/*!
 * DevExtreme (dx.all.debug.js)
 * Version: 20.2.7
 * Build date: Thu Apr 22 2021
 *
 * Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
! function(modules) {
    var installedModules = {};

    function __webpack_require__(moduleId) {
        if (installedModules[moduleId]) {
            return installedModules[moduleId].exports
        }
        var module = installedModules[moduleId] = {
            i: moduleId,
            l: false,
            exports: {}
        };
        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        module.l = true;
        return module.exports
    }
    __webpack_require__.m = modules;
    __webpack_require__.c = installedModules;
    __webpack_require__.d = function(exports, name, getter) {
        if (!__webpack_require__.o(exports, name)) {
            Object.defineProperty(exports, name, {
                configurable: false,
                enumerable: true,
                get: getter
            })
        }
    };
    __webpack_require__.n = function(module) {
        var getter = module && module.__esModule ? function() {
            return module.default
        } : function() {
            return module
        };
        __webpack_require__.d(getter, "a", getter);
        return getter
    };
    __webpack_require__.o = function(object, property) {
        return Object.prototype.hasOwnProperty.call(object, property)
    };
    __webpack_require__.p = "";
    return __webpack_require__(__webpack_require__.s = 1010)
}([
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/extend.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.extend = exports.extendFromObject = void 0;
        var _type = __webpack_require__( /*! ./type */ 1);
        var extendFromObject = function(target, source, overrideExistingValues) {
            target = target || {};
            for (var prop in source) {
                if (Object.prototype.hasOwnProperty.call(source, prop)) {
                    var value = source[prop];
                    if (!(prop in target) || overrideExistingValues) {
                        target[prop] = value
                    }
                }
            }
            return target
        };
        exports.extendFromObject = extendFromObject;
        var extend = function extend(target) {
            target = target || {};
            var i = 1;
            var deep = false;
            if ("boolean" === typeof target) {
                deep = target;
                target = arguments[1] || {};
                i++
            }
            for (; i < arguments.length; i++) {
                var source = arguments[i];
                if (null == source) {
                    continue
                }
                for (var key in source) {
                    var targetValue = target[key];
                    var sourceValue = source[key];
                    var sourceValueIsArray = false;
                    var clone = void 0;
                    if ("__proto__" === key || "constructor" === key || target === sourceValue) {
                        continue
                    }
                    if (deep && sourceValue && ((0, _type.isPlainObject)(sourceValue) || (sourceValueIsArray = Array.isArray(sourceValue)))) {
                        if (sourceValueIsArray) {
                            clone = targetValue && Array.isArray(targetValue) ? targetValue : []
                        } else {
                            clone = targetValue && (0, _type.isPlainObject)(targetValue) ? targetValue : {}
                        }
                        target[key] = extend(deep, clone, sourceValue)
                    } else {
                        if (void 0 !== sourceValue) {
                            target[key] = sourceValue
                        }
                    }
                }
            }
            return target
        };
        exports.extend = extend
    },
    /*!*****************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/type.js ***!
      \*****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.isEvent = exports.type = exports.isDeferred = exports.isPromise = exports.isRenderer = exports.isWindow = exports.isPrimitive = exports.isPlainObject = exports.isEmptyObject = exports.isObject = exports.isNumeric = exports.isString = exports.isFunction = exports.isDefined = exports.isDate = exports.isExponential = exports.isBoolean = void 0;

        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        var types = {
            "[object Array]": "array",
            "[object Date]": "date",
            "[object Object]": "object",
            "[object String]": "string",
            "[object Null]": "null"
        };
        var type = function(object) {
            var typeOfObject = Object.prototype.toString.call(object);
            return "object" === _typeof(object) ? types[typeOfObject] || "object" : _typeof(object)
        };
        exports.type = type;
        var isBoolean = function(object) {
            return "boolean" === typeof object
        };
        exports.isBoolean = isBoolean;
        var isExponential = function(value) {
            return isNumeric(value) && value.toString().indexOf("e") !== -1
        };
        exports.isExponential = isExponential;
        var isDate = function(object) {
            return "date" === type(object)
        };
        exports.isDate = isDate;
        var isDefined = function(object) {
            return null !== object && void 0 !== object
        };
        exports.isDefined = isDefined;
        var isFunction = function(object) {
            return "function" === typeof object
        };
        exports.isFunction = isFunction;
        var isString = function(object) {
            return "string" === typeof object
        };
        exports.isString = isString;
        var isNumeric = function(object) {
            return "number" === typeof object && isFinite(object) || !isNaN(object - parseFloat(object))
        };
        exports.isNumeric = isNumeric;
        var isObject = function(object) {
            return "object" === type(object)
        };
        exports.isObject = isObject;
        var isEmptyObject = function(object) {
            var property;
            for (property in object) {
                return false
            }
            return true
        };
        exports.isEmptyObject = isEmptyObject;
        var isPlainObject = function(object) {
            if (!object || "[object Object]" !== Object.prototype.toString.call(object)) {
                return false
            }
            var proto = Object.getPrototypeOf(object);
            var ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return "function" === typeof ctor && Object.toString.call(ctor) === Object.toString.call(Object)
        };
        exports.isPlainObject = isPlainObject;
        var isPrimitive = function(value) {
            return ["object", "array", "function"].indexOf(type(value)) === -1
        };
        exports.isPrimitive = isPrimitive;
        var isWindow = function(object) {
            return null != object && object === object.window
        };
        exports.isWindow = isWindow;
        var isRenderer = function(object) {
            return !!(object.jquery || object.dxRenderer)
        };
        exports.isRenderer = isRenderer;
        var isPromise = function(object) {
            return object && isFunction(object.then)
        };
        exports.isPromise = isPromise;
        var isDeferred = function(object) {
            return object && isFunction(object.done) && isFunction(object.fail)
        };
        exports.isDeferred = isDeferred;
        var isEvent = function(object) {
            return !!(object && object.preventDefault)
        };
        exports.isEvent = isEvent
    },
    /*!***************************************************!*\
      !*** ./artifacts/transpiled-npm/core/renderer.js ***!
      \***************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer_base = _interopRequireDefault(__webpack_require__( /*! ./renderer_base */ 236));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _renderer_base.default.get();
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/iterator.js ***!
      \*********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.reverseEach = exports.each = exports.map = void 0;
        var map = function(values, callback) {
            if (Array.isArray(values)) {
                return values.map(callback)
            }
            var result = [];
            for (var key in values) {
                result.push(callback(values[key], key))
            }
            return result
        };
        exports.map = map;
        var each = function(values, callback) {
            if (!values) {
                return
            }
            if ("length" in values) {
                for (var i = 0; i < values.length; i++) {
                    if (false === callback.call(values[i], i, values[i])) {
                        break
                    }
                }
            } else {
                for (var key in values) {
                    if (false === callback.call(values[key], key, values[key])) {
                        break
                    }
                }
            }
            return values
        };
        exports.each = each;
        var reverseEach = function(array, callback) {
            if (!array || !("length" in array) || 0 === array.length) {
                return
            }
            for (var i = array.length - 1; i >= 0; i--) {
                if (false === callback.call(array[i], i, array[i])) {
                    break
                }
            }
        };
        exports.reverseEach = reverseEach
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/common.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.equalByValue = exports.grep = exports.asyncNoop = exports.noop = exports.applyServerDecimalSeparator = exports.escapeRegExp = exports.getKeyHash = exports.pairToObject = exports.denormalizeKey = exports.normalizeKey = exports.splitPair = exports.findBestMatches = exports.deferUpdater = exports.deferRenderer = exports.deferUpdate = exports.deferRender = exports.executeAsync = exports.ensureDefined = void 0;
        var _config = _interopRequireDefault(__webpack_require__( /*! ../config */ 31));
        var _guid = _interopRequireDefault(__webpack_require__( /*! ../guid */ 36));
        var _deferred = __webpack_require__( /*! ../utils/deferred */ 6);
        var _data = __webpack_require__( /*! ./data */ 20);
        var _iterator = __webpack_require__( /*! ./iterator */ 3);
        var _type = __webpack_require__( /*! ./type */ 1);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ensureDefined = function(value, defaultValue) {
            return (0, _type.isDefined)(value) ? value : defaultValue
        };
        exports.ensureDefined = ensureDefined;
        var executeAsync = function(action, context) {
            var deferred = new _deferred.Deferred;
            var normalizedContext = context || this;
            var task = {
                promise: deferred.promise(),
                abort: function() {
                    clearTimeout(timerId);
                    deferred.rejectWith(normalizedContext)
                }
            };
            var callback = function() {
                var result = action.call(normalizedContext);
                if (result && result.done && (0, _type.isFunction)(result.done)) {
                    result.done(function() {
                        deferred.resolveWith(normalizedContext)
                    })
                } else {
                    deferred.resolveWith(normalizedContext)
                }
            };
            var timerId = (arguments[2] || setTimeout)(callback, "number" === typeof context ? context : 0);
            return task
        };
        exports.executeAsync = executeAsync;
        var delayedFuncs = [];
        var delayedNames = [];
        var delayedDeferreds = [];
        var executingName;
        var deferExecute = function(name, func, deferred) {
            if (executingName && executingName !== name) {
                delayedFuncs.push(func);
                delayedNames.push(name);
                deferred = deferred || new _deferred.Deferred;
                delayedDeferreds.push(deferred);
                return deferred
            } else {
                var oldExecutingName = executingName;
                var currentDelayedCount = delayedDeferreds.length;
                executingName = name;
                var result = func();
                if (!result) {
                    if (delayedDeferreds.length > currentDelayedCount) {
                        result = _deferred.when.apply(this, delayedDeferreds.slice(currentDelayedCount))
                    } else {
                        if (deferred) {
                            deferred.resolve()
                        }
                    }
                }
                executingName = oldExecutingName;
                if (deferred && result && result.done) {
                    result.done(deferred.resolve).fail(deferred.reject)
                }
                if (!executingName && delayedFuncs.length) {
                    ("render" === delayedNames.shift() ? deferRender : deferUpdate)(delayedFuncs.shift(), delayedDeferreds.shift())
                }
                return result || (0, _deferred.when)()
            }
        };
        var deferRender = function(func, deferred) {
            return deferExecute("render", func, deferred)
        };
        exports.deferRender = deferRender;
        var deferUpdate = function(func, deferred) {
            return deferExecute("update", func, deferred)
        };
        exports.deferUpdate = deferUpdate;
        var deferRenderer = function(func) {
            return function() {
                var that = this;
                return deferExecute("render", function() {
                    return func.call(that)
                })
            }
        };
        exports.deferRenderer = deferRenderer;
        var deferUpdater = function(func) {
            return function() {
                var that = this;
                return deferExecute("update", function() {
                    return func.call(that)
                })
            }
        };
        exports.deferUpdater = deferUpdater;
        var findBestMatches = function(targetFilter, items, mapFn) {
            var bestMatches = [];
            var maxMatchCount = 0;
            (0, _iterator.each)(items, function(index, itemSrc) {
                var matchCount = 0;
                var item = mapFn ? mapFn(itemSrc) : itemSrc;
                (0, _iterator.each)(targetFilter, function(paramName, targetValue) {
                    var value = item[paramName];
                    if (void 0 === value) {
                        return
                    }
                    if (match(value, targetValue)) {
                        matchCount++;
                        return
                    }
                    matchCount = -1;
                    return false
                });
                if (matchCount < maxMatchCount) {
                    return
                }
                if (matchCount > maxMatchCount) {
                    bestMatches.length = 0;
                    maxMatchCount = matchCount
                }
                bestMatches.push(itemSrc)
            });
            return bestMatches
        };
        exports.findBestMatches = findBestMatches;
        var match = function(value, targetValue) {
            if (Array.isArray(value) && Array.isArray(targetValue)) {
                var mismatch = false;
                (0, _iterator.each)(value, function(index, valueItem) {
                    if (valueItem !== targetValue[index]) {
                        mismatch = true;
                        return false
                    }
                });
                if (mismatch) {
                    return false
                }
                return true
            }
            if (value === targetValue) {
                return true
            }
            return false
        };
        var splitPair = function(raw) {
            var _raw$x, _raw$y;
            switch ((0, _type.type)(raw)) {
                case "string":
                    return raw.split(/\s+/, 2);
                case "object":
                    return [null !== (_raw$x = raw.x) && void 0 !== _raw$x ? _raw$x : raw.h, null !== (_raw$y = raw.y) && void 0 !== _raw$y ? _raw$y : raw.v];
                case "number":
                    return [raw];
                case "array":
                    return raw;
                default:
                    return null
            }
        };
        exports.splitPair = splitPair;
        var normalizeKey = function(id) {
            var key = (0, _type.isString)(id) ? id : id.toString();
            var arr = key.match(/[^a-zA-Z0-9_]/g);
            arr && (0, _iterator.each)(arr, function(_, sign) {
                key = key.replace(sign, "__" + sign.charCodeAt() + "__")
            });
            return key
        };
        exports.normalizeKey = normalizeKey;
        var denormalizeKey = function(key) {
            var arr = key.match(/__\d+__/g);
            arr && arr.forEach(function(char) {
                var charCode = parseInt(char.replace("__", ""));
                key = key.replace(char, String.fromCharCode(charCode))
            });
            return key
        };
        exports.denormalizeKey = denormalizeKey;
        var pairToObject = function(raw, preventRound) {
            var pair = splitPair(raw);
            var h = preventRound ? parseFloat(pair && pair[0]) : parseInt(pair && pair[0], 10);
            var v = preventRound ? parseFloat(pair && pair[1]) : parseInt(pair && pair[1], 10);
            if (!isFinite(h)) {
                h = 0
            }
            if (!isFinite(v)) {
                v = h
            }
            return {
                h: h,
                v: v
            }
        };
        exports.pairToObject = pairToObject;
        var getKeyHash = function(key) {
            if (key instanceof _guid.default) {
                return key.toString()
            } else {
                if ((0, _type.isObject)(key) || Array.isArray(key)) {
                    try {
                        var keyHash = JSON.stringify(key);
                        return "{}" === keyHash ? key : keyHash
                    } catch (e) {
                        return key
                    }
                }
            }
            return key
        };
        exports.getKeyHash = getKeyHash;
        var escapeRegExp = function(string) {
            return string.replace(/[[\]{}\-()*+?.\\^$|\s]/g, "\\$&")
        };
        exports.escapeRegExp = escapeRegExp;
        var applyServerDecimalSeparator = function(value) {
            var separator = (0, _config.default)().serverDecimalSeparator;
            if ((0, _type.isDefined)(value)) {
                value = value.toString().replace(".", separator)
            }
            return value
        };
        exports.applyServerDecimalSeparator = applyServerDecimalSeparator;
        var noop = function() {};
        exports.noop = noop;
        var asyncNoop = function() {
            return (new _deferred.Deferred).resolve().promise()
        };
        exports.asyncNoop = asyncNoop;
        var grep = function(elements, checkFunction, invert) {
            var result = [];
            var check;
            var expectedCheck = !invert;
            for (var i = 0; i < elements.length; i++) {
                check = !!checkFunction(elements[i], i);
                if (check === expectedCheck) {
                    result.push(elements[i])
                }
            }
            return result
        };
        exports.grep = grep;
        var arraysEqualByValue = function(array1, array2, depth) {
            if (array1.length !== array2.length) {
                return false
            }
            for (var i = 0; i < array1.length; i++) {
                if (!equalByValue(array1[i], array2[i], depth + 1)) {
                    return false
                }
            }
            return true
        };
        var objectsEqualByValue = function(object1, object2, depth, strict) {
            for (var propertyName in object1) {
                if (Object.prototype.hasOwnProperty.call(object1, propertyName) && !equalByValue(object1[propertyName], object2[propertyName], depth + 1, strict)) {
                    return false
                }
            }
            for (var _propertyName in object2) {
                if (!(_propertyName in object1)) {
                    return false
                }
            }
            return true
        };
        var maxEqualityDepth = 3;
        var equalByValue = function(object1, object2) {
            var depth = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
            var strict = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : true;
            object1 = (0, _data.toComparable)(object1, true);
            object2 = (0, _data.toComparable)(object2, true);
            var comparisonResult = strict ? object1 === object2 : object1 == object2;
            if (comparisonResult || depth >= maxEqualityDepth) {
                return true
            }
            if ((0, _type.isObject)(object1) && (0, _type.isObject)(object2)) {
                return objectsEqualByValue(object1, object2, depth, strict)
            } else {
                if (Array.isArray(object1) && Array.isArray(object2)) {
                    return arraysEqualByValue(object1, object2, depth)
                }
            }
            return false
        };
        exports.equalByValue = equalByValue
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/events/core/events_engine.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _event_registrator_callbacks = _interopRequireDefault(__webpack_require__( /*! ./event_registrator_callbacks */ 131));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _dependency_injector = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/dependency_injector */ 58));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/callbacks */ 27));
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../../core/errors */ 25));
        var _weak_map = _interopRequireDefault(__webpack_require__( /*! ../../core/polyfills/weak_map */ 196));
        var _hook_touch_props = _interopRequireDefault(__webpack_require__( /*! ../../events/core/hook_touch_props */ 237));
        var _call_once = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/call_once */ 85));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        var window = (0, _window.getWindow)();
        var EMPTY_EVENT_NAME = "dxEmptyEventType";
        var NATIVE_EVENTS_TO_SUBSCRIBE = {
            mouseenter: "mouseover",
            mouseleave: "mouseout",
            pointerenter: "pointerover",
            pointerleave: "pointerout"
        };
        var NATIVE_EVENTS_TO_TRIGGER = {
            focusin: "focus",
            focusout: "blur"
        };
        var NO_BUBBLE_EVENTS = ["blur", "focus", "load"];
        var forcePassiveFalseEventNames = ["touchmove", "wheel", "mousewheel", "touchstart"];

        function matchesSafe(target, selector) {
            return !(0, _type.isWindow)(target) && "#document" !== target.nodeName && _dom_adapter.default.elementMatches(target, selector)
        }
        var elementDataMap = new _weak_map.default;
        var guid = 0;
        var skipEvent;
        var special = function() {
            var specialData = {};
            _event_registrator_callbacks.default.add(function(eventName, eventObject) {
                specialData[eventName] = eventObject
            });
            return {
                getField: function(eventName, field) {
                    return specialData[eventName] && specialData[eventName][field]
                },
                callMethod: function(eventName, methodName, context, args) {
                    return specialData[eventName] && specialData[eventName][methodName] && specialData[eventName][methodName].apply(context, args)
                }
            }
        }();
        var eventsEngine = (0, _dependency_injector.default)({
            on: getHandler(normalizeOnArguments(iterate(function(element, eventName, selector, data, handler) {
                var handlersController = getHandlersController(element, eventName);
                handlersController.addHandler(handler, selector, data)
            }))),
            one: getHandler(normalizeOnArguments(function(element, eventName, selector, data, handler) {
                var oneTimeHandler = function oneTimeHandler() {
                    eventsEngine.off(element, eventName, selector, oneTimeHandler);
                    handler.apply(this, arguments)
                };
                eventsEngine.on(element, eventName, selector, data, oneTimeHandler)
            })),
            off: getHandler(normalizeOffArguments(iterate(function(element, eventName, selector, handler) {
                var handlersController = getHandlersController(element, eventName);
                handlersController.removeHandler(handler, selector)
            }))),
            trigger: getHandler(normalizeTriggerArguments(function(element, event, extraParameters) {
                var eventName = event.type;
                var handlersController = getHandlersController(element, event.type);
                special.callMethod(eventName, "trigger", element, [event, extraParameters]);
                handlersController.callHandlers(event, extraParameters);
                var noBubble = special.getField(eventName, "noBubble") || event.isPropagationStopped() || NO_BUBBLE_EVENTS.indexOf(eventName) !== -1;
                if (!noBubble) {
                    var parents = [];
                    var getParents = function getParents(element) {
                        var parent = element.parentNode;
                        if (parent) {
                            parents.push(parent);
                            getParents(parent)
                        }
                    };
                    getParents(element);
                    parents.push(window);
                    var i = 0;
                    while (parents[i] && !event.isPropagationStopped()) {
                        var parentDataByEvent = getHandlersController(parents[i], event.type);
                        parentDataByEvent.callHandlers((0, _extend.extend)(event, {
                            currentTarget: parents[i]
                        }), extraParameters);
                        i++
                    }
                }
                if (element.nodeType || (0, _type.isWindow)(element)) {
                    special.callMethod(eventName, "_default", element, [event, extraParameters]);
                    callNativeMethod(eventName, element)
                }
            })),
            triggerHandler: getHandler(normalizeTriggerArguments(function(element, event, extraParameters) {
                var handlersController = getHandlersController(element, event.type);
                handlersController.callHandlers(event, extraParameters)
            }))
        });

        function applyForEach(args, method) {
            var element = args[0];
            if (!element) {
                return
            }
            if (_dom_adapter.default.isNode(element) || (0, _type.isWindow)(element)) {
                method.apply(eventsEngine, args)
            } else {
                if (!(0, _type.isString)(element) && "length" in element) {
                    var itemArgs = Array.prototype.slice.call(args, 0);
                    Array.prototype.forEach.call(element, function(itemElement) {
                        itemArgs[0] = itemElement;
                        applyForEach(itemArgs, method)
                    })
                } else {
                    throw _errors.default.Error("E0025")
                }
            }
        }

        function getHandler(method) {
            return function() {
                applyForEach(arguments, method)
            }
        }

        function detectPassiveEventHandlersSupport() {
            var isSupported = false;
            try {
                var options = Object.defineProperty({}, "passive", {
                    get: function() {
                        isSupported = true;
                        return true
                    }
                });
                window.addEventListener("test", null, options)
            } catch (e) {}
            return isSupported
        }
        var passiveEventHandlersSupported = (0, _call_once.default)(detectPassiveEventHandlersSupport);
        var contains = function contains(container, element) {
            if ((0, _type.isWindow)(container)) {
                return contains(container.document, element)
            }
            return container.contains ? container.contains(element) : !!(element.compareDocumentPosition(container) & element.DOCUMENT_POSITION_CONTAINS)
        };

        function getHandlersController(element, eventName) {
            var elementData = elementDataMap.get(element);
            eventName = eventName || "";
            var eventNameParts = eventName.split(".");
            var namespaces = eventNameParts.slice(1);
            var eventNameIsDefined = !!eventNameParts[0];
            eventName = eventNameParts[0] || EMPTY_EVENT_NAME;
            if (!elementData) {
                elementData = {};
                elementDataMap.set(element, elementData)
            }
            if (!elementData[eventName]) {
                elementData[eventName] = {
                    handleObjects: [],
                    nativeHandler: null
                }
            }
            var eventData = elementData[eventName];
            return {
                addHandler: function(handler, selector, data) {
                    var callHandler = function(e, extraParameters) {
                        var handlerArgs = [e];
                        var target = e.currentTarget;
                        var relatedTarget = e.relatedTarget;
                        var secondaryTargetIsInside;
                        var result;
                        if (eventName in NATIVE_EVENTS_TO_SUBSCRIBE) {
                            secondaryTargetIsInside = relatedTarget && target && (relatedTarget === target || contains(target, relatedTarget))
                        }
                        if (void 0 !== extraParameters) {
                            handlerArgs.push(extraParameters)
                        }
                        special.callMethod(eventName, "handle", element, [e, data]);
                        if (!secondaryTargetIsInside) {
                            result = handler.apply(target, handlerArgs)
                        }
                        if (false === result) {
                            e.preventDefault();
                            e.stopPropagation()
                        }
                    };
                    var wrappedHandler = function(e, extraParameters) {
                        if (skipEvent && e.type === skipEvent) {
                            return
                        }
                        e.data = data;
                        e.delegateTarget = element;
                        if (selector) {
                            var currentTarget = e.target;
                            while (currentTarget && currentTarget !== element) {
                                if (matchesSafe(currentTarget, selector)) {
                                    e.currentTarget = currentTarget;
                                    callHandler(e, extraParameters)
                                }
                                currentTarget = currentTarget.parentNode
                            }
                        } else {
                            e.currentTarget = e.delegateTarget || e.target;
                            callHandler(e, extraParameters)
                        }
                    };
                    var handleObject = {
                        handler: handler,
                        wrappedHandler: wrappedHandler,
                        selector: selector,
                        type: eventName,
                        data: data,
                        namespace: namespaces.join("."),
                        namespaces: namespaces,
                        guid: ++guid
                    };
                    eventData.handleObjects.push(handleObject);
                    var firstHandlerForTheType = 1 === eventData.handleObjects.length;
                    var shouldAddNativeListener = firstHandlerForTheType && eventNameIsDefined;
                    var nativeListenerOptions;
                    if (shouldAddNativeListener) {
                        shouldAddNativeListener = !special.callMethod(eventName, "setup", element, [data, namespaces, handler])
                    }
                    if (shouldAddNativeListener) {
                        eventData.nativeHandler = getNativeHandler(eventName);
                        if (passiveEventHandlersSupported() && forcePassiveFalseEventNames.indexOf(eventName) > -1) {
                            nativeListenerOptions = {
                                passive: false
                            }
                        }
                        eventData.removeListener = _dom_adapter.default.listen(element, NATIVE_EVENTS_TO_SUBSCRIBE[eventName] || eventName, eventData.nativeHandler, nativeListenerOptions)
                    }
                    special.callMethod(eventName, "add", element, [handleObject])
                },
                removeHandler: function(handler, selector) {
                    var removeByEventName = function(eventName) {
                        var eventData = elementData[eventName];
                        if (!eventData.handleObjects.length) {
                            delete elementData[eventName];
                            return
                        }
                        var removedHandler;
                        eventData.handleObjects = eventData.handleObjects.filter(function(handleObject) {
                            var skip = namespaces.length && !isSubset(handleObject.namespaces, namespaces) || handler && handleObject.handler !== handler || selector && handleObject.selector !== selector;
                            if (!skip) {
                                removedHandler = handleObject.handler;
                                special.callMethod(eventName, "remove", element, [handleObject])
                            }
                            return skip
                        });
                        var lastHandlerForTheType = !eventData.handleObjects.length;
                        var shouldRemoveNativeListener = lastHandlerForTheType && eventName !== EMPTY_EVENT_NAME;
                        if (shouldRemoveNativeListener) {
                            special.callMethod(eventName, "teardown", element, [namespaces, removedHandler]);
                            if (eventData.nativeHandler) {
                                eventData.removeListener()
                            }
                            delete elementData[eventName]
                        }
                    };
                    if (eventNameIsDefined) {
                        removeByEventName(eventName)
                    } else {
                        for (var name in elementData) {
                            removeByEventName(name)
                        }
                    }
                    var elementDataIsEmpty = 0 === Object.keys(elementData).length;
                    if (elementDataIsEmpty) {
                        elementDataMap.delete(element)
                    }
                },
                callHandlers: function(event, extraParameters) {
                    var forceStop = false;
                    var handleCallback = function(handleObject) {
                        if (forceStop) {
                            return
                        }
                        if (!namespaces.length || isSubset(handleObject.namespaces, namespaces)) {
                            handleObject.wrappedHandler(event, extraParameters);
                            forceStop = event.isImmediatePropagationStopped()
                        }
                    };
                    eventData.handleObjects.forEach(handleCallback);
                    if (namespaces.length && elementData[EMPTY_EVENT_NAME]) {
                        elementData[EMPTY_EVENT_NAME].handleObjects.forEach(handleCallback)
                    }
                }
            }
        }

        function getNativeHandler(subscribeName) {
            return function(event, extraParameters) {
                var handlersController = getHandlersController(this, subscribeName);
                event = eventsEngine.Event(event);
                handlersController.callHandlers(event, extraParameters)
            }
        }

        function isSubset(original, checked) {
            for (var i = 0; i < checked.length; i++) {
                if (original.indexOf(checked[i]) < 0) {
                    return false
                }
            }
            return true
        }

        function normalizeOnArguments(callback) {
            return function(element, eventName, selector, data, handler) {
                if (!handler) {
                    handler = data;
                    data = void 0
                }
                if ("string" !== typeof selector) {
                    data = selector;
                    selector = void 0
                }
                if (!handler && "string" === typeof eventName) {
                    handler = data || selector;
                    selector = void 0;
                    data = void 0
                }
                callback(element, eventName, selector, data, handler)
            }
        }

        function normalizeOffArguments(callback) {
            return function(element, eventName, selector, handler) {
                if ("function" === typeof selector) {
                    handler = selector;
                    selector = void 0
                }
                callback(element, eventName, selector, handler)
            }
        }

        function normalizeTriggerArguments(callback) {
            return function(element, src, extraParameters) {
                if ("string" === typeof src) {
                    src = {
                        type: src
                    }
                }
                if (!src.target) {
                    src.target = element
                }
                src.currentTarget = element;
                if (!src.delegateTarget) {
                    src.delegateTarget = element
                }
                if (!src.type && src.originalEvent) {
                    src.type = src.originalEvent.type
                }
                callback(element, src instanceof eventsEngine.Event ? src : eventsEngine.Event(src), extraParameters)
            }
        }

        function normalizeEventArguments(callback) {
            return function(src, config) {
                if (!(this instanceof eventsEngine.Event)) {
                    return new eventsEngine.Event(src, config)
                }
                if (!src) {
                    src = {}
                }
                if ("string" === typeof src) {
                    src = {
                        type: src
                    }
                }
                if (!config) {
                    config = {}
                }
                callback.call(this, src, config)
            }
        }

        function iterate(callback) {
            var iterateEventNames = function(element, eventName) {
                if (eventName && eventName.indexOf(" ") > -1) {
                    var args = Array.prototype.slice.call(arguments, 0);
                    eventName.split(" ").forEach(function(eventName) {
                        args[1] = eventName;
                        callback.apply(this, args)
                    })
                } else {
                    callback.apply(this, arguments)
                }
            };
            return function(element, eventName) {
                if ("object" === _typeof(eventName)) {
                    var args = Array.prototype.slice.call(arguments, 0);
                    for (var name in eventName) {
                        args[1] = name;
                        args[args.length - 1] = eventName[name];
                        iterateEventNames.apply(this, args)
                    }
                } else {
                    iterateEventNames.apply(this, arguments)
                }
            }
        }

        function callNativeMethod(eventName, element) {
            var nativeMethodName = NATIVE_EVENTS_TO_TRIGGER[eventName] || eventName;
            var isLinkClickEvent = function(eventName, element) {
                return "click" === eventName && "a" === element.localName
            };
            if (isLinkClickEvent(eventName, element)) {
                return
            }
            if ((0, _type.isFunction)(element[nativeMethodName])) {
                skipEvent = eventName;
                element[nativeMethodName]();
                skipEvent = void 0
            }
        }

        function calculateWhich(event) {
            var setForMouseEvent = function(event) {
                var mouseEventRegex = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
                return !event.which && void 0 !== event.button && mouseEventRegex.test(event.type)
            };
            var setForKeyEvent = function(event) {
                return null == event.which && 0 === event.type.indexOf("key")
            };
            if (setForKeyEvent(event)) {
                return null != event.charCode ? event.charCode : event.keyCode
            }
            if (setForMouseEvent(event)) {
                var whichByButton = {
                    1: 1,
                    2: 3,
                    3: 1,
                    4: 2
                };
                return whichByButton[event.button]
            }
            return event.which
        }

        function initEvent(EventClass) {
            if (EventClass) {
                eventsEngine.Event = EventClass;
                eventsEngine.Event.prototype = EventClass.prototype
            }
        }
        initEvent(normalizeEventArguments(function(src, config) {
            var that = this;
            var propagationStopped = false;
            var immediatePropagationStopped = false;
            var defaultPrevented = false;
            (0, _extend.extend)(that, src);
            if (src instanceof eventsEngine.Event || (0, _window.hasWindow)() && src instanceof window.Event) {
                that.originalEvent = src;
                that.currentTarget = void 0
            }
            if (!(src instanceof eventsEngine.Event)) {
                (0, _extend.extend)(that, {
                    isPropagationStopped: function() {
                        return !!(propagationStopped || that.originalEvent && that.originalEvent.propagationStopped)
                    },
                    stopPropagation: function() {
                        propagationStopped = true;
                        that.originalEvent && that.originalEvent.stopPropagation()
                    },
                    isImmediatePropagationStopped: function() {
                        return immediatePropagationStopped
                    },
                    stopImmediatePropagation: function() {
                        this.stopPropagation();
                        immediatePropagationStopped = true;
                        that.originalEvent && that.originalEvent.stopImmediatePropagation()
                    },
                    isDefaultPrevented: function() {
                        return !!(defaultPrevented || that.originalEvent && that.originalEvent.defaultPrevented)
                    },
                    preventDefault: function() {
                        defaultPrevented = true;
                        that.originalEvent && that.originalEvent.preventDefault()
                    }
                })
            }
            addProperty("which", calculateWhich, that);
            if (0 === src.type.indexOf("touch")) {
                delete config.pageX;
                delete config.pageY
            }(0, _extend.extend)(that, config);
            that.guid = ++guid
        }));

        function addProperty(propName, hook, eventInstance) {
            Object.defineProperty(eventInstance || eventsEngine.Event.prototype, propName, {
                enumerable: true,
                configurable: true,
                get: function() {
                    return this.originalEvent && hook(this.originalEvent)
                },
                set: function(value) {
                    Object.defineProperty(this, propName, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    })
                }
            })
        }(0, _hook_touch_props.default)(addProperty);
        var beforeSetStrategy = (0, _callbacks.default)();
        var afterSetStrategy = (0, _callbacks.default)();
        eventsEngine.set = function(engine) {
            beforeSetStrategy.fire();
            eventsEngine.inject(engine);
            initEvent(engine.Event);
            afterSetStrategy.fire()
        };
        eventsEngine.subscribeGlobal = function() {
            applyForEach(arguments, normalizeOnArguments(function() {
                var args = arguments;
                eventsEngine.on.apply(this, args);
                beforeSetStrategy.add(function() {
                    var offArgs = Array.prototype.slice.call(args, 0);
                    offArgs.splice(3, 1);
                    eventsEngine.off.apply(this, offArgs)
                });
                afterSetStrategy.add(function() {
                    eventsEngine.on.apply(this, args)
                })
            }))
        };
        eventsEngine.forcePassiveFalseEventNames = forcePassiveFalseEventNames;
        eventsEngine.passiveEventHandlersSupported = passiveEventHandlersSupported;
        var _default = eventsEngine;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/deferred.js ***!
      \*********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.fromPromise = fromPromise;
        exports.setStrategy = setStrategy;
        exports.Deferred = Deferred;
        exports.when = when;
        var _type = __webpack_require__( /*! ../utils/type */ 1);
        var _extend = __webpack_require__( /*! ../utils/extend */ 0);
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ../utils/callbacks */ 27));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var deferredConfig = [{
            method: "resolve",
            handler: "done",
            state: "resolved"
        }, {
            method: "reject",
            handler: "fail",
            state: "rejected"
        }, {
            method: "notify",
            handler: "progress"
        }];
        var _DeferredObj = function() {
            var that = this;
            this._state = "pending";
            this._promise = {};
            deferredConfig.forEach(function(config) {
                var methodName = config.method;
                this[methodName + "Callbacks"] = new _callbacks.default;
                this[methodName] = function() {
                    return this[methodName + "With"](this._promise, arguments)
                }.bind(this);
                this._promise[config.handler] = function(handler) {
                    if (!handler) {
                        return this
                    }
                    var callbacks = that[methodName + "Callbacks"];
                    if (callbacks.fired()) {
                        handler.apply(that[methodName + "Context"], that[methodName + "Args"])
                    } else {
                        callbacks.add(function(context, args) {
                            handler.apply(context, args)
                        }.bind(this))
                    }
                    return this
                }
            }.bind(this));
            this._promise.always = function(handler) {
                return this.done(handler).fail(handler)
            };
            this._promise.catch = function(handler) {
                return this.then(null, handler)
            };
            this._promise.then = function(resolve, reject) {
                var result = new _DeferredObj;
                ["done", "fail"].forEach(function(method) {
                    var callback = "done" === method ? resolve : reject;
                    this[method](function() {
                        if (!callback) {
                            result["done" === method ? "resolve" : "reject"].apply(this, arguments);
                            return
                        }
                        var callbackResult = callback && callback.apply(this, arguments);
                        if ((0, _type.isDeferred)(callbackResult)) {
                            callbackResult.done(result.resolve).fail(result.reject)
                        } else {
                            if ((0, _type.isPromise)(callbackResult)) {
                                callbackResult.then(result.resolve, result.reject)
                            } else {
                                result.resolve.apply(this, (0, _type.isDefined)(callbackResult) ? [callbackResult] : arguments)
                            }
                        }
                    })
                }.bind(this));
                return result.promise()
            };
            this._promise.state = function() {
                return that._state
            };
            this._promise.promise = function(args) {
                return args ? (0, _extend.extend)(args, that._promise) : that._promise
            };
            this._promise.promise(this)
        };
        deferredConfig.forEach(function(config) {
            var methodName = config.method;
            var state = config.state;
            _DeferredObj.prototype[methodName + "With"] = function(context, args) {
                var callbacks = this[methodName + "Callbacks"];
                if ("pending" === this.state()) {
                    this[methodName + "Args"] = args;
                    this[methodName + "Context"] = context;
                    if (state) {
                        this._state = state
                    }
                    callbacks.fire(context, args)
                }
                return this
            }
        });

        function fromPromise(promise, context) {
            if ((0, _type.isDeferred)(promise)) {
                return promise
            } else {
                if ((0, _type.isPromise)(promise)) {
                    var d = new _DeferredObj;
                    promise.then(function() {
                        d.resolveWith.apply(d, [context].concat([
                            [].slice.call(arguments)
                        ]))
                    }, function() {
                        d.rejectWith.apply(d, [context].concat([
                            [].slice.call(arguments)
                        ]))
                    });
                    return d
                }
            }
            return (new _DeferredObj).resolveWith(context, [promise])
        }
        var whenFunc = function() {
            if (1 === arguments.length) {
                return fromPromise(arguments[0])
            }
            var values = [].slice.call(arguments);
            var contexts = [];
            var resolvedCount = 0;
            var deferred = new _DeferredObj;
            var updateState = function(i) {
                return function(value) {
                    contexts[i] = this;
                    values[i] = arguments.length > 1 ? [].slice.call(arguments) : value;
                    resolvedCount++;
                    if (resolvedCount === values.length) {
                        deferred.resolveWith(contexts, values)
                    }
                }
            };
            for (var i = 0; i < values.length; i++) {
                if ((0, _type.isDeferred)(values[i])) {
                    values[i].promise().done(updateState(i)).fail(deferred.reject)
                } else {
                    resolvedCount++
                }
            }
            if (resolvedCount === values.length) {
                deferred.resolveWith(contexts, values)
            }
            return deferred.promise()
        };

        function setStrategy(value) {
            _DeferredObj = value.Deferred;
            whenFunc = value.when
        }

        function Deferred() {
            return new _DeferredObj
        }

        function when() {
            return whenFunc.apply(this, arguments)
        }
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/window.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getNavigator = exports.getCurrentScreenFactor = exports.defaultScreenFactorFunc = exports.hasProperty = exports.getWindow = exports.hasWindow = void 0;
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../dom_adapter */ 11));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var hasWindow = function() {
            return "undefined" !== typeof window
        };
        exports.hasWindow = hasWindow;
        var windowObject = hasWindow() && window;
        if (!windowObject) {
            windowObject = {};
            windowObject.window = windowObject
        }
        var getWindow = function() {
            return windowObject
        };
        exports.getWindow = getWindow;
        var hasProperty = function(prop) {
            return hasWindow() && prop in windowObject
        };
        exports.hasProperty = hasProperty;
        var defaultScreenFactorFunc = function(width) {
            if (width < 768) {
                return "xs"
            } else {
                if (width < 992) {
                    return "sm"
                } else {
                    if (width < 1200) {
                        return "md"
                    } else {
                        return "lg"
                    }
                }
            }
        };
        exports.defaultScreenFactorFunc = defaultScreenFactorFunc;
        var getCurrentScreenFactor = function(screenFactorCallback) {
            var screenFactorFunc = screenFactorCallback || defaultScreenFactorFunc;
            var windowWidth = _dom_adapter.default.getDocumentElement().clientWidth;
            return screenFactorFunc(windowWidth)
        };
        exports.getCurrentScreenFactor = getCurrentScreenFactor;
        var getNavigator = function() {
            return hasWindow() ? windowObject.navigator : {
                userAgent: ""
            }
        };
        exports.getNavigator = getNavigator
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/events/utils/index.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.isCommandKeyPressed = exports.addNamespace = exports.getChar = exports.normalizeKeyName = exports.fireEvent = exports.createEvent = exports.setEventFixMethod = exports.needSkipEvent = exports.stopEventsSkipping = exports.forceSkipEvents = exports.hasTouches = exports.eventDelta = exports.eventData = exports.isFakeClickEvent = exports.isKeyboardEvent = exports.isTouchEvent = exports.isDxMouseWheelEvent = exports.isMouseEvent = exports.isPointerEvent = exports.eventSource = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _add_namespace = _interopRequireDefault(__webpack_require__( /*! ./add_namespace */ 523));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../core/events_engine */ 5));
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _selectors = __webpack_require__( /*! ../../ui/widget/selectors */ 70);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var KEY_MAP = {
            backspace: "backspace",
            tab: "tab",
            enter: "enter",
            escape: "escape",
            pageup: "pageUp",
            pagedown: "pageDown",
            end: "end",
            home: "home",
            arrowleft: "leftArrow",
            arrowup: "upArrow",
            arrowright: "rightArrow",
            arrowdown: "downArrow",
            "delete": "del",
            " ": "space",
            f: "F",
            a: "A",
            "*": "asterisk",
            "-": "minus",
            alt: "alt",
            control: "control",
            shift: "shift",
            left: "leftArrow",
            up: "upArrow",
            right: "rightArrow",
            down: "downArrow",
            multiply: "asterisk",
            spacebar: "space",
            del: "del",
            subtract: "minus",
            esc: "escape"
        };
        var LEGACY_KEY_CODES = {
            8: "backspace",
            9: "tab",
            13: "enter",
            27: "escape",
            33: "pageUp",
            34: "pageDown",
            35: "end",
            36: "home",
            37: "leftArrow",
            38: "upArrow",
            39: "rightArrow",
            40: "downArrow",
            46: "del",
            32: "space",
            70: "F",
            65: "A",
            106: "asterisk",
            109: "minus",
            189: "minus",
            173: "minus",
            16: "shift",
            17: "control",
            18: "alt"
        };
        var EVENT_SOURCES_REGEX = {
            dx: /^dx/i,
            mouse: /(mouse|wheel)/i,
            touch: /^touch/i,
            keyboard: /^key/i,
            pointer: /^(ms)?pointer/i
        };
        var fixMethod = function(e) {
            return e
        };
        var copyEvent = function(originalEvent) {
            return fixMethod(_events_engine.default.Event(originalEvent, originalEvent), originalEvent)
        };
        var isDxEvent = function(e) {
            return "dx" === eventSource(e)
        };
        var isNativeMouseEvent = function(e) {
            return "mouse" === eventSource(e)
        };
        var isNativeTouchEvent = function(e) {
            return "touch" === eventSource(e)
        };
        var eventSource = function(_ref) {
            var type = _ref.type;
            var result = "other";
            (0, _iterator.each)(EVENT_SOURCES_REGEX, function(key) {
                if (this.test(type)) {
                    result = key;
                    return false
                }
            });
            return result
        };
        exports.eventSource = eventSource;
        var isPointerEvent = function(e) {
            return "pointer" === eventSource(e)
        };
        exports.isPointerEvent = isPointerEvent;
        var isMouseEvent = function(e) {
            return isNativeMouseEvent(e) || (isPointerEvent(e) || isDxEvent(e)) && "mouse" === e.pointerType
        };
        exports.isMouseEvent = isMouseEvent;
        var isDxMouseWheelEvent = function(e) {
            return e && "dxmousewheel" === e.type
        };
        exports.isDxMouseWheelEvent = isDxMouseWheelEvent;
        var isTouchEvent = function(e) {
            return isNativeTouchEvent(e) || (isPointerEvent(e) || isDxEvent(e)) && "touch" === e.pointerType
        };
        exports.isTouchEvent = isTouchEvent;
        var isKeyboardEvent = function(e) {
            return "keyboard" === eventSource(e)
        };
        exports.isKeyboardEvent = isKeyboardEvent;
        var isFakeClickEvent = function(_ref2) {
            var screenX = _ref2.screenX,
                offsetX = _ref2.offsetX,
                pageX = _ref2.pageX;
            return 0 === screenX && !offsetX && 0 === pageX
        };
        exports.isFakeClickEvent = isFakeClickEvent;
        var eventData = function(_ref3) {
            var pageX = _ref3.pageX,
                pageY = _ref3.pageY,
                timeStamp = _ref3.timeStamp;
            return {
                x: pageX,
                y: pageY,
                time: timeStamp
            }
        };
        exports.eventData = eventData;
        var eventDelta = function(from, to) {
            return {
                x: to.x - from.x,
                y: to.y - from.y,
                time: to.time - from.time || 1
            }
        };
        exports.eventDelta = eventDelta;
        var hasTouches = function(e) {
            var originalEvent = e.originalEvent,
                pointers = e.pointers;
            if (isNativeTouchEvent(e)) {
                return (originalEvent.touches || []).length
            }
            if (isDxEvent(e)) {
                return (pointers || []).length
            }
            return 0
        };
        exports.hasTouches = hasTouches;
        var skipEvents = false;
        var forceSkipEvents = function() {
            return skipEvents = true
        };
        exports.forceSkipEvents = forceSkipEvents;
        var stopEventsSkipping = function() {
            return skipEvents = false
        };
        exports.stopEventsSkipping = stopEventsSkipping;
        var needSkipEvent = function(e) {
            if (skipEvents) {
                return true
            }
            var target = e.target;
            var $target = (0, _renderer.default)(target);
            var isContentEditable = (null === target || void 0 === target ? void 0 : target.isContentEditable) || (null === target || void 0 === target ? void 0 : target.hasAttribute("contenteditable"));
            var touchInEditable = $target.is("input, textarea, select") || isContentEditable;
            if ($target.is(".dx-skip-gesture-event *, .dx-skip-gesture-event")) {
                return true
            }
            if (isDxMouseWheelEvent(e)) {
                var isTextArea = $target.is("textarea") && $target.hasClass("dx-texteditor-input");
                if (isTextArea || isContentEditable) {
                    return false
                }
                var isInputFocused = $target.is("input[type='number'], textarea, select") && $target.is(":focus");
                return isInputFocused
            }
            if (isMouseEvent(e)) {
                return touchInEditable || e.which > 1
            }
            if (isTouchEvent(e)) {
                return touchInEditable && (0, _selectors.focused)($target)
            }
        };
        exports.needSkipEvent = needSkipEvent;
        var setEventFixMethod = function(func) {
            return fixMethod = func
        };
        exports.setEventFixMethod = setEventFixMethod;
        var createEvent = function(originalEvent, args) {
            var event = copyEvent(originalEvent);
            args && (0, _extend.extend)(event, args);
            return event
        };
        exports.createEvent = createEvent;
        var fireEvent = function(props) {
            var originalEvent = props.originalEvent,
                delegateTarget = props.delegateTarget;
            var event = createEvent(originalEvent, props);
            _events_engine.default.trigger(delegateTarget || event.target, event);
            return event
        };
        exports.fireEvent = fireEvent;
        var normalizeKeyName = function(_ref4) {
            var key = _ref4.key,
                which = _ref4.which;
            var isKeySupported = !!key;
            key = isKeySupported ? key : which;
            if (key) {
                if (isKeySupported) {
                    key = KEY_MAP[key.toLowerCase()] || key
                } else {
                    key = LEGACY_KEY_CODES[key] || String.fromCharCode(key)
                }
                return key
            }
        };
        exports.normalizeKeyName = normalizeKeyName;
        var getChar = function(_ref5) {
            var key = _ref5.key,
                which = _ref5.which;
            return key || String.fromCharCode(which)
        };
        exports.getChar = getChar;
        var addNamespace = _add_namespace.default;
        exports.addNamespace = addNamespace;
        var isCommandKeyPressed = function(_ref6) {
            var ctrlKey = _ref6.ctrlKey,
                metaKey = _ref6.metaKey;
            return ctrlKey || metaKey
        };
        exports.isCommandKeyPressed = isCommandKeyPressed
    },
    /*!****************************************************************!*\
      !*** ./artifacts/transpiled-npm/core/component_registrator.js ***!
      \****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ./renderer */ 2));
        var _component_registrator_callbacks = _interopRequireDefault(__webpack_require__( /*! ./component_registrator_callbacks */ 167));
        var _errors = _interopRequireDefault(__webpack_require__( /*! ./errors */ 25));
        var _public_component = __webpack_require__( /*! ./utils/public_component */ 147);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var registerComponent = function(name, namespace, componentClass) {
            if (!componentClass) {
                componentClass = namespace
            } else {
                namespace[name] = componentClass
            }(0, _public_component.name)(componentClass, name);
            _component_registrator_callbacks.default.fire(name, componentClass)
        };
        var registerRendererComponent = function(name, componentClass) {
            _renderer.default.fn[name] = function(options) {
                var isMemberInvoke = "string" === typeof options;
                var result;
                if (isMemberInvoke) {
                    var memberName = options;
                    var memberArgs = [].slice.call(arguments).slice(1);
                    this.each(function() {
                        var instance = componentClass.getInstance(this);
                        if (!instance) {
                            throw _errors.default.Error("E0009", name)
                        }
                        var member = instance[memberName];
                        var memberValue = member.apply(instance, memberArgs);
                        if (void 0 === result) {
                            result = memberValue
                        }
                    })
                } else {
                    this.each(function() {
                        var instance = componentClass.getInstance(this);
                        if (instance) {
                            instance.option(options)
                        } else {
                            new componentClass(this, options)
                        }
                    });
                    result = this
                }
                return result
            }
        };
        _component_registrator_callbacks.default.add(registerRendererComponent);
        var _default = registerComponent;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/localization/message.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _dependency_injector = _interopRequireDefault(__webpack_require__( /*! ../core/utils/dependency_injector */ 58));
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _string = __webpack_require__( /*! ../core/utils/string */ 43);
        var _inflector = __webpack_require__( /*! ../core/utils/inflector */ 39);
        var _core = _interopRequireDefault(__webpack_require__( /*! ./core */ 87));
        var _default_messages = _interopRequireDefault(__webpack_require__( /*! ./default_messages */ 510));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var baseDictionary = (0, _extend.extend)(true, {}, _default_messages.default);
        var getDataByLocale = function(localeData, locale) {
            return localeData[locale] || {}
        };
        var newMessages = {};
        var messageLocalization = (0, _dependency_injector.default)({
            engine: function() {
                return "base"
            },
            _dictionary: baseDictionary,
            load: function(messages) {
                (0, _extend.extend)(true, this._dictionary, messages)
            },
            _localizablePrefix: "@",
            setup: function(localizablePrefix) {
                this._localizablePrefix = localizablePrefix
            },
            localizeString: function(text) {
                var that = this;
                var regex = new RegExp("(^|[^a-zA-Z_0-9" + that._localizablePrefix + "-]+)(" + that._localizablePrefix + "{1,2})([a-zA-Z_0-9-]+)", "g");
                var escapeString = that._localizablePrefix + that._localizablePrefix;
                return text.replace(regex, function(str, prefix, escape, localizationKey) {
                    var defaultResult = that._localizablePrefix + localizationKey;
                    var result;
                    if (escape !== escapeString) {
                        result = that.format(localizationKey)
                    }
                    if (!result) {
                        newMessages[localizationKey] = (0, _inflector.humanize)(localizationKey)
                    }
                    return prefix + (result || defaultResult)
                })
            },
            localizeNode: function(node) {
                var that = this;
                (0, _renderer.default)(node).each(function(index, nodeItem) {
                    if (!nodeItem.nodeType) {
                        return
                    }
                    if (3 === nodeItem.nodeType) {
                        nodeItem.nodeValue = that.localizeString(nodeItem.nodeValue)
                    } else {
                        if (!(0, _renderer.default)(nodeItem).is("iframe")) {
                            (0, _iterator.each)(nodeItem.attributes || [], function(index, attr) {
                                if ("string" === typeof attr.value) {
                                    var localizedValue = that.localizeString(attr.value);
                                    if (attr.value !== localizedValue) {
                                        attr.value = localizedValue
                                    }
                                }
                            });
                            (0, _renderer.default)(nodeItem).contents().each(function(index, node) {
                                that.localizeNode(node)
                            })
                        }
                    }
                })
            },
            getMessagesByLocales: function() {
                return this._dictionary
            },
            getDictionary: function(onlyNew) {
                if (onlyNew) {
                    return newMessages
                }
                return (0, _extend.extend)({}, newMessages, this.getMessagesByLocales()[_core.default.locale()])
            },
            getFormatter: function(key) {
                return this._getFormatterBase(key) || this._getFormatterBase(key, "en")
            },
            _getFormatterBase: function(key, locale) {
                var _this = this;
                var message = _core.default.getValueByClosestLocale(function(locale) {
                    return getDataByLocale(_this._dictionary, locale)[key]
                });
                if (message) {
                    return function() {
                        var args = 1 === arguments.length && Array.isArray(arguments[0]) ? arguments[0].slice(0) : Array.prototype.slice.call(arguments, 0);
                        args.unshift(message);
                        return _string.format.apply(this, args)
                    }
                }
            },
            format: function(key) {
                var formatter = this.getFormatter(key);
                var values = Array.prototype.slice.call(arguments, 1);
                return formatter && formatter.apply(this, values) || ""
            }
        });
        var _default = messageLocalization;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************!*\
      !*** ./artifacts/transpiled-npm/core/dom_adapter.js ***!
      \******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _dependency_injector = _interopRequireDefault(__webpack_require__( /*! ./utils/dependency_injector */ 58));
        var _common = __webpack_require__( /*! ./utils/common */ 4);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        var ELEMENT_NODE = 1;
        var TEXT_NODE = 3;
        var DOCUMENT_NODE = 9;
        var nativeDOMAdapterStrategy = {
            querySelectorAll: function(element, selector) {
                return element.querySelectorAll(selector)
            },
            elementMatches: function(element, selector) {
                var _this = this;
                var matches = element.matches || element.matchesSelector || element.mozMatchesSelector || element.msMatchesSelector || element.oMatchesSelector || element.webkitMatchesSelector || function(selector) {
                    var doc = element.document || element.ownerDocument;
                    if (!doc) {
                        return false
                    }
                    var items = _this.querySelectorAll(doc, selector);
                    for (var i = 0; i < items.length; i++) {
                        if (items[i] === element) {
                            return true
                        }
                    }
                };
                return matches.call(element, selector)
            },
            createElement: function(tagName, context) {
                context = context || this._document;
                return context.createElement(tagName)
            },
            createElementNS: function(ns, tagName, context) {
                context = context || this._document;
                return context.createElementNS(ns, tagName)
            },
            createTextNode: function(text, context) {
                context = context || this._document;
                return context.createTextNode(text)
            },
            isNode: function(element) {
                return element && "object" === _typeof(element) && "nodeType" in element && "nodeName" in element
            },
            isElementNode: function(element) {
                return element && element.nodeType === ELEMENT_NODE
            },
            isTextNode: function(element) {
                return element && element.nodeType === TEXT_NODE
            },
            isDocument: function(element) {
                return element && element.nodeType === DOCUMENT_NODE
            },
            removeElement: function(element) {
                var parentNode = element && element.parentNode;
                if (parentNode) {
                    parentNode.removeChild(element)
                }
            },
            insertElement: function(parentElement, newElement, nextSiblingElement) {
                if (parentElement && newElement && parentElement !== newElement) {
                    if (nextSiblingElement) {
                        parentElement.insertBefore(newElement, nextSiblingElement)
                    } else {
                        parentElement.appendChild(newElement)
                    }
                }
            },
            getAttribute: function(element, name) {
                return element.getAttribute(name)
            },
            setAttribute: function(element, name, value) {
                element.setAttribute(name, value)
            },
            removeAttribute: function(element, name) {
                element.removeAttribute(name)
            },
            setProperty: function(element, name, value) {
                element[name] = value
            },
            setText: function(element, text) {
                if (element) {
                    element.textContent = text
                }
            },
            setClass: function(element, className, isAdd) {
                if (1 === element.nodeType && className) {
                    if (element.classList) {
                        if (isAdd) {
                            element.classList.add(className)
                        } else {
                            element.classList.remove(className)
                        }
                    } else {
                        var classNameSupported = "string" === typeof element.className;
                        var elementClass = classNameSupported ? element.className : this.getAttribute(element, "class") || "";
                        var classNames = elementClass.split(" ");
                        var classIndex = classNames.indexOf(className);
                        var resultClassName;
                        if (isAdd && classIndex < 0) {
                            resultClassName = elementClass ? elementClass + " " + className : className
                        }
                        if (!isAdd && classIndex >= 0) {
                            classNames.splice(classIndex, 1);
                            resultClassName = classNames.join(" ")
                        }
                        if (void 0 !== resultClassName) {
                            if (classNameSupported) {
                                element.className = resultClassName
                            } else {
                                this.setAttribute(element, "class", resultClassName)
                            }
                        }
                    }
                }
            },
            setStyle: function(element, name, value) {
                element.style[name] = value || ""
            },
            _document: "undefined" === typeof document ? void 0 : document,
            getDocument: function() {
                return this._document
            },
            getActiveElement: function() {
                return this._document.activeElement
            },
            getBody: function() {
                return this._document.body
            },
            createDocumentFragment: function() {
                return this._document.createDocumentFragment()
            },
            getDocumentElement: function() {
                return this._document.documentElement
            },
            getLocation: function() {
                return this._document.location
            },
            getSelection: function() {
                return this._document.selection
            },
            getReadyState: function() {
                return this._document.readyState
            },
            getHead: function() {
                return this._document.head
            },
            hasDocumentProperty: function(property) {
                return property in this._document
            },
            listen: function(element, event, callback, options) {
                if (!element || !("addEventListener" in element)) {
                    return _common.noop
                }
                element.addEventListener(event, callback, options);
                return function() {
                    element.removeEventListener(event, callback)
                }
            }
        };
        var _default = (0, _dependency_injector.default)(nativeDOMAdapterStrategy);
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/array.js ***!
      \******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.groupBy = exports.find = exports.merge = exports.normalizeIndexes = exports.removeDuplicates = exports.uniqueValues = exports.intersection = exports.inArray = exports.wrapToArray = exports.isEmpty = void 0;
        var _type = __webpack_require__( /*! ./type */ 1);
        var _iterator = __webpack_require__( /*! ./iterator */ 3);
        var _object = __webpack_require__( /*! ./object */ 51);
        var _config = _interopRequireDefault(__webpack_require__( /*! ../config */ 31));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }
        var isEmpty = function(entity) {
            return Array.isArray(entity) && !entity.length
        };
        exports.isEmpty = isEmpty;
        var wrapToArray = function(entity) {
            return Array.isArray(entity) ? entity : [entity]
        };
        exports.wrapToArray = wrapToArray;
        var inArray = function(value, object) {
            if (!object) {
                return -1
            }
            var array = Array.isArray(object) ? object : object.toArray();
            return array.indexOf(value)
        };
        exports.inArray = inArray;
        var intersection = function(a, b) {
            if (!Array.isArray(a) || 0 === a.length || !Array.isArray(b) || 0 === b.length) {
                return []
            }
            var result = [];
            (0, _iterator.each)(a, function(_, value) {
                var index = inArray(value, b);
                if (index !== -1) {
                    result.push(value)
                }
            });
            return result
        };
        exports.intersection = intersection;
        var uniqueValues = function(data) {
            return data.filter(function(item, position) {
                return data.indexOf(item) === position
            })
        };
        exports.uniqueValues = uniqueValues;
        var removeDuplicates = function(from, what) {
            if (!Array.isArray(from) || 0 === from.length) {
                return []
            }
            if (!Array.isArray(what) || 0 === what.length) {
                return from.slice()
            }
            var result = [];
            (0, _iterator.each)(from, function(_, value) {
                var index = inArray(value, what);
                if (index === -1) {
                    result.push(value)
                }
            });
            return result
        };
        exports.removeDuplicates = removeDuplicates;
        var normalizeIndexes = function(items, indexParameterName, currentItem, needIndexCallback) {
            var indexedItems = {};
            var parameterIndex = 0;
            var useLegacyVisibleIndex = (0, _config.default)().useLegacyVisibleIndex;
            (0, _iterator.each)(items, function(index, item) {
                index = item[indexParameterName];
                if (index >= 0) {
                    indexedItems[index] = indexedItems[index] || [];
                    if (item === currentItem) {
                        indexedItems[index].unshift(item)
                    } else {
                        indexedItems[index].push(item)
                    }
                } else {
                    item[indexParameterName] = void 0
                }
            });
            if (!useLegacyVisibleIndex) {
                (0, _iterator.each)(items, function() {
                    if (!(0, _type.isDefined)(this[indexParameterName]) && (!needIndexCallback || needIndexCallback(this))) {
                        while (indexedItems[parameterIndex]) {
                            parameterIndex++
                        }
                        indexedItems[parameterIndex] = [this];
                        parameterIndex++
                    }
                })
            }
            parameterIndex = 0;
            (0, _object.orderEach)(indexedItems, function(index, items) {
                (0, _iterator.each)(items, function() {
                    if (index >= 0) {
                        this[indexParameterName] = parameterIndex++
                    }
                })
            });
            if (useLegacyVisibleIndex) {
                (0, _iterator.each)(items, function() {
                    if (!(0, _type.isDefined)(this[indexParameterName]) && (!needIndexCallback || needIndexCallback(this))) {
                        this[indexParameterName] = parameterIndex++
                    }
                })
            }
            return parameterIndex
        };
        exports.normalizeIndexes = normalizeIndexes;
        var merge = function(array1, array2) {
            for (var i = 0; i < array2.length; i++) {
                array1[array1.length] = array2[i]
            }
            return array1
        };
        exports.merge = merge;
        var find = function(array, condition) {
            for (var i = 0; i < array.length; i++) {
                if (condition(array[i])) {
                    return array[i]
                }
            }
        };
        exports.find = find;
        var groupBy = function(array, cb) {
            return array.reduce(function(result, item) {
                return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, cb(item), [].concat(_toConsumableArray(result[cb(item)] || []), [item])))
            }, {})
        };
        exports.groupBy = groupBy
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/core/devices.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _window = __webpack_require__( /*! ./utils/window */ 7);
        var _extend = __webpack_require__( /*! ./utils/extend */ 0);
        var _type = __webpack_require__( /*! ./utils/type */ 1);
        var _iterator = __webpack_require__( /*! ./utils/iterator */ 3);
        var _errors = _interopRequireDefault(__webpack_require__( /*! ./errors */ 25));
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ./utils/callbacks */ 27));
        var _ready_callbacks = _interopRequireDefault(__webpack_require__( /*! ./utils/ready_callbacks */ 49));
        var _resize_callbacks = _interopRequireDefault(__webpack_require__( /*! ./utils/resize_callbacks */ 125));
        var _events_strategy = __webpack_require__( /*! ./events_strategy */ 100);
        var _storage = __webpack_require__( /*! ./utils/storage */ 324);
        var _view_port = __webpack_require__( /*! ./utils/view_port */ 80);
        var _config = _interopRequireDefault(__webpack_require__( /*! ./config */ 31));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var navigator = (0, _window.getNavigator)();
        var window = (0, _window.getWindow)();
        var KNOWN_UA_TABLE = {
            iPhone: "iPhone",
            iPhone5: "iPhone",
            iPhone6: "iPhone",
            iPhone6plus: "iPhone",
            iPad: "iPad",
            iPadMini: "iPad Mini",
            androidPhone: "Android Mobile",
            androidTablet: "Android",
            msSurface: "Windows ARM Tablet PC",
            desktop: "desktop"
        };
        var DEFAULT_DEVICE = {
            deviceType: "desktop",
            platform: "generic",
            version: [],
            phone: false,
            tablet: false,
            android: false,
            ios: false,
            generic: true,
            grade: "A",
            mac: false
        };
        var uaParsers = {
            generic: function(userAgent) {
                var isPhone = /windows phone/i.test(userAgent) || userAgent.match(/WPDesktop/);
                var isTablet = !isPhone && /Windows(.*)arm(.*)Tablet PC/i.test(userAgent);
                var isDesktop = !isPhone && !isTablet && /msapphost/i.test(userAgent);
                var isMac = /((intel|ppc) mac os x)/.test(userAgent.toLowerCase());
                if (!(isPhone || isTablet || isDesktop || isMac)) {
                    return
                }
                return {
                    deviceType: isPhone ? "phone" : isTablet ? "tablet" : "desktop",
                    platform: "generic",
                    version: [],
                    grade: "A",
                    mac: isMac
                }
            },
            ios: function(userAgent) {
                if (!/ip(hone|od|ad)/i.test(userAgent)) {
                    return
                }
                var isPhone = /ip(hone|od)/i.test(userAgent);
                var matches = userAgent.match(/os (\d+)_(\d+)_?(\d+)?/i);
                var version = matches ? [parseInt(matches[1], 10), parseInt(matches[2], 10), parseInt(matches[3] || 0, 10)] : [];
                var isIPhone4 = 480 === window.screen.height;
                var grade = isIPhone4 ? "B" : "A";
                return {
                    deviceType: isPhone ? "phone" : "tablet",
                    platform: "ios",
                    version: version,
                    grade: grade
                }
            },
            android: function(userAgent) {
                if (!/android|htc_|silk/i.test(userAgent)) {
                    return
                }
                var isPhone = /mobile/i.test(userAgent);
                var matches = userAgent.match(/android (\d+)\.?(\d+)?\.?(\d+)?/i);
                var version = matches ? [parseInt(matches[1], 10), parseInt(matches[2] || 0, 10), parseInt(matches[3] || 0, 10)] : [];
                var worseThan4_4 = version.length > 1 && (version[0] < 4 || 4 === version[0] && version[1] < 4);
                var grade = worseThan4_4 ? "B" : "A";
                return {
                    deviceType: isPhone ? "phone" : "tablet",
                    platform: "android",
                    version: version,
                    grade: grade
                }
            }
        };
        var Devices = function() {
            function Devices(options) {
                this._window = (null === options || void 0 === options ? void 0 : options.window) || window;
                this._realDevice = this._getDevice();
                this._currentDevice = void 0;
                this._currentOrientation = void 0;
                this._eventsStrategy = new _events_strategy.EventsStrategy(this);
                this.changed = (0, _callbacks.default)();
                if ((0, _window.hasWindow)()) {
                    _ready_callbacks.default.add(this._recalculateOrientation.bind(this));
                    _resize_callbacks.default.add(this._recalculateOrientation.bind(this))
                }
            }
            var _proto = Devices.prototype;
            _proto.current = function(deviceOrName) {
                if (deviceOrName) {
                    this._currentDevice = this._getDevice(deviceOrName);
                    this._forced = true;
                    this.changed.fire();
                    return
                }
                if (!this._currentDevice) {
                    deviceOrName = void 0;
                    try {
                        deviceOrName = this._getDeviceOrNameFromWindowScope()
                    } catch (e) {
                        deviceOrName = this._getDeviceNameFromSessionStorage()
                    } finally {
                        if (!deviceOrName) {
                            deviceOrName = this._getDeviceNameFromSessionStorage()
                        }
                        if (deviceOrName) {
                            this._forced = true
                        }
                    }
                    this._currentDevice = this._getDevice(deviceOrName)
                }
                return this._currentDevice
            };
            _proto.real = function(forceDevice) {
                return (0, _extend.extend)({}, this._realDevice)
            };
            _proto.orientation = function() {
                return this._currentOrientation
            };
            _proto.isForced = function() {
                return this._forced
            };
            _proto.isRippleEmulator = function() {
                return !!this._window.tinyHippos
            };
            _proto._getCssClasses = function(device) {
                var result = [];
                var realDevice = this._realDevice;
                device = device || this.current();
                if (device.deviceType) {
                    result.push("dx-device-".concat(device.deviceType));
                    if ("desktop" !== device.deviceType) {
                        result.push("dx-device-mobile")
                    }
                }
                result.push("dx-device-".concat(realDevice.platform));
                if (realDevice.version && realDevice.version.length) {
                    result.push("dx-device-".concat(realDevice.platform, "-").concat(realDevice.version[0]))
                }
                if (this.isSimulator()) {
                    result.push("dx-simulator")
                }
                if ((0, _config.default)().rtlEnabled) {
                    result.push("dx-rtl")
                }
                return result
            };
            _proto.attachCssClasses = function(element, device) {
                this._deviceClasses = this._getCssClasses(device).join(" ");
                (0, _renderer.default)(element).addClass(this._deviceClasses)
            };
            _proto.detachCssClasses = function(element) {
                (0, _renderer.default)(element).removeClass(this._deviceClasses)
            };
            _proto.isSimulator = function() {
                try {
                    return this._isSimulator || (0, _window.hasWindow)() && this._window.top !== this._window.self && this._window.top["dx-force-device"] || this.isRippleEmulator()
                } catch (e) {
                    return false
                }
            };
            _proto.forceSimulator = function() {
                this._isSimulator = true
            };
            _proto._getDevice = function(deviceName) {
                if ("genericPhone" === deviceName) {
                    deviceName = {
                        deviceType: "phone",
                        platform: "generic",
                        generic: true
                    }
                }
                if ((0, _type.isPlainObject)(deviceName)) {
                    return this._fromConfig(deviceName)
                } else {
                    var ua;
                    if (deviceName) {
                        ua = KNOWN_UA_TABLE[deviceName];
                        if (!ua) {
                            throw _errors.default.Error("E0005")
                        }
                    } else {
                        ua = navigator.userAgent
                    }
                    return this._fromUA(ua)
                }
            };
            _proto._getDeviceOrNameFromWindowScope = function() {
                var result;
                if ((0, _window.hasWindow)() && (this._window.top["dx-force-device-object"] || this._window.top["dx-force-device"])) {
                    result = this._window.top["dx-force-device-object"] || this._window.top["dx-force-device"]
                }
                return result
            };
            _proto._getDeviceNameFromSessionStorage = function() {
                var sessionStorage = (0, _storage.sessionStorage)();
                if (!sessionStorage) {
                    return
                }
                var deviceOrName = sessionStorage.getItem("dx-force-device");
                try {
                    return JSON.parse(deviceOrName)
                } catch (ex) {
                    return deviceOrName
                }
            };
            _proto._fromConfig = function(config) {
                var result = (0, _extend.extend)({}, DEFAULT_DEVICE, this._currentDevice, config);
                var shortcuts = {
                    phone: "phone" === result.deviceType,
                    tablet: "tablet" === result.deviceType,
                    android: "android" === result.platform,
                    ios: "ios" === result.platform,
                    generic: "generic" === result.platform
                };
                return (0, _extend.extend)(result, shortcuts)
            };
            _proto._fromUA = function(ua) {
                var config;
                (0, _iterator.each)(uaParsers, function(platform, parser) {
                    config = parser(ua);
                    return !config
                });
                if (config) {
                    return this._fromConfig(config)
                }
                return DEFAULT_DEVICE
            };
            _proto._changeOrientation = function() {
                var $window = (0, _renderer.default)(this._window);
                var orientation = $window.height() > $window.width() ? "portrait" : "landscape";
                if (this._currentOrientation === orientation) {
                    return
                }
                this._currentOrientation = orientation;
                this._eventsStrategy.fireEvent("orientationChanged", [{
                    orientation: orientation
                }])
            };
            _proto._recalculateOrientation = function() {
                var windowWidth = (0, _renderer.default)(this._window).width();
                if (this._currentWidth === windowWidth) {
                    return
                }
                this._currentWidth = windowWidth;
                this._changeOrientation()
            };
            _proto.on = function(eventName, eventHandler) {
                this._eventsStrategy.on(eventName, eventHandler);
                return this
            };
            _proto.off = function(eventName, eventHandler) {
                this._eventsStrategy.off(eventName, eventHandler);
                return this
            };
            return Devices
        }();
        var devices = new Devices;
        _view_port.changeCallback.add(function(viewPort, prevViewport) {
            devices.detachCssClasses(prevViewport);
            devices.attachCssClasses(viewPort)
        });
        var _default = devices;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/core/utils.js ***!
      \****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.map = map;
        exports.normalizeEnum = normalizeEnum;
        exports.setCanvasValues = setCanvasValues;
        exports.normalizeBBox = normalizeBBox;
        exports.rotateBBox = rotateBBox;
        exports.convertPolarToXY = convertPolarToXY;
        exports.isRelativeHeightPane = isRelativeHeightPane;
        exports.normalizePanesHeight = normalizePanesHeight;
        exports.updatePanesCanvases = updatePanesCanvases;
        exports.mergeMarginOptions = mergeMarginOptions;
        exports.getVizRangeObject = getVizRangeObject;
        exports.convertVisualRangeObject = convertVisualRangeObject;
        exports.getAddFunction = getAddFunction;
        exports.adjustVisualRange = adjustVisualRange;
        exports.getLogExt = getLogExt;
        exports.raiseToExt = raiseToExt;
        exports.rangesAreEqual = rangesAreEqual;
        exports.valueOf = valueOf;
        exports.pointInCanvas = pointInCanvas;
        exports.getVerticallyShiftedAngularCoords = exports.unique = exports.getCategoriesInfo = exports.processSeriesTemplate = exports.convertXYToPolar = exports.patchFontOptions = exports.enumParser = exports.parseScalar = exports.decreaseGaps = exports.getPower = exports.roundValue = exports.getAppropriateFormat = exports.getDecimalOrder = exports.getDistance = exports.getCosAndSin = exports.degreesToRadians = exports.convertAngleToRendererSpace = exports.normalizeAngle = exports.raiseTo = exports.getAdjustedLog10 = exports.getLog = exports.PANE_PADDING = void 0;
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _math = __webpack_require__( /*! ../../core/utils/math */ 29);
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));
        var _color = _interopRequireDefault(__webpack_require__( /*! ../../color */ 95));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var PI = Math.PI,
            LN10 = Math.LN10,
            abs = Math.abs,
            log = Math.log,
            floor = Math.floor,
            ceil = Math.ceil,
            pow = Math.pow,
            sqrt = Math.sqrt,
            atan2 = Math.atan2;
        var _min = Math.min;
        var _max = Math.max;
        var _cos = Math.cos;
        var _sin = Math.sin;
        var _round = Math.round;
        var dateToMilliseconds = _date.default.dateToMilliseconds;
        var MAX_PIXEL_COUNT = 1e10;
        var PI_DIV_180 = PI / 180;
        var _isNaN = isNaN;
        var _Number = Number;
        var _NaN = NaN;
        var PANE_PADDING = 10;
        exports.PANE_PADDING = PANE_PADDING;
        var getLog = function(value, base) {
            if (!value) {
                return _NaN
            }
            return log(value) / log(base)
        };
        exports.getLog = getLog;
        var getAdjustedLog10 = function(value) {
            return (0, _math.adjust)(getLog(value, 10))
        };
        exports.getAdjustedLog10 = getAdjustedLog10;
        var raiseTo = function(power, base) {
            return pow(base, power)
        };
        exports.raiseTo = raiseTo;
        var normalizeAngle = function(angle) {
            return (angle % 360 + 360) % 360
        };
        exports.normalizeAngle = normalizeAngle;
        var convertAngleToRendererSpace = function(angle) {
            return 90 - angle
        };
        exports.convertAngleToRendererSpace = convertAngleToRendererSpace;
        var degreesToRadians = function(value) {
            return PI * value / 180
        };
        exports.degreesToRadians = degreesToRadians;
        var getCosAndSin = function(angle) {
            var angleInRadians = degreesToRadians(angle);
            return {
                cos: _cos(angleInRadians),
                sin: _sin(angleInRadians)
            }
        };
        exports.getCosAndSin = getCosAndSin;
        var DECIMAL_ORDER_THRESHOLD = 1e-14;
        var getDistance = function(x1, y1, x2, y2) {
            var diffX = x2 - x1;
            var diffY = y2 - y1;
            return sqrt(diffY * diffY + diffX * diffX)
        };
        exports.getDistance = getDistance;
        var getDecimalOrder = function(number) {
            var n = abs(number);
            var cn;
            if (!_isNaN(n)) {
                if (n > 0) {
                    n = log(n) / LN10;
                    cn = ceil(n);
                    return cn - n < DECIMAL_ORDER_THRESHOLD ? cn : floor(n)
                }
                return 0
            }
            return _NaN
        };
        exports.getDecimalOrder = getDecimalOrder;
        var getAppropriateFormat = function(start, end, count) {
            var order = _max(getDecimalOrder(start), getDecimalOrder(end));
            var precision = -getDecimalOrder(abs(end - start) / count);
            var format;
            if (!_isNaN(order) && !_isNaN(precision)) {
                if (abs(order) <= 4) {
                    format = "fixedPoint";
                    precision < 0 && (precision = 0);
                    precision > 4 && (precision = 4)
                } else {
                    format = "exponential";
                    precision += order - 1;
                    precision > 3 && (precision = 3)
                }
                return {
                    type: format,
                    precision: precision
                }
            }
            return null
        };
        exports.getAppropriateFormat = getAppropriateFormat;
        var roundValue = function(value, precision) {
            if (precision > 20) {
                precision = 20
            }
            if ((0, _type.isNumeric)(value)) {
                if ((0, _type.isExponential)(value)) {
                    return _Number(value.toExponential(precision))
                } else {
                    return _Number(value.toFixed(precision))
                }
            }
        };
        exports.roundValue = roundValue;
        var getPower = function(value) {
            return value.toExponential().split("e")[1]
        };
        exports.getPower = getPower;

        function map(array, callback) {
            var i = 0;
            var len = array.length;
            var result = [];
            var value;
            while (i < len) {
                value = callback(array[i], i);
                if (null !== value) {
                    result.push(value)
                }
                i++
            }
            return result
        }

        function selectByKeys(object, keys) {
            return map(keys, function(key) {
                return object[key] ? object[key] : null
            })
        }

        function decreaseFields(object, keys, eachDecrease, decrease) {
            var dec = decrease;
            (0, _iterator.each)(keys, function(_, key) {
                if (object[key]) {
                    object[key] -= eachDecrease;
                    dec -= eachDecrease
                }
            });
            return dec
        }

        function normalizeEnum(value) {
            return String(value).toLowerCase()
        }

        function setCanvasValues(canvas) {
            if (canvas) {
                canvas.originalTop = canvas.top;
                canvas.originalBottom = canvas.bottom;
                canvas.originalLeft = canvas.left;
                canvas.originalRight = canvas.right
            }
            return canvas
        }

        function normalizeBBoxField(value) {
            return -MAX_PIXEL_COUNT < value && value < +MAX_PIXEL_COUNT ? value : 0
        }

        function normalizeBBox(bBox) {
            var xl = normalizeBBoxField(floor(bBox.x));
            var yt = normalizeBBoxField(floor(bBox.y));
            var xr = normalizeBBoxField(ceil(bBox.width + bBox.x));
            var yb = normalizeBBoxField(ceil(bBox.height + bBox.y));
            var result = {
                x: xl,
                y: yt,
                width: xr - xl,
                height: yb - yt
            };
            result.isEmpty = !result.x && !result.y && !result.width && !result.height;
            return result
        }

        function rotateBBox(bBox, center, angle) {
            var cos = _Number(_cos(angle * PI_DIV_180).toFixed(3));
            var sin = _Number(_sin(angle * PI_DIV_180).toFixed(3));
            var w2 = bBox.width / 2;
            var h2 = bBox.height / 2;
            var centerX = bBox.x + w2;
            var centerY = bBox.y + h2;
            var w2_ = abs(w2 * cos) + abs(h2 * sin);
            var h2_ = abs(w2 * sin) + abs(h2 * cos);
            var centerX_ = center[0] + (centerX - center[0]) * cos + (centerY - center[1]) * sin;
            var centerY_ = center[1] - (centerX - center[0]) * sin + (centerY - center[1]) * cos;
            return normalizeBBox({
                x: centerX_ - w2_,
                y: centerY_ - h2_,
                width: 2 * w2_,
                height: 2 * h2_
            })
        }
        var decreaseGaps = function(object, keys, decrease) {
            var arrayGaps;
            do {
                arrayGaps = selectByKeys(object, keys);
                arrayGaps.push(ceil(decrease / arrayGaps.length));
                decrease = decreaseFields(object, keys, _min.apply(null, arrayGaps), decrease)
            } while (decrease > 0 && arrayGaps.length > 1);
            return decrease
        };
        exports.decreaseGaps = decreaseGaps;
        var parseScalar = function(value, defaultValue) {
            return void 0 !== value ? value : defaultValue
        };
        exports.parseScalar = parseScalar;
        var enumParser = function(values) {
            var stored = {};
            var i;
            var ii;
            for (i = 0, ii = values.length; i < ii; ++i) {
                stored[normalizeEnum(values[i])] = 1
            }
            return function(value, defaultValue) {
                var _value = normalizeEnum(value);
                return stored[_value] ? _value : defaultValue
            }
        };
        exports.enumParser = enumParser;
        var patchFontOptions = function(options) {
            var fontOptions = {};
            (0, _iterator.each)(options || {}, function(key, value) {
                if (/^(cursor)$/i.test(key)) {} else {
                    if ("opacity" === key) {
                        value = null
                    } else {
                        if ("color" === key) {
                            key = "fill";
                            if ("opacity" in options) {
                                var color = new _color.default(value);
                                value = "rgba(".concat(color.r, ",").concat(color.g, ",").concat(color.b, ",").concat(options.opacity, ")")
                            }
                        } else {
                            key = "font-" + key
                        }
                    }
                }
                fontOptions[key] = value
            });
            return fontOptions
        };
        exports.patchFontOptions = patchFontOptions;

        function convertPolarToXY(centerCoords, startAngle, angle, radius) {
            var shiftAngle = 90;
            var normalizedRadius = radius > 0 ? radius : 0;
            angle = (0, _type.isDefined)(angle) ? angle + startAngle - shiftAngle : 0;
            var cosSin = getCosAndSin(angle);
            return {
                x: _round(centerCoords.x + normalizedRadius * cosSin.cos),
                y: _round(centerCoords.y + normalizedRadius * cosSin.sin)
            }
        }
        var convertXYToPolar = function(centerCoords, x, y) {
            var radius = getDistance(centerCoords.x, centerCoords.y, x, y);
            var angle = atan2(y - centerCoords.y, x - centerCoords.x);
            return {
                phi: _round(normalizeAngle(180 * angle / PI)),
                r: _round(radius)
            }
        };
        exports.convertXYToPolar = convertXYToPolar;
        var processSeriesTemplate = function(seriesTemplate, items) {
            var customizeSeries = (0, _type.isFunction)(seriesTemplate.customizeSeries) ? seriesTemplate.customizeSeries : _common.noop;
            var nameField = seriesTemplate.nameField;
            var generatedSeries = {};
            var seriesOrder = [];
            var series;
            var i = 0;
            var length;
            var data;
            items = items || [];
            for (length = items.length; i < length; i++) {
                data = items[i];
                if (nameField in data) {
                    series = generatedSeries[data[nameField]];
                    if (!series) {
                        series = generatedSeries[data[nameField]] = {
                            name: data[nameField],
                            nameFieldValue: data[nameField]
                        };
                        seriesOrder.push(series.name)
                    }
                }
            }
            return map(seriesOrder, function(orderedName) {
                var group = generatedSeries[orderedName];
                return (0, _extend.extend)(group, customizeSeries.call(null, group.name))
            })
        };
        exports.processSeriesTemplate = processSeriesTemplate;
        var getCategoriesInfo = function(categories, startValue, endValue) {
            if (0 === categories.length) {
                return {
                    categories: []
                }
            }
            startValue = (0, _type.isDefined)(startValue) ? startValue : categories[0];
            endValue = (0, _type.isDefined)(endValue) ? endValue : categories[categories.length - 1];
            var categoriesValue = map(categories, function(category) {
                return null === category || void 0 === category ? void 0 : category.valueOf()
            });
            var indexStartValue = categoriesValue.indexOf(startValue.valueOf());
            var indexEndValue = categoriesValue.indexOf(endValue.valueOf());
            var swapBuf;
            var inverted = false;
            indexStartValue < 0 && (indexStartValue = 0);
            indexEndValue < 0 && (indexEndValue = categories.length - 1);
            if (indexEndValue < indexStartValue) {
                swapBuf = indexEndValue;
                indexEndValue = indexStartValue;
                indexStartValue = swapBuf;
                inverted = true
            }
            var visibleCategories = categories.slice(indexStartValue, indexEndValue + 1);
            var lastIdx = visibleCategories.length - 1;
            return {
                categories: visibleCategories,
                start: visibleCategories[inverted ? lastIdx : 0],
                end: visibleCategories[inverted ? 0 : lastIdx],
                inverted: inverted
            }
        };
        exports.getCategoriesInfo = getCategoriesInfo;

        function isRelativeHeightPane(pane) {
            return !(pane.unit % 2)
        }

        function normalizePanesHeight(panes) {
            panes.forEach(function(pane) {
                var height = pane.height;
                var unit = 0;
                var parsedHeight = parseFloat(height) || void 0;
                if ((0, _type.isString)(height) && height.indexOf("px") > -1 || (0, _type.isNumeric)(height) && height > 1) {
                    parsedHeight = _round(parsedHeight);
                    unit = 1
                }
                if (!unit && parsedHeight) {
                    if ((0, _type.isString)(height) && height.indexOf("%") > -1) {
                        parsedHeight /= 100;
                        unit = 2
                    } else {
                        if (parsedHeight < 0) {
                            parsedHeight = parsedHeight < -1 ? 1 : abs(parsedHeight)
                        }
                    }
                }
                pane.height = parsedHeight;
                pane.unit = unit
            });
            var relativeHeightPanes = panes.filter(isRelativeHeightPane);
            var weightSum = relativeHeightPanes.reduce(function(prev, next) {
                return prev + (next.height || 0)
            }, 0);
            var weightHeightCount = relativeHeightPanes.length;
            var emptyHeightPanes = relativeHeightPanes.filter(function(pane) {
                return !pane.height
            });
            var emptyHeightCount = emptyHeightPanes.length;
            if (weightSum < 1 && emptyHeightCount) {
                emptyHeightPanes.forEach(function(pane) {
                    return pane.height = (1 - weightSum) / emptyHeightCount
                })
            } else {
                if (weightSum > 1 || weightSum < 1 && !emptyHeightCount || 1 === weightSum && emptyHeightCount) {
                    if (emptyHeightCount) {
                        var weightForEmpty = weightSum / weightHeightCount;
                        var emptyWeightSum = emptyHeightCount * weightForEmpty;
                        relativeHeightPanes.filter(function(pane) {
                            return pane.height
                        }).forEach(function(pane) {
                            return pane.height *= (weightSum - emptyWeightSum) / weightSum
                        });
                        emptyHeightPanes.forEach(function(pane) {
                            return pane.height = weightForEmpty
                        })
                    }
                    relativeHeightPanes.forEach(function(pane) {
                        return pane.height *= 1 / weightSum
                    })
                }
            }
        }

        function updatePanesCanvases(panes, canvas, rotated) {
            var distributedSpace = 0;
            var padding = PANE_PADDING;
            var paneSpace = rotated ? canvas.width - canvas.left - canvas.right : canvas.height - canvas.top - canvas.bottom;
            var totalCustomSpace = panes.reduce(function(prev, cur) {
                return prev + (!isRelativeHeightPane(cur) ? cur.height : 0)
            }, 0);
            var usefulSpace = paneSpace - padding * (panes.length - 1) - totalCustomSpace;
            var startName = rotated ? "left" : "top";
            var endName = rotated ? "right" : "bottom";
            panes.forEach(function(pane) {
                var calcLength = !isRelativeHeightPane(pane) ? pane.height : _round(pane.height * usefulSpace);
                pane.canvas = pane.canvas || {};
                (0, _extend.extend)(pane.canvas, canvas);
                pane.canvas[startName] = canvas[startName] + distributedSpace;
                pane.canvas[endName] = canvas[endName] + (paneSpace - calcLength - distributedSpace);
                distributedSpace = distributedSpace + calcLength + padding;
                setCanvasValues(pane.canvas)
            })
        }
        var unique = function(array) {
            var values = {};
            return map(array, function(item) {
                var result = !values[item] ? item : null;
                values[item] = true;
                return result
            })
        };
        exports.unique = unique;
        var getVerticallyShiftedAngularCoords = function(bBox, dy, center) {
            var isPositive = bBox.x + bBox.width / 2 >= center.x;
            var horizontalOffset1 = (isPositive ? bBox.x : bBox.x + bBox.width) - center.x;
            var verticalOffset1 = bBox.y - center.y;
            var verticalOffset2 = verticalOffset1 + dy;
            var horizontalOffset2 = _round(sqrt(horizontalOffset1 * horizontalOffset1 + verticalOffset1 * verticalOffset1 - verticalOffset2 * verticalOffset2));
            var dx = (isPositive ? +horizontalOffset2 : -horizontalOffset2) || horizontalOffset1;
            return {
                x: center.x + (isPositive ? dx : dx - bBox.width),
                y: bBox.y + dy
            }
        };
        exports.getVerticallyShiftedAngularCoords = getVerticallyShiftedAngularCoords;

        function mergeMarginOptions(opt1, opt2) {
            return {
                checkInterval: opt1.checkInterval || opt2.checkInterval,
                size: _max(opt1.size || 0, opt2.size || 0),
                percentStick: opt1.percentStick || opt2.percentStick,
                sizePointNormalState: _max(opt1.sizePointNormalState || 0, opt2.sizePointNormalState || 0)
            }
        }

        function getVizRangeObject(value) {
            if (Array.isArray(value)) {
                return {
                    startValue: value[0],
                    endValue: value[1]
                }
            } else {
                return value || {}
            }
        }

        function convertVisualRangeObject(visualRange, convertToVisualRange) {
            if (convertToVisualRange) {
                return visualRange
            }
            return [visualRange.startValue, visualRange.endValue]
        }

        function getAddFunction(range, correctZeroLevel) {
            if ("datetime" === range.dataType) {
                return function(rangeValue, marginValue) {
                    var sign = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
                    return new Date(rangeValue.getTime() + sign * marginValue)
                }
            }
            if ("logarithmic" === range.axisType) {
                return function(rangeValue, marginValue) {
                    var sign = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
                    var log = getLogExt(rangeValue, range.base) + sign * marginValue;
                    return raiseToExt(log, range.base)
                }
            }
            return function(rangeValue, marginValue) {
                var sign = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
                var newValue = rangeValue + sign * marginValue;
                return correctZeroLevel && newValue * rangeValue <= 0 ? 0 : newValue
            }
        }

        function adjustVisualRange(options, visualRange, wholeRange, dataRange) {
            var minDefined = (0, _type.isDefined)(visualRange.startValue);
            var maxDefined = (0, _type.isDefined)(visualRange.endValue);
            var nonDiscrete = "discrete" !== options.axisType;
            dataRange = dataRange || wholeRange;
            var add = getAddFunction(options, false);
            var min = minDefined ? visualRange.startValue : dataRange.min;
            var max = maxDefined ? visualRange.endValue : dataRange.max;
            var rangeLength = visualRange.length;
            var categories = dataRange.categories;
            if (nonDiscrete && !(0, _type.isDefined)(min) && !(0, _type.isDefined)(max)) {
                return {
                    startValue: min,
                    endValue: max
                }
            }
            if ((0, _type.isDefined)(rangeLength)) {
                if (nonDiscrete) {
                    if ("datetime" === options.dataType && !(0, _type.isNumeric)(rangeLength)) {
                        rangeLength = dateToMilliseconds(rangeLength)
                    }
                    if (maxDefined && !minDefined || !maxDefined && !minDefined) {
                        (0, _type.isDefined)(wholeRange.max) && (max = max > wholeRange.max ? wholeRange.max : max);
                        min = add(max, rangeLength, -1)
                    } else {
                        if (minDefined && !maxDefined) {
                            (0, _type.isDefined)(wholeRange.min) && (min = min < wholeRange.min ? wholeRange.min : min);
                            max = add(min, rangeLength)
                        }
                    }
                } else {
                    rangeLength = parseInt(rangeLength);
                    if (!isNaN(rangeLength) && isFinite(rangeLength)) {
                        rangeLength--;
                        if (!maxDefined && !minDefined) {
                            max = categories[categories.length - 1];
                            min = categories[categories.length - 1 - rangeLength]
                        } else {
                            if (minDefined && !maxDefined) {
                                var categoriesInfo = getCategoriesInfo(categories, min, void 0);
                                max = categoriesInfo.categories[rangeLength]
                            } else {
                                if (!minDefined && maxDefined) {
                                    var _categoriesInfo = getCategoriesInfo(categories, void 0, max);
                                    min = _categoriesInfo.categories[_categoriesInfo.categories.length - 1 - rangeLength]
                                }
                            }
                        }
                    }
                }
            }
            if (nonDiscrete) {
                if ((0, _type.isDefined)(wholeRange.max) && max > wholeRange.max) {
                    max = wholeRange.max
                }
                if ((0, _type.isDefined)(wholeRange.min) && min < wholeRange.min) {
                    min = wholeRange.min
                }
            }
            return {
                startValue: min,
                endValue: max
            }
        }

        function getLogExt(value, base) {
            var allowNegatives = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : false;
            var linearThreshold = arguments.length > 3 ? arguments[3] : void 0;
            if (!allowNegatives) {
                return getLog(value, base)
            }
            if (0 === value) {
                return 0
            }
            var transformValue = getLog(abs(value), base) - (linearThreshold - 1);
            if (transformValue < 0) {
                return 0
            }
            return (0, _math.adjust)((0, _math.sign)(value) * transformValue, Number(pow(base, linearThreshold - 1).toFixed(abs(linearThreshold))))
        }

        function raiseToExt(value, base) {
            var allowNegatives = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : false;
            var linearThreshold = arguments.length > 3 ? arguments[3] : void 0;
            if (!allowNegatives) {
                return raiseTo(value, base)
            }
            if (0 === value) {
                return 0
            }
            var transformValue = raiseTo(abs(value) + (linearThreshold - 1), base);
            if (transformValue < 0) {
                return 0
            }
            return (0, _math.adjust)((0, _math.sign)(value) * transformValue, Number(pow(base, linearThreshold).toFixed(abs(linearThreshold))))
        }

        function rangesAreEqual(range, rangeFromOptions) {
            if (Array.isArray(rangeFromOptions)) {
                return range.length === rangeFromOptions.length && range.every(function(item, i) {
                    return valueOf(item) === valueOf(rangeFromOptions[i])
                })
            } else {
                return valueOf(range.startValue) === valueOf(rangeFromOptions.startValue) && valueOf(range.endValue) === valueOf(rangeFromOptions.endValue)
            }
        }

        function valueOf(value) {
            return value && value.valueOf()
        }

        function pointInCanvas(canvas, x, y) {
            return x >= canvas.left && x <= canvas.right && y >= canvas.top && y <= canvas.bottom
        }
    },
    /*!************************************************!*\
      !*** ./artifacts/transpiled-npm/core/class.js ***!
      \************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _errors = _interopRequireDefault(__webpack_require__( /*! ./errors */ 25));
        var _type = __webpack_require__( /*! ./utils/type */ 1);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var wrapOverridden = function(baseProto, methodName, method) {
            return function() {
                var prevCallBase = this.callBase;
                this.callBase = baseProto[methodName];
                try {
                    return method.apply(this, arguments)
                } finally {
                    this.callBase = prevCallBase
                }
            }
        };
        var clonePrototype = function(obj) {
            var func = function() {};
            func.prototype = obj.prototype;
            return new func
        };
        var redefine = function(members) {
            var that = this;
            var overridden;
            var memberName;
            var member;
            if (!members) {
                return that
            }
            for (memberName in members) {
                member = members[memberName];
                overridden = "function" === typeof that.prototype[memberName] && "function" === typeof member;
                that.prototype[memberName] = overridden ? wrapOverridden(that.parent.prototype, memberName, member) : member
            }
            return that
        };
        var include = function() {
            var classObj = this;
            var argument;
            var name;
            var i;
            var hasClassObjOwnProperty = Object.prototype.hasOwnProperty.bind(classObj);
            var isES6Class = !hasClassObjOwnProperty("_includedCtors") && !hasClassObjOwnProperty("_includedPostCtors");
            if (isES6Class) {
                classObj._includedCtors = classObj._includedCtors.slice(0);
                classObj._includedPostCtors = classObj._includedPostCtors.slice(0)
            }
            for (i = 0; i < arguments.length; i++) {
                argument = arguments[i];
                if (argument.ctor) {
                    classObj._includedCtors.push(argument.ctor)
                }
                if (argument.postCtor) {
                    classObj._includedPostCtors.push(argument.postCtor)
                }
                for (name in argument) {
                    if ("ctor" === name || "postCtor" === name) {
                        continue
                    }
                    classObj.prototype[name] = argument[name]
                }
            }
            return classObj
        };
        var subclassOf = function(parentClass) {
            var hasParentProperty = Object.prototype.hasOwnProperty.bind(this)("parent");
            var isES6Class = !hasParentProperty && this.parent;
            if (isES6Class) {
                var baseClass = Object.getPrototypeOf(this);
                return baseClass === parentClass || baseClass.subclassOf(parentClass)
            } else {
                if (this.parent === parentClass) {
                    return true
                }
                if (!this.parent || !this.parent.subclassOf) {
                    return false
                }
                return this.parent.subclassOf(parentClass)
            }
        };
        var abstract = function() {
            throw _errors.default.Error("E0001")
        };
        var copyStatic = function() {
            var hasOwn = Object.prototype.hasOwnProperty;
            return function(source, destination) {
                for (var key in source) {
                    if (!hasOwn.call(source, key)) {
                        return
                    }
                    destination[key] = source[key]
                }
            }
        }();
        var classImpl = function() {};
        classImpl.inherit = function(members) {
            var inheritor = function() {
                if (!this || (0, _type.isWindow)(this) || "function" !== typeof this.constructor) {
                    throw _errors.default.Error("E0003")
                }
                var instance = this;
                var ctor = instance.ctor;
                var includedCtors = instance.constructor._includedCtors;
                var includedPostCtors = instance.constructor._includedPostCtors;
                var i;
                for (i = 0; i < includedCtors.length; i++) {
                    includedCtors[i].call(instance)
                }
                if (ctor) {
                    ctor.apply(instance, arguments)
                }
                for (i = 0; i < includedPostCtors.length; i++) {
                    includedPostCtors[i].call(instance)
                }
            };
            inheritor.prototype = clonePrototype(this);
            copyStatic(this, inheritor);
            inheritor.inherit = this.inherit;
            inheritor.abstract = abstract;
            inheritor.redefine = redefine;
            inheritor.include = include;
            inheritor.subclassOf = subclassOf;
            inheritor.parent = this;
            inheritor._includedCtors = this._includedCtors ? this._includedCtors.slice(0) : [];
            inheritor._includedPostCtors = this._includedPostCtors ? this._includedPostCtors.slice(0) : [];
            inheritor.prototype.constructor = inheritor;
            inheritor.redefine(members);
            return inheritor
        };
        classImpl.abstract = abstract;
        var _default = classImpl;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/widget/ui.widget.js ***!
      \*********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _action = _interopRequireDefault(__webpack_require__( /*! ../../core/action */ 111));
        var _dom_component = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_component */ 67));
        var _short = __webpack_require__( /*! ../../events/short */ 128);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _extend2 = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _selectors = __webpack_require__( /*! ./selectors */ 70);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        __webpack_require__( /*! ../../events/click */ 21);
        __webpack_require__( /*! ../../events/core/emitter.feedback */ 149);
        __webpack_require__( /*! ../../events/hover */ 155);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function setAttribute(name, value, target) {
            name = "role" === name || "id" === name ? name : "aria-".concat(name);
            value = (0, _type.isDefined)(value) ? value.toString() : null;
            target.attr(name, value)
        }
        var Widget = _dom_component.default.inherit({
            _feedbackHideTimeout: 400,
            _feedbackShowTimeout: 30,
            _supportedKeys: function() {
                return {}
            },
            _getDefaultOptions: function() {
                return (0, _extend2.extend)(this.callBase(), {
                    hoveredElement: null,
                    isActive: false,
                    disabled: false,
                    visible: true,
                    hint: void 0,
                    activeStateEnabled: false,
                    onContentReady: null,
                    hoverStateEnabled: false,
                    focusStateEnabled: false,
                    tabIndex: 0,
                    accessKey: null,
                    onFocusIn: null,
                    onFocusOut: null,
                    onKeyboardHandled: null,
                    ignoreParentReadOnly: false
                })
            },
            _init: function() {
                this.callBase();
                this._initContentReadyAction()
            },
            _innerWidgetOptionChanged: function(innerWidget, args) {
                var options = Widget.getOptionsFromContainer(args);
                innerWidget && innerWidget.option(options);
                this._options.cache(args.name, options)
            },
            _bindInnerWidgetOptions: function(innerWidget, optionsContainer) {
                var _this = this;
                var syncOptions = function() {
                    return _this._options.silent(optionsContainer, (0, _extend2.extend)({}, innerWidget.option()))
                };
                syncOptions();
                innerWidget.on("optionChanged", syncOptions)
            },
            _getAriaTarget: function() {
                return this._focusTarget()
            },
            _initContentReadyAction: function() {
                this._contentReadyAction = this._createActionByOption("onContentReady", {
                    excludeValidators: ["disabled", "readOnly"]
                })
            },
            _initMarkup: function() {
                var _this$option = this.option(),
                    disabled = _this$option.disabled,
                    visible = _this$option.visible;
                this.$element().addClass("dx-widget");
                this._toggleDisabledState(disabled);
                this._toggleVisibility(visible);
                this._renderHint();
                this._isFocusable() && this._renderFocusTarget();
                this.callBase()
            },
            _render: function() {
                this.callBase();
                this._renderContent();
                this._renderFocusState();
                this._attachFeedbackEvents();
                this._attachHoverEvents();
                this._toggleIndependentState()
            },
            _renderHint: function() {
                var _this$option2 = this.option(),
                    hint = _this$option2.hint;
                this.$element().attr("title", hint || null)
            },
            _renderContent: function() {
                var _this2 = this;
                (0, _common.deferRender)(function() {
                    return !_this2._disposed ? _this2._renderContentImpl() : void 0
                }).done(function() {
                    return !_this2._disposed ? _this2._fireContentReadyAction() : void 0
                })
            },
            _renderContentImpl: _common.noop,
            _fireContentReadyAction: (0, _common.deferRenderer)(function() {
                return this._contentReadyAction()
            }),
            _dispose: function() {
                this._contentReadyAction = null;
                this._detachKeyboardEvents();
                this.callBase()
            },
            _resetActiveState: function() {
                this._toggleActiveState(this._eventBindingTarget(), false)
            },
            _clean: function() {
                this._cleanFocusState();
                this._resetActiveState();
                this.callBase();
                this.$element().empty()
            },
            _toggleVisibility: function(visible) {
                this.$element().toggleClass("dx-state-invisible", !visible);
                this.setAria("hidden", !visible || void 0)
            },
            _renderFocusState: function() {
                this._attachKeyboardEvents();
                if (this._isFocusable()) {
                    this._renderFocusTarget();
                    this._attachFocusEvents();
                    this._renderAccessKey()
                }
            },
            _renderAccessKey: function() {
                var $el = this._focusTarget();
                var _this$option3 = this.option(),
                    accessKey = _this$option3.accessKey;
                $el.attr("accesskey", accessKey)
            },
            _isFocusable: function() {
                var _this$option4 = this.option(),
                    focusStateEnabled = _this$option4.focusStateEnabled,
                    disabled = _this$option4.disabled;
                return focusStateEnabled && !disabled
            },
            _eventBindingTarget: function() {
                return this.$element()
            },
            _focusTarget: function() {
                return this._getActiveElement()
            },
            _getActiveElement: function() {
                var activeElement = this._eventBindingTarget();
                if (this._activeStateUnit) {
                    return activeElement.find(this._activeStateUnit).not(".dx-state-disabled")
                }
                return activeElement
            },
            _renderFocusTarget: function() {
                var _this$option5 = this.option(),
                    tabIndex = _this$option5.tabIndex;
                this._focusTarget().attr("tabIndex", tabIndex)
            },
            _keyboardEventBindingTarget: function() {
                return this._eventBindingTarget()
            },
            _refreshFocusEvent: function() {
                this._detachFocusEvents();
                this._attachFocusEvents()
            },
            _focusEventTarget: function() {
                return this._focusTarget()
            },
            _focusInHandler: function(event) {
                var _this3 = this;
                if (!event.isDefaultPrevented()) {
                    this._createActionByOption("onFocusIn", {
                        beforeExecute: function() {
                            return _this3._updateFocusState(event, true)
                        },
                        excludeValidators: ["readOnly"]
                    })({
                        event: event
                    })
                }
            },
            _focusOutHandler: function(event) {
                var _this4 = this;
                if (!event.isDefaultPrevented()) {
                    this._createActionByOption("onFocusOut", {
                        beforeExecute: function() {
                            return _this4._updateFocusState(event, false)
                        },
                        excludeValidators: ["readOnly", "disabled"]
                    })({
                        event: event
                    })
                }
            },
            _updateFocusState: function(_ref, isFocused) {
                var target = _ref.target;
                if ((0, _array.inArray)(target, this._focusTarget()) !== -1) {
                    this._toggleFocusClass(isFocused, (0, _renderer.default)(target))
                }
            },
            _toggleFocusClass: function(isFocused, $element) {
                var $focusTarget = $element && $element.length ? $element : this._focusTarget();
                $focusTarget.toggleClass("dx-state-focused", isFocused)
            },
            _hasFocusClass: function(element) {
                var $focusTarget = (0, _renderer.default)(element || this._focusTarget());
                return $focusTarget.hasClass("dx-state-focused")
            },
            _isFocused: function() {
                return this._hasFocusClass()
            },
            _getKeyboardListeners: function() {
                return []
            },
            _attachKeyboardEvents: function() {
                var _this5 = this;
                this._detachKeyboardEvents();
                var _this$option6 = this.option(),
                    focusStateEnabled = _this$option6.focusStateEnabled,
                    onKeyboardHandled = _this$option6.onKeyboardHandled;
                var hasChildListeners = this._getKeyboardListeners().length;
                var hasKeyboardEventHandler = !!onKeyboardHandled;
                var shouldAttach = focusStateEnabled || hasChildListeners || hasKeyboardEventHandler;
                if (shouldAttach) {
                    this._keyboardListenerId = _short.keyboard.on(this._keyboardEventBindingTarget(), this._focusTarget(), function(opts) {
                        return _this5._keyboardHandler(opts)
                    })
                }
            },
            _keyboardHandler: function(options, onlyChildProcessing) {
                if (!onlyChildProcessing) {
                    var originalEvent = options.originalEvent,
                        keyName = options.keyName,
                        which = options.which;
                    var keys = this._supportedKeys(originalEvent);
                    var func = keys[keyName] || keys[which];
                    if (void 0 !== func) {
                        var handler = func.bind(this);
                        var result = handler(originalEvent, options);
                        if (!result) {
                            return false
                        }
                    }
                }
                var keyboardListeners = this._getKeyboardListeners();
                var _this$option7 = this.option(),
                    onKeyboardHandled = _this$option7.onKeyboardHandled;
                keyboardListeners.forEach(function(listener) {
                    return listener && listener._keyboardHandler(options)
                });
                onKeyboardHandled && onKeyboardHandled(options);
                return true
            },
            _refreshFocusState: function() {
                this._cleanFocusState();
                this._renderFocusState()
            },
            _cleanFocusState: function() {
                var $element = this._focusTarget();
                $element.removeAttr("tabIndex");
                this._toggleFocusClass(false);
                this._detachFocusEvents();
                this._detachKeyboardEvents()
            },
            _detachKeyboardEvents: function() {
                _short.keyboard.off(this._keyboardListenerId);
                this._keyboardListenerId = null
            },
            _attachHoverEvents: function() {
                var _this6 = this;
                var _this$option8 = this.option(),
                    hoverStateEnabled = _this$option8.hoverStateEnabled;
                var selector = this._activeStateUnit;
                var namespace = "UIFeedback";
                var $el = this._eventBindingTarget();
                _short.hover.off($el, {
                    selector: selector,
                    namespace: namespace
                });
                if (hoverStateEnabled) {
                    _short.hover.on($el, new _action.default(function(_ref2) {
                        var event = _ref2.event,
                            element = _ref2.element;
                        _this6._hoverStartHandler(event);
                        _this6.option("hoveredElement", (0, _renderer.default)(element))
                    }, {
                        excludeValidators: ["readOnly"]
                    }), function(event) {
                        _this6.option("hoveredElement", null);
                        _this6._hoverEndHandler(event)
                    }, {
                        selector: selector,
                        namespace: namespace
                    })
                }
            },
            _attachFeedbackEvents: function() {
                var _this7 = this;
                var _this$option9 = this.option(),
                    activeStateEnabled = _this$option9.activeStateEnabled;
                var selector = this._activeStateUnit;
                var namespace = "UIFeedback";
                var $el = this._eventBindingTarget();
                _short.active.off($el, {
                    namespace: namespace,
                    selector: selector
                });
                if (activeStateEnabled) {
                    _short.active.on($el, new _action.default(function(_ref3) {
                        var event = _ref3.event,
                            element = _ref3.element;
                        return _this7._toggleActiveState((0, _renderer.default)(element), true, event)
                    }), new _action.default(function(_ref4) {
                        var event = _ref4.event,
                            element = _ref4.element;
                        return _this7._toggleActiveState((0, _renderer.default)(element), false, event)
                    }, {
                        excludeValidators: ["disabled", "readOnly"]
                    }), {
                        showTimeout: this._feedbackShowTimeout,
                        hideTimeout: this._feedbackHideTimeout,
                        selector: selector,
                        namespace: namespace
                    })
                }
            },
            _detachFocusEvents: function() {
                var $el = this._focusEventTarget();
                _short.focus.off($el, {
                    namespace: "".concat(this.NAME, "Focus")
                })
            },
            _attachFocusEvents: function() {
                var _this8 = this;
                var $el = this._focusEventTarget();
                _short.focus.on($el, function(e) {
                    return _this8._focusInHandler(e)
                }, function(e) {
                    return _this8._focusOutHandler(e)
                }, {
                    namespace: "".concat(this.NAME, "Focus"),
                    isFocusable: function(index, el) {
                        return (0, _renderer.default)(el).is(_selectors.focusable)
                    }
                })
            },
            _hoverStartHandler: _common.noop,
            _hoverEndHandler: _common.noop,
            _toggleActiveState: function($element, value) {
                this.option("isActive", value);
                $element.toggleClass("dx-state-active", value)
            },
            _updatedHover: function() {
                var hoveredElement = this._options.silent("hoveredElement");
                this._hover(hoveredElement, hoveredElement)
            },
            _findHoverTarget: function($el) {
                return $el && $el.closest(this._activeStateUnit || this._eventBindingTarget())
            },
            _hover: function($el, $previous) {
                var _this$option10 = this.option(),
                    hoverStateEnabled = _this$option10.hoverStateEnabled,
                    disabled = _this$option10.disabled,
                    isActive = _this$option10.isActive;
                $previous = this._findHoverTarget($previous);
                $previous && $previous.toggleClass("dx-state-hover", false);
                if ($el && hoverStateEnabled && !disabled && !isActive) {
                    var newHoveredElement = this._findHoverTarget($el);
                    newHoveredElement && newHoveredElement.toggleClass("dx-state-hover", true)
                }
            },
            _toggleDisabledState: function(value) {
                this.$element().toggleClass("dx-state-disabled", Boolean(value));
                this.setAria("disabled", value || void 0)
            },
            _toggleIndependentState: function() {
                this.$element().toggleClass("dx-state-independent", this.option("ignoreParentReadOnly"))
            },
            _setWidgetOption: function(widgetName, args) {
                var _this9 = this;
                if (!this[widgetName]) {
                    return
                }
                if ((0, _type.isPlainObject)(args[0])) {
                    (0, _iterator.each)(args[0], function(option, value) {
                        return _this9._setWidgetOption(widgetName, [option, value])
                    });
                    return
                }
                var optionName = args[0];
                var value = args[1];
                if (1 === args.length) {
                    value = this.option(optionName)
                }
                var widgetOptionMap = this["".concat(widgetName, "OptionMap")];
                this[widgetName].option(widgetOptionMap ? widgetOptionMap(optionName) : optionName, value)
            },
            _optionChanged: function(args) {
                var name = args.name,
                    value = args.value,
                    previousValue = args.previousValue;
                switch (name) {
                    case "disabled":
                        this._toggleDisabledState(value);
                        this._updatedHover();
                        this._refreshFocusState();
                        break;
                    case "hint":
                        this._renderHint();
                        break;
                    case "ignoreParentReadOnly":
                        this._toggleIndependentState();
                        break;
                    case "activeStateEnabled":
                        this._attachFeedbackEvents();
                        break;
                    case "hoverStateEnabled":
                        this._attachHoverEvents();
                        this._updatedHover();
                        break;
                    case "tabIndex":
                    case "focusStateEnabled":
                        this._refreshFocusState();
                        break;
                    case "onFocusIn":
                    case "onFocusOut":
                        break;
                    case "accessKey":
                        this._renderAccessKey();
                        break;
                    case "hoveredElement":
                        this._hover(value, previousValue);
                        break;
                    case "isActive":
                        this._updatedHover();
                        break;
                    case "visible":
                        this._toggleVisibility(value);
                        if (this._isVisibilityChangeSupported()) {
                            this._checkVisibilityChanged(value ? "shown" : "hiding")
                        }
                        break;
                    case "onKeyboardHandled":
                        this._attachKeyboardEvents();
                        break;
                    case "onContentReady":
                        this._initContentReadyAction();
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _isVisible: function() {
                var _this$option11 = this.option(),
                    visible = _this$option11.visible;
                return this.callBase() && visible
            },
            beginUpdate: function() {
                this._ready(false);
                this.callBase()
            },
            endUpdate: function() {
                this.callBase();
                if (this._initialized) {
                    this._ready(true)
                }
            },
            _ready: function(value) {
                if (0 === arguments.length) {
                    return this._isReady
                }
                this._isReady = value
            },
            setAria: function() {
                if (!(0, _type.isPlainObject)(arguments.length <= 0 ? void 0 : arguments[0])) {
                    setAttribute(arguments.length <= 0 ? void 0 : arguments[0], arguments.length <= 1 ? void 0 : arguments[1], (arguments.length <= 2 ? void 0 : arguments[2]) || this._getAriaTarget())
                } else {
                    var target = (arguments.length <= 1 ? void 0 : arguments[1]) || this._getAriaTarget();
                    (0, _iterator.each)(arguments.length <= 0 ? void 0 : arguments[0], function(name, value) {
                        return setAttribute(name, value, target)
                    })
                }
            },
            isReady: function() {
                return this._ready()
            },
            repaint: function() {
                this._refresh()
            },
            focus: function() {
                _short.focus.trigger(this._focusTarget())
            },
            registerKeyHandler: function(key, handler) {
                var currentKeys = this._supportedKeys();
                this._supportedKeys = function() {
                    return (0, _extend2.extend)(currentKeys, _defineProperty({}, key, handler))
                }
            }
        });
        Widget.getOptionsFromContainer = function(_ref5) {
            var name = _ref5.name,
                fullName = _ref5.fullName,
                value = _ref5.value;
            var options = {};
            if (name === fullName) {
                options = value
            } else {
                var option = fullName.split(".").pop();
                options[option] = value
            }
            return options
        };
        var _default = Widget;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/widget/ui.errors.js ***!
      \*********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _error = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/error */ 146));
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../../core/errors */ 25));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = (0, _error.default)(_errors.default.ERROR_MESSAGES, {
            E1001: "Module '{0}'. Controller '{1}' is already registered",
            E1002: "Module '{0}'. Controller '{1}' does not inherit from DevExpress.ui.dxDataGrid.Controller",
            E1003: "Module '{0}'. View '{1}' is already registered",
            E1004: "Module '{0}'. View '{1}' does not inherit from DevExpress.ui.dxDataGrid.View",
            E1005: "Public method '{0}' is already registered",
            E1006: "Public method '{0}.{1}' does not exist",
            E1007: "State storing cannot be provided due to the restrictions of the browser",
            E1010: "The template does not contain the TextBox widget",
            E1011: 'Items cannot be deleted from the List. Implement the "remove" function in the data store',
            E1012: "Editing type '{0}' with the name '{1}' is unsupported",
            E1016: "Unexpected type of data source is provided for a lookup column",
            E1018: "The 'collapseAll' method cannot be called if you use a remote data source",
            E1019: "Search mode '{0}' is unavailable",
            E1020: "The type cannot be changed after initialization",
            E1021: "{0} '{1}' you are trying to remove does not exist",
            E1022: 'The "markers" option is given an invalid value. Assign an array instead',
            E1023: 'The "routes" option is given an invalid value. Assign an array instead',
            E1025: "This layout is too complex to render",
            E1026: 'The "calculateCustomSummary" function is missing from a field whose "summaryType" option is set to "custom"',
            E1030: "Unknown ScrollView refresh strategy: '{0}'",
            E1031: "Unknown subscription in the Scheduler widget: '{0}'",
            E1032: "Unknown start date in an appointment: '{0}'",
            E1033: "Unknown step in the date navigator: '{0}'",
            E1034: "The browser does not implement an API for saving files",
            E1035: "The editor cannot be created because of an internal error: {0}",
            E1037: "Invalid structure of grouped data",
            E1038: "The browser does not support local storages for local web pages",
            E1039: "A cell's position cannot be calculated",
            E1040: "The '{0}' key value is not unique within the data array",
            E1041: "The '{0}' script is referenced after the DevExtreme scripts or not referenced at all",
            E1042: "{0} requires the key field to be specified",
            E1043: "Changes cannot be processed due to the incorrectly set key",
            E1044: "The key field specified by the keyExpr option does not match the key field specified in the data store",
            E1045: "Editing requires the key field to be specified in the data store",
            E1046: "The '{0}' key field is not found in data objects",
            E1047: 'The "{0}" field is not found in the fields array',
            E1048: 'The "{0}" operation is not found in the filterOperations array',
            E1049: "Column '{0}': filtering is allowed but the 'dataField' or 'name' option is not specified",
            E1050: "The validationRules option does not apply to third-party editors defined in the editCellTemplate",
            E1051: 'HtmlEditor\'s valueType is "{0}", but the {0} converter was not imported.',
            E1052: '{0} should have the "dataSource" option specified',
            E1053: 'The "buttons" option accepts an array that contains only objects or string values',
            E1054: "All text editor buttons must have names",
            E1055: 'One or several text editor buttons have invalid or non-unique "name" values',
            E1056: 'The {0} widget does not support buttons of the "{1}" type',
            E1058: 'The "startDayHour" must be earlier than the "endDayHour"',
            E1059: "The following column names are not unique: {0}",
            E1060: "All editable columns must have names",
            W1001: 'The "key" option cannot be modified after initialization',
            W1002: "An item with the key '{0}' does not exist",
            W1003: "A group with the key '{0}' in which you are trying to select items does not exist",
            W1004: "The item '{0}' you are trying to select in the group '{1}' does not exist",
            W1005: "Due to column data types being unspecified, data has been loaded twice in order to apply initial filter settings. To resolve this issue, specify data types for all grid columns.",
            W1006: "The map service returned the following error: '{0}'",
            W1007: "No item with key {0} was found in the data source, but this key was used as the parent key for item {1}",
            W1008: "Cannot scroll to the '{0}' date because it does not exist on the current view",
            W1009: "Searching works only if data is specified using the dataSource option",
            W1010: "The capability to select all items works with source data of plain structure only",
            W1011: 'The "keyExpr" option is not applied when dataSource is not an array',
            W1012: "The '{0}' key field is not found in data objects",
            W1013: 'The "message" field in the dialog component was renamed to "messageHtml". Change your code correspondingly. In addition, if you used HTML code in the message, make sure that it is secure',
            W1014: "The Floating Action Button exceeds the recommended speed dial action count. If you need to display more speed dial actions, increase the maxSpeedDialActionCount option value in the global config.",
            W1015: 'The "cellDuration" should divide the range from the "startDayHour" to the "endDayHour" into even intervals'
        });
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/core/element.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getPublicElement = getPublicElement;
        exports.setPublicElementWrapper = setPublicElementWrapper;
        var strategy = function(element) {
            return element && element.get(0)
        };

        function getPublicElement(element) {
            return strategy(element)
        }

        function setPublicElementWrapper(newStrategy) {
            strategy = newStrategy
        }
    },
    /*!*****************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/date.js ***!
      \*****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _type = __webpack_require__( /*! ./type */ 1);
        var _math = __webpack_require__( /*! ./math */ 29);
        var _iterator = __webpack_require__( /*! ./iterator */ 3);
        var _inflector = __webpack_require__( /*! ./inflector */ 39);
        var _browser = _interopRequireDefault(__webpack_require__( /*! ./browser */ 23));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _construct(Parent, args, Class) {
            if (_isNativeReflectConstruct()) {
                _construct = Reflect.construct
            } else {
                _construct = function(Parent, args, Class) {
                    var a = [null];
                    a.push.apply(a, args);
                    var Constructor = Function.bind.apply(Parent, a);
                    var instance = new Constructor;
                    if (Class) {
                        _setPrototypeOf(instance, Class.prototype)
                    }
                    return instance
                }
            }
            return _construct.apply(null, arguments)
        }

        function _isNativeReflectConstruct() {
            if ("undefined" === typeof Reflect || !Reflect.construct) {
                return false
            }
            if (Reflect.construct.sham) {
                return false
            }
            if ("function" === typeof Proxy) {
                return true
            }
            try {
                Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                return true
            } catch (e) {
                return false
            }
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var isIE11 = _browser.default.msie && parseInt(_browser.default.version) <= 11;
        var dateUnitIntervals = ["millisecond", "second", "minute", "hour", "day", "week", "month", "quarter", "year"];
        var toMilliseconds = function toMilliseconds(value) {
            switch (value) {
                case "millisecond":
                    return 1;
                case "second":
                    return 1e3 * toMilliseconds("millisecond");
                case "minute":
                    return 60 * toMilliseconds("second");
                case "hour":
                    return 60 * toMilliseconds("minute");
                case "day":
                    return 24 * toMilliseconds("hour");
                case "week":
                    return 7 * toMilliseconds("day");
                case "month":
                    return 30 * toMilliseconds("day");
                case "quarter":
                    return 3 * toMilliseconds("month");
                case "year":
                    return 365 * toMilliseconds("day");
                default:
                    return 0
            }
        };
        var getDatesInterval = function(startDate, endDate, intervalUnit) {
            var delta = endDate.getTime() - startDate.getTime();
            var millisecondCount = toMilliseconds(intervalUnit) || 1;
            return Math.floor(delta / millisecondCount)
        };
        var getNextDateUnit = function(unit, withWeeks) {
            var interval = getDateUnitInterval(unit);
            switch (interval) {
                case "millisecond":
                    return "second";
                case "second":
                    return "minute";
                case "minute":
                    return "hour";
                case "hour":
                    return "day";
                case "day":
                    return withWeeks ? "week" : "month";
                case "week":
                    return "month";
                case "month":
                    return "quarter";
                case "quarter":
                    return "year";
                case "year":
                    return "year";
                default:
                    return 0
            }
        };
        var convertMillisecondsToDateUnits = function(value) {
            var i;
            var dateUnitCount;
            var dateUnitInterval;
            var dateUnitIntervals = ["millisecond", "second", "minute", "hour", "day", "month", "year"];
            var result = {};
            for (i = dateUnitIntervals.length - 1; i >= 0; i--) {
                dateUnitInterval = dateUnitIntervals[i];
                dateUnitCount = Math.floor(value / toMilliseconds(dateUnitInterval));
                if (dateUnitCount > 0) {
                    result[dateUnitInterval + "s"] = dateUnitCount;
                    value -= convertDateUnitToMilliseconds(dateUnitInterval, dateUnitCount)
                }
            }
            return result
        };
        var dateToMilliseconds = function(tickInterval) {
            var milliseconds = 0;
            if ((0, _type.isObject)(tickInterval)) {
                (0, _iterator.each)(tickInterval, function(key, value) {
                    milliseconds += convertDateUnitToMilliseconds(key.substr(0, key.length - 1), value)
                })
            }
            if ((0, _type.isString)(tickInterval)) {
                milliseconds = convertDateUnitToMilliseconds(tickInterval, 1)
            }
            return milliseconds
        };

        function convertDateUnitToMilliseconds(dateUnit, count) {
            return toMilliseconds(dateUnit) * count
        }

        function getDateUnitInterval(tickInterval) {
            var maxInterval = -1;
            var i;
            if ((0, _type.isString)(tickInterval)) {
                return tickInterval
            }
            if ((0, _type.isObject)(tickInterval)) {
                (0, _iterator.each)(tickInterval, function(key, value) {
                    for (i = 0; i < dateUnitIntervals.length; i++) {
                        if (value && (key === dateUnitIntervals[i] + "s" || key === dateUnitIntervals[i]) && maxInterval < i) {
                            maxInterval = i
                        }
                    }
                });
                return dateUnitIntervals[maxInterval]
            }
            return ""
        }
        var tickIntervalToFormatMap = {
            millisecond: "millisecond",
            second: "longtime",
            minute: "shorttime",
            hour: "shorttime",
            day: "day",
            week: "day",
            month: "month",
            quarter: "quarter",
            year: "year"
        };

        function getDateFormatByTickInterval(tickInterval) {
            return tickIntervalToFormatMap[getDateUnitInterval(tickInterval)] || ""
        }
        var getQuarter = function(month) {
            return Math.floor(month / 3)
        };
        var getFirstQuarterMonth = function(month) {
            return 3 * getQuarter(month)
        };

        function correctDateWithUnitBeginning(date, dateInterval, withCorrection, firstDayOfWeek) {
            date = new Date(date.getTime());
            var oldDate = new Date(date.getTime());
            var firstQuarterMonth;
            var month;
            var dateUnitInterval = getDateUnitInterval(dateInterval);
            switch (dateUnitInterval) {
                case "second":
                    date = new Date(1e3 * Math.floor(oldDate.getTime() / 1e3));
                    break;
                case "minute":
                    date = new Date(6e4 * Math.floor(oldDate.getTime() / 6e4));
                    break;
                case "hour":
                    date = new Date(36e5 * Math.floor(oldDate.getTime() / 36e5));
                    break;
                case "year":
                    date.setMonth(0);
                case "month":
                    date.setDate(1);
                case "day":
                    date.setHours(0, 0, 0, 0);
                    break;
                case "week":
                    date = getFirstWeekDate(date, firstDayOfWeek || 0);
                    date.setHours(0, 0, 0, 0);
                    break;
                case "quarter":
                    firstQuarterMonth = getFirstQuarterMonth(date.getMonth());
                    month = date.getMonth();
                    date.setDate(1);
                    date.setHours(0, 0, 0, 0);
                    if (month !== firstQuarterMonth) {
                        date.setMonth(firstQuarterMonth)
                    }
            }
            if (withCorrection && "hour" !== dateUnitInterval && "minute" !== dateUnitInterval && "second" !== dateUnitInterval) {
                fixTimezoneGap(oldDate, date)
            }
            return date
        }

        function trimTime(date) {
            return correctDateWithUnitBeginning(date, "day")
        }
        var setToDayEnd = function(date) {
            var result = trimTime(date);
            result.setDate(result.getDate() + 1);
            return new Date(result.getTime() - 1)
        };
        var getDatesDifferences = function(date1, date2) {
            var counter = 0;
            var differences = {
                year: date1.getFullYear() !== date2.getFullYear(),
                month: date1.getMonth() !== date2.getMonth(),
                day: date1.getDate() !== date2.getDate(),
                hour: date1.getHours() !== date2.getHours(),
                minute: date1.getMinutes() !== date2.getMinutes(),
                second: date1.getSeconds() !== date2.getSeconds(),
                millisecond: date1.getMilliseconds() !== date2.getMilliseconds()
            };
            (0, _iterator.each)(differences, function(key, value) {
                if (value) {
                    counter++
                }
            });
            if (0 === counter && 0 !== getTimezonesDifference(date1, date2)) {
                differences.hour = true;
                counter++
            }
            differences.count = counter;
            return differences
        };

        function addDateInterval(value, interval, dir) {
            var result = new Date(value.getTime());
            var intervalObject = (0, _type.isString)(interval) ? getDateIntervalByString(interval.toLowerCase()) : (0, _type.isNumeric)(interval) ? convertMillisecondsToDateUnits(interval) : interval;
            if (intervalObject.years) {
                result.setFullYear(result.getFullYear() + intervalObject.years * dir)
            }
            if (intervalObject.quarters) {
                result.setMonth(result.getMonth() + 3 * intervalObject.quarters * dir)
            }
            if (intervalObject.months) {
                result.setMonth(result.getMonth() + intervalObject.months * dir)
            }
            if (intervalObject.weeks) {
                result.setDate(result.getDate() + 7 * intervalObject.weeks * dir)
            }
            if (intervalObject.days) {
                result.setDate(result.getDate() + intervalObject.days * dir)
            }
            if (intervalObject.hours) {
                result.setTime(result.getTime() + 36e5 * intervalObject.hours * dir)
            }
            if (intervalObject.minutes) {
                result.setTime(result.getTime() + 6e4 * intervalObject.minutes * dir)
            }
            if (intervalObject.seconds) {
                result.setTime(result.getTime() + 1e3 * intervalObject.seconds * dir)
            }
            if (intervalObject.milliseconds) {
                result.setTime(result.getTime() + intervalObject.milliseconds * dir)
            }
            return result
        }
        var addInterval = function(value, interval, isNegative) {
            var dir = isNegative ? -1 : 1;
            return (0, _type.isDate)(value) ? addDateInterval(value, interval, dir) : (0, _math.adjust)(value + interval * dir, interval)
        };
        var getSequenceByInterval = function(min, max, interval) {
            var intervals = [];
            var cur;
            intervals.push((0, _type.isDate)(min) ? new Date(min.getTime()) : min);
            cur = min;
            while (cur < max) {
                cur = addInterval(cur, interval);
                intervals.push(cur)
            }
            return intervals
        };
        var getViewFirstCellDate = function(viewType, date) {
            if ("month" === viewType) {
                return createDateWithFullYear(date.getFullYear(), date.getMonth(), 1)
            }
            if ("year" === viewType) {
                return createDateWithFullYear(date.getFullYear(), 0, date.getDate())
            }
            if ("decade" === viewType) {
                return createDateWithFullYear(getFirstYearInDecade(date), date.getMonth(), date.getDate())
            }
            if ("century" === viewType) {
                return createDateWithFullYear(getFirstDecadeInCentury(date), date.getMonth(), date.getDate())
            }
        };
        var getViewLastCellDate = function(viewType, date) {
            if ("month" === viewType) {
                return createDateWithFullYear(date.getFullYear(), date.getMonth(), getLastMonthDay(date))
            }
            if ("year" === viewType) {
                return createDateWithFullYear(date.getFullYear(), 11, date.getDate())
            }
            if ("decade" === viewType) {
                return createDateWithFullYear(getFirstYearInDecade(date) + 9, date.getMonth(), date.getDate())
            }
            if ("century" === viewType) {
                return createDateWithFullYear(getFirstDecadeInCentury(date) + 90, date.getMonth(), date.getDate())
            }
        };
        var getViewMinBoundaryDate = function(viewType, date) {
            var resultDate = createDateWithFullYear(date.getFullYear(), date.getMonth(), 1);
            if ("month" === viewType) {
                return resultDate
            }
            resultDate.setMonth(0);
            if ("year" === viewType) {
                return resultDate
            }
            if ("decade" === viewType) {
                resultDate.setFullYear(getFirstYearInDecade(date))
            }
            if ("century" === viewType) {
                resultDate.setFullYear(getFirstDecadeInCentury(date))
            }
            return resultDate
        };
        var getViewMaxBoundaryDate = function(viewType, date) {
            var resultDate = new Date(date);
            resultDate.setDate(getLastMonthDay(date));
            if ("month" === viewType) {
                return resultDate
            }
            resultDate.setMonth(11);
            resultDate.setDate(getLastMonthDay(resultDate));
            if ("year" === viewType) {
                return resultDate
            }
            if ("decade" === viewType) {
                resultDate.setFullYear(getFirstYearInDecade(date) + 9)
            }
            if ("century" === viewType) {
                resultDate.setFullYear(getFirstDecadeInCentury(date) + 99)
            }
            return resultDate
        };

        function getLastMonthDay(date) {
            var resultDate = createDateWithFullYear(date.getFullYear(), date.getMonth() + 1, 0);
            return resultDate.getDate()
        }
        var getViewUp = function(typeView) {
            switch (typeView) {
                case "month":
                    return "year";
                case "year":
                    return "decade";
                case "decade":
                    return "century"
            }
        };
        var getViewDown = function(typeView) {
            switch (typeView) {
                case "century":
                    return "decade";
                case "decade":
                    return "year";
                case "year":
                    return "month"
            }
        };
        var getDifferenceInMonth = function(typeView) {
            var difference = 1;
            if ("year" === typeView) {
                difference = 12
            }
            if ("decade" === typeView) {
                difference = 120
            }
            if ("century" === typeView) {
                difference = 1200
            }
            return difference
        };
        var getDifferenceInMonthForCells = function(typeView) {
            var difference = 1;
            if ("decade" === typeView) {
                difference = 12
            }
            if ("century" === typeView) {
                difference = 120
            }
            return difference
        };

        function getDateIntervalByString(intervalString) {
            var result = {};
            switch (intervalString) {
                case "year":
                    result.years = 1;
                    break;
                case "month":
                    result.months = 1;
                    break;
                case "quarter":
                    result.months = 3;
                    break;
                case "week":
                    result.weeks = 1;
                    break;
                case "day":
                    result.days = 1;
                    break;
                case "hour":
                    result.hours = 1;
                    break;
                case "minute":
                    result.minutes = 1;
                    break;
                case "second":
                    result.seconds = 1;
                    break;
                case "millisecond":
                    result.milliseconds = 1
            }
            return result
        }

        function sameDate(date1, date2) {
            return sameMonthAndYear(date1, date2) && date1.getDate() === date2.getDate()
        }

        function sameMonthAndYear(date1, date2) {
            return sameYear(date1, date2) && date1.getMonth() === date2.getMonth()
        }

        function sameYear(date1, date2) {
            return date1 && date2 && date1.getFullYear() === date2.getFullYear()
        }
        var sameDecade = function(date1, date2) {
            if (!(0, _type.isDefined)(date1) || !(0, _type.isDefined)(date2)) {
                return
            }
            var startDecadeDate1 = date1.getFullYear() - date1.getFullYear() % 10;
            var startDecadeDate2 = date2.getFullYear() - date2.getFullYear() % 10;
            return date1 && date2 && startDecadeDate1 === startDecadeDate2
        };
        var sameCentury = function(date1, date2) {
            if (!(0, _type.isDefined)(date1) || !(0, _type.isDefined)(date2)) {
                return
            }
            var startCenturyDate1 = date1.getFullYear() - date1.getFullYear() % 100;
            var startCenturyDate2 = date2.getFullYear() - date2.getFullYear() % 100;
            return date1 && date2 && startCenturyDate1 === startCenturyDate2
        };

        function getFirstDecadeInCentury(date) {
            return date && date.getFullYear() - date.getFullYear() % 100
        }

        function getFirstYearInDecade(date) {
            return date && date.getFullYear() - date.getFullYear() % 10
        }
        var getShortDateFormat = function() {
            return "yyyy/MM/dd"
        };
        var getFirstMonthDate = function(date) {
            if (!(0, _type.isDefined)(date)) {
                return
            }
            return createDateWithFullYear(date.getFullYear(), date.getMonth(), 1)
        };
        var getLastMonthDate = function(date) {
            if (!(0, _type.isDefined)(date)) {
                return
            }
            return createDateWithFullYear(date.getFullYear(), date.getMonth() + 1, 0)
        };

        function getFirstWeekDate(date, firstDayOfWeek) {
            var delta = (date.getDay() - firstDayOfWeek + 7) % 7;
            var result = new Date(date);
            result.setDate(date.getDate() - delta);
            return result
        }
        var normalizeDateByWeek = function(date, currentDate) {
            var differenceInDays = dateUtils.getDatesInterval(date, currentDate, "day");
            var resultDate = new Date(date);
            if (differenceInDays >= 6) {
                resultDate = new Date(resultDate.setDate(resultDate.getDate() + 7))
            }
            return resultDate
        };
        var dateInRange = function(date, min, max, format) {
            if ("date" === format) {
                min = min && dateUtils.correctDateWithUnitBeginning(min, "day");
                max = max && dateUtils.correctDateWithUnitBeginning(max, "day");
                date = date && dateUtils.correctDateWithUnitBeginning(date, "day")
            }
            return normalizeDate(date, min, max) === date
        };
        var dateTimeFromDecimal = function(number) {
            var hours = Math.floor(number);
            var minutes = number % 1 * 60;
            return {
                hours: hours,
                minutes: minutes
            }
        };
        var roundDateByStartDayHour = function(date, startDayHour) {
            var startTime = this.dateTimeFromDecimal(startDayHour);
            var result = new Date(date);
            if (date.getHours() === startTime.hours && date.getMinutes() < startTime.minutes || date.getHours() < startTime.hours) {
                result.setHours(startTime.hours, startTime.minutes, 0, 0)
            }
            return result
        };

        function normalizeDate(date, min, max) {
            var normalizedDate = date;
            if (!(0, _type.isDefined)(date)) {
                return date
            }
            if ((0, _type.isDefined)(min) && date < min) {
                normalizedDate = min
            }
            if ((0, _type.isDefined)(max) && date > max) {
                normalizedDate = max
            }
            return normalizedDate
        }

        function fixTimezoneGap(oldDate, newDate) {
            if (!(0, _type.isDefined)(oldDate)) {
                return
            }
            var diff = newDate.getHours() - oldDate.getHours();
            if (0 === diff) {
                return
            }
            var sign = 1 === diff || diff === -23 ? -1 : 1;
            var trial = new Date(newDate.getTime() + 36e5 * sign);
            if (sign > 0 || trial.getDate() === newDate.getDate()) {
                newDate.setTime(trial.getTime())
            }
        }
        var roundToHour = function(date) {
            date.setHours(date.getHours() + 1);
            date.setMinutes(0);
            return date
        };

        function getTimezonesDifference(min, max) {
            return 60 * (max.getTimezoneOffset() - min.getTimezoneOffset()) * 1e3
        }
        var makeDate = function(date) {
            return new Date(date)
        };
        var getDatesOfInterval = function(startDate, endDate, step) {
            var result = [];
            var currentDate = new Date(startDate.getTime());
            while (currentDate < endDate) {
                result.push(new Date(currentDate.getTime()));
                currentDate = this.addInterval(currentDate, step)
            }
            return result
        };
        var createDate = function(date) {
            return new Date(isIE11 && (0, _type.isDate)(date) ? date.getTime() : date)
        };
        var createDateWithFullYear = function(year) {
            var result = _construct(Date, Array.prototype.slice.call(arguments));
            result.setFullYear(year);
            return result
        };
        var dateUtils = {
            dateUnitIntervals: dateUnitIntervals,
            convertMillisecondsToDateUnits: convertMillisecondsToDateUnits,
            dateToMilliseconds: dateToMilliseconds,
            getNextDateUnit: getNextDateUnit,
            convertDateUnitToMilliseconds: convertDateUnitToMilliseconds,
            getDateUnitInterval: getDateUnitInterval,
            getDateFormatByTickInterval: getDateFormatByTickInterval,
            getDatesDifferences: getDatesDifferences,
            correctDateWithUnitBeginning: correctDateWithUnitBeginning,
            trimTime: trimTime,
            setToDayEnd: setToDayEnd,
            roundDateByStartDayHour: roundDateByStartDayHour,
            dateTimeFromDecimal: dateTimeFromDecimal,
            addDateInterval: addDateInterval,
            addInterval: addInterval,
            getSequenceByInterval: getSequenceByInterval,
            getDateIntervalByString: getDateIntervalByString,
            sameDate: sameDate,
            sameMonthAndYear: sameMonthAndYear,
            sameMonth: sameMonthAndYear,
            sameYear: sameYear,
            sameDecade: sameDecade,
            sameCentury: sameCentury,
            getDifferenceInMonth: getDifferenceInMonth,
            getDifferenceInMonthForCells: getDifferenceInMonthForCells,
            getFirstYearInDecade: getFirstYearInDecade,
            getFirstDecadeInCentury: getFirstDecadeInCentury,
            getShortDateFormat: getShortDateFormat,
            getViewFirstCellDate: getViewFirstCellDate,
            getViewLastCellDate: getViewLastCellDate,
            getViewDown: getViewDown,
            getViewUp: getViewUp,
            getLastMonthDay: getLastMonthDay,
            getLastMonthDate: getLastMonthDate,
            getFirstMonthDate: getFirstMonthDate,
            getFirstWeekDate: getFirstWeekDate,
            normalizeDateByWeek: normalizeDateByWeek,
            getQuarter: getQuarter,
            getFirstQuarterMonth: getFirstQuarterMonth,
            dateInRange: dateInRange,
            roundToHour: roundToHour,
            normalizeDate: normalizeDate,
            getViewMinBoundaryDate: getViewMinBoundaryDate,
            getViewMaxBoundaryDate: getViewMaxBoundaryDate,
            fixTimezoneGap: fixTimezoneGap,
            getTimezonesDifference: getTimezonesDifference,
            makeDate: makeDate,
            getDatesInterval: getDatesInterval,
            getDatesOfInterval: getDatesOfInterval,
            createDate: createDate,
            createDateWithFullYear: createDateWithFullYear
        };
        dateUtils.sameView = function(view, date1, date2) {
            return dateUtils[(0, _inflector.camelize)("same " + view)](date1, date2)
        };
        var _default = dateUtils;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/data.js ***!
      \*****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.toComparable = exports.compileSetter = exports.compileGetter = void 0;
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../errors */ 25));
        var _class = _interopRequireDefault(__webpack_require__( /*! ../class */ 15));
        var _object = __webpack_require__( /*! ./object */ 51);
        var _type = __webpack_require__( /*! ./type */ 1);
        var _iterator = __webpack_require__( /*! ./iterator */ 3);
        var _variable_wrapper = _interopRequireDefault(__webpack_require__( /*! ./variable_wrapper */ 102));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var unwrapVariable = _variable_wrapper.default.unwrap;
        var isWrapped = _variable_wrapper.default.isWrapped;
        var assign = _variable_wrapper.default.assign;
        var bracketsToDots = function(expr) {
            return expr.replace(/\[/g, ".").replace(/\]/g, "")
        };
        var readPropValue = function(obj, propName, options) {
            options = options || {};
            if ("this" === propName) {
                return unwrap(obj, options)
            }
            return unwrap(obj[propName], options)
        };
        var assignPropValue = function(obj, propName, value, options) {
            if ("this" === propName) {
                throw new _errors.default.Error("E4016")
            }
            var propValue = obj[propName];
            if (options.unwrapObservables && isWrapped(propValue)) {
                assign(propValue, value)
            } else {
                obj[propName] = value
            }
        };
        var prepareOptions = function(options) {
            options = options || {};
            options.unwrapObservables = void 0 !== options.unwrapObservables ? options.unwrapObservables : true;
            return options
        };

        function unwrap(value, options) {
            return options.unwrapObservables ? unwrapVariable(value) : value
        }
        var compileGetter = function(expr) {
            if (arguments.length > 1) {
                expr = [].slice.call(arguments)
            }
            if (!expr || "this" === expr) {
                return function(obj) {
                    return obj
                }
            }
            if ("string" === typeof expr) {
                expr = bracketsToDots(expr);
                var path = expr.split(".");
                return function(obj, options) {
                    options = prepareOptions(options);
                    var functionAsIs = options.functionsAsIs;
                    var hasDefaultValue = "defaultValue" in options;
                    var current = unwrap(obj, options);
                    for (var i = 0; i < path.length; i++) {
                        if (!current) {
                            if (null == current && hasDefaultValue) {
                                return options.defaultValue
                            }
                            break
                        }
                        var pathPart = path[i];
                        if (hasDefaultValue && (0, _type.isObject)(current) && !(pathPart in current)) {
                            return options.defaultValue
                        }
                        var next = unwrap(current[pathPart], options);
                        if (!functionAsIs && (0, _type.isFunction)(next)) {
                            next = next.call(current)
                        }
                        current = next
                    }
                    return current
                }
            }
            if (Array.isArray(expr)) {
                return combineGetters(expr)
            }
            if ((0, _type.isFunction)(expr)) {
                return expr
            }
        };
        exports.compileGetter = compileGetter;

        function combineGetters(getters) {
            var compiledGetters = {};
            for (var i = 0, l = getters.length; i < l; i++) {
                var getter = getters[i];
                compiledGetters[getter] = compileGetter(getter)
            }
            return function(obj, options) {
                var result;
                (0, _iterator.each)(compiledGetters, function(name) {
                    var value = this(obj, options);
                    if (void 0 === value) {
                        return
                    }
                    var current = result || (result = {});
                    var path = name.split(".");
                    var last = path.length - 1;
                    for (var _i = 0; _i < last; _i++) {
                        var pathItem = path[_i];
                        if (!(pathItem in current)) {
                            current[pathItem] = {}
                        }
                        current = current[pathItem]
                    }
                    current[path[last]] = value
                });
                return result
            }
        }
        var ensurePropValueDefined = function(obj, propName, value, options) {
            if ((0, _type.isDefined)(value)) {
                return value
            }
            var newValue = {};
            assignPropValue(obj, propName, newValue, options);
            return newValue
        };
        var compileSetter = function(expr) {
            expr = bracketsToDots(expr || "this").split(".");
            var lastLevelIndex = expr.length - 1;
            return function(obj, value, options) {
                options = prepareOptions(options);
                var currentValue = unwrap(obj, options);
                expr.forEach(function(propertyName, levelIndex) {
                    var propertyValue = readPropValue(currentValue, propertyName, options);
                    var isPropertyFunc = !options.functionsAsIs && (0, _type.isFunction)(propertyValue) && !isWrapped(propertyValue);
                    if (levelIndex === lastLevelIndex) {
                        if (options.merge && (0, _type.isPlainObject)(value) && (!(0, _type.isDefined)(propertyValue) || (0, _type.isPlainObject)(propertyValue))) {
                            propertyValue = ensurePropValueDefined(currentValue, propertyName, propertyValue, options);
                            (0, _object.deepExtendArraySafe)(propertyValue, value, false, true)
                        } else {
                            if (isPropertyFunc) {
                                currentValue[propertyName](value)
                            } else {
                                assignPropValue(currentValue, propertyName, value, options)
                            }
                        }
                    } else {
                        propertyValue = ensurePropValueDefined(currentValue, propertyName, propertyValue, options);
                        if (isPropertyFunc) {
                            propertyValue = propertyValue.call(currentValue)
                        }
                        currentValue = propertyValue
                    }
                })
            }
        };
        exports.compileSetter = compileSetter;
        var toComparable = function(value, caseSensitive) {
            if (value instanceof Date) {
                return value.getTime()
            }
            if (value && value instanceof _class.default && value.valueOf) {
                return value.valueOf()
            }
            if (!caseSensitive && "string" === typeof value) {
                return value.toLowerCase()
            }
            return value
        };
        exports.toComparable = toComparable
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/events/click.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.name = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../core/devices */ 13));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../core/dom_adapter */ 11));
        var _dom = __webpack_require__( /*! ../core/utils/dom */ 33);
        var _frame = __webpack_require__( /*! ../animation/frame */ 129);
        var _index = __webpack_require__( /*! ./utils/index */ 8);
        var _event_nodes_disposing = __webpack_require__( /*! ./utils/event_nodes_disposing */ 530);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ./pointer */ 24));
        var _emitter = _interopRequireDefault(__webpack_require__( /*! ./core/emitter */ 132));
        var _emitter_registrator = _interopRequireDefault(__webpack_require__( /*! ./core/emitter_registrator */ 103));
        var _version = __webpack_require__( /*! ../core/utils/version */ 72);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var CLICK_EVENT_NAME = "dxclick";
        exports.name = CLICK_EVENT_NAME;
        var TOUCH_BOUNDARY = 10;
        var abs = Math.abs;
        var isInput = function(element) {
            return (0, _renderer.default)(element).is("input, textarea, select, button ,:focus, :focus *")
        };
        var misc = {
            requestAnimationFrame: _frame.requestAnimationFrame,
            cancelAnimationFrame: _frame.cancelAnimationFrame
        };
        var ClickEmitter = _emitter.default.inherit({
            ctor: function(element) {
                this.callBase(element);
                this._makeElementClickable((0, _renderer.default)(element))
            },
            _makeElementClickable: function($element) {
                if (!$element.attr("onclick")) {
                    $element.attr("onclick", "void(0)")
                }
            },
            start: function(e) {
                this._blurPrevented = e.isDefaultPrevented();
                this._startTarget = e.target;
                this._startEventData = (0, _index.eventData)(e)
            },
            end: function(e) {
                if (this._eventOutOfElement(e, this.getElement().get(0)) || e.type === _pointer.default.cancel) {
                    this._cancel(e);
                    return
                }
                if (!isInput(e.target) && !this._blurPrevented) {
                    (0, _dom.resetActiveElement)()
                }
                this._accept(e);
                this._clickAnimationFrame = misc.requestAnimationFrame(function() {
                    this._fireClickEvent(e)
                }.bind(this))
            },
            _eventOutOfElement: function(e, element) {
                var target = e.target;
                var targetChanged = !(0, _dom.contains)(element, target) && element !== target;
                var gestureDelta = (0, _index.eventDelta)((0, _index.eventData)(e), this._startEventData);
                var boundsExceeded = abs(gestureDelta.x) > TOUCH_BOUNDARY || abs(gestureDelta.y) > TOUCH_BOUNDARY;
                return targetChanged || boundsExceeded
            },
            _fireClickEvent: function(e) {
                this._fireEvent(CLICK_EVENT_NAME, e, {
                    target: (0, _dom.closestCommonParent)(this._startTarget, e.target)
                })
            },
            dispose: function() {
                misc.cancelAnimationFrame(this._clickAnimationFrame)
            }
        });
        var realDevice = _devices.default.real();
        var useNativeClick = realDevice.generic || realDevice.ios && (0, _version.compare)(realDevice.version, [9, 3]) >= 0 || realDevice.android && (0, _version.compare)(realDevice.version, [5]) >= 0;
        ! function() {
            var NATIVE_CLICK_CLASS = "dx-native-click";
            var isNativeClickEvent = function(target) {
                return useNativeClick || (0, _renderer.default)(target).closest("." + NATIVE_CLICK_CLASS).length
            };
            var prevented = null;
            var lastFiredEvent = null;

            function onNodeRemove() {
                lastFiredEvent = null
            }
            var clickHandler = function(e) {
                var originalEvent = e.originalEvent;
                var eventAlreadyFired = lastFiredEvent === originalEvent || originalEvent && originalEvent.DXCLICK_FIRED;
                var leftButton = !e.which || 1 === e.which;
                if (leftButton && !prevented && isNativeClickEvent(e.target) && !eventAlreadyFired) {
                    if (originalEvent) {
                        originalEvent.DXCLICK_FIRED = true
                    }(0, _event_nodes_disposing.unsubscribeNodesDisposing)(lastFiredEvent, onNodeRemove);
                    lastFiredEvent = originalEvent;
                    (0, _event_nodes_disposing.subscribeNodesDisposing)(lastFiredEvent, onNodeRemove);
                    (0, _index.fireEvent)({
                        type: CLICK_EVENT_NAME,
                        originalEvent: e
                    })
                }
            };
            ClickEmitter = ClickEmitter.inherit({
                _makeElementClickable: function($element) {
                    if (!isNativeClickEvent($element)) {
                        this.callBase($element)
                    }
                    _events_engine.default.on($element, "click", clickHandler)
                },
                configure: function(data) {
                    this.callBase(data);
                    if (data.useNative) {
                        this.getElement().addClass(NATIVE_CLICK_CLASS)
                    }
                },
                start: function(e) {
                    prevented = null;
                    if (!isNativeClickEvent(e.target)) {
                        this.callBase(e)
                    }
                },
                end: function(e) {
                    if (!isNativeClickEvent(e.target)) {
                        this.callBase(e)
                    }
                },
                cancel: function() {
                    prevented = true
                },
                dispose: function() {
                    this.callBase();
                    _events_engine.default.off(this.getElement(), "click", clickHandler)
                }
            })
        }();
        ! function() {
            var desktopDevice = _devices.default.real().generic;
            if (!desktopDevice) {
                var startTarget = null;
                var blurPrevented = false;
                var pointerDownHandler = function(e) {
                    startTarget = e.target;
                    blurPrevented = e.isDefaultPrevented()
                };
                var clickHandler = function(e) {
                    var $target = (0, _renderer.default)(e.target);
                    if (!blurPrevented && startTarget && !$target.is(startTarget) && !(0, _renderer.default)(startTarget).is("label") && isInput($target)) {
                        (0, _dom.resetActiveElement)()
                    }
                    startTarget = null;
                    blurPrevented = false
                };
                var NATIVE_CLICK_FIXER_NAMESPACE = "NATIVE_CLICK_FIXER";
                var document = _dom_adapter.default.getDocument();
                _events_engine.default.subscribeGlobal(document, (0, _index.addNamespace)(_pointer.default.down, NATIVE_CLICK_FIXER_NAMESPACE), pointerDownHandler);
                _events_engine.default.subscribeGlobal(document, (0, _index.addNamespace)("click", NATIVE_CLICK_FIXER_NAMESPACE), clickHandler)
            }
        }();
        (0, _emitter_registrator.default)({
            emitter: ClickEmitter,
            bubble: true,
            events: [CLICK_EVENT_NAME]
        })
    },
    /*!*********************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/position.js ***!
      \*********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getDefaultAlignment = exports.getBoundingRect = void 0;
        var _config = _interopRequireDefault(__webpack_require__( /*! ../config */ 31));
        var _type = __webpack_require__( /*! ../utils/type */ 1);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var getDefaultAlignment = function(isRtlEnabled) {
            var rtlEnabled = null !== isRtlEnabled && void 0 !== isRtlEnabled ? isRtlEnabled : (0, _config.default)().rtlEnabled;
            return rtlEnabled ? "right" : "left"
        };
        exports.getDefaultAlignment = getDefaultAlignment;
        var getBoundingRect = function(element) {
            if ((0, _type.isWindow)(element)) {
                return {
                    width: element.outerWidth,
                    height: element.outerHeight
                }
            }
            var rect;
            try {
                rect = element.getBoundingClientRect()
            } catch (e) {
                rect = {
                    width: 0,
                    height: 0,
                    bottom: 0,
                    top: 0,
                    left: 0,
                    right: 0
                }
            }
            return rect
        };
        exports.getBoundingRect = getBoundingRect
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/browser.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _extend = __webpack_require__( /*! ./extend */ 0);
        var _window = __webpack_require__( /*! ./window */ 7);
        var navigator = (0, _window.getNavigator)();
        var webkitRegExp = /(webkit)[ /]([\w.]+)/;
        var ieRegExp = /(msie) (\d{1,2}\.\d)/;
        var ie11RegExp = /(trident).*rv:(\d{1,2}\.\d)/;
        var msEdge = /(edge)\/((\d+)?[\w.]+)/;
        var mozillaRegExp = /(mozilla)(?:.*? rv:([\w.]+))/;
        var browserFromUA = function(ua) {
            ua = ua.toLowerCase();
            var result = {};
            var matches = ieRegExp.exec(ua) || ie11RegExp.exec(ua) || msEdge.exec(ua) || ua.indexOf("compatible") < 0 && mozillaRegExp.exec(ua) || webkitRegExp.exec(ua) || [];
            var browserName = matches[1];
            var browserVersion = matches[2];
            if ("webkit" === browserName) {
                result.webkit = true;
                if (ua.indexOf("chrome") >= 0 || ua.indexOf("crios") >= 0) {
                    browserName = "chrome";
                    browserVersion = /(?:chrome|crios)\/(\d+\.\d+)/.exec(ua);
                    browserVersion = browserVersion && browserVersion[1]
                } else {
                    if (ua.indexOf("fxios") >= 0) {
                        browserName = "mozilla";
                        browserVersion = /fxios\/(\d+\.\d+)/.exec(ua);
                        browserVersion = browserVersion && browserVersion[1]
                    } else {
                        if (ua.indexOf("safari") >= 0 && /version|phantomjs/.test(ua)) {
                            browserName = "safari";
                            browserVersion = /(?:version|phantomjs)\/([0-9.]+)/.exec(ua);
                            browserVersion = browserVersion && browserVersion[1]
                        } else {
                            browserName = "unknown";
                            browserVersion = /applewebkit\/([0-9.]+)/.exec(ua);
                            browserVersion = browserVersion && browserVersion[1]
                        }
                    }
                }
            }
            if ("trident" === browserName || "edge" === browserName) {
                browserName = "msie"
            }
            if (browserName) {
                result[browserName] = true;
                result.version = browserVersion
            }
            return result
        };
        var _default = (0, _extend.extend)({
            _fromUA: browserFromUA
        }, browserFromUA(navigator.userAgent));
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************!*\
      !*** ./artifacts/transpiled-npm/events/pointer.js ***!
      \****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.default = void 0;
        var support = _interopRequireWildcard(__webpack_require__( /*! ../core/utils/support */ 45));
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../core/utils/browser */ 23));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../core/devices */ 13));
        var _event_registrator = _interopRequireDefault(__webpack_require__( /*! ./core/event_registrator */ 74));
        var _touch = _interopRequireDefault(__webpack_require__( /*! ./pointer/touch */ 254));
        var _mspointer = _interopRequireDefault(__webpack_require__( /*! ./pointer/mspointer */ 531));
        var _mouse = _interopRequireDefault(__webpack_require__( /*! ./pointer/mouse */ 256));
        var _mouse_and_touch = _interopRequireDefault(__webpack_require__( /*! ./pointer/mouse_and_touch */ 532));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }
        var getStrategy = function(support, device, browser) {
            if (support.pointerEvents && browser.msie) {
                return _mspointer.default
            }
            var tablet = device.tablet,
                phone = device.phone;
            if (support.touch && !(tablet || phone)) {
                return _mouse_and_touch.default
            }
            if (support.touch) {
                return _touch.default
            }
            return _mouse.default
        };
        var EventStrategy = getStrategy(support, _devices.default.real(), _browser.default);
        (0, _iterator.each)(EventStrategy.map, function(pointerEvent, originalEvents) {
            (0, _event_registrator.default)(pointerEvent, new EventStrategy(pointerEvent, originalEvents))
        });
        var pointer = {
            down: "dxpointerdown",
            up: "dxpointerup",
            move: "dxpointermove",
            cancel: "dxpointercancel",
            enter: "dxpointerenter",
            leave: "dxpointerleave",
            over: "dxpointerover",
            out: "dxpointerout"
        };
        var _default = pointer;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************!*\
      !*** ./artifacts/transpiled-npm/core/errors.js ***!
      \*************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _error = _interopRequireDefault(__webpack_require__( /*! ./utils/error */ 146));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = (0, _error.default)({
            E0001: "Method is not implemented",
            E0002: "Member name collision: {0}",
            E0003: "A class must be instantiated using the 'new' keyword",
            E0004: "The NAME property of the component is not specified",
            E0005: "Unknown device",
            E0006: "Unknown endpoint key is requested",
            E0007: "'Invalidate' method is called outside the update transaction",
            E0008: "Type of the option name is not appropriate to create an action",
            E0009: "Component '{0}' has not been initialized for an element",
            E0010: "Animation configuration with the '{0}' type requires '{1}' configuration as {2}",
            E0011: "Unknown animation type '{0}'",
            E0012: "jQuery version is too old. Please upgrade jQuery to 1.10.0 or later",
            E0013: "KnockoutJS version is too old. Please upgrade KnockoutJS to 2.3.0 or later",
            E0014: "The 'release' method shouldn't be called for an unlocked Lock object",
            E0015: "Queued task returned an unexpected result",
            E0017: "Event namespace is not defined",
            E0018: "DevExpress.ui.DevExpressPopup widget is required",
            E0020: "Template engine '{0}' is not supported",
            E0021: "Unknown theme is set: {0}",
            E0022: "LINK[rel=DevExpress-theme] tags must go before DevExpress included scripts",
            E0023: "Template name is not specified",
            E0024: "DevExtreme bundle already included",
            E0025: "Unexpected argument type",
            E0100: "Unknown validation type is detected",
            E0101: "Misconfigured range validation rule is detected",
            E0102: "Misconfigured comparison validation rule is detected",
            E0103: "validationCallback of an asynchronous rule should return a jQuery or a native promise",
            E0110: "Unknown validation group is detected",
            E0120: "Adapter for a DevExpressValidator component cannot be configured",
            E0121: "The 'customItem' field of the 'onCustomItemCreating' function's parameter should contain a custom item or Promise that is resolved after the item is created.",
            W0000: "'{0}' is deprecated in {1}. {2}",
            W0001: "{0} - '{1}' option is deprecated in {2}. {3}",
            W0002: "{0} - '{1}' method is deprecated in {2}. {3}",
            W0003: "{0} - '{1}' property is deprecated in {2}. {3}",
            W0004: "Timeout for theme loading is over: {0}",
            W0005: "'{0}' event is deprecated in {1}. {2}",
            W0006: "Invalid recurrence rule: '{0}'",
            W0007: "'{0}' Globalize culture is not defined",
            W0008: "Invalid view name: '{0}'",
            W0009: "Invalid time zone name: '{0}'",
            W0010: "{0} is deprecated in {1}. {2}",
            W0011: "Number parsing is invoked while the parser is not defined",
            W0012: "Date parsing is invoked while the parser is not defined",
            W0013: "'{0}' file is deprecated in {1}. {2}",
            W0014: "{0} - '{1}' type is deprecated in {2}. {3}",
            W0015: "Instead of returning a value from the '{0}' function, write it into the '{1}' field of the function's parameter.",
            W0016: 'The "{0}" option does not accept the "{1}" value since v.{2}. {3}.'
        });
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.core.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.utils */ 35));
        var _uiGrid_core2 = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.modules */ 44));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }
        var _default = _objectSpread(_objectSpread(_objectSpread({}, _uiGrid_core2.default), _uiGrid_core.default), {}, {
            modules: []
        });
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/callbacks.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var Callback = function(options) {
            this._options = options || {};
            this._list = [];
            this._queue = [];
            this._firing = false;
            this._fired = false;
            this._firingIndexes = []
        };
        Callback.prototype._fireCore = function(context, args) {
            var firingIndexes = this._firingIndexes;
            var list = this._list;
            var stopOnFalse = this._options.stopOnFalse;
            var step = firingIndexes.length;
            for (firingIndexes[step] = 0; firingIndexes[step] < list.length; firingIndexes[step]++) {
                var result = list[firingIndexes[step]].apply(context, args);
                if (false === result && stopOnFalse) {
                    break
                }
            }
            firingIndexes.pop()
        };
        Callback.prototype.add = function(fn) {
            if ("function" === typeof fn && (!this._options.unique || !this.has(fn))) {
                this._list.push(fn)
            }
            return this
        };
        Callback.prototype.remove = function(fn) {
            var list = this._list;
            var firingIndexes = this._firingIndexes;
            var index = list.indexOf(fn);
            if (index > -1) {
                list.splice(index, 1);
                if (this._firing && firingIndexes.length) {
                    for (var step = 0; step < firingIndexes.length; step++) {
                        if (index <= firingIndexes[step]) {
                            firingIndexes[step]--
                        }
                    }
                }
            }
            return this
        };
        Callback.prototype.has = function(fn) {
            var list = this._list;
            return fn ? list.indexOf(fn) > -1 : !!list.length
        };
        Callback.prototype.empty = function(fn) {
            this._list = [];
            return this
        };
        Callback.prototype.fireWith = function(context, args) {
            var queue = this._queue;
            args = args || [];
            args = args.slice ? args.slice() : args;
            if (this._options.syncStrategy) {
                this._firing = true;
                this._fireCore(context, args)
            } else {
                queue.push([context, args]);
                if (this._firing) {
                    return
                }
                this._firing = true;
                while (queue.length) {
                    var memory = queue.shift();
                    this._fireCore(memory[0], memory[1])
                }
            }
            this._firing = false;
            this._fired = true;
            return this
        };
        Callback.prototype.fire = function() {
            this.fireWith(this, arguments)
        };
        Callback.prototype.fired = function() {
            return this._fired
        };
        var Callbacks = function(options) {
            return new Callback(options)
        };
        var _default = Callbacks;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/animation/translator.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.parseTranslate = exports.resetPosition = exports.move = exports.getTranslate = exports.getTranslateCss = exports.clearCache = exports.locate = void 0;
        var _element_data = __webpack_require__( /*! ../core/element_data */ 40);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var TRANSLATOR_DATA_KEY = "dxTranslator";
        var TRANSFORM_MATRIX_REGEX = /matrix(3d)?\((.+?)\)/;
        var TRANSLATE_REGEX = /translate(?:3d)?\((.+?)\)/;
        var locate = function($element) {
            var translate = getTranslate($element);
            return {
                left: translate.x,
                top: translate.y
            }
        };
        exports.locate = locate;

        function isPercentValue(value) {
            return "string" === (0, _type.type)(value) && "%" === value[value.length - 1]
        }

        function cacheTranslate($element, translate) {
            if ($element.length) {
                (0, _element_data.data)($element.get(0), TRANSLATOR_DATA_KEY, translate)
            }
        }
        var clearCache = function($element) {
            if ($element.length) {
                (0, _element_data.removeData)($element.get(0), TRANSLATOR_DATA_KEY)
            }
        };
        exports.clearCache = clearCache;
        var getTranslateCss = function(translate) {
            translate.x = translate.x || 0;
            translate.y = translate.y || 0;
            var xValueString = isPercentValue(translate.x) ? translate.x : translate.x + "px";
            var yValueString = isPercentValue(translate.y) ? translate.y : translate.y + "px";
            return "translate(" + xValueString + ", " + yValueString + ")"
        };
        exports.getTranslateCss = getTranslateCss;
        var getTranslate = function($element) {
            var result = $element.length ? (0, _element_data.data)($element.get(0), TRANSLATOR_DATA_KEY) : null;
            if (!result) {
                var transformValue = $element.css("transform") || getTranslateCss({
                    x: 0,
                    y: 0
                });
                var matrix = transformValue.match(TRANSFORM_MATRIX_REGEX);
                var is3D = matrix && matrix[1];
                if (matrix) {
                    matrix = matrix[2].split(",");
                    if ("3d" === is3D) {
                        matrix = matrix.slice(12, 15)
                    } else {
                        matrix.push(0);
                        matrix = matrix.slice(4, 7)
                    }
                } else {
                    matrix = [0, 0, 0]
                }
                result = {
                    x: parseFloat(matrix[0]),
                    y: parseFloat(matrix[1]),
                    z: parseFloat(matrix[2])
                };
                cacheTranslate($element, result)
            }
            return result
        };
        exports.getTranslate = getTranslate;
        var move = function($element, position) {
            var left = position.left;
            var top = position.top;
            var translate;
            if (void 0 === left) {
                translate = getTranslate($element);
                translate.y = top || 0
            } else {
                if (void 0 === top) {
                    translate = getTranslate($element);
                    translate.x = left || 0
                } else {
                    translate = {
                        x: left || 0,
                        y: top || 0,
                        z: 0
                    };
                    cacheTranslate($element, translate)
                }
            }
            $element.css({
                transform: getTranslateCss(translate)
            });
            if (isPercentValue(left) || isPercentValue(top)) {
                clearCache($element)
            }
        };
        exports.move = move;
        var resetPosition = function($element, finishTransition) {
            var originalTransition;
            var stylesConfig = {
                left: 0,
                top: 0,
                transform: "none"
            };
            if (finishTransition) {
                originalTransition = $element.css("transition");
                stylesConfig.transition = "none"
            }
            $element.css(stylesConfig);
            clearCache($element);
            if (finishTransition) {
                $element.get(0).offsetHeight;
                $element.css("transition", originalTransition)
            }
        };
        exports.resetPosition = resetPosition;
        var parseTranslate = function(translateString) {
            var result = translateString.match(TRANSLATE_REGEX);
            if (!result || !result[1]) {
                return
            }
            result = result[1].split(",");
            result = {
                x: parseFloat(result[0]),
                y: parseFloat(result[1]),
                z: parseFloat(result[2])
            };
            return result
        };
        exports.parseTranslate = parseTranslate
    },
    /*!*****************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/math.js ***!
      \*****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.adjust = adjust;
        exports.getPrecision = getPrecision;
        exports.getExponent = getExponent;
        exports.getRoot = getRoot;
        exports.solveCubicEquation = solveCubicEquation;
        exports.trunc = trunc;
        exports.roundFloatPart = roundFloatPart;
        exports.getExponentLength = getExponentLength;
        exports.getRemainderByDivision = getRemainderByDivision;
        exports.inRange = exports.fitIntoRange = exports.sign = void 0;
        var _type = __webpack_require__( /*! ./type */ 1);
        var sign = function(value) {
            if (0 === value) {
                return 0
            }
            return value / Math.abs(value)
        };
        exports.sign = sign;
        var fitIntoRange = function(value, minValue, maxValue) {
            var isMinValueUndefined = !minValue && 0 !== minValue;
            var isMaxValueUndefined = !maxValue && 0 !== maxValue;
            isMinValueUndefined && (minValue = !isMaxValueUndefined ? Math.min(value, maxValue) : value);
            isMaxValueUndefined && (maxValue = !isMinValueUndefined ? Math.max(value, minValue) : value);
            return Math.min(Math.max(value, minValue), maxValue)
        };
        exports.fitIntoRange = fitIntoRange;
        var inRange = function(value, minValue, maxValue) {
            return value >= minValue && value <= maxValue
        };
        exports.inRange = inRange;

        function getExponent(value) {
            return Math.abs(parseInt(value.toExponential().split("e")[1]))
        }

        function _isEdgeBug() {
            var value = 3e-4;
            var correctValue = "0.000300";
            var precisionValue = 3;
            return correctValue !== value.toPrecision(precisionValue)
        }

        function adjust(value, interval) {
            var precision = getPrecision(interval || 0) + 2;
            var separatedValue = value.toString().split(".");
            var sourceValue = value;
            var absValue = Math.abs(value);
            var separatedAdjustedValue;
            var isExponentValue = (0, _type.isExponential)(value);
            var integerPart = absValue > 1 ? 10 : 0;
            if (1 === separatedValue.length) {
                return value
            }
            if (!isExponentValue) {
                if ((0, _type.isExponential)(interval)) {
                    precision = separatedValue[0].length + getExponent(interval)
                }
                value = absValue;
                value = value - Math.floor(value) + integerPart
            }
            precision = _isEdgeBug() && getExponent(value) > 6 || precision > 7 ? 15 : 7;
            if (!isExponentValue) {
                separatedAdjustedValue = parseFloat(value.toPrecision(precision)).toString().split(".");
                if (separatedAdjustedValue[0] === integerPart.toString()) {
                    return parseFloat(separatedValue[0] + "." + separatedAdjustedValue[1])
                }
            }
            return parseFloat(sourceValue.toPrecision(precision))
        }

        function getPrecision(value) {
            var str = value.toString();
            if (str.indexOf(".") < 0) {
                return 0
            }
            var mantissa = str.split(".");
            var positionOfDelimiter = mantissa[1].indexOf("e");
            return positionOfDelimiter >= 0 ? positionOfDelimiter : mantissa[1].length
        }

        function getRoot(x, n) {
            if (x < 0 && n % 2 !== 1) {
                return NaN
            }
            var y = Math.pow(Math.abs(x), 1 / n);
            return n % 2 === 1 && x < 0 ? -y : y
        }

        function solveCubicEquation(a, b, c, d) {
            var min = 1e-8;
            if (Math.abs(a) < min) {
                a = b;
                b = c;
                c = d;
                if (Math.abs(a) < min) {
                    a = b;
                    b = c;
                    if (Math.abs(a) < min) {
                        return []
                    }
                    return [-b / a]
                }
                var D2 = b * b - 4 * a * c;
                if (Math.abs(D2) < min) {
                    return [-b / (2 * a)]
                } else {
                    if (D2 > 0) {
                        return [(-b + Math.sqrt(D2)) / (2 * a), (-b - Math.sqrt(D2)) / (2 * a)]
                    }
                }
                return []
            }
            var p = (3 * a * c - b * b) / (3 * a * a);
            var q = (2 * b * b * b - 9 * a * b * c + 27 * a * a * d) / (27 * a * a * a);
            var roots;
            var u;
            if (Math.abs(p) < min) {
                roots = [getRoot(-q, 3)]
            } else {
                if (Math.abs(q) < min) {
                    roots = [0].concat(p < 0 ? [Math.sqrt(-p), -Math.sqrt(-p)] : [])
                } else {
                    var D3 = q * q / 4 + p * p * p / 27;
                    if (Math.abs(D3) < min) {
                        roots = [-1.5 * q / p, 3 * q / p]
                    } else {
                        if (D3 > 0) {
                            u = getRoot(-q / 2 - Math.sqrt(D3), 3);
                            roots = [u - p / (3 * u)]
                        } else {
                            u = 2 * Math.sqrt(-p / 3);
                            var t = Math.acos(3 * q / p / u) / 3;
                            var k = 2 * Math.PI / 3;
                            roots = [u * Math.cos(t), u * Math.cos(t - k), u * Math.cos(t - 2 * k)]
                        }
                    }
                }
            }
            for (var i = 0; i < roots.length; i++) {
                roots[i] -= b / (3 * a)
            }
            return roots
        }

        function trunc(value) {
            return Math.trunc ? Math.trunc(value) : value > 0 ? Math.floor(value) : Math.ceil(value)
        }

        function getRemainderByDivision(dividend, divider, digitsCount) {
            if (divider === parseInt(divider)) {
                return dividend % divider
            }
            var quotient = roundFloatPart(dividend / divider, digitsCount);
            return (quotient - parseInt(quotient)) * divider
        }

        function getExponentLength(value) {
            var _valueString$split$;
            var valueString = value.toString();
            return (null === (_valueString$split$ = valueString.split(".")[1]) || void 0 === _valueString$split$ ? void 0 : _valueString$split$.length) || parseInt(valueString.split("e-")[1]) || 0
        }

        function roundFloatPart(value) {
            var digitsCount = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
            return parseFloat(value.toFixed(digitsCount))
        }
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.core.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.modules */ 44));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = (0, _extend.extend)({}, _uiGrid_core.default, {
            modules: [],
            foreachNodes: function(nodes, callBack, ignoreHasChildren) {
                for (var i = 0; i < nodes.length; i++) {
                    if (false !== callBack(nodes[i]) && (ignoreHasChildren || nodes[i].hasChildren) && nodes[i].children.length) {
                        this.foreachNodes(nodes[i].children, callBack, ignoreHasChildren)
                    }
                }
            }
        });
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************!*\
      !*** ./artifacts/transpiled-npm/core/config.js ***!
      \*************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _extend = __webpack_require__( /*! ./utils/extend */ 0);
        var _errors = _interopRequireDefault(__webpack_require__( /*! ./errors */ 25));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var config = {
            rtlEnabled: false,
            defaultCurrency: "USD",
            oDataFilterToLower: true,
            serverDecimalSeparator: ".",
            decimalSeparator: ".",
            thousandsSeparator: ",",
            forceIsoDateParsing: true,
            wrapActionsBeforeExecute: true,
            useLegacyStoreResult: false,
            useJQuery: void 0,
            editorStylingMode: void 0,
            useLegacyVisibleIndex: false,
            floatingActionButtonConfig: {
                icon: "add",
                closeIcon: "close",
                label: "",
                position: {
                    at: "right bottom",
                    my: "right bottom",
                    offset: {
                        x: -16,
                        y: -16
                    }
                },
                maxSpeedDialActionCount: 5,
                shading: false,
                direction: "auto"
            },
            optionsParser: function(optionsString) {
                if ("{" !== optionsString.trim().charAt(0)) {
                    optionsString = "{" + optionsString + "}"
                }
                try {
                    return new Function("return " + optionsString)()
                } catch (ex) {
                    throw _errors.default.Error("E3018", ex, optionsString)
                }
            }
        };
        var deprecatedFields = ["decimalSeparator", "thousandsSeparator"];
        var configMethod = function() {
            if (!arguments.length) {
                return config
            }
            var newConfig = arguments.length <= 0 ? void 0 : arguments[0];
            deprecatedFields.forEach(function(deprecatedField) {
                if (newConfig[deprecatedField]) {
                    var message = "Now, the ".concat(deprecatedField, " is selected based on the specified locale.");
                    _errors.default.log("W0003", "config", deprecatedField, "19.2", message)
                }
            });
            (0, _extend.extend)(config, newConfig)
        };
        if ("undefined" !== typeof DevExpress && DevExpress.config) {
            configMethod(DevExpress.config)
        }
        var _default = configMethod;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/localization/date.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _dependency_injector = _interopRequireDefault(__webpack_require__( /*! ../core/utils/dependency_injector */ 58));
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _array = __webpack_require__( /*! ../core/utils/array */ 12);
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../core/errors */ 25));
        var _date = __webpack_require__( /*! ./ldml/date.formatter */ 242);
        var _date2 = __webpack_require__( /*! ./ldml/date.format */ 174);
        var _date3 = __webpack_require__( /*! ./ldml/date.parser */ 231);
        var _default_date_names = _interopRequireDefault(__webpack_require__( /*! ./default_date_names */ 243));
        var _first_day_of_week_data = _interopRequireDefault(__webpack_require__( /*! ./cldr-data/first_day_of_week_data */ 498));
        var _core = _interopRequireDefault(__webpack_require__( /*! ./core */ 87));
        var _number = _interopRequireDefault(__webpack_require__( /*! ./number */ 47));
        var _date4 = _interopRequireDefault(__webpack_require__( /*! ./intl/date */ 499));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DEFAULT_DAY_OF_WEEK_INDEX = 0;
        var hasIntl = "undefined" !== typeof Intl;
        var FORMATS_TO_PATTERN_MAP = {
            shortdate: "M/d/y",
            shorttime: "h:mm a",
            longdate: "EEEE, MMMM d, y",
            longtime: "h:mm:ss a",
            monthandday: "MMMM d",
            monthandyear: "MMMM y",
            quarterandyear: "QQQ y",
            day: "d",
            year: "y",
            shortdateshorttime: "M/d/y, h:mm a",
            longdatelongtime: "EEEE, MMMM d, y, h:mm:ss a",
            month: "LLLL",
            shortyear: "yy",
            dayofweek: "EEEE",
            quarter: "QQQ",
            hour: "HH",
            minute: "mm",
            second: "ss",
            millisecond: "SSS",
            "datetime-local": "yyyy-MM-ddTHH':'mm':'ss"
        };
        var possiblePartPatterns = {
            year: ["y", "yy", "yyyy"],
            day: ["d", "dd"],
            month: ["M", "MM", "MMM", "MMMM"],
            hours: ["H", "HH", "h", "hh", "ah"],
            minutes: ["m", "mm"],
            seconds: ["s", "ss"],
            milliseconds: ["S", "SS", "SSS"]
        };
        var dateLocalization = (0, _dependency_injector.default)({
            engine: function() {
                return "base"
            },
            _getPatternByFormat: function(format) {
                return FORMATS_TO_PATTERN_MAP[format.toLowerCase()]
            },
            _expandPattern: function(pattern) {
                return this._getPatternByFormat(pattern) || pattern
            },
            formatUsesMonthName: function(format) {
                return this._expandPattern(format).indexOf("MMMM") !== -1
            },
            formatUsesDayName: function(format) {
                return this._expandPattern(format).indexOf("EEEE") !== -1
            },
            getFormatParts: function(format) {
                var pattern = this._getPatternByFormat(format) || format;
                var result = [];
                (0, _iterator.each)(pattern.split(/\W+/), function(_, formatPart) {
                    (0, _iterator.each)(possiblePartPatterns, function(partName, possiblePatterns) {
                        if ((0, _array.inArray)(formatPart, possiblePatterns) > -1) {
                            result.push(partName)
                        }
                    })
                });
                return result
            },
            getMonthNames: function(format) {
                return _default_date_names.default.getMonthNames(format)
            },
            getDayNames: function(format) {
                return _default_date_names.default.getDayNames(format)
            },
            getQuarterNames: function(format) {
                return _default_date_names.default.getQuarterNames(format)
            },
            getPeriodNames: function(format) {
                return _default_date_names.default.getPeriodNames(format)
            },
            getTimeSeparator: function() {
                return ":"
            },
            is24HourFormat: function(format) {
                var amTime = new Date(2017, 0, 20, 11, 0, 0, 0);
                var pmTime = new Date(2017, 0, 20, 23, 0, 0, 0);
                var amTimeFormatted = this.format(amTime, format);
                var pmTimeFormatted = this.format(pmTime, format);
                for (var i = 0; i < amTimeFormatted.length; i++) {
                    if (amTimeFormatted[i] !== pmTimeFormatted[i]) {
                        return !isNaN(parseInt(amTimeFormatted[i]))
                    }
                }
            },
            format: function(date, _format) {
                if (!date) {
                    return
                }
                if (!_format) {
                    return date
                }
                var formatter;
                if ("function" === typeof _format) {
                    formatter = _format
                } else {
                    if (_format.formatter) {
                        formatter = _format.formatter
                    } else {
                        _format = _format.type || _format;
                        if ((0, _type.isString)(_format)) {
                            _format = FORMATS_TO_PATTERN_MAP[_format.toLowerCase()] || _format;
                            return _number.default.convertDigits((0, _date.getFormatter)(_format, this)(date))
                        }
                    }
                }
                if (!formatter) {
                    return
                }
                return formatter(date)
            },
            parse: function(text, format) {
                var that = this;
                var ldmlFormat;
                var formatter;
                if (!text) {
                    return
                }
                if (!format) {
                    return this.parse(text, "shortdate")
                }
                if (format.parser) {
                    return format.parser(text)
                }
                if ("string" === typeof format && !FORMATS_TO_PATTERN_MAP[format.toLowerCase()]) {
                    ldmlFormat = format
                } else {
                    formatter = function(value) {
                        var text = that.format(value, format);
                        return _number.default.convertDigits(text, true)
                    };
                    try {
                        ldmlFormat = (0, _date2.getFormat)(formatter)
                    } catch (e) {}
                }
                if (ldmlFormat) {
                    text = _number.default.convertDigits(text, true);
                    return (0, _date3.getParser)(ldmlFormat, this)(text)
                }
                _errors.default.log("W0012");
                var result = new Date(text);
                if (!result || isNaN(result.getTime())) {
                    return
                }
                return result
            },
            firstDayOfWeekIndex: function() {
                var index = _core.default.getValueByClosestLocale(function(locale) {
                    return _first_day_of_week_data.default[locale]
                });
                return void 0 === index ? DEFAULT_DAY_OF_WEEK_INDEX : index
            }
        });
        if (hasIntl) {
            dateLocalization.inject(_date4.default)
        }
        var _default = dateLocalization;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/dom.js ***!
      \****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.createTextElementHiddenCopy = exports.contains = exports.clipboardText = exports.normalizeTemplateElement = exports.extractTemplateMarkup = exports.closestCommonParent = exports.clearSelection = exports.resetActiveElement = void 0;
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _type = __webpack_require__( /*! ./type */ 1);
        var _window = __webpack_require__( /*! ./window */ 7);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var resetActiveElement = function() {
            var activeElement = _dom_adapter.default.getActiveElement();
            var body = _dom_adapter.default.getBody();
            if (activeElement && activeElement !== body && activeElement.blur) {
                try {
                    activeElement.blur()
                } catch (e) {
                    body.blur()
                }
            }
        };
        exports.resetActiveElement = resetActiveElement;
        var clearSelection = function() {
            var selection = window.getSelection();
            if (!selection) {
                return
            }
            if ("Caret" === selection.type) {
                return
            }
            if (selection.empty) {
                selection.empty()
            } else {
                if (selection.removeAllRanges) {
                    try {
                        selection.removeAllRanges()
                    } catch (e) {}
                }
            }
        };
        exports.clearSelection = clearSelection;
        var closestCommonParent = function(startTarget, endTarget) {
            var $startTarget = (0, _renderer.default)(startTarget);
            var $endTarget = (0, _renderer.default)(endTarget);
            if ($startTarget[0] === $endTarget[0]) {
                return $startTarget[0]
            }
            var $startParents = $startTarget.parents();
            var $endParents = $endTarget.parents();
            var startingParent = Math.min($startParents.length, $endParents.length);
            for (var i = -startingParent; i < 0; i++) {
                if ($startParents.get(i) === $endParents.get(i)) {
                    return $startParents.get(i)
                }
            }
        };
        exports.closestCommonParent = closestCommonParent;
        var extractTemplateMarkup = function(element) {
            element = (0, _renderer.default)(element);
            var templateTag = element.length && element.filter(function() {
                var $node = (0, _renderer.default)(this);
                return $node.is("script[type]") && $node.attr("type").indexOf("script") < 0
            });
            if (templateTag.length) {
                return templateTag.eq(0).html()
            } else {
                element = (0, _renderer.default)("<div>").append(element);
                return element.html()
            }
        };
        exports.extractTemplateMarkup = extractTemplateMarkup;
        var normalizeTemplateElement = function normalizeTemplateElement(element) {
            var $element = (0, _type.isDefined)(element) && (element.nodeType || (0, _type.isRenderer)(element)) ? (0, _renderer.default)(element) : (0, _renderer.default)("<div>").html(element).contents();
            if (1 === $element.length) {
                if ($element.is("script")) {
                    $element = normalizeTemplateElement($element.html().trim())
                } else {
                    if ($element.is("table")) {
                        $element = $element.children("tbody").contents()
                    }
                }
            }
            return $element
        };
        exports.normalizeTemplateElement = normalizeTemplateElement;
        var clipboardText = function(event, text) {
            var clipboard = event.originalEvent && event.originalEvent.clipboardData || window.clipboardData;
            if (1 === arguments.length) {
                return clipboard && clipboard.getData("Text")
            }
            clipboard && clipboard.setData("Text", text)
        };
        exports.clipboardText = clipboardText;
        var contains = function contains(container, element) {
            if (!element) {
                return false
            }
            if (_dom_adapter.default.isTextNode(element)) {
                element = element.parentNode
            }
            if (_dom_adapter.default.isDocument(container)) {
                return container.documentElement.contains(element)
            }
            if ((0, _type.isWindow)(container)) {
                return contains(container.document, element)
            }
            return container.contains ? container.contains(element) : !!(element.compareDocumentPosition(container) & element.DOCUMENT_POSITION_CONTAINS)
        };
        exports.contains = contains;
        var createTextElementHiddenCopy = function(element, text, options) {
            var elementStyles = window.getComputedStyle((0, _renderer.default)(element).get(0));
            var includePaddings = options && options.includePaddings;
            return (0, _renderer.default)("<div>").text(text).css({
                fontStyle: elementStyles.fontStyle,
                fontVariant: elementStyles.fontVariant,
                fontWeight: elementStyles.fontWeight,
                fontSize: elementStyles.fontSize,
                fontFamily: elementStyles.fontFamily,
                letterSpacing: elementStyles.letterSpacing,
                border: elementStyles.border,
                paddingTop: includePaddings ? elementStyles.paddingTop : "",
                paddingRight: includePaddings ? elementStyles.paddingRight : "",
                paddingBottom: includePaddings ? elementStyles.paddingBottom : "",
                paddingLeft: includePaddings ? elementStyles.paddingLeft : "",
                visibility: "hidden",
                whiteSpace: "pre",
                position: "absolute",
                "float": "left"
            })
        };
        exports.createTextElementHiddenCopy = createTextElementHiddenCopy
    },
    /*!***********************************************!*\
      !*** ./artifacts/transpiled-npm/ui/themes.js ***!
      \***********************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.waitForThemeLoad = waitForThemeLoad;
        exports.isPendingThemeLoaded = isPendingThemeLoaded;
        exports.init = init;
        exports.current = current;
        exports.attachCssClasses = attachCssClasses;
        exports.detachCssClasses = detachCssClasses;
        exports.isMaterial = isMaterial;
        exports.isGeneric = isGeneric;
        exports.isDark = isDark;
        exports.isWebFontLoaded = isWebFontLoaded;
        exports.waitWebFont = waitWebFont;
        exports.ready = themeReady;
        exports.resetTheme = resetTheme;
        exports.initialized = initialized;
        exports.setDefaultTimeout = setDefaultTimeout;
        exports.default = void 0;
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../core/devices */ 13));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../core/dom_adapter */ 11));
        var _promise = _interopRequireDefault(__webpack_require__( /*! ../core/polyfills/promise */ 73));
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);
        var _html_parser = __webpack_require__( /*! ../core/utils/html_parser */ 238);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _ready_callbacks = _interopRequireDefault(__webpack_require__( /*! ../core/utils/ready_callbacks */ 49));
        var _view_port = __webpack_require__( /*! ../core/utils/view_port */ 80);
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _themes_callback = __webpack_require__( /*! ./themes_callback */ 258);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./widget/ui.errors */ 17));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var ready = _ready_callbacks.default.add;
        var viewPort = _view_port.value;
        var viewPortChanged = _view_port.changeCallback;
        var initDeferred = new _deferred.Deferred;
        var DX_LINK_SELECTOR = "link[rel=dx-theme]";
        var THEME_ATTR = "data-theme";
        var ACTIVE_ATTR = "data-active";
        var DX_HAIRLINES_CLASS = "dx-hairlines";
        var ANY_THEME = "any";
        var context;
        var $activeThemeLink;
        var knownThemes;
        var currentThemeName;
        var pendingThemeName;
        var defaultTimeout = 15e3;
        var THEME_MARKER_PREFIX = "dx.";

        function readThemeMarker() {
            if (!(0, _window.hasWindow)()) {
                return null
            }
            var element = (0, _renderer.default)("<div>", context).addClass("dx-theme-marker").appendTo(context.documentElement);
            var result;
            try {
                result = window.getComputedStyle(element.get(0)).fontFamily;
                if (!result) {
                    return null
                }
                result = result.replace(/["']/g, "");
                if (result.substr(0, THEME_MARKER_PREFIX.length) !== THEME_MARKER_PREFIX) {
                    return null
                }
                return result.substr(THEME_MARKER_PREFIX.length)
            } finally {
                element.remove()
            }
        }

        function waitForThemeLoad(themeName) {
            var waitStartTime;
            var timerId;
            var intervalCleared = true;
            pendingThemeName = themeName;

            function handleLoaded() {
                pendingThemeName = null;
                clearInterval(timerId);
                intervalCleared = true;
                _themes_callback.themeReadyCallback.fire();
                _themes_callback.themeReadyCallback.empty();
                initDeferred.resolve()
            }
            if (isPendingThemeLoaded() || !defaultTimeout) {
                handleLoaded()
            } else {
                if (!intervalCleared) {
                    if (pendingThemeName) {
                        pendingThemeName = themeName
                    }
                    return
                }
                waitStartTime = Date.now();
                intervalCleared = false;
                timerId = setInterval(function() {
                    var isLoaded = isPendingThemeLoaded();
                    var isTimeout = !isLoaded && Date.now() - waitStartTime > defaultTimeout;
                    if (isTimeout) {
                        _ui.default.log("W0004", pendingThemeName)
                    }
                    if (isLoaded || isTimeout) {
                        handleLoaded()
                    }
                }, 10)
            }
        }

        function isPendingThemeLoaded() {
            if (!pendingThemeName) {
                return true
            }
            var anyThemePending = pendingThemeName === ANY_THEME;
            if ("resolved" === initDeferred.state() && anyThemePending) {
                return true
            }
            var themeMarker = readThemeMarker();
            if (themeMarker && anyThemePending) {
                return true
            }
            return themeMarker === pendingThemeName
        }

        function processMarkup() {
            var $allThemeLinks = (0, _renderer.default)(DX_LINK_SELECTOR, context);
            if (!$allThemeLinks.length) {
                return
            }
            knownThemes = {};
            $activeThemeLink = (0, _renderer.default)((0, _html_parser.parseHTML)("<link rel=stylesheet>"), context);
            $allThemeLinks.each(function() {
                var link = (0, _renderer.default)(this, context);
                var fullThemeName = link.attr(THEME_ATTR);
                var url = link.attr("href");
                var isActive = "true" === link.attr(ACTIVE_ATTR);
                knownThemes[fullThemeName] = {
                    url: url,
                    isActive: isActive
                }
            });
            $allThemeLinks.last().after($activeThemeLink);
            $allThemeLinks.remove()
        }

        function resolveFullThemeName(desiredThemeName) {
            var desiredThemeParts = desiredThemeName ? desiredThemeName.split(".") : [];
            var result = null;
            if (knownThemes) {
                if (desiredThemeName in knownThemes) {
                    return desiredThemeName
                }(0, _iterator.each)(knownThemes, function(knownThemeName, themeData) {
                    var knownThemeParts = knownThemeName.split(".");
                    if (desiredThemeParts[0] && knownThemeParts[0] !== desiredThemeParts[0]) {
                        return
                    }
                    if (desiredThemeParts[1] && desiredThemeParts[1] !== knownThemeParts[1]) {
                        return
                    }
                    if (desiredThemeParts[2] && desiredThemeParts[2] !== knownThemeParts[2]) {
                        return
                    }
                    if (!result || themeData.isActive) {
                        result = knownThemeName
                    }
                    if (themeData.isActive) {
                        return false
                    }
                })
            }
            return result
        }

        function initContext(newContext) {
            try {
                if (newContext !== context) {
                    knownThemes = null
                }
            } catch (x) {
                knownThemes = null
            }
            context = newContext
        }

        function init(options) {
            options = options || {};
            initContext(options.context || _dom_adapter.default.getDocument());
            if (!context) {
                return
            }
            processMarkup();
            currentThemeName = void 0;
            current(options)
        }

        function current(options) {
            if (!arguments.length) {
                currentThemeName = currentThemeName || readThemeMarker();
                return currentThemeName
            }
            detachCssClasses(viewPort());
            options = options || {};
            if ("string" === typeof options) {
                options = {
                    theme: options
                }
            }
            var isAutoInit = options._autoInit;
            var loadCallback = options.loadCallback;
            var currentThemeData;
            currentThemeName = resolveFullThemeName(options.theme || currentThemeName);
            if (currentThemeName) {
                currentThemeData = knownThemes[currentThemeName]
            }
            if (loadCallback) {
                _themes_callback.themeReadyCallback.add(loadCallback)
            }
            if (currentThemeData) {
                $activeThemeLink.attr("href", knownThemes[currentThemeName].url);
                if (_themes_callback.themeReadyCallback.has() || "resolved" !== initDeferred.state() || options._forceTimeout) {
                    waitForThemeLoad(currentThemeName)
                }
            } else {
                if (isAutoInit) {
                    if ((0, _window.hasWindow)()) {
                        waitForThemeLoad(ANY_THEME)
                    }
                    _themes_callback.themeReadyCallback.fire();
                    _themes_callback.themeReadyCallback.empty()
                } else {
                    throw _ui.default.Error("E0021", currentThemeName)
                }
            }
            initDeferred.done(function() {
                return attachCssClasses((0, _view_port.originalViewPort)(), currentThemeName)
            })
        }

        function getCssClasses(themeName) {
            themeName = themeName || current();
            var result = [];
            var themeNameParts = themeName && themeName.split(".");
            if (themeNameParts) {
                result.push("dx-theme-" + themeNameParts[0], "dx-theme-" + themeNameParts[0] + "-typography");
                if (themeNameParts.length > 1) {
                    result.push("dx-color-scheme-" + themeNameParts[1] + (isMaterial(themeName) ? "-" + themeNameParts[2] : ""))
                }
            }
            return result
        }
        var themeClasses;

        function attachCssClasses(element, themeName) {
            themeClasses = getCssClasses(themeName).join(" ");
            (0, _renderer.default)(element).addClass(themeClasses);
            var activateHairlines = function() {
                var pixelRatio = (0, _window.hasWindow)() && window.devicePixelRatio;
                if (!pixelRatio || pixelRatio < 2) {
                    return
                }
                var $tester = (0, _renderer.default)("<div>");
                $tester.css("border", ".5px solid transparent");
                (0, _renderer.default)("body").append($tester);
                if (1 === $tester.outerHeight()) {
                    (0, _renderer.default)(element).addClass(DX_HAIRLINES_CLASS);
                    themeClasses += " " + DX_HAIRLINES_CLASS
                }
                $tester.remove()
            };
            activateHairlines()
        }

        function detachCssClasses(element) {
            (0, _renderer.default)(element).removeClass(themeClasses)
        }

        function themeReady(callback) {
            _themes_callback.themeReadyCallback.add(callback)
        }

        function isTheme(themeRegExp, themeName) {
            if (!themeName) {
                themeName = currentThemeName || readThemeMarker()
            }
            return new RegExp(themeRegExp).test(themeName)
        }

        function isMaterial(themeName) {
            return isTheme("material", themeName)
        }

        function isGeneric(themeName) {
            return isTheme("generic", themeName)
        }

        function isDark(themeName) {
            return isTheme("dark", themeName)
        }

        function isWebFontLoaded(text, fontWeight) {
            var testedFont = "Roboto, RobotoFallback, Arial";
            var etalonFont = "Arial";
            var document = _dom_adapter.default.getDocument();
            var testElement = document.createElement("span");
            testElement.style.position = "absolute";
            testElement.style.top = "-9999px";
            testElement.style.left = "-9999px";
            testElement.style.visibility = "hidden";
            testElement.style.fontFamily = etalonFont;
            testElement.style.fontSize = "250px";
            testElement.style.fontWeight = fontWeight;
            testElement.innerHTML = text;
            document.body.appendChild(testElement);
            var etalonFontWidth = testElement.offsetWidth;
            testElement.style.fontFamily = testedFont;
            var testedFontWidth = testElement.offsetWidth;
            testElement.parentNode.removeChild(testElement);
            return etalonFontWidth !== testedFontWidth
        }

        function waitWebFont(text, fontWeight) {
            var interval = 15;
            var timeout = 2e3;
            return new _promise.default(function(resolve) {
                var check = function() {
                    if (isWebFontLoaded(text, fontWeight)) {
                        clear()
                    }
                };
                var clear = function() {
                    clearInterval(intervalId);
                    clearTimeout(timeoutId);
                    resolve()
                };
                var intervalId = setInterval(check, interval);
                var timeoutId = setTimeout(clear, timeout)
            })
        }

        function autoInit() {
            init({
                _autoInit: true,
                _forceTimeout: true
            });
            if ((0, _renderer.default)(DX_LINK_SELECTOR, context).length) {
                throw _ui.default.Error("E0022")
            }
        }
        if ((0, _window.hasWindow)()) {
            autoInit()
        } else {
            ready(autoInit)
        }
        viewPortChanged.add(function(viewPort, prevViewPort) {
            initDeferred.done(function() {
                detachCssClasses(prevViewPort);
                attachCssClasses(viewPort)
            })
        });
        _devices.default.changed.add(function() {
            init({
                _autoInit: true
            })
        });

        function resetTheme() {
            $activeThemeLink && $activeThemeLink.attr("href", "about:blank");
            currentThemeName = null;
            pendingThemeName = null;
            initDeferred = new _deferred.Deferred
        }

        function initialized(callback) {
            initDeferred.done(callback)
        }

        function setDefaultTimeout(timeout) {
            defaultTimeout = timeout
        }
        var _default = {
            setDefaultTimeout: setDefaultTimeout,
            initialized: initialized,
            resetTheme: resetTheme,
            ready: themeReady,
            waitWebFont: waitWebFont,
            isWebFontLoaded: isWebFontLoaded,
            isDark: isDark,
            isGeneric: isGeneric,
            isMaterial: isMaterial,
            detachCssClasses: detachCssClasses,
            attachCssClasses: attachCssClasses,
            current: current,
            waitForThemeLoad: waitForThemeLoad,
            isPendingThemeLoaded: isPendingThemeLoaded
        };
        exports.default = _default
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.utils.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _filtering = _interopRequireDefault(__webpack_require__( /*! ../shared/filtering */ 182));
        var _string = __webpack_require__( /*! ../../core/utils/string */ 43);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _position = __webpack_require__( /*! ../../core/utils/position */ 22);
        var _data = __webpack_require__( /*! ../../core/utils/data */ 20);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _load_panel = _interopRequireDefault(__webpack_require__( /*! ../load_panel */ 180));
        var _utils = _interopRequireDefault(__webpack_require__( /*! ../../data/utils */ 41));
        var _format_helper = _interopRequireDefault(__webpack_require__( /*! ../../format_helper */ 71));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DATAGRID_SELECTION_DISABLED_CLASS = "dx-selection-disabled";
        var DATAGRID_GROUP_OPENED_CLASS = "dx-datagrid-group-opened";
        var DATAGRID_GROUP_CLOSED_CLASS = "dx-datagrid-group-closed";
        var DATAGRID_EXPAND_CLASS = "dx-datagrid-expand";
        var NO_DATA_CLASS = "nodata";
        var DATE_INTERVAL_SELECTORS = {
            year: function(value) {
                return value && value.getFullYear()
            },
            month: function(value) {
                return value && value.getMonth() + 1
            },
            day: function(value) {
                return value && value.getDate()
            },
            quarter: function(value) {
                return value && Math.floor(value.getMonth() / 3) + 1
            },
            hour: function(value) {
                return value && value.getHours()
            },
            minute: function(value) {
                return value && value.getMinutes()
            },
            second: function(value) {
                return value && value.getSeconds()
            }
        };
        var getIntervalSelector = function() {
            var data = arguments[1];
            var value = this.calculateCellValue(data);
            if (!(0, _type.isDefined)(value)) {
                return null
            } else {
                if (isDateType(this.dataType)) {
                    var nameIntervalSelector = arguments[0];
                    return DATE_INTERVAL_SELECTORS[nameIntervalSelector](value)
                } else {
                    if ("number" === this.dataType) {
                        var groupInterval = arguments[0];
                        return Math.floor(Number(value) / groupInterval) * groupInterval
                    }
                }
            }
        };
        var equalSelectors = function(selector1, selector2) {
            if ((0, _type.isFunction)(selector1) && (0, _type.isFunction)(selector2)) {
                if (selector1.originalCallback && selector2.originalCallback) {
                    return selector1.originalCallback === selector2.originalCallback && selector1.columnIndex === selector2.columnIndex
                }
            }
            return selector1 === selector2
        };

        function isDateType(dataType) {
            return "date" === dataType || "datetime" === dataType
        }
        var setEmptyText = function($container) {
            $container.get(0).textContent = "\xa0"
        };
        var normalizeSortingInfo = function(sort) {
            sort = sort || [];
            var result = _utils.default.normalizeSortingInfo(sort);
            for (var i = 0; i < sort.length; i++) {
                if (sort && sort[i] && void 0 !== sort[i].isExpanded) {
                    result[i].isExpanded = sort[i].isExpanded
                }
                if (sort && sort[i] && void 0 !== sort[i].groupInterval) {
                    result[i].groupInterval = sort[i].groupInterval
                }
            }
            return result
        };
        var formatValue = function(value, options) {
            var valueText = _format_helper.default.format(value, options.format) || value && value.toString() || "";
            var formatObject = {
                value: value,
                valueText: options.getDisplayFormat ? options.getDisplayFormat(valueText) : valueText,
                target: options.target || "row",
                groupInterval: options.groupInterval
            };
            return options.customizeText ? options.customizeText.call(options, formatObject) : formatObject.valueText
        };
        var getSummaryText = function(summaryItem, summaryTexts) {
            var displayFormat = summaryItem.displayFormat || summaryItem.columnCaption && summaryTexts[summaryItem.summaryType + "OtherColumn"] || summaryTexts[summaryItem.summaryType];
            return formatValue(summaryItem.value, {
                format: summaryItem.valueFormat,
                getDisplayFormat: function(valueText) {
                    return displayFormat ? (0, _string.format)(displayFormat, valueText, summaryItem.columnCaption) : valueText
                },
                customizeText: summaryItem.customizeText
            })
        };
        var getWidgetInstance = function($element) {
            var editorData = $element.data && $element.data();
            var dxComponents = editorData && editorData.dxComponents;
            var widgetName = dxComponents && dxComponents[0];
            return widgetName && editorData[widgetName]
        };
        var equalFilterParameters = function equalFilterParameters(filter1, filter2) {
            if (Array.isArray(filter1) && Array.isArray(filter2)) {
                if (filter1.length !== filter2.length) {
                    return false
                } else {
                    for (var i = 0; i < filter1.length; i++) {
                        if (!equalFilterParameters(filter1[i], filter2[i])) {
                            return false
                        }
                    }
                }
                return true
            } else {
                if ((0, _type.isFunction)(filter1) && filter1.columnIndex >= 0 && (0, _type.isFunction)(filter2) && filter2.columnIndex >= 0) {
                    return filter1.columnIndex === filter2.columnIndex && (0, _data.toComparable)(filter1.filterValue) === (0, _data.toComparable)(filter2.filterValue)
                } else {
                    return (0, _data.toComparable)(filter1) == (0, _data.toComparable)(filter2)
                }
            }
        };
        var _default = {
            renderNoDataText: function($element) {
                var that = this;
                $element = $element || this.element();
                if (!$element) {
                    return
                }
                var noDataClass = that.addWidgetPrefix(NO_DATA_CLASS);
                var noDataElement = $element.find("." + noDataClass).last();
                var isVisible = this._dataController.isEmpty();
                var isLoading = this._dataController.isLoading();
                if (!noDataElement.length) {
                    noDataElement = (0, _renderer.default)("<span>").addClass(noDataClass).appendTo($element)
                }
                if (isVisible && !isLoading) {
                    noDataElement.removeClass("dx-hidden").text(that._getNoDataText())
                } else {
                    noDataElement.addClass("dx-hidden")
                }
            },
            renderLoadPanel: function($element, $container, isLocalStore) {
                var that = this;
                var loadPanelOptions;
                that._loadPanel && that._loadPanel.$element().remove();
                loadPanelOptions = that.option("loadPanel");
                if (loadPanelOptions && ("auto" === loadPanelOptions.enabled ? !isLocalStore : loadPanelOptions.enabled)) {
                    loadPanelOptions = (0, _extend.extend)({
                        shading: false,
                        message: loadPanelOptions.text,
                        position: function() {
                            var $window = (0, _renderer.default)((0, _window.getWindow)());
                            if ($element.height() > $window.height()) {
                                return {
                                    of: $window,
                                    boundary: $element,
                                    collision: "fit"
                                }
                            }
                            return {
                                of: $element
                            }
                        },
                        container: $container
                    }, loadPanelOptions);
                    that._loadPanel = that._createComponent((0, _renderer.default)("<div>").appendTo($container), _load_panel.default, loadPanelOptions)
                } else {
                    that._loadPanel = null
                }
            },
            getIndexByKey: function(key, items, keyName) {
                var index = -1;
                if (void 0 !== key && Array.isArray(items)) {
                    keyName = arguments.length <= 2 ? "key" : keyName;
                    for (var i = 0; i < items.length; i++) {
                        var item = (0, _type.isDefined)(keyName) ? items[i][keyName] : items[i];
                        if ((0, _common.equalByValue)(key, item)) {
                            index = i;
                            break
                        }
                    }
                }
                return index
            },
            combineFilters: function(filters, operation) {
                var resultFilter = [];
                operation = operation || "and";
                for (var i = 0; i < filters.length; i++) {
                    if (!filters[i]) {
                        continue
                    }
                    if (resultFilter.length) {
                        resultFilter.push(operation)
                    }
                    resultFilter.push(filters[i])
                }
                if (1 === resultFilter.length) {
                    resultFilter = resultFilter[0]
                }
                if (resultFilter.length) {
                    return resultFilter
                }
            },
            checkChanges: function(changes, changeNames) {
                var changesWithChangeNamesCount = 0;
                for (var i = 0; i < changeNames.length; i++) {
                    if (changes[changeNames[i]]) {
                        changesWithChangeNamesCount++
                    }
                }
                return changes.length && changes.length === changesWithChangeNamesCount
            },
            equalFilterParameters: equalFilterParameters,
            proxyMethod: function(instance, methodName, defaultResult) {
                if (!instance[methodName]) {
                    instance[methodName] = function() {
                        var dataSource = this._dataSource;
                        return dataSource ? dataSource[methodName].apply(dataSource, arguments) : defaultResult
                    }
                }
            },
            formatValue: formatValue,
            getFormatOptionsByColumn: function(column, target) {
                return {
                    format: column.format,
                    getDisplayFormat: column.getDisplayFormat,
                    customizeText: column.customizeText,
                    target: target,
                    trueText: column.trueText,
                    falseText: column.falseText
                }
            },
            getDisplayValue: function(column, value, data, rowType) {
                if (column.displayValueMap && void 0 !== column.displayValueMap[value]) {
                    return column.displayValueMap[value]
                } else {
                    if (column.calculateDisplayValue && data && "group" !== rowType) {
                        return column.calculateDisplayValue(data)
                    } else {
                        if (column.lookup && !("group" === rowType && (column.calculateGroupValue || column.calculateDisplayValue))) {
                            return column.lookup.calculateCellValue(value)
                        }
                    }
                }
                return value
            },
            getGroupRowSummaryText: function(summaryItems, summaryTexts) {
                var result = "(";
                for (var i = 0; i < summaryItems.length; i++) {
                    var summaryItem = summaryItems[i];
                    result += (i > 0 ? ", " : "") + getSummaryText(summaryItem, summaryTexts)
                }
                return result += ")"
            },
            getSummaryText: getSummaryText,
            normalizeSortingInfo: normalizeSortingInfo,
            getFormatByDataType: function(dataType) {
                switch (dataType) {
                    case "date":
                        return "shortDate";
                    case "datetime":
                        return "shortDateShortTime"
                }
            },
            getHeaderFilterGroupParameters: function(column, remoteGrouping) {
                var result = [];
                var dataField = column.dataField || column.name;
                var groupInterval = _filtering.default.getGroupInterval(column);
                if (groupInterval) {
                    (0, _iterator.each)(groupInterval, function(index, interval) {
                        result.push(remoteGrouping ? {
                            selector: dataField,
                            groupInterval: interval,
                            isExpanded: index < groupInterval.length - 1
                        } : getIntervalSelector.bind(column, interval))
                    });
                    return result
                }
                if (remoteGrouping) {
                    result = [{
                        selector: dataField,
                        isExpanded: false
                    }]
                } else {
                    result = function result(data) {
                        var result = column.calculateCellValue(data);
                        if (void 0 === result || "" === result) {
                            result = null
                        }
                        return result
                    };
                    if (column.sortingMethod) {
                        result = [{
                            selector: result,
                            compare: column.sortingMethod.bind(column)
                        }]
                    }
                }
                return result
            },
            equalSortParameters: function(sortParameters1, sortParameters2, ignoreIsExpanded) {
                sortParameters1 = normalizeSortingInfo(sortParameters1);
                sortParameters2 = normalizeSortingInfo(sortParameters2);
                if (Array.isArray(sortParameters1) && Array.isArray(sortParameters2)) {
                    if (sortParameters1.length !== sortParameters2.length) {
                        return false
                    } else {
                        for (var i = 0; i < sortParameters1.length; i++) {
                            if (!equalSelectors(sortParameters1[i].selector, sortParameters2[i].selector) || sortParameters1[i].desc !== sortParameters2[i].desc || sortParameters1[i].groupInterval !== sortParameters2[i].groupInterval || !ignoreIsExpanded && Boolean(sortParameters1[i].isExpanded) !== Boolean(sortParameters2[i].isExpanded)) {
                                return false
                            }
                        }
                    }
                    return true
                } else {
                    return (!sortParameters1 || !sortParameters1.length) === (!sortParameters2 || !sortParameters2.length)
                }
            },
            getPointsByColumns: function(items, pointCreated, isVertical, startColumnIndex) {
                var cellsLength = items.length;
                var notCreatePoint = false;
                var item;
                var offset;
                var columnIndex = startColumnIndex || 0;
                var result = [];
                var rtlEnabled;
                for (var i = 0; i <= cellsLength; i++) {
                    if (i < cellsLength) {
                        item = items.eq(i);
                        offset = item.offset();
                        rtlEnabled = "rtl" === item.css("direction")
                    }
                    var point = {
                        index: columnIndex,
                        x: offset ? offset.left + (!isVertical && rtlEnabled ^ i === cellsLength ? (0, _position.getBoundingRect)(item[0]).width : 0) : 0,
                        y: offset ? offset.top + (isVertical && i === cellsLength ? (0, _position.getBoundingRect)(item[0]).height : 0) : 0,
                        columnIndex: columnIndex
                    };
                    if (!isVertical && i > 0) {
                        var prevItemOffset = items.eq(i - 1).offset();
                        if (prevItemOffset.top < point.y) {
                            point.y = prevItemOffset.top
                        }
                    }
                    if (pointCreated) {
                        notCreatePoint = pointCreated(point)
                    }
                    if (!notCreatePoint) {
                        result.push(point)
                    }
                    columnIndex++
                }
                return result
            },
            getExpandCellTemplate: function() {
                return {
                    allowRenderToDetachedContainer: true,
                    render: function(container, options) {
                        var $container = (0, _renderer.default)(container);
                        if ((0, _type.isDefined)(options.value) && !(options.data && options.data.isContinuation) && !options.row.isNewRow) {
                            var rowsView = options.component.getView("rowsView");
                            $container.addClass(DATAGRID_EXPAND_CLASS).addClass(DATAGRID_SELECTION_DISABLED_CLASS);
                            (0, _renderer.default)("<div>").addClass(options.value ? DATAGRID_GROUP_OPENED_CLASS : DATAGRID_GROUP_CLOSED_CLASS).appendTo($container);
                            rowsView.setAria("label", options.value ? rowsView.localize("dxDataGrid-ariaCollapse") : rowsView.localize("dxDataGrid-ariaExpand"), $container)
                        } else {
                            setEmptyText($container)
                        }
                    }
                }
            },
            setEmptyText: setEmptyText,
            isDateType: isDateType,
            getSelectionRange: function(focusedElement) {
                try {
                    if (focusedElement) {
                        return {
                            selectionStart: focusedElement.selectionStart,
                            selectionEnd: focusedElement.selectionEnd
                        }
                    }
                } catch (e) {}
                return {}
            },
            setSelectionRange: function(focusedElement, selectionRange) {
                try {
                    if (focusedElement && focusedElement.setSelectionRange) {
                        focusedElement.setSelectionRange(selectionRange.selectionStart, selectionRange.selectionEnd)
                    }
                } catch (e) {}
            },
            focusAndSelectElement: function(component, $element) {
                _events_engine.default.trigger($element, "focus");
                var isSelectTextOnEditingStart = component.option("editing.selectTextOnEditStart");
                var keyboardController = component.getController("keyboardNavigation");
                var isEditingNavigationMode = keyboardController && keyboardController._isFastEditingStarted();
                var element = $element.get(0);
                if (isSelectTextOnEditingStart && !isEditingNavigationMode && $element.is(".dx-texteditor-input") && !$element.is("[readonly]")) {
                    var editor = getWidgetInstance($element.closest(".dx-texteditor"));
                    (0, _deferred.when)(editor && editor._loadItemDeferred).done(function() {
                        element.select()
                    })
                }
            },
            getWidgetInstance: getWidgetInstance,
            getLastResizableColumnIndex: function(columns, resultWidths) {
                var hasResizableColumns = columns.some(function(column) {
                    return column && !column.command && !column.fixed && false !== column.allowResizing
                });
                var lastColumnIndex;
                for (lastColumnIndex = columns.length - 1; columns[lastColumnIndex]; lastColumnIndex--) {
                    var column = columns[lastColumnIndex];
                    var width = resultWidths && resultWidths[lastColumnIndex];
                    var allowResizing = !hasResizableColumns || false !== column.allowResizing;
                    if (!column.command && !column.fixed && "adaptiveHidden" !== width && allowResizing) {
                        break
                    }
                }
                return lastColumnIndex
            },
            isElementInCurrentGrid: function(controller, $element) {
                if ($element && $element.length) {
                    var $grid = $element.closest("." + controller.getWidgetContainerClass()).parent();
                    return $grid.is(controller.component.$element())
                }
                return false
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************!*\
      !*** ./artifacts/transpiled-npm/core/guid.js ***!
      \***********************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _class = _interopRequireDefault(__webpack_require__( /*! ./class */ 15));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var Guid = _class.default.inherit({
            ctor: function(value) {
                if (value) {
                    value = String(value)
                }
                this._value = this._normalize(value || this._generate())
            },
            _normalize: function(value) {
                value = value.replace(/[^a-f0-9]/gi, "").toLowerCase();
                while (value.length < 32) {
                    value += "0"
                }
                return [value.substr(0, 8), value.substr(8, 4), value.substr(12, 4), value.substr(16, 4), value.substr(20, 12)].join("-")
            },
            _generate: function() {
                var value = "";
                for (var i = 0; i < 32; i++) {
                    value += Math.round(15 * Math.random()).toString(16)
                }
                return value
            },
            toString: function() {
                return this._value
            },
            valueOf: function() {
                return this._value
            },
            toJSON: function() {
                return this._value
            }
        });
        var _default = Guid;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************!*\
      !*** ./artifacts/transpiled-npm/ui/button.js ***!
      \***********************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../core/devices */ 13));
        var _utils = __webpack_require__( /*! ./widget/utils.ink_ripple */ 82);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _themes = __webpack_require__( /*! ./themes */ 34);
        var _action = _interopRequireDefault(__webpack_require__( /*! ../core/action */ 111));
        var _validation_engine = _interopRequireDefault(__webpack_require__( /*! ./validation_engine */ 96));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./widget/ui.widget */ 16));
        var _short = __webpack_require__( /*! ../events/short */ 128);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _function_template = __webpack_require__( /*! ../core/templates/function_template */ 126);
        var _icon = __webpack_require__( /*! ../core/utils/icon */ 56);
        var _element = __webpack_require__( /*! ../core/element */ 18);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var ANONYMOUS_TEMPLATE_NAME = "content";
        var Button = function(_Widget) {
            _inheritsLoose(Button, _Widget);

            function Button() {
                var _this;
                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key]
                }
                _this = _Widget.call.apply(_Widget, [this].concat(args)) || this;
                _this._feedbackHideTimeout = 100;
                return _this
            }
            var _proto = Button.prototype;
            _proto._$content = function() {
                return this.$element().find(".dx-button-content")
            };
            _proto._$submitInput = function() {
                return this.$element().find(".dx-button-submit-input")
            };
            _proto._attachActiveEvents = function(active, inactive) {
                var $el = this._eventBindingTarget();
                var namespace = "inkRipple";
                var selector = this._activeStateUnit;
                _short.active.off($el, {
                    namespace: namespace,
                    selector: selector
                });
                _short.active.on($el, new _action.default(active), new _action.default(inactive, {
                    excludeValidators: ["disabled", "readOnly"]
                }), {
                    showTimeout: this._feedbackShowTimeout,
                    hideTimeout: this._feedbackHideTimeout,
                    selector: selector,
                    namespace: namespace
                })
            };
            _proto._defaultOptionsRules = function() {
                return _Widget.prototype._defaultOptionsRules.call(this).concat([{
                    device: function() {
                        return "desktop" === _devices.default.real().deviceType && !_devices.default.isSimulator()
                    },
                    options: {
                        focusStateEnabled: true
                    }
                }, {
                    device: function() {
                        return (0, _themes.isMaterial)((0, _themes.current)())
                    },
                    options: {
                        useInkRipple: true
                    }
                }])
            };
            _proto._executeClickAction = function(event) {
                this._clickAction({
                    validationGroup: this._validationGroupConfig,
                    event: event
                })
            };
            _proto._findGroup = function() {
                var $element = this.$element();
                var model = this._modelByElement($element);
                var _this$option = this.option(),
                    validationGroup = _this$option.validationGroup;
                return validationGroup || _validation_engine.default.findGroup($element, model)
            };
            _proto._getContentData = function() {
                var _this$option2 = this.option(),
                    icon = _this$option2.icon,
                    text = _this$option2.text,
                    type = _this$option2.type,
                    _templateData = _this$option2._templateData;
                return (0, _extend.extend)({
                    icon: "back" === type && !icon ? "back" : icon,
                    text: text
                }, _templateData)
            };
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_Widget.prototype._getDefaultOptions.call(this), {
                    hoverStateEnabled: true,
                    onClick: null,
                    type: "normal",
                    text: "",
                    icon: "",
                    iconPosition: "left",
                    validationGroup: void 0,
                    activeStateEnabled: true,
                    template: "content",
                    useSubmitBehavior: false,
                    useInkRipple: false,
                    _templateData: {},
                    stylingMode: "contained"
                })
            };
            _proto._getSubmitAction = function() {
                var _this2 = this;
                var needValidate = true;
                var validationStatus = "valid";
                return this._createAction(function(_ref) {
                    var event = _ref.event;
                    if (needValidate) {
                        var validationGroup = _this2._validationGroupConfig;
                        if (validationGroup) {
                            var _validationGroup$vali = validationGroup.validate(),
                                status = _validationGroup$vali.status,
                                complete = _validationGroup$vali.complete;
                            validationStatus = status;
                            if ("pending" === status) {
                                needValidate = false;
                                _this2.option("disabled", true);
                                complete.then(function(_ref2) {
                                    var status = _ref2.status;
                                    _this2.option("disabled", false);
                                    validationStatus = status;
                                    "valid" === validationStatus && _this2._submitInput().click();
                                    needValidate = true
                                })
                            }
                        }
                    }
                    "valid" !== validationStatus && event.preventDefault();
                    event.stopPropagation()
                })
            };
            _proto._initMarkup = function() {
                this.$element().addClass("dx-button");
                this._renderType();
                this._renderStylingMode();
                this._renderInkRipple();
                this._renderClick();
                this._updateAriaLabel();
                _Widget.prototype._initMarkup.call(this);
                this._updateContent();
                this.setAria("role", "button")
            };
            _proto._getAnonymousTemplateName = function() {
                return ANONYMOUS_TEMPLATE_NAME
            };
            _proto._initTemplates = function() {
                var _this3 = this;
                this._templateManager.addDefaultTemplates({
                    content: new _function_template.FunctionTemplate(function(_ref3) {
                        var _ref3$model = _ref3.model,
                            model = void 0 === _ref3$model ? {} : _ref3$model,
                            container = _ref3.container;
                        var text = model.text,
                            icon = model.icon;
                        var _this3$option = _this3.option(),
                            iconPosition = _this3$option.iconPosition;
                        var $icon = (0, _icon.getImageContainer)(icon);
                        var $textContainer = text && (0, _renderer.default)("<span>").text(text).addClass("dx-button-text");
                        var $container = (0, _renderer.default)(container);
                        $container.append($textContainer);
                        if ("left" === iconPosition) {
                            $container.prepend($icon)
                        } else {
                            $icon.addClass("dx-icon-right");
                            $container.append($icon)
                        }
                    })
                });
                _Widget.prototype._initTemplates.call(this)
            };
            _proto._optionChanged = function(args) {
                var name = args.name;
                switch (name) {
                    case "onClick":
                        this._updateClick();
                        break;
                    case "icon":
                    case "text":
                        this._updateContent();
                        this._updateAriaLabel();
                        break;
                    case "type":
                        this._updateType();
                        this._updateContent();
                        break;
                    case "_templateData":
                        break;
                    case "template":
                    case "iconPosition":
                        this._updateContent();
                        break;
                    case "stylingMode":
                        this._updateStylingMode();
                        break;
                    case "useSubmitBehavior":
                        this._updateSubmitInput();
                        break;
                    case "useInkRipple":
                        this._invalidate();
                        break;
                    default:
                        _Widget.prototype._optionChanged.call(this, args)
                }
            };
            _proto._renderClick = function() {
                var _this4 = this;
                var $el = this.$element();
                _short.dxClick.off($el, {
                    namespace: this.NAME
                });
                _short.dxClick.on($el, function(event) {
                    return _this4._executeClickAction(event)
                }, {
                    namespace: this.NAME
                });
                this._updateClick()
            };
            _proto._renderInkRipple = function() {
                var _this5 = this;
                var _this$option3 = this.option(),
                    text = _this$option3.text,
                    icon = _this$option3.icon,
                    type = _this$option3.type,
                    useInkRipple = _this$option3.useInkRipple;
                if (useInkRipple) {
                    var isOnlyIconButton = !text && icon || "back" === type;
                    var _inkRipple = (0, _utils.render)(isOnlyIconButton ? {
                        waveSizeCoefficient: 1,
                        useHoldAnimation: false,
                        isCentered: true
                    } : {});
                    var changeWaveVisibility = function(event, visible) {
                        var _this5$option = _this5.option(),
                            activeStateEnabled = _this5$option.activeStateEnabled,
                            useInkRipple = _this5$option.useInkRipple;
                        if (useInkRipple && activeStateEnabled && !_this5._disposed) {
                            var config = {
                                element: _this5._$content(),
                                event: event
                            };
                            visible ? _inkRipple.showWave(config) : _inkRipple.hideWave(config)
                        }
                    };
                    this._attachActiveEvents(function(_ref4) {
                        var event = _ref4.event;
                        return changeWaveVisibility(event, true)
                    }, function(_ref5) {
                        var event = _ref5.event;
                        return changeWaveVisibility(event)
                    })
                }
            };
            _proto._renderStylingMode = function() {
                var $element = this.$element();
                var _this$option4 = this.option(),
                    stylingMode = _this$option4.stylingMode;
                if (["contained", "text", "outlined"].indexOf(stylingMode) === -1) {
                    stylingMode = this._getDefaultOptions().stylingMode
                }
                $element.addClass("dx-button-mode-".concat(stylingMode))
            };
            _proto._renderSubmitInput = function() {
                var _this$option5 = this.option(),
                    useSubmitBehavior = _this$option5.useSubmitBehavior;
                if (useSubmitBehavior) {
                    var submitAction = this._getSubmitAction();
                    var $content = this._$content();
                    (0, _renderer.default)("<input>").attr("type", "submit").attr("tabindex", -1).addClass("dx-button-submit-input").appendTo($content);
                    _short.click.on(this._$submitInput(), function(event) {
                        return submitAction({
                            event: event
                        })
                    })
                }
            };
            _proto._renderType = function() {
                var _this$option6 = this.option(),
                    type = _this$option6.type;
                var $element = this.$element();
                type && $element.addClass("dx-button-".concat(type))
            };
            _proto._submitInput = function() {
                return this._$submitInput().get(0)
            };
            _proto._supportedKeys = function() {
                var _this6 = this;
                var click = function(e) {
                    e.preventDefault();
                    _this6._executeClickAction(e)
                };
                return (0, _extend.extend)(_Widget.prototype._supportedKeys.call(this), {
                    space: click,
                    enter: click
                })
            };
            _proto._updateAriaLabel = function() {
                var ariaTarget = this._getAriaTarget();
                var _this$option7 = this.option(),
                    icon = _this$option7.icon,
                    text = _this$option7.text;
                if (!text) {
                    if ("image" === (0, _icon.getImageSourceType)(icon)) {
                        icon = icon.indexOf("base64") === -1 ? icon.replace(/.+\/([^.]+)\..+$/, "$1") : "Base64"
                    }
                    text = icon || ""
                }
                ariaTarget.attr("aria-label", text || null)
            };
            _proto._updateClick = function() {
                var _this7 = this;
                this._clickAction = this._createActionByOption("onClick", {
                    excludeValidators: ["readOnly"],
                    afterExecute: function() {
                        var _this7$option = _this7.option(),
                            useSubmitBehavior = _this7$option.useSubmitBehavior;
                        useSubmitBehavior && setTimeout(function() {
                            return _this7._submitInput().click()
                        })
                    }
                })
            };
            _proto._updateContent = function() {
                var $element = this.$element();
                var $content = this._$content();
                var data = this._getContentData();
                var _this$option8 = this.option(),
                    template = _this$option8.template,
                    iconPosition = _this$option8.iconPosition;
                var icon = data.icon,
                    text = data.text;
                $content.length ? $content.empty() : $content = (0, _renderer.default)("<div>").addClass("dx-button-content").appendTo($element);
                $element.toggleClass("dx-button-has-icon", !!icon).toggleClass("dx-button-icon-right", !!icon && "left" !== iconPosition).toggleClass("dx-button-has-text", !!text);
                var $template = (0, _renderer.default)(this._getTemplateByOption("template").render({
                    model: data,
                    container: (0, _element.getPublicElement)($content),
                    transclude: this._templateManager.anonymousTemplateName === template
                }));
                if ($template.hasClass("dx-template-wrapper")) {
                    $template.addClass("dx-button-content");
                    $content.replaceWith($template)
                }
                this._updateSubmitInput()
            };
            _proto._updateSubmitInput = function() {
                var _this$option9 = this.option(),
                    useSubmitBehavior = _this$option9.useSubmitBehavior;
                var $submitInput = this._$submitInput();
                if (!useSubmitBehavior && $submitInput.length) {
                    $submitInput.remove()
                } else {
                    if (useSubmitBehavior && !$submitInput.length) {
                        this._renderSubmitInput()
                    }
                }
            };
            _proto._updateStylingMode = function() {
                var $element = this.$element();
                ["contained", "text", "outlined"].map(function(mode) {
                    return "dx-button-mode-".concat(mode)
                }).forEach($element.removeClass.bind($element));
                this._renderStylingMode()
            };
            _proto._updateType = function() {
                var $element = this.$element();
                ["back", "danger", "default", "normal", "success"].map(function(type) {
                    return "dx-button-".concat(type)
                }).forEach($element.removeClass.bind($element));
                this._renderType()
            };
            _createClass(Button, [{
                key: "_validationGroupConfig",
                get: function() {
                    return _validation_engine.default.getGroupConfig(this._findGroup())
                }
            }]);
            return Button
        }(_ui.default);
        (0, _component_registrator.default)("dxButton", Button);
        var _default = Button;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************!*\
      !*** ./artifacts/transpiled-npm/data/errors.js ***!
      \*************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _error = _interopRequireDefault(__webpack_require__( /*! ../core/utils/error */ 146));
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../core/errors */ 25));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var handlers = {};
        var errors = (0, _error.default)(_errors.default.ERROR_MESSAGES, {
            E4000: "[DevExpress.data]: {0}",
            E4001: "Unknown aggregating function is detected: '{0}'",
            E4002: "Unsupported OData protocol version is used",
            E4003: "Unknown filter operation is used: {0}",
            E4004: "The thenby() method is called before the sortby() method",
            E4005: "Store requires a key expression for this operation",
            E4006: "ArrayStore 'data' option must be an array",
            E4007: "Compound keys cannot be auto-generated",
            E4008: "Attempt to insert an item with a duplicated key",
            E4009: "Data item cannot be found",
            E4010: "CustomStore does not support creating queries",
            E4011: "Custom Store method is not implemented or is not a function: {0}",
            E4012: "Custom Store method returns an invalid value: {0}",
            E4013: "Local Store requires the 'name' configuration option is specified",
            E4014: "Unknown data type is specified for ODataStore: {0}",
            E4015: "Unknown entity name or alias is used: {0}",
            E4016: "The compileSetter(expr) method is called with 'self' passed as a parameter",
            E4017: "Keys cannot be modified",
            E4018: "The server has returned a non-numeric value in a response to an item count request",
            E4019: "Mixing of group operators inside a single group of filter expression is not allowed",
            E4020: "Unknown store type is detected: {0}",
            E4021: "The server response does not provide the totalCount value",
            E4022: "The server response does not provide the groupCount value",
            E4023: "Could not parse the following XML: {0}",
            E4024: "String function {0} cannot be used with the data field {1} of type {2}.",
            W4000: "Data returned from the server has an incorrect structure",
            W4001: 'The {0} field is listed in both "keyType" and "fieldTypes". The value of "fieldTypes" is used.',
            W4002: "Data loading has failed for some cells due to the following error: {0}"
        });
        var errorHandler = null;
        var _errorHandler = function(error) {
            if (handlers.errorHandler) {
                handlers.errorHandler(error)
            }
        };
        handlers = {
            errors: errors,
            errorHandler: errorHandler,
            _errorHandler: _errorHandler
        };
        var _default = handlers;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/inflector.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.captionize = exports.titleize = exports.humanize = exports.camelize = exports.underscore = exports.dasherize = void 0;
        var _iterator = __webpack_require__( /*! ./iterator */ 3);
        var _normalize = function(text) {
            if (void 0 === text || null === text) {
                return ""
            }
            return String(text)
        };
        var _upperCaseFirst = function(text) {
            return _normalize(text).charAt(0).toUpperCase() + text.substr(1)
        };
        var _chop = function(text) {
            return _normalize(text).replace(/([a-z\d])([A-Z])/g, "$1 $2").split(/[\s_-]+/)
        };
        var dasherize = function(text) {
            return (0, _iterator.map)(_chop(text), function(p) {
                return p.toLowerCase()
            }).join("-")
        };
        exports.dasherize = dasherize;
        var underscore = function(text) {
            return dasherize(text).replace(/-/g, "_")
        };
        exports.underscore = underscore;
        var camelize = function(text, upperFirst) {
            return (0, _iterator.map)(_chop(text), function(p, i) {
                p = p.toLowerCase();
                if (upperFirst || i > 0) {
                    p = _upperCaseFirst(p)
                }
                return p
            }).join("")
        };
        exports.camelize = camelize;
        var humanize = function(text) {
            return _upperCaseFirst(dasherize(text).replace(/-/g, " "))
        };
        exports.humanize = humanize;
        var titleize = function(text) {
            return (0, _iterator.map)(_chop(text), function(p) {
                return _upperCaseFirst(p.toLowerCase())
            }).join(" ")
        };
        exports.titleize = titleize;
        var DIGIT_CHARS = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
        var captionize = function(name) {
            var captionList = [];
            var i;
            var char;
            var isPrevCharNewWord = false;
            var isNewWord = false;
            for (i = 0; i < name.length; i++) {
                char = name.charAt(i);
                isNewWord = char === char.toUpperCase() && "-" !== char && ")" !== char && "/" !== char || char in DIGIT_CHARS;
                if ("_" === char || "." === char) {
                    char = " ";
                    isNewWord = true
                } else {
                    if (0 === i) {
                        char = char.toUpperCase();
                        isNewWord = true
                    } else {
                        if (!isPrevCharNewWord && isNewWord) {
                            if (captionList.length > 0) {
                                captionList.push(" ")
                            }
                        }
                    }
                }
                captionList.push(char);
                isPrevCharNewWord = isNewWord
            }
            return captionList.join("")
        };
        exports.captionize = captionize
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/core/element_data.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getDataStrategy = getDataStrategy;
        exports.data = data;
        exports.beforeCleanData = beforeCleanData;
        exports.afterCleanData = afterCleanData;
        exports.cleanData = cleanData;
        exports.removeData = removeData;
        exports.cleanDataRecursive = cleanDataRecursive;
        exports.setDataStrategy = exports.strategyChanging = void 0;
        var _weak_map = _interopRequireDefault(__webpack_require__( /*! ./polyfills/weak_map */ 196));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ./dom_adapter */ 11));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _memorized_callbacks = _interopRequireDefault(__webpack_require__( /*! ./memorized_callbacks */ 197));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var dataMap = new _weak_map.default;
        var strategy;
        var strategyChanging = new _memorized_callbacks.default;
        exports.strategyChanging = strategyChanging;
        var beforeCleanDataFunc = function() {};
        var afterCleanDataFunc = function() {};
        var setDataStrategy = function(value) {
            strategyChanging.fire(value);
            strategy = value;
            var cleanData = strategy.cleanData;
            strategy.cleanData = function(nodes) {
                beforeCleanDataFunc(nodes);
                var result = cleanData.call(this, nodes);
                afterCleanDataFunc(nodes);
                return result
            }
        };
        exports.setDataStrategy = setDataStrategy;
        setDataStrategy({
            data: function() {
                var element = arguments[0];
                var key = arguments[1];
                var value = arguments[2];
                if (!element) {
                    return
                }
                var elementData = dataMap.get(element);
                if (!elementData) {
                    elementData = {};
                    dataMap.set(element, elementData)
                }
                if (void 0 === key) {
                    return elementData
                }
                if (2 === arguments.length) {
                    return elementData[key]
                }
                elementData[key] = value;
                return value
            },
            removeData: function(element, key) {
                if (!element) {
                    return
                }
                if (void 0 === key) {
                    dataMap.delete(element)
                } else {
                    var elementData = dataMap.get(element);
                    if (elementData) {
                        delete elementData[key]
                    }
                }
            },
            cleanData: function(elements) {
                for (var i = 0; i < elements.length; i++) {
                    _events_engine.default.off(elements[i]);
                    dataMap.delete(elements[i])
                }
            }
        });

        function getDataStrategy() {
            return strategy
        }

        function data() {
            return strategy.data.apply(this, arguments)
        }

        function beforeCleanData(callback) {
            beforeCleanDataFunc = callback
        }

        function afterCleanData(callback) {
            afterCleanDataFunc = callback
        }

        function cleanData(nodes) {
            return strategy.cleanData.call(this, nodes)
        }

        function removeData(element, key) {
            return strategy.removeData.call(this, element, key)
        }

        function cleanDataRecursive(element, cleanSelf) {
            if (!_dom_adapter.default.isElementNode(element)) {
                return
            }
            var childElements = element.getElementsByTagName("*");
            strategy.cleanData(childElements);
            if (cleanSelf) {
                strategy.cleanData([element])
            }
        }
    },
    /*!************************************************!*\
      !*** ./artifacts/transpiled-npm/data/utils.js ***!
      \************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../core/dom_adapter */ 11));
        var _ready_callbacks = _interopRequireDefault(__webpack_require__( /*! ../core/utils/ready_callbacks */ 49));
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }
        var ready = _ready_callbacks.default.add;
        var XHR_ERROR_UNLOAD = "DEVEXTREME_XHR_ERROR_UNLOAD";
        var normalizeBinaryCriterion = function(crit) {
            return [crit[0], crit.length < 3 ? "=" : String(crit[1]).toLowerCase(), crit.length < 2 ? true : crit[crit.length - 1]]
        };
        var normalizeSortingInfo = function(info) {
            if (!Array.isArray(info)) {
                info = [info]
            }
            return (0, _iterator.map)(info, function(i) {
                var result = {
                    selector: (0, _type.isFunction)(i) || "string" === typeof i ? i : i.getter || i.field || i.selector,
                    desc: !!(i.desc || "d" === String(i.dir).charAt(0).toLowerCase())
                };
                if (i.compare) {
                    result.compare = i.compare
                }
                return result
            })
        };
        var errorMessageFromXhr = function() {
            var textStatusMessages = {
                timeout: "Network connection timeout",
                error: "Unspecified network error",
                parsererror: "Unexpected server response"
            };
            var explainTextStatus = function(textStatus) {
                var result = textStatusMessages[textStatus];
                if (!result) {
                    return textStatus
                }
                return result
            };
            var unloading;
            ready(function() {
                var window = (0, _window.getWindow)();
                _dom_adapter.default.listen(window, "beforeunload", function() {
                    unloading = true
                })
            });
            return function(xhr, textStatus) {
                if (unloading) {
                    return XHR_ERROR_UNLOAD
                }
                if (xhr.status < 400) {
                    return explainTextStatus(textStatus)
                }
                return xhr.statusText
            }
        }();
        var aggregators = {
            count: {
                seed: 0,
                step: function(count) {
                    return 1 + count
                }
            },
            sum: {
                seed: 0,
                step: function(sum, item) {
                    return sum + item
                }
            },
            min: {
                step: function(min, item) {
                    return item < min ? item : min
                }
            },
            max: {
                step: function(max, item) {
                    return item > max ? item : max
                }
            },
            avg: {
                seed: [0, 0],
                step: function(pair, value) {
                    return [pair[0] + value, pair[1] + 1]
                },
                finalize: function(pair) {
                    return pair[1] ? pair[0] / pair[1] : NaN
                }
            }
        };
        var processRequestResultLock = function() {
            var lockCount = 0;
            var lockDeferred;
            var obtain = function() {
                if (0 === lockCount) {
                    lockDeferred = new _deferred.Deferred
                }
                lockCount++
            };
            var release = function() {
                lockCount--;
                if (lockCount < 1) {
                    lockDeferred.resolve()
                }
            };
            var promise = function() {
                var deferred = 0 === lockCount ? (new _deferred.Deferred).resolve() : lockDeferred;
                return deferred.promise()
            };
            var reset = function() {
                lockCount = 0;
                if (lockDeferred) {
                    lockDeferred.resolve()
                }
            };
            return {
                obtain: obtain,
                release: release,
                promise: promise,
                reset: reset
            }
        }();

        function isDisjunctiveOperator(condition) {
            return /^(or|\|\||\|)$/i.test(condition)
        }

        function isConjunctiveOperator(condition) {
            return /^(and|&&|&)$/i.test(condition)
        }
        var keysEqual = function(keyExpr, key1, key2) {
            if (Array.isArray(keyExpr)) {
                var names = (0, _iterator.map)(key1, function(v, k) {
                    return k
                });
                var name;
                for (var i = 0; i < names.length; i++) {
                    name = names[i];
                    if (!(0, _common.equalByValue)(key1[name], key2[name], 0, false)) {
                        return false
                    }
                }
                return true
            }
            return (0, _common.equalByValue)(key1, key2, 0, false)
        };
        var BASE64_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        var base64_encode = function(input) {
            if (!Array.isArray(input)) {
                input = stringToByteArray(String(input))
            }
            var result = "";

            function getBase64Char(index) {
                return BASE64_CHARS.charAt(index)
            }
            for (var i = 0; i < input.length; i += 3) {
                var octet1 = input[i];
                var octet2 = input[i + 1];
                var octet3 = input[i + 2];
                result += (0, _iterator.map)([octet1 >> 2, (3 & octet1) << 4 | octet2 >> 4, isNaN(octet2) ? 64 : (15 & octet2) << 2 | octet3 >> 6, isNaN(octet3) ? 64 : 63 & octet3], getBase64Char).join("")
            }
            return result
        };

        function stringToByteArray(str) {
            var bytes = [];
            var code;
            var i;
            for (i = 0; i < str.length; i++) {
                code = str.charCodeAt(i);
                if (code < 128) {
                    bytes.push(code)
                } else {
                    if (code < 2048) {
                        bytes.push(192 + (code >> 6), 128 + (63 & code))
                    } else {
                        if (code < 65536) {
                            bytes.push(224 + (code >> 12), 128 + (code >> 6 & 63), 128 + (63 & code))
                        } else {
                            if (code < 2097152) {
                                bytes.push(240 + (code >> 18), 128 + (code >> 12 & 63), 128 + (code >> 6 & 63), 128 + (63 & code))
                            }
                        }
                    }
                }
            }
            return bytes
        }
        var isUnaryOperation = function(crit) {
            return "!" === crit[0] && Array.isArray(crit[1])
        };
        var isGroupOperator = function(value) {
            return "and" === value || "or" === value
        };
        var isGroupCriterion = function(crit) {
            var first = crit[0];
            var second = crit[1];
            if (Array.isArray(first)) {
                return true
            }
            if ((0, _type.isFunction)(first)) {
                if (Array.isArray(second) || (0, _type.isFunction)(second) || isGroupOperator(second)) {
                    return true
                }
            }
            return false
        };
        var trivialPromise = function() {
            var d = new _deferred.Deferred;
            return d.resolve.apply(d, arguments).promise()
        };
        var rejectedPromise = function() {
            var d = new _deferred.Deferred;
            return d.reject.apply(d, arguments).promise()
        };

        function throttle(func, timeout) {
            var timeoutId;
            var lastArgs;
            return function() {
                var _this = this;
                lastArgs = arguments;
                if (!timeoutId) {
                    timeoutId = setTimeout(function() {
                        timeoutId = void 0;
                        if (lastArgs) {
                            func.call(_this, lastArgs)
                        }
                    }, (0, _type.isFunction)(timeout) ? timeout() : timeout)
                }
                return timeoutId
            }
        }

        function throttleChanges(func, timeout) {
            var cache = [];
            var throttled = throttle(function() {
                func.call(this, cache);
                cache = []
            }, timeout);
            return function(changes) {
                if (Array.isArray(changes)) {
                    var _cache;
                    (_cache = cache).push.apply(_cache, _toConsumableArray(changes))
                }
                return throttled.call(this, cache)
            }
        }
        var utils = {
            XHR_ERROR_UNLOAD: XHR_ERROR_UNLOAD,
            normalizeBinaryCriterion: normalizeBinaryCriterion,
            normalizeSortingInfo: normalizeSortingInfo,
            errorMessageFromXhr: errorMessageFromXhr,
            aggregators: aggregators,
            keysEqual: keysEqual,
            throttleChanges: throttleChanges,
            trivialPromise: trivialPromise,
            rejectedPromise: rejectedPromise,
            isDisjunctiveOperator: isDisjunctiveOperator,
            isConjunctiveOperator: isConjunctiveOperator,
            processRequestResultLock: processRequestResultLock,
            isUnaryOperation: isUnaryOperation,
            isGroupCriterion: isGroupCriterion,
            base64_encode: base64_encode
        };
        var _default = utils;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/animation/fx.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../core/errors */ 25));
        var _element = __webpack_require__( /*! ../core/element */ 18);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _translator = __webpack_require__( /*! ./translator */ 28);
        var _easing = __webpack_require__( /*! ./easing */ 253);
        var _frame = __webpack_require__( /*! ./frame */ 129);
        var _support = __webpack_require__( /*! ../core/utils/support */ 45);
        var _position = _interopRequireDefault(__webpack_require__( /*! ./position */ 81));
        var _remove_event = _interopRequireDefault(__webpack_require__( /*! ../core/remove_event */ 152));
        var _index = __webpack_require__( /*! ../events/utils/index */ 8);
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        var window = (0, _window.getWindow)();
        var removeEventName = (0, _index.addNamespace)(_remove_event.default, "dxFX");
        var RELATIVE_VALUE_REGEX = /^([+-])=(.*)/i;
        var ANIM_DATA_KEY = "dxAnimData";
        var ANIM_QUEUE_KEY = "dxAnimQueue";
        var TRANSFORM_PROP = "transform";
        var TransitionAnimationStrategy = {
            initAnimation: function($element, config) {
                $element.css({
                    transitionProperty: "none"
                });
                if ("string" === typeof config.from) {
                    $element.addClass(config.from)
                } else {
                    setProps($element, config.from)
                }
                var that = this;
                var deferred = new _deferred.Deferred;
                var cleanupWhen = config.cleanupWhen;
                config.transitionAnimation = {
                    deferred: deferred,
                    finish: function() {
                        that._finishTransition($element);
                        if (cleanupWhen) {
                            (0, _deferred.when)(deferred, cleanupWhen).always(function() {
                                that._cleanup($element, config)
                            })
                        } else {
                            that._cleanup($element, config)
                        }
                        deferred.resolveWith($element, [config, $element])
                    }
                };
                this._completeAnimationCallback($element, config).done(function() {
                    config.transitionAnimation.finish()
                }).fail(function() {
                    deferred.rejectWith($element, [config, $element])
                });
                if (!config.duration) {
                    config.transitionAnimation.finish()
                }
                $element.css("transform")
            },
            animate: function($element, config) {
                this._startAnimation($element, config);
                return config.transitionAnimation.deferred.promise()
            },
            _completeAnimationCallback: function($element, config) {
                var that = this;
                var startTime = Date.now() + config.delay;
                var deferred = new _deferred.Deferred;
                var transitionEndFired = new _deferred.Deferred;
                var simulatedTransitionEndFired = new _deferred.Deferred;
                var simulatedEndEventTimer;
                var transitionEndEventFullName = (0, _support.transitionEndEventName)() + ".dxFX";
                config.transitionAnimation.cleanup = function() {
                    clearTimeout(simulatedEndEventTimer);
                    clearTimeout(waitForJSCompleteTimer);
                    _events_engine.default.off($element, transitionEndEventFullName);
                    _events_engine.default.off($element, removeEventName)
                };
                _events_engine.default.one($element, transitionEndEventFullName, function() {
                    if (Date.now() - startTime >= config.duration) {
                        transitionEndFired.reject()
                    }
                });
                _events_engine.default.off($element, removeEventName);
                _events_engine.default.on($element, removeEventName, function() {
                    that.stop($element, config);
                    deferred.reject()
                });
                var waitForJSCompleteTimer = setTimeout(function() {
                    simulatedEndEventTimer = setTimeout(function() {
                        simulatedTransitionEndFired.reject()
                    }, config.duration + config.delay + fx._simulatedTransitionEndDelay);
                    (0, _deferred.when)(transitionEndFired, simulatedTransitionEndFired).fail(function() {
                        deferred.resolve()
                    }.bind(this))
                });
                return deferred.promise()
            },
            _startAnimation: function($element, config) {
                $element.css({
                    transitionProperty: "all",
                    transitionDelay: config.delay + "ms",
                    transitionDuration: config.duration + "ms",
                    transitionTimingFunction: config.easing
                });
                if ("string" === typeof config.to) {
                    $element[0].className += " " + config.to
                } else {
                    if (config.to) {
                        setProps($element, config.to)
                    }
                }
            },
            _finishTransition: function($element) {
                $element.css("transition", "none")
            },
            _cleanup: function($element, config) {
                config.transitionAnimation.cleanup();
                if ("string" === typeof config.from) {
                    $element.removeClass(config.from);
                    $element.removeClass(config.to)
                }
            },
            stop: function($element, config, jumpToEnd) {
                if (!config) {
                    return
                }
                if (jumpToEnd) {
                    config.transitionAnimation.finish()
                } else {
                    if ((0, _type.isPlainObject)(config.to)) {
                        (0, _iterator.each)(config.to, function(key) {
                            $element.css(key, $element.css(key))
                        })
                    }
                    this._finishTransition($element);
                    this._cleanup($element, config)
                }
            }
        };
        var FrameAnimationStrategy = {
            initAnimation: function($element, config) {
                setProps($element, config.from)
            },
            animate: function($element, config) {
                var deferred = new _deferred.Deferred;
                var that = this;
                if (!config) {
                    return deferred.reject().promise()
                }(0, _iterator.each)(config.to, function(prop) {
                    if (void 0 === config.from[prop]) {
                        config.from[prop] = that._normalizeValue($element.css(prop))
                    }
                });
                if (config.to[TRANSFORM_PROP]) {
                    config.from[TRANSFORM_PROP] = that._parseTransform(config.from[TRANSFORM_PROP]);
                    config.to[TRANSFORM_PROP] = that._parseTransform(config.to[TRANSFORM_PROP])
                }
                config.frameAnimation = {
                    to: config.to,
                    from: config.from,
                    currentValue: config.from,
                    easing: (0, _easing.convertTransitionTimingFuncToEasing)(config.easing),
                    duration: config.duration,
                    startTime: (new Date).valueOf(),
                    finish: function() {
                        this.currentValue = this.to;
                        this.draw();
                        (0, _frame.cancelAnimationFrame)(config.frameAnimation.animationFrameId);
                        deferred.resolve()
                    },
                    draw: function() {
                        if (config.draw) {
                            config.draw(this.currentValue);
                            return
                        }
                        var currentValue = (0, _extend.extend)({}, this.currentValue);
                        if (currentValue[TRANSFORM_PROP]) {
                            currentValue[TRANSFORM_PROP] = (0, _iterator.map)(currentValue[TRANSFORM_PROP], function(value, prop) {
                                if ("translate" === prop) {
                                    return (0, _translator.getTranslateCss)(value)
                                } else {
                                    if ("scale" === prop) {
                                        return "scale(" + value + ")"
                                    } else {
                                        if ("rotate" === prop.substr(0, prop.length - 1)) {
                                            return prop + "(" + value + "deg)"
                                        }
                                    }
                                }
                            }).join(" ")
                        }
                        $element.css(currentValue)
                    }
                };
                if (config.delay) {
                    config.frameAnimation.startTime += config.delay;
                    config.frameAnimation.delayTimeout = setTimeout(function() {
                        that._startAnimation($element, config)
                    }, config.delay)
                } else {
                    that._startAnimation($element, config)
                }
                return deferred.promise()
            },
            _startAnimation: function($element, config) {
                _events_engine.default.off($element, removeEventName);
                _events_engine.default.on($element, removeEventName, function() {
                    if (config.frameAnimation) {
                        (0, _frame.cancelAnimationFrame)(config.frameAnimation.animationFrameId)
                    }
                });
                this._animationStep($element, config)
            },
            _parseTransform: function(transformString) {
                var result = {};
                (0, _iterator.each)(transformString.match(/\w+\d*\w*\([^)]*\)\s*/g), function(i, part) {
                    var translateData = (0, _translator.parseTranslate)(part);
                    var scaleData = part.match(/scale\((.+?)\)/);
                    var rotateData = part.match(/(rotate.)\((.+)deg\)/);
                    if (translateData) {
                        result.translate = translateData
                    }
                    if (scaleData && scaleData[1]) {
                        result.scale = parseFloat(scaleData[1])
                    }
                    if (rotateData && rotateData[1]) {
                        result[rotateData[1]] = parseFloat(rotateData[2])
                    }
                });
                return result
            },
            stop: function($element, config, jumpToEnd) {
                var frameAnimation = config && config.frameAnimation;
                if (!frameAnimation) {
                    return
                }(0, _frame.cancelAnimationFrame)(frameAnimation.animationFrameId);
                clearTimeout(frameAnimation.delayTimeout);
                if (jumpToEnd) {
                    frameAnimation.finish()
                }
                delete config.frameAnimation
            },
            _animationStep: function($element, config) {
                var frameAnimation = config && config.frameAnimation;
                if (!frameAnimation) {
                    return
                }
                var now = (new Date).valueOf();
                if (now >= frameAnimation.startTime + frameAnimation.duration) {
                    frameAnimation.finish();
                    return
                }
                frameAnimation.currentValue = this._calcStepValue(frameAnimation, now - frameAnimation.startTime);
                frameAnimation.draw();
                var that = this;
                frameAnimation.animationFrameId = (0, _frame.requestAnimationFrame)(function() {
                    that._animationStep($element, config)
                })
            },
            _calcStepValue: function(frameAnimation, currentDuration) {
                var calcValueRecursively = function calcValueRecursively(from, to) {
                    var result = Array.isArray(to) ? [] : {};
                    var calcEasedValue = function(propName) {
                        var x = currentDuration / frameAnimation.duration;
                        var t = currentDuration;
                        var b = 1 * from[propName];
                        var c = to[propName] - from[propName];
                        var d = frameAnimation.duration;
                        return (0, _easing.getEasing)(frameAnimation.easing)(x, t, b, c, d)
                    };
                    (0, _iterator.each)(to, function(propName, endPropValue) {
                        if ("string" === typeof endPropValue && false === parseFloat(endPropValue, 10)) {
                            return true
                        }
                        result[propName] = "object" === _typeof(endPropValue) ? calcValueRecursively(from[propName], endPropValue) : calcEasedValue(propName)
                    });
                    return result
                };
                return calcValueRecursively(frameAnimation.from, frameAnimation.to)
            },
            _normalizeValue: function(value) {
                var numericValue = parseFloat(value, 10);
                if (false === numericValue) {
                    return value
                }
                return numericValue
            }
        };
        var FallbackToNoAnimationStrategy = {
            initAnimation: function() {},
            animate: function() {
                return (new _deferred.Deferred).resolve().promise()
            },
            stop: _common.noop,
            isSynchronous: true
        };
        var getAnimationStrategy = function(config) {
            config = config || {};
            var animationStrategies = {
                transition: (0, _support.transition)() ? TransitionAnimationStrategy : FrameAnimationStrategy,
                frame: FrameAnimationStrategy,
                noAnimation: FallbackToNoAnimationStrategy
            };
            var strategy = config.strategy || "transition";
            if ("css" === config.type && !(0, _support.transition)()) {
                strategy = "noAnimation"
            }
            return animationStrategies[strategy]
        };
        var baseConfigValidator = function(config, animationType, validate, typeMessage) {
            (0, _iterator.each)(["from", "to"], function() {
                if (!validate(config[this])) {
                    throw _errors.default.Error("E0010", animationType, this, typeMessage)
                }
            })
        };
        var isObjectConfigValidator = function(config, animationType) {
            return baseConfigValidator(config, animationType, function(target) {
                return (0, _type.isPlainObject)(target)
            }, "a plain object")
        };
        var isStringConfigValidator = function(config, animationType) {
            return baseConfigValidator(config, animationType, function(target) {
                return "string" === typeof target
            }, "a string")
        };
        var CustomAnimationConfigurator = {
            setup: function() {}
        };
        var CssAnimationConfigurator = {
            validateConfig: function(config) {
                isStringConfigValidator(config, "css")
            },
            setup: function() {}
        };
        var positionAliases = {
            top: {
                my: "bottom center",
                at: "top center"
            },
            bottom: {
                my: "top center",
                at: "bottom center"
            },
            right: {
                my: "left center",
                at: "right center"
            },
            left: {
                my: "right center",
                at: "left center"
            }
        };
        var SlideAnimationConfigurator = {
            validateConfig: function(config) {
                isObjectConfigValidator(config, "slide")
            },
            setup: function($element, config) {
                var location = (0, _translator.locate)($element);
                if ("slide" !== config.type) {
                    var positioningConfig = "slideIn" === config.type ? config.from : config.to;
                    positioningConfig.position = (0, _extend.extend)({
                        of: window
                    }, positionAliases[config.direction]);
                    setupPosition($element, positioningConfig)
                }
                this._setUpConfig(location, config.from);
                this._setUpConfig(location, config.to);
                (0, _translator.clearCache)($element)
            },
            _setUpConfig: function(location, config) {
                config.left = "left" in config ? config.left : "+=0";
                config.top = "top" in config ? config.top : "+=0";
                this._initNewPosition(location, config)
            },
            _initNewPosition: function(location, config) {
                var position = {
                    left: config.left,
                    top: config.top
                };
                delete config.left;
                delete config.top;
                var relativeValue = this._getRelativeValue(position.left);
                if (void 0 !== relativeValue) {
                    position.left = relativeValue + location.left
                } else {
                    config.left = 0
                }
                relativeValue = this._getRelativeValue(position.top);
                if (void 0 !== relativeValue) {
                    position.top = relativeValue + location.top
                } else {
                    config.top = 0
                }
                config[TRANSFORM_PROP] = (0, _translator.getTranslateCss)({
                    x: position.left,
                    y: position.top
                })
            },
            _getRelativeValue: function(value) {
                var relativeValue;
                if ("string" === typeof value && (relativeValue = RELATIVE_VALUE_REGEX.exec(value))) {
                    return parseInt(relativeValue[1] + "1") * relativeValue[2]
                }
            }
        };
        var FadeAnimationConfigurator = {
            setup: function($element, config) {
                var from = config.from;
                var fromOpacity = (0, _type.isPlainObject)(from) ? config.skipElementInitialStyles ? 0 : $element.css("opacity") : String(from);
                var toOpacity;
                switch (config.type) {
                    case "fadeIn":
                        toOpacity = 1;
                        break;
                    case "fadeOut":
                        toOpacity = 0;
                        break;
                    default:
                        toOpacity = String(config.to)
                }
                config.from = {
                    visibility: "visible",
                    opacity: fromOpacity
                };
                config.to = {
                    opacity: toOpacity
                }
            }
        };
        var PopAnimationConfigurator = {
            validateConfig: function(config) {
                isObjectConfigValidator(config, "pop")
            },
            setup: function($element, config) {
                var from = config.from;
                var to = config.to;
                var fromOpacity = "opacity" in from ? from.opacity : $element.css("opacity");
                var toOpacity = "opacity" in to ? to.opacity : 1;
                var fromScale = "scale" in from ? from.scale : 0;
                var toScale = "scale" in to ? to.scale : 1;
                config.from = {
                    opacity: fromOpacity
                };
                var translate = (0, _translator.getTranslate)($element);
                config.from[TRANSFORM_PROP] = this._getCssTransform(translate, fromScale);
                config.to = {
                    opacity: toOpacity
                };
                config.to[TRANSFORM_PROP] = this._getCssTransform(translate, toScale)
            },
            _getCssTransform: function(translate, scale) {
                return (0, _translator.getTranslateCss)(translate) + "scale(" + scale + ")"
            }
        };
        var animationConfigurators = {
            custom: CustomAnimationConfigurator,
            slide: SlideAnimationConfigurator,
            slideIn: SlideAnimationConfigurator,
            slideOut: SlideAnimationConfigurator,
            fade: FadeAnimationConfigurator,
            fadeIn: FadeAnimationConfigurator,
            fadeOut: FadeAnimationConfigurator,
            pop: PopAnimationConfigurator,
            css: CssAnimationConfigurator
        };
        var getAnimationConfigurator = function(config) {
            var result = animationConfigurators[config.type];
            if (!result) {
                throw _errors.default.Error("E0011", config.type)
            }
            return result
        };
        var defaultJSConfig = {
            type: "custom",
            from: {},
            to: {},
            duration: 400,
            start: _common.noop,
            complete: _common.noop,
            easing: "ease",
            delay: 0
        };
        var defaultCssConfig = {
            duration: 400,
            easing: "ease",
            delay: 0
        };

        function setupAnimationOnElement() {
            var animation = this;
            var $element = animation.element;
            var config = animation.config;
            setupPosition($element, config.from);
            setupPosition($element, config.to);
            animation.configurator.setup($element, config);
            $element.data(ANIM_DATA_KEY, animation);
            if (fx.off) {
                config.duration = 0;
                config.delay = 0
            }
            animation.strategy.initAnimation($element, config);
            if (config.start) {
                var element = (0, _element.getPublicElement)($element);
                config.start.apply(this, [element, config])
            }
        }
        var onElementAnimationComplete = function(animation) {
            var $element = animation.element;
            var config = animation.config;
            $element.removeData(ANIM_DATA_KEY);
            if (config.complete) {
                var element = (0, _element.getPublicElement)($element);
                config.complete.apply(this, [element, config])
            }
            animation.deferred.resolveWith(this, [$element, config])
        };
        var startAnimationOnElement = function() {
            var animation = this;
            var $element = animation.element;
            var config = animation.config;
            animation.isStarted = true;
            return animation.strategy.animate($element, config).done(function() {
                onElementAnimationComplete(animation)
            }).fail(function() {
                animation.deferred.rejectWith(this, [$element, config])
            })
        };
        var stopAnimationOnElement = function(jumpToEnd) {
            var animation = this;
            var $element = animation.element;
            var config = animation.config;
            clearTimeout(animation.startTimeout);
            if (!animation.isStarted) {
                animation.start()
            }
            animation.strategy.stop($element, config, jumpToEnd)
        };
        var scopedRemoveEvent = (0, _index.addNamespace)(_remove_event.default, "dxFXStartAnimation");
        var subscribeToRemoveEvent = function(animation) {
            _events_engine.default.off(animation.element, scopedRemoveEvent);
            _events_engine.default.on(animation.element, scopedRemoveEvent, function() {
                fx.stop(animation.element)
            });
            animation.deferred.always(function() {
                _events_engine.default.off(animation.element, scopedRemoveEvent)
            })
        };
        var createAnimation = function(element, initialConfig) {
            var defaultConfig = "css" === initialConfig.type ? defaultCssConfig : defaultJSConfig;
            var config = (0, _extend.extend)(true, {}, defaultConfig, initialConfig);
            var configurator = getAnimationConfigurator(config);
            var strategy = getAnimationStrategy(config);
            var animation = {
                element: (0, _renderer.default)(element),
                config: config,
                configurator: configurator,
                strategy: strategy,
                isSynchronous: strategy.isSynchronous,
                setup: setupAnimationOnElement,
                start: startAnimationOnElement,
                stop: stopAnimationOnElement,
                deferred: new _deferred.Deferred
            };
            if ((0, _type.isFunction)(configurator.validateConfig)) {
                configurator.validateConfig(config)
            }
            subscribeToRemoveEvent(animation);
            return animation
        };
        var animate = function(element, config) {
            var $element = (0, _renderer.default)(element);
            if (!$element.length) {
                return (new _deferred.Deferred).resolve().promise()
            }
            var animation = createAnimation($element, config);
            pushInAnimationQueue($element, animation);
            return animation.deferred.promise()
        };

        function pushInAnimationQueue($element, animation) {
            var queueData = getAnimQueueData($element);
            writeAnimQueueData($element, queueData);
            queueData.push(animation);
            if (!isAnimating($element)) {
                shiftFromAnimationQueue($element, queueData)
            }
        }

        function getAnimQueueData($element) {
            return $element.data(ANIM_QUEUE_KEY) || []
        }

        function writeAnimQueueData($element, queueData) {
            $element.data(ANIM_QUEUE_KEY, queueData)
        }
        var destroyAnimQueueData = function($element) {
            $element.removeData(ANIM_QUEUE_KEY)
        };

        function isAnimating($element) {
            return !!$element.data(ANIM_DATA_KEY)
        }

        function shiftFromAnimationQueue($element, queueData) {
            queueData = getAnimQueueData($element);
            if (!queueData.length) {
                return
            }
            var animation = queueData.shift();
            if (0 === queueData.length) {
                destroyAnimQueueData($element)
            }
            executeAnimation(animation).done(function() {
                if (!isAnimating($element)) {
                    shiftFromAnimationQueue($element)
                }
            })
        }

        function executeAnimation(animation) {
            animation.setup();
            if (fx.off || animation.isSynchronous) {
                animation.start()
            } else {
                animation.startTimeout = setTimeout(function() {
                    animation.start()
                })
            }
            return animation.deferred.promise()
        }

        function setupPosition($element, config) {
            if (!config || !config.position) {
                return
            }
            var win = (0, _renderer.default)(window);
            var left = 0;
            var top = 0;
            var position = _position.default.calculate($element, config.position);
            var offset = $element.offset();
            var currentPosition = $element.position();
            if (currentPosition.top > offset.top) {
                top = win.scrollTop()
            }
            if (currentPosition.left > offset.left) {
                left = win.scrollLeft()
            }(0, _extend.extend)(config, {
                left: position.h.location - offset.left + currentPosition.left - left,
                top: position.v.location - offset.top + currentPosition.top - top
            });
            delete config.position
        }

        function setProps($element, props) {
            (0, _iterator.each)(props, function(key, value) {
                try {
                    $element.css(key, (0, _type.isFunction)(value) ? value() : value)
                } catch (e) {}
            })
        }
        var stop = function(element, jumpToEnd) {
            var $element = (0, _renderer.default)(element);
            var queueData = getAnimQueueData($element);
            (0, _iterator.each)(queueData, function(_, animation) {
                animation.config.delay = 0;
                animation.config.duration = 0;
                animation.isSynchronous = true
            });
            if (!isAnimating($element)) {
                shiftFromAnimationQueue($element, queueData)
            }
            var animation = $element.data(ANIM_DATA_KEY);
            if (animation) {
                animation.stop(jumpToEnd)
            }
            $element.removeData(ANIM_DATA_KEY);
            destroyAnimQueueData($element)
        };
        var fx = {
            off: false,
            animationTypes: animationConfigurators,
            animate: animate,
            createAnimation: createAnimation,
            isAnimating: isAnimating,
            stop: stop,
            _simulatedTransitionEndDelay: 100
        };
        var _default = fx;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/string.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.format = format;
        exports.isEmpty = exports.replaceAll = exports.quadToObject = exports.encodeHtml = void 0;
        var _type = __webpack_require__( /*! ./type */ 1);

        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        var encodeHtml = function() {
            var encodeRegExp = [new RegExp("&", "g"), new RegExp('"', "g"), new RegExp("'", "g"), new RegExp("<", "g"), new RegExp(">", "g")];
            return function(str) {
                return String(str).replace(encodeRegExp[0], "&amp;").replace(encodeRegExp[1], "&quot;").replace(encodeRegExp[2], "&#39;").replace(encodeRegExp[3], "&lt;").replace(encodeRegExp[4], "&gt;")
            }
        }();
        exports.encodeHtml = encodeHtml;
        var splitQuad = function(raw) {
            switch (_typeof(raw)) {
                case "string":
                    return raw.split(/\s+/, 4);
                case "object":
                    return [raw.x || raw.h || raw.left, raw.y || raw.v || raw.top, raw.x || raw.h || raw.right, raw.y || raw.v || raw.bottom];
                case "number":
                    return [raw];
                default:
                    return raw
            }
        };
        var quadToObject = function(raw) {
            var quad = splitQuad(raw);
            var left = parseInt(quad && quad[0], 10);
            var top = parseInt(quad && quad[1], 10);
            var right = parseInt(quad && quad[2], 10);
            var bottom = parseInt(quad && quad[3], 10);
            if (!isFinite(left)) {
                left = 0
            }
            if (!isFinite(top)) {
                top = left
            }
            if (!isFinite(right)) {
                right = left
            }
            if (!isFinite(bottom)) {
                bottom = top
            }
            return {
                top: top,
                right: right,
                bottom: bottom,
                left: left
            }
        };
        exports.quadToObject = quadToObject;

        function format(template) {
            for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                values[_key - 1] = arguments[_key]
            }
            if ((0, _type.isFunction)(template)) {
                return template.apply(void 0, values)
            }
            values.forEach(function(value, index) {
                if ((0, _type.isString)(value)) {
                    value = value.replace(/\$/g, "$$$$")
                }
                var placeholderReg = new RegExp("\\{" + index + "\\}", "gm");
                template = template.replace(placeholderReg, value)
            });
            return template
        }
        var replaceAll = function() {
            var quote = function(str) {
                return (str + "").replace(/([+*?.[^\]$(){}><|=!:])/g, "\\$1")
            };
            return function(text, searchToken, replacementToken) {
                return text.replace(new RegExp("(" + quote(searchToken) + ")", "gi"), replacementToken)
            }
        }();
        exports.replaceAll = replaceAll;
        var isEmpty = function() {
            var SPACE_REGEXP = /\s/g;
            return function(text) {
                return !text || !text.replace(SPACE_REGEXP, "")
            }
        }();
        exports.isEmpty = isEmpty
    },
    /*!***********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.modules.js ***!
      \***********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/callbacks */ 27));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var WIDGET_WITH_LEGACY_CONTAINER_NAME = "dxDataGrid";
        var ModuleItem = _class.default.inherit({
            _endUpdateCore: function() {},
            ctor: function(component) {
                var that = this;
                that._updateLockCount = 0;
                that.component = component;
                that._actions = {};
                that._actionConfigs = {};
                (0, _iterator.each)(this.callbackNames() || [], function(index, name) {
                    var flags = that.callbackFlags(name) || {};
                    flags.unique = true, flags.syncStrategy = true;
                    that[this] = (0, _callbacks.default)(flags)
                })
            },
            init: function() {},
            callbackNames: function() {},
            callbackFlags: function() {},
            publicMethods: function() {},
            beginUpdate: function() {
                this._updateLockCount++
            },
            endUpdate: function() {
                if (this._updateLockCount > 0) {
                    this._updateLockCount--;
                    if (!this._updateLockCount) {
                        this._endUpdateCore()
                    }
                }
            },
            option: function(name) {
                var component = this.component;
                var optionCache = component._optionCache;
                if (1 === arguments.length && optionCache) {
                    if (!(name in optionCache)) {
                        optionCache[name] = component.option(name)
                    }
                    return optionCache[name]
                }
                return component.option.apply(component, arguments)
            },
            _silentOption: function(name, value) {
                var component = this.component;
                var optionCache = component._optionCache;
                if (optionCache) {
                    optionCache[name] = value
                }
                return component._setOptionWithoutOptionChange(name, value)
            },
            localize: function(name) {
                var optionCache = this.component._optionCache;
                if (optionCache) {
                    if (!(name in optionCache)) {
                        optionCache[name] = _message.default.format(name)
                    }
                    return optionCache[name]
                }
                return _message.default.format(name)
            },
            on: function() {
                return this.component.on.apply(this.component, arguments)
            },
            off: function() {
                return this.component.off.apply(this.component, arguments)
            },
            optionChanged: function(args) {
                if (args.name in this._actions) {
                    this.createAction(args.name, this._actionConfigs[args.name]);
                    args.handled = true
                }
            },
            getAction: function(actionName) {
                return this._actions[actionName]
            },
            setAria: function(name, value, $target) {
                var target = $target.get(0);
                var prefix = "role" !== name && "id" !== name ? "aria-" : "";
                if (target.setAttribute) {
                    target.setAttribute(prefix + name, value)
                } else {
                    $target.attr(prefix + name, value)
                }
            },
            _createComponent: function() {
                return this.component._createComponent.apply(this.component, arguments)
            },
            getController: function(name) {
                return this.component._controllers[name]
            },
            createAction: function(actionName, config) {
                if ((0, _type.isFunction)(actionName)) {
                    var action = this.component._createAction(actionName.bind(this), config);
                    return function(e) {
                        action({
                            event: e
                        })
                    }
                } else {
                    this._actions[actionName] = this.component._createActionByOption(actionName, config);
                    this._actionConfigs[actionName] = config
                }
            },
            executeAction: function(actionName, options) {
                var action = this._actions[actionName];
                return action && action(options)
            },
            dispose: function() {
                var that = this;
                (0, _iterator.each)(that.callbackNames() || [], function() {
                    that[this].empty()
                })
            },
            addWidgetPrefix: function(className) {
                var componentName = this.component.NAME;
                return "dx-" + componentName.slice(2).toLowerCase() + (className ? "-" + className : "")
            },
            getWidgetContainerClass: function() {
                var containerName = this.component.NAME === WIDGET_WITH_LEGACY_CONTAINER_NAME ? null : "container";
                return this.addWidgetPrefix(containerName)
            }
        });
        var Controller = ModuleItem;
        var ViewController = Controller.inherit({
            getView: function(name) {
                return this.component._views[name]
            },
            getViews: function() {
                return this.component._views
            }
        });
        var View = ModuleItem.inherit({
            _isReady: function() {
                return this.component.isReady()
            },
            _endUpdateCore: function() {
                this.callBase();
                if (!this._isReady() && this._requireReady) {
                    this._requireRender = false;
                    this.component._requireResize = false
                }
                if (this._requireRender) {
                    this._requireRender = false;
                    this.render(this._$parent)
                }
            },
            _invalidate: function(requireResize, requireReady) {
                this._requireRender = true;
                this.component._requireResize = (0, _window.hasWindow)() && (this.component._requireResize || requireResize);
                this._requireReady = this._requireReady || requireReady
            },
            _renderCore: function() {},
            _resizeCore: function() {},
            _afterRender: function() {},
            _parentElement: function() {
                return this._$parent
            },
            ctor: function(component) {
                this.callBase(component);
                this.renderCompleted = (0, _callbacks.default)();
                this.resizeCompleted = (0, _callbacks.default)()
            },
            element: function() {
                return this._$element
            },
            getElementHeight: function() {
                var $element = this.element();
                if (!$element) {
                    return 0
                }
                var marginTop = parseFloat($element.css("marginTop")) || 0;
                var marginBottom = parseFloat($element.css("marginBottom")) || 0;
                var offsetHeight = $element.get(0).offsetHeight;
                return offsetHeight + marginTop + marginBottom
            },
            isVisible: function() {
                return true
            },
            getTemplate: function(name) {
                return this.component._getTemplate(name)
            },
            render: function($parent, options) {
                var $element = this._$element;
                var isVisible = this.isVisible();
                if (!$element && !$parent) {
                    return
                }
                this._requireReady = false;
                if (!$element) {
                    $element = this._$element = (0, _renderer.default)("<div>").appendTo($parent);
                    this._$parent = $parent
                }
                $element.toggleClass("dx-hidden", !isVisible);
                if (isVisible) {
                    this.component._optionCache = {};
                    this._renderCore(options);
                    this.component._optionCache = void 0;
                    this._afterRender($parent);
                    this.renderCompleted.fire(options)
                }
            },
            resize: function() {
                this.isResizing = true;
                this._resizeCore();
                this.resizeCompleted.fire();
                this.isResizing = false
            },
            focus: function() {
                _events_engine.default.trigger(this.element(), "focus")
            }
        });
        var MODULES_ORDER_MAX_INDEX = 1e6;
        var processModules = function(that, componentClass) {
            var modules = componentClass.modules;
            var modulesOrder = componentClass.modulesOrder;
            var controllerTypes = componentClass.controllerTypes || {};
            var viewTypes = componentClass.viewTypes || {};
            if (!componentClass.controllerTypes) {
                if (modulesOrder) {
                    modules.sort(function(module1, module2) {
                        var orderIndex1 = (0, _array.inArray)(module1.name, modulesOrder);
                        var orderIndex2 = (0, _array.inArray)(module2.name, modulesOrder);
                        if (orderIndex1 < 0) {
                            orderIndex1 = MODULES_ORDER_MAX_INDEX
                        }
                        if (orderIndex2 < 0) {
                            orderIndex2 = MODULES_ORDER_MAX_INDEX
                        }
                        return orderIndex1 - orderIndex2
                    })
                }(0, _iterator.each)(modules, function() {
                    var controllers = this.controllers;
                    var moduleName = this.name;
                    var views = this.views;
                    controllers && (0, _iterator.each)(controllers, function(name, type) {
                        if (controllerTypes[name]) {
                            throw _ui.default.Error("E1001", moduleName, name)
                        } else {
                            if (!(type && type.subclassOf && type.subclassOf(Controller))) {
                                type.subclassOf(Controller);
                                throw _ui.default.Error("E1002", moduleName, name)
                            }
                        }
                        controllerTypes[name] = type
                    });
                    views && (0, _iterator.each)(views, function(name, type) {
                        if (viewTypes[name]) {
                            throw _ui.default.Error("E1003", moduleName, name)
                        } else {
                            if (!(type && type.subclassOf && type.subclassOf(View))) {
                                throw _ui.default.Error("E1004", moduleName, name)
                            }
                        }
                        viewTypes[name] = type
                    })
                });
                (0, _iterator.each)(modules, function() {
                    var extenders = this.extenders;
                    if (extenders) {
                        extenders.controllers && (0, _iterator.each)(extenders.controllers, function(name, extender) {
                            if (controllerTypes[name]) {
                                controllerTypes[name] = controllerTypes[name].inherit(extender)
                            }
                        });
                        extenders.views && (0, _iterator.each)(extenders.views, function(name, extender) {
                            if (viewTypes[name]) {
                                viewTypes[name] = viewTypes[name].inherit(extender)
                            }
                        })
                    }
                });
                componentClass.controllerTypes = controllerTypes;
                componentClass.viewTypes = viewTypes
            }
            var registerPublicMethods = function(that, name, moduleItem) {
                var publicMethods = moduleItem.publicMethods();
                if (publicMethods) {
                    (0, _iterator.each)(publicMethods, function(index, methodName) {
                        if (moduleItem[methodName]) {
                            if (!that[methodName]) {
                                that[methodName] = function() {
                                    return moduleItem[methodName].apply(moduleItem, arguments)
                                }
                            } else {
                                throw _ui.default.Error("E1005", methodName)
                            }
                        } else {
                            throw _ui.default.Error("E1006", name, methodName)
                        }
                    })
                }
            };
            var createModuleItems = function(moduleTypes) {
                var moduleItems = {};
                (0, _iterator.each)(moduleTypes, function(name, moduleType) {
                    var moduleItem = new moduleType(that);
                    moduleItem.name = name;
                    registerPublicMethods(that, name, moduleItem);
                    moduleItems[name] = moduleItem
                });
                return moduleItems
            };
            that._controllers = createModuleItems(controllerTypes);
            that._views = createModuleItems(viewTypes)
        };
        var callModuleItemsMethod = function(that, methodName, args) {
            args = args || [];
            if (that._controllers) {
                (0, _iterator.each)(that._controllers, function() {
                    this[methodName] && this[methodName].apply(this, args)
                })
            }
            if (that._views) {
                (0, _iterator.each)(that._views, function() {
                    this[methodName] && this[methodName].apply(this, args)
                })
            }
        };
        var _default = {
            modules: [],
            View: View,
            ViewController: ViewController,
            Controller: Controller,
            registerModule: function(name, module) {
                var modules = this.modules;
                for (var i = 0; i < modules.length; i++) {
                    if (modules[i].name === name) {
                        return
                    }
                }
                module.name = name;
                modules.push(module);
                delete this.controllerTypes;
                delete this.viewTypes
            },
            registerModulesOrder: function(moduleNames) {
                this.modulesOrder = moduleNames
            },
            unregisterModule: function(name) {
                this.modules = (0, _common.grep)(this.modules, function(module) {
                    return module.name !== name
                });
                delete this.controllerTypes;
                delete this.viewTypes
            },
            processModules: processModules,
            callModuleItemsMethod: callModuleItemsMethod
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/support.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        Object.defineProperty(exports, "stylePropPrefix", {
            enumerable: true,
            get: function() {
                return _style.stylePropPrefix
            }
        });
        Object.defineProperty(exports, "styleProp", {
            enumerable: true,
            get: function() {
                return _style.styleProp
            }
        });
        exports.nativeScrolling = exports.animation = exports.transitionEndEventName = exports.transition = exports.touch = exports.inputType = exports.supportProp = exports.pointerEvents = exports.touchEvents = void 0;
        var _array = __webpack_require__( /*! ./array */ 12);
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../dom_adapter */ 11));
        var _common = __webpack_require__( /*! ./common */ 4);
        var _call_once = _interopRequireDefault(__webpack_require__( /*! ./call_once */ 85));
        var _window = __webpack_require__( /*! ./window */ 7);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../devices */ 13));
        var _style = __webpack_require__( /*! ./style */ 99);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _getNavigator = (0, _window.getNavigator)(),
            maxTouchPoints = _getNavigator.maxTouchPoints,
            msMaxTouchPoints = _getNavigator.msMaxTouchPoints,
            pointerEnabled = _getNavigator.pointerEnabled;
        var transitionEndEventNames = {
            webkitTransition: "webkitTransitionEnd",
            MozTransition: "transitionend",
            OTransition: "oTransitionEnd",
            msTransition: "MsTransitionEnd",
            transition: "transitionend"
        };
        var supportProp = function(prop) {
            return !!(0, _style.styleProp)(prop)
        };
        exports.supportProp = supportProp;
        var isNativeScrollingSupported = function() {
            var _devices$real = _devices.default.real(),
                platform = _devices$real.platform,
                version = _devices$real.version,
                isMac = _devices$real.mac;
            var isObsoleteAndroid = version && version[0] < 4 && "android" === platform;
            var isNativeScrollDevice = !isObsoleteAndroid && (0, _array.inArray)(platform, ["ios", "android"]) > -1 || isMac;
            return isNativeScrollDevice
        };
        var inputType = function(type) {
            if ("text" === type) {
                return true
            }
            var input = _dom_adapter.default.createElement("input");
            try {
                input.setAttribute("type", type);
                input.value = "wrongValue";
                return !input.value
            } catch (e) {
                return false
            }
        };
        exports.inputType = inputType;
        var detectTouchEvents = function(hasWindowProperty, maxTouchPoints) {
            return (hasWindowProperty("ontouchstart") || !!maxTouchPoints) && !hasWindowProperty("callPhantom")
        };
        var detectPointerEvent = function(hasWindowProperty, pointerEnabled) {
            var isPointerEnabled = (0, _common.ensureDefined)(pointerEnabled, true);
            var canUsePointerEvent = (0, _common.ensureDefined)(pointerEnabled, false);
            return hasWindowProperty("PointerEvent") && isPointerEnabled || canUsePointerEvent
        };
        var touchEvents = detectTouchEvents(_window.hasProperty, maxTouchPoints);
        exports.touchEvents = touchEvents;
        var pointerEvents = detectPointerEvent(_window.hasProperty, pointerEnabled);
        exports.pointerEvents = pointerEvents;
        var touchPointersPresent = !!maxTouchPoints || !!msMaxTouchPoints;
        var touch = touchEvents || pointerEvents && touchPointersPresent;
        exports.touch = touch;
        var transition = (0, _call_once.default)(function() {
            return supportProp("transition")
        });
        exports.transition = transition;
        var transitionEndEventName = (0, _call_once.default)(function() {
            return transitionEndEventNames[(0, _style.styleProp)("transition")]
        });
        exports.transitionEndEventName = transitionEndEventName;
        var animation = (0, _call_once.default)(function() {
            return supportProp("animation")
        });
        exports.animation = animation;
        var nativeScrolling = isNativeScrollingSupported();
        exports.nativeScrolling = nativeScrolling
    },
    /*!**********************************************!*\
      !*** ./artifacts/transpiled-npm/ui/popup.js ***!
      \**********************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _translator = __webpack_require__( /*! ../animation/translator */ 28);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../core/devices */ 13));
        var _element = __webpack_require__( /*! ../core/element */ 18);
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _empty_template = __webpack_require__( /*! ../core/templates/empty_template */ 91);
        var _array = __webpack_require__( /*! ../core/utils/array */ 12);
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../core/utils/browser */ 23));
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _inflector = __webpack_require__( /*! ../core/utils/inflector */ 39);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _size = __webpack_require__( /*! ../core/utils/size */ 192);
        var _position = __webpack_require__( /*! ../core/utils/position */ 22);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _version = __webpack_require__( /*! ../core/utils/version */ 72);
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _visibility_change = __webpack_require__( /*! ../events/visibility_change */ 59);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../localization/message */ 10));
        var _button = _interopRequireDefault(__webpack_require__( /*! ./button */ 37));
        var _overlay = _interopRequireDefault(__webpack_require__( /*! ./overlay */ 64));
        var _themes = __webpack_require__( /*! ./themes */ 34);
        __webpack_require__( /*! ./toolbar/ui.toolbar.base */ 337);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var POPUP_CLASS = "dx-popup";
        var POPUP_WRAPPER_CLASS = "dx-popup-wrapper";
        var POPUP_FULL_SCREEN_CLASS = "dx-popup-fullscreen";
        var POPUP_FULL_SCREEN_WIDTH_CLASS = "dx-popup-fullscreen-width";
        var POPUP_NORMAL_CLASS = "dx-popup-normal";
        var POPUP_CONTENT_CLASS = "dx-popup-content";
        var POPUP_DRAGGABLE_CLASS = "dx-popup-draggable";
        var POPUP_TITLE_CLASS = "dx-popup-title";
        var POPUP_TITLE_CLOSEBUTTON_CLASS = "dx-closebutton";
        var POPUP_BOTTOM_CLASS = "dx-popup-bottom";
        var POPUP_HAS_CLOSE_BUTTON_CLASS = "dx-has-close-button";
        var TEMPLATE_WRAPPER_CLASS = "dx-template-wrapper";
        var POPUP_CONTENT_FLEX_HEIGHT_CLASS = "dx-popup-flex-height";
        var POPUP_CONTENT_INHERIT_HEIGHT_CLASS = "dx-popup-inherit-height";
        var ALLOWED_TOOLBAR_ITEM_ALIASES = ["cancel", "clear", "done"];
        var BUTTON_DEFAULT_TYPE = "default";
        var BUTTON_NORMAL_TYPE = "normal";
        var BUTTON_TEXT_MODE = "text";
        var BUTTON_CONTAINED_MODE = "contained";
        var IS_IE11 = _browser.default.msie && 11 === parseInt(_browser.default.version);
        var IS_OLD_SAFARI = _browser.default.safari && (0, _version.compare)(_browser.default.version, [11]) < 0;
        var HEIGHT_STRATEGIES = {
            "static": "",
            inherit: POPUP_CONTENT_INHERIT_HEIGHT_CLASS,
            flex: POPUP_CONTENT_FLEX_HEIGHT_CLASS
        };
        var getButtonPlace = function(name) {
            var device = _devices.default.current();
            var platform = device.platform;
            var toolbar = "bottom";
            var location = "before";
            if ("ios" === platform) {
                switch (name) {
                    case "cancel":
                        toolbar = "top";
                        break;
                    case "clear":
                        toolbar = "top";
                        location = "after";
                        break;
                    case "done":
                        location = "after"
                }
            } else {
                if ("android" === platform && device.version && parseInt(device.version[0]) > 4) {
                    switch (name) {
                        case "cancel":
                            location = "after";
                            break;
                        case "done":
                            location = "after"
                    }
                }
            }
            return {
                toolbar: toolbar,
                location: location
            }
        };
        var Popup = _overlay.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    fullScreen: false,
                    title: "",
                    showTitle: true,
                    titleTemplate: "title",
                    onTitleRendered: null,
                    dragEnabled: false,
                    toolbarItems: [],
                    showCloseButton: false,
                    bottomTemplate: "bottom",
                    useDefaultToolbarButtons: false,
                    useFlatToolbarButtons: false,
                    autoResizeEnabled: true
                })
            },
            _defaultOptionsRules: function() {
                var themeName = (0, _themes.current)();
                return this.callBase().concat([{
                    device: {
                        platform: "ios"
                    },
                    options: {
                        animation: this._iosAnimation
                    }
                }, {
                    device: {
                        platform: "android"
                    },
                    options: {
                        animation: this._androidAnimation
                    }
                }, {
                    device: {
                        platform: "generic"
                    },
                    options: {
                        showCloseButton: true
                    }
                }, {
                    device: function(_device) {
                        return "desktop" === _devices.default.real().deviceType && "generic" === _device.platform
                    },
                    options: {
                        dragEnabled: true
                    }
                }, {
                    device: function() {
                        return "desktop" === _devices.default.real().deviceType && !_devices.default.isSimulator()
                    },
                    options: {
                        focusStateEnabled: true
                    }
                }, {
                    device: function() {
                        return (0, _themes.isMaterial)(themeName)
                    },
                    options: {
                        useDefaultToolbarButtons: true,
                        useFlatToolbarButtons: true
                    }
                }])
            },
            _iosAnimation: {
                show: {
                    type: "slide",
                    duration: 400,
                    from: {
                        position: {
                            my: "top",
                            at: "bottom"
                        }
                    },
                    to: {
                        position: {
                            my: "center",
                            at: "center"
                        }
                    }
                },
                hide: {
                    type: "slide",
                    duration: 400,
                    from: {
                        opacity: 1,
                        position: {
                            my: "center",
                            at: "center"
                        }
                    },
                    to: {
                        opacity: 1,
                        position: {
                            my: "top",
                            at: "bottom"
                        }
                    }
                }
            },
            _androidAnimation: function() {
                var fullScreenConfig = {
                    show: {
                        type: "slide",
                        duration: 300,
                        from: {
                            top: "30%",
                            opacity: 0
                        },
                        to: {
                            top: 0,
                            opacity: 1
                        }
                    },
                    hide: {
                        type: "slide",
                        duration: 300,
                        from: {
                            top: 0,
                            opacity: 1
                        },
                        to: {
                            top: "30%",
                            opacity: 0
                        }
                    }
                };
                var defaultConfig = {
                    show: {
                        type: "fade",
                        duration: 400,
                        from: 0,
                        to: 1
                    },
                    hide: {
                        type: "fade",
                        duration: 400,
                        from: 1,
                        to: 0
                    }
                };
                return this.option("fullScreen") ? fullScreenConfig : defaultConfig
            },
            _init: function() {
                this.callBase();
                this.$element().addClass(POPUP_CLASS);
                this._wrapper().addClass(POPUP_WRAPPER_CLASS);
                this._$popupContent = this._$content.wrapInner((0, _renderer.default)("<div>").addClass(POPUP_CONTENT_CLASS)).children().eq(0)
            },
            _render: function() {
                var isFullscreen = this.option("fullScreen");
                this._toggleFullScreenClass(isFullscreen);
                this.callBase()
            },
            _toggleFullScreenClass: function(value) {
                this._$content.toggleClass(POPUP_FULL_SCREEN_CLASS, value).toggleClass(POPUP_NORMAL_CLASS, !value)
            },
            _initTemplates: function() {
                this.callBase();
                this._templateManager.addDefaultTemplates({
                    title: new _empty_template.EmptyTemplate,
                    bottom: new _empty_template.EmptyTemplate
                })
            },
            _renderContentImpl: function() {
                this._renderTitle();
                this.callBase();
                this._renderBottom()
            },
            _renderTitle: function() {
                var items = this._getToolbarItems("top");
                var titleText = this.option("title");
                var showTitle = this.option("showTitle");
                if (showTitle && !!titleText) {
                    items.unshift({
                        location: _devices.default.current().ios ? "center" : "before",
                        text: titleText
                    })
                }
                if (showTitle || items.length > 0) {
                    this._$title && this._$title.remove();
                    var $title = (0, _renderer.default)("<div>").addClass(POPUP_TITLE_CLASS).insertBefore(this.$content());
                    this._$title = this._renderTemplateByType("titleTemplate", items, $title).addClass(POPUP_TITLE_CLASS);
                    this._renderDrag();
                    this._executeTitleRenderAction(this._$title);
                    this._$title.toggleClass(POPUP_HAS_CLOSE_BUTTON_CLASS, this._hasCloseButton())
                } else {
                    if (this._$title) {
                        this._$title.detach()
                    }
                }
            },
            _renderTemplateByType: function(optionName, data, $container, additionalToolbarOptions) {
                var template = this._getTemplateByOption(optionName);
                var toolbarTemplate = template instanceof _empty_template.EmptyTemplate;
                if (toolbarTemplate) {
                    var integrationOptions = (0, _extend.extend)({}, this.option("integrationOptions"), {
                        skipTemplates: ["content", "title"]
                    });
                    var toolbarOptions = (0, _extend.extend)(additionalToolbarOptions, {
                        items: data,
                        rtlEnabled: this.option("rtlEnabled"),
                        useDefaultButtons: this.option("useDefaultToolbarButtons"),
                        useFlatButtons: this.option("useFlatToolbarButtons"),
                        integrationOptions: integrationOptions
                    });
                    this._getTemplate("dx-polymorph-widget").render({
                        container: $container,
                        model: {
                            widget: "dxToolbarBase",
                            options: toolbarOptions
                        }
                    });
                    var $toolbar = $container.children("div");
                    $container.replaceWith($toolbar);
                    return $toolbar
                } else {
                    var $result = (0, _renderer.default)(template.render({
                        container: (0, _element.getPublicElement)($container)
                    }));
                    if ($result.hasClass(TEMPLATE_WRAPPER_CLASS)) {
                        $container.replaceWith($result);
                        $container = $result
                    }
                    return $container
                }
            },
            _executeTitleRenderAction: function($titleElement) {
                this._getTitleRenderAction()({
                    titleElement: (0, _element.getPublicElement)($titleElement)
                })
            },
            _getTitleRenderAction: function() {
                return this._titleRenderAction || this._createTitleRenderAction()
            },
            _createTitleRenderAction: function() {
                return this._titleRenderAction = this._createActionByOption("onTitleRendered", {
                    element: this.element(),
                    excludeValidators: ["disabled", "readOnly"]
                })
            },
            _getCloseButton: function() {
                return {
                    toolbar: "top",
                    location: "after",
                    template: this._getCloseButtonRenderer()
                }
            },
            _getCloseButtonRenderer: function() {
                var _this = this;
                return function(_, __, container) {
                    var $button = (0, _renderer.default)("<div>").addClass(POPUP_TITLE_CLOSEBUTTON_CLASS);
                    _this._createComponent($button, _button.default, {
                        icon: "close",
                        onClick: _this._createToolbarItemAction(void 0),
                        stylingMode: "text",
                        integrationOptions: {}
                    });
                    (0, _renderer.default)(container).append($button)
                }
            },
            _getToolbarItems: function(toolbar) {
                var _this2 = this;
                var toolbarItems = this.option("toolbarItems");
                var toolbarsItems = [];
                this._toolbarItemClasses = [];
                var currentPlatform = _devices.default.current().platform;
                var index = 0;
                (0, _iterator.each)(toolbarItems, function(_, data) {
                    var isShortcut = (0, _type.isDefined)(data.shortcut);
                    var item = isShortcut ? getButtonPlace(data.shortcut) : data;
                    if (isShortcut && "ios" === currentPlatform && index < 2) {
                        item.toolbar = "top";
                        index++
                    }
                    item.toolbar = data.toolbar || item.toolbar || "top";
                    if (item && item.toolbar === toolbar) {
                        if (isShortcut) {
                            (0, _extend.extend)(item, {
                                location: data.location
                            }, _this2._getToolbarItemByAlias(data))
                        }
                        var isLTROrder = "generic" === currentPlatform;
                        if ("done" === data.shortcut && isLTROrder || "cancel" === data.shortcut && !isLTROrder) {
                            toolbarsItems.unshift(item)
                        } else {
                            toolbarsItems.push(item)
                        }
                    }
                });
                if ("top" === toolbar && this._hasCloseButton()) {
                    toolbarsItems.push(this._getCloseButton())
                }
                return toolbarsItems
            },
            _hasCloseButton: function() {
                return this.option("showCloseButton") && this.option("showTitle")
            },
            _getLocalizationKey: function(itemType) {
                return "done" === itemType.toLowerCase() ? "OK" : (0, _inflector.camelize)(itemType, true)
            },
            _getToolbarItemByAlias: function(data) {
                var that = this;
                var itemType = data.shortcut;
                if ((0, _array.inArray)(itemType, ALLOWED_TOOLBAR_ITEM_ALIASES) < 0) {
                    return false
                }
                var itemConfig = (0, _extend.extend)({
                    text: _message.default.format(this._getLocalizationKey(itemType)),
                    onClick: this._createToolbarItemAction(data.onClick),
                    integrationOptions: {},
                    type: that.option("useDefaultToolbarButtons") ? BUTTON_DEFAULT_TYPE : BUTTON_NORMAL_TYPE,
                    stylingMode: that.option("useFlatToolbarButtons") ? BUTTON_TEXT_MODE : BUTTON_CONTAINED_MODE
                }, data.options || {});
                var itemClass = POPUP_CLASS + "-" + itemType;
                this._toolbarItemClasses.push(itemClass);
                return {
                    template: function(_, __, container) {
                        var $toolbarItem = (0, _renderer.default)("<div>").addClass(itemClass).appendTo(container);
                        that._createComponent($toolbarItem, _button.default, itemConfig)
                    }
                }
            },
            _createToolbarItemAction: function(clickAction) {
                return this._createAction(clickAction, {
                    afterExecute: function(e) {
                        e.component.hide()
                    }
                })
            },
            _renderBottom: function() {
                var items = this._getToolbarItems("bottom");
                if (items.length) {
                    this._$bottom && this._$bottom.remove();
                    var $bottom = (0, _renderer.default)("<div>").addClass(POPUP_BOTTOM_CLASS).insertAfter(this.$content());
                    this._$bottom = this._renderTemplateByType("bottomTemplate", items, $bottom, {
                        compactMode: true
                    }).addClass(POPUP_BOTTOM_CLASS);
                    this._toggleClasses()
                } else {
                    this._$bottom && this._$bottom.detach()
                }
            },
            _toggleClasses: function() {
                var _this3 = this;
                var aliases = ALLOWED_TOOLBAR_ITEM_ALIASES;
                (0, _iterator.each)(aliases, function(_, alias) {
                    var className = POPUP_CLASS + "-" + alias;
                    if ((0, _array.inArray)(className, _this3._toolbarItemClasses) >= 0) {
                        _this3._wrapper().addClass(className + "-visible");
                        _this3._$bottom.addClass(className)
                    } else {
                        _this3._wrapper().removeClass(className + "-visible");
                        _this3._$bottom.removeClass(className)
                    }
                })
            },
            _getContainer: function() {
                if (this.option("fullScreen")) {
                    return (0, _renderer.default)(window)
                }
                return this.callBase()
            },
            _getDragTarget: function() {
                return this.topToolbar()
            },
            _renderGeometryImpl: function(isDimensionChanged) {
                if (!isDimensionChanged) {
                    this._resetContentHeight()
                }
                this.callBase.apply(this, arguments);
                this._setContentHeight()
            },
            _resetContentHeight: function() {
                this._$popupContent.css({
                    height: "auto",
                    maxHeight: "none"
                })
            },
            _renderDrag: function() {
                this.callBase();
                this._$content.toggleClass(POPUP_DRAGGABLE_CLASS, this.option("dragEnabled"))
            },
            _renderResize: function() {
                this.callBase();
                this._resizable.option("onResize", function() {
                    this._setContentHeight();
                    this._actions.onResize(arguments)
                }.bind(this))
            },
            _setContentHeight: function() {
                (this.option("forceApplyBindings") || _common.noop)();
                var overlayContent = this.overlayContent().get(0);
                var currentHeightStrategyClass = this._chooseHeightStrategy(overlayContent);
                this.$content().css(this._getHeightCssStyles(currentHeightStrategyClass, overlayContent));
                this._setHeightClasses(this.overlayContent(), currentHeightStrategyClass)
            },
            _heightStrategyChangeOffset: function(currentHeightStrategyClass, popupVerticalPaddings) {
                return currentHeightStrategyClass === HEIGHT_STRATEGIES.flex ? -popupVerticalPaddings : 0
            },
            _chooseHeightStrategy: function(overlayContent) {
                var isAutoWidth = "auto" === overlayContent.style.width || "" === overlayContent.style.width;
                var currentHeightStrategyClass = HEIGHT_STRATEGIES.static;
                if (this._isAutoHeight() && this.option("autoResizeEnabled")) {
                    if (isAutoWidth || IS_OLD_SAFARI) {
                        if (!IS_IE11) {
                            currentHeightStrategyClass = HEIGHT_STRATEGIES.inherit
                        }
                    } else {
                        currentHeightStrategyClass = HEIGHT_STRATEGIES.flex
                    }
                }
                return currentHeightStrategyClass
            },
            _getHeightCssStyles: function(currentHeightStrategyClass, overlayContent) {
                var cssStyles = {};
                var contentMaxHeight = this._getOptionValue("maxHeight", overlayContent);
                var contentMinHeight = this._getOptionValue("minHeight", overlayContent);
                var popupHeightParts = this._splitPopupHeight();
                var toolbarsAndVerticalOffsetsHeight = popupHeightParts.header + popupHeightParts.footer + popupHeightParts.contentVerticalOffsets + popupHeightParts.popupVerticalOffsets + this._heightStrategyChangeOffset(currentHeightStrategyClass, popupHeightParts.popupVerticalPaddings);
                if (currentHeightStrategyClass === HEIGHT_STRATEGIES.static) {
                    if (!this._isAutoHeight() || contentMaxHeight || contentMinHeight) {
                        var overlayHeight = this.option("fullScreen") ? Math.min((0, _position.getBoundingRect)(overlayContent).height, (0, _window.getWindow)().innerHeight) : (0, _position.getBoundingRect)(overlayContent).height;
                        var contentHeight = overlayHeight - toolbarsAndVerticalOffsetsHeight;
                        cssStyles = {
                            height: Math.max(0, contentHeight),
                            minHeight: "auto",
                            maxHeight: "auto"
                        }
                    }
                } else {
                    var container = (0, _renderer.default)(this._getContainer()).get(0);
                    var maxHeightValue = (0, _size.addOffsetToMaxHeight)(contentMaxHeight, -toolbarsAndVerticalOffsetsHeight, container);
                    var minHeightValue = (0, _size.addOffsetToMinHeight)(contentMinHeight, -toolbarsAndVerticalOffsetsHeight, container);
                    cssStyles = {
                        height: "auto",
                        minHeight: minHeightValue,
                        maxHeight: maxHeightValue
                    }
                }
                return cssStyles
            },
            _setHeightClasses: function($container, currentClass) {
                var excessClasses = "";
                for (var name in HEIGHT_STRATEGIES) {
                    if (HEIGHT_STRATEGIES[name] !== currentClass) {
                        excessClasses += " " + HEIGHT_STRATEGIES[name]
                    }
                }
                $container.removeClass(excessClasses).addClass(currentClass)
            },
            _isAutoHeight: function() {
                return "auto" === this.overlayContent().get(0).style.height
            },
            _splitPopupHeight: function() {
                var topToolbar = this.topToolbar();
                var bottomToolbar = this.bottomToolbar();
                return {
                    header: (0, _size.getVisibleHeight)(topToolbar && topToolbar.get(0)),
                    footer: (0, _size.getVisibleHeight)(bottomToolbar && bottomToolbar.get(0)),
                    contentVerticalOffsets: (0, _size.getVerticalOffsets)(this.overlayContent().get(0), true),
                    popupVerticalOffsets: (0, _size.getVerticalOffsets)(this.$content().get(0), true),
                    popupVerticalPaddings: (0, _size.getVerticalOffsets)(this.$content().get(0), false)
                }
            },
            _shouldFixBodyPosition: function() {
                return this.callBase() || this.option("fullScreen")
            },
            _toggleSafariFullScreen: function(value) {
                var toggleFullScreenBeforeShown = this._shouldFixBodyPosition() && value && !this._isShown;
                if (toggleFullScreenBeforeShown) {
                    this._bodyScrollTop = value ? window.pageYOffset : void 0
                } else {
                    this._toggleSafariScrolling(!value)
                }
            },
            _renderDimensions: function() {
                if (this.option("fullScreen")) {
                    this._$content.css({
                        width: "100%",
                        height: "100%",
                        minWidth: "",
                        maxWidth: "",
                        minHeight: "",
                        maxHeight: ""
                    })
                } else {
                    this.callBase.apply(this, arguments)
                }
                if ((0, _window.hasWindow)()) {
                    this._renderFullscreenWidthClass()
                }
            },
            _renderFullscreenWidthClass: function() {
                this.overlayContent().toggleClass(POPUP_FULL_SCREEN_WIDTH_CLASS, this.overlayContent().outerWidth() === (0, _renderer.default)(window).width())
            },
            refreshPosition: function() {
                this._renderPosition()
            },
            _renderPosition: function() {
                if (this.option("fullScreen")) {
                    (0, _translator.move)(this._$content, {
                        top: 0,
                        left: 0
                    })
                } else {
                    (this.option("forceApplyBindings") || _common.noop)();
                    return this.callBase.apply(this, arguments)
                }
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "showTitle":
                    case "title":
                    case "titleTemplate":
                        this._renderTitle();
                        this._renderGeometry();
                        (0, _visibility_change.triggerResizeEvent)(this._$content);
                        break;
                    case "bottomTemplate":
                        this._renderBottom();
                        this._renderGeometry();
                        (0, _visibility_change.triggerResizeEvent)(this._$content);
                        break;
                    case "onTitleRendered":
                        this._createTitleRenderAction(args.value);
                        break;
                    case "toolbarItems":
                    case "useDefaultToolbarButtons":
                    case "useFlatToolbarButtons":
                        var shouldRenderGeometry = !args.fullName.match(/^toolbarItems((\[\d+\])(\.(options|visible).*)?)?$/);
                        this._renderTitle();
                        this._renderBottom();
                        if (shouldRenderGeometry) {
                            this._renderGeometry();
                            (0, _visibility_change.triggerResizeEvent)(this._$content)
                        }
                        break;
                    case "dragEnabled":
                        this._renderDrag();
                        break;
                    case "autoResizeEnabled":
                        this._renderGeometry();
                        (0, _visibility_change.triggerResizeEvent)(this._$content);
                        break;
                    case "fullScreen":
                        this._toggleFullScreenClass(args.value);
                        this._toggleSafariFullScreen(args.value);
                        this._renderGeometry();
                        (0, _visibility_change.triggerResizeEvent)(this._$content);
                        break;
                    case "showCloseButton":
                        this._renderTitle();
                        break;
                    default:
                        this.callBase(args)
                }
            },
            bottomToolbar: function() {
                return this._$bottom
            },
            topToolbar: function() {
                return this._$title
            },
            $content: function() {
                return this._$popupContent
            },
            content: function() {
                return (0, _element.getPublicElement)(this._$popupContent)
            },
            overlayContent: function() {
                return this._$content
            }
        });
        (0, _component_registrator.default)("dxPopup", Popup);
        var _default = Popup;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************!*\
      !*** ./artifacts/transpiled-npm/localization/number.js ***!
      \*********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _dependency_injector = _interopRequireDefault(__webpack_require__( /*! ../core/utils/dependency_injector */ 58));
        var _array = __webpack_require__( /*! ../core/utils/array */ 12);
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _number = __webpack_require__( /*! ./ldml/number */ 323);
        var _config = _interopRequireDefault(__webpack_require__( /*! ../core/config */ 31));
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../core/errors */ 25));
        var _utils = __webpack_require__( /*! ./utils */ 240);
        var _currency = _interopRequireDefault(__webpack_require__( /*! ./currency */ 114));
        var _number2 = _interopRequireDefault(__webpack_require__( /*! ./intl/number */ 494));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _slicedToArray(arr, i) {
            return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest()
        }

        function _nonIterableRest() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }

        function _iterableToArrayLimit(arr, i) {
            var _i = arr && ("undefined" !== typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]);
            if (null == _i) {
                return
            }
            var _arr = [];
            var _n = true;
            var _d = false;
            var _s, _e;
            try {
                for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
                    _arr.push(_s.value);
                    if (i && _arr.length === i) {
                        break
                    }
                }
            } catch (err) {
                _d = true;
                _e = err
            } finally {
                try {
                    if (!_n && null != _i.return) {
                        _i.return()
                    }
                } finally {
                    if (_d) {
                        throw _e
                    }
                }
            }
            return _arr
        }

        function _arrayWithHoles(arr) {
            if (Array.isArray(arr)) {
                return arr
            }
        }
        var hasIntl = "undefined" !== typeof Intl;
        var MAX_LARGE_NUMBER_POWER = 4;
        var DECIMAL_BASE = 10;
        var NUMERIC_FORMATS = ["currency", "fixedpoint", "exponential", "percent", "decimal"];
        var LargeNumberFormatPostfixes = {
            1: "K",
            2: "M",
            3: "B",
            4: "T"
        };
        var LargeNumberFormatPowers = {
            largenumber: "auto",
            thousands: 1,
            millions: 2,
            billions: 3,
            trillions: 4
        };
        var numberLocalization = (0, _dependency_injector.default)({
            engine: function() {
                return "base"
            },
            numericFormats: NUMERIC_FORMATS,
            defaultLargeNumberFormatPostfixes: LargeNumberFormatPostfixes,
            _parseNumberFormatString: function(formatType) {
                var formatObject = {};
                if (!formatType || "string" !== typeof formatType) {
                    return
                }
                var formatList = formatType.toLowerCase().split(" ");
                (0, _iterator.each)(formatList, function(index, value) {
                    if ((0, _array.inArray)(value, NUMERIC_FORMATS) > -1) {
                        formatObject.formatType = value
                    } else {
                        if (value in LargeNumberFormatPowers) {
                            formatObject.power = LargeNumberFormatPowers[value]
                        }
                    }
                });
                if (formatObject.power && !formatObject.formatType) {
                    formatObject.formatType = "fixedpoint"
                }
                if (formatObject.formatType) {
                    return formatObject
                }
            },
            _calculateNumberPower: function(value, base, minPower, maxPower) {
                var number = Math.abs(value);
                var power = 0;
                if (number > 1) {
                    while (number && number >= base && (void 0 === maxPower || power < maxPower)) {
                        power++;
                        number /= base
                    }
                } else {
                    if (number > 0 && number < 1) {
                        while (number < 1 && (void 0 === minPower || power > minPower)) {
                            power--;
                            number *= base
                        }
                    }
                }
                return power
            },
            _getNumberByPower: function(number, power, base) {
                var result = number;
                while (power > 0) {
                    result /= base;
                    power--
                }
                while (power < 0) {
                    result *= base;
                    power++
                }
                return result
            },
            _formatNumber: function(value, formatObject, formatConfig) {
                if ("auto" === formatObject.power) {
                    formatObject.power = this._calculateNumberPower(value, 1e3, 0, MAX_LARGE_NUMBER_POWER)
                }
                if (formatObject.power) {
                    value = this._getNumberByPower(value, formatObject.power, 1e3)
                }
                var powerPostfix = this.defaultLargeNumberFormatPostfixes[formatObject.power] || "";
                var result = this._formatNumberCore(value, formatObject.formatType, formatConfig);
                result = result.replace(/(\d|.$)(\D*)$/, "$1" + powerPostfix + "$2");
                return result
            },
            _formatNumberExponential: function(value, formatConfig) {
                var power = this._calculateNumberPower(value, DECIMAL_BASE);
                var number = this._getNumberByPower(value, power, DECIMAL_BASE);
                if (void 0 === formatConfig.precision) {
                    formatConfig.precision = 1
                }
                if (number.toFixed(formatConfig.precision || 0) >= DECIMAL_BASE) {
                    power++;
                    number /= DECIMAL_BASE
                }
                var powString = (power >= 0 ? "+" : "") + power.toString();
                return this._formatNumberCore(number, "fixedpoint", formatConfig) + "E" + powString
            },
            _addZeroes: function(value, precision) {
                var multiplier = Math.pow(10, precision);
                var sign = value < 0 ? "-" : "";
                value = (Math.abs(value) * multiplier >>> 0) / multiplier;
                var result = value.toString();
                while (result.length < precision) {
                    result = "0" + result
                }
                return sign + result
            },
            _addGroupSeparators: function(value) {
                var parts = value.toString().split(".");
                return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, (0, _config.default)().thousandsSeparator) + (parts[1] ? (0, _config.default)().decimalSeparator + parts[1] : "")
            },
            _formatNumberCore: function(value, format, formatConfig) {
                if ("exponential" === format) {
                    return this._formatNumberExponential(value, formatConfig)
                }
                if ("decimal" !== format && null !== formatConfig.precision) {
                    formatConfig.precision = formatConfig.precision || 0
                }
                if ("percent" === format) {
                    value = 100 * value
                }
                if (void 0 !== formatConfig.precision) {
                    if ("decimal" === format) {
                        value = this._addZeroes(value, formatConfig.precision)
                    } else {
                        value = null === formatConfig.precision ? value.toPrecision() : (0, _utils.toFixed)(value, formatConfig.precision)
                    }
                }
                if ("decimal" !== format) {
                    value = this._addGroupSeparators(value)
                } else {
                    value = value.toString().replace(".", (0, _config.default)().decimalSeparator)
                }
                if ("percent" === format) {
                    value += "%"
                }
                return value
            },
            _normalizeFormat: function(format) {
                if (!format) {
                    return {}
                }
                if ("function" === typeof format) {
                    return format
                }
                if (!(0, _type.isPlainObject)(format)) {
                    format = {
                        type: format
                    }
                }
                return format
            },
            _getSeparators: function() {
                return {
                    decimalSeparator: this.getDecimalSeparator(),
                    thousandsSeparator: this.getThousandsSeparator()
                }
            },
            getThousandsSeparator: function() {
                return this.format(1e4, "fixedPoint")[2]
            },
            getDecimalSeparator: function() {
                return this.format(1.2, {
                    type: "fixedPoint",
                    precision: 1
                })[1]
            },
            convertDigits: function(value, toStandard) {
                var digits = this.format(90, "decimal");
                if ("string" !== typeof value || "0" === digits[1]) {
                    return value
                }
                var fromFirstDigit = toStandard ? digits[1] : "0";
                var toFirstDigit = toStandard ? "0" : digits[1];
                var fromLastDigit = toStandard ? digits[0] : "9";
                var regExp = new RegExp("[" + fromFirstDigit + "-" + fromLastDigit + "]", "g");
                return value.replace(regExp, function(char) {
                    return String.fromCharCode(char.charCodeAt(0) + (toFirstDigit.charCodeAt(0) - fromFirstDigit.charCodeAt(0)))
                })
            },
            getNegativeEtalonRegExp: function(format) {
                var separators = this._getSeparators();
                var digitalRegExp = new RegExp("[0-9" + (0, _common.escapeRegExp)(separators.decimalSeparator + separators.thousandsSeparator) + "]+", "g");
                var specialCharacters = ["\\", "(", ")", "[", "]", "*", "+", "$", "^", "?", "|", "{", "}"];
                var negativeEtalon = this.format(-1, format).replace(digitalRegExp, "1");
                specialCharacters.forEach(function(char) {
                    negativeEtalon = negativeEtalon.replace(char, "\\".concat(char))
                });
                negativeEtalon = negativeEtalon.replace(" ", "\\s");
                negativeEtalon = negativeEtalon.replace("1", ".+");
                return new RegExp(negativeEtalon, "g")
            },
            getSign: function(text, format) {
                if ("-" === text.replace(/[^0-9-]/g, "").charAt(0)) {
                    return -1
                }
                if (!format) {
                    return 1
                }
                var negativeEtalon = this.getNegativeEtalonRegExp(format);
                return text.match(negativeEtalon) ? -1 : 1
            },
            format: function(value, _format) {
                if ("number" !== typeof value) {
                    return value
                }
                if ("number" === typeof _format) {
                    return value
                }
                _format = _format && _format.formatter || _format;
                if ("function" === typeof _format) {
                    return _format(value)
                }
                _format = this._normalizeFormat(_format);
                if (!_format.type) {
                    _format.type = "decimal"
                }
                var numberConfig = this._parseNumberFormatString(_format.type);
                if (!numberConfig) {
                    var formatterConfig = this._getSeparators();
                    formatterConfig.unlimitedIntegerDigits = _format.unlimitedIntegerDigits;
                    return this.convertDigits((0, _number.getFormatter)(_format.type, formatterConfig)(value))
                }
                return this._formatNumber(value, numberConfig, _format)
            },
            parse: function(text, format) {
                if (!text) {
                    return
                }
                if (format && format.parser) {
                    return format.parser(text)
                }
                text = this.convertDigits(text, true);
                if (format && "string" !== typeof format) {
                    _errors.default.log("W0011")
                }
                var decimalSeparator = this.getDecimalSeparator();
                var regExp = new RegExp("[^0-9" + (0, _common.escapeRegExp)(decimalSeparator) + "]", "g");
                var cleanedText = text.replace(regExp, "").replace(decimalSeparator, ".").replace(/\.$/g, "");
                if ("." === cleanedText || "" === cleanedText) {
                    return null
                }
                if (this._calcSignificantDigits(cleanedText) > 15) {
                    return NaN
                }
                var parsed = +cleanedText * this.getSign(text, format);
                format = this._normalizeFormat(format);
                var formatConfig = this._parseNumberFormatString(format.type);
                var power = null === formatConfig || void 0 === formatConfig ? void 0 : formatConfig.power;
                if (power) {
                    if ("auto" === power) {
                        var match = text.match(/\d(K|M|B|T)/);
                        if (match) {
                            power = (0, _array.find)(Object.keys(LargeNumberFormatPostfixes), function(power) {
                                return LargeNumberFormatPostfixes[power] === match[1]
                            })
                        }
                    }
                    parsed *= Math.pow(10, 3 * power)
                }
                if ("percent" === (null === formatConfig || void 0 === formatConfig ? void 0 : formatConfig.formatType)) {
                    parsed /= 100
                }
                return parsed
            },
            _calcSignificantDigits: function(text) {
                var _text$split = text.split("."),
                    _text$split2 = _slicedToArray(_text$split, 2),
                    integer = _text$split2[0],
                    fractional = _text$split2[1];
                var calcDigitsAfterLeadingZeros = function(digits) {
                    var index = -1;
                    for (var i = 0; i < digits.length; i++) {
                        if ("0" !== digits[i]) {
                            index = i;
                            break
                        }
                    }
                    return index > -1 ? digits.length - index : 0
                };
                var result = 0;
                if (integer) {
                    result += calcDigitsAfterLeadingZeros(integer.split(""))
                }
                if (fractional) {
                    result += calcDigitsAfterLeadingZeros(fractional.split("").reverse())
                }
                return result
            }
        });
        numberLocalization.inject(_currency.default);
        if (hasIntl) {
            numberLocalization.inject(_number2.default)
        }
        var _default = numberLocalization;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************!*\
      !*** ./artifacts/transpiled-npm/data/query.js ***!
      \************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _query_implementation = __webpack_require__( /*! ./query_implementation */ 251);
        var query = function() {
            var impl = Array.isArray(arguments[0]) ? "array" : "remote";
            return _query_implementation.queryImpl[impl].apply(this, arguments)
        };
        var _default = query;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/ready_callbacks.js ***!
      \****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../dom_adapter */ 11));
        var _dependency_injector = _interopRequireDefault(__webpack_require__( /*! ./dependency_injector */ 58));
        var _window = __webpack_require__( /*! ./window */ 7);
        var _call_once = _interopRequireDefault(__webpack_require__( /*! ./call_once */ 85));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var callbacks = [];
        var isReady = function() {
            return "complete" === _dom_adapter.default.getReadyState() || "loading" !== _dom_adapter.default.getReadyState() && !_dom_adapter.default.getDocumentElement().doScroll
        };
        var subscribeReady = (0, _call_once.default)(function() {
            var removeListener = _dom_adapter.default.listen(_dom_adapter.default.getDocument(), "DOMContentLoaded", function() {
                readyCallbacks.fire();
                removeListener()
            })
        });
        var readyCallbacks = {
            add: function(callback) {
                var windowExists = (0, _window.hasWindow)();
                if (windowExists && isReady()) {
                    callback()
                } else {
                    callbacks.push(callback);
                    windowExists && subscribeReady()
                }
            },
            fire: function() {
                callbacks.forEach(function(callback) {
                    return callback()
                });
                callbacks = []
            }
        };
        var _default = (0, _dependency_injector.default)(readyCallbacks);
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************!*\
      !*** ./node_modules/preact/dist/preact.module.js ***!
      \***************************************************/
    /*! exports provided: render, hydrate, createElement, h, Fragment, createRef, isValidElement, Component, cloneElement, createContext, toChildArray, options */
    /*! all exports used */
    function(module, __webpack_exports__, __webpack_require__) {
        Object.defineProperty(__webpack_exports__, "__esModule", {
            value: true
        });
        __webpack_require__.d(__webpack_exports__, "render", function() {
            return N
        });
        __webpack_require__.d(__webpack_exports__, "hydrate", function() {
            return O
        });
        __webpack_require__.d(__webpack_exports__, "createElement", function() {
            return a
        });
        __webpack_require__.d(__webpack_exports__, "h", function() {
            return a
        });
        __webpack_require__.d(__webpack_exports__, "Fragment", function() {
            return y
        });
        __webpack_require__.d(__webpack_exports__, "createRef", function() {
            return h
        });
        __webpack_require__.d(__webpack_exports__, "isValidElement", function() {
            return l
        });
        __webpack_require__.d(__webpack_exports__, "Component", function() {
            return p
        });
        __webpack_require__.d(__webpack_exports__, "cloneElement", function() {
            return S
        });
        __webpack_require__.d(__webpack_exports__, "createContext", function() {
            return q
        });
        __webpack_require__.d(__webpack_exports__, "toChildArray", function() {
            return w
        });
        __webpack_require__.d(__webpack_exports__, "options", function() {
            return n
        });
        var n, l, u, i, t, o, r = {},
            f = [],
            e = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;

        function c(n, l) {
            for (var u in l) {
                n[u] = l[u]
            }
            return n
        }

        function s(n) {
            var l = n.parentNode;
            l && l.removeChild(n)
        }

        function a(n, l, u) {
            var i, t, o, r = arguments,
                f = {};
            for (o in l) {
                "key" == o ? i = l[o] : "ref" == o ? t = l[o] : f[o] = l[o]
            }
            if (arguments.length > 3) {
                for (u = [u], o = 3; o < arguments.length; o++) {
                    u.push(r[o])
                }
            }
            if (null != u && (f.children = u), "function" == typeof n && null != n.defaultProps) {
                for (o in n.defaultProps) {
                    void 0 === f[o] && (f[o] = n.defaultProps[o])
                }
            }
            return v(n, f, i, t, null)
        }

        function v(l, u, i, t, o) {
            var r = {
                type: l,
                props: u,
                key: i,
                ref: t,
                __k: null,
                __: null,
                __b: 0,
                __e: null,
                __d: void 0,
                __c: null,
                __h: null,
                constructor: void 0,
                __v: null == o ? ++n.__v : o
            };
            return null != n.vnode && n.vnode(r), r
        }

        function h() {
            return {
                current: null
            }
        }

        function y(n) {
            return n.children
        }

        function p(n, l) {
            this.props = n, this.context = l
        }

        function d(n, l) {
            if (null == l) {
                return n.__ ? d(n.__, n.__.__k.indexOf(n) + 1) : null
            }
            for (var u; l < n.__k.length; l++) {
                if (null != (u = n.__k[l]) && null != u.__e) {
                    return u.__e
                }
            }
            return "function" == typeof n.type ? d(n) : null
        }

        function _(n) {
            var l, u;
            if (null != (n = n.__) && null != n.__c) {
                for (n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++) {
                    if (null != (u = n.__k[l]) && null != u.__e) {
                        n.__e = n.__c.base = u.__e;
                        break
                    }
                }
                return _(n)
            }
        }

        function k(l) {
            (!l.__d && (l.__d = !0) && u.push(l) && !b.__r++ || t !== n.debounceRendering) && ((t = n.debounceRendering) || i)(b)
        }

        function b() {
            for (var n; b.__r = u.length;) {
                n = u.sort(function(n, l) {
                    return n.__v.__b - l.__v.__b
                }), u = [], n.some(function(n) {
                    var l, u, i, t, o, r;
                    n.__d && (o = (t = (l = n).__v).__e, (r = l.__P) && (u = [], (i = c({}, t)).__v = t.__v + 1, I(r, t, i, l.__n, void 0 !== r.ownerSVGElement, null != t.__h ? [o] : null, u, null == o ? d(t) : o, t.__h), T(u, t), t.__e != o && _(t)))
                })
            }
        }

        function m(n, l, u, i, t, o, e, c, s, a) {
            var h, p, _, k, b, m, w, A = i && i.__k || f,
                P = A.length;
            for (u.__k = [], h = 0; h < l.length; h++) {
                if (null != (k = u.__k[h] = null == (k = l[h]) || "boolean" == typeof k ? null : "string" == typeof k || "number" == typeof k || "bigint" == typeof k ? v(null, k, null, null, k) : Array.isArray(k) ? v(y, {
                        children: k
                    }, null, null, null) : k.__b > 0 ? v(k.type, k.props, k.key, null, k.__v) : k)) {
                    if (k.__ = u, k.__b = u.__b + 1, null === (_ = A[h]) || _ && k.key == _.key && k.type === _.type) {
                        A[h] = void 0
                    } else {
                        for (p = 0; p < P; p++) {
                            if ((_ = A[p]) && k.key == _.key && k.type === _.type) {
                                A[p] = void 0;
                                break
                            }
                            _ = null
                        }
                    }
                    I(n, k, _ = _ || r, t, o, e, c, s, a), b = k.__e, (p = k.ref) && _.ref != p && (w || (w = []), _.ref && w.push(_.ref, null, k), w.push(p, k.__c || b, k)), null != b ? (null == m && (m = b), "function" == typeof k.type && null != k.__k && k.__k === _.__k ? k.__d = s = g(k, s, n) : s = x(n, k, _, A, b, s), a || "option" !== u.type ? "function" == typeof u.type && (u.__d = s) : n.value = "") : s && _.__e == s && s.parentNode != n && (s = d(_))
                }
            }
            for (u.__e = m, h = P; h--;) {
                null != A[h] && ("function" == typeof u.type && null != A[h].__e && A[h].__e == u.__d && (u.__d = d(i, h + 1)), L(A[h], A[h]))
            }
            if (w) {
                for (h = 0; h < w.length; h++) {
                    z(w[h], w[++h], w[++h])
                }
            }
        }

        function g(n, l, u) {
            var i, t;
            for (i = 0; i < n.__k.length; i++) {
                (t = n.__k[i]) && (t.__ = n, l = "function" == typeof t.type ? g(t, l, u) : x(u, t, t, n.__k, t.__e, l))
            }
            return l
        }

        function w(n, l) {
            return l = l || [], null == n || "boolean" == typeof n || (Array.isArray(n) ? n.some(function(n) {
                w(n, l)
            }) : l.push(n)), l
        }

        function x(n, l, u, i, t, o) {
            var r, f, e;
            if (void 0 !== l.__d) {
                r = l.__d, l.__d = void 0
            } else {
                if (null == u || t != o || null == t.parentNode) {
                    n: if (null == o || o.parentNode !== n) {
                        n.appendChild(t), r = null
                    } else {
                        for (f = o, e = 0;
                            (f = f.nextSibling) && e < i.length; e += 2) {
                            if (f == t) {
                                break n
                            }
                        }
                        n.insertBefore(t, o), r = o
                    }
                }
            }
            return void 0 !== r ? r : t.nextSibling
        }

        function A(n, l, u, i, t) {
            var o;
            for (o in u) {
                "children" === o || "key" === o || o in l || C(n, o, null, u[o], i)
            }
            for (o in l) {
                t && "function" != typeof l[o] || "children" === o || "key" === o || "value" === o || "checked" === o || u[o] === l[o] || C(n, o, l[o], u[o], i)
            }
        }

        function P(n, l, u) {
            "-" === l[0] ? n.setProperty(l, u) : n[l] = null == u ? "" : "number" != typeof u || e.test(l) ? u : u + "px"
        }

        function C(n, l, u, i, t) {
            var o;
            n: if ("style" === l) {
                if ("string" == typeof u) {
                    n.style.cssText = u
                } else {
                    if ("string" == typeof i && (n.style.cssText = i = ""), i) {
                        for (l in i) {
                            u && l in u || P(n.style, l, "")
                        }
                    }
                    if (u) {
                        for (l in u) {
                            i && u[l] === i[l] || P(n.style, l, u[l])
                        }
                    }
                }
            } else {
                if ("o" === l[0] && "n" === l[1]) {
                    o = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? i || n.addEventListener(l, o ? H : $, o) : n.removeEventListener(l, o ? H : $, o)
                } else {
                    if ("dangerouslySetInnerHTML" !== l) {
                        if (t) {
                            l = l.replace(/xlink[H:h]/, "h").replace(/sName$/, "s")
                        } else {
                            if ("href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && l in n) {
                                try {
                                    n[l] = null == u ? "" : u;
                                    break n
                                } catch (n) {}
                            }
                        }
                        "function" == typeof u || (null != u && (!1 !== u || "a" === l[0] && "r" === l[1]) ? n.setAttribute(l, u) : n.removeAttribute(l))
                    }
                }
            }
        }

        function $(l) {
            this.l[l.type + !1](n.event ? n.event(l) : l)
        }

        function H(l) {
            this.l[l.type + !0](n.event ? n.event(l) : l)
        }

        function I(l, u, i, t, o, r, f, e, s) {
            var a, v, h, d, _, k, b, g, w, x, A, P = u.type;
            if (void 0 !== u.constructor) {
                return null
            }
            null != i.__h && (s = i.__h, e = u.__e = i.__e, u.__h = null, r = [e]), (a = n.__b) && a(u);
            try {
                n: if ("function" == typeof P) {
                    if (g = u.props, w = (a = P.contextType) && t[a.__c], x = a ? w ? w.props.value : a.__ : t, i.__c ? b = (v = u.__c = i.__c).__ = v.__E : ("prototype" in P && P.prototype.render ? u.__c = v = new P(g, x) : (u.__c = v = new p(g, x), v.constructor = P, v.render = M), w && w.sub(v), v.props = g, v.state || (v.state = {}), v.context = x, v.__n = t, h = v.__d = !0, v.__h = []), null == v.__s && (v.__s = v.state), null != P.getDerivedStateFromProps && (v.__s == v.state && (v.__s = c({}, v.__s)), c(v.__s, P.getDerivedStateFromProps(g, v.__s))), d = v.props, _ = v.state, h) {
                        null == P.getDerivedStateFromProps && null != v.componentWillMount && v.componentWillMount(), null != v.componentDidMount && v.__h.push(v.componentDidMount)
                    } else {
                        if (null == P.getDerivedStateFromProps && g !== d && null != v.componentWillReceiveProps && v.componentWillReceiveProps(g, x), !v.__e && null != v.shouldComponentUpdate && !1 === v.shouldComponentUpdate(g, v.__s, x) || u.__v === i.__v) {
                            v.props = g, v.state = v.__s, u.__v !== i.__v && (v.__d = !1), v.__v = u, u.__e = i.__e, u.__k = i.__k, u.__k.forEach(function(n) {
                                n && (n.__ = u)
                            }), v.__h.length && f.push(v);
                            break n
                        }
                        null != v.componentWillUpdate && v.componentWillUpdate(g, v.__s, x), null != v.componentDidUpdate && v.__h.push(function() {
                            v.componentDidUpdate(d, _, k)
                        })
                    }
                    v.context = x, v.props = g, v.state = v.__s, (a = n.__r) && a(u), v.__d = !1, v.__v = u, v.__P = l, a = v.render(v.props, v.state, v.context), v.state = v.__s, null != v.getChildContext && (t = c(c({}, t), v.getChildContext())), h || null == v.getSnapshotBeforeUpdate || (k = v.getSnapshotBeforeUpdate(d, _)), A = null != a && a.type === y && null == a.key ? a.props.children : a, m(l, Array.isArray(A) ? A : [A], u, i, t, o, r, f, e, s), v.base = u.__e, u.__h = null, v.__h.length && f.push(v), b && (v.__E = v.__ = null), v.__e = !1
                } else {
                    null == r && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = j(i.__e, u, i, t, o, r, f, s)
                }(a = n.diffed) && a(u)
            }
            catch (l) {
                u.__v = null, (s || null != r) && (u.__e = e, u.__h = !!s, r[r.indexOf(e)] = null), n.__e(l, u, i)
            }
        }

        function T(l, u) {
            n.__c && n.__c(u, l), l.some(function(u) {
                try {
                    l = u.__h, u.__h = [], l.some(function(n) {
                        n.call(u)
                    })
                } catch (l) {
                    n.__e(l, u.__v)
                }
            })
        }

        function j(n, l, u, i, t, o, e, c) {
            var a, v, h, y, p = u.props,
                d = l.props,
                _ = l.type,
                k = 0;
            if ("svg" === _ && (t = !0), null != o) {
                for (; k < o.length; k++) {
                    if ((a = o[k]) && (a === n || (_ ? a.localName == _ : 3 == a.nodeType))) {
                        n = a, o[k] = null;
                        break
                    }
                }
            }
            if (null == n) {
                if (null === _) {
                    return document.createTextNode(d)
                }
                n = t ? document.createElementNS("http://www.w3.org/2000/svg", _) : document.createElement(_, d.is && d), o = null, c = !1
            }
            if (null === _) {
                p === d || c && n.data === d || (n.data = d)
            } else {
                if (o = o && f.slice.call(n.childNodes), v = (p = u.props || r).dangerouslySetInnerHTML, h = d.dangerouslySetInnerHTML, !c) {
                    if (null != o) {
                        for (p = {}, y = 0; y < n.attributes.length; y++) {
                            p[n.attributes[y].name] = n.attributes[y].value
                        }
                    }(h || v) && (h && (v && h.__html == v.__html || h.__html === n.innerHTML) || (n.innerHTML = h && h.__html || ""))
                }
                if (A(n, d, p, t, c), h) {
                    l.__k = []
                } else {
                    if (k = l.props.children, m(n, Array.isArray(k) ? k : [k], l, u, i, t && "foreignObject" !== _, o, e, n.firstChild, c), null != o) {
                        for (k = o.length; k--;) {
                            null != o[k] && s(o[k])
                        }
                    }
                }
                c || ("value" in d && void 0 !== (k = d.value) && (k !== n.value || "progress" === _ && !k) && C(n, "value", k, p.value, !1), "checked" in d && void 0 !== (k = d.checked) && k !== n.checked && C(n, "checked", k, p.checked, !1))
            }
            return n
        }

        function z(l, u, i) {
            try {
                "function" == typeof l ? l(u) : l.current = u
            } catch (l) {
                n.__e(l, i)
            }
        }

        function L(l, u, i) {
            var t, o, r;
            if (n.unmount && n.unmount(l), (t = l.ref) && (t.current && t.current !== l.__e || z(t, null, u)), i || "function" == typeof l.type || (i = null != (o = l.__e)), l.__e = l.__d = void 0, null != (t = l.__c)) {
                if (t.componentWillUnmount) {
                    try {
                        t.componentWillUnmount()
                    } catch (l) {
                        n.__e(l, u)
                    }
                }
                t.base = t.__P = null
            }
            if (t = l.__k) {
                for (r = 0; r < t.length; r++) {
                    t[r] && L(t[r], u, i)
                }
            }
            null != o && s(o)
        }

        function M(n, l, u) {
            return this.constructor(n, u)
        }

        function N(l, u, i) {
            var t, o, e;
            n.__ && n.__(l, u), o = (t = "function" == typeof i) ? null : i && i.__k || u.__k, e = [], I(u, l = (!t && i || u).__k = a(y, null, [l]), o || r, r, void 0 !== u.ownerSVGElement, !t && i ? [i] : o ? null : u.firstChild ? f.slice.call(u.childNodes) : null, e, !t && i ? i : o ? o.__e : u.firstChild, t), T(e, l)
        }

        function O(n, l) {
            N(n, l, O)
        }

        function S(n, l, u) {
            var i, t, o, r = arguments,
                f = c({}, n.props);
            for (o in l) {
                "key" == o ? i = l[o] : "ref" == o ? t = l[o] : f[o] = l[o]
            }
            if (arguments.length > 3) {
                for (u = [u], o = 3; o < arguments.length; o++) {
                    u.push(r[o])
                }
            }
            return null != u && (f.children = u), v(n.type, f, i || n.key, t || n.ref, null)
        }

        function q(n, l) {
            var u = {
                __c: l = "__cC" + o++,
                __: n,
                Consumer: function(n, l) {
                    return n.children(l)
                },
                Provider: function(n) {
                    var u, i;
                    return this.getChildContext || (u = [], (i = {})[l] = this, this.getChildContext = function() {
                        return i
                    }, this.shouldComponentUpdate = function(n) {
                        this.props.value !== n.value && u.some(k)
                    }, this.sub = function(n) {
                        u.push(n);
                        var l = n.componentWillUnmount;
                        n.componentWillUnmount = function() {
                            u.splice(u.indexOf(n), 1), l && l.call(n)
                        }
                    }), n.children
                }
            };
            return u.Provider.__ = u.Consumer.contextType = u
        }
        n = {
            __e: function(n, l) {
                for (var u, i, t; l = l.__;) {
                    if ((u = l.__c) && !u.__) {
                        try {
                            if ((i = u.constructor) && null != i.getDerivedStateFromError && (u.setState(i.getDerivedStateFromError(n)), t = u.__d), null != u.componentDidCatch && (u.componentDidCatch(n), t = u.__d), t) {
                                return u.__E = u
                            }
                        } catch (l) {
                            n = l
                        }
                    }
                }
                throw n
            },
            __v: 0
        }, l = function(n) {
            return null != n && void 0 === n.constructor
        }, p.prototype.setState = function(n, l) {
            var u;
            u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = c({}, this.state), "function" == typeof n && (n = n(c({}, u), this.props)), n && c(u, n), null != n && this.__v && (l && this.__h.push(l), k(this))
        }, p.prototype.forceUpdate = function(n) {
            this.__v && (this.__e = !0, n && this.__h.push(n), k(this))
        }, p.prototype.render = y, u = [], i = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, b.__r = 0, o = 0
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/object.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.deepExtendArraySafe = exports.orderEach = exports.clone = void 0;
        var _type = __webpack_require__( /*! ./type */ 1);
        var _variable_wrapper = _interopRequireDefault(__webpack_require__( /*! ./variable_wrapper */ 102));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var clone = function() {
            function Clone() {}
            return function(obj) {
                Clone.prototype = obj;
                return new Clone
            }
        }();
        exports.clone = clone;
        var orderEach = function(map, func) {
            var keys = [];
            var key;
            var i;
            for (key in map) {
                if (Object.prototype.hasOwnProperty.call(map, key)) {
                    keys.push(key)
                }
            }
            keys.sort(function(x, y) {
                var isNumberX = (0, _type.isNumeric)(x);
                var isNumberY = (0, _type.isNumeric)(y);
                if (isNumberX && isNumberY) {
                    return x - y
                }
                if (isNumberX && !isNumberY) {
                    return -1
                }
                if (!isNumberX && isNumberY) {
                    return 1
                }
                if (x < y) {
                    return -1
                }
                if (x > y) {
                    return 1
                }
                return 0
            });
            for (i = 0; i < keys.length; i++) {
                key = keys[i];
                func(key, map[key])
            }
        };
        exports.orderEach = orderEach;
        var assignValueToProperty = function(target, property, value, assignByReference) {
            if (!assignByReference && _variable_wrapper.default.isWrapped(target[property])) {
                _variable_wrapper.default.assign(target[property], value)
            } else {
                target[property] = value
            }
        };
        var deepExtendArraySafe = function deepExtendArraySafe(target, changes, extendComplexObject, assignByReference) {
            var prevValue;
            var newValue;
            for (var name in changes) {
                prevValue = target[name];
                newValue = changes[name];
                if ("__proto__" === name || "constructor" === name || target === newValue) {
                    continue
                }
                if ((0, _type.isPlainObject)(newValue)) {
                    var goDeeper = extendComplexObject ? (0, _type.isObject)(prevValue) : (0, _type.isPlainObject)(prevValue);
                    newValue = deepExtendArraySafe(goDeeper ? prevValue : {}, newValue, extendComplexObject, assignByReference)
                }
                if (void 0 !== newValue && prevValue !== newValue) {
                    assignValueToProperty(target, name, newValue, assignByReference)
                }
            }
            return target
        };
        exports.deepExtendArraySafe = deepExtendArraySafe
    },
    /*!******************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/editor/editor.js ***!
      \******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _element_data = __webpack_require__( /*! ../../core/element_data */ 40);
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/callbacks */ 27));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _validation_engine = _interopRequireDefault(__webpack_require__( /*! ../validation_engine */ 96));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _validation_message = _interopRequireDefault(__webpack_require__( /*! ../validation_message */ 546));
        var _guid = _interopRequireDefault(__webpack_require__( /*! ../../core/guid */ 36));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var INVALID_MESSAGE_AUTO = "dx-invalid-message-auto";
        var READONLY_STATE_CLASS = "dx-state-readonly";
        var INVALID_CLASS = "dx-invalid";
        var DX_INVALID_BADGE_CLASS = "dx-show-invalid-badge";
        var VALIDATION_TARGET = "dx-validation-target";
        var VALIDATION_STATUS_VALID = "valid";
        var VALIDATION_STATUS_INVALID = "invalid";
        var READONLY_NAMESPACE = "editorReadOnly";
        var VALIDATION_MESSAGE_KEYS_MAP = {
            validationMessageMode: "mode",
            validationMessageOffset: "offset",
            validationBoundary: "boundary"
        };
        var Editor = _ui.default.inherit({
            ctor: function() {
                this.showValidationMessageTimeout = null;
                this.validationRequest = (0, _callbacks.default)();
                this.callBase.apply(this, arguments)
            },
            _createElement: function(element) {
                this.callBase(element);
                var $element = this.$element();
                if ($element) {
                    (0, _element_data.data)($element[0], VALIDATION_TARGET, this)
                }
            },
            _initOptions: function(options) {
                this.callBase.apply(this, arguments);
                this.option(_validation_engine.default.initValidationOptions(options))
            },
            _init: function() {
                this.callBase();
                this._options.cache("validationTooltipOptions", this.option("validationTooltipOptions"));
                var $element = this.$element();
                $element.addClass(DX_INVALID_BADGE_CLASS)
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    value: null,
                    name: "",
                    onValueChanged: null,
                    readOnly: false,
                    isValid: true,
                    validationError: null,
                    validationErrors: null,
                    validationStatus: VALIDATION_STATUS_VALID,
                    validationMessageMode: "auto",
                    validationBoundary: void 0,
                    validationMessageOffset: {
                        h: 0,
                        v: 0
                    },
                    validationTooltipOptions: {}
                })
            },
            _attachKeyboardEvents: function() {
                if (!this.option("readOnly")) {
                    this.callBase()
                }
            },
            _setOptionsByReference: function() {
                this.callBase();
                (0, _extend.extend)(this._optionsByReference, {
                    validationError: true
                })
            },
            _createValueChangeAction: function() {
                this._valueChangeAction = this._createActionByOption("onValueChanged", {
                    excludeValidators: ["disabled", "readOnly"]
                })
            },
            _suppressValueChangeAction: function() {
                this._valueChangeActionSuppressed = true
            },
            _resumeValueChangeAction: function() {
                this._valueChangeActionSuppressed = false
            },
            _initMarkup: function() {
                this._toggleReadOnlyState();
                this._setSubmitElementName(this.option("name"));
                this.callBase();
                this._renderValidationState()
            },
            _raiseValueChangeAction: function(value, previousValue) {
                if (!this._valueChangeAction) {
                    this._createValueChangeAction()
                }
                this._valueChangeAction(this._valueChangeArgs(value, previousValue))
            },
            _valueChangeArgs: function(value, previousValue) {
                return {
                    value: value,
                    previousValue: previousValue,
                    event: this._valueChangeEventInstance
                }
            },
            _saveValueChangeEvent: function(e) {
                this._valueChangeEventInstance = e
            },
            _focusInHandler: function(e) {
                var isValidationMessageShownOnFocus = "auto" === this.option("validationMessageMode");
                if (this._canValueBeChangedByClick() && isValidationMessageShownOnFocus) {
                    var _this$_validationMess;
                    var $validationMessageWrapper = null === (_this$_validationMess = this._validationMessage) || void 0 === _this$_validationMess ? void 0 : _this$_validationMess._wrapper();
                    null === $validationMessageWrapper || void 0 === $validationMessageWrapper ? void 0 : $validationMessageWrapper.removeClass(INVALID_MESSAGE_AUTO);
                    clearTimeout(this.showValidationMessageTimeout);
                    this.showValidationMessageTimeout = setTimeout(function() {
                        return null === $validationMessageWrapper || void 0 === $validationMessageWrapper ? void 0 : $validationMessageWrapper.addClass(INVALID_MESSAGE_AUTO)
                    }, 150)
                }
                return this.callBase(e)
            },
            _canValueBeChangedByClick: function() {
                return false
            },
            _getValidationErrors: function() {
                var validationErrors = this.option("validationErrors");
                if (!validationErrors && this.option("validationError")) {
                    validationErrors = [this.option("validationError")]
                }
                return validationErrors
            },
            _disposeValidationMessage: function() {
                if (this._$validationMessage) {
                    this._$validationMessage.remove();
                    this.setAria("describedby", null);
                    this._$validationMessage = void 0;
                    this._validationMessage = void 0
                }
            },
            _toggleValidationClasses: function(isInvalid) {
                this.$element().toggleClass(INVALID_CLASS, isInvalid);
                this.setAria(VALIDATION_STATUS_INVALID, isInvalid || void 0)
            },
            _renderValidationState: function() {
                var isValid = this.option("isValid") && this.option("validationStatus") !== VALIDATION_STATUS_INVALID;
                var validationErrors = this._getValidationErrors();
                var $element = this.$element();
                this._toggleValidationClasses(!isValid);
                if (!(0, _window.hasWindow)()) {
                    return
                }
                this._disposeValidationMessage();
                if (!isValid && validationErrors) {
                    var _this$option = this.option(),
                        validationMessageMode = _this$option.validationMessageMode,
                        validationMessageOffset = _this$option.validationMessageOffset,
                        validationBoundary = _this$option.validationBoundary,
                        rtlEnabled = _this$option.rtlEnabled;
                    this._$validationMessage = (0, _renderer.default)("<div>").appendTo($element);
                    this.setAria("describedby", "dx-" + new _guid.default);
                    this._validationMessage = new _validation_message.default(this._$validationMessage, (0, _extend.extend)({
                        validationErrors: validationErrors,
                        rtlEnabled: rtlEnabled,
                        target: this._getValidationMessageTarget(),
                        container: $element,
                        mode: validationMessageMode,
                        positionRequest: "below",
                        offset: validationMessageOffset,
                        boundary: validationBoundary,
                        describedElement: this._focusTarget()
                    }, this._options.cache("validationTooltipOptions")));
                    this._bindInnerWidgetOptions(this._validationMessage, "validationTooltipOptions")
                }
            },
            _getValidationMessageTarget: function() {
                return this.$element()
            },
            _toggleReadOnlyState: function() {
                var readOnly = this.option("readOnly");
                this._toggleBackspaceHandler(readOnly);
                this.$element().toggleClass(READONLY_STATE_CLASS, !!readOnly);
                this.setAria("readonly", readOnly || void 0)
            },
            _toggleBackspaceHandler: function(isReadOnly) {
                var $eventTarget = this._keyboardEventBindingTarget();
                var eventName = (0, _index.addNamespace)("keydown", READONLY_NAMESPACE);
                _events_engine.default.off($eventTarget, eventName);
                if (isReadOnly) {
                    _events_engine.default.on($eventTarget, eventName, function(e) {
                        if ("backspace" === (0, _index.normalizeKeyName)(e)) {
                            e.preventDefault()
                        }
                    })
                }
            },
            _dispose: function() {
                var element = this.$element()[0];
                (0, _element_data.data)(element, VALIDATION_TARGET, null);
                clearTimeout(this.showValidationMessageTimeout);
                this._disposeValidationMessage();
                this.callBase()
            },
            _setSubmitElementName: function(name) {
                var $submitElement = this._getSubmitElement();
                if (!$submitElement) {
                    return
                }
                if (name.length > 0) {
                    $submitElement.attr("name", name)
                } else {
                    $submitElement.removeAttr("name")
                }
            },
            _getSubmitElement: function() {
                return null
            },
            _setValidationMessageOption: function(_ref) {
                var _this$_validationMess2;
                var name = _ref.name,
                    value = _ref.value;
                var optionKey = VALIDATION_MESSAGE_KEYS_MAP[name] ? VALIDATION_MESSAGE_KEYS_MAP[name] : name;
                null === (_this$_validationMess2 = this._validationMessage) || void 0 === _this$_validationMess2 ? void 0 : _this$_validationMess2.option(optionKey, value)
            },
            _optionChanged: function(args) {
                var _this$_validationMess3;
                switch (args.name) {
                    case "onValueChanged":
                        this._createValueChangeAction();
                        break;
                    case "readOnly":
                        this._toggleReadOnlyState();
                        this._refreshFocusState();
                        break;
                    case "value":
                        if (args.value != args.previousValue) {
                            this.validationRequest.fire({
                                value: args.value,
                                editor: this
                            })
                        }
                        if (!this._valueChangeActionSuppressed) {
                            this._raiseValueChangeAction(args.value, args.previousValue);
                            this._saveValueChangeEvent(void 0)
                        }
                        break;
                    case "width":
                        this.callBase(args);
                        null === (_this$_validationMess3 = this._validationMessage) || void 0 === _this$_validationMess3 ? void 0 : _this$_validationMess3.updateMaxWidth();
                        break;
                    case "name":
                        this._setSubmitElementName(args.value);
                        break;
                    case "isValid":
                    case "validationError":
                    case "validationErrors":
                    case "validationStatus":
                        this.option(_validation_engine.default.synchronizeValidationOptions(args, this.option()));
                        this._renderValidationState();
                        break;
                    case "validationBoundary":
                    case "validationMessageMode":
                    case "validationMessageOffset":
                        this._setValidationMessageOption(args);
                        break;
                    case "rtlEnabled":
                        this._setValidationMessageOption(args);
                        this.callBase(args);
                        break;
                    case "validationTooltipOptions":
                        this._innerWidgetOptionChanged(this._validationMessage, args);
                        break;
                    default:
                        this.callBase(args)
                }
            },
            reset: function() {
                var defaultOptions = this._getDefaultOptions();
                this.option("value", defaultOptions.value)
            }
        });
        var _default = Editor;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************!*\
      !*** ./node_modules/preact/hooks/dist/hooks.module.js ***!
      \********************************************************/
    /*! exports provided: useState, useReducer, useEffect, useLayoutEffect, useRef, useImperativeHandle, useMemo, useCallback, useContext, useDebugValue, useErrorBoundary */
    /*! all exports used */
    function(module, __webpack_exports__, __webpack_require__) {
        Object.defineProperty(__webpack_exports__, "__esModule", {
            value: true
        });
        __webpack_require__.d(__webpack_exports__, "useState", function() {
            return l
        });
        __webpack_require__.d(__webpack_exports__, "useReducer", function() {
            return p
        });
        __webpack_require__.d(__webpack_exports__, "useEffect", function() {
            return y
        });
        __webpack_require__.d(__webpack_exports__, "useLayoutEffect", function() {
            return h
        });
        __webpack_require__.d(__webpack_exports__, "useRef", function() {
            return s
        });
        __webpack_require__.d(__webpack_exports__, "useImperativeHandle", function() {
            return _
        });
        __webpack_require__.d(__webpack_exports__, "useMemo", function() {
            return d
        });
        __webpack_require__.d(__webpack_exports__, "useCallback", function() {
            return A
        });
        __webpack_require__.d(__webpack_exports__, "useContext", function() {
            return F
        });
        __webpack_require__.d(__webpack_exports__, "useDebugValue", function() {
            return T
        });
        __webpack_require__.d(__webpack_exports__, "useErrorBoundary", function() {
            return q
        });
        var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__( /*! preact */ 50);
        var t, u, r, o = 0,
            i = [],
            c = __WEBPACK_IMPORTED_MODULE_0_preact__.options.__b,
            f = __WEBPACK_IMPORTED_MODULE_0_preact__.options.__r,
            e = __WEBPACK_IMPORTED_MODULE_0_preact__.options.diffed,
            a = __WEBPACK_IMPORTED_MODULE_0_preact__.options.__c,
            v = __WEBPACK_IMPORTED_MODULE_0_preact__.options.unmount;

        function m(t, r) {
            __WEBPACK_IMPORTED_MODULE_0_preact__.options.__h && __WEBPACK_IMPORTED_MODULE_0_preact__.options.__h(u, t, o || r), o = 0;
            var i = u.__H || (u.__H = {
                __: [],
                __h: []
            });
            return t >= i.__.length && i.__.push({}), i.__[t]
        }

        function l(n) {
            return o = 1, p(w, n)
        }

        function p(n, r, o) {
            var i = m(t++, 2);
            return i.t = n, i.__c || (i.__ = [o ? o(r) : w(void 0, r), function(n) {
                var t = i.t(i.__[0], n);
                i.__[0] !== t && (i.__ = [t, i.__[1]], i.__c.setState({}))
            }], i.__c = u), i.__
        }

        function y(r, o) {
            var i = m(t++, 3);
            !__WEBPACK_IMPORTED_MODULE_0_preact__.options.__s && k(i.__H, o) && (i.__ = r, i.__H = o, u.__H.__h.push(i))
        }

        function h(r, o) {
            var i = m(t++, 4);
            !__WEBPACK_IMPORTED_MODULE_0_preact__.options.__s && k(i.__H, o) && (i.__ = r, i.__H = o, u.__h.push(i))
        }

        function s(n) {
            return o = 5, d(function() {
                return {
                    current: n
                }
            }, [])
        }

        function _(n, t, u) {
            o = 6, h(function() {
                "function" == typeof n ? n(t()) : n && (n.current = t())
            }, null == u ? u : u.concat(n))
        }

        function d(n, u) {
            var r = m(t++, 7);
            return k(r.__H, u) && (r.__ = n(), r.__H = u, r.__h = n), r.__
        }

        function A(n, t) {
            return o = 8, d(function() {
                return n
            }, t)
        }

        function F(n) {
            var r = u.context[n.__c],
                o = m(t++, 9);
            return o.__c = n, r ? (null == o.__ && (o.__ = !0, r.sub(u)), r.props.value) : n.__
        }

        function T(t, u) {
            __WEBPACK_IMPORTED_MODULE_0_preact__.options.useDebugValue && __WEBPACK_IMPORTED_MODULE_0_preact__.options.useDebugValue(u ? u(t) : t)
        }

        function q(n) {
            var r = m(t++, 10),
                o = l();
            return r.__ = n, u.componentDidCatch || (u.componentDidCatch = function(n) {
                r.__ && r.__(n), o[1](n)
            }), [o[0], function() {
                o[1](void 0)
            }]
        }

        function x() {
            i.forEach(function(t) {
                if (t.__P) {
                    try {
                        t.__H.__h.forEach(g), t.__H.__h.forEach(j), t.__H.__h = []
                    } catch (u) {
                        t.__H.__h = [], __WEBPACK_IMPORTED_MODULE_0_preact__.options.__e(u, t.__v)
                    }
                }
            }), i = []
        }
        __WEBPACK_IMPORTED_MODULE_0_preact__.options.__b = function(n) {
            u = null, c && c(n)
        }, __WEBPACK_IMPORTED_MODULE_0_preact__.options.__r = function(n) {
            f && f(n), t = 0;
            var r = (u = n.__c).__H;
            r && (r.__h.forEach(g), r.__h.forEach(j), r.__h = [])
        }, __WEBPACK_IMPORTED_MODULE_0_preact__.options.diffed = function(t) {
            e && e(t);
            var o = t.__c;
            o && o.__H && o.__H.__h.length && (1 !== i.push(o) && r === __WEBPACK_IMPORTED_MODULE_0_preact__.options.requestAnimationFrame || ((r = __WEBPACK_IMPORTED_MODULE_0_preact__.options.requestAnimationFrame) || function(n) {
                var t, u = function() {
                        clearTimeout(r), b && cancelAnimationFrame(t), setTimeout(n)
                    },
                    r = setTimeout(u, 100);
                b && (t = requestAnimationFrame(u))
            })(x)), u = void 0
        }, __WEBPACK_IMPORTED_MODULE_0_preact__.options.__c = function(t, u) {
            u.some(function(t) {
                try {
                    t.__h.forEach(g), t.__h = t.__h.filter(function(n) {
                        return !n.__ || j(n)
                    })
                } catch (r) {
                    u.some(function(n) {
                        n.__h && (n.__h = [])
                    }), u = [], __WEBPACK_IMPORTED_MODULE_0_preact__.options.__e(r, t.__v)
                }
            }), a && a(t, u)
        }, __WEBPACK_IMPORTED_MODULE_0_preact__.options.unmount = function(t) {
            v && v(t);
            var u = t.__c;
            if (u && u.__H) {
                try {
                    u.__H.__.forEach(g)
                } catch (t) {
                    __WEBPACK_IMPORTED_MODULE_0_preact__.options.__e(t, u.__v)
                }
            }
        };
        var b = "function" == typeof requestAnimationFrame;

        function g(n) {
            var t = u;
            "function" == typeof n.__c && n.__c(), u = t
        }

        function j(n) {
            var t = u;
            n.__c = n.__(), u = t
        }

        function k(n, t) {
            return !n || n.length !== t.length || t.some(function(t, u) {
                return t !== n[u]
            })
        }

        function w(n, t) {
            return "function" == typeof t ? t(n) : t
        }
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/collection/ui.collection_widget.edit.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _uiCollection_widget = _interopRequireDefault(__webpack_require__( /*! ./ui.collection_widget.base */ 548));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _uiCollection_widgetEditStrategy = _interopRequireDefault(__webpack_require__( /*! ./ui.collection_widget.edit.strategy.plain */ 202));
        var _data = __webpack_require__( /*! ../../core/utils/data */ 20);
        var _data_source = __webpack_require__( /*! ../../data/data_source/data_source */ 68);
        var _utils = __webpack_require__( /*! ../../data/data_source/utils */ 69);
        var _selection = _interopRequireDefault(__webpack_require__( /*! ../selection/selection */ 233));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }
        var ITEM_DELETING_DATA_KEY = "dxItemDeleting";
        var NOT_EXISTING_INDEX = -1;
        var indexExists = function(index) {
            return index !== NOT_EXISTING_INDEX
        };
        var CollectionWidget = _uiCollection_widget.default.inherit({
            _setOptionsByReference: function() {
                this.callBase();
                (0, _extend.extend)(this._optionsByReference, {
                    selectedItem: true
                })
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    selectionMode: "none",
                    selectionRequired: false,
                    selectionByClick: true,
                    selectedItems: [],
                    selectedItemKeys: [],
                    maxFilterLengthInRequest: 1500,
                    keyExpr: null,
                    selectedIndex: NOT_EXISTING_INDEX,
                    selectedItem: null,
                    onSelectionChanged: null,
                    onItemReordered: null,
                    onItemDeleting: null,
                    onItemDeleted: null
                })
            },
            ctor: function(element, options) {
                this._userOptions = options || {};
                this.callBase(element, options)
            },
            _init: function() {
                this._initEditStrategy();
                this.callBase();
                this._initKeyGetter();
                this._initSelectionModule()
            },
            _initKeyGetter: function() {
                this._keyGetter = (0, _data.compileGetter)(this.option("keyExpr"))
            },
            _getKeysByItems: function(selectedItems) {
                return this._editStrategy.getKeysByItems(selectedItems)
            },
            _getItemsByKeys: function(selectedItemKeys, selectedItems) {
                return this._editStrategy.getItemsByKeys(selectedItemKeys, selectedItems)
            },
            _getKeyByIndex: function(index) {
                return this._editStrategy.getKeyByIndex(index)
            },
            _getIndexByKey: function(key) {
                return this._editStrategy.getIndexByKey(key)
            },
            _getIndexByItemData: function(itemData) {
                return this._editStrategy.getIndexByItemData(itemData)
            },
            _isKeySpecified: function() {
                return !!(this._dataSource && this._dataSource.key())
            },
            _getCombinedFilter: function() {
                return this._dataSource && this._dataSource.filter()
            },
            key: function() {
                if (this.option("keyExpr")) {
                    return this.option("keyExpr")
                }
                return this._dataSource && this._dataSource.key()
            },
            keyOf: function(item) {
                var key = item;
                var store = this._dataSource && this._dataSource.store();
                if (this.option("keyExpr")) {
                    key = this._keyGetter(item)
                } else {
                    if (store) {
                        key = store.keyOf(item)
                    }
                }
                return key
            },
            _nullValueSelectionSupported: function() {
                return false
            },
            _initSelectionModule: function() {
                var that = this;
                var itemsGetter = that._editStrategy.itemsGetter;
                this._selection = new _selection.default({
                    allowNullValue: this._nullValueSelectionSupported(),
                    mode: this.option("selectionMode"),
                    maxFilterLengthInRequest: this.option("maxFilterLengthInRequest"),
                    equalByReference: !this._isKeySpecified(),
                    onSelectionChanged: function(args) {
                        if (args.addedItemKeys.length || args.removedItemKeys.length) {
                            that.option("selectedItems", that._getItemsByKeys(args.selectedItemKeys, args.selectedItems));
                            that._updateSelectedItems(args)
                        }
                    },
                    filter: that._getCombinedFilter.bind(that),
                    totalCount: function() {
                        var items = that.option("items");
                        var dataSource = that._dataSource;
                        return dataSource && dataSource.totalCount() >= 0 ? dataSource.totalCount() : items.length
                    },
                    key: that.key.bind(that),
                    keyOf: that.keyOf.bind(that),
                    load: function(options) {
                        if (that._dataSource) {
                            var loadOptions = that._dataSource.loadOptions();
                            options.customQueryParams = loadOptions.customQueryParams;
                            options.userData = that._dataSource._userData
                        }
                        var store = that._dataSource && that._dataSource.store();
                        if (store) {
                            return store.load(options).done(function(loadResult) {
                                if (that._disposed) {
                                    return
                                }
                                var items = (0, _utils.normalizeLoadResult)(loadResult).data;
                                that._dataSource._applyMapFunction(items)
                            })
                        } else {
                            return (new _deferred.Deferred).resolve(this.plainItems())
                        }
                    },
                    dataFields: function() {
                        return that._dataSource && that._dataSource.select()
                    },
                    plainItems: itemsGetter.bind(that._editStrategy)
                })
            },
            _initEditStrategy: function() {
                var Strategy = _uiCollection_widgetEditStrategy.default;
                this._editStrategy = new Strategy(this)
            },
            _getSelectedItemIndices: function(keys) {
                var that = this;
                var indices = [];
                keys = keys || this._selection.getSelectedItemKeys();
                that._editStrategy.beginCache();
                (0, _iterator.each)(keys, function(_, key) {
                    var selectedIndex = that._getIndexByKey(key);
                    if (indexExists(selectedIndex)) {
                        indices.push(selectedIndex)
                    }
                });
                that._editStrategy.endCache();
                return indices
            },
            _initMarkup: function() {
                var _this = this;
                this._rendering = true;
                if (!this._dataSource || !this._dataSource.isLoading()) {
                    this._syncSelectionOptions().done(function() {
                        return _this._normalizeSelectedItems()
                    })
                }
                this.callBase()
            },
            _render: function() {
                this.callBase();
                this._rendering = false
            },
            _fireContentReadyAction: function() {
                this._rendering = false;
                this._rendered = true;
                this.callBase.apply(this, arguments)
            },
            _syncSelectionOptions: function(byOption) {
                byOption = byOption || this._chooseSelectOption();
                var selectedItem;
                var selectedIndex;
                var selectedItemKeys;
                var selectedItems;
                switch (byOption) {
                    case "selectedIndex":
                        selectedItem = this._editStrategy.getItemDataByIndex(this.option("selectedIndex"));
                        if ((0, _type.isDefined)(selectedItem)) {
                            this._setOptionWithoutOptionChange("selectedItems", [selectedItem]);
                            this._setOptionWithoutOptionChange("selectedItem", selectedItem);
                            this._setOptionWithoutOptionChange("selectedItemKeys", this._editStrategy.getKeysByItems([selectedItem]))
                        } else {
                            this._setOptionWithoutOptionChange("selectedItems", []);
                            this._setOptionWithoutOptionChange("selectedItemKeys", []);
                            this._setOptionWithoutOptionChange("selectedItem", null)
                        }
                        break;
                    case "selectedItems":
                        selectedItems = this.option("selectedItems") || [];
                        selectedIndex = selectedItems.length ? this._editStrategy.getIndexByItemData(selectedItems[0]) : NOT_EXISTING_INDEX;
                        if (this.option("selectionRequired") && !indexExists(selectedIndex)) {
                            return this._syncSelectionOptions("selectedIndex")
                        }
                        this._setOptionWithoutOptionChange("selectedItem", selectedItems[0]);
                        this._setOptionWithoutOptionChange("selectedIndex", selectedIndex);
                        this._setOptionWithoutOptionChange("selectedItemKeys", this._editStrategy.getKeysByItems(selectedItems));
                        break;
                    case "selectedItem":
                        selectedItem = this.option("selectedItem");
                        selectedIndex = this._editStrategy.getIndexByItemData(selectedItem);
                        if (this.option("selectionRequired") && !indexExists(selectedIndex)) {
                            return this._syncSelectionOptions("selectedIndex")
                        }
                        if ((0, _type.isDefined)(selectedItem)) {
                            this._setOptionWithoutOptionChange("selectedItems", [selectedItem]);
                            this._setOptionWithoutOptionChange("selectedIndex", selectedIndex);
                            this._setOptionWithoutOptionChange("selectedItemKeys", this._editStrategy.getKeysByItems([selectedItem]))
                        } else {
                            this._setOptionWithoutOptionChange("selectedItems", []);
                            this._setOptionWithoutOptionChange("selectedItemKeys", []);
                            this._setOptionWithoutOptionChange("selectedIndex", NOT_EXISTING_INDEX)
                        }
                        break;
                    case "selectedItemKeys":
                        selectedItemKeys = this.option("selectedItemKeys");
                        if (this.option("selectionRequired")) {
                            var selectedItemIndex = this._getIndexByKey(selectedItemKeys[0]);
                            if (!indexExists(selectedItemIndex)) {
                                return this._syncSelectionOptions("selectedIndex")
                            }
                        }
                        return this._selection.setSelection(selectedItemKeys)
                }
                return (new _deferred.Deferred).resolve().promise()
            },
            _chooseSelectOption: function() {
                var optionName = "selectedIndex";
                var isOptionDefined = function(optionName) {
                    var optionValue = this.option(optionName);
                    var length = (0, _type.isDefined)(optionValue) && optionValue.length;
                    return length || optionName in this._userOptions
                }.bind(this);
                if (isOptionDefined("selectedItems")) {
                    optionName = "selectedItems"
                } else {
                    if (isOptionDefined("selectedItem")) {
                        optionName = "selectedItem"
                    } else {
                        if (isOptionDefined("selectedItemKeys")) {
                            optionName = "selectedItemKeys"
                        }
                    }
                }
                return optionName
            },
            _compareKeys: function(oldKeys, newKeys) {
                if (oldKeys.length !== newKeys.length) {
                    return false
                }
                for (var i = 0; i < newKeys.length; i++) {
                    if (oldKeys[i] !== newKeys[i]) {
                        return false
                    }
                }
                return true
            },
            _normalizeSelectedItems: function() {
                if ("none" === this.option("selectionMode")) {
                    this._setOptionWithoutOptionChange("selectedItems", []);
                    this._syncSelectionOptions("selectedItems")
                } else {
                    if ("single" === this.option("selectionMode")) {
                        var newSelection = this.option("selectedItems");
                        if (newSelection.length > 1 || !newSelection.length && this.option("selectionRequired") && this.option("items") && this.option("items").length) {
                            var currentSelection = this._selection.getSelectedItems();
                            var normalizedSelection = void 0 === newSelection[0] ? currentSelection[0] : newSelection[0];
                            if (void 0 === normalizedSelection) {
                                normalizedSelection = this._editStrategy.itemsGetter()[0]
                            }
                            if (this.option("grouped") && normalizedSelection && normalizedSelection.items) {
                                normalizedSelection.items = [normalizedSelection.items[0]]
                            }
                            this._selection.setSelection(this._getKeysByItems([normalizedSelection]));
                            this._setOptionWithoutOptionChange("selectedItems", [normalizedSelection]);
                            return this._syncSelectionOptions("selectedItems")
                        } else {
                            this._selection.setSelection(this._getKeysByItems(newSelection))
                        }
                    } else {
                        var newKeys = this._getKeysByItems(this.option("selectedItems"));
                        var oldKeys = this._selection.getSelectedItemKeys();
                        if (!this._compareKeys(oldKeys, newKeys)) {
                            this._selection.setSelection(newKeys)
                        }
                    }
                }
                return (new _deferred.Deferred).resolve().promise()
            },
            _itemClickHandler: function(e) {
                this._createAction(function(e) {
                    this._itemSelectHandler(e.event)
                }.bind(this), {
                    validatingTargetName: "itemElement"
                })({
                    itemElement: (0, _renderer.default)(e.currentTarget),
                    event: e
                });
                this.callBase.apply(this, arguments)
            },
            _itemSelectHandler: function(e) {
                if (!this.option("selectionByClick")) {
                    return
                }
                var $itemElement = e.currentTarget;
                if (this.isItemSelected($itemElement)) {
                    this.unselectItem(e.currentTarget)
                } else {
                    this.selectItem(e.currentTarget)
                }
            },
            _selectedItemElement: function(index) {
                return this._itemElements().eq(index)
            },
            _postprocessRenderItem: function(args) {
                if ("none" !== this.option("selectionMode")) {
                    var $itemElement = (0, _renderer.default)(args.itemElement);
                    var normalizedItemIndex = this._editStrategy.getNormalizedIndex($itemElement);
                    var isItemSelected = this._isItemSelected(normalizedItemIndex);
                    this._processSelectableItem($itemElement, isItemSelected)
                }
            },
            _processSelectableItem: function($itemElement, isSelected) {
                $itemElement.toggleClass(this._selectedItemClass(), isSelected);
                this._setAriaSelected($itemElement, String(isSelected))
            },
            _updateSelectedItems: function(args) {
                var that = this;
                var addedItemKeys = args.addedItemKeys;
                var removedItemKeys = args.removedItemKeys;
                if (that._rendered && (addedItemKeys.length || removedItemKeys.length)) {
                    var selectionChangePromise = that._selectionChangePromise;
                    if (!that._rendering) {
                        var addedSelection = [];
                        var normalizedIndex;
                        var removedSelection = [];
                        that._editStrategy.beginCache();
                        for (var i = 0; i < addedItemKeys.length; i++) {
                            normalizedIndex = that._getIndexByKey(addedItemKeys[i]);
                            addedSelection.push(normalizedIndex);
                            that._addSelection(normalizedIndex)
                        }
                        for (var _i = 0; _i < removedItemKeys.length; _i++) {
                            normalizedIndex = that._getIndexByKey(removedItemKeys[_i]);
                            removedSelection.push(normalizedIndex);
                            that._removeSelection(normalizedIndex)
                        }
                        that._editStrategy.endCache();
                        that._updateSelection(addedSelection, removedSelection)
                    }(0, _deferred.when)(selectionChangePromise).done(function() {
                        that._fireSelectionChangeEvent(args.addedItems, args.removedItems)
                    })
                }
            },
            _fireSelectionChangeEvent: function(addedItems, removedItems) {
                this._createActionByOption("onSelectionChanged", {
                    excludeValidators: ["disabled", "readOnly"]
                })({
                    addedItems: addedItems,
                    removedItems: removedItems
                })
            },
            _updateSelection: _common.noop,
            _setAriaSelected: function($target, value) {
                this.setAria("selected", value, $target)
            },
            _removeSelection: function(normalizedIndex) {
                var $itemElement = this._editStrategy.getItemElement(normalizedIndex);
                if (indexExists(normalizedIndex)) {
                    this._processSelectableItem($itemElement, false);
                    _events_engine.default.triggerHandler($itemElement, "stateChanged", false)
                }
            },
            _addSelection: function(normalizedIndex) {
                var $itemElement = this._editStrategy.getItemElement(normalizedIndex);
                if (indexExists(normalizedIndex)) {
                    this._processSelectableItem($itemElement, true);
                    _events_engine.default.triggerHandler($itemElement, "stateChanged", true)
                }
            },
            _isItemSelected: function(index) {
                var key = this._getKeyByIndex(index);
                return this._selection.isItemSelected(key, {
                    checkPending: true
                })
            },
            _optionChanged: function(args) {
                var _this2 = this;
                switch (args.name) {
                    case "selectionMode":
                        this._invalidate();
                        break;
                    case "dataSource":
                        if (!args.value || Array.isArray(args.value) && !args.value.length) {
                            this.option("selectedItemKeys", [])
                        }
                        this.callBase(args);
                        break;
                    case "selectedIndex":
                    case "selectedItem":
                    case "selectedItems":
                    case "selectedItemKeys":
                        this._syncSelectionOptions(args.name).done(function() {
                            return _this2._normalizeSelectedItems()
                        });
                        break;
                    case "keyExpr":
                        this._initKeyGetter();
                        break;
                    case "selectionRequired":
                        this._normalizeSelectedItems();
                        break;
                    case "selectionByClick":
                    case "onSelectionChanged":
                    case "onItemDeleting":
                    case "onItemDeleted":
                    case "onItemReordered":
                    case "maxFilterLengthInRequest":
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _clearSelectedItems: function() {
                this._setOptionWithoutOptionChange("selectedItems", []);
                this._syncSelectionOptions("selectedItems")
            },
            _waitDeletingPrepare: function($itemElement) {
                if ($itemElement.data(ITEM_DELETING_DATA_KEY)) {
                    return (new _deferred.Deferred).resolve().promise()
                }
                $itemElement.data(ITEM_DELETING_DATA_KEY, true);
                var deferred = new _deferred.Deferred;
                var deletingActionArgs = {
                    cancel: false
                };
                var deletePromise = this._itemEventHandler($itemElement, "onItemDeleting", deletingActionArgs, {
                    excludeValidators: ["disabled", "readOnly"]
                });
                (0, _deferred.when)(deletePromise).always(function(value) {
                    var deletePromiseExists = !deletePromise;
                    var deletePromiseResolved = !deletePromiseExists && "resolved" === deletePromise.state();
                    var argumentsSpecified = !!arguments.length;
                    var shouldDelete = deletePromiseExists || deletePromiseResolved && !argumentsSpecified || deletePromiseResolved && value;
                    (0, _deferred.when)((0, _deferred.fromPromise)(deletingActionArgs.cancel)).always(function() {
                        $itemElement.data(ITEM_DELETING_DATA_KEY, false)
                    }).done(function(cancel) {
                        shouldDelete && !cancel ? deferred.resolve() : deferred.reject()
                    }).fail(deferred.reject)
                }.bind(this));
                return deferred.promise()
            },
            _deleteItemFromDS: function($item) {
                if (!this._dataSource) {
                    return (new _deferred.Deferred).resolve().promise()
                }
                var deferred = new _deferred.Deferred;
                var disabledState = this.option("disabled");
                var dataStore = this._dataSource.store();
                this.option("disabled", true);
                if (!dataStore.remove) {
                    throw _ui.default.Error("E1011")
                }
                dataStore.remove(dataStore.keyOf(this._getItemData($item))).done(function(key) {
                    if (void 0 !== key) {
                        deferred.resolve()
                    } else {
                        deferred.reject()
                    }
                }).fail(function() {
                    deferred.reject()
                });
                deferred.always(function() {
                    this.option("disabled", disabledState)
                }.bind(this));
                return deferred
            },
            _tryRefreshLastPage: function() {
                var deferred = new _deferred.Deferred;
                if (this._isLastPage() || this.option("grouped")) {
                    deferred.resolve()
                } else {
                    this._refreshLastPage().done(function() {
                        deferred.resolve()
                    })
                }
                return deferred.promise()
            },
            _refreshLastPage: function() {
                this._expectLastItemLoading();
                return this._dataSource.load()
            },
            _updateSelectionAfterDelete: function(index) {
                var key = this._getKeyByIndex(index);
                this._selection.deselect([key])
            },
            _updateIndicesAfterIndex: function(index) {
                var itemElements = this._itemElements();
                for (var i = index + 1; i < itemElements.length; i++) {
                    (0, _renderer.default)(itemElements[i]).data(this._itemIndexKey(), i - 1)
                }
            },
            _simulateOptionChange: function(optionName) {
                var optionValue = this.option(optionName);
                if (optionValue instanceof _data_source.DataSource) {
                    return
                }
                this._optionChangedAction({
                    name: optionName,
                    fullName: optionName,
                    value: optionValue
                })
            },
            isItemSelected: function(itemElement) {
                return this._isItemSelected(this._editStrategy.getNormalizedIndex(itemElement))
            },
            selectItem: function(itemElement) {
                if ("none" === this.option("selectionMode")) {
                    return
                }
                var itemIndex = this._editStrategy.getNormalizedIndex(itemElement);
                if (!indexExists(itemIndex)) {
                    return
                }
                var key = this._getKeyByIndex(itemIndex);
                if (this._selection.isItemSelected(key)) {
                    return
                }
                if ("single" === this.option("selectionMode")) {
                    this._selection.setSelection([key])
                } else {
                    var selectedItemKeys = this.option("selectedItemKeys") || [];
                    this._selection.setSelection([].concat(_toConsumableArray(selectedItemKeys), [key]))
                }
            },
            unselectItem: function(itemElement) {
                var itemIndex = this._editStrategy.getNormalizedIndex(itemElement);
                if (!indexExists(itemIndex)) {
                    return
                }
                var selectedItemKeys = this._selection.getSelectedItemKeys();
                if (this.option("selectionRequired") && selectedItemKeys.length <= 1) {
                    return
                }
                var key = this._getKeyByIndex(itemIndex);
                if (!this._selection.isItemSelected(key, {
                        checkPending: true
                    })) {
                    return
                }
                this._selection.deselect([key])
            },
            _deleteItemElementByIndex: function(index) {
                this._updateSelectionAfterDelete(index);
                this._updateIndicesAfterIndex(index);
                this._editStrategy.deleteItemAtIndex(index)
            },
            _afterItemElementDeleted: function($item, deletedActionArgs) {
                var changingOption = this._dataSource ? "dataSource" : "items";
                this._simulateOptionChange(changingOption);
                this._itemEventHandler($item, "onItemDeleted", deletedActionArgs, {
                    beforeExecute: function() {
                        $item.remove()
                    },
                    excludeValidators: ["disabled", "readOnly"]
                });
                this._renderEmptyMessage()
            },
            deleteItem: function(itemElement) {
                var that = this;
                var deferred = new _deferred.Deferred;
                var $item = this._editStrategy.getItemElement(itemElement);
                var index = this._editStrategy.getNormalizedIndex(itemElement);
                var itemResponseWaitClass = this._itemResponseWaitClass();
                if (indexExists(index)) {
                    this._waitDeletingPrepare($item).done(function() {
                        $item.addClass(itemResponseWaitClass);
                        var deletedActionArgs = that._extendActionArgs($item);
                        that._deleteItemFromDS($item).done(function() {
                            that._deleteItemElementByIndex(index);
                            that._afterItemElementDeleted($item, deletedActionArgs);
                            that._tryRefreshLastPage().done(function() {
                                deferred.resolveWith(that)
                            })
                        }).fail(function() {
                            $item.removeClass(itemResponseWaitClass);
                            deferred.rejectWith(that)
                        })
                    }).fail(function() {
                        deferred.rejectWith(that)
                    })
                } else {
                    deferred.rejectWith(that)
                }
                return deferred.promise()
            },
            reorderItem: function(itemElement, toItemElement) {
                var deferred = new _deferred.Deferred;
                var that = this;
                var strategy = this._editStrategy;
                var $movingItem = strategy.getItemElement(itemElement);
                var $destinationItem = strategy.getItemElement(toItemElement);
                var movingIndex = strategy.getNormalizedIndex(itemElement);
                var destinationIndex = strategy.getNormalizedIndex(toItemElement);
                var changingOption = this._dataSource ? "dataSource" : "items";
                var canMoveItems = indexExists(movingIndex) && indexExists(destinationIndex) && movingIndex !== destinationIndex;
                if (canMoveItems) {
                    deferred.resolveWith(this)
                } else {
                    deferred.rejectWith(this)
                }
                return deferred.promise().done(function() {
                    $destinationItem[strategy.itemPlacementFunc(movingIndex, destinationIndex)]($movingItem);
                    strategy.moveItemAtIndexToIndex(movingIndex, destinationIndex);
                    this._updateIndicesAfterIndex(movingIndex);
                    that.option("selectedItems", that._getItemsByKeys(that._selection.getSelectedItemKeys(), that._selection.getSelectedItems()));
                    if ("items" === changingOption) {
                        that._simulateOptionChange(changingOption)
                    }
                    that._itemEventHandler($movingItem, "onItemReordered", {
                        fromIndex: strategy.getIndex(movingIndex),
                        toIndex: strategy.getIndex(destinationIndex)
                    }, {
                        excludeValidators: ["disabled", "readOnly"]
                    })
                })
            }
        });
        var _default = CollectionWidget;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/themes.js ***!
      \************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getTheme = getTheme;
        exports.currentTheme = currentTheme;
        exports.registerTheme = registerTheme;
        exports.registerThemeSchemeAlias = registerThemeSchemeAlias;
        exports.addCacheItem = addCacheItem;
        exports.removeCacheItem = removeCacheItem;
        exports.refreshTheme = refreshTheme;
        var _extend2 = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _utils = __webpack_require__( /*! ./core/utils */ 14);
        var _themes = __webpack_require__( /*! ../ui/themes */ 34);
        var themes = {};
        var themesMapping = {};
        var themesSchemeMapping = {};
        var _extend = _extend2.extend;
        var _each = _iterator.each;
        var currentThemeName = null;
        var defaultTheme;
        var nextCacheUid = 0;
        var widgetsCache = {};

        function getTheme(themeName) {
            var name = (0, _utils.normalizeEnum)(themeName);
            return themes[name] || themes[themesMapping[name] || currentTheme()]
        }

        function findThemeNameByName(name, scheme) {
            return themesMapping[name + "." + scheme] || themesSchemeMapping[name + "." + scheme] || themesMapping[name]
        }

        function findThemeNameByPlatform(platform, version, scheme) {
            return findThemeNameByName(platform + version, scheme) || findThemeNameByName(platform, scheme)
        }

        function currentTheme(themeName, colorScheme) {
            if (!arguments.length) {
                return currentThemeName || findThemeNameByName((0, _themes.current)()) || defaultTheme
            }
            var scheme = (0, _utils.normalizeEnum)(colorScheme);
            currentThemeName = (themeName && themeName.platform ? findThemeNameByPlatform((0, _utils.normalizeEnum)(themeName.platform), themeName.version, scheme) : findThemeNameByName((0, _utils.normalizeEnum)(themeName), scheme)) || currentThemeName;
            return this
        }

        function getThemeInfo(themeName, splitter) {
            var k = themeName.indexOf(splitter);
            return k > 0 ? {
                name: themeName.substring(0, k),
                scheme: themeName.substring(k + 1)
            } : null
        }

        function registerThemeName(themeName, targetThemeName) {
            var themeInfo = getThemeInfo(themeName, ".") || {
                name: themeName
            };
            var name = themeInfo.name;
            var scheme = themeInfo.scheme;
            if (scheme) {
                themesMapping[name] = themesMapping[name] || targetThemeName;
                themesMapping[name + "." + scheme] = targetThemeName
            } else {
                themesMapping[name] = targetThemeName
            }
        }

        function registerTheme(theme, baseThemeName) {
            var themeName = (0, _utils.normalizeEnum)(theme && theme.name);
            if (themeName) {
                theme.isDefault && (defaultTheme = themeName);
                registerThemeName(themeName, themeName);
                themes[themeName] = _extend(true, {}, getTheme(baseThemeName), patchTheme(theme))
            }
        }

        function registerThemeSchemeAlias(from, to) {
            themesSchemeMapping[from] = to
        }

        function mergeScalar(target, field, source, sourceValue) {
            var _value = source ? source[field] : sourceValue;
            if (void 0 !== _value && void 0 === target[field]) {
                target[field] = _value
            }
        }

        function mergeObject(target, field, source, sourceValue) {
            var _value = source ? source[field] : sourceValue;
            if (void 0 !== _value) {
                target[field] = _extend(true, {}, _value, target[field])
            }
        }

        function patchTheme(theme) {
            theme = _extend(true, {
                loadingIndicator: {
                    font: {}
                },
                "export": {
                    font: {}
                },
                legend: {
                    font: {},
                    border: {}
                },
                title: {
                    font: {}
                },
                tooltip: {
                    font: {}
                },
                "chart:common": {},
                "chart:common:axis": {
                    grid: {},
                    minorGrid: {},
                    tick: {},
                    minorTick: {},
                    title: {
                        font: {}
                    },
                    label: {
                        font: {}
                    }
                },
                "chart:common:annotation": {
                    font: {},
                    border: {}
                },
                chart: {
                    commonSeriesSettings: {
                        candlestick: {}
                    }
                },
                pie: {},
                polar: {},
                gauge: {
                    scale: {
                        tick: {},
                        minorTick: {},
                        label: {
                            font: {}
                        }
                    }
                },
                barGauge: {},
                funnel: {},
                sankey: {},
                map: {
                    background: {}
                },
                treeMap: {
                    tile: {
                        selectionStyle: {
                            border: {}
                        }
                    },
                    group: {
                        border: {},
                        selectionStyle: {
                            border: {}
                        },
                        label: {
                            font: {}
                        }
                    }
                },
                rangeSelector: {
                    scale: {
                        tick: {},
                        minorTick: {},
                        label: {
                            font: {}
                        }
                    },
                    chart: {}
                },
                sparkline: {},
                bullet: {}
            }, theme);
            mergeScalar(theme.loadingIndicator, "backgroundColor", theme);
            mergeScalar(theme.chart.commonSeriesSettings.candlestick, "innerColor", null, theme.backgroundColor);
            mergeScalar(theme.map.background, "color", null, theme.backgroundColor);
            mergeScalar(theme.title.font, "color", null, theme.primaryTitleColor);
            mergeObject(theme.title, "subtitle", null, theme.title);
            mergeScalar(theme.legend.font, "color", null, theme.secondaryTitleColor);
            mergeScalar(theme.legend.border, "color", null, theme.gridColor);
            patchAxes(theme);
            _each(["chart", "pie", "polar", "gauge", "barGauge", "map", "treeMap", "funnel", "rangeSelector", "sparkline", "bullet", "sankey"], function(_, section) {
                mergeScalar(theme[section], "redrawOnResize", theme);
                mergeScalar(theme[section], "containerBackgroundColor", null, theme.backgroundColor);
                mergeObject(theme[section], "tooltip", theme);
                mergeObject(theme[section], "export", theme)
            });
            _each(["chart", "pie", "polar", "gauge", "barGauge", "map", "treeMap", "funnel", "rangeSelector", "sankey"], function(_, section) {
                mergeObject(theme[section], "loadingIndicator", theme);
                mergeObject(theme[section], "legend", theme);
                mergeObject(theme[section], "title", theme)
            });
            _each(["chart", "pie", "polar"], function(_, section) {
                mergeObject(theme, section, null, theme["chart:common"])
            });
            _each(["chart", "polar"], function(_, section) {
                theme[section] = theme[section] || {};
                mergeObject(theme[section], "commonAxisSettings", null, theme["chart:common:axis"])
            });
            _each(["chart", "polar", "map", "pie"], function(_, section) {
                theme[section] = theme[section] || {};
                mergeObject(theme[section], "commonAnnotationSettings", null, theme["chart:common:annotation"])
            });
            mergeObject(theme.rangeSelector.chart, "commonSeriesSettings", theme.chart);
            mergeObject(theme.rangeSelector.chart, "dataPrepareSettings", theme.chart);
            mergeScalar(theme.treeMap.group.border, "color", null, theme.gridColor);
            mergeScalar(theme.treeMap.tile.selectionStyle.border, "color", null, theme.primaryTitleColor);
            mergeScalar(theme.treeMap.group.selectionStyle.border, "color", null, theme.primaryTitleColor);
            mergeScalar(theme.map.legend, "backgroundColor", theme);
            patchMapLayers(theme);
            return theme
        }

        function patchAxes(theme) {
            var commonAxisSettings = theme["chart:common:axis"];
            var colorFieldName = "color";
            _each([commonAxisSettings.grid, commonAxisSettings.minorGrid], function(_, obj) {
                mergeScalar(obj, colorFieldName, null, theme.gridColor)
            });
            _each([commonAxisSettings, commonAxisSettings.tick, commonAxisSettings.minorTick, commonAxisSettings.label.font], function(_, obj) {
                mergeScalar(obj, colorFieldName, null, theme.axisColor)
            });
            mergeScalar(commonAxisSettings.title.font, colorFieldName, null, theme.secondaryTitleColor);
            mergeScalar(theme.gauge.scale.label.font, colorFieldName, null, theme.axisColor);
            mergeScalar(theme.gauge.scale.tick, colorFieldName, null, theme.backgroundColor);
            mergeScalar(theme.gauge.scale.minorTick, colorFieldName, null, theme.backgroundColor);
            mergeScalar(theme.rangeSelector.scale.label.font, colorFieldName, null, theme.axisColor)
        }

        function patchMapLayers(theme) {
            var map = theme.map;
            _each(["area", "line", "marker"], function(_, section) {
                mergeObject(map, "layer:" + section, null, map.layer)
            });
            _each(["dot", "bubble", "pie", "image"], function(_, section) {
                mergeObject(map, "layer:marker:" + section, null, map["layer:marker"])
            })
        }

        function addCacheItem(target) {
            var cacheUid = ++nextCacheUid;
            target._cache = cacheUid;
            widgetsCache[cacheUid] = target
        }

        function removeCacheItem(target) {
            delete widgetsCache[target._cache]
        }

        function refreshTheme() {
            _each(widgetsCache, function() {
                this.refresh()
            });
            return this
        }
    },
    /*!*****************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/icon.js ***!
      \*****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getImageContainer = exports.getImageSourceType = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ICON_CLASS = "dx-icon";
        var SVG_ICON_CLASS = "dx-svg-icon";
        var getImageSourceType = function(source) {
            if (!source || "string" !== typeof source) {
                return false
            }
            if (/^\s*<svg[^>]*>(.|\r?\n)*?<\/svg>\s*$/i.test(source)) {
                return "svg"
            }
            if (/data:.*base64|\.|[^<\s]\//.test(source)) {
                return "image"
            }
            if (/^[\w-_]+$/.test(source)) {
                return "dxIcon"
            }
            if (/^\s?([\w-_]\s?)+$/.test(source)) {
                return "fontIcon"
            }
            return false
        };
        exports.getImageSourceType = getImageSourceType;
        var getImageContainer = function(source) {
            switch (getImageSourceType(source)) {
                case "image":
                    return (0, _renderer.default)("<img>").attr("src", source).addClass(ICON_CLASS);
                case "fontIcon":
                    return (0, _renderer.default)("<i>").addClass("".concat(ICON_CLASS, " ").concat(source));
                case "dxIcon":
                    return (0, _renderer.default)("<i>").addClass("".concat(ICON_CLASS, " ").concat(ICON_CLASS, "-").concat(source));
                case "svg":
                    return (0, _renderer.default)("<i>").addClass("".concat(ICON_CLASS, " ").concat(SVG_ICON_CLASS)).append(source);
                default:
                    return null
            }
        };
        exports.getImageContainer = getImageContainer
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/date_serialization.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _config = _interopRequireDefault(__webpack_require__( /*! ../config */ 31));
        var _date = __webpack_require__( /*! ../../localization/ldml/date.formatter */ 242);
        var _default_date_names = _interopRequireDefault(__webpack_require__( /*! ../../localization/default_date_names */ 243));
        var _type = __webpack_require__( /*! ./type */ 1);
        var _browser = _interopRequireDefault(__webpack_require__( /*! ./browser */ 23));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var NUMBER_SERIALIZATION_FORMAT = "number";
        var DATE_SERIALIZATION_FORMAT = "yyyy/MM/dd";
        var DATETIME_SERIALIZATION_FORMAT = "yyyy/MM/dd HH:mm:ss";
        var ISO8601_PATTERN = /^(\d{4,})(-)?(\d{2})(-)?(\d{2})(?:T(\d{2})(:)?(\d{2})?(:)?(\d{2}(?:\.(\d{1,3})\d*)?)?)?(Z|([+-])(\d{2})(:)?(\d{2})?)?$/;
        var ISO8601_TIME_PATTERN = /^(\d{2}):(\d{2})(:(\d{2}))?$/;
        var ISO8601_PATTERN_PARTS = ["", "yyyy", "", "MM", "", "dd", "THH", "", "mm", "", "ss", ".SSS"];
        var DATE_SERIALIZATION_PATTERN = /^(\d{4})\/(\d{2})\/(\d{2})$/;
        var MILLISECOND_LENGHT = 3;
        var isIE11 = _browser.default.msie && parseInt(_browser.default.version) <= 11;
        var dateParser = function(text, skipISO8601Parsing) {
            var result;
            if ((0, _type.isString)(text) && !skipISO8601Parsing) {
                result = parseISO8601String(text)
            }
            return result || parseDate(text)
        };

        function getTimePart(part) {
            return +part || 0
        }

        function parseDate(text) {
            var isDefaultSerializationFormat = getDateSerializationFormat(text) === DATE_SERIALIZATION_FORMAT;
            var parsedValue = !(0, _type.isDate)(text) && Date.parse(text);
            if ((!parsedValue || isIE11) && isDefaultSerializationFormat) {
                var parts = text.match(DATE_SERIALIZATION_PATTERN);
                if (parts) {
                    var newDate = new Date(getTimePart(parts[1]), getTimePart(parts[2]), getTimePart(parts[3]));
                    newDate.setFullYear(getTimePart(parts[1]));
                    newDate.setMonth(getTimePart(parts[2]) - 1);
                    newDate.setDate(getTimePart(parts[3]));
                    return newDate
                }
            }
            return (0, _type.isNumeric)(parsedValue) ? new Date(parsedValue) : text
        }

        function parseISO8601String(text) {
            var parts = text.match(ISO8601_PATTERN);
            if (!parts) {
                parts = text.match(ISO8601_TIME_PATTERN);
                if (parts) {
                    return new Date(0, 0, 0, getTimePart(parts[1]), getTimePart(parts[2]), getTimePart(parts[4]))
                }
                return
            }
            var year = parts[1];
            var month = --parts[3];
            var day = parts[5];
            var timeZoneHour = 0;
            var timeZoneMinute = 0;
            timeZoneHour = getTimePart(parts[14]);
            timeZoneMinute = getTimePart(parts[16]);
            if ("-" === parts[13]) {
                timeZoneHour = -timeZoneHour;
                timeZoneMinute = -timeZoneMinute
            }
            var hour = getTimePart(parts[6]) - timeZoneHour;
            var minute = getTimePart(parts[8]) - timeZoneMinute;
            var second = getTimePart(parts[10]);
            var parseMilliseconds = function(part) {
                part = part || "";
                return getTimePart(part) * Math.pow(10, MILLISECOND_LENGHT - part.length)
            };
            var millisecond = parseMilliseconds(parts[11]);
            if (parts[12]) {
                return new Date(Date.UTC(year, month, day, hour, minute, second, millisecond))
            }
            return new Date(year, month, day, hour, minute, second, millisecond)
        }
        var getIso8601Format = function(text, useUtc) {
            var parts = text.match(ISO8601_PATTERN);
            var result = "";
            if (!parts) {
                parts = text.match(ISO8601_TIME_PATTERN);
                if (parts) {
                    return parts[3] ? "HH:mm:ss" : "HH:mm"
                }
                return
            }
            for (var i = 1; i < ISO8601_PATTERN_PARTS.length; i++) {
                if (parts[i]) {
                    result += ISO8601_PATTERN_PARTS[i] || parts[i]
                }
            }
            if ("Z" === parts[12]) {
                result += "'Z'"
            }
            if (parts[14]) {
                if (parts[15]) {
                    result += "xxx"
                } else {
                    if (parts[16]) {
                        result += "xx"
                    } else {
                        result += "x"
                    }
                }
            }
            return result
        };
        var deserializeDate = function(value) {
            if ("number" === typeof value) {
                return new Date(value)
            }
            return dateParser(value, !(0, _config.default)().forceIsoDateParsing)
        };
        var serializeDate = function(value, serializationFormat) {
            if (!serializationFormat) {
                return value
            }
            if (!(0, _type.isDate)(value)) {
                return null
            }
            if (serializationFormat === NUMBER_SERIALIZATION_FORMAT) {
                return value && value.valueOf ? value.valueOf() : null
            }
            return (0, _date.getFormatter)(serializationFormat, _default_date_names.default)(value)
        };
        var getDateSerializationFormat = function(value) {
            if ("number" === typeof value) {
                return NUMBER_SERIALIZATION_FORMAT
            } else {
                if ((0, _type.isString)(value)) {
                    var format;
                    if ((0, _config.default)().forceIsoDateParsing) {
                        format = getIso8601Format(value)
                    }
                    if (format) {
                        return format
                    } else {
                        if (value.indexOf(":") >= 0) {
                            return DATETIME_SERIALIZATION_FORMAT
                        } else {
                            return DATE_SERIALIZATION_FORMAT
                        }
                    }
                } else {
                    if (value) {
                        return null
                    }
                }
            }
        };
        var _default = {
            dateParser: dateParser,
            deserializeDate: deserializeDate,
            serializeDate: serializeDate,
            getDateSerializationFormat: getDateSerializationFormat
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/dependency_injector.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = _default;
        var _extend = __webpack_require__( /*! ./extend */ 0);
        var _type = __webpack_require__( /*! ./type */ 1);
        var _iterator = __webpack_require__( /*! ./iterator */ 3);
        var _class = _interopRequireDefault(__webpack_require__( /*! ../class */ 15));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _default(object) {
            var BaseClass = _class.default.inherit(object);
            var InjectedClass = BaseClass;
            var instance = new InjectedClass(object);
            var initialFields = {};
            var injectFields = function(injectionObject, initial) {
                (0, _iterator.each)(injectionObject, function(key) {
                    if ((0, _type.isFunction)(instance[key])) {
                        if (initial || !object[key]) {
                            object[key] = function() {
                                return instance[key].apply(object, arguments)
                            }
                        }
                    } else {
                        if (initial) {
                            initialFields[key] = object[key]
                        }
                        object[key] = instance[key]
                    }
                })
            };
            injectFields(object, true);
            object.inject = function(injectionObject) {
                InjectedClass = InjectedClass.inherit(injectionObject);
                instance = new InjectedClass;
                injectFields(injectionObject)
            };
            object.resetInjection = function() {
                (0, _extend.extend)(object, initialFields);
                InjectedClass = BaseClass;
                instance = new BaseClass
            };
            return object
        }
        module.exports = exports.default
    },
    /*!**************************************************************!*\
      !*** ./artifacts/transpiled-npm/events/visibility_change.js ***!
      \**************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.triggerResizeEvent = exports.triggerHidingEvent = exports.triggerShownEvent = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ./core/events_engine */ 5));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var triggerVisibilityChangeEvent = function(eventName) {
            var VISIBILITY_CHANGE_SELECTOR = ".dx-visibility-change-handler";
            return function(element) {
                var $element = (0, _renderer.default)(element || "body");
                var changeHandlers = $element.filter(VISIBILITY_CHANGE_SELECTOR).add($element.find(VISIBILITY_CHANGE_SELECTOR));
                for (var i = 0; i < changeHandlers.length; i++) {
                    _events_engine.default.triggerHandler(changeHandlers[i], eventName)
                }
            }
        };
        var triggerShownEvent = triggerVisibilityChangeEvent("dxshown");
        exports.triggerShownEvent = triggerShownEvent;
        var triggerHidingEvent = triggerVisibilityChangeEvent("dxhiding");
        exports.triggerHidingEvent = triggerHidingEvent;
        var triggerResizeEvent = triggerVisibilityChangeEvent("dxresize");
        exports.triggerResizeEvent = triggerResizeEvent
    },
    /*!********************************!*\
      !*** external "window.jQuery" ***!
      \********************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports) {
        module.exports = window.jQuery
    },
    /*!******************************************!*\
      !*** external "window.DevExpress.Quill" ***!
      \******************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports) {
        module.exports = window.DevExpress.Quill
    },
    /*!*****************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/dateutil.js ***!
      \*****************************************************/
    /*! exports provided: dateutil, default */
    /*! exports used: dateutil, default */
    function(module, __webpack_exports__, __webpack_require__) {
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return dateutil
        });
        var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__( /*! ./helpers */ 63);
        var dateutil;
        ! function(dateutil) {
            dateutil.MONTH_DAYS = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            dateutil.ONE_DAY = 864e5;
            dateutil.MAXYEAR = 9999;
            dateutil.ORDINAL_BASE = new Date(Date.UTC(1970, 0, 1));
            dateutil.PY_WEEKDAYS = [6, 0, 1, 2, 3, 4, 5];
            dateutil.getYearDay = function(date) {
                var dateNoTime = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                return Math.ceil((dateNoTime.valueOf() - new Date(date.getUTCFullYear(), 0, 1).valueOf()) / dateutil.ONE_DAY) + 1
            };
            dateutil.isLeapYear = function(year) {
                return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0
            };
            dateutil.isDate = function(value) {
                return value instanceof Date
            };
            dateutil.isValidDate = function(value) {
                return dateutil.isDate(value) && !isNaN(value.getTime())
            };
            dateutil.tzOffset = function(date) {
                return 60 * date.getTimezoneOffset() * 1e3
            };
            dateutil.daysBetween = function(date1, date2) {
                var date1ms = date1.getTime() - dateutil.tzOffset(date1);
                var date2ms = date2.getTime() - dateutil.tzOffset(date2);
                var differencems = date1ms - date2ms;
                return Math.round(differencems / dateutil.ONE_DAY)
            };
            dateutil.toOrdinal = function(date) {
                return dateutil.daysBetween(date, dateutil.ORDINAL_BASE)
            };
            dateutil.fromOrdinal = function(ordinal) {
                return new Date(dateutil.ORDINAL_BASE.getTime() + ordinal * dateutil.ONE_DAY)
            };
            dateutil.getMonthDays = function(date) {
                var month = date.getUTCMonth();
                return 1 === month && dateutil.isLeapYear(date.getUTCFullYear()) ? 29 : dateutil.MONTH_DAYS[month]
            };
            dateutil.getWeekday = function(date) {
                return dateutil.PY_WEEKDAYS[date.getUTCDay()]
            };
            dateutil.monthRange = function(year, month) {
                var date = new Date(Date.UTC(year, month, 1));
                return [dateutil.getWeekday(date), dateutil.getMonthDays(date)]
            };
            dateutil.combine = function(date, time) {
                time = time || date;
                return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds()))
            };
            dateutil.clone = function(date) {
                var dolly = new Date(date.getTime());
                return dolly
            };
            dateutil.cloneDates = function(dates) {
                var clones = [];
                for (var i = 0; i < dates.length; i++) {
                    clones.push(dateutil.clone(dates[i]))
                }
                return clones
            };
            dateutil.sort = function(dates) {
                dates.sort(function(a, b) {
                    return a.getTime() - b.getTime()
                })
            };
            dateutil.timeToUntilString = function(time, utc) {
                if (void 0 === utc) {
                    utc = true
                }
                var date = new Date(time);
                return [Object(__WEBPACK_IMPORTED_MODULE_0__helpers__.i)(date.getUTCFullYear().toString(), 4, "0"), Object(__WEBPACK_IMPORTED_MODULE_0__helpers__.i)(date.getUTCMonth() + 1, 2, "0"), Object(__WEBPACK_IMPORTED_MODULE_0__helpers__.i)(date.getUTCDate(), 2, "0"), "T", Object(__WEBPACK_IMPORTED_MODULE_0__helpers__.i)(date.getUTCHours(), 2, "0"), Object(__WEBPACK_IMPORTED_MODULE_0__helpers__.i)(date.getUTCMinutes(), 2, "0"), Object(__WEBPACK_IMPORTED_MODULE_0__helpers__.i)(date.getUTCSeconds(), 2, "0"), utc ? "Z" : ""].join("")
            };
            dateutil.untilStringToDate = function(until) {
                var re = /^(\d{4})(\d{2})(\d{2})(T(\d{2})(\d{2})(\d{2})Z?)?$/;
                var bits = re.exec(until);
                if (!bits) {
                    throw new Error("Invalid UNTIL value: " + until)
                }
                return new Date(Date.UTC(parseInt(bits[1], 10), parseInt(bits[2], 10) - 1, parseInt(bits[3], 10), parseInt(bits[5], 10) || 0, parseInt(bits[6], 10) || 0, parseInt(bits[7], 10) || 0))
            }
        }(dateutil || (dateutil = {}));
        __webpack_exports__.b = dateutil
    },
    /*!****************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/helpers.js ***!
      \****************************************************/
    /*! exports provided: isPresent, isNumber, isWeekdayStr, isArray, range, clone, repeat, toArray, padStart, split, pymod, divmod, empty, notEmpty, includes */
    /*! exports used: divmod, empty, includes, isArray, isNumber, isPresent, isWeekdayStr, notEmpty, padStart, pymod, range, repeat, split, toArray */
    function(module, __webpack_exports__, __webpack_require__) {
        __webpack_require__.d(__webpack_exports__, "f", function() {
            return isPresent
        });
        __webpack_require__.d(__webpack_exports__, "e", function() {
            return isNumber
        });
        __webpack_require__.d(__webpack_exports__, "g", function() {
            return isWeekdayStr
        });
        __webpack_require__.d(__webpack_exports__, "d", function() {
            return isArray
        });
        __webpack_require__.d(__webpack_exports__, "k", function() {
            return range
        });
        __webpack_require__.d(__webpack_exports__, "l", function() {
            return repeat
        });
        __webpack_require__.d(__webpack_exports__, "n", function() {
            return toArray
        });
        __webpack_exports__.i = padStart;
        __webpack_require__.d(__webpack_exports__, "m", function() {
            return split
        });
        __webpack_require__.d(__webpack_exports__, "j", function() {
            return pymod
        });
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return divmod
        });
        __webpack_require__.d(__webpack_exports__, "b", function() {
            return empty
        });
        __webpack_require__.d(__webpack_exports__, "h", function() {
            return notEmpty
        });
        __webpack_require__.d(__webpack_exports__, "c", function() {
            return includes
        });
        var __WEBPACK_IMPORTED_MODULE_0__weekday__ = __webpack_require__( /*! ./weekday */ 159);
        var isPresent = function(value) {
            return null !== value && void 0 !== value
        };
        var isNumber = function(value) {
            return "number" === typeof value
        };
        var isWeekdayStr = function(value) {
            return __WEBPACK_IMPORTED_MODULE_0__weekday__.a.indexOf(value) >= 0
        };
        var isArray = Array.isArray;
        var range = function(start, end) {
            if (void 0 === end) {
                end = start
            }
            if (1 === arguments.length) {
                end = start;
                start = 0
            }
            var rang = [];
            for (var i = start; i < end; i++) {
                rang.push(i)
            }
            return rang
        };
        var repeat = function(value, times) {
            var i = 0;
            var array = [];
            if (isArray(value)) {
                for (; i < times; i++) {
                    array[i] = [].concat(value)
                }
            } else {
                for (; i < times; i++) {
                    array[i] = value
                }
            }
            return array
        };
        var toArray = function(item) {
            if (isArray(item)) {
                return item
            }
            return [item]
        };

        function padStart(item, targetLength, padString) {
            if (void 0 === padString) {
                padString = " "
            }
            var str = String(item);
            targetLength >>= 0;
            if (str.length > targetLength) {
                return String(str)
            }
            targetLength -= str.length;
            if (targetLength > padString.length) {
                padString += repeat(padString, targetLength / padString.length)
            }
            return padString.slice(0, targetLength) + String(str)
        }
        var split = function(str, sep, num) {
            var splits = str.split(sep);
            return num ? splits.slice(0, num).concat([splits.slice(num).join(sep)]) : splits
        };
        var pymod = function(a, b) {
            var r = a % b;
            return r * b < 0 ? r + b : r
        };
        var divmod = function(a, b) {
            return {
                div: Math.floor(a / b),
                mod: pymod(a, b)
            }
        };
        var empty = function(obj) {
            return !isPresent(obj) || 0 === obj.length
        };
        var notEmpty = function(obj) {
            return !empty(obj)
        };
        var includes = function(arr, val) {
            return notEmpty(arr) && arr.indexOf(val) !== -1
        }
    },
    /*!************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/overlay.js ***!
      \************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./overlay/ui.overlay */ 328));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _ui.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************************!*\
      !*** ./artifacts/transpiled-npm/core/templates/bindable_template.js ***!
      \**********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.BindableTemplate = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../renderer */ 2));
        var _template_base = __webpack_require__( /*! ./template_base */ 75);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _remove_event = _interopRequireDefault(__webpack_require__( /*! ../remove_event */ 152));
        var _type = __webpack_require__( /*! ../utils/type */ 1);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var watchChanges = function() {
            var globalWatch = function(data, watchMethod, callback) {
                return watchMethod(function() {
                    return data
                }, callback)
            };
            var fieldsWatch = function(data, watchMethod, fields, fieldsMap, callback) {
                var resolvedData = {};
                var missedFields = fields.slice();
                var watchHandlers = fields.map(function(name) {
                    var fieldGetter = fieldsMap[name];
                    return watchMethod(fieldGetter ? function() {
                        return fieldGetter(data)
                    } : function() {
                        return data[name]
                    }, function(value) {
                        resolvedData[name] = value;
                        if (missedFields.length) {
                            var index = missedFields.indexOf(name);
                            if (index >= 0) {
                                missedFields.splice(index, 1)
                            }
                        }
                        if (!missedFields.length) {
                            callback(resolvedData)
                        }
                    })
                });
                return function() {
                    watchHandlers.forEach(function(dispose) {
                        return dispose()
                    })
                }
            };
            return function(rawData, watchMethod, fields, fieldsMap, callback) {
                var fieldsDispose;
                var globalDispose = globalWatch(rawData, watchMethod, function(dataWithRawFields) {
                    fieldsDispose && fieldsDispose();
                    if ((0, _type.isPrimitive)(dataWithRawFields)) {
                        callback(dataWithRawFields);
                        return
                    }
                    fieldsDispose = fieldsWatch(dataWithRawFields, watchMethod, fields, fieldsMap, callback)
                });
                return function() {
                    fieldsDispose && fieldsDispose();
                    globalDispose && globalDispose()
                }
            }
        }();
        var BindableTemplate = function(_TemplateBase) {
            _inheritsLoose(BindableTemplate, _TemplateBase);

            function BindableTemplate(render, fields, watchMethod, fieldsMap) {
                var _this;
                _this = _TemplateBase.call(this) || this;
                _this._render = render;
                _this._fields = fields;
                _this._fieldsMap = fieldsMap || {};
                _this._watchMethod = watchMethod;
                return _this
            }
            var _proto = BindableTemplate.prototype;
            _proto._renderCore = function(options) {
                var _this2 = this;
                var $container = (0, _renderer.default)(options.container);
                var dispose = watchChanges(options.model, this._watchMethod, this._fields, this._fieldsMap, function(data) {
                    $container.empty();
                    _this2._render($container, data, options.model)
                });
                _events_engine.default.on($container, _remove_event.default, dispose);
                return $container.contents()
            };
            return BindableTemplate
        }(_template_base.TemplateBase);
        exports.BindableTemplate = BindableTemplate
    },
    /*!****************************!*\
      !*** external "window.ko" ***!
      \****************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports) {
        module.exports = window.ko
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/core/dom_component.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _config = _interopRequireDefault(__webpack_require__( /*! ./config */ 31));
        var _errors = _interopRequireDefault(__webpack_require__( /*! ./errors */ 25));
        var _resize_callbacks = _interopRequireDefault(__webpack_require__( /*! ../core/utils/resize_callbacks */ 125));
        var _component = _interopRequireDefault(__webpack_require__( /*! ./component */ 127));
        var _template_manager = __webpack_require__( /*! ./template_manager */ 519);
        var _public_component = __webpack_require__( /*! ./utils/public_component */ 147);
        var _element_data = __webpack_require__( /*! ./element_data */ 40);
        var _iterator = __webpack_require__( /*! ./utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ./utils/extend */ 0);
        var _element = __webpack_require__( /*! ../core/element */ 18);
        var _common = __webpack_require__( /*! ./utils/common */ 4);
        var _array = __webpack_require__( /*! ./utils/array */ 12);
        var _type = __webpack_require__( /*! ./utils/type */ 1);
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _short = __webpack_require__( /*! ../events/short */ 128);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var abstract = _component.default.abstract;
        var DOMComponent = _component.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    width: void 0,
                    height: void 0,
                    rtlEnabled: (0, _config.default)().rtlEnabled,
                    elementAttr: {},
                    disabled: false,
                    integrationOptions: {}
                }, this._useTemplates() ? _template_manager.TemplateManager.createDefaultOptions() : {})
            },
            ctor: function(element, options) {
                this._customClass = null;
                this._createElement(element);
                (0, _public_component.attachInstanceToElement)(this._$element, this, this._dispose);
                this.callBase(options)
            },
            _createElement: function(element) {
                this._$element = (0, _renderer.default)(element)
            },
            _getSynchronizableOptionsForCreateComponent: function() {
                return ["rtlEnabled", "disabled", "templatesRenderAsynchronously"]
            },
            _visibilityChanged: abstract,
            _dimensionChanged: abstract,
            _init: function() {
                this.callBase();
                this._attachWindowResizeCallback();
                this._initTemplateManager()
            },
            _setOptionsByDevice: function(instanceCustomRules) {
                this.callBase([].concat(this.constructor._classCustomRules || [], instanceCustomRules || []))
            },
            _isInitialOptionValue: function(name) {
                var isCustomOption = this.constructor._classCustomRules && Object.prototype.hasOwnProperty.call(this._convertRulesToOptions(this.constructor._classCustomRules), name);
                return !isCustomOption && this.callBase(name)
            },
            _attachWindowResizeCallback: function() {
                if (this._isDimensionChangeSupported()) {
                    var windowResizeCallBack = this._windowResizeCallBack = this._dimensionChanged.bind(this);
                    _resize_callbacks.default.add(windowResizeCallBack)
                }
            },
            _isDimensionChangeSupported: function() {
                return this._dimensionChanged !== abstract
            },
            _renderComponent: function() {
                this._initMarkup();
                (0, _window.hasWindow)() && this._render()
            },
            _initMarkup: function() {
                var _ref = this.option() || {},
                    rtlEnabled = _ref.rtlEnabled;
                this._renderElementAttributes();
                this._toggleRTLDirection(rtlEnabled);
                this._renderVisibilityChange();
                this._renderDimensions()
            },
            _render: function() {
                this._attachVisibilityChangeHandlers()
            },
            _renderElementAttributes: function() {
                var _ref2 = this.option() || {},
                    elementAttr = _ref2.elementAttr;
                var attributes = (0, _extend.extend)({}, elementAttr);
                var classNames = attributes.class;
                delete attributes.class;
                this.$element().attr(attributes).removeClass(this._customClass).addClass(classNames);
                this._customClass = classNames
            },
            _renderVisibilityChange: function() {
                if (this._isDimensionChangeSupported()) {
                    this._attachDimensionChangeHandlers()
                }
                if (this._isVisibilityChangeSupported()) {
                    var $element = this.$element();
                    $element.addClass("dx-visibility-change-handler")
                }
            },
            _renderDimensions: function() {
                var $element = this.$element();
                var element = $element.get(0);
                var width = this._getOptionValue("width", element);
                var height = this._getOptionValue("height", element);
                if (this._isCssUpdateRequired(element, height, width)) {
                    $element.css({
                        width: null === width ? "" : width,
                        height: null === height ? "" : height
                    })
                }
            },
            _isCssUpdateRequired: function(element, height, width) {
                return !!((0, _type.isDefined)(width) || (0, _type.isDefined)(height) || element.style.width || element.style.height)
            },
            _attachDimensionChangeHandlers: function() {
                var _this = this;
                var $el = this.$element();
                var namespace = "".concat(this.NAME, "VisibilityChange");
                _short.resize.off($el, {
                    namespace: namespace
                });
                _short.resize.on($el, function() {
                    return _this._dimensionChanged()
                }, {
                    namespace: namespace
                })
            },
            _attachVisibilityChangeHandlers: function() {
                var _this2 = this;
                if (this._isVisibilityChangeSupported()) {
                    var $el = this.$element();
                    var namespace = "".concat(this.NAME, "VisibilityChange");
                    this._isHidden = !this._isVisible();
                    _short.visibility.off($el, {
                        namespace: namespace
                    });
                    _short.visibility.on($el, function() {
                        return _this2._checkVisibilityChanged("shown")
                    }, function() {
                        return _this2._checkVisibilityChanged("hiding")
                    }, {
                        namespace: namespace
                    })
                }
            },
            _isVisible: function() {
                var $element = this.$element();
                return $element.is(":visible")
            },
            _checkVisibilityChanged: function(action) {
                var isVisible = this._isVisible();
                if (isVisible) {
                    if ("hiding" === action && !this._isHidden) {
                        this._visibilityChanged(false);
                        this._isHidden = true
                    } else {
                        if ("shown" === action && this._isHidden) {
                            this._isHidden = false;
                            this._visibilityChanged(true)
                        }
                    }
                }
            },
            _isVisibilityChangeSupported: function() {
                return this._visibilityChanged !== abstract && (0, _window.hasWindow)()
            },
            _clean: _common.noop,
            _modelByElement: function() {
                var _this$option = this.option(),
                    modelByElement = _this$option.modelByElement;
                var $element = this.$element();
                return modelByElement ? modelByElement($element) : void 0
            },
            _invalidate: function() {
                if (this._isUpdateAllowed()) {
                    throw _errors.default.Error("E0007")
                }
                this._requireRefresh = true
            },
            _refresh: function() {
                this._clean();
                this._renderComponent()
            },
            _dispose: function() {
                this._templateManager && this._templateManager.dispose();
                this.callBase();
                this._clean();
                this._detachWindowResizeCallback()
            },
            _detachWindowResizeCallback: function() {
                if (this._isDimensionChangeSupported()) {
                    _resize_callbacks.default.remove(this._windowResizeCallBack)
                }
            },
            _toggleRTLDirection: function(rtl) {
                var $element = this.$element();
                $element.toggleClass("dx-rtl", rtl)
            },
            _createComponent: function(element, component) {
                var _this3 = this;
                var config = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                var synchronizableOptions = (0, _common.grep)(this._getSynchronizableOptionsForCreateComponent(), function(value) {
                    return !(value in config)
                });
                var _this$option2 = this.option(),
                    integrationOptions = _this$option2.integrationOptions;
                var _this$option3 = this.option(),
                    nestedComponentOptions = _this$option3.nestedComponentOptions;
                nestedComponentOptions = nestedComponentOptions || _common.noop;
                var nestedComponentConfig = (0, _extend.extend)({
                    integrationOptions: integrationOptions
                }, nestedComponentOptions(this));
                synchronizableOptions.forEach(function(optionName) {
                    return nestedComponentConfig[optionName] = _this3.option(optionName)
                });
                this._extendConfig(config, nestedComponentConfig);
                var instance = void 0;
                if ((0, _type.isString)(component)) {
                    var $element = (0, _renderer.default)(element)[component](config);
                    instance = $element[component]("instance")
                } else {
                    if (element) {
                        instance = component.getInstance(element);
                        if (instance) {
                            instance.option(config)
                        } else {
                            instance = new component(element, config)
                        }
                    }
                }
                if (instance) {
                    var optionChangedHandler = function(_ref3) {
                        var name = _ref3.name,
                            value = _ref3.value;
                        if ((0, _array.inArray)(name, synchronizableOptions) >= 0) {
                            instance.option(name, value)
                        }
                    };
                    this.on("optionChanged", optionChangedHandler);
                    instance.on("disposing", function() {
                        return _this3.off("optionChanged", optionChangedHandler)
                    })
                }
                return instance
            },
            _extendConfig: function(config, extendConfig) {
                (0, _iterator.each)(extendConfig, function(key, value) {
                    !Object.prototype.hasOwnProperty.call(config, key) && (config[key] = value)
                })
            },
            _defaultActionConfig: function() {
                var $element = this.$element();
                var context = this._modelByElement($element);
                return (0, _extend.extend)(this.callBase(), {
                    context: context
                })
            },
            _defaultActionArgs: function() {
                var $element = this.$element();
                var model = this._modelByElement($element);
                var element = this.element();
                return (0, _extend.extend)(this.callBase(), {
                    element: element,
                    model: model
                })
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "width":
                    case "height":
                        this._renderDimensions();
                        break;
                    case "rtlEnabled":
                        this._invalidate();
                        break;
                    case "elementAttr":
                        this._renderElementAttributes();
                        break;
                    case "disabled":
                    case "integrationOptions":
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _removeAttributes: function(element) {
                var attrs = element.attributes;
                for (var i = attrs.length - 1; i >= 0; i--) {
                    var attr = attrs[i];
                    if (attr) {
                        var name = attr.name;
                        if (!name.indexOf("aria-") || name.indexOf("dx-") !== -1 || "role" === name || "style" === name || "tabindex" === name) {
                            element.removeAttribute(name)
                        }
                    }
                }
            },
            _removeClasses: function(element) {
                element.className = element.className.split(" ").filter(function(cssClass) {
                    return 0 !== cssClass.lastIndexOf("dx-", 0)
                }).join(" ")
            },
            _updateDOMComponent: function(renderRequired) {
                if (renderRequired) {
                    this._renderComponent()
                } else {
                    if (this._requireRefresh) {
                        this._requireRefresh = false;
                        this._refresh()
                    }
                }
            },
            endUpdate: function() {
                var renderRequired = this._isInitializingRequired();
                this.callBase();
                this._isUpdateAllowed() && this._updateDOMComponent(renderRequired)
            },
            $element: function() {
                return this._$element
            },
            element: function() {
                var $element = this.$element();
                return (0, _element.getPublicElement)($element)
            },
            dispose: function() {
                var element = this.$element().get(0);
                (0, _element_data.cleanDataRecursive)(element, true);
                element.textContent = "";
                this._removeAttributes(element);
                this._removeClasses(element)
            },
            resetOption: function(optionName) {
                this.callBase(optionName);
                if ("width" === optionName || "height" === optionName) {
                    var initialOption = this.initialOption(optionName);
                    !(0, _type.isDefined)(initialOption) && this.$element().css(optionName, "")
                }
            },
            _getAnonymousTemplateName: function() {
                return
            },
            _initTemplateManager: function() {
                if (this._templateManager || !this._useTemplates()) {
                    return
                }
                var _this$option4 = this.option(),
                    _this$option4$integra = _this$option4.integrationOptions,
                    integrationOptions = void 0 === _this$option4$integra ? {} : _this$option4$integra;
                var createTemplate = integrationOptions.createTemplate;
                this._templateManager = new _template_manager.TemplateManager(createTemplate, this._getAnonymousTemplateName());
                this._initTemplates()
            },
            _initTemplates: function() {
                var _this4 = this;
                var _this$_templateManage = this._templateManager.extractTemplates(this.$element()),
                    templates = _this$_templateManage.templates,
                    anonymousTemplateMeta = _this$_templateManage.anonymousTemplateMeta;
                var anonymousTemplate = this.option("integrationOptions.templates.".concat(anonymousTemplateMeta.name));
                templates.forEach(function(_ref4) {
                    var name = _ref4.name,
                        template = _ref4.template;
                    _this4._options.silent("integrationOptions.templates.".concat(name), template)
                });
                if (anonymousTemplateMeta.name && !anonymousTemplate) {
                    this._options.silent("integrationOptions.templates.".concat(anonymousTemplateMeta.name), anonymousTemplateMeta.template);
                    this._options.silent("_hasAnonymousTemplateContent", true)
                }
            },
            _getTemplateByOption: function(optionName) {
                return this._getTemplate(this.option(optionName))
            },
            _getTemplate: function(templateSource) {
                var templates = this.option("integrationOptions.templates");
                var isAsyncTemplate = this.option("templatesRenderAsynchronously");
                var skipTemplates = this.option("integrationOptions.skipTemplates");
                return this._templateManager.getTemplate(templateSource, templates, {
                    isAsyncTemplate: isAsyncTemplate,
                    skipTemplates: skipTemplates
                }, this)
            },
            _saveTemplate: function(name, template) {
                this._setOptionWithoutOptionChange("integrationOptions.templates." + name, this._templateManager._createTemplate(template))
            },
            _useTemplates: function() {
                return true
            }
        });
        DOMComponent.getInstance = function(element) {
            return (0, _public_component.getInstanceByElement)((0, _renderer.default)(element), this)
        };
        DOMComponent.defaultOptions = function(rule) {
            this._classCustomRules = this._classCustomRules || [];
            this._classCustomRules.push(rule)
        };
        var _default = DOMComponent;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************!*\
      !*** ./artifacts/transpiled-npm/data/data_source/data_source.js ***!
      \******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.DataSource = void 0;
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _utils = _interopRequireDefault(__webpack_require__( /*! ../utils */ 41));
        var _array_utils = __webpack_require__( /*! ../array_utils */ 93);
        var _custom_store = _interopRequireDefault(__webpack_require__( /*! ../custom_store */ 130));
        var _events_strategy = __webpack_require__( /*! ../../core/events_strategy */ 100);
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../errors */ 38));
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _queue = __webpack_require__( /*! ../../core/utils/queue */ 252);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _operation_manager = _interopRequireDefault(__webpack_require__( /*! ./operation_manager */ 549));
        var _utils2 = __webpack_require__( /*! ./utils */ 69);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }
        var DataSource = _class.default.inherit({
            ctor: function(options) {
                var _options$reshapeOnPus, _this = this;
                options = (0, _utils2.normalizeDataSourceOptions)(options);
                this._eventsStrategy = new _events_strategy.EventsStrategy(this, {
                    syncStrategy: true
                });
                this._store = options.store;
                this._changedTime = 0;
                var needThrottling = 0 !== options.pushAggregationTimeout;
                if (needThrottling) {
                    var throttlingTimeout = void 0 === options.pushAggregationTimeout ? function() {
                        return 5 * _this._changedTime
                    } : options.pushAggregationTimeout;
                    var pushDeferred;
                    var lastPushWaiters;
                    var throttlingPushHandler = _utils.default.throttleChanges(function(changes) {
                        pushDeferred.resolve();
                        var storePushPending = _deferred.when.apply(void 0, _toConsumableArray(lastPushWaiters));
                        storePushPending.done(function() {
                            return _this._onPush(changes)
                        });
                        lastPushWaiters = void 0;
                        pushDeferred = void 0
                    }, throttlingTimeout);
                    this._onPushHandler = function(args) {
                        _this._aggregationTimeoutId = throttlingPushHandler(args.changes);
                        if (!pushDeferred) {
                            pushDeferred = new _deferred.Deferred
                        }
                        lastPushWaiters = args.waitFor;
                        args.waitFor.push(pushDeferred.promise())
                    };
                    this._store.on("beforePush", this._onPushHandler)
                } else {
                    this._onPushHandler = function(changes) {
                        return _this._onPush(changes)
                    };
                    this._store.on("push", this._onPushHandler)
                }
                this._storeLoadOptions = this._extractLoadOptions(options);
                this._mapFunc = options.map;
                this._postProcessFunc = options.postProcess;
                this._pageIndex = void 0 !== options.pageIndex ? options.pageIndex : 0;
                this._pageSize = void 0 !== options.pageSize ? options.pageSize : 20;
                this._loadingCount = 0;
                this._loadQueue = this._createLoadQueue();
                this._searchValue = "searchValue" in options ? options.searchValue : null;
                this._searchOperation = options.searchOperation || "contains";
                this._searchExpr = options.searchExpr;
                this._paginate = options.paginate;
                this._reshapeOnPush = null !== (_options$reshapeOnPus = options.reshapeOnPush) && void 0 !== _options$reshapeOnPus ? _options$reshapeOnPus : false;
                (0, _iterator.each)(["onChanged", "onLoadError", "onLoadingChanged", "onCustomizeLoadResult", "onCustomizeStoreLoadOptions"], function(_, optionName) {
                    if (optionName in options) {
                        _this.on(optionName.substr(2, 1).toLowerCase() + optionName.substr(3), options[optionName])
                    }
                });
                this._operationManager = new _operation_manager.default;
                this._init()
            },
            _init: function() {
                this._items = [];
                this._userData = {};
                this._totalCount = -1;
                this._isLoaded = false;
                if (!(0, _type.isDefined)(this._paginate)) {
                    this._paginate = !this.group()
                }
                this._isLastPage = !this._paginate
            },
            dispose: function() {
                var _this$_delayedLoadTas;
                this._store.off("beforePush", this._onPushHandler);
                this._store.off("push", this._onPushHandler);
                this._eventsStrategy.dispose();
                clearTimeout(this._aggregationTimeoutId);
                delete this._store;
                null === (_this$_delayedLoadTas = this._delayedLoadTask) || void 0 === _this$_delayedLoadTas ? void 0 : _this$_delayedLoadTas.abort();
                this._operationManager.cancelAll();
                this._disposed = true
            },
            _extractLoadOptions: function(options) {
                var result = {};
                var names = ["sort", "filter", "select", "group", "requireTotalCount"];
                var customNames = this._store._customLoadOptions();
                if (customNames) {
                    names = names.concat(customNames)
                }(0, _iterator.each)(names, function() {
                    result[this] = options[this]
                });
                return result
            },
            loadOptions: function() {
                return this._storeLoadOptions
            },
            items: function() {
                return this._items
            },
            pageIndex: function(newIndex) {
                if (!(0, _type.isNumeric)(newIndex)) {
                    return this._pageIndex
                }
                this._pageIndex = newIndex;
                this._isLastPage = !this._paginate
            },
            paginate: function(value) {
                if (!(0, _type.isBoolean)(value)) {
                    return this._paginate
                }
                if (this._paginate !== value) {
                    this._paginate = value;
                    this.pageIndex(0)
                }
            },
            pageSize: function(value) {
                if (!(0, _type.isNumeric)(value)) {
                    return this._pageSize
                }
                this._pageSize = value
            },
            isLastPage: function() {
                return this._isLastPage
            },
            generateStoreLoadOptionAccessor: function(optionName) {
                var _this2 = this;
                return function(args) {
                    var normalizedArgs = (0, _utils2.normalizeStoreLoadOptionAccessorArguments)(args);
                    if (void 0 === normalizedArgs) {
                        return _this2._storeLoadOptions[optionName]
                    }
                    _this2._storeLoadOptions[optionName] = normalizedArgs
                }
            },
            sort: function() {
                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key]
                }
                return this.generateStoreLoadOptionAccessor("sort")(args)
            },
            filter: function() {
                var newFilter = (0, _utils2.normalizeStoreLoadOptionAccessorArguments)(arguments);
                if (void 0 === newFilter) {
                    return this._storeLoadOptions.filter
                }
                this._storeLoadOptions.filter = newFilter;
                this.pageIndex(0)
            },
            group: function() {
                for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    args[_key2] = arguments[_key2]
                }
                return this.generateStoreLoadOptionAccessor("group")(args)
            },
            select: function() {
                for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                    args[_key3] = arguments[_key3]
                }
                return this.generateStoreLoadOptionAccessor("select")(args)
            },
            requireTotalCount: function(value) {
                if (!(0, _type.isBoolean)(value)) {
                    return this._storeLoadOptions.requireTotalCount
                }
                this._storeLoadOptions.requireTotalCount = value
            },
            searchValue: function(value) {
                if (arguments.length < 1) {
                    return this._searchValue
                }
                this._searchValue = value;
                this.pageIndex(0)
            },
            searchOperation: function(op) {
                if (!(0, _type.isString)(op)) {
                    return this._searchOperation
                }
                this._searchOperation = op;
                this.pageIndex(0)
            },
            searchExpr: function(expr) {
                var argc = arguments.length;
                if (0 === argc) {
                    return this._searchExpr
                }
                if (argc > 1) {
                    expr = [].slice.call(arguments)
                }
                this._searchExpr = expr;
                this.pageIndex(0)
            },
            store: function() {
                return this._store
            },
            key: function() {
                var _this$_store;
                return null === (_this$_store = this._store) || void 0 === _this$_store ? void 0 : _this$_store.key()
            },
            totalCount: function() {
                return this._totalCount
            },
            isLoaded: function() {
                return this._isLoaded
            },
            isLoading: function() {
                return this._loadingCount > 0
            },
            beginLoading: function() {
                this._changeLoadingCount(1)
            },
            endLoading: function() {
                this._changeLoadingCount(-1)
            },
            _createLoadQueue: function() {
                return (0, _queue.create)()
            },
            _changeLoadingCount: function(increment) {
                var oldLoading = this.isLoading();
                this._loadingCount += increment;
                var newLoading = this.isLoading();
                if (oldLoading ^ newLoading) {
                    this._eventsStrategy.fireEvent("loadingChanged", [newLoading])
                }
            },
            _scheduleLoadCallbacks: function(deferred) {
                var _this3 = this;
                this.beginLoading();
                deferred.always(function() {
                    _this3.endLoading()
                })
            },
            _scheduleFailCallbacks: function(deferred) {
                var _this4 = this;
                deferred.fail(function() {
                    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                        args[_key4] = arguments[_key4]
                    }
                    if (args[0] === _utils2.CANCELED_TOKEN) {
                        return
                    }
                    _this4._eventsStrategy.fireEvent("loadError", args)
                })
            },
            _fireChanged: function(args) {
                var date = new Date;
                this._eventsStrategy.fireEvent("changed", args);
                this._changedTime = new Date - date
            },
            _scheduleChangedCallbacks: function(deferred) {
                var _this5 = this;
                deferred.done(function() {
                    return _this5._fireChanged()
                })
            },
            loadSingle: function(propName, propValue) {
                var _this6 = this;
                var d = new _deferred.Deferred;
                var key = this.key();
                var store = this._store;
                var options = this._createStoreLoadOptions();
                var handleDone = function(data) {
                    if (!(0, _type.isDefined)(data) || (0, _array.isEmpty)(data)) {
                        d.reject(new _errors.default.errors.Error("E4009"))
                    } else {
                        if (!Array.isArray(data)) {
                            data = [data]
                        }
                        d.resolve(_this6._applyMapFunction(data)[0])
                    }
                };
                this._scheduleFailCallbacks(d);
                if (arguments.length < 2) {
                    propValue = propName;
                    propName = key
                }
                delete options.skip;
                delete options.group;
                delete options.refresh;
                delete options.pageIndex;
                delete options.searchString;
                var shouldForceByKey = function() {
                    return store instanceof _custom_store.default && !store._byKeyViaLoad()
                };
                (function() {
                    if (propName === key || shouldForceByKey()) {
                        return store.byKey(propValue, options)
                    }
                    options.take = 1;
                    options.filter = options.filter ? [options.filter, [propName, propValue]] : [propName, propValue];
                    return store.load(options)
                })().fail(d.reject).done(handleDone);
                return d.promise()
            },
            load: function() {
                var _this7 = this;
                var d = new _deferred.Deferred;
                var loadTask = function() {
                    if (_this7._disposed) {
                        return
                    }
                    if (!(0, _utils2.isPending)(d)) {
                        return
                    }
                    return _this7._loadFromStore(loadOperation, d)
                };
                this._scheduleLoadCallbacks(d);
                this._scheduleFailCallbacks(d);
                this._scheduleChangedCallbacks(d);
                var loadOperation = this._createLoadOperation(d);
                this._eventsStrategy.fireEvent("customizeStoreLoadOptions", [loadOperation]);
                this._loadQueue.add(function() {
                    if ("number" === typeof loadOperation.delay) {
                        _this7._delayedLoadTask = (0, _common.executeAsync)(loadTask, loadOperation.delay)
                    } else {
                        loadTask()
                    }
                    return d.promise()
                });
                return d.promise({
                    operationId: loadOperation.operationId
                })
            },
            _onPush: function(changes) {
                var _this8 = this;
                if (this._reshapeOnPush) {
                    this.load()
                } else {
                    this._eventsStrategy.fireEvent("changing", [{
                        changes: changes
                    }]);
                    var group = this.group();
                    var items = this.items();
                    var groupLevel = 0;
                    var dataSourceChanges = this.paginate() || group ? changes.filter(function(item) {
                        return "update" === item.type
                    }) : changes;
                    if (group) {
                        groupLevel = Array.isArray(group) ? group.length : 1
                    }
                    if (this._mapFunc) {
                        dataSourceChanges.forEach(function(item) {
                            if ("insert" === item.type) {
                                item.data = _this8._mapFunc(item.data)
                            }
                        })
                    }(0, _array_utils.applyBatch)({
                        keyInfo: this.store(),
                        data: items,
                        changes: dataSourceChanges,
                        groupCount: groupLevel,
                        useInsertIndex: true
                    });
                    this._fireChanged([{
                        changes: changes
                    }])
                }
            },
            _createLoadOperation: function(deferred) {
                var _this9 = this;
                var operationId = this._operationManager.add(deferred);
                var storeLoadOptions = this._createStoreLoadOptions();
                deferred.always(function() {
                    return _this9._operationManager.remove(operationId)
                });
                return {
                    operationId: operationId,
                    storeLoadOptions: storeLoadOptions
                }
            },
            reload: function() {
                var store = this.store();
                if (store instanceof _custom_store.default) {
                    store.clearRawDataCache()
                }
                this._init();
                return this.load()
            },
            cancel: function(operationId) {
                return this._operationManager.cancel(operationId)
            },
            cancelAll: function() {
                return this._operationManager.cancelAll()
            },
            _addSearchOptions: function(storeLoadOptions) {
                if (this._disposed) {
                    return
                }
                if (this.store()._useDefaultSearch) {
                    this._addSearchFilter(storeLoadOptions)
                } else {
                    storeLoadOptions.searchOperation = this._searchOperation;
                    storeLoadOptions.searchValue = this._searchValue;
                    storeLoadOptions.searchExpr = this._searchExpr
                }
            },
            _createStoreLoadOptions: function() {
                var result = (0, _extend.extend)({}, this._storeLoadOptions);
                this._addSearchOptions(result);
                if (this._paginate) {
                    if (this._pageSize) {
                        result.skip = this._pageIndex * this._pageSize;
                        result.take = this._pageSize
                    }
                }
                result.userData = this._userData;
                return result
            },
            _addSearchFilter: function(storeLoadOptions) {
                var value = this._searchValue;
                var op = this._searchOperation;
                var selector = this._searchExpr;
                var searchFilter = [];
                if (!value) {
                    return
                }
                if (!selector) {
                    selector = "this"
                }
                if (!Array.isArray(selector)) {
                    selector = [selector]
                }(0, _iterator.each)(selector, function(i, item) {
                    if (searchFilter.length) {
                        searchFilter.push("or")
                    }
                    searchFilter.push([item, op, value])
                });
                if (storeLoadOptions.filter) {
                    storeLoadOptions.filter = [searchFilter, storeLoadOptions.filter]
                } else {
                    storeLoadOptions.filter = searchFilter
                }
            },
            _loadFromStore: function(loadOptions, pendingDeferred) {
                var _this10 = this;
                var handleSuccess = function(data, extra) {
                    if (_this10._disposed) {
                        return
                    }
                    if (!(0, _utils2.isPending)(pendingDeferred)) {
                        return
                    }
                    var loadResult = (0, _extend.extend)((0, _utils2.normalizeLoadResult)(data, extra), loadOptions);
                    _this10._eventsStrategy.fireEvent("customizeLoadResult", [loadResult]);
                    (0, _deferred.when)(loadResult.data).done(function(data) {
                        loadResult.data = data;
                        _this10._processStoreLoadResult(loadResult, pendingDeferred)
                    }).fail(pendingDeferred.reject)
                };
                if (loadOptions.data) {
                    return (new _deferred.Deferred).resolve(loadOptions.data).done(handleSuccess)
                }
                return this.store().load(loadOptions.storeLoadOptions).done(handleSuccess).fail(pendingDeferred.reject)
            },
            _processStoreLoadResult: function(loadResult, pendingDeferred) {
                var _this11 = this;
                var data = loadResult.data;
                var extra = loadResult.extra;
                var storeLoadOptions = loadResult.storeLoadOptions;
                var resolvePendingDeferred = function() {
                    _this11._isLoaded = true;
                    _this11._totalCount = isFinite(extra.totalCount) ? extra.totalCount : -1;
                    return pendingDeferred.resolve(data, extra)
                };
                var proceedLoadingTotalCount = function() {
                    _this11.store().totalCount(storeLoadOptions).done(function(count) {
                        extra.totalCount = count;
                        resolvePendingDeferred()
                    }).fail(pendingDeferred.reject)
                };
                if (this._disposed) {
                    return
                }
                data = this._applyPostProcessFunction(this._applyMapFunction(data));
                if (!(0, _type.isPlainObject)(extra)) {
                    extra = {}
                }
                this._items = data;
                if (!data.length || !this._paginate || this._pageSize && data.length < this._pageSize) {
                    this._isLastPage = true
                }
                if (storeLoadOptions.requireTotalCount && !isFinite(extra.totalCount)) {
                    proceedLoadingTotalCount()
                } else {
                    resolvePendingDeferred()
                }
            },
            _applyMapFunction: function(data) {
                if (this._mapFunc) {
                    return (0, _utils2.mapDataRespectingGrouping)(data, this._mapFunc, this.group())
                }
                return data
            },
            _applyPostProcessFunction: function(data) {
                if (this._postProcessFunc) {
                    return this._postProcessFunc(data)
                }
                return data
            },
            on: function(eventName, eventHandler) {
                this._eventsStrategy.on(eventName, eventHandler);
                return this
            },
            off: function(eventName, eventHandler) {
                this._eventsStrategy.off(eventName, eventHandler);
                return this
            }
        });
        exports.DataSource = DataSource
    },
    /*!************************************************************!*\
      !*** ./artifacts/transpiled-npm/data/data_source/utils.js ***!
      \************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.normalizeDataSourceOptions = exports.normalizeLoadResult = exports.mapDataRespectingGrouping = exports.normalizeStoreLoadOptionAccessorArguments = exports.isPending = exports.CANCELED_TOKEN = void 0;
        var _ajax = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/ajax */ 79));
        var _abstract_store = _interopRequireDefault(__webpack_require__( /*! ../abstract_store */ 105));
        var _array_store = _interopRequireDefault(__webpack_require__( /*! ../array_store */ 77));
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _custom_store = _interopRequireDefault(__webpack_require__( /*! ../custom_store */ 130));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _utils = _interopRequireDefault(__webpack_require__( /*! ../utils */ 41));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function _objectWithoutProperties(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = _objectWithoutPropertiesLoose(source, excluded);
            var key, i;
            if (Object.getOwnPropertySymbols) {
                var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
                for (i = 0; i < sourceSymbolKeys.length; i++) {
                    key = sourceSymbolKeys[i];
                    if (excluded.indexOf(key) >= 0) {
                        continue
                    }
                    if (!Object.prototype.propertyIsEnumerable.call(source, key)) {
                        continue
                    }
                    target[key] = source[key]
                }
            }
            return target
        }

        function _objectWithoutPropertiesLoose(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = {};
            var sourceKeys = Object.keys(source);
            var key, i;
            for (i = 0; i < sourceKeys.length; i++) {
                key = sourceKeys[i];
                if (excluded.indexOf(key) >= 0) {
                    continue
                }
                target[key] = source[key]
            }
            return target
        }
        var CANCELED_TOKEN = "canceled";
        exports.CANCELED_TOKEN = CANCELED_TOKEN;
        var isPending = function(deferred) {
            return "pending" === deferred.state()
        };
        exports.isPending = isPending;
        var normalizeStoreLoadOptionAccessorArguments = function(originalArguments) {
            switch (originalArguments.length) {
                case 0:
                    return;
                case 1:
                    return originalArguments[0]
            }
            return [].slice.call(originalArguments)
        };
        exports.normalizeStoreLoadOptionAccessorArguments = normalizeStoreLoadOptionAccessorArguments;
        var mapGroup = function(group, level, mapper) {
            return (0, _iterator.map)(group, function(item) {
                var restItem = (item.items, _objectWithoutProperties(item, ["items"]));
                return _objectSpread(_objectSpread({}, restItem), {}, {
                    items: mapRecursive(item.items, level - 1, mapper)
                })
            })
        };
        var mapRecursive = function(items, level, mapper) {
            if (!Array.isArray(items)) {
                return items
            }
            return level ? mapGroup(items, level, mapper) : (0, _iterator.map)(items, mapper)
        };
        var mapDataRespectingGrouping = function(items, mapper, groupInfo) {
            var level = groupInfo ? _utils.default.normalizeSortingInfo(groupInfo).length : 0;
            return mapRecursive(items, level, mapper)
        };
        exports.mapDataRespectingGrouping = mapDataRespectingGrouping;
        var normalizeLoadResult = function(data, extra) {
            var _data;
            if (null !== (_data = data) && void 0 !== _data && _data.data) {
                extra = data;
                data = data.data
            }
            if (!Array.isArray(data)) {
                data = [data]
            }
            return {
                data: data,
                extra: extra
            }
        };
        exports.normalizeLoadResult = normalizeLoadResult;
        var createCustomStoreFromLoadFunc = function(options) {
            var storeConfig = {};
            (0, _iterator.each)(["useDefaultSearch", "key", "load", "loadMode", "cacheRawData", "byKey", "lookup", "totalCount", "insert", "update", "remove"], function() {
                storeConfig[this] = options[this];
                delete options[this]
            });
            return new _custom_store.default(storeConfig)
        };
        var createStoreFromConfig = function(storeConfig) {
            var alias = storeConfig.type;
            delete storeConfig.type;
            return _abstract_store.default.create(alias, storeConfig)
        };
        var createCustomStoreFromUrl = function(url, normalizationOptions) {
            return new _custom_store.default({
                load: function() {
                    return _ajax.default.sendRequest({
                        url: url,
                        dataType: "json"
                    })
                },
                loadMode: null === normalizationOptions || void 0 === normalizationOptions ? void 0 : normalizationOptions.fromUrlLoadMode
            })
        };
        var normalizeDataSourceOptions = function(options, normalizationOptions) {
            var store;
            if ("string" === typeof options) {
                options = {
                    paginate: false,
                    store: createCustomStoreFromUrl(options, normalizationOptions)
                }
            }
            if (void 0 === options) {
                options = []
            }
            if (Array.isArray(options) || options instanceof _abstract_store.default) {
                options = {
                    store: options
                }
            } else {
                options = (0, _extend.extend)({}, options)
            }
            if (void 0 === options.store) {
                options.store = []
            }
            store = options.store;
            if ("load" in options) {
                store = createCustomStoreFromLoadFunc(options)
            } else {
                if (Array.isArray(store)) {
                    store = new _array_store.default(store)
                } else {
                    if ((0, _type.isPlainObject)(store)) {
                        store = createStoreFromConfig((0, _extend.extend)({}, store))
                    }
                }
            }
            options.store = store;
            return options
        };
        exports.normalizeDataSourceOptions = normalizeDataSourceOptions
    },
    /*!*********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/widget/selectors.js ***!
      \*********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.focused = exports.tabbable = exports.focusable = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var focusableFn = function(element, tabIndex) {
            if (!visible(element)) {
                return false
            }
            var nodeName = element.nodeName.toLowerCase();
            var isTabIndexNotNaN = !isNaN(tabIndex);
            var isDisabled = element.disabled;
            var isDefaultFocus = /^(input|select|textarea|button|object|iframe)$/.test(nodeName);
            var isHyperlink = "a" === nodeName;
            var isFocusable = true;
            var isContentEditable = element.isContentEditable;
            if (isDefaultFocus || isContentEditable) {
                isFocusable = !isDisabled
            } else {
                if (isHyperlink) {
                    isFocusable = element.href || isTabIndexNotNaN
                } else {
                    isFocusable = isTabIndexNotNaN
                }
            }
            return isFocusable
        };

        function visible(element) {
            var $element = (0, _renderer.default)(element);
            return $element.is(":visible") && "hidden" !== $element.css("visibility") && "hidden" !== $element.parents().css("visibility")
        }
        var focusable = function(index, element) {
            return focusableFn(element, (0, _renderer.default)(element).attr("tabIndex"))
        };
        exports.focusable = focusable;
        var tabbable = function(index, element) {
            var tabIndex = (0, _renderer.default)(element).attr("tabIndex");
            return (isNaN(tabIndex) || tabIndex >= 0) && focusableFn(element, tabIndex)
        };
        exports.tabbable = tabbable;
        var focused = function($element) {
            var element = (0, _renderer.default)($element).get(0);
            return _dom_adapter.default.getActiveElement() === element
        };
        exports.focused = focused
    },
    /*!***************************************************!*\
      !*** ./artifacts/transpiled-npm/format_helper.js ***!
      \***************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _type = __webpack_require__( /*! ./core/utils/type */ 1);
        var _date = _interopRequireDefault(__webpack_require__( /*! ./core/utils/date */ 19));
        var _number = _interopRequireDefault(__webpack_require__( /*! ./localization/number */ 47));
        var _date2 = _interopRequireDefault(__webpack_require__( /*! ./localization/date */ 32));
        var _dependency_injector = _interopRequireDefault(__webpack_require__( /*! ./core/utils/dependency_injector */ 58));
        __webpack_require__( /*! ./localization/currency */ 114);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = (0, _dependency_injector.default)({
            format: function(value, _format) {
                var formatIsValid = (0, _type.isString)(_format) && "" !== _format || (0, _type.isPlainObject)(_format) || (0, _type.isFunction)(_format);
                var valueIsValid = (0, _type.isNumeric)(value) || (0, _type.isDate)(value);
                if (!formatIsValid || !valueIsValid) {
                    return (0, _type.isDefined)(value) ? value.toString() : ""
                }
                if ((0, _type.isFunction)(_format)) {
                    return _format(value)
                }
                if ((0, _type.isString)(_format)) {
                    _format = {
                        type: _format
                    }
                }
                if ((0, _type.isNumeric)(value)) {
                    return _number.default.format(value, _format)
                }
                if ((0, _type.isDate)(value)) {
                    return _date2.default.format(value, _format)
                }
            },
            getTimeFormat: function(showSecond) {
                return showSecond ? "longtime" : "shorttime"
            },
            _normalizeFormat: function(format) {
                if (!Array.isArray(format)) {
                    return format
                }
                if (1 === format.length) {
                    return format[0]
                }
                return function(date) {
                    return format.map(function(formatPart) {
                        return _date2.default.format(date, formatPart)
                    }).join(" ")
                }
            },
            getDateFormatByDifferences: function(dateDifferences, intervalFormat) {
                var resultFormat = [];
                var needSpecialSecondFormatter = intervalFormat && dateDifferences.millisecond && !(dateDifferences.year || dateDifferences.month || dateDifferences.day);
                if (needSpecialSecondFormatter) {
                    var secondFormatter = function(date) {
                        return date.getSeconds() + date.getMilliseconds() / 1e3 + "s"
                    };
                    resultFormat.push(secondFormatter)
                } else {
                    if (dateDifferences.millisecond) {
                        resultFormat.push("millisecond")
                    }
                }
                if (dateDifferences.hour || dateDifferences.minute || !needSpecialSecondFormatter && dateDifferences.second) {
                    resultFormat.unshift(this.getTimeFormat(dateDifferences.second))
                }
                if (dateDifferences.year && dateDifferences.month && dateDifferences.day) {
                    if (intervalFormat && "month" === intervalFormat) {
                        return "monthandyear"
                    } else {
                        resultFormat.unshift("shortdate");
                        return this._normalizeFormat(resultFormat)
                    }
                }
                if (dateDifferences.year && dateDifferences.month) {
                    return "monthandyear"
                }
                if (dateDifferences.year && dateDifferences.quarter) {
                    return "quarterandyear"
                }
                if (dateDifferences.year) {
                    return "year"
                }
                if (dateDifferences.quarter) {
                    return "quarter"
                }
                if (dateDifferences.month && dateDifferences.day) {
                    if (intervalFormat) {
                        var monthDayFormatter = function(date) {
                            return _date2.default.getMonthNames("abbreviated")[date.getMonth()] + " " + _date2.default.format(date, "day")
                        };
                        resultFormat.unshift(monthDayFormatter)
                    } else {
                        resultFormat.unshift("monthandday")
                    }
                    return this._normalizeFormat(resultFormat)
                }
                if (dateDifferences.month) {
                    return "month"
                }
                if (dateDifferences.day) {
                    if (intervalFormat) {
                        resultFormat.unshift("day")
                    } else {
                        var dayFormatter = function(date) {
                            return _date2.default.format(date, "dayofweek") + ", " + _date2.default.format(date, "day")
                        };
                        resultFormat.unshift(dayFormatter)
                    }
                    return this._normalizeFormat(resultFormat)
                }
                return this._normalizeFormat(resultFormat)
            },
            getDateFormatByTicks: function(ticks) {
                var maxDiff;
                var currentDiff;
                var i;
                if (ticks.length > 1) {
                    maxDiff = _date.default.getDatesDifferences(ticks[0], ticks[1]);
                    for (i = 1; i < ticks.length - 1; i++) {
                        currentDiff = _date.default.getDatesDifferences(ticks[i], ticks[i + 1]);
                        if (maxDiff.count < currentDiff.count) {
                            maxDiff = currentDiff
                        }
                    }
                } else {
                    maxDiff = {
                        year: true,
                        month: true,
                        day: true,
                        hour: ticks[0].getHours() > 0,
                        minute: ticks[0].getMinutes() > 0,
                        second: ticks[0].getSeconds() > 0,
                        millisecond: ticks[0].getMilliseconds() > 0
                    }
                }
                var resultFormat = this.getDateFormatByDifferences(maxDiff);
                return resultFormat
            },
            getDateFormatByTickInterval: function(startValue, endValue, tickInterval) {
                var dateUnitInterval;
                var dateDifferencesConverter = {
                    week: "day"
                };
                var correctDateDifferences = function(dateDifferences, tickInterval, value) {
                    switch (tickInterval) {
                        case "year":
                        case "quarter":
                            dateDifferences.month = value;
                        case "month":
                            dateDifferences.day = value;
                        case "week":
                        case "day":
                            dateDifferences.hour = value;
                        case "hour":
                            dateDifferences.minute = value;
                        case "minute":
                            dateDifferences.second = value;
                        case "second":
                            dateDifferences.millisecond = value
                    }
                };
                var correctDifferencesByMaxDate = function(differences, minDate, maxDate) {
                    if (!maxDate.getMilliseconds() && maxDate.getSeconds()) {
                        if (maxDate.getSeconds() - minDate.getSeconds() === 1) {
                            differences.millisecond = true;
                            differences.second = false
                        }
                    } else {
                        if (!maxDate.getSeconds() && maxDate.getMinutes()) {
                            if (maxDate.getMinutes() - minDate.getMinutes() === 1) {
                                differences.second = true;
                                differences.minute = false
                            }
                        } else {
                            if (!maxDate.getMinutes() && maxDate.getHours()) {
                                if (maxDate.getHours() - minDate.getHours() === 1) {
                                    differences.minute = true;
                                    differences.hour = false
                                }
                            } else {
                                if (!maxDate.getHours() && maxDate.getDate() > 1) {
                                    if (maxDate.getDate() - minDate.getDate() === 1) {
                                        differences.hour = true;
                                        differences.day = false
                                    }
                                } else {
                                    if (1 === maxDate.getDate() && maxDate.getMonth()) {
                                        if (maxDate.getMonth() - minDate.getMonth() === 1) {
                                            differences.day = true;
                                            differences.month = false
                                        }
                                    } else {
                                        if (!maxDate.getMonth() && maxDate.getFullYear()) {
                                            if (maxDate.getFullYear() - minDate.getFullYear() === 1) {
                                                differences.month = true;
                                                differences.year = false
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                };
                tickInterval = (0, _type.isString)(tickInterval) ? tickInterval.toLowerCase() : tickInterval;
                var dateDifferences = _date.default.getDatesDifferences(startValue, endValue);
                if (startValue !== endValue) {
                    correctDifferencesByMaxDate(dateDifferences, startValue > endValue ? endValue : startValue, startValue > endValue ? startValue : endValue)
                }
                dateUnitInterval = _date.default.getDateUnitInterval(dateDifferences);
                correctDateDifferences(dateDifferences, dateUnitInterval, true);
                dateUnitInterval = _date.default.getDateUnitInterval(tickInterval || "second");
                correctDateDifferences(dateDifferences, dateUnitInterval, false);
                dateDifferences[dateDifferencesConverter[dateUnitInterval] || dateUnitInterval] = true;
                var resultFormat = this.getDateFormatByDifferences(dateDifferences);
                return resultFormat
            }
        });
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/version.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.compare = compare;

        function compare(x, y, maxLevel) {
            function normalizeArg(value) {
                if ("string" === typeof value) {
                    return value.split(".")
                }
                if ("number" === typeof value) {
                    return [value]
                }
                return value
            }
            x = normalizeArg(x);
            y = normalizeArg(y);
            var length = Math.max(x.length, y.length);
            if (isFinite(maxLevel)) {
                length = Math.min(length, maxLevel)
            }
            for (var i = 0; i < length; i++) {
                var xItem = parseInt(x[i] || 0, 10);
                var yItem = parseInt(y[i] || 0, 10);
                if (xItem < yItem) {
                    return -1
                }
                if (xItem > yItem) {
                    return 1
                }
            }
            return 0
        }
    },
    /*!************************************************************!*\
      !*** ./artifacts/transpiled-npm/core/polyfills/promise.js ***!
      \************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var promise = (0, _window.hasWindow)() ? (0, _window.getWindow)().Promise : Promise;
        if (!promise) {
            promise = function(resolver) {
                var d = new _deferred.Deferred;
                resolver(d.resolve.bind(this), d.reject.bind(this));
                return d.promise()
            };
            promise.resolve = function(val) {
                return (new _deferred.Deferred).resolve(val).promise()
            };
            promise.reject = function(val) {
                return (new _deferred.Deferred).reject(val).promise()
            };
            promise.all = function(promises) {
                return _deferred.when.apply(this, promises).then(function() {
                    return [].slice.call(arguments)
                })
            }
        }
        var _default = promise;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/events/core/event_registrator.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _event_registrator_callbacks = _interopRequireDefault(__webpack_require__( /*! ./event_registrator_callbacks */ 131));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var registerEvent = function(name, eventObject) {
            var strategy = {};
            if ("noBubble" in eventObject) {
                strategy.noBubble = eventObject.noBubble
            }
            if ("bindType" in eventObject) {
                strategy.bindType = eventObject.bindType
            }
            if ("delegateType" in eventObject) {
                strategy.delegateType = eventObject.delegateType
            }(0, _iterator.each)(["setup", "teardown", "add", "remove", "trigger", "handle", "_default", "dispose"], function(_, methodName) {
                if (!eventObject[methodName]) {
                    return
                }
                strategy[methodName] = function() {
                    var args = [].slice.call(arguments);
                    args.unshift(this);
                    return eventObject[methodName].apply(eventObject, args)
                }
            });
            _event_registrator_callbacks.default.fire(name, strategy)
        };
        registerEvent.callbacks = _event_registrator_callbacks.default;
        var _default = registerEvent;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************!*\
      !*** ./artifacts/transpiled-npm/core/templates/template_base.js ***!
      \******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.TemplateBase = exports.renderedCallbacks = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../renderer */ 2));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../dom_adapter */ 11));
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ../utils/callbacks */ 27));
        var _dom = __webpack_require__( /*! ../utils/dom */ 33);
        var _visibility_change = __webpack_require__( /*! ../../events/visibility_change */ 59);
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../errors */ 25));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var renderedCallbacks = (0, _callbacks.default)({
            syncStrategy: true
        });
        exports.renderedCallbacks = renderedCallbacks;
        var TemplateBase = function() {
            function TemplateBase() {}
            var _proto = TemplateBase.prototype;
            _proto.render = function(options) {
                options = options || {};
                var onRendered = options.onRendered;
                delete options.onRendered;
                var $result = this._renderCore(options);
                this._ensureResultInContainer($result, options.container);
                renderedCallbacks.fire($result, options.container);
                onRendered && onRendered();
                return $result
            };
            _proto._ensureResultInContainer = function($result, container) {
                if (!container) {
                    return
                }
                var $container = (0, _renderer.default)(container);
                var resultInContainer = (0, _dom.contains)($container.get(0), $result.get(0));
                $container.append($result);
                if (resultInContainer) {
                    return
                }
                var resultInBody = _dom_adapter.default.getBody().contains($container.get(0));
                if (!resultInBody) {
                    return
                }(0, _visibility_change.triggerShownEvent)($result)
            };
            _proto._renderCore = function() {
                throw _errors.default.Error("E0001")
            };
            return TemplateBase
        }();
        exports.TemplateBase = TemplateBase
    },
    /*!*************************************************!*\
      !*** ./artifacts/transpiled-npm/events/drag.js ***!
      \*************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.drop = exports.leave = exports.enter = exports.end = exports.start = exports.move = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _element_data = __webpack_require__( /*! ../core/element_data */ 40);
        var _array = __webpack_require__( /*! ../core/utils/array */ 12);
        var iteratorUtils = _interopRequireWildcard(__webpack_require__( /*! ../core/utils/iterator */ 3));
        var _dom = __webpack_require__( /*! ../core/utils/dom */ 33);
        var _event_registrator = _interopRequireDefault(__webpack_require__( /*! ./core/event_registrator */ 74));
        var _index = __webpack_require__( /*! ./utils/index */ 8);
        var _emitter = _interopRequireDefault(__webpack_require__( /*! ./gesture/emitter.gesture */ 176));
        var _emitter_registrator = _interopRequireDefault(__webpack_require__( /*! ./core/emitter_registrator */ 103));

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DRAG_START_EVENT = "dxdragstart";
        exports.start = DRAG_START_EVENT;
        var DRAG_EVENT = "dxdrag";
        exports.move = DRAG_EVENT;
        var DRAG_END_EVENT = "dxdragend";
        exports.end = DRAG_END_EVENT;
        var DRAG_ENTER_EVENT = "dxdragenter";
        exports.enter = DRAG_ENTER_EVENT;
        var DRAG_LEAVE_EVENT = "dxdragleave";
        exports.leave = DRAG_LEAVE_EVENT;
        var DROP_EVENT = "dxdrop";
        exports.drop = DROP_EVENT;
        var DX_DRAG_EVENTS_COUNT_KEY = "dxDragEventsCount";
        var knownDropTargets = [];
        var knownDropTargetSelectors = [];
        var knownDropTargetConfigs = [];
        var dropTargetRegistration = {
            setup: function(element, data) {
                var knownDropTarget = (0, _array.inArray)(element, knownDropTargets) !== -1;
                if (!knownDropTarget) {
                    knownDropTargets.push(element);
                    knownDropTargetSelectors.push([]);
                    knownDropTargetConfigs.push(data || {})
                }
            },
            add: function(element, handleObj) {
                var index = (0, _array.inArray)(element, knownDropTargets);
                this.updateEventsCounter(element, handleObj.type, 1);
                var selector = handleObj.selector;
                if ((0, _array.inArray)(selector, knownDropTargetSelectors[index]) === -1) {
                    knownDropTargetSelectors[index].push(selector)
                }
            },
            updateEventsCounter: function(element, event, value) {
                if ([DRAG_ENTER_EVENT, DRAG_LEAVE_EVENT, DROP_EVENT].indexOf(event) > -1) {
                    var eventsCount = (0, _element_data.data)(element, DX_DRAG_EVENTS_COUNT_KEY) || 0;
                    (0, _element_data.data)(element, DX_DRAG_EVENTS_COUNT_KEY, Math.max(0, eventsCount + value))
                }
            },
            remove: function(element, handleObj) {
                this.updateEventsCounter(element, handleObj.type, -1)
            },
            teardown: function(element) {
                var handlersCount = (0, _element_data.data)(element, DX_DRAG_EVENTS_COUNT_KEY);
                if (!handlersCount) {
                    var index = (0, _array.inArray)(element, knownDropTargets);
                    knownDropTargets.splice(index, 1);
                    knownDropTargetSelectors.splice(index, 1);
                    knownDropTargetConfigs.splice(index, 1);
                    (0, _element_data.removeData)(element, DX_DRAG_EVENTS_COUNT_KEY)
                }
            }
        };
        (0, _event_registrator.default)(DRAG_ENTER_EVENT, dropTargetRegistration);
        (0, _event_registrator.default)(DRAG_LEAVE_EVENT, dropTargetRegistration);
        (0, _event_registrator.default)(DROP_EVENT, dropTargetRegistration);
        var getItemDelegatedTargets = function($element) {
            var dropTargetIndex = (0, _array.inArray)($element.get(0), knownDropTargets);
            var dropTargetSelectors = knownDropTargetSelectors[dropTargetIndex].filter(function(selector) {
                return selector
            });
            var $delegatedTargets = $element.find(dropTargetSelectors.join(", "));
            if ((0, _array.inArray)(void 0, knownDropTargetSelectors[dropTargetIndex]) !== -1) {
                $delegatedTargets = $delegatedTargets.add($element)
            }
            return $delegatedTargets
        };
        var getItemConfig = function($element) {
            var dropTargetIndex = (0, _array.inArray)($element.get(0), knownDropTargets);
            return knownDropTargetConfigs[dropTargetIndex]
        };
        var getItemPosition = function(dropTargetConfig, $element) {
            if (dropTargetConfig.itemPositionFunc) {
                return dropTargetConfig.itemPositionFunc($element)
            } else {
                return $element.offset()
            }
        };
        var getItemSize = function(dropTargetConfig, $element) {
            if (dropTargetConfig.itemSizeFunc) {
                return dropTargetConfig.itemSizeFunc($element)
            }
            return {
                width: $element.get(0).getBoundingClientRect().width,
                height: $element.get(0).getBoundingClientRect().height
            }
        };
        var DragEmitter = _emitter.default.inherit({
            ctor: function(element) {
                this.callBase(element);
                this.direction = "both"
            },
            _init: function(e) {
                this._initEvent = e
            },
            _start: function(e) {
                e = this._fireEvent(DRAG_START_EVENT, this._initEvent);
                this._maxLeftOffset = e.maxLeftOffset;
                this._maxRightOffset = e.maxRightOffset;
                this._maxTopOffset = e.maxTopOffset;
                this._maxBottomOffset = e.maxBottomOffset;
                var dropTargets = (0, _array.wrapToArray)(e.targetElements || (null === e.targetElements ? [] : knownDropTargets));
                this._dropTargets = iteratorUtils.map(dropTargets, function(element) {
                    return (0, _renderer.default)(element).get(0)
                })
            },
            _move: function(e) {
                var eventData = (0, _index.eventData)(e);
                var dragOffset = this._calculateOffset(eventData);
                e = this._fireEvent(DRAG_EVENT, e, {
                    offset: dragOffset
                });
                this._processDropTargets(e);
                if (!e._cancelPreventDefault) {
                    e.preventDefault()
                }
            },
            _calculateOffset: function(eventData) {
                return {
                    x: this._calculateXOffset(eventData),
                    y: this._calculateYOffset(eventData)
                }
            },
            _calculateXOffset: function(eventData) {
                if ("vertical" !== this.direction) {
                    var offset = eventData.x - this._startEventData.x;
                    return this._fitOffset(offset, this._maxLeftOffset, this._maxRightOffset)
                }
                return 0
            },
            _calculateYOffset: function(eventData) {
                if ("horizontal" !== this.direction) {
                    var offset = eventData.y - this._startEventData.y;
                    return this._fitOffset(offset, this._maxTopOffset, this._maxBottomOffset)
                }
                return 0
            },
            _fitOffset: function(offset, minOffset, maxOffset) {
                if (null != minOffset) {
                    offset = Math.max(offset, -minOffset)
                }
                if (null != maxOffset) {
                    offset = Math.min(offset, maxOffset)
                }
                return offset
            },
            _processDropTargets: function(e) {
                var target = this._findDropTarget(e);
                var sameTarget = target === this._currentDropTarget;
                if (!sameTarget) {
                    this._fireDropTargetEvent(e, DRAG_LEAVE_EVENT);
                    this._currentDropTarget = target;
                    this._fireDropTargetEvent(e, DRAG_ENTER_EVENT)
                }
            },
            _fireDropTargetEvent: function(event, eventName) {
                if (!this._currentDropTarget) {
                    return
                }
                var eventData = {
                    type: eventName,
                    originalEvent: event,
                    draggingElement: this._$element.get(0),
                    target: this._currentDropTarget
                };
                (0, _index.fireEvent)(eventData)
            },
            _findDropTarget: function(e) {
                var that = this;
                var result;
                iteratorUtils.each(knownDropTargets, function(_, target) {
                    if (!that._checkDropTargetActive(target)) {
                        return
                    }
                    var $target = (0, _renderer.default)(target);
                    iteratorUtils.each(getItemDelegatedTargets($target), function(_, delegatedTarget) {
                        var $delegatedTarget = (0, _renderer.default)(delegatedTarget);
                        if (that._checkDropTarget(getItemConfig($target), $delegatedTarget, (0, _renderer.default)(result), e)) {
                            result = delegatedTarget
                        }
                    })
                });
                return result
            },
            _checkDropTargetActive: function(target) {
                var active = false;
                iteratorUtils.each(this._dropTargets, function(_, activeTarget) {
                    active = active || activeTarget === target || (0, _dom.contains)(activeTarget, target);
                    return !active
                });
                return active
            },
            _checkDropTarget: function(config, $target, $prevTarget, e) {
                var isDraggingElement = $target.get(0) === (0, _renderer.default)(e.target).get(0);
                if (isDraggingElement) {
                    return false
                }
                var targetPosition = getItemPosition(config, $target);
                if (e.pageX < targetPosition.left) {
                    return false
                }
                if (e.pageY < targetPosition.top) {
                    return false
                }
                var targetSize = getItemSize(config, $target);
                if (e.pageX > targetPosition.left + targetSize.width) {
                    return false
                }
                if (e.pageY > targetPosition.top + targetSize.height) {
                    return false
                }
                if ($prevTarget.length && $prevTarget.closest($target).length) {
                    return false
                }
                if (config.checkDropTarget && !config.checkDropTarget($target, e)) {
                    return false
                }
                return $target
            },
            _end: function(e) {
                var eventData = (0, _index.eventData)(e);
                this._fireEvent(DRAG_END_EVENT, e, {
                    offset: this._calculateOffset(eventData)
                });
                this._fireDropTargetEvent(e, DROP_EVENT);
                delete this._currentDropTarget
            }
        });
        (0, _emitter_registrator.default)({
            emitter: DragEmitter,
            events: [DRAG_START_EVENT, DRAG_EVENT, DRAG_END_EVENT]
        })
    },
    /*!******************************************************!*\
      !*** ./artifacts/transpiled-npm/data/array_store.js ***!
      \******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _utils = _interopRequireDefault(__webpack_require__( /*! ./utils */ 41));
        var _query = _interopRequireDefault(__webpack_require__( /*! ./query */ 48));
        var _errors = _interopRequireDefault(__webpack_require__( /*! ./errors */ 38));
        var _abstract_store = _interopRequireDefault(__webpack_require__( /*! ./abstract_store */ 105));
        var _array_utils = __webpack_require__( /*! ./array_utils */ 93);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ArrayStore = _abstract_store.default.inherit({
            ctor: function(options) {
                if (Array.isArray(options)) {
                    options = {
                        data: options
                    }
                } else {
                    options = options || {}
                }
                this.callBase(options);
                var initialArray = options.data;
                if (initialArray && !Array.isArray(initialArray)) {
                    throw _errors.default.errors.Error("E4006")
                }
                this._array = initialArray || []
            },
            createQuery: function() {
                return (0, _query.default)(this._array, {
                    errorHandler: this._errorHandler
                })
            },
            _byKeyImpl: function(key) {
                var index = (0, _array_utils.indexByKey)(this, this._array, key);
                if (index === -1) {
                    return _utils.default.rejectedPromise(_errors.default.errors.Error("E4009"))
                }
                return _utils.default.trivialPromise(this._array[index])
            },
            _insertImpl: function(values) {
                return (0, _array_utils.insert)(this, this._array, values)
            },
            _pushImpl: function(changes) {
                (0, _array_utils.applyBatch)({
                    keyInfo: this,
                    data: this._array,
                    changes: changes
                })
            },
            _updateImpl: function(key, values) {
                return (0, _array_utils.update)(this, this._array, key, values)
            },
            _removeImpl: function(key) {
                return (0, _array_utils.remove)(this, this._array, key)
            },
            clear: function() {
                this._eventsStrategy.fireEvent("modifying");
                this._array = [];
                this._eventsStrategy.fireEvent("modified")
            }
        }, "array");
        var _default = ArrayStore;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************!*\
      !*** external "window.Globalize" ***!
      \***********************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports) {
        module.exports = window.Globalize
    },
    /*!*****************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/ajax.js ***!
      \*****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _deferred = __webpack_require__( /*! ./deferred */ 6);
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _http_request = _interopRequireDefault(__webpack_require__( /*! ../../core/http_request */ 506));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _extend = __webpack_require__( /*! ./extend */ 0);
        var _type = __webpack_require__( /*! ./type */ 1);
        var _promise = _interopRequireDefault(__webpack_require__( /*! ../polyfills/promise */ 73));
        var _dependency_injector = _interopRequireDefault(__webpack_require__( /*! ./dependency_injector */ 58));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var SUCCESS = "success";
        var ERROR = "error";
        var TIMEOUT = "timeout";
        var NO_CONTENT = "nocontent";
        var PARSER_ERROR = "parsererror";
        var isStatusSuccess = function(status) {
            return 200 <= status && status < 300
        };
        var hasContent = function(status) {
            return 204 !== status
        };
        var paramsConvert = function(params) {
            var result = [];
            for (var name in params) {
                var value = params[name];
                if (void 0 === value) {
                    continue
                }
                if (null === value) {
                    value = ""
                }
                if ("function" === typeof value) {
                    value = value()
                }
                result.push(encodeURIComponent(name) + "=" + encodeURIComponent(value))
            }
            return result.join("&")
        };
        var createScript = function(options) {
            var script = _dom_adapter.default.createElement("script");
            for (var name in options) {
                script[name] = options[name]
            }
            return script
        };
        var removeScript = function(scriptNode) {
            scriptNode.parentNode.removeChild(scriptNode)
        };
        var appendToHead = function(element) {
            return _dom_adapter.default.getHead().appendChild(element)
        };
        var evalScript = function(code) {
            var script = createScript({
                text: code
            });
            appendToHead(script);
            removeScript(script)
        };
        var evalCrossDomainScript = function(url) {
            var script = createScript({
                src: url
            });
            return new _promise.default(function(resolve, reject) {
                var events = {
                    load: resolve,
                    error: reject
                };
                var loadHandler = function(e) {
                    events[e.type]();
                    removeScript(script)
                };
                for (var event in events) {
                    _dom_adapter.default.listen(script, event, loadHandler)
                }
                appendToHead(script)
            })
        };
        var getAcceptHeader = function(options) {
            var dataType = options.dataType || "*";
            var scriptAccept = "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript";
            var accepts = {
                "*": "*/*",
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript",
                jsonp: scriptAccept,
                script: scriptAccept
            };
            (0, _extend.extendFromObject)(accepts, options.accepts, true);
            return accepts[dataType] ? accepts[dataType] + ("*" !== dataType ? ", */*; q=0.01" : "") : accepts["*"]
        };
        var getContentTypeHeader = function(options) {
            var defaultContentType;
            if (options.data && !options.upload && "GET" !== getMethod(options)) {
                defaultContentType = "application/x-www-form-urlencoded;charset=utf-8"
            }
            return options.contentType || defaultContentType
        };
        var getDataFromResponse = function(xhr) {
            return xhr.responseType && "text" !== xhr.responseType || "string" !== typeof xhr.responseText ? xhr.response : xhr.responseText
        };
        var postProcess = function(deferred, xhr, dataType) {
            var data = getDataFromResponse(xhr);
            switch (dataType) {
                case "jsonp":
                    evalScript(data);
                    break;
                case "script":
                    evalScript(data);
                    deferred.resolve(data, SUCCESS, xhr);
                    break;
                case "json":
                    try {
                        deferred.resolve(JSON.parse(data), SUCCESS, xhr)
                    } catch (e) {
                        deferred.reject(xhr, PARSER_ERROR, e)
                    }
                    break;
                default:
                    deferred.resolve(data, SUCCESS, xhr)
            }
        };
        var isCrossDomain = function(url) {
            if (!(0, _window.hasWindow)()) {
                return true
            }
            var crossDomain = false;
            var originAnchor = _dom_adapter.default.createElement("a");
            var urlAnchor = _dom_adapter.default.createElement("a");
            originAnchor.href = window.location.href;
            try {
                urlAnchor.href = url;
                urlAnchor.href = urlAnchor.href;
                crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host
            } catch (e) {
                crossDomain = true
            }
            return crossDomain
        };
        var setHttpTimeout = function(timeout, xhr) {
            return timeout && setTimeout(function() {
                xhr.customStatus = TIMEOUT;
                xhr.abort()
            }, timeout)
        };
        var getJsonpOptions = function(options) {
            if ("jsonp" === options.dataType) {
                var random = Math.random().toString().replace(/\D/g, "");
                var callbackName = options.jsonpCallback || "dxCallback" + Date.now() + "_" + random;
                var callbackParameter = options.jsonp || "callback";
                options.data = options.data || {};
                options.data[callbackParameter] = callbackName;
                return callbackName
            }
        };
        var getRequestOptions = function(options, headers) {
            var params = options.data;
            var paramsAlreadyString = "string" === typeof params;
            var url = options.url || window.location.href;
            if (!paramsAlreadyString && !options.cache) {
                params = params || {};
                params._ = Date.now()
            }
            if (params && !options.upload) {
                if (!paramsAlreadyString) {
                    params = paramsConvert(params)
                }
                if ("GET" === getMethod(options)) {
                    if ("" !== params) {
                        url += (url.indexOf("?") > -1 ? "&" : "?") + params
                    }
                    params = null
                } else {
                    if (headers["Content-Type"] && headers["Content-Type"].indexOf("application/x-www-form-urlencoded") > -1) {
                        params = params.replace(/%20/g, "+")
                    }
                }
            }
            return {
                url: url,
                parameters: params
            }
        };

        function getMethod(options) {
            return (options.method || "GET").toUpperCase()
        }
        var getRequestHeaders = function(options) {
            var headers = options.headers || {};
            headers["Content-Type"] = headers["Content-Type"] || getContentTypeHeader(options);
            headers.Accept = headers.Accept || getAcceptHeader(options);
            if (!options.crossDomain && !headers["X-Requested-With"]) {
                headers["X-Requested-With"] = "XMLHttpRequest"
            }
            return headers
        };
        var sendRequest = function(options) {
            var xhr = _http_request.default.getXhr();
            var d = new _deferred.Deferred;
            var result = d.promise();
            var async = (0, _type.isDefined)(options.async) ? options.async : true;
            var dataType = options.dataType;
            var timeout = options.timeout || 0;
            var timeoutId;
            options.crossDomain = isCrossDomain(options.url);
            var needScriptEvaluation = "jsonp" === dataType || "script" === dataType;
            if (void 0 === options.cache) {
                options.cache = !needScriptEvaluation
            }
            var callbackName = getJsonpOptions(options);
            var headers = getRequestHeaders(options);
            var requestOptions = getRequestOptions(options, headers);
            var url = requestOptions.url;
            var parameters = requestOptions.parameters;
            if (callbackName) {
                window[callbackName] = function(data) {
                    d.resolve(data, SUCCESS, xhr)
                }
            }
            if (options.crossDomain && needScriptEvaluation) {
                var reject = function() {
                    d.reject(xhr, ERROR)
                };
                var resolve = function() {
                    if ("jsonp" === dataType) {
                        return
                    }
                    d.resolve(null, SUCCESS, xhr)
                };
                evalCrossDomainScript(url).then(resolve, reject);
                return result
            }
            if (options.crossDomain && !("withCredentials" in xhr)) {
                d.reject(xhr, ERROR);
                return result
            }
            xhr.open(getMethod(options), url, async, options.username, options.password);
            if (async) {
                xhr.timeout = timeout;
                timeoutId = setHttpTimeout(timeout, xhr, d)
            }
            xhr.onreadystatechange = function(e) {
                if (4 === xhr.readyState) {
                    clearTimeout(timeoutId);
                    if (isStatusSuccess(xhr.status)) {
                        if (hasContent(xhr.status)) {
                            postProcess(d, xhr, dataType)
                        } else {
                            d.resolve(null, NO_CONTENT, xhr)
                        }
                    } else {
                        d.reject(xhr, xhr.customStatus || ERROR)
                    }
                }
            };
            if (options.upload) {
                xhr.upload.onprogress = options.upload.onprogress;
                xhr.upload.onloadstart = options.upload.onloadstart;
                xhr.upload.onabort = options.upload.onabort
            }
            if (options.xhrFields) {
                for (var field in options.xhrFields) {
                    xhr[field] = options.xhrFields[field]
                }
            }
            if ("arraybuffer" === options.responseType) {
                xhr.responseType = options.responseType
            }
            for (var name in headers) {
                if (Object.prototype.hasOwnProperty.call(headers, name) && (0, _type.isDefined)(headers[name])) {
                    xhr.setRequestHeader(name, headers[name])
                }
            }
            if (options.beforeSend) {
                options.beforeSend(xhr)
            }
            xhr.send(parameters);
            result.abort = function() {
                xhr.abort()
            };
            return result
        };
        var _default = (0, _dependency_injector.default)({
            sendRequest: sendRequest
        });
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/view_port.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.originalViewPort = originalViewPort;
        exports.changeCallback = exports.value = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../renderer */ 2));
        var _ready_callbacks = _interopRequireDefault(__webpack_require__( /*! ./ready_callbacks */ 49));
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ./callbacks */ 27));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ready = _ready_callbacks.default.add;
        var changeCallback = (0, _callbacks.default)();
        exports.changeCallback = changeCallback;
        var $originalViewPort = (0, _renderer.default)();
        var value = function() {
            var $current;
            return function(element) {
                if (!arguments.length) {
                    return $current
                }
                var $element = (0, _renderer.default)(element);
                $originalViewPort = $element;
                var isNewViewportFound = !!$element.length;
                var prevViewPort = value();
                $current = isNewViewportFound ? $element : (0, _renderer.default)("body");
                changeCallback.fire(isNewViewportFound ? value() : (0, _renderer.default)(), prevViewPort)
            }
        }();
        exports.value = value;
        ready(function() {
            value(".dx-viewport")
        });

        function originalViewPort() {
            return $originalViewPort
        }
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/animation/position.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../core/dom_adapter */ 11));
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _position = __webpack_require__( /*! ../core/utils/position */ 22);
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../core/utils/browser */ 23));
        var _translator = __webpack_require__( /*! ./translator */ 28);
        var _support = __webpack_require__( /*! ../core/utils/support */ 45);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../core/devices */ 13));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var horzRe = /left|right/;
        var vertRe = /top|bottom/;
        var collisionRe = /fit|flip|none/;
        var scaleRe = /scale(.+)/;
        var IS_SAFARI = _browser.default.safari;
        var normalizeAlign = function(raw) {
            var result = {
                h: "center",
                v: "center"
            };
            var pair = (0, _common.splitPair)(raw);
            if (pair) {
                (0, _iterator.each)(pair, function() {
                    var w = String(this).toLowerCase();
                    if (horzRe.test(w)) {
                        result.h = w
                    } else {
                        if (vertRe.test(w)) {
                            result.v = w
                        }
                    }
                })
            }
            return result
        };
        var normalizeOffset = function(raw) {
            return (0, _common.pairToObject)(raw)
        };
        var normalizeCollision = function(raw) {
            var pair = (0, _common.splitPair)(raw);
            var h = String(pair && pair[0]).toLowerCase();
            var v = String(pair && pair[1]).toLowerCase();
            if (!collisionRe.test(h)) {
                h = "none"
            }
            if (!collisionRe.test(v)) {
                v = h
            }
            return {
                h: h,
                v: v
            }
        };
        var getAlignFactor = function(align) {
            switch (align) {
                case "center":
                    return .5;
                case "right":
                case "bottom":
                    return 1;
                default:
                    return 0
            }
        };
        var inverseAlign = function(align) {
            switch (align) {
                case "left":
                    return "right";
                case "right":
                    return "left";
                case "top":
                    return "bottom";
                case "bottom":
                    return "top";
                default:
                    return align
            }
        };
        var calculateOversize = function(data, bounds) {
            var oversize = 0;
            if (data.myLocation < bounds.min) {
                oversize += bounds.min - data.myLocation
            }
            if (data.myLocation > bounds.max) {
                oversize += data.myLocation - bounds.max
            }
            return oversize
        };
        var collisionSide = function(direction, data, bounds) {
            if (data.myLocation < bounds.min) {
                return "h" === direction ? "left" : "top"
            }
            if (data.myLocation > bounds.max) {
                return "h" === direction ? "right" : "bottom"
            }
            return "none"
        };
        var initMyLocation = function(data) {
            data.myLocation = data.atLocation + getAlignFactor(data.atAlign) * data.atSize - getAlignFactor(data.myAlign) * data.mySize + data.offset
        };
        var collisionResolvers = {
            fit: function(data, bounds) {
                var result = false;
                if (data.myLocation > bounds.max) {
                    data.myLocation = bounds.max;
                    result = true
                }
                if (data.myLocation < bounds.min) {
                    data.myLocation = bounds.min;
                    result = true
                }
                data.fit = result
            },
            flip: function(data, bounds) {
                data.flip = false;
                if ("center" === data.myAlign && "center" === data.atAlign) {
                    return
                }
                if (data.myLocation < bounds.min || data.myLocation > bounds.max) {
                    var inverseData = (0, _extend.extend)({}, data, {
                        myAlign: inverseAlign(data.myAlign),
                        atAlign: inverseAlign(data.atAlign),
                        offset: -data.offset
                    });
                    initMyLocation(inverseData);
                    inverseData.oversize = calculateOversize(inverseData, bounds);
                    if (inverseData.myLocation >= bounds.min && inverseData.myLocation <= bounds.max || data.oversize > inverseData.oversize) {
                        data.myLocation = inverseData.myLocation;
                        data.oversize = inverseData.oversize;
                        data.flip = true
                    }
                }
            },
            flipfit: function(data, bounds) {
                this.flip(data, bounds);
                this.fit(data, bounds)
            },
            none: function(data) {
                data.oversize = 0
            }
        };
        var scrollbarWidth;
        var calculateScrollbarWidth = function() {
            var $scrollDiv = (0, _renderer.default)("<div>").css({
                width: 100,
                height: 100,
                overflow: "scroll",
                position: "absolute",
                top: -9999
            }).appendTo((0, _renderer.default)("body"));
            var result = $scrollDiv.get(0).offsetWidth - $scrollDiv.get(0).clientWidth;
            $scrollDiv.remove();
            scrollbarWidth = result
        };
        var defaultPositionResult = {
            h: {
                location: 0,
                flip: false,
                fit: false,
                oversize: 0
            },
            v: {
                location: 0,
                flip: false,
                fit: false,
                oversize: 0
            }
        };
        var calculatePosition = function(what, options) {
            var $what = (0, _renderer.default)(what);
            var currentOffset = $what.offset();
            var result = (0, _extend.extend)(true, {}, defaultPositionResult, {
                h: {
                    location: currentOffset.left
                },
                v: {
                    location: currentOffset.top
                }
            });
            if (!options) {
                return result
            }
            var my = normalizeAlign(options.my);
            var at = normalizeAlign(options.at);
            var of = (0, _renderer.default)(options.of).length && options.of || window;
            var offset = normalizeOffset(options.offset);
            var collision = normalizeCollision(options.collision);
            var boundary = options.boundary;
            var boundaryOffset = normalizeOffset(options.boundaryOffset);
            var h = {
                mySize: $what.outerWidth(),
                myAlign: my.h,
                atAlign: at.h,
                offset: offset.h,
                collision: collision.h,
                boundaryOffset: boundaryOffset.h
            };
            var v = {
                mySize: $what.outerHeight(),
                myAlign: my.v,
                atAlign: at.v,
                offset: offset.v,
                collision: collision.v,
                boundaryOffset: boundaryOffset.v
            };
            if ( of .preventDefault) {
                h.atLocation = of .pageX;
                v.atLocation = of .pageY;
                h.atSize = 0;
                v.atSize = 0
            } else {
                of = (0, _renderer.default)( of );
                if ((0, _type.isWindow)( of [0])) {
                    h.atLocation = of .scrollLeft();
                    v.atLocation = of .scrollTop();
                    if ("phone" === _devices.default.real().deviceType && of [0].visualViewport) {
                        h.atLocation = Math.max(h.atLocation, of [0].visualViewport.offsetLeft);
                        v.atLocation = Math.max(v.atLocation, of [0].visualViewport.offsetTop);
                        h.atSize = of [0].visualViewport.width;
                        v.atSize = of [0].visualViewport.height
                    } else {
                        h.atSize = of [0].innerWidth > of [0].outerWidth ? of [0].innerWidth : of .width();
                        v.atSize = of [0].innerHeight > of [0].outerHeight || IS_SAFARI ? of [0].innerHeight : of .height()
                    }
                } else {
                    if (9 === of [0].nodeType) {
                        h.atLocation = 0;
                        v.atLocation = 0;
                        h.atSize = of .width();
                        v.atSize = of .height()
                    } else {
                        var ofRect = (0, _position.getBoundingRect)( of .get(0));
                        var o = getOffsetWithoutScale( of );
                        h.atLocation = o.left;
                        v.atLocation = o.top;
                        h.atSize = Math.max(ofRect.width, of .outerWidth());
                        v.atSize = Math.max(ofRect.height, of .outerHeight())
                    }
                }
            }
            initMyLocation(h);
            initMyLocation(v);
            var bounds = function() {
                var win = (0, _renderer.default)(window);
                var windowWidth = win.width();
                var windowHeight = win.height();
                var left = win.scrollLeft();
                var top = win.scrollTop();
                var documentElement = _dom_adapter.default.getDocumentElement();
                var hZoomLevel = _support.touch ? documentElement.clientWidth / windowWidth : 1;
                var vZoomLevel = _support.touch ? documentElement.clientHeight / windowHeight : 1;
                if (void 0 === scrollbarWidth) {
                    calculateScrollbarWidth()
                }
                var boundaryWidth = windowWidth;
                var boundaryHeight = windowHeight;
                if (boundary) {
                    var $boundary = (0, _renderer.default)(boundary);
                    var boundaryPosition = $boundary.offset();
                    left = boundaryPosition.left;
                    top = boundaryPosition.top;
                    boundaryWidth = $boundary.width();
                    boundaryHeight = $boundary.height()
                }
                return {
                    h: {
                        min: left + h.boundaryOffset,
                        max: left + boundaryWidth / hZoomLevel - h.mySize - h.boundaryOffset
                    },
                    v: {
                        min: top + v.boundaryOffset,
                        max: top + boundaryHeight / vZoomLevel - v.mySize - v.boundaryOffset
                    }
                }
            }();
            h.oversize = calculateOversize(h, bounds.h);
            v.oversize = calculateOversize(v, bounds.v);
            h.collisionSide = collisionSide("h", h, bounds.h);
            v.collisionSide = collisionSide("v", v, bounds.v);
            if (collisionResolvers[h.collision]) {
                collisionResolvers[h.collision](h, bounds.h)
            }
            if (collisionResolvers[v.collision]) {
                collisionResolvers[v.collision](v, bounds.v)
            }
            var preciser = function(number) {
                return options.precise ? number : Math.round(number)
            };
            (0, _extend.extend)(true, result, {
                h: {
                    location: preciser(h.myLocation),
                    oversize: preciser(h.oversize),
                    fit: h.fit,
                    flip: h.flip,
                    collisionSide: h.collisionSide
                },
                v: {
                    location: preciser(v.myLocation),
                    oversize: preciser(v.oversize),
                    fit: v.fit,
                    flip: v.flip,
                    collisionSide: v.collisionSide
                },
                precise: options.precise
            });
            return result
        };
        var getOffsetWithoutScale = function getOffsetWithoutScale($startElement) {
            var _currentElement$getAt, _style$match;
            var $currentElement = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : $startElement;
            var currentElement = $currentElement.get(0);
            if (!currentElement) {
                return $startElement.offset()
            }
            var style = (null === (_currentElement$getAt = currentElement.getAttribute) || void 0 === _currentElement$getAt ? void 0 : _currentElement$getAt.call(currentElement, "style")) || "";
            var scale = null === (_style$match = style.match(scaleRe)) || void 0 === _style$match ? void 0 : _style$match[0];
            var offset;
            if (scale) {
                currentElement.setAttribute("style", style.replace(scale, ""));
                offset = getOffsetWithoutScale($startElement, $currentElement.parent());
                currentElement.setAttribute("style", style)
            } else {
                offset = getOffsetWithoutScale($startElement, $currentElement.parent())
            }
            return offset
        };
        var position = function(what, options) {
            var $what = (0, _renderer.default)(what);
            if (!options) {
                return $what.offset()
            }(0, _translator.resetPosition)($what, true);
            var offset = getOffsetWithoutScale($what);
            var targetPosition = options.h && options.v ? options : calculatePosition($what, options);
            var preciser = function(number) {
                return options.precise ? number : Math.round(number)
            };
            (0, _translator.move)($what, {
                left: targetPosition.h.location - preciser(offset.left),
                top: targetPosition.v.location - preciser(offset.top)
            });
            return targetPosition
        };
        var offset = function(element) {
            element = (0, _renderer.default)(element).get(0);
            if ((0, _type.isWindow)(element)) {
                return null
            } else {
                if (element && "pageY" in element && "pageX" in element) {
                    return {
                        top: element.pageY,
                        left: element.pageX
                    }
                }
            }
            return (0, _renderer.default)(element).offset()
        };
        if (!position.inverseAlign) {
            position.inverseAlign = inverseAlign
        }
        if (!position.normalizeAlign) {
            position.normalizeAlign = normalizeAlign
        }
        var _default = {
            calculateScrollbarWidth: calculateScrollbarWidth,
            calculate: calculatePosition,
            setup: position,
            offset: offset
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/widget/utils.ink_ripple.js ***!
      \****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.showWave = showWave;
        exports.hideWave = hideWave;
        exports.render = exports.initConfig = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var INKRIPPLE_CLASS = "dx-inkripple";
        var INKRIPPLE_WAVE_CLASS = "dx-inkripple-wave";
        var INKRIPPLE_SHOWING_CLASS = "dx-inkripple-showing";
        var INKRIPPLE_HIDING_CLASS = "dx-inkripple-hiding";
        var DEFAULT_WAVE_SIZE_COEFFICIENT = 2;
        var MAX_WAVE_SIZE = 4e3;
        var ANIMATION_DURATION = 300;
        var HOLD_ANIMATION_DURATION = 1e3;
        var DEFAULT_WAVE_INDEX = 0;
        var initConfig = function() {
            var config = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            var useHoldAnimation = config.useHoldAnimation,
                waveSizeCoefficient = config.waveSizeCoefficient,
                isCentered = config.isCentered,
                wavesNumber = config.wavesNumber;
            return {
                waveSizeCoefficient: waveSizeCoefficient || DEFAULT_WAVE_SIZE_COEFFICIENT,
                isCentered: isCentered || false,
                wavesNumber: wavesNumber || 1,
                durations: getDurations(null !== useHoldAnimation && void 0 !== useHoldAnimation ? useHoldAnimation : true)
            }
        };
        exports.initConfig = initConfig;
        var render = function(args) {
            var config = initConfig(args);
            return {
                showWave: showWave.bind(this, config),
                hideWave: hideWave.bind(this, config)
            }
        };
        exports.render = render;
        var getInkRipple = function(element) {
            var result = element.children("." + INKRIPPLE_CLASS);
            if (0 === result.length) {
                result = (0, _renderer.default)("<div>").addClass(INKRIPPLE_CLASS).appendTo(element)
            }
            return result
        };
        var getWaves = function(element, wavesNumber) {
            var inkRipple = getInkRipple((0, _renderer.default)(element));
            var result = inkRipple.children("." + INKRIPPLE_WAVE_CLASS).toArray();
            for (var i = result.length; i < wavesNumber; i++) {
                var $currentWave = (0, _renderer.default)("<div>").appendTo(inkRipple).addClass(INKRIPPLE_WAVE_CLASS);
                result.push($currentWave[0])
            }
            return (0, _renderer.default)(result)
        };
        var getWaveStyleConfig = function(args, config) {
            var element = (0, _renderer.default)(config.element);
            var elementWidth = element.outerWidth();
            var elementHeight = element.outerHeight();
            var elementDiagonal = parseInt(Math.sqrt(elementWidth * elementWidth + elementHeight * elementHeight));
            var waveSize = Math.min(MAX_WAVE_SIZE, parseInt(elementDiagonal * args.waveSizeCoefficient));
            var left;
            var top;
            if (args.isCentered) {
                left = (elementWidth - waveSize) / 2;
                top = (elementHeight - waveSize) / 2
            } else {
                var event = config.event;
                var position = element.offset();
                var x = event.pageX - position.left;
                var y = event.pageY - position.top;
                left = x - waveSize / 2;
                top = y - waveSize / 2
            }
            return {
                left: left,
                top: top,
                height: waveSize,
                width: waveSize
            }
        };

        function showWave(args, config) {
            var $wave = getWaves(config.element, args.wavesNumber).eq(config.wave || DEFAULT_WAVE_INDEX);
            args.hidingTimeout && clearTimeout(args.hidingTimeout);
            hideSelectedWave($wave);
            $wave.css(getWaveStyleConfig(args, config));
            args.showingTimeout = setTimeout(showingWaveHandler.bind(this, args, $wave), 0)
        }

        function showingWaveHandler(args, $wave) {
            var durationCss = args.durations.showingScale + "ms";
            $wave.addClass(INKRIPPLE_SHOWING_CLASS).css("transitionDuration", durationCss)
        }

        function getDurations(useHoldAnimation) {
            return {
                showingScale: useHoldAnimation ? HOLD_ANIMATION_DURATION : ANIMATION_DURATION,
                hidingScale: ANIMATION_DURATION,
                hidingOpacity: ANIMATION_DURATION
            }
        }

        function hideSelectedWave($wave) {
            $wave.removeClass(INKRIPPLE_HIDING_CLASS).css("transitionDuration", "")
        }

        function hideWave(args, config) {
            args.showingTimeout && clearTimeout(args.showingTimeout);
            var $wave = getWaves(config.element, config.wavesNumber).eq(config.wave || DEFAULT_WAVE_INDEX);
            var durations = args.durations;
            var durationCss = durations.hidingScale + "ms, " + durations.hidingOpacity + "ms";
            $wave.addClass(INKRIPPLE_HIDING_CLASS).removeClass(INKRIPPLE_SHOWING_CLASS).css("transitionDuration", durationCss);
            var animationDuration = Math.max(durations.hidingScale, durations.hidingOpacity);
            args.hidingTimeout = setTimeout(hideSelectedWave.bind(this, $wave), animationDuration)
        }
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/load_indicator.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _support = __webpack_require__( /*! ../core/utils/support */ 45);
        var _themes = __webpack_require__( /*! ./themes */ 34);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../core/devices */ 13));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./widget/ui.widget */ 16));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var navigator = (0, _window.getNavigator)();
        var LOADINDICATOR_CLASS = "dx-loadindicator";
        var LOADINDICATOR_WRAPPER_CLASS = "dx-loadindicator-wrapper";
        var LOADINDICATOR_CONTENT_CLASS = "dx-loadindicator-content";
        var LOADINDICATOR_ICON_CLASS = "dx-loadindicator-icon";
        var LOADINDICATOR_SEGMENT_CLASS = "dx-loadindicator-segment";
        var LOADINDICATOR_SEGMENT_INNER_CLASS = "dx-loadindicator-segment-inner";
        var LOADINDICATOR_IMAGE_CLASS = "dx-loadindicator-image";
        var LoadIndicator = _ui.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    indicatorSrc: "",
                    activeStateEnabled: false,
                    hoverStateEnabled: false,
                    _animatingSegmentCount: 1,
                    _animatingSegmentInner: false
                })
            },
            _defaultOptionsRules: function() {
                var themeName = (0, _themes.current)();
                return this.callBase().concat([{
                    device: function() {
                        var realDevice = _devices.default.real();
                        var obsoleteAndroid = "android" === realDevice.platform && !/chrome/i.test(navigator.userAgent);
                        return obsoleteAndroid
                    },
                    options: {
                        viaImage: true
                    }
                }, {
                    device: function() {
                        return (0, _themes.isMaterial)(themeName)
                    },
                    options: {
                        _animatingSegmentCount: 2,
                        _animatingSegmentInner: true
                    }
                }, {
                    device: function() {
                        return (0, _themes.isGeneric)(themeName)
                    },
                    options: {
                        _animatingSegmentCount: 7
                    }
                }])
            },
            _useTemplates: function() {
                return false
            },
            _init: function() {
                this.callBase();
                this.$element().addClass(LOADINDICATOR_CLASS)
            },
            _initMarkup: function() {
                this.callBase();
                this._renderWrapper();
                this._renderIndicatorContent();
                this._renderMarkup()
            },
            _renderWrapper: function() {
                this._$wrapper = (0, _renderer.default)("<div>").addClass(LOADINDICATOR_WRAPPER_CLASS);
                this.$element().append(this._$wrapper)
            },
            _renderIndicatorContent: function() {
                this._$content = (0, _renderer.default)("<div>").addClass(LOADINDICATOR_CONTENT_CLASS);
                this._$wrapper.append(this._$content)
            },
            _renderMarkup: function() {
                if ((0, _support.animation)() && !this.option("viaImage") && !this.option("indicatorSrc")) {
                    this._renderMarkupForAnimation()
                } else {
                    this._renderMarkupForImage()
                }
            },
            _renderMarkupForAnimation: function() {
                var animatingSegmentInner = this.option("_animatingSegmentInner");
                this._$indicator = (0, _renderer.default)("<div>").addClass(LOADINDICATOR_ICON_CLASS);
                this._$content.append(this._$indicator);
                for (var i = this.option("_animatingSegmentCount"); i >= 0; --i) {
                    var $segment = (0, _renderer.default)("<div>").addClass(LOADINDICATOR_SEGMENT_CLASS).addClass(LOADINDICATOR_SEGMENT_CLASS + i);
                    if (animatingSegmentInner) {
                        $segment.append((0, _renderer.default)("<div>").addClass(LOADINDICATOR_SEGMENT_INNER_CLASS))
                    }
                    this._$indicator.append($segment)
                }
            },
            _renderMarkupForImage: function() {
                var indicatorSrc = this.option("indicatorSrc");
                this._$wrapper.addClass(LOADINDICATOR_IMAGE_CLASS);
                if (indicatorSrc) {
                    this._$wrapper.css("backgroundImage", "url(" + indicatorSrc + ")")
                }
            },
            _renderDimensions: function() {
                this.callBase();
                this._updateContentSizeForAnimation()
            },
            _updateContentSizeForAnimation: function() {
                if (!this._$indicator) {
                    return
                }
                var width = this.option("width");
                var height = this.option("height");
                if (width || height) {
                    width = this.$element().width();
                    height = this.$element().height();
                    var minDimension = Math.min(height, width);
                    this._$wrapper.css({
                        height: minDimension,
                        width: minDimension,
                        fontSize: minDimension
                    })
                }
            },
            _clean: function() {
                this.callBase();
                this._removeMarkupForAnimation();
                this._removeMarkupForImage()
            },
            _removeMarkupForAnimation: function() {
                if (!this._$indicator) {
                    return
                }
                this._$indicator.remove();
                delete this._$indicator
            },
            _removeMarkupForImage: function() {
                this._$wrapper.css("backgroundImage", "none")
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "_animatingSegmentCount":
                    case "_animatingSegmentInner":
                    case "indicatorSrc":
                        this._invalidate();
                        break;
                    default:
                        this.callBase(args)
                }
            }
        });
        (0, _component_registrator.default)("dxLoadIndicator", LoadIndicator);
        var _default = LoadIndicator;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/pivot_grid/ui.pivot_grid.utils.js ***!
      \***********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.sendRequest = sendRequest;
        exports.findField = findField;
        exports.formatValue = formatValue;
        exports.getCompareFunction = getCompareFunction;
        exports.createPath = createPath;
        exports.foreachDataLevel = foreachDataLevel;
        exports.mergeArraysByMaxValue = mergeArraysByMaxValue;
        exports.getExpandedLevel = getExpandedLevel;
        exports.discoverObjectFields = discoverObjectFields;
        exports.getFieldsDataType = getFieldsDataType;
        exports.setDefaultFieldValueFormatting = setDefaultFieldValueFormatting;
        exports.getFiltersByPath = getFiltersByPath;
        exports.capitalizeFirstLetter = capitalizeFirstLetter;
        exports.storeDrillDownMixin = exports.foreachTreeAsync = exports.foreachTree = exports.setFieldProperty = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _ajax = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/ajax */ 79));
        var _data = __webpack_require__( /*! ../../core/utils/data */ 20);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../localization/date */ 32));
        var _format_helper = _interopRequireDefault(__webpack_require__( /*! ../../format_helper */ 71));
        var _data_source = __webpack_require__( /*! ../../data/data_source/data_source */ 68);
        var _array_store = _interopRequireDefault(__webpack_require__( /*! ../../data/array_store */ 77));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var setFieldProperty = function(field, property, value, isInitialization) {
            var initProperties = field._initProperties = field._initProperties || {};
            var initValue = isInitialization ? value : field[property];
            if (!Object.prototype.hasOwnProperty.call(initProperties, property) || isInitialization) {
                initProperties[property] = initValue
            }
            field[property] = value
        };
        exports.setFieldProperty = setFieldProperty;

        function sendRequest(options) {
            return _ajax.default.sendRequest(options)
        }
        var foreachTreeAsyncDate = new Date;

        function createForeachTreeFunc(isAsync) {
            var foreachTreeFunc = function foreachTreeFunc(items, callback, parentAtFirst, members, index, isChildrenProcessing) {
                members = members || [];
                items = items || [];
                var i;
                var deferred;
                index = index || 0;

                function createForeachTreeAsyncHandler(deferred, i, isChildrenProcessing) {
                    (0, _deferred.when)(foreachTreeFunc(items, callback, parentAtFirst, members, i, isChildrenProcessing)).done(deferred.resolve)
                }
                for (i = index; i < items.length; i++) {
                    if (isAsync && i > index && i % 1e4 === 0 && new Date - foreachTreeAsyncDate >= 300) {
                        foreachTreeAsyncDate = new Date;
                        deferred = new _deferred.Deferred;
                        setTimeout(createForeachTreeAsyncHandler(deferred, i, false), 0);
                        return deferred
                    }
                    var item = items[i];
                    if (!isChildrenProcessing) {
                        members.unshift(item);
                        if (parentAtFirst && false === callback(members, i)) {
                            return
                        }
                        if (item.children) {
                            var childrenDeferred = foreachTreeFunc(item.children, callback, parentAtFirst, members);
                            if (isAsync && childrenDeferred) {
                                deferred = new _deferred.Deferred;
                                childrenDeferred.done(createForeachTreeAsyncHandler(deferred, i, true));
                                return deferred
                            }
                        }
                    }
                    isChildrenProcessing = false;
                    if (!parentAtFirst && false === callback(members, i)) {
                        return
                    }
                    members.shift();
                    if (items[i] !== item) {
                        i--
                    }
                }
            };
            return foreachTreeFunc
        }
        var foreachTree = createForeachTreeFunc(false);
        exports.foreachTree = foreachTree;
        var foreachTreeAsync = createForeachTreeFunc(true);
        exports.foreachTreeAsync = foreachTreeAsync;

        function findField(fields, id) {
            if (fields && (0, _type.isDefined)(id)) {
                for (var i = 0; i < fields.length; i++) {
                    var field = fields[i];
                    if (field.name === id || field.caption === id || field.dataField === id || field.index === id) {
                        return i
                    }
                }
            }
            return -1
        }

        function formatValue(value, options) {
            var valueText = value === value && _format_helper.default.format(value, options.format);
            var formatObject = {
                value: value,
                valueText: valueText || ""
            };
            return options.customizeText ? options.customizeText.call(options, formatObject) : formatObject.valueText
        }

        function getCompareFunction(valueSelector) {
            return function(a, b) {
                var result = 0;
                var valueA = valueSelector(a);
                var valueB = valueSelector(b);
                var aIsDefined = (0, _type.isDefined)(valueA);
                var bIsDefined = (0, _type.isDefined)(valueB);
                if (aIsDefined && bIsDefined) {
                    if (valueA > valueB) {
                        result = 1
                    } else {
                        if (valueA < valueB) {
                            result = -1
                        }
                    }
                }
                if (aIsDefined && !bIsDefined) {
                    result = 1
                }
                if (!aIsDefined && bIsDefined) {
                    result = -1
                }
                return result
            }
        }

        function createPath(items) {
            var result = [];
            for (var i = items.length - 1; i >= 0; i--) {
                result.push(items[i].key || items[i].value)
            }
            return result
        }

        function foreachDataLevel(data, callback, index, childrenField) {
            index = index || 0;
            childrenField = childrenField || "children";
            if (data.length) {
                callback(data, index)
            }
            for (var i = 0; i < data.length; i++) {
                var item = data[i];
                if (item[childrenField] && item[childrenField].length) {
                    foreachDataLevel(item[childrenField], callback, index + 1, childrenField)
                }
            }
        }

        function mergeArraysByMaxValue(values1, values2) {
            var result = [];
            for (var i = 0; i < values1.length; i++) {
                result.push(Math.max(values1[i] || 0, values2[i] || 0))
            }
            return result
        }

        function getExpandedLevel(options, axisName) {
            var dimensions = options[axisName];
            var expandLevel = 0;
            var expandedPaths = ("columns" === axisName ? options.columnExpandedPaths : options.rowExpandedPaths) || [];
            if (options.headerName === axisName) {
                expandLevel = options.path.length
            } else {
                if (options.headerName && options.headerName !== axisName && options.oppositePath) {
                    expandLevel = options.oppositePath.length
                } else {
                    (0, _iterator.each)(expandedPaths, function(_, path) {
                        expandLevel = Math.max(expandLevel, path.length)
                    })
                }
            }
            while (dimensions[expandLevel + 1] && dimensions[expandLevel].expanded) {
                expandLevel++
            }
            return expandLevel
        }

        function createGroupFields(item) {
            return (0, _iterator.map)(["year", "quarter", "month"], function(value, index) {
                return (0, _extend.extend)({}, item, {
                    groupInterval: value,
                    groupIndex: index
                })
            })
        }

        function parseFields(dataSource, fieldsList, path, fieldsDataType) {
            var result = [];
            Object.keys(fieldsList || []).forEach(function(field) {
                if (field && 0 === field.indexOf("__")) {
                    return
                }
                var dataIndex = 1;
                var currentPath = path.length ? path + "." + field : field;
                var dataType = fieldsDataType[currentPath];
                var getter = (0, _data.compileGetter)(currentPath);
                var value = fieldsList[field];
                var items;
                while (!(0, _type.isDefined)(value) && dataSource[dataIndex]) {
                    value = getter(dataSource[dataIndex]);
                    dataIndex++
                }
                if (!dataType && (0, _type.isDefined)(value)) {
                    dataType = (0, _type.type)(value)
                }
                items = [{
                    dataField: currentPath,
                    dataType: dataType,
                    groupName: "date" === dataType ? field : void 0,
                    groupInterval: void 0,
                    displayFolder: path
                }];
                if ("date" === dataType) {
                    items = items.concat(createGroupFields(items[0]))
                } else {
                    if ("object" === dataType) {
                        items = parseFields(dataSource, value, currentPath, fieldsDataType)
                    }
                }
                result.push.apply(result, items)
            });
            return result
        }

        function discoverObjectFields(items, fields) {
            var fieldsDataType = getFieldsDataType(fields);
            return parseFields(items, items[0], "", fieldsDataType)
        }

        function getFieldsDataType(fields) {
            var result = {};
            (0, _iterator.each)(fields, function(_, field) {
                result[field.dataField] = result[field.dataField] || field.dataType
            });
            return result
        }
        var DATE_INTERVAL_FORMATS = {
            month: function(value) {
                return _date.default.getMonthNames()[value - 1]
            },
            quarter: function(value) {
                return _date.default.format(new Date(2e3, 3 * value - 1), "quarter")
            },
            dayOfWeek: function(value) {
                return _date.default.getDayNames()[value]
            }
        };

        function setDefaultFieldValueFormatting(field) {
            if ("date" === field.dataType) {
                if (!field.format) {
                    setFieldProperty(field, "format", DATE_INTERVAL_FORMATS[field.groupInterval])
                }
            } else {
                if ("number" === field.dataType) {
                    var groupInterval = (0, _type.isNumeric)(field.groupInterval) && field.groupInterval > 0 && field.groupInterval;
                    if (groupInterval && !field.customizeText) {
                        setFieldProperty(field, "customizeText", function(formatObject) {
                            var secondValue = formatObject.value + groupInterval;
                            var secondValueText = _format_helper.default.format(secondValue, field.format);
                            return formatObject.valueText && secondValueText ? formatObject.valueText + " - " + secondValueText : ""
                        })
                    }
                }
            }
        }

        function getFiltersByPath(fields, path) {
            var result = [];
            path = path || [];
            for (var i = 0; i < path.length; i++) {
                result.push((0, _extend.extend)({}, fields[i], {
                    groupIndex: null,
                    groupName: null,
                    filterType: "include",
                    filterValues: [path[i]]
                }))
            }
            return result
        }
        var storeDrillDownMixin = {
            createDrillDownDataSource: function(descriptions, params) {
                var items = this.getDrillDownItems(descriptions, params);
                var arrayStore;

                function createCustomStoreMethod(methodName) {
                    return function(options) {
                        var d;
                        if (arrayStore) {
                            d = arrayStore[methodName](options)
                        } else {
                            d = new _deferred.Deferred;
                            (0, _deferred.when)(items).done(function(data) {
                                var arrayStore = new _array_store.default(data);
                                arrayStore[methodName](options).done(d.resolve).fail(d.reject)
                            }).fail(d.reject)
                        }
                        return d
                    }
                }
                var dataSource = new _data_source.DataSource({
                    load: createCustomStoreMethod("load"),
                    totalCount: createCustomStoreMethod("totalCount"),
                    key: this.key()
                });
                return dataSource
            }
        };
        exports.storeDrillDownMixin = storeDrillDownMixin;

        function capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        }
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/call_once.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var callOnce = function(handler) {
            var result;
            var _wrappedHandler = function() {
                result = handler.apply(this, arguments);
                _wrappedHandler = function() {
                    return result
                };
                return result
            };
            return function() {
                return _wrappedHandler.apply(this, arguments)
            }
        };
        var _default = callOnce;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/utils.timeZone.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));
        var _utils = _interopRequireDefault(__webpack_require__( /*! ./timezones/utils.timezones_data */ 325));
        var _dateAdapter = _interopRequireDefault(__webpack_require__( /*! ./dateAdapter */ 528));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _slicedToArray(arr, i) {
            return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest()
        }

        function _nonIterableRest() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }

        function _iterableToArrayLimit(arr, i) {
            var _i = arr && ("undefined" !== typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]);
            if (null == _i) {
                return
            }
            var _arr = [];
            var _n = true;
            var _d = false;
            var _s, _e;
            try {
                for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
                    _arr.push(_s.value);
                    if (i && _arr.length === i) {
                        break
                    }
                }
            } catch (err) {
                _d = true;
                _e = err
            } finally {
                try {
                    if (!_n && null != _i.return) {
                        _i.return()
                    }
                } finally {
                    if (_d) {
                        throw _e
                    }
                }
            }
            return _arr
        }

        function _arrayWithHoles(arr) {
            if (Array.isArray(arr)) {
                return arr
            }
        }
        var toMs = _date.default.dateToMilliseconds;
        var MINUTES_IN_HOUR = 60;
        var createUTCDateWithLocalOffset = function(date) {
            if (!date) {
                return null
            }
            return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()))
        };
        var createDateFromUTCWithLocalOffset = function(date) {
            var result = (0, _dateAdapter.default)(date);
            var timezoneOffsetBeforeInMin = result.getTimezoneOffset();
            result.addTime(result.getTimezoneOffset("minute"));
            result.subtractMinutes(timezoneOffsetBeforeInMin - result.getTimezoneOffset());
            return result.source
        };
        var getTimeZones = function() {
            var date = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Date;
            var dateInUTC = createUTCDate(date);
            return _utils.default.getDisplayedTimeZones(dateInUTC.getTime())
        };
        var createUTCDate = function(date) {
            return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes()))
        };
        var getTimezoneOffsetChangeInMinutes = function(startDate, endDate, updatedStartDate, updatedEndDate) {
            return getDaylightOffset(updatedStartDate, updatedEndDate) - getDaylightOffset(startDate, endDate)
        };
        var getTimezoneOffsetChangeInMs = function(startDate, endDate, updatedStartDate, updatedEndDate) {
            return getTimezoneOffsetChangeInMinutes(startDate, endDate, updatedStartDate, updatedEndDate) * toMs("minute")
        };
        var getDaylightOffset = function(startDate, endDate) {
            return new Date(startDate).getTimezoneOffset() - new Date(endDate).getTimezoneOffset()
        };
        var getDaylightOffsetInMs = function(startDate, endDate) {
            return getDaylightOffset(startDate, endDate) * toMs("minute")
        };
        var calculateTimezoneByValue = function(timezone) {
            var date = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Date;
            if ("string" === typeof timezone) {
                var dateUtc = createUTCDate(date);
                return _utils.default.getTimeZoneOffsetById(timezone, dateUtc.getTime())
            }
            return timezone
        };
        var _getDaylightOffsetByTimezone = function(startDate, endDate, timeZone) {
            return calculateTimezoneByValue(timeZone, startDate) - calculateTimezoneByValue(timeZone, endDate)
        };
        var getCorrectedDateByDaylightOffsets = function(convertedOriginalStartDate, convertedDate, date, timeZone, startDateTimezone) {
            var daylightOffsetByCommonTimezone = _getDaylightOffsetByTimezone(convertedOriginalStartDate, convertedDate, timeZone);
            var daylightOffsetByAppointmentTimezone = _getDaylightOffsetByTimezone(convertedOriginalStartDate, convertedDate, startDateTimezone);
            var diff = daylightOffsetByCommonTimezone - daylightOffsetByAppointmentTimezone;
            return new Date(date.getTime() - diff * toMs("hour"))
        };
        var correctRecurrenceExceptionByTimezone = function(exception, exceptionByStartDate, timeZone, startDateTimeZone) {
            var isBackConversion = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : false;
            var timezoneOffset = (exception.getTimezoneOffset() - exceptionByStartDate.getTimezoneOffset()) / MINUTES_IN_HOUR;
            if (startDateTimeZone) {
                timezoneOffset = _getDaylightOffsetByTimezone(exceptionByStartDate, exception, startDateTimeZone)
            } else {
                if (timeZone) {
                    timezoneOffset = _getDaylightOffsetByTimezone(exceptionByStartDate, exception, timeZone)
                }
            }
            return new Date(exception.getTime() + (isBackConversion ? -1 : 1) * timezoneOffset * toMs("hour"))
        };
        var isTimezoneChangeInDate = function(date) {
            var startDayDate = new Date(new Date(date).setHours(0, 0, 0, 0));
            var endDayDate = new Date(new Date(date).setHours(23, 59, 59, 0));
            return startDayDate.getTimezoneOffset() - endDayDate.getTimezoneOffset() !== 0
        };
        var getDateWithoutTimezoneChange = function(date) {
            var clonedDate = new Date(date);
            if (isTimezoneChangeInDate(clonedDate)) {
                var result = new Date(clonedDate);
                return new Date(result.setDate(result.getDate() + 1))
            }
            return clonedDate
        };
        var isSameAppointmentDates = function(startDate, endDate) {
            endDate = new Date(endDate.getTime() - 1);
            return _date.default.sameDate(startDate, endDate)
        };
        var getClientTimezoneOffset = function() {
            var date = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Date;
            return 6e4 * date.getTimezoneOffset()
        };
        var isEqualLocalTimeZone = function(timeZoneName) {
            var date = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Date;
            if (Intl) {
                var localTimeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
                if (localTimeZoneName === timeZoneName) {
                    return true
                }
            }
            return isEqualLocalTimeZoneByDeclaration(timeZoneName, date)
        };
        var hasDSTInLocalTimeZone = function() {
            var _getExtremeDates = getExtremeDates(),
                _getExtremeDates2 = _slicedToArray(_getExtremeDates, 2),
                startDate = _getExtremeDates2[0],
                endDate = _getExtremeDates2[1];
            return startDate.getTimezoneOffset() !== endDate.getTimezoneOffset()
        };
        var isEqualLocalTimeZoneByDeclaration = function(timeZoneName, date) {
            var year = date.getFullYear();
            var getOffset = function(date) {
                return -date.getTimezoneOffset() / 60
            };
            var getDateAndMoveHourBack = function(dateStamp) {
                return new Date(dateStamp - 36e5)
            };
            var configTuple = _utils.default.getTimeZoneDeclarationTuple(timeZoneName, year);
            var _configTuple = _slicedToArray(configTuple, 2),
                summerTime = _configTuple[0],
                winterTime = _configTuple[1];
            var noDSTInTargetTimeZone = 0 === configTuple.length;
            if (noDSTInTargetTimeZone) {
                var targetTimeZoneOffset = _utils.default.getTimeZoneOffsetById(timeZoneName, date);
                var localTimeZoneOffset = getOffset(date);
                if (targetTimeZoneOffset !== localTimeZoneOffset) {
                    return false
                }
                return hasDSTInLocalTimeZone() ? false : true
            }
            var localSummerOffset = getOffset(new Date(summerTime.date));
            var localWinterOffset = getOffset(new Date(winterTime.date));
            if (localSummerOffset !== summerTime.offset) {
                return false
            }
            if (localSummerOffset === getOffset(getDateAndMoveHourBack(summerTime.date))) {
                return false
            }
            if (localWinterOffset !== winterTime.offset) {
                return false
            }
            if (localWinterOffset === getOffset(getDateAndMoveHourBack(winterTime.date))) {
                return false
            }
            return true
        };
        var getExtremeDates = function() {
            var nowDate = new Date(Date.now());
            var startDate = new Date;
            var endDate = new Date;
            startDate.setFullYear(nowDate.getFullYear(), 0, 1);
            endDate.setFullYear(nowDate.getFullYear(), 6, 1);
            return [startDate, endDate]
        };
        var utils = {
            getDaylightOffset: getDaylightOffset,
            getDaylightOffsetInMs: getDaylightOffsetInMs,
            getTimezoneOffsetChangeInMinutes: getTimezoneOffsetChangeInMinutes,
            getTimezoneOffsetChangeInMs: getTimezoneOffsetChangeInMs,
            calculateTimezoneByValue: calculateTimezoneByValue,
            getCorrectedDateByDaylightOffsets: getCorrectedDateByDaylightOffsets,
            isSameAppointmentDates: isSameAppointmentDates,
            correctRecurrenceExceptionByTimezone: correctRecurrenceExceptionByTimezone,
            getClientTimezoneOffset: getClientTimezoneOffset,
            createUTCDateWithLocalOffset: createUTCDateWithLocalOffset,
            createDateFromUTCWithLocalOffset: createDateFromUTCWithLocalOffset,
            createUTCDate: createUTCDate,
            isTimezoneChangeInDate: isTimezoneChangeInDate,
            getDateWithoutTimezoneChange: getDateWithoutTimezoneChange,
            hasDSTInLocalTimeZone: hasDSTInLocalTimeZone,
            isEqualLocalTimeZone: isEqualLocalTimeZone,
            isEqualLocalTimeZoneByDeclaration: isEqualLocalTimeZoneByDeclaration,
            getTimeZones: getTimeZones
        };
        var _default = utils;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/localization/core.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _dependency_injector = _interopRequireDefault(__webpack_require__( /*! ../core/utils/dependency_injector */ 58));
        var _parent_locales = _interopRequireDefault(__webpack_require__( /*! ./cldr-data/parent_locales */ 495));
        var _parentLocale = _interopRequireDefault(__webpack_require__( /*! ./parentLocale */ 496));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DEFAULT_LOCALE = "en";
        var _default = (0, _dependency_injector.default)({
            locale: function() {
                var currentLocale = DEFAULT_LOCALE;
                return function(locale) {
                    if (!locale) {
                        return currentLocale
                    }
                    currentLocale = locale
                }
            }(),
            getValueByClosestLocale: function(getter) {
                var locale = this.locale();
                var value = getter(locale);
                var isRootLocale;
                while (!value && !isRootLocale) {
                    locale = (0, _parentLocale.default)(_parent_locales.default, locale);
                    if (locale) {
                        value = getter(locale)
                    } else {
                        isRootLocale = true
                    }
                }
                if (void 0 === value && locale !== DEFAULT_LOCALE) {
                    return getter(DEFAULT_LOCALE)
                }
                return value
            }
        });
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/exporter/excel/excel.tag_helper.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var tagHelper = {
            toXml: function(tagName, attributes, content) {
                var result = ["<", tagName];
                for (var attributeName in attributes) {
                    var attributeValue = attributes[attributeName];
                    if ((0, _type.isDefined)(attributeValue)) {
                        result.push(" ", attributeName, '="', attributeValue, '"')
                    }
                }
                if ((0, _type.isDefined)(content) && "" !== content) {
                    result.push(">", content, "</", tagName, ">")
                } else {
                    result.push(" />")
                }
                return result.join("")
            }
        };
        var _default = tagHelper;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/jquery/use_jquery.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = _default;
        var _jquery = _interopRequireDefault(__webpack_require__( /*! jquery */ 60));
        var _config = _interopRequireDefault(__webpack_require__( /*! ../../core/config */ 31));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var useJQuery = (0, _config.default)().useJQuery;
        if (_jquery.default && false !== useJQuery) {
            (0, _config.default)({
                useJQuery: true
            })
        }

        function _default() {
            return _jquery.default && (0, _config.default)().useJQuery
        }
        module.exports = exports.default
    },
    /*!****************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scroll_view.js ***!
      \****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./scroll_view/ui.scroll_view */ 602));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _ui.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/core/templates/empty_template.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.EmptyTemplate = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../renderer */ 2));
        var _template_base = __webpack_require__( /*! ./template_base */ 75);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var EmptyTemplate = function(_TemplateBase) {
            _inheritsLoose(EmptyTemplate, _TemplateBase);

            function EmptyTemplate() {
                return _TemplateBase.apply(this, arguments) || this
            }
            var _proto = EmptyTemplate.prototype;
            _proto._renderCore = function() {
                return (0, _renderer.default)()
            };
            return EmptyTemplate
        }(_template_base.TemplateBase);
        exports.EmptyTemplate = EmptyTemplate
    },
    /*!*************************************************!*\
      !*** ./artifacts/transpiled-npm/data_helper.js ***!
      \*************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _data_source = __webpack_require__( /*! ./data/data_source/data_source */ 68);
        var _extend = __webpack_require__( /*! ./core/utils/extend */ 0);
        var _utils = __webpack_require__( /*! ./data/data_source/utils */ 69);
        var DATA_SOURCE_OPTIONS_METHOD = "_dataSourceOptions";
        var DATA_SOURCE_CHANGED_METHOD = "_dataSourceChangedHandler";
        var DATA_SOURCE_LOAD_ERROR_METHOD = "_dataSourceLoadErrorHandler";
        var DATA_SOURCE_LOADING_CHANGED_METHOD = "_dataSourceLoadingChangedHandler";
        var DATA_SOURCE_FROM_URL_LOAD_MODE_METHOD = "_dataSourceFromUrlLoadMode";
        var SPECIFIC_DATA_SOURCE_OPTION = "_getSpecificDataSourceOption";
        var NORMALIZE_DATA_SOURCE = "_normalizeDataSource";
        var DataHelperMixin = {
            postCtor: function() {
                this.on("disposing", function() {
                    this._disposeDataSource()
                }.bind(this))
            },
            _refreshDataSource: function() {
                this._initDataSource();
                this._loadDataSource()
            },
            _initDataSource: function() {
                var dataSourceOptions = SPECIFIC_DATA_SOURCE_OPTION in this ? this[SPECIFIC_DATA_SOURCE_OPTION]() : this.option("dataSource");
                var widgetDataSourceOptions;
                var dataSourceType;
                this._disposeDataSource();
                if (dataSourceOptions) {
                    if (dataSourceOptions instanceof _data_source.DataSource) {
                        this._isSharedDataSource = true;
                        this._dataSource = dataSourceOptions
                    } else {
                        widgetDataSourceOptions = DATA_SOURCE_OPTIONS_METHOD in this ? this[DATA_SOURCE_OPTIONS_METHOD]() : {};
                        dataSourceType = this._dataSourceType ? this._dataSourceType() : _data_source.DataSource;
                        dataSourceOptions = (0, _utils.normalizeDataSourceOptions)(dataSourceOptions, {
                            fromUrlLoadMode: DATA_SOURCE_FROM_URL_LOAD_MODE_METHOD in this && this[DATA_SOURCE_FROM_URL_LOAD_MODE_METHOD]()
                        });
                        this._dataSource = new dataSourceType((0, _extend.extend)(true, {}, widgetDataSourceOptions, dataSourceOptions))
                    }
                    if (NORMALIZE_DATA_SOURCE in this) {
                        this._dataSource = this[NORMALIZE_DATA_SOURCE](this._dataSource)
                    }
                    this._addDataSourceHandlers()
                }
            },
            _addDataSourceHandlers: function() {
                if (DATA_SOURCE_CHANGED_METHOD in this) {
                    this._addDataSourceChangeHandler()
                }
                if (DATA_SOURCE_LOAD_ERROR_METHOD in this) {
                    this._addDataSourceLoadErrorHandler()
                }
                if (DATA_SOURCE_LOADING_CHANGED_METHOD in this) {
                    this._addDataSourceLoadingChangedHandler()
                }
                this._addReadyWatcher()
            },
            _addReadyWatcher: function() {
                this._dataSource.on("loadingChanged", function(isLoading) {
                    this._ready && this._ready(!isLoading)
                }.bind(this))
            },
            _addDataSourceChangeHandler: function() {
                var dataSource = this._dataSource;
                this._proxiedDataSourceChangedHandler = function(e) {
                    this[DATA_SOURCE_CHANGED_METHOD](dataSource.items(), e)
                }.bind(this);
                dataSource.on("changed", this._proxiedDataSourceChangedHandler)
            },
            _addDataSourceLoadErrorHandler: function() {
                this._proxiedDataSourceLoadErrorHandler = this[DATA_SOURCE_LOAD_ERROR_METHOD].bind(this);
                this._dataSource.on("loadError", this._proxiedDataSourceLoadErrorHandler)
            },
            _addDataSourceLoadingChangedHandler: function() {
                this._proxiedDataSourceLoadingChangedHandler = this[DATA_SOURCE_LOADING_CHANGED_METHOD].bind(this);
                this._dataSource.on("loadingChanged", this._proxiedDataSourceLoadingChangedHandler)
            },
            _loadDataSource: function() {
                if (this._dataSource) {
                    var dataSource = this._dataSource;
                    if (dataSource.isLoaded()) {
                        this._proxiedDataSourceChangedHandler && this._proxiedDataSourceChangedHandler()
                    } else {
                        dataSource.load()
                    }
                }
            },
            _loadSingle: function(key, value) {
                key = "this" === key ? this._dataSource.key() || "this" : key;
                return this._dataSource.loadSingle(key, value)
            },
            _isLastPage: function() {
                return !this._dataSource || this._dataSource.isLastPage() || !this._dataSource._pageSize
            },
            _isDataSourceLoading: function() {
                return this._dataSource && this._dataSource.isLoading()
            },
            _disposeDataSource: function() {
                if (this._dataSource) {
                    if (this._isSharedDataSource) {
                        delete this._isSharedDataSource;
                        this._proxiedDataSourceChangedHandler && this._dataSource.off("changed", this._proxiedDataSourceChangedHandler);
                        this._proxiedDataSourceLoadErrorHandler && this._dataSource.off("loadError", this._proxiedDataSourceLoadErrorHandler);
                        this._proxiedDataSourceLoadingChangedHandler && this._dataSource.off("loadingChanged", this._proxiedDataSourceLoadingChangedHandler)
                    } else {
                        this._dataSource.dispose()
                    }
                    delete this._dataSource;
                    delete this._proxiedDataSourceChangedHandler;
                    delete this._proxiedDataSourceLoadErrorHandler;
                    delete this._proxiedDataSourceLoadingChangedHandler
                }
            },
            getDataSource: function() {
                return this._dataSource || null
            }
        };
        var _default = DataHelperMixin;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************!*\
      !*** ./artifacts/transpiled-npm/data/array_utils.js ***!
      \******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.applyBatch = applyBatch;
        exports.createObjectWithChanges = createObjectWithChanges;
        exports.update = update;
        exports.insert = insert;
        exports.remove = remove;
        exports.indexByKey = indexByKey;
        exports.applyChanges = applyChanges;
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _config = _interopRequireDefault(__webpack_require__( /*! ../core/config */ 31));
        var _guid = _interopRequireDefault(__webpack_require__( /*! ../core/guid */ 36));
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _errors = _interopRequireDefault(__webpack_require__( /*! ./errors */ 38));
        var _object = __webpack_require__( /*! ../core/utils/object */ 51);
        var _data = __webpack_require__( /*! ../core/utils/data */ 20);
        var _utils = _interopRequireDefault(__webpack_require__( /*! ./utils */ 41));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }

        function hasKey(target, keyOrKeys) {
            var key;
            var keys = "string" === typeof keyOrKeys ? keyOrKeys.split() : keyOrKeys.slice();
            while (keys.length) {
                key = keys.shift();
                if (key in target) {
                    return true
                }
            }
            return false
        }

        function findItems(keyInfo, items, key, groupCount) {
            var childItems;
            var result;
            if (groupCount) {
                for (var i = 0; i < items.length; i++) {
                    childItems = items[i].items || items[i].collapsedItems || [];
                    result = findItems(keyInfo, childItems || [], key, groupCount - 1);
                    if (result) {
                        return result
                    }
                }
            } else {
                if (indexByKey(keyInfo, items, key) >= 0) {
                    return items
                }
            }
        }

        function getItems(keyInfo, items, key, groupCount) {
            if (groupCount) {
                return findItems(keyInfo, items, key, groupCount) || []
            }
            return items
        }

        function generateDataByKeyMap(keyInfo, array) {
            if (keyInfo.key() && (!array._dataByKeyMap || array._dataByKeyMapLength !== array.length)) {
                var dataByKeyMap = {};
                var arrayLength = array.length;
                for (var i = 0; i < arrayLength; i++) {
                    dataByKeyMap[JSON.stringify(keyInfo.keyOf(array[i]))] = array[i]
                }
                array._dataByKeyMap = dataByKeyMap;
                array._dataByKeyMapLength = arrayLength
            }
        }

        function getCacheValue(array, key) {
            if (array._dataByKeyMap) {
                return array._dataByKeyMap[JSON.stringify(key)]
            }
        }

        function getHasKeyCacheValue(array, key) {
            if (array._dataByKeyMap) {
                return array._dataByKeyMap[JSON.stringify(key)]
            }
            return true
        }

        function setDataByKeyMapValue(array, key, data) {
            if (array._dataByKeyMap) {
                array._dataByKeyMap[JSON.stringify(key)] = data;
                array._dataByKeyMapLength += data ? 1 : -1
            }
        }

        function createObjectWithChanges(target, changes) {
            var result = target ? Object.create(Object.getPrototypeOf(target)) : {};
            var targetWithoutPrototype = (0, _extend.extendFromObject)({}, target);
            (0, _object.deepExtendArraySafe)(result, targetWithoutPrototype, true, true);
            return (0, _object.deepExtendArraySafe)(result, changes, true, true)
        }

        function applyBatch(_ref) {
            var keyInfo = _ref.keyInfo,
                data = _ref.data,
                changes = _ref.changes,
                groupCount = _ref.groupCount,
                useInsertIndex = _ref.useInsertIndex,
                immutable = _ref.immutable,
                disableCache = _ref.disableCache,
                logError = _ref.logError;
            var resultItems = true === immutable ? _toConsumableArray(data) : data;
            changes.forEach(function(item) {
                var items = "insert" === item.type ? resultItems : getItems(keyInfo, resultItems, item.key, groupCount);
                !disableCache && generateDataByKeyMap(keyInfo, items);
                switch (item.type) {
                    case "update":
                        update(keyInfo, items, item.key, item.data, true, immutable, logError);
                        break;
                    case "insert":
                        insert(keyInfo, items, item.data, useInsertIndex && (0, _type.isDefined)(item.index) ? item.index : -1, true, logError);
                        break;
                    case "remove":
                        remove(keyInfo, items, item.key, true, logError)
                }
            });
            return resultItems
        }

        function getErrorResult(isBatch, logError, errorCode) {
            return !isBatch ? _utils.default.rejectedPromise(_errors.default.errors.Error(errorCode)) : logError && _errors.default.errors.log(errorCode)
        }

        function applyChanges(data, changes) {
            var options = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            var _options$keyExpr = options.keyExpr,
                keyExpr = void 0 === _options$keyExpr ? "id" : _options$keyExpr,
                _options$immutable = options.immutable,
                immutable = void 0 === _options$immutable ? true : _options$immutable;
            var keyGetter = (0, _data.compileGetter)(keyExpr);
            var keyInfo = {
                key: function() {
                    return keyExpr
                },
                keyOf: function(obj) {
                    return keyGetter(obj)
                }
            };
            return applyBatch({
                keyInfo: keyInfo,
                data: data,
                changes: changes,
                immutable: immutable,
                disableCache: true,
                logError: true
            })
        }

        function update(keyInfo, array, key, data, isBatch, immutable, logError) {
            var target;
            var extendComplexObject = true;
            var keyExpr = keyInfo.key();
            if (keyExpr) {
                if (hasKey(data, keyExpr) && !_utils.default.keysEqual(keyExpr, key, keyInfo.keyOf(data))) {
                    return getErrorResult(isBatch, logError, "E4017")
                }
                target = getCacheValue(array, key);
                if (!target) {
                    var index = indexByKey(keyInfo, array, key);
                    if (index < 0) {
                        return getErrorResult(isBatch, logError, "E4009")
                    }
                    target = array[index];
                    if (true === immutable && (0, _type.isDefined)(target)) {
                        var newTarget = createObjectWithChanges(target, data);
                        array[index] = newTarget;
                        return !isBatch && _utils.default.trivialPromise(newTarget, key)
                    }
                }
            } else {
                target = key
            }(0, _object.deepExtendArraySafe)(target, data, extendComplexObject);
            if (!isBatch) {
                if ((0, _config.default)().useLegacyStoreResult) {
                    return _utils.default.trivialPromise(key, data)
                } else {
                    return _utils.default.trivialPromise(target, key)
                }
            }
        }

        function insert(keyInfo, array, data, index, isBatch, logError) {
            var keyValue;
            var keyExpr = keyInfo.key();
            var obj = (0, _type.isPlainObject)(data) ? (0, _extend.extend)({}, data) : data;
            if (keyExpr) {
                keyValue = keyInfo.keyOf(obj);
                if (void 0 === keyValue || "object" === _typeof(keyValue) && (0, _type.isEmptyObject)(keyValue)) {
                    if (Array.isArray(keyExpr)) {
                        throw _errors.default.errors.Error("E4007")
                    }
                    keyValue = obj[keyExpr] = String(new _guid.default)
                } else {
                    if (void 0 !== array[indexByKey(keyInfo, array, keyValue)]) {
                        return getErrorResult(isBatch, logError, "E4008")
                    }
                }
            } else {
                keyValue = obj
            }
            if (index >= 0) {
                array.splice(index, 0, obj)
            } else {
                array.push(obj)
            }
            setDataByKeyMapValue(array, keyValue, obj);
            if (!isBatch) {
                return _utils.default.trivialPromise((0, _config.default)().useLegacyStoreResult ? data : obj, keyValue)
            }
        }

        function remove(keyInfo, array, key, isBatch, logError) {
            var index = indexByKey(keyInfo, array, key);
            if (index > -1) {
                array.splice(index, 1);
                setDataByKeyMapValue(array, key, null)
            }
            if (!isBatch) {
                return _utils.default.trivialPromise(key)
            } else {
                if (index < 0) {
                    return getErrorResult(isBatch, logError, "E4009")
                }
            }
        }

        function indexByKey(keyInfo, array, key) {
            var keyExpr = keyInfo.key();
            if (!getHasKeyCacheValue(array, key)) {
                return -1
            }
            for (var i = 0, arrayLength = array.length; i < arrayLength; i++) {
                if (_utils.default.keysEqual(keyExpr, keyInfo.keyOf(array[i]), key)) {
                    return i
                }
            }
            return -1
        }
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/data/store_helper.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _array_query = _interopRequireDefault(__webpack_require__( /*! ./array_query */ 168));
        var _utils = _interopRequireDefault(__webpack_require__( /*! ./utils */ 41));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function multiLevelGroup(query, groupInfo) {
            query = query.groupBy(groupInfo[0].selector);
            if (groupInfo.length > 1) {
                query = query.select(function(g) {
                    return (0, _extend.extend)({}, g, {
                        items: multiLevelGroup((0, _array_query.default)(g.items), groupInfo.slice(1)).toArray()
                    })
                })
            }
            return query
        }

        function arrangeSortingInfo(groupInfo, sortInfo) {
            var filteredGroup = [];
            (0, _iterator.each)(groupInfo, function(_, group) {
                var collision = (0, _common.grep)(sortInfo, function(sort) {
                    return group.selector === sort.selector
                });
                if (collision.length < 1) {
                    filteredGroup.push(group)
                }
            });
            return filteredGroup.concat(sortInfo)
        }

        function queryByOptions(query, options, isCountQuery) {
            options = options || {};
            var filter = options.filter;
            if (filter) {
                query = query.filter(filter)
            }
            if (isCountQuery) {
                return query
            }
            var sort = options.sort;
            var select = options.select;
            var group = options.group;
            var skip = options.skip;
            var take = options.take;
            if (group) {
                group = _utils.default.normalizeSortingInfo(group);
                group.keepInitialKeyOrder = !!options.group.keepInitialKeyOrder
            }
            if (sort || group) {
                sort = _utils.default.normalizeSortingInfo(sort || []);
                if (group && !group.keepInitialKeyOrder) {
                    sort = arrangeSortingInfo(group, sort)
                }(0, _iterator.each)(sort, function(index) {
                    query = query[index ? "thenBy" : "sortBy"](this.selector, this.desc, this.compare)
                })
            }
            if (select) {
                query = query.select(select)
            }
            if (group) {
                query = multiLevelGroup(query, group)
            }
            if (take || skip) {
                query = query.slice(skip || 0, take)
            }
            return query
        }
        var _default = {
            multiLevelGroup: multiLevelGroup,
            arrangeSortingInfo: arrangeSortingInfo,
            queryByOptions: queryByOptions
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************!*\
      !*** ./artifacts/transpiled-npm/color.js ***!
      \*******************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var standardColorNames = {
            aliceblue: "f0f8ff",
            antiquewhite: "faebd7",
            aqua: "00ffff",
            aquamarine: "7fffd4",
            azure: "f0ffff",
            beige: "f5f5dc",
            bisque: "ffe4c4",
            black: "000000",
            blanchedalmond: "ffebcd",
            blue: "0000ff",
            blueviolet: "8a2be2",
            brown: "a52a2a",
            burlywood: "deb887",
            cadetblue: "5f9ea0",
            chartreuse: "7fff00",
            chocolate: "d2691e",
            coral: "ff7f50",
            cornflowerblue: "6495ed",
            cornsilk: "fff8dc",
            crimson: "dc143c",
            cyan: "00ffff",
            darkblue: "00008b",
            darkcyan: "008b8b",
            darkgoldenrod: "b8860b",
            darkgray: "a9a9a9",
            darkgreen: "006400",
            darkkhaki: "bdb76b",
            darkmagenta: "8b008b",
            darkolivegreen: "556b2f",
            darkorange: "ff8c00",
            darkorchid: "9932cc",
            darkred: "8b0000",
            darksalmon: "e9967a",
            darkseagreen: "8fbc8f",
            darkslateblue: "483d8b",
            darkslategray: "2f4f4f",
            darkturquoise: "00ced1",
            darkviolet: "9400d3",
            deeppink: "ff1493",
            deepskyblue: "00bfff",
            dimgray: "696969",
            dodgerblue: "1e90ff",
            feldspar: "d19275",
            firebrick: "b22222",
            floralwhite: "fffaf0",
            forestgreen: "228b22",
            fuchsia: "ff00ff",
            gainsboro: "dcdcdc",
            ghostwhite: "f8f8ff",
            gold: "ffd700",
            goldenrod: "daa520",
            gray: "808080",
            green: "008000",
            greenyellow: "adff2f",
            honeydew: "f0fff0",
            hotpink: "ff69b4",
            indianred: "cd5c5c",
            indigo: "4b0082",
            ivory: "fffff0",
            khaki: "f0e68c",
            lavender: "e6e6fa",
            lavenderblush: "fff0f5",
            lawngreen: "7cfc00",
            lemonchiffon: "fffacd",
            lightblue: "add8e6",
            lightcoral: "f08080",
            lightcyan: "e0ffff",
            lightgoldenrodyellow: "fafad2",
            lightgrey: "d3d3d3",
            lightgreen: "90ee90",
            lightpink: "ffb6c1",
            lightsalmon: "ffa07a",
            lightseagreen: "20b2aa",
            lightskyblue: "87cefa",
            lightslateblue: "8470ff",
            lightslategray: "778899",
            lightsteelblue: "b0c4de",
            lightyellow: "ffffe0",
            lime: "00ff00",
            limegreen: "32cd32",
            linen: "faf0e6",
            magenta: "ff00ff",
            maroon: "800000",
            mediumaquamarine: "66cdaa",
            mediumblue: "0000cd",
            mediumorchid: "ba55d3",
            mediumpurple: "9370d8",
            mediumseagreen: "3cb371",
            mediumslateblue: "7b68ee",
            mediumspringgreen: "00fa9a",
            mediumturquoise: "48d1cc",
            mediumvioletred: "c71585",
            midnightblue: "191970",
            mintcream: "f5fffa",
            mistyrose: "ffe4e1",
            moccasin: "ffe4b5",
            navajowhite: "ffdead",
            navy: "000080",
            oldlace: "fdf5e6",
            olive: "808000",
            olivedrab: "6b8e23",
            orange: "ffa500",
            orangered: "ff4500",
            orchid: "da70d6",
            palegoldenrod: "eee8aa",
            palegreen: "98fb98",
            paleturquoise: "afeeee",
            palevioletred: "d87093",
            papayawhip: "ffefd5",
            peachpuff: "ffdab9",
            peru: "cd853f",
            pink: "ffc0cb",
            plum: "dda0dd",
            powderblue: "b0e0e6",
            purple: "800080",
            rebeccapurple: "663399",
            red: "ff0000",
            rosybrown: "bc8f8f",
            royalblue: "4169e1",
            saddlebrown: "8b4513",
            salmon: "fa8072",
            sandybrown: "f4a460",
            seagreen: "2e8b57",
            seashell: "fff5ee",
            sienna: "a0522d",
            silver: "c0c0c0",
            skyblue: "87ceeb",
            slateblue: "6a5acd",
            slategray: "708090",
            snow: "fffafa",
            springgreen: "00ff7f",
            steelblue: "4682b4",
            tan: "d2b48c",
            teal: "008080",
            thistle: "d8bfd8",
            tomato: "ff6347",
            turquoise: "40e0d0",
            violet: "ee82ee",
            violetred: "d02090",
            wheat: "f5deb3",
            white: "ffffff",
            whitesmoke: "f5f5f5",
            yellow: "ffff00",
            yellowgreen: "9acd32"
        };
        var standardColorTypes = [{
            re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
            process: function(colorString) {
                return [parseInt(colorString[1], 10), parseInt(colorString[2], 10), parseInt(colorString[3], 10)]
            }
        }, {
            re: /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*(\d*\.*\d+)\)$/,
            process: function(colorString) {
                return [parseInt(colorString[1], 10), parseInt(colorString[2], 10), parseInt(colorString[3], 10), parseFloat(colorString[4])]
            }
        }, {
            re: /^#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})$/,
            process: function(colorString) {
                return [parseInt(colorString[1], 16), parseInt(colorString[2], 16), parseInt(colorString[3], 16)]
            }
        }, {
            re: /^#([a-f0-9]{1})([a-f0-9]{1})([a-f0-9]{1})$/,
            process: function(colorString) {
                return [parseInt(colorString[1] + colorString[1], 16), parseInt(colorString[2] + colorString[2], 16), parseInt(colorString[3] + colorString[3], 16)]
            }
        }, {
            re: /^hsv\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
            process: function(colorString) {
                var h = parseInt(colorString[1], 10);
                var s = parseInt(colorString[2], 10);
                var v = parseInt(colorString[3], 10);
                var rgb = hsvToRgb(h, s, v);
                return [rgb[0], rgb[1], rgb[2], 1, [h, s, v]]
            }
        }, {
            re: /^hsl\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
            process: function(colorString) {
                var h = parseInt(colorString[1], 10);
                var s = parseInt(colorString[2], 10);
                var l = parseInt(colorString[3], 10);
                var rgb = hslToRgb(h, s, l);
                return [rgb[0], rgb[1], rgb[2], 1, null, [h, s, l]]
            }
        }];
        var _round = Math.round;

        function Color(value) {
            this.baseColor = value;
            var color;
            if (value) {
                color = String(value).toLowerCase().replace(/ /g, "");
                color = standardColorNames[color] ? "#" + standardColorNames[color] : color;
                color = parseColor(color)
            }
            if (!color) {
                this.colorIsInvalid = true
            }
            color = color || {};
            this.r = normalize(color[0]);
            this.g = normalize(color[1]);
            this.b = normalize(color[2]);
            this.a = normalize(color[3], 1, 1);
            if (color[4]) {
                this.hsv = {
                    h: color[4][0],
                    s: color[4][1],
                    v: color[4][2]
                }
            } else {
                this.hsv = toHsvFromRgb(this.r, this.g, this.b)
            }
            if (color[5]) {
                this.hsl = {
                    h: color[5][0],
                    s: color[5][1],
                    l: color[5][2]
                }
            } else {
                this.hsl = toHslFromRgb(this.r, this.g, this.b)
            }
        }

        function parseColor(color) {
            if ("transparent" === color) {
                return [0, 0, 0, 0]
            }
            var i = 0;
            var ii = standardColorTypes.length;
            var str;
            for (; i < ii; ++i) {
                str = standardColorTypes[i].re.exec(color);
                if (str) {
                    return standardColorTypes[i].process(str)
                }
            }
            return null
        }

        function normalize(colorComponent, def, max) {
            def = def || 0;
            max = max || 255;
            return colorComponent < 0 || isNaN(colorComponent) ? def : colorComponent > max ? max : colorComponent
        }

        function toHexFromRgb(r, g, b) {
            return "#" + (16777216 | r << 16 | g << 8 | b).toString(16).slice(1)
        }

        function toHsvFromRgb(r, g, b) {
            var max = Math.max(r, g, b);
            var min = Math.min(r, g, b);
            var delta = max - min;
            var H;
            var S;
            var V = max;
            S = 0 === max ? 0 : 1 - min / max;
            if (max === min) {
                H = 0
            } else {
                switch (max) {
                    case r:
                        H = 60 * ((g - b) / delta);
                        if (g < b) {
                            H += 360
                        }
                        break;
                    case g:
                        H = 60 * ((b - r) / delta) + 120;
                        break;
                    case b:
                        H = 60 * ((r - g) / delta) + 240
                }
            }
            S *= 100;
            V *= 100 / 255;
            return {
                h: Math.round(H),
                s: Math.round(S),
                v: Math.round(V)
            }
        }

        function hsvToRgb(h, s, v) {
            var index = Math.floor(h % 360 / 60);
            var vMin = (100 - s) * v / 100;
            var a = (v - vMin) * (h % 60 / 60);
            var vInc = vMin + a;
            var vDec = v - a;
            var r;
            var g;
            var b;
            switch (index) {
                case 0:
                    r = v;
                    g = vInc;
                    b = vMin;
                    break;
                case 1:
                    r = vDec;
                    g = v;
                    b = vMin;
                    break;
                case 2:
                    r = vMin;
                    g = v;
                    b = vInc;
                    break;
                case 3:
                    r = vMin;
                    g = vDec;
                    b = v;
                    break;
                case 4:
                    r = vInc;
                    g = vMin;
                    b = v;
                    break;
                case 5:
                    r = v;
                    g = vMin;
                    b = vDec
            }
            return [Math.round(2.55 * r), Math.round(2.55 * g), Math.round(2.55 * b)]
        }

        function calculateHue(r, g, b, delta) {
            var max = Math.max(r, g, b);
            switch (max) {
                case r:
                    return (g - b) / delta + (g < b ? 6 : 0);
                case g:
                    return (b - r) / delta + 2;
                case b:
                    return (r - g) / delta + 4
            }
        }

        function toHslFromRgb(r, g, b) {
            r = convertTo01Bounds(r, 255);
            g = convertTo01Bounds(g, 255);
            b = convertTo01Bounds(b, 255);
            var max = Math.max(r, g, b);
            var min = Math.min(r, g, b);
            var maxMinSum = max + min;
            var h;
            var s;
            var l = maxMinSum / 2;
            if (max === min) {
                h = s = 0
            } else {
                var delta = max - min;
                if (l > .5) {
                    s = delta / (2 - maxMinSum)
                } else {
                    s = delta / maxMinSum
                }
                h = calculateHue(r, g, b, delta);
                h /= 6
            }
            return {
                h: _round(360 * h),
                s: _round(100 * s),
                l: _round(100 * l)
            }
        }

        function makeColorTint(colorPart, h) {
            var colorTint = h;
            if ("r" === colorPart) {
                colorTint = h + 1 / 3
            }
            if ("b" === colorPart) {
                colorTint = h - 1 / 3
            }
            return colorTint
        }

        function modifyColorTint(colorTint) {
            if (colorTint < 0) {
                colorTint += 1
            }
            if (colorTint > 1) {
                colorTint -= 1
            }
            return colorTint
        }

        function hueToRgb(p, q, colorTint) {
            colorTint = modifyColorTint(colorTint);
            if (colorTint < 1 / 6) {
                return p + 6 * (q - p) * colorTint
            }
            if (colorTint < .5) {
                return q
            }
            if (colorTint < 2 / 3) {
                return p + (q - p) * (2 / 3 - colorTint) * 6
            }
            return p
        }

        function hslToRgb(h, s, l) {
            var r;
            var g;
            var b;
            h = convertTo01Bounds(h, 360);
            s = convertTo01Bounds(s, 100);
            l = convertTo01Bounds(l, 100);
            if (0 === s) {
                r = g = b = l
            } else {
                var q = l < .5 ? l * (1 + s) : l + s - l * s;
                var p = 2 * l - q;
                r = hueToRgb(p, q, makeColorTint("r", h));
                g = hueToRgb(p, q, makeColorTint("g", h));
                b = hueToRgb(p, q, makeColorTint("b", h))
            }
            return [_round(255 * r), _round(255 * g), _round(255 * b)]
        }

        function convertTo01Bounds(n, max) {
            n = Math.min(max, Math.max(0, parseFloat(n)));
            if (Math.abs(n - max) < 1e-6) {
                return 1
            }
            return n % max / parseFloat(max)
        }

        function isIntegerBetweenMinAndMax(number, min, max) {
            min = min || 0;
            max = max || 255;
            if (number % 1 !== 0 || number < min || number > max || "number" !== typeof number || isNaN(number)) {
                return false
            }
            return true
        }
        Color.prototype = {
            constructor: Color,
            highlight: function(step) {
                step = step || 10;
                return this.alter(step).toHex()
            },
            darken: function(step) {
                step = step || 10;
                return this.alter(-step).toHex()
            },
            alter: function(step) {
                var result = new Color;
                result.r = normalize(this.r + step);
                result.g = normalize(this.g + step);
                result.b = normalize(this.b + step);
                return result
            },
            blend: function(blendColor, opacity) {
                var other = blendColor instanceof Color ? blendColor : new Color(blendColor);
                var result = new Color;
                result.r = normalize(_round(this.r * (1 - opacity) + other.r * opacity));
                result.g = normalize(_round(this.g * (1 - opacity) + other.g * opacity));
                result.b = normalize(_round(this.b * (1 - opacity) + other.b * opacity));
                return result
            },
            toHex: function() {
                return toHexFromRgb(this.r, this.g, this.b)
            },
            getPureColor: function() {
                var rgb = hsvToRgb(this.hsv.h, 100, 100);
                return new Color("rgb(" + rgb.join(",") + ")")
            },
            isValidHex: function(hex) {
                return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(hex)
            },
            isValidRGB: function(r, g, b) {
                if (!isIntegerBetweenMinAndMax(r) || !isIntegerBetweenMinAndMax(g) || !isIntegerBetweenMinAndMax(b)) {
                    return false
                }
                return true
            },
            isValidAlpha: function(a) {
                if (isNaN(a) || a < 0 || a > 1 || "number" !== typeof a) {
                    return false
                }
                return true
            },
            colorIsInvalid: false,
            fromHSL: function(hsl) {
                var color = new Color;
                var rgb = hslToRgb(hsl.h, hsl.s, hsl.l);
                color.r = rgb[0];
                color.g = rgb[1];
                color.b = rgb[2];
                return color
            }
        };
        var _default = Color;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/validation_engine.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _class = _interopRequireDefault(__webpack_require__( /*! ../core/class */ 15));
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _array = __webpack_require__( /*! ../core/utils/array */ 12);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _events_strategy = __webpack_require__( /*! ../core/events_strategy */ 100);
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../core/errors */ 25));
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _number = _interopRequireDefault(__webpack_require__( /*! ../localization/number */ 47));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../localization/message */ 10));
        var _promise = _interopRequireDefault(__webpack_require__( /*! ../core/polyfills/promise */ 73));
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var STATUS = {
            valid: "valid",
            invalid: "invalid",
            pending: "pending"
        };
        var BaseRuleValidator = function() {
            function BaseRuleValidator() {
                this.NAME = "base"
            }
            var _proto = BaseRuleValidator.prototype;
            _proto.defaultMessage = function(value) {
                return _message.default.getFormatter("validation-".concat(this.NAME))(value)
            };
            _proto.defaultFormattedMessage = function(value) {
                return _message.default.getFormatter("validation-".concat(this.NAME, "-formatted"))(value)
            };
            _proto._isValueEmpty = function(value) {
                return !rulesValidators.required.validate(value, {})
            };
            _proto.validate = function(value, rule) {
                var _this = this;
                var valueArray = Array.isArray(value) ? value : [value];
                var result = true;
                if (valueArray.length) {
                    valueArray.every(function(itemValue) {
                        result = _this._validate(itemValue, rule);
                        return result
                    })
                } else {
                    result = this._validate(null, rule)
                }
                return result
            };
            return BaseRuleValidator
        }();
        var RequiredRuleValidator = function(_BaseRuleValidator) {
            _inheritsLoose(RequiredRuleValidator, _BaseRuleValidator);

            function RequiredRuleValidator() {
                var _this2;
                _this2 = _BaseRuleValidator.call(this) || this;
                _this2.NAME = "required";
                return _this2
            }
            var _proto2 = RequiredRuleValidator.prototype;
            _proto2._validate = function(value, rule) {
                if (!(0, _type.isDefined)(value)) {
                    return false
                }
                if (false === value) {
                    return false
                }
                value = String(value);
                if (rule.trim || !(0, _type.isDefined)(rule.trim)) {
                    value = value.trim()
                }
                return "" !== value
            };
            return RequiredRuleValidator
        }(BaseRuleValidator);
        var NumericRuleValidator = function(_BaseRuleValidator2) {
            _inheritsLoose(NumericRuleValidator, _BaseRuleValidator2);

            function NumericRuleValidator() {
                var _this3;
                _this3 = _BaseRuleValidator2.call(this) || this;
                _this3.NAME = "numeric";
                return _this3
            }
            var _proto3 = NumericRuleValidator.prototype;
            _proto3._validate = function(value, rule) {
                if (false !== rule.ignoreEmptyValue && this._isValueEmpty(value)) {
                    return true
                }
                if (rule.useCultureSettings && (0, _type.isString)(value)) {
                    return !isNaN(_number.default.parse(value))
                } else {
                    return (0, _type.isNumeric)(value)
                }
            };
            return NumericRuleValidator
        }(BaseRuleValidator);
        var RangeRuleValidator = function(_BaseRuleValidator3) {
            _inheritsLoose(RangeRuleValidator, _BaseRuleValidator3);

            function RangeRuleValidator() {
                var _this4;
                _this4 = _BaseRuleValidator3.call(this) || this;
                _this4.NAME = "range";
                return _this4
            }
            var _proto4 = RangeRuleValidator.prototype;
            _proto4._validate = function(value, rule) {
                if (false !== rule.ignoreEmptyValue && this._isValueEmpty(value)) {
                    return true
                }
                var validNumber = rulesValidators.numeric.validate(value, rule);
                var validValue = (0, _type.isDefined)(value) && "" !== value;
                var number = validNumber ? parseFloat(value) : validValue && value.valueOf();
                var min = rule.min;
                var max = rule.max;
                if (!(validNumber || (0, _type.isDate)(value)) && !validValue) {
                    return false
                }
                if ((0, _type.isDefined)(min)) {
                    if ((0, _type.isDefined)(max)) {
                        return number >= min && number <= max
                    }
                    return number >= min
                } else {
                    if ((0, _type.isDefined)(max)) {
                        return number <= max
                    } else {
                        throw _errors.default.Error("E0101")
                    }
                }
            };
            return RangeRuleValidator
        }(BaseRuleValidator);
        var StringLengthRuleValidator = function(_BaseRuleValidator4) {
            _inheritsLoose(StringLengthRuleValidator, _BaseRuleValidator4);

            function StringLengthRuleValidator() {
                var _this5;
                _this5 = _BaseRuleValidator4.call(this) || this;
                _this5.NAME = "stringLength";
                return _this5
            }
            var _proto5 = StringLengthRuleValidator.prototype;
            _proto5._validate = function(value, rule) {
                var _value;
                value = String(null !== (_value = value) && void 0 !== _value ? _value : "");
                if (rule.trim || !(0, _type.isDefined)(rule.trim)) {
                    value = value.trim()
                }
                if (rule.ignoreEmptyValue && this._isValueEmpty(value)) {
                    return true
                }
                return rulesValidators.range.validate(value.length, (0, _extend.extend)({}, rule))
            };
            return StringLengthRuleValidator
        }(BaseRuleValidator);
        var CustomRuleValidator = function(_BaseRuleValidator5) {
            _inheritsLoose(CustomRuleValidator, _BaseRuleValidator5);

            function CustomRuleValidator() {
                var _this6;
                _this6 = _BaseRuleValidator5.call(this) || this;
                _this6.NAME = "custom";
                return _this6
            }
            var _proto6 = CustomRuleValidator.prototype;
            _proto6.validate = function(value, rule) {
                if (rule.ignoreEmptyValue && this._isValueEmpty(value)) {
                    return true
                }
                var validator = rule.validator;
                var dataGetter = validator && (0, _type.isFunction)(validator.option) && validator.option("dataGetter");
                var extraParams = (0, _type.isFunction)(dataGetter) && dataGetter();
                var params = {
                    value: value,
                    validator: validator,
                    rule: rule
                };
                if (extraParams) {
                    (0, _extend.extend)(params, extraParams)
                }
                return rule.validationCallback(params)
            };
            return CustomRuleValidator
        }(BaseRuleValidator);
        var AsyncRuleValidator = function(_CustomRuleValidator) {
            _inheritsLoose(AsyncRuleValidator, _CustomRuleValidator);

            function AsyncRuleValidator() {
                var _this7;
                _this7 = _CustomRuleValidator.call(this) || this;
                _this7.NAME = "async";
                return _this7
            }
            var _proto7 = AsyncRuleValidator.prototype;
            _proto7.validate = function(value, rule) {
                if (!(0, _type.isDefined)(rule.reevaluate)) {
                    (0, _extend.extend)(rule, {
                        reevaluate: true
                    })
                }
                if (rule.ignoreEmptyValue && this._isValueEmpty(value)) {
                    return true
                }
                var validator = rule.validator;
                var dataGetter = validator && (0, _type.isFunction)(validator.option) && validator.option("dataGetter");
                var extraParams = (0, _type.isFunction)(dataGetter) && dataGetter();
                var params = {
                    value: value,
                    validator: validator,
                    rule: rule
                };
                if (extraParams) {
                    (0, _extend.extend)(params, extraParams)
                }
                var callbackResult = rule.validationCallback(params);
                if (!(0, _type.isPromise)(callbackResult)) {
                    throw _errors.default.Error("E0103")
                }
                return this._getWrappedPromise((0, _deferred.fromPromise)(callbackResult).promise())
            };
            _proto7._getWrappedPromise = function(promise) {
                var deferred = new _deferred.Deferred;
                promise.then(function(res) {
                    deferred.resolve(res)
                }, function(err) {
                    var res = {
                        isValid: false
                    };
                    if ((0, _type.isDefined)(err)) {
                        if ((0, _type.isString)(err)) {
                            res.message = err
                        } else {
                            if ((0, _type.isObject)(err) && (0, _type.isDefined)(err.message) && (0, _type.isString)(err.message)) {
                                res.message = err.message
                            }
                        }
                    }
                    deferred.resolve(res)
                });
                return deferred.promise()
            };
            return AsyncRuleValidator
        }(CustomRuleValidator);
        var CompareRuleValidator = function(_BaseRuleValidator6) {
            _inheritsLoose(CompareRuleValidator, _BaseRuleValidator6);

            function CompareRuleValidator() {
                var _this8;
                _this8 = _BaseRuleValidator6.call(this) || this;
                _this8.NAME = "compare";
                return _this8
            }
            var _proto8 = CompareRuleValidator.prototype;
            _proto8._validate = function(value, rule) {
                if (!rule.comparisonTarget) {
                    throw _errors.default.Error("E0102")
                }
                if (rule.ignoreEmptyValue && this._isValueEmpty(value)) {
                    return true
                }(0, _extend.extend)(rule, {
                    reevaluate: true
                });
                var otherValue = rule.comparisonTarget();
                var type = rule.comparisonType || "==";
                switch (type) {
                    case "==":
                        return value == otherValue;
                    case "!=":
                        return value != otherValue;
                    case "===":
                        return value === otherValue;
                    case "!==":
                        return value !== otherValue;
                    case ">":
                        return value > otherValue;
                    case ">=":
                        return value >= otherValue;
                    case "<":
                        return value < otherValue;
                    case "<=":
                        return value <= otherValue
                }
            };
            return CompareRuleValidator
        }(BaseRuleValidator);
        var PatternRuleValidator = function(_BaseRuleValidator7) {
            _inheritsLoose(PatternRuleValidator, _BaseRuleValidator7);

            function PatternRuleValidator() {
                var _this9;
                _this9 = _BaseRuleValidator7.call(this) || this;
                _this9.NAME = "pattern";
                return _this9
            }
            var _proto9 = PatternRuleValidator.prototype;
            _proto9._validate = function(value, rule) {
                if (false !== rule.ignoreEmptyValue && this._isValueEmpty(value)) {
                    return true
                }
                var pattern = rule.pattern;
                if ((0, _type.isString)(pattern)) {
                    pattern = new RegExp(pattern)
                }
                return pattern.test(value)
            };
            return PatternRuleValidator
        }(BaseRuleValidator);
        var EmailRuleValidator = function(_BaseRuleValidator8) {
            _inheritsLoose(EmailRuleValidator, _BaseRuleValidator8);

            function EmailRuleValidator() {
                var _this10;
                _this10 = _BaseRuleValidator8.call(this) || this;
                _this10.NAME = "email";
                return _this10
            }
            var _proto10 = EmailRuleValidator.prototype;
            _proto10._validate = function(value, rule) {
                if (false !== rule.ignoreEmptyValue && this._isValueEmpty(value)) {
                    return true
                }
                return rulesValidators.pattern.validate(value, (0, _extend.extend)({}, rule, {
                    pattern: /^[\d\w._-]+@[\d\w._-]+\.[\w]+$/i
                }))
            };
            return EmailRuleValidator
        }(BaseRuleValidator);
        var rulesValidators = {
            required: new RequiredRuleValidator,
            numeric: new NumericRuleValidator,
            range: new RangeRuleValidator,
            stringLength: new StringLengthRuleValidator,
            custom: new CustomRuleValidator,
            async: new AsyncRuleValidator,
            compare: new CompareRuleValidator,
            pattern: new PatternRuleValidator,
            email: new EmailRuleValidator
        };
        var GroupConfig = _class.default.inherit({
            ctor: function(group) {
                this.group = group;
                this.validators = [];
                this._pendingValidators = [];
                this._onValidatorStatusChanged = this._onValidatorStatusChanged.bind(this);
                this._resetValidationInfo();
                this._eventsStrategy = new _events_strategy.EventsStrategy(this)
            },
            validate: function() {
                var _this11 = this;
                var result = {
                    isValid: true,
                    brokenRules: [],
                    validators: [],
                    status: STATUS.valid,
                    complete: null
                };
                this._unsubscribeFromAllChangeEvents();
                this._pendingValidators = [];
                this._resetValidationInfo();
                (0, _iterator.each)(this.validators, function(_, validator) {
                    var validatorResult = validator.validate();
                    result.isValid = result.isValid && validatorResult.isValid;
                    if (validatorResult.brokenRules) {
                        result.brokenRules = result.brokenRules.concat(validatorResult.brokenRules)
                    }
                    result.validators.push(validator);
                    if (validatorResult.status === STATUS.pending) {
                        _this11._addPendingValidator(validator)
                    }
                    _this11._subscribeToChangeEvents(validator)
                });
                if (this._pendingValidators.length) {
                    result.status = STATUS.pending
                } else {
                    result.status = result.isValid ? STATUS.valid : STATUS.invalid;
                    this._unsubscribeFromAllChangeEvents();
                    this._raiseValidatedEvent(result)
                }
                this._updateValidationInfo(result);
                return (0, _extend.extend)({}, this._validationInfo.result)
            },
            _subscribeToChangeEvents: function(validator) {
                validator.on("validating", this._onValidatorStatusChanged);
                validator.on("validated", this._onValidatorStatusChanged)
            },
            _unsubscribeFromChangeEvents: function(validator) {
                validator.off("validating", this._onValidatorStatusChanged);
                validator.off("validated", this._onValidatorStatusChanged)
            },
            _unsubscribeFromAllChangeEvents: function() {
                var _this12 = this;
                (0, _iterator.each)(this.validators, function(_, validator) {
                    _this12._unsubscribeFromChangeEvents(validator)
                })
            },
            _updateValidationInfo: function(result) {
                this._validationInfo.result = result;
                if (result.status !== STATUS.pending) {
                    return
                }
                if (!this._validationInfo.deferred) {
                    this._validationInfo.deferred = new _deferred.Deferred;
                    this._validationInfo.result.complete = this._validationInfo.deferred.promise()
                }
            },
            _addPendingValidator: function(validator) {
                var foundValidator = (0, _common.grep)(this._pendingValidators, function(val) {
                    return val === validator
                })[0];
                if (!foundValidator) {
                    this._pendingValidators.push(validator)
                }
            },
            _removePendingValidator: function(validator) {
                var index = (0, _array.inArray)(validator, this._pendingValidators);
                if (index >= 0) {
                    this._pendingValidators.splice(index, 1)
                }
            },
            _orderBrokenRules: function(brokenRules) {
                var orderedRules = [];
                (0, _iterator.each)(this.validators, function(_, validator) {
                    var foundRules = (0, _common.grep)(brokenRules, function(rule) {
                        return rule.validator === validator
                    });
                    if (foundRules.length) {
                        orderedRules = orderedRules.concat(foundRules)
                    }
                });
                return orderedRules
            },
            _updateBrokenRules: function(result) {
                if (!this._validationInfo.result) {
                    return
                }
                var brokenRules = this._validationInfo.result.brokenRules;
                var rules = (0, _common.grep)(brokenRules, function(rule) {
                    return rule.validator !== result.validator
                });
                if (result.brokenRules) {
                    brokenRules = rules.concat(result.brokenRules)
                }
                this._validationInfo.result.brokenRules = this._orderBrokenRules(brokenRules)
            },
            _onValidatorStatusChanged: function(result) {
                if (result.status === STATUS.pending) {
                    this._addPendingValidator(result.validator);
                    return
                }
                this._resolveIfComplete(result)
            },
            _resolveIfComplete: function(result) {
                this._removePendingValidator(result.validator);
                this._updateBrokenRules(result);
                if (!this._pendingValidators.length) {
                    this._unsubscribeFromAllChangeEvents();
                    if (!this._validationInfo.result) {
                        return
                    }
                    this._validationInfo.result.status = 0 === this._validationInfo.result.brokenRules.length ? STATUS.valid : STATUS.invalid;
                    this._validationInfo.result.isValid = this._validationInfo.result.status === STATUS.valid;
                    var res = (0, _extend.extend)({}, this._validationInfo.result, {
                        complete: null
                    });
                    var deferred = this._validationInfo.deferred;
                    this._resetValidationInfo();
                    this._raiseValidatedEvent(res);
                    deferred && setTimeout(function() {
                        deferred.resolve(res)
                    })
                }
            },
            _raiseValidatedEvent: function(result) {
                this._eventsStrategy.fireEvent("validated", [result])
            },
            _resetValidationInfo: function() {
                this._validationInfo = {
                    result: null,
                    deferred: null
                }
            },
            _synchronizeValidationInfo: function() {
                if (this._validationInfo.result) {
                    this._validationInfo.result.validators = this.validators
                }
            },
            removeRegisteredValidator: function(validator) {
                var index = (0, _array.inArray)(validator, this.validators);
                if (index > -1) {
                    this.validators.splice(index, 1);
                    this._synchronizeValidationInfo();
                    this._resolveIfComplete({
                        validator: validator
                    })
                }
            },
            registerValidator: function(validator) {
                if ((0, _array.inArray)(validator, this.validators) < 0) {
                    this.validators.push(validator);
                    this._synchronizeValidationInfo()
                }
            },
            reset: function() {
                (0, _iterator.each)(this.validators, function(_, validator) {
                    validator.reset()
                });
                this._pendingValidators = [];
                this._resetValidationInfo()
            },
            on: function(eventName, eventHandler) {
                this._eventsStrategy.on(eventName, eventHandler);
                return this
            },
            off: function(eventName, eventHandler) {
                this._eventsStrategy.off(eventName, eventHandler);
                return this
            }
        });
        var ValidationEngine = {
            groups: [],
            getGroupConfig: function(group) {
                var result = (0, _common.grep)(this.groups, function(config) {
                    return config.group === group
                });
                if (result.length) {
                    return result[0]
                }
            },
            findGroup: function($element, model) {
                var $dxGroup = $element.parents(".dx-validationgroup").first();
                if ($dxGroup.length) {
                    return $dxGroup.dxValidationGroup("instance")
                }
                return model
            },
            initGroups: function() {
                this.groups = [];
                this.addGroup()
            },
            addGroup: function(group) {
                var config = this.getGroupConfig(group);
                if (!config) {
                    config = new GroupConfig(group);
                    this.groups.push(config)
                }
                return config
            },
            removeGroup: function(group) {
                var config = this.getGroupConfig(group);
                var index = (0, _array.inArray)(config, this.groups);
                if (index > -1) {
                    this.groups.splice(index, 1)
                }
                return config
            },
            _setDefaultMessage: function(info) {
                var rule = info.rule,
                    validator = info.validator,
                    name = info.name;
                if (!(0, _type.isDefined)(rule.message)) {
                    if (validator.defaultFormattedMessage && (0, _type.isDefined)(name)) {
                        rule.message = validator.defaultFormattedMessage(name)
                    } else {
                        rule.message = validator.defaultMessage()
                    }
                }
            },
            _addBrokenRule: function(info) {
                var result = info.result,
                    rule = info.rule;
                if (!result.brokenRule) {
                    result.brokenRule = rule
                }
                if (!result.brokenRules) {
                    result.brokenRules = []
                }
                result.brokenRules.push(rule)
            },
            validate: function(value, rules, name) {
                var _this13 = this;
                var result = {
                    name: name,
                    value: value,
                    brokenRule: null,
                    brokenRules: null,
                    isValid: true,
                    validationRules: rules,
                    pendingRules: null,
                    status: STATUS.valid,
                    complete: null
                };
                var asyncRuleItems = [];
                (0, _iterator.each)(rules || [], function(_, rule) {
                    var ruleValidator = rulesValidators[rule.type];
                    var ruleValidationResult;
                    if (ruleValidator) {
                        if ((0, _type.isDefined)(rule.isValid) && rule.value === value && !rule.reevaluate) {
                            if (!rule.isValid) {
                                result.isValid = false;
                                _this13._addBrokenRule({
                                    result: result,
                                    rule: rule
                                });
                                return false
                            }
                            return true
                        }
                        rule.value = value;
                        if ("async" === rule.type) {
                            asyncRuleItems.push({
                                rule: rule,
                                ruleValidator: ruleValidator
                            });
                            return true
                        }
                        ruleValidationResult = ruleValidator.validate(value, rule);
                        rule.isValid = ruleValidationResult;
                        if (!ruleValidationResult) {
                            result.isValid = false;
                            _this13._setDefaultMessage({
                                rule: rule,
                                validator: ruleValidator,
                                name: name
                            });
                            _this13._addBrokenRule({
                                result: result,
                                rule: rule
                            })
                        }
                        if (!rule.isValid) {
                            return false
                        }
                    } else {
                        throw _errors.default.Error("E0100")
                    }
                });
                if (result.isValid && !result.brokenRules && asyncRuleItems.length) {
                    result = this._validateAsyncRules({
                        value: value,
                        items: asyncRuleItems,
                        result: result,
                        name: name
                    })
                }
                result.status = result.pendingRules ? STATUS.pending : result.isValid ? STATUS.valid : STATUS.invalid;
                return result
            },
            _validateAsyncRules: function(_ref) {
                var _this14 = this;
                var result = _ref.result,
                    value = _ref.value,
                    items = _ref.items,
                    name = _ref.name;
                var asyncResults = [];
                (0, _iterator.each)(items, function(_, item) {
                    var validateResult = item.ruleValidator.validate(value, item.rule);
                    if (!(0, _type.isPromise)(validateResult)) {
                        _this14._updateRuleConfig({
                            rule: item.rule,
                            ruleResult: _this14._getPatchedRuleResult(validateResult),
                            validator: item.ruleValidator,
                            name: name
                        })
                    } else {
                        if (!result.pendingRules) {
                            result.pendingRules = []
                        }
                        result.pendingRules.push(item.rule);
                        var asyncResult = validateResult.then(function(res) {
                            var ruleResult = _this14._getPatchedRuleResult(res);
                            _this14._updateRuleConfig({
                                rule: item.rule,
                                ruleResult: ruleResult,
                                validator: item.ruleValidator,
                                name: name
                            });
                            return ruleResult
                        });
                        asyncResults.push(asyncResult)
                    }
                });
                if (asyncResults.length) {
                    result.complete = _promise.default.all(asyncResults).then(function(values) {
                        return _this14._getAsyncRulesResult({
                            result: result,
                            values: values
                        })
                    })
                }
                return result
            },
            _updateRuleConfig: function(_ref2) {
                var rule = _ref2.rule,
                    ruleResult = _ref2.ruleResult,
                    validator = _ref2.validator,
                    name = _ref2.name;
                rule.isValid = ruleResult.isValid;
                if (!ruleResult.isValid) {
                    if ((0, _type.isDefined)(ruleResult.message) && (0, _type.isString)(ruleResult.message) && ruleResult.message.length) {
                        rule.message = ruleResult.message
                    } else {
                        this._setDefaultMessage({
                            rule: rule,
                            validator: validator,
                            name: name
                        })
                    }
                }
            },
            _getPatchedRuleResult: function(ruleResult) {
                var result;
                var isValid = true;
                if ((0, _type.isObject)(ruleResult)) {
                    result = (0, _extend.extend)({}, ruleResult);
                    if (!(0, _type.isDefined)(result.isValid)) {
                        result.isValid = isValid
                    }
                } else {
                    result = {
                        isValid: (0, _type.isBoolean)(ruleResult) ? ruleResult : isValid
                    }
                }
                return result
            },
            _getAsyncRulesResult: function(_ref3) {
                var _this15 = this;
                var values = _ref3.values,
                    result = _ref3.result;
                (0, _iterator.each)(values, function(index, val) {
                    if (false === val.isValid) {
                        result.isValid = val.isValid;
                        var rule = result.pendingRules[index];
                        _this15._addBrokenRule({
                            result: result,
                            rule: rule
                        })
                    }
                });
                result.pendingRules = null;
                result.complete = null;
                result.status = result.isValid ? STATUS.valid : STATUS.invalid;
                return result
            },
            registerValidatorInGroup: function(group, validator) {
                var groupConfig = ValidationEngine.addGroup(group);
                groupConfig.registerValidator.call(groupConfig, validator)
            },
            _shouldRemoveGroup: function(group, validatorsInGroup) {
                var isDefaultGroup = void 0 === group;
                var isValidationGroupInstance = group && "dxValidationGroup" === group.NAME;
                return !isDefaultGroup && !isValidationGroupInstance && !validatorsInGroup.length
            },
            removeRegisteredValidator: function(group, validator) {
                var config = ValidationEngine.getGroupConfig(group);
                if (config) {
                    config.removeRegisteredValidator.call(config, validator);
                    var validatorsInGroup = config.validators;
                    if (this._shouldRemoveGroup(group, validatorsInGroup)) {
                        this.removeGroup(group)
                    }
                }
            },
            initValidationOptions: function(options) {
                var _this16 = this;
                var initedOptions = {};
                if (options) {
                    var syncOptions = ["isValid", "validationStatus", "validationError", "validationErrors"];
                    syncOptions.forEach(function(prop) {
                        if (prop in options) {
                            (0, _extend.extend)(initedOptions, _this16.synchronizeValidationOptions({
                                name: prop,
                                value: options[prop]
                            }, options))
                        }
                    })
                }
                return initedOptions
            },
            synchronizeValidationOptions: function(_ref4, options) {
                var name = _ref4.name,
                    value = _ref4.value;
                switch (name) {
                    case "validationStatus":
                        var isValid = value === STATUS.valid || value === STATUS.pending;
                        return options.isValid !== isValid ? {
                            isValid: isValid
                        } : {};
                    case "isValid":
                        var validationStatus = options.validationStatus;
                        var newStatus = validationStatus;
                        if (value && validationStatus === STATUS.invalid) {
                            newStatus = STATUS.valid
                        } else {
                            if (!value && validationStatus !== STATUS.invalid) {
                                newStatus = STATUS.invalid
                            }
                        }
                        return newStatus !== validationStatus ? {
                            validationStatus: newStatus
                        } : {};
                    case "validationErrors":
                        var validationError = !value || !value.length ? null : value[0];
                        return options.validationError !== validationError ? {
                            validationError: validationError
                        } : {};
                    case "validationError":
                        var validationErrors = options.validationErrors;
                        if (!value && validationErrors) {
                            return {
                                validationErrors: null
                            }
                        } else {
                            if (value && !validationErrors) {
                                return {
                                    validationErrors: [value]
                                }
                            } else {
                                if (value && validationErrors && value !== validationErrors[0]) {
                                    validationErrors[0] = value;
                                    return {
                                        validationErrors: validationErrors.slice()
                                    }
                                }
                            }
                        }
                }
                return {}
            },
            validateGroup: function(group) {
                var groupConfig = ValidationEngine.getGroupConfig(group);
                if (!groupConfig) {
                    throw _errors.default.Error("E0110")
                }
                return groupConfig.validate()
            },
            resetGroup: function(group) {
                var groupConfig = ValidationEngine.getGroupConfig(group);
                if (!groupConfig) {
                    throw _errors.default.Error("E0110")
                }
                return groupConfig.reset()
            }
        };
        ValidationEngine.initGroups();
        var _default = ValidationEngine;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/text_box.js ***!
      \*************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _text_box = _interopRequireDefault(__webpack_require__( /*! ./text_box/text_box */ 583));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _text_box.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/diagram/diagram.importer.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.getDiagram = getDiagram;
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var Diagram = _interopRequireWildcard(__webpack_require__( /*! devexpress-diagram */ 878));

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function getDiagram() {
            if (!Diagram.default) {
                throw _ui.default.Error("E1041", "devexpress-diagram")
            }
            return Diagram
        }
    },
    /*!******************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/style.js ***!
      \******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.setHeight = exports.setWidth = exports.normalizeStyleProp = exports.stylePropPrefix = exports.styleProp = void 0;
        var _inflector = __webpack_require__( /*! ./inflector */ 39);
        var _call_once = _interopRequireDefault(__webpack_require__( /*! ./call_once */ 85));
        var _type = __webpack_require__( /*! ./type */ 1);
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../dom_adapter */ 11));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var jsPrefixes = ["", "Webkit", "Moz", "O", "Ms"];
        var cssPrefixes = {
            "": "",
            Webkit: "-webkit-",
            Moz: "-moz-",
            O: "-o-",
            ms: "-ms-"
        };
        var getStyles = (0, _call_once.default)(function() {
            return _dom_adapter.default.createElement("dx").style
        });
        var forEachPrefixes = function(prop, callBack) {
            prop = (0, _inflector.camelize)(prop, true);
            var result;
            for (var i = 0, cssPrefixesCount = jsPrefixes.length; i < cssPrefixesCount; i++) {
                var jsPrefix = jsPrefixes[i];
                var prefixedProp = jsPrefix + prop;
                var lowerPrefixedProp = (0, _inflector.camelize)(prefixedProp);
                result = callBack(lowerPrefixedProp, jsPrefix);
                if (void 0 === result) {
                    result = callBack(prefixedProp, jsPrefix)
                }
                if (void 0 !== result) {
                    break
                }
            }
            return result || ""
        };
        var styleProp = function(name) {
            if (name in getStyles()) {
                return name
            }
            var originalName = name;
            name = name.charAt(0).toUpperCase() + name.substr(1);
            for (var i = 1; i < jsPrefixes.length; i++) {
                var prefixedProp = jsPrefixes[i].toLowerCase() + name;
                if (prefixedProp in getStyles()) {
                    return prefixedProp
                }
            }
            return originalName
        };
        exports.styleProp = styleProp;
        var stylePropPrefix = function(prop) {
            return forEachPrefixes(prop, function(specific, jsPrefix) {
                if (specific in getStyles()) {
                    return cssPrefixes[jsPrefix]
                }
            })
        };
        exports.stylePropPrefix = stylePropPrefix;
        var pxExceptions = ["fillOpacity", "columnCount", "flexGrow", "flexShrink", "fontWeight", "lineHeight", "opacity", "zIndex", "zoom"];
        var normalizeStyleProp = function(prop, value) {
            if ((0, _type.isNumeric)(value) && pxExceptions.indexOf(prop) === -1) {
                value += "px"
            }
            return value
        };
        exports.normalizeStyleProp = normalizeStyleProp;
        var setDimensionProperty = function(elements, propertyName, value) {
            if (elements) {
                value = (0, _type.isNumeric)(value) ? value += "px" : value;
                for (var i = 0; i < elements.length; ++i) {
                    elements[i].style[propertyName] = value
                }
            }
        };
        var setWidth = function(elements, value) {
            setDimensionProperty(elements, "width", value)
        };
        exports.setWidth = setWidth;
        var setHeight = function(elements, value) {
            setDimensionProperty(elements, "height", value)
        };
        exports.setHeight = setHeight
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/core/events_strategy.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.EventsStrategy = void 0;
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ./utils/callbacks */ 27));
        var _iterator = __webpack_require__( /*! ./utils/iterator */ 3);
        var _type = __webpack_require__( /*! ./utils/type */ 1);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var EventsStrategy = function() {
            function EventsStrategy(owner) {
                var options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                this._events = {};
                this._owner = owner;
                this._options = options
            }
            EventsStrategy.create = function(owner, strategy) {
                if (strategy) {
                    return (0, _type.isFunction)(strategy) ? strategy(owner) : strategy
                } else {
                    return new EventsStrategy(owner)
                }
            };
            var _proto = EventsStrategy.prototype;
            _proto.hasEvent = function(eventName) {
                var callbacks = this._events[eventName];
                return callbacks ? callbacks.has() : false
            };
            _proto.fireEvent = function(eventName, eventArgs) {
                var callbacks = this._events[eventName];
                if (callbacks) {
                    callbacks.fireWith(this._owner, eventArgs)
                }
                return this._owner
            };
            _proto.on = function(eventName, eventHandler) {
                var _this = this;
                if ((0, _type.isPlainObject)(eventName)) {
                    (0, _iterator.each)(eventName, function(e, h) {
                        _this.on(e, h)
                    })
                } else {
                    var callbacks = this._events[eventName];
                    if (!callbacks) {
                        callbacks = (0, _callbacks.default)({
                            syncStrategy: this._options.syncStrategy
                        });
                        this._events[eventName] = callbacks
                    }
                    var addFn = callbacks.originalAdd || callbacks.add;
                    addFn.call(callbacks, eventHandler)
                }
            };
            _proto.off = function(eventName, eventHandler) {
                var callbacks = this._events[eventName];
                if (callbacks) {
                    if ((0, _type.isFunction)(eventHandler)) {
                        callbacks.remove(eventHandler)
                    } else {
                        callbacks.empty()
                    }
                }
            };
            _proto.dispose = function() {
                (0, _iterator.each)(this._events, function(eventName, event) {
                    event.empty()
                })
            };
            return EventsStrategy
        }();
        exports.EventsStrategy = EventsStrategy
    },
    /*!******************************************************!*\
      !*** ./artifacts/transpiled-npm/data/odata/utils.js ***!
      \******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.escapeServiceOperationParams = exports.formatFunctionInvocationUrl = exports.generateExpand = exports.generateSelect = exports.convertPrimitiveValue = exports.keyConverters = exports.serializeKey = exports.serializeValue = exports.serializePropName = exports.EdmLiteral = exports.sendRequest = void 0;
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _ajax = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/ajax */ 79));
        var _guid = _interopRequireDefault(__webpack_require__( /*! ../../core/guid */ 36));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../errors */ 38));
        var _utils = _interopRequireDefault(__webpack_require__( /*! ../utils */ 41));
        var _string = __webpack_require__( /*! ../../core/utils/string */ 43);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        var GUID_REGEX = /^(\{{0,1}([0-9a-fA-F]){8}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){12}\}{0,1})$/;
        var VERBOSE_DATE_REGEX = /^\/Date\((-?\d+)((\+|-)?(\d+)?)\)\/$/;
        var ISO8601_DATE_REGEX = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[-+]{1}\d{2}(:?)(\d{2})?)?$/;
        var JSON_VERBOSE_MIME_TYPE = "application/json;odata=verbose";
        var makeArray = function(value) {
            return "string" === (0, _type.type)(value) ? value.split() : value
        };
        var hasDot = function(x) {
            return /\./.test(x)
        };
        var pad = function(text, length, right) {
            text = String(text);
            while (text.length < length) {
                text = right ? "".concat(text, "0") : "0".concat(text)
            }
            return text
        };
        var formatISO8601 = function(date, skipZeroTime, skipTimezone) {
            var bag = [];
            var isZeroTime = function() {
                return date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds() < 1
            };
            var padLeft2 = function(text) {
                return pad(text, 2)
            };
            bag.push(date.getFullYear());
            bag.push("-");
            bag.push(padLeft2(date.getMonth() + 1));
            bag.push("-");
            bag.push(padLeft2(date.getDate()));
            if (!(skipZeroTime && isZeroTime())) {
                bag.push("T");
                bag.push(padLeft2(date.getHours()));
                bag.push(":");
                bag.push(padLeft2(date.getMinutes()));
                bag.push(":");
                bag.push(padLeft2(date.getSeconds()));
                if (date.getMilliseconds()) {
                    bag.push(".");
                    bag.push(pad(date.getMilliseconds(), 3))
                }
                if (!skipTimezone) {
                    bag.push("Z")
                }
            }
            return bag.join("")
        };
        var parseISO8601 = function(isoString) {
            var result = new Date(60 * new Date(0).getTimezoneOffset() * 1e3);
            var chunks = isoString.replace("Z", "").split("T");
            var date = /(\d{4})-(\d{2})-(\d{2})/.exec(chunks[0]);
            var time = /(\d{2}):(\d{2}):(\d{2})\.?(\d{0,7})?/.exec(chunks[1]);
            result.setFullYear(Number(date[1]));
            result.setMonth(Number(date[2]) - 1);
            result.setDate(Number(date[3]));
            if (Array.isArray(time) && time.length) {
                result.setHours(Number(time[1]));
                result.setMinutes(Number(time[2]));
                result.setSeconds(Number(time[3]));
                var fractional = (time[4] || "").slice(0, 3);
                fractional = pad(fractional, 3, true);
                result.setMilliseconds(Number(fractional))
            }
            return result
        };
        var isAbsoluteUrl = function(url) {
            return /^(?:[a-z]+:)?\/\//i.test(url)
        };
        var stripParams = function(url) {
            var index = url.indexOf("?");
            if (index > -1) {
                return url.substr(0, index)
            }
            return url
        };
        var toAbsoluteUrl = function(basePath, relativePath) {
            var part;
            var baseParts = stripParams(basePath).split("/");
            var relativeParts = relativePath.split("/");
            baseParts.pop();
            while (relativeParts.length) {
                part = relativeParts.shift();
                if (".." === part) {
                    baseParts.pop()
                } else {
                    baseParts.push(part)
                }
            }
            return baseParts.join("/")
        };
        var param = function(params) {
            var result = [];
            for (var name in params) {
                result.push(name + "=" + params[name])
            }
            return result.join("&")
        };
        var ajaxOptionsForRequest = function(protocolVersion, request) {
            var _options$beforeSend;
            var options = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            var formatPayload = function(payload) {
                return JSON.stringify(payload, function(key, value) {
                    if (!(this[key] instanceof Date)) {
                        return value
                    }
                    value = formatISO8601(this[key]);
                    switch (protocolVersion) {
                        case 2:
                            return value.substr(0, value.length - 1);
                        case 3:
                        case 4:
                            return value;
                        default:
                            throw _errors.default.errors.Error("E4002")
                    }
                })
            };
            request = (0, _extend.extend)({
                async: true,
                method: "get",
                url: "",
                params: {},
                payload: null,
                headers: {},
                timeout: 3e4
            }, request);
            null === (_options$beforeSend = options.beforeSend) || void 0 === _options$beforeSend ? void 0 : _options$beforeSend.call(options, request);
            var _request = request,
                async = _request.async, timeout = _request.timeout, headers = _request.headers;
            var _request2 = request,
                url = _request2.url,
                method = _request2.method;
            var jsonp = options.jsonp,
                withCredentials = options.withCredentials;
            method = (method || "get").toLowerCase();
            var isGet = "get" === method;
            var useJsonp = isGet && jsonp;
            var params = (0, _extend.extend)({}, request.params);
            var ajaxData = isGet ? params : formatPayload(request.payload);
            var qs = !isGet && param(params);
            var contentType = !isGet && JSON_VERBOSE_MIME_TYPE;
            if (qs) {
                url += (url.indexOf("?") > -1 ? "&" : "?") + qs
            }
            if (useJsonp) {
                ajaxData.$format = "json"
            }
            return {
                url: url,
                data: ajaxData,
                dataType: useJsonp ? "jsonp" : "json",
                jsonp: useJsonp && "$callback",
                method: method,
                async: async,
                timeout: timeout,
                headers: headers,
                contentType: contentType,
                accepts: {
                    json: [JSON_VERBOSE_MIME_TYPE, "text/plain"].join()
                },
                xhrFields: {
                    withCredentials: withCredentials
                }
            }
        };
        var sendRequest = function sendRequest(protocolVersion, request, options) {
            var deserializeDates = options.deserializeDates,
                fieldTypes = options.fieldTypes,
                countOnly = options.countOnly,
                isPaged = options.isPaged;
            var d = new _deferred.Deferred;
            var ajaxOptions = ajaxOptionsForRequest(protocolVersion, request, options);
            _ajax.default.sendRequest(ajaxOptions).always(function(obj, textStatus) {
                var transformOptions = {
                    deserializeDates: deserializeDates,
                    fieldTypes: fieldTypes
                };
                var tuple = interpretJsonFormat(obj, textStatus, transformOptions, ajaxOptions);
                var error = tuple.error,
                    data = tuple.data,
                    count = tuple.count;
                var nextUrl = tuple.nextUrl;
                if (error) {
                    if (error.message !== _utils.default.XHR_ERROR_UNLOAD) {
                        d.reject(error)
                    }
                } else {
                    if (countOnly) {
                        if (isFinite(count)) {
                            d.resolve(count)
                        } else {
                            d.reject(new _errors.default.errors.Error("E4018"))
                        }
                    } else {
                        if (nextUrl && !isPaged) {
                            if (!isAbsoluteUrl(nextUrl)) {
                                nextUrl = toAbsoluteUrl(ajaxOptions.url, nextUrl)
                            }
                            sendRequest(protocolVersion, {
                                url: nextUrl
                            }, options).fail(d.reject).done(function(nextData) {
                                return d.resolve(data.concat(nextData))
                            })
                        } else {
                            var extra = isFinite(count) ? {
                                totalCount: count
                            } : void 0;
                            d.resolve(data, extra)
                        }
                    }
                }
            });
            return d.promise()
        };
        exports.sendRequest = sendRequest;
        var formatDotNetError = function(errorObj) {
            var message;
            var currentError = errorObj;
            if ("message" in errorObj) {
                var _errorObj$message;
                message = (null === (_errorObj$message = errorObj.message) || void 0 === _errorObj$message ? void 0 : _errorObj$message.value) || errorObj.message
            }
            while (currentError = currentError.innererror || currentError.internalexception) {
                message = currentError.message;
                if (currentError.internalexception && message.indexOf("inner exception") === -1) {
                    break
                }
            }
            return message
        };
        var errorFromResponse = function(obj, textStatus, ajaxOptions) {
            var _response, _response2, _response3, _response4;
            if ("nocontent" === textStatus) {
                return null
            }
            var message = "Unknown error";
            var response = obj;
            var httpStatus = 200;
            var errorData = {
                requestOptions: ajaxOptions
            };
            if ("success" !== textStatus) {
                var status = obj.status,
                    responseText = obj.responseText;
                httpStatus = status;
                message = _utils.default.errorMessageFromXhr(obj, textStatus);
                try {
                    response = JSON.parse(responseText)
                } catch (x) {}
            }
            var errorObj = (null === (_response = response) || void 0 === _response ? void 0 : _response.then) || (null === (_response2 = response) || void 0 === _response2 ? void 0 : _response2.error) || (null === (_response3 = response) || void 0 === _response3 ? void 0 : _response3["odata.error"]) || (null === (_response4 = response) || void 0 === _response4 ? void 0 : _response4["@odata.error"]);
            if (errorObj) {
                message = formatDotNetError(errorObj) || message;
                errorData.errorDetails = errorObj;
                if (200 === httpStatus) {
                    httpStatus = 500
                }
                var customCode = Number(errorObj.code);
                if (isFinite(customCode) && customCode >= 400) {
                    httpStatus = customCode
                }
            }
            if (httpStatus >= 400 || 0 === httpStatus) {
                errorData.httpStatus = httpStatus;
                return (0, _extend.extend)(Error(message), errorData)
            }
            return null
        };
        var interpretJsonFormat = function(obj, textStatus, transformOptions, ajaxOptions) {
            var error = errorFromResponse(obj, textStatus, ajaxOptions);
            if (error) {
                return {
                    error: error
                }
            }
            if (!(0, _type.isPlainObject)(obj)) {
                return {
                    data: obj
                }
            }
            var value = "d" in obj && (Array.isArray(obj.d) || (0, _type.isObject)(obj.d)) ? interpretVerboseJsonFormat(obj, textStatus) : interpretLightJsonFormat(obj, textStatus);
            transformTypes(value, transformOptions);
            return value
        };
        var interpretVerboseJsonFormat = function(_ref) {
            var _data$results;
            var data = _ref.d;
            if (!(0, _type.isDefined)(data)) {
                return {
                    error: Error("Malformed or unsupported JSON response received")
                }
            }
            return {
                data: null !== (_data$results = data.results) && void 0 !== _data$results ? _data$results : data,
                nextUrl: data.__next,
                count: parseInt(data.__count, 10)
            }
        };
        var interpretLightJsonFormat = function(obj) {
            var _obj$value;
            return {
                data: null !== (_obj$value = obj.value) && void 0 !== _obj$value ? _obj$value : obj,
                nextUrl: obj["@odata.nextLink"],
                count: parseInt(obj["@odata.count"], 10)
            }
        };
        var EdmLiteral = _class.default.inherit({
            ctor: function(value) {
                this._value = value
            },
            valueOf: function() {
                return this._value
            }
        });
        exports.EdmLiteral = EdmLiteral;
        var transformTypes = function transformTypes(obj) {
            var options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            (0, _iterator.each)(obj, function(key, value) {
                if (null !== value && "object" === _typeof(value)) {
                    if ("results" in value) {
                        obj[key] = value.results
                    }
                    transformTypes(obj[key], options)
                } else {
                    if ("string" === typeof value) {
                        var fieldTypes = options.fieldTypes,
                            deserializeDates = options.deserializeDates;
                        var canBeGuid = !fieldTypes || "String" !== fieldTypes[key];
                        if (canBeGuid && GUID_REGEX.test(value)) {
                            obj[key] = new _guid.default(value)
                        }
                        if (false !== deserializeDates) {
                            if (value.match(VERBOSE_DATE_REGEX)) {
                                var date = new Date(Number(RegExp.$1) + 60 * RegExp.$2 * 1e3);
                                obj[key] = new Date(date.valueOf() + 60 * date.getTimezoneOffset() * 1e3)
                            } else {
                                if (ISO8601_DATE_REGEX.test(value)) {
                                    obj[key] = new Date(parseISO8601(obj[key]).valueOf())
                                }
                            }
                        }
                    }
                }
            })
        };
        var serializeDate = function(date) {
            return "datetime'".concat(formatISO8601(date, true, true), "'")
        };
        var serializeString = function(value) {
            return "'".concat(value.replace(/'/g, "''"), "'")
        };
        var serializePropName = function(propName) {
            return propName instanceof EdmLiteral ? propName.valueOf() : propName.replace(/\./g, "/")
        };
        exports.serializePropName = serializePropName;
        var serializeValueV4 = function serializeValueV4(value) {
            if (value instanceof Date) {
                return formatISO8601(value, false, false)
            }
            if (value instanceof _guid.default) {
                return value.valueOf()
            }
            if (Array.isArray(value)) {
                return "[".concat(value.map(function(item) {
                    return serializeValueV4(item)
                }).join(","), "]")
            }
            return serializeValueV2(value)
        };
        var serializeValueV2 = function(value) {
            if (value instanceof Date) {
                return serializeDate(value)
            }
            if (value instanceof _guid.default) {
                return "guid'".concat(value, "'")
            }
            if (value instanceof EdmLiteral) {
                return value.valueOf()
            }
            if ("string" === typeof value) {
                return serializeString(value)
            }
            return String(value)
        };
        var serializeValue = function(value, protocolVersion) {
            switch (protocolVersion) {
                case 2:
                case 3:
                    return serializeValueV2(value);
                case 4:
                    return serializeValueV4(value);
                default:
                    throw _errors.default.errors.Error("E4002")
            }
        };
        exports.serializeValue = serializeValue;
        var serializeKey = function(key, protocolVersion) {
            if ((0, _type.isPlainObject)(key)) {
                var parts = [];
                (0, _iterator.each)(key, function(k, v) {
                    return parts.push("".concat(serializePropName(k), "=").concat(serializeValue(v, protocolVersion)))
                });
                return parts.join()
            }
            return serializeValue(key, protocolVersion)
        };
        exports.serializeKey = serializeKey;
        var keyConverters = {
            String: function(value) {
                return "".concat(value)
            },
            Int32: function(value) {
                return Math.floor(value)
            },
            Int64: function(value) {
                return value instanceof EdmLiteral ? value : new EdmLiteral("".concat(value, "L"))
            },
            Guid: function(value) {
                return value instanceof _guid.default ? value : new _guid.default(value)
            },
            Boolean: function(value) {
                return !!value
            },
            Single: function(value) {
                return value instanceof EdmLiteral ? value : new EdmLiteral(value + "f")
            },
            Decimal: function(value) {
                return value instanceof EdmLiteral ? value : new EdmLiteral(value + "m")
            }
        };
        exports.keyConverters = keyConverters;
        var convertPrimitiveValue = function(type, value) {
            if (null === value) {
                return null
            }
            var converter = keyConverters[type];
            if (!converter) {
                throw _errors.default.errors.Error("E4014", type)
            }
            return converter(value)
        };
        exports.convertPrimitiveValue = convertPrimitiveValue;
        var generateSelect = function(oDataVersion, select) {
            if (!select) {
                return
            }
            return oDataVersion < 4 ? serializePropName(select.join()) : (0, _common.grep)(select, hasDot, true).join()
        };
        exports.generateSelect = generateSelect;
        var formatCore = function formatCore(hash) {
            var result = "";
            var selectValue = [];
            var expandValue = [];
            (0, _iterator.each)(hash, function(key, value) {
                if (Array.isArray(value)) {
                    [].push.apply(selectValue, value)
                }
                if ((0, _type.isPlainObject)(value)) {
                    expandValue.push("".concat(key).concat(formatCore(value)))
                }
            });
            if (selectValue.length || expandValue.length) {
                result += "(";
                if (selectValue.length) {
                    result += "$select=".concat((0, _iterator.map)(selectValue, serializePropName).join())
                }
                if (expandValue.length) {
                    if (selectValue.length) {
                        result += ";"
                    }
                    result += "$expand=".concat((0, _iterator.map)(expandValue, serializePropName).join())
                }
                result += ")"
            }
            return result
        };
        var format = function(hash) {
            var result = [];
            (0, _iterator.each)(hash, function(key, value) {
                return result.push("".concat(key).concat(formatCore(value)))
            });
            return result.join()
        };
        var parseCore = function parseCore(exprParts, root, stepper) {
            var result = stepper(root, exprParts.shift(), exprParts);
            if (false === result) {
                return
            }
            parseCore(exprParts, result, stepper)
        };
        var parseTree = function(exprs, root, stepper) {
            return (0, _iterator.each)(exprs, function(_, x) {
                return parseCore(x.split("."), root, stepper)
            })
        };
        var generatorV2 = function(expand, select) {
            var hash = {};
            if (expand) {
                (0, _iterator.each)(makeArray(expand), function() {
                    hash[serializePropName(this)] = 1
                })
            }
            if (select) {
                (0, _iterator.each)(makeArray(select), function() {
                    var path = this.split(".");
                    if (path.length < 2) {
                        return
                    }
                    path.pop();
                    hash[serializePropName(path.join("."))] = 1
                })
            }
            return (0, _iterator.map)(hash, function(_, v) {
                return v
            }).join()
        };
        var generatorV4 = function(expand, select) {
            var hash = {};
            if (expand || select) {
                if (expand) {
                    parseTree(makeArray(expand), hash, function(node, key, path) {
                        node[key] = node[key] || {};
                        return !path.length ? false : node[key]
                    })
                }
                if (select) {
                    parseTree((0, _common.grep)(makeArray(select), hasDot), hash, function(node, key, path) {
                        if (!path.length) {
                            node[key] = node[key] || [];
                            node[key].push(key);
                            return false
                        }
                        return node[key] = node[key] || {}
                    })
                }
                return format(hash)
            }
        };
        var generateExpand = function(oDataVersion, expand, select) {
            return oDataVersion < 4 ? generatorV2(expand, select) : generatorV4(expand, select)
        };
        exports.generateExpand = generateExpand;
        var formatFunctionInvocationUrl = function(baseUrl, args) {
            return (0, _string.format)("{0}({1})", baseUrl, (0, _iterator.map)(args || {}, function(value, key) {
                return (0, _string.format)("{0}={1}", key, value)
            }).join(","))
        };
        exports.formatFunctionInvocationUrl = formatFunctionInvocationUrl;
        var escapeServiceOperationParams = function(params, version) {
            if (!params) {
                return params
            }
            var result = {};
            (0, _iterator.each)(params, function(k, v) {
                result[k] = serializeValue(v, version)
            });
            return result
        };
        exports.escapeServiceOperationParams = escapeServiceOperationParams
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/variable_wrapper.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _console = __webpack_require__( /*! ./console */ 110);
        var _dependency_injector = _interopRequireDefault(__webpack_require__( /*! ./dependency_injector */ 58));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = (0, _dependency_injector.default)({
            isWrapped: function() {
                return false
            },
            isWritableWrapped: function() {
                return false
            },
            wrap: function(value) {
                return value
            },
            unwrap: function(value) {
                return value
            },
            assign: function() {
                _console.logger.error("Method 'assign' should not be used for not wrapped variables. Use 'isWrapped' method for ensuring.")
            }
        });
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/events/core/emitter_registrator.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _ready_callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/ready_callbacks */ 49));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _element_data = __webpack_require__( /*! ../../core/element_data */ 40);
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _event_registrator = _interopRequireDefault(__webpack_require__( /*! ./event_registrator */ 74));
        var _index = __webpack_require__( /*! ../utils/index */ 8);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../pointer */ 24));
        var _wheel = __webpack_require__( /*! ./wheel */ 148);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var MANAGER_EVENT = "dxEventManager";
        var EMITTER_DATA = "dxEmitter";
        var EventManager = _class.default.inherit({
            ctor: function() {
                this._attachHandlers();
                this.reset();
                this._proxiedCancelHandler = this._cancelHandler.bind(this);
                this._proxiedAcceptHandler = this._acceptHandler.bind(this)
            },
            _attachHandlers: function() {
                _ready_callbacks.default.add(function() {
                    var document = _dom_adapter.default.getDocument();
                    _events_engine.default.subscribeGlobal(document, (0, _index.addNamespace)(_pointer.default.down, MANAGER_EVENT), this._pointerDownHandler.bind(this));
                    _events_engine.default.subscribeGlobal(document, (0, _index.addNamespace)(_pointer.default.move, MANAGER_EVENT), this._pointerMoveHandler.bind(this));
                    _events_engine.default.subscribeGlobal(document, (0, _index.addNamespace)([_pointer.default.up, _pointer.default.cancel].join(" "), MANAGER_EVENT), this._pointerUpHandler.bind(this));
                    _events_engine.default.subscribeGlobal(document, (0, _index.addNamespace)(_wheel.name, MANAGER_EVENT), this._mouseWheelHandler.bind(this))
                }.bind(this))
            },
            _eachEmitter: function(callback) {
                var activeEmitters = this._activeEmitters || [];
                var i = 0;
                while (activeEmitters.length > i) {
                    var emitter = activeEmitters[i];
                    if (false === callback(emitter)) {
                        break
                    }
                    if (activeEmitters[i] === emitter) {
                        i++
                    }
                }
            },
            _applyToEmitters: function(method, arg) {
                this._eachEmitter(function(emitter) {
                    emitter[method].call(emitter, arg)
                })
            },
            reset: function() {
                this._eachEmitter(this._proxiedCancelHandler);
                this._activeEmitters = []
            },
            resetEmitter: function(emitter) {
                this._proxiedCancelHandler(emitter)
            },
            _pointerDownHandler: function(e) {
                if ((0, _index.isMouseEvent)(e) && e.which > 1) {
                    return
                }
                this._updateEmitters(e)
            },
            _updateEmitters: function(e) {
                if (!this._isSetChanged(e)) {
                    return
                }
                this._cleanEmitters(e);
                this._fetchEmitters(e)
            },
            _isSetChanged: function(e) {
                var currentSet = this._closestEmitter(e);
                var previousSet = this._emittersSet || [];
                var setChanged = currentSet.length !== previousSet.length;
                (0, _iterator.each)(currentSet, function(index, emitter) {
                    setChanged = setChanged || previousSet[index] !== emitter;
                    return !setChanged
                });
                this._emittersSet = currentSet;
                return setChanged
            },
            _closestEmitter: function(e) {
                var that = this;
                var result = [];
                var $element = (0, _renderer.default)(e.target);

                function handleEmitter(_, emitter) {
                    if (!!emitter && emitter.validatePointers(e) && emitter.validate(e)) {
                        emitter.addCancelCallback(that._proxiedCancelHandler);
                        emitter.addAcceptCallback(that._proxiedAcceptHandler);
                        result.push(emitter)
                    }
                }
                while ($element.length) {
                    var emitters = (0, _element_data.data)($element.get(0), EMITTER_DATA) || [];
                    (0, _iterator.each)(emitters, handleEmitter);
                    $element = $element.parent()
                }
                return result
            },
            _acceptHandler: function(acceptedEmitter, e) {
                var that = this;
                this._eachEmitter(function(emitter) {
                    if (emitter !== acceptedEmitter) {
                        that._cancelEmitter(emitter, e)
                    }
                })
            },
            _cancelHandler: function(canceledEmitter, e) {
                this._cancelEmitter(canceledEmitter, e)
            },
            _cancelEmitter: function(emitter, e) {
                var activeEmitters = this._activeEmitters;
                if (e) {
                    emitter.cancel(e)
                } else {
                    emitter.reset()
                }
                emitter.removeCancelCallback();
                emitter.removeAcceptCallback();
                var emitterIndex = (0, _array.inArray)(emitter, activeEmitters);
                if (emitterIndex > -1) {
                    activeEmitters.splice(emitterIndex, 1)
                }
            },
            _cleanEmitters: function(e) {
                this._applyToEmitters("end", e);
                this.reset(e)
            },
            _fetchEmitters: function(e) {
                this._activeEmitters = this._emittersSet.slice();
                this._applyToEmitters("start", e)
            },
            _pointerMoveHandler: function(e) {
                this._applyToEmitters("move", e)
            },
            _pointerUpHandler: function(e) {
                this._updateEmitters(e)
            },
            _mouseWheelHandler: function(e) {
                if (!this._allowInterruptionByMouseWheel()) {
                    return
                }
                e.pointers = [null];
                this._pointerDownHandler(e);
                this._adjustWheelEvent(e);
                this._pointerMoveHandler(e);
                e.pointers = [];
                this._pointerUpHandler(e)
            },
            _allowInterruptionByMouseWheel: function() {
                var allowInterruption = true;
                this._eachEmitter(function(emitter) {
                    allowInterruption = emitter.allowInterruptionByMouseWheel() && allowInterruption;
                    return allowInterruption
                });
                return allowInterruption
            },
            _adjustWheelEvent: function(e) {
                var closestGestureEmitter = null;
                this._eachEmitter(function(emitter) {
                    if (!emitter.gesture) {
                        return
                    }
                    var direction = emitter.getDirection(e);
                    if ("horizontal" !== direction && !e.shiftKey || "vertical" !== direction && e.shiftKey) {
                        closestGestureEmitter = emitter;
                        return false
                    }
                });
                if (!closestGestureEmitter) {
                    return
                }
                var direction = closestGestureEmitter.getDirection(e);
                var verticalGestureDirection = "both" === direction && !e.shiftKey || "vertical" === direction;
                var prop = verticalGestureDirection ? "pageY" : "pageX";
                e[prop] += e.delta
            },
            isActive: function(element) {
                var result = false;
                this._eachEmitter(function(emitter) {
                    result = result || emitter.getElement().is(element)
                });
                return result
            }
        });
        var eventManager = new EventManager;
        var EMITTER_SUBSCRIPTION_DATA = "dxEmitterSubscription";
        var registerEmitter = function(emitterConfig) {
            var emitterClass = emitterConfig.emitter;
            var emitterName = emitterConfig.events[0];
            var emitterEvents = emitterConfig.events;
            (0, _iterator.each)(emitterEvents, function(_, eventName) {
                (0, _event_registrator.default)(eventName, {
                    noBubble: !emitterConfig.bubble,
                    setup: function(element) {
                        var subscriptions = (0, _element_data.data)(element, EMITTER_SUBSCRIPTION_DATA) || {};
                        var emitters = (0, _element_data.data)(element, EMITTER_DATA) || {};
                        var emitter = emitters[emitterName] || new emitterClass(element);
                        subscriptions[eventName] = true;
                        emitters[emitterName] = emitter;
                        (0, _element_data.data)(element, EMITTER_DATA, emitters);
                        (0, _element_data.data)(element, EMITTER_SUBSCRIPTION_DATA, subscriptions)
                    },
                    add: function(element, handleObj) {
                        var emitters = (0, _element_data.data)(element, EMITTER_DATA);
                        var emitter = emitters[emitterName];
                        emitter.configure((0, _extend.extend)({
                            delegateSelector: handleObj.selector
                        }, handleObj.data), handleObj.type)
                    },
                    teardown: function(element) {
                        var subscriptions = (0, _element_data.data)(element, EMITTER_SUBSCRIPTION_DATA);
                        var emitters = (0, _element_data.data)(element, EMITTER_DATA);
                        var emitter = emitters[emitterName];
                        delete subscriptions[eventName];
                        var disposeEmitter = true;
                        (0, _iterator.each)(emitterEvents, function(_, eventName) {
                            disposeEmitter = disposeEmitter && !subscriptions[eventName];
                            return disposeEmitter
                        });
                        if (disposeEmitter) {
                            if (eventManager.isActive(element)) {
                                eventManager.resetEmitter(emitter)
                            }
                            emitter && emitter.dispose();
                            delete emitters[emitterName]
                        }
                    }
                })
            })
        };
        var _default = registerEmitter;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************!*\
      !*** ./artifacts/transpiled-npm/events/hold.js ***!
      \*************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _index = __webpack_require__( /*! ./utils/index */ 8);
        var _emitter = _interopRequireDefault(__webpack_require__( /*! ./core/emitter */ 132));
        var _emitter_registrator = _interopRequireDefault(__webpack_require__( /*! ./core/emitter_registrator */ 103));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var abs = Math.abs;
        var HOLD_EVENT_NAME = "dxhold";
        var HOLD_TIMEOUT = 750;
        var TOUCH_BOUNDARY = 5;
        var HoldEmitter = _emitter.default.inherit({
            start: function(e) {
                this._startEventData = (0, _index.eventData)(e);
                this._startTimer(e)
            },
            _startTimer: function(e) {
                var holdTimeout = "timeout" in this ? this.timeout : HOLD_TIMEOUT;
                this._holdTimer = setTimeout(function() {
                    this._requestAccept(e);
                    this._fireEvent(HOLD_EVENT_NAME, e, {
                        target: e.target
                    });
                    this._forgetAccept()
                }.bind(this), holdTimeout)
            },
            move: function(e) {
                if (this._touchWasMoved(e)) {
                    this._cancel(e)
                }
            },
            _touchWasMoved: function(e) {
                var delta = (0, _index.eventDelta)(this._startEventData, (0, _index.eventData)(e));
                return abs(delta.x) > TOUCH_BOUNDARY || abs(delta.y) > TOUCH_BOUNDARY
            },
            end: function() {
                this._stopTimer()
            },
            _stopTimer: function() {
                clearTimeout(this._holdTimer)
            },
            cancel: function() {
                this._stopTimer()
            },
            dispose: function() {
                this._stopTimer()
            }
        });
        (0, _emitter_registrator.default)({
            emitter: HoldEmitter,
            bubble: true,
            events: [HOLD_EVENT_NAME]
        });
        var _default = {
            name: HOLD_EVENT_NAME
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************!*\
      !*** ./artifacts/transpiled-npm/data/abstract_store.js ***!
      \*********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _class = _interopRequireDefault(__webpack_require__( /*! ../core/class */ 15));
        var _events_strategy = __webpack_require__( /*! ../core/events_strategy */ 100);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _errors = _interopRequireDefault(__webpack_require__( /*! ./errors */ 38));
        var _utils = _interopRequireDefault(__webpack_require__( /*! ./utils */ 41));
        var _data = __webpack_require__( /*! ../core/utils/data */ 20);
        var _store_helper = _interopRequireDefault(__webpack_require__( /*! ./store_helper */ 94));
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }
        var abstract = _class.default.abstract;
        var queryByOptions = _store_helper.default.queryByOptions;
        var storeImpl = {};
        var Store = _class.default.inherit({
            ctor: function(options) {
                var that = this;
                options = options || {};
                this._eventsStrategy = new _events_strategy.EventsStrategy(this);
                (0, _iterator.each)(["onLoaded", "onLoading", "onInserted", "onInserting", "onUpdated", "onUpdating", "onPush", "onRemoved", "onRemoving", "onModified", "onModifying"], function(_, optionName) {
                    if (optionName in options) {
                        that.on(optionName.slice(2).toLowerCase(), options[optionName])
                    }
                });
                this._key = options.key;
                this._errorHandler = options.errorHandler;
                this._useDefaultSearch = true
            },
            _customLoadOptions: function() {
                return null
            },
            key: function() {
                return this._key
            },
            keyOf: function(obj) {
                if (!this._keyGetter) {
                    this._keyGetter = (0, _data.compileGetter)(this.key())
                }
                return this._keyGetter(obj)
            },
            _requireKey: function() {
                if (!this.key()) {
                    throw _errors.default.errors.Error("E4005")
                }
            },
            load: function(options) {
                var that = this;
                options = options || {};
                this._eventsStrategy.fireEvent("loading", [options]);
                return this._withLock(this._loadImpl(options)).done(function(result) {
                    that._eventsStrategy.fireEvent("loaded", [result, options])
                })
            },
            _loadImpl: function(options) {
                return queryByOptions(this.createQuery(options), options).enumerate()
            },
            _withLock: function(task) {
                var result = new _deferred.Deferred;
                task.done(function() {
                    var that = this;
                    var args = arguments;
                    _utils.default.processRequestResultLock.promise().done(function() {
                        result.resolveWith(that, args)
                    })
                }).fail(function() {
                    result.rejectWith(this, arguments)
                });
                return result
            },
            createQuery: abstract,
            totalCount: function(options) {
                return this._totalCountImpl(options)
            },
            _totalCountImpl: function(options) {
                return queryByOptions(this.createQuery(options), options, true).count()
            },
            byKey: function(key, extraOptions) {
                return this._addFailHandlers(this._withLock(this._byKeyImpl(key, extraOptions)))
            },
            _byKeyImpl: abstract,
            insert: function(values) {
                var that = this;
                that._eventsStrategy.fireEvent("modifying");
                that._eventsStrategy.fireEvent("inserting", [values]);
                return that._addFailHandlers(that._insertImpl(values).done(function(callbackValues, callbackKey) {
                    that._eventsStrategy.fireEvent("inserted", [callbackValues, callbackKey]);
                    that._eventsStrategy.fireEvent("modified")
                }))
            },
            _insertImpl: abstract,
            update: function(key, values) {
                var that = this;
                that._eventsStrategy.fireEvent("modifying");
                that._eventsStrategy.fireEvent("updating", [key, values]);
                return that._addFailHandlers(that._updateImpl(key, values).done(function() {
                    that._eventsStrategy.fireEvent("updated", [key, values]);
                    that._eventsStrategy.fireEvent("modified")
                }))
            },
            _updateImpl: abstract,
            push: function(changes) {
                var _this = this;
                var beforePushArgs = {
                    changes: changes,
                    waitFor: []
                };
                this._eventsStrategy.fireEvent("beforePush", [beforePushArgs]);
                _deferred.when.apply(void 0, _toConsumableArray(beforePushArgs.waitFor)).done(function() {
                    _this._pushImpl(changes);
                    _this._eventsStrategy.fireEvent("push", [changes])
                })
            },
            _pushImpl: _common.noop,
            remove: function(key) {
                var that = this;
                that._eventsStrategy.fireEvent("modifying");
                that._eventsStrategy.fireEvent("removing", [key]);
                return that._addFailHandlers(that._removeImpl(key).done(function(callbackKey) {
                    that._eventsStrategy.fireEvent("removed", [callbackKey]);
                    that._eventsStrategy.fireEvent("modified")
                }))
            },
            _removeImpl: abstract,
            _addFailHandlers: function(deferred) {
                return deferred.fail(this._errorHandler).fail(_errors.default._errorHandler)
            },
            on: function(eventName, eventHandler) {
                this._eventsStrategy.on(eventName, eventHandler);
                return this
            },
            off: function(eventName, eventHandler) {
                this._eventsStrategy.off(eventName, eventHandler);
                return this
            }
        });
        Store.create = function(alias, options) {
            if (!(alias in storeImpl)) {
                throw _errors.default.errors.Error("E4020", alias)
            }
            return new storeImpl[alias](options)
        };
        Store.registerClass = function(type, alias) {
            if (alias) {
                storeImpl[alias] = type
            }
            return type
        };
        Store.inherit = function(inheritor) {
            return function(members, alias) {
                var type = inheritor.apply(this, [members]);
                Store.registerClass(type, alias);
                return type
            }
        }(Store.inherit);
        var _default = Store;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scroll_view/ui.scrollable.js ***!
      \******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _support = __webpack_require__( /*! ../../core/utils/support */ 45);
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _element = __webpack_require__( /*! ../../core/element */ 18);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _dom_component = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_component */ 67));
        var _selectors = __webpack_require__( /*! ../widget/selectors */ 70);
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _uiEventsEmitterGesture = _interopRequireDefault(__webpack_require__( /*! ./ui.events.emitter.gesture.scroll */ 272));
        var _uiScrollable = __webpack_require__( /*! ./ui.scrollable.simulated */ 349);
        var _uiScrollable2 = _interopRequireDefault(__webpack_require__( /*! ./ui.scrollable.native */ 271));
        var _uiScrollable3 = __webpack_require__( /*! ./ui.scrollable.device */ 351);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var SCROLLABLE = "dxScrollable";
        var SCROLLABLE_STRATEGY = "dxScrollableStrategy";
        var SCROLLABLE_CLASS = "dx-scrollable";
        var SCROLLABLE_DISABLED_CLASS = "dx-scrollable-disabled";
        var SCROLLABLE_CONTAINER_CLASS = "dx-scrollable-container";
        var SCROLLABLE_WRAPPER_CLASS = "dx-scrollable-wrapper";
        var SCROLLABLE_CONTENT_CLASS = "dx-scrollable-content";
        var VERTICAL = "vertical";
        var HORIZONTAL = "horizontal";
        var BOTH = "both";
        var Scrollable = _dom_component.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    disabled: false,
                    onScroll: null,
                    direction: VERTICAL,
                    showScrollbar: "onScroll",
                    useNative: true,
                    bounceEnabled: true,
                    scrollByContent: true,
                    scrollByThumb: false,
                    onUpdated: null,
                    onStart: null,
                    onEnd: null,
                    onBounce: null,
                    onStop: null,
                    useSimulatedScrollbar: false,
                    useKeyboard: true,
                    inertiaEnabled: true,
                    pushBackValue: 0,
                    updateManually: false
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat((0, _uiScrollable3.deviceDependentOptions)(), [{
                    device: function() {
                        return _support.nativeScrolling && "android" === _devices.default.real().platform && !_browser.default.mozilla
                    },
                    options: {
                        useSimulatedScrollbar: true
                    }
                }, {
                    device: function() {
                        return "ios" === _devices.default.real().platform
                    },
                    options: {
                        pushBackValue: 1
                    }
                }])
            },
            _initOptions: function(options) {
                this.callBase(options);
                if (!("useSimulatedScrollbar" in options)) {
                    this._setUseSimulatedScrollbar()
                }
            },
            _setUseSimulatedScrollbar: function() {
                if (!this.initialOption("useSimulatedScrollbar")) {
                    this.option("useSimulatedScrollbar", !this.option("useNative"))
                }
            },
            _init: function() {
                this.callBase();
                this._initScrollableMarkup();
                this._locked = false
            },
            _getWindowDevicePixelRatio: function() {
                return (0, _window.hasWindow)() ? (0, _window.getWindow)().devicePixelRatio : 1
            },
            _visibilityChanged: function(visible) {
                if (visible) {
                    this.update();
                    this._updateRtlPosition();
                    this._savedScrollOffset && this.scrollTo(this._savedScrollOffset);
                    delete this._savedScrollOffset
                } else {
                    this._savedScrollOffset = this.scrollOffset()
                }
            },
            _initScrollableMarkup: function() {
                var $element = this.$element().addClass(SCROLLABLE_CLASS);
                var $container = this._$container = (0, _renderer.default)("<div>").addClass(SCROLLABLE_CONTAINER_CLASS);
                var $wrapper = this._$wrapper = (0, _renderer.default)("<div>").addClass(SCROLLABLE_WRAPPER_CLASS);
                var $content = this._$content = (0, _renderer.default)("<div>").addClass(SCROLLABLE_CONTENT_CLASS);
                if (_dom_adapter.default.hasDocumentProperty("onbeforeactivate") && _browser.default.msie && _browser.default.version < 12) {
                    _events_engine.default.on($element, (0, _index.addNamespace)("beforeactivate", SCROLLABLE), function(e) {
                        if (!(0, _renderer.default)(e.target).is(_selectors.focusable)) {
                            e.preventDefault()
                        }
                    })
                }
                $content.append($element.contents()).appendTo($container);
                $container.appendTo($wrapper);
                $wrapper.appendTo($element)
            },
            _dimensionChanged: function() {
                this.update();
                this._updateRtlPosition()
            },
            _initMarkup: function() {
                this.callBase();
                this._renderDirection()
            },
            _render: function() {
                this._renderStrategy();
                this._attachEventHandlers();
                this._renderDisabledState();
                this._createActions();
                this.update();
                this.callBase();
                this._rtlConfig = {
                    scrollRight: 0,
                    clientWidth: this._container().get(0).clientWidth,
                    windowPixelRatio: this._getWindowDevicePixelRatio()
                };
                this._updateRtlPosition()
            },
            _isHorizontalAndRtlEnabled: function() {
                return this.option("rtlEnabled") && this.option("direction") !== VERTICAL
            },
            _updateRtlPosition: function() {
                var _this = this;
                this._updateBounds();
                if (this._isHorizontalAndRtlEnabled()) {
                    (0, _common.deferUpdate)(function() {
                        var scrollLeft = _this._getMaxOffset().left - _this._rtlConfig.scrollRight;
                        if (scrollLeft <= 0) {
                            scrollLeft = 0;
                            _this._rtlConfig.scrollRight = _this._getMaxOffset().left
                        }(0, _common.deferRender)(function() {
                            if (_this.scrollLeft() !== scrollLeft) {
                                _this._rtlConfig.skipUpdating = true;
                                _this.scrollTo({
                                    left: scrollLeft
                                });
                                _this._rtlConfig.skipUpdating = false
                            }
                        })
                    })
                }
            },
            _getMaxOffset: function() {
                var _this$_container$get = this._container().get(0),
                    scrollWidth = _this$_container$get.scrollWidth,
                    clientWidth = _this$_container$get.clientWidth,
                    scrollHeight = _this$_container$get.scrollHeight,
                    clientHeight = _this$_container$get.clientHeight;
                return {
                    left: scrollWidth - clientWidth,
                    top: scrollHeight - clientHeight
                }
            },
            _updateBounds: function() {
                this._strategy.updateBounds()
            },
            _attachEventHandlers: function() {
                var strategy = this._strategy;
                var initEventData = {
                    getDirection: strategy.getDirection.bind(strategy),
                    validate: this._validate.bind(this),
                    isNative: this.option("useNative"),
                    scrollTarget: this._$container
                };
                _events_engine.default.off(this._$wrapper, "." + SCROLLABLE);
                _events_engine.default.on(this._$wrapper, (0, _index.addNamespace)(_uiEventsEmitterGesture.default.init, SCROLLABLE), initEventData, this._initHandler.bind(this));
                _events_engine.default.on(this._$wrapper, (0, _index.addNamespace)(_uiEventsEmitterGesture.default.start, SCROLLABLE), strategy.handleStart.bind(strategy));
                _events_engine.default.on(this._$wrapper, (0, _index.addNamespace)(_uiEventsEmitterGesture.default.move, SCROLLABLE), strategy.handleMove.bind(strategy));
                _events_engine.default.on(this._$wrapper, (0, _index.addNamespace)(_uiEventsEmitterGesture.default.end, SCROLLABLE), strategy.handleEnd.bind(strategy));
                _events_engine.default.on(this._$wrapper, (0, _index.addNamespace)(_uiEventsEmitterGesture.default.cancel, SCROLLABLE), strategy.handleCancel.bind(strategy));
                _events_engine.default.on(this._$wrapper, (0, _index.addNamespace)(_uiEventsEmitterGesture.default.stop, SCROLLABLE), strategy.handleStop.bind(strategy));
                _events_engine.default.off(this._$container, "." + SCROLLABLE);
                _events_engine.default.on(this._$container, (0, _index.addNamespace)("scroll", SCROLLABLE), strategy.handleScroll.bind(strategy))
            },
            _updateRtlConfig: function() {
                if (this._isHorizontalAndRtlEnabled() && !this._rtlConfig.skipUpdating) {
                    var _this$_container$get2 = this._container().get(0),
                        clientWidth = _this$_container$get2.clientWidth,
                        scrollLeft = _this$_container$get2.scrollLeft;
                    var windowPixelRatio = this._getWindowDevicePixelRatio();
                    if (this._rtlConfig.windowPixelRatio === windowPixelRatio && this._rtlConfig.clientWidth === clientWidth) {
                        this._rtlConfig.scrollRight = this._getMaxOffset().left - scrollLeft
                    }
                    this._rtlConfig.clientWidth = clientWidth;
                    this._rtlConfig.windowPixelRatio = windowPixelRatio
                }
            },
            _validate: function(e) {
                if (this._isLocked()) {
                    return false
                }
                this._updateIfNeed();
                return this._strategy.validate(e)
            },
            _initHandler: function() {
                var strategy = this._strategy;
                strategy.handleInit.apply(strategy, arguments)
            },
            _renderDisabledState: function() {
                this.$element().toggleClass(SCROLLABLE_DISABLED_CLASS, this.option("disabled"));
                if (this.option("disabled")) {
                    this._lock()
                } else {
                    this._unlock()
                }
            },
            _renderDirection: function() {
                this.$element().removeClass("dx-scrollable-" + HORIZONTAL).removeClass("dx-scrollable-" + VERTICAL).removeClass("dx-scrollable-" + BOTH).addClass("dx-scrollable-" + this.option("direction"))
            },
            _renderStrategy: function() {
                this._createStrategy();
                this._strategy.render();
                this.$element().data(SCROLLABLE_STRATEGY, this._strategy)
            },
            _createStrategy: function() {
                this._strategy = this.option("useNative") ? new _uiScrollable2.default(this) : new _uiScrollable.SimulatedStrategy(this)
            },
            _createActions: function() {
                this._strategy && this._strategy.createActions()
            },
            _clean: function() {
                this._strategy && this._strategy.dispose()
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "onStart":
                    case "onEnd":
                    case "onStop":
                    case "onUpdated":
                    case "onScroll":
                    case "onBounce":
                        this._createActions();
                        break;
                    case "direction":
                        this._resetInactiveDirection();
                        this._invalidate();
                        break;
                    case "useNative":
                        this._setUseSimulatedScrollbar();
                        this._invalidate();
                        break;
                    case "inertiaEnabled":
                    case "scrollByContent":
                    case "scrollByThumb":
                    case "bounceEnabled":
                    case "useKeyboard":
                    case "showScrollbar":
                    case "useSimulatedScrollbar":
                    case "pushBackValue":
                        this._invalidate();
                        break;
                    case "disabled":
                        this._renderDisabledState();
                        this._strategy && this._strategy.disabledChanged();
                        break;
                    case "updateManually":
                        break;
                    case "width":
                        this.callBase(args);
                        this._updateRtlPosition();
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _resetInactiveDirection: function() {
                var inactiveProp = this._getInactiveProp();
                if (!inactiveProp || !(0, _window.hasWindow)()) {
                    return
                }
                var scrollOffset = this.scrollOffset();
                scrollOffset[inactiveProp] = 0;
                this.scrollTo(scrollOffset)
            },
            _getInactiveProp: function() {
                var direction = this.option("direction");
                if (direction === VERTICAL) {
                    return "left"
                }
                if (direction === HORIZONTAL) {
                    return "top"
                }
            },
            _location: function() {
                return this._strategy.location()
            },
            _normalizeLocation: function(location) {
                if ((0, _type.isPlainObject)(location)) {
                    var left = (0, _common.ensureDefined)(location.left, location.x);
                    var top = (0, _common.ensureDefined)(location.top, location.y);
                    return {
                        left: (0, _type.isDefined)(left) ? -left : void 0,
                        top: (0, _type.isDefined)(top) ? -top : void 0
                    }
                } else {
                    var direction = this.option("direction");
                    return {
                        left: direction !== VERTICAL ? -location : void 0,
                        top: direction !== HORIZONTAL ? -location : void 0
                    }
                }
            },
            _isLocked: function() {
                return this._locked
            },
            _lock: function() {
                this._locked = true
            },
            _unlock: function() {
                if (!this.option("disabled")) {
                    this._locked = false
                }
            },
            _isDirection: function(direction) {
                var current = this.option("direction");
                if (direction === VERTICAL) {
                    return current !== HORIZONTAL
                }
                if (direction === HORIZONTAL) {
                    return current !== VERTICAL
                }
                return current === direction
            },
            _updateAllowedDirection: function() {
                var allowedDirections = this._strategy._allowedDirections();
                if (this._isDirection(BOTH) && allowedDirections.vertical && allowedDirections.horizontal) {
                    this._allowedDirectionValue = BOTH
                } else {
                    if (this._isDirection(HORIZONTAL) && allowedDirections.horizontal) {
                        this._allowedDirectionValue = HORIZONTAL
                    } else {
                        if (this._isDirection(VERTICAL) && allowedDirections.vertical) {
                            this._allowedDirectionValue = VERTICAL
                        } else {
                            this._allowedDirectionValue = null
                        }
                    }
                }
            },
            _allowedDirection: function() {
                return this._allowedDirectionValue
            },
            _container: function() {
                return this._$container
            },
            $content: function() {
                return this._$content
            },
            content: function() {
                return (0, _element.getPublicElement)(this._$content)
            },
            scrollOffset: function() {
                return this._getScrollOffset()
            },
            _getScrollOffset: function() {
                return {
                    top: -this._location().top,
                    left: -this._location().left
                }
            },
            scrollTop: function() {
                return this.scrollOffset().top
            },
            scrollLeft: function() {
                return this.scrollOffset().left
            },
            clientHeight: function() {
                return this._$container.height()
            },
            scrollHeight: function() {
                return this.$content().outerHeight() - 2 * this._strategy.verticalOffset()
            },
            clientWidth: function() {
                return this._$container.width()
            },
            scrollWidth: function() {
                return this.$content().outerWidth()
            },
            update: function() {
                if (!this._strategy) {
                    return
                }
                return (0, _deferred.when)(this._strategy.update()).done(function() {
                    this._updateAllowedDirection()
                }.bind(this))
            },
            scrollBy: function(distance) {
                distance = this._normalizeLocation(distance);
                if (!distance.top && !distance.left) {
                    return
                }
                this._updateIfNeed();
                this._strategy.scrollBy(distance);
                this._updateRtlConfig()
            },
            scrollTo: function(targetLocation) {
                targetLocation = this._normalizeLocation(targetLocation);
                this._updateIfNeed();
                var location = this._location();
                if (!this.option("useNative")) {
                    targetLocation = this._strategy._applyScaleRatio(targetLocation);
                    location = this._strategy._applyScaleRatio(location)
                }
                var distance = this._normalizeLocation({
                    left: location.left - (0, _common.ensureDefined)(targetLocation.left, location.left),
                    top: location.top - (0, _common.ensureDefined)(targetLocation.top, location.top)
                });
                if (!distance.top && !distance.left) {
                    return
                }
                this._strategy.scrollBy(distance);
                this._updateRtlConfig()
            },
            scrollToElement: function(element, offset) {
                var $element = (0, _renderer.default)(element);
                var elementInsideContent = this.$content().find(element).length;
                var elementIsInsideContent = $element.parents("." + SCROLLABLE_CLASS).length - $element.parents("." + SCROLLABLE_CONTENT_CLASS).length === 0;
                if (!elementInsideContent || !elementIsInsideContent) {
                    return
                }
                var scrollPosition = {
                    top: 0,
                    left: 0
                };
                var direction = this.option("direction");
                if (direction !== VERTICAL) {
                    scrollPosition.left = this.getScrollElementPosition($element, HORIZONTAL, offset)
                }
                if (direction !== HORIZONTAL) {
                    scrollPosition.top = this.getScrollElementPosition($element, VERTICAL, offset)
                }
                this.scrollTo(scrollPosition)
            },
            scrollToElementTopLeft: function(element) {
                var $element = (0, _renderer.default)(element);
                var elementInsideContent = this.$content().find(element).length;
                var elementIsInsideContent = $element.parents("." + SCROLLABLE_CLASS).length - $element.parents("." + SCROLLABLE_CONTENT_CLASS).length === 0;
                if (!elementInsideContent || !elementIsInsideContent) {
                    return
                }
                var scrollPosition = {
                    top: 0,
                    left: 0
                };
                var direction = this.option("direction");
                if (direction !== VERTICAL) {
                    var leftPosition = this._elementPositionRelativeToContent($element, "left");
                    scrollPosition.left = true === this.option("rtlEnabled") ? leftPosition + $element.width() - this.clientWidth() : leftPosition
                }
                if (direction !== HORIZONTAL) {
                    scrollPosition.top = this._elementPositionRelativeToContent($element, "top")
                }
                this.scrollTo(scrollPosition)
            },
            getScrollElementPosition: function($element, direction, offset) {
                offset = offset || {};
                var isVertical = direction === VERTICAL;
                var startOffset = (isVertical ? offset.top : offset.left) || 0;
                var endOffset = (isVertical ? offset.bottom : offset.right) || 0;
                var pushBackOffset = isVertical ? this._strategy.verticalOffset() : 0;
                var elementPositionRelativeToContent = this._elementPositionRelativeToContent($element, isVertical ? "top" : "left");
                var elementPosition = elementPositionRelativeToContent - pushBackOffset;
                var elementSize = $element[isVertical ? "outerHeight" : "outerWidth"]();
                var scrollLocation = isVertical ? this.scrollTop() : this.scrollLeft();
                var clientSize = this._container().get(0)[isVertical ? "clientHeight" : "clientWidth"];
                var startDistance = scrollLocation - elementPosition + startOffset;
                var endDistance = scrollLocation - elementPosition - elementSize + clientSize - endOffset;
                if (startDistance <= 0 && endDistance >= 0) {
                    return scrollLocation
                }
                return scrollLocation - (Math.abs(startDistance) > Math.abs(endDistance) ? endDistance : startDistance)
            },
            _elementPositionRelativeToContent: function($element, prop) {
                var result = 0;
                while (this._hasScrollContent($element)) {
                    result += $element.position()[prop];
                    $element = $element.offsetParent()
                }
                return result
            },
            _hasScrollContent: function($element) {
                var $content = this.$content();
                return $element.closest($content).length && !$element.is($content)
            },
            _updateIfNeed: function() {
                if (!this.option("updateManually")) {
                    this.update()
                }
            },
            _useTemplates: function() {
                return false
            }
        });
        (0, _component_registrator.default)(SCROLLABLE, Scrollable);
        var _default = Scrollable;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/context_menu.js ***!
      \*****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./context_menu/ui.context_menu */ 375));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _ui.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/core/export.js ***!
      \*****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.plugin = exports.ExportMenu = exports.combineMarkups = exports.exportWidgets = exports.getMarkup = exports.exportFromMarkup = void 0;
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _utils = __webpack_require__( /*! ./utils */ 14);
        var _exporter = __webpack_require__( /*! ../../exporter */ 191);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _themes = __webpack_require__( /*! ../themes */ 55);
        var _hover = __webpack_require__( /*! ../../events/hover */ 155);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../../events/pointer */ 24));
        var _console = __webpack_require__( /*! ../../core/utils/console */ 110);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var pointerActions = [_pointer.default.down, _pointer.default.move].join(" ");
        var BUTTON_SIZE = 35;
        var ICON_COORDS = [
            [9, 12, 26, 12, 26, 14, 9, 14],
            [9, 17, 26, 17, 26, 19, 9, 19],
            [9, 22, 26, 22, 26, 24, 9, 24]
        ];
        var LIST_PADDING_TOP = 4;
        var LIST_WIDTH = 120;
        var VERTICAL_TEXT_MARGIN = 8;
        var HORIZONTAL_TEXT_MARGIN = 15;
        var MENU_ITEM_HEIGHT = 30;
        var LIST_STROKE_WIDTH = 1;
        var MARGIN = 10;
        var SHADOW_OFFSET = 2;
        var SHADOW_BLUR = 3;
        var DEFAULT_EXPORT_FORMAT = "PNG";
        var ALLOWED_IMAGE_FORMATS = [DEFAULT_EXPORT_FORMAT, "JPEG", "GIF"];
        var ALLOWED_EXTRA_FORMATS = ["PDF", "SVG"];
        var EXPORT_CSS_CLASS = "dx-export-menu";
        var EXPORT_DATA_KEY = "export-element-type";
        var FORMAT_DATA_KEY = "export-element-format";
        var GET_COLOR_REGEX = /data-backgroundcolor="([^"]*)"/;

        function getValidFormats() {
            var imageFormats = _exporter.image.testFormats(ALLOWED_IMAGE_FORMATS);
            return {
                unsupported: imageFormats.unsupported,
                supported: imageFormats.supported.concat(ALLOWED_EXTRA_FORMATS)
            }
        }

        function validateFormat(format, incidentOccurred, validFormats) {
            validFormats = validFormats || getValidFormats();
            format = String(format).toUpperCase();
            if (validFormats.supported.indexOf(format) !== -1) {
                return format
            }
            if (validFormats.unsupported.indexOf(format) !== -1) {
                incidentOccurred && incidentOccurred("W2108", [format])
            }
        }

        function getCreatorFunc(format) {
            if ("SVG" === format) {
                return _exporter.svg.getData
            } else {
                if ("PDF" === format) {
                    return _exporter.pdf.getData
                } else {
                    return _exporter.image.getData
                }
            }
        }

        function _print(imageSrc, options) {
            var document = (0, _window.getWindow)().document;
            var iFrame = document.createElement("iframe");
            iFrame.onload = setPrint(imageSrc, options);
            iFrame.style.position = "fixed";
            iFrame.style.width = "0";
            iFrame.style.height = "0";
            iFrame.style.right = "0";
            iFrame.style.bottom = "0";
            document.body.appendChild(iFrame)
        }

        function setPrint(imageSrc, options) {
            return function() {
                var _this = this;
                var window = this.contentWindow;
                var img = window.document.createElement("img");
                window.document.body.appendChild(img);
                var removeFrame = function() {
                    _this.parentElement.removeChild(_this)
                };
                img.addEventListener("load", function() {
                    window.focus();
                    window.print()
                });
                img.addEventListener("error", removeFrame);
                window.addEventListener("afterprint", function() {
                    setTimeout(removeFrame, 0)
                });
                img.src = imageSrc
            }
        }

        function getItemAttributes(options, type, itemIndex) {
            var x = BUTTON_SIZE - LIST_WIDTH;
            var y = BUTTON_SIZE + LIST_PADDING_TOP + LIST_STROKE_WIDTH + itemIndex * MENU_ITEM_HEIGHT;
            var attr = {
                rect: {
                    width: LIST_WIDTH - 2 * LIST_STROKE_WIDTH,
                    height: MENU_ITEM_HEIGHT,
                    x: x + LIST_STROKE_WIDTH,
                    y: y
                },
                text: {
                    x: x + (options.rtl ? LIST_WIDTH - HORIZONTAL_TEXT_MARGIN : HORIZONTAL_TEXT_MARGIN),
                    y: y + MENU_ITEM_HEIGHT - VERTICAL_TEXT_MARGIN
                }
            };
            if ("printing" === type) {
                attr.separator = {
                    stroke: options.button.default.borderColor,
                    "stroke-width": LIST_STROKE_WIDTH,
                    cursor: "pointer",
                    sharp: "v",
                    d: "M " + x + " " + (y + MENU_ITEM_HEIGHT - LIST_STROKE_WIDTH) + " L " + (x + LIST_WIDTH) + " " + (y + MENU_ITEM_HEIGHT - LIST_STROKE_WIDTH)
                }
            }
            return attr
        }

        function createMenuItem(renderer, options, settings) {
            var itemData = {};
            var type = settings.type;
            var format = settings.format;
            var attr = getItemAttributes(options, type, settings.itemIndex);
            var fontStyle = (0, _utils.patchFontOptions)(options.font);
            fontStyle["pointer-events"] = "none";
            var menuItem = renderer.g().attr({
                "class": EXPORT_CSS_CLASS + "-list-item"
            });
            itemData[EXPORT_DATA_KEY] = type;
            if (format) {
                itemData[FORMAT_DATA_KEY] = format
            }
            var rect = renderer.rect();
            rect.attr(attr.rect).css({
                cursor: "pointer",
                "pointer-events": "all"
            }).data(itemData);
            rect.on(_hover.start + ".export", function() {
                return rect.attr({
                    fill: options.button.hover.backgroundColor
                })
            }).on(_hover.end + ".export", function() {
                return rect.attr({
                    fill: null
                })
            });
            rect.append(menuItem);
            var text = renderer.text(settings.text).css(fontStyle).attr(attr.text).append(menuItem);
            if ("printing" === type) {
                renderer.path(null, "line").attr(attr.separator).append(menuItem)
            }
            return {
                g: menuItem,
                rect: rect,
                resetState: function() {
                    return rect.attr({
                        fill: null
                    })
                },
                fixPosition: function() {
                    var textBBox = text.getBBox();
                    text.move(attr.text.x - textBBox.x - (options.rtl ? textBBox.width : 0))
                }
            }
        }

        function createMenuItems(renderer, options) {
            var items = [];
            if (options.printingEnabled) {
                items.push(createMenuItem(renderer, options, {
                    type: "printing",
                    text: _message.default.format("vizExport-printingButtonText"),
                    itemIndex: items.length
                }))
            }
            items = options.formats.reduce(function(r, format) {
                r.push(createMenuItem(renderer, options, {
                    type: "exporting",
                    text: _message.default.getFormatter("vizExport-exportButtonText")(format),
                    format: format,
                    itemIndex: r.length
                }));
                return r
            }, items);
            return items
        }

        function getBackgroundColorFromMarkup(markup) {
            var parsedMarkup = GET_COLOR_REGEX.exec(markup);
            return null === parsedMarkup || void 0 === parsedMarkup ? void 0 : parsedMarkup[1]
        }
        var exportFromMarkup = function(markup, options) {
            options.format = validateFormat(options.format) || DEFAULT_EXPORT_FORMAT;
            options.fileName = options.fileName || "file";
            options.exportingAction = options.onExporting;
            options.exportedAction = options.onExported;
            options.fileSavingAction = options.onFileSaving;
            options.margin = (0, _type.isDefined)(options.margin) ? options.margin : MARGIN;
            options.backgroundColor = (0, _type.isDefined)(options.backgroundColor) ? options.backgroundColor : getBackgroundColorFromMarkup(markup) || (0, _themes.getTheme)().backgroundColor;
            (0, _exporter.export)(markup, options, getCreatorFunc(options.format))
        };
        exports.exportFromMarkup = exportFromMarkup;
        var getMarkup = function(widgets) {
            return combineMarkups(widgets).markup
        };
        exports.getMarkup = getMarkup;
        var exportWidgets = function(widgets, options) {
            options = options || {};
            var markupInfo = combineMarkups(widgets, {
                gridLayout: options.gridLayout,
                verticalAlignment: options.verticalAlignment,
                horizontalAlignment: options.horizontalAlignment
            });
            options.width = markupInfo.width;
            options.height = markupInfo.height;
            exportFromMarkup(markupInfo.markup, options)
        };
        exports.exportWidgets = exportWidgets;
        var combineMarkups = function(widgets) {
            var options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            if (!Array.isArray(widgets)) {
                widgets = [
                    [widgets]
                ]
            } else {
                if (!Array.isArray(widgets[0])) {
                    widgets = widgets.map(function(item) {
                        return [item]
                    })
                }
            }
            var compactView = !options.gridLayout;
            var exportItems = widgets.reduce(function(r, row, rowIndex) {
                var rowInfo = row.reduce(function(r, item, colIndex) {
                    var size = item.getSize();
                    var backgroundColor = item.option("backgroundColor") || (0, _themes.getTheme)(item.option("theme")).backgroundColor;
                    backgroundColor && r.backgroundColors.indexOf(backgroundColor) === -1 && r.backgroundColors.push(backgroundColor);
                    r.hOffset = r.width;
                    r.width += size.width;
                    r.height = Math.max(r.height, size.height);
                    r.itemWidth = Math.max(r.itemWidth, size.width);
                    r.items.push({
                        markup: item.svg(),
                        width: size.width,
                        height: size.height,
                        c: colIndex,
                        r: rowIndex,
                        hOffset: r.hOffset
                    });
                    return r
                }, {
                    items: [],
                    height: 0,
                    itemWidth: 0,
                    hOffset: 0,
                    width: 0,
                    backgroundColors: r.backgroundColors
                });
                r.rowOffsets.push(r.totalHeight);
                r.rowHeights.push(rowInfo.height);
                r.totalHeight += rowInfo.height;
                r.items = r.items.concat(rowInfo.items);
                r.itemWidth = Math.max(r.itemWidth, rowInfo.itemWidth);
                r.maxItemLen = Math.max(r.maxItemLen, rowInfo.items.length);
                r.totalWidth = compactView ? Math.max(r.totalWidth, rowInfo.width) : r.maxItemLen * r.itemWidth;
                return r
            }, {
                items: [],
                rowOffsets: [],
                rowHeights: [],
                itemWidth: 0,
                totalHeight: 0,
                maxItemLen: 0,
                totalWidth: 0,
                backgroundColors: []
            });
            var backgroundColor = 'data-backgroundcolor="'.concat(1 === exportItems.backgroundColors.length ? exportItems.backgroundColors[0] : "", '" ');
            var getVOffset = function(item) {
                var align = options.verticalAlignment;
                var dy = exportItems.rowHeights[item.r] - item.height;
                return exportItems.rowOffsets[item.r] + ("bottom" === align ? dy : "center" === align ? dy / 2 : 0)
            };
            var getHOffset = function(item) {
                if (compactView) {
                    return item.hOffset
                }
                var align = options.horizontalAlignment;
                var colWidth = exportItems.itemWidth;
                var dx = colWidth - item.width;
                return item.c * colWidth + ("right" === align ? dx : "center" === align ? dx / 2 : 0)
            };
            var totalHeight = exportItems.totalHeight;
            var totalWidth = exportItems.totalWidth;
            return {
                markup: "<svg " + backgroundColor + 'height="' + totalHeight + '" width="' + totalWidth + '" version="1.1" xmlns="http://www.w3.org/2000/svg">' + exportItems.items.map(function(item) {
                    return '<g transform="translate('.concat(getHOffset(item), ",").concat(getVOffset(item), ')">').concat(item.markup, "</g>")
                }).join("") + "</svg>",
                width: totalWidth,
                height: totalHeight
            }
        };
        exports.combineMarkups = combineMarkups;
        var ExportMenu = function(params) {
            var renderer = this._renderer = params.renderer;
            this._incidentOccurred = params.incidentOccurred;
            this._exportTo = params.exportTo;
            this._print = params.print;
            this._shadow = renderer.shadowFilter("-50%", "-50%", "200%", "200%", SHADOW_OFFSET, 6, SHADOW_BLUR);
            this._shadow.attr({
                opacity: .8
            });
            this._group = renderer.g().attr({
                "class": EXPORT_CSS_CLASS,
                "hidden-for-export": true
            }).linkOn(renderer.root, {
                name: "export-menu",
                after: "peripheral"
            });
            this._buttonGroup = renderer.g().attr({
                "class": EXPORT_CSS_CLASS + "-button"
            }).append(this._group);
            this._listGroup = renderer.g().attr({
                "class": EXPORT_CSS_CLASS + "-list"
            }).append(this._group);
            this._overlay = renderer.rect(-LIST_WIDTH + BUTTON_SIZE, BUTTON_SIZE + LIST_PADDING_TOP, LIST_WIDTH, 0);
            this._overlay.attr({
                "stroke-width": LIST_STROKE_WIDTH,
                cursor: "pointer",
                rx: 4,
                ry: 4,
                filter: this._shadow.id
            });
            this._overlay.data({
                "export-element-type": "list"
            });
            this.validFormats = getValidFormats();
            this._subscribeEvents()
        };
        exports.ExportMenu = ExportMenu;
        (0, _extend.extend)(ExportMenu.prototype, {
            getLayoutOptions: function() {
                if (this._hiddenDueToLayout) {
                    return {
                        width: 0,
                        height: 0,
                        cutSide: "vertical",
                        cutLayoutSide: "top"
                    }
                }
                var bBox = this._buttonGroup.getBBox();
                bBox.cutSide = "vertical";
                bBox.cutLayoutSide = "top";
                bBox.height += MARGIN;
                bBox.position = {
                    vertical: "top",
                    horizontal: "right"
                };
                bBox.verticalAlignment = "top";
                bBox.horizontalAlignment = "right";
                return bBox
            },
            shift: function(_, y) {
                this._group.attr({
                    translateY: this._group.attr("translateY") + y
                })
            },
            draw: function(width, height, canvas) {
                this._group.move(width - BUTTON_SIZE - SHADOW_OFFSET - SHADOW_BLUR + canvas.left, Math.floor(height / 2 - BUTTON_SIZE / 2));
                var layoutOptions = this.getLayoutOptions();
                if (layoutOptions.width > width || layoutOptions.height > height) {
                    this.freeSpace()
                }
                return this
            },
            show: function() {
                this._group.linkAppend()
            },
            hide: function() {
                this._group.linkRemove()
            },
            setOptions: function(options) {
                var _this2 = this;
                this._options = options;
                if (options.formats) {
                    options.formats = options.formats.reduce(function(r, format) {
                        format = validateFormat(format, _this2._incidentOccurred, _this2.validFormats);
                        format && r.push(format);
                        return r
                    }, [])
                } else {
                    options.formats = this.validFormats.supported.slice()
                }
                options.printingEnabled = void 0 === options.printingEnabled ? true : options.printingEnabled;
                if (options.enabled && (options.formats.length || options.printingEnabled)) {
                    this.show();
                    this._updateButton();
                    this._updateList();
                    this._hideList()
                } else {
                    this.hide()
                }
            },
            dispose: function() {
                this._unsubscribeEvents();
                this._group.linkRemove().linkOff();
                this._group.dispose();
                this._shadow.dispose()
            },
            layoutOptions: function() {
                return this._options.enabled && {
                    horizontalAlignment: "right",
                    verticalAlignment: "top",
                    weak: true
                }
            },
            measure: function() {
                this._fillSpace();
                var margin = this._options.button.margin;
                return [BUTTON_SIZE + margin.left + margin.right, BUTTON_SIZE + margin.top + margin.bottom]
            },
            move: function(rect) {
                var margin = this._options.button.margin;
                this._group.attr({
                    translateX: Math.round(rect[0]) + margin.left,
                    translateY: Math.round(rect[1]) + margin.top
                })
            },
            _fillSpace: function() {
                this._hiddenDueToLayout = false;
                this.show()
            },
            freeSpace: function() {
                this._incidentOccurred("W2107");
                this._hiddenDueToLayout = true;
                this.hide()
            },
            _hideList: function() {
                this._listGroup.remove();
                this._listShown = false;
                this._setButtonState("default");
                this._menuItems.forEach(function(item) {
                    return item.resetState()
                })
            },
            _showList: function() {
                this._listGroup.append(this._group);
                this._listShown = true;
                this._menuItems.forEach(function(item) {
                    return item.fixPosition()
                })
            },
            _setButtonState: function(state) {
                var style = this._options.button[state];
                this._button.attr({
                    stroke: style.borderColor,
                    fill: style.backgroundColor
                });
                this._icon.attr({
                    fill: style.color
                })
            },
            _subscribeEvents: function() {
                var _this3 = this;
                this._renderer.root.on(_pointer.default.up + ".export", function(e) {
                    var elementType = e.target[EXPORT_DATA_KEY];
                    if (!elementType) {
                        if (_this3._button) {
                            _this3._hideList()
                        }
                        return
                    }
                    if ("button" === elementType) {
                        if (_this3._listShown) {
                            _this3._setButtonState("default");
                            _this3._hideList()
                        } else {
                            _this3._setButtonState("focus");
                            _this3._showList()
                        }
                    } else {
                        if ("printing" === elementType) {
                            _this3._print();
                            _this3._hideList()
                        } else {
                            if ("exporting" === elementType) {
                                _this3._exportTo(e.target[FORMAT_DATA_KEY]);
                                _this3._hideList()
                            }
                        }
                    }
                });
                this._listGroup.on(pointerActions, function(e) {
                    return e.stopPropagation()
                });
                this._buttonGroup.on(_pointer.default.enter, function() {
                    return _this3._setButtonState("hover")
                });
                this._buttonGroup.on(_pointer.default.leave, function() {
                    return _this3._setButtonState(_this3._listShown ? "focus" : "default")
                });
                this._buttonGroup.on(_pointer.default.down + ".export", function() {
                    return _this3._setButtonState("active")
                })
            },
            _unsubscribeEvents: function() {
                this._renderer.root.off(".export");
                this._listGroup.off();
                this._buttonGroup.off()
            },
            _updateButton: function() {
                var renderer = this._renderer;
                var options = this._options;
                var exportData = {
                    "export-element-type": "button"
                };
                if (!this._button) {
                    this._button = renderer.rect(0, 0, BUTTON_SIZE, BUTTON_SIZE).append(this._buttonGroup);
                    this._button.attr({
                        rx: 4,
                        ry: 4,
                        fill: options.button.default.backgroundColor,
                        stroke: options.button.default.borderColor,
                        "stroke-width": 1,
                        cursor: "pointer"
                    });
                    this._button.data(exportData);
                    this._icon = renderer.path(ICON_COORDS).append(this._buttonGroup);
                    this._icon.attr({
                        fill: options.button.default.color,
                        cursor: "pointer"
                    });
                    this._icon.data(exportData);
                    this._buttonGroup.setTitle(_message.default.format("vizExport-titleMenuText"))
                }
            },
            _updateList: function() {
                var options = this._options;
                var buttonDefault = options.button.default;
                var listGroup = this._listGroup;
                var items = createMenuItems(this._renderer, options);
                this._shadow.attr({
                    color: options.shadowColor
                });
                this._overlay.attr({
                    height: items.length * MENU_ITEM_HEIGHT + 2 * LIST_STROKE_WIDTH,
                    fill: buttonDefault.backgroundColor,
                    stroke: buttonDefault.borderColor
                });
                listGroup.clear();
                this._overlay.append(listGroup);
                items.forEach(function(item) {
                    return item.g.append(listGroup)
                });
                this._menuItems = items
            }
        });

        function getExportOptions(widget, exportOptions, fileName, format) {
            if (format || exportOptions.format) {
                format = validateFormat(format || exportOptions.format, widget._incidentOccurred)
            }
            return {
                format: format || DEFAULT_EXPORT_FORMAT,
                fileName: fileName || exportOptions.fileName || "file",
                proxyUrl: exportOptions.proxyUrl,
                backgroundColor: exportOptions.backgroundColor,
                width: widget._canvas.width,
                height: widget._canvas.height,
                margin: exportOptions.margin,
                svgToCanvas: exportOptions.svgToCanvas,
                forceProxy: exportOptions.forceProxy,
                exportingAction: widget._createActionByOption("onExporting"),
                exportedAction: widget._createActionByOption("onExported"),
                fileSavingAction: widget._createActionByOption("onFileSaving")
            }
        }
        var plugin = {
            name: "export",
            init: function() {
                var _this4 = this;
                this._exportMenu = new ExportMenu({
                    renderer: this._renderer,
                    incidentOccurred: this._incidentOccurred,
                    print: function() {
                        return _this4.print()
                    },
                    exportTo: function(format) {
                        return _this4.exportTo(void 0, format)
                    }
                });
                this._layout.add(this._exportMenu)
            },
            dispose: function() {
                this._exportMenu.dispose()
            },
            members: {
                _getExportMenuOptions: function() {
                    return (0, _extend.extend)({}, this._getOption("export"), {
                        rtl: this._getOption("rtlEnabled", true)
                    })
                },
                _disablePointerEvents: function() {
                    var pointerEventsValue = this._renderer.root.attr("pointer-events");
                    this._renderer.root.attr({
                        "pointer-events": "none"
                    });
                    return pointerEventsValue
                },
                exportTo: function(fileName, format) {
                    var _this5 = this;
                    var menu = this._exportMenu;
                    var options = getExportOptions(this, this._getOption("export") || {}, fileName, format);
                    menu && menu.hide();
                    var pointerEventsValue = this._disablePointerEvents();
                    var promise = (0, _exporter.export)(this._renderer.root.element, options, getCreatorFunc(options.format)).fail(_console.logger.error).always(function() {
                        _this5._renderer.root.attr({
                            "pointer-events": pointerEventsValue
                        })
                    });
                    menu && menu.show();
                    return promise
                },
                print: function() {
                    var _this6 = this;
                    var menu = this._exportMenu;
                    var options = getExportOptions(this, this._getOption("export") || {});
                    options.exportingAction = null;
                    options.exportedAction = null;
                    options.margin = 0;
                    options.format = "PNG";
                    options.forceProxy = true;
                    options.fileSavingAction = function(eventArgs) {
                        _print("data:image/png;base64,".concat(eventArgs.data), {
                            __test: options.__test
                        });
                        eventArgs.cancel = true
                    };
                    var pointerEventsValue = this._disablePointerEvents();
                    menu && menu.hide();
                    var promise = (0, _exporter.export)(this._renderer.root.element, options, getCreatorFunc(options.format)).fail(_console.logger.error).always(function() {
                        _this6._renderer.root.attr({
                            "pointer-events": pointerEventsValue
                        })
                    });
                    menu && menu.show();
                    return promise
                }
            },
            customize: function(constructor) {
                var proto = constructor.prototype;
                constructor.addChange({
                    code: "EXPORT",
                    handler: function() {
                        this._exportMenu.setOptions(this._getExportMenuOptions());
                        this._change(["LAYOUT"])
                    },
                    isThemeDependent: true,
                    isOptionChange: true,
                    option: "export"
                });
                proto._optionChangesMap.onExporting = "EXPORT";
                proto._optionChangesMap.onExported = "EXPORT";
                proto._optionChangesMap.onFileSaving = "EXPORT"
            },
            fontFields: ["export.font"]
        };
        exports.plugin = plugin
    },
    /*!****************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/tree_map/tree_map.base.js ***!
      \****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _common = __webpack_require__( /*! ./common */ 320);
        var _node = _interopRequireDefault(__webpack_require__( /*! ./node */ 190));
        var _tiling = __webpack_require__( /*! ./tiling */ 165);
        var _colorizing = __webpack_require__( /*! ./colorizing */ 230);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _common2 = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _base_widget = _interopRequireDefault(__webpack_require__( /*! ../core/base_widget */ 113));
        __webpack_require__( /*! ./tiling.squarified */ 483);
        __webpack_require__( /*! ./colorizing.discrete */ 485);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _data_source = __webpack_require__( /*! ../core/data_source */ 164);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _max = Math.max;
        var directions = {
            lefttoprightbottom: [1, 1],
            leftbottomrighttop: [1, -1],
            righttopleftbottom: [-1, 1],
            rightbottomlefttop: [-1, -1]
        };
        (0, _tiling.setDefaultAlgorithm)("squarified");
        (0, _colorizing.setDefaultColorizer)("discrete");

        function pickPositiveInteger(val) {
            return val > 0 ? Math.round(val) : 0
        }
        var dxTreeMap = _base_widget.default.inherit({
            _handlers: {
                beginBuildNodes: _common2.noop,
                buildNode: _common2.noop,
                endBuildNodes: _common2.noop,
                setTrackerData: _common2.noop,
                calculateState: function(options) {
                    return (0, _common.buildRectAppearance)(options)
                }
            },
            _rootClass: "dxtm-tree-map",
            _rootClassPrefix: "dxtm",
            _getDefaultSize: function() {
                return {
                    width: 400,
                    height: 400
                }
            },
            _themeSection: "treeMap",
            _fontFields: ["tile.label.font", "group.label.font"],
            _init: function() {
                var that = this;
                that._rectOffsets = {};
                that._handlers = Object.create(that._handlers);
                that._context = {
                    suspend: function() {
                        if (!that._applyingChanges) {
                            that._suspendChanges()
                        }
                    },
                    resume: function() {
                        if (!that._applyingChanges) {
                            that._resumeChanges()
                        }
                    },
                    change: function(codes) {
                        that._change(codes)
                    },
                    settings: [{}, {}],
                    calculateState: that._handlers.calculateState,
                    calculateLabelState: _common.buildTextAppearance
                };
                that._root = that._topNode = {
                    nodes: []
                };
                that.callBase.apply(that, arguments)
            },
            _initialChanges: ["DATA_SOURCE"],
            _initCore: function() {
                var that = this;
                var renderer = that._renderer;
                that._createProxyType();
                that._tilesGroup = renderer.g().linkOn(renderer.root, "tiles").linkAppend();
                that._labelsGroup = renderer.g().linkOn(renderer.root, "labels").linkAppend()
            },
            _createProxyType: _common2.noop,
            _disposeCore: function() {
                var that = this;
                that._filter && that._filter.dispose();
                that._labelsGroup.linkOff();
                that._tilesGroup.linkOff()
            },
            _applySize: function(rect) {
                this._tilingRect = rect.slice();
                this._change(["TILING"])
            },
            _optionChangesMap: {
                dataSource: "DATA_SOURCE",
                valueField: "NODES_CREATE",
                childrenField: "NODES_CREATE",
                colorField: "TILES",
                colorizer: "TILES",
                labelField: "LABELS",
                tile: "TILE_SETTINGS",
                group: "GROUP_SETTINGS",
                maxDepth: "MAX_DEPTH",
                layoutAlgorithm: "TILING",
                layoutDirection: "TILING"
            },
            _themeDependentChanges: ["TILE_SETTINGS", "GROUP_SETTINGS", "MAX_DEPTH"],
            _changeDataSource: function() {
                var that = this;
                that._isDataExpected = that._isSyncData = true;
                that._updateDataSource();
                that._isSyncData = false;
                if (that._isDataExpected) {
                    that._suspendChanges()
                }
            },
            _dataSourceChangedHandler: function() {
                var that = this;
                if (that._isDataExpected) {
                    that._isDataExpected = false;
                    that._change(["NODES_CREATE"]);
                    if (!that._isSyncData) {
                        that._resumeChanges()
                    }
                } else {
                    that._requestChange(["NODES_CREATE"])
                }
            },
            _optionChangesOrder: ["DATA_SOURCE", "TILE_SETTINGS", "GROUP_SETTINGS", "MAX_DEPTH"],
            _change_DATA_SOURCE: function() {
                this._changeDataSource()
            },
            _change_TILE_SETTINGS: function() {
                this._changeTileSettings()
            },
            _change_GROUP_SETTINGS: function() {
                this._changeGroupSettings()
            },
            _change_MAX_DEPTH: function() {
                this._changeMaxDepth()
            },
            _customChangesOrder: ["NODES_CREATE", "NODES_RESET", "TILES", "LABELS", "TILING", "LABELS_LAYOUT"],
            _change_NODES_CREATE: function() {
                this._buildNodes()
            },
            _change_NODES_RESET: function() {
                this._resetNodes()
            },
            _change_TILES: function() {
                this._applyTilesAppearance()
            },
            _change_LABELS: function() {
                this._applyLabelsAppearance()
            },
            _change_TILING: function() {
                this._performTiling()
            },
            _change_LABELS_LAYOUT: function() {
                this._performLabelsLayout()
            },
            _applyChanges: function() {
                var that = this;
                that.callBase.apply(that, arguments);
                if (!that._isDataExpected) {
                    that._drawn()
                }
                that._context.forceReset = false
            },
            _buildNodes: function() {
                var that = this;
                var root = that._root = that._topNode = new _node.default;
                root._id = 0;
                root.parent = {};
                root.data = {};
                root.level = root.index = -1;
                root.ctx = that._context;
                root.label = null;
                that._nodes = [root];
                that._handlers.beginBuildNodes();
                var processedData = that._processDataSourceItems(that._dataSourceItems() || []);
                traverseDataItems(root, processedData.items, 0, {
                    itemsField: !processedData.isPlain && that._getOption("childrenField", true) || "items",
                    valueField: that._getOption("valueField", true) || "value",
                    buildNode: that._handlers.buildNode,
                    ctx: that._context,
                    nodes: that._nodes
                });
                that._onNodesCreated();
                that._handlers.endBuildNodes();
                that._change(["NODES_RESET"])
            },
            _onNodesCreated: _common2.noop,
            _processDataSourceItems: function(items) {
                return {
                    items: items,
                    isPlain: false
                }
            },
            _changeTileSettings: function() {
                var that = this;
                var options = that._getOption("tile");
                var offsets = that._rectOffsets;
                var borderWidth = pickPositiveInteger(options.border.width);
                var edgeOffset = borderWidth / 2;
                var innerOffset = 1 & borderWidth ? .5 : 0;
                var labelOptions = options.label;
                var settings = that._context.settings[0];
                that._change(["TILES", "LABELS"]);
                settings.state = that._handlers.calculateState(options);
                that._filter = that._filter || that._renderer.shadowFilter("-50%", "-50%", "200%", "200%");
                that._filter.attr(labelOptions.shadow);
                that._calculateLabelSettings(settings, labelOptions, that._filter.id);
                if (offsets.tileEdge !== edgeOffset || offsets.tileInner !== innerOffset) {
                    offsets.tileEdge = edgeOffset;
                    offsets.tileInner = innerOffset;
                    that._change(["TILING"])
                }
            },
            _changeGroupSettings: function() {
                var that = this;
                var options = that._getOption("group");
                var labelOptions = options.label;
                var offsets = that._rectOffsets;
                var borderWidth = pickPositiveInteger(options.border.width);
                var edgeOffset = borderWidth / 2;
                var innerOffset = 1 & borderWidth ? .5 : 0;
                var headerHeight = 0;
                var groupPadding = pickPositiveInteger(options.padding);
                var settings = that._context.settings[1];
                that._change(["TILES", "LABELS"]);
                settings.state = that._handlers.calculateState(options);
                that._calculateLabelSettings(settings, labelOptions);
                if (options.headerHeight >= 0) {
                    headerHeight = pickPositiveInteger(options.headerHeight)
                } else {
                    headerHeight = settings.labelParams.height + 2 * pickPositiveInteger(labelOptions.paddingTopBottom)
                }
                if (that._headerHeight !== headerHeight) {
                    that._headerHeight = headerHeight;
                    that._change(["TILING"])
                }
                if (that._groupPadding !== groupPadding) {
                    that._groupPadding = groupPadding;
                    that._change(["TILING"])
                }
                if (offsets.headerEdge !== edgeOffset || offsets.headerInner !== innerOffset) {
                    offsets.headerEdge = edgeOffset;
                    offsets.headerInner = innerOffset;
                    that._change(["TILING"])
                }
            },
            _calculateLabelSettings: function(settings, options, filter) {
                var bBox = this._getTextBBox(options.font);
                var paddingLeftRight = pickPositiveInteger(options.paddingLeftRight);
                var paddingTopBottom = pickPositiveInteger(options.paddingTopBottom);
                var tileLabelOptions = this._getOption("tile.label");
                var groupLabelOptions = this._getOption("group.label");
                settings.labelState = (0, _common.buildTextAppearance)(options, filter);
                settings.labelState.visible = !("visible" in options) || !!options.visible;
                settings.labelParams = {
                    height: bBox.height,
                    rtlEnabled: this._getOption("rtlEnabled", true),
                    paddingTopBottom: paddingTopBottom,
                    paddingLeftRight: paddingLeftRight,
                    tileLabelWordWrap: tileLabelOptions.wordWrap,
                    tileLabelOverflow: tileLabelOptions.textOverflow,
                    groupLabelOverflow: groupLabelOptions.textOverflow
                }
            },
            _changeMaxDepth: function() {
                var maxDepth = this._getOption("maxDepth", true);
                maxDepth = maxDepth >= 1 ? Math.round(maxDepth) : 1 / 0;
                if (this._maxDepth !== maxDepth) {
                    this._maxDepth = maxDepth;
                    this._change(["NODES_RESET"])
                }
            },
            _resetNodes: function() {
                var that = this;
                that._tilesGroup.clear();
                that._renderer.initHatching();
                that._context.forceReset = true;
                that._context.minLevel = that._topNode.level + 1;
                that._context.maxLevel = that._context.minLevel + that._maxDepth - 1;
                that._change(["TILES", "LABELS", "TILING"])
            },
            _processNodes: function(context, process) {
                processNodes(context, this._topNode, process)
            },
            _applyTilesAppearance: function() {
                var that = this;
                var colorizer = (0, _colorizing.getColorizer)(that._getOption("colorizer"), that._themeManager, that._topNode);
                that._processNodes({
                    renderer: that._renderer,
                    group: that._tilesGroup,
                    setTrackerData: that._handlers.setTrackerData,
                    colorField: that._getOption("colorField", true) || "color",
                    getColor: colorizer
                }, processTileAppearance)
            },
            _applyLabelsAppearance: function() {
                var that = this;
                that._labelsGroup.clear();
                that._processNodes({
                    renderer: that._renderer,
                    group: that._labelsGroup,
                    setTrackerData: that._handlers.setTrackerData,
                    labelField: that._getOption("labelField", true) || "name"
                }, processLabelAppearance);
                that._change(["LABELS_LAYOUT"])
            },
            _performTiling: function() {
                var that = this;
                var context = {
                    algorithm: (0, _tiling.getAlgorithm)(that._getOption("layoutAlgorithm", true)),
                    directions: directions[String(that._getOption("layoutDirection", true)).toLowerCase()] || directions.lefttoprightbottom,
                    headerHeight: that._headerHeight,
                    groupPadding: that._groupPadding,
                    rectOffsets: that._rectOffsets
                };
                that._topNode.innerRect = that._tilingRect;
                calculateRects(context, that._topNode);
                that._processNodes(context, processTiling);
                that._change(["LABELS_LAYOUT"]);
                that._onTilingPerformed()
            },
            _onTilingPerformed: _common2.noop,
            _performLabelsLayout: function() {
                this._processNodes(null, processLabelsLayout)
            },
            _getTextBBox: function(fontOptions) {
                var renderer = this._renderer;
                var text = this._textForCalculations || renderer.text("0", 0, 0);
                this._textForCalculations = text;
                text.css((0, _utils.patchFontOptions)(fontOptions)).append(renderer.root);
                var bBox = text.getBBox();
                text.remove();
                return bBox
            }
        });

        function traverseDataItems(root, dataItems, level, params) {
            var nodes = [];
            var allNodes = params.nodes;
            var node;
            var i;
            var ii = dataItems.length;
            var dataItem;
            var totalValue = 0;
            var items;
            for (i = 0; i < ii; ++i) {
                var _items;
                dataItem = dataItems[i];
                node = new _node.default;
                node._id = allNodes.length;
                node.ctx = params.ctx;
                node.parent = root;
                node.level = level;
                node.index = nodes.length;
                node.data = dataItem;
                params.buildNode(node);
                allNodes.push(node);
                nodes.push(node);
                items = dataItem[params.itemsField];
                if (null !== (_items = items) && void 0 !== _items && _items.length) {
                    traverseDataItems(node, items, level + 1, params)
                }
                if (dataItem[params.valueField] > 0) {
                    node.value = Number(dataItem[params.valueField])
                }
                totalValue += node.value
            }
            root.nodes = nodes;
            root.value = totalValue
        }

        function processNodes(context, root, process) {
            var nodes = root.nodes;
            var node;
            var i;
            var ii = nodes.length;
            for (i = 0; i < ii; ++i) {
                node = nodes[i];
                process(context, node);
                if (node.isNode()) {
                    processNodes(context, node, process)
                }
            }
        }
        var createTile = [createLeaf, createGroup];

        function processTileAppearance(context, node) {
            node.color = node.data[context.colorField] || context.getColor(node) || node.parent.color;
            node.updateStyles();
            node.tile = !node.ctx.forceReset && node.tile || createTile[Number(node.isNode())](context, node);
            node.applyState()
        }

        function createLeaf(context, node) {
            var tile = context.renderer.simpleRect().append(context.group);
            context.setTrackerData(node, tile);
            return tile
        }

        function createGroup(context, node) {
            var outer = context.renderer.simpleRect().append(context.group);
            var inner = context.renderer.simpleRect().append(context.group);
            context.setTrackerData(node, inner);
            return {
                outer: outer,
                inner: inner
            }
        }

        function processLabelAppearance(context, node) {
            node.updateLabelStyle();
            if (node.labelState.visible) {
                createLabel(context, node, node.labelState, node.labelParams)
            }
        }

        function createLabel(context, currentNode, settings, params) {
            var textData = currentNode.data[context.labelField];
            currentNode.label = textData ? String(textData) : null;
            textData = currentNode.customLabel || currentNode.label;
            if (textData) {
                currentNode.text = context.renderer.text(textData).attr(settings.attr).css(settings.css).append(context.group);
                context.setTrackerData(currentNode, currentNode.text)
            }
        }
        var emptyRect = [0, 0, 0, 0];

        function calculateRects(context, root) {
            var nodes = root.nodes;
            var items = [];
            var rects = [];
            var sum = 0;
            var i;
            var ii = items.length = rects.length = nodes.length;
            for (i = 0; i < ii; ++i) {
                sum += nodes[i].value;
                items[i] = {
                    value: nodes[i].value,
                    i: i
                }
            }
            if (sum > 0) {
                context.algorithm({
                    items: items.slice(),
                    sum: sum,
                    rect: root.innerRect.slice(),
                    isRotated: 1 & nodes[0].level,
                    directions: context.directions
                })
            }
            for (i = 0; i < ii; ++i) {
                rects[i] = items[i].rect || emptyRect
            }
            root.rects = rects
        }

        function processTiling(context, node) {
            var rect = node.parent.rects[node.index];
            var rectOffsets = context.rectOffsets;
            var headerHeight;
            if (node.isNode()) {
                setRectAttrs(node.tile.outer, buildTileRect(rect, node.parent.innerRect, rectOffsets.headerEdge, rectOffsets.headerInner));
                rect = marginateRect(rect, context.groupPadding);
                headerHeight = Math.min(context.headerHeight, rect[3] - rect[1]);
                node.rect = [rect[0], rect[1], rect[2], rect[1] + headerHeight];
                setRectAttrs(node.tile.inner, marginateRect(node.rect, rectOffsets.headerEdge));
                rect[1] += headerHeight;
                node.innerRect = rect;
                calculateRects(context, node)
            } else {
                node.rect = rect;
                setRectAttrs(node.tile, buildTileRect(rect, node.parent.innerRect, rectOffsets.tileEdge, rectOffsets.tileInner))
            }
        }

        function marginateRect(rect, margin) {
            return [rect[0] + margin, rect[1] + margin, rect[2] - margin, rect[3] - margin]
        }

        function buildTileRect(rect, outer, edgeOffset, innerOffset) {
            return [rect[0] + (rect[0] === outer[0] ? edgeOffset : +innerOffset), rect[1] + (rect[1] === outer[1] ? edgeOffset : +innerOffset), rect[2] - (rect[2] === outer[2] ? edgeOffset : -innerOffset), rect[3] - (rect[3] === outer[3] ? edgeOffset : -innerOffset)]
        }

        function setRectAttrs(element, rect) {
            element.attr({
                x: rect[0],
                y: rect[1],
                width: _max(rect[2] - rect[0], 0),
                height: _max(rect[3] - rect[1], 0)
            })
        }

        function processLabelsLayout(context, node) {
            if (node.text && node.labelState.visible) {
                layoutTextNode(node, node.labelParams)
            }
        }

        function layoutTextNode(node, params) {
            var rect = node.rect;
            var text = node.text;
            var bBox = text.getBBox();
            var paddingLeftRight = params.paddingLeftRight;
            var paddingTopBottom = params.paddingTopBottom;
            var effectiveWidth = rect[2] - rect[0] - 2 * paddingLeftRight;
            text.setMaxSize(effectiveWidth, rect[3] - rect[1] - paddingTopBottom, node.isNode() ? {
                textOverflow: params.groupLabelOverflow,
                wordWrap: "none"
            } : {
                textOverflow: params.tileLabelOverflow,
                wordWrap: params.tileLabelWordWrap,
                hideOverflowEllipsis: true
            });
            text.move(params.rtlEnabled ? rect[2] - paddingLeftRight - bBox.x - bBox.width : rect[0] + paddingLeftRight - bBox.x, rect[1] + paddingTopBottom - bBox.y)
        }(0, _component_registrator.default)("dxTreeMap", dxTreeMap);
        var _default = dxTreeMap;
        exports.default = _default;
        dxTreeMap.addPlugin(_data_source.plugin);
        module.exports = exports.default
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/console.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.debug = exports.logger = void 0;
        var _type = __webpack_require__( /*! ./type */ 1);
        var noop = function() {};
        var getConsoleMethod = function(method) {
            if ("undefined" === typeof console || !(0, _type.isFunction)(console[method])) {
                return noop
            }
            return console[method].bind(console)
        };
        var logger = {
            info: getConsoleMethod("info"),
            warn: getConsoleMethod("warn"),
            error: getConsoleMethod("error")
        };
        exports.logger = logger;
        var debug = function() {
            function assert(condition, message) {
                if (!condition) {
                    throw new Error(message)
                }
            }

            function assertParam(parameter, message) {
                assert(null !== parameter && void 0 !== parameter, message)
            }
            return {
                assert: assert,
                assertParam: assertParam
            }
        }();
        exports.debug = debug
    },
    /*!*************************************************!*\
      !*** ./artifacts/transpiled-npm/core/action.js ***!
      \*************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ./renderer */ 2));
        var _window = __webpack_require__( /*! ./utils/window */ 7);
        var _type = __webpack_require__( /*! ./utils/type */ 1);
        var _iterator = __webpack_require__( /*! ./utils/iterator */ 3);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var Action = function() {
            function Action(action, config) {
                config = config || {};
                this._action = action;
                this._context = config.context || (0, _window.getWindow)();
                this._beforeExecute = config.beforeExecute;
                this._afterExecute = config.afterExecute;
                this._component = config.component;
                this._validatingTargetName = config.validatingTargetName;
                var excludeValidators = this._excludeValidators = {};
                if (config.excludeValidators) {
                    for (var i = 0; i < config.excludeValidators.length; i++) {
                        excludeValidators[config.excludeValidators[i]] = true
                    }
                }
            }
            var _proto = Action.prototype;
            _proto.execute = function() {
                var e = {
                    action: this._action,
                    args: Array.prototype.slice.call(arguments),
                    context: this._context,
                    component: this._component,
                    validatingTargetName: this._validatingTargetName,
                    cancel: false,
                    handled: false
                };
                var beforeExecute = this._beforeExecute;
                var afterExecute = this._afterExecute;
                var argsBag = e.args[0] || {};
                if (!this._validateAction(e)) {
                    return
                }
                null === beforeExecute || void 0 === beforeExecute ? void 0 : beforeExecute.call(this._context, e);
                if (e.cancel) {
                    return
                }
                var result = this._executeAction(e);
                if (argsBag.cancel) {
                    return
                }
                null === afterExecute || void 0 === afterExecute ? void 0 : afterExecute.call(this._context, e);
                return result
            };
            _proto._validateAction = function(e) {
                var excludeValidators = this._excludeValidators;
                var executors = Action.executors;
                for (var name in executors) {
                    if (!excludeValidators[name]) {
                        var _executor$validate;
                        var executor = executors[name];
                        null === (_executor$validate = executor.validate) || void 0 === _executor$validate ? void 0 : _executor$validate.call(executor, e);
                        if (e.cancel) {
                            return false
                        }
                    }
                }
                return true
            };
            _proto._executeAction = function(e) {
                var result;
                var executors = Action.executors;
                for (var name in executors) {
                    var _executor$execute;
                    var executor = executors[name];
                    null === (_executor$execute = executor.execute) || void 0 === _executor$execute ? void 0 : _executor$execute.call(executor, e);
                    if (e.handled) {
                        result = e.result;
                        break
                    }
                }
                return result
            };
            Action.registerExecutor = function(name, executor) {
                if ((0, _type.isPlainObject)(name)) {
                    (0, _iterator.each)(name, Action.registerExecutor);
                    return
                }
                Action.executors[name] = executor
            };
            Action.unregisterExecutor = function() {
                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key]
                }(0, _iterator.each)(args, function() {
                    delete Action.executors[this]
                })
            };
            return Action
        }();
        exports.default = Action;
        Action.executors = {};
        var createValidatorByTargetElement = function(condition) {
            return function(e) {
                if (!e.args.length) {
                    return
                }
                var args = e.args[0];
                var element = args[e.validatingTargetName] || args.element;
                if (element && condition((0, _renderer.default)(element))) {
                    e.cancel = true
                }
            }
        };
        Action.registerExecutor({
            disabled: {
                validate: createValidatorByTargetElement(function($target) {
                    return $target.is(".dx-state-disabled, .dx-state-disabled *")
                })
            },
            readOnly: {
                validate: createValidatorByTargetElement(function($target) {
                    return $target.is(".dx-state-readonly, .dx-state-readonly *:not(.dx-state-independent)")
                })
            },
            undefined: {
                execute: function(e) {
                    if (!e.action) {
                        e.result = void 0;
                        e.handled = true
                    }
                }
            },
            func: {
                execute: function(e) {
                    if ((0, _type.isFunction)(e.action)) {
                        e.result = e.action.call(e.context, e.args[0]);
                        e.handled = true
                    }
                }
            }
        });
        module.exports = exports.default
    },
    /*!*********************************************!*\
      !*** ./artifacts/transpiled-npm/ui/list.js ***!
      \*********************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiListEdit = _interopRequireDefault(__webpack_require__( /*! ./list/ui.list.edit.search */ 593));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }(0, _component_registrator.default)("dxList", _uiListEdit.default);
        var _default = _uiListEdit.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/core/base_widget.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _resize_callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/resize_callbacks */ 125));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _base_theme_manager = __webpack_require__( /*! ../core/base_theme_manager */ 310);
        var _dom_component = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_component */ 67));
        var _helpers = __webpack_require__( /*! ./helpers */ 162);
        var _utils = __webpack_require__( /*! ./utils */ 14);
        var _errors_warnings = _interopRequireDefault(__webpack_require__( /*! ./errors_warnings */ 460));
        var _renderer2 = __webpack_require__( /*! ./renderers/renderer */ 177);
        var _layout = _interopRequireDefault(__webpack_require__( /*! ./layout */ 916));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _base_widget = __webpack_require__( /*! ./base_widget.utils */ 917);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _floor = Math.floor;
        var _log = _errors_warnings.default.log;
        var OPTION_RTL_ENABLED = "rtlEnabled";
        var SIZED_ELEMENT_CLASS = "dx-sized-element";
        var _option = _dom_component.default.prototype.option;

        function getTrue() {
            return true
        }

        function getFalse() {
            return false
        }

        function areCanvasesDifferent(canvas1, canvas2) {
            return !(canvas1.width === canvas2.width && canvas1.height === canvas2.height && canvas1.left === canvas2.left && canvas1.top === canvas2.top && canvas1.right === canvas2.right && canvas1.bottom === canvas2.bottom)
        }

        function defaultOnIncidentOccurred(e) {
            if (!e.component._eventsStrategy.hasEvent("incidentOccurred")) {
                _log.apply(null, [e.target.id].concat(e.target.args || []))
            }
        }

        function pickPositiveValue(values) {
            return values.reduce(function(result, value) {
                return value > 0 && !result ? value : result
            }, 0)
        }
        var getEmptyComponent = function() {
            var emptyComponentConfig = {
                _initTemplates: function() {},
                ctor: function(element, options) {
                    this.callBase(element, options);
                    var sizedElement = _dom_adapter.default.createElement("div");
                    var width = options && (0, _type.isNumeric)(options.width) ? options.width + "px" : "100%";
                    var height = options && (0, _type.isNumeric)(options.height) ? options.height + "px" : this._getDefaultSize().height + "px";
                    _dom_adapter.default.setStyle(sizedElement, "width", width);
                    _dom_adapter.default.setStyle(sizedElement, "height", height);
                    _dom_adapter.default.setClass(sizedElement, SIZED_ELEMENT_CLASS);
                    _dom_adapter.default.insertElement(element, sizedElement)
                }
            };
            var EmptyComponent = _dom_component.default.inherit(emptyComponentConfig);
            var originalInherit = EmptyComponent.inherit;
            EmptyComponent.inherit = function(config) {
                for (var field in config) {
                    if ((0, _type.isFunction)(config[field]) && "_" !== field.substr(0, 1) && "option" !== field || "_dispose" === field || "_optionChanged" === field) {
                        config[field] = _common.noop
                    }
                }
                return originalInherit.call(this, config)
            };
            return EmptyComponent
        };

        function callForEach(functions) {
            functions.forEach(function(c) {
                return c()
            })
        }
        var isServerSide = !(0, _window.hasWindow)();

        function sizeIsValid(value) {
            return (0, _type.isDefined)(value) && value > 0
        }
        var baseWidget = isServerSide ? getEmptyComponent() : _dom_component.default.inherit({
            _eventsMap: {
                onIncidentOccurred: {
                    name: "incidentOccurred"
                },
                onDrawn: {
                    name: "drawn"
                }
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    onIncidentOccurred: defaultOnIncidentOccurred
                })
            },
            _useLinks: true,
            _init: function() {
                var that = this;
                that._$element.children("." + SIZED_ELEMENT_CLASS).remove();
                that.callBase.apply(that, arguments);
                that._changesLocker = 0;
                that._optionChangedLocker = 0;
                that._asyncFirstDrawing = true;
                that._changes = (0, _helpers.changes)();
                that._suspendChanges();
                that._themeManager = that._createThemeManager();
                that._themeManager.setCallback(function() {
                    that._requestChange(that._themeDependentChanges)
                });
                that._renderElementAttributes();
                that._initRenderer();
                var linkTarget = that._useLinks && that._renderer.root;
                linkTarget && linkTarget.enableLinks().virtualLink("core").virtualLink("peripheral");
                that._renderVisibilityChange();
                that._attachVisibilityChangeHandlers();
                that._toggleParentsScrollSubscription(this._isVisible());
                that._initEventTrigger();
                that._incidentOccurred = (0, _base_widget.createIncidentOccurred)(that.NAME, that._eventTrigger);
                that._layout = new _layout.default;
                linkTarget && linkTarget.linkAfter("core");
                that._initPlugins();
                that._initCore();
                linkTarget && linkTarget.linkAfter();
                that._change(that._initialChanges)
            },
            _createThemeManager: function() {
                return new _base_theme_manager.BaseThemeManager(this._getThemeManagerOptions())
            },
            _getThemeManagerOptions: function() {
                return {
                    themeSection: this._themeSection,
                    fontFields: this._fontFields
                }
            },
            _initialChanges: ["LAYOUT", "RESIZE_HANDLER", "THEME", "DISABLED"],
            _initPlugins: function() {
                var that = this;
                (0, _iterator.each)(that._plugins, function(_, plugin) {
                    plugin.init.call(that)
                })
            },
            _disposePlugins: function() {
                var that = this;
                (0, _iterator.each)(that._plugins.slice().reverse(), function(_, plugin) {
                    plugin.dispose.call(that)
                })
            },
            _change: function(codes) {
                this._changes.add(codes)
            },
            _suspendChanges: function() {
                ++this._changesLocker
            },
            _resumeChanges: function() {
                var that = this;
                if (0 === --that._changesLocker && that._changes.count() > 0 && !that._applyingChanges) {
                    that._renderer.lock();
                    that._applyingChanges = true;
                    that._applyChanges();
                    that._changes.reset();
                    that._applyingChanges = false;
                    that._changesApplied();
                    that._renderer.unlock();
                    if (that._optionsQueue) {
                        that._applyQueuedOptions()
                    }
                    that.resolveItemsDeferred(that._legend ? [that._legend] : []);
                    that._optionChangedLocker++;
                    that._notify();
                    that._optionChangedLocker--
                }
            },
            resolveItemsDeferred: function(items) {
                this._resolveDeferred(this._getTemplatesItems(items))
            },
            _collectTemplatesFromItems: function(items) {
                return items.reduce(function(prev, i) {
                    return {
                        items: prev.items.concat(i.getTemplatesDef()),
                        groups: prev.groups.concat(i.getTemplatesGroups())
                    }
                }, {
                    items: [],
                    groups: []
                })
            },
            _getTemplatesItems: function(items) {
                var elements = this._collectTemplatesFromItems(items);
                var extraItems = this._getExtraTemplatesItems();
                return {
                    items: extraItems.items.concat(elements.items),
                    groups: extraItems.groups.concat(elements.groups),
                    launchRequest: [extraItems.launchRequest],
                    doneRequest: [extraItems.doneRequest]
                }
            },
            _getExtraTemplatesItems: function() {
                return {
                    items: [],
                    groups: [],
                    launchRequest: function() {},
                    doneRequest: function() {}
                }
            },
            _resolveDeferred: function(_ref) {
                var items = _ref.items,
                    launchRequest = _ref.launchRequest,
                    doneRequest = _ref.doneRequest,
                    groups = _ref.groups;
                var that = this;
                that._setGroupsVisibility(groups, "hidden");
                if (that._changesApplying) {
                    that._changesApplying = false;
                    callForEach(doneRequest);
                    return
                }
                var syncRendering = true;
                _deferred.when.apply(that, items).done(function() {
                    if (syncRendering) {
                        that._setGroupsVisibility(groups, "visible");
                        return
                    }
                    callForEach(launchRequest);
                    that._changesApplying = true;
                    var changes = ["LAYOUT", "FULL_RENDER"];
                    if (that._asyncFirstDrawing) {
                        changes.push("FORCE_FIRST_DRAWING");
                        that._asyncFirstDrawing = false
                    } else {
                        changes.push("FORCE_DRAWING")
                    }
                    that._requestChange(changes);
                    that._setGroupsVisibility(groups, "visible")
                });
                syncRendering = false
            },
            _setGroupsVisibility: function(groups, visibility) {
                groups.forEach(function(g) {
                    return g.attr({
                        visibility: visibility
                    })
                })
            },
            _applyQueuedOptions: function() {
                var that = this;
                var queue = that._optionsQueue;
                that._optionsQueue = null;
                that.beginUpdate();
                (0, _iterator.each)(queue, function(_, action) {
                    action()
                });
                that.endUpdate()
            },
            _requestChange: function(codes) {
                this._suspendChanges();
                this._change(codes);
                this._resumeChanges()
            },
            _applyChanges: function() {
                var that = this;
                var changes = that._changes;
                var order = that._totalChangesOrder;
                var i;
                var ii = order.length;
                for (i = 0; i < ii; ++i) {
                    if (changes.has(order[i])) {
                        that["_change_" + order[i]]()
                    }
                }
            },
            _optionChangesOrder: ["EVENTS", "THEME", "RENDERER", "RESIZE_HANDLER"],
            _layoutChangesOrder: ["ELEMENT_ATTR", "CONTAINER_SIZE", "LAYOUT"],
            _customChangesOrder: ["DISABLED"],
            _change_EVENTS: function() {
                this._eventTrigger.applyChanges()
            },
            _change_THEME: function() {
                this._setThemeAndRtl()
            },
            _change_RENDERER: function() {
                this._setRendererOptions()
            },
            _change_RESIZE_HANDLER: function() {
                this._setupResizeHandler()
            },
            _change_ELEMENT_ATTR: function() {
                this._renderElementAttributes();
                this._change(["CONTAINER_SIZE"])
            },
            _change_CONTAINER_SIZE: function() {
                this._updateSize()
            },
            _change_LAYOUT: function() {
                this._setContentSize()
            },
            _change_DISABLED: function() {
                var renderer = this._renderer;
                var root = renderer.root;
                if (this.option("disabled")) {
                    this._initDisabledState = root.attr("pointer-events");
                    root.attr({
                        "pointer-events": "none",
                        filter: renderer.getGrayScaleFilter().id
                    })
                } else {
                    if ("none" === root.attr("pointer-events")) {
                        root.attr({
                            "pointer-events": (0, _type.isDefined)(this._initDisabledState) ? this._initDisabledState : null,
                            filter: null
                        })
                    }
                }
            },
            _themeDependentChanges: ["RENDERER"],
            _initRenderer: function() {
                var that = this;
                that._canvas = that._calculateCanvas();
                that._renderer = new _renderer2.Renderer({
                    cssClass: that._rootClassPrefix + " " + that._rootClass,
                    pathModified: that.option("pathModified"),
                    container: that._$element[0]
                });
                that._renderer.resize(that._canvas.width, that._canvas.height)
            },
            _disposeRenderer: function() {
                this._renderer.dispose()
            },
            _getAnimationOptions: _common.noop,
            render: function() {
                this._requestChange(["CONTAINER_SIZE"]);
                var visible = this._isVisible();
                this._toggleParentsScrollSubscription(visible);
                !visible && this._stopCurrentHandling()
            },
            _toggleParentsScrollSubscription: function(subscribe) {
                var $parents = (0, _renderer.default)(this._renderer.root.element).parents();
                var scrollEvents = "scroll.viz_widgets";
                if ("generic" === _devices.default.real().platform) {
                    $parents = $parents.add((0, _window.getWindow)())
                }
                this._proxiedTargetParentsScrollHandler = this._proxiedTargetParentsScrollHandler || function() {
                    this._stopCurrentHandling()
                }.bind(this);
                _events_engine.default.off((0, _renderer.default)().add(this._$prevRootParents), scrollEvents, this._proxiedTargetParentsScrollHandler);
                if (subscribe) {
                    _events_engine.default.on($parents, scrollEvents, this._proxiedTargetParentsScrollHandler);
                    this._$prevRootParents = $parents
                }
            },
            _stopCurrentHandling: _common.noop,
            _dispose: function() {
                var that = this;
                that.callBase.apply(that, arguments);
                that._toggleParentsScrollSubscription(false);
                that._removeResizeHandler();
                that._layout.dispose();
                that._eventTrigger.dispose();
                that._disposeCore();
                that._disposePlugins();
                that._disposeRenderer();
                that._themeManager.dispose();
                that._themeManager = that._renderer = that._eventTrigger = null
            },
            _initEventTrigger: function() {
                var that = this;
                that._eventTrigger = (0, _base_widget.createEventTrigger)(that._eventsMap, function(name) {
                    return that._createActionByOption(name)
                })
            },
            _calculateCanvas: function() {
                var that = this;
                var size = that.option("size") || {};
                var margin = that.option("margin") || {};
                var defaultCanvas = that._getDefaultSize() || {};
                var getSizeOfSide = function(size, side) {
                    if (sizeIsValid(size[side]) || !(0, _window.hasWindow)()) {
                        return 0
                    }
                    var elementSize = that._$element[side]();
                    return elementSize <= 1 ? 0 : elementSize
                };
                var elementWidth = getSizeOfSide(size, "width");
                var elementHeight = getSizeOfSide(size, "height");
                var canvas = {
                    width: size.width <= 0 ? 0 : _floor(pickPositiveValue([size.width, elementWidth, defaultCanvas.width])),
                    height: size.height <= 0 ? 0 : _floor(pickPositiveValue([size.height, elementHeight, defaultCanvas.height])),
                    left: pickPositiveValue([margin.left, defaultCanvas.left]),
                    top: pickPositiveValue([margin.top, defaultCanvas.top]),
                    right: pickPositiveValue([margin.right, defaultCanvas.right]),
                    bottom: pickPositiveValue([margin.bottom, defaultCanvas.bottom])
                };
                if (canvas.width - canvas.left - canvas.right <= 0 || canvas.height - canvas.top - canvas.bottom <= 0) {
                    canvas = {
                        width: 0,
                        height: 0
                    }
                }
                return canvas
            },
            _updateSize: function() {
                var that = this;
                var canvas = that._calculateCanvas();
                that._renderer.fixPlacement();
                if (areCanvasesDifferent(that._canvas, canvas) || that.__forceRender) {
                    that._canvas = canvas;
                    that._recreateSizeDependentObjects(true);
                    that._renderer.resize(canvas.width, canvas.height);
                    that._change(["LAYOUT"])
                }
            },
            _recreateSizeDependentObjects: _common.noop,
            _getMinSize: function() {
                return [0, 0]
            },
            _getAlignmentRect: _common.noop,
            _setContentSize: function() {
                var canvas = this._canvas;
                var layout = this._layout;
                var rect = canvas.width > 0 && canvas.height > 0 ? [canvas.left, canvas.top, canvas.width - canvas.right, canvas.height - canvas.bottom] : [0, 0, 0, 0];
                rect = layout.forward(rect, this._getMinSize());
                var nextRect = this._applySize(rect) || rect;
                layout.backward(nextRect, this._getAlignmentRect() || nextRect)
            },
            _getOption: function(name, isScalar) {
                var theme = this._themeManager.theme(name);
                var option = this.option(name);
                return isScalar ? void 0 !== option ? option : theme : (0, _extend.extend)(true, {}, theme, option)
            },
            _setupResizeHandler: function() {
                var that = this;
                var redrawOnResize = (0, _utils.parseScalar)(this._getOption("redrawOnResize", true), true);
                if (that._resizeHandler) {
                    that._removeResizeHandler()
                }
                that._resizeHandler = (0, _base_widget.createResizeHandler)(function() {
                    if (redrawOnResize) {
                        that._requestChange(["CONTAINER_SIZE"])
                    } else {
                        that._renderer.fixPlacement()
                    }
                });
                _resize_callbacks.default.add(that._resizeHandler)
            },
            _removeResizeHandler: function() {
                if (this._resizeHandler) {
                    _resize_callbacks.default.remove(this._resizeHandler);
                    this._resizeHandler.dispose();
                    this._resizeHandler = null
                }
            },
            _onBeginUpdate: _common.noop,
            beginUpdate: function() {
                var that = this;
                if (that._initialized && that._isUpdateAllowed()) {
                    that._onBeginUpdate();
                    that._suspendChanges()
                }
                that.callBase.apply(that, arguments);
                return that
            },
            endUpdate: function() {
                this.callBase();
                this._isUpdateAllowed() && this._resumeChanges();
                return this
            },
            option: function(name) {
                var that = this;
                if (that._initialized && that._applyingChanges && (arguments.length > 1 || (0, _type.isObject)(name))) {
                    that._optionsQueue = that._optionsQueue || [];
                    that._optionsQueue.push(that._getActionForUpdating(arguments))
                } else {
                    return _option.apply(that, arguments)
                }
            },
            _getActionForUpdating: function(args) {
                var that = this;
                return function() {
                    _option.apply(that, args)
                }
            },
            _clean: _common.noop,
            _render: _common.noop,
            _optionChanged: function(arg) {
                var that = this;
                if (that._optionChangedLocker) {
                    return
                }
                var partialChanges = that.getPartialChangeOptionsName(arg);
                var changes = [];
                if (partialChanges.length > 0) {
                    partialChanges.forEach(function(pc) {
                        return changes.push(that._partialOptionChangesMap[pc])
                    })
                } else {
                    changes.push(that._optionChangesMap[arg.name])
                }
                changes = changes.filter(function(c) {
                    return !!c
                });
                if (that._eventTrigger.change(arg.name)) {
                    that._change(["EVENTS"])
                } else {
                    if (changes.length > 0) {
                        that._change(changes)
                    } else {
                        that.callBase.apply(that, arguments)
                    }
                }
            },
            _notify: _common.noop,
            _changesApplied: _common.noop,
            _optionChangesMap: {
                size: "CONTAINER_SIZE",
                margin: "CONTAINER_SIZE",
                redrawOnResize: "RESIZE_HANDLER",
                theme: "THEME",
                rtlEnabled: "THEME",
                encodeHtml: "THEME",
                elementAttr: "ELEMENT_ATTR",
                disabled: "DISABLED"
            },
            _partialOptionChangesMap: {},
            _partialOptionChangesPath: {},
            getPartialChangeOptionsName: function(changedOption) {
                var that = this;
                var fullName = changedOption.fullName;
                var sections = fullName.split(/[.]/);
                var name = changedOption.name;
                var value = changedOption.value;
                var options = this._partialOptionChangesPath[name];
                var partialChangeOptionsName = [];
                if (options) {
                    if (true === options) {
                        partialChangeOptionsName.push(name)
                    } else {
                        options.forEach(function(op) {
                            fullName.indexOf(op) >= 0 && partialChangeOptionsName.push(op)
                        });
                        if (1 === sections.length) {
                            if ("object" === (0, _type.type)(value)) {
                                that._addOptionsNameForPartialUpdate(value, options, partialChangeOptionsName)
                            } else {
                                if ("array" === (0, _type.type)(value)) {
                                    if (value.length > 0 && value.every(function(item) {
                                            return that._checkOptionsForPartialUpdate(item, options)
                                        })) {
                                        value.forEach(function(item) {
                                            return that._addOptionsNameForPartialUpdate(item, options, partialChangeOptionsName)
                                        })
                                    }
                                }
                            }
                        }
                    }
                }
                return partialChangeOptionsName.filter(function(value, index, self) {
                    return self.indexOf(value) === index
                })
            },
            _checkOptionsForPartialUpdate: function(optionObject, options) {
                return !Object.keys(optionObject).some(function(key) {
                    return options.indexOf(key) === -1
                })
            },
            _addOptionsNameForPartialUpdate: function(optionObject, options, partialChangeOptionsName) {
                var optionKeys = Object.keys(optionObject);
                if (this._checkOptionsForPartialUpdate(optionObject, options)) {
                    optionKeys.forEach(function(key) {
                        return options.indexOf(key) > -1 && partialChangeOptionsName.push(key)
                    })
                }
            },
            _visibilityChanged: function() {
                this.render()
            },
            _setThemeAndRtl: function() {
                this._themeManager.setTheme(this.option("theme"), this.option(OPTION_RTL_ENABLED))
            },
            _getRendererOptions: function() {
                return {
                    rtl: this.option(OPTION_RTL_ENABLED),
                    encodeHtml: this.option("encodeHtml"),
                    animation: this._getAnimationOptions()
                }
            },
            _setRendererOptions: function() {
                this._renderer.setOptions(this._getRendererOptions())
            },
            svg: function() {
                return this._renderer.svg()
            },
            getSize: function() {
                var canvas = this._canvas || {};
                return {
                    width: canvas.width,
                    height: canvas.height
                }
            },
            isReady: getFalse,
            _dataIsReady: getTrue,
            _resetIsReady: function() {
                this.isReady = getFalse
            },
            _drawn: function() {
                var that = this;
                that.isReady = getFalse;
                if (that._dataIsReady()) {
                    that._renderer.onEndAnimation(function() {
                        that.isReady = getTrue
                    })
                }
                that._eventTrigger("drawn", {})
            }
        });
        var _default = baseWidget;
        exports.default = _default;
        (0, _helpers.replaceInherit)(baseWidget);
        module.exports = exports.default
    },
    /*!***********************************************************!*\
      !*** ./artifacts/transpiled-npm/localization/currency.js ***!
      \***********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _default = {
            _formatNumberCore: function(value, format, formatConfig) {
                if ("currency" === format) {
                    formatConfig.precision = formatConfig.precision || 0;
                    var result = this.format(value, (0, _extend.extend)({}, formatConfig, {
                        type: "fixedpoint"
                    }));
                    var currencyPart = this.getCurrencySymbol().symbol.replace(/\$/g, "$$$$");
                    result = result.replace(/^(\D*)(\d.*)/, "$1" + currencyPart + "$2");
                    return result
                }
                return this.callBase.apply(this, arguments)
            },
            getCurrencySymbol: function() {
                return {
                    symbol: "$"
                }
            },
            getOpenXmlCurrencyFormat: function() {
                return "$#,##0{0}_);\\($#,##0{0}\\)"
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/list/ui.list.edit.decorator_registry.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.register = register;
        exports.registry = void 0;
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var registry = {};
        exports.registry = registry;

        function register(option, type, decoratorClass) {
            var decoratorsRegistry = registry;
            var decoratorConfig = {};
            decoratorConfig[option] = decoratorsRegistry[option] ? decoratorsRegistry[option] : {};
            decoratorConfig[option][type] = decoratorClass;
            decoratorsRegistry = (0, _extend.extend)(decoratorsRegistry, decoratorConfig)
        }
    },
    /*!***************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/number_box.js ***!
      \***************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _number_box = _interopRequireDefault(__webpack_require__( /*! ./number_box/number_box */ 614));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _number_box.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/select_box.js ***!
      \***************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _array = __webpack_require__( /*! ../core/utils/array */ 12);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);
        var _element = __webpack_require__( /*! ../core/element */ 18);
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../core/errors */ 25));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../core/dom_adapter */ 11));
        var _utils = __webpack_require__( /*! ./widget/utils.ink_ripple */ 82);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../localization/message */ 10));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./drop_down_editor/ui.drop_down_list */ 269));
        var _index = __webpack_require__( /*! ../events/utils/index */ 8);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DISABLED_STATE_SELECTOR = ".dx-state-disabled";
        var SELECTBOX_CLASS = "dx-selectbox";
        var SELECTBOX_POPUP_CLASS = "dx-selectbox-popup";
        var SELECTBOX_CONTAINER_CLASS = "dx-selectbox-container";
        var SELECTBOX_POPUP_WRAPPER_CLASS = "dx-selectbox-popup-wrapper";
        var SelectBox = _ui.default.inherit({
            _supportedKeys: function() {
                var that = this;
                var parent = this.callBase();
                var clearSelectBox = function(e) {
                    var isEditable = this._isEditable();
                    if (!isEditable) {
                        if (this.option("showClearButton")) {
                            e.preventDefault();
                            this.reset()
                        }
                    } else {
                        if (this._valueSubstituted()) {
                            this._preventFiltering = true
                        }
                    }
                    this._savedTextRemoveEvent = e;
                    this._preventSubstitution = true
                };
                var searchIfNeeded = function() {
                    if (that.option("searchEnabled") && that._valueSubstituted()) {
                        that._searchHandler()
                    }
                };
                return (0, _extend.extend)({}, parent, {
                    tab: function() {
                        if (this.option("opened") && "instantly" === this.option("applyValueMode")) {
                            this._resetCaretPosition(true)
                        }
                        parent.tab && parent.tab.apply(this, arguments);
                        this._cancelSearchIfNeed()
                    },
                    upArrow: function(e) {
                        if (parent.upArrow && parent.upArrow.apply(this, arguments)) {
                            if (!this.option("opened")) {
                                this._setNextValue(e)
                            }
                            return true
                        }
                    },
                    downArrow: function(e) {
                        if (parent.downArrow && parent.downArrow.apply(this, arguments)) {
                            if (!this.option("opened")) {
                                this._setNextValue(e)
                            }
                            return true
                        }
                    },
                    leftArrow: function() {
                        searchIfNeeded();
                        parent.leftArrow && parent.leftArrow.apply(this, arguments)
                    },
                    rightArrow: function() {
                        searchIfNeeded();
                        parent.rightArrow && parent.rightArrow.apply(this, arguments)
                    },
                    home: function() {
                        searchIfNeeded();
                        parent.home && parent.home.apply(this, arguments)
                    },
                    end: function() {
                        searchIfNeeded();
                        parent.end && parent.end.apply(this, arguments)
                    },
                    escape: function() {
                        var result = parent.escape && parent.escape.apply(this, arguments);
                        this._cancelEditing();
                        return null !== result && void 0 !== result ? result : true
                    },
                    enter: function(e) {
                        var isOpened = this.option("opened");
                        var inputText = this._input().val().trim();
                        var isCustomText = inputText && this._list && !this._list.option("focusedElement");
                        if (!inputText && (0, _type.isDefined)(this.option("value")) && this.option("allowClearing")) {
                            this._saveValueChangeEvent(e);
                            this.option({
                                selectedItem: null,
                                value: null
                            });
                            this.close()
                        } else {
                            if (this.option("acceptCustomValue")) {
                                e.preventDefault();
                                if (isCustomText) {
                                    if (isOpened) {
                                        this._toggleOpenState()
                                    }
                                    this._valueChangeEventHandler(e)
                                }
                                return isOpened
                            }
                            if (parent.enter && parent.enter.apply(this, arguments)) {
                                return isOpened
                            }
                        }
                    },
                    space: function(e) {
                        var isOpened = this.option("opened");
                        var isSearchEnabled = this.option("searchEnabled");
                        var acceptCustomValue = this.option("acceptCustomValue");
                        if (!isOpened || isSearchEnabled || acceptCustomValue) {
                            return
                        }
                        e.preventDefault();
                        this._valueChangeEventHandler(e);
                        return true
                    },
                    backspace: clearSelectBox,
                    del: clearSelectBox
                })
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    placeholder: _message.default.format("Select"),
                    fieldTemplate: null,
                    valueChangeEvent: "change",
                    acceptCustomValue: false,
                    onCustomItemCreating: function(e) {
                        if (!(0, _type.isDefined)(e.customItem)) {
                            e.customItem = e.text
                        }
                    },
                    showSelectionControls: false,
                    allowClearing: true,
                    tooltipEnabled: false,
                    openOnFieldClick: true,
                    showDropDownButton: true,
                    displayCustomValue: false,
                    useInkRipple: false,
                    useHiddenSubmitElement: true
                })
            },
            _init: function() {
                this.callBase();
                this._initCustomItemCreatingAction()
            },
            _initMarkup: function() {
                this.$element().addClass(SELECTBOX_CLASS);
                this._renderTooltip();
                this.option("useInkRipple") && this._renderInkRipple();
                this.callBase();
                this._$container.addClass(SELECTBOX_CONTAINER_CLASS)
            },
            _renderInkRipple: function() {
                this._inkRipple = (0, _utils.render)()
            },
            _toggleActiveState: function($element, value, e) {
                this.callBase.apply(this, arguments);
                if (!this._inkRipple || this._isEditable()) {
                    return
                }
                var config = {
                    element: this._inputWrapper(),
                    event: e
                };
                if (value) {
                    this._inkRipple.showWave(config)
                } else {
                    this._inkRipple.hideWave(config)
                }
            },
            _createPopup: function() {
                this.callBase();
                this._popup.$element().addClass(SELECTBOX_POPUP_CLASS);
                this._popup.overlayContent().attr("tabindex", -1)
            },
            _popupWrapperClass: function() {
                return this.callBase() + " " + SELECTBOX_POPUP_WRAPPER_CLASS
            },
            _cancelEditing: function() {
                if (!this.option("searchEnabled") && this._list) {
                    this._focusListElement(null);
                    this._updateField(this.option("selectedItem"))
                }
            },
            _renderOpenedState: function() {
                this.callBase();
                if (this.option("opened")) {
                    this._scrollToSelectedItem();
                    this._focusSelectedElement()
                }
            },
            _focusSelectedElement: function() {
                var searchValue = this._searchValue();
                if (!searchValue) {
                    this._focusListElement(null);
                    return
                }
                var $listItems = this._list._itemElements();
                var index = (0, _array.inArray)(this.option("selectedItem"), this.option("items"));
                var focusedElement = index >= 0 && !this._isCustomItemSelected() ? $listItems.eq(index) : null;
                this._focusListElement(focusedElement)
            },
            _renderFocusedElement: function() {
                if (!this._list) {
                    return
                }
                var searchValue = this._searchValue();
                if (!searchValue || this.option("acceptCustomValue")) {
                    this._focusListElement(null);
                    return
                }
                var $listItems = this._list._itemElements();
                var focusedElement = $listItems.not(DISABLED_STATE_SELECTOR).eq(0);
                this._focusListElement(focusedElement)
            },
            _focusListElement: function(element) {
                this._preventInputValueRender = true;
                this._list.option("focusedElement", (0, _element.getPublicElement)(element));
                delete this._preventInputValueRender
            },
            _scrollToSelectedItem: function() {
                this._list && this._list.scrollToItem(this._list.option("selectedItem"))
            },
            _listContentReadyHandler: function() {
                this.callBase();
                var isPaginate = this._dataSource && this._dataSource.paginate();
                if (isPaginate && this._needPopupRepaint()) {
                    return
                }
                this._scrollToSelectedItem()
            },
            _renderValue: function() {
                this._renderInputValue();
                this._setSubmitValue();
                return (new _deferred.Deferred).resolve()
            },
            _renderInputValue: function() {
                return this.callBase().always(function() {
                    this._renderInputValueAsync()
                }.bind(this))
            },
            _renderInputValueAsync: function() {
                this._renderTooltip();
                this._renderInputValueImpl().always(function() {
                    this._refreshSelected()
                }.bind(this))
            },
            _renderInputValueImpl: function() {
                this._renderField();
                return (new _deferred.Deferred).resolve()
            },
            _setNextItem: function(step) {
                var item = this._calcNextItem(step);
                var value = this._valueGetter(item);
                this._setValue(value)
            },
            _setNextValue: function(e) {
                var dataSourceIsLoaded = this._dataSource.isLoaded() ? (new _deferred.Deferred).resolve() : this._dataSource.load();
                dataSourceIsLoaded.done(function() {
                    var selectedIndex = this._getSelectedIndex();
                    var hasPages = this._dataSource.pageSize();
                    var isLastPage = this._dataSource.isLastPage();
                    var isLastItem = selectedIndex === this._items().length - 1;
                    this._saveValueChangeEvent(e);
                    var step = "downArrow" === (0, _index.normalizeKeyName)(e) ? 1 : -1;
                    if (hasPages && !isLastPage && isLastItem && step > 0) {
                        if (!this._popup) {
                            this._createPopup()
                        }
                        if (!this._dataSource.isLoading()) {
                            this._list._loadNextPage().done(this._setNextItem.bind(this, step))
                        }
                    } else {
                        this._setNextItem(step)
                    }
                }.bind(this))
            },
            _setSelectedItem: function(item) {
                var isUnknownItem = !this._isCustomValueAllowed() && void 0 === item;
                this.callBase(isUnknownItem ? null : item);
                if (!isUnknownItem && (!this._isEditable() || this._isCustomItemSelected())) {
                    this._setListOption("selectedItem", this.option("selectedItem"))
                }
            },
            _isCustomValueAllowed: function() {
                return this.option("acceptCustomValue") || this.callBase()
            },
            _displayValue: function(item) {
                item = !(0, _type.isDefined)(item) && this._isCustomValueAllowed() ? this.option("value") : item;
                return this.callBase(item)
            },
            _listConfig: function() {
                var result = (0, _extend.extend)(this.callBase(), {
                    pageLoadMode: "scrollBottom",
                    onSelectionChanged: this._getSelectionChangeHandler(),
                    selectedItem: this.option("selectedItem"),
                    onFocusedItemChanged: this._listFocusedItemChangeHandler.bind(this)
                });
                if (this.option("showSelectionControls")) {
                    (0, _extend.extend)(result, {
                        showSelectionControls: true,
                        selectionByClick: true
                    })
                }
                return result
            },
            _listFocusedItemChangeHandler: function(e) {
                if (this._preventInputValueRender) {
                    return
                }
                var list = e.component;
                var focusedElement = (0, _renderer.default)(list.option("focusedElement"));
                var focusedItem = list._getItemData(focusedElement);
                this._updateField(focusedItem)
            },
            _updateField: function(item) {
                var fieldTemplate = this._getTemplateByOption("fieldTemplate");
                if (!(fieldTemplate && this.option("fieldTemplate"))) {
                    var text = this._displayGetter(item);
                    this.option("text", text);
                    this._renderDisplayText(text);
                    return
                }
                this._renderField()
            },
            _getSelectionChangeHandler: function() {
                return this.option("showSelectionControls") ? this._selectionChangeHandler.bind(this) : _common.noop
            },
            _selectionChangeHandler: function(e) {
                (0, _iterator.each)(e.addedItems || [], function(_, addedItem) {
                    this._setValue(this._valueGetter(addedItem))
                }.bind(this))
            },
            _getActualSearchValue: function() {
                return this._dataSource.searchValue()
            },
            _toggleOpenState: function(isVisible) {
                if (this.option("disabled")) {
                    return
                }
                isVisible = arguments.length ? isVisible : !this.option("opened");
                if (!isVisible && !this._shouldClearFilter()) {
                    this._restoreInputText(true)
                }
                if (this._wasSearch() && isVisible) {
                    this._wasSearch(false);
                    var showDataImmediately = this.option("showDataBeforeSearch") || 0 === this.option("minSearchLength");
                    if (showDataImmediately && this._dataSource) {
                        if (this._searchTimer) {
                            return
                        }
                        var searchValue = this._getActualSearchValue();
                        searchValue && this._wasSearch(true);
                        this._filterDataSource(searchValue || null)
                    } else {
                        this._setListOption("items", [])
                    }
                }
                if (isVisible) {
                    this._scrollToSelectedItem()
                }
                this.callBase(isVisible)
            },
            _renderTooltip: function() {
                if (this.option("tooltipEnabled")) {
                    this.$element().attr("title", this.option("displayValue"))
                }
            },
            _renderDimensions: function() {
                this.callBase();
                this._dimensionChanged()
            },
            _isValueEqualInputText: function() {
                var initialSelectedItem = this.option("selectedItem");
                if (null === initialSelectedItem) {
                    return false
                }
                var value = this._displayGetter(initialSelectedItem);
                var displayValue = value ? String(value) : "";
                var inputText = this._searchValue();
                return displayValue === inputText
            },
            _popupHidingHandler: function() {
                if (this._isValueEqualInputText()) {
                    this._cancelEditing()
                }
                this.callBase()
            },
            _popupHiddenHandler: function() {
                this.callBase();
                if (this._shouldCancelSearch()) {
                    this._wasSearch(false);
                    this._searchCanceled();
                    this._shouldCancelSearch(false)
                }
            },
            _restoreInputText: function(saveEditingValue) {
                if (this.option("readOnly")) {
                    return
                }
                this._loadItemDeferred && this._loadItemDeferred.always(function() {
                    var initialSelectedItem = this.option("selectedItem");
                    if (this.option("acceptCustomValue")) {
                        if (!saveEditingValue) {
                            this._updateField(initialSelectedItem);
                            this._clearFilter()
                        }
                        return
                    }
                    if (this.option("searchEnabled")) {
                        if (!this._searchValue() && this.option("allowClearing")) {
                            this._clearTextValue();
                            return
                        }
                    }
                    if (this._isValueEqualInputText()) {
                        return
                    }
                    this._renderInputValue().always(function(selectedItem) {
                        var newSelectedItem = (0, _common.ensureDefined)(selectedItem, initialSelectedItem);
                        this._setSelectedItem(newSelectedItem);
                        this._updateField(newSelectedItem);
                        this._clearFilter()
                    }.bind(this))
                }.bind(this))
            },
            _focusOutHandler: function(e) {
                if (!this._preventNestedFocusEvent(e)) {
                    var isOverlayTarget = this._isOverlayNestedTarget(e.relatedTarget);
                    if (!isOverlayTarget) {
                        this._restoreInputText();
                        this._clearSearchTimer()
                    }
                    this._cancelSearchIfNeed(e)
                }
                e.target = this._input().get(0);
                this.callBase(e)
            },
            _cancelSearchIfNeed: function(e) {
                var _this$option = this.option(),
                    searchEnabled = _this$option.searchEnabled;
                var isOverlayTarget = this._isOverlayNestedTarget(null === e || void 0 === e ? void 0 : e.relatedTarget);
                var shouldCancelSearch = this._wasSearch() && searchEnabled && !isOverlayTarget;
                if (shouldCancelSearch) {
                    var _this$_popup;
                    var isPopupVisible = null === (_this$_popup = this._popup) || void 0 === _this$_popup ? void 0 : _this$_popup._hideAnimationProcessing;
                    if (isPopupVisible) {
                        this._shouldCancelSearch(true)
                    } else {
                        this._wasSearch(false);
                        this._searchCanceled()
                    }
                }
            },
            _shouldCancelSearch: function(value) {
                if (!arguments.length) {
                    return this._shouldCancelSearchValue
                }
                this._shouldCancelSearchValue = value
            },
            _isOverlayNestedTarget: function(target) {
                return !!(0, _renderer.default)(target).closest(".".concat(SELECTBOX_POPUP_WRAPPER_CLASS)).length
            },
            _clearTextValue: function() {
                if (this.option("selectedItem")) {
                    if (this._savedTextRemoveEvent) {
                        this._saveValueChangeEvent(this._savedTextRemoveEvent)
                    }
                    this.option("value", null)
                }
                delete this._savedTextRemoveEvent
            },
            _shouldOpenPopup: function() {
                return this._needPassDataSourceToList() && this._wasSearch()
            },
            _isFocused: function() {
                var activeElement = _dom_adapter.default.getActiveElement();
                return this.callBase() && (0, _renderer.default)(activeElement).closest(this._input()).length > 0
            },
            _renderValueChangeEvent: function() {
                if (this._isEditable()) {
                    this.callBase()
                }
            },
            _fieldRenderData: function() {
                var $listFocused = this._list && this.option("opened") && (0, _renderer.default)(this._list.option("focusedElement"));
                if ($listFocused && $listFocused.length) {
                    return this._list._getItemData($listFocused)
                }
                return this.option("selectedItem")
            },
            _isSelectedValue: function(value) {
                return this._isValueEquals(value, this.option("value"))
            },
            _shouldCloseOnItemClick: function() {
                return !(this.option("showSelectionControls") && "single" !== this.option("selectionMode"))
            },
            _listItemClickHandler: function(e) {
                var previousValue = this._getCurrentValue();
                this._focusListElement((0, _renderer.default)(e.itemElement));
                this._saveValueChangeEvent(e.event);
                this._completeSelection(this._valueGetter(e.itemData));
                if (this._shouldCloseOnItemClick()) {
                    this.option("opened", false)
                }
                if (this.option("searchEnabled") && previousValue === this._valueGetter(e.itemData)) {
                    this._updateField(e.itemData)
                }
                if (this._shouldClearFilter()) {
                    this._cancelSearchIfNeed()
                }
            },
            _shouldClearFilter: function() {
                return this._wasSearch()
            },
            _completeSelection: function(value) {
                this._setValue(value)
            },
            _loadItem: function(value, cache) {
                var that = this;
                var deferred = new _deferred.Deferred;
                this.callBase(value, cache).done(function(item) {
                    deferred.resolve(item)
                }.bind(this)).fail(function() {
                    var selectedItem = that.option("selectedItem");
                    if (that.option("acceptCustomValue") && value === that._valueGetter(selectedItem)) {
                        deferred.resolve(selectedItem)
                    } else {
                        deferred.reject()
                    }
                }.bind(this));
                return deferred.promise()
            },
            _loadInputValue: function(value, callback) {
                this._loadItemDeferred = this._loadItem(value).always(callback);
                return this._loadItemDeferred
            },
            _isCustomItemSelected: function() {
                var selectedItem = this.option("selectedItem");
                var searchValue = this._searchValue();
                var selectedItemText = this._displayGetter(selectedItem);
                return !selectedItemText || searchValue !== selectedItemText.toString()
            },
            _valueChangeEventHandler: function(e) {
                if (this.option("acceptCustomValue") && this._isCustomItemSelected() && !this._isValueChanging) {
                    this._isValueChanging = true;
                    this._customItemAddedHandler(e);
                    this._isValueChanging = false
                }
            },
            _initCustomItemCreatingAction: function() {
                this._customItemCreatingAction = this._createActionByOption("onCustomItemCreating")
            },
            _createCustomItem: function(text) {
                var params = {
                    text: text
                };
                var actionResult = this._customItemCreatingAction(params);
                var item = (0, _common.ensureDefined)(actionResult, params.customItem);
                if ((0, _type.isDefined)(actionResult)) {
                    _errors.default.log("W0015", "onCustomItemCreating", "customItem")
                }
                return item
            },
            _customItemAddedHandler: function(e) {
                var searchValue = this._searchValue();
                var item = this._createCustomItem(searchValue);
                this._saveValueChangeEvent(e);
                if (void 0 === item) {
                    this._renderValue();
                    throw _errors.default.Error("E0121")
                }
                if ((0, _type.isPromise)(item)) {
                    (0, _deferred.fromPromise)(item).done(this._setCustomItem.bind(this)).fail(this._setCustomItem.bind(this, null))
                } else {
                    this._setCustomItem(item)
                }
            },
            _setCustomItem: function(item) {
                if (this._disposed) {
                    return
                }
                item = item || null;
                this.option("selectedItem", item);
                this._cancelSearchIfNeed();
                this._setValue(this._valueGetter(item));
                this._renderDisplayText(this._displayGetter(item))
            },
            _clearValueHandler: function(e) {
                this.callBase(e);
                return false
            },
            _wasSearch: function(value) {
                if (!arguments.length) {
                    return this._wasSearchValue
                }
                this._wasSearchValue = value
            },
            _searchHandler: function(e) {
                if (this._preventFiltering) {
                    delete this._preventFiltering;
                    return
                }
                if (this._needPassDataSourceToList()) {
                    this._wasSearch(true)
                }
                this.callBase(e)
            },
            _dataSourceFiltered: function(searchValue) {
                this.callBase();
                if (null !== searchValue) {
                    this._renderInputSubstitution();
                    this._renderFocusedElement()
                }
            },
            _valueSubstituted: function() {
                var input = this._input().get(0);
                var isAllSelected = 0 === input.selectionStart && input.selectionEnd === this._searchValue().length;
                var inputHasSelection = input.selectionStart !== input.selectionEnd;
                return this._wasSearch() && inputHasSelection && !isAllSelected
            },
            _shouldSubstitutionBeRendered: function() {
                return !this._preventSubstitution && this.option("searchEnabled") && !this.option("acceptCustomValue") && "startswith" === this.option("searchMode")
            },
            _renderInputSubstitution: function() {
                if (!this._shouldSubstitutionBeRendered()) {
                    delete this._preventSubstitution;
                    return
                }
                var item = this._list && this._getPlainItems(this._list.option("items"))[0];
                if (!item) {
                    return
                }
                var $input = this._input();
                var valueLength = $input.val().length;
                if (0 === valueLength) {
                    return
                }
                var inputElement = $input.get(0);
                var displayValue = this._displayGetter(item).toString();
                inputElement.value = displayValue;
                this._caret({
                    start: valueLength,
                    end: displayValue.length
                })
            },
            _dispose: function() {
                this._renderInputValueAsync = _common.noop;
                delete this._loadItemDeferred;
                this.callBase()
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "onCustomItemCreating":
                        this._initCustomItemCreatingAction();
                        break;
                    case "tooltipEnabled":
                        this._renderTooltip();
                        break;
                    case "displayCustomValue":
                    case "acceptCustomValue":
                    case "showSelectionControls":
                    case "useInkRipple":
                        this._invalidate();
                        break;
                    case "allowClearing":
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _clean: function() {
                delete this._inkRipple;
                this.callBase()
            }
        });
        (0, _component_registrator.default)("dxSelectBox", SelectBox);
        var _default = SelectBox;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/shared/accessibility.js ***!
      \*************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.subscribeVisibilityChange = subscribeVisibilityChange;
        exports.unsubscribeVisibilityChange = unsubscribeVisibilityChange;
        exports.hiddenFocus = hiddenFocus;
        exports.registerKeyboardAction = registerKeyboardAction;
        exports.restoreFocus = restoreFocus;
        exports.selectView = selectView;
        exports.setTabIndex = setTabIndex;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var FOCUS_STATE_CLASS = "dx-state-focused";
        var FOCUS_DISABLED_CLASS = "dx-cell-focus-disabled";
        var FOCUSED_ROW_SELECTOR = ".dx-row-focused";
        var GRID_ROW_SELECTOR = ".dx-datagrid-rowsview .dx-row";
        var GRID_CELL_SELECTOR = "".concat(GRID_ROW_SELECTOR, " > td");
        var TREELIST_ROW_SELECTOR = ".dx-treelist-rowsview .dx-row";
        var TREELIST_CELL_SELECTOR = "".concat(TREELIST_ROW_SELECTOR, " > td");
        var viewItemSelectorMap = {
            groupPanel: [".dx-datagrid-group-panel .dx-group-panel-item[tabindex]"],
            columnHeaders: [".dx-datagrid-headers .dx-header-row > td.dx-datagrid-action", ".dx-treelist-headers .dx-header-row > td.dx-treelist-action"],
            filterRow: [".dx-datagrid-headers .dx-datagrid-filter-row .dx-editor-cell .dx-texteditor-input", ".dx-treelist-headers .dx-treelist-filter-row .dx-editor-cell .dx-texteditor-input"],
            rowsView: ["".concat(FOCUSED_ROW_SELECTOR), "".concat(GRID_ROW_SELECTOR, "[tabindex]"), "".concat(GRID_CELL_SELECTOR, "[tabindex]"), "".concat(GRID_CELL_SELECTOR), "".concat(TREELIST_ROW_SELECTOR, "[tabindex]"), "".concat(TREELIST_CELL_SELECTOR, "[tabindex]"), "".concat(TREELIST_CELL_SELECTOR)],
            footer: [".dx-datagrid-total-footer .dx-datagrid-summary-item", ".dx-treelist-total-footer .dx-treelist-summary-item"],
            filterPanel: [".dx-datagrid-filter-panel .dx-icon-filter", ".dx-treelist-filter-panel .dx-icon-filter"],
            pager: [".dx-datagrid-pager [tabindex]", ".dx-treelist-pager [tabindex]"]
        };
        var isMouseDown = false;
        var isHiddenFocusing = false;
        var focusedElementInfo = null;

        function processKeyDown(viewName, instance, event, action, $mainElement, executeKeyDown) {
            var isHandled = fireKeyDownEvent(instance, event.originalEvent, executeKeyDown);
            if (isHandled) {
                return
            }
            var keyName = (0, _index.normalizeKeyName)(event);
            if ("enter" === keyName || "space" === keyName) {
                saveFocusedElementInfo(event.target, instance);
                action && action({
                    event: event
                })
            } else {
                if ("tab" === keyName) {
                    $mainElement.addClass(FOCUS_STATE_CLASS)
                } else {
                    selectView(viewName, instance, event)
                }
            }
        }

        function saveFocusedElementInfo(target, instance) {
            var $target = (0, _renderer.default)(target);
            var ariaLabel = $target.attr("aria-label");
            var $activeElements = getActiveAccessibleElements(ariaLabel, instance.element());
            var targetIndex = $activeElements.index($target);
            focusedElementInfo = (0, _extend.extend)({}, {
                ariaLabel: ariaLabel,
                index: targetIndex
            }, {
                viewInstance: instance
            })
        }

        function getActiveAccessibleElements(ariaLabel, viewElement) {
            var $viewElement = (0, _renderer.default)(viewElement);
            var $activeElements;
            if (ariaLabel) {
                $activeElements = $viewElement.find('[aria-label="'.concat(ariaLabel, '"][tabindex]'))
            } else {
                $activeElements = $viewElement.find("[tabindex]")
            }
            return $activeElements
        }

        function findFocusedViewElement(viewSelectors) {
            for (var index in viewSelectors) {
                var selector = viewSelectors[index];
                var $focusViewElement = (0, _renderer.default)(selector).first();
                if ($focusViewElement.length) {
                    return $focusViewElement
                }
            }
        }

        function fireKeyDownEvent(instance, event, executeAction) {
            var args = {
                event: event,
                handled: false
            };
            if (executeAction) {
                executeAction(args)
            } else {
                instance._createActionByOption("onKeyDown")(args)
            }
            return args.handled
        }

        function onDocumentVisibilityChange() {
            isHiddenFocusing = "visible" === _dom_adapter.default.getDocument().visibilityState
        }

        function subscribeVisibilityChange() {
            _events_engine.default.on(_dom_adapter.default.getDocument(), "visibilitychange", onDocumentVisibilityChange)
        }

        function unsubscribeVisibilityChange() {
            _events_engine.default.off(_dom_adapter.default.getDocument(), "visibilitychange", onDocumentVisibilityChange)
        }

        function hiddenFocus(element) {
            isHiddenFocusing = true;
            element.focus();
            isHiddenFocusing = false
        }

        function registerKeyboardAction(viewName, instance, $element, selector, action, executeKeyDown) {
            if (instance.option("useLegacyKeyboardNavigation")) {
                return _common.noop
            }
            var $mainElement = (0, _renderer.default)(instance.element());
            var keyDownHandler = function(e) {
                return processKeyDown(viewName, instance, e, action, $mainElement, executeKeyDown)
            };
            var mouseDownHandler = function() {
                isMouseDown = true;
                $mainElement.removeClass(FOCUS_STATE_CLASS)
            };
            var focusinHandler = function() {
                var needShowOverlay = !isMouseDown && !isHiddenFocusing;
                if (needShowOverlay) {
                    $mainElement.addClass(FOCUS_STATE_CLASS)
                }
                isMouseDown = false
            };
            _events_engine.default.on($element, "keydown", selector, keyDownHandler);
            _events_engine.default.on($element, "mousedown", selector, mouseDownHandler);
            _events_engine.default.on($element, "focusin", selector, focusinHandler);
            return function() {
                _events_engine.default.off($element, "keydown", selector, keyDownHandler);
                _events_engine.default.off($element, "mousedown", selector, mouseDownHandler);
                _events_engine.default.off($element, "focusin", selector, focusinHandler)
            }
        }

        function restoreFocus(instance) {
            if (!instance.option("useLegacyKeyboardNavigation") && focusedElementInfo) {
                var viewInstance = focusedElementInfo.viewInstance;
                if (viewInstance) {
                    var $activeElements = getActiveAccessibleElements(focusedElementInfo.ariaLabel, viewInstance.element());
                    var $targetElement = $activeElements.eq(focusedElementInfo.index);
                    focusedElementInfo = null;
                    _events_engine.default.trigger($targetElement, "focus")
                }
            }
        }

        function selectView(viewName, instance, event) {
            var keyName = (0, _index.normalizeKeyName)(event);
            if (event.ctrlKey && ("upArrow" === keyName || "downArrow" === keyName)) {
                var viewNames = Object.keys(viewItemSelectorMap);
                var viewItemIndex = viewNames.indexOf(viewName);
                while (viewItemIndex >= 0 && viewItemIndex < viewNames.length) {
                    viewItemIndex = "upArrow" === keyName ? --viewItemIndex : ++viewItemIndex;
                    var _viewName = viewNames[viewItemIndex];
                    var viewSelectors = viewItemSelectorMap[_viewName];
                    var $focusViewElement = findFocusedViewElement(viewSelectors);
                    if ($focusViewElement && $focusViewElement.length) {
                        $focusViewElement.attr("tabindex", instance.option("tabindex") || 0);
                        _events_engine.default.trigger($focusViewElement, "focus");
                        $focusViewElement.removeClass(FOCUS_DISABLED_CLASS);
                        break
                    }
                }
            }
        }

        function setTabIndex(instance, $element) {
            if (!instance.option("useLegacyKeyboardnavigation")) {
                $element.attr("tabindex", instance.option("tabindex") || 0)
            }
        }
    },
    /*!**************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/rrule.js ***!
      \**************************************************/
    /*! exports provided: Days, DEFAULT_OPTIONS, defaultKeys, default */
    /*! exports used: DEFAULT_OPTIONS, Days, default, defaultKeys */
    function(module, __webpack_exports__, __webpack_require__) {
        __webpack_require__.d(__webpack_exports__, "b", function() {
            return Days
        });
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return DEFAULT_OPTIONS
        });
        __webpack_require__.d(__webpack_exports__, "d", function() {
            return defaultKeys
        });
        var __WEBPACK_IMPORTED_MODULE_0__dateutil__ = __webpack_require__( /*! ./dateutil */ 62);
        var __WEBPACK_IMPORTED_MODULE_1__iterresult__ = __webpack_require__( /*! ./iterresult */ 295);
        var __WEBPACK_IMPORTED_MODULE_2__callbackiterresult__ = __webpack_require__( /*! ./callbackiterresult */ 790);
        var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__( /*! ./types */ 140);
        var __WEBPACK_IMPORTED_MODULE_4__parseoptions__ = __webpack_require__( /*! ./parseoptions */ 428);
        var __WEBPACK_IMPORTED_MODULE_5__parsestring__ = __webpack_require__( /*! ./parsestring */ 429);
        var __WEBPACK_IMPORTED_MODULE_6__optionstostring__ = __webpack_require__( /*! ./optionstostring */ 430);
        var __WEBPACK_IMPORTED_MODULE_7__cache__ = __webpack_require__( /*! ./cache */ 792);
        var __WEBPACK_IMPORTED_MODULE_8__weekday__ = __webpack_require__( /*! ./weekday */ 159);
        var __WEBPACK_IMPORTED_MODULE_9__iter_index__ = __webpack_require__( /*! ./iter/index */ 431);
        var getnlp = function() {
            if (!getnlp._nlp) {
                getnlp._nlp = __webpack_require__( /*! ./nlp */ 799)
            }
            return getnlp._nlp
        };
        var Days = {
            MO: new __WEBPACK_IMPORTED_MODULE_8__weekday__.b(0),
            TU: new __WEBPACK_IMPORTED_MODULE_8__weekday__.b(1),
            WE: new __WEBPACK_IMPORTED_MODULE_8__weekday__.b(2),
            TH: new __WEBPACK_IMPORTED_MODULE_8__weekday__.b(3),
            FR: new __WEBPACK_IMPORTED_MODULE_8__weekday__.b(4),
            SA: new __WEBPACK_IMPORTED_MODULE_8__weekday__.b(5),
            SU: new __WEBPACK_IMPORTED_MODULE_8__weekday__.b(6)
        };
        var DEFAULT_OPTIONS = {
            freq: __WEBPACK_IMPORTED_MODULE_3__types__.a.YEARLY,
            dtstart: null,
            interval: 1,
            wkst: Days.MO,
            count: null,
            until: null,
            tzid: null,
            bysetpos: null,
            bymonth: null,
            bymonthday: null,
            bynmonthday: null,
            byyearday: null,
            byweekno: null,
            byweekday: null,
            bynweekday: null,
            byhour: null,
            byminute: null,
            bysecond: null,
            byeaster: null
        };
        var defaultKeys = Object.keys(DEFAULT_OPTIONS);
        var RRule = function() {
            function RRule(options, noCache) {
                if (void 0 === options) {
                    options = {}
                }
                if (void 0 === noCache) {
                    noCache = false
                }
                this._cache = noCache ? null : new __WEBPACK_IMPORTED_MODULE_7__cache__.a;
                this.origOptions = Object(__WEBPACK_IMPORTED_MODULE_4__parseoptions__.b)(options);
                var parsedOptions = Object(__WEBPACK_IMPORTED_MODULE_4__parseoptions__.c)(options).parsedOptions;
                this.options = parsedOptions
            }
            RRule.parseText = function(text, language) {
                return getnlp().parseText(text, language)
            };
            RRule.fromText = function(text, language) {
                return getnlp().fromText(text, language)
            };
            RRule.fromString = function(str) {
                return new RRule(RRule.parseString(str) || void 0)
            };
            RRule.prototype._iter = function(iterResult) {
                return Object(__WEBPACK_IMPORTED_MODULE_9__iter_index__.a)(iterResult, this.options)
            };
            RRule.prototype._cacheGet = function(what, args) {
                if (!this._cache) {
                    return false
                }
                return this._cache._cacheGet(what, args)
            };
            RRule.prototype._cacheAdd = function(what, value, args) {
                if (!this._cache) {
                    return
                }
                return this._cache._cacheAdd(what, value, args)
            };
            RRule.prototype.all = function(iterator) {
                if (iterator) {
                    return this._iter(new __WEBPACK_IMPORTED_MODULE_2__callbackiterresult__.a("all", {}, iterator))
                }
                var result = this._cacheGet("all");
                if (false === result) {
                    result = this._iter(new __WEBPACK_IMPORTED_MODULE_1__iterresult__.a("all", {}));
                    this._cacheAdd("all", result)
                }
                return result
            };
            RRule.prototype.between = function(after, before, inc, iterator) {
                if (void 0 === inc) {
                    inc = false
                }
                if (!__WEBPACK_IMPORTED_MODULE_0__dateutil__.b.isValidDate(after) || !__WEBPACK_IMPORTED_MODULE_0__dateutil__.b.isValidDate(before)) {
                    throw new Error("Invalid date passed in to RRule.between")
                }
                var args = {
                    before: before,
                    after: after,
                    inc: inc
                };
                if (iterator) {
                    return this._iter(new __WEBPACK_IMPORTED_MODULE_2__callbackiterresult__.a("between", args, iterator))
                }
                var result = this._cacheGet("between", args);
                if (false === result) {
                    result = this._iter(new __WEBPACK_IMPORTED_MODULE_1__iterresult__.a("between", args));
                    this._cacheAdd("between", result, args)
                }
                return result
            };
            RRule.prototype.before = function(dt, inc) {
                if (void 0 === inc) {
                    inc = false
                }
                if (!__WEBPACK_IMPORTED_MODULE_0__dateutil__.b.isValidDate(dt)) {
                    throw new Error("Invalid date passed in to RRule.before")
                }
                var args = {
                    dt: dt,
                    inc: inc
                };
                var result = this._cacheGet("before", args);
                if (false === result) {
                    result = this._iter(new __WEBPACK_IMPORTED_MODULE_1__iterresult__.a("before", args));
                    this._cacheAdd("before", result, args)
                }
                return result
            };
            RRule.prototype.after = function(dt, inc) {
                if (void 0 === inc) {
                    inc = false
                }
                if (!__WEBPACK_IMPORTED_MODULE_0__dateutil__.b.isValidDate(dt)) {
                    throw new Error("Invalid date passed in to RRule.after")
                }
                var args = {
                    dt: dt,
                    inc: inc
                };
                var result = this._cacheGet("after", args);
                if (false === result) {
                    result = this._iter(new __WEBPACK_IMPORTED_MODULE_1__iterresult__.a("after", args));
                    this._cacheAdd("after", result, args)
                }
                return result
            };
            RRule.prototype.count = function() {
                return this.all().length
            };
            RRule.prototype.toString = function() {
                return Object(__WEBPACK_IMPORTED_MODULE_6__optionstostring__.a)(this.origOptions)
            };
            RRule.prototype.toText = function(gettext, language, dateFormatter) {
                return getnlp().toText(this, gettext, language, dateFormatter)
            };
            RRule.prototype.isFullyConvertibleToText = function() {
                return getnlp().isFullyConvertible(this)
            };
            RRule.prototype.clone = function() {
                return new RRule(this.origOptions)
            };
            RRule.FREQUENCIES = ["YEARLY", "MONTHLY", "WEEKLY", "DAILY", "HOURLY", "MINUTELY", "SECONDLY"];
            RRule.YEARLY = __WEBPACK_IMPORTED_MODULE_3__types__.a.YEARLY;
            RRule.MONTHLY = __WEBPACK_IMPORTED_MODULE_3__types__.a.MONTHLY;
            RRule.WEEKLY = __WEBPACK_IMPORTED_MODULE_3__types__.a.WEEKLY;
            RRule.DAILY = __WEBPACK_IMPORTED_MODULE_3__types__.a.DAILY;
            RRule.HOURLY = __WEBPACK_IMPORTED_MODULE_3__types__.a.HOURLY;
            RRule.MINUTELY = __WEBPACK_IMPORTED_MODULE_3__types__.a.MINUTELY;
            RRule.SECONDLY = __WEBPACK_IMPORTED_MODULE_3__types__.a.SECONDLY;
            RRule.MO = Days.MO;
            RRule.TU = Days.TU;
            RRule.WE = Days.WE;
            RRule.TH = Days.TH;
            RRule.FR = Days.FR;
            RRule.SA = Days.SA;
            RRule.SU = Days.SU;
            RRule.parseString = __WEBPACK_IMPORTED_MODULE_5__parsestring__.b;
            RRule.optionsToString = __WEBPACK_IMPORTED_MODULE_6__optionstostring__.a;
            return RRule
        }();
        __webpack_exports__.c = RRule
    },
    /*!************************************************************!*\
      !*** ./node_modules/rrule/node_modules/tslib/tslib.es6.js ***!
      \************************************************************/
    /*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __createBinding, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet */
    /*! exports used: __assign, __extends, __spreadArrays */
    function(module, __webpack_exports__, __webpack_require__) {
        __webpack_exports__.b = __extends;
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return __assign
        });
        __webpack_exports__.c = __spreadArrays;
        /*! *****************************************************************************
        Copyright (c) Microsoft Corporation.

        Permission to use, copy, modify, and/or distribute this software for any
        purpose with or without fee is hereby granted.

        THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
        REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
        AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
        INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
        LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
        OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
        PERFORMANCE OF THIS SOFTWARE.
        ***************************************************************************** */
        var extendStatics = function(d, b) {
            extendStatics = Object.setPrototypeOf || {
                __proto__: []
            }
            instanceof Array && function(d, b) {
                d.__proto__ = b
            } || function(d, b) {
                for (var p in b) {
                    if (b.hasOwnProperty(p)) {
                        d[p] = b[p]
                    }
                }
            };
            return extendStatics(d, b)
        };

        function __extends(d, b) {
            extendStatics(d, b);

            function __() {
                this.constructor = d
            }
            d.prototype = null === b ? Object.create(b) : (__.prototype = b.prototype, new __)
        }
        var __assign = function() {
            __assign = Object.assign || function(t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) {
                        if (Object.prototype.hasOwnProperty.call(s, p)) {
                            t[p] = s[p]
                        }
                    }
                }
                return t
            };
            return __assign.apply(this, arguments)
        };

        function __spreadArrays() {
            for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
                s += arguments[i].length
            }
            for (var r = Array(s), k = 0, i = 0; i < il; i++) {
                for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
                    r[k] = a[j]
                }
            }
            return r
        }
    },
    /*!****************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/core/title.js ***!
      \****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.plugin = exports.Title = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _utils = __webpack_require__( /*! ./utils */ 14);
        var _layout_element = __webpack_require__( /*! ./layout_element */ 311);
        var _Number = Number;
        var parseHorizontalAlignment = (0, _utils.enumParser)(["left", "center", "right"]);
        var parseVerticalAlignment = (0, _utils.enumParser)(["top", "bottom"]);
        var DEFAULT_MARGIN = 10;

        function hasText(text) {
            return !!(text && String(text).length > 0)
        }

        function processTitleLength(elem, text, width, options, placeholderSize) {
            if (elem.attr({
                    text: text
                }).setMaxSize(width, placeholderSize, options).textChanged) {
                elem.setTitle(text)
            }
        }

        function pickMarginValue(value) {
            return value >= 0 ? _Number(value) : DEFAULT_MARGIN
        }

        function validateMargin(margin) {
            var result;
            if (margin >= 0) {
                result = {
                    left: _Number(margin),
                    top: _Number(margin),
                    right: _Number(margin),
                    bottom: _Number(margin)
                }
            } else {
                margin = margin || {};
                result = {
                    left: pickMarginValue(margin.left),
                    top: pickMarginValue(margin.top),
                    right: pickMarginValue(margin.right),
                    bottom: pickMarginValue(margin.bottom)
                }
            }
            return result
        }

        function checkRect(rect, boundingRect) {
            return rect[2] - rect[0] < boundingRect.width || rect[3] - rect[1] < boundingRect.height
        }
        var Title = function(params) {
            this._params = params;
            this._group = params.renderer.g().attr({
                "class": params.cssClass
            }).linkOn(params.root || params.renderer.root, "title");
            this._hasText = false
        };
        exports.Title = Title;
        (0, _extend.extend)(Title.prototype, _layout_element.LayoutElement.prototype, {
            dispose: function() {
                var that = this;
                that._group.linkRemove();
                that._group.linkOff();
                if (that._titleElement) {
                    that._clipRect.dispose();
                    that._titleElement = that._subtitleElement = that._clipRect = null
                }
                that._params = that._group = that._options = null
            },
            _updateOptions: function(options) {
                this._options = options;
                this._options.horizontalAlignment = parseHorizontalAlignment(options.horizontalAlignment, "center");
                this._options.verticalAlignment = parseVerticalAlignment(options.verticalAlignment, "top");
                this._options.margin = validateMargin(options.margin)
            },
            _updateStructure: function() {
                var that = this;
                var renderer = that._params.renderer;
                var group = that._group;
                var options = that._options;
                var align = options.horizontalAlignment;
                if (!that._titleElement) {
                    that._titleElement = renderer.text().append(group);
                    that._subtitleElement = renderer.text();
                    that._clipRect = renderer.clipRect();
                    group.attr({
                        "clip-path": that._clipRect.id
                    })
                }
                that._titleElement.attr({
                    align: align,
                    "class": options.cssClass
                });
                that._subtitleElement.attr({
                    align: align,
                    "class": options.subtitle.cssClass
                });
                group.linkAppend();
                hasText(options.subtitle.text) ? that._subtitleElement.append(group) : that._subtitleElement.remove()
            },
            _updateTexts: function() {
                var that = this;
                var options = that._options;
                var subtitleOptions = options.subtitle;
                var titleElement = that._titleElement;
                var subtitleElement = that._subtitleElement;
                var testText = "A";
                var titleBox;
                titleElement.attr({
                    text: testText,
                    y: 0
                }).css((0, _utils.patchFontOptions)(options.font));
                titleBox = titleElement.getBBox();
                that._baseLineCorrection = titleBox.height + titleBox.y;
                titleElement.attr({
                    text: options.text
                });
                titleBox = titleElement.getBBox();
                var y = -titleBox.y;
                titleElement.attr({
                    y: y
                });
                if (hasText(subtitleOptions.text)) {
                    subtitleElement.attr({
                        text: subtitleOptions.text,
                        y: 0
                    }).css((0, _utils.patchFontOptions)(subtitleOptions.font))
                }
            },
            _shiftSubtitle: function() {
                var that = this;
                var titleBox = that._titleElement.getBBox();
                var element = that._subtitleElement;
                var offset = that._options.subtitle.offset;
                element.move(0, titleBox.y + titleBox.height - element.getBBox().y - offset)
            },
            _updateBoundingRectAlignment: function() {
                var boundingRect = this._boundingRect;
                var options = this._options;
                boundingRect.verticalAlignment = options.verticalAlignment;
                boundingRect.horizontalAlignment = options.horizontalAlignment;
                boundingRect.cutLayoutSide = options.verticalAlignment;
                boundingRect.cutSide = "vertical";
                boundingRect.position = {
                    horizontal: options.horizontalAlignment,
                    vertical: options.verticalAlignment
                }
            },
            hasText: function() {
                return this._hasText
            },
            update: function(themeOptions, userOptions) {
                var that = this;
                var options = (0, _extend.extend)(true, {}, themeOptions, processTitleOptions(userOptions));
                var _hasText = hasText(options.text);
                var isLayoutChanged = _hasText || _hasText !== that._hasText;
                that._baseLineCorrection = 0;
                that._updateOptions(options);
                that._boundingRect = {};
                if (_hasText) {
                    that._updateStructure();
                    that._updateTexts()
                } else {
                    that._group.linkRemove()
                }
                that._updateBoundingRect();
                that._updateBoundingRectAlignment();
                that._hasText = _hasText;
                return isLayoutChanged
            },
            draw: function(width, height) {
                var that = this;
                if (that._hasText) {
                    that._group.linkAppend();
                    that._correctTitleLength(width);
                    if (that._group.getBBox().height > height) {
                        this.freeSpace()
                    }
                }
                return that
            },
            _correctTitleLength: function(width) {
                var that = this;
                var options = that._options;
                var margin = options.margin;
                var maxWidth = width - margin.left - margin.right;
                var placeholderSize = options.placeholderSize;
                processTitleLength(that._titleElement, options.text, maxWidth, options, placeholderSize);
                if (that._subtitleElement) {
                    if (_Number(placeholderSize) > 0) {
                        placeholderSize -= that._titleElement.getBBox().height
                    }
                    processTitleLength(that._subtitleElement, options.subtitle.text, maxWidth, options.subtitle, placeholderSize);
                    that._shiftSubtitle()
                }
                that._updateBoundingRect();
                var _this$getCorrectedLay = this.getCorrectedLayoutOptions(),
                    x = _this$getCorrectedLay.x,
                    y = _this$getCorrectedLay.y,
                    height = _this$getCorrectedLay.height;
                this._clipRect.attr({
                    x: x,
                    y: y,
                    width: width,
                    height: height
                })
            },
            getLayoutOptions: function() {
                return this._boundingRect || null
            },
            shift: function(x, y) {
                var that = this;
                var box = that.getLayoutOptions();
                that._group.move(x - box.x, y - box.y);
                return that
            },
            _updateBoundingRect: function() {
                var that = this;
                var options = that._options;
                var margin = options.margin;
                var boundingRect = that._boundingRect;
                var box = that._hasText ? that._group.getBBox() : {
                    width: 0,
                    height: 0,
                    x: 0,
                    y: 0,
                    isEmpty: true
                };
                if (!box.isEmpty) {
                    box.height += margin.top + margin.bottom - that._baseLineCorrection;
                    box.width += margin.left + margin.right;
                    box.x -= margin.left;
                    box.y += that._baseLineCorrection - margin.top
                }
                if (options.placeholderSize > 0) {
                    box.height = options.placeholderSize
                }
                boundingRect.height = box.height;
                boundingRect.width = box.width;
                boundingRect.x = box.x;
                boundingRect.y = box.y
            },
            getCorrectedLayoutOptions: function() {
                var srcBox = this.getLayoutOptions();
                var correction = this._baseLineCorrection;
                return (0, _extend.extend)({}, srcBox, {
                    y: srcBox.y - correction,
                    height: srcBox.height + correction
                })
            },
            layoutOptions: function() {
                if (!this._hasText) {
                    return null
                }
                return {
                    horizontalAlignment: this._boundingRect.horizontalAlignment,
                    verticalAlignment: this._boundingRect.verticalAlignment,
                    priority: 0
                }
            },
            measure: function(size) {
                this.draw(size[0], size[1]);
                return [this._boundingRect.width, this._boundingRect.height]
            },
            move: function(rect, fitRect) {
                var boundingRect = this._boundingRect;
                if (checkRect(rect, boundingRect)) {
                    this.shift(fitRect[0], fitRect[1])
                } else {
                    this.shift(Math.round(rect[0]), Math.round(rect[1]))
                }
            },
            freeSpace: function() {
                var that = this;
                that._params.incidentOccurred("W2103");
                that._group.linkRemove();
                that._boundingRect.width = that._boundingRect.height = 0
            },
            getOptions: function() {
                return this._options
            },
            changeLink: function(root) {
                this._group.linkRemove();
                this._group.linkOn(root, "title")
            }
        });

        function processTitleOptions(options) {
            var newOptions = (0, _type.isString)(options) ? {
                text: options
            } : options || {};
            newOptions.subtitle = (0, _type.isString)(newOptions.subtitle) ? {
                text: newOptions.subtitle
            } : newOptions.subtitle || {};
            return newOptions
        }
        var plugin = {
            name: "title",
            init: function() {
                var that = this;
                that._title = new Title({
                    renderer: that._renderer,
                    cssClass: that._rootClassPrefix + "-title",
                    incidentOccurred: that._incidentOccurred
                });
                that._layout.add(that._title)
            },
            dispose: function() {
                this._title.dispose();
                this._title = null
            },
            customize: function(constructor) {
                constructor.addChange({
                    code: "TITLE",
                    handler: function() {
                        if (this._title.update(this._themeManager.theme("title"), this.option("title"))) {
                            this._change(["LAYOUT"])
                        }
                    },
                    isThemeDependent: true,
                    option: "title",
                    isOptionChange: true
                })
            },
            fontFields: ["title.font", "title.subtitle.font"]
        };
        exports.plugin = plugin
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/series/scatter_series.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.polar = exports.chart = void 0;
        var _extend3 = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _range_data_calculator = _interopRequireDefault(__webpack_require__( /*! ./helpers/range_data_calculator */ 226));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }
        var math = Math;
        var _abs = math.abs;
        var _sqrt = math.sqrt;
        var _max = math.max;
        var DEFAULT_TRACKER_WIDTH = 12;
        var DEFAULT_DURATION = 400;
        var HIGH_ERROR = "highError";
        var LOW_ERROR = "lowError";
        var VARIANCE = "variance";
        var STANDARD_DEVIATION = "stddeviation";
        var STANDARD_ERROR = "stderror";
        var PERCENT = "percent";
        var FIXED = "fixed";
        var UNDEFINED = "undefined";
        var DISCRETE = "discrete";
        var LOGARITHMIC = "logarithmic";
        var DATETIME = "datetime";
        var chart = {};
        exports.chart = chart;
        var polar = {};
        exports.polar = polar;

        function sum(array) {
            var result = 0;
            (0, _iterator.each)(array, function(_, value) {
                result += value
            });
            return result
        }

        function isErrorBarTypeCorrect(type) {
            return (0, _array.inArray)(type, [FIXED, PERCENT, VARIANCE, STANDARD_DEVIATION, STANDARD_ERROR]) !== -1
        }

        function variance(array, expectedValue) {
            return sum((0, _utils.map)(array, function(value) {
                return (value - expectedValue) * (value - expectedValue)
            })) / array.length
        }

        function calculateAvgErrorBars(result, data, series) {
            var errorBarsOptions = series.getOptions().valueErrorBar;
            var valueField = series.getValueFields()[0];
            var lowValueField = errorBarsOptions.lowValueField || LOW_ERROR;
            var highValueField = errorBarsOptions.highValueField || HIGH_ERROR;
            if (series.areErrorBarsVisible() && void 0 === errorBarsOptions.type) {
                var fusionData = data.reduce(function(result, item) {
                    if ((0, _type.isDefined)(item[lowValueField])) {
                        result[0] += item[valueField] - item[lowValueField];
                        result[1]++
                    }
                    if ((0, _type.isDefined)(item[highValueField])) {
                        result[2] += item[highValueField] - item[valueField];
                        result[3]++
                    }
                    return result
                }, [0, 0, 0, 0]);
                if (fusionData[1]) {
                    result[lowValueField] = result[valueField] - fusionData[0] / fusionData[1]
                }
                if (fusionData[2]) {
                    result[highValueField] = result[valueField] + fusionData[2] / fusionData[3]
                }
            }
            return result
        }

        function calculateSumErrorBars(result, data, series) {
            var errorBarsOptions = series.getOptions().valueErrorBar;
            var lowValueField = errorBarsOptions.lowValueField || LOW_ERROR;
            var highValueField = errorBarsOptions.highValueField || HIGH_ERROR;
            if (series.areErrorBarsVisible() && void 0 === errorBarsOptions.type) {
                result[lowValueField] = 0;
                result[highValueField] = 0;
                result = data.reduce(function(result, item) {
                    result[lowValueField] += item[lowValueField];
                    result[highValueField] += item[highValueField];
                    return result
                }, result)
            }
            return result
        }

        function getMinMaxAggregator(compare) {
            return function(_ref, series) {
                var intervalStart = _ref.intervalStart,
                    data = _ref.data;
                var valueField = series.getValueFields()[0];
                var targetData = data[0];
                targetData = data.reduce(function(result, item) {
                    var value = item[valueField];
                    if (null === result[valueField]) {
                        result = item
                    }
                    if (null !== value && compare(value, result[valueField])) {
                        return item
                    }
                    return result
                }, targetData);
                return (0, _extend3.extend)({}, targetData, _defineProperty({}, series.getArgumentField(), intervalStart))
            }
        }

        function checkFields(data, fieldsToCheck, skippedFields) {
            var allFieldsIsValid = true;
            for (var field in fieldsToCheck) {
                var isArgument = "argument" === field;
                if (isArgument || "size" === field ? !(0, _type.isDefined)(data[field]) : void 0 === data[field]) {
                    var selector = fieldsToCheck[field];
                    if (!isArgument) {
                        skippedFields[selector] = (skippedFields[selector] || 0) + 1
                    }
                    allFieldsIsValid = false
                }
            }
            return allFieldsIsValid
        }
        var baseScatterMethods = {
            _defaultDuration: DEFAULT_DURATION,
            _defaultTrackerWidth: DEFAULT_TRACKER_WIDTH,
            _applyStyle: _common.noop,
            _updateOptions: _common.noop,
            _parseStyle: _common.noop,
            _prepareSegment: _common.noop,
            _drawSegment: _common.noop,
            _appendInGroup: function() {
                this._group.append(this._extGroups.seriesGroup)
            },
            _createLegendState: function(styleOptions, defaultColor) {
                return {
                    fill: styleOptions.color || defaultColor,
                    hatching: styleOptions.hatching ? (0, _extend3.extend)({}, styleOptions.hatching, {
                        direction: "right"
                    }) : void 0
                }
            },
            _applyElementsClipRect: function(settings) {
                settings["clip-path"] = this._paneClipRectID
            },
            _applyMarkerClipRect: function(settings) {
                settings["clip-path"] = this._forceClipping ? this._paneClipRectID : null
            },
            _createGroup: function(groupName, parent, target, settings) {
                var group = parent[groupName] = parent[groupName] || this._renderer.g();
                target && group.append(target);
                settings && group.attr(settings)
            },
            _applyClearingSettings: function(settings) {
                settings.opacity = null;
                settings.scale = null;
                if (this._options.rotated) {
                    settings.translateX = null
                } else {
                    settings.translateY = null
                }
            },
            _createGroups: function() {
                var that = this;
                that._createGroup("_markersGroup", that, that._group);
                that._createGroup("_labelsGroup", that)
            },
            _setMarkerGroupSettings: function() {
                var that = this;
                var settings = that._createPointStyles(that._getMarkerGroupOptions()).normal;
                settings.class = "dxc-markers";
                settings.opacity = 1;
                that._applyMarkerClipRect(settings);
                that._markersGroup.attr(settings)
            },
            getVisibleArea: function() {
                return this._visibleArea
            },
            areErrorBarsVisible: function() {
                var errorBarOptions = this._options.valueErrorBar;
                return errorBarOptions && this._errorBarsEnabled() && "none" !== errorBarOptions.displayMode && (isErrorBarTypeCorrect((0, _utils.normalizeEnum)(errorBarOptions.type)) || (0, _type.isDefined)(errorBarOptions.lowValueField) || (0, _type.isDefined)(errorBarOptions.highValueField))
            },
            groupPointsByCoords: function(rotated) {
                var cat = [];
                (0, _iterator.each)(this.getVisiblePoints(), function(_, p) {
                    var pointCoord = parseInt(rotated ? p.vy : p.vx);
                    if (!cat[pointCoord]) {
                        cat[pointCoord] = p
                    } else {
                        Array.isArray(cat[pointCoord]) ? cat[pointCoord].push(p) : cat[pointCoord] = [cat[pointCoord], p]
                    }
                });
                return cat
            },
            _createErrorBarGroup: function(animationEnabled) {
                var that = this;
                var errorBarOptions = that._options.valueErrorBar;
                var settings;
                if (that.areErrorBarsVisible()) {
                    settings = {
                        "class": "dxc-error-bars",
                        stroke: errorBarOptions.color,
                        "stroke-width": errorBarOptions.lineWidth,
                        opacity: animationEnabled ? .001 : errorBarOptions.opacity || 1,
                        "stroke-linecap": "square",
                        sharp: true,
                        "clip-path": that._forceClipping ? that._paneClipRectID : that._widePaneClipRectID
                    };
                    that._createGroup("_errorBarGroup", that, that._group, settings)
                }
            },
            _setGroupsSettings: function(animationEnabled) {
                var that = this;
                that._setMarkerGroupSettings();
                that._setLabelGroupSettings(animationEnabled);
                that._createErrorBarGroup(animationEnabled)
            },
            _getCreatingPointOptions: function() {
                var that = this;
                var defaultPointOptions;
                var creatingPointOptions = that._predefinedPointOptions;
                var normalStyle;
                if (!creatingPointOptions) {
                    defaultPointOptions = that._getPointOptions();
                    that._predefinedPointOptions = creatingPointOptions = (0, _extend3.extend)(true, {
                        styles: {}
                    }, defaultPointOptions);
                    normalStyle = defaultPointOptions.styles && defaultPointOptions.styles.normal || {};
                    creatingPointOptions.styles = creatingPointOptions.styles || {};
                    creatingPointOptions.styles.normal = {
                        "stroke-width": normalStyle["stroke-width"],
                        r: normalStyle.r,
                        opacity: normalStyle.opacity
                    }
                }
                return creatingPointOptions
            },
            _getPointOptions: function() {
                return this._parsePointOptions(this._preparePointOptions(), this._options.label)
            },
            _getOptionsForPoint: function() {
                return this._options.point
            },
            _parsePointStyle: function(style, defaultColor, defaultBorderColor, defaultSize) {
                var border = style.border || {};
                var sizeValue = void 0 !== style.size ? style.size : defaultSize;
                return {
                    fill: style.color || defaultColor,
                    stroke: border.color || defaultBorderColor,
                    "stroke-width": border.visible ? border.width : 0,
                    r: sizeValue / 2 + (border.visible && 0 !== sizeValue ? ~~(border.width / 2) || 0 : 0)
                }
            },
            _createPointStyles: function(pointOptions) {
                var that = this;
                var mainPointColor = pointOptions.color || that._options.mainSeriesColor;
                var containerColor = that._options.containerBackgroundColor;
                var normalStyle = that._parsePointStyle(pointOptions, mainPointColor, mainPointColor);
                normalStyle.visibility = pointOptions.visible ? "visible" : "hidden";
                return {
                    normal: normalStyle,
                    hover: that._parsePointStyle(pointOptions.hoverStyle, containerColor, mainPointColor, pointOptions.size),
                    selection: that._parsePointStyle(pointOptions.selectionStyle, containerColor, mainPointColor, pointOptions.size)
                }
            },
            _checkData: function(data, skippedFields, fieldsToCheck) {
                fieldsToCheck = fieldsToCheck || {
                    value: this.getValueFields()[0]
                };
                fieldsToCheck.argument = this.getArgumentField();
                return checkFields(data, fieldsToCheck, skippedFields || {}) && data.value === data.value
            },
            getValueRangeInitialValue: function() {
                return
            },
            _getRangeData: function() {
                return _range_data_calculator.default.getRangeData(this)
            },
            _getPointDataSelector: function() {
                var _this = this;
                var valueField = this.getValueFields()[0];
                var argumentField = this.getArgumentField();
                var tagField = this.getTagField();
                var areErrorBarsVisible = this.areErrorBarsVisible();
                var lowValueField;
                var highValueField;
                if (areErrorBarsVisible) {
                    var errorBarOptions = this._options.valueErrorBar;
                    lowValueField = errorBarOptions.lowValueField || LOW_ERROR;
                    highValueField = errorBarOptions.highValueField || HIGH_ERROR
                }
                return function(data) {
                    var pointData = {
                        value: _this._processEmptyValue(data[valueField]),
                        argument: data[argumentField],
                        tag: data[tagField],
                        data: data
                    };
                    if (areErrorBarsVisible) {
                        pointData.lowError = data[lowValueField];
                        pointData.highError = data[highValueField]
                    }
                    return pointData
                }
            },
            _errorBarsEnabled: function() {
                return this.valueAxisType !== DISCRETE && this.valueAxisType !== LOGARITHMIC && this.valueType !== DATETIME
            },
            _drawPoint: function(options) {
                var point = options.point;
                if (point.isInVisibleArea()) {
                    point.clearVisibility();
                    point.draw(this._renderer, options.groups, options.hasAnimation, options.firstDrawing);
                    this._drawnPoints.push(point)
                } else {
                    point.setInvisibility()
                }
            },
            _animateComplete: function() {
                var that = this;
                var animationSettings = {
                    duration: that._defaultDuration
                };
                that._labelsGroup && that._labelsGroup.animate({
                    opacity: 1
                }, animationSettings);
                that._errorBarGroup && that._errorBarGroup.animate({
                    opacity: that._options.valueErrorBar.opacity || 1
                }, animationSettings)
            },
            _animate: function() {
                var that = this;
                var lastPointIndex = that._drawnPoints.length - 1;
                (0, _iterator.each)(that._drawnPoints || [], function(i, p) {
                    p.animate(i === lastPointIndex ? function() {
                        that._animateComplete()
                    } : void 0, {
                        translateX: p.x,
                        translateY: p.y
                    })
                })
            },
            _defaultAggregator: "avg",
            _aggregators: {
                avg: function(_ref2, series) {
                    var _calculateAvgErrorBar;
                    var data = _ref2.data,
                        intervalStart = _ref2.intervalStart;
                    if (!data.length) {
                        return
                    }
                    var valueField = series.getValueFields()[0];
                    var aggregationResult = data.reduce(function(result, item) {
                        var value = item[valueField];
                        if ((0, _type.isDefined)(value)) {
                            result[0] += value;
                            result[1]++
                        } else {
                            if (null === value) {
                                result[2]++
                            }
                        }
                        return result
                    }, [0, 0, 0]);
                    return calculateAvgErrorBars((_calculateAvgErrorBar = {}, _defineProperty(_calculateAvgErrorBar, valueField, aggregationResult[2] === data.length ? null : aggregationResult[0] / aggregationResult[1]), _defineProperty(_calculateAvgErrorBar, series.getArgumentField(), intervalStart), _calculateAvgErrorBar), data, series)
                },
                sum: function(_ref3, series) {
                    var _calculateSumErrorBar;
                    var intervalStart = _ref3.intervalStart,
                        data = _ref3.data;
                    if (!data.length) {
                        return
                    }
                    var valueField = series.getValueFields()[0];
                    var aggregationResult = data.reduce(function(result, item) {
                        var value = item[valueField];
                        if (void 0 !== value) {
                            result[0] += value
                        }
                        if (null === value) {
                            result[1]++
                        } else {
                            if (void 0 === value) {
                                result[2]++
                            }
                        }
                        return result
                    }, [0, 0, 0]);
                    var value = aggregationResult[0];
                    if (aggregationResult[1] === data.length) {
                        value = null
                    }
                    if (aggregationResult[2] === data.length) {
                        return
                    }
                    return calculateSumErrorBars((_calculateSumErrorBar = {}, _defineProperty(_calculateSumErrorBar, valueField, value), _defineProperty(_calculateSumErrorBar, series.getArgumentField(), intervalStart), _calculateSumErrorBar), data, series)
                },
                count: function(_ref4, series) {
                    var _ref5;
                    var data = _ref4.data,
                        intervalStart = _ref4.intervalStart;
                    var valueField = series.getValueFields()[0];
                    return _ref5 = {}, _defineProperty(_ref5, series.getArgumentField(), intervalStart), _defineProperty(_ref5, valueField, data.filter(function(i) {
                        return void 0 !== i[valueField]
                    }).length), _ref5
                },
                min: getMinMaxAggregator(function(a, b) {
                    return a < b
                }),
                max: getMinMaxAggregator(function(a, b) {
                    return a > b
                })
            },
            _endUpdateData: function() {
                delete this._predefinedPointOptions
            },
            getArgumentField: function() {
                return this._options.argumentField || "arg"
            },
            getValueFields: function() {
                var options = this._options;
                var errorBarsOptions = options.valueErrorBar;
                var valueFields = [options.valueField || "val"];
                var lowValueField;
                var highValueField;
                if (errorBarsOptions) {
                    lowValueField = errorBarsOptions.lowValueField;
                    highValueField = errorBarsOptions.highValueField;
                    (0, _type.isString)(lowValueField) && valueFields.push(lowValueField);
                    (0, _type.isString)(highValueField) && valueFields.push(highValueField)
                }
                return valueFields
            },
            _calculateErrorBars: function(data) {
                if (!this.areErrorBarsVisible()) {
                    return
                }
                var that = this;
                var options = that._options;
                var errorBarsOptions = options.valueErrorBar;
                var errorBarType = (0, _utils.normalizeEnum)(errorBarsOptions.type);
                var floatErrorValue = parseFloat(errorBarsOptions.value);
                var valueField = that.getValueFields()[0];
                var value;
                var lowValueField = errorBarsOptions.lowValueField || LOW_ERROR;
                var highValueField = errorBarsOptions.highValueField || HIGH_ERROR;
                var valueArray;
                var valueArrayLength;
                var meanValue;
                var processDataItem;
                var addSubError = function(_i, item) {
                    value = item.value;
                    item.lowError = value - floatErrorValue;
                    item.highError = value + floatErrorValue
                };
                switch (errorBarType) {
                    case FIXED:
                        processDataItem = addSubError;
                        break;
                    case PERCENT:
                        processDataItem = function(_, item) {
                            value = item.value;
                            var error = value * floatErrorValue / 100;
                            item.lowError = value - error;
                            item.highError = value + error
                        };
                        break;
                    case UNDEFINED:
                        processDataItem = function(_, item) {
                            item.lowError = item.data[lowValueField];
                            item.highError = item.data[highValueField]
                        };
                        break;
                    default:
                        valueArray = (0, _utils.map)(data, function(item) {
                            return (0, _type.isDefined)(item.data[valueField]) ? item.data[valueField] : null
                        });
                        valueArrayLength = valueArray.length;
                        floatErrorValue = floatErrorValue || 1;
                        switch (errorBarType) {
                            case VARIANCE:
                                floatErrorValue = variance(valueArray, sum(valueArray) / valueArrayLength) * floatErrorValue;
                                processDataItem = addSubError;
                                break;
                            case STANDARD_DEVIATION:
                                meanValue = sum(valueArray) / valueArrayLength;
                                floatErrorValue = _sqrt(variance(valueArray, meanValue)) * floatErrorValue;
                                processDataItem = function(_, item) {
                                    item.lowError = meanValue - floatErrorValue;
                                    item.highError = meanValue + floatErrorValue
                                };
                                break;
                            case STANDARD_ERROR:
                                floatErrorValue = _sqrt(variance(valueArray, sum(valueArray) / valueArrayLength) / valueArrayLength) * floatErrorValue;
                                processDataItem = addSubError
                        }
                }
                processDataItem && (0, _iterator.each)(data, processDataItem)
            },
            _patchMarginOptions: function(options) {
                var pointOptions = this._getCreatingPointOptions();
                var styles = pointOptions.styles;
                var maxSize = [styles.normal, styles.hover, styles.selection].reduce(function(max, style) {
                    return _max(max, 2 * style.r + style["stroke-width"])
                }, 0);
                options.size = pointOptions.visible ? maxSize : 0;
                options.sizePointNormalState = pointOptions.visible ? 2 * styles.normal.r + styles.normal["stroke-width"] : 2;
                return options
            },
            usePointsToDefineAutoHiding: function() {
                return true
            }
        };
        exports.chart = chart = (0, _extend3.extend)({}, baseScatterMethods, {
            drawTrackers: function() {
                var that = this;
                var trackers;
                var trackersGroup;
                var segments = that._segments || [];
                var rotated = that._options.rotated;
                if (!that.isVisible()) {
                    return
                }
                if (segments.length) {
                    trackers = that._trackers = that._trackers || [];
                    trackersGroup = that._trackersGroup = (that._trackersGroup || that._renderer.g().attr({
                        fill: "gray",
                        opacity: .001,
                        stroke: "gray",
                        "class": "dxc-trackers"
                    })).attr({
                        "clip-path": this._paneClipRectID || null
                    }).append(that._group);
                    (0, _iterator.each)(segments, function(i, segment) {
                        if (!trackers[i]) {
                            trackers[i] = that._drawTrackerElement(segment).data({
                                "chart-data-series": that
                            }).append(trackersGroup)
                        } else {
                            that._updateTrackerElement(segment, trackers[i])
                        }
                    })
                }
                that._trackersTranslator = that.groupPointsByCoords(rotated)
            },
            _checkAxisVisibleAreaCoord: function(isArgument, coord) {
                var axis = isArgument ? this.getArgumentAxis() : this.getValueAxis();
                var visibleArea = axis.getVisibleArea();
                return (0, _type.isDefined)(coord) && visibleArea[0] <= coord && visibleArea[1] >= coord
            },
            checkSeriesViewportCoord: function(axis, coord) {
                return this.getPoints().length && this.isVisible()
            },
            getSeriesPairCoord: function(coord, isArgument) {
                var oppositeCoord = null;
                var isOpposite = !isArgument && !this._options.rotated || isArgument && this._options.rotated;
                var coordName = !isOpposite ? "vx" : "vy";
                var oppositeCoordName = !isOpposite ? "vy" : "vx";
                var points = this.getVisiblePoints();
                for (var i = 0; i < points.length; i++) {
                    var p = points[i];
                    var tmpCoord = p[coordName] === coord ? p[oppositeCoordName] : void 0;
                    if (this._checkAxisVisibleAreaCoord(!isArgument, tmpCoord)) {
                        oppositeCoord = tmpCoord;
                        break
                    }
                }
                return oppositeCoord
            },
            _getNearestPoints: function(point, nextPoint) {
                return [point, nextPoint]
            },
            _getBezierPoints: function() {
                return []
            },
            _getNearestPointsByCoord: function(coord, isArgument) {
                var that = this;
                var rotated = that.getOptions().rotated;
                var isOpposite = !isArgument && !rotated || isArgument && rotated;
                var coordName = isOpposite ? "vy" : "vx";
                var allPoints = that.getPoints();
                var bezierPoints = that._getBezierPoints();
                var nearestPoints = [];
                if (allPoints.length > 1) {
                    allPoints.forEach(function(point, i) {
                        var nextPoint = allPoints[i + 1];
                        if (nextPoint && (point[coordName] <= coord && nextPoint[coordName] >= coord || point[coordName] >= coord && nextPoint[coordName] <= coord)) {
                            nearestPoints.push(that._getNearestPoints(point, nextPoint, bezierPoints))
                        }
                    })
                } else {
                    nearestPoints.push([allPoints[0], allPoints[0]])
                }
                return nearestPoints
            },
            getNeighborPoint: function(x, y) {
                var pCoord = this._options.rotated ? y : x;
                var nCoord = pCoord;
                var cat = this._trackersTranslator;
                var point = null;
                var minDistance;
                var oppositeCoord = this._options.rotated ? x : y;
                var oppositeCoordName = this._options.rotated ? "vx" : "vy";
                if (this.isVisible() && cat) {
                    point = cat[pCoord];
                    do {
                        point = cat[nCoord] || cat[pCoord];
                        pCoord--;
                        nCoord++
                    } while ((pCoord >= 0 || nCoord < cat.length) && !point);
                    if (Array.isArray(point)) {
                        minDistance = _abs(point[0][oppositeCoordName] - oppositeCoord);
                        (0, _iterator.each)(point, function(i, p) {
                            var distance = _abs(p[oppositeCoordName] - oppositeCoord);
                            if (minDistance >= distance) {
                                minDistance = distance;
                                point = p
                            }
                        })
                    }
                }
                return point
            },
            _applyVisibleArea: function() {
                var that = this;
                var rotated = that._options.rotated;
                var visibleX = (rotated ? that.getValueAxis() : that.getArgumentAxis()).getVisibleArea();
                var visibleY = (rotated ? that.getArgumentAxis() : that.getValueAxis()).getVisibleArea();
                that._visibleArea = {
                    minX: visibleX[0],
                    maxX: visibleX[1],
                    minY: visibleY[0],
                    maxY: visibleY[1]
                }
            },
            getPointCenterByArg: function(arg) {
                var point = this.getPointsByArg(arg)[0];
                return point ? point.getCenterCoord() : void 0
            }
        });
        exports.polar = polar = (0, _extend3.extend)({}, baseScatterMethods, {
            drawTrackers: function() {
                chart.drawTrackers.call(this);
                var cat = this._trackersTranslator;
                var index;
                if (!this.isVisible()) {
                    return
                }(0, _iterator.each)(cat, function(i, category) {
                    if (category) {
                        index = i;
                        return false
                    }
                });
                cat[index + 360] = cat[index]
            },
            getNeighborPoint: function(x, y) {
                var pos = (0, _utils.convertXYToPolar)(this.getValueAxis().getCenter(), x, y);
                return chart.getNeighborPoint.call(this, pos.phi, pos.r)
            },
            _applyVisibleArea: function() {
                var that = this;
                var canvas = that.getValueAxis().getCanvas();
                that._visibleArea = {
                    minX: canvas.left,
                    maxX: canvas.width - canvas.right,
                    minY: canvas.top,
                    maxY: canvas.height - canvas.bottom
                }
            },
            getSeriesPairCoord: function(params, isArgument) {
                var coords = null;
                var paramName = isArgument ? "argument" : "radius";
                var points = this.getVisiblePoints();
                for (var i = 0; i < points.length; i++) {
                    var p = points[i];
                    var tmpPoint = (0, _type.isDefined)(p[paramName]) && (0, _type.isDefined)(params[paramName]) && p[paramName].valueOf() === params[paramName].valueOf() ? {
                        x: p.x,
                        y: p.y
                    } : void 0;
                    if ((0, _type.isDefined)(tmpPoint)) {
                        coords = tmpPoint;
                        break
                    }
                }
                return coords
            }
        })
    },
    /*!******************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/core/tooltip.js ***!
      \******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.plugin = exports.Tooltip = void 0;
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _inflector = __webpack_require__( /*! ../../core/utils/inflector */ 39);
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _renderer2 = __webpack_require__( /*! ./renderers/renderer */ 177);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _utils = __webpack_require__( /*! ./utils */ 14);
        var _format_helper = _interopRequireDefault(__webpack_require__( /*! ../../format_helper */ 71));
        var _plaque = __webpack_require__( /*! ./plaque */ 466);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var format = _format_helper.default.format;
        var mathCeil = Math.ceil;
        var mathMax = Math.max;
        var mathMin = Math.min;
        var window = (0, _window.getWindow)();
        var DEFAULT_HTML_GROUP_WIDTH = 3e3;

        function hideElement($element) {
            $element.css({
                left: "-9999px"
            }).detach()
        }

        function getSpecialFormatOptions(options, specialFormat) {
            var result = options;
            switch (specialFormat) {
                case "argument":
                    result = {
                        format: options.argumentFormat
                    };
                    break;
                case "percent":
                    result = {
                        format: {
                            type: "percent",
                            precision: options.format && options.format.percentPrecision
                        }
                    }
            }
            return result
        }
        var Tooltip = function(params) {
            var that = this;
            var renderer;
            that._eventTrigger = params.eventTrigger;
            that._widgetRoot = params.widgetRoot;
            that._widget = params.widget;
            that._wrapper = (0, _renderer.default)("<div>").css({
                position: "absolute",
                overflow: "hidden",
                pointerEvents: "none"
            }).addClass(params.cssClass);
            that._renderer = renderer = new _renderer2.Renderer({
                pathModified: params.pathModified,
                container: that._wrapper[0]
            });
            var root = renderer.root;
            root.attr({
                "pointer-events": "none"
            });
            that._text = renderer.text(void 0, 0, 0);
            that._textGroupHtml = (0, _renderer.default)("<div>").css({
                position: "absolute",
                padding: 0,
                margin: 0,
                border: "0px solid transparent"
            }).appendTo(that._wrapper);
            that._textHtml = (0, _renderer.default)("<div>").css({
                position: "relative",
                display: "inline-block",
                padding: 0,
                margin: 0,
                border: "0px solid transparent"
            }).appendTo(that._textGroupHtml)
        };
        exports.Tooltip = Tooltip;
        Tooltip.prototype = {
            constructor: Tooltip,
            dispose: function() {
                this._wrapper.remove();
                this._renderer.dispose();
                this._options = this._widgetRoot = null
            },
            _getContainer: function() {
                var options = this._options;
                var container = (0, _renderer.default)(this._widgetRoot).closest(options.container);
                if (0 === container.length) {
                    container = (0, _renderer.default)(options.container)
                }
                return (container.length ? container : (0, _renderer.default)("body")).get(0)
            },
            setTemplate: function(contentTemplate) {
                var that = this;
                that._template = contentTemplate ? that._widget._getTemplate(contentTemplate) : null
            },
            setOptions: function(options) {
                var _this = this;
                options = options || {};
                var that = this;
                that._options = options;
                that._textFontStyles = (0, _utils.patchFontOptions)(options.font);
                that._textFontStyles.color = that._textFontStyles.fill;
                that._wrapper.css({
                    zIndex: options.zIndex
                });
                that._customizeTooltip = options.customizeTooltip;
                var textGroupHtml = that._textGroupHtml;
                var textHtml = that._textHtml;
                if (this.plaque) {
                    this.plaque.clear()
                }
                this.setTemplate(options.contentTemplate);
                var pointerEvents = options.interactive ? "auto" : "none";
                if (options.interactive) {
                    this._renderer.root.css({
                        "-ms-user-select": "auto",
                        "-moz-user-select": "auto",
                        "-webkit-user-select": "auto"
                    })
                }
                var drawTooltip = function(_ref) {
                    var group = _ref.group,
                        onRender = _ref.onRender,
                        eventData = _ref.eventData,
                        isMoving = _ref.isMoving,
                        _ref$templateCallback = _ref.templateCallback,
                        templateCallback = void 0 === _ref$templateCallback ? function() {} : _ref$templateCallback;
                    var state = that._state;
                    if (!isMoving) {
                        var template = that._template;
                        var useTemplate = template && !state.formatObject.skipTemplate;
                        if (state.html || useTemplate) {
                            textGroupHtml.css({
                                color: state.textColor,
                                width: DEFAULT_HTML_GROUP_WIDTH,
                                pointerEvents: pointerEvents
                            });
                            if (useTemplate) {
                                template.render({
                                    model: state.formatObject,
                                    container: textHtml,
                                    onRendered: function() {
                                        state.html = textHtml.html();
                                        if (0 === textHtml.width() && 0 === textHtml.height()) {
                                            _this.plaque.clear();
                                            templateCallback(false);
                                            return
                                        }
                                        onRender();
                                        that._riseEvents(eventData);
                                        that._moveWrapper();
                                        that.plaque.customizeCloud({
                                            fill: state.color,
                                            stroke: state.borderColor,
                                            "pointer-events": pointerEvents
                                        });
                                        templateCallback(true)
                                    }
                                });
                                return
                            } else {
                                that._text.attr({
                                    text: ""
                                });
                                textHtml.html(state.html)
                            }
                        } else {
                            that._text.css({
                                fill: state.textColor
                            }).attr({
                                text: state.text,
                                "class": options.cssClass,
                                "pointer-events": pointerEvents
                            }).append(group.attr({
                                align: options.textAlignment
                            }))
                        }
                        that._riseEvents(eventData);
                        that.plaque.customizeCloud({
                            fill: state.color,
                            stroke: state.borderColor,
                            "pointer-events": pointerEvents
                        })
                    }
                    onRender();
                    that._moveWrapper();
                    return true
                };
                this.plaque = new _plaque.Plaque({
                    opacity: that._options.opacity,
                    color: that._options.color,
                    border: that._options.border,
                    paddingLeftRight: that._options.paddingLeftRight,
                    paddingTopBottom: that._options.paddingTopBottom,
                    arrowLength: that._options.arrowLength,
                    arrowWidth: 20,
                    shadow: that._options.shadow,
                    cornerRadius: that._options.cornerRadius
                }, that, that._renderer.root, drawTooltip, true, function(tooltip, g) {
                    var state = tooltip._state;
                    if (state.html) {
                        var bBox;
                        var getComputedStyle = window.getComputedStyle;
                        if (getComputedStyle) {
                            bBox = getComputedStyle(textHtml.get(0));
                            bBox = {
                                x: 0,
                                y: 0,
                                width: mathCeil(parseFloat(bBox.width)),
                                height: mathCeil(parseFloat(bBox.height))
                            }
                        } else {
                            bBox = textHtml.get(0).getBoundingClientRect();
                            bBox = {
                                x: 0,
                                y: 0,
                                width: mathCeil(bBox.width ? bBox.width : bBox.right - bBox.left),
                                height: mathCeil(bBox.height ? bBox.height : bBox.bottom - bBox.top)
                            }
                        }
                        return bBox
                    }
                    return g.getBBox()
                }, function(tooltip, g, x, y) {
                    var state = tooltip._state;
                    if (state.html) {
                        that._textGroupHtml.css({
                            left: x,
                            top: y
                        })
                    } else {
                        g.move(x, y)
                    }
                });
                return that
            },
            _riseEvents: function(eventData) {
                var that = this;
                that._eventData && that._eventTrigger("tooltipHidden", that._eventData);
                that._eventData = eventData;
                that._eventTrigger("tooltipShown", that._eventData)
            },
            setRendererOptions: function(options) {
                this._renderer.setOptions(options);
                this._textGroupHtml.css({
                    direction: options.rtl ? "rtl" : "ltr"
                });
                return this
            },
            update: function(options) {
                var that = this;
                that.setOptions(options);
                hideElement(that._wrapper);
                var normalizedCSS = {};
                for (var name in that._textFontStyles) {
                    normalizedCSS[(0, _inflector.camelize)(name)] = that._textFontStyles[name]
                }
                that._textGroupHtml.css(normalizedCSS);
                that._text.css(that._textFontStyles);
                that._eventData = null;
                return that
            },
            _prepare: function(formatObject, state) {
                var customizeTooltip = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this._customizeTooltip;
                var options = this._options;
                var customize = {};
                if ((0, _type.isFunction)(customizeTooltip)) {
                    customize = customizeTooltip.call(formatObject, formatObject);
                    customize = (0, _type.isPlainObject)(customize) ? customize : {};
                    if ("text" in customize) {
                        state.text = (0, _type.isDefined)(customize.text) ? String(customize.text) : ""
                    }
                    if ("html" in customize) {
                        state.html = (0, _type.isDefined)(customize.html) ? String(customize.html) : ""
                    }
                }
                if (!("text" in state) && !("html" in state)) {
                    state.text = formatObject.valueText || formatObject.description || ""
                }
                state.color = customize.color || options.color;
                state.borderColor = customize.borderColor || (options.border || {}).color;
                state.textColor = customize.fontColor || (this._textFontStyles || {}).color;
                return !!state.text || !!state.html || !!this._template
            },
            show: function(formatObject, params, eventData, customizeTooltip, templateCallback) {
                var that = this;
                if (that._options.forceEvents) {
                    eventData.x = params.x;
                    eventData.y = params.y - params.offset;
                    that._riseEvents(eventData);
                    return true
                }
                var state = {
                    formatObject: formatObject,
                    eventData: eventData,
                    templateCallback: templateCallback
                };
                if (!that._prepare(formatObject, state, customizeTooltip)) {
                    return false
                }
                that._state = state;
                that._wrapper.appendTo(that._getContainer());
                that._clear();
                var parameters = (0, _extend.extend)({}, that._options, {
                    canvas: that._getCanvas()
                }, state, {
                    x: params.x,
                    y: params.y,
                    offset: params.offset
                });
                return this.plaque.clear().draw(parameters)
            },
            isCursorOnTooltip: function(x, y) {
                if (this._options.interactive && this.isEnabled()) {
                    var box = this.plaque.getBBox();
                    return x > box.x && x < box.x + box.width && y > box.y && y < box.y + box.height
                }
                return false
            },
            hide: function() {
                var that = this;
                hideElement(that._wrapper);
                if (that._eventData) {
                    that._eventTrigger("tooltipHidden", that._eventData);
                    that._clear();
                    that._eventData = null
                }
            },
            _clear: function() {
                this._textHtml.empty()
            },
            move: function(x, y, offset) {
                this.plaque.draw({
                    x: x,
                    y: y,
                    offset: offset,
                    canvas: this._getCanvas(),
                    isMoving: true
                })
            },
            _moveWrapper: function() {
                var that = this;
                var plaqueBBox = this.plaque.getBBox();
                that._renderer.resize(plaqueBBox.width, plaqueBBox.height);
                var offset = that._wrapper.css({
                    left: 0,
                    top: 0
                }).offset();
                var left = plaqueBBox.x;
                var top = plaqueBBox.y;
                that._wrapper.css({
                    left: left - offset.left,
                    top: top - offset.top
                });
                this.plaque.moveRoot(-left, -top);
                if (this._state.html) {
                    that._textHtml.css({
                        left: -left,
                        top: -top
                    });
                    that._textGroupHtml.css({
                        width: mathCeil(that._textHtml.width())
                    })
                }
            },
            formatValue: function(value, _specialFormat) {
                var options = _specialFormat ? getSpecialFormatOptions(this._options, _specialFormat) : this._options;
                return format(value, options.format)
            },
            getLocation: function() {
                return (0, _utils.normalizeEnum)(this._options.location)
            },
            isEnabled: function() {
                return !!this._options.enabled || !!this._options.forceEvents
            },
            isShared: function() {
                return !!this._options.shared
            },
            _getCanvas: function() {
                var container = this._getContainer();
                var containerBox = container.getBoundingClientRect();
                var html = _dom_adapter.default.getDocumentElement();
                var document = _dom_adapter.default.getDocument();
                var left = window.pageXOffset || html.scrollLeft || 0;
                var top = window.pageYOffset || html.scrollTop || 0;
                var box = {
                    left: left,
                    top: top,
                    width: mathMax(html.clientWidth, document.body.clientWidth) + left,
                    height: mathMax(document.body.scrollHeight, html.scrollHeight, document.body.offsetHeight, html.offsetHeight, document.body.clientHeight, html.clientHeight),
                    right: 0,
                    bottom: 0
                };
                if (container !== _dom_adapter.default.getBody()) {
                    left = mathMax(box.left, box.left + containerBox.left);
                    top = mathMax(box.top, box.top + containerBox.top);
                    box.width = mathMin(containerBox.width, box.width) + left + box.left;
                    box.height = mathMin(containerBox.height, box.height) + top + box.top;
                    box.left = left;
                    box.top = top
                }
                return box
            }
        };
        var plugin = {
            name: "tooltip",
            init: function() {
                this._initTooltip()
            },
            dispose: function() {
                this._disposeTooltip()
            },
            members: {
                _initTooltip: function() {
                    this._tooltip = new Tooltip({
                        cssClass: this._rootClassPrefix + "-tooltip",
                        eventTrigger: this._eventTrigger,
                        pathModified: this.option("pathModified"),
                        widgetRoot: this.element(),
                        widget: this
                    })
                },
                _disposeTooltip: function() {
                    this._tooltip.dispose();
                    this._tooltip = null
                },
                _setTooltipRendererOptions: function() {
                    this._tooltip.setRendererOptions(this._getRendererOptions())
                },
                _setTooltipOptions: function() {
                    this._tooltip.update(this._getOption("tooltip"))
                }
            },
            extenders: {
                _stopCurrentHandling: function() {
                    this._tooltip && this._tooltip.hide()
                }
            },
            customize: function(constructor) {
                var proto = constructor.prototype;
                proto._eventsMap.onTooltipShown = {
                    name: "tooltipShown"
                };
                proto._eventsMap.onTooltipHidden = {
                    name: "tooltipHidden"
                };
                constructor.addChange({
                    code: "TOOLTIP_RENDERER",
                    handler: function() {
                        this._setTooltipRendererOptions()
                    },
                    isThemeDependent: true,
                    isOptionChange: true
                });
                constructor.addChange({
                    code: "TOOLTIP",
                    handler: function() {
                        this._setTooltipOptions()
                    },
                    isThemeDependent: true,
                    isOptionChange: true,
                    option: "tooltip"
                })
            },
            fontFields: ["tooltip.font"]
        };
        exports.plugin = plugin
    },
    /*!***********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/translators/range.js ***!
      \***********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.Range = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _isDefined = _type.isDefined;
        var _isDate = _type.isDate;
        var _isFunction = _type.isFunction;
        var minSelector = "min";
        var maxSelector = "max";
        var minVisibleSelector = "minVisible";
        var maxVisibleSelector = "maxVisible";
        var baseSelector = "base";
        var axisTypeSelector = "axisType";

        function otherLessThan(thisValue, otherValue) {
            return otherValue < thisValue
        }

        function otherGreaterThan(thisValue, otherValue) {
            return otherValue > thisValue
        }

        function compareAndReplace(thisValue, otherValue, setValue, compare) {
            var otherValueDefined = _isDefined(otherValue);
            if (_isDefined(thisValue)) {
                if (otherValueDefined && compare(thisValue, otherValue)) {
                    setValue(otherValue)
                }
            } else {
                if (otherValueDefined) {
                    setValue(otherValue)
                }
            }
        }
        var Range = function(range) {
            range && (0, _extend.extend)(this, range)
        };
        exports.Range = Range;
        var _Range = Range;
        _Range.prototype = {
            constructor: _Range,
            addRange: function(otherRange) {
                var that = this;
                var categories = that.categories;
                var otherCategories = otherRange.categories;
                var isDiscrete = "discrete" === that[axisTypeSelector];
                var compareAndReplaceByField = function(field, compare) {
                    compareAndReplace(that[field], otherRange[field], function(value) {
                        that[field] = value
                    }, compare)
                };
                var controlValuesByVisibleBounds = function(valueField, visibleValueField, compare) {
                    compareAndReplace(that[valueField], that[visibleValueField], function(value) {
                        _isDefined(that[valueField]) && (that[valueField] = value)
                    }, compare)
                };
                var checkField = function(field) {
                    that[field] = that[field] || otherRange[field]
                };
                checkField("invert");
                checkField(axisTypeSelector);
                checkField("dataType");
                checkField("isSpacedMargin");
                if ("logarithmic" === that[axisTypeSelector]) {
                    checkField(baseSelector)
                } else {
                    that[baseSelector] = void 0
                }
                compareAndReplaceByField(minSelector, otherLessThan);
                compareAndReplaceByField(maxSelector, otherGreaterThan);
                if (isDiscrete) {
                    checkField(minVisibleSelector);
                    checkField(maxVisibleSelector)
                } else {
                    compareAndReplaceByField(minVisibleSelector, otherLessThan);
                    compareAndReplaceByField(maxVisibleSelector, otherGreaterThan)
                }
                compareAndReplaceByField("interval", otherLessThan);
                if (!isDiscrete) {
                    controlValuesByVisibleBounds(minSelector, minVisibleSelector, otherLessThan);
                    controlValuesByVisibleBounds(minSelector, maxVisibleSelector, otherLessThan);
                    controlValuesByVisibleBounds(maxSelector, maxVisibleSelector, otherGreaterThan);
                    controlValuesByVisibleBounds(maxSelector, minVisibleSelector, otherGreaterThan)
                }
                if (void 0 === categories) {
                    that.categories = otherCategories
                } else {
                    that.categories = otherCategories ? (0, _utils.unique)(categories.concat(otherCategories)) : categories
                }
                if ("logarithmic" === that[axisTypeSelector]) {
                    checkField("allowNegatives");
                    compareAndReplaceByField("linearThreshold", otherLessThan)
                }
                return that
            },
            isEmpty: function() {
                return (!_isDefined(this[minSelector]) || !_isDefined(this[maxSelector])) && (!this.categories || 0 === this.categories.length)
            },
            correctValueZeroLevel: function() {
                var that = this;
                if ("logarithmic" === that[axisTypeSelector] || _isDate(that[maxSelector]) || _isDate(that[minSelector])) {
                    return that
                }

                function setZeroLevel(min, max) {
                    that[min] < 0 && that[max] < 0 && (that[max] = 0);
                    that[min] > 0 && that[max] > 0 && (that[min] = 0)
                }
                setZeroLevel(minSelector, maxSelector);
                setZeroLevel(minVisibleSelector, maxVisibleSelector);
                return that
            },
            sortCategories: function(sort) {
                if (false === sort || !this.categories) {
                    return
                }
                if (Array.isArray(sort)) {
                    var sortValues = sort.map(function(item) {
                        return item.valueOf()
                    });
                    var filteredSeriesCategories = this.categories.filter(function(item) {
                        return sortValues.indexOf(item.valueOf()) === -1
                    });
                    this.categories = sort.concat(filteredSeriesCategories)
                } else {
                    var notAFunction = !_isFunction(sort);
                    if (notAFunction && "string" !== this.dataType) {
                        sort = function(a, b) {
                            return a.valueOf() - b.valueOf()
                        }
                    } else {
                        if (notAFunction) {
                            sort = false
                        }
                    }
                    sort && this.categories.sort(sort)
                }
            }
        }
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/resize_callbacks.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _window = __webpack_require__( /*! ./window */ 7);
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../dom_adapter */ 11));
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ./callbacks */ 27));
        var _ready_callbacks = _interopRequireDefault(__webpack_require__( /*! ./ready_callbacks */ 49));
        var _call_once = _interopRequireDefault(__webpack_require__( /*! ./call_once */ 85));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var resizeCallbacks = function() {
            var prevSize;
            var callbacks = (0, _callbacks.default)();
            var originalCallbacksAdd = callbacks.add;
            var originalCallbacksRemove = callbacks.remove;
            if (!(0, _window.hasWindow)()) {
                return callbacks
            }
            var formatSize = function() {
                var window = (0, _window.getWindow)();
                return {
                    width: window.innerWidth,
                    height: window.innerHeight
                }
            };
            var handleResize = function() {
                var now = formatSize();
                if (now.width === prevSize.width && now.height === prevSize.height) {
                    return
                }
                var changedDimension;
                if (now.width === prevSize.width) {
                    changedDimension = "height"
                }
                if (now.height === prevSize.height) {
                    changedDimension = "width"
                }
                prevSize = now;
                callbacks.fire(changedDimension)
            };
            var setPrevSize = (0, _call_once.default)(function() {
                prevSize = formatSize()
            });
            var removeListener;
            callbacks.add = function() {
                var result = originalCallbacksAdd.apply(callbacks, arguments);
                setPrevSize();
                _ready_callbacks.default.add(function() {
                    if (!removeListener && callbacks.has()) {
                        removeListener = _dom_adapter.default.listen((0, _window.getWindow)(), "resize", handleResize)
                    }
                });
                return result
            };
            callbacks.remove = function() {
                var result = originalCallbacksRemove.apply(callbacks, arguments);
                if (!callbacks.has() && removeListener) {
                    removeListener();
                    removeListener = void 0
                }
                return result
            };
            return callbacks
        }();
        var _default = resizeCallbacks;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************************!*\
      !*** ./artifacts/transpiled-npm/core/templates/function_template.js ***!
      \**********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.FunctionTemplate = void 0;
        var _template_base = __webpack_require__( /*! ./template_base */ 75);
        var _dom = __webpack_require__( /*! ../utils/dom */ 33);

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var FunctionTemplate = function(_TemplateBase) {
            _inheritsLoose(FunctionTemplate, _TemplateBase);

            function FunctionTemplate(render) {
                var _this;
                _this = _TemplateBase.call(this) || this;
                _this._render = render;
                return _this
            }
            var _proto = FunctionTemplate.prototype;
            _proto._renderCore = function(options) {
                return (0, _dom.normalizeTemplateElement)(this._render(options))
            };
            return FunctionTemplate
        }(_template_base.TemplateBase);
        exports.FunctionTemplate = FunctionTemplate
    },
    /*!****************************************************!*\
      !*** ./artifacts/transpiled-npm/core/component.js ***!
      \****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _config = _interopRequireDefault(__webpack_require__( /*! ./config */ 31));
        var _extend = __webpack_require__( /*! ./utils/extend */ 0);
        var _index = __webpack_require__( /*! ./options/index */ 335);
        var _utils = __webpack_require__( /*! ./options/utils */ 198);
        var _class = _interopRequireDefault(__webpack_require__( /*! ./class */ 15));
        var _action = _interopRequireDefault(__webpack_require__( /*! ./action */ 111));
        var _errors = _interopRequireDefault(__webpack_require__( /*! ./errors */ 25));
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ./utils/callbacks */ 27));
        var _events_strategy = __webpack_require__( /*! ./events_strategy */ 100);
        var _public_component = __webpack_require__( /*! ./utils/public_component */ 147);
        var _postponed_operations = __webpack_require__( /*! ./postponed_operations */ 518);
        var _type = __webpack_require__( /*! ./utils/type */ 1);
        var _common = __webpack_require__( /*! ./utils/common */ 4);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var getEventName = function(actionName) {
            return actionName.charAt(2).toLowerCase() + actionName.substr(3)
        };
        var isInnerOption = function(optionName) {
            return 0 === optionName.indexOf("_", 0)
        };
        var Component = _class.default.inherit({
            _setDeprecatedOptions: function() {
                this._deprecatedOptions = {}
            },
            _getDeprecatedOptions: function() {
                return this._deprecatedOptions
            },
            _getDefaultOptions: function() {
                return {
                    onInitialized: null,
                    onOptionChanged: null,
                    onDisposing: null,
                    defaultOptionsRules: null
                }
            },
            _defaultOptionsRules: function() {
                return []
            },
            _setOptionsByDevice: function(rules) {
                this._options.applyRules(rules)
            },
            _convertRulesToOptions: function(rules) {
                return (0, _utils.convertRulesToOptions)(rules)
            },
            _isInitialOptionValue: function(name) {
                return this._options.isInitial(name)
            },
            _setOptionsByReference: function() {
                this._optionsByReference = {}
            },
            _getOptionsByReference: function() {
                return this._optionsByReference
            },
            ctor: function() {
                var options = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                var _optionChangedCallbacks = options._optionChangedCallbacks,
                    _disposingCallbacks = options._disposingCallbacks;
                this.NAME = (0, _public_component.name)(this.constructor);
                this._eventsStrategy = _events_strategy.EventsStrategy.create(this, options.eventsStrategy);
                this._updateLockCount = 0;
                this._optionChangedCallbacks = _optionChangedCallbacks || (0, _callbacks.default)();
                this._disposingCallbacks = _disposingCallbacks || (0, _callbacks.default)();
                this.postponedOperations = new _postponed_operations.PostponedOperations;
                this._createOptions(options)
            },
            _createOptions: function(options) {
                var _this = this;
                this.beginUpdate();
                try {
                    this._setOptionsByReference();
                    this._setDeprecatedOptions();
                    this._options = new _index.Options(this._getDefaultOptions(), this._getDefaultOptions(), this._getOptionsByReference(), this._getDeprecatedOptions());
                    this._options.onChanging(function(name, previousValue, value) {
                        return _this._initialized && _this._optionChanging(name, previousValue, value)
                    });
                    this._options.onDeprecated(function(option, info) {
                        return _this._logDeprecatedOptionWarning(option, info)
                    });
                    this._options.onChanged(function(name, value, previousValue) {
                        return _this._notifyOptionChanged(name, value, previousValue)
                    });
                    this._options.onStartChange(function() {
                        return _this.beginUpdate()
                    });
                    this._options.onEndChange(function() {
                        return _this.endUpdate()
                    });
                    this._options.addRules(this._defaultOptionsRules());
                    if (options && options.onInitializing) {
                        options.onInitializing.apply(this, [options])
                    }
                    this._setOptionsByDevice(options.defaultOptionsRules);
                    this._initOptions(options)
                } finally {
                    this.endUpdate()
                }
            },
            _initOptions: function(options) {
                this.option(options)
            },
            _init: function() {
                var _this2 = this;
                this._createOptionChangedAction();
                this.on("disposing", function(args) {
                    _this2._disposingCallbacks.fireWith(_this2, [args])
                })
            },
            _logDeprecatedOptionWarning: function(option, info) {
                var message = info.message || "Use the '".concat(info.alias, "' option instead");
                _errors.default.log("W0001", this.NAME, option, info.since, message)
            },
            _logDeprecatedComponentWarning: function(since, alias) {
                _errors.default.log("W0000", this.NAME, since, "Use the '".concat(alias, "' widget instead"))
            },
            _createOptionChangedAction: function() {
                this._optionChangedAction = this._createActionByOption("onOptionChanged", {
                    excludeValidators: ["disabled", "readOnly"]
                })
            },
            _createDisposingAction: function() {
                this._disposingAction = this._createActionByOption("onDisposing", {
                    excludeValidators: ["disabled", "readOnly"]
                })
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "onDisposing":
                    case "onInitialized":
                        break;
                    case "onOptionChanged":
                        this._createOptionChangedAction();
                        break;
                    case "defaultOptionsRules":
                }
            },
            _dispose: function() {
                this._optionChangedCallbacks.empty();
                this._createDisposingAction();
                this._disposingAction();
                this._eventsStrategy.dispose();
                this._options.dispose();
                this._disposed = true
            },
            _lockUpdate: function() {
                this._updateLockCount++
            },
            _unlockUpdate: function() {
                this._updateLockCount = Math.max(this._updateLockCount - 1, 0)
            },
            _isUpdateAllowed: function() {
                return 0 === this._updateLockCount
            },
            _isInitializingRequired: function() {
                return !this._initializing && !this._initialized
            },
            _commitUpdate: function() {
                this.postponedOperations.callPostponedOperations();
                this._isInitializingRequired() && this._initializeComponent()
            },
            _initializeComponent: function() {
                this._initializing = true;
                try {
                    this._init()
                } finally {
                    this._initializing = false;
                    this._lockUpdate();
                    this._createActionByOption("onInitialized", {
                        excludeValidators: ["disabled", "readOnly"]
                    })();
                    this._unlockUpdate();
                    this._initialized = true
                }
            },
            instance: function() {
                return this
            },
            beginUpdate: function() {
                this._lockUpdate()
            },
            endUpdate: function() {
                this._unlockUpdate();
                this._isUpdateAllowed() && this._commitUpdate()
            },
            _optionChanging: _common.noop,
            _notifyOptionChanged: function(option, value, previousValue) {
                if (this._initialized) {
                    var optionNames = [option].concat(this._options.getAliasesByName(option));
                    for (var i = 0; i < optionNames.length; i++) {
                        var name = optionNames[i];
                        var args = {
                            name: name.split(/[.[]/)[0],
                            fullName: name,
                            value: value,
                            previousValue: previousValue
                        };
                        if (!isInnerOption(name)) {
                            this._optionChangedCallbacks.fireWith(this, [(0, _extend.extend)(this._defaultActionArgs(), args)]);
                            this._optionChangedAction((0, _extend.extend)({}, args))
                        }
                        if (!this._disposed && this._cancelOptionChange !== name) {
                            this._optionChanged(args)
                        }
                    }
                }
            },
            initialOption: function(name) {
                return this._options.initial(name)
            },
            _defaultActionConfig: function() {
                return {
                    context: this,
                    component: this
                }
            },
            _defaultActionArgs: function() {
                return {
                    component: this
                }
            },
            _createAction: function(actionSource, config) {
                var _this3 = this;
                var action;
                return function(e) {
                    if (!(0, _type.isDefined)(e)) {
                        e = {}
                    }
                    if (!(0, _type.isPlainObject)(e)) {
                        e = {
                            actionValue: e
                        }
                    }
                    action = action || new _action.default(actionSource, (0, _extend.extend)(config, _this3._defaultActionConfig()));
                    return action.execute.call(action, (0, _extend.extend)(e, _this3._defaultActionArgs()))
                }
            },
            _createActionByOption: function(optionName, config) {
                var _this4 = this;
                var action;
                var eventName;
                var actionFunc;
                var result = function() {
                    if (!eventName) {
                        config = config || {};
                        if ("string" !== typeof optionName) {
                            throw _errors.default.Error("E0008")
                        }
                        if (0 === optionName.indexOf("on")) {
                            eventName = getEventName(optionName)
                        }
                        actionFunc = _this4.option(optionName)
                    }
                    if (!action && !actionFunc && !config.beforeExecute && !config.afterExecute && !_this4._eventsStrategy.hasEvent(eventName)) {
                        return
                    }
                    if (!action) {
                        var beforeExecute = config.beforeExecute;
                        config.beforeExecute = function() {
                            for (var _len2 = arguments.length, props = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                                props[_key2] = arguments[_key2]
                            }
                            beforeExecute && beforeExecute.apply(_this4, props);
                            _this4._eventsStrategy.fireEvent(eventName, props[0].args)
                        };
                        action = _this4._createAction(actionFunc, config)
                    }
                    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key]
                    }
                    if ((0, _config.default)().wrapActionsBeforeExecute) {
                        var beforeActionExecute = _this4.option("beforeActionExecute") || _common.noop;
                        var wrappedAction = beforeActionExecute(_this4, action, config) || action;
                        return wrappedAction.apply(_this4, args)
                    }
                    return action.apply(_this4, args)
                };
                if ((0, _config.default)().wrapActionsBeforeExecute) {
                    return result
                }
                var onActionCreated = this.option("onActionCreated") || _common.noop;
                return onActionCreated(this, result, config) || result
            },
            on: function(eventName, eventHandler) {
                this._eventsStrategy.on(eventName, eventHandler);
                return this
            },
            off: function(eventName, eventHandler) {
                this._eventsStrategy.off(eventName, eventHandler);
                return this
            },
            hasActionSubscription: function(actionName) {
                return !!this._options.silent(actionName) || this._eventsStrategy.hasEvent(getEventName(actionName))
            },
            isOptionDeprecated: function(name) {
                return this._options.isDeprecated(name)
            },
            _setOptionWithoutOptionChange: function(name, value) {
                this._cancelOptionChange = name;
                this.option(name, value);
                this._cancelOptionChange = false
            },
            _getOptionValue: function(name, context) {
                var value = this.option(name);
                if ((0, _type.isFunction)(value)) {
                    return value.bind(context)()
                }
                return value
            },
            option: function() {
                var _this$_options;
                return (_this$_options = this._options).option.apply(_this$_options, arguments)
            },
            resetOption: function(name) {
                this.beginUpdate();
                this._options.reset(name);
                this.endUpdate()
            }
        });
        var _default = Component;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/events/short.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.keyboard = exports.click = exports.dxClick = exports.focus = exports.visibility = exports.hover = exports.resize = exports.active = void 0;
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../core/dom_adapter */ 11));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ./core/events_engine */ 5));
        var _keyboard_processor = _interopRequireDefault(__webpack_require__( /*! ./core/keyboard_processor */ 522));
        var _index = __webpack_require__( /*! ./utils/index */ 8);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function addNamespace(event, namespace) {
            return namespace ? (0, _index.addNamespace)(event, namespace) : event
        }

        function executeAction(action, args) {
            return "function" === typeof action ? action(args) : action.execute(args)
        }
        var active = {
            on: function($el, active, inactive, opts) {
                var selector = opts.selector,
                    showTimeout = opts.showTimeout,
                    hideTimeout = opts.hideTimeout,
                    namespace = opts.namespace;
                _events_engine.default.on($el, addNamespace("dxactive", namespace), selector, {
                    timeout: showTimeout
                }, function(event) {
                    return executeAction(active, {
                        event: event,
                        element: event.currentTarget
                    })
                });
                _events_engine.default.on($el, addNamespace("dxinactive", namespace), selector, {
                    timeout: hideTimeout
                }, function(event) {
                    return executeAction(inactive, {
                        event: event,
                        element: event.currentTarget
                    })
                })
            },
            off: function($el, _ref) {
                var namespace = _ref.namespace,
                    selector = _ref.selector;
                _events_engine.default.off($el, addNamespace("dxactive", namespace), selector);
                _events_engine.default.off($el, addNamespace("dxinactive", namespace), selector)
            }
        };
        exports.active = active;
        var resize = {
            on: function($el, resize) {
                var _ref2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                    namespace = _ref2.namespace;
                _events_engine.default.on($el, addNamespace("dxresize", namespace), resize)
            },
            off: function($el) {
                var _ref3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                    namespace = _ref3.namespace;
                _events_engine.default.off($el, addNamespace("dxresize", namespace))
            }
        };
        exports.resize = resize;
        var hover = {
            on: function($el, start, end, _ref4) {
                var selector = _ref4.selector,
                    namespace = _ref4.namespace;
                _events_engine.default.on($el, addNamespace("dxhoverend", namespace), selector, function(event) {
                    return end(event)
                });
                _events_engine.default.on($el, addNamespace("dxhoverstart", namespace), selector, function(event) {
                    return executeAction(start, {
                        element: event.target,
                        event: event
                    })
                })
            },
            off: function($el, _ref5) {
                var selector = _ref5.selector,
                    namespace = _ref5.namespace;
                _events_engine.default.off($el, addNamespace("dxhoverstart", namespace), selector);
                _events_engine.default.off($el, addNamespace("dxhoverend", namespace), selector)
            }
        };
        exports.hover = hover;
        var visibility = {
            on: function($el, shown, hiding, _ref6) {
                var namespace = _ref6.namespace;
                _events_engine.default.on($el, addNamespace("dxhiding", namespace), hiding);
                _events_engine.default.on($el, addNamespace("dxshown", namespace), shown)
            },
            off: function($el, _ref7) {
                var namespace = _ref7.namespace;
                _events_engine.default.off($el, addNamespace("dxhiding", namespace));
                _events_engine.default.off($el, addNamespace("dxshown", namespace))
            }
        };
        exports.visibility = visibility;
        var focus = {
            on: function($el, focusIn, focusOut, _ref8) {
                var namespace = _ref8.namespace,
                    isFocusable = _ref8.isFocusable;
                _events_engine.default.on($el, addNamespace("focusin", namespace), focusIn);
                _events_engine.default.on($el, addNamespace("focusout", namespace), focusOut);
                if (_dom_adapter.default.hasDocumentProperty("onbeforeactivate")) {
                    _events_engine.default.on($el, addNamespace("beforeactivate", namespace), function(e) {
                        return isFocusable(null, e.target) || e.preventDefault()
                    })
                }
            },
            off: function($el, _ref9) {
                var namespace = _ref9.namespace;
                _events_engine.default.off($el, addNamespace("focusin", namespace));
                _events_engine.default.off($el, addNamespace("focusout", namespace));
                if (_dom_adapter.default.hasDocumentProperty("onbeforeactivate")) {
                    _events_engine.default.off($el, addNamespace("beforeactivate", namespace))
                }
            },
            trigger: function($el) {
                return _events_engine.default.trigger($el, "focus")
            }
        };
        exports.focus = focus;
        var dxClick = {
            on: function($el, click) {
                var _ref10 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                    namespace = _ref10.namespace;
                _events_engine.default.on($el, addNamespace("dxclick", namespace), click)
            },
            off: function($el) {
                var _ref11 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                    namespace = _ref11.namespace;
                _events_engine.default.off($el, addNamespace("dxclick", namespace))
            }
        };
        exports.dxClick = dxClick;
        var click = {
            on: function($el, click) {
                var _ref12 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                    namespace = _ref12.namespace;
                _events_engine.default.on($el, addNamespace("click", namespace), click)
            },
            off: function($el) {
                var _ref13 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                    namespace = _ref13.namespace;
                _events_engine.default.off($el, addNamespace("click", namespace))
            }
        };
        exports.click = click;
        var index = 0;
        var keyboardProcessors = {};
        var generateListenerId = function() {
            return "keyboardProcessorId".concat(index++)
        };
        var keyboard = {
            on: function(element, focusTarget, handler) {
                var listenerId = generateListenerId();
                keyboardProcessors[listenerId] = new _keyboard_processor.default({
                    element: element,
                    focusTarget: focusTarget,
                    handler: handler
                });
                return listenerId
            },
            off: function(listenerId) {
                if (listenerId && keyboardProcessors[listenerId]) {
                    keyboardProcessors[listenerId].dispose();
                    delete keyboardProcessors[listenerId]
                }
            },
            _getProcessor: function(listenerId) {
                return keyboardProcessors[listenerId]
            }
        };
        exports.keyboard = keyboard
    },
    /*!*****************************************************!*\
      !*** ./artifacts/transpiled-npm/animation/frame.js ***!
      \*****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.requestAnimationFrame = requestAnimationFrame;
        exports.cancelAnimationFrame = cancelAnimationFrame;
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _call_once = _interopRequireDefault(__webpack_require__( /*! ../core/utils/call_once */ 85));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.hasWindow)() ? (0, _window.getWindow)() : {};
        var FRAME_ANIMATION_STEP_TIME = 1e3 / 60;
        var request = function(callback) {
            return setTimeout(callback, FRAME_ANIMATION_STEP_TIME)
        };
        var cancel = function(requestID) {
            clearTimeout(requestID)
        };
        var setAnimationFrameMethods = (0, _call_once.default)(function() {
            var nativeRequest = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame;
            var nativeCancel = window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || window.oCancelAnimationFrame || window.msCancelAnimationFrame;
            if (nativeRequest && nativeCancel) {
                request = nativeRequest;
                cancel = nativeCancel
            }
            if (nativeRequest && !nativeCancel) {
                var canceledRequests = {};
                request = function(callback) {
                    var requestId = nativeRequest.call(window, function() {
                        try {
                            if (requestId in canceledRequests) {
                                return
                            }
                            callback.apply(this, arguments)
                        } finally {
                            delete canceledRequests[requestId]
                        }
                    });
                    return requestId
                };
                cancel = function(requestId) {
                    canceledRequests[requestId] = true
                }
            }
        });

        function requestAnimationFrame() {
            setAnimationFrameMethods();
            return request.apply(window, arguments)
        }

        function cancelAnimationFrame() {
            setAnimationFrameMethods();
            cancel.apply(window, arguments)
        }
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/data/custom_store.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _utils = _interopRequireDefault(__webpack_require__( /*! ./utils */ 41));
        var _array_utils = __webpack_require__( /*! ./array_utils */ 93);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _config = _interopRequireDefault(__webpack_require__( /*! ../core/config */ 31));
        var _errors = _interopRequireDefault(__webpack_require__( /*! ./errors */ 38));
        var _abstract_store = _interopRequireDefault(__webpack_require__( /*! ./abstract_store */ 105));
        var _array_query = _interopRequireDefault(__webpack_require__( /*! ./array_query */ 168));
        var _store_helper = _interopRequireDefault(__webpack_require__( /*! ./store_helper */ 94));
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var TOTAL_COUNT = "totalCount";
        var LOAD = "load";
        var BY_KEY = "byKey";
        var INSERT = "insert";
        var UPDATE = "update";
        var REMOVE = "remove";

        function isPromise(obj) {
            return obj && (0, _type.isFunction)(obj.then)
        }

        function trivialPromise(value) {
            return (new _deferred.Deferred).resolve(value).promise()
        }

        function ensureRequiredFuncOption(name, obj) {
            if (!(0, _type.isFunction)(obj)) {
                throw _errors.default.errors.Error("E4011", name)
            }
        }

        function throwInvalidUserFuncResult(name) {
            throw _errors.default.errors.Error("E4012", name)
        }

        function createUserFuncFailureHandler(pendingDeferred) {
            function errorMessageFromXhr(promiseArguments) {
                var xhr = promiseArguments[0];
                var textStatus = promiseArguments[1];
                if (!xhr || !xhr.getResponseHeader) {
                    return null
                }
                return _utils.default.errorMessageFromXhr(xhr, textStatus)
            }
            return function(arg) {
                var error;
                if (arg instanceof Error) {
                    error = arg
                } else {
                    error = new Error(errorMessageFromXhr(arguments) || arg && String(arg) || "Unknown error")
                }
                if (error.message !== _utils.default.XHR_ERROR_UNLOAD) {
                    pendingDeferred.reject(error)
                }
            }
        }

        function invokeUserLoad(store, options) {
            var userFunc = store._loadFunc;
            var userResult;
            ensureRequiredFuncOption(LOAD, userFunc);
            userResult = userFunc.apply(store, [options]);
            if (Array.isArray(userResult)) {
                userResult = trivialPromise(userResult)
            } else {
                if (null === userResult || void 0 === userResult) {
                    userResult = trivialPromise([])
                } else {
                    if (!isPromise(userResult)) {
                        throwInvalidUserFuncResult(LOAD)
                    }
                }
            }
            return (0, _deferred.fromPromise)(userResult)
        }

        function invokeUserTotalCountFunc(store, options) {
            var userFunc = store._totalCountFunc;
            var userResult;
            if (!(0, _type.isFunction)(userFunc)) {
                throw _errors.default.errors.Error("E4021")
            }
            userResult = userFunc.apply(store, [options]);
            if (!isPromise(userResult)) {
                userResult = Number(userResult);
                if (!isFinite(userResult)) {
                    throwInvalidUserFuncResult(TOTAL_COUNT)
                }
                userResult = trivialPromise(userResult)
            }
            return (0, _deferred.fromPromise)(userResult)
        }

        function invokeUserByKeyFunc(store, key, extraOptions) {
            var userFunc = store._byKeyFunc;
            var userResult;
            ensureRequiredFuncOption(BY_KEY, userFunc);
            userResult = userFunc.apply(store, [key, extraOptions]);
            if (!isPromise(userResult)) {
                userResult = trivialPromise(userResult)
            }
            return (0, _deferred.fromPromise)(userResult)
        }

        function runRawLoad(pendingDeferred, store, userFuncOptions, continuation) {
            if (store.__rawData) {
                continuation(store.__rawData)
            } else {
                var loadPromise = store.__rawDataPromise || invokeUserLoad(store, userFuncOptions);
                if (store._cacheRawData) {
                    store.__rawDataPromise = loadPromise
                }
                loadPromise.always(function() {
                    delete store.__rawDataPromise
                }).done(function(rawData) {
                    if (store._cacheRawData) {
                        store.__rawData = rawData
                    }
                    continuation(rawData)
                }).fail(createUserFuncFailureHandler(pendingDeferred))
            }
        }

        function runRawLoadWithQuery(pendingDeferred, store, options, countOnly) {
            options = options || {};
            var userFuncOptions = {};
            if ("userData" in options) {
                userFuncOptions.userData = options.userData
            }
            runRawLoad(pendingDeferred, store, userFuncOptions, function(rawData) {
                var rawDataQuery = (0, _array_query.default)(rawData, {
                    errorHandler: store._errorHandler
                });
                var itemsQuery;
                var totalCountQuery;
                var waitList = [];
                var items;
                var totalCount;
                if (!countOnly) {
                    itemsQuery = _store_helper.default.queryByOptions(rawDataQuery, options);
                    if (itemsQuery === rawDataQuery) {
                        items = rawData.slice(0)
                    } else {
                        waitList.push(itemsQuery.enumerate().done(function(asyncResult) {
                            items = asyncResult
                        }))
                    }
                }
                if (options.requireTotalCount || countOnly) {
                    totalCountQuery = _store_helper.default.queryByOptions(rawDataQuery, options, true);
                    if (totalCountQuery === rawDataQuery) {
                        totalCount = rawData.length
                    } else {
                        waitList.push(totalCountQuery.count().done(function(asyncResult) {
                            totalCount = asyncResult
                        }))
                    }
                }
                _deferred.when.apply(_renderer.default, waitList).done(function() {
                    if (countOnly) {
                        pendingDeferred.resolve(totalCount)
                    } else {
                        if (options.requireTotalCount) {
                            pendingDeferred.resolve(items, {
                                totalCount: totalCount
                            })
                        } else {
                            pendingDeferred.resolve(items)
                        }
                    }
                }).fail(function(x) {
                    pendingDeferred.reject(x)
                })
            })
        }

        function runRawLoadWithKey(pendingDeferred, store, key) {
            runRawLoad(pendingDeferred, store, {}, function(rawData) {
                var keyExpr = store.key();
                var item;
                for (var i = 0, len = rawData.length; i < len; i++) {
                    item = rawData[i];
                    if (_utils.default.keysEqual(keyExpr, store.keyOf(rawData[i]), key)) {
                        pendingDeferred.resolve(item);
                        return
                    }
                }
                pendingDeferred.reject(_errors.default.errors.Error("E4009"))
            })
        }
        var CustomStore = _abstract_store.default.inherit({
            ctor: function(options) {
                options = options || {};
                this.callBase(options);
                this._useDefaultSearch = !!options.useDefaultSearch || "raw" === options.loadMode;
                this._loadMode = options.loadMode;
                this._cacheRawData = false !== options.cacheRawData;
                this._loadFunc = options[LOAD];
                this._totalCountFunc = options[TOTAL_COUNT];
                this._byKeyFunc = options[BY_KEY];
                this._insertFunc = options[INSERT];
                this._updateFunc = options[UPDATE];
                this._removeFunc = options[REMOVE]
            },
            createQuery: function() {
                throw _errors.default.errors.Error("E4010")
            },
            clearRawDataCache: function() {
                delete this.__rawData
            },
            _totalCountImpl: function(options) {
                var d = new _deferred.Deferred;
                if ("raw" === this._loadMode && !this._totalCountFunc) {
                    runRawLoadWithQuery(d, this, options, true)
                } else {
                    invokeUserTotalCountFunc(this, options).done(function(count) {
                        d.resolve(Number(count))
                    }).fail(createUserFuncFailureHandler(d));
                    d = this._addFailHandlers(d)
                }
                return d.promise()
            },
            _pushImpl: function(changes) {
                if (this.__rawData) {
                    (0, _array_utils.applyBatch)({
                        keyInfo: this,
                        data: this.__rawData,
                        changes: changes
                    })
                }
            },
            _loadImpl: function(options) {
                var d = new _deferred.Deferred;
                if ("raw" === this._loadMode) {
                    runRawLoadWithQuery(d, this, options, false)
                } else {
                    invokeUserLoad(this, options).done(function(data, extra) {
                        d.resolve(data, extra)
                    }).fail(createUserFuncFailureHandler(d));
                    d = this._addFailHandlers(d)
                }
                return d.promise()
            },
            _byKeyImpl: function(key, extraOptions) {
                var d = new _deferred.Deferred;
                if (this._byKeyViaLoad()) {
                    this._requireKey();
                    runRawLoadWithKey(d, this, key)
                } else {
                    invokeUserByKeyFunc(this, key, extraOptions).done(function(obj) {
                        d.resolve(obj)
                    }).fail(createUserFuncFailureHandler(d))
                }
                return d.promise()
            },
            _byKeyViaLoad: function() {
                return "raw" === this._loadMode && !this._byKeyFunc
            },
            _insertImpl: function(values) {
                var that = this;
                var userFunc = that._insertFunc;
                var userResult;
                var d = new _deferred.Deferred;
                ensureRequiredFuncOption(INSERT, userFunc);
                userResult = userFunc.apply(that, [values]);
                if (!isPromise(userResult)) {
                    userResult = trivialPromise(userResult)
                }(0, _deferred.fromPromise)(userResult).done(function(serverResponse) {
                    if ((0, _config.default)().useLegacyStoreResult) {
                        d.resolve(values, serverResponse)
                    } else {
                        d.resolve(serverResponse || values, that.keyOf(serverResponse))
                    }
                }).fail(createUserFuncFailureHandler(d));
                return d.promise()
            },
            _updateImpl: function(key, values) {
                var userFunc = this._updateFunc;
                var userResult;
                var d = new _deferred.Deferred;
                ensureRequiredFuncOption(UPDATE, userFunc);
                userResult = userFunc.apply(this, [key, values]);
                if (!isPromise(userResult)) {
                    userResult = trivialPromise(userResult)
                }(0, _deferred.fromPromise)(userResult).done(function(serverResponse) {
                    if ((0, _config.default)().useLegacyStoreResult) {
                        d.resolve(key, values)
                    } else {
                        d.resolve(serverResponse || values, key)
                    }
                }).fail(createUserFuncFailureHandler(d));
                return d.promise()
            },
            _removeImpl: function(key) {
                var userFunc = this._removeFunc;
                var userResult;
                var d = new _deferred.Deferred;
                ensureRequiredFuncOption(REMOVE, userFunc);
                userResult = userFunc.apply(this, [key]);
                if (!isPromise(userResult)) {
                    userResult = trivialPromise()
                }(0, _deferred.fromPromise)(userResult).done(function() {
                    d.resolve(key)
                }).fail(createUserFuncFailureHandler(d));
                return d.promise()
            }
        });
        var _default = CustomStore;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/events/core/event_registrator_callbacks.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _memorized_callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/memorized_callbacks */ 197));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = new _memorized_callbacks.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************!*\
      !*** ./artifacts/transpiled-npm/events/core/emitter.js ***!
      \*********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/callbacks */ 27));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _index = __webpack_require__( /*! ../utils/index */ 8);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var Emitter = _class.default.inherit({
            ctor: function(element) {
                this._$element = (0, _renderer.default)(element);
                this._cancelCallback = (0, _callbacks.default)();
                this._acceptCallback = (0, _callbacks.default)()
            },
            getElement: function() {
                return this._$element
            },
            validate: function(e) {
                return !(0, _index.isDxMouseWheelEvent)(e)
            },
            validatePointers: function(e) {
                return 1 === (0, _index.hasTouches)(e)
            },
            allowInterruptionByMouseWheel: function() {
                return true
            },
            configure: function(data) {
                (0, _extend.extend)(this, data)
            },
            addCancelCallback: function(callback) {
                this._cancelCallback.add(callback)
            },
            removeCancelCallback: function() {
                this._cancelCallback.empty()
            },
            _cancel: function(e) {
                this._cancelCallback.fire(this, e)
            },
            addAcceptCallback: function(callback) {
                this._acceptCallback.add(callback)
            },
            removeAcceptCallback: function() {
                this._acceptCallback.empty()
            },
            _accept: function(e) {
                this._acceptCallback.fire(this, e)
            },
            _requestAccept: function(e) {
                this._acceptRequestEvent = e
            },
            _forgetAccept: function() {
                this._accept(this._acceptRequestEvent);
                this._acceptRequestEvent = null
            },
            start: _common.noop,
            move: _common.noop,
            end: _common.noop,
            cancel: _common.noop,
            reset: function() {
                if (this._acceptRequestEvent) {
                    this._accept(this._acceptRequestEvent)
                }
            },
            _fireEvent: function(eventName, e, params) {
                var eventData = (0, _extend.extend)({
                    type: eventName,
                    originalEvent: e,
                    target: this._getEmitterTarget(e),
                    delegateTarget: this.getElement().get(0)
                }, params);
                e = (0, _index.fireEvent)(eventData);
                if (e.cancel) {
                    this._cancel(e)
                }
                return e
            },
            _getEmitterTarget: function(e) {
                return (this.delegateSelector ? (0, _renderer.default)(e.target).closest(this.delegateSelector) : this.getElement()).get(0)
            },
            dispose: _common.noop
        });
        var _default = Emitter;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************!*\
      !*** external "window.angular" ***!
      \*********************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports) {
        module.exports = window.angular
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/localization/globalize/core.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _globalize = _interopRequireDefault(__webpack_require__( /*! globalize */ 78));
        var _core = _interopRequireDefault(__webpack_require__( /*! ../core */ 87));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        if (_globalize.default && _globalize.default.load) {
            var likelySubtags = {
                supplemental: {
                    version: {
                        _cldrVersion: "28",
                        _unicodeVersion: "8.0.0",
                        _number: "$Revision: 11965 $"
                    },
                    likelySubtags: {
                        en: "en-Latn-US",
                        de: "de-Latn-DE",
                        ru: "ru-Cyrl-RU",
                        ja: "ja-Jpan-JP"
                    }
                }
            };
            if (!_globalize.default.locale()) {
                _globalize.default.load(likelySubtags);
                _globalize.default.locale("en")
            }
            _core.default.inject({
                locale: function(_locale) {
                    if (!_locale) {
                        return _globalize.default.locale().locale
                    }
                    _globalize.default.locale(_locale)
                }
            })
        }
    },
    /*!************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/popover.js ***!
      \************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _element = __webpack_require__( /*! ../core/element */ 18);
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../core/dom_adapter */ 11));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _translator = __webpack_require__( /*! ../animation/translator */ 28);
        var _position = _interopRequireDefault(__webpack_require__( /*! ../animation/position */ 81));
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _math = __webpack_require__( /*! ../core/utils/math */ 29);
        var _index = __webpack_require__( /*! ../events/utils/index */ 8);
        var _popup = _interopRequireDefault(__webpack_require__( /*! ./popup */ 46));
        var _position2 = __webpack_require__( /*! ../core/utils/position */ 22);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        var window = (0, _window.getWindow)();
        var POPOVER_CLASS = "dx-popover";
        var POPOVER_WRAPPER_CLASS = "dx-popover-wrapper";
        var POPOVER_ARROW_CLASS = "dx-popover-arrow";
        var POPOVER_WITHOUT_TITLE_CLASS = "dx-popover-without-title";
        var POSITION_FLIP_MAP = {
            left: "right",
            top: "bottom",
            right: "left",
            bottom: "top",
            center: "center"
        };
        var WEIGHT_OF_SIDES = {
            left: -1,
            top: -1,
            center: 0,
            right: 1,
            bottom: 1
        };
        var POSITION_ALIASES = {
            top: {
                my: "bottom center",
                at: "top center",
                collision: "fit flip"
            },
            bottom: {
                my: "top center",
                at: "bottom center",
                collision: "fit flip"
            },
            right: {
                my: "left center",
                at: "right center",
                collision: "flip fit"
            },
            left: {
                my: "right center",
                at: "left center",
                collision: "flip fit"
            }
        };
        var SIDE_BORDER_WIDTH_STYLES = {
            left: "borderLeftWidth",
            top: "borderTopWidth",
            right: "borderRightWidth",
            bottom: "borderBottomWidth"
        };
        var getEventNameByOption = function(optionValue) {
            return (0, _type.isObject)(optionValue) ? optionValue.name : optionValue
        };
        var getEventName = function(that, optionName) {
            var optionValue = that.option(optionName);
            return getEventNameByOption(optionValue)
        };
        var getEventDelay = function(that, optionName) {
            var optionValue = that.option(optionName);
            return (0, _type.isObject)(optionValue) && optionValue.delay
        };
        var attachEvent = function(that, name) {
            var target = that.option("target");
            var isSelector = (0, _type.isString)(target);
            var event = getEventName(that, name + "Event");
            if (!event || that.option("disabled")) {
                return
            }
            var eventName = (0, _index.addNamespace)(event, that.NAME);
            var action = that._createAction(function() {
                var delay = getEventDelay(that, name + "Event");
                this._clearEventsTimeouts();
                if (delay) {
                    this._timeouts[name] = setTimeout(function() {
                        that[name]()
                    }, delay)
                } else {
                    that[name]()
                }
            }.bind(that), {
                validatingTargetName: "target"
            });
            var handler = function(e) {
                action({
                    event: e,
                    target: (0, _renderer.default)(e.currentTarget)
                })
            };
            var EVENT_HANDLER_NAME = "_" + name + "EventHandler";
            if (isSelector) {
                that[EVENT_HANDLER_NAME] = handler;
                _events_engine.default.on(_dom_adapter.default.getDocument(), eventName, target, handler)
            } else {
                var targetElement = (0, _element.getPublicElement)((0, _renderer.default)(target));
                that[EVENT_HANDLER_NAME] = void 0;
                _events_engine.default.on(targetElement, eventName, handler)
            }
        };
        var detachEvent = function(that, target, name, event) {
            var eventName = event || getEventName(that, name + "Event");
            if (!eventName) {
                return
            }
            eventName = (0, _index.addNamespace)(eventName, that.NAME);
            var EVENT_HANDLER_NAME = "_" + name + "EventHandler";
            if (that[EVENT_HANDLER_NAME]) {
                _events_engine.default.off(_dom_adapter.default.getDocument(), eventName, target, that[EVENT_HANDLER_NAME])
            } else {
                _events_engine.default.off((0, _element.getPublicElement)((0, _renderer.default)(target)), eventName)
            }
        };
        var Popover = _popup.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    target: window,
                    shading: false,
                    position: "bottom",
                    closeOnOutsideClick: true,
                    animation: {
                        show: {
                            type: "fade",
                            from: 0,
                            to: 1
                        },
                        hide: {
                            type: "fade",
                            to: 0
                        }
                    },
                    showTitle: false,
                    width: "auto",
                    height: "auto",
                    dragEnabled: false,
                    resizeEnabled: false,
                    fullScreen: false,
                    closeOnTargetScroll: true,
                    arrowPosition: "",
                    arrowOffset: 0,
                    boundaryOffset: {
                        h: 10,
                        v: 10
                    },
                    _fixedPosition: true
                })
            },
            _defaultOptionsRules: function() {
                return [{
                    device: {
                        platform: "ios"
                    },
                    options: {
                        arrowPosition: {
                            boundaryOffset: {
                                h: 20,
                                v: -10
                            },
                            collision: "fit"
                        }
                    }
                }, {
                    device: function() {
                        return !(0, _window.hasWindow)()
                    },
                    options: {
                        animation: null
                    }
                }]
            },
            _init: function() {
                this.callBase();
                this._renderArrow();
                this._timeouts = {};
                this.$element().addClass(POPOVER_CLASS);
                this._wrapper().addClass(POPOVER_WRAPPER_CLASS)
            },
            _render: function() {
                this.callBase.apply(this, arguments);
                this._detachEvents(this.option("target"));
                this._attachEvents()
            },
            _detachEvents: function(target) {
                detachEvent(this, target, "show");
                detachEvent(this, target, "hide")
            },
            _attachEvents: function() {
                attachEvent(this, "show");
                attachEvent(this, "hide")
            },
            _renderArrow: function() {
                this._$arrow = (0, _renderer.default)("<div>").addClass(POPOVER_ARROW_CLASS).prependTo(this.overlayContent())
            },
            _documentDownHandler: function(e) {
                if (this._isOutsideClick(e)) {
                    return this.callBase(e)
                }
                return true
            },
            _isOutsideClick: function(e) {
                return !(0, _renderer.default)(e.target).closest(this.option("target")).length
            },
            _animate: function(animation) {
                if (animation && animation.to && "object" === _typeof(animation.to)) {
                    (0, _extend.extend)(animation.to, {
                        position: this._getContainerPosition()
                    })
                }
                this.callBase.apply(this, arguments)
            },
            _stopAnimation: function() {
                this.callBase.apply(this, arguments)
            },
            _renderTitle: function() {
                this._wrapper().toggleClass(POPOVER_WITHOUT_TITLE_CLASS, !this.option("showTitle"));
                this.callBase()
            },
            _renderPosition: function() {
                this.callBase();
                this._renderOverlayPosition()
            },
            _renderOverlayBoundaryOffset: _common.noop,
            _renderOverlayPosition: function() {
                this._resetOverlayPosition();
                this._updateContentSize();
                var contentPosition = this._getContainerPosition();
                var resultLocation = _position.default.setup(this._$content, contentPosition);
                var positionSide = this._getSideByLocation(resultLocation);
                this._togglePositionClass("dx-position-" + positionSide);
                this._toggleFlippedClass(resultLocation.h.flip, resultLocation.v.flip);
                var isArrowVisible = this._isHorizontalSide() || this._isVerticalSide();
                if (isArrowVisible) {
                    this._renderArrowPosition(positionSide)
                }
            },
            _resetOverlayPosition: function() {
                this._setContentHeight(true);
                this._togglePositionClass("dx-position-" + this._positionSide);
                (0, _translator.move)(this._$content, {
                    left: 0,
                    top: 0
                });
                this._$arrow.css({
                    top: "auto",
                    right: "auto",
                    bottom: "auto",
                    left: "auto"
                })
            },
            _updateContentSize: function() {
                if (!this._$popupContent) {
                    return
                }
                var containerLocation = _position.default.calculate(this._$content, this._getContainerPosition());
                if (containerLocation.h.oversize > 0 && this._isHorizontalSide() && !containerLocation.h.fit) {
                    var newContainerWidth = this._$content.width() - containerLocation.h.oversize;
                    this._$content.width(newContainerWidth)
                }
                if (containerLocation.v.oversize > 0 && this._isVerticalSide() && !containerLocation.v.fit) {
                    var newOverlayContentHeight = this._$content.height() - containerLocation.v.oversize;
                    var newPopupContentHeight = this._$popupContent.height() - containerLocation.v.oversize;
                    this._$content.height(newOverlayContentHeight);
                    this._$popupContent.height(newPopupContentHeight)
                }
            },
            _getContainerPosition: function() {
                var offset = (0, _common.pairToObject)(this._position.offset || "");
                var hOffset = offset.h;
                var vOffset = offset.v;
                var isVerticalSide = this._isVerticalSide();
                var isHorizontalSide = this._isHorizontalSide();
                if (isVerticalSide || isHorizontalSide) {
                    var isPopoverInside = this._isPopoverInside();
                    var sign = (isPopoverInside ? -1 : 1) * WEIGHT_OF_SIDES[this._positionSide];
                    var arrowSize = isVerticalSide ? this._$arrow.height() : this._$arrow.width();
                    var arrowSizeCorrection = this._getContentBorderWidth(this._positionSide);
                    var arrowOffset = sign * (arrowSize - arrowSizeCorrection);
                    isVerticalSide ? vOffset += arrowOffset : hOffset += arrowOffset
                }
                return (0, _extend.extend)({}, this._position, {
                    offset: hOffset + " " + vOffset
                })
            },
            _getContentBorderWidth: function(side) {
                var borderWidth = this._$content.css(SIDE_BORDER_WIDTH_STYLES[side]);
                return parseInt(borderWidth) || 0
            },
            _getSideByLocation: function(location) {
                var isFlippedByVertical = location.v.flip;
                var isFlippedByHorizontal = location.h.flip;
                return this._isVerticalSide() && isFlippedByVertical || this._isHorizontalSide() && isFlippedByHorizontal || this._isPopoverInside() ? POSITION_FLIP_MAP[this._positionSide] : this._positionSide
            },
            _togglePositionClass: function(positionClass) {
                this._$wrapper.removeClass("dx-position-left dx-position-right dx-position-top dx-position-bottom").addClass(positionClass)
            },
            _toggleFlippedClass: function(isFlippedHorizontal, isFlippedVertical) {
                this._$wrapper.toggleClass("dx-popover-flipped-horizontal", isFlippedHorizontal).toggleClass("dx-popover-flipped-vertical", isFlippedVertical)
            },
            _renderArrowPosition: function(side) {
                var arrowRect = (0, _position2.getBoundingRect)(this._$arrow.get(0));
                var arrowFlip = -(this._isVerticalSide(side) ? arrowRect.height : arrowRect.width);
                this._$arrow.css(POSITION_FLIP_MAP[side], arrowFlip);
                var axis = this._isVerticalSide(side) ? "left" : "top";
                var sizeProperty = this._isVerticalSide(side) ? "width" : "height";
                var $target = (0, _renderer.default)(this._position.of);
                var targetOffset = _position.default.offset($target) || {
                    top: 0,
                    left: 0
                };
                var contentOffset = _position.default.offset(this._$content);
                var arrowSize = arrowRect[sizeProperty];
                var contentLocation = contentOffset[axis];
                var contentSize = (0, _position2.getBoundingRect)(this._$content.get(0))[sizeProperty];
                var targetLocation = targetOffset[axis];
                var targetSize = $target.get(0).preventDefault ? 0 : (0, _position2.getBoundingRect)($target.get(0))[sizeProperty];
                var min = Math.max(contentLocation, targetLocation);
                var max = Math.min(contentLocation + contentSize, targetLocation + targetSize);
                var arrowLocation;
                if ("start" === this.option("arrowPosition")) {
                    arrowLocation = min - contentLocation
                } else {
                    if ("end" === this.option("arrowPosition")) {
                        arrowLocation = max - contentLocation - arrowSize
                    } else {
                        arrowLocation = (min + max) / 2 - contentLocation - arrowSize / 2
                    }
                }
                var borderWidth = this._getContentBorderWidth(side);
                var finalArrowLocation = (0, _math.fitIntoRange)(arrowLocation - borderWidth + this.option("arrowOffset"), borderWidth, contentSize - arrowSize - 2 * borderWidth);
                this._$arrow.css(axis, finalArrowLocation)
            },
            _isPopoverInside: function() {
                var position = this._transformStringPosition(this.option("position"), POSITION_ALIASES);
                var my = _position.default.setup.normalizeAlign(position.my);
                var at = _position.default.setup.normalizeAlign(position.at);
                return my.h === at.h && my.v === at.v
            },
            _setContentHeight: function(fullUpdate) {
                if (fullUpdate) {
                    this.callBase()
                }
            },
            _renderWrapperPosition: function() {
                if (this.option("shading")) {
                    this._$wrapper.css({
                        top: 0,
                        left: 0
                    })
                }
            },
            _renderWrapperDimensions: function() {
                if (this.option("shading")) {
                    this._$wrapper.css({
                        width: "100%",
                        height: "100%"
                    })
                }
            },
            _normalizePosition: function() {
                var position = (0, _extend.extend)({}, this._transformStringPosition(this.option("position"), POSITION_ALIASES));
                if (!position.of) {
                    position.of = this.option("target")
                }
                if (!position.collision) {
                    position.collision = "flip"
                }
                if (!position.boundaryOffset) {
                    position.boundaryOffset = this.option("boundaryOffset")
                }
                this._positionSide = this._getDisplaySide(position);
                this._position = position
            },
            _getDisplaySide: function(position) {
                var my = _position.default.setup.normalizeAlign(position.my);
                var at = _position.default.setup.normalizeAlign(position.at);
                var weightSign = WEIGHT_OF_SIDES[my.h] === WEIGHT_OF_SIDES[at.h] && WEIGHT_OF_SIDES[my.v] === WEIGHT_OF_SIDES[at.v] ? -1 : 1;
                var horizontalWeight = Math.abs(WEIGHT_OF_SIDES[my.h] - weightSign * WEIGHT_OF_SIDES[at.h]);
                var verticalWeight = Math.abs(WEIGHT_OF_SIDES[my.v] - weightSign * WEIGHT_OF_SIDES[at.v]);
                return horizontalWeight > verticalWeight ? at.h : at.v
            },
            _isVerticalSide: function(side) {
                side = side || this._positionSide;
                return "top" === side || "bottom" === side
            },
            _isHorizontalSide: function(side) {
                side = side || this._positionSide;
                return "left" === side || "right" === side
            },
            _clearEventTimeout: function(name) {
                clearTimeout(this._timeouts[name])
            },
            _clearEventsTimeouts: function() {
                this._clearEventTimeout("show");
                this._clearEventTimeout("hide")
            },
            _clean: function() {
                this._detachEvents(this.option("target"));
                this.callBase.apply(this, arguments)
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "boundaryOffset":
                    case "arrowPosition":
                    case "arrowOffset":
                        this._renderGeometry();
                        break;
                    case "fullScreen":
                        if (args.value) {
                            this.option("fullScreen", false)
                        }
                        break;
                    case "target":
                        args.previousValue && this._detachEvents(args.previousValue);
                        this.callBase(args);
                        break;
                    case "showEvent":
                    case "hideEvent":
                        var name = args.name.substring(0, 4);
                        var event = getEventNameByOption(args.previousValue);
                        this.hide();
                        detachEvent(this, this.option("target"), name, event);
                        attachEvent(this, name);
                        break;
                    case "visible":
                        this._clearEventTimeout(args.value ? "show" : "hide");
                        this.callBase(args);
                        break;
                    default:
                        this.callBase(args)
                }
            },
            show: function(target) {
                if (target) {
                    this.option("target", target)
                }
                return this.callBase()
            }
        });
        (0, _component_registrator.default)("dxPopover", Popover);
        var _default = Popover;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/check_box.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../core/devices */ 13));
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _utils = __webpack_require__( /*! ./widget/utils.ink_ripple */ 82);
        var _editor = _interopRequireDefault(__webpack_require__( /*! ./editor/editor */ 52));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _index = __webpack_require__( /*! ../events/utils/index */ 8);
        var _click = __webpack_require__( /*! ../events/click */ 21);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var CHECKBOX_CLASS = "dx-checkbox";
        var CHECKBOX_ICON_CLASS = "dx-checkbox-icon";
        var CHECKBOX_CHECKED_CLASS = "dx-checkbox-checked";
        var CHECKBOX_CONTAINER_CLASS = "dx-checkbox-container";
        var CHECKBOX_TEXT_CLASS = "dx-checkbox-text";
        var CHECKBOX_HAS_TEXT_CLASS = "dx-checkbox-has-text";
        var CHECKBOX_INDETERMINATE_CLASS = "dx-checkbox-indeterminate";
        var CHECKBOX_FEEDBACK_HIDE_TIMEOUT = 100;
        var CheckBox = _editor.default.inherit({
            _supportedKeys: function() {
                var click = function(e) {
                    e.preventDefault();
                    this._clickAction({
                        event: e
                    })
                };
                return (0, _extend.extend)(this.callBase(), {
                    space: click
                })
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    hoverStateEnabled: true,
                    activeStateEnabled: true,
                    value: false,
                    text: "",
                    useInkRipple: false
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: function() {
                        return "desktop" === _devices.default.real().deviceType && !_devices.default.isSimulator()
                    },
                    options: {
                        focusStateEnabled: true
                    }
                }])
            },
            _canValueBeChangedByClick: function() {
                return true
            },
            _useTemplates: function() {
                return false
            },
            _feedbackHideTimeout: CHECKBOX_FEEDBACK_HIDE_TIMEOUT,
            _initMarkup: function() {
                this._renderSubmitElement();
                this._$container = (0, _renderer.default)("<div>").addClass(CHECKBOX_CONTAINER_CLASS);
                this.setAria("role", "checkbox");
                this.$element().addClass(CHECKBOX_CLASS);
                this._renderValue();
                this._renderIcon();
                this._renderText();
                this.option("useInkRipple") && this._renderInkRipple();
                this.$element().append(this._$container);
                this.callBase()
            },
            _render: function() {
                this._renderClick();
                this.callBase()
            },
            _renderSubmitElement: function() {
                this._$submitElement = (0, _renderer.default)("<input>").attr("type", "hidden").appendTo(this.$element())
            },
            _getSubmitElement: function() {
                return this._$submitElement
            },
            _renderInkRipple: function() {
                this._inkRipple = (0, _utils.render)({
                    waveSizeCoefficient: 2.5,
                    useHoldAnimation: false,
                    wavesNumber: 2,
                    isCentered: true
                })
            },
            _renderInkWave: function(element, dxEvent, doRender, waveIndex) {
                if (!this._inkRipple) {
                    return
                }
                var config = {
                    element: element,
                    event: dxEvent,
                    wave: waveIndex
                };
                if (doRender) {
                    this._inkRipple.showWave(config)
                } else {
                    this._inkRipple.hideWave(config)
                }
            },
            _updateFocusState: function(e, value) {
                this.callBase.apply(this, arguments);
                this._renderInkWave(this._$icon, e, value, 0)
            },
            _toggleActiveState: function($element, value, e) {
                this.callBase.apply(this, arguments);
                this._renderInkWave(this._$icon, e, value, 1)
            },
            _renderIcon: function() {
                this._$icon = (0, _renderer.default)("<span>").addClass(CHECKBOX_ICON_CLASS).prependTo(this._$container)
            },
            _renderText: function() {
                var textValue = this.option("text");
                if (!textValue) {
                    if (this._$text) {
                        this._$text.remove();
                        this.$element().removeClass(CHECKBOX_HAS_TEXT_CLASS)
                    }
                    return
                }
                if (!this._$text) {
                    this._$text = (0, _renderer.default)("<span>").addClass(CHECKBOX_TEXT_CLASS)
                }
                this._$text.text(textValue);
                this._$container.append(this._$text);
                this.$element().addClass(CHECKBOX_HAS_TEXT_CLASS)
            },
            _renderClick: function() {
                var that = this;
                var eventName = (0, _index.addNamespace)(_click.name, that.NAME);
                that._clickAction = that._createAction(that._clickHandler);
                _events_engine.default.off(that.$element(), eventName);
                _events_engine.default.on(that.$element(), eventName, function(e) {
                    that._clickAction({
                        event: e
                    })
                })
            },
            _clickHandler: function(args) {
                var that = args.component;
                that._saveValueChangeEvent(args.event);
                that.option("value", !that.option("value"))
            },
            _renderValue: function() {
                var $element = this.$element();
                var checked = this.option("value");
                var indeterminate = void 0 === checked;
                $element.toggleClass(CHECKBOX_CHECKED_CLASS, Boolean(checked));
                $element.toggleClass(CHECKBOX_INDETERMINATE_CLASS, indeterminate);
                this._getSubmitElement().val(checked);
                this.setAria("checked", indeterminate ? "mixed" : checked || "false")
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "useInkRipple":
                        this._invalidate();
                        break;
                    case "value":
                        this._renderValue();
                        this.callBase(args);
                        break;
                    case "text":
                        this._renderText();
                        this._renderDimensions();
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _clean: function() {
                delete this._inkRipple;
                this.callBase()
            }
        });
        (0, _component_registrator.default)("dxCheckBox", CheckBox);
        var _default = CheckBox;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/date_box/ui.date_utils.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _date_serialization = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date_serialization */ 57));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../localization/date */ 32));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        var DATE_COMPONENTS = ["year", "day", "month", "day"];
        var TIME_COMPONENTS = ["hours", "minutes", "seconds", "milliseconds"];
        var ONE_MINUTE = 6e4;
        var ONE_DAY = 60 * ONE_MINUTE * 24;
        var ONE_YEAR = 365 * ONE_DAY;
        var getStringFormat = function(format) {
            var formatType = _typeof(format);
            if ("string" === formatType) {
                return "format"
            }
            if ("object" === formatType && void 0 !== format.type) {
                return format.type
            }
            return null
        };
        var dateUtils = {
            SUPPORTED_FORMATS: ["date", "time", "datetime"],
            ONE_MINUTE: ONE_MINUTE,
            ONE_DAY: ONE_DAY,
            ONE_YEAR: ONE_YEAR,
            MIN_DATEVIEW_DEFAULT_DATE: new Date(1900, 0, 1),
            MAX_DATEVIEW_DEFAULT_DATE: function() {
                var newDate = new Date;
                return new Date(newDate.getFullYear() + 50, newDate.getMonth(), newDate.getDate(), 23, 59, 59)
            }(),
            FORMATS_INFO: {
                date: {
                    getStandardPattern: function() {
                        return "yyyy-MM-dd"
                    },
                    components: DATE_COMPONENTS
                },
                time: {
                    getStandardPattern: function() {
                        return "HH:mm"
                    },
                    components: TIME_COMPONENTS
                },
                datetime: {
                    getStandardPattern: function() {
                        var standardPattern;
                        ! function() {
                            var androidFormatPattern = "yyyy-MM-ddTHH:mmZ";
                            var testDateString = "2000-01-01T01:01Z";
                            var $input = (0, _renderer.default)("<input>").attr("type", "datetime");
                            $input.val(testDateString);
                            if ($input.val()) {
                                standardPattern = androidFormatPattern
                            }
                        }();
                        if (!standardPattern) {
                            standardPattern = "yyyy-MM-ddTHH:mm:ssZ"
                        }
                        dateUtils.FORMATS_INFO.datetime.getStandardPattern = function() {
                            return standardPattern
                        };
                        return standardPattern
                    },
                    components: [].concat(DATE_COMPONENTS, TIME_COMPONENTS)
                },
                "datetime-local": {
                    getStandardPattern: function() {
                        return "yyyy-MM-ddTHH:mm:ss"
                    },
                    components: [].concat(DATE_COMPONENTS, ["hours", "minutes", "seconds"])
                }
            },
            FORMATS_MAP: {
                date: "shortdate",
                time: "shorttime",
                datetime: "shortdateshorttime"
            },
            SUBMIT_FORMATS_MAP: {
                date: "date",
                time: "time",
                datetime: "datetime-local"
            },
            toStandardDateFormat: function(date, type) {
                var pattern = dateUtils.FORMATS_INFO[type].getStandardPattern();
                return _date_serialization.default.serializeDate(date, pattern)
            },
            fromStandardDateFormat: function(text) {
                var date = _date_serialization.default.dateParser(text);
                return (0, _type.isDate)(date) ? date : void 0
            },
            getMaxMonthDay: function(year, month) {
                return new Date(year, month + 1, 0).getDate()
            },
            mergeDates: function(oldValue, newValue, format) {
                if (!newValue) {
                    return newValue || null
                }
                if (!oldValue || isNaN(oldValue.getTime())) {
                    var now = new Date(null);
                    oldValue = new Date(now.getFullYear(), now.getMonth(), now.getDate())
                }
                var result = new Date(oldValue.valueOf());
                var formatInfo = dateUtils.FORMATS_INFO[format];
                (0, _iterator.each)(formatInfo.components, function() {
                    var componentInfo = dateUtils.DATE_COMPONENTS_INFO[this];
                    result[componentInfo.setter](newValue[componentInfo.getter]())
                });
                return result
            },
            getLongestCaptionIndex: function(captionArray) {
                var longestIndex = 0;
                var longestCaptionLength = 0;
                var i;
                for (i = 0; i < captionArray.length; ++i) {
                    if (captionArray[i].length > longestCaptionLength) {
                        longestIndex = i;
                        longestCaptionLength = captionArray[i].length
                    }
                }
                return longestIndex
            },
            formatUsesMonthName: function(format) {
                return _date.default.formatUsesMonthName(format)
            },
            formatUsesDayName: function(format) {
                return _date.default.formatUsesDayName(format)
            },
            getLongestDate: function(format, monthNames, dayNames) {
                var stringFormat = getStringFormat(format);
                var month = 9;
                if (!stringFormat || dateUtils.formatUsesMonthName(stringFormat)) {
                    month = dateUtils.getLongestCaptionIndex(monthNames)
                }
                var longestDate = new Date(1888, month, 21, 23, 59, 59, 999);
                if (!stringFormat || dateUtils.formatUsesDayName(stringFormat)) {
                    var date = longestDate.getDate() - longestDate.getDay() + dateUtils.getLongestCaptionIndex(dayNames);
                    longestDate.setDate(date)
                }
                return longestDate
            },
            normalizeTime: function(date) {
                date.setSeconds(0);
                date.setMilliseconds(0)
            }
        };
        dateUtils.DATE_COMPONENTS_INFO = {
            year: {
                getter: "getFullYear",
                setter: "setFullYear",
                formatter: function(value, date) {
                    var formatDate = new Date(date.getTime());
                    formatDate.setFullYear(value);
                    return _date.default.format(formatDate, "yyyy")
                },
                startValue: void 0,
                endValue: void 0
            },
            day: {
                getter: "getDate",
                setter: "setDate",
                formatter: function(value, date) {
                    var formatDate = new Date(date.getTime());
                    formatDate.setDate(value);
                    return _date.default.format(formatDate, "d")
                },
                startValue: 1,
                endValue: void 0
            },
            month: {
                getter: "getMonth",
                setter: "setMonth",
                formatter: function(value) {
                    return _date.default.getMonthNames()[value]
                },
                startValue: 0,
                endValue: 11
            },
            hours: {
                getter: "getHours",
                setter: "setHours",
                formatter: function(value) {
                    return _date.default.format(new Date(0, 0, 0, value), "hour")
                },
                startValue: 0,
                endValue: 23
            },
            minutes: {
                getter: "getMinutes",
                setter: "setMinutes",
                formatter: function(value) {
                    return _date.default.format(new Date(0, 0, 0, 0, value), "minute")
                },
                startValue: 0,
                endValue: 59
            },
            seconds: {
                getter: "getSeconds",
                setter: "setSeconds",
                formatter: function(value) {
                    return _date.default.format(new Date(0, 0, 0, 0, 0, value), "second")
                },
                startValue: 0,
                endValue: 59
            },
            milliseconds: {
                getter: "getMilliseconds",
                setter: "setMilliseconds",
                formatter: function(value) {
                    return _date.default.format(new Date(0, 0, 0, 0, 0, 0, value), "millisecond")
                },
                startValue: 0,
                endValue: 999
            }
        };
        var _default = dateUtils;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************!*\
      !*** ./artifacts/transpiled-npm/ui/form.js ***!
      \*********************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./form/ui.form */ 637));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _ui.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/recurrence.js ***!
      \*************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getRecurrenceProcessor = getRecurrenceProcessor;
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../../core/errors */ 25));
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _rrule = __webpack_require__( /*! rrule */ 220);
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));
        var _utilsTimeZone = _interopRequireDefault(__webpack_require__( /*! ./utils.timeZone.js */ 86));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _slicedToArray(arr, i) {
            return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest()
        }

        function _nonIterableRest() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }

        function _iterableToArrayLimit(arr, i) {
            var _i = arr && ("undefined" !== typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]);
            if (null == _i) {
                return
            }
            var _arr = [];
            var _n = true;
            var _d = false;
            var _s, _e;
            try {
                for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
                    _arr.push(_s.value);
                    if (i && _arr.length === i) {
                        break
                    }
                }
            } catch (err) {
                _d = true;
                _e = err
            } finally {
                try {
                    if (!_n && null != _i.return) {
                        _i.return()
                    }
                } finally {
                    if (_d) {
                        throw _e
                    }
                }
            }
            return _arr
        }

        function _arrayWithHoles(arr) {
            if (Array.isArray(arr)) {
                return arr
            }
        }
        var toMs = _date.default.dateToMilliseconds;
        var ruleNames = ["freq", "interval", "byday", "byweekno", "byyearday", "bymonth", "bymonthday", "count", "until", "byhour", "byminute", "bysecond", "bysetpos", "wkst"];
        var freqNames = ["DAILY", "WEEKLY", "MONTHLY", "YEARLY", "SECONDLY", "MINUTELY", "HOURLY"];
        var days = {
            SU: 0,
            MO: 1,
            TU: 2,
            WE: 3,
            TH: 4,
            FR: 5,
            SA: 6
        };
        var loggedWarnings = [];
        var recurrence = null;

        function getRecurrenceProcessor() {
            if (!recurrence) {
                recurrence = new RecurrenceProcessor
            }
            return recurrence
        }
        var RecurrenceProcessor = function() {
            function RecurrenceProcessor() {
                this.rRule = null;
                this.rRuleSet = null;
                this.validator = new RecurrenceValidator
            }
            var _proto = RecurrenceProcessor.prototype;
            _proto.generateDates = function(options) {
                var result = [];
                var recurrenceRule = this.evalRecurrenceRule(options.rule);
                var rule = recurrenceRule.rule;
                if (!recurrenceRule.isValid || !rule.freq) {
                    return result
                }
                var startDateUtc = _utilsTimeZone.default.createUTCDateWithLocalOffset(options.start);
                var endDateUtc = _utilsTimeZone.default.createUTCDateWithLocalOffset(options.end);
                var minDateUtc = _utilsTimeZone.default.createUTCDateWithLocalOffset(options.min);
                var maxDateUtc = _utilsTimeZone.default.createUTCDateWithLocalOffset(options.max);
                var duration = endDateUtc ? endDateUtc.getTime() - startDateUtc.getTime() : 0;
                this._initializeRRule(options, startDateUtc);
                var minTime = minDateUtc.getTime();
                var leftBorder = this._getLeftBorder(options, minDateUtc, duration);
                this.rRuleSet.between(leftBorder, maxDateUtc, true).forEach(function(date) {
                    var endAppointmentTime = date.getTime() + duration;
                    if (endAppointmentTime >= minTime) {
                        var correctDate = _utilsTimeZone.default.createDateFromUTCWithLocalOffset(date);
                        result.push(correctDate)
                    }
                });
                return result
            };
            _proto.hasRecurrence = function(options) {
                return !!this.generateDates(options).length
            };
            _proto.evalRecurrenceRule = function(rule) {
                var result = {
                    rule: {},
                    isValid: false
                };
                if (rule) {
                    result.rule = this._parseRecurrenceRule(rule);
                    result.isValid = this.validator.validateRRule(result.rule, rule)
                }
                return result
            };
            _proto.isValidRecurrenceRule = function(rule) {
                return this.evalRecurrenceRule(rule).isValid
            };
            _proto.daysFromByDayRule = function(rule) {
                var result = [];
                if (rule.byday) {
                    if (Array.isArray(rule.byday)) {
                        result = rule.byday
                    } else {
                        result = rule.byday.split(",")
                    }
                }
                return result.map(function(item) {
                    var match = item.match(/[A-Za-z]+/);
                    return !!match && match[0]
                }).filter(function(item) {
                    return !!item
                })
            };
            _proto.getAsciiStringByDate = function(date) {
                var currentOffset = date.getTimezoneOffset() * toMs("minute");
                var offsetDate = new Date(date.getTime() + currentOffset);
                return offsetDate.getFullYear() + ("0" + (offsetDate.getMonth() + 1)).slice(-2) + ("0" + offsetDate.getDate()).slice(-2) + "T" + ("0" + offsetDate.getHours()).slice(-2) + ("0" + offsetDate.getMinutes()).slice(-2) + ("0" + offsetDate.getSeconds()).slice(-2) + "Z"
            };
            _proto.getRecurrenceString = function(object) {
                if (!object || !object.freq) {
                    return
                }
                var result = "";
                for (var field in object) {
                    var value = object[field];
                    if ("interval" === field && value < 2) {
                        continue
                    }
                    if ("until" === field) {
                        value = this.getAsciiStringByDate(value)
                    }
                    result += field + "=" + value + ";"
                }
                result = result.substring(0, result.length - 1);
                return result.toUpperCase()
            };
            _proto._parseExceptionToRawArray = function(value) {
                return value.match(/(\d{4})(\d{2})(\d{2})(T(\d{2})(\d{2})(\d{2}))?(Z)?/)
            };
            _proto.getDateByAsciiString = function(exceptionText) {
                if ("string" !== typeof exceptionText) {
                    return exceptionText
                }
                var result = this._parseExceptionToRawArray(exceptionText);
                if (!result) {
                    return null
                }
                var _this$_createDateTupl = this._createDateTuple(result),
                    _this$_createDateTupl2 = _slicedToArray(_this$_createDateTupl, 7),
                    year = _this$_createDateTupl2[0],
                    month = _this$_createDateTupl2[1],
                    date = _this$_createDateTupl2[2],
                    hours = _this$_createDateTupl2[3],
                    minutes = _this$_createDateTupl2[4],
                    seconds = _this$_createDateTupl2[5],
                    isUtc = _this$_createDateTupl2[6];
                if (isUtc) {
                    return new Date(Date.UTC(year, month, date, hours, minutes, seconds))
                }
                return new Date(year, month, date, hours, minutes, seconds)
            };
            _proto._dispose = function() {
                if (this.rRuleSet) {
                    delete this.rRuleSet;
                    this.rRuleSet = null
                }
                if (this.rRule) {
                    delete this.rRule;
                    this.rRule = null
                }
            };
            _proto._getTimeZoneOffset = function() {
                return (new Date).getTimezoneOffset()
            };
            _proto._initializeRRule = function(options, startDateUtc) {
                var _this = this;
                var ruleOptions = _rrule.RRule.parseString(options.rule);
                var firstDayOfWeek = options.firstDayOfWeek;
                ruleOptions.dtstart = startDateUtc;
                if (!ruleOptions.wkst && firstDayOfWeek) {
                    var weekDayNumbers = [6, 0, 1, 2, 3, 4, 5];
                    ruleOptions.wkst = weekDayNumbers[firstDayOfWeek]
                }
                this._createRRule(ruleOptions);
                if (options.exception) {
                    var exceptionStrings = options.exception;
                    var exceptionDates = exceptionStrings.split(",").map(function(rule) {
                        return _this.getDateByAsciiString(rule)
                    });
                    exceptionDates.forEach(function(date) {
                        if (options.getPostProcessedException) {
                            date = options.getPostProcessedException(date)
                        }
                        var utcDate = _utilsTimeZone.default.createUTCDateWithLocalOffset(date);
                        _this.rRuleSet.exdate(utcDate)
                    })
                }
            };
            _proto._createRRule = function(ruleOptions) {
                this._dispose();
                var rRuleSet = new _rrule.RRuleSet;
                this.rRuleSet = rRuleSet;
                this.rRule = new _rrule.RRule(ruleOptions);
                this.rRuleSet.rrule(this.rRule)
            };
            _proto._getLeftBorder = function(options, minDateUtc, appointmentDuration) {
                if (options.end && !_utilsTimeZone.default.isSameAppointmentDates(options.start, options.end)) {
                    return new Date(minDateUtc.getTime() - appointmentDuration)
                }
                return minDateUtc
            };
            _proto._parseRecurrenceRule = function(recurrence) {
                var ruleObject = {};
                var ruleParts = recurrence.split(";");
                for (var i = 0, len = ruleParts.length; i < len; i++) {
                    var rule = ruleParts[i].split("=");
                    var ruleName = rule[0].toLowerCase();
                    var ruleValue = rule[1];
                    ruleObject[ruleName] = ruleValue
                }
                var count = parseInt(ruleObject.count);
                if (!isNaN(count)) {
                    ruleObject.count = count
                }
                if (ruleObject.interval) {
                    var interval = parseInt(ruleObject.interval);
                    if (!isNaN(interval)) {
                        ruleObject.interval = interval
                    }
                } else {
                    ruleObject.interval = 1
                }
                if (ruleObject.freq && ruleObject.until) {
                    ruleObject.until = this.getDateByAsciiString(ruleObject.until)
                }
                return ruleObject
            };
            _proto._createDateTuple = function(parseResult) {
                var isUtc = void 0 !== parseResult[8];
                parseResult.shift();
                if (void 0 === parseResult[3]) {
                    parseResult.splice(3)
                } else {
                    parseResult.splice(3, 1);
                    parseResult.splice(6)
                }
                parseResult[1]--;
                parseResult.unshift(null);
                return [parseInt(parseResult[1]), parseInt(parseResult[2]), parseInt(parseResult[3]), parseInt(parseResult[4]) || 0, parseInt(parseResult[5]) || 0, parseInt(parseResult[6]) || 0, isUtc]
            };
            return RecurrenceProcessor
        }();
        var RecurrenceValidator = function() {
            function RecurrenceValidator() {}
            var _proto2 = RecurrenceValidator.prototype;
            _proto2.validateRRule = function(rule, recurrence) {
                if (this._brokenRuleNameExists(rule) || (0, _array.inArray)(rule.freq, freqNames) === -1 || this._wrongCountRule(rule) || this._wrongIntervalRule(rule) || this._wrongDayOfWeek(rule) || this._wrongByMonthDayRule(rule) || this._wrongByMonth(rule) || this._wrongUntilRule(rule)) {
                    this._logBrokenRule(recurrence);
                    return false
                }
                return true
            };
            _proto2._wrongUntilRule = function(rule) {
                var wrongUntil = false;
                var until = rule.until;
                if (void 0 !== until && !(until instanceof Date)) {
                    wrongUntil = true
                }
                return wrongUntil
            };
            _proto2._wrongCountRule = function(rule) {
                var wrongCount = false;
                var count = rule.count;
                if (count && "string" === typeof count) {
                    wrongCount = true
                }
                return wrongCount
            };
            _proto2._wrongByMonthDayRule = function(rule) {
                var wrongByMonthDay = false;
                var byMonthDay = rule.bymonthday;
                if (byMonthDay && isNaN(parseInt(byMonthDay))) {
                    wrongByMonthDay = true
                }
                return wrongByMonthDay
            };
            _proto2._wrongByMonth = function(rule) {
                var wrongByMonth = false;
                var byMonth = rule.bymonth;
                if (byMonth && isNaN(parseInt(byMonth))) {
                    wrongByMonth = true
                }
                return wrongByMonth
            };
            _proto2._wrongIntervalRule = function(rule) {
                var wrongInterval = false;
                var interval = rule.interval;
                if (interval && "string" === typeof interval) {
                    wrongInterval = true
                }
                return wrongInterval
            };
            _proto2._wrongDayOfWeek = function(rule) {
                var byDay = rule.byday;
                var daysByRule = getRecurrenceProcessor().daysFromByDayRule(rule);
                var brokenDaysExist = false;
                if ("" === byDay) {
                    brokenDaysExist = true
                }(0, _iterator.each)(daysByRule, function(_, day) {
                    if (!Object.prototype.hasOwnProperty.call(days, day)) {
                        brokenDaysExist = true;
                        return false
                    }
                });
                return brokenDaysExist
            };
            _proto2._brokenRuleNameExists = function(rule) {
                var brokenRuleExists = false;
                (0, _iterator.each)(rule, function(ruleName) {
                    if ((0, _array.inArray)(ruleName, ruleNames) === -1) {
                        brokenRuleExists = true;
                        return false
                    }
                });
                return brokenRuleExists
            };
            _proto2._logBrokenRule = function(recurrence) {
                if ((0, _array.inArray)(recurrence, loggedWarnings) === -1) {
                    _errors.default.log("W0006", recurrence);
                    loggedWarnings.push(recurrence)
                }
            };
            return RecurrenceValidator
        }()
    },
    /*!**************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/types.js ***!
      \**************************************************/
    /*! exports provided: Frequency, freqIsDailyOrGreater */
    /*! exports used: Frequency, freqIsDailyOrGreater */
    function(module, __webpack_exports__, __webpack_require__) {
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return Frequency
        });
        __webpack_exports__.b = freqIsDailyOrGreater;
        var Frequency;
        ! function(Frequency) {
            Frequency[Frequency.YEARLY = 0] = "YEARLY";
            Frequency[Frequency.MONTHLY = 1] = "MONTHLY";
            Frequency[Frequency.WEEKLY = 2] = "WEEKLY";
            Frequency[Frequency.DAILY = 3] = "DAILY";
            Frequency[Frequency.HOURLY = 4] = "HOURLY";
            Frequency[Frequency.MINUTELY = 5] = "MINUTELY";
            Frequency[Frequency.SECONDLY = 6] = "SECONDLY"
        }(Frequency || (Frequency = {}));

        function freqIsDailyOrGreater(freq) {
            return freq < Frequency.HOURLY
        }
    },
    /*!****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/file_manager/ui.file_manager.common.js ***!
      \****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getMapFromObject = exports.findItemsByKeys = exports.extendAttributes = exports.getDisplayFileSize = exports.whenSome = void 0;
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }
        var whenSome = function(arg, onSuccess, onError) {
            onSuccess = onSuccess || _common.noop;
            onError = onError || _common.noop;
            if (!Array.isArray(arg)) {
                arg = [arg]
            }
            var deferreds = arg.map(function(item, index) {
                return (0, _deferred.when)(item).then(function(result) {
                    (0, _type.isFunction)(onSuccess) && onSuccess({
                        item: item,
                        index: index,
                        result: result
                    });
                    return result
                }, function(error) {
                    if (!error) {
                        error = {}
                    }
                    error.index = index;
                    (0, _type.isFunction)(onError) && onError(error);
                    return (new _deferred.Deferred).resolve().promise()
                })
            });
            return _deferred.when.apply(null, deferreds)
        };
        exports.whenSome = whenSome;
        var getDisplayFileSize = function(byteSize) {
            var sizesTitles = ["B", "KB", "MB", "GB", "TB"];
            var index = 0;
            var displaySize = byteSize;
            while (displaySize >= 1024 && index <= sizesTitles.length - 1) {
                displaySize /= 1024;
                index++
            }
            displaySize = Math.round(10 * displaySize) / 10;
            return "".concat(displaySize, " ").concat(sizesTitles[index])
        };
        exports.getDisplayFileSize = getDisplayFileSize;
        var extendAttributes = function(targetObject, sourceObject, objectKeysArray) {
            objectKeysArray.forEach(function(objectKey) {
                (0, _extend.extend)(true, targetObject, (0, _type.isDefined)(sourceObject[objectKey]) ? _defineProperty({}, objectKey, sourceObject[objectKey]) : {})
            });
            return targetObject
        };
        exports.extendAttributes = extendAttributes;
        var findItemsByKeys = function(itemInfos, keys) {
            var itemMap = {};
            keys.forEach(function(key) {
                itemMap[key] = null
            });
            itemInfos.forEach(function(itemInfo) {
                var key = itemInfo.fileItem.key;
                if (Object.prototype.hasOwnProperty.call(itemMap, key)) {
                    itemMap[key] = itemInfo
                }
            });
            var result = [];
            keys.forEach(function(key) {
                var itemInfo = itemMap[key];
                if (itemInfo) {
                    result.push(itemInfo)
                }
            });
            return result
        };
        exports.findItemsByKeys = findItemsByKeys;
        var getMapFromObject = function(object) {
            var keys = Object.keys(object);
            var values = [];
            keys.forEach(function(key) {
                return values.push(object[key])
            });
            return {
                keys: keys,
                values: values
            }
        };
        exports.getMapFromObject = getMapFromObject
    },
    /*!*************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/diagram/diagram.commands_manager.js ***!
      \*************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _diagram = __webpack_require__( /*! ./diagram.importer */ 98);
        var _file_saver = __webpack_require__( /*! ../../exporter/file_saver */ 178);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var SEPARATOR = "separator";
        var SEPARATOR_COMMAND = {
            widget: SEPARATOR
        };
        var CSS_CLASSES = {
            SMALL_EDITOR_ITEM: "dx-diagram-sm-edit-item",
            MEDIUM_EDITOR_ITEM: "dx-diagram-md-edit-item",
            LARGE_EDITOR_ITEM: "dx-diagram-lg-edit-item",
            IMAGE_DROPDOWN_ITEM: "dx-diagram-image-dropdown-item",
            COLOR_EDITOR_ITEM: "dx-diagram-color-edit-item",
            LARGE_ICON_ITEM: "dx-diagram-lg-icon-item"
        };
        var DiagramCommandsManager = {
            SHOW_TOOLBOX_COMMAND_NAME: "toolbox",
            SHOW_PROPERTIES_PANEL_COMMAND_NAME: "propertiesPanel",
            getAllCommands: function() {
                var _this = this;
                var _getDiagram = (0, _diagram.getDiagram)(),
                    DiagramCommand = _getDiagram.DiagramCommand;
                return this._allCommands || (this._allCommands = {
                    separator: SEPARATOR_COMMAND,
                    exportSvg: {
                        command: DiagramCommand.ExportSvg,
                        text: _message.default.format("dxDiagram-commandExportToSvg"),
                        getParameter: function(widget) {
                            return function(dataURI) {
                                return _this._exportTo(widget, dataURI, "SVG", "image/svg+xml")
                            }
                        }
                    },
                    exportPng: {
                        command: DiagramCommand.ExportPng,
                        text: _message.default.format("dxDiagram-commandExportToPng"),
                        getParameter: function(widget) {
                            return function(dataURI) {
                                return _this._exportTo(widget, dataURI, "PNG", "image/png")
                            }
                        }
                    },
                    exportJpg: {
                        command: DiagramCommand.ExportJpg,
                        text: _message.default.format("dxDiagram-commandExportToJpg"),
                        getParameter: function(widget) {
                            return function(dataURI) {
                                return _this._exportTo(widget, dataURI, "JPEG", "image/jpeg")
                            }
                        }
                    },
                    undo: {
                        command: DiagramCommand.Undo,
                        hint: _message.default.format("dxDiagram-commandUndo"),
                        text: _message.default.format("dxDiagram-commandUndo"),
                        icon: "undo",
                        menuIcon: "undo"
                    },
                    redo: {
                        command: DiagramCommand.Redo,
                        hint: _message.default.format("dxDiagram-commandRedo"),
                        text: _message.default.format("dxDiagram-commandRedo"),
                        icon: "redo",
                        menuIcon: "redo"
                    },
                    cut: {
                        command: DiagramCommand.Cut,
                        hint: _message.default.format("dxDiagram-commandCut"),
                        text: _message.default.format("dxDiagram-commandCut"),
                        icon: "cut",
                        menuIcon: "cut"
                    },
                    copy: {
                        command: DiagramCommand.Copy,
                        hint: _message.default.format("dxDiagram-commandCopy"),
                        text: _message.default.format("dxDiagram-commandCopy"),
                        icon: "copy",
                        menuIcon: "copy"
                    },
                    paste: {
                        command: DiagramCommand.PasteInPosition,
                        hint: _message.default.format("dxDiagram-commandPaste"),
                        text: _message.default.format("dxDiagram-commandPaste"),
                        icon: "paste",
                        menuIcon: "paste"
                    },
                    selectAll: {
                        command: DiagramCommand.SelectAll,
                        hint: _message.default.format("dxDiagram-commandSelectAll"),
                        text: _message.default.format("dxDiagram-commandSelectAll"),
                        icon: "dx-diagram-i-button-select-all dx-diagram-i",
                        menuIcon: "dx-diagram-i-menu-select-all dx-diagram-i"
                    },
                    "delete": {
                        command: DiagramCommand.Delete,
                        hint: _message.default.format("dxDiagram-commandDelete"),
                        text: _message.default.format("dxDiagram-commandDelete"),
                        icon: "remove",
                        menuIcon: "remove"
                    },
                    fontName: {
                        command: DiagramCommand.FontName,
                        hint: _message.default.format("dxDiagram-commandFontName"),
                        text: _message.default.format("dxDiagram-commandFontName"),
                        widget: "dxSelectBox",
                        items: ["Arial", "Arial Black", "Helvetica", "Times New Roman", "Courier New", "Courier", "Verdana", "Georgia", "Comic Sans MS", "Trebuchet MS"].map(function(item) {
                            return {
                                text: item,
                                value: item
                            }
                        }),
                        cssClass: CSS_CLASSES.MEDIUM_EDITOR_ITEM
                    },
                    fontSize: {
                        command: DiagramCommand.FontSize,
                        hint: _message.default.format("dxDiagram-commandFontSize"),
                        text: _message.default.format("dxDiagram-commandFontSize"),
                        widget: "dxSelectBox",
                        items: [8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72].map(function(item) {
                            return {
                                text: item + "pt",
                                value: item + "pt"
                            }
                        }),
                        cssClass: CSS_CLASSES.SMALL_EDITOR_ITEM
                    },
                    bold: {
                        command: DiagramCommand.Bold,
                        hint: _message.default.format("dxDiagram-commandBold"),
                        text: _message.default.format("dxDiagram-commandBold"),
                        icon: "bold",
                        menuIcon: "bold"
                    },
                    italic: {
                        command: DiagramCommand.Italic,
                        hint: _message.default.format("dxDiagram-commandItalic"),
                        text: _message.default.format("dxDiagram-commandItalic"),
                        icon: "italic",
                        menuIcon: "italic"
                    },
                    underline: {
                        command: DiagramCommand.Underline,
                        hint: _message.default.format("dxDiagram-commandUnderline"),
                        text: _message.default.format("dxDiagram-commandUnderline"),
                        icon: "underline",
                        menuIcon: "underline"
                    },
                    fontColor: {
                        command: DiagramCommand.FontColor,
                        text: _message.default.format("dxDiagram-commandTextColor"),
                        hint: _message.default.format("dxDiagram-commandTextColor"),
                        widget: "dxColorBox",
                        icon: "dx-icon dx-icon-color",
                        menuIcon: "dx-icon dx-icon-color",
                        cssClass: CSS_CLASSES.COLOR_EDITOR_ITEM
                    },
                    lineColor: {
                        command: DiagramCommand.StrokeColor,
                        text: _message.default.format("dxDiagram-commandLineColor"),
                        hint: _message.default.format("dxDiagram-commandLineColor"),
                        widget: "dxColorBox",
                        icon: "dx-icon dx-icon-background",
                        menuIcon: "dx-icon dx-icon-background",
                        cssClass: CSS_CLASSES.COLOR_EDITOR_ITEM
                    },
                    lineWidth: {
                        command: DiagramCommand.StrokeWidth,
                        text: _message.default.format("dxDiagram-commandLineWidth"),
                        hint: _message.default.format("dxDiagram-commandLineWidth"),
                        widget: "dxSelectBox",
                        items: [1, 2, 3, 4, 5, 6, 7, 8].map(function(item) {
                            return {
                                text: item + "px",
                                value: item.toString()
                            }
                        }),
                        cssClass: CSS_CLASSES.SMALL_EDITOR_ITEM
                    },
                    lineStyle: {
                        command: DiagramCommand.StrokeStyle,
                        text: _message.default.format("dxDiagram-commandLineStyle"),
                        hint: _message.default.format("dxDiagram-commandLineStyle"),
                        widget: "dxSelectBox",
                        items: [{
                            value: "",
                            menuIcon: "dx-diagram-i-line-solid dx-diagram-i",
                            hint: _message.default.format("dxDiagram-commandLineStyleSolid")
                        }, {
                            value: "2,2",
                            menuIcon: "dx-diagram-i-line-dotted dx-diagram-i",
                            hint: _message.default.format("dxDiagram-commandLineStyleDotted")
                        }, {
                            value: "6,2",
                            menuIcon: "dx-diagram-i-line-dashed dx-diagram-i",
                            hint: _message.default.format("dxDiagram-commandLineStyleDashed")
                        }],
                        cssClass: CSS_CLASSES.IMAGE_DROPDOWN_ITEM
                    },
                    fillColor: {
                        command: DiagramCommand.FillColor,
                        text: _message.default.format("dxDiagram-commandFillColor"),
                        hint: _message.default.format("dxDiagram-commandFillColor"),
                        widget: "dxColorBox",
                        icon: "dx-diagram-i dx-diagram-i-button-fill",
                        menuIcon: "dx-diagram-i dx-diagram-i-menu-fill",
                        cssClass: CSS_CLASSES.COLOR_EDITOR_ITEM
                    },
                    textAlignLeft: {
                        command: DiagramCommand.TextLeftAlign,
                        hint: _message.default.format("dxDiagram-commandAlignLeft"),
                        text: _message.default.format("dxDiagram-commandAlignLeft"),
                        icon: "alignleft",
                        menuIcon: "alignleft"
                    },
                    textAlignCenter: {
                        command: DiagramCommand.TextCenterAlign,
                        hint: _message.default.format("dxDiagram-commandAlignCenter"),
                        text: _message.default.format("dxDiagram-commandAlignCenter"),
                        icon: "aligncenter",
                        menuIcon: "aligncenter"
                    },
                    textAlignRight: {
                        command: DiagramCommand.TextRightAlign,
                        hint: _message.default.format("dxDiagram-commandAlignRight"),
                        text: _message.default.format("dxDiagram-commandAlignRight"),
                        icon: "alignright",
                        menu: "alignright"
                    },
                    lock: {
                        command: DiagramCommand.Lock,
                        hint: _message.default.format("dxDiagram-commandLock"),
                        text: _message.default.format("dxDiagram-commandLock"),
                        icon: "dx-diagram-i-button-lock dx-diagram-i",
                        menuIcon: "dx-diagram-i-menu-lock dx-diagram-i"
                    },
                    unlock: {
                        command: DiagramCommand.Unlock,
                        hint: _message.default.format("dxDiagram-commandUnlock"),
                        text: _message.default.format("dxDiagram-commandUnlock"),
                        icon: "dx-diagram-i-button-unlock dx-diagram-i",
                        menuIcon: "dx-diagram-i-menu-unlock dx-diagram-i"
                    },
                    bringToFront: {
                        command: DiagramCommand.BringToFront,
                        hint: _message.default.format("dxDiagram-commandBringToFront"),
                        text: _message.default.format("dxDiagram-commandBringToFront"),
                        icon: "dx-diagram-i-button-bring-to-front dx-diagram-i",
                        menuIcon: "dx-diagram-i-menu-bring-to-front dx-diagram-i"
                    },
                    sendToBack: {
                        command: DiagramCommand.SendToBack,
                        hint: _message.default.format("dxDiagram-commandSendToBack"),
                        text: _message.default.format("dxDiagram-commandSendToBack"),
                        icon: "dx-diagram-i-button-send-to-back dx-diagram-i",
                        menuIcon: "dx-diagram-i-menu-send-to-back dx-diagram-i"
                    },
                    insertShapeImage: {
                        command: DiagramCommand.InsertShapeImage,
                        text: _message.default.format("dxDiagram-commandInsertShapeImage"),
                        icon: "dx-diagram-i-button-image-insert dx-diagram-i",
                        menuIcon: "dx-diagram-i-menu-image-insert dx-diagram-i"
                    },
                    editShapeImage: {
                        command: DiagramCommand.EditShapeImage,
                        text: _message.default.format("dxDiagram-commandEditShapeImage"),
                        icon: "dx-diagram-i-button-image-edit dx-diagram-i",
                        menuIcon: "dx-diagram-i-menu-image-edit dx-diagram-i"
                    },
                    deleteShapeImage: {
                        command: DiagramCommand.DeleteShapeImage,
                        text: _message.default.format("dxDiagram-commandDeleteShapeImage"),
                        icon: "dx-diagram-i-button-image-delete dx-diagram-i",
                        menuIcon: "dx-diagram-i-menu-image-delete dx-diagram-i"
                    },
                    connectorLineType: {
                        command: DiagramCommand.ConnectorLineOption,
                        widget: "dxSelectBox",
                        hint: _message.default.format("dxDiagram-commandConnectorLineType"),
                        items: [{
                            value: 0,
                            menuIcon: "dx-diagram-i-connector-straight dx-diagram-i",
                            hint: _message.default.format("dxDiagram-commandConnectorLineStraight")
                        }, {
                            value: 1,
                            menuIcon: "dx-diagram-i-connector-orthogonal dx-diagram-i",
                            hint: _message.default.format("dxDiagram-commandConnectorLineOrthogonal")
                        }],
                        cssClass: CSS_CLASSES.IMAGE_DROPDOWN_ITEM
                    },
                    connectorLineStart: {
                        command: DiagramCommand.ConnectorStartLineEnding,
                        widget: "dxSelectBox",
                        items: [{
                            value: 0,
                            menuIcon: "dx-diagram-i-connector-begin-none dx-diagram-i",
                            hint: _message.default.format("dxDiagram-commandConnectorLineNone")
                        }, {
                            value: 1,
                            menuIcon: "dx-diagram-i-connector-begin-arrow dx-diagram-i",
                            hint: _message.default.format("dxDiagram-commandConnectorLineArrow")
                        }, {
                            value: 2,
                            menuIcon: "dx-diagram-i-connector-begin-outlined-triangle dx-diagram-i",
                            hint: _message.default.format("dxDiagram-commandConnectorLineArrow")
                        }, {
                            value: 3,
                            menuIcon: "dx-diagram-i-connector-begin-filled-triangle dx-diagram-i",
                            hint: _message.default.format("dxDiagram-commandConnectorLineArrow")
                        }],
                        hint: _message.default.format("dxDiagram-commandConnectorLineStart"),
                        cssClass: CSS_CLASSES.IMAGE_DROPDOWN_ITEM
                    },
                    connectorLineEnd: {
                        command: DiagramCommand.ConnectorEndLineEnding,
                        widget: "dxSelectBox",
                        items: [{
                            value: 0,
                            menuIcon: "dx-diagram-i-connector-end-none dx-diagram-i",
                            hint: _message.default.format("dxDiagram-commandConnectorLineNone")
                        }, {
                            value: 1,
                            menuIcon: "dx-diagram-i-connector-end-arrow dx-diagram-i",
                            hint: _message.default.format("dxDiagram-commandConnectorLineArrow")
                        }, {
                            value: 2,
                            menuIcon: "dx-diagram-i-connector-end-outlined-triangle dx-diagram-i",
                            hint: _message.default.format("dxDiagram-commandConnectorLineArrow")
                        }, {
                            value: 3,
                            menuIcon: "dx-diagram-i-connector-end-filled-triangle dx-diagram-i",
                            hint: _message.default.format("dxDiagram-commandConnectorLineArrow")
                        }],
                        hint: _message.default.format("dxDiagram-commandConnectorLineEnd"),
                        cssClass: CSS_CLASSES.IMAGE_DROPDOWN_ITEM
                    },
                    layoutTreeTopToBottom: {
                        command: DiagramCommand.AutoLayoutTreeVertical,
                        text: _message.default.format("dxDiagram-commandLayoutTopToBottom"),
                        hint: _message.default.format("dxDiagram-commandLayoutTopToBottom"),
                        icon: "dx-diagram-i-button-layout-tree-tb dx-diagram-i",
                        cssClass: CSS_CLASSES.LARGE_ICON_ITEM
                    },
                    layoutTreeBottomToTop: {
                        command: DiagramCommand.AutoLayoutTreeVerticalBottomToTop,
                        text: _message.default.format("dxDiagram-commandLayoutBottomToTop"),
                        hint: _message.default.format("dxDiagram-commandLayoutBottomToTop"),
                        icon: "dx-diagram-i-button-layout-tree-bt dx-diagram-i",
                        cssClass: CSS_CLASSES.LARGE_ICON_ITEM
                    },
                    layoutTreeLeftToRight: {
                        command: DiagramCommand.AutoLayoutTreeHorizontal,
                        text: _message.default.format("dxDiagram-commandLayoutLeftToRight"),
                        hint: _message.default.format("dxDiagram-commandLayoutLeftToRight"),
                        icon: "dx-diagram-i-button-layout-tree-lr dx-diagram-i",
                        cssClass: CSS_CLASSES.LARGE_ICON_ITEM
                    },
                    layoutTreeRightToLeft: {
                        command: DiagramCommand.AutoLayoutTreeHorizontalRightToLeft,
                        text: _message.default.format("dxDiagram-commandLayoutRightToLeft"),
                        hint: _message.default.format("dxDiagram-commandLayoutRightToLeft"),
                        icon: "dx-diagram-i-button-layout-tree-rl dx-diagram-i",
                        cssClass: CSS_CLASSES.LARGE_ICON_ITEM
                    },
                    layoutLayeredTopToBottom: {
                        command: DiagramCommand.AutoLayoutLayeredVertical,
                        text: _message.default.format("dxDiagram-commandLayoutTopToBottom"),
                        hint: _message.default.format("dxDiagram-commandLayoutTopToBottom"),
                        icon: "dx-diagram-i-button-layout-layered-tb dx-diagram-i",
                        cssClass: CSS_CLASSES.LARGE_ICON_ITEM
                    },
                    layoutLayeredBottomToTop: {
                        command: DiagramCommand.AutoLayoutLayeredVerticalBottomToTop,
                        text: _message.default.format("dxDiagram-commandLayoutBottomToTop"),
                        hint: _message.default.format("dxDiagram-commandLayoutBottomToTop"),
                        icon: "dx-diagram-i-button-layout-layered-bt dx-diagram-i",
                        cssClass: CSS_CLASSES.LARGE_ICON_ITEM
                    },
                    layoutLayeredLeftToRight: {
                        command: DiagramCommand.AutoLayoutLayeredHorizontal,
                        text: _message.default.format("dxDiagram-commandLayoutLeftToRight"),
                        hint: _message.default.format("dxDiagram-commandLayoutLeftToRight"),
                        icon: "dx-diagram-i-button-layout-layered-lr dx-diagram-i",
                        cssClass: CSS_CLASSES.LARGE_ICON_ITEM
                    },
                    layoutLayeredRightToLeft: {
                        command: DiagramCommand.AutoLayoutLayeredHorizontalRightToLeft,
                        text: _message.default.format("dxDiagram-commandLayoutRightToLeft"),
                        hint: _message.default.format("dxDiagram-commandLayoutRightToLeft"),
                        icon: "dx-diagram-i-button-layout-layered-rl dx-diagram-i",
                        cssClass: CSS_CLASSES.LARGE_ICON_ITEM
                    },
                    fullScreen: {
                        command: DiagramCommand.Fullscreen,
                        hint: _message.default.format("dxDiagram-commandFullscreen"),
                        text: _message.default.format("dxDiagram-commandFullscreen"),
                        icon: "dx-diagram-i dx-diagram-i-button-fullscreen",
                        menuIcon: "dx-diagram-i dx-diagram-i-menu-fullscreen",
                        cssClass: CSS_CLASSES.COLOR_EDITOR_ITEM
                    },
                    units: {
                        command: DiagramCommand.ViewUnits,
                        hint: _message.default.format("dxDiagram-commandUnits"),
                        text: _message.default.format("dxDiagram-commandUnits"),
                        widget: "dxSelectBox"
                    },
                    simpleView: {
                        command: DiagramCommand.ToggleSimpleView,
                        hint: _message.default.format("dxDiagram-commandSimpleView"),
                        text: _message.default.format("dxDiagram-commandSimpleView"),
                        widget: "dxCheckBox"
                    },
                    showGrid: {
                        command: DiagramCommand.ShowGrid,
                        hint: _message.default.format("dxDiagram-commandShowGrid"),
                        text: _message.default.format("dxDiagram-commandShowGrid"),
                        widget: "dxCheckBox"
                    },
                    snapToGrid: {
                        command: DiagramCommand.SnapToGrid,
                        hint: _message.default.format("dxDiagram-commandSnapToGrid"),
                        text: _message.default.format("dxDiagram-commandSnapToGrid"),
                        widget: "dxCheckBox"
                    },
                    gridSize: {
                        command: DiagramCommand.GridSize,
                        hint: _message.default.format("dxDiagram-commandGridSize"),
                        text: _message.default.format("dxDiagram-commandGridSize"),
                        widget: "dxSelectBox"
                    },
                    pageSize: {
                        command: DiagramCommand.PageSize,
                        hint: _message.default.format("dxDiagram-commandPageSize"),
                        text: _message.default.format("dxDiagram-commandPageSize"),
                        widget: "dxSelectBox",
                        cssClass: CSS_CLASSES.LARGE_EDITOR_ITEM,
                        getCommandValue: function(v) {
                            return JSON.parse(v)
                        },
                        getEditorValue: function(v) {
                            return JSON.stringify(v)
                        }
                    },
                    pageOrientation: {
                        command: DiagramCommand.PageLandscape,
                        hint: _message.default.format("dxDiagram-commandPageOrientation"),
                        text: _message.default.format("dxDiagram-commandPageOrientation"),
                        widget: "dxSelectBox",
                        items: [{
                            value: true,
                            text: _message.default.format("dxDiagram-commandPageOrientationLandscape")
                        }, {
                            value: false,
                            text: _message.default.format("dxDiagram-commandPageOrientationPortrait")
                        }],
                        cssClass: CSS_CLASSES.MEDIUM_EDITOR_ITEM
                    },
                    pageColor: {
                        command: DiagramCommand.PageColor,
                        hint: _message.default.format("dxDiagram-commandPageColor"),
                        text: _message.default.format("dxDiagram-commandPageColor"),
                        widget: "dxColorBox",
                        icon: "dx-diagram-i dx-diagram-i-button-fill",
                        menuIcon: "dx-diagram-i dx-diagram-i-menu-fill",
                        cssClass: CSS_CLASSES.COLOR_EDITOR_ITEM
                    },
                    zoomLevel: {
                        command: DiagramCommand.ZoomLevel,
                        hint: _message.default.format("dxDiagram-commandZoomLevel"),
                        text: _message.default.format("dxDiagram-commandZoomLevel"),
                        widget: "dxTextBox",
                        items: [SEPARATOR_COMMAND, {
                            command: DiagramCommand.FitToScreen,
                            hint: _message.default.format("dxDiagram-commandFitToContent"),
                            text: _message.default.format("dxDiagram-commandFitToContent")
                        }, {
                            command: DiagramCommand.FitToWidth,
                            hint: _message.default.format("dxDiagram-commandFitToWidth"),
                            text: _message.default.format("dxDiagram-commandFitToWidth")
                        }, SEPARATOR_COMMAND, {
                            command: DiagramCommand.AutoZoomToContent,
                            hint: _message.default.format("dxDiagram-commandAutoZoomByContent"),
                            text: _message.default.format("dxDiagram-commandAutoZoomByContent")
                        }, {
                            command: DiagramCommand.AutoZoomToWidth,
                            hint: _message.default.format("dxDiagram-commandAutoZoomByWidth"),
                            text: _message.default.format("dxDiagram-commandAutoZoomByWidth")
                        }],
                        getEditorDisplayValue: function(v) {
                            return Math.round(100 * v) + "%"
                        },
                        cssClass: CSS_CLASSES.SMALL_EDITOR_ITEM
                    },
                    toolbox: {
                        command: this.SHOW_TOOLBOX_COMMAND_NAME,
                        iconChecked: "dx-diagram-i dx-diagram-i-button-toolbox-close",
                        iconUnchecked: "dx-diagram-i dx-diagram-i-button-toolbox-open",
                        hint: _message.default.format("dxDiagram-uiShowToolbox"),
                        text: _message.default.format("dxDiagram-uiShowToolbox")
                    },
                    propertiesPanel: {
                        command: this.SHOW_PROPERTIES_PANEL_COMMAND_NAME,
                        iconChecked: "close",
                        iconUnchecked: "dx-diagram-i dx-diagram-i-button-properties-panel-open",
                        hint: _message.default.format("dxDiagram-uiProperties"),
                        text: _message.default.format("dxDiagram-uiProperties")
                    }
                })
            },
            getMainToolbarCommands: function(commands, excludeCommands) {
                var allCommands = this.getAllCommands();
                var mainToolbarCommands = commands ? this._getPreparedCommands(allCommands, commands) : this._getDefaultMainToolbarCommands(allCommands);
                return this._prepareToolbarCommands(mainToolbarCommands, excludeCommands)
            },
            _getDefaultMainToolbarCommands: function(allCommands) {
                return this._defaultMainToolbarCommands || (this._defaultMainToolbarCommands = [allCommands.undo, allCommands.redo, allCommands.separator, allCommands.fontName, allCommands.fontSize, allCommands.bold, allCommands.italic, allCommands.underline, allCommands.separator, allCommands.lineWidth, allCommands.lineStyle, allCommands.separator, allCommands.fontColor, allCommands.lineColor, allCommands.fillColor, allCommands.separator, allCommands.textAlignLeft, allCommands.textAlignCenter, allCommands.textAlignRight, allCommands.separator, allCommands.connectorLineType, allCommands.connectorLineStart, allCommands.connectorLineEnd, allCommands.separator, {
                    text: _message.default.format("dxDiagram-uiLayout"),
                    showText: "always",
                    items: [{
                        text: _message.default.format("dxDiagram-uiLayoutTree"),
                        items: [allCommands.layoutTreeTopToBottom, allCommands.layoutTreeBottomToTop, allCommands.layoutTreeLeftToRight, allCommands.layoutTreeRightToLeft]
                    }, {
                        text: _message.default.format("dxDiagram-uiLayoutLayered"),
                        items: [allCommands.layoutLayeredTopToBottom, allCommands.layoutLayeredBottomToTop, allCommands.layoutLayeredLeftToRight, allCommands.layoutLayeredRightToLeft]
                    }]
                }])
            },
            getHistoryToolbarCommands: function(commands, excludeCommands) {
                var allCommands = this.getAllCommands();
                var historyToolbarCommands = commands ? this._getPreparedCommands(allCommands, commands) : this._getDefaultHistoryToolbarCommands(allCommands);
                return this._prepareToolbarCommands(historyToolbarCommands, excludeCommands)
            },
            _getDefaultHistoryToolbarCommands: function(allCommands) {
                return this._defaultHistoryToolbarCommands || (this._defaultHistoryToolbarCommands = [allCommands.undo, allCommands.redo, allCommands.separator, allCommands.toolbox])
            },
            getViewToolbarCommands: function(commands, excludeCommands) {
                var allCommands = this.getAllCommands();
                var viewToolbarCommands = commands ? this._getPreparedCommands(allCommands, commands) : this._getDefaultViewToolbarCommands(allCommands);
                return this._prepareToolbarCommands(viewToolbarCommands, excludeCommands)
            },
            _getDefaultViewToolbarCommands: function(allCommands) {
                return this._defaultViewToolbarCommands || (this._defaultViewToolbarCommands = [allCommands.zoomLevel, allCommands.separator, allCommands.fullScreen, allCommands.separator, {
                    widget: "dxButton",
                    icon: "export",
                    text: _message.default.format("dxDiagram-uiExport"),
                    hint: _message.default.format("dxDiagram-uiExport"),
                    items: [allCommands.exportSvg, allCommands.exportPng, allCommands.exportJpg]
                }, {
                    icon: "preferences",
                    hint: _message.default.format("dxDiagram-uiSettings"),
                    text: _message.default.format("dxDiagram-uiSettings"),
                    items: [allCommands.units, allCommands.separator, allCommands.showGrid, allCommands.snapToGrid, allCommands.gridSize, allCommands.separator, allCommands.simpleView, allCommands.toolbox]
                }])
            },
            getPropertiesToolbarCommands: function(commands, excludeCommands) {
                var allCommands = this.getAllCommands();
                var propertiesCommands = commands ? this._getPreparedCommands(allCommands, commands) : this._getDefaultPropertiesToolbarCommands(allCommands);
                return this._prepareToolbarCommands(propertiesCommands, excludeCommands)
            },
            _getDefaultPropertiesToolbarCommands: function(allCommands) {
                return this._defaultPropertiesToolbarCommands || (this._defaultPropertiesToolbarCommands = [allCommands.propertiesPanel])
            },
            _getDefaultPropertyPanelCommandGroups: function() {
                return this._defaultPropertyPanelCommandGroups || (this._defaultPropertyPanelCommandGroups = [{
                    title: _message.default.format("dxDiagram-uiStyle"),
                    groups: [{
                        title: _message.default.format("dxDiagram-uiText"),
                        commands: ["fontName", "fontSize", "bold", "italic", "underline", "textAlignLeft", "textAlignCenter", "textAlignRight", "fontColor"]
                    }, {
                        title: _message.default.format("dxDiagram-uiObject"),
                        commands: ["lineStyle", "lineWidth", "lineColor", "fillColor"]
                    }, {
                        title: _message.default.format("dxDiagram-uiConnector"),
                        commands: ["connectorLineType", "connectorLineStart", "connectorLineEnd"]
                    }]
                }, {
                    title: _message.default.format("dxDiagram-uiLayout"),
                    groups: [{
                        title: _message.default.format("dxDiagram-uiLayoutLayered"),
                        commands: ["layoutLayeredTopToBottom", "layoutLayeredBottomToTop", "layoutLayeredLeftToRight", "layoutLayeredRightToLeft"]
                    }, {
                        title: _message.default.format("dxDiagram-uiLayoutTree"),
                        commands: ["layoutTreeTopToBottom", "layoutTreeBottomToTop", "layoutTreeLeftToRight", "layoutTreeRightToLeft"]
                    }]
                }, {
                    title: _message.default.format("dxDiagram-uiDiagram"),
                    groups: [{
                        title: _message.default.format("dxDiagram-uiPage"),
                        commands: ["pageSize", "pageOrientation", "pageColor"]
                    }]
                }])
            },
            _preparePropertyPanelGroups: function(groups) {
                var _this2 = this;
                var allCommands = this.getAllCommands();
                var result = [];
                groups.forEach(function(g) {
                    var commands = g.commands;
                    if (commands) {
                        commands = _this2._getPreparedCommands(allCommands, commands);
                        commands = _this2._prepareToolbarCommands(commands)
                    }
                    var subGroups;
                    if (g.groups) {
                        subGroups = [];
                        g.groups.forEach(function(sg) {
                            var subCommands = sg.commands;
                            if (subCommands) {
                                subCommands = _this2._getPreparedCommands(allCommands, subCommands);
                                subCommands = _this2._prepareToolbarCommands(subCommands)
                            }
                            subGroups.push({
                                title: sg.title,
                                commands: subCommands
                            })
                        })
                    }
                    result.push({
                        title: g.title,
                        commands: commands,
                        groups: subGroups
                    })
                });
                return result
            },
            getPropertyPanelCommandTabs: function(commandGroups) {
                commandGroups = commandGroups || this._getDefaultPropertyPanelCommandGroups();
                return this._preparePropertyPanelGroups(commandGroups)
            },
            getContextMenuCommands: function(commands) {
                var allCommands = this.getAllCommands();
                var contextMenuCommands = commands ? this._getPreparedCommands(allCommands, commands) : this._getDefaultContextMenuCommands(allCommands);
                return this._prepareContextMenuCommands(contextMenuCommands)
            },
            _getDefaultContextMenuCommands: function(allCommands) {
                return this._defaultContextMenuCommands || (this._defaultContextMenuCommands = [allCommands.cut, allCommands.copy, allCommands.paste, allCommands.delete, allCommands.separator, allCommands.selectAll, allCommands.separator, allCommands.bringToFront, allCommands.sendToBack, allCommands.separator, allCommands.lock, allCommands.unlock, allCommands.separator, allCommands.insertShapeImage, allCommands.editShapeImage, allCommands.deleteShapeImage])
            },
            _getPreparedCommands: function(allCommands, commands) {
                var _this3 = this;
                return commands.map(function(c) {
                    if (allCommands[c]) {
                        return allCommands[c]
                    } else {
                        if (c.text || c.icon || c.name) {
                            var internalCommand = c.name && allCommands[c.name];
                            var command = {
                                command: internalCommand && internalCommand.command,
                                name: c.name,
                                text: c.text || internalCommand && internalCommand.text,
                                hint: c.text || internalCommand && internalCommand.hint,
                                icon: c.icon || internalCommand && internalCommand.icon,
                                menuIcon: c.icon || internalCommand && internalCommand.menuIcon,
                                widget: internalCommand && internalCommand.widget,
                                cssClass: internalCommand && internalCommand.cssClass,
                                getParameter: internalCommand && internalCommand.getParameter,
                                getCommandValue: internalCommand && internalCommand.getCommandValue,
                                getEditorValue: internalCommand && internalCommand.getEditorValue,
                                getEditorDisplayValue: internalCommand && internalCommand.getEditorDisplayValue,
                                iconChecked: internalCommand && internalCommand.iconChecked,
                                iconUnchecked: internalCommand && internalCommand.iconUnchecked
                            };
                            if (Array.isArray(c.items)) {
                                command.items = _this3._getPreparedCommands(allCommands, c.items)
                            } else {
                                command.items = internalCommand && internalCommand.items
                            }
                            return command
                        }
                    }
                }).filter(function(c) {
                    return c
                })
            },
            _prepareContextMenuCommands: function(commands, excludeCommands, rootCommand) {
                var _this4 = this;
                var beginGroup = false;
                return commands.map(function(c) {
                    if (!_this4._isValidCommand(c, excludeCommands)) {
                        return
                    }
                    if (c === SEPARATOR_COMMAND) {
                        beginGroup = true
                    } else {
                        var command = _this4._cloneCommand(c, excludeCommands);
                        command.icon = command.menuIcon;
                        command.beginGroup = beginGroup;
                        command.rootCommand = !command.command ? rootCommand && rootCommand.command : void 0;
                        beginGroup = false;
                        return command
                    }
                }).filter(function(c) {
                    return c
                })
            },
            _prepareToolbarCommands: function(commands, excludeCommands) {
                var _this5 = this;
                return commands.map(function(c) {
                    if (_this5._isValidCommand(c, excludeCommands)) {
                        return _this5._cloneCommand(c, excludeCommands)
                    }
                }).filter(function(c) {
                    return c
                }).filter(function(c, index, arr) {
                    if (c.widget === SEPARATOR && index === arr.length - 1) {
                        return false
                    }
                    return c
                })
            },
            _cloneCommand: function(c, excludeCommands) {
                var command = (0, _extend.extend)({}, c);
                if (Array.isArray(c.items)) {
                    command.items = this._prepareContextMenuCommands(c.items, excludeCommands, command)
                }
                return command
            },
            _isValidCommand: function(c, excludeCommands) {
                excludeCommands = excludeCommands || [];
                return excludeCommands.indexOf(c.command) === -1
            },
            _exportTo: function(widget, dataURI, format, mimeString) {
                var window = (0, _window.getWindow)();
                if (window && window.atob && (0, _type.isFunction)(window.Blob)) {
                    var blob = this._getBlobByDataURI(window, dataURI, mimeString);
                    var options = widget.option("export");
                    _file_saver.fileSaver.saveAs(options.fileName || "foo", format, blob, options.proxyURL)
                }
            },
            _getBlobByDataURI: function(window, dataURI, mimeString) {
                var byteString = window.atob(dataURI.split(",")[1]);
                var ia = new Uint8Array(byteString.length);
                for (var i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i)
                }
                return new window.Blob([ia.buffer], {
                    type: mimeString
                })
            }
        };
        var _default = DiagramCommandsManager;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/components/consts.js ***!
      \***********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _default = {
            events: {
                mouseover: "mouseover",
                mouseout: "mouseout",
                mousemove: "mousemove",
                touchstart: "touchstart",
                touchmove: "touchmove",
                touchend: "touchend",
                mousedown: "mousedown",
                mouseup: "mouseup",
                click: "click",
                selectSeries: "selectseries",
                deselectSeries: "deselectseries",
                selectPoint: "selectpoint",
                deselectPoint: "deselectpoint",
                showPointTooltip: "showpointtooltip",
                hidePointTooltip: "hidepointtooltip"
            },
            states: {
                hover: "hover",
                normal: "normal",
                selection: "selection",
                normalMark: 0,
                hoverMark: 1,
                selectedMark: 2,
                applyHover: "applyHover",
                applySelected: "applySelected",
                resetItem: "resetItem"
            },
            radialLabelIndent: 30,
            pieLabelSpacing: 10,
            pieSeriesSpacing: 4
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/series/points/symbol_point.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _extend2 = __webpack_require__( /*! ../../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../../core/utils/iterator */ 3);
        var _common = __webpack_require__( /*! ../../../core/utils/common */ 4);
        var _window = __webpack_require__( /*! ../../../core/utils/window */ 7);
        var _label = __webpack_require__( /*! ./label */ 315);
        var _type = __webpack_require__( /*! ../../../core/utils/type */ 1);
        var _utils = __webpack_require__( /*! ../../core/utils */ 14);
        var window = (0, _window.getWindow)();
        var _extend = _extend2.extend;
        var _math = Math;
        var _round = _math.round;
        var _floor = _math.floor;
        var _ceil = _math.ceil;
        var DEFAULT_IMAGE_WIDTH = 20;
        var DEFAULT_IMAGE_HEIGHT = 20;
        var LABEL_OFFSET = 10;
        var CANVAS_POSITION_DEFAULT = "canvas_position_default";

        function getSquareMarkerCoords(radius) {
            return [-radius, -radius, radius, -radius, radius, radius, -radius, radius, -radius, -radius]
        }

        function getPolygonMarkerCoords(radius) {
            var r = _ceil(radius);
            return [-r, 0, 0, -r, r, 0, 0, r, -r, 0]
        }

        function getCrossMarkerCoords(radius) {
            var r = _ceil(radius);
            var floorHalfRadius = _floor(r / 2);
            var ceilHalfRadius = _ceil(r / 2);
            return [-r, -floorHalfRadius, -floorHalfRadius, -r, 0, -ceilHalfRadius, floorHalfRadius, -r, r, -floorHalfRadius, ceilHalfRadius, 0, r, floorHalfRadius, floorHalfRadius, r, 0, ceilHalfRadius, -floorHalfRadius, r, -r, floorHalfRadius, -ceilHalfRadius, 0]
        }

        function getTriangleDownMarkerCoords(radius) {
            return [-radius, -radius, radius, -radius, 0, radius, -radius, -radius]
        }

        function getTriangleUpMarkerCoords(radius) {
            return [-radius, radius, radius, radius, 0, -radius, -radius, radius]
        }
        var _default = {
            deleteLabel: function() {
                this._label.dispose();
                this._label = null
            },
            _hasGraphic: function() {
                return this.graphic
            },
            clearVisibility: function() {
                var that = this;
                var graphic = that.graphic;
                if (graphic && graphic.attr("visibility")) {
                    graphic.attr({
                        visibility: null
                    })
                }
            },
            isVisible: function() {
                return this.inVisibleArea && this.series.isVisible()
            },
            setInvisibility: function() {
                var that = this;
                var graphic = that.graphic;
                if (graphic && "hidden" !== graphic.attr("visibility")) {
                    graphic.attr({
                        visibility: "hidden"
                    })
                }
                that._errorBar && that._errorBar.attr({
                    visibility: "hidden"
                });
                that._label.draw(false)
            },
            clearMarker: function() {
                var graphic = this.graphic;
                graphic && graphic.attr(this._emptySettings)
            },
            _createLabel: function() {
                this._label = new _label.Label({
                    renderer: this.series._renderer,
                    labelsGroup: this.series._labelsGroup,
                    point: this
                })
            },
            _updateLabelData: function() {
                this._label.setData(this._getLabelFormatObject())
            },
            _updateLabelOptions: function() {
                !this._label && this._createLabel();
                this._label.setOptions(this._options.label)
            },
            _checkImage: function(image) {
                return (0, _type.isDefined)(image) && ("string" === typeof image || (0, _type.isDefined)(image.url))
            },
            _fillStyle: function() {
                this._styles = this._options.styles
            },
            _checkSymbol: function(oldOptions, newOptions) {
                var oldSymbol = oldOptions.symbol;
                var newSymbol = newOptions.symbol;
                var symbolChanged = "circle" === oldSymbol && "circle" !== newSymbol || "circle" !== oldSymbol && "circle" === newSymbol;
                var imageChanged = this._checkImage(oldOptions.image) !== this._checkImage(newOptions.image);
                return !!(symbolChanged || imageChanged)
            },
            _populatePointShape: function(symbol, radius) {
                switch (symbol) {
                    case "square":
                        return getSquareMarkerCoords(radius);
                    case "polygon":
                        return getPolygonMarkerCoords(radius);
                    case "triangle":
                    case "triangleDown":
                        return getTriangleDownMarkerCoords(radius);
                    case "triangleUp":
                        return getTriangleUpMarkerCoords(radius);
                    case "cross":
                        return getCrossMarkerCoords(radius)
                }
            },
            hasCoords: function() {
                return null !== this.x && null !== this.y
            },
            correctValue: function(correction) {
                var that = this;
                var axis = that.series.getValueAxis();
                if (that.hasValue()) {
                    that.value = that.properValue = axis.validateUnit(that.initialValue.valueOf() + correction.valueOf());
                    that.minValue = axis.validateUnit(correction)
                }
            },
            resetCorrection: function() {
                this.value = this.properValue = this.initialValue;
                this.minValue = CANVAS_POSITION_DEFAULT
            },
            resetValue: function() {
                var that = this;
                if (that.hasValue()) {
                    that.value = that.properValue = that.initialValue = 0;
                    that.minValue = 0;
                    that._label.setDataField("value", that.value)
                }
            },
            _getTranslates: function(animationEnabled) {
                var translateX = this.x;
                var translateY = this.y;
                if (animationEnabled) {
                    if (this._options.rotated) {
                        translateX = this.defaultX
                    } else {
                        translateY = this.defaultY
                    }
                }
                return {
                    x: translateX,
                    y: translateY
                }
            },
            _createImageMarker: function(renderer, settings, options) {
                var width = options.width || DEFAULT_IMAGE_WIDTH;
                var height = options.height || DEFAULT_IMAGE_HEIGHT;
                return renderer.image(-_round(.5 * width), -_round(.5 * height), width, height, options.url ? options.url.toString() : options.toString(), "center").attr({
                    translateX: settings.translateX,
                    translateY: settings.translateY,
                    visibility: settings.visibility
                })
            },
            _createSymbolMarker: function(renderer, pointSettings) {
                var marker;
                var symbol = this._options.symbol;
                if ("circle" === symbol) {
                    delete pointSettings.points;
                    marker = renderer.circle().attr(pointSettings)
                } else {
                    if ("square" === symbol || "polygon" === symbol || "triangle" === symbol || "triangleDown" === symbol || "triangleUp" === symbol || "cross" === symbol) {
                        marker = renderer.path([], "area").attr(pointSettings).sharp()
                    }
                }
                return marker
            },
            _createMarker: function(renderer, group, image, settings) {
                var that = this;
                var marker = that._checkImage(image) ? that._createImageMarker(renderer, settings, image) : that._createSymbolMarker(renderer, settings);
                if (marker) {
                    marker.data({
                        "chart-data-point": that
                    }).append(group)
                }
                return marker
            },
            _getSymbolBBox: function(x, y, r) {
                return {
                    x: x - r,
                    y: y - r,
                    width: 2 * r,
                    height: 2 * r
                }
            },
            _getImageBBox: function(x, y) {
                var image = this._options.image;
                var width = image.width || DEFAULT_IMAGE_WIDTH;
                var height = image.height || DEFAULT_IMAGE_HEIGHT;
                return {
                    x: x - _round(width / 2),
                    y: y - _round(height / 2),
                    width: width,
                    height: height
                }
            },
            _getGraphicBBox: function() {
                var that = this;
                var options = that._options;
                var x = that.x;
                var y = that.y;
                var bBox;
                if (options.visible) {
                    bBox = that._checkImage(options.image) ? that._getImageBBox(x, y) : that._getSymbolBBox(x, y, options.styles.normal.r)
                } else {
                    bBox = {
                        x: x,
                        y: y,
                        width: 0,
                        height: 0
                    }
                }
                return bBox
            },
            hideInsideLabel: _common.noop,
            _getShiftLabelCoords: function(label) {
                var coord = this._addLabelAlignmentAndOffset(label, this._getLabelCoords(label));
                return this._checkLabelPosition(label, coord)
            },
            _drawLabel: function() {
                var that = this;
                var customVisibility = that._getCustomLabelVisibility();
                var label = that._label;
                var isVisible = that._showForZeroValues() && that.hasValue() && false !== customVisibility && (that.series.getLabelVisibility() || customVisibility);
                label.draw(!!isVisible)
            },
            correctLabelPosition: function(label) {
                var that = this;
                var coord = that._getShiftLabelCoords(label);
                if (!that.hideInsideLabel(label, coord)) {
                    label.setFigureToDrawConnector(that._getLabelConnector(label.pointPosition));
                    label.shift(_round(coord.x), _round(coord.y))
                }
            },
            _showForZeroValues: function() {
                return true
            },
            _getLabelConnector: function(pointPosition) {
                var bBox = this._getGraphicBBox(pointPosition);
                var w2 = bBox.width / 2;
                var h2 = bBox.height / 2;
                return {
                    x: bBox.x + w2,
                    y: bBox.y + h2,
                    r: this._options.visible ? Math.max(w2, h2) : 0
                }
            },
            _getPositionFromLocation: function() {
                return {
                    x: this.x,
                    y: this.y
                }
            },
            _isPointInVisibleArea: function(visibleArea, graphicBBox) {
                return visibleArea.minX <= graphicBBox.x + graphicBBox.width && visibleArea.maxX >= graphicBBox.x && visibleArea.minY <= graphicBBox.y + graphicBBox.height && visibleArea.maxY >= graphicBBox.y
            },
            _checkLabelPosition: function(label, coord) {
                var that = this;
                var visibleArea = that._getVisibleArea();
                var labelBBox = label.getBoundingRect();
                var graphicBBox = that._getGraphicBBox(label.pointPosition);
                var fullGraphicBBox = that._getGraphicBBox();
                var isInside = "inside" === label.getLayoutOptions().position;
                var offset = LABEL_OFFSET;
                if (that._isPointInVisibleArea(visibleArea, fullGraphicBBox)) {
                    if (!that._options.rotated) {
                        if (visibleArea.minX > coord.x) {
                            coord.x = visibleArea.minX
                        }
                        if (visibleArea.maxX < coord.x + labelBBox.width) {
                            coord.x = visibleArea.maxX - labelBBox.width
                        }
                        if (visibleArea.minY > coord.y) {
                            coord.y = isInside ? visibleArea.minY : graphicBBox.y + graphicBBox.height + offset
                        }
                        if (visibleArea.maxY < coord.y + labelBBox.height) {
                            coord.y = isInside ? visibleArea.maxY - labelBBox.height : graphicBBox.y - labelBBox.height - offset
                        }
                    } else {
                        if (visibleArea.minX > coord.x) {
                            coord.x = isInside ? visibleArea.minX : graphicBBox.x + graphicBBox.width + offset
                        }
                        if (visibleArea.maxX < coord.x + labelBBox.width) {
                            coord.x = isInside ? visibleArea.maxX - labelBBox.width : graphicBBox.x - offset - labelBBox.width
                        }
                        if (visibleArea.minY > coord.y) {
                            coord.y = visibleArea.minY
                        }
                        if (visibleArea.maxY < coord.y + labelBBox.height) {
                            coord.y = visibleArea.maxY - labelBBox.height
                        }
                    }
                }
                return coord
            },
            _addLabelAlignmentAndOffset: function(label, coord) {
                var labelBBox = label.getBoundingRect();
                var labelOptions = label.getLayoutOptions();
                if (!this._options.rotated) {
                    if ("left" === labelOptions.alignment) {
                        coord.x += labelBBox.width / 2
                    } else {
                        if ("right" === labelOptions.alignment) {
                            coord.x -= labelBBox.width / 2
                        }
                    }
                }
                coord.x += labelOptions.horizontalOffset;
                coord.y += labelOptions.verticalOffset;
                return coord
            },
            _getLabelCoords: function(label) {
                return this._getLabelCoordOfPosition(label, this._getLabelPosition(label.pointPosition))
            },
            _getLabelCoordOfPosition: function(label, position) {
                var that = this;
                var labelBBox = label.getBoundingRect();
                var graphicBBox = that._getGraphicBBox(label.pointPosition);
                var offset = LABEL_OFFSET;
                var centerY = graphicBBox.height / 2 - labelBBox.height / 2;
                var centerX = graphicBBox.width / 2 - labelBBox.width / 2;
                var x = graphicBBox.x;
                var y = graphicBBox.y;
                switch (position) {
                    case "left":
                        x -= labelBBox.width + offset;
                        y += centerY;
                        break;
                    case "right":
                        x += graphicBBox.width + offset;
                        y += centerY;
                        break;
                    case "top":
                        x += centerX;
                        y -= labelBBox.height + offset;
                        break;
                    case "bottom":
                        x += centerX;
                        y += graphicBBox.height + offset;
                        break;
                    case "inside":
                        x += centerX;
                        y += centerY
                }
                return {
                    x: x,
                    y: y
                }
            },
            _drawMarker: function(renderer, group, animationEnabled) {
                var that = this;
                var options = that._options;
                var translates = that._getTranslates(animationEnabled);
                var style = that._getStyle();
                that.graphic = that._createMarker(renderer, group, options.image, _extend({
                    translateX: translates.x,
                    translateY: translates.y,
                    points: that._populatePointShape(options.symbol, style.r)
                }, style))
            },
            _getErrorBarSettings: function() {
                return {
                    visibility: "visible"
                }
            },
            _getErrorBarBaseEdgeLength: function() {
                return 2 * this.getPointRadius()
            },
            _drawErrorBar: function(renderer, group) {
                if (!this._options.errorBars) {
                    return
                }
                var that = this;
                var options = that._options;
                var errorBarOptions = options.errorBars;
                var points = [];
                var settings;
                var pos = that._errorBarPos;
                var high = that._highErrorCoord;
                var low = that._lowErrorCoord;
                var displayMode = (0, _utils.normalizeEnum)(errorBarOptions.displayMode);
                var isHighDisplayMode = "high" === displayMode;
                var isLowDisplayMode = "low" === displayMode;
                var highErrorOnly = (isHighDisplayMode || !(0, _type.isDefined)(low)) && (0, _type.isDefined)(high) && !isLowDisplayMode;
                var lowErrorOnly = (isLowDisplayMode || !(0, _type.isDefined)(high)) && (0, _type.isDefined)(low) && !isHighDisplayMode;
                var edgeLength = errorBarOptions.edgeLength;
                if (edgeLength <= 1 && edgeLength > 0) {
                    edgeLength = this._getErrorBarBaseEdgeLength() * errorBarOptions.edgeLength
                }
                edgeLength = _floor(parseInt(edgeLength) / 2);
                highErrorOnly && (low = that._baseErrorBarPos);
                lowErrorOnly && (high = that._baseErrorBarPos);
                if ("none" !== displayMode && (0, _type.isDefined)(high) && (0, _type.isDefined)(low) && (0, _type.isDefined)(pos)) {
                    !lowErrorOnly && points.push([pos - edgeLength, high, pos + edgeLength, high]);
                    points.push([pos, high, pos, low]);
                    !highErrorOnly && points.push([pos + edgeLength, low, pos - edgeLength, low]);
                    options.rotated && (0, _iterator.each)(points, function(_, p) {
                        p.reverse()
                    });
                    settings = that._getErrorBarSettings(errorBarOptions);
                    if (!that._errorBar) {
                        that._errorBar = renderer.path(points, "line").attr(settings).append(group)
                    } else {
                        settings.points = points;
                        that._errorBar.attr(settings)
                    }
                } else {
                    that._errorBar && that._errorBar.attr({
                        visibility: "hidden"
                    })
                }
            },
            getTooltipParams: function() {
                var that = this;
                var graphic = that.graphic;
                return {
                    x: that.x,
                    y: that.y,
                    offset: graphic ? graphic.getBBox().height / 2 : 0
                }
            },
            setPercentValue: function(absTotal, total, leftHoleTotal, rightHoleTotal) {
                var that = this;
                var valuePercent = that.value / absTotal || 0;
                var minValuePercent = that.minValue / absTotal || 0;
                var percent = valuePercent - minValuePercent;
                that._label.setDataField("percent", percent);
                that._label.setDataField("total", total);
                if (that.series.isFullStackedSeries() && that.hasValue()) {
                    if (that.leftHole) {
                        that.leftHole /= absTotal - leftHoleTotal;
                        that.minLeftHole /= absTotal - leftHoleTotal
                    }
                    if (that.rightHole) {
                        that.rightHole /= absTotal - rightHoleTotal;
                        that.minRightHole /= absTotal - rightHoleTotal
                    }
                    that.value = that.properValue = valuePercent;
                    that.minValue = !minValuePercent ? that.minValue : minValuePercent
                }
            },
            _storeTrackerR: function() {
                var that = this;
                var navigator = window.navigator;
                var r = that._options.styles.normal.r;
                var minTrackerSize = (0, _window.hasProperty)("ontouchstart") || navigator.msPointerEnabled && navigator.msMaxTouchPoints || navigator.pointerEnabled && navigator.maxTouchPoints ? 20 : 6;
                that._options.trackerR = r < minTrackerSize ? minTrackerSize : r;
                return that._options.trackerR
            },
            _translateErrorBars: function() {
                var that = this;
                var options = that._options;
                var rotated = options.rotated;
                var errorBars = options.errorBars;
                var translator = that._getValTranslator();
                if (!errorBars) {
                    return
                }(0, _type.isDefined)(that.lowError) && (that._lowErrorCoord = translator.translate(that.lowError));
                (0, _type.isDefined)(that.highError) && (that._highErrorCoord = translator.translate(that.highError));
                that._errorBarPos = _floor(rotated ? that.vy : that.vx);
                that._baseErrorBarPos = "stdDeviation" === errorBars.type ? that._lowErrorCoord + (that._highErrorCoord - that._lowErrorCoord) / 2 : rotated ? that.vx : that.vy
            },
            _translate: function() {
                var that = this;
                var valTranslator = that._getValTranslator();
                var argTranslator = that._getArgTranslator();
                if (that._options.rotated) {
                    that.vx = that.x = valTranslator.translate(that.value);
                    that.vy = that.y = argTranslator.translate(that.argument);
                    that.minX = valTranslator.translate(that.minValue);
                    that.defaultX = valTranslator.translate(CANVAS_POSITION_DEFAULT)
                } else {
                    that.vy = that.y = valTranslator.translate(that.value);
                    that.vx = that.x = argTranslator.translate(that.argument);
                    that.minY = valTranslator.translate(that.minValue);
                    that.defaultY = valTranslator.translate(CANVAS_POSITION_DEFAULT)
                }
                that._translateErrorBars();
                that._calculateVisibility(that.x, that.y)
            },
            _updateData: function(data) {
                var that = this;
                that.value = that.properValue = that.initialValue = that.originalValue = data.value;
                that.minValue = that.initialMinValue = that.originalMinValue = (0, _type.isDefined)(data.minValue) ? data.minValue : CANVAS_POSITION_DEFAULT
            },
            _getImageSettings: function(image) {
                return {
                    href: image.url || image.toString(),
                    width: image.width || DEFAULT_IMAGE_WIDTH,
                    height: image.height || DEFAULT_IMAGE_HEIGHT
                }
            },
            getCrosshairData: function() {
                var that = this;
                var r = that._options.rotated;
                var value = that.properValue;
                var argument = that.argument;
                return {
                    x: that.vx,
                    y: that.vy,
                    xValue: r ? value : argument,
                    yValue: r ? argument : value,
                    axis: that.series.axis
                }
            },
            getPointRadius: function() {
                var style = this._getStyle();
                var options = this._options;
                var r = style.r;
                var extraSpace;
                var symbol = options.symbol;
                var isSquare = "square" === symbol;
                var isTriangle = "triangle" === symbol || "triangleDown" === symbol || "triangleUp" === symbol;
                if (options.visible && !options.image && r) {
                    extraSpace = style["stroke-width"] / 2;
                    return (isSquare || isTriangle ? 1.4 * r : r) + extraSpace
                }
                return 0
            },
            _updateMarker: function(animationEnabled, style) {
                var that = this;
                var options = that._options;
                var settings;
                var image = options.image;
                var visibility = !that.isVisible() ? {
                    visibility: "hidden"
                } : {};
                if (that._checkImage(image)) {
                    settings = _extend({}, {
                        visibility: style.visibility
                    }, visibility, that._getImageSettings(image))
                } else {
                    settings = _extend({}, style, visibility, {
                        points: that._populatePointShape(options.symbol, style.r)
                    })
                }
                if (!animationEnabled) {
                    settings.translateX = that.x;
                    settings.translateY = that.y
                }
                that.graphic.attr(settings).sharp()
            },
            _getLabelFormatObject: function() {
                var that = this;
                return {
                    argument: that.initialArgument,
                    value: that.initialValue,
                    originalArgument: that.originalArgument,
                    originalValue: that.originalValue,
                    seriesName: that.series.name,
                    lowErrorValue: that.lowError,
                    highErrorValue: that.highError,
                    point: that
                }
            },
            _getLabelPosition: function() {
                var rotated = this._options.rotated;
                if (this.initialValue > 0) {
                    return rotated ? "right" : "top"
                } else {
                    return rotated ? "left" : "bottom"
                }
            },
            _getFormatObject: function(tooltip) {
                var that = this;
                var labelFormatObject = that._label.getData();
                return _extend({}, labelFormatObject, {
                    argumentText: tooltip.formatValue(that.initialArgument, "argument"),
                    valueText: tooltip.formatValue(that.initialValue)
                }, (0, _type.isDefined)(labelFormatObject.percent) ? {
                    percentText: tooltip.formatValue(labelFormatObject.percent, "percent")
                } : {}, (0, _type.isDefined)(labelFormatObject.total) ? {
                    totalText: tooltip.formatValue(labelFormatObject.total)
                } : {})
            },
            getMarkerVisibility: function() {
                return this._options.visible
            },
            coordsIn: function(x, y) {
                var trackerRadius = this._storeTrackerR();
                return x >= this.x - trackerRadius && x <= this.x + trackerRadius && y >= this.y - trackerRadius && y <= this.y + trackerRadius
            },
            getMinValue: function(noErrorBar) {
                var errorBarOptions = this._options.errorBars;
                if (errorBarOptions && !noErrorBar) {
                    var displayMode = errorBarOptions.displayMode;
                    var lowValue = "high" !== displayMode && (0, _type.isDefined)(this.lowError) ? this.lowError : this.value;
                    var highValue = "low" !== displayMode && (0, _type.isDefined)(this.highError) ? this.highError : this.value;
                    return lowValue < highValue ? lowValue : highValue
                } else {
                    return this.value
                }
            },
            getMaxValue: function(noErrorBar) {
                var errorBarOptions = this._options.errorBars;
                if (errorBarOptions && !noErrorBar) {
                    var displayMode = errorBarOptions.displayMode;
                    var lowValue = "high" !== displayMode && (0, _type.isDefined)(this.lowError) ? this.lowError : this.value;
                    var highValue = "low" !== displayMode && (0, _type.isDefined)(this.highError) ? this.highError : this.value;
                    return lowValue > highValue ? lowValue : highValue
                } else {
                    return this.value
                }
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/core/loading_indicator.js ***!
      \****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.plugin = exports.LoadingIndicator = void 0;
        var _utils = __webpack_require__( /*! ./utils */ 14);
        var STATE_HIDDEN = 0;
        var STATE_SHOWN = 1;
        var ANIMATION_EASING = "linear";
        var ANIMATION_DURATION = 400;
        var LOADING_INDICATOR_READY = "loadingIndicatorReady";
        var LoadingIndicator = function(parameters) {
            var that = this;
            var renderer = parameters.renderer;
            that._group = renderer.g().attr({
                "class": "dx-loading-indicator"
            }).linkOn(renderer.root, {
                name: "loading-indicator",
                after: "peripheral"
            });
            that._rect = renderer.rect().attr({
                opacity: 0
            }).append(that._group);
            that._text = renderer.text().attr({
                align: "center"
            }).append(that._group);
            that._createStates(parameters.eventTrigger, that._group, renderer.root, parameters.notify)
        };
        exports.LoadingIndicator = LoadingIndicator;
        LoadingIndicator.prototype = {
            constructor: LoadingIndicator,
            _createStates: function(eventTrigger, group, root, notify) {
                var that = this;
                that._states = [{
                    opacity: 0,
                    start: function() {
                        notify(false)
                    },
                    complete: function() {
                        group.linkRemove();
                        root.css({
                            "pointer-events": ""
                        });
                        eventTrigger(LOADING_INDICATOR_READY)
                    }
                }, {
                    opacity: .85,
                    start: function() {
                        group.linkAppend();
                        root.css({
                            "pointer-events": "none"
                        });
                        notify(true)
                    },
                    complete: function() {
                        eventTrigger(LOADING_INDICATOR_READY)
                    }
                }];
                that._state = STATE_HIDDEN
            },
            setSize: function(size) {
                var width = size.width;
                var height = size.height;
                this._rect.attr({
                    width: width,
                    height: height
                });
                this._text.attr({
                    x: width / 2,
                    y: height / 2
                })
            },
            setOptions: function(options) {
                this._rect.attr({
                    fill: options.backgroundColor
                });
                this._text.css((0, _utils.patchFontOptions)(options.font)).attr({
                    text: options.text,
                    "class": options.cssClass
                });
                this[options.show ? "show" : "hide"]()
            },
            dispose: function() {
                var that = this;
                that._group.linkRemove().linkOff();
                that._group = that._rect = that._text = that._states = null
            },
            _transit: function(stateId) {
                var that = this;
                var state;
                if (that._state !== stateId) {
                    that._state = stateId;
                    that._isHiding = false;
                    state = that._states[stateId];
                    that._rect.stopAnimation().animate({
                        opacity: state.opacity
                    }, {
                        complete: state.complete,
                        easing: ANIMATION_EASING,
                        duration: ANIMATION_DURATION,
                        unstoppable: true
                    });
                    that._noHiding = true;
                    state.start();
                    that._noHiding = false
                }
            },
            show: function() {
                this._transit(STATE_SHOWN)
            },
            hide: function() {
                this._transit(STATE_HIDDEN)
            },
            scheduleHiding: function() {
                if (!this._noHiding) {
                    this._isHiding = true
                }
            },
            fulfillHiding: function() {
                if (this._isHiding) {
                    this.hide()
                }
            }
        };
        var plugin = {
            name: "loading_indicator",
            init: function() {
                var that = this;
                that._loadingIndicator = new LoadingIndicator({
                    eventTrigger: that._eventTrigger,
                    renderer: that._renderer,
                    notify: notify
                });
                that._scheduleLoadingIndicatorHiding();

                function notify(state) {
                    that._skipLoadingIndicatorOptions = true;
                    that.option("loadingIndicator", {
                        show: state
                    });
                    that._skipLoadingIndicatorOptions = false;
                    if (state) {
                        that._stopCurrentHandling()
                    }
                }
            },
            dispose: function() {
                this._loadingIndicator.dispose();
                this._loadingIndicator = null
            },
            members: {
                _scheduleLoadingIndicatorHiding: function() {
                    this._loadingIndicator.scheduleHiding()
                },
                _fulfillLoadingIndicatorHiding: function() {
                    this._loadingIndicator.fulfillHiding()
                },
                showLoadingIndicator: function() {
                    this._loadingIndicator.show()
                },
                hideLoadingIndicator: function() {
                    this._loadingIndicator.hide()
                },
                _onBeginUpdate: function() {
                    if (!this._optionChangedLocker) {
                        this._scheduleLoadingIndicatorHiding()
                    }
                }
            },
            extenders: {
                _dataSourceLoadingChangedHandler: function(isLoading) {
                    if (isLoading && (this._options.silent("loadingIndicator") || {}).enabled) {
                        this._loadingIndicator.show()
                    }
                },
                _setContentSize: function() {
                    this._loadingIndicator.setSize(this._canvas)
                },
                endUpdate: function() {
                    if (this._initialized && this._dataIsReady()) {
                        this._fulfillLoadingIndicatorHiding()
                    }
                }
            },
            customize: function(constructor) {
                var proto = constructor.prototype;
                if (proto._dataSourceChangedHandler) {
                    var _dataSourceChangedHandler = proto._dataSourceChangedHandler;
                    proto._dataSourceChangedHandler = function() {
                        this._scheduleLoadingIndicatorHiding();
                        _dataSourceChangedHandler.apply(this, arguments)
                    }
                }
                constructor.addChange({
                    code: "LOADING_INDICATOR",
                    handler: function() {
                        if (!this._skipLoadingIndicatorOptions) {
                            this._loadingIndicator.setOptions(this._getOption("loadingIndicator"))
                        }
                        this._scheduleLoadingIndicatorHiding()
                    },
                    isThemeDependent: true,
                    option: "loadingIndicator",
                    isOptionChange: true
                });
                proto._eventsMap.onLoadingIndicatorReady = {
                    name: "loadingIndicatorReady"
                };
                var _drawn = proto._drawn;
                proto._drawn = function() {
                    _drawn.apply(this, arguments);
                    if (this._dataIsReady()) {
                        this._fulfillLoadingIndicatorHiding()
                    }
                }
            },
            fontFields: ["loadingIndicator.font"]
        };
        exports.plugin = plugin
    },
    /*!******************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/error.js ***!
      \******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = _default;
        var _extend = __webpack_require__( /*! ./extend */ 0);
        var _console = __webpack_require__( /*! ./console */ 110);
        var _string = __webpack_require__( /*! ./string */ 43);
        var _version = _interopRequireDefault(__webpack_require__( /*! ../version */ 173));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ERROR_URL = "http://js.devexpress.com/error/" + _version.default.split(".").slice(0, 2).join("_") + "/";

        function _default(baseErrors, errors) {
            var exports = {
                ERROR_MESSAGES: (0, _extend.extend)(errors, baseErrors),
                Error: function() {
                    return makeError([].slice.call(arguments))
                },
                log: function(id) {
                    var method = "log";
                    if (/^E\d+$/.test(id)) {
                        method = "error"
                    } else {
                        if (/^W\d+$/.test(id)) {
                            method = "warn"
                        }
                    }
                    _console.logger[method]("log" === method ? id : combineMessage([].slice.call(arguments)))
                }
            };

            function combineMessage(args) {
                var id = args[0];
                args = args.slice(1);
                return formatMessage(id, formatDetails(id, args))
            }

            function formatDetails(id, args) {
                args = [exports.ERROR_MESSAGES[id]].concat(args);
                return _string.format.apply(this, args).replace(/\.*\s*?$/, "")
            }

            function formatMessage(id, details) {
                return _string.format.apply(this, ["{0} - {1}. See:\n{2}", id, details, getErrorUrl(id)])
            }

            function makeError(args) {
                var id = args[0];
                args = args.slice(1);
                var details = formatDetails(id, args);
                var url = getErrorUrl(id);
                var message = formatMessage(id, details);
                return (0, _extend.extend)(new Error(message), {
                    __id: id,
                    __details: details,
                    url: url
                })
            }

            function getErrorUrl(id) {
                return ERROR_URL + id
            }
            return exports
        }
        module.exports = exports.default
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/public_component.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.attachInstanceToElement = attachInstanceToElement;
        exports.getInstanceByElement = getInstanceByElement;
        exports.name = void 0;
        var _element_data = __webpack_require__( /*! ../../core/element_data */ 40);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _weak_map = _interopRequireDefault(__webpack_require__( /*! ../polyfills/weak_map */ 196));
        var _type = __webpack_require__( /*! ./type */ 1);
        var _remove_event = _interopRequireDefault(__webpack_require__( /*! ../remove_event */ 152));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var COMPONENT_NAMES_DATA_KEY = "dxComponents";
        var ANONYMOUS_COMPONENT_DATA_KEY = "dxPrivateComponent";
        var componentNames = new _weak_map.default;
        var nextAnonymousComponent = 0;
        var getName = function(componentClass, newName) {
            if ((0, _type.isDefined)(newName)) {
                componentNames.set(componentClass, newName);
                return
            }
            if (!componentNames.has(componentClass)) {
                var generatedName = ANONYMOUS_COMPONENT_DATA_KEY + nextAnonymousComponent++;
                componentNames.set(componentClass, generatedName);
                return generatedName
            }
            return componentNames.get(componentClass)
        };
        exports.name = getName;

        function attachInstanceToElement($element, componentInstance, disposeFn) {
            var data = (0, _element_data.data)($element.get(0));
            var name = getName(componentInstance.constructor);
            data[name] = componentInstance;
            if (disposeFn) {
                _events_engine.default.one($element, _remove_event.default, function() {
                    disposeFn.call(componentInstance)
                })
            }
            if (!data[COMPONENT_NAMES_DATA_KEY]) {
                data[COMPONENT_NAMES_DATA_KEY] = []
            }
            data[COMPONENT_NAMES_DATA_KEY].push(name)
        }

        function getInstanceByElement($element, componentClass) {
            var name = getName(componentClass);
            return (0, _element_data.data)($element.get(0), name)
        }
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/events/core/wheel.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.name = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _event_registrator = _interopRequireDefault(__webpack_require__( /*! ./event_registrator */ 74));
        var _index = __webpack_require__( /*! ../utils/index */ 8);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var EVENT_NAME = "dxmousewheel";
        exports.name = EVENT_NAME;
        var EVENT_NAMESPACE = "dxWheel";
        var NATIVE_EVENT_NAME = "wheel";
        var PIXEL_MODE = 0;
        var DELTA_MUTLIPLIER = 30;
        var wheel = {
            setup: function(element) {
                var $element = (0, _renderer.default)(element);
                _events_engine.default.on($element, (0, _index.addNamespace)(NATIVE_EVENT_NAME, EVENT_NAMESPACE), wheel._wheelHandler.bind(wheel))
            },
            teardown: function(element) {
                _events_engine.default.off(element, ".".concat(EVENT_NAMESPACE))
            },
            _wheelHandler: function(e) {
                var _e$originalEvent = e.originalEvent,
                    deltaMode = _e$originalEvent.deltaMode,
                    deltaY = _e$originalEvent.deltaY,
                    deltaX = _e$originalEvent.deltaX,
                    deltaZ = _e$originalEvent.deltaZ;
                (0, _index.fireEvent)({
                    type: EVENT_NAME,
                    originalEvent: e,
                    delta: this._normalizeDelta(deltaY, deltaMode),
                    deltaX: deltaX,
                    deltaY: deltaY,
                    deltaZ: deltaZ,
                    deltaMode: deltaMode,
                    pointerType: "mouse"
                });
                e.stopPropagation()
            },
            _normalizeDelta: function(delta) {
                var deltaMode = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : PIXEL_MODE;
                if (deltaMode === PIXEL_MODE) {
                    return -delta
                } else {
                    return -DELTA_MUTLIPLIER * delta
                }
            }
        };
        (0, _event_registrator.default)(EVENT_NAME, wheel)
    },
    /*!******************************************************************!*\
      !*** ./artifacts/transpiled-npm/events/core/emitter.feedback.js ***!
      \******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.inactive = exports.active = exports.lock = void 0;
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _dom = __webpack_require__( /*! ../../core/utils/dom */ 33);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _index = __webpack_require__( /*! ../utils/index */ 8);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../pointer */ 24));
        var _emitter = _interopRequireDefault(__webpack_require__( /*! ./emitter */ 132));
        var _emitter_registrator = _interopRequireDefault(__webpack_require__( /*! ./emitter_registrator */ 103));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ACTIVE_EVENT_NAME = "dxactive";
        exports.active = ACTIVE_EVENT_NAME;
        var INACTIVE_EVENT_NAME = "dxinactive";
        exports.inactive = INACTIVE_EVENT_NAME;
        var ACTIVE_TIMEOUT = 30;
        var INACTIVE_TIMEOUT = 400;
        var FeedbackEvent = _class.default.inherit({
            ctor: function(timeout, fire) {
                this._timeout = timeout;
                this._fire = fire
            },
            start: function() {
                var that = this;
                this._schedule(function() {
                    that.force()
                })
            },
            _schedule: function(fn) {
                this.stop();
                this._timer = setTimeout(fn, this._timeout)
            },
            stop: function() {
                clearTimeout(this._timer)
            },
            force: function() {
                if (this._fired) {
                    return
                }
                this.stop();
                this._fire();
                this._fired = true
            },
            fired: function() {
                return this._fired
            }
        });
        var activeFeedback;
        var FeedbackEmitter = _emitter.default.inherit({
            ctor: function() {
                this.callBase.apply(this, arguments);
                this._active = new FeedbackEvent(0, _common.noop);
                this._inactive = new FeedbackEvent(0, _common.noop)
            },
            configure: function(data, eventName) {
                switch (eventName) {
                    case ACTIVE_EVENT_NAME:
                        data.activeTimeout = data.timeout;
                        break;
                    case INACTIVE_EVENT_NAME:
                        data.inactiveTimeout = data.timeout
                }
                this.callBase(data)
            },
            start: function(e) {
                if (activeFeedback) {
                    var activeChildExists = (0, _dom.contains)(this.getElement().get(0), activeFeedback.getElement().get(0));
                    var childJustActivated = !activeFeedback._active.fired();
                    if (activeChildExists && childJustActivated) {
                        this._cancel();
                        return
                    }
                    activeFeedback._inactive.force()
                }
                activeFeedback = this;
                this._initEvents(e);
                this._active.start()
            },
            _initEvents: function(e) {
                var that = this;
                var eventTarget = this._getEmitterTarget(e);
                var mouseEvent = (0, _index.isMouseEvent)(e);
                var isSimulator = _devices.default.isSimulator();
                var deferFeedback = isSimulator || !mouseEvent;
                var activeTimeout = (0, _common.ensureDefined)(this.activeTimeout, ACTIVE_TIMEOUT);
                var inactiveTimeout = (0, _common.ensureDefined)(this.inactiveTimeout, INACTIVE_TIMEOUT);
                this._active = new FeedbackEvent(deferFeedback ? activeTimeout : 0, function() {
                    that._fireEvent(ACTIVE_EVENT_NAME, e, {
                        target: eventTarget
                    })
                });
                this._inactive = new FeedbackEvent(deferFeedback ? inactiveTimeout : 0, function() {
                    that._fireEvent(INACTIVE_EVENT_NAME, e, {
                        target: eventTarget
                    });
                    activeFeedback = null
                })
            },
            cancel: function(e) {
                this.end(e)
            },
            end: function(e) {
                var skipTimers = e.type !== _pointer.default.up;
                if (skipTimers) {
                    this._active.stop()
                } else {
                    this._active.force()
                }
                this._inactive.start();
                if (skipTimers) {
                    this._inactive.force()
                }
            },
            dispose: function() {
                this._active.stop();
                this._inactive.stop();
                if (activeFeedback === this) {
                    activeFeedback = null
                }
                this.callBase()
            },
            lockInactive: function() {
                this._active.force();
                this._inactive.stop();
                activeFeedback = null;
                this._cancel();
                return this._inactive.force.bind(this._inactive)
            }
        });
        FeedbackEmitter.lock = function(deferred) {
            var lockInactive = activeFeedback ? activeFeedback.lockInactive() : _common.noop;
            deferred.done(lockInactive)
        };
        (0, _emitter_registrator.default)({
            emitter: FeedbackEmitter,
            events: [ACTIVE_EVENT_NAME, INACTIVE_EVENT_NAME]
        });
        var lock = FeedbackEmitter.lock;
        exports.lock = lock
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/collection/item.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _public_component = __webpack_require__( /*! ../../core/utils/public_component */ 147);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var INVISIBLE_STATE_CLASS = "dx-state-invisible";
        var DISABLED_STATE_CLASS = "dx-state-disabled";
        var ITEM_CONTENT_PLACEHOLDER_CLASS = "dx-item-content-placeholder";
        var forcibleWatcher = function(watchMethod, fn, callback) {
            var filteredCallback = function() {
                var oldValue;
                return function(value) {
                    if (oldValue !== value) {
                        callback(value, oldValue);
                        oldValue = value
                    }
                }
            }();
            return {
                dispose: watchMethod(fn, filteredCallback),
                force: function() {
                    filteredCallback(fn())
                }
            }
        };
        var CollectionItem = _class.default.inherit({
            ctor: function($element, options, rawData) {
                this._$element = $element;
                this._options = options;
                this._rawData = rawData;
                (0, _public_component.attachInstanceToElement)($element, this, this._dispose);
                this._render()
            },
            _render: function() {
                var $placeholder = (0, _renderer.default)("<div>").addClass(ITEM_CONTENT_PLACEHOLDER_CLASS);
                this._$element.append($placeholder);
                this._watchers = [];
                this._renderWatchers()
            },
            _renderWatchers: function() {
                this._startWatcher("disabled", this._renderDisabled.bind(this));
                this._startWatcher("visible", this._renderVisible.bind(this))
            },
            _startWatcher: function(field, render) {
                var rawData = this._rawData;
                var exprGetter = this._options.fieldGetter(field);
                var watcher = forcibleWatcher(this._options.watchMethod(), function() {
                    return exprGetter(rawData)
                }, function(value, oldValue) {
                    this._dirty = true;
                    render(value, oldValue)
                }.bind(this));
                this._watchers.push(watcher)
            },
            setDataField: function() {
                this._dirty = false;
                (0, _iterator.each)(this._watchers, function(_, watcher) {
                    watcher.force()
                });
                if (this._dirty) {
                    return true
                }
            },
            _renderDisabled: function(value, oldValue) {
                this._$element.toggleClass(DISABLED_STATE_CLASS, !!value);
                this._updateOwnerFocus(value)
            },
            _updateOwnerFocus: function(isDisabled) {
                var ownerComponent = this._options.owner;
                if (ownerComponent && isDisabled) {
                    ownerComponent._resetItemFocus(this._$element)
                }
            },
            _renderVisible: function(value, oldValue) {
                this._$element.toggleClass(INVISIBLE_STATE_CLASS, void 0 !== value && !value)
            },
            _dispose: function() {
                (0, _iterator.each)(this._watchers, function(_, watcher) {
                    watcher.dispose()
                })
            }
        });
        CollectionItem.getInstance = function($element) {
            return (0, _public_component.getInstanceByElement)($element, this)
        };
        var _default = CollectionItem;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************!*\
      !*** ./artifacts/transpiled-npm/events/double_click.js ***!
      \*********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.name = void 0;
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _dom = __webpack_require__( /*! ../core/utils/dom */ 33);
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../core/dom_adapter */ 11));
        var _class = _interopRequireDefault(__webpack_require__( /*! ../core/class */ 15));
        var _event_registrator = _interopRequireDefault(__webpack_require__( /*! ./core/event_registrator */ 74));
        var _click = __webpack_require__( /*! ./click */ 21);
        var _index = __webpack_require__( /*! ./utils/index */ 8);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DBLCLICK_EVENT_NAME = "dxdblclick";
        exports.name = DBLCLICK_EVENT_NAME;
        var DBLCLICK_NAMESPACE = "dxDblClick";
        var NAMESPACED_CLICK_EVENT = (0, _index.addNamespace)(_click.name, DBLCLICK_NAMESPACE);
        var DBLCLICK_TIMEOUT = 300;
        var DblClick = _class.default.inherit({
            ctor: function() {
                this._handlerCount = 0;
                this._forgetLastClick()
            },
            _forgetLastClick: function() {
                this._firstClickTarget = null;
                this._lastClickTimeStamp = -DBLCLICK_TIMEOUT
            },
            add: function() {
                if (this._handlerCount <= 0) {
                    _events_engine.default.on(_dom_adapter.default.getDocument(), NAMESPACED_CLICK_EVENT, this._clickHandler.bind(this))
                }
                this._handlerCount++
            },
            _clickHandler: function(e) {
                var timeStamp = e.timeStamp || Date.now();
                var timeBetweenClicks = timeStamp - this._lastClickTimeStamp;
                var isSimulated = timeBetweenClicks < 0;
                var isDouble = !isSimulated && timeBetweenClicks < DBLCLICK_TIMEOUT;
                if (isDouble) {
                    (0, _index.fireEvent)({
                        type: DBLCLICK_EVENT_NAME,
                        target: (0, _dom.closestCommonParent)(this._firstClickTarget, e.target),
                        originalEvent: e
                    });
                    this._forgetLastClick()
                } else {
                    this._firstClickTarget = e.target;
                    this._lastClickTimeStamp = timeStamp
                }
            },
            remove: function() {
                this._handlerCount--;
                if (this._handlerCount <= 0) {
                    this._forgetLastClick();
                    _events_engine.default.off(_dom_adapter.default.getDocument(), NAMESPACED_CLICK_EVENT)
                }
            }
        });
        (0, _event_registrator.default)(DBLCLICK_EVENT_NAME, new DblClick)
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/core/remove_event.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ./renderer */ 2));
        var _element_data = __webpack_require__( /*! ./element_data */ 40);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _event_registrator = _interopRequireDefault(__webpack_require__( /*! ../events/core/event_registrator */ 74));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var eventName = "dxremove";
        var eventPropName = "dxRemoveEvent";
        (0, _element_data.beforeCleanData)(function(elements) {
            elements = [].slice.call(elements);
            for (var i = 0; i < elements.length; i++) {
                var $element = (0, _renderer.default)(elements[i]);
                if ($element.prop(eventPropName)) {
                    $element[0][eventPropName] = null;
                    _events_engine.default.triggerHandler($element, eventName)
                }
            }
        });
        (0, _event_registrator.default)(eventName, {
            noBubble: true,
            setup: function(element) {
                (0, _renderer.default)(element).prop(eventPropName, true)
            }
        });
        var _default = eventName;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************************!*\
      !*** ./artifacts/transpiled-npm/core/templates/child_default_template.js ***!
      \***************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.ChildDefaultTemplate = void 0;
        var _template_base = __webpack_require__( /*! ./template_base */ 75);

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var ChildDefaultTemplate = function(_TemplateBase) {
            _inheritsLoose(ChildDefaultTemplate, _TemplateBase);

            function ChildDefaultTemplate(name) {
                var _this;
                _this = _TemplateBase.call(this) || this;
                _this.name = name;
                return _this
            }
            return ChildDefaultTemplate
        }(_template_base.TemplateBase);
        exports.ChildDefaultTemplate = ChildDefaultTemplate
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/bundles/modules/core.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var windowUtils = __webpack_require__( /*! ../../core/utils/window */ 7);
        var window = windowUtils.getWindow();
        var DevExpress = window.DevExpress = window.DevExpress || {};
        var errors = DevExpress.errors = __webpack_require__( /*! ../../core/errors */ 25);
        if (DevExpress._DEVEXTREME_BUNDLE_INITIALIZED) {
            throw errors.Error("E0024")
        }
        DevExpress._DEVEXTREME_BUNDLE_INITIALIZED = true;
        DevExpress.clientExporter = __webpack_require__( /*! ../../exporter */ 191);
        DevExpress.excelExporter = __webpack_require__( /*! ../../excel_exporter */ 508);
        DevExpress.pdfExporter = __webpack_require__( /*! ../../pdf_exporter */ 514);
        DevExpress.VERSION = __webpack_require__( /*! ../../core/version */ 173);
        DevExpress.Class = __webpack_require__( /*! ../../core/class */ 15);
        DevExpress.DOMComponent = __webpack_require__( /*! ../../core/dom_component */ 67);
        DevExpress.Component = __webpack_require__( /*! ../../core/component */ 127);
        DevExpress.registerComponent = __webpack_require__( /*! ../../core/component_registrator */ 9);
        DevExpress.devices = __webpack_require__( /*! ../../core/devices */ 13);
        DevExpress.Color = __webpack_require__( /*! ../../color */ 95);
        var animationFrame = __webpack_require__( /*! ../../animation/frame */ 129);
        DevExpress.utils = {};
        DevExpress.utils.requestAnimationFrame = animationFrame.requestAnimationFrame;
        DevExpress.utils.cancelAnimationFrame = animationFrame.cancelAnimationFrame;
        DevExpress.utils.initMobileViewport = __webpack_require__( /*! ../../mobile/init_mobile_viewport/init_mobile_viewport */ 524).initMobileViewport;
        DevExpress.utils.getTimeZones = __webpack_require__( /*! ../../time_zone_utils */ 525).getTimeZones;
        DevExpress.utils.extendFromObject = __webpack_require__( /*! ../../core/utils/extend */ 0).extendFromObject;
        DevExpress.utils.triggerShownEvent = __webpack_require__( /*! ../../events/visibility_change */ 59).triggerShownEvent;
        DevExpress.utils.triggerHidingEvent = __webpack_require__( /*! ../../events/visibility_change */ 59).triggerHidingEvent;
        DevExpress.utils.resetActiveElement = __webpack_require__( /*! ../../core/utils/dom */ 33).resetActiveElement;
        DevExpress.utils.findBestMatches = __webpack_require__( /*! ../../core/utils/common */ 4).findBestMatches;
        DevExpress.createQueue = __webpack_require__( /*! ../../core/utils/queue */ 252).create;
        DevExpress.utils.dom = __webpack_require__( /*! ../../core/utils/dom */ 33);
        DevExpress.utils.common = __webpack_require__( /*! ../../core/utils/common */ 4);
        DevExpress.utils.date = __webpack_require__( /*! ../../core/utils/date */ 19);
        DevExpress.utils.browser = __webpack_require__( /*! ../../core/utils/browser */ 23);
        DevExpress.utils.inflector = __webpack_require__( /*! ../../core/utils/inflector */ 39);
        DevExpress.utils.iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        DevExpress.utils.readyCallbacks = __webpack_require__( /*! ../../core/utils/ready_callbacks */ 49);
        DevExpress.utils.resizeCallbacks = __webpack_require__( /*! ../../core/utils/resize_callbacks */ 125);
        DevExpress.utils.console = __webpack_require__( /*! ../../core/utils/console */ 110);
        DevExpress.utils.string = __webpack_require__( /*! ../../core/utils/string */ 43);
        DevExpress.utils.support = __webpack_require__( /*! ../../core/utils/support */ 45);
        DevExpress.utils.ajax = __webpack_require__( /*! ../../core/utils/ajax */ 79);
        DevExpress.viewPort = __webpack_require__( /*! ../../core/utils/view_port */ 80).value;
        DevExpress.hideTopOverlay = __webpack_require__( /*! ../../mobile/hide_top_overlay */ 529);
        DevExpress.formatHelper = __webpack_require__( /*! ../../format_helper */ 71);
        DevExpress.config = __webpack_require__( /*! ../../core/config */ 31);
        DevExpress.animationPresets = __webpack_require__( /*! ../../animation/presets/presets */ 200).presets;
        DevExpress.fx = __webpack_require__( /*! ../../animation/fx */ 42);
        DevExpress.TransitionExecutor = __webpack_require__( /*! ../../animation/transition_executor/transition_executor */ 326).TransitionExecutor;
        DevExpress.AnimationPresetCollection = __webpack_require__( /*! ../../animation/presets/presets */ 200).PresetCollection;
        DevExpress.events = __webpack_require__( /*! ../../events/index */ 327);
        DevExpress.events.click = __webpack_require__( /*! ../../events/click */ 21);
        DevExpress.events.utils = __webpack_require__( /*! ../../events/utils/index */ 8);
        DevExpress.events.GestureEmitter = __webpack_require__( /*! ../../events/gesture/emitter.gesture */ 176);
        DevExpress.localization = __webpack_require__( /*! ../../localization */ 533);
        DevExpress.templateRendered = __webpack_require__( /*! ../../core/templates/template_base */ 75).renderedCallbacks;
        DevExpress.setTemplateEngine = __webpack_require__( /*! ../../core/templates/template_engine_registry */ 175).setTemplateEngine;
        module.exports = DevExpress
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/events/hover.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.end = exports.start = void 0;
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _element_data = __webpack_require__( /*! ../core/element_data */ 40);
        var _class = _interopRequireDefault(__webpack_require__( /*! ../core/class */ 15));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../core/devices */ 13));
        var _event_registrator = _interopRequireDefault(__webpack_require__( /*! ./core/event_registrator */ 74));
        var _index = __webpack_require__( /*! ./utils/index */ 8);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ./pointer */ 24));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var HOVERSTART_NAMESPACE = "dxHoverStart";
        var HOVERSTART = "dxhoverstart";
        exports.start = HOVERSTART;
        var POINTERENTER_NAMESPACED_EVENT_NAME = (0, _index.addNamespace)(_pointer.default.enter, HOVERSTART_NAMESPACE);
        var HOVEREND_NAMESPACE = "dxHoverEnd";
        var HOVEREND = "dxhoverend";
        exports.end = HOVEREND;
        var POINTERLEAVE_NAMESPACED_EVENT_NAME = (0, _index.addNamespace)(_pointer.default.leave, HOVEREND_NAMESPACE);
        var Hover = _class.default.inherit({
            noBubble: true,
            ctor: function() {
                this._handlerArrayKeyPath = this._eventNamespace + "_HandlerStore"
            },
            setup: function(element) {
                (0, _element_data.data)(element, this._handlerArrayKeyPath, {})
            },
            add: function(element, handleObj) {
                var that = this;
                var handler = function(e) {
                    that._handler(e)
                };
                _events_engine.default.on(element, this._originalEventName, handleObj.selector, handler);
                (0, _element_data.data)(element, this._handlerArrayKeyPath)[handleObj.guid] = handler
            },
            _handler: function(e) {
                if ((0, _index.isTouchEvent)(e) || _devices.default.isSimulator()) {
                    return
                }(0, _index.fireEvent)({
                    type: this._eventName,
                    originalEvent: e,
                    delegateTarget: e.delegateTarget
                })
            },
            remove: function(element, handleObj) {
                var handler = (0, _element_data.data)(element, this._handlerArrayKeyPath)[handleObj.guid];
                _events_engine.default.off(element, this._originalEventName, handleObj.selector, handler)
            },
            teardown: function(element) {
                (0, _element_data.removeData)(element, this._handlerArrayKeyPath)
            }
        });
        var HoverStart = Hover.inherit({
            ctor: function() {
                this._eventNamespace = HOVERSTART_NAMESPACE;
                this._eventName = HOVERSTART;
                this._originalEventName = POINTERENTER_NAMESPACED_EVENT_NAME;
                this.callBase()
            },
            _handler: function(e) {
                var pointers = e.pointers || [];
                if (!pointers.length) {
                    this.callBase(e)
                }
            }
        });
        var HoverEnd = Hover.inherit({
            ctor: function() {
                this._eventNamespace = HOVEREND_NAMESPACE;
                this._eventName = HOVEREND;
                this._originalEventName = POINTERLEAVE_NAMESPACED_EVENT_NAME;
                this.callBase()
            }
        });
        (0, _event_registrator.default)(HOVERSTART, new HoverStart);
        (0, _event_registrator.default)(HOVEREND, new HoverEnd)
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/list/ui.list.edit.decorator.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _swipe = __webpack_require__( /*! ../../events/swipe */ 194);
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var LIST_EDIT_DECORATOR = "dxListEditDecorator";
        var SWIPE_START_EVENT_NAME = (0, _index.addNamespace)(_swipe.start, LIST_EDIT_DECORATOR);
        var SWIPE_UPDATE_EVENT_NAME = (0, _index.addNamespace)(_swipe.swipe, LIST_EDIT_DECORATOR);
        var SWIPE_END_EVENT_NAME = (0, _index.addNamespace)(_swipe.end, LIST_EDIT_DECORATOR);
        var EditDecorator = _class.default.inherit({
            ctor: function(list) {
                this._list = list;
                this._init()
            },
            _init: _common.noop,
            _shouldHandleSwipe: false,
            _attachSwipeEvent: function(config) {
                var swipeConfig = {
                    itemSizeFunc: function() {
                        if (this._clearSwipeCache) {
                            this._itemWidthCache = this._list.$element().width();
                            this._clearSwipeCache = false
                        }
                        return this._itemWidthCache
                    }.bind(this)
                };
                _events_engine.default.on(config.$itemElement, SWIPE_START_EVENT_NAME, swipeConfig, this._itemSwipeStartHandler.bind(this));
                _events_engine.default.on(config.$itemElement, SWIPE_UPDATE_EVENT_NAME, this._itemSwipeUpdateHandler.bind(this));
                _events_engine.default.on(config.$itemElement, SWIPE_END_EVENT_NAME, this._itemSwipeEndHandler.bind(this))
            },
            _itemSwipeStartHandler: function(e) {
                var $itemElement = (0, _renderer.default)(e.currentTarget);
                if ($itemElement.is(".dx-state-disabled, .dx-state-disabled *")) {
                    e.cancel = true;
                    return
                }
                clearTimeout(this._list._inkRippleTimer);
                this._swipeStartHandler($itemElement, e)
            },
            _itemSwipeUpdateHandler: function(e) {
                var $itemElement = (0, _renderer.default)(e.currentTarget);
                this._swipeUpdateHandler($itemElement, e)
            },
            _itemSwipeEndHandler: function(e) {
                var $itemElement = (0, _renderer.default)(e.currentTarget);
                this._swipeEndHandler($itemElement, e);
                this._clearSwipeCache = true
            },
            beforeBag: _common.noop,
            afterBag: _common.noop,
            _commonOptions: function() {
                return {
                    activeStateEnabled: this._list.option("activeStateEnabled"),
                    hoverStateEnabled: this._list.option("hoverStateEnabled"),
                    focusStateEnabled: this._list.option("focusStateEnabled")
                }
            },
            modifyElement: function(config) {
                if (this._shouldHandleSwipe) {
                    this._attachSwipeEvent(config);
                    this._clearSwipeCache = true
                }
            },
            afterRender: _common.noop,
            handleClick: _common.noop,
            handleKeyboardEvents: _common.noop,
            handleEnterPressing: _common.noop,
            handleContextMenu: _common.noop,
            _swipeStartHandler: _common.noop,
            _swipeUpdateHandler: _common.noop,
            _swipeEndHandler: _common.noop,
            visibilityChange: _common.noop,
            getExcludedSelectors: _common.noop,
            dispose: _common.noop
        });
        var _default = EditDecorator;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/toolbar.js ***!
      \************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _array = __webpack_require__( /*! ../core/utils/array */ 12);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _uiToolbarStrategy = _interopRequireDefault(__webpack_require__( /*! ./toolbar/ui.toolbar.strategy.action_sheet */ 656));
        var _uiToolbarStrategy2 = _interopRequireDefault(__webpack_require__( /*! ./toolbar/ui.toolbar.strategy.drop_down_menu */ 657));
        var _uiToolbar = _interopRequireDefault(__webpack_require__( /*! ./toolbar/ui.toolbar.base */ 337));
        var _child_default_template = __webpack_require__( /*! ../core/templates/child_default_template */ 153);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var STRATEGIES = {
            actionSheet: _uiToolbarStrategy.default,
            dropDownMenu: _uiToolbarStrategy2.default
        };
        var TOOLBAR_AUTO_HIDE_ITEM_CLASS = "dx-toolbar-item-auto-hide";
        var TOOLBAR_AUTO_HIDE_TEXT_CLASS = "dx-toolbar-text-auto-hide";
        var TOOLBAR_HIDDEN_ITEM = "dx-toolbar-item-invisible";
        var Toolbar = _uiToolbar.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    menuItemTemplate: "menuItem",
                    submenuType: "dropDownMenu",
                    menuContainer: void 0
                })
            },
            _dimensionChanged: function(dimension) {
                if ("height" === dimension) {
                    return
                }
                this._menuStrategy.toggleMenuVisibility(false, true);
                this.callBase();
                this._menuStrategy.renderMenuItems()
            },
            _initTemplates: function() {
                this.callBase();
                this._templateManager.addDefaultTemplates({
                    actionSheetItem: new _child_default_template.ChildDefaultTemplate("item")
                })
            },
            _initMarkup: function() {
                this.callBase();
                this._renderMenu()
            },
            _postProcessRenderItems: function() {
                var _this = this;
                this._hideOverflowItems();
                this._menuStrategy._updateMenuVisibility();
                this.callBase();
                (0, _common.deferRender)(function() {
                    _this._menuStrategy.renderMenuItems()
                })
            },
            _renderItem: function(index, item, itemContainer, $after) {
                var itemElement = this.callBase(index, item, itemContainer, $after);
                if ("auto" === item.locateInMenu) {
                    itemElement.addClass(TOOLBAR_AUTO_HIDE_ITEM_CLASS)
                }
                if ("dxButton" === item.widget && "inMenu" === item.showText) {
                    itemElement.toggleClass(TOOLBAR_AUTO_HIDE_TEXT_CLASS)
                }
                return itemElement
            },
            _getItemsWidth: function() {
                return this._getSummaryItemsWidth([this._$beforeSection, this._$centerSection, this._$afterSection])
            },
            _hideOverflowItems: function(elementWidth) {
                var overflowItems = this.$element().find("." + TOOLBAR_AUTO_HIDE_ITEM_CLASS);
                if (!overflowItems.length) {
                    return
                }
                elementWidth = elementWidth || this.$element().width();
                (0, _renderer.default)(overflowItems).removeClass(TOOLBAR_HIDDEN_ITEM);
                var itemsWidth = this._getItemsWidth();
                while (overflowItems.length && elementWidth < itemsWidth) {
                    var $item = overflowItems.eq(-1);
                    itemsWidth -= $item.outerWidth();
                    $item.addClass(TOOLBAR_HIDDEN_ITEM);
                    overflowItems.splice(-1, 1)
                }
            },
            _getMenuItems: function() {
                var that = this;
                var menuItems = (0, _common.grep)(this.option("items") || [], function(item) {
                    return that._isMenuItem(item)
                });
                var $hiddenItems = this._itemContainer().children("." + TOOLBAR_AUTO_HIDE_ITEM_CLASS + "." + TOOLBAR_HIDDEN_ITEM).not(".dx-state-invisible");
                this._restoreItems = this._restoreItems || [];
                var overflowItems = [].slice.call($hiddenItems).map(function(item) {
                    var itemData = that._getItemData(item);
                    var $itemContainer = (0, _renderer.default)(item).children();
                    var $itemMarkup = $itemContainer.children();
                    return (0, _extend.extend)({
                        menuItemTemplate: function() {
                            that._restoreItems.push({
                                container: $itemContainer,
                                item: $itemMarkup
                            });
                            var $container = (0, _renderer.default)("<div>").addClass(TOOLBAR_AUTO_HIDE_ITEM_CLASS);
                            return $container.append($itemMarkup)
                        }
                    }, itemData)
                });
                return (0, _array.merge)(overflowItems, menuItems)
            },
            _getToolbarItems: function() {
                var that = this;
                return (0, _common.grep)(this.option("items") || [], function(item) {
                    return !that._isMenuItem(item)
                })
            },
            _renderMenu: function() {
                var _this2 = this;
                this._renderMenuStrategy();
                (0, _common.deferRender)(function() {
                    _this2._menuStrategy.render()
                })
            },
            _renderMenuStrategy: function() {
                var strategyName = this.option("submenuType");
                if (this._requireDropDownStrategy()) {
                    strategyName = "dropDownMenu"
                }
                var strategy = STRATEGIES[strategyName];
                if (!(this._menuStrategy && this._menuStrategy.NAME === strategyName)) {
                    this._menuStrategy = new strategy(this)
                }
            },
            _requireDropDownStrategy: function() {
                var items = this.option("items") || [];
                var result = false;
                (0, _iterator.each)(items, function(index, item) {
                    if ("auto" === item.locateInMenu) {
                        result = true
                    } else {
                        if ("always" === item.locateInMenu && item.widget) {
                            result = true
                        }
                    }
                });
                return result
            },
            _arrangeItems: function() {
                if (this.$element().is(":hidden")) {
                    return
                }
                this._$centerSection.css({
                    margin: "0 auto",
                    "float": "none"
                });
                (0, _iterator.each)(this._restoreItems || [], function(_, obj) {
                    (0, _renderer.default)(obj.container).append(obj.item)
                });
                this._restoreItems = [];
                var elementWidth = this.$element().width();
                this._hideOverflowItems(elementWidth);
                this.callBase(elementWidth)
            },
            _itemOptionChanged: function(item, property, value) {
                if (this._isMenuItem(item)) {
                    this._menuStrategy.renderMenuItems()
                } else {
                    if (this._isToolbarItem(item)) {
                        this.callBase(item, property, value)
                    } else {
                        this.callBase(item, property, value);
                        this._menuStrategy.renderMenuItems()
                    }
                }
                if ("location" === property) {
                    this.repaint()
                }
            },
            _isMenuItem: function(itemData) {
                return "menu" === itemData.location || "always" === itemData.locateInMenu
            },
            _isToolbarItem: function(itemData) {
                return void 0 === itemData.location || "never" === itemData.locateInMenu
            },
            _optionChanged: function(args) {
                var name = args.name;
                var value = args.value;
                switch (name) {
                    case "submenuType":
                        this._invalidate();
                        break;
                    case "visible":
                        this.callBase.apply(this, arguments);
                        this._menuStrategy.handleToolbarVisibilityChange(value);
                        break;
                    case "menuItemTemplate":
                        this._changeMenuOption("itemTemplate", this._getTemplate(value));
                        break;
                    case "onItemClick":
                        this._changeMenuOption(name, value);
                        this.callBase.apply(this, arguments);
                        break;
                    case "menuContainer":
                        this._changeMenuOption("container", value);
                        break;
                    default:
                        this.callBase.apply(this, arguments)
                }
            },
            _changeMenuOption: function(name, value) {
                this._menuStrategy.widgetOption(name, value)
            }
        });
        (0, _component_registrator.default)("dxToolbar", Toolbar);
        var _default = Toolbar;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_view.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiTree_view = _interopRequireDefault(__webpack_require__( /*! ./tree_view/ui.tree_view.search */ 395));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _uiTree_view.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/weekday.js ***!
      \****************************************************/
    /*! exports provided: ALL_WEEKDAYS, Weekday */
    /*! exports used: ALL_WEEKDAYS, Weekday */
    function(module, __webpack_exports__, __webpack_require__) {
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return ALL_WEEKDAYS
        });
        __webpack_require__.d(__webpack_exports__, "b", function() {
            return Weekday
        });
        var ALL_WEEKDAYS = ["MO", "TU", "WE", "TH", "FR", "SA", "SU"];
        var Weekday = function() {
            function Weekday(weekday, n) {
                if (0 === n) {
                    throw new Error("Can't create weekday with n == 0")
                }
                this.weekday = weekday;
                this.n = n
            }
            Weekday.fromStr = function(str) {
                return new Weekday(ALL_WEEKDAYS.indexOf(str))
            };
            Weekday.prototype.nth = function(n) {
                return this.n === n ? this : new Weekday(this.weekday, n)
            };
            Weekday.prototype.equals = function(other) {
                return this.weekday === other.weekday && this.n === other.n
            };
            Weekday.prototype.toString = function() {
                var s = ALL_WEEKDAYS[this.weekday];
                if (this.n) {
                    s = (this.n > 0 ? "+" : "") + String(this.n) + s
                }
                return s
            };
            Weekday.prototype.getJsWeekday = function() {
                return 6 === this.weekday ? 0 : this.weekday + 1
            };
            return Weekday
        }()
    },
    /*!************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/constants.js ***!
      \************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.AGENDA_LAST_IN_DATE_APPOINTMENT_CLASS = exports.APPOINTMENT_DRAG_SOURCE_CLASS = exports.DIRECTION_APPOINTMENT_CLASSES = exports.REDUCED_APPOINTMENT_PARTS_CLASSES = exports.ALL_DAY_APPOINTMENT_CLASS = exports.EMPTY_APPOINTMENT_CLASS = exports.RECURRENCE_APPOINTMENT_CLASS = exports.REDUCED_APPOINTMENT_ICON = exports.REDUCED_APPOINTMENT_CLASS = exports.APPOINTMENT_SETTINGS_KEY = exports.LIST_ITEM_CLASS = exports.FIXED_CONTAINER_CLASS = exports.LIST_ITEM_DATA_KEY = void 0;
        var LIST_ITEM_DATA_KEY = "dxListItemData";
        exports.LIST_ITEM_DATA_KEY = LIST_ITEM_DATA_KEY;
        var FIXED_CONTAINER_CLASS = "dx-scheduler-fixed-appointments";
        exports.FIXED_CONTAINER_CLASS = FIXED_CONTAINER_CLASS;
        var LIST_ITEM_CLASS = "dx-list-item";
        exports.LIST_ITEM_CLASS = LIST_ITEM_CLASS;
        var APPOINTMENT_SETTINGS_KEY = "dxAppointmentSettings";
        exports.APPOINTMENT_SETTINGS_KEY = APPOINTMENT_SETTINGS_KEY;
        var REDUCED_APPOINTMENT_CLASS = "dx-scheduler-appointment-reduced";
        exports.REDUCED_APPOINTMENT_CLASS = REDUCED_APPOINTMENT_CLASS;
        var REDUCED_APPOINTMENT_ICON = "dx-scheduler-appointment-reduced-icon";
        exports.REDUCED_APPOINTMENT_ICON = REDUCED_APPOINTMENT_ICON;
        var RECURRENCE_APPOINTMENT_CLASS = "dx-scheduler-appointment-recurrence";
        exports.RECURRENCE_APPOINTMENT_CLASS = RECURRENCE_APPOINTMENT_CLASS;
        var EMPTY_APPOINTMENT_CLASS = "dx-scheduler-appointment-empty";
        exports.EMPTY_APPOINTMENT_CLASS = EMPTY_APPOINTMENT_CLASS;
        var ALL_DAY_APPOINTMENT_CLASS = "dx-scheduler-all-day-appointment";
        exports.ALL_DAY_APPOINTMENT_CLASS = ALL_DAY_APPOINTMENT_CLASS;
        var REDUCED_APPOINTMENT_PARTS_CLASSES = {
            head: "dx-scheduler-appointment-head",
            body: "dx-scheduler-appointment-body",
            tail: "dx-scheduler-appointment-tail"
        };
        exports.REDUCED_APPOINTMENT_PARTS_CLASSES = REDUCED_APPOINTMENT_PARTS_CLASSES;
        var DIRECTION_APPOINTMENT_CLASSES = {
            horizontal: "dx-scheduler-appointment-horizontal",
            vertical: "dx-scheduler-appointment-vertical"
        };
        exports.DIRECTION_APPOINTMENT_CLASSES = DIRECTION_APPOINTMENT_CLASSES;
        var APPOINTMENT_DRAG_SOURCE_CLASS = "dx-scheduler-appointment-drag-source";
        exports.APPOINTMENT_DRAG_SOURCE_CLASS = APPOINTMENT_DRAG_SOURCE_CLASS;
        var AGENDA_LAST_IN_DATE_APPOINTMENT_CLASS = "dx-scheduler-last-in-date-agenda-appointment";
        exports.AGENDA_LAST_IN_DATE_APPOINTMENT_CLASS = AGENDA_LAST_IN_DATE_APPOINTMENT_CLASS
    },
    /*!******************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/ui/scheduler/workspaces/base/layout_props.js ***!
      \******************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.LayoutProps = void 0;
        var LayoutProps = {
            viewData: {
                groupedData: [],
                cellCountInGroupRow: 0
            }
        };
        exports.LayoutProps = LayoutProps
    },
    /*!******************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/core/helpers.js ***!
      \******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.expand = expand;
        exports.changes = changes;
        exports.replaceInherit = void 0;
        var _extend2 = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var isServerSide = !(0, _window.hasWindow)();

        function Flags() {
            this.reset()
        }
        Flags.prototype = {
            constructor: Flags,
            add: function(codes) {
                var i;
                var ii = codes.length;
                var flags = this._flags;
                for (i = 0; i < ii; ++i) {
                    flags[codes[i]] = 1
                }
            },
            has: function(code) {
                return this._flags[code] > 0
            },
            count: function() {
                return Object.keys(this._flags).length
            },
            reset: function() {
                this._flags = {}
            }
        };

        function combineMaps(baseMap, thisMap) {
            return baseMap !== thisMap ? (0, _extend2.extend)({}, baseMap, thisMap) : (0, _extend2.extend)({}, baseMap)
        }

        function combineLists(baseList, thisList) {
            return baseList !== thisList ? baseList.concat(thisList) : baseList.slice()
        }

        function buildTotalChanges(proto) {
            proto._totalChangesOrder = proto._optionChangesOrder.concat(proto._layoutChangesOrder, proto._customChangesOrder)
        }

        function addChange(settings) {
            var proto = this.prototype;
            var code = settings.code;
            proto["_change_" + code] = settings.handler;
            if (settings.isThemeDependent) {
                proto._themeDependentChanges.push(code)
            }
            if (settings.option) {
                proto._optionChangesMap[settings.option] = code
            }(settings.isOptionChange ? proto._optionChangesOrder : proto._customChangesOrder).push(code);
            buildTotalChanges(proto)
        }

        function createChainExecutor() {
            var executeChain = function executeChain() {
                var i;
                var ii = executeChain._chain.length;
                var result;
                for (i = 0; i < ii; ++i) {
                    result = executeChain._chain[i].apply(this, arguments)
                }
                return result
            };
            executeChain._chain = [];
            executeChain.add = function(item) {
                executeChain._chain.push(item)
            };
            executeChain.copy = function(executor) {
                executeChain._chain = executor._chain.slice()
            };
            return executeChain
        }

        function expand(target, name, expander) {
            var current = target[name];
            if (!current) {
                current = expander
            } else {
                if (!current.add) {
                    current = createChainExecutor();
                    current.add(target[name]);
                    current.add(expander)
                } else {
                    if (false === Object.prototype.hasOwnProperty.call(target, name)) {
                        current = createChainExecutor();
                        current.copy(target[name])
                    }
                    current.add(expander)
                }
            }
            target[name] = current
        }

        function addPlugin(plugin) {
            var proto = this.prototype;
            proto._plugins.push(plugin);
            plugin.fontFields && proto._fontFields.push.apply(proto._fontFields, plugin.fontFields);
            if (plugin.members) {
                (0, _extend2.extend)(this.prototype, plugin.members)
            }
            if (plugin.customize) {
                plugin.customize(this)
            }
            if (plugin.extenders) {
                Object.keys(plugin.extenders).forEach(function(key) {
                    var func = plugin.extenders[key];
                    expand(proto, key, func)
                }, this)
            }
        }
        var replaceInherit = isServerSide ? function(widget) {
            var _inherit = widget.inherit;
            widget.inherit = function() {
                var result = _inherit.apply(this, arguments);
                var proto = result.prototype;
                ["_plugins", "_eventsMap", "_initialChanges", "_themeDependentChanges", "_optionChangesMap", "_optionChangesOrder", "_layoutChangesOrder", "_customChangesOrder", "_totalChangesOrder"].forEach(function(key) {
                    proto[key] = {}
                });
                result.addPlugin = _common.noop;
                return result
            };
            widget.addChange = _common.noop;
            widget.addPlugin = _common.noop
        } : function(widget) {
            var _inherit = widget.inherit;
            widget.inherit = function() {
                var proto = this.prototype;
                var plugins = proto._plugins;
                var fontFields = proto._fontFields;
                var eventsMap = proto._eventsMap;
                var initialChanges = proto._initialChanges;
                var themeDependentChanges = proto._themeDependentChanges;
                var optionChangesMap = proto._optionChangesMap;
                var partialOptionChangesMap = proto._partialOptionChangesMap;
                var partialOptionChangesPath = proto._partialOptionChangesPath;
                var optionChangesOrder = proto._optionChangesOrder;
                var layoutChangesOrder = proto._layoutChangesOrder;
                var customChangesOrder = proto._customChangesOrder;
                var result = _inherit.apply(this, arguments);
                proto = result.prototype;
                proto._plugins = combineLists(plugins, proto._plugins);
                proto._fontFields = combineLists(fontFields, proto._fontFields);
                proto._eventsMap = combineMaps(eventsMap, proto._eventsMap);
                proto._initialChanges = combineLists(initialChanges, proto._initialChanges);
                proto._themeDependentChanges = combineLists(themeDependentChanges, proto._themeDependentChanges);
                proto._optionChangesMap = combineMaps(optionChangesMap, proto._optionChangesMap);
                proto._partialOptionChangesMap = combineMaps(partialOptionChangesMap, proto._partialOptionChangesMap);
                proto._partialOptionChangesPath = combineMaps(partialOptionChangesPath, proto._partialOptionChangesPath);
                proto._optionChangesOrder = combineLists(optionChangesOrder, proto._optionChangesOrder);
                proto._layoutChangesOrder = combineLists(layoutChangesOrder, proto._layoutChangesOrder);
                proto._customChangesOrder = combineLists(customChangesOrder, proto._customChangesOrder);
                buildTotalChanges(proto);
                result.addPlugin = addPlugin;
                return result
            };
            widget.prototype._plugins = [];
            widget.prototype._fontFields = [];
            widget.addChange = addChange;
            widget.addPlugin = addPlugin
        };
        exports.replaceInherit = replaceInherit;

        function changes() {
            return new Flags
        }
    },
    /*!***********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/series/bar_series.js ***!
      \***********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.polar = exports.chart = void 0;
        var _extend2 = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var scatterSeries = _interopRequireWildcard(__webpack_require__( /*! ./scatter_series */ 122));
        var _area_series = __webpack_require__( /*! ./area_series */ 188);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }
        var areaSeries = _area_series.chart.area;
        var chartSeries = scatterSeries.chart;
        var polarSeries = scatterSeries.polar;
        var _extend = _extend2.extend;
        var _each = _iterator.each;
        var chart = {};
        exports.chart = chart;
        var polar = {};
        exports.polar = polar;
        var baseBarSeriesMethods = {
            _createLegendState: function(styleOptions, defaultColor) {
                return {
                    fill: styleOptions.color || defaultColor,
                    hatching: styleOptions.hatching
                }
            },
            _parsePointStyle: function(style, defaultColor, defaultBorderColor) {
                var color = style.color || defaultColor;
                var base = chartSeries._parsePointStyle.call(this, style, color, defaultBorderColor);
                base.fill = color;
                base.hatching = style.hatching;
                base.dashStyle = style.border && style.border.dashStyle || "solid";
                delete base.r;
                return base
            },
            _applyMarkerClipRect: function(settings) {
                settings["clip-path"] = null
            },
            _setGroupsSettings: function(animationEnabled, firstDrawing) {
                var that = this;
                var settings = {};
                chartSeries._setGroupsSettings.apply(that, arguments);
                if (animationEnabled && firstDrawing) {
                    settings = this._getAffineCoordOptions()
                } else {
                    if (!animationEnabled) {
                        settings = {
                            scaleX: 1,
                            scaleY: 1,
                            translateX: 0,
                            translateY: 0
                        }
                    }
                }
                that._markersGroup.attr(settings)
            },
            _drawPoint: function(options) {
                options.hasAnimation = options.hasAnimation && !options.firstDrawing;
                options.firstDrawing = false;
                chartSeries._drawPoint.call(this, options)
            },
            _getMainColor: function() {
                return this._options.mainSeriesColor
            },
            _createPointStyles: function(pointOptions) {
                var that = this;
                var mainColor = pointOptions.color || that._getMainColor();
                return {
                    normal: that._parsePointStyle(pointOptions, mainColor, mainColor),
                    hover: that._parsePointStyle(pointOptions.hoverStyle || {}, mainColor, mainColor),
                    selection: that._parsePointStyle(pointOptions.selectionStyle || {}, mainColor, mainColor)
                }
            },
            _updatePointsVisibility: function() {
                var visibility = this._options.visible;
                (0, _iterator.each)(this._points, function(_, point) {
                    point._options.visible = visibility
                })
            },
            _getOptionsForPoint: function() {
                return this._options
            },
            _animate: function(firstDrawing) {
                var that = this;
                var complete = function() {
                    that._animateComplete()
                };
                var animateFunc = function(drawnPoints, complete) {
                    var lastPointIndex = drawnPoints.length - 1;
                    _each(drawnPoints || [], function(i, point) {
                        point.animate(i === lastPointIndex ? complete : void 0, point.getMarkerCoords())
                    })
                };
                that._animatePoints(firstDrawing, complete, animateFunc)
            },
            getValueRangeInitialValue: areaSeries.getValueRangeInitialValue,
            _patchMarginOptions: function(options) {
                options.checkInterval = true;
                return options
            },
            _defaultAggregator: "sum",
            _defineDrawingState: function() {},
            usePointsToDefineAutoHiding: function() {
                return false
            }
        };
        chart.bar = _extend({}, chartSeries, baseBarSeriesMethods, {
            _getAffineCoordOptions: function() {
                var rotated = this._options.rotated;
                var direction = rotated ? "X" : "Y";
                var settings = {
                    scaleX: rotated ? .001 : 1,
                    scaleY: rotated ? 1 : .001
                };
                settings["translate" + direction] = this.getValueAxis().getTranslator().translate("canvas_position_default");
                return settings
            },
            _animatePoints: function(firstDrawing, complete, animateFunc) {
                var that = this;
                that._markersGroup.animate({
                    scaleX: 1,
                    scaleY: 1,
                    translateY: 0,
                    translateX: 0
                }, void 0, complete);
                if (!firstDrawing) {
                    animateFunc(that._drawnPoints, complete)
                }
            },
            checkSeriesViewportCoord: function(axis, coord) {
                if (!chartSeries.checkSeriesViewportCoord.call(this)) {
                    return false
                }
                if (axis.isArgumentAxis) {
                    return true
                }
                var translator = axis.getTranslator();
                var range = this.getViewport();
                var min = translator.translate(range.categories ? range.categories[0] : range.min);
                var max = translator.translate(range.categories ? range.categories[range.categories.length - 1] : range.max);
                var rotated = this.getOptions().rotated;
                var inverted = axis.getOptions().inverted;
                return rotated && !inverted || !rotated && inverted ? coord >= min && coord <= max : coord >= max && coord <= min
            },
            getSeriesPairCoord: function(coord, isArgument) {
                var oppositeCoord = null;
                var rotated = this._options.rotated;
                var isOpposite = !isArgument && !rotated || isArgument && rotated;
                var coordName = isOpposite ? "vy" : "vx";
                var oppositeCoordName = isOpposite ? "vx" : "vy";
                var points = this.getPoints();
                for (var i = 0; i < points.length; i++) {
                    var p = points[i];
                    var tmpCoord = void 0;
                    if (isArgument) {
                        tmpCoord = p.getCenterCoord()[coordName[1]] === coord ? p[oppositeCoordName] : void 0
                    } else {
                        tmpCoord = p[coordName] === coord ? p[oppositeCoordName] : void 0
                    }
                    if (this._checkAxisVisibleAreaCoord(!isArgument, tmpCoord)) {
                        oppositeCoord = tmpCoord;
                        break
                    }
                }
                return oppositeCoord
            }
        });
        polar.bar = _extend({}, polarSeries, baseBarSeriesMethods, {
            _animatePoints: function(firstDrawing, complete, animateFunc) {
                animateFunc(this._drawnPoints, complete)
            },
            _setGroupsSettings: chartSeries._setGroupsSettings,
            _drawPoint: function(point, groups, animationEnabled) {
                chartSeries._drawPoint.call(this, point, groups, animationEnabled)
            },
            _parsePointStyle: function(style) {
                var base = baseBarSeriesMethods._parsePointStyle.apply(this, arguments);
                base.opacity = style.opacity;
                return base
            },
            _createGroups: chartSeries._createGroups,
            _setMarkerGroupSettings: function() {
                var that = this;
                var markersSettings = that._createPointStyles(that._getMarkerGroupOptions()).normal;
                markersSettings.class = "dxc-markers";
                that._applyMarkerClipRect(markersSettings);
                var groupSettings = _extend({}, markersSettings);
                delete groupSettings.opacity;
                that._markersGroup.attr(groupSettings)
            },
            getSeriesPairCoord: function(params, isArgument) {
                var coords = null;
                var paramName = isArgument ? "argument" : "radius";
                var points = this.getVisiblePoints();
                var argAxis = this.getArgumentAxis();
                var startAngle = argAxis.getAngles()[0];
                for (var i = 0; i < points.length; i++) {
                    var p = points[i];
                    var tmpPoint = (0, _type.isDefined)(p[paramName]) && (0, _type.isDefined)(params[paramName]) && p[paramName].valueOf() === params[paramName].valueOf() ? (0, _utils.convertPolarToXY)(argAxis.getCenter(), startAngle, -argAxis.getTranslatedAngle(p.angle), p.radius) : void 0;
                    if ((0, _type.isDefined)(tmpPoint)) {
                        coords = tmpPoint;
                        break
                    }
                }
                return coords
            },
            _createLegendState: areaSeries._createLegendState
        })
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/core/data_source.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.plugin = void 0;
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _data_helper = _interopRequireDefault(__webpack_require__( /*! ../../data_helper */ 92));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var postCtor = _data_helper.default.postCtor;
        var name;
        var members = {
            _dataSourceLoadErrorHandler: function() {
                this._dataSourceChangedHandler()
            },
            _dataSourceOptions: function() {
                return {
                    paginate: false
                }
            },
            _updateDataSource: function() {
                this._refreshDataSource();
                if (!this.option("dataSource")) {
                    this._dataSourceChangedHandler()
                }
            },
            _dataIsLoaded: function() {
                return !this._dataSource || this._dataSource.isLoaded()
            },
            _dataSourceItems: function() {
                return this._dataSource && this._dataSource.items()
            }
        };
        for (name in _data_helper.default) {
            if ("postCtor" === name) {
                continue
            }
            members[name] = _data_helper.default[name]
        }
        var plugin = {
            name: "data_source",
            init: function() {
                postCtor.call(this)
            },
            dispose: _common.noop,
            members: members
        };
        exports.plugin = plugin
    },
    /*!*********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/tree_map/tiling.js ***!
      \*********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getAlgorithm = getAlgorithm;
        exports.addAlgorithm = addAlgorithm;
        exports.setDefaultAlgorithm = setDefaultAlgorithm;
        exports.buildSidesData = buildSidesData;
        exports.calculateRectangles = calculateRectangles;
        exports.getStaticSideIndex = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _round = Math.round;
        var algorithms = {};
        var defaultAlgorithm;

        function getAlgorithm(value) {
            return algorithms[(0, _utils.normalizeEnum)(value)] || (0, _type.isFunction)(value) && value || defaultAlgorithm
        }

        function addAlgorithm(name, callback) {
            algorithms[name] = callback
        }

        function setDefaultAlgorithm(name) {
            defaultAlgorithm = algorithms[name]
        }
        var directionToIndexOffsets = {};
        directionToIndexOffsets[-1] = [2, 0];
        directionToIndexOffsets[1] = [0, 2];
        var getStaticSideIndex = function(rect) {
            return rect[2] - rect[0] < rect[3] - rect[1] ? 0 : 1
        };
        exports.getStaticSideIndex = getStaticSideIndex;

        function buildSidesData(rect, directions, _staticSideIndex) {
            var staticSideIndex = void 0 !== _staticSideIndex ? _staticSideIndex : getStaticSideIndex(rect);
            var variedSideIndex = 1 - staticSideIndex;
            var staticSideDirection = directions[staticSideIndex];
            var variedSideDirection = directions[variedSideIndex];
            var staticSideIndexOffsets = directionToIndexOffsets[staticSideDirection];
            var variedSideIndexOffsets = directionToIndexOffsets[variedSideDirection];
            return {
                staticSide: rect[2 + staticSideIndex] - rect[staticSideIndex],
                variedSide: rect[2 + variedSideIndex] - rect[variedSideIndex],
                static1: staticSideIndex + staticSideIndexOffsets[0],
                static2: staticSideIndex + staticSideIndexOffsets[1],
                varied1: variedSideIndex + variedSideIndexOffsets[0],
                varied2: variedSideIndex + variedSideIndexOffsets[1],
                staticDir: staticSideDirection,
                variedDir: variedSideDirection
            }
        }

        function calculateRectangles(nodes, head, totalRect, sidesData, rowData) {
            var i;
            var ii;
            var variedSidePart = [0, 0, 0, 0];
            var static1 = sidesData.static1;
            var static2 = sidesData.static2;
            var position = totalRect[static1];
            var dir = sidesData.staticDir;
            var side = sidesData.staticSide;
            var sum = rowData.sum;
            var rect;
            var delta;
            variedSidePart[sidesData.varied1] = totalRect[sidesData.varied1];
            variedSidePart[sidesData.varied2] = totalRect[sidesData.varied1] + sidesData.variedDir * rowData.side;
            for (i = head, ii = head + rowData.count; i < ii; ++i) {
                rect = variedSidePart.slice();
                rect[static1] = position;
                delta = _round(side * nodes[i].value / sum) || 0;
                sum -= nodes[i].value;
                side -= delta;
                position += dir * delta;
                rect[static2] = position;
                nodes[i].rect = rect
            }
            totalRect[sidesData.varied1] = variedSidePart[sidesData.varied2]
        }
    },
    /*!******************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/tree_map/api.js ***!
      \******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _tree_map = _interopRequireDefault(__webpack_require__( /*! ./tree_map.base */ 109));
        var _node = _interopRequireDefault(__webpack_require__( /*! ./node */ 190));
        var _extend2 = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var proto = _tree_map.default.prototype;
        var nodeProto = _node.default.prototype;
        proto._eventsMap.onNodesInitialized = {
            name: "nodesInitialized"
        };
        proto._eventsMap.onNodesRendering = {
            name: "nodesRendering"
        };
        proto._createProxyType = function() {
            var that = this;
            var nodes;
            Proxy.prototype = {
                constructor: Proxy,
                getParent: function() {
                    return nodes[this._id].parent.proxy || null
                },
                getChild: function(index) {
                    var _nodes = nodes[this._id].nodes;
                    return _nodes ? _nodes[index].proxy : null
                },
                getChildrenCount: function() {
                    var _nodes = nodes[this._id].nodes;
                    return _nodes ? _nodes.length : 0
                },
                getAllChildren: function() {
                    var _nodes = nodes[this._id].nodes;
                    var i;
                    var ii = _nodes && _nodes.length;
                    var list = [];
                    for (i = 0; i < ii; ++i) {
                        list.push(_nodes[i].proxy)
                    }
                    return list
                },
                getAllNodes: function() {
                    var list = [];
                    collectNodes(nodes[this._id], list);
                    return list
                },
                isLeaf: function() {
                    return !nodes[this._id].isNode()
                },
                isActive: function() {
                    return nodes[this._id].isActive()
                },
                value: function(arg) {
                    var node = nodes[this._id];
                    var result;
                    if (void 0 !== arg) {
                        updateValue(node, arg > 0 ? Number(arg) : 0);
                        change(node, ["TILING"]);
                        result = this
                    } else {
                        result = node.value
                    }
                    return result
                },
                label: function(arg) {
                    var node = nodes[this._id];
                    var result;
                    if (void 0 !== arg) {
                        node.customLabel = arg ? String(arg) : null;
                        change(node, ["LABELS"]);
                        result = this
                    } else {
                        result = node.customLabel || node.label
                    }
                    return result
                },
                customize: function(settings) {
                    var node = nodes[this._id];
                    if (settings) {
                        node._custom = node._custom || {};
                        (0, _extend2.extend)(true, node._custom, settings);
                        node._partialState = node._partialLabelState = null
                    }
                    change(node, ["TILES", "LABELS"]);
                    return this
                },
                resetCustomization: function() {
                    var node = nodes[this._id];
                    node._custom = node._partialState = node._partialLabelState = null;
                    change(node, ["TILES", "LABELS"]);
                    return this
                }
            };
            that._extendProxyType(Proxy.prototype);

            function Proxy(node) {
                var that = this;
                node.proxy = that;
                that._id = node._id;
                that.level = node.level;
                that.index = node.index;
                that.data = node.data
            }
            that._handlers.beginBuildNodes = function() {
                nodes = that._nodes;
                new Proxy(that._root)
            };
            that._handlers.buildNode = function(node) {
                new Proxy(node)
            };
            that._handlers.endBuildNodes = function() {
                that._eventTrigger("nodesInitialized", {
                    root: that._root.proxy
                })
            }
        };

        function change(node, codes) {
            var ctx = node.ctx;
            ctx.suspend();
            ctx.change(codes);
            ctx.resume()
        }

        function collectNodes(node, list) {
            var nodes = node.nodes;
            var i;
            var ii = nodes && nodes.length;
            for (i = 0; i < ii; ++i) {
                list.push(nodes[i].proxy);
                collectNodes(nodes[i], list)
            }
        }

        function updateValue(node, value) {
            var delta = value - node.value;
            while (node) {
                node.value += delta;
                node = node.parent
            }
        }
        proto._extendProxyType = _common.noop;
        var _resetNodes = proto._resetNodes;
        proto._resetNodes = function() {
            _resetNodes.call(this);
            this._eventTrigger("nodesRendering", {
                node: this._topNode.proxy
            })
        };
        var _updateStyles = nodeProto.updateStyles;
        nodeProto.updateStyles = function() {
            var that = this;
            _updateStyles.call(that);
            if (that._custom) {
                that._partialState = !that.ctx.forceReset && that._partialState || that.ctx.calculateState(that._custom);
                (0, _extend2.extend)(true, that.state, that._partialState)
            }
        };
        var _updateLabelStyle = nodeProto.updateLabelStyle;
        nodeProto.updateLabelStyle = function() {
            var that = this;
            var custom = that._custom;
            _updateLabelStyle.call(that);
            if (custom && custom.label) {
                that._partialLabelState = !that.ctx.forceReset && that._partialLabelState || calculatePartialLabelState(that, custom.label);
                that.labelState = (0, _extend2.extend)(true, {}, that.labelState, that._partialLabelState)
            }
        };

        function calculatePartialLabelState(node, settings) {
            var state = node.ctx.calculateLabelState(settings);
            if ("visible" in settings) {
                state.visible = !!settings.visible
            }
            return state
        }
        proto.getRootNode = function() {
            return this._root.proxy
        };
        proto.resetNodes = function() {
            var context = this._context;
            context.suspend();
            context.change(["NODES_CREATE"]);
            context.resume();
            return this
        }
    },
    /*!**************************************************************************!*\
      !*** ./artifacts/transpiled-npm/core/component_registrator_callbacks.js ***!
      \**************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _memorized_callbacks = _interopRequireDefault(__webpack_require__( /*! ./memorized_callbacks */ 197));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = new _memorized_callbacks.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************!*\
      !*** ./artifacts/transpiled-npm/data/array_query.js ***!
      \******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _class = _interopRequireDefault(__webpack_require__( /*! ../core/class */ 15));
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _data = __webpack_require__( /*! ../core/utils/data */ 20);
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);
        var _errors = _interopRequireDefault(__webpack_require__( /*! ./errors */ 38));
        var _utils = _interopRequireDefault(__webpack_require__( /*! ./utils */ 41));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var Iterator = _class.default.inherit({
            toArray: function() {
                var result = [];
                this.reset();
                while (this.next()) {
                    result.push(this.current())
                }
                return result
            },
            countable: function() {
                return false
            }
        });
        var ArrayIterator = Iterator.inherit({
            ctor: function(array) {
                this.array = array;
                this.index = -1
            },
            next: function() {
                if (this.index + 1 < this.array.length) {
                    this.index++;
                    return true
                }
                return false
            },
            current: function() {
                return this.array[this.index]
            },
            reset: function() {
                this.index = -1
            },
            toArray: function() {
                return this.array.slice(0)
            },
            countable: function() {
                return true
            },
            count: function() {
                return this.array.length
            }
        });
        var WrappedIterator = Iterator.inherit({
            ctor: function(iter) {
                this.iter = iter
            },
            next: function() {
                return this.iter.next()
            },
            current: function() {
                return this.iter.current()
            },
            reset: function() {
                return this.iter.reset()
            }
        });
        var MapIterator = WrappedIterator.inherit({
            ctor: function(iter, mapper) {
                this.callBase(iter);
                this.index = -1;
                this.mapper = mapper
            },
            current: function() {
                return this.mapper(this.callBase(), this.index)
            },
            next: function() {
                var hasNext = this.callBase();
                if (hasNext) {
                    this.index++
                }
                return hasNext
            }
        });
        var defaultCompare = function(xValue, yValue) {
            xValue = (0, _data.toComparable)(xValue);
            yValue = (0, _data.toComparable)(yValue);
            if (null === xValue && null !== yValue) {
                return -1
            }
            if (null !== xValue && null === yValue) {
                return 1
            }
            if (void 0 === xValue && void 0 !== yValue) {
                return 1
            }
            if (void 0 !== xValue && void 0 === yValue) {
                return -1
            }
            if (xValue < yValue) {
                return -1
            }
            if (xValue > yValue) {
                return 1
            }
            return 0
        };
        var SortIterator = Iterator.inherit({
            ctor: function(iter, getter, desc, compare) {
                if (!(iter instanceof MapIterator)) {
                    iter = new MapIterator(iter, this._wrap)
                }
                this.iter = iter;
                this.rules = [{
                    getter: getter,
                    desc: desc,
                    compare: compare
                }]
            },
            thenBy: function(getter, desc, compare) {
                var result = new SortIterator(this.sortedIter || this.iter, getter, desc, compare);
                if (!this.sortedIter) {
                    result.rules = this.rules.concat(result.rules)
                }
                return result
            },
            next: function() {
                this._ensureSorted();
                return this.sortedIter.next()
            },
            current: function() {
                this._ensureSorted();
                return this.sortedIter.current()
            },
            reset: function() {
                delete this.sortedIter
            },
            countable: function() {
                return this.sortedIter || this.iter.countable()
            },
            count: function() {
                if (this.sortedIter) {
                    return this.sortedIter.count()
                }
                return this.iter.count()
            },
            _ensureSorted: function() {
                var that = this;
                if (that.sortedIter) {
                    return
                }(0, _iterator.each)(that.rules, function() {
                    this.getter = (0, _data.compileGetter)(this.getter)
                });
                that.sortedIter = new MapIterator(new ArrayIterator(this.iter.toArray().sort(function(x, y) {
                    return that._compare(x, y)
                })), that._unwrap)
            },
            _wrap: function(record, index) {
                return {
                    index: index,
                    value: record
                }
            },
            _unwrap: function(wrappedItem) {
                return wrappedItem.value
            },
            _compare: function(x, y) {
                var xIndex = x.index;
                var yIndex = y.index;
                x = x.value;
                y = y.value;
                if (x === y) {
                    return xIndex - yIndex
                }
                for (var i = 0, rulesCount = this.rules.length; i < rulesCount; i++) {
                    var rule = this.rules[i];
                    var xValue = rule.getter(x);
                    var yValue = rule.getter(y);
                    var compare = rule.compare || defaultCompare;
                    var compareResult = compare(xValue, yValue);
                    if (compareResult) {
                        return rule.desc ? -compareResult : compareResult
                    }
                }
                return xIndex - yIndex
            }
        });
        var compileCriteria = function() {
            var compileGroup = function(crit) {
                var ops = [];
                var isConjunctiveOperator = false;
                var isConjunctiveNextOperator = false;
                (0, _iterator.each)(crit, function() {
                    if (Array.isArray(this) || (0, _type.isFunction)(this)) {
                        if (ops.length > 1 && isConjunctiveOperator !== isConjunctiveNextOperator) {
                            throw new _errors.default.errors.Error("E4019")
                        }
                        ops.push(compileCriteria(this));
                        isConjunctiveOperator = isConjunctiveNextOperator;
                        isConjunctiveNextOperator = true
                    } else {
                        isConjunctiveNextOperator = _utils.default.isConjunctiveOperator(this)
                    }
                });
                return function(d) {
                    var result = isConjunctiveOperator;
                    for (var i = 0; i < ops.length; i++) {
                        if (ops[i](d) !== isConjunctiveOperator) {
                            result = !isConjunctiveOperator;
                            break
                        }
                    }
                    return result
                }
            };
            var toString = function(value) {
                return (0, _type.isDefined)(value) ? value.toString() : ""
            };
            var compileBinary = function(crit) {
                crit = _utils.default.normalizeBinaryCriterion(crit);
                var getter = (0, _data.compileGetter)(crit[0]);
                var op = crit[1];
                var value = crit[2];
                value = (0, _data.toComparable)(value);
                switch (op.toLowerCase()) {
                    case "=":
                        return compileEquals(getter, value);
                    case "<>":
                        return compileEquals(getter, value, true);
                    case ">":
                        return function(obj) {
                            return (0, _data.toComparable)(getter(obj)) > value
                        };
                    case "<":
                        return function(obj) {
                            return (0, _data.toComparable)(getter(obj)) < value
                        };
                    case ">=":
                        return function(obj) {
                            return (0, _data.toComparable)(getter(obj)) >= value
                        };
                    case "<=":
                        return function(obj) {
                            return (0, _data.toComparable)(getter(obj)) <= value
                        };
                    case "startswith":
                        return function(obj) {
                            return 0 === (0, _data.toComparable)(toString(getter(obj))).indexOf(value)
                        };
                    case "endswith":
                        return function(obj) {
                            var getterValue = (0, _data.toComparable)(toString(getter(obj)));
                            var searchValue = toString(value);
                            if (getterValue.length < searchValue.length) {
                                return false
                            }
                            var index = getterValue.lastIndexOf(value);
                            return index !== -1 && index === getterValue.length - value.length
                        };
                    case "contains":
                        return function(obj) {
                            return (0, _data.toComparable)(toString(getter(obj))).indexOf(value) > -1
                        };
                    case "notcontains":
                        return function(obj) {
                            return (0, _data.toComparable)(toString(getter(obj))).indexOf(value) === -1
                        }
                }
                throw _errors.default.errors.Error("E4003", op)
            };

            function compileEquals(getter, value, negate) {
                return function(obj) {
                    obj = (0, _data.toComparable)(getter(obj));
                    var result = useStrictComparison(value) ? obj === value : obj == value;
                    if (negate) {
                        result = !result
                    }
                    return result
                }
            }

            function useStrictComparison(value) {
                return "" === value || 0 === value || false === value
            }

            function compileUnary(crit) {
                var op = crit[0];
                var criteria = compileCriteria(crit[1]);
                if ("!" === op) {
                    return function(obj) {
                        return !criteria(obj)
                    }
                }
                throw _errors.default.errors.Error("E4003", op)
            }
            return function(crit) {
                if ((0, _type.isFunction)(crit)) {
                    return crit
                }
                if (_utils.default.isGroupCriterion(crit)) {
                    return compileGroup(crit)
                }
                if (_utils.default.isUnaryOperation(crit)) {
                    return compileUnary(crit)
                }
                return compileBinary(crit)
            }
        }();
        var FilterIterator = WrappedIterator.inherit({
            ctor: function(iter, criteria) {
                this.callBase(iter);
                this.criteria = compileCriteria(criteria)
            },
            next: function() {
                while (this.iter.next()) {
                    if (this.criteria(this.current())) {
                        return true
                    }
                }
                return false
            }
        });
        var GroupIterator = Iterator.inherit({
            ctor: function(iter, getter) {
                this.iter = iter;
                this.getter = getter
            },
            next: function() {
                this._ensureGrouped();
                return this.groupedIter.next()
            },
            current: function() {
                this._ensureGrouped();
                return this.groupedIter.current()
            },
            reset: function() {
                delete this.groupedIter
            },
            countable: function() {
                return !!this.groupedIter
            },
            count: function() {
                return this.groupedIter.count()
            },
            _ensureGrouped: function() {
                if (this.groupedIter) {
                    return
                }
                var hash = {};
                var keys = [];
                var iter = this.iter;
                var getter = (0, _data.compileGetter)(this.getter);
                iter.reset();
                while (iter.next()) {
                    var current = iter.current();
                    var key = getter(current);
                    if (key in hash) {
                        hash[key].push(current)
                    } else {
                        hash[key] = [current];
                        keys.push(key)
                    }
                }
                this.groupedIter = new ArrayIterator((0, _iterator.map)(keys, function(key) {
                    return {
                        key: key,
                        items: hash[key]
                    }
                }))
            }
        });
        var SelectIterator = WrappedIterator.inherit({
            ctor: function(iter, getter) {
                this.callBase(iter);
                this.getter = (0, _data.compileGetter)(getter)
            },
            current: function() {
                return this.getter(this.callBase())
            },
            countable: function() {
                return this.iter.countable()
            },
            count: function() {
                return this.iter.count()
            }
        });
        var SliceIterator = WrappedIterator.inherit({
            ctor: function(iter, skip, take) {
                this.callBase(iter);
                this.skip = Math.max(0, skip);
                this.take = Math.max(0, take);
                this.pos = 0
            },
            next: function() {
                if (this.pos >= this.skip + this.take) {
                    return false
                }
                while (this.pos < this.skip && this.iter.next()) {
                    this.pos++
                }
                this.pos++;
                return this.iter.next()
            },
            reset: function() {
                this.callBase();
                this.pos = 0
            },
            countable: function() {
                return this.iter.countable()
            },
            count: function() {
                return Math.min(this.iter.count() - this.skip, this.take)
            }
        });
        var arrayQueryImpl = function arrayQueryImpl(iter, queryOptions) {
            queryOptions = queryOptions || {};
            if (!(iter instanceof Iterator)) {
                iter = new ArrayIterator(iter)
            }
            var handleError = function(error) {
                var handler = queryOptions.errorHandler;
                if (handler) {
                    handler(error)
                }
                _errors.default._errorHandler(error)
            };
            var aggregateCore = function(aggregator) {
                var d = (new _deferred.Deferred).fail(handleError);
                var seed;
                var step = aggregator.step;
                var finalize = aggregator.finalize;
                try {
                    iter.reset();
                    if ("seed" in aggregator) {
                        seed = aggregator.seed
                    } else {
                        seed = iter.next() ? iter.current() : NaN
                    }
                    var accumulator = seed;
                    while (iter.next()) {
                        accumulator = step(accumulator, iter.current())
                    }
                    d.resolve(finalize ? finalize(accumulator) : accumulator)
                } catch (x) {
                    d.reject(x)
                }
                return d.promise()
            };
            var aggregate = function(seed, step, finalize) {
                if (arguments.length < 2) {
                    return aggregateCore({
                        step: arguments[0]
                    })
                }
                return aggregateCore({
                    seed: seed,
                    step: step,
                    finalize: finalize
                })
            };
            var standardAggregate = function(name) {
                return aggregateCore(_utils.default.aggregators[name])
            };
            var select = function(getter) {
                if (!(0, _type.isFunction)(getter) && !Array.isArray(getter)) {
                    getter = [].slice.call(arguments)
                }
                return chainQuery(new SelectIterator(iter, getter))
            };
            var selectProp = function(name) {
                return select((0, _data.compileGetter)(name))
            };

            function chainQuery(iter) {
                return arrayQueryImpl(iter, queryOptions)
            }
            return {
                toArray: function() {
                    return iter.toArray()
                },
                enumerate: function() {
                    var d = (new _deferred.Deferred).fail(handleError);
                    try {
                        d.resolve(iter.toArray())
                    } catch (x) {
                        d.reject(x)
                    }
                    return d.promise()
                },
                sortBy: function(getter, desc, compare) {
                    return chainQuery(new SortIterator(iter, getter, desc, compare))
                },
                thenBy: function(getter, desc, compare) {
                    if (iter instanceof SortIterator) {
                        return chainQuery(iter.thenBy(getter, desc, compare))
                    }
                    throw _errors.default.errors.Error("E4004")
                },
                filter: function(criteria) {
                    if (!Array.isArray(criteria)) {
                        criteria = [].slice.call(arguments)
                    }
                    return chainQuery(new FilterIterator(iter, criteria))
                },
                slice: function(skip, take) {
                    if (void 0 === take) {
                        take = Number.MAX_VALUE
                    }
                    return chainQuery(new SliceIterator(iter, skip, take))
                },
                select: select,
                groupBy: function(getter) {
                    return chainQuery(new GroupIterator(iter, getter))
                },
                aggregate: aggregate,
                count: function() {
                    if (iter.countable()) {
                        var d = (new _deferred.Deferred).fail(handleError);
                        try {
                            d.resolve(iter.count())
                        } catch (x) {
                            d.reject(x)
                        }
                        return d.promise()
                    }
                    return standardAggregate("count")
                },
                sum: function(getter) {
                    if (getter) {
                        return selectProp(getter).sum()
                    }
                    return standardAggregate("sum")
                },
                min: function(getter) {
                    if (getter) {
                        return selectProp(getter).min()
                    }
                    return standardAggregate("min")
                },
                max: function(getter) {
                    if (getter) {
                        return selectProp(getter).max()
                    }
                    return standardAggregate("max")
                },
                avg: function(getter) {
                    if (getter) {
                        return selectProp(getter).avg()
                    }
                    return standardAggregate("avg")
                }
            }
        };
        var _default = arrayQueryImpl;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************!*\
      !*** ./artifacts/transpiled-npm/events/pointer/base.js ***!
      \*********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _index = __webpack_require__( /*! ../utils/index */ 8);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var POINTER_EVENTS_NAMESPACE = "dxPointerEvents";
        var BaseStrategy = _class.default.inherit({
            ctor: function(eventName, originalEvents) {
                this._eventName = eventName;
                this._originalEvents = (0, _index.addNamespace)(originalEvents, POINTER_EVENTS_NAMESPACE);
                this._handlerCount = 0;
                this.noBubble = this._isNoBubble()
            },
            _isNoBubble: function() {
                var eventName = this._eventName;
                return "dxpointerenter" === eventName || "dxpointerleave" === eventName
            },
            _handler: function(e) {
                var delegateTarget = this._getDelegateTarget(e);
                return this._fireEvent({
                    type: this._eventName,
                    pointerType: e.pointerType || (0, _index.eventSource)(e),
                    originalEvent: e,
                    delegateTarget: delegateTarget,
                    timeStamp: _browser.default.mozilla ? (new Date).getTime() : e.timeStamp
                })
            },
            _getDelegateTarget: function(e) {
                var delegateTarget;
                if (this.noBubble) {
                    delegateTarget = e.delegateTarget
                }
                return delegateTarget
            },
            _fireEvent: function(args) {
                return (0, _index.fireEvent)(args)
            },
            _setSelector: function(handleObj) {
                this._selector = this.noBubble && handleObj ? handleObj.selector : null
            },
            _getSelector: function() {
                return this._selector
            },
            setup: function() {
                return true
            },
            add: function(element, handleObj) {
                if (this._handlerCount <= 0 || this.noBubble) {
                    element = this.noBubble ? element : _dom_adapter.default.getDocument();
                    this._setSelector(handleObj);
                    var that = this;
                    _events_engine.default.on(element, this._originalEvents, this._getSelector(), function(e) {
                        that._handler(e)
                    })
                }
                if (!this.noBubble) {
                    this._handlerCount++
                }
            },
            remove: function(handleObj) {
                this._setSelector(handleObj);
                if (!this.noBubble) {
                    this._handlerCount--
                }
            },
            teardown: function(element) {
                if (this._handlerCount && !this.noBubble) {
                    return
                }
                element = this.noBubble ? element : _dom_adapter.default.getDocument();
                if (this._originalEvents !== "." + POINTER_EVENTS_NAMESPACE) {
                    _events_engine.default.off(element, this._originalEvents, this._getSelector())
                }
            },
            dispose: function(element) {
                element = this.noBubble ? element : _dom_adapter.default.getDocument();
                _events_engine.default.off(element, this._originalEvents)
            }
        });
        var _default = BaseStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/widget/swatch_container.js ***!
      \****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _view_port = __webpack_require__( /*! ../../core/utils/view_port */ 80);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var SWATCH_CONTAINER_CLASS_PREFIX = "dx-swatch-";
        var getSwatchContainer = function(element) {
            var $element = (0, _renderer.default)(element);
            var swatchContainer = $element.closest('[class^="'.concat(SWATCH_CONTAINER_CLASS_PREFIX, '"], [class*=" ').concat(SWATCH_CONTAINER_CLASS_PREFIX, '"]'));
            var viewport = (0, _view_port.value)();
            if (!swatchContainer.length) {
                return viewport
            }
            var swatchClassRegex = new RegExp("(\\s|^)(".concat(SWATCH_CONTAINER_CLASS_PREFIX, ".*?)(\\s|$)"));
            var swatchClass = swatchContainer[0].className.match(swatchClassRegex)[2];
            var viewportSwatchContainer = viewport.children("." + swatchClass);
            if (!viewportSwatchContainer.length) {
                viewportSwatchContainer = (0, _renderer.default)("<div>").addClass(swatchClass).appendTo(viewport)
            }
            return viewportSwatchContainer
        };
        var _default = {
            getSwatchContainer: getSwatchContainer
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************************!*\
      !*** ./artifacts/transpiled-npm/data/odata/query_adapter.js ***!
      \**************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.odata = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _config = _interopRequireDefault(__webpack_require__( /*! ../../core/config */ 31));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _query_adapters = _interopRequireDefault(__webpack_require__( /*! ../query_adapters */ 199));
        var _utils = __webpack_require__( /*! ./utils */ 101);
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../errors */ 38));
        var _utils2 = _interopRequireDefault(__webpack_require__( /*! ../utils */ 41));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DEFAULT_PROTOCOL_VERSION = 2;
        var STRING_FUNCTIONS = ["contains", "notcontains", "startswith", "endswith"];
        var compileCriteria = function() {
            var protocolVersion;
            var forceLowerCase;
            var fieldTypes;
            var createBinaryOperationFormatter = function(op) {
                return function(prop, val) {
                    return "".concat(prop, " ").concat(op, " ").concat(val)
                }
            };
            var createStringFuncFormatter = function(op, reverse) {
                return function(prop, val) {
                    var bag = [op, "("];
                    if (forceLowerCase) {
                        prop = prop.indexOf("tolower(") === -1 ? "tolower(".concat(prop, ")") : prop;
                        val = val.toLowerCase()
                    }
                    if (reverse) {
                        bag.push(val, ",", prop)
                    } else {
                        bag.push(prop, ",", val)
                    }
                    bag.push(")");
                    return bag.join("")
                }
            };
            var isStringFunction = function(name) {
                return STRING_FUNCTIONS.some(function(funcName) {
                    return funcName === name
                })
            };
            var formatters = {
                "=": createBinaryOperationFormatter("eq"),
                "<>": createBinaryOperationFormatter("ne"),
                ">": createBinaryOperationFormatter("gt"),
                ">=": createBinaryOperationFormatter("ge"),
                "<": createBinaryOperationFormatter("lt"),
                "<=": createBinaryOperationFormatter("le"),
                startswith: createStringFuncFormatter("startswith"),
                endswith: createStringFuncFormatter("endswith")
            };
            var formattersV2 = (0, _extend.extend)({}, formatters, {
                contains: createStringFuncFormatter("substringof", true),
                notcontains: createStringFuncFormatter("not substringof", true)
            });
            var formattersV4 = (0, _extend.extend)({}, formatters, {
                contains: createStringFuncFormatter("contains"),
                notcontains: createStringFuncFormatter("not contains")
            });
            var compileBinary = function(criteria) {
                var _fieldTypes;
                criteria = _utils2.default.normalizeBinaryCriterion(criteria);
                var op = criteria[1];
                var fieldName = criteria[0];
                var fieldType = fieldTypes && fieldTypes[fieldName];
                if (fieldType && isStringFunction(op) && "String" !== fieldType) {
                    throw new _errors.default.errors.Error("E4024", op, fieldName, fieldType)
                }
                var formatters = 4 === protocolVersion ? formattersV4 : formattersV2;
                var formatter = formatters[op.toLowerCase()];
                if (!formatter) {
                    throw _errors.default.errors.Error("E4003", op)
                }
                var value = criteria[2];
                if (null !== (_fieldTypes = fieldTypes) && void 0 !== _fieldTypes && _fieldTypes[fieldName]) {
                    value = (0, _utils.convertPrimitiveValue)(fieldTypes[fieldName], value)
                }
                return formatter((0, _utils.serializePropName)(fieldName), (0, _utils.serializeValue)(value, protocolVersion))
            };
            var compileUnary = function(criteria) {
                var op = criteria[0];
                var crit = compileCore(criteria[1]);
                if ("!" === op) {
                    return "not (".concat(crit, ")")
                }
                throw _errors.default.errors.Error("E4003", op)
            };
            var compileGroup = function(criteria) {
                var bag = [];
                var groupOperator;
                var nextGroupOperator;
                (0, _iterator.each)(criteria, function(index, criterion) {
                    if (Array.isArray(criterion)) {
                        if (bag.length > 1 && groupOperator !== nextGroupOperator) {
                            throw new _errors.default.errors.Error("E4019")
                        }
                        bag.push("(".concat(compileCore(criterion), ")"));
                        groupOperator = nextGroupOperator;
                        nextGroupOperator = "and"
                    } else {
                        nextGroupOperator = _utils2.default.isConjunctiveOperator(this) ? "and" : "or"
                    }
                });
                return bag.join(" ".concat(groupOperator, " "))
            };
            var compileCore = function(criteria) {
                if (Array.isArray(criteria[0])) {
                    return compileGroup(criteria)
                }
                if (_utils2.default.isUnaryOperation(criteria)) {
                    return compileUnary(criteria)
                }
                return compileBinary(criteria)
            };
            return function(criteria, version, types, filterToLower) {
                fieldTypes = types;
                forceLowerCase = null !== filterToLower && void 0 !== filterToLower ? filterToLower : (0, _config.default)().oDataFilterToLower;
                protocolVersion = version;
                return compileCore(criteria)
            }
        }();
        var createODataQueryAdapter = function(queryOptions) {
            var _sorting = [];
            var _criteria = [];
            var _expand = queryOptions.expand;
            var _select;
            var _skip;
            var _take;
            var _countQuery;
            var _oDataVersion = queryOptions.version || DEFAULT_PROTOCOL_VERSION;
            var hasSlice = function() {
                return _skip || void 0 !== _take
            };
            var hasFunction = function hasFunction(criterion) {
                for (var i = 0; i < criterion.length; i++) {
                    if ((0, _type.isFunction)(criterion[i])) {
                        return true
                    }
                    if (Array.isArray(criterion[i]) && hasFunction(criterion[i])) {
                        return true
                    }
                }
                return false
            };
            var requestData = function() {
                var result = {};
                if (!_countQuery) {
                    if (_sorting.length) {
                        result.$orderby = _sorting.join(",")
                    }
                    if (_skip) {
                        result.$skip = _skip
                    }
                    if (void 0 !== _take) {
                        result.$top = _take
                    }
                    result.$select = (0, _utils.generateSelect)(_oDataVersion, _select) || void 0;
                    result.$expand = (0, _utils.generateExpand)(_oDataVersion, _expand, _select) || void 0
                }
                if (_criteria.length) {
                    var criteria = _criteria.length < 2 ? _criteria[0] : _criteria;
                    var fieldTypes = null === queryOptions || void 0 === queryOptions ? void 0 : queryOptions.fieldTypes;
                    var filterToLower = null === queryOptions || void 0 === queryOptions ? void 0 : queryOptions.filterToLower;
                    result.$filter = compileCriteria(criteria, _oDataVersion, fieldTypes, filterToLower)
                }
                if (_countQuery) {
                    result.$top = 0
                }
                if (queryOptions.requireTotalCount || _countQuery) {
                    if (4 !== _oDataVersion) {
                        result.$inlinecount = "allpages"
                    } else {
                        result.$count = "true"
                    }
                }
                return result
            };
            var tryLiftSelect = function(tasks) {
                var selectIndex = -1;
                for (var i = 0; i < tasks.length; i++) {
                    if ("select" === tasks[i].name) {
                        selectIndex = i;
                        break
                    }
                }
                if (selectIndex < 0 || !(0, _type.isFunction)(tasks[selectIndex].args[0])) {
                    return
                }
                var nextTask = tasks[1 + selectIndex];
                if (!nextTask || "slice" !== nextTask.name) {
                    return
                }
                tasks[1 + selectIndex] = tasks[selectIndex];
                tasks[selectIndex] = nextTask
            };
            return {
                optimize: tryLiftSelect,
                exec: function(url) {
                    return (0, _utils.sendRequest)(_oDataVersion, {
                        url: url,
                        params: (0, _extend.extend)(requestData(), null === queryOptions || void 0 === queryOptions ? void 0 : queryOptions.params)
                    }, {
                        beforeSend: queryOptions.beforeSend,
                        jsonp: queryOptions.jsonp,
                        withCredentials: queryOptions.withCredentials,
                        countOnly: _countQuery,
                        deserializeDates: queryOptions.deserializeDates,
                        fieldTypes: queryOptions.fieldTypes,
                        isPaged: isFinite(_take)
                    })
                },
                multiSort: function(args) {
                    var rules;
                    if (hasSlice()) {
                        return false
                    }
                    for (var i = 0; i < args.length; i++) {
                        var getter = args[i][0];
                        var desc = !!args[i][1];
                        var rule = void 0;
                        if ("string" !== typeof getter) {
                            return false
                        }
                        rule = (0, _utils.serializePropName)(getter);
                        if (desc) {
                            rule += " desc"
                        }
                        rules = rules || [];
                        rules.push(rule)
                    }
                    _sorting = rules
                },
                slice: function(skipCount, takeCount) {
                    if (hasSlice()) {
                        return false
                    }
                    _skip = skipCount;
                    _take = takeCount
                },
                filter: function(criterion) {
                    if (hasSlice()) {
                        return false
                    }
                    if (!Array.isArray(criterion)) {
                        criterion = [].slice.call(arguments)
                    }
                    if (hasFunction(criterion)) {
                        return false
                    }
                    if (_criteria.length) {
                        _criteria.push("and")
                    }
                    _criteria.push(criterion)
                },
                select: function(expr) {
                    if (_select || (0, _type.isFunction)(expr)) {
                        return false
                    }
                    if (!Array.isArray(expr)) {
                        expr = [].slice.call(arguments)
                    }
                    _select = expr
                },
                count: function() {
                    return _countQuery = true
                }
            }
        };
        _query_adapters.default.odata = createODataQueryAdapter;
        var odata = createODataQueryAdapter;
        exports.odata = odata
    },
    /*!**************************************************************!*\
      !*** ./artifacts/transpiled-npm/events/gesture/swipeable.js ***!
      \**************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _swipe = __webpack_require__( /*! ../swipe */ 194);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _dom_component = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_component */ 67));
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _index = __webpack_require__( /*! ../utils/index */ 8);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _public_component = __webpack_require__( /*! ../../core/utils/public_component */ 147);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DX_SWIPEABLE = "dxSwipeable";
        var SWIPEABLE_CLASS = "dx-swipeable";
        var ACTION_TO_EVENT_MAP = {
            onStart: _swipe.start,
            onUpdated: _swipe.swipe,
            onEnd: _swipe.end,
            onCancel: "dxswipecancel"
        };
        var Swipeable = _dom_component.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    elastic: true,
                    immediate: false,
                    direction: "horizontal",
                    itemSizeFunc: null,
                    onStart: null,
                    onUpdated: null,
                    onEnd: null,
                    onCancel: null
                })
            },
            _render: function() {
                this.callBase();
                this.$element().addClass(SWIPEABLE_CLASS);
                this._attachEventHandlers()
            },
            _attachEventHandlers: function() {
                this._detachEventHandlers();
                if (this.option("disabled")) {
                    return
                }
                var NAME = this.NAME;
                this._createEventData();
                (0, _iterator.each)(ACTION_TO_EVENT_MAP, function(actionName, eventName) {
                    var action = this._createActionByOption(actionName, {
                        context: this
                    });
                    eventName = (0, _index.addNamespace)(eventName, NAME);
                    _events_engine.default.on(this.$element(), eventName, this._eventData, function(e) {
                        return action({
                            event: e
                        })
                    })
                }.bind(this))
            },
            _createEventData: function() {
                this._eventData = {
                    elastic: this.option("elastic"),
                    itemSizeFunc: this.option("itemSizeFunc"),
                    direction: this.option("direction"),
                    immediate: this.option("immediate")
                }
            },
            _detachEventHandlers: function() {
                _events_engine.default.off(this.$element(), "." + DX_SWIPEABLE)
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "disabled":
                    case "onStart":
                    case "onUpdated":
                    case "onEnd":
                    case "onCancel":
                    case "elastic":
                    case "immediate":
                    case "itemSizeFunc":
                    case "direction":
                        this._detachEventHandlers();
                        this._attachEventHandlers();
                        break;
                    case "rtlEnabled":
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _useTemplates: function() {
                return false
            }
        });
        (0, _public_component.name)(Swipeable, DX_SWIPEABLE);
        var _default = Swipeable;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/core/version.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _default = "20.2.7";
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/localization/ldml/date.format.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getFormat = void 0;
        var _number = _interopRequireDefault(__webpack_require__( /*! ../number */ 47));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ARABIC_COMMA = "\u060c";
        var FORMAT_SEPARATORS = " .,:;/\\<>()-[]" + ARABIC_COMMA;
        var AM_PM_PATTERN = ". m.";
        var checkDigit = function(char) {
            var code = char && _number.default.convertDigits(char, false).charCodeAt(0);
            var zeroCode = _number.default.convertDigits("0", false).charCodeAt(0);
            return zeroCode <= code && code < zeroCode + 10
        };
        var checkPatternContinue = function(text, patterns, index, isDigit) {
            var char = text[index];
            var nextChar = text[index + 1];
            if (!isDigit) {
                if ("." === char || " " === char && text.slice(index - 1, index + 3) === AM_PM_PATTERN) {
                    return true
                }
                if ("-" === char && !checkDigit(nextChar)) {
                    return true
                }
            }
            var isDigitChanged = isDigit && patterns.some(function(pattern) {
                return text[index] !== pattern[index]
            });
            return FORMAT_SEPARATORS.indexOf(char) < 0 && isDigit === checkDigit(char) && (!isDigit || isDigitChanged)
        };
        var getPatternStartIndex = function(defaultPattern, index) {
            if (!checkDigit(defaultPattern[index])) {
                while (index > 0 && !checkDigit(defaultPattern[index - 1]) && ("." === defaultPattern[index - 1] || FORMAT_SEPARATORS.indexOf(defaultPattern[index - 1]) < 0)) {
                    index--
                }
            }
            return index
        };
        var getDifference = function(defaultPattern, patterns, processedIndexes, isDigit) {
            var i = 0;
            var result = [];
            var patternsFilter = function(pattern) {
                return defaultPattern[i] !== pattern[i] && (void 0 === isDigit || checkDigit(defaultPattern[i]) === isDigit)
            };
            if (!Array.isArray(patterns)) {
                patterns = [patterns]
            }
            for (i = 0; i < defaultPattern.length; i++) {
                if (processedIndexes.indexOf(i) < 0 && patterns.filter(patternsFilter).length) {
                    i = getPatternStartIndex(defaultPattern, i);
                    do {
                        isDigit = checkDigit(defaultPattern[i]);
                        if (!result.length && !isDigit && checkDigit(patterns[0][i])) {
                            break
                        }
                        result.push(i);
                        processedIndexes.unshift(i);
                        i++
                    } while (defaultPattern[i] && checkPatternContinue(defaultPattern, patterns, i, isDigit));
                    break
                }
            }
            if (1 === result.length && ("0" === defaultPattern[processedIndexes[0] - 1] || "\u0660" === defaultPattern[processedIndexes[0] - 1])) {
                processedIndexes.unshift(processedIndexes[0] - 1)
            }
            return result
        };
        var replaceCharsCore = function(pattern, indexes, char, patternPositions) {
            var baseCharIndex = indexes[0];
            var patternIndex = baseCharIndex < patternPositions.length ? patternPositions[baseCharIndex] : baseCharIndex;
            indexes.forEach(function(_, index) {
                pattern = pattern.substr(0, patternIndex + index) + (char.length > 1 ? char[index] : char) + pattern.substr(patternIndex + index + 1)
            });
            if (1 === indexes.length) {
                pattern = pattern.replace("0" + char, char + char);
                pattern = pattern.replace("\u0660" + char, char + char)
            }
            return pattern
        };
        var replaceChars = function(pattern, indexes, char, patternPositions) {
            var i;
            var index;
            var patternIndex;
            if (!checkDigit(pattern[indexes[0]] || "0")) {
                var letterCount = Math.max(indexes.length <= 3 ? 3 : 4, char.length);
                while (indexes.length > letterCount) {
                    index = indexes.pop();
                    patternIndex = patternPositions[index];
                    patternPositions[index] = -1;
                    for (i = index + 1; i < patternPositions.length; i++) {
                        patternPositions[i]--
                    }
                    pattern = pattern.substr(0, patternIndex) + pattern.substr(patternIndex + 1)
                }
                index = indexes[indexes.length - 1] + 1, patternIndex = index < patternPositions.length ? patternPositions[index] : index;
                while (indexes.length < letterCount) {
                    indexes.push(indexes[indexes.length - 1] + 1);
                    for (i = index; i < patternPositions.length; i++) {
                        patternPositions[i]++
                    }
                    pattern = pattern.substr(0, patternIndex) + " " + pattern.substr(patternIndex)
                }
            }
            pattern = replaceCharsCore(pattern, indexes, char, patternPositions);
            return pattern
        };
        var formatValue = function(value, formatter) {
            if (Array.isArray(value)) {
                return value.map(function(value) {
                    return (formatter(value) || "").toString()
                })
            }
            return (formatter(value) || "").toString()
        };
        var ESCAPE_CHARS_REGEXP = /[a-zA-Z]/g;
        var escapeChars = function(pattern, defaultPattern, processedIndexes, patternPositions) {
            var escapeIndexes = defaultPattern.split("").map(function(char, index) {
                if (processedIndexes.indexOf(index) < 0 && (char.match(ESCAPE_CHARS_REGEXP) || "'" === char)) {
                    return patternPositions[index]
                }
                return -1
            });
            pattern = pattern.split("").map(function(char, index) {
                var result = char;
                var isCurrentCharEscaped = escapeIndexes.indexOf(index) >= 0;
                var isPrevCharEscaped = index > 0 && escapeIndexes.indexOf(index - 1) >= 0;
                var isNextCharEscaped = escapeIndexes.indexOf(index + 1) >= 0;
                if (isCurrentCharEscaped) {
                    if (!isPrevCharEscaped) {
                        result = "'" + result
                    }
                    if (!isNextCharEscaped) {
                        result += "'"
                    }
                }
                return result
            }).join("");
            return pattern
        };
        var getFormat = function(formatter) {
            var processedIndexes = [];
            var defaultPattern = formatValue(new Date(2009, 8, 8, 6, 5, 4), formatter);
            var patternPositions = defaultPattern.split("").map(function(_, index) {
                return index
            });
            var result = defaultPattern;
            var replacedPatterns = {};
            var datePatterns = [{
                date: new Date(2009, 8, 8, 6, 5, 4, 111),
                pattern: "S"
            }, {
                date: new Date(2009, 8, 8, 6, 5, 2),
                pattern: "s"
            }, {
                date: new Date(2009, 8, 8, 6, 2, 4),
                pattern: "m"
            }, {
                date: new Date(2009, 8, 8, 18, 5, 4),
                pattern: "H",
                isDigit: true
            }, {
                date: new Date(2009, 8, 8, 2, 5, 4),
                pattern: "h",
                isDigit: true
            }, {
                date: new Date(2009, 8, 8, 18, 5, 4),
                pattern: "a",
                isDigit: false
            }, {
                date: new Date(2009, 8, 1, 6, 5, 4),
                pattern: "d"
            }, {
                date: [new Date(2009, 8, 2, 6, 5, 4), new Date(2009, 8, 3, 6, 5, 4), new Date(2009, 8, 4, 6, 5, 4)],
                pattern: "E"
            }, {
                date: new Date(2009, 9, 6, 6, 5, 4),
                pattern: "M"
            }, {
                date: new Date(1998, 8, 8, 6, 5, 4),
                pattern: "y"
            }];
            if (!result) {
                return
            }
            datePatterns.forEach(function(test) {
                var diff = getDifference(defaultPattern, formatValue(test.date, formatter), processedIndexes, test.isDigit);
                var pattern = "M" === test.pattern && !replacedPatterns.d ? "L" : test.pattern;
                result = replaceChars(result, diff, pattern, patternPositions);
                replacedPatterns[pattern] = diff.length
            });
            result = escapeChars(result, defaultPattern, processedIndexes, patternPositions);
            if (processedIndexes.length) {
                return result
            }
        };
        exports.getFormat = getFormat
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/core/templates/template_engine_registry.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.registerTemplateEngine = registerTemplateEngine;
        exports.setTemplateEngine = setTemplateEngine;
        exports.getCurrentTemplateEngine = getCurrentTemplateEngine;
        var _type = __webpack_require__( /*! ../utils/type */ 1);
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../errors */ 25));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var templateEngines = {};
        var currentTemplateEngine;

        function registerTemplateEngine(name, templateEngine) {
            templateEngines[name] = templateEngine
        }

        function setTemplateEngine(templateEngine) {
            if ((0, _type.isString)(templateEngine)) {
                currentTemplateEngine = templateEngines[templateEngine];
                if (!currentTemplateEngine) {
                    throw _errors.default.Error("E0020", templateEngine)
                }
            } else {
                currentTemplateEngine = templateEngine
            }
        }

        function getCurrentTemplateEngine() {
            return currentTemplateEngine
        }
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/events/gesture/emitter.gesture.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _style = __webpack_require__( /*! ../../core/utils/style */ 99);
        var _call_once = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/call_once */ 85));
        var _dom = __webpack_require__( /*! ../../core/utils/dom */ 33);
        var _ready_callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/ready_callbacks */ 49));
        var _math = __webpack_require__( /*! ../../core/utils/math */ 29);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _index = __webpack_require__( /*! ../utils/index */ 8);
        var _emitter = _interopRequireDefault(__webpack_require__( /*! ../core/emitter */ 132));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ready = _ready_callbacks.default.add;
        var abs = Math.abs;
        var SLEEP = 0;
        var INITED = 1;
        var STARTED = 2;
        var TOUCH_BOUNDARY = 10;
        var IMMEDIATE_TOUCH_BOUNDARY = 0;
        var IMMEDIATE_TIMEOUT = 180;
        var supportPointerEvents = function() {
            return (0, _style.styleProp)("pointer-events")
        };
        var setGestureCover = (0, _call_once.default)(function() {
            var GESTURE_COVER_CLASS = "dx-gesture-cover";
            var isDesktop = "desktop" === _devices.default.real().deviceType;
            if (!supportPointerEvents() || !isDesktop) {
                return _common.noop
            }
            var $cover = (0, _renderer.default)("<div>").addClass(GESTURE_COVER_CLASS).css("pointerEvents", "none");
            _events_engine.default.subscribeGlobal($cover, "dxmousewheel", function(e) {
                e.preventDefault()
            });
            ready(function() {
                $cover.appendTo("body")
            });
            return function(toggle, cursor) {
                $cover.css("pointerEvents", toggle ? "all" : "none");
                toggle && $cover.css("cursor", cursor)
            }
        });
        var gestureCover = function(toggle, cursor) {
            var gestureCoverStrategy = setGestureCover();
            gestureCoverStrategy(toggle, cursor)
        };
        var GestureEmitter = _emitter.default.inherit({
            gesture: true,
            configure: function(data) {
                this.getElement().css("msTouchAction", data.immediate ? "pinch-zoom" : "");
                this.callBase(data)
            },
            allowInterruptionByMouseWheel: function() {
                return this._stage !== STARTED
            },
            getDirection: function() {
                return this.direction
            },
            _cancel: function() {
                this.callBase.apply(this, arguments);
                this._toggleGestureCover(false);
                this._stage = SLEEP
            },
            start: function(e) {
                if (e._needSkipEvent || (0, _index.needSkipEvent)(e)) {
                    this._cancel(e);
                    return
                }
                this._startEvent = (0, _index.createEvent)(e);
                this._startEventData = (0, _index.eventData)(e);
                this._stage = INITED;
                this._init(e);
                this._setupImmediateTimer()
            },
            _setupImmediateTimer: function() {
                clearTimeout(this._immediateTimer);
                this._immediateAccepted = false;
                if (!this.immediate) {
                    return
                }
                this._immediateTimer = setTimeout(function() {
                    this._immediateAccepted = true
                }.bind(this), IMMEDIATE_TIMEOUT)
            },
            move: function(e) {
                if (this._stage === INITED && this._directionConfirmed(e)) {
                    this._stage = STARTED;
                    this._resetActiveElement();
                    this._toggleGestureCover(true);
                    this._clearSelection(e);
                    this._adjustStartEvent(e);
                    this._start(this._startEvent);
                    if (this._stage === SLEEP) {
                        return
                    }
                    this._requestAccept(e);
                    this._move(e);
                    this._forgetAccept()
                } else {
                    if (this._stage === STARTED) {
                        this._clearSelection(e);
                        this._move(e)
                    }
                }
            },
            _directionConfirmed: function(e) {
                var touchBoundary = this._getTouchBoundary(e);
                var delta = (0, _index.eventDelta)(this._startEventData, (0, _index.eventData)(e));
                var deltaX = abs(delta.x);
                var deltaY = abs(delta.y);
                var horizontalMove = this._validateMove(touchBoundary, deltaX, deltaY);
                var verticalMove = this._validateMove(touchBoundary, deltaY, deltaX);
                var direction = this.getDirection(e);
                var bothAccepted = "both" === direction && (horizontalMove || verticalMove);
                var horizontalAccepted = "horizontal" === direction && horizontalMove;
                var verticalAccepted = "vertical" === direction && verticalMove;
                return bothAccepted || horizontalAccepted || verticalAccepted || this._immediateAccepted
            },
            _validateMove: function(touchBoundary, mainAxis, crossAxis) {
                return mainAxis && mainAxis >= touchBoundary && (this.immediate ? mainAxis >= crossAxis : true)
            },
            _getTouchBoundary: function(e) {
                return this.immediate || (0, _index.isDxMouseWheelEvent)(e) ? IMMEDIATE_TOUCH_BOUNDARY : TOUCH_BOUNDARY
            },
            _adjustStartEvent: function(e) {
                var touchBoundary = this._getTouchBoundary(e);
                var delta = (0, _index.eventDelta)(this._startEventData, (0, _index.eventData)(e));
                this._startEvent.pageX += (0, _math.sign)(delta.x) * touchBoundary;
                this._startEvent.pageY += (0, _math.sign)(delta.y) * touchBoundary
            },
            _resetActiveElement: function() {
                if ("ios" === _devices.default.real().platform && this.getElement().find(":focus").length) {
                    (0, _dom.resetActiveElement)()
                }
            },
            _toggleGestureCover: function(toggle) {
                this._toggleGestureCoverImpl(toggle)
            },
            _toggleGestureCoverImpl: function(toggle) {
                var isStarted = this._stage === STARTED;
                if (isStarted) {
                    gestureCover(toggle, this.getElement().css("cursor"))
                }
            },
            _clearSelection: function(e) {
                if ((0, _index.isDxMouseWheelEvent)(e) || (0, _index.isTouchEvent)(e)) {
                    return
                }(0, _dom.clearSelection)()
            },
            end: function(e) {
                this._toggleGestureCover(false);
                if (this._stage === STARTED) {
                    this._end(e)
                } else {
                    if (this._stage === INITED) {
                        this._stop(e)
                    }
                }
                this._stage = SLEEP
            },
            dispose: function() {
                clearTimeout(this._immediateTimer);
                this.callBase.apply(this, arguments);
                this._toggleGestureCover(false)
            },
            _init: _common.noop,
            _start: _common.noop,
            _move: _common.noop,
            _stop: _common.noop,
            _end: _common.noop
        });
        GestureEmitter.initialTouchBoundary = TOUCH_BOUNDARY;
        GestureEmitter.touchBoundary = function(newBoundary) {
            if ((0, _type.isDefined)(newBoundary)) {
                TOUCH_BOUNDARY = newBoundary;
                return
            }
            return TOUCH_BOUNDARY
        };
        var _default = GestureEmitter;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/core/renderers/renderer.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getFuncIri = getFuncIri;
        exports.processHatchingAttrs = processHatchingAttrs;
        exports.Renderer = Renderer;
        exports.refreshPaths = exports.TextSvgElement = exports.RectSvgElement = exports.ArcSvgElement = exports.PathSvgElement = exports.SvgElement = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../../core/renderer */ 2));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../../core/dom_adapter */ 11));
        var _window = __webpack_require__( /*! ../../../core/utils/window */ 7);
        var _call_once = _interopRequireDefault(__webpack_require__( /*! ../../../core/utils/call_once */ 85));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../../events/core/events_engine */ 5));
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../../core/utils/browser */ 23));
        var _svg = __webpack_require__( /*! ../../../core/utils/svg */ 205);
        var _animation = __webpack_require__( /*! ./animation */ 906);
        var _utils = __webpack_require__( /*! ../utils */ 14);
        var _type = __webpack_require__( /*! ../../../core/utils/type */ 1);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _slicedToArray(arr, i) {
            return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest()
        }

        function _nonIterableRest() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }

        function _iterableToArrayLimit(arr, i) {
            var _i = arr && ("undefined" !== typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]);
            if (null == _i) {
                return
            }
            var _arr = [];
            var _n = true;
            var _d = false;
            var _s, _e;
            try {
                for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
                    _arr.push(_s.value);
                    if (i && _arr.length === i) {
                        break
                    }
                }
            } catch (err) {
                _d = true;
                _e = err
            } finally {
                try {
                    if (!_n && null != _i.return) {
                        _i.return()
                    }
                } finally {
                    if (_d) {
                        throw _e
                    }
                }
            }
            return _arr
        }

        function _arrayWithHoles(arr) {
            if (Array.isArray(arr)) {
                return arr
            }
        }
        var window = (0, _window.getWindow)();
        var max = Math.max,
            min = Math.min,
            floor = Math.floor,
            round = Math.round,
            sin = Math.sin,
            cos = Math.cos,
            abs = Math.abs,
            PI = Math.PI;
        var PI_DIV_180 = PI / 180;
        var SHARPING_CORRECTION = .5;
        var ARC_COORD_PREC = 5;
        var pxAddingExceptions = {
            "column-count": true,
            "fill-opacity": true,
            "flex-grow": true,
            "flex-shrink": true,
            "font-weight": true,
            "line-height": true,
            opacity: true,
            order: true,
            orphans: true,
            widows: true,
            "z-index": true,
            zoom: true
        };
        var KEY_TEXT = "text";
        var KEY_STROKE = "stroke";
        var KEY_STROKE_WIDTH = "stroke-width";
        var KEY_STROKE_OPACITY = "stroke-opacity";
        var KEY_FONT_SIZE = "font-size";
        var KEY_FONT_STYLE = "font-style";
        var KEY_FONT_WEIGHT = "font-weight";
        var KEY_TEXT_DECORATION = "text-decoration";
        var KEY_TEXTS_ALIGNMENT = "textsAlignment";
        var NONE = "none";
        var DEFAULT_FONT_SIZE = 12;
        var ELLIPSIS = "...";
        var objectCreate = function() {
            if (!Object.create) {
                return function(proto) {
                    var F = function() {};
                    F.prototype = proto;
                    return new F
                }
            } else {
                return function(proto) {
                    return Object.create(proto)
                }
            }
        }();
        var DEFAULTS = {
            scaleX: 1,
            scaleY: 1,
            "pointer-events": null
        };
        var getBackup = (0, _call_once.default)(function() {
            var backupContainer = _dom_adapter.default.createElement("div");
            var backupCounter = 0;
            backupContainer.style.left = "-9999px";
            backupContainer.style.position = "absolute";
            return {
                backupContainer: backupContainer,
                backupCounter: backupCounter
            }
        });

        function backupRoot(root) {
            if (0 === getBackup().backupCounter) {
                _dom_adapter.default.getBody().appendChild(getBackup().backupContainer)
            }++getBackup().backupCounter;
            root.append({
                element: getBackup().backupContainer
            })
        }

        function restoreRoot(root, container) {
            root.append({
                element: container
            });
            --getBackup().backupCounter;
            if (0 === getBackup().backupCounter) {
                _dom_adapter.default.getBody().removeChild(getBackup().backupContainer)
            }
        }
        var getNextDefsSvgId = function() {
            var numDefsSvgElements = 1;
            return function() {
                return "DevExpress_" + numDefsSvgElements++
            }
        }();

        function isObjectArgument(value) {
            return value && "string" !== typeof value
        }

        function createElement(tagName) {
            return _dom_adapter.default.createElementNS("http://www.w3.org/2000/svg", tagName)
        }

        function getFuncIri(id, pathModified) {
            return null !== id ? "url(" + (pathModified ? window.location.href.split("#")[0] : "") + "#" + id + ")" : id
        }

        function extend(target, source) {
            var key;
            for (key in source) {
                target[key] = source[key]
            }
            return target
        }

        function roundValue(value, exp) {
            value = value.toString().split("e");
            value = round(+(value[0] + "e" + (value[1] ? +value[1] + exp : exp)));
            value = value.toString().split("e");
            return +(value[0] + "e" + (value[1] ? +value[1] - exp : -exp))
        }

        function getBoundingClientRect(element) {
            var box;
            try {
                box = element.getBoundingClientRect()
            } catch (e) {}
            return box || {
                left: 0,
                top: 0
            }
        }
        var preserveAspectRatioMap = {
            full: NONE,
            lefttop: "xMinYMin",
            leftcenter: "xMinYMid",
            leftbottom: "xMinYMax",
            centertop: "xMidYMin",
            center: "xMidYMid",
            centerbottom: "xMidYMax",
            righttop: "xMaxYMin",
            rightcenter: "xMaxYMid",
            rightbottom: "xMaxYMax"
        };

        function processHatchingAttrs(element, attrs) {
            if (attrs.hatching && "none" !== (0, _utils.normalizeEnum)(attrs.hatching.direction)) {
                attrs = extend({}, attrs);
                attrs.fill = element._hatching = element.renderer.lockHatching(attrs.fill, attrs.hatching, element._hatching);
                delete attrs.hatching
            } else {
                if (element._hatching) {
                    element.renderer.releaseHatching(element._hatching);
                    element._hatching = null
                }
            }
            return attrs
        }

        function normalizeArcParams(x, y, innerR, outerR, startAngle, endAngle) {
            var isCircle;
            var noArc = true;
            var angleDiff = roundValue(endAngle, 3) - roundValue(startAngle, 3);
            if (angleDiff) {
                if (abs(angleDiff) % 360 === 0) {
                    startAngle = 0;
                    endAngle = 360;
                    isCircle = true;
                    endAngle -= .01
                }
                if (startAngle > 360) {
                    startAngle %= 360
                }
                if (endAngle > 360) {
                    endAngle %= 360
                }
                if (startAngle > endAngle) {
                    startAngle -= 360
                }
                noArc = false
            }
            startAngle *= PI_DIV_180;
            endAngle *= PI_DIV_180;
            return [x, y, min(outerR, innerR), max(outerR, innerR), cos(startAngle), sin(startAngle), cos(endAngle), sin(endAngle), isCircle, floor(abs(endAngle - startAngle) / PI) % 2 ? "1" : "0", noArc]
        }
        var buildArcPath = function(x, y, innerR, outerR, startAngleCos, startAngleSin, endAngleCos, endAngleSin, isCircle, longFlag) {
            return ["M", (x + outerR * startAngleCos).toFixed(ARC_COORD_PREC), (y - outerR * startAngleSin).toFixed(ARC_COORD_PREC), "A", outerR.toFixed(ARC_COORD_PREC), outerR.toFixed(ARC_COORD_PREC), 0, longFlag, 0, (x + outerR * endAngleCos).toFixed(ARC_COORD_PREC), (y - outerR * endAngleSin).toFixed(ARC_COORD_PREC), isCircle ? "M" : "L", (x + innerR * endAngleCos).toFixed(5), (y - innerR * endAngleSin).toFixed(ARC_COORD_PREC), "A", innerR.toFixed(ARC_COORD_PREC), innerR.toFixed(ARC_COORD_PREC), 0, longFlag, 1, (x + innerR * startAngleCos).toFixed(ARC_COORD_PREC), (y - innerR * startAngleSin).toFixed(ARC_COORD_PREC), "Z"].join(" ")
        };

        function buildPathSegments(points, type) {
            var list = [
                ["M", 0, 0]
            ];
            switch (type) {
                case "line":
                    list = buildLineSegments(points);
                    break;
                case "area":
                    list = buildLineSegments(points, true);
                    break;
                case "bezier":
                    list = buildCurveSegments(points);
                    break;
                case "bezierarea":
                    list = buildCurveSegments(points, true)
            }
            return list
        }

        function buildLineSegments(points, close) {
            return buildSegments(points, buildSimpleLineSegment, close)
        }

        function buildCurveSegments(points, close) {
            return buildSegments(points, buildSimpleCurveSegment, close)
        }

        function buildSegments(points, buildSimpleSegment, close) {
            var _points$;
            var i;
            var ii;
            var list = [];
            if (null !== (_points$ = points[0]) && void 0 !== _points$ && _points$.length) {
                for (i = 0, ii = points.length; i < ii; ++i) {
                    buildSimpleSegment(points[i], close, list)
                }
            } else {
                buildSimpleSegment(points, close, list)
            }
            return list
        }

        function buildSimpleLineSegment(points, close, list) {
            var i = 0;
            var k0 = list.length;
            var k = k0;
            var ii = (points || []).length;
            if (ii) {
                if (void 0 !== points[0].x) {
                    for (; i < ii;) {
                        list[k++] = ["L", points[i].x, points[i++].y]
                    }
                } else {
                    for (; i < ii;) {
                        list[k++] = ["L", points[i++], points[i++]]
                    }
                }
                list[k0][0] = "M"
            } else {
                list[k] = ["M", 0, 0]
            }
            close && list.push(["Z"]);
            return list
        }

        function buildSimpleCurveSegment(points, close, list) {
            var i;
            var k = list.length;
            var ii = (points || []).length;
            if (ii) {
                if (void 0 !== points[0].x) {
                    list[k++] = ["M", points[0].x, points[0].y];
                    for (i = 1; i < ii;) {
                        list[k++] = ["C", points[i].x, points[i++].y, points[i].x, points[i++].y, points[i].x, points[i++].y]
                    }
                } else {
                    list[k++] = ["M", points[0], points[1]];
                    for (i = 2; i < ii;) {
                        list[k++] = ["C", points[i++], points[i++], points[i++], points[i++], points[i++], points[i++]]
                    }
                }
            } else {
                list[k] = ["M", 0, 0]
            }
            close && list.push(["Z"]);
            return list
        }

        function combinePathParam(segments) {
            var d = [];
            var k = 0;
            var i;
            var ii = segments.length;
            var segment;
            var j;
            var jj;
            for (i = 0; i < ii; ++i) {
                segment = segments[i];
                for (j = 0, jj = segment.length; j < jj; ++j) {
                    d[k++] = segment[j]
                }
            }
            return d.join(" ")
        }

        function compensateSegments(oldSegments, newSegments, type) {
            var oldLength = oldSegments.length;
            var newLength = newSegments.length;
            var i;
            var originalNewSegments;
            var makeEqualSegments = type.indexOf("area") !== -1 ? makeEqualAreaSegments : makeEqualLineSegments;
            if (0 === oldLength) {
                for (i = 0; i < newLength; i++) {
                    oldSegments.push(newSegments[i].slice(0))
                }
            } else {
                if (oldLength < newLength) {
                    makeEqualSegments(oldSegments, newSegments, type)
                } else {
                    if (oldLength > newLength) {
                        originalNewSegments = newSegments.slice(0);
                        makeEqualSegments(newSegments, oldSegments, type)
                    }
                }
            }
            return originalNewSegments
        }

        function prepareConstSegment(constSeg, type) {
            var x = constSeg[constSeg.length - 2];
            var y = constSeg[constSeg.length - 1];
            switch (type) {
                case "line":
                case "area":
                    constSeg[0] = "L";
                    break;
                case "bezier":
                case "bezierarea":
                    constSeg[0] = "C";
                    constSeg[1] = constSeg[3] = constSeg[5] = x;
                    constSeg[2] = constSeg[4] = constSeg[6] = y
            }
        }

        function makeEqualLineSegments(short, long, type) {
            var constSeg = short[short.length - 1].slice();
            var i = short.length;
            prepareConstSegment(constSeg, type);
            for (; i < long.length; i++) {
                short[i] = constSeg.slice(0)
            }
        }

        function makeEqualAreaSegments(short, long, type) {
            var i;
            var head;
            var shortLength = short.length;
            var longLength = long.length;
            var constsSeg1;
            var constsSeg2;
            if ((shortLength - 1) % 2 === 0 && (longLength - 1) % 2 === 0) {
                i = (shortLength - 1) / 2 - 1;
                head = short.slice(0, i + 1);
                constsSeg1 = head[head.length - 1].slice(0);
                constsSeg2 = short.slice(i + 1)[0].slice(0);
                prepareConstSegment(constsSeg1, type);
                prepareConstSegment(constsSeg2, type);
                for (var j = i; j < (longLength - 1) / 2 - 1; j++) {
                    short.splice(j + 1, 0, constsSeg1);
                    short.splice(j + 3, 0, constsSeg2)
                }
            }
        }

        function baseCss(that, styles) {
            var elemStyles = that._styles;
            var key;
            var value;
            styles = styles || {};
            for (key in styles) {
                value = styles[key];
                if ((0, _type.isDefined)(value)) {
                    value += "number" === typeof value && !pxAddingExceptions[key] ? "px" : "";
                    elemStyles[key] = "" !== value ? value : null
                }
            }
            for (key in elemStyles) {
                value = elemStyles[key];
                if (value) {
                    that.element.style[key] = value
                } else {
                    if (null === value) {
                        that.element.style[key] = ""
                    }
                }
            }
            return that
        }

        function fixFuncIri(wrapper, attribute) {
            var element = wrapper.element;
            var id = wrapper.attr(attribute);
            if (id && id.indexOf("DevExpress") !== -1) {
                element.removeAttribute(attribute);
                element.setAttribute(attribute, getFuncIri(id, wrapper.renderer.pathModified))
            }
        }

        function baseAttr(that, attrs) {
            attrs = attrs || {};
            var settings = that._settings;
            var attributes = {};
            var key;
            var value;
            var elem = that.element;
            var renderer = that.renderer;
            var rtl = renderer.rtl;
            var hasTransformations;
            var recalculateDashStyle;
            var sw;
            var i;
            if (!isObjectArgument(attrs)) {
                if (attrs in settings) {
                    return settings[attrs]
                }
                if (attrs in DEFAULTS) {
                    return DEFAULTS[attrs]
                }
                return 0
            }
            extend(attributes, attrs);
            for (key in attributes) {
                value = attributes[key];
                if (void 0 === value) {
                    continue
                }
                settings[key] = value;
                if ("align" === key) {
                    key = "text-anchor";
                    value = {
                        left: rtl ? "end" : "start",
                        center: "middle",
                        right: rtl ? "start" : "end"
                    } [value] || null
                } else {
                    if ("dashStyle" === key) {
                        recalculateDashStyle = true;
                        continue
                    } else {
                        if (key === KEY_STROKE_WIDTH) {
                            recalculateDashStyle = true
                        } else {
                            if (value && ("fill" === key || "clip-path" === key || "filter" === key) && 0 === value.indexOf("DevExpress")) {
                                that._addFixIRICallback();
                                value = getFuncIri(value, renderer.pathModified)
                            } else {
                                if (/^(translate(X|Y)|rotate[XY]?|scale(X|Y)|sharp|sharpDirection)$/i.test(key)) {
                                    hasTransformations = true;
                                    continue
                                } else {
                                    if (/^(x|y|d)$/i.test(key)) {
                                        hasTransformations = true
                                    }
                                }
                            }
                        }
                    }
                }
                if (null === value) {
                    elem.removeAttribute(key)
                } else {
                    elem.setAttribute(key, value)
                }
            }
            if (recalculateDashStyle && "dashStyle" in settings) {
                value = settings.dashStyle;
                sw = ("_originalSW" in that ? that._originalSW : settings[KEY_STROKE_WIDTH]) || 1;
                key = "stroke-dasharray";
                value = null === value ? "" : (0, _utils.normalizeEnum)(value);
                if ("" === value || "solid" === value || value === NONE) {
                    that.element.removeAttribute(key)
                } else {
                    value = value.replace(/longdash/g, "8,3,").replace(/dash/g, "4,3,").replace(/dot/g, "1,3,").replace(/,$/, "").split(",");
                    i = value.length;
                    while (i--) {
                        value[i] = parseInt(value[i]) * sw
                    }
                    that.element.setAttribute(key, value.join(","))
                }
            }
            if (hasTransformations) {
                that._applyTransformation()
            }
            return that
        }

        function pathAttr(attrs) {
            var that = this;
            var segments;
            if (isObjectArgument(attrs)) {
                attrs = extend({}, attrs);
                segments = attrs.segments;
                if ("points" in attrs) {
                    segments = buildPathSegments(attrs.points, that.type);
                    delete attrs.points
                }
                if (segments) {
                    attrs.d = combinePathParam(segments);
                    that.segments = segments;
                    delete attrs.segments
                }
            }
            return baseAttr(that, attrs)
        }

        function arcAttr(attrs) {
            var settings = this._settings;
            var x;
            var y;
            var innerRadius;
            var outerRadius;
            var startAngle;
            var endAngle;
            if (isObjectArgument(attrs)) {
                attrs = extend({}, attrs);
                if ("x" in attrs || "y" in attrs || "innerRadius" in attrs || "outerRadius" in attrs || "startAngle" in attrs || "endAngle" in attrs) {
                    settings.x = x = "x" in attrs ? attrs.x : settings.x;
                    delete attrs.x;
                    settings.y = y = "y" in attrs ? attrs.y : settings.y;
                    delete attrs.y;
                    settings.innerRadius = innerRadius = "innerRadius" in attrs ? attrs.innerRadius : settings.innerRadius;
                    delete attrs.innerRadius;
                    settings.outerRadius = outerRadius = "outerRadius" in attrs ? attrs.outerRadius : settings.outerRadius;
                    delete attrs.outerRadius;
                    settings.startAngle = startAngle = "startAngle" in attrs ? attrs.startAngle : settings.startAngle;
                    delete attrs.startAngle;
                    settings.endAngle = endAngle = "endAngle" in attrs ? attrs.endAngle : settings.endAngle;
                    delete attrs.endAngle;
                    attrs.d = buildArcPath.apply(null, normalizeArcParams(x, y, innerRadius, outerRadius, startAngle, endAngle))
                }
            }
            return baseAttr(this, attrs)
        }

        function rectAttr(attrs) {
            var that = this;
            var x;
            var y;
            var width;
            var height;
            var sw;
            var maxSW;
            var newSW;
            if (isObjectArgument(attrs)) {
                attrs = extend({}, attrs);
                if (void 0 !== attrs.x || void 0 !== attrs.y || void 0 !== attrs.width || void 0 !== attrs.height || void 0 !== attrs[KEY_STROKE_WIDTH]) {
                    void 0 !== attrs.x ? x = that._originalX = attrs.x : x = that._originalX || 0;
                    void 0 !== attrs.y ? y = that._originalY = attrs.y : y = that._originalY || 0;
                    void 0 !== attrs.width ? width = that._originalWidth = attrs.width : width = that._originalWidth || 0;
                    void 0 !== attrs.height ? height = that._originalHeight = attrs.height : height = that._originalHeight || 0;
                    void 0 !== attrs[KEY_STROKE_WIDTH] ? sw = that._originalSW = attrs[KEY_STROKE_WIDTH] : sw = that._originalSW;
                    maxSW = ~~((width < height ? width : height) / 2);
                    newSW = (sw || 0) < maxSW ? sw || 0 : maxSW;
                    attrs.x = x + newSW / 2;
                    attrs.y = y + newSW / 2;
                    attrs.width = width - newSW;
                    attrs.height = height - newSW;
                    ((sw || 0) !== newSW || !(0 === newSW && void 0 === sw)) && (attrs[KEY_STROKE_WIDTH] = newSW)
                }
                if ("sharp" in attrs) {
                    delete attrs.sharp
                }
            }
            return baseAttr(that, attrs)
        }

        function textAttr(attrs) {
            var that = this;
            var isResetRequired;
            if (!isObjectArgument(attrs)) {
                return baseAttr(that, attrs)
            }
            attrs = extend({}, attrs);
            var settings = that._settings;
            var wasStroked = (0, _type.isDefined)(settings[KEY_STROKE]) && (0, _type.isDefined)(settings[KEY_STROKE_WIDTH]);
            if (void 0 !== attrs[KEY_TEXT]) {
                settings[KEY_TEXT] = attrs[KEY_TEXT];
                delete attrs[KEY_TEXT];
                isResetRequired = true
            }
            if (void 0 !== attrs[KEY_STROKE]) {
                settings[KEY_STROKE] = attrs[KEY_STROKE];
                delete attrs[KEY_STROKE]
            }
            if (void 0 !== attrs[KEY_STROKE_WIDTH]) {
                settings[KEY_STROKE_WIDTH] = attrs[KEY_STROKE_WIDTH];
                delete attrs[KEY_STROKE_WIDTH]
            }
            if (void 0 !== attrs[KEY_STROKE_OPACITY]) {
                settings[KEY_STROKE_OPACITY] = attrs[KEY_STROKE_OPACITY];
                delete attrs[KEY_STROKE_OPACITY]
            }
            if (void 0 !== attrs[KEY_TEXTS_ALIGNMENT]) {
                alignTextNodes(that, attrs[KEY_TEXTS_ALIGNMENT]);
                delete attrs[KEY_TEXTS_ALIGNMENT]
            }
            var isStroked = (0, _type.isDefined)(settings[KEY_STROKE]) && (0, _type.isDefined)(settings[KEY_STROKE_WIDTH]);
            baseAttr(that, attrs);
            isResetRequired = isResetRequired || isStroked !== wasStroked && settings[KEY_TEXT];
            if (isResetRequired) {
                createTextNodes(that, settings.text, isStroked);
                that._hasEllipsis = false
            }
            if (isResetRequired || void 0 !== attrs.x || void 0 !== attrs.y) {
                locateTextNodes(that)
            }
            if (isStroked) {
                strokeTextNodes(that)
            }
            return that
        }

        function textCss(styles) {
            styles = styles || {};
            baseCss(this, styles);
            if (KEY_FONT_SIZE in styles) {
                locateTextNodes(this)
            }
            return this
        }

        function orderHtmlTree(list, line, node, parentStyle, parentClassName) {
            var style;
            var realStyle;
            var i;
            var ii;
            var nodes;
            if (void 0 !== node.wholeText) {
                list.push({
                    value: node.wholeText,
                    style: parentStyle,
                    className: parentClassName,
                    line: line,
                    height: parentStyle[KEY_FONT_SIZE] || 0
                })
            } else {
                if ("BR" === node.tagName) {
                    ++line
                } else {
                    if (_dom_adapter.default.isElementNode(node)) {
                        extend(style = {}, parentStyle);
                        switch (node.tagName) {
                            case "B":
                            case "STRONG":
                                style[KEY_FONT_WEIGHT] = "bold";
                                break;
                            case "I":
                            case "EM":
                                style[KEY_FONT_STYLE] = "italic";
                                break;
                            case "U":
                                style[KEY_TEXT_DECORATION] = "underline"
                        }
                        realStyle = node.style;
                        realStyle.color && (style.fill = realStyle.color);
                        realStyle.fontSize && (style[KEY_FONT_SIZE] = realStyle.fontSize);
                        realStyle.fontStyle && (style[KEY_FONT_STYLE] = realStyle.fontStyle);
                        realStyle.fontWeight && (style[KEY_FONT_WEIGHT] = realStyle.fontWeight);
                        realStyle.textDecoration && (style[KEY_TEXT_DECORATION] = realStyle.textDecoration);
                        for (i = 0, nodes = node.childNodes, ii = nodes.length; i < ii; ++i) {
                            line = orderHtmlTree(list, line, nodes[i], style, node.className || parentClassName)
                        }
                    }
                }
            }
            return line
        }

        function adjustLineHeights(items) {
            var i;
            var ii;
            var currentItem = items[0];
            var item;
            for (i = 1, ii = items.length; i < ii; ++i) {
                item = items[i];
                if (item.line === currentItem.line) {
                    currentItem.height = maxLengthFontSize(currentItem.height, item.height);
                    currentItem.inherits = currentItem.inherits || 0 === parseFloat(item.height);
                    item.height = NaN
                } else {
                    currentItem = item
                }
            }
        }

        function removeExtraAttrs(html) {
            var findTagAttrs = /(?:(<[a-z0-9]+\s*))([\s\S]*?)(>|\/>)/gi;
            var findStyleAndClassAttrs = /(style|class)\s*=\s*(["'])(?:(?!\2).)*\2\s?/gi;
            return html.replace(findTagAttrs, function(allTagAttrs, p1, p2, p3) {
                p2 = (p2 && p2.match(findStyleAndClassAttrs) || []).map(function(str) {
                    return str
                }).join(" ");
                return p1 + p2 + p3
            })
        }

        function parseHTML(text) {
            var items = [];
            var div = _dom_adapter.default.createElement("div");
            div.innerHTML = text.replace(/\r/g, "").replace(/\n/g, "<br/>");
            orderHtmlTree(items, 0, div, {}, "");
            adjustLineHeights(items);
            return items
        }

        function parseMultiline(text) {
            var texts = text.replace(/\r/g, "").split(/\n/g);
            var i = 0;
            var items = [];
            for (; i < texts.length; i++) {
                items.push({
                    value: texts[i].trim(),
                    height: 0,
                    line: i
                })
            }
            return items
        }

        function createTspans(items, element, fieldName) {
            var i;
            var ii;
            var item;
            for (i = 0, ii = items.length; i < ii; ++i) {
                item = items[i];
                item[fieldName] = createElement("tspan");
                item[fieldName].appendChild(_dom_adapter.default.createTextNode(item.value));
                item.style && baseCss({
                    element: item[fieldName],
                    _styles: {}
                }, item.style);
                item.className && item[fieldName].setAttribute("class", item.className);
                element.appendChild(item[fieldName])
            }
        }

        function restoreText() {
            if (this._hasEllipsis) {
                this.attr({
                    text: this._settings.text
                })
            }
        }

        function applyEllipsis(maxWidth) {
            var that = this;
            var lines;
            var hasEllipsis = false;
            var i;
            var ii;
            var lineParts;
            var j;
            var jj;
            var text;
            restoreText.call(that);
            var ellipsis = that.renderer.text(ELLIPSIS).attr(that._styles).append(that.renderer.root);
            var ellipsisWidth = ellipsis.getBBox().width;
            if (that._getElementBBox().width > maxWidth) {
                if (maxWidth - ellipsisWidth < 0) {
                    maxWidth = 0
                } else {
                    maxWidth -= ellipsisWidth
                }
                lines = prepareLines(that.element, that._texts, maxWidth);
                for (i = 0, ii = lines.length; i < ii; ++i) {
                    lineParts = lines[i].parts;
                    if (1 === lines[i].commonLength) {
                        continue
                    }
                    for (j = 0, jj = lineParts.length; j < jj; ++j) {
                        text = lineParts[j];
                        if ((0, _type.isDefined)(text.endIndex)) {
                            setNewText(text, text.endIndex);
                            hasEllipsis = true
                        } else {
                            if (text.startBox > maxWidth) {
                                removeTextSpan(text)
                            }
                        }
                    }
                }
            }
            ellipsis.remove();
            that._hasEllipsis = hasEllipsis;
            return hasEllipsis
        }

        function cloneAndRemoveAttrs(node) {
            var clone;
            if (node) {
                clone = node.cloneNode();
                clone.removeAttribute("y");
                clone.removeAttribute("x")
            }
            return clone || node
        }

        function detachTitleElements(element) {
            var titleElements = _dom_adapter.default.querySelectorAll(element, "title");
            for (var i = 0; i < titleElements.length; i++) {
                element.removeChild(titleElements[i])
            }
            return titleElements
        }

        function detachAndStoreTitleElements(element) {
            var titleElements = detachTitleElements(element);
            return function() {
                for (var i = 0; i < titleElements.length; i++) {
                    element.appendChild(titleElements[i])
                }
            }
        }

        function setMaxSize(maxWidth, maxHeight) {
            var options = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            var that = this;
            var lines = [];
            var textChanged = false;
            var textIsEmpty = false;
            var ellipsisMaxWidth = maxWidth;
            restoreText.call(that);
            var restoreTitleElement = detachAndStoreTitleElements(this.element);
            var ellipsis = that.renderer.text(ELLIPSIS).attr(that._styles).append(that.renderer.root);
            var ellipsisWidth = ellipsis.getBBox().width;
            var _that$_getElementBBox = that._getElementBBox(),
                width = _that$_getElementBBox.width,
                height = _that$_getElementBBox.height;
            if ((width || height) && (width > maxWidth || maxHeight && height > maxHeight)) {
                if (maxWidth - ellipsisWidth < 0) {
                    ellipsisMaxWidth = 0
                } else {
                    ellipsisMaxWidth -= ellipsisWidth
                }
                lines = applyOverflowRules(that.element, that._texts, maxWidth, ellipsisMaxWidth, options, maxHeight);
                lines = setMaxHeight(lines, ellipsisMaxWidth, options, maxHeight, parseFloat(this._getLineHeight()));
                this._texts = lines.reduce(function(texts, line) {
                    return texts.concat(line.parts)
                }, []).filter(function(t) {
                    return "" !== t.value
                }).map(function(t) {
                    t.stroke && t.tspan.parentNode.appendChild(t.stroke);
                    return t
                }).map(function(t) {
                    t.tspan.parentNode.appendChild(t.tspan);
                    return t
                });
                !this._texts.length && (this._texts = null);
                textChanged = true;
                if (this._texts) {
                    locateTextNodes(this)
                } else {
                    this.element.textContent = "";
                    textIsEmpty = true
                }
            }
            ellipsis.remove();
            that._hasEllipsis = textChanged;
            restoreTitleElement();
            return {
                rowCount: lines.length,
                textChanged: textChanged,
                textIsEmpty: textIsEmpty
            }
        }

        function getIndexForEllipsis(text, maxWidth, startBox, endBox) {
            var k;
            var kk;
            if (startBox <= maxWidth && endBox > maxWidth) {
                for (k = 1, kk = text.value.length; k <= kk; ++k) {
                    if (startBox + text.tspan.getSubStringLength(0, k) > maxWidth) {
                        return k - 1
                    }
                }
            }
        }

        function getTextWidth(text) {
            return text.value.length ? text.tspan.getSubStringLength(0, text.value.length) : 0
        }

        function prepareLines(element, texts, maxWidth) {
            var lines = [];
            var i;
            var ii;
            var text;
            var startBox;
            var endBox;
            if (texts) {
                for (i = 0, ii = texts.length; i < ii; ++i) {
                    text = texts[i];
                    if (!lines[text.line]) {
                        text.startBox = startBox = 0;
                        lines.push({
                            commonLength: text.value.length,
                            parts: [text]
                        })
                    } else {
                        text.startBox = startBox;
                        lines[text.line].parts.push(text);
                        lines[text.line].commonLength += text.value.length
                    }
                    endBox = startBox + text.tspan.getSubStringLength(0, text.value.length);
                    text.endIndex = getIndexForEllipsis(text, maxWidth, startBox, endBox);
                    startBox = endBox
                }
            } else {
                text = {
                    value: element.textContent,
                    tspan: element
                };
                text.startBox = startBox = 0;
                endBox = startBox + getTextWidth(text);
                text.endIndex = getIndexForEllipsis(text, maxWidth, startBox, endBox);
                lines = [{
                    commonLength: element.textContent.length,
                    parts: [text]
                }]
            }
            return lines
        }

        function getSpaceBreakIndex(text, maxWidth) {
            var initialIndices = text.startBox > 0 ? [0] : [];
            var spaceIndices = text.value.split("").reduce(function(indices, char, index) {
                if (" " === char) {
                    indices.push(index)
                }
                return indices
            }, initialIndices);
            var spaceIndex = 0;
            while (void 0 !== spaceIndices[spaceIndex + 1] && text.startBox + text.tspan.getSubStringLength(0, spaceIndices[spaceIndex + 1]) < maxWidth) {
                spaceIndex++
            }
            return spaceIndices[spaceIndex]
        }

        function getWordBreakIndex(text, maxWidth) {
            for (var i = 0; i < text.value.length - 1; i++) {
                if (text.startBox + text.tspan.getSubStringLength(0, i + 1) > maxWidth) {
                    return i
                }
            }
        }

        function getEllipsisString(ellipsisMaxWidth, _ref) {
            var hideOverflowEllipsis = _ref.hideOverflowEllipsis;
            return hideOverflowEllipsis && 0 === ellipsisMaxWidth ? "" : ELLIPSIS
        }

        function setEllipsis(text, ellipsisMaxWidth, options) {
            var ellipsis = getEllipsisString(ellipsisMaxWidth, options);
            if (text.value.length && text.tspan.parentNode) {
                for (var i = text.value.length - 1; i >= 1; i--) {
                    if (text.startBox + text.tspan.getSubStringLength(0, i) < ellipsisMaxWidth) {
                        setNewText(text, i, ellipsis);
                        break
                    } else {
                        if (1 === i) {
                            setNewText(text, 0, ellipsis)
                        }
                    }
                }
            }
        }

        function wordWrap(text, maxWidth, ellipsisMaxWidth, options, lastStepBreakIndex) {
            var wholeText = text.value;
            var breakIndex;
            if ("none" !== options.wordWrap) {
                breakIndex = "normal" === options.wordWrap ? getSpaceBreakIndex(text, maxWidth) : getWordBreakIndex(text, maxWidth)
            }
            var restLines = [];
            var restText;
            if (isFinite(breakIndex) && !(0 === lastStepBreakIndex && 0 === breakIndex)) {
                setNewText(text, breakIndex, "");
                var newTextOffset = " " === wholeText[breakIndex] ? 1 : 0;
                var restString = wholeText.slice(breakIndex + newTextOffset);
                if (restString.length) {
                    var restTspan = cloneAndRemoveAttrs(text.tspan);
                    restTspan.textContent = restString;
                    text.tspan.parentNode.appendChild(restTspan);
                    restText = extend(extend({}, text), {
                        value: restString,
                        startBox: 0,
                        height: 0,
                        tspan: restTspan,
                        stroke: cloneAndRemoveAttrs(text.stroke),
                        endBox: restTspan.getSubStringLength(0, restString.length)
                    });
                    restText.stroke && (restText.stroke.textContent = restString);
                    if (restText.endBox > maxWidth) {
                        restLines = wordWrap(restText, maxWidth, ellipsisMaxWidth, options, breakIndex);
                        if (!restLines.length) {
                            return []
                        }
                    }
                }
            }
            if (text.value.length) {
                if ("ellipsis" === options.textOverflow && text.tspan.getSubStringLength(0, text.value.length) > maxWidth) {
                    setEllipsis(text, ellipsisMaxWidth, options)
                }
                if ("hide" === options.textOverflow && text.tspan.getSubStringLength(0, text.value.length) > maxWidth) {
                    return []
                }
            } else {
                text.tspan.parentNode.removeChild(text.tspan)
            }
            var parts = [];
            if (restText) {
                parts.push(restText)
            }
            return [{
                commonLength: wholeText.length,
                parts: parts
            }].concat(restLines)
        }

        function calculateLineHeight(line, lineHeight) {
            return line.parts.reduce(function(height, text) {
                return max(height, getItemLineHeight(text, lineHeight))
            }, 0)
        }

        function setMaxHeight(lines, ellipsisMaxWidth, options, maxHeight, lineHeight) {
            var textOverflow = options.textOverflow;
            if (!isFinite(maxHeight) || 0 === Number(maxHeight) || "none" === textOverflow) {
                return lines
            }
            var result = lines.reduce(function(_ref2, l, index, arr) {
                var _ref3 = _slicedToArray(_ref2, 2),
                    lines = _ref3[0],
                    commonHeight = _ref3[1];
                var height = calculateLineHeight(l, lineHeight);
                commonHeight += height;
                if (commonHeight < maxHeight) {
                    lines.push(l)
                } else {
                    l.parts.forEach(function(item) {
                        removeTextSpan(item)
                    });
                    if ("ellipsis" === textOverflow) {
                        var prevLine = arr[index - 1];
                        if (prevLine) {
                            var text = prevLine.parts[prevLine.parts.length - 1];
                            if (!text.hasEllipsis) {
                                if (0 === ellipsisMaxWidth || text.endBox < ellipsisMaxWidth) {
                                    setNewText(text, text.value.length, getEllipsisString(ellipsisMaxWidth, options))
                                } else {
                                    setEllipsis(text, ellipsisMaxWidth, options)
                                }
                            }
                        }
                    }
                }
                return [lines, commonHeight]
            }, [
                [], 0
            ]);
            if ("hide" === textOverflow && result[1] > maxHeight) {
                result[0].forEach(function(l) {
                    l.parts.forEach(function(item) {
                        removeTextSpan(item)
                    })
                });
                return []
            }
            return result[0]
        }

        function applyOverflowRules(element, texts, maxWidth, ellipsisMaxWidth, options) {
            if (!texts) {
                var textValue = element.textContent;
                var text = {
                    value: textValue,
                    height: 0,
                    line: 0
                };
                element.textContent = "";
                createTspans([text], element, "tspan");
                texts = [text]
            }
            return texts.reduce(function(_ref4, text) {
                var _ref5 = _slicedToArray(_ref4, 5),
                    lines = _ref5[0],
                    startBox = _ref5[1],
                    endBox = _ref5[2],
                    stop = _ref5[3],
                    lineNumber = _ref5[4];
                var line = lines[lines.length - 1];
                if (stop) {
                    return [lines, startBox, endBox, stop]
                }
                if (!line || text.line !== lineNumber) {
                    text.startBox = startBox = 0;
                    lines.push({
                        commonLength: text.value.length,
                        parts: [text]
                    })
                } else {
                    text.startBox = startBox;
                    if (startBox > ellipsisMaxWidth && "none" === options.wordWrap && "ellipsis" === options.textOverflow) {
                        removeTextSpan(text);
                        return [lines, startBox, endBox, stop, lineNumber]
                    }
                    line.parts.push(text);
                    line.commonLength += text.value.length
                }
                text.endBox = endBox = startBox + getTextWidth(text);
                startBox = endBox;
                if ((0, _type.isDefined)(maxWidth) && endBox > maxWidth) {
                    var wordWrapLines = wordWrap(text, maxWidth, ellipsisMaxWidth, options);
                    if (!wordWrapLines.length) {
                        lines = [];
                        stop = true
                    } else {
                        lines = lines.concat(wordWrapLines.filter(function(l) {
                            return l.parts.length > 0
                        }))
                    }
                }
                return [lines, startBox, endBox, stop, text.line]
            }, [
                [], 0, 0, false, 0
            ])[0]
        }

        function setNewText(text, index) {
            var insertString = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ELLIPSIS;
            var newText = text.value.substr(0, index) + insertString;
            text.value = text.tspan.textContent = newText;
            text.stroke && (text.stroke.textContent = newText);
            if (insertString === ELLIPSIS) {
                text.hasEllipsis = true
            }
        }

        function removeTextSpan(text) {
            text.tspan.parentNode && text.tspan.parentNode.removeChild(text.tspan);
            text.stroke && text.stroke.parentNode && text.stroke.parentNode.removeChild(text.stroke)
        }

        function createTextNodes(wrapper, text, isStroked) {
            var items;
            var parsedHtml;
            wrapper._texts = null;
            wrapper.clear();
            if (null === text) {
                return
            }
            text = "" + text;
            if (!wrapper.renderer.encodeHtml && (/<[a-z][\s\S]*>/i.test(text) || text.indexOf("&") !== -1)) {
                parsedHtml = removeExtraAttrs(text);
                items = parseHTML(parsedHtml)
            } else {
                if (/\n/g.test(text)) {
                    items = parseMultiline(text)
                } else {
                    if (isStroked) {
                        items = [{
                            value: text.trim(),
                            height: 0
                        }]
                    }
                }
            }
            if (items) {
                if (items.length) {
                    wrapper._texts = items;
                    if (isStroked) {
                        createTspans(items, wrapper.element, KEY_STROKE)
                    }
                    createTspans(items, wrapper.element, "tspan")
                }
            } else {
                wrapper.element.appendChild(_dom_adapter.default.createTextNode(text))
            }
        }

        function setTextNodeAttribute(item, name, value) {
            item.tspan.setAttribute(name, value);
            item.stroke && item.stroke.setAttribute(name, value)
        }

        function getItemLineHeight(item, defaultValue) {
            return item.inherits ? maxLengthFontSize(item.height, defaultValue) : item.height || defaultValue
        }

        function locateTextNodes(wrapper) {
            if (!wrapper._texts) {
                return
            }
            var items = wrapper._texts;
            var x = wrapper._settings.x;
            var lineHeight = wrapper._getLineHeight();
            var i;
            var ii;
            var item = items[0];
            setTextNodeAttribute(item, "x", x);
            setTextNodeAttribute(item, "y", wrapper._settings.y);
            for (i = 1, ii = items.length; i < ii; ++i) {
                item = items[i];
                if (parseFloat(item.height) >= 0) {
                    setTextNodeAttribute(item, "x", x);
                    var height = getItemLineHeight(item, lineHeight);
                    setTextNodeAttribute(item, "dy", height)
                }
            }
        }

        function alignTextNodes(wrapper, alignment) {
            if (!wrapper._texts || "center" === alignment) {
                return
            }
            var items = wrapper._texts;
            var direction = "left" === alignment ? -1 : 1;
            var maxTextWidth = Math.max.apply(Math, items.map(function(t) {
                return getTextWidth(t)
            }));
            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                var textWidth = getTextWidth(item);
                if (0 !== maxTextWidth && maxTextWidth !== textWidth) {
                    setTextNodeAttribute(item, "dx", direction * round((maxTextWidth - textWidth) / 2 * 10) / 10)
                }
            }
        }

        function maxLengthFontSize(fontSize1, fontSize2) {
            var parsedHeight1 = parseFloat(fontSize1);
            var parsedHeight2 = parseFloat(fontSize2);
            var height1 = parsedHeight1 || DEFAULT_FONT_SIZE;
            var height2 = parsedHeight2 || DEFAULT_FONT_SIZE;
            return height1 > height2 ? !isNaN(parsedHeight1) ? fontSize1 : height1 : !isNaN(parsedHeight2) ? fontSize2 : height2
        }

        function strokeTextNodes(wrapper) {
            if (!wrapper._texts) {
                return
            }
            var items = wrapper._texts;
            var stroke = wrapper._settings[KEY_STROKE];
            var strokeWidth = wrapper._settings[KEY_STROKE_WIDTH];
            var strokeOpacity = wrapper._settings[KEY_STROKE_OPACITY] || 1;
            var tspan;
            var i;
            var ii;
            for (i = 0, ii = items.length; i < ii; ++i) {
                tspan = items[i].stroke;
                tspan.setAttribute(KEY_STROKE, stroke);
                tspan.setAttribute(KEY_STROKE_WIDTH, strokeWidth);
                tspan.setAttribute(KEY_STROKE_OPACITY, strokeOpacity);
                tspan.setAttribute("stroke-linejoin", "round")
            }
        }

        function baseAnimate(that, params, options, complete) {
            options = options || {};
            var key;
            var value;
            var renderer = that.renderer;
            var settings = that._settings;
            var animationParams = {};
            var defaults = {
                translateX: 0,
                translateY: 0,
                scaleX: 1,
                scaleY: 1,
                rotate: 0,
                rotateX: 0,
                rotateY: 0
            };
            if (complete) {
                options.complete = complete
            }
            if (renderer.animationEnabled()) {
                for (key in params) {
                    value = params[key];
                    if (/^(translate(X|Y)|rotate[XY]?|scale(X|Y))$/i.test(key)) {
                        animationParams.transform = animationParams.transform || {
                            from: {},
                            to: {}
                        };
                        animationParams.transform.from[key] = key in settings ? Number(settings[key].toFixed(3)) : defaults[key];
                        animationParams.transform.to[key] = value
                    } else {
                        if ("arc" === key || "segments" === key) {
                            animationParams[key] = value
                        } else {
                            animationParams[key] = {
                                from: key in settings ? settings[key] : parseFloat(that.element.getAttribute(key) || 0),
                                to: value
                            }
                        }
                    }
                }
                renderer.animateElement(that, animationParams, extend(extend({}, renderer._animation), options))
            } else {
                options.step && options.step.call(that, 1, 1);
                options.complete && options.complete.call(that);
                that.attr(params)
            }
            return that
        }

        function pathAnimate(params, options, complete) {
            var that = this;
            var curSegments = that.segments || [];
            var newSegments;
            var endSegments;
            if (that.renderer.animationEnabled() && "points" in params) {
                newSegments = buildPathSegments(params.points, that.type);
                endSegments = compensateSegments(curSegments, newSegments, that.type);
                params.segments = {
                    from: curSegments,
                    to: newSegments,
                    end: endSegments
                };
                delete params.points
            }
            return baseAnimate(that, params, options, complete)
        }

        function arcAnimate(params, options, complete) {
            var that = this;
            var settings = that._settings;
            var arcParams = {
                from: {},
                to: {}
            };
            if (that.renderer.animationEnabled() && ("x" in params || "y" in params || "innerRadius" in params || "outerRadius" in params || "startAngle" in params || "endAngle" in params)) {
                arcParams.from.x = settings.x || 0;
                arcParams.from.y = settings.y || 0;
                arcParams.from.innerRadius = settings.innerRadius || 0;
                arcParams.from.outerRadius = settings.outerRadius || 0;
                arcParams.from.startAngle = settings.startAngle || 0;
                arcParams.from.endAngle = settings.endAngle || 0;
                arcParams.to.x = "x" in params ? params.x : settings.x;
                delete params.x;
                arcParams.to.y = "y" in params ? params.y : settings.y;
                delete params.y;
                arcParams.to.innerRadius = "innerRadius" in params ? params.innerRadius : settings.innerRadius;
                delete params.innerRadius;
                arcParams.to.outerRadius = "outerRadius" in params ? params.outerRadius : settings.outerRadius;
                delete params.outerRadius;
                arcParams.to.startAngle = "startAngle" in params ? params.startAngle : settings.startAngle;
                delete params.startAngle;
                arcParams.to.endAngle = "endAngle" in params ? params.endAngle : settings.endAngle;
                delete params.endAngle;
                params.arc = arcParams
            }
            return baseAnimate(that, params, options, complete)
        }

        function buildLink(target, parameters) {
            var obj = {
                is: false,
                name: parameters.name || parameters,
                after: parameters.after
            };
            if (target) {
                obj.to = target
            } else {
                obj.virtual = true
            }
            return obj
        }
        var SvgElement = function(renderer, tagName, type) {
            var that = this;
            that.renderer = renderer;
            that.element = createElement(tagName);
            that._settings = {};
            that._styles = {};
            if ("path" === tagName) {
                that.type = type || "line"
            }
        };
        exports.SvgElement = SvgElement;

        function removeFuncIriCallback(callback) {
            fixFuncIriCallbacks.remove(callback)
        }
        SvgElement.prototype = {
            constructor: SvgElement,
            _getJQElement: function() {
                return this._$element || (this._$element = (0, _renderer.default)(this.element))
            },
            _addFixIRICallback: function() {
                var that = this;
                var fn = function() {
                    fixFuncIri(that, "fill");
                    fixFuncIri(that, "clip-path");
                    fixFuncIri(that, "filter")
                };
                that.element._fixFuncIri = fn;
                fn.renderer = that.renderer;
                fixFuncIriCallbacks.add(fn);
                that._addFixIRICallback = function() {}
            },
            _clearChildrenFuncIri: function() {
                var clearChildren = function clearChildren(element) {
                    var i;
                    for (i = 0; i < element.childNodes.length; i++) {
                        removeFuncIriCallback(element.childNodes[i]._fixFuncIri);
                        clearChildren(element.childNodes[i])
                    }
                };
                clearChildren(this.element)
            },
            dispose: function() {
                removeFuncIriCallback(this.element._fixFuncIri);
                this._clearChildrenFuncIri();
                this._getJQElement().remove();
                return this
            },
            append: function(parent) {
                (parent || this.renderer.root).element.appendChild(this.element);
                return this
            },
            remove: function() {
                var element = this.element;
                element.parentNode && element.parentNode.removeChild(element);
                return this
            },
            enableLinks: function() {
                this._links = [];
                return this
            },
            virtualLink: function(parameters) {
                linkItem({
                    _link: buildLink(null, parameters)
                }, this);
                return this
            },
            linkAfter: function(name) {
                this._linkAfter = name;
                return this
            },
            linkOn: function(target, parameters) {
                this._link = buildLink(target, parameters);
                linkItem(this, target);
                return this
            },
            linkOff: function() {
                unlinkItem(this);
                this._link = null;
                return this
            },
            linkAppend: function() {
                var link = this._link;
                var items = link.to._links;
                var i;
                var next;
                for (i = link.i + 1;
                    (next = items[i]) && !next._link.is; ++i) {}
                this._insert(link.to, next);
                link.is = true;
                return this
            },
            _insert: function(parent, next) {
                parent.element.insertBefore(this.element, next ? next.element : null)
            },
            linkRemove: function() {
                this.remove();
                this._link.is = false;
                return this
            },
            clear: function() {
                this._clearChildrenFuncIri();
                this._getJQElement().empty();
                return this
            },
            toBackground: function() {
                var elem = this.element;
                var parent = elem.parentNode;
                parent && parent.insertBefore(elem, parent.firstChild);
                return this
            },
            toForeground: function() {
                var elem = this.element;
                var parent = elem.parentNode;
                parent && parent.appendChild(elem);
                return this
            },
            attr: function(attrs) {
                return baseAttr(this, attrs)
            },
            smartAttr: function(attrs) {
                return this.attr(processHatchingAttrs(this, attrs))
            },
            css: function(styles) {
                return baseCss(this, styles)
            },
            animate: function(params, options, complete) {
                return baseAnimate(this, params, options, complete)
            },
            sharp: function(pos, sharpDirection) {
                return this.attr({
                    sharp: pos || true,
                    sharpDirection: sharpDirection
                })
            },
            _applyTransformation: function() {
                var tr = this._settings;
                var rotateX;
                var rotateY;
                var transformations = [];
                var sharpMode = tr.sharp;
                var trDirection = tr.sharpDirection || 1;
                var strokeOdd = tr[KEY_STROKE_WIDTH] % 2;
                var correctionX = strokeOdd && ("h" === sharpMode || true === sharpMode) ? SHARPING_CORRECTION * trDirection : 0;
                var correctionY = strokeOdd && ("v" === sharpMode || true === sharpMode) ? SHARPING_CORRECTION * trDirection : 0;
                transformations.push("translate(" + ((tr.translateX || 0) + correctionX) + "," + ((tr.translateY || 0) + correctionY) + ")");
                if (tr.rotate) {
                    if ("rotateX" in tr) {
                        rotateX = tr.rotateX
                    } else {
                        rotateX = tr.x
                    }
                    if ("rotateY" in tr) {
                        rotateY = tr.rotateY
                    } else {
                        rotateY = tr.y
                    }
                    transformations.push("rotate(" + tr.rotate + "," + (rotateX || 0) + "," + (rotateY || 0) + ")")
                }
                var scaleXDefined = (0, _type.isDefined)(tr.scaleX);
                var scaleYDefined = (0, _type.isDefined)(tr.scaleY);
                if (scaleXDefined || scaleYDefined) {
                    transformations.push("scale(" + (scaleXDefined ? tr.scaleX : 1) + "," + (scaleYDefined ? tr.scaleY : 1) + ")")
                }
                if (transformations.length) {
                    this.element.setAttribute("transform", transformations.join(" "))
                }
            },
            move: function(x, y, animate, animOptions) {
                var obj = {};
                (0, _type.isDefined)(x) && (obj.translateX = x);
                (0, _type.isDefined)(y) && (obj.translateY = y);
                if (!animate) {
                    this.attr(obj)
                } else {
                    this.animate(obj, animOptions)
                }
                return this
            },
            rotate: function(angle, x, y, animate, animOptions) {
                var obj = {
                    rotate: angle || 0
                };
                (0, _type.isDefined)(x) && (obj.rotateX = x);
                (0, _type.isDefined)(y) && (obj.rotateY = y);
                if (!animate) {
                    this.attr(obj)
                } else {
                    this.animate(obj, animOptions)
                }
                return this
            },
            _getElementBBox: function() {
                var elem = this.element;
                var bBox;
                try {
                    bBox = elem.getBBox && elem.getBBox()
                } catch (e) {}
                return bBox || {
                    x: 0,
                    y: 0,
                    width: elem.offsetWidth || 0,
                    height: elem.offsetHeight || 0
                }
            },
            getBBox: function() {
                var transformation = this._settings;
                var bBox = this._getElementBBox();
                if (transformation.rotate) {
                    bBox = (0, _utils.rotateBBox)(bBox, [("rotateX" in transformation ? transformation.rotateX : transformation.x) || 0, ("rotateY" in transformation ? transformation.rotateY : transformation.y) || 0], -transformation.rotate)
                } else {
                    bBox = (0, _utils.normalizeBBox)(bBox)
                }
                return bBox
            },
            markup: function() {
                return (0, _svg.getSvgMarkup)(this.element)
            },
            getOffset: function() {
                return this._getJQElement().offset()
            },
            stopAnimation: function(disableComplete) {
                var animation = this.animation;
                animation && animation.stop(disableComplete);
                return this
            },
            setTitle: function(text) {
                var titleElem = createElement("title");
                titleElem.textContent = text || "";
                this.element.appendChild(titleElem)
            },
            removeTitle: function() {
                detachTitleElements(this.element)
            },
            data: function(obj, val) {
                var elem = this.element;
                var key;
                if (void 0 !== val) {
                    elem[obj] = val
                } else {
                    for (key in obj) {
                        elem[key] = obj[key]
                    }
                }
                return this
            },
            on: function() {
                var args = [this._getJQElement()];
                args.push.apply(args, arguments);
                _events_engine.default.on.apply(_events_engine.default, args);
                return this
            },
            off: function() {
                var args = [this._getJQElement()];
                args.push.apply(args, arguments);
                _events_engine.default.off.apply(_events_engine.default, args);
                return this
            },
            trigger: function() {
                var args = [this._getJQElement()];
                args.push.apply(args, arguments);
                _events_engine.default.trigger.apply(_events_engine.default, args);
                return this
            }
        };
        var PathSvgElement = function(renderer, type) {
            SvgElement.call(this, renderer, "path", type)
        };
        exports.PathSvgElement = PathSvgElement;
        PathSvgElement.prototype = objectCreate(SvgElement.prototype);
        extend(PathSvgElement.prototype, {
            constructor: PathSvgElement,
            attr: pathAttr,
            animate: pathAnimate
        });
        var ArcSvgElement = function(renderer) {
            SvgElement.call(this, renderer, "path", "arc")
        };
        exports.ArcSvgElement = ArcSvgElement;
        ArcSvgElement.prototype = objectCreate(SvgElement.prototype);
        extend(ArcSvgElement.prototype, {
            constructor: ArcSvgElement,
            attr: arcAttr,
            animate: arcAnimate
        });
        var RectSvgElement = function(renderer) {
            SvgElement.call(this, renderer, "rect")
        };
        exports.RectSvgElement = RectSvgElement;
        RectSvgElement.prototype = objectCreate(SvgElement.prototype);
        extend(RectSvgElement.prototype, {
            constructor: RectSvgElement,
            attr: rectAttr
        });
        var TextSvgElement = function(renderer) {
            SvgElement.call(this, renderer, "text");
            this.css({
                "white-space": "pre"
            })
        };
        exports.TextSvgElement = TextSvgElement;
        TextSvgElement.prototype = objectCreate(SvgElement.prototype);
        extend(TextSvgElement.prototype, {
            constructor: TextSvgElement,
            attr: textAttr,
            css: textCss,
            applyEllipsis: applyEllipsis,
            setMaxSize: setMaxSize,
            restoreText: restoreText,
            _getLineHeight: function() {
                return !isNaN(parseFloat(this._styles[KEY_FONT_SIZE])) ? this._styles[KEY_FONT_SIZE] : DEFAULT_FONT_SIZE
            }
        });

        function updateIndexes(items, k) {
            var i;
            var item;
            for (i = k; item = items[i]; ++i) {
                item._link.i = i
            }
        }

        function linkItem(target, container) {
            var items = container._links;
            var key = target._link.after = target._link.after || container._linkAfter;
            var i;
            var item;
            if (key) {
                for (i = 0;
                    (item = items[i]) && item._link.name !== key; ++i) {}
                if (item) {
                    for (++i;
                        (item = items[i]) && item._link.after === key; ++i) {}
                }
            } else {
                i = items.length
            }
            items.splice(i, 0, target);
            updateIndexes(items, i)
        }

        function unlinkItem(target) {
            var i;
            var items = target._link.to._links;
            for (i = 0; items[i] !== target; ++i) {}
            items.splice(i, 1);
            updateIndexes(items, i)
        }

        function Renderer(options) {
            var that = this;
            that.root = that._createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                version: "1.1",
                fill: NONE,
                stroke: NONE,
                "stroke-width": 0
            }).attr({
                "class": options.cssClass
            }).css({
                "line-height": "normal",
                "-ms-user-select": NONE,
                "-moz-user-select": NONE,
                "-webkit-user-select": NONE,
                "-webkit-tap-highlight-color": "rgba(0, 0, 0, 0)",
                display: "block",
                overflow: "hidden"
            });
            that._init();
            that.pathModified = !!options.pathModified;
            that._$container = (0, _renderer.default)(options.container);
            that.root.append({
                element: options.container
            });
            that.fixPlacement();
            that._locker = 0;
            that._backed = false
        }
        Renderer.prototype = {
            constructor: Renderer,
            _init: function() {
                var that = this;
                that._defs = that._createElement("defs").append(that.root);
                that._animationController = new _animation.AnimationController(that.root.element);
                that._animation = {
                    enabled: true,
                    duration: 1e3,
                    easing: "easeOutCubic"
                }
            },
            fixPlacement: function() {
                if (!_browser.default.mozilla && !_browser.default.msie) {
                    return
                }
                var box = getBoundingClientRect(this._$container.get(0));
                var dx = roundValue(box.left % 1, 2);
                var dy = roundValue(box.top % 1, 2);
                if (_browser.default.msie) {
                    this.root.css({
                        transform: "translate(" + -dx + "px," + -dy + "px)"
                    })
                } else {
                    if (_browser.default.mozilla) {
                        this.root.move(-dx, -dy)
                    }
                }
            },
            removePlacementFix: function() {
                if (!_browser.default.mozilla && !_browser.default.msie) {
                    return
                }
                if (_browser.default.msie) {
                    this.root.css({
                        transform: ""
                    })
                } else {
                    if (_browser.default.mozilla) {
                        this.root.attr({
                            transform: null
                        })
                    }
                }
            },
            setOptions: function(options) {
                var that = this;
                that.rtl = !!options.rtl;
                that.encodeHtml = !!options.encodeHtml;
                that.updateAnimationOptions(options.animation || {});
                that.root.attr({
                    direction: that.rtl ? "rtl" : "ltr"
                });
                return that
            },
            _createElement: function(tagName, attr, type) {
                var elem = new SvgElement(this, tagName, type);
                attr && elem.attr(attr);
                return elem
            },
            lock: function() {
                var that = this;
                if (0 === that._locker) {
                    that._backed = !that._$container.is(":visible");
                    if (that._backed) {
                        backupRoot(that.root)
                    }
                }++that._locker;
                return that
            },
            unlock: function() {
                var that = this;
                --that._locker;
                if (0 === that._locker) {
                    if (that._backed) {
                        restoreRoot(that.root, that._$container[0]);
                        that.fixPlacement()
                    }
                    that._backed = false
                }
                return that
            },
            resize: function(width, height) {
                if (width >= 0 && height >= 0) {
                    this.root.attr({
                        width: width,
                        height: height
                    })
                }
                return this
            },
            dispose: function() {
                var that = this;
                var key;
                that.root.dispose();
                that._defs.dispose();
                that._animationController.dispose();
                fixFuncIriCallbacks.removeByRenderer(that);
                for (key in that) {
                    that[key] = null
                }
                return that
            },
            animationEnabled: function() {
                return !!this._animation.enabled
            },
            updateAnimationOptions: function(newOptions) {
                extend(this._animation, newOptions);
                return this
            },
            stopAllAnimations: function(lock) {
                this._animationController[lock ? "lock" : "stop"]();
                return this
            },
            animateElement: function(element, params, options) {
                this._animationController.animateElement(element, params, options);
                return this
            },
            svg: function() {
                this.removePlacementFix();
                var markup = this.root.markup();
                this.fixPlacement();
                return markup
            },
            getRootOffset: function() {
                return this.root.getOffset()
            },
            onEndAnimation: function(endAnimation) {
                this._animationController.onEndAnimation(endAnimation)
            },
            rect: function(x, y, width, height) {
                var elem = new RectSvgElement(this);
                return elem.attr({
                    x: x || 0,
                    y: y || 0,
                    width: width || 0,
                    height: height || 0
                })
            },
            simpleRect: function() {
                return this._createElement("rect")
            },
            circle: function(x, y, r) {
                return this._createElement("circle", {
                    cx: x || 0,
                    cy: y || 0,
                    r: r || 0
                })
            },
            g: function() {
                return this._createElement("g")
            },
            image: function image(x, y, w, h, href, location) {
                var image = this._createElement("image", {
                    x: x || 0,
                    y: y || 0,
                    width: w || 0,
                    height: h || 0,
                    preserveAspectRatio: preserveAspectRatioMap[(0, _utils.normalizeEnum)(location)] || NONE
                });
                image.element.setAttributeNS("http://www.w3.org/1999/xlink", "href", href || "");
                return image
            },
            path: function(points, type) {
                var elem = new PathSvgElement(this, type);
                return elem.attr({
                    points: points || []
                })
            },
            arc: function(x, y, innerRadius, outerRadius, startAngle, endAngle) {
                var elem = new ArcSvgElement(this);
                return elem.attr({
                    x: x || 0,
                    y: y || 0,
                    innerRadius: innerRadius || 0,
                    outerRadius: outerRadius || 0,
                    startAngle: startAngle || 0,
                    endAngle: endAngle || 0
                })
            },
            text: function(_text, x, y) {
                var elem = new TextSvgElement(this);
                return elem.attr({
                    text: _text,
                    x: x || 0,
                    y: y || 0
                })
            },
            linearGradient: function(stops) {
                var id = getNextDefsSvgId();
                var that = this;
                var gradient = that._createElement("linearGradient", {
                    id: id
                }).append(that._defs);
                gradient.id = id;
                stops.forEach(function(stop) {
                    that._createElement("stop", {
                        offset: stop.offset,
                        "stop-color": stop["stop-color"]
                    }).append(gradient)
                });
                return gradient
            },
            pattern: function pattern(color, hatching, _id) {
                hatching = hatching || {};
                var that = this;
                var step = hatching.step || 6;
                var stepTo2 = step / 2;
                var stepBy15 = 1.5 * step;
                var id = _id || getNextDefsSvgId();
                var d = "right" === (0, _utils.normalizeEnum)(hatching.direction) ? "M " + stepTo2 + " " + -stepTo2 + " L " + -stepTo2 + " " + stepTo2 + " M 0 " + step + " L " + step + " 0 M " + stepBy15 + " " + stepTo2 + " L " + stepTo2 + " " + stepBy15 : "M 0 0 L " + step + " " + step + " M " + -stepTo2 + " " + stepTo2 + " L " + stepTo2 + " " + stepBy15 + " M " + stepTo2 + " " + -stepTo2 + " L " + stepBy15 + " " + stepTo2;
                var pattern = that._createElement("pattern", {
                    id: id,
                    width: step,
                    height: step,
                    patternUnits: "userSpaceOnUse"
                }).append(that._defs);
                pattern.id = id;
                that.rect(0, 0, step, step).attr({
                    fill: color,
                    opacity: hatching.opacity
                }).append(pattern);
                new PathSvgElement(this).attr({
                    d: d,
                    "stroke-width": hatching.width || 1,
                    stroke: color
                }).append(pattern);
                return pattern
            },
            _getPointsWithYOffset: function(points, offset) {
                return points.map(function(point, index) {
                    if (index % 2 !== 0) {
                        return point + offset
                    }
                    return point
                })
            },
            clipShape: function(method, methodArgs) {
                var that = this;
                var id = getNextDefsSvgId();
                var clipPath = that._createElement("clipPath", {
                    id: id
                }).append(that._defs);
                var shape = method.apply(that, methodArgs).append(clipPath);
                shape.id = id;
                shape.remove = function() {
                    throw "Not implemented"
                };
                shape.dispose = function() {
                    clipPath.dispose();
                    clipPath = null;
                    return this
                };
                return shape
            },
            clipRect: function(x, y, width, height) {
                return this.clipShape(this.rect, arguments)
            },
            clipCircle: function(x, y, radius) {
                return this.clipShape(this.circle, arguments)
            },
            shadowFilter: function(x, y, width, height, offsetX, offsetY, blur, color, opacity) {
                var that = this;
                var id = getNextDefsSvgId();
                var filter = that._createElement("filter", {
                    id: id,
                    x: x || 0,
                    y: y || 0,
                    width: width || 0,
                    height: height || 0
                }).append(that._defs);
                var gaussianBlur = that._createElement("feGaussianBlur", {
                    "in": "SourceGraphic",
                    result: "gaussianBlurResult",
                    stdDeviation: blur || 0
                }).append(filter);
                var offset = that._createElement("feOffset", {
                    "in": "gaussianBlurResult",
                    result: "offsetResult",
                    dx: offsetX || 0,
                    dy: offsetY || 0
                }).append(filter);
                var flood = that._createElement("feFlood", {
                    result: "floodResult",
                    "flood-color": color || "",
                    "flood-opacity": opacity
                }).append(filter);
                var composite = that._createElement("feComposite", {
                    "in": "floodResult",
                    in2: "offsetResult",
                    operator: "in",
                    result: "compositeResult"
                }).append(filter);
                var finalComposite = that._createElement("feComposite", {
                    "in": "SourceGraphic",
                    in2: "compositeResult",
                    operator: "over"
                }).append(filter);
                filter.id = id;
                filter.gaussianBlur = gaussianBlur;
                filter.offset = offset;
                filter.flood = flood;
                filter.composite = composite;
                filter.finalComposite = finalComposite;
                filter.attr = function(attrs) {
                    var that = this;
                    var filterAttrs = {};
                    var offsetAttrs = {};
                    var floodAttrs = {};
                    "x" in attrs && (filterAttrs.x = attrs.x);
                    "y" in attrs && (filterAttrs.y = attrs.y);
                    "width" in attrs && (filterAttrs.width = attrs.width);
                    "height" in attrs && (filterAttrs.height = attrs.height);
                    baseAttr(that, filterAttrs);
                    "blur" in attrs && that.gaussianBlur.attr({
                        stdDeviation: attrs.blur
                    });
                    "offsetX" in attrs && (offsetAttrs.dx = attrs.offsetX);
                    "offsetY" in attrs && (offsetAttrs.dy = attrs.offsetY);
                    that.offset.attr(offsetAttrs);
                    "color" in attrs && (floodAttrs["flood-color"] = attrs.color);
                    "opacity" in attrs && (floodAttrs["flood-opacity"] = attrs.opacity);
                    that.flood.attr(floodAttrs);
                    return that
                };
                return filter
            },
            brightFilter: function(type, slope) {
                var that = this;
                var id = getNextDefsSvgId();
                var filter = that._createElement("filter", {
                    id: id
                }).append(that._defs);
                var componentTransferElement = that._createElement("feComponentTransfer").append(filter);
                var attrs = {
                    type: type,
                    slope: slope
                };
                filter.id = id;
                that._createElement("feFuncR", attrs).append(componentTransferElement);
                that._createElement("feFuncG", attrs).append(componentTransferElement);
                that._createElement("feFuncB", attrs).append(componentTransferElement);
                return filter
            },
            getGrayScaleFilter: function() {
                if (this._grayScaleFilter) {
                    return this._grayScaleFilter
                }
                var that = this;
                var id = getNextDefsSvgId();
                var filter = that._createElement("filter", {
                    id: id
                }).append(that._defs);
                that._createElement("feColorMatrix").attr({
                    type: "matrix",
                    values: "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 0.6 0"
                }).append(filter);
                filter.id = id;
                that._grayScaleFilter = filter;
                return filter
            },
            initHatching: function() {
                var storage = this._hatchingStorage = this._hatchingStorage || {
                    byHash: {},
                    baseId: getNextDefsSvgId()
                };
                var byHash = storage.byHash;
                var name;
                for (name in byHash) {
                    byHash[name].pattern.dispose()
                }
                storage.byHash = {};
                storage.refToHash = {};
                storage.nextId = 0
            },
            lockHatching: function(color, hatching, ref) {
                var storage = this._hatchingStorage;
                var hash = getHatchingHash(color, hatching);
                var storageItem;
                var pattern;
                if (storage.refToHash[ref] !== hash) {
                    if (ref) {
                        this.releaseHatching(ref)
                    }
                    storageItem = storage.byHash[hash];
                    if (!storageItem) {
                        pattern = this.pattern(color, hatching, storage.baseId + "-hatching-" + storage.nextId++);
                        storageItem = storage.byHash[hash] = {
                            pattern: pattern,
                            count: 0
                        };
                        storage.refToHash[pattern.id] = hash
                    }++storageItem.count;
                    ref = storageItem.pattern.id
                }
                return ref
            },
            releaseHatching: function(ref) {
                var storage = this._hatchingStorage;
                var hash = storage.refToHash[ref];
                var storageItem = storage.byHash[hash];
                if (storageItem && 0 === --storageItem.count) {
                    storageItem.pattern.dispose();
                    delete storage.byHash[hash];
                    delete storage.refToHash[ref]
                }
            }
        };

        function getHatchingHash(color, hatching) {
            return "@" + color + "::" + hatching.step + ":" + hatching.width + ":" + hatching.opacity + ":" + hatching.direction
        }
        var fixFuncIriCallbacks = function() {
            var callbacks = [];
            return {
                add: function(fn) {
                    callbacks.push(fn)
                },
                remove: function(fn) {
                    callbacks = callbacks.filter(function(el) {
                        return el !== fn
                    })
                },
                removeByRenderer: function(renderer) {
                    callbacks = callbacks.filter(function(el) {
                        return el.renderer !== renderer
                    })
                },
                fire: function() {
                    callbacks.forEach(function(fn) {
                        fn()
                    })
                }
            }
        }();
        var refreshPaths = function() {
            fixFuncIriCallbacks.fire()
        };
        exports.refreshPaths = refreshPaths
    },
    /*!*********************************************************!*\
      !*** ./artifacts/transpiled-npm/exporter/file_saver.js ***!
      \*********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.fileSaver = exports.MIME_TYPES = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../core/dom_adapter */ 11));
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../ui/widget/ui.errors */ 17));
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _console = __webpack_require__( /*! ../core/utils/console */ 110);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var navigator = (0, _window.getNavigator)();
        var FILE_EXTESIONS = {
            EXCEL: "xlsx",
            CSS: "css",
            PNG: "png",
            JPEG: "jpeg",
            GIF: "gif",
            SVG: "svg",
            PDF: "pdf"
        };
        var MIME_TYPES = {
            CSS: "text/css",
            EXCEL: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            PNG: "image/png",
            JPEG: "image/jpeg",
            GIF: "image/gif",
            SVG: "image/svg+xml",
            PDF: "application/pdf"
        };
        exports.MIME_TYPES = MIME_TYPES;
        var fileSaver = {
            _revokeObjectURLTimeout: 3e4,
            _getDataUri: function(format, data) {
                var mimeType = this._getMimeType(format);
                return "data:".concat(mimeType, ";base64,").concat(data)
            },
            _getMimeType: function(format) {
                return MIME_TYPES[format] || "application/octet-stream"
            },
            _linkDownloader: function(fileName, href) {
                var exportLinkElement = _dom_adapter.default.createElement("a");
                exportLinkElement.download = fileName;
                exportLinkElement.href = href;
                exportLinkElement.target = "_blank";
                return exportLinkElement
            },
            _formDownloader: function(proxyUrl, fileName, contentType, data) {
                var formAttributes = {
                    method: "post",
                    action: proxyUrl,
                    enctype: "multipart/form-data"
                };
                var exportForm = (0, _renderer.default)("<form>").css({
                    display: "none"
                }).attr(formAttributes);

                function setAttributes(element, attributes) {
                    for (var key in attributes) {
                        element.setAttribute(key, attributes[key])
                    }
                    return element
                }
                exportForm.append(setAttributes(_dom_adapter.default.createElement("input"), {
                    type: "hidden",
                    name: "fileName",
                    value: fileName
                }));
                exportForm.append(setAttributes(_dom_adapter.default.createElement("input"), {
                    type: "hidden",
                    name: "contentType",
                    value: contentType
                }));
                exportForm.append(setAttributes(_dom_adapter.default.createElement("input"), {
                    type: "hidden",
                    name: "data",
                    value: data
                }));
                exportForm.appendTo("body");
                _events_engine.default.trigger(exportForm, "submit");
                if (_events_engine.default.trigger(exportForm, "submit")) {
                    exportForm.remove()
                }
            },
            _saveByProxy: function(proxyUrl, fileName, format, data) {
                var contentType = this._getMimeType(format);
                return this._formDownloader(proxyUrl, fileName, contentType, data)
            },
            _winJSBlobSave: function(blob, fileName, format) {
                var savePicker = new Windows.Storage.Pickers.FileSavePicker;
                savePicker.suggestedStartLocation = Windows.Storage.Pickers.PickerLocationId.documentsLibrary;
                var fileExtension = FILE_EXTESIONS[format];
                if (fileExtension) {
                    var mimeType = this._getMimeType(format);
                    savePicker.fileTypeChoices.insert(mimeType, ["." + fileExtension])
                }
                savePicker.suggestedFileName = fileName;
                savePicker.pickSaveFileAsync().then(function(file) {
                    if (file) {
                        file.openAsync(Windows.Storage.FileAccessMode.readWrite).then(function(outputStream) {
                            var inputStream = blob.msDetachStream();
                            Windows.Storage.Streams.RandomAccessStream.copyAsync(inputStream, outputStream).then(function() {
                                outputStream.flushAsync().done(function() {
                                    inputStream.close();
                                    outputStream.close()
                                })
                            })
                        })
                    }
                })
            },
            _click: function(link) {
                try {
                    link.dispatchEvent(new MouseEvent("click", {
                        cancelable: true
                    }))
                } catch (e) {
                    var event = _dom_adapter.default.getDocument().createEvent("MouseEvents");
                    event.initMouseEvent("click", true, true, window, 0, 0, 0, 80, 20, false, false, false, false, 0, null);
                    link.dispatchEvent(event)
                }
            },
            _saveBlobAs: function(fileName, format, data) {
                var _this = this;
                this._blobSaved = false;
                if ((0, _type.isDefined)(navigator.msSaveOrOpenBlob)) {
                    navigator.msSaveOrOpenBlob(data, fileName);
                    this._blobSaved = true
                } else {
                    if ((0, _type.isDefined)(window.WinJS)) {
                        this._winJSBlobSave(data, fileName, format);
                        this._blobSaved = true
                    } else {
                        var URL = window.URL || window.webkitURL || window.mozURL || window.msURL || window.oURL;
                        if ((0, _type.isDefined)(URL)) {
                            var objectURL = URL.createObjectURL(data);
                            var downloadLink = this._linkDownloader(fileName, objectURL);
                            setTimeout(function() {
                                URL.revokeObjectURL(objectURL);
                                _this._objectUrlRevoked = true
                            }, this._revokeObjectURLTimeout);
                            this._click(downloadLink)
                        } else {
                            _console.logger.warn("window.URL || window.webkitURL || window.mozURL || window.msURL || window.oURL is not defined")
                        }
                    }
                }
            },
            saveAs: function(fileName, format, data, proxyURL, forceProxy) {
                var fileExtension = FILE_EXTESIONS[format];
                if (fileExtension) {
                    fileName += "." + fileExtension
                }
                if ((0, _type.isDefined)(proxyURL)) {
                    _ui.default.log("W0001", "Export", "proxyURL", "19.2", "This option is no longer required")
                }
                if (forceProxy) {
                    this._saveByProxy(proxyURL, fileName, format, data)
                } else {
                    if ((0, _type.isFunction)(window.Blob)) {
                        this._saveBlobAs(fileName, format, data)
                    } else {
                        if ((0, _type.isDefined)(proxyURL) && !(0, _type.isDefined)(navigator.userAgent.match(/iPad/i))) {
                            this._saveByProxy(proxyURL, fileName, format, data)
                        } else {
                            if (!(0, _type.isDefined)(navigator.userAgent.match(/iPad/i))) {
                                _ui.default.log("E1034")
                            }
                            var downloadLink = this._linkDownloader(fileName, this._getDataUri(format, data));
                            this._click(downloadLink)
                        }
                    }
                }
            }
        };
        exports.fileSaver = fileSaver
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/events/contextmenu.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.name = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _support = __webpack_require__( /*! ../core/utils/support */ 45);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../core/devices */ 13));
        var _class = _interopRequireDefault(__webpack_require__( /*! ../core/class */ 15));
        var _event_registrator = _interopRequireDefault(__webpack_require__( /*! ./core/event_registrator */ 74));
        var _index = __webpack_require__( /*! ./utils/index */ 8);
        var _hold = _interopRequireDefault(__webpack_require__( /*! ./hold */ 104));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var CONTEXTMENU_NAMESPACE = "dxContexMenu";
        var CONTEXTMENU_NAMESPACED_EVENT_NAME = (0, _index.addNamespace)("contextmenu", CONTEXTMENU_NAMESPACE);
        var HOLD_NAMESPACED_EVENT_NAME = (0, _index.addNamespace)(_hold.default.name, CONTEXTMENU_NAMESPACE);
        var CONTEXTMENU_EVENT_NAME = "dxcontextmenu";
        var ContextMenu = _class.default.inherit({
            setup: function(element) {
                var $element = (0, _renderer.default)(element);
                _events_engine.default.on($element, CONTEXTMENU_NAMESPACED_EVENT_NAME, this._contextMenuHandler.bind(this));
                if (_support.touch || _devices.default.isSimulator()) {
                    _events_engine.default.on($element, HOLD_NAMESPACED_EVENT_NAME, this._holdHandler.bind(this))
                }
            },
            _holdHandler: function(e) {
                if ((0, _index.isMouseEvent)(e) && !_devices.default.isSimulator()) {
                    return
                }
                this._fireContextMenu(e)
            },
            _contextMenuHandler: function(e) {
                if (_support.touch || _devices.default.isSimulator()) {
                    e.preventDefault()
                }
                this._fireContextMenu(e)
            },
            _fireContextMenu: function(e) {
                return (0, _index.fireEvent)({
                    type: CONTEXTMENU_EVENT_NAME,
                    originalEvent: e
                })
            },
            teardown: function(element) {
                _events_engine.default.off(element, "." + CONTEXTMENU_NAMESPACE)
            }
        });
        (0, _event_registrator.default)(CONTEXTMENU_EVENT_NAME, new ContextMenu);
        var name = CONTEXTMENU_EVENT_NAME;
        exports.name = name
    },
    /*!***************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/load_panel.js ***!
      \***************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../localization/message */ 10));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _load_indicator = _interopRequireDefault(__webpack_require__( /*! ./load_indicator */ 83));
        var _overlay = _interopRequireDefault(__webpack_require__( /*! ./overlay */ 64));
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);
        var _themes = __webpack_require__( /*! ./themes */ 34);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var LOADPANEL_CLASS = "dx-loadpanel";
        var LOADPANEL_WRAPPER_CLASS = "dx-loadpanel-wrapper";
        var LOADPANEL_INDICATOR_CLASS = "dx-loadpanel-indicator";
        var LOADPANEL_MESSAGE_CLASS = "dx-loadpanel-message";
        var LOADPANEL_CONTENT_CLASS = "dx-loadpanel-content";
        var LOADPANEL_CONTENT_WRAPPER_CLASS = "dx-loadpanel-content-wrapper";
        var LOADPANEL_PANE_HIDDEN_CLASS = "dx-loadpanel-pane-hidden";
        var LoadPanel = _overlay.default.inherit({
            _supportedKeys: function() {
                return (0, _extend.extend)(this.callBase(), {
                    escape: _common.noop
                })
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    message: _message.default.format("Loading"),
                    width: 222,
                    height: 90,
                    animation: null,
                    showIndicator: true,
                    indicatorSrc: "",
                    showPane: true,
                    delay: 0,
                    templatesRenderAsynchronously: false,
                    hideTopOverlayHandler: null,
                    resizeEnabled: false,
                    focusStateEnabled: false
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: {
                        platform: "generic"
                    },
                    options: {
                        shadingColor: "transparent"
                    }
                }, {
                    device: function() {
                        return (0, _themes.isMaterial)()
                    },
                    options: {
                        message: "",
                        width: 60,
                        height: 60,
                        maxHeight: 60,
                        maxWidth: 60
                    }
                }])
            },
            _init: function() {
                this.callBase.apply(this, arguments)
            },
            _render: function() {
                this.callBase();
                this.$element().addClass(LOADPANEL_CLASS);
                this._wrapper().addClass(LOADPANEL_WRAPPER_CLASS)
            },
            _renderContentImpl: function() {
                this.callBase();
                this.$content().addClass(LOADPANEL_CONTENT_CLASS);
                this._$contentWrapper = (0, _renderer.default)("<div>").addClass(LOADPANEL_CONTENT_WRAPPER_CLASS);
                this._$contentWrapper.appendTo(this._$content);
                this._togglePaneVisible();
                this._cleanPreviousContent();
                this._renderLoadIndicator();
                this._renderMessage()
            },
            _show: function() {
                var delay = this.option("delay");
                if (!delay) {
                    return this.callBase()
                }
                var deferred = new _deferred.Deferred;
                var callBase = this.callBase.bind(this);
                this._clearShowTimeout();
                this._showTimeout = setTimeout(function() {
                    callBase().done(function() {
                        deferred.resolve()
                    })
                }, delay);
                return deferred.promise()
            },
            _hide: function() {
                this._clearShowTimeout();
                return this.callBase()
            },
            _clearShowTimeout: function() {
                clearTimeout(this._showTimeout)
            },
            _renderMessage: function() {
                if (!this._$contentWrapper) {
                    return
                }
                var message = this.option("message");
                if (!message) {
                    return
                }
                var $message = (0, _renderer.default)("<div>").addClass(LOADPANEL_MESSAGE_CLASS).text(message);
                this._$contentWrapper.append($message)
            },
            _renderLoadIndicator: function() {
                if (!this._$contentWrapper || !this.option("showIndicator")) {
                    return
                }
                if (!this._$indicator) {
                    this._$indicator = (0, _renderer.default)("<div>").addClass(LOADPANEL_INDICATOR_CLASS).appendTo(this._$contentWrapper)
                }
                this._createComponent(this._$indicator, _load_indicator.default, {
                    indicatorSrc: this.option("indicatorSrc")
                })
            },
            _cleanPreviousContent: function() {
                this.$content().find("." + LOADPANEL_MESSAGE_CLASS).remove();
                this.$content().find("." + LOADPANEL_INDICATOR_CLASS).remove();
                delete this._$indicator
            },
            _togglePaneVisible: function() {
                this.$content().toggleClass(LOADPANEL_PANE_HIDDEN_CLASS, !this.option("showPane"))
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "delay":
                        break;
                    case "message":
                    case "showIndicator":
                        this._cleanPreviousContent();
                        this._renderLoadIndicator();
                        this._renderMessage();
                        break;
                    case "showPane":
                        this._togglePaneVisible();
                        break;
                    case "indicatorSrc":
                        this._renderLoadIndicator();
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _dispose: function() {
                this._clearShowTimeout();
                this.callBase()
            }
        });
        (0, _component_registrator.default)("dxLoadPanel", LoadPanel);
        var _default = LoadPanel;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/drawer/ui.drawer.animation.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.animation = void 0;
        var _fx = _interopRequireDefault(__webpack_require__( /*! ../../animation/fx */ 42));
        var _inflector = __webpack_require__( /*! ../../core/utils/inflector */ 39);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var animation = {
            moveTo: function(config) {
                var $element = config.$element;
                var position = config.position;
                var direction = config.direction || "left";
                var toConfig = {};
                var animationType;
                switch (direction) {
                    case "right":
                        toConfig.transform = "translate(" + position + "px, 0px)";
                        animationType = "custom";
                        break;
                    case "left":
                        toConfig.left = position;
                        animationType = "slide";
                        break;
                    case "top":
                    case "bottom":
                        toConfig.top = position;
                        animationType = "slide"
                }
                _fx.default.animate($element, {
                    type: animationType,
                    to: toConfig,
                    duration: config.duration,
                    complete: config.complete
                })
            },
            margin: function margin(config) {
                var $element = config.$element;
                var margin = config.margin;
                var direction = config.direction || "left";
                var toConfig = {};
                toConfig["margin" + (0, _inflector.camelize)(direction, true)] = margin;
                _fx.default.animate($element, {
                    to: toConfig,
                    duration: config.duration,
                    complete: config.complete
                })
            },
            fade: function($element, config, duration, completeAction) {
                _fx.default.animate($element, {
                    type: "fade",
                    to: config.to,
                    from: config.from,
                    duration: duration,
                    complete: completeAction
                })
            },
            size: function size(config) {
                var $element = config.$element;
                var size = config.size;
                var direction = config.direction || "left";
                var marginTop = config.marginTop || 0;
                var duration = config.duration;
                var toConfig = {};
                if ("right" === direction || "left" === direction) {
                    toConfig.width = size
                } else {
                    toConfig.height = size
                }
                if ("bottom" === direction) {
                    toConfig.marginTop = marginTop
                }
                _fx.default.animate($element, {
                    to: toConfig,
                    duration: duration,
                    complete: config.complete
                })
            },
            complete: function($element) {
                _fx.default.stop($element, true)
            }
        };
        exports.animation = animation
    },
    /*!*********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/shared/filtering.js ***!
      \*********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var DEFAULT_DATE_INTERVAL = ["year", "month", "day"];
        var DEFAULT_DATETIME_INTERVAL = ["year", "month", "day", "hour", "minute"];
        var isDateType = function(dataType) {
            return "date" === dataType || "datetime" === dataType
        };
        var getGroupInterval = function(column) {
            var index;
            var result = [];
            var dateIntervals = ["year", "month", "day", "hour", "minute", "second"];
            var groupInterval = column.headerFilter && column.headerFilter.groupInterval;
            var interval = "quarter" === groupInterval ? "month" : groupInterval;
            if (isDateType(column.dataType) && null !== groupInterval) {
                result = "datetime" === column.dataType ? DEFAULT_DATETIME_INTERVAL : DEFAULT_DATE_INTERVAL;
                index = (0, _array.inArray)(interval, dateIntervals);
                if (index >= 0) {
                    result = dateIntervals.slice(0, index);
                    result.push(groupInterval);
                    return result
                }
                return result
            } else {
                if ((0, _type.isDefined)(groupInterval)) {
                    return Array.isArray(groupInterval) ? groupInterval : [groupInterval]
                }
            }
        };
        var _default = function() {
            var getFilterSelector = function(column, target) {
                var selector = column.dataField || column.selector;
                if ("search" === target) {
                    selector = column.displayField || column.calculateDisplayValue || selector
                }
                return selector
            };
            var isZeroTime = function(date) {
                return date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds() < 1
            };
            var getDateValues = function(dateValue) {
                if ((0, _type.isDate)(dateValue)) {
                    return [dateValue.getFullYear(), dateValue.getMonth(), dateValue.getDate(), dateValue.getHours(), dateValue.getMinutes(), dateValue.getSeconds()]
                }
                return (0, _iterator.map)(("" + dateValue).split("/"), function(value, index) {
                    return 1 === index ? Number(value) - 1 : Number(value)
                })
            };
            var getFilterExpressionByRange = function(filterValue, target) {
                var column = this;
                var endFilterValue;
                var startFilterExpression;
                var endFilterExpression;
                var selector = getFilterSelector(column, target);
                if (Array.isArray(filterValue) && (0, _type.isDefined)(filterValue[0]) && (0, _type.isDefined)(filterValue[1])) {
                    startFilterExpression = [selector, ">=", filterValue[0]];
                    endFilterExpression = [selector, "<=", filterValue[1]];
                    if (isDateType(column.dataType) && isZeroTime(filterValue[1])) {
                        endFilterValue = new Date(filterValue[1].getTime());
                        if ("date" === column.dataType) {
                            endFilterValue.setDate(filterValue[1].getDate() + 1)
                        }
                        endFilterExpression = [selector, "<", endFilterValue]
                    }
                    return [startFilterExpression, "and", endFilterExpression]
                }
            };
            var getFilterExpressionForDate = function(filterValue, selectedFilterOperation, target) {
                var column = this;
                var dateStart;
                var dateEnd;
                var dateInterval;
                var values = getDateValues(filterValue);
                var selector = getFilterSelector(column, target);
                if ("headerFilter" === target) {
                    dateInterval = getGroupInterval(column)[values.length - 1]
                } else {
                    if ("datetime" === column.dataType) {
                        dateInterval = "minute"
                    }
                }
                switch (dateInterval) {
                    case "year":
                        dateStart = new Date(values[0], 0, 1);
                        dateEnd = new Date(values[0] + 1, 0, 1);
                        break;
                    case "month":
                        dateStart = new Date(values[0], values[1], 1);
                        dateEnd = new Date(values[0], values[1] + 1, 1);
                        break;
                    case "quarter":
                        dateStart = new Date(values[0], 3 * values[1], 1);
                        dateEnd = new Date(values[0], 3 * values[1] + 3, 1);
                        break;
                    case "hour":
                        dateStart = new Date(values[0], values[1], values[2], values[3]);
                        dateEnd = new Date(values[0], values[1], values[2], values[3] + 1);
                        break;
                    case "minute":
                        dateStart = new Date(values[0], values[1], values[2], values[3], values[4]);
                        dateEnd = new Date(values[0], values[1], values[2], values[3], values[4] + 1);
                        break;
                    case "second":
                        dateStart = new Date(values[0], values[1], values[2], values[3], values[4], values[5]);
                        dateEnd = new Date(values[0], values[1], values[2], values[3], values[4], values[5] + 1);
                        break;
                    default:
                        dateStart = new Date(values[0], values[1], values[2]);
                        dateEnd = new Date(values[0], values[1], values[2] + 1)
                }
                switch (selectedFilterOperation) {
                    case "<":
                        return [selector, "<", dateStart];
                    case "<=":
                        return [selector, "<", dateEnd];
                    case ">":
                        return [selector, ">=", dateEnd];
                    case ">=":
                        return [selector, ">=", dateStart];
                    case "<>":
                        return [
                            [selector, "<", dateStart], "or", [selector, ">=", dateEnd]
                        ];
                    default:
                        return [
                            [selector, ">=", dateStart], "and", [selector, "<", dateEnd]
                        ]
                }
            };
            var getFilterExpressionForNumber = function(filterValue, selectedFilterOperation, target) {
                var column = this;
                var selector = getFilterSelector(column, target);
                var groupInterval = getGroupInterval(column);
                if ("headerFilter" === target && groupInterval && (0, _type.isDefined)(filterValue)) {
                    var values = ("" + filterValue).split("/");
                    var value = Number(values[values.length - 1]);
                    var interval = groupInterval[values.length - 1];
                    var startFilterValue = [selector, ">=", value];
                    var endFilterValue = [selector, "<", value + interval];
                    var condition = [startFilterValue, "and", endFilterValue];
                    return condition
                }
                return [selector, selectedFilterOperation || "=", filterValue]
            };
            return {
                defaultCalculateFilterExpression: function(filterValue, selectedFilterOperation, target) {
                    var column = this;
                    var selector = getFilterSelector(column, target);
                    var isSearchByDisplayValue = column.calculateDisplayValue && "search" === target;
                    var dataType = isSearchByDisplayValue && column.lookup && column.lookup.dataType || column.dataType;
                    var filter = null;
                    if (("headerFilter" === target || "filterBuilder" === target) && null === filterValue) {
                        filter = [selector, selectedFilterOperation || "=", null];
                        if ("string" === dataType) {
                            filter = [filter, "=" === selectedFilterOperation ? "or" : "and", [selector, selectedFilterOperation || "=", ""]]
                        }
                    } else {
                        if ("string" === dataType && (!column.lookup || isSearchByDisplayValue)) {
                            filter = [selector, selectedFilterOperation || "contains", filterValue]
                        } else {
                            if ("between" === selectedFilterOperation) {
                                return getFilterExpressionByRange.apply(column, [filterValue, target])
                            } else {
                                if (isDateType(dataType) && (0, _type.isDefined)(filterValue)) {
                                    return getFilterExpressionForDate.apply(column, arguments)
                                } else {
                                    if ("number" === dataType) {
                                        return getFilterExpressionForNumber.apply(column, arguments)
                                    } else {
                                        if ("object" !== dataType) {
                                            filter = [selector, selectedFilterOperation || "=", filterValue]
                                        }
                                    }
                                }
                            }
                        }
                    }
                    return filter
                },
                getGroupInterval: getGroupInterval
            }
        }();
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.columns_view.js ***!
      \****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.ColumnsView = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _element_data = __webpack_require__( /*! ../../core/element_data */ 40);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../../events/pointer */ 24));
        var _click = __webpack_require__( /*! ../../events/click */ 21);
        var _double_click = __webpack_require__( /*! ../../events/double_click */ 151);
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _style = __webpack_require__( /*! ../../core/utils/style */ 99);
        var _element = __webpack_require__( /*! ../../core/element */ 18);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _position = __webpack_require__( /*! ../../core/utils/position */ 22);
        var iteratorUtils = _interopRequireWildcard(__webpack_require__( /*! ../../core/utils/iterator */ 3));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.modules */ 44));
        var _uiGrid_core2 = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.utils */ 35));
        var _uiGrid_core3 = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.column_state_mixin */ 380));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var SCROLL_CONTAINER_CLASS = "scroll-container";
        var GROUP_SPACE_CLASS = "group-space";
        var CONTENT_CLASS = "content";
        var TABLE_CLASS = "table";
        var TABLE_FIXED_CLASS = "table-fixed";
        var CONTENT_FIXED_CLASS = "content-fixed";
        var ROW_CLASS = "dx-row";
        var GROUP_ROW_CLASS = "dx-group-row";
        var DETAIL_ROW_CLASS = "dx-master-detail-row";
        var FILTER_ROW_CLASS = "filter-row";
        var CELL_UPDATED_ANIMATION_CLASS = "cell-updated-animation";
        var HIDDEN_COLUMNS_WIDTH = "0.0001px";
        var CELL_HINT_VISIBLE = "dxCellHintVisible";
        var FORM_FIELD_ITEM_CONTENT_CLASS = "dx-field-item-content";
        var appendElementTemplate = {
            render: function(options) {
                options.container.append(options.content)
            }
        };
        var subscribeToRowEvents = function(that, $table) {
            var touchTarget;
            var touchCurrentTarget;
            var timeoutId;

            function clearTouchTargets(timeout) {
                return setTimeout(function() {
                    touchTarget = touchCurrentTarget = null
                }, timeout)
            }
            _events_engine.default.on($table, "touchstart touchend", ".dx-row", function(e) {
                clearTimeout(timeoutId);
                if ("touchstart" === e.type) {
                    touchTarget = e.target;
                    touchCurrentTarget = e.currentTarget;
                    timeoutId = clearTouchTargets(1e3)
                } else {
                    timeoutId = clearTouchTargets()
                }
            });
            _events_engine.default.on($table, [_click.name, _double_click.name, _pointer.default.down].join(" "), ".dx-row", {
                useNative: that._isNativeClick()
            }, that.createAction(function(e) {
                var event = e.event;
                if (touchTarget) {
                    event.target = touchTarget;
                    event.currentTarget = touchCurrentTarget
                }
                if (!(0, _renderer.default)(event.target).closest("a").length) {
                    e.rowIndex = that.getRowIndex(event.currentTarget);
                    if (e.rowIndex >= 0) {
                        e.rowElement = (0, _element.getPublicElement)((0, _renderer.default)(event.currentTarget));
                        e.columns = that.getColumns();
                        if (event.type === _pointer.default.down) {
                            that._rowPointerDown(e)
                        } else {
                            if (event.type === _click.name) {
                                that._rowClick(e)
                            } else {
                                that._rowDblClick(e)
                            }
                        }
                    }
                }
            }))
        };
        var getWidthStyle = function(width) {
            if ("auto" === width) {
                return ""
            }
            return (0, _type.isNumeric)(width) ? width + "px" : width
        };
        var setCellWidth = function(cell, column, width) {
            cell.style.width = cell.style.maxWidth = "auto" === column.width ? "" : width
        };
        var copyAttributes = function(element, newElement) {
            if (!element || !newElement) {
                return
            }
            var oldAttributes = element.attributes;
            var newAttributes = newElement.attributes;
            var i;
            for (i = 0; i < oldAttributes.length; i++) {
                var name = oldAttributes[i].nodeName;
                if (!newElement.hasAttribute(name)) {
                    element.removeAttribute(name)
                }
            }
            for (i = 0; i < newAttributes.length; i++) {
                element.setAttribute(newAttributes[i].nodeName, newAttributes[i].nodeValue)
            }
        };
        var ColumnsView = _uiGrid_core.default.View.inherit(_uiGrid_core3.default).inherit({
            _createScrollableOptions: function() {
                var that = this;
                var scrollingOptions = that.option("scrolling");
                var useNativeScrolling = that.option("scrolling.useNative");
                var options = (0, _extend.extend)({
                    pushBackValue: 0
                }, scrollingOptions, {
                    direction: "both",
                    bounceEnabled: false,
                    useKeyboard: false
                });
                if (void 0 === useNativeScrolling) {
                    useNativeScrolling = true
                }
                if ("auto" === useNativeScrolling) {
                    delete options.useNative;
                    delete options.useSimulatedScrollbar
                } else {
                    options.useNative = !!useNativeScrolling;
                    options.useSimulatedScrollbar = !useNativeScrolling
                }
                return options
            },
            _updateCell: function($cell, parameters) {
                if (parameters.rowType) {
                    this._cellPrepared($cell, parameters)
                }
            },
            _createCell: function(options) {
                var column = options.column;
                var alignment = column.alignment || (0, _position.getDefaultAlignment)(this.option("rtlEnabled"));
                var cell = _dom_adapter.default.createElement("td");
                cell.style.textAlign = alignment;
                var $cell = (0, _renderer.default)(cell);
                if ("data" === options.rowType && column.headerId && !column.type) {
                    if (this.component.option("showColumnHeaders")) {
                        this.setAria("describedby", column.headerId, $cell)
                    }
                }
                if (column.cssClass) {
                    $cell.addClass(column.cssClass)
                }
                if ("expand" === column.command) {
                    $cell.addClass(column.cssClass);
                    $cell.addClass(this.addWidgetPrefix(GROUP_SPACE_CLASS))
                }
                if (column.colspan > 1) {
                    $cell.attr("colSpan", column.colspan)
                } else {
                    if (!column.isBand && "auto" !== column.visibleWidth && !this.option("legacyRendering") && this.option("columnAutoWidth")) {
                        if (column.width || column.minWidth) {
                            cell.style.minWidth = getWidthStyle(column.minWidth || column.width)
                        }
                        if (column.width) {
                            setCellWidth(cell, column, getWidthStyle(column.width))
                        }
                    }
                }
                return $cell
            },
            _createRow: function(rowObject) {
                var $element = (0, _renderer.default)("<tr>").addClass(ROW_CLASS);
                this.setAria("role", "row", $element);
                return $element
            },
            _isAltRow: function(row) {
                return row && row.dataIndex % 2 === 1
            },
            _createTable: function(columns, isAppend) {
                var that = this;
                var $table = (0, _renderer.default)("<table>").addClass(that.addWidgetPrefix(TABLE_CLASS)).addClass(that.addWidgetPrefix(TABLE_FIXED_CLASS));
                if (columns && !isAppend) {
                    $table.append(that._createColGroup(columns));
                    if (_browser.default.safari) {
                        $table.append((0, _renderer.default)("<thead>").append("<tr>"))
                    }
                    that.setAria("role", "presentation", $table)
                } else {
                    that.setAria("hidden", true, $table)
                }
                this.setAria("role", "presentation", (0, _renderer.default)("<tbody>").appendTo($table));
                if (isAppend) {
                    return $table
                }
                if (_browser.default.mozilla) {
                    _events_engine.default.on($table, "mousedown", "td", function(e) {
                        if (e.ctrlKey) {
                            e.preventDefault()
                        }
                    })
                }
                if (that.option("cellHintEnabled")) {
                    _events_engine.default.on($table, "mousemove", ".dx-row > td", this.createAction(function(args) {
                        var e = args.event;
                        var $element = (0, _renderer.default)(e.target);
                        var $cell = (0, _renderer.default)(e.currentTarget);
                        var $row = $cell.parent();
                        var isDataRow = $row.hasClass("dx-data-row");
                        var isHeaderRow = $row.hasClass("dx-header-row");
                        var isGroupRow = $row.hasClass(GROUP_ROW_CLASS);
                        var isMasterDetailRow = $row.hasClass(DETAIL_ROW_CLASS);
                        var isFilterRow = $row.hasClass(that.addWidgetPrefix(FILTER_ROW_CLASS));
                        var visibleColumns = that._columnsController.getVisibleColumns();
                        var rowOptions = $row.data("options");
                        var columnIndex = $cell.index();
                        var cellOptions = rowOptions && rowOptions.cells && rowOptions.cells[columnIndex];
                        var column = cellOptions ? cellOptions.column : visibleColumns[columnIndex];
                        var msieCorrection = _browser.default.msie ? 1 : 0;
                        if (!isMasterDetailRow && !isFilterRow && (!isDataRow || isDataRow && column && !column.cellTemplate) && (!isHeaderRow || isHeaderRow && column && !column.headerCellTemplate) && (!isGroupRow || isGroupRow && column && (void 0 === column.groupIndex || !column.groupCellTemplate))) {
                            if ($element.data(CELL_HINT_VISIBLE)) {
                                $element.removeAttr("title");
                                $element.data(CELL_HINT_VISIBLE, false)
                            }
                            var difference = $element[0].scrollWidth - $element[0].clientWidth - msieCorrection;
                            if (difference > 0 && !(0, _type.isDefined)($element.attr("title"))) {
                                $element.attr("title", $element.text());
                                $element.data(CELL_HINT_VISIBLE, true)
                            }
                        }
                    }))
                }
                var getOptions = function(event) {
                    var $cell = (0, _renderer.default)(event.currentTarget);
                    var $fieldItemContent = (0, _renderer.default)(event.target).closest("." + FORM_FIELD_ITEM_CONTENT_CLASS);
                    var rowOptions = $cell.parent().data("options");
                    var options = rowOptions && rowOptions.cells && rowOptions.cells[$cell.index()];
                    if (!$cell.closest("table").is(event.delegateTarget)) {
                        return
                    }
                    var resultOptions = (0, _extend.extend)({}, options, {
                        cellElement: (0, _element.getPublicElement)($cell),
                        event: event,
                        eventType: event.type
                    });
                    if ($fieldItemContent.length) {
                        var formItemOptions = $fieldItemContent.data("dx-form-item");
                        if (formItemOptions.column) {
                            resultOptions.column = formItemOptions.column;
                            resultOptions.columnIndex = that._columnsController.getVisibleIndex(resultOptions.column.index)
                        }
                    }
                    return resultOptions
                };
                _events_engine.default.on($table, "mouseover", ".dx-row > td", function(e) {
                    var options = getOptions(e);
                    options && that.executeAction("onCellHoverChanged", options)
                });
                _events_engine.default.on($table, "mouseout", ".dx-row > td", function(e) {
                    var options = getOptions(e);
                    options && that.executeAction("onCellHoverChanged", options)
                });
                _events_engine.default.on($table, _click.name, ".dx-row > td", function(e) {
                    var options = getOptions(e);
                    options && that.executeAction("onCellClick", options)
                });
                _events_engine.default.on($table, _double_click.name, ".dx-row > td", function(e) {
                    var options = getOptions(e);
                    options && that.executeAction("onCellDblClick", options)
                });
                subscribeToRowEvents(that, $table);
                return $table
            },
            _isNativeClick: _common.noop,
            _rowPointerDown: _common.noop,
            _rowClick: _common.noop,
            _rowDblClick: _common.noop,
            _createColGroup: function(columns) {
                var colgroupElement = (0, _renderer.default)("<colgroup>");
                for (var i = 0; i < columns.length; i++) {
                    var colspan = columns[i].colspan || 1;
                    for (var j = 0; j < colspan; j++) {
                        colgroupElement.append(this._createCol(columns[i]))
                    }
                }
                return colgroupElement
            },
            _createCol: function(column) {
                var width = column.visibleWidth || column.width;
                if ("adaptiveHidden" === width) {
                    width = HIDDEN_COLUMNS_WIDTH
                }
                var col = (0, _renderer.default)("<col>");
                (0, _style.setWidth)(col, width);
                return col
            },
            renderDelayedTemplates: function() {
                var delayedTemplates = this._delayedTemplates;
                var syncTemplates = delayedTemplates.filter(function(template) {
                    return !template.async
                });
                var asyncTemplates = delayedTemplates.filter(function(template) {
                    return template.async
                });
                this._delayedTemplates = [];
                this._renderDelayedTemplatesCore(syncTemplates);
                this._renderDelayedTemplatesCoreAsync(asyncTemplates)
            },
            _renderDelayedTemplatesCoreAsync: function(templates) {
                var that = this;
                if (templates.length) {
                    (0, _window.getWindow)().setTimeout(function() {
                        that._renderDelayedTemplatesCore(templates, true)
                    })
                }
            },
            _renderDelayedTemplatesCore: function(templates, isAsync) {
                var date = new Date;
                while (templates.length) {
                    var templateParameters = templates.shift();
                    var options = templateParameters.options;
                    var doc = _dom_adapter.default.getDocument();
                    if (!isAsync || (0, _renderer.default)(options.container).closest(doc).length) {
                        templateParameters.template.render(options)
                    }
                    if (isAsync && new Date - date > 30) {
                        this._renderDelayedTemplatesCoreAsync(templates);
                        break
                    }
                }
                if (!templates.length && this._delayedTemplates.length) {
                    this.renderDelayedTemplates()
                }
            },
            _processTemplate: function(template) {
                var that = this;
                var renderingTemplate;
                if (template && template.render && !(0, _type.isRenderer)(template)) {
                    renderingTemplate = {
                        allowRenderToDetachedContainer: template.allowRenderToDetachedContainer,
                        render: function(options) {
                            template.render(options.container, options.model);
                            options.deferred && options.deferred.resolve()
                        }
                    }
                } else {
                    if ((0, _type.isFunction)(template)) {
                        renderingTemplate = {
                            render: function(options) {
                                var renderedTemplate = template((0, _element.getPublicElement)(options.container), options.model);
                                if (renderedTemplate && (renderedTemplate.nodeType || (0, _type.isRenderer)(renderedTemplate))) {
                                    options.container.append(renderedTemplate)
                                }
                                options.deferred && options.deferred.resolve()
                            }
                        }
                    } else {
                        var templateID = (0, _type.isString)(template) ? template : (0, _renderer.default)(template).attr("id");
                        if (!templateID) {
                            renderingTemplate = that.getTemplate(template)
                        } else {
                            if (!that._templatesCache[templateID]) {
                                that._templatesCache[templateID] = that.getTemplate(template)
                            }
                            renderingTemplate = that._templatesCache[templateID]
                        }
                    }
                }
                return renderingTemplate
            },
            renderTemplate: function(container, template, options, allowRenderToDetachedContainer) {
                var that = this;
                var renderingTemplate = that._processTemplate(template, options);
                var column = options.column;
                var isDataRow = "data" === options.rowType;
                var templateDeferred = new _deferred.Deferred;
                var templateOptions = {
                    container: container,
                    model: options,
                    deferred: templateDeferred,
                    onRendered: function() {
                        templateDeferred.resolve()
                    }
                };
                if (renderingTemplate) {
                    options.component = that.component;
                    var async = column && (column.renderAsync && isDataRow || that.option("renderAsync") && (false !== column.renderAsync && (column.command || column.showEditorAlways) && isDataRow || "filter" === options.rowType));
                    if ((renderingTemplate.allowRenderToDetachedContainer || allowRenderToDetachedContainer) && !async) {
                        renderingTemplate.render(templateOptions)
                    } else {
                        that._delayedTemplates.push({
                            template: renderingTemplate,
                            options: templateOptions,
                            async: async
                        })
                    }
                } else {
                    templateDeferred.reject()
                }
                return templateDeferred.promise()
            },
            _getBodies: function(tableElement) {
                return (0, _renderer.default)(tableElement).children("tbody").not(".dx-header").not(".dx-footer")
            },
            _wrapRowIfNeed: function($table, $row) {
                var $tBodies = this.option("rowTemplate") && this._getBodies(this._tableElement || $table);
                if ($tBodies && $tBodies.filter("." + ROW_CLASS).length) {
                    var $tbody = (0, _renderer.default)("<tbody>").addClass($row.attr("class"));
                    this.setAria("role", "presentation", $tbody);
                    return $tbody.append($row)
                }
                return $row
            },
            _appendRow: function($table, $row, appendTemplate) {
                appendTemplate = appendTemplate || appendElementTemplate;
                appendTemplate.render({
                    content: $row,
                    container: $table
                })
            },
            _resizeCore: function() {
                var scrollLeft = this._scrollLeft;
                if (scrollLeft >= 0) {
                    this._scrollLeft = 0;
                    this.scrollTo({
                        left: scrollLeft
                    })
                }
            },
            _renderCore: function(e) {
                var $root = this.element().parent();
                if (!$root || $root.parent().length) {
                    this.renderDelayedTemplates(e)
                }
            },
            _renderTable: function(options) {
                options = options || {};
                options.columns = this._columnsController.getVisibleColumns();
                var changeType = options.change && options.change.changeType;
                var $table = this._createTable(options.columns, "append" === changeType || "prepend" === changeType || "update" === changeType);
                this._renderRows($table, options);
                return $table
            },
            _renderRows: function($table, options) {
                var that = this;
                var rows = that._getRows(options.change);
                var columnIndices = options.change && options.change.columnIndices || [];
                var changeTypes = options.change && options.change.changeTypes || [];
                for (var i = 0; i < rows.length; i++) {
                    that._renderRow($table, (0, _extend.extend)({
                        row: rows[i],
                        columnIndices: columnIndices[i],
                        changeType: changeTypes[i]
                    }, options))
                }
            },
            _renderRow: function($table, options) {
                if (!options.columnIndices) {
                    options.row.cells = []
                }
                var $row = this._createRow(options.row);
                var $wrappedRow = this._wrapRowIfNeed($table, $row);
                if ("remove" !== options.changeType) {
                    this._renderCells($row, options)
                }
                this._appendRow($table, $wrappedRow);
                var rowOptions = (0, _extend.extend)({
                    columns: options.columns
                }, options.row);
                this._addWatchMethod(rowOptions, options.row);
                this._rowPrepared($wrappedRow, rowOptions, options.row)
            },
            _needRenderCell: function(columnIndex, columnIndices) {
                return !columnIndices || columnIndices.indexOf(columnIndex) >= 0
            },
            _renderCells: function($row, options) {
                var that = this;
                var columnIndex = 0;
                var row = options.row;
                var columns = options.columns;
                for (var i = 0; i < columns.length; i++) {
                    if (this._needRenderCell(i, options.columnIndices)) {
                        that._renderCell($row, (0, _extend.extend)({
                            column: columns[i],
                            columnIndex: columnIndex,
                            value: row.values && row.values[columnIndex],
                            oldValue: row.oldValues && row.oldValues[columnIndex]
                        }, options))
                    }
                    if (columns[i].colspan > 1) {
                        columnIndex += columns[i].colspan
                    } else {
                        columnIndex++
                    }
                }
            },
            _updateCells: function($rowElement, $newRowElement, columnIndices) {
                var $cells = $rowElement.children();
                var $newCells = $newRowElement.children();
                var highlightChanges = this.option("highlightChanges");
                var cellUpdatedClass = this.addWidgetPrefix(CELL_UPDATED_ANIMATION_CLASS);
                columnIndices.forEach(function(columnIndex, index) {
                    var $cell = $cells.eq(columnIndex);
                    var $newCell = $newCells.eq(index);
                    $cell.replaceWith($newCell);
                    if (highlightChanges && !$newCell.hasClass("dx-command-expand")) {
                        $newCell.addClass(cellUpdatedClass)
                    }
                });
                copyAttributes($rowElement.get(0), $newRowElement.get(0))
            },
            _setCellAriaAttributes: function($cell, cellOptions) {
                if ("freeSpace" !== cellOptions.rowType) {
                    this.setAria("selected", false, $cell);
                    this.setAria("role", "gridcell", $cell);
                    var columnIndexOffset = this._columnsController.getColumnIndexOffset();
                    var ariaColIndex = cellOptions.columnIndex + columnIndexOffset + 1;
                    this.setAria("colindex", ariaColIndex, $cell)
                }
            },
            _renderCell: function($row, options) {
                var cellOptions = this._getCellOptions(options);
                if (options.columnIndices) {
                    if (options.row.cells) {
                        options.row.cells[cellOptions.columnIndex] = cellOptions
                    }
                } else {
                    options.row.cells.push(cellOptions)
                }
                var $cell = this._createCell(cellOptions);
                this._setCellAriaAttributes($cell, cellOptions);
                this._renderCellContent($cell, cellOptions);
                $row.get(0).appendChild($cell.get(0));
                return $cell
            },
            _renderCellContent: function($cell, options) {
                var _this = this;
                var template = this._getCellTemplate(options);
                (0, _deferred.when)(!template || this.renderTemplate($cell, template, options)).done(function() {
                    _this._updateCell($cell, options)
                })
            },
            _getCellTemplate: function() {},
            _getRows: function() {
                return []
            },
            _getCellOptions: function(options) {
                var cellOptions = {
                    column: options.column,
                    columnIndex: options.columnIndex,
                    rowType: options.row.rowType,
                    isAltRow: this._isAltRow(options.row)
                };
                this._addWatchMethod(cellOptions);
                return cellOptions
            },
            _addWatchMethod: function(options, source) {
                if (!this.option("repaintChangesOnly")) {
                    return
                }
                var watchers = [];
                source = source || options;
                source.watch = source.watch || function(getter, updateFunc) {
                    var oldValue = getter(source.data);
                    var watcher = function(row) {
                        var newValue = getter(source.data);
                        if (JSON.stringify(oldValue) !== JSON.stringify(newValue)) {
                            if (row) {
                                updateFunc(newValue, oldValue)
                            }
                            oldValue = newValue
                        }
                    };
                    watchers.push(watcher);
                    var stopWatch = function() {
                        var index = watchers.indexOf(watcher);
                        if (index >= 0) {
                            watchers.splice(index, 1)
                        }
                    };
                    return stopWatch
                };
                source.update = source.update || function(row) {
                    if (row) {
                        this.data = options.data = row.data;
                        this.rowIndex = options.rowIndex = row.rowIndex;
                        this.dataIndex = options.dataIndex = row.dataIndex;
                        this.isExpanded = options.isExpanded = row.isExpanded;
                        if (options.row) {
                            options.row = row
                        }
                    }
                    watchers.forEach(function(watcher) {
                        watcher(row)
                    })
                };
                if (source !== options) {
                    options.watch = source.watch.bind(source)
                }
                return options
            },
            _cellPrepared: function(cell, options) {
                options.cellElement = (0, _element.getPublicElement)((0, _renderer.default)(cell));
                this.executeAction("onCellPrepared", options)
            },
            _rowPrepared: function($row, options) {
                (0, _element_data.data)($row.get(0), "options", options);
                options.rowElement = (0, _element.getPublicElement)($row);
                this.executeAction("onRowPrepared", options)
            },
            _columnOptionChanged: function(e) {
                var optionNames = e.optionNames;
                if (_uiGrid_core2.default.checkChanges(optionNames, ["width", "visibleWidth"])) {
                    var visibleColumns = this._columnsController.getVisibleColumns();
                    var widths = iteratorUtils.map(visibleColumns, function(column) {
                        var width = column.visibleWidth || column.width;
                        return (0, _type.isDefined)(width) ? width : "auto"
                    });
                    this.setColumnWidths({
                        widths: widths,
                        optionNames: optionNames
                    });
                    return
                }
                if (!this._requireReady) {
                    this.render()
                }
            },
            getCellIndex: function($cell) {
                var cellIndex = $cell.length ? $cell[0].cellIndex : -1;
                return cellIndex
            },
            getTableElements: function() {
                return this._tableElement || (0, _renderer.default)()
            },
            getTableElement: function() {
                return this._tableElement
            },
            setTableElement: function(tableElement) {
                this._tableElement = tableElement
            },
            optionChanged: function(args) {
                this.callBase(args);
                switch (args.name) {
                    case "cellHintEnabled":
                    case "onCellPrepared":
                    case "onRowPrepared":
                    case "onCellHoverChanged":
                        this._invalidate(true, true);
                        args.handled = true
                }
            },
            init: function() {
                var that = this;
                that._scrollLeft = -1;
                that._columnsController = that.getController("columns");
                that._dataController = that.getController("data");
                that._delayedTemplates = [];
                that._templatesCache = {};
                that.createAction("onCellClick");
                that.createAction("onRowClick");
                that.createAction("onCellDblClick");
                that.createAction("onRowDblClick");
                that.createAction("onCellHoverChanged", {
                    excludeValidators: ["disabled", "readOnly"]
                });
                that.createAction("onCellPrepared", {
                    excludeValidators: ["disabled", "readOnly"],
                    category: "rendering"
                });
                that.createAction("onRowPrepared", {
                    excludeValidators: ["disabled", "readOnly"],
                    category: "rendering",
                    afterExecute: function(e) {
                        that._afterRowPrepared(e)
                    }
                });
                that._columnsController.columnsChanged.add(that._columnOptionChanged.bind(that));
                that._dataController && that._dataController.changed.add(that._handleDataChanged.bind(that))
            },
            _afterRowPrepared: _common.noop,
            _handleDataChanged: function() {},
            callbackNames: function() {
                return ["scrollChanged"]
            },
            scrollTo: function(pos) {
                var $element = this.element();
                var $scrollContainer = $element && $element.children("." + this.addWidgetPrefix(SCROLL_CONTAINER_CLASS)).not("." + this.addWidgetPrefix(CONTENT_FIXED_CLASS));
                if ((0, _type.isDefined)(pos) && (0, _type.isDefined)(pos.left) && this._scrollLeft !== pos.left) {
                    this._scrollLeft = pos.left;
                    $scrollContainer && $scrollContainer.scrollLeft(pos.left)
                }
            },
            _wrapTableInScrollContainer: function($table) {
                var _this2 = this;
                var $scrollContainer = (0, _renderer.default)("<div>");
                _events_engine.default.on($scrollContainer, "scroll", function() {
                    var scrollLeft = $scrollContainer.scrollLeft();
                    if (scrollLeft !== _this2._scrollLeft) {
                        _this2.scrollChanged.fire({
                            left: scrollLeft
                        }, _this2.name)
                    }
                });
                $scrollContainer.addClass(this.addWidgetPrefix(CONTENT_CLASS)).addClass(this.addWidgetPrefix(SCROLL_CONTAINER_CLASS)).append($table).appendTo(this.element());
                this.setAria("role", "presentation", $scrollContainer);
                return $scrollContainer
            },
            _updateContent: function($newTableElement) {
                this.setTableElement($newTableElement);
                this._wrapTableInScrollContainer($newTableElement)
            },
            _findContentElement: _common.noop,
            _getWidths: function($cellElements) {
                var result = [];
                var legacyRendering = this.option("legacyRendering");
                var width;
                if ($cellElements) {
                    iteratorUtils.each($cellElements, function(index, item) {
                        width = item.offsetWidth;
                        if (item.getBoundingClientRect) {
                            var clientRect = (0, _position.getBoundingRect)(item);
                            if (clientRect.width > width - 1) {
                                width = legacyRendering ? Math.ceil(clientRect.width) : clientRect.width
                            }
                        }
                        result.push(width)
                    })
                }
                return result
            },
            getColumnWidths: function($tableElement) {
                var that = this;
                var result = [];
                var $rows;
                var $cells;
                (this.option("forceApplyBindings") || _common.noop)();
                $tableElement = $tableElement || that.getTableElement();
                if ($tableElement) {
                    $rows = $tableElement.children("tbody:not(.dx-header)").children();
                    for (var i = 0; i < $rows.length; i++) {
                        var $row = $rows.eq(i);
                        var isRowVisible = "none" !== $row.get(0).style.display && !$row.hasClass("dx-state-invisible");
                        if (!$row.is("." + GROUP_ROW_CLASS) && !$row.is("." + DETAIL_ROW_CLASS) && isRowVisible) {
                            $cells = $row.children("td");
                            break
                        }
                    }
                    result = that._getWidths($cells)
                }
                return result
            },
            getVisibleColumnIndex: function(columnIndex, rowIndex) {
                return columnIndex
            },
            setColumnWidths: function(_ref) {
                var widths = _ref.widths,
                    $tableElement = _ref.$tableElement,
                    columns = _ref.columns,
                    fixed = _ref.fixed;
                var $cols;
                var width;
                var minWidth;
                var columnIndex;
                var columnAutoWidth = this.option("columnAutoWidth");
                var legacyRendering = this.option("legacyRendering");
                $tableElement = $tableElement || this.getTableElement();
                if ($tableElement && $tableElement.length && widths) {
                    columnIndex = 0;
                    $cols = $tableElement.children("colgroup").children("col");
                    (0, _style.setWidth)($cols, "auto");
                    columns = columns || this.getColumns(null, $tableElement);
                    for (var i = 0; i < columns.length; i++) {
                        if (!legacyRendering && columnAutoWidth && !fixed) {
                            width = columns[i].width;
                            if (width && !columns[i].command) {
                                width = columns[i].visibleWidth || width;
                                width = getWidthStyle(width);
                                minWidth = getWidthStyle(columns[i].minWidth || width);
                                var $rows = $rows || $tableElement.children().children(".dx-row").not("." + GROUP_ROW_CLASS).not("." + DETAIL_ROW_CLASS);
                                for (var rowIndex = 0; rowIndex < $rows.length; rowIndex++) {
                                    var visibleIndex = this.getVisibleColumnIndex(i, rowIndex);
                                    var cell = $rows[rowIndex].cells[visibleIndex];
                                    if (cell) {
                                        setCellWidth(cell, columns[i], width);
                                        cell.style.minWidth = minWidth
                                    }
                                }
                            }
                        }
                        if (columns[i].colspan) {
                            columnIndex += columns[i].colspan;
                            continue
                        }
                        width = widths[columnIndex];
                        if ("adaptiveHidden" === width) {
                            width = HIDDEN_COLUMNS_WIDTH
                        }
                        if ("number" === typeof width) {
                            width = width.toFixed(3) + "px"
                        }(0, _style.setWidth)($cols.eq(columnIndex), (0, _type.isDefined)(width) ? width : "auto");
                        columnIndex++
                    }
                }
            },
            getCellElements: function(rowIndex) {
                return this._getCellElementsCore(rowIndex)
            },
            _getCellElementsCore: function(rowIndex) {
                var $row = this._getRowElements().eq(rowIndex);
                return $row.children()
            },
            _getCellElement: function(rowIndex, columnIdentifier) {
                var that = this;
                var $cell;
                var $cells = that.getCellElements(rowIndex);
                var columnVisibleIndex = that._getVisibleColumnIndex($cells, rowIndex, columnIdentifier);
                if ($cells.length && columnVisibleIndex >= 0) {
                    $cell = $cells.eq(columnVisibleIndex)
                }
                if ($cell && $cell.length) {
                    return $cell
                }
            },
            _getRowElement: function(rowIndex) {
                var that = this;
                var $rowElement = (0, _renderer.default)();
                var $tableElements = that.getTableElements();
                iteratorUtils.each($tableElements, function(_, tableElement) {
                    $rowElement = $rowElement.add(that._getRowElements((0, _renderer.default)(tableElement)).eq(rowIndex))
                });
                if ($rowElement.length) {
                    return $rowElement
                }
            },
            getCellElement: function(rowIndex, columnIdentifier) {
                return (0, _element.getPublicElement)(this._getCellElement(rowIndex, columnIdentifier))
            },
            getRowElement: function(rowIndex) {
                var $rows = this._getRowElement(rowIndex);
                var elements = [];
                if ($rows && !(0, _element.getPublicElement)($rows).get) {
                    for (var i = 0; i < $rows.length; i++) {
                        elements.push($rows[i])
                    }
                } else {
                    elements = $rows
                }
                return elements
            },
            _getVisibleColumnIndex: function($cells, rowIndex, columnIdentifier) {
                if ((0, _type.isString)(columnIdentifier)) {
                    var columnIndex = this._columnsController.columnOption(columnIdentifier, "index");
                    return this._columnsController.getVisibleIndex(columnIndex)
                }
                return columnIdentifier
            },
            getColumnElements: function() {},
            getColumns: function(rowIndex) {
                return this._columnsController.getVisibleColumns(rowIndex)
            },
            getCell: function(cellPosition, rows) {
                var $rows = rows || this._getRowElements();
                var $cells;
                if ($rows.length > 0 && cellPosition.rowIndex >= 0) {
                    if ("virtual" !== this.option("scrolling.mode")) {
                        cellPosition.rowIndex = cellPosition.rowIndex < $rows.length ? cellPosition.rowIndex : $rows.length - 1
                    }
                    $cells = this.getCellElements(cellPosition.rowIndex);
                    if ($cells && $cells.length > 0) {
                        return $cells.eq($cells.length > cellPosition.columnIndex ? cellPosition.columnIndex : $cells.length - 1)
                    }
                }
            },
            getRowsCount: function() {
                var tableElement = this.getTableElement();
                if (tableElement && 1 === tableElement.length) {
                    return tableElement[0].rows.length
                }
                return 0
            },
            _getRowElementsCore: function(tableElement) {
                tableElement = tableElement || this.getTableElement();
                if (tableElement) {
                    var tBodies = this.option("rowTemplate") && tableElement.find("> tbody." + ROW_CLASS);
                    return tBodies && tBodies.length ? tBodies : tableElement.find("> tbody > ." + ROW_CLASS + ", > ." + ROW_CLASS)
                }
                return (0, _renderer.default)()
            },
            _getRowElements: function(tableElement) {
                return this._getRowElementsCore(tableElement)
            },
            getRowIndex: function($row) {
                return this._getRowElements().index($row)
            },
            getBoundingRect: function() {},
            getName: function() {},
            setScrollerSpacing: function(width) {
                var that = this;
                var $element = that.element();
                var rtlEnabled = that.option("rtlEnabled");
                $element && $element.css({
                    paddingLeft: rtlEnabled ? width : "",
                    paddingRight: !rtlEnabled ? width : ""
                })
            },
            isScrollbarVisible: function(isHorizontal) {
                var $element = this.element();
                var $tableElement = this._tableElement;
                if ($element && $tableElement) {
                    return isHorizontal ? $tableElement.outerWidth() - $element.width() > 0 : $tableElement.outerHeight() - $element.height() > 0
                }
                return false
            }
        });
        exports.ColumnsView = ColumnsView
    },
    /*!*************************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/preact_wrapper/component.js ***!
      \*************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.default = void 0;
        var Preact = _interopRequireWildcard(__webpack_require__( /*! preact */ 50));
        var _hooks = __webpack_require__( /*! preact/hooks */ 53);
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _dom_component = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_component */ 67));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _utils = __webpack_require__( /*! ./utils */ 828);
        var _element = __webpack_require__( /*! ../../core/element */ 18);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function _slicedToArray(arr, i) {
            return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest()
        }

        function _nonIterableRest() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }

        function _iterableToArrayLimit(arr, i) {
            var _i = arr && ("undefined" !== typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]);
            if (null == _i) {
                return
            }
            var _arr = [];
            var _n = true;
            var _d = false;
            var _s, _e;
            try {
                for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
                    _arr.push(_s.value);
                    if (i && _arr.length === i) {
                        break
                    }
                }
            } catch (err) {
                _d = true;
                _e = err
            } finally {
                try {
                    if (!_n && null != _i.return) {
                        _i.return()
                    }
                } finally {
                    if (_d) {
                        throw _e
                    }
                }
            }
            return _arr
        }

        function _arrayWithHoles(arr) {
            if (Array.isArray(arr)) {
                return arr
            }
        }

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var setDefaultOptionValue = function(options, defaultValueGetter) {
            return function(name) {
                if (options.hasOwnProperty(name) && void 0 === options[name]) {
                    options[name] = defaultValueGetter(name)
                }
            }
        };
        var PreactWrapper = function(_DOMComponent) {
            _inheritsLoose(PreactWrapper, _DOMComponent);

            function PreactWrapper() {
                return _DOMComponent.apply(this, arguments) || this
            }
            var _proto = PreactWrapper.prototype;
            _proto._getDefaultOptions = function() {
                var _this = this;
                return (0, _extend.extend)(true, _DOMComponent.prototype._getDefaultOptions.call(this), this._viewComponent.defaultProps, this._propsInfo.twoWay.reduce(function(options, _ref) {
                    var _objectSpread2;
                    var _ref2 = _slicedToArray(_ref, 3),
                        name = _ref2[0],
                        defaultValue = _ref2[1],
                        eventName = _ref2[2];
                    return _objectSpread(_objectSpread({}, options), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, name, defaultValue), _defineProperty(_objectSpread2, eventName, function(value) {
                        return _this.option(name, value)
                    }), _objectSpread2))
                }, {}))
            };
            _proto._initMarkup = function() {
                var props = this.getProps();
                if (this._shouldRefresh) {
                    this._shouldRefresh = false;
                    this._renderPreact(_objectSpread(_objectSpread({}, props), {}, {
                        width: null,
                        height: null,
                        style: "",
                        className: "",
                        children: null
                    }))
                }
                this._renderPreact(props)
            };
            _proto._renderPreact = function(props) {
                var containerNode = this.$element()[0];
                if (!containerNode.parentNode) {
                    this._documentFragment.appendChild(containerNode)
                }
                Preact.render(Preact.h(this._viewComponent, props), containerNode, this._preactReplaced ? void 0 : containerNode);
                this._preactReplaced = true;
                if (containerNode.parentNode === this._documentFragment) {
                    this._documentFragment.removeChild(containerNode)
                }
            };
            _proto._render = function() {};
            _proto._dispose = function() {
                Preact.render(null, this.$element()[0]);
                _DOMComponent.prototype._dispose.call(this)
            };
            _proto._patchOptionValues = function(options) {
                var _this2 = this;
                var _this$_propsInfo = this._propsInfo,
                    allowNull = _this$_propsInfo.allowNull,
                    elements = _this$_propsInfo.elements,
                    twoWay = _this$_propsInfo.twoWay;
                var defaultProps = this._viewComponent.defaultProps;
                allowNull.forEach(setDefaultOptionValue(options, function() {
                    return null
                }));
                Object.keys(defaultProps).forEach(setDefaultOptionValue(options, function(name) {
                    return defaultProps[name]
                }));
                twoWay.forEach(function(_ref3) {
                    var _ref4 = _slicedToArray(_ref3, 2),
                        name = _ref4[0],
                        defaultValue = _ref4[1];
                    return setDefaultOptionValue(options, function() {
                        return defaultValue
                    })(name)
                });
                elements.forEach(function(name) {
                    if (name in options) {
                        options[name] = _this2._patchElementParam(options[name])
                    }
                });
                return options
            };
            _proto.getProps = function() {
                var options = this._patchOptionValues(_objectSpread(_objectSpread({}, this.option()), {}, {
                    ref: this._viewRef,
                    children: this._extractDefaultSlot()
                }));
                return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, options), this.elementAttr), options.elementAttr), {}, {
                    className: [].concat(_toConsumableArray((this.elementAttr.class || "").split(" ")), _toConsumableArray((options.elementAttr.class || "").split(" "))).filter(function(c, i, a) {
                        return c && a.indexOf(c) === i
                    }).join(" ").trim(),
                    "class": ""
                }, this._actionsMap)
            };
            _proto._getActionConfigs = function() {
                return {}
            };
            _proto._init = function() {
                var _this3 = this;
                _DOMComponent.prototype._init.call(this);
                this._documentFragment = _dom_adapter.default.createDocumentFragment();
                this._actionsMap = {};
                Object.keys(this._getActionConfigs()).forEach(function(name) {
                    return _this3._addAction(name)
                });
                this._viewRef = Preact.createRef();
                this._supportedKeys = function() {
                    return {}
                }
            };
            _proto._addAction = function(event, action) {
                if (!action) {
                    var actionByOption = this._createActionByOption(event, this._getActionConfigs()[event]);
                    action = function(actArgs) {
                        Object.keys(actArgs).forEach(function(name) {
                            if (_dom_adapter.default.isNode(actArgs[name])) {
                                actArgs[name] = (0, _element.getPublicElement)((0, _renderer.default)(actArgs[name]))
                            }
                        });
                        return actionByOption(actArgs)
                    }
                }
                this._actionsMap[event] = action
            };
            _proto._optionChanged = function(option) {
                var _ref5 = option || {},
                    name = _ref5.name;
                if (name && this._getActionConfigs()[name]) {
                    this._addAction(name)
                }
                _DOMComponent.prototype._optionChanged.call(this, option);
                this._invalidate()
            };
            _proto._extractDefaultSlot = function() {
                var _this4 = this;
                if (this.option("_hasAnonymousTemplateContent")) {
                    var dummyDivRefCallback = function(dummyDivRef) {
                        if (dummyDivRef) {
                            var parentNode = dummyDivRef.parentNode;
                            parentNode.removeChild(dummyDivRef);
                            _this4._getTemplate(_this4._templateManager.anonymousTemplateName).render({
                                container: (0, _element.getPublicElement)((0, _renderer.default)(parentNode)),
                                transclude: true
                            })
                        }
                    };
                    return Preact.h(Preact.Fragment, {}, Preact.h("div", {
                        style: {
                            display: "none"
                        },
                        ref: dummyDivRefCallback
                    }))
                }
                return null
            };
            _proto._createTemplateComponent = function(props, templateOption) {
                if (!templateOption) {
                    return
                }
                var template = this._getTemplate(templateOption);
                return function(_ref6) {
                    var data = _ref6.data,
                        index = _ref6.index;
                    var dummyDivRef = (0, _hooks.useRef)();
                    (0, _hooks.useLayoutEffect)(function() {
                        var parentNode = dummyDivRef.current.parentNode;
                        parentNode.removeChild(dummyDivRef.current);
                        var $parent = (0, _renderer.default)(parentNode);
                        var $children = $parent.contents();
                        Object.keys(data).forEach(function(name) {
                            if (_dom_adapter.default.isNode(data[name])) {
                                data[name] = (0, _element.getPublicElement)((0, _renderer.default)(data[name]))
                            }
                        });
                        (0, _renderer.default)(template.render(_objectSpread({
                            container: (0, _element.getPublicElement)($parent),
                            model: data
                        }, isFinite(index) ? {
                            index: index
                        } : {})));
                        var $newChildren = $parent.contents();
                        return function() {
                            (0, _utils.removeDifferentElements)($children, $newChildren)
                        }
                    }, Object.keys(props).map(function(key) {
                        return props[key]
                    }));
                    return Preact.h(Preact.Fragment, {}, Preact.h("div", {
                        style: {
                            display: "none"
                        },
                        ref: dummyDivRef
                    }))
                }
            };
            _proto._wrapKeyDownHandler = function(handler) {
                var _this5 = this;
                return function(options) {
                    var keyName = options.keyName,
                        originalEvent = options.originalEvent,
                        which = options.which;
                    var keys = _this5._supportedKeys();
                    var func = keys[keyName] || keys[which];
                    if (void 0 !== func) {
                        var _handler = func.bind(_this5);
                        var result = _handler(originalEvent, options);
                        if (!result) {
                            originalEvent.cancel = true;
                            return originalEvent
                        }
                    }
                    return null === handler || void 0 === handler ? void 0 : handler(originalEvent, options)
                }
            };
            _proto._toPublicElement = function(element) {
                return (0, _element.getPublicElement)((0, _renderer.default)(element))
            };
            _proto._patchElementParam = function(value) {
                var _result, _result2;
                var result;
                try {
                    result = (0, _renderer.default)(value)
                } catch (error) {
                    return value
                }
                result = null === (_result = result) || void 0 === _result ? void 0 : _result.get(0);
                return null !== (_result2 = result) && void 0 !== _result2 && _result2.nodeType ? result : value
            };
            _proto.repaint = function() {
                this._shouldRefresh = true;
                this._refresh()
            };
            _proto.registerKeyHandler = function(key, handler) {
                var currentKeys = this._supportedKeys();
                this._supportedKeys = function() {
                    return _objectSpread(_objectSpread({}, currentKeys), {}, _defineProperty({}, key, handler))
                }
            };
            _proto.setAria = function() {
                throw new Error('"setAria" method is deprecated, use "aria" property instead')
            };
            _createClass(PreactWrapper, [{
                key: "viewRef",
                get: function() {
                    return this._viewRef.current
                }
            }, {
                key: "elementAttr",
                get: function() {
                    var _this$_storedClasses;
                    if (!this._elementAttr) {
                        var attributes = this.$element()[0].attributes;
                        this._elementAttr = _objectSpread({}, Object.keys(attributes).reduce(function(a, key) {
                            if (attributes[key].specified) {
                                a[attributes[key].name] = attributes[key].value
                            }
                            return a
                        }, {}))
                    }
                    var elemStyle = this.$element()[0].style;
                    var style = {};
                    for (var i = 0; i < elemStyle.length; i++) {
                        style[elemStyle[i]] = elemStyle.getPropertyValue(elemStyle[i])
                    }
                    this._elementAttr.style = style;
                    var cssClass = this.$element()[0].getAttribute("class") || "";
                    this._storedClasses = null !== (_this$_storedClasses = this._storedClasses) && void 0 !== _this$_storedClasses ? _this$_storedClasses : cssClass.split(" ").filter(function(name) {
                        return 0 === name.indexOf("dx-")
                    }).join(" ");
                    this._elementAttr.class = cssClass.split(" ").filter(function(name) {
                        return 0 !== name.indexOf("dx-")
                    }).concat(this._storedClasses).join(" ").trim();
                    return this._elementAttr
                }
            }]);
            return PreactWrapper
        }(_dom_component.default);
        exports.default = PreactWrapper;
        PreactWrapper.IS_RENOVATED_WIDGET = false;
        PreactWrapper.IS_RENOVATED_WIDGET = true;
        module.exports = exports.default
    },
    /*!******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/ui/scheduler/workspaces/utils.js ***!
      \******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.isVerticalGroupOrientation = exports.getIsGroupedAllDayPanel = exports.getGroupCellClasses = exports.addHeightToStyle = exports.getKeyByGroup = exports.getKeyByDateAndGroup = void 0;
        var _combine_classes = __webpack_require__( /*! ../../../utils/combine_classes */ 222);
        var _consts = __webpack_require__( /*! ../consts */ 830);

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }
        var getKeyByDateAndGroup = function(date, groupIndex) {
            var key = date.getTime();
            if (!groupIndex) {
                return key.toString()
            }
            return (key + groupIndex).toString()
        };
        exports.getKeyByDateAndGroup = getKeyByDateAndGroup;
        var getKeyByGroup = function(groupIndex) {
            return groupIndex.toString()
        };
        exports.getKeyByGroup = getKeyByGroup;
        var addHeightToStyle = function(height, style) {
            var nextStyle = style || {};
            return _objectSpread(_objectSpread({}, nextStyle), {}, {
                height: height ? "".concat(height, "px") : nextStyle.height
            })
        };
        exports.addHeightToStyle = addHeightToStyle;
        var getGroupCellClasses = function() {
            var isFirstGroupCell = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : false;
            var isLastGroupCell = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : false;
            var className = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "";
            return (0, _combine_classes.combineClasses)(_defineProperty({
                "dx-scheduler-first-group-cell": isFirstGroupCell,
                "dx-scheduler-last-group-cell": isLastGroupCell
            }, className, true))
        };
        exports.getGroupCellClasses = getGroupCellClasses;
        var getIsGroupedAllDayPanel = function(viewData, index) {
            var _groupData$allDayPane;
            var groupedData = viewData.groupedData;
            var groupData = groupedData[index];
            var isAllDayPanel = !!(null !== groupData && void 0 !== groupData && null !== (_groupData$allDayPane = groupData.allDayPanel) && void 0 !== _groupData$allDayPane && _groupData$allDayPane.length);
            var isGroupedAllDayPanel = !!(null !== groupData && void 0 !== groupData && groupData.isGroupedAllDayPanel);
            return isAllDayPanel && isGroupedAllDayPanel
        };
        exports.getIsGroupedAllDayPanel = getIsGroupedAllDayPanel;
        var isVerticalGroupOrientation = function(groupOrientation) {
            return groupOrientation === _consts.VERTICAL_GROUP_ORIENTATION
        };
        exports.isVerticalGroupOrientation = isVerticalGroupOrientation
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/diagram/ui.diagram.toolbar.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _toolbar = _interopRequireDefault(__webpack_require__( /*! ../toolbar */ 157));
        var _context_menu = _interopRequireDefault(__webpack_require__( /*! ../context_menu */ 107));
        var _diagram = _interopRequireDefault(__webpack_require__( /*! ./diagram.bar */ 307));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _uiDiagram = _interopRequireDefault(__webpack_require__( /*! ./ui.diagram.panel */ 456));
        var _uiDiagram2 = _interopRequireDefault(__webpack_require__( /*! ./ui.diagram.menu_helper */ 457));
        var _diagram2 = __webpack_require__( /*! ./diagram.importer */ 98);
        __webpack_require__( /*! ../select_box */ 117);
        __webpack_require__( /*! ../color_box */ 353);
        __webpack_require__( /*! ../check_box */ 136);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var ACTIVE_FORMAT_CLASS = "dx-format-active";
        var DIAGRAM_TOOLBAR_CLASS = "dx-diagram-toolbar";
        var DIAGRAM_TOOLBAR_SEPARATOR_CLASS = "dx-diagram-toolbar-separator";
        var DIAGRAM_TOOLBAR_MENU_SEPARATOR_CLASS = "dx-diagram-toolbar-menu-separator";
        var DIAGRAM_MOBILE_TOOLBAR_COLOR_BOX_OPENED_CLASS = "dx-diagram-mobile-toolbar-color-box-opened";
        var DiagramToolbar = function(_DiagramPanel) {
            _inheritsLoose(DiagramToolbar, _DiagramPanel);

            function DiagramToolbar() {
                return _DiagramPanel.apply(this, arguments) || this
            }
            var _proto = DiagramToolbar.prototype;
            _proto._init = function() {
                this._commands = [];
                this._itemHelpers = {};
                this._commandContextMenus = {};
                this._contextMenuList = [];
                this._valueConverters = {};
                this.bar = new DiagramToolbarBar(this);
                this._createOnInternalCommand();
                this._createOnCustomCommand();
                this._createOnSubMenuVisibilityChangingAction();
                _DiagramPanel.prototype._init.call(this)
            };
            _proto._initMarkup = function() {
                _DiagramPanel.prototype._initMarkup.call(this);
                var isServerSide = !(0, _window.hasWindow)();
                if (!this.option("skipAdjustSize") && !isServerSide) {
                    this.$element().width("")
                }
                this._commands = this._getCommands();
                this._itemHelpers = {};
                this._commandContextMenus = {};
                this._contextMenuList = [];
                var $toolbar = this._createMainElement();
                this._renderToolbar($toolbar);
                if (!this.option("skipAdjustSize") && !isServerSide) {
                    var $toolbarContent = this.$element().find(".dx-toolbar-before");
                    this.$element().width($toolbarContent.width())
                }
            };
            _proto._createMainElement = function() {
                return (0, _renderer.default)("<div>").addClass(DIAGRAM_TOOLBAR_CLASS).appendTo(this._$element)
            };
            _proto._getCommands = function() {
                return this.option("commands") || []
            };
            _proto._renderToolbar = function($toolbar) {
                var beforeCommands = this._commands.filter(function(command) {
                    return ["after", "center"].indexOf(command.position) === -1
                });
                var centerCommands = this._commands.filter(function(command) {
                    return "center" === command.position
                });
                var afterCommands = this._commands.filter(function(command) {
                    return "after" === command.position
                });
                var dataSource = [].concat(this._prepareToolbarItems(beforeCommands, "before", this._executeCommand)).concat(this._prepareToolbarItems(centerCommands, "center", this._executeCommand)).concat(this._prepareToolbarItems(afterCommands, "after", this._executeCommand));
                this._toolbarInstance = this._createComponent($toolbar, _toolbar.default, {
                    dataSource: dataSource
                })
            };
            _proto._prepareToolbarItems = function(items, location, actionHandler) {
                var _this = this;
                return items.map(function(item) {
                    return (0, _extend.extend)(true, {
                        location: location,
                        locateInMenu: _this.option("locateInMenu")
                    }, _this._createItem(item, location, actionHandler), _this._createItemOptions(item), _this._createItemActionOptions(item, actionHandler))
                })
            };
            _proto._createItem = function(item, location, actionHandler) {
                var _this2 = this;
                if (item.getCommandValue || item.getEditorValue || item.getEditorDisplayValue) {
                    this._valueConverters[item.command] = {
                        getCommandValue: item.getCommandValue,
                        getEditorValue: item.getEditorValue,
                        getEditorDisplayValue: item.getEditorDisplayValue
                    }
                }
                if ("separator" === item.widget) {
                    return {
                        template: function(data, index, element) {
                            (0, _renderer.default)(element).addClass(DIAGRAM_TOOLBAR_SEPARATOR_CLASS)
                        },
                        menuItemTemplate: function(data, index, element) {
                            (0, _renderer.default)(element).addClass(DIAGRAM_TOOLBAR_MENU_SEPARATOR_CLASS)
                        }
                    }
                }
                return {
                    widget: item.widget || "dxButton",
                    cssClass: item.cssClass,
                    options: {
                        stylingMode: this.option("buttonStylingMode"),
                        type: this.option("buttonType"),
                        text: item.text,
                        hint: item.hint,
                        icon: item.icon || item.iconUnchecked || item.iconChecked,
                        iconChecked: item.iconChecked,
                        iconUnchecked: item.iconUnchecked,
                        onInitialized: function(e) {
                            return _this2._onItemInitialized(e.component, item)
                        },
                        onContentReady: function(e) {
                            return _this2._onItemContentReady(e.component, item, actionHandler)
                        }
                    }
                }
            };
            _proto._createItemOptions = function(_ref) {
                var widget = _ref.widget,
                    command = _ref.command,
                    items = _ref.items,
                    valueExpr = _ref.valueExpr,
                    displayExpr = _ref.displayExpr,
                    showText = _ref.showText,
                    hint = _ref.hint,
                    icon = _ref.icon;
                if ("dxSelectBox" === widget) {
                    return this._createSelectBoxItemOptions(command, hint, items, valueExpr, displayExpr)
                } else {
                    if ("dxTextBox" === widget) {
                        return this._createTextBoxItemOptions(command, hint)
                    } else {
                        if ("dxColorBox" === widget) {
                            return this._createColorBoxItemOptions(command, hint, icon)
                        } else {
                            if (!widget || "dxButton" === widget) {
                                return {
                                    showText: showText || "inMenu"
                                }
                            }
                        }
                    }
                }
            };
            _proto._createSelectBoxItemOptions = function(command, hint, items, valueExpr, displayExpr) {
                var options = this._createTextEditorItemOptions(hint);
                options = (0, _extend.extend)(true, options, {
                    options: {
                        dataSource: items,
                        displayExpr: displayExpr || "text",
                        valueExpr: valueExpr || "value",
                        dropDownOptions: {
                            container: this.option("container")
                        }
                    }
                });
                var isSelectButton = items && items.every(function(i) {
                    return void 0 !== i.icon
                });
                if (isSelectButton) {
                    options = (0, _extend.extend)(true, options, {
                        options: {
                            fieldTemplate: function(data, container) {
                                (0, _renderer.default)("<i>").addClass(data && data.icon).appendTo(container);
                                (0, _renderer.default)("<div>").dxTextBox({
                                    readOnly: true,
                                    stylingMode: "outlined"
                                }).appendTo(container)
                            },
                            itemTemplate: function(data, index, container) {
                                (0, _renderer.default)(container).attr("title", data.hint);
                                return '<i class="'.concat(data.icon, '"></i>')
                            }
                        }
                    })
                }
                return options
            };
            _proto._createTextBoxItemOptions = function(command, hint) {
                var _this3 = this;
                var options = this._createTextEditorItemOptions(hint);
                options = (0, _extend.extend)(true, options, {
                    options: {
                        readOnly: true,
                        focusStateEnabled: false,
                        hoverStateEnabled: false,
                        buttons: [{
                            name: "dropDown",
                            location: "after",
                            options: {
                                icon: "spindown",
                                disabled: false,
                                stylingMode: "text",
                                onClick: function(e) {
                                    var contextMenu = _this3._commandContextMenus[command];
                                    if (contextMenu) {
                                        _this3._toggleContextMenu(contextMenu)
                                    }
                                }
                            }
                        }]
                    }
                });
                return options
            };
            _proto._createColorBoxItemOptions = function(command, hint, icon) {
                var _this4 = this;
                var options = this._createTextEditorItemOptions(hint);
                if (icon) {
                    options = (0, _extend.extend)(true, options, {
                        options: {
                            openOnFieldClick: true,
                            fieldTemplate: function(data, container) {
                                (0, _renderer.default)("<i>").addClass(icon).css("borderBottomColor", data).appendTo(container);
                                (0, _renderer.default)("<div>").dxTextBox({
                                    readOnly: true,
                                    stylingMode: "outlined"
                                }).appendTo(container)
                            }
                        }
                    })
                }
                options = (0, _extend.extend)(true, options, {
                    options: {
                        dropDownOptions: {
                            container: this.option("container")
                        },
                        onOpened: function() {
                            if (_this4.option("isMobileView")) {
                                (0, _renderer.default)("body").addClass(DIAGRAM_MOBILE_TOOLBAR_COLOR_BOX_OPENED_CLASS)
                            }
                        },
                        onClosed: function() {
                            (0, _renderer.default)("body").removeClass(DIAGRAM_MOBILE_TOOLBAR_COLOR_BOX_OPENED_CLASS)
                        }
                    }
                });
                return options
            };
            _proto._createTextEditorItemOptions = function(hint) {
                return {
                    options: {
                        stylingMode: this.option("editorStylingMode"),
                        hint: hint
                    }
                }
            };
            _proto._createItemActionOptions = function(item, handler) {
                var _this5 = this;
                switch (item.widget) {
                    case "dxSelectBox":
                    case "dxColorBox":
                    case "dxCheckBox":
                        return {
                            options: {
                                onValueChanged: function(e) {
                                    var parameter = _uiDiagram2.default.getItemCommandParameter(_this5, item, e.component.option("value"));
                                    handler.call(_this5, item.command, item.name, parameter)
                                }
                            }
                        };
                    case "dxTextBox":
                        return {};
                    default:
                        return {
                            options: {
                                onClick: function(e) {
                                    if (!item.items) {
                                        var parameter = _uiDiagram2.default.getItemCommandParameter(_this5, item);
                                        handler.call(_this5, item.command, item.name, parameter)
                                    } else {
                                        var contextMenu = e.component._contextMenu;
                                        if (contextMenu) {
                                            _this5._toggleContextMenu(contextMenu)
                                        }
                                    }
                                }
                            }
                        }
                }
            };
            _proto._toggleContextMenu = function(contextMenu) {
                this._contextMenuList.forEach(function(cm) {
                    if (contextMenu !== cm) {
                        cm.hide()
                    }
                });
                contextMenu.toggle()
            };
            _proto._onItemInitialized = function(widget, item) {
                this._addItemHelper(item.command, new DiagramToolbarItemHelper(widget))
            };
            _proto._onItemContentReady = function(widget, item, actionHandler) {
                var _this6 = this;
                var _getDiagram = (0, _diagram2.getDiagram)(),
                    Browser = _getDiagram.Browser;
                if (("dxButton" === widget.NAME || "dxTextBox" === widget.NAME) && item.items) {
                    var $menuContainer = (0, _renderer.default)("<div>").appendTo(this.$element());
                    widget._contextMenu = this._createComponent($menuContainer, _context_menu.default, {
                        items: item.items,
                        target: widget.$element(),
                        cssClass: _uiDiagram2.default.getContextMenuCssClass(),
                        showEvent: "",
                        closeOnOutsideClick: function(e) {
                            return !Browser.TouchUI && 0 === (0, _renderer.default)(e.target).closest(widget._contextMenu._dropDownButtonElement).length
                        },
                        focusStateEnabled: false,
                        position: {
                            at: "left bottom"
                        },
                        itemTemplate: function(itemData, itemIndex, itemElement) {
                            _uiDiagram2.default.getContextMenuItemTemplate(this, itemData, itemIndex, itemElement)
                        },
                        onItemClick: function(_ref2) {
                            var component = _ref2.component,
                                itemData = _ref2.itemData;
                            _uiDiagram2.default.onContextMenuItemClick(_this6, itemData, actionHandler.bind(_this6));
                            if (!itemData.items || !itemData.items.length) {
                                component.hide()
                            }
                        },
                        onShowing: function(e) {
                            if (_this6._showingSubMenu) {
                                return
                            }
                            _this6._showingSubMenu = e.component;
                            _this6._onSubMenuVisibilityChangingAction({
                                visible: true,
                                component: _this6
                            });
                            e.component.option("items", e.component.option("items"));
                            delete _this6._showingSubMenu
                        },
                        onInitialized: function(_ref3) {
                            var component = _ref3.component;
                            return _this6._onContextMenuInitialized(component, item, widget)
                        },
                        onDisposing: function(_ref4) {
                            var component = _ref4.component;
                            return _this6._onContextMenuDisposing(component, item)
                        }
                    });
                    if (!Browser.TouchUI) {
                        widget._contextMenu._dropDownButtonElement = widget.$element();
                        if ("dxTextBox" === widget.NAME) {
                            widget._contextMenu._dropDownButtonElement = widget.getButton("dropDown").element()
                        }
                    }
                }
            };
            _proto._onContextMenuInitialized = function(widget, item, rootWidget) {
                this._contextMenuList.push(widget);
                if (item.command) {
                    this._commandContextMenus[item.command] = widget
                }
                this._addContextMenuHelper(item, widget, [], rootWidget)
            };
            _proto._addItemHelper = function(command, helper) {
                if (void 0 !== command) {
                    if (this._itemHelpers[command]) {
                        throw new Error("Toolbar cannot contain duplicated commands.")
                    }
                    this._itemHelpers[command] = helper
                }
            };
            _proto._addContextMenuHelper = function(item, widget, indexPath, rootWidget) {
                var _this7 = this;
                if (item.items) {
                    item.items.forEach(function(subItem, index) {
                        var itemIndexPath = indexPath.concat(index);
                        _this7._addItemHelper(subItem.command, new DiagramToolbarSubItemHelper(widget, itemIndexPath, subItem.command, rootWidget));
                        _this7._addContextMenuHelper(subItem, widget, itemIndexPath, rootWidget)
                    })
                }
            };
            _proto._onContextMenuDisposing = function(widget, item) {
                this._contextMenuList.splice(this._contextMenuList.indexOf(widget), 1);
                delete this._commandContextMenus[item.command]
            };
            _proto._executeCommand = function(command, name, value) {
                if (this._updateLocked) {
                    return
                }
                if ("number" === typeof command) {
                    var valueConverter = this._valueConverters[command];
                    if (valueConverter && valueConverter.getCommandValue) {
                        value = valueConverter.getCommandValue(value)
                    }
                    this.bar.raiseBarCommandExecuted(command, value)
                } else {
                    if ("string" === typeof command) {
                        this._onInternalCommandAction({
                            command: command
                        })
                    }
                }
                if (void 0 !== name) {
                    this._onCustomCommandAction({
                        name: name
                    })
                }
            };
            _proto._createOnInternalCommand = function() {
                this._onInternalCommandAction = this._createActionByOption("onInternalCommand")
            };
            _proto._createOnCustomCommand = function() {
                this._onCustomCommandAction = this._createActionByOption("onCustomCommand")
            };
            _proto._setItemEnabled = function(command, enabled) {
                if (command in this._itemHelpers) {
                    var helper = this._itemHelpers[command];
                    if (helper.canUpdate(this._showingSubMenu)) {
                        helper.setEnabled(enabled)
                    }
                }
            };
            _proto._setEnabled = function(enabled) {
                this._toolbarInstance.option("disabled", !enabled);
                this._contextMenuList.forEach(function(contextMenu) {
                    contextMenu.option("disabled", !enabled)
                })
            };
            _proto._setItemValue = function(command, value) {
                try {
                    this._updateLocked = true;
                    if (command in this._itemHelpers) {
                        var helper = this._itemHelpers[command];
                        if (helper.canUpdate(this._showingSubMenu)) {
                            var valueConverter = this._valueConverters[command];
                            if (valueConverter && valueConverter.getEditorValue) {
                                value = valueConverter.getEditorValue(value)
                            }
                            var displayValue;
                            if (valueConverter && valueConverter.getEditorDisplayValue) {
                                displayValue = valueConverter.getEditorDisplayValue(value)
                            }
                            var contextMenu = this._commandContextMenus[command];
                            helper.setValue(value, displayValue, contextMenu, contextMenu && command)
                        }
                    }
                } finally {
                    this._updateLocked = false
                }
            };
            _proto._setItemSubItems = function(command, items) {
                this._updateLocked = true;
                if (command in this._itemHelpers) {
                    var helper = this._itemHelpers[command];
                    if (helper.canUpdate(this._showingSubMenu)) {
                        var contextMenu = this._commandContextMenus[command];
                        helper.setItems(items, contextMenu, contextMenu && command)
                    }
                }
                this._updateLocked = false
            };
            _proto._createOnSubMenuVisibilityChangingAction = function() {
                this._onSubMenuVisibilityChangingAction = this._createActionByOption("onSubMenuVisibilityChanging")
            };
            _proto._optionChanged = function(args) {
                switch (args.name) {
                    case "isMobileView":
                        (0, _renderer.default)("body").removeClass(DIAGRAM_MOBILE_TOOLBAR_COLOR_BOX_OPENED_CLASS);
                        this._invalidate();
                        break;
                    case "onSubMenuVisibilityChanging":
                        this._createOnSubMenuVisibilityChangingAction();
                        break;
                    case "onInternalCommand":
                        this._createOnInternalCommand();
                        break;
                    case "onCustomCommand":
                        this._createOnCustomCommand();
                        break;
                    case "container":
                    case "commands":
                        this._invalidate();
                        break;
                    case "export":
                        break;
                    default:
                        _DiagramPanel.prototype._optionChanged.call(this, args)
                }
            };
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_DiagramPanel.prototype._getDefaultOptions.call(this), {
                    isMobileView: false,
                    "export": {
                        fileName: "Diagram",
                        proxyUrl: void 0
                    },
                    locateInMenu: "auto",
                    buttonStylingMode: "text",
                    buttonType: "normal",
                    editorStylingMode: "filled",
                    skipAdjustSize: false
                })
            };
            _proto.setCommandChecked = function(command, checked) {
                this._setItemValue(command, checked)
            };
            _proto.setCommandEnabled = function(command, enabled) {
                this._setItemEnabled(command, enabled)
            };
            return DiagramToolbar
        }(_uiDiagram.default);
        var DiagramToolbarBar = function(_DiagramBar) {
            _inheritsLoose(DiagramToolbarBar, _DiagramBar);

            function DiagramToolbarBar() {
                return _DiagramBar.apply(this, arguments) || this
            }
            var _proto2 = DiagramToolbarBar.prototype;
            _proto2.getCommandKeys = function() {
                return this._getKeys(this._owner._commands)
            };
            _proto2.setItemValue = function(key, value) {
                this._owner._setItemValue(key, value)
            };
            _proto2.setItemEnabled = function(key, enabled) {
                this._owner._setItemEnabled(key, enabled)
            };
            _proto2.setEnabled = function(enabled) {
                this._owner._setEnabled(enabled)
            };
            _proto2.setItemSubItems = function(key, items) {
                this._owner._setItemSubItems(key, items)
            };
            return DiagramToolbarBar
        }(_diagram.default);
        var DiagramToolbarItemHelper = function() {
            function DiagramToolbarItemHelper(widget) {
                this._widget = widget
            }
            var _proto3 = DiagramToolbarItemHelper.prototype;
            _proto3.canUpdate = function(showingSubMenu) {
                return void 0 === showingSubMenu
            };
            _proto3.setEnabled = function(enabled) {
                this._widget.option("disabled", !enabled)
            };
            _proto3.setValue = function(value, displayValue, contextMenu, rootCommandKey) {
                if ("value" in this._widget.option()) {
                    this._updateEditorValue(value, displayValue)
                } else {
                    if (void 0 !== value) {
                        this._updateButtonValue(value)
                    }
                }
                if (contextMenu) {
                    this._updateContextMenuItemValue(contextMenu, "", rootCommandKey, value)
                }
            };
            _proto3.setItems = function(items, contextMenu, rootCommandKey) {
                if (contextMenu) {
                    this._updateContextMenuItems(contextMenu, "", rootCommandKey, items)
                } else {
                    this._updateEditorItems(items)
                }
            };
            _proto3._updateContextMenuItems = function(contextMenu, itemOptionText, rootCommandKey, items) {
                _uiDiagram2.default.updateContextMenuItems(contextMenu, itemOptionText, rootCommandKey, items)
            };
            _proto3._updateEditorItems = function(items) {
                if ("items" in this._widget.option()) {
                    this._widget.option("items", items.map(function(item) {
                        return {
                            value: _uiDiagram2.default.getItemValue(item),
                            text: item.text
                        }
                    }))
                }
            };
            _proto3._updateEditorValue = function(value, displayValue) {
                this._widget.option("value", value);
                if (!this._widget.option("selectedItem") && displayValue) {
                    this._widget.option("value", displayValue)
                }
            };
            _proto3._updateButtonValue = function(value) {
                if (this._widget.option("iconChecked") && this._widget.option("iconUnchecked")) {
                    this._widget.option("icon", value ? this._widget.option("iconChecked") : this._widget.option("iconUnchecked"))
                } else {
                    this._widget.$element().toggleClass(ACTIVE_FORMAT_CLASS, value)
                }
            };
            _proto3._updateContextMenuItemValue = function(contextMenu, itemOptionText, rootCommandKey, value) {
                _uiDiagram2.default.updateContextMenuItemValue(contextMenu, itemOptionText, rootCommandKey, value)
            };
            return DiagramToolbarItemHelper
        }();
        var DiagramToolbarSubItemHelper = function(_DiagramToolbarItemHe) {
            _inheritsLoose(DiagramToolbarSubItemHelper, _DiagramToolbarItemHe);

            function DiagramToolbarSubItemHelper(widget, indexPath, rootCommandKey, rootWidget) {
                var _this8;
                _this8 = _DiagramToolbarItemHe.call(this, widget) || this;
                _this8._indexPath = indexPath;
                _this8._rootCommandKey = rootCommandKey;
                _this8._rootWidget = rootWidget;
                return _this8
            }
            var _proto4 = DiagramToolbarSubItemHelper.prototype;
            _proto4.canUpdate = function(showingSubMenu) {
                return _DiagramToolbarItemHe.prototype.canUpdate.call(this, showingSubMenu) || showingSubMenu === this._widget
            };
            _proto4.setEnabled = function(enabled) {
                this._widget.option(this._getItemOptionText() + "disabled", !enabled);
                var rootEnabled = this._hasEnabledCommandItems(this._widget.option("items"));
                this._rootWidget.option("disabled", !rootEnabled)
            };
            _proto4._hasEnabledCommandItems = function(items) {
                var _this9 = this;
                if (items) {
                    return items.some(function(item) {
                        return void 0 !== item.command && !item.disabled || _this9._hasEnabledCommandItems(item.items)
                    })
                }
                return false
            };
            _proto4.setValue = function(value) {
                this._updateContextMenuItemValue(this._widget, this._getItemOptionText(), this._rootCommandKey, value)
            };
            _proto4.setItems = function(items) {
                this._updateContextMenuItems(this._widget, this._getItemOptionText(), this._rootCommandKey, items)
            };
            _proto4._getItemOptionText = function() {
                return _uiDiagram2.default.getItemOptionText(this._widget, this._indexPath)
            };
            return DiagramToolbarSubItemHelper
        }(DiagramToolbarItemHelper);
        var _default = DiagramToolbar;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/palette.js ***!
      \*************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.currentPalette = currentPalette;
        exports.generateColors = generateColors;
        exports.getPalette = getPalette;
        exports.registerPalette = registerPalette;
        exports.getAccentColor = getAccentColor;
        exports.createPalette = createPalette;
        exports.getDiscretePalette = getDiscretePalette;
        exports.getGradientPalette = getGradientPalette;
        var _utils = __webpack_require__( /*! ./core/utils */ 14);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _color = _interopRequireDefault(__webpack_require__( /*! ../color */ 95));
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _palettes;

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }
        var _floor = Math.floor;
        var _ceil = Math.ceil;
        var _isArray = Array.isArray;
        var HIGHLIGHTING_STEP = 50;
        var DEFAULT_PALETTE = "material";
        var officePalette = {
            simpleSet: ["#5f8b95", "#ba4d51", "#af8a53", "#955f71", "#859666", "#7e688c"],
            indicatingSet: ["#a3b97c", "#e1b676", "#ec7f83"],
            gradientSet: ["#5f8b95", "#ba4d51"],
            accentColor: "#ba4d51"
        };
        var palettes = (_palettes = {}, _defineProperty(_palettes, DEFAULT_PALETTE, {
            simpleSet: ["#1db2f5", "#f5564a", "#97c95c", "#ffc720", "#eb3573", "#a63db8"],
            indicatingSet: ["#97c95c", "#ffc720", "#f5564a"],
            gradientSet: ["#1db2f5", "#97c95c"],
            accentColor: "#1db2f5"
        }), _defineProperty(_palettes, "office", officePalette), _defineProperty(_palettes, "harmony light", {
            simpleSet: ["#fcb65e", "#679ec5", "#ad79ce", "#7abd5c", "#e18e92", "#b6d623", "#b7abea", "#85dbd5"],
            indicatingSet: ["#b6d623", "#fcb65e", "#e18e92"],
            gradientSet: ["#7abd5c", "#fcb65e"],
            accentColor: "#679ec5"
        }), _defineProperty(_palettes, "soft pastel", {
            simpleSet: ["#60a69f", "#78b6d9", "#6682bb", "#a37182", "#eeba69", "#90ba58", "#456c68", "#7565a4"],
            indicatingSet: ["#90ba58", "#eeba69", "#a37182"],
            gradientSet: ["#78b6d9", "#eeba69"],
            accentColor: "#60a69f"
        }), _defineProperty(_palettes, "pastel", {
            simpleSet: ["#bb7862", "#70b3a1", "#bb626a", "#057d85", "#ab394b", "#dac599", "#153459", "#b1d2c6"],
            indicatingSet: ["#70b3a1", "#dac599", "#bb626a"],
            gradientSet: ["#bb7862", "#70b3a1"],
            accentColor: "#bb7862"
        }), _defineProperty(_palettes, "bright", {
            simpleSet: ["#70c92f", "#f8ca00", "#bd1550", "#e97f02", "#9d419c", "#7e4452", "#9ab57e", "#36a3a6"],
            indicatingSet: ["#70c92f", "#f8ca00", "#bd1550"],
            gradientSet: ["#e97f02", "#f8ca00"],
            accentColor: "#e97f02"
        }), _defineProperty(_palettes, "soft", {
            simpleSet: ["#cbc87b", "#9ab57e", "#e55253", "#7e4452", "#e8c267", "#565077", "#6babac", "#ad6082"],
            indicatingSet: ["#9ab57e", "#e8c267", "#e55253"],
            gradientSet: ["#9ab57e", "#e8c267"],
            accentColor: "#565077"
        }), _defineProperty(_palettes, "ocean", {
            simpleSet: ["#75c099", "#acc371", "#378a8a", "#5fa26a", "#064970", "#38c5d2", "#00a7c6", "#6f84bb"],
            indicatingSet: ["#c8e394", "#7bc59d", "#397c8b"],
            gradientSet: ["#acc371", "#38c5d2"],
            accentColor: "#378a8a"
        }), _defineProperty(_palettes, "vintage", {
            simpleSet: ["#dea484", "#efc59c", "#cb715e", "#eb9692", "#a85c4c", "#f2c0b5", "#c96374", "#dd956c"],
            indicatingSet: ["#ffe5c6", "#f4bb9d", "#e57660"],
            gradientSet: ["#efc59c", "#cb715e"],
            accentColor: "#cb715e"
        }), _defineProperty(_palettes, "violet", {
            simpleSet: ["#d1a1d1", "#eeacc5", "#7b5685", "#7e7cad", "#a13d73", "#5b41ab", "#e287e2", "#689cc1"],
            indicatingSet: ["#d8e2f6", "#d0b2da", "#d56a8a"],
            gradientSet: ["#eeacc5", "#7b5685"],
            accentColor: "#7b5685"
        }), _defineProperty(_palettes, "carmine", {
            simpleSet: ["#fb7764", "#73d47f", "#fed85e", "#d47683", "#dde392", "#757ab2"],
            indicatingSet: ["#5cb85c", "#f0ad4e", "#d9534f"],
            gradientSet: ["#fb7764", "#73d47f"],
            accentColor: "#f05b41"
        }), _defineProperty(_palettes, "dark moon", {
            simpleSet: ["#4ddac1", "#f4c99a", "#80dd9b", "#f998b3", "#4aaaa0", "#a5aef1"],
            indicatingSet: ["#59d8a4", "#f0ad4e", "#f9517e"],
            gradientSet: ["#4ddac1", "#f4c99a"],
            accentColor: "#3debd3"
        }), _defineProperty(_palettes, "soft blue", {
            simpleSet: ["#7ab8eb", "#97da97", "#facb86", "#e78683", "#839bda", "#4db7be"],
            indicatingSet: ["#5cb85c", "#f0ad4e", "#d9534f"],
            gradientSet: ["#7ab8eb", "#97da97"],
            accentColor: "#7ab8eb"
        }), _defineProperty(_palettes, "dark violet", {
            simpleSet: ["#9c63ff", "#64c064", "#eead51", "#d2504b", "#4b6bbf", "#2da7b0"],
            indicatingSet: ["#5cb85c", "#f0ad4e", "#d9534f"],
            gradientSet: ["#9c63ff", "#64c064"],
            accentColor: "#9c63ff"
        }), _defineProperty(_palettes, "green mist", {
            simpleSet: ["#3cbab2", "#8ed962", "#5b9d95", "#efcc7c", "#f1929f", "#4d8dab"],
            indicatingSet: ["#72d63c", "#ffc852", "#f74a5e"],
            gradientSet: ["#3cbab2", "#8ed962"],
            accentColor: "#3cbab2"
        }), _palettes);
        var currentPaletteName;

        function currentPalette(name) {
            if (void 0 === name) {
                return currentPaletteName || DEFAULT_PALETTE
            } else {
                name = (0, _utils.normalizeEnum)(name);
                currentPaletteName = name in palettes ? name : void 0
            }
        }

        function generateColors(palette, count) {
            var options = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                keepLastColorInEnd: false
            };
            options.type = options.baseColorSet;
            options.extensionMode = options.paletteExtensionMode;
            return createPalette(palette, options).generateColors(count)
        }

        function getPalette(palette, parameters) {
            parameters = parameters || {};
            palette = palette || (void 0 === currentPaletteName ? parameters.themeDefault : currentPalette());
            var result;
            var type = parameters.type;
            if (_isArray(palette)) {
                return palette.slice(0)
            } else {
                if ((0, _type.isString)(palette)) {
                    result = palettes[(0, _utils.normalizeEnum)(palette)]
                }
                if (!result) {
                    result = palettes[currentPalette()]
                }
            }
            return type ? result[type].slice(0) : result
        }

        function registerPalette(name, palette) {
            var item = {};
            var paletteName;
            if (_isArray(palette)) {
                item.simpleSet = palette.slice(0)
            } else {
                if (palette) {
                    item.simpleSet = _isArray(palette.simpleSet) ? palette.simpleSet.slice(0) : void 0;
                    item.indicatingSet = _isArray(palette.indicatingSet) ? palette.indicatingSet.slice(0) : void 0;
                    item.gradientSet = _isArray(palette.gradientSet) ? palette.gradientSet.slice(0) : void 0;
                    item.accentColor = palette.accentColor
                }
            }
            if (!item.accentColor) {
                item.accentColor = item.simpleSet && item.simpleSet[0]
            }
            if (item.simpleSet || item.indicatingSet || item.gradientSet) {
                paletteName = (0, _utils.normalizeEnum)(name);
                (0, _extend.extend)(palettes[paletteName] = palettes[paletteName] || {}, item)
            }
        }

        function getAccentColor(palette, themeDefault) {
            palette = getPalette(palette, {
                themeDefault: themeDefault
            });
            return palette.accentColor || palette[0]
        }

        function RingBuf(buf) {
            var ind = 0;
            this.next = function() {
                var res = buf[ind++];
                if (ind === buf.length) {
                    this.reset()
                }
                return res
            };
            this.reset = function() {
                ind = 0
            }
        }

        function getAlternateColorsStrategy(palette, parameters) {
            var stepHighlight = parameters.useHighlight ? HIGHLIGHTING_STEP : 0;
            var paletteSteps = new RingBuf([0, stepHighlight, -stepHighlight]);
            var currentPalette = [];

            function _reset() {
                var step = paletteSteps.next();
                currentPalette = step ? getAlteredPalette(palette, step) : palette.slice(0)
            }
            return {
                getColor: function(index) {
                    var color = currentPalette[index % palette.length];
                    if (index % palette.length === palette.length - 1) {
                        _reset()
                    }
                    return color
                },
                generateColors: function(count) {
                    var colors = [];
                    count = count || parameters.count;
                    for (var i = 0; i < count; i++) {
                        colors.push(this.getColor(i))
                    }
                    return colors
                },
                reset: function() {
                    paletteSteps.reset();
                    _reset()
                }
            }
        }

        function getExtrapolateColorsStrategy(palette, parameters) {
            function convertColor(color, cycleIndex, cycleCount) {
                var hsl = new _color.default(color).hsl;
                var l = hsl.l / 100;
                var diapason = cycleCount - 1 / cycleCount;
                var minL = l - .5 * diapason;
                var maxL = l + .5 * diapason;
                var cycleMiddle = (cycleCount - 1) / 2;
                var cycleDiff = cycleIndex - cycleMiddle;
                if (minL < Math.min(.5, .9 * l)) {
                    minL = Math.min(.5, .9 * l)
                }
                if (maxL > Math.max(.8, l + .15 * (1 - l))) {
                    maxL = Math.max(.8, l + .15 * (1 - l))
                }
                if (cycleDiff < 0) {
                    l -= (minL - l) * cycleDiff / cycleMiddle
                } else {
                    l += (maxL - l) * (cycleDiff / cycleMiddle)
                }
                hsl.l = 100 * l;
                return _color.default.prototype.fromHSL(hsl).toHex()
            }
            return {
                getColor: function(index, count) {
                    var paletteCount = palette.length;
                    var cycles = _floor((count - 1) / paletteCount + 1);
                    var color = palette[index % paletteCount];
                    if (cycles > 1) {
                        return convertColor(color, _floor(index / paletteCount), cycles)
                    }
                    return color
                },
                generateColors: function(count) {
                    var colors = [];
                    count = count || parameters.count;
                    for (var i = 0; i < count; i++) {
                        colors.push(this.getColor(i, count))
                    }
                    return colors
                },
                reset: function() {}
            }
        }

        function getColorMixer(palette, parameters) {
            var paletteCount = palette.length;
            var extendedPalette = [];

            function distributeColors(count, colorsCount, startIndex, distribution) {
                var groupSize = Math.floor(count / colorsCount);
                var extraItems = count - colorsCount * groupSize;
                var i = startIndex;
                var middleIndex;
                var size;
                while (i < startIndex + count) {
                    size = groupSize;
                    if (extraItems > 0) {
                        size += 1;
                        extraItems--
                    }
                    middleIndex = size > 2 ? Math.floor(size / 2) : 0;
                    distribution.push(i + middleIndex);
                    i += size
                }
                return distribution.sort(function(a, b) {
                    return a - b
                })
            }

            function getColorAndDistance(arr, startIndex, count) {
                startIndex = (count + startIndex) % count;
                var distance = 0;
                for (var i = startIndex; i < 2 * count; i += 1) {
                    var index = (count + i) % count;
                    if (arr[index]) {
                        return [arr[index], distance]
                    }
                    distance++
                }
            }

            function blendColors(paletteWithEmptyColors, paletteLength) {
                for (var i = 0; i < paletteLength; i++) {
                    var color = paletteWithEmptyColors[i];
                    if (!color) {
                        var color1 = paletteWithEmptyColors[i - 1];
                        if (!color1) {
                            continue
                        } else {
                            var c2 = getColorAndDistance(paletteWithEmptyColors, i, paletteLength);
                            var color2 = new _color.default(c2[0]);
                            color1 = new _color.default(color1);
                            for (var j = 0; j < c2[1]; j++, i++) {
                                paletteWithEmptyColors[i] = color1.blend(color2, (j + 1) / (c2[1] + 1)).toHex()
                            }
                        }
                    }
                }
                return paletteWithEmptyColors
            }

            function extendPalette(count) {
                if (count <= paletteCount) {
                    return palette
                }
                var result = [];
                var colorInGroups = paletteCount - 2;
                var currentColorIndex = 0;
                var cleanColorIndices = [];
                if (parameters.keepLastColorInEnd) {
                    cleanColorIndices = distributeColors(count - 2, colorInGroups, 1, [0, count - 1])
                } else {
                    cleanColorIndices = distributeColors(count - 1, paletteCount - 1, 1, [0])
                }
                for (var i = 0; i < count; i++) {
                    if (cleanColorIndices.indexOf(i) > -1) {
                        result[i] = palette[currentColorIndex++]
                    }
                }
                result = blendColors(result, count);
                return result
            }
            return {
                getColor: function(index, count) {
                    count = count || parameters.count || paletteCount;
                    if (extendedPalette.length !== count) {
                        extendedPalette = extendPalette(count)
                    }
                    return extendedPalette[index % count]
                },
                generateColors: function(count, repeat) {
                    count = count || parameters.count || paletteCount;
                    if (repeat && count > paletteCount) {
                        var colors = extendPalette(paletteCount);
                        for (var i = 0; i < count - paletteCount; i++) {
                            colors.push(colors[i])
                        }
                        return colors
                    } else {
                        return paletteCount > 0 ? extendPalette(count).slice(0, count) : []
                    }
                },
                reset: function() {}
            }
        }

        function createPalette(palette, parameters, themeDefaultPalette) {
            var paletteObj = {
                dispose: function() {
                    this._extensionStrategy = null
                },
                getNextColor: function(count) {
                    return this._extensionStrategy.getColor(this._currentColor++, count)
                },
                generateColors: function(count, parameters) {
                    return this._extensionStrategy.generateColors(count, (parameters || {}).repeat)
                },
                reset: function() {
                    this._currentColor = 0;
                    this._extensionStrategy.reset();
                    return this
                }
            };
            parameters = parameters || {};
            var extensionMode = (parameters.extensionMode || "").toLowerCase();
            var colors = getPalette(palette, {
                type: parameters.type || "simpleSet",
                themeDefault: themeDefaultPalette
            });
            if ("alternate" === extensionMode) {
                paletteObj._extensionStrategy = getAlternateColorsStrategy(colors, parameters)
            } else {
                if ("extrapolate" === extensionMode) {
                    paletteObj._extensionStrategy = getExtrapolateColorsStrategy(colors, parameters)
                } else {
                    paletteObj._extensionStrategy = getColorMixer(colors, parameters)
                }
            }
            paletteObj.reset();
            return paletteObj
        }

        function getAlteredPalette(originalPalette, step) {
            var palette = [];
            var i;
            var ii = originalPalette.length;
            for (i = 0; i < ii; ++i) {
                palette.push(getNewColor(originalPalette[i], step))
            }
            return palette
        }

        function getNewColor(currentColor, step) {
            var newColor = new _color.default(currentColor).alter(step);
            var lightness = getLightness(newColor);
            if (lightness > 200 || lightness < 55) {
                newColor = new _color.default(currentColor).alter(-step / 2)
            }
            return newColor.toHex()
        }

        function getLightness(color) {
            return .3 * color.r + .59 * color.g + .11 * color.b
        }

        function getDiscretePalette(source, size, themeDefaultPalette) {
            var palette = size > 0 ? createDiscreteColors(getPalette(source, {
                type: "gradientSet",
                themeDefault: themeDefaultPalette
            }), size) : [];
            return {
                getColor: function(index) {
                    return palette[index] || null
                }
            }
        }

        function createDiscreteColors(source, count) {
            var colorCount = count - 1;
            var sourceCount = source.length - 1;
            var colors = [];
            var gradient = [];
            var i;

            function addColor(pos) {
                var k = sourceCount * pos;
                var kl = _floor(k);
                var kr = _ceil(k);
                gradient.push(colors[kl].blend(colors[kr], k - kl).toHex())
            }
            for (i = 0; i <= sourceCount; ++i) {
                colors.push(new _color.default(source[i]))
            }
            if (colorCount > 0) {
                for (i = 0; i <= colorCount; ++i) {
                    addColor(i / colorCount)
                }
            } else {
                addColor(.5)
            }
            return gradient
        }

        function getGradientPalette(source, themeDefaultPalette) {
            var palette = getPalette(source, {
                type: "gradientSet",
                themeDefault: themeDefaultPalette
            });
            var color1 = new _color.default(palette[0]);
            var color2 = new _color.default(palette[1]);
            return {
                getColor: function(ratio) {
                    return 0 <= ratio && ratio <= 1 ? color1.blend(color2, ratio).toHex() : null
                }
            }
        }
    },
    /*!************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/series/area_series.js ***!
      \************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.polar = exports.chart = void 0;
        var _object = __webpack_require__( /*! ../../core/utils/object */ 51);
        var _extend2 = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _scatter_series = __webpack_require__( /*! ./scatter_series */ 122);
        var _line_series = __webpack_require__( /*! ./line_series */ 227);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var chartLineSeries = _line_series.chart.line;
        var polarLineSeries = _line_series.polar.line;
        var _extend = _extend2.extend;
        var calculateBezierPoints = _line_series.chart.spline._calculateBezierPoints;
        var chart = {};
        exports.chart = chart;
        var polar = {};
        exports.polar = polar;
        var baseAreaMethods = {
            _createBorderElement: chartLineSeries._createMainElement,
            _createLegendState: function(styleOptions, defaultColor) {
                return {
                    fill: styleOptions.color || defaultColor,
                    opacity: styleOptions.opacity,
                    hatching: styleOptions.hatching
                }
            },
            getValueRangeInitialValue: function() {
                if ("logarithmic" !== this.valueAxisType && "datetime" !== this.valueType && false !== this.showZero) {
                    return 0
                } else {
                    return _scatter_series.chart.getValueRangeInitialValue.call(this)
                }
            },
            _getDefaultSegment: function(segment) {
                var defaultSegment = chartLineSeries._getDefaultSegment(segment);
                defaultSegment.area = defaultSegment.line.concat(defaultSegment.line.slice().reverse());
                return defaultSegment
            },
            _updateElement: function(element, segment, animate, complete) {
                var lineParams = {
                    points: segment.line
                };
                var areaParams = {
                    points: segment.area
                };
                var borderElement = element.line;
                if (animate) {
                    borderElement && borderElement.animate(lineParams);
                    element.area.animate(areaParams, {}, complete)
                } else {
                    borderElement && borderElement.attr(lineParams);
                    element.area.attr(areaParams)
                }
            },
            _removeElement: function(element) {
                element.line && element.line.remove();
                element.area.remove()
            },
            _drawElement: function(segment) {
                return {
                    line: this._bordersGroup && this._createBorderElement(segment.line, {
                        "stroke-width": this._styles.normal.border["stroke-width"]
                    }).append(this._bordersGroup),
                    area: this._createMainElement(segment.area).append(this._elementsGroup)
                }
            },
            _applyStyle: function(style) {
                var that = this;
                that._elementsGroup && that._elementsGroup.smartAttr(style.elements);
                that._bordersGroup && that._bordersGroup.attr(style.border);
                (that._graphics || []).forEach(function(graphic) {
                    graphic.line && graphic.line.attr({
                        "stroke-width": style.border["stroke-width"]
                    }).sharp()
                })
            },
            _parseStyle: function(options, defaultColor, defaultBorderColor) {
                var borderOptions = options.border || {};
                var borderStyle = chartLineSeries._parseLineOptions(borderOptions, defaultBorderColor);
                borderStyle.stroke = borderOptions.visible && borderStyle["stroke-width"] ? borderStyle.stroke : "none";
                borderStyle["stroke-width"] = borderStyle["stroke-width"] || 1;
                return {
                    border: borderStyle,
                    elements: {
                        stroke: "none",
                        fill: options.color || defaultColor,
                        hatching: options.hatching,
                        opacity: options.opacity
                    }
                }
            },
            _areBordersVisible: function() {
                var options = this._options;
                return options.border.visible || options.hoverStyle.border.visible || options.selectionStyle.border.visible
            },
            _createMainElement: function(points, settings) {
                return this._renderer.path(points, "area").attr(settings)
            },
            _getTrackerSettings: function(segment) {
                return {
                    "stroke-width": segment.singlePointSegment ? this._defaultTrackerWidth : 0
                }
            },
            _getMainPointsFromSegment: function(segment) {
                return segment.area
            }
        };

        function createAreaPoints(points) {
            return (0, _utils.map)(points, function(pt) {
                return pt.getCoords()
            }).concat((0, _utils.map)(points.slice().reverse(), function(pt) {
                return pt.getCoords(true)
            }))
        }
        var areaSeries = chart.area = _extend({}, chartLineSeries, baseAreaMethods, {
            _prepareSegment: function(points, rotated) {
                var that = this;
                var processedPoints = that._processSinglePointsAreaSegment(points, rotated);
                var areaPoints = createAreaPoints(processedPoints);
                var argAxis = that.getArgumentAxis();
                if (argAxis.getAxisPosition) {
                    var argAxisPosition = argAxis.getAxisPosition();
                    var axisOptions = argAxis.getOptions();
                    var edgeOffset = (!rotated ? -1 : 1) * Math.round(axisOptions.width / 2);
                    if (axisOptions.visible) {
                        areaPoints.forEach(function(p, i) {
                            if (p) {
                                var index = 1 === points.length ? 0 : i < points.length ? i : areaPoints.length - 1 - i;
                                rotated && p.x === points[index].defaultX && p.x === argAxisPosition - argAxis.getAxisShift() && (p.x += edgeOffset);
                                !rotated && p.y === points[index].defaultY && p.y === argAxisPosition - argAxis.getAxisShift() && (p.y += edgeOffset)
                            }
                        })
                    }
                }
                return {
                    line: processedPoints,
                    area: areaPoints,
                    singlePointSegment: processedPoints !== points
                }
            },
            _processSinglePointsAreaSegment: function(points, rotated) {
                if (points && 1 === points.length) {
                    var p = points[0];
                    var p1 = (0, _object.clone)(p);
                    p1[rotated ? "y" : "x"] += 1;
                    p1.argument = null;
                    return [p, p1]
                }
                return points
            }
        });
        polar.area = _extend({}, polarLineSeries, baseAreaMethods, {
            _prepareSegment: function(points, rotated, lastSegment) {
                lastSegment && polarLineSeries._closeSegment.call(this, points);
                return areaSeries._prepareSegment.call(this, points)
            },
            _processSinglePointsAreaSegment: function(points) {
                return _line_series.polar.line._prepareSegment.call(this, points).line
            }
        });
        chart.steparea = _extend({}, areaSeries, {
            _prepareSegment: function(points, rotated) {
                var stepLineSeries = _line_series.chart.stepline;
                points = areaSeries._processSinglePointsAreaSegment(points, rotated);
                return areaSeries._prepareSegment.call(this, stepLineSeries._calculateStepLinePoints.call(this, points), rotated)
            },
            getSeriesPairCoord: _line_series.chart.stepline.getSeriesPairCoord
        });
        chart.splinearea = _extend({}, areaSeries, {
            _areaPointsToSplineAreaPoints: function(areaPoints) {
                var previousMiddlePoint = areaPoints[areaPoints.length / 2 - 1];
                var middlePoint = areaPoints[areaPoints.length / 2];
                areaPoints.splice(areaPoints.length / 2, 0, {
                    x: previousMiddlePoint.x,
                    y: previousMiddlePoint.y
                }, {
                    x: middlePoint.x,
                    y: middlePoint.y
                })
            },
            _prepareSegment: function(points, rotated) {
                var processedPoints = areaSeries._processSinglePointsAreaSegment(points, rotated);
                var areaSegment = areaSeries._prepareSegment.call(this, calculateBezierPoints(processedPoints, rotated));
                this._areaPointsToSplineAreaPoints(areaSegment.area);
                areaSegment.singlePointSegment = processedPoints !== points;
                return areaSegment
            },
            _getDefaultSegment: function(segment) {
                var areaDefaultSegment = areaSeries._getDefaultSegment(segment);
                this._areaPointsToSplineAreaPoints(areaDefaultSegment.area);
                return areaDefaultSegment
            },
            _createMainElement: function(points, settings) {
                return this._renderer.path(points, "bezierarea").attr(settings)
            },
            _createBorderElement: _line_series.chart.spline._createMainElement,
            getSeriesPairCoord: _line_series.chart.spline.getSeriesPairCoord,
            _getNearestPoints: _line_series.chart.spline._getNearestPoints,
            _getBezierPoints: _line_series.chart.spline._getBezierPoints,
            obtainCubicBezierTCoef: _line_series.chart.spline.obtainCubicBezierTCoef
        })
    },
    /*!***********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/gauges/base_gauge.js ***!
      \***********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.compareArrays = compareArrays;
        exports.getSampleText = exports.formatValue = exports.dxBaseGauge = void 0;
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _extend2 = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _translator1d = __webpack_require__( /*! ../translators/translator1d */ 475);
        var _base_widget = _interopRequireDefault(__webpack_require__( /*! ../core/base_widget */ 113));
        var _theme_manager = _interopRequireDefault(__webpack_require__( /*! ./theme_manager */ 945));
        var _tracker = _interopRequireDefault(__webpack_require__( /*! ./tracker */ 946));
        var _format_helper = _interopRequireDefault(__webpack_require__( /*! ../../format_helper */ 71));
        var _export = __webpack_require__( /*! ../core/export */ 108);
        var _title = __webpack_require__( /*! ../core/title */ 121);
        var _tooltip = __webpack_require__( /*! ../core/tooltip */ 123);
        var _loading_indicator = __webpack_require__( /*! ../core/loading_indicator */ 145);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _Number = Number;
        var _extend = _extend2.extend;
        var _format = _format_helper.default.format;
        var dxBaseGauge = _base_widget.default.inherit({
            _rootClassPrefix: "dxg",
            _themeSection: "gauge",
            _createThemeManager: function() {
                return new _theme_manager.default.ThemeManager(this._getThemeManagerOptions())
            },
            _initCore: function() {
                var that = this;
                var root = that._renderer.root;
                that._valueChangingLocker = 0;
                that._translator = that._factory.createTranslator();
                that._tracker = that._factory.createTracker({
                    renderer: that._renderer,
                    container: root
                });
                that._setTrackerCallbacks()
            },
            _beginValueChanging: function() {
                this._resetIsReady();
                this._onBeginUpdate();
                ++this._valueChangingLocker
            },
            _endValueChanging: function() {
                if (0 === --this._valueChangingLocker) {
                    this._drawn()
                }
            },
            _setTrackerCallbacks: function() {
                var that = this;
                var renderer = that._renderer;
                var tooltip = that._tooltip;
                that._tracker.setCallbacks({
                    "tooltip-show": function(target, info, callback) {
                        var tooltipParameters = target.getTooltipParameters();
                        var offset = renderer.getRootOffset();
                        var formatObject = _extend({
                            value: tooltipParameters.value,
                            valueText: tooltip.formatValue(tooltipParameters.value),
                            color: tooltipParameters.color
                        }, info);
                        return tooltip.show(formatObject, {
                            x: tooltipParameters.x + offset.left,
                            y: tooltipParameters.y + offset.top,
                            offset: tooltipParameters.offset
                        }, {
                            target: info
                        }, void 0, callback)
                    },
                    "tooltip-hide": function() {
                        return tooltip.hide()
                    }
                })
            },
            _dispose: function() {
                this._cleanCore();
                this.callBase.apply(this, arguments)
            },
            _disposeCore: function() {
                var that = this;
                that._themeManager.dispose();
                that._tracker.dispose();
                that._translator = that._tracker = null
            },
            _cleanCore: function() {
                var that = this;
                that._tracker.deactivate();
                that._cleanContent()
            },
            _renderCore: function() {
                var that = this;
                if (!that._isValidDomain) {
                    return
                }
                that._renderContent();
                that._tracker.setTooltipState(that._tooltip.isEnabled());
                that._tracker.activate();
                that._noAnimation = false
            },
            _applyChanges: function() {
                this.callBase.apply(this, arguments);
                this._resizing = this._noAnimation = false
            },
            _setContentSize: function() {
                var that = this;
                that._resizing = that._noAnimation = 2 === that._changes.count();
                that.callBase.apply(that, arguments)
            },
            _applySize: function(rect) {
                var that = this;
                that._innerRect = {
                    left: rect[0],
                    top: rect[1],
                    right: rect[2],
                    bottom: rect[3]
                };
                var layoutCache = that._layout._cache;
                that._cleanCore();
                that._renderCore();
                that._layout._cache = that._layout._cache || layoutCache;
                return [rect[0], that._innerRect.top, rect[2], that._innerRect.bottom]
            },
            _initialChanges: ["DOMAIN"],
            _themeDependentChanges: ["DOMAIN"],
            _optionChangesMap: {
                subtitle: "MOSTLY_TOTAL",
                indicator: "MOSTLY_TOTAL",
                geometry: "MOSTLY_TOTAL",
                animation: "MOSTLY_TOTAL",
                startValue: "DOMAIN",
                endValue: "DOMAIN"
            },
            _optionChangesOrder: ["DOMAIN", "MOSTLY_TOTAL"],
            _change_DOMAIN: function() {
                this._setupDomain()
            },
            _change_MOSTLY_TOTAL: function() {
                this._applyMostlyTotalChange()
            },
            _setupDomain: function() {
                var that = this;
                that._setupDomainCore();
                that._isValidDomain = isFinite(1 / (that._translator.getDomain()[1] - that._translator.getDomain()[0]));
                if (!that._isValidDomain) {
                    that._incidentOccurred("W2301")
                }
                that._change(["MOSTLY_TOTAL"])
            },
            _applyMostlyTotalChange: function() {
                var that = this;
                that._setupCodomain();
                that._setupAnimationSettings();
                that._setupDefaultFormat();
                that._change(["LAYOUT"])
            },
            _setupAnimationSettings: function() {
                var that = this;
                var option = that.option("animation");
                that._animationSettings = null;
                if (void 0 === option || option) {
                    option = _extend({
                        enabled: true,
                        duration: 1e3,
                        easing: "easeOutCubic"
                    }, option);
                    if (option.enabled && option.duration > 0) {
                        that._animationSettings = {
                            duration: _Number(option.duration),
                            easing: option.easing
                        }
                    }
                }
                that._containerBackgroundColor = that.option("containerBackgroundColor") || that._themeManager.theme().containerBackgroundColor
            },
            _setupDefaultFormat: function() {
                var domain = this._translator.getDomain();
                this._defaultFormatOptions = (0, _utils.getAppropriateFormat)(domain[0], domain[1], this._getApproximateScreenRange())
            },
            _setupDomainCore: null,
            _calculateSize: null,
            _cleanContent: null,
            _renderContent: null,
            _setupCodomain: null,
            _getApproximateScreenRange: null,
            _factory: {
                createTranslator: function() {
                    return new _translator1d.Translator1D
                },
                createTracker: function(parameters) {
                    return new _tracker.default(parameters)
                }
            }
        });
        exports.dxBaseGauge = dxBaseGauge;
        var formatValue = function(value, options, extra) {
            options = options || {};
            var text = _format(value, options.format);
            var formatObject;
            if ("function" === typeof options.customizeText) {
                formatObject = _extend({
                    value: value,
                    valueText: text
                }, extra);
                return String(options.customizeText.call(formatObject, formatObject))
            }
            return text
        };
        exports.formatValue = formatValue;
        var getSampleText = function(translator, options) {
            var text1 = formatValue(translator.getDomainStart(), options);
            var text2 = formatValue(translator.getDomainEnd(), options);
            return text1.length >= text2.length ? text1 : text2
        };
        exports.getSampleText = getSampleText;

        function compareArrays(array1, array2) {
            return array1 && array2 && array1.length === array2.length && compareArraysElements(array1, array2)
        }

        function compareArraysElements(array1, array2) {
            var i;
            var ii = array1.length;
            var array1ValueIsNaN;
            var array2ValueIsNaN;
            for (i = 0; i < ii; ++i) {
                array1ValueIsNaN = array1[i] !== array1[i];
                array2ValueIsNaN = array2[i] !== array2[i];
                if (array1ValueIsNaN && array2ValueIsNaN) {
                    continue
                }
                if (array1[i] !== array2[i]) {
                    return false
                }
            }
            return true
        }
        dxBaseGauge.addPlugin(_export.plugin);
        dxBaseGauge.addPlugin(_title.plugin);
        dxBaseGauge.addPlugin(_tooltip.plugin);
        dxBaseGauge.addPlugin(_loading_indicator.plugin);
        var _setTooltipOptions = dxBaseGauge.prototype._setTooltipOptions;
        dxBaseGauge.prototype._setTooltipOptions = function() {
            _setTooltipOptions.apply(this, arguments);
            this._tracker && this._tracker.setTooltipState(this._tooltip.isEnabled())
        }
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/tree_map/node.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _extend2 = __webpack_require__( /*! ../../core/utils/extend */ 0);

        function Node() {}
        var updateTile = [updateLeaf, updateGroup];
        (0, _extend2.extend)(Node.prototype, {
            value: 0,
            isNode: function() {
                return !!(this.nodes && this.level < this.ctx.maxLevel)
            },
            isActive: function() {
                var ctx = this.ctx;
                return this.level >= ctx.minLevel && this.level <= ctx.maxLevel
            },
            updateStyles: function() {
                var that = this;
                var isNode = Number(that.isNode());
                that.state = that._buildState(that.ctx.settings[isNode].state, !isNode && that.color && {
                    fill: that.color
                })
            },
            _buildState: function(state, extra) {
                var base = (0, _extend2.extend)({}, state);
                return extra ? (0, _extend2.extend)(base, extra) : base
            },
            updateLabelStyle: function() {
                var settings = this.ctx.settings[Number(this.isNode())];
                this.labelState = settings.labelState;
                this.labelParams = settings.labelParams
            },
            _getState: function() {
                return this.state
            },
            applyState: function() {
                updateTile[Number(this.isNode())](this.tile, this._getState())
            }
        });

        function updateLeaf(content, attrs) {
            content.smartAttr(attrs)
        }

        function updateGroup(content, attrs) {
            content.outer.attr({
                stroke: attrs.stroke,
                "stroke-width": attrs["stroke-width"],
                "stroke-opacity": attrs["stroke-opacity"]
            });
            content.inner.smartAttr({
                fill: attrs.fill,
                opacity: attrs.opacity,
                hatching: attrs.hatching
            })
        }
        var _default = Node;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************!*\
      !*** ./artifacts/transpiled-npm/exporter.js ***!
      \**********************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.export = _export;
        Object.defineProperty(exports, "fileSaver", {
            enumerable: true,
            get: function() {
                return _file_saver.fileSaver
            }
        });
        exports.svg = exports.pdf = exports.image = exports.excel = void 0;
        var _file_saver = __webpack_require__( /*! ./exporter/file_saver */ 178);
        var _excel_creator = __webpack_require__( /*! ./exporter/excel_creator */ 493);
        var _image_creator = __webpack_require__( /*! ./exporter/image_creator */ 247);
        var _svg_creator = __webpack_require__( /*! ./exporter/svg_creator */ 505);
        var _type = __webpack_require__( /*! ./core/utils/type */ 1);
        var _deferred = __webpack_require__( /*! ./core/utils/deferred */ 6);
        var _excel_format_converter = _interopRequireDefault(__webpack_require__( /*! ./exporter/excel_format_converter */ 239));
        var _pdf_creator = __webpack_require__( /*! ./exporter/pdf_creator */ 507);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _export(data, options, getData) {
            if (!data) {
                return (new _deferred.Deferred).resolve()
            }
            var exportingAction = options.exportingAction;
            var exportedAction = options.exportedAction;
            var fileSavingAction = options.fileSavingAction;
            var eventArgs = {
                fileName: options.fileName,
                format: options.format,
                cancel: false
            };
            (0, _type.isFunction)(exportingAction) && exportingAction(eventArgs);
            if (!eventArgs.cancel) {
                return getData(data, options).then(function(blob) {
                    (0, _type.isFunction)(exportedAction) && exportedAction();
                    if ((0, _type.isFunction)(fileSavingAction)) {
                        eventArgs.data = blob;
                        fileSavingAction(eventArgs)
                    }
                    if (!eventArgs.cancel) {
                        _file_saver.fileSaver.saveAs(eventArgs.fileName, options.format, blob, options.proxyUrl, options.forceProxy)
                    }
                })
            }
            return (new _deferred.Deferred).resolve()
        }
        var excel = {
            creator: _excel_creator.ExcelCreator,
            getData: _excel_creator.getData,
            formatConverter: _excel_format_converter.default
        };
        exports.excel = excel;
        var image = {
            creator: _image_creator.imageCreator,
            getData: _image_creator.getData,
            testFormats: _image_creator.testFormats
        };
        exports.image = image;
        var pdf = {
            getData: _pdf_creator.getData
        };
        exports.pdf = pdf;
        var svg = {
            creator: _svg_creator.svgCreator,
            getData: _svg_creator.getData
        };
        exports.svg = svg
    },
    /*!*****************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/size.js ***!
      \*****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.parseHeight = exports.getVisibleHeight = exports.getVerticalOffsets = exports.addOffsetToMinHeight = exports.addOffsetToMaxHeight = exports.getElementBoxParams = exports.getSize = void 0;
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _type = __webpack_require__( /*! ../utils/type */ 1);
        var window = (0, _window.getWindow)();
        var SPECIAL_HEIGHT_VALUES = ["auto", "none", "inherit", "initial"];
        var getSizeByStyles = function(elementStyles, styles) {
            var result = 0;
            styles.forEach(function(style) {
                result += parseFloat(elementStyles[style]) || 0
            });
            return result
        };
        var getElementBoxParams = function(name, elementStyles) {
            var beforeName = "width" === name ? "Left" : "Top";
            var afterName = "width" === name ? "Right" : "Bottom";
            return {
                padding: getSizeByStyles(elementStyles, ["padding" + beforeName, "padding" + afterName]),
                border: getSizeByStyles(elementStyles, ["border" + beforeName + "Width", "border" + afterName + "Width"]),
                margin: getSizeByStyles(elementStyles, ["margin" + beforeName, "margin" + afterName])
            }
        };
        exports.getElementBoxParams = getElementBoxParams;
        var getBoxSizingOffset = function(name, elementStyles, boxParams) {
            var size = elementStyles[name];
            if ("border-box" === elementStyles.boxSizing && size.length && "%" !== size[size.length - 1]) {
                return boxParams.border + boxParams.padding
            }
            return 0
        };
        var getSize = function(element, name, include) {
            var elementStyles = window.getComputedStyle(element);
            var boxParams = getElementBoxParams(name, elementStyles);
            var clientRect = element.getClientRects().length;
            var boundingClientRect = element.getBoundingClientRect()[name];
            var result = clientRect ? boundingClientRect : 0;
            if (result <= 0) {
                result = parseFloat(elementStyles[name] || element.style[name]) || 0;
                result -= getBoxSizingOffset(name, elementStyles, boxParams)
            } else {
                result -= boxParams.padding + boxParams.border
            }
            if (include.paddings) {
                result += boxParams.padding
            }
            if (include.borders) {
                result += boxParams.border
            }
            if (include.margins) {
                result += boxParams.margin
            }
            return result
        };
        exports.getSize = getSize;
        var getContainerHeight = function(container) {
            return (0, _type.isWindow)(container) ? container.innerHeight : container.offsetHeight
        };
        var parseHeight = function(value, container) {
            if (value.indexOf("px") > 0) {
                value = parseInt(value.replace("px", ""))
            } else {
                if (value.indexOf("%") > 0) {
                    value = parseInt(value.replace("%", "")) * getContainerHeight(container) / 100
                } else {
                    if (!isNaN(value)) {
                        value = parseInt(value)
                    }
                }
            }
            return value
        };
        exports.parseHeight = parseHeight;
        var getHeightWithOffset = function(value, offset, container) {
            if (!value) {
                return null
            }
            if (SPECIAL_HEIGHT_VALUES.indexOf(value) > -1) {
                return offset ? null : value
            }
            if ((0, _type.isString)(value)) {
                value = parseHeight(value, container)
            }
            if ((0, _type.isNumeric)(value)) {
                return Math.max(0, value + offset)
            }
            var operationString = offset < 0 ? " - " : " ";
            return "calc(" + value + operationString + Math.abs(offset) + "px)"
        };
        var addOffsetToMaxHeight = function(value, offset, container) {
            var maxHeight = getHeightWithOffset(value, offset, container);
            return null !== maxHeight ? maxHeight : "none"
        };
        exports.addOffsetToMaxHeight = addOffsetToMaxHeight;
        var addOffsetToMinHeight = function(value, offset, container) {
            var minHeight = getHeightWithOffset(value, offset, container);
            return null !== minHeight ? minHeight : 0
        };
        exports.addOffsetToMinHeight = addOffsetToMinHeight;
        var getVerticalOffsets = function(element, withMargins) {
            if (!element) {
                return 0
            }
            var boxParams = getElementBoxParams("height", window.getComputedStyle(element));
            return boxParams.padding + boxParams.border + (withMargins ? boxParams.margin : 0)
        };
        exports.getVerticalOffsets = getVerticalOffsets;
        var getVisibleHeight = function(element) {
            if (element) {
                var boundingClientRect = element.getBoundingClientRect();
                if (boundingClientRect.height) {
                    return boundingClientRect.height
                }
            }
            return 0
        };
        exports.getVisibleHeight = getVisibleHeight
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/resizable.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _translator = __webpack_require__( /*! ../animation/translator */ 28);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _dom_component = _interopRequireDefault(__webpack_require__( /*! ../core/dom_component */ 67));
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _array = __webpack_require__( /*! ../core/utils/array */ 12);
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _math = __webpack_require__( /*! ../core/utils/math */ 29);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _drag = __webpack_require__( /*! ../events/drag */ 76);
        var _position = __webpack_require__( /*! ../core/utils/position */ 22);
        var _index = __webpack_require__( /*! ../events/utils/index */ 8);
        var _visibility_change = __webpack_require__( /*! ../events/visibility_change */ 59);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var RESIZABLE = "dxResizable";
        var RESIZABLE_CLASS = "dx-resizable";
        var RESIZABLE_RESIZING_CLASS = "dx-resizable-resizing";
        var RESIZABLE_HANDLE_CLASS = "dx-resizable-handle";
        var RESIZABLE_HANDLE_TOP_CLASS = "dx-resizable-handle-top";
        var RESIZABLE_HANDLE_BOTTOM_CLASS = "dx-resizable-handle-bottom";
        var RESIZABLE_HANDLE_LEFT_CLASS = "dx-resizable-handle-left";
        var RESIZABLE_HANDLE_RIGHT_CLASS = "dx-resizable-handle-right";
        var RESIZABLE_HANDLE_CORNER_CLASS = "dx-resizable-handle-corner";
        var DRAGSTART_START_EVENT_NAME = (0, _index.addNamespace)(_drag.start, RESIZABLE);
        var DRAGSTART_EVENT_NAME = (0, _index.addNamespace)(_drag.move, RESIZABLE);
        var DRAGSTART_END_EVENT_NAME = (0, _index.addNamespace)(_drag.end, RESIZABLE);
        var SIDE_BORDER_WIDTH_STYLES = {
            left: "borderLeftWidth",
            top: "borderTopWidth",
            right: "borderRightWidth",
            bottom: "borderBottomWidth"
        };
        var Resizable = _dom_component.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    handles: "all",
                    step: "1",
                    stepPrecision: "simple",
                    area: void 0,
                    minWidth: 30,
                    maxWidth: 1 / 0,
                    minHeight: 30,
                    maxHeight: 1 / 0,
                    onResizeStart: null,
                    onResize: null,
                    onResizeEnd: null,
                    roundStepValue: true
                })
            },
            _init: function() {
                this.callBase();
                this.$element().addClass(RESIZABLE_CLASS)
            },
            _initMarkup: function() {
                this.callBase();
                this._renderHandles()
            },
            _render: function() {
                this.callBase();
                this._renderActions()
            },
            _renderActions: function() {
                this._resizeStartAction = this._createActionByOption("onResizeStart");
                this._resizeEndAction = this._createActionByOption("onResizeEnd");
                this._resizeAction = this._createActionByOption("onResize")
            },
            _renderHandles: function() {
                var _this = this;
                this._handles = [];
                var handles = this.option("handles");
                if ("none" === handles) {
                    return
                }
                var directions = "all" === handles ? ["top", "bottom", "left", "right"] : handles.split(" ");
                (0, _iterator.each)(directions, function(index, handleName) {
                    _this._renderHandle(handleName)
                });
                (0, _array.inArray)("bottom", directions) + 1 && (0, _array.inArray)("right", directions) + 1 && this._renderHandle("corner-bottom-right");
                (0, _array.inArray)("bottom", directions) + 1 && (0, _array.inArray)("left", directions) + 1 && this._renderHandle("corner-bottom-left");
                (0, _array.inArray)("top", directions) + 1 && (0, _array.inArray)("right", directions) + 1 && this._renderHandle("corner-top-right");
                (0, _array.inArray)("top", directions) + 1 && (0, _array.inArray)("left", directions) + 1 && this._renderHandle("corner-top-left");
                this._attachEventHandlers()
            },
            _renderHandle: function(handleName) {
                var $handle = (0, _renderer.default)("<div>").addClass(RESIZABLE_HANDLE_CLASS).addClass(RESIZABLE_HANDLE_CLASS + "-" + handleName).appendTo(this.$element());
                this._handles.push($handle)
            },
            _attachEventHandlers: function() {
                if (this.option("disabled")) {
                    return
                }
                var handlers = {};
                handlers[DRAGSTART_START_EVENT_NAME] = this._dragStartHandler.bind(this);
                handlers[DRAGSTART_EVENT_NAME] = this._dragHandler.bind(this);
                handlers[DRAGSTART_END_EVENT_NAME] = this._dragEndHandler.bind(this);
                this._handles.forEach(function(handleElement) {
                    _events_engine.default.on(handleElement, handlers, {
                        direction: "both",
                        immediate: true
                    })
                })
            },
            _detachEventHandlers: function() {
                this._handles.forEach(function(handleElement) {
                    _events_engine.default.off(handleElement)
                })
            },
            _toggleEventHandlers: function(shouldAttachEvents) {
                shouldAttachEvents ? this._attachEventHandlers() : this._detachEventHandlers()
            },
            _dragStartHandler: function(e) {
                var $element = this.$element();
                if ($element.is(".dx-state-disabled, .dx-state-disabled *")) {
                    e.cancel = true;
                    return
                }
                this._toggleResizingClass(true);
                this._movingSides = this._getMovingSides(e);
                this._elementLocation = (0, _translator.locate)($element);
                var elementRect = (0, _position.getBoundingRect)($element.get(0));
                this._elementSize = {
                    width: elementRect.width,
                    height: elementRect.height
                };
                this._renderDragOffsets(e);
                this._resizeStartAction({
                    event: e,
                    width: this._elementSize.width,
                    height: this._elementSize.height,
                    handles: this._movingSides
                });
                e.targetElements = null
            },
            _toggleResizingClass: function(value) {
                this.$element().toggleClass(RESIZABLE_RESIZING_CLASS, value)
            },
            _renderDragOffsets: function(e) {
                var area = this._getArea();
                if (!area) {
                    return
                }
                var $handle = (0, _renderer.default)(e.target).closest("." + RESIZABLE_HANDLE_CLASS);
                var handleWidth = $handle.outerWidth();
                var handleHeight = $handle.outerHeight();
                var handleOffset = $handle.offset();
                var areaOffset = area.offset;
                var scrollOffset = this._getAreaScrollOffset();
                e.maxLeftOffset = handleOffset.left - areaOffset.left - scrollOffset.scrollX;
                e.maxRightOffset = areaOffset.left + area.width - handleOffset.left - handleWidth + scrollOffset.scrollX;
                e.maxTopOffset = handleOffset.top - areaOffset.top - scrollOffset.scrollY;
                e.maxBottomOffset = areaOffset.top + area.height - handleOffset.top - handleHeight + scrollOffset.scrollY
            },
            _getBorderWidth: function($element, direction) {
                if ((0, _type.isWindow)($element.get(0))) {
                    return 0
                }
                var borderWidth = $element.css(SIDE_BORDER_WIDTH_STYLES[direction]);
                return parseInt(borderWidth) || 0
            },
            _dragHandler: function(e) {
                var $element = this.$element();
                var sides = this._movingSides;
                var location = this._elementLocation;
                var size = this._elementSize;
                var offset = this._getOffset(e);
                var width = size.width + offset.x * (sides.left ? -1 : 1);
                var height = size.height + offset.y * (sides.top ? -1 : 1);
                if (offset.x || "strict" === this.option("stepPrecision")) {
                    this._renderWidth(width)
                }
                if (offset.y || "strict" === this.option("stepPrecision")) {
                    this._renderHeight(height)
                }
                var elementRect = (0, _position.getBoundingRect)($element.get(0));
                var offsetTop = offset.y - ((elementRect.height || height) - height);
                var offsetLeft = offset.x - ((elementRect.width || width) - width);
                (0, _translator.move)($element, {
                    top: location.top + (sides.top ? offsetTop : 0),
                    left: location.left + (sides.left ? offsetLeft : 0)
                });
                this._resizeAction({
                    event: e,
                    width: this.option("width") || width,
                    height: this.option("height") || height,
                    handles: this._movingSides
                });
                (0, _visibility_change.triggerResizeEvent)($element)
            },
            _getOffset: function(e) {
                var offset = e.offset;
                var steps = (0, _common.pairToObject)(this.option("step"), !this.option("roundStepValue"));
                var sides = this._getMovingSides(e);
                var strictPrecision = "strict" === this.option("stepPrecision");
                if (!sides.left && !sides.right) {
                    offset.x = 0
                }
                if (!sides.top && !sides.bottom) {
                    offset.y = 0
                }
                return strictPrecision ? this._getStrictOffset(offset, steps, sides) : this._getSimpleOffset(offset, steps)
            },
            _getSimpleOffset: function(offset, steps) {
                return {
                    x: offset.x - offset.x % steps.h,
                    y: offset.y - offset.y % steps.v
                }
            },
            _getStrictOffset: function(offset, steps, sides) {
                var location = this._elementLocation;
                var size = this._elementSize;
                var xPos = sides.left ? location.left : location.left + size.width;
                var yPos = sides.top ? location.top : location.top + size.height;
                var newXShift = (xPos + offset.x) % steps.h;
                var newYShift = (yPos + offset.y) % steps.v;
                var sign = Math.sign || function(x) {
                    x = +x;
                    if (0 === x || isNaN(x)) {
                        return x
                    }
                    return x > 0 ? 1 : -1
                };
                var separatorOffset = function(steps, offset) {
                    return (1 + .2 * sign(offset)) % 1 * steps
                };
                var isSmallOffset = function(offset, steps) {
                    return Math.abs(offset) < .2 * steps
                };
                var newOffsetX = offset.x - newXShift;
                var newOffsetY = offset.y - newYShift;
                if (newXShift > separatorOffset(steps.h, offset.x)) {
                    newOffsetX += steps.h
                }
                if (newYShift > separatorOffset(steps.v, offset.y)) {
                    newOffsetY += steps.v
                }
                return {
                    x: (sides.left || sides.right) && !isSmallOffset(offset.x, steps.h) ? newOffsetX : 0,
                    y: (sides.top || sides.bottom) && !isSmallOffset(offset.y, steps.v) ? newOffsetY : 0
                }
            },
            _getMovingSides: function(e) {
                var $target = (0, _renderer.default)(e.target);
                var hasCornerTopLeftClass = $target.hasClass(RESIZABLE_HANDLE_CORNER_CLASS + "-top-left");
                var hasCornerTopRightClass = $target.hasClass(RESIZABLE_HANDLE_CORNER_CLASS + "-top-right");
                var hasCornerBottomLeftClass = $target.hasClass(RESIZABLE_HANDLE_CORNER_CLASS + "-bottom-left");
                var hasCornerBottomRightClass = $target.hasClass(RESIZABLE_HANDLE_CORNER_CLASS + "-bottom-right");
                return {
                    top: $target.hasClass(RESIZABLE_HANDLE_TOP_CLASS) || hasCornerTopLeftClass || hasCornerTopRightClass,
                    left: $target.hasClass(RESIZABLE_HANDLE_LEFT_CLASS) || hasCornerTopLeftClass || hasCornerBottomLeftClass,
                    bottom: $target.hasClass(RESIZABLE_HANDLE_BOTTOM_CLASS) || hasCornerBottomLeftClass || hasCornerBottomRightClass,
                    right: $target.hasClass(RESIZABLE_HANDLE_RIGHT_CLASS) || hasCornerTopRightClass || hasCornerBottomRightClass
                }
            },
            _getArea: function() {
                var area = this.option("area");
                if ((0, _type.isFunction)(area)) {
                    area = area.call(this)
                }
                if ((0, _type.isPlainObject)(area)) {
                    return this._getAreaFromObject(area)
                }
                return this._getAreaFromElement(area)
            },
            _getAreaScrollOffset: function() {
                var area = this.option("area");
                var isElement = !(0, _type.isFunction)(area) && !(0, _type.isPlainObject)(area);
                var scrollOffset = {
                    scrollY: 0,
                    scrollX: 0
                };
                if (isElement) {
                    var areaElement = (0, _renderer.default)(area)[0];
                    if ((0, _type.isWindow)(areaElement)) {
                        scrollOffset.scrollX = areaElement.pageXOffset;
                        scrollOffset.scrollY = areaElement.pageYOffset
                    }
                }
                return scrollOffset
            },
            _getAreaFromObject: function(area) {
                var result = {
                    width: area.right - area.left,
                    height: area.bottom - area.top,
                    offset: {
                        left: area.left,
                        top: area.top
                    }
                };
                this._correctAreaGeometry(result);
                return result
            },
            _getAreaFromElement: function(area) {
                var $area = (0, _renderer.default)(area);
                var result;
                if ($area.length) {
                    result = {
                        width: $area.innerWidth(),
                        height: $area.innerHeight(),
                        offset: (0, _extend.extend)({
                            top: 0,
                            left: 0
                        }, (0, _type.isWindow)($area[0]) ? {} : $area.offset())
                    };
                    this._correctAreaGeometry(result, $area)
                }
                return result
            },
            _correctAreaGeometry: function(result, $area) {
                var areaBorderLeft = $area ? this._getBorderWidth($area, "left") : 0;
                var areaBorderTop = $area ? this._getBorderWidth($area, "top") : 0;
                result.offset.left += areaBorderLeft + this._getBorderWidth(this.$element(), "left");
                result.offset.top += areaBorderTop + this._getBorderWidth(this.$element(), "top");
                result.width -= this.$element().outerWidth() - this.$element().innerWidth();
                result.height -= this.$element().outerHeight() - this.$element().innerHeight()
            },
            _dragEndHandler: function(e) {
                var $element = this.$element();
                this._resizeEndAction({
                    event: e,
                    width: $element.outerWidth(),
                    height: $element.outerHeight(),
                    handles: this._movingSides
                });
                this._toggleResizingClass(false)
            },
            _renderWidth: function(width) {
                this.option("width", (0, _math.fitIntoRange)(width, this.option("minWidth"), this.option("maxWidth")))
            },
            _renderHeight: function(height) {
                this.option("height", (0, _math.fitIntoRange)(height, this.option("minHeight"), this.option("maxHeight")))
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "disabled":
                        this._toggleEventHandlers(!args.value);
                        this.callBase(args);
                        break;
                    case "handles":
                        this._invalidate();
                        break;
                    case "minWidth":
                    case "maxWidth":
                        (0, _window.hasWindow)() && this._renderWidth(this.$element().outerWidth());
                        break;
                    case "minHeight":
                    case "maxHeight":
                        (0, _window.hasWindow)() && this._renderHeight(this.$element().outerHeight());
                        break;
                    case "onResize":
                    case "onResizeStart":
                    case "onResizeEnd":
                        this._renderActions();
                        break;
                    case "area":
                    case "stepPrecision":
                    case "step":
                    case "roundStepValue":
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _clean: function() {
                this.$element().find("." + RESIZABLE_HANDLE_CLASS).remove()
            },
            _useTemplates: function() {
                return false
            }
        });
        (0, _component_registrator.default)(RESIZABLE, Resizable);
        var _default = Resizable;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/events/swipe.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.end = exports.start = exports.swipe = void 0;
        var _index = __webpack_require__( /*! ./utils/index */ 8);
        var _emitter = _interopRequireDefault(__webpack_require__( /*! ./gesture/emitter.gesture */ 176));
        var _emitter_registrator = _interopRequireDefault(__webpack_require__( /*! ./core/emitter_registrator */ 103));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var SWIPE_START_EVENT = "dxswipestart";
        exports.start = SWIPE_START_EVENT;
        var SWIPE_EVENT = "dxswipe";
        exports.swipe = SWIPE_EVENT;
        var SWIPE_END_EVENT = "dxswipeend";
        exports.end = SWIPE_END_EVENT;
        var HorizontalStrategy = {
            defaultItemSizeFunc: function() {
                return this.getElement().width()
            },
            getBounds: function() {
                return [this._maxLeftOffset, this._maxRightOffset]
            },
            calcOffsetRatio: function(e) {
                var endEventData = (0, _index.eventData)(e);
                return (endEventData.x - (this._savedEventData && this._savedEventData.x || 0)) / this._itemSizeFunc().call(this, e)
            },
            isFastSwipe: function(e) {
                var endEventData = (0, _index.eventData)(e);
                return this.FAST_SWIPE_SPEED_LIMIT * Math.abs(endEventData.x - this._tickData.x) >= endEventData.time - this._tickData.time
            }
        };
        var VerticalStrategy = {
            defaultItemSizeFunc: function() {
                return this.getElement().height()
            },
            getBounds: function() {
                return [this._maxTopOffset, this._maxBottomOffset]
            },
            calcOffsetRatio: function(e) {
                var endEventData = (0, _index.eventData)(e);
                return (endEventData.y - (this._savedEventData && this._savedEventData.y || 0)) / this._itemSizeFunc().call(this, e)
            },
            isFastSwipe: function(e) {
                var endEventData = (0, _index.eventData)(e);
                return this.FAST_SWIPE_SPEED_LIMIT * Math.abs(endEventData.y - this._tickData.y) >= endEventData.time - this._tickData.time
            }
        };
        var STRATEGIES = {
            horizontal: HorizontalStrategy,
            vertical: VerticalStrategy
        };
        var SwipeEmitter = _emitter.default.inherit({
            TICK_INTERVAL: 300,
            FAST_SWIPE_SPEED_LIMIT: 10,
            ctor: function(element) {
                this.callBase(element);
                this.direction = "horizontal";
                this.elastic = true
            },
            _getStrategy: function() {
                return STRATEGIES[this.direction]
            },
            _defaultItemSizeFunc: function() {
                return this._getStrategy().defaultItemSizeFunc.call(this)
            },
            _itemSizeFunc: function() {
                return this.itemSizeFunc || this._defaultItemSizeFunc
            },
            _init: function(e) {
                this._tickData = (0, _index.eventData)(e)
            },
            _start: function(e) {
                this._savedEventData = (0, _index.eventData)(e);
                e = this._fireEvent(SWIPE_START_EVENT, e);
                if (!e.cancel) {
                    this._maxLeftOffset = e.maxLeftOffset;
                    this._maxRightOffset = e.maxRightOffset;
                    this._maxTopOffset = e.maxTopOffset;
                    this._maxBottomOffset = e.maxBottomOffset
                }
            },
            _move: function(e) {
                var strategy = this._getStrategy();
                var moveEventData = (0, _index.eventData)(e);
                var offset = strategy.calcOffsetRatio.call(this, e);
                offset = this._fitOffset(offset, this.elastic);
                if (moveEventData.time - this._tickData.time > this.TICK_INTERVAL) {
                    this._tickData = moveEventData
                }
                this._fireEvent(SWIPE_EVENT, e, {
                    offset: offset
                });
                e.preventDefault()
            },
            _end: function(e) {
                var strategy = this._getStrategy();
                var offsetRatio = strategy.calcOffsetRatio.call(this, e);
                var isFast = strategy.isFastSwipe.call(this, e);
                var startOffset = offsetRatio;
                var targetOffset = this._calcTargetOffset(offsetRatio, isFast);
                startOffset = this._fitOffset(startOffset, this.elastic);
                targetOffset = this._fitOffset(targetOffset, false);
                this._fireEvent(SWIPE_END_EVENT, e, {
                    offset: startOffset,
                    targetOffset: targetOffset
                })
            },
            _fitOffset: function(offset, elastic) {
                var strategy = this._getStrategy();
                var bounds = strategy.getBounds.call(this);
                if (offset < -bounds[0]) {
                    return elastic ? (-2 * bounds[0] + offset) / 3 : -bounds[0]
                }
                if (offset > bounds[1]) {
                    return elastic ? (2 * bounds[1] + offset) / 3 : bounds[1]
                }
                return offset
            },
            _calcTargetOffset: function(offsetRatio, isFast) {
                var result;
                if (isFast) {
                    result = Math.ceil(Math.abs(offsetRatio));
                    if (offsetRatio < 0) {
                        result = -result
                    }
                } else {
                    result = Math.round(offsetRatio)
                }
                return result
            }
        });
        (0, _emitter_registrator.default)({
            emitter: SwipeEmitter,
            events: [SWIPE_START_EVENT, SWIPE_EVENT, SWIPE_END_EVENT]
        })
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/drop_down_editor/ui.drop_down_editor.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _guid = _interopRequireDefault(__webpack_require__( /*! ../../core/guid */ 36));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _selectors = __webpack_require__( /*! ../widget/selectors */ 70);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _element = __webpack_require__( /*! ../../core/element */ 18);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _position = _interopRequireDefault(__webpack_require__( /*! ../../animation/position */ 81));
        var _position2 = __webpack_require__( /*! ../../core/utils/position */ 22);
        var _ui2 = _interopRequireDefault(__webpack_require__( /*! ./ui.drop_down_button */ 582));
        var _ui3 = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _text_box = _interopRequireDefault(__webpack_require__( /*! ../text_box */ 97));
        var _click = __webpack_require__( /*! ../../events/click */ 21);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _function_template = __webpack_require__( /*! ../../core/templates/function_template */ 126);
        var _popup = _interopRequireDefault(__webpack_require__( /*! ../popup */ 46));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _utils = __webpack_require__( /*! ./utils */ 208);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DROP_DOWN_EDITOR_CLASS = "dx-dropdowneditor";
        var DROP_DOWN_EDITOR_INPUT_WRAPPER = "dx-dropdowneditor-input-wrapper";
        var DROP_DOWN_EDITOR_BUTTON_ICON = "dx-dropdowneditor-icon";
        var DROP_DOWN_EDITOR_OVERLAY = "dx-dropdowneditor-overlay";
        var DROP_DOWN_EDITOR_OVERLAY_FLIPPED = "dx-dropdowneditor-overlay-flipped";
        var DROP_DOWN_EDITOR_ACTIVE = "dx-dropdowneditor-active";
        var DROP_DOWN_EDITOR_FIELD_CLICKABLE = "dx-dropdowneditor-field-clickable";
        var DROP_DOWN_EDITOR_FIELD_TEMPLATE_WRAPPER = "dx-dropdowneditor-field-template-wrapper";
        var isIOs = "ios" === _devices.default.current().platform;
        var DropDownEditor = _text_box.default.inherit({
            _supportedKeys: function() {
                return (0, _extend.extend)({}, this.callBase(), {
                    tab: function(e) {
                        if (!this.option("opened")) {
                            return
                        }
                        if ("instantly" === this.option("applyValueMode")) {
                            this.close();
                            return
                        }
                        var $focusableElement = e.shiftKey ? this._getLastPopupElement() : this._getFirstPopupElement();
                        $focusableElement && _events_engine.default.trigger($focusableElement, "focus");
                        e.preventDefault()
                    },
                    escape: function(e) {
                        if (this.option("opened")) {
                            e.preventDefault()
                        }
                        this.close();
                        return true
                    },
                    upArrow: function(e) {
                        if (!(0, _index.isCommandKeyPressed)(e)) {
                            e.preventDefault();
                            e.stopPropagation();
                            if (e.altKey) {
                                this.close();
                                return false
                            }
                        }
                        return true
                    },
                    downArrow: function(e) {
                        if (!(0, _index.isCommandKeyPressed)(e)) {
                            e.preventDefault();
                            e.stopPropagation();
                            if (e.altKey) {
                                this._validatedOpening();
                                return false
                            }
                        }
                        return true
                    },
                    enter: function(e) {
                        if (this.option("opened")) {
                            e.preventDefault();
                            this._valueChangeEventHandler(e)
                        }
                        return true
                    }
                })
            },
            _getDefaultButtons: function() {
                return this.callBase().concat([{
                    name: "dropDown",
                    Ctor: _ui2.default
                }])
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    value: null,
                    onOpened: null,
                    onClosed: null,
                    opened: false,
                    acceptCustomValue: true,
                    applyValueMode: "instantly",
                    deferRendering: true,
                    activeStateEnabled: true,
                    dropDownButtonTemplate: "dropDownButton",
                    fieldTemplate: null,
                    openOnFieldClick: false,
                    showDropDownButton: true,
                    buttons: void 0,
                    dropDownOptions: {
                        showTitle: false
                    },
                    popupPosition: this._getDefaultPopupPosition(),
                    onPopupInitialized: null,
                    applyButtonText: _message.default.format("OK"),
                    cancelButtonText: _message.default.format("Cancel"),
                    buttonsLocation: "default",
                    useHiddenSubmitElement: false
                })
            },
            _useTemplates: function() {
                return true
            },
            _getDefaultPopupPosition: function(isRtlEnabled) {
                var position = (0, _position2.getDefaultAlignment)(isRtlEnabled);
                return {
                    offset: {
                        h: 0,
                        v: -1
                    },
                    my: position + " top",
                    at: position + " bottom",
                    collision: "flip flip"
                }
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: function(_device) {
                        var isGeneric = "generic" === _device.platform;
                        return isGeneric
                    },
                    options: {
                        popupPosition: {
                            offset: {
                                v: 0
                            }
                        }
                    }
                }])
            },
            _inputWrapper: function() {
                return this.$element().find("." + DROP_DOWN_EDITOR_INPUT_WRAPPER)
            },
            _init: function() {
                this.callBase();
                this._initVisibilityActions();
                this._initPopupInitializedAction();
                this._updatePopupPosition(this.option("rtlEnabled"));
                this._options.cache("dropDownOptions", this.option("dropDownOptions"))
            },
            _updatePopupPosition: function(isRtlEnabled) {
                var _this$_getDefaultPopu = this._getDefaultPopupPosition(isRtlEnabled),
                    my = _this$_getDefaultPopu.my,
                    at = _this$_getDefaultPopu.at;
                var currentPosition = this.option("popupPosition");
                this.option("popupPosition", (0, _extend.extend)({}, currentPosition, {
                    my: my,
                    at: at
                }))
            },
            _initVisibilityActions: function() {
                this._openAction = this._createActionByOption("onOpened", {
                    excludeValidators: ["disabled", "readOnly"]
                });
                this._closeAction = this._createActionByOption("onClosed", {
                    excludeValidators: ["disabled", "readOnly"]
                })
            },
            _initPopupInitializedAction: function() {
                this._popupInitializedAction = this._createActionByOption("onPopupInitialized", {
                    excludeValidators: ["disabled", "readOnly"]
                })
            },
            _initMarkup: function() {
                this._renderSubmitElement();
                this.callBase();
                this.$element().addClass(DROP_DOWN_EDITOR_CLASS);
                this.setAria("role", "combobox")
            },
            _render: function() {
                this.callBase();
                this._renderOpenHandler();
                this._attachFocusOutHandler();
                this._renderOpenedState()
            },
            _renderContentImpl: function() {
                if (!this.option("deferRendering")) {
                    this._createPopup()
                }
            },
            _renderInput: function() {
                this.callBase();
                this._wrapInput();
                this._setDefaultAria()
            },
            _wrapInput: function() {
                this._$container = this.$element().wrapInner((0, _renderer.default)("<div>").addClass(DROP_DOWN_EDITOR_INPUT_WRAPPER)).children().eq(0)
            },
            _setDefaultAria: function() {
                this.setAria({
                    haspopup: "true",
                    autocomplete: "list"
                })
            },
            _readOnlyPropValue: function() {
                return !this._isEditable() || this.callBase()
            },
            _cleanFocusState: function() {
                this.callBase();
                if (this.option("fieldTemplate")) {
                    this._detachFocusEvents()
                }
            },
            _getFieldTemplate: function() {
                return this.option("fieldTemplate") && this._getTemplateByOption("fieldTemplate")
            },
            _renderMask: function() {
                if (this.option("fieldTemplate")) {
                    return
                }
                this.callBase()
            },
            _renderField: function() {
                var fieldTemplate = this._getFieldTemplate();
                fieldTemplate && this._renderTemplatedField(fieldTemplate, this._fieldRenderData())
            },
            _renderPlaceholder: function() {
                var hasFieldTemplate = !!this._getFieldTemplate();
                if (!hasFieldTemplate) {
                    this.callBase()
                }
            },
            _renderValue: function() {
                if (this.option("useHiddenSubmitElement")) {
                    this._setSubmitValue()
                }
                var promise = this.callBase();
                promise.always(this._renderField.bind(this))
            },
            _renderTemplatedField: function(fieldTemplate, data) {
                var _this = this;
                var isFocused = (0, _selectors.focused)(this._input());
                var $container = this._$container;
                this._detachKeyboardEvents();
                this._refreshButtonsContainer();
                this._detachWrapperContent();
                this._detachFocusEvents();
                $container.empty();
                var $templateWrapper = (0, _renderer.default)("<div>").addClass(DROP_DOWN_EDITOR_FIELD_TEMPLATE_WRAPPER).appendTo($container);
                fieldTemplate.render({
                    model: data,
                    container: (0, _element.getPublicElement)($templateWrapper),
                    onRendered: function() {
                        var $input = _this._input();
                        if (!$input.length) {
                            throw _ui.default.Error("E1010")
                        }
                        _this._integrateInput();
                        isFocused && _events_engine.default.trigger($input, "focus")
                    }
                });
                this._attachWrapperContent($container)
            },
            _detachWrapperContent: function() {
                var _this$_$submitElement, _this$_$beforeButtons, _this$_$afterButtonsC;
                var useHiddenSubmitElement = this.option("useHiddenSubmitElement");
                useHiddenSubmitElement && (null === (_this$_$submitElement = this._$submitElement) || void 0 === _this$_$submitElement ? void 0 : _this$_$submitElement.detach());
                var beforeButtonsContainerParent = null === (_this$_$beforeButtons = this._$beforeButtonsContainer) || void 0 === _this$_$beforeButtons ? void 0 : _this$_$beforeButtons[0].parentNode;
                var afterButtonsContainerParent = null === (_this$_$afterButtonsC = this._$afterButtonsContainer) || void 0 === _this$_$afterButtonsC ? void 0 : _this$_$afterButtonsC[0].parentNode;
                null === beforeButtonsContainerParent || void 0 === beforeButtonsContainerParent ? void 0 : beforeButtonsContainerParent.removeChild(this._$beforeButtonsContainer[0]);
                null === afterButtonsContainerParent || void 0 === afterButtonsContainerParent ? void 0 : afterButtonsContainerParent.removeChild(this._$afterButtonsContainer[0])
            },
            _attachWrapperContent: function($container) {
                var _this$_$submitElement2;
                var useHiddenSubmitElement = this.option("useHiddenSubmitElement");
                $container.prepend(this._$beforeButtonsContainer);
                useHiddenSubmitElement && (null === (_this$_$submitElement2 = this._$submitElement) || void 0 === _this$_$submitElement2 ? void 0 : _this$_$submitElement2.appendTo($container));
                $container.append(this._$afterButtonsContainer)
            },
            _refreshButtonsContainer: function() {
                this._$buttonsContainer = this.$element().children().eq(0)
            },
            _integrateInput: function() {
                this._refreshEvents();
                this._refreshValueChangeEvent();
                this._renderFocusState();
                this._refreshEmptinessEvent()
            },
            _refreshEmptinessEvent: function() {
                _events_engine.default.off(this._input(), "input blur", this._toggleEmptinessEventHandler);
                this._renderEmptinessEvent()
            },
            _fieldRenderData: function() {
                return this.option("value")
            },
            _initTemplates: function() {
                this._templateManager.addDefaultTemplates({
                    dropDownButton: new _function_template.FunctionTemplate(function(options) {
                        var $icon = (0, _renderer.default)("<div>").addClass(DROP_DOWN_EDITOR_BUTTON_ICON);
                        (0, _renderer.default)(options.container).append($icon)
                    })
                });
                this.callBase()
            },
            _renderOpenHandler: function() {
                var $inputWrapper = this._inputWrapper();
                var eventName = (0, _index.addNamespace)(_click.name, this.NAME);
                var openOnFieldClick = this.option("openOnFieldClick");
                _events_engine.default.off($inputWrapper, eventName);
                _events_engine.default.on($inputWrapper, eventName, this._getInputClickHandler(openOnFieldClick));
                this.$element().toggleClass(DROP_DOWN_EDITOR_FIELD_CLICKABLE, openOnFieldClick);
                if (openOnFieldClick) {
                    this._openOnFieldClickAction = this._createAction(this._openHandler.bind(this))
                }
            },
            _attachFocusOutHandler: function() {
                var _this2 = this;
                if (isIOs) {
                    this._detachFocusOutEvents();
                    _events_engine.default.on(this._inputWrapper(), (0, _index.addNamespace)("focusout", this.NAME), function(event) {
                        var newTarget = event.relatedTarget;
                        var popupWrapper = _this2.content ? (0, _renderer.default)(_this2.content()).closest("." + DROP_DOWN_EDITOR_OVERLAY) : _this2._$popup;
                        if (newTarget && _this2.option("opened")) {
                            var isNewTargetOutside = 0 === (0, _renderer.default)(newTarget).closest("." + DROP_DOWN_EDITOR_OVERLAY, popupWrapper).length;
                            if (isNewTargetOutside) {
                                _this2.close()
                            }
                        }
                    })
                }
            },
            _detachFocusOutEvents: function() {
                isIOs && _events_engine.default.off(this._inputWrapper(), (0, _index.addNamespace)("focusout", this.NAME))
            },
            _getInputClickHandler: function(openOnFieldClick) {
                var _this3 = this;
                return openOnFieldClick ? function(e) {
                    _this3._executeOpenAction(e)
                } : function(e) {
                    _this3._focusInput()
                }
            },
            _openHandler: function() {
                this._toggleOpenState()
            },
            _executeOpenAction: function(e) {
                this._openOnFieldClickAction({
                    event: e
                })
            },
            _keyboardEventBindingTarget: function() {
                return this._input()
            },
            _focusInput: function() {
                if (this.option("disabled")) {
                    return false
                }
                if (this.option("focusStateEnabled") && !(0, _selectors.focused)(this._input())) {
                    this._resetCaretPosition();
                    _events_engine.default.trigger(this._input(), "focus")
                }
                return true
            },
            _resetCaretPosition: function() {
                var ignoreEditable = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : false;
                var inputElement = this._input().get(0);
                if (inputElement) {
                    var value = inputElement.value;
                    var caretPosition = (0, _type.isDefined)(value) && (ignoreEditable || this._isEditable()) ? value.length : 0;
                    this._caret({
                        start: caretPosition,
                        end: caretPosition
                    }, true)
                }
            },
            _isEditable: function() {
                return this.option("acceptCustomValue")
            },
            _toggleOpenState: function(isVisible) {
                if (!this._focusInput()) {
                    return
                }
                if (!this.option("readOnly")) {
                    isVisible = arguments.length ? isVisible : !this.option("opened");
                    this.option("opened", isVisible)
                }
            },
            _renderOpenedState: function() {
                var opened = this.option("opened");
                if (opened) {
                    this._createPopup()
                }
                this.$element().toggleClass(DROP_DOWN_EDITOR_ACTIVE, opened);
                this._setPopupOption("visible", opened);
                this.setAria({
                    expanded: opened
                });
                this.setAria("owns", (opened || void 0) && this._popupContentId, this.$element())
            },
            _createPopup: function() {
                if (this._$popup) {
                    return
                }
                this._$popup = (0, _renderer.default)("<div>").addClass(DROP_DOWN_EDITOR_OVERLAY).addClass(this.option("customOverlayCssClass")).appendTo(this.$element());
                this._renderPopup();
                this._renderPopupContent()
            },
            _renderPopupContent: _common.noop,
            _renderPopup: function() {
                var popupConfig = (0, _extend.extend)(this._popupConfig(), this._options.cache("dropDownOptions"));
                this._popup = this._createComponent(this._$popup, _popup.default, popupConfig);
                this._popup.on({
                    showing: this._popupShowingHandler.bind(this),
                    shown: this._popupShownHandler.bind(this),
                    hiding: this._popupHidingHandler.bind(this),
                    hidden: this._popupHiddenHandler.bind(this),
                    contentReady: this._contentReadyHandler.bind(this)
                });
                this._contentReadyHandler();
                this._setPopupContentId(this._popup.$content());
                this._bindInnerWidgetOptions(this._popup, "dropDownOptions")
            },
            _setPopupContentId: function($popupContent) {
                this._popupContentId = "dx-" + new _guid.default;
                this.setAria("id", this._popupContentId, $popupContent)
            },
            _contentReadyHandler: _common.noop,
            _popupConfig: function() {
                var _this4 = this;
                return {
                    onInitialized: this._popupInitializedHandler(),
                    position: (0, _extend.extend)(this.option("popupPosition"), {
                        of: this.$element()
                    }),
                    showTitle: this.option("dropDownOptions.showTitle"),
                    width: function() {
                        return (0, _utils.getElementWidth)(_this4.$element())
                    },
                    height: "auto",
                    shading: false,
                    closeOnTargetScroll: true,
                    closeOnOutsideClick: this._closeOutsideDropDownHandler.bind(this),
                    animation: {
                        show: {
                            type: "fade",
                            duration: 0,
                            from: 0,
                            to: 1
                        },
                        hide: {
                            type: "fade",
                            duration: 400,
                            from: 1,
                            to: 0
                        }
                    },
                    deferRendering: false,
                    focusStateEnabled: false,
                    showCloseButton: false,
                    dragEnabled: false,
                    toolbarItems: this._getPopupToolbarItems(),
                    onPositioned: this._popupPositionedHandler.bind(this),
                    fullScreen: false,
                    contentTemplate: null
                }
            },
            _popupInitializedHandler: function() {
                var _this5 = this;
                if (!this.option("onPopupInitialized")) {
                    return null
                }
                return function(e) {
                    _this5._popupInitializedAction({
                        popup: e.component
                    })
                }
            },
            _dimensionChanged: function() {
                var _this6 = this;
                var popupWidth = (0, _utils.getSizeValue)(this.option("dropDownOptions.width"));
                if (void 0 === popupWidth) {
                    this._setPopupOption("width", function() {
                        return (0, _utils.getElementWidth)(_this6.$element())
                    })
                }
            },
            _popupPositionedHandler: function(e) {
                e.position && this._popup.overlayContent().toggleClass(DROP_DOWN_EDITOR_OVERLAY_FLIPPED, e.position.v.flip)
            },
            _popupShowingHandler: _common.noop,
            _popupHidingHandler: function() {
                this.option("opened", false)
            },
            _popupShownHandler: function() {
                var _this$_validationMess;
                this._openAction();
                null === (_this$_validationMess = this._validationMessage) || void 0 === _this$_validationMess ? void 0 : _this$_validationMess.option("positionRequest", this._getValidationMessagePositionRequest())
            },
            _popupHiddenHandler: function() {
                var _this$_validationMess2;
                this._closeAction();
                null === (_this$_validationMess2 = this._validationMessage) || void 0 === _this$_validationMess2 ? void 0 : _this$_validationMess2.option("positionRequest", this._getValidationMessagePositionRequest())
            },
            _getValidationMessagePositionRequest: function() {
                var positionRequest = "below";
                if (this._popup && this._popup.option("visible")) {
                    var _animationPosition$se = _position.default.setup(this.$element()),
                        myTop = _animationPosition$se.top;
                    var _animationPosition$se2 = _position.default.setup(this._popup.$content()),
                        popupTop = _animationPosition$se2.top;
                    positionRequest = myTop + this.option("popupPosition").offset.v > popupTop ? "below" : "above"
                }
                return positionRequest
            },
            _closeOutsideDropDownHandler: function(_ref) {
                var target = _ref.target;
                var $target = (0, _renderer.default)(target);
                var dropDownButton = this.getButton("dropDown");
                var $dropDownButton = dropDownButton && dropDownButton.$element();
                var isInputClicked = !!$target.closest(this.$element()).length;
                var isDropDownButtonClicked = !!$target.closest($dropDownButton).length;
                var isOutsideClick = !isInputClicked && !isDropDownButtonClicked;
                return isOutsideClick
            },
            _clean: function() {
                delete this._openOnFieldClickAction;
                if (this._$popup) {
                    this._$popup.remove();
                    delete this._$popup;
                    delete this._popup
                }
                this.callBase()
            },
            _setPopupOption: function(optionName, value) {
                this._setWidgetOption("_popup", arguments)
            },
            _validatedOpening: function() {
                if (!this.option("readOnly")) {
                    this._toggleOpenState(true)
                }
            },
            _getPopupToolbarItems: function() {
                return "useButtons" === this.option("applyValueMode") ? this._popupToolbarItemsConfig() : []
            },
            _getFirstPopupElement: function() {
                return this._popup._wrapper().find(".dx-popup-done.dx-button")
            },
            _getLastPopupElement: function() {
                return this._popup._wrapper().find(".dx-popup-cancel.dx-button")
            },
            _popupElementTabHandler: function(e) {
                var $element = (0, _renderer.default)(e.currentTarget);
                if (e.shiftKey && $element.is(this._getFirstPopupElement()) || !e.shiftKey && $element.is(this._getLastPopupElement())) {
                    _events_engine.default.trigger(this._input(), "focus");
                    e.preventDefault()
                }
            },
            _popupElementEscHandler: function() {
                _events_engine.default.trigger(this._input(), "focus");
                this.close()
            },
            _popupButtonInitializedHandler: function(e) {
                e.component.registerKeyHandler("tab", this._popupElementTabHandler.bind(this));
                e.component.registerKeyHandler("escape", this._popupElementEscHandler.bind(this))
            },
            _popupToolbarItemsConfig: function() {
                var buttonsConfig = [{
                    shortcut: "done",
                    options: {
                        onClick: this._applyButtonHandler.bind(this),
                        text: this.option("applyButtonText"),
                        onInitialized: this._popupButtonInitializedHandler.bind(this)
                    }
                }, {
                    shortcut: "cancel",
                    options: {
                        onClick: this._cancelButtonHandler.bind(this),
                        text: this.option("cancelButtonText"),
                        onInitialized: this._popupButtonInitializedHandler.bind(this)
                    }
                }];
                return this._applyButtonsLocation(buttonsConfig)
            },
            _applyButtonsLocation: function(buttonsConfig) {
                var buttonsLocation = this.option("buttonsLocation");
                var resultConfig = buttonsConfig;
                if ("default" !== buttonsLocation) {
                    var position = (0, _common.splitPair)(buttonsLocation);
                    (0, _iterator.each)(resultConfig, function(_, element) {
                        (0, _extend.extend)(element, {
                            toolbar: position[0],
                            location: position[1]
                        })
                    })
                }
                return resultConfig
            },
            _applyButtonHandler: function() {
                this.close();
                this.option("focusStateEnabled") && this.focus()
            },
            _cancelButtonHandler: function() {
                this.close();
                this.option("focusStateEnabled") && this.focus()
            },
            _popupOptionChanged: function(args) {
                var options = _ui3.default.getOptionsFromContainer(args);
                this._setPopupOption(options);
                var optionsKeys = Object.keys(options);
                if (optionsKeys.indexOf("width") !== -1 || optionsKeys.indexOf("height") !== -1) {
                    this._dimensionChanged()
                }
            },
            _renderSubmitElement: function() {
                if (this.option("useHiddenSubmitElement")) {
                    this._$submitElement = (0, _renderer.default)("<input>").attr("type", "hidden").appendTo(this.$element())
                }
            },
            _setSubmitValue: function() {
                this._getSubmitElement().val(this.option("value"))
            },
            _getSubmitElement: function() {
                if (this.option("useHiddenSubmitElement")) {
                    return this._$submitElement
                } else {
                    return this.callBase()
                }
            },
            _dispose: function() {
                this._detachFocusOutEvents();
                this.callBase()
            },
            _setDeprecatedOptions: function() {
                this.callBase();
                (0, _extend.extend)(this._deprecatedOptions, {
                    showPopupTitle: {
                        since: "20.1",
                        alias: "dropDownOptions.showTitle"
                    }
                })
            },
            _optionChanged: function(args) {
                var _this$_popup;
                switch (args.name) {
                    case "width":
                    case "height":
                        this.callBase(args);
                        null === (_this$_popup = this._popup) || void 0 === _this$_popup ? void 0 : _this$_popup.repaint();
                        break;
                    case "opened":
                        this._renderOpenedState();
                        break;
                    case "onOpened":
                    case "onClosed":
                        this._initVisibilityActions();
                        break;
                    case "onPopupInitialized":
                        this._initPopupInitializedAction();
                        break;
                    case "fieldTemplate":
                        if ((0, _type.isDefined)(args.value)) {
                            this._renderField()
                        } else {
                            this._invalidate()
                        }
                        break;
                    case "acceptCustomValue":
                    case "openOnFieldClick":
                        this._invalidate();
                        break;
                    case "dropDownButtonTemplate":
                    case "showDropDownButton":
                        this._updateButtons(["dropDown"]);
                        break;
                    case "dropDownOptions":
                        this._popupOptionChanged(args);
                        this._options.cache("dropDownOptions", this.option("dropDownOptions"));
                        break;
                    case "popupPosition":
                        break;
                    case "deferRendering":
                        if ((0, _window.hasWindow)()) {
                            this._createPopup()
                        }
                        break;
                    case "applyValueMode":
                    case "applyButtonText":
                    case "cancelButtonText":
                    case "buttonsLocation":
                        this._setPopupOption("toolbarItems", this._getPopupToolbarItems());
                        break;
                    case "showPopupTitle":
                        this._setPopupOption("showTitle", args.value);
                        break;
                    case "useHiddenSubmitElement":
                        if (this._$submitElement) {
                            this._$submitElement.remove();
                            this._$submitElement = void 0
                        }
                        this._renderSubmitElement();
                        break;
                    case "rtlEnabled":
                        this._updatePopupPosition(args.value);
                        this.callBase(args);
                        break;
                    default:
                        this.callBase(args)
                }
            },
            open: function() {
                this.option("opened", true)
            },
            close: function() {
                this.option("opened", false)
            },
            field: function() {
                return (0, _element.getPublicElement)(this._input())
            },
            content: function() {
                return this._popup ? this._popup.content() : null
            }
        });
        (0, _component_registrator.default)("dxDropDownEditor", DropDownEditor);
        var _default = DropDownEditor;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************************!*\
      !*** ./artifacts/transpiled-npm/core/polyfills/weak_map.js ***!
      \*************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _array = __webpack_require__( /*! ../utils/array */ 12);
        var _window = __webpack_require__( /*! ../utils/window */ 7);
        var weakMap = (0, _window.hasWindow)() ? (0, _window.getWindow)().WeakMap : WeakMap;
        if (!weakMap) {
            weakMap = function() {
                var keys = [];
                var values = [];
                this.set = function(key, value) {
                    var index = (0, _array.inArray)(key, keys);
                    if (index === -1) {
                        keys.push(key);
                        values.push(value)
                    } else {
                        values[index] = value
                    }
                };
                this.get = function(key) {
                    var index = (0, _array.inArray)(key, keys);
                    if (index === -1) {
                        return
                    }
                    return values[index]
                };
                this.has = function(key) {
                    var index = (0, _array.inArray)(key, keys);
                    if (index === -1) {
                        return false
                    }
                    return true
                };
                this.delete = function(key) {
                    var index = (0, _array.inArray)(key, keys);
                    if (index === -1) {
                        return
                    }
                    keys.splice(index, 1);
                    values.splice(index, 1)
                }
            }
        }
        var _default = weakMap;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************************!*\
      !*** ./artifacts/transpiled-npm/core/memorized_callbacks.js ***!
      \**************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ./utils/callbacks */ 27));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var MemorizedCallbacks = function() {
            function MemorizedCallbacks() {
                this.memory = [];
                this.callbacks = (0, _callbacks.default)()
            }
            var _proto = MemorizedCallbacks.prototype;
            _proto.add = function(fn) {
                (0, _iterator.each)(this.memory, function(_, item) {
                    return fn.apply(fn, item)
                });
                this.callbacks.add(fn)
            };
            _proto.remove = function(fn) {
                this.callbacks.remove(fn)
            };
            _proto.fire = function() {
                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key]
                }
                this.memory.push(args);
                this.callbacks.fire.apply(this.callbacks, args)
            };
            return MemorizedCallbacks
        }();
        exports.default = MemorizedCallbacks;
        module.exports = exports.default
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/core/options/utils.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.createDefaultOptionRules = exports.getNestedOptionValue = exports.getParentName = exports.getFieldName = exports.deviceMatch = exports.normalizeOptions = exports.convertRulesToOptions = void 0;
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../devices */ 13));
        var _type = __webpack_require__( /*! ../utils/type */ 1);
        var _common = __webpack_require__( /*! ../utils/common */ 4);
        var _extend = __webpack_require__( /*! ../utils/extend */ 0);
        var _data = __webpack_require__( /*! ../utils/data */ 20);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }
        var cachedGetters = {};
        var convertRulesToOptions = function(rules) {
            var currentDevice = _devices.default.current();
            return rules.reduce(function(options, _ref) {
                var device = _ref.device,
                    ruleOptions = _ref.options;
                var deviceFilter = device || {};
                var match = (0, _type.isFunction)(deviceFilter) ? deviceFilter(currentDevice) : deviceMatch(currentDevice, deviceFilter);
                if (match) {
                    (0, _extend.extend)(true, options, ruleOptions)
                }
                return options
            }, {})
        };
        exports.convertRulesToOptions = convertRulesToOptions;
        var normalizeOptions = function(options, value) {
            return "string" !== typeof options ? options : _defineProperty({}, options, value)
        };
        exports.normalizeOptions = normalizeOptions;
        var deviceMatch = function(device, filter) {
            return (0, _type.isEmptyObject)(filter) || (0, _common.findBestMatches)(device, [filter]).length > 0
        };
        exports.deviceMatch = deviceMatch;
        var getFieldName = function(fullName) {
            return fullName.substr(fullName.lastIndexOf(".") + 1)
        };
        exports.getFieldName = getFieldName;
        var getParentName = function(fullName) {
            return fullName.substr(0, fullName.lastIndexOf("."))
        };
        exports.getParentName = getParentName;
        var getNestedOptionValue = function(optionsObject, name) {
            cachedGetters[name] = cachedGetters[name] || (0, _data.compileGetter)(name);
            return cachedGetters[name](optionsObject, {
                functionsAsIs: true
            })
        };
        exports.getNestedOptionValue = getNestedOptionValue;
        var createDefaultOptionRules = function() {
            var options = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
            return options
        };
        exports.createDefaultOptionRules = createDefaultOptionRules
    },
    /*!*********************************************************!*\
      !*** ./artifacts/transpiled-npm/data/query_adapters.js ***!
      \*********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _default = {};
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/animation/presets/presets.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.PresetCollection = exports.presets = void 0;
        var _component = _interopRequireDefault(__webpack_require__( /*! ../../core/component */ 127));
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _fx = _interopRequireDefault(__webpack_require__( /*! ../fx */ 42));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var directionPostfixes = {
            forward: " dx-forward",
            backward: " dx-backward",
            none: " dx-no-direction",
            undefined: " dx-no-direction"
        };
        var optionPrefix = "preset_";
        var AnimationPresetCollection = _component.default.inherit({
            ctor: function() {
                this.callBase.apply(this, arguments);
                this._registeredPresets = [];
                this.resetToDefaults()
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    defaultAnimationDuration: 400,
                    defaultAnimationDelay: 0,
                    defaultStaggerAnimationDuration: 300,
                    defaultStaggerAnimationDelay: 40,
                    defaultStaggerAnimationStartDelay: 500
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: function(_device) {
                        return _device.phone
                    },
                    options: {
                        defaultStaggerAnimationDuration: 350,
                        defaultStaggerAnimationDelay: 50,
                        defaultStaggerAnimationStartDelay: 0
                    }
                }, {
                    device: function() {
                        return _devices.default.current().android || _devices.default.real.android
                    },
                    options: {
                        defaultAnimationDelay: 100
                    }
                }])
            },
            _getPresetOptionName: function(animationName) {
                return optionPrefix + animationName
            },
            _createAndroidSlideAnimationConfig: function(throughOpacity, widthMultiplier) {
                var that = this;
                var createBaseConfig = function(configModifier) {
                    return {
                        type: "slide",
                        delay: void 0 === configModifier.delay ? that.option("defaultAnimationDelay") : configModifier.delay,
                        duration: void 0 === configModifier.duration ? that.option("defaultAnimationDuration") : configModifier.duration
                    }
                };
                return {
                    enter: function($element, configModifier) {
                        var width = $element.parent().width() * widthMultiplier;
                        var direction = configModifier.direction;
                        var config = createBaseConfig(configModifier);
                        config.to = {
                            left: 0,
                            opacity: 1
                        };
                        if ("forward" === direction) {
                            config.from = {
                                left: width,
                                opacity: throughOpacity
                            }
                        } else {
                            if ("backward" === direction) {
                                config.from = {
                                    left: -width,
                                    opacity: throughOpacity
                                }
                            } else {
                                config.from = {
                                    left: 0,
                                    opacity: 0
                                }
                            }
                        }
                        return _fx.default.createAnimation($element, config)
                    },
                    leave: function($element, configModifier) {
                        var width = $element.parent().width() * widthMultiplier;
                        var direction = configModifier.direction;
                        var config = createBaseConfig(configModifier);
                        config.from = {
                            left: 0,
                            opacity: 1
                        };
                        if ("forward" === direction) {
                            config.to = {
                                left: -width,
                                opacity: throughOpacity
                            }
                        } else {
                            if ("backward" === direction) {
                                config.to = {
                                    left: width,
                                    opacity: throughOpacity
                                }
                            } else {
                                config.to = {
                                    left: 0,
                                    opacity: 0
                                }
                            }
                        }
                        return _fx.default.createAnimation($element, config)
                    }
                }
            },
            _createOpenDoorConfig: function() {
                var that = this;
                var createBaseConfig = function(configModifier) {
                    return {
                        type: "css",
                        extraCssClasses: "dx-opendoor-animation",
                        delay: void 0 === configModifier.delay ? that.option("defaultAnimationDelay") : configModifier.delay,
                        duration: void 0 === configModifier.duration ? that.option("defaultAnimationDuration") : configModifier.duration
                    }
                };
                return {
                    enter: function($element, configModifier) {
                        var direction = configModifier.direction;
                        var config = createBaseConfig(configModifier);
                        config.delay = "none" === direction ? config.delay : config.duration;
                        config.from = "dx-enter dx-opendoor-animation" + directionPostfixes[direction];
                        config.to = "dx-enter-active";
                        return _fx.default.createAnimation($element, config)
                    },
                    leave: function($element, configModifier) {
                        var direction = configModifier.direction;
                        var config = createBaseConfig(configModifier);
                        config.from = "dx-leave dx-opendoor-animation" + directionPostfixes[direction];
                        config.to = "dx-leave-active";
                        return _fx.default.createAnimation($element, config)
                    }
                }
            },
            _createWinPopConfig: function() {
                var that = this;
                var baseConfig = {
                    type: "css",
                    extraCssClasses: "dx-win-pop-animation",
                    duration: that.option("defaultAnimationDuration")
                };
                return {
                    enter: function($element, configModifier) {
                        var config = baseConfig;
                        var direction = configModifier.direction;
                        config.delay = "none" === direction ? that.option("defaultAnimationDelay") : that.option("defaultAnimationDuration") / 2;
                        config.from = "dx-enter dx-win-pop-animation" + directionPostfixes[direction];
                        config.to = "dx-enter-active";
                        return _fx.default.createAnimation($element, config)
                    },
                    leave: function($element, configModifier) {
                        var config = baseConfig;
                        var direction = configModifier.direction;
                        config.delay = that.option("defaultAnimationDelay");
                        config.from = "dx-leave dx-win-pop-animation" + directionPostfixes[direction];
                        config.to = "dx-leave-active";
                        return _fx.default.createAnimation($element, config)
                    }
                }
            },
            resetToDefaults: function() {
                this.clear();
                this.registerDefaultPresets();
                this.applyChanges()
            },
            clear: function(name) {
                var that = this;
                var newRegisteredPresets = [];
                (0, _iterator.each)(this._registeredPresets, function(index, preset) {
                    if (!name || name === preset.name) {
                        that.option(that._getPresetOptionName(preset.name), void 0)
                    } else {
                        newRegisteredPresets.push(preset)
                    }
                });
                this._registeredPresets = newRegisteredPresets;
                this.applyChanges()
            },
            registerPreset: function(name, config) {
                this._registeredPresets.push({
                    name: name,
                    config: config
                })
            },
            applyChanges: function() {
                var that = this;
                var customRules = [];
                (0, _iterator.each)(this._registeredPresets, function(index, preset) {
                    var rule = {
                        device: preset.config.device,
                        options: {}
                    };
                    rule.options[that._getPresetOptionName(preset.name)] = preset.config.animation;
                    customRules.push(rule)
                });
                this._setOptionsByDevice(customRules)
            },
            getPreset: function(name) {
                var result = name;
                while ("string" === typeof result) {
                    result = this.option(this._getPresetOptionName(result))
                }
                return result
            },
            registerDefaultPresets: function() {
                this.registerPreset("pop", {
                    animation: {
                        extraCssClasses: "dx-android-pop-animation",
                        delay: this.option("defaultAnimationDelay"),
                        duration: this.option("defaultAnimationDuration")
                    }
                });
                this.registerPreset("openDoor", {
                    animation: this._createOpenDoorConfig()
                });
                this.registerPreset("win-pop", {
                    animation: this._createWinPopConfig()
                });
                this.registerPreset("fade", {
                    animation: {
                        extraCssClasses: "dx-fade-animation",
                        delay: this.option("defaultAnimationDelay"),
                        duration: this.option("defaultAnimationDuration")
                    }
                });
                this.registerPreset("slide", {
                    device: function() {
                        return _devices.default.current().android || _devices.default.real.android
                    },
                    animation: this._createAndroidSlideAnimationConfig(1, 1)
                });
                this.registerPreset("slide", {
                    device: function() {
                        return !_devices.default.current().android && !_devices.default.real.android
                    },
                    animation: {
                        extraCssClasses: "dx-slide-animation",
                        delay: this.option("defaultAnimationDelay"),
                        duration: this.option("defaultAnimationDuration")
                    }
                });
                this.registerPreset("ios7-slide", {
                    animation: {
                        extraCssClasses: "dx-ios7-slide-animation",
                        delay: this.option("defaultAnimationDelay"),
                        duration: this.option("defaultAnimationDuration")
                    }
                });
                this.registerPreset("overflow", {
                    animation: {
                        extraCssClasses: "dx-overflow-animation",
                        delay: this.option("defaultAnimationDelay"),
                        duration: this.option("defaultAnimationDuration")
                    }
                });
                this.registerPreset("ios7-toolbar", {
                    device: function() {
                        return !_devices.default.current().android && !_devices.default.real.android
                    },
                    animation: {
                        extraCssClasses: "dx-ios7-toolbar-animation",
                        delay: this.option("defaultAnimationDelay"),
                        duration: this.option("defaultAnimationDuration")
                    }
                });
                this.registerPreset("ios7-toolbar", {
                    device: function() {
                        return _devices.default.current().android || _devices.default.real.android
                    },
                    animation: this._createAndroidSlideAnimationConfig(0, .4)
                });
                this.registerPreset("stagger-fade", {
                    animation: {
                        extraCssClasses: "dx-fade-animation",
                        staggerDelay: this.option("defaultStaggerAnimationDelay"),
                        duration: this.option("defaultStaggerAnimationDuration"),
                        delay: this.option("defaultStaggerAnimationStartDelay")
                    }
                });
                this.registerPreset("stagger-slide", {
                    animation: {
                        extraCssClasses: "dx-slide-animation",
                        staggerDelay: this.option("defaultStaggerAnimationDelay"),
                        duration: this.option("defaultStaggerAnimationDuration"),
                        delay: this.option("defaultStaggerAnimationStartDelay")
                    }
                });
                this.registerPreset("stagger-fade-slide", {
                    animation: {
                        extraCssClasses: "dx-fade-slide-animation",
                        staggerDelay: this.option("defaultStaggerAnimationDelay"),
                        duration: this.option("defaultStaggerAnimationDuration"),
                        delay: this.option("defaultStaggerAnimationStartDelay")
                    }
                });
                this.registerPreset("stagger-drop", {
                    animation: {
                        extraCssClasses: "dx-drop-animation",
                        staggerDelay: this.option("defaultStaggerAnimationDelay"),
                        duration: this.option("defaultStaggerAnimationDuration"),
                        delay: this.option("defaultStaggerAnimationStartDelay")
                    }
                });
                this.registerPreset("stagger-fade-drop", {
                    animation: {
                        extraCssClasses: "dx-fade-drop-animation",
                        staggerDelay: this.option("defaultStaggerAnimationDelay"),
                        duration: this.option("defaultStaggerAnimationDuration"),
                        delay: this.option("defaultStaggerAnimationStartDelay")
                    }
                });
                this.registerPreset("stagger-fade-rise", {
                    animation: {
                        extraCssClasses: "dx-fade-rise-animation",
                        staggerDelay: this.option("defaultStaggerAnimationDelay"),
                        duration: this.option("defaultStaggerAnimationDuration"),
                        delay: this.option("defaultStaggerAnimationStartDelay")
                    }
                });
                this.registerPreset("stagger-3d-drop", {
                    animation: {
                        extraCssClasses: "dx-3d-drop-animation",
                        staggerDelay: this.option("defaultStaggerAnimationDelay"),
                        duration: this.option("defaultStaggerAnimationDuration"),
                        delay: this.option("defaultStaggerAnimationStartDelay")
                    }
                });
                this.registerPreset("stagger-fade-zoom", {
                    animation: {
                        extraCssClasses: "dx-fade-zoom-animation",
                        staggerDelay: this.option("defaultStaggerAnimationDelay"),
                        duration: this.option("defaultStaggerAnimationDuration"),
                        delay: this.option("defaultStaggerAnimationStartDelay")
                    }
                })
            }
        });
        exports.PresetCollection = AnimationPresetCollection;
        var animationPresets = new AnimationPresetCollection;
        exports.presets = animationPresets
    },
    /*!****************************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/angular/module.js ***!
      \****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _angular = _interopRequireDefault(__webpack_require__( /*! angular */ 133));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ngModule;
        if (_angular.default) {
            ngModule = _angular.default.module("dx", [])
        }
        var _default = ngModule;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/collection/ui.collection_widget.edit.strategy.plain.js ***!
      \********************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _uiCollection_widgetEdit = _interopRequireDefault(__webpack_require__( /*! ./ui.collection_widget.edit.strategy */ 550));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        var PlainEditStrategy = _uiCollection_widgetEdit.default.inherit({
            _getPlainItems: function() {
                return this._collectionWidget.option("items") || []
            },
            getIndexByItemData: function(itemData) {
                var keyOf = this._collectionWidget.keyOf.bind(this._collectionWidget);
                if (keyOf) {
                    return this.getIndexByKey(keyOf(itemData))
                } else {
                    return (0, _array.inArray)(itemData, this._getPlainItems())
                }
            },
            getItemDataByIndex: function(index) {
                return this._getPlainItems()[index]
            },
            deleteItemAtIndex: function(index) {
                this._getPlainItems().splice(index, 1)
            },
            itemsGetter: function() {
                return this._getPlainItems()
            },
            getKeysByItems: function(items) {
                var keyOf = this._collectionWidget.keyOf.bind(this._collectionWidget);
                var result = items;
                if (keyOf) {
                    result = [];
                    for (var i = 0; i < items.length; i++) {
                        result.push(keyOf(items[i]))
                    }
                }
                return result
            },
            getIndexByKey: function(key) {
                var cache = this._cache;
                var keys = cache && cache.keys || this.getKeysByItems(this._getPlainItems());
                if (cache && !cache.keys) {
                    cache.keys = keys
                }
                if ("object" === _typeof(key)) {
                    for (var i = 0, length = keys.length; i < length; i++) {
                        if (this._equalKeys(key, keys[i])) {
                            return i
                        }
                    }
                } else {
                    return keys.indexOf(key)
                }
                return -1
            },
            getItemsByKeys: function(keys, items) {
                return (items || keys).slice()
            },
            moveItemAtIndexToIndex: function(movingIndex, destinationIndex) {
                var items = this._getPlainItems();
                var movedItemData = items[movingIndex];
                items.splice(movingIndex, 1);
                items.splice(destinationIndex, 0, movedItemData)
            },
            _isItemIndex: function(index) {
                return "number" === typeof index && Math.round(index) === index
            },
            _getNormalizedItemIndex: function(itemElement) {
                return this._collectionWidget._itemElements().index(itemElement)
            },
            _normalizeItemIndex: function(index) {
                return index
            },
            _denormalizeItemIndex: function(index) {
                return index
            },
            _getItemByNormalizedIndex: function(index) {
                return index > -1 ? this._collectionWidget._itemElements().eq(index) : null
            },
            _itemsFromSameParent: function() {
                return true
            }
        });
        var _default = PlainEditStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/localization/globalize/number.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        __webpack_require__( /*! ./core */ 134);
        var _globalize = _interopRequireDefault(__webpack_require__( /*! globalize */ 78));
        var _number = _interopRequireDefault(__webpack_require__( /*! ../number */ 47));
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../../core/errors */ 25));
        __webpack_require__( /*! globalize/number */ 78);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        if (_globalize.default && _globalize.default.formatNumber) {
            var enNumbers = {
                main: {
                    en: {
                        identity: {
                            version: {
                                _cldrVersion: "28",
                                _number: "$Revision: 11972 $"
                            },
                            language: "en"
                        },
                        numbers: {
                            defaultNumberingSystem: "latn",
                            otherNumberingSystems: {
                                "native": "latn"
                            },
                            minimumGroupingDigits: "1",
                            "symbols-numberSystem-latn": {
                                decimal: ".",
                                group: ",",
                                list: ";",
                                percentSign: "%",
                                plusSign: "+",
                                minusSign: "-",
                                exponential: "E",
                                superscriptingExponent: "\xd7",
                                perMille: "\u2030",
                                infinity: "\u221e",
                                nan: "NaN",
                                timeSeparator: ":"
                            },
                            "decimalFormats-numberSystem-latn": {
                                standard: "#,##0.###",
                                "long": {
                                    decimalFormat: {
                                        "1000-count-one": "0 thousand",
                                        "1000-count-other": "0 thousand",
                                        "10000-count-one": "00 thousand",
                                        "10000-count-other": "00 thousand",
                                        "100000-count-one": "000 thousand",
                                        "100000-count-other": "000 thousand",
                                        "1000000-count-one": "0 million",
                                        "1000000-count-other": "0 million",
                                        "10000000-count-one": "00 million",
                                        "10000000-count-other": "00 million",
                                        "100000000-count-one": "000 million",
                                        "100000000-count-other": "000 million",
                                        "1000000000-count-one": "0 billion",
                                        "1000000000-count-other": "0 billion",
                                        "10000000000-count-one": "00 billion",
                                        "10000000000-count-other": "00 billion",
                                        "100000000000-count-one": "000 billion",
                                        "100000000000-count-other": "000 billion",
                                        "1000000000000-count-one": "0 trillion",
                                        "1000000000000-count-other": "0 trillion",
                                        "10000000000000-count-one": "00 trillion",
                                        "10000000000000-count-other": "00 trillion",
                                        "100000000000000-count-one": "000 trillion",
                                        "100000000000000-count-other": "000 trillion"
                                    }
                                },
                                "short": {
                                    decimalFormat: {
                                        "1000-count-one": "0K",
                                        "1000-count-other": "0K",
                                        "10000-count-one": "00K",
                                        "10000-count-other": "00K",
                                        "100000-count-one": "000K",
                                        "100000-count-other": "000K",
                                        "1000000-count-one": "0M",
                                        "1000000-count-other": "0M",
                                        "10000000-count-one": "00M",
                                        "10000000-count-other": "00M",
                                        "100000000-count-one": "000M",
                                        "100000000-count-other": "000M",
                                        "1000000000-count-one": "0B",
                                        "1000000000-count-other": "0B",
                                        "10000000000-count-one": "00B",
                                        "10000000000-count-other": "00B",
                                        "100000000000-count-one": "000B",
                                        "100000000000-count-other": "000B",
                                        "1000000000000-count-one": "0T",
                                        "1000000000000-count-other": "0T",
                                        "10000000000000-count-one": "00T",
                                        "10000000000000-count-other": "00T",
                                        "100000000000000-count-one": "000T",
                                        "100000000000000-count-other": "000T"
                                    }
                                }
                            },
                            "scientificFormats-numberSystem-latn": {
                                standard: "#E0"
                            },
                            "percentFormats-numberSystem-latn": {
                                standard: "#,##0%"
                            },
                            "currencyFormats-numberSystem-latn": {
                                currencySpacing: {
                                    beforeCurrency: {
                                        currencyMatch: "[:^S:]",
                                        surroundingMatch: "[:digit:]",
                                        insertBetween: "\xa0"
                                    },
                                    afterCurrency: {
                                        currencyMatch: "[:^S:]",
                                        surroundingMatch: "[:digit:]",
                                        insertBetween: "\xa0"
                                    }
                                },
                                standard: "\xa4#,##0.00",
                                accounting: "\xa4#,##0.00;(\xa4#,##0.00)",
                                "short": {
                                    standard: {
                                        "1000-count-one": "\xa40K",
                                        "1000-count-other": "\xa40K",
                                        "10000-count-one": "\xa400K",
                                        "10000-count-other": "\xa400K",
                                        "100000-count-one": "\xa4000K",
                                        "100000-count-other": "\xa4000K",
                                        "1000000-count-one": "\xa40M",
                                        "1000000-count-other": "\xa40M",
                                        "10000000-count-one": "\xa400M",
                                        "10000000-count-other": "\xa400M",
                                        "100000000-count-one": "\xa4000M",
                                        "100000000-count-other": "\xa4000M",
                                        "1000000000-count-one": "\xa40B",
                                        "1000000000-count-other": "\xa40B",
                                        "10000000000-count-one": "\xa400B",
                                        "10000000000-count-other": "\xa400B",
                                        "100000000000-count-one": "\xa4000B",
                                        "100000000000-count-other": "\xa4000B",
                                        "1000000000000-count-one": "\xa40T",
                                        "1000000000000-count-other": "\xa40T",
                                        "10000000000000-count-one": "\xa400T",
                                        "10000000000000-count-other": "\xa400T",
                                        "100000000000000-count-one": "\xa4000T",
                                        "100000000000000-count-other": "\xa4000T"
                                    }
                                },
                                "unitPattern-count-one": "{0} {1}",
                                "unitPattern-count-other": "{0} {1}"
                            },
                            "miscPatterns-numberSystem-latn": {
                                atLeast: "{0}+",
                                range: "{0}\u2013{1}"
                            }
                        }
                    }
                }
            };
            if ("en" === _globalize.default.locale().locale) {
                _globalize.default.load(enNumbers);
                _globalize.default.locale("en")
            }
            var formattersCache = {};
            var getFormatter = function(format) {
                var formatter;
                var formatCacheKey;
                if ("object" === _typeof(format)) {
                    formatCacheKey = _globalize.default.locale().locale + ":" + JSON.stringify(format)
                } else {
                    formatCacheKey = _globalize.default.locale().locale + ":" + format
                }
                formatter = formattersCache[formatCacheKey];
                if (!formatter) {
                    formatter = formattersCache[formatCacheKey] = _globalize.default.numberFormatter(format)
                }
                return formatter
            };
            var globalizeNumberLocalization = {
                engine: function() {
                    return "globalize"
                },
                _formatNumberCore: function(value, format, formatConfig) {
                    if ("exponential" === format) {
                        return this.callBase.apply(this, arguments)
                    }
                    return getFormatter(this._normalizeFormatConfig(format, formatConfig, value))(value)
                },
                _normalizeFormatConfig: function(format, formatConfig, value) {
                    var config;
                    if ("decimal" === format) {
                        config = {
                            minimumIntegerDigits: formatConfig.precision || 1,
                            useGrouping: false,
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 20,
                            round: value < 0 ? "ceil" : "floor"
                        }
                    } else {
                        config = this._getPrecisionConfig(formatConfig.precision)
                    }
                    if ("percent" === format) {
                        config.style = "percent"
                    }
                    return config
                },
                _getPrecisionConfig: function(precision) {
                    var config;
                    if (null === precision) {
                        config = {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 20
                        }
                    } else {
                        config = {
                            minimumFractionDigits: precision || 0,
                            maximumFractionDigits: precision || 0
                        }
                    }
                    return config
                },
                format: function(value, _format) {
                    if ("number" !== typeof value) {
                        return value
                    }
                    _format = this._normalizeFormat(_format);
                    if (!_format || "function" !== typeof _format && !_format.type && !_format.formatter) {
                        return getFormatter(_format)(value)
                    }
                    return this.callBase.apply(this, arguments)
                },
                parse: function(text, format) {
                    if (!text) {
                        return
                    }
                    if (format && (format.parser || "string" === typeof format)) {
                        return this.callBase.apply(this, arguments)
                    }
                    if (format) {
                        _errors.default.log("W0011")
                    }
                    var result = _globalize.default.parseNumber(text);
                    if (isNaN(result)) {
                        result = this.callBase.apply(this, arguments)
                    }
                    return result
                }
            };
            _number.default.resetInjection();
            _number.default.inject(globalizeNumberLocalization)
        }
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/localization/language_codes.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getLanguageId = getLanguageId;
        var _core = _interopRequireDefault(__webpack_require__( /*! ./core */ 87));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var LANGUAGE_CODES = {
            ar: 1,
            bg: 2,
            ca: 3,
            "zh-Hans": 4,
            cs: 5,
            da: 6,
            de: 7,
            el: 8,
            en: 9,
            es: 10,
            fi: 11,
            fr: 12,
            he: 13,
            hu: 14,
            is: 15,
            it: 16,
            ja: 17,
            ko: 18,
            nl: 19,
            no: 20,
            pl: 21,
            pt: 22,
            rm: 23,
            ro: 24,
            ru: 25,
            hr: 26,
            sk: 27,
            sq: 28,
            sv: 29,
            th: 30,
            tr: 31,
            ur: 32,
            id: 33,
            uk: 34,
            be: 35,
            sl: 36,
            et: 37,
            lv: 38,
            lt: 39,
            tg: 40,
            fa: 41,
            vi: 42,
            hy: 43,
            az: 44,
            eu: 45,
            hsb: 46,
            mk: 47,
            tn: 50,
            xh: 52,
            zu: 53,
            af: 54,
            ka: 55,
            fo: 56,
            hi: 57,
            mt: 58,
            se: 59,
            ga: 60,
            ms: 62,
            kk: 63,
            ky: 64,
            sw: 65,
            tk: 66,
            uz: 67,
            tt: 68,
            bn: 69,
            pa: 70,
            gu: 71,
            or: 72,
            ta: 73,
            te: 74,
            kn: 75,
            ml: 76,
            as: 77,
            mr: 78,
            sa: 79,
            mn: 80,
            bo: 81,
            cy: 82,
            km: 83,
            lo: 84,
            gl: 86,
            kok: 87,
            syr: 90,
            si: 91,
            iu: 93,
            am: 94,
            tzm: 95,
            ne: 97,
            fy: 98,
            ps: 99,
            fil: 100,
            dv: 101,
            ha: 104,
            yo: 106,
            quz: 107,
            nso: 108,
            ba: 109,
            lb: 110,
            kl: 111,
            ig: 112,
            ii: 120,
            arn: 122,
            moh: 124,
            br: 126,
            ug: 128,
            mi: 129,
            oc: 130,
            co: 131,
            gsw: 132,
            sah: 133,
            qut: 134,
            rw: 135,
            wo: 136,
            prs: 140,
            gd: 145,
            "ar-SA": 1025,
            "bg-BG": 1026,
            "ca-ES": 1027,
            "zh-TW": 1028,
            "cs-CZ": 1029,
            "da-DK": 1030,
            "de-DE": 1031,
            "el-GR": 1032,
            "en-US": 1033,
            "fi-FI": 1035,
            "fr-FR": 1036,
            "he-IL": 1037,
            "hu-HU": 1038,
            "is-IS": 1039,
            "it-IT": 1040,
            "ja-JP": 1041,
            "ko-KR": 1042,
            "nl-NL": 1043,
            "nb-NO": 1044,
            "pl-PL": 1045,
            "pt-BR": 1046,
            "rm-CH": 1047,
            "ro-RO": 1048,
            "ru-RU": 1049,
            "hr-HR": 1050,
            "sk-SK": 1051,
            "sq-AL": 1052,
            "sv-SE": 1053,
            "th-TH": 1054,
            "tr-TR": 1055,
            "ur-PK": 1056,
            "id-ID": 1057,
            "uk-UA": 1058,
            "be-BY": 1059,
            "sl-SI": 1060,
            "et-EE": 1061,
            "lv-LV": 1062,
            "lt-LT": 1063,
            "tg-Cyrl-TJ": 1064,
            "fa-IR": 1065,
            "vi-VN": 1066,
            "hy-AM": 1067,
            "az-Latn-AZ": 1068,
            "eu-ES": 1069,
            "hsb-DE": 1070,
            "mk-MK": 1071,
            "tn-ZA": 1074,
            "xh-ZA": 1076,
            "zu-ZA": 1077,
            "af-ZA": 1078,
            "ka-GE": 1079,
            "fo-FO": 1080,
            "hi-IN": 1081,
            "mt-MT": 1082,
            "se-NO": 1083,
            "ms-MY": 1086,
            "kk-KZ": 1087,
            "ky-KG": 1088,
            "sw-KE": 1089,
            "tk-TM": 1090,
            "uz-Latn-UZ": 1091,
            "tt-RU": 1092,
            "bn-IN": 1093,
            "pa-IN": 1094,
            "gu-IN": 1095,
            "or-IN": 1096,
            "ta-IN": 1097,
            "te-IN": 1098,
            "kn-IN": 1099,
            "ml-IN": 1100,
            "as-IN": 1101,
            "mr-IN": 1102,
            "sa-IN": 1103,
            "mn-MN": 1104,
            "bo-CN": 1105,
            "cy-GB": 1106,
            "km-KH": 1107,
            "lo-LA": 1108,
            "gl-ES": 1110,
            "kok-IN": 1111,
            "syr-SY": 1114,
            "si-LK": 1115,
            "iu-Cans-CA": 1117,
            "am-ET": 1118,
            "ne-NP": 1121,
            "fy-NL": 1122,
            "ps-AF": 1123,
            "fil-PH": 1124,
            "dv-MV": 1125,
            "ha-Latn-NG": 1128,
            "yo-NG": 1130,
            "quz-BO": 1131,
            "nso-ZA": 1132,
            "ba-RU": 1133,
            "lb-LU": 1134,
            "kl-GL": 1135,
            "ig-NG": 1136,
            "ii-CN": 1144,
            "arn-CL": 1146,
            "moh-CA": 1148,
            "br-FR": 1150,
            "ug-CN": 1152,
            "mi-NZ": 1153,
            "oc-FR": 1154,
            "co-FR": 1155,
            "gsw-FR": 1156,
            "sah-RU": 1157,
            "qut-GT": 1158,
            "rw-RW": 1159,
            "wo-SN": 1160,
            "prs-AF": 1164,
            "gd-GB": 1169,
            "ar-IQ": 2049,
            "zh-CN": 2052,
            "de-CH": 2055,
            "en-GB": 2057,
            "es-MX": 2058,
            "fr-BE": 2060,
            "it-CH": 2064,
            "nl-BE": 2067,
            "nn-NO": 2068,
            "pt-PT": 2070,
            "sr-Latn-CS": 2074,
            "sv-FI": 2077,
            "az-Cyrl-AZ": 2092,
            "dsb-DE": 2094,
            "se-SE": 2107,
            "ga-IE": 2108,
            "ms-BN": 2110,
            "uz-Cyrl-UZ": 2115,
            "bn-BD": 2117,
            "mn-Mong-CN": 2128,
            "iu-Latn-CA": 2141,
            "tzm-Latn-DZ": 2143,
            "quz-EC": 2155,
            "ar-EG": 3073,
            "zh-HK": 3076,
            "de-AT": 3079,
            "en-AU": 3081,
            "es-ES": 3082,
            "fr-CA": 3084,
            "sr-Cyrl-CS": 3098,
            "se-FI": 3131,
            "quz-PE": 3179,
            "ar-LY": 4097,
            "zh-SG": 4100,
            "de-LU": 4103,
            "en-CA": 4105,
            "es-GT": 4106,
            "fr-CH": 4108,
            "hr-BA": 4122,
            "smj-NO": 4155,
            "ar-DZ": 5121,
            "zh-MO": 5124,
            "de-LI": 5127,
            "en-NZ": 5129,
            "es-CR": 5130,
            "fr-LU": 5132,
            "bs-Latn-BA": 5146,
            "smj-SE": 5179,
            "ar-MA": 6145,
            "en-IE": 6153,
            "es-PA": 6154,
            "fr-MC": 6156,
            "sr-Latn-BA": 6170,
            "sma-NO": 6203,
            "ar-TN": 7169,
            "en-ZA": 7177,
            "es-DO": 7178,
            "sr-Cyrl-BA": 7194,
            "sma-SE": 7227,
            "ar-OM": 8193,
            "en-JM": 8201,
            "es-VE": 8202,
            "bs-Cyrl-BA": 8218,
            "sms-FI": 8251,
            "ar-YE": 9217,
            "en-029": 9225,
            "es-CO": 9226,
            "sr-Latn-RS": 9242,
            "smn-FI": 9275,
            "ar-SY": 10241,
            "en-BZ": 10249,
            "es-PE": 10250,
            "sr-Cyrl-RS": 10266,
            "ar-JO": 11265,
            "en-TT": 11273,
            "es-AR": 11274,
            "sr-Latn-ME": 11290,
            "ar-LB": 12289,
            "en-ZW": 12297,
            "es-EC": 12298,
            "sr-Cyrl-ME": 12314,
            "ar-KW": 13313,
            "en-PH": 13321,
            "es-CL": 13322,
            "ar-AE": 14337,
            "es-UY": 14346,
            "ar-BH": 15361,
            "es-PY": 15370,
            "ar-QA": 16385,
            "en-IN": 16393,
            "es-BO": 16394,
            "en-MY": 17417,
            "es-SV": 17418,
            "en-SG": 18441,
            "es-HN": 18442,
            "es-NI": 19466,
            "es-PR": 20490,
            "es-US": 21514,
            "bs-Cyrl": 25626,
            "bs-Latn": 26650,
            "sr-Cyrl": 27674,
            "sr-Latn": 28698,
            smn: 28731,
            "az-Cyrl": 29740,
            sms: 29755,
            zh: 30724,
            nn: 30740,
            bs: 30746,
            "az-Latn": 30764,
            sma: 30779,
            "uz-Cyrl": 30787,
            "mn-Cyrl": 30800,
            "iu-Cans": 30813,
            "zh-Hant": 31748,
            nb: 31764,
            sr: 31770,
            "tg-Cyrl": 31784,
            dsb: 31790,
            smj: 31803,
            "uz-Latn": 31811,
            "mn-Mong": 31824,
            "iu-Latn": 31837,
            "tzm-Latn": 31839,
            "ha-Latn": 31848
        };

        function getLanguageId() {
            return LANGUAGE_CODES[_core.default.locale()]
        }
    },
    /*!****************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/svg.js ***!
      \****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getSvgMarkup = getSvgMarkup;
        exports.getSvgElement = getSvgElement;
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _window = __webpack_require__( /*! ./window */ 7);
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();

        function getMarkup(element, backgroundColor) {
            var temp = _dom_adapter.default.createElement("div");
            var clone = element.cloneNode(true);
            if (backgroundColor) {
                (0, _renderer.default)(clone).css("backgroundColor", backgroundColor)
            }
            temp.appendChild(clone);
            return temp.innerHTML
        }

        function fixNamespaces(markup) {
            var first = true;
            if (markup.indexOf("xmlns:xlink") === -1) {
                markup = markup.replace("<svg", '<svg xmlns:xlink="http://www.w3.org/1999/xlink"')
            }
            markup = markup.replace(/xmlns="[\s\S]*?"/gi, function(match) {
                if (!first) {
                    return ""
                }
                first = false;
                return match
            });
            return markup.replace(/xmlns:NS1="[\s\S]*?"/gi, "").replace(/NS1:xmlns:xlink="([\s\S]*?)"/gi, 'xmlns:xlink="$1"')
        }

        function decodeHtmlEntities(markup) {
            return markup.replace(/&quot;/gi, "&#34;").replace(/&amp;/gi, "&#38;").replace(/&apos;/gi, "&#39;").replace(/&lt;/gi, "&#60;").replace(/&gt;/gi, "&#62;").replace(/&nbsp;/gi, "&#160;").replace(/&shy;/gi, "&#173;")
        }

        function getSvgMarkup(element, backgroundColor) {
            return fixNamespaces(decodeHtmlEntities(getMarkup(element, backgroundColor)))
        }

        function getSvgElement(markup) {
            return _dom_adapter.default.isNode(markup) ? markup : (new window.DOMParser).parseFromString(markup, "image/svg+xml").childNodes[0]
        }
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/file_management/provider_base.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _data = __webpack_require__( /*! ../core/utils/data */ 20);
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _date_serialization = _interopRequireDefault(__webpack_require__( /*! ../core/utils/date_serialization */ 57));
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);
        var _file_system_item = _interopRequireDefault(__webpack_require__( /*! ./file_system_item */ 333));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DEFAULT_FILE_UPLOAD_CHUNK_SIZE = 2e5;
        var FileSystemProviderBase = function() {
            function FileSystemProviderBase(options) {
                options = (0, _common.ensureDefined)(options, {});
                this._keyGetter = (0, _data.compileGetter)(this._getKeyExpr(options));
                this._nameGetter = (0, _data.compileGetter)(this._getNameExpr(options));
                this._isDirGetter = (0, _data.compileGetter)(this._getIsDirExpr(options));
                this._sizeGetter = (0, _data.compileGetter)(this._getSizeExpr(options));
                this._dateModifiedGetter = (0, _data.compileGetter)(this._getDateModifiedExpr(options));
                this._thumbnailGetter = (0, _data.compileGetter)(options.thumbnailExpr || "thumbnail")
            }
            var _proto = FileSystemProviderBase.prototype;
            _proto.getItems = function(parentDirectory) {
                return []
            };
            _proto.renameItem = function(item, name) {};
            _proto.createDirectory = function(parentDirectory, name) {};
            _proto.deleteItems = function(items) {};
            _proto.moveItems = function(items, destinationDirectory) {};
            _proto.copyItems = function(items, destinationDirectory) {};
            _proto.uploadFileChunk = function(fileData, chunksInfo, destinationDirectory) {};
            _proto.abortFileUpload = function(fileData, chunksInfo, destinationDirectory) {};
            _proto.downloadItems = function(items) {};
            _proto.getItemsContent = function(items) {};
            _proto.getFileUploadChunkSize = function() {
                return DEFAULT_FILE_UPLOAD_CHUNK_SIZE
            };
            _proto._convertDataObjectsToFileItems = function(entries, pathInfo) {
                var _this = this;
                var result = [];
                (0, _iterator.each)(entries, function(_, entry) {
                    var fileItem = _this._createFileItem(entry, pathInfo);
                    result.push(fileItem)
                });
                return result
            };
            _proto._createFileItem = function(dataObj, pathInfo) {
                var fileItem = new _file_system_item.default(pathInfo, this._nameGetter(dataObj), (!!this._isDirGetter(dataObj)));
                fileItem.size = this._sizeGetter(dataObj);
                if (void 0 === fileItem.size) {
                    fileItem.size = 0
                }
                fileItem.dateModified = _date_serialization.default.deserializeDate(this._dateModifiedGetter(dataObj));
                if (void 0 === fileItem.dateModified) {
                    fileItem.dateModified = new Date
                }
                if (fileItem.isDirectory) {
                    fileItem.hasSubDirectories = this._hasSubDirs(dataObj)
                }
                fileItem.key = this._keyGetter(dataObj);
                if (!fileItem.key) {
                    fileItem.key = fileItem.relativeName
                }
                fileItem.thumbnail = this._thumbnailGetter(dataObj) || "";
                fileItem.dataItem = dataObj;
                return fileItem
            };
            _proto._hasSubDirs = function(dataObj) {
                return true
            };
            _proto._getKeyExpr = function(options) {
                return options.keyExpr || this._defaultKeyExpr
            };
            _proto._defaultKeyExpr = function(fileItem) {
                if (2 === arguments.length) {
                    fileItem.__KEY__ = arguments[1];
                    return
                }
                return Object.prototype.hasOwnProperty.call(fileItem, "__KEY__") ? fileItem.__KEY__ : null
            };
            _proto._getNameExpr = function(options) {
                return options.nameExpr || "name"
            };
            _proto._getIsDirExpr = function(options) {
                return options.isDirectoryExpr || "isDirectory"
            };
            _proto._getSizeExpr = function(options) {
                return options.sizeExpr || "size"
            };
            _proto._getDateModifiedExpr = function(options) {
                return options.dateModifiedExpr || "dateModified"
            };
            _proto._executeActionAsDeferred = function(action, keepResult) {
                var deferred = new _deferred.Deferred;
                try {
                    var result = action();
                    if ((0, _type.isPromise)(result)) {
                        (0, _deferred.fromPromise)(result).done(function(userResult) {
                            return deferred.resolve(keepResult && userResult || void 0)
                        }).fail(function(error) {
                            return deferred.reject(error)
                        })
                    } else {
                        deferred.resolve(keepResult && result || void 0)
                    }
                } catch (error) {
                    return deferred.reject(error)
                }
                return deferred.promise()
            };
            return FileSystemProviderBase
        }();
        var _default = FileSystemProviderBase;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/text_box/texteditor_button_collection/button.js ***!
      \*************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../../core/renderer */ 2));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var TextEditorButton = function() {
            function TextEditorButton(name, editor, options) {
                this.instance = null;
                this.$container = null;
                this.$placeMarker = null;
                this.editor = editor;
                this.name = name;
                this.options = options || {}
            }
            var _proto = TextEditorButton.prototype;
            _proto._addPlaceMarker = function($container) {
                this.$placeMarker = (0, _renderer.default)("<div>").appendTo($container)
            };
            _proto._addToContainer = function($element) {
                var $placeMarker = this.$placeMarker,
                    $container = this.$container;
                $placeMarker ? $placeMarker.replaceWith($element) : $element.appendTo($container)
            };
            _proto._attachEvents = function() {
                throw "Not implemented"
            };
            _proto._create = function() {
                throw "Not implemented"
            };
            _proto._isRendered = function() {
                return !!this.instance
            };
            _proto._isVisible = function() {
                var editor = this.editor,
                    options = this.options;
                return options.visible || !editor.option("readOnly")
            };
            _proto._isDisabled = function() {
                throw "Not implemented"
            };
            _proto._shouldRender = function() {
                return this._isVisible() && !this._isRendered()
            };
            _proto.dispose = function() {
                var instance = this.instance,
                    $placeMarker = this.$placeMarker;
                if (instance) {
                    instance.dispose ? instance.dispose() : instance.remove();
                    this.instance = null
                }
                $placeMarker && $placeMarker.remove()
            };
            _proto.render = function() {
                var $container = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.$container;
                this.$container = $container;
                if (this._isVisible()) {
                    var _this$_create = this._create(),
                        instance = _this$_create.instance,
                        $element = _this$_create.$element;
                    this.instance = instance;
                    this._attachEvents(instance, $element)
                } else {
                    this._addPlaceMarker($container)
                }
            };
            _proto.update = function() {
                if (this._shouldRender()) {
                    this.render()
                }
                return !!this.instance
            };
            return TextEditorButton
        }();
        exports.default = TextEditorButton;
        module.exports = exports.default
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/drop_down_editor/utils.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getSizeValue = exports.getElementWidth = void 0;
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var getElementWidth = function($element) {
            if ((0, _window.hasWindow)()) {
                return $element.outerWidth()
            }
        };
        exports.getElementWidth = getElementWidth;
        var getSizeValue = function(size) {
            if (null === size) {
                size = void 0
            }
            if ("function" === typeof size) {
                size = size()
            }
            return size
        };
        exports.getSizeValue = getSizeValue
    },
    /*!************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/collection/ui.collection_widget.live_update.js ***!
      \************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _uiCollection_widget = _interopRequireDefault(__webpack_require__( /*! ./ui.collection_widget.edit */ 54));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _array_utils = __webpack_require__( /*! ../../data/array_utils */ 93);
        var _utils = _interopRequireDefault(__webpack_require__( /*! ../../data/utils */ 41));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _array_compare = __webpack_require__( /*! ../../core/utils/array_compare */ 234);
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }
        var PRIVATE_KEY_FIELD = "__dx_key__";
        var _default = _uiCollection_widget.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    repaintChangesOnly: false
                })
            },
            ctor: function() {
                var _this = this;
                this.callBase.apply(this, arguments);
                this._customizeStoreLoadOptions = function(e) {
                    var dataSource = _this._dataSource;
                    if (dataSource && !dataSource.isLoaded()) {
                        _this._correctionIndex = 0
                    }
                    if (_this._correctionIndex && e.storeLoadOptions) {
                        e.storeLoadOptions.skip += _this._correctionIndex
                    }
                }, this._dataSource && this._dataSource.on("customizeStoreLoadOptions", this._customizeStoreLoadOptions)
            },
            reload: function() {
                this._correctionIndex = 0
            },
            _init: function() {
                this.callBase();
                this._refreshItemsCache();
                this._correctionIndex = 0
            },
            _findItemElementByKey: function(key) {
                var _this2 = this;
                var result = (0, _renderer.default)();
                var keyExpr = this.key();
                this.itemElements().each(function(_, item) {
                    var $item = (0, _renderer.default)(item);
                    var itemData = _this2._getItemData($item);
                    if (keyExpr ? _utils.default.keysEqual(keyExpr, _this2.keyOf(itemData), key) : _this2._isItemEquals(itemData, key)) {
                        result = $item;
                        return false
                    }
                });
                return result
            },
            _dataSourceChangedHandler: function(newItems, e) {
                if (null !== e && void 0 !== e && e.changes) {
                    this._modifyByChanges(e.changes)
                } else {
                    this.callBase(newItems, e);
                    this._refreshItemsCache()
                }
            },
            _isItemEquals: function(item1, item2) {
                if (item1 && item1[PRIVATE_KEY_FIELD]) {
                    item1 = item1.data
                }
                try {
                    return JSON.stringify(item1) === JSON.stringify(item2)
                } catch (e) {
                    return item1 === item2
                }
            },
            _isItemStrictEquals: function(item1, item2) {
                return this._isItemEquals(item1, item2)
            },
            _partialRefresh: function() {
                var _this3 = this;
                if (this.option("repaintChangesOnly")) {
                    var keyOf = function(data) {
                        if (data && void 0 !== data[PRIVATE_KEY_FIELD]) {
                            return data[PRIVATE_KEY_FIELD]
                        }
                        return _this3.keyOf(data)
                    };
                    var result = (0, _array_compare.findChanges)(this._itemsCache, this._editStrategy.itemsGetter(), keyOf, this._isItemStrictEquals.bind(this));
                    if (result && this._itemsCache.length) {
                        this._modifyByChanges(result, true);
                        this._renderEmptyMessage();
                        return true
                    } else {
                        this._refreshItemsCache()
                    }
                }
                return false
            },
            _refreshItemsCache: function() {
                if (this.option("repaintChangesOnly")) {
                    var items = this._editStrategy.itemsGetter();
                    try {
                        this._itemsCache = (0, _extend.extend)(true, [], items);
                        if (!this.key()) {
                            this._itemsCache = this._itemsCache.map(function(itemCache, index) {
                                var _ref;
                                return _ref = {}, _defineProperty(_ref, PRIVATE_KEY_FIELD, items[index]), _defineProperty(_ref, "data", itemCache), _ref
                            })
                        }
                    } catch (e) {
                        this._itemsCache = (0, _extend.extend)([], items)
                    }
                }
            },
            _dispose: function() {
                this._dataSource && this._dataSource.off("customizeStoreLoadOptions", this._customizeStoreLoadOptions);
                this.callBase()
            },
            _updateByChange: function(keyInfo, items, change, isPartialRefresh) {
                var _this4 = this;
                if (isPartialRefresh) {
                    this._renderItem(change.index, change.data, null, this._findItemElementByKey(change.key))
                } else {
                    var changedItem = items[(0, _array_utils.indexByKey)(keyInfo, items, change.key)];
                    if (changedItem) {
                        (0, _array_utils.update)(keyInfo, items, change.key, change.data).done(function() {
                            _this4._renderItem(items.indexOf(changedItem), changedItem, null, _this4._findItemElementByKey(change.key))
                        })
                    }
                }
            },
            _insertByChange: function(keyInfo, items, change, isPartialRefresh) {
                var _this5 = this;
                (0, _deferred.when)(isPartialRefresh || (0, _array_utils.insert)(keyInfo, items, change.data, change.index)).done(function() {
                    var _change$index;
                    _this5._beforeItemElementInserted(change);
                    _this5._renderItem(null !== (_change$index = change.index) && void 0 !== _change$index ? _change$index : items.length, change.data);
                    _this5._afterItemElementInserted();
                    _this5._correctionIndex++
                })
            },
            _updateSelectionAfterRemoveByChange: function(removeIndex) {
                var selectedIndex = this.option("selectedIndex");
                if (selectedIndex > removeIndex) {
                    this.option("selectedIndex", selectedIndex - 1)
                } else {
                    if (selectedIndex === removeIndex && 1 === this.option("selectedItems").length) {
                        this.option("selectedItems", [])
                    } else {
                        this._normalizeSelectedItems()
                    }
                }
            },
            _beforeItemElementInserted: function(change) {
                var selectedIndex = this.option("selectedIndex");
                if (change.index <= selectedIndex) {
                    this.option("selectedIndex", selectedIndex + 1)
                }
            },
            _afterItemElementInserted: _common.noop,
            _removeByChange: function(keyInfo, items, change, isPartialRefresh) {
                var _this6 = this;
                var index = isPartialRefresh ? change.index : (0, _array_utils.indexByKey)(keyInfo, items, change.key);
                var removedItem = isPartialRefresh ? change.oldItem : items[index];
                if (removedItem) {
                    var $removedItemElement = this._findItemElementByKey(change.key);
                    var deletedActionArgs = this._extendActionArgs($removedItemElement);
                    this._waitDeletingPrepare($removedItemElement).done(function() {
                        if (isPartialRefresh) {
                            _this6._updateIndicesAfterIndex(index - 1);
                            _this6._afterItemElementDeleted($removedItemElement, deletedActionArgs);
                            _this6._updateSelectionAfterRemoveByChange(index)
                        } else {
                            _this6._deleteItemElementByIndex(index);
                            _this6._afterItemElementDeleted($removedItemElement, deletedActionArgs)
                        }
                    });
                    this._correctionIndex--
                }
            },
            _modifyByChanges: function(changes, isPartialRefresh) {
                var _this7 = this;
                var items = this._editStrategy.itemsGetter();
                var keyInfo = {
                    key: this.key.bind(this),
                    keyOf: this.keyOf.bind(this)
                };
                var dataSource = this._dataSource;
                var paginate = dataSource && dataSource.paginate();
                var group = dataSource && dataSource.group();
                if (paginate || group) {
                    changes = changes.filter(function(item) {
                        return "insert" !== item.type || void 0 !== item.index
                    })
                }
                changes.forEach(function(change) {
                    return _this7["_".concat(change.type, "ByChange")](keyInfo, items, change, isPartialRefresh)
                });
                this._renderedItemsCount = items.length;
                this._refreshItemsCache();
                this._fireContentReadyAction()
            },
            _appendItemToContainer: function($container, $itemFrame, index) {
                var nextSiblingElement = $container.children(this._itemSelector()).get(index);
                _dom_adapter.default.insertElement($container.get(0), $itemFrame.get(0), nextSiblingElement)
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "items":
                        var isItemsUpdated = this._partialRefresh(args.value);
                        if (!isItemsUpdated) {
                            this.callBase(args)
                        }
                        break;
                    case "dataSource":
                        if (!this.option("repaintChangesOnly") || !args.value) {
                            this.option("items", [])
                        }
                        this.callBase(args);
                        break;
                    case "repaintChangesOnly":
                        break;
                    default:
                        this.callBase(args)
                }
            }
        });
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/draggable.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _string = __webpack_require__( /*! ../core/utils/string */ 43);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _translator = __webpack_require__( /*! ../animation/translator */ 28);
        var _animator = _interopRequireDefault(__webpack_require__( /*! ./scroll_view/animator */ 350));
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../core/utils/browser */ 23));
        var _inflector = __webpack_require__( /*! ../core/utils/inflector */ 39);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _dom_component = _interopRequireDefault(__webpack_require__( /*! ../core/dom_component */ 67));
        var _element = __webpack_require__( /*! ../core/element */ 18);
        var _index = __webpack_require__( /*! ../events/utils/index */ 8);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../events/pointer */ 24));
        var _drag = __webpack_require__( /*! ../events/drag */ 76);
        var _position = _interopRequireDefault(__webpack_require__( /*! ../animation/position */ 81));
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _view_port = __webpack_require__( /*! ../core/utils/view_port */ 80);
        var _empty_template = __webpack_require__( /*! ../core/templates/empty_template */ 91);
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);
        var _position2 = __webpack_require__( /*! ../core/utils/position */ 22);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }
        var window = (0, _window.getWindow)();
        var DRAGGABLE = "dxDraggable";
        var DRAGSTART_EVENT_NAME = (0, _index.addNamespace)(_drag.start, DRAGGABLE);
        var DRAG_EVENT_NAME = (0, _index.addNamespace)(_drag.move, DRAGGABLE);
        var DRAGEND_EVENT_NAME = (0, _index.addNamespace)(_drag.end, DRAGGABLE);
        var DRAG_ENTER_EVENT_NAME = (0, _index.addNamespace)(_drag.enter, DRAGGABLE);
        var DRAGEND_LEAVE_EVENT_NAME = (0, _index.addNamespace)(_drag.leave, DRAGGABLE);
        var POINTERDOWN_EVENT_NAME = (0, _index.addNamespace)(_pointer.default.down, DRAGGABLE);
        var CLONE_CLASS = "clone";
        var targetDraggable;
        var sourceDraggable;
        var ANONYMOUS_TEMPLATE_NAME = "content";
        var getMousePosition = function(event) {
            return {
                x: event.pageX - (0, _renderer.default)(window).scrollLeft(),
                y: event.pageY - (0, _renderer.default)(window).scrollTop()
            }
        };
        var GESTURE_COVER_CLASS = "dx-gesture-cover";
        var ScrollHelper = function() {
            function ScrollHelper(orientation, component) {
                this._preventScroll = true;
                this._component = component;
                if ("vertical" === orientation) {
                    this._scrollValue = "scrollTop";
                    this._overFlowAttr = "overflowY";
                    this._sizeAttr = "height";
                    this._scrollSizeProp = "scrollHeight";
                    this._clientSizeProp = "clientHeight";
                    this._limitProps = {
                        start: "top",
                        end: "bottom"
                    }
                } else {
                    this._scrollValue = "scrollLeft";
                    this._overFlowAttr = "overflowX";
                    this._sizeAttr = "width";
                    this._scrollSizeProp = "scrollWidth";
                    this._clientSizeProp = "clientWidth";
                    this._limitProps = {
                        start: "left",
                        end: "right"
                    }
                }
            }
            var _proto = ScrollHelper.prototype;
            _proto.updateScrollable = function(elements, mousePosition) {
                var that = this;
                if (!elements.some(function(element) {
                        return that._trySetScrollable(element, mousePosition)
                    })) {
                    that._$scrollableAtPointer = null;
                    that._scrollSpeed = 0
                }
            };
            _proto.isScrolling = function() {
                return !!this._scrollSpeed
            };
            _proto.isScrollable = function($element) {
                var that = this;
                return ("auto" === $element.css(that._overFlowAttr) || $element.hasClass("dx-scrollable-container")) && $element.prop(that._scrollSizeProp) > $element[that._sizeAttr]()
            };
            _proto._trySetScrollable = function(element, mousePosition) {
                var that = this;
                var $element = (0, _renderer.default)(element);
                var distanceToBorders;
                var sensitivity = that._component.option("scrollSensitivity");
                var isScrollable = that.isScrollable($element);
                if (isScrollable) {
                    distanceToBorders = that._calculateDistanceToBorders($element, mousePosition);
                    if (sensitivity > distanceToBorders[that._limitProps.start]) {
                        if (!that._preventScroll) {
                            that._scrollSpeed = -that._calculateScrollSpeed(distanceToBorders[that._limitProps.start]);
                            that._$scrollableAtPointer = $element
                        }
                    } else {
                        if (sensitivity > distanceToBorders[that._limitProps.end]) {
                            if (!that._preventScroll) {
                                that._scrollSpeed = that._calculateScrollSpeed(distanceToBorders[that._limitProps.end]);
                                that._$scrollableAtPointer = $element
                            }
                        } else {
                            isScrollable = false;
                            that._preventScroll = false
                        }
                    }
                }
                return isScrollable
            };
            _proto._calculateDistanceToBorders = function($area, mousePosition) {
                var area = $area.get(0);
                var areaBoundingRect;
                if (area) {
                    areaBoundingRect = (0, _position2.getBoundingRect)(area);
                    return {
                        left: mousePosition.x - areaBoundingRect.left,
                        top: mousePosition.y - areaBoundingRect.top,
                        right: areaBoundingRect.right - mousePosition.x,
                        bottom: areaBoundingRect.bottom - mousePosition.y
                    }
                } else {
                    return {}
                }
            };
            _proto._calculateScrollSpeed = function(distance) {
                var component = this._component;
                var sensitivity = component.option("scrollSensitivity");
                var maxSpeed = component.option("scrollSpeed");
                return Math.ceil(Math.pow((sensitivity - distance) / sensitivity, 2) * maxSpeed)
            };
            _proto.scrollByStep = function() {
                var that = this;
                if (that._$scrollableAtPointer && that._scrollSpeed) {
                    if (that._$scrollableAtPointer.hasClass("dx-scrollable-container")) {
                        var $scrollable = that._$scrollableAtPointer.closest(".dx-scrollable");
                        var scrollableInstance = $scrollable.data("dxScrollable") || $scrollable.data("dxScrollView");
                        if (scrollableInstance) {
                            var nextScrollPosition = scrollableInstance.scrollOffset()[that._limitProps.start] + that._scrollSpeed;
                            scrollableInstance.scrollTo(_defineProperty({}, that._limitProps.start, nextScrollPosition))
                        }
                    } else {
                        var _nextScrollPosition = that._$scrollableAtPointer[that._scrollValue]() + that._scrollSpeed;
                        that._$scrollableAtPointer[that._scrollValue](_nextScrollPosition)
                    }
                    var dragMoveArgs = that._component._dragMoveArgs;
                    if (dragMoveArgs) {
                        that._component._dragMoveHandler(dragMoveArgs)
                    }
                }
            };
            _proto.reset = function() {
                this._$scrollableAtPointer = null;
                this._scrollSpeed = 0;
                this._preventScroll = true
            };
            _proto.isOutsideScrollable = function($scrollable, event) {
                if (!$scrollable) {
                    return false
                }
                var scrollableSize = (0, _position2.getBoundingRect)($scrollable.get(0));
                var start = scrollableSize[this._limitProps.start];
                var size = scrollableSize[this._sizeAttr];
                var mousePosition = getMousePosition(event);
                var location = "width" === this._sizeAttr ? mousePosition.x : mousePosition.y;
                return location < start || location > start + size
            };
            return ScrollHelper
        }();
        var ScrollAnimator = _animator.default.inherit({
            ctor: function(strategy) {
                this.callBase();
                this._strategy = strategy
            },
            _step: function() {
                var horizontalScrollHelper = this._strategy._horizontalScrollHelper;
                var verticalScrollHelper = this._strategy._verticalScrollHelper;
                horizontalScrollHelper && horizontalScrollHelper.scrollByStep();
                verticalScrollHelper && verticalScrollHelper.scrollByStep()
            }
        });
        var Draggable = _dom_component.default.inherit({
            reset: _common.noop,
            dragMove: _common.noop,
            dragEnter: _common.noop,
            dragLeave: _common.noop,
            dragEnd: function(sourceEvent) {
                var sourceDraggable = this._getSourceDraggable();
                sourceDraggable._fireRemoveEvent(sourceEvent);
                return (new _deferred.Deferred).resolve()
            },
            _fireRemoveEvent: _common.noop,
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    onDragStart: null,
                    onDragMove: null,
                    onDragEnd: null,
                    onDragEnter: null,
                    onDragLeave: null,
                    onDrop: null,
                    immediate: true,
                    dragDirection: "both",
                    boundary: void 0,
                    boundOffset: 0,
                    allowMoveByClick: false,
                    itemData: null,
                    container: void 0,
                    dragTemplate: void 0,
                    contentTemplate: "content",
                    handle: "",
                    filter: "",
                    clone: false,
                    autoScroll: true,
                    scrollSpeed: 30,
                    scrollSensitivity: 60,
                    group: void 0,
                    data: void 0
                })
            },
            _setOptionsByReference: function() {
                this.callBase.apply(this, arguments);
                (0, _extend.extend)(this._optionsByReference, {
                    component: true,
                    group: true,
                    itemData: true,
                    data: true
                })
            },
            _init: function() {
                this.callBase();
                this._attachEventHandlers();
                this._scrollAnimator = new ScrollAnimator(this);
                this._horizontalScrollHelper = new ScrollHelper("horizontal", this);
                this._verticalScrollHelper = new ScrollHelper("vertical", this)
            },
            _normalizeCursorOffset: function(offset) {
                if ((0, _type.isObject)(offset)) {
                    offset = {
                        h: offset.x,
                        v: offset.y
                    }
                }
                offset = (0, _common.splitPair)(offset).map(function(value) {
                    return parseFloat(value)
                });
                return {
                    left: offset[0],
                    top: 1 === offset.length ? offset[0] : offset[1]
                }
            },
            _getNormalizedCursorOffset: function(offset, options) {
                if ((0, _type.isFunction)(offset)) {
                    offset = offset.call(this, options)
                }
                return this._normalizeCursorOffset(offset)
            },
            _calculateElementOffset: function(options) {
                var elementOffset;
                var dragElementOffset;
                var event = options.event;
                var $element = (0, _renderer.default)(options.itemElement);
                var $dragElement = (0, _renderer.default)(options.dragElement);
                var isCloned = this._dragElementIsCloned();
                var cursorOffset = this.option("cursorOffset");
                var normalizedCursorOffset = {
                    left: 0,
                    top: 0
                };
                var currentLocate = this._initialLocate = (0, _translator.locate)($dragElement);
                if (isCloned || options.initialOffset || cursorOffset) {
                    elementOffset = options.initialOffset || $element.offset();
                    if (cursorOffset) {
                        normalizedCursorOffset = this._getNormalizedCursorOffset(cursorOffset, options);
                        if (isFinite(normalizedCursorOffset.left)) {
                            elementOffset.left = event.pageX
                        }
                        if (isFinite(normalizedCursorOffset.top)) {
                            elementOffset.top = event.pageY
                        }
                    }
                    dragElementOffset = $dragElement.offset();
                    elementOffset.top -= dragElementOffset.top + (normalizedCursorOffset.top || 0) - currentLocate.top;
                    elementOffset.left -= dragElementOffset.left + (normalizedCursorOffset.left || 0) - currentLocate.left
                }
                return elementOffset
            },
            _initPosition: function(options) {
                var $dragElement = (0, _renderer.default)(options.dragElement);
                var elementOffset = this._calculateElementOffset(options);
                if (elementOffset) {
                    this._move(elementOffset, $dragElement)
                }
                this._startPosition = (0, _translator.locate)($dragElement)
            },
            _startAnimator: function() {
                if (!this._scrollAnimator.inProgress()) {
                    this._scrollAnimator.start()
                }
            },
            _stopAnimator: function() {
                this._scrollAnimator.stop()
            },
            _addWidgetPrefix: function(className) {
                var componentName = this.NAME;
                return (0, _inflector.dasherize)(componentName) + (className ? "-" + className : "")
            },
            _getItemsSelector: function() {
                return this.option("filter") || ""
            },
            _$content: function() {
                var $element = this.$element();
                var $wrapper = $element.children(".dx-template-wrapper");
                return $wrapper.length ? $wrapper : $element
            },
            _attachEventHandlers: function() {
                var _this = this;
                if (this.option("disabled")) {
                    return
                }
                var $element = this._$content();
                var itemsSelector = this._getItemsSelector();
                var allowMoveByClick = this.option("allowMoveByClick");
                var data = {
                    direction: this.option("dragDirection"),
                    immediate: this.option("immediate"),
                    checkDropTarget: function($target, event) {
                        var targetGroup = _this.option("group");
                        var sourceGroup = _this._getSourceDraggable().option("group");
                        var $scrollable = _this._getScrollable($target);
                        if (_this._verticalScrollHelper.isOutsideScrollable($scrollable, event) || _this._horizontalScrollHelper.isOutsideScrollable($scrollable, event)) {
                            return false
                        }
                        return sourceGroup && sourceGroup === targetGroup
                    }
                };
                if (allowMoveByClick) {
                    $element = this._getArea();
                    _events_engine.default.on($element, POINTERDOWN_EVENT_NAME, data, this._pointerDownHandler.bind(this))
                }
                if (">" === itemsSelector[0]) {
                    itemsSelector = itemsSelector.slice(1)
                }
                _events_engine.default.on($element, DRAGSTART_EVENT_NAME, itemsSelector, data, this._dragStartHandler.bind(this));
                _events_engine.default.on($element, DRAG_EVENT_NAME, data, this._dragMoveHandler.bind(this));
                _events_engine.default.on($element, DRAGEND_EVENT_NAME, data, this._dragEndHandler.bind(this));
                _events_engine.default.on($element, DRAG_ENTER_EVENT_NAME, data, this._dragEnterHandler.bind(this));
                _events_engine.default.on($element, DRAGEND_LEAVE_EVENT_NAME, data, this._dragLeaveHandler.bind(this))
            },
            _dragElementIsCloned: function() {
                return this._$dragElement && this._$dragElement.hasClass(this._addWidgetPrefix(CLONE_CLASS))
            },
            _getDragTemplateArgs: function($element, $container) {
                return {
                    container: (0, _element.getPublicElement)($container),
                    model: {
                        itemData: this.option("itemData"),
                        itemElement: (0, _element.getPublicElement)($element)
                    }
                }
            },
            _createDragElement: function($element) {
                var result = $element;
                var clone = this.option("clone");
                var $container = this._getContainer();
                var template = this.option("dragTemplate");
                if (template) {
                    template = this._getTemplate(template);
                    result = (0, _renderer.default)("<div>").appendTo($container);
                    template.render(this._getDragTemplateArgs($element, result))
                } else {
                    if (clone) {
                        result = (0, _renderer.default)("<div>").appendTo($container);
                        $element.clone().css({
                            width: $element.css("width"),
                            height: $element.css("height")
                        }).appendTo(result)
                    }
                }
                return result.toggleClass(this._addWidgetPrefix(CLONE_CLASS), result.get(0) !== $element.get(0)).toggleClass("dx-rtl", this.option("rtlEnabled"))
            },
            _resetDragElement: function() {
                if (this._dragElementIsCloned()) {
                    this._$dragElement.remove()
                } else {
                    this._toggleDraggingClass(false)
                }
                this._$dragElement = null
            },
            _resetSourceElement: function() {
                this._toggleDragSourceClass(false);
                this._$sourceElement = null
            },
            _detachEventHandlers: function() {
                _events_engine.default.off(this._$content(), "." + DRAGGABLE);
                _events_engine.default.off(this._getArea(), "." + DRAGGABLE)
            },
            _move: function(position, $element) {
                (0, _translator.move)($element || this._$dragElement, position)
            },
            _getDraggableElement: function(e) {
                var $sourceElement = this._getSourceElement();
                if ($sourceElement) {
                    return $sourceElement
                }
                var allowMoveByClick = this.option("allowMoveByClick");
                if (allowMoveByClick) {
                    return this.$element()
                }
                var $target = (0, _renderer.default)(e && e.target);
                var itemsSelector = this._getItemsSelector();
                if (">" === itemsSelector[0]) {
                    var $items = this._$content().find(itemsSelector);
                    if (!$items.is($target)) {
                        $target = $target.closest($items)
                    }
                }
                return $target
            },
            _getSourceElement: function() {
                var draggable = this._getSourceDraggable();
                return draggable._$sourceElement
            },
            _pointerDownHandler: function(e) {
                if ((0, _index.needSkipEvent)(e)) {
                    return
                }
                var position = {};
                var $element = this.$element();
                var dragDirection = this.option("dragDirection");
                if ("horizontal" === dragDirection || "both" === dragDirection) {
                    position.left = e.pageX - $element.offset().left + (0, _translator.locate)($element).left - $element.width() / 2
                }
                if ("vertical" === dragDirection || "both" === dragDirection) {
                    position.top = e.pageY - $element.offset().top + (0, _translator.locate)($element).top - $element.height() / 2
                }
                this._move(position, $element);
                this._getAction("onDragMove")(this._getEventArgs(e))
            },
            _isValidElement: function(event, $element) {
                var handle = this.option("handle");
                var $target = (0, _renderer.default)(event.originalEvent && event.originalEvent.target);
                if (handle && !$target.closest(handle).length) {
                    return false
                }
                if (!$element.length) {
                    return false
                }
                return !$element.is(".dx-state-disabled, .dx-state-disabled *")
            },
            _dragStartHandler: function(e) {
                var $element = this._getDraggableElement(e);
                if (this._$sourceElement) {
                    return
                }
                if (!this._isValidElement(e, $element)) {
                    e.cancel = true;
                    return
                }
                var dragStartArgs = this._getDragStartArgs(e, $element);
                this._getAction("onDragStart")(dragStartArgs);
                if (dragStartArgs.cancel) {
                    e.cancel = true;
                    return
                }
                this.option("itemData", dragStartArgs.itemData);
                this._setSourceDraggable();
                this._$sourceElement = $element;
                var initialOffset = $element.offset();
                var $dragElement = this._$dragElement = this._createDragElement($element);
                this._toggleDraggingClass(true);
                this._toggleDragSourceClass(true);
                this._setGestureCoverCursor($dragElement.children());
                var isFixedPosition = "fixed" === $dragElement.css("position");
                this._initPosition((0, _extend.extend)({}, dragStartArgs, {
                    dragElement: $dragElement.get(0),
                    initialOffset: isFixedPosition && initialOffset
                }));
                var $area = this._getArea();
                var areaOffset = this._getAreaOffset($area);
                var boundOffset = this._getBoundOffset();
                var areaWidth = $area.outerWidth();
                var areaHeight = $area.outerHeight();
                var elementWidth = $dragElement.width();
                var elementHeight = $dragElement.height();
                var startOffset = {
                    left: $dragElement.offset().left - areaOffset.left,
                    top: $dragElement.offset().top - areaOffset.top
                };
                if ($area.length) {
                    e.maxLeftOffset = startOffset.left - boundOffset.left;
                    e.maxRightOffset = areaWidth - startOffset.left - elementWidth - boundOffset.right;
                    e.maxTopOffset = startOffset.top - boundOffset.top;
                    e.maxBottomOffset = areaHeight - startOffset.top - elementHeight - boundOffset.bottom
                }
                if (this.option("autoScroll")) {
                    this._startAnimator()
                }
            },
            _getAreaOffset: function($area) {
                var offset = $area && _position.default.offset($area);
                return offset ? offset : {
                    left: 0,
                    top: 0
                }
            },
            _toggleDraggingClass: function(value) {
                this._$dragElement && this._$dragElement.toggleClass(this._addWidgetPrefix("dragging"), value)
            },
            _toggleDragSourceClass: function(value, $element) {
                var $sourceElement = $element || this._$sourceElement;
                $sourceElement && $sourceElement.toggleClass(this._addWidgetPrefix("source"), value)
            },
            _setGestureCoverCursor: function($element) {
                (0, _renderer.default)(".".concat(GESTURE_COVER_CLASS)).css("cursor", $element.css("cursor"))
            },
            _getBoundOffset: function() {
                var boundOffset = this.option("boundOffset");
                if ((0, _type.isFunction)(boundOffset)) {
                    boundOffset = boundOffset.call(this)
                }
                return (0, _string.quadToObject)(boundOffset)
            },
            _getArea: function() {
                var area = this.option("boundary");
                if ((0, _type.isFunction)(area)) {
                    area = area.call(this)
                }
                return (0, _renderer.default)(area)
            },
            _getContainer: function() {
                var container = this.option("container");
                if (void 0 === container) {
                    container = (0, _view_port.value)()
                }
                return (0, _renderer.default)(container)
            },
            _dragMoveHandler: function(e, scrollBy) {
                this._dragMoveArgs = e;
                if (!this._$dragElement) {
                    e.cancel = true;
                    return
                }
                var offset = e.offset;
                var startPosition = this._startPosition;
                this._move({
                    left: startPosition.left + offset.x,
                    top: startPosition.top + offset.y
                });
                if (!scrollBy) {
                    this._updateScrollable(e)
                }
                var eventArgs = this._getEventArgs(e);
                this._getAction("onDragMove")(eventArgs);
                if (true === eventArgs.cancel) {
                    return
                }
                var targetDraggable = this._getTargetDraggable();
                targetDraggable.dragMove(e, scrollBy)
            },
            _updateScrollable: function(e) {
                var that = this;
                if (that.option("autoScroll")) {
                    var mousePosition = getMousePosition(e);
                    var allObjects = that.getElementsFromPoint(mousePosition);
                    that._verticalScrollHelper.updateScrollable(allObjects, mousePosition);
                    that._horizontalScrollHelper.updateScrollable(allObjects, mousePosition)
                }
            },
            getElementsFromPoint: function(position, dragElement) {
                var ownerDocument = (dragElement || this._$dragElement.get(0)).ownerDocument;
                if (_browser.default.msie) {
                    var msElements = ownerDocument.msElementsFromPoint(position.x, position.y);
                    if (msElements) {
                        return Array.prototype.slice.call(msElements)
                    }
                    return []
                }
                return ownerDocument.elementsFromPoint(position.x, position.y)
            },
            _getScrollable: function($element) {
                var _this2 = this;
                var $scrollable;
                $element.parents().toArray().some(function(parent) {
                    var $parent = (0, _renderer.default)(parent);
                    if (_this2._horizontalScrollHelper.isScrollable($parent) || _this2._verticalScrollHelper.isScrollable($parent)) {
                        $scrollable = $parent;
                        return true
                    }
                });
                return $scrollable
            },
            _defaultActionArgs: function() {
                var args = this.callBase.apply(this, arguments);
                var component = this.option("component");
                if (component) {
                    args.component = component;
                    args.element = component.element()
                }
                return args
            },
            _getEventArgs: function(e) {
                var sourceDraggable = this._getSourceDraggable();
                var targetDraggable = this._getTargetDraggable();
                return {
                    event: e,
                    itemData: sourceDraggable.option("itemData"),
                    itemElement: (0, _element.getPublicElement)(sourceDraggable._$sourceElement),
                    fromComponent: sourceDraggable.option("component") || sourceDraggable,
                    toComponent: targetDraggable.option("component") || targetDraggable,
                    fromData: sourceDraggable.option("data"),
                    toData: targetDraggable.option("data")
                }
            },
            _getDragStartArgs: function(e, $itemElement) {
                var args = this._getEventArgs(e);
                return {
                    event: args.event,
                    itemData: args.itemData,
                    itemElement: $itemElement,
                    fromData: args.fromData
                }
            },
            _revertItemToInitialPosition: function() {
                !this._dragElementIsCloned() && this._move(this._initialLocate, this._$sourceElement)
            },
            _dragEndHandler: function(e) {
                var _this3 = this;
                var d = new _deferred.Deferred;
                var dragEndEventArgs = this._getEventArgs(e);
                var dropEventArgs = this._getEventArgs(e);
                var targetDraggable = this._getTargetDraggable();
                var needRevertPosition = true;
                try {
                    this._getAction("onDragEnd")(dragEndEventArgs)
                } finally {
                    (0, _deferred.when)((0, _deferred.fromPromise)(dragEndEventArgs.cancel)).done(function(cancel) {
                        if (!cancel) {
                            if (targetDraggable !== _this3) {
                                targetDraggable._getAction("onDrop")(dropEventArgs)
                            }
                            if (!dropEventArgs.cancel) {
                                needRevertPosition = false;
                                (0, _deferred.when)((0, _deferred.fromPromise)(targetDraggable.dragEnd(dragEndEventArgs))).always(d.resolve);
                                return
                            }
                        }
                        d.resolve()
                    }).fail(d.resolve);
                    d.done(function() {
                        if (needRevertPosition) {
                            _this3._revertItemToInitialPosition()
                        }
                        _this3.reset();
                        targetDraggable.reset();
                        _this3._stopAnimator();
                        _this3._horizontalScrollHelper.reset();
                        _this3._verticalScrollHelper.reset();
                        _this3._resetDragElement();
                        _this3._resetSourceElement();
                        _this3._resetTargetDraggable();
                        _this3._resetSourceDraggable()
                    })
                }
            },
            _isTargetOverAnotherDraggable: function(e) {
                var _this4 = this;
                var sourceDraggable = this._getSourceDraggable();
                if (this === sourceDraggable) {
                    return false
                }
                var $dragElement = sourceDraggable._$dragElement;
                var $sourceDraggableElement = sourceDraggable.$element();
                var $targetDraggableElement = this.$element();
                var mousePosition = getMousePosition(e);
                var elements = this.getElementsFromPoint(mousePosition, e.target);
                var firstWidgetElement = elements.filter(function(element) {
                    var $element = (0, _renderer.default)(element);
                    if ($element.hasClass(_this4._addWidgetPrefix())) {
                        return !$element.closest($dragElement).length
                    }
                })[0];
                var $sourceElement = this._getSourceElement();
                var isTargetOverItself = firstWidgetElement === $sourceDraggableElement.get(0);
                var isTargetOverNestedDraggable = (0, _renderer.default)(firstWidgetElement).closest($sourceElement).length;
                return !firstWidgetElement || firstWidgetElement === $targetDraggableElement.get(0) && !isTargetOverItself && !isTargetOverNestedDraggable
            },
            _dragEnterHandler: function(e) {
                this._fireDragEnterEvent(e);
                if (this._isTargetOverAnotherDraggable(e)) {
                    this._setTargetDraggable()
                }
                var sourceDraggable = this._getSourceDraggable();
                sourceDraggable.dragEnter(e)
            },
            _dragLeaveHandler: function(e) {
                this._fireDragLeaveEvent(e);
                this._resetTargetDraggable();
                if (this !== this._getSourceDraggable()) {
                    this.reset()
                }
                var sourceDraggable = this._getSourceDraggable();
                sourceDraggable.dragLeave(e)
            },
            _getAction: function(name) {
                return this["_" + name + "Action"] || this._createActionByOption(name)
            },
            _getAnonymousTemplateName: function() {
                return ANONYMOUS_TEMPLATE_NAME
            },
            _initTemplates: function() {
                if (!this.option("contentTemplate")) {
                    return
                }
                this._templateManager.addDefaultTemplates({
                    content: new _empty_template.EmptyTemplate
                });
                this.callBase.apply(this, arguments)
            },
            _render: function() {
                this.callBase();
                this.$element().addClass(this._addWidgetPrefix());
                var transclude = this._templateManager.anonymousTemplateName === this.option("contentTemplate");
                var template = this._getTemplateByOption("contentTemplate");
                if (template) {
                    (0, _renderer.default)(template.render({
                        container: this.element(),
                        transclude: transclude
                    }))
                }
            },
            _optionChanged: function(args) {
                var name = args.name;
                switch (name) {
                    case "onDragStart":
                    case "onDragMove":
                    case "onDragEnd":
                    case "onDrop":
                    case "onDragEnter":
                    case "onDragLeave":
                        this["_" + name + "Action"] = this._createActionByOption(name);
                        break;
                    case "dragTemplate":
                    case "contentTemplate":
                    case "container":
                    case "clone":
                        break;
                    case "allowMoveByClick":
                    case "dragDirection":
                    case "disabled":
                    case "boundary":
                    case "filter":
                    case "immediate":
                        this._resetDragElement();
                        this._detachEventHandlers();
                        this._attachEventHandlers();
                        break;
                    case "autoScroll":
                        this._verticalScrollHelper.reset();
                        this._horizontalScrollHelper.reset();
                        break;
                    case "scrollSensitivity":
                    case "scrollSpeed":
                    case "boundOffset":
                    case "handle":
                    case "group":
                    case "data":
                    case "itemData":
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _getTargetDraggable: function() {
                return targetDraggable || this
            },
            _getSourceDraggable: function() {
                return sourceDraggable || this
            },
            _setTargetDraggable: function() {
                var currentGroup = this.option("group");
                var sourceDraggable = this._getSourceDraggable();
                if (currentGroup && currentGroup === sourceDraggable.option("group")) {
                    targetDraggable = this
                }
            },
            _setSourceDraggable: function() {
                sourceDraggable = this
            },
            _resetSourceDraggable: function() {
                sourceDraggable = null
            },
            _resetTargetDraggable: function() {
                targetDraggable = null
            },
            _dispose: function() {
                this.callBase();
                this._detachEventHandlers();
                this._resetDragElement();
                this._resetTargetDraggable();
                this._resetSourceDraggable();
                this._$sourceElement = null;
                this._stopAnimator()
            },
            _fireDragEnterEvent: function(sourceEvent) {
                var args = this._getEventArgs(sourceEvent);
                this._getAction("onDragEnter")(args)
            },
            _fireDragLeaveEvent: function(sourceEvent) {
                var args = this._getEventArgs(sourceEvent);
                this._getAction("onDragLeave")(args)
            }
        });
        (0, _component_registrator.default)(DRAGGABLE, Draggable);
        var _default = Draggable;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************!*\
      !*** ./artifacts/transpiled-npm/ui/box.js ***!
      \********************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _inflector = __webpack_require__( /*! ../core/utils/inflector */ 39);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _style = __webpack_require__( /*! ../core/utils/style */ 99);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../core/utils/browser */ 23));
        var _item = _interopRequireDefault(__webpack_require__( /*! ./collection/item */ 150));
        var _uiCollection_widget = _interopRequireDefault(__webpack_require__( /*! ./collection/ui.collection_widget.edit */ 54));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var BOX_CLASS = "dx-box";
        var BOX_SELECTOR = ".dx-box";
        var BOX_ITEM_CLASS = "dx-box-item";
        var BOX_ITEM_DATA_KEY = "dxBoxItemData";
        var MINSIZE_MAP = {
            row: "minWidth",
            col: "minHeight"
        };
        var MAXSIZE_MAP = {
            row: "maxWidth",
            col: "maxHeight"
        };
        var SHRINK = 1;
        var FLEX_JUSTIFY_CONTENT_MAP = {
            start: "flex-start",
            end: "flex-end",
            center: "center",
            "space-between": "space-between",
            "space-around": "space-around"
        };
        var FLEX_ALIGN_ITEMS_MAP = {
            start: "flex-start",
            end: "flex-end",
            center: "center",
            stretch: "stretch"
        };
        var FLEX_DIRECTION_MAP = {
            row: "row",
            col: "column"
        };
        var setFlexProp = function(element, prop, value) {
            value = (0, _style.normalizeStyleProp)(prop, value);
            element.style[(0, _style.styleProp)(prop)] = value;
            if (!(0, _window.hasWindow)()) {
                if ("" === value || !(0, _type.isDefined)(value)) {
                    return
                }
                var cssName = (0, _inflector.dasherize)(prop);
                var styleExpr = cssName + ": " + value + ";";
                if (!element.attributes.style) {
                    element.setAttribute("style", styleExpr)
                } else {
                    if (element.attributes.style.value.indexOf(styleExpr) < 0) {
                        element.attributes.style.value += " " + styleExpr
                    }
                }
            }
        };
        var BOX_EVENTNAMESPACE = "dxBox";
        var UPDATE_EVENT = "dxupdate." + BOX_EVENTNAMESPACE;
        var FALLBACK_BOX_ITEM = "dx-box-fallback-item";
        var FALLBACK_WRAP_MAP = {
            row: "nowrap",
            col: "normal"
        };
        var FALLBACK_MAIN_SIZE_MAP = {
            row: "width",
            col: "height"
        };
        var FALLBACK_CROSS_SIZE_MAP = {
            row: "height",
            col: "width"
        };
        var FALLBACK_PRE_MARGIN_MAP = {
            row: "marginLeft",
            col: "marginTop"
        };
        var FALLBACK_POST_MARGIN_MAP = {
            row: "marginRight",
            col: "marginBottom"
        };
        var FALLBACK_CROSS_PRE_MARGIN_MAP = {
            row: "marginTop",
            col: "marginLeft"
        };
        var FALLBACK_CROSS_POST_MARGIN_MAP = {
            row: "marginBottom",
            col: "marginRight"
        };
        var MARGINS_RTL_FLIP_MAP = {
            marginLeft: "marginRight",
            marginRight: "marginLeft"
        };
        var BoxItem = function(_CollectionWidgetItem) {
            _inheritsLoose(BoxItem, _CollectionWidgetItem);

            function BoxItem() {
                return _CollectionWidgetItem.apply(this, arguments) || this
            }
            var _proto = BoxItem.prototype;
            _proto._renderVisible = function(value, oldValue) {
                _CollectionWidgetItem.prototype._renderVisible.call(this, value);
                if ((0, _type.isDefined)(oldValue)) {
                    this._options.fireItemStateChangedAction({
                        name: "visible",
                        state: value,
                        oldState: oldValue
                    })
                }
            };
            return BoxItem
        }(_item.default);
        var FlexLayoutStrategy = function() {
            function FlexLayoutStrategy($element, option) {
                this._$element = $element;
                this._option = option;
                this.initSize = _common.noop;
                this.update = _common.noop
            }
            var _proto2 = FlexLayoutStrategy.prototype;
            _proto2.renderBox = function() {
                this._$element.css({
                    display: (0, _style.stylePropPrefix)("flexDirection") + "flex"
                });
                setFlexProp(this._$element.get(0), "flexDirection", FLEX_DIRECTION_MAP[this._option("direction")])
            };
            _proto2.renderAlign = function() {
                this._$element.css({
                    justifyContent: this._normalizedAlign()
                })
            };
            _proto2._normalizedAlign = function() {
                var align = this._option("align");
                return align in FLEX_JUSTIFY_CONTENT_MAP ? FLEX_JUSTIFY_CONTENT_MAP[align] : align
            };
            _proto2.renderCrossAlign = function() {
                this._$element.css({
                    alignItems: this._normalizedCrossAlign()
                })
            };
            _proto2._normalizedCrossAlign = function() {
                var crossAlign = this._option("crossAlign");
                return crossAlign in FLEX_ALIGN_ITEMS_MAP ? FLEX_ALIGN_ITEMS_MAP[crossAlign] : crossAlign
            };
            _proto2.renderItems = function($items) {
                var flexPropPrefix = (0, _style.stylePropPrefix)("flexDirection");
                var direction = this._option("direction");
                (0, _iterator.each)($items, function() {
                    var $item = (0, _renderer.default)(this);
                    var item = $item.data(BOX_ITEM_DATA_KEY);
                    $item.css({
                        display: flexPropPrefix + "flex"
                    }).css(MAXSIZE_MAP[direction], item.maxSize || "none").css(MINSIZE_MAP[direction], item.minSize || "0");
                    setFlexProp($item.get(0), "flexBasis", item.baseSize || 0);
                    setFlexProp($item.get(0), "flexGrow", item.ratio);
                    setFlexProp($item.get(0), "flexShrink", (0, _type.isDefined)(item.shrink) ? item.shrink : SHRINK);
                    $item.children().each(function(_, itemContent) {
                        (0, _renderer.default)(itemContent).css({
                            width: "auto",
                            height: "auto",
                            display: (0, _style.stylePropPrefix)("flexDirection") + "flex",
                            flexBasis: 0
                        });
                        setFlexProp(itemContent, "flexGrow", 1);
                        setFlexProp(itemContent, "flexDirection", (0, _renderer.default)(itemContent)[0].style.flexDirection || "column")
                    })
                })
            };
            return FlexLayoutStrategy
        }();
        var FallbackLayoutStrategy = function() {
            function FallbackLayoutStrategy($element, option) {
                this._$element = $element;
                this._option = option
            }
            var _proto3 = FallbackLayoutStrategy.prototype;
            _proto3.renderBox = function() {
                this._$element.css({
                    fontSize: 0,
                    whiteSpace: FALLBACK_WRAP_MAP[this._option("direction")],
                    verticalAlign: "top"
                });
                _events_engine.default.off(this._$element, UPDATE_EVENT);
                _events_engine.default.on(this._$element, UPDATE_EVENT, this.update.bind(this))
            };
            _proto3.renderAlign = function() {
                var $items = this._$items;
                if (!$items) {
                    return
                }
                var align = this._option("align");
                var totalItemSize = this.totalItemSize;
                var direction = this._option("direction");
                var boxSize = this._$element[FALLBACK_MAIN_SIZE_MAP[direction]]();
                var freeSpace = boxSize - totalItemSize;
                var shift = 0;
                this._setItemsMargins($items, direction, 0);
                switch (align) {
                    case "start":
                        break;
                    case "end":
                        shift = freeSpace;
                        $items.first().css(this._chooseMarginSide(FALLBACK_PRE_MARGIN_MAP[direction]), shift);
                        break;
                    case "center":
                        shift = .5 * freeSpace;
                        $items.first().css(this._chooseMarginSide(FALLBACK_PRE_MARGIN_MAP[direction]), shift);
                        $items.last().css(this._chooseMarginSide(FALLBACK_POST_MARGIN_MAP[direction]), shift);
                        break;
                    case "space-between":
                        shift = .5 * freeSpace / ($items.length - 1);
                        this._setItemsMargins($items, direction, shift);
                        $items.first().css(this._chooseMarginSide(FALLBACK_PRE_MARGIN_MAP[direction]), 0);
                        $items.last().css(this._chooseMarginSide(FALLBACK_POST_MARGIN_MAP[direction]), 0);
                        break;
                    case "space-around":
                        shift = .5 * freeSpace / $items.length;
                        this._setItemsMargins($items, direction, shift)
                }
            };
            _proto3._setItemsMargins = function($items, direction, shift) {
                $items.css(this._chooseMarginSide(FALLBACK_PRE_MARGIN_MAP[direction]), shift).css(this._chooseMarginSide(FALLBACK_POST_MARGIN_MAP[direction]), shift)
            };
            _proto3.renderCrossAlign = function() {
                var $items = this._$items;
                if (!$items) {
                    return
                }
                var crossAlign = this._option("crossAlign");
                var direction = this._option("direction");
                var size = this._$element[FALLBACK_CROSS_SIZE_MAP[direction]]();
                var that = this;
                switch (crossAlign) {
                    case "start":
                        break;
                    case "end":
                        (0, _iterator.each)($items, function() {
                            var $item = (0, _renderer.default)(this);
                            var itemSize = $item[FALLBACK_CROSS_SIZE_MAP[direction]]();
                            var shift = size - itemSize;
                            $item.css(that._chooseMarginSide(FALLBACK_CROSS_PRE_MARGIN_MAP[direction]), shift)
                        });
                        break;
                    case "center":
                        (0, _iterator.each)($items, function() {
                            var $item = (0, _renderer.default)(this);
                            var itemSize = $item[FALLBACK_CROSS_SIZE_MAP[direction]]();
                            var shift = .5 * (size - itemSize);
                            $item.css(that._chooseMarginSide(FALLBACK_CROSS_PRE_MARGIN_MAP[direction]), shift).css(that._chooseMarginSide(FALLBACK_CROSS_POST_MARGIN_MAP[direction]), shift)
                        });
                        break;
                    case "stretch":
                        $items.css(that._chooseMarginSide(FALLBACK_CROSS_PRE_MARGIN_MAP[direction]), 0).css(that._chooseMarginSide(FALLBACK_CROSS_POST_MARGIN_MAP[direction]), 0).css(FALLBACK_CROSS_SIZE_MAP[direction], "100%")
                }
            };
            _proto3._chooseMarginSide = function(value) {
                if (!this._option("rtlEnabled")) {
                    return value
                }
                return MARGINS_RTL_FLIP_MAP[value] || value
            };
            _proto3.renderItems = function($items) {
                var _this = this;
                this._$items = $items;
                var direction = this._option("direction");
                var totalRatio = 0;
                var totalWeightedShrink = 0;
                var totalBaseSize = 0;
                (0, _iterator.each)($items, function(_, item) {
                    var $item = (0, _renderer.default)(item);
                    $item.css({
                        display: "inline-block",
                        verticalAlign: "top"
                    });
                    $item[FALLBACK_MAIN_SIZE_MAP[direction]]("auto");
                    $item.removeClass(FALLBACK_BOX_ITEM);
                    var itemData = $item.data(BOX_ITEM_DATA_KEY);
                    var ratio = itemData.ratio || 0;
                    var size = _this._baseSize($item);
                    var shrink = (0, _type.isDefined)(itemData.shrink) ? itemData.shrink : SHRINK;
                    totalRatio += ratio;
                    totalWeightedShrink += shrink * size;
                    totalBaseSize += size
                });
                var freeSpaceSize = this._boxSize() - totalBaseSize;
                var itemSize = function($item) {
                    var itemData = $item.data(BOX_ITEM_DATA_KEY);
                    var size = _this._baseSize($item);
                    var factor = freeSpaceSize >= 0 ? itemData.ratio || 0 : ((0, _type.isDefined)(itemData.shrink) ? itemData.shrink : SHRINK) * size;
                    var totalFactor = freeSpaceSize >= 0 ? totalRatio : totalWeightedShrink;
                    var shift = totalFactor ? Math.round(freeSpaceSize * factor / totalFactor) : 0;
                    return size + shift
                };
                var totalItemSize = 0;
                (0, _iterator.each)($items, function(_, item) {
                    var $item = (0, _renderer.default)(item);
                    var itemData = (0, _renderer.default)(item).data(BOX_ITEM_DATA_KEY);
                    var size = itemSize($item);
                    totalItemSize += size;
                    $item.css(MAXSIZE_MAP[direction], itemData.maxSize || "none").css(MINSIZE_MAP[direction], itemData.minSize || "0").css(FALLBACK_MAIN_SIZE_MAP[direction], size);
                    $item.addClass(FALLBACK_BOX_ITEM)
                });
                this.totalItemSize = totalItemSize
            };
            _proto3._baseSize = function(item) {
                var itemData = (0, _renderer.default)(item).data(BOX_ITEM_DATA_KEY);
                return null == itemData.baseSize ? 0 : "auto" === itemData.baseSize ? this._contentSize(item) : this._parseSize(itemData.baseSize)
            };
            _proto3._contentSize = function(item) {
                return (0, _renderer.default)(item)[FALLBACK_MAIN_SIZE_MAP[this._option("direction")]]()
            };
            _proto3._parseSize = function(size) {
                return String(size).match(/.+%$/) ? .01 * parseFloat(size) * this._boxSizeValue : size
            };
            _proto3._boxSize = function(value) {
                if (!arguments.length) {
                    this._boxSizeValue = this._boxSizeValue || this._totalBaseSize();
                    return this._boxSizeValue
                }
                this._boxSizeValue = value
            };
            _proto3._totalBaseSize = function() {
                var _this2 = this;
                var result = 0;
                (0, _iterator.each)(this._$items, function(_, item) {
                    result += _this2._baseSize(item)
                });
                return result
            };
            _proto3.initSize = function() {
                this._boxSize(this._$element[FALLBACK_MAIN_SIZE_MAP[this._option("direction")]]())
            };
            _proto3.update = function() {
                if (!this._$items || this._$element.is(":hidden")) {
                    return
                }
                this._$items.detach();
                this.initSize();
                this._$element.append(this._$items);
                this.renderItems(this._$items);
                this.renderAlign();
                this.renderCrossAlign();
                var element = this._$element.get(0);
                this._$items.find(BOX_SELECTOR).each(function() {
                    if (element === (0, _renderer.default)(this).parent().closest(BOX_SELECTOR).get(0)) {
                        _events_engine.default.triggerHandler(this, UPDATE_EVENT)
                    }
                })
            };
            return FallbackLayoutStrategy
        }();
        var Box = function(_CollectionWidget) {
            _inheritsLoose(Box, _CollectionWidget);

            function Box() {
                return _CollectionWidget.apply(this, arguments) || this
            }
            var _proto4 = Box.prototype;
            _proto4._getDefaultOptions = function() {
                return (0, _extend.extend)(_CollectionWidget.prototype._getDefaultOptions.call(this), {
                    direction: "row",
                    align: "start",
                    crossAlign: "stretch",
                    activeStateEnabled: false,
                    focusStateEnabled: false,
                    onItemStateChanged: void 0,
                    _layoutStrategy: "flex",
                    _queue: void 0
                })
            };
            _proto4._defaultOptionsRules = function() {
                return _CollectionWidget.prototype._defaultOptionsRules.call(this).concat([{
                    device: function() {
                        return _browser.default.msie
                    },
                    options: {
                        _layoutStrategy: "fallback"
                    }
                }])
            };
            _proto4._itemClass = function() {
                return BOX_ITEM_CLASS
            };
            _proto4._itemDataKey = function() {
                return BOX_ITEM_DATA_KEY
            };
            _proto4._itemElements = function() {
                return this._itemContainer().children(this._itemSelector())
            };
            _proto4._init = function() {
                _CollectionWidget.prototype._init.call(this);
                this.$element().addClass("".concat(BOX_CLASS, "-").concat(this.option("_layoutStrategy")));
                this._initLayout();
                this._initBoxQueue()
            };
            _proto4._initLayout = function() {
                this._layout = "fallback" === this.option("_layoutStrategy") ? new FallbackLayoutStrategy(this.$element(), this.option.bind(this)) : new FlexLayoutStrategy(this.$element(), this.option.bind(this))
            };
            _proto4._initBoxQueue = function() {
                this._queue = this.option("_queue") || []
            };
            _proto4._queueIsNotEmpty = function() {
                return this.option("_queue") ? false : !!this._queue.length
            };
            _proto4._pushItemToQueue = function($item, config) {
                this._queue.push({
                    $item: $item,
                    config: config
                })
            };
            _proto4._shiftItemFromQueue = function() {
                return this._queue.shift()
            };
            _proto4._initMarkup = function() {
                this.$element().addClass(BOX_CLASS);
                this._layout.renderBox();
                _CollectionWidget.prototype._initMarkup.call(this);
                this._renderAlign();
                this._renderActions()
            };
            _proto4._renderActions = function() {
                this._onItemStateChanged = this._createActionByOption("onItemStateChanged")
            };
            _proto4._renderAlign = function() {
                this._layout.renderAlign();
                this._layout.renderCrossAlign()
            };
            _proto4._renderItems = function(items) {
                var _this3 = this;
                this._layout.initSize();
                _CollectionWidget.prototype._renderItems.call(this, items);
                while (this._queueIsNotEmpty()) {
                    var item = this._shiftItemFromQueue();
                    this._createComponent(item.$item, Box, (0, _extend.extend)({
                        _layoutStrategy: this.option("_layoutStrategy"),
                        itemTemplate: this.option("itemTemplate"),
                        itemHoldTimeout: this.option("itemHoldTimeout"),
                        onItemHold: this.option("onItemHold"),
                        onItemClick: this.option("onItemClick"),
                        onItemContextMenu: this.option("onItemContextMenu"),
                        onItemRendered: this.option("onItemRendered"),
                        _queue: this._queue
                    }, item.config))
                }
                this._layout.renderItems(this._itemElements());
                clearTimeout(this._updateTimer);
                this._updateTimer = setTimeout(function() {
                    if (!_this3._isUpdated) {
                        _this3._layout.update()
                    }
                    _this3._isUpdated = false;
                    _this3._updateTimer = null
                })
            };
            _proto4._renderItemContent = function(args) {
                var $itemNode = args.itemData && args.itemData.node;
                if ($itemNode) {
                    return this._renderItemContentByNode(args, $itemNode)
                }
                return _CollectionWidget.prototype._renderItemContent.call(this, args)
            };
            _proto4._postprocessRenderItem = function(args) {
                var boxConfig = args.itemData.box;
                if (!boxConfig) {
                    return
                }
                this._pushItemToQueue(args.itemContent, boxConfig)
            };
            _proto4._createItemByTemplate = function(itemTemplate, args) {
                if (args.itemData.box) {
                    return itemTemplate.source ? itemTemplate.source() : (0, _renderer.default)()
                }
                return _CollectionWidget.prototype._createItemByTemplate.call(this, itemTemplate, args)
            };
            _proto4._visibilityChanged = function(visible) {
                if (visible) {
                    this._dimensionChanged()
                }
            };
            _proto4._dimensionChanged = function() {
                if (this._updateTimer) {
                    return
                }
                this._isUpdated = true;
                this._layout.update()
            };
            _proto4._dispose = function() {
                clearTimeout(this._updateTimer);
                _CollectionWidget.prototype._dispose.apply(this, arguments)
            };
            _proto4._itemOptionChanged = function(item, property, value, oldValue) {
                if ("visible" === property) {
                    this._onItemStateChanged({
                        name: property,
                        state: value,
                        oldState: false !== oldValue
                    })
                }
                _CollectionWidget.prototype._itemOptionChanged.call(this, item, property, value)
            };
            _proto4._optionChanged = function(args) {
                switch (args.name) {
                    case "_layoutStrategy":
                    case "_queue":
                    case "direction":
                        this._invalidate();
                        break;
                    case "align":
                        this._layout.renderAlign();
                        break;
                    case "crossAlign":
                        this._layout.renderCrossAlign();
                        break;
                    default:
                        _CollectionWidget.prototype._optionChanged.call(this, args)
                }
            };
            _proto4._itemOptions = function() {
                var _this4 = this;
                var options = _CollectionWidget.prototype._itemOptions.call(this);
                options.fireItemStateChangedAction = function(e) {
                    _this4._onItemStateChanged(e)
                };
                return options
            };
            _proto4.repaint = function() {
                this._dimensionChanged()
            };
            return Box
        }(_uiCollection_widget.default);
        Box.ItemClass = BoxItem;
        (0, _component_registrator.default)("dxBox", Box);
        var _default = Box;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/date_box.js ***!
      \*************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./date_box/ui.date_box */ 620));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _ui.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/date_box/ui.date_box.strategy.js ***!
      \**********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../localization/date */ 32));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var abstract = _class.default.abstract;
        var DateBoxStrategy = _class.default.inherit({
            ctor: function(dateBox) {
                this.dateBox = dateBox
            },
            widgetOption: function() {
                return this._widget && this._widget.option.apply(this._widget, arguments)
            },
            _renderWidget: function(element) {
                element = element || (0, _renderer.default)("<div>");
                this._widget = this._createWidget(element);
                this._widget.$element().appendTo(this._getWidgetContainer())
            },
            _createWidget: function(element) {
                var widgetName = this._getWidgetName();
                var widgetOptions = this._getWidgetOptions();
                return this.dateBox._createComponent(element, widgetName, widgetOptions)
            },
            _getWidgetOptions: abstract,
            _getWidgetName: abstract,
            getDefaultOptions: function() {
                return {
                    mode: "text"
                }
            },
            getDisplayFormat: abstract,
            supportedKeys: _common.noop,
            getKeyboardListener: _common.noop,
            customizeButtons: _common.noop,
            getParsedText: function(text, format) {
                var value = _date.default.parse(text, format);
                return value ? value : _date.default.parse(text)
            },
            renderInputMinMax: _common.noop,
            renderOpenedState: function() {
                this._updateValue()
            },
            popupConfig: abstract,
            _dimensionChanged: function() {
                var _this$_getPopup;
                null === (_this$_getPopup = this._getPopup()) || void 0 === _this$_getPopup ? void 0 : _this$_getPopup.repaint()
            },
            renderPopupContent: function() {
                var popup = this._getPopup();
                this._renderWidget();
                var $popupContent = popup.$content().parent();
                _events_engine.default.off($popupContent, "mousedown");
                _events_engine.default.on($popupContent, "mousedown", this._preventFocusOnPopup.bind(this))
            },
            getFirstPopupElement: _common.noop,
            getLastPopupElement: _common.noop,
            _preventFocusOnPopup: function(e) {
                e.preventDefault()
            },
            _getWidgetContainer: function() {
                return this._getPopup().$content()
            },
            _getPopup: function() {
                return this.dateBox._popup
            },
            popupShowingHandler: _common.noop,
            popupHiddenHandler: _common.noop,
            _updateValue: function() {
                this._widget && this._widget.option("value", this.dateBoxValue())
            },
            useCurrentDateByDefault: _common.noop,
            getDefaultDate: function() {
                return new Date
            },
            textChangedHandler: _common.noop,
            renderValue: function() {
                if (this.dateBox.option("opened")) {
                    this._updateValue()
                }
            },
            getValue: function() {
                return this._widget.option("value")
            },
            isAdaptivityChanged: function() {
                return false
            },
            dispose: function() {
                var popup = this._getPopup();
                if (popup) {
                    popup.$content().empty()
                }
            },
            dateBoxValue: function() {
                if (arguments.length) {
                    return this.dateBox.dateValue.apply(this.dateBox, arguments)
                } else {
                    return this.dateBox.dateOption.apply(this.dateBox, ["value"])
                }
            }
        });
        var _default = DateBoxStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/drop_down_menu.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../core/devices */ 13));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./widget/ui.widget */ 16));
        var _button = _interopRequireDefault(__webpack_require__( /*! ./button */ 37));
        var _popover = _interopRequireDefault(__webpack_require__( /*! ./popover */ 135));
        var _data_helper = _interopRequireDefault(__webpack_require__( /*! ../data_helper */ 92));
        var _list = _interopRequireDefault(__webpack_require__( /*! ./list */ 112));
        var _themes = __webpack_require__( /*! ./themes */ 34);
        var _child_default_template = __webpack_require__( /*! ../core/templates/child_default_template */ 153);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var DROP_DOWN_MENU_CLASS = "dx-dropdownmenu";
        var DROP_DOWN_MENU_POPUP_CLASS = "dx-dropdownmenu-popup";
        var DROP_DOWN_MENU_POPUP_WRAPPER_CLASS = "dx-dropdownmenu-popup-wrapper";
        var DROP_DOWN_MENU_LIST_CLASS = "dx-dropdownmenu-list";
        var DROP_DOWN_MENU_BUTTON_CLASS = "dx-dropdownmenu-button";
        var POPUP_OPTION_MAP = {
            popupWidth: "width",
            popupHeight: "height",
            popupMaxHeight: "maxHeight",
            popupAutoResizeEnabled: "autoResizeEnabled"
        };
        var BUTTON_OPTION_MAP = {
            buttonIcon: "icon",
            buttonText: "text",
            buttonWidth: "width",
            buttonHeight: "height",
            buttonTemplate: "template"
        };
        var DropDownMenu = _ui.default.inherit({
            _supportedKeys: function() {
                var extension = {};
                if (!this.option("opened") || !this._list.option("focusedElement")) {
                    extension = this._button._supportedKeys()
                }
                return (0, _extend.extend)(this.callBase(), extension, {
                    tab: function() {
                        this._popup && this._popup.hide()
                    }
                })
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    items: [],
                    onItemClick: null,
                    dataSource: null,
                    itemTemplate: "item",
                    buttonText: "",
                    buttonIcon: "overflow",
                    buttonWidth: void 0,
                    buttonHeight: void 0,
                    buttonTemplate: "content",
                    onButtonClick: null,
                    usePopover: false,
                    popupWidth: "auto",
                    popupHeight: "auto",
                    activeStateEnabled: true,
                    hoverStateEnabled: true,
                    opened: false,
                    selectionMode: "none",
                    selectedItemKeys: [],
                    deferRendering: false,
                    popupPosition: {
                        my: "top center",
                        at: "bottom center",
                        collision: "fit flip",
                        offset: {
                            v: 1
                        }
                    },
                    popupAnimation: void 0,
                    onItemRendered: null,
                    menuWidget: _list.default,
                    popupMaxHeight: void 0,
                    closeOnClick: true,
                    useInkRipple: false,
                    container: void 0,
                    popupAutoResizeEnabled: false
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: {
                        platform: "ios"
                    },
                    options: {
                        usePopover: true
                    }
                }, {
                    device: {
                        platform: "generic"
                    },
                    options: {
                        popupPosition: {
                            offset: {
                                v: 4
                            }
                        }
                    }
                }, {
                    device: function() {
                        return "desktop" === _devices.default.real().deviceType && !_devices.default.isSimulator()
                    },
                    options: {
                        focusStateEnabled: true
                    }
                }, {
                    device: {
                        platform: "android"
                    },
                    options: {
                        popupPosition: {
                            my: "top " + (this.option("rtlEnabled") ? "left" : "right"),
                            at: "top " + (this.option("rtlEnabled") ? "left" : "right"),
                            collision: "flipfit"
                        },
                        popupAnimation: {
                            show: {
                                type: "pop",
                                duration: 200,
                                from: {
                                    scale: 0
                                },
                                to: {
                                    scale: 1
                                }
                            },
                            hide: {
                                type: "pop",
                                duration: 200,
                                from: {
                                    scale: 1
                                },
                                to: {
                                    scale: 0
                                }
                            }
                        }
                    }
                }, {
                    device: function() {
                        return (0, _themes.isMaterial)()
                    },
                    options: {
                        useInkRipple: true
                    }
                }])
            },
            _initOptions: function(options) {
                if ("android" === _devices.default.current().platform) {
                    if (!options.popupPosition) {
                        options.popupPosition = {
                            at: (options.usePopover ? "bottom " : "top ") + (options.rtlEnabled ? "left" : "right")
                        }
                    }
                }
                this.callBase(options)
            },
            _dataSourceOptions: function() {
                return {
                    paginate: false
                }
            },
            _init: function() {
                this.callBase();
                this.$element().addClass(DROP_DOWN_MENU_CLASS);
                this._initDataSource();
                this._initItemClickAction();
                this._initButtonClickAction()
            },
            _initItemClickAction: function() {
                this._itemClickAction = this._createActionByOption("onItemClick")
            },
            _initButtonClickAction: function() {
                this._buttonClickAction = this._createActionByOption("onButtonClick")
            },
            _initTemplates: function() {
                this._templateManager.addDefaultTemplates({
                    content: new _child_default_template.ChildDefaultTemplate("content")
                });
                this.callBase()
            },
            _initMarkup: function() {
                this._renderButton();
                this.callBase()
            },
            _render: function() {
                this.callBase();
                this.setAria({
                    role: "menubar",
                    haspopup: true,
                    expanded: this.option("opened")
                })
            },
            _renderContentImpl: function() {
                if (this.option("opened")) {
                    this._renderPopup()
                }
            },
            _clean: function() {
                this._cleanFocusState();
                if (this._popup) {
                    this._popup.$element().remove();
                    delete this._$popup
                }
            },
            _renderButton: function() {
                var $button = this.$element().addClass(DROP_DOWN_MENU_BUTTON_CLASS);
                var config = this._buttonOptions();
                this._button = this._createComponent($button, _button.default, config)
            },
            _toggleActiveState: function($element, value, e) {
                this._button._toggleActiveState($element, value, e)
            },
            _buttonOptions: function() {
                return {
                    text: this.option("buttonText"),
                    icon: this.option("buttonIcon"),
                    width: this.option("buttonWidth"),
                    height: this.option("buttonHeight"),
                    useInkRipple: this.option("useInkRipple"),
                    template: this.option("buttonTemplate"),
                    focusStateEnabled: false,
                    onClick: function(e) {
                        this.option("opened", !this.option("opened"));
                        this._buttonClickAction(e)
                    }.bind(this)
                }
            },
            _toggleMenuVisibility: function(opened) {
                var state = void 0 === opened ? !this._popup.option("visible") : opened;
                if (opened) {
                    this._renderPopup()
                }
                this._popup.toggle(state);
                this.setAria("expanded", state)
            },
            _renderPopup: function() {
                if (this._$popup) {
                    return
                }
                var $popup = this._$popup = (0, _renderer.default)("<div>").appendTo(this.$element());
                var config = this._popupOptions();
                this._popup = this._createComponent($popup, _popover.default, config)
            },
            _popupOptions: function() {
                var usePopup = !this.option("usePopover");
                return {
                    onInitialized: function(args) {
                        args.component._wrapper().addClass(DROP_DOWN_MENU_POPUP_WRAPPER_CLASS).toggleClass(DROP_DOWN_MENU_POPUP_CLASS, usePopup)
                    },
                    visible: this.option("opened"),
                    deferRendering: false,
                    contentTemplate: function(contentElement) {
                        this._renderList(contentElement)
                    }.bind(this),
                    position: this.option("popupPosition"),
                    animation: this.option("popupAnimation"),
                    onOptionChanged: function(args) {
                        if ("visible" === args.name) {
                            this.option("opened", args.value)
                        }
                    }.bind(this),
                    target: this.$element(),
                    height: this.option("popupHeight"),
                    width: this.option("popupWidth"),
                    maxHeight: this.option("popupMaxHeight"),
                    container: this.option("container"),
                    autoResizeEnabled: this.option("popupAutoResizeEnabled")
                }
            },
            _renderList: function(contentElement) {
                var $content = (0, _renderer.default)(contentElement);
                var listConfig = this._listOptions();
                $content.addClass(DROP_DOWN_MENU_LIST_CLASS);
                this._list = this._createComponent($content, this.option("menuWidget"), listConfig);
                this._list._getAriaTarget = function() {
                    return this.$element()
                }.bind(this);
                this._setListDataSource();
                var listMaxHeight = .5 * (0, _renderer.default)(window).height();
                if ($content.height() > listMaxHeight) {
                    $content.height(listMaxHeight)
                }
            },
            _listOptions: function() {
                return {
                    pageLoadMode: "scrollBottom",
                    indicateLoading: false,
                    noDataText: "",
                    selectionMode: this.option("selectionMode"),
                    selectedItemKeys: this.option("selectedItemKeys"),
                    itemTemplate: this.option("itemTemplate"),
                    onItemClick: function(e) {
                        if (this.option("closeOnClick")) {
                            this.option("opened", false)
                        }
                        this._itemClickAction(e)
                    }.bind(this),
                    tabIndex: -1,
                    focusStateEnabled: this.option("focusStateEnabled"),
                    activeStateEnabled: this.option("activeStateEnabled"),
                    onItemRendered: this.option("onItemRendered"),
                    _itemAttributes: {
                        role: "menuitem"
                    }
                }
            },
            _setListDataSource: function() {
                if (this._list) {
                    this._list.option("dataSource", this._dataSource || this.option("items"))
                }
                delete this._deferRendering
            },
            _getKeyboardListeners: function() {
                return this.callBase().concat([this._list])
            },
            _toggleVisibility: function(visible) {
                this.callBase(visible);
                this._button.option("visible", visible)
            },
            _optionChanged: function(args) {
                var name = args.name;
                var value = args.value;
                switch (name) {
                    case "items":
                    case "dataSource":
                        if (this.option("deferRendering") && !this.option("opened")) {
                            this._deferRendering = true
                        } else {
                            this._refreshDataSource();
                            this._setListDataSource()
                        }
                        break;
                    case "itemTemplate":
                        if (this._list) {
                            this._list.option(name, this._getTemplate(value))
                        }
                        break;
                    case "onItemClick":
                        this._initItemClickAction();
                        break;
                    case "onButtonClick":
                        this._buttonClickAction();
                        break;
                    case "buttonIcon":
                    case "buttonText":
                    case "buttonWidth":
                    case "buttonHeight":
                    case "buttonTemplate":
                        this._button.option(BUTTON_OPTION_MAP[name], value);
                        this._renderPopup();
                        break;
                    case "popupWidth":
                    case "popupHeight":
                    case "popupMaxHeight":
                    case "popupAutoResizeEnabled":
                        this._popup.option(POPUP_OPTION_MAP[name], value);
                        break;
                    case "usePopover":
                    case "menuWidget":
                    case "useInkRipple":
                        this._invalidate();
                        break;
                    case "focusStateEnabled":
                    case "activeStateEnabled":
                        if (this._list) {
                            this._list.option(name, value)
                        }
                        this.callBase(args);
                        break;
                    case "selectionMode":
                    case "selectedItemKeys":
                    case "onItemRendered":
                        if (this._list) {
                            this._list.option(name, value)
                        }
                        break;
                    case "opened":
                        if (this._deferRendering) {
                            this._refreshDataSource();
                            this._setListDataSource()
                        }
                        this._toggleMenuVisibility(value);
                        break;
                    case "deferRendering":
                    case "popupPosition":
                    case "closeOnClick":
                        break;
                    case "container":
                        this._popup && this._popup.option(args.name, args.value);
                        break;
                    default:
                        this.callBase(args)
                }
            },
            open: function() {
                this.option("opened", true)
            },
            close: function() {
                this.option("opened", false)
            }
        }).include(_data_helper.default);
        (0, _component_registrator.default)("dxDropDownMenu", DropDownMenu);
        var _default = DropDownMenu;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tabs.js ***!
      \*********************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../core/devices */ 13));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _button = _interopRequireDefault(__webpack_require__( /*! ./button */ 37));
        var _utils = __webpack_require__( /*! ./widget/utils.ink_ripple */ 82);
        var _index = __webpack_require__( /*! ../events/utils/index */ 8);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../events/pointer */ 24));
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _item = _interopRequireDefault(__webpack_require__( /*! ./tabs/item */ 359));
        var _constants = __webpack_require__( /*! ./tabs/constants */ 360);
        var _themes = __webpack_require__( /*! ./themes */ 34);
        var _hold = _interopRequireDefault(__webpack_require__( /*! ../events/hold */ 104));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./scroll_view/ui.scrollable */ 106));
        var _uiCollection_widget = _interopRequireDefault(__webpack_require__( /*! ./collection/ui.collection_widget.live_update */ 209));
        var _icon = __webpack_require__( /*! ../core/utils/icon */ 56);
        var _bindable_template = __webpack_require__( /*! ../core/templates/bindable_template */ 65);
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var TABS_CLASS = "dx-tabs";
        var TABS_WRAPPER_CLASS = "dx-tabs-wrapper";
        var TABS_STRETCHED_CLASS = "dx-tabs-stretched";
        var TABS_SCROLLABLE_CLASS = "dx-tabs-scrollable";
        var TABS_NAV_BUTTONS_CLASS = "dx-tabs-nav-buttons";
        var OVERFLOW_HIDDEN_CLASS = "dx-overflow-hidden";
        var TABS_ITEM_CLASS = "dx-tab";
        var TABS_ITEM_SELECTED_CLASS = "dx-tab-selected";
        var TABS_NAV_BUTTON_CLASS = "dx-tabs-nav-button";
        var TABS_LEFT_NAV_BUTTON_CLASS = "dx-tabs-nav-button-left";
        var TABS_RIGHT_NAV_BUTTON_CLASS = "dx-tabs-nav-button-right";
        var TABS_ITEM_TEXT_CLASS = "dx-tab-text";
        var TABS_ITEM_DATA_KEY = "dxTabData";
        var BUTTON_NEXT_ICON = "chevronnext";
        var BUTTON_PREV_ICON = "chevronprev";
        var FEEDBACK_HIDE_TIMEOUT = 100;
        var FEEDBACK_DURATION_INTERVAL = 5;
        var FEEDBACK_SCROLL_TIMEOUT = 300;
        var TAB_OFFSET = 30;
        var Tabs = _uiCollection_widget.default.inherit({
            _activeStateUnit: "." + TABS_ITEM_CLASS,
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    hoverStateEnabled: true,
                    showNavButtons: true,
                    scrollByContent: true,
                    scrollingEnabled: true,
                    selectionMode: "single",
                    activeStateEnabled: true,
                    selectionRequired: false,
                    selectOnFocus: true,
                    loopItemFocus: false,
                    useInkRipple: false,
                    badgeExpr: function(data) {
                        return data ? data.badge : void 0
                    },
                    _itemAttributes: {
                        role: "tab"
                    }
                })
            },
            _defaultOptionsRules: function() {
                var themeName = (0, _themes.current)();
                return this.callBase().concat([{
                    device: function() {
                        return "desktop" !== _devices.default.real().deviceType
                    },
                    options: {
                        showNavButtons: false
                    }
                }, {
                    device: {
                        deviceType: "desktop"
                    },
                    options: {
                        scrollByContent: false
                    }
                }, {
                    device: function() {
                        return "desktop" === _devices.default.real().deviceType && !_devices.default.isSimulator()
                    },
                    options: {
                        focusStateEnabled: true
                    }
                }, {
                    device: function() {
                        return (0, _themes.isMaterial)(themeName)
                    },
                    options: {
                        useInkRipple: true,
                        selectOnFocus: false
                    }
                }])
            },
            _init: function() {
                this.callBase();
                this.setAria("role", "tablist");
                this.$element().addClass(TABS_CLASS);
                this._renderWrapper();
                this._renderMultiple();
                this._feedbackHideTimeout = FEEDBACK_HIDE_TIMEOUT
            },
            _initTemplates: function() {
                this.callBase();
                this._templateManager.addDefaultTemplates({
                    item: new _bindable_template.BindableTemplate(function($container, data) {
                        if ((0, _type.isPlainObject)(data)) {
                            this._prepareDefaultItemTemplate(data, $container)
                        } else {
                            $container.text(String(data))
                        }
                        var $iconElement = (0, _icon.getImageContainer)(data.icon);
                        $iconElement && $iconElement.prependTo($container);
                        $container.wrapInner((0, _renderer.default)("<span>").addClass(TABS_ITEM_TEXT_CLASS))
                    }.bind(this), ["text", "html", "icon"], this.option("integrationOptions.watchMethod"))
                })
            },
            _createItemByTemplate: function(itemTemplate, renderArgs) {
                var _this = this;
                var itemData = renderArgs.itemData,
                    container = renderArgs.container,
                    index = renderArgs.index;
                this._deferredTemplates[index] = new _deferred.Deferred;
                return itemTemplate.render({
                    model: itemData,
                    container: container,
                    index: index,
                    onRendered: function() {
                        return _this._deferredTemplates[index].resolve()
                    }
                })
            },
            _itemClass: function() {
                return TABS_ITEM_CLASS
            },
            _selectedItemClass: function() {
                return TABS_ITEM_SELECTED_CLASS
            },
            _itemDataKey: function() {
                return TABS_ITEM_DATA_KEY
            },
            _initMarkup: function() {
                this._deferredTemplates = [];
                this.callBase();
                this.option("useInkRipple") && this._renderInkRipple();
                this.$element().addClass(OVERFLOW_HIDDEN_CLASS)
            },
            _render: function() {
                this.callBase();
                this._deferRenderScrolling()
            },
            _deferRenderScrolling: function() {
                var _this2 = this;
                _deferred.when.apply(this, this._deferredTemplates).done(function() {
                    return _this2._renderScrolling()
                })
            },
            _renderScrolling: function() {
                var removeClasses = [TABS_STRETCHED_CLASS, _constants.TABS_EXPANDED_CLASS, OVERFLOW_HIDDEN_CLASS];
                this.$element().removeClass(removeClasses.join(" "));
                if (this.option("scrollingEnabled") && this._isItemsWidthExceeded()) {
                    if (!this._scrollable) {
                        this._renderScrollable();
                        this._renderNavButtons()
                    }
                    this._scrollable.update();
                    this._updateNavButtonsVisibility();
                    if (this.option("rtlEnabled")) {
                        this._scrollable.scrollTo({
                            left: this._scrollable.scrollWidth() - this._scrollable.clientWidth()
                        })
                    }
                    this._scrollToItem(this.option("selectedItem"))
                }
                if (!(this.option("scrollingEnabled") && this._isItemsWidthExceeded())) {
                    this._cleanScrolling();
                    if (this._needStretchItems() && !this._isItemsWidthExceeded()) {
                        this.$element().addClass(TABS_STRETCHED_CLASS)
                    }
                    this.$element().removeClass(TABS_NAV_BUTTONS_CLASS).addClass(_constants.TABS_EXPANDED_CLASS)
                }
            },
            _isItemsWidthExceeded: function() {
                var tabItemsWidth = this._getSummaryItemsWidth(this._getVisibleItems(), true);
                return tabItemsWidth - 1 > this.$element().width()
            },
            _needStretchItems: function() {
                var $visibleItems = this._getVisibleItems();
                var elementWidth = this.$element().width();
                var itemsWidth = [];
                (0, _iterator.each)($visibleItems, function(_, item) {
                    itemsWidth.push((0, _renderer.default)(item).outerWidth(true))
                });
                var maxTabWidth = Math.max.apply(null, itemsWidth);
                return maxTabWidth > elementWidth / $visibleItems.length
            },
            _cleanNavButtons: function() {
                if (!this._leftButton || !this._rightButton) {
                    return
                }
                this._leftButton.$element().remove();
                this._rightButton.$element().remove();
                this._leftButton = null;
                this._rightButton = null
            },
            _cleanScrolling: function() {
                if (!this._scrollable) {
                    return
                }
                this._$wrapper.appendTo(this.$element());
                this._scrollable.$element().remove();
                this._scrollable = null;
                this._cleanNavButtons()
            },
            _renderInkRipple: function() {
                this._inkRipple = (0, _utils.render)()
            },
            _toggleActiveState: function($element, value, e) {
                this.callBase.apply(this, arguments);
                if (!this._inkRipple) {
                    return
                }
                var config = {
                    element: $element,
                    event: e
                };
                if (value) {
                    this._inkRipple.showWave(config)
                } else {
                    this._inkRipple.hideWave(config)
                }
            },
            _renderMultiple: function() {
                if ("multiple" === this.option("selectionMode")) {
                    this.option("selectOnFocus", false)
                }
            },
            _renderWrapper: function() {
                this._$wrapper = (0, _renderer.default)("<div>").addClass(TABS_WRAPPER_CLASS);
                this.$element().append(this._$wrapper)
            },
            _itemContainer: function() {
                return this._$wrapper
            },
            _renderScrollable: function() {
                var $itemContainer = this.$element().wrapInner((0, _renderer.default)("<div>").addClass(TABS_SCROLLABLE_CLASS)).children();
                this._scrollable = this._createComponent($itemContainer, _ui.default, {
                    direction: "horizontal",
                    showScrollbar: false,
                    useKeyboard: false,
                    useNative: false,
                    scrollByContent: this.option("scrollByContent"),
                    onScroll: this._updateNavButtonsVisibility.bind(this)
                });
                this.$element().append(this._scrollable.$element())
            },
            _scrollToItem: function(itemData) {
                if (!this._scrollable) {
                    return
                }
                var $item = this._editStrategy.getItemElement(itemData);
                this._scrollable.scrollToElement($item)
            },
            _renderNavButtons: function() {
                this.$element().toggleClass(TABS_NAV_BUTTONS_CLASS, this.option("showNavButtons"));
                if (!this.option("showNavButtons")) {
                    return
                }
                var rtlEnabled = this.option("rtlEnabled");
                this._leftButton = this._createNavButton(-TAB_OFFSET, rtlEnabled ? BUTTON_NEXT_ICON : BUTTON_PREV_ICON);
                var $leftButton = this._leftButton.$element();
                $leftButton.addClass(TABS_LEFT_NAV_BUTTON_CLASS);
                this.$element().prepend($leftButton);
                this._rightButton = this._createNavButton(TAB_OFFSET, rtlEnabled ? BUTTON_PREV_ICON : BUTTON_NEXT_ICON);
                var $rightButton = this._rightButton.$element();
                $rightButton.addClass(TABS_RIGHT_NAV_BUTTON_CLASS);
                this.$element().append($rightButton)
            },
            _updateNavButtonsVisibility: function() {
                this._leftButton && this._leftButton.option("disabled", this._scrollable.scrollLeft() <= 0);
                this._rightButton && this._rightButton.option("disabled", this._scrollable.scrollLeft() >= Math.round(this._scrollable.scrollWidth() - this._scrollable.clientWidth()))
            },
            _updateScrollPosition: function(offset, duration) {
                this._scrollable.update();
                this._scrollable.scrollBy(offset / duration)
            },
            _createNavButton: function(offset, icon) {
                var that = this;
                var holdAction = that._createAction(function() {
                    that._holdInterval = setInterval(function() {
                        that._updateScrollPosition(offset, FEEDBACK_DURATION_INTERVAL)
                    }, FEEDBACK_DURATION_INTERVAL)
                });
                var holdEventName = (0, _index.addNamespace)(_hold.default.name, "dxNavButton");
                var pointerUpEventName = (0, _index.addNamespace)(_pointer.default.up, "dxNavButton");
                var pointerOutEventName = (0, _index.addNamespace)(_pointer.default.out, "dxNavButton");
                var navButton = this._createComponent((0, _renderer.default)("<div>").addClass(TABS_NAV_BUTTON_CLASS), _button.default, {
                    focusStateEnabled: false,
                    icon: icon,
                    onClick: function() {
                        that._updateScrollPosition(offset, 1)
                    },
                    integrationOptions: {}
                });
                var $navButton = navButton.$element();
                _events_engine.default.on($navButton, holdEventName, {
                    timeout: FEEDBACK_SCROLL_TIMEOUT
                }, function(e) {
                    holdAction({
                        event: e
                    })
                }.bind(this));
                _events_engine.default.on($navButton, pointerUpEventName, function() {
                    that._clearInterval()
                });
                _events_engine.default.on($navButton, pointerOutEventName, function() {
                    that._clearInterval()
                });
                return navButton
            },
            _clearInterval: function() {
                if (this._holdInterval) {
                    clearInterval(this._holdInterval)
                }
            },
            _updateSelection: function(addedSelection) {
                this._scrollable && this._scrollable.scrollToElement(this.itemElements().eq(addedSelection[0]), {
                    left: 1,
                    right: 1
                })
            },
            _visibilityChanged: function(visible) {
                if (visible) {
                    this._dimensionChanged()
                }
            },
            _dimensionChanged: function() {
                this._renderScrolling()
            },
            _itemSelectHandler: function(e) {
                if ("single" === this.option("selectionMode") && this.isItemSelected(e.currentTarget)) {
                    return
                }
                this.callBase(e)
            },
            _clean: function() {
                this._deferredTemplates = [];
                this._cleanScrolling();
                this.callBase()
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "useInkRipple":
                    case "scrollingEnabled":
                    case "showNavButtons":
                        this._invalidate();
                        break;
                    case "scrollByContent":
                        this._scrollable && this._scrollable.option(args.name, args.value);
                        break;
                    case "width":
                        this.callBase(args);
                        this._dimensionChanged();
                        break;
                    case "selectionMode":
                        this._renderMultiple();
                        this.callBase(args);
                        break;
                    case "badgeExpr":
                        this._invalidate();
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _afterItemElementInserted: function() {
                this.callBase();
                this._deferRenderScrolling()
            },
            _afterItemElementDeleted: function($item, deletedActionArgs) {
                this.callBase($item, deletedActionArgs);
                this._renderScrolling()
            }
        });
        Tabs.ItemClass = _item.default;
        (0, _component_registrator.default)("dxTabs", Tabs);
        var _default = Tabs;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/validator.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _element_data = __webpack_require__( /*! ../core/element_data */ 40);
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ../core/utils/callbacks */ 27));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./widget/ui.errors */ 17));
        var _dom_component = _interopRequireDefault(__webpack_require__( /*! ../core/dom_component */ 67));
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _validation_engine = _interopRequireDefault(__webpack_require__( /*! ./validation_engine */ 96));
        var _default_adapter = _interopRequireDefault(__webpack_require__( /*! ./validation/default_adapter */ 643));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);
        var _guid = _interopRequireDefault(__webpack_require__( /*! ../core/guid */ 36));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var VALIDATOR_CLASS = "dx-validator";
        var VALIDATION_STATUS_VALID = "valid";
        var VALIDATION_STATUS_INVALID = "invalid";
        var VALIDATION_STATUS_PENDING = "pending";
        var Validator = _dom_component.default.inherit({
            _initOptions: function(options) {
                this.callBase.apply(this, arguments);
                this.option(_validation_engine.default.initValidationOptions(options))
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    validationRules: []
                })
            },
            _init: function() {
                this.callBase();
                this._initGroupRegistration();
                this.focused = (0, _callbacks.default)();
                this._initAdapter();
                this._validationInfo = {
                    result: null,
                    deferred: null,
                    skipValidation: false
                }
            },
            _initGroupRegistration: function() {
                var group = this._findGroup();
                if (!this._groupWasInit) {
                    this.on("disposing", function(args) {
                        _validation_engine.default.removeRegisteredValidator(args.component._validationGroup, args.component)
                    })
                }
                if (!this._groupWasInit || this._validationGroup !== group) {
                    _validation_engine.default.removeRegisteredValidator(this._validationGroup, this);
                    this._groupWasInit = true;
                    this._validationGroup = group;
                    _validation_engine.default.registerValidatorInGroup(group, this)
                }
            },
            _setOptionsByReference: function() {
                this.callBase();
                (0, _extend.extend)(this._optionsByReference, {
                    validationGroup: true
                })
            },
            _initAdapter: function() {
                var _this = this;
                var element = this.$element()[0];
                var dxStandardEditor = (0, _element_data.data)(element, "dx-validation-target");
                var adapter = this.option("adapter");
                if (!adapter) {
                    if (dxStandardEditor) {
                        adapter = new _default_adapter.default(dxStandardEditor, this);
                        adapter.validationRequestsCallbacks.push(function(args) {
                            if (_this._validationInfo.skipValidation) {
                                return
                            }
                            _this.validate(args)
                        });
                        this.option("adapter", adapter);
                        return
                    }
                    throw _ui.default.Error("E0120")
                }
                var callbacks = adapter.validationRequestsCallbacks;
                if (callbacks) {
                    callbacks.push(function(args) {
                        _this.validate(args)
                    })
                }
            },
            _toggleRTLDirection: function(isRtl) {
                var _this$option$editor$o, _this$option, _this$option$editor;
                var rtlEnabled = null !== (_this$option$editor$o = null === (_this$option = this.option("adapter")) || void 0 === _this$option ? void 0 : null === (_this$option$editor = _this$option.editor) || void 0 === _this$option$editor ? void 0 : _this$option$editor.option("rtlEnabled")) && void 0 !== _this$option$editor$o ? _this$option$editor$o : isRtl;
                this.callBase(rtlEnabled)
            },
            _initMarkup: function() {
                this.$element().addClass(VALIDATOR_CLASS);
                this.callBase()
            },
            _visibilityChanged: function(visible) {
                if (visible) {
                    this._initGroupRegistration()
                }
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "validationGroup":
                        this._initGroupRegistration();
                        return;
                    case "validationRules":
                        this._resetValidationRules();
                        void 0 !== this.option("isValid") && this.validate();
                        return;
                    case "adapter":
                        this._initAdapter();
                        break;
                    case "isValid":
                    case "validationStatus":
                        this.option(_validation_engine.default.synchronizeValidationOptions(args, this.option()));
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _getValidationRules: function() {
                var _this2 = this;
                if (!this._validationRules) {
                    this._validationRules = (0, _iterator.map)(this.option("validationRules"), function(rule, index) {
                        return (0, _extend.extend)({}, rule, {
                            validator: _this2,
                            index: index
                        })
                    })
                }
                return this._validationRules
            },
            _findGroup: function() {
                var $element = this.$element();
                return this.option("validationGroup") || _validation_engine.default.findGroup($element, this._modelByElement($element))
            },
            _resetValidationRules: function() {
                delete this._validationRules
            },
            validate: function(args) {
                var _this3 = this;
                var adapter = this.option("adapter");
                var name = this.option("name");
                var bypass = adapter.bypass && adapter.bypass();
                var value = args && void 0 !== args.value ? args.value : adapter.getValue();
                var currentError = adapter.getCurrentValidationError && adapter.getCurrentValidationError();
                var rules = this._getValidationRules();
                var currentResult = this._validationInfo && this._validationInfo.result;
                if (currentResult && currentResult.status === VALIDATION_STATUS_PENDING && currentResult.value === value) {
                    return (0, _extend.extend)({}, currentResult)
                }
                var result;
                if (bypass) {
                    result = {
                        isValid: true,
                        status: VALIDATION_STATUS_VALID
                    }
                } else {
                    if (currentError && currentError.editorSpecific) {
                        currentError.validator = this;
                        result = {
                            isValid: false,
                            status: VALIDATION_STATUS_INVALID,
                            brokenRule: currentError,
                            brokenRules: [currentError]
                        }
                    } else {
                        result = _validation_engine.default.validate(value, rules, name)
                    }
                }
                result.id = (new _guid.default).toString();
                this._applyValidationResult(result, adapter);
                result.complete && result.complete.then(function(res) {
                    if (res.id === _this3._validationInfo.result.id) {
                        _this3._applyValidationResult(res, adapter)
                    }
                });
                return (0, _extend.extend)({}, this._validationInfo.result)
            },
            reset: function() {
                var adapter = this.option("adapter");
                var result = {
                    id: null,
                    isValid: true,
                    brokenRule: null,
                    brokenRules: null,
                    pendingRules: null,
                    status: VALIDATION_STATUS_VALID,
                    complete: null
                };
                this._validationInfo.skipValidation = true;
                adapter.reset();
                this._validationInfo.skipValidation = false;
                this._resetValidationRules();
                this._applyValidationResult(result, adapter)
            },
            _updateValidationResult: function(result) {
                if (!this._validationInfo.result || this._validationInfo.result.id !== result.id) {
                    var complete = this._validationInfo.deferred && this._validationInfo.result.complete;
                    this._validationInfo.result = (0, _extend.extend)({}, result, {
                        complete: complete
                    })
                } else {
                    for (var prop in result) {
                        if ("id" !== prop && "complete" !== prop) {
                            this._validationInfo.result[prop] = result[prop]
                        }
                    }
                }
            },
            _applyValidationResult: function(result, adapter) {
                var validatedAction = this._createActionByOption("onValidated", {
                    excludeValidators: ["readOnly"]
                });
                result.validator = this;
                this._updateValidationResult(result);
                adapter.applyValidationResults && adapter.applyValidationResults(this._validationInfo.result);
                this.option({
                    validationStatus: this._validationInfo.result.status
                });
                if (this._validationInfo.result.status === VALIDATION_STATUS_PENDING) {
                    if (!this._validationInfo.deferred) {
                        this._validationInfo.deferred = new _deferred.Deferred;
                        this._validationInfo.result.complete = this._validationInfo.deferred.promise()
                    }
                    this._eventsStrategy.fireEvent("validating", [this._validationInfo.result]);
                    return
                }
                if (this._validationInfo.result.status !== VALIDATION_STATUS_PENDING) {
                    validatedAction(result);
                    if (this._validationInfo.deferred) {
                        this._validationInfo.deferred.resolve(result);
                        this._validationInfo.deferred = null
                    }
                }
            },
            focus: function() {
                var adapter = this.option("adapter");
                adapter && adapter.focus && adapter.focus()
            },
            _useTemplates: function() {
                return false
            }
        });
        (0, _component_registrator.default)("dxValidator", Validator);
        var _default = Validator;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tooltip.js ***!
      \************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _tooltip = _interopRequireDefault(__webpack_require__( /*! ./tooltip/tooltip */ 371));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _tooltip.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.data_source_adapter.js ***!
      \***********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.data_source_adapter */ 382));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var dataSourceAdapterType = _uiGrid_core.default;
        var _default = {
            extend: function(extender) {
                dataSourceAdapterType = dataSourceAdapterType.inherit(extender)
            },
            create: function(component) {
                return new dataSourceAdapterType(component)
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/filter_builder/utils.js ***!
      \*************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getGroupCriteria = getGroupCriteria;
        exports.setGroupValue = setGroupValue;
        exports.getGroupMenuItem = getGroupMenuItem;
        exports.getGroupValue = getGroupValue;
        exports.getFilterOperations = getFilterOperations;
        exports.getCaptionByOperation = getCaptionByOperation;
        exports.getOperationFromAvailable = getOperationFromAvailable;
        exports.getCustomOperation = getCustomOperation;
        exports.getAvailableOperations = getAvailableOperations;
        exports.getDefaultOperation = getDefaultOperation;
        exports.createCondition = createCondition;
        exports.removeItem = removeItem;
        exports.createEmptyGroup = createEmptyGroup;
        exports.isEmptyGroup = isEmptyGroup;
        exports.addItem = addItem;
        exports.getField = getField;
        exports.isGroup = isGroup;
        exports.isCondition = isCondition;
        exports.convertToInnerStructure = convertToInnerStructure;
        exports.getNormalizedFields = getNormalizedFields;
        exports.getFilterExpression = getFilterExpression;
        exports.getNormalizedFilter = getNormalizedFilter;
        exports.getCurrentLookupValueText = getCurrentLookupValueText;
        exports.getCurrentValueText = getCurrentValueText;
        exports.getItems = getItems;
        exports.getCaptionWithParents = getCaptionWithParents;
        exports.updateConditionByOperation = updateConditionByOperation;
        exports.getOperationValue = getOperationValue;
        exports.isValidCondition = isValidCondition;
        exports.getMergedOperations = getMergedOperations;
        exports.removeFieldConditionsFromFilter = removeFieldConditionsFromFilter;
        exports.syncFilters = syncFilters;
        exports.getMatchedConditions = getMatchedConditions;
        exports.filterHasField = filterHasField;
        exports.renderValueText = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../../data/errors */ 38));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _data = __webpack_require__( /*! ../../core/utils/data */ 20);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _filtering = _interopRequireDefault(__webpack_require__( /*! ../shared/filtering */ 182));
        var _format_helper = _interopRequireDefault(__webpack_require__( /*! ../../format_helper */ 71));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _inflector = __webpack_require__( /*! ../../core/utils/inflector */ 39);
        var _between = __webpack_require__( /*! ./between */ 717);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _data_source = __webpack_require__( /*! ../../data/data_source/data_source */ 68);
        var _ui2 = _interopRequireDefault(__webpack_require__( /*! ./ui.filter_operations_dictionary */ 718));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DEFAULT_DATA_TYPE = "string";
        var EMPTY_MENU_ICON = "icon-none";
        var AND_GROUP_OPERATION = "and";
        var EQUAL_OPERATION = "=";
        var NOT_EQUAL_OPERATION = "<>";
        var DATATYPE_OPERATIONS = {
            number: ["=", "<>", "<", ">", "<=", ">=", "isblank", "isnotblank"],
            string: ["contains", "notcontains", "startswith", "endswith", "=", "<>", "isblank", "isnotblank"],
            date: ["=", "<>", "<", ">", "<=", ">=", "isblank", "isnotblank"],
            datetime: ["=", "<>", "<", ">", "<=", ">=", "isblank", "isnotblank"],
            "boolean": ["=", "<>", "isblank", "isnotblank"],
            object: ["isblank", "isnotblank"]
        };
        var DEFAULT_FORMAT = {
            date: "shortDate",
            datetime: "shortDateShortTime"
        };
        var LOOKUP_OPERATIONS = ["=", "<>", "isblank", "isnotblank"];
        var AVAILABLE_FIELD_PROPERTIES = ["caption", "customizeText", "dataField", "dataType", "editorTemplate", "falseText", "editorOptions", "filterOperations", "format", "lookup", "trueText", "calculateFilterExpression", "name"];
        var FILTER_BUILDER_CLASS = "dx-filterbuilder";
        var FILTER_BUILDER_ITEM_TEXT_CLASS = FILTER_BUILDER_CLASS + "-text";
        var FILTER_BUILDER_ITEM_TEXT_PART_CLASS = FILTER_BUILDER_ITEM_TEXT_CLASS + "-part";
        var FILTER_BUILDER_ITEM_TEXT_SEPARATOR_CLASS = FILTER_BUILDER_ITEM_TEXT_CLASS + "-separator";
        var FILTER_BUILDER_ITEM_TEXT_SEPARATOR_EMPTY_CLASS = FILTER_BUILDER_ITEM_TEXT_SEPARATOR_CLASS + "-empty";

        function getFormattedValueText(field, value) {
            var fieldFormat = field.format || DEFAULT_FORMAT[field.dataType];
            return _format_helper.default.format(value, fieldFormat)
        }

        function isNegationGroup(group) {
            return group && group.length > 1 && "!" === group[0] && !isCondition(group)
        }

        function getGroupCriteria(group) {
            return isNegationGroup(group) ? group[1] : group
        }

        function setGroupCriteria(group, criteria) {
            if (isNegationGroup(group)) {
                group[1] = criteria
            } else {
                group = criteria
            }
            return group
        }

        function convertGroupToNewStructure(group, value) {
            var isNegationValue = function(value) {
                return value.indexOf("!") !== -1
            };
            var convertGroupToNegationGroup = function(group) {
                var criteria = group.slice(0);
                group.length = 0;
                group.push("!", criteria)
            };
            var convertNegationGroupToGroup = function(group) {
                var criteria = getGroupCriteria(group);
                group.length = 0;
                [].push.apply(group, criteria)
            };
            if (isNegationValue(value)) {
                if (!isNegationGroup(group)) {
                    convertGroupToNegationGroup(group)
                }
            } else {
                if (isNegationGroup(group)) {
                    convertNegationGroupToGroup(group)
                }
            }
        }

        function setGroupValue(group, value) {
            convertGroupToNewStructure(group, value);
            var criteria = getGroupCriteria(group);
            var i;
            var getNormalizedGroupValue = function(value) {
                return value.indexOf("!") === -1 ? value : value.substring(1)
            };
            var changeCriteriaValue = function(criteria, value) {
                for (i = 0; i < criteria.length; i++) {
                    if (!Array.isArray(criteria[i])) {
                        criteria[i] = value
                    }
                }
            };
            value = getNormalizedGroupValue(value);
            changeCriteriaValue(criteria, value);
            return group
        }

        function getGroupMenuItem(group, availableGroups) {
            var groupValue = getGroupValue(group);
            return availableGroups.filter(function(item) {
                return item.value === groupValue
            })[0]
        }

        function getCriteriaOperation(criteria) {
            if (isCondition(criteria)) {
                return AND_GROUP_OPERATION
            }
            var value = "";
            for (var i = 0; i < criteria.length; i++) {
                var item = criteria[i];
                if (!Array.isArray(item)) {
                    if (value && value !== item) {
                        throw new _errors.default.errors.Error("E4019")
                    }
                    if ("!" !== item) {
                        value = item
                    }
                }
            }
            return value
        }

        function getGroupValue(group) {
            var criteria = getGroupCriteria(group);
            var value = getCriteriaOperation(criteria);
            if (!value) {
                value = AND_GROUP_OPERATION
            }
            if (criteria !== group) {
                value = "!" + value
            }
            return value
        }

        function getDefaultFilterOperations(field) {
            return field.lookup && LOOKUP_OPERATIONS || DATATYPE_OPERATIONS[field.dataType || DEFAULT_DATA_TYPE]
        }

        function containItems(entity) {
            return Array.isArray(entity) && entity.length
        }

        function getFilterOperations(field) {
            var result = containItems(field.filterOperations) ? field.filterOperations : getDefaultFilterOperations(field);
            return (0, _extend.extend)([], result)
        }

        function getCaptionByOperation(operation, filterOperationDescriptions) {
            var operationName = _ui2.default.getNameByFilterOperation(operation);
            return filterOperationDescriptions && filterOperationDescriptions[operationName] ? filterOperationDescriptions[operationName] : operationName
        }

        function getOperationFromAvailable(operation, availableOperations) {
            for (var i = 0; i < availableOperations.length; i++) {
                if (availableOperations[i].value === operation) {
                    return availableOperations[i]
                }
            }
            throw new _ui.default.Error("E1048", operation)
        }

        function getCustomOperation(customOperations, name) {
            var filteredOperations = customOperations.filter(function(item) {
                return item.name === name
            });
            return filteredOperations.length ? filteredOperations[0] : null
        }

        function getAvailableOperations(field, filterOperationDescriptions, customOperations) {
            var filterOperations = getFilterOperations(field);
            var isLookupField = !!field.lookup;
            customOperations.forEach(function(customOperation) {
                if (!field.filterOperations && filterOperations.indexOf(customOperation.name) === -1) {
                    var dataTypes = customOperation && customOperation.dataTypes;
                    var isOperationForbidden = isLookupField ? !!customOperation.notForLookup : false;
                    if (!isOperationForbidden && dataTypes && dataTypes.indexOf(field.dataType || DEFAULT_DATA_TYPE) >= 0) {
                        filterOperations.push(customOperation.name)
                    }
                }
            });
            return filterOperations.map(function(operation) {
                var customOperation = getCustomOperation(customOperations, operation);
                if (customOperation) {
                    return {
                        icon: customOperation.icon || EMPTY_MENU_ICON,
                        text: customOperation.caption || (0, _inflector.captionize)(customOperation.name),
                        value: customOperation.name,
                        isCustom: true
                    }
                } else {
                    return {
                        icon: _ui2.default.getIconByFilterOperation(operation) || EMPTY_MENU_ICON,
                        text: getCaptionByOperation(operation, filterOperationDescriptions),
                        value: operation
                    }
                }
            })
        }

        function getDefaultOperation(field) {
            return field.defaultFilterOperation || getFilterOperations(field)[0]
        }

        function createCondition(field, customOperations) {
            var condition = [field.dataField, "", ""];
            var filterOperation = getDefaultOperation(field);
            updateConditionByOperation(condition, filterOperation, customOperations);
            return condition
        }

        function removeItem(group, item) {
            var criteria = getGroupCriteria(group);
            var index = criteria.indexOf(item);
            criteria.splice(index, 1);
            if (1 !== criteria.length) {
                criteria.splice(index, 1)
            }
            return group
        }

        function createEmptyGroup(value) {
            return value.indexOf("not") !== -1 ? ["!", [value.substring(3).toLowerCase()]] : [value]
        }

        function isEmptyGroup(group) {
            var criteria = getGroupCriteria(group);
            if (isCondition(criteria)) {
                return false
            }
            var hasConditions = criteria.some(function(item) {
                return isCondition(item)
            });
            return !hasConditions
        }

        function addItem(item, group) {
            var criteria = getGroupCriteria(group);
            var groupValue = getGroupValue(criteria);
            1 === criteria.length ? criteria.unshift(item) : criteria.push(item, groupValue);
            return group
        }

        function getField(dataField, fields) {
            for (var i = 0; i < fields.length; i++) {
                if (fields[i].name === dataField) {
                    return fields[i]
                }
                if (fields[i].dataField.toLowerCase() === dataField.toLowerCase()) {
                    return fields[i]
                }
            }
            var extendedFields = getItems(fields, true).filter(function(item) {
                return item.dataField.toLowerCase() === dataField.toLowerCase()
            });
            if (extendedFields.length > 0) {
                return extendedFields[0]
            }
            throw new _ui.default.Error("E1047", dataField)
        }

        function isGroup(criteria) {
            if (!Array.isArray(criteria)) {
                return false
            }
            return criteria.length < 2 || Array.isArray(criteria[0]) || Array.isArray(criteria[1])
        }

        function isCondition(criteria) {
            if (!Array.isArray(criteria)) {
                return false
            }
            return criteria.length > 1 && !Array.isArray(criteria[0]) && !Array.isArray(criteria[1])
        }

        function convertToInnerGroup(group, customOperations) {
            var groupOperation = getCriteriaOperation(group).toLowerCase() || AND_GROUP_OPERATION;
            var innerGroup = [];
            for (var i = 0; i < group.length; i++) {
                if (isGroup(group[i])) {
                    innerGroup.push(convertToInnerStructure(group[i], customOperations));
                    innerGroup.push(groupOperation)
                } else {
                    if (isCondition(group[i])) {
                        innerGroup.push(convertToInnerCondition(group[i], customOperations));
                        innerGroup.push(groupOperation)
                    }
                }
            }
            if (0 === innerGroup.length) {
                innerGroup.push(groupOperation)
            }
            return innerGroup
        }

        function conditionHasCustomOperation(condition, customOperations) {
            var customOperation = getCustomOperation(customOperations, condition[1]);
            return customOperation && customOperation.name === condition[1]
        }

        function convertToInnerCondition(condition, customOperations) {
            if (conditionHasCustomOperation(condition, customOperations)) {
                return condition
            }
            if (condition.length < 3) {
                condition[2] = condition[1];
                condition[1] = EQUAL_OPERATION
            }
            return condition
        }

        function convertToInnerStructure(value, customOperations) {
            if (!value) {
                return [AND_GROUP_OPERATION]
            }
            value = (0, _extend.extend)(true, [], value);
            if (isCondition(value)) {
                return [convertToInnerCondition(value, customOperations), AND_GROUP_OPERATION]
            }
            if (isNegationGroup(value)) {
                return ["!", isCondition(value[1]) ? [convertToInnerCondition(value[1], customOperations), AND_GROUP_OPERATION] : isNegationGroup(value[1]) ? [convertToInnerStructure(value[1], customOperations), AND_GROUP_OPERATION] : convertToInnerGroup(value[1], customOperations)]
            }
            return convertToInnerGroup(value, customOperations)
        }

        function getNormalizedFields(fields) {
            return fields.reduce(function(result, field) {
                if ((0, _type.isDefined)(field.dataField)) {
                    var normalizedField = {};
                    for (var key in field) {
                        if (field[key] && AVAILABLE_FIELD_PROPERTIES.indexOf(key) > -1) {
                            normalizedField[key] = field[key]
                        }
                    }
                    normalizedField.defaultCalculateFilterExpression = _filtering.default.defaultCalculateFilterExpression;
                    if (!(0, _type.isDefined)(normalizedField.dataType)) {
                        normalizedField.dataType = DEFAULT_DATA_TYPE
                    }
                    if (!(0, _type.isDefined)(normalizedField.trueText)) {
                        normalizedField.trueText = _message.default.format("dxDataGrid-trueText")
                    }
                    if (!(0, _type.isDefined)(normalizedField.falseText)) {
                        normalizedField.falseText = _message.default.format("dxDataGrid-falseText")
                    }
                    result.push(normalizedField)
                }
                return result
            }, [])
        }

        function getConditionFilterExpression(condition, fields, customOperations, target) {
            var field = getField(condition[0], fields);
            var filterExpression = convertToInnerCondition(condition, customOperations);
            var customOperation = customOperations.length && getCustomOperation(customOperations, filterExpression[1]);
            if (customOperation && customOperation.calculateFilterExpression) {
                return customOperation.calculateFilterExpression.apply(customOperation, [filterExpression[2], field, fields])
            } else {
                if (field.createFilterExpression) {
                    return field.createFilterExpression.apply(field, [filterExpression[2], filterExpression[1], target])
                } else {
                    if (field.calculateFilterExpression) {
                        return field.calculateFilterExpression.apply(field, [filterExpression[2], filterExpression[1], target])
                    } else {
                        return field.defaultCalculateFilterExpression.apply(field, [filterExpression[2], filterExpression[1], target])
                    }
                }
            }
        }

        function getFilterExpression(value, fields, customOperations, target) {
            if (!(0, _type.isDefined)(value)) {
                return null
            }
            if (isNegationGroup(value)) {
                var filterExpression = getFilterExpression(value[1], fields, customOperations, target);
                return ["!", filterExpression]
            }
            var criteria = getGroupCriteria(value);
            if (isCondition(criteria)) {
                return getConditionFilterExpression(criteria, fields, customOperations, target) || null
            } else {
                var result = [];
                var _filterExpression;
                var groupValue = getGroupValue(criteria);
                for (var i = 0; i < criteria.length; i++) {
                    if (isGroup(criteria[i])) {
                        _filterExpression = getFilterExpression(criteria[i], fields, customOperations, target);
                        if (_filterExpression) {
                            i && result.push(groupValue);
                            result.push(_filterExpression)
                        }
                    } else {
                        if (isCondition(criteria[i])) {
                            _filterExpression = getConditionFilterExpression(criteria[i], fields, customOperations, target);
                            if (_filterExpression) {
                                result.length && result.push(groupValue);
                                result.push(_filterExpression)
                            }
                        }
                    }
                }
                if (1 === result.length) {
                    result = result[0]
                }
                return result.length ? result : null
            }
        }

        function getNormalizedFilter(group) {
            var criteria = getGroupCriteria(group);
            var i;
            if (0 === criteria.length) {
                return null
            }
            var itemsForRemove = [];
            for (i = 0; i < criteria.length; i++) {
                if (isGroup(criteria[i])) {
                    var normalizedGroupValue = getNormalizedFilter(criteria[i]);
                    if (normalizedGroupValue) {
                        criteria[i] = normalizedGroupValue
                    } else {
                        itemsForRemove.push(criteria[i])
                    }
                } else {
                    if (isCondition(criteria[i])) {
                        if (!isValidCondition(criteria[i])) {
                            itemsForRemove.push(criteria[i])
                        }
                    }
                }
            }
            for (i = 0; i < itemsForRemove.length; i++) {
                removeItem(criteria, itemsForRemove[i])
            }
            if (1 === criteria.length) {
                return null
            }
            criteria.splice(criteria.length - 1, 1);
            if (1 === criteria.length) {
                group = setGroupCriteria(group, criteria[0])
            }
            if (0 === group.length) {
                return null
            }
            return group
        }

        function getCurrentLookupValueText(field, value, handler) {
            if ("" === value) {
                handler("");
                return
            }
            var lookup = field.lookup;
            if (lookup.items) {
                handler(lookup.calculateCellValue(value) || "")
            } else {
                var lookupDataSource = (0, _type.isFunction)(lookup.dataSource) ? lookup.dataSource({}) : lookup.dataSource;
                var dataSource = new _data_source.DataSource(lookupDataSource);
                dataSource.loadSingle(lookup.valueExpr, value).done(function(result) {
                    var valueText = "";
                    if (result) {
                        valueText = lookup.displayExpr ? (0, _data.compileGetter)(lookup.displayExpr)(result) : result
                    }
                    if (field.customizeText) {
                        valueText = field.customizeText({
                            value: value,
                            valueText: valueText
                        })
                    }
                    handler(valueText)
                }).fail(function() {
                    handler("")
                })
            }
        }

        function getPrimitiveValueText(field, value, customOperation, target) {
            var valueText;
            if (true === value) {
                valueText = field.trueText || _message.default.format("dxDataGrid-trueText")
            } else {
                if (false === value) {
                    valueText = field.falseText || _message.default.format("dxDataGrid-falseText")
                } else {
                    valueText = getFormattedValueText(field, value)
                }
            }
            if (field.customizeText) {
                valueText = field.customizeText.call(field, {
                    value: value,
                    valueText: valueText,
                    target: target
                })
            }
            if (customOperation && customOperation.customizeText) {
                valueText = customOperation.customizeText.call(customOperation, {
                    value: value,
                    valueText: valueText,
                    field: field,
                    target: target
                })
            }
            return valueText
        }

        function getArrayValueText(field, value, customOperation, target) {
            return value.map(function(v) {
                return getPrimitiveValueText(field, v, customOperation, target)
            })
        }

        function checkDefaultValue(value) {
            return "" === value || null === value
        }

        function getCurrentValueText(field, value, customOperation) {
            var target = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "filterBuilder";
            if (checkDefaultValue(value)) {
                return ""
            }
            if (Array.isArray(value)) {
                var result = new _deferred.Deferred;
                _deferred.when.apply(this, getArrayValueText(field, value, customOperation, target)).done(function() {
                    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key]
                    }
                    var text = args.some(function(item) {
                        return !checkDefaultValue(item)
                    }) ? args.map(function(item) {
                        return !checkDefaultValue(item) ? item : "?"
                    }) : "";
                    result.resolve(text)
                });
                return result
            } else {
                return getPrimitiveValueText(field, value, customOperation, target)
            }
        }

        function itemExists(plainItems, parentId) {
            return plainItems.some(function(item) {
                return item.dataField === parentId
            })
        }

        function pushItemAndCheckParent(originalItems, plainItems, item) {
            var dataField = item.dataField;
            if (hasParent(dataField)) {
                item.parentId = getParentIdFromItemDataField(dataField);
                if (!itemExists(plainItems, item.parentId) && !itemExists(originalItems, item.parentId)) {
                    pushItemAndCheckParent(originalItems, plainItems, {
                        id: item.parentId,
                        dataType: "object",
                        dataField: item.parentId,
                        caption: generateCaptionByDataField(item.parentId, true),
                        filterOperations: ["isblank", "isnotblank"]
                    })
                }
            }
            plainItems.push(item)
        }

        function generateCaptionByDataField(dataField, allowHierarchicalFields) {
            var caption = "";
            if (allowHierarchicalFields) {
                dataField = dataField.substring(dataField.lastIndexOf(".") + 1)
            } else {
                if (hasParent(dataField)) {
                    dataField.split(".").forEach(function(field, index, arr) {
                        caption += (0, _inflector.captionize)(field);
                        if (index !== arr.length - 1) {
                            caption += "."
                        }
                    });
                    return caption
                }
            }
            return (0, _inflector.captionize)(dataField)
        }

        function getItems(fields, allowHierarchicalFields) {
            var items = [];
            for (var i = 0; i < fields.length; i++) {
                var item = (0, _extend.extend)(true, {
                    caption: generateCaptionByDataField(fields[i].dataField, allowHierarchicalFields)
                }, fields[i]);
                item.id = item.name || item.dataField;
                if (allowHierarchicalFields) {
                    pushItemAndCheckParent(fields, items, item)
                } else {
                    items.push(item)
                }
            }
            return items
        }

        function hasParent(dataField) {
            return dataField.lastIndexOf(".") !== -1
        }

        function getParentIdFromItemDataField(dataField) {
            return dataField.substring(0, dataField.lastIndexOf("."))
        }

        function getCaptionWithParents(item, plainItems) {
            if (hasParent(item.dataField)) {
                var parentId = getParentIdFromItemDataField(item.dataField);
                for (var i = 0; i < plainItems.length; i++) {
                    if (plainItems[i].dataField === parentId) {
                        return getCaptionWithParents(plainItems[i], plainItems) + "." + item.caption
                    }
                }
            }
            return item.caption
        }

        function updateConditionByOperation(condition, operation, customOperations) {
            var customOperation = getCustomOperation(customOperations, operation);
            if (customOperation) {
                if (false === customOperation.hasValue) {
                    condition[1] = operation;
                    condition.length = 2
                } else {
                    condition[1] = operation;
                    condition[2] = ""
                }
                return condition
            }
            if ("isblank" === operation) {
                condition[1] = EQUAL_OPERATION;
                condition[2] = null
            } else {
                if ("isnotblank" === operation) {
                    condition[1] = NOT_EQUAL_OPERATION;
                    condition[2] = null
                } else {
                    customOperation = getCustomOperation(customOperations, condition[1]);
                    if (customOperation || 2 === condition.length || null === condition[2]) {
                        condition[2] = ""
                    }
                    condition[1] = operation
                }
            }
            return condition
        }

        function getOperationValue(condition) {
            var caption;
            if (null === condition[2]) {
                if (condition[1] === EQUAL_OPERATION) {
                    caption = "isblank"
                } else {
                    caption = "isnotblank"
                }
            } else {
                caption = condition[1]
            }
            return caption
        }

        function isValidCondition(condition) {
            return "" !== condition[2]
        }

        function getMergedOperations(customOperations, betweenCaption, context) {
            var result = (0, _extend.extend)(true, [], customOperations);
            var betweenIndex = -1;
            result.some(function(customOperation, index) {
                if ("between" === customOperation.name) {
                    betweenIndex = index;
                    return true
                }
            });
            if (betweenIndex !== -1) {
                result[betweenIndex] = (0, _extend.extend)((0, _between.getConfig)(betweenCaption, context), result[betweenIndex])
            } else {
                result.unshift((0, _between.getConfig)(betweenCaption, context))
            }
            return result
        }

        function isMatchedCondition(filter, addedFilterDataField) {
            return filter[0] === addedFilterDataField
        }

        function removeFieldConditionsFromFilter(filter, dataField) {
            if (!filter || 0 === filter.length) {
                return null
            }
            if (isCondition(filter)) {
                var hasMatchedCondition = isMatchedCondition(filter, dataField);
                return !hasMatchedCondition ? filter : null
            } else {
                return syncConditionIntoGroup(filter, [dataField], false)
            }
        }

        function syncConditionIntoGroup(filter, addedFilter, canPush) {
            var result = [];
            filter.forEach(function(item) {
                if (isCondition(item)) {
                    if (isMatchedCondition(item, addedFilter[0])) {
                        if (canPush) {
                            result.push(addedFilter);
                            canPush = false
                        } else {
                            result.splice(result.length - 1, 1)
                        }
                    } else {
                        result.push(item)
                    }
                } else {
                    (result.length || isGroup(item)) && result.push(item)
                }
            });
            if (0 === result.length) {
                return null
            }
            if (canPush) {
                result.push(AND_GROUP_OPERATION);
                result.push(addedFilter)
            }
            return 1 === result.length ? result[0] : result
        }

        function syncFilters(filter, addedFilter) {
            if (null === filter || 0 === filter.length) {
                return addedFilter
            }
            if (isCondition(filter)) {
                if (isMatchedCondition(filter, addedFilter[0])) {
                    return addedFilter
                } else {
                    return [filter, AND_GROUP_OPERATION, addedFilter]
                }
            }
            var groupValue = getGroupValue(filter);
            if (groupValue !== AND_GROUP_OPERATION) {
                return [addedFilter, "and", filter]
            }
            return syncConditionIntoGroup(filter, addedFilter, true)
        }

        function getMatchedConditions(filter, dataField) {
            if (null === filter || 0 === filter.length) {
                return []
            }
            if (isCondition(filter)) {
                if (isMatchedCondition(filter, dataField)) {
                    return [filter]
                } else {
                    return []
                }
            }
            var groupValue = getGroupValue(filter);
            if (groupValue !== AND_GROUP_OPERATION) {
                return []
            }
            var result = filter.filter(function(item) {
                return isCondition(item) && isMatchedCondition(item, dataField)
            });
            return result
        }

        function filterHasField(filter, dataField) {
            if (null === filter || 0 === filter.length) {
                return false
            }
            if (isCondition(filter)) {
                return filter[0] === dataField
            }
            return filter.some(function(item) {
                return (isCondition(item) || isGroup(item)) && filterHasField(item, dataField)
            })
        }
        var renderValueText = function($container, value, customOperation) {
            if (Array.isArray(value)) {
                var lastItemIndex = value.length - 1;
                $container.empty();
                value.forEach(function(t, i) {
                    (0, _renderer.default)("<span>").addClass(FILTER_BUILDER_ITEM_TEXT_PART_CLASS).text(t).appendTo($container);
                    if (i !== lastItemIndex) {
                        (0, _renderer.default)("<span>").addClass(FILTER_BUILDER_ITEM_TEXT_SEPARATOR_CLASS).text(customOperation && customOperation.valueSeparator ? customOperation.valueSeparator : "|").addClass(FILTER_BUILDER_ITEM_TEXT_SEPARATOR_EMPTY_CLASS).appendTo($container)
                    }
                })
            } else {
                if (value) {
                    $container.text(value)
                } else {
                    $container.text(_message.default.format("dxFilterBuilder-enterValueText"))
                }
            }
        };
        exports.renderValueText = renderValueText
    },
    /*!**************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/index.js ***!
      \**************************************************/
    /*! exports provided: rrulestr, Frequency, Weekday, RRule, RRuleSet, default */
    /*! all exports used */
    function(module, __webpack_exports__, __webpack_require__) {
        Object.defineProperty(__webpack_exports__, "__esModule", {
            value: true
        });
        var __WEBPACK_IMPORTED_MODULE_0__rrule__ = __webpack_require__( /*! ./rrule */ 119);
        var __WEBPACK_IMPORTED_MODULE_1__rruleset__ = __webpack_require__( /*! ./rruleset */ 432);
        var __WEBPACK_IMPORTED_MODULE_2__rrulestr__ = __webpack_require__( /*! ./rrulestr */ 433);
        __webpack_require__.d(__webpack_exports__, "rrulestr", function() {
            return __WEBPACK_IMPORTED_MODULE_2__rrulestr__.a
        });
        var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__( /*! ./types */ 140);
        __webpack_require__.d(__webpack_exports__, "Frequency", function() {
            return __WEBPACK_IMPORTED_MODULE_3__types__.a
        });
        var __WEBPACK_IMPORTED_MODULE_4__weekday__ = __webpack_require__( /*! ./weekday */ 159);
        __webpack_require__.d(__webpack_exports__, "Weekday", function() {
            return __WEBPACK_IMPORTED_MODULE_4__weekday__.b
        });
        __webpack_require__.d(__webpack_exports__, "RRule", function() {
            return __WEBPACK_IMPORTED_MODULE_0__rrule__.c
        });
        __webpack_require__.d(__webpack_exports__, "RRuleSet", function() {
            return __WEBPACK_IMPORTED_MODULE_1__rruleset__.a
        });
        /*!
         * rrule.js - Library for working with recurrence rules for calendar dates.
         * https://github.com/jakubroztocil/rrule
         *
         * Copyright 2010, Jakub Roztocil and Lars Schoning
         * Licenced under the BSD licence.
         * https://github.com/jakubroztocil/rrule/blob/master/LICENCE
         *
         * Based on:
         * python-dateutil - Extensions to the standard Python datetime module.
         * Copyright (c) 2003-2011 - Gustavo Niemeyer <gustavo@niemeyer.net>
         * Copyright (c) 2012 - Tomi Pieviläinen <tomi.pievilainen@iki.fi>
         * https://github.com/jakubroztocil/rrule/blob/master/LICENCE
         *
         */
        __webpack_exports__.default = __WEBPACK_IMPORTED_MODULE_0__rrule__.c
    },
    /*!*******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/ui.scheduler.publisher_mixin.js ***!
      \*******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var publisherMixin = {
            notifyObserver: function(subject, args) {
                var observer = this.option("observer");
                if (observer) {
                    observer.fire(subject, args)
                }
            },
            invoke: function() {
                var observer = this.option("observer");
                if (observer) {
                    return observer.fire.apply(observer, arguments)
                }
            }
        };
        var _default = publisherMixin;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/utils/combine_classes.js ***!
      \**********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.combineClasses = combineClasses;

        function combineClasses(classesMap) {
            return Object.keys(classesMap).filter(function(p) {
                return classesMap[p]
            }).join(" ")
        }
    },
    /*!*********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/ui/scheduler/workspaces/base/row.js ***!
      \*********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.Row = Row;
        exports.RowProps = exports.viewFunction = void 0;
        var Preact = _interopRequireWildcard(__webpack_require__( /*! preact */ 50));
        var _hooks = __webpack_require__( /*! preact/hooks */ 53);

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function _objectWithoutProperties(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = _objectWithoutPropertiesLoose(source, excluded);
            var key, i;
            if (Object.getOwnPropertySymbols) {
                var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
                for (i = 0; i < sourceSymbolKeys.length; i++) {
                    key = sourceSymbolKeys[i];
                    if (excluded.indexOf(key) >= 0) {
                        continue
                    }
                    if (!Object.prototype.propertyIsEnumerable.call(source, key)) {
                        continue
                    }
                    target[key] = source[key]
                }
            }
            return target
        }

        function _objectWithoutPropertiesLoose(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = {};
            var sourceKeys = Object.keys(source);
            var key, i;
            for (i = 0; i < sourceKeys.length; i++) {
                key = sourceKeys[i];
                if (excluded.indexOf(key) >= 0) {
                    continue
                }
                target[key] = source[key]
            }
            return target
        }

        function _extends() {
            _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key]
                        }
                    }
                }
                return target
            };
            return _extends.apply(this, arguments)
        }
        var viewFunction = function(viewModel) {
            return Preact.h("tr", _extends({}, viewModel.restAttributes, {
                className: viewModel.props.className
            }), viewModel.props.children)
        };
        exports.viewFunction = viewFunction;
        var RowProps = {
            className: ""
        };
        exports.RowProps = RowProps;

        function Row(props) {
            var __restAttributes = (0, _hooks.useCallback)(function() {
                var restProps = (props.children, props.className, _objectWithoutProperties(props, ["children", "className"]));
                return restProps
            }, [props]);
            return viewFunction({
                props: _objectSpread({}, props),
                restAttributes: __restAttributes()
            })
        }
        Row.defaultProps = _objectSpread({}, RowProps)
    },
    /*!***********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/components/legend.js ***!
      \***********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.plugin = exports.Legend = void 0;
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _extend2 = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _layout_element = __webpack_require__( /*! ../core/layout_element */ 311);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _title = __webpack_require__( /*! ../core/title */ 121);
        var _object = __webpack_require__( /*! ../../core/utils/object */ 51);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _renderer = __webpack_require__( /*! ../core/renderers/renderer */ 177);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _Number = Number;
        var _math = Math;
        var _round = _math.round;
        var _max = _math.max;
        var _min = _math.min;
        var _ceil = _math.ceil;
        var _isDefined = _type.isDefined;
        var _isFunction = _type.isFunction;
        var _enumParser = _utils.enumParser;
        var _normalizeEnum = _utils.normalizeEnum;
        var _extend = _extend2.extend;
        var DEFAULT_MARGIN = 10;
        var DEFAULT_MARKER_HATCHING_WIDTH = 2;
        var DEFAULT_MARKER_HATCHING_STEP = 5;
        var CENTER = "center";
        var RIGHT = "right";
        var LEFT = "left";
        var TOP = "top";
        var BOTTOM = "bottom";
        var HORIZONTAL = "horizontal";
        var VERTICAL = "vertical";
        var INSIDE = "inside";
        var OUTSIDE = "outside";
        var NONE = "none";
        var HEIGHT = "height";
        var WIDTH = "width";
        var parseHorizontalAlignment = _enumParser([LEFT, CENTER, RIGHT]);
        var parseVerticalAlignment = _enumParser([TOP, BOTTOM]);
        var parseOrientation = _enumParser([VERTICAL, HORIZONTAL]);
        var parseItemTextPosition = _enumParser([LEFT, RIGHT, TOP, BOTTOM]);
        var parsePosition = _enumParser([OUTSIDE, INSIDE]);
        var parseItemsAlignment = _enumParser([LEFT, CENTER, RIGHT]);

        function getState(state, color, stateName) {
            if (!state) {
                return
            }
            var colorFromAction = state.fill;
            return (0, _extend2.extend)({}, {
                state: stateName,
                fill: colorFromAction === NONE ? color : colorFromAction,
                opacity: state.opacity,
                hatching: _extend({}, state.hatching, {
                    step: DEFAULT_MARKER_HATCHING_STEP,
                    width: DEFAULT_MARKER_HATCHING_WIDTH
                })
            })
        }

        function getAttributes(item, state, size) {
            var attrs = (0, _renderer.processHatchingAttrs)(item, state);
            if (attrs.fill && 0 === attrs.fill.indexOf("DevExpress")) {
                attrs.fill = (0, _renderer.getFuncIri)(attrs.fill)
            }
            attrs.opacity = attrs.opacity >= 0 ? attrs.opacity : 1;
            return (0, _extend2.extend)({}, attrs, {
                size: size
            })
        }

        function parseMargins(options) {
            var margin = options.margin;
            if (margin >= 0) {
                margin = _Number(options.margin);
                margin = {
                    top: margin,
                    bottom: margin,
                    left: margin,
                    right: margin
                }
            } else {
                margin = {
                    top: margin.top >= 0 ? _Number(margin.top) : DEFAULT_MARGIN,
                    bottom: margin.bottom >= 0 ? _Number(margin.bottom) : DEFAULT_MARGIN,
                    left: margin.left >= 0 ? _Number(margin.left) : DEFAULT_MARGIN,
                    right: margin.right >= 0 ? _Number(margin.right) : DEFAULT_MARGIN
                }
            }
            options.margin = margin
        }

        function getSizeItem(options, markerBBox, labelBBox) {
            var defaultXMargin = 7;
            var defaultTopMargin = 4;
            var width;
            var height;
            switch (options.itemTextPosition) {
                case LEFT:
                case RIGHT:
                    width = markerBBox.width + defaultXMargin + labelBBox.width;
                    height = _max(markerBBox.height, labelBBox.height);
                    break;
                case TOP:
                case BOTTOM:
                    width = _max(markerBBox.width, labelBBox.width);
                    height = markerBBox.height + defaultTopMargin + labelBBox.height
            }
            return {
                width: width,
                height: height
            }
        }

        function calculateBBoxLabelAndMarker(markerBBox, labelBBox) {
            var bBox = {};
            bBox.left = _min(markerBBox.x, labelBBox.x);
            bBox.top = _min(markerBBox.y, labelBBox.y);
            bBox.right = _max(markerBBox.x + markerBBox.width, labelBBox.x + labelBBox.width);
            bBox.bottom = _max(markerBBox.y + markerBBox.height, labelBBox.y + labelBBox.height);
            return bBox
        }

        function applyMarkerState(id, idToIndexMap, items, stateName) {
            var item = idToIndexMap && items[idToIndexMap[id]];
            if (item) {
                item.renderMarker(item.states[stateName])
            }
        }

        function parseOptions(options, textField, allowInsidePosition) {
            if (!options) {
                return null
            }
            parseMargins(options);
            options.horizontalAlignment = parseHorizontalAlignment(options.horizontalAlignment, RIGHT);
            options.verticalAlignment = parseVerticalAlignment(options.verticalAlignment, options.horizontalAlignment === CENTER ? BOTTOM : TOP);
            options.orientation = parseOrientation(options.orientation, options.horizontalAlignment === CENTER ? HORIZONTAL : VERTICAL);
            options.itemTextPosition = parseItemTextPosition(options.itemTextPosition, options.orientation === HORIZONTAL ? BOTTOM : RIGHT);
            options.position = allowInsidePosition ? parsePosition(options.position, OUTSIDE) : OUTSIDE;
            options.itemsAlignment = parseItemsAlignment(options.itemsAlignment, null);
            options.hoverMode = _normalizeEnum(options.hoverMode);
            options.customizeText = _isFunction(options.customizeText) ? options.customizeText : function() {
                return this[textField]
            };
            options.customizeHint = _isFunction(options.customizeHint) ? options.customizeHint : _common.noop;
            options._incidentOccurred = options._incidentOccurred || _common.noop;
            return options
        }

        function createSquareMarker(renderer, size) {
            return renderer.rect(0, 0, size, size)
        }

        function createCircleMarker(renderer, size) {
            return renderer.circle(size / 2, size / 2, size / 2)
        }

        function isCircle(type) {
            return "circle" === _normalizeEnum(type)
        }

        function inRect(rect, x, y) {
            return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom
        }

        function checkLinesSize(lines, layoutOptions, countItems, margins) {
            var position = {
                x: 0,
                y: 0
            };
            var maxMeasureLength = 0;
            var maxAltMeasureLength = 0;
            var margin = 0;
            if ("y" === layoutOptions.direction) {
                margin = margins.top + margins.bottom
            } else {
                margin = margins.left + margins.right
            }
            lines.forEach(function(line, i) {
                var firstItem = line[0];
                var lineLength = line.length;
                line.forEach(function(item, index) {
                    var offset = item.offset || layoutOptions.spacing;
                    position[layoutOptions.direction] += item[layoutOptions.measure] + (index !== lineLength - 1 ? offset : 0);
                    maxMeasureLength = _max(maxMeasureLength, position[layoutOptions.direction])
                });
                position[layoutOptions.direction] = 0;
                position[layoutOptions.altDirection] += firstItem[layoutOptions.altMeasure] + firstItem.altOffset || layoutOptions.altSpacing;
                maxAltMeasureLength = _max(maxAltMeasureLength, position[layoutOptions.altDirection])
            });
            if (maxMeasureLength + margin > layoutOptions.length) {
                layoutOptions.countItem = decreaseItemCount(layoutOptions, countItems);
                return true
            }
        }

        function decreaseItemCount(layoutOptions, countItems) {
            layoutOptions.altCountItem++;
            return _ceil(countItems / layoutOptions.altCountItem)
        }

        function getLineLength(line, layoutOptions) {
            return line.reduce(function(lineLength, item) {
                var offset = item.offset || layoutOptions.spacing;
                return lineLength + item[layoutOptions.measure] + offset
            }, 0)
        }

        function getMaxLineLength(lines, layoutOptions) {
            return lines.reduce(function(maxLineLength, line) {
                return _max(maxLineLength, getLineLength(line, layoutOptions))
            }, 0)
        }

        function getInitPositionForDirection(line, layoutOptions, maxLineLength) {
            var lineLength = getLineLength(line, layoutOptions);
            var initPosition;
            switch (layoutOptions.itemsAlignment) {
                case RIGHT:
                    initPosition = maxLineLength - lineLength;
                    break;
                case CENTER:
                    initPosition = (maxLineLength - lineLength) / 2;
                    break;
                default:
                    initPosition = 0
            }
            return initPosition
        }

        function getPos(layoutOptions) {
            switch (layoutOptions.itemTextPosition) {
                case BOTTOM:
                    return {
                        horizontal: CENTER, vertical: TOP
                    };
                case TOP:
                    return {
                        horizontal: CENTER, vertical: BOTTOM
                    };
                case LEFT:
                    return {
                        horizontal: RIGHT, vertical: CENTER
                    };
                case RIGHT:
                    return {
                        horizontal: LEFT, vertical: CENTER
                    }
            }
        }

        function getLines(lines, layoutOptions, itemIndex) {
            var tableLine = {};
            if (itemIndex % layoutOptions.countItem === 0) {
                if (layoutOptions.markerOffset) {
                    lines.push([], [])
                } else {
                    lines.push([])
                }
            }
            if (layoutOptions.markerOffset) {
                tableLine.firstLine = lines[lines.length - 1];
                tableLine.secondLine = lines[lines.length - 2]
            } else {
                tableLine.firstLine = tableLine.secondLine = lines[lines.length - 1]
            }
            return tableLine
        }

        function setMaxInLine(line, measure) {
            var maxLineSize = line.reduce(function(maxLineSize, item) {
                var itemMeasure = item ? item[measure] : maxLineSize;
                return _max(maxLineSize, itemMeasure)
            }, 0);
            line.forEach(function(item) {
                if (item) {
                    item[measure] = maxLineSize
                }
            })
        }

        function transpose(array) {
            var width = array.length;
            var height = array[0].length;
            var i;
            var j;
            var transposeArray = [];
            for (i = 0; i < height; i++) {
                transposeArray[i] = [];
                for (j = 0; j < width; j++) {
                    transposeArray[i][j] = array[j][i]
                }
            }
            return transposeArray
        }

        function getAlign(position) {
            switch (position) {
                case TOP:
                case BOTTOM:
                    return CENTER;
                case LEFT:
                    return RIGHT;
                case RIGHT:
                    return LEFT
            }
        }
        var getMarkerCreator = function(type) {
            return isCircle(type) ? createCircleMarker : createSquareMarker
        };

        function getTitleHorizontalAlignment(options) {
            if (options.horizontalAlignment === CENTER) {
                return CENTER
            } else {
                if (options.itemTextPosition === RIGHT) {
                    return LEFT
                } else {
                    if (options.itemTextPosition === LEFT) {
                        return RIGHT
                    } else {
                        return CENTER
                    }
                }
            }
        }
        var Legend = function(settings) {
            var that = this;
            that._renderer = settings.renderer;
            that._legendGroup = settings.group;
            that._backgroundClass = settings.backgroundClass;
            that._itemGroupClass = settings.itemGroupClass;
            that._textField = settings.textField;
            that._getCustomizeObject = settings.getFormatObject;
            that._titleGroupClass = settings.titleGroupClass;
            that._allowInsidePosition = settings.allowInsidePosition;
            that._widget = settings.widget;
            that._updated = false
        };
        exports.Legend = Legend;
        var _Legend = Legend;
        var legendPrototype = _Legend.prototype = (0, _object.clone)(_layout_element.LayoutElement.prototype);
        (0, _extend2.extend)(legendPrototype, {
            constructor: _Legend,
            getOptions: function() {
                return this._options
            },
            update: function() {
                var data = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
                var options = arguments.length > 1 ? arguments[1] : void 0;
                var themeManagerTitleOptions = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                var that = this;
                options = that._options = parseOptions(options, that._textField, that._allowInsidePosition) || {};
                var initMarkerSize = options.markerSize;
                this._updated = true;
                this._data = data.map(function(dataItem) {
                    dataItem.size = _Number(dataItem.size > 0 ? dataItem.size : initMarkerSize);
                    dataItem.marker = getAttributes(dataItem, dataItem.states.normal);
                    Object.defineProperty(dataItem.marker, "size", {
                        get: function() {
                            return dataItem.size
                        },
                        set: function(value) {
                            dataItem.size = value
                        }
                    });
                    Object.defineProperty(dataItem.marker, "opacity", {
                        get: function() {
                            return dataItem.states.normal.opacity
                        },
                        set: function(value) {
                            dataItem.states.normal.opacity = dataItem.states.hover.opacity = dataItem.states.selection.opacity = value
                        }
                    });
                    return dataItem
                });
                if (options.customizeItems) {
                    that._data = options.customizeItems(data.slice()) || data
                }
                that._boundingRect = {
                    width: 0,
                    height: 0,
                    x: 0,
                    y: 0
                };
                if (that.isVisible() && !that._title) {
                    that._title = new _title.Title({
                        renderer: that._renderer,
                        cssClass: that._titleGroupClass,
                        root: that._legendGroup
                    })
                }
                if (that._title) {
                    var titleOptions = options.title;
                    themeManagerTitleOptions.horizontalAlignment = getTitleHorizontalAlignment(options);
                    that._title.update(themeManagerTitleOptions, titleOptions)
                }
                this.erase();
                return that
            },
            isVisible: function() {
                return this._options && this._options.visible
            },
            draw: function(width, height) {
                var that = this;
                var items = that._getItemData();
                that.erase();
                if (!(that.isVisible() && items && items.length)) {
                    return that
                }
                that._insideLegendGroup = that._renderer.g().enableLinks().append(that._legendGroup);
                that._title.changeLink(that._insideLegendGroup);
                that._createBackground();
                if (that._title.hasText()) {
                    var horizontalPadding = that._background ? 2 * that._options.paddingLeftRight : 0;
                    that._title.draw(width - horizontalPadding, height)
                }
                that._markersGroup = that._renderer.g().attr({
                    "class": that._itemGroupClass
                }).append(that._insideLegendGroup);
                that._createItems(items);
                that._updateElementsPosition(width, height);
                return that
            },
            _measureElements: function() {
                var options = this._options;
                var maxBBoxHeight = 0;
                this._items.forEach(function(item) {
                    var labelBBox = item.label.getBBox();
                    var markerBBox = item.marker.getBBox();
                    item.markerBBox = markerBBox;
                    item.markerSize = Math.max(markerBBox.width, markerBBox.height);
                    var bBox = getSizeItem(options, markerBBox, labelBBox);
                    item.labelBBox = labelBBox;
                    item.bBox = bBox;
                    maxBBoxHeight = _max(maxBBoxHeight, bBox.height)
                });
                if (options.equalRowHeight) {
                    this._items.forEach(function(item) {
                        return item.bBox.height = maxBBoxHeight
                    })
                }
            },
            _updateElementsPosition: function(width, height) {
                var that = this;
                var options = that._options;
                this._size = {
                    width: width,
                    height: height
                };
                that._measureElements();
                that._locateElements(options);
                that._finalUpdate(options);
                var size = that.getLayoutOptions();
                if (size.width > width || size.height > height) {
                    that.freeSpace()
                }
            },
            _createItems: function(items) {
                var that = this;
                var options = that._options;
                var renderer = that._renderer;
                var createMarker = getMarkerCreator(options.markerShape);
                that._markersId = {};
                var templateFunction = !options.markerTemplate ? function(dataItem, group) {
                    var attrs = dataItem.marker;
                    createMarker(renderer, attrs.size).attr({
                        fill: attrs.fill,
                        opacity: attrs.opacity
                    }).append({
                        element: group
                    })
                } : options.markerTemplate;
                var template = that._widget._getTemplate(templateFunction);
                var markersGroup = that._markersGroup;
                markersGroup.css((0, _utils.patchFontOptions)(options.font));
                that._deferredItems = [];
                that._templatesGroups = [];
                that._items = (items || []).map(function(dataItem, i) {
                    var stateOfDataItem = dataItem.states;
                    var normalState = stateOfDataItem.normal;
                    var normalStateFill = normalState.fill;
                    dataItem.size = dataItem.marker.size;
                    var states = {
                        normal: (0, _extend2.extend)(normalState, {
                            fill: normalStateFill || options.markerColor || options.defaultColor,
                            state: "normal"
                        }),
                        hover: getState(stateOfDataItem.hover, normalStateFill, "hovered"),
                        selection: getState(stateOfDataItem.selection, normalStateFill, "selected")
                    };
                    dataItem.states = states;
                    var itemGroup = renderer.g().append(markersGroup);
                    var markerGroup = renderer.g().attr({
                        "class": "dxl-marker"
                    }).append(itemGroup);
                    that._deferredItems[i] = new _deferred.Deferred;
                    that._templatesGroups.push(markerGroup);
                    var item = {
                        label: that._createLabel(dataItem, itemGroup),
                        marker: markerGroup,
                        renderer: renderer,
                        group: itemGroup,
                        tracker: {
                            id: dataItem.id,
                            argument: dataItem.argument,
                            argumentIndex: dataItem.argumentIndex
                        },
                        states: states,
                        itemTextPosition: options.itemTextPosition,
                        markerOffset: 0,
                        bBoxes: [],
                        renderMarker: function(state) {
                            dataItem.marker = getAttributes(item, state, dataItem.size);
                            markerGroup.clear();
                            template.render({
                                model: dataItem,
                                container: markerGroup.element,
                                onRendered: that._deferredItems[i].resolve
                            })
                        }
                    };
                    item.renderMarker(states.normal);
                    that._createHint(dataItem, itemGroup);
                    if (void 0 !== dataItem.id) {
                        that._markersId[dataItem.id] = i
                    }
                    return item
                })
            },
            getTemplatesGroups: function() {
                return this._templatesGroups || []
            },
            getTemplatesDef: function() {
                return this._deferredItems || []
            },
            _getItemData: function() {
                var items = this._data || [];
                var options = this._options || {};
                if (options.inverted) {
                    items = items.slice().reverse()
                }
                return items.filter(function(i) {
                    return i.visible
                })
            },
            _finalUpdate: function(options) {
                this._adjustBackgroundSettings(options);
                this._setBoundingRect(options.margin)
            },
            erase: function() {
                var that = this;
                var insideLegendGroup = that._insideLegendGroup;
                insideLegendGroup && insideLegendGroup.dispose();
                that._insideLegendGroup = that._markersGroup = that._x1 = that._x2 = that._y2 = that._y2 = null;
                return that
            },
            _locateElements: function(locationOptions) {
                this._moveInInitialValues();
                this._locateRowsColumns(locationOptions)
            },
            _moveInInitialValues: function() {
                var that = this;
                that._title.hasText() && that._title.move([0, 0]);
                that._legendGroup && that._legendGroup.move(0, 0);
                that._background && that._background.attr({
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                })
            },
            applySelected: function(id) {
                applyMarkerState(id, this._markersId, this._items, "selection");
                return this
            },
            applyHover: function(id) {
                applyMarkerState(id, this._markersId, this._items, "hover");
                return this
            },
            resetItem: function(id) {
                applyMarkerState(id, this._markersId, this._items, "normal");
                return this
            },
            _createLabel: function(data, group) {
                var labelFormatObject = this._getCustomizeObject(data);
                var options = this._options;
                var align = getAlign(options.itemTextPosition);
                var text = options.customizeText.call(labelFormatObject, labelFormatObject);
                var fontStyle = _isDefined(data.textOpacity) ? {
                    color: options.font.color,
                    opacity: data.textOpacity
                } : {};
                return this._renderer.text(text, 0, 0).css((0, _utils.patchFontOptions)(fontStyle)).attr({
                    align: align,
                    "class": options.cssClass
                }).append(group)
            },
            _createHint: function(data, group) {
                var labelFormatObject = this._getCustomizeObject(data);
                var text = this._options.customizeHint.call(labelFormatObject, labelFormatObject);
                if (_isDefined(text) && "" !== text) {
                    group.setTitle(text)
                }
            },
            _createBackground: function() {
                var that = this;
                var isInside = that._options.position === INSIDE;
                var color = that._options.backgroundColor;
                var fill = color || (isInside ? that._options.containerBackgroundColor : NONE);
                if (that._options.border.visible || (isInside || color) && color !== NONE) {
                    that._background = that._renderer.rect(0, 0, 0, 0).attr({
                        fill: fill,
                        "class": that._backgroundClass
                    }).append(that._insideLegendGroup)
                }
            },
            _locateRowsColumns: function(options) {
                var that = this;
                var iteration = 0;
                var layoutOptions = that._getItemsLayoutOptions();
                var countItems = that._items.length;
                var lines;
                do {
                    lines = [];
                    that._createLines(lines, layoutOptions);
                    that._alignLines(lines, layoutOptions);
                    iteration++
                } while (checkLinesSize(lines, layoutOptions, countItems, options.margin) && iteration < countItems);
                that._applyItemPosition(lines, layoutOptions)
            },
            _createLines: function(lines, layoutOptions) {
                this._items.forEach(function(item, i) {
                    var tableLine = getLines(lines, layoutOptions, i);
                    var labelBox = {
                        width: item.labelBBox.width,
                        height: item.labelBBox.height,
                        element: item.label,
                        bBox: item.labelBBox,
                        pos: getPos(layoutOptions),
                        itemIndex: i
                    };
                    var markerBox = {
                        width: item.markerBBox.width,
                        height: item.markerBBox.height,
                        element: item.marker,
                        pos: {
                            horizontal: CENTER,
                            vertical: CENTER
                        },
                        bBox: {
                            width: item.markerBBox.width,
                            height: item.markerBBox.height,
                            x: item.markerBBox.x,
                            y: item.markerBBox.y
                        },
                        itemIndex: i
                    };
                    var firstItem;
                    var secondItem;
                    var offsetDirection = layoutOptions.markerOffset ? "altOffset" : "offset";
                    if (layoutOptions.inverseLabelPosition) {
                        firstItem = labelBox;
                        secondItem = markerBox
                    } else {
                        firstItem = markerBox;
                        secondItem = labelBox
                    }
                    firstItem[offsetDirection] = layoutOptions.labelOffset;
                    tableLine.secondLine.push(firstItem);
                    tableLine.firstLine.push(secondItem)
                })
            },
            _alignLines: function(lines, layoutOptions) {
                var i;
                var measure = layoutOptions.altMeasure;
                lines.forEach(function(line) {
                    return setMaxInLine(line, measure)
                });
                measure = layoutOptions.measure;
                if (layoutOptions.itemsAlignment) {
                    if (layoutOptions.markerOffset) {
                        for (i = 0; i < lines.length;) {
                            transpose([lines[i++], lines[i++]]).forEach(processLine)
                        }
                    }
                } else {
                    transpose(lines).forEach(processLine)
                }

                function processLine(line) {
                    setMaxInLine(line, measure)
                }
            },
            _applyItemPosition: function(lines, layoutOptions) {
                var that = this;
                var position = {
                    x: 0,
                    y: 0
                };
                var maxLineLength = getMaxLineLength(lines, layoutOptions);
                lines.forEach(function(line) {
                    var firstItem = line[0];
                    var altOffset = firstItem.altOffset || layoutOptions.altSpacing;
                    position[layoutOptions.direction] = getInitPositionForDirection(line, layoutOptions, maxLineLength);
                    line.forEach(function(item) {
                        var offset = item.offset || layoutOptions.spacing;
                        var wrap = new _layout_element.WrapperLayoutElement(item.element, item.bBox);
                        var itemBBoxOptions = {
                            x: position.x,
                            y: position.y,
                            width: item.width,
                            height: item.height
                        };
                        var itemBBox = new _layout_element.WrapperLayoutElement(null, itemBBoxOptions);
                        var itemLegend = that._items[item.itemIndex];
                        wrap.position({
                            of: itemBBox,
                            my: item.pos,
                            at: item.pos
                        });
                        itemLegend.bBoxes.push(itemBBox);
                        position[layoutOptions.direction] += item[layoutOptions.measure] + offset
                    });
                    position[layoutOptions.altDirection] += firstItem[layoutOptions.altMeasure] + altOffset
                });
                this._items.forEach(function(item) {
                    var itemBBox = calculateBBoxLabelAndMarker(item.bBoxes[0].getLayoutOptions(), item.bBoxes[1].getLayoutOptions());
                    var horizontal = that._options.columnItemSpacing / 2;
                    var vertical = that._options.rowItemSpacing / 2;
                    item.tracker.left = itemBBox.left - horizontal;
                    item.tracker.right = itemBBox.right + horizontal;
                    item.tracker.top = itemBBox.top - vertical;
                    item.tracker.bottom = itemBBox.bottom + vertical
                })
            },
            _getItemsLayoutOptions: function() {
                var that = this;
                var options = that._options;
                var orientation = options.orientation;
                var layoutOptions = {
                    itemsAlignment: options.itemsAlignment,
                    orientation: options.orientation
                };
                var width = that._size.width - (that._background ? 2 * options.paddingLeftRight : 0);
                var height = that._size.height - (that._background ? 2 * options.paddingTopBottom : 0);
                if (orientation === HORIZONTAL) {
                    layoutOptions.length = width;
                    layoutOptions.spacing = options.columnItemSpacing;
                    layoutOptions.direction = "x";
                    layoutOptions.measure = WIDTH;
                    layoutOptions.altMeasure = HEIGHT;
                    layoutOptions.altDirection = "y";
                    layoutOptions.altSpacing = options.rowItemSpacing;
                    layoutOptions.countItem = options.columnCount;
                    layoutOptions.altCountItem = options.rowCount;
                    layoutOptions.marginTextLabel = 4;
                    layoutOptions.labelOffset = 7;
                    if (options.itemTextPosition === BOTTOM || options.itemTextPosition === TOP) {
                        layoutOptions.labelOffset = 4;
                        layoutOptions.markerOffset = true
                    }
                } else {
                    layoutOptions.length = height;
                    layoutOptions.spacing = options.rowItemSpacing;
                    layoutOptions.direction = "y";
                    layoutOptions.measure = HEIGHT;
                    layoutOptions.altMeasure = WIDTH;
                    layoutOptions.altDirection = "x";
                    layoutOptions.altSpacing = options.columnItemSpacing;
                    layoutOptions.countItem = options.rowCount;
                    layoutOptions.altCountItem = options.columnCount;
                    layoutOptions.marginTextLabel = 7;
                    layoutOptions.labelOffset = 4;
                    if (options.itemTextPosition === RIGHT || options.itemTextPosition === LEFT) {
                        layoutOptions.labelOffset = 7;
                        layoutOptions.markerOffset = true
                    }
                }
                if (!layoutOptions.countItem) {
                    if (layoutOptions.altCountItem) {
                        layoutOptions.countItem = _ceil(that._items.length / layoutOptions.altCountItem)
                    } else {
                        layoutOptions.countItem = that._items.length
                    }
                }
                if (options.itemTextPosition === TOP || options.itemTextPosition === LEFT) {
                    layoutOptions.inverseLabelPosition = true
                }
                layoutOptions.itemTextPosition = options.itemTextPosition;
                layoutOptions.altCountItem = layoutOptions.altCountItem || _ceil(that._items.length / layoutOptions.countItem);
                return layoutOptions
            },
            _adjustBackgroundSettings: function(locationOptions) {
                if (!this._background) {
                    return
                }
                var border = locationOptions.border;
                var legendBox = this._calculateTotalBox();
                var backgroundSettings = {
                    x: _round(legendBox.x - locationOptions.paddingLeftRight),
                    y: _round(legendBox.y - locationOptions.paddingTopBottom),
                    width: _round(legendBox.width) + 2 * locationOptions.paddingLeftRight,
                    height: _round(legendBox.height),
                    opacity: locationOptions.backgroundOpacity
                };
                if (border.visible && border.width && border.color && border.color !== NONE) {
                    backgroundSettings["stroke-width"] = border.width;
                    backgroundSettings.stroke = border.color;
                    backgroundSettings["stroke-opacity"] = border.opacity;
                    backgroundSettings.dashStyle = border.dashStyle;
                    backgroundSettings.rx = border.cornerRadius || 0;
                    backgroundSettings.ry = border.cornerRadius || 0
                }
                this._background.attr(backgroundSettings)
            },
            _setBoundingRect: function(margin) {
                if (!this._insideLegendGroup) {
                    return
                }
                var box = this._calculateTotalBox();
                box.height += margin.top + margin.bottom;
                box.widthWithoutMargins = box.width;
                box.width += margin.left + margin.right;
                box.x -= margin.left;
                box.y -= margin.top;
                this._boundingRect = box
            },
            _calculateTotalBox: function() {
                var markerBox = this._markersGroup.getBBox();
                var titleBox = this._title.getCorrectedLayoutOptions();
                var box = this._insideLegendGroup.getBBox();
                var verticalPadding = this._background ? 2 * this._options.paddingTopBottom : 0;
                box.height = markerBox.height + titleBox.height + verticalPadding;
                titleBox.width > box.width && (box.width = titleBox.width);
                return box
            },
            getActionCallback: function(point) {
                var that = this;
                if (that._options.visible) {
                    return function(act) {
                        that[act](point.index)
                    }
                } else {
                    return _common.noop
                }
            },
            getLayoutOptions: function() {
                var options = this._options;
                var boundingRect = this._insideLegendGroup ? this._boundingRect : {
                    width: 0,
                    height: 0,
                    x: 0,
                    y: 0
                };
                if (options) {
                    boundingRect.verticalAlignment = options.verticalAlignment;
                    boundingRect.horizontalAlignment = options.horizontalAlignment;
                    if (options.orientation === HORIZONTAL) {
                        boundingRect.cutLayoutSide = options.verticalAlignment;
                        boundingRect.cutSide = "vertical"
                    } else {
                        if (options.horizontalAlignment === CENTER) {
                            boundingRect.cutLayoutSide = options.verticalAlignment;
                            boundingRect.cutSide = "vertical"
                        } else {
                            boundingRect.cutLayoutSide = options.horizontalAlignment;
                            boundingRect.cutSide = "horizontal"
                        }
                    }
                    boundingRect.position = {
                        horizontal: options.horizontalAlignment,
                        vertical: options.verticalAlignment
                    };
                    return boundingRect
                }
                return null
            },
            shift: function(x, y) {
                var that = this;
                var box = {};
                if (that._insideLegendGroup) {
                    that._insideLegendGroup.attr({
                        translateX: x - that._boundingRect.x,
                        translateY: y - that._boundingRect.y
                    })
                }
                that._title && that._shiftTitle(that._boundingRect.widthWithoutMargins);
                that._markersGroup && that._shiftMarkers();
                if (that._insideLegendGroup) {
                    box = that._legendGroup.getBBox()
                }
                that._x1 = box.x;
                that._y1 = box.y;
                that._x2 = box.x + box.width;
                that._y2 = box.y + box.height;
                return that
            },
            _shiftTitle: function(boxWidth) {
                var that = this;
                var title = that._title;
                var titleBox = title.getCorrectedLayoutOptions();
                if (!titleBox || !title.hasText()) {
                    return
                }
                var width = boxWidth - (that._background ? 2 * that._options.paddingLeftRight : 0);
                var titleOptions = title.getOptions();
                var titleY = titleBox.y + titleOptions.margin.top;
                var titleX = 0;
                if (titleOptions.verticalAlignment === BOTTOM && that._markersGroup) {
                    titleY += that._markersGroup.getBBox().height
                }
                if (titleOptions.horizontalAlignment === RIGHT) {
                    titleX = width - titleBox.width
                } else {
                    if (titleOptions.horizontalAlignment === CENTER) {
                        titleX = (width - titleBox.width) / 2
                    }
                }
                title.shift(titleX, titleY)
            },
            _shiftMarkers: function() {
                var titleBox = this._title.getLayoutOptions();
                var markerBox = this._markersGroup.getBBox();
                var titleOptions = this._title.getOptions() || {};
                var center = 0;
                var y = 0;
                if (titleBox.width > markerBox.width && this._options.horizontalAlignment === CENTER) {
                    center = titleBox.width / 2 - markerBox.width / 2
                }
                if (titleOptions.verticalAlignment === TOP) {
                    y = titleBox.height
                }
                if (0 !== center || 0 !== y) {
                    this._markersGroup.attr({
                        translateX: center,
                        translateY: y
                    });
                    this._items.forEach(function(item) {
                        item.tracker.left += center;
                        item.tracker.right += center;
                        item.tracker.top += y;
                        item.tracker.bottom += y
                    })
                }
            },
            getPosition: function() {
                return this._options.position
            },
            coordsIn: function(x, y) {
                return x >= this._x1 && x <= this._x2 && y >= this._y1 && y <= this._y2
            },
            getItemByCoord: function(x, y) {
                var items = this._items;
                var legendGroup = this._insideLegendGroup;
                x -= legendGroup.attr("translateX");
                y -= legendGroup.attr("translateY");
                for (var i = 0; i < items.length; i++) {
                    if (inRect(items[i].tracker, x, y)) {
                        return items[i].tracker
                    }
                }
                return null
            },
            dispose: function() {
                var that = this;
                that._title && that._title.dispose();
                that._legendGroup = that._insideLegendGroup = that._title = that._renderer = that._options = that._data = that._items = null;
                return that
            },
            layoutOptions: function() {
                if (!this.isVisible()) {
                    return null
                }
                var pos = this.getLayoutOptions();
                return {
                    horizontalAlignment: this._options.horizontalAlignment,
                    verticalAlignment: this._options.verticalAlignment,
                    side: pos.cutSide,
                    priority: 1,
                    position: this.getPosition()
                }
            },
            measure: function(size) {
                if (this._updated || !this._insideLegendGroup) {
                    this.draw(size[0], size[1]);
                    this._updated = false
                } else {
                    this._items.forEach(function(item) {
                        item.bBoxes = []
                    });
                    this._updateElementsPosition(size[0], size[1])
                }
                var rect = this.getLayoutOptions();
                return [rect.width, rect.height]
            },
            move: function(rect) {
                this.shift(rect[0], rect[1])
            },
            freeSpace: function() {
                this._options._incidentOccurred("W2104");
                this.erase()
            }
        });
        var plugin = {
            name: "legend",
            init: function() {
                var that = this;
                var group = this._renderer.g().attr({
                    "class": this._rootClassPrefix + "-legend"
                }).enableLinks().append(that._renderer.root);
                that._legend = new Legend({
                    renderer: that._renderer,
                    group: group,
                    widget: this,
                    itemGroupClass: this._rootClassPrefix + "-item",
                    titleGroupClass: this._rootClassPrefix + "-title",
                    textField: "text",
                    getFormatObject: function(data) {
                        return {
                            item: data.item,
                            text: data.text
                        }
                    }
                });
                that._layout.add(that._legend)
            },
            extenders: {
                _applyTilesAppearance: function() {
                    var that = this;
                    this._items.forEach(function(item) {
                        that._applyLegendItemStyle(item.id, item.getState())
                    })
                },
                _buildNodes: function() {
                    this._createLegendItems()
                }
            },
            members: {
                _applyLegendItemStyle: function(id, state) {
                    var legend = this._legend;
                    switch (state) {
                        case "hover":
                            legend.applyHover(id);
                            break;
                        case "selection":
                            legend.applySelected(id);
                            break;
                        default:
                            legend.resetItem(id)
                    }
                },
                _createLegendItems: function() {
                    if (this._legend.update(this._getLegendData(), this._getOption("legend"), this._themeManager.theme("legend").title)) {
                        this._requestChange(["LAYOUT"])
                    }
                }
            },
            dispose: function() {
                this._legend.dispose()
            },
            customize: function(constructor) {
                constructor.prototype._proxyData.push(function(x, y) {
                    if (this._legend.coordsIn(x, y)) {
                        var item = this._legend.getItemByCoord(x, y);
                        if (item) {
                            return {
                                id: item.id,
                                type: "legend"
                            }
                        }
                    }
                });
                constructor.addChange({
                    code: "LEGEND",
                    handler: function() {
                        this._createLegendItems()
                    },
                    isThemeDependent: true,
                    option: "legend",
                    isOptionChange: true
                })
            }
        };
        exports.plugin = plugin
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/series/points/bar_point.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _extend2 = __webpack_require__( /*! ../../../core/utils/extend */ 0);
        var _symbol_point = _interopRequireDefault(__webpack_require__( /*! ./symbol_point */ 144));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _extend = _extend2.extend;
        var _math = Math;
        var _floor = _math.floor;
        var _abs = _math.abs;
        var CANVAS_POSITION_DEFAULT = "canvas_position_default";
        var DEFAULT_BAR_TRACKER_SIZE = 9;
        var CORRECTING_BAR_TRACKER_VALUE = 4;
        var RIGHT = "right";
        var LEFT = "left";
        var TOP = "top";
        var BOTTOM = "bottom";

        function getLabelOrientation(point) {
            var initialValue = point.initialValue;
            var invert = point._getValTranslator().getBusinessRange().invert;
            var isDiscreteValue = "discrete" === point.series.valueAxisType;
            var isFullStacked = point.series.isFullStackedSeries();
            var notAxisInverted = !isDiscreteValue && (initialValue >= 0 && !invert || initialValue < 0 && invert) || isDiscreteValue && !invert || isFullStacked;
            return notAxisInverted ? TOP : BOTTOM
        }
        var _default = _extend({}, _symbol_point.default, {
            correctCoordinates: function(correctOptions) {
                var that = this;
                var correction = _floor(correctOptions.offset - correctOptions.width / 2);
                if (that._options.rotated) {
                    that.height = correctOptions.width;
                    that.yCorrection = correction;
                    that.xCorrection = null
                } else {
                    that.width = correctOptions.width;
                    that.xCorrection = correction;
                    that.yCorrection = null
                }
            },
            _getGraphicBBox: function(location) {
                var bBox = {
                    x: this.x,
                    y: this.y,
                    width: this.width,
                    height: this.height
                };
                if (location) {
                    var isTop = "top" === location;
                    if (!this._options.rotated) {
                        bBox.y = isTop ? bBox.y : bBox.y + bBox.height;
                        bBox.height = 0
                    } else {
                        bBox.x = isTop ? bBox.x + bBox.width : bBox.x;
                        bBox.width = 0
                    }
                }
                return bBox
            },
            _getLabelConnector: function(location) {
                return this._getGraphicBBox(location)
            },
            _getLabelPosition: function() {
                var position = getLabelOrientation(this);
                if (this._options.rotated) {
                    position = position === TOP ? RIGHT : LEFT
                }
                return position
            },
            _getLabelCoords: function(label) {
                var that = this;
                var coords;
                if (0 === that.initialValue && that.series.isFullStackedSeries()) {
                    if (!this._options.rotated) {
                        coords = that._getLabelCoordOfPosition(label, TOP)
                    } else {
                        coords = that._getLabelCoordOfPosition(label, RIGHT)
                    }
                } else {
                    if ("inside" === label.getLayoutOptions().position) {
                        coords = that._getLabelCoordOfPosition(label, "inside")
                    } else {
                        coords = _symbol_point.default._getLabelCoords.call(this, label)
                    }
                }
                return coords
            },
            _drawLabel: function() {
                this._label.pointPosition = "inside" !== this._label.getLayoutOptions().position && getLabelOrientation(this);
                _symbol_point.default._drawLabel.call(this)
            },
            hideInsideLabel: function(label, coord) {
                var graphicBBox = this._getGraphicBBox();
                var labelBBox = label.getBoundingRect();
                if (this._options.resolveLabelsOverlapping) {
                    if ((coord.y <= graphicBBox.y && coord.y + labelBBox.height >= graphicBBox.y + graphicBBox.height || coord.x <= graphicBBox.x && coord.x + labelBBox.width >= graphicBBox.x + graphicBBox.width) && !(coord.y > graphicBBox.y + graphicBBox.height || coord.y + labelBBox.height < graphicBBox.y || coord.x > graphicBBox.x + graphicBBox.width || coord.x + labelBBox.width < graphicBBox.x)) {
                        label.draw(false);
                        return true
                    }
                }
                return false
            },
            _showForZeroValues: function() {
                return this._options.label.showForZeroValues || this.initialValue
            },
            _drawMarker: function(renderer, group, animationEnabled) {
                var that = this;
                var style = that._getStyle();
                var r = that._options.cornerRadius;
                var rotated = that._options.rotated;
                var _that$getMarkerCoords = that.getMarkerCoords(),
                    x = _that$getMarkerCoords.x,
                    y = _that$getMarkerCoords.y,
                    width = _that$getMarkerCoords.width,
                    height = _that$getMarkerCoords.height;
                if (animationEnabled) {
                    if (rotated) {
                        width = 0;
                        x = that.defaultX
                    } else {
                        height = 0;
                        y = that.defaultY
                    }
                }
                that.graphic = renderer.rect(x, y, width, height).attr({
                    rx: r,
                    ry: r
                }).smartAttr(style).data({
                    "chart-data-point": that
                }).append(group)
            },
            _getSettingsForTracker: function() {
                var that = this;
                var y = that.y;
                var height = that.height;
                var x = that.x;
                var width = that.width;
                if (that._options.rotated) {
                    if (1 === width) {
                        width = DEFAULT_BAR_TRACKER_SIZE;
                        x -= CORRECTING_BAR_TRACKER_VALUE
                    }
                } else {
                    if (1 === height) {
                        height = DEFAULT_BAR_TRACKER_SIZE;
                        y -= CORRECTING_BAR_TRACKER_VALUE
                    }
                }
                return {
                    x: x,
                    y: y,
                    width: width,
                    height: height
                }
            },
            getGraphicSettings: function() {
                var graphic = this.graphic;
                return {
                    x: graphic.attr("x"),
                    y: graphic.attr("y"),
                    height: graphic.attr("height"),
                    width: graphic.attr("width")
                }
            },
            _getEdgeTooltipParams: function() {
                var isPositive = this.value >= 0;
                var xCoord;
                var yCoord;
                var invertedBusinessRange = this._getValTranslator().getBusinessRange().invert;
                var x = this.x,
                    y = this.y,
                    width = this.width,
                    height = this.height;
                if (this._options.rotated) {
                    yCoord = y + height / 2;
                    if (invertedBusinessRange) {
                        xCoord = isPositive ? x : x + width
                    } else {
                        xCoord = isPositive ? x + width : x
                    }
                } else {
                    xCoord = x + width / 2;
                    if (invertedBusinessRange) {
                        yCoord = isPositive ? y + height : y
                    } else {
                        yCoord = isPositive ? y : y + height
                    }
                }
                return {
                    x: xCoord,
                    y: yCoord,
                    offset: 0
                }
            },
            getTooltipParams: function(location) {
                if ("edge" === location) {
                    return this._getEdgeTooltipParams()
                }
                var center = this.getCenterCoord();
                center.offset = 0;
                return center
            },
            getCenterCoord: function() {
                var width = this.width,
                    height = this.height,
                    x = this.x,
                    y = this.y;
                return {
                    x: x + width / 2,
                    y: y + height / 2
                }
            },
            _truncateCoord: function(coord, bounds) {
                if (null === coord) {
                    return coord
                }
                if (coord < bounds[0]) {
                    return bounds[0]
                }
                if (coord > bounds[1]) {
                    return bounds[1]
                }
                return coord
            },
            _getErrorBarBaseEdgeLength: function() {
                return this._options.rotated ? this.height : this.width
            },
            _translateErrorBars: function(argVisibleArea) {
                _symbol_point.default._translateErrorBars.call(this);
                if (this._errorBarPos < argVisibleArea[0] || this._errorBarPos > argVisibleArea[1]) {
                    this._errorBarPos = void 0
                }
            },
            _translate: function() {
                var that = this;
                var rotated = that._options.rotated;
                var valAxis = rotated ? "x" : "y";
                var argAxis = rotated ? "y" : "x";
                var valIntervalName = rotated ? "width" : "height";
                var argIntervalName = rotated ? "height" : "width";
                var argTranslator = that._getArgTranslator();
                var valTranslator = that._getValTranslator();
                var argVisibleArea = that.series.getArgumentAxis().getVisibleArea();
                var valVisibleArea = that.series.getValueAxis().getVisibleArea();
                var arg;
                var val;
                var minVal;
                arg = argTranslator.translate(that.argument);
                that[argAxis] = arg = null === arg ? arg : arg + (that[argAxis + "Correction"] || 0);
                val = valTranslator.translate(that.value, 1);
                minVal = valTranslator.translate(that.minValue);
                that["v" + valAxis] = val;
                that["v" + argAxis] = arg + that[argIntervalName] / 2;
                val = that._truncateCoord(val, valVisibleArea);
                minVal = that._truncateCoord(minVal, valVisibleArea);
                that[valIntervalName] = _abs(val - minVal);
                val = val < minVal ? val : minVal;
                that._calculateVisibility(rotated ? val : arg, rotated ? arg : val, that.width, that.height);
                that[valAxis] = null === val ? val : val + (that[valAxis + "Correction"] || 0);
                that["min" + valAxis.toUpperCase()] = null === minVal ? minVal : minVal + (that[valAxis + "Correction"] || 0);
                that["default" + valAxis.toUpperCase()] = valTranslator.translate(CANVAS_POSITION_DEFAULT);
                that._translateErrorBars(argVisibleArea);
                if (that.inVisibleArea && null !== that[argAxis]) {
                    if (that[argAxis] < argVisibleArea[0]) {
                        that[argIntervalName] = that[argIntervalName] - (argVisibleArea[0] - that[argAxis]);
                        that[argAxis] = argVisibleArea[0]
                    }
                    if (that[argAxis] + that[argIntervalName] > argVisibleArea[1]) {
                        that[argIntervalName] = argVisibleArea[1] - that[argAxis]
                    }
                }
            },
            _updateMarker: function(animationEnabled, style) {
                this.graphic.smartAttr(_extend({}, style, !animationEnabled ? this.getMarkerCoords() : {}))
            },
            getMarkerCoords: function() {
                var that = this;
                var x = that.x;
                var y = that.y;
                var width = that.width;
                var height = that.height;
                var argAxis = that.series.getArgumentAxis();
                var rotated = that._options.rotated;
                if (argAxis.getAxisPosition) {
                    var axisOptions = argAxis.getOptions();
                    var edgeOffset = Math.round(axisOptions.width / 2);
                    var argAxisPosition = argAxis.getAxisPosition();
                    if (axisOptions.visible) {
                        if (!rotated) {
                            height -= that.minY === that.defaultY && that.minY === argAxisPosition - argAxis.getAxisShift() ? edgeOffset : 0;
                            height < 0 && (height = 0)
                        } else {
                            var isStartFromAxis = that.minX === that.defaultX && that.minX === argAxisPosition - argAxis.getAxisShift();
                            x += isStartFromAxis ? edgeOffset : 0;
                            width -= isStartFromAxis ? edgeOffset : 0;
                            width < 0 && (width = 0)
                        }
                    }
                }
                return {
                    x: x,
                    y: y,
                    width: width,
                    height: height
                }
            },
            coordsIn: function(x, y) {
                var that = this;
                return x >= that.x && x <= that.x + that.width && y >= that.y && y <= that.y + that.height
            }
        });
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/series/helpers/range_data_calculator.js ***!
      \******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _utils = __webpack_require__( /*! ../../core/utils */ 14);
        var _type = __webpack_require__( /*! ../../../core/utils/type */ 1);
        var _common = __webpack_require__( /*! ../../../core/utils/common */ 4);
        var DISCRETE = "discrete";
        var abs = Math.abs,
            floor = Math.floor,
            ceil = Math.ceil,
            min = Math.min;

        function continuousRangeCalculator(range, minValue, maxValue) {
            range.min = range.min < minValue ? range.min : minValue;
            range.max = range.max > maxValue ? range.max : maxValue
        }

        function createGetLogFunction(axisType, axis) {
            if ("logarithmic" !== axisType) {
                return null
            }
            var base = axis.getOptions().logarithmBase;
            return function(value) {
                var log = (0, _utils.getLog)(abs(value), base);
                var round = log < 0 ? floor : ceil;
                return round(log)
            }
        }

        function getRangeCalculator(axisType, axis, getLog) {
            var rangeCalculator = continuousRangeCalculator;
            if (axisType === DISCRETE) {
                rangeCalculator = function(range, minValue, maxValue) {
                    if (minValue !== maxValue) {
                        range.categories.push(maxValue)
                    }
                    range.categories.push(minValue)
                }
            } else {
                if (axis) {
                    rangeCalculator = function(range, value) {
                        var interval = axis.calculateInterval(value, range.prevValue);
                        var minInterval = range.interval;
                        range.interval = (minInterval < interval ? minInterval : interval) || minInterval;
                        range.prevValue = value;
                        continuousRangeCalculator(range, value, value)
                    }
                }
            }
            if (getLog) {
                return function(range, minValue, maxValue) {
                    var minArgs = [];
                    rangeCalculator(range, minValue, maxValue);
                    0 !== minValue && minArgs.push(getLog(minValue));
                    0 !== maxValue && minArgs.push(getLog(maxValue));
                    var linearThreshold = min.apply(null, minArgs);
                    range.linearThreshold = range.linearThreshold < linearThreshold ? range.linearThreshold : linearThreshold
                }
            }
            return rangeCalculator
        }

        function getInitialRange(axisType, dataType, firstValue) {
            var range = {
                axisType: axisType,
                dataType: dataType
            };
            if (axisType === DISCRETE) {
                range.categories = []
            } else {
                range.min = firstValue;
                range.max = firstValue
            }
            return range
        }

        function processCategories(range) {
            if (range.categories) {
                range.categories = (0, _utils.unique)(range.categories)
            }
            return range
        }

        function getValueForArgument(point, extraPoint, x, range) {
            if (extraPoint && (0, _type.isDefined)(extraPoint.value)) {
                var y1 = point.value;
                var y2 = extraPoint.value;
                var x1 = point.argument;
                var x2 = extraPoint.argument;
                var r = (x - x1) * (y2 - y1) / (x2 - x1) + y1.valueOf();
                return "datetime" === range.dataType ? new Date(r) : r
            } else {
                return point.value
            }
        }

        function calculateRangeBetweenPoints(rangeCalculator, range, point, prevPoint, bound) {
            var value = getValueForArgument(point, prevPoint, bound, range);
            rangeCalculator(range, value, value)
        }

        function isLineSeries(series) {
            return series.type.toLowerCase().indexOf("line") >= 0 || series.type.toLowerCase().indexOf("area") >= 0
        }

        function getViewportReducer(series) {
            var rangeCalculator = getRangeCalculator(series.valueAxisType);
            var argumentAxis = series.getArgumentAxis();
            var viewport = argumentAxis && series.getArgumentAxis().visualRange() || {};
            var calculatePointBetweenPoints = isLineSeries(series) ? calculateRangeBetweenPoints : _common.noop;
            if (argumentAxis && argumentAxis.getMarginOptions().checkInterval) {
                var range = series.getArgumentAxis().getTranslator().getBusinessRange();
                var add = (0, _utils.getAddFunction)(range, false);
                var interval = range.interval;
                if (isFinite(interval) && (0, _type.isDefined)(viewport.startValue) && (0, _type.isDefined)(viewport.endValue)) {
                    viewport.startValue = add(viewport.startValue, interval, -1);
                    viewport.endValue = add(viewport.endValue, interval)
                }
            }
            var viewportFilter = getViewPortFilter(viewport);
            return function(range, point, index, points) {
                var argument = point.argument;
                if (!point.hasValue()) {
                    return range
                }
                if (viewportFilter(argument)) {
                    if (!range.startCalc) {
                        range.startCalc = true;
                        calculatePointBetweenPoints(rangeCalculator, range, point, points[index - 1], viewport.startValue)
                    }
                    rangeCalculator(range, point.getMinValue(), point.getMaxValue())
                } else {
                    if (!viewport.categories && (0, _type.isDefined)(viewport.startValue) && argument > viewport.startValue) {
                        if (!range.startCalc) {
                            calculatePointBetweenPoints(rangeCalculator, range, point, points[index - 1], viewport.startValue)
                        }
                        range.endCalc = true;
                        calculatePointBetweenPoints(rangeCalculator, range, point, points[index - 1], viewport.endValue)
                    }
                }
                return range
            }
        }

        function getViewPortFilter(viewport) {
            if (viewport.categories) {
                var dictionary = viewport.categories.reduce(function(result, category) {
                    result[category.valueOf()] = true;
                    return result
                }, {});
                return function(argument) {
                    return (0, _type.isDefined)(argument) && dictionary[argument.valueOf()]
                }
            }
            if (!(0, _type.isDefined)(viewport.startValue) && !(0, _type.isDefined)(viewport.endValue)) {
                return function() {
                    return true
                }
            }
            if (!(0, _type.isDefined)(viewport.endValue)) {
                return function(argument) {
                    return argument >= viewport.startValue
                }
            }
            if (!(0, _type.isDefined)(viewport.startValue)) {
                return function(argument) {
                    return argument <= viewport.endValue
                }
            }
            return function(argument) {
                return argument >= viewport.startValue && argument <= viewport.endValue
            }
        }
        var _default = {
            getViewPortFilter: getViewPortFilter,
            getArgumentRange: function(series) {
                var data = series._data || [];
                var range = {};
                if (data.length) {
                    if (series.argumentAxisType === DISCRETE) {
                        range = {
                            categories: data.map(function(item) {
                                return item.argument
                            })
                        }
                    } else {
                        var interval;
                        if (data.length > 1) {
                            var i1 = series.getArgumentAxis().calculateInterval(data[0].argument, data[1].argument);
                            var i2 = series.getArgumentAxis().calculateInterval(data[data.length - 1].argument, data[data.length - 2].argument);
                            interval = min(i1, i2)
                        }
                        range = {
                            min: data[0].argument,
                            max: data[data.length - 1].argument,
                            interval: interval
                        }
                    }
                }
                return processCategories(range)
            },
            getRangeData: function(series) {
                var points = series.getPoints();
                var useAggregation = series.useAggregation();
                var argumentCalculator = getRangeCalculator(series.argumentAxisType, points.length > 1 && series.getArgumentAxis(), createGetLogFunction(series.argumentAxisType, series.getArgumentAxis()));
                var valueRangeCalculator = getRangeCalculator(series.valueAxisType, null, createGetLogFunction(series.valueAxisType, series.getValueAxis()));
                var viewportReducer = getViewportReducer(series);
                var range = points.reduce(function(range, point, index, points) {
                    var argument = point.argument;
                    if (!point.isArgumentCorrect()) {
                        return range
                    }
                    argumentCalculator(range.arg, argument, argument);
                    if (point.hasValue()) {
                        valueRangeCalculator(range.val, point.getMinValue(), point.getMaxValue());
                        viewportReducer(range.viewport, point, index, points)
                    }
                    return range
                }, {
                    arg: getInitialRange(series.argumentAxisType, series.argumentType),
                    val: getInitialRange(series.valueAxisType, series.valueType, points.length ? series.getValueRangeInitialValue() : void 0),
                    viewport: getInitialRange(series.valueAxisType, series.valueType, points.length ? series.getValueRangeInitialValue() : void 0)
                });
                if (useAggregation) {
                    var argumentRange = this.getArgumentRange(series);
                    if (series.argumentAxisType === DISCRETE) {
                        range.arg = argumentRange
                    } else {
                        var viewport = series.getArgumentAxis().getViewport();
                        if ((0, _type.isDefined)(viewport.startValue) || (0, _type.isDefined)(viewport.length)) {
                            argumentCalculator(range.arg, argumentRange.min, argumentRange.min)
                        }
                        if ((0, _type.isDefined)(viewport.endValue) || (0, _type.isDefined)(viewport.length) && (0, _type.isDefined)(viewport.startValue)) {
                            argumentCalculator(range.arg, argumentRange.max, argumentRange.max)
                        }
                    }
                }
                processCategories(range.arg);
                processCategories(range.val);
                return range
            },
            getViewport: function(series) {
                var points = series.getPoints();
                var range = {};
                var reducer = getViewportReducer(series);
                range = getInitialRange(series.valueAxisType, series.valueType, points.length ? series.getValueRangeInitialValue() : void 0);
                points.some(function(point, index) {
                    reducer(range, point, index, points);
                    return range.endCalc
                });
                return range
            },
            getPointsInViewPort: function(series) {
                var argumentViewPortFilter = getViewPortFilter(series.getArgumentAxis().visualRange() || {});
                var valueViewPort = series.getValueAxis().visualRange() || {};
                var valueViewPortFilter = getViewPortFilter(valueViewPort);
                var points = series.getPoints();
                var addValue = function(values, point, isEdge) {
                    var minValue = point.getMinValue();
                    var maxValue = point.getMaxValue();
                    var isMinValueInViewPort = valueViewPortFilter(minValue);
                    var isMaxValueInViewPort = valueViewPortFilter(maxValue);
                    if (isMinValueInViewPort) {
                        values.push(minValue)
                    }
                    if (maxValue !== minValue && isMaxValueInViewPort) {
                        values.push(maxValue)
                    }
                    if (isEdge && !isMinValueInViewPort && !isMaxValueInViewPort) {
                        if (!values.length) {
                            values.push(valueViewPort.startValue)
                        } else {
                            values.push(valueViewPort.endValue)
                        }
                    }
                };
                var addEdgePoints = isLineSeries(series) ? function(result, points, index) {
                    var point = points[index];
                    var prevPoint = points[index - 1];
                    var nextPoint = points[index + 1];
                    if (nextPoint && argumentViewPortFilter(nextPoint.argument)) {
                        addValue(result[1], point, true)
                    }
                    if (prevPoint && argumentViewPortFilter(prevPoint.argument)) {
                        addValue(result[1], point, true)
                    }
                } : _common.noop;
                var checkPointInViewport = function(result, point, index) {
                    if (argumentViewPortFilter(point.argument)) {
                        addValue(result[0], point)
                    } else {
                        addEdgePoints(result, points, index)
                    }
                    return result
                };
                return points.reduce(checkPointInViewport, [
                    [],
                    []
                ])
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/series/line_series.js ***!
      \************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.polar = exports.chart = void 0;
        var _scatter_series = __webpack_require__( /*! ./scatter_series */ 122);
        var _object = __webpack_require__( /*! ../../core/utils/object */ 51);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _math = __webpack_require__( /*! ../../core/utils/math */ 29);
        var DISCRETE = "discrete";
        var round = Math.round,
            sqrt = Math.sqrt,
            pow = Math.pow,
            min = Math.min,
            max = Math.max,
            abs = Math.abs;
        var chart = {};
        exports.chart = chart;
        var polar = {};
        exports.polar = polar;

        function clonePoint(point, newX, newY, newAngle) {
            var p = (0, _object.clone)(point);
            p.x = newX;
            p.y = newY;
            p.angle = newAngle;
            return p
        }

        function getTangentPoint(point, prevPoint, centerPoint, tan, nextStepAngle) {
            var correctAngle = point.angle + nextStepAngle;
            var cosSin = (0, _utils.getCosAndSin)(correctAngle);
            var x = centerPoint.x + (point.radius + tan * nextStepAngle) * cosSin.cos;
            var y = centerPoint.y - (point.radius + tan * nextStepAngle) * cosSin.sin;
            return clonePoint(prevPoint, x, y, correctAngle)
        }

        function obtainCubicBezierTCoef(p, p0, p1, p2, p3) {
            var d = p0 - p;
            var c = 3 * p1 - 3 * p0;
            var b = 3 * p2 - 6 * p1 + 3 * p0;
            var a = p3 - 3 * p2 + 3 * p1 - p0;
            return (0, _math.solveCubicEquation)(a, b, c, d)
        }
        var lineMethods = {
            autoHidePointMarkersEnabled: function() {
                return true
            },
            _applyGroupSettings: function(style, settings, group) {
                var that = this;
                settings = (0, _extend.extend)(settings, style);
                that._applyElementsClipRect(settings);
                group.attr(settings)
            },
            _setGroupsSettings: function(animationEnabled) {
                var that = this;
                var style = that._styles.normal;
                that._applyGroupSettings(style.elements, {
                    "class": "dxc-elements"
                }, that._elementsGroup);
                that._bordersGroup && that._applyGroupSettings(style.border, {
                    "class": "dxc-borders"
                }, that._bordersGroup);
                _scatter_series.chart._setGroupsSettings.call(that, animationEnabled);
                animationEnabled && that._markersGroup && that._markersGroup.attr({
                    opacity: .001
                })
            },
            _createGroups: function() {
                var that = this;
                that._createGroup("_elementsGroup", that, that._group);
                that._areBordersVisible() && that._createGroup("_bordersGroup", that, that._group);
                _scatter_series.chart._createGroups.call(that)
            },
            _areBordersVisible: function() {
                return false
            },
            _getDefaultSegment: function(segment) {
                return {
                    line: (0, _utils.map)(segment.line || [], function(pt) {
                        return pt.getDefaultCoords()
                    })
                }
            },
            _prepareSegment: function(points) {
                return {
                    line: points
                }
            },
            _parseLineOptions: function(options, defaultColor) {
                return {
                    stroke: options.color || defaultColor,
                    "stroke-width": options.width,
                    dashStyle: options.dashStyle || "solid"
                }
            },
            _parseStyle: function(options, defaultColor) {
                return {
                    elements: this._parseLineOptions(options, defaultColor)
                }
            },
            _applyStyle: function(style) {
                var that = this;
                that._elementsGroup && that._elementsGroup.attr(style.elements);
                (0, _iterator.each)(that._graphics || [], function(_, graphic) {
                    graphic.line && graphic.line.attr({
                        "stroke-width": style.elements["stroke-width"]
                    }).sharp()
                })
            },
            _drawElement: function(segment, group) {
                return {
                    line: this._createMainElement(segment.line, {
                        "stroke-width": this._styles.normal.elements["stroke-width"]
                    }).append(group)
                }
            },
            _removeElement: function(element) {
                element.line.remove()
            },
            _updateElement: function(element, segment, animate, animationComplete) {
                var params = {
                    points: segment.line
                };
                var lineElement = element.line;
                animate ? lineElement.animate(params, {}, animationComplete) : lineElement.attr(params)
            },
            _animateComplete: function() {
                var that = this;
                _scatter_series.chart._animateComplete.call(that);
                that._markersGroup && that._markersGroup.animate({
                    opacity: 1
                }, {
                    duration: that._defaultDuration
                })
            },
            _animate: function() {
                var that = this;
                var lastIndex = that._graphics.length - 1;
                (0, _iterator.each)(that._graphics || [], function(i, elem) {
                    var complete;
                    if (i === lastIndex) {
                        complete = function() {
                            that._animateComplete()
                        }
                    }
                    that._updateElement(elem, that._segments[i], true, complete)
                })
            },
            _drawPoint: function(options) {
                _scatter_series.chart._drawPoint.call(this, {
                    point: options.point,
                    groups: options.groups
                })
            },
            _createMainElement: function(points, settings) {
                return this._renderer.path(points, "line").attr(settings)
            },
            _sortPoints: function(points, rotated) {
                return rotated ? points.sort(function(p1, p2) {
                    return p2.y - p1.y
                }) : points.sort(function(p1, p2) {
                    return p1.x - p2.x
                })
            },
            _drawSegment: function(points, animationEnabled, segmentCount, lastSegment) {
                var that = this;
                var rotated = that._options.rotated;
                var segment = that._prepareSegment(points, rotated, lastSegment);
                that._segments.push(segment);
                if (!that._graphics[segmentCount]) {
                    that._graphics[segmentCount] = that._drawElement(animationEnabled ? that._getDefaultSegment(segment) : segment, that._elementsGroup)
                } else {
                    if (!animationEnabled) {
                        that._updateElement(that._graphics[segmentCount], segment)
                    }
                }
            },
            _getTrackerSettings: function() {
                var that = this;
                var defaultTrackerWidth = that._defaultTrackerWidth;
                var strokeWidthFromElements = that._styles.normal.elements["stroke-width"];
                return {
                    "stroke-width": strokeWidthFromElements > defaultTrackerWidth ? strokeWidthFromElements : defaultTrackerWidth,
                    fill: "none"
                }
            },
            _getMainPointsFromSegment: function(segment) {
                return segment.line
            },
            _drawTrackerElement: function(segment) {
                return this._createMainElement(this._getMainPointsFromSegment(segment), this._getTrackerSettings(segment))
            },
            _updateTrackerElement: function(segment, element) {
                var settings = this._getTrackerSettings(segment);
                settings.points = this._getMainPointsFromSegment(segment);
                element.attr(settings)
            },
            checkSeriesViewportCoord: function(axis, coord) {
                if (!_scatter_series.chart.checkSeriesViewportCoord.call(this)) {
                    return false
                }
                var range = axis.isArgumentAxis ? this.getArgumentRange() : this.getViewport();
                var min = axis.getTranslator().translate(range.categories ? range.categories[0] : range.min);
                var max = axis.getTranslator().translate(range.categories ? range.categories[range.categories.length - 1] : range.max);
                var rotated = this.getOptions().rotated;
                var inverted = axis.getOptions().inverted;
                return axis.isArgumentAxis && (!rotated && !inverted || rotated && inverted) || !axis.isArgumentAxis && (rotated && !inverted || !rotated && inverted) ? coord >= min && coord <= max : coord >= max && coord <= min
            }
        };
        var lineSeries = chart.line = (0, _extend.extend)({}, _scatter_series.chart, lineMethods, {
            getPointCenterByArg: function(arg) {
                var value = this.getArgumentAxis().getTranslator().translate(arg);
                return {
                    x: value,
                    y: value
                }
            },
            getSeriesPairCoord: function(coord, isArgument) {
                var that = this;
                var oppositeCoord = null;
                var nearestPoints = this._getNearestPointsByCoord(coord, isArgument);
                var needValueCoord = isArgument && !that._options.rotated || !isArgument && that._options.rotated;
                for (var i = 0; i < nearestPoints.length; i++) {
                    var p = nearestPoints[i];
                    var k = (p[1].vy - p[0].vy) / (p[1].vx - p[0].vx);
                    var b = p[0].vy - p[0].vx * k;
                    var tmpCoord = void 0;
                    if (p[1].vx - p[0].vx === 0) {
                        tmpCoord = needValueCoord ? p[0].vy : p[0].vx
                    } else {
                        tmpCoord = needValueCoord ? k * coord + b : (coord - b) / k
                    }
                    if (this._checkAxisVisibleAreaCoord(!isArgument, tmpCoord)) {
                        oppositeCoord = tmpCoord;
                        break
                    }
                }
                return oppositeCoord
            }
        });
        chart.stepline = (0, _extend.extend)({}, lineSeries, {
            _calculateStepLinePoints: function(points) {
                var segment = [];
                var coordName = this._options.rotated ? "x" : "y";
                (0, _iterator.each)(points, function(i, pt) {
                    var point;
                    if (!i) {
                        segment.push(pt);
                        return
                    }
                    var step = segment[segment.length - 1][coordName];
                    if (step !== pt[coordName]) {
                        point = (0, _object.clone)(pt);
                        point[coordName] = step;
                        segment.push(point)
                    }
                    segment.push(pt)
                });
                return segment
            },
            _prepareSegment: function(points) {
                return lineSeries._prepareSegment(this._calculateStepLinePoints(points))
            },
            getSeriesPairCoord: function(coord, isArgument) {
                var oppositeCoord;
                var rotated = this._options.rotated;
                var isOpposite = !isArgument && !rotated || isArgument && rotated;
                var coordName = !isOpposite ? "vx" : "vy";
                var oppositeCoordName = !isOpposite ? "vy" : "vx";
                var nearestPoints = this._getNearestPointsByCoord(coord, isArgument);
                for (var i = 0; i < nearestPoints.length; i++) {
                    var p = nearestPoints[i];
                    var tmpCoord = void 0;
                    if (isArgument) {
                        tmpCoord = coord !== p[1][coordName] ? p[0][oppositeCoordName] : p[1][oppositeCoordName]
                    } else {
                        tmpCoord = coord === p[0][coordName] ? p[0][oppositeCoordName] : p[1][oppositeCoordName]
                    }
                    if (this._checkAxisVisibleAreaCoord(!isArgument, tmpCoord)) {
                        oppositeCoord = tmpCoord;
                        break
                    }
                }
                return oppositeCoord
            }
        });
        chart.spline = (0, _extend.extend)({}, lineSeries, {
            _calculateBezierPoints: function(src, rotated) {
                var bezierPoints = [];
                var pointsCopy = src;
                var checkExtremum = function(otherPointCoord, pointCoord, controlCoord) {
                    return otherPointCoord > pointCoord && controlCoord > otherPointCoord || otherPointCoord < pointCoord && controlCoord < otherPointCoord ? otherPointCoord : controlCoord
                };
                if (1 !== pointsCopy.length) {
                    pointsCopy.forEach(function(curPoint, i) {
                        var leftControlX;
                        var leftControlY;
                        var rightControlX;
                        var rightControlY;
                        var prevPoint = pointsCopy[i - 1];
                        var nextPoint = pointsCopy[i + 1];
                        var x1;
                        var x2;
                        var y1;
                        var y2;
                        var lambda = .5;
                        var a;
                        var b;
                        var c;
                        var xc;
                        var yc;
                        var shift;
                        if (!i || i === pointsCopy.length - 1) {
                            bezierPoints.push(curPoint, curPoint);
                            return
                        }
                        var xCur = curPoint.x;
                        var yCur = curPoint.y;
                        x1 = prevPoint.x;
                        x2 = nextPoint.x;
                        y1 = prevPoint.y;
                        y2 = nextPoint.y;
                        var curIsExtremum = !!(!rotated && (yCur <= prevPoint.y && yCur <= nextPoint.y || yCur >= prevPoint.y && yCur >= nextPoint.y) || rotated && (xCur <= prevPoint.x && xCur <= nextPoint.x || xCur >= prevPoint.x && xCur >= nextPoint.x));
                        if (curIsExtremum) {
                            if (!rotated) {
                                rightControlY = leftControlY = yCur;
                                rightControlX = (xCur + nextPoint.x) / 2;
                                leftControlX = (xCur + prevPoint.x) / 2
                            } else {
                                rightControlX = leftControlX = xCur;
                                rightControlY = (yCur + nextPoint.y) / 2;
                                leftControlY = (yCur + prevPoint.y) / 2
                            }
                        } else {
                            a = y2 - y1;
                            b = x1 - x2;
                            c = y1 * x2 - x1 * y2;
                            if (!rotated) {
                                if (!b) {
                                    bezierPoints.push(curPoint, curPoint, curPoint);
                                    return
                                }
                                xc = xCur;
                                yc = -1 * (a * xc + c) / b;
                                shift = yc - yCur;
                                y1 -= shift;
                                y2 -= shift
                            } else {
                                if (!a) {
                                    bezierPoints.push(curPoint, curPoint, curPoint);
                                    return
                                }
                                yc = yCur;
                                xc = -1 * (b * yc + c) / a;
                                shift = xc - xCur;
                                x1 -= shift;
                                x2 -= shift
                            }
                            rightControlX = (xCur + lambda * x2) / (1 + lambda);
                            rightControlY = (yCur + lambda * y2) / (1 + lambda);
                            leftControlX = (xCur + lambda * x1) / (1 + lambda);
                            leftControlY = (yCur + lambda * y1) / (1 + lambda)
                        }
                        if (!rotated) {
                            leftControlY = checkExtremum(prevPoint.y, yCur, leftControlY);
                            rightControlY = checkExtremum(nextPoint.y, yCur, rightControlY)
                        } else {
                            leftControlX = checkExtremum(prevPoint.x, xCur, leftControlX);
                            rightControlX = checkExtremum(nextPoint.x, xCur, rightControlX)
                        }
                        var leftPoint = clonePoint(curPoint, leftControlX, leftControlY);
                        var rightPoint = clonePoint(curPoint, rightControlX, rightControlY);
                        bezierPoints.push(leftPoint, curPoint, rightPoint)
                    })
                } else {
                    bezierPoints.push(pointsCopy[0])
                }
                return bezierPoints
            },
            _prepareSegment: function(points, rotated) {
                return lineSeries._prepareSegment(this._calculateBezierPoints(points, rotated))
            },
            _createMainElement: function(points, settings) {
                return this._renderer.path(points, "bezier").attr(settings)
            },
            getSeriesPairCoord: function(coord, isArgument) {
                var that = this;
                var oppositeCoord = null;
                var isOpposite = !isArgument && !this._options.rotated || isArgument && this._options.rotated;
                var coordName = !isOpposite ? "vx" : "vy";
                var bezierCoordName = !isOpposite ? "x" : "y";
                var oppositeCoordName = !isOpposite ? "vy" : "vx";
                var bezierOppositeCoordName = !isOpposite ? "y" : "x";
                var axis = !isArgument ? that.getArgumentAxis() : that.getValueAxis();
                var visibleArea = axis.getVisibleArea();
                var nearestPoints = this._getNearestPointsByCoord(coord, isArgument);
                var _loop = function(i) {
                    var p = nearestPoints[i];
                    if (1 === p.length) {
                        visibleArea[0] <= p[0][oppositeCoordName] && visibleArea[1] >= p[0][oppositeCoordName] && (oppositeCoord = p[0][oppositeCoordName])
                    } else {
                        var ts = obtainCubicBezierTCoef(coord, p[0][coordName], p[1][bezierCoordName], p[2][bezierCoordName], p[3][coordName]);
                        ts.forEach(function(t) {
                            if (t >= 0 && t <= 1) {
                                var tmpCoord = Math.pow(1 - t, 3) * p[0][oppositeCoordName] + 3 * Math.pow(1 - t, 2) * t * p[1][bezierOppositeCoordName] + 3 * (1 - t) * t * t * p[2][bezierOppositeCoordName] + t * t * t * p[3][oppositeCoordName];
                                if (visibleArea[0] <= tmpCoord && visibleArea[1] >= tmpCoord) {
                                    oppositeCoord = tmpCoord
                                }
                            }
                        })
                    }
                    if (null !== oppositeCoord) {
                        return "break"
                    }
                };
                for (var i = 0; i < nearestPoints.length; i++) {
                    var _ret = _loop(i);
                    if ("break" === _ret) {
                        break
                    }
                }
                return oppositeCoord
            },
            _getNearestPoints: function(point, nextPoint, bezierPoints) {
                var index = bezierPoints.indexOf(point);
                return [point, bezierPoints[index + 1], bezierPoints[index + 2], nextPoint]
            },
            _getBezierPoints: function() {
                return this._segments.length > 0 ? this._segments.reduce(function(a, seg) {
                    return a.concat(seg.line)
                }, []) : []
            }
        });
        polar.line = (0, _extend.extend)({}, _scatter_series.polar, lineMethods, {
            _sortPoints: function(points) {
                return points
            },
            _prepareSegment: function(points, rotated, lastSegment) {
                var preparedPoints = [];
                var centerPoint = this.getValueAxis().getCenter();
                var i;
                lastSegment && this._closeSegment(points);
                if (this.argumentAxisType !== DISCRETE && this.valueAxisType !== DISCRETE) {
                    for (i = 1; i < points.length; i++) {
                        preparedPoints = preparedPoints.concat(this._getTangentPoints(points[i], points[i - 1], centerPoint))
                    }
                    if (!preparedPoints.length) {
                        preparedPoints = points
                    }
                } else {
                    return lineSeries._prepareSegment.call(this, points)
                }
                return {
                    line: preparedPoints
                }
            },
            _getRemainingAngle: function(angle) {
                var normAngle = (0, _utils.normalizeAngle)(angle);
                return angle >= 0 ? 360 - normAngle : -normAngle
            },
            _closeSegment: function(points) {
                var point;
                if (this._segments.length) {
                    point = this._segments[0].line[0]
                } else {
                    point = clonePoint(points[0], points[0].x, points[0].y, points[0].angle)
                }
                point = this._modifyReflectedPoint(point, points[points.length - 1]);
                if (point) {
                    points.push(point)
                }
            },
            _modifyReflectedPoint: function(point, lastPoint) {
                if (lastPoint.angle === point.angle) {
                    return
                }
                if ((0, _utils.normalizeAngle)(round(lastPoint.angle)) === (0, _utils.normalizeAngle)(round(point.angle))) {
                    point.angle = lastPoint.angle
                } else {
                    var differenceAngle = lastPoint.angle - point.angle;
                    point.angle = lastPoint.angle + this._getRemainingAngle(differenceAngle)
                }
                return point
            },
            _getTangentPoints: function(point, prevPoint, centerPoint) {
                var tangentPoints = [];
                var betweenAngle = Math.round(prevPoint.angle - point.angle);
                var tan = (prevPoint.radius - point.radius) / betweenAngle;
                var i;
                if (0 === betweenAngle) {
                    tangentPoints = [prevPoint, point]
                } else {
                    if (betweenAngle > 0) {
                        for (i = betweenAngle; i >= 0; i--) {
                            tangentPoints.push(getTangentPoint(point, prevPoint, centerPoint, tan, i))
                        }
                    } else {
                        for (i = 0; i >= betweenAngle; i--) {
                            tangentPoints.push(getTangentPoint(point, prevPoint, centerPoint, tan, betweenAngle - i))
                        }
                    }
                }
                return tangentPoints
            },
            getSeriesPairCoord: function(params, isArgument) {
                var that = this;
                var argAxis = that.getArgumentAxis();
                var paramName = isArgument ? "angle" : "radius";
                var coordParam = params[paramName];
                var centerPoint = argAxis.getCenter();
                var getLengthByCoords = function(p1, p2) {
                    return sqrt(pow(p1.x - p2.x, 2) + pow(p1.y - p2.y, 2))
                };
                var isInsideInterval = function(prevPoint, point, _ref) {
                    var x = _ref.x,
                        y = _ref.y;
                    return getLengthByCoords({
                        x: x,
                        y: y
                    }, centerPoint) <= argAxis.getRadius() && min(prevPoint.x, point.x) <= x && max(prevPoint.x, point.x) >= x && min(prevPoint.y, point.y) <= y && max(prevPoint.y, point.y) >= y
                };
                var coords;
                var neighborPoints = that.getNeighborPoints(coordParam, paramName);
                if (1 === neighborPoints.length) {
                    coords = neighborPoints[0]
                } else {
                    if (neighborPoints.length > 1) {
                        var prevPoint = neighborPoints[0];
                        var point = neighborPoints[1];
                        if (that.argumentAxisType !== DISCRETE && that.valueAxisType !== DISCRETE) {
                            var tan;
                            var stepAngle;
                            if (isArgument) {
                                tan = (prevPoint.radius - point.radius) / (prevPoint.angle - point.angle);
                                stepAngle = coordParam - point.angle
                            } else {
                                tan = (prevPoint.radius - point.radius) / (prevPoint.angle - point.angle);
                                stepAngle = (coordParam - point.radius) / tan
                            }
                            coords = getTangentPoint(point, prevPoint, centerPoint, tan, stepAngle)
                        } else {
                            if (isArgument) {
                                var cosSin = (0, _utils.getCosAndSin)(-coordParam);
                                var k1 = (point.y - prevPoint.y) / (point.x - prevPoint.x);
                                var b1 = prevPoint.y - prevPoint.x * k1;
                                var k2 = cosSin.sin / cosSin.cos;
                                var b2 = centerPoint.y - k2 * centerPoint.x;
                                var x = (b2 - b1) / (k1 - k2);
                                var y = k1 * x + b1;
                                if (isInsideInterval(prevPoint, point, {
                                        x: x,
                                        y: y
                                    })) {
                                    var quarter = abs((0, _math.trunc)((360 + coordParam) / 90) % 4);
                                    if (0 === quarter && x >= centerPoint.x && y <= centerPoint.y || 1 === quarter && x <= centerPoint.x && y <= centerPoint.y || 2 === quarter && x <= centerPoint.x && y >= centerPoint.y || 3 === quarter && x >= centerPoint.x && y >= centerPoint.y) {
                                        coords = {
                                            x: x,
                                            y: y
                                        }
                                    }
                                }
                            } else {
                                var k = (point.y - prevPoint.y) / (point.x - prevPoint.x);
                                var y0 = prevPoint.y - prevPoint.x * k;
                                var a = 1 + k * k;
                                var b = -2 * centerPoint.x + 2 * k * y0 - 2 * k * centerPoint.y;
                                var c = -pow(coordParam, 2) + pow(y0 - centerPoint.y, 2) + pow(centerPoint.x, 2);
                                var d = b * b - 4 * a * c;
                                if (d >= 0) {
                                    var x1 = (-b - sqrt(d)) / (2 * a);
                                    var x2 = (-b + sqrt(d)) / (2 * a);
                                    var y1 = k * x1 + y0;
                                    var y2 = k * x2 + y0;
                                    coords = isInsideInterval(prevPoint, point, {
                                        x: x1,
                                        y: y1
                                    }) ? {
                                        x: x1,
                                        y: y1
                                    } : isInsideInterval(prevPoint, point, {
                                        x: x2,
                                        y: y2
                                    }) ? {
                                        x: x2,
                                        y: y2
                                    } : void 0
                                }
                            }
                        }
                    }
                }
                return coords
            },
            getNeighborPoints: function(param, paramName) {
                var points = this.getPoints();
                var neighborPoints = [];
                if (this.getOptions().closed) {
                    points = (0, _extend.extend)(true, [], points);
                    var lastPoint = points[points.length - 1];
                    var firstPointCopy = clonePoint(points[0], points[0].x, points[0].y, points[0].angle);
                    var lastPointCopy = clonePoint(lastPoint, lastPoint.x, lastPoint.y, lastPoint.angle);
                    var rearwardRefPoint = this._modifyReflectedPoint(firstPointCopy, lastPoint);
                    var forwardRefPoint = this._modifyReflectedPoint(lastPointCopy, points[0]);
                    if (forwardRefPoint) {
                        points.unshift(forwardRefPoint)
                    }
                    if (rearwardRefPoint) {
                        points.push(rearwardRefPoint)
                    }
                }
                for (var i = 1; i < points.length; i++) {
                    if (points[i - 1][paramName] === param) {
                        neighborPoints.push(points[i - 1])
                    } else {
                        if (points[i][paramName] === param) {
                            neighborPoints.push(points[i])
                        } else {
                            if (points[i][paramName] > param && points[i - 1][paramName] < param || points[i - 1][paramName] > param && points[i][paramName] < param) {
                                neighborPoints.push(points[i - 1]);
                                neighborPoints.push(points[i])
                            }
                        }
                    }
                    if (neighborPoints.length > 0) {
                        break
                    }
                }
                return neighborPoints
            }
        })
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/core/annotations.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.plugins = exports.createAnnotations = void 0;
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _tooltip = __webpack_require__( /*! ../core/tooltip */ 123);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _utils = __webpack_require__( /*! ./utils */ 14);
        var _plaque = __webpack_require__( /*! ./plaque */ 466);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../../events/pointer */ 24));
        var _drag = __webpack_require__( /*! ../../events/drag */ 76);
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var getDocument = _dom_adapter.default.getDocument;
        var EVENT_NS = "annotations";
        var DOT_EVENT_NS = "." + EVENT_NS;
        var POINTER_ACTION = (0, _index.addNamespace)([_pointer.default.down, _pointer.default.move], EVENT_NS);
        var POINTER_UP_EVENT_NAME = (0, _index.addNamespace)(_pointer.default.up, EVENT_NS);
        var DRAG_START_EVENT_NAME = _drag.start + DOT_EVENT_NS;
        var DRAG_EVENT_NAME = _drag.move + DOT_EVENT_NS;
        var DRAG_END_EVENT_NAME = _drag.end + DOT_EVENT_NS;

        function coreAnnotation(options, contentTemplate) {
            return {
                draw: function(widget, group) {
                    var _this = this;
                    var annotationGroup = widget._renderer.g().append(group).css((0, _utils.patchFontOptions)(options.font));
                    if (this.plaque) {
                        this.plaque.clear()
                    }
                    this.plaque = new _plaque.Plaque((0, _extend.extend)(true, {}, options, {
                        cornerRadius: (options.border || {}).cornerRadius
                    }), widget, annotationGroup, contentTemplate, widget._isAnnotationBounded(options));
                    this.plaque.draw(widget._getAnnotationCoords(this));
                    if (options.allowDragging) {
                        annotationGroup.on(DRAG_START_EVENT_NAME, {
                            immediate: true
                        }, function(e) {
                            _this._dragOffsetX = _this.plaque.x - e.pageX;
                            _this._dragOffsetY = _this.plaque.y - e.pageY
                        }).on(DRAG_EVENT_NAME, function(e) {
                            _this.plaque.move(e.pageX + _this._dragOffsetX, e.pageY + _this._dragOffsetY)
                        }).on(DRAG_END_EVENT_NAME, function(e) {
                            _this.offsetX = (_this.offsetX || 0) + e.offset.x;
                            _this.offsetY = (_this.offsetY || 0) + e.offset.y
                        })
                    }
                },
                hitTest: function(x, y) {
                    return this.plaque.hitTest(x, y)
                },
                showTooltip: function(tooltip, _ref) {
                    var x = _ref.x,
                        y = _ref.y;
                    var that = this;
                    var options = that.options;
                    if (tooltip.annotation !== that) {
                        tooltip.setTemplate(options.tooltipTemplate);
                        var callback = function(result) {
                            result && (tooltip.annotation = that)
                        };
                        callback(tooltip.show(options, {
                            x: x,
                            y: y
                        }, {
                            target: options
                        }, options.customizeTooltip, callback))
                    } else {
                        tooltip.move(x, y)
                    }
                }
            }
        }

        function getTemplateFunction(options, widget) {
            var template;
            if ("text" === options.type) {
                template = function(item, groupElement) {
                    var text = widget._renderer.text(item.text).attr({
                        "class": item.cssClass
                    }).append({
                        element: groupElement
                    });
                    if (item.width > 0 || item.height > 0) {
                        text.setMaxSize(item.width, item.height, {
                            wordWrap: item.wordWrap,
                            textOverflow: item.textOverflow
                        })
                    }
                }
            } else {
                if ("image" === options.type) {
                    template = function(item, groupElement) {
                        var _ref2 = item.image || {},
                            width = _ref2.width,
                            height = _ref2.height,
                            url = _ref2.url,
                            location = _ref2.location;
                        var outerWidth = item.width,
                            outerHeight = item.height;
                        var imageWidth = outerWidth > 0 ? Math.min(width, outerWidth) : width;
                        var imageHeight = outerHeight > 0 ? Math.min(height, outerHeight) : height;
                        widget._renderer.image(0, 0, imageWidth, imageHeight, url, location || "center").append({
                            element: groupElement
                        })
                    }
                } else {
                    if ("custom" === options.type) {
                        template = options.template
                    }
                }
            }
            return template
        }

        function getImageObject(image) {
            return "string" === typeof image ? {
                url: image
            } : image
        }
        var createAnnotations = function(widget, items) {
            var commonAnnotationSettings = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            var customizeAnnotation = arguments.length > 3 ? arguments[3] : void 0;
            var pullOptions = arguments.length > 4 ? arguments[4] : void 0;
            var commonImageOptions = getImageObject(commonAnnotationSettings.image);
            return items.reduce(function(arr, item) {
                var currentImageOptions = getImageObject(item.image);
                var customizedItem = (0, _type.isFunction)(customizeAnnotation) ? customizeAnnotation(item) : {};
                if (customizedItem) {
                    customizedItem.image = getImageObject(customizedItem.image)
                }
                var options = (0, _extend.extend)(true, {}, commonAnnotationSettings, item, {
                    image: commonImageOptions
                }, {
                    image: currentImageOptions
                }, customizedItem);
                var templateFunction = getTemplateFunction(options, widget);
                var annotation = templateFunction && (0, _extend.extend)(true, pullOptions(options), coreAnnotation(options, widget._getTemplate(templateFunction)));
                annotation && arr.push(annotation);
                return arr
            }, [])
        };
        exports.createAnnotations = createAnnotations;
        var chartPlugin = {
            name: "annotations_chart",
            init: function() {},
            dispose: function() {},
            members: {
                _getAnnotationCoords: function(annotation) {
                    var _axis, _axis2;
                    var coords = {
                        offsetX: annotation.offsetX,
                        offsetY: annotation.offsetY
                    };
                    var argCoordName = this._options.silent("rotated") ? "y" : "x";
                    var valCoordName = this._options.silent("rotated") ? "x" : "y";
                    var argAxis = this.getArgumentAxis();
                    var argument = argAxis.validateUnit(annotation.argument);
                    var axis = this.getValueAxis(annotation.axis);
                    var series;
                    var pane = null === (_axis = axis) || void 0 === _axis ? void 0 : _axis.pane;
                    if (annotation.series) {
                        var _series;
                        series = this.series.filter(function(s) {
                            return s.name === annotation.series
                        })[0];
                        axis = null === (_series = series) || void 0 === _series ? void 0 : _series.getValueAxis();
                        (0, _type.isDefined)(axis) && (pane = axis.pane)
                    }
                    if ((0, _type.isDefined)(argument)) {
                        if (series) {
                            var center = series.getPointCenterByArg(argument);
                            center && (coords[argCoordName] = center[argCoordName])
                        } else {
                            coords[argCoordName] = argAxis.getTranslator().translate(argument)
                        }!(0, _type.isDefined)(pane) && (pane = argAxis.pane)
                    }
                    var value = null === (_axis2 = axis) || void 0 === _axis2 ? void 0 : _axis2.validateUnit(annotation.value);
                    if ((0, _type.isDefined)(value)) {
                        var _axis3;
                        coords[valCoordName] = null === (_axis3 = axis) || void 0 === _axis3 ? void 0 : _axis3.getTranslator().translate(value);
                        !(0, _type.isDefined)(pane) && (0, _type.isDefined)(axis) && (pane = axis.pane)
                    }
                    coords.canvas = this._getCanvasForPane(pane);
                    if ((0, _type.isDefined)(coords[argCoordName]) && !(0, _type.isDefined)(value)) {
                        var _series2;
                        if (!(0, _type.isDefined)(axis) && !(0, _type.isDefined)(series)) {
                            coords[valCoordName] = argAxis.getAxisPosition()
                        } else {
                            if ((0, _type.isDefined)(axis) && !(0, _type.isDefined)(series)) {
                                coords[valCoordName] = this._argumentAxes.filter(function(a) {
                                    return a.pane === axis.pane
                                })[0].getAxisPosition()
                            } else {
                                if (null !== (_series2 = series) && void 0 !== _series2 && _series2.checkSeriesViewportCoord(argAxis, coords[argCoordName])) {
                                    coords[valCoordName] = series.getSeriesPairCoord(coords[argCoordName], true)
                                }
                            }
                        }
                    }
                    if (!(0, _type.isDefined)(argument) && (0, _type.isDefined)(coords[valCoordName])) {
                        if ((0, _type.isDefined)(axis) && !(0, _type.isDefined)(series)) {
                            coords[argCoordName] = axis.getAxisPosition()
                        } else {
                            if ((0, _type.isDefined)(series)) {
                                if (series.checkSeriesViewportCoord(axis, coords[valCoordName])) {
                                    coords[argCoordName] = series.getSeriesPairCoord(coords[valCoordName], false)
                                }
                            }
                        }
                    }
                    return coords
                },
                _annotationsPointerEventHandler: function(event) {
                    var originalEvent = event.originalEvent || {};
                    var touch = originalEvent.touches && originalEvent.touches[0] || {};
                    var rootOffset = this._renderer.getRootOffset();
                    var coords = {
                        x: touch.pageX || originalEvent.pageX || event.pageX,
                        y: touch.pageY || originalEvent.pageY || event.pageY
                    };
                    var annotation = this._annotations.items.filter(function(a) {
                        return a.hitTest(coords.x - rootOffset.left, coords.y - rootOffset.top)
                    })[0];
                    if (!annotation || !annotation.options.tooltipEnabled) {
                        this._annotations.hideTooltip();
                        return
                    }
                    this._clear();
                    if (annotation.options.allowDragging && event.type === _pointer.default.down) {
                        this._annotations._hideToolTipForDrag = true
                    }
                    if (!this._annotations._hideToolTipForDrag) {
                        annotation.showTooltip(this._annotations.tooltip, coords);
                        event.stopPropagation()
                    }
                },
                _isAnnotationBounded: function(options) {
                    return (0, _type.isDefined)(options.value) || (0, _type.isDefined)(options.argument)
                },
                _pullOptions: function(options) {
                    return {
                        type: options.type,
                        name: options.name,
                        x: options.x,
                        y: options.y,
                        value: options.value,
                        argument: options.argument,
                        axis: options.axis,
                        series: options.series,
                        options: options,
                        offsetX: options.offsetX,
                        offsetY: options.offsetY
                    }
                },
                _forceAnnotationRender: function() {
                    this._change(["FORCE_RENDER"])
                },
                _clear: function() {
                    this.hideTooltip();
                    this.clearHover()
                }
            }
        };
        var polarChartPlugin = {
            name: "annotations_polar_chart",
            init: function() {},
            dispose: function() {},
            members: {
                _getAnnotationCoords: function(annotation) {
                    var coords = {
                        offsetX: annotation.offsetX,
                        offsetY: annotation.offsetY,
                        canvas: this._calcCanvas()
                    };
                    var argAxis = this.getArgumentAxis();
                    var argument = argAxis.validateUnit(annotation.argument);
                    var value = this.getValueAxis().validateUnit(annotation.value);
                    var radius = annotation.radius;
                    var angle = annotation.angle;
                    var pointCoords;
                    var series;
                    if (annotation.series) {
                        series = this.series.filter(function(s) {
                            return s.name === annotation.series
                        })[0]
                    }(0, _extend.extend)(true, coords, this.getXYFromPolar(angle, radius, argument, value));
                    if ((0, _type.isDefined)(series)) {
                        if ((0, _type.isDefined)(coords.angle) && !(0, _type.isDefined)(value) && !(0, _type.isDefined)(radius)) {
                            if (!(0, _type.isDefined)(argument)) {
                                argument = argAxis.getTranslator().from(isFinite(angle) ? this.getActualAngle(angle) : coords.angle)
                            }
                            pointCoords = series.getSeriesPairCoord({
                                argument: argument,
                                angle: -coords.angle
                            }, true)
                        } else {
                            if ((0, _type.isDefined)(coords.radius) && !(0, _type.isDefined)(argument) && !(0, _type.isDefined)(angle)) {
                                pointCoords = series.getSeriesPairCoord({
                                    radius: coords.radius
                                }, false)
                            }
                        }
                        if ((0, _type.isDefined)(pointCoords)) {
                            coords.x = pointCoords.x;
                            coords.y = pointCoords.y
                        }
                    }
                    if (annotation.series && !(0, _type.isDefined)(pointCoords)) {
                        coords.x = coords.y = void 0
                    }
                    return coords
                },
                _annotationsPointerEventHandler: chartPlugin.members._annotationsPointerEventHandler,
                _isAnnotationBounded: chartPlugin.members._isAnnotationBounded,
                _pullOptions: function(options) {
                    var polarOptions = (0, _extend.extend)({}, {
                        radius: options.radius,
                        angle: options.angle
                    }, chartPlugin.members._pullOptions(options));
                    delete polarOptions.axis;
                    return polarOptions
                },
                _forceAnnotationRender: chartPlugin.members._forceAnnotationRender,
                _clear: chartPlugin.members._clear
            }
        };
        var vectorMapPlugin = {
            name: "annotations_vector_map",
            init: function() {},
            dispose: function() {
                this._annotations._offTracker();
                this._annotations._offTracker = null
            },
            members: {
                _getAnnotationCoords: function(annotation) {
                    var coords = {
                        offsetX: annotation.offsetX,
                        offsetY: annotation.offsetY
                    };
                    coords.canvas = this._projection.getCanvas();
                    if (annotation.coordinates) {
                        var data = this._projection.toScreenPoint(annotation.coordinates);
                        coords.x = data[0];
                        coords.y = data[1]
                    }
                    return coords
                },
                _annotationsPointerEventHandler: chartPlugin.members._annotationsPointerEventHandler,
                _isAnnotationBounded: function(options) {
                    return (0, _type.isDefined)(options.coordinates)
                },
                _pullOptions: function(options) {
                    var vectorMapOptions = (0, _extend.extend)({}, {
                        coordinates: options.coordinates
                    }, chartPlugin.members._pullOptions(options));
                    delete vectorMapOptions.axis;
                    delete vectorMapOptions.series;
                    delete vectorMapOptions.argument;
                    delete vectorMapOptions.value;
                    return vectorMapOptions
                },
                _forceAnnotationRender: function() {
                    this._change(["EXTRA_ELEMENTS"])
                },
                _getAnnotationStyles: function() {
                    return {
                        "text-anchor": "start"
                    }
                },
                _clear: function() {}
            },
            extenders: {
                _prepareExtraElements: function() {
                    var that = this;
                    var renderElements = function() {
                        that._renderExtraElements()
                    };
                    that._annotations._offTracker = that._tracker.on({
                        move: renderElements,
                        zoom: renderElements,
                        end: renderElements
                    })
                }
            }
        };
        var pieChartPlugin = {
            name: "annotations_pie_chart",
            init: function() {},
            dispose: function() {},
            members: {
                _getAnnotationCoords: function(annotation) {
                    var series;
                    var coords = {
                        offsetX: annotation.offsetX,
                        offsetY: annotation.offsetY,
                        canvas: this._canvas
                    };
                    if (annotation.argument) {
                        if (annotation.series) {
                            series = this.getSeriesByName(annotation.series)
                        } else {
                            series = this.series[0]
                        }
                        var argument = series.getPointsByArg(annotation.argument)[0];
                        var _argument$getAnnotati = argument.getAnnotationCoords(annotation.location),
                            x = _argument$getAnnotati.x,
                            y = _argument$getAnnotati.y;
                        coords.x = x;
                        coords.y = y
                    }
                    return coords
                },
                _isAnnotationBounded: function(options) {
                    return options.argument
                },
                _annotationsPointerEventHandler: chartPlugin.members._annotationsPointerEventHandler,
                _pullOptions: function(options) {
                    var pieChartOptions = (0, _extend.extend)({}, {
                        location: options.location
                    }, chartPlugin.members._pullOptions(options));
                    delete pieChartOptions.axis;
                    return pieChartOptions
                },
                _clear: chartPlugin.members._clear,
                _forceAnnotationRender: chartPlugin.members._forceAnnotationRender
            }
        };
        var corePlugin = {
            name: "annotations_core",
            init: function() {
                this._annotations = {
                    items: [],
                    _hideToolTipForDrag: false,
                    tooltip: new _tooltip.Tooltip({
                        cssClass: "".concat(this._rootClassPrefix, "-annotation-tooltip"),
                        eventTrigger: this._eventTrigger,
                        widgetRoot: this.element(),
                        widget: this
                    }),
                    hideTooltip: function() {
                        this.tooltip.annotation = null;
                        this.tooltip.hide()
                    },
                    clearItems: function() {
                        this.items.forEach(function(i) {
                            return i.plaque.clear()
                        });
                        this.items = []
                    }
                };
                this._annotations.tooltip.setRendererOptions(this._getRendererOptions())
            },
            dispose: function() {
                this._annotationsGroup.linkRemove().linkOff();
                _events_engine.default.off(getDocument(), DOT_EVENT_NS);
                this._annotationsGroup.off(DOT_EVENT_NS);
                this._annotations.tooltip && this._annotations.tooltip.dispose()
            },
            extenders: {
                _createHtmlStructure: function() {
                    var _this2 = this;
                    this._annotationsGroup = this._renderer.g().attr({
                        "class": "".concat(this._rootClassPrefix, "-annotations")
                    }).css(this._getAnnotationStyles()).linkOn(this._renderer.root, "annotations").linkAppend();
                    _events_engine.default.on(getDocument(), POINTER_ACTION, function() {
                        return _this2._annotations.hideTooltip()
                    });
                    _events_engine.default.on(getDocument(), POINTER_UP_EVENT_NAME, function(event) {
                        _this2._annotations._hideToolTipForDrag = false;
                        _this2._annotationsPointerEventHandler(event)
                    });
                    this._annotationsGroup.on(POINTER_ACTION, this._annotationsPointerEventHandler.bind(this))
                },
                _renderExtraElements: function() {
                    var _this3 = this;
                    this._annotationsGroup.clear();
                    this._annotations.items.forEach(function(item) {
                        return item.draw(_this3, _this3._annotationsGroup)
                    })
                },
                _stopCurrentHandling: function() {
                    this._annotations.hideTooltip()
                }
            },
            members: {
                _buildAnnotations: function() {
                    this._annotations.clearItems();
                    var items = this._getOption("annotations", true);
                    if (!(null !== items && void 0 !== items && items.length)) {
                        return
                    }
                    this._annotations.items = createAnnotations(this, items, this._getOption("commonAnnotationSettings"), this._getOption("customizeAnnotation", true), this._pullOptions)
                },
                _setAnnotationTooltipOptions: function() {
                    var tooltipOptions = (0, _extend.extend)({}, this._getOption("tooltip"));
                    tooltipOptions.contentTemplate = tooltipOptions.customizeTooltip = void 0;
                    this._annotations.tooltip.update(tooltipOptions)
                },
                _getAnnotationCoords: function() {
                    return {}
                },
                _pullOptions: function() {
                    return {}
                },
                _getAnnotationStyles: function() {
                    return {}
                }
            },
            customize: function(constructor) {
                constructor.addChange({
                    code: "ANNOTATIONITEMS",
                    handler: function() {
                        this._requestChange(["ANNOTATIONS"])
                    },
                    isOptionChange: true,
                    option: "annotations"
                });
                constructor.addChange({
                    code: "ANNOTATIONSSETTINGS",
                    handler: function() {
                        this._requestChange(["ANNOTATIONS"])
                    },
                    isOptionChange: true,
                    option: "commonAnnotationSettings"
                });
                constructor.addChange({
                    code: "ANNOTATIONS",
                    handler: function() {
                        this._buildAnnotations();
                        this._setAnnotationTooltipOptions();
                        this._forceAnnotationRender()
                    },
                    isThemeDependent: true,
                    isOptionChange: true
                })
            },
            fontFields: ["commonAnnotationSettings.font"]
        };
        var plugins = {
            core: corePlugin,
            chart: chartPlugin,
            polarChart: polarChartPlugin,
            vectorMap: vectorMapPlugin,
            pieChart: pieChartPlugin
        };
        exports.plugins = plugins
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/range_selector/common.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.formatValue = exports.consts = exports.utils = exports.HEIGHT_COMPACT_MODE = void 0;
        var _smart_formatter = __webpack_require__( /*! ../axes/smart_formatter */ 468);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var HEIGHT_COMPACT_MODE = 24;
        exports.HEIGHT_COMPACT_MODE = HEIGHT_COMPACT_MODE;
        var POINTER_SIZE = 4;
        var EMPTY_SLIDER_MARKER_TEXT = ". . .";
        var utils = {
            trackerSettings: {
                fill: "grey",
                stroke: "grey",
                opacity: 1e-4
            },
            animationSettings: {
                duration: 250
            }
        };
        exports.utils = utils;
        var consts = {
            emptySliderMarkerText: EMPTY_SLIDER_MARKER_TEXT,
            pointerSize: POINTER_SIZE
        };
        exports.consts = consts;
        var formatValue = function(value, formatOptions, tickIntervalsInfo, valueType, type, logarithmBase) {
            var formatObject = {
                value: value,
                valueText: (0, _smart_formatter.smartFormatter)(value, {
                    labelOptions: formatOptions,
                    ticks: tickIntervalsInfo ? tickIntervalsInfo.ticks : [],
                    tickInterval: tickIntervalsInfo ? tickIntervalsInfo.tickInterval : void 0,
                    dataType: valueType,
                    type: type,
                    logarithmBase: logarithmBase
                })
            };
            return String((0, _type.isFunction)(formatOptions.customizeText) ? formatOptions.customizeText.call(formatObject, formatObject) : formatObject.valueText)
        };
        exports.formatValue = formatValue
    },
    /*!*************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/tree_map/colorizing.js ***!
      \*************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getColorizer = getColorizer;
        exports.addColorizer = addColorizer;
        exports.setDefaultColorizer = setDefaultColorizer;
        exports.createColorCodeGetter = createColorCodeGetter;
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var colorizers = {};
        var defaultColorizerName;

        function wrapLeafColorGetter(getter) {
            return function(node) {
                return !node.isNode() ? getter(node) : void 0
            }
        }

        function wrapGroupColorGetter(getter) {
            return function(node) {
                var parent = !node.isNode() && node.parent;
                return parent ? parent._groupColor = parent._groupColor || getter(parent) : void 0
            }
        }

        function getColorizer(options, themeManager, root) {
            var type = (0, _utils.normalizeEnum)(options.type || defaultColorizerName);
            var colorizer = colorizers[type] && colorizers[type](options, themeManager, root);
            return colorizer ? (options.colorizeGroups ? wrapGroupColorGetter : wrapLeafColorGetter)(colorizer) : _common.noop
        }

        function addColorizer(name, colorizer) {
            colorizers[name] = colorizer
        }

        function setDefaultColorizer(name) {
            defaultColorizerName = name
        }

        function getValueAsColorCode(node) {
            return node.value
        }

        function createColorCode(colorCodeField) {
            return function(node) {
                return Number(node.data[colorCodeField])
            }
        }

        function createColorCodeGetter(options) {
            return options.colorCodeField ? createColorCode(options.colorCodeField) : getValueAsColorCode
        }
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/localization/ldml/date.parser.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getParser = exports.getPatternSetters = exports.getRegExpInfo = void 0;
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var FORMAT_TYPES = {
            3: "abbreviated",
            4: "wide",
            5: "narrow"
        };
        var monthRegExpGenerator = function(count, dateParts) {
            if (count > 2) {
                return Object.keys(FORMAT_TYPES).map(function(count) {
                    return ["format", "standalone"].map(function(type) {
                        return dateParts.getMonthNames(FORMAT_TYPES[count], type).join("|")
                    }).join("|")
                }).join("|")
            }
            return "0?[1-9]|1[012]"
        };
        var PATTERN_REGEXPS = {
            y: function(count) {
                return "[0-9]+"
            },
            M: monthRegExpGenerator,
            L: monthRegExpGenerator,
            Q: function(count, dateParts) {
                if (count > 2) {
                    return dateParts.getQuarterNames(FORMAT_TYPES[count], "format").join("|")
                }
                return "0?[1-4]"
            },
            E: function(count, dateParts) {
                return "\\D*"
            },
            a: function(count, dateParts) {
                return dateParts.getPeriodNames(FORMAT_TYPES[count < 3 ? 3 : count], "format").join("|")
            },
            d: function(count) {
                return "0?[1-9]|[12][0-9]|3[01]"
            },
            H: function(count) {
                return "0?[0-9]|1[0-9]|2[0-3]"
            },
            h: function(count) {
                return "0?[1-9]|1[012]"
            },
            m: function(count) {
                return "0?[0-9]|[1-5][0-9]"
            },
            s: function(count) {
                return "0?[0-9]|[1-5][0-9]"
            },
            S: function(count) {
                return "[0-9]{1," + count + "}"
            },
            w: function(count) {
                return "0?[0-9]|[1-5][0-9]"
            }
        };
        var parseNumber = Number;
        var caseInsensitiveIndexOf = function(array, value) {
            return array.map(function(item) {
                return item.toLowerCase()
            }).indexOf(value.toLowerCase())
        };
        var monthPatternParser = function(text, count, dateParts) {
            if (count > 2) {
                return ["format", "standalone"].map(function(type) {
                    return Object.keys(FORMAT_TYPES).map(function(count) {
                        var monthNames = dateParts.getMonthNames(FORMAT_TYPES[count], type);
                        return caseInsensitiveIndexOf(monthNames, text)
                    })
                }).reduce(function(a, b) {
                    return a.concat(b)
                }).filter(function(index) {
                    return index >= 0
                })[0]
            }
            return parseNumber(text) - 1
        };
        var PATTERN_PARSERS = {
            y: function(text, count) {
                var year = parseNumber(text);
                if (2 === count) {
                    return year < 30 ? 2e3 + year : 1900 + year
                }
                return year
            },
            M: monthPatternParser,
            L: monthPatternParser,
            Q: function(text, count, dateParts) {
                if (count > 2) {
                    return dateParts.getQuarterNames(FORMAT_TYPES[count], "format").indexOf(text)
                }
                return parseNumber(text) - 1
            },
            E: function(text, count, dateParts) {
                var dayNames = dateParts.getDayNames(FORMAT_TYPES[count < 3 ? 3 : count], "format");
                return caseInsensitiveIndexOf(dayNames, text)
            },
            a: function(text, count, dateParts) {
                var periodNames = dateParts.getPeriodNames(FORMAT_TYPES[count < 3 ? 3 : count], "format");
                return caseInsensitiveIndexOf(periodNames, text)
            },
            d: parseNumber,
            H: parseNumber,
            h: parseNumber,
            m: parseNumber,
            s: parseNumber,
            S: function(text, count) {
                count = Math.max(count, 3);
                text = text.slice(0, 3);
                while (count < 3) {
                    text += "0";
                    count++
                }
                return parseNumber(text)
            }
        };
        var ORDERED_PATTERNS = ["y", "M", "d", "h", "m", "s", "S"];
        var PATTERN_SETTERS = {
            y: "setFullYear",
            M: "setMonth",
            L: "setMonth",
            a: function(date, value, datePartValues) {
                var hours = date.getHours();
                var hourPartValue = datePartValues.h;
                if (void 0 !== hourPartValue && hourPartValue !== hours) {
                    hours--
                }
                if (!value && 12 === hours) {
                    hours = 0
                } else {
                    if (value && 12 !== hours) {
                        hours += 12
                    }
                }
                date.setHours(hours)
            },
            d: "setDate",
            H: "setHours",
            h: "setHours",
            m: "setMinutes",
            s: "setSeconds",
            S: "setMilliseconds"
        };
        var getSameCharCount = function(text, index) {
            var char = text[index];
            var count = 0;
            do {
                index++;
                count++
            } while (text[index] === char);
            return count
        };
        var createPattern = function(char, count) {
            var result = "";
            for (var i = 0; i < count; i++) {
                result += char
            }
            return result
        };
        var getRegExpInfo = function(format, dateParts) {
            var regexpText = "";
            var stubText = "";
            var isEscaping;
            var patterns = [];
            var addPreviousStub = function() {
                if (stubText) {
                    patterns.push("'" + stubText + "'");
                    regexpText += (0, _common.escapeRegExp)(stubText) + ")";
                    stubText = ""
                }
            };
            for (var i = 0; i < format.length; i++) {
                var char = format[i];
                var isEscapeChar = "'" === char;
                var regexpPart = PATTERN_REGEXPS[char];
                if (isEscapeChar) {
                    isEscaping = !isEscaping;
                    if ("'" !== format[i - 1]) {
                        continue
                    }
                }
                if (regexpPart && !isEscaping) {
                    var count = getSameCharCount(format, i);
                    var pattern = createPattern(char, count);
                    addPreviousStub();
                    patterns.push(pattern);
                    regexpText += "(" + regexpPart(count, dateParts) + ")";
                    i += count - 1
                } else {
                    if (!stubText) {
                        regexpText += "("
                    }
                    stubText += char
                }
            }
            addPreviousStub();
            return {
                patterns: patterns,
                regexp: new RegExp("^" + regexpText + "$", "i")
            }
        };
        exports.getRegExpInfo = getRegExpInfo;
        var getPatternSetters = function() {
            return PATTERN_SETTERS
        };
        exports.getPatternSetters = getPatternSetters;
        var setPatternPart = function(date, pattern, text, dateParts, datePartValues) {
            var patternChar = pattern[0];
            var partSetter = PATTERN_SETTERS[patternChar];
            var partParser = PATTERN_PARSERS[patternChar];
            if (partSetter && partParser) {
                var value = partParser(text, pattern.length, dateParts);
                datePartValues[pattern] = value;
                if (date[partSetter]) {
                    date[partSetter](value)
                } else {
                    partSetter(date, value, datePartValues)
                }
            }
        };
        var setPatternPartFromNow = function(date, pattern, now) {
            var setterName = PATTERN_SETTERS[pattern];
            var getterName = "g" + setterName.substr(1);
            var value = now[getterName]();
            date[setterName](value)
        };
        var getShortPatterns = function(fullPatterns) {
            return fullPatterns.map(function(pattern) {
                if ("'" === pattern[0]) {
                    return ""
                } else {
                    return "H" === pattern[0] ? "h" : pattern[0]
                }
            })
        };
        var getMaxOrderedPatternIndex = function(patterns) {
            var indexes = patterns.map(function(pattern) {
                return ORDERED_PATTERNS.indexOf(pattern)
            });
            return Math.max.apply(Math, indexes)
        };
        var getOrderedFormatPatterns = function(formatPatterns) {
            var otherPatterns = formatPatterns.filter(function(pattern) {
                return ORDERED_PATTERNS.indexOf(pattern) < 0
            });
            return ORDERED_PATTERNS.concat(otherPatterns)
        };
        var getParser = function(format, dateParts) {
            var regExpInfo = getRegExpInfo(format, dateParts);
            return function(text) {
                var regExpResult = regExpInfo.regexp.exec(text);
                if (regExpResult) {
                    var now = new Date;
                    var date = new Date(now.getFullYear(), 0, 1);
                    var formatPatterns = getShortPatterns(regExpInfo.patterns);
                    var maxPatternIndex = getMaxOrderedPatternIndex(formatPatterns);
                    var orderedFormatPatterns = getOrderedFormatPatterns(formatPatterns);
                    var datePartValues = {};
                    orderedFormatPatterns.forEach(function(pattern, index) {
                        if (!pattern || index < ORDERED_PATTERNS.length && index > maxPatternIndex) {
                            return
                        }
                        var patternIndex = formatPatterns.indexOf(pattern);
                        if (patternIndex >= 0) {
                            var regExpPattern = regExpInfo.patterns[patternIndex];
                            var regExpText = regExpResult[patternIndex + 1];
                            setPatternPart(date, regExpPattern, regExpText, dateParts, datePartValues)
                        } else {
                            setPatternPartFromNow(date, pattern, now)
                        }
                    });
                    return date
                }
                return null
            }
        };
        exports.getParser = getParser
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/mobile/hide_callback.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.hideCallback = void 0;
        var _array = __webpack_require__( /*! ../core/utils/array */ 12);
        var hideCallback = function() {
            var callbacks = [];
            return {
                add: function(callback) {
                    var indexOfCallback = (0, _array.inArray)(callback, callbacks);
                    if (indexOfCallback === -1) {
                        callbacks.push(callback)
                    }
                },
                remove: function(callback) {
                    var indexOfCallback = (0, _array.inArray)(callback, callbacks);
                    if (indexOfCallback !== -1) {
                        callbacks.splice(indexOfCallback, 1)
                    }
                },
                fire: function() {
                    var callback = callbacks.pop();
                    var result = !!callback;
                    if (result) {
                        callback()
                    }
                    return result
                },
                hasCallback: function() {
                    return callbacks.length > 0
                }
            }
        }();
        exports.hideCallback = hideCallback
    },
    /*!************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/selection/selection.js ***!
      \************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _selectionStrategy = _interopRequireDefault(__webpack_require__( /*! ./selection.strategy.deferred */ 551));
        var _selectionStrategy2 = _interopRequireDefault(__webpack_require__( /*! ./selection.strategy.standard */ 552));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _class.default.inherit({
            ctor: function(options) {
                this.options = (0, _extend.extend)(this._getDefaultOptions(), options, {
                    selectedItemKeys: options.selectedKeys || []
                });
                this._selectionStrategy = this.options.deferred ? new _selectionStrategy.default(this.options) : new _selectionStrategy2.default(this.options);
                this._focusedItemIndex = -1;
                if (!this.options.equalByReference) {
                    this._selectionStrategy.updateSelectedItemKeyHash(this.options.selectedItemKeys)
                }
            },
            _getDefaultOptions: function() {
                return {
                    allowNullValue: false,
                    deferred: false,
                    equalByReference: false,
                    mode: "multiple",
                    selectedItems: [],
                    selectionFilter: [],
                    maxFilterLengthInRequest: 0,
                    onSelectionChanged: _common.noop,
                    key: _common.noop,
                    keyOf: function(item) {
                        return item
                    },
                    load: function() {
                        return (new _deferred.Deferred).resolve([])
                    },
                    totalCount: function() {
                        return -1
                    },
                    isSelectableItem: function() {
                        return true
                    },
                    isItemSelected: function() {
                        return false
                    },
                    getItemData: function(item) {
                        return item
                    },
                    dataFields: _common.noop,
                    filter: _common.noop
                }
            },
            validate: function() {
                this._selectionStrategy.validate()
            },
            getSelectedItemKeys: function() {
                return this._selectionStrategy.getSelectedItemKeys()
            },
            getSelectedItems: function() {
                return this._selectionStrategy.getSelectedItems()
            },
            selectionFilter: function(value) {
                if (void 0 === value) {
                    return this.options.selectionFilter
                }
                var filterIsChanged = this.options.selectionFilter !== value && JSON.stringify(this.options.selectionFilter) !== JSON.stringify(value);
                this.options.selectionFilter = value;
                filterIsChanged && this.onSelectionChanged()
            },
            setSelection: function(keys) {
                return this.selectedItemKeys(keys)
            },
            select: function(keys) {
                return this.selectedItemKeys(keys, true)
            },
            deselect: function(keys) {
                return this.selectedItemKeys(keys, true, true)
            },
            selectedItemKeys: function(keys, preserve, isDeselect, isSelectAll) {
                var _keys;
                var that = this;
                keys = null !== (_keys = keys) && void 0 !== _keys ? _keys : [];
                keys = Array.isArray(keys) ? keys : [keys];
                that.validate();
                return this._selectionStrategy.selectedItemKeys(keys, preserve, isDeselect, isSelectAll)
            },
            clearSelection: function() {
                return this.selectedItemKeys([])
            },
            _addSelectedItem: function(itemData, key) {
                this._selectionStrategy.addSelectedItem(key, itemData)
            },
            _removeSelectedItem: function(key) {
                this._selectionStrategy.removeSelectedItem(key)
            },
            _setSelectedItems: function(keys, items) {
                this._selectionStrategy.setSelectedItems(keys, items)
            },
            onSelectionChanged: function() {
                this._selectionStrategy.onSelectionChanged()
            },
            changeItemSelection: function(itemIndex, keys) {
                var isSelectedItemsChanged;
                var items = this.options.plainItems();
                var item = items[itemIndex];
                if (!this.isSelectable() || !this.isDataItem(item)) {
                    return false
                }
                var itemData = this.options.getItemData(item);
                var itemKey = this.options.keyOf(itemData);
                keys = keys || {};
                if (keys.shift && "multiple" === this.options.mode && this._focusedItemIndex >= 0) {
                    isSelectedItemsChanged = this.changeItemSelectionWhenShiftKeyPressed(itemIndex, items)
                } else {
                    if (keys.control) {
                        this._resetItemSelectionWhenShiftKeyPressed();
                        var isSelected = this._selectionStrategy.isItemDataSelected(itemData);
                        if ("single" === this.options.mode) {
                            this.clearSelectedItems()
                        }
                        if (isSelected) {
                            this._removeSelectedItem(itemKey)
                        } else {
                            this._addSelectedItem(itemData, itemKey)
                        }
                        isSelectedItemsChanged = true
                    } else {
                        this._resetItemSelectionWhenShiftKeyPressed();
                        var isKeysEqual = this._selectionStrategy.equalKeys(this.options.selectedItemKeys[0], itemKey);
                        if (1 !== this.options.selectedItemKeys.length || !isKeysEqual) {
                            this._setSelectedItems([itemKey], [itemData]);
                            isSelectedItemsChanged = true
                        }
                    }
                }
                if (isSelectedItemsChanged) {
                    this._focusedItemIndex = itemIndex;
                    this.onSelectionChanged();
                    return true
                }
            },
            isDataItem: function(item) {
                return this.options.isSelectableItem(item)
            },
            isSelectable: function() {
                return "single" === this.options.mode || "multiple" === this.options.mode
            },
            isItemDataSelected: function(data) {
                return this._selectionStrategy.isItemDataSelected(data, {
                    checkPending: true
                })
            },
            isItemSelected: function(arg, options) {
                return this._selectionStrategy.isItemKeySelected(arg, options)
            },
            _resetItemSelectionWhenShiftKeyPressed: function() {
                delete this._shiftFocusedItemIndex
            },
            _resetFocusedItemIndex: function() {
                this._focusedItemIndex = -1
            },
            changeItemSelectionWhenShiftKeyPressed: function(itemIndex, items) {
                var isSelectedItemsChanged = false;
                var itemIndexStep;
                var index;
                var keyOf = this.options.keyOf;
                var focusedItem = items[this._focusedItemIndex];
                var focusedData = this.options.getItemData(focusedItem);
                var focusedKey = keyOf(focusedData);
                var isFocusedItemSelected = focusedItem && this.isItemDataSelected(focusedData);
                if (!(0, _type.isDefined)(this._shiftFocusedItemIndex)) {
                    this._shiftFocusedItemIndex = this._focusedItemIndex
                }
                var data;
                var itemKey;
                if (this._shiftFocusedItemIndex !== this._focusedItemIndex) {
                    itemIndexStep = this._focusedItemIndex < this._shiftFocusedItemIndex ? 1 : -1;
                    for (index = this._focusedItemIndex; index !== this._shiftFocusedItemIndex; index += itemIndexStep) {
                        if (this.isDataItem(items[index])) {
                            itemKey = keyOf(this.options.getItemData(items[index]));
                            this._removeSelectedItem(itemKey);
                            isSelectedItemsChanged = true
                        }
                    }
                }
                if (itemIndex !== this._shiftFocusedItemIndex) {
                    itemIndexStep = itemIndex < this._shiftFocusedItemIndex ? 1 : -1;
                    for (index = itemIndex; index !== this._shiftFocusedItemIndex; index += itemIndexStep) {
                        if (this.isDataItem(items[index])) {
                            data = this.options.getItemData(items[index]);
                            itemKey = keyOf(data);
                            this._addSelectedItem(data, itemKey);
                            isSelectedItemsChanged = true
                        }
                    }
                }
                if (this.isDataItem(focusedItem) && !isFocusedItemSelected) {
                    this._addSelectedItem(focusedData, focusedKey);
                    isSelectedItemsChanged = true
                }
                return isSelectedItemsChanged
            },
            clearSelectedItems: function() {
                this._setSelectedItems([], [])
            },
            selectAll: function(isOnePage) {
                this._resetFocusedItemIndex();
                if (isOnePage) {
                    return this._onePageSelectAll(false)
                } else {
                    return this.selectedItemKeys([], true, false, true)
                }
            },
            deselectAll: function(isOnePage) {
                this._resetFocusedItemIndex();
                if (isOnePage) {
                    return this._onePageSelectAll(true)
                } else {
                    return this.selectedItemKeys([], true, true, true)
                }
            },
            _onePageSelectAll: function(isDeselect) {
                var items = this._selectionStrategy.getSelectableItems(this.options.plainItems());
                for (var i = 0; i < items.length; i++) {
                    var item = items[i];
                    if (this.isDataItem(item)) {
                        var itemData = this.options.getItemData(item);
                        var itemKey = this.options.keyOf(itemData);
                        var isSelected = this.isItemSelected(itemKey);
                        if (!isSelected && !isDeselect) {
                            this._addSelectedItem(itemData, itemKey)
                        }
                        if (isSelected && isDeselect) {
                            this._removeSelectedItem(itemKey)
                        }
                    }
                }
                this.onSelectionChanged();
                return (new _deferred.Deferred).resolve()
            },
            getSelectAllState: function(visibleOnly) {
                return this._selectionStrategy.getSelectAllState(visibleOnly)
            }
        });
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/array_compare.js ***!
      \**************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.findChanges = exports.isKeysEqual = void 0;
        var _type = __webpack_require__( /*! ./type */ 1);
        var getKeyWrapper = function(item, getKey) {
            var key = getKey(item);
            if ((0, _type.isObject)(key)) {
                try {
                    return JSON.stringify(key)
                } catch (e) {
                    return key
                }
            }
            return key
        };
        var getSameNewByOld = function(oldItem, newItems, newIndexByKey, getKey) {
            var key = getKeyWrapper(oldItem, getKey);
            return newItems[newIndexByKey[key]]
        };
        var isKeysEqual = function(oldKeys, newKeys) {
            if (oldKeys.length !== newKeys.length) {
                return false
            }
            for (var i = 0; i < newKeys.length; i++) {
                if (oldKeys[i] !== newKeys[i]) {
                    return false
                }
            }
            return true
        };
        exports.isKeysEqual = isKeysEqual;
        var findChanges = function(oldItems, newItems, getKey, isItemEquals) {
            var oldIndexByKey = {};
            var newIndexByKey = {};
            var addedCount = 0;
            var removeCount = 0;
            var result = [];
            oldItems.forEach(function(item, index) {
                var key = getKeyWrapper(item, getKey);
                oldIndexByKey[key] = index
            });
            newItems.forEach(function(item, index) {
                var key = getKeyWrapper(item, getKey);
                newIndexByKey[key] = index
            });
            var itemCount = Math.max(oldItems.length, newItems.length);
            for (var index = 0; index < itemCount + addedCount; index++) {
                var newItem = newItems[index];
                var oldNextIndex = index - addedCount + removeCount;
                var nextOldItem = oldItems[oldNextIndex];
                var isRemoved = !newItem || nextOldItem && !getSameNewByOld(nextOldItem, newItems, newIndexByKey, getKey);
                if (isRemoved) {
                    if (nextOldItem) {
                        result.push({
                            type: "remove",
                            key: getKey(nextOldItem),
                            index: index,
                            oldItem: nextOldItem
                        });
                        removeCount++;
                        index--
                    }
                } else {
                    var key = getKeyWrapper(newItem, getKey);
                    var oldIndex = oldIndexByKey[key];
                    var oldItem = oldItems[oldIndex];
                    if (!oldItem) {
                        addedCount++;
                        result.push({
                            type: "insert",
                            data: newItem,
                            index: index
                        })
                    } else {
                        if (oldIndex === oldNextIndex) {
                            if (!isItemEquals(oldItem, newItem)) {
                                result.push({
                                    type: "update",
                                    data: newItem,
                                    key: getKey(newItem),
                                    index: index,
                                    oldItem: oldItem
                                })
                            }
                        } else {
                            return
                        }
                    }
                }
            }
            return result
        };
        exports.findChanges = findChanges
    },
    /*!****************************************************************!*\
      !*** ./artifacts/transpiled-npm/bundles/modules/parts/core.js ***!
      \****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var DevExpress = __webpack_require__( /*! ../../../bundles/modules/core */ 154);
        __webpack_require__( /*! ../../../integration/jquery */ 257);
        __webpack_require__( /*! ../../../integration/angular */ 544);
        __webpack_require__( /*! ../../../integration/knockout */ 556);
        __webpack_require__( /*! ../../../localization/globalize/core */ 134);
        __webpack_require__( /*! ../../../localization/globalize/message */ 565);
        __webpack_require__( /*! ../../../localization/globalize/number */ 203);
        __webpack_require__( /*! ../../../localization/globalize/date */ 566);
        __webpack_require__( /*! ../../../localization/globalize/currency */ 567);
        __webpack_require__( /*! ../../../events/click */ 21);
        __webpack_require__( /*! ../../../events/contextmenu */ 179);
        __webpack_require__( /*! ../../../events/double_click */ 151);
        __webpack_require__( /*! ../../../events/drag */ 76);
        __webpack_require__( /*! ../../../events/hold */ 104);
        __webpack_require__( /*! ../../../events/hover */ 155);
        __webpack_require__( /*! ../../../events/pointer */ 24);
        __webpack_require__( /*! ../../../events/swipe */ 194);
        __webpack_require__( /*! ../../../events/transform */ 331);
        module.exports = DevExpress
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/core/renderer_base.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _element_data = __webpack_require__( /*! ./element_data */ 40);
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ./dom_adapter */ 11));
        var _window = __webpack_require__( /*! ./utils/window */ 7);
        var _type = __webpack_require__( /*! ./utils/type */ 1);
        var _style = __webpack_require__( /*! ./utils/style */ 99);
        var _size = __webpack_require__( /*! ./utils/size */ 192);
        var _html_parser = __webpack_require__( /*! ./utils/html_parser */ 238);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var renderer;
        var initRender = function(selector, context) {
            if (!selector) {
                this.length = 0;
                return this
            }
            if ("string" === typeof selector) {
                if ("body" === selector) {
                    this[0] = context ? context.body : _dom_adapter.default.getBody();
                    this.length = 1;
                    return this
                }
                context = context || _dom_adapter.default.getDocument();
                if ("<" === selector[0]) {
                    this[0] = _dom_adapter.default.createElement(selector.slice(1, -1), context);
                    this.length = 1;
                    return this
                } [].push.apply(this, _dom_adapter.default.querySelectorAll(context, selector));
                return this
            } else {
                if (_dom_adapter.default.isNode(selector) || (0, _type.isWindow)(selector)) {
                    this[0] = selector;
                    this.length = 1;
                    return this
                } else {
                    if (Array.isArray(selector)) {
                        [].push.apply(this, selector);
                        return this
                    }
                }
            }
            return renderer(selector.toArray ? selector.toArray() : [selector])
        };
        renderer = function(selector, context) {
            return new initRender(selector, context)
        };
        renderer.fn = {
            dxRenderer: true
        };
        initRender.prototype = renderer.fn;
        var repeatMethod = function(methodName, args) {
            for (var i = 0; i < this.length; i++) {
                var item = renderer(this[i]);
                item[methodName].apply(item, args)
            }
            return this
        };
        var setAttributeValue = function(element, attrName, value) {
            if (void 0 !== value && null !== value) {
                _dom_adapter.default.setAttribute(element, attrName, value)
            } else {
                _dom_adapter.default.removeAttribute(element, attrName)
            }
        };
        initRender.prototype.show = function() {
            return this.toggle(true)
        };
        initRender.prototype.hide = function() {
            return this.toggle(false)
        };
        initRender.prototype.toggle = function(value) {
            if (this[0]) {
                this.toggleClass("dx-state-invisible", !value)
            }
            return this
        };
        initRender.prototype.attr = function(attrName, value) {
            if (this.length > 1 && arguments.length > 1) {
                return repeatMethod.call(this, "attr", arguments)
            }
            if (!this[0]) {
                if ((0, _type.isObject)(attrName) || void 0 !== value) {
                    return this
                } else {
                    return
                }
            }
            if (!this[0].getAttribute) {
                return this.prop(attrName, value)
            }
            if ("string" === typeof attrName && 1 === arguments.length) {
                var result = this[0].getAttribute(attrName);
                return null == result ? void 0 : result
            } else {
                if ((0, _type.isPlainObject)(attrName)) {
                    for (var key in attrName) {
                        this.attr(key, attrName[key])
                    }
                } else {
                    setAttributeValue(this[0], attrName, value)
                }
            }
            return this
        };
        initRender.prototype.removeAttr = function(attrName) {
            this[0] && _dom_adapter.default.removeAttribute(this[0], attrName);
            return this
        };
        initRender.prototype.prop = function(propName, value) {
            if (!this[0]) {
                return this
            }
            if ("string" === typeof propName && 1 === arguments.length) {
                return this[0][propName]
            } else {
                if ((0, _type.isPlainObject)(propName)) {
                    for (var key in propName) {
                        this.prop(key, propName[key])
                    }
                } else {
                    _dom_adapter.default.setProperty(this[0], propName, value)
                }
            }
            return this
        };
        initRender.prototype.addClass = function(className) {
            return this.toggleClass(className, true)
        };
        initRender.prototype.removeClass = function(className) {
            return this.toggleClass(className, false)
        };
        initRender.prototype.hasClass = function(className) {
            if (!this[0] || void 0 === this[0].className) {
                return false
            }
            var classNames = className.split(" ");
            for (var i = 0; i < classNames.length; i++) {
                if (this[0].classList) {
                    if (this[0].classList.contains(classNames[i])) {
                        return true
                    }
                } else {
                    var _className = (0, _type.isString)(this[0].className) ? this[0].className : _dom_adapter.default.getAttribute(this[0], "class");
                    if ((_className || "").split(" ").indexOf(classNames[i]) >= 0) {
                        return true
                    }
                }
            }
            return false
        };
        initRender.prototype.toggleClass = function(className, value) {
            if (this.length > 1) {
                return repeatMethod.call(this, "toggleClass", arguments)
            }
            if (!this[0] || !className) {
                return this
            }
            value = void 0 === value ? !this.hasClass(className) : value;
            var classNames = className.split(" ");
            for (var i = 0; i < classNames.length; i++) {
                _dom_adapter.default.setClass(this[0], classNames[i], value)
            }
            return this
        };
        ["width", "height", "outerWidth", "outerHeight", "innerWidth", "innerHeight"].forEach(function(methodName) {
            var partialName = methodName.toLowerCase().indexOf("width") >= 0 ? "Width" : "Height";
            var propName = partialName.toLowerCase();
            var isOuter = 0 === methodName.indexOf("outer");
            var isInner = 0 === methodName.indexOf("inner");
            initRender.prototype[methodName] = function(value) {
                if (this.length > 1 && arguments.length > 0) {
                    return repeatMethod.call(this, methodName, arguments)
                }
                var element = this[0];
                if (!element) {
                    return
                }
                if ((0, _type.isWindow)(element)) {
                    return isOuter ? element["inner" + partialName] : _dom_adapter.default.getDocumentElement()["client" + partialName]
                }
                if (_dom_adapter.default.isDocument(element)) {
                    var documentElement = _dom_adapter.default.getDocumentElement();
                    var body = _dom_adapter.default.getBody();
                    return Math.max(body["scroll" + partialName], body["offset" + partialName], documentElement["scroll" + partialName], documentElement["offset" + partialName], documentElement["client" + partialName])
                }
                if (0 === arguments.length || "boolean" === typeof value) {
                    var include = {
                        paddings: isInner || isOuter,
                        borders: isOuter,
                        margins: value
                    };
                    return (0, _size.getSize)(element, propName, include)
                }
                if (void 0 === value || null === value) {
                    return this
                }
                if ((0, _type.isNumeric)(value)) {
                    var elementStyles = window.getComputedStyle(element);
                    var sizeAdjustment = (0, _size.getElementBoxParams)(propName, elementStyles);
                    var isBorderBox = "border-box" === elementStyles.boxSizing;
                    value = Number(value);
                    if (isOuter) {
                        value -= isBorderBox ? 0 : sizeAdjustment.border + sizeAdjustment.padding
                    } else {
                        if (isInner) {
                            value += isBorderBox ? sizeAdjustment.border : -sizeAdjustment.padding
                        } else {
                            if (isBorderBox) {
                                value += sizeAdjustment.border + sizeAdjustment.padding
                            }
                        }
                    }
                }
                value += (0, _type.isNumeric)(value) ? "px" : "";
                _dom_adapter.default.setStyle(element, propName, value);
                return this
            }
        });
        initRender.prototype.html = function(value) {
            if (!arguments.length) {
                return this[0].innerHTML
            }
            this.empty();
            if ("string" === typeof value && !(0, _html_parser.isTablePart)(value) || "number" === typeof value) {
                this[0].innerHTML = value;
                return this
            }
            return this.append((0, _html_parser.parseHTML)(value))
        };
        var appendElements = function(element, nextSibling) {
            if (!this[0] || !element) {
                return
            }
            if ("string" === typeof element) {
                element = (0, _html_parser.parseHTML)(element)
            } else {
                if (element.nodeType) {
                    element = [element]
                } else {
                    if ((0, _type.isNumeric)(element)) {
                        element = [_dom_adapter.default.createTextNode(element)]
                    }
                }
            }
            for (var i = 0; i < element.length; i++) {
                var item = element[i];
                var container = this[0];
                var wrapTR = "TABLE" === container.tagName && "TR" === item.tagName;
                if (wrapTR && container.tBodies && container.tBodies.length) {
                    container = container.tBodies[0]
                }
                _dom_adapter.default.insertElement(container, item.nodeType ? item : item[0], nextSibling)
            }
        };
        var setCss = function(name, value) {
            if (!this[0] || !this[0].style) {
                return
            }
            if (null === value || "number" === typeof value && isNaN(value)) {
                return
            }
            name = (0, _style.styleProp)(name);
            for (var i = 0; i < this.length; i++) {
                this[i].style[name] = (0, _style.normalizeStyleProp)(name, value)
            }
        };
        initRender.prototype.css = function(name, value) {
            if ((0, _type.isString)(name)) {
                if (2 === arguments.length) {
                    setCss.call(this, name, value)
                } else {
                    if (!this[0]) {
                        return
                    }
                    name = (0, _style.styleProp)(name);
                    var result = window.getComputedStyle(this[0])[name] || this[0].style[name];
                    return (0, _type.isNumeric)(result) ? result.toString() : result
                }
            } else {
                if ((0, _type.isPlainObject)(name)) {
                    for (var key in name) {
                        setCss.call(this, key, name[key])
                    }
                }
            }
            return this
        };
        initRender.prototype.prepend = function(element) {
            if (arguments.length > 1) {
                for (var i = 0; i < arguments.length; i++) {
                    this.prepend(arguments[i])
                }
                return this
            }
            appendElements.apply(this, [element, this[0].firstChild]);
            return this
        };
        initRender.prototype.append = function(element) {
            if (arguments.length > 1) {
                for (var i = 0; i < arguments.length; i++) {
                    this.append(arguments[i])
                }
                return this
            }
            appendElements.apply(this, [element]);
            return this
        };
        initRender.prototype.prependTo = function(element) {
            if (this.length > 1) {
                for (var i = this.length - 1; i >= 0; i--) {
                    renderer(this[i]).prependTo(element)
                }
                return this
            }
            element = renderer(element);
            if (element[0]) {
                _dom_adapter.default.insertElement(element[0], this[0], element[0].firstChild)
            }
            return this
        };
        initRender.prototype.appendTo = function(element) {
            if (this.length > 1) {
                return repeatMethod.call(this, "appendTo", arguments)
            }
            _dom_adapter.default.insertElement(renderer(element)[0], this[0]);
            return this
        };
        initRender.prototype.insertBefore = function(element) {
            if (element && element[0]) {
                _dom_adapter.default.insertElement(element[0].parentNode, this[0], element[0])
            }
            return this
        };
        initRender.prototype.insertAfter = function(element) {
            if (element && element[0]) {
                _dom_adapter.default.insertElement(element[0].parentNode, this[0], element[0].nextSibling)
            }
            return this
        };
        initRender.prototype.before = function(element) {
            if (this[0]) {
                _dom_adapter.default.insertElement(this[0].parentNode, element[0], this[0])
            }
            return this
        };
        initRender.prototype.after = function(element) {
            if (this[0]) {
                _dom_adapter.default.insertElement(this[0].parentNode, element[0], this[0].nextSibling)
            }
            return this
        };
        initRender.prototype.wrap = function(wrapper) {
            if (this[0]) {
                var wrap = renderer(wrapper);
                wrap.insertBefore(this);
                wrap.append(this)
            }
            return this
        };
        initRender.prototype.wrapInner = function(wrapper) {
            var contents = this.contents();
            if (contents.length) {
                contents.wrap(wrapper)
            } else {
                this.append(wrapper)
            }
            return this
        };
        initRender.prototype.replaceWith = function(element) {
            if (!(element && element[0])) {
                return
            }
            if (element.is(this)) {
                return this
            }
            element.insertBefore(this);
            this.remove();
            return element
        };
        initRender.prototype.remove = function() {
            if (this.length > 1) {
                return repeatMethod.call(this, "remove", arguments)
            }(0, _element_data.cleanDataRecursive)(this[0], true);
            _dom_adapter.default.removeElement(this[0]);
            return this
        };
        initRender.prototype.detach = function() {
            if (this.length > 1) {
                return repeatMethod.call(this, "detach", arguments)
            }
            _dom_adapter.default.removeElement(this[0]);
            return this
        };
        initRender.prototype.empty = function() {
            if (this.length > 1) {
                return repeatMethod.call(this, "empty", arguments)
            }(0, _element_data.cleanDataRecursive)(this[0]);
            _dom_adapter.default.setText(this[0], "");
            return this
        };
        initRender.prototype.clone = function() {
            var result = [];
            for (var i = 0; i < this.length; i++) {
                result.push(this[i].cloneNode(true))
            }
            return renderer(result)
        };
        initRender.prototype.text = function(value) {
            if (!arguments.length) {
                var result = "";
                for (var i = 0; i < this.length; i++) {
                    result += this[i] && this[i].textContent || ""
                }
                return result
            }
            var text = (0, _type.isFunction)(value) ? value() : value;
            (0, _element_data.cleanDataRecursive)(this[0], false);
            _dom_adapter.default.setText(this[0], (0, _type.isDefined)(text) ? text : "");
            return this
        };
        initRender.prototype.val = function(value) {
            if (1 === arguments.length) {
                return this.prop("value", (0, _type.isDefined)(value) ? value : "")
            }
            return this.prop("value")
        };
        initRender.prototype.contents = function() {
            if (!this[0]) {
                return renderer()
            }
            var result = [];
            result.push.apply(result, this[0].childNodes);
            return renderer(result)
        };
        initRender.prototype.find = function(selector) {
            var result = renderer();
            if (!selector) {
                return result
            }
            var nodes = [];
            var i;
            if ("string" === typeof selector) {
                selector = selector.trim();
                for (i = 0; i < this.length; i++) {
                    var element = this[i];
                    if (_dom_adapter.default.isElementNode(element)) {
                        var elementId = element.getAttribute("id");
                        var queryId = elementId || "dx-query-children";
                        if (!elementId) {
                            setAttributeValue(element, "id", queryId)
                        }
                        queryId = "[id='" + queryId + "'] ";
                        var querySelector = queryId + selector.replace(/([^\\])(,)/g, "$1, " + queryId);
                        nodes.push.apply(nodes, _dom_adapter.default.querySelectorAll(element, querySelector));
                        setAttributeValue(element, "id", elementId)
                    } else {
                        if (_dom_adapter.default.isDocument(element)) {
                            nodes.push.apply(nodes, _dom_adapter.default.querySelectorAll(element, selector))
                        }
                    }
                }
            } else {
                for (i = 0; i < this.length; i++) {
                    selector = _dom_adapter.default.isNode(selector) ? selector : selector[0];
                    if (this[i] !== selector && this[i].contains(selector)) {
                        nodes.push(selector)
                    }
                }
            }
            return result.add(nodes)
        };
        var isVisible = function(_, element) {
            if (!element.nodeType) {
                return true
            }
            return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length)
        };
        initRender.prototype.filter = function(selector) {
            if (!selector) {
                return renderer()
            }
            if (":visible" === selector) {
                return this.filter(isVisible)
            } else {
                if (":hidden" === selector) {
                    return this.filter(function(_, element) {
                        return !isVisible(_, element)
                    })
                }
            }
            var result = [];
            for (var i = 0; i < this.length; i++) {
                var item = this[i];
                if (_dom_adapter.default.isElementNode(item) && "string" === (0, _type.type)(selector)) {
                    _dom_adapter.default.elementMatches(item, selector) && result.push(item)
                } else {
                    if (_dom_adapter.default.isNode(selector) || (0, _type.isWindow)(selector)) {
                        selector === item && result.push(item)
                    } else {
                        if ((0, _type.isFunction)(selector)) {
                            selector.call(item, i, item) && result.push(item)
                        } else {
                            for (var j = 0; j < selector.length; j++) {
                                selector[j] === item && result.push(item)
                            }
                        }
                    }
                }
            }
            return renderer(result)
        };
        initRender.prototype.not = function(selector) {
            var result = [];
            var nodes = this.filter(selector).toArray();
            for (var i = 0; i < this.length; i++) {
                if (nodes.indexOf(this[i]) === -1) {
                    result.push(this[i])
                }
            }
            return renderer(result)
        };
        initRender.prototype.is = function(selector) {
            return !!this.filter(selector).length
        };
        initRender.prototype.children = function(selector) {
            var result = [];
            for (var i = 0; i < this.length; i++) {
                var nodes = this[i] ? this[i].childNodes : [];
                for (var j = 0; j < nodes.length; j++) {
                    if (_dom_adapter.default.isElementNode(nodes[j])) {
                        result.push(nodes[j])
                    }
                }
            }
            result = renderer(result);
            return selector ? result.filter(selector) : result
        };
        initRender.prototype.siblings = function() {
            var element = this[0];
            if (!element || !element.parentNode) {
                return renderer()
            }
            var result = [];
            var parentChildNodes = element.parentNode.childNodes || [];
            for (var i = 0; i < parentChildNodes.length; i++) {
                var node = parentChildNodes[i];
                if (_dom_adapter.default.isElementNode(node) && node !== element) {
                    result.push(node)
                }
            }
            return renderer(result)
        };
        initRender.prototype.each = function(callback) {
            for (var i = 0; i < this.length; i++) {
                if (false === callback.call(this[i], i, this[i])) {
                    break
                }
            }
        };
        initRender.prototype.index = function(element) {
            if (!element) {
                return this.parent().children().index(this)
            }
            element = renderer(element);
            return this.toArray().indexOf(element[0])
        };
        initRender.prototype.get = function(index) {
            return this[index < 0 ? this.length + index : index]
        };
        initRender.prototype.eq = function(index) {
            index = index < 0 ? this.length + index : index;
            return renderer(this[index])
        };
        initRender.prototype.first = function() {
            return this.eq(0)
        };
        initRender.prototype.last = function() {
            return this.eq(-1)
        };
        initRender.prototype.parent = function(selector) {
            if (!this[0]) {
                return renderer()
            }
            var result = renderer(this[0].parentNode);
            return !selector || result.is(selector) ? result : renderer()
        };
        initRender.prototype.parents = function(selector) {
            var result = [];
            var parent = this.parent();
            while (parent && parent[0] && !_dom_adapter.default.isDocument(parent[0])) {
                if (_dom_adapter.default.isElementNode(parent[0])) {
                    if (!selector || selector && parent.is(selector)) {
                        result.push(parent.get(0))
                    }
                }
                parent = parent.parent()
            }
            return renderer(result)
        };
        initRender.prototype.closest = function(selector) {
            if (this.is(selector)) {
                return this
            }
            var parent = this.parent();
            while (parent && parent.length) {
                if (parent.is(selector)) {
                    return parent
                }
                parent = parent.parent()
            }
            return renderer()
        };
        initRender.prototype.next = function(selector) {
            if (!this[0]) {
                return renderer()
            }
            var next = renderer(this[0].nextSibling);
            if (!arguments.length) {
                return next
            }
            while (next && next.length) {
                if (next.is(selector)) {
                    return next
                }
                next = next.next()
            }
            return renderer()
        };
        initRender.prototype.prev = function() {
            if (!this[0]) {
                return renderer()
            }
            return renderer(this[0].previousSibling)
        };
        initRender.prototype.add = function(selector) {
            var targets = renderer(selector);
            var result = this.toArray();
            for (var i = 0; i < targets.length; i++) {
                var target = targets[i];
                if (result.indexOf(target) === -1) {
                    result.push(target)
                }
            }
            return renderer(result)
        };
        var emptyArray = [];
        initRender.prototype.splice = function() {
            return renderer(emptyArray.splice.apply(this, arguments))
        };
        initRender.prototype.slice = function() {
            return renderer(emptyArray.slice.apply(this, arguments))
        };
        initRender.prototype.toArray = function() {
            return emptyArray.slice.call(this)
        };
        var getWindowByElement = function(element) {
            return (0, _type.isWindow)(element) ? element : element.defaultView
        };
        initRender.prototype.offset = function() {
            if (!this[0]) {
                return
            }
            if (!this[0].getClientRects().length) {
                return {
                    top: 0,
                    left: 0
                }
            }
            var rect = this[0].getBoundingClientRect();
            var win = getWindowByElement(this[0].ownerDocument);
            var docElem = this[0].ownerDocument.documentElement;
            return {
                top: rect.top + win.pageYOffset - docElem.clientTop,
                left: rect.left + win.pageXOffset - docElem.clientLeft
            }
        };
        initRender.prototype.offsetParent = function() {
            if (!this[0]) {
                return renderer()
            }
            var offsetParent = renderer(this[0].offsetParent);
            while (offsetParent[0] && "static" === offsetParent.css("position")) {
                offsetParent = renderer(offsetParent[0].offsetParent)
            }
            offsetParent = offsetParent[0] ? offsetParent : renderer(_dom_adapter.default.getDocumentElement());
            return offsetParent
        };
        initRender.prototype.position = function() {
            if (!this[0]) {
                return
            }
            var offset;
            var marginTop = parseFloat(this.css("marginTop"));
            var marginLeft = parseFloat(this.css("marginLeft"));
            if ("fixed" === this.css("position")) {
                offset = this[0].getBoundingClientRect();
                return {
                    top: offset.top - marginTop,
                    left: offset.left - marginLeft
                }
            }
            offset = this.offset();
            var offsetParent = this.offsetParent();
            var parentOffset = {
                top: 0,
                left: 0
            };
            if ("HTML" !== offsetParent[0].nodeName) {
                parentOffset = offsetParent.offset()
            }
            parentOffset = {
                top: parentOffset.top + parseFloat(offsetParent.css("borderTopWidth")),
                left: parentOffset.left + parseFloat(offsetParent.css("borderLeftWidth"))
            };
            return {
                top: offset.top - parentOffset.top - marginTop,
                left: offset.left - parentOffset.left - marginLeft
            }
        };
        [{
            name: "scrollLeft",
            offsetProp: "pageXOffset",
            scrollWindow: function(win, value) {
                win.scrollTo(value, win.pageYOffset)
            }
        }, {
            name: "scrollTop",
            offsetProp: "pageYOffset",
            scrollWindow: function(win, value) {
                win.scrollTo(win.pageXOffset, value)
            }
        }].forEach(function(directionStrategy) {
            var propName = directionStrategy.name;
            initRender.prototype[propName] = function(value) {
                if (!this[0]) {
                    return
                }
                var window = getWindowByElement(this[0]);
                if (void 0 === value) {
                    return window ? window[directionStrategy.offsetProp] : this[0][propName]
                }
                if (window) {
                    directionStrategy.scrollWindow(window, value)
                } else {
                    this[0][propName] = value
                }
                return this
            }
        });
        initRender.prototype.data = function(key, value) {
            if (!this[0]) {
                return
            }
            if (arguments.length < 2) {
                return _element_data.data.call(renderer, this[0], key)
            }
            _element_data.data.call(renderer, this[0], key, value);
            return this
        };
        initRender.prototype.removeData = function(key) {
            this[0] && (0, _element_data.removeData)(this[0], key);
            return this
        };
        var rendererWrapper = function() {
            return renderer.apply(this, arguments)
        };
        Object.defineProperty(rendererWrapper, "fn", {
            enumerable: true,
            configurable: true,
            get: function() {
                return renderer.fn
            },
            set: function(value) {
                renderer.fn = value
            }
        });
        var _default = {
            set: function(strategy) {
                renderer = strategy
            },
            get: function() {
                return rendererWrapper
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************!*\
      !*** ./artifacts/transpiled-npm/events/core/hook_touch_props.js ***!
      \******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = _default;
        var touchPropsToHook = ["pageX", "pageY", "screenX", "screenY", "clientX", "clientY"];
        var touchPropHook = function(name, event) {
            if (event[name] && !event.touches || !event.touches) {
                return event[name]
            }
            var touches = event.touches.length ? event.touches : event.changedTouches;
            if (!touches.length) {
                return
            }
            return touches[0][name]
        };

        function _default(callback) {
            touchPropsToHook.forEach(function(name) {
                callback(name, function(event) {
                    return touchPropHook(name, event)
                })
            }, this)
        }
        module.exports = exports.default
    },
    /*!************************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/html_parser.js ***!
      \************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.isTablePart = exports.parseHTML = void 0;
        var _array = __webpack_require__( /*! ./array */ 12);
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../dom_adapter */ 11));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var isTagName = /<([a-z][^/\0>\x20\t\r\n\f]+)/i;
        var tagWrappers = {
            "default": {
                tagsCount: 0,
                startTags: "",
                endTags: ""
            },
            thead: {
                tagsCount: 1,
                startTags: "<table>",
                endTags: "</table>"
            },
            td: {
                tagsCount: 3,
                startTags: "<table><tbody><tr>",
                endTags: "</tr></tbody></table>"
            },
            col: {
                tagsCount: 2,
                startTags: "<table><colgroup>",
                endTags: "</colgroup></table>"
            },
            tr: {
                tagsCount: 2,
                startTags: "<table><tbody>",
                endTags: "</tbody></table>"
            }
        };
        tagWrappers.tbody = tagWrappers.colgroup = tagWrappers.caption = tagWrappers.tfoot = tagWrappers.thead;
        tagWrappers.th = tagWrappers.td;
        var parseHTML = function(html) {
            if ("string" !== typeof html) {
                return null
            }
            var fragment = _dom_adapter.default.createDocumentFragment();
            var container = fragment.appendChild(_dom_adapter.default.createElement("div"));
            var tags = isTagName.exec(html);
            var firstRootTag = tags && tags[1].toLowerCase();
            var tagWrapper = tagWrappers[firstRootTag] || tagWrappers.default;
            container.innerHTML = tagWrapper.startTags + html + tagWrapper.endTags;
            for (var i = 0; i < tagWrapper.tagsCount; i++) {
                container = container.lastChild
            }
            return (0, _array.merge)([], container.childNodes)
        };
        exports.parseHTML = parseHTML;
        var isTablePart = function(html) {
            var tags = isTagName.exec(html);
            return tags && tags[1] in tagWrappers
        };
        exports.isTablePart = isTablePart
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/exporter/excel_format_converter.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _string = __webpack_require__( /*! ../core/utils/string */ 43);
        var _number = _interopRequireDefault(__webpack_require__( /*! ../localization/number */ 47));
        var _date = _interopRequireDefault(__webpack_require__( /*! ../localization/date */ 32));
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _date2 = __webpack_require__( /*! ../localization/ldml/date.format */ 174);
        var _language_codes = __webpack_require__( /*! ../localization/language_codes */ 204);
        __webpack_require__( /*! ../localization/currency */ 114);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ARABIC_ZERO_CODE = 1632;
        var DEFINED_NUMBER_FORMTATS = {
            thousands: "#,##0{0},&quot;K&quot;",
            millions: "#,##0{0},,&quot;M&quot;",
            billions: "#,##0{0},,,&quot;B&quot;",
            trillions: "#,##0{0},,,,&quot;T&quot;",
            percent: "0{0}%",
            decimal: "#{0}",
            fixedpoint: "#,##0{0}",
            exponential: "0{0}E+00",
            currency: " "
        };
        var PERIOD_REGEXP = /a+/g;
        var DAY_REGEXP = /E/g;
        var DO_REGEXP = /dE+/g;
        var STANDALONE_MONTH_REGEXP = /L/g;
        var HOUR_REGEXP = /h/g;
        var ANY_REGEXP = /./g;
        var excelFormatConverter = {
            _applyPrecision: function(format, precision) {
                var result;
                var i;
                if (precision > 0) {
                    result = "decimal" !== format ? "." : "";
                    for (i = 0; i < precision; i++) {
                        result += "0"
                    }
                    return result
                }
                return ""
            },
            _hasArabicDigits: function(text) {
                var code;
                for (var i = 0; i < text.length; i++) {
                    code = text.charCodeAt(i);
                    if (code >= ARABIC_ZERO_CODE && code < ARABIC_ZERO_CODE + 10) {
                        return true
                    }
                }
                return false
            },
            _convertDateFormatToOpenXml: function(format) {
                return format.split("/").join("\\/").split("'").map(function(datePart, index) {
                    if (index % 2 === 0) {
                        return datePart.replace(PERIOD_REGEXP, "AM/PM").replace(DO_REGEXP, "d").replace(DAY_REGEXP, "d").replace(STANDALONE_MONTH_REGEXP, "M").replace(HOUR_REGEXP, "H").split("[").join("\\[").split("]").join("\\]")
                    }
                    if (datePart) {
                        return datePart.replace(ANY_REGEXP, "\\$&")
                    }
                    return "'"
                }).join("")
            },
            _convertDateFormat: function(format) {
                var formattedValue = (_date.default.format(new Date(2009, 8, 8, 6, 5, 4), format) || "").toString();
                var result = (0, _date2.getFormat)(function(value) {
                    return _date.default.format(value, format)
                });
                if (result) {
                    result = this._convertDateFormatToOpenXml(result);
                    result = this._getLanguageInfo(formattedValue) + result
                }
                return result
            },
            _getLanguageInfo: function(defaultPattern) {
                var languageID = (0, _language_codes.getLanguageId)();
                var languageIDStr = languageID ? languageID.toString(16) : "";
                var languageInfo = "";
                if (this._hasArabicDigits(defaultPattern)) {
                    while (languageIDStr.length < 3) {
                        languageIDStr = "0" + languageIDStr
                    }
                    languageInfo = "[$-2010" + languageIDStr + "]"
                } else {
                    if (languageIDStr) {
                        languageInfo = "[$-" + languageIDStr + "]"
                    }
                }
                return languageInfo
            },
            _convertNumberFormat: function(format, precision, currency) {
                var result;
                var excelFormat;
                if ("currency" === format) {
                    excelFormat = _number.default.getOpenXmlCurrencyFormat(currency)
                } else {
                    excelFormat = DEFINED_NUMBER_FORMTATS[format.toLowerCase()]
                }
                if (excelFormat) {
                    result = (0, _string.format)(excelFormat, this._applyPrecision(format, precision))
                }
                return result
            },
            convertFormat: function(format, precision, type, currency) {
                if ((0, _type.isDefined)(format)) {
                    if ("date" === type) {
                        return excelFormatConverter._convertDateFormat(format)
                    } else {
                        if ((0, _type.isString)(format) && DEFINED_NUMBER_FORMTATS[format.toLowerCase()]) {
                            return excelFormatConverter._convertNumberFormat(format, precision, currency)
                        }
                    }
                }
            }
        };
        var _default = excelFormatConverter;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/localization/utils.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.toFixed = toFixed;
        var _math = __webpack_require__( /*! ../core/utils/math */ 29);
        var DECIMAL_BASE = 10;

        function roundByAbs(value) {
            var valueSign = (0, _math.sign)(value);
            return valueSign * Math.round(Math.abs(value))
        }

        function adjustValue(value, precision) {
            var precisionMultiplier = Math.pow(DECIMAL_BASE, precision);
            var roundMultiplier = precisionMultiplier * DECIMAL_BASE;
            var intermediateValue = value * roundMultiplier / DECIMAL_BASE;
            return roundByAbs(intermediateValue) / precisionMultiplier
        }

        function toFixed(value, precision) {
            var valuePrecision = precision || 0;
            var adjustedValue = valuePrecision > 0 ? adjustValue.apply(void 0, arguments) : value;
            return adjustedValue.toFixed(valuePrecision)
        }
    },
    /*!***************************************************************************!*\
      !*** ./artifacts/transpiled-npm/localization/open_xml_currency_format.js ***!
      \***************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _default = function(currencySymbol, accountingFormat) {
            if (!accountingFormat) {
                return
            }
            var encodedCurrencySymbol = currencySymbol;
            if ("string" === typeof currencySymbol) {
                encodedCurrencySymbol = "";
                for (var i = 0; i < currencySymbol.length; i++) {
                    if ("$" !== currencySymbol[i]) {
                        encodedCurrencySymbol += "\\"
                    }
                    encodedCurrencySymbol += currencySymbol[i]
                }
            }
            var encodeSymbols = {
                ".00": "{0}",
                "'": "\\'",
                "\\(": "\\(",
                "\\)": "\\)",
                " ": "\\ ",
                '"': "&quot;",
                "\\\xa4": encodedCurrencySymbol
            };
            var result = accountingFormat.split(";");
            for (var _i = 0; _i < result.length; _i++) {
                for (var symbol in encodeSymbols) {
                    if (Object.prototype.hasOwnProperty.call(encodeSymbols, symbol)) {
                        result[_i] = result[_i].replace(new RegExp(symbol, "g"), encodeSymbols[symbol])
                    }
                }
            }
            return 2 === result.length ? result[0] + "_);" + result[1] : result[0]
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************************!*\
      !*** ./artifacts/transpiled-npm/localization/ldml/date.formatter.js ***!
      \**********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getFormatter = void 0;

        function leftPad(text, length) {
            while (text.length < length) {
                text = "0" + text
            }
            return text
        }
        var FORMAT_TYPES = {
            3: "abbreviated",
            4: "wide",
            5: "narrow"
        };
        var LDML_FORMATTERS = {
            y: function(date, count, useUtc) {
                var year = date[useUtc ? "getUTCFullYear" : "getFullYear"]();
                if (2 === count) {
                    year %= 100
                }
                return leftPad(year.toString(), count)
            },
            M: function(date, count, useUtc, dateParts) {
                var month = date[useUtc ? "getUTCMonth" : "getMonth"]();
                var formatType = FORMAT_TYPES[count];
                if (formatType) {
                    return dateParts.getMonthNames(formatType, "format")[month]
                }
                return leftPad((month + 1).toString(), Math.min(count, 2))
            },
            L: function(date, count, useUtc, dateParts) {
                var month = date[useUtc ? "getUTCMonth" : "getMonth"]();
                var formatType = FORMAT_TYPES[count];
                if (formatType) {
                    return dateParts.getMonthNames(formatType, "standalone")[month]
                }
                return leftPad((month + 1).toString(), Math.min(count, 2))
            },
            Q: function(date, count, useUtc, dateParts) {
                var month = date[useUtc ? "getUTCMonth" : "getMonth"]();
                var quarter = Math.floor(month / 3);
                var formatType = FORMAT_TYPES[count];
                if (formatType) {
                    return dateParts.getQuarterNames(formatType)[quarter]
                }
                return leftPad((quarter + 1).toString(), Math.min(count, 2))
            },
            E: function(date, count, useUtc, dateParts) {
                var day = date[useUtc ? "getUTCDay" : "getDay"]();
                var formatType = FORMAT_TYPES[count < 3 ? 3 : count];
                return dateParts.getDayNames(formatType)[day]
            },
            a: function(date, count, useUtc, dateParts) {
                var hours = date[useUtc ? "getUTCHours" : "getHours"]();
                var period = hours < 12 ? 0 : 1;
                var formatType = FORMAT_TYPES[count];
                return dateParts.getPeriodNames(formatType)[period]
            },
            d: function(date, count, useUtc) {
                return leftPad(date[useUtc ? "getUTCDate" : "getDate"]().toString(), Math.min(count, 2))
            },
            H: function(date, count, useUtc) {
                return leftPad(date[useUtc ? "getUTCHours" : "getHours"]().toString(), Math.min(count, 2))
            },
            h: function(date, count, useUtc) {
                var hours = date[useUtc ? "getUTCHours" : "getHours"]();
                return leftPad((hours % 12 || 12).toString(), Math.min(count, 2))
            },
            m: function(date, count, useUtc) {
                return leftPad(date[useUtc ? "getUTCMinutes" : "getMinutes"]().toString(), Math.min(count, 2))
            },
            s: function(date, count, useUtc) {
                return leftPad(date[useUtc ? "getUTCSeconds" : "getSeconds"]().toString(), Math.min(count, 2))
            },
            S: function(date, count, useUtc) {
                return leftPad(date[useUtc ? "getUTCMilliseconds" : "getMilliseconds"]().toString(), 3).substr(0, count)
            },
            x: function(date, count, useUtc) {
                var timezoneOffset = useUtc ? 0 : date.getTimezoneOffset();
                var signPart = timezoneOffset > 0 ? "-" : "+";
                var timezoneOffsetAbs = Math.abs(timezoneOffset);
                var hours = Math.floor(timezoneOffsetAbs / 60);
                var minutes = timezoneOffsetAbs % 60;
                var hoursPart = leftPad(hours.toString(), 2);
                var minutesPart = leftPad(minutes.toString(), 2);
                return signPart + hoursPart + (count >= 3 ? ":" : "") + (count > 1 || minutes ? minutesPart : "")
            },
            X: function(date, count, useUtc) {
                if (useUtc || !date.getTimezoneOffset()) {
                    return "Z"
                }
                return LDML_FORMATTERS.x(date, count, useUtc)
            },
            Z: function(date, count, useUtc) {
                return LDML_FORMATTERS.X(date, count >= 5 ? 3 : 2, useUtc)
            }
        };
        var getFormatter = function(format, dateParts) {
            return function(date) {
                var charIndex;
                var formatter;
                var char;
                var charCount = 0;
                var separator = "'";
                var isEscaping = false;
                var isCurrentCharEqualsNext;
                var result = "";
                if (!date) {
                    return null
                }
                if (!format) {
                    return date
                }
                var useUtc = "Z" === format[format.length - 1] || "'Z'" === format.slice(-3);
                for (charIndex = 0; charIndex < format.length; charIndex++) {
                    char = format[charIndex];
                    formatter = LDML_FORMATTERS[char];
                    isCurrentCharEqualsNext = char === format[charIndex + 1];
                    charCount++;
                    if (!isCurrentCharEqualsNext) {
                        if (formatter && !isEscaping) {
                            result += formatter(date, charCount, useUtc, dateParts)
                        }
                        charCount = 0
                    }
                    if (char === separator && !isCurrentCharEqualsNext) {
                        isEscaping = !isEscaping
                    } else {
                        if (isEscaping || !formatter) {
                            result += char
                        }
                    }
                    if (char === separator && isCurrentCharEqualsNext) {
                        charIndex++
                    }
                }
                return result
            }
        };
        exports.getFormatter = getFormatter
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/localization/default_date_names.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        var PERIODS = ["AM", "PM"];
        var QUARTERS = ["Q1", "Q2", "Q3", "Q4"];
        var cutCaptions = function(captions, format) {
            var lengthByFormat = {
                abbreviated: 3,
                "short": 2,
                narrow: 1
            };
            return (0, _iterator.map)(captions, function(caption) {
                return caption.substr(0, lengthByFormat[format])
            })
        };
        var _default = {
            getMonthNames: function(format) {
                return cutCaptions(MONTHS, format)
            },
            getDayNames: function(format) {
                return cutCaptions(DAYS, format)
            },
            getQuarterNames: function(format) {
                return QUARTERS
            },
            getPeriodNames: function(format) {
                return PERIODS
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************************!*\
      !*** ./artifacts/transpiled-npm/exporter/excel/excel.fill_helper.js ***!
      \**********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _excel = _interopRequireDefault(__webpack_require__( /*! ./excel.tag_helper */ 88));
        var _excel2 = _interopRequireDefault(__webpack_require__( /*! ./excel.pattern_fill_helper */ 503));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var fillHelper = {
            tryCreateTag: function(sourceObj) {
                var result = null;
                if ((0, _type.isDefined)(sourceObj)) {
                    result = {
                        patternFill: _excel2.default.tryCreateTag(sourceObj.patternFill)
                    };
                    if (fillHelper.isEmpty(result)) {
                        result = null
                    }
                }
                return result
            },
            tryCreateFillFromSimpleFormat: function() {
                var _ref = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                    backgroundColor = _ref.backgroundColor,
                    fillPatternType = _ref.fillPatternType,
                    fillPatternColor = _ref.fillPatternColor;
                if ((0, _type.isDefined)(backgroundColor) && !((0, _type.isDefined)(fillPatternType) && (0, _type.isDefined)(fillPatternColor))) {
                    return {
                        patternFill: {
                            patternType: "solid",
                            foregroundColor: {
                                rgb: backgroundColor
                            }
                        }
                    }
                } else {
                    if ((0, _type.isDefined)(fillPatternType) && (0, _type.isDefined)(fillPatternColor)) {
                        return {
                            patternFill: {
                                patternType: fillPatternType,
                                foregroundColor: {
                                    rgb: fillPatternColor
                                },
                                backgroundColor: {
                                    rgb: backgroundColor
                                }
                            }
                        }
                    }
                }
            },
            copySimpleFormat: function(source, target) {
                if (void 0 !== source.backgroundColor) {
                    target.backgroundColor = source.backgroundColor
                }
                if (void 0 !== source.fillPatternType) {
                    target.fillPatternType = source.fillPatternType
                }
                if (void 0 !== source.fillPatternColor) {
                    target.fillPatternColor = source.fillPatternColor
                }
            },
            copy: function(source) {
                var result = null;
                if ((0, _type.isDefined)(source)) {
                    result = {};
                    if (void 0 !== source.patternFill) {
                        result.patternFill = _excel2.default.copy(source.patternFill)
                    }
                }
                return result
            },
            areEqual: function(leftTag, rightTag) {
                return fillHelper.isEmpty(leftTag) && fillHelper.isEmpty(rightTag) || (0, _type.isDefined)(leftTag) && (0, _type.isDefined)(rightTag) && _excel2.default.areEqual(leftTag.patternFill, rightTag.patternFill)
            },
            isEmpty: function(tag) {
                return !(0, _type.isDefined)(tag) || _excel2.default.isEmpty(tag.patternFill)
            },
            toXml: function(tag) {
                return _excel.default.toXml("fill", {}, _excel2.default.toXml(tag.patternFill))
            }
        };
        var _default = fillHelper;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************!*\
      !*** ./artifacts/transpiled-npm/exporter/excel/excel.color_helper.js ***!
      \***********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _excel = _interopRequireDefault(__webpack_require__( /*! ./excel.tag_helper */ 88));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var colorHelper = {
            _tryConvertColor: function(source) {
                if ("string" !== typeof source) {
                    return source
                }
                var result;
                if (source.length > 0 && "#" === source[0]) {
                    var colorCode = source.substr(1, source.length);
                    if (6 === colorCode.length) {
                        result = "FF" + colorCode
                    } else {
                        if (8 === colorCode.length) {
                            result = colorCode[6] + colorCode[7] + colorCode.substr(0, 6)
                        } else {
                            result = colorCode
                        }
                    }
                } else {
                    result = source
                }
                return result
            },
            tryCreateTag: function(sourceObj) {
                var result = null;
                if ((0, _type.isDefined)(sourceObj)) {
                    if ("string" === typeof sourceObj) {
                        result = {
                            rgb: this._tryConvertColor(sourceObj)
                        }
                    } else {
                        result = {
                            rgb: this._tryConvertColor(sourceObj.rgb),
                            theme: sourceObj.theme
                        }
                    }
                    if (colorHelper.isEmpty(result)) {
                        result = null
                    }
                }
                return result
            },
            copy: function(source) {
                var result = null;
                if ((0, _type.isDefined)(source)) {
                    if ("string" === typeof source) {
                        result = source
                    } else {
                        result = {};
                        if (void 0 !== source.rgb) {
                            result.rgb = source.rgb
                        }
                        if (void 0 !== source.theme) {
                            result.theme = source.theme
                        }
                    }
                }
                return result
            },
            isEmpty: function(tag) {
                return !(0, _type.isDefined)(tag) || !(0, _type.isDefined)(tag.rgb) && !(0, _type.isDefined)(tag.theme)
            },
            areEqual: function(leftTag, rightTag) {
                return colorHelper.isEmpty(leftTag) && colorHelper.isEmpty(rightTag) || (0, _type.isDefined)(leftTag) && (0, _type.isDefined)(rightTag) && leftTag.rgb === rightTag.rgb && leftTag.theme === rightTag.theme
            },
            toXml: function(tagName, tag) {
                return _excel.default.toXml(tagName, {
                    rgb: tag.rgb,
                    theme: tag.theme
                })
            }
        };
        var _default = colorHelper;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************************!*\
      !*** ./artifacts/transpiled-npm/exporter/excel/excel.font_helper.js ***!
      \**********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _excel = _interopRequireDefault(__webpack_require__( /*! ./excel.tag_helper */ 88));
        var _excel2 = _interopRequireDefault(__webpack_require__( /*! ./excel.color_helper */ 245));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var fontHelper = {
            tryCreateTag: function(sourceObj) {
                var result = null;
                if ((0, _type.isDefined)(sourceObj)) {
                    result = {
                        size: sourceObj.size,
                        name: sourceObj.name,
                        family: sourceObj.family,
                        scheme: sourceObj.scheme,
                        bold: sourceObj.bold,
                        italic: sourceObj.italic,
                        underline: sourceObj.underline,
                        color: _excel2.default.tryCreateTag(sourceObj.color)
                    };
                    if (fontHelper.isEmpty(result)) {
                        result = null
                    }
                }
                return result
            },
            copy: function(source) {
                var result = null;
                if ((0, _type.isDefined)(source)) {
                    result = {};
                    if (void 0 !== source.size) {
                        result.size = source.size
                    }
                    if (void 0 !== source.name) {
                        result.name = source.name
                    }
                    if (void 0 !== source.family) {
                        result.family = source.family
                    }
                    if (void 0 !== source.scheme) {
                        result.scheme = source.scheme
                    }
                    if (void 0 !== source.bold) {
                        result.bold = source.bold
                    }
                    if (void 0 !== source.italic) {
                        result.italic = source.italic
                    }
                    if (void 0 !== source.underline) {
                        result.underline = source.underline
                    }
                    if (void 0 !== source.color) {
                        result.color = _excel2.default.copy(source.color)
                    }
                }
                return result
            },
            areEqual: function(leftTag, rightTag) {
                return fontHelper.isEmpty(leftTag) && fontHelper.isEmpty(rightTag) || (0, _type.isDefined)(leftTag) && (0, _type.isDefined)(rightTag) && leftTag.size === rightTag.size && leftTag.name === rightTag.name && leftTag.family === rightTag.family && leftTag.scheme === rightTag.scheme && (leftTag.bold === rightTag.bold || !leftTag.bold === !rightTag.bold) && (leftTag.italic === rightTag.italic || !leftTag.italic === !rightTag.italic) && leftTag.underline === rightTag.underline && _excel2.default.areEqual(leftTag.color, rightTag.color)
            },
            isEmpty: function(tag) {
                return !(0, _type.isDefined)(tag) || !(0, _type.isDefined)(tag.size) && !(0, _type.isDefined)(tag.name) && !(0, _type.isDefined)(tag.family) && !(0, _type.isDefined)(tag.scheme) && (!(0, _type.isDefined)(tag.bold) || !tag.bold) && (!(0, _type.isDefined)(tag.italic) || !tag.italic) && !(0, _type.isDefined)(tag.underline) && _excel2.default.isEmpty(tag.color)
            },
            toXml: function(tag) {
                var content = [(0, _type.isDefined)(tag.bold) && tag.bold ? _excel.default.toXml("b", {}) : "", (0, _type.isDefined)(tag.size) ? _excel.default.toXml("sz", {
                    val: tag.size
                }) : "", (0, _type.isDefined)(tag.color) ? _excel2.default.toXml("color", tag.color) : "", (0, _type.isDefined)(tag.name) ? _excel.default.toXml("name", {
                    val: tag.name
                }) : "", (0, _type.isDefined)(tag.family) ? _excel.default.toXml("family", {
                    val: tag.family
                }) : "", (0, _type.isDefined)(tag.scheme) ? _excel.default.toXml("scheme", {
                    val: tag.scheme
                }) : "", (0, _type.isDefined)(tag.italic) && tag.italic ? _excel.default.toXml("i", {}) : "", (0, _type.isDefined)(tag.underline) ? _excel.default.toXml("u", {
                    val: tag.underline
                }) : ""].join("");
                return _excel.default.toXml("font", {}, content)
            }
        };
        var _default = fontHelper;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************************!*\
      !*** ./artifacts/transpiled-npm/exporter/image_creator.js ***!
      \************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getData = getData;
        exports.testFormats = testFormats;
        exports.imageCreator = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _color = _interopRequireDefault(__webpack_require__( /*! ../color */ 95));
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _svg = __webpack_require__( /*! ../core/utils/svg */ 205);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../core/dom_adapter */ 11));
        var _dom = __webpack_require__( /*! ../core/utils/dom */ 33);
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _inflector = __webpack_require__( /*! ../core/utils/inflector */ 39);
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var _math = Math;
        var PI = _math.PI;
        var _min = _math.min;
        var _abs = _math.abs;
        var _sqrt = _math.sqrt;
        var _pow = _math.pow;
        var _atan2 = _math.atan2;
        var _cos = _math.cos;
        var _sin = _math.sin;
        var _number = Number;
        var IMAGE_QUALITY = 1;
        var TEXT_DECORATION_LINE_WIDTH_COEFF = .05;
        var DEFAULT_FONT_SIZE = "10px";
        var DEFAULT_FONT_FAMILY = "sans-serif";
        var DEFAULT_TEXT_COLOR = "#000";
        var parseAttributes;

        function createCanvas(width, height, margin) {
            var canvas = (0, _renderer.default)("<canvas>")[0];
            canvas.width = width + 2 * margin;
            canvas.height = height + 2 * margin;
            canvas.hidden = true;
            return canvas
        }

        function getStringFromCanvas(canvas, mimeType) {
            var dataURL = canvas.toDataURL(mimeType, IMAGE_QUALITY);
            var imageData = window.atob(dataURL.substring(("data:" + mimeType + ";base64,").length));
            return imageData
        }

        function arcTo(x1, y1, x2, y2, radius, largeArcFlag, clockwise, context) {
            var cBx = (x1 + x2) / 2;
            var cBy = (y1 + y2) / 2;
            var aB = _atan2(y1 - y2, x1 - x2);
            var k = largeArcFlag ? 1 : -1;
            aB += 90 * (PI / 180) * (clockwise ? 1 : -1);
            var opSide = _sqrt(_pow(x2 - x1, 2) + _pow(y2 - y1, 2)) / 2;
            var adjSide = _sqrt(_abs(_pow(radius, 2) - _pow(opSide, 2)));
            var centerX = cBx + k * (adjSide * _cos(aB));
            var centerY = cBy + k * (adjSide * _sin(aB));
            var startAngle = _atan2(y1 - centerY, x1 - centerX);
            var endAngle = _atan2(y2 - centerY, x2 - centerX);
            context.arc(centerX, centerY, radius, startAngle, endAngle, !clockwise)
        }

        function getElementOptions(element, rootAppended) {
            var attr = parseAttributes(element.attributes || {});
            var options = (0, _extend.extend)({}, attr, {
                text: element.textContent.replace(/\s+/g, " "),
                textAlign: "middle" === attr["text-anchor"] ? "center" : attr["text-anchor"]
            });
            var transform = attr.transform;
            var coords;
            if (transform) {
                coords = transform.match(/translate\(-*\d+([.]\d+)*(,*\s*-*\d+([.]\d+)*)*/);
                if (coords) {
                    coords = coords[0].match(/-*\d+([.]\d+)*/g);
                    options.translateX = _number(coords[0]);
                    options.translateY = coords[1] ? _number(coords[1]) : 0
                }
                coords = transform.match(/rotate\(-*\d+([.]\d+)*(,*\s*-*\d+([.]\d+)*,*\s*-*\d+([.]\d+)*)*/);
                if (coords) {
                    coords = coords[0].match(/-*\d+([.]\d+)*/g);
                    options.rotationAngle = _number(coords[0]);
                    options.rotationX = coords[1] && _number(coords[1]);
                    options.rotationY = coords[2] && _number(coords[2])
                }
                coords = transform.match(/scale\(-*\d+([.]\d+)*(,*\s*-*\d+([.]\d+)*)*/);
                if (coords) {
                    coords = coords[0].match(/-*\d+([.]\d+)*/g);
                    options.scaleX = _number(coords[0]);
                    if (coords.length > 1) {
                        options.scaleY = _number(coords[1])
                    } else {
                        options.scaleY = options.scaleX
                    }
                }
            }
            parseStyles(element, options, rootAppended);
            return options
        }

        function drawRect(context, options) {
            var x = options.x;
            var y = options.y;
            var width = options.width;
            var height = options.height;
            var cornerRadius = options.rx;
            if (!cornerRadius) {
                context.rect(x, y, width, height)
            } else {
                cornerRadius = _min(cornerRadius, width / 2, height / 2);
                context.save();
                context.translate(x, y);
                context.moveTo(width / 2, 0);
                context.arcTo(width, 0, width, height, cornerRadius);
                context.arcTo(width, height, 0, height, cornerRadius);
                context.arcTo(0, height, 0, 0, cornerRadius);
                context.arcTo(0, 0, cornerRadius, 0, cornerRadius);
                context.lineTo(width / 2, 0);
                context.restore()
            }
        }

        function drawImage(context, options, shared) {
            var d = new _deferred.Deferred;
            var image = new window.Image;
            image.onload = function() {
                context.save();
                context.globalAlpha = options.globalAlpha;
                transformElement(context, options);
                clipElement(context, options, shared);
                context.drawImage(image, options.x, options.y, options.width, options.height);
                context.restore();
                d.resolve()
            };
            image.onerror = function() {
                d.resolve()
            };
            image.setAttribute("crossOrigin", "anonymous");
            image.src = options.href || options["xlink:href"];
            return d
        }

        function drawPath(context, dAttr) {
            var dArray = dAttr.replace(/,/g, " ").split(/([A-Z])/i).filter(function(item) {
                return "" !== item.trim()
            });
            var i = 0;
            var params;
            var prevParams;
            var prevParamsLen;
            do {
                params = (dArray[i + 1] || "").trim().split(" ");
                switch (dArray[i]) {
                    case "M":
                        context.moveTo(_number(params[0]), _number(params[1]));
                        i += 2;
                        break;
                    case "L":
                        for (var j = 0; j < params.length / 2; j++) {
                            context.lineTo(_number(params[2 * j]), _number(params[2 * j + 1]))
                        }
                        i += 2;
                        break;
                    case "C":
                        context.bezierCurveTo(_number(params[0]), _number(params[1]), _number(params[2]), _number(params[3]), _number(params[4]), _number(params[5]));
                        i += 2;
                        break;
                    case "a":
                        prevParams = dArray[i - 1].trim().split(" ");
                        prevParamsLen = prevParams.length - 1;
                        arcTo(_number(prevParams[prevParamsLen - 1]), _number(prevParams[prevParamsLen]), _number(prevParams[prevParamsLen - 1]) + _number(params[5]), _number(prevParams[prevParamsLen]) + _number(params[6]), _number(params[0]), _number(params[3]), _number(params[4]), context);
                        i += 2;
                        break;
                    case "A":
                        prevParams = dArray[i - 1].trim().split(" ");
                        prevParamsLen = prevParams.length - 1;
                        arcTo(_number(prevParams[prevParamsLen - 1]), _number(prevParams[prevParamsLen]), _number(params[5]), _number(params[6]), _number(params[0]), _number(params[3]), _number(params[4]), context);
                        i += 2;
                        break;
                    case "Z":
                        context.closePath();
                        i += 1;
                        break;
                    default:
                        i++
                }
            } while (i < dArray.length)
        }

        function parseStyles(element, options, rootAppended) {
            var style = element.style || {};
            var field;
            for (field in style) {
                if ("" !== style[field]) {
                    options[(0, _inflector.camelize)(field)] = style[field]
                }
            }
            if (rootAppended && _dom_adapter.default.isElementNode(element)) {
                style = window.getComputedStyle(element);
                ["fill", "stroke", "stroke-width", "font-family", "font-size", "font-style", "font-weight"].forEach(function(prop) {
                    if (prop in style && "" !== style[prop]) {
                        options[(0, _inflector.camelize)(prop)] = style[prop]
                    }
                });
                ["opacity", "fill-opacity", "stroke-opacity"].forEach(function(prop) {
                    if (prop in style && "" !== style[prop] && "1" !== style[prop]) {
                        options[prop] = _number(style[prop])
                    }
                })
            }
            options.textDecoration = options.textDecoration || options.textDecorationLine;
            options.globalAlpha = (0, _type.isDefined)(options.opacity) ? options.opacity : options.globalAlpha
        }

        function parseUrl(urlString) {
            var matches = urlString && urlString.match(/url\(.*#(.*?)["']?\)/i);
            return matches && matches[1]
        }

        function setFontStyle(context, options) {
            var fontParams = [];
            options.fontSize = options.fontSize || DEFAULT_FONT_SIZE;
            options.fontFamily || DEFAULT_FONT_FAMILY;
            options.fill = options.fill || DEFAULT_TEXT_COLOR;
            options.fontStyle && fontParams.push(options.fontStyle);
            options.fontWeight && fontParams.push(options.fontWeight);
            fontParams.push(options.fontSize);
            fontParams.push(options.fontFamily);
            context.font = fontParams.join(" ");
            context.textAlign = options.textAlign;
            context.fillStyle = options.fill;
            context.globalAlpha = options.globalAlpha
        }

        function drawText(context, options, shared) {
            setFontStyle(context, options);
            applyFilter(context, options, shared);
            options.text && context.fillText(options.text, options.x || 0, options.y || 0);
            strokeElement(context, options, true);
            drawTextDecoration(context, options, shared)
        }

        function drawTextDecoration(context, options, shared) {
            if (!options.textDecoration || "none" === options.textDecoration) {
                return
            }
            var x = options.x;
            var textWidth = context.measureText(options.text).width;
            var textHeight = parseInt(options.fontSize, 10);
            var lineHeight = textHeight * TEXT_DECORATION_LINE_WIDTH_COEFF < 1 ? 1 : textHeight * TEXT_DECORATION_LINE_WIDTH_COEFF;
            var y = options.y;
            switch (options.textDecoration) {
                case "line-through":
                    y -= textHeight / 3 + lineHeight / 2;
                    break;
                case "overline":
                    y -= textHeight - lineHeight;
                    break;
                case "underline":
                    y += lineHeight
            }
            context.rect(x, y, textWidth, lineHeight);
            fillElement(context, options, shared);
            strokeElement(context, options)
        }

        function aggregateOpacity(options) {
            options.strokeOpacity = void 0 !== options["stroke-opacity"] ? options["stroke-opacity"] : 1;
            options.fillOpacity = void 0 !== options["fill-opacity"] ? options["fill-opacity"] : 1;
            if (void 0 !== options.opacity) {
                options.strokeOpacity *= options.opacity;
                options.fillOpacity *= options.opacity
            }
        }

        function hasTspan(element) {
            var nodes = element.childNodes;
            for (var i = 0; i < nodes.length; i++) {
                if ("tspan" === nodes[i].tagName) {
                    return true
                }
            }
            return false
        }

        function drawTextElement(childNodes, context, options, shared) {
            var lines = [];
            var line;
            var offset = 0;
            for (var i = 0; i < childNodes.length; i++) {
                var element = childNodes[i];
                if (void 0 === element.tagName) {
                    drawElement(element, context, options, shared)
                } else {
                    if ("tspan" === element.tagName || "text" === element.tagName) {
                        var elementOptions = getElementOptions(element, shared.rootAppended);
                        var mergedOptions = (0, _extend.extend)({}, options, elementOptions);
                        if ("tspan" === element.tagName && hasTspan(element)) {
                            drawTextElement(element.childNodes, context, mergedOptions, shared);
                            continue
                        }
                        mergedOptions.textAlign = "start";
                        if (!line || void 0 !== elementOptions.x) {
                            line = {
                                elements: [],
                                options: [],
                                widths: [],
                                offsets: []
                            };
                            lines.push(line)
                        }
                        if (void 0 !== elementOptions.y) {
                            offset = 0
                        }
                        if (void 0 !== elementOptions.dy) {
                            offset += parseFloat(elementOptions.dy)
                        }
                        line.elements.push(element);
                        line.options.push(mergedOptions);
                        line.offsets.push(offset);
                        setFontStyle(context, mergedOptions);
                        line.widths.push(context.measureText(mergedOptions.text).width)
                    }
                }
            }
            lines.forEach(function(line) {
                var commonWidth = line.widths.reduce(function(commonWidth, width) {
                    return commonWidth + width
                }, 0);
                var xDiff = 0;
                var currentOffset = 0;
                if ("center" === options.textAlign) {
                    xDiff = commonWidth / 2
                }
                if ("end" === options.textAlign) {
                    xDiff = commonWidth
                }
                line.options.forEach(function(o, index) {
                    var width = line.widths[index];
                    o.x = o.x - xDiff + currentOffset;
                    o.y += line.offsets[index];
                    currentOffset += width
                });
                line.elements.forEach(function(element, index) {
                    drawTextElement(element.childNodes, context, line.options[index], shared)
                })
            })
        }

        function drawElement(element, context, parentOptions, shared) {
            var tagName = element.tagName;
            var isText = "text" === tagName || "tspan" === tagName || void 0 === tagName;
            var isImage = "image" === tagName;
            var options = (0, _extend.extend)({}, parentOptions, getElementOptions(element, shared.rootAppended));
            if ("hidden" === options.visibility || options["hidden-for-export"]) {
                return
            }
            context.save();
            !isImage && transformElement(context, options);
            clipElement(context, options, shared);
            aggregateOpacity(options);
            var promise;
            context.beginPath();
            switch (element.tagName) {
                case void 0:
                    drawText(context, options, shared);
                    break;
                case "text":
                case "tspan":
                    drawTextElement(element.childNodes, context, options, shared);
                    break;
                case "image":
                    promise = drawImage(context, options, shared);
                    break;
                case "path":
                    drawPath(context, options.d);
                    break;
                case "rect":
                    drawRect(context, options);
                    context.closePath();
                    break;
                case "circle":
                    context.arc(options.cx, options.cy, options.r, 0, 2 * PI, 1)
            }
            if (!isText) {
                applyFilter(context, options, shared);
                fillElement(context, options, shared);
                strokeElement(context, options)
            }
            applyGradient(context, options, shared, element);
            context.restore();
            return promise
        }

        function applyGradient(context, options, _ref, element) {
            var gradients = _ref.gradients;
            if (0 === gradients.length) {
                return
            }
            var id = parseUrl(options.fill);
            if (id && gradients[id]) {
                var box = element.getBBox();
                var gradient = context.createLinearGradient(box.x, 0, box.x + box.width, 0);
                gradients[id].forEach(function(opt) {
                    var offset = parseInt(opt.offset.replace(/%/, ""));
                    gradient.addColorStop(offset / 100, opt.stopColor)
                });
                context.globalAlpha = options.opacity;
                context.fillStyle = gradient;
                context.fill()
            }
        }

        function applyFilter(context, options, shared) {
            var filterOptions;
            var id = parseUrl(options.filter);
            if (id) {
                filterOptions = shared.filters[id];
                if (!filterOptions) {
                    filterOptions = {
                        offsetX: 0,
                        offsetY: 0,
                        blur: 0,
                        color: "#000"
                    }
                }
                context.shadowOffsetX = filterOptions.offsetX;
                context.shadowOffsetY = filterOptions.offsetY;
                context.shadowColor = filterOptions.color;
                context.shadowBlur = filterOptions.blur
            }
        }

        function transformElement(context, options) {
            context.translate(options.translateX || 0, options.translateY || 0);
            options.translateX = void 0;
            options.translateY = void 0;
            if (options.rotationAngle) {
                context.translate(options.rotationX || 0, options.rotationY || 0);
                context.rotate(options.rotationAngle * PI / 180);
                context.translate(-(options.rotationX || 0), -(options.rotationY || 0));
                options.rotationAngle = void 0;
                options.rotationX = void 0;
                options.rotationY = void 0
            }
            if (isFinite(options.scaleX)) {
                context.scale(options.scaleX, options.scaleY);
                options.scaleX = void 0;
                options.scaleY = void 0
            }
        }

        function clipElement(context, options, shared) {
            if (options["clip-path"]) {
                drawElement(shared.clipPaths[parseUrl(options["clip-path"])], context, {}, shared);
                context.clip();
                options["clip-path"] = void 0
            }
        }

        function hex2rgba(hexColor, alpha) {
            var color = new _color.default(hexColor);
            return "rgba(" + color.r + "," + color.g + "," + color.b + "," + alpha + ")"
        }

        function createGradient(element) {
            var options = [];
            (0, _iterator.each)(element.childNodes, function(_, _ref2) {
                var attributes = _ref2.attributes;
                options.push({
                    offset: attributes.offset.value,
                    stopColor: attributes["stop-color"].value
                })
            });
            return options
        }

        function createFilter(element) {
            var color;
            var opacity;
            var filterOptions = {};
            (0, _iterator.each)(element.childNodes, function(_, node) {
                var attr = node.attributes;
                if (!attr.result) {
                    return
                }
                switch (attr.result.value) {
                    case "gaussianBlurResult":
                        filterOptions.blur = _number(attr.stdDeviation.value);
                        break;
                    case "offsetResult":
                        filterOptions.offsetX = _number(attr.dx.value);
                        filterOptions.offsetY = _number(attr.dy.value);
                        break;
                    case "floodResult":
                        color = attr["flood-color"] ? attr["flood-color"].value : "#000";
                        opacity = attr["flood-opacity"] ? attr["flood-opacity"].value : 1;
                        filterOptions.color = hex2rgba(color, opacity)
                }
            });
            return filterOptions
        }

        function asyncEach(array, callback) {
            var d = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : new _deferred.Deferred;
            var i = 0;
            for (; i < array.length; i++) {
                var result = callback(array[i]);
                if ((0, _type.isPromise)(result)) {
                    result.then(function() {
                        asyncEach(Array.prototype.slice.call(array, i + 1), callback, d)
                    });
                    break
                }
            }
            if (i === array.length) {
                d.resolve()
            }
            return d
        }

        function drawCanvasElements(elements, context, parentOptions, shared) {
            return asyncEach(elements, function(element) {
                switch (element.tagName && element.tagName.toLowerCase()) {
                    case "g":
                    case "svg":
                        var options = (0, _extend.extend)({}, parentOptions, getElementOptions(element, shared.rootAppended));
                        context.save();
                        transformElement(context, options);
                        clipElement(context, options, shared);
                        var onDone = function() {
                            context.restore()
                        };
                        var d = drawCanvasElements(element.childNodes, context, options, shared);
                        if ((0, _type.isPromise)(d)) {
                            d.then(onDone)
                        } else {
                            onDone()
                        }
                        return d;
                    case "defs":
                        return drawCanvasElements(element.childNodes, context, {}, shared);
                    case "clippath":
                        shared.clipPaths[element.attributes.id.textContent] = element.childNodes[0];
                        break;
                    case "pattern":
                        shared.patterns[element.attributes.id.textContent] = element;
                        break;
                    case "filter":
                        shared.filters[element.id] = createFilter(element);
                        break;
                    case "lineargradient":
                        shared.gradients[element.attributes.id.textContent] = createGradient(element);
                        break;
                    default:
                        return drawElement(element, context, parentOptions, shared)
                }
            })
        }

        function setLineDash(context, options) {
            var matches = options["stroke-dasharray"] && options["stroke-dasharray"].match(/(\d+)/g);
            if (matches && matches.length) {
                matches = (0, _iterator.map)(matches, function(item) {
                    return _number(item)
                });
                context.setLineDash(matches)
            }
        }

        function strokeElement(context, options, isText) {
            var stroke = options.stroke;
            if (stroke && "none" !== stroke && 0 !== options["stroke-width"]) {
                setLineDash(context, options);
                context.lineJoin = options["stroke-linejoin"];
                context.lineWidth = options["stroke-width"];
                context.globalAlpha = options.strokeOpacity;
                context.strokeStyle = stroke;
                isText ? context.strokeText(options.text, options.x, options.y) : context.stroke();
                context.globalAlpha = 1
            }
        }

        function getPattern(context, pattern, shared) {
            var options = getElementOptions(pattern, shared.rootAppended);
            var patternCanvas = createCanvas(options.width, options.height, 0);
            var patternContext = patternCanvas.getContext("2d");
            drawCanvasElements(pattern.childNodes, patternContext, options, shared);
            return context.createPattern(patternCanvas, "repeat")
        }

        function fillElement(context, options, shared) {
            var fill = options.fill;
            if (fill && "none" !== fill) {
                if (fill.search(/url/) === -1) {
                    context.fillStyle = fill
                } else {
                    var pattern = shared.patterns[parseUrl(fill)];
                    if (!pattern) {
                        return
                    }
                    context.fillStyle = getPattern(context, pattern, shared)
                }
                context.globalAlpha = options.fillOpacity;
                context.fill();
                context.globalAlpha = 1
            }
        }
        parseAttributes = function(attributes) {
            var newAttributes = {};
            var attr;
            (0, _iterator.each)(attributes, function(index, item) {
                attr = item.textContent;
                if (isFinite(attr)) {
                    attr = _number(attr)
                }
                newAttributes[item.name.toLowerCase()] = attr
            });
            return newAttributes
        };

        function drawBackground(context, width, height, backgroundColor, margin) {
            context.fillStyle = backgroundColor || "#ffffff";
            context.fillRect(-margin, -margin, width + 2 * margin, height + 2 * margin)
        }

        function createInvisibleDiv() {
            var invisibleDiv = _dom_adapter.default.createElement("div");
            invisibleDiv.style.left = "-9999px";
            invisibleDiv.style.position = "absolute";
            return invisibleDiv
        }

        function convertSvgToCanvas(svg, canvas, rootAppended) {
            return drawCanvasElements(svg.childNodes, canvas.getContext("2d"), {}, {
                clipPaths: {},
                patterns: {},
                filters: {},
                gradients: {},
                rootAppended: rootAppended
            })
        }

        function getCanvasFromSvg(markup, width, height, backgroundColor, margin, pixelRatio) {
            var svgToCanvas = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : convertSvgToCanvas;
            var canvas = createCanvas(width, height, margin);
            var context = canvas.getContext("2d");
            context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            var svgElem = (0, _svg.getSvgElement)(markup);
            var invisibleDiv;
            var markupIsDomElement = _dom_adapter.default.isElementNode(markup);
            context.translate(margin, margin);
            _dom_adapter.default.getBody().appendChild(canvas);
            if (!markupIsDomElement) {
                invisibleDiv = createInvisibleDiv();
                invisibleDiv.appendChild(svgElem);
                _dom_adapter.default.getBody().appendChild(invisibleDiv)
            }
            if (svgElem.attributes.direction) {
                canvas.dir = svgElem.attributes.direction.textContent
            }
            drawBackground(context, width, height, backgroundColor, margin);
            return (0, _deferred.fromPromise)(svgToCanvas(svgElem, canvas, markupIsDomElement && (0, _dom.contains)(_dom_adapter.default.getBody(), markup))).then(function() {
                return canvas
            }).always(function() {
                invisibleDiv && _dom_adapter.default.getBody().removeChild(invisibleDiv);
                _dom_adapter.default.getBody().removeChild(canvas)
            })
        }
        var imageCreator = {
            getImageData: function(markup, options) {
                var pixelRatio = window.devicePixelRatio || 1;
                var mimeType = "image/" + options.format;
                var width = options.width * pixelRatio;
                var height = options.height * pixelRatio;
                var backgroundColor = options.backgroundColor;
                if ((0, _type.isFunction)(options.__parseAttributesFn)) {
                    parseAttributes = options.__parseAttributesFn
                }
                return getCanvasFromSvg(markup, width, height, backgroundColor, options.margin, pixelRatio, options.svgToCanvas).then(function(canvas) {
                    return getStringFromCanvas(canvas, mimeType)
                })
            },
            getData: function(markup, options) {
                var that = this;
                return imageCreator.getImageData(markup, options).then(function(binaryData) {
                    var mimeType = "image/" + options.format;
                    var data = (0, _type.isFunction)(window.Blob) && !options.forceProxy ? that._getBlob(binaryData, mimeType) : that._getBase64(binaryData);
                    return data
                })
            },
            _getBlob: function(binaryData, mimeType) {
                var i;
                var dataArray = new Uint8Array(binaryData.length);
                for (i = 0; i < binaryData.length; i++) {
                    dataArray[i] = binaryData.charCodeAt(i)
                }
                return new window.Blob([dataArray.buffer], {
                    type: mimeType
                })
            },
            _getBase64: function(binaryData) {
                return window.btoa(binaryData)
            }
        };
        exports.imageCreator = imageCreator;

        function getData(data, options) {
            return imageCreator.getData(data, options)
        }

        function testFormats(formats) {
            var canvas = createCanvas(100, 100, 0);
            return formats.reduce(function(r, f) {
                var mimeType = ("image/" + f).toLowerCase();
                if (canvas.toDataURL(mimeType).indexOf(mimeType) !== -1) {
                    r.supported.push(f)
                } else {
                    r.unsupported.push(f)
                }
                return r
            }, {
                supported: [],
                unsupported: []
            })
        }
    },
    /*!*************************************************************!*\
      !*** ./artifacts/transpiled-npm/exporter/exceljs/export.js ***!
      \*************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.Export = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _export_format = __webpack_require__( /*! ./export_format */ 511);
        var _export_merged_ranges_manager = __webpack_require__( /*! ./export_merged_ranges_manager */ 512);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var MAX_DIGIT_WIDTH_IN_PIXELS = 7;
        var MAX_EXCEL_COLUMN_WIDTH = 255;
        var Export = {
            getFullOptions: function(options) {
                var fullOptions = (0, _extend.extend)({}, options);
                if (!((0, _type.isDefined)(fullOptions.worksheet) && (0, _type.isObject)(fullOptions.worksheet))) {
                    throw Error('The "worksheet" field must contain an object.')
                }
                if (!(0, _type.isDefined)(fullOptions.topLeftCell)) {
                    fullOptions.topLeftCell = {
                        row: 1,
                        column: 1
                    }
                } else {
                    if ((0, _type.isString)(fullOptions.topLeftCell)) {
                        var _fullOptions$workshee = fullOptions.worksheet.getCell(fullOptions.topLeftCell),
                            row = _fullOptions$workshee.row,
                            col = _fullOptions$workshee.col;
                        fullOptions.topLeftCell = {
                            row: row,
                            column: col
                        }
                    }
                }
                if (!(0, _type.isDefined)(fullOptions.keepColumnWidths)) {
                    fullOptions.keepColumnWidths = true
                }
                if (!(0, _type.isDefined)(fullOptions.loadPanel)) {
                    fullOptions.loadPanel = {}
                }
                if (!(0, _type.isDefined)(fullOptions.loadPanel.enabled)) {
                    fullOptions.loadPanel.enabled = true
                }
                if (!(0, _type.isDefined)(fullOptions.loadPanel.text)) {
                    fullOptions.loadPanel.text = _message.default.format("dxDataGrid-exporting")
                }
                return fullOptions
            },
            convertDateForExcelJS: function(date) {
                return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()))
            },
            setNumberFormat: function(excelCell, numberFormat) {
                excelCell.numFmt = numberFormat
            },
            getCellStyles: function(dataProvider) {
                var _this = this;
                var styles = dataProvider.getStyles();
                styles.forEach(function(style) {
                    var numberFormat = _this.tryConvertToExcelNumberFormat(style.format, style.dataType);
                    if ((0, _type.isDefined)(numberFormat)) {
                        numberFormat = numberFormat.replace(/&quot;/g, '"')
                    }
                    style.numberFormat = numberFormat
                });
                return styles
            },
            tryConvertToExcelNumberFormat: function(format, dataType) {
                var newFormat = _export_format.ExportFormat.formatObjectConverter(format, dataType);
                var currency = newFormat.currency;
                format = newFormat.format;
                dataType = newFormat.dataType;
                return _export_format.ExportFormat.convertFormat(format, newFormat.precision, dataType, currency)
            },
            setAlignment: function(excelCell, wrapText, horizontalAlignment) {
                excelCell.alignment = excelCell.alignment || {};
                if ((0, _type.isDefined)(wrapText)) {
                    excelCell.alignment.wrapText = wrapText
                }
                if ((0, _type.isDefined)(horizontalAlignment)) {
                    excelCell.alignment.horizontal = horizontalAlignment
                }
                excelCell.alignment.vertical = "top"
            },
            setColumnsWidth: function(worksheet, widths, startColumnIndex) {
                if (!(0, _type.isDefined)(widths)) {
                    return
                }
                for (var i = 0; i < widths.length; i++) {
                    var columnWidth = widths[i];
                    if ("number" === typeof columnWidth && isFinite(columnWidth)) {
                        worksheet.getColumn(startColumnIndex + i).width = Math.min(MAX_EXCEL_COLUMN_WIDTH, Math.floor(columnWidth / MAX_DIGIT_WIDTH_IN_PIXELS * 100) / 100)
                    }
                }
            },
            setLoadPanelOptions: function(component, options, renderLoadPanel) {
                if (!(0, _window.hasWindow)()) {
                    return
                }
                component._setOptionWithoutOptionChange("loadPanel", options);
                renderLoadPanel(component)
            },
            "export": function(options, helpers) {
                var _this2 = this;
                var customizeCell = options.customizeCell,
                    component = options.component,
                    worksheet = options.worksheet,
                    topLeftCell = options.topLeftCell,
                    autoFilterEnabled = options.autoFilterEnabled,
                    keepColumnWidths = options.keepColumnWidths,
                    selectedRowsOnly = options.selectedRowsOnly,
                    loadPanel = options.loadPanel,
                    mergeRowFieldValues = options.mergeRowFieldValues,
                    mergeColumnFieldValues = options.mergeColumnFieldValues;
                var initialLoadPanelOptions = (0, _extend.extend)({}, component.option("loadPanel"));
                if ("animation" in component.option("loadPanel")) {
                    loadPanel.animation = null
                }
                this.setLoadPanelOptions(component, loadPanel, helpers._renderLoadPanel);
                var wrapText = !!component.option("wordWrapEnabled");
                worksheet.properties.outlineProperties = {
                    summaryBelow: false,
                    summaryRight: false
                };
                var cellRange = {
                    from: {
                        row: topLeftCell.row,
                        column: topLeftCell.column
                    },
                    to: {
                        row: topLeftCell.row,
                        column: topLeftCell.column
                    }
                };
                var dataProvider = component.getDataProvider(selectedRowsOnly);
                return new Promise(function(resolve) {
                    dataProvider.ready().done(function() {
                        var columns = dataProvider.getColumns();
                        var dataRowsCount = dataProvider.getRowsCount();
                        if (keepColumnWidths) {
                            _this2.setColumnsWidth(worksheet, dataProvider.getColumnsWidths(), cellRange.from.column)
                        }
                        var mergedRangesManager = new _export_merged_ranges_manager.MergedRangesManager(dataProvider, helpers, mergeRowFieldValues, mergeColumnFieldValues);
                        var styles = _this2.getCellStyles(dataProvider);
                        for (var rowIndex = 0; rowIndex < dataRowsCount; rowIndex++) {
                            var row = worksheet.getRow(cellRange.from.row + rowIndex);
                            helpers._trySetOutlineLevel(dataProvider, row, rowIndex);
                            _this2.exportRow(dataProvider, helpers, mergedRangesManager, rowIndex, columns.length, row, cellRange.from.column, customizeCell, wrapText, styles);
                            if (rowIndex >= 1) {
                                cellRange.to.row++
                            }
                        }
                        mergedRangesManager.applyMergedRages(worksheet);
                        cellRange.to.column += columns.length > 0 ? columns.length - 1 : 0;
                        var worksheetViewSettings = worksheet.views[0] || {};
                        if (component.option("rtlEnabled")) {
                            worksheetViewSettings.rightToLeft = true
                        }
                        if (helpers._isFrozenZone(dataProvider)) {
                            if (Object.keys(worksheetViewSettings).indexOf("state") === -1) {
                                (0, _extend.extend)(worksheetViewSettings, helpers._getWorksheetFrozenState(dataProvider, cellRange))
                            }
                            helpers._trySetAutoFilter(dataProvider, worksheet, cellRange, autoFilterEnabled)
                        }
                        if (Object.keys(worksheetViewSettings).length > 0) {
                            worksheet.views = [worksheetViewSettings]
                        }
                        resolve(cellRange)
                    }).always(function() {
                        _this2.setLoadPanelOptions(component, initialLoadPanelOptions, helpers._renderLoadPanel)
                    })
                })
            },
            exportRow: function(dataProvider, helpers, mergedRangesManager, rowIndex, cellCount, row, startColumnIndex, customizeCell, wrapText, styles) {
                for (var cellIndex = 0; cellIndex < cellCount; cellIndex++) {
                    var cellData = dataProvider.getCellData(rowIndex, cellIndex, true);
                    var excelCell = row.getCell(startColumnIndex + cellIndex);
                    mergedRangesManager.updateMergedRanges(excelCell, rowIndex, cellIndex);
                    var cellInfo = mergedRangesManager.findMergedCellInfo(rowIndex, cellIndex);
                    if ((0, _type.isDefined)(cellInfo) && excelCell !== cellInfo.masterCell) {
                        excelCell.style = cellInfo.masterCell.style;
                        excelCell.value = cellInfo.masterCell.value
                    } else {
                        if ((0, _type.isDate)(cellData.value)) {
                            excelCell.value = this.convertDateForExcelJS(cellData.value)
                        } else {
                            excelCell.value = cellData.value
                        }
                        if ((0, _type.isDefined)(excelCell.value)) {
                            var _styles$dataProvider$ = styles[dataProvider.getStyleId(rowIndex, cellIndex)],
                                bold = _styles$dataProvider$.bold,
                                horizontalAlignment = _styles$dataProvider$.alignment,
                                numberFormat = _styles$dataProvider$.numberFormat;
                            if ((0, _type.isDefined)(numberFormat)) {
                                this.setNumberFormat(excelCell, numberFormat)
                            } else {
                                if ((0, _type.isString)(excelCell.value) && /^[@=+-]/.test(excelCell.value)) {
                                    this.setNumberFormat(excelCell, "@")
                                }
                            }
                            helpers._trySetFont(excelCell, bold);
                            this.setAlignment(excelCell, wrapText, horizontalAlignment)
                        }
                    }
                    if ((0, _type.isFunction)(customizeCell)) {
                        customizeCell(helpers._getCustomizeCellOptions(excelCell, cellData.cellSourceData))
                    }
                }
            }
        };
        exports.Export = Export
    },
    /*!***********************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/comparator.js ***!
      \***********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.equals = void 0;
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../dom_adapter */ 11));
        var _data = __webpack_require__( /*! ./data */ 20);
        var _type = __webpack_require__( /*! ./type */ 1);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        var hasNegation = function(oldValue, newValue) {
            return 1 / oldValue === 1 / newValue
        };
        var equals = function(oldValue, newValue) {
            oldValue = (0, _data.toComparable)(oldValue, true);
            newValue = (0, _data.toComparable)(newValue, true);
            if (oldValue && newValue && (0, _type.isRenderer)(oldValue) && (0, _type.isRenderer)(newValue)) {
                return newValue.is(oldValue)
            }
            var oldValueIsNaN = oldValue !== oldValue;
            var newValueIsNaN = newValue !== newValue;
            if (oldValueIsNaN && newValueIsNaN) {
                return true
            }
            if (0 === oldValue && 0 === newValue) {
                return hasNegation(oldValue, newValue)
            }
            if (null === oldValue || "object" !== _typeof(oldValue) || _dom_adapter.default.isElementNode(oldValue)) {
                return oldValue === newValue
            }
            return false
        };
        exports.equals = equals
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/template_manager.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.acquireTemplate = exports.acquireIntegrationTemplate = exports.defaultCreateElement = exports.templateKey = exports.validateTemplateSource = exports.getNormalizedTemplateArgs = exports.addOneRenderedCall = exports.suitableTemplatesByName = exports.findTemplates = void 0;
        var _config = _interopRequireDefault(__webpack_require__( /*! ../config */ 31));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../devices */ 13));
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../errors */ 25));
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../renderer */ 2));
        var _child_default_template = __webpack_require__( /*! ../templates/child_default_template */ 153);
        var _empty_template = __webpack_require__( /*! ../templates/empty_template */ 91);
        var _template = __webpack_require__( /*! ../templates/template */ 520);
        var _template_base = __webpack_require__( /*! ../templates/template_base */ 75);
        var _array = __webpack_require__( /*! ./array */ 12);
        var _common = __webpack_require__( /*! ./common */ 4);
        var _dom = __webpack_require__( /*! ./dom */ 33);
        var _extend = __webpack_require__( /*! ./extend */ 0);
        var _type = __webpack_require__( /*! ./type */ 1);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var findTemplates = function(element, name) {
            var optionsAttributeName = "data-options";
            var templates = (0, _renderer.default)(element).contents().filter("[".concat(optionsAttributeName, '*="').concat(name, '"]'));
            return [].slice.call(templates).map(function(element) {
                var optionsString = (0, _renderer.default)(element).attr(optionsAttributeName) || "";
                return {
                    element: element,
                    options: (0, _config.default)().optionsParser(optionsString)[name]
                }
            }).filter(function(template) {
                return !!template.options
            })
        };
        exports.findTemplates = findTemplates;
        var suitableTemplatesByName = function(rawTemplates) {
            var templatesMap = (0, _array.groupBy)(rawTemplates, function(template) {
                return template.options.name
            });
            if (templatesMap[void 0]) {
                throw _errors.default.Error("E0023")
            }
            var result = {};
            Object.keys(templatesMap).forEach(function(name) {
                var _findBestMatches$;
                var suitableTemplate = null === (_findBestMatches$ = (0, _common.findBestMatches)(_devices.default.current(), templatesMap[name], function(template) {
                    return template.options
                })[0]) || void 0 === _findBestMatches$ ? void 0 : _findBestMatches$.element;
                if (suitableTemplate) {
                    result[name] = suitableTemplate
                }
            });
            return result
        };
        exports.suitableTemplatesByName = suitableTemplatesByName;
        var addOneRenderedCall = function(template) {
            var _render = template.render.bind(template);
            return (0, _extend.extend)({}, template, {
                render: function(options) {
                    var templateResult = _render(options);
                    options && options.onRendered && options.onRendered();
                    return templateResult
                }
            })
        };
        exports.addOneRenderedCall = addOneRenderedCall;
        var getNormalizedTemplateArgs = function(options) {
            var args = [];
            if ("model" in options) {
                args.push(options.model)
            }
            if ("index" in options) {
                args.push(options.index)
            }
            args.push(options.container);
            return args
        };
        exports.getNormalizedTemplateArgs = getNormalizedTemplateArgs;
        var validateTemplateSource = function(templateSource) {
            return "string" === typeof templateSource ? (0, _dom.normalizeTemplateElement)(templateSource) : templateSource
        };
        exports.validateTemplateSource = validateTemplateSource;
        var templateKey = function(templateSource) {
            return (0, _type.isRenderer)(templateSource) && templateSource[0] || templateSource
        };
        exports.templateKey = templateKey;
        var defaultCreateElement = function(element) {
            return new _template.Template(element)
        };
        exports.defaultCreateElement = defaultCreateElement;
        var acquireIntegrationTemplate = function(templateSource, templates, isAsyncTemplate, skipTemplates) {
            var integrationTemplate = null;
            if (!skipTemplates || skipTemplates.indexOf(templateSource) === -1) {
                integrationTemplate = templates[templateSource];
                if (integrationTemplate && !(integrationTemplate instanceof _template_base.TemplateBase) && !isAsyncTemplate) {
                    integrationTemplate = addOneRenderedCall(integrationTemplate)
                }
            }
            return integrationTemplate
        };
        exports.acquireIntegrationTemplate = acquireIntegrationTemplate;
        var acquireTemplate = function(templateSource, createTemplate, templates, isAsyncTemplate, skipTemplates, defaultTemplates) {
            if (null == templateSource) {
                return new _empty_template.EmptyTemplate
            }
            if (templateSource instanceof _child_default_template.ChildDefaultTemplate) {
                return defaultTemplates[templateSource.name]
            }
            if (templateSource instanceof _template_base.TemplateBase) {
                return templateSource
            }
            if ((0, _type.isFunction)(templateSource.render) && !(0, _type.isRenderer)(templateSource)) {
                return isAsyncTemplate ? templateSource : addOneRenderedCall(templateSource)
            }
            if (templateSource.nodeType || (0, _type.isRenderer)(templateSource)) {
                return createTemplate((0, _renderer.default)(templateSource))
            }
            return acquireIntegrationTemplate(templateSource, templates, isAsyncTemplate, skipTemplates) || defaultTemplates[templateSource] || createTemplate(templateSource)
        };
        exports.acquireTemplate = acquireTemplate
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/data/query_implementation.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.queryImpl = void 0;
        var _array_query = _interopRequireDefault(__webpack_require__( /*! ./array_query */ 168));
        var _remote_query = _interopRequireDefault(__webpack_require__( /*! ./remote_query */ 526));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var queryImpl = {
            array: _array_query.default,
            remote: _remote_query.default
        };
        exports.queryImpl = queryImpl
    },
    /*!******************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/queue.js ***!
      \******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.create = createQueue;
        exports.enqueue = void 0;
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../errors */ 25));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function createQueue(discardPendingTasks) {
            var _tasks = [];
            var _busy = false;

            function exec() {
                while (_tasks.length) {
                    _busy = true;
                    var task = _tasks.shift();
                    var result = task();
                    if (void 0 === result) {
                        continue
                    }
                    if (result.then) {
                        (0, _deferred.when)(result).always(exec);
                        return
                    }
                    throw _errors.default.Error("E0015")
                }
                _busy = false
            }

            function add(task, removeTaskCallback) {
                if (!discardPendingTasks) {
                    _tasks.push(task)
                } else {
                    if (_tasks[0] && removeTaskCallback) {
                        removeTaskCallback(_tasks[0])
                    }
                    _tasks = [task]
                }
                if (!_busy) {
                    exec()
                }
            }

            function busy() {
                return _busy
            }
            return {
                add: add,
                busy: busy
            }
        }
        var enqueue = createQueue().add;
        exports.enqueue = enqueue
    },
    /*!******************************************************!*\
      !*** ./artifacts/transpiled-npm/animation/easing.js ***!
      \******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.setEasing = setEasing;
        exports.getEasing = getEasing;
        exports.convertTransitionTimingFuncToEasing = void 0;
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var CSS_TRANSITION_EASING_REGEX = /cubic-bezier\((\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\)/;
        var TransitionTimingFuncMap = {
            linear: "cubic-bezier(0, 0, 1, 1)",
            swing: "cubic-bezier(0.445, 0.05, 0.55, 0.95)",
            ease: "cubic-bezier(0.25, 0.1, 0.25, 1)",
            "ease-in": "cubic-bezier(0.42, 0, 1, 1)",
            "ease-out": "cubic-bezier(0, 0, 0.58, 1)",
            "ease-in-out": "cubic-bezier(0.42, 0, 0.58, 1)"
        };
        var polynomBezier = function(x1, y1, x2, y2) {
            var Cx = 3 * x1;
            var Bx = 3 * (x2 - x1) - Cx;
            var Ax = 1 - Cx - Bx;
            var Cy = 3 * y1;
            var By = 3 * (y2 - y1) - Cy;
            var Ay = 1 - Cy - By;
            var bezierX = function(t) {
                return t * (Cx + t * (Bx + t * Ax))
            };
            var bezierY = function(t) {
                return t * (Cy + t * (By + t * Ay))
            };
            var derivativeX = function(t) {
                return Cx + t * (2 * Bx + 3 * t * Ax)
            };
            var findXFor = function(t) {
                var x = t;
                var i = 0;
                var z;
                while (i < 14) {
                    z = bezierX(x) - t;
                    if (Math.abs(z) < .001) {
                        break
                    }
                    x -= z / derivativeX(x);
                    i++
                }
                return x
            };
            return function(t) {
                return bezierY(findXFor(t))
            }
        };
        var easing = {};
        var convertTransitionTimingFuncToEasing = function(cssTransitionEasing) {
            cssTransitionEasing = TransitionTimingFuncMap[cssTransitionEasing] || cssTransitionEasing;
            var coeffs = cssTransitionEasing.match(CSS_TRANSITION_EASING_REGEX);
            var forceName;
            if (!coeffs) {
                forceName = "linear";
                coeffs = TransitionTimingFuncMap[forceName].match(CSS_TRANSITION_EASING_REGEX)
            }
            coeffs = coeffs.slice(1, 5);
            for (var i = 0; i < coeffs.length; i++) {
                coeffs[i] = parseFloat(coeffs[i])
            }
            var easingName = forceName || "cubicbezier_" + coeffs.join("_").replace(/\./g, "p");
            if (!(0, _type.isFunction)(easing[easingName])) {
                easing[easingName] = function(x, t, b, c, d) {
                    return c * polynomBezier(coeffs[0], coeffs[1], coeffs[2], coeffs[3])(t / d) + b
                }
            }
            return easingName
        };
        exports.convertTransitionTimingFuncToEasing = convertTransitionTimingFuncToEasing;

        function setEasing(value) {
            easing = value
        }

        function getEasing(name) {
            return easing[name]
        }
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/events/pointer/touch.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _base = _interopRequireDefault(__webpack_require__( /*! ./base */ 169));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var eventMap = {
            dxpointerdown: "touchstart",
            dxpointermove: "touchmove",
            dxpointerup: "touchend",
            dxpointercancel: "touchcancel",
            dxpointerover: "",
            dxpointerout: "",
            dxpointerenter: "",
            dxpointerleave: ""
        };
        var normalizeTouchEvent = function(e) {
            var pointers = [];
            (0, _iterator.each)(e.touches, function(_, touch) {
                pointers.push((0, _extend.extend)({
                    pointerId: touch.identifier
                }, touch))
            });
            return {
                pointers: pointers,
                pointerId: e.changedTouches[0].identifier
            }
        };
        var skipTouchWithSameIdentifier = function(pointerEvent) {
            return "ios" === _devices.default.real().platform && ("dxpointerdown" === pointerEvent || "dxpointerup" === pointerEvent)
        };
        var TouchStrategy = _base.default.inherit({
            ctor: function() {
                this.callBase.apply(this, arguments);
                this._pointerId = 0
            },
            _handler: function(e) {
                if (skipTouchWithSameIdentifier(this._eventName)) {
                    var touch = e.changedTouches[0];
                    if (this._pointerId === touch.identifier && 0 !== this._pointerId) {
                        return
                    }
                    this._pointerId = touch.identifier
                }
                return this.callBase.apply(this, arguments)
            },
            _fireEvent: function(args) {
                return this.callBase((0, _extend.extend)(normalizeTouchEvent(args.originalEvent), args))
            }
        });
        TouchStrategy.map = eventMap;
        TouchStrategy.normalize = normalizeTouchEvent;
        var _default = TouchStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************************!*\
      !*** ./artifacts/transpiled-npm/events/pointer/observer.js ***!
      \*************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _ready_callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/ready_callbacks */ 49));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var addEventsListener = function(events, handler) {
            _ready_callbacks.default.add(function() {
                events.split(" ").forEach(function(event) {
                    _dom_adapter.default.listen(_dom_adapter.default.getDocument(), event, handler, true)
                })
            })
        };
        var Observer = function(eventMap, pointerEquals, onPointerAdding) {
            onPointerAdding = onPointerAdding || function() {};
            var pointers = [];
            var getPointerIndex = function(e) {
                var index = -1;
                (0, _iterator.each)(pointers, function(i, pointer) {
                    if (!pointerEquals(e, pointer)) {
                        return true
                    }
                    index = i;
                    return false
                });
                return index
            };
            var addPointer = function(e) {
                if (getPointerIndex(e) === -1) {
                    onPointerAdding(e);
                    pointers.push(e)
                }
            };
            var removePointer = function(e) {
                var index = getPointerIndex(e);
                if (index > -1) {
                    pointers.splice(index, 1)
                }
            };
            var updatePointer = function(e) {
                pointers[getPointerIndex(e)] = e
            };
            addEventsListener(eventMap.dxpointerdown, addPointer);
            addEventsListener(eventMap.dxpointermove, updatePointer);
            addEventsListener(eventMap.dxpointerup, removePointer);
            addEventsListener(eventMap.dxpointercancel, removePointer);
            this.pointers = function() {
                return pointers
            };
            this.reset = function() {
                pointers = []
            }
        };
        var _default = Observer;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/events/pointer/mouse.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _base = _interopRequireDefault(__webpack_require__( /*! ./base */ 169));
        var _observer = _interopRequireDefault(__webpack_require__( /*! ./observer */ 255));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var eventMap = {
            dxpointerdown: "mousedown",
            dxpointermove: "mousemove",
            dxpointerup: "mouseup",
            dxpointercancel: "",
            dxpointerover: "mouseover",
            dxpointerout: "mouseout",
            dxpointerenter: "mouseenter",
            dxpointerleave: "mouseleave"
        };
        var normalizeMouseEvent = function(e) {
            e.pointerId = 1;
            return {
                pointers: observer.pointers(),
                pointerId: 1
            }
        };
        var observer;
        var activated = false;
        var activateStrategy = function() {
            if (activated) {
                return
            }
            observer = new _observer.default(eventMap, function() {
                return true
            });
            activated = true
        };
        var MouseStrategy = _base.default.inherit({
            ctor: function() {
                this.callBase.apply(this, arguments);
                activateStrategy()
            },
            _fireEvent: function(args) {
                return this.callBase((0, _extend.extend)(normalizeMouseEvent(args.originalEvent), args))
            }
        });
        MouseStrategy.map = eventMap;
        MouseStrategy.normalize = normalizeMouseEvent;
        MouseStrategy.activate = activateStrategy;
        MouseStrategy.resetObserver = function() {
            observer.reset()
        };
        var _default = MouseStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/jquery.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _jquery = _interopRequireDefault(__webpack_require__( /*! jquery */ 60));
        var _version = __webpack_require__( /*! ../core/utils/version */ 72);
        var _error = _interopRequireDefault(__webpack_require__( /*! ../core/utils/error */ 146));
        var _use_jquery = _interopRequireDefault(__webpack_require__( /*! ./jquery/use_jquery */ 89));
        __webpack_require__( /*! ./jquery/renderer */ 534);
        __webpack_require__( /*! ./jquery/hooks */ 535);
        __webpack_require__( /*! ./jquery/deferred */ 536);
        __webpack_require__( /*! ./jquery/hold_ready */ 537);
        __webpack_require__( /*! ./jquery/events */ 538);
        __webpack_require__( /*! ./jquery/easing */ 539);
        __webpack_require__( /*! ./jquery/element_data */ 540);
        __webpack_require__( /*! ./jquery/element */ 541);
        __webpack_require__( /*! ./jquery/component_registrator */ 542);
        __webpack_require__( /*! ./jquery/ajax */ 543);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var useJQuery = (0, _use_jquery.default)();
        if (useJQuery && (0, _version.compare)(_jquery.default.fn.jquery, [1, 10]) < 0) {
            throw _error.default.Error("E0012")
        }
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/themes_callback.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.themeReadyCallback = void 0;
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ../core/utils/callbacks */ 27));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var themeReadyCallback = new _callbacks.default;
        exports.themeReadyCallback = themeReadyCallback
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/locker.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../errors */ 25));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var Locker = function() {
            var info = {};
            var currentCount = function(lockName) {
                return info[lockName] || 0
            };
            return {
                obtain: function(lockName) {
                    info[lockName] = currentCount(lockName) + 1
                },
                release: function(lockName) {
                    var count = currentCount(lockName);
                    if (count < 1) {
                        throw _errors.default.Error("E0014")
                    }
                    if (1 === count) {
                        delete info[lockName]
                    } else {
                        info[lockName] = count - 1
                    }
                },
                locked: function(lockName) {
                    return currentCount(lockName) > 0
                }
            }
        };
        var _default = Locker;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/selection/selection.strategy.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _query = _interopRequireDefault(__webpack_require__( /*! ../../data/query */ 48));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _class.default.inherit({
            ctor: function(options) {
                this.options = options;
                this._setOption("disabledItemKeys", []);
                this._clearItemKeys()
            },
            _clearItemKeys: function() {
                this._setOption("addedItemKeys", []);
                this._setOption("removedItemKeys", []);
                this._setOption("removedItems", []);
                this._setOption("addedItems", [])
            },
            validate: _common.noop,
            _setOption: function(name, value) {
                this.options[name] = value
            },
            onSelectionChanged: function onSelectionChanged() {
                var addedItemKeys = this.options.addedItemKeys;
                var removedItemKeys = this.options.removedItemKeys;
                var addedItems = this.options.addedItems;
                var removedItems = this.options.removedItems;
                var selectedItems = this.options.selectedItems;
                var selectedItemKeys = this.options.selectedItemKeys;
                var onSelectionChanged = this.options.onSelectionChanged || _common.noop;
                this._clearItemKeys();
                onSelectionChanged({
                    selectedItems: selectedItems,
                    selectedItemKeys: selectedItemKeys,
                    addedItemKeys: addedItemKeys,
                    removedItemKeys: removedItemKeys,
                    addedItems: addedItems,
                    removedItems: removedItems
                })
            },
            equalKeys: function(key1, key2) {
                if (this.options.equalByReference) {
                    if ((0, _type.isObject)(key1) && (0, _type.isObject)(key2)) {
                        return key1 === key2
                    }
                }
                return (0, _common.equalByValue)(key1, key2)
            },
            getSelectableItems: function(items) {
                return items.filter(function(item) {
                    return !item.disabled
                })
            },
            _clearSelection: function(keys, preserve, isDeselect, isSelectAll) {
                keys = keys || [];
                keys = Array.isArray(keys) ? keys : [keys];
                this.validate();
                return this.selectedItemKeys(keys, preserve, isDeselect, isSelectAll)
            },
            _loadFilteredData: function(remoteFilter, localFilter, select, isSelectAll) {
                var filterLength = encodeURI(JSON.stringify(remoteFilter)).length;
                var needLoadAllData = this.options.maxFilterLengthInRequest && filterLength > this.options.maxFilterLengthInRequest;
                var deferred = new _deferred.Deferred;
                var loadOptions = {
                    filter: needLoadAllData ? void 0 : remoteFilter,
                    select: needLoadAllData ? this.options.dataFields() : select || this.options.dataFields()
                };
                if (remoteFilter && 0 === remoteFilter.length) {
                    deferred.resolve([])
                } else {
                    this.options.load(loadOptions).done(function(items) {
                        var filteredItems = (0, _type.isPlainObject)(items) ? items.data : items;
                        if (localFilter && !isSelectAll) {
                            filteredItems = filteredItems.filter(localFilter)
                        } else {
                            if (needLoadAllData) {
                                filteredItems = (0, _query.default)(filteredItems).filter(remoteFilter).toArray()
                            }
                        }
                        deferred.resolve(filteredItems)
                    }).fail(deferred.reject.bind(deferred))
                }
                return deferred
            },
            updateSelectedItemKeyHash: function(keys) {
                for (var i = 0; i < keys.length; i++) {
                    var keyHash = (0, _common.getKeyHash)(keys[i]);
                    if (!(0, _type.isObject)(keyHash)) {
                        this.options.keyHashIndices[keyHash] = this.options.keyHashIndices[keyHash] || [];
                        var keyIndices = this.options.keyHashIndices[keyHash];
                        keyIndices.push(i)
                    }
                }
            },
            _isAnyItemSelected: function(items) {
                for (var i = 0; i < items.length; i++) {
                    if (this.options.isItemSelected(items[i])) {
                        return
                    }
                }
                return false
            },
            _getFullSelectAllState: function() {
                var items = this.options.plainItems();
                var dataFilter = this.options.filter();
                var selectedItems = this.options.selectedItems;
                if (dataFilter) {
                    selectedItems = (0, _query.default)(selectedItems).filter(dataFilter).toArray()
                }
                var selectedItemsLength = selectedItems.length;
                if (!selectedItemsLength) {
                    return this._isAnyItemSelected(items)
                }
                if (selectedItemsLength >= this.options.totalCount() - this.options.disabledItemKeys.length) {
                    return true
                }
                return
            },
            _getVisibleSelectAllState: function() {
                var items = this.getSelectableItems(this.options.plainItems());
                var hasSelectedItems = false;
                var hasUnselectedItems = false;
                for (var i = 0; i < items.length; i++) {
                    var item = items[i];
                    var itemData = this.options.getItemData(item);
                    var key = this.options.keyOf(itemData);
                    if (this.options.isSelectableItem(item)) {
                        if (this.isItemKeySelected(key)) {
                            hasSelectedItems = true
                        } else {
                            hasUnselectedItems = true
                        }
                    }
                }
                if (hasSelectedItems) {
                    return !hasUnselectedItems ? true : void 0
                } else {
                    return false
                }
            }
        });
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/knockout/utils.js ***!
      \****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getClosestNodeWithContext = void 0;
        var _knockout = _interopRequireDefault(__webpack_require__( /*! knockout */ 66));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var getClosestNodeWithContext = function getClosestNodeWithContext(node) {
            var context = _knockout.default.contextFor(node);
            if (!context && node.parentNode) {
                return getClosestNodeWithContext(node.parentNode)
            }
            return node
        };
        exports.getClosestNodeWithContext = getClosestNodeWithContext
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/bundles/modules/data.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var DevExpress = __webpack_require__( /*! ./core */ 154);
        module.exports = DevExpress.data = DevExpress.data || {};
        Object.defineProperty(DevExpress.data, "errorHandler", {
            get: function() {
                /*! ../../data/errors */
                return __webpack_require__(38).errorHandler
            },
            set: function(value) {
                __webpack_require__( /*! ../../data/errors */ 38).errorHandler = value
            }
        });
        Object.defineProperty(DevExpress.data, "_errorHandler", {
            get: function() {
                /*! ../../data/errors */
                return __webpack_require__(38)._errorHandler
            },
            set: function(value) {
                __webpack_require__( /*! ../../data/errors */ 38)._errorHandler = value
            }
        });
        DevExpress.data.DataSource = __webpack_require__( /*! ../../data/data_source */ 332);
        DevExpress.data.query = __webpack_require__( /*! ../../data/query */ 48);
        DevExpress.data.Store = __webpack_require__( /*! ../../data/abstract_store */ 105);
        DevExpress.data.ArrayStore = __webpack_require__( /*! ../../data/array_store */ 77);
        DevExpress.data.CustomStore = __webpack_require__( /*! ../../data/custom_store */ 130);
        DevExpress.data.LocalStore = __webpack_require__( /*! ../../data/local_store */ 568);
        DevExpress.data.base64_encode = __webpack_require__( /*! ../../data/utils */ 41).base64_encode;
        DevExpress.data.applyChanges = __webpack_require__( /*! ../../data/apply_changes */ 569);
        DevExpress.data.Guid = __webpack_require__( /*! ../../core/guid */ 36);
        DevExpress.data.utils = {};
        DevExpress.data.utils.compileGetter = __webpack_require__( /*! ../../core/utils/data */ 20).compileGetter;
        DevExpress.data.utils.compileSetter = __webpack_require__( /*! ../../core/utils/data */ 20).compileSetter;
        DevExpress.EndpointSelector = __webpack_require__( /*! ../../data/endpoint_selector */ 570);
        DevExpress.data.queryImpl = __webpack_require__( /*! ../../data/query_implementation */ 251).queryImpl;
        DevExpress.data.queryAdapters = __webpack_require__( /*! ../../data/query_adapters */ 199);
        var dataUtils = __webpack_require__( /*! ../../data/utils */ 41);
        DevExpress.data.utils.normalizeBinaryCriterion = dataUtils.normalizeBinaryCriterion;
        DevExpress.data.utils.normalizeSortingInfo = dataUtils.normalizeSortingInfo;
        DevExpress.data.utils.errorMessageFromXhr = dataUtils.errorMessageFromXhr;
        DevExpress.data.utils.aggregators = dataUtils.aggregators;
        DevExpress.data.utils.keysEqual = dataUtils.keysEqual;
        DevExpress.data.utils.isDisjunctiveOperator = dataUtils.isDisjunctiveOperator;
        DevExpress.data.utils.isConjunctiveOperator = dataUtils.isConjunctiveOperator;
        DevExpress.data.utils.processRequestResultLock = dataUtils.processRequestResultLock;
        DevExpress.data.utils.toComparable = __webpack_require__( /*! ../../core/utils/data */ 20).toComparable;
        DevExpress.data.utils.multiLevelGroup = __webpack_require__( /*! ../../data/store_helper */ 94).multiLevelGroup;
        DevExpress.data.utils.arrangeSortingInfo = __webpack_require__( /*! ../../data/store_helper */ 94).arrangeSortingInfo;
        DevExpress.data.utils.normalizeDataSourceOptions = __webpack_require__( /*! ../../data/data_source/utils */ 69).normalizeDataSourceOptions
    },
    /*!******************************************************!*\
      !*** ./artifacts/transpiled-npm/data/odata/store.js ***!
      \******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _config = _interopRequireDefault(__webpack_require__( /*! ../../core/config */ 31));
        var _utils = __webpack_require__( /*! ./utils */ 101);
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../errors */ 38));
        var _query = _interopRequireDefault(__webpack_require__( /*! ../query */ 48));
        var _abstract_store = _interopRequireDefault(__webpack_require__( /*! ../abstract_store */ 105));
        var _request_dispatcher = _interopRequireDefault(__webpack_require__( /*! ./request_dispatcher */ 264));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        __webpack_require__( /*! ./query_adapter */ 171);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }
        var ANONYMOUS_KEY_NAME = "5d46402c-7899-4ea9-bd81-8b73c47c7683";
        var expandKeyType = function(key, keyType) {
            return _defineProperty({}, key, keyType)
        };
        var mergeFieldTypesWithKeyType = function(fieldTypes, keyType) {
            var result = {};
            for (var field in fieldTypes) {
                result[field] = fieldTypes[field]
            }
            for (var keyName in keyType) {
                if (keyName in result) {
                    if (result[keyName] !== keyType[keyName]) {
                        _errors.default.errors.log("W4001", keyName)
                    }
                } else {
                    result[keyName] = keyType[keyName]
                }
            }
            return result
        };
        var ODataStore = _abstract_store.default.inherit({
            ctor: function(options) {
                this.callBase(options);
                this._requestDispatcher = new _request_dispatcher.default(options);
                var key = this.key();
                var fieldTypes = options.fieldTypes;
                var keyType = options.keyType;
                if (keyType) {
                    var keyTypeIsString = "string" === typeof keyType;
                    if (!key) {
                        key = keyTypeIsString ? ANONYMOUS_KEY_NAME : Object.keys(keyType);
                        this._legacyAnonymousKey = key
                    }
                    if (keyTypeIsString) {
                        keyType = expandKeyType(key, keyType)
                    }
                    fieldTypes = mergeFieldTypesWithKeyType(fieldTypes, keyType)
                }
                this._fieldTypes = fieldTypes || {};
                if (2 === this.version()) {
                    this._updateMethod = "MERGE"
                } else {
                    this._updateMethod = "PATCH"
                }
            },
            _customLoadOptions: function() {
                return ["expand", "customQueryParams"]
            },
            _byKeyImpl: function(key, extraOptions) {
                var params = {};
                if (extraOptions) {
                    params.$expand = (0, _utils.generateExpand)(this.version(), extraOptions.expand, extraOptions.select) || void 0;
                    params.$select = (0, _utils.generateSelect)(this.version(), extraOptions.select) || void 0
                }
                return this._requestDispatcher.sendRequest(this._byKeyUrl(key), "GET", params)
            },
            createQuery: function(loadOptions) {
                var _loadOptions$urlOverr;
                var url;
                var queryOptions = {
                    adapter: "odata",
                    beforeSend: this._requestDispatcher.beforeSend,
                    errorHandler: this._errorHandler,
                    jsonp: this._requestDispatcher.jsonp,
                    version: this._requestDispatcher.version,
                    withCredentials: this._requestDispatcher._withCredentials,
                    expand: null === loadOptions || void 0 === loadOptions ? void 0 : loadOptions.expand,
                    requireTotalCount: null === loadOptions || void 0 === loadOptions ? void 0 : loadOptions.requireTotalCount,
                    deserializeDates: this._requestDispatcher._deserializeDates,
                    fieldTypes: this._fieldTypes
                };
                url = null !== (_loadOptions$urlOverr = null === loadOptions || void 0 === loadOptions ? void 0 : loadOptions.urlOverride) && void 0 !== _loadOptions$urlOverr ? _loadOptions$urlOverr : this._requestDispatcher.url;
                if ((0, _type.isDefined)(this._requestDispatcher.filterToLower)) {
                    queryOptions.filterToLower = this._requestDispatcher.filterToLower
                }
                if (null !== loadOptions && void 0 !== loadOptions && loadOptions.customQueryParams) {
                    var params = (0, _utils.escapeServiceOperationParams)(null === loadOptions || void 0 === loadOptions ? void 0 : loadOptions.customQueryParams, this.version());
                    if (4 === this.version()) {
                        url = (0, _utils.formatFunctionInvocationUrl)(url, params)
                    } else {
                        queryOptions.params = params
                    }
                }
                return (0, _query.default)(url, queryOptions)
            },
            _insertImpl: function(values) {
                var _this = this;
                this._requireKey();
                var d = new _deferred.Deferred;
                (0, _deferred.when)(this._requestDispatcher.sendRequest(this._requestDispatcher.url, "POST", null, values)).done(function(serverResponse) {
                    return d.resolve(serverResponse && !(0, _config.default)().useLegacyStoreResult ? serverResponse : values, _this.keyOf(serverResponse))
                }).fail(d.reject);
                return d.promise()
            },
            _updateImpl: function(key, values) {
                var d = new _deferred.Deferred;
                (0, _deferred.when)(this._requestDispatcher.sendRequest(this._byKeyUrl(key), this._updateMethod, null, values)).done(function(serverResponse) {
                    return (0, _config.default)().useLegacyStoreResult ? d.resolve(key, values) : d.resolve(serverResponse || values, key)
                }).fail(d.reject);
                return d.promise()
            },
            _removeImpl: function(key) {
                var d = new _deferred.Deferred;
                (0, _deferred.when)(this._requestDispatcher.sendRequest(this._byKeyUrl(key), "DELETE")).done(function() {
                    return d.resolve(key)
                }).fail(d.reject);
                return d.promise()
            },
            _convertKey: function(value) {
                var result = value;
                var fieldTypes = this._fieldTypes;
                var key = this.key() || this._legacyAnonymousKey;
                if (Array.isArray(key)) {
                    result = {};
                    for (var i = 0; i < key.length; i++) {
                        var keyName = key[i];
                        result[keyName] = (0, _utils.convertPrimitiveValue)(fieldTypes[keyName], value[keyName])
                    }
                } else {
                    if (fieldTypes[key]) {
                        result = (0, _utils.convertPrimitiveValue)(fieldTypes[key], value)
                    }
                }
                return result
            },
            _byKeyUrl: function(value) {
                var baseUrl = this._requestDispatcher.url;
                var convertedKey = this._convertKey(value);
                return "".concat(baseUrl, "(").concat(encodeURIComponent((0, _utils.serializeKey)(convertedKey, this.version())), ")")
            },
            version: function() {
                return this._requestDispatcher.version
            }
        }, "odata");
        var _default = ODataStore;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/data/odata/request_dispatcher.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _utils = __webpack_require__( /*! ./utils */ 101);
        __webpack_require__( /*! ./query_adapter */ 171);

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }
        var DEFAULT_PROTOCOL_VERSION = 2;
        var RequestDispatcher = function() {
            function RequestDispatcher(options) {
                options = options || {};
                this._url = String(options.url).replace(/\/+$/, "");
                this._beforeSend = options.beforeSend;
                this._jsonp = options.jsonp;
                this._version = options.version || DEFAULT_PROTOCOL_VERSION;
                this._withCredentials = options.withCredentials;
                this._deserializeDates = options.deserializeDates;
                this._filterToLower = options.filterToLower
            }
            var _proto = RequestDispatcher.prototype;
            _proto.sendRequest = function(url, method, params, payload) {
                return (0, _utils.sendRequest)(this.version, {
                    url: url,
                    method: method,
                    params: params || {},
                    payload: payload
                }, {
                    beforeSend: this._beforeSend,
                    jsonp: this._jsonp,
                    withCredentials: this._withCredentials,
                    deserializeDates: this._deserializeDates
                })
            };
            _createClass(RequestDispatcher, [{
                key: "version",
                get: function() {
                    return this._version
                }
            }, {
                key: "beforeSend",
                get: function() {
                    return this._beforeSend
                }
            }, {
                key: "url",
                get: function() {
                    return this._url
                }
            }, {
                key: "jsonp",
                get: function() {
                    return this._jsonp
                }
            }, {
                key: "filterToLower",
                get: function() {
                    return this._filterToLower
                }
            }]);
            return RequestDispatcher
        }();
        exports.default = RequestDispatcher;
        module.exports = exports.default
    },
    /*!***********************************************************!*\
      !*** ./artifacts/transpiled-npm/file_management/utils.js ***!
      \***********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.pathCombine = exports.getEscapedFileName = exports.getPathParts = exports.getParentPath = exports.getName = exports.getFileExtension = exports.PATH_SEPARATOR = void 0;
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var PATH_SEPARATOR = "/";
        exports.PATH_SEPARATOR = PATH_SEPARATOR;
        var getFileExtension = function(path) {
            var index = path.lastIndexOf(".");
            return index !== -1 ? path.substr(index) : ""
        };
        exports.getFileExtension = getFileExtension;
        var getName = function(path) {
            var index = path.lastIndexOf(PATH_SEPARATOR);
            return index !== -1 ? path.substr(index + PATH_SEPARATOR.length) : path
        };
        exports.getName = getName;
        var getParentPath = function(path) {
            var index = path.lastIndexOf(PATH_SEPARATOR);
            return index !== -1 ? path.substr(0, index) : ""
        };
        exports.getParentPath = getParentPath;
        var getPathParts = function(path, includeFullPath) {
            if (!path || "/" === path) {
                return []
            }
            var result = [];
            var pathPart = "";
            for (var i = 0; i < path.length; i++) {
                var char = path.charAt(i);
                if (char === PATH_SEPARATOR) {
                    var nextChar = path.charAt(i + 1);
                    if (nextChar !== PATH_SEPARATOR) {
                        if (pathPart) {
                            result.push(pathPart);
                            pathPart = ""
                        }
                        char = nextChar
                    }
                    i++
                }
                pathPart += char
            }
            if (pathPart) {
                result.push(pathPart)
            }
            if (includeFullPath) {
                for (var _i = 0; _i < result.length; _i++) {
                    result[_i] = pathCombine(0 === _i ? "" : result[_i - 1], getEscapedFileName(result[_i]))
                }
            }
            return result
        };
        exports.getPathParts = getPathParts;
        var getEscapedFileName = function(fileName) {
            return fileName.replace(/\//g, "//")
        };
        exports.getEscapedFileName = getEscapedFileName;
        var pathCombine = function() {
            var result = "";
            (0, _iterator.each)(arguments, function(_, arg) {
                if (arg) {
                    if (result) {
                        result += PATH_SEPARATOR
                    }
                    result += arg
                }
            });
            return result
        };
        exports.pathCombine = pathCombine
    },
    /*!************************************************************!*\
      !*** ./artifacts/transpiled-npm/file_management/errors.js ***!
      \************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var ErrorCode = {
            NoAccess: 0,
            FileExists: 1,
            FileNotFound: 2,
            DirectoryExists: 3,
            DirectoryNotFound: 4,
            WrongFileExtension: 5,
            MaxFileSizeExceeded: 6,
            InvalidSymbols: 7,
            Other: 32767
        };
        var _default = ErrorCode;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************!*\
      !*** ./artifacts/transpiled-npm/ui/dialog.js ***!
      \***********************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.confirm = exports.alert = exports.custom = exports.title = exports.FakeDialogComponent = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _component = _interopRequireDefault(__webpack_require__( /*! ../core/component */ 127));
        var _action = _interopRequireDefault(__webpack_require__( /*! ../core/action */ 111));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../core/devices */ 13));
        var _config = _interopRequireDefault(__webpack_require__( /*! ../core/config */ 31));
        var _dom = __webpack_require__( /*! ../core/utils/dom */ 33);
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _view_port = __webpack_require__( /*! ../core/utils/view_port */ 80);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../localization/message */ 10));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./widget/ui.errors */ 17));
        var _popup = _interopRequireDefault(__webpack_require__( /*! ./popup */ 46));
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var DEFAULT_BUTTON = {
            text: "OK",
            onClick: function() {
                return true
            }
        };
        var DX_DIALOG_CLASSNAME = "dx-dialog";
        var DX_DIALOG_WRAPPER_CLASSNAME = "".concat(DX_DIALOG_CLASSNAME, "-wrapper");
        var DX_DIALOG_ROOT_CLASSNAME = "".concat(DX_DIALOG_CLASSNAME, "-root");
        var DX_DIALOG_CONTENT_CLASSNAME = "".concat(DX_DIALOG_CLASSNAME, "-content");
        var DX_DIALOG_MESSAGE_CLASSNAME = "".concat(DX_DIALOG_CLASSNAME, "-message");
        var DX_DIALOG_BUTTONS_CLASSNAME = "".concat(DX_DIALOG_CLASSNAME, "-buttons");
        var DX_DIALOG_BUTTON_CLASSNAME = "".concat(DX_DIALOG_CLASSNAME, "-button");
        var DX_BUTTON_CLASSNAME = "dx-button";
        var FakeDialogComponent = _component.default.inherit({
            ctor: function(element, options) {
                this.callBase(options)
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: {
                        platform: "ios"
                    },
                    options: {
                        width: 276
                    }
                }, {
                    device: {
                        platform: "android"
                    },
                    options: {
                        lWidth: "60%",
                        pWidth: "80%"
                    }
                }])
            }
        });
        exports.FakeDialogComponent = FakeDialogComponent;
        var title = "";
        exports.title = title;
        var custom = function(options) {
            var deferred = new _deferred.Deferred;
            var defaultOptions = (new FakeDialogComponent).option();
            options = (0, _extend.extend)(defaultOptions, options);
            var $element = (0, _renderer.default)("<div>").addClass(DX_DIALOG_CLASSNAME).appendTo((0, _view_port.value)());
            var isMessageDefined = "message" in options;
            var isMessageHtmlDefined = "messageHtml" in options;
            if (isMessageDefined) {
                _ui.default.log("W1013")
            }
            var messageHtml = String(isMessageHtmlDefined ? options.messageHtml : options.message);
            var $message = (0, _renderer.default)("<div>").addClass(DX_DIALOG_MESSAGE_CLASSNAME).html(messageHtml);
            var popupToolbarItems = [];
            (0, _iterator.each)(options.buttons || [DEFAULT_BUTTON], function() {
                var action = new _action.default(this.onClick, {
                    context: popupInstance
                });
                popupToolbarItems.push({
                    toolbar: "bottom",
                    location: _devices.default.current().android ? "after" : "center",
                    widget: "dxButton",
                    options: (0, _extend.extend)({}, this, {
                        onClick: function() {
                            var result = action.execute.apply(action, arguments);
                            hide(result)
                        }
                    })
                })
            });
            var popupInstance = new _popup.default($element, (0, _extend.extend)({
                title: options.title || title,
                showTitle: (0, _common.ensureDefined)(options.showTitle, true),
                dragEnabled: (0, _common.ensureDefined)(options.dragEnabled, true),
                height: "auto",
                width: function() {
                    var isPortrait = (0, _renderer.default)(window).height() > (0, _renderer.default)(window).width();
                    var key = (isPortrait ? "p" : "l") + "Width";
                    var widthOption = Object.prototype.hasOwnProperty.call(options, key) ? options[key] : options.width;
                    return (0, _type.isFunction)(widthOption) ? widthOption() : widthOption
                },
                showCloseButton: options.showCloseButton || false,
                ignoreChildEvents: false,
                onContentReady: function(args) {
                    args.component.$content().addClass(DX_DIALOG_CONTENT_CLASSNAME).append($message)
                },
                onShowing: function(e) {
                    e.component.bottomToolbar().addClass(DX_DIALOG_BUTTONS_CLASSNAME).find(".".concat(DX_BUTTON_CLASSNAME)).addClass(DX_DIALOG_BUTTON_CLASSNAME);
                    (0, _dom.resetActiveElement)()
                },
                onShown: function(e) {
                    var $firstButton = e.component.bottomToolbar().find(".".concat(DX_BUTTON_CLASSNAME)).first();
                    _events_engine.default.trigger($firstButton, "focus")
                },
                onHiding: function() {
                    deferred.reject()
                },
                toolbarItems: popupToolbarItems,
                animation: {
                    show: {
                        type: "pop",
                        duration: 400
                    },
                    hide: {
                        type: "pop",
                        duration: 400,
                        to: {
                            opacity: 0,
                            scale: 0
                        },
                        from: {
                            opacity: 1,
                            scale: 1
                        }
                    }
                },
                rtlEnabled: (0, _config.default)().rtlEnabled,
                boundaryOffset: {
                    h: 10,
                    v: 0
                }
            }, options.popupOptions));
            popupInstance._wrapper().addClass(DX_DIALOG_WRAPPER_CLASSNAME);
            if (options.position) {
                popupInstance.option("position", options.position)
            }
            popupInstance._wrapper().addClass(DX_DIALOG_ROOT_CLASSNAME);

            function show() {
                popupInstance.show();
                return deferred.promise()
            }

            function hide(value) {
                deferred.resolve(value);
                popupInstance.hide().done(function() {
                    popupInstance.$element().remove()
                })
            }
            return {
                show: show,
                hide: hide
            }
        };
        exports.custom = custom;
        var alert = function(messageHtml, title, showTitle) {
            var options = (0, _type.isPlainObject)(messageHtml) ? messageHtml : {
                title: title,
                messageHtml: messageHtml,
                showTitle: showTitle,
                dragEnabled: showTitle
            };
            return custom(options).show()
        };
        exports.alert = alert;
        var confirm = function(messageHtml, title, showTitle) {
            var options = (0, _type.isPlainObject)(messageHtml) ? messageHtml : {
                title: title,
                messageHtml: messageHtml,
                showTitle: showTitle,
                buttons: [{
                    text: _message.default.format("Yes"),
                    onClick: function() {
                        return true
                    }
                }, {
                    text: _message.default.format("No"),
                    onClick: function() {
                        return false
                    }
                }],
                dragEnabled: showTitle
            };
            return custom(options).show()
        };
        exports.confirm = confirm
    },
    /*!*****************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/action_sheet.js ***!
      \*****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../localization/message */ 10));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _button = _interopRequireDefault(__webpack_require__( /*! ./button */ 37));
        var _uiCollection_widget = _interopRequireDefault(__webpack_require__( /*! ./collection/ui.collection_widget.edit */ 54));
        var _popup = _interopRequireDefault(__webpack_require__( /*! ./popup */ 46));
        var _popover = _interopRequireDefault(__webpack_require__( /*! ./popover */ 135));
        var _bindable_template = __webpack_require__( /*! ../core/templates/bindable_template */ 65);
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var ACTION_SHEET_CLASS = "dx-actionsheet";
        var ACTION_SHEET_CONTAINER_CLASS = "dx-actionsheet-container";
        var ACTION_SHEET_POPUP_WRAPPER_CLASS = "dx-actionsheet-popup-wrapper";
        var ACTION_SHEET_POPOVER_WRAPPER_CLASS = "dx-actionsheet-popover-wrapper";
        var ACTION_SHEET_CANCEL_BUTTON_CLASS = "dx-actionsheet-cancel";
        var ACTION_SHEET_ITEM_CLASS = "dx-actionsheet-item";
        var ACTION_SHEET_ITEM_DATA_KEY = "dxActionSheetItemData";
        var ACTION_SHEET_WITHOUT_TITLE_CLASS = "dx-actionsheet-without-title";
        var ActionSheet = _uiCollection_widget.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    usePopover: false,
                    target: null,
                    title: "",
                    showTitle: true,
                    showCancelButton: true,
                    cancelText: _message.default.format("Cancel"),
                    onCancelClick: null,
                    visible: false,
                    noDataText: "",
                    focusStateEnabled: false,
                    selectionByClick: false
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: {
                        platform: "ios",
                        tablet: true
                    },
                    options: {
                        usePopover: true
                    }
                }])
            },
            _initTemplates: function() {
                this.callBase();
                this._templateManager.addDefaultTemplates({
                    item: new _bindable_template.BindableTemplate(function($container, data) {
                        var button = new _button.default((0, _renderer.default)("<div>"), (0, _extend.extend)({
                            onClick: data && data.click
                        }, data));
                        $container.append(button.$element())
                    }, ["disabled", "icon", "text", "type", "onClick", "click"], this.option("integrationOptions.watchMethod"))
                })
            },
            _itemContainer: function() {
                return this._$itemContainer
            },
            _itemClass: function() {
                return ACTION_SHEET_ITEM_CLASS
            },
            _itemDataKey: function() {
                return ACTION_SHEET_ITEM_DATA_KEY
            },
            _toggleVisibility: _common.noop,
            _renderDimensions: _common.noop,
            _initMarkup: function() {
                this.callBase();
                this.$element().addClass(ACTION_SHEET_CLASS);
                this._createItemContainer()
            },
            _render: function() {
                this._renderPopup()
            },
            _createItemContainer: function() {
                this._$itemContainer = (0, _renderer.default)("<div>").addClass(ACTION_SHEET_CONTAINER_CLASS);
                this._renderDisabled()
            },
            _renderDisabled: function() {
                this._$itemContainer.toggleClass("dx-state-disabled", this.option("disabled"))
            },
            _renderPopup: function() {
                this._$popup = (0, _renderer.default)("<div>").appendTo(this.$element());
                this._isPopoverMode() ? this._createPopover() : this._createPopup();
                this._renderPopupTitle();
                this._mapPopupOption("visible")
            },
            _mapPopupOption: function(optionName) {
                this._popup && this._popup.option(optionName, this.option(optionName))
            },
            _isPopoverMode: function() {
                return this.option("usePopover") && this.option("target")
            },
            _renderPopupTitle: function() {
                this._mapPopupOption("showTitle");
                this._popup && this._popup._wrapper().toggleClass(ACTION_SHEET_WITHOUT_TITLE_CLASS, !this.option("showTitle"))
            },
            _clean: function() {
                if (this._$popup) {
                    this._$popup.remove()
                }
                this.callBase()
            },
            _overlayConfig: function() {
                return {
                    onInitialized: function(args) {
                        this._popup = args.component
                    }.bind(this),
                    disabled: false,
                    showTitle: true,
                    title: this.option("title"),
                    deferRendering: !window.angular,
                    onContentReady: this._popupContentReadyAction.bind(this),
                    onHidden: this.hide.bind(this)
                }
            },
            _createPopover: function() {
                this._createComponent(this._$popup, _popover.default, (0, _extend.extend)(this._overlayConfig(), {
                    width: this.option("width") || 200,
                    height: this.option("height") || "auto",
                    target: this.option("target")
                }));
                this._popup._wrapper().addClass(ACTION_SHEET_POPOVER_WRAPPER_CLASS)
            },
            _createPopup: function() {
                this._createComponent(this._$popup, _popup.default, (0, _extend.extend)(this._overlayConfig(), {
                    dragEnabled: false,
                    width: this.option("width") || "100%",
                    height: this.option("height") || "auto",
                    showCloseButton: false,
                    position: {
                        my: "bottom",
                        at: "bottom",
                        of: window
                    },
                    animation: {
                        show: {
                            type: "slide",
                            duration: 400,
                            from: {
                                position: {
                                    my: "top",
                                    at: "bottom",
                                    of: window
                                }
                            },
                            to: {
                                position: {
                                    my: "bottom",
                                    at: "bottom",
                                    of: window
                                }
                            }
                        },
                        hide: {
                            type: "slide",
                            duration: 400,
                            from: {
                                position: {
                                    my: "bottom",
                                    at: "bottom",
                                    of: window
                                }
                            },
                            to: {
                                position: {
                                    my: "top",
                                    at: "bottom",
                                    of: window
                                }
                            }
                        }
                    }
                }));
                this._popup._wrapper().addClass(ACTION_SHEET_POPUP_WRAPPER_CLASS)
            },
            _popupContentReadyAction: function() {
                this._popup.$content().append(this._$itemContainer);
                this._attachClickEvent();
                this._attachHoldEvent();
                this._prepareContent();
                this._renderContent();
                this._renderCancelButton()
            },
            _renderCancelButton: function() {
                if (this._isPopoverMode()) {
                    return
                }
                if (this._$cancelButton) {
                    this._$cancelButton.remove()
                }
                if (this.option("showCancelButton")) {
                    var cancelClickAction = this._createActionByOption("onCancelClick") || _common.noop;
                    var that = this;
                    this._$cancelButton = (0, _renderer.default)("<div>").addClass(ACTION_SHEET_CANCEL_BUTTON_CLASS).appendTo(this._popup && this._popup.$content());
                    this._createComponent(this._$cancelButton, _button.default, {
                        disabled: false,
                        text: this.option("cancelText"),
                        onClick: function(e) {
                            var hidingArgs = {
                                event: e,
                                cancel: false
                            };
                            cancelClickAction(hidingArgs);
                            if (!hidingArgs.cancel) {
                                that.hide()
                            }
                        },
                        integrationOptions: {}
                    })
                }
            },
            _attachItemClickEvent: _common.noop,
            _itemClickHandler: function(e) {
                this.callBase(e);
                if (!(0, _renderer.default)(e.target).is(".dx-state-disabled, .dx-state-disabled *")) {
                    this.hide()
                }
            },
            _itemHoldHandler: function(e) {
                this.callBase(e);
                if (!(0, _renderer.default)(e.target).is(".dx-state-disabled, .dx-state-disabled *")) {
                    this.hide()
                }
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "width":
                    case "height":
                    case "visible":
                    case "title":
                        this._mapPopupOption(args.name);
                        break;
                    case "disabled":
                        this._renderDisabled();
                        break;
                    case "showTitle":
                        this._renderPopupTitle();
                        break;
                    case "showCancelButton":
                    case "onCancelClick":
                    case "cancelText":
                        this._renderCancelButton();
                        break;
                    case "target":
                    case "usePopover":
                    case "items":
                        this._invalidate();
                        break;
                    default:
                        this.callBase(args)
                }
            },
            toggle: function(showing) {
                var that = this;
                var d = new _deferred.Deferred;
                that._popup.toggle(showing).done(function() {
                    that.option("visible", showing);
                    d.resolveWith(that)
                });
                return d.promise()
            },
            show: function() {
                return this.toggle(true)
            },
            hide: function() {
                return this.toggle(false)
            }
        });
        (0, _component_registrator.default)("dxActionSheet", ActionSheet);
        var _default = ActionSheet;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/drop_down_editor/ui.drop_down_list.js ***!
      \***************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _guid = _interopRequireDefault(__webpack_require__( /*! ../../core/guid */ 36));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./ui.drop_down_editor */ 195));
        var _list = _interopRequireDefault(__webpack_require__( /*! ../list */ 112));
        var _ui2 = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _query = _interopRequireDefault(__webpack_require__( /*! ../../data/query */ 48));
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _ui3 = _interopRequireDefault(__webpack_require__( /*! ../editor/ui.data_expression */ 275));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _child_default_template = __webpack_require__( /*! ../../core/templates/child_default_template */ 153);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _grouped_data_converter_mixin = _interopRequireDefault(__webpack_require__( /*! ../shared/grouped_data_converter_mixin */ 334));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        var window = (0, _window.getWindow)();
        var LIST_ITEM_SELECTOR = ".dx-list-item";
        var LIST_ITEM_DATA_KEY = "dxListItemData";
        var DROPDOWNLIST_POPUP_WRAPPER_CLASS = "dx-dropdownlist-popup-wrapper";
        var SKIP_GESTURE_EVENT_CLASS = "dx-skip-gesture-event";
        var SEARCH_EVENT = "input";
        var SEARCH_MODES = ["startswith", "contains", "endwith", "notcontains"];
        var DropDownList = _ui.default.inherit({
            _supportedKeys: function() {
                var parent = this.callBase();
                return (0, _extend.extend)({}, parent, {
                    tab: function(e) {
                        if (this._allowSelectItemByTab()) {
                            this._saveValueChangeEvent(e);
                            var $focusedItem = (0, _renderer.default)(this._list.option("focusedElement"));
                            $focusedItem.length && this._setSelectedElement($focusedItem)
                        }
                        parent.tab.apply(this, arguments)
                    },
                    space: _common.noop,
                    home: _common.noop,
                    end: _common.noop
                })
            },
            _allowSelectItemByTab: function() {
                return this.option("opened") && "instantly" === this.option("applyValueMode")
            },
            _setSelectedElement: function($element) {
                var value = this._valueGetter(this._list._getItemData($element));
                this._setValue(value)
            },
            _setValue: function(value) {
                this.option("value", value)
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), (0, _extend.extend)(_ui3.default._dataExpressionDefaultOptions(), {
                    displayValue: void 0,
                    searchEnabled: false,
                    searchMode: "contains",
                    searchTimeout: 500,
                    minSearchLength: 0,
                    searchExpr: null,
                    valueChangeEvent: "input change keyup",
                    selectedItem: null,
                    noDataText: _message.default.format("dxCollectionWidget-noDataText"),
                    onSelectionChanged: null,
                    onItemClick: _common.noop,
                    showDataBeforeSearch: false,
                    grouped: false,
                    groupTemplate: "group",
                    popupPosition: {
                        my: "left top",
                        at: "left bottom",
                        offset: {
                            h: 0,
                            v: 0
                        },
                        collision: "flip"
                    },
                    wrapItemText: false
                }))
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: {
                        platform: "ios"
                    },
                    options: {
                        popupPosition: {
                            offset: {
                                v: -1
                            }
                        }
                    }
                }, {
                    device: {
                        platform: "generic"
                    },
                    options: {
                        buttonsLocation: "bottom center"
                    }
                }])
            },
            _setOptionsByReference: function() {
                this.callBase();
                (0, _extend.extend)(this._optionsByReference, {
                    value: true,
                    selectedItem: true,
                    displayValue: true
                })
            },
            _init: function() {
                this.callBase();
                this._initDataExpressions();
                this._initActions();
                this._setListDataSource();
                this._validateSearchMode();
                this._clearSelectedItem();
                this._initItems()
            },
            _setListFocusedElementOptionChange: function() {
                this._list._updateParentActiveDescendant = this._updateActiveDescendant.bind(this)
            },
            _initItems: function() {
                var items = this.option().items;
                if (items && !items.length && this._dataSource) {
                    this.option().items = this._dataSource.items()
                }
            },
            _initActions: function() {
                this._initContentReadyAction();
                this._initSelectionChangedAction();
                this._initItemClickAction()
            },
            _initContentReadyAction: function() {
                this._contentReadyAction = this._createActionByOption("onContentReady", {
                    excludeValidators: ["disabled", "readOnly"]
                })
            },
            _initSelectionChangedAction: function() {
                this._selectionChangedAction = this._createActionByOption("onSelectionChanged", {
                    excludeValidators: ["disabled", "readOnly"]
                })
            },
            _initItemClickAction: function() {
                this._itemClickAction = this._createActionByOption("onItemClick")
            },
            _initTemplates: function() {
                this.callBase();
                this._templateManager.addDefaultTemplates({
                    item: new _child_default_template.ChildDefaultTemplate("item")
                })
            },
            _isEditable: function() {
                return this.callBase() || this.option("searchEnabled")
            },
            _saveFocusOnWidget: function(e) {
                if (this._list && this._list.initialOption("focusStateEnabled")) {
                    this._focusInput()
                }
            },
            _fitIntoRange: function(value, start, end) {
                if (value > end) {
                    return start
                }
                if (value < start) {
                    return end
                }
                return value
            },
            _items: function() {
                var items = this._getPlainItems(!this._list && this._dataSource.items());
                var availableItems = new _query.default(items).filter("disabled", "<>", true).toArray();
                return availableItems
            },
            _calcNextItem: function(step) {
                var items = this._items();
                var nextIndex = this._fitIntoRange(this._getSelectedIndex() + step, 0, items.length - 1);
                return items[nextIndex]
            },
            _getSelectedIndex: function() {
                var items = this._items();
                var selectedItem = this.option("selectedItem");
                var result = -1;
                (0, _iterator.each)(items, function(index, item) {
                    if (this._isValueEquals(item, selectedItem)) {
                        result = index;
                        return false
                    }
                }.bind(this));
                return result
            },
            _createPopup: function() {
                this.callBase();
                this._updateCustomBoundaryContainer();
                this._popup._wrapper().addClass(this._popupWrapperClass());
                var $popupContent = this._popup.$content();
                _events_engine.default.off($popupContent, "mouseup");
                _events_engine.default.on($popupContent, "mouseup", this._saveFocusOnWidget.bind(this));
                var that = this;
                this._popup.on({
                    shown: function() {
                        that.$element().addClass(SKIP_GESTURE_EVENT_CLASS)
                    },
                    hidden: function() {
                        that.$element().removeClass(SKIP_GESTURE_EVENT_CLASS)
                    }
                })
            },
            _updateCustomBoundaryContainer: function() {
                var customContainer = this.option("dropDownOptions.container");
                var $container = customContainer && (0, _renderer.default)(customContainer);
                if ($container && $container.length && !(0, _type.isWindow)($container.get(0))) {
                    var $containerWithParents = [].slice.call($container.parents());
                    $containerWithParents.unshift($container.get(0));
                    (0, _iterator.each)($containerWithParents, function(i, parent) {
                        if (parent === (0, _renderer.default)("body").get(0)) {
                            return false
                        } else {
                            if ("hidden" === window.getComputedStyle(parent).overflowY) {
                                this._$customBoundaryContainer = (0, _renderer.default)(parent);
                                return false
                            }
                        }
                    }.bind(this))
                }
            },
            _popupWrapperClass: function() {
                return DROPDOWNLIST_POPUP_WRAPPER_CLASS
            },
            _renderInputValue: function() {
                var value = this._getCurrentValue();
                return this._loadInputValue(value, this._setSelectedItem.bind(this)).always(this.callBase.bind(this, value))
            },
            _loadInputValue: function(value, callback) {
                return this._loadItem(value).always(callback)
            },
            _getItemFromPlain: function(value, cache) {
                var plainItems;
                var selectedItem;
                if (cache && "object" !== _typeof(value)) {
                    if (!cache.itemByValue) {
                        cache.itemByValue = {};
                        plainItems = this._getPlainItems();
                        plainItems.forEach(function(item) {
                            cache.itemByValue[this._valueGetter(item)] = item
                        }, this)
                    }
                    selectedItem = cache.itemByValue[value]
                }
                if (!selectedItem) {
                    plainItems = this._getPlainItems();
                    selectedItem = (0, _common.grep)(plainItems, function(item) {
                        return this._isValueEquals(this._valueGetter(item), value)
                    }.bind(this))[0]
                }
                return selectedItem
            },
            _loadItem: function(value, cache) {
                var selectedItem = this._getItemFromPlain(value, cache);
                return void 0 !== selectedItem ? (new _deferred.Deferred).resolve(selectedItem).promise() : this._loadValue(value)
            },
            _getPlainItems: function(items) {
                var plainItems = [];
                items = items || this.option("items") || this._dataSource.items() || [];
                for (var i = 0; i < items.length; i++) {
                    if (items[i] && items[i].items) {
                        plainItems = plainItems.concat(items[i].items)
                    } else {
                        plainItems.push(items[i])
                    }
                }
                return plainItems
            },
            _updateActiveDescendant: function() {
                var _this$_list;
                var opened = this.option("opened");
                var listFocusedItemId = null === (_this$_list = this._list) || void 0 === _this$_list ? void 0 : _this$_list.getFocusedItemId();
                var isElementOnDom = (0, _renderer.default)("#".concat(listFocusedItemId)).length > 0;
                var activedescendant = opened && isElementOnDom && listFocusedItemId;
                this.setAria({
                    activedescendant: activedescendant || null
                })
            },
            _setSelectedItem: function(item) {
                var displayValue = this._displayValue(item);
                this.option("selectedItem", (0, _common.ensureDefined)(item, null));
                this.option("displayValue", displayValue)
            },
            _displayValue: function(item) {
                return this._displayGetter(item)
            },
            _refreshSelected: function() {
                var cache = {};
                this._listItemElements().each(function(_, itemElement) {
                    var $itemElement = (0, _renderer.default)(itemElement);
                    var itemValue = this._valueGetter($itemElement.data(LIST_ITEM_DATA_KEY));
                    var isItemSelected = this._isSelectedValue(itemValue, cache);
                    if (isItemSelected) {
                        this._list.selectItem($itemElement)
                    } else {
                        this._list.unselectItem($itemElement)
                    }
                }.bind(this))
            },
            _popupShownHandler: function() {
                this.callBase();
                this._setFocusPolicy()
            },
            _setFocusPolicy: function() {
                if (!this.option("focusStateEnabled") || !this._list) {
                    return
                }
                this._list.option("focusedElement", null)
            },
            _isSelectedValue: function(value) {
                return this._isValueEquals(value, this.option("value"))
            },
            _validateSearchMode: function() {
                var searchMode = this.option("searchMode");
                var normalizedSearchMode = searchMode.toLowerCase();
                if ((0, _array.inArray)(normalizedSearchMode, SEARCH_MODES) < 0) {
                    throw _ui2.default.Error("E1019", searchMode)
                }
            },
            _clearSelectedItem: function() {
                this.option("selectedItem", null)
            },
            _processDataSourceChanging: function() {
                this._setListDataSource();
                this._renderInputValue().fail(function() {
                    if (this._isCustomValueAllowed()) {
                        return
                    }
                    this._clearSelectedItem()
                }.bind(this))
            },
            _isCustomValueAllowed: function() {
                return this.option("displayCustomValue")
            },
            reset: function() {
                this.callBase();
                this._clearFilter();
                this._clearSelectedItem();
                this._preventFiltering = true
            },
            _listItemElements: function() {
                return this._$list ? this._$list.find(LIST_ITEM_SELECTOR) : (0, _renderer.default)()
            },
            _popupConfig: function() {
                return (0, _extend.extend)(this.callBase(), {
                    templatesRenderAsynchronously: false,
                    autoResizeEnabled: false,
                    maxHeight: this._getMaxHeight.bind(this)
                })
            },
            _renderPopupContent: function() {
                this.callBase();
                this._renderList()
            },
            _getKeyboardListeners: function() {
                var canListHaveFocus = this._canListHaveFocus();
                return this.callBase().concat([!canListHaveFocus && this._list])
            },
            _setAriaTargetForList: function() {
                this._list._getAriaTarget = this._getAriaTarget.bind(this)
            },
            _renderList: function() {
                this._listId = "dx-" + (new _guid.default)._value;
                var $list = this._$list = (0, _renderer.default)("<div>").attr("id", this._listId).appendTo(this._popup.$content());
                this._list = this._createComponent($list, _list.default, this._listConfig());
                this._refreshList();
                this._setAriaTargetForList();
                this._list.option("_listAttributes", {
                    role: "combobox"
                });
                this._renderPreventBlur(this._$list);
                this._setListFocusedElementOptionChange()
            },
            _renderPreventBlur: function($target) {
                var eventName = (0, _index.addNamespace)("mousedown", "dxDropDownList");
                _events_engine.default.off($target, eventName);
                _events_engine.default.on($target, eventName, function(e) {
                    e.preventDefault()
                }.bind(this))
            },
            _renderOpenedState: function() {
                this.callBase();
                this._list && this._updateActiveDescendant();
                this.setAria({
                    controls: this._list && this._listId,
                    owns: this._popup && this._popupContentId
                })
            },
            _setDefaultAria: function() {
                this.setAria({
                    haspopup: "listbox",
                    autocomplete: "list"
                })
            },
            _refreshList: function() {
                if (this._list && this._shouldRefreshDataSource()) {
                    this._setListDataSource()
                }
            },
            _shouldRefreshDataSource: function() {
                var dataSourceProvided = !!this._list.option("dataSource");
                return dataSourceProvided !== this._needPassDataSourceToList()
            },
            _isDesktopDevice: function() {
                return "desktop" === _devices.default.real().deviceType
            },
            _listConfig: function() {
                var options = {
                    selectionMode: "single",
                    _templates: this.option("_templates"),
                    templateProvider: this.option("templateProvider"),
                    noDataText: this.option("noDataText"),
                    grouped: this.option("grouped"),
                    wrapItemText: this.option("wrapItemText"),
                    onContentReady: this._listContentReadyHandler.bind(this),
                    itemTemplate: this.option("itemTemplate"),
                    indicateLoading: false,
                    keyExpr: this._getCollectionKeyExpr(),
                    displayExpr: this._displayGetterExpr(),
                    groupTemplate: this.option("groupTemplate"),
                    onItemClick: this._listItemClickAction.bind(this),
                    dataSource: this._getDataSource(),
                    _revertPageOnEmptyLoad: true,
                    hoverStateEnabled: this._isDesktopDevice() ? this.option("hoverStateEnabled") : false,
                    focusStateEnabled: this._isDesktopDevice() ? this.option("focusStateEnabled") : false
                };
                if (!this._canListHaveFocus()) {
                    options.tabIndex = null
                }
                return options
            },
            _canListHaveFocus: function() {
                return false
            },
            _getDataSource: function() {
                return this._needPassDataSourceToList() ? this._dataSource : null
            },
            _dataSourceOptions: function() {
                return {
                    paginate: false
                }
            },
            _getGroupedOption: function() {
                return this.option("grouped")
            },
            _dataSourceFromUrlLoadMode: function() {
                return "raw"
            },
            _listContentReadyHandler: function() {
                this._list = this._list || this._$list.dxList("instance");
                if (!this.option("deferRendering")) {
                    this._refreshSelected()
                }
                this._dimensionChanged();
                this._contentReadyAction()
            },
            _setListOption: function(optionName, value) {
                this._setWidgetOption("_list", arguments)
            },
            _listItemClickAction: function(e) {
                this._listItemClickHandler(e);
                this._itemClickAction(e)
            },
            _listItemClickHandler: _common.noop,
            _setListDataSource: function() {
                if (!this._list) {
                    return
                }
                this._setListOption("dataSource", this._getDataSource());
                if (!this._needPassDataSourceToList()) {
                    this._setListOption("items", [])
                }
            },
            _needPassDataSourceToList: function() {
                return this.option("showDataBeforeSearch") || this._isMinSearchLengthExceeded()
            },
            _isMinSearchLengthExceeded: function() {
                return this._searchValue().toString().length >= this.option("minSearchLength")
            },
            _needClearFilter: function() {
                return this._canKeepDataSource() ? false : this._needPassDataSourceToList()
            },
            _canKeepDataSource: function() {
                var _this$_dataSource;
                var isMinSearchLengthExceeded = this._isMinSearchLengthExceeded();
                return (null === (_this$_dataSource = this._dataSource) || void 0 === _this$_dataSource ? void 0 : _this$_dataSource.isLoaded()) && this.option("showDataBeforeSearch") && this.option("minSearchLength") && !isMinSearchLengthExceeded && !this._isLastMinSearchLengthExceeded
            },
            _searchValue: function() {
                return this._input().val() || ""
            },
            _getSearchEvent: function() {
                return (0, _index.addNamespace)(SEARCH_EVENT, this.NAME + "Search")
            },
            _getSetFocusPolicyEvent: function() {
                return (0, _index.addNamespace)("input", this.NAME + "FocusPolicy")
            },
            _renderEvents: function() {
                this.callBase();
                _events_engine.default.on(this._input(), this._getSetFocusPolicyEvent(), this._setFocusPolicy.bind(this));
                if (this._shouldRenderSearchEvent()) {
                    _events_engine.default.on(this._input(), this._getSearchEvent(), this._searchHandler.bind(this))
                }
            },
            _shouldRenderSearchEvent: function() {
                return this.option("searchEnabled")
            },
            _refreshEvents: function() {
                _events_engine.default.off(this._input(), this._getSearchEvent());
                _events_engine.default.off(this._input(), this._getSetFocusPolicyEvent());
                this.callBase()
            },
            _searchHandler: function() {
                if (!this._isMinSearchLengthExceeded()) {
                    this._searchCanceled();
                    return
                }
                var searchTimeout = this.option("searchTimeout");
                if (searchTimeout) {
                    this._clearSearchTimer();
                    this._searchTimer = setTimeout(this._searchDataSource.bind(this), searchTimeout)
                } else {
                    this._searchDataSource()
                }
            },
            _searchCanceled: function() {
                this._clearSearchTimer();
                if (this._needClearFilter()) {
                    this._filterDataSource(null)
                }
                this._refreshList()
            },
            _searchDataSource: function() {
                this._filterDataSource(this._searchValue())
            },
            _filterDataSource: function(searchValue) {
                this._clearSearchTimer();
                var dataSource = this._dataSource;
                if (dataSource) {
                    dataSource.searchExpr(this.option("searchExpr") || this._displayGetterExpr());
                    dataSource.searchOperation(this.option("searchMode"));
                    dataSource.searchValue(searchValue);
                    dataSource.load().done(this._dataSourceFiltered.bind(this, searchValue))
                }
            },
            _clearFilter: function() {
                var dataSource = this._dataSource;
                dataSource && dataSource.searchValue() && dataSource.searchValue(null)
            },
            _dataSourceFiltered: function() {
                this._isLastMinSearchLengthExceeded = this._isMinSearchLengthExceeded();
                this._refreshList();
                this._refreshPopupVisibility()
            },
            _shouldOpenPopup: function() {
                return this._hasItemsToShow()
            },
            _refreshPopupVisibility: function() {
                if (this.option("readOnly") || !this._searchValue()) {
                    return
                }
                var shouldOpenPopup = this._shouldOpenPopup();
                if (shouldOpenPopup && !this._isFocused()) {
                    return
                }
                this.option("opened", shouldOpenPopup);
                if (shouldOpenPopup) {
                    this._dimensionChanged()
                }
            },
            _dataSourceChangedHandler: function(newItems) {
                if (0 === this._dataSource.pageIndex()) {
                    this.option().items = newItems
                } else {
                    this.option().items = this.option().items.concat(newItems)
                }
            },
            _hasItemsToShow: function() {
                var resultItems = this._dataSource && this._dataSource.items() || [];
                var resultAmount = resultItems.length;
                var isMinSearchLengthExceeded = this._needPassDataSourceToList();
                return !!(isMinSearchLengthExceeded && resultAmount)
            },
            _clearSearchTimer: function() {
                clearTimeout(this._searchTimer);
                delete this._searchTimer
            },
            _popupShowingHandler: function() {
                this._dimensionChanged()
            },
            _dimensionChanged: function() {
                this.callBase(arguments);
                this._popup && this._updatePopupDimensions()
            },
            _needPopupRepaint: function() {
                if (!this._dataSource) {
                    return false
                }
                var currentPageIndex = this._dataSource.pageIndex();
                var needRepaint = (0, _type.isDefined)(this._pageIndex) && currentPageIndex <= this._pageIndex;
                this._pageIndex = currentPageIndex;
                return needRepaint
            },
            _updatePopupDimensions: function() {
                if (this._needPopupRepaint()) {
                    this._popup.repaint()
                }
                this._list && this._list.updateDimensions()
            },
            _getMaxHeight: function() {
                var $element = this.$element();
                var $customBoundaryContainer = this._$customBoundaryContainer;
                var offsetTop = $element.offset().top - ($customBoundaryContainer ? $customBoundaryContainer.offset().top : 0);
                var windowHeight = (0, _renderer.default)(window).outerHeight();
                var containerHeight = $customBoundaryContainer ? Math.min($customBoundaryContainer.outerHeight(), windowHeight) : windowHeight;
                var maxHeight = Math.max(offsetTop, containerHeight - offsetTop - $element.outerHeight());
                return Math.min(.5 * containerHeight, maxHeight)
            },
            _clean: function() {
                if (this._list) {
                    delete this._list
                }
                delete this._isLastMinSearchLengthExceeded;
                this.callBase()
            },
            _dispose: function() {
                this._clearSearchTimer();
                this.callBase()
            },
            _setCollectionWidgetOption: function() {
                this._setListOption.apply(this, arguments)
            },
            _setSubmitValue: function() {
                var value = this.option("value");
                var submitValue = this._shouldUseDisplayValue(value) ? this._displayGetter(value) : value;
                this._getSubmitElement().val(submitValue)
            },
            _shouldUseDisplayValue: function(value) {
                return "this" === this.option("valueExpr") && (0, _type.isObject)(value)
            },
            _optionChanged: function(args) {
                this._dataExpressionOptionChanged(args);
                switch (args.name) {
                    case "hoverStateEnabled":
                    case "focusStateEnabled":
                        this._isDesktopDevice() && this._setListOption(args.name, args.value);
                        this.callBase(args);
                        break;
                    case "items":
                        if (!this.option("dataSource")) {
                            this._processDataSourceChanging()
                        }
                        break;
                    case "dataSource":
                        this._processDataSourceChanging();
                        break;
                    case "valueExpr":
                        this._renderValue();
                        this._setListOption("keyExpr", this._getCollectionKeyExpr());
                        break;
                    case "displayExpr":
                        this._renderValue();
                        this._setListOption("displayExpr", this._displayGetterExpr());
                        break;
                    case "searchMode":
                        this._validateSearchMode();
                        break;
                    case "minSearchLength":
                        this._refreshList();
                        break;
                    case "searchEnabled":
                    case "showDataBeforeSearch":
                    case "searchExpr":
                        this._invalidate();
                        break;
                    case "onContentReady":
                        this._initContentReadyAction();
                        break;
                    case "onSelectionChanged":
                        this._initSelectionChangedAction();
                        break;
                    case "onItemClick":
                        this._initItemClickAction();
                        break;
                    case "grouped":
                    case "groupTemplate":
                    case "wrapItemText":
                    case "noDataText":
                        this._setListOption(args.name);
                        break;
                    case "displayValue":
                        this.option("text", args.value);
                        break;
                    case "itemTemplate":
                    case "searchTimeout":
                        break;
                    case "selectedItem":
                        if (args.previousValue !== args.value) {
                            this._selectionChangedAction({
                                selectedItem: args.value
                            })
                        }
                        break;
                    default:
                        this.callBase(args)
                }
            }
        }).include(_ui3.default, _grouped_data_converter_mixin.default);
        (0, _component_registrator.default)("dxDropDownList", DropDownList);
        var _default = DropDownList;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/list/ui.list.base.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.setScrollView = setScrollView;
        exports.ListBase = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _icon = __webpack_require__( /*! ../../core/utils/icon */ 56);
        var _element = __webpack_require__( /*! ../../core/element */ 18);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _data = __webpack_require__( /*! ../../core/utils/data */ 20);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _fx = _interopRequireDefault(__webpack_require__( /*! ../../animation/fx */ 42));
        var _click = __webpack_require__( /*! ../../events/click */ 21);
        var _swipe = __webpack_require__( /*! ../../events/swipe */ 194);
        var _support = __webpack_require__( /*! ../../core/utils/support */ 45);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _utils = __webpack_require__( /*! ../widget/utils.ink_ripple */ 82);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _item = _interopRequireDefault(__webpack_require__( /*! ./item */ 601));
        var _button = _interopRequireDefault(__webpack_require__( /*! ../button */ 37));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _themes = __webpack_require__( /*! ../themes */ 34);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _scroll_view = _interopRequireDefault(__webpack_require__( /*! ../scroll_view */ 90));
        var _uiScrollable = __webpack_require__( /*! ../scroll_view/ui.scrollable.device */ 351);
        var _uiCollection_widget = _interopRequireDefault(__webpack_require__( /*! ../collection/ui.collection_widget.live_update */ 209));
        var _bindable_template = __webpack_require__( /*! ../../core/templates/bindable_template */ 65);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _grouped_data_converter_mixin = _interopRequireDefault(__webpack_require__( /*! ../shared/grouped_data_converter_mixin */ 334));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var LIST_CLASS = "dx-list";
        var LIST_ITEM_CLASS = "dx-list-item";
        var LIST_ITEM_SELECTOR = "." + LIST_ITEM_CLASS;
        var LIST_ITEM_ICON_CONTAINER_CLASS = "dx-list-item-icon-container";
        var LIST_ITEM_ICON_CLASS = "dx-list-item-icon";
        var LIST_GROUP_CLASS = "dx-list-group";
        var LIST_GROUP_HEADER_CLASS = "dx-list-group-header";
        var LIST_GROUP_BODY_CLASS = "dx-list-group-body";
        var LIST_COLLAPSIBLE_GROUPS_CLASS = "dx-list-collapsible-groups";
        var LIST_GROUP_COLLAPSED_CLASS = "dx-list-group-collapsed";
        var LIST_GROUP_HEADER_INDICATOR_CLASS = "dx-list-group-header-indicator";
        var LIST_HAS_NEXT_CLASS = "dx-has-next";
        var LIST_NEXT_BUTTON_CLASS = "dx-list-next-button";
        var WRAP_ITEM_TEXT_CLASS = "dx-wrap-item-text";
        var SELECT_ALL_ITEM_SELECTOR = ".dx-list-select-all";
        var LIST_ITEM_DATA_KEY = "dxListItemData";
        var LIST_FEEDBACK_SHOW_TIMEOUT = 70;
        var groupItemsGetter = (0, _data.compileGetter)("items");
        var _scrollView;
        var ListBase = _uiCollection_widget.default.inherit({
            _activeStateUnit: [LIST_ITEM_SELECTOR, SELECT_ALL_ITEM_SELECTOR].join(","),
            _supportedKeys: function() {
                var that = this;
                var moveFocusPerPage = function(direction) {
                    var $item = getEdgeVisibleItem(direction);
                    var isFocusedItem = $item.is(that.option("focusedElement"));
                    if (isFocusedItem) {
                        scrollListTo($item, direction);
                        $item = getEdgeVisibleItem(direction)
                    }
                    that.option("focusedElement", (0, _element.getPublicElement)($item));
                    that.scrollToItem($item)
                };

                function getEdgeVisibleItem(direction) {
                    var scrollTop = that.scrollTop();
                    var containerHeight = that.$element().height();
                    var $item = (0, _renderer.default)(that.option("focusedElement"));
                    var isItemVisible = true;
                    if (!$item.length) {
                        return (0, _renderer.default)()
                    }
                    while (isItemVisible) {
                        var $nextItem = $item[direction]();
                        if (!$nextItem.length) {
                            break
                        }
                        var nextItemLocation = $nextItem.position().top + $nextItem.outerHeight() / 2;
                        isItemVisible = nextItemLocation < containerHeight + scrollTop && nextItemLocation > scrollTop;
                        if (isItemVisible) {
                            $item = $nextItem
                        }
                    }
                    return $item
                }

                function scrollListTo($item, direction) {
                    var resultPosition = $item.position().top;
                    if ("prev" === direction) {
                        resultPosition = $item.position().top - that.$element().height() + $item.outerHeight()
                    }
                    that.scrollTo(resultPosition)
                }
                return (0, _extend.extend)(this.callBase(), {
                    leftArrow: _common.noop,
                    rightArrow: _common.noop,
                    pageUp: function() {
                        moveFocusPerPage("prev");
                        return false
                    },
                    pageDown: function() {
                        moveFocusPerPage("next");
                        return false
                    }
                })
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    hoverStateEnabled: true,
                    pullRefreshEnabled: false,
                    scrollingEnabled: true,
                    showScrollbar: "onScroll",
                    useNativeScrolling: true,
                    bounceEnabled: true,
                    scrollByContent: true,
                    scrollByThumb: false,
                    pullingDownText: _message.default.format("dxList-pullingDownText"),
                    pulledDownText: _message.default.format("dxList-pulledDownText"),
                    refreshingText: _message.default.format("dxList-refreshingText"),
                    pageLoadingText: _message.default.format("dxList-pageLoadingText"),
                    onScroll: null,
                    onPullRefresh: null,
                    onPageLoading: null,
                    pageLoadMode: "scrollBottom",
                    nextButtonText: _message.default.format("dxList-nextButtonText"),
                    onItemSwipe: null,
                    grouped: false,
                    onGroupRendered: null,
                    collapsibleGroups: false,
                    groupTemplate: "group",
                    indicateLoading: true,
                    activeStateEnabled: true,
                    _itemAttributes: {
                        role: "option"
                    },
                    _listAttributes: {
                        role: "listbox"
                    },
                    useInkRipple: false,
                    wrapItemText: false,
                    _swipeEnabled: true,
                    _revertPageOnEmptyLoad: false,
                    showChevronExpr: function(data) {
                        return data ? data.showChevron : void 0
                    },
                    badgeExpr: function(data) {
                        return data ? data.badge : void 0
                    }
                })
            },
            _defaultOptionsRules: function() {
                var themeName = (0, _themes.current)();
                return this.callBase().concat((0, _uiScrollable.deviceDependentOptions)(), [{
                    device: function() {
                        return !_support.nativeScrolling
                    },
                    options: {
                        useNativeScrolling: false
                    }
                }, {
                    device: function(_device) {
                        return !_support.nativeScrolling && !_devices.default.isSimulator() && "desktop" === _devices.default.real().deviceType && "generic" === _device.platform
                    },
                    options: {
                        showScrollbar: "onHover",
                        pageLoadMode: "nextButton"
                    }
                }, {
                    device: function() {
                        return "desktop" === _devices.default.real().deviceType && !_devices.default.isSimulator()
                    },
                    options: {
                        focusStateEnabled: true
                    }
                }, {
                    device: function() {
                        return (0, _themes.isMaterial)(themeName)
                    },
                    options: {
                        pullingDownText: "",
                        pulledDownText: "",
                        refreshingText: "",
                        pageLoadingText: "",
                        useInkRipple: true
                    }
                }])
            },
            _visibilityChanged: function(visible) {
                if (visible) {
                    this._updateLoadingState(true)
                }
            },
            _itemClass: function() {
                return LIST_ITEM_CLASS
            },
            _itemDataKey: function() {
                return LIST_ITEM_DATA_KEY
            },
            _itemContainer: function() {
                return this._$container
            },
            _saveSelectionChangeEvent: function(e) {
                this._selectionChangeEventInstance = e
            },
            _getSelectionChangeEvent: function() {
                return this._selectionChangeEventInstance
            },
            _refreshItemElements: function() {
                if (!this.option("grouped")) {
                    this._itemElementsCache = this._itemContainer().children(this._itemSelector())
                } else {
                    this._itemElementsCache = this._itemContainer().children("." + LIST_GROUP_CLASS).children("." + LIST_GROUP_BODY_CLASS).children(this._itemSelector())
                }
            },
            _modifyByChanges: function() {
                this.callBase.apply(this, arguments);
                this._refreshItemElements();
                this._updateLoadingState(true)
            },
            reorderItem: function(itemElement, toItemElement) {
                var promise = this.callBase(itemElement, toItemElement);
                return promise.done(function() {
                    this._refreshItemElements()
                })
            },
            deleteItem: function(itemElement) {
                var promise = this.callBase(itemElement);
                return promise.done(function() {
                    this._refreshItemElements()
                })
            },
            _itemElements: function() {
                return this._itemElementsCache
            },
            _itemSelectHandler: function(e) {
                if ("single" === this.option("selectionMode") && this.isItemSelected(e.currentTarget)) {
                    return
                }
                this.callBase(e)
            },
            _allowDynamicItemsAppend: function() {
                return true
            },
            _resetDataSourcePageIndex: function() {
                var currentDataSource = this.getDataSource();
                if (currentDataSource && 0 !== currentDataSource.pageIndex()) {
                    currentDataSource.pageIndex(0);
                    currentDataSource.load()
                }
            },
            _init: function() {
                this.callBase();
                this._resetDataSourcePageIndex();
                this._$container = this.$element();
                this._initScrollView();
                this._feedbackShowTimeout = LIST_FEEDBACK_SHOW_TIMEOUT;
                this._createGroupRenderAction()
            },
            _scrollBottomMode: function() {
                return "scrollBottom" === this.option("pageLoadMode")
            },
            _nextButtonMode: function() {
                return "nextButton" === this.option("pageLoadMode")
            },
            _dataSourceOptions: function() {
                var scrollBottom = this._scrollBottomMode();
                var nextButton = this._nextButtonMode();
                return (0, _extend.extend)(this.callBase(), {
                    paginate: (0, _common.ensureDefined)(scrollBottom || nextButton, true)
                })
            },
            _getGroupedOption: function() {
                return this.option("grouped")
            },
            _dataSourceFromUrlLoadMode: function() {
                return "raw"
            },
            _initScrollView: function() {
                var scrollingEnabled = this.option("scrollingEnabled");
                var pullRefreshEnabled = scrollingEnabled && this.option("pullRefreshEnabled");
                var autoPagingEnabled = scrollingEnabled && this._scrollBottomMode() && !!this._dataSource;
                this._scrollView = this._createComponent(this.$element(), getScrollView(), {
                    disabled: this.option("disabled") || !scrollingEnabled,
                    onScroll: this._scrollHandler.bind(this),
                    onPullDown: pullRefreshEnabled ? this._pullDownHandler.bind(this) : null,
                    onReachBottom: autoPagingEnabled ? this._scrollBottomHandler.bind(this) : null,
                    showScrollbar: this.option("showScrollbar"),
                    useNative: this.option("useNativeScrolling"),
                    bounceEnabled: this.option("bounceEnabled"),
                    scrollByContent: this.option("scrollByContent"),
                    scrollByThumb: this.option("scrollByThumb"),
                    pullingDownText: this.option("pullingDownText"),
                    pulledDownText: this.option("pulledDownText"),
                    refreshingText: this.option("refreshingText"),
                    reachBottomText: this.option("pageLoadingText"),
                    useKeyboard: false
                });
                this._$container = (0, _renderer.default)(this._scrollView.content());
                if (this.option("wrapItemText")) {
                    this._$container.addClass(WRAP_ITEM_TEXT_CLASS)
                }
                this._createScrollViewActions()
            },
            _createScrollViewActions: function() {
                this._scrollAction = this._createActionByOption("onScroll");
                this._pullRefreshAction = this._createActionByOption("onPullRefresh");
                this._pageLoadingAction = this._createActionByOption("onPageLoading")
            },
            _scrollHandler: function(e) {
                this._scrollAction && this._scrollAction(e)
            },
            _initTemplates: function() {
                this._templateManager.addDefaultTemplates({
                    group: new _bindable_template.BindableTemplate(function($container, data) {
                        if ((0, _type.isPlainObject)(data)) {
                            if (data.key) {
                                $container.text(data.key)
                            }
                        } else {
                            $container.text(String(data))
                        }
                    }, ["key"], this.option("integrationOptions.watchMethod"))
                });
                this.callBase()
            },
            _prepareDefaultItemTemplate: function(data, $container) {
                this.callBase(data, $container);
                if (data.icon) {
                    var $icon = (0, _icon.getImageContainer)(data.icon).addClass(LIST_ITEM_ICON_CLASS);
                    var $iconContainer = (0, _renderer.default)("<div>").addClass(LIST_ITEM_ICON_CONTAINER_CLASS);
                    $iconContainer.append($icon);
                    $container.prepend($iconContainer)
                }
            },
            _getBindableFields: function() {
                return ["text", "html", "icon"]
            },
            _updateLoadingState: function(tryLoadMore) {
                var isDataLoaded = !tryLoadMore || this._isLastPage();
                var scrollBottomMode = this._scrollBottomMode();
                var stopLoading = isDataLoaded || !scrollBottomMode;
                var hideLoadIndicator = stopLoading && !this._isDataSourceLoading();
                if (stopLoading || this._scrollViewIsFull()) {
                    this._scrollView.release(hideLoadIndicator);
                    this._toggleNextButton(this._shouldRenderNextButton() && !this._isLastPage());
                    this._loadIndicationSuppressed(false)
                } else {
                    this._infiniteDataLoading()
                }
            },
            _shouldRenderNextButton: function() {
                return this._nextButtonMode() && this._dataSource && this._dataSource.isLoaded()
            },
            _isDataSourceFirstLoadCompleted: function(newValue) {
                if ((0, _type.isDefined)(newValue)) {
                    this._isFirstLoadCompleted = newValue
                }
                return this._isFirstLoadCompleted
            },
            _dataSourceLoadingChangedHandler: function(isLoading) {
                if (this._loadIndicationSuppressed()) {
                    return
                }
                if (isLoading && this.option("indicateLoading")) {
                    this._showLoadingIndicatorTimer = setTimeout(function() {
                        var isEmpty = !this._itemElements().length;
                        var shouldIndicateLoading = !isEmpty || this._isDataSourceFirstLoadCompleted();
                        if (shouldIndicateLoading) {
                            var _this$_scrollView;
                            null === (_this$_scrollView = this._scrollView) || void 0 === _this$_scrollView ? void 0 : _this$_scrollView.startLoading()
                        }
                    }.bind(this))
                } else {
                    clearTimeout(this._showLoadingIndicatorTimer);
                    this._scrollView && this._scrollView.finishLoading()
                }
                if (!isLoading) {
                    this._isDataSourceFirstLoadCompleted(false)
                }
            },
            _dataSourceChangedHandler: function() {
                if (!this._shouldAppendItems() && (0, _window.hasWindow)()) {
                    this._scrollView && this._scrollView.scrollTo(0)
                }
                this.callBase.apply(this, arguments);
                this._isDataSourceFirstLoadCompleted(true)
            },
            _refreshContent: function() {
                this._prepareContent();
                this._fireContentReadyAction()
            },
            _hideLoadingIfLoadIndicationOff: function() {
                if (!this.option("indicateLoading")) {
                    this._dataSourceLoadingChangedHandler(false)
                }
            },
            _loadIndicationSuppressed: function(value) {
                if (!arguments.length) {
                    return this._isLoadIndicationSuppressed
                }
                this._isLoadIndicationSuppressed = value
            },
            _scrollViewIsFull: function() {
                return !this._scrollView || this._scrollView.isFull()
            },
            _pullDownHandler: function(e) {
                this._pullRefreshAction(e);
                if (this._dataSource && !this._isDataSourceLoading()) {
                    this._clearSelectedItems();
                    this._dataSource.pageIndex(0);
                    this._dataSource.reload()
                } else {
                    this._updateLoadingState()
                }
            },
            _infiniteDataLoading: function() {
                var _this = this;
                var isElementVisible = this.$element().is(":visible");
                if (isElementVisible && !this._scrollViewIsFull() && !this._isDataSourceLoading() && !this._isLastPage()) {
                    clearTimeout(this._loadNextPageTimer);
                    this._loadNextPageTimer = setTimeout(function() {
                        _this._loadNextPage().done(_this._setPreviousPageIfNewIsEmpty.bind(_this))
                    })
                }
            },
            _setPreviousPageIfNewIsEmpty: function(result) {
                if (this.option("_revertPageOnEmptyLoad")) {
                    var dataSource = this.getDataSource();
                    var pageIndex = null === dataSource || void 0 === dataSource ? void 0 : dataSource.pageIndex();
                    if (0 === (null === result || void 0 === result ? void 0 : result.length) && pageIndex > 0) {
                        this._fireContentReadyAction();
                        dataSource.pageIndex(pageIndex - 1)
                    }
                }
            },
            _scrollBottomHandler: function(e) {
                this._pageLoadingAction(e);
                if (!this._isDataSourceLoading() && !this._isLastPage()) {
                    this._loadNextPage()
                } else {
                    this._updateLoadingState()
                }
            },
            _renderItems: function(items) {
                if (this.option("grouped")) {
                    (0, _iterator.each)(items, this._renderGroup.bind(this));
                    this._attachGroupCollapseEvent();
                    this._renderEmptyMessage();
                    if ((0, _themes.isMaterial)()) {
                        this.attachGroupHeaderInkRippleEvents()
                    }
                } else {
                    this.callBase.apply(this, arguments)
                }
                this._refreshItemElements();
                this._updateLoadingState(true)
            },
            _attachGroupCollapseEvent: function() {
                var eventName = (0, _index.addNamespace)(_click.name, this.NAME);
                var selector = "." + LIST_GROUP_HEADER_CLASS;
                var $element = this.$element();
                var collapsibleGroups = this.option("collapsibleGroups");
                $element.toggleClass(LIST_COLLAPSIBLE_GROUPS_CLASS, collapsibleGroups);
                _events_engine.default.off($element, eventName, selector);
                if (collapsibleGroups) {
                    _events_engine.default.on($element, eventName, selector, function(e) {
                        this._createAction(function(e) {
                            var $group = (0, _renderer.default)(e.event.currentTarget).parent();
                            this._collapseGroupHandler($group);
                            if (this.option("focusStateEnabled")) {
                                this.option("focusedElement", (0, _element.getPublicElement)($group.find("." + LIST_ITEM_CLASS).eq(0)))
                            }
                        }.bind(this), {
                            validatingTargetName: "element"
                        })({
                            event: e
                        })
                    }.bind(this))
                }
            },
            _collapseGroupHandler: function($group, toggle) {
                var deferred = new _deferred.Deferred;
                if ($group.hasClass(LIST_GROUP_COLLAPSED_CLASS) === toggle) {
                    return deferred.resolve()
                }
                var $groupBody = $group.children("." + LIST_GROUP_BODY_CLASS);
                var startHeight = $groupBody.outerHeight();
                var endHeight = 0 === startHeight ? $groupBody.height("auto").outerHeight() : 0;
                $group.toggleClass(LIST_GROUP_COLLAPSED_CLASS, toggle);
                _fx.default.animate($groupBody, {
                    type: "custom",
                    from: {
                        height: startHeight
                    },
                    to: {
                        height: endHeight
                    },
                    duration: 200,
                    complete: function() {
                        this.updateDimensions();
                        this._updateLoadingState();
                        deferred.resolve()
                    }.bind(this)
                });
                return deferred.promise()
            },
            _dataSourceLoadErrorHandler: function() {
                this._forgetNextPageLoading();
                if (this._initialized) {
                    this._renderEmptyMessage();
                    this._updateLoadingState()
                }
            },
            _initMarkup: function() {
                this._itemElementsCache = (0, _renderer.default)();
                this.$element().addClass(LIST_CLASS);
                this.callBase();
                this.option("useInkRipple") && this._renderInkRipple();
                this.setAria("role", this.option("_listAttributes").role)
            },
            _renderInkRipple: function() {
                this._inkRipple = (0, _utils.render)()
            },
            _toggleActiveState: function($element, value, e) {
                this.callBase.apply(this, arguments);
                var that = this;
                if (!this._inkRipple) {
                    return
                }
                var config = {
                    element: $element,
                    event: e
                };
                if (value) {
                    if ((0, _themes.isMaterial)()) {
                        this._inkRippleTimer = setTimeout(function() {
                            that._inkRipple.showWave(config)
                        }, LIST_FEEDBACK_SHOW_TIMEOUT / 2)
                    } else {
                        that._inkRipple.showWave(config)
                    }
                } else {
                    clearTimeout(this._inkRippleTimer);
                    this._inkRipple.hideWave(config)
                }
            },
            _postprocessRenderItem: function(args) {
                this._refreshItemElements();
                this.callBase.apply(this, arguments);
                if (this.option("_swipeEnabled")) {
                    this._attachSwipeEvent((0, _renderer.default)(args.itemElement))
                }
            },
            _attachSwipeEvent: function($itemElement) {
                var endEventName = (0, _index.addNamespace)(_swipe.end, this.NAME);
                _events_engine.default.on($itemElement, endEventName, this._itemSwipeEndHandler.bind(this))
            },
            _itemSwipeEndHandler: function(e) {
                this._itemDXEventHandler(e, "onItemSwipe", {
                    direction: e.offset < 0 ? "left" : "right"
                })
            },
            _nextButtonHandler: function(e) {
                this._pageLoadingAction(e);
                var source = this._dataSource;
                if (source && !source.isLoading()) {
                    this._scrollView.toggleLoading(true);
                    this._$nextButton.detach();
                    this._loadIndicationSuppressed(true);
                    this._loadNextPage()
                }
            },
            _renderGroup: function(index, group) {
                var $groupElement = (0, _renderer.default)("<div>").addClass(LIST_GROUP_CLASS).appendTo(this._itemContainer());
                var $groupHeaderElement = (0, _renderer.default)("<div>").addClass(LIST_GROUP_HEADER_CLASS).appendTo($groupElement);
                var groupTemplateName = this.option("groupTemplate");
                var groupTemplate = this._getTemplate(group.template || groupTemplateName, group, index, $groupHeaderElement);
                var renderArgs = {
                    index: index,
                    itemData: group,
                    container: (0, _element.getPublicElement)($groupHeaderElement)
                };
                this._createItemByTemplate(groupTemplate, renderArgs);
                if ((0, _themes.isMaterial)()) {
                    (0, _renderer.default)("<div>").addClass(LIST_GROUP_HEADER_INDICATOR_CLASS).prependTo($groupHeaderElement)
                }
                this._renderingGroupIndex = index;
                var $groupBody = (0, _renderer.default)("<div>").addClass(LIST_GROUP_BODY_CLASS).appendTo($groupElement);
                (0, _iterator.each)(groupItemsGetter(group) || [], function(index, item) {
                    this._renderItem(index, item, $groupBody)
                }.bind(this));
                this._groupRenderAction({
                    groupElement: (0, _element.getPublicElement)($groupElement),
                    groupIndex: index,
                    groupData: group
                })
            },
            downInkRippleHandler: function(e) {
                this._toggleActiveState((0, _renderer.default)(e.currentTarget), true, e)
            },
            upInkRippleHandler: function(e) {
                this._toggleActiveState((0, _renderer.default)(e.currentTarget), false)
            },
            attachGroupHeaderInkRippleEvents: function() {
                var selector = "." + LIST_GROUP_HEADER_CLASS;
                var $element = this.$element();
                this._downInkRippleHandler = this._downInkRippleHandler || this.downInkRippleHandler.bind(this);
                this._upInkRippleHandler = this._upInkRippleHandler || this.upInkRippleHandler.bind(this);
                var downArguments = [$element, "dxpointerdown", selector, this._downInkRippleHandler];
                var upArguments = [$element, "dxpointerup dxpointerout", selector, this._upInkRippleHandler];
                _events_engine.default.off.apply(_events_engine.default, downArguments);
                _events_engine.default.on.apply(_events_engine.default, downArguments);
                _events_engine.default.off.apply(_events_engine.default, upArguments);
                _events_engine.default.on.apply(_events_engine.default, upArguments)
            },
            _createGroupRenderAction: function() {
                this._groupRenderAction = this._createActionByOption("onGroupRendered")
            },
            _clean: function() {
                clearTimeout(this._inkRippleTimer);
                if (this._$nextButton) {
                    this._$nextButton.remove();
                    this._$nextButton = null
                }
                delete this._inkRipple;
                this.callBase.apply(this, arguments)
            },
            _dispose: function() {
                this._isDataSourceFirstLoadCompleted(false);
                clearTimeout(this._holdTimer);
                clearTimeout(this._loadNextPageTimer);
                clearTimeout(this._showLoadingIndicatorTimer);
                this.callBase()
            },
            _toggleDisabledState: function(value) {
                this.callBase(value);
                this._scrollView.option("disabled", value || !this.option("scrollingEnabled"))
            },
            _toggleNextButton: function(value) {
                var dataSource = this._dataSource;
                var $nextButton = this._getNextButton();
                this.$element().toggleClass(LIST_HAS_NEXT_CLASS, value);
                if (value && dataSource && dataSource.isLoaded()) {
                    $nextButton.appendTo(this._itemContainer())
                }
                if (!value) {
                    $nextButton.detach()
                }
            },
            _getNextButton: function() {
                if (!this._$nextButton) {
                    this._$nextButton = this._createNextButton()
                }
                return this._$nextButton
            },
            _createNextButton: function() {
                var $result = (0, _renderer.default)("<div>").addClass(LIST_NEXT_BUTTON_CLASS);
                var $button = (0, _renderer.default)("<div>").appendTo($result);
                this._createComponent($button, _button.default, {
                    text: this.option("nextButtonText"),
                    onClick: this._nextButtonHandler.bind(this),
                    type: (0, _themes.isMaterial)() ? "default" : void 0,
                    integrationOptions: {}
                });
                return $result
            },
            _moveFocus: function() {
                this.callBase.apply(this, arguments);
                this.scrollToItem(this.option("focusedElement"))
            },
            _refresh: function() {
                if (!(0, _window.hasWindow)()) {
                    this.callBase()
                } else {
                    var scrollTop = this._scrollView.scrollTop();
                    this.callBase();
                    scrollTop && this._scrollView.scrollTo(scrollTop)
                }
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "pageLoadMode":
                        this._toggleNextButton(args.value);
                        this._initScrollView();
                        break;
                    case "dataSource":
                        this.callBase(args);
                        this._initScrollView();
                        this._isDataSourceFirstLoadCompleted(false);
                        break;
                    case "items":
                        this.callBase(args);
                        this._isDataSourceFirstLoadCompleted(false);
                        break;
                    case "pullingDownText":
                    case "pulledDownText":
                    case "refreshingText":
                    case "pageLoadingText":
                    case "showScrollbar":
                    case "bounceEnabled":
                    case "scrollByContent":
                    case "scrollByThumb":
                    case "useNativeScrolling":
                    case "scrollingEnabled":
                    case "pullRefreshEnabled":
                        this._initScrollView();
                        this._updateLoadingState();
                        break;
                    case "nextButtonText":
                    case "onItemSwipe":
                    case "useInkRipple":
                        this._invalidate();
                        break;
                    case "onScroll":
                    case "onPullRefresh":
                    case "onPageLoading":
                        this._createScrollViewActions();
                        break;
                    case "grouped":
                    case "collapsibleGroups":
                    case "groupTemplate":
                        this._invalidate();
                        break;
                    case "wrapItemText":
                        this._$container.toggleClass(WRAP_ITEM_TEXT_CLASS, args.value);
                        break;
                    case "onGroupRendered":
                        this._createGroupRenderAction();
                        break;
                    case "width":
                    case "height":
                        this.callBase(args);
                        this._scrollView.update();
                        break;
                    case "indicateLoading":
                        this._hideLoadingIfLoadIndicationOff();
                        break;
                    case "visible":
                        this.callBase(args);
                        this._scrollView.update();
                        break;
                    case "rtlEnabled":
                        this._initScrollView();
                        this.callBase(args);
                        break;
                    case "showChevronExpr":
                    case "badgeExpr":
                        this._invalidate();
                        break;
                    case "_swipeEnabled":
                    case "_revertPageOnEmptyLoad":
                        break;
                    case "_listAttributes":
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _extendActionArgs: function($itemElement) {
                if (!this.option("grouped")) {
                    return this.callBase($itemElement)
                }
                var $group = $itemElement.closest("." + LIST_GROUP_CLASS);
                var $item = $group.find("." + LIST_ITEM_CLASS);
                return (0, _extend.extend)(this.callBase($itemElement), {
                    itemIndex: {
                        group: $group.index(),
                        item: $item.index($itemElement)
                    }
                })
            },
            expandGroup: function(groupIndex) {
                var deferred = new _deferred.Deferred;
                var $group = this._itemContainer().find("." + LIST_GROUP_CLASS).eq(groupIndex);
                this._collapseGroupHandler($group, false).done(function() {
                    deferred.resolveWith(this)
                }.bind(this));
                return deferred.promise()
            },
            collapseGroup: function(groupIndex) {
                var deferred = new _deferred.Deferred;
                var $group = this._itemContainer().find("." + LIST_GROUP_CLASS).eq(groupIndex);
                this._collapseGroupHandler($group, true).done(function() {
                    deferred.resolveWith(this)
                }.bind(this));
                return deferred
            },
            updateDimensions: function() {
                var that = this;
                var deferred = new _deferred.Deferred;
                if (that._scrollView) {
                    that._scrollView.update().done(function() {
                        !that._scrollViewIsFull() && that._updateLoadingState(true);
                        deferred.resolveWith(that)
                    })
                } else {
                    deferred.resolveWith(that)
                }
                return deferred.promise()
            },
            reload: function() {
                this.callBase();
                this.scrollTo(0);
                this._pullDownHandler()
            },
            repaint: function() {
                this.scrollTo(0);
                this.callBase()
            },
            scrollTop: function() {
                return this._scrollView.scrollOffset().top
            },
            clientHeight: function() {
                return this._scrollView.clientHeight()
            },
            scrollHeight: function() {
                return this._scrollView.scrollHeight()
            },
            scrollBy: function(distance) {
                this._scrollView.scrollBy(distance)
            },
            scrollTo: function(location) {
                this._scrollView.scrollTo(location)
            },
            scrollToItem: function(itemElement) {
                var $item = this._editStrategy.getItemElement(itemElement);
                this._scrollView.scrollToElement($item)
            }
        }).include(_grouped_data_converter_mixin.default);
        exports.ListBase = ListBase;
        ListBase.ItemClass = _item.default;

        function getScrollView() {
            return _scrollView || _scroll_view.default
        }

        function setScrollView(value) {
            _scrollView = value
        }
    },
    /*!*************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scroll_view/ui.scrollable.native.js ***!
      \*************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./ui.scrollbar */ 348));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var SCROLLABLE_NATIVE = "dxNativeScrollable";
        var SCROLLABLE_NATIVE_CLASS = "dx-scrollable-native";
        var SCROLLABLE_SCROLLBAR_SIMULATED = "dx-scrollable-scrollbar-simulated";
        var SCROLLABLE_SCROLLBARS_HIDDEN = "dx-scrollable-scrollbars-hidden";
        var VERTICAL = "vertical";
        var HORIZONTAL = "horizontal";
        var HIDE_SCROLLBAR_TIMEOUT = 500;
        var NativeStrategy = _class.default.inherit({
            ctor: function(scrollable) {
                this._init(scrollable)
            },
            _init: function(scrollable) {
                this._component = scrollable;
                this._$element = scrollable.$element();
                this._$container = scrollable._$container;
                this._$content = scrollable._$content;
                this._direction = scrollable.option("direction");
                this._useSimulatedScrollbar = scrollable.option("useSimulatedScrollbar");
                this._showScrollbar = scrollable.option("showScrollbar");
                this.option = scrollable.option.bind(scrollable);
                this._createActionByOption = scrollable._createActionByOption.bind(scrollable);
                this._isLocked = scrollable._isLocked.bind(scrollable);
                this._isDirection = scrollable._isDirection.bind(scrollable);
                this._allowedDirection = scrollable._allowedDirection.bind(scrollable);
                this._getScrollOffset = scrollable._getScrollOffset.bind(scrollable);
                this._getMaxOffset = scrollable._getMaxOffset.bind(scrollable)
            },
            render: function() {
                this._renderPushBackOffset();
                var device = _devices.default.real();
                var deviceType = device.platform;
                this._$element.addClass(SCROLLABLE_NATIVE_CLASS).addClass(SCROLLABLE_NATIVE_CLASS + "-" + deviceType).toggleClass(SCROLLABLE_SCROLLBARS_HIDDEN, !this._showScrollbar);
                if (this._showScrollbar && this._useSimulatedScrollbar) {
                    this._renderScrollbars()
                }
            },
            updateBounds: _common.noop,
            _renderPushBackOffset: function() {
                var pushBackValue = this.option("pushBackValue");
                if (!pushBackValue && !this._component._lastPushBackValue) {
                    return
                }
                this._$content.css({
                    paddingTop: pushBackValue,
                    paddingBottom: pushBackValue
                });
                this._component._lastPushBackValue = pushBackValue
            },
            _renderScrollbars: function() {
                this._scrollbars = {};
                this._hideScrollbarTimeout = 0;
                this._$element.addClass(SCROLLABLE_SCROLLBAR_SIMULATED);
                this._renderScrollbar(VERTICAL);
                this._renderScrollbar(HORIZONTAL)
            },
            _renderScrollbar: function(direction) {
                if (!this._isDirection(direction)) {
                    return
                }
                this._scrollbars[direction] = new _ui.default((0, _renderer.default)("<div>").appendTo(this._$element), {
                    direction: direction,
                    expandable: this._component.option("scrollByThumb")
                })
            },
            handleInit: _common.noop,
            handleStart: function() {
                this._disablePushBack = true
            },
            handleMove: function(e) {
                if (this._isLocked()) {
                    e.cancel = true;
                    return
                }
                if (this._allowedDirection()) {
                    e.originalEvent.isScrollingEvent = true
                }
            },
            handleEnd: function() {
                this._disablePushBack = false
            },
            handleCancel: _common.noop,
            handleStop: _common.noop,
            _eachScrollbar: function(callback) {
                callback = callback.bind(this);
                (0, _iterator.each)(this._scrollbars || {}, function(direction, scrollbar) {
                    callback(scrollbar, direction)
                })
            },
            createActions: function() {
                this._scrollAction = this._createActionByOption("onScroll");
                this._updateAction = this._createActionByOption("onUpdated")
            },
            _createActionArgs: function() {
                var _this$location = this.location(),
                    left = _this$location.left,
                    top = _this$location.top;
                return {
                    event: this._eventForUserAction,
                    scrollOffset: this._getScrollOffset(),
                    reachedLeft: this._isReachedLeft(left),
                    reachedRight: this._isReachedRight(left),
                    reachedTop: this._isDirection(VERTICAL) ? top >= 0 : void 0,
                    reachedBottom: this._isDirection(VERTICAL) ? Math.abs(top) >= this._getMaxOffset().top - 2 * this.option("pushBackValue") : void 0
                }
            },
            _isReachedLeft: function() {
                return this._isDirection(HORIZONTAL) ? this.location().left >= 0 : void 0
            },
            _isReachedRight: function() {
                return this._isDirection(HORIZONTAL) ? Math.abs(this.location().left) >= this._getMaxOffset().left : void 0
            },
            handleScroll: function(e) {
                this._component._updateRtlConfig();
                if (!this._isScrollLocationChanged()) {
                    e.stopImmediatePropagation();
                    return
                }
                this._eventForUserAction = e;
                this._moveScrollbars();
                this._scrollAction(this._createActionArgs());
                this._lastLocation = this.location();
                this._pushBackFromBoundary()
            },
            _pushBackFromBoundary: function() {
                var pushBackValue = this.option("pushBackValue");
                if (!pushBackValue || this._disablePushBack) {
                    return
                }
                var scrollOffset = this._containerSize.height - this._contentSize.height;
                var scrollTopPos = this._$container.scrollTop();
                var scrollBottomPos = scrollOffset + scrollTopPos - 2 * pushBackValue;
                if (!scrollTopPos) {
                    this._$container.scrollTop(pushBackValue)
                } else {
                    if (!scrollBottomPos) {
                        this._$container.scrollTop(pushBackValue - scrollOffset)
                    }
                }
            },
            _isScrollLocationChanged: function() {
                var currentLocation = this.location();
                var lastLocation = this._lastLocation || {};
                var isTopChanged = lastLocation.top !== currentLocation.top;
                var isLeftChanged = lastLocation.left !== currentLocation.left;
                return isTopChanged || isLeftChanged
            },
            _moveScrollbars: function() {
                this._eachScrollbar(function(scrollbar) {
                    scrollbar.moveTo(this.location());
                    scrollbar.option("visible", true)
                });
                this._hideScrollbars()
            },
            _hideScrollbars: function() {
                clearTimeout(this._hideScrollbarTimeout);
                this._hideScrollbarTimeout = setTimeout(function() {
                    this._eachScrollbar(function(scrollbar) {
                        scrollbar.option("visible", false)
                    })
                }.bind(this), HIDE_SCROLLBAR_TIMEOUT)
            },
            location: function() {
                return {
                    left: -this._$container.scrollLeft(),
                    top: this.option("pushBackValue") - this._$container.scrollTop()
                }
            },
            disabledChanged: _common.noop,
            update: function() {
                this._update();
                this._updateAction(this._createActionArgs())
            },
            _update: function() {
                this._updateDimensions();
                this._updateScrollbars()
            },
            _updateDimensions: function() {
                this._containerSize = {
                    height: this._$container.height(),
                    width: this._$container.width()
                };
                this._componentContentSize = {
                    height: this._component.$content().height(),
                    width: this._component.$content().width()
                };
                this._contentSize = {
                    height: this._$content.height(),
                    width: this._$content.width()
                };
                this._pushBackFromBoundary()
            },
            _updateScrollbars: function() {
                this._eachScrollbar(function(scrollbar, direction) {
                    var dimension = direction === VERTICAL ? "height" : "width";
                    scrollbar.option({
                        containerSize: this._containerSize[dimension],
                        contentSize: this._componentContentSize[dimension]
                    });
                    scrollbar.update()
                })
            },
            _allowedDirections: function() {
                return {
                    vertical: this._isDirection(VERTICAL) && this._contentSize.height > this._containerSize.height,
                    horizontal: this._isDirection(HORIZONTAL) && this._contentSize.width > this._containerSize.width
                }
            },
            dispose: function() {
                var className = this._$element.get(0).className;
                var scrollableNativeRegexp = new RegExp(SCROLLABLE_NATIVE_CLASS + "\\S*", "g");
                if (scrollableNativeRegexp.test(className)) {
                    this._$element.removeClass(className.match(scrollableNativeRegexp).join(" "))
                }
                _events_engine.default.off(this._$element, "." + SCROLLABLE_NATIVE);
                _events_engine.default.off(this._$container, "." + SCROLLABLE_NATIVE);
                this._removeScrollbars();
                clearTimeout(this._hideScrollbarTimeout)
            },
            _removeScrollbars: function() {
                this._eachScrollbar(function(scrollbar) {
                    scrollbar.$element().remove()
                })
            },
            scrollBy: function(distance) {
                var location = this.location();
                this._$container.scrollTop(Math.round(-location.top - distance.top + this.option("pushBackValue")));
                this._$container.scrollLeft(Math.round(-location.left - distance.left))
            },
            validate: function(e) {
                if (this.option("disabled")) {
                    return false
                }
                if ((0, _index.isDxMouseWheelEvent)(e) && this._isScrolledInMaxDirection(e)) {
                    return false
                }
                return !!this._allowedDirection()
            },
            _isScrolledInMaxDirection: function(e) {
                var container = this._$container.get(0);
                var result;
                if (e.delta > 0) {
                    result = e.shiftKey ? !container.scrollLeft : !container.scrollTop
                } else {
                    if (e.shiftKey) {
                        result = container.scrollLeft >= this._getMaxOffset().left
                    } else {
                        result = container.scrollTop >= this._getMaxOffset().top
                    }
                }
                return result
            },
            getDirection: function() {
                return this._allowedDirection()
            },
            verticalOffset: function() {
                return this.option("pushBackValue")
            }
        });
        var _default = NativeStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scroll_view/ui.events.emitter.gesture.scroll.js ***!
      \*************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _emitter = _interopRequireDefault(__webpack_require__( /*! ../../events/gesture/emitter.gesture */ 176));
        var _emitter_registrator = _interopRequireDefault(__webpack_require__( /*! ../../events/core/emitter_registrator */ 103));
        var _frame = __webpack_require__( /*! ../../animation/frame */ 129);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _version = __webpack_require__( /*! ../../core/utils/version */ 72);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var abstract = _class.default.abstract;
        var realDevice = _devices.default.real();
        var SCROLL_INIT_EVENT = "dxscrollinit";
        var SCROLL_START_EVENT = "dxscrollstart";
        var SCROLL_MOVE_EVENT = "dxscroll";
        var SCROLL_END_EVENT = "dxscrollend";
        var SCROLL_STOP_EVENT = "dxscrollstop";
        var SCROLL_CANCEL_EVENT = "dxscrollcancel";
        var Locker = _class.default.inherit(function() {
            var NAMESPACED_SCROLL_EVENT = (0, _index.addNamespace)("scroll", "dxScrollEmitter");
            return {
                ctor: function(element) {
                    this._element = element;
                    this._locked = false;
                    var that = this;
                    this._proxiedScroll = function(e) {
                        that._scroll(e)
                    };
                    _events_engine.default.on(this._element, NAMESPACED_SCROLL_EVENT, this._proxiedScroll)
                },
                _scroll: abstract,
                check: function(e, callback) {
                    if (this._locked) {
                        callback()
                    }
                },
                dispose: function() {
                    _events_engine.default.off(this._element, NAMESPACED_SCROLL_EVENT, this._proxiedScroll)
                }
            }
        }());
        var TimeoutLocker = Locker.inherit(function() {
            return {
                ctor: function(element, timeout) {
                    this.callBase(element);
                    this._timeout = timeout
                },
                _scroll: function() {
                    this._prepare();
                    this._forget()
                },
                _prepare: function() {
                    if (this._timer) {
                        this._clearTimer()
                    }
                    this._locked = true
                },
                _clearTimer: function() {
                    clearTimeout(this._timer);
                    this._locked = false;
                    this._timer = null
                },
                _forget: function() {
                    var that = this;
                    this._timer = setTimeout(function() {
                        that._clearTimer()
                    }, this._timeout)
                },
                dispose: function() {
                    this.callBase();
                    this._clearTimer()
                }
            }
        }());
        var WheelLocker = TimeoutLocker.inherit(function() {
            var WHEEL_UNLOCK_TIMEOUT = 400;
            return {
                ctor: function(element) {
                    this.callBase(element, WHEEL_UNLOCK_TIMEOUT);
                    this._lastWheelDirection = null
                },
                check: function(e, callback) {
                    this._checkDirectionChanged(e);
                    this.callBase(e, callback)
                },
                _checkDirectionChanged: function(e) {
                    if (!(0, _index.isDxMouseWheelEvent)(e)) {
                        this._lastWheelDirection = null;
                        return
                    }
                    var direction = e.shiftKey || false;
                    var directionChange = null !== this._lastWheelDirection && direction !== this._lastWheelDirection;
                    this._lastWheelDirection = direction;
                    this._locked = this._locked && !directionChange
                }
            }
        }());
        var PointerLocker = TimeoutLocker.inherit(function() {
            var POINTER_UNLOCK_TIMEOUT = 400;
            return {
                ctor: function(element) {
                    this.callBase(element, POINTER_UNLOCK_TIMEOUT)
                }
            }
        }());
        ! function() {
            var ios8_greater = realDevice.ios && (0, _version.compare)(realDevice.version, [8]) >= 0;
            var android5_greater = realDevice.android && (0, _version.compare)(realDevice.version, [5]) >= 0;
            if (!(ios8_greater || android5_greater)) {
                return
            }
            PointerLocker = Locker.inherit(function() {
                return {
                    _scroll: function() {
                        this._locked = true;
                        var that = this;
                        (0, _frame.cancelAnimationFrame)(this._scrollFrame);
                        this._scrollFrame = (0, _frame.requestAnimationFrame)(function() {
                            that._locked = false
                        })
                    },
                    check: function(e, callback) {
                        (0, _frame.cancelAnimationFrame)(this._scrollFrame);
                        (0, _frame.cancelAnimationFrame)(this._checkFrame);
                        var that = this;
                        var callBase = this.callBase;
                        this._checkFrame = (0, _frame.requestAnimationFrame)(function() {
                            callBase.call(that, e, callback);
                            that._locked = false
                        })
                    },
                    dispose: function() {
                        this.callBase();
                        (0, _frame.cancelAnimationFrame)(this._scrollFrame);
                        (0, _frame.cancelAnimationFrame)(this._checkFrame)
                    }
                }
            }())
        }();
        var ScrollEmitter = _emitter.default.inherit(function() {
            var INERTIA_TIMEOUT = 100;
            var VELOCITY_CALC_TIMEOUT = 200;
            var FRAME_DURATION = Math.round(1e3 / 60);
            return {
                ctor: function(element) {
                    this.callBase.apply(this, arguments);
                    this.direction = "both";
                    this._pointerLocker = new PointerLocker(element);
                    this._wheelLocker = new WheelLocker(element)
                },
                validate: function() {
                    return true
                },
                configure: function(data) {
                    if (data.scrollTarget) {
                        this._pointerLocker.dispose();
                        this._wheelLocker.dispose();
                        this._pointerLocker = new PointerLocker(data.scrollTarget);
                        this._wheelLocker = new WheelLocker(data.scrollTarget)
                    }
                    this.callBase(data)
                },
                _init: function(e) {
                    this._wheelLocker.check(e, function() {
                        if ((0, _index.isDxMouseWheelEvent)(e)) {
                            this._accept(e)
                        }
                    }.bind(this));
                    this._pointerLocker.check(e, function() {
                        var skipCheck = this.isNative && (0, _index.isMouseEvent)(e);
                        if (!(0, _index.isDxMouseWheelEvent)(e) && !skipCheck) {
                            this._accept(e)
                        }
                    }.bind(this));
                    this._fireEvent(SCROLL_INIT_EVENT, e);
                    this._prevEventData = (0, _index.eventData)(e)
                },
                move: function(e) {
                    this.callBase.apply(this, arguments);
                    e.isScrollingEvent = this.isNative || e.isScrollingEvent
                },
                _start: function(e) {
                    this._savedEventData = (0, _index.eventData)(e);
                    this._fireEvent(SCROLL_START_EVENT, e);
                    this._prevEventData = (0, _index.eventData)(e)
                },
                _move: function(e) {
                    var currentEventData = (0, _index.eventData)(e);
                    this._fireEvent(SCROLL_MOVE_EVENT, e, {
                        delta: (0, _index.eventDelta)(this._prevEventData, currentEventData)
                    });
                    var delta = (0, _index.eventDelta)(this._savedEventData, currentEventData);
                    if (delta.time > VELOCITY_CALC_TIMEOUT) {
                        this._savedEventData = this._prevEventData
                    }
                    this._prevEventData = (0, _index.eventData)(e)
                },
                _end: function(e) {
                    var endEventDelta = (0, _index.eventDelta)(this._prevEventData, (0, _index.eventData)(e));
                    var velocity = {
                        x: 0,
                        y: 0
                    };
                    if (!(0, _index.isDxMouseWheelEvent)(e) && endEventDelta.time < INERTIA_TIMEOUT) {
                        var delta = (0, _index.eventDelta)(this._savedEventData, this._prevEventData);
                        var velocityMultiplier = FRAME_DURATION / delta.time;
                        velocity = {
                            x: delta.x * velocityMultiplier,
                            y: delta.y * velocityMultiplier
                        }
                    }
                    this._fireEvent(SCROLL_END_EVENT, e, {
                        velocity: velocity
                    })
                },
                _stop: function(e) {
                    this._fireEvent(SCROLL_STOP_EVENT, e)
                },
                cancel: function(e) {
                    this.callBase.apply(this, arguments);
                    this._fireEvent(SCROLL_CANCEL_EVENT, e)
                },
                dispose: function() {
                    this.callBase.apply(this, arguments);
                    this._pointerLocker.dispose();
                    this._wheelLocker.dispose()
                },
                _clearSelection: function() {
                    if (this.isNative) {
                        return
                    }
                    return this.callBase.apply(this, arguments)
                },
                _toggleGestureCover: function() {
                    if (this.isNative) {
                        return
                    }
                    return this.callBase.apply(this, arguments)
                }
            }
        }());
        (0, _emitter_registrator.default)({
            emitter: ScrollEmitter,
            events: [SCROLL_INIT_EVENT, SCROLL_START_EVENT, SCROLL_MOVE_EVENT, SCROLL_END_EVENT, SCROLL_STOP_EVENT, SCROLL_CANCEL_EVENT]
        });
        var _default = {
            init: SCROLL_INIT_EVENT,
            start: SCROLL_START_EVENT,
            move: SCROLL_MOVE_EVENT,
            end: SCROLL_END_EVENT,
            stop: SCROLL_STOP_EVENT,
            cancel: SCROLL_CANCEL_EVENT
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/sortable.js ***!
      \*************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _draggable = _interopRequireDefault(__webpack_require__( /*! ./draggable */ 210));
        var _element = __webpack_require__( /*! ../core/element */ 18);
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _position = __webpack_require__( /*! ../core/utils/position */ 22);
        var _translator = __webpack_require__( /*! ../animation/translator */ 28);
        var _fx = _interopRequireDefault(__webpack_require__( /*! ../animation/fx */ 42));
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }
        var window = (0, _window.getWindow)();
        var SORTABLE = "dxSortable";
        var PLACEHOLDER_CLASS = "placeholder";
        var CLONE_CLASS = "clone";
        var isElementVisible = function(itemElement) {
            return (0, _renderer.default)(itemElement).is(":visible")
        };
        var animate = function(element, config) {
            var _config$to, _config$to2;
            if (!element) {
                return
            }
            var left = (null === (_config$to = config.to) || void 0 === _config$to ? void 0 : _config$to.left) || 0;
            var top = (null === (_config$to2 = config.to) || void 0 === _config$to2 ? void 0 : _config$to2.top) || 0;
            element.style.transform = "translate(".concat(left, "px,").concat(top, "px)");
            element.style.transition = _fx.default.off ? "" : "transform ".concat(config.duration, "ms ").concat(config.easing)
        };
        var stopAnimation = function(element) {
            if (!element) {
                return
            }
            element.style.transform = "";
            element.style.transition = ""
        };

        function getScrollableBoundary($scrollable) {
            var offset = $scrollable.offset();
            var style = $scrollable[0].style;
            var paddingLeft = parseFloat(style.paddingLeft) || 0;
            var paddingRight = parseFloat(style.paddingRight) || 0;
            var paddingTop = parseFloat(style.paddingTop) || 0;
            var width = $scrollable[0].clientWidth - (paddingLeft + paddingRight);
            var height = $scrollable.height();
            var left = offset.left + paddingLeft;
            var top = offset.top + paddingTop;
            return {
                left: left,
                right: left + width,
                top: top,
                bottom: top + height
            }
        }
        var Sortable = _draggable.default.inherit({
            _init: function() {
                this.callBase();
                this._sourceScrollHandler = this._handleSourceScroll.bind(this);
                this._sourceScrollableInfo = null
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    clone: true,
                    filter: "> *",
                    itemOrientation: "vertical",
                    dropFeedbackMode: "push",
                    allowDropInsideItem: false,
                    allowReordering: true,
                    moveItemOnDrop: false,
                    onDragChange: null,
                    onAdd: null,
                    onRemove: null,
                    onReorder: null,
                    onPlaceholderPrepared: null,
                    animation: {
                        type: "slide",
                        duration: 300,
                        easing: "ease"
                    },
                    fromIndex: null,
                    toIndex: null,
                    dropInsideItem: false,
                    itemPoints: null,
                    fromIndexOffset: 0,
                    offset: 0,
                    autoUpdate: false,
                    draggableElementSize: 0
                })
            },
            reset: function() {
                this.option({
                    dropInsideItem: false,
                    toIndex: null,
                    fromIndex: null,
                    itemPoints: null,
                    fromIndexOffset: 0,
                    draggableElementSize: 0
                });
                if (this._$placeholderElement) {
                    this._$placeholderElement.remove()
                }
                this._$placeholderElement = null;
                if (!this._isIndicateMode() && this._$modifiedItem) {
                    this._$modifiedItem.css("marginBottom", this._modifiedItemMargin);
                    this._$modifiedItem = null
                }
            },
            _getPrevVisibleItem: function(items, index) {
                return items.slice(0, index).reverse().filter(isElementVisible)[0]
            },
            _dragStartHandler: function(e) {
                this.callBase.apply(this, arguments);
                if (true === e.cancel) {
                    return
                }
                var $sourceElement = this._getSourceElement();
                this._updateItemPoints();
                this._subscribeToSourceScroll(e);
                this.option("fromIndex", this._getElementIndex($sourceElement));
                this.option("fromIndexOffset", this.option("offset"))
            },
            _dragEndHandler: function() {
                this.callBase.apply(this, arguments);
                this._unsubscribeFromSourceScroll()
            },
            _subscribeToSourceScroll: function(e) {
                var $scrollable = this._getScrollable((0, _renderer.default)(e.target));
                if ($scrollable) {
                    this._sourceScrollableInfo = {
                        element: $scrollable,
                        scrollLeft: $scrollable.scrollLeft(),
                        scrollTop: $scrollable.scrollTop()
                    };
                    _events_engine.default.on($scrollable, "scroll", this._sourceScrollHandler)
                }
            },
            _unsubscribeFromSourceScroll: function() {
                if (this._sourceScrollableInfo) {
                    _events_engine.default.off(this._sourceScrollableInfo.element, "scroll", this._sourceScrollHandler);
                    this._sourceScrollableInfo = null
                }
            },
            _handleSourceScroll: function(e) {
                var _this = this;
                var sourceScrollableInfo = this._sourceScrollableInfo;
                if (sourceScrollableInfo) {
                    ["scrollLeft", "scrollTop"].forEach(function(scrollProp) {
                        if (e.target[scrollProp] !== sourceScrollableInfo[scrollProp]) {
                            var scrollBy = e.target[scrollProp] - sourceScrollableInfo[scrollProp];
                            _this._correctItemPoints(scrollBy);
                            sourceScrollableInfo[scrollProp] = e.target[scrollProp]
                        }
                    })
                }
            },
            _dragEnterHandler: function() {
                this.callBase.apply(this, arguments);
                if (this === this._getSourceDraggable()) {
                    return
                }
                this._updateItemPoints();
                this.option("fromIndex", -1);
                if (!this._isIndicateMode()) {
                    var itemPoints = this.option("itemPoints");
                    var lastItemPoint = itemPoints[itemPoints.length - 1];
                    if (lastItemPoint) {
                        var $element = this.$element();
                        var $sourceElement = this._getSourceElement();
                        var isVertical = this._isVerticalOrientation();
                        var sourceElementSize = isVertical ? $sourceElement.outerHeight(true) : $sourceElement.outerWidth(true);
                        var scrollSize = $element.get(0)[isVertical ? "scrollHeight" : "scrollWidth"];
                        var scrollPosition = $element.get(0)[isVertical ? "scrollTop" : "scrollLeft"];
                        var positionProp = isVertical ? "top" : "left";
                        var lastPointPosition = lastItemPoint[positionProp];
                        var elementPosition = $element.offset()[positionProp];
                        var freeSize = elementPosition + scrollSize - scrollPosition - lastPointPosition;
                        if (freeSize < sourceElementSize) {
                            if (isVertical) {
                                var items = this._getItems();
                                var $lastItem = (0, _renderer.default)(this._getPrevVisibleItem(items));
                                this._$modifiedItem = $lastItem;
                                this._modifiedItemMargin = $lastItem.get(0).style.marginBottom;
                                $lastItem.css("marginBottom", sourceElementSize - freeSize);
                                var $sortable = $lastItem.closest(".dx-sortable");
                                var sortable = $sortable.data("dxScrollable") || $sortable.data("dxScrollView");
                                sortable && sortable.update()
                            }
                        }
                    }
                }
            },
            dragEnter: function() {
                if (this !== this._getTargetDraggable()) {
                    this.option("toIndex", -1)
                }
            },
            dragLeave: function() {
                if (this !== this._getTargetDraggable()) {
                    this.option("toIndex", this.option("fromIndex"))
                }
            },
            _isInsideTargetDraggable: function(event) {
                var $targetDraggable = this._getTargetDraggable().$element();
                var $scrollable = this._getScrollable($targetDraggable);
                if ($scrollable) {
                    var _getScrollableBoundar = getScrollableBoundary($scrollable),
                        left = _getScrollableBoundar.left,
                        right = _getScrollableBoundar.right,
                        top = _getScrollableBoundar.top,
                        bottom = _getScrollableBoundar.bottom;
                    var validX = left <= event.pageX && event.pageX <= right;
                    var validY = top <= event.pageY && event.pageY <= bottom;
                    return validY && validX
                }
                return true
            },
            dragEnd: function(sourceEvent) {
                var $sourceElement = this._getSourceElement();
                var sourceDraggable = this._getSourceDraggable();
                var isSourceDraggable = sourceDraggable.NAME !== this.NAME;
                var toIndex = this.option("toIndex");
                var isInsideTargetDraggable = this._isInsideTargetDraggable(sourceEvent.event);
                if (null !== toIndex && toIndex >= 0 && isInsideTargetDraggable) {
                    var cancelAdd;
                    var cancelRemove;
                    if (sourceDraggable !== this) {
                        cancelAdd = this._fireAddEvent(sourceEvent);
                        if (!cancelAdd) {
                            cancelRemove = this._fireRemoveEvent(sourceEvent)
                        }
                    }
                    if (isSourceDraggable) {
                        (0, _translator.resetPosition)($sourceElement)
                    }
                    if (this.option("moveItemOnDrop")) {
                        !cancelAdd && this._moveItem($sourceElement, toIndex, cancelRemove)
                    }
                    if (sourceDraggable === this) {
                        return this._fireReorderEvent(sourceEvent)
                    }
                }
                return (new _deferred.Deferred).resolve()
            },
            dragMove: function(e) {
                var itemPoints = this.option("itemPoints");
                if (!itemPoints) {
                    return
                }
                var isVertical = this._isVerticalOrientation();
                var axisName = isVertical ? "top" : "left";
                var cursorPosition = isVertical ? e.pageY : e.pageX;
                var rtlEnabled = this.option("rtlEnabled");
                var itemPoint;
                for (var i = itemPoints.length - 1; i >= 0; i--) {
                    var centerPosition = itemPoints[i + 1] && (itemPoints[i][axisName] + itemPoints[i + 1][axisName]) / 2;
                    if ((!isVertical && rtlEnabled ? cursorPosition > centerPosition : centerPosition > cursorPosition) || void 0 === centerPosition) {
                        itemPoint = itemPoints[i]
                    } else {
                        break
                    }
                }
                if (itemPoint) {
                    this._updatePlaceholderPosition(e, itemPoint);
                    if (this._verticalScrollHelper.isScrolling() && this._isIndicateMode()) {
                        this._movePlaceholder()
                    }
                }
            },
            _isIndicateMode: function() {
                return "indicate" === this.option("dropFeedbackMode") || this.option("allowDropInsideItem")
            },
            _createPlaceholder: function() {
                var $placeholderContainer;
                if (this._isIndicateMode()) {
                    $placeholderContainer = (0, _renderer.default)("<div>").addClass(this._addWidgetPrefix(PLACEHOLDER_CLASS)).insertBefore(this._getSourceDraggable()._$dragElement)
                }
                this._$placeholderElement = $placeholderContainer;
                return $placeholderContainer
            },
            _getItems: function() {
                var itemsSelector = this._getItemsSelector();
                return this._$content().find(itemsSelector).not("." + this._addWidgetPrefix(PLACEHOLDER_CLASS)).not("." + this._addWidgetPrefix(CLONE_CLASS)).toArray()
            },
            _allowReordering: function() {
                var sourceDraggable = this._getSourceDraggable();
                var targetDraggable = this._getTargetDraggable();
                return sourceDraggable !== targetDraggable || this.option("allowReordering")
            },
            _isValidPoint: function(visibleIndex, draggableVisibleIndex, dropInsideItem) {
                var allowDropInsideItem = this.option("allowDropInsideItem");
                var allowReordering = dropInsideItem || this._allowReordering();
                if (!allowReordering && (0 !== visibleIndex || !allowDropInsideItem)) {
                    return false
                }
                if (!this._isIndicateMode()) {
                    return true
                }
                return draggableVisibleIndex === -1 || visibleIndex !== draggableVisibleIndex && (dropInsideItem || visibleIndex !== draggableVisibleIndex + 1)
            },
            _getItemPoints: function() {
                var that = this;
                var result = [];
                var $item;
                var offset;
                var itemWidth;
                var rtlEnabled = that.option("rtlEnabled");
                var isVertical = that._isVerticalOrientation();
                var itemElements = that._getItems();
                var visibleItemElements = itemElements.filter(isElementVisible);
                var visibleItemCount = visibleItemElements.length;
                var $draggableItem = this._getDraggableElement();
                var draggableVisibleIndex = visibleItemElements.indexOf($draggableItem.get(0));
                if (visibleItemCount) {
                    for (var i = 0; i <= visibleItemCount; i++) {
                        var needCorrectLeftPosition = !isVertical && rtlEnabled ^ i === visibleItemCount;
                        var needCorrectTopPosition = isVertical && i === visibleItemCount;
                        if (i < visibleItemCount) {
                            $item = (0, _renderer.default)(visibleItemElements[i]);
                            offset = $item.offset();
                            itemWidth = $item.outerWidth()
                        }
                        result.push({
                            dropInsideItem: false,
                            left: offset.left + (needCorrectLeftPosition ? itemWidth : 0),
                            top: offset.top + (needCorrectTopPosition ? result[i - 1].height : 0),
                            index: i === visibleItemCount ? itemElements.length : itemElements.indexOf($item.get(0)),
                            $item: $item,
                            width: $item.outerWidth(),
                            height: $item.outerHeight(),
                            isValid: that._isValidPoint(i, draggableVisibleIndex)
                        })
                    }
                    if (this.option("allowDropInsideItem")) {
                        var points = result;
                        result = [];
                        for (var _i = 0; _i < points.length; _i++) {
                            result.push(points[_i]);
                            if (points[_i + 1]) {
                                result.push((0, _extend.extend)({}, points[_i], {
                                    dropInsideItem: true,
                                    top: Math.floor((points[_i].top + points[_i + 1].top) / 2),
                                    left: Math.floor((points[_i].left + points[_i + 1].left) / 2),
                                    isValid: this._isValidPoint(_i, draggableVisibleIndex, true)
                                }))
                            }
                        }
                    }
                } else {
                    result.push({
                        dropInsideItem: false,
                        index: 0,
                        isValid: true
                    })
                }
                return result
            },
            _updateItemPoints: function(forceUpdate) {
                if (forceUpdate || this.option("autoUpdate") || !this.option("itemPoints")) {
                    this.option("itemPoints", this._getItemPoints())
                }
            },
            _correctItemPoints: function(scrollBy) {
                var itemPoints = this.option("itemPoints");
                if (scrollBy && itemPoints && !this.option("autoUpdate")) {
                    var isVertical = this._isVerticalOrientation();
                    var positionPropName = isVertical ? "top" : "left";
                    itemPoints.forEach(function(itemPoint) {
                        itemPoint[positionPropName] -= scrollBy
                    })
                }
            },
            _getElementIndex: function($itemElement) {
                return this._getItems().indexOf($itemElement.get(0))
            },
            _getDragTemplateArgs: function($element) {
                var args = this.callBase.apply(this, arguments);
                args.model.fromIndex = this._getElementIndex($element);
                return args
            },
            _togglePlaceholder: function(value) {
                this._$placeholderElement && this._$placeholderElement.toggle(value)
            },
            _isVerticalOrientation: function() {
                return "vertical" === this.option("itemOrientation")
            },
            _normalizeToIndex: function(toIndex, dropInsideItem) {
                var isAnotherDraggable = this._getSourceDraggable() !== this._getTargetDraggable();
                var fromIndex = this.option("fromIndex");
                if (null === toIndex) {
                    return fromIndex
                }
                return Math.max(isAnotherDraggable || fromIndex >= toIndex || dropInsideItem ? toIndex : toIndex - 1, 0)
            },
            _updatePlaceholderPosition: function(e, itemPoint) {
                var sourceDraggable = this._getSourceDraggable();
                var toIndex = this._normalizeToIndex(itemPoint.index, itemPoint.dropInsideItem);
                var eventArgs = (0, _extend.extend)(this._getEventArgs(e), {
                    toIndex: toIndex,
                    dropInsideItem: itemPoint.dropInsideItem
                });
                itemPoint.isValid && this._getAction("onDragChange")(eventArgs);
                if (eventArgs.cancel || !itemPoint.isValid) {
                    if (!itemPoint.isValid) {
                        this.option({
                            dropInsideItem: false,
                            toIndex: null
                        })
                    }
                    return
                }
                this.option({
                    dropInsideItem: itemPoint.dropInsideItem,
                    toIndex: itemPoint.index
                });
                this._getAction("onPlaceholderPrepared")((0, _extend.extend)(this._getEventArgs(e), {
                    placeholderElement: (0, _element.getPublicElement)(this._$placeholderElement),
                    dragElement: (0, _element.getPublicElement)(sourceDraggable._$dragElement)
                }));
                this._updateItemPoints()
            },
            _makeWidthCorrection: function($item, width) {
                this._$scrollable = this._getScrollable($item);
                if (this._$scrollable && this._$scrollable.width() < width) {
                    var scrollableWidth = this._$scrollable.width();
                    var offsetLeft = $item.offset().left - this._$scrollable.offset().left;
                    var offsetRight = scrollableWidth - $item.outerWidth() - offsetLeft;
                    if (offsetLeft > 0) {
                        width = scrollableWidth - offsetLeft
                    } else {
                        if (offsetRight > 0) {
                            width = scrollableWidth - offsetRight
                        } else {
                            width = scrollableWidth
                        }
                    }
                }
                return width
            },
            _updatePlaceholderSizes: function($placeholderElement, itemElement) {
                var that = this;
                var dropInsideItem = that.option("dropInsideItem");
                var $item = (0, _renderer.default)(itemElement);
                var isVertical = that._isVerticalOrientation();
                var width = "";
                var height = "";
                $placeholderElement.toggleClass(that._addWidgetPrefix("placeholder-inside"), dropInsideItem);
                if (isVertical || dropInsideItem) {
                    width = $item.outerWidth()
                }
                if (!isVertical || dropInsideItem) {
                    height = $item.outerHeight()
                }
                width = that._makeWidthCorrection($item, width);
                $placeholderElement.css({
                    width: width,
                    height: height
                })
            },
            _moveItem: function($itemElement, index, cancelRemove) {
                var $prevTargetItemElement;
                var $itemElements = this._getItems();
                var $targetItemElement = $itemElements[index];
                var sourceDraggable = this._getSourceDraggable();
                if (cancelRemove) {
                    $itemElement = $itemElement.clone();
                    sourceDraggable._toggleDragSourceClass(false, $itemElement)
                }
                if (!$targetItemElement) {
                    $prevTargetItemElement = $itemElements[index - 1]
                }
                this._moveItemCore($itemElement, $targetItemElement, $prevTargetItemElement)
            },
            _moveItemCore: function($targetItem, item, prevItem) {
                if (!item && !prevItem) {
                    $targetItem.appendTo(this.$element())
                } else {
                    if (prevItem) {
                        $targetItem.insertAfter((0, _renderer.default)(prevItem))
                    } else {
                        $targetItem.insertBefore((0, _renderer.default)(item))
                    }
                }
            },
            _getDragStartArgs: function(e, $itemElement) {
                return (0, _extend.extend)(this.callBase.apply(this, arguments), {
                    fromIndex: this._getElementIndex($itemElement)
                })
            },
            _getEventArgs: function(e) {
                var sourceDraggable = this._getSourceDraggable();
                var targetDraggable = this._getTargetDraggable();
                var dropInsideItem = targetDraggable.option("dropInsideItem");
                return (0, _extend.extend)(this.callBase.apply(this, arguments), {
                    fromIndex: sourceDraggable.option("fromIndex"),
                    toIndex: this._normalizeToIndex(targetDraggable.option("toIndex"), dropInsideItem),
                    dropInsideItem: dropInsideItem
                })
            },
            _optionChanged: function(args) {
                var _this2 = this;
                var name = args.name;
                switch (name) {
                    case "onDragChange":
                    case "onPlaceholderPrepared":
                    case "onAdd":
                    case "onRemove":
                    case "onReorder":
                        this["_" + name + "Action"] = this._createActionByOption(name);
                        break;
                    case "itemOrientation":
                    case "allowDropInsideItem":
                    case "moveItemOnDrop":
                    case "dropFeedbackMode":
                    case "itemPoints":
                    case "animation":
                    case "allowReordering":
                    case "fromIndexOffset":
                    case "offset":
                    case "draggableElementSize":
                    case "autoUpdate":
                        break;
                    case "fromIndex":
                        [false, true].forEach(function(isDragSource) {
                            var fromIndex = isDragSource ? args.value : args.previousValue;
                            if (null !== fromIndex) {
                                var $fromElement = (0, _renderer.default)(_this2._getItems()[fromIndex]);
                                _this2._toggleDragSourceClass(isDragSource, $fromElement)
                            }
                        });
                        break;
                    case "dropInsideItem":
                        this._optionChangedDropInsideItem(args);
                        break;
                    case "toIndex":
                        this._optionChangedToIndex(args);
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _optionChangedDropInsideItem: function() {
                if (this._isIndicateMode() && this._$placeholderElement) {
                    this._movePlaceholder()
                }
            },
            _isPositionVisible: function(position) {
                var $element = this.$element();
                var scrollContainer;
                if ("hidden" !== $element.css("overflow")) {
                    scrollContainer = $element.get(0)
                } else {
                    $element.parents().each(function() {
                        if ("visible" !== (0, _renderer.default)(this).css("overflow")) {
                            scrollContainer = this;
                            return false
                        }
                    })
                }
                if (scrollContainer) {
                    var clientRect = (0, _position.getBoundingRect)(scrollContainer);
                    var isVerticalOrientation = this._isVerticalOrientation();
                    var start = isVerticalOrientation ? "top" : "left";
                    var end = isVerticalOrientation ? "bottom" : "right";
                    var pageOffset = isVerticalOrientation ? window.pageYOffset : window.pageXOffset;
                    if (position[start] < clientRect[start] + pageOffset || position[start] > clientRect[end] + pageOffset) {
                        return false
                    }
                }
                return true
            },
            _optionChangedToIndex: function(args) {
                var toIndex = args.value;
                if (this._isIndicateMode()) {
                    var showPlaceholder = null !== toIndex && toIndex >= 0;
                    this._togglePlaceholder(showPlaceholder);
                    if (showPlaceholder) {
                        this._movePlaceholder()
                    }
                } else {
                    this._moveItems(args.previousValue, args.value, args.fullUpdate)
                }
            },
            update: function() {
                if (null === this.option("fromIndex") && null === this.option("toIndex")) {
                    return
                }
                this._updateItemPoints(true);
                this._updateDragSourceClass();
                var toIndex = this.option("toIndex");
                this._optionChangedToIndex({
                    value: toIndex,
                    fullUpdate: true
                })
            },
            _updateDragSourceClass: function() {
                var fromIndex = this._getActualFromIndex();
                var $fromElement = (0, _renderer.default)(this._getItems()[fromIndex]);
                if ($fromElement.length) {
                    this._$sourceElement = $fromElement;
                    this._toggleDragSourceClass(true, $fromElement)
                }
            },
            _makeLeftCorrection: function(left, leftMargin) {
                var that = this;
                var $scrollable = that._$scrollable;
                if ($scrollable && that._isVerticalOrientation() && $scrollable.scrollLeft() > leftMargin) {
                    left += $scrollable.scrollLeft() - leftMargin
                }
                return left
            },
            _movePlaceholder: function() {
                var that = this;
                var $placeholderElement = that._$placeholderElement || that._createPlaceholder();
                var items = that._getItems();
                var toIndex = that.option("toIndex");
                var isVerticalOrientation = that._isVerticalOrientation();
                var rtlEnabled = this.option("rtlEnabled");
                var dropInsideItem = that.option("dropInsideItem");
                var position = null;
                var leftMargin = 0;
                var itemElement = items[toIndex];
                if (itemElement) {
                    var $itemElement = (0, _renderer.default)(itemElement);
                    position = $itemElement.offset();
                    leftMargin = parseFloat($itemElement.css("marginLeft"));
                    if (!isVerticalOrientation && rtlEnabled && !dropInsideItem) {
                        position.left += $itemElement.outerWidth(true)
                    }
                } else {
                    var prevVisibleItemElement = itemElement = this._getPrevVisibleItem(items, toIndex);
                    if (prevVisibleItemElement) {
                        position = (0, _renderer.default)(prevVisibleItemElement).offset();
                        if (isVerticalOrientation) {
                            position.top += (0, _renderer.default)(prevVisibleItemElement).outerHeight(true)
                        } else {
                            if (!rtlEnabled) {
                                position.left += (0, _renderer.default)(prevVisibleItemElement).outerWidth(true)
                            }
                        }
                    }
                }
                that._updatePlaceholderSizes($placeholderElement, itemElement);
                if (position && !that._isPositionVisible(position)) {
                    position = null
                }
                if (position) {
                    position.left = that._makeLeftCorrection(position.left, leftMargin);
                    that._move(position, $placeholderElement)
                }
                $placeholderElement.toggle(!!position)
            },
            _getPositions: function(items, elementSize, fromIndex, toIndex) {
                var positions = [];
                for (var i = 0; i < items.length; i++) {
                    var position = 0;
                    if (null === toIndex || null === fromIndex) {
                        positions.push(position);
                        continue
                    }
                    if (fromIndex === -1) {
                        if (i >= toIndex) {
                            position = elementSize
                        }
                    } else {
                        if (toIndex === -1) {
                            if (i > fromIndex) {
                                position = -elementSize
                            }
                        } else {
                            if (fromIndex < toIndex) {
                                if (i > fromIndex && i < toIndex) {
                                    position = -elementSize
                                }
                            } else {
                                if (fromIndex > toIndex) {
                                    if (i >= toIndex && i < fromIndex) {
                                        position = elementSize
                                    }
                                }
                            }
                        }
                    }
                    positions.push(position)
                }
                return positions
            },
            _getDraggableElementSize: function(isVerticalOrientation) {
                var $draggableItem = this._getDraggableElement();
                var size = this.option("draggableElementSize");
                if (!size) {
                    size = isVerticalOrientation ? ($draggableItem.outerHeight() + $draggableItem.outerHeight(true)) / 2 : ($draggableItem.outerWidth() + $draggableItem.outerWidth(true)) / 2;
                    if (!this.option("autoUpdate")) {
                        this.option("draggableElementSize", size)
                    }
                }
                return size
            },
            _getActualFromIndex: function() {
                var _this$option = this.option(),
                    fromIndex = _this$option.fromIndex,
                    fromIndexOffset = _this$option.fromIndexOffset,
                    offset = _this$option.offset;
                return null == fromIndex ? null : fromIndex + fromIndexOffset - offset
            },
            _moveItems: function(prevToIndex, toIndex, fullUpdate) {
                var fromIndex = this._getActualFromIndex();
                var isVerticalOrientation = this._isVerticalOrientation();
                var positionPropName = isVerticalOrientation ? "top" : "left";
                var elementSize = this._getDraggableElementSize(isVerticalOrientation);
                var items = this._getItems();
                var prevPositions = this._getPositions(items, elementSize, fromIndex, prevToIndex);
                var positions = this._getPositions(items, elementSize, fromIndex, toIndex);
                var animationConfig = this.option("animation");
                var rtlEnabled = this.option("rtlEnabled");
                for (var i = 0; i < items.length; i++) {
                    var itemElement = items[i];
                    var prevPosition = prevPositions[i];
                    var position = positions[i];
                    if (null === toIndex || null === fromIndex) {
                        stopAnimation(itemElement)
                    } else {
                        if (prevPosition !== position || fullUpdate && position) {
                            animate(itemElement, (0, _extend.extend)({}, animationConfig, {
                                to: _defineProperty({}, positionPropName, !isVerticalOrientation && rtlEnabled ? -position : position)
                            }))
                        }
                    }
                }
            },
            _toggleDragSourceClass: function(value, $element) {
                var $sourceElement = $element || this._$sourceElement;
                this.callBase.apply(this, arguments);
                if (!this._isIndicateMode()) {
                    $sourceElement && $sourceElement.toggleClass(this._addWidgetPrefix("source-hidden"), value)
                }
            },
            _dispose: function() {
                this.reset();
                this.callBase()
            },
            _fireAddEvent: function(sourceEvent) {
                var args = this._getEventArgs(sourceEvent);
                this._getAction("onAdd")(args);
                return args.cancel
            },
            _fireRemoveEvent: function(sourceEvent) {
                var sourceDraggable = this._getSourceDraggable();
                var args = this._getEventArgs(sourceEvent);
                sourceDraggable._getAction("onRemove")(args);
                return args.cancel
            },
            _fireReorderEvent: function(sourceEvent) {
                var args = this._getEventArgs(sourceEvent);
                this._getAction("onReorder")(args);
                return args.promise || (new _deferred.Deferred).resolve()
            }
        });
        (0, _component_registrator.default)(SORTABLE, Sortable);
        var _default = Sortable;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/widget/ui.search_box_mixin.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _text_box = _interopRequireDefault(__webpack_require__( /*! ../text_box */ 97));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = {
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    searchMode: "",
                    searchExpr: null,
                    searchValue: "",
                    searchEnabled: false,
                    searchEditorOptions: {}
                })
            },
            _initMarkup: function() {
                this._renderSearch();
                this.callBase()
            },
            _renderSearch: function() {
                var $element = this.$element();
                var searchEnabled = this.option("searchEnabled");
                var searchBoxClassName = this._addWidgetPrefix("search");
                var rootElementClassName = this._addWidgetPrefix("with-search");
                if (!searchEnabled) {
                    $element.removeClass(rootElementClassName);
                    this._removeSearchBox();
                    return
                }
                var editorOptions = this._getSearchEditorOptions();
                if (this._searchEditor) {
                    this._searchEditor.option(editorOptions)
                } else {
                    $element.addClass(rootElementClassName);
                    this._$searchEditorElement = (0, _renderer.default)("<div>").addClass(searchBoxClassName).prependTo($element);
                    this._searchEditor = this._createComponent(this._$searchEditorElement, _text_box.default, editorOptions)
                }
            },
            _removeSearchBox: function() {
                this._$searchEditorElement && this._$searchEditorElement.remove();
                delete this._$searchEditorElement;
                delete this._searchEditor
            },
            _getSearchEditorOptions: function() {
                var that = this;
                var userEditorOptions = that.option("searchEditorOptions");
                var searchText = _message.default.format("Search");
                return (0, _extend.extend)({
                    mode: "search",
                    placeholder: searchText,
                    tabIndex: that.option("tabIndex"),
                    value: that.option("searchValue"),
                    valueChangeEvent: "input",
                    inputAttr: {
                        "aria-label": searchText
                    },
                    onValueChanged: function(e) {
                        var searchTimeout = that.option("searchTimeout");
                        that._valueChangeDeferred = new _deferred.Deferred;
                        clearTimeout(that._valueChangeTimeout);
                        that._valueChangeDeferred.done(function() {
                            this.option("searchValue", e.value)
                        }.bind(that));
                        if (e.event && "input" === e.event.type && searchTimeout) {
                            that._valueChangeTimeout = setTimeout(function() {
                                that._valueChangeDeferred.resolve()
                            }, searchTimeout)
                        } else {
                            that._valueChangeDeferred.resolve()
                        }
                    }
                }, userEditorOptions)
            },
            _getAriaTarget: function() {
                if (this.option("searchEnabled")) {
                    return this._itemContainer(true)
                }
                return this.$element()
            },
            _focusTarget: function() {
                if (this.option("searchEnabled")) {
                    return this._itemContainer(true)
                }
                return this.callBase()
            },
            _updateFocusState: function(e, isFocused) {
                if (this.option("searchEnabled")) {
                    this._toggleFocusClass(isFocused, this.$element())
                }
                this.callBase(e, isFocused)
            },
            getOperationBySearchMode: function(searchMode) {
                return "equals" === searchMode ? "=" : searchMode
            },
            _cleanAria: function($target) {
                this.setAria({
                    role: null,
                    activedescendant: null
                }, $target);
                $target.attr("tabIndex", null)
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "searchEnabled":
                    case "searchEditorOptions":
                        this._cleanAria(this.option("searchEnabled") ? this.$element() : this._itemContainer());
                        this._invalidate();
                        break;
                    case "searchExpr":
                    case "searchMode":
                    case "searchValue":
                        if (!this._dataSource) {
                            _ui.default.log("W1009");
                            return
                        }
                        if ("searchMode" === args.name) {
                            this._dataSource.searchOperation(this.getOperationBySearchMode(args.value))
                        } else {
                            this._dataSource[args.name](args.value)
                        }
                        this._dataSource.load();
                        break;
                    case "searchTimeout":
                        break;
                    default:
                        this.callBase(args)
                }
            },
            focus: function() {
                if (!this.option("focusedElement") && this.option("searchEnabled")) {
                    this._searchEditor && this._searchEditor.focus();
                    return
                }
                this.callBase()
            },
            _refresh: function() {
                if (this._valueChangeDeferred) {
                    this._valueChangeDeferred.resolve()
                }
                this.callBase()
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/editor/ui.data_expression.js ***!
      \******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _variable_wrapper = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/variable_wrapper */ 102));
        var _data = __webpack_require__( /*! ../../core/utils/data */ 20);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _data_helper = _interopRequireDefault(__webpack_require__( /*! ../../data_helper */ 92));
        var _data_source = __webpack_require__( /*! ../../data/data_source/data_source */ 68);
        var _array_store = _interopRequireDefault(__webpack_require__( /*! ../../data/array_store */ 77));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        var DataExpressionMixin = (0, _extend.extend)({}, _data_helper.default, {
            _dataExpressionDefaultOptions: function() {
                return {
                    items: [],
                    dataSource: null,
                    itemTemplate: "item",
                    value: null,
                    valueExpr: "this",
                    displayExpr: void 0
                }
            },
            _initDataExpressions: function() {
                this._compileValueGetter();
                this._compileDisplayGetter();
                this._initDynamicTemplates();
                this._initDataSource();
                this._itemsToDataSource()
            },
            _itemsToDataSource: function() {
                if (!this.option("dataSource")) {
                    this._dataSource = new _data_source.DataSource({
                        store: new _array_store.default(this.option("items")),
                        pageSize: 0
                    })
                }
            },
            _compileDisplayGetter: function() {
                this._displayGetter = (0, _data.compileGetter)(this._displayGetterExpr())
            },
            _displayGetterExpr: function() {
                return this.option("displayExpr")
            },
            _compileValueGetter: function() {
                this._valueGetter = (0, _data.compileGetter)(this._valueGetterExpr())
            },
            _valueGetterExpr: function() {
                return this.option("valueExpr") || "this"
            },
            _loadValue: function(value) {
                var deferred = new _deferred.Deferred;
                value = this._unwrappedValue(value);
                if (!(0, _type.isDefined)(value)) {
                    return deferred.reject().promise()
                }
                this._loadSingle(this._valueGetterExpr(), value).done(function(item) {
                    this._isValueEquals(this._valueGetter(item), value) ? deferred.resolve(item) : deferred.reject()
                }.bind(this)).fail(function() {
                    deferred.reject()
                });
                return deferred.promise()
            },
            _getCurrentValue: function() {
                return this.option("value")
            },
            _unwrappedValue: function(value) {
                var _value;
                value = null !== (_value = value) && void 0 !== _value ? _value : this._getCurrentValue();
                if (value && this._dataSource && "this" === this._valueGetterExpr()) {
                    value = this._getItemKey(value)
                }
                return _variable_wrapper.default.unwrap(value)
            },
            _getItemKey: function(value) {
                var key = this._dataSource.key();
                if (Array.isArray(key)) {
                    var result = {};
                    for (var i = 0, n = key.length; i < n; i++) {
                        result[key[i]] = value[key[i]]
                    }
                    return result
                }
                if (key && "object" === _typeof(value)) {
                    value = value[key]
                }
                return value
            },
            _isValueEquals: function(value1, value2) {
                var dataSourceKey = this._dataSource && this._dataSource.key();
                var result = this._compareValues(value1, value2);
                if (!result && dataSourceKey && (0, _type.isDefined)(value1) && (0, _type.isDefined)(value2)) {
                    if (Array.isArray(dataSourceKey)) {
                        result = this._compareByCompositeKey(value1, value2, dataSourceKey)
                    } else {
                        result = this._compareByKey(value1, value2, dataSourceKey)
                    }
                }
                return result
            },
            _compareByCompositeKey: function(value1, value2, key) {
                var isObject = _type.isObject;
                if (!isObject(value1) || !isObject(value2)) {
                    return false
                }
                for (var i = 0, n = key.length; i < n; i++) {
                    if (value1[key[i]] !== value2[key[i]]) {
                        return false
                    }
                }
                return true
            },
            _compareByKey: function(value1, value2, key) {
                var unwrapObservable = _variable_wrapper.default.unwrap;
                var valueKey1 = (0, _common.ensureDefined)(unwrapObservable(value1[key]), value1);
                var valueKey2 = (0, _common.ensureDefined)(unwrapObservable(value2[key]), value2);
                return this._compareValues(valueKey1, valueKey2)
            },
            _compareValues: function(value1, value2) {
                return (0, _data.toComparable)(value1, true) === (0, _data.toComparable)(value2, true)
            },
            _initDynamicTemplates: _common.noop,
            _setCollectionWidgetItemTemplate: function() {
                this._initDynamicTemplates();
                this._setCollectionWidgetOption("itemTemplate", this.option("itemTemplate"))
            },
            _getCollectionKeyExpr: function() {
                var valueExpr = this.option("valueExpr");
                var isValueExprField = (0, _type.isString)(valueExpr) && "this" !== valueExpr || (0, _type.isFunction)(valueExpr);
                return isValueExprField ? valueExpr : null
            },
            _dataExpressionOptionChanged: function(args) {
                switch (args.name) {
                    case "items":
                        this._itemsToDataSource();
                        this._setCollectionWidgetOption("items");
                        break;
                    case "dataSource":
                        this._initDataSource();
                        break;
                    case "itemTemplate":
                        this._setCollectionWidgetItemTemplate();
                        break;
                    case "valueExpr":
                        this._compileValueGetter();
                        break;
                    case "displayExpr":
                        this._compileDisplayGetter();
                        this._initDynamicTemplates();
                        this._setCollectionWidgetOption("displayExpr")
                }
            }
        });
        var _default = DataExpressionMixin;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/button_group.js ***!
      \*****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./widget/ui.widget */ 16));
        var _button = _interopRequireDefault(__webpack_require__( /*! ./button */ 37));
        var _uiCollection_widget = _interopRequireDefault(__webpack_require__( /*! ./collection/ui.collection_widget.edit */ 54));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _bindable_template = __webpack_require__( /*! ../core/templates/bindable_template */ 65);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var BUTTON_GROUP_CLASS = "dx-buttongroup";
        var BUTTON_GROUP_WRAPPER_CLASS = BUTTON_GROUP_CLASS + "-wrapper";
        var BUTTON_GROUP_ITEM_CLASS = BUTTON_GROUP_CLASS + "-item";
        var BUTTON_GROUP_FIRST_ITEM_CLASS = BUTTON_GROUP_CLASS + "-first-item";
        var BUTTON_GROUP_LAST_ITEM_CLASS = BUTTON_GROUP_CLASS + "-last-item";
        var BUTTON_GROUP_ITEM_HAS_WIDTH = BUTTON_GROUP_ITEM_CLASS + "-has-width";
        var SHAPE_STANDARD_CLASS = "dx-shape-standard";
        var ButtonCollection = _uiCollection_widget.default.inherit({
            _initTemplates: function() {
                var _this = this;
                this.callBase();
                this._templateManager.addDefaultTemplates({
                    item: new _bindable_template.BindableTemplate(function($container, data, model) {
                        _this._prepareItemStyles($container);
                        _this._createComponent($container, _button.default, (0, _extend.extend)({}, model, data, _this._getBasicButtonOptions(), {
                            _templateData: model,
                            template: model.template || _this.option("buttonTemplate")
                        }))
                    }, ["text", "type", "icon", "disabled", "visible", "hint"], this.option("integrationOptions.watchMethod"))
                })
            },
            _getBasicButtonOptions: function() {
                return {
                    focusStateEnabled: false,
                    onClick: null,
                    hoverStateEnabled: this.option("hoverStateEnabled"),
                    activeStateEnabled: this.option("activeStateEnabled"),
                    stylingMode: this.option("stylingMode")
                }
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    itemTemplateProperty: null
                })
            },
            _prepareItemStyles: function($item) {
                var itemIndex = $item.data("dxItemIndex");
                0 === itemIndex && $item.addClass(BUTTON_GROUP_FIRST_ITEM_CLASS);
                var items = this.option("items");
                items && itemIndex === items.length - 1 && $item.addClass(BUTTON_GROUP_LAST_ITEM_CLASS);
                $item.addClass(SHAPE_STANDARD_CLASS)
            },
            _renderItemContent: function(args) {
                args.container = (0, _renderer.default)(args.container).parent();
                return this.callBase(args)
            },
            _renderItemContentByNode: function(args, $node) {
                args.container = (0, _renderer.default)(args.container.children().first());
                return this.callBase(args, $node)
            },
            _focusTarget: function() {
                return this.$element().parent()
            },
            _keyboardEventBindingTarget: function() {
                return this._focusTarget()
            },
            _refreshContent: function() {
                this._prepareContent();
                this._renderContent()
            },
            _itemClass: function() {
                return BUTTON_GROUP_ITEM_CLASS
            },
            _itemSelectHandler: function(e) {
                if ("single" === this.option("selectionMode") && this.isItemSelected(e.currentTarget)) {
                    return
                }
                this.callBase(e)
            }
        });
        var ButtonGroup = _ui.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    hoverStateEnabled: true,
                    focusStateEnabled: true,
                    selectionMode: "single",
                    selectedItems: [],
                    selectedItemKeys: [],
                    stylingMode: "contained",
                    keyExpr: "text",
                    items: [],
                    buttonTemplate: "content",
                    onSelectionChanged: null,
                    onItemClick: null
                })
            },
            _init: function() {
                this.callBase();
                this._createItemClickAction()
            },
            _createItemClickAction: function() {
                this._itemClickAction = this._createActionByOption("onItemClick")
            },
            _initMarkup: function() {
                this.setAria("role", "group");
                this.$element().addClass(BUTTON_GROUP_CLASS);
                this._renderButtons();
                this._syncSelectionOptions();
                this.callBase()
            },
            _fireSelectionChangeEvent: function(addedItems, removedItems) {
                this._createActionByOption("onSelectionChanged", {
                    excludeValidators: ["disabled", "readOnly"]
                })({
                    addedItems: addedItems,
                    removedItems: removedItems
                })
            },
            _renderButtons: function() {
                var _this2 = this;
                var $buttons = (0, _renderer.default)("<div>").addClass(BUTTON_GROUP_WRAPPER_CLASS).appendTo(this.$element());
                var selectedItems = this.option("selectedItems");
                var options = {
                    selectionMode: this.option("selectionMode"),
                    items: this.option("items"),
                    keyExpr: this.option("keyExpr"),
                    buttonTemplate: this.option("buttonTemplate"),
                    scrollingEnabled: false,
                    selectedItemKeys: this.option("selectedItemKeys"),
                    focusStateEnabled: this.option("focusStateEnabled"),
                    hoverStateEnabled: this.option("hoverStateEnabled"),
                    activeStateEnabled: this.option("activeStateEnabled"),
                    stylingMode: this.option("stylingMode"),
                    accessKey: this.option("accessKey"),
                    tabIndex: this.option("tabIndex"),
                    noDataText: "",
                    selectionRequired: false,
                    onItemRendered: function(e) {
                        var width = _this2.option("width");
                        (0, _type.isDefined)(width) && (0, _renderer.default)(e.itemElement).addClass(BUTTON_GROUP_ITEM_HAS_WIDTH)
                    },
                    onSelectionChanged: function(e) {
                        _this2._syncSelectionOptions();
                        _this2._fireSelectionChangeEvent(e.addedItems, e.removedItems)
                    },
                    onItemClick: function(e) {
                        _this2._itemClickAction(e)
                    }
                };
                if ((0, _type.isDefined)(selectedItems) && selectedItems.length) {
                    options.selectedItems = selectedItems
                }
                this._buttonsCollection = this._createComponent($buttons, ButtonCollection, options)
            },
            _syncSelectionOptions: function() {
                this._setOptionWithoutOptionChange("selectedItems", this._buttonsCollection.option("selectedItems"));
                this._setOptionWithoutOptionChange("selectedItemKeys", this._buttonsCollection.option("selectedItemKeys"))
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "stylingMode":
                    case "selectionMode":
                    case "keyExpr":
                    case "buttonTemplate":
                    case "items":
                    case "activeStateEnabled":
                    case "focusStateEnabled":
                    case "hoverStateEnabled":
                    case "tabIndex":
                        this._invalidate();
                        break;
                    case "selectedItemKeys":
                    case "selectedItems":
                        this._buttonsCollection.option(args.name, args.value);
                        break;
                    case "onItemClick":
                        this._createItemClickAction();
                        break;
                    case "onSelectionChanged":
                        break;
                    case "width":
                        this.callBase(args);
                        this._buttonsCollection.itemElements().toggleClass(BUTTON_GROUP_ITEM_HAS_WIDTH, !!args.value);
                        break;
                    default:
                        this.callBase(args)
                }
            }
        });
        (0, _component_registrator.default)("dxButtonGroup", ButtonGroup);
        var _default = ButtonGroup;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/calendar.js ***!
      \*************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./calendar/ui.calendar */ 609));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _ui.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/drawer/ui.drawer.js ***!
      \*********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _element = __webpack_require__( /*! ../../core/element */ 18);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _position = __webpack_require__( /*! ../../core/utils/position */ 22);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _empty_template = __webpack_require__( /*! ../../core/templates/empty_template */ 91);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _uiDrawerRenderingStrategy = _interopRequireDefault(__webpack_require__( /*! ./ui.drawer.rendering.strategy.push */ 632));
        var _uiDrawerRenderingStrategy2 = _interopRequireDefault(__webpack_require__( /*! ./ui.drawer.rendering.strategy.shrink */ 633));
        var _uiDrawerRenderingStrategy3 = _interopRequireDefault(__webpack_require__( /*! ./ui.drawer.rendering.strategy.overlap */ 634));
        var _uiDrawer = __webpack_require__( /*! ./ui.drawer.animation */ 181);
        var _click = __webpack_require__( /*! ../../events/click */ 21);
        var _fx = _interopRequireDefault(__webpack_require__( /*! ../../animation/fx */ 42));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _visibility_change = __webpack_require__( /*! ../../events/visibility_change */ 59);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DRAWER_CLASS = "dx-drawer";
        var DRAWER_WRAPPER_CLASS = "dx-drawer-wrapper";
        var DRAWER_PANEL_CONTENT_CLASS = "dx-drawer-panel-content";
        var DRAWER_VIEW_CONTENT_CLASS = "dx-drawer-content";
        var DRAWER_SHADER_CLASS = "dx-drawer-shader";
        var INVISIBLE_STATE_CLASS = "dx-state-invisible";
        var OPENED_STATE_CLASS = "dx-drawer-opened";
        var ANONYMOUS_TEMPLATE_NAME = "content";
        var PANEL_TEMPLATE_NAME = "panel";
        var Drawer = _ui.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    position: "left",
                    opened: false,
                    minSize: null,
                    maxSize: null,
                    shading: false,
                    template: PANEL_TEMPLATE_NAME,
                    openedStateMode: "shrink",
                    revealMode: "slide",
                    animationEnabled: true,
                    animationDuration: 400,
                    closeOnOutsideClick: false,
                    contentTemplate: ANONYMOUS_TEMPLATE_NAME,
                    target: void 0
                })
            },
            _setDeprecatedOptions: function() {
                this.callBase();
                (0, _extend.extend)(this._deprecatedOptions, {
                    target: {
                        since: "20.1",
                        message: "Functionality associated with this option is not intended for the Drawer widget."
                    }
                })
            },
            _init: function() {
                this.callBase();
                this._initStrategy();
                this.$element().addClass(DRAWER_CLASS);
                this._whenAnimationCompleted = void 0;
                this._whenPanelContentRendered = void 0;
                this._whenPanelContentRefreshed = void 0;
                this._$wrapper = (0, _renderer.default)("<div>").addClass(DRAWER_WRAPPER_CLASS);
                this._$viewContentWrapper = (0, _renderer.default)("<div>").addClass(DRAWER_VIEW_CONTENT_CLASS);
                this._$wrapper.append(this._$viewContentWrapper);
                this.$element().append(this._$wrapper)
            },
            _initStrategy: function() {
                switch (this.option("openedStateMode")) {
                    case "push":
                        this._strategy = new _uiDrawerRenderingStrategy.default(this);
                        break;
                    case "shrink":
                        this._strategy = new _uiDrawerRenderingStrategy2.default(this);
                        break;
                    case "overlap":
                        this._strategy = new _uiDrawerRenderingStrategy3.default(this);
                        break;
                    default:
                        this._strategy = new _uiDrawerRenderingStrategy.default(this)
                }
            },
            _getAnonymousTemplateName: function() {
                return ANONYMOUS_TEMPLATE_NAME
            },
            _initTemplates: function() {
                var defaultTemplates = {};
                defaultTemplates[PANEL_TEMPLATE_NAME] = new _empty_template.EmptyTemplate;
                defaultTemplates[ANONYMOUS_TEMPLATE_NAME] = new _empty_template.EmptyTemplate;
                this._templateManager.addDefaultTemplates(defaultTemplates);
                this.callBase()
            },
            _viewContentWrapperClickHandler: function(e) {
                var closeOnOutsideClick = this.option("closeOnOutsideClick");
                if ((0, _type.isFunction)(closeOnOutsideClick)) {
                    closeOnOutsideClick = closeOnOutsideClick(e)
                }
                if (closeOnOutsideClick && this.option("opened")) {
                    this.stopAnimations();
                    if (this.option("shading")) {
                        e.preventDefault()
                    }
                    this.hide()
                }
            },
            _initMarkup: function() {
                this.callBase();
                this._toggleOpenedStateClass(this.option("opened"));
                this._renderPanelContentWrapper();
                this._refreshOpenedStateModeClass();
                this._refreshRevealModeClass();
                this._renderShader();
                this._whenPanelContentRendered = new _deferred.Deferred;
                this._strategy.renderPanelContent(this._whenPanelContentRendered);
                this._strategy.onPanelContentRendered();
                this._renderViewContent();
                _events_engine.default.off(this._$viewContentWrapper, _click.name);
                _events_engine.default.on(this._$viewContentWrapper, _click.name, this._viewContentWrapperClickHandler.bind(this));
                this._refreshPositionClass();
                this._refreshWrapperChildrenOrder()
            },
            _render: function() {
                var _this = this;
                this._initMinMaxSize();
                this.callBase();
                this._whenPanelContentRendered.always(function() {
                    _this._initMinMaxSize();
                    _this._strategy.refreshPanelElementSize("slide" === _this.option("revealMode") || !_this.isHorizontalDirection());
                    _this._renderPosition(_this.option("opened"), true);
                    _this._removePanelManualPosition()
                })
            },
            _removePanelManualPosition: function() {
                if (this._$panelContentWrapper.attr("manualposition")) {
                    this._$panelContentWrapper.removeAttr("manualPosition");
                    this._$panelContentWrapper.css({
                        position: "",
                        top: "",
                        left: "",
                        right: "",
                        bottom: ""
                    })
                }
            },
            _renderPanelContentWrapper: function() {
                this._$panelContentWrapper = (0, _renderer.default)("<div>").addClass(DRAWER_PANEL_CONTENT_CLASS);
                var position = this.calcTargetPosition();
                if ("push" === this.option("openedStateMode") && ["top", "bottom"].indexOf(position) > -1) {
                    this._$panelContentWrapper.addClass(DRAWER_PANEL_CONTENT_CLASS + "-push-top-or-bottom")
                }
                if ("overlap" !== this.option("openedStateMode") && !this.option("opened") && !this.option("minSize")) {
                    this._$panelContentWrapper.attr("manualposition", true);
                    this._$panelContentWrapper.css({
                        position: "absolute",
                        top: "-10000px",
                        left: "-10000px",
                        right: "auto",
                        bottom: "auto"
                    })
                }
                this._$wrapper.append(this._$panelContentWrapper)
            },
            _refreshOpenedStateModeClass: function(prevOpenedStateMode) {
                if (prevOpenedStateMode) {
                    this.$element().removeClass(DRAWER_CLASS + "-" + prevOpenedStateMode)
                }
                this.$element().addClass(DRAWER_CLASS + "-" + this.option("openedStateMode"))
            },
            _refreshPositionClass: function(prevPosition) {
                if (prevPosition) {
                    this.$element().removeClass(DRAWER_CLASS + "-" + prevPosition)
                }
                this.$element().addClass(DRAWER_CLASS + "-" + this.calcTargetPosition())
            },
            _refreshWrapperChildrenOrder: function() {
                var position = this.calcTargetPosition();
                if (this._strategy.isViewContentFirst(position, this.option("rtlEnabled"))) {
                    this._$wrapper.prepend(this._$viewContentWrapper)
                } else {
                    this._$wrapper.prepend(this._$panelContentWrapper)
                }
            },
            _refreshRevealModeClass: function(prevRevealMode) {
                if (prevRevealMode) {
                    this.$element().removeClass(DRAWER_CLASS + "-" + prevRevealMode)
                }
                this.$element().addClass(DRAWER_CLASS + "-" + this.option("revealMode"))
            },
            _renderViewContent: function() {
                var contentTemplateOption = this.option("contentTemplate");
                var contentTemplate = this._getTemplate(contentTemplateOption);
                if (contentTemplate) {
                    var $viewTemplate = contentTemplate.render({
                        container: this.viewContent(),
                        noModel: true,
                        transclude: this._templateManager.anonymousTemplateName === contentTemplateOption
                    });
                    if ($viewTemplate.hasClass("ng-scope")) {
                        (0, _renderer.default)(this._$viewContentWrapper).children().not(".".concat(DRAWER_SHADER_CLASS)).replaceWith($viewTemplate)
                    }
                }
            },
            _renderShader: function() {
                this._$shader = this._$shader || (0, _renderer.default)("<div>").addClass(DRAWER_SHADER_CLASS);
                this._$shader.appendTo(this.viewContent());
                this._toggleShaderVisibility(this.option("opened"))
            },
            _initSize: function() {
                this._initMinMaxSize()
            },
            _initMinMaxSize: function() {
                var realPanelSize = this.isHorizontalDirection() ? this.getRealPanelWidth() : this.getRealPanelHeight();
                this._maxSize = this.option("maxSize") || realPanelSize;
                this._minSize = this.option("minSize") || 0
            },
            calcTargetPosition: function() {
                var position = this.option("position");
                var rtl = this.option("rtlEnabled");
                var result = position;
                if ("before" === position) {
                    result = rtl ? "right" : "left"
                } else {
                    if ("after" === position) {
                        result = rtl ? "left" : "right"
                    }
                }
                return result
            },
            getOverlayTarget: function() {
                return this._options.silent("target") || this._$wrapper
            },
            getOverlay: function() {
                return this._overlay
            },
            getMaxSize: function() {
                return this._maxSize
            },
            getMinSize: function() {
                return this._minSize
            },
            getRealPanelWidth: function() {
                if ((0, _window.hasWindow)()) {
                    if ((0, _type.isDefined)(this.option("templateSize"))) {
                        return this.option("templateSize")
                    } else {
                        return (0, _position.getBoundingRect)(this._getPanelTemplateElement()).width
                    }
                } else {
                    return 0
                }
            },
            getRealPanelHeight: function() {
                if ((0, _window.hasWindow)()) {
                    if ((0, _type.isDefined)(this.option("templateSize"))) {
                        return this.option("templateSize")
                    } else {
                        return (0, _position.getBoundingRect)(this._getPanelTemplateElement()).height
                    }
                } else {
                    return 0
                }
            },
            _getPanelTemplateElement: function() {
                var $panelContent = this._strategy.getPanelContent();
                var $result = $panelContent;
                if ($panelContent.children().length) {
                    $result = $panelContent.children().eq(0);
                    if ($panelContent.hasClass("dx-overlay-content") && $result.hasClass("dx-template-wrapper") && $result.children().length) {
                        $result = $result.children().eq(0)
                    }
                }
                return $result.get(0)
            },
            getElementHeight: function($element) {
                var $children = $element.children();
                return $children.length ? (0, _position.getBoundingRect)($children.eq(0).get(0)).height : (0, _position.getBoundingRect)($element.get(0)).height
            },
            isHorizontalDirection: function() {
                var position = this.calcTargetPosition();
                return "left" === position || "right" === position
            },
            stopAnimations: function(jumpToEnd) {
                _fx.default.stop(this._$shader, jumpToEnd);
                _fx.default.stop((0, _renderer.default)(this.content()), jumpToEnd);
                _fx.default.stop((0, _renderer.default)(this.viewContent()), jumpToEnd);
                var overlay = this.getOverlay();
                if (overlay) {
                    _fx.default.stop((0, _renderer.default)(overlay.$content()), jumpToEnd)
                }
            },
            setZIndex: function(zIndex) {
                this._$shader.css("zIndex", zIndex - 1);
                this._$panelContentWrapper.css("zIndex", zIndex)
            },
            resizeContent: function() {
                this.resizeViewContent
            },
            resizeViewContent: function() {
                (0, _visibility_change.triggerResizeEvent)(this.viewContent())
            },
            _isInvertedPosition: function() {
                var position = this.calcTargetPosition();
                return "right" === position || "bottom" === position
            },
            _renderPosition: function(isDrawerOpened, disableAnimation, jumpToEnd) {
                this.stopAnimations(jumpToEnd);
                if (!(0, _window.hasWindow)()) {
                    return
                }(0, _renderer.default)(this.viewContent()).css("paddingLeft", 0);
                (0, _renderer.default)(this.viewContent()).css("paddingRight", 0);
                (0, _renderer.default)(this.viewContent()).css("paddingTop", 0);
                (0, _renderer.default)(this.viewContent()).css("paddingBottom", 0);
                var animationEnabled = this.option("animationEnabled");
                if (true === disableAnimation) {
                    animationEnabled = false
                }
                if (isDrawerOpened) {
                    this._toggleShaderVisibility(isDrawerOpened)
                }
                this._strategy.renderPosition(animationEnabled, this.option("animationDuration"))
            },
            _animationCompleteHandler: function() {
                this.resizeViewContent();
                if (this._whenAnimationCompleted) {
                    this._whenAnimationCompleted.resolve()
                }
            },
            _getPositionCorrection: function() {
                return this._isInvertedPosition() ? -1 : 1
            },
            _dispose: function() {
                _uiDrawer.animation.complete((0, _renderer.default)(this.viewContent()));
                this.callBase()
            },
            _visibilityChanged: function(visible) {
                if (visible) {
                    this._dimensionChanged()
                }
            },
            _dimensionChanged: function() {
                this._initMinMaxSize();
                this._strategy.refreshPanelElementSize("slide" === this.option("revealMode"));
                this._renderPosition(this.option("opened"), true)
            },
            _toggleShaderVisibility: function(visible) {
                if (this.option("shading")) {
                    this._$shader.toggleClass(INVISIBLE_STATE_CLASS, !visible);
                    this._$shader.css("visibility", visible ? "visible" : "hidden")
                } else {
                    this._$shader.toggleClass(INVISIBLE_STATE_CLASS, true)
                }
            },
            _toggleOpenedStateClass: function(opened) {
                this.$element().toggleClass(OPENED_STATE_CLASS, opened)
            },
            _refreshPanel: function() {
                var _this2 = this;
                (0, _renderer.default)(this.viewContent()).css("left", 0);
                (0, _renderer.default)(this.viewContent()).css("transform", "translate(0px, 0px)");
                (0, _renderer.default)(this.viewContent()).removeClass("dx-theme-background-color");
                this._removePanelContentWrapper();
                this._removeOverlay();
                this._renderPanelContentWrapper();
                this._refreshWrapperChildrenOrder();
                this._whenPanelContentRefreshed = new _deferred.Deferred;
                this._strategy.renderPanelContent(this._whenPanelContentRefreshed);
                this._strategy.onPanelContentRendered();
                if ((0, _window.hasWindow)()) {
                    this._whenPanelContentRefreshed.always(function() {
                        _this2._strategy.refreshPanelElementSize("slide" === _this2.option("revealMode"));
                        _this2._renderPosition(_this2.option("opened"), true, true);
                        _this2._removePanelManualPosition()
                    })
                }
            },
            _clean: function() {
                this._cleanFocusState();
                this._removePanelContentWrapper();
                this._removeOverlay()
            },
            _removePanelContentWrapper: function() {
                if (this._$panelContentWrapper) {
                    this._$panelContentWrapper.remove()
                }
            },
            _removeOverlay: function() {
                if (this._overlay) {
                    this._overlay.dispose();
                    delete this._overlay;
                    delete this._$panelContentWrapper
                }
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "width":
                        this.callBase(args);
                        this._dimensionChanged();
                        break;
                    case "opened":
                        this._renderPosition(this.option("opened"));
                        this._toggleOpenedStateClass(args.value);
                        break;
                    case "position":
                        this._refreshPositionClass(args.previousValue);
                        this._refreshWrapperChildrenOrder();
                        this._invalidate();
                        break;
                    case "contentTemplate":
                    case "template":
                        this._invalidate();
                        break;
                    case "openedStateMode":
                    case "target":
                        this._initStrategy();
                        this._refreshOpenedStateModeClass(args.previousValue);
                        this._refreshPanel();
                        break;
                    case "minSize":
                    case "maxSize":
                        this._initMinMaxSize();
                        this._renderPosition(this.option("opened"), true);
                        break;
                    case "revealMode":
                        this._refreshRevealModeClass(args.previousValue);
                        this._refreshPanel();
                        break;
                    case "shading":
                        this._toggleShaderVisibility(this.option("opened"));
                        break;
                    case "animationEnabled":
                    case "animationDuration":
                    case "closeOnOutsideClick":
                        break;
                    default:
                        this.callBase(args)
                }
            },
            content: function() {
                return (0, _element.getPublicElement)(this._$panelContentWrapper)
            },
            viewContent: function() {
                return (0, _element.getPublicElement)(this._$viewContentWrapper)
            },
            show: function() {
                return this.toggle(true)
            },
            hide: function() {
                return this.toggle(false)
            },
            toggle: function(opened) {
                var targetOpened = void 0 === opened ? !this.option("opened") : opened;
                this._whenAnimationCompleted = new _deferred.Deferred;
                this.option("opened", targetOpened);
                return this._whenAnimationCompleted.promise()
            }
        });
        (0, _component_registrator.default)("dxDrawer", Drawer);
        var _default = Drawer;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/drawer/ui.drawer.rendering.strategy.js ***!
      \****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _uiDrawer = __webpack_require__( /*! ./ui.drawer.animation */ 181);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DrawerStrategy = function() {
            function DrawerStrategy(drawer) {
                this._drawer = drawer
            }
            var _proto = DrawerStrategy.prototype;
            _proto.getDrawerInstance = function() {
                return this._drawer
            };
            _proto.renderPanelContent = function(whenPanelContentRendered) {
                var drawer = this.getDrawerInstance();
                var template = drawer._getTemplate(drawer.option("template"));
                if (template) {
                    template.render({
                        container: drawer.content(),
                        onRendered: function() {
                            whenPanelContentRendered.resolve()
                        }
                    })
                }
            };
            _proto.renderPosition = function(changePositionUsingFxAnimation, animationDuration) {
                var whenPositionAnimationCompleted = new _deferred.Deferred;
                var whenShaderAnimationCompleted = new _deferred.Deferred;
                var drawer = this.getDrawerInstance();
                if (changePositionUsingFxAnimation) {
                    _deferred.when.apply(_renderer.default, [whenPositionAnimationCompleted, whenShaderAnimationCompleted]).done(function() {
                        drawer._animationCompleteHandler()
                    })
                }
                this._internalRenderPosition(changePositionUsingFxAnimation, whenPositionAnimationCompleted);
                if (!changePositionUsingFxAnimation) {
                    drawer.resizeViewContent()
                }
                this.renderShaderVisibility(changePositionUsingFxAnimation, animationDuration, whenShaderAnimationCompleted)
            };
            _proto._getPanelOffset = function(isDrawerOpened) {
                var drawer = this.getDrawerInstance();
                var size = drawer.isHorizontalDirection() ? drawer.getRealPanelWidth() : drawer.getRealPanelHeight();
                if (isDrawerOpened) {
                    return -(size - drawer.getMaxSize())
                } else {
                    return -(size - drawer.getMinSize())
                }
            };
            _proto._getPanelSize = function(isDrawerOpened) {
                return isDrawerOpened ? this.getDrawerInstance().getMaxSize() : this.getDrawerInstance().getMinSize()
            };
            _proto.renderShaderVisibility = function(changePositionUsingFxAnimation, duration, whenAnimationCompleted) {
                var _this = this;
                var drawer = this.getDrawerInstance();
                var isShaderVisible = drawer.option("opened");
                var fadeConfig = isShaderVisible ? {
                    from: 0,
                    to: 1
                } : {
                    from: 1,
                    to: 0
                };
                if (changePositionUsingFxAnimation) {
                    _uiDrawer.animation.fade((0, _renderer.default)(drawer._$shader), fadeConfig, duration, function() {
                        _this._drawer._toggleShaderVisibility(isShaderVisible);
                        whenAnimationCompleted.resolve()
                    })
                } else {
                    drawer._toggleShaderVisibility(isShaderVisible);
                    drawer._$shader.css("opacity", fadeConfig.to)
                }
            };
            _proto.getPanelContent = function() {
                return (0, _renderer.default)(this.getDrawerInstance().content())
            };
            _proto.setPanelSize = function(calcFromRealPanelSize) {
                this.refreshPanelElementSize(calcFromRealPanelSize)
            };
            _proto.refreshPanelElementSize = function(calcFromRealPanelSize) {
                var drawer = this.getDrawerInstance();
                var panelSize = this._getPanelSize(drawer.option("opened"));
                if (drawer.isHorizontalDirection()) {
                    (0, _renderer.default)(drawer.content()).width(calcFromRealPanelSize ? drawer.getRealPanelWidth() : panelSize)
                } else {
                    (0, _renderer.default)(drawer.content()).height(calcFromRealPanelSize ? drawer.getRealPanelHeight() : panelSize)
                }
            };
            _proto.isViewContentFirst = function() {
                return false
            };
            _proto.onPanelContentRendered = function() {};
            return DrawerStrategy
        }();
        var _default = DrawerStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/overlay/utils.js ***!
      \******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getElementMaxHeightByWindow = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var WINDOW_HEIGHT_PERCENT = .9;
        var getElementMaxHeightByWindow = function($element, startLocation) {
            var $window = (0, _renderer.default)((0, _window.getWindow)());
            var _$element$offset = $element.offset(),
                elementOffset = _$element$offset.top;
            var actualOffset;
            if ((0, _type.isNumeric)(startLocation)) {
                if (startLocation < elementOffset) {
                    return elementOffset - startLocation
                } else {
                    actualOffset = $window.innerHeight() - startLocation + $window.scrollTop()
                }
            } else {
                var offsetTop = elementOffset - $window.scrollTop();
                var offsetBottom = $window.innerHeight() - offsetTop - $element.outerHeight();
                actualOffset = Math.max(offsetTop, offsetBottom)
            }
            return actualOffset * WINDOW_HEIGHT_PERCENT
        };
        exports.getElementMaxHeightByWindow = getElementMaxHeightByWindow
    },
    /*!******************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/file_uploader.js ***!
      \******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _guid = _interopRequireDefault(__webpack_require__( /*! ../core/guid */ 36));
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ../core/utils/callbacks */ 27));
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _array = __webpack_require__( /*! ../core/utils/array */ 12);
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);
        var _ajax = _interopRequireDefault(__webpack_require__( /*! ../core/utils/ajax */ 79));
        var _editor = _interopRequireDefault(__webpack_require__( /*! ./editor/editor */ 52));
        var _button = _interopRequireDefault(__webpack_require__( /*! ./button */ 37));
        var _progress_bar = _interopRequireDefault(__webpack_require__( /*! ./progress_bar */ 282));
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../core/utils/browser */ 23));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../core/devices */ 13));
        var _index = __webpack_require__( /*! ../events/utils/index */ 8);
        var _click = __webpack_require__( /*! ../events/click */ 21);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../localization/message */ 10));
        var _themes = __webpack_require__( /*! ./themes */ 34);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var window = (0, _window.getWindow)();
        var FILEUPLOADER_CLASS = "dx-fileuploader";
        var FILEUPLOADER_EMPTY_CLASS = "dx-fileuploader-empty";
        var FILEUPLOADER_SHOW_FILE_LIST_CLASS = "dx-fileuploader-show-file-list";
        var FILEUPLOADER_DRAGOVER_CLASS = "dx-fileuploader-dragover";
        var FILEUPLOADER_WRAPPER_CLASS = "dx-fileuploader-wrapper";
        var FILEUPLOADER_CONTAINER_CLASS = "dx-fileuploader-container";
        var FILEUPLOADER_CONTENT_CLASS = "dx-fileuploader-content";
        var FILEUPLOADER_INPUT_WRAPPER_CLASS = "dx-fileuploader-input-wrapper";
        var FILEUPLOADER_INPUT_CONTAINER_CLASS = "dx-fileuploader-input-container";
        var FILEUPLOADER_INPUT_LABEL_CLASS = "dx-fileuploader-input-label";
        var FILEUPLOADER_INPUT_CLASS = "dx-fileuploader-input";
        var FILEUPLOADER_FILES_CONTAINER_CLASS = "dx-fileuploader-files-container";
        var FILEUPLOADER_FILE_CONTAINER_CLASS = "dx-fileuploader-file-container";
        var FILEUPLOADER_FILE_INFO_CLASS = "dx-fileuploader-file-info";
        var FILEUPLOADER_FILE_STATUS_MESSAGE_CLASS = "dx-fileuploader-file-status-message";
        var FILEUPLOADER_FILE_CLASS = "dx-fileuploader-file";
        var FILEUPLOADER_FILE_NAME_CLASS = "dx-fileuploader-file-name";
        var FILEUPLOADER_FILE_SIZE_CLASS = "dx-fileuploader-file-size";
        var FILEUPLOADER_BUTTON_CLASS = "dx-fileuploader-button";
        var FILEUPLOADER_BUTTON_CONTAINER_CLASS = "dx-fileuploader-button-container";
        var FILEUPLOADER_CANCEL_BUTTON_CLASS = "dx-fileuploader-cancel-button";
        var FILEUPLOADER_UPLOAD_BUTTON_CLASS = "dx-fileuploader-upload-button";
        var FILEUPLOADER_INVALID_CLASS = "dx-fileuploader-invalid";
        var FILEUPLOADER_AFTER_LOAD_DELAY = 400;
        var FILEUPLOADER_CHUNK_META_DATA_NAME = "chunkMetadata";
        var renderFileUploaderInput = function() {
            return (0, _renderer.default)("<input>").attr("type", "file")
        };
        var isFormDataSupported = function() {
            return !!window.FormData
        };
        var FileUploader = function(_Editor) {
            _inheritsLoose(FileUploader, _Editor);

            function FileUploader() {
                return _Editor.apply(this, arguments) || this
            }
            var _proto = FileUploader.prototype;
            _proto._supportedKeys = function() {
                var _this = this;
                var click = function(e) {
                    e.preventDefault();
                    var $selectButton = _this._selectButton.$element();
                    _events_engine.default.trigger($selectButton, _click.name)
                };
                return (0, _extend.extend)(_Editor.prototype._supportedKeys.call(this), {
                    space: click,
                    enter: click
                })
            };
            _proto._setOptionsByReference = function() {
                _Editor.prototype._setOptionsByReference.call(this);
                (0, _extend.extend)(this._optionsByReference, {
                    value: true
                })
            };
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_Editor.prototype._getDefaultOptions.call(this), {
                    chunkSize: 0,
                    value: [],
                    selectButtonText: _message.default.format("dxFileUploader-selectFile"),
                    uploadButtonText: _message.default.format("dxFileUploader-upload"),
                    labelText: _message.default.format("dxFileUploader-dropFile"),
                    name: "files[]",
                    multiple: false,
                    accept: "",
                    uploadUrl: "/",
                    allowCanceling: true,
                    showFileList: true,
                    progress: 0,
                    dialogTrigger: void 0,
                    dropZone: void 0,
                    readyToUploadMessage: _message.default.format("dxFileUploader-readyToUpload"),
                    uploadedMessage: _message.default.format("dxFileUploader-uploaded"),
                    uploadFailedMessage: _message.default.format("dxFileUploader-uploadFailedMessage"),
                    uploadAbortedMessage: _message.default.format("dxFileUploader-uploadAbortedMessage"),
                    uploadMode: "instantly",
                    uploadMethod: "POST",
                    uploadHeaders: {},
                    uploadCustomData: {},
                    onBeforeSend: null,
                    onUploadStarted: null,
                    onUploaded: null,
                    onFilesUploaded: null,
                    onProgress: null,
                    onUploadError: null,
                    onUploadAborted: null,
                    onDropZoneEnter: null,
                    onDropZoneLeave: null,
                    allowedFileExtensions: [],
                    maxFileSize: 0,
                    minFileSize: 0,
                    inputAttr: {},
                    invalidFileExtensionMessage: _message.default.format("dxFileUploader-invalidFileExtension"),
                    invalidMaxFileSizeMessage: _message.default.format("dxFileUploader-invalidMaxFileSize"),
                    invalidMinFileSizeMessage: _message.default.format("dxFileUploader-invalidMinFileSize"),
                    extendSelection: true,
                    validationMessageMode: "always",
                    uploadFile: null,
                    uploadChunk: null,
                    abortUpload: null,
                    validationMessageOffset: {
                        h: 0,
                        v: 0
                    },
                    useNativeInputClick: false,
                    useDragOver: true,
                    nativeDropSupported: true,
                    _uploadButtonType: "normal"
                })
            };
            _proto._defaultOptionsRules = function() {
                return _Editor.prototype._defaultOptionsRules.call(this).concat([{
                    device: function() {
                        return "desktop" === _devices.default.real().deviceType && !_devices.default.isSimulator()
                    },
                    options: {
                        focusStateEnabled: true
                    }
                }, {
                    device: [{
                        platform: "android"
                    }],
                    options: {
                        validationMessageOffset: {
                            v: 0
                        }
                    }
                }, {
                    device: function() {
                        return "desktop" !== _devices.default.real().deviceType
                    },
                    options: {
                        useDragOver: false
                    }
                }, {
                    device: function() {
                        return !isFormDataSupported()
                    },
                    options: {
                        uploadMode: "useForm"
                    }
                }, {
                    device: function() {
                        return _browser.default.msie || "desktop" !== _devices.default.real().deviceType
                    },
                    options: {
                        nativeDropSupported: false
                    }
                }, {
                    device: function() {
                        return (0, _themes.isMaterial)()
                    },
                    options: {
                        _uploadButtonType: "default"
                    }
                }])
            };
            _proto._initOptions = function(options) {
                var isLabelTextDefined = "labelText" in options;
                _Editor.prototype._initOptions.call(this, options);
                if (!isLabelTextDefined && !this._shouldDragOverBeRendered()) {
                    this.option("labelText", "")
                }
            };
            _proto._init = function() {
                _Editor.prototype._init.call(this);
                this._initFileInput();
                this._initLabel();
                this._setUploadStrategy();
                this._createFiles();
                this._createBeforeSendAction();
                this._createUploadStartedAction();
                this._createUploadedAction();
                this._createFilesUploadedAction();
                this._createProgressAction();
                this._createUploadErrorAction();
                this._createUploadAbortedAction();
                this._createDropZoneEnterAction();
                this._createDropZoneLeaveAction()
            };
            _proto._setUploadStrategy = function() {
                var strategy = null;
                if (this.option("chunkSize") > 0) {
                    var uploadChunk = this.option("uploadChunk");
                    strategy = uploadChunk && (0, _type.isFunction)(uploadChunk) ? new CustomChunksFileUploadStrategy(this) : new DefaultChunksFileUploadStrategy(this)
                } else {
                    var uploadFile = this.option("uploadFile");
                    strategy = uploadFile && (0, _type.isFunction)(uploadFile) ? new CustomWholeFileUploadStrategy(this) : new DefaultWholeFileUploadStrategy(this)
                }
                this._uploadStrategy = strategy
            };
            _proto._initFileInput = function() {
                var _this2 = this;
                this._isCustomClickEvent = false;
                if (!this._$fileInput) {
                    this._$fileInput = renderFileUploaderInput();
                    _events_engine.default.on(this._$fileInput, "change", this._inputChangeHandler.bind(this));
                    _events_engine.default.on(this._$fileInput, "click", function(e) {
                        e.stopPropagation();
                        return _this2.option("useNativeInputClick") || _this2._isCustomClickEvent
                    })
                }
                this._$fileInput.prop({
                    multiple: this.option("multiple"),
                    accept: this.option("accept"),
                    tabIndex: -1
                })
            };
            _proto._inputChangeHandler = function() {
                if (this._doPreventInputChange) {
                    return
                }
                var fileName = this._$fileInput.val().replace(/^.*\\/, "");
                var files = this._$fileInput.prop("files");
                if (files && !files.length && "useForm" !== this.option("uploadMode")) {
                    return
                }
                var value = files ? this._getFiles(files) : [{
                    name: fileName
                }];
                this._changeValue(value);
                if ("instantly" === this.option("uploadMode")) {
                    this._uploadFiles()
                }
            };
            _proto._shouldFileListBeExtended = function() {
                return "useForm" !== this.option("uploadMode") && this.option("extendSelection") && this.option("multiple")
            };
            _proto._removeDuplicates = function(files, value) {
                var result = [];
                for (var i = 0; i < value.length; i++) {
                    if (!this._isFileInArray(files, value[i])) {
                        result.push(value[i])
                    }
                }
                return result
            };
            _proto._isFileInArray = function(files, file) {
                for (var i = 0; i < files.length; i++) {
                    var item = files[i];
                    if (item.size === file.size && item.name === file.name) {
                        return true
                    }
                }
                return false
            };
            _proto._changeValue = function(value) {
                var files = this._shouldFileListBeExtended() ? this.option("value").slice() : [];
                if ("instantly" !== this.option("uploadMode")) {
                    value = this._removeDuplicates(files, value)
                }
                this.option("value", files.concat(value))
            };
            _proto._getFiles = function(fileList) {
                var values = [];
                (0, _iterator.each)(fileList, function(_, value) {
                    return values.push(value)
                });
                return values
            };
            _proto._getFile = function(fileData) {
                var targetFileValue = (0, _type.isNumeric)(fileData) ? this.option("value")[fileData] : fileData;
                return this._files.filter(function(file) {
                    return file.value === targetFileValue
                })[0]
            };
            _proto._initLabel = function() {
                if (!this._$inputLabel) {
                    this._$inputLabel = (0, _renderer.default)("<div>")
                }
                this._updateInputLabelText()
            };
            _proto._updateInputLabelText = function() {
                var correctedValue = this._isInteractionDisabled() ? "" : this.option("labelText");
                this._$inputLabel.text(correctedValue)
            };
            _proto._focusTarget = function() {
                return this.$element().find("." + FILEUPLOADER_BUTTON_CLASS)
            };
            _proto._getSubmitElement = function() {
                return this._$fileInput
            };
            _proto._initMarkup = function() {
                _Editor.prototype._initMarkup.call(this);
                this.$element().addClass(FILEUPLOADER_CLASS);
                this._renderWrapper();
                this._renderInputWrapper();
                this._renderSelectButton();
                this._renderInputContainer();
                this._renderUploadButton();
                this._preventRecreatingFiles = true
            };
            _proto._render = function() {
                this._preventRecreatingFiles = false;
                this._attachDragEventHandlers(this._$inputWrapper);
                this._attachDragEventHandlers(this.option("dropZone"));
                this._renderFiles();
                _Editor.prototype._render.call(this)
            };
            _proto._createFileProgressBar = function(file) {
                file.progressBar = this._createProgressBar(file.value.size);
                file.progressBar.$element().appendTo(file.$file);
                this._initStatusMessage(file);
                this._ensureCancelButtonInitialized(file)
            };
            _proto._setStatusMessage = function(file, message) {
                var _this3 = this;
                setTimeout(function() {
                    if (_this3.option("showFileList")) {
                        if (file.$statusMessage) {
                            file.$statusMessage.text(message);
                            file.$statusMessage.css("display", "");
                            file.progressBar.$element().remove()
                        }
                    }
                }, FILEUPLOADER_AFTER_LOAD_DELAY)
            };
            _proto._getUploadAbortedStatusMessage = function() {
                return "instantly" === this.option("uploadMode") ? this.option("uploadAbortedMessage") : this.option("readyToUploadMessage")
            };
            _proto._createFiles = function() {
                var _this4 = this;
                var value = this.option("value");
                if (this._files && (0 === value.length || !this._shouldFileListBeExtended())) {
                    this._preventFilesUploading(this._files);
                    this._files = null
                }
                if (!this._files) {
                    this._files = []
                }(0, _iterator.each)(value.slice(this._files.length), function(_, value) {
                    var file = _this4._createFile(value);
                    _this4._validateFile(file);
                    _this4._files.push(file)
                })
            };
            _proto._preventFilesUploading = function(files) {
                var _this5 = this;
                files.forEach(function(file) {
                    return _this5._uploadStrategy.abortUpload(file)
                })
            };
            _proto._validateFile = function(file) {
                file.isValidFileExtension = this._validateFileExtension(file);
                file.isValidMinSize = this._validateMinFileSize(file);
                file.isValidMaxSize = this._validateMaxFileSize(file)
            };
            _proto._validateFileExtension = function(file) {
                var allowedExtensions = this.option("allowedFileExtensions");
                var fileExtension = file.value.name.substring(file.value.name.lastIndexOf(".")).toLowerCase();
                if (0 === allowedExtensions.length) {
                    return true
                }
                for (var i = 0; i < allowedExtensions.length; i++) {
                    if (fileExtension === allowedExtensions[i].toLowerCase()) {
                        return true
                    }
                }
                return false
            };
            _proto._validateMaxFileSize = function(file) {
                var fileSize = file.value.size;
                var maxFileSize = this.option("maxFileSize");
                return maxFileSize > 0 ? fileSize <= maxFileSize : true
            };
            _proto._validateMinFileSize = function(file) {
                var fileSize = file.value.size;
                var minFileSize = this.option("minFileSize");
                return minFileSize > 0 ? fileSize >= minFileSize : true
            };
            _proto._createBeforeSendAction = function() {
                this._beforeSendAction = this._createActionByOption("onBeforeSend", {
                    excludeValidators: ["readOnly"]
                })
            };
            _proto._createUploadStartedAction = function() {
                this._uploadStartedAction = this._createActionByOption("onUploadStarted", {
                    excludeValidators: ["readOnly"]
                })
            };
            _proto._createUploadedAction = function() {
                this._uploadedAction = this._createActionByOption("onUploaded", {
                    excludeValidators: ["readOnly"]
                })
            };
            _proto._createFilesUploadedAction = function() {
                this._filesUploadedAction = this._createActionByOption("onFilesUploaded", {
                    excludeValidators: ["readOnly"]
                })
            };
            _proto._createProgressAction = function() {
                this._progressAction = this._createActionByOption("onProgress", {
                    excludeValidators: ["readOnly"]
                })
            };
            _proto._createUploadAbortedAction = function() {
                this._uploadAbortedAction = this._createActionByOption("onUploadAborted", {
                    excludeValidators: ["readOnly"]
                })
            };
            _proto._createUploadErrorAction = function() {
                this._uploadErrorAction = this._createActionByOption("onUploadError", {
                    excludeValidators: ["readOnly"]
                })
            };
            _proto._createDropZoneEnterAction = function() {
                this._dropZoneEnterAction = this._createActionByOption("onDropZoneEnter")
            };
            _proto._createDropZoneLeaveAction = function() {
                this._dropZoneLeaveAction = this._createActionByOption("onDropZoneLeave")
            };
            _proto._createFile = function(value) {
                return {
                    value: value,
                    loadedSize: 0,
                    onProgress: (0, _callbacks.default)(),
                    onAbort: (0, _callbacks.default)(),
                    onLoad: (0, _callbacks.default)(),
                    onError: (0, _callbacks.default)(),
                    onLoadStart: (0, _callbacks.default)(),
                    isValidFileExtension: true,
                    isValidMaxSize: true,
                    isValidMinSize: true,
                    isValid: function() {
                        return this.isValidFileExtension && this.isValidMaxSize && this.isValidMinSize
                    },
                    isInitialized: false
                }
            };
            _proto._resetFileState = function(file) {
                file.isAborted = false;
                file.uploadStarted = false;
                file.isStartLoad = false;
                file.loadedSize = 0;
                file.chunksData = void 0;
                file.request = void 0
            };
            _proto._renderFiles = function() {
                var _this$_validationMess, _this6 = this;
                var value = this.option("value");
                if (!this._$filesContainer) {
                    this._$filesContainer = (0, _renderer.default)("<div>").addClass(FILEUPLOADER_FILES_CONTAINER_CLASS).appendTo(this._$content)
                } else {
                    if (!this._shouldFileListBeExtended() || 0 === value.length) {
                        this._$filesContainer.empty()
                    }
                }
                var showFileList = this.option("showFileList");
                if (showFileList) {
                    (0, _iterator.each)(this._files, function(_, file) {
                        if (!file.$file) {
                            _this6._renderFile(file)
                        }
                    })
                }
                this.$element().toggleClass(FILEUPLOADER_SHOW_FILE_LIST_CLASS, showFileList);
                this._toggleFileUploaderEmptyClassName();
                this._updateFileNameMaxWidth();
                null === (_this$_validationMess = this._validationMessage) || void 0 === _this$_validationMess ? void 0 : _this$_validationMess.repaint()
            };
            _proto._renderFile = function(file) {
                var value = file.value;
                var $fileContainer = (0, _renderer.default)("<div>").addClass(FILEUPLOADER_FILE_CONTAINER_CLASS).appendTo(this._$filesContainer);
                this._renderFileButtons(file, $fileContainer);
                file.$file = (0, _renderer.default)("<div>").addClass(FILEUPLOADER_FILE_CLASS).appendTo($fileContainer);
                var $fileInfo = (0, _renderer.default)("<div>").addClass(FILEUPLOADER_FILE_INFO_CLASS).appendTo(file.$file);
                file.$statusMessage = (0, _renderer.default)("<div>").addClass(FILEUPLOADER_FILE_STATUS_MESSAGE_CLASS).appendTo(file.$file);
                (0, _renderer.default)("<div>").addClass(FILEUPLOADER_FILE_NAME_CLASS).text(value.name).appendTo($fileInfo);
                if ((0, _type.isDefined)(value.size)) {
                    (0, _renderer.default)("<div>").addClass(FILEUPLOADER_FILE_SIZE_CLASS).text(this._getFileSize(value.size)).appendTo($fileInfo)
                }
                if (file.isValid()) {
                    file.$statusMessage.text(this.option("readyToUploadMessage"))
                } else {
                    if (!file.isValidFileExtension) {
                        file.$statusMessage.append(this._createValidationElement("invalidFileExtensionMessage"))
                    }
                    if (!file.isValidMaxSize) {
                        file.$statusMessage.append(this._createValidationElement("invalidMaxFileSizeMessage"))
                    }
                    if (!file.isValidMinSize) {
                        file.$statusMessage.append(this._createValidationElement("invalidMinFileSizeMessage"))
                    }
                    $fileContainer.addClass(FILEUPLOADER_INVALID_CLASS)
                }
            };
            _proto._createValidationElement = function(key) {
                return (0, _renderer.default)("<span>").text(this.option(key))
            };
            _proto._updateFileNameMaxWidth = function() {
                var cancelButtonsCount = this.option("allowCanceling") && "useForm" !== this.option("uploadMode") ? 1 : 0;
                var uploadButtonsCount = "useButtons" === this.option("uploadMode") ? 1 : 0;
                var filesContainerWidth = this._$filesContainer.find("." + FILEUPLOADER_FILE_CONTAINER_CLASS).first().width() || this._$filesContainer.width();
                var $buttonContainer = this._$filesContainer.find("." + FILEUPLOADER_BUTTON_CONTAINER_CLASS).eq(0);
                var buttonsWidth = $buttonContainer.width() * (cancelButtonsCount + uploadButtonsCount);
                var $fileSize = this._$filesContainer.find("." + FILEUPLOADER_FILE_SIZE_CLASS).eq(0);
                var prevFileSize = $fileSize.text();
                $fileSize.text("1000 Mb");
                var fileSizeWidth = $fileSize.width();
                $fileSize.text(prevFileSize);
                this._$filesContainer.find("." + FILEUPLOADER_FILE_NAME_CLASS).css("maxWidth", filesContainerWidth - buttonsWidth - fileSizeWidth)
            };
            _proto._renderFileButtons = function(file, $container) {
                var $cancelButton = this._getCancelButton(file);
                $cancelButton && $container.append($cancelButton);
                var $uploadButton = this._getUploadButton(file);
                $uploadButton && $container.append($uploadButton)
            };
            _proto._getCancelButton = function(file) {
                var _this7 = this;
                if ("useForm" === this.option("uploadMode")) {
                    return null
                }
                file.cancelButton = this._createComponent((0, _renderer.default)("<div>").addClass(FILEUPLOADER_BUTTON_CLASS + " " + FILEUPLOADER_CANCEL_BUTTON_CLASS), _button.default, {
                    onClick: function() {
                        return _this7._removeFile(file)
                    },
                    icon: "close",
                    visible: this.option("allowCanceling"),
                    disabled: this.option("readOnly"),
                    integrationOptions: {}
                });
                return (0, _renderer.default)("<div>").addClass(FILEUPLOADER_BUTTON_CONTAINER_CLASS).append(file.cancelButton.$element())
            };
            _proto._getUploadButton = function(file) {
                var _this8 = this;
                if (!file.isValid() || "useButtons" !== this.option("uploadMode")) {
                    return null
                }
                file.uploadButton = this._createComponent((0, _renderer.default)("<div>").addClass(FILEUPLOADER_BUTTON_CLASS + " " + FILEUPLOADER_UPLOAD_BUTTON_CLASS), _button.default, {
                    onClick: function() {
                        return _this8._uploadFile(file)
                    },
                    icon: "upload"
                });
                file.onLoadStart.add(function() {
                    return file.uploadButton.option({
                        visible: false,
                        disabled: true
                    })
                });
                file.onAbort.add(function() {
                    return file.uploadButton.option({
                        visible: true,
                        disabled: false
                    })
                });
                return (0, _renderer.default)("<div>").addClass(FILEUPLOADER_BUTTON_CONTAINER_CLASS).append(file.uploadButton.$element())
            };
            _proto._removeFile = function(file) {
                var _file$$file;
                null === (_file$$file = file.$file) || void 0 === _file$$file ? void 0 : _file$$file.parent().remove();
                this._files.splice((0, _array.inArray)(file, this._files), 1);
                var value = this.option("value").slice();
                value.splice((0, _array.inArray)(file.value, value), 1);
                this._preventRecreatingFiles = true;
                this.option("value", value);
                this._preventRecreatingFiles = false;
                this._toggleFileUploaderEmptyClassName();
                this._doPreventInputChange = true;
                this._$fileInput.val("");
                this._doPreventInputChange = false
            };
            _proto.removeFile = function(fileData) {
                if ("useForm" === this.option("uploadMode") || !(0, _type.isDefined)(fileData)) {
                    return
                }
                var file = this._getFile(fileData);
                if (file) {
                    if (file.uploadStarted) {
                        this._preventFilesUploading([file])
                    }
                    this._removeFile(file)
                }
            };
            _proto._toggleFileUploaderEmptyClassName = function() {
                this.$element().toggleClass(FILEUPLOADER_EMPTY_CLASS, !this._files.length || this._hasInvalidFile(this._files))
            };
            _proto._hasInvalidFile = function(files) {
                for (var i = 0; i < files.length; i++) {
                    if (!files[i].isValid()) {
                        return true
                    }
                }
                return false
            };
            _proto._getFileSize = function(size) {
                var i = 0;
                var labels = [_message.default.format("dxFileUploader-bytes"), _message.default.format("dxFileUploader-kb"), _message.default.format("dxFileUploader-Mb"), _message.default.format("dxFileUploader-Gb")];
                var count = labels.length - 1;
                while (i < count && size >= 1024) {
                    size /= 1024;
                    i++
                }
                return Math.round(size) + " " + labels[i]
            };
            _proto._renderSelectButton = function() {
                var $button = (0, _renderer.default)("<div>").addClass(FILEUPLOADER_BUTTON_CLASS).appendTo(this._$inputWrapper);
                this._selectButton = this._createComponent($button, _button.default, {
                    text: this.option("selectButtonText"),
                    focusStateEnabled: false,
                    integrationOptions: {},
                    disabled: this.option("readOnly")
                });
                this._selectFileDialogHandler = this._selectButtonClickHandler.bind(this);
                if ("desktop" === _devices.default.real().deviceType) {
                    this._selectButton.option("onClick", this._selectFileDialogHandler)
                } else {
                    this._attachSelectFileDialogHandler(this._selectButton.$element())
                }
                this._attachSelectFileDialogHandler(this.option("dialogTrigger"))
            };
            _proto._selectButtonClickHandler = function() {
                if (this.option("useNativeInputClick")) {
                    return
                }
                if (this._isInteractionDisabled()) {
                    return false
                }
                this._isCustomClickEvent = true;
                _events_engine.default.trigger(this._$fileInput, "click");
                this._isCustomClickEvent = false
            };
            _proto._attachSelectFileDialogHandler = function(target) {
                if (!(0, _type.isDefined)(target)) {
                    return
                }
                this._detachSelectFileDialogHandler(target);
                _events_engine.default.on((0, _renderer.default)(target), "click", this._selectFileDialogHandler)
            };
            _proto._detachSelectFileDialogHandler = function(target) {
                if (!(0, _type.isDefined)(target)) {
                    return
                }
                _events_engine.default.off((0, _renderer.default)(target), "click", this._selectFileDialogHandler)
            };
            _proto._renderUploadButton = function() {
                if ("useButtons" !== this.option("uploadMode")) {
                    return
                }
                var $uploadButton = (0, _renderer.default)("<div>").addClass(FILEUPLOADER_BUTTON_CLASS).addClass(FILEUPLOADER_UPLOAD_BUTTON_CLASS).appendTo(this._$content);
                this._uploadButton = this._createComponent($uploadButton, _button.default, {
                    text: this.option("uploadButtonText"),
                    onClick: this._uploadButtonClickHandler.bind(this),
                    type: this.option("_uploadButtonType"),
                    integrationOptions: {}
                })
            };
            _proto._uploadButtonClickHandler = function() {
                this._uploadFiles()
            };
            _proto._shouldDragOverBeRendered = function() {
                return !this.option("readOnly") && ("useForm" !== this.option("uploadMode") || this.option("nativeDropSupported"))
            };
            _proto._isInteractionDisabled = function() {
                return this.option("readOnly") || this.option("disabled")
            };
            _proto._renderInputContainer = function() {
                this._$inputContainer = (0, _renderer.default)("<div>").addClass(FILEUPLOADER_INPUT_CONTAINER_CLASS).appendTo(this._$inputWrapper);
                this._$fileInput.addClass(FILEUPLOADER_INPUT_CLASS);
                this._renderInput();
                var labelId = "dx-fileuploader-input-label-".concat(new _guid.default);
                this._$inputLabel.attr("id", labelId).addClass(FILEUPLOADER_INPUT_LABEL_CLASS).appendTo(this._$inputContainer);
                this.setAria("labelledby", labelId, this._$fileInput)
            };
            _proto._renderInput = function() {
                if (this.option("useNativeInputClick")) {
                    this._selectButton.option("template", this._selectButtonInputTemplate.bind(this))
                } else {
                    this._$fileInput.appendTo(this._$inputContainer);
                    this._selectButton.option("template", "content")
                }
                this._applyInputAttributes(this.option("inputAttr"))
            };
            _proto._selectButtonInputTemplate = function(data, content) {
                var $content = (0, _renderer.default)(content);
                var $text = (0, _renderer.default)("<span>").addClass("dx-button-text").text(data.text);
                $content.append($text).append(this._$fileInput);
                return $content
            };
            _proto._renderInputWrapper = function() {
                this._$inputWrapper = (0, _renderer.default)("<div>").addClass(FILEUPLOADER_INPUT_WRAPPER_CLASS).appendTo(this._$content)
            };
            _proto._detachDragEventHandlers = function(target) {
                if (!(0, _type.isDefined)(target)) {
                    return
                }
                _events_engine.default.off((0, _renderer.default)(target), (0, _index.addNamespace)("", this.NAME))
            };
            _proto._attachDragEventHandlers = function(target) {
                var isCustomTarget = target !== this._$inputWrapper;
                if (!(0, _type.isDefined)(target) || !this._shouldDragOverBeRendered()) {
                    return
                }
                this._detachDragEventHandlers(target);
                target = (0, _renderer.default)(target);
                this._dragEventsTargets = [];
                _events_engine.default.on(target, (0, _index.addNamespace)("dragenter", this.NAME), this._dragEnterHandler.bind(this, isCustomTarget));
                _events_engine.default.on(target, (0, _index.addNamespace)("dragover", this.NAME), this._dragOverHandler.bind(this));
                _events_engine.default.on(target, (0, _index.addNamespace)("dragleave", this.NAME), this._dragLeaveHandler.bind(this, isCustomTarget));
                _events_engine.default.on(target, (0, _index.addNamespace)("drop", this.NAME), this._dropHandler.bind(this, isCustomTarget))
            };
            _proto._applyInputAttributes = function(customAttributes) {
                this._$fileInput.attr(customAttributes)
            };
            _proto._useInputForDrop = function() {
                return this.option("nativeDropSupported") && "useForm" === this.option("uploadMode")
            };
            _proto._dragEnterHandler = function(isCustomTarget, e) {
                if (this.option("disabled")) {
                    return false
                }
                if (!this._useInputForDrop()) {
                    e.preventDefault()
                }
                this._tryToggleDropZoneActive(true, isCustomTarget, e);
                this._updateEventTargets(e)
            };
            _proto._dragOverHandler = function(e) {
                if (!this._useInputForDrop()) {
                    e.preventDefault()
                }
                e.originalEvent.dataTransfer.dropEffect = "copy"
            };
            _proto._dragLeaveHandler = function(isCustomTarget, e) {
                if (!this._useInputForDrop()) {
                    e.preventDefault()
                }
                this._updateEventTargets(e);
                this._tryToggleDropZoneActive(false, isCustomTarget, e)
            };
            _proto._updateEventTargets = function(e) {
                var targetIndex = this._dragEventsTargets.indexOf(e.target);
                var isTargetExists = targetIndex !== -1;
                if ("dragenter" === e.type) {
                    !isTargetExists && this._dragEventsTargets.push(e.target)
                } else {
                    isTargetExists && this._dragEventsTargets.splice(targetIndex, 1)
                }
            };
            _proto._tryToggleDropZoneActive = function(active, isCustom, event) {
                var classAction = active ? "addClass" : "removeClass";
                var mouseAction = active ? "_dropZoneEnterAction" : "_dropZoneLeaveAction";
                if (!this._dragEventsTargets.length) {
                    this[mouseAction]({
                        event: event,
                        dropZoneElement: event.currentTarget
                    });
                    if (!isCustom) {
                        this.$element()[classAction](FILEUPLOADER_DRAGOVER_CLASS)
                    }
                }
            };
            _proto._dropHandler = function(isCustomTarget, e) {
                this._dragEventsTargets = [];
                if (!isCustomTarget) {
                    this.$element().removeClass(FILEUPLOADER_DRAGOVER_CLASS)
                }
                if (this._useInputForDrop() || isCustomTarget && this._isInteractionDisabled()) {
                    return
                }
                e.preventDefault();
                var fileList = e.originalEvent.dataTransfer.files;
                var files = this._getFiles(fileList);
                if (!this.option("multiple") && files.length > 1) {
                    return
                }
                this._changeValue(this._filterFiles(files));
                if ("instantly" === this.option("uploadMode")) {
                    this._uploadFiles()
                }
            };
            _proto._handleAllFilesUploaded = function() {
                var areAllFilesLoaded = this._files.every(function(file) {
                    return !file.isValid() || file._isError || file._isLoaded || file.isAborted
                });
                if (areAllFilesLoaded) {
                    this._filesUploadedAction()
                }
            };
            _proto._filterFiles = function(files) {
                if (!files.length) {
                    return files
                }
                var accept = this.option("accept");
                if (!accept.length) {
                    return files
                }
                var result = [];
                var allowedTypes = this._getAllowedFileTypes(accept);
                for (var i = 0, n = files.length; i < n; i++) {
                    if (this._isFileTypeAllowed(files[i], allowedTypes)) {
                        result.push(files[i])
                    }
                }
                return result
            };
            _proto._getAllowedFileTypes = function(acceptSting) {
                if (!acceptSting.length) {
                    return []
                }
                return acceptSting.split(",").map(function(item) {
                    return item.trim()
                })
            };
            _proto._isFileTypeAllowed = function(file, allowedTypes) {
                for (var i = 0, n = allowedTypes.length; i < n; i++) {
                    var allowedType = allowedTypes[i];
                    if ("." === allowedType[0]) {
                        allowedType = allowedType.replace(".", "\\.");
                        if (file.name.match(new RegExp(allowedType + "$", "i"))) {
                            return true
                        }
                    } else {
                        allowedType = allowedType.replace(new RegExp("\\*", "g"), "");
                        if (file.type.match(new RegExp(allowedType, "i"))) {
                            return true
                        }
                    }
                }
                return false
            };
            _proto._renderWrapper = function() {
                var $wrapper = (0, _renderer.default)("<div>").addClass(FILEUPLOADER_WRAPPER_CLASS).appendTo(this.$element());
                var $container = (0, _renderer.default)("<div>").addClass(FILEUPLOADER_CONTAINER_CLASS).appendTo($wrapper);
                this._$content = (0, _renderer.default)("<div>").addClass(FILEUPLOADER_CONTENT_CLASS).appendTo($container)
            };
            _proto._clean = function() {
                this._$fileInput.detach();
                delete this._$filesContainer;
                if (this._files) {
                    this._files.forEach(function(file) {
                        file.$file = null;
                        file.$statusMessage = null
                    })
                }
                _Editor.prototype._clean.call(this)
            };
            _proto.abortUpload = function(fileData) {
                if ("useForm" === this.option("uploadMode")) {
                    return
                }
                if ((0, _type.isDefined)(fileData)) {
                    var file = this._getFile(fileData);
                    if (file) {
                        this._preventFilesUploading([file])
                    }
                } else {
                    this._preventFilesUploading(this._files)
                }
            };
            _proto.upload = function(fileData) {
                if ("useForm" === this.option("uploadMode")) {
                    return
                }
                if ((0, _type.isDefined)(fileData)) {
                    var file = this._getFile(fileData);
                    if (file && isFormDataSupported()) {
                        this._uploadFile(file)
                    }
                } else {
                    this._uploadFiles()
                }
            };
            _proto._uploadFiles = function() {
                var _this9 = this;
                if (isFormDataSupported()) {
                    (0, _iterator.each)(this._files, function(_, file) {
                        return _this9._uploadFile(file)
                    })
                }
            };
            _proto._uploadFile = function(file) {
                this._uploadStrategy.upload(file)
            };
            _proto._updateProgressBar = function(file, loadedFileData) {
                file.progressBar && file.progressBar.option({
                    value: loadedFileData.loaded,
                    showStatus: true
                });
                this._progressAction({
                    file: file.value,
                    segmentSize: loadedFileData.currentSegmentSize,
                    bytesLoaded: loadedFileData.loaded,
                    bytesTotal: loadedFileData.total,
                    event: loadedFileData.event,
                    request: file.request
                })
            };
            _proto._updateTotalProgress = function(totalFilesSize, totalLoadedFilesSize) {
                var progress = totalFilesSize ? this._getProgressValue(totalLoadedFilesSize / totalFilesSize) : 0;
                this.option("progress", progress);
                this._setLoadedSize(totalLoadedFilesSize)
            };
            _proto._getProgressValue = function(ratio) {
                return Math.floor(100 * ratio)
            };
            _proto._initStatusMessage = function(file) {
                file.$statusMessage.css("display", "none")
            };
            _proto._ensureCancelButtonInitialized = function(file) {
                var _this10 = this;
                if (file.isInitialized) {
                    return
                }
                file.cancelButton.option("onClick", function() {
                    _this10._preventFilesUploading([file]);
                    _this10._removeFile(file)
                });
                var hideCancelButton = function() {
                    setTimeout(function() {
                        file.cancelButton.option({
                            visible: false
                        })
                    }, FILEUPLOADER_AFTER_LOAD_DELAY)
                };
                file.onLoad.add(hideCancelButton);
                file.onError.add(hideCancelButton)
            };
            _proto._createProgressBar = function(fileSize) {
                var _this11 = this;
                return this._createComponent((0, _renderer.default)("<div>"), _progress_bar.default, {
                    value: void 0,
                    min: 0,
                    max: fileSize,
                    statusFormat: function(ratio) {
                        return _this11._getProgressValue(ratio) + "%"
                    },
                    showStatus: false,
                    statusPosition: "right"
                })
            };
            _proto._getTotalFilesSize = function() {
                var _this12 = this;
                if (!this._totalFilesSize) {
                    this._totalFilesSize = 0;
                    (0, _iterator.each)(this._files, function(_, file) {
                        _this12._totalFilesSize += file.value.size
                    })
                }
                return this._totalFilesSize
            };
            _proto._getTotalLoadedFilesSize = function() {
                var _this13 = this;
                if (!this._totalLoadedFilesSize) {
                    this._totalLoadedFilesSize = 0;
                    (0, _iterator.each)(this._files, function(_, file) {
                        _this13._totalLoadedFilesSize += file.loadedSize
                    })
                }
                return this._totalLoadedFilesSize
            };
            _proto._setLoadedSize = function(value) {
                this._totalLoadedFilesSize = value
            };
            _proto._recalculateProgress = function() {
                this._totalFilesSize = 0;
                this._totalLoadedFilesSize = 0;
                this._updateTotalProgress(this._getTotalFilesSize(), this._getTotalLoadedFilesSize())
            };
            _proto._updateReadOnlyState = function() {
                var readOnly = this.option("readOnly");
                this._selectButton.option("disabled", readOnly);
                this._files.forEach(function(file) {
                    var _file$cancelButton;
                    return null === (_file$cancelButton = file.cancelButton) || void 0 === _file$cancelButton ? void 0 : _file$cancelButton.option("disabled", readOnly)
                });
                this._updateInputLabelText();
                this._attachDragEventHandlers(this._$inputWrapper)
            };
            _proto._optionChanged = function(args) {
                var name = args.name,
                    value = args.value,
                    previousValue = args.previousValue;
                switch (name) {
                    case "height":
                    case "width":
                        this._updateFileNameMaxWidth();
                        _Editor.prototype._optionChanged.call(this, args);
                        break;
                    case "value":
                        !value.length && this._$fileInput.val("");
                        if (!this._preventRecreatingFiles) {
                            this._createFiles();
                            this._renderFiles()
                        }
                        this._recalculateProgress();
                        _Editor.prototype._optionChanged.call(this, args);
                        break;
                    case "name":
                        this._initFileInput();
                        _Editor.prototype._optionChanged.call(this, args);
                        break;
                    case "accept":
                        this._initFileInput();
                        break;
                    case "multiple":
                        this._initFileInput();
                        if (!args.value) {
                            this.reset()
                        }
                        break;
                    case "readOnly":
                        this._updateReadOnlyState();
                        _Editor.prototype._optionChanged.call(this, args);
                        break;
                    case "selectButtonText":
                        this._selectButton.option("text", value);
                        break;
                    case "uploadButtonText":
                        this._uploadButton && this._uploadButton.option("text", value);
                        break;
                    case "_uploadButtonType":
                        this._uploadButton && this._uploadButton.option("type", value);
                        break;
                    case "dialogTrigger":
                        this._detachSelectFileDialogHandler(previousValue);
                        this._attachSelectFileDialogHandler(value);
                        break;
                    case "dropZone":
                        this._detachDragEventHandlers(previousValue);
                        this._attachDragEventHandlers(value);
                        break;
                    case "maxFileSize":
                    case "minFileSize":
                    case "allowedFileExtensions":
                    case "invalidFileExtensionMessage":
                    case "invalidMaxFileSizeMessage":
                    case "invalidMinFileSizeMessage":
                    case "readyToUploadMessage":
                    case "uploadedMessage":
                    case "uploadFailedMessage":
                    case "uploadAbortedMessage":
                        this._invalidate();
                        break;
                    case "labelText":
                        this._updateInputLabelText();
                        break;
                    case "showFileList":
                        if (!this._preventRecreatingFiles) {
                            this._renderFiles()
                        }
                        break;
                    case "uploadFile":
                    case "uploadChunk":
                    case "chunkSize":
                        this._setUploadStrategy();
                        break;
                    case "abortUpload":
                    case "uploadUrl":
                    case "progress":
                    case "uploadMethod":
                    case "uploadHeaders":
                    case "uploadCustomData":
                    case "extendSelection":
                        break;
                    case "allowCanceling":
                    case "uploadMode":
                        this.reset();
                        this._invalidate();
                        break;
                    case "onBeforeSend":
                        this._createBeforeSendAction();
                        break;
                    case "onUploadStarted":
                        this._createUploadStartedAction();
                        break;
                    case "onUploaded":
                        this._createUploadedAction();
                        break;
                    case "onFilesUploaded":
                        this._createFilesUploadedAction();
                        break;
                    case "onProgress":
                        this._createProgressAction();
                        break;
                    case "onUploadError":
                        this._createUploadErrorAction();
                        break;
                    case "onUploadAborted":
                        this._createUploadAbortedAction();
                        break;
                    case "onDropZoneEnter":
                        this._createDropZoneEnterAction();
                        break;
                    case "onDropZoneLeave":
                        this._createDropZoneLeaveAction();
                        break;
                    case "useNativeInputClick":
                        this._renderInput();
                        break;
                    case "useDragOver":
                        this._attachDragEventHandlers(this._$inputWrapper);
                        break;
                    case "nativeDropSupported":
                        this._invalidate();
                        break;
                    case "inputAttr":
                        this._applyInputAttributes(this.option(name));
                        break;
                    default:
                        _Editor.prototype._optionChanged.call(this, args)
                }
            };
            _proto.reset = function() {
                this.option("value", [])
            };
            return FileUploader
        }(_editor.default);
        var FileBlobReader = function() {
            function FileBlobReader(file, chunkSize) {
                this.file = file;
                this.chunkSize = chunkSize;
                this.index = 0
            }
            var _proto2 = FileBlobReader.prototype;
            _proto2.read = function() {
                if (!this.file) {
                    return null
                }
                var result = this.createBlobResult(this.file, this.index, this.chunkSize);
                if (result.isCompleted) {
                    this.file = null
                }
                this.index++;
                return result
            };
            _proto2.createBlobResult = function(file, index, chunkSize) {
                var currentPosition = index * chunkSize;
                return {
                    blob: this.sliceFile(file, currentPosition, chunkSize),
                    index: index,
                    isCompleted: currentPosition + chunkSize >= file.size
                }
            };
            _proto2.sliceFile = function(file, startPos, length) {
                if (file.slice) {
                    return file.slice(startPos, startPos + length)
                }
                if (file.webkitSlice) {
                    return file.webkitSlice(startPos, startPos + length)
                }
                return null
            };
            return FileBlobReader
        }();
        var FileUploadStrategyBase = function() {
            function FileUploadStrategyBase(fileUploader) {
                this.fileUploader = fileUploader
            }
            var _proto3 = FileUploadStrategyBase.prototype;
            _proto3.upload = function(file) {
                if (file.isInitialized && file.isAborted) {
                    this.fileUploader._resetFileState(file)
                }
                if (file.isValid() && !file.uploadStarted) {
                    this._prepareFileBeforeUpload(file);
                    this._uploadCore(file)
                }
            };
            _proto3.abortUpload = function abortUpload(file) {
                var _this14 = this;
                if (file._isError || file._isLoaded || file.isAborted || !file.uploadStarted) {
                    return
                }
                file.isAborted = true;
                file.request && file.request.abort();
                if (this._isCustomCallback("abortUpload")) {
                    var abortUpload = this.fileUploader.option("abortUpload");
                    var arg = this._createUploadArgument(file);
                    var deferred = null;
                    try {
                        var result = abortUpload(file.value, arg);
                        deferred = (0, _deferred.fromPromise)(result)
                    } catch (error) {
                        deferred = (new _deferred.Deferred).reject(error).promise()
                    }
                    deferred.done(function() {
                        return file.onAbort.fire()
                    }).fail(function(error) {
                        return _this14._handleFileError(file, error)
                    })
                }
            };
            _proto3._beforeSend = function(xhr, file) {
                var arg = this._createUploadArgument(file);
                this.fileUploader._beforeSendAction({
                    request: xhr,
                    file: file.value,
                    uploadInfo: arg
                });
                file.request = xhr
            };
            _proto3._createUploadArgument = function(file) {};
            _proto3._uploadCore = function(file) {};
            _proto3._isCustomCallback = function(name) {
                var callback = this.fileUploader.option(name);
                return callback && (0, _type.isFunction)(callback)
            };
            _proto3._handleFileError = function(file, error) {
                file._isError = true;
                file.onError.fire(error)
            };
            _proto3._prepareFileBeforeUpload = function(file) {
                if (file.$file) {
                    var _file$progressBar;
                    null === (_file$progressBar = file.progressBar) || void 0 === _file$progressBar ? void 0 : _file$progressBar.dispose();
                    this.fileUploader._createFileProgressBar(file)
                }
                if (file.isInitialized) {
                    return
                }
                file.onLoadStart.add(this._onUploadStarted.bind(this, file));
                file.onLoad.add(this._onLoadedHandler.bind(this, file));
                file.onError.add(this._onErrorHandler.bind(this, file));
                file.onAbort.add(this._onAbortHandler.bind(this, file));
                file.onProgress.add(this._onProgressHandler.bind(this, file));
                file.isInitialized = true
            };
            _proto3._isStatusError = function(status) {
                return 400 <= status && status < 500 || 500 <= status && status < 600
            };
            _proto3._onUploadStarted = function(file, e) {
                file.uploadStarted = true;
                this.fileUploader._uploadStartedAction({
                    file: file.value,
                    event: e,
                    request: file.request
                })
            };
            _proto3._onAbortHandler = function(file, e) {
                var args = {
                    file: file.value,
                    event: e,
                    request: file.request,
                    message: this.fileUploader._getUploadAbortedStatusMessage()
                };
                this.fileUploader._uploadAbortedAction(args);
                this.fileUploader._setStatusMessage(file, args.message);
                this.fileUploader._handleAllFilesUploaded()
            };
            _proto3._onErrorHandler = function(file, error) {
                var args = {
                    file: file.value,
                    event: void 0,
                    request: file.request,
                    error: error,
                    message: this.fileUploader.option("uploadFailedMessage")
                };
                this.fileUploader._uploadErrorAction(args);
                this.fileUploader._setStatusMessage(file, args.message);
                this.fileUploader._handleAllFilesUploaded()
            };
            _proto3._onLoadedHandler = function(file, e) {
                var args = {
                    file: file.value,
                    event: e,
                    request: file.request,
                    message: this.fileUploader.option("uploadedMessage")
                };
                file._isLoaded = true;
                this.fileUploader._uploadedAction(args);
                this.fileUploader._setStatusMessage(file, args.message);
                this.fileUploader._handleAllFilesUploaded()
            };
            _proto3._onProgressHandler = function(file, e) {
                if (file) {
                    var totalFilesSize = this.fileUploader._getTotalFilesSize();
                    var totalLoadedFilesSize = this.fileUploader._getTotalLoadedFilesSize();
                    var loadedSize = Math.min(e.loaded, file.value.size);
                    var segmentSize = loadedSize - file.loadedSize;
                    file.loadedSize = loadedSize;
                    this.fileUploader._updateTotalProgress(totalFilesSize, totalLoadedFilesSize + segmentSize);
                    this.fileUploader._updateProgressBar(file, this._getLoadedData(loadedSize, e.total, segmentSize, e))
                }
            };
            _proto3._getLoadedData = function(loaded, total, currentSegmentSize, event) {
                return {
                    loaded: loaded,
                    total: total,
                    currentSegmentSize: currentSegmentSize
                }
            };
            _proto3._extendFormData = function(formData) {
                var formDataEntries = this.fileUploader.option("uploadCustomData");
                for (var entryName in formDataEntries) {
                    if (Object.prototype.hasOwnProperty.call(formDataEntries, entryName) && (0, _type.isDefined)(formDataEntries[entryName])) {
                        formData.append(entryName, formDataEntries[entryName])
                    }
                }
            };
            return FileUploadStrategyBase
        }();
        var ChunksFileUploadStrategyBase = function(_FileUploadStrategyBa) {
            _inheritsLoose(ChunksFileUploadStrategyBase, _FileUploadStrategyBa);

            function ChunksFileUploadStrategyBase(fileUploader) {
                var _this15;
                _this15 = _FileUploadStrategyBa.call(this, fileUploader) || this;
                _this15.chunkSize = _this15.fileUploader.option("chunkSize");
                return _this15
            }
            var _proto4 = ChunksFileUploadStrategyBase.prototype;
            _proto4._uploadCore = function(file) {
                var realFile = file.value;
                var chunksData = {
                    name: realFile.name,
                    loadedBytes: 0,
                    type: realFile.type,
                    blobReader: new FileBlobReader(realFile, this.chunkSize),
                    guid: new _guid.default,
                    fileSize: realFile.size,
                    count: Math.ceil(realFile.size / this.chunkSize),
                    customData: {}
                };
                file.chunksData = chunksData;
                this._sendChunk(file, chunksData)
            };
            _proto4._sendChunk = function(file, chunksData) {
                var _this16 = this;
                var chunk = chunksData.blobReader.read();
                chunksData.currentChunk = chunk;
                if (chunk) {
                    this._sendChunkCore(file, chunksData, chunk).done(function() {
                        if (file.isAborted) {
                            return
                        }
                        chunksData.loadedBytes += chunk.blob.size;
                        file.onProgress.fire({
                            loaded: chunksData.loadedBytes,
                            total: file.value.size
                        });
                        if (chunk.isCompleted) {
                            file.onLoad.fire()
                        }
                        setTimeout(function() {
                            return _this16._sendChunk(file, chunksData)
                        })
                    }).fail(function(error) {
                        if (_this16._shouldHandleError(error)) {
                            _this16._handleFileError(file, error)
                        }
                    })
                }
            };
            _proto4._sendChunkCore = function(file, chunksData, chunk) {};
            _proto4._shouldHandleError = function(error) {};
            _proto4._tryRaiseStartLoad = function(file) {
                if (!file.isStartLoad) {
                    file.isStartLoad = true;
                    file.onLoadStart.fire()
                }
            };
            _proto4._getEvent = function(e) {
                return null
            };
            _proto4._createUploadArgument = function(file) {
                return this._createChunksInfo(file.chunksData)
            };
            _proto4._createChunksInfo = function(chunksData) {
                return {
                    bytesUploaded: chunksData.loadedBytes,
                    chunkCount: chunksData.count,
                    customData: chunksData.customData,
                    chunkBlob: chunksData.currentChunk.blob,
                    chunkIndex: chunksData.currentChunk.index
                }
            };
            return ChunksFileUploadStrategyBase
        }(FileUploadStrategyBase);
        var DefaultChunksFileUploadStrategy = function(_ChunksFileUploadStra) {
            _inheritsLoose(DefaultChunksFileUploadStrategy, _ChunksFileUploadStra);

            function DefaultChunksFileUploadStrategy() {
                return _ChunksFileUploadStra.apply(this, arguments) || this
            }
            var _proto5 = DefaultChunksFileUploadStrategy.prototype;
            _proto5._sendChunkCore = function(file, chunksData, chunk) {
                var _this17 = this;
                return _ajax.default.sendRequest({
                    url: this.fileUploader.option("uploadUrl"),
                    method: this.fileUploader.option("uploadMethod"),
                    headers: this.fileUploader.option("uploadHeaders"),
                    beforeSend: function(xhr) {
                        return _this17._beforeSend(xhr, file)
                    },
                    upload: {
                        onloadstart: function() {
                            return _this17._tryRaiseStartLoad(file)
                        },
                        onabort: function() {
                            return file.onAbort.fire()
                        }
                    },
                    data: this._createFormData({
                        fileName: chunksData.name,
                        blobName: this.fileUploader.option("name"),
                        blob: chunk.blob,
                        index: chunk.index,
                        count: chunksData.count,
                        type: chunksData.type,
                        guid: chunksData.guid,
                        size: chunksData.fileSize
                    })
                })
            };
            _proto5._shouldHandleError = function(e) {
                return this._isStatusError(e.status)
            };
            _proto5._createFormData = function(options) {
                var formData = new window.FormData;
                formData.append(options.blobName, options.blob);
                formData.append(FILEUPLOADER_CHUNK_META_DATA_NAME, JSON.stringify({
                    FileName: options.fileName,
                    Index: options.index,
                    TotalCount: options.count,
                    FileSize: options.size,
                    FileType: options.type,
                    FileGuid: options.guid
                }));
                this._extendFormData(formData);
                return formData
            };
            return DefaultChunksFileUploadStrategy
        }(ChunksFileUploadStrategyBase);
        var CustomChunksFileUploadStrategy = function(_ChunksFileUploadStra2) {
            _inheritsLoose(CustomChunksFileUploadStrategy, _ChunksFileUploadStra2);

            function CustomChunksFileUploadStrategy() {
                return _ChunksFileUploadStra2.apply(this, arguments) || this
            }
            var _proto6 = CustomChunksFileUploadStrategy.prototype;
            _proto6._sendChunkCore = function(file, chunksData) {
                this._tryRaiseStartLoad(file);
                var chunksInfo = this._createChunksInfo(chunksData);
                var uploadChunk = this.fileUploader.option("uploadChunk");
                try {
                    var result = uploadChunk(file.value, chunksInfo);
                    return (0, _deferred.fromPromise)(result)
                } catch (error) {
                    return (new _deferred.Deferred).reject(error).promise()
                }
            };
            _proto6._shouldHandleError = function(e) {
                return true
            };
            return CustomChunksFileUploadStrategy
        }(ChunksFileUploadStrategyBase);
        var WholeFileUploadStrategyBase = function(_FileUploadStrategyBa2) {
            _inheritsLoose(WholeFileUploadStrategyBase, _FileUploadStrategyBa2);

            function WholeFileUploadStrategyBase() {
                return _FileUploadStrategyBa2.apply(this, arguments) || this
            }
            var _proto7 = WholeFileUploadStrategyBase.prototype;
            _proto7._uploadCore = function(file) {
                var _this18 = this;
                file.loadedSize = 0;
                this._uploadFile(file).done(function() {
                    if (!file.isAborted) {
                        file.onLoad.fire()
                    }
                }).fail(function(error) {
                    if (_this18._shouldHandleError(file, error)) {
                        _this18._handleFileError(file, error)
                    }
                })
            };
            _proto7._uploadFile = function(file) {};
            _proto7._shouldHandleError = function(file, e) {};
            _proto7._handleProgress = function(file, e) {
                if (file._isError) {
                    return
                }
                file._isProgressStarted = true;
                file.onProgress.fire(e)
            };
            _proto7._getLoadedData = function(loaded, total, segmentSize, event) {
                var result = _FileUploadStrategyBa2.prototype._getLoadedData.call(this, loaded, total, segmentSize, event);
                result.event = event;
                return result
            };
            return WholeFileUploadStrategyBase
        }(FileUploadStrategyBase);
        var DefaultWholeFileUploadStrategy = function(_WholeFileUploadStrat) {
            _inheritsLoose(DefaultWholeFileUploadStrategy, _WholeFileUploadStrat);

            function DefaultWholeFileUploadStrategy() {
                return _WholeFileUploadStrat.apply(this, arguments) || this
            }
            var _proto8 = DefaultWholeFileUploadStrategy.prototype;
            _proto8._uploadFile = function(file) {
                var _this19 = this;
                return _ajax.default.sendRequest({
                    url: this.fileUploader.option("uploadUrl"),
                    method: this.fileUploader.option("uploadMethod"),
                    headers: this.fileUploader.option("uploadHeaders"),
                    beforeSend: function(xhr) {
                        return _this19._beforeSend(xhr, file)
                    },
                    upload: {
                        onprogress: function(e) {
                            return _this19._handleProgress(file, e)
                        },
                        onloadstart: function() {
                            return file.onLoadStart.fire()
                        },
                        onabort: function() {
                            return file.onAbort.fire()
                        }
                    },
                    data: this._createFormData(this.fileUploader.option("name"), file.value)
                })
            };
            _proto8._shouldHandleError = function(file, e) {
                return this._isStatusError(e.status) || !file._isProgressStarted
            };
            _proto8._createFormData = function(fieldName, fieldValue) {
                var formData = new window.FormData;
                formData.append(fieldName, fieldValue, fieldValue.name);
                this._extendFormData(formData);
                return formData
            };
            return DefaultWholeFileUploadStrategy
        }(WholeFileUploadStrategyBase);
        var CustomWholeFileUploadStrategy = function(_WholeFileUploadStrat2) {
            _inheritsLoose(CustomWholeFileUploadStrategy, _WholeFileUploadStrat2);

            function CustomWholeFileUploadStrategy() {
                return _WholeFileUploadStrat2.apply(this, arguments) || this
            }
            var _proto9 = CustomWholeFileUploadStrategy.prototype;
            _proto9._uploadFile = function(file) {
                var _this20 = this;
                file.onLoadStart.fire();
                var progressCallback = function(loadedBytes) {
                    var arg = {
                        loaded: loadedBytes,
                        total: file.size
                    };
                    _this20._handleProgress(file, arg)
                };
                var uploadFile = this.fileUploader.option("uploadFile");
                try {
                    var result = uploadFile(file.value, progressCallback);
                    return (0, _deferred.fromPromise)(result)
                } catch (error) {
                    return (new _deferred.Deferred).reject(error).promise()
                }
            };
            _proto9._shouldHandleError = function(file, e) {
                return true
            };
            return CustomWholeFileUploadStrategy
        }(WholeFileUploadStrategyBase);
        (0, _component_registrator.default)("dxFileUploader", FileUploader);
        var _default = FileUploader;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/progress_bar.js ***!
      \*****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _track_bar = _interopRequireDefault(__webpack_require__( /*! ./track_bar */ 283));
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var PROGRESSBAR_CLASS = "dx-progressbar";
        var PROGRESSBAR_CONTAINER_CLASS = "dx-progressbar-container";
        var PROGRESSBAR_RANGE_CONTAINER_CLASS = "dx-progressbar-range-container";
        var PROGRESSBAR_RANGE_CLASS = "dx-progressbar-range";
        var PROGRESSBAR_WRAPPER_CLASS = "dx-progressbar-wrapper";
        var PROGRESSBAR_STATUS_CLASS = "dx-progressbar-status";
        var PROGRESSBAR_INDETERMINATE_SEGMENT_CONTAINER = "dx-progressbar-animating-container";
        var PROGRESSBAR_INDETERMINATE_SEGMENT = "dx-progressbar-animating-segment";
        var ProgressBar = _track_bar.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    value: 0,
                    statusFormat: function(ratio) {
                        return "Progress: " + Math.round(100 * ratio) + "%"
                    },
                    showStatus: true,
                    onComplete: null,
                    activeStateEnabled: false,
                    statusPosition: "bottom left",
                    _animatingSegmentCount: 0
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: function(_device) {
                        return "android" === _device.platform
                    },
                    options: {
                        _animatingSegmentCount: 2
                    }
                }])
            },
            _initMarkup: function() {
                this._renderStatus();
                this._createCompleteAction();
                this.callBase();
                this.$element().addClass(PROGRESSBAR_CLASS);
                this._$wrapper.addClass(PROGRESSBAR_WRAPPER_CLASS);
                this._$bar.addClass(PROGRESSBAR_CONTAINER_CLASS);
                this.setAria("role", "progressbar");
                (0, _renderer.default)("<div>").addClass(PROGRESSBAR_RANGE_CONTAINER_CLASS).appendTo(this._$wrapper).append(this._$bar);
                this._$range.addClass(PROGRESSBAR_RANGE_CLASS);
                this._toggleStatus(this.option("showStatus"))
            },
            _useTemplates: function() {
                return false
            },
            _createCompleteAction: function() {
                this._completeAction = this._createActionByOption("onComplete")
            },
            _renderStatus: function() {
                this._$status = (0, _renderer.default)("<div>").addClass(PROGRESSBAR_STATUS_CLASS)
            },
            _renderIndeterminateState: function() {
                this._$segmentContainer = (0, _renderer.default)("<div>").addClass(PROGRESSBAR_INDETERMINATE_SEGMENT_CONTAINER);
                var segments = this.option("_animatingSegmentCount");
                for (var i = 0; i < segments; i++) {
                    (0, _renderer.default)("<div>").addClass(PROGRESSBAR_INDETERMINATE_SEGMENT).addClass(PROGRESSBAR_INDETERMINATE_SEGMENT + "-" + (i + 1)).appendTo(this._$segmentContainer)
                }
                this._$segmentContainer.appendTo(this._$wrapper)
            },
            _toggleStatus: function(value) {
                var splitPosition = this.option("statusPosition").split(" ");
                if (value) {
                    if ("top" === splitPosition[0] || "left" === splitPosition[0]) {
                        this._$status.prependTo(this._$wrapper)
                    } else {
                        this._$status.appendTo(this._$wrapper)
                    }
                } else {
                    this._$status.detach()
                }
                this._togglePositionClass()
            },
            _togglePositionClass: function() {
                var position = this.option("statusPosition");
                var splitPosition = position.split(" ");
                this._$wrapper.removeClass("dx-position-top-left dx-position-top-right dx-position-bottom-left dx-position-bottom-right dx-position-left dx-position-right");
                var positionClass = "dx-position-" + splitPosition[0];
                if (splitPosition[1]) {
                    positionClass += "-" + splitPosition[1]
                }
                this._$wrapper.addClass(positionClass)
            },
            _toggleIndeterminateState: function(value) {
                if (value) {
                    this._renderIndeterminateState();
                    this._$bar.toggle(false)
                } else {
                    this._$bar.toggle(true);
                    this._$segmentContainer.remove();
                    delete this._$segmentContainer
                }
            },
            _renderValue: function() {
                var val = this.option("value");
                var max = this.option("max");
                if (!val && 0 !== val) {
                    this._toggleIndeterminateState(true);
                    return
                }
                if (this._$segmentContainer) {
                    this._toggleIndeterminateState(false)
                }
                if (val === max) {
                    this._completeAction()
                }
                this.callBase();
                this._setStatus()
            },
            _setStatus: function() {
                var format = this.option("statusFormat");
                if ((0, _type.isFunction)(format)) {
                    format = format.bind(this)
                } else {
                    format = function(value) {
                        return value
                    }
                }
                var statusText = format(this._currentRatio, this.option("value"));
                this._$status.text(statusText)
            },
            _dispose: function() {
                this._$status.remove();
                this.callBase()
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "statusFormat":
                        this._setStatus();
                        break;
                    case "showStatus":
                        this._toggleStatus(args.value);
                        break;
                    case "statusPosition":
                        this._toggleStatus(this.option("showStatus"));
                        break;
                    case "onComplete":
                        this._createCompleteAction();
                        break;
                    case "_animatingSegmentCount":
                        break;
                    default:
                        this.callBase(args)
                }
            }
        });
        (0, _component_registrator.default)("dxProgressBar", ProgressBar);
        var _default = ProgressBar;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/track_bar.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _editor = _interopRequireDefault(__webpack_require__( /*! ./editor/editor */ 52));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _fx = _interopRequireDefault(__webpack_require__( /*! ../animation/fx */ 42));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var TRACKBAR_CLASS = "dx-trackbar";
        var TRACKBAR_CONTAINER_CLASS = "dx-trackbar-container";
        var TRACKBAR_RANGE_CLASS = "dx-trackbar-range";
        var TRACKBAR_WRAPPER_CLASS = "dx-trackbar-wrapper";
        var TrackBar = _editor.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    min: 0,
                    max: 100,
                    value: 0
                })
            },
            _initMarkup: function() {
                this.$element().addClass(TRACKBAR_CLASS);
                this._renderWrapper();
                this._renderContainer();
                this._renderRange();
                this._renderValue();
                this._setRangeStyles();
                this.callBase()
            },
            _render: function() {
                this.callBase();
                this._setRangeStyles(this._rangeStylesConfig())
            },
            _renderWrapper: function() {
                this._$wrapper = (0, _renderer.default)("<div>").addClass(TRACKBAR_WRAPPER_CLASS).appendTo(this.$element())
            },
            _renderContainer: function() {
                this._$bar = (0, _renderer.default)("<div>").addClass(TRACKBAR_CONTAINER_CLASS).appendTo(this._$wrapper)
            },
            _renderRange: function() {
                this._$range = (0, _renderer.default)("<div>").addClass(TRACKBAR_RANGE_CLASS).appendTo(this._$bar)
            },
            _renderValue: function() {
                var val = this.option("value");
                var min = this.option("min");
                var max = this.option("max");
                if (min > max) {
                    return
                }
                if (val < min) {
                    this.option("value", min);
                    this._currentRatio = 0;
                    return
                }
                if (val > max) {
                    this.option("value", max);
                    this._currentRatio = 1;
                    return
                }
                var ratio = min === max ? 0 : (val - min) / (max - min);
                !this._needPreventAnimation && this._setRangeStyles({
                    width: 100 * ratio + "%"
                });
                this.setAria({
                    valuemin: this.option("min"),
                    valuemax: max,
                    valuenow: val
                });
                this._currentRatio = ratio
            },
            _rangeStylesConfig: function() {
                return {
                    width: 100 * this._currentRatio + "%"
                }
            },
            _setRangeStyles: function(options) {
                _fx.default.stop(this._$range);
                if (!options) {
                    this._$range.css({
                        width: 0
                    });
                    return
                }
                if (this._needPreventAnimation || !(0, _window.hasWindow)()) {
                    return
                }
                _fx.default.animate(this._$range, {
                    type: "custom",
                    duration: 100,
                    to: options
                })
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "value":
                        this._renderValue();
                        this.callBase(args);
                        break;
                    case "max":
                    case "min":
                        this._renderValue();
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _dispose: function() {
                _fx.default.stop(this._$range);
                this.callBase()
            }
        });
        (0, _component_registrator.default)("dxTrackBar", TrackBar);
        var _default = TrackBar;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tab_panel.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _support = __webpack_require__( /*! ../core/utils/support */ 45);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../core/devices */ 13));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../core/dom_adapter */ 11));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _multi_view = _interopRequireDefault(__webpack_require__( /*! ./multi_view */ 358));
        var _tabs = _interopRequireDefault(__webpack_require__( /*! ./tabs */ 215));
        var _item = _interopRequireDefault(__webpack_require__( /*! ./tab_panel/item */ 639));
        var _icon = __webpack_require__( /*! ../core/utils/icon */ 56);
        var _element = __webpack_require__( /*! ../core/element */ 18);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _bindable_template = __webpack_require__( /*! ../core/templates/bindable_template */ 65);
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var TABPANEL_CLASS = "dx-tabpanel";
        var TABPANEL_TABS_CLASS = "dx-tabpanel-tabs";
        var TABPANEL_CONTAINER_CLASS = "dx-tabpanel-container";
        var TABS_ITEM_TEXT_CLASS = "dx-tab-text";
        var TabPanel = _multi_view.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    itemTitleTemplate: "title",
                    hoverStateEnabled: true,
                    showNavButtons: false,
                    scrollByContent: true,
                    scrollingEnabled: true,
                    onTitleClick: null,
                    onTitleHold: null,
                    onTitleRendered: null,
                    badgeExpr: function(data) {
                        return data ? data.badge : void 0
                    }
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: function() {
                        return "desktop" === _devices.default.real().deviceType && !_devices.default.isSimulator()
                    },
                    options: {
                        focusStateEnabled: true
                    }
                }, {
                    device: function() {
                        return !_support.touch
                    },
                    options: {
                        swipeEnabled: false
                    }
                }, {
                    device: {
                        platform: "generic"
                    },
                    options: {
                        animationEnabled: false
                    }
                }])
            },
            _init: function() {
                this.callBase();
                this.$element().addClass(TABPANEL_CLASS);
                this.setAria("role", "tabpanel")
            },
            _initMarkup: function() {
                this.callBase();
                this._createTitleActions();
                this._renderLayout()
            },
            _initTemplates: function() {
                this.callBase();
                this._templateManager.addDefaultTemplates({
                    title: new _bindable_template.BindableTemplate(function($container, data) {
                        if ((0, _type.isPlainObject)(data)) {
                            var $iconElement = (0, _icon.getImageContainer)(data.icon);
                            if ($iconElement) {
                                $container.append($iconElement)
                            }
                            if ((0, _type.isDefined)(data.title) && !(0, _type.isPlainObject)(data.title)) {
                                $container.append(_dom_adapter.default.createTextNode(data.title))
                            }
                        } else {
                            if ((0, _type.isDefined)(data)) {
                                $container.text(String(data))
                            }
                        }
                        $container.wrapInner((0, _renderer.default)("<span>").addClass(TABS_ITEM_TEXT_CLASS))
                    }, ["title", "icon"], this.option("integrationOptions.watchMethod"))
                })
            },
            _createTitleActions: function() {
                this._createTitleClickAction();
                this._createTitleHoldAction();
                this._createTitleRenderedAction()
            },
            _createTitleClickAction: function() {
                this._titleClickAction = this._createActionByOption("onTitleClick")
            },
            _createTitleHoldAction: function() {
                this._titleHoldAction = this._createActionByOption("onTitleHold")
            },
            _createTitleRenderedAction: function() {
                this._titleRenderedAction = this._createActionByOption("onTitleRendered")
            },
            _renderContent: function() {
                var that = this;
                this.callBase();
                if (this.option("templatesRenderAsynchronously")) {
                    this._resizeEventTimer = setTimeout(function() {
                        that._updateLayout()
                    }, 0)
                }
            },
            _renderLayout: function() {
                if (this._tabs) {
                    this._updateLayout();
                    return
                }
                var $element = this.$element();
                this._$tabContainer = (0, _renderer.default)("<div>").addClass(TABPANEL_TABS_CLASS).appendTo($element);
                var $tabs = (0, _renderer.default)("<div>").appendTo(this._$tabContainer);
                this._tabs = this._createComponent($tabs, _tabs.default, this._tabConfig());
                this._$container = (0, _renderer.default)("<div>").addClass(TABPANEL_CONTAINER_CLASS).appendTo($element);
                this._$container.append(this._$wrapper);
                this._updateLayout()
            },
            _updateLayout: function() {
                if ((0, _window.hasWindow)()) {
                    var tabsHeight = this._$tabContainer.outerHeight();
                    this._$container.css({
                        marginTop: -tabsHeight,
                        paddingTop: tabsHeight
                    })
                }
            },
            _refreshActiveDescendant: function() {
                if (!this._tabs) {
                    return
                }
                var tabs = this._tabs;
                var tabItems = tabs.itemElements();
                var $activeTab = (0, _renderer.default)(tabItems[tabs.option("selectedIndex")]);
                var id = this.getFocusedItemId();
                this.setAria("controls", void 0, (0, _renderer.default)(tabItems));
                this.setAria("controls", id, $activeTab)
            },
            _tabConfig: function() {
                return {
                    selectOnFocus: true,
                    focusStateEnabled: this.option("focusStateEnabled"),
                    hoverStateEnabled: this.option("hoverStateEnabled"),
                    repaintChangesOnly: this.option("repaintChangesOnly"),
                    tabIndex: this.option("tabIndex"),
                    selectedIndex: this.option("selectedIndex"),
                    badgeExpr: this.option("badgeExpr"),
                    onItemClick: this._titleClickAction.bind(this),
                    onItemHold: this._titleHoldAction.bind(this),
                    itemHoldTimeout: this.option("itemHoldTimeout"),
                    onSelectionChanged: function(e) {
                        this.option("selectedIndex", e.component.option("selectedIndex"));
                        this._refreshActiveDescendant()
                    }.bind(this),
                    onItemRendered: this._titleRenderedAction.bind(this),
                    itemTemplate: this._getTemplateByOption("itemTitleTemplate"),
                    items: this.option("items"),
                    noDataText: null,
                    scrollingEnabled: this.option("scrollingEnabled"),
                    scrollByContent: this.option("scrollByContent"),
                    showNavButtons: this.option("showNavButtons"),
                    itemTemplateProperty: "tabTemplate",
                    loopItemFocus: this.option("loop"),
                    selectionRequired: true,
                    onOptionChanged: function(args) {
                        if ("focusedElement" === args.name) {
                            if (args.value) {
                                var $value = (0, _renderer.default)(args.value);
                                var $newItem = this._itemElements().eq($value.index());
                                this.option("focusedElement", (0, _element.getPublicElement)($newItem))
                            } else {
                                this.option("focusedElement", args.value)
                            }
                        }
                    }.bind(this),
                    onFocusIn: function(args) {
                        this._focusInHandler(args.event)
                    }.bind(this),
                    onFocusOut: function(args) {
                        if (!this._isFocusOutHandlerExecuting) {
                            this._focusOutHandler(args.event)
                        }
                    }.bind(this)
                }
            },
            _renderFocusTarget: function() {
                this._focusTarget().attr("tabIndex", -1)
            },
            _updateFocusState: function(e, isFocused) {
                this.callBase(e, isFocused);
                if (e.target === this._tabs._focusTarget().get(0)) {
                    this._toggleFocusClass(isFocused, this._focusTarget())
                }
            },
            _focusOutHandler: function(e) {
                this._isFocusOutHandlerExecuting = true;
                this.callBase.apply(this, arguments);
                this._tabs._focusOutHandler(e);
                this._isFocusOutHandlerExecuting = false
            },
            _setTabsOption: function(name, value) {
                if (this._tabs) {
                    this._tabs.option(name, value)
                }
            },
            _visibilityChanged: function(visible) {
                if (visible) {
                    this._tabs._dimensionChanged();
                    this._updateLayout()
                }
            },
            registerKeyHandler: function(key, handler) {
                this.callBase(key, handler);
                if (this._tabs) {
                    this._tabs.registerKeyHandler(key, handler)
                }
            },
            repaint: function() {
                this.callBase();
                this._tabs.repaint()
            },
            _optionChanged: function(args) {
                var name = args.name;
                var value = args.value;
                var fullName = args.fullName;
                switch (name) {
                    case "dataSource":
                        this.callBase(args);
                        break;
                    case "items":
                        this._setTabsOption(name, this.option(name));
                        this._updateLayout();
                        if (!this.option("repaintChangesOnly")) {
                            this._tabs.repaint()
                        }
                        this.callBase(args);
                        break;
                    case "width":
                        this.callBase(args);
                        this._tabs.repaint();
                        break;
                    case "selectedIndex":
                    case "selectedItem":
                        this._setTabsOption(fullName, value);
                        this.callBase(args);
                        if (true === this.option("focusStateEnabled")) {
                            var selectedIndex = this.option("selectedIndex");
                            var selectedTabContent = this._itemElements().eq(selectedIndex);
                            this.option("focusedElement", (0, _element.getPublicElement)(selectedTabContent))
                        }
                        break;
                    case "itemHoldTimeout":
                    case "focusStateEnabled":
                    case "hoverStateEnabled":
                        this._setTabsOption(fullName, value);
                        this.callBase(args);
                        break;
                    case "scrollingEnabled":
                    case "scrollByContent":
                    case "showNavButtons":
                        this._setTabsOption(fullName, value);
                        break;
                    case "focusedElement":
                        var id = value ? (0, _renderer.default)(value).index() : value;
                        var newItem = value ? this._tabs._itemElements().eq(id) : value;
                        this._setTabsOption("focusedElement", (0, _element.getPublicElement)(newItem));
                        this.callBase(args);
                        break;
                    case "itemTitleTemplate":
                        this._setTabsOption("itemTemplate", this._getTemplateByOption("itemTitleTemplate"));
                        break;
                    case "onTitleClick":
                        this._createTitleClickAction();
                        this._setTabsOption("onItemClick", this._titleClickAction.bind(this));
                        break;
                    case "onTitleHold":
                        this._createTitleHoldAction();
                        this._setTabsOption("onItemHold", this._titleHoldAction.bind(this));
                        break;
                    case "onTitleRendered":
                        this._createTitleRenderedAction();
                        this._setTabsOption("onItemRendered", this._titleRenderedAction.bind(this));
                        break;
                    case "loop":
                        this._setTabsOption("loopItemFocus", value);
                        break;
                    case "badgeExpr":
                        this._invalidate();
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _clean: function() {
                clearTimeout(this._resizeEventTimer);
                this.callBase()
            }
        });
        TabPanel.ItemClass = _item.default;
        (0, _component_registrator.default)("dxTabPanel", TabPanel);
        var _default = TabPanel;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/validation_summary.js ***!
      \***********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _validation_engine = _interopRequireDefault(__webpack_require__( /*! ./validation_engine */ 96));
        var _uiCollection_widget = _interopRequireDefault(__webpack_require__( /*! ./collection/ui.collection_widget.edit */ 54));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var VALIDATION_SUMMARY_CLASS = "dx-validationsummary";
        var ITEM_CLASS = VALIDATION_SUMMARY_CLASS + "-item";
        var ITEM_DATA_KEY = VALIDATION_SUMMARY_CLASS + "-item-data";
        var ValidationSummary = _uiCollection_widget.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    focusStateEnabled: false,
                    noDataText: null
                })
            },
            _setOptionsByReference: function() {
                this.callBase();
                (0, _extend.extend)(this._optionsByReference, {
                    validationGroup: true
                })
            },
            _init: function() {
                this.callBase();
                this._initGroupRegistration()
            },
            _initGroupRegistration: function() {
                var $element = this.$element();
                var group = this.option("validationGroup") || _validation_engine.default.findGroup($element, this._modelByElement($element));
                var groupConfig = _validation_engine.default.addGroup(group);
                this._unsubscribeGroup();
                this._groupWasInit = true;
                this._validationGroup = group;
                this.groupSubscription = this._groupValidationHandler.bind(this);
                groupConfig.on("validated", this.groupSubscription)
            },
            _unsubscribeGroup: function() {
                var groupConfig = _validation_engine.default.getGroupConfig(this._validationGroup);
                groupConfig && groupConfig.off("validated", this.groupSubscription)
            },
            _getOrderedItems: function(validators, items) {
                var orderedItems = [];
                (0, _iterator.each)(validators, function(_, validator) {
                    var foundItems = (0, _common.grep)(items, function(item) {
                        if (item.validator === validator) {
                            return true
                        }
                    });
                    if (foundItems.length) {
                        orderedItems = orderedItems.concat(foundItems)
                    }
                });
                return orderedItems
            },
            _groupValidationHandler: function(params) {
                var _this = this;
                var items = this._getOrderedItems(params.validators, (0, _iterator.map)(params.brokenRules, function(rule) {
                    return {
                        text: rule.message,
                        validator: rule.validator,
                        index: rule.index
                    }
                }));
                this.validators = params.validators;
                (0, _iterator.each)(this.validators, function(_, validator) {
                    if (validator._validationSummary !== _this) {
                        var handler = _this._itemValidationHandler.bind(_this);
                        var disposingHandler = function() {
                            validator.off("validated", handler);
                            validator._validationSummary = null;
                            handler = null
                        };
                        validator.on("validated", handler);
                        validator.on("disposing", disposingHandler);
                        validator._validationSummary = _this
                    }
                });
                this.option("items", items)
            },
            _itemValidationHandler: function(_ref) {
                var isValid = _ref.isValid,
                    validator = _ref.validator,
                    brokenRules = _ref.brokenRules;
                var items = this.option("items");
                var itemsChanged = false;
                var itemIndex = 0;
                var _loop = function() {
                    var item = items[itemIndex];
                    if (item.validator === validator) {
                        var foundRule = (0, _common.grep)(brokenRules || [], function(rule) {
                            return rule.index === item.index
                        })[0];
                        if (isValid || !foundRule) {
                            items.splice(itemIndex, 1);
                            itemsChanged = true;
                            return "continue"
                        }
                        if (foundRule.message !== item.text) {
                            item.text = foundRule.message;
                            itemsChanged = true
                        }
                    }
                    itemIndex++
                };
                while (itemIndex < items.length) {
                    var _ret = _loop();
                    if ("continue" === _ret) {
                        continue
                    }
                }(0, _iterator.each)(brokenRules, function(_, rule) {
                    var foundItem = (0, _common.grep)(items, function(item) {
                        return item.validator === validator && item.index === rule.index
                    })[0];
                    if (!foundItem) {
                        items.push({
                            text: rule.message,
                            validator: validator,
                            index: rule.index
                        });
                        itemsChanged = true
                    }
                });
                if (itemsChanged) {
                    items = this._getOrderedItems(this.validators, items);
                    this.option("items", items)
                }
            },
            _initMarkup: function() {
                this.$element().addClass(VALIDATION_SUMMARY_CLASS);
                this.callBase()
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "validationGroup":
                        this._initGroupRegistration();
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _itemClass: function() {
                return ITEM_CLASS
            },
            _itemDataKey: function() {
                return ITEM_DATA_KEY
            },
            _postprocessRenderItem: function(params) {
                _events_engine.default.on(params.itemElement, "click", function() {
                    params.itemData.validator && params.itemData.validator.focus && params.itemData.validator.focus()
                })
            },
            _dispose: function() {
                this.callBase();
                this._unsubscribeGroup()
            }
        });
        (0, _component_registrator.default)("dxValidationSummary", ValidationSummary);
        var _default = ValidationSummary;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/text_box/utils.scroll.js ***!
      \**************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.prepareScrollData = exports.allowScroll = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var allowScroll = function(container, delta, shiftKey) {
            var $container = (0, _renderer.default)(container);
            var scrollTopPos = shiftKey ? $container.scrollLeft() : $container.scrollTop();
            var prop = shiftKey ? "Width" : "Height";
            var scrollBottomPos = $container.prop("scroll".concat(prop)) - $container.prop("client".concat(prop)) - scrollTopPos;
            if (0 === scrollTopPos && 0 === scrollBottomPos) {
                return false
            }
            var isScrollFromTop = 0 === scrollTopPos && delta >= 0;
            var isScrollFromBottom = 0 === scrollBottomPos && delta <= 0;
            var isScrollFromMiddle = scrollTopPos > 0 && scrollBottomPos > 0;
            if (isScrollFromTop || isScrollFromBottom || isScrollFromMiddle) {
                return true
            }
        };
        exports.allowScroll = allowScroll;
        var prepareScrollData = function(container, validateTarget) {
            var $container = (0, _renderer.default)(container);
            var isCorrectTarget = function(eventTarget) {
                return validateTarget ? (0, _renderer.default)(eventTarget).is(container) : true
            };
            return {
                validate: function(e) {
                    if ((0, _index.isDxMouseWheelEvent)(e) && isCorrectTarget(e.target)) {
                        if (allowScroll($container, -e.delta, e.shiftKey)) {
                            e._needSkipEvent = true;
                            return true
                        }
                        return false
                    }
                }
            }
        };
        exports.prepareScrollData = prepareScrollData
    },
    /*!************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/html_editor/converterController.js ***!
      \************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var ConverterController = function() {
            function ConverterController() {
                this._converters = {}
            }
            var _proto = ConverterController.prototype;
            _proto.addConverter = function(name, converter) {
                this._converters[name] = converter
            };
            _proto.getConverter = function(name) {
                return this._converters[name]
            };
            return ConverterController
        }();
        var controller = new ConverterController;
        var _default = controller;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/radio_group.js ***!
      \****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _radio_group = _interopRequireDefault(__webpack_require__( /*! ./radio_group/radio_group */ 676));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _radio_group.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tag_box.js ***!
      \************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../core/devices */ 13));
        var _element_data = __webpack_require__( /*! ../core/element_data */ 40);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _selection_filter = __webpack_require__( /*! ../core/utils/selection_filter */ 330);
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);
        var _dom = __webpack_require__( /*! ../core/utils/dom */ 33);
        var _element = __webpack_require__( /*! ../core/element */ 18);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _array = __webpack_require__( /*! ../core/utils/array */ 12);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../localization/message */ 10));
        var _index = __webpack_require__( /*! ../events/utils/index */ 8);
        var _click = __webpack_require__( /*! ../events/click */ 21);
        var _utils = _interopRequireDefault(__webpack_require__( /*! ./text_box/utils.caret */ 343));
        var _utils2 = __webpack_require__( /*! ../data/data_source/utils */ 69);
        var _scroll_rtl_behavior = _interopRequireDefault(__webpack_require__( /*! ../core/utils/scroll_rtl_behavior */ 681));
        var _select_box = _interopRequireDefault(__webpack_require__( /*! ./select_box */ 117));
        var _bindable_template = __webpack_require__( /*! ../core/templates/bindable_template */ 65);
        var _utils3 = __webpack_require__( /*! ./text_box/utils.scroll */ 286);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        var TAGBOX_TAG_DATA_KEY = "dxTagData";
        var TAGBOX_CLASS = "dx-tagbox";
        var TAGBOX_TAG_CONTAINER_CLASS = "dx-tag-container";
        var TAGBOX_TAG_CLASS = "dx-tag";
        var TAGBOX_MULTI_TAG_CLASS = "dx-tagbox-multi-tag";
        var TAGBOX_CUSTOM_TAG_CLASS = "dx-tag-custom";
        var TAGBOX_TAG_REMOVE_BUTTON_CLASS = "dx-tag-remove-button";
        var TAGBOX_ONLY_SELECT_CLASS = "dx-tagbox-only-select";
        var TAGBOX_SINGLE_LINE_CLASS = "dx-tagbox-single-line";
        var TAGBOX_POPUP_WRAPPER_CLASS = "dx-tagbox-popup-wrapper";
        var TAGBOX_TAG_CONTENT_CLASS = "dx-tag-content";
        var TAGBOX_DEFAULT_FIELD_TEMPLATE_CLASS = "dx-tagbox-default-template";
        var TAGBOX_CUSTOM_FIELD_TEMPLATE_CLASS = "dx-tagbox-custom-template";
        var NATIVE_CLICK_CLASS = "dx-native-click";
        var TEXTEDITOR_INPUT_CONTAINER_CLASS = "dx-texteditor-input-container";
        var TAGBOX_MOUSE_WHEEL_DELTA_MULTIPLIER = -.3;
        var TagBox = _select_box.default.inherit({
            _supportedKeys: function() {
                var _this = this;
                var parent = this.callBase();
                var sendToList = function(options) {
                    return _this._list._keyboardHandler(options)
                };
                var rtlEnabled = this.option("rtlEnabled");
                return (0, _extend.extend)({}, parent, {
                    backspace: function(e) {
                        if (!this._isCaretAtTheStart()) {
                            return
                        }
                        this._processKeyboardEvent(e);
                        this._isTagRemoved = true;
                        var $tagToDelete = this._$focusedTag || this._tagElements().last();
                        if (this._$focusedTag) {
                            this._moveTagFocus("prev", true)
                        }
                        if (0 === $tagToDelete.length) {
                            return
                        }
                        this._preserveFocusedTag = true;
                        this._removeTagElement($tagToDelete);
                        delete this._preserveFocusedTag
                    },
                    upArrow: function(e, opts) {
                        return e.altKey || !_this._list ? parent.upArrow.call(_this, e) : sendToList(opts)
                    },
                    downArrow: function(e, opts) {
                        return e.altKey || !_this._list ? parent.downArrow.call(_this, e) : sendToList(opts)
                    },
                    del: function(e) {
                        if (!this._$focusedTag || !this._isCaretAtTheStart()) {
                            return
                        }
                        this._processKeyboardEvent(e);
                        this._isTagRemoved = true;
                        var $tagToDelete = this._$focusedTag;
                        this._moveTagFocus("next", true);
                        this._preserveFocusedTag = true;
                        this._removeTagElement($tagToDelete);
                        delete this._preserveFocusedTag
                    },
                    enter: function(e, options) {
                        var isListItemFocused = this._list && null !== this._list.option("focusedElement");
                        var isCustomItem = this.option("acceptCustomValue") && !isListItemFocused;
                        if (isCustomItem) {
                            e.preventDefault();
                            "" !== this._searchValue() && this._customItemAddedHandler(e);
                            return
                        }
                        if (this.option("opened")) {
                            this._saveValueChangeEvent(e);
                            sendToList(options);
                            e.preventDefault()
                        }
                    },
                    space: function(e, options) {
                        var isOpened = this.option("opened");
                        var isInputActive = this._shouldRenderSearchEvent();
                        if (isOpened && !isInputActive) {
                            this._saveValueChangeEvent(e);
                            sendToList(options);
                            e.preventDefault()
                        }
                    },
                    leftArrow: function(e) {
                        if (!this._isCaretAtTheStart() || this._isEmpty() || this._isEditable() && rtlEnabled && !this._$focusedTag) {
                            return
                        }
                        e.preventDefault();
                        var direction = rtlEnabled ? "next" : "prev";
                        this._moveTagFocus(direction);
                        !this.option("multiline") && this._scrollContainer(direction)
                    },
                    rightArrow: function(e) {
                        if (!this._isCaretAtTheStart() || this._isEmpty() || this._isEditable() && !rtlEnabled && !this._$focusedTag) {
                            return
                        }
                        e.preventDefault();
                        var direction = rtlEnabled ? "prev" : "next";
                        this._moveTagFocus(direction);
                        !this.option("multiline") && this._scrollContainer(direction)
                    }
                })
            },
            _processKeyboardEvent: function(e) {
                e.preventDefault();
                e.stopPropagation();
                this._saveValueChangeEvent(e)
            },
            _isEmpty: function() {
                return 0 === this._getValue().length
            },
            _updateTagsContainer: function($element) {
                this._$tagsContainer = $element.addClass(TAGBOX_TAG_CONTAINER_CLASS).addClass(NATIVE_CLICK_CLASS);
                this._$tagsContainer.parent().addClass(NATIVE_CLICK_CLASS)
            },
            _allowSelectItemByTab: function() {
                return false
            },
            _isCaretAtTheStart: function() {
                var position = (0, _utils.default)(this._input());
                return 0 === position.start && 0 === position.end
            },
            _moveTagFocus: function(direction, clearOnBoundary) {
                if (!this._$focusedTag) {
                    var tagElements = this._tagElements();
                    this._$focusedTag = "next" === direction ? tagElements.first() : tagElements.last();
                    this._toggleFocusClass(true, this._$focusedTag);
                    return
                }
                var $nextFocusedTag = this._$focusedTag[direction](".".concat(TAGBOX_TAG_CLASS));
                if ($nextFocusedTag.length > 0) {
                    this._replaceFocusedTag($nextFocusedTag)
                } else {
                    if (clearOnBoundary || "next" === direction && this._isEditable()) {
                        this._clearTagFocus()
                    }
                }
            },
            _replaceFocusedTag: function($nextFocusedTag) {
                this._toggleFocusClass(false, this._$focusedTag);
                this._$focusedTag = $nextFocusedTag;
                this._toggleFocusClass(true, this._$focusedTag)
            },
            _clearTagFocus: function() {
                if (!this._$focusedTag) {
                    return
                }
                this._toggleFocusClass(false, this._$focusedTag);
                delete this._$focusedTag
            },
            _focusClassTarget: function($element) {
                if ($element && $element.length && $element[0] !== this._focusTarget()[0]) {
                    return $element
                }
                return this.callBase()
            },
            _scrollContainer: function(direction) {
                if (this.option("multiline") || !(0, _window.hasWindow)()) {
                    return
                }
                if (!this._$tagsContainer) {
                    return
                }
                var scrollPosition = this._getScrollPosition(direction);
                this._$tagsContainer.scrollLeft(scrollPosition)
            },
            _getScrollPosition: function(direction) {
                if ("start" === direction || "end" === direction) {
                    return this._getBorderPosition(direction)
                }
                return this._$focusedTag ? this._getFocusedTagPosition(direction) : this._getBorderPosition("end")
            },
            _getBorderPosition: function(direction) {
                var rtlEnabled = this.option("rtlEnabled");
                var isScrollLeft = "end" === direction ^ rtlEnabled;
                var scrollBehavior = (0, _scroll_rtl_behavior.default)();
                var isScrollInverted = rtlEnabled && scrollBehavior.decreasing ^ scrollBehavior.positive;
                var scrollSign = !rtlEnabled || scrollBehavior.positive ? 1 : -1;
                return isScrollLeft ^ !isScrollInverted ? 0 : scrollSign * (this._$tagsContainer.get(0).scrollWidth - this._$tagsContainer.outerWidth())
            },
            _getFocusedTagPosition: function(direction) {
                var rtlEnabled = this.option("rtlEnabled");
                var isScrollLeft = "next" === direction ^ rtlEnabled;
                var _this$_$focusedTag$po = this._$focusedTag.position(),
                    scrollOffset = _this$_$focusedTag$po.left;
                var scrollLeft = this._$tagsContainer.scrollLeft();
                if (isScrollLeft) {
                    scrollOffset += this._$focusedTag.outerWidth(true) - this._$tagsContainer.outerWidth()
                }
                if (isScrollLeft ^ scrollOffset < 0) {
                    var scrollBehavior = (0, _scroll_rtl_behavior.default)();
                    var scrollCorrection = rtlEnabled && !scrollBehavior.decreasing && scrollBehavior.positive ? -1 : 1;
                    scrollLeft += scrollOffset * scrollCorrection
                }
                return scrollLeft
            },
            _setNextValue: _common.noop,
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    value: [],
                    showDropDownButton: false,
                    maxFilterLength: 1500,
                    tagTemplate: "tag",
                    selectAllText: _message.default.format("dxList-selectAll"),
                    hideSelectedItems: false,
                    selectedItems: [],
                    selectAllMode: "page",
                    onSelectAllValueChanged: null,
                    maxDisplayedTags: void 0,
                    showMultiTagOnly: true,
                    onMultiTagPreparing: null,
                    multiline: true,
                    useSubmitBehavior: true
                })
            },
            _init: function() {
                this.callBase();
                this._selectedItems = [];
                this._initSelectAllValueChangedAction()
            },
            _initActions: function() {
                this.callBase();
                this._initMultiTagPreparingAction()
            },
            _initMultiTagPreparingAction: function() {
                this._multiTagPreparingAction = this._createActionByOption("onMultiTagPreparing", {
                    beforeExecute: function(e) {
                        this._multiTagPreparingHandler(e.args[0])
                    }.bind(this),
                    excludeValidators: ["disabled", "readOnly"]
                })
            },
            _multiTagPreparingHandler: function(args) {
                var _this$_getValue = this._getValue(),
                    selectedCount = _this$_getValue.length;
                if (!this.option("showMultiTagOnly")) {
                    args.text = _message.default.getFormatter("dxTagBox-moreSelected")(selectedCount - this.option("maxDisplayedTags") + 1)
                } else {
                    args.text = _message.default.getFormatter("dxTagBox-selected")(selectedCount)
                }
            },
            _initDynamicTemplates: function() {
                this.callBase();
                this._templateManager.addDefaultTemplates({
                    tag: new _bindable_template.BindableTemplate(function($container, data) {
                        var _data$text;
                        var $tagContent = (0, _renderer.default)("<div>").addClass(TAGBOX_TAG_CONTENT_CLASS);
                        (0, _renderer.default)("<span>").text(null !== (_data$text = data.text) && void 0 !== _data$text ? _data$text : data).appendTo($tagContent);
                        (0, _renderer.default)("<div>").addClass(TAGBOX_TAG_REMOVE_BUTTON_CLASS).appendTo($tagContent);
                        $container.append($tagContent)
                    }, ["text"], this.option("integrationOptions.watchMethod"), {
                        text: this._displayGetter
                    })
                })
            },
            _toggleSubmitElement: function(enabled) {
                if (enabled) {
                    this._renderSubmitElement();
                    this._setSubmitValue()
                } else {
                    this._$submitElement && this._$submitElement.remove();
                    delete this._$submitElement
                }
            },
            _renderSubmitElement: function() {
                if (!this.option("useSubmitBehavior")) {
                    return
                }
                this._$submitElement = (0, _renderer.default)("<select>").attr("multiple", "multiple").css("display", "none").appendTo(this.$element())
            },
            _setSubmitValue: function() {
                if (!this.option("useSubmitBehavior")) {
                    return
                }
                var value = this._getValue();
                var $options = [];
                for (var i = 0, n = value.length; i < n; i++) {
                    var useDisplayText = this._shouldUseDisplayValue(value[i]);
                    $options.push((0, _renderer.default)("<option>").val(useDisplayText ? this._displayGetter(value[i]) : value[i]).attr("selected", "selected"))
                }
                this._getSubmitElement().empty().append($options)
            },
            _initMarkup: function() {
                this._tagElementsCache = (0, _renderer.default)();
                var isSingleLineMode = !this.option("multiline");
                this.$element().addClass(TAGBOX_CLASS).toggleClass(TAGBOX_ONLY_SELECT_CLASS, !(this.option("searchEnabled") || this.option("acceptCustomValue"))).toggleClass(TAGBOX_SINGLE_LINE_CLASS, isSingleLineMode);
                this._initTagTemplate();
                this.callBase()
            },
            _render: function() {
                this.callBase();
                this._renderTagRemoveAction();
                this._renderSingleLineScroll();
                this._scrollContainer("start")
            },
            _initTagTemplate: function() {
                this._tagTemplate = this._getTemplateByOption("tagTemplate")
            },
            _renderField: function() {
                var isDefaultFieldTemplate = !(0, _type.isDefined)(this.option("fieldTemplate"));
                this.$element().toggleClass(TAGBOX_DEFAULT_FIELD_TEMPLATE_CLASS, isDefaultFieldTemplate).toggleClass(TAGBOX_CUSTOM_FIELD_TEMPLATE_CLASS, !isDefaultFieldTemplate);
                this.callBase()
            },
            _renderTagRemoveAction: function() {
                var tagRemoveAction = this._createAction(this._removeTagHandler.bind(this));
                var eventName = (0, _index.addNamespace)(_click.name, "dxTagBoxTagRemove");
                _events_engine.default.off(this._$tagsContainer, eventName);
                _events_engine.default.on(this._$tagsContainer, eventName, ".".concat(TAGBOX_TAG_REMOVE_BUTTON_CLASS), function(event) {
                    tagRemoveAction({
                        event: event
                    })
                });
                this._renderTypingEvent()
            },
            _renderSingleLineScroll: function() {
                var mouseWheelEvent = (0, _index.addNamespace)("dxmousewheel", this.NAME);
                var $element = this.$element();
                var isMultiline = this.option("multiline");
                _events_engine.default.off($element, mouseWheelEvent);
                if ("desktop" !== _devices.default.real().deviceType) {
                    this._$tagsContainer && this._$tagsContainer.css("overflowX", isMultiline ? "" : "auto");
                    return
                }
                if (isMultiline) {
                    return
                }
                _events_engine.default.on($element, mouseWheelEvent, this._tagContainerMouseWheelHandler.bind(this))
            },
            _tagContainerMouseWheelHandler: function(e) {
                var scrollLeft = this._$tagsContainer.scrollLeft();
                var delta = e.delta * TAGBOX_MOUSE_WHEEL_DELTA_MULTIPLIER;
                if (!(0, _index.isCommandKeyPressed)(e) && (0, _utils3.allowScroll)(this._$tagsContainer, delta, true)) {
                    this._$tagsContainer.scrollLeft(scrollLeft + delta);
                    return false
                }
            },
            _renderTypingEvent: function() {
                var _this2 = this;
                var input = this._input();
                var namespace = (0, _index.addNamespace)("keydown", this.NAME);
                _events_engine.default.off(input, namespace);
                _events_engine.default.on(input, namespace, function(e) {
                    var keyName = (0, _index.normalizeKeyName)(e);
                    if (!_this2._isControlKey(keyName) && _this2._isEditable()) {
                        _this2._clearTagFocus()
                    }
                })
            },
            _popupWrapperClass: function() {
                return this.callBase() + " " + TAGBOX_POPUP_WRAPPER_CLASS
            },
            _renderInput: function() {
                this.callBase();
                this._renderPreventBlur(this._inputWrapper())
            },
            _renderInputValueImpl: function() {
                return this._renderMultiSelect()
            },
            _loadInputValue: function() {
                return (0, _deferred.when)()
            },
            _clearTextValue: function() {
                this._input().val("");
                this._toggleEmptinessEventHandler();
                this.option("text", "")
            },
            _focusInHandler: function(e) {
                if (!this._preventNestedFocusEvent(e)) {
                    this._scrollContainer("end")
                }
                this.callBase(e)
            },
            _renderInputValue: function() {
                this.option("displayValue", this._searchValue());
                return this.callBase()
            },
            _restoreInputText: function(saveEditingValue) {
                if (!saveEditingValue) {
                    this._clearTextValue()
                }
            },
            _focusOutHandler: function(e) {
                if (!this._preventNestedFocusEvent(e)) {
                    this._clearTagFocus();
                    this._scrollContainer("start")
                }
                this.callBase(e)
            },
            _getFirstPopupElement: function() {
                return this.option("showSelectionControls") ? this._list.$element() : this.callBase()
            },
            _initSelectAllValueChangedAction: function() {
                this._selectAllValueChangeAction = this._createActionByOption("onSelectAllValueChanged")
            },
            _renderList: function() {
                var _this3 = this;
                this.callBase();
                this._setListDataSourceFilter();
                if (this.option("showSelectionControls")) {
                    this._list.registerKeyHandler("tab", function(e) {
                        return _this3._popupElementTabHandler(e)
                    });
                    this._list.registerKeyHandler("escape", function(e) {
                        return _this3._popupElementEscHandler(e)
                    })
                }
            },
            _canListHaveFocus: function() {
                return "useButtons" === this.option("applyValueMode")
            },
            _listConfig: function() {
                var _this4 = this;
                var selectionMode = this.option("showSelectionControls") ? "all" : "multiple";
                return (0, _extend.extend)(this.callBase(), {
                    selectionMode: selectionMode,
                    selectAllText: this.option("selectAllText"),
                    onSelectAllValueChanged: function(_ref) {
                        var value = _ref.value;
                        _this4._selectAllValueChangeAction({
                            value: value
                        })
                    },
                    selectAllMode: this.option("selectAllMode"),
                    selectedItems: this._selectedItems,
                    onFocusedItemChanged: null
                })
            },
            _renderMultiSelect: function() {
                var _this5 = this;
                var d = new _deferred.Deferred;
                this._updateTagsContainer(this._$textEditorInputContainer);
                this._renderInputSize();
                this._renderTags().done(function() {
                    _this5._popup && _this5._popup.refreshPosition();
                    d.resolve()
                }).fail(d.reject);
                return d.promise()
            },
            _listItemClickHandler: function(e) {
                !this.option("showSelectionControls") && this._clearTextValue();
                if ("useButtons" === this.option("applyValueMode")) {
                    return
                }
                this.callBase(e);
                this._saveValueChangeEvent(void 0)
            },
            _shouldClearFilter: function() {
                var shouldClearFilter = this.callBase();
                var showSelectionControls = this.option("showSelectionControls");
                return !showSelectionControls && shouldClearFilter
            },
            _renderInputSize: function() {
                var $input = this._input();
                var value = $input.val();
                var isEmptyInput = (0, _type.isString)(value) && value;
                var cursorWidth = 5;
                var width = "";
                var size = "";
                var canTypeText = this.option("searchEnabled") || this.option("acceptCustomValue");
                if (isEmptyInput && canTypeText) {
                    var $calculationElement = (0, _dom.createTextElementHiddenCopy)($input, value, {
                        includePaddings: true
                    });
                    $calculationElement.insertAfter($input);
                    width = $calculationElement.outerWidth() + cursorWidth;
                    $calculationElement.remove()
                } else {
                    if (!value) {
                        size = 1
                    }
                }
                $input.css("width", width);
                $input.attr("size", size)
            },
            _renderInputSubstitution: function() {
                this.callBase();
                this._updateWidgetHeight()
            },
            _getValue: function() {
                return this.option("value") || []
            },
            _multiTagRequired: function() {
                var values = this._getValue();
                var maxDisplayedTags = this.option("maxDisplayedTags");
                return (0, _type.isDefined)(maxDisplayedTags) && values.length > maxDisplayedTags
            },
            _renderMultiTag: function($input) {
                var $tag = (0, _renderer.default)("<div>").addClass(TAGBOX_TAG_CLASS).addClass(TAGBOX_MULTI_TAG_CLASS);
                var args = {
                    multiTagElement: (0, _element.getPublicElement)($tag),
                    selectedItems: this.option("selectedItems")
                };
                this._multiTagPreparingAction(args);
                if (args.cancel) {
                    return false
                }
                $tag.data(TAGBOX_TAG_DATA_KEY, args.text);
                $tag.insertBefore($input);
                this._tagTemplate.render({
                    model: args.text,
                    container: (0, _element.getPublicElement)($tag)
                });
                return $tag
            },
            _getFilteredItems: function(values) {
                var _this$_list, _this6 = this;
                var creator = new _selection_filter.SelectionFilterCreator(values);
                var listSelectedItems = null === (_this$_list = this._list) || void 0 === _this$_list ? void 0 : _this$_list.option("selectedItems");
                var isListItemsLoaded = !!listSelectedItems && this._list.getDataSource().isLoaded();
                var selectedItems = listSelectedItems || this.option("selectedItems");
                var clientFilterFunction = creator.getLocalFilter(this._valueGetter);
                var filteredItems = selectedItems.filter(clientFilterFunction);
                var selectedItemsAlreadyLoaded = filteredItems.length === values.length;
                var d = new _deferred.Deferred;
                if ((!this._isDataSourceChanged || isListItemsLoaded) && selectedItemsAlreadyLoaded) {
                    return d.resolve(filteredItems).promise()
                } else {
                    var dataSource = this._dataSource;
                    var dataSourceFilter = dataSource.filter();
                    var filterExpr = creator.getCombinedFilter(this.option("valueExpr"), dataSourceFilter);
                    var filterLength = encodeURI(JSON.stringify(filterExpr)).length;
                    var filter = filterLength > this.option("maxFilterLength") ? void 0 : filterExpr;
                    var _dataSource$loadOptio = dataSource.loadOptions(),
                        customQueryParams = _dataSource$loadOptio.customQueryParams,
                        expand = _dataSource$loadOptio.expand,
                        select = _dataSource$loadOptio.select;
                    dataSource.store().load({
                        filter: filter,
                        customQueryParams: customQueryParams,
                        expand: expand,
                        select: select
                    }).done(function(data, extra) {
                        _this6._isDataSourceChanged = false;
                        if (_this6._disposed) {
                            d.reject();
                            return
                        }
                        var _normalizeLoadResult = (0, _utils2.normalizeLoadResult)(data, extra),
                            items = _normalizeLoadResult.data;
                        var mappedItems = dataSource._applyMapFunction(items);
                        d.resolve(mappedItems.filter(clientFilterFunction))
                    }).fail(d.reject);
                    return d.promise()
                }
            },
            _createTagsData: function(values, filteredItems) {
                var _this7 = this;
                var items = [];
                var cache = {};
                var isValueExprSpecified = "this" === this._valueGetterExpr();
                var filteredValues = {};
                filteredItems.forEach(function(filteredItem) {
                    var filteredItemValue = isValueExprSpecified ? JSON.stringify(filteredItem) : _this7._valueGetter(filteredItem);
                    filteredValues[filteredItemValue] = filteredItem
                });
                var loadItemPromises = [];
                values.forEach(function(value, index) {
                    var currentItem = filteredValues[isValueExprSpecified ? JSON.stringify(value) : value];
                    if (isValueExprSpecified && !(0, _type.isDefined)(currentItem)) {
                        loadItemPromises.push(_this7._loadItem(value, cache).always(function(item) {
                            var newItem = _this7._createTagData(items, item, value, index);
                            items.splice(index, 0, newItem)
                        }))
                    } else {
                        var newItem = _this7._createTagData(items, currentItem, value, index);
                        items.splice(index, 0, newItem)
                    }
                });
                var d = new _deferred.Deferred;
                _deferred.when.apply(this, loadItemPromises).always(function() {
                    d.resolve(items)
                });
                return d.promise()
            },
            _createTagData: function(items, item, value, valueIndex) {
                if ((0, _type.isDefined)(item)) {
                    this._selectedItems.push(item);
                    return item
                } else {
                    var selectedItem = this.option("selectedItem");
                    var customItem = this._valueGetter(selectedItem) === value ? selectedItem : value;
                    return customItem
                }
            },
            _isGroupedData: function() {
                return this.option("grouped") && !this._dataSource.group()
            },
            _getItemsByValues: function(values) {
                var resultItems = [];
                values.forEach(function(value) {
                    var item = this._getItemFromPlain(value);
                    if ((0, _type.isDefined)(item)) {
                        resultItems.push(item)
                    }
                }.bind(this));
                return resultItems
            },
            _getFilteredGroupedItems: function(values) {
                var selectedItems = new _deferred.Deferred;
                if (!this._dataSource.items().length) {
                    this._dataSource.load().done(function() {
                        selectedItems.resolve(this._getItemsByValues(values))
                    }.bind(this)).fail(selectedItems.resolve([]))
                } else {
                    selectedItems.resolve(this._getItemsByValues(values))
                }
                return selectedItems.promise()
            },
            _loadTagsData: function() {
                var _this8 = this;
                var values = this._getValue();
                var tagData = new _deferred.Deferred;
                this._selectedItems = [];
                var filteredItemsPromise = this._isGroupedData() ? this._getFilteredGroupedItems(values) : this._getFilteredItems(values);
                filteredItemsPromise.done(function(filteredItems) {
                    var items = _this8._createTagsData(values, filteredItems);
                    items.always(function(data) {
                        tagData.resolve(data)
                    })
                }).fail(tagData.reject.bind(this));
                return tagData.promise()
            },
            _renderTags: function() {
                var _this9 = this;
                var d = new _deferred.Deferred;
                var isPlainDataUsed = false;
                if (this._shouldGetItemsFromPlain(this._valuesToUpdate)) {
                    this._selectedItems = this._getItemsFromPlain(this._valuesToUpdate);
                    if (this._selectedItems.length === this._valuesToUpdate.length) {
                        this._renderTagsImpl(this._selectedItems);
                        isPlainDataUsed = true;
                        d.resolve()
                    }
                }
                if (!isPlainDataUsed) {
                    this._loadTagsData().done(function(items) {
                        if (_this9._disposed) {
                            d.reject();
                            return
                        }
                        _this9._renderTagsImpl(items);
                        d.resolve()
                    }).fail(d.reject)
                }
                return d.promise()
            },
            _renderTagsImpl: function(items) {
                this._renderTagsCore(items);
                this._renderEmptyState();
                if (!this._preserveFocusedTag) {
                    this._clearTagFocus()
                }
            },
            _shouldGetItemsFromPlain: function(values) {
                return values && this._dataSource.isLoaded() && values.length <= this._getPlainItems().length
            },
            _getItemsFromPlain: function(values) {
                var selectedItems = this._getSelectedItemsFromList(values);
                var needFilterPlainItems = 0 === selectedItems.length && values.length > 0 || selectedItems.length < values.length;
                if (needFilterPlainItems) {
                    var plainItems = this._getPlainItems();
                    selectedItems = this._filterSelectedItems(plainItems, values)
                }
                return selectedItems
            },
            _getSelectedItemsFromList: function(values) {
                var _this$_list2;
                var listSelectedItems = null === (_this$_list2 = this._list) || void 0 === _this$_list2 ? void 0 : _this$_list2.option("selectedItems");
                var selectedItems = [];
                if (values.length === (null === listSelectedItems || void 0 === listSelectedItems ? void 0 : listSelectedItems.length)) {
                    selectedItems = this._filterSelectedItems(listSelectedItems, values)
                }
                return selectedItems
            },
            _filterSelectedItems: function(plainItems, values) {
                var _this10 = this;
                var selectedItems = plainItems.filter(function(dataItem) {
                    var currentValue;
                    for (var i = 0; i < values.length; i++) {
                        currentValue = values[i];
                        if ((0, _type.isObject)(currentValue)) {
                            if (_this10._isValueEquals(dataItem, currentValue)) {
                                return true
                            }
                        } else {
                            if (_this10._isValueEquals(_this10._valueGetter(dataItem), currentValue)) {
                                return true
                            }
                        }
                    }
                    return false
                }, this);
                return selectedItems
            },
            _integrateInput: function() {
                this.callBase();
                this._updateTagsContainer((0, _renderer.default)(".".concat(TEXTEDITOR_INPUT_CONTAINER_CLASS)));
                this._renderTagRemoveAction()
            },
            _renderTagsCore: function(items) {
                var _this11 = this;
                this._renderField();
                this.option("selectedItems", this._selectedItems.slice());
                this._cleanTags();
                var $multiTag = this._multiTagRequired() && this._renderMultiTag(this._input());
                var showMultiTagOnly = this.option("showMultiTagOnly");
                var maxDisplayedTags = this.option("maxDisplayedTags");
                items.forEach(function(item, index) {
                    if ($multiTag && showMultiTagOnly || $multiTag && !showMultiTagOnly && index - maxDisplayedTags >= -1) {
                        return false
                    }
                    _this11._renderTag(item, $multiTag || _this11._input())
                });
                if (this._isFocused()) {
                    this._scrollContainer("end")
                }
                this._refreshTagElements()
            },
            _cleanTags: function() {
                if (this._multiTagRequired()) {
                    this._tagElements().remove()
                } else {
                    var $tags = this._tagElements();
                    var values = this._getValue();
                    (0, _iterator.each)($tags, function(_, tag) {
                        var $tag = (0, _renderer.default)(tag);
                        var index = (0, _array.inArray)($tag.data(TAGBOX_TAG_DATA_KEY), values);
                        if (index < 0) {
                            $tag.remove()
                        }
                    })
                }
            },
            _renderEmptyState: function() {
                var isEmpty = !(this._getValue().length || this._selectedItems.length || this._searchValue());
                this._toggleEmptiness(isEmpty);
                this._renderDisplayText()
            },
            _renderDisplayText: function() {
                this._renderInputSize()
            },
            _refreshTagElements: function() {
                this._tagElementsCache = this.$element().find(".".concat(TAGBOX_TAG_CLASS))
            },
            _tagElements: function() {
                return this._tagElementsCache
            },
            _applyTagTemplate: function(item, $tag) {
                this._tagTemplate.render({
                    model: item,
                    container: (0, _element.getPublicElement)($tag)
                })
            },
            _renderTag: function(item, $input) {
                var value = this._valueGetter(item);
                if (!(0, _type.isDefined)(value)) {
                    return
                }
                var $tag = this._getTag(value);
                var displayValue = this._displayGetter(item);
                var itemModel = this._getItemModel(item, displayValue);
                if ($tag) {
                    if ((0, _type.isDefined)(displayValue)) {
                        $tag.empty();
                        this._applyTagTemplate(itemModel, $tag)
                    }
                    $tag.removeClass(TAGBOX_CUSTOM_TAG_CLASS)
                } else {
                    $tag = this._createTag(value, $input);
                    if ((0, _type.isDefined)(item)) {
                        this._applyTagTemplate(itemModel, $tag)
                    } else {
                        $tag.addClass(TAGBOX_CUSTOM_TAG_CLASS);
                        this._applyTagTemplate(value, $tag)
                    }
                }
            },
            _getItemModel: function(item, displayValue) {
                if ((0, _type.isObject)(item) && (0, _type.isDefined)(displayValue)) {
                    return item
                } else {
                    return (0, _common.ensureDefined)(displayValue, "")
                }
            },
            _getTag: function(value) {
                var $tags = this._tagElements();
                var tagsLength = $tags.length;
                var result = false;
                for (var i = 0; i < tagsLength; i++) {
                    var $tag = $tags[i];
                    var tagData = (0, _element_data.data)($tag, TAGBOX_TAG_DATA_KEY);
                    if (value === tagData || (0, _common.equalByValue)(value, tagData)) {
                        result = (0, _renderer.default)($tag);
                        break
                    }
                }
                return result
            },
            _createTag: function(value, $input) {
                return (0, _renderer.default)("<div>").addClass(TAGBOX_TAG_CLASS).data(TAGBOX_TAG_DATA_KEY, value).insertBefore($input)
            },
            _toggleEmptinessEventHandler: function() {
                this._toggleEmptiness(!this._getValue().length && !this._searchValue().length)
            },
            _customItemAddedHandler: function(e) {
                this.callBase(e);
                this._clearTextValue()
            },
            _removeTagHandler: function(args) {
                var e = args.event;
                e.stopPropagation();
                this._saveValueChangeEvent(e);
                var $tag = (0, _renderer.default)(e.target).closest(".".concat(TAGBOX_TAG_CLASS));
                this._removeTagElement($tag)
            },
            _removeTagElement: function($tag) {
                if ($tag.hasClass(TAGBOX_MULTI_TAG_CLASS)) {
                    if (!this.option("showMultiTagOnly")) {
                        this.option("value", this._getValue().slice(0, this.option("maxDisplayedTags")))
                    } else {
                        this.reset()
                    }
                    return
                }
                var itemValue = $tag.data(TAGBOX_TAG_DATA_KEY);
                this._removeTagWithUpdate(itemValue);
                this._refreshTagElements()
            },
            _updateField: _common.noop,
            _removeTagWithUpdate: function(itemValue) {
                var value = this._getValue().slice();
                this._removeTag(value, itemValue);
                this.option("value", value);
                if (0 === value.length) {
                    this._clearTagFocus()
                }
            },
            _getCurrentValue: function() {
                return this._lastValue()
            },
            _selectionChangeHandler: function(e) {
                var _this12 = this;
                if ("useButtons" === this.option("applyValueMode")) {
                    return
                }
                var value = this._getValue().slice();
                (0, _iterator.each)(e.removedItems || [], function(_, removedItem) {
                    _this12._removeTag(value, _this12._valueGetter(removedItem))
                });
                (0, _iterator.each)(e.addedItems || [], function(_, addedItem) {
                    _this12._addTag(value, _this12._valueGetter(addedItem))
                });
                this._updateWidgetHeight();
                if (!(0, _common.equalByValue)(this._list.option("selectedItemKeys"), this.option("value"))) {
                    var listSelectionChangeEvent = this._list._getSelectionChangeEvent();
                    listSelectionChangeEvent && this._saveValueChangeEvent(listSelectionChangeEvent);
                    this.option("value", value)
                }
                this._list._saveSelectionChangeEvent(void 0)
            },
            _removeTag: function(value, item) {
                var index = this._valueIndex(item, value);
                if (index >= 0) {
                    value.splice(index, 1)
                }
            },
            _addTag: function(value, item) {
                var index = this._valueIndex(item);
                if (index < 0) {
                    value.push(item)
                }
            },
            _fieldRenderData: function() {
                return this._selectedItems.slice()
            },
            _completeSelection: function(value) {
                if (!this.option("showSelectionControls")) {
                    this._setValue(value)
                }
            },
            _setValue: function(value) {
                if (null === value) {
                    return
                }
                var useButtons = "useButtons" === this.option("applyValueMode");
                var valueIndex = this._valueIndex(value);
                var values = (useButtons ? this._list.option("selectedItemKeys") : this._getValue()).slice();
                if (valueIndex >= 0) {
                    values.splice(valueIndex, 1)
                } else {
                    values.push(value)
                }
                if ("useButtons" === this.option("applyValueMode")) {
                    this._list.option("selectedItemKeys", values)
                } else {
                    this.option("value", values)
                }
            },
            _isSelectedValue: function(value, cache) {
                return this._valueIndex(value, null, cache) > -1
            },
            _valueIndex: function(value, values, cache) {
                var _this13 = this;
                var result = -1;
                if (cache && "object" !== _typeof(value)) {
                    if (!cache.indexByValues) {
                        cache.indexByValues = {};
                        values = values || this._getValue();
                        values.forEach(function(value, index) {
                            cache.indexByValues[value] = index
                        })
                    }
                    if (value in cache.indexByValues) {
                        return cache.indexByValues[value]
                    }
                }
                values = values || this._getValue();
                (0, _iterator.each)(values, function(index, selectedValue) {
                    if (_this13._isValueEquals(value, selectedValue)) {
                        result = index;
                        return false
                    }
                });
                return result
            },
            _lastValue: function() {
                var values = this._getValue();
                var lastValue = values[values.length - 1];
                return null !== lastValue && void 0 !== lastValue ? lastValue : null
            },
            _valueChangeEventHandler: _common.noop,
            _shouldRenderSearchEvent: function() {
                return this.option("searchEnabled") || this.option("acceptCustomValue")
            },
            _searchHandler: function(e) {
                if (this.option("searchEnabled") && !!e && !this._isTagRemoved) {
                    this.callBase(e);
                    this._setListDataSourceFilter()
                }
                this._updateWidgetHeight();
                delete this._isTagRemoved
            },
            _updateWidgetHeight: function() {
                var element = this.$element();
                var originalHeight = element.height();
                this._renderInputSize();
                var currentHeight = element.height();
                if (this._popup && this.option("opened") && this._isEditable() && currentHeight !== originalHeight) {
                    this._popup.repaint()
                }
            },
            _refreshSelected: function() {
                var _this$_list3;
                (null === (_this$_list3 = this._list) || void 0 === _this$_list3 ? void 0 : _this$_list3.getDataSource()) && this._list.option("selectedItems", this._selectedItems)
            },
            _resetListDataSourceFilter: function() {
                var dataSource = this._getDataSource();
                if (!dataSource) {
                    return
                }
                delete this._userFilter;
                dataSource.filter(null);
                dataSource.reload()
            },
            _setListDataSourceFilter: function() {
                if (!this.option("hideSelectedItems") || !this._list) {
                    return
                }
                var dataSource = this._getDataSource();
                if (!dataSource) {
                    return
                }
                var valueGetterExpr = this._valueGetterExpr();
                if ((0, _type.isString)(valueGetterExpr) && "this" !== valueGetterExpr) {
                    var filter = this._dataSourceFilterExpr();
                    if (void 0 === this._userFilter) {
                        this._userFilter = dataSource.filter() || null
                    }
                    this._userFilter && filter.push(this._userFilter);
                    filter.length ? dataSource.filter(filter) : dataSource.filter(null)
                } else {
                    dataSource.filter(this._dataSourceFilterFunction.bind(this))
                }
                dataSource.load()
            },
            _dataSourceFilterExpr: function() {
                var _this14 = this;
                var filter = [];
                (0, _iterator.each)(this._getValue(), function(index, value) {
                    filter.push(["!", [_this14._valueGetterExpr(), value]])
                });
                return filter
            },
            _dataSourceFilterFunction: function(itemData) {
                var _this15 = this;
                var itemValue = this._valueGetter(itemData);
                var result = true;
                (0, _iterator.each)(this._getValue(), function(index, value) {
                    if (_this15._isValueEquals(value, itemValue)) {
                        result = false;
                        return false
                    }
                });
                return result
            },
            _dataSourceChangedHandler: function() {
                this._isDataSourceChanged = true;
                this.callBase.apply(this, arguments)
            },
            _applyButtonHandler: function(args) {
                this._saveValueChangeEvent(args.event);
                this.option("value", this._getSortedListValues());
                this._clearTextValue();
                this.callBase();
                this._cancelSearchIfNeed()
            },
            _getSortedListValues: function() {
                var listValues = this._getListValues();
                var currentValue = this.option("value") || [];
                var existedItems = listValues.length ? currentValue.filter(function(item) {
                    return listValues.indexOf(item) !== -1
                }) : [];
                var newItems = existedItems.length ? listValues.filter(function(item) {
                    return currentValue.indexOf(item) === -1
                }) : listValues;
                return existedItems.concat(newItems);
            },
            _getListValues: function() {
                var _this16 = this;
                if (!this._list) {
                    return []
                }
                var selectedItems = this._getPlainItems(this._list.option("selectedItems"));
                var result = [];
                (0, _iterator.each)(selectedItems, function(index, item) {
                    result[index] = _this16._valueGetter(item)
                });
                return result
            },
            _setListDataSource: function() {
                var currentValue = this._getValue();
                this.callBase();
                if (currentValue !== this.option("value")) {
                    this.option("value", currentValue)
                }
                this._refreshSelected()
            },
            _renderOpenedState: function() {
                this.callBase();
                if ("useButtons" === this.option("applyValueMode") && !this.option("opened")) {
                    this._refreshSelected()
                }
            },
            reset: function() {
                this._restoreInputText();
                var defaultValue = this._getDefaultOptions().value;
                var currentValue = this.option("value");
                if (defaultValue && 0 === defaultValue.length && currentValue && defaultValue.length === currentValue.length) {
                    return
                }
                this.callBase()
            },
            _clean: function() {
                this.callBase();
                delete this._defaultTagTemplate;
                delete this._valuesToUpdate;
                delete this._tagTemplate
            },
            _removeDuplicates: function(from, what) {
                var _this17 = this;
                var result = [];
                (0, _iterator.each)(from, function(_, value) {
                    var filteredItems = what.filter(function(item) {
                        return _this17._valueGetter(value) === _this17._valueGetter(item)
                    });
                    if (!filteredItems.length) {
                        result.push(value)
                    }
                });
                return result
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "onSelectAllValueChanged":
                        this._initSelectAllValueChangedAction();
                        break;
                    case "onMultiTagPreparing":
                        this._initMultiTagPreparingAction();
                        this._renderTags();
                        break;
                    case "hideSelectedItems":
                        if (args.value) {
                            this._setListDataSourceFilter()
                        } else {
                            this._resetListDataSourceFilter()
                        }
                        break;
                    case "useSubmitBehavior":
                        this._toggleSubmitElement(args.value);
                        break;
                    case "displayExpr":
                        this.callBase(args);
                        this._initTemplates();
                        this._invalidate();
                        break;
                    case "tagTemplate":
                        this._initTagTemplate();
                        this._invalidate();
                        break;
                    case "selectAllText":
                        this._setListOption("selectAllText", this.option("selectAllText"));
                        break;
                    case "readOnly":
                    case "disabled":
                        this.callBase(args);
                        !args.value && this._renderTypingEvent();
                        break;
                    case "value":
                        this._valuesToUpdate = null === args || void 0 === args ? void 0 : args.value;
                        this.callBase(args);
                        this._valuesToUpdate = void 0;
                        this._setListDataSourceFilter();
                        break;
                    case "maxDisplayedTags":
                    case "showMultiTagOnly":
                        this._renderTags();
                        break;
                    case "selectAllMode":
                        this._setListOption(args.name, args.value);
                        break;
                    case "selectedItem":
                        break;
                    case "selectedItems":
                        this._selectionChangedAction({
                            addedItems: this._removeDuplicates(args.value, args.previousValue),
                            removedItems: this._removeDuplicates(args.previousValue, args.value)
                        });
                        break;
                    case "multiline":
                        this.$element().toggleClass(TAGBOX_SINGLE_LINE_CLASS, !args.value);
                        this._renderSingleLineScroll();
                        break;
                    case "maxFilterLength":
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _getActualSearchValue: function() {
                return this.callBase() || this._searchValue()
            },
            _popupHidingHandler: function() {
                this.callBase();
                this._clearFilter()
            }
        });
        (0, _component_registrator.default)("dxTagBox", TagBox);
        var _default = TagBox;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.accessibility.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.registerKeyboardAction = void 0;
        var accessibility = _interopRequireWildcard(__webpack_require__( /*! ../../ui/shared/accessibility */ 118));

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }
        var registerKeyboardAction = function(viewName, instance, $element, selector, action) {
            var keyboardController = instance.getController("keyboardNavigation");
            if (instance.option("useLegacyKeyboardNavigation") || keyboardController && !keyboardController.isKeyboardEnabled()) {
                return
            }
            var executeKeyDown = function(args) {
                instance.executeAction("onKeyDown", args)
            };
            instance.createAction("onKeyDown");
            accessibility.registerKeyboardAction(viewName, instance, $element, selector, action, executeKeyDown)
        };
        exports.registerKeyboardAction = registerKeyboardAction
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.utils.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.createGroupFilter = createGroupFilter;
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.utils */ 35));
        var _utils = _interopRequireDefault(__webpack_require__( /*! ../../data/utils */ 41));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function createGroupFilter(path, storeLoadOptions) {
            var groups = _utils.default.normalizeSortingInfo(storeLoadOptions.group);
            var filter = [];
            for (var i = 0; i < path.length; i++) {
                filter.push([groups[i].selector, "=", path[i]])
            }
            if (storeLoadOptions.filter) {
                filter.push(storeLoadOptions.filter)
            }
            return _uiGrid_core.default.combineFilters(filter)
        }
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/pivot_grid/data_source.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _utils = __webpack_require__( /*! ../../data/data_source/utils */ 69);
        var _abstract_store = _interopRequireDefault(__webpack_require__( /*! ../../data/abstract_store */ 105));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _events_strategy = __webpack_require__( /*! ../../core/events_strategy */ 100);
        var _inflector = __webpack_require__( /*! ../../core/utils/inflector */ 39);
        var _local_store = __webpack_require__( /*! ./local_store */ 772);
        var _remote_store = _interopRequireDefault(__webpack_require__( /*! ./remote_store */ 773));
        var _data_source = __webpack_require__( /*! ./data_source.utils */ 775);
        var _xmla_store = __webpack_require__( /*! ./xmla_store/xmla_store */ 426);
        var _uiPivot_grid = __webpack_require__( /*! ./ui.pivot_grid.summary_display_modes */ 776);
        var _uiPivot_grid2 = __webpack_require__( /*! ./ui.pivot_grid.utils */ 84);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DESCRIPTION_NAME_BY_AREA = {
            row: "rows",
            column: "columns",
            data: "values",
            filter: "filters"
        };
        var STATE_PROPERTIES = ["area", "areaIndex", "sortOrder", "filterType", "filterValues", "sortBy", "sortBySummaryField", "sortBySummaryPath", "expanded", "summaryType", "summaryDisplayMode"];
        var CALCULATED_PROPERTIES = ["format", "selector", "customizeText", "caption"];
        var ALL_CALCULATED_PROPERTIES = CALCULATED_PROPERTIES.concat(["allowSorting", "allowSortingBySummary", "allowFiltering", "allowExpandAll"]);

        function createCaption(field) {
            var caption = field.dataField || field.groupName || "";
            var summaryType = (field.summaryType || "").toLowerCase();
            if ((0, _type.isString)(field.groupInterval)) {
                caption += "_" + field.groupInterval
            }
            if (summaryType && "custom" !== summaryType) {
                summaryType = summaryType.replace(/^./, summaryType[0].toUpperCase());
                if (caption.length) {
                    summaryType = " (" + summaryType + ")"
                }
            } else {
                summaryType = ""
            }
            return (0, _inflector.titleize)(caption) + summaryType
        }

        function resetFieldState(field, properties) {
            var initialProperties = field._initProperties || {};
            (0, _iterator.each)(properties, function(_, prop) {
                if (Object.prototype.hasOwnProperty.call(initialProperties, prop)) {
                    field[prop] = initialProperties[prop]
                }
            })
        }

        function updateCalculatedFieldProperties(field, calculatedProperties) {
            resetFieldState(field, calculatedProperties);
            if (!(0, _type.isDefined)(field.caption)) {
                (0, _uiPivot_grid2.setFieldProperty)(field, "caption", createCaption(field))
            }
        }

        function areExpressionsUsed(dataFields) {
            return dataFields.some(function(field) {
                return field.summaryDisplayMode || field.calculateSummaryValue
            })
        }

        function isRunningTotalUsed(dataFields) {
            return dataFields.some(function(field) {
                return !!field.runningTotal
            })
        }

        function isDataExists(data) {
            return data.rows.length || data.columns.length || data.values.length
        }
        var _default = _class.default.inherit(function() {
            var findHeaderItem = function(headerItems, path) {
                if (headerItems._cacheByPath) {
                    return headerItems._cacheByPath[path.join(".")] || null
                }
            };
            var getHeaderItemsLastIndex = function getHeaderItemsLastIndex(headerItems, grandTotalIndex) {
                var i;
                var lastIndex = -1;
                var headerItem;
                if (headerItems) {
                    for (i = 0; i < headerItems.length; i++) {
                        headerItem = headerItems[i];
                        if (void 0 !== headerItem.index) {
                            lastIndex = Math.max(lastIndex, headerItem.index)
                        }
                        if (headerItem.children) {
                            lastIndex = Math.max(lastIndex, getHeaderItemsLastIndex(headerItem.children))
                        } else {
                            if (headerItem.collapsedChildren) {
                                lastIndex = Math.max(lastIndex, getHeaderItemsLastIndex(headerItem.collapsedChildren))
                            }
                        }
                    }
                }
                if ((0, _type.isDefined)(grandTotalIndex)) {
                    lastIndex = Math.max(lastIndex, grandTotalIndex)
                }
                return lastIndex
            };
            var updateHeaderItemChildren = function(headerItems, headerItem, children, grandTotalIndex) {
                var applyingHeaderItemsCount = getHeaderItemsLastIndex(children) + 1;
                var emptyIndex = getHeaderItemsLastIndex(headerItems, grandTotalIndex) + 1;
                var index;
                var applyingItemIndexesToCurrent = [];
                var needIndexUpdate = false;
                var d = new _deferred.Deferred;
                if (headerItem.children && headerItem.children.length === children.length) {
                    for (var i = 0; i < children.length; i++) {
                        var child = children[i];
                        if (void 0 !== child.index) {
                            if (void 0 === headerItem.children[i].index) {
                                child.index = applyingItemIndexesToCurrent[child.index] = emptyIndex++;
                                headerItem.children[i] = child
                            } else {
                                applyingItemIndexesToCurrent[child.index] = headerItem.children[i].index
                            }
                        }
                    }
                } else {
                    needIndexUpdate = true;
                    for (index = 0; index < applyingHeaderItemsCount; index++) {
                        applyingItemIndexesToCurrent[index] = emptyIndex++
                    }
                    headerItem.children = children
                }(0, _deferred.when)((0, _uiPivot_grid2.foreachTreeAsync)(headerItem.children, function(items) {
                    if (needIndexUpdate) {
                        items[0].index = applyingItemIndexesToCurrent[items[0].index]
                    }
                })).done(function() {
                    d.resolve(applyingItemIndexesToCurrent)
                });
                return d
            };
            var updateHeaderItems = function(headerItems, newHeaderItems, grandTotalIndex) {
                var d = new _deferred.Deferred;
                var emptyIndex = grandTotalIndex >= 0 && getHeaderItemsLastIndex(headerItems, grandTotalIndex) + 1;
                var applyingItemIndexesToCurrent = [];
                (0, _deferred.when)((0, _uiPivot_grid2.foreachTreeAsync)(headerItems, function(items) {
                    delete items[0].collapsedChildren
                })).done(function() {
                    (0, _deferred.when)((0, _uiPivot_grid2.foreachTreeAsync)(newHeaderItems, function(newItems, index) {
                        var newItem = newItems[0];
                        if (newItem.index >= 0) {
                            var headerItem = findHeaderItem(headerItems, (0, _uiPivot_grid2.createPath)(newItems));
                            if (headerItem && headerItem.index >= 0) {
                                applyingItemIndexesToCurrent[newItem.index] = headerItem.index
                            } else {
                                if (emptyIndex) {
                                    var path = (0, _uiPivot_grid2.createPath)(newItems.slice(1));
                                    headerItem = findHeaderItem(headerItems, path);
                                    var parentItems = path.length ? headerItem && headerItem.children : headerItems;
                                    if (parentItems) {
                                        parentItems[index] = newItem;
                                        newItem.index = applyingItemIndexesToCurrent[newItem.index] = emptyIndex++
                                    }
                                }
                            }
                        }
                    })).done(function() {
                        d.resolve(applyingItemIndexesToCurrent)
                    })
                });
                return d
            };
            var updateDataSourceCells = function(dataSource, newDataSourceCells, newRowItemIndexesToCurrent, newColumnItemIndexesToCurrent) {
                var newRowIndex;
                var newColumnIndex;
                var newRowCells;
                var newCell;
                var rowIndex;
                var columnIndex;
                var dataSourceCells = dataSource.values;
                if (newDataSourceCells) {
                    for (newRowIndex = 0; newRowIndex <= newDataSourceCells.length; newRowIndex++) {
                        newRowCells = newDataSourceCells[newRowIndex];
                        rowIndex = newRowItemIndexesToCurrent[newRowIndex];
                        if (!(0, _type.isDefined)(rowIndex)) {
                            rowIndex = dataSource.grandTotalRowIndex
                        }
                        if (newRowCells && (0, _type.isDefined)(rowIndex)) {
                            if (!dataSourceCells[rowIndex]) {
                                dataSourceCells[rowIndex] = []
                            }
                            for (newColumnIndex = 0; newColumnIndex <= newRowCells.length; newColumnIndex++) {
                                newCell = newRowCells[newColumnIndex];
                                columnIndex = newColumnItemIndexesToCurrent[newColumnIndex];
                                if (!(0, _type.isDefined)(columnIndex)) {
                                    columnIndex = dataSource.grandTotalColumnIndex
                                }
                                if ((0, _type.isDefined)(newCell) && (0, _type.isDefined)(columnIndex)) {
                                    dataSourceCells[rowIndex][columnIndex] = newCell
                                }
                            }
                        }
                    }
                }
            };

            function createLocalOrRemoteStore(dataSourceOptions, notifyProgress) {
                var StoreConstructor = dataSourceOptions.remoteOperations || dataSourceOptions.paginate ? _remote_store.default : _local_store.LocalStore;
                return new StoreConstructor((0, _extend.extend)((0, _utils.normalizeDataSourceOptions)(dataSourceOptions), {
                    onChanged: null,
                    onLoadingChanged: null,
                    onProgressChanged: notifyProgress
                }))
            }

            function createStore(dataSourceOptions, notifyProgress) {
                var store;
                var storeOptions;
                if ((0, _type.isPlainObject)(dataSourceOptions) && dataSourceOptions.load) {
                    store = createLocalOrRemoteStore(dataSourceOptions, notifyProgress)
                } else {
                    if (dataSourceOptions && !dataSourceOptions.store) {
                        dataSourceOptions = {
                            store: dataSourceOptions
                        }
                    }
                    storeOptions = dataSourceOptions.store;
                    if ("xmla" === storeOptions.type) {
                        store = new _xmla_store.XmlaStore(storeOptions)
                    } else {
                        if ((0, _type.isPlainObject)(storeOptions) && storeOptions.type || storeOptions instanceof _abstract_store.default || Array.isArray(storeOptions)) {
                            store = createLocalOrRemoteStore(dataSourceOptions, notifyProgress)
                        } else {
                            if (storeOptions instanceof _class.default) {
                                store = storeOptions
                            }
                        }
                    }
                }
                return store
            }

            function equalFields(fields, prevFields, count) {
                for (var i = 0; i < count; i++) {
                    if (!fields[i] || !prevFields[i] || fields[i].index !== prevFields[i].index) {
                        return false
                    }
                }
                return true
            }

            function getExpandedPaths(dataSource, loadOptions, dimensionName, prevLoadOptions) {
                var result = [];
                var fields = loadOptions && loadOptions[dimensionName] || [];
                var prevFields = prevLoadOptions && prevLoadOptions[dimensionName] || [];
                (0, _uiPivot_grid2.foreachTree)(dataSource[dimensionName], function(items) {
                    var item = items[0];
                    var path = (0, _uiPivot_grid2.createPath)(items);
                    if (item.children && fields[path.length - 1] && !fields[path.length - 1].expanded) {
                        if (path.length < fields.length && (!prevLoadOptions || equalFields(fields, prevFields, path.length))) {
                            result.push(path.slice())
                        }
                    }
                }, true);
                return result
            }

            function setFieldProperties(field, srcField, skipInitPropertySave, properties) {
                if (srcField) {
                    (0, _iterator.each)(properties, function(_, name) {
                        if (skipInitPropertySave) {
                            field[name] = srcField[name]
                        } else {
                            if (("summaryType" === name || "summaryDisplayMode" === name) && void 0 === srcField[name]) {
                                return
                            }(0, _uiPivot_grid2.setFieldProperty)(field, name, srcField[name])
                        }
                    })
                } else {
                    resetFieldState(field, properties)
                }
                return field
            }

            function getFieldsState(fields, properties) {
                var result = [];
                (0, _iterator.each)(fields, function(_, field) {
                    result.push(setFieldProperties({
                        dataField: field.dataField,
                        name: field.name
                    }, field, true, properties))
                });
                return result
            }

            function getFieldStateId(field) {
                if (field.name) {
                    return field.name
                }
                return field.dataField + ""
            }

            function getFieldsById(fields, id) {
                var result = [];
                (0, _iterator.each)(fields || [], function(_, field) {
                    if (getFieldStateId(field) === id) {
                        result.push(field)
                    }
                });
                return result
            }

            function setFieldsStateCore(stateFields, fields) {
                stateFields = stateFields || [];
                (0, _iterator.each)(fields, function(index, field) {
                    setFieldProperties(field, stateFields[index], false, STATE_PROPERTIES);
                    updateCalculatedFieldProperties(field, CALCULATED_PROPERTIES)
                });
                return fields
            }

            function setFieldsState(stateFields, fields) {
                stateFields = stateFields || [];
                var fieldsById = {};
                var id;
                (0, _iterator.each)(fields, function(_, field) {
                    id = getFieldStateId(field);
                    if (!fieldsById[id]) {
                        fieldsById[id] = getFieldsById(fields, getFieldStateId(field))
                    }
                });
                (0, _iterator.each)(fieldsById, function(id, fields) {
                    setFieldsStateCore(getFieldsById(stateFields, id), fields)
                });
                return fields
            }

            function getFieldsByGroup(fields, groupingField) {
                return fields.filter(function(field) {
                    return field.groupName === groupingField.groupName && (0, _type.isNumeric)(field.groupIndex) && false !== field.visible
                }).map(function(field) {
                    return (0, _extend.extend)(field, {
                        areaIndex: groupingField.areaIndex,
                        area: groupingField.area,
                        expanded: (0, _type.isDefined)(field.expanded) ? field.expanded : groupingField.expanded,
                        dataField: field.dataField || groupingField.dataField,
                        dataType: field.dataType || groupingField.dataType,
                        sortBy: field.sortBy || groupingField.sortBy,
                        sortOrder: field.sortOrder || groupingField.sortOrder,
                        sortBySummaryField: field.sortBySummaryField || groupingField.sortBySummaryField,
                        sortBySummaryPath: field.sortBySummaryPath || groupingField.sortBySummaryPath,
                        visible: field.visible || groupingField.visible,
                        showTotals: (0, _type.isDefined)(field.showTotals) ? field.showTotals : groupingField.showTotals,
                        showGrandTotals: (0, _type.isDefined)(field.showGrandTotals) ? field.showGrandTotals : groupingField.showGrandTotals
                    })
                }).sort(function(a, b) {
                    return a.groupIndex - b.groupIndex
                })
            }

            function sortFieldsByAreaIndex(fields) {
                fields.sort(function(field1, field2) {
                    return field1.areaIndex - field2.areaIndex || field1.groupIndex - field2.groupIndex
                })
            }

            function isAreaField(field, area) {
                var canAddFieldInArea = "data" === area || false !== field.visible;
                return field.area === area && !(0, _type.isDefined)(field.groupIndex) && canAddFieldInArea
            }

            function getFieldId(field, retrieveFieldsOptionValue) {
                var groupName = field.groupName || "";
                return (field.dataField || groupName) + (field.groupInterval ? groupName + field.groupInterval : "NOGROUP") + (retrieveFieldsOptionValue ? "" : groupName)
            }

            function mergeFields(fields, storeFields, retrieveFieldsOptionValue) {
                var result = [];
                var fieldsDictionary = {};
                var removedFields = {};
                var mergedGroups = [];
                var dataTypes = (0, _uiPivot_grid2.getFieldsDataType)(fields);
                if (storeFields) {
                    (0, _iterator.each)(storeFields, function(_, field) {
                        fieldsDictionary[getFieldId(field, retrieveFieldsOptionValue)] = field
                    });
                    (0, _iterator.each)(fields, function(_, field) {
                        var fieldKey = getFieldId(field, retrieveFieldsOptionValue);
                        var storeField = fieldsDictionary[fieldKey] || removedFields[fieldKey];
                        var mergedField;
                        if (storeField) {
                            if (storeField._initProperties) {
                                resetFieldState(storeField, ALL_CALCULATED_PROPERTIES)
                            }
                            mergedField = (0, _extend.extend)({}, storeField, field, {
                                _initProperties: null
                            })
                        } else {
                            fieldsDictionary[fieldKey] = mergedField = field
                        }(0, _extend.extend)(mergedField, {
                            dataType: dataTypes[field.dataField]
                        });
                        delete fieldsDictionary[fieldKey];
                        removedFields[fieldKey] = storeField;
                        result.push(mergedField)
                    });
                    if (retrieveFieldsOptionValue) {
                        (0, _iterator.each)(fieldsDictionary, function(_, field) {
                            result.push(field)
                        })
                    }
                } else {
                    result = fields
                }
                result.push.apply(result, mergedGroups);
                assignGroupIndexes(result);
                return result
            }

            function assignGroupIndexes(fields) {
                fields.forEach(function(field) {
                    if (field.groupName && field.groupInterval && void 0 === field.groupIndex) {
                        var maxGroupIndex = fields.filter(function(f) {
                            return f.groupName === field.groupName && (0, _type.isNumeric)(f.groupIndex)
                        }).map(function(f) {
                            return f.groupIndex
                        }).reduce(function(prev, current) {
                            return Math.max(prev, current)
                        }, -1);
                        field.groupIndex = maxGroupIndex + 1
                    }
                })
            }

            function getFields(that) {
                var result = new _deferred.Deferred;
                var store = that._store;
                var storeFields = store && store.getFields(that._fields);
                var mergedFields;
                (0, _deferred.when)(storeFields).done(function(storeFields) {
                    that._storeFields = storeFields;
                    mergedFields = mergeFields(that._fields, storeFields, that._retrieveFields);
                    result.resolve(mergedFields)
                }).fail(result.reject);
                return result
            }

            function formatHeaderItems(data, loadOptions, headerName) {
                return (0, _uiPivot_grid2.foreachTreeAsync)(data[headerName], function(items) {
                    var item = items[0];
                    item.text = item.text || (0, _uiPivot_grid2.formatValue)(item.value, loadOptions[headerName][(0, _uiPivot_grid2.createPath)(items).length - 1])
                })
            }

            function formatHeaders(loadOptions, data) {
                return (0, _deferred.when)(formatHeaderItems(data, loadOptions, "columns"), formatHeaderItems(data, loadOptions, "rows"))
            }

            function updateCache(headerItems) {
                var d = new _deferred.Deferred;
                var cacheByPath = {};
                (0, _deferred.when)((0, _uiPivot_grid2.foreachTreeAsync)(headerItems, function(items) {
                    var path = (0, _uiPivot_grid2.createPath)(items).join(".");
                    cacheByPath[path] = items[0]
                })).done(d.resolve);
                headerItems._cacheByPath = cacheByPath;
                return d
            }

            function _getAreaFields(fields, area) {
                var areaFields = [];
                (0, _iterator.each)(fields, function() {
                    if (isAreaField(this, area)) {
                        areaFields.push(this)
                    }
                });
                return areaFields
            }
            return {
                ctor: function(options) {
                    options = options || {};
                    this._eventsStrategy = new _events_strategy.EventsStrategy(this);
                    var that = this;
                    var store = createStore(options, function(progress) {
                        that._eventsStrategy.fireEvent("progressChanged", [progress])
                    });
                    that._store = store;
                    that._paginate = !!options.paginate;
                    that._pageSize = options.pageSize || 40;
                    that._data = {
                        rows: [],
                        columns: [],
                        values: []
                    };
                    that._loadingCount = 0;
                    that._isFieldsModified = false;
                    (0, _iterator.each)(["changed", "loadError", "loadingChanged", "progressChanged", "fieldsPrepared", "expandValueChanging"], function(_, eventName) {
                        var optionName = "on" + eventName[0].toUpperCase() + eventName.slice(1);
                        if (Object.prototype.hasOwnProperty.call(options, optionName)) {
                            this.on(eventName, options[optionName])
                        }
                    }.bind(this));
                    that._retrieveFields = (0, _type.isDefined)(options.retrieveFields) ? options.retrieveFields : true;
                    that._fields = options.fields || [];
                    that._descriptions = options.descriptions ? (0, _extend.extend)(that._createDescriptions(), options.descriptions) : void 0;
                    if (!store) {
                        (0, _extend.extend)(true, that._data, options.store || options)
                    }
                },
                getData: function() {
                    return this._data
                },
                getAreaFields: function(area, collectGroups) {
                    var areaFields = [];
                    var descriptions;
                    if (collectGroups || "data" === area) {
                        areaFields = _getAreaFields(this._fields, area);
                        sortFieldsByAreaIndex(areaFields)
                    } else {
                        descriptions = this._descriptions || {};
                        areaFields = descriptions[DESCRIPTION_NAME_BY_AREA[area]] || []
                    }
                    return areaFields
                },
                fields: function(_fields) {
                    var that = this;
                    if (_fields) {
                        that._fields = mergeFields(_fields, that._storeFields, that._retrieveFields);
                        that._fieldsPrepared(that._fields)
                    }
                    return that._fields
                },
                field: function field(id, options) {
                    var that = this;
                    var fields = that._fields;
                    var field = fields && fields[(0, _type.isNumeric)(id) ? id : (0, _uiPivot_grid2.findField)(fields, id)];
                    var levels;
                    if (field && options) {
                        (0, _iterator.each)(options, function(optionName, optionValue) {
                            var isInitialization = (0, _array.inArray)(optionName, STATE_PROPERTIES) < 0;
                            (0, _uiPivot_grid2.setFieldProperty)(field, optionName, optionValue, isInitialization);
                            if ("sortOrder" === optionName) {
                                levels = field.levels || [];
                                for (var i = 0; i < levels.length; i++) {
                                    levels[i][optionName] = optionValue
                                }
                            }
                        });
                        updateCalculatedFieldProperties(field, CALCULATED_PROPERTIES);
                        that._descriptions = that._createDescriptions(field);
                        that._isFieldsModified = true;
                        that._eventsStrategy.fireEvent("fieldChanged", [field])
                    }
                    return field
                },
                getFieldValues: function(index, applyFilters, options) {
                    var that = this;
                    var field = this._fields && this._fields[index];
                    var store = this.store();
                    var loadFields = [];
                    var loadOptions = {
                        columns: loadFields,
                        rows: [],
                        values: this.getAreaFields("data"),
                        filters: applyFilters ? this._fields.filter(function(f) {
                            return f !== field && f.area && f.filterValues && f.filterValues.length
                        }) : [],
                        skipValues: true
                    };
                    var searchValue;
                    var d = new _deferred.Deferred;
                    if (options) {
                        searchValue = options.searchValue;
                        loadOptions.columnSkip = options.skip;
                        loadOptions.columnTake = options.take
                    }
                    if (field && store) {
                        (0, _iterator.each)(field.levels || [field], function() {
                            loadFields.push((0, _extend.extend)({}, this, {
                                expanded: true,
                                filterValues: null,
                                sortOrder: "asc",
                                sortBySummaryField: null,
                                searchValue: searchValue
                            }))
                        });
                        store.load(loadOptions).done(function(data) {
                            if (loadOptions.columnSkip) {
                                data.columns = data.columns.slice(loadOptions.columnSkip)
                            }
                            if (loadOptions.columnTake) {
                                data.columns = data.columns.slice(0, loadOptions.columnTake)
                            }
                            formatHeaders(loadOptions, data);
                            if (!loadOptions.columnTake) {
                                that._sort(loadOptions, data)
                            }
                            d.resolve(data.columns)
                        }).fail(d)
                    } else {
                        d.reject()
                    }
                    return d
                },
                reload: function() {
                    return this.load({
                        reload: true
                    })
                },
                filter: function() {
                    var store = this._store;
                    return store.filter.apply(store, arguments)
                },
                load: function(options) {
                    var that = this;
                    var d = new _deferred.Deferred;
                    options = options || {};
                    that.beginLoading();
                    d.fail(function(e) {
                        that._eventsStrategy.fireEvent("loadError", [e])
                    }).always(function() {
                        that.endLoading()
                    });

                    function loadTask() {
                        that._delayedLoadTask = void 0;
                        if (!that._descriptions) {
                            (0, _deferred.when)(getFields(that)).done(function(fields) {
                                that._fieldsPrepared(fields);
                                that._loadCore(options, d)
                            }).fail(d.reject).fail(that._loadErrorHandler)
                        } else {
                            that._loadCore(options, d)
                        }
                    }
                    if (that.store()) {
                        that._delayedLoadTask = (0, _common.executeAsync)(loadTask)
                    } else {
                        loadTask()
                    }
                    return d
                },
                createDrillDownDataSource: function(params) {
                    return this._store.createDrillDownDataSource(this._descriptions, params)
                },
                _createDescriptions: function(currentField) {
                    var that = this;
                    var fields = that.fields();
                    var descriptions = {
                        rows: [],
                        columns: [],
                        values: [],
                        filters: []
                    };
                    (0, _iterator.each)(["row", "column", "data", "filter"], function(_, areaName) {
                        (0, _array.normalizeIndexes)(_getAreaFields(fields, areaName), "areaIndex", currentField)
                    });
                    (0, _iterator.each)(fields || [], function(_, field) {
                        var descriptionName = DESCRIPTION_NAME_BY_AREA[field.area];
                        var dimension = descriptions[descriptionName];
                        var groupName = field.groupName;
                        if (groupName && !(0, _type.isNumeric)(field.groupIndex)) {
                            field.levels = getFieldsByGroup(fields, field)
                        }
                        if (!dimension || groupName && (0, _type.isNumeric)(field.groupIndex) || false === field.visible && "data" !== field.area && "filter" !== field.area) {
                            return
                        }
                        if (field.levels && dimension !== descriptions.filters && dimension !== descriptions.values) {
                            dimension.push.apply(dimension, field.levels);
                            if (field.filterValues && field.filterValues.length) {
                                descriptions.filters.push(field)
                            }
                        } else {
                            dimension.push(field)
                        }
                    });
                    (0, _iterator.each)(descriptions, function(_, fields) {
                        sortFieldsByAreaIndex(fields)
                    });
                    var indices = {};
                    (0, _iterator.each)(descriptions.values, function(_, field) {
                        var expression = field.calculateSummaryValue;
                        if ((0, _type.isFunction)(expression)) {
                            var summaryCell = (0, _uiPivot_grid.createMockSummaryCell)(descriptions, fields, indices);
                            expression(summaryCell)
                        }
                    });
                    return descriptions
                },
                _fieldsPrepared: function(fields) {
                    var that = this;
                    that._fields = fields;
                    (0, _iterator.each)(fields, function(index, field) {
                        field.index = index;
                        updateCalculatedFieldProperties(field, ALL_CALCULATED_PROPERTIES)
                    });
                    var currentFieldState = getFieldsState(fields, ["caption"]);
                    that._eventsStrategy.fireEvent("fieldsPrepared", [fields]);
                    for (var i = 0; i < fields.length; i++) {
                        if (fields[i].caption !== currentFieldState[i].caption) {
                            (0, _uiPivot_grid2.setFieldProperty)(fields[i], "caption", fields[i].caption, true)
                        }
                    }
                    that._descriptions = that._createDescriptions()
                },
                isLoading: function() {
                    return this._loadingCount > 0
                },
                state: function(_state, skipLoading) {
                    var that = this;
                    if (arguments.length) {
                        _state = (0, _extend.extend)({
                            rowExpandedPaths: [],
                            columnExpandedPaths: []
                        }, _state);
                        if (!that._descriptions) {
                            that.beginLoading();
                            (0, _deferred.when)(getFields(that)).done(function(fields) {
                                that._fields = setFieldsState(_state.fields, fields);
                                that._fieldsPrepared(fields);
                                !skipLoading && that.load(_state)
                            }).always(function() {
                                that.endLoading()
                            })
                        } else {
                            that._fields = setFieldsState(_state.fields, that._fields);
                            that._descriptions = that._createDescriptions();
                            !skipLoading && that.load(_state)
                        }
                    } else {
                        return {
                            fields: getFieldsState(that._fields, STATE_PROPERTIES),
                            columnExpandedPaths: getExpandedPaths(that._data, that._descriptions, "columns", that._lastLoadOptions),
                            rowExpandedPaths: getExpandedPaths(that._data, that._descriptions, "rows", that._lastLoadOptions)
                        }
                    }
                },
                beginLoading: function() {
                    this._changeLoadingCount(1)
                },
                endLoading: function() {
                    this._changeLoadingCount(-1)
                },
                _changeLoadingCount: function(increment) {
                    var oldLoading = this.isLoading();
                    this._loadingCount += increment;
                    var newLoading = this.isLoading();
                    if (oldLoading ^ newLoading) {
                        this._eventsStrategy.fireEvent("loadingChanged", [newLoading])
                    }
                },
                _hasPagingValues: function(options, area, oppositeIndex) {
                    var takeField = area + "Take";
                    var skipField = area + "Skip";
                    var values = this._data.values;
                    var items = this._data[area + "s"];
                    var oppositeArea = "row" === area ? "column" : "row";
                    var indices = [];
                    if (options.path && options.area === area) {
                        var headerItem = findHeaderItem(items, options.path);
                        items = headerItem && headerItem.children;
                        if (!items) {
                            return false
                        }
                    }
                    if (options.oppositePath && options.area === oppositeArea) {
                        var _headerItem = findHeaderItem(items, options.oppositePath);
                        items = _headerItem && _headerItem.children;
                        if (!items) {
                            return false
                        }
                    }
                    for (var i = options[skipField]; i < options[skipField] + options[takeField]; i++) {
                        if (items[i]) {
                            indices.push(items[i].index)
                        }
                    }
                    return indices.every(function(index) {
                        if (void 0 !== index) {
                            if ("row" === area) {
                                return (values[index] || [])[oppositeIndex]
                            } else {
                                return (values[oppositeIndex] || [])[index]
                            }
                        }
                    })
                },
                _processPagingCacheByArea: function(options, pageSize, area) {
                    var takeField = area + "Take";
                    var skipField = area + "Skip";
                    var items = this._data[area + "s"];
                    var oppositeArea = "row" === area ? "column" : "row";
                    var item;
                    if (options[takeField]) {
                        if (options.path && options.area === area) {
                            var headerItem = findHeaderItem(items, options.path);
                            items = headerItem && headerItem.children || []
                        }
                        if (options.oppositePath && options.area === oppositeArea) {
                            var _headerItem2 = findHeaderItem(items, options.oppositePath);
                            items = _headerItem2 && _headerItem2.children || []
                        }
                        do {
                            item = items[options[skipField]];
                            if (item && void 0 !== item.index) {
                                if (this._hasPagingValues(options, oppositeArea, item.index)) {
                                    options[skipField]++;
                                    options[takeField]--
                                } else {
                                    break
                                }
                            }
                        } while (item && void 0 !== item.index && options[takeField]);
                        if (options[takeField]) {
                            var start = Math.floor(options[skipField] / pageSize) * pageSize;
                            var end = Math.ceil((options[skipField] + options[takeField]) / pageSize) * pageSize;
                            options[skipField] = start;
                            options[takeField] = end - start
                        }
                    }
                },
                _processPagingCache: function(storeLoadOptions) {
                    var pageSize = this._pageSize;
                    if (pageSize < 0) {
                        return
                    }
                    for (var i = 0; i < storeLoadOptions.length; i++) {
                        this._processPagingCacheByArea(storeLoadOptions[i], pageSize, "row");
                        this._processPagingCacheByArea(storeLoadOptions[i], pageSize, "column")
                    }
                },
                _loadCore: function(options, deferred) {
                    var that = this;
                    var store = this._store;
                    var descriptions = this._descriptions;
                    var reload = options.reload || this.paginate() && that._isFieldsModified;
                    var paginate = this.paginate();
                    var headerName = DESCRIPTION_NAME_BY_AREA[options.area];
                    options = options || {};
                    if (store) {
                        (0, _extend.extend)(options, descriptions);
                        options.columnExpandedPaths = options.columnExpandedPaths || getExpandedPaths(this._data, options, "columns", that._lastLoadOptions);
                        options.rowExpandedPaths = options.rowExpandedPaths || getExpandedPaths(this._data, options, "rows", that._lastLoadOptions);
                        if (paginate) {
                            options.pageSize = this._pageSize
                        }
                        if (headerName) {
                            options.headerName = headerName
                        }
                        that.beginLoading();
                        deferred.always(function() {
                            that.endLoading()
                        });
                        var storeLoadOptions = [options];
                        that._eventsStrategy.fireEvent("customizeStoreLoadOptions", [storeLoadOptions, reload]);
                        if (!reload) {
                            that._processPagingCache(storeLoadOptions)
                        }
                        storeLoadOptions = storeLoadOptions.filter(function(options) {
                            return !(options.rows.length && 0 === options.rowTake) && !(options.columns.length && 0 === options.columnTake)
                        });
                        if (!storeLoadOptions.length) {
                            that._update(deferred);
                            return
                        }
                        var results = storeLoadOptions.map(function(options) {
                            return store.load(options)
                        });
                        _deferred.when.apply(null, results).done(function() {
                            var results = arguments;
                            for (var i = 0; i < results.length; i++) {
                                var _options = storeLoadOptions[i];
                                var data = results[i];
                                var isLast = i === results.length - 1;
                                if (_options.path) {
                                    that.applyPartialDataSource(_options.area, _options.path, data, isLast ? deferred : false, _options.oppositePath)
                                } else {
                                    if (paginate && !reload && isDataExists(that._data)) {
                                        that.mergePartialDataSource(data, isLast ? deferred : false)
                                    } else {
                                        (0, _extend.extend)(that._data, data);
                                        that._lastLoadOptions = _options;
                                        that._update(isLast ? deferred : false)
                                    }
                                }
                            }
                        }).fail(deferred.reject)
                    } else {
                        that._update(deferred)
                    }
                },
                _sort: function(descriptions, data, getAscOrder) {
                    var store = this._store;
                    if (store && !this._paginate) {
                        (0, _data_source.sort)(descriptions, data, getAscOrder)
                    }
                },
                paginate: function() {
                    return this._paginate && this._store && this._store.supportPaging()
                },
                isEmpty: function() {
                    var dataFields = this.getAreaFields("data");
                    var data = this.getData();
                    return !dataFields.length || !data.values.length
                },
                _update: function(deferred) {
                    var that = this;
                    var descriptions = that._descriptions;
                    var loadedData = that._data;
                    var dataFields = descriptions.values;
                    var expressionsUsed = areExpressionsUsed(dataFields);
                    (0, _deferred.when)(formatHeaders(descriptions, loadedData), updateCache(loadedData.rows), updateCache(loadedData.columns)).done(function() {
                        if (expressionsUsed) {
                            that._sort(descriptions, loadedData, expressionsUsed);
                            !that.isEmpty() && (0, _uiPivot_grid.applyDisplaySummaryMode)(descriptions, loadedData)
                        }
                        that._sort(descriptions, loadedData);
                        !that.isEmpty() && isRunningTotalUsed(dataFields) && (0, _uiPivot_grid.applyRunningTotal)(descriptions, loadedData);
                        that._data = loadedData;
                        false !== deferred && (0, _deferred.when)(deferred).done(function() {
                            that._isFieldsModified = false;
                            that._eventsStrategy.fireEvent("changed");
                            if ((0, _type.isDefined)(that._data.grandTotalRowIndex)) {
                                loadedData.grandTotalRowIndex = that._data.grandTotalRowIndex
                            }
                            if ((0, _type.isDefined)(that._data.grandTotalColumnIndex)) {
                                loadedData.grandTotalColumnIndex = that._data.grandTotalColumnIndex
                            }
                        });
                        deferred && deferred.resolve(that._data)
                    });
                    return deferred
                },
                store: function() {
                    return this._store
                },
                collapseHeaderItem: function(area, path) {
                    var that = this;
                    var headerItems = "column" === area ? that._data.columns : that._data.rows;
                    var headerItem = findHeaderItem(headerItems, path);
                    var field = that.getAreaFields(area)[path.length - 1];
                    if (headerItem && headerItem.children) {
                        that._eventsStrategy.fireEvent("expandValueChanging", [{
                            area: area,
                            path: path,
                            expanded: false
                        }]);
                        if (field) {
                            field.expanded = false
                        }
                        headerItem.collapsedChildren = headerItem.children;
                        delete headerItem.children;
                        that._update();
                        if (that.paginate()) {
                            that.load()
                        }
                        return true
                    }
                    return false
                },
                collapseAll: function(id) {
                    var _this = this;
                    var dataChanged = false;
                    var field = this.field(id) || {};
                    var areaOffsets = [(0, _array.inArray)(field, this.getAreaFields(field.area))];
                    field.expanded = false;
                    if (field && field.levels) {
                        areaOffsets = [];
                        field.levels.forEach(function(f) {
                            areaOffsets.push((0, _array.inArray)(f, _this.getAreaFields(field.area)));
                            f.expanded = false
                        })
                    }(0, _uiPivot_grid2.foreachTree)(this._data[field.area + "s"], function(items) {
                        var item = items[0];
                        var path = (0, _uiPivot_grid2.createPath)(items);
                        if (item && item.children && areaOffsets.indexOf(path.length - 1) !== -1) {
                            item.collapsedChildren = item.children;
                            delete item.children;
                            dataChanged = true
                        }
                    }, true);
                    dataChanged && this._update()
                },
                expandAll: function(id) {
                    var field = this.field(id);
                    if (field && field.area) {
                        field.expanded = true;
                        if (field && field.levels) {
                            field.levels.forEach(function(f) {
                                f.expanded = true
                            })
                        }
                        this.load()
                    }
                },
                expandHeaderItem: function(area, path) {
                    var that = this;
                    var headerItems = "column" === area ? that._data.columns : that._data.rows;
                    var headerItem = findHeaderItem(headerItems, path);
                    if (headerItem && !headerItem.children) {
                        var hasCache = !!headerItem.collapsedChildren;
                        var options = {
                            area: area,
                            path: path,
                            expanded: true,
                            needExpandData: !hasCache
                        };
                        that._eventsStrategy.fireEvent("expandValueChanging", [options]);
                        if (hasCache) {
                            headerItem.children = headerItem.collapsedChildren;
                            delete headerItem.collapsedChildren;
                            that._update()
                        } else {
                            if (this.store()) {
                                that.load(options)
                            }
                        }
                        return hasCache
                    }
                    return false
                },
                mergePartialDataSource: function(dataSource, deferred) {
                    var that = this;
                    var loadedData = that._data;
                    var newRowItemIndexesToCurrent;
                    var newColumnItemIndexesToCurrent;
                    if (dataSource && dataSource.values) {
                        dataSource.rows = dataSource.rows || [];
                        dataSource.columns = dataSource.columns || [];
                        newRowItemIndexesToCurrent = updateHeaderItems(loadedData.rows, dataSource.rows, loadedData.grandTotalColumnIndex);
                        newColumnItemIndexesToCurrent = updateHeaderItems(loadedData.columns, dataSource.columns, loadedData.grandTotalColumnIndex);
                        (0, _deferred.when)(newRowItemIndexesToCurrent, newColumnItemIndexesToCurrent).done(function(newRowItemIndexesToCurrent, newColumnItemIndexesToCurrent) {
                            if (newRowItemIndexesToCurrent.length || newColumnItemIndexesToCurrent.length) {
                                updateDataSourceCells(loadedData, dataSource.values, newRowItemIndexesToCurrent, newColumnItemIndexesToCurrent)
                            }
                            that._update(deferred)
                        })
                    }
                },
                applyPartialDataSource: function(area, path, dataSource, deferred, oppositePath) {
                    var that = this;
                    var loadedData = that._data;
                    var headerItems = "column" === area ? loadedData.columns : loadedData.rows;
                    var headerItem;
                    var oppositeHeaderItems = "column" === area ? loadedData.rows : loadedData.columns;
                    var oppositeHeaderItem;
                    var newRowItemIndexesToCurrent;
                    var newColumnItemIndexesToCurrent;
                    if (dataSource && dataSource.values) {
                        dataSource.rows = dataSource.rows || [];
                        dataSource.columns = dataSource.columns || [];
                        headerItem = findHeaderItem(headerItems, path);
                        oppositeHeaderItem = oppositePath && findHeaderItem(oppositeHeaderItems, oppositePath);
                        if (headerItem) {
                            if ("column" === area) {
                                newColumnItemIndexesToCurrent = updateHeaderItemChildren(headerItems, headerItem, dataSource.columns, loadedData.grandTotalColumnIndex);
                                if (oppositeHeaderItem) {
                                    newRowItemIndexesToCurrent = updateHeaderItemChildren(oppositeHeaderItems, oppositeHeaderItem, dataSource.rows, loadedData.grandTotalRowIndex)
                                } else {
                                    newRowItemIndexesToCurrent = updateHeaderItems(loadedData.rows, dataSource.rows, loadedData.grandTotalRowIndex)
                                }
                            } else {
                                newRowItemIndexesToCurrent = updateHeaderItemChildren(headerItems, headerItem, dataSource.rows, loadedData.grandTotalRowIndex);
                                if (oppositeHeaderItem) {
                                    newColumnItemIndexesToCurrent = updateHeaderItemChildren(oppositeHeaderItems, oppositeHeaderItem, dataSource.columns, loadedData.grandTotalColumnIndex)
                                } else {
                                    newColumnItemIndexesToCurrent = updateHeaderItems(loadedData.columns, dataSource.columns, loadedData.grandTotalColumnIndex)
                                }
                            }(0, _deferred.when)(newRowItemIndexesToCurrent, newColumnItemIndexesToCurrent).done(function(newRowItemIndexesToCurrent, newColumnItemIndexesToCurrent) {
                                if ("row" === area && newRowItemIndexesToCurrent.length || "column" === area && newColumnItemIndexesToCurrent.length) {
                                    updateDataSourceCells(loadedData, dataSource.values, newRowItemIndexesToCurrent, newColumnItemIndexesToCurrent);
                                }
                                that._update(deferred)
                            })
                        }
                    }
                },
                on: function(eventName, eventHandler) {
                    this._eventsStrategy.on(eventName, eventHandler);
                    return this
                },
                off: function(eventName, eventHandler) {
                    this._eventsStrategy.off(eventName, eventHandler);
                    return this
                },
                dispose: function() {
                    var that = this;
                    var delayedLoadTask = that._delayedLoadTask;
                    this._eventsStrategy.dispose();
                    if (delayedLoadTask) {
                        delayedLoadTask.abort()
                    }
                    this._isDisposed = true
                },
                isDisposed: function() {
                    return !!this._isDisposed
                }
            }
        }());
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/pivot_grid/ui.pivot_grid.area_item.js ***!
      \***************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.AreaItem = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _element = __webpack_require__( /*! ../../core/element */ 18);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _position = __webpack_require__( /*! ../../core/utils/position */ 22);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var PIVOTGRID_EXPAND_CLASS = "dx-expand";
        var getRealElementWidth = function(element) {
            var width = 0;
            var offsetWidth = element.offsetWidth;
            if (element.getBoundingClientRect) {
                var clientRect = (0, _position.getBoundingRect)(element);
                width = clientRect.width;
                if (!width) {
                    width = clientRect.right - clientRect.left
                }
                if (width <= offsetWidth - 1) {
                    width = offsetWidth
                }
            }
            return width > 0 ? width : offsetWidth
        };

        function getFakeTableOffset(scrollPos, elementOffset, tableSize, viewPortSize) {
            var offset = 0;
            var halfTableCount = 0;
            var halfTableSize = tableSize / 2;
            if (scrollPos + viewPortSize - (elementOffset + tableSize) > 1) {
                if (scrollPos >= elementOffset + tableSize + halfTableSize) {
                    halfTableCount = parseInt((scrollPos - (elementOffset + tableSize)) / halfTableSize, 10)
                }
                offset = elementOffset + tableSize + halfTableSize * halfTableCount
            } else {
                if (scrollPos < elementOffset) {
                    if (scrollPos <= elementOffset - halfTableSize) {
                        halfTableCount = parseInt((scrollPos - (elementOffset - halfTableSize)) / halfTableSize, 10)
                    }
                    offset = elementOffset - (tableSize - halfTableSize * halfTableCount)
                } else {
                    offset = elementOffset
                }
            }
            return offset
        }
        var AreaItem = _class.default.inherit({
            _getRowElement: function(index) {
                var that = this;
                if (that._tableElement && that._tableElement.length > 0) {
                    return that._tableElement[0].rows[index]
                }
                return null
            },
            _createGroupElement: function() {
                return (0, _renderer.default)("<div>")
            },
            _createTableElement: function() {
                return (0, _renderer.default)("<table>")
            },
            _getCellText: function(cell, encodeHtml) {
                var cellText = cell.isWhiteSpace ? "&nbsp" : cell.text || "&nbsp";
                if (encodeHtml && (cellText.indexOf("<") !== -1 || cellText.indexOf(">") !== -1)) {
                    cellText = (0, _renderer.default)("<div>").text(cellText).html()
                }
                return cellText
            },
            _getRowClassNames: function() {},
            _applyCustomStyles: function(options) {
                if (options.cell.width) {
                    options.cssArray.push("min-width:" + options.cell.width + "px")
                }
                if (options.cell.sorted) {
                    options.classArray.push("dx-pivotgrid-sorted")
                }
            },
            _getMainElementMarkup: function() {
                return "<tbody>"
            },
            _getCloseMainElementMarkup: function() {
                return "</tbody>"
            },
            _renderTableContent: function(tableElement, data) {
                var that = this;
                var rowsCount = data.length;
                var row;
                var cell;
                var i;
                var j;
                var rowElement;
                var cellElement;
                var cellText;
                var rtlEnabled = that.option("rtlEnabled");
                var markupArray = [];
                var encodeHtml = that.option("encodeHtml");
                var rowClassNames;
                var colspan = "colspan='";
                var rowspan = "rowspan='";
                tableElement.data("area", that._getAreaName());
                tableElement.data("data", data);
                tableElement.css("width", "");
                markupArray.push(that._getMainElementMarkup());
                for (i = 0; i < rowsCount; i++) {
                    row = data[i];
                    var columnMarkupArray = [];
                    rowClassNames = [];
                    markupArray.push("<tr ");
                    for (j = 0; j < row.length; j++) {
                        cell = row[j];
                        this._getRowClassNames(i, cell, rowClassNames);
                        columnMarkupArray.push("<td ");
                        if (cell) {
                            cell.rowspan && columnMarkupArray.push(rowspan + (cell.rowspan || 1) + "'");
                            cell.colspan && columnMarkupArray.push(colspan + (cell.colspan || 1) + "'");
                            var styleOptions = {
                                cellElement: cellElement,
                                cell: cell,
                                cellsCount: row.length,
                                cellIndex: j,
                                rowElement: rowElement,
                                rowIndex: i,
                                rowsCount: rowsCount,
                                rtlEnabled: rtlEnabled,
                                classArray: [],
                                cssArray: []
                            };
                            that._applyCustomStyles(styleOptions);
                            if (styleOptions.cssArray.length) {
                                columnMarkupArray.push("style='");
                                columnMarkupArray.push(styleOptions.cssArray.join(";"));
                                columnMarkupArray.push("'")
                            }
                            if (styleOptions.classArray.length) {
                                columnMarkupArray.push("class='");
                                columnMarkupArray.push(styleOptions.classArray.join(" "));
                                columnMarkupArray.push("'")
                            }
                            columnMarkupArray.push(">");
                            if ((0, _type.isDefined)(cell.expanded)) {
                                columnMarkupArray.push("<div class='dx-expand-icon-container'><span class='" + PIVOTGRID_EXPAND_CLASS + "'></span></div>")
                            }
                            cellText = this._getCellText(cell, encodeHtml)
                        } else {
                            cellText = ""
                        }
                        columnMarkupArray.push("<span ");
                        if ((0, _type.isDefined)(cell.wordWrapEnabled)) {
                            columnMarkupArray.push("style='white-space:", cell.wordWrapEnabled ? "normal" : "nowrap", ";'")
                        }
                        columnMarkupArray.push(">" + cellText + "</span>");
                        if (cell.sorted) {
                            columnMarkupArray.push("<span class='dx-icon-sorted'></span>")
                        }
                        columnMarkupArray.push("</td>")
                    }
                    if (rowClassNames.length) {
                        markupArray.push("class='");
                        markupArray.push(rowClassNames.join(" "));
                        markupArray.push("'")
                    }
                    markupArray.push(">");
                    markupArray.push(columnMarkupArray.join(""));
                    markupArray.push("</tr>")
                }
                markupArray.push(this._getCloseMainElementMarkup());
                tableElement.append(markupArray.join(""));
                this._triggerOnCellPrepared(tableElement, data)
            },
            _triggerOnCellPrepared: function(tableElement, data) {
                var that = this;
                var rowElements = tableElement.find("tr");
                var areaName = that._getAreaName();
                var onCellPrepared = that.option("onCellPrepared");
                var hasEvent = that.component._eventsStrategy.hasEvent("cellPrepared");
                var rowElement;
                var $cellElement;
                var onCellPreparedArgs;
                var defaultActionArgs = this.component._defaultActionArgs();
                var row;
                var cell;
                var rowIndex;
                var columnIndex;
                if (onCellPrepared || hasEvent) {
                    for (rowIndex = 0; rowIndex < data.length; rowIndex++) {
                        row = data[rowIndex];
                        rowElement = rowElements.eq(rowIndex);
                        for (columnIndex = 0; columnIndex < row.length; columnIndex++) {
                            cell = row[columnIndex];
                            $cellElement = rowElement.children().eq(columnIndex);
                            onCellPreparedArgs = {
                                area: areaName,
                                rowIndex: rowIndex,
                                columnIndex: columnIndex,
                                cellElement: (0, _element.getPublicElement)($cellElement),
                                cell: cell
                            };
                            if (hasEvent) {
                                that.component._trigger("onCellPrepared", onCellPreparedArgs)
                            } else {
                                onCellPrepared((0, _extend.extend)(onCellPreparedArgs, defaultActionArgs))
                            }
                        }
                    }
                }
            },
            _getRowHeight: function(index) {
                var row = this._getRowElement(index);
                var height = 0;
                var offsetHeight = row.offsetHeight;
                if (row && row.lastChild) {
                    if (row.getBoundingClientRect) {
                        var clientRect = (0, _position.getBoundingRect)(row);
                        height = clientRect.height;
                        if (height <= offsetHeight - 1) {
                            height = offsetHeight
                        }
                    }
                    return height > 0 ? height : offsetHeight
                }
                return 0
            },
            _setRowHeight: function(index, value) {
                var row = this._getRowElement(index);
                if (row) {
                    row.style.height = value + "px"
                }
            },
            ctor: function(component) {
                this.component = component
            },
            option: function() {
                return this.component.option.apply(this.component, arguments)
            },
            getRowsLength: function() {
                var that = this;
                if (that._tableElement && that._tableElement.length > 0) {
                    return that._tableElement[0].rows.length
                }
                return 0
            },
            getRowsHeight: function() {
                var that = this;
                var result = [];
                var rowsLength = that.getRowsLength();
                var i;
                for (i = 0; i < rowsLength; i++) {
                    result.push(that._getRowHeight(i))
                }
                return result
            },
            setRowsHeight: function(values) {
                var that = this;
                var totalHeight = 0;
                var valuesLength = values.length;
                var i;
                for (i = 0; i < valuesLength; i++) {
                    totalHeight += values[i];
                    that._setRowHeight(i, values[i])
                }
                this._tableHeight = totalHeight;
                this._tableElement[0].style.height = totalHeight + "px"
            },
            getColumnsWidth: function() {
                var rowsLength = this.getRowsLength();
                var rowIndex;
                var row;
                var i;
                var columnIndex;
                var processedCells = [];
                var result = [];
                var fillCells = function(cells, rowIndex, columnIndex, rowSpan, colSpan) {
                    var rowOffset;
                    var columnOffset;
                    for (rowOffset = 0; rowOffset < rowSpan; rowOffset++) {
                        for (columnOffset = 0; columnOffset < colSpan; columnOffset++) {
                            cells[rowIndex + rowOffset] = cells[rowIndex + rowOffset] || [];
                            cells[rowIndex + rowOffset][columnIndex + columnOffset] = true
                        }
                    }
                };
                if (rowsLength) {
                    for (rowIndex = 0; rowIndex < rowsLength; rowIndex++) {
                        processedCells[rowIndex] = processedCells[rowIndex] || [];
                        row = this._getRowElement(rowIndex);
                        for (i = 0; i < row.cells.length; i++) {
                            for (columnIndex = 0; processedCells[rowIndex][columnIndex]; columnIndex++) {}
                            fillCells(processedCells, rowIndex, columnIndex, row.cells[i].rowSpan, row.cells[i].colSpan);
                            if (1 === row.cells[i].colSpan) {
                                result[columnIndex] = result[columnIndex] || getRealElementWidth(row.cells[i])
                            }
                        }
                    }
                }
                return result
            },
            setColumnsWidth: function(values) {
                var i;
                var tableElement = this._tableElement[0];
                var colgroupElementHTML = "";
                var columnsCount = this.getColumnsCount();
                var columnWidth = [];
                for (i = 0; i < columnsCount; i++) {
                    columnWidth.push(values[i] || 0)
                }
                for (i = columnsCount; i < values.length && values; i++) {
                    columnWidth[columnsCount - 1] += values[i]
                }
                for (i = 0; i < columnsCount; i++) {
                    colgroupElementHTML += '<col style="width: ' + columnWidth[i] + 'px">'
                }
                this._colgroupElement.html(colgroupElementHTML);
                this._tableWidth = columnWidth.reduce(function(sum, width) {
                    return sum + width
                }, 0);
                tableElement.style.width = this._tableWidth + "px";
                tableElement.style.tableLayout = "fixed"
            },
            resetColumnsWidth: function() {
                this._colgroupElement.find("col").width("auto");
                this._tableElement.css({
                    width: "",
                    tableLayout: ""
                })
            },
            groupWidth: function(value) {
                if (void 0 === value) {
                    return this._groupElement.width()
                } else {
                    if (value >= 0) {
                        this._groupWidth = value;
                        return this._groupElement[0].style.width = value + "px"
                    } else {
                        return this._groupElement[0].style.width = value
                    }
                }
            },
            groupHeight: function(value) {
                if (void 0 === value) {
                    return this._groupElement.height()
                }
                this._groupHeight = null;
                if (value >= 0) {
                    this._groupHeight = value;
                    this._groupElement[0].style.height = value + "px"
                } else {
                    this._groupElement[0].style.height = value
                }
            },
            groupElement: function() {
                return this._groupElement
            },
            tableElement: function() {
                return this._tableElement
            },
            element: function() {
                return this._rootElement
            },
            headElement: function() {
                return this._tableElement.find("thead")
            },
            _setTableCss: function(styles) {
                if (this.option("rtlEnabled")) {
                    styles.right = styles.left;
                    delete styles.left
                }
                this.tableElement().css(styles)
            },
            setVirtualContentParams: function(params) {
                this._virtualContent.css({
                    width: params.width,
                    height: params.height
                });
                this.groupElement().addClass("dx-virtual-mode")
            },
            disableVirtualMode: function() {
                this.groupElement().removeClass("dx-virtual-mode")
            },
            _renderVirtualContent: function() {
                var that = this;
                if (!that._virtualContent && "virtual" === that.option("scrolling.mode")) {
                    that._virtualContent = (0, _renderer.default)("<div>").addClass("dx-virtual-content").insertBefore(that._tableElement)
                }
            },
            reset: function() {
                var that = this;
                var tableElement = that._tableElement[0];
                that._fakeTable && that._fakeTable.detach();
                that._fakeTable = null;
                that.disableVirtualMode();
                that.groupWidth("100%");
                that.groupHeight("auto");
                that.resetColumnsWidth();
                if (tableElement) {
                    for (var i = 0; i < tableElement.rows.length; i++) {
                        tableElement.rows[i].style.height = ""
                    }
                    tableElement.style.height = "";
                    tableElement.style.width = "100%"
                }
            },
            _updateFakeTableVisibility: function() {
                var that = this;
                var tableElement = that.tableElement()[0];
                var horizontalOffsetName = that.option("rtlEnabled") ? "right" : "left";
                var fakeTableElement = that._fakeTable[0];
                if (tableElement.style.top === fakeTableElement.style.top && fakeTableElement.style[horizontalOffsetName] === tableElement.style[horizontalOffsetName]) {
                    that._fakeTable.addClass("dx-hidden")
                } else {
                    that._fakeTable.removeClass("dx-hidden")
                }
            },
            _moveFakeTableHorizontally: function(scrollPos) {
                var that = this;
                var rtlEnabled = that.option("rtlEnabled");
                var offsetStyleName = rtlEnabled ? "right" : "left";
                var tableElementOffset = parseFloat(that.tableElement()[0].style[offsetStyleName]);
                var offset = getFakeTableOffset(scrollPos, tableElementOffset, that._tableWidth, that._groupWidth);
                if (parseFloat(that._fakeTable[0].style[offsetStyleName]) !== offset) {
                    that._fakeTable[0].style[offsetStyleName] = offset + "px"
                }
            },
            _moveFakeTableTop: function(scrollPos) {
                var that = this;
                var tableElementOffsetTop = parseFloat(that.tableElement()[0].style.top);
                var offsetTop = getFakeTableOffset(scrollPos, tableElementOffsetTop, that._tableHeight, that._groupHeight);
                if (parseFloat(that._fakeTable[0].style.top) !== offsetTop) {
                    that._fakeTable[0].style.top = offsetTop + "px"
                }
            },
            _moveFakeTable: function() {
                this._updateFakeTableVisibility()
            },
            _createFakeTable: function() {
                var that = this;
                if (!that._fakeTable) {
                    that._fakeTable = that.tableElement().clone().addClass("dx-pivot-grid-fake-table").appendTo(that._virtualContent)
                }
            },
            render: function(rootElement, data) {
                var that = this;
                if (that._tableElement) {
                    try {
                        that._tableElement[0].innerHTML = ""
                    } catch (e) {
                        that._tableElement.empty()
                    }
                    that._tableElement.attr("style", "")
                } else {
                    that._groupElement = that._createGroupElement();
                    that._tableElement = that._createTableElement();
                    that._tableElement.appendTo(that._groupElement);
                    that._groupElement.appendTo(rootElement);
                    that._rootElement = rootElement
                }
                that._colgroupElement = (0, _renderer.default)("<colgroup>").appendTo(that._tableElement);
                that._renderTableContent(that._tableElement, data);
                that._renderVirtualContent()
            },
            _getScrollable: function() {
                return this.groupElement().data("dxScrollable")
            },
            on: function(eventName, handler) {
                var that = this;
                var scrollable = that._getScrollable();
                if (scrollable) {
                    scrollable.on(eventName, function(e) {
                        if (that.option("rtlEnabled") && (0, _type.isDefined)(e.scrollOffset.left)) {
                            e.scrollOffset.left = scrollable.$content().width() - scrollable._container().width() - e.scrollOffset.left
                        }
                        handler(e)
                    })
                }
                return this
            },
            off: function(eventName) {
                var scrollable = this._getScrollable();
                if (scrollable) {
                    scrollable.off(eventName)
                }
                return this
            },
            scrollTo: function(pos) {
                var scrollable = this._getScrollable();
                var scrollablePos = pos;
                if (scrollable) {
                    if (this.option("rtlEnabled")) {
                        if ("column" === this._getAreaName()) {
                            scrollablePos = scrollable.$content().width() - scrollable._container().width() - pos
                        } else {
                            if ("data" === this._getAreaName()) {
                                scrollablePos = {
                                    x: scrollable.$content().width() - scrollable._container().width() - pos.x,
                                    y: pos.y
                                }
                            }
                        }
                    }
                    scrollable.scrollTo(scrollablePos);
                    if (this._virtualContent) {
                        this._createFakeTable();
                        this._moveFakeTable(pos)
                    }
                }
            },
            updateScrollable: function() {
                var scrollable = this._getScrollable();
                if (scrollable) {
                    return scrollable.update()
                }
            },
            getColumnsCount: function() {
                var columnCount = 0;
                var row = this._getRowElement(0);
                var cells;
                if (row) {
                    cells = row.cells;
                    for (var i = 0, len = cells.length; i < len; ++i) {
                        columnCount += cells[i].colSpan
                    }
                }
                return columnCount
            },
            getData: function() {
                var tableElement = this._tableElement;
                return tableElement ? tableElement.data("data") : []
            }
        });
        exports.AreaItem = AreaItem
    },
    /*!************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/pivot_grid/ui.pivot_grid.field_chooser_base.js ***!
      \************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _array_store = _interopRequireDefault(__webpack_require__( /*! ../../data/array_store */ 77));
        var _click = __webpack_require__( /*! ../../events/click */ 21);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _uiGrid_core = __webpack_require__( /*! ../grid_core/ui.grid_core.header_filter_core */ 408);
        var _uiGrid_core2 = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.column_state_mixin */ 380));
        var _uiGrid_core3 = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.sorting_mixin */ 385));
        var _uiPivot_grid = __webpack_require__( /*! ./ui.pivot_grid.utils */ 84);
        var _ui2 = _interopRequireDefault(__webpack_require__( /*! ./ui.sortable */ 780));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var IE_FIELD_WIDTH_CORRECTION = 1;
        var DIV = "<div>";
        var HeaderFilterView = _uiGrid_core.HeaderFilterView.inherit({
            _getSearchExpr: function(options) {
                options.useDefaultSearchExpr = true;
                return this.callBase(options)
            }
        });
        var processItems = function(groupItems, field) {
            var filterValues = [];
            var isTree = !!field.groupName;
            var isExcludeFilterType = "exclude" === field.filterType;
            if (field.filterValues) {
                (0, _iterator.each)(field.filterValues, function(_, filterValue) {
                    filterValues.push(Array.isArray(filterValue) ? filterValue.join("/") : filterValue && filterValue.valueOf())
                })
            }(0, _uiPivot_grid.foreachTree)(groupItems, function(items) {
                var item = items[0];
                var path = (0, _uiPivot_grid.createPath)(items);
                var preparedFilterValueByText = isTree ? (0, _iterator.map)(items, function(item) {
                    return item.text
                }).reverse().join("/") : item.text;
                item.value = isTree ? path.slice(0) : item.key || item.value;
                var preparedFilterValue = isTree ? path.join("/") : item.value && item.value.valueOf();
                if (item.children) {
                    item.items = item.children;
                    item.children = null
                }(0, _uiGrid_core.updateHeaderFilterItemSelectionState)(item, item.key && (0, _array.inArray)(preparedFilterValueByText, filterValues) > -1 || (0, _array.inArray)(preparedFilterValue, filterValues) > -1, isExcludeFilterType)
            })
        };

        function getMainGroupField(dataSource, sourceField) {
            var field = sourceField;
            if ((0, _type.isDefined)(sourceField.groupIndex)) {
                field = dataSource.getAreaFields(sourceField.area, true)[sourceField.areaIndex]
            }
            return field
        }

        function getStringState(state) {
            state = state || {};
            return JSON.stringify([state.fields, state.columnExpandedPaths, state.rowExpandedPaths])
        }
        var FieldChooserBase = _ui.default.inherit(_uiGrid_core2.default).inherit(_uiGrid_core3.default).inherit(_uiGrid_core.headerFilterMixin).inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    allowFieldDragging: true,
                    applyChangesMode: "instantly",
                    state: null,
                    headerFilter: {
                        width: 252,
                        height: 325,
                        searchTimeout: 500,
                        texts: {
                            emptyValue: _message.default.format("dxDataGrid-headerFilterEmptyValue"),
                            ok: _message.default.format("dxDataGrid-headerFilterOK"),
                            cancel: _message.default.format("dxDataGrid-headerFilterCancel")
                        }
                    }
                })
            },
            _init: function() {
                this.callBase();
                this._headerFilterView = new HeaderFilterView(this);
                this._refreshDataSource();
                this.subscribeToEvents()
            },
            _refreshDataSource: function() {
                var dataSource = this.option("dataSource");
                if (dataSource && dataSource.fields && dataSource.load) {
                    this._dataSource = dataSource
                }
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "dataSource":
                        this._refreshDataSource();
                        break;
                    case "applyChangesMode":
                        break;
                    case "state":
                        if (this._skipStateChange || !this._dataSource) {
                            break
                        }
                        if ("instantly" === this.option("applyChangesMode") && getStringState(this._dataSource.state()) !== getStringState(args.value)) {
                            this._dataSource.state(args.value)
                        } else {
                            this._clean(true);
                            this._renderComponent()
                        }
                        break;
                    case "headerFilter":
                    case "allowFieldDragging":
                        this._invalidate();
                        break;
                    default:
                        this.callBase(args)
                }
            },
            renderField: function(field, showColumnLines) {
                var that = this;
                var $fieldContent = (0, _renderer.default)(DIV).addClass("dx-area-field-content").text(field.caption || field.dataField);
                var $fieldElement = (0, _renderer.default)(DIV).addClass("dx-area-field").addClass("dx-area-box").data("field", field).append($fieldContent);
                var mainGroupField = getMainGroupField(that._dataSource, field);
                if ("data" !== field.area) {
                    if (field.allowSorting) {
                        that._applyColumnState({
                            name: "sort",
                            rootElement: $fieldElement,
                            column: {
                                alignment: that.option("rtlEnabled") ? "right" : "left",
                                sortOrder: "desc" === field.sortOrder ? "desc" : "asc"
                            },
                            showColumnLines: showColumnLines
                        })
                    }
                    that._applyColumnState({
                        name: "headerFilter",
                        rootElement: $fieldElement,
                        column: {
                            alignment: that.option("rtlEnabled") ? "right" : "left",
                            filterValues: mainGroupField.filterValues,
                            allowFiltering: mainGroupField.allowFiltering && !field.groupIndex
                        },
                        showColumnLines: showColumnLines
                    })
                }
                if (field.groupName) {
                    $fieldElement.attr("item-group", field.groupName)
                }
                return $fieldElement
            },
            _clean: function() {},
            _render: function() {
                this.callBase();
                this._headerFilterView.render(this.$element())
            },
            renderSortable: function() {
                var that = this;
                that._createComponent(that.$element(), _ui2.default, (0, _extend.extend)({
                    allowDragging: that.option("allowFieldDragging"),
                    itemSelector: ".dx-area-field",
                    itemContainerSelector: ".dx-area-field-container",
                    groupSelector: ".dx-area-fields",
                    groupFilter: function() {
                        var dataSource = that._dataSource;
                        var $sortable = (0, _renderer.default)(this).closest(".dx-sortable-old");
                        var pivotGrid = $sortable.data("dxPivotGrid");
                        var pivotGridFieldChooser = $sortable.data("dxPivotGridFieldChooser");
                        if (pivotGrid) {
                            return pivotGrid.getDataSource() === dataSource
                        }
                        if (pivotGridFieldChooser) {
                            return pivotGridFieldChooser.option("dataSource") === dataSource
                        }
                        return false
                    },
                    itemRender: function($sourceItem, target) {
                        var $item;
                        if ($sourceItem.hasClass("dx-area-box")) {
                            $item = $sourceItem.clone();
                            if ("drag" === target) {
                                (0, _iterator.each)($sourceItem, function(index, sourceItem) {
                                    $item.eq(index).css("width", parseInt((0, _renderer.default)(sourceItem).outerWidth(), 10) + IE_FIELD_WIDTH_CORRECTION)
                                })
                            }
                        } else {
                            $item = (0, _renderer.default)(DIV).addClass("dx-area-field").addClass("dx-area-box").text($sourceItem.text())
                        }
                        if ("drag" === target) {
                            var wrapperContainer = (0, _renderer.default)(DIV);
                            (0, _iterator.each)($item, function(_, item) {
                                var wrapper = (0, _renderer.default)("<div>").addClass("dx-pivotgrid-fields-container").addClass("dx-widget").append((0, _renderer.default)(item));
                                wrapperContainer.append(wrapper)
                            });
                            return wrapperContainer.children()
                        }
                        return $item
                    },
                    onDragging: function(e) {
                        var field = e.sourceElement.data("field");
                        var targetGroup = e.targetGroup;
                        e.cancel = false;
                        if (true === field.isMeasure) {
                            if ("column" === targetGroup || "row" === targetGroup || "filter" === targetGroup) {
                                e.cancel = true
                            }
                        } else {
                            if (false === field.isMeasure && "data" === targetGroup) {
                                e.cancel = true
                            }
                        }
                    },
                    useIndicator: true,
                    onChanged: function(e) {
                        var dataSource = that._dataSource;
                        var field = e.sourceElement.data("field");
                        e.removeSourceElement = !!e.sourceGroup;
                        that._adjustSortableOnChangedArgs(e);
                        if (field) {
                            that._applyChanges([getMainGroupField(dataSource, field)], {
                                area: e.targetGroup,
                                areaIndex: e.targetIndex
                            })
                        }
                    }
                }, that._getSortableOptions()))
            },
            _processDemandState: function(func) {
                var that = this;
                var isInstantlyMode = "instantly" === that.option("applyChangesMode");
                var dataSource = that._dataSource;
                if (isInstantlyMode) {
                    func(dataSource, isInstantlyMode)
                } else {
                    var currentState = dataSource.state();
                    var pivotGridState = that.option("state");
                    if (pivotGridState) {
                        dataSource.state(pivotGridState, true)
                    }
                    func(dataSource, isInstantlyMode);
                    dataSource.state(currentState, true)
                }
            },
            _applyChanges: function(fields, props) {
                var that = this;
                that._processDemandState(function(dataSource, isInstantlyMode) {
                    fields.forEach(function(_ref) {
                        var index = _ref.index;
                        dataSource.field(index, props)
                    });
                    if (isInstantlyMode) {
                        dataSource.load()
                    } else {
                        that._changedHandler()
                    }
                })
            },
            _adjustSortableOnChangedArgs: function(e) {
                e.removeSourceElement = false;
                e.removeTargetElement = true;
                e.removeSourceClass = false
            },
            _getSortableOptions: function() {
                return {
                    direction: "auto"
                }
            },
            subscribeToEvents: function(element) {
                var that = this;
                var func = function(e) {
                    var field = (0, _renderer.default)(e.currentTarget).data("field");
                    var mainGroupField = (0, _extend.extend)(true, {}, getMainGroupField(that._dataSource, field));
                    var isHeaderFilter = (0, _renderer.default)(e.target).hasClass("dx-header-filter");
                    var dataSource = that._dataSource;
                    var type = mainGroupField.groupName ? "tree" : "list";
                    var paginate = dataSource.paginate() && "list" === type;
                    if (isHeaderFilter) {
                        that._headerFilterView.showHeaderFilterMenu((0, _renderer.default)(e.currentTarget), (0, _extend.extend)(mainGroupField, {
                            type: type,
                            encodeHtml: that.option("encodeHtml"),
                            dataSource: {
                                useDefaultSearch: !paginate,
                                load: function(options) {
                                    var userData = options.userData;
                                    if (userData.store) {
                                        return userData.store.load(options)
                                    } else {
                                        var d = new _deferred.Deferred;
                                        dataSource.getFieldValues(mainGroupField.index, that.option("headerFilter.showRelevantValues"), paginate ? options : void 0).done(function(data) {
                                            var emptyValue = that.option("headerFilter.texts.emptyValue");
                                            data.forEach(function(element) {
                                                if (!element.text) {
                                                    element.text = emptyValue
                                                }
                                            });
                                            if (paginate) {
                                                d.resolve(data)
                                            } else {
                                                userData.store = new _array_store.default(data);
                                                userData.store.load(options).done(d.resolve).fail(d.reject)
                                            }
                                        }).fail(d.reject);
                                        return d
                                    }
                                },
                                postProcess: function(data) {
                                    processItems(data, mainGroupField);
                                    return data
                                }
                            },
                            apply: function() {
                                that._applyChanges([mainGroupField], {
                                    filterValues: this.filterValues,
                                    filterType: this.filterType
                                })
                            }
                        }))
                    } else {
                        if (field.allowSorting && "data" !== field.area) {
                            that._applyChanges([field], {
                                sortOrder: "desc" === field.sortOrder ? "asc" : "desc"
                            })
                        }
                    }
                };
                if (element) {
                    _events_engine.default.on(element, _click.name, ".dx-area-field.dx-area-box", func);
                    return
                }
                _events_engine.default.on(that.$element(), _click.name, ".dx-area-field.dx-area-box", func)
            },
            _initTemplates: _common.noop,
            addWidgetPrefix: function(className) {
                return "dx-pivotgrid-" + className
            }
        });
        (0, _component_registrator.default)("dxPivotGridFieldChooserBase", FieldChooserBase);
        var _default = FieldChooserBase;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/iterresult.js ***!
      \*******************************************************/
    /*! exports provided: default */
    /*! exports used: default */
    function(module, __webpack_exports__, __webpack_require__) {
        var IterResult = function() {
            function IterResult(method, args) {
                this.minDate = null;
                this.maxDate = null;
                this._result = [];
                this.total = 0;
                this.method = method;
                this.args = args;
                if ("between" === method) {
                    this.maxDate = args.inc ? args.before : new Date(args.before.getTime() - 1);
                    this.minDate = args.inc ? args.after : new Date(args.after.getTime() + 1)
                } else {
                    if ("before" === method) {
                        this.maxDate = args.inc ? args.dt : new Date(args.dt.getTime() - 1)
                    } else {
                        if ("after" === method) {
                            this.minDate = args.inc ? args.dt : new Date(args.dt.getTime() + 1)
                        }
                    }
                }
            }
            IterResult.prototype.accept = function(date) {
                ++this.total;
                var tooEarly = this.minDate && date < this.minDate;
                var tooLate = this.maxDate && date > this.maxDate;
                if ("between" === this.method) {
                    if (tooEarly) {
                        return true
                    }
                    if (tooLate) {
                        return false
                    }
                } else {
                    if ("before" === this.method) {
                        if (tooLate) {
                            return false
                        }
                    } else {
                        if ("after" === this.method) {
                            if (tooEarly) {
                                return true
                            }
                            this.add(date);
                            return false
                        }
                    }
                }
                return this.add(date)
            };
            IterResult.prototype.add = function(date) {
                this._result.push(date);
                return true
            };
            IterResult.prototype.getValue = function() {
                var res = this._result;
                switch (this.method) {
                    case "all":
                    case "between":
                        return res;
                    case "before":
                    case "after":
                    default:
                        return res.length ? res[res.length - 1] : null
                }
            };
            IterResult.prototype.clone = function() {
                return new IterResult(this.method, this.args)
            };
            return IterResult
        }();
        __webpack_exports__.a = IterResult
    },
    /*!*****************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/datetime.js ***!
      \*****************************************************/
    /*! exports provided: Time, DateTime */
    /*! exports used: DateTime, Time */
    function(module, __webpack_exports__, __webpack_require__) {
        __webpack_require__.d(__webpack_exports__, "b", function() {
            return Time
        });
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return DateTime
        });
        var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__( /*! tslib */ 120);
        var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__( /*! ./types */ 140);
        var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__( /*! ./helpers */ 63);
        var __WEBPACK_IMPORTED_MODULE_3__dateutil__ = __webpack_require__( /*! ./dateutil */ 62);
        var Time = function() {
            function Time(hour, minute, second, millisecond) {
                this.hour = hour;
                this.minute = minute;
                this.second = second;
                this.millisecond = millisecond || 0
            }
            Time.prototype.getHours = function() {
                return this.hour
            };
            Time.prototype.getMinutes = function() {
                return this.minute
            };
            Time.prototype.getSeconds = function() {
                return this.second
            };
            Time.prototype.getMilliseconds = function() {
                return this.millisecond
            };
            Time.prototype.getTime = function() {
                return 1e3 * (60 * this.hour * 60 + 60 * this.minute + this.second) + this.millisecond
            };
            return Time
        }();
        var DateTime = function(_super) {
            Object(__WEBPACK_IMPORTED_MODULE_0_tslib__.b)(DateTime, _super);

            function DateTime(year, month, day, hour, minute, second, millisecond) {
                var _this = _super.call(this, hour, minute, second, millisecond) || this;
                _this.year = year;
                _this.month = month;
                _this.day = day;
                return _this
            }
            DateTime.fromDate = function(date) {
                return new this(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.valueOf() % 1e3)
            };
            DateTime.prototype.getWeekday = function() {
                return __WEBPACK_IMPORTED_MODULE_3__dateutil__.a.getWeekday(new Date(this.getTime()))
            };
            DateTime.prototype.getTime = function() {
                return new Date(Date.UTC(this.year, this.month - 1, this.day, this.hour, this.minute, this.second, this.millisecond)).getTime()
            };
            DateTime.prototype.getDay = function() {
                return this.day
            };
            DateTime.prototype.getMonth = function() {
                return this.month
            };
            DateTime.prototype.getYear = function() {
                return this.year
            };
            DateTime.prototype.addYears = function(years) {
                this.year += years
            };
            DateTime.prototype.addMonths = function(months) {
                this.month += months;
                if (this.month > 12) {
                    var yearDiv = Math.floor(this.month / 12);
                    var monthMod = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.j)(this.month, 12);
                    this.month = monthMod;
                    this.year += yearDiv;
                    if (0 === this.month) {
                        this.month = 12;
                        --this.year
                    }
                }
            };
            DateTime.prototype.addWeekly = function(days, wkst) {
                if (wkst > this.getWeekday()) {
                    this.day += -(this.getWeekday() + 1 + (6 - wkst)) + 7 * days
                } else {
                    this.day += -(this.getWeekday() - wkst) + 7 * days
                }
                this.fixDay()
            };
            DateTime.prototype.addDaily = function(days) {
                this.day += days;
                this.fixDay()
            };
            DateTime.prototype.addHours = function(hours, filtered, byhour) {
                if (filtered) {
                    this.hour += Math.floor((23 - this.hour) / hours) * hours
                }
                while (true) {
                    this.hour += hours;
                    var _a = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.a)(this.hour, 24),
                        dayDiv = _a.div,
                        hourMod = _a.mod;
                    if (dayDiv) {
                        this.hour = hourMod;
                        this.addDaily(dayDiv)
                    }
                    if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.b)(byhour) || Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.c)(byhour, this.hour)) {
                        break
                    }
                }
            };
            DateTime.prototype.addMinutes = function(minutes, filtered, byhour, byminute) {
                if (filtered) {
                    this.minute += Math.floor((1439 - (60 * this.hour + this.minute)) / minutes) * minutes
                }
                while (true) {
                    this.minute += minutes;
                    var _a = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.a)(this.minute, 60),
                        hourDiv = _a.div,
                        minuteMod = _a.mod;
                    if (hourDiv) {
                        this.minute = minuteMod;
                        this.addHours(hourDiv, false, byhour)
                    }
                    if ((Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.b)(byhour) || Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.c)(byhour, this.hour)) && (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.b)(byminute) || Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.c)(byminute, this.minute))) {
                        break
                    }
                }
            };
            DateTime.prototype.addSeconds = function(seconds, filtered, byhour, byminute, bysecond) {
                if (filtered) {
                    this.second += Math.floor((86399 - (3600 * this.hour + 60 * this.minute + this.second)) / seconds) * seconds
                }
                while (true) {
                    this.second += seconds;
                    var _a = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.a)(this.second, 60),
                        minuteDiv = _a.div,
                        secondMod = _a.mod;
                    if (minuteDiv) {
                        this.second = secondMod;
                        this.addMinutes(minuteDiv, false, byhour, byminute)
                    }
                    if ((Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.b)(byhour) || Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.c)(byhour, this.hour)) && (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.b)(byminute) || Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.c)(byminute, this.minute)) && (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.b)(bysecond) || Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.c)(bysecond, this.second))) {
                        break
                    }
                }
            };
            DateTime.prototype.fixDay = function() {
                if (this.day <= 28) {
                    return
                }
                var daysinmonth = __WEBPACK_IMPORTED_MODULE_3__dateutil__.a.monthRange(this.year, this.month - 1)[1];
                if (this.day <= daysinmonth) {
                    return
                }
                while (this.day > daysinmonth) {
                    this.day -= daysinmonth;
                    ++this.month;
                    if (13 === this.month) {
                        this.month = 1;
                        ++this.year;
                        if (this.year > __WEBPACK_IMPORTED_MODULE_3__dateutil__.a.MAXYEAR) {
                            return
                        }
                    }
                    daysinmonth = __WEBPACK_IMPORTED_MODULE_3__dateutil__.a.monthRange(this.year, this.month - 1)[1]
                }
            };
            DateTime.prototype.add = function(options, filtered) {
                var freq = options.freq,
                    interval = options.interval,
                    wkst = options.wkst,
                    byhour = options.byhour,
                    byminute = options.byminute,
                    bysecond = options.bysecond;
                switch (freq) {
                    case __WEBPACK_IMPORTED_MODULE_1__types__.a.YEARLY:
                        return this.addYears(interval);
                    case __WEBPACK_IMPORTED_MODULE_1__types__.a.MONTHLY:
                        return this.addMonths(interval);
                    case __WEBPACK_IMPORTED_MODULE_1__types__.a.WEEKLY:
                        return this.addWeekly(interval, wkst);
                    case __WEBPACK_IMPORTED_MODULE_1__types__.a.DAILY:
                        return this.addDaily(interval);
                    case __WEBPACK_IMPORTED_MODULE_1__types__.a.HOURLY:
                        return this.addHours(interval, filtered, byhour);
                    case __WEBPACK_IMPORTED_MODULE_1__types__.a.MINUTELY:
                        return this.addMinutes(interval, filtered, byhour, byminute);
                    case __WEBPACK_IMPORTED_MODULE_1__types__.a.SECONDLY:
                        return this.addSeconds(interval, filtered, byhour, byminute, bysecond)
                }
            };
            return DateTime
        }(Time)
    },
    /*!*********************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/datewithzone.js ***!
      \*********************************************************/
    /*! exports provided: DateWithZone */
    /*! exports used: DateWithZone */
    function(module, __webpack_exports__, __webpack_require__) {
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return DateWithZone
        });
        var __WEBPACK_IMPORTED_MODULE_0__dateutil__ = __webpack_require__( /*! ./dateutil */ 62);
        var __WEBPACK_IMPORTED_MODULE_1_luxon__ = __webpack_require__( /*! luxon */ 791);
        __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luxon__);
        var DateWithZone = function() {
            function DateWithZone(date, tzid) {
                this.date = date;
                this.tzid = tzid
            }
            Object.defineProperty(DateWithZone.prototype, "isUTC", {
                get: function() {
                    return !this.tzid || "UTC" === this.tzid.toUpperCase()
                },
                enumerable: true,
                configurable: true
            });
            DateWithZone.prototype.toString = function() {
                var datestr = __WEBPACK_IMPORTED_MODULE_0__dateutil__.b.timeToUntilString(this.date.getTime(), this.isUTC);
                if (!this.isUTC) {
                    return ";TZID=" + this.tzid + ":" + datestr
                }
                return ":" + datestr
            };
            DateWithZone.prototype.getTime = function() {
                return this.date.getTime()
            };
            DateWithZone.prototype.rezonedDate = function() {
                if (this.isUTC) {
                    return this.date
                }
                try {
                    var datetime = __WEBPACK_IMPORTED_MODULE_1_luxon__.DateTime.fromJSDate(this.date);
                    var rezoned = datetime.setZone(this.tzid, {
                        keepLocalTime: true
                    });
                    return rezoned.toJSDate()
                } catch (e) {
                    if (e instanceof TypeError) {
                        console.error("Using TZID without Luxon available is unsupported. Returned times are in UTC, not the requested time zone")
                    }
                    return this.date
                }
            };
            return DateWithZone
        }()
    },
    /*!*****************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/nlp/i18n.js ***!
      \*****************************************************/
    /*! exports provided: default */
    /*! exports used: default */
    function(module, __webpack_exports__, __webpack_require__) {
        var ENGLISH = {
            dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            tokens: {
                SKIP: /^[ \r\n\t]+|^\.$/,
                number: /^[1-9][0-9]*/,
                numberAsText: /^(one|two|three)/i,
                every: /^every/i,
                "day(s)": /^days?/i,
                "weekday(s)": /^weekdays?/i,
                "week(s)": /^weeks?/i,
                "hour(s)": /^hours?/i,
                "minute(s)": /^minutes?/i,
                "month(s)": /^months?/i,
                "year(s)": /^years?/i,
                on: /^(on|in)/i,
                at: /^(at)/i,
                the: /^the/i,
                first: /^first/i,
                second: /^second/i,
                third: /^third/i,
                nth: /^([1-9][0-9]*)(\.|th|nd|rd|st)/i,
                last: /^last/i,
                "for": /^for/i,
                "time(s)": /^times?/i,
                until: /^(un)?til/i,
                monday: /^mo(n(day)?)?/i,
                tuesday: /^tu(e(s(day)?)?)?/i,
                wednesday: /^we(d(n(esday)?)?)?/i,
                thursday: /^th(u(r(sday)?)?)?/i,
                friday: /^fr(i(day)?)?/i,
                saturday: /^sa(t(urday)?)?/i,
                sunday: /^su(n(day)?)?/i,
                january: /^jan(uary)?/i,
                february: /^feb(ruary)?/i,
                march: /^mar(ch)?/i,
                april: /^apr(il)?/i,
                may: /^may/i,
                june: /^june?/i,
                july: /^july?/i,
                august: /^aug(ust)?/i,
                september: /^sep(t(ember)?)?/i,
                october: /^oct(ober)?/i,
                november: /^nov(ember)?/i,
                december: /^dec(ember)?/i,
                comma: /^(,\s*|(and|or)\s*)+/i
            }
        };
        __webpack_exports__.a = ENGLISH
    },
    /*!***************************************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/rendering_strategies/ui.scheduler.appointments.strategy.base.js ***!
      \***************************************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiSchedulerAppointmentsPositioningStrategy = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.appointmentsPositioning.strategy.base */ 437));
        var _uiSchedulerAppointmentsPositioningStrategy2 = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.appointmentsPositioning.strategy.adaptive */ 811));
        var _extend = __webpack_require__( /*! ../../../core/utils/extend */ 0);
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../../core/utils/date */ 19));
        var _type = __webpack_require__( /*! ../../../core/utils/type */ 1);
        var _themes = __webpack_require__( /*! ../../themes */ 34);
        var _utils = _interopRequireDefault(__webpack_require__( /*! ../utils.timeZone */ 86));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }
        var toMs = _date.default.dateToMilliseconds;
        var APPOINTMENT_MIN_SIZE = 2;
        var APPOINTMENT_DEFAULT_HEIGHT = 20;
        var COMPACT_THEME_APPOINTMENT_DEFAULT_HEIGHT = 18;
        var DROP_DOWN_BUTTON_ADAPTIVE_SIZE = 28;
        var BaseRenderingStrategy = function() {
            function BaseRenderingStrategy(instance) {
                this.instance = instance;
                this._initPositioningStrategy()
            }
            var _proto = BaseRenderingStrategy.prototype;
            _proto._isAdaptive = function() {
                return this.instance.fire("isAdaptive")
            };
            _proto._correctCollectorCoordinatesInAdaptive = function(coordinates, isAllDay) {
                coordinates.top = coordinates.top + this.getCollectorTopOffset(isAllDay);
                coordinates.left = coordinates.left + this.getCollectorLeftOffset()
            };
            _proto._initPositioningStrategy = function() {
                this._positioningStrategy = this._isAdaptive() ? new _uiSchedulerAppointmentsPositioningStrategy2.default(this) : new _uiSchedulerAppointmentsPositioningStrategy.default(this)
            };
            _proto.getPositioningStrategy = function() {
                return this._positioningStrategy
            };
            _proto.getAppointmentMinSize = function() {
                return APPOINTMENT_MIN_SIZE
            };
            _proto.keepAppointmentSettings = function() {
                return false
            };
            _proto.getDeltaTime = function() {};
            _proto.getAppointmentGeometry = function(coordinates) {
                return coordinates
            };
            _proto.needCorrectAppointmentDates = function() {
                return true
            };
            _proto.getDirection = function() {
                return "horizontal"
            };
            _proto.createTaskPositionMap = function(items) {
                delete this._maxAppointmentCountPerCell;
                var length = items && items.length;
                if (!length) {
                    return
                }
                this._defaultWidth = this.instance.fire("getCellWidth");
                this._defaultHeight = this.instance.fire("getCellHeight");
                this._allDayHeight = this.instance._allDayCellHeight;
                var map = [];
                for (var i = 0; i < length; i++) {
                    var coordinates = this._getItemPosition(items[i]);
                    if (this._isRtl()) {
                        coordinates = this._correctRtlCoordinates(coordinates)
                    }
                    map.push(coordinates)
                }
                var positionArray = this._getSortedPositions(map);
                var resultPositions = this._getResultPositions(positionArray);
                return this._getExtendedPositionMap(map, resultPositions)
            };
            _proto._getDeltaWidth = function(args, initialSize) {
                var intervalWidth = this.instance.fire("getResizableStep") || this.getAppointmentMinSize();
                var initialWidth = initialSize.width;
                return Math.round((args.width - initialWidth) / intervalWidth)
            };
            _proto._correctRtlCoordinates = function(coordinates) {
                var width = coordinates[0].width || this._getAppointmentMaxWidth();
                coordinates.forEach(function(coordinate) {
                    if (!coordinate.appointmentReduced) {
                        coordinate.left -= width
                    }
                });
                return coordinates
            };
            _proto._getAppointmentMaxWidth = function() {
                return this.getDefaultCellWidth()
            };
            _proto._getItemPosition = function(appointment) {
                var position = this._getAppointmentCoordinates(appointment);
                var allDay = this.isAllDay(appointment);
                var result = [];
                for (var j = 0; j < position.length; j++) {
                    var height = this.calculateAppointmentHeight(appointment, position[j]);
                    var width = this.calculateAppointmentWidth(appointment, position[j]);
                    var resultWidth = width;
                    var appointmentReduced = null;
                    var multiWeekAppointmentParts = [];
                    var initialRowIndex = position[j].rowIndex;
                    var initialCellIndex = position[j].cellIndex;
                    if (this._needVerifyItemSize() || allDay) {
                        var currentMaxAllowedPosition = position[j].hMax;
                        if (this.isAppointmentGreaterThan(currentMaxAllowedPosition, {
                                left: position[j].left,
                                width: width
                            })) {
                            appointmentReduced = "head";
                            initialRowIndex = position[j].rowIndex;
                            initialCellIndex = position[j].cellIndex;
                            resultWidth = this._reduceMultiWeekAppointment(width, {
                                left: position[j].left,
                                right: currentMaxAllowedPosition
                            });
                            multiWeekAppointmentParts = this._getAppointmentParts({
                                sourceAppointmentWidth: width,
                                reducedWidth: resultWidth,
                                height: height
                            }, position[j]);
                            if (this._isRtl()) {
                                position[j].left = currentMaxAllowedPosition
                            }
                        }
                    }(0, _extend.extend)(position[j], {
                        height: height,
                        width: resultWidth,
                        allDay: allDay,
                        rowIndex: initialRowIndex,
                        cellIndex: initialCellIndex,
                        appointmentReduced: appointmentReduced
                    });
                    result = this._getAppointmentPartsPosition(multiWeekAppointmentParts, position[j], result)
                }
                return result
            };
            _proto._getAppointmentPartsPosition = function(appointmentParts, position, result) {
                if (appointmentParts.length) {
                    appointmentParts.unshift(position);
                    result = result.concat(appointmentParts)
                } else {
                    result.push(position)
                }
                return result
            };
            _proto._getAppointmentCoordinates = function(appointment) {
                return this.instance.fire("createAppointmentSettings", appointment)
            };
            _proto._isRtl = function() {
                return this.instance.option("rtlEnabled")
            };
            _proto._getAppointmentParts = function() {
                return []
            };
            _proto._getCompactAppointmentParts = function(appointmentWidth) {
                var cellWidth = this.getDefaultCellWidth() || this.getAppointmentMinSize();
                return Math.round(appointmentWidth / cellWidth)
            };
            _proto._reduceMultiWeekAppointment = function(sourceAppointmentWidth, bound) {
                if (this._isRtl()) {
                    sourceAppointmentWidth = Math.floor(bound.left - bound.right)
                } else {
                    sourceAppointmentWidth = bound.right - Math.floor(bound.left)
                }
                return sourceAppointmentWidth
            };
            _proto.calculateAppointmentHeight = function() {
                return 0
            };
            _proto.calculateAppointmentWidth = function() {
                return 0
            };
            _proto.isAppointmentGreaterThan = function(etalon, comparisonParameters) {
                var result = comparisonParameters.left + comparisonParameters.width - etalon;
                if (this._isRtl()) {
                    result = etalon + comparisonParameters.width - comparisonParameters.left
                }
                return result > this.getDefaultCellWidth() / 2
            };
            _proto.isAllDay = function() {
                return false
            };
            _proto.cropAppointmentWidth = function(width, cellWidth) {
                if (this.instance.fire("isGroupedByDate")) {
                    width = cellWidth
                }
                return width
            };
            _proto._getSortedPositions = function(positionList) {
                var _this = this;
                var result = [];
                var round = function(value) {
                    return Math.round(100 * value) / 100
                };
                var createItem = function(rowIndex, cellIndex, top, left, bottom, right, position, allDay) {
                    return {
                        i: rowIndex,
                        j: cellIndex,
                        top: round(top),
                        left: round(left),
                        bottom: round(bottom),
                        right: round(right),
                        cellPosition: position,
                        allDay: allDay
                    }
                };
                for (var rowIndex = 0, rowCount = positionList.length; rowIndex < rowCount; rowIndex++) {
                    for (var cellIndex = 0, cellCount = positionList[rowIndex].length; cellIndex < cellCount; cellIndex++) {
                        var _positionList$rowInde = positionList[rowIndex][cellIndex],
                            top = _positionList$rowInde.top,
                            left = _positionList$rowInde.left,
                            height = _positionList$rowInde.height,
                            width = _positionList$rowInde.width,
                            cellPosition = _positionList$rowInde.cellPosition,
                            allDay = _positionList$rowInde.allDay;
                        result.push(createItem(rowIndex, cellIndex, top, left, top + height, left + width, cellPosition, allDay))
                    }
                }
                return result.sort(function(a, b) {
                    return _this._sortCondition(a, b)
                })
            };
            _proto._sortCondition = function() {};
            _proto._getConditions = function(a, b) {
                var isSomeEdge = this._isSomeEdge(a, b);
                return {
                    columnCondition: isSomeEdge || this._normalizeCondition(a.left, b.left),
                    rowCondition: isSomeEdge || this._normalizeCondition(a.top, b.top),
                    cellPositionCondition: isSomeEdge || this._normalizeCondition(a.cellPosition, b.cellPosition)
                }
            };
            _proto._rowCondition = function(a, b) {
                var conditions = this._getConditions(a, b);
                return conditions.columnCondition || conditions.rowCondition
            };
            _proto._columnCondition = function(a, b) {
                var conditions = this._getConditions(a, b);
                return conditions.rowCondition || conditions.columnCondition
            };
            _proto._isSomeEdge = function(a, b) {
                return a.i === b.i && a.j === b.j
            };
            _proto._normalizeCondition = function(first, second) {
                var result = first - second;
                return Math.abs(result) > 1 ? result : 0
            };
            _proto._isItemsCross = function(firstItem, secondItem) {
                var areItemsInTheSameTable = !!firstItem.allDay === !!secondItem.allDay;
                var areItemsAllDay = firstItem.allDay && secondItem.allDay;
                if (areItemsInTheSameTable) {
                    var orientation = this._getOrientation(areItemsAllDay);
                    return this._checkItemsCrossing(firstItem, secondItem, orientation)
                } else {
                    return false
                }
            };
            _proto._checkItemsCrossing = function(firstItem, secondItem, orientation) {
                var firstItemSide_1 = Math.floor(firstItem[orientation[0]]);
                var firstItemSide_2 = Math.floor(firstItem[orientation[1]]);
                var secondItemSide_1 = Math.ceil(secondItem[orientation[0]]);
                var secondItemSide_2 = Math.ceil(secondItem[orientation[1]]);
                var isItemCross = Math.abs(firstItem[orientation[2]] - secondItem[orientation[2]]) <= 1;
                return isItemCross && (firstItemSide_1 <= secondItemSide_1 && firstItemSide_2 > secondItemSide_1 || firstItemSide_1 < secondItemSide_2 && firstItemSide_2 >= secondItemSide_2 || firstItemSide_1 === secondItemSide_1 && firstItemSide_2 === secondItemSide_2)
            };
            _proto._getOrientation = function(isAllDay) {
                return isAllDay ? ["left", "right", "top"] : ["top", "bottom", "left"]
            };
            _proto._getResultPositions = function(sortedArray) {
                var _this2 = this;
                var result = [];
                var i;
                var sortedIndex = 0;
                var currentItem;
                var indexes;
                var itemIndex;
                var maxIndexInStack = 0;
                var stack = {};
                var findFreeIndex = function findFreeIndex(indexes, index) {
                    var isFind = indexes.some(function(item) {
                        return item === index
                    });
                    if (isFind) {
                        return findFreeIndex(indexes, ++index)
                    } else {
                        return index
                    }
                };
                var createItem = function(currentItem, index) {
                    var currentIndex = index || 0;
                    return {
                        index: currentIndex,
                        i: currentItem.i,
                        j: currentItem.j,
                        left: currentItem.left,
                        right: currentItem.right,
                        top: currentItem.top,
                        bottom: currentItem.bottom,
                        allDay: currentItem.allDay,
                        sortedIndex: _this2._skipSortedIndex(currentIndex) ? null : sortedIndex++
                    }
                };
                var startNewStack = function(currentItem) {
                    stack.items = [createItem(currentItem)];
                    stack.left = currentItem.left;
                    stack.right = currentItem.right;
                    stack.top = currentItem.top;
                    stack.bottom = currentItem.bottom;
                    stack.allDay = currentItem.allDay
                };
                var pushItemsInResult = function(items) {
                    items.forEach(function(item) {
                        result.push({
                            index: item.index,
                            count: maxIndexInStack + 1,
                            i: item.i,
                            j: item.j,
                            sortedIndex: item.sortedIndex
                        })
                    })
                };
                for (i = 0; i < sortedArray.length; i++) {
                    currentItem = sortedArray[i];
                    indexes = [];
                    if (!stack.items) {
                        startNewStack(currentItem)
                    } else {
                        if (this._isItemsCross(stack, currentItem)) {
                            stack.items.forEach(function(item, index) {
                                if (_this2._isItemsCross(item, currentItem)) {
                                    indexes.push(item.index)
                                }
                            });
                            itemIndex = indexes.length ? findFreeIndex(indexes, 0) : 0;
                            stack.items.push(createItem(currentItem, itemIndex));
                            maxIndexInStack = Math.max(itemIndex, maxIndexInStack);
                            stack.left = Math.min(stack.left, currentItem.left);
                            stack.right = Math.max(stack.right, currentItem.right);
                            stack.top = Math.min(stack.top, currentItem.top);
                            stack.bottom = Math.max(stack.bottom, currentItem.bottom);
                            stack.allDay = currentItem.allDay
                        } else {
                            pushItemsInResult(stack.items);
                            stack = {};
                            startNewStack(currentItem);
                            maxIndexInStack = 0
                        }
                    }
                }
                if (stack.items) {
                    pushItemsInResult(stack.items)
                }
                return result.sort(function(a, b) {
                    var columnCondition = a.j - b.j;
                    var rowCondition = a.i - b.i;
                    return rowCondition ? rowCondition : columnCondition
                })
            };
            _proto._skipSortedIndex = function(index) {
                return index > this._getMaxAppointmentCountPerCell() - 1
            };
            _proto._findIndexByKey = function(arr, iKey, jKey, iValue, jValue) {
                var result = 0;
                for (var i = 0, len = arr.length; i < len; i++) {
                    if (arr[i][iKey] === iValue && arr[i][jKey] === jValue) {
                        result = i;
                        break
                    }
                }
                return result
            };
            _proto._getExtendedPositionMap = function(map, positions) {
                var positionCounter = 0;
                var result = [];
                for (var i = 0, mapLength = map.length; i < mapLength; i++) {
                    var resultString = [];
                    for (var j = 0, itemLength = map[i].length; j < itemLength; j++) {
                        map[i][j].index = positions[positionCounter].index;
                        map[i][j].sortedIndex = positions[positionCounter].sortedIndex;
                        map[i][j].count = positions[positionCounter++].count;
                        resultString.push(map[i][j]);
                        this._checkLongCompactAppointment(map[i][j], resultString)
                    }
                    result.push(resultString)
                }
                return result
            };
            _proto._checkLongCompactAppointment = function(item, result) {
                this._splitLongCompactAppointment(item, result);
                return result
            };
            _proto._splitLongCompactAppointment = function(item, result) {
                var appointmentCountPerCell = this._getMaxAppointmentCountPerCellByType(item.allDay);
                var compactCount = 0;
                if (void 0 !== appointmentCountPerCell && item.index > appointmentCountPerCell - 1) {
                    item.isCompact = true;
                    compactCount = this._getCompactAppointmentParts(item.width);
                    for (var k = 1; k < compactCount; k++) {
                        var compactPart = (0, _extend.extend)(true, {}, item);
                        compactPart.left = this._getCompactLeftCoordinate(item.left, k);
                        compactPart.cellIndex = compactPart.cellIndex + k;
                        compactPart.sortedIndex = null;
                        result.push(compactPart)
                    }
                }
                return result
            };
            _proto.normalizeEndDateByViewEnd = function(appointment, endDate) {
                var result = new Date(endDate.getTime());
                if (!this.isAllDay(appointment)) {
                    var viewEndDate = _date.default.roundToHour(this.instance.fire("getEndViewDate"));
                    if (result > viewEndDate) {
                        result = viewEndDate
                    }
                }
                var endDayHour = this.instance._getCurrentViewOption("endDayHour");
                var allDay = this.instance.fire("getField", "allDay", appointment);
                var currentViewEndTime = new Date(new Date(endDate.getTime()).setHours(endDayHour, 0, 0, 0));
                if (result.getTime() > currentViewEndTime.getTime() || allDay && result.getHours() < endDayHour) {
                    result = currentViewEndTime
                }
                return result
            };
            _proto._adjustDurationByDaylightDiff = function(duration, startDate, endDate) {
                var daylightDiff = _utils.default.getDaylightOffset(startDate, endDate);
                return this._needAdjustDuration(daylightDiff) ? this._calculateDurationByDaylightDiff(duration, daylightDiff) : duration
            };
            _proto._needAdjustDuration = function(diff) {
                return 0 !== diff
            };
            _proto._calculateDurationByDaylightDiff = function(duration, diff) {
                return duration + diff * toMs("minute")
            };
            _proto._getAppointmentDurationInMs = function(startDate, endDate, allDay) {
                return this.instance.fire("getAppointmentDurationInMs", {
                    startDate: startDate,
                    endDate: endDate,
                    allDay: allDay
                })
            };
            _proto._markAppointmentAsVirtual = function(coordinates) {
                var isAllDay = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : false;
                var countFullWidthAppointmentInCell = this._getMaxAppointmentCountPerCellByType(isAllDay);
                if (coordinates.count - countFullWidthAppointmentInCell > 0) {
                    var top = coordinates.top,
                        left = coordinates.left;
                    coordinates.virtual = {
                        top: top,
                        left: left,
                        index: this._generateAppointmentCollectorIndex(coordinates, isAllDay),
                        isAllDay: isAllDay
                    }
                }
            };
            _proto._generateAppointmentCollectorIndex = function(_ref, isAllDay) {
                var groupIndex = _ref.groupIndex,
                    rowIndex = _ref.rowIndex,
                    cellIndex = _ref.cellIndex;
                return "".concat(groupIndex, "-").concat(rowIndex, "-").concat(cellIndex, "-").concat(isAllDay)
            };
            _proto._getMaxAppointmentCountPerCellByType = function(isAllDay) {
                var appointmentCountPerCell = this._getMaxAppointmentCountPerCell();
                if ((0, _type.isObject)(appointmentCountPerCell)) {
                    return isAllDay ? this._getMaxAppointmentCountPerCell().allDay : this._getMaxAppointmentCountPerCell().simple
                } else {
                    return appointmentCountPerCell
                }
            };
            _proto.getDropDownAppointmentWidth = function(intervalCount, isAllDay) {
                return this.getPositioningStrategy().getDropDownAppointmentWidth(intervalCount, isAllDay)
            };
            _proto.getDropDownAppointmentHeight = function() {
                return this.getPositioningStrategy().getDropDownAppointmentHeight()
            };
            _proto.getDropDownButtonAdaptiveSize = function() {
                return DROP_DOWN_BUTTON_ADAPTIVE_SIZE
            };
            _proto.getDefaultCellWidth = function() {
                return this._defaultWidth
            };
            _proto.getDefaultCellHeight = function() {
                return this._defaultHeight
            };
            _proto.getDefaultAllDayCellHeight = function() {
                return this._allDayHeight
            };
            _proto.getCollectorTopOffset = function(allDay) {
                return this.getPositioningStrategy().getCollectorTopOffset(allDay)
            };
            _proto.getCollectorLeftOffset = function() {
                return this.getPositioningStrategy().getCollectorLeftOffset()
            };
            _proto.getAppointmentDataCalculator = function() {};
            _proto._customizeCoordinates = function(coordinates, height, appointmentCountPerCell, topOffset, isAllDay) {
                var index = coordinates.index;
                var appointmentHeight = height / appointmentCountPerCell;
                var appointmentTop = coordinates.top + index * appointmentHeight;
                var top = appointmentTop + topOffset;
                var width = coordinates.width;
                var left = coordinates.left;
                if (coordinates.isCompact) {
                    this._isAdaptive() && this._correctCollectorCoordinatesInAdaptive(coordinates, isAllDay);
                    this._markAppointmentAsVirtual(coordinates, isAllDay)
                }
                return {
                    height: appointmentHeight,
                    width: width,
                    top: top,
                    left: left,
                    empty: this._isAppointmentEmpty(height, width)
                }
            };
            _proto._isAppointmentEmpty = function(height, width) {
                return height < this._getAppointmentMinHeight() || width < this._getAppointmentMinWidth()
            };
            _proto._calculateGeometryConfig = function(coordinates) {
                var overlappingMode = this.instance.fire("getMaxAppointmentsPerCell");
                var offsets = this._getOffsets();
                var appointmentDefaultOffset = this._getAppointmentDefaultOffset();
                var appointmentCountPerCell = this._getAppointmentCount(overlappingMode, coordinates);
                var ratio = this._getDefaultRatio(coordinates, appointmentCountPerCell);
                var maxHeight = this._getMaxHeight();
                if (!(0, _type.isNumeric)(appointmentCountPerCell)) {
                    appointmentCountPerCell = coordinates.count;
                    ratio = (maxHeight - offsets.unlimited) / maxHeight
                }
                var topOffset = (1 - ratio) * maxHeight;
                if ("auto" === overlappingMode || (0, _type.isNumeric)(overlappingMode)) {
                    ratio = 1;
                    maxHeight -= appointmentDefaultOffset;
                    topOffset = appointmentDefaultOffset
                }
                return {
                    height: ratio * maxHeight,
                    appointmentCountPerCell: appointmentCountPerCell,
                    offset: topOffset
                }
            };
            _proto._getAppointmentCount = function() {};
            _proto._getDefaultRatio = function() {};
            _proto._getOffsets = function() {};
            _proto._getMaxHeight = function() {};
            _proto._needVerifyItemSize = function() {
                return false
            };
            _proto.needSeparateAppointment = function(allDay) {
                return this.instance.fire("isGroupedByDate") && allDay
            };
            _proto._getMaxAppointmentCountPerCell = function() {
                if (!this._maxAppointmentCountPerCell) {
                    var overlappingMode = this.instance.fire("getMaxAppointmentsPerCell");
                    var appointmentCountPerCell;
                    if ((0, _type.isNumeric)(overlappingMode)) {
                        appointmentCountPerCell = overlappingMode
                    }
                    if ("auto" === overlappingMode) {
                        appointmentCountPerCell = this._getDynamicAppointmentCountPerCell()
                    }
                    if ("unlimited" === overlappingMode) {
                        appointmentCountPerCell = void 0
                    }
                    this._maxAppointmentCountPerCell = appointmentCountPerCell
                }
                return this._maxAppointmentCountPerCell
            };
            _proto._getDynamicAppointmentCountPerCell = function() {
                return this.getPositioningStrategy().getDynamicAppointmentCountPerCell()
            };
            _proto.hasAllDayAppointments = function() {
                return false
            };
            _proto._isCompactTheme = function() {
                return "compact" === ((0, _themes.current)() || "").split(".").pop()
            };
            _proto._getAppointmentDefaultOffset = function() {
                return this.getPositioningStrategy().getAppointmentDefaultOffset()
            };
            _proto._getAppointmentDefaultHeight = function() {
                return this._getAppointmentHeightByTheme()
            };
            _proto._getAppointmentMinHeight = function() {
                return this._getAppointmentDefaultHeight()
            };
            _proto._getAppointmentHeightByTheme = function() {
                return this._isCompactTheme() ? COMPACT_THEME_APPOINTMENT_DEFAULT_HEIGHT : APPOINTMENT_DEFAULT_HEIGHT
            };
            _proto._getAppointmentDefaultWidth = function() {
                return this.getPositioningStrategy()._getAppointmentDefaultWidth()
            };
            _proto._getAppointmentMinWidth = function() {
                return this._getAppointmentDefaultWidth()
            };
            _proto._needVerticalGroupBounds = function() {
                return false
            };
            _proto._needHorizontalGroupBounds = function() {
                return false
            };
            _createClass(BaseRenderingStrategy, [{
                key: "isVirtualScrolling",
                get: function() {
                    return this.instance.fire("isVirtualScrolling")
                }
            }]);
            return BaseRenderingStrategy
        }();
        var _default = BaseRenderingStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/ui.scheduler.table_creator.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _element_data = __webpack_require__( /*! ../../core/element_data */ 40);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _element = __webpack_require__( /*! ../../core/element */ 18);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ROW_SELECTOR = "tr";
        var SchedulerTableCreator = function() {
            function SchedulerTableCreator() {
                this.VERTICAL = "vertical";
                this.HORIZONTAL = "horizontal"
            }
            var _proto = SchedulerTableCreator.prototype;
            _proto.insertAllDayRow = function(allDayElements, tableBody, index) {
                if (allDayElements[index]) {
                    var row = allDayElements[index].find(ROW_SELECTOR);
                    if (!row.length) {
                        row = (0, _renderer.default)(_dom_adapter.default.createElement(ROW_SELECTOR));
                        row.append(allDayElements[index].get(0))
                    }
                    tableBody.appendChild(row.get ? row.get(0) : row)
                }
            };
            _proto.makeTable = function(options) {
                var tableBody = _dom_adapter.default.createElement("tbody");
                var templateCallbacks = [];
                var row;
                var rowCountInGroup = options.groupCount ? options.rowCount / options.groupCount : options.rowCount;
                var allDayElementIndex = 0;
                var allDayElements = options.allDayElements;
                var groupIndex = options.groupIndex;
                var rowCount = options.rowCount;
                (0, _renderer.default)(options.container).append(tableBody);
                if (allDayElements) {
                    this.insertAllDayRow(allDayElements, tableBody, 0);
                    allDayElementIndex++
                }
                for (var i = 0; i < rowCount; i++) {
                    row = _dom_adapter.default.createElement(ROW_SELECTOR);
                    tableBody.appendChild(row);
                    var isLastRowInGroup = (i + 1) % rowCountInGroup === 0;
                    if (options.rowClass) {
                        row.className = options.rowClass
                    }
                    for (var j = 0; j < options.cellCount; j++) {
                        var td = _dom_adapter.default.createElement("td");
                        row.appendChild(td);
                        if (options.cellClass) {
                            if ((0, _type.isFunction)(options.cellClass)) {
                                td.className = options.cellClass(i, j)
                            } else {
                                td.className = options.cellClass
                            }
                        }
                        var cellDataObject = void 0;
                        var dataKey = void 0;
                        var dataValue = void 0;
                        if (options.getCellData) {
                            cellDataObject = options.getCellData(td, i, j, groupIndex);
                            dataKey = cellDataObject.key;
                            dataValue = cellDataObject.value;
                            dataKey && (0, _element_data.data)(td, dataKey, dataValue)
                        }
                        if (options.cellTemplate && options.cellTemplate.render) {
                            var templateOptions = {
                                model: {
                                    text: options.getCellText ? options.getCellText(i, j) : "",
                                    date: options.getCellDate ? options.getCellDate(i) : void 0
                                },
                                container: (0, _element.getPublicElement)((0, _renderer.default)(td)),
                                index: i * options.cellCount + j
                            };
                            if (dataValue) {
                                if (dataValue.startDate) {
                                    templateOptions.model.startDate = dataValue.startDate
                                }
                                if (dataValue.endDate) {
                                    templateOptions.model.endDate = dataValue.endDate
                                }
                                if (dataValue.groups) {
                                    templateOptions.model.groups = dataValue.groups
                                }
                                if (dataValue.allDay) {
                                    templateOptions.model.allDay = dataValue.allDay
                                }
                            }
                            templateCallbacks.push(options.cellTemplate.render.bind(options.cellTemplate, templateOptions))
                        } else {
                            if (options.getCellText) {
                                td.innerHTML = "<div>" + options.getCellText(i, j) + "</div>"
                            }
                        }
                    }
                    if (allDayElements && isLastRowInGroup) {
                        this.insertAllDayRow(allDayElements, tableBody, allDayElementIndex);
                        allDayElementIndex++
                    }
                }
                return templateCallbacks
            };
            _proto.makeGroupedTable = function(type, groups, cssClasses, cellCount, cellTemplate, rowCount, groupByDate) {
                var rows = [];
                if (type === this.VERTICAL) {
                    rows = this._makeVerticalGroupedRows(groups, cssClasses, cellTemplate, rowCount)
                } else {
                    rows = this._makeHorizontalGroupedRows(groups, cssClasses, cellCount, cellTemplate, groupByDate)
                }
                return rows
            };
            _proto.makeGroupedTableFromJSON = function(type, data, config) {
                var table;
                var cellStorage = [];
                var rowIndex = 0;
                config = config || {};
                var cellTag = config.cellTag || "td";
                var childrenField = config.childrenField || "children";
                var titleField = config.titleField || "title";
                var groupTableClass = config.groupTableClass;
                var groupRowClass = config.groupRowClass;
                var groupCellClass = config.groupCellClass;
                var groupCellCustomContent = config.groupCellCustomContent;

                function createTable() {
                    table = _dom_adapter.default.createElement("table");
                    if (groupTableClass) {
                        table.className = groupTableClass
                    }
                }

                function getChildCount(item) {
                    if (item[childrenField]) {
                        return item[childrenField].length
                    }
                    return 0
                }

                function createCell(text, childCount, index, data) {
                    var cell = {
                        element: _dom_adapter.default.createElement(cellTag),
                        childCount: childCount
                    };
                    if (groupCellClass) {
                        cell.element.className = groupCellClass
                    }
                    var cellText = _dom_adapter.default.createTextNode(text);
                    if ("function" === typeof groupCellCustomContent) {
                        groupCellCustomContent(cell.element, cellText, index, data)
                    } else {
                        cell.element.appendChild(cellText)
                    }
                    return cell
                }

                function generateCells(data) {
                    for (var i = 0; i < data.length; i++) {
                        var childCount = getChildCount(data[i]);
                        var cell = createCell(data[i][titleField], childCount, i, data[i]);
                        if (!cellStorage[rowIndex]) {
                            cellStorage[rowIndex] = []
                        }
                        cellStorage[rowIndex].push(cell);
                        if (childCount) {
                            generateCells(data[i][childrenField])
                        } else {
                            rowIndex++
                        }
                    }
                }

                function putCellsToRows() {
                    cellStorage.forEach(function(cells) {
                        var row = _dom_adapter.default.createElement(ROW_SELECTOR);
                        if (groupRowClass) {
                            row.className = groupRowClass
                        }
                        var rowspans = [];
                        for (var i = cells.length - 1; i >= 0; i--) {
                            var prev = cells[i + 1];
                            var rowspan = cells[i].childCount;
                            if (prev && prev.childCount) {
                                rowspan *= prev.childCount
                            }
                            rowspans.push(rowspan)
                        }
                        rowspans.reverse();
                        cells.forEach(function(cell, index) {
                            if (rowspans[index]) {
                                cell.element.setAttribute("rowSpan", rowspans[index])
                            }
                            row.appendChild(cell.element)
                        });
                        table.appendChild(row)
                    })
                }
                createTable();
                generateCells(data);
                putCellsToRows();
                return table
            };
            _proto._makeFlexGroupedRowCells = function(group, repeatCount, cssClasses, cellTemplate) {
                var repeatByDate = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 1;
                var cells = [];
                var items = group.items;
                var itemCount = items.length;
                for (var i = 0; i < repeatCount * repeatByDate; i++) {
                    for (var j = 0; j < itemCount; j++) {
                        var $container = (0, _renderer.default)("<div>");
                        var cell = {};
                        if (cellTemplate && cellTemplate.render) {
                            var templateOptions = {
                                model: items[j],
                                container: (0, _element.getPublicElement)($container),
                                index: i * itemCount + j
                            };
                            if (group.data) {
                                templateOptions.model.data = group.data[j]
                            }
                            cell.template = cellTemplate.render.bind(cellTemplate, templateOptions)
                        } else {
                            $container.text(items[j].text).attr("title", items[j].text).addClass("dx-scheduler-group-header-content");
                            $container = (0, _renderer.default)("<div>").append($container)
                        }
                        var cssClass = (0, _type.isFunction)(cssClasses.groupHeaderClass) ? cssClasses.groupHeaderClass(j) : cssClasses.groupHeaderClass;
                        cell.element = $container.addClass(cssClass);
                        cells.push(cell)
                    }
                }
                return cells
            };
            _proto._makeVerticalGroupedRows = function(groups, cssClasses, cellTemplate) {
                var cellTemplates = [];
                var repeatCount = 1;
                var cellsArray = [];
                var cellIterator = function(cell) {
                    if (cell.template) {
                        cellTemplates.push(cell.template)
                    }
                };
                for (var i = 0; i < groups.length; i++) {
                    if (i > 0) {
                        repeatCount = groups[i - 1].items.length * repeatCount
                    }
                    var cells = this._makeFlexGroupedRowCells(groups[i], repeatCount, cssClasses, cellTemplate);
                    cells.forEach(cellIterator);
                    cellsArray.push(cells)
                }
                var rows = [];
                var groupCount = cellsArray.length;
                for (var _i = 0; _i < groupCount; _i++) {
                    rows.push((0, _renderer.default)("<div>").addClass(cssClasses.groupHeaderRowClass))
                }
                for (var _i2 = groupCount - 1; _i2 >= 0; _i2--) {
                    var currentColumnLength = cellsArray[_i2].length;
                    for (var j = 0; j < currentColumnLength; j++) {
                        rows[_i2].append(cellsArray[_i2][j].element)
                    }
                }
                return {
                    elements: (0, _renderer.default)("<div>").addClass("dx-scheduler-group-flex-container").append(rows),
                    cellTemplates: cellTemplates
                }
            };
            _proto._makeHorizontalGroupedRows = function(groups, cssClasses, cellCount, cellTemplate, groupByDate) {
                var repeatCount = 1;
                var groupCount = groups.length;
                var rows = [];
                var cellTemplates = [];
                var repeatByDate = groupByDate ? cellCount : 1;
                var cellIterator = function(cell) {
                    if (cell.template) {
                        cellTemplates.push(cell.template)
                    }
                    return cell.element
                };
                for (var i = 0; i < groupCount; i++) {
                    if (i > 0) {
                        repeatCount = groups[i - 1].items.length * repeatCount
                    }
                    var cells = this._makeGroupedRowCells(groups[i], repeatCount, cssClasses, cellTemplate, repeatByDate);
                    rows.push((0, _renderer.default)("<tr>").addClass(cssClasses.groupRowClass).append(cells.map(cellIterator)))
                }
                var maxCellCount = rows[groupCount - 1].find("th").length;
                for (var j = 0; j < groupCount; j++) {
                    var $cell = rows[j].find("th");
                    var colspan = maxCellCount / $cell.length;
                    if (!groupByDate) {
                        colspan *= cellCount
                    }
                    if (colspan > 1 && 1 === repeatByDate || groupByDate && groupCount > 1) {
                        $cell.attr("colSpan", colspan)
                    }
                }
                return {
                    elements: rows,
                    cellTemplates: cellTemplates
                }
            };
            _proto._makeGroupedRowCells = function(group, repeatCount, cssClasses, cellTemplate, repeatByDate) {
                repeatByDate = repeatByDate || 1;
                repeatCount *= repeatByDate;
                var cells = [];
                var items = group.items;
                var itemCount = items.length;
                for (var i = 0; i < repeatCount; i++) {
                    for (var j = 0; j < itemCount; j++) {
                        var $container = (0, _renderer.default)("<div>");
                        var cell = {};
                        if (cellTemplate && cellTemplate.render) {
                            var templateOptions = {
                                model: items[j],
                                container: (0, _element.getPublicElement)($container),
                                index: i * itemCount + j
                            };
                            if (group.data) {
                                templateOptions.model.data = group.data[j]
                            }
                            cell.template = cellTemplate.render.bind(cellTemplate, templateOptions)
                        } else {
                            $container.text(items[j].text);
                            $container = (0, _renderer.default)("<div>").append($container)
                        }
                        $container.addClass(cssClasses.groupHeaderContentClass);
                        var cssClass = void 0;
                        if ((0, _type.isFunction)(cssClasses.groupHeaderClass)) {
                            cssClass = cssClasses.groupHeaderClass(j)
                        } else {
                            cssClass = cssClasses.groupHeaderClass
                        }
                        cell.element = (0, _renderer.default)("<th>").addClass(cssClass).append($container);
                        cells.push(cell)
                    }
                }
                return cells
            };
            return SchedulerTableCreator
        }();
        var _default = {
            tableCreator: new SchedulerTableCreator
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/ui/scheduler/workspaces/base/table.js ***!
      \***********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.Table = Table;
        exports.TableProps = exports.viewFunction = void 0;
        var _utils = __webpack_require__( /*! ../utils */ 185);
        var _virtualRow = __webpack_require__( /*! ./virtual-row */ 831);
        var Preact = _interopRequireWildcard(__webpack_require__( /*! preact */ 50));
        var _hooks = __webpack_require__( /*! preact/hooks */ 53);

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function _objectWithoutProperties(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = _objectWithoutPropertiesLoose(source, excluded);
            var key, i;
            if (Object.getOwnPropertySymbols) {
                var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
                for (i = 0; i < sourceSymbolKeys.length; i++) {
                    key = sourceSymbolKeys[i];
                    if (excluded.indexOf(key) >= 0) {
                        continue
                    }
                    if (!Object.prototype.propertyIsEnumerable.call(source, key)) {
                        continue
                    }
                    target[key] = source[key]
                }
            }
            return target
        }

        function _objectWithoutPropertiesLoose(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = {};
            var sourceKeys = Object.keys(source);
            var key, i;
            for (i = 0; i < sourceKeys.length; i++) {
                key = sourceKeys[i];
                if (excluded.indexOf(key) >= 0) {
                    continue
                }
                target[key] = source[key]
            }
            return target
        }

        function _extends() {
            _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key]
                        }
                    }
                }
                return target
            };
            return _extends.apply(this, arguments)
        }
        var viewFunction = function(_ref) {
            var hasBottomVirtualRow = _ref.hasBottomVirtualRow,
                hasTopVirtualRow = _ref.hasTopVirtualRow,
                _ref$props = _ref.props,
                bottomVirtualRowHeight = _ref$props.bottomVirtualRowHeight,
                children = _ref$props.children,
                className = _ref$props.className,
                topVirtualRowHeight = _ref$props.topVirtualRowHeight,
                virtualCellsCount = _ref$props.virtualCellsCount,
                restAttributes = _ref.restAttributes,
                style = _ref.style;
            return Preact.h("table", _extends({}, restAttributes, {
                className: className,
                style: style
            }), Preact.h("tbody", null, hasTopVirtualRow && hasBottomVirtualRow && Preact.h(Preact.Fragment, null, Preact.h(_virtualRow.VirtualRow, {
                height: topVirtualRowHeight,
                cellsCount: virtualCellsCount
            }), children, Preact.h(_virtualRow.VirtualRow, {
                height: bottomVirtualRowHeight,
                cellsCount: virtualCellsCount
            })), hasTopVirtualRow && !hasBottomVirtualRow && Preact.h(Preact.Fragment, null, Preact.h(_virtualRow.VirtualRow, {
                height: topVirtualRowHeight,
                cellsCount: virtualCellsCount
            }), children), !hasTopVirtualRow && hasBottomVirtualRow && Preact.h(Preact.Fragment, null, children, Preact.h(_virtualRow.VirtualRow, {
                height: bottomVirtualRowHeight,
                cellsCount: virtualCellsCount
            })), !hasTopVirtualRow && !hasBottomVirtualRow && Preact.h(Preact.Fragment, null, children)))
        };
        exports.viewFunction = viewFunction;
        var TableProps = {
            className: "",
            topVirtualRowHeight: 0,
            bottomVirtualRowHeight: 0,
            virtualCellsCount: 0,
            isVirtual: false
        };
        exports.TableProps = TableProps;

        function Table(props) {
            var __style = (0, _hooks.useCallback)(function() {
                var height = props.height;
                var _restAttributes = __restAttributes(),
                    style = _restAttributes.style;
                return (0, _utils.addHeightToStyle)(height, style)
            }, [props.height]);
            var __hasTopVirtualRow = (0, _hooks.useCallback)(function() {
                var isVirtual = props.isVirtual,
                    topVirtualRowHeight = props.topVirtualRowHeight;
                return !!isVirtual && !!topVirtualRowHeight
            }, [props.isVirtual, props.topVirtualRowHeight]);
            var __hasBottomVirtualRow = (0, _hooks.useCallback)(function() {
                var bottomVirtualRowHeight = props.bottomVirtualRowHeight,
                    isVirtual = props.isVirtual;
                return !!isVirtual && !!bottomVirtualRowHeight
            }, [props.bottomVirtualRowHeight, props.isVirtual]);
            var __restAttributes = (0, _hooks.useCallback)(function() {
                var restProps = (props.bottomVirtualRowHeight, props.children, props.className, props.height, props.isVirtual, props.topVirtualRowHeight, props.virtualCellsCount, _objectWithoutProperties(props, ["bottomVirtualRowHeight", "children", "className", "height", "isVirtual", "topVirtualRowHeight", "virtualCellsCount"]));
                return restProps
            }, [props]);
            return viewFunction({
                props: _objectSpread({}, props),
                style: __style(),
                hasTopVirtualRow: __hasTopVirtualRow(),
                hasBottomVirtualRow: __hasBottomVirtualRow(),
                restAttributes: __restAttributes()
            })
        }
        Table.defaultProps = _objectSpread({}, TableProps)
    },
    /*!*********************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/ui/scheduler/workspaces/base/date_table/cell.js ***!
      \*********************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.DateTableCellBase = DateTableCellBase;
        exports.DateTableCellBaseProps = exports.viewFunction = void 0;
        var _cell = __webpack_require__( /*! ../cell */ 303);
        var _combine_classes = __webpack_require__( /*! ../../../../../utils/combine_classes */ 222);
        var Preact = _interopRequireWildcard(__webpack_require__( /*! preact */ 50));
        var _hooks = __webpack_require__( /*! preact/hooks */ 53);

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function _objectWithoutProperties(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = _objectWithoutPropertiesLoose(source, excluded);
            var key, i;
            if (Object.getOwnPropertySymbols) {
                var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
                for (i = 0; i < sourceSymbolKeys.length; i++) {
                    key = sourceSymbolKeys[i];
                    if (excluded.indexOf(key) >= 0) {
                        continue
                    }
                    if (!Object.prototype.propertyIsEnumerable.call(source, key)) {
                        continue
                    }
                    target[key] = source[key]
                }
            }
            return target
        }

        function _objectWithoutPropertiesLoose(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = {};
            var sourceKeys = Object.keys(source);
            var key, i;
            for (i = 0; i < sourceKeys.length; i++) {
                key = sourceKeys[i];
                if (excluded.indexOf(key) >= 0) {
                    continue
                }
                target[key] = source[key]
            }
            return target
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function _extends() {
            _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key]
                        }
                    }
                }
                return target
            };
            return _extends.apply(this, arguments)
        }
        var viewFunction = function(viewModel) {
            return Preact.h(_cell.CellBase, _extends({}, viewModel.restAttributes, {
                isFirstGroupCell: viewModel.props.isFirstGroupCell,
                isLastGroupCell: viewModel.props.isLastGroupCell,
                contentTemplate: viewModel.props.dataCellTemplate,
                contentTemplateProps: viewModel.dataCellTemplateProps,
                className: viewModel.classes
            }), viewModel.props.children)
        };
        exports.viewFunction = viewFunction;
        var DateTableCellBaseProps = _objectSpread({}, _cell.CellBaseProps);
        exports.DateTableCellBaseProps = DateTableCellBaseProps;
        var getTemplate = function(TemplateProp) {
            return TemplateProp && (TemplateProp.defaultProps ? function(props) {
                return Preact.h(TemplateProp, _extends({}, props))
            } : TemplateProp)
        };

        function DateTableCellBase(props) {
            var __classes = (0, _hooks.useCallback)(function() {
                var allDay = props.allDay,
                    className = props.className;
                return (0, _combine_classes.combineClasses)(_defineProperty({
                    "dx-scheduler-cell-sizes-horizontal": true,
                    "dx-scheduler-cell-sizes-vertical": !allDay,
                    "dx-scheduler-date-table-cell": !allDay
                }, className, true))
            }, [props.allDay, props.className]);
            var __dataCellTemplateProps = (0, _hooks.useCallback)(function() {
                var allDay = props.allDay,
                    endDate = props.endDate,
                    groupIndex = props.groupIndex,
                    groups = props.groups,
                    index = props.index,
                    startDate = props.startDate,
                    text = props.text;
                return {
                    data: {
                        startDate: startDate,
                        endDate: endDate,
                        groups: groups,
                        groupIndex: groups ? groupIndex : void 0,
                        text: text || "",
                        allDay: allDay || void 0
                    },
                    index: index
                }
            }, [props.allDay, props.endDate, props.groupIndex, props.groups, props.index, props.startDate, props.text]);
            var __restAttributes = (0, _hooks.useCallback)(function() {
                var restProps = (props.allDay, props.children, props.className, props.contentTemplate, props.contentTemplateProps, props.dataCellTemplate, props.endDate, props.groupIndex, props.groups, props.index, props.isFirstGroupCell, props.isLastGroupCell, props.startDate, props.text, _objectWithoutProperties(props, ["allDay", "children", "className", "contentTemplate", "contentTemplateProps", "dataCellTemplate", "endDate", "groupIndex", "groups", "index", "isFirstGroupCell", "isLastGroupCell", "startDate", "text"]));
                return restProps
            }, [props]);
            return viewFunction({
                props: _objectSpread(_objectSpread({}, props), {}, {
                    dataCellTemplate: getTemplate(props.dataCellTemplate),
                    contentTemplate: getTemplate(props.contentTemplate)
                }),
                classes: __classes(),
                dataCellTemplateProps: __dataCellTemplateProps(),
                restAttributes: __restAttributes()
            })
        }
        DateTableCellBase.defaultProps = _objectSpread({}, DateTableCellBaseProps)
    },
    /*!**********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/ui/scheduler/workspaces/base/cell.js ***!
      \**********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.CellBase = CellBase;
        exports.CellBaseProps = exports.viewFunction = void 0;
        var _utils = __webpack_require__( /*! ../utils */ 185);
        var Preact = _interopRequireWildcard(__webpack_require__( /*! preact */ 50));
        var _hooks = __webpack_require__( /*! preact/hooks */ 53);

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function _objectWithoutProperties(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = _objectWithoutPropertiesLoose(source, excluded);
            var key, i;
            if (Object.getOwnPropertySymbols) {
                var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
                for (i = 0; i < sourceSymbolKeys.length; i++) {
                    key = sourceSymbolKeys[i];
                    if (excluded.indexOf(key) >= 0) {
                        continue
                    }
                    if (!Object.prototype.propertyIsEnumerable.call(source, key)) {
                        continue
                    }
                    target[key] = source[key]
                }
            }
            return target
        }

        function _objectWithoutPropertiesLoose(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = {};
            var sourceKeys = Object.keys(source);
            var key, i;
            for (i = 0; i < sourceKeys.length; i++) {
                key = sourceKeys[i];
                if (excluded.indexOf(key) >= 0) {
                    continue
                }
                target[key] = source[key]
            }
            return target
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function _extends() {
            _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key]
                        }
                    }
                }
                return target
            };
            return _extends.apply(this, arguments)
        }
        var viewFunction = function(viewModel) {
            var ContentTemplate = viewModel.props.contentTemplate;
            return Preact.h("td", _extends({}, viewModel.restAttributes, {
                className: viewModel.classes
            }), !viewModel.props.contentTemplate && viewModel.props.children, viewModel.props.contentTemplate && ContentTemplate(_objectSpread({}, viewModel.props.contentTemplateProps)))
        };
        exports.viewFunction = viewFunction;
        var CellBaseProps = {
            className: "",
            isFirstGroupCell: false,
            isLastGroupCell: false,
            startDate: new Date,
            endDate: new Date,
            allDay: false,
            text: "",
            index: 0,
            contentTemplateProps: {
                data: {},
                index: 0
            }
        };
        exports.CellBaseProps = CellBaseProps;
        var getTemplate = function(TemplateProp) {
            return TemplateProp && (TemplateProp.defaultProps ? function(props) {
                return Preact.h(TemplateProp, _extends({}, props))
            } : TemplateProp)
        };

        function CellBase(props) {
            var __classes = (0, _hooks.useCallback)(function() {
                var className = props.className,
                    isFirstGroupCell = props.isFirstGroupCell,
                    isLastGroupCell = props.isLastGroupCell;
                return (0, _utils.getGroupCellClasses)(isFirstGroupCell, isLastGroupCell, className)
            }, [props.className, props.isFirstGroupCell, props.isLastGroupCell]);
            var __restAttributes = (0, _hooks.useCallback)(function() {
                var restProps = (props.allDay, props.children, props.className, props.contentTemplate, props.contentTemplateProps, props.endDate, props.groupIndex, props.groups, props.index, props.isFirstGroupCell, props.isLastGroupCell, props.startDate, props.text, _objectWithoutProperties(props, ["allDay", "children", "className", "contentTemplate", "contentTemplateProps", "endDate", "groupIndex", "groups", "index", "isFirstGroupCell", "isLastGroupCell", "startDate", "text"]));
                return restProps
            }, [props]);
            return viewFunction({
                props: _objectSpread(_objectSpread({}, props), {}, {
                    contentTemplate: getTemplate(props.contentTemplate)
                }),
                classes: __classes(),
                restAttributes: __restAttributes()
            })
        }
        CellBase.defaultProps = _objectSpread({}, CellBaseProps)
    },
    /*!***********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/workspaces/ui.scheduler.timeline.js ***!
      \***********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../../core/renderer */ 2));
        var _common = __webpack_require__( /*! ../../../core/utils/common */ 4);
        var _extend = __webpack_require__( /*! ../../../core/utils/extend */ 0);
        var _position = __webpack_require__( /*! ../../../core/utils/position */ 22);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../../core/component_registrator */ 9));
        var _uiSchedulerWork_space = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.work_space.indicator */ 305));
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../../core/utils/date */ 19));
        var _uiScheduler = _interopRequireDefault(__webpack_require__( /*! ../ui.scheduler.table_creator */ 300));
        var _uiSchedulerCurrent_time_shader = _interopRequireDefault(__webpack_require__( /*! ../shaders/ui.scheduler.current_time_shader.horizontal */ 841));
        var _utils = _interopRequireDefault(__webpack_require__( /*! ../utils.timeZone */ 86));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var tableCreator = _uiScheduler.default.tableCreator;
        var TIMELINE_CLASS = "dx-scheduler-timeline";
        var GROUP_TABLE_CLASS = "dx-scheduler-group-table";
        var HORIZONTAL_GROUPED_WORKSPACE_CLASS = "dx-scheduler-work-space-horizontal-grouped";
        var HEADER_PANEL_CELL_CLASS = "dx-scheduler-header-panel-cell";
        var HEADER_PANEL_WEEK_CELL_CLASS = "dx-scheduler-header-panel-week-cell";
        var HEADER_ROW_CLASS = "dx-scheduler-header-row";
        var HORIZONTAL = "horizontal";
        var DATE_TABLE_CELL_BORDER = 1;
        var DATE_TABLE_HEADER_MARGIN = 10;
        var toMs = _date.default.dateToMilliseconds;
        var SchedulerTimeline = function(_SchedulerWorkSpace) {
            _inheritsLoose(SchedulerTimeline, _SchedulerWorkSpace);

            function SchedulerTimeline() {
                return _SchedulerWorkSpace.apply(this, arguments) || this
            }
            var _proto = SchedulerTimeline.prototype;
            _proto._init = function() {
                _SchedulerWorkSpace.prototype._init.call(this);
                this.$element().addClass(TIMELINE_CLASS);
                this._$sidebarTable = (0, _renderer.default)("<div>").addClass(GROUP_TABLE_CLASS)
            };
            _proto._getCellFromNextRow = function(direction, isMultiSelection) {
                if (!isMultiSelection) {
                    return _SchedulerWorkSpace.prototype._getCellFromNextRow.call(this, direction, isMultiSelection)
                }
                return this._$focusedCell
            };
            _proto._getDefaultGroupStrategy = function() {
                return "vertical"
            };
            _proto._toggleGroupingDirectionClass = function() {
                this.$element().toggleClass(HORIZONTAL_GROUPED_WORKSPACE_CLASS, this._isHorizontalGroupedWorkSpace())
            };
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_SchedulerWorkSpace.prototype._getDefaultOptions.call(this), {
                    groupOrientation: "vertical"
                })
            };
            _proto._getRowCount = function() {
                return 1
            };
            _proto._getCellCount = function() {
                return this._getCellCountInDay() * this.option("intervalCount")
            };
            _proto.getGroupTableWidth = function() {
                return this._$sidebarTable ? this._$sidebarTable.outerWidth() : 0
            };
            _proto._getTotalRowCount = function(groupCount) {
                if (this._isHorizontalGroupedWorkSpace()) {
                    return this._getRowCount()
                } else {
                    groupCount = groupCount || 1;
                    return this._getRowCount() * groupCount
                }
            };
            _proto._getDateForHeaderText = function(index) {
                var newFirstViewDate = _utils.default.getDateWithoutTimezoneChange(this._firstViewDate);
                return this._getDateByIndexCore(newFirstViewDate, index)
            };
            _proto._getDateByIndexCore = function(date, index) {
                var result = new Date(date);
                var dayIndex = Math.floor(index / this._getCellCountInDay());
                result.setTime(date.getTime() + this._calculateCellIndex(0, index) * this._getInterval() + dayIndex * this._getHiddenInterval());
                return result
            };
            _proto._getDateByIndex = function(index) {
                var newFirstViewDate = _utils.default.getDateWithoutTimezoneChange(this._firstViewDate);
                var result = this._getDateByIndexCore(newFirstViewDate, index);
                if (_utils.default.isTimezoneChangeInDate(this._firstViewDate)) {
                    result.setDate(result.getDate() - 1)
                }
                return result
            };
            _proto._getFormat = function() {
                return "shorttime"
            };
            _proto._needApplyLastGroupCellClass = function() {
                return true
            };
            _proto._calculateHiddenInterval = function(rowIndex, cellIndex) {
                var dayIndex = Math.floor(cellIndex / this._getCellCountInDay());
                return dayIndex * this._getHiddenInterval()
            };
            _proto._getMillisecondsOffset = function(rowIndex, cellIndex) {
                cellIndex = this._calculateCellIndex(rowIndex, cellIndex);
                return this._getInterval() * cellIndex + this._calculateHiddenInterval(rowIndex, cellIndex)
            };
            _proto._createWorkSpaceElements = function() {
                this._createWorkSpaceScrollableElements()
            };
            _proto._getWorkSpaceHeight = function() {
                if (this.option("crossScrollingEnabled")) {
                    return (0, _position.getBoundingRect)(this._$dateTable.get(0)).height
                }
                return (0, _position.getBoundingRect)(this.$element().get(0)).height
            };
            _proto._dateTableScrollableConfig = function() {
                var config = _SchedulerWorkSpace.prototype._dateTableScrollableConfig.call(this);
                var timelineConfig = {
                    direction: HORIZONTAL
                };
                return this.option("crossScrollingEnabled") ? config : (0, _extend.extend)(config, timelineConfig)
            };
            _proto._needCreateCrossScrolling = function() {
                return true
            };
            _proto._headerScrollableConfig = function() {
                var config = _SchedulerWorkSpace.prototype._headerScrollableConfig.call(this);
                return (0, _extend.extend)(config, {
                    scrollByContent: true
                })
            };
            _proto._renderTimePanel = function() {
                return (0, _common.noop)()
            };
            _proto._renderAllDayPanel = function() {
                return (0, _common.noop)()
            };
            _proto._getTableAllDay = function() {
                return false
            };
            _proto._getDateHeaderTemplate = function() {
                return this.option("timeCellTemplate")
            };
            _proto._toggleAllDayVisibility = function() {
                return (0, _common.noop)()
            };
            _proto._changeAllDayVisibility = function() {
                return (0, _common.noop)()
            };
            _proto.supportAllDayRow = function() {
                return false
            };
            _proto._getGroupHeaderContainer = function() {
                if (this._isHorizontalGroupedWorkSpace()) {
                    return this._$thead
                }
                return this._$sidebarTable
            };
            _proto._insertAllDayRowsIntoDateTable = function() {
                return false
            };
            _proto._createAllDayPanelElements = function() {
                return (0, _common.noop)()
            };
            _proto._renderDateHeader = function() {
                var $headerRow = _SchedulerWorkSpace.prototype._renderDateHeader.call(this);
                if (this._needRenderWeekHeader()) {
                    var firstViewDate = new Date(this._firstViewDate);
                    var $cells = [];
                    var colspan = this._getCellCountInDay();
                    var cellTemplate = this.option("dateCellTemplate");
                    for (var i = 0; i < this._getWeekDuration() * this.option("intervalCount"); i++) {
                        var $th = (0, _renderer.default)("<th>");
                        var text = this._formatWeekdayAndDay(firstViewDate);
                        if (cellTemplate) {
                            var templateOptions = {
                                model: {
                                    text: text,
                                    date: new Date(firstViewDate)
                                },
                                container: $th,
                                index: i
                            };
                            cellTemplate.render(templateOptions)
                        } else {
                            $th.text(text)
                        }
                        $th.addClass(HEADER_PANEL_CELL_CLASS).addClass(HEADER_PANEL_WEEK_CELL_CLASS).attr("colSpan", colspan);
                        $cells.push($th);
                        this._incrementDate(firstViewDate)
                    }
                    var $row = (0, _renderer.default)("<tr>").addClass(HEADER_ROW_CLASS).append($cells);
                    $headerRow.before($row)
                }
            };
            _proto._needRenderWeekHeader = function() {
                return false
            };
            _proto._incrementDate = function(date) {
                date.setDate(date.getDate() + 1)
            };
            _proto._getWeekDuration = function() {
                return 1
            };
            _proto._renderView = function() {
                this._setFirstViewDate();
                var groupCellTemplates = this._renderGroupHeader();
                this._renderDateHeader();
                this._renderAllDayPanel();
                this._renderTimePanel();
                this._renderDateTable();
                this._shader = new _uiSchedulerCurrent_time_shader.default(this);
                this._updateGroupTableHeight();
                this._$sidebarTable.appendTo(this._sidebarScrollable.$content());
                this._applyCellTemplates(groupCellTemplates)
            };
            _proto._setHorizontalGroupHeaderCellsHeight = function() {
                return (0, _common.noop)()
            };
            _proto.getIndicationCellCount = function() {
                var timeDiff = this._getTimeDiff();
                return this._calculateDurationInCells(timeDiff)
            };
            _proto._getTimeDiff = function() {
                var today = this._getToday();
                var date = this._getIndicationFirstViewDate();
                return today.getTime() - date.getTime()
            };
            _proto._calculateDurationInCells = function(timeDiff) {
                var today = this._getToday();
                var differenceInDays = Math.floor(timeDiff / toMs("day"));
                var duration = (timeDiff - differenceInDays * toMs("day") - this.option("startDayHour") * toMs("hour")) / this.getCellDuration();
                if (today.getHours() > this.option("endDayHour")) {
                    duration = this._getCellCountInDay()
                }
                if (duration < 0) {
                    duration = 0
                }
                return differenceInDays * this._getCellCountInDay() + duration
            };
            _proto.getIndicationWidth = function() {
                if (this.isGroupedByDate()) {
                    var cellCount = this.getIndicationCellCount();
                    var integerPart = Math.floor(cellCount);
                    var fractionPart = cellCount - integerPart;
                    return this.getCellWidth() * (integerPart * this._getGroupCount() + fractionPart)
                } else {
                    return this.getIndicationCellCount() * this.getCellWidth()
                }
            };
            _proto._renderIndicator = function(height, rtlOffset, $container, groupCount) {
                var $indicator;
                var width = this.getIndicationWidth();
                if ("vertical" === this.option("groupOrientation")) {
                    $indicator = this._createIndicator($container);
                    $indicator.height((0, _position.getBoundingRect)($container.get(0)).height);
                    $indicator.css("left", rtlOffset ? rtlOffset - width : width)
                } else {
                    for (var i = 0; i < groupCount; i++) {
                        var offset = this.isGroupedByDate() ? i * this.getCellWidth() : this._getCellCount() * this.getCellWidth() * i;
                        $indicator = this._createIndicator($container);
                        $indicator.height((0, _position.getBoundingRect)($container.get(0)).height);
                        $indicator.css("left", rtlOffset ? rtlOffset - width - offset : width + offset)
                    }
                }
            };
            _proto._isVerticalShader = function() {
                return false
            };
            _proto._isCurrentTimeHeaderCell = function(headerIndex) {
                var result = false;
                if (this.isIndicationOnView()) {
                    var date = this._getDateByIndex(headerIndex);
                    var now = this._getToday();
                    date = new Date(date);
                    if (_date.default.sameDate(now, date)) {
                        var startCellDate = new Date(date);
                        var endCellDate = new Date(date);
                        endCellDate = endCellDate.setMilliseconds(date.getMilliseconds() + this.getCellDuration());
                        result = _date.default.dateInRange(now, startCellDate, endCellDate)
                    }
                }
                return result
            };
            _proto._cleanView = function() {
                _SchedulerWorkSpace.prototype._cleanView.call(this);
                this._$sidebarTable.empty()
            };
            _proto._visibilityChanged = function(visible) {
                _SchedulerWorkSpace.prototype._visibilityChanged.call(this, visible)
            };
            _proto._setTableSizes = function() {
                var cellHeight = this.getCellHeight();
                var minHeight = this._getWorkSpaceMinHeight();
                var $groupCells = this._$sidebarTable.find("tr");
                var height = cellHeight * $groupCells.length;
                if (height < minHeight) {
                    height = minHeight
                }
                this._$sidebarTable.height(height);
                this._$dateTable.height(height);
                _SchedulerWorkSpace.prototype._setTableSizes.call(this)
            };
            _proto._getWorkSpaceMinHeight = function() {
                var minHeight = this._getWorkSpaceHeight();
                var workspaceContainerHeight = this.$element().outerHeight(true) - this.getHeaderPanelHeight() - 2 * DATE_TABLE_CELL_BORDER - DATE_TABLE_HEADER_MARGIN;
                if (minHeight < workspaceContainerHeight) {
                    minHeight = workspaceContainerHeight
                }
                return minHeight
            };
            _proto._makeGroupRows = function(groups, groupByDate) {
                var tableCreatorStrategy = "vertical" === this.option("groupOrientation") ? tableCreator.VERTICAL : tableCreator.HORIZONTAL;
                return tableCreator.makeGroupedTable(tableCreatorStrategy, groups, {
                    groupRowClass: this._getGroupRowClass(),
                    groupHeaderRowClass: this._getGroupRowClass(),
                    groupHeaderClass: this._getGroupHeaderClass.bind(this),
                    groupHeaderContentClass: this._getGroupHeaderContentClass()
                }, this._getCellCount() || 1, this.option("resourceCellTemplate"), this._getTotalRowCount(this._getGroupCount()), groupByDate)
            };
            _proto._ensureGroupHeaderCellsHeight = function(cellHeight) {
                var minCellHeight = this._calculateMinCellHeight();
                if (cellHeight < minCellHeight) {
                    return minCellHeight
                }
                return cellHeight
            };
            _proto._calculateMinCellHeight = function() {
                var dateTable = this._getDateTable();
                var dateTableRowSelector = "." + this._getDateTableRowClass();
                return (0, _position.getBoundingRect)(dateTable).height / dateTable.find(dateTableRowSelector).length - 2 * DATE_TABLE_CELL_BORDER
            };
            _proto._getCellCoordinatesByIndex = function(index) {
                return {
                    cellIndex: index % this._getCellCount(),
                    rowIndex: 0
                }
            };
            _proto._getCellByCoordinates = function(cellCoordinates, groupIndex) {
                var indexes = this._groupedStrategy.prepareCellIndexes(cellCoordinates, groupIndex);
                return this._$dateTable.find("tr").eq(indexes.rowIndex).find("td").eq(indexes.cellIndex)
            };
            _proto._getWorkSpaceWidth = function() {
                return this._$dateTable.outerWidth(true)
            };
            _proto._getIndicationFirstViewDate = function() {
                return _date.default.trimTime(new Date(this._firstViewDate))
            };
            _proto._getIntervalBetween = function(currentDate, allDay) {
                var startDayHour = this.option("startDayHour");
                var endDayHour = this.option("endDayHour");
                var firstViewDate = this.getStartViewDate();
                var firstViewDateTime = firstViewDate.getTime();
                var hiddenInterval = (24 - endDayHour + startDayHour) * toMs("hour");
                var timeZoneOffset = _date.default.getTimezonesDifference(firstViewDate, currentDate);
                var apptStart = currentDate.getTime();
                var fullInterval = apptStart - firstViewDateTime - timeZoneOffset;
                var fullDays = Math.floor(fullInterval / toMs("day"));
                var tailDuration = fullInterval - fullDays * toMs("day");
                var tailDelta = 0;
                var cellCount = this._getCellCountInDay() * (fullDays - this._getWeekendsCount(fullDays));
                var gapBeforeAppt = apptStart - _date.default.trimTime(new Date(currentDate)).getTime();
                var result = cellCount * this.option("hoursInterval") * toMs("hour");
                if (!allDay) {
                    if (currentDate.getHours() < startDayHour) {
                        tailDelta = tailDuration - hiddenInterval + gapBeforeAppt
                    } else {
                        if (currentDate.getHours() >= startDayHour && currentDate.getHours() < endDayHour) {
                            tailDelta = tailDuration
                        } else {
                            if (currentDate.getHours() >= startDayHour && currentDate.getHours() >= endDayHour) {
                                tailDelta = tailDuration - (gapBeforeAppt - endDayHour * toMs("hour"))
                            } else {
                                if (!fullDays) {
                                    result = fullInterval
                                }
                            }
                        }
                    }
                    result += tailDelta
                }
                return result
            };
            _proto._getWeekendsCount = function() {
                return 0
            };
            _proto.getAllDayContainer = function() {
                return null
            };
            _proto.getTimePanelWidth = function() {
                return 0
            };
            _proto.getPositionShift = function(timeShift) {
                var positionShift = _SchedulerWorkSpace.prototype.getPositionShift.call(this, timeShift);
                var left = this.getCellWidth() * timeShift;
                if (this.option("rtlEnabled")) {
                    left *= -1
                }
                left += positionShift.left;
                return {
                    top: 0,
                    left: left,
                    cellPosition: left
                }
            };
            _proto.getVisibleBounds = function() {
                var isRtl = this.option("rtlEnabled");
                var result = {};
                var $scrollable = this.getScrollable().$element();
                var cellWidth = this.getCellWidth();
                var scrollableOffset = isRtl ? this.getScrollableOuterWidth() - this.getScrollableScrollLeft() : this.getScrollableScrollLeft();
                var scrolledCellCount = scrollableOffset / cellWidth;
                var visibleCellCount = $scrollable.width() / cellWidth;
                var totalCellCount = isRtl ? scrolledCellCount - visibleCellCount : scrolledCellCount + visibleCellCount;
                var leftDate = this._getDateByIndex(scrolledCellCount);
                var rightDate = this._getDateByIndex(totalCellCount);
                if (isRtl) {
                    leftDate = this._getDateByIndex(totalCellCount);
                    rightDate = this._getDateByIndex(scrolledCellCount)
                }
                result.left = {
                    hours: leftDate.getHours(),
                    minutes: leftDate.getMinutes() >= 30 ? 30 : 0,
                    date: _date.default.trimTime(leftDate)
                };
                result.right = {
                    hours: rightDate.getHours(),
                    minutes: rightDate.getMinutes() >= 30 ? 30 : 0,
                    date: _date.default.trimTime(rightDate)
                };
                return result
            };
            _proto.getIntervalDuration = function(allDay) {
                return this.getCellDuration()
            };
            _proto._supportCompactDropDownAppointments = function() {
                return false
            };
            _proto.getCellMinWidth = function() {
                return 0
            };
            _proto.getWorkSpaceLeftOffset = function() {
                return 0
            };
            _proto.scrollToTime = function(hours, minutes, date) {
                var coordinates = this._getScrollCoordinates(hours, minutes, date);
                var scrollable = this.getScrollable();
                var offset = this.option("rtlEnabled") ? (0, _position.getBoundingRect)(this.getScrollableContainer().get(0)).width : 0;
                if (this.option("templatesRenderAsynchronously")) {
                    setTimeout(function() {
                        scrollable.scrollBy({
                            left: coordinates.left - scrollable.scrollLeft() - offset,
                            top: 0
                        })
                    })
                } else {
                    scrollable.scrollBy({
                        left: coordinates.left - scrollable.scrollLeft() - offset,
                        top: 0
                    })
                }
            };
            _proto._getRowCountWithAllDayRows = function() {
                return this._getRowCount()
            };
            return SchedulerTimeline
        }(_uiSchedulerWork_space.default);
        (0, _component_registrator.default)("dxSchedulerTimeline", SchedulerTimeline);
        var _default = SchedulerTimeline;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/workspaces/ui.scheduler.work_space.indicator.js ***!
      \***********************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../../core/renderer */ 2));
        var _uiScheduler = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.work_space */ 441));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../../core/component_registrator */ 9));
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../../core/utils/date */ 19));
        var _extend = __webpack_require__( /*! ../../../core/utils/extend */ 0);
        var _position = __webpack_require__( /*! ../../../core/utils/position */ 22);
        var _window = __webpack_require__( /*! ../../../core/utils/window */ 7);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var toMs = _date.default.dateToMilliseconds;
        var SCHEDULER_DATE_TIME_INDICATOR_CLASS = "dx-scheduler-date-time-indicator";
        var TIME_PANEL_CURRENT_TIME_CELL_CLASS = "dx-scheduler-time-panel-current-time-cell";
        var HEADER_CURRENT_TIME_CELL_CLASS = "dx-scheduler-header-panel-current-time-cell";
        var SchedulerWorkSpaceIndicator = function(_SchedulerWorkSpace) {
            _inheritsLoose(SchedulerWorkSpaceIndicator, _SchedulerWorkSpace);

            function SchedulerWorkSpaceIndicator() {
                return _SchedulerWorkSpace.apply(this, arguments) || this
            }
            var _proto = SchedulerWorkSpaceIndicator.prototype;
            _proto._getTimeZoneCalculator = function() {
                return this.invoke("getTimeZoneCalculator")
            };
            _proto._getToday = function() {
                var todayDate = this.option("indicatorTime") || new Date;
                var timeZoneCalculator = this._getTimeZoneCalculator();
                return (null === timeZoneCalculator || void 0 === timeZoneCalculator ? void 0 : timeZoneCalculator.createDate(todayDate, {
                    path: "toGrid"
                })) || todayDate
            };
            _proto.isIndicationOnView = function() {
                if (this.option("showCurrentTimeIndicator")) {
                    var today = this._getToday();
                    var endViewDate = _date.default.trimTime(this.getEndViewDate());
                    return _date.default.dateInRange(today, this._firstViewDate, new Date(endViewDate.getTime() + toMs("day")))
                }
                return false
            };
            _proto.isIndicationAvailable = function() {
                if (!(0, _window.hasWindow)()) {
                    return false
                }
                var today = this._getToday();
                return today >= _date.default.trimTime(new Date(this.getStartViewDate()))
            };
            _proto.isIndicatorVisible = function() {
                var today = this._getToday();
                var endViewDate = new Date(this.getEndViewDate().getTime() + this._getEndViewDateTimeDiff() - 1);
                var firstViewDate = new Date(this.getStartViewDate());
                firstViewDate.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
                endViewDate.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
                return _date.default.dateInRange(today, firstViewDate, endViewDate)
            };
            _proto._renderDateTimeIndication = function() {
                if (this.isIndicationAvailable()) {
                    if (this.option("shadeUntilCurrentTime")) {
                        this._shader.render()
                    }
                    if (this.isIndicationOnView() && this.isIndicatorVisible()) {
                        var groupCount = this._getGroupCount() || 1;
                        var $container = this._dateTableScrollable.$content();
                        var height = this.getIndicationHeight();
                        var rtlOffset = this._getRtlOffset(this.getCellWidth());
                        this._renderIndicator(height, rtlOffset, $container, groupCount)
                    }
                }
            };
            _proto._renderIndicator = function(height, rtlOffset, $container, groupCount) {
                var groupedByDate = this.isGroupedByDate();
                var repeatCount = groupedByDate ? 1 : groupCount;
                for (var i = 0; i < repeatCount; i++) {
                    var $indicator = this._createIndicator($container);
                    $indicator.width(groupedByDate ? this.getCellWidth() * groupCount : this.getCellWidth());
                    this._groupedStrategy.shiftIndicator($indicator, height, rtlOffset, i)
                }
            };
            _proto._createIndicator = function($container) {
                var $indicator = (0, _renderer.default)("<div>").addClass(SCHEDULER_DATE_TIME_INDICATOR_CLASS);
                $container.append($indicator);
                return $indicator
            };
            _proto._getRtlOffset = function(width) {
                return this.option("rtlEnabled") ? (0, _position.getBoundingRect)(this._dateTableScrollable.$content().get(0)).width - this.getTimePanelWidth() - width : 0
            };
            _proto._setIndicationUpdateInterval = function() {
                if (!this.option("showCurrentTimeIndicator") || 0 === this.option("indicatorUpdateInterval")) {
                    return
                }
                this._clearIndicatorUpdateInterval();
                this._indicatorInterval = setInterval(function() {
                    this._refreshDateTimeIndication()
                }.bind(this), this.option("indicatorUpdateInterval"))
            };
            _proto._clearIndicatorUpdateInterval = function() {
                if (this._indicatorInterval) {
                    clearInterval(this._indicatorInterval);
                    delete this._indicatorInterval
                }
            };
            _proto._isVerticalShader = function() {
                return true
            };
            _proto.getIndicationWidth = function(groupIndex) {
                var maxWidth = this.getCellWidth() * this._getCellCount();
                var difference = this._getIndicatorDuration();
                if (difference > this._getCellCount()) {
                    difference = this._getCellCount()
                }
                var width = difference * this.getRoundedCellWidth(groupIndex, groupIndex * this._getCellCount(), difference);
                return maxWidth < width ? maxWidth : width
            };
            _proto.getIndicatorOffset = function(groupIndex) {
                var difference = this._getIndicatorDuration() - 1;
                var offset = difference * this.getRoundedCellWidth(groupIndex, groupIndex * this._getCellCount(), difference);
                return offset
            };
            _proto._getIndicatorDuration = function() {
                var today = this._getToday();
                var firstViewDate = new Date(this._firstViewDate);
                var timeDiff = today.getTime() - firstViewDate.getTime();
                if ("workWeek" === this.option("type")) {
                    timeDiff -= this._getWeekendsCount(Math.round(timeDiff / toMs("day"))) * toMs("day")
                }
                return Math.ceil((timeDiff + 1) / toMs("day"))
            };
            _proto.getIndicationHeight = function() {
                var today = this._getToday();
                var cellHeight = this.getCellHeight();
                var date = new Date(this._firstViewDate);
                if (this.isIndicationOnView()) {
                    date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate())
                }
                var duration = today.getTime() - date.getTime();
                var cellCount = duration / this.getCellDuration();
                return cellCount * cellHeight
            };
            _proto._dispose = function() {
                this._clearIndicatorUpdateInterval();
                _SchedulerWorkSpace.prototype._dispose.apply(this, arguments)
            };
            _proto._refreshDateTimeIndication = function() {
                this._cleanDateTimeIndicator();
                this._shader && this._shader.clean();
                this._renderDateTimeIndication()
            };
            _proto._isCurrentTime = function(date) {
                if (this.isIndicationOnView()) {
                    var today = this._getToday();
                    var result = false;
                    date = new Date(date);
                    date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
                    var startCellDate = new Date(date);
                    var endCellDate = new Date(date);
                    if (_date.default.sameDate(today, date)) {
                        startCellDate = startCellDate.setMilliseconds(date.getMilliseconds() - this.getCellDuration() + 1);
                        endCellDate = endCellDate.setMilliseconds(date.getMilliseconds() + this.getCellDuration());
                        result = _date.default.dateInRange(today, startCellDate, endCellDate)
                    }
                    return result
                }
            };
            _proto._isCurrentTimeHeaderCell = function(headerIndex) {
                if (this.isIndicationOnView()) {
                    var date = this._getDateByIndex(headerIndex);
                    return _date.default.sameDate(date, this._getToday())
                }
                return false
            };
            _proto._getTimeCellClass = function(i) {
                var startViewDate = this._getTimeCellDate(i);
                var cellClass = _SchedulerWorkSpace.prototype._getTimeCellClass.call(this, i);
                if (this._isCurrentTime(startViewDate)) {
                    return cellClass + " " + TIME_PANEL_CURRENT_TIME_CELL_CLASS
                }
                return cellClass
            };
            _proto._getHeaderPanelCellClass = function(i) {
                var cellClass = _SchedulerWorkSpace.prototype._getHeaderPanelCellClass.call(this, i);
                if (this._isCurrentTimeHeaderCell(i)) {
                    return cellClass + " " + HEADER_CURRENT_TIME_CELL_CLASS
                }
                return cellClass
            };
            _proto._cleanView = function() {
                _SchedulerWorkSpace.prototype._cleanView.call(this);
                this._cleanDateTimeIndicator()
            };
            _proto._dimensionChanged = function() {
                _SchedulerWorkSpace.prototype._dimensionChanged.call(this);
                this._refreshDateTimeIndication()
            };
            _proto._cleanDateTimeIndicator = function() {
                this.$element().find("." + SCHEDULER_DATE_TIME_INDICATOR_CLASS).remove()
            };
            _proto._cleanWorkSpace = function() {
                _SchedulerWorkSpace.prototype._cleanWorkSpace.call(this);
                this._renderDateTimeIndication();
                this._setIndicationUpdateInterval()
            };
            _proto._optionChanged = function(args) {
                switch (args.name) {
                    case "showCurrentTimeIndicator":
                    case "indicatorTime":
                        this._cleanWorkSpace();
                        break;
                    case "indicatorUpdateInterval":
                        this._setIndicationUpdateInterval();
                        break;
                    case "showAllDayPanel":
                        _SchedulerWorkSpace.prototype._optionChanged.call(this, args);
                        this._refreshDateTimeIndication();
                        break;
                    case "allDayExpanded":
                        _SchedulerWorkSpace.prototype._optionChanged.call(this, args);
                        this._refreshDateTimeIndication();
                        break;
                    case "crossScrollingEnabled":
                        _SchedulerWorkSpace.prototype._optionChanged.call(this, args);
                        this._refreshDateTimeIndication();
                        break;
                    case "shadeUntilCurrentTime":
                        this._refreshDateTimeIndication();
                        break;
                    default:
                        _SchedulerWorkSpace.prototype._optionChanged.call(this, args)
                }
            };
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_SchedulerWorkSpace.prototype._getDefaultOptions.call(this), {
                    showCurrentTimeIndicator: true,
                    indicatorTime: new Date,
                    indicatorUpdateInterval: 5 * toMs("minute"),
                    shadeUntilCurrentTime: true
                })
            };
            return SchedulerWorkSpaceIndicator
        }(_uiScheduler.default);
        (0, _component_registrator.default)("dxSchedulerWorkSpace", SchedulerWorkSpaceIndicator);
        var _default = SchedulerWorkSpaceIndicator;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/file_manager/ui.file_manager.dialog.js ***!
      \****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _popup = _interopRequireDefault(__webpack_require__( /*! ../popup */ 46));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var FILE_MANAGER_DIALOG_CONTENT = "dx-filemanager-dialog";
        var FILE_MANAGER_DIALOG_POPUP = "dx-filemanager-dialog-popup";
        var FileManagerDialogBase = function(_Widget) {
            _inheritsLoose(FileManagerDialogBase, _Widget);

            function FileManagerDialogBase() {
                return _Widget.apply(this, arguments) || this
            }
            var _proto = FileManagerDialogBase.prototype;
            _proto._initMarkup = function() {
                var _this = this;
                _Widget.prototype._initMarkup.call(this);
                this._createOnClosedAction();
                var options = this._getDialogOptions();
                var $popup = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_DIALOG_POPUP).appendTo(this.$element());
                if (options.popupCssClass) {
                    $popup.addClass(options.popupCssClass)
                }
                var popupOptions = {
                    showTitle: true,
                    title: options.title,
                    visible: false,
                    closeOnOutsideClick: true,
                    contentTemplate: this._createContentTemplate.bind(this),
                    toolbarItems: [{
                        widget: "dxButton",
                        toolbar: "bottom",
                        location: "after",
                        options: {
                            text: options.buttonText,
                            onClick: this._applyDialogChanges.bind(this)
                        }
                    }, {
                        widget: "dxButton",
                        toolbar: "bottom",
                        location: "after",
                        options: {
                            text: _message.default.format("dxFileManager-dialogButtonCancel"),
                            onClick: this._closeDialog.bind(this)
                        }
                    }],
                    onInitialized: function(_ref) {
                        var component = _ref.component;
                        component.registerKeyHandler("enter", _this._applyDialogChanges.bind(_this))
                    },
                    onHidden: this._onPopupHidden.bind(this),
                    onShown: this._onPopupShown.bind(this)
                };
                if ((0, _type.isDefined)(options.height)) {
                    popupOptions.height = options.height
                }
                if ((0, _type.isDefined)(options.maxHeight)) {
                    popupOptions.maxHeight = options.maxHeight
                }
                this._popup = this._createComponent($popup, _popup.default, popupOptions)
            };
            _proto.show = function() {
                this._dialogResult = null;
                this._popup.show()
            };
            _proto._getDialogOptions = function() {
                return {
                    title: "Title",
                    buttonText: "ButtonText",
                    contentCssClass: "",
                    popupCssClass: ""
                }
            };
            _proto._createContentTemplate = function(element) {
                this._$contentElement = (0, _renderer.default)("<div>").appendTo(element).addClass(FILE_MANAGER_DIALOG_CONTENT);
                var cssClass = this._getDialogOptions().contentCssClass;
                if (cssClass) {
                    this._$contentElement.addClass(cssClass)
                }
            };
            _proto._getDialogResult = function() {
                return null
            };
            _proto._applyDialogChanges = function() {
                var result = this._getDialogResult();
                if (result) {
                    this._dialogResult = result;
                    this._popup.hide()
                }
            };
            _proto._closeDialog = function() {
                this._popup.hide()
            };
            _proto._onPopupHidden = function() {
                this._onClosedAction({
                    dialogResult: this._dialogResult
                })
            };
            _proto._onPopupShown = function() {};
            _proto._createOnClosedAction = function() {
                this._onClosedAction = this._createActionByOption("onClosed")
            };
            _proto._setTitle = function(newTitle) {
                this._popup.option("title", newTitle)
            };
            _proto._setButtonText = function(newText) {
                this._popup.option("toolbarItems[0].options.text", newText)
            };
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_Widget.prototype._getDefaultOptions.call(this), {
                    onClosed: null
                })
            };
            _proto._optionChanged = function(args) {
                var name = args.name;
                switch (name) {
                    case "onClosed":
                        this._createOnPathChangedAction();
                        break;
                    default:
                        _Widget.prototype._optionChanged.call(this, args)
                }
            };
            return FileManagerDialogBase
        }(_ui.default);
        var _default = FileManagerDialogBase;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/diagram/diagram.bar.js ***!
      \************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _diagram = __webpack_require__( /*! ./diagram.importer */ 98);
        var DiagramBar = function() {
            function DiagramBar(owner) {
                var _getDiagram = (0, _diagram.getDiagram)(),
                    EventDispatcher = _getDiagram.EventDispatcher;
                this.onChanged = new EventDispatcher;
                this._owner = owner
            }
            var _proto = DiagramBar.prototype;
            _proto.raiseBarCommandExecuted = function(key, parameter) {
                this.onChanged.raise("notifyBarCommandExecuted", parseInt(key), parameter)
            };
            _proto.getCommandKeys = function() {
                throw "Not Implemented"
            };
            _proto.setItemValue = function(key, value) {};
            _proto.setItemEnabled = function(key, enabled) {};
            _proto.setItemVisible = function(key, enabled) {};
            _proto.setEnabled = function(enabled) {};
            _proto.setItemSubItems = function(key, items) {};
            _proto.isVisible = function() {
                return true
            };
            _proto._getKeys = function(items) {
                var _this = this;
                var keys = items.reduce(function(commands, item) {
                    if (void 0 !== item.command) {
                        commands.push(item.command)
                    }
                    if (item.items) {
                        commands = commands.concat(_this._getKeys(item.items))
                    }
                    return commands
                }, []);
                return keys
            };
            return DiagramBar
        }();
        var _default = DiagramBar;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/export.js ***!
      \************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.default = void 0;
        var Export = _interopRequireWildcard(__webpack_require__( /*! ./core/export */ 108));

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }
        var _default = Export;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/chart_components/base_chart.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.BaseChart = exports.overlapping = void 0;
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _base_widget = _interopRequireDefault(__webpack_require__( /*! ../core/base_widget */ 113));
        var _legend = __webpack_require__( /*! ../components/legend */ 224);
        var _data_validator = __webpack_require__( /*! ../components/data_validator */ 312);
        var _base_series = __webpack_require__( /*! ../series/base_series */ 314);
        var _chart_theme_manager = __webpack_require__( /*! ../components/chart_theme_manager */ 464);
        var _layout_manager = __webpack_require__( /*! ./layout_manager */ 465);
        var trackerModule = _interopRequireWildcard(__webpack_require__( /*! ./tracker */ 928));
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _export = __webpack_require__( /*! ../core/export */ 108);
        var _title = __webpack_require__( /*! ../core/title */ 121);
        var _data_source = __webpack_require__( /*! ../core/data_source */ 164);
        var _tooltip = __webpack_require__( /*! ../core/tooltip */ 123);
        var _loading_indicator = __webpack_require__( /*! ../core/loading_indicator */ 145);

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _isArray = Array.isArray;
        var REINIT_REFRESH_ACTION = "_reinit";
        var REINIT_DATA_SOURCE_REFRESH_ACTION = "_updateDataSource";
        var DATA_INIT_REFRESH_ACTION = "_dataInit";
        var FORCE_RENDER_REFRESH_ACTION = "_forceRender";
        var RESIZE_REFRESH_ACTION = "_resize";
        var ACTIONS_BY_PRIORITY = [REINIT_REFRESH_ACTION, REINIT_DATA_SOURCE_REFRESH_ACTION, DATA_INIT_REFRESH_ACTION, FORCE_RENDER_REFRESH_ACTION, RESIZE_REFRESH_ACTION];
        var DEFAULT_OPACITY = .3;
        var REFRESH_SERIES_DATA_INIT_ACTION_OPTIONS = ["series", "commonSeriesSettings", "dataPrepareSettings", "seriesSelectionMode", "pointSelectionMode", "synchronizeMultiAxes", "resolveLabelsOverlapping"];
        var REFRESH_SERIES_FAMILIES_ACTION_OPTIONS = ["minBubbleSize", "maxBubbleSize", "barGroupPadding", "barGroupWidth", "negativesAsZeroes", "negativesAsZeros"];
        var FORCE_RENDER_REFRESH_ACTION_OPTIONS = ["adaptiveLayout", "crosshair", "resolveLabelOverlapping", "adjustOnZoom", "stickyHovering"];
        var FONT = "font";

        function checkHeightRollingStock(rollingStocks, stubCanvas) {
            var canvasSize = stubCanvas.end - stubCanvas.start;
            var size = 0;
            rollingStocks.forEach(function(rollingStock) {
                size += rollingStock.getBoundingRect().width
            });
            while (canvasSize < size) {
                size -= findAndKillSmallValue(rollingStocks)
            }
        }

        function findAndKillSmallValue(rollingStocks) {
            var smallestObject = rollingStocks.reduce(function(prev, rollingStock, index) {
                if (!rollingStock) {
                    return prev
                }
                var value = rollingStock.value();
                return value < prev.value ? {
                    value: value,
                    rollingStock: rollingStock,
                    index: index
                } : prev
            }, {
                rollingStock: void 0,
                value: 1 / 0,
                index: void 0
            });
            smallestObject.rollingStock.getLabels()[0].draw(false);
            var width = smallestObject.rollingStock.getBoundingRect().width;
            rollingStocks[smallestObject.index] = null;
            return width
        }

        function checkStackOverlap(rollingStocks) {
            var i;
            var j;
            var iLength;
            var jLength;
            var overlap = false;
            for (i = 0, iLength = rollingStocks.length - 1; i < iLength; i++) {
                for (j = i + 1, jLength = rollingStocks.length; j < jLength; j++) {
                    if (i !== j && checkStacksOverlapping(rollingStocks[i], rollingStocks[j], true)) {
                        overlap = true;
                        break
                    }
                }
                if (overlap) {
                    break
                }
            }
            return overlap
        }

        function resolveLabelOverlappingInOneDirection(points, canvas, isRotated, shiftFunction) {
            var customSorting = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : function() {
                return 0
            };
            var rollingStocks = [];
            var stubCanvas = {
                start: isRotated ? canvas.left : canvas.top,
                end: isRotated ? canvas.width - canvas.right : canvas.height - canvas.bottom
            };
            var hasStackedSeries = false;
            points.forEach(function(p) {
                if (!p) {
                    return
                }
                hasStackedSeries = hasStackedSeries || p.series.isStackedSeries() || p.series.isFullStackedSeries();
                p.getLabels().forEach(function(l) {
                    l.isVisible() && rollingStocks.push(new RollingStock(l, isRotated, shiftFunction))
                })
            });
            if (hasStackedSeries) {
                !isRotated && rollingStocks.reverse()
            } else {
                var rollingStocksTmp = rollingStocks.slice();
                rollingStocks.sort(function(a, b) {
                    return customSorting(a, b) || a.getInitialPosition() - b.getInitialPosition() || rollingStocksTmp.indexOf(a) - rollingStocksTmp.indexOf(b)
                })
            }
            if (!checkStackOverlap(rollingStocks)) {
                return false
            }
            checkHeightRollingStock(rollingStocks, stubCanvas);
            prepareOverlapStacks(rollingStocks);
            rollingStocks.reverse();
            moveRollingStock(rollingStocks, stubCanvas);
            return true
        }

        function checkStacksOverlapping(firstRolling, secondRolling, inTwoSides) {
            if (!firstRolling || !secondRolling) {
                return
            }
            var firstRect = firstRolling.getBoundingRect();
            var secondRect = secondRolling.getBoundingRect();
            var oppositeOverlapping = inTwoSides ? firstRect.oppositeStart <= secondRect.oppositeStart && firstRect.oppositeEnd > secondRect.oppositeStart || secondRect.oppositeStart <= firstRect.oppositeStart && secondRect.oppositeEnd > firstRect.oppositeStart : true;
            return firstRect.end > secondRect.start && oppositeOverlapping
        }

        function prepareOverlapStacks(rollingStocks) {
            var i;
            var currentRollingStock;
            var root;
            for (i = 0; i < rollingStocks.length - 1; i++) {
                currentRollingStock = root || rollingStocks[i];
                if (checkStacksOverlapping(currentRollingStock, rollingStocks[i + 1])) {
                    currentRollingStock.toChain(rollingStocks[i + 1]);
                    rollingStocks[i + 1] = null;
                    root = currentRollingStock
                } else {
                    root = rollingStocks[i + 1] || currentRollingStock
                }
            }
        }

        function moveRollingStock(rollingStocks, canvas) {
            var i;
            var j;
            var currentRollingStock;
            var nextRollingStock;
            var currentBBox;
            var nextBBox;
            for (i = 0; i < rollingStocks.length; i++) {
                currentRollingStock = rollingStocks[i];
                if (rollingStocksIsOut(currentRollingStock, canvas)) {
                    currentBBox = currentRollingStock.getBoundingRect();
                    for (j = i + 1; j < rollingStocks.length; j++) {
                        nextRollingStock = rollingStocks[j];
                        if (!nextRollingStock) {
                            continue
                        }
                        nextBBox = nextRollingStock.getBoundingRect();
                        if (nextBBox.end > currentBBox.start - (currentBBox.end - canvas.end)) {
                            nextRollingStock.toChain(currentRollingStock);
                            rollingStocks[i] = currentRollingStock = null;
                            break
                        }
                    }
                }
                currentRollingStock && currentRollingStock.setRollingStockInCanvas(canvas)
            }
        }

        function rollingStocksIsOut(rollingStock, canvas) {
            return rollingStock && rollingStock.getBoundingRect().end > canvas.end
        }

        function RollingStock(label, isRotated, shiftFunction) {
            var bBox = label.getBoundingRect();
            var x = bBox.x;
            var y = bBox.y;
            var endX = bBox.x + bBox.width;
            var endY = bBox.y + bBox.height;
            this.labels = [label];
            this.shiftFunction = shiftFunction;
            this._bBox = {
                start: isRotated ? x : y,
                width: isRotated ? bBox.width : bBox.height,
                end: isRotated ? endX : endY,
                oppositeStart: isRotated ? y : x,
                oppositeEnd: isRotated ? endY : endX
            };
            this._initialPosition = isRotated ? bBox.x : bBox.y;
            return this
        }
        RollingStock.prototype = {
            toChain: function(nextRollingStock) {
                var nextRollingStockBBox = nextRollingStock.getBoundingRect();
                nextRollingStock.shift(nextRollingStockBBox.start - this._bBox.end);
                this._changeBoxWidth(nextRollingStockBBox.width);
                this.labels = this.labels.concat(nextRollingStock.labels)
            },
            getBoundingRect: function() {
                return this._bBox
            },
            shift: function(shiftLength) {
                var shiftFunction = this.shiftFunction;
                (0, _iterator.each)(this.labels, function(index, label) {
                    var bBox = label.getBoundingRect();
                    var coords = shiftFunction(bBox, shiftLength);
                    if (!label.hideInsideLabel(coords)) {
                        label.shift(coords.x, coords.y)
                    }
                });
                this._bBox.end -= shiftLength;
                this._bBox.start -= shiftLength
            },
            setRollingStockInCanvas: function(canvas) {
                if (this._bBox.end > canvas.end) {
                    this.shift(this._bBox.end - canvas.end)
                }
            },
            getLabels: function() {
                return this.labels
            },
            value: function() {
                return this.labels[0].getData().value
            },
            getInitialPosition: function() {
                return this._initialPosition
            },
            _changeBoxWidth: function(width) {
                this._bBox.end += width;
                this._bBox.width += width
            }
        };

        function getLegendFields(name) {
            return {
                nameField: name + "Name",
                colorField: name + "Color",
                indexField: name + "Index"
            }
        }

        function getLegendSettings(legendDataField) {
            var formatObjectFields = getLegendFields(legendDataField);
            return {
                getFormatObject: function(data) {
                    var res = {};
                    res[formatObjectFields.indexField] = data.id;
                    res[formatObjectFields.colorField] = data.states.normal.fill;
                    res[formatObjectFields.nameField] = data.text;
                    return res
                },
                textField: formatObjectFields.nameField
            }
        }

        function checkOverlapping(firstRect, secondRect) {
            return (firstRect.x <= secondRect.x && secondRect.x <= firstRect.x + firstRect.width || firstRect.x >= secondRect.x && firstRect.x <= secondRect.x + secondRect.width) && (firstRect.y <= secondRect.y && secondRect.y <= firstRect.y + firstRect.height || firstRect.y >= secondRect.y && firstRect.y <= secondRect.y + secondRect.height)
        }
        var overlapping = {
            resolveLabelOverlappingInOneDirection: resolveLabelOverlappingInOneDirection
        };
        exports.overlapping = overlapping;
        var BaseChart = _base_widget.default.inherit({
            _eventsMap: {
                onSeriesClick: {
                    name: "seriesClick"
                },
                onPointClick: {
                    name: "pointClick"
                },
                onArgumentAxisClick: {
                    name: "argumentAxisClick"
                },
                onLegendClick: {
                    name: "legendClick"
                },
                onSeriesSelectionChanged: {
                    name: "seriesSelectionChanged"
                },
                onPointSelectionChanged: {
                    name: "pointSelectionChanged"
                },
                onSeriesHoverChanged: {
                    name: "seriesHoverChanged"
                },
                onPointHoverChanged: {
                    name: "pointHoverChanged"
                },
                onDone: {
                    name: "done"
                },
                onZoomStart: {
                    name: "zoomStart"
                },
                onZoomEnd: {
                    name: "zoomEnd"
                }
            },
            _fontFields: ["legend." + FONT, "legend.title." + FONT, "legend.title.subtitle." + FONT, "commonSeriesSettings.label." + FONT],
            _rootClassPrefix: "dxc",
            _rootClass: "dxc-chart",
            _initialChanges: ["INIT"],
            _themeDependentChanges: ["REFRESH_SERIES_REINIT"],
            _getThemeManagerOptions: function() {
                var themeOptions = this.callBase.apply(this, arguments);
                themeOptions.options = this.option();
                return themeOptions
            },
            _createThemeManager: function() {
                var chartOption = this.option();
                var themeManager = new _chart_theme_manager.ThemeManager(this._getThemeManagerOptions());
                themeManager.setTheme(chartOption.theme, chartOption.rtlEnabled);
                return themeManager
            },
            _initCore: function() {
                var that = this;
                that._canvasClipRect = that._renderer.clipRect();
                that._createHtmlStructure();
                that._createLegend();
                that._createTracker();
                that._needHandleRenderComplete = true;
                that.layoutManager = new _layout_manager.LayoutManager;
                that._createScrollBar();
                _events_engine.default.on(that._$element, "contextmenu", function(event) {
                    if ((0, _index.isTouchEvent)(event) || (0, _index.isPointerEvent)(event)) {
                        event.preventDefault()
                    }
                });
                _events_engine.default.on(that._$element, "MSHoldVisual", function(event) {
                    event.preventDefault()
                })
            },
            _getLayoutItems: _common.noop,
            _layoutManagerOptions: function() {
                return this._themeManager.getOptions("adaptiveLayout")
            },
            _reinit: function() {
                var that = this;
                (0, _utils.setCanvasValues)(that._canvas);
                that._reinitAxes();
                that._requestChange(["DATA_SOURCE", "DATA_INIT", "CORRECT_AXIS", "FULL_RENDER"])
            },
            _correctAxes: _common.noop,
            _createHtmlStructure: function() {
                var that = this;
                var renderer = that._renderer;
                var root = renderer.root;
                var createConstantLinesGroup = function() {
                    return renderer.g().attr({
                        "class": "dxc-constant-lines-group"
                    }).linkOn(root, "constant-lines")
                };
                that._constantLinesGroup = {
                    dispose: function() {
                        this.under.dispose();
                        this.above.dispose()
                    },
                    linkOff: function() {
                        this.under.linkOff();
                        this.above.linkOff()
                    },
                    clear: function() {
                        this.under.linkRemove().clear();
                        this.above.linkRemove().clear()
                    },
                    linkAppend: function() {
                        this.under.linkAppend();
                        this.above.linkAppend()
                    }
                };
                that._backgroundRect = renderer.rect().attr({
                    fill: "gray",
                    opacity: 1e-4
                }).append(root);
                that._panesBackgroundGroup = renderer.g().attr({
                    "class": "dxc-background"
                }).append(root);
                that._stripsGroup = renderer.g().attr({
                    "class": "dxc-strips-group"
                }).linkOn(root, "strips");
                that._gridGroup = renderer.g().attr({
                    "class": "dxc-grids-group"
                }).linkOn(root, "grids");
                that._panesBorderGroup = renderer.g().attr({
                    "class": "dxc-border"
                }).linkOn(root, "border");
                that._axesGroup = renderer.g().attr({
                    "class": "dxc-axes-group"
                }).linkOn(root, "axes");
                that._labelAxesGroup = renderer.g().attr({
                    "class": "dxc-strips-labels-group"
                }).linkOn(root, "strips-labels");
                that._constantLinesGroup.under = createConstantLinesGroup();
                that._seriesGroup = renderer.g().attr({
                    "class": "dxc-series-group"
                }).linkOn(root, "series");
                that._constantLinesGroup.above = createConstantLinesGroup();
                that._scaleBreaksGroup = renderer.g().attr({
                    "class": "dxc-scale-breaks"
                }).linkOn(root, "scale-breaks");
                that._labelsGroup = renderer.g().attr({
                    "class": "dxc-labels-group"
                }).linkOn(root, "labels");
                that._crosshairCursorGroup = renderer.g().attr({
                    "class": "dxc-crosshair-cursor"
                }).linkOn(root, "crosshair");
                that._legendGroup = renderer.g().attr({
                    "class": "dxc-legend",
                    "clip-path": that._getCanvasClipRectID()
                }).linkOn(root, "legend").linkAppend(root).enableLinks();
                that._scrollBarGroup = renderer.g().attr({
                    "class": "dxc-scroll-bar"
                }).linkOn(root, "scroll-bar")
            },
            _disposeObjectsInArray: function(propName, fieldNames) {
                (0, _iterator.each)(this[propName] || [], function(_, item) {
                    if (fieldNames && item) {
                        (0, _iterator.each)(fieldNames, function(_, field) {
                            item[field] && item[field].dispose()
                        })
                    } else {
                        item && item.dispose()
                    }
                });
                this[propName] = null
            },
            _disposeCore: function() {
                var that = this;
                var disposeObject = function(propName) {
                    if (that[propName]) {
                        that[propName].dispose();
                        that[propName] = null
                    }
                };
                var unlinkGroup = function(name) {
                    that[name].linkOff()
                };
                var disposeObjectsInArray = this._disposeObjectsInArray;
                that._renderer.stopAllAnimations();
                disposeObjectsInArray.call(that, "series");
                disposeObject("_tracker");
                disposeObject("_crosshair");
                that.layoutManager = that._userOptions = that._canvas = that._groupsData = null;
                unlinkGroup("_stripsGroup");
                unlinkGroup("_gridGroup");
                unlinkGroup("_axesGroup");
                unlinkGroup("_constantLinesGroup");
                unlinkGroup("_labelAxesGroup");
                unlinkGroup("_panesBorderGroup");
                unlinkGroup("_seriesGroup");
                unlinkGroup("_labelsGroup");
                unlinkGroup("_crosshairCursorGroup");
                unlinkGroup("_legendGroup");
                unlinkGroup("_scrollBarGroup");
                unlinkGroup("_scaleBreaksGroup");
                disposeObject("_canvasClipRect");
                disposeObject("_panesBackgroundGroup");
                disposeObject("_backgroundRect");
                disposeObject("_stripsGroup");
                disposeObject("_gridGroup");
                disposeObject("_axesGroup");
                disposeObject("_constantLinesGroup");
                disposeObject("_labelAxesGroup");
                disposeObject("_panesBorderGroup");
                disposeObject("_seriesGroup");
                disposeObject("_labelsGroup");
                disposeObject("_crosshairCursorGroup");
                disposeObject("_legendGroup");
                disposeObject("_scrollBarGroup");
                disposeObject("_scaleBreaksGroup")
            },
            _getAnimationOptions: function() {
                return this._themeManager.getOptions("animation")
            },
            _getDefaultSize: function() {
                return {
                    width: 400,
                    height: 400
                }
            },
            _getOption: function(name) {
                return this._themeManager.getOptions(name)
            },
            _applySize: function(rect) {
                this._rect = rect.slice();
                if (!this._changes.has("FULL_RENDER")) {
                    this._processRefreshData(RESIZE_REFRESH_ACTION)
                }
            },
            _resize: function() {
                this._doRender(this.__renderOptions || {
                    animate: false,
                    isResize: true
                })
            },
            _trackerType: "ChartTracker",
            _createTracker: function() {
                var that = this;
                that._tracker = new trackerModule[that._trackerType]({
                    seriesGroup: that._seriesGroup,
                    renderer: that._renderer,
                    tooltip: that._tooltip,
                    legend: that._legend,
                    eventTrigger: that._eventTrigger
                })
            },
            _getTrackerSettings: function() {
                return (0, _extend.extend)({
                    chart: this
                }, this._getSelectionModes())
            },
            _getSelectionModes: function() {
                var themeManager = this._themeManager;
                return {
                    seriesSelectionMode: themeManager.getOptions("seriesSelectionMode"),
                    pointSelectionMode: themeManager.getOptions("pointSelectionMode")
                }
            },
            _updateTracker: function(trackerCanvases) {
                var that = this;
                that._tracker.update(that._getTrackerSettings());
                that._tracker.setCanvases({
                    left: 0,
                    right: that._canvas.width,
                    top: 0,
                    bottom: that._canvas.height
                }, trackerCanvases)
            },
            _createCanvasFromRect: function(rect) {
                var currentCanvas = this._canvas;
                return (0, _utils.setCanvasValues)({
                    left: rect[0],
                    top: rect[1],
                    right: currentCanvas.width - rect[2],
                    bottom: currentCanvas.height - rect[3],
                    width: currentCanvas.width,
                    height: currentCanvas.height
                })
            },
            _doRender: function(_options) {
                var that = this;
                if (0 === that._canvas.width && 0 === that._canvas.height) {
                    return
                }
                that._resetIsReady();
                var drawOptions = that._prepareDrawOptions(_options);
                var recreateCanvas = drawOptions.recreateCanvas;
                that._preserveOriginalCanvas();
                if (recreateCanvas) {
                    that.__currentCanvas = that._canvas
                } else {
                    that._canvas = that.__currentCanvas
                }
                recreateCanvas && that._updateCanvasClipRect(that._canvas);
                this._canvas = this._createCanvasFromRect(this._rect);
                that._renderer.stopAllAnimations(true);
                that._cleanGroups();
                var startTime = new Date;
                that._renderElements(drawOptions);
                that._lastRenderingTime = new Date - startTime
            },
            _preserveOriginalCanvas: function() {
                this.__originalCanvas = this._canvas;
                this._canvas = (0, _extend.extend)({}, this._canvas)
            },
            _layoutAxes: _common.noop,
            _renderElements: function(drawOptions) {
                var that = this;
                var preparedOptions = that._prepareToRender(drawOptions);
                var isRotated = that._isRotated();
                var isLegendInside = that._isLegendInside();
                var trackerCanvases = [];
                (0, _extend.extend)({}, that._canvas);
                var argBusinessRange;
                var zoomMinArg;
                var zoomMaxArg;
                that._renderer.lock();
                if (drawOptions.drawLegend && that._legend) {
                    that._legendGroup.linkAppend()
                }
                that.layoutManager.setOptions(that._layoutManagerOptions());
                var layoutTargets = that._getLayoutTargets();
                this._layoutAxes(function(needSpace) {
                    var axisDrawOptions = needSpace ? (0, _extend.extend)({}, drawOptions, {
                        animate: false,
                        recreateCanvas: true
                    }) : drawOptions;
                    var canvas = that._renderAxes(axisDrawOptions, preparedOptions);
                    that._shrinkAxes(needSpace, canvas)
                });
                that._applyClipRects(preparedOptions);
                that._appendSeriesGroups();
                that._createCrosshairCursor();
                layoutTargets.forEach(function(_ref) {
                    var canvas = _ref.canvas;
                    trackerCanvases.push({
                        left: canvas.left,
                        right: canvas.width - canvas.right,
                        top: canvas.top,
                        bottom: canvas.height - canvas.bottom
                    })
                });
                if (that._scrollBar) {
                    argBusinessRange = that._argumentAxes[0].getTranslator().getBusinessRange();
                    if ("discrete" === argBusinessRange.axisType && argBusinessRange.categories && argBusinessRange.categories.length <= 1 || "discrete" !== argBusinessRange.axisType && argBusinessRange.min === argBusinessRange.max) {
                        zoomMinArg = zoomMaxArg = void 0
                    } else {
                        zoomMinArg = argBusinessRange.minVisible;
                        zoomMaxArg = argBusinessRange.maxVisible
                    }
                    that._scrollBar.init(argBusinessRange, !that._argumentAxes[0].getOptions().valueMarginsEnabled).setPosition(zoomMinArg, zoomMaxArg)
                }
                that._updateTracker(trackerCanvases);
                that._updateLegendPosition(drawOptions, isLegendInside);
                that._applyPointMarkersAutoHiding();
                that._renderSeries(drawOptions, isRotated, isLegendInside);
                that._renderer.unlock()
            },
            _updateLegendPosition: _common.noop,
            _createCrosshairCursor: _common.noop,
            _appendSeriesGroups: function() {
                this._seriesGroup.linkAppend();
                this._labelsGroup.linkAppend();
                this._appendAdditionalSeriesGroups()
            },
            _renderSeries: function(drawOptions, isRotated, isLegendInside) {
                this._calculateSeriesLayout(drawOptions, isRotated);
                this._renderSeriesElements(drawOptions, isLegendInside)
            },
            _calculateSeriesLayout: function(drawOptions, isRotated) {
                drawOptions.hideLayoutLabels = this.layoutManager.needMoreSpaceForPanesCanvas(this._getLayoutTargets(), isRotated) && !this._themeManager.getOptions("adaptiveLayout").keepLabels;
                this._updateSeriesDimensions(drawOptions)
            },
            _getArgFilter: function() {
                return function() {
                    return true
                }
            },
            _getValFilter: function(series) {
                return function() {
                    return true
                }
            },
            _getPointsToAnimation: function(series) {
                var _this = this;
                var argViewPortFilter = this._getArgFilter();
                return series.map(function(s) {
                    var valViewPortFilter = _this._getValFilter(s);
                    return s.getPoints().filter(function(p) {
                        return p.getOptions().visible && argViewPortFilter(p.argument) && (valViewPortFilter(p.getMinValue(true)) || valViewPortFilter(p.getMaxValue(true)))
                    }).length
                })
            },
            _renderSeriesElements: function(drawOptions, isLegendInside) {
                var that = this;
                var i;
                var series = that.series;
                var singleSeries;
                var seriesLength = series.length;
                var resolveLabelOverlapping = that._themeManager.getOptions("resolveLabelOverlapping");
                var pointsToAnimation = that._getPointsToAnimation(series);
                for (i = 0; i < seriesLength; i++) {
                    singleSeries = series[i];
                    that._applyExtraSettings(singleSeries, drawOptions);
                    singleSeries.draw(drawOptions.animate && pointsToAnimation[i] <= drawOptions.animationPointsLimit && that._renderer.animationEnabled(), drawOptions.hideLayoutLabels, that._getLegendCallBack(singleSeries))
                }
                if ("none" === resolveLabelOverlapping) {
                    that._adjustSeriesLabels(false)
                } else {
                    that._locateLabels(resolveLabelOverlapping)
                }
                that._renderTrackers(isLegendInside);
                that._tracker.repairTooltip();
                that._renderExtraElements();
                that._clearCanvas();
                that._seriesElementsDrawn = true
            },
            _changesApplied: function() {
                var that = this;
                if (that._seriesElementsDrawn) {
                    that._seriesElementsDrawn = false;
                    that._drawn();
                    that._renderCompleteHandler()
                }
            },
            _locateLabels: function(resolveLabelOverlapping) {
                this._resolveLabelOverlapping(resolveLabelOverlapping)
            },
            _renderExtraElements: function() {},
            _clearCanvas: function() {
                this._canvas = this.__originalCanvas
            },
            _resolveLabelOverlapping: function(resolveLabelOverlapping) {
                var func;
                switch (resolveLabelOverlapping) {
                    case "stack":
                        func = this._resolveLabelOverlappingStack;
                        break;
                    case "hide":
                        func = this._resolveLabelOverlappingHide;
                        break;
                    case "shift":
                        func = this._resolveLabelOverlappingShift
                }
                return (0, _type.isFunction)(func) && func.call(this)
            },
            _getVisibleSeries: function() {
                return (0, _common.grep)(this.getAllSeries(), function(series) {
                    return series.isVisible()
                })
            },
            _resolveLabelOverlappingHide: function() {
                var labels = [];
                var currentLabel;
                var nextLabel;
                var currentLabelRect;
                var nextLabelRect;
                var i;
                var j;
                var points;
                var series = this._getVisibleSeries();
                for (i = 0; i < series.length; i++) {
                    points = series[i].getVisiblePoints();
                    for (j = 0; j < points.length; j++) {
                        labels.push.apply(labels, points[j].getLabels())
                    }
                }
                for (i = 0; i < labels.length; i++) {
                    currentLabel = labels[i];
                    if (!currentLabel.isVisible()) {
                        continue
                    }
                    currentLabelRect = currentLabel.getBoundingRect();
                    for (j = i + 1; j < labels.length; j++) {
                        nextLabel = labels[j];
                        nextLabelRect = nextLabel.getBoundingRect();
                        if (checkOverlapping(currentLabelRect, nextLabelRect)) {
                            nextLabel.draw(false)
                        }
                    }
                }
            },
            _cleanGroups: function() {
                var that = this;
                that._stripsGroup.linkRemove().clear();
                that._gridGroup.linkRemove().clear();
                that._axesGroup.linkRemove().clear();
                that._constantLinesGroup.above.clear();
                that._labelAxesGroup.linkRemove().clear();
                that._labelsGroup.linkRemove().clear();
                that._crosshairCursorGroup.linkRemove().clear();
                that._scaleBreaksGroup.linkRemove().clear()
            },
            _allowLegendInsidePosition: function() {
                return false
            },
            _createLegend: function() {
                var that = this;
                var legendSettings = getLegendSettings(that._legendDataField);
                that._legend = new _legend.Legend({
                    renderer: that._renderer,
                    widget: that,
                    group: that._legendGroup,
                    backgroundClass: "dxc-border",
                    itemGroupClass: "dxc-item",
                    titleGroupClass: "dxc-title",
                    textField: legendSettings.textField,
                    getFormatObject: legendSettings.getFormatObject,
                    allowInsidePosition: that._allowLegendInsidePosition()
                });
                that._updateLegend();
                that._layout.add(that._legend)
            },
            _updateLegend: function() {
                var that = this;
                var themeManager = that._themeManager;
                var legendOptions = themeManager.getOptions("legend");
                var legendData = that._getLegendData();
                legendOptions.containerBackgroundColor = themeManager.getOptions("containerBackgroundColor");
                legendOptions._incidentOccurred = that._incidentOccurred;
                that._legend.update(legendData, legendOptions, themeManager.theme("legend").title);
                this._change(["LAYOUT"])
            },
            _prepareDrawOptions: function(drawOptions) {
                var animationOptions = this._getAnimationOptions();
                var options = (0, _extend.extend)({}, {
                    force: false,
                    adjustAxes: true,
                    drawLegend: true,
                    drawTitle: true,
                    animate: animationOptions.enabled,
                    animationPointsLimit: animationOptions.maxPointCountSupported
                }, drawOptions, this.__renderOptions);
                if (!(0, _type.isDefined)(options.recreateCanvas)) {
                    options.recreateCanvas = options.adjustAxes && options.drawLegend && options.drawTitle
                }
                return options
            },
            _processRefreshData: function(newRefreshAction) {
                var currentRefreshActionPosition = (0, _array.inArray)(this._currentRefreshData, ACTIONS_BY_PRIORITY);
                var newRefreshActionPosition = (0, _array.inArray)(newRefreshAction, ACTIONS_BY_PRIORITY);
                if (!this._currentRefreshData || currentRefreshActionPosition >= 0 && newRefreshActionPosition < currentRefreshActionPosition) {
                    this._currentRefreshData = newRefreshAction
                }
                this._requestChange(["REFRESH"])
            },
            _getLegendData: function() {
                return (0, _utils.map)(this._getLegendTargets(), function(item) {
                    var legendData = item.legendData;
                    var style = item.getLegendStyles;
                    var opacity = style.normal.opacity;
                    if (!item.visible) {
                        if (!(0, _type.isDefined)(opacity) || opacity > DEFAULT_OPACITY) {
                            opacity = DEFAULT_OPACITY
                        }
                        legendData.textOpacity = DEFAULT_OPACITY
                    }
                    var opacityStyle = {
                        opacity: opacity
                    };
                    legendData.states = {
                        hover: (0, _extend.extend)({}, style.hover, opacityStyle),
                        selection: (0, _extend.extend)({}, style.selection, opacityStyle),
                        normal: (0, _extend.extend)({}, style.normal, opacityStyle)
                    };
                    return legendData
                })
            },
            _getLegendOptions: function(item) {
                return {
                    legendData: {
                        text: item[this._legendItemTextField],
                        id: item.index,
                        visible: true
                    },
                    getLegendStyles: item.getLegendStyles(),
                    visible: item.isVisible()
                }
            },
            _disposeSeries: function(seriesIndex) {
                var _that$series;
                var that = this;
                if (that.series) {
                    if ((0, _type.isDefined)(seriesIndex)) {
                        that.series[seriesIndex].dispose();
                        that.series.splice(seriesIndex, 1)
                    } else {
                        (0, _iterator.each)(that.series, function(_, s) {
                            return s.dispose()
                        });
                        that.series.length = 0
                    }
                }
                if (!(null !== (_that$series = that.series) && void 0 !== _that$series && _that$series.length)) {
                    that.series = []
                }
            },
            _disposeSeriesFamilies: function() {
                var that = this;
                (0, _iterator.each)(that.seriesFamilies || [], function(_, family) {
                    family.dispose()
                });
                that.seriesFamilies = null;
                that._needHandleRenderComplete = true
            },
            _optionChanged: function(arg) {
                this._themeManager.resetOptions(arg.name);
                this.callBase.apply(this, arguments)
            },
            _applyChanges: function() {
                var that = this;
                that._themeManager.update(that._options.silent());
                that.callBase.apply(that, arguments)
            },
            _optionChangesMap: {
                animation: "ANIMATION",
                dataSource: "DATA_SOURCE",
                palette: "PALETTE",
                paletteExtensionMode: "PALETTE",
                legend: "FORCE_DATA_INIT",
                seriesTemplate: "FORCE_DATA_INIT",
                "export": "FORCE_RENDER",
                valueAxis: "AXES_AND_PANES",
                argumentAxis: "AXES_AND_PANES",
                commonAxisSettings: "AXES_AND_PANES",
                panes: "AXES_AND_PANES",
                commonPaneSettings: "AXES_AND_PANES",
                defaultPane: "AXES_AND_PANES",
                containerBackgroundColor: "AXES_AND_PANES",
                rotated: "ROTATED",
                autoHidePointMarkers: "REFRESH_SERIES_REINIT",
                customizePoint: "REFRESH_SERIES_REINIT",
                customizeLabel: "REFRESH_SERIES_REINIT",
                scrollBar: "SCROLL_BAR"
            },
            _optionChangesOrder: ["ROTATED", "PALETTE", "REFRESH_SERIES_REINIT", "AXES_AND_PANES", "INIT", "REINIT", "DATA_SOURCE", "REFRESH_SERIES_DATA_INIT", "DATA_INIT", "FORCE_DATA_INIT", "REFRESH_AXES", "CORRECT_AXIS"],
            _customChangesOrder: ["ANIMATION", "REFRESH_SERIES_FAMILIES", "FORCE_FIRST_DRAWING", "FORCE_DRAWING", "FORCE_RENDER", "VISUAL_RANGE", "SCROLL_BAR", "REINIT", "REFRESH", "FULL_RENDER"],
            _change_ANIMATION: function() {
                this._renderer.updateAnimationOptions(this._getAnimationOptions())
            },
            _change_DATA_SOURCE: function() {
                this._needHandleRenderComplete = true;
                this._updateDataSource()
            },
            _change_PALETTE: function() {
                this._themeManager.updatePalette();
                this._refreshSeries("DATA_INIT")
            },
            _change_REFRESH_SERIES_DATA_INIT: function() {
                this._refreshSeries("DATA_INIT")
            },
            _change_DATA_INIT: function() {
                if ((!this.series || this.needToPopulateSeries) && !this._changes.has("FORCE_DATA_INIT")) {
                    this._dataInit()
                }
            },
            _change_FORCE_DATA_INIT: function() {
                this._dataInit()
            },
            _change_REFRESH_SERIES_FAMILIES: function() {
                this._processSeriesFamilies();
                this._populateBusinessRange();
                this._processRefreshData(FORCE_RENDER_REFRESH_ACTION)
            },
            _change_FORCE_RENDER: function() {
                this._processRefreshData(FORCE_RENDER_REFRESH_ACTION)
            },
            _change_AXES_AND_PANES: function() {
                this._refreshSeries("INIT")
            },
            _change_ROTATED: function() {
                this._createScrollBar();
                this._refreshSeries("INIT")
            },
            _change_REFRESH_SERIES_REINIT: function() {
                this._refreshSeries("INIT")
            },
            _change_REFRESH_AXES: function() {
                var that = this;
                (0, _utils.setCanvasValues)(that._canvas);
                that._reinitAxes();
                that._requestChange(["CORRECT_AXIS", "FULL_RENDER"])
            },
            _change_SCROLL_BAR: function() {
                this._createScrollBar();
                this._processRefreshData(FORCE_RENDER_REFRESH_ACTION)
            },
            _change_REINIT: function() {
                this._processRefreshData(REINIT_REFRESH_ACTION)
            },
            _change_FORCE_DRAWING: function() {
                this._resetComponentsAnimation()
            },
            _change_FORCE_FIRST_DRAWING: function() {
                this._resetComponentsAnimation(true)
            },
            _resetComponentsAnimation: function(isFirstDrawing) {
                this.series.forEach(function(s) {
                    s.resetApplyingAnimation(isFirstDrawing)
                });
                this._resetAxesAnimation(isFirstDrawing)
            },
            _resetAxesAnimation: _common.noop,
            _refreshSeries: function(actionName) {
                this.needToPopulateSeries = true;
                this._requestChange([actionName])
            },
            _change_CORRECT_AXIS: function() {
                this._correctAxes()
            },
            _doRefresh: function() {
                var methodName = this._currentRefreshData;
                if (methodName) {
                    this._currentRefreshData = null;
                    this._renderer.stopAllAnimations(true);
                    this[methodName]()
                }
            },
            _updateCanvasClipRect: function(canvas) {
                var that = this;
                var width = Math.max(canvas.width - canvas.left - canvas.right, 0);
                var height = Math.max(canvas.height - canvas.top - canvas.bottom, 0);
                that._canvasClipRect.attr({
                    x: canvas.left,
                    y: canvas.top,
                    width: width,
                    height: height
                });
                that._backgroundRect.attr({
                    x: canvas.left,
                    y: canvas.top,
                    width: width,
                    height: height
                })
            },
            _getCanvasClipRectID: function() {
                return this._canvasClipRect.id
            },
            _dataSourceChangedHandler: function() {
                if (this._changes.has("INIT")) {
                    this._requestChange(["DATA_INIT"])
                } else {
                    this._requestChange(["FORCE_DATA_INIT"])
                }
            },
            _dataInit: function() {
                this._dataSpecificInit(true)
            },
            _processSingleSeries: function(singleSeries) {
                singleSeries.createPoints(false)
            },
            _handleSeriesDataUpdated: function() {
                var _this2 = this;
                if (this._getVisibleSeries().some(function(s) {
                        return s.useAggregation()
                    })) {
                    this._populateMarginOptions()
                }
                this.series.forEach(function(s) {
                    return _this2._processSingleSeries(s)
                }, this)
            },
            _dataSpecificInit: function(needRedraw) {
                var that = this;
                if (!that.series || that.needToPopulateSeries) {
                    that.series = that._populateSeries()
                }
                that._repopulateSeries();
                that._seriesPopulatedHandlerCore();
                that._populateBusinessRange();
                that._tracker.updateSeries(that.series, this._changes.has("INIT"));
                that._updateLegend();
                if (needRedraw) {
                    this._requestChange(["FULL_RENDER"])
                }
            },
            _forceRender: function() {
                this._doRender({
                    force: true
                })
            },
            _repopulateSeries: function() {
                var that = this;
                var themeManager = that._themeManager;
                var data = that._dataSourceItems();
                var dataValidatorOptions = themeManager.getOptions("dataPrepareSettings");
                var seriesTemplate = themeManager.getOptions("seriesTemplate");
                if (seriesTemplate) {
                    that._populateSeries(data)
                }
                that._groupSeries();
                var parsedData = (0, _data_validator.validateData)(data, that._groupsData, that._incidentOccurred, dataValidatorOptions);
                themeManager.resetPalette();
                that.series.forEach(function(singleSeries) {
                    singleSeries.updateData(parsedData[singleSeries.getArgumentField()])
                });
                that._handleSeriesDataUpdated()
            },
            _renderCompleteHandler: function() {
                var that = this;
                var allSeriesInited = true;
                if (that._needHandleRenderComplete) {
                    (0, _iterator.each)(that.series, function(_, s) {
                        allSeriesInited = allSeriesInited && s.canRenderCompleteHandle()
                    });
                    if (allSeriesInited) {
                        that._needHandleRenderComplete = false;
                        that._eventTrigger("done", {
                            target: that
                        })
                    }
                }
            },
            _dataIsReady: function() {
                return (0, _type.isDefined)(this.option("dataSource")) && this._dataIsLoaded()
            },
            _populateSeriesOptions: function(data) {
                var that = this;
                var themeManager = that._themeManager;
                var seriesTemplate = themeManager.getOptions("seriesTemplate");
                var seriesOptions = seriesTemplate ? (0, _utils.processSeriesTemplate)(seriesTemplate, data || []) : that.option("series");
                var allSeriesOptions = _isArray(seriesOptions) ? seriesOptions : seriesOptions ? [seriesOptions] : [];
                var extraOptions = that._getExtraOptions();
                var particularSeriesOptions;
                var seriesTheme;
                var seriesThemes = [];
                var seriesVisibilityChanged = function(target) {
                    that._specialProcessSeries();
                    that._populateBusinessRange(target && target.getValueAxis(), true);
                    that._renderer.stopAllAnimations(true);
                    that._updateLegend();
                    that._requestChange(["FULL_RENDER"])
                };
                for (var i = 0; i < allSeriesOptions.length; i++) {
                    particularSeriesOptions = (0, _extend.extend)(true, {}, allSeriesOptions[i], extraOptions);
                    if (!(0, _type.isDefined)(particularSeriesOptions.name) || "" === particularSeriesOptions.name) {
                        particularSeriesOptions.name = "Series " + (i + 1).toString()
                    }
                    particularSeriesOptions.rotated = that._isRotated();
                    particularSeriesOptions.customizePoint = themeManager.getOptions("customizePoint");
                    particularSeriesOptions.customizeLabel = themeManager.getOptions("customizeLabel");
                    particularSeriesOptions.visibilityChanged = seriesVisibilityChanged;
                    particularSeriesOptions.incidentOccurred = that._incidentOccurred;
                    seriesTheme = themeManager.getOptions("series", particularSeriesOptions, allSeriesOptions.length);
                    if (that._checkPaneName(seriesTheme)) {
                        seriesThemes.push(seriesTheme)
                    }
                }
                return seriesThemes
            },
            _populateSeries: function(data) {
                var that = this;
                var seriesBasis = [];
                var incidentOccurred = that._incidentOccurred;
                var seriesThemes = that._populateSeriesOptions(data);
                var particularSeries;
                var disposeSeriesFamilies = false;
                that.needToPopulateSeries = false;
                (0, _iterator.each)(seriesThemes, function(_, theme) {
                    var curSeries = that.series && that.series.filter(function(s) {
                        return s.name === theme.name && seriesBasis.map(function(sb) {
                            return sb.series
                        }).indexOf(s) === -1
                    })[0];
                    if (curSeries && curSeries.type === theme.type) {
                        seriesBasis.push({
                            series: curSeries,
                            options: theme
                        })
                    } else {
                        seriesBasis.push({
                            options: theme
                        });
                        disposeSeriesFamilies = true
                    }
                });
                that._tracker.clearHover();
                (0, _iterator.reverseEach)(that.series, function(index, series) {
                    if (!seriesBasis.some(function(s) {
                            return series === s.series
                        })) {
                        that._disposeSeries(index);
                        disposeSeriesFamilies = true
                    }
                });
                !disposeSeriesFamilies && (disposeSeriesFamilies = seriesBasis.some(function(sb) {
                    return sb.series.name !== seriesThemes[sb.series.index].name
                }));
                that.series = [];
                disposeSeriesFamilies && that._disposeSeriesFamilies();
                that._themeManager.resetPalette();
                var eventPipe = function(data) {
                    that.series.forEach(function(currentSeries) {
                        currentSeries.notify(data)
                    })
                };
                (0, _iterator.each)(seriesBasis, function(_, basis) {
                    var seriesTheme = basis.options;
                    var renderSettings = {
                        commonSeriesModes: that._getSelectionModes(),
                        argumentAxis: that.getArgumentAxis(),
                        valueAxis: that._getValueAxis(seriesTheme.pane, seriesTheme.axis)
                    };
                    if (basis.series) {
                        particularSeries = basis.series;
                        particularSeries.updateOptions(seriesTheme, renderSettings)
                    } else {
                        particularSeries = new _base_series.Series((0, _extend.extend)({
                            renderer: that._renderer,
                            seriesGroup: that._seriesGroup,
                            labelsGroup: that._labelsGroup,
                            eventTrigger: that._eventTrigger,
                            eventPipe: eventPipe,
                            incidentOccurred: incidentOccurred
                        }, renderSettings), seriesTheme)
                    }
                    if (!particularSeries.isUpdated) {
                        incidentOccurred("E2101", [seriesTheme.type])
                    } else {
                        particularSeries.index = that.series.length;
                        that.series.push(particularSeries)
                    }
                });
                return that.series
            },
            getStackedPoints: function(point) {
                var stackName = point.series.getStackName();
                return this._getVisibleSeries().reduce(function(stackPoints, series) {
                    if (!(0, _type.isDefined)(series.getStackName()) || !(0, _type.isDefined)(stackName) || stackName === series.getStackName()) {
                        stackPoints = stackPoints.concat(series.getPointsByArg(point.argument))
                    }
                    return stackPoints
                }, [])
            },
            getAllSeries: function() {
                return (this.series || []).slice()
            },
            getSeriesByName: function(name) {
                var found = null;
                (0, _iterator.each)(this.series, function(i, singleSeries) {
                    if (singleSeries.name === name) {
                        found = singleSeries;
                        return false
                    }
                });
                return found
            },
            getSeriesByPos: function(pos) {
                return (this.series || [])[pos]
            },
            clearSelection: function() {
                this._tracker.clearSelection()
            },
            hideTooltip: function() {
                this._tracker._hideTooltip()
            },
            clearHover: function() {
                this._tracker.clearHover()
            },
            render: function(renderOptions) {
                var that = this;
                that.__renderOptions = renderOptions;
                that.__forceRender = renderOptions && renderOptions.force;
                that.callBase.apply(that, arguments);
                that.__renderOptions = that.__forceRender = null;
                return that
            },
            refresh: function() {
                this._disposeSeries();
                this._disposeSeriesFamilies();
                this._requestChange(["CONTAINER_SIZE", "REFRESH_SERIES_REINIT"])
            },
            _getMinSize: function() {
                var adaptiveLayout = this._layoutManagerOptions();
                return [adaptiveLayout.width, adaptiveLayout.height]
            },
            _change_REFRESH: function() {
                if (!this._changes.has("INIT")) {
                    this._doRefresh()
                } else {
                    this._currentRefreshData = null
                }
            },
            _change_FULL_RENDER: function() {
                this._forceRender()
            },
            _change_INIT: function() {
                this._reinit()
            },
            _stopCurrentHandling: function() {
                this._tracker.stopCurrentHandling()
            }
        });
        exports.BaseChart = BaseChart;
        REFRESH_SERIES_DATA_INIT_ACTION_OPTIONS.forEach(function(name) {
            BaseChart.prototype._optionChangesMap[name] = "REFRESH_SERIES_DATA_INIT"
        });
        FORCE_RENDER_REFRESH_ACTION_OPTIONS.forEach(function(name) {
            BaseChart.prototype._optionChangesMap[name] = "FORCE_RENDER"
        });
        REFRESH_SERIES_FAMILIES_ACTION_OPTIONS.forEach(function(name) {
            BaseChart.prototype._optionChangesMap[name] = "REFRESH_SERIES_FAMILIES"
        });
        BaseChart.addPlugin(_export.plugin);
        BaseChart.addPlugin(_title.plugin);
        BaseChart.addPlugin(_data_source.plugin);
        BaseChart.addPlugin(_tooltip.plugin);
        BaseChart.addPlugin(_loading_indicator.plugin);
        var _change_TITLE = BaseChart.prototype._change_TITLE;
        BaseChart.prototype._change_TITLE = function() {
            _change_TITLE.apply(this, arguments);
            this._change(["FORCE_RENDER"])
        }
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/core/base_theme_manager.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.BaseThemeManager = void 0;
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _extend2 = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _palette = __webpack_require__( /*! ../palette */ 187);
        var _utils = __webpack_require__( /*! ./utils */ 14);
        var _themes = __webpack_require__( /*! ../themes */ 55);
        __webpack_require__( /*! ./themes/generic.light */ 907);
        __webpack_require__( /*! ./themes/generic.dark */ 908);
        __webpack_require__( /*! ./themes/generic.contrast */ 909);
        __webpack_require__( /*! ./themes/generic.carmine */ 910);
        __webpack_require__( /*! ./themes/generic.darkmoon */ 911);
        __webpack_require__( /*! ./themes/generic.softblue */ 912);
        __webpack_require__( /*! ./themes/generic.darkviolet */ 913);
        __webpack_require__( /*! ./themes/generic.greenmist */ 914);
        __webpack_require__( /*! ./themes/material */ 915);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _getTheme = _themes.getTheme;
        var _addCacheItem = _themes.addCacheItem;
        var _removeCacheItem = _themes.removeCacheItem;
        var _extend = _extend2.extend;
        var _each = _iterator.each;

        function getThemePart(theme, path) {
            var _theme = theme;
            path && _each(path.split("."), function(_, pathItem) {
                return _theme = _theme[pathItem]
            });
            return _theme
        }
        var BaseThemeManager = _class.default.inherit({
            ctor: function(options) {
                this._themeSection = options.themeSection;
                this._fontFields = options.fontFields || [];
                _addCacheItem(this)
            },
            dispose: function() {
                var that = this;
                _removeCacheItem(that);
                that._callback = that._theme = that._font = null;
                return that
            },
            setCallback: function(callback) {
                this._callback = callback;
                return this
            },
            setTheme: function(theme, rtl) {
                this._current = theme;
                this._rtl = rtl;
                return this.refresh()
            },
            refresh: function() {
                var that = this;
                var current = that._current || {};
                var theme = _getTheme(current.name || current);
                that._themeName = theme.name;
                that._defaultPalette = theme.defaultPalette;
                that._font = _extend({}, theme.font, current.font);
                that._themeSection && _each(that._themeSection.split("."), function(_, path) {
                    theme = _extend(true, {}, theme[path])
                });
                that._theme = _extend(true, {}, theme, (0, _type.isString)(current) ? {} : current);
                that._initializeTheme();
                if ((0, _utils.parseScalar)(that._rtl, that._theme.rtlEnabled)) {
                    _extend(true, that._theme, that._theme._rtl)
                }
                that._callback();
                return that
            },
            theme: function(path) {
                return getThemePart(this._theme, path)
            },
            themeName: function() {
                return this._themeName
            },
            createPalette: function(palette, options) {
                return (0, _palette.createPalette)(palette, options, this._defaultPalette)
            },
            createDiscretePalette: function(palette, count) {
                return (0, _palette.getDiscretePalette)(palette, count, this._defaultPalette)
            },
            createGradientPalette: function(palette) {
                return (0, _palette.getGradientPalette)(palette, this._defaultPalette)
            },
            getAccentColor: function(palette) {
                return (0, _palette.getAccentColor)(palette, this._defaultPalette)
            },
            _initializeTheme: function() {
                var that = this;
                _each(that._fontFields || [], function(_, path) {
                    that._initializeFont(getThemePart(that._theme, path))
                })
            },
            _initializeFont: function(font) {
                _extend(font, this._font, _extend({}, font))
            }
        });
        exports.BaseThemeManager = BaseThemeManager
    },
    /*!*************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/core/layout_element.js ***!
      \*************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.LayoutElement = LayoutElement;
        exports.WrapperLayoutElement = WrapperLayoutElement;
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _object = __webpack_require__( /*! ../../core/utils/object */ 51);
        var _round = Math.round;
        var defaultOffset = {
            horizontal: 0,
            vertical: 0
        };
        var alignFactors = {
            center: .5,
            right: 1,
            bottom: 1,
            left: 0,
            top: 0
        };

        function LayoutElement(options) {
            this._options = options
        }
        LayoutElement.prototype = {
            constructor: LayoutElement,
            position: function(options) {
                var that = this;
                var ofBBox = options.of.getLayoutOptions();
                var myBBox = that.getLayoutOptions();
                var at = options.at;
                var my = options.my;
                var offset = options.offset || defaultOffset;
                var shiftX = -alignFactors[my.horizontal] * myBBox.width + ofBBox.x + alignFactors[at.horizontal] * ofBBox.width + parseInt(offset.horizontal);
                var shiftY = -alignFactors[my.vertical] * myBBox.height + ofBBox.y + alignFactors[at.vertical] * ofBBox.height + parseInt(offset.vertical);
                that.shift(_round(shiftX), _round(shiftY))
            },
            getLayoutOptions: _common.noop
        };

        function WrapperLayoutElement(renderElement, bBox) {
            this._renderElement = renderElement;
            this._cacheBBox = bBox
        }
        var wrapperLayoutElementPrototype = WrapperLayoutElement.prototype = (0, _object.clone)(LayoutElement.prototype);
        wrapperLayoutElementPrototype.constructor = WrapperLayoutElement;
        wrapperLayoutElementPrototype.getLayoutOptions = function() {
            return this._cacheBBox || this._renderElement.getBBox()
        };
        wrapperLayoutElementPrototype.shift = function(shiftX, shiftY) {
            var bBox = this.getLayoutOptions();
            this._renderElement.move(_round(shiftX - bBox.x), _round(shiftY - bBox.y))
        }
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/components/data_validator.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.validateData = validateData;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _parse_utils = __webpack_require__( /*! ./parse_utils */ 313);
        var STRING = "string";
        var NUMERIC = "numeric";
        var DATETIME = "datetime";
        var DISCRETE = "discrete";
        var SEMIDISCRETE = "semidiscrete";
        var CONTINUOUS = "continuous";
        var LOGARITHMIC = "logarithmic";
        var VALUE_TYPE = "valueType";
        var ARGUMENT_TYPE = "argumentType";
        var axisTypeParser = (0, _utils.enumParser)([STRING, NUMERIC, DATETIME]);
        var _isArray = Array.isArray;

        function groupingValues(data, others, valueField, index) {
            if (index >= 0) {
                data.slice(index).forEach(function(cell) {
                    if ((0, _type.isDefined)(cell[valueField])) {
                        others[valueField] += cell[valueField];
                        cell[valueField] = void 0
                    }
                })
            }
        }

        function processGroups(groups) {
            groups.forEach(function(group) {
                group.valueType = group.valueAxisType = null;
                group.series.forEach(function(series) {
                    series.updateDataType({})
                });
                group.valueAxis && group.valueAxis.resetTypes(VALUE_TYPE)
            })
        }

        function sortValues(data, asc, selector) {
            var func = asc ? function(a, b) {
                return a - b
            } : function(a, b) {
                return b - a
            };
            data.sort(function(a, b) {
                var valA = selector(a);
                var valB = selector(b);
                var aa = (0, _type.isDefined)(valA) ? 1 : 0;
                var bb = (0, _type.isDefined)(valB) ? 1 : 0;
                return aa && bb ? func(valA, valB) : func(aa, bb)
            });
            return data
        }

        function resetArgumentAxes(axes) {
            axes && axes.forEach(function(axis) {
                axis.resetTypes(ARGUMENT_TYPE)
            })
        }

        function parseCategories(categories, parser) {
            var newArray = [];
            categories.forEach(function(category) {
                var parsedCategory = parser(category);
                void 0 !== parsedCategory && newArray.push(parsedCategory)
            });
            return newArray
        }

        function parseAxisCategories(groupsData, parsers) {
            var argumentCategories = groupsData.argumentOptions && groupsData.argumentOptions.categories;
            groupsData.groups.forEach(function(valueGroup, i) {
                var categories = valueGroup.valueOptions && valueGroup.valueOptions.categories;
                if (categories) {
                    valueGroup.valueOptions.categories = parseCategories(categories, parsers[i + 1])
                }
            });
            if (argumentCategories) {
                groupsData.argumentOptions.categories = parseCategories(argumentCategories, parsers[0])
            }
        }

        function eigen(x) {
            return x
        }

        function getType(unit, type) {
            var result = type;
            if (type === STRING || (0, _type.isString)(unit)) {
                result = STRING
            } else {
                if (type === DATETIME || (0, _type.isDate)(unit)) {
                    result = DATETIME
                } else {
                    if ((0, _type.isNumeric)(unit)) {
                        result = NUMERIC
                    }
                }
            }
            return result
        }

        function correctAxisType(type, axisType, hasCategories, incidentOccurred) {
            if (type === STRING && (axisType === CONTINUOUS || axisType === LOGARITHMIC || axisType === SEMIDISCRETE)) {
                incidentOccurred("E2002")
            }
            return axisType === LOGARITHMIC ? LOGARITHMIC : hasCategories || axisType === DISCRETE || type === STRING ? DISCRETE : axisType === SEMIDISCRETE ? SEMIDISCRETE : CONTINUOUS
        }

        function validUnit(unit, field, incidentOccurred) {
            if (unit) {
                incidentOccurred(!(0, _type.isNumeric)(unit) && !(0, _type.isDate)(unit) && !(0, _type.isString)(unit) ? "E2003" : "E2004", [field])
            }
        }

        function createParserUnit(type, axisType, incidentOccurred) {
            var parser = type ? (0, _parse_utils.getParser)(type) : eigen;
            var filterInfinity = axisType !== DISCRETE ? function(x) {
                return isFinite(x) || void 0 === x ? x : null
            } : eigen;
            return function(unit, field) {
                var parseUnit = filterInfinity(parser(unit));
                if (void 0 === parseUnit) {
                    validUnit(unit, field, incidentOccurred)
                }
                return parseUnit
            }
        }

        function prepareParsers(groupsData, incidentOccurred) {
            var argumentParser = createParserUnit(groupsData.argumentType, groupsData.argumentAxisType, incidentOccurred);
            var sizeParser;
            var valueParser;
            var categoryParsers = [argumentParser];
            var cache = {};
            var list = [];
            groupsData.groups.forEach(function(group, groupIndex) {
                group.series.forEach(function(series) {
                    valueParser = createParserUnit(group.valueType, group.valueAxisType, incidentOccurred);
                    sizeParser = createParserUnit(NUMERIC, CONTINUOUS, incidentOccurred);
                    cache[series.getArgumentField()] = argumentParser;
                    series.getValueFields().forEach(function(field) {
                        categoryParsers[groupIndex + 1] = valueParser;
                        cache[field] = valueParser
                    });
                    if (series.getSizeField()) {
                        cache[series.getSizeField()] = sizeParser
                    }
                })
            });
            for (var field in cache) {
                list.push([field, cache[field]])
            }
            list.length && parseAxisCategories(groupsData, categoryParsers);
            return list
        }

        function getParsedCell(cell, parsers) {
            var i;
            var ii = parsers.length;
            var obj = (0, _extend.extend)({}, cell);
            var field;
            var value;
            for (i = 0; i < ii; ++i) {
                field = parsers[i][0];
                value = cell[field];
                obj[field] = parsers[i][1](value, field)
            }
            return obj
        }

        function parse(data, parsers) {
            var parsedData = [];
            var i;
            var ii = data.length;
            parsedData.length = ii;
            for (i = 0; i < ii; ++i) {
                parsedData[i] = getParsedCell(data[i], parsers)
            }
            return parsedData
        }

        function findIndexByThreshold(data, valueField, threshold) {
            var i;
            var ii = data.length;
            var value;
            for (i = 0; i < ii; ++i) {
                value = data[i][valueField];
                if ((0, _type.isDefined)(value) && threshold > value) {
                    break
                }
            }
            return i
        }

        function groupMinSlices(originalData, argumentField, valueField, smallValuesGrouping) {
            smallValuesGrouping = smallValuesGrouping || {};
            var mode = smallValuesGrouping.mode;
            var others = {};
            if (!mode || "none" === mode) {
                return
            }
            others[argumentField] = String(smallValuesGrouping.groupName || "others");
            others[valueField] = 0;
            var data = sortValues(originalData.slice(), false, function(a) {
                return a[valueField]
            });
            groupingValues(data, others, valueField, "smallValueThreshold" === mode ? findIndexByThreshold(data, valueField, smallValuesGrouping.threshold) : smallValuesGrouping.topCount);
            others[valueField] && originalData.push(others)
        }

        function groupPieData(data, groupsData) {
            var firstSeries = groupsData.groups[0] && groupsData.groups[0].series[0];
            var isPie = firstSeries && ("pie" === firstSeries.type || "doughnut" === firstSeries.type || "donut" === firstSeries.type);
            if (!isPie) {
                return
            }
            groupsData.groups.forEach(function(group) {
                group.series.forEach(function(series) {
                    groupMinSlices(data, series.getArgumentField(), series.getValueFields()[0], series.getOptions().smallValuesGrouping)
                })
            })
        }

        function addUniqueItemToCollection(item, collection, itemsHash) {
            if (!itemsHash[item]) {
                collection.push(item);
                itemsHash[item] = true
            }
        }

        function getUniqueArgumentFields(groupsData) {
            var uniqueArgumentFields = [];
            var hash = {};
            groupsData.groups.forEach(function(group) {
                group.series.forEach(function(series) {
                    addUniqueItemToCollection(series.getArgumentField(), uniqueArgumentFields, hash)
                })
            });
            return uniqueArgumentFields
        }

        function sort(a, b) {
            var result = a - b;
            if (isNaN(result)) {
                if (!(0, _type.isDefined)(a)) {
                    return 1
                }
                if (!(0, _type.isDefined)(b)) {
                    return -1
                }
                return 0
            }
            return result
        }

        function sortByArgument(data, argumentField) {
            return data.slice().sort(function(a, b) {
                return sort(a[argumentField], b[argumentField])
            })
        }

        function sortByCallback(data, callback) {
            return data.slice().sort(callback)
        }

        function checkValueTypeOfGroup(group, cell) {
            group.series.forEach(function(series) {
                series.getValueFields().forEach(function(field) {
                    group.valueType = getType(cell[field], group.valueType)
                })
            });
            return group.valueType
        }

        function getSortByCategories(categories) {
            var hash = {};
            categories.forEach(function(value, i) {
                hash[value] = i
            });
            return function(data, argumentField) {
                return sortValues(data.slice(), true, function(a) {
                    return hash[a[argumentField]]
                })
            }
        }

        function sortData(data, groupsData, options, uniqueArgumentFields) {
            var dataByArguments = {};
            var isDiscrete = groupsData.argumentAxisType === DISCRETE;
            var userCategories = isDiscrete && groupsData.argumentOptions && groupsData.argumentOptions.categories;
            var sortFunction = function(data) {
                return data
            };
            var sortingMethodOption = options.sortingMethod;
            var reSortCategories;
            if (!userCategories && (0, _type.isFunction)(sortingMethodOption)) {
                data = sortByCallback(data, sortingMethodOption)
            }
            if (isDiscrete) {
                groupsData.categories = getCategories(data, uniqueArgumentFields, userCategories)
            }
            if (userCategories || !(0, _type.isFunction)(sortingMethodOption) && groupsData.argumentType === STRING && !options._skipArgumentSorting) {
                sortFunction = getSortByCategories(groupsData.categories)
            } else {
                if (true === sortingMethodOption && groupsData.argumentType !== STRING) {
                    sortFunction = sortByArgument;
                    reSortCategories = isDiscrete
                }
            }
            uniqueArgumentFields.forEach(function(field) {
                dataByArguments[field] = sortFunction(data, field)
            });
            if (reSortCategories) {
                groupsData.categories = groupsData.categories.sort(sort)
            }
            return dataByArguments
        }

        function checkItemExistence(collection, item) {
            return collection.map(function(collectionItem) {
                return collectionItem.valueOf()
            }).indexOf(item.valueOf()) === -1
        }

        function getCategories(data, uniqueArgumentFields, userCategories) {
            var categories = userCategories ? userCategories.slice() : [];
            uniqueArgumentFields.forEach(function(field) {
                data.forEach(function(item) {
                    var dataItem = item[field];
                    (0, _type.isDefined)(dataItem) && checkItemExistence(categories, dataItem) && categories.push(dataItem)
                })
            });
            return categories
        }

        function checkArgumentTypeOfGroup(series, cell, groupsData) {
            series.forEach(function(currentSeries) {
                groupsData.argumentType = getType(cell[currentSeries.getArgumentField()], groupsData.argumentType)
            });
            return groupsData.argumentType
        }

        function checkType(data, groupsData, checkTypeForAllData) {
            var groupsWithUndefinedValueType = [];
            var groupsWithUndefinedArgumentType = [];
            var argumentTypeGroup = groupsData.argumentOptions && axisTypeParser(groupsData.argumentOptions.argumentType);
            var groupsIndexes;
            groupsData.groups.forEach(function(group) {
                if (!group.series.length) {
                    return
                }
                var valueTypeGroup = group.valueOptions && axisTypeParser(group.valueOptions.valueType);
                group.valueType = valueTypeGroup;
                groupsData.argumentType = argumentTypeGroup;
                !valueTypeGroup && groupsWithUndefinedValueType.push(group);
                !argumentTypeGroup && groupsWithUndefinedArgumentType.push(group)
            });
            if (groupsWithUndefinedValueType.length || groupsWithUndefinedArgumentType.length) {
                groupsIndexes = groupsWithUndefinedValueType.map(function(_, index) {
                    return index
                });
                data.some(function(cell) {
                    var defineArg;
                    groupsWithUndefinedValueType.forEach(function(group, groupIndex) {
                        if (checkValueTypeOfGroup(group, cell) && groupsIndexes.indexOf(groupIndex) >= 0) {
                            groupsIndexes.splice(groupIndex, 1)
                        }
                    });
                    if (!defineArg) {
                        groupsWithUndefinedArgumentType.forEach(function(group) {
                            defineArg = checkArgumentTypeOfGroup(group.series, cell, groupsData)
                        })
                    }
                    if (!checkTypeForAllData && defineArg && 0 === groupsIndexes.length) {
                        return true
                    }
                })
            }
        }

        function checkAxisType(groupsData, incidentOccurred) {
            var argumentOptions = groupsData.argumentOptions || {};
            var userArgumentCategories = argumentOptions && argumentOptions.categories || [];
            var argumentAxisType = correctAxisType(groupsData.argumentType, argumentOptions.type, !!userArgumentCategories.length, incidentOccurred);
            groupsData.groups.forEach(function(group) {
                var valueOptions = group.valueOptions || {};
                var valueCategories = valueOptions.categories || [];
                var valueAxisType = correctAxisType(group.valueType, valueOptions.type, !!valueCategories.length, incidentOccurred);
                group.series.forEach(function(series) {
                    var optionsSeries = {};
                    optionsSeries.argumentAxisType = argumentAxisType;
                    optionsSeries.valueAxisType = valueAxisType;
                    groupsData.argumentAxisType = groupsData.argumentAxisType || optionsSeries.argumentAxisType;
                    group.valueAxisType = group.valueAxisType || optionsSeries.valueAxisType;
                    optionsSeries.argumentType = groupsData.argumentType;
                    optionsSeries.valueType = group.valueType;
                    optionsSeries.showZero = valueOptions.showZero;
                    series.updateDataType(optionsSeries)
                });
                group.valueAxisType = group.valueAxisType || valueAxisType;
                if (group.valueAxis) {
                    group.valueAxis.setTypes(group.valueAxisType, group.valueType, VALUE_TYPE);
                    group.valueAxis.validate()
                }
            });
            groupsData.argumentAxisType = groupsData.argumentAxisType || argumentAxisType;
            if (groupsData.argumentAxes) {
                groupsData.argumentAxes.forEach(function(axis) {
                    axis.setTypes(groupsData.argumentAxisType, groupsData.argumentType, ARGUMENT_TYPE);
                    axis.validate()
                })
            }
        }

        function verifyData(source, incidentOccurred) {
            var data = [];
            var sourceIsDefined = (0, _type.isDefined)(source);
            var hasError = sourceIsDefined && !_isArray(source);
            var i;
            var ii;
            var k;
            var item;
            if (sourceIsDefined && !hasError) {
                for (i = 0, ii = source.length, k = 0; i < ii; ++i) {
                    item = source[i];
                    if ((0, _type.isObject)(item)) {
                        data[k++] = item
                    } else {
                        if (item) {
                            hasError = true
                        }
                    }
                }
            }
            if (hasError) {
                incidentOccurred("E2001")
            }
            return data
        }

        function validateData(data, groupsData, incidentOccurred, options) {
            data = verifyData(data, incidentOccurred);
            groupsData.argumentType = groupsData.argumentAxisType = null;
            processGroups(groupsData.groups);
            resetArgumentAxes(groupsData.argumentAxes);
            checkType(data, groupsData, options.checkTypeForAllData);
            checkAxisType(groupsData, incidentOccurred);
            if (options.convertToAxisDataType) {
                data = parse(data, prepareParsers(groupsData, incidentOccurred))
            }
            groupPieData(data, groupsData);
            var dataByArgumentFields = sortData(data, groupsData, options, getUniqueArgumentFields(groupsData));
            return dataByArgumentFields
        }
    },
    /*!****************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/components/parse_utils.js ***!
      \****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.correctValueType = correctValueType;
        exports.getParser = void 0;
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _date_serialization = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date_serialization */ 57));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var parsers = {
            string: function(val) {
                return (0, _type.isDefined)(val) ? "" + val : val
            },
            numeric: function(val) {
                if (!(0, _type.isDefined)(val)) {
                    return val
                }
                var parsedVal = Number(val);
                if (isNaN(parsedVal)) {
                    parsedVal = void 0
                }
                return parsedVal
            },
            datetime: function(val) {
                if (!(0, _type.isDefined)(val)) {
                    return val
                }
                var parsedVal;
                var numVal = Number(val);
                if (!isNaN(numVal)) {
                    parsedVal = new Date(numVal)
                } else {
                    parsedVal = _date_serialization.default.deserializeDate(val)
                }
                if (isNaN(Number(parsedVal))) {
                    parsedVal = void 0
                }
                return parsedVal
            }
        };

        function correctValueType(type) {
            return "numeric" === type || "datetime" === type || "string" === type ? type : ""
        }
        var getParser = function(valueType) {
            return parsers[correctValueType(valueType)] || _common.noop
        };
        exports.getParser = getParser
    },
    /*!************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/series/base_series.js ***!
      \************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.Series = Series;
        exports.mixins = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend2 = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _base_point = __webpack_require__( /*! ./points/base_point */ 918);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _consts = _interopRequireDefault(__webpack_require__( /*! ../components/consts */ 143));
        var _range_data_calculator = _interopRequireDefault(__webpack_require__( /*! ./helpers/range_data_calculator */ 226));
        var scatterSeries = _interopRequireWildcard(__webpack_require__( /*! ./scatter_series */ 122));
        var lineSeries = _interopRequireWildcard(__webpack_require__( /*! ./line_series */ 227));
        var areaSeries = _interopRequireWildcard(__webpack_require__( /*! ./area_series */ 188));
        var barSeries = _interopRequireWildcard(__webpack_require__( /*! ./bar_series */ 163));
        var _range_series = __webpack_require__( /*! ./range_series */ 923);
        var _bubble_series = __webpack_require__( /*! ./bubble_series */ 924);
        var pieSeries = _interopRequireWildcard(__webpack_require__( /*! ./pie_series */ 925));
        var financialSeries = _interopRequireWildcard(__webpack_require__( /*! ./financial_series */ 926));
        var stackedSeries = _interopRequireWildcard(__webpack_require__( /*! ./stacked_series */ 927));

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var seriesNS = {};
        var states = _consts.default.states;
        var DISCRETE = "discrete";
        var SELECTED_STATE = states.selectedMark;
        var HOVER_STATE = states.hoverMark;
        var HOVER = states.hover;
        var NORMAL = states.normal;
        var SELECTION = states.selection;
        var APPLY_SELECTED = states.applySelected;
        var APPLY_HOVER = states.applyHover;
        var RESET_ITEM = states.resetItem;
        var NONE_MODE = "none";
        var INCLUDE_POINTS = "includepoints";
        var NEAREST_POINT = "nearestpoint";
        var SERIES_SELECTION_CHANGED = "seriesSelectionChanged";
        var POINT_SELECTION_CHANGED = "pointSelectionChanged";
        var SERIES_HOVER_CHANGED = "seriesHoverChanged";
        var POINT_HOVER_CHANGED = "pointHoverChanged";
        var ALL_SERIES_POINTS = "allseriespoints";
        var ALL_ARGUMENT_POINTS = "allargumentpoints";
        var POINT_HOVER = "pointHover";
        var CLEAR_POINT_HOVER = "clearPointHover";
        var SERIES_SELECT = "seriesSelect";
        var POINT_SELECT = "pointSelect";
        var POINT_DESELECT = "pointDeselect";
        var getEmptyBusinessRange = function() {
            return {
                arg: {},
                val: {}
            }
        };

        function triggerEvent(element, event, point) {
            element && element.trigger(event, point)
        }
        seriesNS.mixins = {
            chart: {},
            pie: {},
            polar: {}
        };
        seriesNS.mixins.chart.scatter = scatterSeries.chart;
        seriesNS.mixins.polar.scatter = scatterSeries.polar;
        (0, _extend2.extend)(seriesNS.mixins.pie, pieSeries);
        (0, _extend2.extend)(seriesNS.mixins.chart, lineSeries.chart, areaSeries.chart, barSeries.chart, _range_series.chart, _bubble_series.chart, financialSeries, stackedSeries.chart);
        (0, _extend2.extend)(seriesNS.mixins.polar, lineSeries.polar, areaSeries.polar, barSeries.polar, stackedSeries.polar);

        function includePointsMode(mode) {
            mode = (0, _utils.normalizeEnum)(mode);
            return mode === INCLUDE_POINTS || mode === ALL_SERIES_POINTS
        }

        function getLabelOptions(labelOptions, defaultColor) {
            var opt = labelOptions || {};
            var labelFont = (0, _extend2.extend)({}, opt.font) || {};
            var labelBorder = opt.border || {};
            var labelConnector = opt.connector || {};
            var backgroundAttr = {
                fill: opt.backgroundColor || defaultColor,
                "stroke-width": labelBorder.visible ? labelBorder.width || 0 : 0,
                stroke: labelBorder.visible && labelBorder.width ? labelBorder.color : "none",
                dashStyle: labelBorder.dashStyle
            };
            var connectorAttr = {
                stroke: labelConnector.visible && labelConnector.width ? labelConnector.color || defaultColor : "none",
                "stroke-width": labelConnector.visible ? labelConnector.width || 0 : 0
            };
            labelFont.color = "none" === opt.backgroundColor && "#ffffff" === (0, _utils.normalizeEnum)(labelFont.color) && "inside" !== opt.position ? defaultColor : labelFont.color;
            return {
                alignment: opt.alignment,
                format: opt.format,
                argumentFormat: opt.argumentFormat,
                customizeText: (0, _type.isFunction)(opt.customizeText) ? opt.customizeText : void 0,
                attributes: {
                    font: labelFont
                },
                visible: 0 !== labelFont.size ? opt.visible : false,
                showForZeroValues: opt.showForZeroValues,
                horizontalOffset: opt.horizontalOffset,
                verticalOffset: opt.verticalOffset,
                radialOffset: opt.radialOffset,
                background: backgroundAttr,
                position: opt.position,
                connector: connectorAttr,
                rotationAngle: opt.rotationAngle,
                wordWrap: opt.wordWrap,
                textOverflow: opt.textOverflow,
                cssClass: opt.cssClass
            }
        }

        function setPointHoverState(point, legendCallback) {
            point.fullState |= HOVER_STATE;
            point.applyView(legendCallback)
        }

        function releasePointHoverState(point, legendCallback) {
            point.fullState &= ~HOVER_STATE;
            point.applyView(legendCallback);
            point.releaseHoverState()
        }

        function setPointSelectedState(point, legendCallback) {
            point.fullState |= SELECTED_STATE;
            point.applyView(legendCallback)
        }

        function releasePointSelectedState(point, legendCallback) {
            point.fullState &= ~SELECTED_STATE;
            point.applyView(legendCallback)
        }

        function mergePointOptionsCore(base, extra) {
            var options = (0, _extend2.extend)({}, base, extra);
            options.border = (0, _extend2.extend)({}, base && base.border, extra && extra.border);
            return options
        }

        function mergePointOptions(base, extra) {
            var options = mergePointOptionsCore(base, extra);
            options.image = (0, _extend2.extend)(true, {}, base.image, extra.image);
            options.selectionStyle = mergePointOptionsCore(base.selectionStyle, extra.selectionStyle);
            options.hoverStyle = mergePointOptionsCore(base.hoverStyle, extra.hoverStyle);
            return options
        }

        function Series(settings, options) {
            var that = this;
            that.fullState = 0;
            that._extGroups = settings;
            that._renderer = settings.renderer;
            that._group = settings.renderer.g().attr({
                "class": "dxc-series"
            });
            that._eventTrigger = settings.eventTrigger;
            that._eventPipe = settings.eventPipe;
            that._incidentOccurred = settings.incidentOccurred;
            that._legendCallback = _common.noop;
            that.updateOptions(options, settings)
        }

        function getData(pointData) {
            return pointData.data
        }

        function getValueChecker(axisType, axis) {
            if (!axis || "logarithmic" !== axisType || false !== axis.getOptions().allowNegatives) {
                return function() {
                    return true
                }
            } else {
                return function(value) {
                    return value > 0
                }
            }
        }
        Series.prototype = {
            constructor: Series,
            _createLegendState: _common.noop,
            getLegendStyles: function() {
                return this._styles.legendStyles
            },
            _createStyles: function(options) {
                var that = this;
                var mainSeriesColor = options.mainSeriesColor;
                that._styles = {
                    normal: that._parseStyle(options, mainSeriesColor, mainSeriesColor),
                    hover: that._parseStyle(options.hoverStyle || {}, mainSeriesColor, mainSeriesColor),
                    selection: that._parseStyle(options.selectionStyle || {}, mainSeriesColor, mainSeriesColor),
                    legendStyles: {
                        normal: that._createLegendState(options, mainSeriesColor),
                        hover: that._createLegendState(options.hoverStyle || {}, mainSeriesColor),
                        selection: that._createLegendState(options.selectionStyle || {}, mainSeriesColor)
                    }
                }
            },
            setClippingParams: function(baseId, wideId, forceClipping) {
                var clipLabels = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : true;
                this._paneClipRectID = baseId;
                this._widePaneClipRectID = wideId;
                this._forceClipping = forceClipping;
                this._clipLabels = clipLabels
            },
            applyClip: function() {
                this._group.attr({
                    "clip-path": this._paneClipRectID
                })
            },
            resetClip: function() {
                this._group.attr({
                    "clip-path": null
                })
            },
            getTagField: function() {
                return this._options.tagField || "tag"
            },
            getValueFields: _common.noop,
            getSizeField: _common.noop,
            getArgumentField: _common.noop,
            getPoints: function() {
                return this._points
            },
            getPointsInViewPort: function() {
                return _range_data_calculator.default.getPointsInViewPort(this)
            },
            _createPoint: function(data, index, oldPoint) {
                data.index = index;
                var that = this;
                var pointsByArgument = that.pointsByArgument;
                var options = that._getCreatingPointOptions(data);
                var arg = data.argument.valueOf();
                var point = oldPoint;
                if (point) {
                    point.update(data, options)
                } else {
                    point = new _base_point.Point(that, data, options);
                    if (that.isSelected() && includePointsMode(that.lastSelectionMode)) {
                        point.setView(SELECTION)
                    }
                }
                var pointByArgument = pointsByArgument[arg];
                if (pointByArgument) {
                    pointByArgument.push(point)
                } else {
                    pointsByArgument[arg] = [point]
                }
                if (point.hasValue()) {
                    that.customizePoint(point, data)
                }
                return point
            },
            getRangeData: function() {
                return this._visible ? this._getRangeData() : getEmptyBusinessRange()
            },
            getArgumentRange: function() {
                return this._visible ? _range_data_calculator.default.getArgumentRange(this) : getEmptyBusinessRange()
            },
            getViewport: function() {
                return _range_data_calculator.default.getViewport(this)
            },
            _deleteGroup: function(groupName) {
                var group = this[groupName];
                if (group) {
                    group.dispose();
                    this[groupName] = null
                }
            },
            updateOptions: function(newOptions, settings) {
                var that = this;
                var widgetType = newOptions.widgetType;
                var oldType = that.type;
                var newType = newOptions.type;
                that.type = newType && (0, _utils.normalizeEnum)(newType.toString());
                if (!that._checkType(widgetType) || that._checkPolarBarType(widgetType, newOptions)) {
                    that.dispose();
                    that.isUpdated = false;
                    return
                }
                if (oldType !== that.type) {
                    that._firstDrawing = true;
                    that._resetType(oldType, widgetType);
                    that._setType(that.type, widgetType)
                } else {
                    that._defineDrawingState()
                }
                that._options = newOptions;
                that._pointOptions = null;
                that.name = newOptions.name;
                that.pane = newOptions.pane;
                that.tag = newOptions.tag;
                if (settings) {
                    that._seriesModes = settings.commonSeriesModes || that._seriesModes;
                    that._valueAxis = settings.valueAxis || that._valueAxis;
                    that.axis = that._valueAxis && that._valueAxis.name;
                    that._argumentAxis = settings.argumentAxis || that._argumentAxis
                }
                that._createStyles(newOptions);
                that._stackName = null;
                that._updateOptions(newOptions);
                that._visible = newOptions.visible;
                that.isUpdated = true;
                that.stack = newOptions.stack;
                that.barOverlapGroup = newOptions.barOverlapGroup;
                that._createGroups();
                that._processEmptyValue = newOptions.ignoreEmptyPoints ? function(x) {
                    return null === x ? void 0 : x
                } : function(x) {
                    return x
                }
            },
            _defineDrawingState: function() {
                this._firstDrawing = true
            },
            _disposePoints: function(points) {
                (0, _iterator.each)(points || [], function(_, p) {
                    p.dispose()
                })
            },
            updateDataType: function(settings) {
                var that = this;
                that.argumentType = settings.argumentType;
                that.valueType = settings.valueType;
                that.argumentAxisType = settings.argumentAxisType;
                that.valueAxisType = settings.valueAxisType;
                that.showZero = settings.showZero;
                this._argumentChecker = getValueChecker(settings.argumentAxisType, that.getArgumentAxis());
                this._valueChecker = getValueChecker(settings.valueAxisType, that.getValueAxis());
                return that
            },
            _argumentChecker: function() {
                return true
            },
            _valueChecker: function() {
                return true
            },
            getOptions: function() {
                return this._options
            },
            _getOldPoint: function(data, oldPointsByArgument, index) {
                var arg = data.argument && data.argument.valueOf();
                var point = (oldPointsByArgument[arg] || [])[0];
                if (point) {
                    oldPointsByArgument[arg].splice(0, 1)
                }
                return point
            },
            updateData: function(data) {
                var that = this;
                var options = that._options;
                var nameField = options.nameField;
                data = data || [];
                if (data.length) {
                    that._canRenderCompleteHandle = true
                }
                var dataSelector = this._getPointDataSelector();
                var itemsWithoutArgument = 0;
                that._data = data.reduce(function(data, dataItem, index) {
                    var pointDataItem = dataSelector(dataItem);
                    if ((0, _type.isDefined)(pointDataItem.argument)) {
                        if (!nameField || dataItem[nameField] === options.nameFieldValue) {
                            pointDataItem.index = index;
                            data.push(pointDataItem)
                        }
                    } else {
                        itemsWithoutArgument++
                    }
                    return data
                }, []);
                if (itemsWithoutArgument && itemsWithoutArgument === data.length) {
                    that._incidentOccurred("W2002", [that.name, that.getArgumentField()])
                }
                that._endUpdateData()
            },
            _getData: function() {
                var data = this._data || [];
                if (this.useAggregation()) {
                    data = this._resample(this.getArgumentAxis().getAggregationInfo(this._useAllAggregatedPoints, this.argumentAxisType !== DISCRETE ? this.getArgumentRange() : {}), data)
                }
                return data
            },
            useAggregation: function() {
                var aggregation = this.getOptions().aggregation;
                return aggregation && aggregation.enabled
            },
            autoHidePointMarkersEnabled: _common.noop,
            usePointsToDefineAutoHiding: _common.noop,
            createPoints: function(useAllAggregatedPoints) {
                this._normalizeUsingAllAggregatedPoints(useAllAggregatedPoints);
                this._createPoints()
            },
            _normalizeUsingAllAggregatedPoints: function(useAllAggregatedPoints) {
                this._useAllAggregatedPoints = this.useAggregation() && (this.argumentAxisType === DISCRETE || (this._data || []).length > 1 && !!useAllAggregatedPoints)
            },
            _createPoints: function() {
                var that = this;
                var oldPointsByArgument = that.pointsByArgument || {};
                var data = that._getData();
                that.pointsByArgument = {};
                that._calculateErrorBars(data);
                var skippedFields = {};
                var points = data.reduce(function(points, pointDataItem) {
                    if (that._checkData(pointDataItem, skippedFields)) {
                        var pointIndex = points.length;
                        var oldPoint = that._getOldPoint(pointDataItem, oldPointsByArgument, pointIndex);
                        var point = that._createPoint(pointDataItem, pointIndex, oldPoint);
                        points.push(point)
                    }
                    return points
                }, []);
                for (var field in skippedFields) {
                    if (skippedFields[field] === data.length) {
                        that._incidentOccurred("W2002", [that.name, field])
                    }
                }
                Object.keys(oldPointsByArgument).forEach(function(key) {
                    return that._disposePoints(oldPointsByArgument[key])
                });
                that._points = points
            },
            _removeOldSegments: function() {
                var that = this;
                var startIndex = that._segments.length;
                (0, _iterator.each)(that._graphics.splice(startIndex, that._graphics.length) || [], function(_, elem) {
                    that._removeElement(elem)
                });
                if (that._trackers) {
                    (0, _iterator.each)(that._trackers.splice(startIndex, that._trackers.length) || [], function(_, elem) {
                        elem.remove()
                    })
                }
            },
            _drawElements: function(animationEnabled, firstDrawing, translateAllPoints) {
                var that = this;
                var points = that._points || [];
                var closeSegment = points[0] && points[0].hasValue() && that._options.closed;
                var groupForPoint = {
                    markers: that._markersGroup,
                    errorBars: that._errorBarGroup
                };
                that._drawnPoints = [];
                that._graphics = that._graphics || [];
                that._segments = [];
                var segments = points.reduce(function(segments, p) {
                    var segment = segments[segments.length - 1];
                    if (!p.translated || translateAllPoints) {
                        p.translate();
                        !translateAllPoints && p.setDefaultCoords()
                    }
                    if (p.hasValue() && p.hasCoords()) {
                        translateAllPoints && that._drawPoint({
                            point: p,
                            groups: groupForPoint,
                            hasAnimation: animationEnabled,
                            firstDrawing: firstDrawing
                        });
                        segment.push(p)
                    } else {
                        if (!p.hasValue()) {
                            segment.length && segments.push([])
                        } else {
                            p.setInvisibility()
                        }
                    }
                    return segments
                }, [
                    []
                ]);
                segments.forEach(function(segment, index) {
                    if (segment.length) {
                        that._drawSegment(segment, animationEnabled, index, closeSegment && index === this.length - 1)
                    }
                }, segments);
                that._firstDrawing = !points.length;
                that._removeOldSegments();
                animationEnabled && that._animate(firstDrawing)
            },
            draw: function(animationEnabled, hideLayoutLabels, legendCallback) {
                var that = this;
                var firstDrawing = that._firstDrawing;
                that._legendCallback = legendCallback || that._legendCallback;
                if (!that._visible) {
                    animationEnabled = false;
                    that._group.remove();
                    return
                }
                that._appendInGroup();
                that._applyVisibleArea();
                that._setGroupsSettings(animationEnabled, firstDrawing);
                !firstDrawing && !that._resetApplyingAnimation && that._drawElements(false, firstDrawing, false);
                that._drawElements(animationEnabled, firstDrawing, true);
                hideLayoutLabels && that.hideLabels();
                if (that.isSelected()) {
                    that._changeStyle(that.lastSelectionMode, void 0, true)
                } else {
                    if (that.isHovered()) {
                        that._changeStyle(that.lastHoverMode, void 0, true)
                    } else {
                        that._applyStyle(that._styles.normal)
                    }
                }
                that._resetApplyingAnimation = false
            },
            _setLabelGroupSettings: function(animationEnabled) {
                var settings = {
                    "class": "dxc-labels",
                    "pointer-events": "none"
                };
                this._clipLabels && this._applyElementsClipRect(settings);
                this._applyClearingSettings(settings);
                animationEnabled && (settings.opacity = .001);
                this._labelsGroup.attr(settings).append(this._extGroups.labelsGroup)
            },
            _checkType: function(widgetType) {
                return !!seriesNS.mixins[widgetType][this.type]
            },
            _checkPolarBarType: function(widgetType, options) {
                return "polar" === widgetType && options.spiderWidget && this.type.indexOf("bar") !== -1
            },
            _resetType: function(seriesType, widgetType) {
                var methodName;
                var methods;
                if (seriesType) {
                    methods = seriesNS.mixins[widgetType][seriesType];
                    for (methodName in methods) {
                        delete this[methodName]
                    }
                }
            },
            _setType: function(seriesType, widgetType) {
                var methodName;
                var methods = seriesNS.mixins[widgetType][seriesType];
                for (methodName in methods) {
                    this[methodName] = methods[methodName]
                }
            },
            _setPointsView: function(view, target) {
                this.getPoints().forEach(function(point) {
                    if (target !== point) {
                        point.setView(view)
                    }
                })
            },
            _resetPointsView: function(view, target) {
                this.getPoints().forEach(function(point) {
                    if (target !== point) {
                        point.resetView(view)
                    }
                })
            },
            _resetNearestPoint: function() {
                var that = this;
                that._nearestPoint && null !== that._nearestPoint.series && that._nearestPoint.resetView(HOVER);
                that._nearestPoint = null
            },
            _setSelectedState: function(mode) {
                var that = this;
                that.lastSelectionMode = (0, _utils.normalizeEnum)(mode || that._options.selectionMode);
                that.fullState = that.fullState | SELECTED_STATE;
                that._resetNearestPoint();
                that._changeStyle(that.lastSelectionMode);
                if (that.lastSelectionMode !== NONE_MODE && that.isHovered() && includePointsMode(that.lastHoverMode)) {
                    that._resetPointsView(HOVER)
                }
            },
            _releaseSelectedState: function() {
                var that = this;
                that.fullState = that.fullState & ~SELECTED_STATE;
                that._changeStyle(that.lastSelectionMode, SELECTION);
                if (that.lastSelectionMode !== NONE_MODE && that.isHovered() && includePointsMode(that.lastHoverMode)) {
                    that._setPointsView(HOVER)
                }
            },
            isFullStackedSeries: function() {
                return 0 === this.type.indexOf("fullstacked")
            },
            isStackedSeries: function() {
                return 0 === this.type.indexOf("stacked")
            },
            resetApplyingAnimation: function(isFirstDrawing) {
                this._resetApplyingAnimation = true;
                if (isFirstDrawing) {
                    this._firstDrawing = true
                }
            },
            isFinancialSeries: function() {
                return "stock" === this.type || "candlestick" === this.type
            },
            _canChangeView: function() {
                return !this.isSelected() && (0, _utils.normalizeEnum)(this._options.hoverMode) !== NONE_MODE
            },
            _changeStyle: function(mode, resetView, skipPoints) {
                var that = this;
                var state = that.fullState;
                var styles = [NORMAL, HOVER, SELECTION, SELECTION];
                if ("none" === that.lastHoverMode) {
                    state &= ~HOVER_STATE
                }
                if ("none" === that.lastSelectionMode) {
                    state &= ~SELECTED_STATE
                }
                if (includePointsMode(mode) && !skipPoints) {
                    if (!resetView) {
                        that._setPointsView(styles[state])
                    } else {
                        that._resetPointsView(resetView)
                    }
                }
                that._legendCallback([RESET_ITEM, APPLY_HOVER, APPLY_SELECTED, APPLY_SELECTED][state]);
                that._applyStyle(that._styles[styles[state]])
            },
            updateHover: function(x, y) {
                var that = this;
                var currentNearestPoint = that._nearestPoint;
                var point = that.isHovered() && that.lastHoverMode === NEAREST_POINT && that.getNeighborPoint(x, y);
                if (point !== currentNearestPoint && !(that.isSelected() && that.lastSelectionMode !== NONE_MODE)) {
                    that._resetNearestPoint();
                    if (point) {
                        point.setView(HOVER);
                        that._nearestPoint = point
                    }
                }
            },
            _getMainAxisName: function() {
                return this._options.rotated ? "X" : "Y"
            },
            areLabelsVisible: function() {
                return !(0, _type.isDefined)(this._options.maxLabelCount) || this._points.length <= this._options.maxLabelCount
            },
            getLabelVisibility: function() {
                return this.areLabelsVisible() && this._options.label && this._options.label.visible
            },
            customizePoint: function customizePoint(point, pointData) {
                var that = this;
                var options = that._options;
                var customizePoint = options.customizePoint;
                var customizeObject;
                var pointOptions;
                var customLabelOptions;
                var customOptions;
                var customizeLabel = options.customizeLabel;
                var useLabelCustomOptions;
                var usePointCustomOptions;
                if (customizeLabel && customizeLabel.call) {
                    customizeObject = (0, _extend2.extend)({
                        seriesName: that.name
                    }, pointData);
                    customizeObject.series = that;
                    customLabelOptions = customizeLabel.call(customizeObject, customizeObject);
                    useLabelCustomOptions = customLabelOptions && !(0, _type.isEmptyObject)(customLabelOptions);
                    customLabelOptions = useLabelCustomOptions ? (0, _extend2.extend)(true, {}, options.label, customLabelOptions) : null
                }
                if (customizePoint && customizePoint.call) {
                    customizeObject = customizeObject || (0, _extend2.extend)({
                        seriesName: that.name
                    }, pointData);
                    customizeObject.series = that;
                    customOptions = customizePoint.call(customizeObject, customizeObject);
                    usePointCustomOptions = customOptions && !(0, _type.isEmptyObject)(customOptions)
                }
                if (useLabelCustomOptions || usePointCustomOptions) {
                    pointOptions = that._parsePointOptions(that._preparePointOptions(customOptions), customLabelOptions || options.label, pointData, point);
                    pointOptions.styles.useLabelCustomOptions = useLabelCustomOptions;
                    pointOptions.styles.usePointCustomOptions = usePointCustomOptions;
                    point.updateOptions(pointOptions)
                }
            },
            show: function() {
                if (!this._visible) {
                    this._changeVisibility(true)
                }
            },
            hide: function() {
                if (this._visible) {
                    this._changeVisibility(false)
                }
            },
            _changeVisibility: function(visibility) {
                var that = this;
                that._visible = that._options.visible = visibility;
                that._updatePointsVisibility();
                that.hidePointTooltip();
                that._options.visibilityChanged(that)
            },
            _updatePointsVisibility: _common.noop,
            hideLabels: function() {
                (0, _iterator.each)(this._points, function(_, point) {
                    point._label.draw(false)
                })
            },
            _parsePointOptions: function(pointOptions, labelOptions, data, point) {
                var that = this;
                var options = that._options;
                var styles = that._createPointStyles(pointOptions, data, point);
                var parsedOptions = (0, _extend2.extend)({}, pointOptions, {
                    type: options.type,
                    rotated: options.rotated,
                    styles: styles,
                    widgetType: options.widgetType,
                    visibilityChanged: options.visibilityChanged
                });
                parsedOptions.label = getLabelOptions(labelOptions, styles.normal.fill);
                if (that.areErrorBarsVisible()) {
                    parsedOptions.errorBars = options.valueErrorBar
                }
                return parsedOptions
            },
            _preparePointOptions: function(customOptions) {
                var pointOptions = this._getOptionsForPoint();
                return customOptions ? mergePointOptions(pointOptions, customOptions) : pointOptions
            },
            _getMarkerGroupOptions: function() {
                return (0, _extend2.extend)(false, {}, this._getOptionsForPoint(), {
                    hoverStyle: {},
                    selectionStyle: {}
                })
            },
            _getAggregationMethod: function(isDiscrete, aggregateByCategory) {
                var options = this.getOptions().aggregation;
                var method = (0, _utils.normalizeEnum)(options.method);
                var customAggregator = "custom" === method && options.calculate;
                var aggregator;
                if (isDiscrete && !aggregateByCategory) {
                    aggregator = function(_ref) {
                        var data = _ref.data;
                        return data[0]
                    }
                } else {
                    aggregator = this._aggregators[method] || this._aggregators[this._defaultAggregator]
                }
                return customAggregator || aggregator
            },
            _resample: function(_ref2, data) {
                var interval = _ref2.interval,
                    ticks = _ref2.ticks,
                    aggregateByCategory = _ref2.aggregateByCategory;
                var that = this;
                var isDiscrete = that.argumentAxisType === DISCRETE || that.valueAxisType === DISCRETE;
                var dataIndex = 0;
                var dataSelector = this._getPointDataSelector();
                var options = that.getOptions();
                var addAggregatedData = function(target, data, aggregationInfo) {
                    if (!data) {
                        return
                    }
                    var processData = function(d) {
                        var pointData = d && dataSelector(d, options);
                        if (pointData && that._checkData(pointData)) {
                            pointData.aggregationInfo = aggregationInfo;
                            target.push(pointData)
                        }
                    };
                    if (Array.isArray(data)) {
                        data.forEach(processData)
                    } else {
                        processData(data)
                    }
                };
                var aggregationMethod = this._getAggregationMethod(isDiscrete, aggregateByCategory);
                if (isDiscrete) {
                    if (aggregateByCategory) {
                        var categories = this.getArgumentAxis().getTranslator().getBusinessRange().categories;
                        var groups = categories.reduce(function(g, category) {
                            g[category.valueOf()] = [];
                            return g
                        }, {});
                        data.forEach(function(dataItem) {
                            groups[dataItem.argument.valueOf()].push(dataItem)
                        });
                        return categories.reduce(function(result, c) {
                            addAggregatedData(result, aggregationMethod({
                                aggregationInterval: null,
                                intervalStart: c,
                                intervalEnd: c,
                                data: groups[c.valueOf()].map(getData)
                            }, that));
                            return result
                        }, [])
                    } else {
                        return data.reduce(function(result, dataItem, index, data) {
                            result[1].push(dataItem);
                            if (index === data.length - 1 || (index + 1) % interval === 0) {
                                var dataInInterval = result[1];
                                var aggregationInfo = {
                                    aggregationInterval: interval,
                                    data: dataInInterval.map(getData)
                                };
                                addAggregatedData(result[0], aggregationMethod(aggregationInfo, that));
                                result[1] = []
                            }
                            return result
                        }, [
                            [],
                            []
                        ])[0]
                    }
                }
                var aggregatedData = [];
                for (var i = 1; i < ticks.length; i++) {
                    var intervalEnd = ticks[i];
                    var intervalStart = ticks[i - 1];
                    var dataInInterval = [];
                    while (data[dataIndex] && data[dataIndex].argument < intervalEnd) {
                        if (data[dataIndex].argument >= intervalStart) {
                            dataInInterval.push(data[dataIndex])
                        }
                        dataIndex++
                    }
                    var aggregationInfo = {
                        intervalStart: intervalStart,
                        intervalEnd: intervalEnd,
                        aggregationInterval: interval,
                        data: dataInInterval.map(getData)
                    };
                    addAggregatedData(aggregatedData, aggregationMethod(aggregationInfo, that), aggregationInfo)
                }
                that._endUpdateData();
                return aggregatedData
            },
            canRenderCompleteHandle: function() {
                var result = this._canRenderCompleteHandle;
                delete this._canRenderCompleteHandle;
                return !!result
            },
            isHovered: function() {
                return !!(1 & this.fullState)
            },
            isSelected: function() {
                return !!(2 & this.fullState)
            },
            isVisible: function() {
                return this._visible
            },
            getAllPoints: function() {
                this._createAllAggregatedPoints();
                return (this._points || []).slice()
            },
            getPointByPos: function(pos) {
                this._createAllAggregatedPoints();
                return (this._points || [])[pos]
            },
            getVisiblePoints: function() {
                return (this._drawnPoints || []).slice()
            },
            selectPoint: function(point) {
                if (!point.isSelected()) {
                    setPointSelectedState(point, this._legendCallback);
                    this._eventPipe({
                        action: POINT_SELECT,
                        target: point
                    });
                    this._eventTrigger(POINT_SELECTION_CHANGED, {
                        target: point
                    })
                }
            },
            deselectPoint: function(point) {
                if (point.isSelected()) {
                    releasePointSelectedState(point, this._legendCallback);
                    this._eventPipe({
                        action: POINT_DESELECT,
                        target: point
                    });
                    this._eventTrigger(POINT_SELECTION_CHANGED, {
                        target: point
                    })
                }
            },
            hover: function(mode) {
                var that = this;
                var eventTrigger = that._eventTrigger;
                if (that.isHovered()) {
                    return
                }
                that.lastHoverMode = (0, _utils.normalizeEnum)(mode || that._options.hoverMode);
                that.fullState = that.fullState | HOVER_STATE;
                that._changeStyle(that.lastHoverMode, void 0, that.isSelected() && that.lastSelectionMode !== NONE_MODE);
                eventTrigger(SERIES_HOVER_CHANGED, {
                    target: that
                })
            },
            clearHover: function() {
                var that = this;
                var eventTrigger = that._eventTrigger;
                if (!that.isHovered()) {
                    return
                }
                that._resetNearestPoint();
                that.fullState = that.fullState & ~HOVER_STATE;
                that._changeStyle(that.lastHoverMode, HOVER, that.isSelected() && that.lastSelectionMode !== NONE_MODE);
                eventTrigger(SERIES_HOVER_CHANGED, {
                    target: that
                })
            },
            hoverPoint: function(point) {
                var that = this;
                if (!point.isHovered()) {
                    point.clearHover();
                    setPointHoverState(point, that._legendCallback);
                    that._canChangeView() && that._applyStyle(that._styles.hover);
                    that._eventPipe({
                        action: POINT_HOVER,
                        target: point
                    });
                    that._eventTrigger(POINT_HOVER_CHANGED, {
                        target: point
                    })
                }
            },
            clearPointHover: function() {
                var that = this;
                that.getPoints().some(function(currentPoint) {
                    if (currentPoint.isHovered()) {
                        releasePointHoverState(currentPoint, that._legendCallback);
                        that._canChangeView() && that._applyStyle(that._styles.normal);
                        that._eventPipe({
                            action: CLEAR_POINT_HOVER,
                            target: currentPoint
                        });
                        that._eventTrigger(POINT_HOVER_CHANGED, {
                            target: currentPoint
                        });
                        return true
                    }
                    return false
                })
            },
            showPointTooltip: function(point) {
                triggerEvent(this._extGroups.seriesGroup, "showpointtooltip", point)
            },
            hidePointTooltip: function(point) {
                triggerEvent(this._extGroups.seriesGroup, "hidepointtooltip", point)
            },
            select: function() {
                var that = this;
                if (!that.isSelected()) {
                    that._setSelectedState(that._options.selectionMode);
                    that._eventPipe({
                        action: SERIES_SELECT,
                        target: that
                    });
                    that._group.toForeground();
                    that._eventTrigger(SERIES_SELECTION_CHANGED, {
                        target: that
                    })
                }
            },
            clearSelection: function() {
                var that = this;
                if (that.isSelected()) {
                    that._releaseSelectedState();
                    that._eventTrigger(SERIES_SELECTION_CHANGED, {
                        target: that
                    })
                }
            },
            getPointsByArg: function(arg, skipPointsCreation) {
                var that = this;
                var argValue = arg.valueOf();
                var points = that.pointsByArgument[argValue];
                if (!points && !skipPointsCreation && that._createAllAggregatedPoints()) {
                    points = that.pointsByArgument[argValue]
                }
                return points || []
            },
            _createAllAggregatedPoints: function() {
                if (this.useAggregation() && !this._useAllAggregatedPoints) {
                    this.createPoints(true);
                    return true
                }
                return false
            },
            getPointsByKeys: function(arg) {
                return this.getPointsByArg(arg)
            },
            notify: function(data) {
                var that = this;
                var action = data.action;
                var seriesModes = that._seriesModes;
                var target = data.target;
                var targetOptions = target.getOptions();
                var pointHoverMode = (0, _utils.normalizeEnum)(targetOptions.hoverMode);
                var selectionModeOfPoint = (0, _utils.normalizeEnum)(targetOptions.selectionMode);
                if (action === POINT_HOVER) {
                    that._hoverPointHandler(target, pointHoverMode, data.notifyLegend)
                } else {
                    if (action === CLEAR_POINT_HOVER) {
                        that._clearPointHoverHandler(target, pointHoverMode, data.notifyLegend)
                    } else {
                        if (action === SERIES_SELECT) {
                            target !== that && "single" === seriesModes.seriesSelectionMode && that.clearSelection()
                        } else {
                            if (action === POINT_SELECT) {
                                if ("single" === seriesModes.pointSelectionMode) {
                                    that.getPoints().some(function(currentPoint) {
                                        if (currentPoint !== target && currentPoint.isSelected()) {
                                            that.deselectPoint(currentPoint);
                                            return true
                                        }
                                        return false
                                    })
                                }
                                that._selectPointHandler(target, selectionModeOfPoint)
                            } else {
                                if (action === POINT_DESELECT) {
                                    that._deselectPointHandler(target, selectionModeOfPoint)
                                }
                            }
                        }
                    }
                }
            },
            _selectPointHandler: function(target, mode) {
                var that = this;
                if (mode === ALL_SERIES_POINTS) {
                    target.series === that && that._setPointsView(SELECTION, target)
                } else {
                    if (mode === ALL_ARGUMENT_POINTS) {
                        that.getPointsByKeys(target.argument, target.argumentIndex).forEach(function(currentPoint) {
                            currentPoint !== target && currentPoint.setView(SELECTION)
                        })
                    }
                }
            },
            _deselectPointHandler: function(target, mode) {
                if (mode === ALL_SERIES_POINTS) {
                    target.series === this && this._resetPointsView(SELECTION, target)
                } else {
                    if (mode === ALL_ARGUMENT_POINTS) {
                        this.getPointsByKeys(target.argument, target.argumentIndex).forEach(function(currentPoint) {
                            currentPoint !== target && currentPoint.resetView(SELECTION)
                        })
                    }
                }
            },
            _hoverPointHandler: function(target, mode, notifyLegend) {
                var that = this;
                if (target.series !== that && mode === ALL_ARGUMENT_POINTS) {
                    that.getPointsByKeys(target.argument, target.argumentIndex).forEach(function(currentPoint) {
                        currentPoint.setView(HOVER)
                    });
                    notifyLegend && that._legendCallback(target)
                } else {
                    if (mode === ALL_SERIES_POINTS && target.series === that) {
                        that._setPointsView(HOVER, target)
                    }
                }
            },
            _clearPointHoverHandler: function(target, mode, notifyLegend) {
                var that = this;
                if (mode === ALL_ARGUMENT_POINTS) {
                    target.series !== that && that.getPointsByKeys(target.argument, target.argumentIndex).forEach(function(currentPoint) {
                        currentPoint.resetView(HOVER)
                    });
                    notifyLegend && that._legendCallback(target)
                } else {
                    if (mode === ALL_SERIES_POINTS && target.series === that) {
                        that._resetPointsView(HOVER, target)
                    }
                }
            },
            _deletePoints: function() {
                var that = this;
                that._disposePoints(that._points);
                that._points = that._drawnPoints = null
            },
            _deleteTrackers: function() {
                var that = this;
                (0, _iterator.each)(that._trackers || [], function(_, tracker) {
                    tracker.remove()
                });
                that._trackersGroup && that._trackersGroup.dispose();
                that._trackers = that._trackersGroup = null
            },
            dispose: function() {
                var that = this;
                that._deletePoints();
                that._group.dispose();
                that._labelsGroup && that._labelsGroup.dispose();
                that._errorBarGroup && that._errorBarGroup.dispose();
                that._deleteTrackers();
                that._group = that._extGroups = that._markersGroup = that._elementsGroup = that._bordersGroup = that._labelsGroup = that._errorBarGroup = that._graphics = that._rangeData = that._renderer = that._styles = that._options = that._pointOptions = that._drawnPoints = that.pointsByArgument = that._segments = that._prevSeries = null
            },
            correctPosition: _common.noop,
            drawTrackers: _common.noop,
            getNeighborPoint: _common.noop,
            areErrorBarsVisible: _common.noop,
            getMarginOptions: function() {
                return this._patchMarginOptions({
                    percentStick: this.isFullStackedSeries()
                })
            },
            getColor: function() {
                return this.getLegendStyles().normal.fill
            },
            getOpacity: function() {
                return this._options.opacity
            },
            getStackName: function() {
                return this._stackName
            },
            getBarOverlapGroup: function() {
                return this._options.barOverlapGroup
            },
            getPointByCoord: function(x, y) {
                var point = this.getNeighborPoint(x, y);
                return null !== point && void 0 !== point && point.coordsIn(x, y) ? point : null
            },
            getValueAxis: function() {
                return this._valueAxis
            },
            getArgumentAxis: function() {
                return this._argumentAxis
            },
            getMarkersGroup: function() {
                return this._markersGroup
            },
            getRenderer: function() {
                return this._renderer
            }
        };
        var mixins = seriesNS.mixins;
        exports.mixins = mixins
    },
    /*!*************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/series/points/label.js ***!
      \*************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.Label = Label;
        var _format_helper = _interopRequireDefault(__webpack_require__( /*! ../../../format_helper */ 71));
        var _utils = __webpack_require__( /*! ../../core/utils */ 14);
        var _iterator = __webpack_require__( /*! ../../../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../../../core/utils/extend */ 0);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _format = _format_helper.default.format;
        var _math = Math;
        var _round = _math.round;
        var _floor = _math.floor;
        var _abs = _math.abs;
        var CONNECTOR_LENGTH = 12;
        var LABEL_BACKGROUND_PADDING_X = 8;
        var LABEL_BACKGROUND_PADDING_Y = 4;

        function getClosestCoord(point, coords) {
            var closestDistance = 1 / 0;
            var closestCoord;
            (0, _iterator.each)(coords, function(_, coord) {
                var x = point[0] - coord[0];
                var y = point[1] - coord[1];
                var distance = x * x + y * y;
                if (distance < closestDistance) {
                    closestDistance = distance;
                    closestCoord = coord
                }
            });
            return [_floor(closestCoord[0]), _floor(closestCoord[1])]
        }

        function getCrossCoord(rect, coord, indexOffset) {
            return (coord - rect[0 + indexOffset]) / (rect[2 + indexOffset] - rect[0 + indexOffset]) * (rect[3 - indexOffset] - rect[1 - indexOffset]) + rect[1 - indexOffset]
        }
        var barPointStrategy = {
            isLabelInside: function(labelPoint, figure) {
                var xc = labelPoint.x + labelPoint.width / 2;
                var yc = labelPoint.y + labelPoint.height / 2;
                return figure.x <= xc && xc <= figure.x + figure.width && figure.y <= yc && yc <= figure.y + figure.height
            },
            prepareLabelPoints: function(bBox, rotatedBBox, isHorizontal, angle, figureCenter) {
                var x1 = rotatedBBox.x;
                var xc = x1 + rotatedBBox.width / 2;
                var x2 = x1 + rotatedBBox.width - 1;
                var y1 = rotatedBBox.y;
                var yc = y1 + rotatedBBox.height / 2;
                var y2 = y1 + rotatedBBox.height - 1;
                var labelPoints;
                var isRectangular = _abs(angle) % 90 === 0;
                if (figureCenter[0] > x1 && figureCenter[0] < x2) {
                    if (isRectangular) {
                        labelPoints = [
                            [figureCenter[0], _abs(figureCenter[1] - y1) < _abs(figureCenter[1] - y2) ? y1 : y2]
                        ]
                    } else {
                        labelPoints = [
                            [figureCenter[0], getCrossCoord([x1, y1, x2, y2], figureCenter[0], 0)]
                        ]
                    }
                } else {
                    if (figureCenter[1] > y1 && figureCenter[1] < y2) {
                        if (isRectangular) {
                            labelPoints = [
                                [_abs(figureCenter[0] - x1) < _abs(figureCenter[0] - x2) ? x1 : x2, figureCenter[1]]
                            ]
                        } else {
                            labelPoints = [
                                [getCrossCoord([x1, y1, x2, y2], figureCenter[1], 1), figureCenter[1]]
                            ]
                        }
                    } else {
                        if (isRectangular) {
                            labelPoints = [
                                [x1, y1],
                                [isHorizontal ? x1 : xc, isHorizontal ? yc : y1],
                                [x2, y1],
                                [x1, y2],
                                [isHorizontal ? x2 : xc, isHorizontal ? yc : y2],
                                [x2, y2]
                            ]
                        } else {
                            labelPoints = [
                                [xc, yc]
                            ]
                        }
                    }
                }
                return labelPoints
            },
            isHorizontal: function(bBox, figure) {
                return bBox.x > figure.x + figure.width || bBox.x + bBox.width < figure.x
            },
            getFigureCenter: function(figure) {
                return [_floor(figure.x + figure.width / 2), _floor(figure.y + figure.height / 2)]
            },
            findFigurePoint: function(figure, labelPoint) {
                var figureCenter = barPointStrategy.getFigureCenter(figure);
                var point = getClosestCoord(labelPoint, [
                    [figure.x, figureCenter[1]],
                    [figureCenter[0], figure.y + figure.height],
                    [figure.x + figure.width, figureCenter[1]],
                    [figureCenter[0], figure.y]
                ]);
                return point
            },
            adjustPoints: function(points) {
                var lineIsVertical = _abs(points[1] - points[3]) <= 1;
                var lineIsHorizontal = _abs(points[0] - points[2]) <= 1;
                if (lineIsHorizontal) {
                    points[0] = points[2]
                }
                if (lineIsVertical) {
                    points[1] = points[3]
                }
                return points
            }
        };
        var symbolPointStrategy = {
            isLabelInside: function() {
                return false
            },
            prepareLabelPoints: barPointStrategy.prepareLabelPoints,
            isHorizontal: function(bBox, figure) {
                return bBox.x > figure.x + figure.r || bBox.x + bBox.width < figure.x - figure.r
            },
            getFigureCenter: function(figure) {
                return [figure.x, figure.y]
            },
            findFigurePoint: function(figure, labelPoint) {
                var angle = Math.atan2(figure.y - labelPoint[1], labelPoint[0] - figure.x);
                return [_round(figure.x + figure.r * Math.cos(angle)), _round(figure.y - figure.r * Math.sin(angle))]
            },
            adjustPoints: barPointStrategy.adjustPoints
        };
        var piePointStrategy = {
            isLabelInside: function(_0, _1, isOutside) {
                return !isOutside
            },
            prepareLabelPoints: function(bBox, rotatedBBox, isHorizontal, angle) {
                var xl = bBox.x;
                var xr = xl + bBox.width;
                var xc = xl + _round(bBox.width / 2);
                var yt = bBox.y;
                var yb = yt + bBox.height;
                var yc = yt + _round(bBox.height / 2);
                var points = [
                    [
                        [xl, yt],
                        [xr, yt]
                    ],
                    [
                        [xr, yt],
                        [xr, yb]
                    ],
                    [
                        [xr, yb],
                        [xl, yb]
                    ],
                    [
                        [xl, yb],
                        [xl, yt]
                    ]
                ];
                var cosSin = (0, _utils.getCosAndSin)(angle);
                if (0 === angle) {
                    points = isHorizontal ? [
                        [xl, yc],
                        [xr, yc]
                    ] : [
                        [xc, yt],
                        [xc, yb]
                    ]
                } else {
                    points = points.map(function(pair) {
                        return pair.map(function(point) {
                            return [_round((point[0] - xc) * cosSin.cos + (point[1] - yc) * cosSin.sin + xc), _round(-(point[0] - xc) * cosSin.sin + (point[1] - yc) * cosSin.cos + yc)]
                        })
                    }).reduce(function(r, pair) {
                        var point1x = pair[0][0];
                        var point1y = pair[0][1];
                        var point2x = pair[1][0];
                        var point2y = pair[1][1];
                        if (isHorizontal) {
                            if (point1y >= yc && yc >= point2y || point1y <= yc && yc <= point2y) {
                                r.push([(yc - point1y) * (point2x - point1x) / (point2y - point1y) + point1x, yc])
                            }
                        } else {
                            if (point1x >= xc && xc >= point2x || point1x <= xc && xc <= point2x) {
                                r.push([xc, (xc - point1x) * (point2y - point1y) / (point2x - point1x) + point1y])
                            }
                        }
                        return r
                    }, [])
                }
                return points
            },
            isHorizontal: function(bBox, figure) {
                return bBox.x > figure.x || figure.x > bBox.x + bBox.width
            },
            getFigureCenter: symbolPointStrategy.getFigureCenter,
            findFigurePoint: function(figure, labelPoint, isHorizontal) {
                if (!isHorizontal) {
                    return [figure.x, figure.y]
                }
                var labelX = labelPoint[0];
                var x = _round(figure.x + (figure.y - labelPoint[1]) / Math.tan((0, _utils.degreesToRadians)(figure.angle)));
                var points = [figure.x, figure.y, x, labelPoint[1]];
                if (!(figure.x <= x && x <= labelX) && !(labelX <= x && x <= figure.x)) {
                    if (_abs(figure.x - labelX) < CONNECTOR_LENGTH) {
                        points = [figure.x, figure.y]
                    } else {
                        if (figure.x <= labelX) {
                            points[2] = figure.x + CONNECTOR_LENGTH
                        } else {
                            points[2] = figure.x - CONNECTOR_LENGTH
                        }
                    }
                }
                return points
            },
            adjustPoints: function(points) {
                return points
            }
        };

        function selectStrategy(figure) {
            return void 0 !== figure.angle && piePointStrategy || void 0 !== figure.r && symbolPointStrategy || barPointStrategy
        }

        function disposeItem(obj, field) {
            obj[field] && obj[field].dispose();
            obj[field] = null
        }

        function checkBackground(background) {
            return background && (background.fill && "none" !== background.fill || background["stroke-width"] > 0 && background.stroke && "none" !== background.stroke)
        }

        function checkConnector(connector) {
            return connector && connector["stroke-width"] > 0 && connector.stroke && "none" !== connector.stroke
        }

        function formatText(data, options) {
            var format = options.format;
            data.valueText = _format(data.value, format);
            data.argumentText = _format(data.argument, options.argumentFormat);
            if (void 0 !== data.percent) {
                data.percentText = _format(data.percent, {
                    type: "percent",
                    precision: format && format.percentPrecision
                })
            }
            if (void 0 !== data.total) {
                data.totalText = _format(data.total, format)
            }
            if (void 0 !== data.openValue) {
                data.openValueText = _format(data.openValue, format)
            }
            if (void 0 !== data.closeValue) {
                data.closeValueText = _format(data.closeValue, format)
            }
            if (void 0 !== data.lowValue) {
                data.lowValueText = _format(data.lowValue, format)
            }
            if (void 0 !== data.highValue) {
                data.highValueText = _format(data.highValue, format)
            }
            if (void 0 !== data.reductionValue) {
                data.reductionValueText = _format(data.reductionValue, format)
            }
            return options.customizeText ? options.customizeText.call(data, data) : data.valueText
        }

        function Label(renderSettings) {
            this._renderer = renderSettings.renderer;
            this._container = renderSettings.labelsGroup;
            this._point = renderSettings.point;
            this._strategy = renderSettings.strategy;
            this._rowCount = 1
        }
        Label.prototype = {
            constructor: Label,
            setColor: function(color) {
                this._color = color
            },
            setOptions: function(options) {
                this._options = options
            },
            setData: function(data) {
                this._data = data
            },
            setDataField: function(fieldName, fieldValue) {
                this._data = this._data || {};
                this._data[fieldName] = fieldValue
            },
            getData: function() {
                return this._data
            },
            setFigureToDrawConnector: function(figure) {
                this._figure = figure
            },
            dispose: function() {
                var that = this;
                disposeItem(that, "_group");
                that._data = that._options = that._textContent = that._visible = that._insideGroup = that._text = that._background = that._connector = that._figure = null
            },
            _setVisibility: function(value, state) {
                this._group && this._group.attr({
                    visibility: value
                });
                this._visible = state
            },
            isVisible: function() {
                return this._visible
            },
            hide: function(holdInvisible) {
                this._holdVisibility = !!holdInvisible;
                this._hide()
            },
            _hide: function() {
                this._setVisibility("hidden", false)
            },
            show: function(holdVisible) {
                var correctPosition = !this._drawn;
                if (this._point.hasValue()) {
                    this._holdVisibility = !!holdVisible;
                    this._show();
                    correctPosition && this._point.correctLabelPosition(this)
                }
            },
            _show: function() {
                var that = this;
                var renderer = that._renderer;
                var container = that._container;
                var options = that._options || {};
                var text = that._textContent = formatText(that._data, that._options) || null;
                if (text) {
                    if (!that._group) {
                        that._group = renderer.g().append(container);
                        that._insideGroup = renderer.g().append(that._group);
                        that._text = renderer.text("", 0, 0).append(that._insideGroup)
                    }
                    that._text.css(options.attributes ? (0, _utils.patchFontOptions)(options.attributes.font) : {});
                    if (checkBackground(options.background)) {
                        that._background = that._background || renderer.rect().append(that._insideGroup).toBackground();
                        that._background.attr(options.background);
                        that._color && that._background.attr({
                            fill: that._color
                        })
                    } else {
                        disposeItem(that, "_background")
                    }
                    if (checkConnector(options.connector)) {
                        that._connector = that._connector || renderer.path([], "line").sharp().append(that._group).toBackground();
                        that._connector.attr(options.connector);
                        that._color && that._connector.attr({
                            stroke: that._color
                        })
                    } else {
                        disposeItem(that, "_connector")
                    }
                    that._text.attr({
                        text: text,
                        align: options.textAlignment,
                        "class": options.cssClass
                    });
                    that._updateBackground(that._text.getBBox());
                    that._setVisibility("visible", true);
                    that._drawn = true
                } else {
                    that._hide()
                }
            },
            _getLabelVisibility: function(isVisible) {
                return this._holdVisibility ? this.isVisible() : isVisible
            },
            draw: function(isVisible) {
                if (this._getLabelVisibility(isVisible)) {
                    this._show();
                    this._point && this._point.correctLabelPosition(this)
                } else {
                    this._drawn = false;
                    this._hide()
                }
                return this
            },
            _updateBackground: function(bBox) {
                var that = this;
                if (that._background) {
                    bBox.x -= LABEL_BACKGROUND_PADDING_X;
                    bBox.y -= LABEL_BACKGROUND_PADDING_Y;
                    bBox.width += 2 * LABEL_BACKGROUND_PADDING_X;
                    bBox.height += 2 * LABEL_BACKGROUND_PADDING_Y;
                    that._background.attr(bBox)
                }
                that._bBoxWithoutRotation = (0, _extend.extend)({}, bBox);
                var rotationAngle = that._options.rotationAngle || 0;
                that._insideGroup.rotate(rotationAngle, bBox.x + bBox.width / 2, bBox.y + bBox.height / 2);
                bBox = (0, _utils.rotateBBox)(bBox, [bBox.x + bBox.width / 2, bBox.y + bBox.height / 2], -rotationAngle);
                that._bBox = bBox
            },
            getFigureCenter: function() {
                var figure = this._figure;
                var strategy = this._strategy || selectStrategy(figure);
                return strategy.getFigureCenter(figure)
            },
            _getConnectorPoints: function() {
                var that = this;
                var figure = that._figure;
                var options = that._options;
                var strategy = that._strategy || selectStrategy(figure);
                var bBox = that._shiftBBox(that._bBoxWithoutRotation);
                var rotatedBBox = that.getBoundingRect();
                var labelPoint;
                var points = [];
                var isHorizontal;
                if (!strategy.isLabelInside(bBox, figure, "inside" !== options.position)) {
                    isHorizontal = strategy.isHorizontal(bBox, figure);
                    var figureCenter = that.getFigureCenter();
                    points = strategy.prepareLabelPoints(bBox, rotatedBBox, isHorizontal, -options.rotationAngle || 0, figureCenter);
                    labelPoint = getClosestCoord(figureCenter, points);
                    points = strategy.findFigurePoint(figure, labelPoint, isHorizontal);
                    points = points.concat(labelPoint)
                }
                return strategy.adjustPoints(points)
            },
            fit: function(maxWidth) {
                var padding = this._background ? 2 * LABEL_BACKGROUND_PADDING_X : 0;
                var rowCountChanged = false;
                if (this._text) {
                    var result = this._text.setMaxSize(maxWidth - padding, void 0, this._options);
                    var rowCount = result.rowCount;
                    if (0 === rowCount) {
                        rowCount = 1
                    }
                    if (rowCount !== this._rowCount) {
                        rowCountChanged = true;
                        this._rowCount = rowCount
                    }
                    result.textIsEmpty && disposeItem(this, "_background")
                }
                this._updateBackground(this._text.getBBox());
                return rowCountChanged
            },
            resetEllipsis: function() {
                this._text && this._text.restoreText();
                this._updateBackground(this._text.getBBox())
            },
            setTrackerData: function(point) {
                this._text.data({
                    "chart-data-point": point
                });
                this._background && this._background.data({
                    "chart-data-point": point
                })
            },
            hideInsideLabel: function(coords) {
                return this._point.hideInsideLabel(this, coords)
            },
            getPoint: function() {
                return this._point
            },
            shift: function(x, y) {
                var that = this;
                if (that._textContent) {
                    that._insideGroup.attr({
                        translateX: that._x = _round(x - that._bBox.x),
                        translateY: that._y = _round(y - that._bBox.y)
                    });
                    if (that._connector) {
                        that._connector.attr({
                            points: that._getConnectorPoints()
                        })
                    }
                }
                return that
            },
            getBoundingRect: function() {
                return this._shiftBBox(this._bBox)
            },
            _shiftBBox: function(bBox) {
                return this._textContent ? {
                    x: bBox.x + this._x,
                    y: bBox.y + this._y,
                    width: bBox.width,
                    height: bBox.height
                } : {}
            },
            getLayoutOptions: function() {
                var options = this._options;
                return {
                    alignment: options.alignment,
                    background: checkBackground(options.background),
                    horizontalOffset: options.horizontalOffset,
                    verticalOffset: options.verticalOffset,
                    radialOffset: options.radialOffset,
                    position: options.position,
                    connectorOffset: (checkConnector(options.connector) ? CONNECTOR_LENGTH : 0) + (checkBackground(options.background) ? LABEL_BACKGROUND_PADDING_X : 0)
                }
            }
        }
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/axes/base_axis.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.Axis = void 0;
        var _smart_formatter = __webpack_require__( /*! ./smart_formatter */ 468);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _axes_constants = _interopRequireDefault(__webpack_require__( /*! ./axes_constants */ 317));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _format_helper = _interopRequireDefault(__webpack_require__( /*! ../../format_helper */ 71));
        var _parse_utils = __webpack_require__( /*! ../components/parse_utils */ 313);
        var _tick_generator = __webpack_require__( /*! ./tick_generator */ 469);
        var _translator2d = __webpack_require__( /*! ../translators/translator2d */ 318);
        var _range = __webpack_require__( /*! ../translators/range */ 124);
        var _tick = __webpack_require__( /*! ./tick */ 470);
        var _math2 = __webpack_require__( /*! ../../core/utils/math */ 29);
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _xy_axes = _interopRequireDefault(__webpack_require__( /*! ./xy_axes */ 471));
        var polarMethods = _interopRequireWildcard(__webpack_require__( /*! ./polar_axes */ 935));
        var _constant_line = _interopRequireDefault(__webpack_require__( /*! ./constant_line */ 936));
        var _strip = _interopRequireDefault(__webpack_require__( /*! ./strip */ 937));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _axes_utils = __webpack_require__( /*! ./axes_utils */ 472);

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }
        var convertTicksToValues = _axes_constants.default.convertTicksToValues;
        var _math = Math;
        var _abs = _math.abs;
        var _max = _math.max;
        var _min = _math.min;
        var _isArray = Array.isArray;
        var DEFAULT_AXIS_LABEL_SPACING = 5;
        var MAX_GRID_BORDER_ADHENSION = 4;
        var TOP = _axes_constants.default.top;
        var BOTTOM = _axes_constants.default.bottom;
        var LEFT = _axes_constants.default.left;
        var RIGHT = _axes_constants.default.right;
        var CENTER = _axes_constants.default.center;
        var KEEP = "keep";
        var SHIFT = "shift";
        var RESET = "reset";
        var ROTATE = "rotate";
        var DEFAULT_AXIS_DIVISION_FACTOR = 50;
        var DEFAULT_MINOR_AXIS_DIVISION_FACTOR = 15;
        var SCROLL_THRESHOLD = 5;
        var MIN_BAR_MARGIN = 5;
        var MAX_MARGIN_VALUE = .8;
        var dateIntervals = {
            day: 864e5,
            week: 6048e5
        };

        function getTickGenerator(options, incidentOccurred, skipTickGeneration, rangeIsEmpty, adjustDivisionFactor, _ref) {
            var _options$workWeek;
            var allowNegatives = _ref.allowNegatives,
                linearThreshold = _ref.linearThreshold;
            return (0, _tick_generator.tickGenerator)({
                axisType: options.type,
                dataType: options.dataType,
                logBase: options.logarithmBase,
                allowNegatives: allowNegatives,
                linearThreshold: linearThreshold,
                axisDivisionFactor: adjustDivisionFactor(options.axisDivisionFactor || DEFAULT_AXIS_DIVISION_FACTOR),
                minorAxisDivisionFactor: adjustDivisionFactor(options.minorAxisDivisionFactor || DEFAULT_MINOR_AXIS_DIVISION_FACTOR),
                numberMultipliers: options.numberMultipliers,
                calculateMinors: options.minorTick.visible || options.minorGrid.visible || options.calculateMinors,
                allowDecimals: options.allowDecimals,
                endOnTick: options.endOnTick,
                incidentOccurred: incidentOccurred,
                firstDayOfWeek: null === (_options$workWeek = options.workWeek) || void 0 === _options$workWeek ? void 0 : _options$workWeek[0],
                skipTickGeneration: skipTickGeneration,
                skipCalculationLimits: options.skipCalculationLimits,
                generateExtraTick: options.generateExtraTick,
                minTickInterval: options.minTickInterval,
                rangeIsEmpty: rangeIsEmpty
            })
        }

        function createMajorTick(axis, renderer, skippedCategory) {
            var options = axis.getOptions();
            return (0, _tick.tick)(axis, renderer, options.tick, options.grid, skippedCategory, false)
        }

        function createMinorTick(axis, renderer) {
            var options = axis.getOptions();
            return (0, _tick.tick)(axis, renderer, options.minorTick, options.minorGrid)
        }

        function createBoundaryTick(axis, renderer, isFirst) {
            var options = axis.getOptions();
            return (0, _tick.tick)(axis, renderer, (0, _extend.extend)({}, options.tick, {
                visible: options.showCustomBoundaryTicks
            }), options.grid, void 0, false, isFirst ? -1 : 1)
        }

        function callAction(elements, action, actionArgument1, actionArgument2) {
            (elements || []).forEach(function(e) {
                return e[action](actionArgument1, actionArgument2)
            })
        }

        function initTickCoords(ticks) {
            callAction(ticks, "initCoords")
        }

        function drawTickMarks(ticks, options) {
            callAction(ticks, "drawMark", options)
        }

        function drawGrids(ticks, drawLine) {
            callAction(ticks, "drawGrid", drawLine)
        }

        function updateTicksPosition(ticks, options, animate) {
            callAction(ticks, "updateTickPosition", options, animate)
        }

        function updateGridsPosition(ticks, animate) {
            callAction(ticks, "updateGridPosition", animate)
        }

        function cleanUpInvalidTicks(ticks) {
            var i = ticks.length - 1;
            for (i; i >= 0; i--) {
                if (!removeInvalidTick(ticks, i)) {
                    break
                }
            }
            for (i = 0; i < ticks.length; i++) {
                if (removeInvalidTick(ticks, i)) {
                    i--
                } else {
                    break
                }
            }
        }

        function removeInvalidTick(ticks, i) {
            if (null === ticks[i].coords.x || null === ticks[i].coords.y) {
                ticks.splice(i, 1);
                return true
            }
            return false
        }

        function validateAxisOptions(options) {
            var _labelOptions$minSpac;
            var labelOptions = options.label;
            var position = options.position;
            var defaultPosition = options.isHorizontal ? BOTTOM : LEFT;
            var secondaryPosition = options.isHorizontal ? TOP : RIGHT;
            var labelPosition = labelOptions.position;
            if (position !== defaultPosition && position !== secondaryPosition) {
                position = defaultPosition
            }
            if (!labelPosition || "outside" === labelPosition) {
                labelPosition = position
            } else {
                if ("inside" === labelPosition) {
                    var _TOP$BOTTOM$LEFT$RIGH;
                    labelPosition = (_TOP$BOTTOM$LEFT$RIGH = {}, _defineProperty(_TOP$BOTTOM$LEFT$RIGH, TOP, BOTTOM), _defineProperty(_TOP$BOTTOM$LEFT$RIGH, BOTTOM, TOP), _defineProperty(_TOP$BOTTOM$LEFT$RIGH, LEFT, RIGHT), _defineProperty(_TOP$BOTTOM$LEFT$RIGH, RIGHT, LEFT), _TOP$BOTTOM$LEFT$RIGH)[position]
                }
            }
            if (labelPosition !== defaultPosition && labelPosition !== secondaryPosition) {
                labelPosition = position
            }
            if (labelOptions.alignment !== CENTER && !labelOptions.userAlignment) {
                var _TOP$BOTTOM$LEFT$RIGH2;
                labelOptions.alignment = (_TOP$BOTTOM$LEFT$RIGH2 = {}, _defineProperty(_TOP$BOTTOM$LEFT$RIGH2, TOP, CENTER), _defineProperty(_TOP$BOTTOM$LEFT$RIGH2, BOTTOM, CENTER), _defineProperty(_TOP$BOTTOM$LEFT$RIGH2, LEFT, RIGHT), _defineProperty(_TOP$BOTTOM$LEFT$RIGH2, RIGHT, LEFT), _TOP$BOTTOM$LEFT$RIGH2)[labelPosition]
            }
            options.position = position;
            labelOptions.position = labelPosition;
            options.hoverMode = options.hoverMode ? options.hoverMode.toLowerCase() : "none";
            labelOptions.minSpacing = null !== (_labelOptions$minSpac = labelOptions.minSpacing) && void 0 !== _labelOptions$minSpac ? _labelOptions$minSpac : DEFAULT_AXIS_LABEL_SPACING;
            options.type && (options.type = options.type.toLowerCase());
            options.argumentType && (options.argumentType = options.argumentType.toLowerCase());
            options.valueType && (options.valueType = options.valueType.toLowerCase())
        }

        function getOptimalAngle(boxes, labelOpt) {
            var angle = 180 * _math.asin((boxes[0].height + labelOpt.minSpacing) / (boxes[1].x - boxes[0].x)) / _math.PI;
            return angle < 45 ? -45 : -90
        }

        function updateLabels(ticks, step, func) {
            ticks.forEach(function(tick, index) {
                if (tick.getContentContainer()) {
                    if (index % step !== 0) {
                        tick.removeLabel()
                    } else {
                        if (func) {
                            func(tick, index)
                        }
                    }
                }
            })
        }

        function getZoomBoundValue(optionValue, dataValue) {
            if (void 0 === optionValue) {
                return dataValue
            } else {
                if (null === optionValue) {
                    return
                } else {
                    return optionValue
                }
            }
        }

        function configureGenerator(options, axisDivisionFactor, viewPort, screenDelta, minTickInterval) {
            var tickGeneratorOptions = (0, _extend.extend)({}, options, {
                endOnTick: true,
                axisDivisionFactor: axisDivisionFactor,
                skipCalculationLimits: true,
                generateExtraTick: true,
                minTickInterval: minTickInterval
            });
            return function(tickInterval, skipTickGeneration, min, max, breaks) {
                return getTickGenerator(tickGeneratorOptions, _common.noop, skipTickGeneration, viewPort.isEmpty(), function(v) {
                    return v
                }, viewPort)({
                    min: min,
                    max: max,
                    categories: viewPort.categories,
                    isSpacedMargin: viewPort.isSpacedMargin
                }, screenDelta, tickInterval, (0, _type.isDefined)(tickInterval), void 0, void 0, void 0, breaks)
            }
        }

        function getConstantLineSharpDirection(coord, axisCanvas) {
            return Math.max(axisCanvas.start, axisCanvas.end) !== coord ? 1 : -1
        }
        var Axis = function(renderSettings) {
            var that = this;
            that._renderer = renderSettings.renderer;
            that._incidentOccurred = renderSettings.incidentOccurred;
            that._eventTrigger = renderSettings.eventTrigger;
            that._stripsGroup = renderSettings.stripsGroup;
            that._labelAxesGroup = renderSettings.labelAxesGroup;
            that._constantLinesGroup = renderSettings.constantLinesGroup;
            that._scaleBreaksGroup = renderSettings.scaleBreaksGroup;
            that._axesContainerGroup = renderSettings.axesContainerGroup;
            that._gridContainerGroup = renderSettings.gridGroup;
            that._axisCssPrefix = renderSettings.widgetClass + "-" + (renderSettings.axisClass ? renderSettings.axisClass + "-" : "");
            that._setType(renderSettings.axisType, renderSettings.drawingType);
            that._createAxisGroups();
            that._translator = that._createTranslator();
            that.isArgumentAxis = renderSettings.isArgumentAxis;
            that._viewport = {};
            that._firstDrawing = true;
            that._initRange = {};
            that._getTemplate = renderSettings.getTemplate
        };
        exports.Axis = Axis;
        Axis.prototype = {
            constructor: Axis,
            _drawAxis: function() {
                var options = this._options;
                if (!options.visible) {
                    return
                }
                this._axisElement = this._createAxisElement();
                this._updateAxisElementPosition();
                this._axisElement.attr({
                    "stroke-width": options.width,
                    stroke: options.color,
                    "stroke-opacity": options.opacity
                }).sharp(this._getSharpParam(true), this.getAxisSharpDirection()).append(this._axisLineGroup)
            },
            _createPathElement: function(points, attr, sharpDirection) {
                return this.sharp(this._renderer.path(points, "line").attr(attr), sharpDirection)
            },
            sharp: function(svgElement) {
                var sharpDirection = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                return svgElement.sharp(this._getSharpParam(), sharpDirection)
            },
            customPositionIsAvailable: function() {
                return false
            },
            getOrthogonalAxis: _common.noop,
            getCustomPosition: _common.noop,
            getCustomBoundaryPosition: _common.noop,
            resolveOverlappingForCustomPositioning: _common.noop,
            hasNonBoundaryPosition: function() {
                return false
            },
            customPositionIsBoundaryOrthogonalAxis: function() {
                return false
            },
            getResolvedBoundaryPosition: function() {
                return this.getOptions().position
            },
            getAxisSharpDirection: function() {
                var position = this.getResolvedBoundaryPosition();
                return this.hasNonBoundaryPosition() || position !== BOTTOM && position !== RIGHT ? 1 : -1
            },
            getSharpDirectionByCoords: function(coords) {
                var canvas = this._getCanvasStartEnd();
                var maxCoord = Math.max(canvas.start, canvas.end);
                return this.getRadius ? 0 : maxCoord !== coords[this._isHorizontal ? "x" : "y"] ? 1 : -1
            },
            _getGridLineDrawer: function() {
                var that = this;
                return function(tick, gridStyle) {
                    var grid = that._getGridPoints(tick.coords);
                    if (grid.points) {
                        return that._createPathElement(grid.points, gridStyle, that.getSharpDirectionByCoords(tick.coords))
                    }
                    return null
                }
            },
            _getGridPoints: function(coords) {
                var that = this;
                var isHorizontal = this._isHorizontal;
                var tickPositionField = isHorizontal ? "x" : "y";
                var orthogonalPositions = this._orthogonalPositions;
                var positionFrom = orthogonalPositions.start;
                var positionTo = orthogonalPositions.end;
                var borderOptions = that.borderOptions;
                var canvasStart = isHorizontal ? LEFT : TOP;
                var canvasEnd = isHorizontal ? RIGHT : BOTTOM;
                var axisCanvas = that.getCanvas();
                var canvas = {
                    left: axisCanvas.left,
                    right: axisCanvas.width - axisCanvas.right,
                    top: axisCanvas.top,
                    bottom: axisCanvas.height - axisCanvas.bottom
                };
                var firstBorderLinePosition = borderOptions.visible && borderOptions[canvasStart] ? canvas[canvasStart] : void 0;
                var lastBorderLinePosition = borderOptions.visible && borderOptions[canvasEnd] ? canvas[canvasEnd] : void 0;
                var minDelta = MAX_GRID_BORDER_ADHENSION + firstBorderLinePosition;
                var maxDelta = lastBorderLinePosition - MAX_GRID_BORDER_ADHENSION;
                if (that.areCoordsOutsideAxis(coords) || void 0 === coords[tickPositionField] || coords[tickPositionField] < minDelta || coords[tickPositionField] > maxDelta) {
                    return {
                        points: null
                    }
                }
                return {
                    points: isHorizontal ? null !== coords[tickPositionField] ? [coords[tickPositionField], positionFrom, coords[tickPositionField], positionTo] : null : null !== coords[tickPositionField] ? [positionFrom, coords[tickPositionField], positionTo, coords[tickPositionField]] : null
                }
            },
            _getConstantLinePos: function(parsedValue, canvasStart, canvasEnd) {
                var value = this._getTranslatedCoord(parsedValue);
                if (!(0, _type.isDefined)(value) || value < _min(canvasStart, canvasEnd) || value > _max(canvasStart, canvasEnd)) {
                    return
                }
                return value
            },
            _getConstantLineGraphicAttributes: function(value) {
                var positionFrom = this._orthogonalPositions.start;
                var positionTo = this._orthogonalPositions.end;
                return {
                    points: this._isHorizontal ? [value, positionFrom, value, positionTo] : [positionFrom, value, positionTo, value]
                }
            },
            _createConstantLine: function(value, attr) {
                return this._createPathElement(this._getConstantLineGraphicAttributes(value).points, attr, getConstantLineSharpDirection(value, this._getCanvasStartEnd()))
            },
            _drawConstantLineLabelText: function(text, x, y, _ref2, group) {
                var font = _ref2.font,
                    cssClass = _ref2.cssClass;
                return this._renderer.text(text, x, y).css((0, _utils.patchFontOptions)((0, _extend.extend)({}, this._options.label.font, font))).attr({
                    align: "center",
                    "class": cssClass
                }).append(group)
            },
            _drawConstantLineLabels: function(parsedValue, lineLabelOptions, value, group) {
                var _text;
                var that = this;
                var text = lineLabelOptions.text;
                var options = that._options;
                var labelOptions = options.label;
                that._checkAlignmentConstantLineLabels(lineLabelOptions);
                text = null !== (_text = text) && void 0 !== _text ? _text : that.formatLabel(parsedValue, labelOptions);
                var coords = that._getConstantLineLabelsCoords(value, lineLabelOptions);
                return that._drawConstantLineLabelText(text, coords.x, coords.y, lineLabelOptions, group)
            },
            _getStripPos: function(startValue, endValue, canvasStart, canvasEnd, range) {
                var isContinuous = !!(range.minVisible || range.maxVisible);
                var categories = (range.categories || []).reduce(function(result, cat) {
                    result.push(cat.valueOf());
                    return result
                }, []);
                var start;
                var end;
                var swap;
                var startCategoryIndex;
                var endCategoryIndex;
                if (!isContinuous) {
                    if ((0, _type.isDefined)(startValue) && (0, _type.isDefined)(endValue)) {
                        var parsedStartValue = this.parser(startValue);
                        var parsedEndValue = this.parser(endValue);
                        startCategoryIndex = (0, _array.inArray)((0, _type.isDefined)(parsedStartValue) ? parsedStartValue.valueOf() : void 0, categories);
                        endCategoryIndex = (0, _array.inArray)((0, _type.isDefined)(parsedEndValue) ? parsedEndValue.valueOf() : void 0, categories);
                        if (startCategoryIndex === -1 || endCategoryIndex === -1) {
                            return {
                                from: 0,
                                to: 0,
                                outOfCanvas: true
                            }
                        }
                        if (startCategoryIndex > endCategoryIndex) {
                            swap = endValue;
                            endValue = startValue;
                            startValue = swap
                        }
                    }
                }
                if ((0, _type.isDefined)(startValue)) {
                    startValue = this.validateUnit(startValue, "E2105", "strip");
                    start = this._getTranslatedCoord(startValue, -1)
                } else {
                    start = canvasStart
                }
                if ((0, _type.isDefined)(endValue)) {
                    endValue = this.validateUnit(endValue, "E2105", "strip");
                    end = this._getTranslatedCoord(endValue, 1)
                } else {
                    end = canvasEnd
                }
                var stripPosition = start < end ? {
                    from: start,
                    to: end
                } : {
                    from: end,
                    to: start
                };
                var visibleArea = this.getVisibleArea();
                if (stripPosition.from <= visibleArea[0] && stripPosition.to <= visibleArea[0] || stripPosition.from >= visibleArea[1] && stripPosition.to >= visibleArea[1]) {
                    stripPosition.outOfCanvas = true
                }
                return stripPosition
            },
            _getStripGraphicAttributes: function(fromPoint, toPoint) {
                var x;
                var y;
                var width;
                var height;
                var orthogonalPositions = this._orthogonalPositions;
                var positionFrom = orthogonalPositions.start;
                var positionTo = orthogonalPositions.end;
                if (this._isHorizontal) {
                    x = fromPoint;
                    y = _min(positionFrom, positionTo);
                    width = toPoint - fromPoint;
                    height = _abs(positionFrom - positionTo)
                } else {
                    x = _min(positionFrom, positionTo);
                    y = fromPoint;
                    width = _abs(positionFrom - positionTo);
                    height = _abs(fromPoint - toPoint)
                }
                return {
                    x: x,
                    y: y,
                    width: width,
                    height: height
                }
            },
            _createStrip: function(attrs) {
                return this._renderer.rect(attrs.x, attrs.y, attrs.width, attrs.height)
            },
            _adjustStripLabels: function() {
                var that = this;
                this._strips.forEach(function(strip) {
                    if (strip.label) {
                        strip.label.attr(that._getAdjustedStripLabelCoords(strip))
                    }
                })
            },
            _adjustLabelsCoord: function(offset, maxWidth, checkCanvas) {
                var _this = this;
                var that = this;
                var getContainerAttrs = function(tick) {
                    return _this._getLabelAdjustedCoord(tick, offset + (tick.labelOffset || 0), maxWidth, checkCanvas)
                };
                that._majorTicks.forEach(function(tick) {
                    if (tick.label) {
                        tick.updateMultilineTextAlignment();
                        tick.label.attr(getContainerAttrs(tick))
                    } else {
                        tick.templateContainer && tick.templateContainer.attr(getContainerAttrs(tick))
                    }
                })
            },
            _adjustLabels: function(offset) {
                var that = this;
                var options = that.getOptions();
                var positionsAreConsistent = options.position === options.label.position;
                var maxSize = that._majorTicks.reduce(function(size, tick) {
                    if (!tick.getContentContainer()) {
                        return size
                    }
                    var bBox = tick.labelRotationAngle ? (0, _utils.rotateBBox)(tick.labelBBox, [tick.labelCoords.x, tick.labelCoords.y], -tick.labelRotationAngle) : tick.labelBBox;
                    return {
                        width: _max(size.width || 0, bBox.width),
                        height: _max(size.height || 0, bBox.height),
                        offset: _max(size.offset || 0, tick.labelOffset || 0)
                    }
                }, {});
                var additionalOffset = positionsAreConsistent ? that._isHorizontal ? maxSize.height : maxSize.width : 0;
                that._adjustLabelsCoord(offset, maxSize.width);
                return offset + additionalOffset + (additionalOffset && that._options.label.indentFromAxis) + (positionsAreConsistent ? maxSize.offset : 0)
            },
            _getLabelAdjustedCoord: function(tick, offset, maxWidth) {
                offset = offset || 0;
                var that = this;
                var options = that._options;
                var templateBox = tick.templateContainer && tick.templateContainer.getBBox();
                var box = templateBox || (0, _utils.rotateBBox)(tick.labelBBox, [tick.labelCoords.x, tick.labelCoords.y], -tick.labelRotationAngle || 0);
                var textAlign = tick.labelAlignment || options.label.alignment;
                var isDiscrete = "discrete" === that._options.type;
                var isFlatLabel = tick.labelRotationAngle % 90 === 0;
                var indentFromAxis = options.label.indentFromAxis;
                var labelPosition = options.label.position;
                var axisPosition = that._axisPosition;
                var labelCoords = tick.labelCoords;
                var labelX = labelCoords.x;
                var translateX;
                var translateY;
                if (that._isHorizontal) {
                    if (labelPosition === BOTTOM) {
                        translateY = axisPosition + indentFromAxis - box.y + offset
                    } else {
                        translateY = axisPosition - indentFromAxis - (box.y + box.height) - offset
                    }
                    if (textAlign === RIGHT) {
                        translateX = isDiscrete && isFlatLabel ? tick.coords.x - (box.x + box.width) : labelX - box.x - box.width
                    } else {
                        if (textAlign === LEFT) {
                            translateX = isDiscrete && isFlatLabel ? labelX - box.x - (tick.coords.x - labelX) : labelX - box.x
                        } else {
                            translateX = labelX - box.x - box.width / 2
                        }
                    }
                } else {
                    translateY = labelCoords.y - box.y - box.height / 2;
                    if (labelPosition === LEFT) {
                        if (textAlign === LEFT) {
                            translateX = axisPosition - indentFromAxis - maxWidth - box.x
                        } else {
                            if (textAlign === CENTER) {
                                translateX = axisPosition - indentFromAxis - maxWidth / 2 - box.x - box.width / 2
                            } else {
                                translateX = axisPosition - indentFromAxis - box.x - box.width
                            }
                        }
                        translateX -= offset
                    } else {
                        if (textAlign === RIGHT) {
                            translateX = axisPosition + indentFromAxis + maxWidth - box.x - box.width
                        } else {
                            if (textAlign === CENTER) {
                                translateX = axisPosition + indentFromAxis + maxWidth / 2 - box.x - box.width / 2
                            } else {
                                translateX = axisPosition + indentFromAxis - box.x
                            }
                        }
                        translateX += offset
                    }
                }
                return {
                    translateX: translateX,
                    translateY: translateY
                }
            },
            _createAxisConstantLineGroups: function() {
                var that = this;
                var renderer = that._renderer;
                var classSelector = that._axisCssPrefix;
                var constantLinesClass = classSelector + "constant-lines";
                var insideGroup = renderer.g().attr({
                    "class": constantLinesClass
                });
                var outsideGroup1 = renderer.g().attr({
                    "class": constantLinesClass
                });
                var outsideGroup2 = renderer.g().attr({
                    "class": constantLinesClass
                });
                return {
                    inside: insideGroup,
                    outside1: outsideGroup1,
                    left: outsideGroup1,
                    top: outsideGroup1,
                    outside2: outsideGroup2,
                    right: outsideGroup2,
                    bottom: outsideGroup2,
                    remove: function() {
                        this.inside.remove();
                        this.outside1.remove();
                        this.outside2.remove()
                    },
                    clear: function() {
                        this.inside.clear();
                        this.outside1.clear();
                        this.outside2.clear()
                    }
                }
            },
            _createAxisGroups: function() {
                var that = this;
                var renderer = that._renderer;
                var classSelector = that._axisCssPrefix;
                that._axisGroup = renderer.g().attr({
                    "class": classSelector + "axis"
                }).enableLinks();
                that._axisStripGroup = renderer.g().attr({
                    "class": classSelector + "strips"
                });
                that._axisGridGroup = renderer.g().attr({
                    "class": classSelector + "grid"
                });
                that._axisElementsGroup = renderer.g().attr({
                    "class": classSelector + "elements"
                }).linkOn(that._axisGroup, "axisElements").linkAppend();
                that._axisLineGroup = renderer.g().attr({
                    "class": classSelector + "line"
                }).linkOn(that._axisGroup, "axisLine").linkAppend();
                that._axisTitleGroup = renderer.g().attr({
                    "class": classSelector + "title"
                }).append(that._axisGroup);
                that._axisConstantLineGroups = {
                    above: that._createAxisConstantLineGroups(),
                    under: that._createAxisConstantLineGroups()
                };
                that._axisStripLabelGroup = renderer.g().attr({
                    "class": classSelector + "axis-labels"
                })
            },
            _clearAxisGroups: function() {
                var that = this;
                that._axisGroup.remove();
                that._axisStripGroup.remove();
                that._axisStripLabelGroup.remove();
                that._axisConstantLineGroups.above.remove();
                that._axisConstantLineGroups.under.remove();
                that._axisGridGroup.remove();
                that._axisTitleGroup.clear();
                (!that._options.label.template || !that.isRendered()) && that._axisElementsGroup.clear();
                that._axisLineGroup && that._axisLineGroup.clear();
                that._axisStripGroup && that._axisStripGroup.clear();
                that._axisGridGroup && that._axisGridGroup.clear();
                that._axisConstantLineGroups.above.clear();
                that._axisConstantLineGroups.under.clear();
                that._axisStripLabelGroup && that._axisStripLabelGroup.clear()
            },
            _getLabelFormatObject: function(value, labelOptions, range, point, tickInterval, ticks) {
                range = range || this._getViewportRange();
                var formatObject = {
                    value: value,
                    valueText: (0, _smart_formatter.smartFormatter)(value, {
                        labelOptions: labelOptions,
                        ticks: ticks || convertTicksToValues(this._majorTicks),
                        tickInterval: null !== tickInterval && void 0 !== tickInterval ? tickInterval : this._tickInterval,
                        dataType: this._options.dataType,
                        logarithmBase: this._options.logarithmBase,
                        type: this._options.type,
                        showTransition: !this._options.marker.visible,
                        point: point
                    }) || "",
                    min: range.minVisible,
                    max: range.maxVisible
                };
                if (point) {
                    formatObject.point = point
                }
                return formatObject
            },
            formatLabel: function(value, labelOptions, range, point, tickInterval, ticks) {
                var formatObject = this._getLabelFormatObject(value, labelOptions, range, point, tickInterval, ticks);
                return (0, _type.isFunction)(labelOptions.customizeText) ? labelOptions.customizeText.call(formatObject, formatObject) : formatObject.valueText
            },
            formatHint: function(value, labelOptions, range) {
                var formatObject = this._getLabelFormatObject(value, labelOptions, range);
                return (0, _type.isFunction)(labelOptions.customizeHint) ? labelOptions.customizeHint.call(formatObject, formatObject) : void 0
            },
            formatRange: function(startValue, endValue, interval) {
                return (0, _smart_formatter.formatRange)(startValue, endValue, interval, this.getOptions())
            },
            _setTickOffset: function() {
                var options = this._options;
                var discreteAxisDivisionMode = options.discreteAxisDivisionMode;
                this._tickOffset = +("crossLabels" !== discreteAxisDivisionMode || !discreteAxisDivisionMode)
            },
            resetApplyingAnimation: function(isFirstDrawing) {
                this._resetApplyingAnimation = true;
                if (isFirstDrawing) {
                    this._firstDrawing = true
                }
            },
            isFirstDrawing: function() {
                return this._firstDrawing
            },
            getMargins: function() {
                var that = this;
                var _that$_options = that._options,
                    position = _that$_options.position,
                    offset = _that$_options.offset,
                    customPosition = _that$_options.customPosition,
                    placeholderSize = _that$_options.placeholderSize,
                    grid = _that$_options.grid,
                    tick = _that$_options.tick,
                    crosshairMargin = _that$_options.crosshairMargin;
                var isDefinedCustomPositionOption = (0, _type.isDefined)(customPosition);
                var boundaryPosition = that.getResolvedBoundaryPosition();
                var canvas = that.getCanvas();
                var cLeft = canvas.left;
                var cTop = canvas.top;
                var cRight = canvas.width - canvas.right;
                var cBottom = canvas.height - canvas.bottom;
                var edgeMarginCorrection = _max(grid.visible && grid.width || 0, tick.visible && tick.width || 0);
                var constantLineAboveSeries = that._axisConstantLineGroups.above;
                var constantLineUnderSeries = that._axisConstantLineGroups.under;
                var boxes = [that._axisElementsGroup, constantLineAboveSeries.outside1, constantLineAboveSeries.outside2, constantLineUnderSeries.outside1, constantLineUnderSeries.outside2, that._axisLineGroup].map(function(group) {
                    return group && group.getBBox()
                }).concat(function(group) {
                    var box = group && group.getBBox();
                    if (!box || box.isEmpty) {
                        return box
                    }
                    if (that._isHorizontal) {
                        box.x = cLeft;
                        box.width = cRight - cLeft
                    } else {
                        box.y = cTop;
                        box.height = cBottom - cTop
                    }
                    return box
                }(that._axisTitleGroup));
                var margins = (0, _axes_utils.calculateCanvasMargins)(boxes, canvas);
                margins[position] += crosshairMargin;
                if (that.hasNonBoundaryPosition() && isDefinedCustomPositionOption) {
                    margins[boundaryPosition] = 0
                }
                if (placeholderSize) {
                    margins[position] = placeholderSize
                }
                if (edgeMarginCorrection) {
                    if (that._isHorizontal && canvas.right < edgeMarginCorrection && margins.right < edgeMarginCorrection) {
                        margins.right = edgeMarginCorrection
                    }
                    if (!that._isHorizontal && canvas.bottom < edgeMarginCorrection && margins.bottom < edgeMarginCorrection) {
                        margins.bottom = edgeMarginCorrection
                    }
                }
                if (!isDefinedCustomPositionOption && (0, _type.isDefined)(offset)) {
                    var moveByOffset = that.customPositionIsBoundary() && (offset > 0 && (boundaryPosition === LEFT || boundaryPosition === TOP) || offset < 0 && (boundaryPosition === RIGHT || boundaryPosition === BOTTOM));
                    margins[boundaryPosition] -= moveByOffset ? offset : 0
                }
                return margins
            },
            validateUnit: function(unit, idError, parameters) {
                var that = this;
                unit = that.parser(unit);
                if (void 0 === unit && idError) {
                    that._incidentOccurred(idError, [parameters])
                }
                return unit
            },
            _setType: function(axisType, drawingType) {
                var that = this;
                var axisTypeMethods;
                switch (axisType) {
                    case "xyAxes":
                        axisTypeMethods = _xy_axes.default;
                        break;
                    case "polarAxes":
                        axisTypeMethods = polarMethods
                }(0, _extend.extend)(that, axisTypeMethods[drawingType])
            },
            _getSharpParam: function() {
                return true
            },
            _disposeBreaksGroup: _common.noop,
            dispose: function() {
                var that = this;
                [that._axisElementsGroup, that._axisStripGroup, that._axisGroup].forEach(function(g) {
                    g.dispose()
                });
                that._strips = that._title = null;
                that._axisStripGroup = that._axisConstantLineGroups = that._axisStripLabelGroup = that._axisBreaksGroup = null;
                that._axisLineGroup = that._axisElementsGroup = that._axisGridGroup = null;
                that._axisGroup = that._axisTitleGroup = null;
                that._axesContainerGroup = that._stripsGroup = that._constantLinesGroup = null;
                that._renderer = that._options = that._textOptions = that._textFontStyles = null;
                that._translator = null;
                that._majorTicks = that._minorTicks = null;
                that._disposeBreaksGroup();
                that._templatesRendered && that._templatesRendered.reject()
            },
            getOptions: function() {
                return this._options
            },
            setPane: function(pane) {
                this.pane = pane;
                this._options.pane = pane
            },
            setTypes: function(type, axisType, typeSelector) {
                this._options.type = type || this._options.type;
                this._options[typeSelector] = axisType || this._options[typeSelector];
                this._updateTranslator()
            },
            resetTypes: function(typeSelector) {
                this._options.type = this._initTypes.type;
                this._options[typeSelector] = this._initTypes[typeSelector]
            },
            getTranslator: function() {
                return this._translator
            },
            updateOptions: function(options) {
                var that = this;
                var labelOpt = options.label;
                validateAxisOptions(options);
                that._options = options;
                options.tick = options.tick || {};
                options.minorTick = options.minorTick || {};
                options.grid = options.grid || {};
                options.minorGrid = options.minorGrid || {};
                options.title = options.title || {};
                options.marker = options.marker || {};
                that._initTypes = {
                    type: options.type,
                    argumentType: options.argumentType,
                    valueType: options.valueType
                };
                that._setTickOffset();
                that._isHorizontal = options.isHorizontal;
                that.pane = options.pane;
                that.name = options.name;
                that.priority = options.priority;
                that._hasLabelFormat = "" !== labelOpt.format && (0, _type.isDefined)(labelOpt.format);
                that._textOptions = {
                    opacity: labelOpt.opacity,
                    align: "center",
                    "class": labelOpt.cssClass
                };
                that._textFontStyles = (0, _utils.patchFontOptions)(labelOpt.font);
                if (options.type === _axes_constants.default.logarithmic) {
                    if (options.logarithmBaseError) {
                        that._incidentOccurred("E2104");
                        delete options.logarithmBaseError
                    }
                }
                that._updateTranslator();
                that._createConstantLines();
                that._strips = (options.strips || []).map(function(o) {
                    return (0, _strip.default)(that, o)
                });
                that._majorTicks = that._minorTicks = null;
                that._firstDrawing = true
            },
            calculateInterval: function(value, prevValue) {
                var options = this._options;
                if (!options || options.type !== _axes_constants.default.logarithmic) {
                    return _abs(value - prevValue)
                }
                var _Range = new _range.Range(this.getTranslator().getBusinessRange()),
                    allowNegatives = _Range.allowNegatives,
                    linearThreshold = _Range.linearThreshold;
                return _abs((0, _utils.getLogExt)(value, options.logarithmBase, allowNegatives, linearThreshold) - (0, _utils.getLogExt)(prevValue, options.logarithmBase, allowNegatives, linearThreshold))
            },
            getCanvasRange: function() {
                var translator = this._translator;
                return {
                    startValue: translator.from(translator.translate("canvas_position_start")),
                    endValue: translator.from(translator.translate("canvas_position_end"))
                }
            },
            _processCanvas: function(canvas) {
                return canvas
            },
            updateCanvas: function(canvas, canvasRedesign) {
                if (!canvasRedesign) {
                    var positions = this._orthogonalPositions = {
                        start: !this._isHorizontal ? canvas.left : canvas.top,
                        end: !this._isHorizontal ? canvas.width - canvas.right : canvas.height - canvas.bottom
                    };
                    positions.center = positions.start + (positions.end - positions.start) / 2
                } else {
                    this._orthogonalPositions = null
                }
                this._canvas = canvas;
                this._translator.updateCanvas(this._processCanvas(canvas));
                this._initAxisPositions()
            },
            getCanvas: function() {
                return this._canvas
            },
            getAxisShift: function() {
                return this._axisShift || 0
            },
            hideTitle: function() {
                var that = this;
                if (that._options.title.text) {
                    that._incidentOccurred("W2105", [that._isHorizontal ? "horizontal" : "vertical"]);
                    that._axisTitleGroup.clear()
                }
            },
            getTitle: function() {
                return this._title
            },
            hideOuterElements: function() {
                var that = this;
                var options = that._options;
                if ((options.label.visible || that._outsideConstantLines.length) && !that._translator.getBusinessRange().isEmpty()) {
                    that._incidentOccurred("W2106", [that._isHorizontal ? "horizontal" : "vertical"]);
                    that._axisElementsGroup.clear();
                    callAction(that._outsideConstantLines, "removeLabel")
                }
            },
            _resolveLogarithmicOptionsForRange: function(range) {
                var options = this._options;
                if (options.type === _axes_constants.default.logarithmic) {
                    range.addRange({
                        allowNegatives: void 0 !== options.allowNegatives ? options.allowNegatives : range.min <= 0
                    });
                    if (!isNaN(options.linearThreshold)) {
                        range.linearThreshold = options.linearThreshold
                    }
                }
            },
            adjustViewport: function(businessRange) {
                var that = this;
                var options = that._options;
                var isDiscrete = options.type === _axes_constants.default.discrete;
                var categories = that._seriesData && that._seriesData.categories || [];
                var wholeRange = that.adjustRange((0, _utils.getVizRangeObject)(options.wholeRange));
                var visualRange = that.getViewport() || {};
                var result = new _range.Range(businessRange);
                that._addConstantLinesToRange(result, "minVisible", "maxVisible");
                var minDefined = (0, _type.isDefined)(visualRange.startValue);
                var maxDefined = (0, _type.isDefined)(visualRange.endValue);
                if (!isDiscrete) {
                    minDefined = minDefined && (!(0, _type.isDefined)(wholeRange.endValue) || visualRange.startValue < wholeRange.endValue);
                    maxDefined = maxDefined && (!(0, _type.isDefined)(wholeRange.startValue) || visualRange.endValue > wholeRange.startValue)
                }
                var minVisible = minDefined ? visualRange.startValue : result.minVisible;
                var maxVisible = maxDefined ? visualRange.endValue : result.maxVisible;
                if (!isDiscrete) {
                    var _wholeRange$startValu, _wholeRange$endValue;
                    result.min = null !== (_wholeRange$startValu = wholeRange.startValue) && void 0 !== _wholeRange$startValu ? _wholeRange$startValu : result.min;
                    result.max = null !== (_wholeRange$endValue = wholeRange.endValue) && void 0 !== _wholeRange$endValue ? _wholeRange$endValue : result.max;
                } else {
                    var categoriesInfo = (0, _utils.getCategoriesInfo)(categories, wholeRange.startValue, wholeRange.endValue);
                    categories = categoriesInfo.categories;
                    result.categories = categories
                }
                var adjustedVisualRange = (0, _utils.adjustVisualRange)({
                    axisType: options.type,
                    dataType: options.dataType,
                    base: options.logarithmBase
                }, {
                    startValue: minDefined ? visualRange.startValue : void 0,
                    endValue: maxDefined ? visualRange.endValue : void 0,
                    length: visualRange.length
                }, {
                    categories: categories,
                    min: wholeRange.startValue,
                    max: wholeRange.endValue
                }, {
                    categories: categories,
                    min: minVisible,
                    max: maxVisible
                });
                result.minVisible = adjustedVisualRange.startValue;
                result.maxVisible = adjustedVisualRange.endValue;
                !(0, _type.isDefined)(result.min) && (result.min = result.minVisible);
                !(0, _type.isDefined)(result.max) && (result.max = result.maxVisible);
                result.addRange({});
                that._resolveLogarithmicOptionsForRange(result);
                return result
            },
            adjustRange: function(range) {
                range = range || {};
                var isDiscrete = this._options.type === _axes_constants.default.discrete;
                var isLogarithmic = this._options.type === _axes_constants.default.logarithmic;
                var disabledNegatives = false === this._options.allowNegatives;
                if (isLogarithmic) {
                    range.startValue = disabledNegatives && range.startValue <= 0 ? null : range.startValue;
                    range.endValue = disabledNegatives && range.endValue <= 0 ? null : range.endValue
                }
                if (!isDiscrete && (0, _type.isDefined)(range.startValue) && (0, _type.isDefined)(range.endValue) && range.startValue > range.endValue) {
                    var tmp = range.endValue;
                    range.endValue = range.startValue;
                    range.startValue = tmp
                }
                return range
            },
            _getVisualRangeUpdateMode: function(viewport, newRange, oppositeValue) {
                var value = this._options.visualRangeUpdateMode;
                var translator = this._translator;
                var range = this._seriesData;
                if (this.isArgumentAxis) {
                    if ([SHIFT, KEEP, RESET].indexOf(value) === -1) {
                        if (range.axisType === _axes_constants.default.discrete) {
                            var categories = range.categories;
                            var newCategories = newRange.categories;
                            var visualRange = this.visualRange();
                            if (categories && newCategories && categories.length && newCategories.map(function(c) {
                                    return c.valueOf()
                                }).join(",").indexOf(categories.map(function(c) {
                                    return c.valueOf()
                                }).join(",")) !== -1 && (visualRange.startValue.valueOf() !== categories[0].valueOf() || visualRange.endValue.valueOf() !== categories[categories.length - 1].valueOf())) {
                                value = KEEP
                            } else {
                                value = RESET
                            }
                        } else {
                            var minPoint = translator.translate(range.min);
                            var minVisiblePoint = translator.translate(viewport.startValue);
                            var maxPoint = translator.translate(range.max);
                            var maxVisiblePoint = translator.translate(viewport.endValue);
                            if (minPoint === minVisiblePoint && maxPoint === maxVisiblePoint) {
                                value = RESET
                            } else {
                                if (minPoint !== minVisiblePoint && maxPoint === maxVisiblePoint) {
                                    value = SHIFT
                                } else {
                                    value = KEEP
                                }
                            }
                        }
                    }
                } else {
                    if ([KEEP, RESET].indexOf(value) === -1) {
                        if (oppositeValue === KEEP) {
                            value = KEEP
                        } else {
                            value = RESET
                        }
                    }
                }
                return value
            },
            _handleBusinessRangeChanged: function(oppositeVisualRangeUpdateMode, axisReinitialized, newRange) {
                var that = this;
                var visualRange = this.visualRange();
                if (axisReinitialized || that._translator.getBusinessRange().isEmpty()) {
                    return
                }
                var visualRangeUpdateMode = that._lastVisualRangeUpdateMode = that._getVisualRangeUpdateMode(visualRange, newRange, oppositeVisualRangeUpdateMode);
                if (!that.isArgumentAxis) {
                    var viewport = that.getViewport();
                    if (!(0, _type.isDefined)(viewport.startValue) && !(0, _type.isDefined)(viewport.endValue) && !(0, _type.isDefined)(viewport.length)) {
                        visualRangeUpdateMode = RESET
                    }
                }
                that._prevDataWasEmpty && (visualRangeUpdateMode = KEEP);
                if (visualRangeUpdateMode === KEEP) {
                    that._setVisualRange([visualRange.startValue, visualRange.endValue])
                }
                if (visualRangeUpdateMode === RESET) {
                    that._setVisualRange([null, null])
                }
                if (visualRangeUpdateMode === SHIFT) {
                    that._setVisualRange({
                        length: that.getVisualRangeLength()
                    })
                }
            },
            getVisualRangeLength: function(range) {
                var currentBusinessRange = range || this._translator.getBusinessRange();
                var type = this._options.type;
                var length;
                if (type === _axes_constants.default.logarithmic) {
                    length = (0, _math2.adjust)(this.calculateInterval(currentBusinessRange.maxVisible, currentBusinessRange.minVisible))
                } else {
                    if (type === _axes_constants.default.discrete) {
                        var categoriesInfo = (0, _utils.getCategoriesInfo)(currentBusinessRange.categories, currentBusinessRange.minVisible, currentBusinessRange.maxVisible);
                        length = categoriesInfo.categories.length
                    } else {
                        length = currentBusinessRange.maxVisible - currentBusinessRange.minVisible
                    }
                }
                return length
            },
            getVisualRangeCenter: function(range) {
                var businessRange = this._translator.getBusinessRange();
                var currentBusinessRange = range || businessRange;
                var _this$_options = this._options,
                    type = _this$_options.type,
                    logarithmBase = _this$_options.logarithmBase;
                var center;
                if (!(0, _type.isDefined)(currentBusinessRange.minVisible) || !(0, _type.isDefined)(currentBusinessRange.maxVisible)) {
                    return
                }
                if (type === _axes_constants.default.logarithmic) {
                    var allowNegatives = currentBusinessRange.allowNegatives,
                        linearThreshold = currentBusinessRange.linearThreshold,
                        minVisible = currentBusinessRange.minVisible,
                        maxVisible = currentBusinessRange.maxVisible;
                    center = (0, _utils.raiseToExt)((0, _math2.adjust)((0, _utils.getLogExt)(maxVisible, logarithmBase, allowNegatives, linearThreshold) + (0, _utils.getLogExt)(minVisible, logarithmBase, allowNegatives, linearThreshold)) / 2, logarithmBase, allowNegatives, linearThreshold)
                } else {
                    if (type === _axes_constants.default.discrete) {
                        var categoriesInfo = (0, _utils.getCategoriesInfo)(currentBusinessRange.categories, currentBusinessRange.minVisible, currentBusinessRange.maxVisible);
                        var index = Math.ceil(categoriesInfo.categories.length / 2) - 1;
                        center = businessRange.categories.indexOf(categoriesInfo.categories[index])
                    } else {
                        center = (currentBusinessRange.maxVisible.valueOf() + currentBusinessRange.minVisible.valueOf()) / 2
                    }
                }
                return center
            },
            setBusinessRange: function(range, axisReinitialized, oppositeVisualRangeUpdateMode, argCategories) {
                var _that$_seriesData$min, _that$_seriesData$max;
                var that = this;
                var options = that._options;
                var isDiscrete = options.type === _axes_constants.default.discrete;
                that._handleBusinessRangeChanged(oppositeVisualRangeUpdateMode, axisReinitialized, range);
                that._seriesData = new _range.Range(range);
                var dataIsEmpty = that._seriesData.isEmpty();
                that._prevDataWasEmpty = dataIsEmpty;
                that._seriesData.addRange({
                    categories: options.categories,
                    dataType: options.dataType,
                    axisType: options.type,
                    base: options.logarithmBase,
                    invert: options.inverted
                });
                that._resolveLogarithmicOptionsForRange(that._seriesData);
                if (!isDiscrete) {
                    if (!(0, _type.isDefined)(that._seriesData.min) && !(0, _type.isDefined)(that._seriesData.max)) {
                        var visualRange = that.getViewport();
                        visualRange && that._seriesData.addRange({
                            min: visualRange.startValue,
                            max: visualRange.endValue
                        })
                    }
                    var synchronizedValue = options.synchronizedValue;
                    if ((0, _type.isDefined)(synchronizedValue)) {
                        that._seriesData.addRange({
                            min: synchronizedValue,
                            max: synchronizedValue
                        })
                    }
                }
                that._seriesData.minVisible = null !== (_that$_seriesData$min = that._seriesData.minVisible) && void 0 !== _that$_seriesData$min ? _that$_seriesData$min : that._seriesData.min;
                that._seriesData.maxVisible = null !== (_that$_seriesData$max = that._seriesData.maxVisible) && void 0 !== _that$_seriesData$max ? _that$_seriesData$max : that._seriesData.max;
                if (!that.isArgumentAxis && options.showZero) {
                    that._seriesData.correctValueZeroLevel()
                }
                that._seriesData.sortCategories(that.getCategoriesSorter(argCategories));
                that._seriesData.userBreaks = that._seriesData.isEmpty() ? [] : that._getScaleBreaks(options, that._seriesData, that._series, that.isArgumentAxis);
                that._translator.updateBusinessRange(that._getViewportRange())
            },
            _addConstantLinesToRange: function(dataRange, minValueField, maxValueField) {
                this._outsideConstantLines.concat(this._insideConstantLines || []).forEach(function(cl) {
                    if (cl.options.extendAxis) {
                        var _dataRange$addRange;
                        var value = cl.getParsedValue();
                        dataRange.addRange((_dataRange$addRange = {}, _defineProperty(_dataRange$addRange, minValueField, value), _defineProperty(_dataRange$addRange, maxValueField, value), _dataRange$addRange))
                    }
                })
            },
            setGroupSeries: function(series) {
                this._series = series
            },
            getLabelsPosition: function() {
                var that = this;
                var options = that._options;
                var position = options.position;
                var labelShift = options.label.indentFromAxis + (that._axisShift || 0) + that._constantLabelOffset;
                var axisPosition = that._axisPosition;
                return position === TOP || position === LEFT ? axisPosition - labelShift : axisPosition + labelShift
            },
            getFormattedValue: function(value, options, point) {
                var labelOptions = this._options.label;
                return (0, _type.isDefined)(value) ? this.formatLabel(value, (0, _extend.extend)(true, {}, labelOptions, options), void 0, point) : null
            },
            _getBoundaryTicks: function(majors, viewPort) {
                var that = this;
                var length = majors.length;
                var options = that._options;
                var customBounds = options.customBoundTicks;
                var min = viewPort.minVisible;
                var max = viewPort.maxVisible;
                var addMinMax = options.showCustomBoundaryTicks ? that._boundaryTicksVisibility : {};
                var boundaryTicks = [];
                if (options.type === _axes_constants.default.discrete) {
                    if (that._tickOffset && 0 !== majors.length) {
                        boundaryTicks = [majors[0], majors[majors.length - 1]]
                    }
                } else {
                    if (customBounds) {
                        if (addMinMax.min && (0, _type.isDefined)(customBounds[0])) {
                            boundaryTicks.push(customBounds[0])
                        }
                        if (addMinMax.max && (0, _type.isDefined)(customBounds[1])) {
                            boundaryTicks.push(customBounds[1])
                        }
                    } else {
                        if (addMinMax.min && (0 === length || majors[0] > min)) {
                            boundaryTicks.push(min)
                        }
                        if (addMinMax.max && (0 === length || majors[length - 1] < max)) {
                            boundaryTicks.push(max)
                        }
                    }
                }
                return boundaryTicks
            },
            setPercentLabelFormat: function() {
                if (!this._hasLabelFormat) {
                    this._options.label.format = "percent"
                }
            },
            resetAutoLabelFormat: function() {
                if (!this._hasLabelFormat) {
                    delete this._options.label.format
                }
            },
            getMultipleAxesSpacing: function() {
                return this._options.multipleAxesSpacing || 0
            },
            getTicksValues: function() {
                return {
                    majorTicksValues: convertTicksToValues(this._majorTicks),
                    minorTicksValues: convertTicksToValues(this._minorTicks)
                }
            },
            estimateTickInterval: function(canvas) {
                var that = this;
                that.updateCanvas(canvas);
                return that._tickInterval !== that._getTicks(that._getViewportRange(), _common.noop, true).tickInterval
            },
            setTicks: function(ticks) {
                var majors = ticks.majorTicks || [];
                this._majorTicks = majors.map(createMajorTick(this, this._renderer, this._getSkippedCategory(majors)));
                this._minorTicks = (ticks.minorTicks || []).map(createMinorTick(this, this._renderer));
                this._isSynchronized = true
            },
            _adjustDivisionFactor: function(val) {
                return val
            },
            _getTicks: function(viewPort, incidentOccurred, skipTickGeneration) {
                var that = this;
                var options = that._options;
                var customTicks = options.customTicks;
                var customMinorTicks = options.customMinorTicks;
                return getTickGenerator(options, incidentOccurred || that._incidentOccurred, skipTickGeneration, that._translator.getBusinessRange().isEmpty(), that._adjustDivisionFactor.bind(that), viewPort)({
                    min: viewPort.minVisible,
                    max: viewPort.maxVisible,
                    categories: viewPort.categories,
                    isSpacedMargin: viewPort.isSpacedMargin
                }, that._getScreenDelta(), options.tickInterval, "ignore" === options.label.overlappingBehavior || options.forceUserTickInterval, {
                    majors: customTicks,
                    minors: customMinorTicks
                }, options.minorTickInterval, options.minorTickCount, that._initialBreaks)
            },
            _createTicksAndLabelFormat: function(range, incidentOccurred) {
                var options = this._options;
                var ticks = this._getTicks(range, incidentOccurred, false);
                if (!range.isEmpty() && options.type === _axes_constants.default.discrete && "datetime" === options.dataType && !this._hasLabelFormat && ticks.ticks.length) {
                    options.label.format = _format_helper.default.getDateFormatByTicks(ticks.ticks)
                }
                return ticks
            },
            getAggregationInfo: function(useAllAggregatedPoints, range) {
                var _visualRange$startVal, _visualRange$endValue, _that$_seriesData;
                var that = this;
                var options = that._options;
                var marginOptions = that._marginOptions;
                var businessRange = new _range.Range(that.getTranslator().getBusinessRange()).addRange(range);
                var visualRange = that.getViewport();
                var minVisible = null !== (_visualRange$startVal = null === visualRange || void 0 === visualRange ? void 0 : visualRange.startValue) && void 0 !== _visualRange$startVal ? _visualRange$startVal : businessRange.minVisible;
                var maxVisible = null !== (_visualRange$endValue = null === visualRange || void 0 === visualRange ? void 0 : visualRange.endValue) && void 0 !== _visualRange$endValue ? _visualRange$endValue : businessRange.maxVisible;
                var ticks = [];
                if (options.type === _axes_constants.default.discrete && options.aggregateByCategory) {
                    return {
                        aggregateByCategory: true
                    }
                }
                var aggregationInterval = options.aggregationInterval;
                var aggregationGroupWidth = options.aggregationGroupWidth;
                if (!aggregationGroupWidth && marginOptions) {
                    if (marginOptions.checkInterval) {
                        aggregationGroupWidth = options.axisDivisionFactor
                    }
                    if (marginOptions.sizePointNormalState) {
                        aggregationGroupWidth = Math.min(marginOptions.sizePointNormalState, options.axisDivisionFactor)
                    }
                }
                var minInterval = !options.aggregationGroupWidth && !aggregationInterval && range.interval;
                var generateTicks = configureGenerator(options, aggregationGroupWidth, businessRange, that._getScreenDelta(), minInterval);
                var tickInterval = generateTicks(aggregationInterval, true, minVisible, maxVisible, null === (_that$_seriesData = that._seriesData) || void 0 === _that$_seriesData ? void 0 : _that$_seriesData.breaks).tickInterval;
                if (options.type !== _axes_constants.default.discrete) {
                    var min = useAllAggregatedPoints ? businessRange.min : minVisible;
                    var max = useAllAggregatedPoints ? businessRange.max : maxVisible;
                    if ((0, _type.isDefined)(min) && (0, _type.isDefined)(max)) {
                        var add = (0, _utils.getAddFunction)({
                            base: options.logarithmBase,
                            axisType: options.type,
                            dataType: options.dataType
                        }, false);
                        var start = min;
                        var end = max;
                        if (!useAllAggregatedPoints) {
                            var maxMinDistance = Math.max(that.calculateInterval(max, min), "datetime" === options.dataType ? _date.default.dateToMilliseconds(tickInterval) : tickInterval);
                            start = add(min, maxMinDistance, -1);
                            end = add(max, maxMinDistance)
                        }
                        start = start < businessRange.min ? businessRange.min : start;
                        end = end > businessRange.max ? businessRange.max : end;
                        var breaks = that._getScaleBreaks(options, {
                            minVisible: start,
                            maxVisible: end
                        }, that._series, that.isArgumentAxis);
                        var filteredBreaks = that._filterBreaks(breaks, {
                            minVisible: start,
                            maxVisible: end
                        }, options.breakStyle);
                        ticks = generateTicks(tickInterval, false, start, end, filteredBreaks).ticks
                    }
                }
                that._aggregationInterval = tickInterval;
                return {
                    interval: tickInterval,
                    ticks: ticks
                }
            },
            createTicks: function(canvas) {
                var that = this;
                var renderer = that._renderer;
                var options = that._options;
                if (!canvas) {
                    return
                }
                that._isSynchronized = false;
                that.updateCanvas(canvas);
                var range = that._getViewportRange();
                that._initialBreaks = range.breaks = this._seriesData.breaks = that._filterBreaks(this._seriesData.userBreaks, range, options.breakStyle);
                that._estimatedTickInterval = that._getTicks(that.adjustViewport(this._seriesData), _common.noop, true).tickInterval;
                var margins = this._calculateValueMargins();
                range.addRange({
                    minVisible: margins.minValue,
                    maxVisible: margins.maxValue,
                    isSpacedMargin: margins.isSpacedMargin
                });
                var ticks = that._createTicksAndLabelFormat(range);
                var boundaryTicks = that._getBoundaryTicks(ticks.ticks, that._getViewportRange());
                if (options.showCustomBoundaryTicks && boundaryTicks.length) {
                    that._boundaryTicks = [boundaryTicks[0]].map(createBoundaryTick(that, renderer, true));
                    if (boundaryTicks.length > 1) {
                        that._boundaryTicks = that._boundaryTicks.concat([boundaryTicks[1]].map(createBoundaryTick(that, renderer, false)))
                    }
                } else {
                    that._boundaryTicks = []
                }
                var minors = (ticks.minorTicks || []).filter(function(minor) {
                    return !boundaryTicks.some(function(boundary) {
                        return (0, _utils.valueOf)(boundary) === (0, _utils.valueOf)(minor)
                    })
                });
                that._tickInterval = ticks.tickInterval;
                that._minorTickInterval = ticks.minorTickInterval;
                var oldMajorTicks = that._majorTicks || [];
                var majorTicksByValues = oldMajorTicks.reduce(function(r, t) {
                    r[t.value.valueOf()] = t;
                    return r
                }, {});
                var sameType = (0, _type.type)(ticks.ticks[0]) === (0, _type.type)(oldMajorTicks[0] && oldMajorTicks[0].value);
                var skippedCategory = that._getSkippedCategory(ticks.ticks);
                var majorTicks = ticks.ticks.map(function(v) {
                    var tick = majorTicksByValues[v.valueOf()];
                    if (tick && sameType) {
                        delete majorTicksByValues[v.valueOf()];
                        tick.setSkippedCategory(skippedCategory);
                        return tick
                    } else {
                        return createMajorTick(that, renderer, skippedCategory)(v)
                    }
                });
                that._majorTicks = majorTicks;
                var oldMinorTicks = that._minorTicks || [];
                that._minorTicks = minors.map(function(v, i) {
                    var minorTick = oldMinorTicks[i];
                    if (minorTick) {
                        minorTick.updateValue(v);
                        return minorTick
                    }
                    return createMinorTick(that, renderer)(v)
                });
                that._ticksToRemove = Object.keys(majorTicksByValues).map(function(k) {
                    return majorTicksByValues[k]
                }).concat(oldMinorTicks.slice(that._minorTicks.length, oldMinorTicks.length));
                that._ticksToRemove.forEach(function(t) {
                    var _t$label;
                    return null === (_t$label = t.label) || void 0 === _t$label ? void 0 : _t$label.removeTitle()
                });
                if (ticks.breaks) {
                    that._seriesData.breaks = ticks.breaks
                }
                that._reinitTranslator(that._getViewportRange())
            },
            _reinitTranslator: function(range) {
                var that = this;
                var translator = that._translator;
                if (that._isSynchronized) {
                    return
                }
                translator.updateBusinessRange(range)
            },
            _getViewportRange: function() {
                return this.adjustViewport(this._seriesData)
            },
            setMarginOptions: function(options) {
                this._marginOptions = options
            },
            getMarginOptions: function() {
                var _this$_marginOptions;
                return null !== (_this$_marginOptions = this._marginOptions) && void 0 !== _this$_marginOptions ? _this$_marginOptions : {}
            },
            _calculateRangeInterval: function(interval) {
                var isDateTime = "datetime" === this._options.dataType;
                var minArgs = [];
                var addToArgs = function(value) {
                    (0, _type.isDefined)(value) && minArgs.push(isDateTime ? _date.default.dateToMilliseconds(value) : value)
                };
                addToArgs(this._tickInterval);
                addToArgs(this._estimatedTickInterval);
                (0, _type.isDefined)(interval) && minArgs.push(interval);
                addToArgs(this._aggregationInterval);
                return this._calculateWorkWeekInterval(_min.apply(this, minArgs))
            },
            _calculateWorkWeekInterval: function(businessInterval) {
                var options = this._options;
                if ("datetime" === options.dataType && options.workdaysOnly && businessInterval) {
                    var workWeek = options.workWeek.length * dateIntervals.day;
                    var weekend = dateIntervals.week - workWeek;
                    if (workWeek !== businessInterval && weekend < businessInterval) {
                        var weekendsCount = Math.ceil(businessInterval / dateIntervals.week);
                        businessInterval = weekend >= businessInterval ? dateIntervals.day : businessInterval - weekend * weekendsCount
                    } else {
                        if (weekend >= businessInterval && businessInterval > dateIntervals.day) {
                            businessInterval = dateIntervals.day
                        }
                    }
                }
                return businessInterval
            },
            _getConvertIntervalCoefficient: function(intervalInPx, screenDelta) {
                var ratioOfCanvasRange = this._translator.ratioOfCanvasRange();
                return ratioOfCanvasRange / (ratioOfCanvasRange * screenDelta / (intervalInPx + screenDelta))
            },
            _calculateValueMargins: function(ticks) {
                this._resetMargins();
                var that = this;
                var margins = that.getMarginOptions();
                var marginSize = (margins.size || 0) / 2;
                var options = that._options;
                var dataRange = that._getViewportRange();
                var viewPort = that.getViewport();
                var screenDelta = that._getScreenDelta();
                var isDiscrete = (options.type || "").indexOf(_axes_constants.default.discrete) !== -1;
                var valueMarginsEnabled = options.valueMarginsEnabled && !isDiscrete && !that.customPositionIsBoundaryOrthogonalAxis();
                var translator = that._translator;
                var minValueMargin = options.minValueMargin;
                var maxValueMargin = options.maxValueMargin;
                var minPadding = 0;
                var maxPadding = 0;
                var interval = 0;
                var rangeInterval;
                if (dataRange.stubData || !screenDelta) {
                    return {
                        startPadding: 0,
                        endPadding: 0
                    }
                }
                if (that.isArgumentAxis && margins.checkInterval) {
                    rangeInterval = that._calculateRangeInterval(dataRange.interval);
                    var pxInterval = translator.getInterval(rangeInterval);
                    if (isFinite(pxInterval)) {
                        interval = Math.ceil(pxInterval / (2 * that._getConvertIntervalCoefficient(pxInterval, screenDelta)))
                    } else {
                        rangeInterval = 0
                    }
                }
                var minPercentPadding;
                var maxPercentPadding;
                var maxPaddingValue = screenDelta * MAX_MARGIN_VALUE / 2;
                if (valueMarginsEnabled) {
                    if ((0, _type.isDefined)(minValueMargin)) {
                        minPercentPadding = isFinite(minValueMargin) ? minValueMargin : 0
                    } else {
                        if (!that.isArgumentAxis && margins.checkInterval && (0, _utils.valueOf)(dataRange.minVisible) > 0 && (0, _utils.valueOf)(dataRange.minVisible) === (0, _utils.valueOf)(dataRange.min)) {
                            minPadding = MIN_BAR_MARGIN
                        } else {
                            minPadding = Math.max(marginSize, interval);
                            minPadding = Math.min(maxPaddingValue, minPadding)
                        }
                    }
                    if ((0, _type.isDefined)(maxValueMargin)) {
                        maxPercentPadding = isFinite(maxValueMargin) ? maxValueMargin : 0
                    } else {
                        if (!that.isArgumentAxis && margins.checkInterval && (0, _utils.valueOf)(dataRange.maxVisible) < 0 && (0, _utils.valueOf)(dataRange.maxVisible) === (0, _utils.valueOf)(dataRange.max)) {
                            maxPadding = MIN_BAR_MARGIN
                        } else {
                            maxPadding = Math.max(marginSize, interval);
                            maxPadding = Math.min(maxPaddingValue, maxPadding)
                        }
                    }
                }
                var percentStick = margins.percentStick && !this.isArgumentAxis;
                if (percentStick) {
                    if (1 === _abs(dataRange.max)) {
                        maxPadding = 0
                    }
                    if (1 === _abs(dataRange.min)) {
                        minPadding = 0
                    }
                }
                var canvasStartEnd = that._getCanvasStartEnd();
                var commonMargin = 1 + (minPercentPadding || 0) + (maxPercentPadding || 0);
                var screenDeltaWithMargins = (screenDelta - minPadding - maxPadding) / commonMargin || screenDelta;
                if (void 0 !== minPercentPadding || void 0 !== maxPercentPadding) {
                    if (void 0 !== minPercentPadding) {
                        minPadding = screenDeltaWithMargins * minPercentPadding
                    }
                    if (void 0 !== maxPercentPadding) {
                        maxPadding = screenDeltaWithMargins * maxPercentPadding
                    }
                }
                var minValue;
                var maxValue;
                if (options.type !== _axes_constants.default.discrete && ticks && ticks.length > 1 && !options.skipViewportExtending && !viewPort.action && false !== options.endOnTick) {
                    var length = ticks.length;
                    var firstTickPosition = translator.translate(ticks[0].value);
                    var lastTickPosition = translator.translate(ticks[length - 1].value);
                    var invertMultiplier = firstTickPosition > lastTickPosition ? -1 : 1;
                    var minTickPadding = _max(invertMultiplier * (canvasStartEnd.start - firstTickPosition), 0);
                    var maxTickPadding = _max(invertMultiplier * (lastTickPosition - canvasStartEnd.end), 0);
                    if (minTickPadding > minPadding || maxTickPadding > maxPadding) {
                        var commonPadding = maxTickPadding + minTickPadding;
                        var coeff = that._getConvertIntervalCoefficient(commonPadding, screenDelta);
                        if (minTickPadding >= minPadding) {
                            minValue = ticks[0].value
                        }
                        if (maxTickPadding >= maxPadding) {
                            maxValue = ticks[length - 1].value
                        }
                        minPadding = _max(minTickPadding, minPadding) / coeff;
                        maxPadding = _max(maxTickPadding, maxPadding) / coeff
                    }
                }
                minPercentPadding = void 0 === minPercentPadding ? minPadding / screenDeltaWithMargins : minPercentPadding;
                maxPercentPadding = void 0 === maxPercentPadding ? maxPadding / screenDeltaWithMargins : maxPercentPadding;
                if (!isDiscrete) {
                    if (this._translator.isInverted()) {
                        var _minValue, _maxValue;
                        minValue = null !== (_minValue = minValue) && void 0 !== _minValue ? _minValue : translator.from(canvasStartEnd.start + screenDelta * minPercentPadding, -1);
                        maxValue = null !== (_maxValue = maxValue) && void 0 !== _maxValue ? _maxValue : translator.from(canvasStartEnd.end - screenDelta * maxPercentPadding, 1)
                    } else {
                        var _minValue2, _maxValue2;
                        minValue = null !== (_minValue2 = minValue) && void 0 !== _minValue2 ? _minValue2 : translator.from(canvasStartEnd.start - screenDelta * minPercentPadding, -1);
                        maxValue = null !== (_maxValue2 = maxValue) && void 0 !== _maxValue2 ? _maxValue2 : translator.from(canvasStartEnd.end + screenDelta * maxPercentPadding, 1)
                    }
                }
                var _that$getCorrectedVal = that.getCorrectedValuesToZero(minValue, maxValue),
                    correctedMin = _that$getCorrectedVal.correctedMin,
                    correctedMax = _that$getCorrectedVal.correctedMax,
                    start = _that$getCorrectedVal.start,
                    end = _that$getCorrectedVal.end;
                minPadding = null !== start && void 0 !== start ? start : minPadding;
                maxPadding = null !== end && void 0 !== end ? end : maxPadding;
                return {
                    startPadding: translator.isInverted() ? maxPadding : minPadding,
                    endPadding: translator.isInverted() ? minPadding : maxPadding,
                    minValue: null !== correctedMin && void 0 !== correctedMin ? correctedMin : minValue,
                    maxValue: null !== correctedMax && void 0 !== correctedMax ? correctedMax : maxValue,
                    interval: rangeInterval,
                    isSpacedMargin: minPadding === maxPadding && 0 !== minPadding
                }
            },
            getCorrectedValuesToZero: function(minValue, maxValue) {
                var that = this;
                var translator = that._translator;
                var canvasStartEnd = that._getCanvasStartEnd();
                var dataRange = that._getViewportRange();
                var screenDelta = that._getScreenDelta();
                var options = that._options;
                var start;
                var end;
                var correctedMin;
                var correctedMax;
                var correctZeroLevel = function(minPoint, maxPoint) {
                    var minExpectedPadding = _abs(canvasStartEnd.start - minPoint);
                    var maxExpectedPadding = _abs(canvasStartEnd.end - maxPoint);
                    var coeff = that._getConvertIntervalCoefficient(minExpectedPadding + maxExpectedPadding, screenDelta);
                    start = minExpectedPadding / coeff;
                    end = maxExpectedPadding / coeff
                };
                if (!that.isArgumentAxis && "datetime" !== options.dataType) {
                    if (minValue * dataRange.min <= 0 && minValue * dataRange.minVisible <= 0) {
                        correctZeroLevel(translator.translate(0), translator.translate(maxValue));
                        correctedMin = 0
                    }
                    if (maxValue * dataRange.max <= 0 && maxValue * dataRange.maxVisible <= 0) {
                        correctZeroLevel(translator.translate(minValue), translator.translate(0));
                        correctedMax = 0
                    }
                }
                return {
                    start: isFinite(start) ? start : null,
                    end: isFinite(end) ? end : null,
                    correctedMin: correctedMin,
                    correctedMax: correctedMax
                }
            },
            applyMargins: function() {
                if (this._isSynchronized) {
                    return
                }
                var margins = this._calculateValueMargins(this._majorTicks);
                var canvas = (0, _extend.extend)({}, this._canvas, {
                    startPadding: margins.startPadding,
                    endPadding: margins.endPadding
                });
                this._translator.updateCanvas(this._processCanvas(canvas));
                if (isFinite(margins.interval)) {
                    var br = this._translator.getBusinessRange();
                    br.addRange({
                        interval: margins.interval
                    });
                    this._translator.updateBusinessRange(br)
                }
            },
            _resetMargins: function() {
                this._reinitTranslator(this._getViewportRange());
                if (this._canvas) {
                    this._translator.updateCanvas(this._processCanvas(this._canvas))
                }
            },
            _createConstantLines: function() {
                var _this2 = this;
                var constantLines = (this._options.constantLines || []).map(function(o) {
                    return (0, _constant_line.default)(_this2, o)
                });
                this._outsideConstantLines = constantLines.filter(function(l) {
                    return "outside" === l.labelPosition
                });
                this._insideConstantLines = constantLines.filter(function(l) {
                    return "inside" === l.labelPosition
                })
            },
            draw: function(canvas, borderOptions) {
                var that = this;
                var options = this._options;
                that.borderOptions = borderOptions || {
                    visible: false
                };
                that._resetMargins();
                that.createTicks(canvas);
                that.applyMargins();
                that._clearAxisGroups();
                initTickCoords(that._majorTicks);
                initTickCoords(that._minorTicks);
                initTickCoords(that._boundaryTicks);
                that._axisGroup.append(that._axesContainerGroup);
                that._drawAxis();
                that._drawTitle();
                drawTickMarks(that._majorTicks, options.tick);
                drawTickMarks(that._minorTicks, options.minorTick);
                drawTickMarks(that._boundaryTicks, options.tick);
                var drawGridLine = that._getGridLineDrawer();
                drawGrids(that._majorTicks, drawGridLine);
                drawGrids(that._minorTicks, drawGridLine);
                callAction(that._majorTicks, "drawLabel", that._getViewportRange(), that._getTemplate());
                that._templatesRendered && that._templatesRendered.reject();
                that._templatesRendered = new _deferred.Deferred;
                _deferred.when.apply(this, that._majorTicks.map(function(tick) {
                    return tick.getTemplateDeferred()
                })).done(function() {
                    that._templatesRendered.resolve()
                });
                that._majorTicks.forEach(function(tick) {
                    tick.labelRotationAngle = 0;
                    tick.labelAlignment = void 0;
                    tick.labelOffset = 0
                });
                callAction(that._outsideConstantLines.concat(that._insideConstantLines), "draw");
                callAction(that._strips, "draw");
                that._dateMarkers = that._drawDateMarkers() || [];
                that._labelAxesGroup && that._axisStripLabelGroup.append(that._labelAxesGroup);
                that._gridContainerGroup && that._axisGridGroup.append(that._gridContainerGroup);
                that._stripsGroup && that._axisStripGroup.append(that._stripsGroup);
                if (that._constantLinesGroup) {
                    that._axisConstantLineGroups.above.inside.append(that._constantLinesGroup.above);
                    that._axisConstantLineGroups.above.outside1.append(that._constantLinesGroup.above);
                    that._axisConstantLineGroups.above.outside2.append(that._constantLinesGroup.above);
                    that._axisConstantLineGroups.under.inside.append(that._constantLinesGroup.under);
                    that._axisConstantLineGroups.under.outside1.append(that._constantLinesGroup.under);
                    that._axisConstantLineGroups.under.outside2.append(that._constantLinesGroup.under)
                }
                that._measureTitle();
                (0, _axes_utils.measureLabels)(that._majorTicks);
                !options.label.template && that._applyWordWrap();
                (0, _axes_utils.measureLabels)(that._outsideConstantLines);
                (0, _axes_utils.measureLabels)(that._insideConstantLines);
                (0, _axes_utils.measureLabels)(that._strips);
                (0, _axes_utils.measureLabels)(that._dateMarkers);
                that._adjustConstantLineLabels(that._insideConstantLines);
                that._adjustStripLabels();
                var offset = that._constantLabelOffset = that._adjustConstantLineLabels(that._outsideConstantLines);
                if (!that._translator.getBusinessRange().isEmpty()) {
                    that._setLabelsPlacement();
                    offset = that._adjustLabels(offset)
                }
                offset = that._adjustDateMarkers(offset);
                that._adjustTitle(offset)
            },
            getTemplatesDef: function() {
                return this._templatesRendered
            },
            setRenderedState: function(state) {
                this._drawn = state
            },
            isRendered: function() {
                return this._drawn
            },
            _applyWordWrap: function() {
                var that = this;
                var convertedTickInterval;
                var textWidth;
                var textHeight;
                var options = this._options;
                var tickInterval = that._tickInterval;
                if ((0, _type.isDefined)(tickInterval)) {
                    convertedTickInterval = that.getTranslator().getInterval("datetime" === options.dataType ? _date.default.dateToMilliseconds(tickInterval) : tickInterval)
                }
                var displayMode = that._validateDisplayMode(options.label.displayMode);
                var overlappingMode = that._validateOverlappingMode(options.label.overlappingBehavior, displayMode);
                var wordWrapMode = options.label.wordWrap || "none";
                var overflowMode = options.label.textOverflow || "none";
                if (("none" !== wordWrapMode || "none" !== overflowMode) && displayMode !== ROTATE && overlappingMode !== ROTATE && "auto" !== overlappingMode) {
                    var usefulSpace = (0, _type.isDefined)(options.placeholderSize) ? options.placeholderSize - options.label.indentFromAxis : void 0;
                    if (that._isHorizontal) {
                        textWidth = convertedTickInterval;
                        textHeight = usefulSpace
                    } else {
                        textWidth = usefulSpace;
                        textHeight = convertedTickInterval
                    }
                    var correctByWidth = false;
                    var correctByHeight = false;
                    if (textWidth) {
                        if (that._majorTicks.some(function(tick) {
                                return tick.labelBBox.width > textWidth
                            })) {
                            correctByWidth = true
                        }
                    }
                    if (textHeight) {
                        if (that._majorTicks.some(function(tick) {
                                return tick.labelBBox.height > textHeight
                            })) {
                            correctByHeight = true
                        }
                    }
                    if (correctByWidth || correctByHeight) {
                        that._majorTicks.forEach(function(tick) {
                            tick.label && tick.label.setMaxSize(textWidth, textHeight, options.label)
                        });
                        (0, _axes_utils.measureLabels)(that._majorTicks)
                    }
                }
            },
            _measureTitle: _common.noop,
            animate: function() {
                callAction(this._majorTicks, "animateLabels")
            },
            updateSize: function(canvas, animate) {
                var updateTitle = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : true;
                var that = this;
                that.updateCanvas(canvas);
                if (updateTitle) {
                    that._checkTitleOverflow();
                    that._measureTitle();
                    that._updateTitleCoords()
                }
                that._reinitTranslator(that._getViewportRange());
                that.applyMargins();
                var animationEnabled = !that._firstDrawing && animate;
                var options = that._options;
                initTickCoords(that._majorTicks);
                initTickCoords(that._minorTicks);
                initTickCoords(that._boundaryTicks);
                if (that._resetApplyingAnimation && !that._firstDrawing) {
                    that._resetStartCoordinates()
                }
                cleanUpInvalidTicks(that._majorTicks);
                cleanUpInvalidTicks(that._minorTicks);
                cleanUpInvalidTicks(that._boundaryTicks);
                if (that._axisElement) {
                    that._updateAxisElementPosition()
                }
                updateTicksPosition(that._majorTicks, options.tick, animationEnabled);
                updateTicksPosition(that._minorTicks, options.minorTick, animationEnabled);
                updateTicksPosition(that._boundaryTicks, options.tick);
                callAction(that._majorTicks, "updateLabelPosition", animationEnabled);
                that._outsideConstantLines.concat(that._insideConstantLines || []).forEach(function(l) {
                    return l.updatePosition(animationEnabled)
                });
                callAction(that._strips, "updatePosition", animationEnabled);
                updateGridsPosition(that._majorTicks, animationEnabled);
                updateGridsPosition(that._minorTicks, animationEnabled);
                if (animationEnabled) {
                    callAction(that._ticksToRemove || [], "fadeOutElements")
                }
                that.prepareAnimation();
                that._ticksToRemove = null;
                if (!that._translator.getBusinessRange().isEmpty()) {
                    that._firstDrawing = false
                }
                that._resetApplyingAnimation = false;
                that._updateLabelsPosition()
            },
            _updateLabelsPosition: _common.noop,
            prepareAnimation: function() {
                var that = this;
                var action = "saveCoords";
                callAction(that._majorTicks, action);
                callAction(that._minorTicks, action);
                callAction(that._insideConstantLines, action);
                callAction(that._outsideConstantLines, action);
                callAction(that._strips, action)
            },
            _resetStartCoordinates: function() {
                var that = this;
                var action = "resetCoordinates";
                callAction(that._majorTicks, action);
                callAction(that._minorTicks, action);
                callAction(that._insideConstantLines, action);
                callAction(that._outsideConstantLines, action);
                callAction(that._strips, action)
            },
            applyClipRects: function(elementsClipID, canvasClipID) {
                this._axisGroup.attr({
                    "clip-path": canvasClipID
                });
                this._axisStripGroup.attr({
                    "clip-path": elementsClipID
                })
            },
            _validateVisualRange: function(optionValue) {
                var range = (0, _utils.getVizRangeObject)(optionValue);
                if (void 0 !== range.startValue) {
                    range.startValue = this.validateUnit(range.startValue)
                }
                if (void 0 !== range.endValue) {
                    range.endValue = this.validateUnit(range.endValue)
                }
                return (0, _utils.convertVisualRangeObject)(range, !_isArray(optionValue))
            },
            _validateOptions: function(options) {
                var that = this;
                options.wholeRange = that._validateVisualRange(options.wholeRange);
                options.visualRange = options._customVisualRange = that._validateVisualRange(options._customVisualRange);
                that._setVisualRange(options._customVisualRange)
            },
            beforeCleanGroups: function() {
                this._options.label.template && this._axisElementsGroup && this._axisElementsGroup.linkRemove()
            },
            afterCleanGroups: function() {
                this._options.label.template && this._axisElementsGroup && this._axisElementsGroup.linkAppend()
            },
            validate: function() {
                var that = this;
                var options = that._options;
                var dataType = that.isArgumentAxis ? options.argumentType : options.valueType;
                var parser = dataType ? (0, _parse_utils.getParser)(dataType) : function(unit) {
                    return unit
                };
                that.parser = parser;
                options.dataType = dataType;
                that._validateOptions(options)
            },
            resetVisualRange: function(isSilent) {
                this._seriesData.minVisible = this._seriesData.min;
                this._seriesData.maxVisible = this._seriesData.max;
                this.handleZooming([null, null], {
                    start: !!isSilent,
                    end: !!isSilent
                })
            },
            _setVisualRange: function(visualRange, allowPartialUpdate) {
                var range = this.adjustRange((0, _utils.getVizRangeObject)(visualRange));
                if (allowPartialUpdate) {
                    (0, _type.isDefined)(range.startValue) && (this._viewport.startValue = range.startValue);
                    (0, _type.isDefined)(range.endValue) && (this._viewport.endValue = range.endValue)
                } else {
                    this._viewport = range
                }
            },
            _applyZooming: function(visualRange, allowPartialUpdate) {
                var that = this;
                that._resetVisualRangeOption();
                that._setVisualRange(visualRange, allowPartialUpdate);
                var viewPort = that.getViewport();
                that._seriesData.userBreaks = that._getScaleBreaks(that._options, {
                    minVisible: viewPort.startValue,
                    maxVisible: viewPort.endValue
                }, that._series, that.isArgumentAxis);
                that._translator.updateBusinessRange(that._getViewportRange())
            },
            getZoomStartEventArg: function(event, actionType) {
                return {
                    axis: this,
                    range: this.visualRange(),
                    cancel: false,
                    event: event,
                    actionType: actionType
                }
            },
            _getZoomEndEventArg: function(previousRange, event, actionType, zoomFactor, shift) {
                var newRange = this.visualRange();
                return {
                    axis: this,
                    previousRange: previousRange,
                    range: newRange,
                    cancel: false,
                    event: event,
                    actionType: actionType,
                    zoomFactor: zoomFactor,
                    shift: shift,
                    rangeStart: newRange.startValue,
                    rangeEnd: newRange.endValue
                }
            },
            getZoomBounds: function() {
                var wholeRange = (0, _utils.getVizRangeObject)(this._options.wholeRange);
                var range = this.getTranslator().getBusinessRange();
                var secondPriorityRange = {
                    startValue: getZoomBoundValue(this._initRange.startValue, range.min),
                    endValue: getZoomBoundValue(this._initRange.endValue, range.max)
                };
                return {
                    startValue: getZoomBoundValue(wholeRange.startValue, secondPriorityRange.startValue),
                    endValue: getZoomBoundValue(wholeRange.endValue, secondPriorityRange.endValue)
                }
            },
            setInitRange: function() {
                this._initRange = {};
                if (0 === Object.keys(this._options.wholeRange || {}).length) {
                    this._initRange = this.getZoomBounds()
                }
            },
            _resetVisualRangeOption: function() {
                this._options._customVisualRange = {}
            },
            getTemplatesGroups: function() {
                var ticks = this._majorTicks;
                if (ticks) {
                    return this._majorTicks.map(function(tick) {
                        return tick.templateContainer
                    }).filter(function(item) {
                        return (0, _type.isDefined)(item)
                    })
                } else {
                    return []
                }
            },
            setCustomVisualRange: function(range) {
                this._options._customVisualRange = range
            },
            visualRange: function visualRange() {
                var that = this;
                var args = arguments;
                var visualRange;
                if (0 === args.length) {
                    var adjustedRange = that._getAdjustedBusinessRange();
                    var startValue = adjustedRange.minVisible;
                    var endValue = adjustedRange.maxVisible;
                    if (that._options.type === _axes_constants.default.discrete) {
                        var _startValue, _endValue;
                        startValue = null !== (_startValue = startValue) && void 0 !== _startValue ? _startValue : adjustedRange.categories[0];
                        endValue = null !== (_endValue = endValue) && void 0 !== _endValue ? _endValue : adjustedRange.categories[adjustedRange.categories.length - 1];
                        return {
                            startValue: startValue,
                            endValue: endValue,
                            categories: (0, _utils.getCategoriesInfo)(adjustedRange.categories, startValue, endValue).categories
                        }
                    }
                    return {
                        startValue: startValue,
                        endValue: endValue
                    }
                } else {
                    if (_isArray(args[0])) {
                        visualRange = args[0]
                    } else {
                        if ((0, _type.isPlainObject)(args[0])) {
                            visualRange = (0, _extend.extend)({}, args[0])
                        } else {
                            visualRange = [args[0], args[1]]
                        }
                    }
                }
                var zoomResults = that.handleZooming(visualRange, args[1]);
                if (!zoomResults.isPrevented) {
                    that._visualRange(that, zoomResults)
                }
            },
            handleZooming: function(visualRange, preventEvents, domEvent, action) {
                var that = this;
                preventEvents = preventEvents || {};
                if ((0, _type.isDefined)(visualRange)) {
                    visualRange = that._validateVisualRange(visualRange);
                    visualRange.action = action
                }
                var zoomStartEvent = that.getZoomStartEventArg(domEvent, action);
                var previousRange = zoomStartEvent.range;
                !preventEvents.start && that._eventTrigger("zoomStart", zoomStartEvent);
                var zoomResults = {
                    isPrevented: zoomStartEvent.cancel,
                    skipEventRising: preventEvents.skipEventRising,
                    range: visualRange || zoomStartEvent.range
                };
                if (!zoomStartEvent.cancel) {
                    (0, _type.isDefined)(visualRange) && that._applyZooming(visualRange, preventEvents.allowPartialUpdate);
                    if (!(0, _type.isDefined)(that._storedZoomEndParams)) {
                        that._storedZoomEndParams = {
                            startRange: previousRange,
                            type: this.getOptions().type
                        }
                    }
                    that._storedZoomEndParams.event = domEvent;
                    that._storedZoomEndParams.action = action;
                    that._storedZoomEndParams.prevent = !!preventEvents.end
                }
                return zoomResults
            },
            handleZoomEnd: function() {
                var that = this;
                if ((0, _type.isDefined)(that._storedZoomEndParams) && !that._storedZoomEndParams.prevent) {
                    var previousRange = that._storedZoomEndParams.startRange;
                    var domEvent = that._storedZoomEndParams.event;
                    var action = that._storedZoomEndParams.action;
                    var previousBusinessRange = {
                        minVisible: previousRange.startValue,
                        maxVisible: previousRange.endValue,
                        categories: previousRange.categories
                    };
                    var typeIsNotChanged = that.getOptions().type === that._storedZoomEndParams.type;
                    var shift = typeIsNotChanged ? (0, _math2.adjust)(that.getVisualRangeCenter() - that.getVisualRangeCenter(previousBusinessRange)) : NaN;
                    var zoomFactor = typeIsNotChanged ? +(Math.round(that.getVisualRangeLength(previousBusinessRange) / (that.getVisualRangeLength() || 1) + "e+2") + "e-2") : NaN;
                    var zoomEndEvent = that._getZoomEndEventArg(previousRange, domEvent, action, zoomFactor, shift);
                    zoomEndEvent.cancel = that.checkZoomingLowerLimitOvercome(1 === zoomFactor ? "pan" : "zoom", zoomFactor).stopInteraction;
                    that._eventTrigger("zoomEnd", zoomEndEvent);
                    if (zoomEndEvent.cancel) {
                        that._restorePreviousVisualRange(previousRange)
                    }
                    that._storedZoomEndParams = null
                }
            },
            _restorePreviousVisualRange: function(previousRange) {
                var that = this;
                that._storedZoomEndParams = null;
                that._applyZooming(previousRange);
                that._visualRange(that, previousRange)
            },
            checkZoomingLowerLimitOvercome: function(actionType, zoomFactor, range) {
                var that = this;
                var options = that._options;
                var translator = that._translator;
                var minZoom = options.minVisualRangeLength;
                var correctedRange = range;
                var visualRange;
                var isOvercoming = "zoom" === actionType && zoomFactor >= 1;
                var businessRange = translator.getBusinessRange();
                if (range) {
                    visualRange = that.adjustRange((0, _utils.getVizRangeObject)(range));
                    visualRange = {
                        minVisible: visualRange.startValue,
                        maxVisible: visualRange.endValue,
                        categories: businessRange.categories
                    }
                }
                var beforeVisualRangeLength = that.getVisualRangeLength(businessRange);
                var afterVisualRangeLength = that.getVisualRangeLength(visualRange);
                if ((0, _type.isDefined)(minZoom) || "discrete" === options.type) {
                    minZoom = translator.convert(minZoom);
                    if (visualRange && minZoom < beforeVisualRangeLength && minZoom >= afterVisualRangeLength) {
                        correctedRange = (0, _utils.getVizRangeObject)(translator.getRangeByMinZoomValue(minZoom, visualRange));
                        isOvercoming = false
                    } else {
                        isOvercoming &= minZoom > afterVisualRangeLength
                    }
                } else {
                    var canvasLength = that._translator.canvasLength;
                    var fullRange = {
                        minVisible: businessRange.min,
                        maxVisible: businessRange.max,
                        categories: businessRange.categories
                    };
                    isOvercoming &= that.getVisualRangeLength(fullRange) / canvasLength >= afterVisualRangeLength
                }
                return {
                    stopInteraction: !!isOvercoming,
                    correctedRange: correctedRange
                }
            },
            dataVisualRangeIsReduced: function() {
                var minDataValue;
                var maxDataValue;
                var translator = this.getTranslator();
                if ("discrete" === this._options.type) {
                    var categories = translator.getBusinessRange().categories;
                    minDataValue = categories[0];
                    maxDataValue = categories[categories.length - 1]
                } else {
                    var seriesData = this._seriesData;
                    minDataValue = seriesData.min;
                    maxDataValue = seriesData.max
                }
                if (!(0, _type.isDefined)(minDataValue) || !(0, _type.isDefined)(maxDataValue)) {
                    return false
                }
                var startPoint = translator.translate(minDataValue);
                var endPoint = translator.translate(maxDataValue);
                var edges = [Math.min(startPoint, endPoint), Math.max(startPoint, endPoint)];
                var visualRange = this.visualRange();
                var visualRangeStartPoint = translator.translate(visualRange.startValue);
                var visualRangeEndPoint = translator.translate(visualRange.endValue);
                return visualRangeStartPoint > edges[0] && visualRangeStartPoint < edges[1] || visualRangeEndPoint > edges[0] && visualRangeEndPoint < edges[1] || visualRangeStartPoint === visualRangeEndPoint && edges[0] !== edges[1]
            },
            isExtremePosition: function(isMax) {
                var extremeDataValue;
                var seriesData;
                if ("discrete" === this._options.type) {
                    seriesData = this._translator.getBusinessRange();
                    extremeDataValue = isMax ? seriesData.categories[seriesData.categories.length - 1] : seriesData.categories[0]
                } else {
                    seriesData = this.getZoomBounds();
                    extremeDataValue = isMax ? seriesData.endValue : seriesData.startValue
                }
                var translator = this.getTranslator();
                var extremePoint = translator.translate(extremeDataValue);
                var visualRange = this.visualRange();
                var visualRangePoint = isMax ? translator.translate(visualRange.endValue) : translator.translate(visualRange.startValue);
                return _abs(visualRangePoint - extremePoint) < SCROLL_THRESHOLD
            },
            getViewport: function() {
                return this._viewport
            },
            getFullTicks: function() {
                var majors = this._majorTicks || [];
                if (this._options.type === _axes_constants.default.discrete) {
                    return convertTicksToValues(majors)
                } else {
                    return convertTicksToValues(majors.concat(this._minorTicks, this._boundaryTicks)).sort(function(a, b) {
                        return (0, _utils.valueOf)(a) - (0, _utils.valueOf)(b)
                    })
                }
            },
            measureLabels: function(canvas, withIndents) {
                var that = this;
                var options = that._options;
                var widthAxis = options.visible ? options.width : 0;
                var ticks;
                var indent = withIndents ? options.label.indentFromAxis + .5 * options.tick.length : 0;
                var tickInterval;
                var viewportRange = that._getViewportRange();
                if (viewportRange.isEmpty() || !options.label.visible || !that._axisElementsGroup) {
                    return {
                        height: widthAxis,
                        width: widthAxis,
                        x: 0,
                        y: 0
                    }
                }
                if (that._majorTicks) {
                    ticks = convertTicksToValues(that._majorTicks)
                } else {
                    that.updateCanvas(canvas);
                    ticks = that._createTicksAndLabelFormat(viewportRange, _common.noop);
                    tickInterval = ticks.tickInterval;
                    ticks = ticks.ticks
                }
                var maxText = ticks.reduce(function(prevLabel, tick, index) {
                    var label = that.formatLabel(tick, options.label, viewportRange, void 0, tickInterval, ticks);
                    if (prevLabel.length < label.length) {
                        return label
                    } else {
                        return prevLabel
                    }
                }, that.formatLabel(ticks[0], options.label, viewportRange, void 0, tickInterval, ticks));
                var text = that._renderer.text(maxText, 0, 0).css(that._textFontStyles).attr(that._textOptions).append(that._renderer.root);
                var box = text.getBBox();
                text.remove();
                return {
                    x: box.x,
                    y: box.y,
                    width: box.width + indent,
                    height: box.height + indent
                }
            },
            _setLabelsPlacement: function() {
                if (!this._options.label.visible) {
                    return
                }
                var that = this;
                var labelOpt = that._options.label;
                var displayMode = that._validateDisplayMode(labelOpt.displayMode);
                var overlappingMode = that._validateOverlappingMode(labelOpt.overlappingBehavior, displayMode);
                var ignoreOverlapping = "none" === overlappingMode || "ignore" === overlappingMode;
                var behavior = {
                    rotationAngle: labelOpt.rotationAngle,
                    staggeringSpacing: labelOpt.staggeringSpacing
                };
                var notRecastStep;
                var boxes = that._majorTicks.map(function(tick) {
                    return tick.labelBBox
                });
                var step = that._getStep(boxes);
                switch (displayMode) {
                    case ROTATE:
                        if (ignoreOverlapping) {
                            notRecastStep = true;
                            step = 1
                        }
                        that._applyLabelMode(displayMode, step, boxes, labelOpt, notRecastStep);
                        break;
                    case "stagger":
                        if (ignoreOverlapping) {
                            step = 2
                        }
                        that._applyLabelMode(displayMode, _max(step, 2), boxes, labelOpt);
                        break;
                    default:
                        that._applyLabelOverlapping(boxes, overlappingMode, step, behavior)
                }
            },
            _applyLabelOverlapping: function(boxes, mode, step, behavior) {
                var that = this;
                var labelOpt = that._options.label;
                var majorTicks = that._majorTicks;
                if ("none" === mode || "ignore" === mode) {
                    return
                }
                var checkLabels = function(box, index, array) {
                    if (0 === index) {
                        return false
                    }
                    return _axes_constants.default.areLabelsOverlap(box, array[index - 1], labelOpt.minSpacing, labelOpt.alignment)
                };
                if (step > 1 && boxes.some(checkLabels)) {
                    that._applyLabelMode(mode, step, boxes, behavior)
                }
                that._checkBoundedLabelsOverlapping(majorTicks, boxes, mode)
            },
            _applyLabelMode: function(mode, step, boxes, behavior, notRecastStep) {
                var that = this;
                var majorTicks = that._majorTicks;
                var labelOpt = that._options.label;
                var angle = behavior.rotationAngle;
                var labelHeight;
                var alignment;
                var func;
                switch (mode) {
                    case ROTATE:
                        if (!labelOpt.userAlignment) {
                            alignment = angle < 0 ? RIGHT : LEFT;
                            if (angle % 90 === 0) {
                                alignment = CENTER
                            }
                        }
                        step = notRecastStep ? step : that._getStep(boxes, angle);
                        func = function(tick) {
                            var contentContainer = tick.getContentContainer();
                            if (!contentContainer) {
                                return
                            }
                            contentContainer.rotate(angle);
                            tick.labelRotationAngle = angle;
                            alignment && (tick.labelAlignment = alignment)
                        };
                        updateLabels(majorTicks, step, func);
                        break;
                    case "stagger":
                        labelHeight = that._getMaxLabelHeight(boxes, behavior.staggeringSpacing);
                        func = function(tick, index) {
                            if (index / (step - 1) % 2 !== 0) {
                                tick.labelOffset = labelHeight
                            }
                        };
                        updateLabels(majorTicks, step - 1, func);
                        break;
                    case "auto":
                    case "_auto":
                        if (2 === step) {
                            that._applyLabelMode("stagger", step, boxes, behavior)
                        } else {
                            that._applyLabelMode(ROTATE, step, boxes, {
                                rotationAngle: getOptimalAngle(boxes, labelOpt)
                            })
                        }
                        break;
                    default:
                        updateLabels(majorTicks, step)
                }
            },
            getMarkerTrackers: _common.noop,
            _drawDateMarkers: _common.noop,
            _adjustDateMarkers: _common.noop,
            coordsIn: _common.noop,
            areCoordsOutsideAxis: _common.noop,
            _getSkippedCategory: _common.noop,
            _initAxisPositions: _common.noop,
            _drawTitle: _common.noop,
            _updateTitleCoords: _common.noop,
            _adjustConstantLineLabels: _common.noop,
            _createTranslator: function() {
                return new _translator2d.Translator2D({}, {}, {})
            },
            _updateTranslator: function() {
                var translator = this._translator;
                translator.update(translator.getBusinessRange(), this._canvas || {}, this._getTranslatorOptions())
            },
            _getTranslatorOptions: function() {
                var _options$workWeek2, _options$breakStyle$w, _options$breakStyle;
                var options = this._options;
                return {
                    isHorizontal: this._isHorizontal,
                    shiftZeroValue: !this.isArgumentAxis,
                    interval: options.semiDiscreteInterval,
                    firstDayOfWeek: null === (_options$workWeek2 = options.workWeek) || void 0 === _options$workWeek2 ? void 0 : _options$workWeek2[0],
                    stick: this._getStick(),
                    breaksSize: null !== (_options$breakStyle$w = null === (_options$breakStyle = options.breakStyle) || void 0 === _options$breakStyle ? void 0 : _options$breakStyle.width) && void 0 !== _options$breakStyle$w ? _options$breakStyle$w : 0
                }
            },
            getVisibleArea: function() {
                var canvas = this._getCanvasStartEnd();
                return [canvas.start, canvas.end].sort(function(a, b) {
                    return a - b
                })
            },
            _getCanvasStartEnd: function() {
                var isHorizontal = this._isHorizontal;
                var canvas = this._canvas || {};
                var invert = this._translator.getBusinessRange().invert;
                var coords = isHorizontal ? [canvas.left, canvas.width - canvas.right] : [canvas.height - canvas.bottom, canvas.top];
                invert && coords.reverse();
                return {
                    start: coords[0],
                    end: coords[1]
                }
            },
            _getScreenDelta: function() {
                var that = this;
                var canvas = that._getCanvasStartEnd();
                var breaks = that._seriesData ? that._seriesData.breaks || [] : [];
                var breaksLength = breaks.length;
                var screenDelta = _abs(canvas.start - canvas.end);
                return screenDelta - (breaksLength ? breaks[breaksLength - 1].cumulativeWidth : 0)
            },
            _getScaleBreaks: function() {
                return []
            },
            _filterBreaks: function() {
                return []
            },
            _adjustTitle: _common.noop,
            _checkTitleOverflow: _common.noop,
            getSpiderTicks: _common.noop,
            setSpiderTicks: _common.noop,
            _checkBoundedLabelsOverlapping: _common.noop,
            drawScaleBreaks: _common.noop,
            _visualRange: _common.noop,
            _rotateConstantLine: _common.noop,
            applyVisualRangeSetter: function(visualRangeSetter) {
                this._visualRange = visualRangeSetter
            },
            getCategoriesSorter: function(argCategories) {
                var sort;
                if (this.isArgumentAxis) {
                    sort = argCategories
                } else {
                    var categoriesSortingMethod = this._options.categoriesSortingMethod;
                    sort = null !== categoriesSortingMethod && void 0 !== categoriesSortingMethod ? categoriesSortingMethod : this._options.categories
                }
                return sort
            },
            _getAdjustedBusinessRange: function() {
                return this.adjustViewport(this._translator.getBusinessRange())
            }
        }
    },
    /*!*************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/axes/axes_constants.js ***!
      \*************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _default = {
            logarithmic: "logarithmic",
            discrete: "discrete",
            numeric: "numeric",
            left: "left",
            right: "right",
            top: "top",
            bottom: "bottom",
            center: "center",
            horizontal: "horizontal",
            vertical: "vertical",
            convertTicksToValues: function(ticks) {
                return (0, _utils.map)(ticks || [], function(item) {
                    return item.value
                })
            },
            validateOverlappingMode: function(mode) {
                return "ignore" === mode || "none" === mode ? mode : "hide"
            },
            getTicksCountInRange: function(ticks, valueKey, range) {
                var i = 1;
                if (ticks.length > 1) {
                    for (; i < ticks.length; i++) {
                        if (Math.abs(ticks[i].coords[valueKey] - ticks[0].coords[valueKey]) >= range) {
                            break
                        }
                    }
                }
                return i
            },
            areLabelsOverlap: function(bBox1, bBox2, spacing, alignment) {
                var horizontalInverted = bBox1.x > bBox2.x;
                var verticalInverted = bBox1.y > bBox2.y;
                var x1 = bBox1.x;
                var x2 = bBox2.x;
                var width1 = bBox1.width;
                var width2 = bBox2.width;
                if ("left" === alignment) {
                    x1 += width1 / 2;
                    x2 += width2 / 2
                } else {
                    if ("right" === alignment) {
                        x1 -= width1 / 2;
                        x2 -= width2 / 2
                    }
                }
                var hasHorizontalOverlapping = horizontalInverted ? x2 + width2 + spacing > x1 : x1 + width1 + spacing > x2;
                var hasVerticalOverlapping = verticalInverted ? bBox2.y + bBox2.height > bBox1.y : bBox1.y + bBox1.height > bBox2.y;
                return hasHorizontalOverlapping && hasVerticalOverlapping
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/translators/translator2d.js ***!
      \******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.Translator2D = void 0;
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _range = __webpack_require__( /*! ./range */ 124);
        var _category_translator = _interopRequireDefault(__webpack_require__( /*! ./category_translator */ 930));
        var _interval_translator = _interopRequireDefault(__webpack_require__( /*! ./interval_translator */ 931));
        var _datetime_translator = _interopRequireDefault(__webpack_require__( /*! ./datetime_translator */ 932));
        var _logarithmic_translator = _interopRequireDefault(__webpack_require__( /*! ./logarithmic_translator */ 933));
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _math = __webpack_require__( /*! ../../core/utils/math */ 29);
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _abs = Math.abs;
        var CANVAS_PROP = ["width", "height", "left", "top", "bottom", "right"];
        var dummyTranslator = {
            to: function(value) {
                var coord = this._canvasOptions.startPoint + (this._options.conversionValue ? value : Math.round(value));
                return coord > this._canvasOptions.endPoint ? this._canvasOptions.endPoint : coord
            },
            from: function(value) {
                return value - this._canvasOptions.startPoint
            }
        };
        var validateCanvas = function(canvas) {
            (0, _iterator.each)(CANVAS_PROP, function(_, prop) {
                canvas[prop] = parseInt(canvas[prop]) || 0
            });
            return canvas
        };
        var makeCategoriesToPoints = function(categories) {
            var categoriesToPoints = {};
            categories.forEach(function(item, i) {
                categoriesToPoints[item.valueOf()] = i
            });
            return categoriesToPoints
        };
        var validateBusinessRange = function(businessRange) {
            if (!(businessRange instanceof _range.Range)) {
                businessRange = new _range.Range(businessRange)
            }

            function validate(valueSelector, baseValueSelector) {
                if (!(0, _type.isDefined)(businessRange[valueSelector]) && (0, _type.isDefined)(businessRange[baseValueSelector])) {
                    businessRange[valueSelector] = businessRange[baseValueSelector]
                }
            }
            validate("minVisible", "min");
            validate("maxVisible", "max");
            return businessRange
        };

        function prepareBreaks(breaks, range) {
            var transform = "logarithmic" === range.axisType ? function(value) {
                return (0, _utils.getLogExt)(value, range.base)
            } : function(value) {
                return value
            };
            var array = [];
            var br;
            var transformFrom;
            var transformTo;
            var i;
            var length = breaks.length;
            var sum = 0;
            for (i = 0; i < length; i++) {
                br = breaks[i];
                transformFrom = transform(br.from);
                transformTo = transform(br.to);
                sum += transformTo - transformFrom;
                array.push({
                    trFrom: transformFrom,
                    trTo: transformTo,
                    from: br.from,
                    to: br.to,
                    length: sum,
                    cumulativeWidth: br.cumulativeWidth
                })
            }
            return array
        }

        function getCanvasBounds(range) {
            var min = range.min;
            var max = range.max;
            var minVisible = range.minVisible;
            var maxVisible = range.maxVisible;
            var isLogarithmic = "logarithmic" === range.axisType;
            if (isLogarithmic) {
                maxVisible = (0, _utils.getLogExt)(maxVisible, range.base, range.allowNegatives, range.linearThreshold);
                minVisible = (0, _utils.getLogExt)(minVisible, range.base, range.allowNegatives, range.linearThreshold);
                min = (0, _utils.getLogExt)(min, range.base, range.allowNegatives, range.linearThreshold);
                max = (0, _utils.getLogExt)(max, range.base, range.allowNegatives, range.linearThreshold)
            }
            return {
                base: range.base,
                rangeMin: min,
                rangeMax: max,
                rangeMinVisible: minVisible,
                rangeMaxVisible: maxVisible
            }
        }

        function getCheckingMethodsAboutBreaks(inverted) {
            return {
                isStartSide: !inverted ? function(pos, breaks, start, end) {
                    return pos < breaks[0][start]
                } : function(pos, breaks, start, end) {
                    return pos <= breaks[breaks.length - 1][end]
                },
                isEndSide: !inverted ? function(pos, breaks, start, end) {
                    return pos >= breaks[breaks.length - 1][end]
                } : function(pos, breaks, start, end) {
                    return pos > breaks[0][start]
                },
                isInBreak: !inverted ? function(pos, br, start, end) {
                    return pos >= br[start] && pos < br[end]
                } : function(pos, br, start, end) {
                    return pos > br[end] && pos <= br[start]
                },
                isBetweenBreaks: !inverted ? function(pos, br, prevBreak, start, end) {
                    return pos < br[start] && pos >= prevBreak[end]
                } : function(pos, br, prevBreak, start, end) {
                    return pos >= br[end] && pos < prevBreak[start]
                },
                getLength: !inverted ? function(br) {
                    return br.length
                } : function(br, lastBreak) {
                    return lastBreak.length - br.length
                },
                getBreaksSize: !inverted ? function(br) {
                    return br.cumulativeWidth
                } : function(br, lastBreak) {
                    return lastBreak.cumulativeWidth - br.cumulativeWidth
                }
            }
        }
        var _Translator2d = function(businessRange, canvas, options) {
            this.update(businessRange, canvas, options)
        };
        exports.Translator2D = _Translator2d;
        _Translator2d.prototype = {
            constructor: _Translator2d,
            reinit: function() {
                var that = this;
                var options = that._options;
                var range = that._businessRange;
                var categories = range.categories || [];
                var script = {};
                var canvasOptions = that._prepareCanvasOptions();
                var visibleCategories = (0, _utils.getCategoriesInfo)(categories, range.minVisible, range.maxVisible).categories;
                var categoriesLength = visibleCategories.length;
                if (range.isEmpty()) {
                    script = dummyTranslator
                } else {
                    switch (range.axisType) {
                        case "logarithmic":
                            script = _logarithmic_translator.default;
                            break;
                        case "semidiscrete":
                            script = _interval_translator.default;
                            canvasOptions.ratioOfCanvasRange = canvasOptions.canvasLength / (_date.default.addInterval(canvasOptions.rangeMaxVisible, options.interval) - canvasOptions.rangeMinVisible);
                            break;
                        case "discrete":
                            script = _category_translator.default;
                            that._categories = categories;
                            canvasOptions.interval = that._getDiscreteInterval(options.addSpiderCategory ? categoriesLength + 1 : categoriesLength, canvasOptions);
                            that._categoriesToPoints = makeCategoriesToPoints(categories, canvasOptions.invert);
                            if (categoriesLength) {
                                canvasOptions.startPointIndex = that._categoriesToPoints[visibleCategories[0].valueOf()];
                                that.visibleCategories = visibleCategories
                            }
                            break;
                        default:
                            if ("datetime" === range.dataType) {
                                script = _datetime_translator.default
                            }
                    }
                }(that._oldMethods || []).forEach(function(methodName) {
                    delete that[methodName]
                });
                that._oldMethods = Object.keys(script);
                (0, _extend.extend)(that, script);
                that._conversionValue = options.conversionValue ? function(value) {
                    return value
                } : function(value) {
                    return Math.round(value)
                };
                that.sc = {};
                that._checkingMethodsAboutBreaks = [getCheckingMethodsAboutBreaks(false), getCheckingMethodsAboutBreaks(that.isInverted())];
                that._translateBreaks();
                that._calculateSpecialValues()
            },
            _translateBreaks: function() {
                var breaks = this._breaks;
                var size = this._options.breaksSize;
                var i;
                var b;
                var end;
                var length;
                if (void 0 === breaks) {
                    return
                }
                for (i = 0, length = breaks.length; i < length; i++) {
                    b = breaks[i];
                    end = this.translate(b.to);
                    b.end = end;
                    b.start = !b.gapSize ? !this.isInverted() ? end - size : end + size : end
                }
            },
            _checkValueAboutBreaks: function(breaks, pos, start, end, methods) {
                var i;
                var length;
                var prop = {
                    length: 0,
                    breaksSize: void 0,
                    inBreak: false
                };
                var br;
                var prevBreak;
                var lastBreak = breaks[breaks.length - 1];
                if (methods.isStartSide(pos, breaks, start, end)) {
                    return prop
                } else {
                    if (methods.isEndSide(pos, breaks, start, end)) {
                        return {
                            length: lastBreak.length,
                            breaksSize: lastBreak.cumulativeWidth,
                            inBreak: false
                        }
                    }
                }
                for (i = 0, length = breaks.length; i < length; i++) {
                    br = breaks[i];
                    prevBreak = breaks[i - 1];
                    if (methods.isInBreak(pos, br, start, end)) {
                        prop.inBreak = true;
                        prop.break = br;
                        break
                    }
                    if (prevBreak && methods.isBetweenBreaks(pos, br, prevBreak, start, end)) {
                        prop = {
                            length: methods.getLength(prevBreak, lastBreak),
                            breaksSize: methods.getBreaksSize(prevBreak, lastBreak),
                            inBreak: false
                        };
                        break
                    }
                }
                return prop
            },
            isInverted: function() {
                return !(this._options.isHorizontal ^ this._businessRange.invert)
            },
            _getDiscreteInterval: function(categoriesLength, canvasOptions) {
                var correctedCategoriesCount = categoriesLength - (this._options.stick ? 1 : 0);
                return correctedCategoriesCount > 0 ? canvasOptions.canvasLength / correctedCategoriesCount : canvasOptions.canvasLength
            },
            _prepareCanvasOptions: function() {
                var that = this;
                var businessRange = that._businessRange;
                var canvasOptions = that._canvasOptions = getCanvasBounds(businessRange);
                var canvas = that._canvas;
                var breaks = that._breaks;
                var length;
                canvasOptions.startPadding = canvas.startPadding || 0;
                canvasOptions.endPadding = canvas.endPadding || 0;
                if (that._options.isHorizontal) {
                    canvasOptions.startPoint = canvas.left + canvasOptions.startPadding;
                    length = canvas.width;
                    canvasOptions.endPoint = canvas.width - canvas.right - canvasOptions.endPadding;
                    canvasOptions.invert = businessRange.invert
                } else {
                    canvasOptions.startPoint = canvas.top + canvasOptions.startPadding;
                    length = canvas.height;
                    canvasOptions.endPoint = canvas.height - canvas.bottom - canvasOptions.endPadding;
                    canvasOptions.invert = !businessRange.invert
                }
                that.canvasLength = canvasOptions.canvasLength = canvasOptions.endPoint - canvasOptions.startPoint;
                canvasOptions.rangeDoubleError = Math.pow(10, (0, _utils.getPower)(canvasOptions.rangeMax - canvasOptions.rangeMin) - (0, _utils.getPower)(length) - 2);
                canvasOptions.ratioOfCanvasRange = canvasOptions.canvasLength / (canvasOptions.rangeMaxVisible - canvasOptions.rangeMinVisible);
                if (void 0 !== breaks) {
                    canvasOptions.ratioOfCanvasRange = (canvasOptions.canvasLength - breaks[breaks.length - 1].cumulativeWidth) / (canvasOptions.rangeMaxVisible - canvasOptions.rangeMinVisible - breaks[breaks.length - 1].length)
                }
                return canvasOptions
            },
            updateCanvas: function(canvas) {
                this._canvas = validateCanvas(canvas);
                this.reinit()
            },
            updateBusinessRange: function(businessRange) {
                var that = this;
                var breaks = businessRange.breaks || [];
                that._userBreaks = businessRange.userBreaks || [];
                that._businessRange = validateBusinessRange(businessRange);
                that._breaks = breaks.length ? prepareBreaks(breaks, that._businessRange) : void 0;
                that.reinit()
            },
            update: function(businessRange, canvas, options) {
                var that = this;
                that._options = (0, _extend.extend)(that._options || {}, options);
                that._canvas = validateCanvas(canvas);
                that.updateBusinessRange(businessRange)
            },
            getBusinessRange: function() {
                return this._businessRange
            },
            getEventScale: function(zoomEvent) {
                return zoomEvent.deltaScale || 1
            },
            getCanvasVisibleArea: function() {
                return {
                    min: this._canvasOptions.startPoint,
                    max: this._canvasOptions.endPoint
                }
            },
            _calculateSpecialValues: function() {
                var that = this;
                var canvasOptions = that._canvasOptions;
                var startPoint = canvasOptions.startPoint - canvasOptions.startPadding;
                var endPoint = canvasOptions.endPoint + canvasOptions.endPadding;
                var range = that._businessRange;
                var minVisible = range.minVisible;
                var maxVisible = range.maxVisible;
                var canvas_position_center_middle = startPoint + canvasOptions.canvasLength / 2;
                var canvas_position_default;
                if (minVisible < 0 && maxVisible > 0 && minVisible !== maxVisible) {
                    canvas_position_default = that.translate(0, 1)
                }
                if (!(0, _type.isDefined)(canvas_position_default)) {
                    var invert = range.invert ^ (minVisible < 0 && maxVisible <= 0);
                    if (that._options.isHorizontal) {
                        canvas_position_default = invert ? endPoint : startPoint
                    } else {
                        canvas_position_default = invert ? startPoint : endPoint
                    }
                }
                that.sc = {
                    canvas_position_default: canvas_position_default,
                    canvas_position_left: startPoint,
                    canvas_position_top: startPoint,
                    canvas_position_center: canvas_position_center_middle,
                    canvas_position_middle: canvas_position_center_middle,
                    canvas_position_right: endPoint,
                    canvas_position_bottom: endPoint,
                    canvas_position_start: canvasOptions.invert ? endPoint : startPoint,
                    canvas_position_end: canvasOptions.invert ? startPoint : endPoint
                }
            },
            translateSpecialCase: function(value) {
                return this.sc[value]
            },
            _calculateProjection: function(distance) {
                var canvasOptions = this._canvasOptions;
                return canvasOptions.invert ? canvasOptions.endPoint - distance : canvasOptions.startPoint + distance
            },
            _calculateUnProjection: function(distance) {
                var canvasOptions = this._canvasOptions;
                "datetime" === this._businessRange.dataType && (distance = Math.round(distance));
                return canvasOptions.invert ? canvasOptions.rangeMaxVisible.valueOf() - distance : canvasOptions.rangeMinVisible.valueOf() + distance
            },
            getMinBarSize: function(minBarSize) {
                var visibleArea = this.getCanvasVisibleArea();
                var minValue = this.from(visibleArea.min + minBarSize);
                return _abs(this.from(visibleArea.min) - (!(0, _type.isDefined)(minValue) ? this.from(visibleArea.max) : minValue))
            },
            checkMinBarSize: function(value, minShownValue, stackValue) {
                return _abs(value) < minShownValue ? value >= 0 ? minShownValue : -minShownValue : value
            },
            translate: function(bp, direction) {
                var specialValue = this.translateSpecialCase(bp);
                if ((0, _type.isDefined)(specialValue)) {
                    return Math.round(specialValue)
                }
                if (isNaN(bp)) {
                    return null
                }
                return this.to(bp, direction)
            },
            getInterval: function(interval) {
                var _interval;
                var canvasOptions = this._canvasOptions;
                interval = null !== (_interval = interval) && void 0 !== _interval ? _interval : this._businessRange.interval;
                if (interval) {
                    return Math.round(canvasOptions.ratioOfCanvasRange * interval)
                }
                return Math.round(canvasOptions.endPoint - canvasOptions.startPoint)
            },
            zoom: function(translate, scale, wholeRange) {
                var canvasOptions = this._canvasOptions;
                if (canvasOptions.rangeMinVisible.valueOf() === canvasOptions.rangeMaxVisible.valueOf() && 0 !== translate) {
                    return this.zoomZeroLengthRange(translate, scale)
                }
                var startPoint = canvasOptions.startPoint;
                var endPoint = canvasOptions.endPoint;
                var isInverted = this.isInverted();
                var newStart = (startPoint + translate) / scale;
                var newEnd = (endPoint + translate) / scale;
                wholeRange = wholeRange || {};
                var minPoint = this.to(isInverted ? wholeRange.endValue : wholeRange.startValue);
                var maxPoint = this.to(isInverted ? wholeRange.startValue : wholeRange.endValue);
                var min;
                var max;
                if (minPoint > newStart) {
                    newEnd -= newStart - minPoint;
                    newStart = minPoint;
                    min = isInverted ? wholeRange.endValue : wholeRange.startValue
                }
                if (maxPoint < newEnd) {
                    newStart -= newEnd - maxPoint;
                    newEnd = maxPoint;
                    max = isInverted ? wholeRange.startValue : wholeRange.endValue
                }
                if (maxPoint - minPoint < newEnd - newStart) {
                    newStart = minPoint;
                    newEnd = maxPoint
                }
                translate = (endPoint - startPoint) * newStart / (newEnd - newStart) - startPoint;
                scale = (startPoint + translate) / newStart || 1;
                min = (0, _type.isDefined)(min) ? min : (0, _math.adjust)(this.from(newStart, 1));
                max = (0, _type.isDefined)(max) ? max : (0, _math.adjust)(this.from(newEnd, -1));
                if (scale <= 1) {
                    min = this._correctValueAboutBreaks(min, 1 === scale ? translate : -1);
                    max = this._correctValueAboutBreaks(max, 1 === scale ? translate : 1)
                }
                if (min > max) {
                    min = min > wholeRange.endValue ? wholeRange.endValue : min;
                    max = max < wholeRange.startValue ? wholeRange.startValue : max
                } else {
                    min = min < wholeRange.startValue ? wholeRange.startValue : min;
                    max = max > wholeRange.endValue ? wholeRange.endValue : max
                }
                return {
                    min: min,
                    max: max,
                    translate: (0, _math.adjust)(translate),
                    scale: (0, _math.adjust)(scale)
                }
            },
            _correctValueAboutBreaks: function(value, direction) {
                var br = this._userBreaks.filter(function(br) {
                    return value >= br.from && value <= br.to
                });
                if (br.length) {
                    return direction > 0 ? br[0].to : br[0].from
                } else {
                    return value
                }
            },
            zoomZeroLengthRange: function(translate, scale) {
                var canvasOptions = this._canvasOptions;
                var min = canvasOptions.rangeMin;
                var max = canvasOptions.rangeMax;
                var correction = (max.valueOf() !== min.valueOf() ? max.valueOf() - min.valueOf() : _abs(canvasOptions.rangeMinVisible.valueOf() - min.valueOf())) / canvasOptions.canvasLength;
                var isDateTime = (0, _type.isDate)(max) || (0, _type.isDate)(min);
                var isLogarithmic = "logarithmic" === this._businessRange.axisType;
                var newMin = canvasOptions.rangeMinVisible.valueOf() - correction;
                var newMax = canvasOptions.rangeMaxVisible.valueOf() + correction;
                newMin = isLogarithmic ? (0, _math.adjust)((0, _utils.raiseToExt)(newMin, canvasOptions.base)) : isDateTime ? new Date(newMin) : newMin;
                newMax = isLogarithmic ? (0, _math.adjust)((0, _utils.raiseToExt)(newMax, canvasOptions.base)) : isDateTime ? new Date(newMax) : newMax;
                return {
                    min: newMin,
                    max: newMax,
                    translate: translate,
                    scale: scale
                }
            },
            getMinScale: function(zoom) {
                var _this$_businessRange = this._businessRange,
                    dataType = _this$_businessRange.dataType,
                    interval = _this$_businessRange.interval;
                if ("datetime" === dataType && 1 === interval) {
                    return this.getDateTimeMinScale(zoom)
                }
                return zoom ? 1.1 : .9
            },
            getDateTimeMinScale: function(zoom) {
                var canvasOptions = this._canvasOptions;
                var length = canvasOptions.canvasLength / canvasOptions.ratioOfCanvasRange;
                length += (parseInt(.1 * length) || 1) * (zoom ? -2 : 2);
                return canvasOptions.canvasLength / (Math.max(length, 1) * canvasOptions.ratioOfCanvasRange)
            },
            getScale: function(val1, val2) {
                var canvasOptions = this._canvasOptions;
                if (canvasOptions.rangeMax === canvasOptions.rangeMin) {
                    return 1
                }
                val1 = (0, _type.isDefined)(val1) ? this._fromValue(val1) : canvasOptions.rangeMin;
                val2 = (0, _type.isDefined)(val2) ? this._fromValue(val2) : canvasOptions.rangeMax;
                return (canvasOptions.rangeMax - canvasOptions.rangeMin) / Math.abs(val1 - val2)
            },
            isValid: function(value) {
                var co = this._canvasOptions;
                value = this._fromValue(value);
                return null !== value && !isNaN(value) && value.valueOf() + co.rangeDoubleError >= co.rangeMin && value.valueOf() - co.rangeDoubleError <= co.rangeMax
            },
            getCorrectValue: function(value, direction) {
                var that = this;
                var breaks = that._breaks;
                var prop;
                value = that._fromValue(value);
                if (that._breaks) {
                    prop = that._checkValueAboutBreaks(breaks, value, "trFrom", "trTo", that._checkingMethodsAboutBreaks[0]);
                    if (true === prop.inBreak) {
                        return that._toValue(direction > 0 ? prop.break.trTo : prop.break.trFrom)
                    }
                }
                return that._toValue(value)
            },
            to: function(bp, direction) {
                var range = this.getBusinessRange();
                if ((0, _type.isDefined)(range.maxVisible) && (0, _type.isDefined)(range.minVisible) && range.maxVisible.valueOf() === range.minVisible.valueOf()) {
                    if (!(0, _type.isDefined)(bp) || range.maxVisible.valueOf() !== bp.valueOf()) {
                        return null
                    }
                    return this.translateSpecialCase(0 === bp && this._options.shiftZeroValue ? "canvas_position_default" : "canvas_position_middle")
                }
                bp = this._fromValue(bp);
                var that = this;
                var canvasOptions = that._canvasOptions;
                var breaks = that._breaks;
                var prop = {
                    length: 0
                };
                var commonBreakSize = 0;
                if (void 0 !== breaks) {
                    prop = that._checkValueAboutBreaks(breaks, bp, "trFrom", "trTo", that._checkingMethodsAboutBreaks[0]);
                    commonBreakSize = (0, _type.isDefined)(prop.breaksSize) ? prop.breaksSize : 0
                }
                if (true === prop.inBreak) {
                    if (direction > 0) {
                        return prop.break.start
                    } else {
                        if (direction < 0) {
                            return prop.break.end
                        } else {
                            return null
                        }
                    }
                }
                return that._conversionValue(that._calculateProjection((bp - canvasOptions.rangeMinVisible - prop.length) * canvasOptions.ratioOfCanvasRange + commonBreakSize))
            },
            from: function(pos, direction) {
                var that = this;
                var breaks = that._breaks;
                var prop = {
                    length: 0
                };
                var canvasOptions = that._canvasOptions;
                var startPoint = canvasOptions.startPoint;
                var commonBreakSize = 0;
                if (void 0 !== breaks) {
                    prop = that._checkValueAboutBreaks(breaks, pos, "start", "end", that._checkingMethodsAboutBreaks[1]);
                    commonBreakSize = (0, _type.isDefined)(prop.breaksSize) ? prop.breaksSize : 0
                }
                if (true === prop.inBreak) {
                    if (direction > 0) {
                        return that._toValue(prop.break.trTo)
                    } else {
                        if (direction < 0) {
                            return that._toValue(prop.break.trFrom)
                        } else {
                            return null
                        }
                    }
                }
                return that._toValue(that._calculateUnProjection((pos - startPoint - commonBreakSize) / canvasOptions.ratioOfCanvasRange + prop.length))
            },
            isValueProlonged: false,
            getRange: function() {
                return [this._toValue(this._canvasOptions.rangeMin), this._toValue(this._canvasOptions.rangeMax)]
            },
            getScreenRange: function() {
                return [this._canvasOptions.startPoint, this._canvasOptions.endPoint]
            },
            add: function(value, diff, dir) {
                return this._add(value, diff, (this._businessRange.invert ? -1 : 1) * dir)
            },
            _add: function(value, diff, coeff) {
                return this._toValue(this._fromValue(value) + diff * coeff)
            },
            _fromValue: function(value) {
                return null !== value ? Number(value) : null
            },
            _toValue: function(value) {
                return null !== value ? Number(value) : null
            },
            ratioOfCanvasRange: function() {
                return this._canvasOptions.ratioOfCanvasRange
            },
            convert: function(value) {
                return value
            },
            getRangeByMinZoomValue: function(minZoom, visualRange) {
                if (visualRange.minVisible + minZoom <= this._businessRange.max) {
                    return [visualRange.minVisible, visualRange.minVisible + minZoom]
                } else {
                    return [visualRange.maxVisible - minZoom, visualRange.maxVisible]
                }
            }
        }
    },
    /*!****************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/gauges/base_indicators.js ***!
      \****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.BaseRangeBar = exports.BaseTextCloudMarker = exports.BaseIndicator = exports.BaseElement = void 0;
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _base_gauge = __webpack_require__( /*! ./base_gauge */ 189);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _isFinite = isFinite;
        var _Number = Number;
        var _round = Math.round;
        var _formatValue = _base_gauge.formatValue;
        var _getSampleText = _base_gauge.getSampleText;
        var BaseElement = _class.default.inherit({
            ctor: function(parameters) {
                var that = this;
                (0, _iterator.each)(parameters, function(name, value) {
                    that["_" + name] = value
                });
                that._init()
            },
            dispose: function() {
                var that = this;
                that._dispose();
                (0, _iterator.each)(that, function(name) {
                    that[name] = null
                });
                return that
            },
            getOffset: function() {
                return _Number(this._options.offset) || 0
            }
        });
        exports.BaseElement = BaseElement;
        var BaseIndicator = BaseElement.inherit({
            _init: function() {
                var that = this;
                that._rootElement = that._createRoot().linkOn(that._owner, {
                    name: "value-indicator",
                    after: "core"
                });
                that._trackerElement = that._createTracker()
            },
            _dispose: function() {
                this._rootElement.linkOff()
            },
            _setupAnimation: function() {
                var that = this;
                if (that._options.animation) {
                    that._animation = {
                        step: function(pos) {
                            that._actualValue = that._animation.start + that._animation.delta * pos;
                            that._actualPosition = that._translator.translate(that._actualValue);
                            that._move()
                        },
                        duration: that._options.animation.duration > 0 ? _Number(that._options.animation.duration) : 0,
                        easing: that._options.animation.easing
                    }
                }
            },
            _runAnimation: function(value) {
                var that = this;
                var animation = that._animation;
                animation.start = that._actualValue;
                animation.delta = value - that._actualValue;
                that._rootElement.animate({
                    _: 0
                }, {
                    step: animation.step,
                    duration: animation.duration,
                    easing: animation.easing
                })
            },
            _createRoot: function() {
                return this._renderer.g().attr({
                    "class": this._className
                })
            },
            _createTracker: function() {
                return this._renderer.path([], "area")
            },
            _getTrackerSettings: _common.noop,
            clean: function() {
                var that = this;
                that._animation && that._rootElement.stopAnimation();
                that._rootElement.linkRemove().clear();
                that._clear();
                that._tracker.detach(that._trackerElement);
                that._options = that.enabled = that._animation = null;
                return that
            },
            render: function(options) {
                var that = this;
                that.type = options.type;
                that._options = options;
                that._actualValue = that._currentValue = that._translator.adjust(that._options.currentValue);
                that.enabled = that._isEnabled();
                if (that.enabled) {
                    that._setupAnimation();
                    that._rootElement.attr({
                        fill: that._options.color
                    }).linkAppend();
                    that._tracker.attach(that._trackerElement, that, that._trackerInfo)
                }
                return that
            },
            resize: function(layout) {
                var that = this;
                that._rootElement.clear();
                that._clear();
                that.visible = that._isVisible(layout);
                if (that.visible) {
                    (0, _extend.extend)(that._options, layout);
                    that._actualPosition = that._translator.translate(that._actualValue);
                    that._render();
                    that._trackerElement.attr(that._getTrackerSettings());
                    that._move()
                }
                return that
            },
            value: function(arg, _noAnimation) {
                var that = this;
                var val;
                var rootElement = this._rootElement;
                var visibility = null;
                if (void 0 === arg) {
                    return that._currentValue
                }
                if (null === arg) {
                    visibility = "hidden";
                    that._currentValue = arg
                } else {
                    val = that._translator.adjust(arg);
                    if (that._currentValue !== val && _isFinite(val)) {
                        that._currentValue = val;
                        if (that.visible) {
                            if (that._animation && !_noAnimation) {
                                that._runAnimation(val)
                            } else {
                                that._actualValue = val;
                                that._actualPosition = that._translator.translate(val);
                                that._move()
                            }
                        }
                    }
                }
                rootElement.attr({
                    visibility: visibility
                });
                return that
            },
            _isEnabled: null,
            _isVisible: null,
            _render: null,
            _clear: null,
            _move: null
        });
        exports.BaseIndicator = BaseIndicator;
        var COEFFICIENTS_MAP = {};
        COEFFICIENTS_MAP["right-bottom"] = COEFFICIENTS_MAP.rb = [0, -1, -1, 0, 0, 1, 1, 0];
        COEFFICIENTS_MAP["bottom-right"] = COEFFICIENTS_MAP.br = [-1, 0, 0, -1, 1, 0, 0, 1];
        COEFFICIENTS_MAP["left-bottom"] = COEFFICIENTS_MAP.lb = [0, -1, 1, 0, 0, 1, -1, 0];
        COEFFICIENTS_MAP["bottom-left"] = COEFFICIENTS_MAP.bl = [1, 0, 0, -1, -1, 0, 0, 1];
        COEFFICIENTS_MAP["left-top"] = COEFFICIENTS_MAP.lt = [0, 1, 1, 0, 0, -1, -1, 0];
        COEFFICIENTS_MAP["top-left"] = COEFFICIENTS_MAP.tl = [1, 0, 0, 1, -1, 0, 0, -1];
        COEFFICIENTS_MAP["right-top"] = COEFFICIENTS_MAP.rt = [0, 1, -1, 0, 0, -1, 1, 0];
        COEFFICIENTS_MAP["top-right"] = COEFFICIENTS_MAP.tr = [-1, 0, 0, 1, 1, 0, 0, -1];

        function getTextCloudInfo(options) {
            var x = options.x;
            var y = options.y;
            var type = COEFFICIENTS_MAP[options.type];
            var cloudWidth = options.cloudWidth;
            var cloudHeight = options.cloudHeight;
            var tailWidth;
            var tailHeight;
            var cx = x;
            var cy = y;
            tailWidth = tailHeight = options.tailLength;
            if (1 & type[0]) {
                tailHeight = Math.min(tailHeight, cloudHeight / 3)
            } else {
                tailWidth = Math.min(tailWidth, cloudWidth / 3)
            }
            return {
                cx: _round(cx + type[0] * tailWidth + (type[0] + type[2]) * cloudWidth / 2),
                cy: _round(cy + type[1] * tailHeight + (type[1] + type[3]) * cloudHeight / 2),
                points: [_round(x), _round(y), _round(x += type[0] * (cloudWidth + tailWidth)), _round(y += type[1] * (cloudHeight + tailHeight)), _round(x += type[2] * cloudWidth), _round(y += type[3] * cloudHeight), _round(x += type[4] * cloudWidth), _round(y += type[5] * cloudHeight), _round(x += type[6] * (cloudWidth - tailWidth)), _round(y += type[7] * (cloudHeight - tailHeight))]
            }
        }
        var BaseTextCloudMarker = BaseIndicator.inherit({
            _move: function() {
                var that = this;
                var options = that._options;
                var textCloudOptions = that._getTextCloudOptions();
                var text = _formatValue(that._actualValue, options.text);
                that._text.attr({
                    text: text
                });
                var bBox = that._text.getBBox();
                var x = textCloudOptions.x;
                var y = textCloudOptions.y;
                var cloudWidth = (bBox.width || text.length * that._textUnitWidth) + 2 * options.horizontalOffset;
                var cloudHeight = (bBox.height || that._textHeight) + 2 * options.verticalOffset;
                var info = getTextCloudInfo({
                    x: x,
                    y: y,
                    cloudWidth: cloudWidth,
                    cloudHeight: cloudHeight,
                    tailLength: options.arrowLength,
                    type: that._correctCloudType(textCloudOptions.type, {
                        x: x,
                        y: y
                    }, {
                        width: cloudWidth,
                        height: cloudHeight
                    })
                });
                that._text.attr({
                    x: info.cx,
                    y: info.cy + that._textVerticalOffset
                });
                that._cloud.attr({
                    points: info.points
                });
                that._trackerElement && that._trackerElement.attr({
                    points: info.points
                })
            },
            _measureText: function() {
                var that = this;
                var root;
                var text;
                var bBox;
                var sampleText;
                if (!that._textVerticalOffset) {
                    root = that._createRoot().append(that._owner);
                    sampleText = _getSampleText(that._translator, that._options.text);
                    text = that._renderer.text(sampleText, 0, 0).attr({
                        align: "center"
                    }).css((0, _utils.patchFontOptions)(that._options.text.font)).append(root);
                    bBox = text.getBBox();
                    root.remove();
                    that._textVerticalOffset = -bBox.y - bBox.height / 2;
                    that._textWidth = bBox.width;
                    that._textHeight = bBox.height;
                    that._textUnitWidth = that._textWidth / sampleText.length;
                    that._textFullWidth = that._textWidth + 2 * that._options.horizontalOffset;
                    that._textFullHeight = that._textHeight + 2 * that._options.verticalOffset
                }
            },
            _render: function() {
                var that = this;
                that._measureText();
                that._cloud = that._cloud || that._renderer.path([], "area").append(that._rootElement);
                that._text = that._text || that._renderer.text().append(that._rootElement);
                that._text.attr({
                    align: "center"
                }).css((0, _utils.patchFontOptions)(that._options.text.font))
            },
            _clear: function() {
                delete this._cloud;
                delete this._text
            },
            getTooltipParameters: function() {
                var position = this._getTextCloudOptions();
                return {
                    x: position.x,
                    y: position.y,
                    value: this._currentValue,
                    color: this._options.color
                }
            },
            _correctCloudType: function(type) {
                return type
            }
        });
        exports.BaseTextCloudMarker = BaseTextCloudMarker;
        var BaseRangeBar = BaseIndicator.inherit({
            _measureText: function() {
                var that = this;
                var root;
                var text;
                var bBox;
                that._hasText = that._isTextVisible();
                if (that._hasText && !that._textVerticalOffset) {
                    root = that._createRoot().append(that._owner);
                    text = that._renderer.text(_getSampleText(that._translator, that._options.text), 0, 0).attr({
                        "class": "dxg-text",
                        align: "center"
                    }).css((0, _utils.patchFontOptions)(that._options.text.font)).append(root);
                    bBox = text.getBBox();
                    root.remove();
                    that._textVerticalOffset = -bBox.y - bBox.height / 2;
                    that._textWidth = bBox.width;
                    that._textHeight = bBox.height
                }
            },
            _move: function() {
                var that = this;
                that._updateBarItemsPositions();
                if (that._hasText) {
                    that._text.attr({
                        text: _formatValue(that._actualValue, that._options.text)
                    });
                    that._updateTextPosition();
                    that._updateLinePosition()
                }
            },
            _updateBarItems: function() {
                var that = this;
                var options = that._options;
                var spaceColor;
                var translator = that._translator;
                that._setBarSides();
                that._startPosition = translator.translate(translator.getDomainStart());
                that._endPosition = translator.translate(translator.getDomainEnd());
                that._basePosition = translator.translate(options.baseValue);
                that._space = that._getSpace();
                var backgroundColor = options.backgroundColor || "none";
                if ("none" !== backgroundColor && that._space > 0) {
                    spaceColor = options.containerBackgroundColor || "none"
                } else {
                    that._space = 0;
                    spaceColor = "none"
                }
                that._backItem1.attr({
                    fill: backgroundColor
                });
                that._backItem2.attr({
                    fill: backgroundColor
                });
                that._spaceItem1.attr({
                    fill: spaceColor
                });
                that._spaceItem2.attr({
                    fill: spaceColor
                })
            },
            _getSpace: function() {
                return 0
            },
            _updateTextItems: function() {
                var that = this;
                if (that._hasText) {
                    that._line = that._line || that._renderer.path([], "line").attr({
                        "class": "dxg-main-bar",
                        "stroke-linecap": "square"
                    }).append(that._rootElement);
                    that._text = that._text || that._renderer.text("", 0, 0).attr({
                        "class": "dxg-text"
                    }).append(that._rootElement);
                    that._text.attr({
                        align: that._getTextAlign()
                    }).css(that._getFontOptions());
                    that._setTextItemsSides()
                } else {
                    if (that._line) {
                        that._line.remove();
                        delete that._line
                    }
                    if (that._text) {
                        that._text.remove();
                        delete that._text
                    }
                }
            },
            _isTextVisible: function() {
                return false
            },
            _getTextAlign: function() {
                return "center"
            },
            _getFontOptions: function() {
                var options = this._options;
                var font = options.text.font;
                if (!font || !font.color) {
                    font = (0, _extend.extend)({}, font, {
                        color: options.color
                    })
                }
                return (0, _utils.patchFontOptions)(font)
            },
            _updateBarItemsPositions: function() {
                var that = this;
                var positions = that._getPositions();
                that._backItem1.attr(that._buildItemSettings(positions.start, positions.back1));
                that._backItem2.attr(that._buildItemSettings(positions.back2, positions.end));
                that._spaceItem1.attr(that._buildItemSettings(positions.back1, positions.main1));
                that._spaceItem2.attr(that._buildItemSettings(positions.main2, positions.back2));
                that._mainItem.attr(that._buildItemSettings(positions.main1, positions.main2));
                that._trackerElement && that._trackerElement.attr(that._buildItemSettings(positions.main1, positions.main2))
            },
            _render: function() {
                var that = this;
                that._measureText();
                if (!that._backItem1) {
                    that._backItem1 = that._createBarItem();
                    that._backItem1.attr({
                        "class": "dxg-back-bar"
                    })
                }
                if (!that._backItem2) {
                    that._backItem2 = that._createBarItem();
                    that._backItem2.attr({
                        "class": "dxg-back-bar"
                    })
                }
                if (!that._spaceItem1) {
                    that._spaceItem1 = that._createBarItem();
                    that._spaceItem1.attr({
                        "class": "dxg-space-bar"
                    })
                }
                if (!that._spaceItem2) {
                    that._spaceItem2 = that._createBarItem();
                    that._spaceItem2.attr({
                        "class": "dxg-space-bar"
                    })
                }
                if (!that._mainItem) {
                    that._mainItem = that._createBarItem();
                    that._mainItem.attr({
                        "class": "dxg-main-bar"
                    })
                }
                that._updateBarItems();
                that._updateTextItems()
            },
            _clear: function() {
                var that = this;
                delete that._backItem1;
                delete that._backItem2;
                delete that._spaceItem1;
                delete that._spaceItem2;
                delete that._mainItem;
                delete that._hasText;
                delete that._line;
                delete that._text
            },
            getTooltipParameters: function() {
                var position = this._getTooltipPosition();
                return {
                    x: position.x,
                    y: position.y,
                    value: this._currentValue,
                    color: this._options.color,
                    offset: 0
                }
            }
        });
        exports.BaseRangeBar = BaseRangeBar
    },
    /*!*********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/tree_map/common.js ***!
      \*********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.buildRectAppearance = buildRectAppearance;
        exports.buildTextAppearance = buildTextAppearance;
        var _utils = __webpack_require__( /*! ../core/utils */ 14);

        function buildRectAppearance(option) {
            var border = option.border || {};
            return {
                fill: option.color,
                opacity: option.opacity,
                stroke: border.color,
                "stroke-width": border.width,
                "stroke-opacity": border.opacity,
                hatching: option.hatching
            }
        }

        function buildTextAppearance(options, filter) {
            return {
                attr: {
                    filter: filter
                },
                css: (0, _utils.patchFontOptions)(options.font)
            }
        }
    },
    /*!************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/components/tracker.js ***!
      \************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.Tracker = Tracker;
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _click = __webpack_require__( /*! ../../events/click */ 21);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../../events/pointer */ 24));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var downPointerEventName = _pointer.default.down;
        var movePointerEventName = _pointer.default.move;

        function Tracker(parameters) {
            this._initHandlers(parameters)
        }
        Tracker.prototype = {
            constructor: Tracker,
            _initHandlers: function(parameters) {
                var document = _dom_adapter.default.getDocument();
                parameters.getCoords = function(e) {
                    var data = (0, _index.eventData)(e);
                    var offset = parameters.widget._renderer.getRootOffset();
                    return [data.x - offset.left, data.y - offset.top]
                };
                parameters.root.on(_click.name, clickHandler);
                parameters.root.on(downPointerEventName, downHandler);
                _events_engine.default.on(document, downPointerEventName, downHandler);
                _events_engine.default.on(document, movePointerEventName, moveHandler);
                this._disposeHandlers = function() {
                    parameters.root.off(_click.name, clickHandler);
                    parameters.root.off(downPointerEventName, downHandler);
                    _events_engine.default.off(document, downPointerEventName, downHandler);
                    _events_engine.default.off(document, movePointerEventName, moveHandler)
                };

                function clickHandler(e) {
                    processClick(e, parameters)
                }
                var isRootDown = false;

                function downHandler(e) {
                    if (isRootDown) {
                        isRootDown = false
                    } else {
                        if (void 0 !== parameters.getData(e)) {
                            isRootDown = true
                        }
                        moveHandler(e)
                    }
                }

                function moveHandler(e) {
                    processHover(e, parameters);
                    parameters.widget._getOption("tooltip").enabled && processTooltip(e, parameters)
                }
            },
            dispose: function() {
                this._disposeHandlers()
            }
        };

        function processClick(e, params) {
            var id = params.getData(e);
            if (id >= 0) {
                params.click({
                    node: params.getNode(id),
                    coords: params.getCoords(e),
                    event: e
                })
            }
        }

        function processHover(e, params) {
            var id = params.getData(e);
            if (id >= 0) {
                params.getNode(id).setHover()
            } else {
                params.widget.clearHover()
            }
        }

        function processTooltip(e, params) {
            var id = params.getData(e, true);
            var coords;
            if (id >= 0) {
                coords = (0, _index.eventData)(e);
                params.getNode(id).showTooltip([coords.x, coords.y])
            } else {
                params.widget.hideTooltip()
            }
        }
    },
    /*!*******************************!*\
      !*** external "window.JSZip" ***!
      \*******************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports) {
        module.exports = window.JSZip
    },
    /*!**************************************************************!*\
      !*** ./artifacts/transpiled-npm/localization/ldml/number.js ***!
      \**************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getFormatter = getFormatter;
        exports.getFormat = getFormat;
        var _math = __webpack_require__( /*! ../../core/utils/math */ 29);
        var _utils = __webpack_require__( /*! ../utils */ 240);
        var DEFAULT_CONFIG = {
            thousandsSeparator: ",",
            decimalSeparator: "."
        };
        var ESCAPING_CHAR = "'";
        var MAXIMUM_NUMBER_LENGTH = 15;

        function getGroupSizes(formatString) {
            return formatString.split(",").slice(1).map(function(str) {
                return str.split("").filter(function(char) {
                    return "#" === char || "0" === char
                }).length
            })
        }

        function getSignParts(format) {
            var signParts = format.split(";");
            if (1 === signParts.length) {
                signParts.push("-" + signParts[0])
            }
            return signParts
        }

        function reverseString(str) {
            return str.toString().split("").reverse().join("")
        }

        function isPercentFormat(format) {
            return format.indexOf("%") !== -1 && !format.match(/'[^']*%[^']*'/g)
        }

        function removeStubs(str) {
            return str.replace(/'.+'/g, "")
        }

        function getNonRequiredDigitCount(floatFormat) {
            if (!floatFormat) {
                return 0
            }
            var format = removeStubs(floatFormat);
            return format.length - format.replace(/[#]/g, "").length
        }

        function getRequiredDigitCount(floatFormat) {
            if (!floatFormat) {
                return 0
            }
            var format = removeStubs(floatFormat);
            return format.length - format.replace(/[0]/g, "").length
        }

        function normalizeValueString(valuePart, minDigitCount, maxDigitCount) {
            if (!valuePart) {
                return ""
            }
            if (valuePart.length > maxDigitCount) {
                valuePart = valuePart.substr(0, maxDigitCount)
            }
            while (valuePart.length > minDigitCount && "0" === valuePart.slice(-1)) {
                valuePart = valuePart.substr(0, valuePart.length - 1)
            }
            while (valuePart.length < minDigitCount) {
                valuePart += "0"
            }
            return valuePart
        }

        function applyGroups(valueString, groupSizes, thousandsSeparator) {
            if (!groupSizes.length) {
                return valueString
            }
            var groups = [];
            var index = 0;
            while (valueString) {
                var groupSize = groupSizes[index];
                if (!groupSize) {
                    break
                }
                groups.push(valueString.slice(0, groupSize));
                valueString = valueString.slice(groupSize);
                if (index < groupSizes.length - 1) {
                    index++
                }
            }
            return groups.join(thousandsSeparator)
        }

        function formatNumberPart(format, valueString) {
            return format.split(ESCAPING_CHAR).map(function(formatPart, escapeIndex) {
                var isEscape = escapeIndex % 2;
                if (!formatPart && isEscape) {
                    return ESCAPING_CHAR
                }
                return isEscape ? formatPart : formatPart.replace(/[,#0]+/, valueString)
            }).join("")
        }

        function getFloatPointIndex(format) {
            var isEscape = false;
            for (var index = 0; index < format.length; index++) {
                if ("'" === format[index]) {
                    isEscape = !isEscape
                }
                if ("." === format[index] && !isEscape) {
                    return index
                }
            }
            return format.length
        }

        function getFormatter(format, config) {
            config = config || DEFAULT_CONFIG;
            return function(value) {
                if ("number" !== typeof value || isNaN(value)) {
                    return ""
                }
                var signFormatParts = getSignParts(format);
                var isPositiveZero = 1 / value === 1 / 0;
                var isPositive = value > 0 || isPositiveZero;
                var numberFormat = signFormatParts[isPositive ? 0 : 1];
                if (isPercentFormat(numberFormat)) {
                    value = 100 * value
                }
                if (!isPositive) {
                    value = -value
                }
                var floatPointIndex = getFloatPointIndex(numberFormat);
                var floatFormatParts = [numberFormat.substr(0, floatPointIndex), numberFormat.substr(floatPointIndex + 1)];
                var minFloatPrecision = getRequiredDigitCount(floatFormatParts[1]);
                var maxFloatPrecision = minFloatPrecision + getNonRequiredDigitCount(floatFormatParts[1]);
                var minIntegerPrecision = getRequiredDigitCount(floatFormatParts[0]);
                var maxIntegerPrecision = getNonRequiredDigitCount(floatFormatParts[0]) || config.unlimitedIntegerDigits ? void 0 : minIntegerPrecision;
                var integerLength = Math.floor(value).toString().length;
                var floatPrecision = (0, _math.fitIntoRange)(maxFloatPrecision, 0, MAXIMUM_NUMBER_LENGTH - integerLength);
                var groupSizes = getGroupSizes(floatFormatParts[0]).reverse();
                var valueParts = (0, _utils.toFixed)(value, floatPrecision < 0 ? 0 : floatPrecision).split(".");
                var valueIntegerPart = normalizeValueString(reverseString(valueParts[0]), minIntegerPrecision, maxIntegerPrecision);
                var valueFloatPart = normalizeValueString(valueParts[1], minFloatPrecision, maxFloatPrecision);
                valueIntegerPart = applyGroups(valueIntegerPart, groupSizes, config.thousandsSeparator);
                var integerString = reverseString(formatNumberPart(reverseString(floatFormatParts[0]), valueIntegerPart));
                var floatString = maxFloatPrecision ? formatNumberPart(floatFormatParts[1], valueFloatPart) : "";
                var result = integerString + (floatString.match(/\d/) ? config.decimalSeparator : "") + floatString;
                return result
            }
        }

        function parseValue(text, isPercent, isNegative) {
            var value = (isPercent ? .01 : 1) * parseFloat(text) || 0;
            return isNegative ? -value : value
        }

        function prepareValueText(valueText, formatter, isPercent, isIntegerPart) {
            var nextValueText = valueText;
            var char;
            var text;
            var nextText;
            do {
                if (nextText) {
                    char = text.length === nextText.length ? "0" : "1";
                    valueText = isIntegerPart ? char + valueText : valueText + char
                }
                text = nextText || formatter(parseValue(nextValueText, isPercent));
                nextValueText = isIntegerPart ? "1" + nextValueText : nextValueText + "1";
                nextText = formatter(parseValue(nextValueText, isPercent))
            } while (text !== nextText && (isIntegerPart ? text.length === nextText.length : text.length <= nextText.length));
            if (isIntegerPart && nextText.length > text.length) {
                var hasGroups = formatter(12345).indexOf("12345") === -1;
                do {
                    valueText = "1" + valueText
                } while (hasGroups && parseValue(valueText, isPercent) < 1e5)
            }
            return valueText
        }

        function getFormatByValueText(valueText, formatter, isPercent, isNegative) {
            var format = formatter(parseValue(valueText, isPercent, isNegative));
            var valueTextParts = valueText.split(".");
            var valueTextWithModifiedFloat = valueTextParts[0] + ".3" + valueTextParts[1].slice(1);
            var valueWithModifiedFloat = parseValue(valueTextWithModifiedFloat, isPercent, isNegative);
            var decimalSeparatorIndex = formatter(valueWithModifiedFloat).indexOf("3") - 1;
            format = format.replace(/(\d)\D(\d)/g, "$1,$2");
            if (decimalSeparatorIndex >= 0) {
                format = format.slice(0, decimalSeparatorIndex) + "." + format.slice(decimalSeparatorIndex + 1)
            }
            format = format.replace(/1+/, "1").replace(/1/g, "#");
            if (!isPercent) {
                format = format.replace("%", "'%'")
            }
            return format
        }

        function getFormat(formatter) {
            var valueText = ".";
            var isPercent = formatter(1).indexOf("100") >= 0;
            valueText = prepareValueText(valueText, formatter, isPercent, true);
            valueText = prepareValueText(valueText, formatter, isPercent, false);
            var positiveFormat = getFormatByValueText(valueText, formatter, isPercent, false);
            var negativeFormat = getFormatByValueText(valueText, formatter, isPercent, true);
            return negativeFormat === "-" + positiveFormat ? positiveFormat : positiveFormat + ";" + negativeFormat
        }
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/storage.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.sessionStorage = void 0;
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var window = (0, _window.getWindow)();
        var getSessionStorage = function() {
            var sessionStorage;
            try {
                sessionStorage = window.sessionStorage
            } catch (e) {}
            return sessionStorage
        };
        exports.sessionStorage = getSessionStorage
    },
    /*!*********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/timezones/utils.timezones_data.js ***!
      \*********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _query = _interopRequireDefault(__webpack_require__( /*! ../../../data/query */ 48));
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../../../core/errors */ 25));
        var _timezones_data = _interopRequireDefault(__webpack_require__( /*! ./timezones_data */ 527));
        var _math = __webpack_require__( /*! ../../../core/utils/math */ 29);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var timeZoneDataUtils = {
            _timeZones: _timezones_data.default.zones,
            getDisplayedTimeZones: function(timestamp) {
                var _this = this;
                var timeZones = this._timeZones.map(function(timezone) {
                    var offset = _this.getUtcOffset(timezone.offsets, timezone.offsetIndices, timezone.untils, timestamp);
                    var title = "(GMT ".concat(_this.formatOffset(offset), ") ").concat(_this.formatId(timezone.id));
                    return {
                        offset: offset,
                        title: title,
                        id: timezone.id
                    }
                });
                return (0, _query.default)(timeZones).sortBy("offset").toArray()
            },
            formatOffset: function(offset) {
                var hours = Math.floor(offset);
                var minutesInDecimal = offset - hours;
                var signString = (0, _math.sign)(offset) >= 0 ? "+" : "-";
                var hoursString = "0".concat(Math.abs(hours)).slice(-2);
                var minutesString = minutesInDecimal > 0 ? ":".concat(60 * minutesInDecimal) : ":00";
                return signString + hoursString + minutesString
            },
            formatId: function(id) {
                return id.split("/").join(" - ").split("_").join(" ")
            },
            getTimezoneById: function(id) {
                var result;
                var i = 0;
                var tzList = this._timeZones;
                if (id) {
                    while (!result) {
                        if (!tzList[i]) {
                            _errors.default.log("W0009", id);
                            return
                        }
                        var currentId = tzList[i].id;
                        if (currentId === id) {
                            result = tzList[i]
                        }
                        i++
                    }
                }
                return result
            },
            getTimeZoneOffsetById: function(id, timestamp) {
                var tz = this.getTimezoneById(id);
                if (tz) {
                    return this.getUtcOffset(tz.offsets, tz.offsetIndices, tz.untils, timestamp)
                }
                return
            },
            getTimeZoneDeclarationTuple: function(id, year) {
                var tz = this.getTimezoneById(id);
                if (tz) {
                    return this.getTimeZoneDeclarationTupleCore(tz.offsets, tz.offsetIndices, tz.untils, year)
                }
                return []
            },
            getTimeZoneDeclarationTupleCore: function(offsets, offsetIndices, untils, year) {
                var tupleResult = [];
                var offsetIndicesList = offsetIndices.split("");
                var offsetsList = offsets.split("|").map(function(value) {
                    return parseInt(value)
                });
                var untilsList = untils.split("|").map(function(until) {
                    if ("Infinity" === until) {
                        return null
                    }
                    return 1e3 * parseInt(until, 36)
                });
                var currentDate = 0;
                for (var i = 0, listLength = untilsList.length; i < listLength; i++) {
                    currentDate += untilsList[i];
                    if (new Date(currentDate).getFullYear() === year) {
                        var offset = offsetsList[Number(offsetIndicesList[i + 1])];
                        tupleResult.push({
                            date: currentDate,
                            offset: -offset / 60
                        })
                    }
                    if (new Date(currentDate).getFullYear() > year) {
                        break
                    }
                }
                return tupleResult
            },
            getUtcOffset: function(offsets, offsetIndices, untils, dateTimeStamp) {
                var index = 0;
                var offsetIndicesList = offsetIndices.split("");
                var offsetsList = offsets.split("|");
                var untilsList = untils.split("|").map(function(until) {
                    if ("Infinity" === until) {
                        return null
                    }
                    return 1e3 * parseInt(until, 36)
                });
                var currentUntil = 0;
                for (var i = 0, listLength = untilsList.length; i < listLength; i++) {
                    currentUntil += untilsList[i];
                    if (dateTimeStamp >= currentUntil) {
                        index = i;
                        continue
                    } else {
                        break
                    }
                }
                if (untilsList[index + 1]) {
                    index++
                }
                var offset = Number(offsetsList[Number(offsetIndicesList[index])]);
                return -offset / 60 || offset
            }
        };
        var _default = timeZoneDataUtils;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/animation/transition_executor/transition_executor.js ***!
      \***************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.TransitionExecutor = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _fx = _interopRequireDefault(__webpack_require__( /*! ../fx */ 42));
        var _presets = __webpack_require__( /*! ../presets/presets */ 200);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var directionPostfixes = {
            forward: " dx-forward",
            backward: " dx-backward",
            none: " dx-no-direction",
            undefined: " dx-no-direction"
        };
        var DX_ANIMATING_CLASS = "dx-animating";
        var TransitionExecutor = _class.default.inherit({
            ctor: function() {
                this._accumulatedDelays = {
                    enter: 0,
                    leave: 0
                };
                this._animations = [];
                this.reset()
            },
            _createAnimations: function($elements, initialConfig, configModifier, type) {
                var that = this;
                var result = [];
                configModifier = configModifier || {};
                var animationConfig = this._prepareElementAnimationConfig(initialConfig, configModifier, type);
                if (animationConfig) {
                    $elements.each(function() {
                        var animation = that._createAnimation((0, _renderer.default)(this), animationConfig, configModifier);
                        if (animation) {
                            animation.element.addClass(DX_ANIMATING_CLASS);
                            animation.setup();
                            result.push(animation)
                        }
                    })
                }
                return result
            },
            _prepareElementAnimationConfig: function(config, configModifier, type) {
                var result;
                if ("string" === typeof config) {
                    var presetName = config;
                    config = _presets.presets.getPreset(presetName)
                }
                if (!config) {
                    result = void 0
                } else {
                    if ((0, _type.isFunction)(config[type])) {
                        result = config[type]
                    } else {
                        result = (0, _extend.extend)({
                            skipElementInitialStyles: true,
                            cleanupWhen: this._completePromise
                        }, config, configModifier);
                        if (!result.type || "css" === result.type) {
                            var cssClass = "dx-" + type;
                            var extraCssClasses = (result.extraCssClasses ? " " + result.extraCssClasses : "") + directionPostfixes[result.direction];
                            result.type = "css";
                            result.from = (result.from || cssClass) + extraCssClasses;
                            result.to = result.to || cssClass + "-active"
                        }
                        result.staggerDelay = result.staggerDelay || 0;
                        result.delay = result.delay || 0;
                        if (result.staggerDelay) {
                            result.delay += this._accumulatedDelays[type];
                            this._accumulatedDelays[type] += result.staggerDelay
                        }
                    }
                }
                return result
            },
            _createAnimation: function($element, animationConfig, configModifier) {
                var result;
                if ((0, _type.isPlainObject)(animationConfig)) {
                    result = _fx.default.createAnimation($element, animationConfig)
                } else {
                    if ((0, _type.isFunction)(animationConfig)) {
                        result = animationConfig($element, configModifier)
                    }
                }
                return result
            },
            _startAnimations: function() {
                var animations = this._animations;
                for (var i = 0; i < animations.length; i++) {
                    animations[i].start()
                }
            },
            _stopAnimations: function(jumpToEnd) {
                var animations = this._animations;
                for (var i = 0; i < animations.length; i++) {
                    animations[i].stop(jumpToEnd)
                }
            },
            _clearAnimations: function() {
                var animations = this._animations;
                for (var i = 0; i < animations.length; i++) {
                    animations[i].element.removeClass(DX_ANIMATING_CLASS)
                }
                this._animations.length = 0
            },
            reset: function() {
                this._accumulatedDelays.enter = 0;
                this._accumulatedDelays.leave = 0;
                this._clearAnimations();
                this._completeDeferred = new _deferred.Deferred;
                this._completePromise = this._completeDeferred.promise()
            },
            enter: function($elements, animationConfig, configModifier) {
                var animations = this._createAnimations($elements, animationConfig, configModifier, "enter");
                this._animations.push.apply(this._animations, animations)
            },
            leave: function($elements, animationConfig, configModifier) {
                var animations = this._createAnimations($elements, animationConfig, configModifier, "leave");
                this._animations.push.apply(this._animations, animations)
            },
            start: function() {
                var that = this;
                var result;
                if (!this._animations.length) {
                    that.reset();
                    result = (new _deferred.Deferred).resolve().promise()
                } else {
                    var animationDeferreds = (0, _iterator.map)(this._animations, function(animation) {
                        var result = new _deferred.Deferred;
                        animation.deferred.always(function() {
                            result.resolve()
                        });
                        return result.promise()
                    });
                    result = _deferred.when.apply(_renderer.default, animationDeferreds).always(function() {
                        that._completeDeferred.resolve();
                        that.reset()
                    });
                    (0, _common.executeAsync)(function() {
                        that._startAnimations()
                    })
                }
                return result
            },
            stop: function(jumpToEnd) {
                this._stopAnimations(jumpToEnd)
            }
        });
        exports.TransitionExecutor = TransitionExecutor
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/events/index.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.Event = exports.triggerHandler = exports.trigger = exports.off = exports.one = exports.on = void 0;
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ./core/events_engine */ 5));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var on = _events_engine.default.on;
        exports.on = on;
        var one = _events_engine.default.one;
        exports.one = one;
        var off = _events_engine.default.off;
        exports.off = off;
        var trigger = _events_engine.default.trigger;
        exports.trigger = trigger;
        var triggerHandler = _events_engine.default.triggerHandler;
        exports.triggerHandler = triggerHandler;
        var Event = _events_engine.default.Event;
        exports.Event = Event
    },
    /*!***********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/overlay/ui.overlay.js ***!
      \***********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _fx = _interopRequireDefault(__webpack_require__( /*! ../../animation/fx */ 42));
        var _position = _interopRequireDefault(__webpack_require__( /*! ../../animation/position */ 81));
        var _translator = __webpack_require__( /*! ../../animation/translator */ 28);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _element = __webpack_require__( /*! ../../core/element */ 18);
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _empty_template = __webpack_require__( /*! ../../core/templates/empty_template */ 91);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _dom = __webpack_require__( /*! ../../core/utils/dom */ 33);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _math = __webpack_require__( /*! ../../core/utils/math */ 29);
        var _ready_callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/ready_callbacks */ 49));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _view_port = __webpack_require__( /*! ../../core/utils/view_port */ 80);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _drag = __webpack_require__( /*! ../../events/drag */ 76);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../../events/pointer */ 24));
        var _short = __webpack_require__( /*! ../../events/short */ 128);
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _visibility_change = __webpack_require__( /*! ../../events/visibility_change */ 59);
        var _hide_callback = __webpack_require__( /*! ../../mobile/hide_callback */ 232);
        var _resizable = _interopRequireDefault(__webpack_require__( /*! ../resizable */ 193));
        var _selectors = __webpack_require__( /*! ../widget/selectors */ 70);
        var _swatch_container = _interopRequireDefault(__webpack_require__( /*! ../widget/swatch_container */ 170));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var zIndexPool = _interopRequireWildcard(__webpack_require__( /*! ./z_index */ 329));

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        var ready = _ready_callbacks.default.add;
        var window = (0, _window.getWindow)();
        var viewPortChanged = _view_port.changeCallback;
        var OVERLAY_CLASS = "dx-overlay";
        var OVERLAY_WRAPPER_CLASS = "dx-overlay-wrapper";
        var OVERLAY_CONTENT_CLASS = "dx-overlay-content";
        var OVERLAY_SHADER_CLASS = "dx-overlay-shader";
        var OVERLAY_MODAL_CLASS = "dx-overlay-modal";
        var INNER_OVERLAY_CLASS = "dx-inner-overlay";
        var INVISIBLE_STATE_CLASS = "dx-state-invisible";
        var ANONYMOUS_TEMPLATE_NAME = "content";
        var RTL_DIRECTION_CLASS = "dx-rtl";
        var ACTIONS = ["onShowing", "onShown", "onHiding", "onHidden", "onPositioned", "onResizeStart", "onResize", "onResizeEnd"];
        var OVERLAY_STACK = [];
        var DISABLED_STATE_CLASS = "dx-state-disabled";
        var PREVENT_SAFARI_SCROLLING_CLASS = "dx-prevent-safari-scrolling";
        var TAB_KEY = "tab";
        var POSITION_ALIASES = {
            top: {
                my: "top center",
                at: "top center"
            },
            bottom: {
                my: "bottom center",
                at: "bottom center"
            },
            right: {
                my: "right center",
                at: "right center"
            },
            left: {
                my: "left center",
                at: "left center"
            },
            center: {
                my: "center",
                at: "center"
            },
            "right bottom": {
                my: "right bottom",
                at: "right bottom"
            },
            "right top": {
                my: "right top",
                at: "right top"
            },
            "left bottom": {
                my: "left bottom",
                at: "left bottom"
            },
            "left top": {
                my: "left top",
                at: "left top"
            }
        };
        var realDevice = _devices.default.real();
        var firefoxDesktop = _browser.default.mozilla && "desktop" === realDevice.deviceType;
        var iOS = "ios" === realDevice.platform;
        var hasSafariAddressBar = _browser.default.safari && "desktop" !== realDevice.deviceType;
        var forceRepaint = function($element) {
            if (firefoxDesktop) {
                $element.width()
            }
        };
        var getElement = function(value) {
            if ((0, _type.isEvent)(value)) {
                value = value.target
            }
            return (0, _renderer.default)(value)
        };
        ready(function() {
            _events_engine.default.subscribeGlobal(_dom_adapter.default.getDocument(), _pointer.default.down, function(e) {
                for (var i = OVERLAY_STACK.length - 1; i >= 0; i--) {
                    if (!OVERLAY_STACK[i]._proxiedDocumentDownHandler(e)) {
                        return
                    }
                }
            })
        });
        var Overlay = _ui.default.inherit({
            _supportedKeys: function() {
                var offsetSize = 5;
                var move = function(top, left, e) {
                    if (!this.option("dragEnabled")) {
                        return
                    }
                    e.preventDefault();
                    e.stopPropagation();
                    var allowedOffsets = this._allowedOffsets();
                    var offset = {
                        top: (0, _math.fitIntoRange)(top, -allowedOffsets.top, allowedOffsets.bottom),
                        left: (0, _math.fitIntoRange)(left, -allowedOffsets.left, allowedOffsets.right)
                    };
                    this._changePosition(offset)
                };
                return (0, _extend.extend)(this.callBase(), {
                    escape: function() {
                        this.hide()
                    },
                    upArrow: move.bind(this, -offsetSize, 0),
                    downArrow: move.bind(this, offsetSize, 0),
                    leftArrow: move.bind(this, 0, -offsetSize),
                    rightArrow: move.bind(this, 0, offsetSize)
                })
            },
            _getDefaultOptions: function() {
                var _this = this;
                return (0, _extend.extend)(this.callBase(), {
                    activeStateEnabled: false,
                    visible: false,
                    deferRendering: true,
                    shading: true,
                    shadingColor: "",
                    position: {
                        my: "center",
                        at: "center"
                    },
                    width: function() {
                        return .8 * (0, _renderer.default)(window).width()
                    },
                    minWidth: null,
                    maxWidth: null,
                    height: function() {
                        return .8 * (0, _renderer.default)(window).height()
                    },
                    minHeight: null,
                    maxHeight: null,
                    animation: {
                        show: {
                            type: "pop",
                            duration: 300,
                            from: {
                                scale: .55
                            }
                        },
                        hide: {
                            type: "pop",
                            duration: 300,
                            to: {
                                opacity: 0,
                                scale: .55
                            },
                            from: {
                                opacity: 1,
                                scale: 1
                            }
                        }
                    },
                    closeOnOutsideClick: false,
                    onShowing: null,
                    onShown: null,
                    onHiding: null,
                    onHidden: null,
                    contentTemplate: "content",
                    dragEnabled: false,
                    resizeEnabled: false,
                    onResizeStart: null,
                    onResize: null,
                    onResizeEnd: null,
                    innerOverlay: false,
                    target: void 0,
                    container: void 0,
                    hideTopOverlayHandler: function() {
                        _this.hide()
                    },
                    closeOnTargetScroll: false,
                    onPositioned: null,
                    boundaryOffset: {
                        h: 0,
                        v: 0
                    },
                    propagateOutsideClick: false,
                    ignoreChildEvents: true,
                    _checkParentVisibility: true,
                    _fixedPosition: false
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: function() {
                        return !(0, _window.hasWindow)()
                    },
                    options: {
                        width: null,
                        height: null,
                        animation: null,
                        _checkParentVisibility: false
                    }
                }])
            },
            _setOptionsByReference: function() {
                this.callBase();
                (0, _extend.extend)(this._optionsByReference, {
                    animation: true
                })
            },
            _wrapper: function() {
                return this._$wrapper
            },
            _container: function() {
                return this._$content
            },
            _eventBindingTarget: function() {
                return this._$content
            },
            _init: function() {
                this.callBase();
                this._initActions();
                this._initCloseOnOutsideClickHandler();
                this._initTabTerminatorHandler();
                this._$wrapper = (0, _renderer.default)("<div>").addClass(OVERLAY_WRAPPER_CLASS);
                this._$content = (0, _renderer.default)("<div>").addClass(OVERLAY_CONTENT_CLASS);
                this._initInnerOverlayClass();
                var $element = this.$element();
                this._$wrapper.addClass($element.attr("class"));
                $element.addClass(OVERLAY_CLASS);
                this._$wrapper.attr("data-bind", "dxControlsDescendantBindings: true");
                _events_engine.default.on(this._$wrapper, "MSPointerDown", _common.noop);
                _events_engine.default.on(this._$wrapper, "focusin", function(e) {
                    e.stopPropagation()
                });
                this._toggleViewPortSubscription(true);
                this._initHideTopOverlayHandler(this.option("hideTopOverlayHandler"))
            },
            _initOptions: function(options) {
                this._initTarget(options.target);
                var container = void 0 === options.container ? this.option("container") : options.container;
                this._initContainer(container);
                this.callBase(options)
            },
            _initInnerOverlayClass: function() {
                this._$content.toggleClass(INNER_OVERLAY_CLASS, this.option("innerOverlay"))
            },
            _initTarget: function(target) {
                if (!(0, _type.isDefined)(target)) {
                    return
                }
                var options = this.option();
                (0, _iterator.each)(["position.of", "animation.show.from.position.of", "animation.show.to.position.of", "animation.hide.from.position.of", "animation.hide.to.position.of"], function(_, path) {
                    var pathParts = path.split(".");
                    var option = options;
                    while (option) {
                        if (1 === pathParts.length) {
                            if ((0, _type.isPlainObject)(option)) {
                                option[pathParts.shift()] = target
                            }
                            break
                        } else {
                            option = option[pathParts.shift()]
                        }
                    }
                })
            },
            _initContainer: function(container) {
                container = void 0 === container ? (0, _view_port.value)() : container;
                var $element = this.$element();
                var $container = $element.closest(container);
                if (!$container.length) {
                    $container = (0, _renderer.default)(container).first()
                }
                this._$container = $container.length ? $container : $element.parent()
            },
            _initHideTopOverlayHandler: function(handler) {
                this._hideTopOverlayHandler = handler
            },
            _initActions: function() {
                var _this2 = this;
                this._actions = {};
                (0, _iterator.each)(ACTIONS, function(_, action) {
                    _this2._actions[action] = _this2._createActionByOption(action, {
                        excludeValidators: ["disabled", "readOnly"]
                    }) || _common.noop
                })
            },
            _initCloseOnOutsideClickHandler: function() {
                var that = this;
                this._proxiedDocumentDownHandler = function() {
                    return that._documentDownHandler.apply(that, arguments)
                }
            },
            _documentDownHandler: function(e) {
                if (this._showAnimationProcessing) {
                    this._stopAnimation()
                }
                var closeOnOutsideClick = this.option("closeOnOutsideClick");
                if ((0, _type.isFunction)(closeOnOutsideClick)) {
                    closeOnOutsideClick = closeOnOutsideClick(e)
                }
                var $container = this._$content;
                var isAttachedTarget = (0, _renderer.default)(window.document).is(e.target) || (0, _dom.contains)(window.document, e.target);
                var isInnerOverlay = (0, _renderer.default)(e.target).closest("." + INNER_OVERLAY_CLASS).length;
                var outsideClick = isAttachedTarget && !isInnerOverlay && !($container.is(e.target) || (0, _dom.contains)($container.get(0), e.target));
                if (outsideClick && closeOnOutsideClick) {
                    this._outsideClickHandler(e)
                }
                return this.option("propagateOutsideClick")
            },
            _outsideClickHandler: function(e) {
                if (this.option("shading")) {
                    e.preventDefault()
                }
                this.hide()
            },
            _getAnonymousTemplateName: function() {
                return ANONYMOUS_TEMPLATE_NAME
            },
            _initTemplates: function() {
                this._templateManager.addDefaultTemplates({
                    content: new _empty_template.EmptyTemplate
                });
                this.callBase()
            },
            _isTopOverlay: function() {
                var overlayStack = this._overlayStack();
                for (var i = overlayStack.length - 1; i >= 0; i--) {
                    var tabbableElements = overlayStack[i]._findTabbableBounds();
                    if (tabbableElements.first || tabbableElements.last) {
                        return overlayStack[i] === this
                    }
                }
                return false
            },
            _overlayStack: function() {
                return OVERLAY_STACK
            },
            _zIndexInitValue: function() {
                return Overlay.baseZIndex()
            },
            _toggleViewPortSubscription: function(toggle) {
                viewPortChanged.remove(this._viewPortChangeHandle);
                if (toggle) {
                    this._viewPortChangeHandle = this._viewPortChangeHandler.bind(this);
                    viewPortChanged.add(this._viewPortChangeHandle)
                }
            },
            _viewPortChangeHandler: function() {
                this._initContainer(this.option("container"));
                this._refresh()
            },
            _renderVisibilityAnimate: function(visible) {
                this._stopAnimation();
                return visible ? this._show() : this._hide()
            },
            _normalizePosition: function() {
                var position = this.option("position");
                this._position = "function" === typeof position ? position() : position
            },
            _getAnimationConfig: function() {
                var animation = this.option("animation");
                if ((0, _type.isFunction)(animation)) {
                    animation = animation.call(this)
                }
                return animation
            },
            _show: function() {
                var _this3 = this;
                var that = this;
                var deferred = new _deferred.Deferred;
                this._parentHidden = this._isParentHidden();
                deferred.done(function() {
                    delete that._parentHidden
                });
                if (this._parentHidden) {
                    this._isHidden = true;
                    return deferred.resolve()
                }
                if (this._currentVisible) {
                    return (new _deferred.Deferred).resolve().promise()
                }
                this._currentVisible = true;
                this._isShown = false;
                this._normalizePosition();
                var animation = that._getAnimationConfig() || {};
                var showAnimation = this._normalizeAnimation(animation.show, "to");
                var startShowAnimation = showAnimation && showAnimation.start || _common.noop;
                var completeShowAnimation = showAnimation && showAnimation.complete || _common.noop;
                if (this._isHidingActionCanceled) {
                    delete this._isHidingActionCanceled;
                    deferred.resolve()
                } else {
                    var show = function() {
                        _this3._renderVisibility(true);
                        if (_this3._isShowingActionCanceled) {
                            delete _this3._isShowingActionCanceled;
                            deferred.resolve();
                            return
                        }
                        _this3._animate(showAnimation, function() {
                            if (that.option("focusStateEnabled")) {
                                _events_engine.default.trigger(that._focusTarget(), "focus")
                            }
                            completeShowAnimation.apply(this, arguments);
                            that._showAnimationProcessing = false;
                            that._isShown = true;
                            that._actions.onShown();
                            that._toggleSafariScrolling(false);
                            deferred.resolve()
                        }, function() {
                            startShowAnimation.apply(this, arguments);
                            that._showAnimationProcessing = true
                        })
                    };
                    if (this.option("templatesRenderAsynchronously")) {
                        this._stopShowTimer();
                        this._asyncShowTimeout = setTimeout(show)
                    } else {
                        show()
                    }
                }
                return deferred.promise()
            },
            _normalizeAnimation: function(animation, prop) {
                if (animation) {
                    animation = (0, _extend.extend)({
                        type: "slide"
                    }, animation);
                    if (animation[prop] && "object" === _typeof(animation[prop])) {
                        (0, _extend.extend)(animation[prop], {
                            position: this._position
                        })
                    }
                }
                return animation
            },
            _hide: function() {
                if (!this._currentVisible) {
                    return (new _deferred.Deferred).resolve().promise()
                }
                this._currentVisible = false;
                var that = this;
                var deferred = new _deferred.Deferred;
                var animation = that._getAnimationConfig() || {};
                var hideAnimation = this._normalizeAnimation(animation.hide, "from");
                var startHideAnimation = hideAnimation && hideAnimation.start || _common.noop;
                var completeHideAnimation = hideAnimation && hideAnimation.complete || _common.noop;
                var hidingArgs = {
                    cancel: false
                };
                if (this._isShowingActionCanceled) {
                    deferred.resolve()
                } else {
                    this._actions.onHiding(hidingArgs);
                    that._toggleSafariScrolling(true);
                    if (hidingArgs.cancel) {
                        this._isHidingActionCanceled = true;
                        this.option("visible", true);
                        deferred.resolve()
                    } else {
                        this._forceFocusLost();
                        this._toggleShading(false);
                        this._toggleSubscriptions(false);
                        this._stopShowTimer();
                        this._animate(hideAnimation, function() {
                            var _that$_actions;
                            that._$content.css("pointerEvents", "");
                            that._renderVisibility(false);
                            completeHideAnimation.apply(this, arguments);
                            that._hideAnimationProcessing = false;
                            null === (_that$_actions = that._actions) || void 0 === _that$_actions ? void 0 : _that$_actions.onHidden();
                            deferred.resolve()
                        }, function() {
                            that._$content.css("pointerEvents", "none");
                            startHideAnimation.apply(this, arguments);
                            that._hideAnimationProcessing = true
                        })
                    }
                }
                return deferred.promise()
            },
            _forceFocusLost: function() {
                var activeElement = _dom_adapter.default.getActiveElement();
                var shouldResetActiveElement = !!this._$content.find(activeElement).length;
                if (shouldResetActiveElement) {
                    (0, _dom.resetActiveElement)()
                }
            },
            _animate: function(animation, completeCallback, startCallback) {
                if (animation) {
                    startCallback = startCallback || animation.start || _common.noop;
                    _fx.default.animate(this._$content, (0, _extend.extend)({}, animation, {
                        start: startCallback,
                        complete: completeCallback
                    }))
                } else {
                    completeCallback()
                }
            },
            _stopAnimation: function() {
                _fx.default.stop(this._$content, true)
            },
            _renderVisibility: function(visible) {
                if (visible && this._isParentHidden()) {
                    return
                }
                this._currentVisible = visible;
                this._stopAnimation();
                if (!visible) {
                    (0, _visibility_change.triggerHidingEvent)(this._$content)
                }
                this._toggleVisibility(visible);
                this._$content.toggleClass(INVISIBLE_STATE_CLASS, !visible);
                this._updateZIndexStackPosition(visible);
                if (visible) {
                    this._renderContent();
                    var showingArgs = {
                        cancel: false
                    };
                    this._actions.onShowing(showingArgs);
                    if (showingArgs.cancel) {
                        this._toggleVisibility(false);
                        this._$content.toggleClass(INVISIBLE_STATE_CLASS, true);
                        this._updateZIndexStackPosition(false);
                        this._moveFromContainer();
                        this._isShowingActionCanceled = true;
                        this.option("visible", false);
                        return
                    }
                    this._moveToContainer();
                    this._renderGeometry();
                    (0, _visibility_change.triggerShownEvent)(this._$content);
                    (0, _visibility_change.triggerResizeEvent)(this._$content)
                } else {
                    this._moveFromContainer()
                }
                this._toggleShading(visible);
                this._toggleSubscriptions(visible)
            },
            _updateZIndexStackPosition: function(pushToStack) {
                var overlayStack = this._overlayStack();
                var index = (0, _array.inArray)(this, overlayStack);
                if (pushToStack) {
                    if (index === -1) {
                        this._zIndex = zIndexPool.create(this._zIndexInitValue());
                        overlayStack.push(this)
                    }
                    this._$wrapper.css("zIndex", this._zIndex);
                    this._$content.css("zIndex", this._zIndex)
                } else {
                    if (index !== -1) {
                        overlayStack.splice(index, 1);
                        zIndexPool.remove(this._zIndex)
                    }
                }
            },
            _toggleShading: function(visible) {
                this._$wrapper.toggleClass(OVERLAY_MODAL_CLASS, this.option("shading") && !this.option("container"));
                this._$wrapper.toggleClass(OVERLAY_SHADER_CLASS, visible && this.option("shading"));
                this._$wrapper.css("backgroundColor", this.option("shading") ? this.option("shadingColor") : "");
                this._toggleTabTerminator(visible && this.option("shading"))
            },
            _initTabTerminatorHandler: function() {
                var that = this;
                this._proxiedTabTerminatorHandler = function() {
                    that._tabKeyHandler.apply(that, arguments)
                }
            },
            _toggleTabTerminator: function(enabled) {
                var eventName = (0, _index.addNamespace)("keydown", this.NAME);
                if (enabled) {
                    _events_engine.default.on(_dom_adapter.default.getDocument(), eventName, this._proxiedTabTerminatorHandler)
                } else {
                    _events_engine.default.off(_dom_adapter.default.getDocument(), eventName, this._proxiedTabTerminatorHandler)
                }
            },
            _findTabbableBounds: function() {
                var $elements = this._$wrapper.find("*");
                var elementsCount = $elements.length - 1;
                var result = {
                    first: null,
                    last: null
                };
                for (var i = 0; i <= elementsCount; i++) {
                    if (!result.first && $elements.eq(i).is(_selectors.tabbable)) {
                        result.first = $elements.eq(i)
                    }
                    if (!result.last && $elements.eq(elementsCount - i).is(_selectors.tabbable)) {
                        result.last = $elements.eq(elementsCount - i)
                    }
                    if (result.first && result.last) {
                        break
                    }
                }
                return result
            },
            _tabKeyHandler: function(e) {
                if ((0, _index.normalizeKeyName)(e) !== TAB_KEY || !this._isTopOverlay()) {
                    return
                }
                var tabbableElements = this._findTabbableBounds();
                var $firstTabbable = tabbableElements.first;
                var $lastTabbable = tabbableElements.last;
                var isTabOnLast = !e.shiftKey && e.target === $lastTabbable.get(0);
                var isShiftTabOnFirst = e.shiftKey && e.target === $firstTabbable.get(0);
                var isEmptyTabList = 0 === tabbableElements.length;
                var isOutsideTarget = !(0, _dom.contains)(this._$wrapper.get(0), e.target);
                if (isTabOnLast || isShiftTabOnFirst || isEmptyTabList || isOutsideTarget) {
                    e.preventDefault();
                    var $focusElement = e.shiftKey ? $lastTabbable : $firstTabbable;
                    _events_engine.default.trigger($focusElement, "focusin");
                    _events_engine.default.trigger($focusElement, "focus")
                }
            },
            _toggleSubscriptions: function(enabled) {
                if ((0, _window.hasWindow)()) {
                    this._toggleHideTopOverlayCallback(enabled);
                    this._toggleParentsScrollSubscription(enabled)
                }
            },
            _toggleHideTopOverlayCallback: function(subscribe) {
                if (!this._hideTopOverlayHandler) {
                    return
                }
                if (subscribe) {
                    _hide_callback.hideCallback.add(this._hideTopOverlayHandler)
                } else {
                    _hide_callback.hideCallback.remove(this._hideTopOverlayHandler)
                }
            },
            _toggleParentsScrollSubscription: function(subscribe) {
                var _this4 = this;
                if (!this._position) {
                    return
                }
                var target = this._position.of || (0, _renderer.default)();
                var closeOnScroll = this.option("closeOnTargetScroll");
                var $parents = getElement(target).parents();
                var scrollEvent = (0, _index.addNamespace)("scroll", this.NAME);
                if ("desktop" === _devices.default.real().deviceType) {
                    $parents = $parents.add(window)
                }
                this._proxiedTargetParentsScrollHandler = this._proxiedTargetParentsScrollHandler || function(e) {
                    _this4._targetParentsScrollHandler(e)
                };
                _events_engine.default.off((0, _renderer.default)().add(this._$prevTargetParents), scrollEvent, this._proxiedTargetParentsScrollHandler);
                if (subscribe && closeOnScroll) {
                    _events_engine.default.on($parents, scrollEvent, this._proxiedTargetParentsScrollHandler);
                    this._$prevTargetParents = $parents
                }
            },
            _targetParentsScrollHandler: function(e) {
                var closeHandled = false;
                var closeOnScroll = this.option("closeOnTargetScroll");
                if ((0, _type.isFunction)(closeOnScroll)) {
                    closeHandled = closeOnScroll(e)
                }
                if (!closeHandled && !this._showAnimationProcessing) {
                    this.hide()
                }
            },
            _render: function() {
                this.callBase();
                this._appendContentToElement();
                this._renderVisibilityAnimate(this.option("visible"))
            },
            _appendContentToElement: function() {
                if (!this._$content.parent().is(this.$element())) {
                    this._$content.appendTo(this.$element())
                }
            },
            _renderContent: function() {
                var shouldDeferRendering = !this._currentVisible && this.option("deferRendering");
                var isParentHidden = this.option("visible") && this._isParentHidden();
                if (isParentHidden) {
                    this._isHidden = true;
                    return
                }
                if (this._contentAlreadyRendered || shouldDeferRendering) {
                    return
                }
                this._contentAlreadyRendered = true;
                this._appendContentToElement();
                this.callBase()
            },
            _isParentHidden: function() {
                if (!this.option("_checkParentVisibility")) {
                    return false
                }
                if (void 0 !== this._parentHidden) {
                    return this._parentHidden
                }
                var $parent = this.$element().parent();
                if ($parent.is(":visible")) {
                    return false
                }
                var isHidden = false;
                $parent.add($parent.parents()).each(function() {
                    var $element = (0, _renderer.default)(this);
                    if ("none" === $element.css("display")) {
                        isHidden = true;
                        return false
                    }
                });
                return isHidden || !_dom_adapter.default.getBody().contains($parent.get(0))
            },
            _renderContentImpl: function() {
                var _this5 = this;
                var whenContentRendered = new _deferred.Deferred;
                var contentTemplateOption = this.option("contentTemplate");
                var contentTemplate = this._getTemplate(contentTemplateOption);
                var transclude = this._templateManager.anonymousTemplateName === contentTemplateOption;
                contentTemplate && contentTemplate.render({
                    container: (0, _element.getPublicElement)(this.$content()),
                    noModel: true,
                    transclude: transclude,
                    onRendered: function() {
                        whenContentRendered.resolve()
                    }
                });
                this._renderDrag();
                this._renderResize();
                this._renderScrollTerminator();
                whenContentRendered.done(function() {
                    if (_this5.option("visible")) {
                        _this5._moveToContainer()
                    }
                });
                return whenContentRendered.promise()
            },
            _renderDrag: function() {
                var $dragTarget = this._getDragTarget();
                if (!$dragTarget) {
                    return
                }
                var startEventName = (0, _index.addNamespace)(_drag.start, this.NAME);
                var updateEventName = (0, _index.addNamespace)(_drag.move, this.NAME);
                _events_engine.default.off($dragTarget, startEventName);
                _events_engine.default.off($dragTarget, updateEventName);
                if (!this.option("dragEnabled")) {
                    return
                }
                _events_engine.default.on($dragTarget, startEventName, this._dragStartHandler.bind(this));
                _events_engine.default.on($dragTarget, updateEventName, this._dragUpdateHandler.bind(this))
            },
            _renderResize: function() {
                this._resizable = this._createComponent(this._$content, _resizable.default, {
                    handles: this.option("resizeEnabled") ? "all" : "none",
                    onResizeEnd: this._resizeEndHandler.bind(this),
                    onResize: this._actions.onResize.bind(this),
                    onResizeStart: this._actions.onResizeStart.bind(this),
                    minHeight: 100,
                    minWidth: 100,
                    area: this._getDragResizeContainer()
                })
            },
            _resizeEndHandler: function() {
                this._positionChangeHandled = true;
                var width = this._resizable.option("width");
                var height = this._resizable.option("height");
                width && this.option("width", width);
                height && this.option("height", height);
                this._actions.onResizeEnd()
            },
            _renderScrollTerminator: function() {
                var $scrollTerminator = this._wrapper();
                var terminatorEventName = (0, _index.addNamespace)(_drag.move, this.NAME);
                _events_engine.default.off($scrollTerminator, terminatorEventName);
                _events_engine.default.on($scrollTerminator, terminatorEventName, {
                    validate: function() {
                        return true
                    },
                    getDirection: function() {
                        return "both"
                    },
                    _toggleGestureCover: function(toggle) {
                        if (!toggle) {
                            this._toggleGestureCoverImpl(toggle)
                        }
                    },
                    _clearSelection: _common.noop,
                    isNative: true
                }, function(e) {
                    var originalEvent = e.originalEvent.originalEvent;
                    var _ref = originalEvent || {},
                        type = _ref.type;
                    var isWheel = "wheel" === type;
                    var isMouseMove = "mousemove" === type;
                    var isScrollByWheel = isWheel && !(0, _index.isCommandKeyPressed)(e);
                    e._cancelPreventDefault = true;
                    if (originalEvent && false !== e.cancelable && (!isMouseMove && !isWheel || isScrollByWheel)) {
                        e.preventDefault()
                    }
                })
            },
            _getDragTarget: function() {
                return this.$content()
            },
            _dragStartHandler: function(e) {
                e.targetElements = [];
                this._prevOffset = {
                    x: 0,
                    y: 0
                };
                var allowedOffsets = this._allowedOffsets();
                e.maxTopOffset = allowedOffsets.top;
                e.maxBottomOffset = allowedOffsets.bottom;
                e.maxLeftOffset = allowedOffsets.left;
                e.maxRightOffset = allowedOffsets.right
            },
            _getDragResizeContainer: function() {
                var isContainerDefined = (0, _view_port.originalViewPort)().get(0) || this.option("container");
                var $container = !isContainerDefined ? (0, _renderer.default)(window) : this._$container;
                return $container
            },
            _deltaSize: function() {
                var $content = this._$content;
                var $container = this._getDragResizeContainer();
                var contentWidth = $content.outerWidth();
                var contentHeight = $content.outerHeight();
                var containerWidth = $container.outerWidth();
                var containerHeight = $container.outerHeight();
                if (this._isWindow($container)) {
                    var document = _dom_adapter.default.getDocument();
                    var fullPageHeight = Math.max((0, _renderer.default)(document).outerHeight(), containerHeight);
                    var fullPageWidth = Math.max((0, _renderer.default)(document).outerWidth(), containerWidth);
                    containerHeight = fullPageHeight;
                    containerWidth = fullPageWidth
                }
                return {
                    width: containerWidth - contentWidth,
                    height: containerHeight - contentHeight
                }
            },
            _dragUpdateHandler: function(e) {
                var offset = e.offset;
                var prevOffset = this._prevOffset;
                var targetOffset = {
                    top: offset.y - prevOffset.y,
                    left: offset.x - prevOffset.x
                };
                this._changePosition(targetOffset);
                this._prevOffset = offset
            },
            _changePosition: function(offset) {
                var position = (0, _translator.locate)(this._$content);
                (0, _translator.move)(this._$content, {
                    left: position.left + offset.left,
                    top: position.top + offset.top
                });
                this._positionChangeHandled = true
            },
            _allowedOffsets: function() {
                var position = (0, _translator.locate)(this._$content);
                var deltaSize = this._deltaSize();
                var isAllowedDrag = deltaSize.height >= 0 && deltaSize.width >= 0;
                var shaderOffset = this.option("shading") && !this.option("container") && !this._isWindow(this._getContainer()) ? (0, _translator.locate)(this._$wrapper) : {
                    top: 0,
                    left: 0
                };
                var boundaryOffset = this.option("boundaryOffset");
                return {
                    top: isAllowedDrag ? position.top + shaderOffset.top + boundaryOffset.v : 0,
                    bottom: isAllowedDrag ? -position.top - shaderOffset.top + deltaSize.height - boundaryOffset.v : 0,
                    left: isAllowedDrag ? position.left + shaderOffset.left + boundaryOffset.h : 0,
                    right: isAllowedDrag ? -position.left - shaderOffset.left + deltaSize.width - boundaryOffset.h : 0
                }
            },
            _moveFromContainer: function() {
                this._$content.appendTo(this.$element());
                this._detachWrapperToContainer()
            },
            _detachWrapperToContainer: function() {
                this._$wrapper.detach()
            },
            _moveToContainer: function() {
                this._attachWrapperToContainer();
                this._$content.appendTo(this._$wrapper)
            },
            _attachWrapperToContainer: function() {
                var $element = this.$element();
                var containerDefined = void 0 !== this.option("container");
                var renderContainer = containerDefined ? this._$container : _swatch_container.default.getSwatchContainer($element);
                if (renderContainer && renderContainer[0] === $element.parent()[0]) {
                    renderContainer = $element
                }
                this._$wrapper.appendTo(renderContainer)
            },
            _fixHeightAfterSafariAddressBarResizing: function() {
                if (this._isWindow(this._getContainer()) && hasSafariAddressBar) {
                    this._$wrapper.css("minHeight", window.innerHeight)
                }
            },
            _renderGeometry: function(isDimensionChanged) {
                if (this.option("visible") && (0, _window.hasWindow)()) {
                    this._renderGeometryImpl(isDimensionChanged)
                }
            },
            _renderGeometryImpl: function(isDimensionChanged) {
                this._stopAnimation();
                this._normalizePosition();
                this._renderWrapper();
                this._fixHeightAfterSafariAddressBarResizing();
                this._renderDimensions();
                var resultPosition = this._renderPosition();
                this._actions.onPositioned({
                    position: resultPosition
                })
            },
            _fixWrapperPosition: function() {
                this._$wrapper.css("position", this._useFixedPosition() ? "fixed" : "absolute")
            },
            _useFixedPosition: function() {
                return this._shouldFixBodyPosition() || this.option("_fixedPosition")
            },
            _shouldFixBodyPosition: function() {
                var $container = this._getContainer();
                return this._isWindow($container) && (!iOS || void 0 !== this._bodyScrollTop)
            },
            _toggleSafariScrolling: function(scrollingEnabled) {
                if (iOS && this._shouldFixBodyPosition()) {
                    var body = _dom_adapter.default.getBody();
                    if (scrollingEnabled) {
                        (0, _renderer.default)(body).removeClass(PREVENT_SAFARI_SCROLLING_CLASS);
                        window.scrollTo(0, this._bodyScrollTop);
                        this._bodyScrollTop = void 0
                    } else {
                        if (this.option("visible")) {
                            this._bodyScrollTop = window.pageYOffset;
                            (0, _renderer.default)(body).addClass(PREVENT_SAFARI_SCROLLING_CLASS)
                        }
                    }
                }
            },
            _renderWrapper: function() {
                this._fixWrapperPosition();
                this._renderWrapperDimensions();
                this._renderWrapperPosition()
            },
            _renderWrapperDimensions: function() {
                var wrapperWidth;
                var wrapperHeight;
                var $container = this._getContainer();
                if (!$container) {
                    return
                }
                var isWindow = this._isWindow($container);
                wrapperWidth = isWindow ? "" : $container.outerWidth(), wrapperHeight = isWindow ? "" : $container.outerHeight();
                this._$wrapper.css({
                    width: wrapperWidth,
                    height: wrapperHeight
                })
            },
            _isWindow: function($element) {
                return !!$element && (0, _type.isWindow)($element.get(0))
            },
            _renderWrapperPosition: function() {
                var $container = this._getContainer();
                if ($container) {
                    _position.default.setup(this._$wrapper, {
                        my: "top left",
                        at: "top left",
                        of: $container
                    })
                }
            },
            _getContainer: function() {
                var position = this._position;
                var container = this.option("container");
                var positionOf = null;
                if (!container && position) {
                    positionOf = (0, _type.isEvent)(position.of) ? window : position.of || window
                }
                return getElement(container || positionOf)
            },
            _renderDimensions: function() {
                var content = this._$content.get(0);
                this._$content.css({
                    minWidth: this._getOptionValue("minWidth", content),
                    maxWidth: this._getOptionValue("maxWidth", content),
                    minHeight: this._getOptionValue("minHeight", content),
                    maxHeight: this._getOptionValue("maxHeight", content),
                    width: this._getOptionValue("width", content),
                    height: this._getOptionValue("height", content)
                })
            },
            _renderPosition: function() {
                if (this._positionChangeHandled) {
                    var allowedOffsets = this._allowedOffsets();
                    this._changePosition({
                        top: (0, _math.fitIntoRange)(0, -allowedOffsets.top, allowedOffsets.bottom),
                        left: (0, _math.fitIntoRange)(0, -allowedOffsets.left, allowedOffsets.right)
                    })
                } else {
                    this._renderOverlayBoundaryOffset();
                    (0, _translator.resetPosition)(this._$content);
                    var position = this._transformStringPosition(this._position, POSITION_ALIASES);
                    var resultPosition = _position.default.setup(this._$content, position);
                    forceRepaint(this._$content);
                    return resultPosition
                }
            },
            _transformStringPosition: function(position, positionAliases) {
                if ((0, _type.isString)(position)) {
                    position = (0, _extend.extend)({}, positionAliases[position])
                }
                return position
            },
            _renderOverlayBoundaryOffset: function() {
                var boundaryOffset = this.option("boundaryOffset");
                this._$content.css("margin", boundaryOffset.v + "px " + boundaryOffset.h + "px")
            },
            _focusTarget: function() {
                return this._$content
            },
            _attachKeyboardEvents: function() {
                var _this6 = this;
                this._keyboardListenerId = _short.keyboard.on(this._$content, null, function(opts) {
                    return _this6._keyboardHandler(opts)
                })
            },
            _keyboardHandler: function(options) {
                var e = options.originalEvent;
                var $target = (0, _renderer.default)(e.target);
                if ($target.is(this._$content) || !this.option("ignoreChildEvents")) {
                    this.callBase.apply(this, arguments)
                }
            },
            _isVisible: function() {
                return this.option("visible")
            },
            _visibilityChanged: function(visible) {
                if (visible) {
                    if (this.option("visible")) {
                        this._renderVisibilityAnimate(visible)
                    }
                } else {
                    this._renderVisibilityAnimate(visible)
                }
            },
            _dimensionChanged: function() {
                this._renderGeometry(true)
            },
            _clean: function() {
                if (!this._contentAlreadyRendered) {
                    this.$content().empty()
                }
                this._renderVisibility(false);
                this._stopShowTimer();
                this._cleanFocusState()
            },
            _stopShowTimer: function() {
                if (this._asyncShowTimeout) {
                    clearTimeout(this._asyncShowTimeout)
                }
                this._asyncShowTimeout = null
            },
            _dispose: function() {
                _fx.default.stop(this._$content, false);
                clearTimeout(this._deferShowTimer);
                this._toggleViewPortSubscription(false);
                this._toggleSubscriptions(false);
                this._updateZIndexStackPosition(false);
                this._toggleTabTerminator(false);
                this._toggleSafariScrolling(true);
                this._actions = null;
                this.callBase();
                zIndexPool.remove(this._zIndex);
                this._$wrapper.remove();
                this._$content.remove()
            },
            _toggleDisabledState: function(value) {
                this.callBase.apply(this, arguments);
                this._$content.toggleClass(DISABLED_STATE_CLASS, Boolean(value))
            },
            _toggleRTLDirection: function(rtl) {
                this._$content.toggleClass(RTL_DIRECTION_CLASS, rtl)
            },
            _optionChanged: function(args) {
                var _this7 = this;
                var value = args.value;
                if ((0, _array.inArray)(args.name, ACTIONS) > -1) {
                    this._initActions();
                    return
                }
                switch (args.name) {
                    case "dragEnabled":
                        this._renderDrag();
                        this._renderGeometry();
                        break;
                    case "resizeEnabled":
                        this._renderResize();
                        this._renderGeometry();
                        break;
                    case "shading":
                    case "shadingColor":
                        this._toggleShading(this.option("visible"));
                        break;
                    case "width":
                    case "height":
                    case "minWidth":
                    case "maxWidth":
                    case "minHeight":
                    case "maxHeight":
                    case "boundaryOffset":
                        this._renderGeometry();
                        break;
                    case "position":
                        this._positionChangeHandled = false;
                        this._renderGeometry();
                        break;
                    case "visible":
                        this._renderVisibilityAnimate(value).done(function() {
                            if (!_this7._animateDeferred) {
                                return
                            }
                            _this7._animateDeferred.resolveWith(_this7)
                        });
                        break;
                    case "target":
                        this._initTarget(value);
                        this._invalidate();
                        break;
                    case "container":
                        this._initContainer(value);
                        this._invalidate();
                        break;
                    case "innerOverlay":
                        this._initInnerOverlayClass();
                        break;
                    case "deferRendering":
                    case "contentTemplate":
                        this._contentAlreadyRendered = false;
                        this._clean();
                        this._invalidate();
                        break;
                    case "hideTopOverlayHandler":
                        this._toggleHideTopOverlayCallback(false);
                        this._initHideTopOverlayHandler(args.value);
                        this._toggleHideTopOverlayCallback(this.option("visible"));
                        break;
                    case "closeOnTargetScroll":
                        this._toggleParentsScrollSubscription(this.option("visible"));
                        break;
                    case "closeOnOutsideClick":
                    case "animation":
                    case "propagateOutsideClick":
                        break;
                    case "rtlEnabled":
                        this._contentAlreadyRendered = false;
                        this.callBase(args);
                        break;
                    case "_fixedPosition":
                        this._fixWrapperPosition();
                        break;
                    default:
                        this.callBase(args)
                }
            },
            toggle: function(showing) {
                var _this8 = this;
                showing = void 0 === showing ? !this.option("visible") : showing;
                var result = new _deferred.Deferred;
                if (showing === this.option("visible")) {
                    return result.resolveWith(this, [showing]).promise()
                }
                var animateDeferred = new _deferred.Deferred;
                this._animateDeferred = animateDeferred;
                this.option("visible", showing);
                animateDeferred.promise().done(function() {
                    delete _this8._animateDeferred;
                    result.resolveWith(_this8, [_this8.option("visible")])
                });
                return result.promise()
            },
            $content: function() {
                return this._$content
            },
            show: function() {
                return this.toggle(true)
            },
            hide: function() {
                return this.toggle(false)
            },
            content: function() {
                return (0, _element.getPublicElement)(this._$content)
            },
            repaint: function() {
                if (this._contentAlreadyRendered) {
                    this._renderGeometry();
                    (0, _visibility_change.triggerResizeEvent)(this._$content)
                } else {
                    this.callBase()
                }
            }
        });
        Overlay.baseZIndex = function(zIndex) {
            return zIndexPool.base(zIndex)
        };
        (0, _component_registrator.default)("dxOverlay", Overlay);
        var _default = Overlay;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/overlay/z_index.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.clearStack = exports.remove = exports.create = exports.base = void 0;
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var baseZIndex = 1500;
        var zIndexStack = [];
        var base = function(ZIndex) {
            baseZIndex = (0, _common.ensureDefined)(ZIndex, baseZIndex);
            return baseZIndex
        };
        exports.base = base;
        var create = function() {
            var baseIndex = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : baseZIndex;
            var length = zIndexStack.length;
            var index = (length ? zIndexStack[length - 1] : baseIndex) + 1;
            zIndexStack.push(index);
            return index
        };
        exports.create = create;
        var remove = function(zIndex) {
            var position = zIndexStack.indexOf(zIndex);
            if (position >= 0) {
                zIndexStack.splice(position, 1)
            }
        };
        exports.remove = remove;
        var clearStack = function() {
            zIndexStack = []
        };
        exports.clearStack = clearStack
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/selection_filter.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.SelectionFilterCreator = void 0;
        var _common = __webpack_require__( /*! ./common */ 4);
        var _type = __webpack_require__( /*! ./type */ 1);
        var SelectionFilterCreator = function(selectedItemKeys, isSelectAll) {
            this.getLocalFilter = function(keyGetter, equalKeys, equalByReference, keyExpr) {
                equalKeys = void 0 === equalKeys ? _common.equalByValue : equalKeys;
                return functionFilter.bind(this, equalKeys, keyGetter, equalByReference, keyExpr)
            };
            this.getExpr = function(keyExpr) {
                if (!keyExpr) {
                    return
                }
                var filterExpr;
                selectedItemKeys.forEach(function(key, index) {
                    filterExpr = filterExpr || [];
                    var filterExprPart;
                    if (index > 0) {
                        filterExpr.push(isSelectAll ? "and" : "or")
                    }
                    if ((0, _type.isString)(keyExpr)) {
                        filterExprPart = getFilterForPlainKey(keyExpr, key)
                    } else {
                        filterExprPart = getFilterForCompositeKey(keyExpr, key)
                    }
                    filterExpr.push(filterExprPart)
                });
                if (filterExpr && 1 === filterExpr.length) {
                    filterExpr = filterExpr[0]
                }
                return filterExpr
            };
            this.getCombinedFilter = function(keyExpr, dataSourceFilter) {
                var filterExpr = this.getExpr(keyExpr);
                var combinedFilter = filterExpr;
                if (isSelectAll && dataSourceFilter) {
                    if (filterExpr) {
                        combinedFilter = [];
                        combinedFilter.push(filterExpr);
                        combinedFilter.push(dataSourceFilter)
                    } else {
                        combinedFilter = dataSourceFilter
                    }
                }
                return combinedFilter
            };
            var selectedItemKeyHashesMap;
            var getSelectedItemKeyHashesMap = function(selectedItemKeys) {
                if (!selectedItemKeyHashesMap) {
                    selectedItemKeyHashesMap = {};
                    for (var i = 0; i < selectedItemKeys.length; i++) {
                        selectedItemKeyHashesMap[(0, _common.getKeyHash)(selectedItemKeys[i])] = true
                    }
                }
                return selectedItemKeyHashesMap
            };
            var normalizeKeys = function(keys, keyOf, keyExpr) {
                return Array.isArray(keyExpr) ? keys.map(function(key) {
                    return keyOf(key)
                }) : keys
            };

            function functionFilter(equalKeys, keyOf, equalByReference, keyExpr, item) {
                var key = keyOf(item);
                var keyHash;
                var i;
                if (!equalByReference) {
                    keyHash = (0, _common.getKeyHash)(key);
                    if (!(0, _type.isObject)(keyHash)) {
                        var selectedKeyHashesMap = getSelectedItemKeyHashesMap(normalizeKeys(selectedItemKeys, keyOf, keyExpr));
                        if (selectedKeyHashesMap[keyHash]) {
                            return !isSelectAll
                        }
                        return !!isSelectAll
                    }
                }
                for (i = 0; i < selectedItemKeys.length; i++) {
                    if (equalKeys(selectedItemKeys[i], key)) {
                        return !isSelectAll
                    }
                }
                return !!isSelectAll
            }

            function getFilterForPlainKey(keyExpr, keyValue) {
                if (void 0 === keyValue) {
                    return
                }
                return [keyExpr, isSelectAll ? "<>" : "=", keyValue]
            }

            function getFilterForCompositeKey(keyExpr, itemKeyValue) {
                var filterExpr = [];
                for (var i = 0, length = keyExpr.length; i < length; i++) {
                    var currentKeyExpr = keyExpr[i];
                    var currentKeyValue = itemKeyValue && itemKeyValue[currentKeyExpr];
                    var filterExprPart = getFilterForPlainKey(currentKeyExpr, currentKeyValue);
                    if (!filterExprPart) {
                        break
                    }
                    if (i > 0) {
                        filterExpr.push(isSelectAll ? "or" : "and")
                    }
                    filterExpr.push(filterExprPart)
                }
                return filterExpr
            }
        };
        exports.SelectionFilterCreator = SelectionFilterCreator
    },
    /*!******************************************************!*\
      !*** ./artifacts/transpiled-npm/events/transform.js ***!
      \******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.rotateend = exports.rotate = exports.rotatestart = exports.pinchend = exports.pinch = exports.pinchstart = exports.zoomend = exports.zoom = exports.zoomstart = exports.translateend = exports.translate = exports.translatestart = exports.transformend = exports.transform = exports.transformstart = void 0;
        var _math = __webpack_require__( /*! ../core/utils/math */ 29);
        var iteratorUtils = _interopRequireWildcard(__webpack_require__( /*! ../core/utils/iterator */ 3));
        var _index = __webpack_require__( /*! ./utils/index */ 8);
        var _emitter = _interopRequireDefault(__webpack_require__( /*! ./core/emitter */ 132));
        var _emitter_registrator = _interopRequireDefault(__webpack_require__( /*! ./core/emitter_registrator */ 103));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }
        var DX_PREFIX = "dx";
        var TRANSFORM = "transform";
        var TRANSLATE = "translate";
        var PINCH = "pinch";
        var ROTATE = "rotate";
        var START_POSTFIX = "start";
        var UPDATE_POSTFIX = "";
        var END_POSTFIX = "end";
        var eventAliases = [];
        var addAlias = function(eventName, eventArgs) {
            eventAliases.push({
                name: eventName,
                args: eventArgs
            })
        };
        addAlias(TRANSFORM, {
            scale: true,
            deltaScale: true,
            rotation: true,
            deltaRotation: true,
            translation: true,
            deltaTranslation: true
        });
        addAlias(TRANSLATE, {
            translation: true,
            deltaTranslation: true
        });
        addAlias(PINCH, {
            scale: true,
            deltaScale: true
        });
        addAlias(ROTATE, {
            rotation: true,
            deltaRotation: true
        });
        var getVector = function(first, second) {
            return {
                x: second.pageX - first.pageX,
                y: -second.pageY + first.pageY,
                centerX: .5 * (second.pageX + first.pageX),
                centerY: .5 * (second.pageY + first.pageY)
            }
        };
        var getEventVector = function(e) {
            var pointers = e.pointers;
            return getVector(pointers[0], pointers[1])
        };
        var getDistance = function(vector) {
            return Math.sqrt(vector.x * vector.x + vector.y * vector.y)
        };
        var getScale = function(firstVector, secondVector) {
            return getDistance(firstVector) / getDistance(secondVector)
        };
        var getRotation = function(firstVector, secondVector) {
            var scalarProduct = firstVector.x * secondVector.x + firstVector.y * secondVector.y;
            var distanceProduct = getDistance(firstVector) * getDistance(secondVector);
            if (0 === distanceProduct) {
                return 0
            }
            var sign = (0, _math.sign)(firstVector.x * secondVector.y - secondVector.x * firstVector.y);
            var angle = Math.acos((0, _math.fitIntoRange)(scalarProduct / distanceProduct, -1, 1));
            return sign * angle
        };
        var getTranslation = function(firstVector, secondVector) {
            return {
                x: firstVector.centerX - secondVector.centerX,
                y: firstVector.centerY - secondVector.centerY
            }
        };
        var TransformEmitter = _emitter.default.inherit({
            validatePointers: function(e) {
                return (0, _index.hasTouches)(e) > 1
            },
            start: function(e) {
                this._accept(e);
                var startVector = getEventVector(e);
                this._startVector = startVector;
                this._prevVector = startVector;
                this._fireEventAliases(START_POSTFIX, e)
            },
            move: function(e) {
                var currentVector = getEventVector(e);
                var eventArgs = this._getEventArgs(currentVector);
                this._fireEventAliases(UPDATE_POSTFIX, e, eventArgs);
                this._prevVector = currentVector
            },
            end: function(e) {
                var eventArgs = this._getEventArgs(this._prevVector);
                this._fireEventAliases(END_POSTFIX, e, eventArgs)
            },
            _getEventArgs: function(vector) {
                return {
                    scale: getScale(vector, this._startVector),
                    deltaScale: getScale(vector, this._prevVector),
                    rotation: getRotation(vector, this._startVector),
                    deltaRotation: getRotation(vector, this._prevVector),
                    translation: getTranslation(vector, this._startVector),
                    deltaTranslation: getTranslation(vector, this._prevVector)
                }
            },
            _fireEventAliases: function(eventPostfix, originalEvent, eventArgs) {
                eventArgs = eventArgs || {};
                iteratorUtils.each(eventAliases, function(_, eventAlias) {
                    var args = {};
                    iteratorUtils.each(eventAlias.args, function(name) {
                        if (name in eventArgs) {
                            args[name] = eventArgs[name]
                        }
                    });
                    this._fireEvent(DX_PREFIX + eventAlias.name + eventPostfix, originalEvent, args)
                }.bind(this))
            }
        });
        var eventNames = eventAliases.reduce(function(result, eventAlias) {
            [START_POSTFIX, UPDATE_POSTFIX, END_POSTFIX].forEach(function(eventPostfix) {
                result.push(DX_PREFIX + eventAlias.name + eventPostfix)
            });
            return result
        }, []);
        (0, _emitter_registrator.default)({
            emitter: TransformEmitter,
            events: eventNames
        });
        var exportNames = {};
        iteratorUtils.each(eventNames, function(_, eventName) {
            exportNames[eventName.substring(DX_PREFIX.length)] = eventName
        });
        var transformstart = exportNames.transformstart,
            transform = exportNames.transform,
            transformend = exportNames.transformend,
            translatestart = exportNames.translatestart,
            translate = exportNames.translate,
            translateend = exportNames.translateend,
            zoomstart = exportNames.zoomstart,
            zoom = exportNames.zoom,
            zoomend = exportNames.zoomend,
            pinchstart = exportNames.pinchstart,
            pinch = exportNames.pinch,
            pinchend = exportNames.pinchend,
            rotatestart = exportNames.rotatestart,
            rotate = exportNames.rotate,
            rotateend = exportNames.rotateend;
        exports.rotateend = rotateend;
        exports.rotate = rotate;
        exports.rotatestart = rotatestart;
        exports.pinchend = pinchend;
        exports.pinch = pinch;
        exports.pinchstart = pinchstart;
        exports.zoomend = zoomend;
        exports.zoom = zoom;
        exports.zoomstart = zoomstart;
        exports.translateend = translateend;
        exports.translate = translate;
        exports.translatestart = translatestart;
        exports.transformend = transformend;
        exports.transform = transform;
        exports.transformstart = transformstart
    },
    /*!******************************************************!*\
      !*** ./artifacts/transpiled-npm/data/data_source.js ***!
      \******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _data_source = __webpack_require__( /*! ./data_source/data_source */ 68);
        var _default = _data_source.DataSource;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************************!*\
      !*** ./artifacts/transpiled-npm/file_management/file_system_item.js ***!
      \**********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _utils = __webpack_require__( /*! ./utils */ 265);

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }
        var FileSystemItem = function() {
            function FileSystemItem() {
                var ctor = (0, _type.isString)(arguments[0]) ? this._publicCtor : this._internalCtor;
                ctor.apply(this, arguments)
            }
            var _proto = FileSystemItem.prototype;
            _proto._internalCtor = function(pathInfo, name, isDirectory) {
                this.name = name || "";
                this.pathInfo = pathInfo && _toConsumableArray(pathInfo) || [];
                this.parentPath = this._getPathByPathInfo(this.pathInfo);
                this.relativeName = (0, _utils.pathCombine)(this.parentPath, name);
                this.key = this._getPathByPathInfo(this.getFullPathInfo(), true);
                this.path = (0, _utils.pathCombine)(this.parentPath, name);
                this.pathKeys = this.pathInfo.map(function(_ref) {
                    var key = _ref.key;
                    return key
                });
                if (!this.isRoot()) {
                    this.pathKeys.push(this.key)
                }
                this._initialize(isDirectory)
            };
            _proto._publicCtor = function(path, isDirectory, pathKeys) {
                this.path = path || "";
                this.pathKeys = pathKeys || [];
                var pathInfo = [];
                var parts = (0, _utils.getPathParts)(path, true);
                for (var i = 0; i < parts.length - 1; i++) {
                    var part = parts[i];
                    var pathInfoPart = {
                        key: this.pathKeys[i] || part,
                        name: (0, _utils.getName)(part)
                    };
                    pathInfo.push(pathInfoPart)
                }
                this.pathInfo = pathInfo;
                this.relativeName = path;
                this.name = (0, _utils.getName)(path);
                this.key = this.pathKeys.length ? this.pathKeys[this.pathKeys.length - 1] : path;
                this.parentPath = parts.length > 1 ? parts[parts.length - 2] : "";
                this._initialize(isDirectory)
            };
            _proto._initialize = function(isDirectory) {
                this.isDirectory = !!isDirectory;
                this.size = 0;
                this.dateModified = new Date;
                this.thumbnail = "";
                this.tooltipText = ""
            };
            _proto.getFullPathInfo = function() {
                var pathInfo = _toConsumableArray(this.pathInfo);
                if (!this.isRoot()) {
                    pathInfo.push({
                        key: this.key,
                        name: this.name
                    })
                }
                return pathInfo
            };
            _proto.isRoot = function() {
                return "" === this.path
            };
            _proto.getFileExtension = function() {
                return this.isDirectory ? "" : (0, _utils.getFileExtension)(this.name)
            };
            _proto.equals = function(item) {
                return item && this.key === item.key
            };
            _proto.createClone = function() {
                var result = new FileSystemItem(this.pathInfo, this.name, this.isDirectory);
                result.key = this.key;
                result.size = this.size;
                result.dateModified = this.dateModified;
                result.thumbnail = this.thumbnail;
                result.tooltipText = this.tooltipText;
                result.hasSubDirectories = this.hasSubDirectories;
                result.dataItem = this.dataItem;
                return result
            };
            _proto._getPathByPathInfo = function(pathInfo, escape) {
                return pathInfo.map(function(info) {
                    return escape ? (0, _utils.getEscapedFileName)(info.name) : info.name
                }).join(_utils.PATH_SEPARATOR)
            };
            return FileSystemItem
        }();
        var _default = FileSystemItem;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/shared/grouped_data_converter_mixin.js ***!
      \****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var isCorrectStructure = function(data) {
            return Array.isArray(data) && data.every(function(item) {
                var hasTwoFields = 2 === Object.keys(item).length;
                var hasCorrectFields = "key" in item && "items" in item;
                return hasTwoFields && hasCorrectFields && Array.isArray(item.items)
            })
        };
        var _default = {
            _getSpecificDataSourceOption: function() {
                var groupKey = "key";
                var dataSource = this.option("dataSource");
                var hasSimpleItems = false;
                var data = {};
                if (this._getGroupedOption() && isCorrectStructure(dataSource)) {
                    data = dataSource.reduce(function(accumulator, item) {
                        var items = item.items.map(function(innerItem) {
                            if (!(0, _type.isObject)(innerItem)) {
                                innerItem = {
                                    text: innerItem
                                };
                                hasSimpleItems = true
                            }
                            if (!(groupKey in innerItem)) {
                                innerItem[groupKey] = item.key
                            }
                            return innerItem
                        });
                        return accumulator.concat(items)
                    }, []);
                    dataSource = {
                        store: {
                            type: "array",
                            data: data
                        },
                        group: {
                            selector: "key",
                            keepInitialKeyOrder: true
                        }
                    };
                    if (hasSimpleItems) {
                        dataSource.searchExpr = "text"
                    }
                }
                return dataSource
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/core/options/index.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.Options = void 0;
        var _type = __webpack_require__( /*! ../utils/type */ 1);
        var _common = __webpack_require__( /*! ../utils/common */ 4);
        var _option_manager = __webpack_require__( /*! ./option_manager */ 517);
        var _object = __webpack_require__( /*! ../utils/object */ 51);
        var _utils = __webpack_require__( /*! ./utils */ 198);
        var _extend = __webpack_require__( /*! ../utils/extend */ 0);

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }
        var Options = function() {
            function Options(options, defaultOptions, optionsByReference, deprecatedOptions) {
                var _this = this;
                this._deprecatedCallback;
                this._startChangeCallback;
                this._endChangeCallback;
                this._default = defaultOptions;
                this._deprecated = deprecatedOptions;
                this._deprecatedNames = [];
                this._initDeprecatedNames();
                this._optionManager = new _option_manager.OptionManager(options, optionsByReference);
                this._optionManager.onRelevantNamesPrepared(function(options, name, value, silent) {
                    return _this._setRelevantNames(options, name, value, silent)
                });
                this._cachedOptions = {};
                this._rules = []
            }
            var _proto = Options.prototype;
            _proto._initDeprecatedNames = function() {
                for (var optionName in this._deprecated) {
                    this._deprecatedNames.push(optionName)
                }
            };
            _proto._getByRules = function(rules) {
                rules = Array.isArray(rules) ? this._rules.concat(rules) : this._rules;
                return (0, _utils.convertRulesToOptions)(rules)
            };
            _proto._notifyDeprecated = function(option) {
                var info = this._deprecated[option];
                if (info) {
                    this._deprecatedCallback(option, info)
                }
            };
            _proto._setRelevantNames = function(options, name, value, silent) {
                if (name) {
                    var normalizedName = this._normalizeName(name, silent);
                    if (normalizedName && normalizedName !== name) {
                        this._setField(options, normalizedName, value);
                        this._clearField(options, name)
                    }
                }
            };
            _proto._setField = function(options, fullName, value) {
                var fieldName = "";
                var fieldObject = null;
                do {
                    fieldName = fieldName ? ".".concat(fieldName) : "";
                    fieldName = (0, _utils.getFieldName)(fullName) + fieldName;
                    fullName = (0, _utils.getParentName)(fullName);
                    fieldObject = fullName ? this._optionManager.get(options, fullName, false) : options
                } while (!fieldObject);
                fieldObject[fieldName] = value
            };
            _proto._clearField = function(options, name) {
                delete options[name];
                var previousFieldName = (0, _utils.getParentName)(name);
                var fieldObject = previousFieldName ? this._optionManager.get(options, previousFieldName, false) : options;
                if (fieldObject) {
                    delete fieldObject[(0, _utils.getFieldName)(name)]
                }
            };
            _proto._normalizeName = function(name, silent) {
                if (this._deprecatedNames.length && name) {
                    for (var i = 0; i < this._deprecatedNames.length; i++) {
                        if (this._deprecatedNames[i] === name) {
                            var deprecate = this._deprecated[name];
                            if (deprecate) {
                                !silent && this._notifyDeprecated(name);
                                return deprecate.alias || name
                            }
                        }
                    }
                }
                return name
            };
            _proto.addRules = function(rules) {
                this._rules = rules.concat(this._rules)
            };
            _proto.applyRules = function(rules) {
                var options = this._getByRules(rules);
                this.silent(options)
            };
            _proto.dispose = function() {
                this._deprecatedCallback = _common.noop;
                this._startChangeCallback = _common.noop;
                this._endChangeCallback = _common.noop;
                this._optionManager.dispose()
            };
            _proto.onChanging = function(callBack) {
                this._optionManager.onChanging(callBack)
            };
            _proto.onChanged = function(callBack) {
                this._optionManager.onChanged(callBack)
            };
            _proto.onDeprecated = function(callBack) {
                this._deprecatedCallback = callBack
            };
            _proto.onStartChange = function(callBack) {
                this._startChangeCallback = callBack
            };
            _proto.onEndChange = function(callBack) {
                this._endChangeCallback = callBack
            };
            _proto.isInitial = function(name) {
                var value = this.silent(name);
                var initialValue = this.initial(name);
                var areFunctions = (0, _type.isFunction)(value) && (0, _type.isFunction)(initialValue);
                return areFunctions ? value.toString() === initialValue.toString() : (0, _common.equalByValue)(value, initialValue)
            };
            _proto.initial = function(name) {
                return (0, _utils.getNestedOptionValue)(this._initial, name)
            };
            _proto.option = function(options, value) {
                var isGetter = arguments.length < 2 && "object" !== (0, _type.type)(options);
                if (isGetter) {
                    return this._optionManager.get(void 0, this._normalizeName(options))
                } else {
                    this._startChangeCallback();
                    try {
                        this._optionManager.set(options, value)
                    } finally {
                        this._endChangeCallback()
                    }
                }
            };
            _proto.silent = function(options, value) {
                var isGetter = arguments.length < 2 && "object" !== (0, _type.type)(options);
                if (isGetter) {
                    return this._optionManager.get(void 0, options, void 0, true)
                } else {
                    this._optionManager.set(options, value, void 0, true)
                }
            };
            _proto.reset = function(name) {
                var _this2 = this;
                if (name) {
                    var fullPath = name.replace(/\[([^\]])\]/g, ".$1").split(".");
                    var value = fullPath.reduce(function(value, field) {
                        return value ? value[field] : _this2.initial(field)
                    }, null);
                    var defaultValue = (0, _type.isObject)(value) ? (0, _object.clone)(value) : value;
                    this._optionManager.set(name, defaultValue, false)
                }
            };
            _proto.getAliasesByName = function(name) {
                var _this3 = this;
                return Object.keys(this._deprecated).filter(function(aliasName) {
                    return name === _this3._deprecated[aliasName].alias
                })
            };
            _proto.isDeprecated = function(name) {
                return Object.prototype.hasOwnProperty.call(this._deprecated, name)
            };
            _proto.cache = function(name, options) {
                var isGetter = arguments.length < 2;
                if (isGetter) {
                    return this._cachedOptions[name]
                } else {
                    this._cachedOptions[name] = (0, _extend.extend)(this._cachedOptions[name], options)
                }
            };
            _createClass(Options, [{
                key: "_initial",
                get: function() {
                    if (!this._initialOptions) {
                        var rulesOptions = this._getByRules(this.silent("defaultOptionsRules"));
                        this._initialOptions = this._default;
                        this._optionManager._setByReference(this._initialOptions, rulesOptions)
                    }
                    return this._initialOptions
                },
                set: function(value) {
                    this._initialOptions = value
                }
            }]);
            return Options
        }();
        exports.Options = Options
    },
    /*!****************************************************************!*\
      !*** ./artifacts/transpiled-npm/bundles/modules/parts/data.js ***!
      \****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var DevExpress = __webpack_require__( /*! ./core */ 235);
        var data = DevExpress.data = __webpack_require__( /*! ../../../bundles/modules/data */ 262);
        data.odata = __webpack_require__( /*! ../../../bundles/modules/data.odata */ 571);
        module.exports = data
    },
    /*!****************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/toolbar/ui.toolbar.base.js ***!
      \****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _themes = __webpack_require__( /*! ../themes */ 34);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _position = __webpack_require__( /*! ../../core/utils/position */ 22);
        var _uiCollection_widget = _interopRequireDefault(__webpack_require__( /*! ../collection/ui.collection_widget.async */ 578));
        var _promise = _interopRequireDefault(__webpack_require__( /*! ../../core/polyfills/promise */ 73));
        var _bindable_template = __webpack_require__( /*! ../../core/templates/bindable_template */ 65);
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../../core/errors */ 25));
        var _fx = _interopRequireDefault(__webpack_require__( /*! ../../animation/fx */ 42));
        var _constants = __webpack_require__( /*! ./constants */ 338);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var TOOLBAR_BEFORE_CLASS = "dx-toolbar-before";
        var TOOLBAR_CENTER_CLASS = "dx-toolbar-center";
        var TOOLBAR_AFTER_CLASS = "dx-toolbar-after";
        var TOOLBAR_MINI_CLASS = "dx-toolbar-mini";
        var TOOLBAR_ITEM_CLASS = "dx-toolbar-item";
        var TOOLBAR_LABEL_CLASS = "dx-toolbar-label";
        var TOOLBAR_BUTTON_CLASS = "dx-toolbar-button";
        var TOOLBAR_ITEMS_CONTAINER_CLASS = "dx-toolbar-items-container";
        var TOOLBAR_GROUP_CLASS = "dx-toolbar-group";
        var TOOLBAR_COMPACT_CLASS = "dx-toolbar-compact";
        var TOOLBAR_LABEL_SELECTOR = "." + TOOLBAR_LABEL_CLASS;
        var TOOLBAR_MULTILINE_CLASS = "dx-toolbar-multiline";
        var TEXT_BUTTON_MODE = "text";
        var DEFAULT_BUTTON_TYPE = "default";
        var TOOLBAR_ITEM_DATA_KEY = "dxToolbarItemDataKey";
        var ToolbarBase = _uiCollection_widget.default.inherit({
            compactMode: false,
            ctor: function(element, options) {
                this._userOptions = options || {};
                this.callBase(element, options);
                if ("height" in this._userOptions) {
                    _errors.default.log("W0001", this.NAME, "height", "20.1", "Functionality associated with this option is not intended for the Toolbar widget.")
                }
            },
            _getSynchronizableOptionsForCreateComponent: function() {
                return this.callBase().filter(function(item) {
                    return "disabled" !== item
                })
            },
            _initTemplates: function() {
                this.callBase();
                var template = new _bindable_template.BindableTemplate(function($container, data, rawModel) {
                    if ((0, _type.isPlainObject)(data)) {
                        if (data.text) {
                            $container.text(data.text).wrapInner("<div>")
                        }
                        if (data.html) {
                            $container.html(data.html)
                        }
                        if ("dxButton" === data.widget) {
                            if (this.option("useFlatButtons")) {
                                data.options = data.options || {};
                                data.options.stylingMode = data.options.stylingMode || TEXT_BUTTON_MODE
                            }
                            if (this.option("useDefaultButtons")) {
                                data.options = data.options || {};
                                data.options.type = data.options.type || DEFAULT_BUTTON_TYPE
                            }
                        }
                    } else {
                        $container.text(String(data))
                    }
                    this._getTemplate("dx-polymorph-widget").render({
                        container: $container,
                        model: rawModel,
                        parent: this
                    })
                }.bind(this), ["text", "html", "widget", "options"], this.option("integrationOptions.watchMethod"));
                this._templateManager.addDefaultTemplates({
                    item: template,
                    menuItem: template
                })
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    renderAs: "topToolbar",
                    grouped: false,
                    useFlatButtons: false,
                    useDefaultButtons: false,
                    multiline: false
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: function() {
                        return (0, _themes.isMaterial)()
                    },
                    options: {
                        useFlatButtons: true
                    }
                }])
            },
            _itemContainer: function() {
                return this._$toolbarItemsContainer.find(["." + TOOLBAR_BEFORE_CLASS, "." + TOOLBAR_CENTER_CLASS, "." + TOOLBAR_AFTER_CLASS].join(","))
            },
            _itemClass: function() {
                return TOOLBAR_ITEM_CLASS
            },
            _itemDataKey: function() {
                return TOOLBAR_ITEM_DATA_KEY
            },
            _buttonClass: function() {
                return TOOLBAR_BUTTON_CLASS
            },
            _dimensionChanged: function() {
                this._arrangeItems();
                this._applyCompactMode()
            },
            _initMarkup: function() {
                this._renderToolbar();
                this._renderSections();
                this.callBase();
                this.setAria("role", "toolbar")
            },
            _waitParentAnimationFinished: function() {
                var _this = this;
                var $element = this.$element();
                var timeout = 15;
                return new _promise.default(function(resolve) {
                    var check = function() {
                        var readyToResolve = true;
                        $element.parents().each(function(_, parent) {
                            if (_fx.default.isAnimating((0, _renderer.default)(parent))) {
                                readyToResolve = false;
                                return false
                            }
                        });
                        if (readyToResolve) {
                            resolve()
                        }
                        return readyToResolve
                    };
                    var runCheck = function runCheck() {
                        clearTimeout(_this._waitParentAnimationTimeout);
                        _this._waitParentAnimationTimeout = setTimeout(function() {
                            return check() || runCheck()
                        }, timeout)
                    };
                    runCheck()
                })
            },
            _render: function() {
                this.callBase();
                this._renderItemsAsync();
                if ((0, _themes.isMaterial)()) {
                    _promise.default.all([this._waitParentAnimationFinished(), this._checkWebFontForLabelsLoaded()]).then(this._dimensionChanged.bind(this))
                }
            },
            _postProcessRenderItems: function() {
                this._arrangeItems()
            },
            _renderToolbar: function() {
                this.$element().addClass(_constants.TOOLBAR_CLASS).toggleClass(TOOLBAR_MULTILINE_CLASS, this.option("multiline"));
                this._$toolbarItemsContainer = (0, _renderer.default)("<div>").addClass(TOOLBAR_ITEMS_CONTAINER_CLASS).appendTo(this.$element())
            },
            _renderSections: function() {
                var $container = this._$toolbarItemsContainer;
                var that = this;
                (0, _iterator.each)(["before", "center", "after"], function() {
                    var sectionClass = "dx-toolbar-" + this;
                    var $section = $container.find("." + sectionClass);
                    if (!$section.length) {
                        that["_$" + this + "Section"] = $section = (0, _renderer.default)("<div>").addClass(sectionClass).appendTo($container)
                    }
                })
            },
            _checkWebFontForLabelsLoaded: function() {
                var $labels = this.$element().find(TOOLBAR_LABEL_SELECTOR);
                var promises = [];
                $labels.each(function(_, label) {
                    var text = (0, _renderer.default)(label).text();
                    var fontWeight = (0, _renderer.default)(label).css("fontWeight");
                    promises.push((0, _themes.waitWebFont)(text, fontWeight))
                });
                return _promise.default.all(promises)
            },
            _arrangeItems: function(elementWidth) {
                elementWidth = elementWidth || this.$element().width();
                this._$centerSection.css({
                    margin: "0 auto",
                    "float": "none"
                });
                var beforeRect = (0, _position.getBoundingRect)(this._$beforeSection.get(0));
                var afterRect = (0, _position.getBoundingRect)(this._$afterSection.get(0));
                this._alignCenterSection(beforeRect, afterRect, elementWidth);
                var $label = this._$toolbarItemsContainer.find(TOOLBAR_LABEL_SELECTOR).eq(0);
                var $section = $label.parent();
                if (!$label.length) {
                    return
                }
                var labelOffset = beforeRect.width ? beforeRect.width : $label.position().left;
                var widthBeforeSection = $section.hasClass(TOOLBAR_BEFORE_CLASS) ? 0 : labelOffset;
                var widthAfterSection = $section.hasClass(TOOLBAR_AFTER_CLASS) ? 0 : afterRect.width;
                var elemsAtSectionWidth = 0;
                $section.children().not(TOOLBAR_LABEL_SELECTOR).each(function() {
                    elemsAtSectionWidth += (0, _renderer.default)(this).outerWidth()
                });
                var freeSpace = elementWidth - elemsAtSectionWidth;
                var sectionMaxWidth = Math.max(freeSpace - widthBeforeSection - widthAfterSection, 0);
                if ($section.hasClass(TOOLBAR_BEFORE_CLASS)) {
                    this._alignSection(this._$beforeSection, sectionMaxWidth)
                } else {
                    var labelPaddings = $label.outerWidth() - $label.width();
                    $label.css("maxWidth", sectionMaxWidth - labelPaddings)
                }
            },
            _alignCenterSection: function(beforeRect, afterRect, elementWidth) {
                this._alignSection(this._$centerSection, elementWidth - beforeRect.width - afterRect.width);
                var isRTL = this.option("rtlEnabled");
                var leftRect = isRTL ? afterRect : beforeRect;
                var rightRect = isRTL ? beforeRect : afterRect;
                var centerRect = (0, _position.getBoundingRect)(this._$centerSection.get(0));
                if (leftRect.right > centerRect.left || centerRect.right > rightRect.left) {
                    this._$centerSection.css({
                        marginLeft: leftRect.width,
                        marginRight: rightRect.width,
                        "float": leftRect.width > rightRect.width ? "none" : "right"
                    })
                }
            },
            _alignSection: function($section, maxWidth) {
                var $labels = $section.find(TOOLBAR_LABEL_SELECTOR);
                var labels = $labels.toArray();
                maxWidth -= this._getCurrentLabelsPaddings(labels);
                var currentWidth = this._getCurrentLabelsWidth(labels);
                var difference = Math.abs(currentWidth - maxWidth);
                if (maxWidth < currentWidth) {
                    labels = labels.reverse();
                    this._alignSectionLabels(labels, difference, false)
                } else {
                    this._alignSectionLabels(labels, difference, true)
                }
            },
            _alignSectionLabels: function(labels, difference, expanding) {
                var getRealLabelWidth = function(label) {
                    return (0, _position.getBoundingRect)(label).width
                };
                for (var i = 0; i < labels.length; i++) {
                    var $label = (0, _renderer.default)(labels[i]);
                    var currentLabelWidth = Math.ceil(getRealLabelWidth(labels[i]));
                    var labelMaxWidth = void 0;
                    if (expanding) {
                        $label.css("maxWidth", "inherit")
                    }
                    var possibleLabelWidth = Math.ceil(expanding ? getRealLabelWidth(labels[i]) : currentLabelWidth);
                    if (possibleLabelWidth < difference) {
                        labelMaxWidth = expanding ? possibleLabelWidth : 0;
                        difference -= possibleLabelWidth
                    } else {
                        labelMaxWidth = expanding ? currentLabelWidth + difference : currentLabelWidth - difference;
                        $label.css("maxWidth", labelMaxWidth);
                        break
                    }
                    $label.css("maxWidth", labelMaxWidth)
                }
            },
            _applyCompactMode: function() {
                var $element = this.$element();
                $element.removeClass(TOOLBAR_COMPACT_CLASS);
                if (this.option("compactMode") && this._getSummaryItemsWidth(this.itemElements(), true) > $element.width()) {
                    $element.addClass(TOOLBAR_COMPACT_CLASS)
                }
            },
            _getCurrentLabelsWidth: function(labels) {
                var width = 0;
                labels.forEach(function(label, index) {
                    width += (0, _renderer.default)(label).outerWidth()
                });
                return width
            },
            _getCurrentLabelsPaddings: function(labels) {
                var padding = 0;
                labels.forEach(function(label, index) {
                    padding += (0, _renderer.default)(label).outerWidth() - (0, _renderer.default)(label).width()
                });
                return padding
            },
            _renderItem: function(index, item, itemContainer, $after) {
                var location = item.location || "center";
                var container = itemContainer || this["_$" + location + "Section"];
                var itemHasText = !!(item.text || item.html);
                var itemElement = this.callBase(index, item, container, $after);
                itemElement.toggleClass(this._buttonClass(), !itemHasText).toggleClass(TOOLBAR_LABEL_CLASS, itemHasText).addClass(item.cssClass);
                return itemElement
            },
            _renderGroupedItems: function() {
                var that = this;
                (0, _iterator.each)(this.option("items"), function(groupIndex, group) {
                    var groupItems = group.items;
                    var $container = (0, _renderer.default)("<div>").addClass(TOOLBAR_GROUP_CLASS);
                    var location = group.location || "center";
                    if (!groupItems || !groupItems.length) {
                        return
                    }(0, _iterator.each)(groupItems, function(itemIndex, item) {
                        that._renderItem(itemIndex, item, $container, null)
                    });
                    that._$toolbarItemsContainer.find(".dx-toolbar-" + location).append($container)
                })
            },
            _renderItems: function(items) {
                var grouped = this.option("grouped") && items.length && items[0].items;
                grouped ? this._renderGroupedItems() : this.callBase(items)
            },
            _getToolbarItems: function() {
                return this.option("items") || []
            },
            _renderContentImpl: function() {
                var items = this._getToolbarItems();
                this.$element().toggleClass(TOOLBAR_MINI_CLASS, 0 === items.length);
                if (this._renderedItemsCount) {
                    this._renderItems(items.slice(this._renderedItemsCount))
                } else {
                    this._renderItems(items)
                }
                this._applyCompactMode()
            },
            _renderEmptyMessage: _common.noop,
            _clean: function() {
                this._$toolbarItemsContainer.children().empty();
                this.$element().empty()
            },
            _visibilityChanged: function(visible) {
                if (visible) {
                    this._arrangeItems()
                }
            },
            _isVisible: function() {
                return this.$element().width() > 0 && this.$element().height() > 0
            },
            _getIndexByItem: function(item) {
                return (0, _array.inArray)(item, this._getToolbarItems())
            },
            _itemOptionChanged: function(item, property, value) {
                this.callBase.apply(this, [item, property, value]);
                this._arrangeItems()
            },
            _optionChanged: function(args) {
                var name = args.name;
                switch (name) {
                    case "width":
                        this.callBase.apply(this, arguments);
                        this._dimensionChanged();
                        break;
                    case "multiline":
                        this.$element().toggleClass(TOOLBAR_MULTILINE_CLASS, args.value);
                        break;
                    case "renderAs":
                    case "useFlatButtons":
                    case "useDefaultButtons":
                        this._invalidate();
                        break;
                    case "compactMode":
                        this._applyCompactMode();
                        break;
                    case "grouped":
                        break;
                    default:
                        this.callBase.apply(this, arguments)
                }
            },
            _dispose: function() {
                this.callBase();
                clearTimeout(this._waitParentAnimationTimeout)
            }
        });
        (0, _component_registrator.default)("dxToolbarBase", ToolbarBase);
        var _default = ToolbarBase;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/toolbar/constants.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.TOOLBAR_CLASS = void 0;
        var TOOLBAR_CLASS = "dx-toolbar";
        exports.TOOLBAR_CLASS = TOOLBAR_CLASS
    },
    /*!***********************************************!*\
      !*** ./artifacts/transpiled-npm/ui/notify.js ***!
      \***********************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _action = _interopRequireDefault(__webpack_require__( /*! ../core/action */ 111));
        var _view_port = __webpack_require__( /*! ../core/utils/view_port */ 80);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _toast = _interopRequireDefault(__webpack_require__( /*! ./toast */ 340));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var $notify = null;
        var notify = function(message, type, displayTime) {
            var options = (0, _type.isPlainObject)(message) ? message : {
                message: message
            };
            var userHiddenAction = options.onHidden;
            (0, _extend.extend)(options, {
                type: type,
                displayTime: displayTime,
                onHidden: function(args) {
                    (0, _renderer.default)(args.element).remove();
                    new _action.default(userHiddenAction, {
                        context: args.model
                    }).execute(arguments)
                }
            });
            $notify = (0, _renderer.default)("<div>").appendTo((0, _view_port.value)());
            new _toast.default($notify, options).show()
        };
        var _default = notify;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************!*\
      !*** ./artifacts/transpiled-npm/ui/toast.js ***!
      \**********************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../core/dom_adapter */ 11));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _ready_callbacks = _interopRequireDefault(__webpack_require__( /*! ../core/utils/ready_callbacks */ 49));
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _array = __webpack_require__( /*! ../core/utils/array */ 12);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../events/pointer */ 24));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _overlay = _interopRequireDefault(__webpack_require__( /*! ./overlay */ 64));
        var _themes = __webpack_require__( /*! ./themes */ 34);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var ready = _ready_callbacks.default.add;
        var TOAST_CLASS = "dx-toast";
        var TOAST_CLASS_PREFIX = TOAST_CLASS + "-";
        var TOAST_WRAPPER_CLASS = TOAST_CLASS_PREFIX + "wrapper";
        var TOAST_CONTENT_CLASS = TOAST_CLASS_PREFIX + "content";
        var TOAST_MESSAGE_CLASS = TOAST_CLASS_PREFIX + "message";
        var TOAST_ICON_CLASS = TOAST_CLASS_PREFIX + "icon";
        var WIDGET_NAME = "dxToast";
        var toastTypes = ["info", "warning", "error", "success"];
        var TOAST_STACK = [];
        var FIRST_Z_INDEX_OFFSET = 8e3;
        var visibleToastInstance = null;
        var POSITION_ALIASES = {
            top: {
                my: "top",
                at: "top",
                of: null,
                offset: "0 0"
            },
            bottom: {
                my: "bottom",
                at: "bottom",
                of: null,
                offset: "0 -20"
            },
            center: {
                my: "center",
                at: "center",
                of: null,
                offset: "0 0"
            },
            right: {
                my: "center right",
                at: "center right",
                of: null,
                offset: "0 0"
            },
            left: {
                my: "center left",
                at: "center left",
                of: null,
                offset: "0 0"
            }
        };
        ready(function() {
            _events_engine.default.subscribeGlobal(_dom_adapter.default.getDocument(), _pointer.default.down, function(e) {
                for (var i = TOAST_STACK.length - 1; i >= 0; i--) {
                    if (!TOAST_STACK[i]._proxiedDocumentDownHandler(e)) {
                        return
                    }
                }
            })
        });
        var Toast = _overlay.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    message: "",
                    type: "info",
                    displayTime: 2e3,
                    position: "bottom center",
                    animation: {
                        show: {
                            type: "fade",
                            duration: 400,
                            from: 0,
                            to: 1
                        },
                        hide: {
                            type: "fade",
                            duration: 400,
                            to: 0
                        }
                    },
                    shading: false,
                    height: "auto",
                    hideTopOverlayHandler: null,
                    closeOnSwipe: true,
                    closeOnClick: false,
                    resizeEnabled: false
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: {
                        platform: "android"
                    },
                    options: {
                        closeOnOutsideClick: true,
                        width: "auto",
                        position: {
                            at: "bottom left",
                            my: "bottom left",
                            offset: "20 -20"
                        },
                        animation: {
                            show: {
                                type: "slide",
                                duration: 200,
                                from: {
                                    position: {
                                        my: "top",
                                        at: "bottom",
                                        of: window
                                    }
                                }
                            },
                            hide: {
                                type: "slide",
                                duration: 200,
                                to: {
                                    position: {
                                        my: "top",
                                        at: "bottom",
                                        of: window
                                    }
                                }
                            }
                        }
                    }
                }, {
                    device: function(_device) {
                        var isPhone = "phone" === _device.deviceType;
                        var isAndroid = "android" === _device.platform;
                        return isPhone && isAndroid
                    },
                    options: {
                        width: function() {
                            var _window$visualViewpor;
                            return (null === window || void 0 === window ? void 0 : null === (_window$visualViewpor = window.visualViewport) || void 0 === _window$visualViewpor ? void 0 : _window$visualViewpor.width) || (0, _renderer.default)(window).width()
                        },
                        position: {
                            at: "bottom center",
                            my: "bottom center",
                            offset: "0 0"
                        }
                    }
                }, {
                    device: function(_device2) {
                        return "phone" === _device2.deviceType
                    },
                    options: {
                        width: function() {
                            var _window$visualViewpor2;
                            return (null === window || void 0 === window ? void 0 : null === (_window$visualViewpor2 = window.visualViewport) || void 0 === _window$visualViewpor2 ? void 0 : _window$visualViewpor2.width) || (0, _renderer.default)(window).width()
                        }
                    }
                }, {
                    device: function() {
                        return (0, _themes.isMaterial)()
                    },
                    options: {
                        minWidth: 344,
                        maxWidth: 568,
                        displayTime: 4e3
                    }
                }])
            },
            _init: function() {
                this.callBase();
                this._posStringToObject()
            },
            _renderContentImpl: function() {
                if (this.option("message")) {
                    this._message = (0, _renderer.default)("<div>").addClass(TOAST_MESSAGE_CLASS).text(this.option("message")).appendTo(this.$content())
                }
                this.setAria("role", "alert", this._message);
                if ((0, _array.inArray)(this.option("type").toLowerCase(), toastTypes) > -1) {
                    this.$content().prepend((0, _renderer.default)("<div>").addClass(TOAST_ICON_CLASS))
                }
                this.callBase()
            },
            _render: function() {
                this.callBase();
                this.$element().addClass(TOAST_CLASS);
                this._wrapper().addClass(TOAST_WRAPPER_CLASS);
                this._$content.addClass(TOAST_CLASS_PREFIX + String(this.option("type")).toLowerCase());
                this.$content().addClass(TOAST_CONTENT_CLASS);
                this._toggleCloseEvents("Swipe");
                this._toggleCloseEvents("Click")
            },
            _renderScrollTerminator: _common.noop,
            _toggleCloseEvents: function(event) {
                var dxEvent = "dx" + event.toLowerCase();
                _events_engine.default.off(this._$content, dxEvent);
                this.option("closeOn" + event) && _events_engine.default.on(this._$content, dxEvent, this.hide.bind(this))
            },
            _posStringToObject: function() {
                if (!(0, _type.isString)(this.option("position"))) {
                    return
                }
                var verticalPosition = this.option("position").split(" ")[0];
                var horizontalPosition = this.option("position").split(" ")[1];
                this.option("position", (0, _extend.extend)({}, POSITION_ALIASES[verticalPosition]));
                switch (horizontalPosition) {
                    case "center":
                    case "left":
                    case "right":
                        this.option("position").at += " " + horizontalPosition;
                        this.option("position").my += " " + horizontalPosition
                }
            },
            _show: function() {
                if (visibleToastInstance && visibleToastInstance !== this) {
                    clearTimeout(visibleToastInstance._hideTimeout);
                    visibleToastInstance.hide()
                }
                visibleToastInstance = this;
                return this.callBase.apply(this, arguments).done(function() {
                    clearTimeout(this._hideTimeout);
                    this._hideTimeout = setTimeout(this.hide.bind(this), this.option("displayTime"))
                }.bind(this))
            },
            _hide: function() {
                visibleToastInstance = null;
                return this.callBase.apply(this, arguments)
            },
            _overlayStack: function() {
                return TOAST_STACK
            },
            _zIndexInitValue: function() {
                return this.callBase() + FIRST_Z_INDEX_OFFSET
            },
            _dispose: function() {
                clearTimeout(this._hideTimeout);
                visibleToastInstance = null;
                this.callBase()
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "type":
                        this._$content.removeClass(TOAST_CLASS_PREFIX + args.previousValue);
                        this._$content.addClass(TOAST_CLASS_PREFIX + String(args.value).toLowerCase());
                        break;
                    case "message":
                        if (this._message) {
                            this._message.text(args.value)
                        }
                        break;
                    case "closeOnSwipe":
                        this._toggleCloseEvents("Swipe");
                        break;
                    case "closeOnClick":
                        this._toggleCloseEvents("Click");
                        break;
                    case "displayTime":
                    case "position":
                        break;
                    default:
                        this.callBase(args)
                }
            }
        });
        (0, _component_registrator.default)(WIDGET_NAME, Toast);
        var _default = Toast;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/speed_dial_action/speed_dial_main_item.js ***!
      \*******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.initAction = initAction;
        exports.disposeAction = disposeAction;
        exports.repaint = repaint;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _config = _interopRequireDefault(__webpack_require__( /*! ../../core/config */ 31));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _swatch_container = _interopRequireDefault(__webpack_require__( /*! ../widget/swatch_container */ 170));
        var _speed_dial_item = _interopRequireDefault(__webpack_require__( /*! ./speed_dial_item */ 580));
        var _themes = __webpack_require__( /*! ../themes */ 34);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var getSwatchContainer = _swatch_container.default.getSwatchContainer;
        var FAB_MAIN_CLASS = "dx-fa-button-main";
        var FAB_MAIN_CLASS_WITH_LABEL = "dx-fa-button-with-label";
        var FAB_CLOSE_ICON_CLASS = "dx-fa-button-icon-close";
        var INVISIBLE_STATE_CLASS = "dx-state-invisible";
        var speedDialMainItem = null;
        var modifyActionOptions = function(action) {
            return (0, _extend.extend)({}, action._options.silent(), {
                onInitialized: null,
                onDisposing: null
            })
        };
        var SpeedDialMainItem = function(_SpeedDialItem) {
            _inheritsLoose(SpeedDialMainItem, _SpeedDialItem);

            function SpeedDialMainItem() {
                return _SpeedDialItem.apply(this, arguments) || this
            }
            var _proto = SpeedDialMainItem.prototype;
            _proto._getDefaultOptions = function() {
                var defaultOptions = {
                    icon: "add",
                    closeIcon: "close",
                    position: {
                        at: "right bottom",
                        my: "right bottom",
                        offset: {
                            x: -16,
                            y: -16
                        }
                    },
                    maxSpeedDialActionCount: 5,
                    hint: "",
                    label: "",
                    direction: "auto",
                    actions: [],
                    activeStateEnabled: true,
                    hoverStateEnabled: true,
                    indent: 55,
                    childIndent: 40,
                    childOffset: 9,
                    callOverlayRenderShading: true,
                    closeOnOutsideClick: true
                };
                return (0, _extend.extend)(_SpeedDialItem.prototype._getDefaultOptions.call(this), (0, _extend.extend)(defaultOptions, (0, _config.default)().floatingActionButtonConfig, {
                    shading: false
                }))
            };
            _proto._defaultOptionsRules = function() {
                return _SpeedDialItem.prototype._defaultOptionsRules.call(this).concat([{
                    device: function() {
                        return (0, _themes.isMaterial)()
                    },
                    options: {
                        indent: 72,
                        childIndent: 56,
                        childOffset: 8
                    }
                }])
            };
            _proto._render = function() {
                this.$element().addClass(FAB_MAIN_CLASS);
                _SpeedDialItem.prototype._render.call(this);
                this._moveToContainer();
                this._renderCloseIcon();
                this._renderClick()
            };
            _proto._renderLabel = function() {
                _SpeedDialItem.prototype._renderLabel.call(this);
                this.$element().toggleClass(FAB_MAIN_CLASS_WITH_LABEL, !!this._$label)
            };
            _proto._renderCloseIcon = function() {
                this._$closeIcon = this._renderButtonIcon(this._$closeIcon, this._options.silent("closeIcon"), FAB_CLOSE_ICON_CLASS);
                this._$closeIcon.addClass(INVISIBLE_STATE_CLASS)
            };
            _proto._renderClick = function() {
                this._clickAction = 1 === this._getVisibleActions().length ? this._getActionComponent()._createActionByOption("onClick") : this._createAction(this._clickHandler.bind(this));
                this._setClickAction()
            };
            _proto._getVisibleActions = function(actions) {
                var currentActions = actions || this.option("actions");
                return currentActions.filter(function(action) {
                    return action.option("visible")
                })
            };
            _proto._getCurrentOptions = function(actions) {
                var visibleActions = speedDialMainItem._getVisibleActions(actions);
                return 1 === visibleActions.length ? (0, _extend.extend)(visibleActions[0]._options.silent(), {
                    position: this._getPosition()
                }) : (0, _extend.extend)(this._getDefaultOptions(), {
                    visible: 0 !== visibleActions.length
                })
            };
            _proto._clickHandler = function() {
                var actions = this._actionItems.filter(function(action) {
                    return action.option("actionVisible")
                }).sort(function(action, nextAction) {
                    return action.option("index") - nextAction.option("index")
                });
                if (1 === actions.length) {
                    return
                }
                var lastActionIndex = actions.length - 1;
                for (var i = 0; i < actions.length; i++) {
                    actions[i].option("animation", this._getActionAnimation(actions[i], i, lastActionIndex));
                    actions[i].option("position", this._getActionPosition(actions, i));
                    actions[i]._$wrapper.css("position", this._$wrapper.css("position"));
                    actions[i].toggle()
                }
                if ((0, _config.default)().floatingActionButtonConfig.shading) {
                    this._isShadingShown = !this.option("shading");
                    this.option("shading", this._isShadingShown)
                }
                this._$icon.toggleClass(INVISIBLE_STATE_CLASS);
                this._$closeIcon.toggleClass(INVISIBLE_STATE_CLASS)
            };
            _proto._updateZIndexStackPosition = function() {
                _SpeedDialItem.prototype._updateZIndexStackPosition.call(this);
                var overlayStack = this._overlayStack();
                overlayStack.push(this)
            };
            _proto._renderActions = function() {
                var _this = this;
                var actions = this.option("actions");
                var minActionButtonCount = 1;
                if (this._actionItems && this._actionItems.length) {
                    this._actionItems.forEach(function(actionItem) {
                        actionItem.dispose();
                        actionItem.$element().remove()
                    });
                    this._actionItems = []
                }
                this._actionItems = [];
                if (actions.length === minActionButtonCount) {
                    return
                }
                for (var i = 0; i < actions.length; i++) {
                    var action = actions[i];
                    var $actionElement = (0, _renderer.default)("<div>").appendTo(getSwatchContainer(action.$element()));
                    _events_engine.default.off($actionElement, "click");
                    _events_engine.default.on($actionElement, "click", function() {
                        _this._clickHandler()
                    });
                    action._options.silent("actionComponent", action);
                    action._options.silent("parentPosition", this._getPosition());
                    action._options.silent("actionVisible", action._options.silent("visible"));
                    this._actionItems.push(this._createComponent($actionElement, _speed_dial_item.default, (0, _extend.extend)({}, modifyActionOptions(action), {
                        visible: false
                    })))
                }
            };
            _proto._getActionAnimation = function(action, index, lastActionIndex) {
                var actionAnimationDelay = 30;
                action._options.silent("animation.show.delay", actionAnimationDelay * index);
                action._options.silent("animation.hide.delay", actionAnimationDelay * (lastActionIndex - index));
                return action._options.silent("animation")
            };
            _proto._getDirectionIndex = function(actions, direction) {
                var directionIndex = 1;
                if ("auto" === direction) {
                    var contentHeight = this.$content().height();
                    var actionsHeight = this.initialOption("indent") + this.initialOption("childIndent") * actions.length - contentHeight;
                    var offsetTop = this.$content().offset().top;
                    if (actionsHeight < offsetTop) {
                        return -directionIndex
                    } else {
                        var offsetBottom = this._getContainer().height() - contentHeight - offsetTop;
                        return offsetTop >= offsetBottom ? -directionIndex : directionIndex
                    }
                }
                return "down" !== direction ? -directionIndex : directionIndex
            };
            _proto._getActionPosition = function(actions, index) {
                var action = actions[index];
                var actionOffsetXValue = this.initialOption("childOffset");
                var actionOffsetX = action._options.silent("label") && !this._$label ? this._isPositionLeft(this._getPosition()) ? actionOffsetXValue : -actionOffsetXValue : 0;
                var actionOffsetYValue = this.initialOption("indent") + this.initialOption("childIndent") * index;
                var actionOffsetY = this._getDirectionIndex(actions, this.option("direction")) * actionOffsetYValue;
                var actionPositionAtMy = action._options.silent("label") ? this._isPositionLeft(this._getPosition()) ? "left" : "right" : "center";
                return {
                    of: this.$content(),
                    at: actionPositionAtMy,
                    my: actionPositionAtMy,
                    offset: {
                        x: actionOffsetX,
                        y: actionOffsetY
                    }
                }
            };
            _proto._outsideClickHandler = function(e) {
                if (this._isShadingShown) {
                    var isShadingClick = (0, _renderer.default)(e.target)[0] === this._$wrapper[0];
                    if (isShadingClick) {
                        e.preventDefault();
                        this._clickHandler()
                    }
                }
            };
            _proto._setPosition = function() {
                if (this.option("visible")) {
                    this._hide();
                    this._show()
                }
            };
            _proto._getPosition = function() {
                return this._getDefaultOptions().position
            };
            _proto._getInkRippleContainer = function() {
                return this.$content()
            };
            _proto._optionChanged = function(args) {
                switch (args.name) {
                    case "actions":
                        if (this._isVisible()) {
                            this._renderIcon()
                        }
                        this._renderCloseIcon();
                        this._renderClick();
                        this._renderActions();
                        break;
                    case "maxSpeedDialActionCount":
                        this._renderActions();
                        break;
                    case "closeIcon":
                        this._renderCloseIcon();
                        break;
                    case "position":
                        this._setPosition();
                        break;
                    case "label":
                        if (this._isVisible()) {
                            this._renderLabel()
                        }
                        this._setPosition();
                        break;
                    case "icon":
                        if (this._isVisible()) {
                            this._renderIcon()
                        }
                        break;
                    default:
                        _SpeedDialItem.prototype._optionChanged.call(this, args)
                }
            };
            return SpeedDialMainItem
        }(_speed_dial_item.default);

        function initAction(newAction) {
            newAction._options.silent("onInitializing", null);
            var isActionExist = false;
            if (!speedDialMainItem) {
                var $fabMainElement = (0, _renderer.default)("<div>").appendTo(getSwatchContainer(newAction.$element()));
                speedDialMainItem = newAction._createComponent($fabMainElement, SpeedDialMainItem, (0, _extend.extend)({}, modifyActionOptions(newAction), {
                    actions: [newAction]
                }))
            } else {
                var savedActions = speedDialMainItem.option("actions");
                savedActions.forEach(function(action) {
                    if (action._options.silent("id") === newAction._options.silent("id")) {
                        isActionExist = true;
                        return newAction
                    }
                });
                delete speedDialMainItem._options.silent("position");
                if (!isActionExist) {
                    if (speedDialMainItem._getVisibleActions(savedActions).length >= speedDialMainItem.option("maxSpeedDialActionCount")) {
                        newAction.dispose();
                        _ui.default.log("W1014");
                        return
                    }
                    savedActions.push(newAction);
                    speedDialMainItem.option((0, _extend.extend)(speedDialMainItem._getCurrentOptions(savedActions), {
                        actions: savedActions
                    }))
                } else {
                    if (1 === savedActions.length) {
                        speedDialMainItem.option((0, _extend.extend)({}, modifyActionOptions(savedActions[0]), {
                            actions: savedActions,
                            position: speedDialMainItem._getPosition()
                        }))
                    } else {
                        speedDialMainItem.option((0, _extend.extend)(speedDialMainItem._getCurrentOptions(savedActions), {
                            actions: savedActions
                        }))
                    }
                }
            }
        }

        function disposeAction(actionId) {
            if (!speedDialMainItem) {
                return
            }
            var savedActions = speedDialMainItem.option("actions");
            var savedActionsCount = savedActions.length;
            savedActions = savedActions.filter(function(action) {
                return action._options.silent("id") !== actionId
            });
            if (savedActionsCount === savedActions.length) {
                return
            }
            if (!savedActions.length) {
                speedDialMainItem.dispose();
                speedDialMainItem.$element().remove();
                speedDialMainItem = null
            } else {
                if (1 === savedActions.length) {
                    speedDialMainItem.option((0, _extend.extend)({}, modifyActionOptions(savedActions[0]), {
                        actions: savedActions
                    }))
                } else {
                    speedDialMainItem.option({
                        actions: savedActions
                    })
                }
            }
        }

        function repaint() {
            if (!speedDialMainItem) {
                return
            }
            var visibleActions = speedDialMainItem._getVisibleActions();
            var icon = 1 === visibleActions.length ? visibleActions[0].option("icon") : speedDialMainItem._getDefaultOptions().icon;
            var label = 1 === visibleActions.length ? visibleActions[0].option("label") : speedDialMainItem._getDefaultOptions().label;
            speedDialMainItem.option({
                actions: speedDialMainItem.option("actions"),
                icon: icon,
                closeIcon: speedDialMainItem._getDefaultOptions().closeIcon,
                position: speedDialMainItem._getPosition(),
                label: label,
                maxSpeedDialActionCount: speedDialMainItem._getDefaultOptions().maxSpeedDialActionCount,
                direction: speedDialMainItem._getDefaultOptions().direction
            })
        }
    },
    /*!****************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/text_box/ui.text_editor.js ***!
      \****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _uiText_editor = _interopRequireDefault(__webpack_require__( /*! ./ui.text_editor.mask */ 584));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }(0, _component_registrator.default)("dxTextEditor", _uiText_editor.default);
        var _default = _uiText_editor.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/text_box/utils.caret.js ***!
      \*************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _devices$real = _devices.default.real(),
            ios = _devices$real.ios,
            mac = _devices$real.mac;
        var isFocusingOnCaretChange = _browser.default.msie || ios || mac;
        var getCaret = function(input) {
            var range;
            try {
                range = {
                    start: input.selectionStart,
                    end: input.selectionEnd
                }
            } catch (e) {
                range = {
                    start: 0,
                    end: 0
                }
            }
            return range
        };
        var setCaret = function(input, position) {
            if (!_dom_adapter.default.getBody().contains(input)) {
                return
            }
            try {
                input.selectionStart = position.start;
                input.selectionEnd = position.end
            } catch (e) {}
        };
        var caret = function(input, position) {
            var force = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : false;
            input = (0, _renderer.default)(input).get(0);
            if (!(0, _type.isDefined)(position)) {
                return getCaret(input)
            }
            if (!force && isFocusingOnCaretChange && _dom_adapter.default.getActiveElement() !== input) {
                return
            }
            setCaret(input, position)
        };
        var _default = caret;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/text_box/ui.text_editor.mask.strategy.base.js ***!
      \***********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _dom = __webpack_require__( /*! ../../core/utils/dom */ 33);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var MASK_EVENT_NAMESPACE = "dxMask";
        var BLUR_EVENT = "blur beforedeactivate";
        var EMPTY_CHAR = " ";
        var BaseMaskStrategy = function() {
            function BaseMaskStrategy(editor) {
                this.editor = editor;
                this.DIRECTION = {
                    FORWARD: "forward",
                    BACKWARD: "backward"
                };
                this.NAME = this._getStrategyName()
            }
            var _proto = BaseMaskStrategy.prototype;
            _proto._getStrategyName = function() {
                return "base"
            };
            _proto.editorOption = function() {
                var _this$editor;
                return (_this$editor = this.editor).option.apply(_this$editor, arguments)
            };
            _proto.editorInput = function() {
                return this.editor._input()
            };
            _proto.editorCaret = function(newCaret) {
                if (!newCaret) {
                    return this.editor._caret()
                }
                this.editor._caret(newCaret)
            };
            _proto.getHandler = function(handlerName) {
                var handler = this["_".concat(handlerName, "Handler")] || function() {};
                return handler.bind(this)
            };
            _proto.attachEvents = function() {
                var _this = this;
                var $input = this.editorInput();
                this.getHandleEventNames().forEach(function(eventName) {
                    var subscriptionName = (0, _index.addNamespace)(eventName.toLowerCase(), MASK_EVENT_NAMESPACE);
                    _events_engine.default.on($input, subscriptionName, _this.getEventHandler(eventName))
                });
                this._attachChangeEventHandlers()
            };
            _proto.getHandleEventNames = function() {
                return ["focusIn", "focusOut", "keyDown", "input", "paste", "cut", "drop"]
            };
            _proto.getEventHandler = function(eventName) {
                return this["_".concat(eventName, "Handler")].bind(this)
            };
            _proto.detachEvents = function() {
                _events_engine.default.off(this.editorInput(), ".".concat(MASK_EVENT_NAMESPACE))
            };
            _proto._attachChangeEventHandlers = function() {
                if ((0, _array.inArray)("change", this.editorOption("valueChangeEvent").split(" ")) === -1) {
                    return
                }
                _events_engine.default.on(this.editorInput(), (0, _index.addNamespace)(BLUR_EVENT, MASK_EVENT_NAMESPACE), function(e) {
                    this._suppressCaretChanging(this._changeHandler, [e]);
                    this._changeHandler(e)
                }.bind(this.editor))
            };
            _proto._focusInHandler = function() {
                this.editor._showMaskPlaceholder();
                this.editor._direction(this.DIRECTION.FORWARD);
                if (!this.editor._isValueEmpty() && this.editorOption("isValid")) {
                    this.editor._adjustCaret()
                } else {
                    var caret = this.editor._maskRulesChain.first();
                    this._caretTimeout = setTimeout(function() {
                        this._caret({
                            start: caret,
                            end: caret
                        })
                    }.bind(this.editor), 0)
                }
            };
            _proto._focusOutHandler = function(event) {
                this.editor._changeHandler(event);
                if ("onFocus" === this.editorOption("showMaskMode") && this.editor._isValueEmpty()) {
                    this.editorOption("text", "");
                    this.editor._renderDisplayText("")
                }
            };
            _proto._cutHandler = function(event) {
                var caret = this.editorCaret();
                var selectedText = this.editorInput().val().substring(caret.start, caret.end);
                this.editor._maskKeyHandler(event, function() {
                    return (0, _dom.clipboardText)(event, selectedText)
                })
            };
            _proto._dropHandler = function() {
                this._clearDragTimer();
                this._dragTimer = setTimeout(function() {
                    this.option("value", this._convertToValue(this._input().val()))
                }.bind(this.editor))
            };
            _proto._clearDragTimer = function() {
                clearTimeout(this._dragTimer)
            };
            _proto._keyDownHandler = function() {
                this._keyPressHandled = false
            };
            _proto._pasteHandler = function(event) {
                var editor = this.editor;
                this._keyPressHandled = true;
                var caret = this.editorCaret();
                editor._maskKeyHandler(event, function() {
                    var pastedText = (0, _dom.clipboardText)(event);
                    var restText = editor._maskRulesChain.text().substring(caret.end);
                    var accepted = editor._handleChain({
                        text: pastedText,
                        start: caret.start,
                        length: pastedText.length
                    });
                    var newCaret = caret.start + accepted;
                    editor._handleChain({
                        text: restText,
                        start: newCaret,
                        length: restText.length
                    });
                    editor._caret({
                        start: newCaret,
                        end: newCaret
                    })
                })
            };
            _proto._autoFillHandler = function(event) {
                var _this2 = this;
                var editor = this.editor;
                var inputVal = this.editorInput().val();
                this._inputHandlerTimer = setTimeout(function() {
                    _this2._keyPressHandled = true;
                    if (_this2._isAutoFill()) {
                        _this2._keyPressHandled = true;
                        editor._maskKeyHandler(event, function() {
                            editor._handleChain({
                                text: inputVal,
                                start: 0,
                                length: inputVal.length
                            })
                        });
                        editor._validateMask()
                    }
                })
            };
            _proto._isAutoFill = function() {
                var $input = this.editor._input();
                var result = false;
                if (_browser.default.msie && _browser.default.version > 11) {
                    result = $input.hasClass("edge-autofilled")
                } else {
                    if (_browser.default.webkit) {
                        var input = $input.get(0);
                        result = input && input.matches(":-webkit-autofill")
                    }
                }
                return result
            };
            _proto.runWithoutEventProcessing = function(action) {
                var keyPressHandled = this._keyPressHandled;
                this._keyPressHandled = true;
                action();
                this._keyPressHandled = keyPressHandled
            };
            _proto._backspaceHandler = function() {};
            _proto._delHandler = function(event) {
                var editor = this.editor;
                this._keyPressHandled = true;
                editor._maskKeyHandler(event, function() {
                    return !editor._hasSelection() && editor._handleKey(EMPTY_CHAR)
                })
            };
            _proto.clean = function() {
                this._clearDragTimer();
                clearTimeout(this._backspaceHandlerTimeout);
                clearTimeout(this._caretTimeout);
                clearTimeout(this._inputHandlerTimer)
            };
            return BaseMaskStrategy
        }();
        exports.default = BaseMaskStrategy;
        module.exports = exports.default
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/list/ui.list.edit.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _uiListEditStrategy = _interopRequireDefault(__webpack_require__( /*! ./ui.list.edit.strategy.grouped */ 594));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _uiListEdit = _interopRequireDefault(__webpack_require__( /*! ./ui.list.edit.provider */ 595));
        var _uiList = __webpack_require__( /*! ./ui.list.base */ 270);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var LIST_ITEM_SELECTED_CLASS = "dx-list-item-selected";
        var LIST_ITEM_RESPONSE_WAIT_CLASS = "dx-list-item-response-wait";
        var ListEdit = _uiList.ListBase.inherit({
            _supportedKeys: function() {
                var _this = this;
                var that = this;
                var parent = this.callBase();
                var deleteFocusedItem = function(e) {
                    if (that.option("allowItemDeleting")) {
                        e.preventDefault();
                        that.deleteItem(that.option("focusedElement"))
                    }
                };
                var moveFocusedItem = function(e, moveUp) {
                    var editStrategy = _this._editStrategy;
                    var focusedElement = _this.option("focusedElement");
                    var focusedItemIndex = editStrategy.getNormalizedIndex(focusedElement);
                    var isLastIndexFocused = focusedItemIndex === _this._getLastItemIndex();
                    if (isLastIndexFocused && _this._isDataSourceLoading()) {
                        return
                    }
                    if (e.shiftKey && that.option("itemDragging.allowReordering")) {
                        var nextItemIndex = focusedItemIndex + (moveUp ? -1 : 1);
                        var $nextItem = editStrategy.getItemElement(nextItemIndex);
                        _this.reorderItem(focusedElement, $nextItem);
                        _this.scrollToItem(focusedElement);
                        e.preventDefault()
                    } else {
                        var editProvider = _this._editProvider;
                        var isInternalMoving = editProvider.handleKeyboardEvents(focusedItemIndex, moveUp);
                        if (!isInternalMoving) {
                            moveUp ? parent.upArrow(e) : parent.downArrow(e)
                        }
                    }
                };
                var enter = function(e) {
                    if (!this._editProvider.handleEnterPressing(e)) {
                        parent.enter.apply(this, arguments)
                    }
                };
                var space = function(e) {
                    if (!this._editProvider.handleEnterPressing(e)) {
                        parent.space.apply(this, arguments)
                    }
                };
                return (0, _extend.extend)({}, parent, {
                    del: deleteFocusedItem,
                    upArrow: function(e) {
                        return moveFocusedItem(e, true)
                    },
                    downArrow: function(e) {
                        return moveFocusedItem(e)
                    },
                    enter: enter,
                    space: space
                })
            },
            _updateSelection: function() {
                this._editProvider.afterItemsRendered();
                this.callBase()
            },
            _getLastItemIndex: function() {
                return this._itemElements().length - 1
            },
            _refreshItemElements: function() {
                this.callBase();
                var excludedSelectors = this._editProvider.getExcludedItemSelectors();
                if (excludedSelectors.length) {
                    this._itemElementsCache = this._itemElementsCache.not(excludedSelectors)
                }
            },
            _isItemStrictEquals: function(item1, item2) {
                var privateKey = item1 && item1.__dx_key__;
                if (privateKey && !this.key() && this._selection.isItemSelected(privateKey)) {
                    return false
                }
                return this.callBase(item1, item2)
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    showSelectionControls: false,
                    selectionMode: "none",
                    selectAllMode: "page",
                    onSelectAllValueChanged: null,
                    selectAllText: _message.default.format("dxList-selectAll"),
                    menuItems: [],
                    menuMode: "context",
                    allowItemDeleting: false,
                    itemDeleteMode: "static",
                    itemDragging: {}
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: function(_device) {
                        return "ios" === _device.platform
                    },
                    options: {
                        menuMode: "slide",
                        itemDeleteMode: "slideItem"
                    }
                }, {
                    device: {
                        platform: "android"
                    },
                    options: {
                        itemDeleteMode: "swipe"
                    }
                }])
            },
            _init: function() {
                this.callBase();
                this._initEditProvider()
            },
            _initDataSource: function() {
                this.callBase();
                if (!this._isPageSelectAll()) {
                    this._dataSource && this._dataSource.requireTotalCount(true)
                }
            },
            _isPageSelectAll: function() {
                return "page" === this.option("selectAllMode")
            },
            _initEditProvider: function() {
                this._editProvider = new _uiListEdit.default(this)
            },
            _disposeEditProvider: function() {
                if (this._editProvider) {
                    this._editProvider.dispose()
                }
            },
            _refreshEditProvider: function() {
                this._disposeEditProvider();
                this._initEditProvider()
            },
            _initEditStrategy: function() {
                if (this.option("grouped")) {
                    this._editStrategy = new _uiListEditStrategy.default(this)
                } else {
                    this.callBase()
                }
            },
            _initMarkup: function() {
                this._refreshEditProvider();
                this.callBase()
            },
            _renderItems: function() {
                this.callBase.apply(this, arguments);
                this._editProvider.afterItemsRendered()
            },
            _selectedItemClass: function() {
                return LIST_ITEM_SELECTED_CLASS
            },
            _itemResponseWaitClass: function() {
                return LIST_ITEM_RESPONSE_WAIT_CLASS
            },
            _itemClickHandler: function(e) {
                var $itemElement = (0, _renderer.default)(e.currentTarget);
                if ($itemElement.is(".dx-state-disabled, .dx-state-disabled *")) {
                    return
                }
                var handledByEditProvider = this._editProvider.handleClick($itemElement, e);
                if (handledByEditProvider) {
                    return
                }
                this._saveSelectionChangeEvent(e);
                this.callBase.apply(this, arguments)
            },
            _shouldFireContextMenuEvent: function() {
                return this.callBase.apply(this, arguments) || this._editProvider.contextMenuHandlerExists()
            },
            _itemHoldHandler: function(e) {
                var $itemElement = (0, _renderer.default)(e.currentTarget);
                if ($itemElement.is(".dx-state-disabled, .dx-state-disabled *")) {
                    return
                }
                var handledByEditProvider = (0, _index.isTouchEvent)(e) && this._editProvider.handleContextMenu($itemElement, e);
                if (handledByEditProvider) {
                    e.handledByEditProvider = true;
                    return
                }
                this.callBase.apply(this, arguments)
            },
            _itemContextMenuHandler: function(e) {
                var $itemElement = (0, _renderer.default)(e.currentTarget);
                if ($itemElement.is(".dx-state-disabled, .dx-state-disabled *")) {
                    return
                }
                var handledByEditProvider = !e.handledByEditProvider && this._editProvider.handleContextMenu($itemElement, e);
                if (handledByEditProvider) {
                    e.preventDefault();
                    return
                }
                this.callBase.apply(this, arguments)
            },
            _postprocessRenderItem: function(args) {
                this.callBase.apply(this, arguments);
                this._editProvider.modifyItemElement(args)
            },
            _clean: function() {
                this._disposeEditProvider();
                this.callBase()
            },
            focusListItem: function(index) {
                var $item = this._editStrategy.getItemElement(index);
                this.option("focusedElement", $item);
                this.focus();
                this.scrollToItem(this.option("focusedElement"))
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "selectAllMode":
                        this._initDataSource();
                        this._dataSource.pageIndex(0);
                        this._dataSource.load();
                        break;
                    case "grouped":
                        this._clearSelectedItems();
                        delete this._renderingGroupIndex;
                        this._initEditStrategy();
                        this.callBase(args);
                        break;
                    case "showSelectionControls":
                    case "menuItems":
                    case "menuMode":
                    case "allowItemDeleting":
                    case "itemDeleteMode":
                    case "itemDragging":
                    case "selectAllText":
                        this._invalidate();
                        break;
                    case "onSelectAllValueChanged":
                        break;
                    default:
                        this.callBase(args)
                }
            },
            selectAll: function() {
                return this._selection.selectAll(this._isPageSelectAll())
            },
            unselectAll: function() {
                return this._selection.deselectAll(this._isPageSelectAll())
            },
            isSelectAll: function() {
                return this._selection.getSelectAllState(this._isPageSelectAll())
            },
            getFlatIndexByItemElement: function(itemElement) {
                return this._itemElements().index(itemElement)
            },
            getItemElementByFlatIndex: function(flatIndex) {
                var $itemElements = this._itemElements();
                if (flatIndex < 0 || flatIndex >= $itemElements.length) {
                    return (0, _renderer.default)()
                }
                return $itemElements.eq(flatIndex)
            },
            getItemByIndex: function(index) {
                return this._editStrategy.getItemDataByIndex(index)
            }
        });
        var _default = ListEdit;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/list/ui.list.edit.decorator.switchable.js ***!
      \*******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _uiListEdit = _interopRequireDefault(__webpack_require__( /*! ./ui.list.edit.decorator */ 156));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../../events/pointer */ 24));
        var _emitter = __webpack_require__( /*! ../../events/core/emitter.feedback */ 149);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var abstract = _uiListEdit.default.abstract;
        var LIST_EDIT_DECORATOR = "dxListEditDecorator";
        var POINTER_DOWN_EVENT_NAME = (0, _index.addNamespace)(_pointer.default.down, LIST_EDIT_DECORATOR);
        var ACTIVE_EVENT_NAME = (0, _index.addNamespace)(_emitter.active, LIST_EDIT_DECORATOR);
        var LIST_ITEM_CONTENT_CLASS = "dx-list-item-content";
        var SWITCHABLE_DELETE_READY_CLASS = "dx-list-switchable-delete-ready";
        var SWITCHABLE_MENU_SHIELD_POSITIONING_CLASS = "dx-list-switchable-menu-shield-positioning";
        var SWITCHABLE_DELETE_TOP_SHIELD_CLASS = "dx-list-switchable-delete-top-shield";
        var SWITCHABLE_DELETE_BOTTOM_SHIELD_CLASS = "dx-list-switchable-delete-bottom-shield";
        var SWITCHABLE_MENU_ITEM_SHIELD_POSITIONING_CLASS = "dx-list-switchable-menu-item-shield-positioning";
        var SWITCHABLE_DELETE_ITEM_CONTENT_SHIELD_CLASS = "dx-list-switchable-delete-item-content-shield";
        var SWITCHABLE_DELETE_BUTTON_CONTAINER_CLASS = "dx-list-switchable-delete-button-container";
        var SwitchableEditDecorator = _uiListEdit.default.inherit({
            _init: function() {
                this._$topShield = (0, _renderer.default)("<div>").addClass(SWITCHABLE_DELETE_TOP_SHIELD_CLASS);
                this._$bottomShield = (0, _renderer.default)("<div>").addClass(SWITCHABLE_DELETE_BOTTOM_SHIELD_CLASS);
                this._$itemContentShield = (0, _renderer.default)("<div>").addClass(SWITCHABLE_DELETE_ITEM_CONTENT_SHIELD_CLASS);
                _events_engine.default.on(this._$topShield, POINTER_DOWN_EVENT_NAME, this._cancelDeleteReadyItem.bind(this));
                _events_engine.default.on(this._$bottomShield, POINTER_DOWN_EVENT_NAME, this._cancelDeleteReadyItem.bind(this));
                this._list.$element().append(this._$topShield.toggle(false)).append(this._$bottomShield.toggle(false))
            },
            handleClick: function() {
                return this._cancelDeleteReadyItem()
            },
            _cancelDeleteReadyItem: function() {
                if (!this._$readyToDeleteItem) {
                    return false
                }
                this._cancelDelete(this._$readyToDeleteItem);
                return true
            },
            _cancelDelete: function($itemElement) {
                this._toggleDeleteReady($itemElement, false)
            },
            _toggleDeleteReady: function($itemElement, readyToDelete) {
                if (void 0 === readyToDelete) {
                    readyToDelete = !this._isReadyToDelete($itemElement)
                }
                this._toggleShields($itemElement, readyToDelete);
                this._toggleScrolling(readyToDelete);
                this._cacheReadyToDeleteItem($itemElement, readyToDelete);
                this._animateToggleDelete($itemElement, readyToDelete)
            },
            _isReadyToDelete: function($itemElement) {
                return $itemElement.hasClass(SWITCHABLE_DELETE_READY_CLASS)
            },
            _toggleShields: function($itemElement, enabled) {
                this._list.$element().toggleClass(SWITCHABLE_MENU_SHIELD_POSITIONING_CLASS, enabled);
                this._$topShield.toggle(enabled);
                this._$bottomShield.toggle(enabled);
                if (enabled) {
                    this._updateShieldsHeight($itemElement)
                }
                this._toggleContentShield($itemElement, enabled)
            },
            _updateShieldsHeight: function($itemElement) {
                var $list = this._list.$element();
                var listTopOffset = $list.offset().top;
                var listHeight = $list.outerHeight();
                var itemTopOffset = $itemElement.offset().top;
                var itemHeight = $itemElement.outerHeight();
                var dirtyTopShieldHeight = itemTopOffset - listTopOffset;
                var dirtyBottomShieldHeight = listHeight - itemHeight - dirtyTopShieldHeight;
                this._$topShield.height(Math.max(dirtyTopShieldHeight, 0));
                this._$bottomShield.height(Math.max(dirtyBottomShieldHeight, 0))
            },
            _toggleContentShield: function($itemElement, enabled) {
                if (enabled) {
                    $itemElement.find("." + LIST_ITEM_CONTENT_CLASS).first().append(this._$itemContentShield)
                } else {
                    this._$itemContentShield.detach()
                }
            },
            _toggleScrolling: function(readyToDelete) {
                var scrollView = this._list.$element().dxScrollView("instance");
                if (readyToDelete) {
                    scrollView.on("start", this._cancelScrolling)
                } else {
                    scrollView.off("start", this._cancelScrolling)
                }
            },
            _cancelScrolling: function(args) {
                args.event.cancel = true
            },
            _cacheReadyToDeleteItem: function($itemElement, cache) {
                if (cache) {
                    this._$readyToDeleteItem = $itemElement
                } else {
                    delete this._$readyToDeleteItem
                }
            },
            _animateToggleDelete: function($itemElement, readyToDelete) {
                if (readyToDelete) {
                    this._enablePositioning($itemElement);
                    this._prepareDeleteReady($itemElement);
                    this._animatePrepareDeleteReady($itemElement);
                    _events_engine.default.off($itemElement, _pointer.default.up)
                } else {
                    this._forgetDeleteReady($itemElement);
                    this._animateForgetDeleteReady($itemElement).done(this._disablePositioning.bind(this, $itemElement))
                }
            },
            _enablePositioning: function($itemElement) {
                $itemElement.addClass(SWITCHABLE_MENU_ITEM_SHIELD_POSITIONING_CLASS);
                _events_engine.default.on($itemElement, ACTIVE_EVENT_NAME, _common.noop);
                _events_engine.default.one($itemElement, _pointer.default.up, this._disablePositioning.bind(this, $itemElement))
            },
            _disablePositioning: function($itemElement) {
                $itemElement.removeClass(SWITCHABLE_MENU_ITEM_SHIELD_POSITIONING_CLASS);
                _events_engine.default.off($itemElement, ACTIVE_EVENT_NAME)
            },
            _prepareDeleteReady: function($itemElement) {
                $itemElement.addClass(SWITCHABLE_DELETE_READY_CLASS)
            },
            _forgetDeleteReady: function($itemElement) {
                $itemElement.removeClass(SWITCHABLE_DELETE_READY_CLASS)
            },
            _animatePrepareDeleteReady: abstract,
            _animateForgetDeleteReady: abstract,
            _getDeleteButtonContainer: function($itemElement) {
                $itemElement = $itemElement || this._$readyToDeleteItem;
                return $itemElement.children("." + SWITCHABLE_DELETE_BUTTON_CONTAINER_CLASS)
            },
            _deleteItem: function($itemElement) {
                $itemElement = $itemElement || this._$readyToDeleteItem;
                this._getDeleteButtonContainer($itemElement).detach();
                if ($itemElement.is(".dx-state-disabled, .dx-state-disabled *")) {
                    return
                }
                this._list.deleteItem($itemElement).always(this._cancelDelete.bind(this, $itemElement))
            },
            _isRtlEnabled: function() {
                return this._list.option("rtlEnabled")
            },
            dispose: function() {
                if (this._$topShield) {
                    this._$topShield.remove()
                }
                if (this._$bottomShield) {
                    this._$bottomShield.remove()
                }
                this.callBase.apply(this, arguments)
            }
        });
        var _default = SwitchableEditDecorator;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/list/ui.list.edit.decorator_menu_helper.js ***!
      \********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var EditDecoratorMenuHelperMixin = {
            _menuEnabled: function() {
                return !!this._menuItems().length
            },
            _menuItems: function() {
                return this._list.option("menuItems")
            },
            _deleteEnabled: function() {
                return this._list.option("allowItemDeleting")
            },
            _fireMenuAction: function($itemElement, action) {
                this._list._itemEventHandlerByHandler($itemElement, action, {}, {
                    excludeValidators: ["disabled", "readOnly"]
                })
            }
        };
        var _default = EditDecoratorMenuHelperMixin;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scroll_view/ui.scrollbar.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _ready_callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/ready_callbacks */ 49));
        var _translator = __webpack_require__( /*! ../../animation/translator */ 28);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../../events/pointer */ 24));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var SCROLLBAR = "dxScrollbar";
        var SCROLLABLE_SCROLLBAR_CLASS = "dx-scrollable-scrollbar";
        var SCROLLABLE_SCROLLBAR_ACTIVE_CLASS = "".concat(SCROLLABLE_SCROLLBAR_CLASS, "-active");
        var SCROLLABLE_SCROLL_CLASS = "dx-scrollable-scroll";
        var SCROLLABLE_SCROLL_CONTENT_CLASS = "dx-scrollable-scroll-content";
        var HOVER_ENABLED_STATE = "dx-scrollbar-hoverable";
        var HORIZONTAL = "horizontal";
        var THUMB_MIN_SIZE = 15;
        var SCROLLBAR_VISIBLE = {
            onScroll: "onScroll",
            onHover: "onHover",
            always: "always",
            never: "never"
        };
        var activeScrollbar = null;
        var Scrollbar = _ui.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    direction: null,
                    visible: false,
                    activeStateEnabled: false,
                    visibilityMode: SCROLLBAR_VISIBLE.onScroll,
                    containerSize: 0,
                    contentSize: 0,
                    expandable: true,
                    scaleRatio: 1
                })
            },
            _init: function() {
                this.callBase();
                this._isHovered = false
            },
            _initMarkup: function() {
                this._renderThumb();
                this.callBase()
            },
            _render: function() {
                this.callBase();
                this._renderDirection();
                this._update();
                this._attachPointerDownHandler();
                this.option("hoverStateEnabled", this._isHoverMode());
                this.$element().toggleClass(HOVER_ENABLED_STATE, this.option("hoverStateEnabled"))
            },
            _renderThumb: function() {
                this._$thumb = (0, _renderer.default)("<div>").addClass(SCROLLABLE_SCROLL_CLASS);
                (0, _renderer.default)("<div>").addClass(SCROLLABLE_SCROLL_CONTENT_CLASS).appendTo(this._$thumb);
                this.$element().addClass(SCROLLABLE_SCROLLBAR_CLASS).append(this._$thumb)
            },
            isThumb: function($element) {
                return !!this.$element().find($element).length
            },
            _isHoverMode: function() {
                var visibilityMode = this.option("visibilityMode");
                return (visibilityMode === SCROLLBAR_VISIBLE.onHover || visibilityMode === SCROLLBAR_VISIBLE.always) && this.option("expandable")
            },
            _renderDirection: function() {
                var direction = this.option("direction");
                this.$element().addClass("dx-scrollbar-" + direction);
                this._dimension = direction === HORIZONTAL ? "width" : "height";
                this._prop = direction === HORIZONTAL ? "left" : "top"
            },
            _attachPointerDownHandler: function() {
                _events_engine.default.on(this._$thumb, (0, _index.addNamespace)(_pointer.default.down, SCROLLBAR), this.feedbackOn.bind(this))
            },
            feedbackOn: function() {
                this.$element().addClass(SCROLLABLE_SCROLLBAR_ACTIVE_CLASS);
                activeScrollbar = this
            },
            feedbackOff: function() {
                this.$element().removeClass(SCROLLABLE_SCROLLBAR_ACTIVE_CLASS);
                activeScrollbar = null
            },
            cursorEnter: function() {
                this._isHovered = true;
                if (this._needScrollbar()) {
                    this.option("visible", true)
                }
            },
            cursorLeave: function() {
                this._isHovered = false;
                this.option("visible", false)
            },
            _renderDimensions: function() {
                this._$thumb.css({
                    width: this.option("width"),
                    height: this.option("height")
                })
            },
            _toggleVisibility: function(visible) {
                if (this.option("visibilityMode") === SCROLLBAR_VISIBLE.onScroll) {
                    this._$thumb.css("opacity")
                }
                visible = this._adjustVisibility(visible);
                this.option().visible = visible;
                this._$thumb.toggleClass("dx-state-invisible", !visible)
            },
            _adjustVisibility: function(visible) {
                if (this._baseContainerToContentRatio && !this._needScrollbar()) {
                    return false
                }
                switch (this.option("visibilityMode")) {
                    case SCROLLBAR_VISIBLE.onScroll:
                        break;
                    case SCROLLBAR_VISIBLE.onHover:
                        visible = visible || !!this._isHovered;
                        break;
                    case SCROLLBAR_VISIBLE.never:
                        visible = false;
                        break;
                    case SCROLLBAR_VISIBLE.always:
                        visible = true
                }
                return visible
            },
            moveTo: function(location) {
                if (this._isHidden()) {
                    return
                }
                if ((0, _type.isPlainObject)(location)) {
                    location = location[this._prop] || 0
                }
                var scrollBarLocation = {};
                scrollBarLocation[this._prop] = this._calculateScrollBarPosition(location);
                (0, _translator.move)(this._$thumb, scrollBarLocation)
            },
            _calculateScrollBarPosition: function(location) {
                return -location * this._thumbRatio
            },
            _update: function() {
                var containerSize = Math.round(this.option("containerSize"));
                var contentSize = Math.round(this.option("contentSize"));
                var baseContainerSize = Math.round(this.option("baseContainerSize"));
                var baseContentSize = Math.round(this.option("baseContentSize"));
                if (isNaN(baseContainerSize)) {
                    baseContainerSize = containerSize;
                    baseContentSize = contentSize
                }
                this._baseContainerToContentRatio = baseContentSize ? baseContainerSize / baseContentSize : baseContainerSize;
                this._realContainerToContentRatio = contentSize ? containerSize / contentSize : containerSize;
                var thumbSize = Math.round(Math.max(Math.round(containerSize * this._realContainerToContentRatio), THUMB_MIN_SIZE));
                this._thumbRatio = (containerSize - thumbSize) / (this.option("scaleRatio") * (contentSize - containerSize));
                this.option(this._dimension, thumbSize / this.option("scaleRatio"));
                this.$element().css("display", this._needScrollbar() ? "" : "none")
            },
            _isHidden: function() {
                return this.option("visibilityMode") === SCROLLBAR_VISIBLE.never
            },
            _needScrollbar: function() {
                return !this._isHidden() && this._baseContainerToContentRatio < 1
            },
            containerToContentRatio: function() {
                return this._realContainerToContentRatio
            },
            _normalizeSize: function(size) {
                return (0, _type.isPlainObject)(size) ? size[this._dimension] || 0 : size
            },
            _clean: function() {
                this.callBase();
                if (this === activeScrollbar) {
                    activeScrollbar = null
                }
                _events_engine.default.off(this._$thumb, "." + SCROLLBAR)
            },
            _optionChanged: function(args) {
                if (this._isHidden()) {
                    return
                }
                switch (args.name) {
                    case "containerSize":
                    case "contentSize":
                        this.option()[args.name] = this._normalizeSize(args.value);
                        this._update();
                        break;
                    case "baseContentSize":
                    case "baseContainerSize":
                        this._update();
                        break;
                    case "visibilityMode":
                    case "direction":
                        this._invalidate();
                        break;
                    case "scaleRatio":
                        this._update();
                        break;
                    default:
                        this.callBase.apply(this, arguments)
                }
            },
            update: (0, _common.deferRenderer)(function() {
                this._adjustVisibility() && this.option("visible", true)
            })
        });
        _ready_callbacks.default.add(function() {
            _events_engine.default.subscribeGlobal(_dom_adapter.default.getDocument(), (0, _index.addNamespace)(_pointer.default.up, SCROLLBAR), function() {
                if (activeScrollbar) {
                    activeScrollbar.feedbackOff()
                }
            })
        });
        var _default = Scrollbar;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scroll_view/ui.scrollable.simulated.js ***!
      \****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.SimulatedStrategy = exports.Scroller = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _inflector = __webpack_require__( /*! ../../core/utils/inflector */ 39);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _position = __webpack_require__( /*! ../../core/utils/position */ 22);
        var _translator = __webpack_require__( /*! ../../animation/translator */ 28);
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _animator = _interopRequireDefault(__webpack_require__( /*! ./animator */ 350));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./ui.scrollbar */ 348));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var realDevice = _devices.default.real;
        var isSluggishPlatform = "android" === realDevice.platform;
        var SCROLLABLE_SIMULATED = "dxSimulatedScrollable";
        var SCROLLABLE_STRATEGY = "dxScrollableStrategy";
        var SCROLLABLE_SIMULATED_CURSOR = SCROLLABLE_SIMULATED + "Cursor";
        var SCROLLABLE_SIMULATED_KEYBOARD = SCROLLABLE_SIMULATED + "Keyboard";
        var SCROLLABLE_SIMULATED_CLASS = "dx-scrollable-simulated";
        var SCROLLABLE_SCROLLBARS_HIDDEN = "dx-scrollable-scrollbars-hidden";
        var SCROLLABLE_SCROLLBARS_ALWAYSVISIBLE = "dx-scrollable-scrollbars-alwaysvisible";
        var SCROLLABLE_SCROLLBAR_CLASS = "dx-scrollable-scrollbar";
        var VERTICAL = "vertical";
        var HORIZONTAL = "horizontal";
        var ACCELERATION = isSluggishPlatform ? .95 : .92;
        var OUT_BOUNDS_ACCELERATION = .5;
        var MIN_VELOCITY_LIMIT = 1;
        var FRAME_DURATION = Math.round(1e3 / 60);
        var SCROLL_LINE_HEIGHT = 40;
        var VALIDATE_WHEEL_TIMEOUT = 500;
        var BOUNCE_MIN_VELOCITY_LIMIT = MIN_VELOCITY_LIMIT / 5;
        var BOUNCE_DURATION = isSluggishPlatform ? 300 : 400;
        var BOUNCE_FRAMES = BOUNCE_DURATION / FRAME_DURATION;
        var BOUNCE_ACCELERATION_SUM = (1 - Math.pow(ACCELERATION, BOUNCE_FRAMES)) / (1 - ACCELERATION);
        var KEY_CODES = {
            PAGE_UP: "pageUp",
            PAGE_DOWN: "pageDown",
            END: "end",
            HOME: "home",
            LEFT: "leftArrow",
            UP: "upArrow",
            RIGHT: "rightArrow",
            DOWN: "downArrow",
            TAB: "tab"
        };
        var InertiaAnimator = _animator.default.inherit({
            ctor: function(scroller) {
                this.callBase();
                this.scroller = scroller
            },
            VELOCITY_LIMIT: MIN_VELOCITY_LIMIT,
            _isFinished: function() {
                return Math.abs(this.scroller._velocity) <= this.VELOCITY_LIMIT
            },
            _step: function() {
                this.scroller._scrollStep(this.scroller._velocity);
                this.scroller._velocity *= this._acceleration()
            },
            _acceleration: function() {
                return this.scroller._inBounds() ? ACCELERATION : OUT_BOUNDS_ACCELERATION
            },
            _complete: function() {
                this.scroller._scrollComplete()
            },
            _stop: function() {
                this.scroller._stopComplete()
            }
        });
        var BounceAnimator = InertiaAnimator.inherit({
            VELOCITY_LIMIT: BOUNCE_MIN_VELOCITY_LIMIT,
            _isFinished: function() {
                return this.scroller._crossBoundOnNextStep() || this.callBase()
            },
            _acceleration: function() {
                return ACCELERATION
            },
            _complete: function() {
                this.scroller._move(this.scroller._bounceLocation);
                this.callBase()
            }
        });
        var Scroller = _class.default.inherit({
            ctor: function(options) {
                this._initOptions(options);
                this._initAnimators();
                this._initScrollbar()
            },
            _initOptions: function(options) {
                var _this = this;
                this._location = 0;
                this._topReached = false;
                this._bottomReached = false;
                this._axis = options.direction === HORIZONTAL ? "x" : "y";
                this._prop = options.direction === HORIZONTAL ? "left" : "top";
                this._dimension = options.direction === HORIZONTAL ? "width" : "height";
                this._scrollProp = options.direction === HORIZONTAL ? "scrollLeft" : "scrollTop";
                (0, _iterator.each)(options, function(optionName, optionValue) {
                    _this["_" + optionName] = optionValue
                })
            },
            _initAnimators: function() {
                this._inertiaAnimator = new InertiaAnimator(this);
                this._bounceAnimator = new BounceAnimator(this)
            },
            _initScrollbar: function() {
                this._scrollbar = new _ui.default((0, _renderer.default)("<div>").appendTo(this._$container), {
                    direction: this._direction,
                    visible: this._scrollByThumb,
                    visibilityMode: this._visibilityModeNormalize(this._scrollbarVisible),
                    expandable: this._scrollByThumb
                });
                this._$scrollbar = this._scrollbar.$element()
            },
            _visibilityModeNormalize: function(mode) {
                return true === mode ? "onScroll" : false === mode ? "never" : mode
            },
            _scrollStep: function(delta) {
                var prevLocation = this._location;
                this._location += delta;
                this._suppressBounce();
                this._move();
                if (Math.abs(prevLocation - this._location) < 1) {
                    return
                }
                _events_engine.default.triggerHandler(this._$container, {
                    type: "scroll"
                })
            },
            _suppressBounce: function() {
                if (this._bounceEnabled || this._inBounds(this._location)) {
                    return
                }
                this._velocity = 0;
                this._location = this._boundLocation()
            },
            _boundLocation: function(location) {
                location = void 0 !== location ? location : this._location;
                return Math.max(Math.min(location, this._maxOffset), this._minOffset)
            },
            _move: function(location) {
                this._location = void 0 !== location ? location * this._getScaleRatio() : this._location;
                this._moveContent();
                this._moveScrollbar()
            },
            _moveContent: function() {
                var location = this._location;
                this._$container[this._scrollProp](-location / this._getScaleRatio());
                this._moveContentByTranslator(location)
            },
            _getScaleRatio: function() {
                if ((0, _window.hasWindow)() && !this._scaleRatio) {
                    var element = this._$element.get(0);
                    var realDimension = this._getRealDimension(element, this._dimension);
                    var baseDimension = this._getBaseDimension(element, this._dimension);
                    this._scaleRatio = Math.round(realDimension / baseDimension * 100) / 100
                }
                return this._scaleRatio || 1
            },
            _getRealDimension: function(element, dimension) {
                return Math.round((0, _position.getBoundingRect)(element)[dimension])
            },
            _getBaseDimension: function(element, dimension) {
                var dimensionName = "offset" + (0, _inflector.titleize)(dimension);
                return element[dimensionName]
            },
            _moveContentByTranslator: function(location) {
                var translateOffset;
                var minOffset = -this._maxScrollPropValue;
                if (location > 0) {
                    translateOffset = location
                } else {
                    if (location <= minOffset) {
                        translateOffset = location - minOffset
                    } else {
                        translateOffset = location % 1
                    }
                }
                if (this._translateOffset === translateOffset) {
                    return
                }
                var targetLocation = {};
                targetLocation[this._prop] = translateOffset;
                this._translateOffset = translateOffset;
                if (0 === translateOffset) {
                    (0, _translator.resetPosition)(this._$content);
                    return
                }(0, _translator.move)(this._$content, targetLocation)
            },
            _moveScrollbar: function() {
                this._scrollbar.moveTo(this._location)
            },
            _scrollComplete: function() {
                if (this._inBounds()) {
                    this._hideScrollbar();
                    if (this._completeDeferred) {
                        this._completeDeferred.resolve()
                    }
                }
                this._scrollToBounds()
            },
            _scrollToBounds: function() {
                if (this._inBounds()) {
                    return
                }
                this._bounceAction();
                this._setupBounce();
                this._bounceAnimator.start()
            },
            _setupBounce: function() {
                var boundLocation = this._bounceLocation = this._boundLocation();
                var bounceDistance = boundLocation - this._location;
                this._velocity = bounceDistance / BOUNCE_ACCELERATION_SUM
            },
            _inBounds: function(location) {
                location = void 0 !== location ? location : this._location;
                return this._boundLocation(location) === location
            },
            _crossBoundOnNextStep: function() {
                var location = this._location;
                var nextLocation = location + this._velocity;
                return location < this._minOffset && nextLocation >= this._minOffset || location > this._maxOffset && nextLocation <= this._maxOffset
            },
            _initHandler: function(e) {
                this._stopDeferred = new _deferred.Deferred;
                this._stopScrolling();
                this._prepareThumbScrolling(e);
                return this._stopDeferred.promise()
            },
            _stopScrolling: (0, _common.deferRenderer)(function() {
                this._hideScrollbar();
                this._inertiaAnimator.stop();
                this._bounceAnimator.stop()
            }),
            _prepareThumbScrolling: function(e) {
                if ((0, _index.isDxMouseWheelEvent)(e.originalEvent)) {
                    return
                }
                var $target = (0, _renderer.default)(e.originalEvent.target);
                var scrollbarClicked = this._isScrollbar($target);
                if (scrollbarClicked) {
                    this._moveToMouseLocation(e)
                }
                this._thumbScrolling = scrollbarClicked || this._isThumb($target);
                this._crossThumbScrolling = !this._thumbScrolling && this._isAnyThumbScrolling($target);
                if (this._thumbScrolling) {
                    this._scrollbar.feedbackOn()
                }
            },
            _isThumbScrollingHandler: function($target) {
                return this._isThumb($target)
            },
            _moveToMouseLocation: function(e) {
                var mouseLocation = e["page" + this._axis.toUpperCase()] - this._$element.offset()[this._prop];
                var location = this._location + mouseLocation / this._containerToContentRatio() - this._$container.height() / 2;
                this._scrollStep(-Math.round(location))
            },
            _stopComplete: function() {
                if (this._stopDeferred) {
                    this._stopDeferred.resolve()
                }
            },
            _startHandler: function() {
                this._showScrollbar()
            },
            _moveHandler: function(delta) {
                if (this._crossThumbScrolling) {
                    return
                }
                if (this._thumbScrolling) {
                    delta[this._axis] = -Math.round(delta[this._axis] / this._containerToContentRatio())
                }
                this._scrollBy(delta)
            },
            _scrollBy: function(delta) {
                delta = delta[this._axis];
                if (!this._inBounds()) {
                    delta *= OUT_BOUNDS_ACCELERATION
                }
                this._scrollStep(delta)
            },
            _scrollByHandler: function(delta) {
                this._scrollBy(delta);
                this._scrollComplete()
            },
            _containerToContentRatio: function() {
                return this._scrollbar.containerToContentRatio()
            },
            _endHandler: function(velocity) {
                this._completeDeferred = new _deferred.Deferred;
                this._velocity = velocity[this._axis];
                this._inertiaHandler();
                this._resetThumbScrolling();
                return this._completeDeferred.promise()
            },
            _inertiaHandler: function() {
                this._suppressInertia();
                this._inertiaAnimator.start()
            },
            _suppressInertia: function() {
                if (!this._inertiaEnabled || this._thumbScrolling) {
                    this._velocity = 0
                }
            },
            _resetThumbScrolling: function() {
                this._thumbScrolling = false;
                this._crossThumbScrolling = false
            },
            _stopHandler: function() {
                if (this._thumbScrolling) {
                    this._scrollComplete()
                }
                this._resetThumbScrolling();
                this._scrollToBounds()
            },
            _disposeHandler: function() {
                this._stopScrolling();
                this._$scrollbar.remove()
            },
            _updateHandler: function() {
                this._update();
                this._moveToBounds()
            },
            _update: function() {
                var _this2 = this;
                this._stopScrolling();
                return (0, _common.deferUpdate)(function() {
                    _this2._resetScaleRatio();
                    _this2._updateLocation();
                    _this2._updateBounds();
                    _this2._updateScrollbar();
                    (0, _common.deferRender)(function() {
                        _this2._moveScrollbar();
                        _this2._scrollbar.update()
                    })
                })
            },
            _resetScaleRatio: function() {
                this._scaleRatio = null
            },
            _updateLocation: function() {
                this._location = ((0, _translator.locate)(this._$content)[this._prop] - this._$container[this._scrollProp]()) * this._getScaleRatio()
            },
            _updateBounds: function() {
                this._maxOffset = Math.round(this._getMaxOffset());
                this._minOffset = Math.round(this._getMinOffset())
            },
            _getMaxOffset: function() {
                return 0
            },
            _getMinOffset: function() {
                this._maxScrollPropValue = Math.max(this._contentSize() - this._containerSize(), 0);
                return -this._maxScrollPropValue
            },
            _updateScrollbar: (0, _common.deferUpdater)(function() {
                var _this3 = this;
                var containerSize = this._containerSize();
                var contentSize = this._contentSize();
                var baseContainerSize = this._getBaseDimension(this._$container.get(0), this._dimension);
                var baseContentSize = this._getBaseDimension(this._$content.get(0), this._dimension);
                (0, _common.deferRender)(function() {
                    _this3._scrollbar.option({
                        containerSize: containerSize,
                        contentSize: contentSize,
                        baseContainerSize: baseContainerSize,
                        baseContentSize: baseContentSize,
                        scaleRatio: _this3._getScaleRatio()
                    })
                })
            }),
            _moveToBounds: (0, _common.deferRenderer)((0, _common.deferUpdater)((0, _common.deferRenderer)(function() {
                var location = this._boundLocation();
                var locationChanged = location !== this._location;
                this._location = location;
                this._move();
                if (locationChanged) {
                    this._scrollAction()
                }
            }))),
            _createActionsHandler: function(actions) {
                this._scrollAction = actions.scroll;
                this._bounceAction = actions.bounce
            },
            _showScrollbar: function() {
                this._scrollbar.option("visible", true)
            },
            _hideScrollbar: function() {
                this._scrollbar.option("visible", false)
            },
            _containerSize: function() {
                return this._getRealDimension(this._$container.get(0), this._dimension)
            },
            _contentSize: function() {
                var isOverflowHidden = "hidden" === this._$content.css("overflow" + this._axis.toUpperCase());
                var contentSize = this._getRealDimension(this._$content.get(0), this._dimension);
                if (!isOverflowHidden) {
                    var containerScrollSize = this._$content[0]["scroll" + (0, _inflector.titleize)(this._dimension)] * this._getScaleRatio();
                    contentSize = Math.max(containerScrollSize, contentSize)
                }
                return contentSize
            },
            _validateEvent: function(e) {
                var $target = (0, _renderer.default)(e.originalEvent.target);
                return this._isThumb($target) || this._isScrollbar($target) || this._isContent($target)
            },
            _isThumb: function($element) {
                return this._scrollByThumb && this._scrollbar.isThumb($element)
            },
            _isScrollbar: function($element) {
                return this._scrollByThumb && $element && $element.is(this._$scrollbar)
            },
            _isContent: function($element) {
                return this._scrollByContent && !!$element.closest(this._$element).length
            },
            _reachedMin: function() {
                return this._location <= this._minOffset
            },
            _reachedMax: function() {
                return this._location >= this._maxOffset
            },
            _cursorEnterHandler: function() {
                this._resetScaleRatio();
                this._updateScrollbar();
                this._scrollbar.cursorEnter()
            },
            _cursorLeaveHandler: function() {
                this._scrollbar.cursorLeave()
            },
            dispose: _common.noop
        });
        exports.Scroller = Scroller;
        var hoveredScrollable;
        var activeScrollable;
        var SimulatedStrategy = _class.default.inherit({
            ctor: function(scrollable) {
                this._init(scrollable)
            },
            _init: function(scrollable) {
                this._component = scrollable;
                this._$element = scrollable.$element();
                this._$container = scrollable._$container;
                this._$wrapper = scrollable._$wrapper;
                this._$content = scrollable._$content;
                this.option = scrollable.option.bind(scrollable);
                this._createActionByOption = scrollable._createActionByOption.bind(scrollable);
                this._isLocked = scrollable._isLocked.bind(scrollable);
                this._isDirection = scrollable._isDirection.bind(scrollable);
                this._allowedDirection = scrollable._allowedDirection.bind(scrollable);
                this._getScrollOffset = scrollable._getScrollOffset.bind(scrollable)
            },
            render: function() {
                this._$element.addClass(SCROLLABLE_SIMULATED_CLASS);
                this._createScrollers();
                if (this.option("useKeyboard")) {
                    this._$container.prop("tabIndex", 0)
                }
                this._attachKeyboardHandler();
                this._attachCursorHandlers()
            },
            _createScrollers: function() {
                this._scrollers = {};
                if (this._isDirection(HORIZONTAL)) {
                    this._createScroller(HORIZONTAL)
                }
                if (this._isDirection(VERTICAL)) {
                    this._createScroller(VERTICAL)
                }
                this._$element.toggleClass(SCROLLABLE_SCROLLBARS_ALWAYSVISIBLE, "always" === this.option("showScrollbar"));
                this._$element.toggleClass(SCROLLABLE_SCROLLBARS_HIDDEN, !this.option("showScrollbar"))
            },
            _createScroller: function(direction) {
                this._scrollers[direction] = new Scroller(this._scrollerOptions(direction))
            },
            _scrollerOptions: function(direction) {
                return {
                    direction: direction,
                    $content: this._$content,
                    $container: this._$container,
                    $wrapper: this._$wrapper,
                    $element: this._$element,
                    scrollByContent: this.option("scrollByContent"),
                    scrollByThumb: this.option("scrollByThumb"),
                    scrollbarVisible: this.option("showScrollbar"),
                    bounceEnabled: this.option("bounceEnabled"),
                    inertiaEnabled: this.option("inertiaEnabled"),
                    isAnyThumbScrolling: this._isAnyThumbScrolling.bind(this)
                }
            },
            _applyScaleRatio: function(targetLocation) {
                for (var direction in this._scrollers) {
                    var prop = this._getPropByDirection(direction);
                    if ((0, _type.isDefined)(targetLocation[prop])) {
                        var scroller = this._scrollers[direction];
                        targetLocation[prop] *= scroller._getScaleRatio()
                    }
                }
                return targetLocation
            },
            _isAnyThumbScrolling: function($target) {
                var result = false;
                this._eventHandler("isThumbScrolling", $target).done(function(isThumbScrollingVertical, isThumbScrollingHorizontal) {
                    result = isThumbScrollingVertical || isThumbScrollingHorizontal
                });
                return result
            },
            handleInit: function(e) {
                this._suppressDirections(e);
                this._eventForUserAction = e;
                this._eventHandler("init", e).done(this._stopAction)
            },
            _suppressDirections: function(e) {
                if ((0, _index.isDxMouseWheelEvent)(e.originalEvent)) {
                    this._prepareDirections(true);
                    return
                }
                this._prepareDirections();
                this._eachScroller(function(scroller, direction) {
                    var isValid = scroller._validateEvent(e);
                    this._validDirections[direction] = isValid
                })
            },
            _prepareDirections: function(value) {
                value = value || false;
                this._validDirections = {};
                this._validDirections[HORIZONTAL] = value;
                this._validDirections[VERTICAL] = value
            },
            _eachScroller: function(callback) {
                callback = callback.bind(this);
                (0, _iterator.each)(this._scrollers, function(direction, scroller) {
                    callback(scroller, direction)
                })
            },
            handleStart: function(e) {
                this._eventForUserAction = e;
                this._eventHandler("start").done(this._startAction)
            },
            _saveActive: function() {
                activeScrollable = this
            },
            _resetActive: function() {
                if (activeScrollable === this) {
                    activeScrollable = null
                }
            },
            handleMove: function(e) {
                if (this._isLocked()) {
                    e.cancel = true;
                    this._resetActive();
                    return
                }
                this._saveActive();
                e.preventDefault && e.preventDefault();
                this._adjustDistance(e, e.delta);
                this._eventForUserAction = e;
                this._eventHandler("move", e.delta)
            },
            _adjustDistance: function(e, distance) {
                distance.x *= this._validDirections[HORIZONTAL];
                distance.y *= this._validDirections[VERTICAL];
                var devicePixelRatio = this._tryGetDevicePixelRatio();
                if (devicePixelRatio && (0, _index.isDxMouseWheelEvent)(e.originalEvent)) {
                    distance.x = Math.round(distance.x / devicePixelRatio * 100) / 100;
                    distance.y = Math.round(distance.y / devicePixelRatio * 100) / 100
                }
            },
            _tryGetDevicePixelRatio: function() {
                if ((0, _window.hasWindow)()) {
                    return (0, _window.getWindow)().devicePixelRatio
                }
            },
            handleEnd: function(e) {
                this._resetActive();
                this._refreshCursorState(e.originalEvent && e.originalEvent.target);
                this._adjustDistance(e, e.velocity);
                this._eventForUserAction = e;
                return this._eventHandler("end", e.velocity).done(this._endAction)
            },
            handleCancel: function(e) {
                this._resetActive();
                this._eventForUserAction = e;
                return this._eventHandler("end", {
                    x: 0,
                    y: 0
                })
            },
            handleStop: function() {
                this._resetActive();
                this._eventHandler("stop")
            },
            handleScroll: function() {
                this._component._updateRtlConfig();
                this._scrollAction()
            },
            _attachKeyboardHandler: function() {
                _events_engine.default.off(this._$element, ".".concat(SCROLLABLE_SIMULATED_KEYBOARD));
                if (!this.option("disabled") && this.option("useKeyboard")) {
                    _events_engine.default.on(this._$element, (0, _index.addNamespace)("keydown", SCROLLABLE_SIMULATED_KEYBOARD), this._keyDownHandler.bind(this))
                }
            },
            _keyDownHandler: function(e) {
                var _this4 = this;
                clearTimeout(this._updateHandlerTimeout);
                this._updateHandlerTimeout = setTimeout(function() {
                    if ((0, _index.normalizeKeyName)(e) === KEY_CODES.TAB) {
                        _this4._eachScroller(function(scroller) {
                            scroller._updateHandler()
                        })
                    }
                });
                if (!this._$container.is(_dom_adapter.default.getActiveElement())) {
                    return
                }
                var handled = true;
                switch ((0, _index.normalizeKeyName)(e)) {
                    case KEY_CODES.DOWN:
                        this._scrollByLine({
                            y: 1
                        });
                        break;
                    case KEY_CODES.UP:
                        this._scrollByLine({
                            y: -1
                        });
                        break;
                    case KEY_CODES.RIGHT:
                        this._scrollByLine({
                            x: 1
                        });
                        break;
                    case KEY_CODES.LEFT:
                        this._scrollByLine({
                            x: -1
                        });
                        break;
                    case KEY_CODES.PAGE_DOWN:
                        this._scrollByPage(1);
                        break;
                    case KEY_CODES.PAGE_UP:
                        this._scrollByPage(-1);
                        break;
                    case KEY_CODES.HOME:
                        this._scrollToHome();
                        break;
                    case KEY_CODES.END:
                        this._scrollToEnd();
                        break;
                    default:
                        handled = false
                }
                if (handled) {
                    e.stopPropagation();
                    e.preventDefault()
                }
            },
            _scrollByLine: function(lines) {
                var devicePixelRatio = this._tryGetDevicePixelRatio();
                var scrollOffset = SCROLL_LINE_HEIGHT;
                if (devicePixelRatio) {
                    scrollOffset = Math.abs(scrollOffset / devicePixelRatio * 100) / 100
                }
                this.scrollBy({
                    top: (lines.y || 0) * -scrollOffset,
                    left: (lines.x || 0) * -scrollOffset
                })
            },
            _scrollByPage: function(page) {
                var prop = this._wheelProp();
                var dimension = this._dimensionByProp(prop);
                var distance = {};
                distance[prop] = page * -this._$container[dimension]();
                this.scrollBy(distance)
            },
            _dimensionByProp: function(prop) {
                return "left" === prop ? "width" : "height"
            },
            _getPropByDirection: function(direction) {
                return direction === HORIZONTAL ? "left" : "top"
            },
            _scrollToHome: function() {
                var prop = this._wheelProp();
                var distance = {};
                distance[prop] = 0;
                this._component.scrollTo(distance)
            },
            _scrollToEnd: function() {
                var prop = this._wheelProp();
                var dimension = this._dimensionByProp(prop);
                var distance = {};
                distance[prop] = this._$content[dimension]() - this._$container[dimension]();
                this._component.scrollTo(distance)
            },
            createActions: function() {
                this._startAction = this._createActionHandler("onStart");
                this._stopAction = this._createActionHandler("onStop");
                this._endAction = this._createActionHandler("onEnd");
                this._updateAction = this._createActionHandler("onUpdated");
                this._createScrollerActions()
            },
            _createScrollerActions: function() {
                this._scrollAction = this._createActionHandler("onScroll");
                this._bounceAction = this._createActionHandler("onBounce");
                this._eventHandler("createActions", {
                    scroll: this._scrollAction,
                    bounce: this._bounceAction
                })
            },
            _createActionHandler: function(optionName) {
                var _arguments = arguments,
                    _this5 = this;
                var actionHandler = this._createActionByOption(optionName);
                return function() {
                    actionHandler((0, _extend.extend)(_this5._createActionArgs(), _arguments))
                }
            },
            _createActionArgs: function() {
                var _this$_scrollers = this._scrollers,
                    scrollerX = _this$_scrollers.horizontal,
                    scrollerY = _this$_scrollers.vertical;
                var offset = this._getScrollOffset();
                this._scrollOffset = {
                    top: scrollerY && offset.top,
                    left: scrollerX && offset.left
                };
                return {
                    event: this._eventForUserAction,
                    scrollOffset: this._scrollOffset,
                    reachedLeft: scrollerX && scrollerX._reachedMax(),
                    reachedRight: scrollerX && scrollerX._reachedMin(),
                    reachedTop: scrollerY && scrollerY._reachedMax(),
                    reachedBottom: scrollerY && scrollerY._reachedMin()
                }
            },
            _eventHandler: function(eventName) {
                var args = [].slice.call(arguments).slice(1);
                var deferreds = (0, _iterator.map)(this._scrollers, function(scroller) {
                    return scroller["_" + eventName + "Handler"].apply(scroller, args)
                });
                return _deferred.when.apply(_renderer.default, deferreds).promise()
            },
            location: function location() {
                var location = (0, _translator.locate)(this._$content);
                location.top -= this._$container.scrollTop();
                location.left -= this._$container.scrollLeft();
                return location
            },
            disabledChanged: function() {
                this._attachCursorHandlers()
            },
            _attachCursorHandlers: function() {
                _events_engine.default.off(this._$element, ".".concat(SCROLLABLE_SIMULATED_CURSOR));
                if (!this.option("disabled") && this._isHoverMode()) {
                    _events_engine.default.on(this._$element, (0, _index.addNamespace)("mouseenter", SCROLLABLE_SIMULATED_CURSOR), this._cursorEnterHandler.bind(this));
                    _events_engine.default.on(this._$element, (0, _index.addNamespace)("mouseleave", SCROLLABLE_SIMULATED_CURSOR), this._cursorLeaveHandler.bind(this))
                }
            },
            _isHoverMode: function() {
                return "onHover" === this.option("showScrollbar")
            },
            _cursorEnterHandler: function(e) {
                e = e || {};
                e.originalEvent = e.originalEvent || {};
                if (activeScrollable || e.originalEvent._hoverHandled) {
                    return
                }
                if (hoveredScrollable) {
                    hoveredScrollable._cursorLeaveHandler()
                }
                hoveredScrollable = this;
                this._eventHandler("cursorEnter");
                e.originalEvent._hoverHandled = true
            },
            _cursorLeaveHandler: function(e) {
                if (hoveredScrollable !== this || activeScrollable === hoveredScrollable) {
                    return
                }
                this._eventHandler("cursorLeave");
                hoveredScrollable = null;
                this._refreshCursorState(e && e.relatedTarget)
            },
            _refreshCursorState: function(target) {
                if (!this._isHoverMode() && (!target || activeScrollable)) {
                    return
                }
                var $target = (0, _renderer.default)(target);
                var $scrollable = $target.closest(".".concat(SCROLLABLE_SIMULATED_CLASS, ":not(.dx-state-disabled)"));
                var targetScrollable = $scrollable.length && $scrollable.data(SCROLLABLE_STRATEGY);
                if (hoveredScrollable && hoveredScrollable !== targetScrollable) {
                    hoveredScrollable._cursorLeaveHandler()
                }
                if (targetScrollable) {
                    targetScrollable._cursorEnterHandler()
                }
            },
            update: function() {
                var _this6 = this;
                var result = this._eventHandler("update").done(this._updateAction);
                return (0, _deferred.when)(result, (0, _common.deferUpdate)(function() {
                    var allowedDirections = _this6._allowedDirections();
                    (0, _common.deferRender)(function() {
                        var touchDirection = allowedDirections.vertical ? "pan-x" : "";
                        touchDirection = allowedDirections.horizontal ? "pan-y" : touchDirection;
                        touchDirection = allowedDirections.vertical && allowedDirections.horizontal ? "none" : touchDirection;
                        _this6._$container.css("touchAction", touchDirection)
                    });
                    return (0, _deferred.when)().promise()
                }))
            },
            _allowedDirections: function() {
                var bounceEnabled = this.option("bounceEnabled");
                var verticalScroller = this._scrollers[VERTICAL];
                var horizontalScroller = this._scrollers[HORIZONTAL];
                return {
                    vertical: verticalScroller && (verticalScroller._minOffset < 0 || bounceEnabled),
                    horizontal: horizontalScroller && (horizontalScroller._minOffset < 0 || bounceEnabled)
                }
            },
            updateBounds: function() {
                this._scrollers[HORIZONTAL] && this._scrollers[HORIZONTAL]._updateBounds()
            },
            scrollBy: function(distance) {
                var verticalScroller = this._scrollers[VERTICAL];
                var horizontalScroller = this._scrollers[HORIZONTAL];
                if (verticalScroller) {
                    distance.top = verticalScroller._boundLocation(distance.top + verticalScroller._location) - verticalScroller._location
                }
                if (horizontalScroller) {
                    distance.left = horizontalScroller._boundLocation(distance.left + horizontalScroller._location) - horizontalScroller._location
                }
                this._prepareDirections(true);
                this._startAction();
                this._eventHandler("scrollBy", {
                    x: distance.left,
                    y: distance.top
                });
                this._endAction()
            },
            validate: function(e) {
                if ((0, _index.isDxMouseWheelEvent)(e) && (0, _index.isCommandKeyPressed)(e)) {
                    return false
                }
                if (this.option("disabled")) {
                    return false
                }
                if (this.option("bounceEnabled")) {
                    return true
                }
                return (0, _index.isDxMouseWheelEvent)(e) ? this._validateWheel(e) : this._validateMove(e)
            },
            _validateWheel: function(e) {
                var _this7 = this;
                var scroller = this._scrollers[this._wheelDirection(e)];
                var reachedMin = scroller._reachedMin();
                var reachedMax = scroller._reachedMax();
                var contentGreaterThanContainer = !reachedMin || !reachedMax;
                var locatedNotAtBound = !reachedMin && !reachedMax;
                var scrollFromMin = reachedMin && e.delta > 0;
                var scrollFromMax = reachedMax && e.delta < 0;
                var validated = contentGreaterThanContainer && (locatedNotAtBound || scrollFromMin || scrollFromMax);
                validated = validated || void 0 !== this._validateWheelTimer;
                if (validated) {
                    clearTimeout(this._validateWheelTimer);
                    this._validateWheelTimer = setTimeout(function() {
                        _this7._validateWheelTimer = void 0
                    }, VALIDATE_WHEEL_TIMEOUT)
                }
                return validated
            },
            _validateMove: function(e) {
                if (!this.option("scrollByContent") && !(0, _renderer.default)(e.target).closest(".".concat(SCROLLABLE_SCROLLBAR_CLASS)).length) {
                    return false
                }
                return this._allowedDirection()
            },
            getDirection: function(e) {
                return (0, _index.isDxMouseWheelEvent)(e) ? this._wheelDirection(e) : this._allowedDirection()
            },
            _wheelProp: function() {
                return this._wheelDirection() === HORIZONTAL ? "left" : "top"
            },
            _wheelDirection: function(e) {
                switch (this.option("direction")) {
                    case HORIZONTAL:
                        return HORIZONTAL;
                    case VERTICAL:
                        return VERTICAL;
                    default:
                        return e && e.shiftKey ? HORIZONTAL : VERTICAL
                }
            },
            verticalOffset: function() {
                return 0
            },
            dispose: function() {
                this._resetActive();
                if (hoveredScrollable === this) {
                    hoveredScrollable = null
                }
                this._eventHandler("dispose");
                this._detachEventHandlers();
                this._$element.removeClass(SCROLLABLE_SIMULATED_CLASS);
                this._eventForUserAction = null;
                clearTimeout(this._validateWheelTimer);
                clearTimeout(this._updateHandlerTimeout)
            },
            _detachEventHandlers: function() {
                _events_engine.default.off(this._$element, ".".concat(SCROLLABLE_SIMULATED_CURSOR));
                _events_engine.default.off(this._$container, ".".concat(SCROLLABLE_SIMULATED_KEYBOARD))
            }
        });
        exports.SimulatedStrategy = SimulatedStrategy
    },
    /*!*************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scroll_view/animator.js ***!
      \*************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _frame = __webpack_require__( /*! ../../animation/frame */ 129);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var abstract = _class.default.abstract;
        var Animator = _class.default.inherit({
            ctor: function() {
                this._finished = true;
                this._stopped = false;
                this._proxiedStepCore = this._stepCore.bind(this)
            },
            start: function() {
                this._stopped = false;
                this._finished = false;
                this._stepCore()
            },
            stop: function() {
                this._stopped = true;
                (0, _frame.cancelAnimationFrame)(this._stepAnimationFrame)
            },
            _stepCore: function() {
                if (this._isStopped()) {
                    this._stop();
                    return
                }
                if (this._isFinished()) {
                    this._finished = true;
                    this._complete();
                    return
                }
                this._step();
                this._stepAnimationFrame = (0, _frame.requestAnimationFrame)(this._proxiedStepCore)
            },
            _step: abstract,
            _isFinished: _common.noop,
            _stop: _common.noop,
            _complete: _common.noop,
            _isStopped: function() {
                return this._stopped
            },
            inProgress: function() {
                return !(this._stopped || this._finished)
            }
        });
        var _default = Animator;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scroll_view/ui.scrollable.device.js ***!
      \*************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.deviceDependentOptions = void 0;
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _support = __webpack_require__( /*! ../../core/utils/support */ 45);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var deviceDependentOptions = function() {
            return [{
                device: function() {
                    return !_support.nativeScrolling
                },
                options: {
                    useNative: false
                }
            }, {
                device: function(_device) {
                    return !_devices.default.isSimulator() && "desktop" === _devices.default.real().deviceType && "generic" === _device.platform
                },
                options: {
                    bounceEnabled: false,
                    scrollByThumb: true,
                    scrollByContent: _support.touch,
                    showScrollbar: "onHover"
                }
            }]
        };
        exports.deviceDependentOptions = deviceDependentOptions
    },
    /*!*********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/drop_down_button.js ***!
      \*********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./widget/ui.widget */ 16));
        var _function_template = __webpack_require__( /*! ../core/templates/function_template */ 126);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _button_group = _interopRequireDefault(__webpack_require__( /*! ./button_group */ 276));
        var _popup = _interopRequireDefault(__webpack_require__( /*! ./popup */ 46));
        var _list = _interopRequireDefault(__webpack_require__( /*! ./list */ 112));
        var _data = __webpack_require__( /*! ../core/utils/data */ 20);
        var _element = __webpack_require__( /*! ../core/element */ 18);
        var _icon = __webpack_require__( /*! ../core/utils/icon */ 56);
        var _data_helper = _interopRequireDefault(__webpack_require__( /*! ../data_helper */ 92));
        var _data_source = __webpack_require__( /*! ../data/data_source/data_source */ 68);
        var _array_store = _interopRequireDefault(__webpack_require__( /*! ../data/array_store */ 77));
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _guid = _interopRequireDefault(__webpack_require__( /*! ../core/guid */ 36));
        var _utils = __webpack_require__( /*! ./drop_down_editor/utils */ 208);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../localization/message */ 10));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DROP_DOWN_BUTTON_CLASS = "dx-dropdownbutton";
        var DROP_DOWN_BUTTON_CONTENT = "dx-dropdownbutton-content";
        var DROP_DOWN_BUTTON_ACTION_CLASS = "dx-dropdownbutton-action";
        var DROP_DOWN_BUTTON_TOGGLE_CLASS = "dx-dropdownbutton-toggle";
        var DROP_DOWN_BUTTON_HAS_ARROW_CLASS = "dx-dropdownbutton-has-arrow";
        var DROP_DOWN_BUTTON_POPUP_WRAPPER_CLASS = "dx-dropdownbutton-popup-wrapper";
        var DX_BUTTON_TEXT_CLASS = "dx-button-text";
        var DX_ICON_RIGHT_CLASS = "dx-icon-right";
        var DropDownButton = _ui.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    itemTemplate: "item",
                    keyExpr: "this",
                    displayExpr: "this",
                    selectedItem: null,
                    selectedItemKey: null,
                    stylingMode: "outlined",
                    deferRendering: true,
                    noDataText: _message.default.format("dxCollectionWidget-noDataText"),
                    useSelectMode: false,
                    splitButton: false,
                    showArrowIcon: true,
                    text: "",
                    icon: void 0,
                    onButtonClick: null,
                    onSelectionChanged: null,
                    onItemClick: null,
                    opened: false,
                    items: null,
                    dataSource: null,
                    focusStateEnabled: true,
                    hoverStateEnabled: true,
                    dropDownOptions: {},
                    dropDownContentTemplate: "content",
                    wrapItemText: false,
                    grouped: false,
                    groupTemplate: "group",
                    buttonGroupOptions: {}
                })
            },
            _setOptionsByReference: function() {
                this.callBase();
                (0, _extend.extend)(this._optionsByReference, {
                    selectedItem: true
                })
            },
            _init: function() {
                this.callBase();
                this._createItemClickAction();
                this._createActionClickAction();
                this._createSelectionChangedAction();
                this._initDataSource();
                this._compileKeyGetter();
                this._compileDisplayGetter();
                this._itemsToDataSource(this.option("items"));
                this._options.cache("buttonGroupOptions", this.option("buttonGroupOptions"));
                this._options.cache("dropDownOptions", this.option("dropDownOptions"))
            },
            _initTemplates: function() {
                var _this = this;
                this._templateManager.addDefaultTemplates({
                    content: new _function_template.FunctionTemplate(function(options) {
                        var $popupContent = (0, _renderer.default)(options.container);
                        var $listContainer = (0, _renderer.default)("<div>").appendTo($popupContent);
                        _this._list = _this._createComponent($listContainer, _list.default, _this._listOptions());
                        _this._list.registerKeyHandler("escape", _this._escHandler.bind(_this));
                        _this._list.registerKeyHandler("tab", _this._escHandler.bind(_this));
                        _this._list.registerKeyHandler("leftArrow", _this._escHandler.bind(_this));
                        _this._list.registerKeyHandler("rightArrow", _this._escHandler.bind(_this))
                    })
                });
                this.callBase()
            },
            _itemsToDataSource: function(value) {
                if (!this._dataSource) {
                    this._dataSource = new _data_source.DataSource({
                        store: new _array_store.default({
                            key: this._getKey(),
                            data: value
                        }),
                        pageSize: 0
                    })
                }
            },
            _getKey: function() {
                var _this$_dataSource;
                var keyExpr = this.option("keyExpr");
                var storeKey = null === (_this$_dataSource = this._dataSource) || void 0 === _this$_dataSource ? void 0 : _this$_dataSource.key();
                return (0, _type.isDefined)(storeKey) && (!(0, _type.isDefined)(keyExpr) || "this" === keyExpr) ? storeKey : keyExpr
            },
            _compileKeyGetter: function() {
                this._keyGetter = (0, _data.compileGetter)(this._getKey())
            },
            _compileDisplayGetter: function() {
                this._displayGetter = (0, _data.compileGetter)(this.option("displayExpr"))
            },
            _initMarkup: function() {
                this.callBase();
                this.$element().addClass(DROP_DOWN_BUTTON_CLASS);
                this._renderButtonGroup();
                this._updateArrowClass();
                if ((0, _type.isDefined)(this.option("selectedItemKey"))) {
                    this._loadSelectedItem().done(this._updateActionButton.bind(this))
                }
            },
            _renderFocusTarget: _common.noop,
            _render: function() {
                if (!this.option("deferRendering") || this.option("opened")) {
                    this._renderPopup()
                }
                this.callBase()
            },
            _renderContentImpl: function() {
                if (this._popup) {
                    this._renderPopupContent()
                }
                return this.callBase()
            },
            _loadSelectedItem: function() {
                var d = new _deferred.Deferred;
                if (this._list && void 0 !== this._lastSelectedItemData) {
                    var cachedResult = this.option("useSelectMode") ? this._list.option("selectedItem") : this._lastSelectedItemData;
                    return d.resolve(cachedResult)
                }
                this._lastSelectedItemData = void 0;
                var selectedItemKey = this.option("selectedItemKey");
                this._loadSingle(this._getKey(), selectedItemKey).done(d.resolve).fail(function() {
                    d.resolve(null)
                });
                return d.promise()
            },
            _createActionClickAction: function() {
                this._actionClickAction = this._createActionByOption("onButtonClick")
            },
            _createSelectionChangedAction: function() {
                this._selectionChangedAction = this._createActionByOption("onSelectionChanged")
            },
            _createItemClickAction: function() {
                this._itemClickAction = this._createActionByOption("onItemClick")
            },
            _fireSelectionChangedAction: function(_ref) {
                var previousValue = _ref.previousValue,
                    value = _ref.value;
                this._selectionChangedAction({
                    item: value,
                    previousItem: previousValue
                })
            },
            _fireItemClickAction: function(_ref2) {
                var event = _ref2.event,
                    itemElement = _ref2.itemElement,
                    itemData = _ref2.itemData;
                return this._itemClickAction({
                    event: event,
                    itemElement: itemElement,
                    itemData: this._actionItem || itemData
                })
            },
            _actionButtonConfig: function() {
                return {
                    text: this.option("text"),
                    icon: this.option("icon"),
                    elementAttr: {
                        "class": DROP_DOWN_BUTTON_ACTION_CLASS
                    }
                }
            },
            _getButtonGroupItems: function() {
                var items = [];
                items.push(this._actionButtonConfig());
                if (this.option("splitButton")) {
                    items.push({
                        icon: "spindown",
                        elementAttr: {
                            "class": DROP_DOWN_BUTTON_TOGGLE_CLASS
                        }
                    })
                }
                return items
            },
            _buttonGroupItemClick: function(_ref3) {
                var event = _ref3.event,
                    itemData = _ref3.itemData;
                var isActionButton = itemData.elementAttr.class === DROP_DOWN_BUTTON_ACTION_CLASS;
                var isToggleButton = itemData.elementAttr.class === DROP_DOWN_BUTTON_TOGGLE_CLASS;
                if (isToggleButton) {
                    this.toggle()
                } else {
                    if (isActionButton) {
                        this._actionClickAction({
                            event: event,
                            selectedItem: this.option("selectedItem")
                        });
                        if (!this.option("splitButton")) {
                            this.toggle()
                        }
                    }
                }
            },
            _buttonGroupOptions: function() {
                var _this2 = this;
                return (0, _extend.extend)({
                    items: this._getButtonGroupItems(),
                    focusStateEnabled: this.option("focusStateEnabled"),
                    hoverStateEnabled: this.option("hoverStateEnabled"),
                    onItemClick: this._buttonGroupItemClick.bind(this),
                    width: "100%",
                    height: "100%",
                    stylingMode: this.option("stylingMode"),
                    selectionMode: "none",
                    tabIndex: this.option("tabIndex"),
                    onKeyboardHandled: function(e) {
                        return _this2._keyboardHandler(e)
                    },
                    buttonTemplate: function(_ref4, buttonContent) {
                        var text = _ref4.text,
                            icon = _ref4.icon;
                        if (_this2.option("splitButton") || !_this2.option("showArrowIcon")) {
                            return "content"
                        }
                        var $firstIcon = (0, _icon.getImageContainer)(icon);
                        var $textContainer = text ? (0, _renderer.default)("<span>").text(text).addClass(DX_BUTTON_TEXT_CLASS) : void 0;
                        var $secondIcon = (0, _icon.getImageContainer)("spindown").addClass(DX_ICON_RIGHT_CLASS);
                        (0, _renderer.default)(buttonContent).append($firstIcon, $textContainer, $secondIcon)
                    }
                }, this._options.cache("buttonGroupOptions"))
            },
            _renderPopupContent: function() {
                var $content = this._popup.$content();
                var template = this._getTemplateByOption("dropDownContentTemplate");
                $content.empty();
                this._popupContentId = "dx-" + new _guid.default;
                this.setAria("id", this._popupContentId, $content);
                return template.render({
                    container: (0, _element.getPublicElement)($content),
                    model: this.option("items") || this._dataSource
                })
            },
            _popupOptions: function() {
                var _this3 = this;
                var horizontalAlignment = this.option("rtlEnabled") ? "right" : "left";
                return (0, _extend.extend)({
                    dragEnabled: false,
                    focusStateEnabled: false,
                    deferRendering: this.option("deferRendering"),
                    closeOnOutsideClick: function(e) {
                        var $element = _this3.$element();
                        var $buttonClicked = (0, _renderer.default)(e.target).closest(".".concat(DROP_DOWN_BUTTON_CLASS));
                        return !$buttonClicked.is($element)
                    },
                    showTitle: false,
                    animation: {
                        show: {
                            type: "fade",
                            duration: 0,
                            from: 0,
                            to: 1
                        },
                        hide: {
                            type: "fade",
                            duration: 400,
                            from: 1,
                            to: 0
                        }
                    },
                    width: function() {
                        return (0, _utils.getElementWidth)(_this3.$element())
                    },
                    height: "auto",
                    shading: false,
                    position: {
                        of: this.$element(),
                        collision: "flipfit",
                        my: horizontalAlignment + " top",
                        at: horizontalAlignment + " bottom"
                    }
                }, this._options.cache("dropDownOptions"), {
                    visible: this.option("opened")
                })
            },
            _listOptions: function() {
                var _this4 = this;
                var selectedItemKey = this.option("selectedItemKey");
                var useSelectMode = this.option("useSelectMode");
                return {
                    selectionMode: useSelectMode ? "single" : "none",
                    wrapItemText: this.option("wrapItemText"),
                    focusStateEnabled: this.option("focusStateEnabled"),
                    hoverStateEnabled: this.option("hoverStateEnabled"),
                    showItemDataTitle: true,
                    onContentReady: function() {
                        return _this4._fireContentReadyAction()
                    },
                    selectedItemKeys: (0, _type.isDefined)(selectedItemKey) && useSelectMode ? [selectedItemKey] : [],
                    grouped: this.option("grouped"),
                    groupTemplate: this.option("groupTemplate"),
                    keyExpr: this._getKey(),
                    noDataText: this.option("noDataText"),
                    displayExpr: this.option("displayExpr"),
                    itemTemplate: this.option("itemTemplate"),
                    items: this.option("items"),
                    dataSource: this._dataSource,
                    onItemClick: function(e) {
                        if (!_this4.option("useSelectMode")) {
                            _this4._lastSelectedItemData = e.itemData
                        }
                        _this4.option("selectedItemKey", _this4._keyGetter(e.itemData));
                        var actionResult = _this4._fireItemClickAction(e);
                        if (false !== actionResult) {
                            _this4.toggle(false);
                            _this4._buttonGroup.focus()
                        }
                    }
                }
            },
            _upDownKeyHandler: function() {
                if (this._popup && this._popup.option("visible") && this._list) {
                    this._list.focus()
                } else {
                    this.open()
                }
                return true
            },
            _escHandler: function() {
                this.close();
                this._buttonGroup.focus();
                return true
            },
            _tabHandler: function() {
                this.close();
                return true
            },
            _renderPopup: function() {
                var $popup = (0, _renderer.default)("<div>");
                this.$element().append($popup);
                this._popup = this._createComponent($popup, _popup.default, this._popupOptions());
                this._popup.$content().addClass(DROP_DOWN_BUTTON_CONTENT);
                this._popup._wrapper().addClass(DROP_DOWN_BUTTON_POPUP_WRAPPER_CLASS);
                this._popup.on("hiding", this._popupHidingHandler.bind(this));
                this._popup.on("showing", this._popupShowingHandler.bind(this));
                this._bindInnerWidgetOptions(this._popup, "dropDownOptions")
            },
            _popupHidingHandler: function() {
                this.option("opened", false);
                this.setAria({
                    expanded: false,
                    owns: void 0
                })
            },
            _popupOptionChanged: function(args) {
                var options = _ui.default.getOptionsFromContainer(args);
                this._setPopupOption(options);
                var optionsKeys = Object.keys(options);
                if (optionsKeys.indexOf("width") !== -1 || optionsKeys.indexOf("height") !== -1) {
                    this._dimensionChanged()
                }
            },
            _dimensionChanged: function() {
                var _this5 = this;
                var popupWidth = (0, _utils.getSizeValue)(this.option("dropDownOptions.width"));
                if (void 0 === popupWidth) {
                    this._setPopupOption("width", function() {
                        return (0, _utils.getElementWidth)(_this5.$element())
                    })
                }
            },
            _setPopupOption: function(optionName, value) {
                this._setWidgetOption("_popup", arguments)
            },
            _popupShowingHandler: function() {
                this.option("opened", true);
                this.setAria({
                    expanded: true,
                    owns: this._popupContentId
                })
            },
            _renderButtonGroup: function() {
                var $buttonGroup = this._buttonGroup && this._buttonGroup.$element() || (0, _renderer.default)("<div>");
                if (!this._buttonGroup) {
                    this.$element().append($buttonGroup)
                }
                this._buttonGroup = this._createComponent($buttonGroup, _button_group.default, this._buttonGroupOptions());
                this._buttonGroup.registerKeyHandler("downArrow", this._upDownKeyHandler.bind(this));
                this._buttonGroup.registerKeyHandler("tab", this._tabHandler.bind(this));
                this._buttonGroup.registerKeyHandler("upArrow", this._upDownKeyHandler.bind(this));
                this._buttonGroup.registerKeyHandler("escape", this._escHandler.bind(this));
                this._bindInnerWidgetOptions(this._buttonGroup, "buttonGroupOptions")
            },
            _updateArrowClass: function() {
                var hasArrow = this.option("splitButton") || this.option("showArrowIcon");
                this.$element().toggleClass(DROP_DOWN_BUTTON_HAS_ARROW_CLASS, hasArrow)
            },
            toggle: function(visible) {
                if (!this._popup) {
                    this._renderPopup();
                    this._renderContent()
                }
                return this._popup.toggle(visible)
            },
            open: function() {
                return this.toggle(true)
            },
            close: function() {
                return this.toggle(false)
            },
            _setListOption: function(name, value) {
                this._list && this._list.option(name, value)
            },
            _getDisplayValue: function(item) {
                var isPrimitiveItem = !(0, _type.isPlainObject)(item);
                var displayValue = isPrimitiveItem ? item : this._displayGetter(item);
                return !(0, _type.isPlainObject)(displayValue) ? String((0, _common.ensureDefined)(displayValue, "")) : ""
            },
            _updateActionButton: function(selectedItem) {
                if (this.option("useSelectMode")) {
                    this.option({
                        text: this._getDisplayValue(selectedItem),
                        icon: (0, _type.isPlainObject)(selectedItem) ? selectedItem.icon : void 0
                    })
                }
                this._setOptionWithoutOptionChange("selectedItem", selectedItem);
                this._setOptionWithoutOptionChange("selectedItemKey", this._keyGetter(selectedItem))
            },
            _clean: function() {
                this._list && this._list.$element().remove();
                this._popup && this._popup.$element().remove()
            },
            _selectedItemKeyChanged: function(value) {
                var _this6 = this;
                this._setListOption("selectedItemKeys", this.option("useSelectMode") && (0, _type.isDefined)(value) ? [value] : []);
                var previousItem = this.option("selectedItem");
                this._loadSelectedItem().done(function(selectedItem) {
                    _this6._updateActionButton(selectedItem);
                    if (_this6._displayGetter(previousItem) !== _this6._displayGetter(selectedItem)) {
                        _this6._fireSelectionChangedAction({
                            previousValue: previousItem,
                            value: selectedItem
                        })
                    }
                })
            },
            _actionButtonOptionChanged: function(_ref5) {
                var name = _ref5.name,
                    value = _ref5.value;
                var newConfig = {};
                newConfig[name] = value;
                this._buttonGroup.option("items[0]", (0, _extend.extend)({}, this._actionButtonConfig(), newConfig));
                this._popup && this._popup.repaint()
            },
            _selectModeChanged: function(value) {
                if (value) {
                    this._setListOption("selectionMode", "single");
                    var selectedItemKey = this.option("selectedItemKey");
                    this._setListOption("selectedItemKeys", (0, _type.isDefined)(selectedItemKey) ? [selectedItemKey] : [])
                } else {
                    this._setListOption("selectionMode", "none");
                    this.option({
                        selectedItemKey: void 0,
                        selectedItem: void 0
                    })
                }
            },
            _updateItemCollection: function(optionName) {
                var _this7 = this;
                var selectedItemKey = this.option("selectedItemKey");
                this._setListOption("selectedItem", null);
                this._setWidgetOption("_list", [optionName]);
                if ((0, _type.isDefined)(selectedItemKey)) {
                    this._loadSelectedItem().done(function(selectedItem) {
                        _this7._setListOption("selectedItemKeys", [selectedItemKey]);
                        _this7._setListOption("selectedItem", selectedItem)
                    }).fail(function(error) {
                        _this7._setListOption("selectedItemKeys", [])
                    }).always(this._updateActionButton.bind(this))
                }
            },
            _updateDataSource: function() {
                var items = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this._dataSource.items();
                this._dataSource = void 0;
                this._itemsToDataSource(items);
                this._updateKeyExpr()
            },
            _updateKeyExpr: function() {
                this._compileKeyGetter();
                this._setListOption("keyExpr", this._getKey())
            },
            focus: function() {
                this._buttonGroup.focus()
            },
            _optionChanged: function(args) {
                var _this$_popup;
                var name = args.name,
                    value = args.value;
                switch (name) {
                    case "useSelectMode":
                        this._selectModeChanged(value);
                        break;
                    case "splitButton":
                        this._updateArrowClass();
                        this._renderButtonGroup();
                        break;
                    case "displayExpr":
                        this._compileDisplayGetter();
                        this._setListOption(name, value);
                        this._updateActionButton(this.option("selectedItem"));
                        break;
                    case "keyExpr":
                        this._updateDataSource();
                        break;
                    case "buttonGroupOptions":
                        this._innerWidgetOptionChanged(this._buttonGroup, args);
                        break;
                    case "dropDownOptions":
                        if ("dropDownOptions.visible" === args.fullName) {
                            break
                        }
                        if (void 0 !== args.value.visible) {
                            delete args.value.visible
                        }
                        this._popupOptionChanged(args);
                        this._innerWidgetOptionChanged(this._popup, args);
                        break;
                    case "opened":
                        this.toggle(value);
                        break;
                    case "focusStateEnabled":
                    case "hoverStateEnabled":
                        this._setListOption(name, value);
                        this._buttonGroup.option(name, value);
                        this.callBase(args);
                        break;
                    case "items":
                        this._updateDataSource(this.option("items"));
                        this._updateItemCollection(name);
                        break;
                    case "dataSource":
                        if (Array.isArray(value)) {
                            this._updateDataSource(this.option("dataSource"))
                        } else {
                            this._initDataSource();
                            this._updateKeyExpr()
                        }
                        this._updateItemCollection(name);
                        break;
                    case "icon":
                    case "text":
                        this._actionButtonOptionChanged(args);
                        break;
                    case "showArrowIcon":
                        this._updateArrowClass();
                        this._buttonGroup.repaint();
                        this._popup && this._popup.repaint();
                        break;
                    case "width":
                    case "height":
                        this.callBase(args);
                        null === (_this$_popup = this._popup) || void 0 === _this$_popup ? void 0 : _this$_popup.repaint();
                        break;
                    case "stylingMode":
                        this._buttonGroup.option(name, value);
                        break;
                    case "itemTemplate":
                    case "grouped":
                    case "noDataText":
                    case "groupTemplate":
                    case "wrapItemText":
                        this._setListOption(name, value);
                        break;
                    case "dropDownContentTemplate":
                        this._renderContent();
                        break;
                    case "selectedItemKey":
                        this._selectedItemKeyChanged(value);
                        break;
                    case "selectedItem":
                        break;
                    case "onItemClick":
                        this._createItemClickAction();
                        break;
                    case "onButtonClick":
                        this._createActionClickAction();
                        break;
                    case "onSelectionChanged":
                        this._createSelectionChangedAction();
                        break;
                    case "deferRendering":
                        this.toggle(this.option("opened"));
                        break;
                    case "tabIndex":
                        this._buttonGroup.option(name, value);
                        break;
                    default:
                        this.callBase(args)
                }
            }
        }).include(_data_helper.default);
        (0, _component_registrator.default)("dxDropDownButton", DropDownButton);
        var _default = DropDownButton;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/color_box.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _color_box = _interopRequireDefault(__webpack_require__( /*! ./color_box/color_box */ 613));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _color_box.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/color_box/color_view.js ***!
      \*************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _translator = __webpack_require__( /*! ../../animation/translator */ 28);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _color = _interopRequireDefault(__webpack_require__( /*! ../../color */ 95));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _editor = _interopRequireDefault(__webpack_require__( /*! ../editor/editor */ 52));
        var _number_box = _interopRequireDefault(__webpack_require__( /*! ../number_box */ 116));
        var _text_box = _interopRequireDefault(__webpack_require__( /*! ../text_box */ 97));
        var _draggable = _interopRequireDefault(__webpack_require__( /*! ../draggable */ 210));
        var _click = __webpack_require__( /*! ../../events/click */ 21);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var COLOR_VIEW_CLASS = "dx-colorview";
        var COLOR_VIEW_CONTAINER_CLASS = "dx-colorview-container";
        var COLOR_VIEW_ROW_CLASS = "dx-colorview-container-row";
        var COLOR_VIEW_CELL_CLASS = "dx-colorview-container-cell";
        var COLOR_VIEW_PALETTE_CLASS = "dx-colorview-palette";
        var COLOR_VIEW_PALETTE_CELL_CLASS = "dx-colorview-palette-cell";
        var COLOR_VIEW_PALETTE_HANDLE_CLASS = "dx-colorview-palette-handle";
        var COLOR_VIEW_PALETTE_GRADIENT_CLASS = "dx-colorview-palette-gradient";
        var COLOR_VIEW_PALETTE_GRADIENT_WHITE_CLASS = "dx-colorview-palette-gradient-white";
        var COLOR_VIEW_PALETTE_GRADIENT_BLACK_CLASS = "dx-colorview-palette-gradient-black";
        var COLOR_VIEW_HUE_SCALE_CLASS = "dx-colorview-hue-scale";
        var COLOR_VIEW_HUE_SCALE_CELL_CLASS = "dx-colorview-hue-scale-cell";
        var COLOR_VIEW_HUE_SCALE_HANDLE_CLASS = "dx-colorview-hue-scale-handle";
        var COLOR_VIEW_HUE_SCALE_WRAPPER_CLASS = "dx-colorview-hue-scale-wrapper";
        var COLOR_VIEW_CONTROLS_CONTAINER_CLASS = "dx-colorview-controls-container";
        var COLOR_VIEW_RED_LABEL_CLASS = "dx-colorview-label-red";
        var COLOR_VIEW_GREEN_LABEL_CLASS = "dx-colorview-label-green";
        var COLOR_VIEW_BLUE_LABEL_CLASS = "dx-colorview-label-blue";
        var COLOR_VIEW_HEX_LABEL_CLASS = "dx-colorview-label-hex";
        var COLOR_VIEW_ALPHA_CHANNEL_SCALE_CLASS = "dx-colorview-alpha-channel-scale";
        var COLOR_VIEW_APLHA_CHANNEL_ROW_CLASS = "dx-colorview-alpha-channel-row";
        var COLOR_VIEW_ALPHA_CHANNEL_SCALE_WRAPPER_CLASS = "dx-colorview-alpha-channel-wrapper";
        var COLOR_VIEW_ALPHA_CHANNEL_LABEL_CLASS = "dx-colorview-alpha-channel-label";
        var COLOR_VIEW_ALPHA_CHANNEL_HANDLE_CLASS = "dx-colorview-alpha-channel-handle";
        var COLOR_VIEW_ALPHA_CHANNEL_CELL_CLASS = "dx-colorview-alpha-channel-cell";
        var COLOR_VIEW_ALPHA_CHANNEL_BORDER_CLASS = "dx-colorview-alpha-channel-border";
        var COLOR_VIEW_COLOR_PREVIEW = "dx-colorview-color-preview";
        var COLOR_VIEW_COLOR_PREVIEW_CONTAINER_CLASS = "dx-colorview-color-preview-container";
        var COLOR_VIEW_COLOR_PREVIEW_CONTAINER_INNER_CLASS = "dx-colorview-color-preview-container-inner";
        var COLOR_VIEW_COLOR_PREVIEW_COLOR_CURRENT = "dx-colorview-color-preview-color-current";
        var COLOR_VIEW_COLOR_PREVIEW_COLOR_NEW = "dx-colorview-color-preview-color-new";
        var ColorView = _editor.default.inherit({
            _supportedKeys: function() {
                var isRTL = this.option("rtlEnabled");
                var that = this;
                var getHorizontalPaletteStep = function(e) {
                    var step = 100 / that._paletteWidth;
                    if (e.shiftKey) {
                        step *= that.option("keyStep")
                    }
                    step = step > 1 ? step : 1;
                    return Math.round(step)
                };
                var updateHorizontalPaletteValue = function(step) {
                    var value = that._currentColor.hsv.s + step;
                    if (value > 100) {
                        value = 100
                    } else {
                        if (value < 0) {
                            value = 0
                        }
                    }
                    that._currentColor.hsv.s = value;
                    updatePaletteValue()
                };
                var getVerticalPaletteStep = function(e) {
                    var step = 100 / that._paletteHeight;
                    if (e.shiftKey) {
                        step *= that.option("keyStep")
                    }
                    step = step > 1 ? step : 1;
                    return Math.round(step)
                };
                var updateVerticalPaletteValue = function(step) {
                    var value = that._currentColor.hsv.v + step;
                    if (value > 100) {
                        value = 100
                    } else {
                        if (value < 0) {
                            value = 0
                        }
                    }
                    that._currentColor.hsv.v = value;
                    updatePaletteValue()
                };

                function updatePaletteValue() {
                    that._placePaletteHandle();
                    that._updateColorFromHsv(that._currentColor.hsv.h, that._currentColor.hsv.s, that._currentColor.hsv.v)
                }
                var getHueScaleStep = function(e) {
                    var step = 360 / (that._hueScaleWrapperHeight - that._hueScaleHandleHeight);
                    if (e.shiftKey) {
                        step *= that.option("keyStep")
                    }
                    step = step > 1 ? step : 1;
                    return step
                };
                var updateHueScaleValue = function(step) {
                    that._currentColor.hsv.h += step;
                    that._placeHueScaleHandle();
                    var handleLocation = (0, _translator.locate)(that._$hueScaleHandle);
                    that._updateColorHue(handleLocation.top + that._hueScaleHandleHeight / 2)
                };
                var getAlphaScaleStep = function(e) {
                    var step = 1 / that._alphaChannelScaleWorkWidth;
                    if (e.shiftKey) {
                        step *= that.option("keyStep")
                    }
                    step = step > .01 ? step : .01;
                    step = isRTL ? -step : step;
                    return step
                };
                var updateAlphaScaleValue = function(step) {
                    that._currentColor.a += step;
                    that._placeAlphaChannelHandle();
                    var handleLocation = (0, _translator.locate)(that._$alphaChannelHandle);
                    that._calculateColorTransparencyByScaleWidth(handleLocation.left + that._alphaChannelHandleWidth / 2)
                };
                return (0, _extend.extend)(this.callBase(), {
                    upArrow: function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                        if (e.ctrlKey) {
                            if (this._currentColor.hsv.h <= 360 && !this._isTopColorHue) {
                                this._saveValueChangeEvent(e);
                                updateHueScaleValue(getHueScaleStep(e))
                            }
                        } else {
                            if (this._currentColor.hsv.v < 100) {
                                this._saveValueChangeEvent(e);
                                updateVerticalPaletteValue(getVerticalPaletteStep(e))
                            }
                        }
                    },
                    downArrow: function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                        if (e.ctrlKey) {
                            if (this._currentColor.hsv.h >= 0) {
                                if (this._isTopColorHue) {
                                    this._currentColor.hsv.h = 360
                                }
                                this._saveValueChangeEvent(e);
                                updateHueScaleValue(-getHueScaleStep(e))
                            }
                        } else {
                            if (this._currentColor.hsv.v > 0) {
                                this._saveValueChangeEvent(e);
                                updateVerticalPaletteValue(-getVerticalPaletteStep(e))
                            }
                        }
                    },
                    rightArrow: function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                        if (e.ctrlKey) {
                            if (isRTL ? this._currentColor.a < 1 : this._currentColor.a > 0 && this.option("editAlphaChannel")) {
                                this._saveValueChangeEvent(e);
                                updateAlphaScaleValue(-getAlphaScaleStep(e))
                            }
                        } else {
                            if (this._currentColor.hsv.s < 100) {
                                this._saveValueChangeEvent(e);
                                updateHorizontalPaletteValue(getHorizontalPaletteStep(e))
                            }
                        }
                    },
                    leftArrow: function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                        if (e.ctrlKey) {
                            if (isRTL ? this._currentColor.a > 0 : this._currentColor.a < 1 && this.option("editAlphaChannel")) {
                                this._saveValueChangeEvent(e);
                                updateAlphaScaleValue(getAlphaScaleStep(e))
                            }
                        } else {
                            if (this._currentColor.hsv.s > 0) {
                                this._saveValueChangeEvent(e);
                                updateHorizontalPaletteValue(-getHorizontalPaletteStep(e))
                            }
                        }
                    },
                    enter: function(e) {
                        this._fireEnterKeyPressed(e)
                    }
                })
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    value: null,
                    matchValue: null,
                    onEnterKeyPressed: void 0,
                    editAlphaChannel: false,
                    keyStep: 1,
                    stylingMode: void 0
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: function() {
                        return "desktop" === _devices.default.real().deviceType && !_devices.default.isSimulator()
                    },
                    options: {
                        focusStateEnabled: true
                    }
                }])
            },
            _init: function() {
                this.callBase();
                this._initColorAndOpacity();
                this._initEnterKeyPressedAction()
            },
            _initEnterKeyPressedAction: function() {
                this._onEnterKeyPressedAction = this._createActionByOption("onEnterKeyPressed")
            },
            _fireEnterKeyPressed: function(e) {
                if (!this._onEnterKeyPressedAction) {
                    return
                }
                this._onEnterKeyPressedAction({
                    event: e
                })
            },
            _initColorAndOpacity: function() {
                this._setCurrentColor(this.option("value"))
            },
            _setCurrentColor: function(value) {
                value = value || "#000000";
                var newColor = new _color.default(value);
                if (!newColor.colorIsInvalid) {
                    if (!this._currentColor || this._makeRgba(this._currentColor) !== this._makeRgba(newColor)) {
                        this._currentColor = newColor;
                        if (this._$currentColor) {
                            this._makeTransparentBackground(this._$currentColor, newColor)
                        }
                    }
                } else {
                    this.option("value", this._currentColor.baseColor)
                }
            },
            _setBaseColor: function(value) {
                var color = value || "#000000";
                var newColor = new _color.default(color);
                if (!newColor.colorIsInvalid) {
                    var isBaseColorChanged = this._makeRgba(this.option("matchValue") !== this._makeRgba(newColor));
                    if (isBaseColorChanged) {
                        if (this._$baseColor) {
                            this._makeTransparentBackground(this._$baseColor, newColor)
                        }
                    }
                }
            },
            _initMarkup: function() {
                this.callBase();
                this.$element().addClass(COLOR_VIEW_CLASS);
                this._renderColorPickerContainer()
            },
            _render: function() {
                this.callBase();
                this._renderPalette();
                this._renderHueScale();
                this._renderControlsContainer();
                this._renderControls();
                this._renderAlphaChannelElements()
            },
            _makeTransparentBackground: function($el, color) {
                if (!(color instanceof _color.default)) {
                    color = new _color.default(color)
                }
                $el.css("backgroundColor", this._makeRgba(color))
            },
            _makeRgba: function(color) {
                if (!(color instanceof _color.default)) {
                    color = new _color.default(color)
                }
                return "rgba(" + [color.r, color.g, color.b, color.a].join(", ") + ")"
            },
            _renderValue: function() {
                this.callBase(this.option("editAlphaChannel") ? this._makeRgba(this._currentColor) : this.option("value"))
            },
            _renderColorPickerContainer: function() {
                var $parent = this.$element();
                this._$colorPickerContainer = (0, _renderer.default)("<div>").addClass(COLOR_VIEW_CONTAINER_CLASS).appendTo($parent);
                this._renderHtmlRows()
            },
            _renderHtmlRows: function(updatedOption) {
                var $renderedRows = this._$colorPickerContainer.find("." + COLOR_VIEW_ROW_CLASS);
                var renderedRowsCount = $renderedRows.length;
                var rowCount = this.option("editAlphaChannel") ? 2 : 1;
                var delta = renderedRowsCount - rowCount;
                if (delta > 0) {
                    $renderedRows.eq(-1).remove()
                }
                if (delta < 0) {
                    delta = Math.abs(delta);
                    var rows = [];
                    var i;
                    for (i = 0; i < delta; i++) {
                        rows.push((0, _renderer.default)("<div>").addClass(COLOR_VIEW_ROW_CLASS))
                    }
                    if (renderedRowsCount) {
                        for (i = 0; i < rows.length; i++) {
                            $renderedRows.eq(0).after(rows[i])
                        }
                    } else {
                        this._$colorPickerContainer.append(rows)
                    }
                }
            },
            _renderHtmlCellInsideRow: function(index, $rowParent, additionalClass) {
                return (0, _renderer.default)("<div>").addClass(COLOR_VIEW_CELL_CLASS).addClass(additionalClass).appendTo($rowParent.find("." + COLOR_VIEW_ROW_CLASS).eq(index))
            },
            _renderPalette: function() {
                var $paletteCell = this._renderHtmlCellInsideRow(0, this._$colorPickerContainer, COLOR_VIEW_PALETTE_CELL_CLASS);
                var $paletteGradientWhite = (0, _renderer.default)("<div>").addClass([COLOR_VIEW_PALETTE_GRADIENT_CLASS, COLOR_VIEW_PALETTE_GRADIENT_WHITE_CLASS].join(" "));
                var $paletteGradientBlack = (0, _renderer.default)("<div>").addClass([COLOR_VIEW_PALETTE_GRADIENT_CLASS, COLOR_VIEW_PALETTE_GRADIENT_BLACK_CLASS].join(" "));
                this._$palette = (0, _renderer.default)("<div>").addClass(COLOR_VIEW_PALETTE_CLASS).css("backgroundColor", this._currentColor.getPureColor().toHex()).appendTo($paletteCell);
                this._paletteHeight = this._$palette.height();
                this._paletteWidth = this._$palette.width();
                this._renderPaletteHandle();
                this._$palette.append([$paletteGradientWhite, $paletteGradientBlack])
            },
            _renderPaletteHandle: function() {
                var _this = this;
                this._$paletteHandle = (0, _renderer.default)("<div>").addClass(COLOR_VIEW_PALETTE_HANDLE_CLASS).appendTo(this._$palette);
                this._createComponent(this._$paletteHandle, _draggable.default, {
                    contentTemplate: null,
                    boundary: this._$palette,
                    allowMoveByClick: true,
                    boundOffset: function() {
                        return -this._paletteHandleHeight / 2
                    }.bind(this),
                    onDragMove: function(_ref) {
                        var event = _ref.event;
                        var paletteHandlePosition = (0, _translator.locate)(_this._$paletteHandle);
                        _this._updateByDrag = true;
                        _this._saveValueChangeEvent(event);
                        _this._updateColorFromHsv(_this._currentColor.hsv.h, _this._calculateColorSaturation(paletteHandlePosition), _this._calculateColorValue(paletteHandlePosition))
                    }
                });
                this._paletteHandleWidth = this._$paletteHandle.width();
                this._paletteHandleHeight = this._$paletteHandle.height();
                this._placePaletteHandle()
            },
            _placePaletteHandle: function() {
                (0, _translator.move)(this._$paletteHandle, {
                    left: Math.round(this._paletteWidth * this._currentColor.hsv.s / 100 - this._paletteHandleWidth / 2),
                    top: Math.round(this._paletteHeight - this._paletteHeight * this._currentColor.hsv.v / 100 - this._paletteHandleHeight / 2)
                })
            },
            _calculateColorValue: function(paletteHandlePosition) {
                var value = Math.floor(paletteHandlePosition.top + this._paletteHandleHeight / 2);
                return 100 - Math.round(100 * value / this._paletteHeight)
            },
            _calculateColorSaturation: function(paletteHandlePosition) {
                var saturation = Math.floor(paletteHandlePosition.left + this._paletteHandleWidth / 2);
                return Math.round(100 * saturation / this._paletteWidth)
            },
            _updateColorFromHsv: function(hue, saturation, value) {
                var a = this._currentColor.a;
                this._currentColor = new _color.default("hsv(" + [hue, saturation, value].join(",") + ")");
                this._currentColor.a = a;
                this._updateColorParamsAndColorPreview();
                this.applyColor()
            },
            _renderHueScale: function() {
                var $hueScaleCell = this._renderHtmlCellInsideRow(0, this._$colorPickerContainer, COLOR_VIEW_HUE_SCALE_CELL_CLASS);
                this._$hueScaleWrapper = (0, _renderer.default)("<div>").addClass(COLOR_VIEW_HUE_SCALE_WRAPPER_CLASS).appendTo($hueScaleCell);
                this._$hueScale = (0, _renderer.default)("<div>").addClass(COLOR_VIEW_HUE_SCALE_CLASS).appendTo(this._$hueScaleWrapper);
                this._hueScaleHeight = this._$hueScale.height();
                this._hueScaleWrapperHeight = this._$hueScaleWrapper.outerHeight();
                this._renderHueScaleHandle()
            },
            _renderHueScaleHandle: function() {
                var _this2 = this;
                this._$hueScaleHandle = (0, _renderer.default)("<div>").addClass(COLOR_VIEW_HUE_SCALE_HANDLE_CLASS).appendTo(this._$hueScaleWrapper);
                this._createComponent(this._$hueScaleHandle, _draggable.default, {
                    contentTemplate: null,
                    boundary: this._$hueScaleWrapper,
                    allowMoveByClick: true,
                    dragDirection: "vertical",
                    onDragMove: function(_ref2) {
                        var event = _ref2.event;
                        _this2._updateByDrag = true;
                        _this2._saveValueChangeEvent(event);
                        _this2._updateColorHue((0, _translator.locate)(_this2._$hueScaleHandle).top + _this2._hueScaleHandleHeight / 2)
                    }
                });
                this._hueScaleHandleHeight = this._$hueScaleHandle.height();
                this._placeHueScaleHandle()
            },
            _placeHueScaleHandle: function() {
                var hueScaleHeight = this._hueScaleWrapperHeight;
                var handleHeight = this._hueScaleHandleHeight;
                var top = (hueScaleHeight - handleHeight) * (360 - this._currentColor.hsv.h) / 360;
                if (hueScaleHeight < top + handleHeight) {
                    top = hueScaleHeight - handleHeight
                }
                if (top < 0) {
                    top = 0
                }(0, _translator.move)(this._$hueScaleHandle, {
                    top: Math.round(top)
                })
            },
            _updateColorHue: function(handlePosition) {
                var hue = 360 - Math.round(360 * (handlePosition - this._hueScaleHandleHeight / 2) / (this._hueScaleWrapperHeight - this._hueScaleHandleHeight));
                var saturation = this._currentColor.hsv.s;
                var value = this._currentColor.hsv.v;
                this._isTopColorHue = false;
                hue = hue < 0 ? 0 : hue;
                if (hue >= 360) {
                    this._isTopColorHue = true;
                    hue = 0
                }
                this._updateColorFromHsv(hue, saturation, value);
                this._$palette.css("backgroundColor", this._currentColor.getPureColor().toHex())
            },
            _renderControlsContainer: function() {
                var $controlsContainerCell = this._renderHtmlCellInsideRow(0, this._$colorPickerContainer);
                this._$controlsContainer = (0, _renderer.default)("<div>").addClass(COLOR_VIEW_CONTROLS_CONTAINER_CLASS).appendTo($controlsContainerCell)
            },
            _renderControls: function() {
                this._renderColorsPreview();
                this._renderRgbInputs();
                this._renderHexInput()
            },
            _renderColorsPreview: function() {
                var $colorsPreviewContainer = (0, _renderer.default)("<div>").addClass(COLOR_VIEW_COLOR_PREVIEW_CONTAINER_CLASS).appendTo(this._$controlsContainer);
                var $colorsPreviewContainerInner = (0, _renderer.default)("<div>").addClass(COLOR_VIEW_COLOR_PREVIEW_CONTAINER_INNER_CLASS).appendTo($colorsPreviewContainer);
                this._$currentColor = (0, _renderer.default)("<div>").addClass([COLOR_VIEW_COLOR_PREVIEW, COLOR_VIEW_COLOR_PREVIEW_COLOR_NEW].join(" "));
                this._$baseColor = (0, _renderer.default)("<div>").addClass([COLOR_VIEW_COLOR_PREVIEW, COLOR_VIEW_COLOR_PREVIEW_COLOR_CURRENT].join(" "));
                this._makeTransparentBackground(this._$baseColor, this.option("matchValue"));
                this._makeTransparentBackground(this._$currentColor, this._currentColor);
                $colorsPreviewContainerInner.append([this._$baseColor, this._$currentColor])
            },
            _renderAlphaChannelElements: function() {
                if (this.option("editAlphaChannel")) {
                    this._$colorPickerContainer.find("." + COLOR_VIEW_ROW_CLASS).eq(1).addClass(COLOR_VIEW_APLHA_CHANNEL_ROW_CLASS);
                    this._renderAlphaChannelScale();
                    this._renderAlphaChannelInput()
                }
            },
            _renderRgbInputs: function() {
                this._rgbInputsWithLabels = [this._renderEditorWithLabel({
                    editorType: _number_box.default,
                    value: this._currentColor.r,
                    onValueChanged: this._updateColor.bind(this, false),
                    labelText: "R",
                    labelAriaText: _message.default.format("dxColorView-ariaRed"),
                    labelClass: COLOR_VIEW_RED_LABEL_CLASS
                }), this._renderEditorWithLabel({
                    editorType: _number_box.default,
                    value: this._currentColor.g,
                    onValueChanged: this._updateColor.bind(this, false),
                    labelText: "G",
                    labelAriaText: _message.default.format("dxColorView-ariaGreen"),
                    labelClass: COLOR_VIEW_GREEN_LABEL_CLASS
                }), this._renderEditorWithLabel({
                    editorType: _number_box.default,
                    value: this._currentColor.b,
                    onValueChanged: this._updateColor.bind(this, false),
                    labelText: "B",
                    labelAriaText: _message.default.format("dxColorView-ariaBlue"),
                    labelClass: COLOR_VIEW_BLUE_LABEL_CLASS
                })];
                this._$controlsContainer.append(this._rgbInputsWithLabels);
                this._rgbInputs = [this._rgbInputsWithLabels[0].find(".dx-numberbox").dxNumberBox("instance"), this._rgbInputsWithLabels[1].find(".dx-numberbox").dxNumberBox("instance"), this._rgbInputsWithLabels[2].find(".dx-numberbox").dxNumberBox("instance")]
            },
            _renderEditorWithLabel: function(options) {
                var _this3 = this;
                var $editor = (0, _renderer.default)("<div>");
                var $label = (0, _renderer.default)("<label>").addClass(options.labelClass).text(options.labelText + ":").append($editor);
                _events_engine.default.off($label, _click.name);
                _events_engine.default.on($label, _click.name, function(e) {
                    e.preventDefault()
                });
                var editorType = options.editorType;
                var editorOptions = (0, _extend.extend)({
                    value: options.value,
                    onValueChanged: options.onValueChanged,
                    onKeyboardHandled: function(opts) {
                        return _this3._keyboardHandler(opts)
                    }
                }, {
                    stylingMode: this.option("stylingMode")
                });
                if (editorType === _number_box.default) {
                    editorOptions.min = options.min || 0;
                    editorOptions.max = options.max || 255;
                    editorOptions.step = options.step || 1
                }
                var editor = new editorType($editor, editorOptions);
                editor.registerKeyHandler("enter", function(e) {
                    this._fireEnterKeyPressed(e)
                }.bind(this));
                this.setAria("label", options.labelAriaText, $editor);
                return $label
            },
            hexInputOptions: function() {
                return {
                    editorType: _text_box.default,
                    value: this._currentColor.toHex().replace("#", ""),
                    onValueChanged: this._updateColor.bind(this, true),
                    labelClass: COLOR_VIEW_HEX_LABEL_CLASS,
                    labelText: "#",
                    labelAriaText: _message.default.format("dxColorView-ariaHex")
                }
            },
            _renderHexInput: function() {
                this._hexInput = _text_box.default.getInstance(this._renderEditorWithLabel(this.hexInputOptions()).appendTo(this._$controlsContainer).find(".dx-textbox"))
            },
            _renderAlphaChannelScale: function() {
                var $alphaChannelScaleCell = this._renderHtmlCellInsideRow(1, this._$colorPickerContainer, COLOR_VIEW_ALPHA_CHANNEL_CELL_CLASS);
                var $alphaChannelBorder = (0, _renderer.default)("<div>").addClass(COLOR_VIEW_ALPHA_CHANNEL_BORDER_CLASS).appendTo($alphaChannelScaleCell);
                var $alphaChannelScaleWrapper = (0, _renderer.default)("<div>").addClass(COLOR_VIEW_ALPHA_CHANNEL_SCALE_WRAPPER_CLASS).appendTo($alphaChannelBorder);
                this._$alphaChannelScale = (0, _renderer.default)("<div>").addClass(COLOR_VIEW_ALPHA_CHANNEL_SCALE_CLASS).appendTo($alphaChannelScaleWrapper);
                this._makeCSSLinearGradient(this._$alphaChannelScale);
                this._renderAlphaChannelHandle($alphaChannelScaleCell)
            },
            _makeCSSLinearGradient: function($el) {
                var color = this._currentColor;
                var colorAsRgb = [color.r, color.g, color.b].join(",");
                var colorAsHex = color.toHex().replace("#", "");
                var combineGradientString = function(colorAsRgb, colorAsHex) {
                    var rtlEnabled = this.option("rtlEnabled");
                    var startColor = "rgba(" + colorAsRgb + ", " + (rtlEnabled ? "1" : "0") + ")";
                    var finishColor = "rgba(" + colorAsRgb + ", " + (rtlEnabled ? "0" : "1") + ")";
                    var startColorIE = "'#" + (rtlEnabled ? "00" : "") + colorAsHex + "'";
                    var finishColorIE = "'#" + (rtlEnabled ? "" : "00") + colorAsHex + "'";
                    return ["background-image: -webkit-linear-gradient(180deg, " + startColor + ", " + finishColor + ")", "background-image: -moz-linear-gradient(-90deg, " + startColor + ", " + finishColor + ")", "background-image: -o-linear-gradient(-90deg, " + startColor + ", " + finishColor + ")", "background-image: linear-gradient(-90deg, " + startColor + ", " + finishColor + ")", "filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1,startColorstr=" + startColorIE + ", endColorstr=" + finishColorIE + ")"].join(";")
                };
                $el.attr("style", combineGradientString.call(this, colorAsRgb, colorAsHex))
            },
            _renderAlphaChannelInput: function() {
                var that = this;
                var $alphaChannelInputCell = this._renderHtmlCellInsideRow(1, this._$colorPickerContainer);
                that._alphaChannelInput = this._renderEditorWithLabel({
                    editorType: _number_box.default,
                    value: this._currentColor.a,
                    max: 1,
                    step: .1,
                    onValueChanged: function(args) {
                        var value = args.value;
                        value = that._currentColor.isValidAlpha(value) ? value : that._currentColor.a;
                        args.event && that._saveValueChangeEvent(args.event);
                        that._updateColorTransparency(value);
                        that._placeAlphaChannelHandle()
                    },
                    labelClass: COLOR_VIEW_ALPHA_CHANNEL_LABEL_CLASS,
                    labelText: "Alpha",
                    labelAriaText: _message.default.format("dxColorView-ariaAlpha")
                }).appendTo($alphaChannelInputCell).find(".dx-numberbox").dxNumberBox("instance")
            },
            _updateColorTransparency: function(transparency) {
                this._currentColor.a = transparency;
                this.applyColor()
            },
            _renderAlphaChannelHandle: function($parent) {
                var _this4 = this;
                this._$alphaChannelHandle = (0, _renderer.default)("<div>").addClass(COLOR_VIEW_ALPHA_CHANNEL_HANDLE_CLASS).appendTo($parent);
                this._createComponent(this._$alphaChannelHandle, _draggable.default, {
                    contentTemplate: null,
                    boundary: $parent,
                    allowMoveByClick: true,
                    dragDirection: "horizontal",
                    onDragMove: function(_ref3) {
                        var event = _ref3.event;
                        _this4._updateByDrag = true;
                        var $alphaChannelHandle = _this4._$alphaChannelHandle;
                        var alphaChannelHandlePosition = (0, _translator.locate)($alphaChannelHandle).left + _this4._alphaChannelHandleWidth / 2;
                        _this4._saveValueChangeEvent(event);
                        _this4._calculateColorTransparencyByScaleWidth(alphaChannelHandlePosition)
                    }
                });
                this._alphaChannelHandleWidth = this._$alphaChannelHandle.width();
                this._alphaChannelScaleWorkWidth = $parent.width() - this._alphaChannelHandleWidth;
                this._placeAlphaChannelHandle()
            },
            _calculateColorTransparencyByScaleWidth: function(handlePosition) {
                var transparency = (handlePosition - this._alphaChannelHandleWidth / 2) / this._alphaChannelScaleWorkWidth;
                var rtlEnabled = this.option("rtlEnabled");
                transparency = rtlEnabled ? transparency : 1 - transparency;
                if (handlePosition >= this._alphaChannelScaleWorkWidth + this._alphaChannelHandleWidth / 2) {
                    transparency = rtlEnabled ? 1 : 0
                } else {
                    if (transparency < 1) {
                        transparency = transparency.toFixed(2)
                    }
                }
                transparency = Math.max(transparency, 0);
                transparency = Math.min(transparency, 1);
                this._alphaChannelInput.option("value", transparency)
            },
            _placeAlphaChannelHandle: function() {
                var left = this._alphaChannelScaleWorkWidth * (1 - this._currentColor.a);
                if (left < 0) {
                    left = 0
                }
                if (this._alphaChannelScaleWorkWidth < left) {
                    left = this._alphaChannelScaleWorkWidth
                }(0, _translator.move)(this._$alphaChannelHandle, {
                    left: this.option("rtlEnabled") ? this._alphaChannelScaleWorkWidth - left : left
                })
            },
            applyColor: function() {
                var colorValue = this.option("editAlphaChannel") ? this._makeRgba(this._currentColor) : this._currentColor.toHex();
                this._makeTransparentBackground(this._$currentColor, this._currentColor);
                this.option("value", colorValue)
            },
            cancelColor: function() {
                this._initColorAndOpacity();
                this._refreshMarkup()
            },
            _updateColor: function(isHex, args) {
                var rgba;
                var newColor;
                if (isHex) {
                    newColor = this._validateHex("#" + this._hexInput.option("value"))
                } else {
                    rgba = this._validateRgb();
                    if (this._alphaChannelInput) {
                        rgba.push(this._alphaChannelInput.option("value"));
                        newColor = "rgba(" + rgba.join(", ") + ")"
                    } else {
                        newColor = "rgb(" + rgba.join(", ") + ")"
                    }
                }
                if (!this._suppressEditorsValueUpdating) {
                    this._currentColor = new _color.default(newColor);
                    this._saveValueChangeEvent(args.event);
                    this.applyColor();
                    this._refreshMarkup()
                }
            },
            _validateHex: function(hex) {
                return this._currentColor.isValidHex(hex) ? hex : this._currentColor.toHex()
            },
            _validateRgb: function() {
                var r = this._rgbInputs[0].option("value");
                var g = this._rgbInputs[1].option("value");
                var b = this._rgbInputs[2].option("value");
                if (!this._currentColor.isValidRGB(r, g, b)) {
                    r = this._currentColor.r;
                    g = this._currentColor.g;
                    b = this._currentColor.b
                }
                return [r, g, b]
            },
            _refreshMarkup: function() {
                this._placeHueScaleHandle();
                this._placePaletteHandle();
                this._updateColorParamsAndColorPreview();
                this._$palette.css("backgroundColor", this._currentColor.getPureColor().toHex());
                if (this._$alphaChannelHandle) {
                    this._updateColorTransparency(this._currentColor.a);
                    this._placeAlphaChannelHandle()
                }
            },
            _updateColorParamsAndColorPreview: function() {
                this._suppressEditorsValueUpdating = true;
                this._hexInput.option("value", this._currentColor.toHex().replace("#", ""));
                this._rgbInputs[0].option("value", this._currentColor.r);
                this._rgbInputs[1].option("value", this._currentColor.g);
                this._rgbInputs[2].option("value", this._currentColor.b);
                this._suppressEditorsValueUpdating = false;
                if (this.option("editAlphaChannel")) {
                    this._makeCSSLinearGradient.call(this, this._$alphaChannelScale);
                    this._alphaChannelInput.option("value", this._currentColor.a)
                }
            },
            _optionChanged: function(args) {
                var value = args.value;
                switch (args.name) {
                    case "value":
                        this._setCurrentColor(value);
                        if (!this._updateByDrag) {
                            this._refreshMarkup()
                        }
                        this._updateByDrag = false;
                        this.callBase(args);
                        break;
                    case "matchValue":
                        this._setBaseColor(value);
                        break;
                    case "onEnterKeyPressed":
                        this._initEnterKeyPressedAction();
                        break;
                    case "editAlphaChannel":
                        if (this._$colorPickerContainer) {
                            this._renderHtmlRows("editAlphaChannel");
                            this._renderAlphaChannelElements()
                        }
                        break;
                    case "keyStep":
                        break;
                    case "stylingMode":
                        this._renderControls();
                        break;
                    default:
                        this.callBase(args)
                }
            }
        });
        (0, _component_registrator.default)("dxColorView", ColorView);
        var _default = ColorView;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/number_box/utils.js ***!
      \*********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.splitByIndex = exports.getNthOccurrence = exports.getRealSeparatorIndex = void 0;
        var getRealSeparatorIndex = function(str) {
            var quoteBalance = 0;
            var separatorCount = 0;
            for (var i = 0; i < str.length; ++i) {
                if ("'" === str[i]) {
                    quoteBalance++
                }
                if ("." === str[i]) {
                    ++separatorCount;
                    if (quoteBalance % 2 === 0) {
                        return {
                            occurrence: separatorCount,
                            index: i
                        }
                    }
                }
            }
            return {
                occurrence: 1,
                index: -1
            }
        };
        exports.getRealSeparatorIndex = getRealSeparatorIndex;
        var getNthOccurrence = function(str, c, n) {
            var i = -1;
            while (n-- && i++ < str.length) {
                i = str.indexOf(c, i)
            }
            return i
        };
        exports.getNthOccurrence = getNthOccurrence;
        var splitByIndex = function(str, index) {
            if (index === -1) {
                return [str]
            }
            return [str.slice(0, index), str.slice(index + 1)]
        };
        exports.splitByIndex = splitByIndex
    },
    /*!*******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/date_box/ui.date_box.strategy.calendar.js ***!
      \*******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _calendar = _interopRequireDefault(__webpack_require__( /*! ../calendar */ 277));
        var _uiDate_box = _interopRequireDefault(__webpack_require__( /*! ./ui.date_box.strategy */ 213));
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var CalendarStrategy = _uiDate_box.default.inherit({
            NAME: "Calendar",
            supportedKeys: function() {
                var homeEndHandler = function(e) {
                    if (this.option("opened")) {
                        e.preventDefault();
                        return true
                    }
                    return false
                };
                return {
                    rightArrow: function() {
                        if (this.option("opened")) {
                            return true
                        }
                    },
                    leftArrow: function() {
                        if (this.option("opened")) {
                            return true
                        }
                    },
                    enter: function(e) {
                        if (this.dateBox.option("opened")) {
                            e.preventDefault();
                            if (this._widget.option("zoomLevel") === this._widget.option("maxZoomLevel")) {
                                var viewValue = this._getContouredValue();
                                var lastActionElement = this._lastActionElement;
                                if (viewValue && "calendar" === lastActionElement) {
                                    this.dateBoxValue(viewValue, e)
                                }
                                this.dateBox.close();
                                this.dateBox._valueChangeEventHandler(e)
                            } else {
                                return true
                            }
                        } else {
                            this.dateBox._valueChangeEventHandler(e)
                        }
                    }.bind(this),
                    home: homeEndHandler,
                    end: homeEndHandler
                }
            },
            getDisplayFormat: function(displayFormat) {
                return displayFormat || "shortdate"
            },
            _getWidgetName: function() {
                return _calendar.default
            },
            _getContouredValue: function() {
                return this._widget._view.option("contouredDate")
            },
            getKeyboardListener: function() {
                return this._widget
            },
            _getWidgetOptions: function() {
                var disabledDates = this.dateBox.option("disabledDates");
                return (0, _extend.extend)(this.dateBox.option("calendarOptions"), {
                    value: this.dateBoxValue() || null,
                    dateSerializationFormat: null,
                    min: this.dateBox.dateOption("min"),
                    max: this.dateBox.dateOption("max"),
                    onValueChanged: this._valueChangedHandler.bind(this),
                    onCellClick: this._cellClickHandler.bind(this),
                    tabIndex: null,
                    disabledDates: (0, _type.isFunction)(disabledDates) ? this._injectComponent(disabledDates.bind(this.dateBox)) : disabledDates,
                    onContouredChanged: this._refreshActiveDescendant.bind(this),
                    hasFocus: function() {
                        return true
                    }
                })
            },
            _injectComponent: function(func) {
                var that = this;
                return function(params) {
                    (0, _extend.extend)(params, {
                        component: that.dateBox
                    });
                    return func(params)
                }
            },
            _refreshActiveDescendant: function(e) {
                this._lastActionElement = "calendar";
                this.dateBox.setAria("activedescendant", e.actionValue)
            },
            popupConfig: function(_popupConfig) {
                var _this = this;
                var toolbarItems = _popupConfig.toolbarItems;
                var buttonsLocation = this.dateBox.option("buttonsLocation");
                var position = [];
                if ("default" !== buttonsLocation) {
                    position = (0, _common.splitPair)(buttonsLocation)
                } else {
                    position = ["bottom", "center"]
                }
                if ("useButtons" === this.dateBox.option("applyValueMode") && this._isCalendarVisible()) {
                    toolbarItems.unshift({
                        widget: "dxButton",
                        toolbar: position[0],
                        location: "after" === position[1] ? "before" : position[1],
                        options: {
                            onInitialized: function(e) {
                                e.component.registerKeyHandler("escape", this._escapeHandler.bind(this))
                            }.bind(this),
                            onClick: function(args) {
                                _this._widget._toTodayView(args)
                            },
                            text: _message.default.format("dxCalendar-todayButtonText"),
                            type: "today"
                        }
                    })
                }
                return (0, _extend.extend)(true, _popupConfig, {
                    toolbarItems: toolbarItems,
                    position: {
                        collision: "flipfit flip"
                    },
                    width: "auto"
                })
            },
            _isCalendarVisible: function() {
                return (0, _type.isEmptyObject)(this.dateBox.option("calendarOptions")) || false !== this.dateBox.option("calendarOptions.visible")
            },
            _escapeHandler: function() {
                this.dateBox.close();
                this.dateBox.focus()
            },
            _valueChangedHandler: function(e) {
                var dateBox = this.dateBox;
                var value = e.value;
                var prevValue = e.previousValue;
                if (_date.default.sameDate(value, prevValue)) {
                    return
                }
                if ("instantly" === dateBox.option("applyValueMode")) {
                    this.dateBoxValue(this.getValue(), e.event)
                }
            },
            _updateValue: function() {
                if (!this._widget) {
                    return
                }
                this._widget.option("value", this.dateBoxValue())
            },
            textChangedHandler: function() {
                this._lastActionElement = "input";
                if (this.dateBox.option("opened") && this._widget) {
                    this._updateValue(true)
                }
            },
            _cellClickHandler: function(e) {
                var dateBox = this.dateBox;
                if ("instantly" === dateBox.option("applyValueMode")) {
                    dateBox.option("opened", false);
                    this.dateBoxValue(this.getValue(), e.event)
                }
            }
        });
        var _default = CalendarStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/form/ui.form.items_runtime_info.js ***!
      \************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _guid = _interopRequireDefault(__webpack_require__( /*! ../../core/guid */ 36));
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var FormItemsRunTimeInfo = function() {
            function FormItemsRunTimeInfo() {
                this._map = {}
            }
            var _proto = FormItemsRunTimeInfo.prototype;
            _proto._findWidgetInstance = function(condition) {
                var result;
                (0, _iterator.each)(this._map, function(guid, _ref) {
                    var widgetInstance = _ref.widgetInstance,
                        item = _ref.item;
                    if (condition(item)) {
                        result = widgetInstance;
                        return false
                    }
                });
                return result
            };
            _proto._findFieldByCondition = function(callback, valueExpr) {
                var result;
                (0, _iterator.each)(this._map, function(key, value) {
                    if (callback(value)) {
                        result = "guid" === valueExpr ? key : value[valueExpr];
                        return false
                    }
                });
                return result
            };
            _proto.clear = function() {
                this._map = {}
            };
            _proto.removeItemsByItems = function(itemsRunTimeInfo) {
                var _this = this;
                (0, _iterator.each)(itemsRunTimeInfo.getItems(), function(guid) {
                    return _this.removeItemByKey(guid)
                })
            };
            _proto.removeItemByKey = function(key) {
                delete this._map[key]
            };
            _proto.add = function(options) {
                var key = options.guid || new _guid.default;
                this._map[key] = options;
                return key
            };
            _proto.addItemsOrExtendFrom = function(itemsRunTimeInfo) {
                var _this2 = this;
                itemsRunTimeInfo.each(function(key, itemRunTimeInfo) {
                    if (_this2._map[key]) {
                        if (itemRunTimeInfo.widgetInstance) {
                            _this2._map[key].widgetInstance = itemRunTimeInfo.widgetInstance
                        }
                        _this2._map[key].$itemContainer = itemRunTimeInfo.$itemContainer
                    } else {
                        _this2.add({
                            item: itemRunTimeInfo.item,
                            widgetInstance: itemRunTimeInfo.widgetInstance,
                            guid: key,
                            $itemContainer: itemRunTimeInfo.$itemContainer
                        })
                    }
                })
            };
            _proto.extendRunTimeItemInfoByKey = function(key, options) {
                if (this._map[key]) {
                    this._map[key] = (0, _extend.extend)(this._map[key], options)
                }
            };
            _proto.findWidgetInstanceByItem = function(item) {
                return this._findWidgetInstance(function(storedItem) {
                    return storedItem === item
                })
            };
            _proto.getGroupOrTabLayoutManagerByPath = function(targetPath) {
                return this._findFieldByCondition(function(_ref2) {
                    var path = _ref2.path;
                    return path === targetPath
                }, "layoutManager")
            };
            _proto.getKeyByPath = function(targetPath) {
                return this._findFieldByCondition(function(_ref3) {
                    var path = _ref3.path;
                    return path === targetPath
                }, "guid")
            };
            _proto.findWidgetInstanceByName = function(name) {
                return this._findWidgetInstance(function(item) {
                    return name === item.name
                })
            };
            _proto.findWidgetInstanceByDataField = function(dataField) {
                return this._findWidgetInstance(function(item) {
                    return dataField === ((0, _type.isString)(item) ? item : item.dataField)
                })
            };
            _proto.findItemContainerByItem = function(item) {
                for (var key in this._map) {
                    if (this._map[key].item === item) {
                        return this._map[key].$itemContainer
                    }
                }
                return null
            };
            _proto.findItemIndexByItem = function(targetItem) {
                return this._findFieldByCondition(function(_ref4) {
                    var item = _ref4.item;
                    return item === targetItem
                }, "itemIndex")
            };
            _proto.getItems = function() {
                return this._map
            };
            _proto.each = function(handler) {
                (0, _iterator.each)(this._map, function(key, itemRunTimeInfo) {
                    handler(key, itemRunTimeInfo)
                })
            };
            _proto.removeItemsByPathStartWith = function(path) {
                var _this3 = this;
                var keys = Object.keys(this._map);
                var filteredKeys = keys.filter(function(key) {
                    return _this3._map[key].path.indexOf(path, 0) > -1
                });
                filteredKeys.forEach(function(key) {
                    return _this3.removeItemByKey(key)
                })
            };
            return FormItemsRunTimeInfo
        }();
        exports.default = FormItemsRunTimeInfo;
        module.exports = exports.default
    },
    /*!***************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/multi_view.js ***!
      \***************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _translator2 = __webpack_require__( /*! ../animation/translator */ 28);
        var _uiMulti_view = __webpack_require__( /*! ./multi_view/ui.multi_view.animation */ 638);
        var _math = __webpack_require__( /*! ../core/utils/math */ 29);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _visibility_change = __webpack_require__( /*! ../events/visibility_change */ 59);
        var _element = __webpack_require__( /*! ../core/element */ 18);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../core/devices */ 13));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _uiCollection_widget = _interopRequireDefault(__webpack_require__( /*! ./collection/ui.collection_widget.live_update */ 209));
        var _swipeable = _interopRequireDefault(__webpack_require__( /*! ../events/gesture/swipeable */ 172));
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var MULTIVIEW_CLASS = "dx-multiview";
        var MULTIVIEW_WRAPPER_CLASS = "dx-multiview-wrapper";
        var MULTIVIEW_ITEM_CONTAINER_CLASS = "dx-multiview-item-container";
        var MULTIVIEW_ITEM_CLASS = "dx-multiview-item";
        var MULTIVIEW_ITEM_HIDDEN_CLASS = "dx-multiview-item-hidden";
        var MULTIVIEW_ITEM_DATA_KEY = "dxMultiViewItemData";
        var MULTIVIEW_ANIMATION_DURATION = 200;
        var toNumber = function(value) {
            return +value
        };
        var position = function($element) {
            return (0, _translator2.locate)($element).left
        };
        var MultiView = _uiCollection_widget.default.inherit({
            _activeStateUnit: "." + MULTIVIEW_ITEM_CLASS,
            _supportedKeys: function() {
                return (0, _extend.extend)(this.callBase(), {
                    pageUp: _common.noop,
                    pageDown: _common.noop
                })
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    selectedIndex: 0,
                    swipeEnabled: true,
                    animationEnabled: true,
                    loop: false,
                    deferRendering: true,
                    _itemAttributes: {
                        role: "tabpanel"
                    },
                    loopItemFocus: false,
                    selectOnFocus: true,
                    selectionMode: "single",
                    selectionRequired: true,
                    selectionByClick: false
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: function() {
                        return "desktop" === _devices.default.real().deviceType && !_devices.default.isSimulator()
                    },
                    options: {
                        focusStateEnabled: true
                    }
                }])
            },
            _itemClass: function() {
                return MULTIVIEW_ITEM_CLASS
            },
            _itemDataKey: function() {
                return MULTIVIEW_ITEM_DATA_KEY
            },
            _itemContainer: function() {
                return this._$itemContainer
            },
            _itemElements: function() {
                return this._itemContainer().children(this._itemSelector())
            },
            _itemWidth: function() {
                if (!this._itemWidthValue) {
                    this._itemWidthValue = this._$wrapper.width()
                }
                return this._itemWidthValue
            },
            _clearItemWidthCache: function() {
                delete this._itemWidthValue
            },
            _itemsCount: function() {
                return this.option("items").length
            },
            _normalizeIndex: function(index) {
                var count = this._itemsCount();
                if (index < 0) {
                    index += count
                }
                if (index >= count) {
                    index -= count
                }
                return index
            },
            _getRTLSignCorrection: function() {
                return this.option("rtlEnabled") ? -1 : 1
            },
            _init: function() {
                this.callBase.apply(this, arguments);
                var $element = this.$element();
                $element.addClass(MULTIVIEW_CLASS);
                this._$wrapper = (0, _renderer.default)("<div>").addClass(MULTIVIEW_WRAPPER_CLASS);
                this._$wrapper.appendTo($element);
                this._$itemContainer = (0, _renderer.default)("<div>").addClass(MULTIVIEW_ITEM_CONTAINER_CLASS);
                this._$itemContainer.appendTo(this._$wrapper);
                this.option("loopItemFocus", this.option("loop"));
                this._initSwipeable()
            },
            _initMarkup: function() {
                this._deferredItems = [];
                this.callBase();
                var selectedItemIndices = this._getSelectedItemIndices();
                this._updateItemsVisibility(selectedItemIndices[0])
            },
            _afterItemElementDeleted: function($item, deletedActionArgs) {
                this.callBase($item, deletedActionArgs);
                if (this._deferredItems) {
                    this._deferredItems.splice(deletedActionArgs.itemIndex, 1)
                }
            },
            _beforeItemElementInserted: function(change) {
                this.callBase.apply(this, arguments);
                if (this._deferredItems) {
                    this._deferredItems.splice(change.index, 0, null)
                }
            },
            _executeItemRenderAction: function(index, itemData, itemElement) {
                index = (this.option("items") || []).indexOf(itemData);
                this.callBase(index, itemData, itemElement)
            },
            _renderItemContent: function(args) {
                var renderContentDeferred = new _deferred.Deferred;
                var that = this;
                var callBase = this.callBase;
                var deferred = new _deferred.Deferred;
                deferred.done(function() {
                    var $itemContent = callBase.call(that, args);
                    renderContentDeferred.resolve($itemContent)
                });
                this._deferredItems[args.index] = deferred;
                this.option("deferRendering") || deferred.resolve();
                return renderContentDeferred.promise()
            },
            _render: function() {
                var _this = this;
                this.callBase();
                (0, _common.deferRender)(function() {
                    var selectedItemIndices = _this._getSelectedItemIndices();
                    _this._updateItems(selectedItemIndices[0])
                })
            },
            _updateItems: function(selectedIndex, newIndex) {
                this._updateItemsPosition(selectedIndex, newIndex);
                this._updateItemsVisibility(selectedIndex, newIndex)
            },
            _modifyByChanges: function() {
                this.callBase.apply(this, arguments);
                var selectedItemIndices = this._getSelectedItemIndices();
                this._updateItemsVisibility(selectedItemIndices[0])
            },
            _updateItemsPosition: function(selectedIndex, newIndex) {
                var $itemElements = this._itemElements();
                var positionSign = (0, _type.isDefined)(newIndex) ? -this._animationDirection(newIndex, selectedIndex) : void 0;
                var $selectedItem = $itemElements.eq(selectedIndex);
                _uiMulti_view._translator.move($selectedItem, 0);
                if ((0, _type.isDefined)(newIndex)) {
                    _uiMulti_view._translator.move($itemElements.eq(newIndex), 100 * positionSign + "%")
                }
            },
            _updateItemsVisibility: function(selectedIndex, newIndex) {
                var $itemElements = this._itemElements();
                $itemElements.each(function(itemIndex, item) {
                    var $item = (0, _renderer.default)(item);
                    var isHidden = itemIndex !== selectedIndex && itemIndex !== newIndex;
                    if (!isHidden) {
                        this._renderSpecificItem(itemIndex)
                    }
                    $item.toggleClass(MULTIVIEW_ITEM_HIDDEN_CLASS, isHidden);
                    this.setAria("hidden", isHidden || void 0, $item)
                }.bind(this))
            },
            _renderSpecificItem: function(index) {
                var $item = this._itemElements().eq(index);
                var hasItemContent = $item.find(this._itemContentClass()).length > 0;
                if ((0, _type.isDefined)(index) && !hasItemContent) {
                    this._deferredItems[index].resolve();
                    (0, _visibility_change.triggerResizeEvent)($item)
                }
            },
            _refreshItem: function($item, item) {
                this.callBase($item, item);
                this._updateItemsVisibility(this.option("selectedIndex"))
            },
            _setAriaSelected: _common.noop,
            _updateSelection: function(addedSelection, removedSelection) {
                var newIndex = addedSelection[0];
                var prevIndex = removedSelection[0];
                _uiMulti_view.animation.complete(this._$itemContainer);
                this._updateItems(prevIndex, newIndex);
                var animationDirection = this._animationDirection(newIndex, prevIndex);
                this._animateItemContainer(animationDirection * this._itemWidth(), function() {
                    _uiMulti_view._translator.move(this._$itemContainer, 0);
                    this._updateItems(newIndex);
                    this._$itemContainer.width()
                }.bind(this))
            },
            _animateItemContainer: function(position, completeCallback) {
                var duration = this.option("animationEnabled") ? MULTIVIEW_ANIMATION_DURATION : 0;
                _uiMulti_view.animation.moveTo(this._$itemContainer, position, duration, completeCallback)
            },
            _animationDirection: function(newIndex, prevIndex) {
                var containerPosition = position(this._$itemContainer);
                var indexDifference = (prevIndex - newIndex) * this._getRTLSignCorrection() * this._getItemFocusLoopSignCorrection();
                var isSwipePresent = 0 !== containerPosition;
                var directionSignVariable = isSwipePresent ? containerPosition : indexDifference;
                return (0, _math.sign)(directionSignVariable)
            },
            _getSwipeDisabledState: function() {
                return !this.option("swipeEnabled") || this._itemsCount() <= 1
            },
            _initSwipeable: function() {
                var _this2 = this;
                this._createComponent(this.$element(), _swipeable.default, {
                    disabled: this._getSwipeDisabledState(),
                    elastic: false,
                    itemSizeFunc: this._itemWidth.bind(this),
                    onStart: function(args) {
                        return _this2._swipeStartHandler(args.event)
                    },
                    onUpdated: function(args) {
                        return _this2._swipeUpdateHandler(args.event)
                    },
                    onEnd: function(args) {
                        return _this2._swipeEndHandler(args.event)
                    }
                })
            },
            _swipeStartHandler: function(e) {
                _uiMulti_view.animation.complete(this._$itemContainer);
                var selectedIndex = this.option("selectedIndex");
                var loop = this.option("loop");
                var lastIndex = this._itemsCount() - 1;
                var rtl = this.option("rtlEnabled");
                e.maxLeftOffset = toNumber(loop || (rtl ? selectedIndex > 0 : selectedIndex < lastIndex));
                e.maxRightOffset = toNumber(loop || (rtl ? selectedIndex < lastIndex : selectedIndex > 0));
                this._swipeDirection = null
            },
            _swipeUpdateHandler: function(e) {
                var offset = e.offset;
                var swipeDirection = (0, _math.sign)(offset) * this._getRTLSignCorrection();
                _uiMulti_view._translator.move(this._$itemContainer, offset * this._itemWidth());
                if (swipeDirection !== this._swipeDirection) {
                    this._swipeDirection = swipeDirection;
                    var selectedIndex = this.option("selectedIndex");
                    var newIndex = this._normalizeIndex(selectedIndex - swipeDirection);
                    this._updateItems(selectedIndex, newIndex)
                }
            },
            _swipeEndHandler: function(e) {
                var targetOffset = e.targetOffset * this._getRTLSignCorrection();
                if (targetOffset) {
                    this.option("selectedIndex", this._normalizeIndex(this.option("selectedIndex") - targetOffset));
                    var $selectedElement = this.itemElements().filter(".dx-item-selected");
                    this.option("focusStateEnabled") && this.option("focusedElement", (0, _element.getPublicElement)($selectedElement))
                } else {
                    this._animateItemContainer(0, _common.noop)
                }
            },
            _getItemFocusLoopSignCorrection: function() {
                return this._itemFocusLooped ? -1 : 1
            },
            _moveFocus: function() {
                this.callBase.apply(this, arguments);
                this._itemFocusLooped = false
            },
            _prevItem: function($items) {
                var $result = this.callBase.apply(this, arguments);
                this._itemFocusLooped = $result.is($items.last());
                return $result
            },
            _nextItem: function($items) {
                var $result = this.callBase.apply(this, arguments);
                this._itemFocusLooped = $result.is($items.first());
                return $result
            },
            _dimensionChanged: function() {
                this._clearItemWidthCache()
            },
            _visibilityChanged: function(visible) {
                if (visible) {
                    this._dimensionChanged()
                }
            },
            _updateSwipeDisabledState: function() {
                var disabled = this._getSwipeDisabledState();
                _swipeable.default.getInstance(this.$element()).option("disabled", disabled)
            },
            _optionChanged: function(args) {
                var value = args.value;
                switch (args.name) {
                    case "loop":
                        this.option("loopItemFocus", value);
                        break;
                    case "animationEnabled":
                        break;
                    case "swipeEnabled":
                        this._updateSwipeDisabledState();
                        break;
                    case "deferRendering":
                        this._invalidate();
                        break;
                    case "items":
                        this._updateSwipeDisabledState();
                        this.callBase(args);
                        break;
                    default:
                        this.callBase(args)
                }
            }
        });
        (0, _component_registrator.default)("dxMultiView", MultiView);
        var _default = MultiView;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tabs/item.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _item = _interopRequireDefault(__webpack_require__( /*! ../collection/item */ 150));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var TABS_ITEM_BADGE_CLASS = "dx-tabs-item-badge";
        var BADGE_CLASS = "dx-badge";
        var TabsItem = _item.default.inherit({
            _renderWatchers: function() {
                this.callBase();
                this._startWatcher("badge", this._renderBadge.bind(this))
            },
            _renderBadge: function(badge) {
                this._$element.children("." + BADGE_CLASS).remove();
                if (!badge) {
                    return
                }
                var $badge = (0, _renderer.default)("<div>").addClass(TABS_ITEM_BADGE_CLASS).addClass(BADGE_CLASS).text(badge);
                this._$element.append($badge)
            }
        });
        var _default = TabsItem;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tabs/constants.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.TABS_EXPANDED_CLASS = void 0;
        var TABS_EXPANDED_CLASS = "dx-tabs-expanded";
        exports.TABS_EXPANDED_CLASS = TABS_EXPANDED_CLASS
    },
    /*!***********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/form/ui.form.utils.js ***!
      \***********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getItemPath = exports.isFullPathContainsTabs = exports.tryGetTabPath = exports.getOptionNameFromFullName = exports.getFullOptionName = exports.isExpectedItem = exports.getTextWithoutSpaces = exports.concatPaths = exports.createItemPathByIndex = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }
        var createItemPathByIndex = function(index, isTabs) {
            return "".concat(isTabs ? "tabs" : "items", "[").concat(index, "]")
        };
        exports.createItemPathByIndex = createItemPathByIndex;
        var concatPaths = function(path1, path2) {
            if ((0, _type.isDefined)(path1) && (0, _type.isDefined)(path2)) {
                return "".concat(path1, ".").concat(path2)
            }
            return path1 || path2
        };
        exports.concatPaths = concatPaths;
        var getTextWithoutSpaces = function(text) {
            return text ? text.replace(/\s/g, "") : void 0
        };
        exports.getTextWithoutSpaces = getTextWithoutSpaces;
        var isExpectedItem = function(item, fieldName) {
            return item && (item.dataField === fieldName || item.name === fieldName || getTextWithoutSpaces(item.title) === fieldName || "group" === item.itemType && getTextWithoutSpaces(item.caption) === fieldName)
        };
        exports.isExpectedItem = isExpectedItem;
        var getFullOptionName = function(path, optionName) {
            return "".concat(path, ".").concat(optionName)
        };
        exports.getFullOptionName = getFullOptionName;
        var getOptionNameFromFullName = function(fullName) {
            var parts = fullName.split(".");
            return parts[parts.length - 1].replace(/\[\d+]/, "")
        };
        exports.getOptionNameFromFullName = getOptionNameFromFullName;
        var tryGetTabPath = function(fullPath) {
            var pathParts = fullPath.split(".");
            var resultPathParts = _toConsumableArray(pathParts);
            for (var i = pathParts.length - 1; i >= 0; i--) {
                if (isFullPathContainsTabs(pathParts[i])) {
                    return resultPathParts.join(".")
                }
                resultPathParts.splice(i, 1)
            }
            return ""
        };
        exports.tryGetTabPath = tryGetTabPath;
        var isFullPathContainsTabs = function(fullPath) {
            return fullPath.indexOf("tabs") > -1
        };
        exports.isFullPathContainsTabs = isFullPathContainsTabs;
        var getItemPath = function getItemPath(items, item, isTabs) {
            var index = items.indexOf(item);
            if (index > -1) {
                return createItemPathByIndex(index, isTabs)
            }
            for (var i = 0; i < items.length; i++) {
                var targetItem = items[i];
                var tabOrGroupItems = targetItem.tabs || targetItem.items;
                if (tabOrGroupItems) {
                    var itemPath = getItemPath(tabOrGroupItems, item, targetItem.tabs);
                    if (itemPath) {
                        return concatPaths(createItemPathByIndex(i, isTabs), itemPath)
                    }
                }
            }
        };
        exports.getItemPath = getItemPath
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/responsive_box.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./widget/ui.errors */ 17));
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _box = _interopRequireDefault(__webpack_require__( /*! ./box */ 211));
        var _uiCollection_widget = _interopRequireDefault(__webpack_require__( /*! ./collection/ui.collection_widget.edit */ 54));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var RESPONSIVE_BOX_CLASS = "dx-responsivebox";
        var SCREEN_SIZE_CLASS_PREFIX = RESPONSIVE_BOX_CLASS + "-screen-";
        var BOX_ITEM_CLASS = "dx-box-item";
        var BOX_ITEM_DATA_KEY = "dxBoxItemData";
        var HD_SCREEN_WIDTH = 1920;
        var ResponsiveBox = _uiCollection_widget.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    rows: [],
                    cols: [],
                    screenByWidth: null,
                    singleColumnScreen: "",
                    height: "100%",
                    width: "100%",
                    activeStateEnabled: false,
                    focusStateEnabled: false,
                    onItemStateChanged: void 0,
                    onLayoutChanged: null,
                    currentScreenFactor: void 0,
                    _layoutStrategy: void 0
                })
            },
            _init: function() {
                if (!this.option("screenByWidth")) {
                    this._options.silent("screenByWidth", _window.defaultScreenFactorFunc)
                }
                this.callBase();
                this._initLayoutChangedAction()
            },
            _initLayoutChangedAction: function() {
                this._layoutChangedAction = this._createActionByOption("onLayoutChanged", {
                    excludeValidators: ["disabled", "readonly"]
                })
            },
            _itemClass: function() {
                return BOX_ITEM_CLASS
            },
            _itemDataKey: function() {
                return BOX_ITEM_DATA_KEY
            },
            _initMarkup: function() {
                this.callBase();
                this.$element().addClass(RESPONSIVE_BOX_CLASS);
                this._updateRootBox()
            },
            _updateRootBox: function() {
                clearTimeout(this._updateTimer);
                this._updateTimer = setTimeout(function() {
                    if (this._$root) {
                        _events_engine.default.triggerHandler(this._$root, "dxupdate")
                    }
                }.bind(this))
            },
            _renderItems: function() {
                this._setScreenSize();
                this._screenItems = this._itemsByScreen();
                this._prepareGrid();
                this._spreadItems();
                this._layoutItems();
                this._linkNodeToItem()
            },
            _itemOptionChanged: function(item) {
                var $item = this._findItemElementByItem(item);
                if (!$item.length) {
                    return
                }
                this._refreshItem($item, item);
                this._clearItemNodeTemplates();
                this._update(true)
            },
            _setScreenSize: function() {
                var currentScreen = this._getCurrentScreen();
                this._removeScreenSizeClass();
                this.$element().addClass(SCREEN_SIZE_CLASS_PREFIX + currentScreen);
                this.option("currentScreenFactor", currentScreen)
            },
            _removeScreenSizeClass: function() {
                var currentScreenFactor = this.option("currentScreenFactor");
                currentScreenFactor && this.$element().removeClass(SCREEN_SIZE_CLASS_PREFIX + currentScreenFactor)
            },
            _prepareGrid: function() {
                var grid = this._grid = [];
                this._prepareRowsAndCols();
                (0, _iterator.each)(this._rows, function() {
                    var row = [];
                    grid.push(row);
                    (0, _iterator.each)(this._cols, function() {
                        row.push(this._createEmptyCell())
                    }.bind(this))
                }.bind(this))
            },
            getSingleColumnRows: function() {
                var rows = this.option("rows");
                var screenItemsLength = this._screenItems.length;
                if (rows.length) {
                    var filteredRows = this._filterByScreen(rows);
                    var result = [];
                    for (var i = 0; i < screenItemsLength; i++) {
                        var sizeConfig = this._defaultSizeConfig();
                        if (i < filteredRows.length && (0, _type.isDefined)(filteredRows[i].shrink)) {
                            sizeConfig.shrink = filteredRows[i].shrink
                        }
                        result.push(sizeConfig)
                    }
                    return result
                } else {
                    return this._defaultSizeConfig(screenItemsLength)
                }
            },
            _prepareRowsAndCols: function() {
                if (this._isSingleColumnScreen()) {
                    this._prepareSingleColumnScreenItems();
                    this._rows = this.getSingleColumnRows();
                    this._cols = this._defaultSizeConfig(1)
                } else {
                    this._rows = this._sizesByScreen(this.option("rows"));
                    this._cols = this._sizesByScreen(this.option("cols"))
                }
            },
            _isSingleColumnScreen: function() {
                return this._screenRegExp().test(this.option("singleColumnScreen")) || !this.option("rows").length || !this.option("cols").length
            },
            _prepareSingleColumnScreenItems: function() {
                this._screenItems.sort(function(item1, item2) {
                    return item1.location.row - item2.location.row || item1.location.col - item2.location.col
                });
                (0, _iterator.each)(this._screenItems, function(index, item) {
                    (0, _extend.extend)(item.location, {
                        row: index,
                        col: 0,
                        rowspan: 1,
                        colspan: 1
                    })
                })
            },
            _sizesByScreen: function(sizeConfigs) {
                return (0, _iterator.map)(this._filterByScreen(sizeConfigs), function(sizeConfig) {
                    return (0, _extend.extend)(this._defaultSizeConfig(), sizeConfig)
                }.bind(this))
            },
            _createDefaultSizeConfig: function() {
                return {
                    ratio: 1,
                    baseSize: 0,
                    minSize: 0,
                    maxSize: 0
                }
            },
            _defaultSizeConfig: function(size) {
                var defaultSizeConfig = this._createDefaultSizeConfig();
                if (!arguments.length) {
                    return defaultSizeConfig
                }
                var result = [];
                for (var i = 0; i < size; i++) {
                    result.push(defaultSizeConfig)
                }
                return result
            },
            _filterByScreen: function(items) {
                var screenRegExp = this._screenRegExp();
                return (0, _common.grep)(items, function(item) {
                    return !item.screen || screenRegExp.test(item.screen)
                })
            },
            _screenRegExp: function() {
                var screen = this._getCurrentScreen();
                return new RegExp("(^|\\s)" + screen + "($|\\s)", "i")
            },
            _getCurrentScreen: function() {
                var width = this._screenWidth();
                return this.option("screenByWidth")(width)
            },
            _screenWidth: function() {
                return (0, _window.hasWindow)() ? (0, _renderer.default)(window).width() : HD_SCREEN_WIDTH
            },
            _createEmptyCell: function() {
                return {
                    item: {},
                    location: {
                        colspan: 1,
                        rowspan: 1
                    }
                }
            },
            _spreadItems: function() {
                (0, _iterator.each)(this._screenItems, function(_, itemInfo) {
                    var location = itemInfo.location || {};
                    var itemCol = location.col;
                    var itemRow = location.row;
                    var row = this._grid[itemRow];
                    var itemCell = row && row[itemCol];
                    this._occupyCells(itemCell, itemInfo)
                }.bind(this))
            },
            _itemsByScreen: function() {
                var _this = this;
                return this.option("items").reduce(function(result, item) {
                    var locations = item.location || {};
                    locations = (0, _type.isPlainObject)(locations) ? [locations] : locations;
                    _this._filterByScreen(locations).forEach(function(location) {
                        result.push({
                            item: item,
                            location: (0, _extend.extend)({
                                rowspan: 1,
                                colspan: 1
                            }, location)
                        })
                    });
                    return result
                }, [])
            },
            _occupyCells: function(itemCell, itemInfo) {
                if (!itemCell || this._isItemCellOccupied(itemCell, itemInfo)) {
                    return
                }(0, _extend.extend)(itemCell, itemInfo);
                this._markSpanningCell(itemCell)
            },
            _isItemCellOccupied: function(itemCell, itemInfo) {
                if (!(0, _type.isEmptyObject)(itemCell.item)) {
                    return true
                }
                var result = false;
                this._loopOverSpanning(itemInfo.location, function(cell) {
                    result = result || !(0, _type.isEmptyObject)(cell.item)
                });
                return result
            },
            _loopOverSpanning: function(location, callback) {
                var rowEnd = location.row + location.rowspan - 1;
                var colEnd = location.col + location.colspan - 1;
                var boundRowEnd = Math.min(rowEnd, this._rows.length - 1);
                var boundColEnd = Math.min(colEnd, this._cols.length - 1);
                location.rowspan -= rowEnd - boundRowEnd;
                location.colspan -= colEnd - boundColEnd;
                for (var rowIndex = location.row; rowIndex <= boundRowEnd; rowIndex++) {
                    for (var colIndex = location.col; colIndex <= boundColEnd; colIndex++) {
                        if (rowIndex !== location.row || colIndex !== location.col) {
                            callback(this._grid[rowIndex][colIndex])
                        }
                    }
                }
            },
            _markSpanningCell: function(itemCell) {
                this._loopOverSpanning(itemCell.location, function(cell) {
                    (0, _extend.extend)(cell, {
                        item: itemCell.item,
                        spanningCell: itemCell
                    })
                })
            },
            _linkNodeToItem: function() {
                (0, _iterator.each)(this._itemElements(), function(_, itemNode) {
                    var $item = (0, _renderer.default)(itemNode);
                    var item = $item.data(BOX_ITEM_DATA_KEY);
                    if (!item.box) {
                        item.node = $item.children()
                    }
                })
            },
            _layoutItems: function() {
                var rowsCount = this._grid.length;
                var colsCount = rowsCount && this._grid[0].length;
                if (!rowsCount && !colsCount) {
                    return
                }
                var result = this._layoutBlock({
                    direction: "col",
                    row: {
                        start: 0,
                        end: rowsCount - 1
                    },
                    col: {
                        start: 0,
                        end: colsCount - 1
                    }
                });
                var rootBox = this._prepareBoxConfig(result.box || {
                    direction: "row",
                    items: [(0, _extend.extend)(result, {
                        ratio: 1
                    })]
                });
                (0, _extend.extend)(rootBox, this._rootBoxConfig(rootBox.items));
                this._$root = (0, _renderer.default)("<div>").appendTo(this._itemContainer());
                this._createComponent(this._$root, _box.default, rootBox)
            },
            _rootBoxConfig: function(items) {
                var rootItems = (0, _iterator.each)(items, function(index, item) {
                    this._needApplyAutoBaseSize(item) && (0, _extend.extend)(item, {
                        baseSize: "auto"
                    })
                }.bind(this));
                return (0, _extend.extend)({
                    width: "100%",
                    height: "100%",
                    items: rootItems,
                    itemTemplate: this._getTemplateByOption("itemTemplate"),
                    itemHoldTimeout: this.option("itemHoldTimeout"),
                    onItemHold: this._createActionByOption("onItemHold"),
                    onItemClick: this._createActionByOption("onItemClick"),
                    onItemContextMenu: this._createActionByOption("onItemContextMenu"),
                    onItemRendered: this._createActionByOption("onItemRendered")
                }, {
                    _layoutStrategy: this.option("_layoutStrategy")
                })
            },
            _needApplyAutoBaseSize: function(item) {
                return !item.baseSize && (!item.minSize || "auto" === item.minSize) && (!item.maxSize || "auto" === item.maxSize)
            },
            _prepareBoxConfig: function(config) {
                return (0, _extend.extend)(config || {}, {
                    crossAlign: "stretch",
                    onItemStateChanged: this.option("onItemStateChanged")
                })
            },
            _layoutBlock: function(options) {
                if (this._isSingleItem(options)) {
                    return this._itemByCell(options.row.start, options.col.start)
                }
                return this._layoutDirection(options)
            },
            _isSingleItem: function(options) {
                var firstCellLocation = this._grid[options.row.start][options.col.start].location;
                var isItemRowSpanned = options.row.end - options.row.start === firstCellLocation.rowspan - 1;
                var isItemColSpanned = options.col.end - options.col.start === firstCellLocation.colspan - 1;
                return isItemRowSpanned && isItemColSpanned
            },
            _itemByCell: function(rowIndex, colIndex) {
                var itemCell = this._grid[rowIndex][colIndex];
                return itemCell.spanningCell ? null : itemCell.item
            },
            _layoutDirection: function(options) {
                var items = [];
                var direction = options.direction;
                var crossDirection = this._crossDirection(direction);
                var block;
                while (block = this._nextBlock(options)) {
                    if (this._isBlockIndivisible(options.prevBlockOptions, block)) {
                        throw _ui.default.Error("E1025")
                    }
                    var item = this._layoutBlock({
                        direction: crossDirection,
                        row: block.row,
                        col: block.col,
                        prevBlockOptions: options
                    });
                    if (item) {
                        (0, _extend.extend)(item, this._blockSize(block, crossDirection));
                        items.push(item)
                    }
                    options[crossDirection].start = block[crossDirection].end + 1
                }
                return {
                    box: this._prepareBoxConfig({
                        direction: direction,
                        items: items
                    })
                }
            },
            _isBlockIndivisible: function(options, block) {
                return options && options.col.start === block.col.start && options.col.end === block.col.end && options.row.start === block.row.start && options.row.end === block.row.end
            },
            _crossDirection: function(direction) {
                return "col" === direction ? "row" : "col"
            },
            _nextBlock: function(options) {
                var direction = options.direction;
                var crossDirection = this._crossDirection(direction);
                var startIndex = options[direction].start;
                var endIndex = options[direction].end;
                var crossStartIndex = options[crossDirection].start;
                if (crossStartIndex > options[crossDirection].end) {
                    return null
                }
                var crossSpan = 1;
                for (var crossIndex = crossStartIndex; crossIndex < crossStartIndex + crossSpan; crossIndex++) {
                    var lineCrossSpan = 1;
                    for (var index = startIndex; index <= endIndex; index++) {
                        var cell = this._cellByDirection(direction, index, crossIndex);
                        lineCrossSpan = Math.max(lineCrossSpan, cell.location[crossDirection + "span"])
                    }
                    var lineCrossEndIndex = crossIndex + lineCrossSpan;
                    var crossEndIndex = crossStartIndex + crossSpan;
                    if (lineCrossEndIndex > crossEndIndex) {
                        crossSpan += lineCrossEndIndex - crossEndIndex
                    }
                }
                var result = {};
                result[direction] = {
                    start: startIndex,
                    end: endIndex
                };
                result[crossDirection] = {
                    start: crossStartIndex,
                    end: crossStartIndex + crossSpan - 1
                };
                return result
            },
            _cellByDirection: function(direction, index, crossIndex) {
                return "col" === direction ? this._grid[crossIndex][index] : this._grid[index][crossIndex]
            },
            _blockSize: function(block, direction) {
                var defaultMinSize = "row" === direction ? "auto" : 0;
                var sizeConfigs = "row" === direction ? this._rows : this._cols;
                var result = (0, _extend.extend)(this._createDefaultSizeConfig(), {
                    ratio: 0
                });
                for (var index = block[direction].start; index <= block[direction].end; index++) {
                    var sizeConfig = sizeConfigs[index];
                    result.ratio += sizeConfig.ratio;
                    result.baseSize += sizeConfig.baseSize;
                    result.minSize += sizeConfig.minSize;
                    result.maxSize += sizeConfig.maxSize;
                    if ((0, _type.isDefined)(sizeConfig.shrink)) {
                        result.shrink = sizeConfig.shrink
                    }
                }
                result.minSize = result.minSize ? result.minSize : defaultMinSize;
                result.maxSize = result.maxSize ? result.maxSize : "auto";
                this._isSingleColumnScreen() && (result.baseSize = "auto");
                return result
            },
            _update: function(forceRemoveRoot) {
                var $existingRoot = this._$root;
                this._renderItems();
                if ($existingRoot) {
                    if (forceRemoveRoot) {
                        $existingRoot.remove()
                    } else {
                        $existingRoot.detach();
                        this._saveAssistantRoot($existingRoot)
                    }
                }
                this._layoutChangedAction();
                this._updateRootBox()
            },
            _saveAssistantRoot: function($root) {
                this._assistantRoots = this._assistantRoots || [];
                this._assistantRoots.push($root)
            },
            _dispose: function() {
                clearTimeout(this._updateTimer);
                this._clearItemNodeTemplates();
                this._cleanUnusedRoots();
                this.callBase.apply(this, arguments)
            },
            _cleanUnusedRoots: function() {
                if (!this._assistantRoots) {
                    return
                }(0, _iterator.each)(this._assistantRoots, function(_, item) {
                    (0, _renderer.default)(item).remove()
                })
            },
            _clearItemNodeTemplates: function() {
                (0, _iterator.each)(this.option("items"), function() {
                    delete this.node
                })
            },
            _toggleVisibility: function(visible) {
                this.callBase(visible);
                if (visible) {
                    this._updateRootBox()
                }
            },
            _attachClickEvent: _common.noop,
            _optionChanged: function(args) {
                switch (args.name) {
                    case "rows":
                    case "cols":
                    case "screenByWidth":
                    case "_layoutStrategy":
                    case "singleColumnScreen":
                        this._clearItemNodeTemplates();
                        this._invalidate();
                        break;
                    case "width":
                    case "height":
                        this.callBase(args);
                        this._update();
                        break;
                    case "onLayoutChanged":
                        this._initLayoutChangedAction();
                        break;
                    case "itemTemplate":
                        this._clearItemNodeTemplates();
                        this.callBase(args);
                        break;
                    case "currentScreenFactor":
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _dimensionChanged: function() {
                if (this._getCurrentScreen() !== this.option("currentScreenFactor")) {
                    this._update()
                }
            },
            repaint: function() {
                this._update()
            }
        });
        (0, _component_registrator.default)("dxResponsiveBox", ResponsiveBox);
        var _default = ResponsiveBox;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/form/constants.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.FORM_VALIDATION_SUMMARY = exports.GROUP_COL_COUNT_ATTR = exports.GROUP_COL_COUNT_CLASS = exports.FIELD_ITEM_TAB_CLASS = exports.HIDDEN_LABEL_CLASS = exports.FORM_GROUP_WITH_CAPTION_CLASS = exports.FIELD_ITEM_CONTENT_HAS_TABS_CLASS = exports.FIELD_ITEM_CONTENT_HAS_GROUP_CLASS = exports.FORM_GROUP_CONTENT_CLASS = exports.ROOT_SIMPLE_ITEM_CLASS = exports.SINGLE_COLUMN_ITEM_CONTENT = exports.FIELD_BUTTON_ITEM_CLASS = exports.FIELD_EMPTY_ITEM_CLASS = exports.FIELD_ITEM_CONTENT_CLASS = exports.FIELD_ITEM_CONTENT_LOCATION_CLASS = exports.FIELD_ITEM_LABEL_CLASS = exports.FIELD_ITEM_LABEL_ALIGN_CLASS = exports.FIELD_ITEM_LABEL_LOCATION_CLASS = exports.LABEL_HORIZONTAL_ALIGNMENT_CLASS = exports.LABEL_VERTICAL_ALIGNMENT_CLASS = exports.FORM_LAYOUT_MANAGER_CLASS = exports.FIELD_ITEM_CONTENT_WRAPPER_CLASS = exports.FIELD_ITEM_HELP_TEXT_CLASS = exports.FIELD_ITEM_LABEL_CONTENT_CLASS = exports.FIELD_ITEM_LABEL_TEXT_CLASS = exports.FIELD_ITEM_REQUIRED_CLASS = exports.FIELD_ITEM_OPTIONAL_CLASS = exports.FIELD_ITEM_REQUIRED_MARK_CLASS = exports.FIELD_ITEM_OPTIONAL_MARK_CLASS = exports.LAYOUT_MANAGER_ONE_COLUMN = exports.FLEX_LAYOUT_CLASS = exports.FIELD_ITEM_CLASS = exports.FORM_FIELD_ITEM_COL_CLASS = exports.FORM_GROUP_CAPTION_CLASS = exports.FORM_GROUP_CLASS = exports.FORM_CLASS = void 0;
        var FORM_CLASS = "dx-form";
        exports.FORM_CLASS = FORM_CLASS;
        var FORM_GROUP_CLASS = "dx-form-group";
        exports.FORM_GROUP_CLASS = FORM_GROUP_CLASS;
        var FORM_GROUP_CAPTION_CLASS = "dx-form-group-caption";
        exports.FORM_GROUP_CAPTION_CLASS = FORM_GROUP_CAPTION_CLASS;
        var FORM_FIELD_ITEM_COL_CLASS = "dx-col-";
        exports.FORM_FIELD_ITEM_COL_CLASS = FORM_FIELD_ITEM_COL_CLASS;
        var FIELD_ITEM_CLASS = "dx-field-item";
        exports.FIELD_ITEM_CLASS = FIELD_ITEM_CLASS;
        var FLEX_LAYOUT_CLASS = "dx-flex-layout";
        exports.FLEX_LAYOUT_CLASS = FLEX_LAYOUT_CLASS;
        var LAYOUT_MANAGER_ONE_COLUMN = "dx-layout-manager-one-col";
        exports.LAYOUT_MANAGER_ONE_COLUMN = LAYOUT_MANAGER_ONE_COLUMN;
        var FIELD_ITEM_OPTIONAL_MARK_CLASS = "dx-field-item-optional-mark";
        exports.FIELD_ITEM_OPTIONAL_MARK_CLASS = FIELD_ITEM_OPTIONAL_MARK_CLASS;
        var FIELD_ITEM_REQUIRED_MARK_CLASS = "dx-field-item-required-mark";
        exports.FIELD_ITEM_REQUIRED_MARK_CLASS = FIELD_ITEM_REQUIRED_MARK_CLASS;
        var FIELD_ITEM_OPTIONAL_CLASS = "dx-field-item-optional";
        exports.FIELD_ITEM_OPTIONAL_CLASS = FIELD_ITEM_OPTIONAL_CLASS;
        var FIELD_ITEM_REQUIRED_CLASS = "dx-field-item-required";
        exports.FIELD_ITEM_REQUIRED_CLASS = FIELD_ITEM_REQUIRED_CLASS;
        var FIELD_ITEM_LABEL_TEXT_CLASS = "dx-field-item-label-text";
        exports.FIELD_ITEM_LABEL_TEXT_CLASS = FIELD_ITEM_LABEL_TEXT_CLASS;
        var FIELD_ITEM_LABEL_CONTENT_CLASS = "dx-field-item-label-content";
        exports.FIELD_ITEM_LABEL_CONTENT_CLASS = FIELD_ITEM_LABEL_CONTENT_CLASS;
        var FIELD_ITEM_HELP_TEXT_CLASS = "dx-field-item-help-text";
        exports.FIELD_ITEM_HELP_TEXT_CLASS = FIELD_ITEM_HELP_TEXT_CLASS;
        var FIELD_ITEM_CONTENT_WRAPPER_CLASS = "dx-field-item-content-wrapper";
        exports.FIELD_ITEM_CONTENT_WRAPPER_CLASS = FIELD_ITEM_CONTENT_WRAPPER_CLASS;
        var FORM_LAYOUT_MANAGER_CLASS = "dx-layout-manager";
        exports.FORM_LAYOUT_MANAGER_CLASS = FORM_LAYOUT_MANAGER_CLASS;
        var LABEL_VERTICAL_ALIGNMENT_CLASS = "dx-label-v-align";
        exports.LABEL_VERTICAL_ALIGNMENT_CLASS = LABEL_VERTICAL_ALIGNMENT_CLASS;
        var LABEL_HORIZONTAL_ALIGNMENT_CLASS = "dx-label-h-align";
        exports.LABEL_HORIZONTAL_ALIGNMENT_CLASS = LABEL_HORIZONTAL_ALIGNMENT_CLASS;
        var FIELD_ITEM_LABEL_LOCATION_CLASS = "dx-field-item-label-location-";
        exports.FIELD_ITEM_LABEL_LOCATION_CLASS = FIELD_ITEM_LABEL_LOCATION_CLASS;
        var FIELD_ITEM_LABEL_ALIGN_CLASS = "dx-field-item-label-align";
        exports.FIELD_ITEM_LABEL_ALIGN_CLASS = FIELD_ITEM_LABEL_ALIGN_CLASS;
        var FIELD_ITEM_LABEL_CLASS = "dx-field-item-label";
        exports.FIELD_ITEM_LABEL_CLASS = FIELD_ITEM_LABEL_CLASS;
        var FIELD_ITEM_CONTENT_LOCATION_CLASS = "dx-field-item-content-location-";
        exports.FIELD_ITEM_CONTENT_LOCATION_CLASS = FIELD_ITEM_CONTENT_LOCATION_CLASS;
        var FIELD_ITEM_CONTENT_CLASS = "dx-field-item-content";
        exports.FIELD_ITEM_CONTENT_CLASS = FIELD_ITEM_CONTENT_CLASS;
        var FIELD_EMPTY_ITEM_CLASS = "dx-field-empty-item";
        exports.FIELD_EMPTY_ITEM_CLASS = FIELD_EMPTY_ITEM_CLASS;
        var FIELD_BUTTON_ITEM_CLASS = "dx-field-button-item";
        exports.FIELD_BUTTON_ITEM_CLASS = FIELD_BUTTON_ITEM_CLASS;
        var SINGLE_COLUMN_ITEM_CONTENT = "dx-single-column-item-content";
        exports.SINGLE_COLUMN_ITEM_CONTENT = SINGLE_COLUMN_ITEM_CONTENT;
        var ROOT_SIMPLE_ITEM_CLASS = "dx-root-simple-item";
        exports.ROOT_SIMPLE_ITEM_CLASS = ROOT_SIMPLE_ITEM_CLASS;
        var FORM_GROUP_CONTENT_CLASS = "dx-form-group-content";
        exports.FORM_GROUP_CONTENT_CLASS = FORM_GROUP_CONTENT_CLASS;
        var FIELD_ITEM_CONTENT_HAS_GROUP_CLASS = "dx-field-item-has-group";
        exports.FIELD_ITEM_CONTENT_HAS_GROUP_CLASS = FIELD_ITEM_CONTENT_HAS_GROUP_CLASS;
        var FIELD_ITEM_CONTENT_HAS_TABS_CLASS = "dx-field-item-has-tabs";
        exports.FIELD_ITEM_CONTENT_HAS_TABS_CLASS = FIELD_ITEM_CONTENT_HAS_TABS_CLASS;
        var FORM_GROUP_WITH_CAPTION_CLASS = "dx-form-group-with-caption";
        exports.FORM_GROUP_WITH_CAPTION_CLASS = FORM_GROUP_WITH_CAPTION_CLASS;
        var HIDDEN_LABEL_CLASS = "dx-layout-manager-hidden-label";
        exports.HIDDEN_LABEL_CLASS = HIDDEN_LABEL_CLASS;
        var FIELD_ITEM_TAB_CLASS = "dx-field-item-tab";
        exports.FIELD_ITEM_TAB_CLASS = FIELD_ITEM_TAB_CLASS;
        var GROUP_COL_COUNT_CLASS = "dx-group-colcount-";
        exports.GROUP_COL_COUNT_CLASS = GROUP_COL_COUNT_CLASS;
        var GROUP_COL_COUNT_ATTR = "group-col-count";
        exports.GROUP_COL_COUNT_ATTR = GROUP_COL_COUNT_ATTR;
        var FORM_VALIDATION_SUMMARY = "dx-form-validation-summary";
        exports.FORM_VALIDATION_SUMMARY = FORM_VALIDATION_SUMMARY
    },
    /*!*********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/validation_group.js ***!
      \*********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _dom_component = _interopRequireDefault(__webpack_require__( /*! ../core/dom_component */ 67));
        var _validation_summary = _interopRequireDefault(__webpack_require__( /*! ./validation_summary */ 285));
        var _validation_engine = _interopRequireDefault(__webpack_require__( /*! ./validation_engine */ 96));
        var _validator = _interopRequireDefault(__webpack_require__( /*! ./validator */ 216));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var VALIDATION_ENGINE_CLASS = "dx-validationgroup";
        var VALIDATOR_CLASS = "dx-validator";
        var VALIDATION_SUMMARY_CLASS = "dx-validationsummary";
        var ValidationGroup = function(_DOMComponent) {
            _inheritsLoose(ValidationGroup, _DOMComponent);

            function ValidationGroup() {
                return _DOMComponent.apply(this, arguments) || this
            }
            var _proto = ValidationGroup.prototype;
            _proto._getDefaultOptions = function() {
                return _DOMComponent.prototype._getDefaultOptions.call(this)
            };
            _proto._init = function() {
                _DOMComponent.prototype._init.call(this);
                _validation_engine.default.addGroup(this)
            };
            _proto._initMarkup = function() {
                var $element = this.$element();
                $element.addClass(VALIDATION_ENGINE_CLASS);
                $element.find(".".concat(VALIDATOR_CLASS)).each(function(_, validatorContainer) {
                    _validator.default.getInstance((0, _renderer.default)(validatorContainer))._initGroupRegistration()
                });
                $element.find(".".concat(VALIDATION_SUMMARY_CLASS)).each(function(_, summaryContainer) {
                    _validation_summary.default.getInstance((0, _renderer.default)(summaryContainer))._initGroupRegistration()
                });
                _DOMComponent.prototype._initMarkup.call(this)
            };
            _proto.validate = function() {
                return _validation_engine.default.validateGroup(this)
            };
            _proto.reset = function() {
                return _validation_engine.default.resetGroup(this)
            };
            _proto._dispose = function() {
                _validation_engine.default.removeGroup(this);
                this.$element().removeClass(VALIDATION_ENGINE_CLASS);
                _DOMComponent.prototype._dispose.call(this)
            };
            _proto._useTemplates = function() {
                return false
            };
            return ValidationGroup
        }(_dom_component.default);
        (0, _component_registrator.default)("dxValidationGroup", ValidationGroup);
        var _default = ValidationGroup;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/toolbar/ui.toolbar.strategy.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _data = __webpack_require__( /*! ../../core/utils/data */ 20);
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _button = _interopRequireDefault(__webpack_require__( /*! ../button */ 37));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var abstract = _class.default.abstract;
        var TOOLBAR_MENU_CONTAINER_CLASS = "dx-toolbar-menu-container";
        var TOOLBAR_MENU_BUTTON_CLASS = "dx-toolbar-menu-button";
        var ToolbarStrategy = _class.default.inherit({
            ctor: function(toolbar) {
                this._toolbar = toolbar
            },
            render: function() {
                this._renderMenuButton();
                this._renderWidget()
            },
            _widgetOptions: function() {
                var itemClickAction = this._toolbar._createActionByOption("onItemClick");
                return {
                    itemTemplate: this._getMenuItemTemplate.bind(this),
                    onItemClick: function(e) {
                        this._toggleMenu(false, true);
                        itemClickAction(e)
                    }.bind(this)
                }
            },
            _getMenuItemTemplate: function() {
                return this._toolbar._getTemplateByOption("menuItemTemplate")
            },
            _renderWidget: function() {
                var $menu = (0, _renderer.default)("<div>").appendTo(this._menuContainer());
                this._menu = this._toolbar._createComponent($menu, this._menuWidgetClass(), this._widgetOptions());
                this.renderMenuItems()
            },
            _menuContainer: abstract,
            _menuWidgetClass: abstract,
            _hasVisibleMenuItems: function(items) {
                var menuItems = items || this._toolbar.option("items");
                var result = false;
                var optionGetter = (0, _data.compileGetter)("visible");
                var overflowGetter = (0, _data.compileGetter)("locateInMenu");
                (0, _iterator.each)(menuItems, function(index, item) {
                    var itemVisible = optionGetter(item, {
                        functionsAsIs: true
                    });
                    var itemOverflow = overflowGetter(item, {
                        functionsAsIs: true
                    });
                    if (false !== itemVisible && ("auto" === itemOverflow || "always" === itemOverflow) || "menu" === item.location) {
                        result = true
                    }
                });
                return result
            },
            _getMenuItems: function() {
                return this._toolbar._getMenuItems()
            },
            _updateMenuVisibility: _common.noop,
            _renderMenuButton: function() {
                var buttonOptions = this._menuButtonOptions();
                this._renderMenuButtonContainer();
                this._$button = (0, _renderer.default)("<div>").appendTo(this._$menuButtonContainer).addClass(TOOLBAR_MENU_BUTTON_CLASS);
                this._toolbar._createComponent(this._$button, _button.default, buttonOptions)
            },
            _menuButtonOptions: function() {
                return {
                    onClick: this._menuButtonClickHandler.bind(this)
                }
            },
            _menuButtonClickHandler: function() {
                this._toggleMenu(!this._menuShown, true)
            },
            _renderMenuButtonContainer: function() {
                var $afterSection = this._toolbar._$afterSection;
                this._$menuButtonContainer = (0, _renderer.default)("<div>").appendTo($afterSection).addClass(this._toolbar._buttonClass()).addClass(TOOLBAR_MENU_CONTAINER_CLASS)
            },
            renderMenuItems: function() {
                this._menu && this._menu.option("items", this._getMenuItems())
            },
            toggleMenuVisibility: function(visible, animate) {
                this._menu && this._toggleMenu(visible, animate)
            },
            _toggleMenu: function(visible) {
                this._menuShown = visible
            },
            getMenuWidget: function() {
                return this._menu
            },
            widgetOption: function(name, value) {
                this._menu && this._menu.option(name, value)
            },
            handleToolbarVisibilityChange: _common.noop
        });
        var _default = ToolbarStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/html_editor/modules/popup.js ***!
      \******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _devextremeQuill = _interopRequireDefault(__webpack_require__( /*! devextreme-quill */ 61));
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../../core/utils/extend */ 0);
        var _window = __webpack_require__( /*! ../../../core/utils/window */ 7);
        var _popup = _interopRequireDefault(__webpack_require__( /*! ../../popup */ 46));
        var _list = _interopRequireDefault(__webpack_require__( /*! ../../list */ 112));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var ListPopupModule = {};
        if (_devextremeQuill.default) {
            var SUGGESTION_LIST_CLASS = "dx-suggestion-list";
            var SUGGESTION_LIST_WRAPPER_CLASS = "dx-suggestion-list-wrapper";
            var BaseModule = _devextremeQuill.default.import("core/module");
            var MIN_HEIGHT = 100;
            ListPopupModule = function(_BaseModule) {
                _inheritsLoose(ListPopupModule, _BaseModule);
                var _proto = ListPopupModule.prototype;
                _proto._getDefaultOptions = function() {
                    return {
                        dataSource: null
                    }
                };

                function ListPopupModule(quill, options) {
                    var _this;
                    _this = _BaseModule.call(this, quill, options) || this;
                    _this.options = (0, _extend.extend)({}, _this._getDefaultOptions(), options);
                    _this._popup = _this.renderPopup();
                    _this._popup._wrapper().addClass(SUGGESTION_LIST_WRAPPER_CLASS);
                    return _this
                }
                _proto.renderList = function($container, options) {
                    var $list = (0, _renderer.default)("<div>").addClass(SUGGESTION_LIST_CLASS).appendTo($container);
                    this._list = this.options.editorInstance._createComponent($list, _list.default, options)
                };
                _proto.renderPopup = function() {
                    var editorInstance = this.options.editorInstance;
                    var $container = (0, _renderer.default)("<div>").appendTo(editorInstance.$element());
                    var popupConfig = this._getPopupConfig();
                    return editorInstance._createComponent($container, _popup.default, popupConfig)
                };
                _proto._getPopupConfig = function() {
                    var _this2 = this;
                    return {
                        contentTemplate: function(contentElem) {
                            var listConfig = _this2._getListConfig(_this2.options);
                            _this2.renderList((0, _renderer.default)(contentElem), listConfig)
                        },
                        deferRendering: false,
                        onShown: function() {
                            _this2._list.focus()
                        },
                        onHidden: function() {
                            _this2._list.unselectAll();
                            _this2._list.option("focusedElement", null)
                        },
                        showTitle: false,
                        width: "auto",
                        height: "auto",
                        shading: false,
                        closeOnTargetScroll: true,
                        closeOnOutsideClick: true,
                        animation: {
                            show: {
                                type: "fade",
                                duration: 0,
                                from: 0,
                                to: 1
                            },
                            hide: {
                                type: "fade",
                                duration: 400,
                                from: 1,
                                to: 0
                            }
                        },
                        fullScreen: false,
                        maxHeight: this.maxHeight
                    }
                };
                _proto._getListConfig = function(options) {
                    return {
                        dataSource: options.dataSource,
                        onSelectionChanged: this.selectionChangedHandler.bind(this),
                        selectionMode: "single",
                        pageLoadMode: "scrollBottom"
                    }
                };
                _proto.selectionChangedHandler = function(e) {
                    if (this._popup.option("visible")) {
                        this._popup.hide();
                        this.insertEmbedContent(e)
                    }
                };
                _proto.insertEmbedContent = function(selectionChangedEvent) {};
                _proto.showPopup = function() {
                    this._popup && this._popup.show()
                };
                _proto.savePosition = function(position) {
                    this.caretPosition = position
                };
                _proto.getPosition = function() {
                    return this.caretPosition
                };
                _createClass(ListPopupModule, [{
                    key: "maxHeight",
                    get: function() {
                        var window = (0, _window.getWindow)();
                        var windowHeight = window && (0, _renderer.default)(window).height() || 0;
                        return Math.max(MIN_HEIGHT, .5 * windowHeight)
                    }
                }]);
                return ListPopupModule
            }(BaseModule)
        }
        var _default = ListPopupModule;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/map/provider.js ***!
      \*****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _promise = _interopRequireDefault(__webpack_require__( /*! ../../core/polyfills/promise */ 73));
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var abstract = _class.default.abstract;
        var Provider = _class.default.inherit({
            _defaultRouteWeight: function() {
                return 5
            },
            _defaultRouteOpacity: function() {
                return .5
            },
            _defaultRouteColor: function() {
                return "#0000FF"
            },
            ctor: function(map, $container) {
                this._mapWidget = map;
                this._$container = $container
            },
            render: function(markerOptions, routeOptions) {
                return this._renderImpl().then(function() {
                    return _promise.default.all([this._applyFunctionIfNeeded("addMarkers", markerOptions), this._applyFunctionIfNeeded("addRoutes", routeOptions)]).then(function() {
                        return true
                    })
                }.bind(this))
            },
            _renderImpl: abstract,
            updateDimensions: abstract,
            updateMapType: abstract,
            updateBounds: abstract,
            updateCenter: abstract,
            updateZoom: abstract,
            updateControls: abstract,
            updateMarkers: function(markerOptionsToRemove, markerOptionsToAdd) {
                return new _promise.default(function(resolve) {
                    return this._applyFunctionIfNeeded("removeMarkers", markerOptionsToRemove).then(function(removeValue) {
                        this._applyFunctionIfNeeded("addMarkers", markerOptionsToAdd).then(function(addValue) {
                            resolve(addValue ? addValue : removeValue)
                        })
                    }.bind(this))
                }.bind(this))
            },
            addMarkers: abstract,
            removeMarkers: abstract,
            adjustViewport: abstract,
            updateRoutes: function(routeOptionsToRemove, routeOptionsToAdd) {
                return new _promise.default(function(resolve) {
                    return this._applyFunctionIfNeeded("removeRoutes", routeOptionsToRemove).then(function(removeValue) {
                        this._applyFunctionIfNeeded("addRoutes", routeOptionsToAdd).then(function(addValue) {
                            resolve(addValue ? addValue : removeValue)
                        })
                    }.bind(this))
                }.bind(this))
            },
            addRoutes: abstract,
            removeRoutes: abstract,
            clean: abstract,
            map: function() {
                return this._map
            },
            isEventsCanceled: function() {
                return false
            },
            _option: function(name, value) {
                if (void 0 === value) {
                    return this._mapWidget.option(name)
                }
                this._mapWidget.setOptionSilent(name, value)
            },
            _keyOption: function(providerName) {
                var key = this._option("apiKey");
                return void 0 === key[providerName] ? key : key[providerName]
            },
            _parseTooltipOptions: function(option) {
                return {
                    text: option.text || option,
                    visible: option.isShown || false
                }
            },
            _getLatLng: function(location) {
                if ("string" === typeof location) {
                    var coords = (0, _iterator.map)(location.split(","), function(item) {
                        return item.trim()
                    });
                    var numericRegex = /^[-+]?[0-9]*\.?[0-9]*$/;
                    if (2 === coords.length && coords[0].match(numericRegex) && coords[1].match(numericRegex)) {
                        return {
                            lat: parseFloat(coords[0]),
                            lng: parseFloat(coords[1])
                        }
                    }
                } else {
                    if (Array.isArray(location) && 2 === location.length) {
                        return {
                            lat: location[0],
                            lng: location[1]
                        }
                    } else {
                        if ((0, _type.isPlainObject)(location) && (0, _type.isNumeric)(location.lat) && (0, _type.isNumeric)(location.lng)) {
                            return location
                        }
                    }
                }
                return null
            },
            _areBoundsSet: function() {
                return this._option("bounds.northEast") && this._option("bounds.southWest")
            },
            _addEventNamespace: function(name) {
                return (0, _index.addNamespace)(name, this._mapWidget.NAME)
            },
            _applyFunctionIfNeeded: function(fnName, array) {
                if (!array.length) {
                    return _promise.default.resolve()
                }
                return this[fnName](array)
            },
            _fireAction: function(name, actionArguments) {
                this._mapWidget._createActionByOption(name)(actionArguments)
            },
            _fireClickAction: function(actionArguments) {
                this._fireAction("onClick", actionArguments)
            },
            _fireMarkerAddedAction: function(actionArguments) {
                this._fireAction("onMarkerAdded", actionArguments)
            },
            _fireMarkerRemovedAction: function(actionArguments) {
                this._fireAction("onMarkerRemoved", actionArguments)
            },
            _fireRouteAddedAction: function(actionArguments) {
                this._fireAction("onRouteAdded", actionArguments)
            },
            _fireRouteRemovedAction: function(actionArguments) {
                this._fireAction("onRouteRemoved", actionArguments)
            }
        });
        var _default = Provider;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/map/provider.dynamic.js ***!
      \*************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _promise = _interopRequireDefault(__webpack_require__( /*! ../../core/polyfills/promise */ 73));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _provider = _interopRequireDefault(__webpack_require__( /*! ./provider */ 367));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var abstract = _provider.default.abstract;
        var DynamicProvider = _provider.default.inherit({
            _geocodeLocation: function(location) {
                return new _promise.default(function(resolve) {
                    var cache = this._geocodedLocations;
                    var cachedLocation = cache[location];
                    if (cachedLocation) {
                        resolve(cachedLocation)
                    } else {
                        this._geocodeLocationImpl(location).then(function(geocodedLocation) {
                            cache[location] = geocodedLocation;
                            resolve(geocodedLocation)
                        })
                    }
                }.bind(this))
            },
            _renderImpl: function() {
                return this._load().then(function() {
                    return this._init()
                }.bind(this)).then(function() {
                    return _promise.default.all([this.updateMapType(), this._areBoundsSet() ? this.updateBounds() : this.updateCenter()])
                }.bind(this)).then(function() {
                    this._attachHandlers();
                    return new _promise.default(function(resolve) {
                        var timeout = setTimeout(function() {
                            clearTimeout(timeout);
                            resolve()
                        })
                    })
                }.bind(this))
            },
            _load: function() {
                if (!this._mapsLoader) {
                    this._mapsLoader = this._loadImpl()
                }
                this._markers = [];
                this._routes = [];
                return this._mapsLoader
            },
            _loadImpl: abstract,
            _init: abstract,
            _attachHandlers: abstract,
            addMarkers: function(options) {
                return _promise.default.all((0, _iterator.map)(options, function(options) {
                    return this._addMarker(options)
                }.bind(this))).then(function(markerObjects) {
                    this._fitBounds();
                    return [false, (0, _iterator.map)(markerObjects, function(markerObject) {
                        return markerObject.marker
                    })]
                }.bind(this))
            },
            _addMarker: function(options) {
                return this._renderMarker(options).then(function(markerObject) {
                    this._markers.push((0, _extend.extend)({
                        options: options
                    }, markerObject));
                    this._fireMarkerAddedAction({
                        options: options,
                        originalMarker: markerObject.marker
                    });
                    return markerObject
                }.bind(this))
            },
            _renderMarker: abstract,
            removeMarkers: function(markersOptionsToRemove) {
                var that = this;
                (0, _iterator.each)(markersOptionsToRemove, function(_, markerOptionToRemove) {
                    that._removeMarker(markerOptionToRemove)
                });
                return _promise.default.resolve()
            },
            _removeMarker: function(markersOptionToRemove) {
                var that = this;
                (0, _iterator.each)(this._markers, function(markerIndex, markerObject) {
                    if (markerObject.options !== markersOptionToRemove) {
                        return true
                    }
                    that._destroyMarker(markerObject);
                    that._markers.splice(markerIndex, 1);
                    that._fireMarkerRemovedAction({
                        options: markerObject.options
                    });
                    return false
                })
            },
            _destroyMarker: abstract,
            _clearMarkers: function() {
                while (this._markers.length > 0) {
                    this._removeMarker(this._markers[0].options)
                }
            },
            addRoutes: function(options) {
                return _promise.default.all((0, _iterator.map)(options, function(options) {
                    return this._addRoute(options)
                }.bind(this))).then(function(routeObjects) {
                    this._fitBounds();
                    return [false, (0, _iterator.map)(routeObjects, function(routeObject) {
                        return routeObject.instance
                    })]
                }.bind(this))
            },
            _addRoute: function(options) {
                return this._renderRoute(options).then(function(routeObject) {
                    this._routes.push((0, _extend.extend)({
                        options: options
                    }, routeObject));
                    this._fireRouteAddedAction({
                        options: options,
                        originalRoute: routeObject.instance
                    });
                    return routeObject
                }.bind(this))
            },
            _renderRoute: abstract,
            removeRoutes: function(options) {
                var that = this;
                (0, _iterator.each)(options, function(routeIndex, options) {
                    that._removeRoute(options)
                });
                return _promise.default.resolve()
            },
            _removeRoute: function(options) {
                var that = this;
                (0, _iterator.each)(this._routes, function(routeIndex, routeObject) {
                    if (routeObject.options !== options) {
                        return true
                    }
                    that._destroyRoute(routeObject);
                    that._routes.splice(routeIndex, 1);
                    that._fireRouteRemovedAction({
                        options: options
                    });
                    return false
                })
            },
            _destroyRoute: abstract,
            _clearRoutes: function() {
                while (this._routes.length > 0) {
                    this._removeRoute(this._routes[0].options)
                }
            },
            adjustViewport: function() {
                return this._fitBounds()
            },
            isEventsCanceled: function() {
                return true
            },
            _fitBounds: abstract,
            _updateBounds: function() {
                var that = this;
                this._clearBounds();
                if (!this._option("autoAdjust")) {
                    return
                }(0, _iterator.each)(this._markers, function(_, markerObject) {
                    that._extendBounds(markerObject.location)
                });
                (0, _iterator.each)(this._routes, function(_, routeObject) {
                    routeObject.northEast && that._extendBounds(routeObject.northEast);
                    routeObject.southWest && that._extendBounds(routeObject.southWest)
                })
            },
            _clearBounds: function() {
                this._bounds = null
            },
            _extendBounds: abstract
        });
        var _default = DynamicProvider;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************!*\
      !*** ./artifacts/transpiled-npm/ui/slider.js ***!
      \***********************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./slider/ui.slider */ 678));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _ui.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/slider/ui.slider_handle.js ***!
      \****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _tooltip = _interopRequireDefault(__webpack_require__( /*! ../tooltip */ 217));
        var _translator = __webpack_require__( /*! ../../animation/translator */ 28);
        var _position = _interopRequireDefault(__webpack_require__( /*! ../../animation/position */ 81));
        var _math = __webpack_require__( /*! ../../core/utils/math */ 29);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _position2 = __webpack_require__( /*! ../../core/utils/position */ 22);
        var _number = _interopRequireDefault(__webpack_require__( /*! ../../localization/number */ 47));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var SLIDER_CLASS = "dx-slider";
        var SLIDER_HANDLE_CLASS = "dx-slider-handle";
        var POSITION_ALIASES = {
            top: {
                my: "bottom center",
                at: "top center",
                collision: "none"
            },
            bottom: {
                my: "top center",
                at: "bottom center",
                collision: "none"
            },
            right: {
                my: "left center",
                at: "right center",
                collision: "none"
            },
            left: {
                my: "right center",
                at: "left center",
                collision: "none"
            }
        };
        var SliderHandle = _ui.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    hoverStateEnabled: false,
                    value: 0,
                    tooltipEnabled: false,
                    tooltipFormat: function(v) {
                        return v
                    },
                    tooltipPosition: "top",
                    tooltipShowMode: "onHover",
                    tooltipFitIn: null
                })
            },
            _initMarkup: function() {
                this.callBase();
                this.$element().addClass(SLIDER_HANDLE_CLASS);
                this.setAria({
                    role: "slider",
                    valuenow: this.option("value")
                })
            },
            _render: function() {
                this._renderTooltip();
                this.callBase()
            },
            _renderTooltip: function() {
                if (this.option("tooltipEnabled")) {
                    if (!this._$tooltip) {
                        this._$tooltip = (0, _renderer.default)("<div>").appendTo(this.$element())
                    }
                    this._$slider = this.$element().closest("." + SLIDER_CLASS);
                    this._updateTooltip()
                } else {
                    this._removeTooltip()
                }
            },
            _createTooltip: function() {
                if (this._tooltip) {
                    return false
                }
                this._tooltip = this._createComponent(this._$tooltip, _tooltip.default, {
                    visible: true,
                    target: this.$element(),
                    closeOnOutsideClick: false,
                    container: this.$element(),
                    hideTopOverlayHandler: null,
                    closeOnTargetScroll: false,
                    onPositioned: function(args) {
                        this._saveTooltipElements(args.component);
                        this._saveTooltipLocation();
                        this._centeredTooltipPosition()
                    }.bind(this),
                    animation: null,
                    arrowPosition: null,
                    templatesRenderAsynchronously: false,
                    _fixedPosition: false
                });
                return true
            },
            _removeTooltip: function() {
                if (!this._$tooltip) {
                    return
                }
                this._$tooltip.remove();
                delete this._$tooltip;
                delete this._tooltip
            },
            _renderTooltipPosition: function() {
                if (!this._tooltip) {
                    return
                }
                var position = this.option("tooltipPosition");
                this._saveTooltipElements();
                this._resetTooltipPosition();
                if ("string" === (0, _type.type)(position)) {
                    position = (0, _extend.extend)({
                        boundary: this._$slider,
                        boundaryOffset: {
                            h: 1,
                            v: 1
                        }
                    }, POSITION_ALIASES[position])
                }
                this._tooltip.option("position", position);
                this._saveTooltipLocation()
            },
            _saveTooltipElements: function(tooltip) {
                tooltip = this._tooltip || tooltip;
                this._$tooltipContent = tooltip.$content().parent();
                this._$tooltipArrow = this._$tooltipContent.find(".dx-popover-arrow")
            },
            _resetTooltipPosition: function() {
                (0, _translator.resetPosition)(this._$tooltipContent);
                (0, _translator.resetPosition)(this._$tooltipArrow)
            },
            _saveTooltipLocation: function() {
                this._contentLocate = (0, _translator.locate)(this._$tooltipContent)
            },
            _centeredTooltipPosition: function() {
                if (!this._tooltip) {
                    return
                }
                this._$tooltipContent.outerWidth("auto");
                var outerWidthWithoutRounding = (0, _position2.getBoundingRect)(this._$tooltipContent.get(0)).width;
                var tooltipOuterWidth = Math.ceil(outerWidthWithoutRounding);
                var roundedTooltipOuterWidth = tooltipOuterWidth % 2 + tooltipOuterWidth;
                this._$tooltipContent.outerWidth(roundedTooltipOuterWidth);
                var tooltipCenter = (roundedTooltipOuterWidth - this.$element().width()) / 2;
                this._contentLocate.left = -tooltipCenter;
                this._$tooltipArrow.css({
                    marginLeft: -this._$tooltipArrow.outerWidth() / 2,
                    left: "50%"
                });
                this._fitTooltip()
            },
            _fitTooltip: function() {
                if (!this._tooltip) {
                    return
                }
                var position = this.option("tooltipPosition");
                if ("string" === (0, _type.type)(position)) {
                    position = (0, _extend.extend)({
                        of: this.$element(),
                        boundary: this._$slider,
                        boundaryOffset: {
                            h: 2,
                            v: 1
                        }
                    }, POSITION_ALIASES[position], {
                        collision: "fit none"
                    })
                }
                var calculatePosition = _position.default.calculate(this._$tooltipContent, position);
                var isLeftSide = "left" === calculatePosition.h.collisionSide;
                var arrowLeft = (isLeftSide ? -1 : 1) * calculatePosition.h.oversize;
                var arrowMinLeft = this._contentLocate.left;
                var arrowMaxRight = this._contentLocate.left + this._$tooltipContent.outerWidth() - this._$tooltipArrow.outerWidth();
                (0, _translator.move)(this._$tooltipContent, {
                    left: this._contentLocate.left + (isLeftSide ? 1 : -1) * calculatePosition.h.oversize
                });
                (0, _translator.move)(this._$tooltipArrow, {
                    left: (0, _math.fitIntoRange)(arrowLeft, arrowMinLeft, arrowMaxRight)
                })
            },
            _getFormattedValue: function(value) {
                return _number.default.format(value, this.option("tooltipFormat"))
            },
            _renderValue: function() {
                if (!this._tooltip) {
                    return
                }
                var value = this.option("value");
                this._tooltip.$content().html(this._getFormattedValue(value));
                this._fitTooltip()
            },
            _updateTooltip: function() {
                var hoverMode = /^onhover$/i.test(this.option("tooltipShowMode"));
                if (!hoverMode) {
                    this._createTooltip()
                }
                this.$element().toggleClass("dx-slider-tooltip-on-hover", hoverMode);
                this._renderTooltipPosition();
                this._renderValue();
                this._centeredTooltipPosition()
            },
            _clean: function() {
                this.callBase();
                delete this._$tooltip;
                delete this._tooltip
            },
            _ensureTooltipIsCentered: function(value, previousValue) {
                if ((0, _type.isDefined)(value) && (0, _type.isDefined)(previousValue) && value.toString().length !== previousValue.toString().length) {
                    this._centeredTooltipPosition()
                }
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "tooltipFormat":
                        this._renderValue();
                        break;
                    case "value":
                        this._renderValue();
                        var value = this._getFormattedValue(args.value);
                        var previousValue = this._getFormattedValue(args.previousValue);
                        this._ensureTooltipIsCentered(value, previousValue);
                        this.setAria("valuenow", args.value);
                        break;
                    case "tooltipEnabled":
                        this._renderTooltip();
                        break;
                    case "tooltipPosition":
                        this._renderTooltipPosition();
                        this._centeredTooltipPosition();
                        break;
                    case "tooltipShowMode":
                        this._updateTooltip();
                        break;
                    case "tooltipFitIn":
                        this._fitTooltip();
                        break;
                    default:
                        this.callBase(args)
                }
            },
            fitTooltipPosition: function() {
                this._fitTooltip()
            },
            updateTooltip: function() {
                if (!this._createTooltip()) {
                    return
                }
                this._renderTooltipPosition();
                this._renderValue();
                this._centeredTooltipPosition()
            },
            repaint: function() {
                this._renderTooltipPosition();
                this._centeredTooltipPosition();
                if (this._tooltip) {
                    this._tooltip._visibilityChanged(true)
                }
            }
        });
        var _default = SliderHandle;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tooltip/tooltip.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _guid = _interopRequireDefault(__webpack_require__( /*! ../../core/guid */ 36));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _popover = _interopRequireDefault(__webpack_require__( /*! ../popover */ 135));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var TOOLTIP_CLASS = "dx-tooltip";
        var TOOLTIP_WRAPPER_CLASS = "dx-tooltip-wrapper";
        var Tooltip = _popover.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    toolbarItems: [],
                    showCloseButton: false,
                    showTitle: false,
                    title: null,
                    titleTemplate: null,
                    onTitleRendered: null,
                    bottomTemplate: null,
                    propagateOutsideClick: true
                })
            },
            _render: function() {
                this.$element().addClass(TOOLTIP_CLASS);
                this._wrapper().addClass(TOOLTIP_WRAPPER_CLASS);
                this.callBase()
            },
            _renderContent: function() {
                this.callBase();
                this._contentId = "dx-" + new _guid.default;
                this._$content.attr({
                    id: this._contentId,
                    role: "tooltip"
                });
                this._toggleAriaDescription(true)
            },
            _toggleAriaDescription: function(showing) {
                var $target = (0, _renderer.default)(this.option("target"));
                var label = showing ? this._contentId : void 0;
                if (!(0, _type.isWindow)($target.get(0))) {
                    this.setAria("describedby", label, $target)
                }
            }
        });
        (0, _component_registrator.default)("dxTooltip", Tooltip);
        var _default = Tooltip;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************!*\
      !*** ./artifacts/transpiled-npm/ui/switch.js ***!
      \***********************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../core/devices */ 13));
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _utils = __webpack_require__( /*! ./widget/utils.ink_ripple */ 82);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _editor = _interopRequireDefault(__webpack_require__( /*! ./editor/editor */ 52));
        var _index = __webpack_require__( /*! ../events/utils/index */ 8);
        var _emitter = __webpack_require__( /*! ../events/core/emitter.feedback */ 149);
        var _position = __webpack_require__( /*! ../core/utils/position */ 22);
        var _fx = _interopRequireDefault(__webpack_require__( /*! ../animation/fx */ 42));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../localization/message */ 10));
        var _click = __webpack_require__( /*! ../events/click */ 21);
        var _swipeable = _interopRequireDefault(__webpack_require__( /*! ../events/gesture/swipeable */ 172));
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var SWITCH_CLASS = "dx-switch";
        var SWITCH_WRAPPER_CLASS = SWITCH_CLASS + "-wrapper";
        var SWITCH_CONTAINER_CLASS = SWITCH_CLASS + "-container";
        var SWITCH_INNER_CLASS = SWITCH_CLASS + "-inner";
        var SWITCH_HANDLE_CLASS = SWITCH_CLASS + "-handle";
        var SWITCH_ON_VALUE_CLASS = SWITCH_CLASS + "-on-value";
        var SWITCH_ON_CLASS = SWITCH_CLASS + "-on";
        var SWITCH_OFF_CLASS = SWITCH_CLASS + "-off";
        var SWITCH_ANIMATION_DURATION = 100;
        var Switch = _editor.default.inherit({
            _supportedKeys: function() {
                var isRTL = this.option("rtlEnabled");
                var click = function(e) {
                    e.preventDefault();
                    this._clickAction({
                        event: e
                    })
                };
                var move = function(value, e) {
                    e.preventDefault();
                    e.stopPropagation();
                    this._saveValueChangeEvent(e);
                    this._animateValue(value)
                };
                return (0, _extend.extend)(this.callBase(), {
                    space: click,
                    enter: click,
                    leftArrow: move.bind(this, isRTL ? true : false),
                    rightArrow: move.bind(this, isRTL ? false : true)
                })
            },
            _useTemplates: function() {
                return false
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    hoverStateEnabled: true,
                    activeStateEnabled: true,
                    switchedOnText: _message.default.format("dxSwitch-switchedOnText"),
                    switchedOffText: _message.default.format("dxSwitch-switchedOffText"),
                    value: false,
                    useInkRipple: false
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: function() {
                        return "desktop" === _devices.default.real().deviceType && !_devices.default.isSimulator()
                    },
                    options: {
                        focusStateEnabled: true
                    }
                }])
            },
            _feedbackHideTimeout: 0,
            _animating: false,
            _initMarkup: function() {
                this._renderContainers();
                this.option("useInkRipple") && this._renderInkRipple();
                this.$element().addClass(SWITCH_CLASS).append(this._$switchWrapper);
                this._renderSubmitElement();
                this._renderClick();
                this.setAria("role", "button");
                this._renderSwipeable();
                this.callBase();
                this._renderSwitchInner();
                this._renderLabels();
                this._renderValue()
            },
            _getInnerOffset: function(value, offset) {
                var ratio = (offset - this._offsetDirection() * Number(!value)) / 2;
                return 100 * ratio + "%"
            },
            _getHandleOffset: function(value, offset) {
                if (this.option("rtlEnabled")) {
                    value = !value
                }
                if (value) {
                    var calcValue = -100 + 100 * -offset;
                    return calcValue + "%"
                } else {
                    return 100 * -offset + "%"
                }
            },
            _renderSwitchInner: function() {
                this._$switchInner = (0, _renderer.default)("<div>").addClass(SWITCH_INNER_CLASS).appendTo(this._$switchContainer);
                this._$handle = (0, _renderer.default)("<div>").addClass(SWITCH_HANDLE_CLASS).appendTo(this._$switchInner)
            },
            _renderLabels: function() {
                this._$labelOn = (0, _renderer.default)("<div>").addClass(SWITCH_ON_CLASS).prependTo(this._$switchInner);
                this._$labelOff = (0, _renderer.default)("<div>").addClass(SWITCH_OFF_CLASS).appendTo(this._$switchInner);
                this._setLabelsText()
            },
            _renderContainers: function() {
                this._$switchContainer = (0, _renderer.default)("<div>").addClass(SWITCH_CONTAINER_CLASS);
                this._$switchWrapper = (0, _renderer.default)("<div>").addClass(SWITCH_WRAPPER_CLASS).append(this._$switchContainer)
            },
            _renderSwipeable: function() {
                this._createComponent(this.$element(), _swipeable.default, {
                    elastic: false,
                    immediate: true,
                    onStart: this._swipeStartHandler.bind(this),
                    onUpdated: this._swipeUpdateHandler.bind(this),
                    onEnd: this._swipeEndHandler.bind(this),
                    itemSizeFunc: this._getItemSizeFunc.bind(this)
                })
            },
            _getItemSizeFunc: function() {
                return this._$switchContainer.outerWidth(true) - (0, _position.getBoundingRect)(this._$handle.get(0)).width
            },
            _renderSubmitElement: function() {
                this._$submitElement = (0, _renderer.default)("<input>").attr("type", "hidden").appendTo(this.$element())
            },
            _getSubmitElement: function() {
                return this._$submitElement
            },
            _renderInkRipple: function() {
                this._inkRipple = (0, _utils.render)({
                    waveSizeCoefficient: 1.7,
                    isCentered: true,
                    useHoldAnimation: false,
                    wavesNumber: 2
                })
            },
            _renderInkWave: function(element, dxEvent, doRender, waveIndex) {
                if (!this._inkRipple) {
                    return
                }
                var config = {
                    element: element,
                    event: dxEvent,
                    wave: waveIndex
                };
                if (doRender) {
                    this._inkRipple.showWave(config)
                } else {
                    this._inkRipple.hideWave(config)
                }
            },
            _updateFocusState: function(e, value) {
                this.callBase.apply(this, arguments);
                this._renderInkWave(this._$handle, e, value, 0)
            },
            _toggleActiveState: function($element, value, e) {
                this.callBase.apply(this, arguments);
                this._renderInkWave(this._$handle, e, value, 1)
            },
            _offsetDirection: function() {
                return this.option("rtlEnabled") ? -1 : 1
            },
            _renderPosition: function(state, swipeOffset) {
                var innerOffset = this._getInnerOffset(state, swipeOffset);
                var handleOffset = this._getHandleOffset(state, swipeOffset);
                this._$switchInner.css("transform", " translateX(" + innerOffset + ")");
                this._$handle.css("transform", " translateX(" + handleOffset + ")")
            },
            _validateValue: function() {
                var check = this.option("value");
                if ("boolean" !== typeof check) {
                    this._options.silent("value", !!check)
                }
            },
            _renderClick: function() {
                var eventName = (0, _index.addNamespace)(_click.name, this.NAME);
                var $element = this.$element();
                this._clickAction = this._createAction(this._clickHandler.bind(this));
                _events_engine.default.off($element, eventName);
                _events_engine.default.on($element, eventName, function(e) {
                    this._clickAction({
                        event: e
                    })
                }.bind(this))
            },
            _clickHandler: function(args) {
                var e = args.event;
                this._saveValueChangeEvent(e);
                if (this._animating || this._swiping) {
                    return
                }
                this._animateValue(!this.option("value"))
            },
            _animateValue: function(value) {
                var startValue = this.option("value");
                var endValue = value;
                if (startValue === endValue) {
                    return
                }
                this._animating = true;
                var fromInnerOffset = this._getInnerOffset(startValue, 0);
                var toInnerOffset = this._getInnerOffset(endValue, 0);
                var fromHandleOffset = this._getHandleOffset(startValue, 0);
                var toHandleOffset = this._getHandleOffset(endValue, 0);
                var that = this;
                var fromInnerConfig = {};
                var toInnerConfig = {};
                var fromHandleConfig = {};
                var toHandlerConfig = {};
                fromInnerConfig.transform = " translateX(" + fromInnerOffset + ")";
                toInnerConfig.transform = " translateX(" + toInnerOffset + ")";
                fromHandleConfig.transform = " translateX(" + fromHandleOffset + ")";
                toHandlerConfig.transform = " translateX(" + toHandleOffset + ")";
                this.$element().toggleClass(SWITCH_ON_VALUE_CLASS, endValue);
                _fx.default.animate(this._$handle, {
                    from: fromHandleConfig,
                    to: toHandlerConfig,
                    duration: SWITCH_ANIMATION_DURATION
                });
                _fx.default.animate(this._$switchInner, {
                    from: fromInnerConfig,
                    to: toInnerConfig,
                    duration: SWITCH_ANIMATION_DURATION,
                    complete: function() {
                        that._animating = false;
                        that.option("value", endValue)
                    }
                })
            },
            _swipeStartHandler: function(e) {
                var state = this.option("value");
                var rtlEnabled = this.option("rtlEnabled");
                var maxOffOffset = rtlEnabled ? 0 : 1;
                var maxOnOffset = rtlEnabled ? 1 : 0;
                e.event.maxLeftOffset = state ? maxOffOffset : maxOnOffset;
                e.event.maxRightOffset = state ? maxOnOffset : maxOffOffset;
                this._swiping = true;
                this._feedbackDeferred = new _deferred.Deferred;
                (0, _emitter.lock)(this._feedbackDeferred);
                this._toggleActiveState(this.$element(), this.option("activeStateEnabled"))
            },
            _swipeUpdateHandler: function(e) {
                this._renderPosition(this.option("value"), e.event.offset)
            },
            _swipeEndHandler: function(e) {
                var that = this;
                var offsetDirection = this._offsetDirection();
                var toInnerConfig = {};
                var toHandleConfig = {};
                var innerOffset = this._getInnerOffset(that.option("value"), e.event.targetOffset);
                var handleOffset = this._getHandleOffset(that.option("value"), e.event.targetOffset);
                toInnerConfig.transform = " translateX(" + innerOffset + ")";
                toHandleConfig.transform = " translateX(" + handleOffset + ")";
                _fx.default.animate(this._$handle, {
                    to: toHandleConfig,
                    duration: SWITCH_ANIMATION_DURATION
                });
                _fx.default.animate(this._$switchInner, {
                    to: toInnerConfig,
                    duration: SWITCH_ANIMATION_DURATION,
                    complete: function() {
                        that._swiping = false;
                        var pos = that.option("value") + offsetDirection * e.event.targetOffset;
                        that._saveValueChangeEvent(e.event);
                        that.option("value", Boolean(pos));
                        that._feedbackDeferred.resolve();
                        that._toggleActiveState(that.$element(), false)
                    }
                })
            },
            _renderValue: function() {
                this._validateValue();
                var val = this.option("value");
                this._renderPosition(val, 0);
                this.$element().toggleClass(SWITCH_ON_VALUE_CLASS, val);
                this._getSubmitElement().val(val);
                this.setAria({
                    pressed: val,
                    label: val ? this.option("switchedOnText") : this.option("switchedOffText")
                })
            },
            _setLabelsText: function() {
                this._$labelOn && this._$labelOn.text(this.option("switchedOnText"));
                this._$labelOff && this._$labelOff.text(this.option("switchedOffText"))
            },
            _visibilityChanged: function(visible) {
                if (visible) {
                    this.repaint()
                }
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "useInkRipple":
                        this._invalidate();
                        break;
                    case "width":
                        delete this._marginBound;
                        this._refresh();
                        break;
                    case "switchedOnText":
                    case "switchedOffText":
                        this._setLabelsText();
                        break;
                    case "value":
                        this._renderValue();
                        this.callBase(args);
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _clean: function() {
                delete this._inkRipple;
                this.callBase()
            }
        });
        (0, _component_registrator.default)("dxSwitch", Switch);
        var _default = Switch;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/text_area.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _index = __webpack_require__( /*! ../events/utils/index */ 8);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../events/pointer */ 24));
        var _uiEventsEmitterGesture = _interopRequireDefault(__webpack_require__( /*! ../ui/scroll_view/ui.events.emitter.gesture.scroll */ 272));
        var _size = __webpack_require__( /*! ../core/utils/size */ 192);
        var _utils = __webpack_require__( /*! ./text_box/utils.scroll */ 286);
        var _text_box = _interopRequireDefault(__webpack_require__( /*! ./text_box */ 97));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var TEXTAREA_CLASS = "dx-textarea";
        var TEXTEDITOR_INPUT_CLASS = "dx-texteditor-input";
        var TEXTEDITOR_INPUT_CLASS_AUTO_RESIZE = "dx-texteditor-input-auto-resize";
        var TextArea = _text_box.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    spellcheck: true,
                    minHeight: void 0,
                    maxHeight: void 0,
                    autoResizeEnabled: false
                })
            },
            _initMarkup: function() {
                this.$element().addClass(TEXTAREA_CLASS);
                this.callBase();
                this.setAria("multiline", "true")
            },
            _renderContentImpl: function() {
                this._updateInputHeight();
                this.callBase()
            },
            _renderInput: function() {
                this.callBase();
                this._renderScrollHandler()
            },
            _createInput: function() {
                var $input = (0, _renderer.default)("<textarea>");
                this._applyInputAttributes($input, this.option("inputAttr"));
                this._updateInputAutoResizeAppearance($input);
                return $input
            },
            _applyInputAttributes: function($input, customAttributes) {
                $input.attr(customAttributes).addClass(TEXTEDITOR_INPUT_CLASS)
            },
            _renderScrollHandler: function() {
                this._eventY = 0;
                var $input = this._input();
                var initScrollData = (0, _utils.prepareScrollData)($input, true);
                _events_engine.default.on($input, (0, _index.addNamespace)(_uiEventsEmitterGesture.default.init, this.NAME), initScrollData, _common.noop);
                _events_engine.default.on($input, (0, _index.addNamespace)(_pointer.default.down, this.NAME), this._pointerDownHandler.bind(this));
                _events_engine.default.on($input, (0, _index.addNamespace)(_pointer.default.move, this.NAME), this._pointerMoveHandler.bind(this))
            },
            _pointerDownHandler: function(e) {
                this._eventY = (0, _index.eventData)(e).y
            },
            _pointerMoveHandler: function(e) {
                var currentEventY = (0, _index.eventData)(e).y;
                var delta = this._eventY - currentEventY;
                if ((0, _utils.allowScroll)(this._input(), delta)) {
                    e.isScrollingEvent = true;
                    e.stopPropagation()
                }
                this._eventY = currentEventY
            },
            _renderDimensions: function() {
                var $element = this.$element();
                var element = $element.get(0);
                var width = this._getOptionValue("width", element);
                var height = this._getOptionValue("height", element);
                var minHeight = this.option("minHeight");
                var maxHeight = this.option("maxHeight");
                $element.css({
                    minHeight: void 0 !== minHeight ? minHeight : "",
                    maxHeight: void 0 !== maxHeight ? maxHeight : "",
                    width: width,
                    height: height
                })
            },
            _resetDimensions: function() {
                this.$element().css({
                    height: "",
                    minHeight: "",
                    maxHeight: ""
                })
            },
            _renderEvents: function() {
                if (this.option("autoResizeEnabled")) {
                    _events_engine.default.on(this._input(), (0, _index.addNamespace)("input paste", this.NAME), this._updateInputHeight.bind(this))
                }
                this.callBase()
            },
            _refreshEvents: function() {
                _events_engine.default.off(this._input(), (0, _index.addNamespace)("input paste", this.NAME));
                this.callBase()
            },
            _getHeightDifference: function($input) {
                return (0, _size.getVerticalOffsets)(this._$element.get(0), false) + (0, _size.getVerticalOffsets)(this._$textEditorContainer.get(0), false) + (0, _size.getVerticalOffsets)(this._$textEditorInputContainer.get(0), false) + (0, _size.getElementBoxParams)("height", (0, _window.getWindow)().getComputedStyle($input.get(0))).margin
            },
            _updateInputHeight: function() {
                var $input = this._input();
                var autoHeightResizing = void 0 === this.option("height") && this.option("autoResizeEnabled");
                if (!autoHeightResizing) {
                    $input.css("height", "");
                    return
                } else {
                    this._resetDimensions();
                    this._$element.css("height", this._$element.outerHeight())
                }
                $input.css("height", 0);
                var heightDifference = this._getHeightDifference($input);
                this._renderDimensions();
                var minHeight = this._getBoundaryHeight("minHeight");
                var maxHeight = this._getBoundaryHeight("maxHeight");
                var inputHeight = $input[0].scrollHeight;
                if (void 0 !== minHeight) {
                    inputHeight = Math.max(inputHeight, minHeight - heightDifference)
                }
                if (void 0 !== maxHeight) {
                    var adjustedMaxHeight = maxHeight - heightDifference;
                    var needScroll = inputHeight > adjustedMaxHeight;
                    inputHeight = Math.min(inputHeight, adjustedMaxHeight);
                    this._updateInputAutoResizeAppearance($input, !needScroll)
                }
                $input.css("height", inputHeight);
                if (autoHeightResizing) {
                    this._$element.css("height", "auto")
                }
            },
            _getBoundaryHeight: function(optionName) {
                var boundaryValue = this.option(optionName);
                if ((0, _type.isDefined)(boundaryValue)) {
                    return "number" === typeof boundaryValue ? boundaryValue : (0, _size.parseHeight)(boundaryValue, this._$textEditorContainer.get(0))
                }
            },
            _renderInputType: _common.noop,
            _visibilityChanged: function(visible) {
                if (visible) {
                    this._updateInputHeight()
                }
            },
            _updateInputAutoResizeAppearance: function($input, isAutoResizeEnabled) {
                if ($input) {
                    var autoResizeEnabled = (0, _common.ensureDefined)(isAutoResizeEnabled, this.option("autoResizeEnabled"));
                    $input.toggleClass(TEXTEDITOR_INPUT_CLASS_AUTO_RESIZE, autoResizeEnabled)
                }
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "autoResizeEnabled":
                        this._updateInputAutoResizeAppearance(this._input(), args.value);
                        this._refreshEvents();
                        this._updateInputHeight();
                        break;
                    case "value":
                    case "height":
                        this.callBase(args);
                        this._updateInputHeight();
                        break;
                    case "minHeight":
                    case "maxHeight":
                        this._renderDimensions();
                        this._updateInputHeight();
                        break;
                    case "visible":
                        this.callBase(args);
                        args.value && this._updateInputHeight();
                        break;
                    default:
                        this.callBase(args)
                }
            }
        });
        (0, _component_registrator.default)("dxTextArea", TextArea);
        var _default = TextArea;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/accordion.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _fx = _interopRequireDefault(__webpack_require__( /*! ../animation/fx */ 42));
        var _click = __webpack_require__( /*! ../events/click */ 21);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../core/devices */ 13));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../core/dom_adapter */ 11));
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _element = __webpack_require__( /*! ../core/element */ 18);
        var iteratorUtils = _interopRequireWildcard(__webpack_require__( /*! ../core/utils/iterator */ 3));
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _index = __webpack_require__( /*! ../events/utils/index */ 8);
        var _uiCollection_widget = _interopRequireDefault(__webpack_require__( /*! ./collection/ui.collection_widget.live_update */ 209));
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);
        var _bindable_template = __webpack_require__( /*! ../core/templates/bindable_template */ 65);
        var _icon = __webpack_require__( /*! ../core/utils/icon */ 56);
        var _themes = __webpack_require__( /*! ./themes */ 34);

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ACCORDION_CLASS = "dx-accordion";
        var ACCORDION_WRAPPER_CLASS = "dx-accordion-wrapper";
        var ACCORDION_ITEM_CLASS = "dx-accordion-item";
        var ACCORDION_ITEM_OPENED_CLASS = "dx-accordion-item-opened";
        var ACCORDION_ITEM_CLOSED_CLASS = "dx-accordion-item-closed";
        var ACCORDION_ITEM_TITLE_CLASS = "dx-accordion-item-title";
        var ACCORDION_ITEM_BODY_CLASS = "dx-accordion-item-body";
        var ACCORDION_ITEM_TITLE_CAPTION_CLASS = "dx-accordion-item-title-caption";
        var ACCORDION_ITEM_DATA_KEY = "dxAccordionItemData";
        var Accordion = _uiCollection_widget.default.inherit({
            _activeStateUnit: "." + ACCORDION_ITEM_CLASS,
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    hoverStateEnabled: true,
                    height: void 0,
                    itemTitleTemplate: "title",
                    onItemTitleClick: null,
                    selectedIndex: 0,
                    collapsible: false,
                    multiple: false,
                    animationDuration: 300,
                    deferRendering: true,
                    selectionByClick: true,
                    activeStateEnabled: true,
                    _itemAttributes: {
                        role: "tab"
                    },
                    _animationEasing: "ease"
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: function() {
                        return "desktop" === _devices.default.real().deviceType && !_devices.default.isSimulator()
                    },
                    options: {
                        focusStateEnabled: true
                    }
                }, {
                    device: function() {
                        return (0, _themes.isMaterial)()
                    },
                    options: {
                        animationDuration: 200,
                        _animationEasing: "cubic-bezier(0.4, 0, 0.2, 1)"
                    }
                }])
            },
            _itemElements: function() {
                return this._itemContainer().children(this._itemSelector())
            },
            _init: function() {
                this.callBase();
                this.option("selectionRequired", !this.option("collapsible"));
                this.option("selectionMode", this.option("multiple") ? "multiple" : "single");
                var $element = this.$element();
                $element.addClass(ACCORDION_CLASS);
                this._$container = (0, _renderer.default)("<div>").addClass(ACCORDION_WRAPPER_CLASS);
                $element.append(this._$container)
            },
            _initTemplates: function() {
                this.callBase();
                this._templateManager.addDefaultTemplates({
                    title: new _bindable_template.BindableTemplate(function($container, data) {
                        if ((0, _type.isPlainObject)(data)) {
                            var $iconElement = (0, _icon.getImageContainer)(data.icon);
                            if ($iconElement) {
                                $container.append($iconElement)
                            }
                            if ((0, _type.isDefined)(data.title) && !(0, _type.isPlainObject)(data.title)) {
                                $container.append(_dom_adapter.default.createTextNode(data.title))
                            }
                        } else {
                            if ((0, _type.isDefined)(data)) {
                                $container.text(String(data))
                            }
                        }
                        $container.wrapInner((0, _renderer.default)("<div>").addClass(ACCORDION_ITEM_TITLE_CAPTION_CLASS))
                    }, ["title", "icon"], this.option("integrationOptions.watchMethod"))
                })
            },
            _initMarkup: function() {
                var _this = this;
                this._deferredItems = [];
                this.callBase();
                this.setAria({
                    role: "tablist",
                    multiselectable: this.option("multiple")
                });
                (0, _common.deferRender)(function() {
                    var selectedItemIndices = _this._getSelectedItemIndices();
                    _this._renderSelection(selectedItemIndices, [])
                })
            },
            _render: function() {
                this.callBase();
                this._updateItemHeightsWrapper(true)
            },
            _itemDataKey: function() {
                return ACCORDION_ITEM_DATA_KEY
            },
            _itemClass: function() {
                return ACCORDION_ITEM_CLASS
            },
            _itemContainer: function() {
                return this._$container
            },
            _itemTitles: function() {
                return this._itemElements().find("." + ACCORDION_ITEM_TITLE_CLASS)
            },
            _itemContents: function() {
                return this._itemElements().find("." + ACCORDION_ITEM_BODY_CLASS)
            },
            _getItemData: function(target) {
                return (0, _renderer.default)(target).parent().data(this._itemDataKey()) || this.callBase.apply(this, arguments)
            },
            _executeItemRenderAction: function(itemData) {
                if (itemData.type) {
                    return
                }
                this.callBase.apply(this, arguments)
            },
            _itemSelectHandler: function(e) {
                if ((0, _renderer.default)(e.target).closest(this._itemContents()).length) {
                    return
                }
                this.callBase.apply(this, arguments)
            },
            _afterItemElementDeleted: function($item, deletedActionArgs) {
                this._deferredItems.splice(deletedActionArgs.itemIndex, 1);
                this.callBase.apply(this, arguments)
            },
            _renderItemContent: function(args) {
                var itemTitle = this.callBase((0, _extend.extend)({}, args, {
                    contentClass: ACCORDION_ITEM_TITLE_CLASS,
                    templateProperty: "titleTemplate",
                    defaultTemplateName: this.option("itemTitleTemplate")
                }));
                this._attachItemTitleClickAction(itemTitle);
                var deferred = new _deferred.Deferred;
                if ((0, _type.isDefined)(this._deferredItems[args.index])) {
                    this._deferredItems[args.index] = deferred
                } else {
                    this._deferredItems.push(deferred)
                }
                if (!this.option("deferRendering") || this._getSelectedItemIndices().indexOf(args.index) >= 0) {
                    deferred.resolve()
                }
                deferred.done(this.callBase.bind(this, (0, _extend.extend)({}, args, {
                    contentClass: ACCORDION_ITEM_BODY_CLASS,
                    container: (0, _element.getPublicElement)((0, _renderer.default)("<div>").appendTo((0, _renderer.default)(itemTitle).parent()))
                })))
            },
            _attachItemTitleClickAction: function(itemTitle) {
                var eventName = (0, _index.addNamespace)(_click.name, this.NAME);
                _events_engine.default.off(itemTitle, eventName);
                _events_engine.default.on(itemTitle, eventName, this._itemTitleClickHandler.bind(this))
            },
            _itemTitleClickHandler: function(e) {
                this._itemDXEventHandler(e, "onItemTitleClick")
            },
            _renderSelection: function(addedSelection, removedSelection) {
                this._itemElements().addClass(ACCORDION_ITEM_CLOSED_CLASS);
                this.setAria("hidden", true, this._itemContents());
                this._updateItems(addedSelection, removedSelection)
            },
            _updateSelection: function(addedSelection, removedSelection) {
                this._updateItems(addedSelection, removedSelection);
                this._updateItemHeightsWrapper(false)
            },
            _updateItems: function(addedSelection, removedSelection) {
                var _this2 = this;
                var $items = this._itemElements();
                iteratorUtils.each(addedSelection, function(_, index) {
                    _this2._deferredItems[index].resolve();
                    var $item = $items.eq(index).addClass(ACCORDION_ITEM_OPENED_CLASS).removeClass(ACCORDION_ITEM_CLOSED_CLASS);
                    _this2.setAria("hidden", false, $item.find("." + ACCORDION_ITEM_BODY_CLASS))
                });
                iteratorUtils.each(removedSelection, function(_, index) {
                    var $item = $items.eq(index).removeClass(ACCORDION_ITEM_OPENED_CLASS);
                    _this2.setAria("hidden", true, $item.find("." + ACCORDION_ITEM_BODY_CLASS))
                })
            },
            _updateItemHeightsWrapper: function(skipAnimation) {
                if (this.option("templatesRenderAsynchronously")) {
                    this._animationTimer = setTimeout(function() {
                        this._updateItemHeights(skipAnimation)
                    }.bind(this))
                } else {
                    this._updateItemHeights(skipAnimation)
                }
            },
            _updateItemHeights: function(skipAnimation) {
                var that = this;
                var deferredAnimate = that._deferredAnimate;
                var itemHeight = this._splitFreeSpace(this._calculateFreeSpace());
                clearTimeout(this._animationTimer);
                return _deferred.when.apply(_renderer.default, [].slice.call(this._itemElements()).map(function(item) {
                    return that._updateItemHeight((0, _renderer.default)(item), itemHeight, skipAnimation)
                })).done(function() {
                    if (deferredAnimate) {
                        deferredAnimate.resolveWith(that)
                    }
                })
            },
            _updateItemHeight: function($item, itemHeight, skipAnimation) {
                var $title = $item.children("." + ACCORDION_ITEM_TITLE_CLASS);
                if (_fx.default.isAnimating($item)) {
                    _fx.default.stop($item)
                }
                var startItemHeight = $item.outerHeight();
                var finalItemHeight = $item.hasClass(ACCORDION_ITEM_OPENED_CLASS) ? itemHeight + $title.outerHeight() || $item.height("auto").outerHeight() : $title.outerHeight();
                return this._animateItem($item, startItemHeight, finalItemHeight, skipAnimation, !!itemHeight)
            },
            _animateItem: function($element, startHeight, endHeight, skipAnimation, fixedHeight) {
                var d;
                if (skipAnimation || startHeight === endHeight) {
                    $element.css("height", endHeight);
                    d = (new _deferred.Deferred).resolve()
                } else {
                    d = _fx.default.animate($element, {
                        type: "custom",
                        from: {
                            height: startHeight
                        },
                        to: {
                            height: endHeight
                        },
                        duration: this.option("animationDuration"),
                        easing: this.option("_animationEasing")
                    })
                }
                return d.done(function() {
                    if ($element.hasClass(ACCORDION_ITEM_OPENED_CLASS) && !fixedHeight) {
                        $element.css("height", "")
                    }
                    $element.not("." + ACCORDION_ITEM_OPENED_CLASS).addClass(ACCORDION_ITEM_CLOSED_CLASS)
                })
            },
            _splitFreeSpace: function(freeSpace) {
                if (!freeSpace) {
                    return freeSpace
                }
                return freeSpace / this.option("selectedItems").length
            },
            _calculateFreeSpace: function() {
                var height = this.option("height");
                if (void 0 === height || "auto" === height) {
                    return
                }
                var $titles = this._itemTitles();
                var itemsHeight = 0;
                iteratorUtils.each($titles, function(_, title) {
                    itemsHeight += (0, _renderer.default)(title).outerHeight()
                });
                return this.$element().height() - itemsHeight
            },
            _visibilityChanged: function(visible) {
                if (visible) {
                    this._dimensionChanged()
                }
            },
            _dimensionChanged: function() {
                this._updateItemHeights(true)
            },
            _clean: function() {
                clearTimeout(this._animationTimer);
                this.callBase()
            },
            _tryParseItemPropertyName: function(fullName) {
                var matches = fullName.match(/.*\.(.*)/);
                if ((0, _type.isDefined)(matches) && matches.length >= 1) {
                    return matches[1]
                }
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "items":
                        this.callBase(args);
                        if ("title" === this._tryParseItemPropertyName(args.fullName)) {
                            this._renderSelection(this._getSelectedItemIndices(), [])
                        }
                        if ("visible" === this._tryParseItemPropertyName(args.fullName)) {
                            this._updateItemHeightsWrapper(true)
                        }
                        break;
                    case "animationDuration":
                    case "onItemTitleClick":
                    case "_animationEasing":
                        break;
                    case "collapsible":
                        this.option("selectionRequired", !this.option("collapsible"));
                        break;
                    case "itemTitleTemplate":
                    case "height":
                    case "deferRendering":
                        this._invalidate();
                        break;
                    case "multiple":
                        this.option("selectionMode", args.value ? "multiple" : "single");
                        break;
                    default:
                        this.callBase(args)
                }
            },
            expandItem: function(index) {
                this._deferredAnimate = new _deferred.Deferred;
                this.selectItem(index);
                return this._deferredAnimate.promise()
            },
            collapseItem: function(index) {
                this._deferredAnimate = new _deferred.Deferred;
                this.unselectItem(index);
                return this._deferredAnimate.promise()
            },
            updateDimensions: function() {
                return this._updateItemHeights(false)
            }
        });
        (0, _component_registrator.default)("dxAccordion", Accordion);
        var _default = Accordion;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/context_menu/ui.context_menu.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _guid = _interopRequireDefault(__webpack_require__( /*! ../../core/guid */ 36));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _dom = __webpack_require__( /*! ../../core/utils/dom */ 33);
        var _element = __webpack_require__( /*! ../../core/element */ 18);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _fx = _interopRequireDefault(__webpack_require__( /*! ../../animation/fx */ 42));
        var _position = _interopRequireDefault(__webpack_require__( /*! ../../animation/position */ 81));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _overlay = _interopRequireDefault(__webpack_require__( /*! ../overlay */ 64));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./ui.menu_base */ 376));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var DX_MENU_CLASS = "dx-menu";
        var DX_MENU_ITEM_CLASS = DX_MENU_CLASS + "-item";
        var DX_MENU_ITEM_EXPANDED_CLASS = DX_MENU_ITEM_CLASS + "-expanded";
        var DX_MENU_PHONE_CLASS = "dx-menu-phone-overlay";
        var DX_MENU_ITEMS_CONTAINER_CLASS = DX_MENU_CLASS + "-items-container";
        var DX_MENU_ITEM_WRAPPER_CLASS = DX_MENU_ITEM_CLASS + "-wrapper";
        var DX_SUBMENU_CLASS = "dx-submenu";
        var DX_CONTEXT_MENU_CLASS = "dx-context-menu";
        var DX_HAS_CONTEXT_MENU_CLASS = "dx-has-context-menu";
        var DX_STATE_DISABLED_CLASS = "dx-state-disabled";
        var DX_STATE_FOCUSED_CLASS = "dx-state-focused";
        var DX_STATE_HOVER_CLASS = "dx-state-hover";
        var FOCUS_UP = "up";
        var FOCUS_DOWN = "down";
        var FOCUS_LEFT = "left";
        var FOCUS_RIGHT = "right";
        var FOCUS_FIRST = "first";
        var FOCUS_LAST = "last";
        var ACTIONS = ["onShowing", "onShown", "onSubmenuCreated", "onHiding", "onHidden", "onPositioning", "onLeftFirstItem", "onLeftLastItem", "onCloseRootSubmenu", "onExpandLastSubmenu"];
        var LOCAL_SUBMENU_DIRECTIONS = [FOCUS_UP, FOCUS_DOWN, FOCUS_FIRST, FOCUS_LAST];
        var DEFAULT_SHOW_EVENT = "dxcontextmenu";
        var ContextMenu = function(_MenuBase) {
            _inheritsLoose(ContextMenu, _MenuBase);

            function ContextMenu() {
                return _MenuBase.apply(this, arguments) || this
            }
            var _proto = ContextMenu.prototype;
            _proto.getShowEvent = function(showEventOption) {
                var result = null;
                if ((0, _type.isObject)(showEventOption)) {
                    if (null !== showEventOption.name) {
                        result = showEventOption.name || DEFAULT_SHOW_EVENT
                    }
                } else {
                    result = showEventOption
                }
                return result
            };
            _proto.getShowDelay = function(showEventOption) {
                return (0, _type.isObject)(showEventOption) && showEventOption.delay
            };
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_MenuBase.prototype._getDefaultOptions.call(this), {
                    showEvent: DEFAULT_SHOW_EVENT,
                    closeOnOutsideClick: true,
                    position: {
                        at: "top left",
                        my: "top left"
                    },
                    onShowing: null,
                    onShown: null,
                    onSubmenuCreated: null,
                    onHiding: null,
                    onHidden: null,
                    onPositioning: null,
                    submenuDirection: "auto",
                    visible: false,
                    target: void 0,
                    onLeftFirstItem: null,
                    onLeftLastItem: null,
                    onCloseRootSubmenu: null,
                    onExpandLastSubmenu: null
                })
            };
            _proto._defaultOptionsRules = function() {
                return _MenuBase.prototype._defaultOptionsRules.call(this).concat([{
                    device: function() {
                        return !(0, _window.hasWindow)()
                    },
                    options: {
                        animation: null
                    }
                }])
            };
            _proto._initActions = function() {
                var _this = this;
                this._actions = {};
                (0, _iterator.each)(ACTIONS, function(index, action) {
                    _this._actions[action] = _this._createActionByOption(action) || _common.noop
                })
            };
            _proto._setOptionsByReference = function() {
                _MenuBase.prototype._setOptionsByReference.call(this);
                (0, _extend.extend)(this._optionsByReference, {
                    animation: true,
                    selectedItem: true
                })
            };
            _proto._focusInHandler = function() {};
            _proto._itemContainer = function() {
                return this._overlay ? this._overlay.$content() : (0, _renderer.default)()
            };
            _proto._eventBindingTarget = function() {
                return this._itemContainer()
            };
            _proto.itemsContainer = function() {
                return this._overlay ? this._overlay.$content() : void 0
            };
            _proto._supportedKeys = function() {
                var _this2 = this;
                var selectItem = function() {
                    var $item = (0, _renderer.default)(_this2.option("focusedElement"));
                    _this2.hide();
                    if (!$item.length || !_this2._isSelectionEnabled()) {
                        return
                    }
                    _this2.selectItem($item[0])
                };
                return (0, _extend.extend)(_MenuBase.prototype._supportedKeys.call(this), {
                    space: selectItem,
                    escape: this.hide
                })
            };
            _proto._getActiveItem = function() {
                var $availableItems = this._getAvailableItems();
                var $focusedItem = $availableItems.filter(".".concat(DX_STATE_FOCUSED_CLASS));
                var $hoveredItem = $availableItems.filter(".".concat(DX_STATE_HOVER_CLASS));
                var $hoveredItemContainer = $hoveredItem.closest(".".concat(DX_MENU_ITEMS_CONTAINER_CLASS));
                if ($hoveredItemContainer.find(".".concat(DX_MENU_ITEM_CLASS)).index($focusedItem) >= 0) {
                    return $focusedItem
                }
                if ($hoveredItem.length) {
                    return $hoveredItem
                }
                return _MenuBase.prototype._getActiveItem.call(this)
            };
            _proto._moveFocus = function(location) {
                var $items = this._getItemsByLocation(location);
                var $oldTarget = this._getActiveItem(true);
                var $hoveredItem = this.itemsContainer().find(".".concat(DX_STATE_HOVER_CLASS));
                var $focusedItem = (0, _renderer.default)(this.option("focusedElement"));
                var $activeItemHighlighted = !!($focusedItem.length || $hoveredItem.length);
                var $newTarget;
                switch (location) {
                    case FOCUS_UP:
                        $newTarget = $activeItemHighlighted ? this._prevItem($items) : $oldTarget;
                        this._setFocusedElement($newTarget);
                        if ($oldTarget.is($items.first())) {
                            this._actions.onLeftFirstItem($oldTarget)
                        }
                        break;
                    case FOCUS_DOWN:
                        $newTarget = $activeItemHighlighted ? this._nextItem($items) : $oldTarget;
                        this._setFocusedElement($newTarget);
                        if ($oldTarget.is($items.last())) {
                            this._actions.onLeftLastItem($oldTarget)
                        }
                        break;
                    case FOCUS_RIGHT:
                        $newTarget = this.option("rtlEnabled") ? this._hideSubmenuHandler() : this._expandSubmenuHandler($items, location);
                        this._setFocusedElement($newTarget);
                        break;
                    case FOCUS_LEFT:
                        $newTarget = this.option("rtlEnabled") ? this._expandSubmenuHandler($items, location) : this._hideSubmenuHandler();
                        this._setFocusedElement($newTarget);
                        break;
                    case FOCUS_FIRST:
                        $newTarget = $items.first();
                        this._setFocusedElement($newTarget);
                        break;
                    case FOCUS_LAST:
                        $newTarget = $items.last();
                        this._setFocusedElement($newTarget);
                        break;
                    default:
                        return _MenuBase.prototype._moveFocus.call(this, location)
                }
            };
            _proto._setFocusedElement = function($element) {
                if ($element && 0 !== $element.length) {
                    this.option("focusedElement", (0, _element.getPublicElement)($element))
                }
            };
            _proto._getItemsByLocation = function(location) {
                var $activeItem = this._getActiveItem(true);
                var $items;
                if ((0, _array.inArray)(location, LOCAL_SUBMENU_DIRECTIONS) >= 0) {
                    $items = $activeItem.closest(".".concat(DX_MENU_ITEMS_CONTAINER_CLASS)).children().children()
                }
                $items = this._getAvailableItems($items);
                return $items
            };
            _proto._getAriaTarget = function() {
                return this.$element()
            };
            _proto._refreshActiveDescendant = function() {
                if ((0, _type.isDefined)(this._overlay)) {
                    var $target = this._overlay.$content();
                    _MenuBase.prototype._refreshActiveDescendant.call(this, $target)
                }
            };
            _proto._hideSubmenuHandler = function() {
                var $curItem = this._getActiveItem(true);
                var $parentItem = $curItem.parents(".".concat(DX_MENU_ITEM_EXPANDED_CLASS)).first();
                if ($parentItem.length) {
                    this._hideSubmenusOnSameLevel($parentItem);
                    this._hideSubmenu($curItem.closest(".".concat(DX_SUBMENU_CLASS)));
                    return $parentItem
                }
                this._actions.onCloseRootSubmenu($curItem);
                return $curItem
            };
            _proto._expandSubmenuHandler = function($items, location) {
                var $curItem = this._getActiveItem(true);
                var itemData = this._getItemData($curItem);
                var node = this._dataAdapter.getNodeByItem(itemData);
                var isItemHasSubmenu = this._hasSubmenu(node);
                var $submenu = $curItem.children(".".concat(DX_SUBMENU_CLASS));
                if (isItemHasSubmenu && !$curItem.hasClass(DX_STATE_DISABLED_CLASS)) {
                    if (!$submenu.length || "hidden" === $submenu.css("visibility")) {
                        this._showSubmenu($curItem)
                    }
                    return this._nextItem(this._getItemsByLocation(location))
                }
                this._actions.onExpandLastSubmenu($curItem);
                return
            };
            _proto._clean = function() {
                if (this._overlay) {
                    this._overlay.$element().remove();
                    this._overlay = null
                }
                this._detachShowContextMenuEvents(this._getTarget());
                _MenuBase.prototype._clean.call(this)
            };
            _proto._initMarkup = function() {
                this.$element().addClass(DX_HAS_CONTEXT_MENU_CLASS);
                _MenuBase.prototype._initMarkup.call(this)
            };
            _proto._render = function() {
                _MenuBase.prototype._render.call(this);
                this._renderVisibility(this.option("visible"));
                this._addWidgetClass()
            };
            _proto._renderContentImpl = function() {
                this._detachShowContextMenuEvents(this._getTarget());
                this._attachShowContextMenuEvents()
            };
            _proto._attachKeyboardEvents = function() {
                !this._keyboardListenerId && this._focusTarget().length && _MenuBase.prototype._attachKeyboardEvents.call(this)
            };
            _proto._renderContextMenuOverlay = function() {
                if (this._overlay) {
                    return
                }
                var overlayOptions = this._getOverlayOptions();
                this._overlay = this._createComponent((0, _renderer.default)("<div>").appendTo(this._$element), _overlay.default, overlayOptions);
                var $overlayContent = this._overlay.$content();
                $overlayContent.addClass(DX_CONTEXT_MENU_CLASS);
                this._addCustomCssClass($overlayContent);
                this._addPlatformDependentClass($overlayContent);
                this._attachContextMenuEvent()
            };
            _proto._itemContextMenuHandler = function(e) {
                _MenuBase.prototype._itemContextMenuHandler.call(this, e);
                e.stopPropagation()
            };
            _proto._addPlatformDependentClass = function($element) {
                if (_devices.default.current().phone) {
                    $element.addClass(DX_MENU_PHONE_CLASS)
                }
            };
            _proto._detachShowContextMenuEvents = function(target) {
                var showEvent = this.getShowEvent(this.option("showEvent"));
                if (!showEvent) {
                    return
                }
                var eventName = (0, _index.addNamespace)(showEvent, this.NAME);
                if (this._showContextMenuEventHandler) {
                    _events_engine.default.off(_dom_adapter.default.getDocument(), eventName, target, this._showContextMenuEventHandler)
                } else {
                    _events_engine.default.off((0, _renderer.default)(target), eventName)
                }
            };
            _proto._attachShowContextMenuEvents = function() {
                var _this3 = this;
                var target = this._getTarget();
                var showEvent = this.getShowEvent(this.option("showEvent"));
                if (!showEvent) {
                    return
                }
                var eventName = (0, _index.addNamespace)(showEvent, this.NAME);
                var contextMenuAction = this._createAction(function(e) {
                    var delay = _this3.getShowDelay(_this3.option("showEvent"));
                    if (delay) {
                        setTimeout(function() {
                            return _this3._show(e.event)
                        }, delay)
                    } else {
                        _this3._show(e.event)
                    }
                }, {
                    validatingTargetName: "target"
                });
                var handler = function(e) {
                    return contextMenuAction({
                        event: e,
                        target: (0, _renderer.default)(e.currentTarget)
                    })
                };
                contextMenuAction = this._createAction(contextMenuAction);
                if ((0, _type.isRenderer)(target) || target.nodeType || (0, _type.isWindow)(target)) {
                    this._showContextMenuEventHandler = void 0;
                    _events_engine.default.on(target, eventName, handler)
                } else {
                    this._showContextMenuEventHandler = handler;
                    _events_engine.default.on(_dom_adapter.default.getDocument(), eventName, target, this._showContextMenuEventHandler)
                }
            };
            _proto._hoverEndHandler = function(e) {
                _MenuBase.prototype._hoverEndHandler.call(this, e);
                e.stopPropagation()
            };
            _proto._renderDimensions = function() {};
            _proto._renderContainer = function($wrapper, submenuContainer) {
                var $holder = submenuContainer || this._itemContainer();
                $wrapper = (0, _renderer.default)("<div>");
                $wrapper.appendTo($holder).addClass(DX_SUBMENU_CLASS).css("visibility", submenuContainer ? "hidden" : "visible");
                var $itemsContainer = _MenuBase.prototype._renderContainer.call(this, $wrapper);
                if (submenuContainer) {
                    return $itemsContainer
                }
                if (this.option("width")) {
                    return $itemsContainer.css("minWidth", this.option("width"))
                }
                if (this.option("height")) {
                    return $itemsContainer.css("minHeight", this.option("height"))
                }
                return $itemsContainer
            };
            _proto._renderSubmenuItems = function(node, $itemFrame) {
                this._renderItems(this._getChildNodes(node), $itemFrame);
                this._actions.onSubmenuCreated({
                    itemElement: (0, _element.getPublicElement)($itemFrame),
                    itemData: node.internalFields.item,
                    submenuElement: (0, _element.getPublicElement)($itemFrame.children(".".concat(DX_SUBMENU_CLASS)))
                })
            };
            _proto._getOverlayOptions = function() {
                var position = this.option("position");
                var overlayOptions = {
                    focusStateEnabled: this.option("focusStateEnabled"),
                    animation: this.option("animation"),
                    innerOverlay: true,
                    closeOnOutsideClick: this._closeOnOutsideClickHandler.bind(this),
                    propagateOutsideClick: true,
                    closeOnTargetScroll: true,
                    deferRendering: false,
                    position: {
                        at: position.at,
                        my: position.my,
                        of: this._getTarget(),
                        collision: "flipfit"
                    },
                    shading: false,
                    showTitle: false,
                    height: "auto",
                    width: "auto",
                    onShown: this._overlayShownActionHandler.bind(this),
                    onHiding: this._overlayHidingActionHandler.bind(this),
                    onHidden: this._overlayHiddenActionHandler.bind(this)
                };
                return overlayOptions
            };
            _proto._overlayShownActionHandler = function(arg) {
                this._actions.onShown(arg)
            };
            _proto._overlayHidingActionHandler = function(arg) {
                this._actions.onHiding(arg);
                if (!arg.cancel) {
                    this._hideAllShownSubmenus();
                    this._setOptionWithoutOptionChange("visible", false)
                }
            };
            _proto._overlayHiddenActionHandler = function(arg) {
                this._actions.onHidden(arg)
            };
            _proto._closeOnOutsideClickHandler = function(e) {
                var closeOnOutsideClick = this.option("closeOnOutsideClick");
                if ((0, _type.isFunction)(closeOnOutsideClick)) {
                    return closeOnOutsideClick(e)
                }
                if (!closeOnOutsideClick) {
                    return false
                }
                if (_dom_adapter.default.isDocument(e.target)) {
                    return true
                }
                var $activeItemContainer = this._getActiveItemsContainer(e.target);
                var $itemContainers = this._getItemsContainers();
                var $clickedItem = this._searchActiveItem(e.target);
                var $rootItem = this.$element().parents(".".concat(DX_MENU_ITEM_CLASS));
                var isRootItemClicked = $clickedItem[0] === $rootItem[0] && $clickedItem.length && $rootItem.length;
                var isInnerOverlayClicked = this._isIncludeOverlay($activeItemContainer, $itemContainers) && $clickedItem.length;
                if (isInnerOverlayClicked || isRootItemClicked) {
                    if ("onClick" === this._getShowSubmenuMode()) {
                        this._hideAllShownChildSubmenus($clickedItem)
                    }
                    return false
                }
                return true
            };
            _proto._getActiveItemsContainer = function(target) {
                return (0, _renderer.default)(target).closest(".".concat(DX_MENU_ITEMS_CONTAINER_CLASS))
            };
            _proto._getItemsContainers = function() {
                return this._overlay._$content.find(".".concat(DX_MENU_ITEMS_CONTAINER_CLASS))
            };
            _proto._searchActiveItem = function(target) {
                return (0, _renderer.default)(target).closest(".".concat(DX_MENU_ITEM_CLASS)).eq(0)
            };
            _proto._isIncludeOverlay = function($activeOverlay, $allOverlays) {
                var isSame = false;
                (0, _iterator.each)($allOverlays, function(index, $overlay) {
                    if ($activeOverlay.is($overlay) && !isSame) {
                        isSame = true
                    }
                });
                return isSame
            };
            _proto._hideAllShownChildSubmenus = function($clickedItem) {
                var _this4 = this;
                var $submenuElements = $clickedItem.find(".".concat(DX_SUBMENU_CLASS));
                var shownSubmenus = (0, _extend.extend)([], this._shownSubmenus);
                if ($submenuElements.length > 0) {
                    (0, _iterator.each)(shownSubmenus, function(index, $submenu) {
                        var $context = _this4._searchActiveItem($submenu.context).parent();
                        if ($context.parent().is($clickedItem.parent().parent()) && !$context.is($clickedItem.parent())) {
                            _this4._hideSubmenu($submenu)
                        }
                    })
                }
            };
            _proto._showSubmenu = function($item) {
                var node = this._dataAdapter.getNodeByItem(this._getItemData($item));
                this._hideSubmenusOnSameLevel($item);
                if (!this._hasSubmenu(node)) {
                    return
                }
                var $submenu = $item.children(".".concat(DX_SUBMENU_CLASS));
                var isSubmenuRendered = $submenu.length;
                _MenuBase.prototype._showSubmenu.call(this, $item);
                if (!isSubmenuRendered) {
                    this._renderSubmenuItems(node, $item)
                }
                if (!this._isSubmenuVisible($submenu)) {
                    this._drawSubmenu($item)
                }
            };
            _proto._hideSubmenusOnSameLevel = function($item) {
                var $expandedItems = $item.parent(".".concat(DX_MENU_ITEM_WRAPPER_CLASS)).siblings().find(".".concat(DX_MENU_ITEM_EXPANDED_CLASS));
                if ($expandedItems.length) {
                    $expandedItems.removeClass(DX_MENU_ITEM_EXPANDED_CLASS);
                    this._hideSubmenu($expandedItems.find(".".concat(DX_SUBMENU_CLASS)))
                }
            };
            _proto._hideSubmenuGroup = function($submenu) {
                if (this._isSubmenuVisible($submenu)) {
                    this._hideSubmenuCore($submenu)
                }
            };
            _proto._isSubmenuVisible = function($submenu) {
                return "visible" === $submenu.css("visibility")
            };
            _proto._drawSubmenu = function($itemElement) {
                var animation = this.option("animation") ? this.option("animation").show : {};
                var $submenu = $itemElement.children(".".concat(DX_SUBMENU_CLASS));
                var submenuPosition = this._getSubmenuPosition($itemElement);
                if (this._overlay && this._overlay.option("visible")) {
                    if (!(0, _type.isDefined)(this._shownSubmenus)) {
                        this._shownSubmenus = []
                    }
                    if ((0, _array.inArray)($submenu, this._shownSubmenus)) {
                        this._shownSubmenus.push($submenu)
                    }
                    if (animation) {
                        _fx.default.stop($submenu)
                    }
                    _position.default.setup($submenu, submenuPosition);
                    if (animation) {
                        if ((0, _type.isPlainObject)(animation.to)) {
                            animation.to.position = submenuPosition
                        }
                        this._animate($submenu, animation)
                    }
                    $submenu.css("visibility", "visible")
                }
            };
            _proto._animate = function($container, options) {
                _fx.default.animate($container, options)
            };
            _proto._getSubmenuPosition = function($rootItem) {
                var submenuDirection = this.option("submenuDirection").toLowerCase();
                var $rootItemWrapper = $rootItem.parent(".".concat(DX_MENU_ITEM_WRAPPER_CLASS));
                var position = {
                    collision: "flip",
                    of: $rootItemWrapper,
                    offset: {
                        h: 0,
                        v: -1
                    }
                };
                switch (submenuDirection) {
                    case "left":
                        position.at = "left top";
                        position.my = "right top";
                        break;
                    case "right":
                        position.at = "right top";
                        position.my = "left top";
                        break;
                    default:
                        if (this.option("rtlEnabled")) {
                            position.at = "left top";
                            position.my = "right top"
                        } else {
                            position.at = "right top";
                            position.my = "left top"
                        }
                }
                return position
            };
            _proto._updateSubmenuVisibilityOnClick = function(actionArgs) {
                if (!actionArgs.args.length) {
                    return
                }
                var itemData = actionArgs.args[0].itemData;
                var node = this._dataAdapter.getNodeByItem(itemData);
                if (!node) {
                    return
                }
                var $itemElement = (0, _renderer.default)(actionArgs.args[0].itemElement);
                var $submenu = $itemElement.find(".".concat(DX_SUBMENU_CLASS));
                var shouldRenderSubmenu = this._hasSubmenu(node) && !$submenu.length;
                if (shouldRenderSubmenu) {
                    this._renderSubmenuItems(node, $itemElement);
                    $submenu = $itemElement.find(".".concat(DX_SUBMENU_CLASS))
                }
                if ($itemElement.context === $submenu.context && "visible" === $submenu.css("visibility")) {
                    return
                }
                var notCloseMenuOnItemClick = itemData && false === itemData.closeMenuOnClick;
                if (!itemData || itemData.disabled || notCloseMenuOnItemClick) {
                    return
                }
                this._updateSelectedItemOnClick(actionArgs);
                if (0 === $submenu.length) {
                    var $prevSubmenu = (0, _renderer.default)($itemElement.parents(".".concat(DX_SUBMENU_CLASS))[0]);
                    this._hideSubmenu($prevSubmenu);
                    if (!actionArgs.canceled && this._overlay && this._overlay.option("visible")) {
                        this.option("visible", false)
                    }
                } else {
                    if (this._shownSubmenus && this._shownSubmenus.length > 0) {
                        if (this._shownSubmenus[0].is($submenu)) {
                            this._hideSubmenu($submenu)
                        }
                    }
                    this._showSubmenu($itemElement)
                }
            };
            _proto._hideSubmenu = function($curSubmenu) {
                var _this5 = this;
                var shownSubmenus = (0, _extend.extend)([], this._shownSubmenus);
                (0, _iterator.each)(shownSubmenus, function(index, $submenu) {
                    if ($curSubmenu.is($submenu) || (0, _dom.contains)($curSubmenu[0], $submenu[0])) {
                        $submenu.parent().removeClass(DX_MENU_ITEM_EXPANDED_CLASS);
                        _this5._hideSubmenuCore($submenu)
                    }
                })
            };
            _proto._hideSubmenuCore = function($submenu) {
                var index = (0, _array.inArray)($submenu, this._shownSubmenus);
                var animation = this.option("animation") ? this.option("animation").hide : null;
                if (index >= 0) {
                    this._shownSubmenus.splice(index, 1)
                }
                this._stopAnimate($submenu);
                animation && this._animate($submenu, animation);
                $submenu.css("visibility", "hidden")
            };
            _proto._stopAnimate = function($container) {
                _fx.default.stop($container, true)
            };
            _proto._hideAllShownSubmenus = function() {
                var _this6 = this;
                var shownSubmenus = (0, _extend.extend)([], this._shownSubmenus);
                var $expandedItems = this._overlay.$content().find(".".concat(DX_MENU_ITEM_EXPANDED_CLASS));
                $expandedItems.removeClass(DX_MENU_ITEM_EXPANDED_CLASS);
                (0, _iterator.each)(shownSubmenus, function(_, $submenu) {
                    _this6._hideSubmenu($submenu)
                })
            };
            _proto._visibilityChanged = function(visible) {
                if (visible) {
                    this._renderContentImpl()
                }
            };
            _proto._optionChanged = function(args) {
                if ((0, _array.inArray)(args.name, ACTIONS) > -1) {
                    this._initActions();
                    return
                }
                switch (args.name) {
                    case "visible":
                        this._renderVisibility(args.value);
                        break;
                    case "showEvent":
                    case "position":
                    case "submenuDirection":
                        this._invalidate();
                        break;
                    case "target":
                        args.previousValue && this._detachShowContextMenuEvents(args.previousValue);
                        this._invalidate();
                        break;
                    case "closeOnOutsideClick":
                        break;
                    default:
                        _MenuBase.prototype._optionChanged.call(this, args)
                }
            };
            _proto._renderVisibility = function(showing) {
                return showing ? this._show() : this._hide()
            };
            _proto._toggleVisibility = function() {};
            _proto._show = function(event) {
                var args = {
                    jQEvent: event
                };
                var promise = (new _deferred.Deferred).reject().promise();
                this._actions.onShowing(args);
                if (args.cancel) {
                    return promise
                }
                var position = this._positionContextMenu(event);
                if (position) {
                    if (!this._overlay) {
                        this._renderContextMenuOverlay();
                        this._overlay.$content().addClass(this._widgetClass());
                        this._renderFocusState();
                        this._attachHoverEvents();
                        this._attachClickEvent();
                        this._renderItems(this._dataAdapter.getRootNodes())
                    }
                    this._setOptionWithoutOptionChange("visible", true);
                    this._overlay.option("position", position);
                    promise = this._overlay.show();
                    event && event.stopPropagation();
                    this._setAriaAttributes()
                }
                return promise
            };
            _proto._setAriaAttributes = function() {
                this._overlayContentId = "dx-".concat(new _guid.default);
                this.setAria("owns", this._overlayContentId);
                this.setAria({
                    id: this._overlayContentId,
                    role: "menu"
                }, this._overlay.$content())
            };
            _proto._cleanAriaAttributes = function() {
                this._overlay && this.setAria("id", null, this._overlay.$content());
                this.setAria("owns", void 0)
            };
            _proto._getTarget = function() {
                return this.option("target") || this.option("position").of || (0, _renderer.default)(_dom_adapter.default.getDocument())
            };
            _proto._getContextMenuPosition = function() {
                return (0, _extend.extend)({}, this.option("position"), {
                    of: this._getTarget()
                })
            };
            _proto._positionContextMenu = function(jQEvent) {
                var position = this._getContextMenuPosition();
                var isInitialPosition = this._isInitialOptionValue("position");
                var positioningAction = this._createActionByOption("onPositioning", actionArgs);
                if (jQEvent && jQEvent.preventDefault && isInitialPosition) {
                    position.of = jQEvent
                }
                var actionArgs = {
                    position: position,
                    event: jQEvent
                };
                positioningAction(actionArgs);
                if (actionArgs.cancel) {
                    position = null
                } else {
                    if (actionArgs.event) {
                        actionArgs.event.cancel = true;
                        jQEvent.preventDefault()
                    }
                }
                return position
            };
            _proto._refresh = function() {
                if (!(0, _window.hasWindow)()) {
                    _MenuBase.prototype._refresh.call(this)
                } else {
                    if (this._overlay) {
                        var lastPosition = this._overlay.option("position");
                        _MenuBase.prototype._refresh.call(this);
                        this._overlay && this._overlay.option("position", lastPosition)
                    } else {
                        _MenuBase.prototype._refresh.call(this)
                    }
                }
            };
            _proto._hide = function() {
                var promise;
                if (this._overlay) {
                    promise = this._overlay.hide();
                    this._setOptionWithoutOptionChange("visible", false)
                }
                this._cleanAriaAttributes();
                this.option("focusedElement", null);
                return promise || (new _deferred.Deferred).reject().promise()
            };
            _proto.toggle = function(showing) {
                var visible = this.option("visible");
                showing = void 0 === showing ? !visible : showing;
                return this._renderVisibility(showing)
            };
            _proto.show = function() {
                return this.toggle(true)
            };
            _proto.hide = function() {
                return this.toggle(false)
            };
            return ContextMenu
        }(_ui.default);
        (0, _component_registrator.default)("dxContextMenu", ContextMenu);
        var _default = ContextMenu;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/context_menu/ui.menu_base.js ***!
      \******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _utils = __webpack_require__( /*! ../widget/utils.ink_ripple */ 82);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../hierarchical_collection/ui.hierarchical_collection_widget */ 377));
        var _uiMenu_baseEdit = _interopRequireDefault(__webpack_require__( /*! ./ui.menu_base.edit.strategy */ 689));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _item = _interopRequireDefault(__webpack_require__( /*! ../collection/item */ 150));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var DX_MENU_CLASS = "dx-menu";
        var DX_MENU_NO_ICONS_CLASS = DX_MENU_CLASS + "-no-icons";
        var DX_MENU_BASE_CLASS = "dx-menu-base";
        var ITEM_CLASS = DX_MENU_CLASS + "-item";
        var DX_ITEM_CONTENT_CLASS = ITEM_CLASS + "-content";
        var DX_MENU_SELECTED_ITEM_CLASS = ITEM_CLASS + "-selected";
        var DX_MENU_ITEM_WRAPPER_CLASS = ITEM_CLASS + "-wrapper";
        var DX_MENU_ITEMS_CONTAINER_CLASS = DX_MENU_CLASS + "-items-container";
        var DX_MENU_ITEM_EXPANDED_CLASS = ITEM_CLASS + "-expanded";
        var DX_MENU_SEPARATOR_CLASS = DX_MENU_CLASS + "-separator";
        var DX_MENU_ITEM_LAST_GROUP_ITEM = DX_MENU_CLASS + "-last-group-item";
        var DX_ITEM_HAS_TEXT = ITEM_CLASS + "-has-text";
        var DX_ITEM_HAS_ICON = ITEM_CLASS + "-has-icon";
        var DX_ITEM_HAS_SUBMENU = ITEM_CLASS + "-has-submenu";
        var DX_MENU_ITEM_POPOUT_CLASS = ITEM_CLASS + "-popout";
        var DX_MENU_ITEM_POPOUT_CONTAINER_CLASS = DX_MENU_ITEM_POPOUT_CLASS + "-container";
        var DX_MENU_ITEM_CAPTION_CLASS = ITEM_CLASS + "-text";
        var SINGLE_SELECTION_MODE = "single";
        var DEFAULT_DELAY = {
            show: 50,
            hide: 300
        };
        var MenuBase = function(_HierarchicalCollecti) {
            _inheritsLoose(MenuBase, _HierarchicalCollecti);

            function MenuBase() {
                return _HierarchicalCollecti.apply(this, arguments) || this
            }
            var _proto = MenuBase.prototype;
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_HierarchicalCollecti.prototype._getDefaultOptions.call(this), {
                    items: [],
                    cssClass: "",
                    activeStateEnabled: true,
                    showSubmenuMode: {
                        name: "onHover",
                        delay: {
                            show: 50,
                            hide: 300
                        }
                    },
                    animation: {
                        show: {
                            type: "fade",
                            from: 0,
                            to: 1,
                            duration: 100
                        },
                        hide: {
                            type: "fade",
                            from: 1,
                            to: 0,
                            duration: 100
                        }
                    },
                    selectByClick: false,
                    focusOnSelectedItem: false,
                    keyExpr: null,
                    _itemAttributes: {
                        role: "menuitem"
                    },
                    useInkRipple: false
                })
            };
            _proto._itemDataKey = function() {
                return "dxMenuItemDataKey"
            };
            _proto._itemClass = function() {
                return ITEM_CLASS
            };
            _proto._setAriaSelected = function() {};
            _proto._selectedItemClass = function() {
                return DX_MENU_SELECTED_ITEM_CLASS
            };
            _proto._widgetClass = function() {
                return DX_MENU_BASE_CLASS
            };
            _proto._focusTarget = function() {
                return this._itemContainer()
            };
            _proto._clean = function() {
                this.option("focusedElement", null);
                _HierarchicalCollecti.prototype._clean.call(this)
            };
            _proto._supportedKeys = function() {
                var _this = this;
                var selectItem = function() {
                    var $item = (0, _renderer.default)(_this.option("focusedElement"));
                    if (!$item.length || !_this._isSelectionEnabled()) {
                        return
                    }
                    _this.selectItem($item[0])
                };
                return (0, _extend.extend)(_HierarchicalCollecti.prototype._supportedKeys.call(this), {
                    space: selectItem,
                    pageUp: _common.noop,
                    pageDown: _common.noop
                })
            };
            _proto._isSelectionEnabled = function() {
                return this.option("selectionMode") === SINGLE_SELECTION_MODE
            };
            _proto._init = function() {
                this._activeStateUnit = ".".concat(ITEM_CLASS);
                _HierarchicalCollecti.prototype._init.call(this);
                this._renderSelectedItem();
                this._initActions()
            };
            _proto._getTextContainer = function(itemData) {
                var itemText = itemData.text;
                var $itemContainer = (0, _renderer.default)("<span>").addClass(DX_MENU_ITEM_CAPTION_CLASS);
                var itemContent = (0, _type.isPlainObject)(itemData) ? itemText : String(itemData);
                return itemText && $itemContainer.text(itemContent)
            };
            _proto._getPopoutContainer = function(itemData) {
                var items = itemData.items;
                var $popOutContainer;
                if (items && items.length) {
                    var $popOutImage = (0, _renderer.default)("<div>").addClass(DX_MENU_ITEM_POPOUT_CLASS);
                    $popOutContainer = (0, _renderer.default)("<span>").addClass(DX_MENU_ITEM_POPOUT_CONTAINER_CLASS).append($popOutImage)
                }
                return $popOutContainer
            };
            _proto._getDataAdapterOptions = function() {
                return {
                    rootValue: 0,
                    multipleSelection: false,
                    recursiveSelection: false,
                    recursiveExpansion: false,
                    searchValue: ""
                }
            };
            _proto._selectByItem = function(selectedItem) {
                if (!selectedItem) {
                    return
                }
                var nodeToSelect = this._dataAdapter.getNodeByItem(selectedItem);
                this._dataAdapter.toggleSelection(nodeToSelect.internalFields.key, true)
            };
            _proto._renderSelectedItem = function() {
                var selectedKeys = this._dataAdapter.getSelectedNodesKeys();
                var selectedKey = selectedKeys.length && selectedKeys[0];
                var selectedItem = this.option("selectedItem");
                if (!selectedKey) {
                    this._selectByItem(selectedItem);
                    return
                }
                var node = this._dataAdapter.getNodeByKey(selectedKey);
                if (false === node.selectable) {
                    return
                }
                if (!selectedItem) {
                    this.option("selectedItem", node.internalFields.item);
                    return
                }
                if (selectedItem !== node.internalFields.item) {
                    this._dataAdapter.toggleSelection(selectedKey, false);
                    this._selectByItem(selectedItem)
                }
            };
            _proto._initActions = function() {};
            _proto._initMarkup = function() {
                _HierarchicalCollecti.prototype._initMarkup.call(this);
                this._addCustomCssClass(this.$element());
                this.option("useInkRipple") && this._renderInkRipple()
            };
            _proto._renderInkRipple = function() {
                this._inkRipple = (0, _utils.render)()
            };
            _proto._toggleActiveState = function($element, value, e) {
                _HierarchicalCollecti.prototype._toggleActiveState.apply(this, arguments);
                if (!this._inkRipple) {
                    return
                }
                var config = {
                    element: $element,
                    event: e
                };
                if (value) {
                    this._inkRipple.showWave(config)
                } else {
                    this._inkRipple.hideWave(config)
                }
            };
            _proto._getShowSubmenuMode = function() {
                var defaultValue = "onClick";
                var optionValue = this.option("showSubmenuMode");
                optionValue = (0, _type.isObject)(optionValue) ? optionValue.name : optionValue;
                return this._isDesktopDevice() ? optionValue : defaultValue
            };
            _proto._initSelectedItems = function() {};
            _proto._isDesktopDevice = function() {
                return "desktop" === _devices.default.real().deviceType
            };
            _proto._initEditStrategy = function() {
                var Strategy = _uiMenu_baseEdit.default;
                this._editStrategy = new Strategy(this)
            };
            _proto._addCustomCssClass = function($element) {
                $element.addClass(this.option("cssClass"))
            };
            _proto._itemWrapperSelector = function() {
                return ".".concat(DX_MENU_ITEM_WRAPPER_CLASS)
            };
            _proto._hoverStartHandler = function(e) {
                var $itemElement = this._getItemElementByEventArgs(e);
                if (!$itemElement || this._isItemDisabled($itemElement)) {
                    return
                }
                e.stopPropagation();
                if ("onHover" === this._getShowSubmenuMode()) {
                    clearTimeout(this._showSubmenusTimeout);
                    this._showSubmenusTimeout = setTimeout(this._showSubmenu.bind(this, $itemElement), this._getSubmenuDelay("show"))
                }
            };
            _proto._getAvailableItems = function($itemElements) {
                return _HierarchicalCollecti.prototype._getAvailableItems.call(this, $itemElements).filter(function() {
                    return "hidden" !== (0, _renderer.default)(this).css("visibility")
                })
            };
            _proto._isItemDisabled = function($item) {
                return this._disabledGetter($item.data(this._itemDataKey()))
            };
            _proto._showSubmenu = function($itemElement) {
                this._addExpandedClass($itemElement)
            };
            _proto._addExpandedClass = function(itemElement) {
                (0, _renderer.default)(itemElement).addClass(DX_MENU_ITEM_EXPANDED_CLASS)
            };
            _proto._getSubmenuDelay = function(action) {
                var _this$option = this.option("showSubmenuMode"),
                    delay = _this$option.delay;
                if (!(0, _type.isDefined)(delay)) {
                    return DEFAULT_DELAY[action]
                }
                return (0, _type.isObject)(delay) ? delay[action] : delay
            };
            _proto._getItemElementByEventArgs = function(eventArgs) {
                var $target = (0, _renderer.default)(eventArgs.target);
                if ($target.hasClass(this._itemClass()) || $target.get(0) === eventArgs.currentTarget) {
                    return $target
                }
                while (!$target.hasClass(this._itemClass())) {
                    $target = $target.parent();
                    if ($target.hasClass("dx-submenu")) {
                        return null
                    }
                }
                return $target
            };
            _proto._hoverEndHandler = function() {
                clearTimeout(this._showSubmenusTimeout)
            };
            _proto._hasSubmenu = function(node) {
                return node && node.internalFields.childrenKeys.length
            };
            _proto._renderContentImpl = function() {
                this._renderItems(this._dataAdapter.getRootNodes())
            };
            _proto._renderItems = function(nodes, submenuContainer) {
                var _this2 = this;
                if (nodes.length) {
                    this.hasIcons = false;
                    var $nodeContainer = this._renderContainer(this.$element(), submenuContainer);
                    var firstVisibleIndex = -1;
                    var nextGroupFirstIndex = -1;
                    (0, _iterator.each)(nodes, function(index, node) {
                        var isVisibleNode = false !== node.visible;
                        if (isVisibleNode && firstVisibleIndex < 0) {
                            firstVisibleIndex = index
                        }
                        var isBeginGroup = firstVisibleIndex < index && (node.beginGroup || index === nextGroupFirstIndex);
                        if (isBeginGroup) {
                            nextGroupFirstIndex = isVisibleNode ? index : index + 1
                        }
                        if (index === nextGroupFirstIndex && firstVisibleIndex < index) {
                            _this2._renderSeparator($nodeContainer)
                        }
                        _this2._renderItem(index, node, $nodeContainer)
                    });
                    if (!this.hasIcons) {
                        $nodeContainer.addClass(DX_MENU_NO_ICONS_CLASS)
                    }
                }
            };
            _proto._renderContainer = function($wrapper) {
                var $container = (0, _renderer.default)("<ul>");
                this.setAria("role", "none", $container);
                return $container.appendTo($wrapper).addClass(DX_MENU_ITEMS_CONTAINER_CLASS)
            };
            _proto._createDOMElement = function($nodeContainer) {
                var $node = (0, _renderer.default)("<li>");
                this.setAria("role", "none", $node);
                return $node.appendTo($nodeContainer).addClass(DX_MENU_ITEM_WRAPPER_CLASS)
            };
            _proto._renderItem = function(index, node, $nodeContainer, $nodeElement) {
                var items = this.option("items");
                var $node = $nodeElement || this._createDOMElement($nodeContainer);
                if (items[index + 1] && items[index + 1].beginGroup) {
                    $node.addClass(DX_MENU_ITEM_LAST_GROUP_ITEM)
                }
                var $itemFrame = _HierarchicalCollecti.prototype._renderItem.call(this, index, node.internalFields.item, $node);
                if (node.internalFields.item === this.option("selectedItem")) {
                    $itemFrame.addClass(DX_MENU_SELECTED_ITEM_CLASS)
                }
                $itemFrame.attr("tabIndex", -1);
                if (this._hasSubmenu(node)) {
                    this.setAria("haspopup", "true", $itemFrame)
                }
            };
            _proto._renderItemFrame = function(index, itemData, $itemContainer) {
                var $itemFrame = $itemContainer.children(".".concat(ITEM_CLASS));
                return $itemFrame.length ? $itemFrame : _HierarchicalCollecti.prototype._renderItemFrame.apply(this, arguments)
            };
            _proto._refreshItem = function($item, item) {
                var node = this._dataAdapter.getNodeByItem(item);
                var index = $item.data(this._itemIndexKey());
                var $nodeContainer = $item.closest("ul");
                var $nodeElement = $item.closest("li");
                this._renderItem(index, node, $nodeContainer, $nodeElement)
            };
            _proto._addContentClasses = function(itemData, $itemFrame) {
                var hasText = itemData.text ? !!itemData.text.length : false;
                var hasIcon = !!itemData.icon;
                var hasSubmenu = itemData.items ? !!itemData.items.length : false;
                $itemFrame.toggleClass(DX_ITEM_HAS_TEXT, hasText);
                $itemFrame.toggleClass(DX_ITEM_HAS_ICON, hasIcon);
                if (!this.hasIcons) {
                    this.hasIcons = hasIcon
                }
                $itemFrame.toggleClass(DX_ITEM_HAS_SUBMENU, hasSubmenu)
            };
            _proto._getItemContent = function($itemFrame) {
                var $itemContent = _HierarchicalCollecti.prototype._getItemContent.call(this, $itemFrame);
                if (!$itemContent.length) {
                    $itemContent = $itemFrame.children(".".concat(DX_ITEM_CONTENT_CLASS))
                }
                return $itemContent
            };
            _proto._postprocessRenderItem = function(args) {
                var $itemElement = (0, _renderer.default)(args.itemElement);
                var selectedIndex = this._dataAdapter.getSelectedNodesKeys();
                if (!selectedIndex.length || !this._selectedGetter(args.itemData) || !this._isItemSelectable(args.itemData)) {
                    this._setAriaSelected($itemElement, "false");
                    return
                }
                var node = this._dataAdapter.getNodeByItem(args.itemData);
                if (node.internalFields.key === selectedIndex[0]) {
                    $itemElement.addClass(this._selectedItemClass());
                    this._setAriaSelected($itemElement, "true")
                } else {
                    this._setAriaSelected($itemElement, "false")
                }
            };
            _proto._isItemSelectable = function(item) {
                return false !== item.selectable
            };
            _proto._renderSeparator = function($itemsContainer) {
                (0, _renderer.default)("<li>").appendTo($itemsContainer).addClass(DX_MENU_SEPARATOR_CLASS)
            };
            _proto._itemClickHandler = function(e) {
                if (e._skipHandling) {
                    return
                }
                var itemClickActionHandler = this._createAction(this._updateSubmenuVisibilityOnClick.bind(this));
                this._itemDXEventHandler(e, "onItemClick", {}, {
                    afterExecute: itemClickActionHandler.bind(this)
                });
                e._skipHandling = true
            };
            _proto._updateSubmenuVisibilityOnClick = function(actionArgs) {
                this._updateSelectedItemOnClick(actionArgs);
                if ("onClick" === this._getShowSubmenuMode()) {
                    this._addExpandedClass(actionArgs.args[0].itemElement)
                }
            };
            _proto._updateSelectedItemOnClick = function(actionArgs) {
                var args = actionArgs.args ? actionArgs.args[0] : actionArgs;
                if (!this._isItemSelectionAllowed(args.itemData)) {
                    return
                }
                var selectedItemKey = this._dataAdapter.getSelectedNodesKeys();
                var selectedNode = selectedItemKey.length && this._dataAdapter.getNodeByKey(selectedItemKey[0]);
                if (selectedNode) {
                    this._toggleItemSelection(selectedNode, false)
                }
                if (!selectedNode || selectedNode.internalFields.item !== args.itemData) {
                    this.selectItem(args.itemData)
                } else {
                    this._fireSelectionChangeEvent(null, this.option("selectedItem"));
                    this._setOptionWithoutOptionChange("selectedItem", null)
                }
            };
            _proto._isItemSelectionAllowed = function(item) {
                var isSelectionByClickEnabled = this._isSelectionEnabled() && this.option("selectByClick");
                return !this._isContainerEmpty() && isSelectionByClickEnabled && this._isItemSelectable(item) && !this._itemsGetter(item)
            };
            _proto._isContainerEmpty = function() {
                return this._itemContainer().is(":empty")
            };
            _proto._syncSelectionOptions = function() {
                return (0, _common.asyncNoop)()
            };
            _proto._optionChanged = function(args) {
                switch (args.name) {
                    case "showSubmenuMode":
                        break;
                    case "selectedItem":
                        var node = this._dataAdapter.getNodeByItem(args.value);
                        var selectedKey = this._dataAdapter.getSelectedNodesKeys()[0];
                        if (node && node.internalFields.key !== selectedKey) {
                            if (false === node.selectable) {
                                break
                            }
                            if (selectedKey) {
                                this._toggleItemSelection(this._dataAdapter.getNodeByKey(selectedKey), false)
                            }
                            this._toggleItemSelection(node, true);
                            this._updateSelectedItems()
                        }
                        break;
                    case "cssClass":
                    case "position":
                    case "selectByClick":
                    case "animation":
                    case "useInkRipple":
                        this._invalidate();
                        break;
                    default:
                        _HierarchicalCollecti.prototype._optionChanged.call(this, args)
                }
            };
            _proto._toggleItemSelection = function(node, value) {
                var itemElement = this._getElementByItem(node.internalFields.item);
                itemElement && (0, _renderer.default)(itemElement).toggleClass(DX_MENU_SELECTED_ITEM_CLASS);
                this._dataAdapter.toggleSelection(node.internalFields.key, value)
            };
            _proto._getElementByItem = function(itemData) {
                var _this3 = this;
                var result;
                (0, _iterator.each)(this._itemElements(), function(_, itemElement) {
                    if ((0, _renderer.default)(itemElement).data(_this3._itemDataKey()) !== itemData) {
                        return true
                    }
                    result = itemElement;
                    return false
                });
                return result
            };
            _proto._updateSelectedItems = function(oldSelection, newSelection) {
                if (oldSelection || newSelection) {
                    this._fireSelectionChangeEvent(newSelection, oldSelection)
                }
            };
            _proto._fireSelectionChangeEvent = function(addedSelection, removedSelection) {
                this._createActionByOption("onSelectionChanged", {
                    excludeValidators: ["disabled", "readOnly"]
                })({
                    addedItems: [addedSelection],
                    removedItems: [removedSelection]
                })
            };
            _proto.selectItem = function(itemElement) {
                var itemData = itemElement.nodeType ? this._getItemData(itemElement) : itemElement;
                var selectedKey = this._dataAdapter.getSelectedNodesKeys()[0];
                var selectedItem = this.option("selectedItem");
                var node = this._dataAdapter.getNodeByItem(itemData);
                if (node.internalFields.key !== selectedKey) {
                    if (selectedKey) {
                        this._toggleItemSelection(this._dataAdapter.getNodeByKey(selectedKey), false)
                    }
                    this._toggleItemSelection(node, true);
                    this._updateSelectedItems(selectedItem, itemData);
                    this._setOptionWithoutOptionChange("selectedItem", itemData)
                }
            };
            _proto.unselectItem = function(itemElement) {
                var itemData = itemElement.nodeType ? this._getItemData(itemElement) : itemElement;
                var node = this._dataAdapter.getNodeByItem(itemData);
                var selectedItem = this.option("selectedItem");
                if (node.internalFields.selected) {
                    this._toggleItemSelection(node, false);
                    this._updateSelectedItems(selectedItem, null);
                    this._setOptionWithoutOptionChange("selectedItem", null)
                }
            };
            return MenuBase
        }(_ui.default);
        MenuBase.ItemClass = _item.default;
        var _default = MenuBase;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/hierarchical_collection/ui.hierarchical_collection_widget.js ***!
      \**************************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _data = __webpack_require__( /*! ../../core/utils/data */ 20);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _icon = __webpack_require__( /*! ../../core/utils/icon */ 56);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./ui.data_adapter */ 687));
        var _uiCollection_widget = _interopRequireDefault(__webpack_require__( /*! ../collection/ui.collection_widget.edit */ 54));
        var _bindable_template = __webpack_require__( /*! ../../core/templates/bindable_template */ 65);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DISABLED_STATE_CLASS = "dx-state-disabled";
        var HierarchicalCollectionWidget = _uiCollection_widget.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    keyExpr: "id",
                    displayExpr: "text",
                    selectedExpr: "selected",
                    disabledExpr: "disabled",
                    itemsExpr: "items",
                    hoverStateEnabled: true,
                    parentIdExpr: "parentId",
                    expandedExpr: "expanded"
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: function() {
                        return "desktop" === _devices.default.real().deviceType && !_devices.default.isSimulator()
                    },
                    options: {
                        focusStateEnabled: true
                    }
                }])
            },
            _init: function() {
                this.callBase();
                this._initAccessors();
                this._initDataAdapter();
                this._initDynamicTemplates()
            },
            _initDataSource: function() {
                this.callBase();
                this._dataSource && this._dataSource.paginate(false)
            },
            _initDataAdapter: function() {
                var accessors = this._createDataAdapterAccessors();
                this._dataAdapter = new _ui.default((0, _extend.extend)({
                    dataAccessors: {
                        getters: accessors.getters,
                        setters: accessors.setters
                    },
                    items: this.option("items")
                }, this._getDataAdapterOptions()))
            },
            _getDataAdapterOptions: _common.noop,
            _initDynamicTemplates: function() {
                var that = this;
                this._templateManager.addDefaultTemplates({
                    item: new _bindable_template.BindableTemplate(function($container, itemData) {
                        $container.html(itemData.html).append(this._getIconContainer(itemData)).append(this._getTextContainer(itemData)).append(this._getPopoutContainer(itemData));
                        that._addContentClasses(itemData, $container.parent())
                    }.bind(this), ["text", "html", "items", "icon"], this.option("integrationOptions.watchMethod"), {
                        text: this._displayGetter,
                        items: this._itemsGetter
                    })
                })
            },
            _getIconContainer: function(itemData) {
                return itemData.icon ? (0, _icon.getImageContainer)(itemData.icon) : void 0
            },
            _getTextContainer: function(itemData) {
                return (0, _renderer.default)("<span>").text(itemData.text)
            },
            _getPopoutContainer: _common.noop,
            _addContentClasses: _common.noop,
            _initAccessors: function() {
                var that = this;
                (0, _iterator.each)(this._getAccessors(), function(_, accessor) {
                    that._compileAccessor(accessor)
                });
                this._compileDisplayGetter()
            },
            _getAccessors: function() {
                return ["key", "selected", "items", "disabled", "parentId", "expanded"]
            },
            _getChildNodes: function(node) {
                var that = this;
                var arr = [];
                (0, _iterator.each)(node.internalFields.childrenKeys, function(_, key) {
                    var childNode = that._dataAdapter.getNodeByKey(key);
                    arr.push(childNode)
                });
                return arr
            },
            _hasChildren: function(node) {
                return node && node.internalFields.childrenKeys.length
            },
            _compileAccessor: function(optionName) {
                var getter = "_" + optionName + "Getter";
                var setter = "_" + optionName + "Setter";
                var optionExpr = this.option(optionName + "Expr");
                if (!optionExpr) {
                    this[getter] = _common.noop;
                    this[setter] = _common.noop;
                    return
                } else {
                    if ((0, _type.isFunction)(optionExpr)) {
                        this[setter] = function(obj, value) {
                            obj[optionExpr()] = value
                        };
                        this[getter] = function(obj) {
                            return obj[optionExpr()]
                        };
                        return
                    }
                }
                this[getter] = (0, _data.compileGetter)(optionExpr);
                this[setter] = (0, _data.compileSetter)(optionExpr)
            },
            _createDataAdapterAccessors: function() {
                var that = this;
                var accessors = {
                    getters: {},
                    setters: {}
                };
                (0, _iterator.each)(this._getAccessors(), function(_, accessor) {
                    var getterName = "_" + accessor + "Getter";
                    var setterName = "_" + accessor + "Setter";
                    var newAccessor = "parentId" === accessor ? "parentKey" : accessor;
                    accessors.getters[newAccessor] = that[getterName];
                    accessors.setters[newAccessor] = that[setterName]
                });
                accessors.getters.display = !this._displayGetter ? function(itemData) {
                    return itemData.text
                } : this._displayGetter;
                return accessors
            },
            _initMarkup: function() {
                this.callBase();
                this._addWidgetClass()
            },
            _addWidgetClass: function() {
                this._focusTarget().addClass(this._widgetClass())
            },
            _widgetClass: _common.noop,
            _renderItemFrame: function(index, itemData) {
                var $itemFrame = this.callBase.apply(this, arguments);
                $itemFrame.toggleClass(DISABLED_STATE_CLASS, !!this._disabledGetter(itemData));
                return $itemFrame
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "displayExpr":
                    case "keyExpr":
                        this._initAccessors();
                        this._initDynamicTemplates();
                        this.repaint();
                        break;
                    case "itemsExpr":
                    case "selectedExpr":
                    case "disabledExpr":
                    case "expandedExpr":
                    case "parentIdExpr":
                        this._initAccessors();
                        this._initDataAdapter();
                        this.repaint();
                        break;
                    case "items":
                        this._initDataAdapter();
                        this.callBase(args);
                        break;
                    default:
                        this.callBase(args)
                }
            }
        });
        var _default = HierarchicalCollectionWidget;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.base */ 691));
        __webpack_require__( /*! ./ui.data_grid.state_storing */ 701);
        __webpack_require__( /*! ./ui.data_grid.selection */ 702);
        __webpack_require__( /*! ./ui.data_grid.column_chooser */ 703);
        __webpack_require__( /*! ./ui.data_grid.grouping */ 705);
        __webpack_require__( /*! ./ui.data_grid.master_detail */ 708);
        __webpack_require__( /*! ./ui.data_grid.editing */ 709);
        __webpack_require__( /*! ./ui.data_grid.validating */ 711);
        __webpack_require__( /*! ./ui.data_grid.virtual_scrolling */ 712);
        __webpack_require__( /*! ./ui.data_grid.filter_row */ 713);
        __webpack_require__( /*! ./ui.data_grid.header_filter */ 715);
        __webpack_require__( /*! ./ui.data_grid.filter_sync */ 716);
        __webpack_require__( /*! ./ui.data_grid.filter_builder */ 720);
        __webpack_require__( /*! ./ui.data_grid.filter_panel */ 722);
        __webpack_require__( /*! ./ui.data_grid.search */ 723);
        __webpack_require__( /*! ./ui.data_grid.pager */ 724);
        __webpack_require__( /*! ./ui.data_grid.columns_resizing_reordering */ 726);
        __webpack_require__( /*! ./ui.data_grid.keyboard_navigation */ 727);
        __webpack_require__( /*! ./ui.data_grid.summary */ 728);
        __webpack_require__( /*! ./ui.data_grid.column_fixing */ 730);
        __webpack_require__( /*! ./ui.data_grid.adaptivity */ 731);
        __webpack_require__( /*! ./ui.data_grid.virtual_columns */ 732);
        __webpack_require__( /*! ./ui.data_grid.export */ 733);
        __webpack_require__( /*! ./ui.data_grid.focus */ 734);
        __webpack_require__( /*! ./ui.data_grid.row_dragging */ 735);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _uiData_grid.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.column_headers.js ***!
      \******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _uiGrid_core = __webpack_require__( /*! ./ui.grid_core.columns_view */ 183);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _uiGrid_core2 = __webpack_require__( /*! ./ui.grid_core.accessibility */ 290);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var CELL_CONTENT_CLASS = "text-content";
        var HEADERS_CLASS = "headers";
        var NOWRAP_CLASS = "nowrap";
        var ROW_CLASS_SELECTOR = ".dx-row";
        var HEADER_ROW_CLASS = "dx-header-row";
        var COLUMN_LINES_CLASS = "dx-column-lines";
        var CONTEXT_MENU_SORT_ASC_ICON = "context-menu-sort-asc";
        var CONTEXT_MENU_SORT_DESC_ICON = "context-menu-sort-desc";
        var CONTEXT_MENU_SORT_NONE_ICON = "context-menu-sort-none";
        var CELL_FOCUS_DISABLED_CLASS = "dx-cell-focus-disabled";
        var VISIBILITY_HIDDEN_CLASS = "dx-visibility-hidden";
        var TEXT_CONTENT_ALIGNMENT_CLASS_PREFIX = "dx-text-content-alignment-";
        var SORT_INDICATOR_CLASS = "dx-sort-indicator";
        var SORT_INDEX_INDICATOR_CLASS = "dx-sort-index-indicator";
        var HEADER_FILTER_CLASS_SELECTOR = ".dx-header-filter";
        var HEADER_FILTER_INDICATOR_CLASS = "dx-header-filter-indicator";
        var MULTI_ROW_HEADER_CLASS = "dx-header-multi-row";
        var _default = {
            defaultOptions: function() {
                return {
                    showColumnHeaders: true,
                    cellHintEnabled: true
                }
            },
            views: {
                columnHeadersView: _uiGrid_core.ColumnsView.inherit(function() {
                    var createCellContent = function(that, $cell, options) {
                        var $cellContent = (0, _renderer.default)("<div>").addClass(that.addWidgetPrefix(CELL_CONTENT_CLASS));
                        that.setAria("role", "presentation", $cellContent);
                        addCssClassesToCellContent(that, $cell, options.column, $cellContent);
                        var showColumnLines = that.option("showColumnLines");
                        var contentAlignment = that.getController("columns").getHeaderContentAlignment(options.column.alignment);
                        return $cellContent[showColumnLines || "right" === contentAlignment ? "appendTo" : "prependTo"]($cell)
                    };

                    function addCssClassesToCellContent(that, $cell, column, $cellContent) {
                        var $indicatorElements = that._getIndicatorElements($cell, true);
                        var $visibleIndicatorElements = that._getIndicatorElements($cell);
                        var indicatorCount = $indicatorElements && $indicatorElements.length;
                        var columnAlignment = that._getColumnAlignment(column.alignment);
                        var sortIndicatorClassName = ".".concat(that._getIndicatorClassName("sort"));
                        var sortIndexIndicatorClassName = ".".concat(that._getIndicatorClassName("sortIndex"));
                        var $sortIndicator = $visibleIndicatorElements.filter(sortIndicatorClassName);
                        var $sortIndexIndicator = $visibleIndicatorElements.children().filter(sortIndexIndicatorClassName);
                        $cellContent = $cellContent || $cell.children("." + that.addWidgetPrefix(CELL_CONTENT_CLASS));
                        $cellContent.toggleClass(TEXT_CONTENT_ALIGNMENT_CLASS_PREFIX + columnAlignment, indicatorCount > 0).toggleClass(TEXT_CONTENT_ALIGNMENT_CLASS_PREFIX + ("left" === columnAlignment ? "right" : "left"), indicatorCount > 0 && "center" === column.alignment).toggleClass(SORT_INDICATOR_CLASS, !!$sortIndicator.length).toggleClass(SORT_INDEX_INDICATOR_CLASS, !!$sortIndexIndicator.length).toggleClass(HEADER_FILTER_INDICATOR_CLASS, !!$visibleIndicatorElements.filter("." + that._getIndicatorClassName("headerFilter")).length)
                    }
                    return {
                        _createTable: function() {
                            var $table = this.callBase.apply(this, arguments);
                            _events_engine.default.on($table, "mousedown selectstart", this.createAction(function(e) {
                                var event = e.event;
                                if (event.shiftKey) {
                                    event.preventDefault()
                                }
                            }));
                            return $table
                        },
                        _isLegacyKeyboardNavigation: function() {
                            return this.option("useLegacyKeyboardNavigation")
                        },
                        _getDefaultTemplate: function(column) {
                            var that = this;
                            return function($container, options) {
                                var $content = column.command ? $container : createCellContent(that, $container, options);
                                var caption = "expand" !== column.command && column.caption;
                                if (caption) {
                                    $content.text(caption)
                                } else {
                                    if (column.command) {
                                        $container.html("&nbsp;")
                                    }
                                }
                            }
                        },
                        _getHeaderTemplate: function(column) {
                            return column.headerCellTemplate || {
                                allowRenderToDetachedContainer: true,
                                render: this._getDefaultTemplate(column)
                            }
                        },
                        _processTemplate: function(template, options) {
                            var that = this;
                            var resultTemplate;
                            var column = options.column;
                            var renderingTemplate = that.callBase(template);
                            if ("header" === options.rowType && renderingTemplate && column.headerCellTemplate && !column.command) {
                                resultTemplate = {
                                    render: function(options) {
                                        var $content = createCellContent(that, options.container, options.model);
                                        renderingTemplate.render((0, _extend.extend)({}, options, {
                                            container: $content
                                        }))
                                    }
                                }
                            } else {
                                resultTemplate = renderingTemplate
                            }
                            return resultTemplate
                        },
                        _handleDataChanged: function(e) {
                            if ("refresh" !== e.changeType) {
                                return
                            }
                            if (this._isGroupingChanged || this._requireReady) {
                                this._isGroupingChanged = false;
                                this.render()
                            }
                        },
                        _renderCell: function($row, options) {
                            var $cell = this.callBase($row, options);
                            if ("header" === options.row.rowType) {
                                $cell.addClass(CELL_FOCUS_DISABLED_CLASS);
                                if (!this._isLegacyKeyboardNavigation()) {
                                    if (options.column && !options.column.type) {
                                        $cell.attr("tabindex", this.option("tabindex") || 0)
                                    }
                                }
                            }
                            return $cell
                        },
                        _setCellAriaAttributes: function($cell, cellOptions) {
                            this.callBase($cell, cellOptions);
                            if ("header" === cellOptions.rowType) {
                                this.setAria("role", "columnheader", $cell);
                                if (cellOptions.column && !cellOptions.column.command && !cellOptions.column.isBand) {
                                    $cell.attr("id", cellOptions.column.headerId);
                                    this.setAria("label", _message.default.format("dxDataGrid-ariaColumn") + " " + cellOptions.column.caption, $cell)
                                }
                            }
                        },
                        _createRow: function(row) {
                            var $row = this.callBase(row).toggleClass(COLUMN_LINES_CLASS, this.option("showColumnLines"));
                            if ("header" === row.rowType) {
                                $row.addClass(HEADER_ROW_CLASS);
                                if (!this._isLegacyKeyboardNavigation()) {
                                    (0, _uiGrid_core2.registerKeyboardAction)("columnHeaders", this, $row, "td", this._handleActionKeyDown.bind(this))
                                }
                            }
                            return $row
                        },
                        _handleActionKeyDown: function(args) {
                            var event = args.event;
                            var $target = (0, _renderer.default)(event.target);
                            this._lastActionElement = event.target;
                            if ($target.is(HEADER_FILTER_CLASS_SELECTOR)) {
                                var headerFilterController = this.getController("headerFilter");
                                var $column = $target.closest("td");
                                var columnIndex = this.getColumnIndexByElement($column);
                                if (columnIndex >= 0) {
                                    headerFilterController.showHeaderFilterMenu(columnIndex, false)
                                }
                            } else {
                                var $row = $target.closest(ROW_CLASS_SELECTOR);
                                this._processHeaderAction(event, $row)
                            }
                            event.preventDefault()
                        },
                        _renderCore: function() {
                            var that = this;
                            var $container = that.element();
                            if (that._tableElement && !that._dataController.isLoaded() && !that._hasRowElements) {
                                return
                            }
                            $container.addClass(that.addWidgetPrefix(HEADERS_CLASS)).toggleClass(that.addWidgetPrefix(NOWRAP_CLASS), !that.option("wordWrapEnabled")).empty();
                            that.setAria("role", "presentation", $container);
                            that._updateContent(that._renderTable());
                            if (that.getRowCount() > 1) {
                                $container.addClass(MULTI_ROW_HEADER_CLASS)
                            }
                            that.callBase.apply(that, arguments)
                        },
                        _renderRows: function() {
                            var that = this;
                            if (that._dataController.isLoaded() || that._hasRowElements) {
                                that.callBase.apply(that, arguments);
                                that._hasRowElements = true
                            }
                        },
                        _getRowVisibleColumns: function(rowIndex) {
                            return this._columnsController.getVisibleColumns(rowIndex)
                        },
                        _renderRow: function($table, options) {
                            options.columns = this._getRowVisibleColumns(options.row.rowIndex);
                            this.callBase($table, options)
                        },
                        _createCell: function(options) {
                            var column = options.column;
                            var $cellElement = this.callBase.apply(this, arguments);
                            column.rowspan > 1 && "header" === options.rowType && $cellElement.attr("rowSpan", column.rowspan);
                            return $cellElement
                        },
                        _getRows: function() {
                            var result = [];
                            var rowCount = this.getRowCount();
                            if (this.option("showColumnHeaders")) {
                                for (var i = 0; i < rowCount; i++) {
                                    result.push({
                                        rowType: "header",
                                        rowIndex: i
                                    })
                                }
                            }
                            return result
                        },
                        _getCellTemplate: function(options) {
                            if ("header" === options.rowType) {
                                return this._getHeaderTemplate(options.column)
                            }
                        },
                        _columnOptionChanged: function(e) {
                            var changeTypes = e.changeTypes;
                            var optionNames = e.optionNames;
                            if (changeTypes.grouping) {
                                this._isGroupingChanged = true;
                                return
                            }
                            this.callBase(e);
                            if (optionNames.width || optionNames.visible) {
                                this.resizeCompleted.fire()
                            }
                        },
                        _isElementVisible: function(elementOptions) {
                            return elementOptions && elementOptions.visible
                        },
                        _alignCaptionByCenter: function($cell) {
                            var $indicatorsContainer = this._getIndicatorContainer($cell, true);
                            if ($indicatorsContainer && $indicatorsContainer.length) {
                                $indicatorsContainer.filter("." + VISIBILITY_HIDDEN_CLASS).remove();
                                $indicatorsContainer = this._getIndicatorContainer($cell);
                                $indicatorsContainer.clone().addClass(VISIBILITY_HIDDEN_CLASS).css("float", "").insertBefore($cell.children("." + this.addWidgetPrefix(CELL_CONTENT_CLASS)))
                            }
                        },
                        _updateCell: function($cell, options) {
                            if ("header" === options.rowType && "center" === options.column.alignment) {
                                this._alignCaptionByCenter($cell)
                            }
                            this.callBase.apply(this, arguments)
                        },
                        _updateIndicator: function($cell, column, indicatorName) {
                            var $indicatorElement = this.callBase.apply(this, arguments);
                            if ("center" === column.alignment) {
                                this._alignCaptionByCenter($cell)
                            }
                            addCssClassesToCellContent(this, $cell, column);
                            return $indicatorElement
                        },
                        _getIndicatorContainer: function($cell, returnAll) {
                            var $indicatorsContainer = this.callBase($cell);
                            return returnAll ? $indicatorsContainer : $indicatorsContainer.filter(":not(." + VISIBILITY_HIDDEN_CLASS + ")")
                        },
                        _isSortableElement: function() {
                            return true
                        },
                        getHeadersRowHeight: function() {
                            var $tableElement = this.getTableElement();
                            var $headerRows = $tableElement && $tableElement.find("." + HEADER_ROW_CLASS);
                            return $headerRows && $headerRows.toArray().reduce(function(sum, headerRow) {
                                return sum + (0, _renderer.default)(headerRow).height()
                            }, 0) || 0
                        },
                        getHeaderElement: function(index) {
                            var columnElements = this.getColumnElements();
                            return columnElements && columnElements.eq(index)
                        },
                        getColumnElements: function(index, bandColumnIndex) {
                            var that = this;
                            var $cellElement;
                            var columnsController = that._columnsController;
                            var rowCount = that.getRowCount();
                            if (that.option("showColumnHeaders")) {
                                if (rowCount > 1 && (!(0, _type.isDefined)(index) || (0, _type.isDefined)(bandColumnIndex))) {
                                    var result = [];
                                    var visibleColumns = (0, _type.isDefined)(bandColumnIndex) ? columnsController.getChildrenByBandColumn(bandColumnIndex, true) : columnsController.getVisibleColumns();
                                    (0, _iterator.each)(visibleColumns, function(_, column) {
                                        var rowIndex = (0, _type.isDefined)(index) ? index : columnsController.getRowIndex(column.index);
                                        $cellElement = that._getCellElement(rowIndex, columnsController.getVisibleIndex(column.index, rowIndex));
                                        $cellElement && result.push($cellElement.get(0))
                                    });
                                    return (0, _renderer.default)(result)
                                } else {
                                    if (!index || index < rowCount) {
                                        return that.getCellElements(index || 0)
                                    }
                                }
                            }
                        },
                        getColumnIndexByElement: function($cell) {
                            var cellIndex = this.getCellIndex($cell);
                            var $row = $cell.closest(".dx-row");
                            var rowIndex = $row[0].rowIndex;
                            var column = this.getColumns(rowIndex)[cellIndex];
                            return column ? column.index : -1
                        },
                        getVisibleColumnIndex: function(columnIndex, rowIndex) {
                            var column = this.getColumns()[columnIndex];
                            return column ? this._columnsController.getVisibleIndex(column.index, rowIndex) : -1
                        },
                        getColumnWidths: function() {
                            var $columnElements = this.getColumnElements();
                            if ($columnElements && $columnElements.length) {
                                return this._getWidths($columnElements)
                            }
                            return this.callBase.apply(this, arguments)
                        },
                        allowDragging: function(column, sourceLocation, draggingPanels) {
                            var i;
                            var draggableColumnCount = 0;
                            var rowIndex = column && this._columnsController.getRowIndex(column.index);
                            var columns = this.getColumns(0 === rowIndex ? 0 : null);
                            var canHideColumn = (null === column || void 0 === column ? void 0 : column.allowHiding) && columns.length > 1;
                            var allowDrag = function(column) {
                                return column.allowReordering || column.allowGrouping || column.allowHiding
                            };
                            for (i = 0; i < columns.length; i++) {
                                if (allowDrag(columns[i])) {
                                    draggableColumnCount++
                                }
                            }
                            if (draggableColumnCount <= 1 && !canHideColumn) {
                                return false
                            } else {
                                if (!draggingPanels) {
                                    return (this.option("allowColumnReordering") || this._columnsController.isColumnOptionUsed("allowReordering")) && column && column.allowReordering
                                }
                            }
                            for (i = 0; i < draggingPanels.length; i++) {
                                var draggingPanel = draggingPanels[i];
                                if (draggingPanel && draggingPanel.allowDragging(column, sourceLocation)) {
                                    return true
                                }
                            }
                            return false
                        },
                        getBoundingRect: function() {
                            var that = this;
                            var $columnElements = that.getColumnElements();
                            if ($columnElements && $columnElements.length) {
                                var offset = that.getTableElement().offset();
                                return {
                                    top: offset.top
                                }
                            }
                            return null
                        },
                        getName: function() {
                            return "headers"
                        },
                        getColumnCount: function() {
                            var $columnElements = this.getColumnElements();
                            return $columnElements ? $columnElements.length : 0
                        },
                        isVisible: function() {
                            return this.option("showColumnHeaders")
                        },
                        optionChanged: function(args) {
                            var that = this;
                            switch (args.name) {
                                case "showColumnHeaders":
                                case "wordWrapEnabled":
                                case "showColumnLines":
                                    that._invalidate(true, true);
                                    args.handled = true;
                                    break;
                                default:
                                    that.callBase(args)
                            }
                        },
                        getHeight: function() {
                            return this.getElementHeight()
                        },
                        getContextMenuItems: function(options) {
                            var that = this;
                            var column = options.column;
                            if (options.row && ("header" === options.row.rowType || "detailAdaptive" === options.row.rowType)) {
                                var sortingOptions = that.option("sorting");
                                if (sortingOptions && "none" !== sortingOptions.mode && column && column.allowSorting) {
                                    var onItemClick = function(params) {
                                        setTimeout(function() {
                                            that._columnsController.changeSortOrder(column.index, params.itemData.value)
                                        })
                                    };
                                    return [{
                                        text: sortingOptions.ascendingText,
                                        value: "asc",
                                        disabled: "asc" === column.sortOrder,
                                        icon: CONTEXT_MENU_SORT_ASC_ICON,
                                        onItemClick: onItemClick
                                    }, {
                                        text: sortingOptions.descendingText,
                                        value: "desc",
                                        disabled: "desc" === column.sortOrder,
                                        icon: CONTEXT_MENU_SORT_DESC_ICON,
                                        onItemClick: onItemClick
                                    }, {
                                        text: sortingOptions.clearText,
                                        value: "none",
                                        disabled: !column.sortOrder,
                                        icon: CONTEXT_MENU_SORT_NONE_ICON,
                                        onItemClick: onItemClick
                                    }]
                                }
                            }
                        },
                        getRowCount: function() {
                            return this._columnsController && this._columnsController.getRowCount()
                        },
                        setRowsOpacity: function(columnIndex, value, rowIndex) {
                            var that = this;
                            var i;
                            var columnElements;
                            var rowCount = that.getRowCount();
                            var columns = that._columnsController.getColumns();
                            var column = columns && columns[columnIndex];
                            var columnID = column && column.isBand && column.index;
                            var setColumnOpacity = function(index, column) {
                                if (column.ownerBand === columnID) {
                                    columnElements.eq(index).css({
                                        opacity: value
                                    });
                                    if (column.isBand) {
                                        that.setRowsOpacity(column.index, value, i + 1)
                                    }
                                }
                            };
                            if ((0, _type.isDefined)(columnID)) {
                                rowIndex = rowIndex || 0;
                                for (i = rowIndex; i < rowCount; i++) {
                                    columnElements = that.getCellElements(i);
                                    (0, _iterator.each)(that.getColumns(i), setColumnOpacity)
                                }
                            }
                        }
                    }
                }())
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.column_state_mixin.js ***!
      \**********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _position = __webpack_require__( /*! ../../core/utils/position */ 22);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var COLUMN_INDICATORS_CLASS = "dx-column-indicators";
        var GROUP_PANEL_ITEM_CLASS = "dx-group-panel-item";
        var _default = {
            _applyColumnState: function(options) {
                var _that$component;
                var that = this;
                var rtlEnabled = this.option("rtlEnabled");
                var columnAlignment = that._getColumnAlignment(options.column.alignment, rtlEnabled);
                var parameters = (0, _extend.extend)(true, {
                    columnAlignment: columnAlignment
                }, options);
                var isGroupPanelItem = parameters.rootElement.hasClass(GROUP_PANEL_ITEM_CLASS);
                var $indicatorsContainer = that._createIndicatorContainer(parameters, isGroupPanelItem);
                var $span = (0, _renderer.default)("<span>").addClass(that._getIndicatorClassName(options.name));
                var columnsController = null === (_that$component = that.component) || void 0 === _that$component ? void 0 : _that$component.getController("columns");
                var indicatorAlignment = (null === columnsController || void 0 === columnsController ? void 0 : columnsController.getHeaderContentAlignment(columnAlignment)) || columnAlignment;
                parameters.container = $indicatorsContainer;
                parameters.indicator = $span;
                that._renderIndicator(parameters);
                $indicatorsContainer[(isGroupPanelItem || !options.showColumnLines) && "left" === indicatorAlignment ? "appendTo" : "prependTo"](options.rootElement);
                return $span
            },
            _getIndicatorClassName: _common.noop,
            _getColumnAlignment: function(alignment, rtlEnabled) {
                rtlEnabled = rtlEnabled || this.option("rtlEnabled");
                return alignment && "center" !== alignment ? alignment : (0, _position.getDefaultAlignment)(rtlEnabled)
            },
            _createIndicatorContainer: function(options, ignoreIndicatorAlignment) {
                var $indicatorsContainer = this._getIndicatorContainer(options.rootElement);
                var indicatorAlignment = "left" === options.columnAlignment ? "right" : "left";
                if (!$indicatorsContainer.length) {
                    $indicatorsContainer = (0, _renderer.default)("<div>").addClass(COLUMN_INDICATORS_CLASS)
                }
                this.setAria("role", "presentation", $indicatorsContainer);
                return $indicatorsContainer.css("float", options.showColumnLines && !ignoreIndicatorAlignment ? indicatorAlignment : null)
            },
            _getIndicatorContainer: function($cell) {
                return $cell && $cell.find("." + COLUMN_INDICATORS_CLASS)
            },
            _getIndicatorElements: function($cell) {
                var $indicatorContainer = this._getIndicatorContainer($cell);
                return $indicatorContainer && $indicatorContainer.children()
            },
            _renderIndicator: function(options) {
                var $container = options.container;
                var $indicator = options.indicator;
                $container && $indicator && $container.append($indicator)
            },
            _updateIndicators: function(indicatorName) {
                var that = this;
                var columns = that.getColumns();
                var $cells = that.getColumnElements();
                var $cell;
                if (!$cells || columns.length !== $cells.length) {
                    return
                }
                for (var i = 0; i < columns.length; i++) {
                    $cell = $cells.eq(i);
                    that._updateIndicator($cell, columns[i], indicatorName);
                    var rowOptions = $cell.parent().data("options");
                    if (rowOptions && rowOptions.cells) {
                        rowOptions.cells[$cell.index()].column = columns[i]
                    }
                }
            },
            _updateIndicator: function($cell, column, indicatorName) {
                if (!column.command) {
                    return this._applyColumnState({
                        name: indicatorName,
                        rootElement: $cell,
                        column: column,
                        showColumnLines: this.option("showColumnLines")
                    })
                }
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.columns_controller.js ***!
      \**********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/callbacks */ 27));
        var _variable_wrapper = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/variable_wrapper */ 102));
        var _data = __webpack_require__( /*! ../../core/utils/data */ 20);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _position = __webpack_require__( /*! ../../core/utils/position */ 22);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _config = _interopRequireDefault(__webpack_require__( /*! ../../core/config */ 31));
        var _object = __webpack_require__( /*! ../../core/utils/object */ 51);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.modules */ 44));
        var _uiGrid_core2 = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.utils */ 35));
        var _inflector = __webpack_require__( /*! ../../core/utils/inflector */ 39);
        var _date_serialization = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date_serialization */ 57));
        var _number = _interopRequireDefault(__webpack_require__( /*! ../../localization/number */ 47));
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../localization/date */ 32));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _abstract_store = _interopRequireDefault(__webpack_require__( /*! ../../data/abstract_store */ 105));
        var _data_source = __webpack_require__( /*! ../../data/data_source/data_source */ 68);
        var _utils = __webpack_require__( /*! ../../data/data_source/utils */ 69);
        var _filtering = _interopRequireDefault(__webpack_require__( /*! ../shared/filtering */ 182));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }
        var USER_STATE_FIELD_NAMES_15_1 = ["filterValues", "filterType", "fixed", "fixedPosition"];
        var USER_STATE_FIELD_NAMES = ["visibleIndex", "dataField", "name", "dataType", "width", "visible", "sortOrder", "lastSortOrder", "sortIndex", "groupIndex", "filterValue", "selectedFilterOperation", "added"].concat(USER_STATE_FIELD_NAMES_15_1);
        var IGNORE_COLUMN_OPTION_NAMES = {
            visibleWidth: true,
            bestFitWidth: true,
            bufferedFilterValue: true
        };
        var COMMAND_EXPAND_CLASS = "dx-command-expand";
        var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
        var GROUP_COMMAND_COLUMN_NAME = "groupExpand";
        var regExp = /columns\[(\d+)\]\.?/gi;
        var globalColumnId = 1;
        var _default = {
            defaultOptions: function() {
                return {
                    commonColumnSettings: {
                        allowFiltering: true,
                        allowHiding: true,
                        allowSorting: true,
                        allowEditing: true,
                        encodeHtml: true,
                        trueText: _message.default.format("dxDataGrid-trueText"),
                        falseText: _message.default.format("dxDataGrid-falseText")
                    },
                    allowColumnReordering: false,
                    allowColumnResizing: false,
                    columnResizingMode: "nextColumn",
                    columnMinWidth: void 0,
                    columnWidth: void 0,
                    adaptColumnWidthByRatio: true,
                    columns: void 0,
                    regenerateColumnsByVisibleItems: false,
                    customizeColumns: null,
                    dateSerializationFormat: void 0
                }
            },
            controllers: {
                columns: _uiGrid_core.default.Controller.inherit(function() {
                    var DEFAULT_COLUMN_OPTIONS = {
                        visible: true,
                        showInColumnChooser: true
                    };
                    var DATATYPE_OPERATIONS = {
                        number: ["=", "<>", "<", ">", "<=", ">=", "between"],
                        string: ["contains", "notcontains", "startswith", "endswith", "=", "<>"],
                        date: ["=", "<>", "<", ">", "<=", ">=", "between"],
                        datetime: ["=", "<>", "<", ">", "<=", ">=", "between"]
                    };
                    var COLUMN_INDEX_OPTIONS = {
                        visibleIndex: true,
                        groupIndex: true,
                        grouped: true,
                        sortIndex: true,
                        sortOrder: true
                    };
                    var GROUP_LOCATION = "group";
                    var COLUMN_CHOOSER_LOCATION = "columnChooser";
                    var setFilterOperationsAsDefaultValues = function(column) {
                        column.filterOperations = column.defaultFilterOperations
                    };
                    var createColumn = function(that, columnOptions, userStateColumnOptions, bandColumn) {
                        var commonColumnOptions = {};
                        if (columnOptions) {
                            if ((0, _type.isString)(columnOptions)) {
                                columnOptions = {
                                    dataField: columnOptions
                                }
                            }
                            that.setName(columnOptions);
                            var result = {};
                            if (columnOptions.command) {
                                result = (0, _object.deepExtendArraySafe)(commonColumnOptions, columnOptions)
                            } else {
                                commonColumnOptions = that.getCommonSettings(columnOptions);
                                if (userStateColumnOptions && userStateColumnOptions.name && userStateColumnOptions.dataField) {
                                    columnOptions = (0, _extend.extend)({}, columnOptions, {
                                        dataField: userStateColumnOptions.dataField
                                    })
                                }
                                var calculatedColumnOptions = that._createCalculatedColumnOptions(columnOptions, bandColumn);
                                if (!columnOptions.type) {
                                    result = {
                                        headerId: "dx-col-".concat(globalColumnId++)
                                    }
                                }
                                result = (0, _object.deepExtendArraySafe)(result, DEFAULT_COLUMN_OPTIONS);
                                (0, _object.deepExtendArraySafe)(result, commonColumnOptions);
                                (0, _object.deepExtendArraySafe)(result, calculatedColumnOptions);
                                (0, _object.deepExtendArraySafe)(result, columnOptions);
                                (0, _object.deepExtendArraySafe)(result, {
                                    selector: null
                                })
                            }
                            if (columnOptions.filterOperations === columnOptions.defaultFilterOperations) {
                                setFilterOperationsAsDefaultValues(result)
                            }
                            return result
                        }
                    };
                    var createColumnsFromOptions = function createColumnsFromOptions(that, columnsOptions, bandColumn) {
                        var result = [];
                        if (columnsOptions) {
                            (0, _iterator.each)(columnsOptions, function(index, columnOptions) {
                                var userStateColumnOptions = that._columnsUserState && checkUserStateColumn(columnOptions, that._columnsUserState[index]) && that._columnsUserState[index];
                                var column = createColumn(that, columnOptions, userStateColumnOptions, bandColumn);
                                if (column) {
                                    if (bandColumn) {
                                        column.ownerBand = bandColumn
                                    }
                                    result.push(column);
                                    if (column.columns) {
                                        result = result.concat(createColumnsFromOptions(that, column.columns, column));
                                        delete column.columns;
                                        column.hasColumns = true
                                    }
                                }
                            })
                        }
                        return result
                    };
                    var getParentBandColumns = function(columnIndex, columnParentByIndex) {
                        var result = [];
                        var parent = columnParentByIndex[columnIndex];
                        while (parent) {
                            result.unshift(parent);
                            columnIndex = parent.index;
                            parent = columnParentByIndex[columnIndex]
                        }
                        return result
                    };
                    var _getChildrenByBandColumn = function(columnIndex, columnChildrenByIndex, recursive) {
                        var result = [];
                        var children = columnChildrenByIndex[columnIndex];
                        if (children) {
                            for (var i = 0; i < children.length; i++) {
                                var column = children[i];
                                if (!(0, _type.isDefined)(column.groupIndex) || column.showWhenGrouped) {
                                    result.push(column);
                                    if (recursive && column.isBand) {
                                        result = result.concat(_getChildrenByBandColumn(column.index, columnChildrenByIndex, recursive))
                                    }
                                }
                            }
                        }
                        return result
                    };
                    var getColumnByIndexes = function(that, columnIndexes) {
                        var result;
                        var columns;
                        var bandColumnsCache = that.getBandColumnsCache();
                        var callbackFilter = function(column) {
                            var ownerBand = result ? result.index : void 0;
                            return column.ownerBand === ownerBand
                        };
                        if (bandColumnsCache.isPlain) {
                            result = that._columns[columnIndexes[0]]
                        } else {
                            columns = that._columns.filter(callbackFilter);
                            for (var i = 0; i < columnIndexes.length; i++) {
                                result = columns[columnIndexes[i]];
                                if (result) {
                                    columns = that._columns.filter(callbackFilter)
                                }
                            }
                        }
                        return result
                    };
                    var getColumnFullPath = function(that, column) {
                        var result = [];
                        var columns;
                        var bandColumnsCache = that.getBandColumnsCache();
                        var callbackFilter = function(item) {
                            return item.ownerBand === column.ownerBand
                        };
                        if (bandColumnsCache.isPlain) {
                            var columnIndex = that._columns.indexOf(column);
                            if (columnIndex >= 0) {
                                result = ["columns[".concat(columnIndex, "]")]
                            }
                        } else {
                            columns = that._columns.filter(callbackFilter);
                            while (columns.length && columns.indexOf(column) !== -1) {
                                result.unshift("columns[".concat(columns.indexOf(column), "]"));
                                column = bandColumnsCache.columnParentByIndex[column.index];
                                columns = column ? that._columns.filter(callbackFilter) : []
                            }
                        }
                        return result.join(".")
                    };
                    var calculateColspan = function calculateColspan(that, columnID) {
                        var colspan = 0;
                        var columns = that.getChildrenByBandColumn(columnID, true);
                        (0, _iterator.each)(columns, function(_, column) {
                            if (column.isBand) {
                                column.colspan = column.colspan || calculateColspan(that, column.index);
                                colspan += column.colspan || 1
                            } else {
                                colspan += 1
                            }
                        });
                        return colspan
                    };
                    var processBandColumns = function(that, columns, bandColumnsCache) {
                        var rowspan;
                        for (var i = 0; i < columns.length; i++) {
                            var column = columns[i];
                            if (column.visible || column.command) {
                                if (column.isBand) {
                                    column.colspan = column.colspan || calculateColspan(that, column.index)
                                }
                                if (!column.isBand || !column.colspan) {
                                    rowspan = that.getRowCount();
                                    if (!column.command && (!(0, _type.isDefined)(column.groupIndex) || column.showWhenGrouped)) {
                                        rowspan -= getParentBandColumns(column.index, bandColumnsCache.columnParentByIndex).length
                                    }
                                    if (rowspan > 1) {
                                        column.rowspan = rowspan
                                    }
                                }
                            }
                        }
                    };
                    var getValueDataType = function(value) {
                        var dataType = (0, _type.type)(value);
                        if ("string" !== dataType && "boolean" !== dataType && "number" !== dataType && "date" !== dataType && "object" !== dataType) {
                            dataType = void 0
                        }
                        return dataType
                    };
                    var getSerializationFormat = function(dataType, value) {
                        switch (dataType) {
                            case "date":
                            case "datetime":
                                return _date_serialization.default.getDateSerializationFormat(value);
                            case "number":
                                if ((0, _type.isString)(value)) {
                                    return "string"
                                }
                                if ((0, _type.isNumeric)(value)) {
                                    return null
                                }
                        }
                    };
                    var updateSerializers = function(options, dataType) {
                        if (!options.deserializeValue) {
                            if (_uiGrid_core2.default.isDateType(dataType)) {
                                options.deserializeValue = function(value) {
                                    return _date_serialization.default.deserializeDate(value)
                                };
                                options.serializeValue = function(value) {
                                    return (0, _type.isString)(value) ? value : _date_serialization.default.serializeDate(value, this.serializationFormat)
                                }
                            }
                            if ("number" === dataType) {
                                options.deserializeValue = function(value) {
                                    var parsedValue = parseFloat(value);
                                    return isNaN(parsedValue) ? value : parsedValue
                                };
                                options.serializeValue = function(value, target) {
                                    if ("filter" === target) {
                                        return value
                                    }
                                    return (0, _type.isDefined)(value) && "string" === this.serializationFormat ? value.toString() : value
                                }
                            }
                        }
                    };
                    var getAlignmentByDataType = function(dataType, isRTL) {
                        switch (dataType) {
                            case "number":
                                return "right";
                            case "boolean":
                                return "center";
                            default:
                                return (0, _position.getDefaultAlignment)(isRTL)
                        }
                    };
                    var customizeTextForBooleanDataType = function(e) {
                        if (true === e.value) {
                            return this.trueText || "true"
                        } else {
                            if (false === e.value) {
                                return this.falseText || "false"
                            } else {
                                return e.valueText || ""
                            }
                        }
                    };
                    var getCustomizeTextByDataType = function(dataType) {
                        if ("boolean" === dataType) {
                            return customizeTextForBooleanDataType
                        }
                    };
                    var createColumnsFromDataSource = function(that, dataSource) {
                        var firstItems = that._getFirstItems(dataSource);
                        var fieldName;
                        var processedFields = {};
                        var result = [];
                        for (var i = 0; i < firstItems.length; i++) {
                            if (firstItems[i]) {
                                for (fieldName in firstItems[i]) {
                                    if (!(0, _type.isFunction)(firstItems[i][fieldName]) || _variable_wrapper.default.isWrapped(firstItems[i][fieldName])) {
                                        processedFields[fieldName] = true
                                    }
                                }
                            }
                        }
                        for (fieldName in processedFields) {
                            if (0 !== fieldName.indexOf("__")) {
                                var column = createColumn(that, fieldName);
                                result.push(column)
                            }
                        }
                        return result
                    };
                    var updateColumnIndexes = function(that) {
                        (0, _iterator.each)(that._columns, function(index, column) {
                            column.index = index
                        });
                        (0, _iterator.each)(that._columns, function(index, column) {
                            if ((0, _type.isObject)(column.ownerBand)) {
                                column.ownerBand = column.ownerBand.index
                            }
                        });
                        (0, _iterator.each)(that._commandColumns, function(index, column) {
                            column.index = -(index + 1)
                        })
                    };
                    var updateColumnGroupIndexes = function(that, currentColumn) {
                        (0, _array.normalizeIndexes)(that._columns, "groupIndex", currentColumn, function(column) {
                            var grouped = column.grouped;
                            delete column.grouped;
                            return grouped
                        })
                    };
                    var updateColumnSortIndexes = function(that, currentColumn) {
                        (0, _iterator.each)(that._columns, function(index, column) {
                            if ((0, _type.isDefined)(column.sortIndex) && !isSortOrderValid(column.sortOrder)) {
                                delete column.sortIndex
                            }
                        });
                        (0, _array.normalizeIndexes)(that._columns, "sortIndex", currentColumn, function(column) {
                            return !(0, _type.isDefined)(column.groupIndex) && isSortOrderValid(column.sortOrder)
                        })
                    };
                    var updateColumnVisibleIndexes = function(that, currentColumn) {
                        var key;
                        var column;
                        var bandColumns = {};
                        var result = [];
                        var bandColumnsCache = that.getBandColumnsCache();
                        var columns = that._columns.filter(function(column) {
                            return !column.command
                        });
                        for (var i = 0; i < columns.length; i++) {
                            column = columns[i];
                            var parentBandColumns = getParentBandColumns(i, bandColumnsCache.columnParentByIndex);
                            if (parentBandColumns.length) {
                                var bandColumnIndex = parentBandColumns[parentBandColumns.length - 1].index;
                                bandColumns[bandColumnIndex] = bandColumns[bandColumnIndex] || [];
                                bandColumns[bandColumnIndex].push(column)
                            } else {
                                result.push(column)
                            }
                        }
                        for (key in bandColumns) {
                            (0, _array.normalizeIndexes)(bandColumns[key], "visibleIndex", currentColumn)
                        }(0, _array.normalizeIndexes)(result, "visibleIndex", currentColumn)
                    };
                    var getColumnIndexByVisibleIndex = function(that, visibleIndex, location) {
                        var rowIndex = (0, _type.isObject)(visibleIndex) ? visibleIndex.rowIndex : null;
                        var columns = location === GROUP_LOCATION ? that.getGroupColumns() : location === COLUMN_CHOOSER_LOCATION ? that.getChooserColumns() : that.getVisibleColumns(rowIndex);
                        var column;
                        visibleIndex = (0, _type.isObject)(visibleIndex) ? visibleIndex.columnIndex : visibleIndex;
                        column = columns[visibleIndex];
                        if (column && column.type === GROUP_COMMAND_COLUMN_NAME) {
                            column = that._columns.filter(function(col) {
                                return column.type === col.type
                            })[0] || column
                        }
                        return column && (0, _type.isDefined)(column.index) ? column.index : -1
                    };
                    var moveColumnToGroup = function(that, column, groupIndex) {
                        var groupColumns = that.getGroupColumns();
                        var i;
                        if (groupIndex >= 0) {
                            for (i = 0; i < groupColumns.length; i++) {
                                if (groupColumns[i].groupIndex >= groupIndex) {
                                    groupColumns[i].groupIndex++
                                }
                            }
                        } else {
                            groupIndex = 0;
                            for (i = 0; i < groupColumns.length; i++) {
                                groupIndex = Math.max(groupIndex, groupColumns[i].groupIndex + 1)
                            }
                        }
                        return groupIndex
                    };

                    function checkUserStateColumn(column, userStateColumn) {
                        return column && userStateColumn && (userStateColumn.name === column.name || !column.name) && (userStateColumn.dataField === column.dataField || column.name)
                    }
                    var applyUserState = function(that) {
                        var columnsUserState = that._columnsUserState;
                        var ignoreColumnOptionNames = that._ignoreColumnOptionNames || [];
                        var columns = that._columns;
                        var columnCountById = {};
                        var resultColumns = [];
                        var allColumnsHaveState = true;
                        var userStateColumnIndexes = [];
                        var column;
                        var userStateColumnIndex;
                        var i;

                        function applyFieldsState(column, userStateColumn) {
                            if (!userStateColumn) {
                                return
                            }
                            for (var index = 0; index < USER_STATE_FIELD_NAMES.length; index++) {
                                var fieldName = USER_STATE_FIELD_NAMES[index];
                                if ((0, _array.inArray)(fieldName, ignoreColumnOptionNames) >= 0) {
                                    continue
                                }
                                if ("dataType" === fieldName) {
                                    column[fieldName] = column[fieldName] || userStateColumn[fieldName]
                                } else {
                                    if ((0, _array.inArray)(fieldName, USER_STATE_FIELD_NAMES_15_1) >= 0) {
                                        if (fieldName in userStateColumn) {
                                            column[fieldName] = userStateColumn[fieldName]
                                        }
                                    } else {
                                        if ("selectedFilterOperation" === fieldName && userStateColumn[fieldName]) {
                                            column.defaultSelectedFilterOperation = column[fieldName] || null
                                        }
                                        column[fieldName] = userStateColumn[fieldName]
                                    }
                                }
                            }
                        }

                        function findUserStateColumn(columnsUserState, column) {
                            var id = column.name || column.dataField;
                            var count = columnCountById[id] || 0;
                            for (var j = 0; j < columnsUserState.length; j++) {
                                if (checkUserStateColumn(column, columnsUserState[j])) {
                                    if (count) {
                                        count--
                                    } else {
                                        columnCountById[id] = columnCountById[id] || 0;
                                        columnCountById[id]++;
                                        return j
                                    }
                                }
                            }
                            return -1
                        }
                        if (columnsUserState) {
                            for (i = 0; i < columns.length; i++) {
                                userStateColumnIndex = findUserStateColumn(columnsUserState, columns[i]);
                                allColumnsHaveState = allColumnsHaveState && userStateColumnIndex >= 0;
                                userStateColumnIndexes.push(userStateColumnIndex)
                            }
                            for (i = 0; i < columns.length; i++) {
                                column = columns[i];
                                userStateColumnIndex = userStateColumnIndexes[i];
                                if (that._hasUserState || allColumnsHaveState) {
                                    applyFieldsState(column, columnsUserState[userStateColumnIndex])
                                }
                                if (userStateColumnIndex >= 0 && (0, _type.isDefined)(columnsUserState[userStateColumnIndex].initialIndex)) {
                                    resultColumns[userStateColumnIndex] = column
                                } else {
                                    resultColumns.push(column)
                                }
                            }
                            var hasAddedBands = false;
                            for (i = 0; i < columnsUserState.length; i++) {
                                var columnUserState = columnsUserState[i];
                                if (columnUserState.added && findUserStateColumn(columns, columnUserState) < 0) {
                                    column = createColumn(that, columnUserState.added);
                                    applyFieldsState(column, columnUserState);
                                    resultColumns.push(column);
                                    if (columnUserState.added.columns) {
                                        hasAddedBands = true
                                    }
                                }
                            }
                            if (hasAddedBands) {
                                updateColumnIndexes(that);
                                resultColumns = createColumnsFromOptions(that, resultColumns)
                            }
                            assignColumns(that, resultColumns)
                        }
                    };
                    var updateIndexes = function(that, column) {
                        updateColumnIndexes(that);
                        updateColumnGroupIndexes(that, column);
                        updateColumnSortIndexes(that, column);
                        resetBandColumnsCache(that);
                        updateColumnVisibleIndexes(that, column)
                    };
                    var resetColumnsCache = function(that) {
                        that.resetColumnsCache()
                    };

                    function assignColumns(that, columns) {
                        that._columns = columns;
                        resetColumnsCache(that);
                        that.updateColumnDataTypes()
                    }
                    var updateColumnChanges = function(that, changeType, optionName, columnIndex) {
                        var columnChanges = that._columnChanges || {
                            optionNames: {
                                length: 0
                            },
                            changeTypes: {
                                length: 0
                            },
                            columnIndex: columnIndex
                        };
                        optionName = optionName || "all";
                        optionName = optionName.split(".")[0];
                        var changeTypes = columnChanges.changeTypes;
                        if (changeType && !changeTypes[changeType]) {
                            changeTypes[changeType] = true;
                            changeTypes.length++
                        }
                        var optionNames = columnChanges.optionNames;
                        if (optionName && !optionNames[optionName]) {
                            optionNames[optionName] = true;
                            optionNames.length++
                        }
                        if (void 0 === columnIndex || columnIndex !== columnChanges.columnIndex) {
                            delete columnChanges.columnIndex
                        }
                        that._columnChanges = columnChanges;
                        resetColumnsCache(that)
                    };
                    var fireColumnsChanged = function(that) {
                        var onColumnsChanging = that.option("onColumnsChanging");
                        var columnChanges = that._columnChanges;
                        var reinitOptionNames = ["dataField", "lookup", "dataType", "columns"];
                        var needReinit = function(options) {
                            return options && reinitOptionNames.some(function(name) {
                                return options[name]
                            })
                        };
                        if (that.isInitialized() && !that._updateLockCount && columnChanges) {
                            if (onColumnsChanging) {
                                that._updateLockCount++;
                                onColumnsChanging((0, _extend.extend)({
                                    component: that.component
                                }, columnChanges));
                                that._updateLockCount--
                            }
                            that._columnChanges = void 0;
                            if (needReinit(columnChanges.optionNames)) {
                                that.reinit()
                            } else {
                                that.columnsChanged.fire(columnChanges)
                            }
                        }
                    };
                    var updateSortOrderWhenGrouping = function(that, column, groupIndex, prevGroupIndex) {
                        var columnWasGrouped = prevGroupIndex >= 0;
                        if (groupIndex >= 0) {
                            if (!columnWasGrouped) {
                                column.lastSortOrder = column.sortOrder
                            }
                        } else {
                            var sortMode = that.option("sorting.mode");
                            var sortOrder = column.lastSortOrder;
                            if ("single" === sortMode) {
                                var sortedByAnotherColumn = that._columns.some(function(col) {
                                    return col !== column && (0, _type.isDefined)(col.sortIndex)
                                });
                                if (sortedByAnotherColumn) {
                                    sortOrder = void 0
                                }
                            }
                            column.sortOrder = sortOrder
                        }
                    };
                    var fireOptionChanged = function(that, options) {
                        var value = options.value;
                        var optionName = options.optionName;
                        var prevValue = options.prevValue;
                        var fullOptionName = options.fullOptionName;
                        var fullOptionPath = "".concat(fullOptionName, ".").concat(optionName);
                        if (!IGNORE_COLUMN_OPTION_NAMES[optionName] && that._skipProcessingColumnsChange !== fullOptionPath) {
                            that._skipProcessingColumnsChange = fullOptionPath;
                            that.component._notifyOptionChanged(fullOptionPath, value, prevValue);
                            that._skipProcessingColumnsChange = false
                        }
                    };
                    var columnOptionCore = function(that, column, optionName, value, notFireEvent) {
                        var optionGetter = (0, _data.compileGetter)(optionName);
                        var columnIndex = column.index;
                        var columns;
                        var changeType;
                        var initialColumn;
                        if (3 === arguments.length) {
                            return optionGetter(column, {
                                functionsAsIs: true
                            })
                        }
                        var prevValue = optionGetter(column, {
                            functionsAsIs: true
                        });
                        if (prevValue !== value) {
                            if ("groupIndex" === optionName || "calculateGroupValue" === optionName) {
                                changeType = "grouping";
                                updateSortOrderWhenGrouping(that, column, value, prevValue)
                            } else {
                                if ("sortIndex" === optionName || "sortOrder" === optionName || "calculateSortValue" === optionName) {
                                    changeType = "sorting"
                                } else {
                                    changeType = "columns"
                                }
                            }
                            var optionSetter = (0, _data.compileSetter)(optionName);
                            optionSetter(column, value, {
                                functionsAsIs: true
                            });
                            var fullOptionName = getColumnFullPath(that, column);
                            if (COLUMN_INDEX_OPTIONS[optionName]) {
                                updateIndexes(that, column);
                                value = optionGetter(column)
                            }
                            if ("name" === optionName || "allowEditing" === optionName) {
                                that._checkColumns()
                            }
                            fullOptionName && fireOptionChanged(that, {
                                fullOptionName: fullOptionName,
                                optionName: optionName,
                                value: value,
                                prevValue: prevValue
                            });
                            if (!(0, _type.isDefined)(prevValue) && !(0, _type.isDefined)(value) && 0 !== optionName.indexOf("buffer")) {
                                notFireEvent = true
                            }
                            if (!notFireEvent) {
                                if ((0, _array.inArray)(optionName, USER_STATE_FIELD_NAMES) < 0 && "visibleWidth" !== optionName) {
                                    columns = that.option("columns");
                                    initialColumn = that.getColumnByPath(fullOptionName, columns);
                                    if ((0, _type.isString)(initialColumn)) {
                                        initialColumn = columns[columnIndex] = {
                                            dataField: initialColumn
                                        }
                                    }
                                    if (initialColumn && checkUserStateColumn(initialColumn, column)) {
                                        optionSetter(initialColumn, value, {
                                            functionsAsIs: true
                                        })
                                    }
                                }
                                updateColumnChanges(that, changeType, optionName, columnIndex)
                            } else {
                                resetColumnsCache(that)
                            }
                        }
                    };

                    function isSortOrderValid(sortOrder) {
                        return "asc" === sortOrder || "desc" === sortOrder
                    }
                    var addExpandColumn = function(that) {
                        var options = that._getExpandColumnOptions();
                        that.addCommandColumn(options)
                    };
                    var defaultSetCellValue = function(data, value) {
                        var path = this.dataField.split(".");
                        var dotCount = path.length - 1;
                        if (this.serializeValue) {
                            value = this.serializeValue(value)
                        }
                        for (var i = 0; i < dotCount; i++) {
                            var name = path[i];
                            data = data[name] = data[name] || {}
                        }
                        data[path[dotCount]] = value
                    };
                    var getDataColumns = function getDataColumns(columns, rowIndex, bandColumnID) {
                        var result = [];
                        rowIndex = rowIndex || 0;
                        columns[rowIndex] && (0, _iterator.each)(columns[rowIndex], function(_, column) {
                            if (column.ownerBand === bandColumnID || column.type === GROUP_COMMAND_COLUMN_NAME) {
                                if (!column.isBand || !column.colspan) {
                                    if (!column.command || rowIndex < 1) {
                                        result.push(column)
                                    }
                                } else {
                                    result.push.apply(result, getDataColumns(columns, rowIndex + 1, column.index))
                                }
                            }
                        });
                        return result
                    };
                    var _getRowCount = function(that) {
                        var rowCount = 1;
                        var bandColumnsCache = that.getBandColumnsCache();
                        var columnParentByIndex = bandColumnsCache.columnParentByIndex;
                        that._columns.forEach(function(column) {
                            var parents = getParentBandColumns(column.index, columnParentByIndex);
                            var invisibleParents = parents.filter(function(column) {
                                return !column.visible
                            });
                            if (column.visible && !invisibleParents.length) {
                                rowCount = Math.max(rowCount, parents.length + 1)
                            }
                        });
                        return rowCount
                    };
                    var isCustomCommandColumn = function(that, commandColumn) {
                        return !!that._columns.filter(function(column) {
                            return column.type === commandColumn.type
                        }).length
                    };
                    var getFixedPosition = function(that, column) {
                        var rtlEnabled = that.option("rtlEnabled");
                        if (column.command && !isCustomCommandColumn(that, column) || !column.fixedPosition) {
                            return rtlEnabled ? "right" : "left"
                        }
                        return column.fixedPosition
                    };
                    var processExpandColumns = function(columns, expandColumns, type, columnIndex) {
                        var customColumnIndex;
                        var rowCount = this.getRowCount();
                        var rowspan = columns[columnIndex] && columns[columnIndex].rowspan;
                        var expandColumnsByType = expandColumns.filter(function(column) {
                            return column.type === type
                        });
                        columns.forEach(function(column, index) {
                            if (column.type === type) {
                                customColumnIndex = index;
                                rowspan = columns[index + 1] ? columns[index + 1].rowspan : rowCount
                            }
                        });
                        if (rowspan > 1) {
                            expandColumnsByType = (0, _iterator.map)(expandColumnsByType, function(expandColumn) {
                                return (0, _extend.extend)({}, expandColumn, {
                                    rowspan: rowspan
                                })
                            })
                        }
                        expandColumnsByType.unshift.apply(expandColumnsByType, (0, _type.isDefined)(customColumnIndex) ? [customColumnIndex, 1] : [columnIndex, 0]);
                        columns.splice.apply(columns, expandColumnsByType);
                        return rowspan || 1
                    };
                    var digitsCount = function(number) {
                        var i;
                        for (i = 0; number > 1; i++) {
                            number /= 10
                        }
                        return i
                    };
                    var numberToString = function(number, digitsCount) {
                        var str = number ? number.toString() : "0";
                        while (str.length < digitsCount) {
                            str = "0" + str
                        }
                        return str
                    };
                    var mergeColumns = function(that, columns, commandColumns, needToExtend) {
                        var column;
                        var commandColumnIndex;
                        var result = columns.slice().map(function(column) {
                            return (0, _extend.extend)({}, column)
                        });
                        var isColumnFixing = that._isColumnFixing();
                        var defaultCommandColumns = commandColumns.slice().map(function(column) {
                            return (0, _extend.extend)({
                                fixed: isColumnFixing
                            }, column)
                        });
                        var getCommandColumnIndex = function(column) {
                            return commandColumns.reduce(function(result, commandColumn, index) {
                                var columnType = needToExtend && column.type === GROUP_COMMAND_COLUMN_NAME ? "expand" : column.type;
                                return commandColumn.type === columnType || commandColumn.command === column.command ? index : result
                            }, -1)
                        };
                        var callbackFilter = function(commandColumn) {
                            return commandColumn.command !== commandColumns[commandColumnIndex].command
                        };
                        for (var i = 0; i < columns.length; i++) {
                            column = columns[i];
                            commandColumnIndex = column && (column.type || column.command) ? getCommandColumnIndex(column) : -1;
                            if (commandColumnIndex >= 0) {
                                if (needToExtend) {
                                    result[i] = (0, _extend.extend)({
                                        fixed: isColumnFixing
                                    }, commandColumns[commandColumnIndex], column);
                                    if (column.type !== GROUP_COMMAND_COLUMN_NAME) {
                                        defaultCommandColumns = defaultCommandColumns.filter(callbackFilter)
                                    }
                                } else {
                                    var columnOptions = {
                                        visibleIndex: column.visibleIndex,
                                        index: column.index,
                                        headerId: column.headerId,
                                        allowFixing: 0 === column.groupIndex,
                                        allowReordering: 0 === column.groupIndex,
                                        groupIndex: column.groupIndex
                                    };
                                    result[i] = (0, _extend.extend)({}, column, commandColumns[commandColumnIndex], column.type === GROUP_COMMAND_COLUMN_NAME && columnOptions)
                                }
                            }
                        }
                        if (columns.length && needToExtend && defaultCommandColumns.length) {
                            result = result.concat(defaultCommandColumns)
                        }
                        return result
                    };
                    var isColumnFixed = function(that, column) {
                        return (0, _type.isDefined)(column.fixed) || !column.type ? column.fixed : that._isColumnFixing()
                    };
                    var convertOwnerBandToColumnReference = function(columns) {
                        columns.forEach(function(column) {
                            if ((0, _type.isDefined)(column.ownerBand)) {
                                column.ownerBand = columns[column.ownerBand]
                            }
                        })
                    };
                    var resetBandColumnsCache = function(that) {
                        that._bandColumnsCache = void 0
                    };
                    var findColumn = function(columns, identifier) {
                        var identifierOptionName = (0, _type.isString)(identifier) && identifier.substr(0, identifier.indexOf(":"));
                        var column;
                        if (void 0 === identifier) {
                            return
                        }
                        if (identifierOptionName) {
                            identifier = identifier.substr(identifierOptionName.length + 1)
                        }
                        if (identifierOptionName) {
                            column = columns.filter(function(column) {
                                return "" + column[identifierOptionName] === identifier
                            })[0]
                        } else {
                            ["index", "name", "dataField", "caption"].some(function(optionName) {
                                column = columns.filter(function(column) {
                                    return column[optionName] === identifier
                                })[0];
                                return !!column
                            })
                        }
                        return column
                    };
                    return {
                        _getExpandColumnOptions: function() {
                            return {
                                type: "expand",
                                command: "expand",
                                width: "auto",
                                cssClass: COMMAND_EXPAND_CLASS,
                                allowEditing: false,
                                allowGrouping: false,
                                allowSorting: false,
                                allowResizing: false,
                                allowReordering: false,
                                allowHiding: false
                            }
                        },
                        _getFirstItems: function(dataSource) {
                            var groupsCount;
                            var items = [];
                            var getFirstItemsCore = function getFirstItemsCore(items, groupsCount) {
                                if (!items || !groupsCount) {
                                    return items
                                }
                                for (var i = 0; i < items.length; i++) {
                                    var childItems = getFirstItemsCore(items[i].items || items[i].collapsedItems, groupsCount - 1);
                                    if (childItems && childItems.length) {
                                        return childItems
                                    }
                                }
                            };
                            if (dataSource && dataSource.items().length > 0) {
                                groupsCount = _uiGrid_core2.default.normalizeSortingInfo(dataSource.group()).length;
                                items = getFirstItemsCore(dataSource.items(), groupsCount) || []
                            }
                            return items
                        },
                        _endUpdateCore: function() {
                            !this._skipProcessingColumnsChange && fireColumnsChanged(this)
                        },
                        init: function() {
                            var that = this;
                            var columns = that.option("columns");
                            that._commandColumns = that._commandColumns || [];
                            that._columns = that._columns || [];
                            that._isColumnsFromOptions = !!columns;
                            if (that._isColumnsFromOptions) {
                                assignColumns(that, columns ? createColumnsFromOptions(that, columns) : []);
                                applyUserState(that)
                            } else {
                                assignColumns(that, that._columnsUserState ? createColumnsFromOptions(that, that._columnsUserState) : that._columns)
                            }
                            addExpandColumn(that);
                            if (that._dataSourceApplied) {
                                that.applyDataSource(that._dataSource, true)
                            } else {
                                updateIndexes(that)
                            }
                            that._checkColumns()
                        },
                        callbackNames: function() {
                            return ["columnsChanged"]
                        },
                        getColumnByPath: function(path, columns) {
                            var that = this;
                            var column;
                            var columnIndexes = [];
                            path.replace(regExp, function(_, columnIndex) {
                                columnIndexes.push(parseInt(columnIndex));
                                return ""
                            });
                            if (columnIndexes.length) {
                                if (columns) {
                                    column = columnIndexes.reduce(function(column, index) {
                                        return column && column.columns && column.columns[index]
                                    }, {
                                        columns: columns
                                    })
                                } else {
                                    column = getColumnByIndexes(that, columnIndexes)
                                }
                            }
                            return column
                        },
                        optionChanged: function(args) {
                            var needUpdateRequireResize;
                            switch (args.name) {
                                case "adaptColumnWidthByRatio":
                                    args.handled = true;
                                    break;
                                case "dataSource":
                                    if (args.value !== args.previousValue && !this.option("columns") && (!Array.isArray(args.value) || !Array.isArray(args.previousValue))) {
                                        this._columns = []
                                    }
                                    break;
                                case "columns":
                                    needUpdateRequireResize = this._skipProcessingColumnsChange;
                                    args.handled = true;
                                    if (!this._skipProcessingColumnsChange) {
                                        if (args.name === args.fullName) {
                                            this._columnsUserState = null;
                                            this._ignoreColumnOptionNames = null;
                                            this.init()
                                        } else {
                                            this._columnOptionChanged(args);
                                            needUpdateRequireResize = true
                                        }
                                    }
                                    if (needUpdateRequireResize) {
                                        this._updateRequireResize(args)
                                    }
                                    break;
                                case "commonColumnSettings":
                                case "columnAutoWidth":
                                case "allowColumnResizing":
                                case "allowColumnReordering":
                                case "columnFixing":
                                case "grouping":
                                case "groupPanel":
                                case "regenerateColumnsByVisibleItems":
                                case "customizeColumns":
                                case "editing":
                                case "columnHidingEnabled":
                                case "dateSerializationFormat":
                                case "columnResizingMode":
                                case "columnMinWidth":
                                case "columnWidth":
                                    var _args$fullName, _args$fullName2, _args$fullName3, _args$fullName4, _args$fullName5;
                                    args.handled = true;
                                    var ignoreColumnOptionNames = "columnWidth" === args.fullName && ["width"];
                                    var isEditingPopup = 0 === (null === (_args$fullName = args.fullName) || void 0 === _args$fullName ? void 0 : _args$fullName.indexOf("editing.popup"));
                                    var isEditingForm = 0 === (null === (_args$fullName2 = args.fullName) || void 0 === _args$fullName2 ? void 0 : _args$fullName2.indexOf("editing.form"));
                                    var isEditRowKey = 0 === (null === (_args$fullName3 = args.fullName) || void 0 === _args$fullName3 ? void 0 : _args$fullName3.indexOf("editing.editRowKey"));
                                    var isEditColumnName = 0 === (null === (_args$fullName4 = args.fullName) || void 0 === _args$fullName4 ? void 0 : _args$fullName4.indexOf("editing.editColumnName"));
                                    var isChanges = 0 === (null === (_args$fullName5 = args.fullName) || void 0 === _args$fullName5 ? void 0 : _args$fullName5.indexOf("editing.changes"));
                                    var needReinit = !isEditingPopup && !isEditingForm && !isEditRowKey && !isChanges && !isEditColumnName;
                                    if (needReinit) {
                                        this.reinit(ignoreColumnOptionNames)
                                    }
                                    break;
                                case "rtlEnabled":
                                    this.reinit();
                                    break;
                                default:
                                    this.callBase(args)
                            }
                        },
                        _columnOptionChanged: function(args) {
                            var columnOptionValue = {};
                            var column = this.getColumnByPath(args.fullName);
                            var columnOptionName = args.fullName.replace(regExp, "");
                            if (column) {
                                if (columnOptionName) {
                                    columnOptionValue[columnOptionName] = args.value
                                } else {
                                    columnOptionValue = args.value
                                }
                                this._skipProcessingColumnsChange = args.fullName;
                                this.columnOption(column.index, columnOptionValue);
                                this._skipProcessingColumnsChange = false
                            }
                        },
                        _updateRequireResize: function(args) {
                            var component = this.component;
                            if ("width" === args.fullName.replace(regExp, "") && component._updateLockCount) {
                                component._requireResize = true
                            }
                        },
                        publicMethods: function() {
                            return ["addColumn", "deleteColumn", "columnOption", "columnCount", "clearSorting", "clearGrouping", "getVisibleColumns", "getVisibleColumnIndex"]
                        },
                        applyDataSource: function(dataSource, forceApplying) {
                            var that = this;
                            var isDataSourceLoaded = dataSource && dataSource.isLoaded();
                            that._dataSource = dataSource;
                            if (!that._dataSourceApplied || 0 === that._dataSourceColumnsCount || forceApplying || that.option("regenerateColumnsByVisibleItems")) {
                                if (isDataSourceLoaded) {
                                    if (!that._isColumnsFromOptions) {
                                        var columnsFromDataSource = createColumnsFromDataSource(that, dataSource);
                                        if (columnsFromDataSource.length) {
                                            assignColumns(that, columnsFromDataSource);
                                            that._dataSourceColumnsCount = that._columns.length;
                                            applyUserState(that)
                                        }
                                    }
                                    return that.updateColumns(dataSource, forceApplying)
                                } else {
                                    that._dataSourceApplied = false
                                }
                            } else {
                                if (isDataSourceLoaded && !that.isAllDataTypesDefined(true) && that.updateColumnDataTypes(dataSource)) {
                                    updateColumnChanges(that, "columns");
                                    fireColumnsChanged(that);
                                    return (new _deferred.Deferred).reject().promise()
                                }
                            }
                        },
                        reset: function() {
                            this._dataSourceApplied = false;
                            this._dataSourceColumnsCount = void 0;
                            this.reinit()
                        },
                        resetColumnsCache: function() {
                            var that = this;
                            that._visibleColumns = void 0;
                            that._fixedColumns = void 0;
                            that._rowCount = void 0;
                            resetBandColumnsCache(that)
                        },
                        reinit: function(ignoreColumnOptionNames) {
                            this._columnsUserState = this.getUserState();
                            this._ignoreColumnOptionNames = ignoreColumnOptionNames || null;
                            this.init();
                            if (ignoreColumnOptionNames) {
                                this._ignoreColumnOptionNames = null
                            }
                        },
                        isInitialized: function() {
                            return !!this._columns.length || !!this.option("columns")
                        },
                        isDataSourceApplied: function() {
                            return this._dataSourceApplied
                        },
                        getCommonSettings: function(column) {
                            var commonColumnSettings = (!column || !column.type) && this.option("commonColumnSettings") || {};
                            var groupingOptions = this.option("grouping") || {};
                            var groupPanelOptions = this.option("groupPanel") || {};
                            return (0, _extend.extend)({
                                allowFixing: this.option("columnFixing.enabled"),
                                allowResizing: this.option("allowColumnResizing") || void 0,
                                allowReordering: this.option("allowColumnReordering"),
                                minWidth: this.option("columnMinWidth"),
                                width: this.option("columnWidth"),
                                autoExpandGroup: groupingOptions.autoExpandAll,
                                allowCollapsing: groupingOptions.allowCollapsing,
                                allowGrouping: groupPanelOptions.allowColumnDragging && groupPanelOptions.visible || groupingOptions.contextMenuEnabled
                            }, commonColumnSettings)
                        },
                        isColumnOptionUsed: function(optionName) {
                            for (var i = 0; i < this._columns.length; i++) {
                                if (this._columns[i][optionName]) {
                                    return true
                                }
                            }
                        },
                        isAllDataTypesDefined: function(checkSerializers) {
                            var columns = this._columns;
                            if (!columns.length) {
                                return false
                            }
                            for (var i = 0; i < columns.length; i++) {
                                if (!columns[i].dataField && columns[i].calculateCellValue === columns[i].defaultCalculateCellValue) {
                                    continue
                                }
                                if (!columns[i].dataType || checkSerializers && columns[i].deserializeValue && void 0 === columns[i].serializationFormat) {
                                    return false
                                }
                            }
                            return true
                        },
                        getColumns: function() {
                            return this._columns
                        },
                        isBandColumnsUsed: function() {
                            return this.getColumns().some(function(column) {
                                return column.isBand
                            })
                        },
                        getGroupColumns: function() {
                            var result = [];
                            (0, _iterator.each)(this._columns, function() {
                                var column = this;
                                if ((0, _type.isDefined)(column.groupIndex)) {
                                    result[column.groupIndex] = column
                                }
                            });
                            return result
                        },
                        getVisibleColumns: function(rowIndex) {
                            this._visibleColumns = this._visibleColumns || this._getVisibleColumnsCore();
                            rowIndex = (0, _type.isDefined)(rowIndex) ? rowIndex : this._visibleColumns.length - 1;
                            return this._visibleColumns[rowIndex] || []
                        },
                        getFixedColumns: function(rowIndex) {
                            this._fixedColumns = this._fixedColumns || this._getFixedColumnsCore();
                            rowIndex = (0, _type.isDefined)(rowIndex) ? rowIndex : this._fixedColumns.length - 1;
                            return this._fixedColumns[rowIndex] || []
                        },
                        getFilteringColumns: function() {
                            return this.getColumns().filter(function(item) {
                                return (item.dataField || item.name) && (item.allowFiltering || item.allowHeaderFiltering)
                            }).map(function(item) {
                                var field = (0, _extend.extend)(true, {}, item);
                                if (!(0, _type.isDefined)(field.dataField)) {
                                    field.dataField = field.name
                                }
                                field.filterOperations = item.filterOperations !== item.defaultFilterOperations ? field.filterOperations : null;
                                return field
                            })
                        },
                        getColumnIndexOffset: function() {
                            return 0
                        },
                        _getFixedColumnsCore: function() {
                            var that = this;
                            var result = [];
                            var rowCount = that.getRowCount();
                            var isColumnFixing = that._isColumnFixing();
                            var transparentColumn = {
                                command: "transparent"
                            };
                            var transparentColspan = 0;
                            var notFixedColumnCount;
                            var transparentColumnIndex;
                            var lastFixedPosition;
                            if (isColumnFixing) {
                                for (var i = 0; i <= rowCount; i++) {
                                    notFixedColumnCount = 0;
                                    lastFixedPosition = null;
                                    transparentColumnIndex = null;
                                    var visibleColumns = that.getVisibleColumns(i, true);
                                    for (var j = 0; j < visibleColumns.length; j++) {
                                        var prevColumn = visibleColumns[j - 1];
                                        var column = visibleColumns[j];
                                        if (!column.fixed) {
                                            if (0 === i) {
                                                if (column.isBand && column.colspan) {
                                                    transparentColspan += column.colspan
                                                } else {
                                                    transparentColspan++
                                                }
                                            }
                                            notFixedColumnCount++;
                                            if (!(0, _type.isDefined)(transparentColumnIndex)) {
                                                transparentColumnIndex = j
                                            }
                                        } else {
                                            if (prevColumn && prevColumn.fixed && getFixedPosition(that, prevColumn) !== getFixedPosition(that, column)) {
                                                if (!(0, _type.isDefined)(transparentColumnIndex)) {
                                                    transparentColumnIndex = j
                                                }
                                            } else {
                                                lastFixedPosition = column.fixedPosition
                                            }
                                        }
                                    }
                                    if (0 === i && (0 === notFixedColumnCount || notFixedColumnCount >= visibleColumns.length)) {
                                        return []
                                    }
                                    if (!(0, _type.isDefined)(transparentColumnIndex)) {
                                        transparentColumnIndex = "right" === lastFixedPosition ? 0 : visibleColumns.length
                                    }
                                    result[i] = visibleColumns.slice(0);
                                    if (!transparentColumn.colspan) {
                                        transparentColumn.colspan = transparentColspan
                                    }
                                    result[i].splice(transparentColumnIndex, notFixedColumnCount, transparentColumn)
                                }
                            }
                            return result.map(function(columns) {
                                return columns.map(function(column) {
                                    var newColumn = _objectSpread({}, column);
                                    if (newColumn.headerId) {
                                        newColumn.headerId += "-fixed"
                                    }
                                    return newColumn
                                })
                            })
                        },
                        _isColumnFixing: function() {
                            var isColumnFixing = this.option("columnFixing.enabled");
                            !isColumnFixing && (0, _iterator.each)(this._columns, function(_, column) {
                                if (column.fixed) {
                                    isColumnFixing = true;
                                    return false
                                }
                            });
                            return isColumnFixing
                        },
                        _getExpandColumnsCore: function() {
                            return this.getGroupColumns()
                        },
                        getExpandColumns: function() {
                            var expandColumns = this._getExpandColumnsCore();
                            var expandColumn;
                            var firstGroupColumn = expandColumns.filter(function(column) {
                                return 0 === column.groupIndex
                            })[0];
                            var isFixedFirstGroupColumn = firstGroupColumn && firstGroupColumn.fixed;
                            var isColumnFixing = this._isColumnFixing();
                            if (expandColumns.length) {
                                expandColumn = this.columnOption("command:expand")
                            }
                            expandColumns = (0, _iterator.map)(expandColumns, function(column) {
                                return (0, _extend.extend)({}, column, {
                                    visibleWidth: null,
                                    minWidth: null,
                                    cellTemplate: !(0, _type.isDefined)(column.groupIndex) ? column.cellTemplate : null,
                                    headerCellTemplate: null,
                                    fixed: !(0, _type.isDefined)(column.groupIndex) || !isFixedFirstGroupColumn ? isColumnFixing : true
                                }, expandColumn, {
                                    index: column.index,
                                    type: column.type || GROUP_COMMAND_COLUMN_NAME
                                })
                            });
                            return expandColumns
                        },
                        getBandColumnsCache: function() {
                            if (!this._bandColumnsCache) {
                                var columns = this._columns;
                                var columnChildrenByIndex = {};
                                var columnParentByIndex = {};
                                var isPlain = true;
                                columns.forEach(function(column) {
                                    var parentIndex = column.ownerBand;
                                    var parent = columns[parentIndex];
                                    if (column.hasColumns) {
                                        isPlain = false
                                    }
                                    if (column.colspan) {
                                        column.colspan = void 0
                                    }
                                    if (column.rowspan) {
                                        column.rowspan = void 0
                                    }
                                    if (parent) {
                                        columnParentByIndex[column.index] = parent
                                    } else {
                                        parentIndex = -1
                                    }
                                    columnChildrenByIndex[parentIndex] = columnChildrenByIndex[parentIndex] || [];
                                    columnChildrenByIndex[parentIndex].push(column)
                                });
                                this._bandColumnsCache = {
                                    isPlain: isPlain,
                                    columnChildrenByIndex: columnChildrenByIndex,
                                    columnParentByIndex: columnParentByIndex
                                }
                            }
                            return this._bandColumnsCache
                        },
                        _isColumnVisible: function(column) {
                            return column.visible && this.isParentColumnVisible(column.index)
                        },
                        _getVisibleColumnsCore: function() {
                            var that = this;
                            var i;
                            var result = [];
                            var rowspanGroupColumns = 0;
                            var rowspanExpandColumns = 0;
                            var rowCount = that.getRowCount();
                            var positiveIndexedColumns = [];
                            var negativeIndexedColumns = [];
                            var notGroupedColumnsCount = 0;
                            var isFixedToEnd;
                            var rtlEnabled = that.option("rtlEnabled");
                            var bandColumnsCache = that.getBandColumnsCache();
                            var expandColumns = mergeColumns(that, that.getExpandColumns(), that._columns);
                            var columns = mergeColumns(that, that._columns, that._commandColumns, true);
                            var columnDigitsCount = digitsCount(columns.length);
                            processBandColumns(that, columns, bandColumnsCache);
                            for (i = 0; i < rowCount; i++) {
                                result[i] = [];
                                negativeIndexedColumns[i] = [{}];
                                positiveIndexedColumns[i] = [{}, {}, {}]
                            }(0, _iterator.each)(columns, function() {
                                var column = this;
                                var visibleIndex = column.visibleIndex;
                                var indexedColumns;
                                var parentBandColumns = getParentBandColumns(column.index, bandColumnsCache.columnParentByIndex);
                                var visible = that._isColumnVisible(column);
                                if (visible && (!(0, _type.isDefined)(column.groupIndex) || column.showWhenGrouped)) {
                                    var rowIndex = parentBandColumns.length;
                                    if (visibleIndex < 0) {
                                        visibleIndex = -visibleIndex;
                                        indexedColumns = negativeIndexedColumns[rowIndex]
                                    } else {
                                        column.fixed = parentBandColumns.length ? parentBandColumns[0].fixed : column.fixed;
                                        column.fixedPosition = parentBandColumns.length ? parentBandColumns[0].fixedPosition : column.fixedPosition;
                                        if (column.fixed) {
                                            isFixedToEnd = "right" === column.fixedPosition;
                                            if (rtlEnabled && (!column.command || isCustomCommandColumn(that, column))) {
                                                isFixedToEnd = !isFixedToEnd
                                            }
                                            if (isFixedToEnd) {
                                                indexedColumns = positiveIndexedColumns[rowIndex][2]
                                            } else {
                                                indexedColumns = positiveIndexedColumns[rowIndex][0]
                                            }
                                        } else {
                                            indexedColumns = positiveIndexedColumns[rowIndex][1]
                                        }
                                    }
                                    if (parentBandColumns.length) {
                                        visibleIndex = numberToString(visibleIndex, columnDigitsCount);
                                        for (i = parentBandColumns.length - 1; i >= 0; i--) {
                                            visibleIndex = numberToString(parentBandColumns[i].visibleIndex, columnDigitsCount) + visibleIndex
                                        }
                                    }
                                    indexedColumns[visibleIndex] = indexedColumns[visibleIndex] || [];
                                    indexedColumns[visibleIndex].push(column);
                                    notGroupedColumnsCount++
                                }
                            });
                            (0, _iterator.each)(result, function(rowIndex) {
                                (0, _object.orderEach)(negativeIndexedColumns[rowIndex], function(_, columns) {
                                    result[rowIndex].unshift.apply(result[rowIndex], columns)
                                });
                                var firstPositiveIndexColumn = result[rowIndex].length;
                                (0, _iterator.each)(positiveIndexedColumns[rowIndex], function(index, columnsByFixing) {
                                    (0, _object.orderEach)(columnsByFixing, function(_, columnsByVisibleIndex) {
                                        result[rowIndex].push.apply(result[rowIndex], columnsByVisibleIndex)
                                    })
                                });
                                if (rowspanExpandColumns < rowIndex + 1) {
                                    rowspanExpandColumns += processExpandColumns.call(that, result[rowIndex], expandColumns, "detailExpand", firstPositiveIndexColumn)
                                }
                                if (rowspanGroupColumns < rowIndex + 1) {
                                    rowspanGroupColumns += processExpandColumns.call(that, result[rowIndex], expandColumns, GROUP_COMMAND_COLUMN_NAME, firstPositiveIndexColumn)
                                }
                            });
                            result.push(getDataColumns(result));
                            if (!notGroupedColumnsCount && that._columns.length) {
                                result[rowCount].push({
                                    command: "empty"
                                })
                            }
                            return result
                        },
                        getInvisibleColumns: function(columns, bandColumnIndex) {
                            var that = this;
                            var result = [];
                            var hiddenColumnsByBand;
                            columns = columns || that._columns;
                            (0, _iterator.each)(columns, function(_, column) {
                                if (column.ownerBand !== bandColumnIndex) {
                                    return
                                }
                                if (column.isBand) {
                                    if (!column.visible) {
                                        hiddenColumnsByBand = that.getChildrenByBandColumn(column.index)
                                    } else {
                                        hiddenColumnsByBand = that.getInvisibleColumns(that.getChildrenByBandColumn(column.index), column.index)
                                    }
                                    if (hiddenColumnsByBand.length) {
                                        result.push(column);
                                        result = result.concat(hiddenColumnsByBand)
                                    }
                                    return
                                }
                                if (!column.visible) {
                                    result.push(column)
                                }
                            });
                            return result
                        },
                        getChooserColumns: function(getAllColumns) {
                            var columns = getAllColumns ? this.getColumns() : this.getInvisibleColumns();
                            return (0, _common.grep)(columns, function(column) {
                                return column.showInColumnChooser
                            })
                        },
                        allowMoveColumn: function(fromVisibleIndex, toVisibleIndex, sourceLocation, targetLocation) {
                            var that = this;
                            var columnIndex = getColumnIndexByVisibleIndex(that, fromVisibleIndex, sourceLocation);
                            var sourceColumn = that._columns[columnIndex];
                            if (sourceColumn && (sourceColumn.allowReordering || sourceColumn.allowGrouping || sourceColumn.allowHiding)) {
                                if (sourceLocation === targetLocation) {
                                    if (sourceLocation === COLUMN_CHOOSER_LOCATION) {
                                        return false
                                    }
                                    fromVisibleIndex = (0, _type.isObject)(fromVisibleIndex) ? fromVisibleIndex.columnIndex : fromVisibleIndex;
                                    toVisibleIndex = (0, _type.isObject)(toVisibleIndex) ? toVisibleIndex.columnIndex : toVisibleIndex;
                                    return fromVisibleIndex !== toVisibleIndex && fromVisibleIndex + 1 !== toVisibleIndex
                                } else {
                                    if (sourceLocation === GROUP_LOCATION && targetLocation !== COLUMN_CHOOSER_LOCATION || targetLocation === GROUP_LOCATION) {
                                        return sourceColumn && sourceColumn.allowGrouping
                                    } else {
                                        if (sourceLocation === COLUMN_CHOOSER_LOCATION || targetLocation === COLUMN_CHOOSER_LOCATION) {
                                            return sourceColumn && sourceColumn.allowHiding
                                        }
                                    }
                                }
                                return true
                            }
                            return false
                        },
                        moveColumn: function(fromVisibleIndex, toVisibleIndex, sourceLocation, targetLocation) {
                            var that = this;
                            var options = {};
                            var prevGroupIndex;
                            var fromIndex = getColumnIndexByVisibleIndex(that, fromVisibleIndex, sourceLocation);
                            var toIndex = getColumnIndexByVisibleIndex(that, toVisibleIndex, targetLocation);
                            var targetGroupIndex;
                            if (fromIndex >= 0) {
                                var column = that._columns[fromIndex];
                                toVisibleIndex = (0, _type.isObject)(toVisibleIndex) ? toVisibleIndex.columnIndex : toVisibleIndex;
                                targetGroupIndex = toIndex >= 0 ? that._columns[toIndex].groupIndex : -1;
                                if ((0, _type.isDefined)(column.groupIndex) && sourceLocation === GROUP_LOCATION) {
                                    if (targetGroupIndex > column.groupIndex) {
                                        targetGroupIndex--
                                    }
                                    if (targetLocation !== GROUP_LOCATION) {
                                        options.groupIndex = void 0
                                    } else {
                                        prevGroupIndex = column.groupIndex;
                                        delete column.groupIndex;
                                        updateColumnGroupIndexes(that)
                                    }
                                }
                                if (targetLocation === GROUP_LOCATION) {
                                    options.groupIndex = moveColumnToGroup(that, column, targetGroupIndex);
                                    column.groupIndex = prevGroupIndex
                                } else {
                                    if (toVisibleIndex >= 0) {
                                        var targetColumn = that._columns[toIndex];
                                        if (!targetColumn || column.ownerBand !== targetColumn.ownerBand) {
                                            options.visibleIndex = MAX_SAFE_INTEGER
                                        } else {
                                            if (isColumnFixed(that, column) ^ isColumnFixed(that, targetColumn)) {
                                                options.visibleIndex = MAX_SAFE_INTEGER
                                            } else {
                                                options.visibleIndex = targetColumn.visibleIndex
                                            }
                                        }
                                    }
                                }
                                var isVisible = targetLocation !== COLUMN_CHOOSER_LOCATION;
                                if (column.visible !== isVisible) {
                                    options.visible = isVisible
                                }
                                that.columnOption(column.index, options)
                            }
                        },
                        changeSortOrder: function(columnIndex, sortOrder) {
                            var that = this;
                            var options = {};
                            var sortingOptions = that.option("sorting");
                            var sortingMode = sortingOptions && sortingOptions.mode;
                            var needResetSorting = "single" === sortingMode || !sortOrder;
                            var allowSorting = "single" === sortingMode || "multiple" === sortingMode;
                            var column = that._columns[columnIndex];
                            var nextSortOrder = function(column) {
                                if ("ctrl" === sortOrder) {
                                    if (!("sortOrder" in column && "sortIndex" in column)) {
                                        return false
                                    }
                                    options.sortOrder = void 0;
                                    options.sortIndex = void 0
                                } else {
                                    if ((0, _type.isDefined)(column.groupIndex) || (0, _type.isDefined)(column.sortIndex)) {
                                        options.sortOrder = "desc" === column.sortOrder ? "asc" : "desc"
                                    } else {
                                        options.sortOrder = "asc"
                                    }
                                }
                                return true
                            };
                            if (allowSorting && column && column.allowSorting) {
                                if (needResetSorting && !(0, _type.isDefined)(column.groupIndex)) {
                                    (0, _iterator.each)(that._columns, function(index) {
                                        if (index !== columnIndex && this.sortOrder) {
                                            if (!(0, _type.isDefined)(this.groupIndex)) {
                                                delete this.sortOrder
                                            }
                                            delete this.sortIndex
                                        }
                                    })
                                }
                                if (isSortOrderValid(sortOrder)) {
                                    if (column.sortOrder !== sortOrder) {
                                        options.sortOrder = sortOrder
                                    }
                                } else {
                                    if ("none" === sortOrder) {
                                        if (column.sortOrder) {
                                            options.sortIndex = void 0;
                                            options.sortOrder = void 0
                                        }
                                    } else {
                                        nextSortOrder(column)
                                    }
                                }
                            }
                            that.columnOption(column.index, options)
                        },
                        getSortDataSourceParameters: function(useLocalSelector) {
                            var that = this;
                            var sortColumns = [];
                            var sort = [];
                            (0, _iterator.each)(that._columns, function() {
                                if ((this.dataField || this.selector || this.calculateCellValue) && (0, _type.isDefined)(this.sortIndex) && !(0, _type.isDefined)(this.groupIndex)) {
                                    sortColumns[this.sortIndex] = this
                                }
                            });
                            (0, _iterator.each)(sortColumns, function() {
                                var sortOrder = this && this.sortOrder;
                                if (isSortOrderValid(sortOrder)) {
                                    var sortItem = {
                                        selector: this.calculateSortValue || this.displayField || this.calculateDisplayValue || useLocalSelector && this.selector || this.dataField || this.calculateCellValue,
                                        desc: "desc" === this.sortOrder
                                    };
                                    if (this.sortingMethod) {
                                        sortItem.compare = this.sortingMethod.bind(this)
                                    }
                                    sort.push(sortItem)
                                }
                            });
                            return sort.length > 0 ? sort : null
                        },
                        getGroupDataSourceParameters: function(useLocalSelector) {
                            var group = [];
                            (0, _iterator.each)(this.getGroupColumns(), function() {
                                var selector = this.calculateGroupValue || this.displayField || this.calculateDisplayValue || useLocalSelector && this.selector || this.dataField || this.calculateCellValue;
                                if (selector) {
                                    var groupItem = {
                                        selector: selector,
                                        desc: "desc" === this.sortOrder,
                                        isExpanded: !!this.autoExpandGroup
                                    };
                                    if (this.sortingMethod) {
                                        groupItem.compare = this.sortingMethod.bind(this)
                                    }
                                    group.push(groupItem)
                                }
                            });
                            return group.length > 0 ? group : null
                        },
                        refresh: function(updateNewLookupsOnly) {
                            var deferreds = [];
                            (0, _iterator.each)(this._columns, function() {
                                var lookup = this.lookup;
                                if (lookup && !this.calculateDisplayValue) {
                                    if (updateNewLookupsOnly && lookup.valueMap) {
                                        return
                                    }
                                    if (lookup.update) {
                                        deferreds.push(lookup.update())
                                    }
                                }
                            });
                            return _deferred.when.apply(_renderer.default, deferreds).done(resetColumnsCache.bind(null, this))
                        },
                        _updateColumnOptions: function(column, columnIndex) {
                            column.selector = column.selector || function(data) {
                                return column.calculateCellValue(data)
                            };
                            (0, _iterator.each)(["calculateSortValue", "calculateGroupValue", "calculateDisplayValue"], function(_, calculateCallbackName) {
                                var calculateCallback = column[calculateCallbackName];
                                if ((0, _type.isFunction)(calculateCallback) && !calculateCallback.originalCallback) {
                                    column[calculateCallbackName] = function(data) {
                                        return calculateCallback.call(column, data)
                                    };
                                    column[calculateCallbackName].originalCallback = calculateCallback;
                                    column[calculateCallbackName].columnIndex = columnIndex
                                }
                            });
                            if ((0, _type.isString)(column.calculateDisplayValue)) {
                                column.displayField = column.calculateDisplayValue;
                                column.calculateDisplayValue = (0, _data.compileGetter)(column.displayField)
                            }
                            if (column.calculateDisplayValue) {
                                column.displayValueMap = column.displayValueMap || {}
                            }
                            updateSerializers(column, column.dataType);
                            var lookup = column.lookup;
                            if (lookup) {
                                updateSerializers(lookup, lookup.dataType)
                            }
                            var dataType = lookup ? lookup.dataType : column.dataType;
                            if (dataType) {
                                column.alignment = column.alignment || getAlignmentByDataType(dataType, this.option("rtlEnabled"));
                                column.format = column.format || _uiGrid_core2.default.getFormatByDataType(dataType);
                                column.customizeText = column.customizeText || getCustomizeTextByDataType(dataType);
                                column.defaultFilterOperations = column.defaultFilterOperations || !lookup && DATATYPE_OPERATIONS[dataType] || [];
                                if (!(0, _type.isDefined)(column.filterOperations)) {
                                    setFilterOperationsAsDefaultValues(column)
                                }
                                column.defaultFilterOperation = column.filterOperations && column.filterOperations[0] || "=";
                                column.showEditorAlways = (0, _type.isDefined)(column.showEditorAlways) ? column.showEditorAlways : "boolean" === dataType && !column.cellTemplate
                            }
                        },
                        updateColumnDataTypes: function(dataSource) {
                            var that = this;
                            var dateSerializationFormat = that.option("dateSerializationFormat");
                            var firstItems = that._getFirstItems(dataSource);
                            var isColumnDataTypesUpdated = false;
                            (0, _iterator.each)(that._columns, function(index, column) {
                                var i;
                                var value;
                                var dataType;
                                var lookupDataType;
                                var valueDataType;
                                var lookup = column.lookup;
                                if (_uiGrid_core2.default.isDateType(column.dataType) && void 0 === column.serializationFormat) {
                                    column.serializationFormat = dateSerializationFormat
                                }
                                if (lookup && _uiGrid_core2.default.isDateType(lookup.dataType) && void 0 === column.serializationFormat) {
                                    lookup.serializationFormat = dateSerializationFormat
                                }
                                if (column.calculateCellValue && firstItems.length) {
                                    if (!column.dataType || lookup && !lookup.dataType) {
                                        for (i = 0; i < firstItems.length; i++) {
                                            value = column.calculateCellValue(firstItems[i]);
                                            if (!column.dataType) {
                                                valueDataType = getValueDataType(value);
                                                dataType = dataType || valueDataType;
                                                if (dataType && valueDataType && dataType !== valueDataType) {
                                                    dataType = "string"
                                                }
                                            }
                                            if (lookup && !lookup.dataType) {
                                                valueDataType = getValueDataType(_uiGrid_core2.default.getDisplayValue(column, value, firstItems[i]));
                                                lookupDataType = lookupDataType || valueDataType;
                                                if (lookupDataType && valueDataType && lookupDataType !== valueDataType) {
                                                    lookupDataType = "string"
                                                }
                                            }
                                        }
                                        if (dataType || lookupDataType) {
                                            if (dataType) {
                                                column.dataType = dataType
                                            }
                                            if (lookup && lookupDataType) {
                                                lookup.dataType = lookupDataType
                                            }
                                            isColumnDataTypesUpdated = true
                                        }
                                    }
                                    if (void 0 === column.serializationFormat || lookup && void 0 === lookup.serializationFormat) {
                                        for (i = 0; i < firstItems.length; i++) {
                                            value = column.calculateCellValue(firstItems[i], true);
                                            if (void 0 === column.serializationFormat) {
                                                column.serializationFormat = getSerializationFormat(column.dataType, value)
                                            }
                                            if (lookup && void 0 === lookup.serializationFormat) {
                                                lookup.serializationFormat = getSerializationFormat(lookup.dataType, lookup.calculateCellValue(value, true))
                                            }
                                        }
                                    }
                                }
                                that._updateColumnOptions(column, index)
                            });
                            return isColumnDataTypesUpdated
                        },
                        _customizeColumns: function(columns) {
                            var that = this;
                            var customizeColumns = that.option("customizeColumns");
                            if (customizeColumns) {
                                var hasOwnerBand = columns.some(function(column) {
                                    return (0, _type.isObject)(column.ownerBand)
                                });
                                if (hasOwnerBand) {
                                    updateIndexes(that)
                                }
                                customizeColumns(columns);
                                assignColumns(that, createColumnsFromOptions(that, columns))
                            }
                        },
                        updateColumns: function(dataSource, forceApplying) {
                            var _this = this;
                            if (!forceApplying) {
                                this.updateSortingGrouping(dataSource)
                            }
                            if (!dataSource || dataSource.isLoaded()) {
                                var sortParameters = dataSource ? dataSource.sort() || [] : this.getSortDataSourceParameters();
                                var groupParameters = dataSource ? dataSource.group() || [] : this.getGroupDataSourceParameters();
                                var filterParameters = null === dataSource || void 0 === dataSource ? void 0 : dataSource.lastLoadOptions().filter;
                                this._customizeColumns(this._columns);
                                updateIndexes(this);
                                var columns = this._columns;
                                return (0, _deferred.when)(this.refresh(true)).always(function() {
                                    if (_this._columns !== columns) {
                                        return
                                    }
                                    _this._updateChanges(dataSource, {
                                        sorting: sortParameters,
                                        grouping: groupParameters,
                                        filtering: filterParameters
                                    });
                                    fireColumnsChanged(_this)
                                })
                            }
                        },
                        _updateChanges: function(dataSource, parameters) {
                            if (dataSource) {
                                this.updateColumnDataTypes(dataSource);
                                this._dataSourceApplied = true
                            }
                            if (!_uiGrid_core2.default.equalSortParameters(parameters.sorting, this.getSortDataSourceParameters())) {
                                updateColumnChanges(this, "sorting")
                            }
                            if (!_uiGrid_core2.default.equalSortParameters(parameters.grouping, this.getGroupDataSourceParameters())) {
                                updateColumnChanges(this, "grouping")
                            }
                            var dataController = this.getController("data");
                            if (dataController && !_uiGrid_core2.default.equalFilterParameters(parameters.filtering, dataController.getCombinedFilter())) {
                                updateColumnChanges(this, "filtering")
                            }
                            updateColumnChanges(this, "columns")
                        },
                        updateSortingGrouping: function(dataSource, fromDataSource) {
                            var that = this;
                            var sortParameters;
                            var isColumnsChanged;
                            var updateSortGroupParameterIndexes = function(columns, sortParameters, indexParameterName) {
                                (0, _iterator.each)(columns, function(index, column) {
                                    delete column[indexParameterName];
                                    if (sortParameters) {
                                        for (var i = 0; i < sortParameters.length; i++) {
                                            var selector = sortParameters[i].selector;
                                            var isExpanded = sortParameters[i].isExpanded;
                                            if (selector === column.dataField || selector === column.name || selector === column.selector || selector === column.calculateCellValue || selector === column.calculateGroupValue || selector === column.calculateDisplayValue) {
                                                column.sortOrder = column.sortOrder || (sortParameters[i].desc ? "desc" : "asc");
                                                if (void 0 !== isExpanded) {
                                                    column.autoExpandGroup = isExpanded
                                                }
                                                column[indexParameterName] = i;
                                                break
                                            }
                                        }
                                    }
                                })
                            };
                            if (dataSource) {
                                sortParameters = _uiGrid_core2.default.normalizeSortingInfo(dataSource.sort());
                                var groupParameters = _uiGrid_core2.default.normalizeSortingInfo(dataSource.group());
                                var columnsGroupParameters = that.getGroupDataSourceParameters();
                                var columnsSortParameters = that.getSortDataSourceParameters();
                                if (!that._columns.length) {
                                    (0, _iterator.each)(groupParameters, function(index, group) {
                                        that._columns.push(group.selector)
                                    });
                                    (0, _iterator.each)(sortParameters, function(index, sort) {
                                        that._columns.push(sort.selector)
                                    });
                                    assignColumns(that, createColumnsFromOptions(that, that._columns))
                                }
                                if ((fromDataSource || !columnsGroupParameters && !that._hasUserState) && !_uiGrid_core2.default.equalSortParameters(groupParameters, columnsGroupParameters)) {
                                    updateSortGroupParameterIndexes(that._columns, groupParameters, "groupIndex");
                                    if (fromDataSource) {
                                        updateColumnChanges(that, "grouping");
                                        isColumnsChanged = true
                                    }
                                }
                                if ((fromDataSource || !columnsSortParameters && !that._hasUserState) && !_uiGrid_core2.default.equalSortParameters(sortParameters, columnsSortParameters)) {
                                    updateSortGroupParameterIndexes(that._columns, sortParameters, "sortIndex");
                                    if (fromDataSource) {
                                        updateColumnChanges(that, "sorting");
                                        isColumnsChanged = true
                                    }
                                }
                                if (isColumnsChanged) {
                                    fireColumnsChanged(that)
                                }
                            }
                        },
                        updateFilter: function(filter, remoteFiltering, columnIndex, filterValue) {
                            var that = this;
                            if (!Array.isArray(filter)) {
                                return filter
                            }
                            filter = (0, _extend.extend)([], filter);
                            columnIndex = void 0 !== filter.columnIndex ? filter.columnIndex : columnIndex;
                            filterValue = void 0 !== filter.filterValue ? filter.filterValue : filterValue;
                            if ((0, _type.isString)(filter[0]) && "!" !== filter[0]) {
                                var column = that.columnOption(filter[0]);
                                if (remoteFiltering) {
                                    if ((0, _config.default)().forceIsoDateParsing && column && column.serializeValue && filter.length > 1) {
                                        filter[filter.length - 1] = column.serializeValue(filter[filter.length - 1], "filter")
                                    }
                                } else {
                                    if (column && column.selector) {
                                        filter[0] = column.selector;
                                        filter[0].columnIndex = column.index
                                    }
                                }
                            } else {
                                if ((0, _type.isFunction)(filter[0])) {
                                    filter[0].columnIndex = columnIndex;
                                    filter[0].filterValue = filterValue
                                }
                            }
                            for (var i = 0; i < filter.length; i++) {
                                filter[i] = that.updateFilter(filter[i], remoteFiltering, columnIndex, filterValue)
                            }
                            return filter
                        },
                        columnCount: function() {
                            return this._columns ? this._columns.length : 0
                        },
                        columnOption: function(identifier, option, value, notFireEvent) {
                            var that = this;
                            var columns = that._columns.concat(that._commandColumns);
                            var column = findColumn(columns, identifier);
                            if (column) {
                                if (1 === arguments.length) {
                                    return (0, _extend.extend)({}, column)
                                }
                                if ((0, _type.isString)(option)) {
                                    if (2 === arguments.length) {
                                        return columnOptionCore(that, column, option)
                                    } else {
                                        columnOptionCore(that, column, option, value, notFireEvent)
                                    }
                                } else {
                                    if ((0, _type.isObject)(option)) {
                                        (0, _iterator.each)(option, function(optionName, value) {
                                            columnOptionCore(that, column, optionName, value, notFireEvent)
                                        })
                                    }
                                }
                                fireColumnsChanged(that)
                            }
                        },
                        clearSorting: function() {
                            var that = this;
                            var columnCount = this.columnCount();
                            that.beginUpdate();
                            for (var i = 0; i < columnCount; i++) {
                                that.columnOption(i, "sortOrder", void 0)
                            }
                            that.endUpdate()
                        },
                        clearGrouping: function() {
                            var that = this;
                            var columnCount = this.columnCount();
                            that.beginUpdate();
                            for (var i = 0; i < columnCount; i++) {
                                that.columnOption(i, "groupIndex", void 0)
                            }
                            that.endUpdate()
                        },
                        getVisibleIndex: function(index, rowIndex) {
                            var columns = this.getVisibleColumns(rowIndex);
                            for (var i = columns.length - 1; i >= 0; i--) {
                                if (columns[i].index === index) {
                                    return i
                                }
                            }
                            return -1
                        },
                        getVisibleIndexByColumn: function(column, rowIndex) {
                            var visibleColumns = this.getVisibleColumns(rowIndex);
                            var visibleColumn = visibleColumns.filter(function(col) {
                                return col.index === column.index && col.command === column.command
                            })[0];
                            return visibleColumns.indexOf(visibleColumn)
                        },
                        getVisibleColumnIndex: function(id, rowIndex) {
                            var index = this.columnOption(id, "index");
                            return this.getVisibleIndex(index, rowIndex)
                        },
                        addColumn: function(options) {
                            var that = this;
                            var column = createColumn(that, options);
                            var index = that._columns.length;
                            that._columns.push(column);
                            if (column.isBand) {
                                that._columns = createColumnsFromOptions(that, that._columns);
                                column = that._columns[index]
                            }
                            column.added = options;
                            updateIndexes(that, column);
                            that.updateColumns(that._dataSource);
                            that._checkColumns()
                        },
                        deleteColumn: function(id) {
                            var that = this;
                            var column = that.columnOption(id);
                            if (column && column.index >= 0) {
                                convertOwnerBandToColumnReference(that._columns);
                                that._columns.splice(column.index, 1);
                                if (column.isBand) {
                                    var childIndexes = that.getChildrenByBandColumn(column.index).map(function(column) {
                                        return column.index
                                    });
                                    that._columns = that._columns.filter(function(column) {
                                        return childIndexes.indexOf(column.index) < 0
                                    })
                                }
                                updateIndexes(that);
                                that.updateColumns(that._dataSource)
                            }
                        },
                        addCommandColumn: function(options) {
                            var commandColumn = this._commandColumns.filter(function(column) {
                                return column.command === options.command
                            })[0];
                            if (!commandColumn) {
                                commandColumn = options;
                                this._commandColumns.push(commandColumn)
                            }
                        },
                        getUserState: function() {
                            var columns = this._columns;
                            var result = [];
                            var i;

                            function handleStateField(index, value) {
                                if (void 0 !== columns[i][value]) {
                                    result[i][value] = columns[i][value]
                                }
                            }
                            for (i = 0; i < columns.length; i++) {
                                result[i] = {};
                                (0, _iterator.each)(USER_STATE_FIELD_NAMES, handleStateField)
                            }
                            return result
                        },
                        setName: function(column) {
                            var dataField = column.dataField;
                            if (!(0, _type.isDefined)(column.name) && (0, _type.isDefined)(dataField)) {
                                column.name = dataField
                            }
                        },
                        setUserState: function(state) {
                            var that = this;
                            var dataSource = that._dataSource;
                            var ignoreColumnOptionNames = that.option("stateStoring.ignoreColumnOptionNames");
                            null === state || void 0 === state ? void 0 : state.forEach(this.setName);
                            if (!ignoreColumnOptionNames) {
                                ignoreColumnOptionNames = [];
                                var commonColumnSettings = that.getCommonSettings();
                                if (!that.option("columnChooser.enabled")) {
                                    ignoreColumnOptionNames.push("visible")
                                }
                                if ("none" === that.option("sorting.mode")) {
                                    ignoreColumnOptionNames.push("sortIndex", "sortOrder")
                                }
                                if (!commonColumnSettings.allowGrouping) {
                                    ignoreColumnOptionNames.push("groupIndex")
                                }
                                if (!commonColumnSettings.allowFixing) {
                                    ignoreColumnOptionNames.push("fixed", "fixedPosition")
                                }
                                if (!commonColumnSettings.allowResizing) {
                                    ignoreColumnOptionNames.push("width", "visibleWidth")
                                }
                                var isFilterPanelHidden = !that.option("filterPanel.visible");
                                if (!that.option("filterRow.visible") && isFilterPanelHidden) {
                                    ignoreColumnOptionNames.push("filterValue", "selectedFilterOperation")
                                }
                                if (!that.option("headerFilter.visible") && isFilterPanelHidden) {
                                    ignoreColumnOptionNames.push("filterValues", "filterType")
                                }
                            }
                            that._columnsUserState = state;
                            that._ignoreColumnOptionNames = ignoreColumnOptionNames;
                            that._hasUserState = !!state;
                            updateColumnChanges(that, "filtering");
                            that.init();
                            if (dataSource) {
                                dataSource.sort(that.getSortDataSourceParameters());
                                dataSource.group(that.getGroupDataSourceParameters())
                            }
                        },
                        _checkColumns: function() {
                            var usedNames = {};
                            var hasEditableColumnWithoutName = false;
                            var duplicatedNames = [];
                            this._columns.forEach(function(column) {
                                var _column$columns;
                                var name = column.name;
                                var isBand = null === (_column$columns = column.columns) || void 0 === _column$columns ? void 0 : _column$columns.length;
                                var isEditable = column.allowEditing && (column.dataField || column.setCellValue) && !isBand;
                                if (name) {
                                    if (usedNames[name]) {
                                        duplicatedNames.push('"'.concat(name, '"'))
                                    }
                                    usedNames[name] = true
                                } else {
                                    if (isEditable) {
                                        hasEditableColumnWithoutName = true
                                    }
                                }
                            });
                            if (duplicatedNames.length) {
                                _ui.default.log("E1059", duplicatedNames.join(", "))
                            }
                            if (hasEditableColumnWithoutName) {
                                _ui.default.log("E1060")
                            }
                        },
                        _createCalculatedColumnOptions: function(columnOptions, bandColumn) {
                            var calculatedColumnOptions = {};
                            var dataField = columnOptions.dataField;
                            if (Array.isArray(columnOptions.columns) && columnOptions.columns.length || columnOptions.isBand) {
                                calculatedColumnOptions.isBand = true;
                                dataField = null
                            }
                            if (dataField) {
                                if ((0, _type.isString)(dataField)) {
                                    var getter = (0, _data.compileGetter)(dataField);
                                    calculatedColumnOptions = {
                                        caption: (0, _inflector.captionize)(dataField),
                                        calculateCellValue: function(data, skipDeserialization) {
                                            var value = getter(data);
                                            return this.deserializeValue && !skipDeserialization ? this.deserializeValue(value) : value
                                        },
                                        setCellValue: defaultSetCellValue,
                                        parseValue: function(text) {
                                            var column = this;
                                            var result;
                                            var parsedValue;
                                            if ("number" === column.dataType) {
                                                if ((0, _type.isString)(text) && column.format) {
                                                    parsedValue = _number.default.parse(text);
                                                    if ((0, _type.isNumeric)(parsedValue)) {
                                                        result = parsedValue
                                                    }
                                                } else {
                                                    if ((0, _type.isDefined)(text) && (0, _type.isNumeric)(text)) {
                                                        result = Number(text)
                                                    }
                                                }
                                            } else {
                                                if ("boolean" === column.dataType) {
                                                    if (text === column.trueText) {
                                                        result = true
                                                    } else {
                                                        if (text === column.falseText) {
                                                            result = false
                                                        }
                                                    }
                                                } else {
                                                    if (_uiGrid_core2.default.isDateType(column.dataType)) {
                                                        parsedValue = _date.default.parse(text, column.format);
                                                        if (parsedValue) {
                                                            result = parsedValue
                                                        }
                                                    } else {
                                                        result = text
                                                    }
                                                }
                                            }
                                            return result
                                        }
                                    }
                                }
                                calculatedColumnOptions.allowFiltering = true
                            } else {
                                calculatedColumnOptions.allowFiltering = !!columnOptions.calculateFilterExpression
                            }
                            calculatedColumnOptions.calculateFilterExpression = function() {
                                return _filtering.default.defaultCalculateFilterExpression.apply(this, arguments)
                            };
                            calculatedColumnOptions.createFilterExpression = function(filterValue) {
                                var result;
                                if (this.calculateFilterExpression) {
                                    result = this.calculateFilterExpression.apply(this, arguments)
                                }
                                if ((0, _type.isFunction)(result)) {
                                    result = [result, "=", true]
                                }
                                if (result) {
                                    result.columnIndex = this.index;
                                    result.filterValue = filterValue
                                }
                                return result
                            };
                            if (!dataField || !(0, _type.isString)(dataField)) {
                                (0, _extend.extend)(true, calculatedColumnOptions, {
                                    allowSorting: false,
                                    allowGrouping: false,
                                    calculateCellValue: function() {
                                        return null
                                    }
                                })
                            }
                            if (bandColumn) {
                                calculatedColumnOptions.allowFixing = false
                            }
                            if (columnOptions.dataType) {
                                calculatedColumnOptions.userDataType = columnOptions.dataType
                            }
                            if (columnOptions.selectedFilterOperation && !("defaultSelectedFilterOperation" in calculatedColumnOptions)) {
                                calculatedColumnOptions.defaultSelectedFilterOperation = columnOptions.selectedFilterOperation
                            }
                            if (columnOptions.lookup) {
                                calculatedColumnOptions.lookup = {
                                    calculateCellValue: function(value, skipDeserialization) {
                                        if (this.valueExpr) {
                                            value = this.valueMap && this.valueMap[value];
                                        }
                                        return this.deserializeValue && !skipDeserialization ? this.deserializeValue(value) : value
                                    },
                                    updateValueMap: function() {
                                        this.valueMap = {};
                                        if (this.items) {
                                            var calculateValue = (0, _data.compileGetter)(this.valueExpr);
                                            var calculateDisplayValue = (0, _data.compileGetter)(this.displayExpr);
                                            for (var i = 0; i < this.items.length; i++) {
                                                var item = this.items[i];
                                                var displayValue = calculateDisplayValue(item);
                                                this.valueMap[calculateValue(item)] = displayValue;
                                                this.dataType = this.dataType || getValueDataType(displayValue)
                                            }
                                        }
                                    },
                                    update: function() {
                                        var that = this;
                                        var dataSource = that.dataSource;
                                        if (dataSource) {
                                            if ((0, _type.isFunction)(dataSource) && !_variable_wrapper.default.isWrapped(dataSource)) {
                                                dataSource = dataSource({})
                                            }
                                            if ((0, _type.isPlainObject)(dataSource) || dataSource instanceof _abstract_store.default || Array.isArray(dataSource)) {
                                                if (that.valueExpr) {
                                                    var dataSourceOptions = (0, _utils.normalizeDataSourceOptions)(dataSource);
                                                    dataSourceOptions.paginate = false;
                                                    dataSource = new _data_source.DataSource(dataSourceOptions);
                                                    return dataSource.load().done(function(data) {
                                                        that.items = data;
                                                        that.updateValueMap && that.updateValueMap()
                                                    })
                                                }
                                            } else {
                                                _ui.default.log("E1016")
                                            }
                                        } else {
                                            that.updateValueMap && that.updateValueMap()
                                        }
                                    }
                                }
                            }
                            calculatedColumnOptions.resizedCallbacks = (0, _callbacks.default)();
                            if (columnOptions.resized) {
                                calculatedColumnOptions.resizedCallbacks.add(columnOptions.resized.bind(columnOptions))
                            }(0, _iterator.each)(calculatedColumnOptions, function(optionName) {
                                if ((0, _type.isFunction)(calculatedColumnOptions[optionName]) && 0 !== optionName.indexOf("default")) {
                                    var defaultOptionName = "default" + optionName.charAt(0).toUpperCase() + optionName.substr(1);
                                    calculatedColumnOptions[defaultOptionName] = calculatedColumnOptions[optionName]
                                }
                            });
                            return calculatedColumnOptions
                        },
                        getRowCount: function() {
                            this._rowCount = this._rowCount || _getRowCount(this);
                            return this._rowCount
                        },
                        getRowIndex: function(columnIndex, alwaysGetRowIndex) {
                            var column = this._columns[columnIndex];
                            var bandColumnsCache = this.getBandColumnsCache();
                            return column && (alwaysGetRowIndex || column.visible && !(column.command || (0, _type.isDefined)(column.groupIndex))) ? getParentBandColumns(columnIndex, bandColumnsCache.columnParentByIndex).length : 0
                        },
                        getChildrenByBandColumn: function(bandColumnIndex, onlyVisibleDirectChildren) {
                            var that = this;
                            var bandColumnsCache = that.getBandColumnsCache();
                            var result = _getChildrenByBandColumn(bandColumnIndex, bandColumnsCache.columnChildrenByIndex, !onlyVisibleDirectChildren);
                            if (onlyVisibleDirectChildren) {
                                return result.filter(function(column) {
                                    return column.visible && !column.command
                                }).sort(function(column1, column2) {
                                    return column1.visibleIndex - column2.visibleIndex
                                })
                            }
                            return result
                        },
                        isParentBandColumn: function(columnIndex, bandColumnIndex) {
                            var result = false;
                            var column = this._columns[columnIndex];
                            var bandColumnsCache = this.getBandColumnsCache();
                            var parentBandColumns = column && getParentBandColumns(columnIndex, bandColumnsCache.columnParentByIndex);
                            if (parentBandColumns) {
                                (0, _iterator.each)(parentBandColumns, function(_, bandColumn) {
                                    if (bandColumn.index === bandColumnIndex) {
                                        result = true;
                                        return false
                                    }
                                })
                            }
                            return result
                        },
                        isParentColumnVisible: function(columnIndex) {
                            var result = true;
                            var bandColumnsCache = this.getBandColumnsCache();
                            var bandColumns = columnIndex >= 0 && getParentBandColumns(columnIndex, bandColumnsCache.columnParentByIndex);
                            bandColumns && (0, _iterator.each)(bandColumns, function(_, bandColumn) {
                                result = result && bandColumn.visible;
                                return result
                            });
                            return result
                        },
                        getColumnId: function(column) {
                            if (column.command && column.type === GROUP_COMMAND_COLUMN_NAME) {
                                if (isCustomCommandColumn(this, column)) {
                                    return "type:" + column.type
                                }
                                return "command:" + column.command
                            }
                            return column.index
                        },
                        getCustomizeTextByDataType: getCustomizeTextByDataType,
                        getHeaderContentAlignment: function(columnAlignment) {
                            var rtlEnabled = this.option("rtlEnabled");
                            if (rtlEnabled) {
                                return "left" === columnAlignment ? "right" : "left"
                            }
                            return columnAlignment
                        }
                    }
                }())
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.data_source_adapter.js ***!
      \***********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/callbacks */ 27));
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ../data_grid/ui.data_grid.core */ 26));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _array_store = _interopRequireDefault(__webpack_require__( /*! ../../data/array_store */ 77));
        var _array_utils = __webpack_require__( /*! ../../data/array_utils */ 93);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _uiData_grid.default.Controller.inherit(function() {
            function cloneItems(items, groupCount) {
                if (items) {
                    items = items.slice(0);
                    if (groupCount) {
                        for (var i = 0; i < items.length; i++) {
                            items[i] = (0, _extend.extend)({
                                key: items[i].key
                            }, items[i]);
                            items[i].items = cloneItems(items[i].items, groupCount - 1)
                        }
                    }
                }
                return items
            }

            function calculateOperationTypes(loadOptions, lastLoadOptions, isFullReload) {
                var operationTypes = {
                    reload: true,
                    fullReload: true
                };
                if (lastLoadOptions) {
                    operationTypes = {
                        sorting: !_uiData_grid.default.equalSortParameters(loadOptions.sort, lastLoadOptions.sort),
                        grouping: !_uiData_grid.default.equalSortParameters(loadOptions.group, lastLoadOptions.group, true),
                        groupExpanding: !_uiData_grid.default.equalSortParameters(loadOptions.group, lastLoadOptions.group) || lastLoadOptions.groupExpand,
                        filtering: !_uiData_grid.default.equalFilterParameters(loadOptions.filter, lastLoadOptions.filter),
                        pageIndex: loadOptions.pageIndex !== lastLoadOptions.pageIndex,
                        skip: loadOptions.skip !== lastLoadOptions.skip,
                        take: loadOptions.take !== lastLoadOptions.take,
                        fullReload: isFullReload
                    };
                    operationTypes.reload = isFullReload || operationTypes.sorting || operationTypes.grouping || operationTypes.filtering;
                    operationTypes.paging = operationTypes.pageIndex || operationTypes.take
                }
                return operationTypes
            }

            function executeTask(action, timeout) {
                if ((0, _type.isDefined)(timeout)) {
                    (0, _common.executeAsync)(action, timeout)
                } else {
                    action()
                }
            }

            function createEmptyPagesData() {
                return {
                    pages: {}
                }
            }

            function getPageDataFromCache(options) {
                return options.cachedPagesData.pages[options.pageIndex]
            }

            function setPageDataToCache(options, data) {
                var pageIndex = options.pageIndex;
                if (void 0 !== pageIndex) {
                    options.cachedPagesData.pages[pageIndex] = data
                }
            }
            return {
                init: function(dataSource, remoteOperations) {
                    var that = this;
                    that._dataSource = dataSource;
                    that._remoteOperations = remoteOperations || {};
                    that._isLastPage = !dataSource.isLastPage();
                    that._hasLastPage = false;
                    that._currentTotalCount = 0;
                    that._cachedPagesData = createEmptyPagesData();
                    that._lastOperationTypes = {};
                    that._eventsStrategy = dataSource._eventsStrategy;
                    that._skipCorrection = 0;
                    that._isLoadingAll = false;
                    that.changed = (0, _callbacks.default)();
                    that.loadingChanged = (0, _callbacks.default)();
                    that.loadError = (0, _callbacks.default)();
                    that.customizeStoreLoadOptions = (0, _callbacks.default)();
                    that.changing = (0, _callbacks.default)();
                    that._dataChangedHandler = that._handleDataChanged.bind(that);
                    that._dataLoadingHandler = that._handleDataLoading.bind(that);
                    that._dataLoadedHandler = that._handleDataLoaded.bind(that);
                    that._loadingChangedHandler = that._handleLoadingChanged.bind(that);
                    that._loadErrorHandler = that._handleLoadError.bind(that);
                    that._pushHandler = that._handlePush.bind(that);
                    that._changingHandler = that._handleChanging.bind(that);
                    dataSource.on("changed", that._dataChangedHandler);
                    dataSource.on("customizeStoreLoadOptions", that._dataLoadingHandler);
                    dataSource.on("customizeLoadResult", that._dataLoadedHandler);
                    dataSource.on("loadingChanged", that._loadingChangedHandler);
                    dataSource.on("loadError", that._loadErrorHandler);
                    dataSource.on("changing", that._changingHandler);
                    dataSource.store().on("push", that._pushHandler);
                    (0, _iterator.each)(dataSource, function(memberName, member) {
                        if (!that[memberName] && (0, _type.isFunction)(member)) {
                            that[memberName] = function() {
                                return this._dataSource[memberName].apply(this._dataSource, arguments)
                            }
                        }
                    })
                },
                remoteOperations: function() {
                    return this._remoteOperations
                },
                dispose: function(isSharedDataSource) {
                    var that = this;
                    var dataSource = that._dataSource;
                    var store = dataSource.store();
                    dataSource.off("changed", that._dataChangedHandler);
                    dataSource.off("customizeStoreLoadOptions", that._dataLoadingHandler);
                    dataSource.off("customizeLoadResult", that._dataLoadedHandler);
                    dataSource.off("loadingChanged", that._loadingChangedHandler);
                    dataSource.off("loadError", that._loadErrorHandler);
                    dataSource.off("changing", that._changingHandler);
                    store && store.off("push", that._pushHandler);
                    if (!isSharedDataSource) {
                        dataSource.dispose()
                    }
                },
                refresh: function(options, operationTypes) {
                    var that = this;
                    var dataSource = that._dataSource;
                    if (operationTypes.reload) {
                        that.resetCurrentTotalCount();
                        that._isLastPage = !dataSource.paginate();
                        that._hasLastPage = that._isLastPage
                    }
                },
                resetCurrentTotalCount: function() {
                    this._currentTotalCount = 0;
                    this._skipCorrection = 0
                },
                resetCache: function() {
                    this._cachedStoreData = void 0;
                    this._cachedPagingData = void 0
                },
                resetPagesCache: function() {
                    this._cachedPagesData = createEmptyPagesData()
                },
                _needClearStoreDataCache: function() {
                    var remoteOperations = this.remoteOperations();
                    var operationTypes = calculateOperationTypes(this._lastLoadOptions || {}, {});
                    var isLocalOperations = Object.keys(remoteOperations).every(function(operationName) {
                        return !operationTypes[operationName] || !remoteOperations[operationName]
                    });
                    return !isLocalOperations
                },
                push: function(changes, fromStore) {
                    var store = this.store();
                    if (this._needClearStoreDataCache()) {
                        this._cachedStoreData = void 0
                    }
                    this._cachedPagingData = void 0;
                    this.resetPagesCache(true);
                    if (this._cachedStoreData) {
                        (0, _array_utils.applyBatch)({
                            keyInfo: store,
                            data: this._cachedStoreData,
                            changes: changes
                        })
                    }
                    if (!fromStore) {
                        this._applyBatch(changes)
                    }
                },
                getDataIndexGetter: function() {
                    var _this = this;
                    if (!this._dataIndexGetter) {
                        var indexByKey;
                        var storeData;
                        var store = this.store();
                        this._dataIndexGetter = function(data) {
                            var isCacheUpdated = storeData && storeData !== _this._cachedStoreData;
                            if (!indexByKey || isCacheUpdated) {
                                storeData = _this._cachedStoreData || [];
                                indexByKey = {};
                                for (var i = 0; i < storeData.length; i++) {
                                    indexByKey[(0, _common.getKeyHash)(store.keyOf(storeData[i]))] = i
                                }
                            }
                            return indexByKey[(0, _common.getKeyHash)(store.keyOf(data))]
                        }
                    }
                    return this._dataIndexGetter
                },
                _getKeyInfo: function() {
                    return this.store()
                },
                _applyBatch: function(changes) {
                    var _this2 = this;
                    var keyInfo = this._getKeyInfo();
                    var dataSource = this._dataSource;
                    var groupCount = _uiData_grid.default.normalizeSortingInfo(this.group()).length;
                    var totalCount = this.totalCount();
                    var isVirtualMode = "virtual" === this.option("scrolling.mode");
                    changes = changes.filter(function(change) {
                        return !dataSource.paginate() || "insert" !== change.type || void 0 !== change.index
                    });
                    var getItemCount = function() {
                        return groupCount ? _this2.itemsCount() : _this2._items.length
                    };
                    var oldItemCount = getItemCount();
                    (0, _array_utils.applyBatch)({
                        keyInfo: keyInfo,
                        data: this._items,
                        changes: changes,
                        groupCount: groupCount,
                        useInsertIndex: true
                    });
                    (0, _array_utils.applyBatch)({
                        keyInfo: keyInfo,
                        data: dataSource.items(),
                        changes: changes,
                        groupCount: groupCount,
                        useInsertIndex: true
                    });
                    if (this._currentTotalCount > 0 || isVirtualMode && totalCount === oldItemCount) {
                        this._skipCorrection += getItemCount() - oldItemCount
                    }
                    changes.splice(0, changes.length)
                },
                _handlePush: function(changes) {
                    this.push(changes, true)
                },
                _handleChanging: function(e) {
                    this.changing.fire(e);
                    this._applyBatch(e.changes)
                },
                _needCleanCacheByOperation: function(operationType, remoteOperations) {
                    var operationTypesByOrder = ["filtering", "sorting", "paging"];
                    var operationTypeIndex = operationTypesByOrder.indexOf(operationType);
                    var currentOperationTypes = operationTypeIndex >= 0 ? operationTypesByOrder.slice(operationTypeIndex) : [operationType];
                    return currentOperationTypes.some(function(operationType) {
                        return remoteOperations[operationType]
                    })
                },
                _customizeRemoteOperations: function(options, operationTypes) {
                    var that = this;
                    var cachedStoreData = that._cachedStoreData;
                    var cachedPagingData = that._cachedPagingData;
                    var cachedPagesData = that._cachedPagesData;
                    if (options.storeLoadOptions.filter && !options.remoteOperations.filtering || options.storeLoadOptions.sort && !options.remoteOperations.sorting) {
                        options.remoteOperations = {
                            filtering: options.remoteOperations.filtering
                        }
                    }
                    if (operationTypes.fullReload) {
                        cachedStoreData = void 0;
                        cachedPagingData = void 0;
                        cachedPagesData = createEmptyPagesData()
                    } else {
                        if (operationTypes.reload) {
                            cachedPagingData = void 0;
                            cachedPagesData = createEmptyPagesData()
                        } else {
                            if (operationTypes.take || operationTypes.groupExpanding) {
                                cachedPagesData = createEmptyPagesData()
                            }
                        }(0, _iterator.each)(operationTypes, function(operationType, value) {
                            if (value && that._needCleanCacheByOperation(operationType, options.remoteOperations)) {
                                cachedStoreData = void 0;
                                cachedPagingData = void 0
                            }
                        })
                    }
                    if (cachedPagingData) {
                        options.remoteOperations.paging = false
                    }
                    options.cachedStoreData = cachedStoreData;
                    options.cachedPagingData = cachedPagingData;
                    options.cachedPagesData = cachedPagesData;
                    if (!options.isCustomLoading) {
                        that._cachedStoreData = cachedStoreData;
                        that._cachedPagingData = cachedPagingData;
                        that._cachedPagesData = cachedPagesData
                    }
                },
                _handleDataLoading: function(options) {
                    var that = this;
                    var dataSource = that._dataSource;
                    var lastLoadOptions = that._lastLoadOptions;
                    that.customizeStoreLoadOptions.fire(options);
                    options.delay = this.option("loadingTimeout");
                    options.originalStoreLoadOptions = options.storeLoadOptions;
                    options.remoteOperations = (0, _extend.extend)({}, this.remoteOperations());
                    var isFullReload = !that.isLoaded() && !that._isRefreshing;
                    if (that.option("integrationOptions.renderedOnServer") && !that.isLoaded()) {
                        options.delay = void 0
                    }
                    var loadOptions = (0, _extend.extend)({
                        pageIndex: that.pageIndex()
                    }, options.storeLoadOptions);
                    var operationTypes = calculateOperationTypes(loadOptions, lastLoadOptions, isFullReload);
                    that._customizeRemoteOperations(options, operationTypes);
                    if (!options.isCustomLoading) {
                        var isRefreshing = that._isRefreshing;
                        options.pageIndex = dataSource.pageIndex();
                        options.lastLoadOptions = loadOptions;
                        options.operationTypes = operationTypes;
                        that._loadingOperationTypes = operationTypes;
                        that._isRefreshing = true;
                        (0, _deferred.when)(isRefreshing || that._isRefreshed || that.refresh(options, operationTypes)).done(function() {
                            if (that._lastOperationId === options.operationId) {
                                that._isRefreshed = true;
                                that.load().always(function() {
                                    that._isRefreshed = false
                                })
                            }
                        }).fail(function() {
                            dataSource.cancel(options.operationId)
                        }).always(function() {
                            that._isRefreshing = false
                        });
                        dataSource.cancel(that._lastOperationId);
                        that._lastOperationId = options.operationId;
                        if (that._isRefreshing) {
                            dataSource.cancel(that._lastOperationId)
                        }
                    }
                    this._handleDataLoadingCore(options)
                },
                _handleDataLoadingCore: function(options) {
                    var remoteOperations = options.remoteOperations;
                    options.loadOptions = {};
                    var cachedExtra = options.cachedPagesData.extra;
                    var localLoadOptionNames = {
                        filter: !remoteOperations.filtering,
                        sort: !remoteOperations.sorting,
                        group: !remoteOperations.grouping,
                        summary: !remoteOperations.summary,
                        skip: !remoteOperations.paging,
                        take: !remoteOperations.paging,
                        requireTotalCount: cachedExtra && "totalCount" in cachedExtra || !remoteOperations.paging
                    };
                    (0, _iterator.each)(options.storeLoadOptions, function(optionName, optionValue) {
                        if (localLoadOptionNames[optionName]) {
                            options.loadOptions[optionName] = optionValue;
                            delete options.storeLoadOptions[optionName]
                        }
                    });
                    if (cachedExtra) {
                        options.extra = cachedExtra
                    }
                    options.data = getPageDataFromCache(options) || options.cachedStoreData
                },
                _handleDataLoaded: function(options) {
                    var _this3 = this;
                    var loadOptions = options.loadOptions;
                    var localPaging = options.remoteOperations && !options.remoteOperations.paging;
                    var cachedPagesData = options.cachedPagesData;
                    var storeLoadOptions = options.storeLoadOptions;
                    var needCache = false !== this.option("cacheEnabled") && storeLoadOptions;
                    var needPageCache = needCache && !options.isCustomLoading && cachedPagesData && (!localPaging || storeLoadOptions.group) && !this.option("legacyRendering");
                    var needPagingCache = needCache && localPaging;
                    var needStoreCache = needPagingCache && !options.isCustomLoading;
                    if (!loadOptions) {
                        this._dataSource.cancel(options.operationId);
                        return
                    }
                    if (options.lastLoadOptions) {
                        this._lastLoadOptions = options.lastLoadOptions;
                        Object.keys(options.operationTypes).forEach(function(operationType) {
                            _this3._lastOperationTypes[operationType] = _this3._lastOperationTypes[operationType] || options.operationTypes[operationType]
                        })
                    }
                    if (localPaging) {
                        options.skip = loadOptions.skip;
                        options.take = loadOptions.take;
                        delete loadOptions.skip;
                        delete loadOptions.take
                    }
                    if (loadOptions.group) {
                        loadOptions.group = options.group || loadOptions.group
                    }
                    var groupCount = _uiData_grid.default.normalizeSortingInfo(storeLoadOptions.group || loadOptions.group).length;
                    if (!needPageCache || !getPageDataFromCache(options)) {
                        if (needPagingCache && options.cachedPagingData) {
                            options.data = cloneItems(options.cachedPagingData, groupCount)
                        } else {
                            if (needStoreCache) {
                                if (!this._cachedStoreData) {
                                    this._cachedStoreData = cloneItems(options.data, _uiData_grid.default.normalizeSortingInfo(storeLoadOptions.group).length)
                                } else {
                                    if (options.mergeStoreLoadData) {
                                        options.data = this._cachedStoreData = this._cachedStoreData.concat(options.data)
                                    }
                                }
                            }
                            new _array_store.default(options.data).load(loadOptions).done(function(data) {
                                options.data = data;
                                if (needStoreCache) {
                                    _this3._cachedPagingData = cloneItems(options.data, groupCount)
                                }
                            }).fail(function(error) {
                                options.data = (new _deferred.Deferred).reject(error)
                            })
                        }
                        if (loadOptions.requireTotalCount && localPaging) {
                            options.extra = (0, _type.isPlainObject)(options.extra) ? options.extra : {};
                            options.extra.totalCount = options.data.length
                        }
                        if (options.extra && options.extra.totalCount >= 0 && (false === storeLoadOptions.requireTotalCount || false === loadOptions.requireTotalCount)) {
                            options.extra.totalCount = -1
                        }
                        this._handleDataLoadedCore(options);
                        if (needPageCache) {
                            cachedPagesData.extra = cachedPagesData.extra || (0, _extend.extend)({}, options.extra);
                            (0, _deferred.when)(options.data).done(function(data) {
                                setPageDataToCache(options, cloneItems(data, groupCount))
                            })
                        }
                    }
                    options.storeLoadOptions = options.originalStoreLoadOptions
                },
                _handleDataLoadedCore: function(options) {
                    if (options.remoteOperations && !options.remoteOperations.paging && Array.isArray(options.data)) {
                        if (void 0 !== options.skip) {
                            options.data = options.data.slice(options.skip)
                        }
                        if (void 0 !== options.take) {
                            options.data = options.data.slice(0, options.take)
                        }
                    }
                },
                _handleLoadingChanged: function(isLoading) {
                    this.loadingChanged.fire(isLoading)
                },
                _handleLoadError: function(error) {
                    this.loadError.fire(error);
                    this.changed.fire({
                        changeType: "loadError",
                        error: error
                    })
                },
                _handleDataChanged: function(args) {
                    var that = this;
                    var currentTotalCount;
                    var dataSource = that._dataSource;
                    var isLoading = false;
                    var itemsCount = that.itemsCount();
                    that._isLastPage = !itemsCount || !that.pageSize() || itemsCount < that.pageSize();
                    if (that._isLastPage) {
                        that._hasLastPage = true
                    }
                    if (dataSource.totalCount() >= 0) {
                        if (dataSource.pageIndex() >= that.pageCount()) {
                            dataSource.pageIndex(that.pageCount() - 1);
                            that.pageIndex(dataSource.pageIndex());
                            that.resetPagesCache();
                            dataSource.load();
                            isLoading = true
                        }
                    } else {
                        if (!args || (0, _type.isDefined)(args.changeType)) {
                            currentTotalCount = dataSource.pageIndex() * that.pageSize() + itemsCount;
                            that._currentTotalCount = Math.max(that._currentTotalCount, currentTotalCount);
                            if (0 === itemsCount && dataSource.pageIndex() >= that.pageCount()) {
                                dataSource.pageIndex(that.pageCount() - 1);
                                if ("infinite" !== that.option("scrolling.mode")) {
                                    dataSource.load();
                                    isLoading = true
                                }
                            }
                        }
                    }
                    if (!isLoading) {
                        that._operationTypes = that._lastOperationTypes;
                        that._lastOperationTypes = {};
                        that.component._optionCache = {};
                        that.changed.fire(args);
                        that.component._optionCache = void 0
                    }
                },
                _scheduleCustomLoadCallbacks: function(deferred) {
                    var that = this;
                    that._isCustomLoading = true;
                    deferred.always(function() {
                        that._isCustomLoading = false
                    })
                },
                loadingOperationTypes: function() {
                    return this._loadingOperationTypes
                },
                operationTypes: function() {
                    return this._operationTypes
                },
                lastLoadOptions: function() {
                    return this._lastLoadOptions || {}
                },
                isLastPage: function() {
                    return this._isLastPage
                },
                totalCount: function() {
                    return parseInt((this._currentTotalCount || this._dataSource.totalCount()) + this._skipCorrection)
                },
                itemsCount: function() {
                    return this._dataSource.items().length
                },
                totalItemsCount: function() {
                    return this.totalCount()
                },
                pageSize: function() {
                    var dataSource = this._dataSource;
                    if (!arguments.length && !dataSource.paginate()) {
                        return 0
                    }
                    return dataSource.pageSize.apply(dataSource, arguments)
                },
                pageCount: function() {
                    var that = this;
                    var count = that.totalItemsCount() - that._skipCorrection;
                    var pageSize = that.pageSize();
                    if (pageSize && count > 0) {
                        return Math.max(1, Math.ceil(count / pageSize))
                    }
                    return 1
                },
                hasKnownLastPage: function() {
                    return this._hasLastPage || this._dataSource.totalCount() >= 0
                },
                loadFromStore: function(loadOptions, store) {
                    var dataSource = this._dataSource;
                    var d = new _deferred.Deferred;
                    if (!dataSource) {
                        return
                    }
                    store = store || dataSource.store();
                    store.load(loadOptions).done(function(data, extra) {
                        if (data && !Array.isArray(data) && Array.isArray(data.data)) {
                            extra = data;
                            data = data.data
                        }
                        d.resolve(data, extra)
                    }).fail(d.reject);
                    return d
                },
                isCustomLoading: function() {
                    return !!this._isCustomLoading
                },
                load: function(options) {
                    var _this4 = this;
                    var that = this;
                    var dataSource = that._dataSource;
                    var d = new _deferred.Deferred;
                    if (options) {
                        var store = dataSource.store();
                        var dataSourceLoadOptions = dataSource.loadOptions();
                        var loadResult = {
                            storeLoadOptions: options,
                            isCustomLoading: true
                        };
                        (0, _iterator.each)(store._customLoadOptions() || [], function(_, optionName) {
                            if (!(optionName in loadResult.storeLoadOptions)) {
                                loadResult.storeLoadOptions[optionName] = dataSourceLoadOptions[optionName]
                            }
                        });
                        this._isLoadingAll = options.isLoadingAll;
                        that._scheduleCustomLoadCallbacks(d);
                        dataSource._scheduleLoadCallbacks(d);
                        that._handleDataLoading(loadResult);
                        executeTask(function() {
                            if (!dataSource.store()) {
                                return d.reject("canceled")
                            }(0, _deferred.when)(loadResult.data || that.loadFromStore(loadResult.storeLoadOptions)).done(function(data, extra) {
                                loadResult.data = data;
                                loadResult.extra = extra || {};
                                that._handleDataLoaded(loadResult);
                                if (options.requireTotalCount && void 0 === loadResult.extra.totalCount) {
                                    loadResult.extra.totalCount = store.totalCount(loadResult.storeLoadOptions)
                                }(0, _deferred.when)(loadResult.data, loadResult.extra.totalCount).done(function(data, totalCount) {
                                    loadResult.extra.totalCount = totalCount;
                                    d.resolve(data, loadResult.extra)
                                }).fail(d.reject)
                            }).fail(d.reject)
                        }, that.option("loadingTimeout"));
                        return d.fail(function() {
                            that._eventsStrategy.fireEvent("loadError", arguments)
                        }).always(function() {
                            _this4._isLoadingAll = false
                        }).promise()
                    } else {
                        return dataSource.load()
                    }
                },
                reload: function(full) {
                    return full ? this._dataSource.reload() : this._dataSource.load()
                },
                getCachedStoreData: function() {
                    return this._cachedStoreData
                }
            }
        }());
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.data_controller.js ***!
      \*******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.modules */ 44));
        var _uiGrid_core2 = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.utils */ 35));
        var _array_store = _interopRequireDefault(__webpack_require__( /*! ../../data/array_store */ 77));
        var _custom_store = _interopRequireDefault(__webpack_require__( /*! ../../data/custom_store */ 130));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _data_helper = _interopRequireDefault(__webpack_require__( /*! ../../data_helper */ 92));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _array_compare = __webpack_require__( /*! ../../core/utils/array_compare */ 234);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = {
            defaultOptions: function() {
                return {
                    loadingTimeout: 0,
                    dataSource: null,
                    cacheEnabled: true,
                    repaintChangesOnly: false,
                    highlightChanges: false,
                    onDataErrorOccurred: null,
                    remoteOperations: "auto",
                    paging: {
                        enabled: true,
                        pageSize: void 0,
                        pageIndex: void 0
                    }
                }
            },
            controllers: {
                data: _uiGrid_core.default.Controller.inherit({}).include(_data_helper.default).inherit(function() {
                    var changePaging = function(that, optionName, value) {
                        var dataSource = that._dataSource;
                        if (dataSource) {
                            if (void 0 !== value) {
                                if (dataSource[optionName]() !== value) {
                                    if ("pageSize" === optionName) {
                                        dataSource.pageIndex(0)
                                    }
                                    dataSource[optionName](value);
                                    that._skipProcessingPagingChange = true;
                                    that.option("paging." + optionName, value);
                                    that._skipProcessingPagingChange = false;
                                    return dataSource["pageIndex" === optionName ? "load" : "reload"]().done(that.pageChanged.fire.bind(that.pageChanged))
                                }
                                return (0, _deferred.Deferred)().resolve().promise()
                            }
                            return dataSource[optionName]()
                        }
                        return 0
                    };
                    var members = {
                        init: function() {
                            var _this = this;
                            var that = this;
                            that._items = [];
                            that._columnsController = that.getController("columns");
                            that._currentOperationTypes = null;
                            that._dataChangedHandler = function(e) {
                                that._currentOperationTypes = _this._dataSource.operationTypes();
                                that._handleDataChanged(e);
                                that._currentOperationTypes = null
                            };
                            that._columnsChangedHandler = that._handleColumnsChanged.bind(that);
                            that._loadingChangedHandler = that._handleLoadingChanged.bind(that);
                            that._loadErrorHandler = that._handleLoadError.bind(that);
                            that._customizeStoreLoadOptionsHandler = that._handleCustomizeStoreLoadOptions.bind(that);
                            that._changingHandler = that._handleChanging.bind(that);
                            that._columnsController.columnsChanged.add(that._columnsChangedHandler);
                            that._isLoading = false;
                            that._isCustomLoading = false;
                            that._repaintChangesOnly = void 0;
                            that._changes = [];
                            that.createAction("onDataErrorOccurred");
                            that.dataErrorOccurred.add(function(error) {
                                return that.executeAction("onDataErrorOccurred", {
                                    error: error
                                })
                            });
                            that._refreshDataSource()
                        },
                        callbackNames: function() {
                            return ["changed", "loadingChanged", "dataErrorOccurred", "pageChanged", "dataSourceChanged"]
                        },
                        callbackFlags: function(name) {
                            if ("dataErrorOccurred" === name) {
                                return {
                                    stopOnFalse: true
                                }
                            }
                        },
                        publicMethods: function() {
                            return ["beginCustomLoading", "endCustomLoading", "refresh", "filter", "clearFilter", "getCombinedFilter", "keyOf", "byKey", "getDataByKeys", "pageIndex", "pageSize", "pageCount", "totalCount", "_disposeDataSource", "getKeyByRowIndex", "getRowIndexByKey", "getDataSource", "getVisibleRows", "repaintRows"]
                        },
                        reset: function() {
                            this._columnsController.reset();
                            this._items = [];
                            this._refreshDataSource()
                        },
                        optionChanged: function(args) {
                            var that = this;
                            var dataSource;

                            function handled() {
                                args.handled = true
                            }
                            if ("dataSource" === args.name && args.name === args.fullName && (args.value === args.previousValue || that.option("columns") && Array.isArray(args.value) && Array.isArray(args.previousValue))) {
                                if (args.value !== args.previousValue) {
                                    var store = that.store();
                                    if (store) {
                                        store._array = args.value
                                    }
                                }
                                handled();
                                that.refresh(that.option("repaintChangesOnly"));
                                return
                            }
                            switch (args.name) {
                                case "cacheEnabled":
                                case "repaintChangesOnly":
                                case "highlightChanges":
                                case "loadingTimeout":
                                    handled();
                                    break;
                                case "remoteOperations":
                                case "keyExpr":
                                case "dataSource":
                                case "scrolling":
                                    handled();
                                    that.reset();
                                    break;
                                case "paging":
                                    dataSource = that.dataSource();
                                    if (dataSource && that._setPagingOptions(dataSource)) {
                                        dataSource.load().done(that.pageChanged.fire.bind(that.pageChanged))
                                    }
                                    handled();
                                    break;
                                case "rtlEnabled":
                                    that.reset();
                                    break;
                                case "columns":
                                    dataSource = that.dataSource();
                                    if (dataSource && dataSource.isLoading() && args.name === args.fullName) {
                                        this._useSortingGroupingFromColumns = true;
                                        dataSource.load()
                                    }
                                    break;
                                default:
                                    that.callBase(args)
                            }
                        },
                        isReady: function() {
                            return !this._isLoading
                        },
                        getDataSource: function() {
                            return this._dataSource && this._dataSource._dataSource
                        },
                        getCombinedFilter: function(returnDataField) {
                            return this.combinedFilter(void 0, returnDataField)
                        },
                        combinedFilter: function(filter, returnDataField) {
                            var that = this;
                            var dataSource = that._dataSource;
                            var columnsController = that._columnsController;
                            if (dataSource) {
                                if (void 0 === filter) {
                                    filter = dataSource.filter()
                                }
                                var additionalFilter = that._calculateAdditionalFilter();
                                if (additionalFilter) {
                                    if (columnsController.isDataSourceApplied() || columnsController.isAllDataTypesDefined()) {
                                        filter = _uiGrid_core2.default.combineFilters([additionalFilter, filter])
                                    }
                                }
                                filter = columnsController.updateFilter(filter, returnDataField || dataSource.remoteOperations().filtering)
                            }
                            return filter
                        },
                        waitReady: function() {
                            if (this._updateLockCount) {
                                this._readyDeferred = new _deferred.Deferred;
                                return this._readyDeferred
                            }
                            return (0, _deferred.when)()
                        },
                        _endUpdateCore: function() {
                            var changes = this._changes;
                            if (changes.length) {
                                this._changes = [];
                                var repaintChangesOnly = changes.every(function(change) {
                                    return change.repaintChangesOnly
                                });
                                this.updateItems(1 === changes.length ? changes[0] : {
                                    repaintChangesOnly: repaintChangesOnly
                                })
                            }
                            if (this._readyDeferred) {
                                this._readyDeferred.resolve();
                                this._readyDeferred = null
                            }
                        },
                        _handleCustomizeStoreLoadOptions: function(e) {
                            var columnsController = this._columnsController;
                            var dataSource = this._dataSource;
                            var storeLoadOptions = e.storeLoadOptions;
                            if (e.isCustomLoading && !storeLoadOptions.isLoadingAll) {
                                return
                            }
                            storeLoadOptions.filter = this.combinedFilter(storeLoadOptions.filter);
                            if (!columnsController.isDataSourceApplied()) {
                                columnsController.updateColumnDataTypes(dataSource)
                            }
                            this._columnsUpdating = true;
                            columnsController.updateSortingGrouping(dataSource, !this._useSortingGroupingFromColumns);
                            this._columnsUpdating = false;
                            storeLoadOptions.sort = columnsController.getSortDataSourceParameters();
                            storeLoadOptions.group = columnsController.getGroupDataSourceParameters();
                            dataSource.sort(storeLoadOptions.sort);
                            dataSource.group(storeLoadOptions.group);
                            storeLoadOptions.sort = columnsController.getSortDataSourceParameters(!dataSource.remoteOperations().sorting);
                            e.group = columnsController.getGroupDataSourceParameters(!dataSource.remoteOperations().grouping)
                        },
                        _handleColumnsChanged: function(e) {
                            var that = this;
                            var changeTypes = e.changeTypes;
                            var optionNames = e.optionNames;
                            var filterValue;
                            var filterValues;
                            var filterApplied;
                            var updateItemsHandler = function updateItemsHandler() {
                                that._columnsController.columnsChanged.remove(updateItemsHandler);
                                that.updateItems()
                            };
                            if (changeTypes.sorting || changeTypes.grouping) {
                                if (that._dataSource && !that._columnsUpdating) {
                                    that._dataSource.group(that._columnsController.getGroupDataSourceParameters());
                                    that._dataSource.sort(that._columnsController.getSortDataSourceParameters());
                                    that.reload()
                                }
                            } else {
                                if (changeTypes.columns) {
                                    if (optionNames.filterValues || optionNames.filterValue || optionNames.selectedFilterOperation) {
                                        filterValue = that._columnsController.columnOption(e.columnIndex, "filterValue");
                                        filterValues = that._columnsController.columnOption(e.columnIndex, "filterValues");
                                        if (Array.isArray(filterValues) || void 0 === e.columnIndex || (0, _type.isDefined)(filterValue) || !optionNames.selectedFilterOperation || optionNames.filterValue) {
                                            that._applyFilter();
                                            filterApplied = true
                                        }
                                    }
                                    if (!that._needApplyFilter && !_uiGrid_core2.default.checkChanges(optionNames, ["width", "visibleWidth", "filterValue", "bufferedFilterValue", "selectedFilterOperation", "filterValues", "filterType"])) {
                                        that._columnsController.columnsChanged.add(updateItemsHandler)
                                    }
                                    if ((0, _type.isDefined)(optionNames.visible)) {
                                        var column = that._columnsController.columnOption(e.columnIndex);
                                        if (column && ((0, _type.isDefined)(column.filterValue) || (0, _type.isDefined)(column.filterValues))) {
                                            that._applyFilter();
                                            filterApplied = true
                                        }
                                    }
                                }
                            }
                            if (!filterApplied && changeTypes.filtering) {
                                that.reload()
                            }
                        },
                        _handleDataChanged: function(e) {
                            var that = this;
                            var dataSource = that._dataSource;
                            var columnsController = that._columnsController;
                            var isAsyncDataSourceApplying = false;
                            this._useSortingGroupingFromColumns = false;
                            if (dataSource && !that._isDataSourceApplying) {
                                that._isDataSourceApplying = true;
                                (0, _deferred.when)(that._columnsController.applyDataSource(dataSource)).done(function() {
                                    if (that._isLoading) {
                                        that._handleLoadingChanged(false)
                                    }
                                    if (isAsyncDataSourceApplying && e && e.isDelayed) {
                                        e.isDelayed = false
                                    }
                                    that._isDataSourceApplying = false;
                                    var hasAdditionalFilter = function() {
                                        var additionalFilter = that._calculateAdditionalFilter();
                                        return additionalFilter && additionalFilter.length
                                    };
                                    var needApplyFilter = that._needApplyFilter;
                                    that._needApplyFilter = false;
                                    if (needApplyFilter && !that._isAllDataTypesDefined && hasAdditionalFilter()) {
                                        _ui.default.log("W1005", that.component.NAME);
                                        that._applyFilter()
                                    } else {
                                        that.updateItems(e, true)
                                    }
                                }).fail(function() {
                                    that._isDataSourceApplying = false
                                });
                                if (that._isDataSourceApplying) {
                                    isAsyncDataSourceApplying = true;
                                    that._handleLoadingChanged(true)
                                }
                                that._needApplyFilter = !that._columnsController.isDataSourceApplied();
                                that._isAllDataTypesDefined = columnsController.isAllDataTypesDefined()
                            }
                        },
                        _handleLoadingChanged: function(isLoading) {
                            this._isLoading = isLoading;
                            this._fireLoadingChanged()
                        },
                        _handleLoadError: function(e) {
                            this.dataErrorOccurred.fire(e)
                        },
                        fireError: function() {
                            this.dataErrorOccurred.fire(_ui.default.Error.apply(_ui.default, arguments))
                        },
                        _setPagingOptions: function(dataSource) {
                            var pageIndex = this.option("paging.pageIndex");
                            var pageSize = this.option("paging.pageSize");
                            var pagingEnabled = this.option("paging.enabled");
                            var scrollingMode = this.option("scrolling.mode");
                            var appendMode = "infinite" === scrollingMode;
                            var virtualMode = "virtual" === scrollingMode;
                            var paginate = pagingEnabled || virtualMode || appendMode;
                            var isChanged = false;
                            dataSource.requireTotalCount(!appendMode);
                            if (void 0 !== pagingEnabled && dataSource.paginate() !== paginate) {
                                dataSource.paginate(paginate);
                                isChanged = true
                            }
                            if (void 0 !== pageSize && dataSource.pageSize() !== pageSize) {
                                dataSource.pageSize(pageSize);
                                isChanged = true
                            }
                            if (void 0 !== pageIndex && dataSource.pageIndex() !== pageIndex) {
                                dataSource.pageIndex(pageIndex);
                                isChanged = true
                            }
                            return isChanged
                        },
                        _getSpecificDataSourceOption: function() {
                            var dataSource = this.option("dataSource");
                            if (Array.isArray(dataSource)) {
                                return {
                                    store: {
                                        type: "array",
                                        data: dataSource,
                                        key: this.option("keyExpr")
                                    }
                                }
                            }
                            return dataSource
                        },
                        _initDataSource: function() {
                            var that = this;
                            var dataSource = this.option("dataSource");
                            var oldDataSource = this._dataSource;
                            that.callBase();
                            dataSource = that._dataSource;
                            that._useSortingGroupingFromColumns = true;
                            if (dataSource) {
                                that._setPagingOptions(dataSource);
                                that.setDataSource(dataSource)
                            } else {
                                if (oldDataSource) {
                                    that.updateItems()
                                }
                            }
                        },
                        _loadDataSource: function() {
                            var that = this;
                            var dataSource = that._dataSource;
                            var result = new _deferred.Deferred;
                            (0, _deferred.when)(this._columnsController.refresh(true)).always(function() {
                                if (dataSource) {
                                    dataSource.load().done(result.resolve).fail(result.reject)
                                } else {
                                    result.resolve()
                                }
                            });
                            return result.promise()
                        },
                        _beforeProcessItems: function(items) {
                            return items.slice(0)
                        },
                        getRowIndexDelta: function() {
                            return 0
                        },
                        _processItems: function(items, change) {
                            var that = this;
                            var rowIndexDelta = that.getRowIndexDelta();
                            var changeType = change.changeType;
                            var visibleColumns = that._columnsController.getVisibleColumns(null, "loadingAll" === changeType);
                            var visibleItems = that._items;
                            var lastVisibleItem = "append" === changeType && visibleItems.length > 0 ? visibleItems[visibleItems.length - 1] : null;
                            var dataIndex = (0, _type.isDefined)(null === lastVisibleItem || void 0 === lastVisibleItem ? void 0 : lastVisibleItem.dataIndex) ? lastVisibleItem.dataIndex + 1 : 0;
                            var options = {
                                visibleColumns: visibleColumns,
                                dataIndex: dataIndex
                            };
                            var result = [];
                            (0, _iterator.each)(items, function(index, item) {
                                if ((0, _type.isDefined)(item)) {
                                    options.rowIndex = index - rowIndexDelta;
                                    item = that._processItem(item, options);
                                    result.push(item)
                                }
                            });
                            return result
                        },
                        _processItem: function(item, options) {
                            item = this._generateDataItem(item, options);
                            item = this._processDataItem(item, options);
                            item.dataIndex = options.dataIndex++;
                            return item
                        },
                        _generateDataItem: function(data) {
                            return {
                                rowType: "data",
                                data: data,
                                key: this.keyOf(data)
                            }
                        },
                        _processDataItem: function(dataItem, options) {
                            dataItem.values = this.generateDataValues(dataItem.data, options.visibleColumns);
                            return dataItem
                        },
                        generateDataValues: function(data, columns, isModified) {
                            var values = [];
                            var value;
                            for (var i = 0; i < columns.length; i++) {
                                var column = columns[i];
                                value = isModified ? void 0 : null;
                                if (!column.command) {
                                    if (column.calculateCellValue) {
                                        value = column.calculateCellValue(data)
                                    } else {
                                        if (column.dataField) {
                                            value = data[column.dataField]
                                        }
                                    }
                                }
                                values.push(value)
                            }
                            return values
                        },
                        _applyChange: function(change) {
                            var that = this;
                            if ("update" === change.changeType) {
                                that._applyChangeUpdate(change)
                            } else {
                                if (that.items().length && change.repaintChangesOnly && "refresh" === change.changeType) {
                                    that._applyChangesOnly(change)
                                } else {
                                    if ("refresh" === change.changeType) {
                                        that._applyChangeFull(change)
                                    }
                                }
                            }
                        },
                        _applyChangeFull: function(change) {
                            this._items = change.items.slice(0)
                        },
                        _getRowIndices: function(change) {
                            var rowIndices = change.rowIndices.slice(0);
                            var rowIndexDelta = this.getRowIndexDelta();
                            rowIndices.sort(function(a, b) {
                                return a - b
                            });
                            for (var i = 0; i < rowIndices.length; i++) {
                                var correctedRowIndex = rowIndices[i];
                                if (change.allowInvisibleRowIndices) {
                                    correctedRowIndex += rowIndexDelta
                                }
                                if (correctedRowIndex < 0) {
                                    rowIndices.splice(i, 1);
                                    i--
                                }
                            }
                            return rowIndices
                        },
                        _applyChangeUpdate: function(change) {
                            var that = this;
                            var items = change.items;
                            var rowIndices = that._getRowIndices(change);
                            var rowIndexDelta = that.getRowIndexDelta();
                            var repaintChangesOnly = that.option("repaintChangesOnly");
                            var prevIndex = -1;
                            var rowIndexCorrection = 0;
                            var changeType;
                            change.items = [];
                            change.rowIndices = [];
                            change.columnIndices = [];
                            change.changeTypes = [];
                            var equalItems = function(item1, item2, strict) {
                                var result = item1 && item2 && (0, _common.equalByValue)(item1.key, item2.key);
                                if (result && strict) {
                                    result = item1.rowType === item2.rowType && ("detail" !== item2.rowType || item1.isEditing === item2.isEditing)
                                }
                                return result
                            };
                            (0, _iterator.each)(rowIndices, function(index, rowIndex) {
                                var columnIndices;
                                rowIndex += rowIndexCorrection + rowIndexDelta;
                                if (prevIndex === rowIndex) {
                                    return
                                }
                                prevIndex = rowIndex;
                                var oldItem = that._items[rowIndex];
                                var oldNextItem = that._items[rowIndex + 1];
                                var newItem = items[rowIndex];
                                var newNextItem = items[rowIndex + 1];
                                var strict = equalItems(oldItem, oldNextItem) || equalItems(newItem, newNextItem);
                                if (newItem) {
                                    newItem.rowIndex = rowIndex;
                                    change.items.push(newItem)
                                }
                                if (oldItem && newItem && equalItems(oldItem, newItem, strict)) {
                                    changeType = "update";
                                    that._items[rowIndex] = newItem;
                                    if (oldItem.visible !== newItem.visible) {
                                        change.items.splice(-1, 1, {
                                            visible: newItem.visible
                                        })
                                    } else {
                                        if (repaintChangesOnly && !change.isFullUpdate) {
                                            columnIndices = that._partialUpdateRow(oldItem, newItem, rowIndex - rowIndexDelta)
                                        }
                                    }
                                } else {
                                    if (newItem && !oldItem || newNextItem && equalItems(oldItem, newNextItem, strict)) {
                                        changeType = "insert";
                                        that._items.splice(rowIndex, 0, newItem);
                                        rowIndexCorrection++
                                    } else {
                                        if (oldItem && !newItem || oldNextItem && equalItems(newItem, oldNextItem, strict)) {
                                            changeType = "remove";
                                            that._items.splice(rowIndex, 1);
                                            rowIndexCorrection--;
                                            prevIndex = -1
                                        } else {
                                            if (newItem) {
                                                changeType = "update";
                                                that._items[rowIndex] = newItem
                                            } else {
                                                return
                                            }
                                        }
                                    }
                                }
                                change.rowIndices.push(rowIndex - rowIndexDelta);
                                change.changeTypes.push(changeType);
                                change.columnIndices.push(columnIndices)
                            })
                        },
                        _isCellChanged: function(oldRow, newRow, visibleRowIndex, columnIndex, isLiveUpdate) {
                            if (JSON.stringify(oldRow.values[columnIndex]) !== JSON.stringify(newRow.values[columnIndex])) {
                                return true
                            }

                            function isCellModified(row, columnIndex) {
                                return row.modifiedValues ? void 0 !== row.modifiedValues[columnIndex] : false
                            }
                            if (isCellModified(oldRow, columnIndex) !== isCellModified(newRow, columnIndex)) {
                                return true
                            }
                            return false
                        },
                        _getChangedColumnIndices: function(oldItem, newItem, visibleRowIndex, isLiveUpdate) {
                            if (oldItem.rowType === newItem.rowType && "group" !== newItem.rowType && "groupFooter" !== newItem.rowType) {
                                var columnIndices = [];
                                if ("detail" !== newItem.rowType) {
                                    for (var columnIndex = 0; columnIndex < oldItem.values.length; columnIndex++) {
                                        if (this._isCellChanged(oldItem, newItem, visibleRowIndex, columnIndex, isLiveUpdate)) {
                                            columnIndices.push(columnIndex)
                                        }
                                    }
                                }
                                return columnIndices
                            }
                        },
                        _partialUpdateRow: function(oldItem, newItem, visibleRowIndex, isLiveUpdate) {
                            var changedColumnIndices = this._getChangedColumnIndices(oldItem, newItem, visibleRowIndex, isLiveUpdate);
                            if (changedColumnIndices) {
                                oldItem.cells && oldItem.cells.forEach(function(cell, columnIndex) {
                                    var isCellChanged = changedColumnIndices.indexOf(columnIndex) >= 0;
                                    if (!isCellChanged && cell && cell.update) {
                                        cell.update(newItem)
                                    }
                                });
                                newItem.update = oldItem.update;
                                newItem.watch = oldItem.watch;
                                newItem.cells = oldItem.cells;
                                if (isLiveUpdate) {
                                    newItem.oldValues = oldItem.values
                                }
                                oldItem.update && oldItem.update(newItem)
                            }
                            return changedColumnIndices
                        },
                        _isItemEquals: function(item1, item2) {
                            if (JSON.stringify(item1.values) !== JSON.stringify(item2.values)) {
                                return false
                            }
                            var compareFields = ["modified", "isNewRow", "removed", "isEditing"];
                            if (compareFields.some(function(field) {
                                    return item1[field] !== item2[field]
                                })) {
                                return false
                            }
                            if ("group" === item1.rowType || "groupFooter" === item1.rowType) {
                                var _item1$data, _item2$data, _item1$data2, _item2$data2;
                                var expandedMatch = item1.isExpanded === item2.isExpanded;
                                var summaryCellsMatch = JSON.stringify(item1.summaryCells) === JSON.stringify(item2.summaryCells);
                                var continuationMatch = (null === (_item1$data = item1.data) || void 0 === _item1$data ? void 0 : _item1$data.isContinuation) === (null === (_item2$data = item2.data) || void 0 === _item2$data ? void 0 : _item2$data.isContinuation) && (null === (_item1$data2 = item1.data) || void 0 === _item1$data2 ? void 0 : _item1$data2.isContinuationOnNextPage) === (null === (_item2$data2 = item2.data) || void 0 === _item2$data2 ? void 0 : _item2$data2.isContinuationOnNextPage);
                                if (!expandedMatch || !summaryCellsMatch || !continuationMatch) {
                                    return false
                                }
                            }
                            return true
                        },
                        _applyChangesOnly: function(change) {
                            var _this2 = this;
                            var rowIndices = [];
                            var columnIndices = [];
                            var changeTypes = [];
                            var items = [];
                            var newIndexByKey = {};

                            function getRowKey(row) {
                                if (row) {
                                    return row.rowType + "," + JSON.stringify(row.key)
                                }
                            }
                            var isItemEquals = function(item1, item2) {
                                if (!_this2._isItemEquals(item1, item2)) {
                                    return false
                                }
                                if (item1.cells) {
                                    item1.update && item1.update(item2);
                                    item1.cells.forEach(function(cell) {
                                        if (cell && cell.update) {
                                            cell.update(item2)
                                        }
                                    })
                                }
                                return true
                            };
                            var oldItems = this._items.slice();
                            change.items.forEach(function(item, index) {
                                var key = getRowKey(item);
                                newIndexByKey[key] = index;
                                item.rowIndex = index
                            });
                            var result = (0, _array_compare.findChanges)(oldItems, change.items, getRowKey, isItemEquals);
                            if (!result) {
                                this._applyChangeFull(change);
                                return
                            }
                            result.forEach(function(change) {
                                switch (change.type) {
                                    case "update":
                                        var index = change.index;
                                        var newItem = change.data;
                                        var oldItem = change.oldItem;
                                        var changedColumnIndices = _this2._partialUpdateRow(oldItem, newItem, index, true);
                                        rowIndices.push(index);
                                        changeTypes.push("update");
                                        items.push(newItem);
                                        _this2._items[index] = newItem;
                                        columnIndices.push(changedColumnIndices);
                                        break;
                                    case "insert":
                                        rowIndices.push(change.index);
                                        changeTypes.push("insert");
                                        items.push(change.data);
                                        columnIndices.push(void 0);
                                        _this2._items.splice(change.index, 0, change.data);
                                        break;
                                    case "remove":
                                        rowIndices.push(change.index);
                                        changeTypes.push("remove");
                                        _this2._items.splice(change.index, 1);
                                        items.push(change.oldItem);
                                        columnIndices.push(void 0)
                                }
                            });
                            change.repaintChangesOnly = true;
                            change.changeType = "update";
                            change.rowIndices = rowIndices;
                            change.columnIndices = columnIndices;
                            change.changeTypes = changeTypes;
                            change.items = items;
                            if (oldItems.length) {
                                change.isLiveUpdate = true
                            }
                            this._correctRowIndices(function(rowIndex) {
                                var oldItem = oldItems[rowIndex];
                                var key = getRowKey(oldItem);
                                var newRowIndex = newIndexByKey[key];
                                return newRowIndex >= 0 ? newRowIndex - rowIndex : 0
                            })
                        },
                        _correctRowIndices: _common.noop,
                        _updateItemsCore: function(change) {
                            var that = this;
                            var items;
                            var dataSource = that._dataSource;
                            var changeType = change.changeType || "refresh";
                            change.changeType = changeType;
                            if (dataSource) {
                                items = change.items || dataSource.items();
                                items = that._beforeProcessItems(items);
                                items = that._processItems(items, change);
                                change.items = items;
                                var oldItems = that._items.length === items.length && that._items;
                                that._applyChange(change);
                                var rowIndexDelta = that.getRowIndexDelta();
                                (0, _iterator.each)(that._items, function(index, item) {
                                    item.rowIndex = index - rowIndexDelta;
                                    if (oldItems) {
                                        item.cells = oldItems[index].cells || []
                                    }
                                })
                            } else {
                                that._items = []
                            }
                        },
                        _handleChanging: function(e) {
                            var that = this;
                            var rows = that.getVisibleRows();
                            var dataSource = that.dataSource();
                            if (dataSource) {
                                e.changes.forEach(function(change) {
                                    if ("insert" === change.type && change.index >= 0) {
                                        var dataIndex = 0;
                                        for (var i = 0; i < change.index; i++) {
                                            var row = rows[i];
                                            if (row && ("data" === row.rowType || "group" === row.rowType)) {
                                                dataIndex++
                                            }
                                        }
                                        change.index = dataIndex
                                    }
                                })
                            }
                        },
                        updateItems: function(change, isDataChanged) {
                            change = change || {};
                            var that = this;
                            if (void 0 !== that._repaintChangesOnly) {
                                change.repaintChangesOnly = that._repaintChangesOnly
                            } else {
                                if (change.changes) {
                                    change.repaintChangesOnly = that.option("repaintChangesOnly")
                                } else {
                                    if (isDataChanged) {
                                        var operationTypes = that.dataSource().operationTypes();
                                        change.repaintChangesOnly = operationTypes && !operationTypes.grouping && !operationTypes.filtering && that.option("repaintChangesOnly");
                                        change.isDataChanged = true;
                                        if (operationTypes && (operationTypes.reload || operationTypes.paging || operationTypes.groupExpanding)) {
                                            change.needUpdateDimensions = true
                                        }
                                    }
                                }
                            }
                            if (that._updateLockCount) {
                                that._changes.push(change);
                                return
                            }
                            that._updateItemsCore(change);
                            if (change.cancel) {
                                return
                            }
                            that._fireChanged(change)
                        },
                        loadingOperationTypes: function() {
                            var dataSource = this.dataSource();
                            return dataSource && dataSource.loadingOperationTypes() || {}
                        },
                        _fireChanged: function(change) {
                            var _this3 = this;
                            if (this._currentOperationTypes) {
                                change.operationTypes = this._currentOperationTypes;
                                this._currentOperationTypes = null
                            }(0, _common.deferRender)(function() {
                                _this3.changed.fire(change)
                            })
                        },
                        isLoading: function() {
                            return this._isLoading || this._isCustomLoading
                        },
                        _fireLoadingChanged: function() {
                            this.loadingChanged.fire(this.isLoading(), this._loadingText)
                        },
                        _calculateAdditionalFilter: function() {
                            return null
                        },
                        _applyFilter: function() {
                            var that = this;
                            var dataSource = that._dataSource;
                            if (dataSource) {
                                dataSource.pageIndex(0);
                                return that.reload().done(that.pageChanged.fire.bind(that.pageChanged))
                            }
                        },
                        filter: function filter(filterExpr) {
                            var dataSource = this._dataSource;
                            var filter = dataSource && dataSource.filter();
                            if (0 === arguments.length) {
                                return filter
                            }
                            filterExpr = arguments.length > 1 ? Array.prototype.slice.call(arguments, 0) : filterExpr;
                            if (_uiGrid_core2.default.equalFilterParameters(filter, filterExpr)) {
                                return
                            }
                            if (dataSource) {
                                dataSource.filter(filterExpr)
                            }
                            this._applyFilter()
                        },
                        clearFilter: function(filterName) {
                            var that = this;
                            var columnsController = that._columnsController;
                            var clearColumnOption = function(optionName) {
                                var columnCount = columnsController.columnCount();
                                for (var index = 0; index < columnCount; index++) {
                                    columnsController.columnOption(index, optionName, void 0)
                                }
                            };
                            that.component.beginUpdate();
                            if (arguments.length > 0) {
                                switch (filterName) {
                                    case "dataSource":
                                        that.filter(null);
                                        break;
                                    case "search":
                                        that.searchByText("");
                                        break;
                                    case "header":
                                        clearColumnOption("filterValues");
                                        break;
                                    case "row":
                                        clearColumnOption("filterValue")
                                }
                            } else {
                                that.filter(null);
                                that.searchByText("");
                                clearColumnOption("filterValue");
                                clearColumnOption("bufferedFilterValue");
                                clearColumnOption("filterValues")
                            }
                            that.component.endUpdate()
                        },
                        _fireDataSourceChanged: function() {
                            var that = this;
                            var changedHandler = function changedHandler() {
                                that.changed.remove(changedHandler);
                                that.dataSourceChanged.fire()
                            };
                            that.changed.add(changedHandler)
                        },
                        _getDataSourceAdapter: _common.noop,
                        _createDataSourceAdapterCore: function(dataSource, remoteOperations) {
                            var dataSourceAdapterProvider = this._getDataSourceAdapter();
                            var dataSourceAdapter = dataSourceAdapterProvider.create(this.component);
                            dataSourceAdapter.init(dataSource, remoteOperations);
                            return dataSourceAdapter
                        },
                        isLocalStore: function(store) {
                            store = store || this.store();
                            return store instanceof _array_store.default
                        },
                        isCustomStore: function(store) {
                            store = store || this.store();
                            return store instanceof _custom_store.default
                        },
                        _createDataSourceAdapter: function(dataSource) {
                            var remoteOperations = this.option("remoteOperations");
                            var store = dataSource.store();
                            var enabledRemoteOperations = {
                                filtering: true,
                                sorting: true,
                                paging: true,
                                grouping: true,
                                summary: true
                            };
                            if (remoteOperations && remoteOperations.groupPaging) {
                                remoteOperations = (0, _extend.extend)({}, enabledRemoteOperations, remoteOperations)
                            }
                            if ("auto" === remoteOperations) {
                                remoteOperations = this.isLocalStore(store) || this.isCustomStore(store) ? {} : {
                                    filtering: true,
                                    sorting: true,
                                    paging: true
                                }
                            }
                            if (true === remoteOperations) {
                                remoteOperations = enabledRemoteOperations
                            }
                            return this._createDataSourceAdapterCore(dataSource, remoteOperations)
                        },
                        setDataSource: function(dataSource) {
                            var that = this;
                            var oldDataSource = that._dataSource;
                            if (!dataSource && oldDataSource) {
                                oldDataSource.cancelAll();
                                oldDataSource.changed.remove(that._dataChangedHandler);
                                oldDataSource.loadingChanged.remove(that._loadingChangedHandler);
                                oldDataSource.loadError.remove(that._loadErrorHandler);
                                oldDataSource.customizeStoreLoadOptions.remove(that._customizeStoreLoadOptionsHandler);
                                oldDataSource.changing.remove(that._changingHandler);
                                oldDataSource.dispose(that._isSharedDataSource)
                            }
                            if (dataSource) {
                                dataSource = that._createDataSourceAdapter(dataSource)
                            }
                            that._dataSource = dataSource;
                            if (dataSource) {
                                that._fireDataSourceChanged();
                                that._isLoading = !dataSource.isLoaded();
                                that._needApplyFilter = true;
                                that._isAllDataTypesDefined = that._columnsController.isAllDataTypesDefined();
                                dataSource.changed.add(that._dataChangedHandler);
                                dataSource.loadingChanged.add(that._loadingChangedHandler);
                                dataSource.loadError.add(that._loadErrorHandler);
                                dataSource.customizeStoreLoadOptions.add(that._customizeStoreLoadOptionsHandler);
                                dataSource.changing.add(that._changingHandler)
                            }
                        },
                        items: function() {
                            return this._items
                        },
                        isEmpty: function() {
                            return !this.items().length
                        },
                        pageCount: function() {
                            return this._dataSource ? this._dataSource.pageCount() : 1
                        },
                        dataSource: function() {
                            return this._dataSource
                        },
                        store: function() {
                            var dataSource = this._dataSource;
                            return dataSource && dataSource.store()
                        },
                        loadAll: function(data) {
                            var that = this;
                            var d = new _deferred.Deferred;
                            var dataSource = that._dataSource;
                            if (dataSource) {
                                if (data) {
                                    var options = {
                                        data: data,
                                        isCustomLoading: true,
                                        storeLoadOptions: {
                                            isLoadingAll: true
                                        },
                                        loadOptions: {
                                            filter: that.getCombinedFilter(),
                                            group: dataSource.group(),
                                            sort: dataSource.sort()
                                        }
                                    };
                                    dataSource._handleDataLoaded(options);
                                    (0, _deferred.when)(options.data).done(function(data) {
                                        data = that._beforeProcessItems(data);
                                        d.resolve(that._processItems(data, {
                                            changeType: "loadingAll"
                                        }), options.extra && options.extra.summary)
                                    }).fail(d.reject)
                                } else {
                                    if (!dataSource.isLoading()) {
                                        var loadOptions = (0, _extend.extend)({}, dataSource.loadOptions(), {
                                            isLoadingAll: true,
                                            requireTotalCount: false
                                        });
                                        dataSource.load(loadOptions).done(function(items, extra) {
                                            items = that._beforeProcessItems(items);
                                            items = that._processItems(items, {
                                                changeType: "loadingAll"
                                            });
                                            d.resolve(items, extra && extra.summary)
                                        }).fail(d.reject)
                                    } else {
                                        d.reject()
                                    }
                                }
                            } else {
                                d.resolve([])
                            }
                            return d
                        },
                        getKeyByRowIndex: function(rowIndex, byLoaded) {
                            var item = this.items(byLoaded)[rowIndex];
                            if (item) {
                                return item.key
                            }
                        },
                        getRowIndexByKey: function(key, byLoaded) {
                            return _uiGrid_core2.default.getIndexByKey(key, this.items(byLoaded))
                        },
                        keyOf: function(data) {
                            var store = this.store();
                            if (store) {
                                return store.keyOf(data)
                            }
                        },
                        byKey: function(key) {
                            var store = this.store();
                            var rowIndex = this.getRowIndexByKey(key);
                            var result;
                            if (!store) {
                                return
                            }
                            if (rowIndex >= 0) {
                                result = (new _deferred.Deferred).resolve(this.items()[rowIndex].data)
                            }
                            return result || store.byKey(key)
                        },
                        key: function() {
                            var store = this.store();
                            if (store) {
                                return store.key()
                            }
                        },
                        getRowIndexOffset: function() {
                            return 0
                        },
                        getDataByKeys: function(rowKeys) {
                            var that = this;
                            var result = new _deferred.Deferred;
                            var deferreds = [];
                            var data = [];
                            (0, _iterator.each)(rowKeys, function(index, key) {
                                deferreds.push(that.byKey(key).done(function(keyData) {
                                    data[index] = keyData
                                }))
                            });
                            _deferred.when.apply(_renderer.default, deferreds).always(function() {
                                result.resolve(data)
                            });
                            return result
                        },
                        pageIndex: function(value) {
                            return changePaging(this, "pageIndex", value)
                        },
                        pageSize: function(value) {
                            return changePaging(this, "pageSize", value)
                        },
                        beginCustomLoading: function(messageText) {
                            this._isCustomLoading = true;
                            this._loadingText = messageText || "";
                            this._fireLoadingChanged()
                        },
                        endCustomLoading: function() {
                            this._isCustomLoading = false;
                            this._loadingText = void 0;
                            this._fireLoadingChanged()
                        },
                        refresh: function(options) {
                            if (true === options) {
                                options = {
                                    reload: true,
                                    changesOnly: true
                                }
                            } else {
                                if (!options) {
                                    options = {
                                        lookup: true,
                                        selection: true,
                                        reload: true
                                    }
                                }
                            }
                            var that = this;
                            var dataSource = that.getDataSource();
                            var changesOnly = options.changesOnly;
                            var d = new _deferred.Deferred;
                            var customizeLoadResult = function() {
                                that._repaintChangesOnly = !!changesOnly
                            };
                            (0, _deferred.when)(!options.lookup || that._columnsController.refresh()).always(function() {
                                if (options.load || options.reload) {
                                    dataSource && dataSource.on("customizeLoadResult", customizeLoadResult);
                                    (0, _deferred.when)(that.reload(options.reload, changesOnly)).always(function() {
                                        dataSource && dataSource.off("customizeLoadResult", customizeLoadResult);
                                        that._repaintChangesOnly = void 0
                                    }).done(d.resolve).fail(d.reject)
                                } else {
                                    that.updateItems({
                                        repaintChangesOnly: options.changesOnly
                                    });
                                    d.resolve()
                                }
                            });
                            return d.promise()
                        },
                        getVisibleRows: function() {
                            return this.items()
                        },
                        _disposeDataSource: function() {
                            this.setDataSource(null)
                        },
                        dispose: function() {
                            this._disposeDataSource();
                            this.callBase.apply(this, arguments)
                        },
                        repaintRows: function(rowIndexes, changesOnly) {
                            rowIndexes = Array.isArray(rowIndexes) ? rowIndexes : [rowIndexes];
                            if (rowIndexes.length > 1 || (0, _type.isDefined)(rowIndexes[0])) {
                                this.updateItems({
                                    changeType: "update",
                                    rowIndices: rowIndexes,
                                    isFullUpdate: !changesOnly
                                })
                            }
                        },
                        skipProcessingPagingChange: function(fullName) {
                            return this._skipProcessingPagingChange && ("paging.pageIndex" === fullName || "paging.pageSize" === fullName)
                        },
                        getUserState: function() {
                            return {
                                searchText: this.option("searchPanel.text"),
                                pageIndex: this.pageIndex(),
                                pageSize: this.pageSize()
                            }
                        },
                        getCachedStoreData: function() {
                            return this._dataSource && this._dataSource.getCachedStoreData()
                        }
                    };
                    _uiGrid_core2.default.proxyMethod(members, "load");
                    _uiGrid_core2.default.proxyMethod(members, "reload");
                    _uiGrid_core2.default.proxyMethod(members, "push");
                    _uiGrid_core2.default.proxyMethod(members, "itemsCount", 0);
                    _uiGrid_core2.default.proxyMethod(members, "totalItemsCount", 0);
                    _uiGrid_core2.default.proxyMethod(members, "hasKnownLastPage", true);
                    _uiGrid_core2.default.proxyMethod(members, "isLoaded", true);
                    _uiGrid_core2.default.proxyMethod(members, "totalCount", 0);
                    return members
                }())
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.sorting.js ***!
      \***********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _click = __webpack_require__( /*! ../../events/click */ 21);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.sorting_mixin */ 385));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var COLUMN_HEADERS_VIEW_NAMESPACE = "dxDataGridColumnHeadersView";
        var ColumnHeadersViewSortingExtender = (0, _extend.extend)({}, _uiGrid_core.default, {
            _createRow: function(row) {
                var _this = this;
                var $row = this.callBase(row);
                if ("header" === row.rowType) {
                    _events_engine.default.on($row, (0, _index.addNamespace)(_click.name, COLUMN_HEADERS_VIEW_NAMESPACE), "td", this.createAction(function(e) {
                        _this._processHeaderAction(e.event, $row)
                    }))
                }
                return $row
            },
            _processHeaderAction: function(event, $row) {
                if ((0, _renderer.default)(event.currentTarget).parent().get(0) !== $row.get(0)) {
                    return
                }
                var that = this;
                var keyName = null;
                var $cellElementFromEvent = (0, _renderer.default)(event.currentTarget);
                var rowIndex = $cellElementFromEvent.parent().index();
                var columnIndex = -1;
                [].slice.call(that.getCellElements(rowIndex)).some(function($cellElement, index) {
                    if ($cellElement === $cellElementFromEvent.get(0)) {
                        columnIndex = index;
                        return true
                    }
                });
                var visibleColumns = that._columnsController.getVisibleColumns(rowIndex);
                var column = visibleColumns[columnIndex];
                var editingController = that.getController("editing");
                var editingMode = that.option("editing.mode");
                var isCellEditing = editingController && editingController.isEditing() && ("batch" === editingMode || "cell" === editingMode);
                if (isCellEditing || !that._isSortableElement((0, _renderer.default)(event.target))) {
                    return
                }
                if (column && !(0, _type.isDefined)(column.groupIndex) && !column.command) {
                    if (event.shiftKey) {
                        keyName = "shift"
                    } else {
                        if (event.ctrlKey) {
                            keyName = "ctrl"
                        }
                    }
                    setTimeout(function() {
                        that._columnsController.changeSortOrder(column.index, keyName)
                    })
                }
            },
            _renderCellContent: function($cell, options) {
                var that = this;
                var column = options.column;
                if (!column.command && "header" === options.rowType) {
                    that._applyColumnState({
                        name: "sort",
                        rootElement: $cell,
                        column: column,
                        showColumnLines: that.option("showColumnLines")
                    })
                }
                that.callBase($cell, options)
            },
            _columnOptionChanged: function(e) {
                var changeTypes = e.changeTypes;
                if (1 === changeTypes.length && changeTypes.sorting) {
                    this._updateIndicators("sort");
                    return
                }
                this.callBase(e)
            },
            optionChanged: function(args) {
                var that = this;
                switch (args.name) {
                    case "sorting":
                        that._invalidate();
                        args.handled = true;
                        break;
                    default:
                        that.callBase(args)
                }
            }
        });
        var HeaderPanelSortingExtender = (0, _extend.extend)({}, _uiGrid_core.default, {
            _createGroupPanelItem: function($rootElement, groupColumn) {
                var that = this;
                var $item = that.callBase.apply(that, arguments);
                _events_engine.default.on($item, (0, _index.addNamespace)(_click.name, "dxDataGridHeaderPanel"), that.createAction(function() {
                    that._processGroupItemAction(groupColumn.index)
                }));
                that._applyColumnState({
                    name: "sort",
                    rootElement: $item,
                    column: {
                        alignment: that.option("rtlEnabled") ? "right" : "left",
                        allowSorting: groupColumn.allowSorting,
                        sortOrder: "desc" === groupColumn.sortOrder ? "desc" : "asc"
                    },
                    showColumnLines: true
                });
                return $item
            },
            _processGroupItemAction: function(groupColumnIndex) {
                var _this2 = this;
                setTimeout(function() {
                    return _this2.getController("columns").changeSortOrder(groupColumnIndex)
                })
            },
            optionChanged: function(args) {
                var that = this;
                switch (args.name) {
                    case "sorting":
                        that._invalidate();
                        args.handled = true;
                        break;
                    default:
                        that.callBase(args)
                }
            }
        });
        var _default = {
            defaultOptions: function() {
                return {
                    sorting: {
                        mode: "single",
                        ascendingText: _message.default.format("dxDataGrid-sortingAscendingText"),
                        descendingText: _message.default.format("dxDataGrid-sortingDescendingText"),
                        clearText: _message.default.format("dxDataGrid-sortingClearText"),
                        showSortIndexes: true
                    }
                }
            },
            extenders: {
                views: {
                    columnHeadersView: ColumnHeadersViewSortingExtender,
                    headerPanel: HeaderPanelSortingExtender
                }
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.sorting_mixin.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var SORT_CLASS = "dx-sort";
        var SORT_NONE_CLASS = "dx-sort-none";
        var SORTUP_CLASS = "dx-sort-up";
        var SORTDOWN_CLASS = "dx-sort-down";
        var SORT_INDEX_CLASS = "dx-sort-index";
        var SORT_INDEX_ICON_CLASS = "dx-sort-index-icon";
        var HEADERS_ACTION_CLASS = "action";
        var _default = {
            _applyColumnState: function(options) {
                var that = this;
                var ariaSortState;
                var $sortIndicator;
                var sortingMode = that.option("sorting.mode");
                var rootElement = options.rootElement;
                var column = options.column;
                var $indicatorsContainer = that._getIndicatorContainer(rootElement);
                if ("sort" === options.name) {
                    rootElement.find("." + SORT_CLASS).remove();
                    !$indicatorsContainer.children().length && $indicatorsContainer.remove();
                    var isSortingAllowed = ("single" === sortingMode || "multiple" === sortingMode) && column.allowSorting;
                    if (!(0, _type.isDefined)(column.groupIndex) && (isSortingAllowed || (0, _type.isDefined)(column.sortOrder))) {
                        ariaSortState = "asc" === column.sortOrder ? "ascending" : "descending";
                        $sortIndicator = that.callBase(options).toggleClass(SORTUP_CLASS, "asc" === column.sortOrder).toggleClass(SORTDOWN_CLASS, "desc" === column.sortOrder);
                        var hasSeveralSortIndexes = that.getController && !!that.getController("columns").columnOption("sortIndex:1");
                        if (hasSeveralSortIndexes && that.option("sorting.showSortIndexes") && column.sortIndex >= 0) {
                            (0, _renderer.default)("<span>").addClass(SORT_INDEX_ICON_CLASS).text(column.sortIndex + 1).appendTo($sortIndicator);
                            $sortIndicator.addClass(SORT_INDEX_CLASS)
                        }
                        options.rootElement.addClass(that.addWidgetPrefix(HEADERS_ACTION_CLASS))
                    }
                    if (!(0, _type.isDefined)(column.sortOrder)) {
                        that.setAria("sort", "none", rootElement)
                    } else {
                        that.setAria("sort", ariaSortState, rootElement)
                    }
                    return $sortIndicator
                } else {
                    return that.callBase(options)
                }
            },
            _getIndicatorClassName: function(name) {
                if ("sort" === name) {
                    return SORT_CLASS
                } else {
                    if ("sortIndex" === name) {
                        return SORT_INDEX_ICON_CLASS
                    }
                }
                return this.callBase(name)
            },
            _renderIndicator: function(options) {
                var column = options.column;
                var $container = options.container;
                var $indicator = options.indicator;
                if ("sort" === options.name) {
                    var rtlEnabled = this.option("rtlEnabled");
                    if (!(0, _type.isDefined)(column.sortOrder)) {
                        $indicator && $indicator.addClass(SORT_NONE_CLASS)
                    }
                    if ($container.children().length && (!rtlEnabled && "left" === options.columnAlignment || rtlEnabled && "right" === options.columnAlignment)) {
                        $container.prepend($indicator);
                        return
                    }
                }
                this.callBase(options)
            },
            _updateIndicator: function($cell, column, indicatorName) {
                if ("sort" === indicatorName && (0, _type.isDefined)(column.groupIndex)) {
                    return
                }
                return this.callBase.apply(this, arguments)
            },
            _getIndicatorElements: function($cell, returnAll) {
                var $indicatorElements = this.callBase($cell);
                return returnAll ? $indicatorElements : $indicatorElements && $indicatorElements.not("." + SORT_NONE_CLASS)
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.rows.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _style = __webpack_require__( /*! ../../core/utils/style */ 99);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _position = __webpack_require__( /*! ../../core/utils/position */ 22);
        var _string = __webpack_require__( /*! ../../core/utils/string */ 43);
        var _data = __webpack_require__( /*! ../../core/utils/data */ 20);
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.utils */ 35));
        var _uiGrid_core2 = __webpack_require__( /*! ./ui.grid_core.columns_view */ 183);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../scroll_view/ui.scrollable */ 106));
        var _remove_event = _interopRequireDefault(__webpack_require__( /*! ../../core/remove_event */ 152));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ROWS_VIEW_CLASS = "rowsview";
        var CONTENT_CLASS = "content";
        var NOWRAP_CLASS = "nowrap";
        var GROUP_ROW_CLASS = "dx-group-row";
        var GROUP_CELL_CLASS = "dx-group-cell";
        var DATA_ROW_CLASS = "dx-data-row";
        var FREE_SPACE_CLASS = "dx-freespace-row";
        var ROW_LINES_CLASS = "dx-row-lines";
        var COLUMN_LINES_CLASS = "dx-column-lines";
        var ROW_ALTERNATION_CLASS = "dx-row-alt";
        var LAST_ROW_BORDER = "dx-last-row-border";
        var EMPTY_CLASS = "dx-empty";
        var ROW_INSERTED_ANIMATION_CLASS = "row-inserted-animation";
        var LOADPANEL_HIDE_TIMEOUT = 200;

        function getMaxHorizontalScrollOffset(scrollable) {
            return scrollable ? scrollable.scrollWidth() - scrollable.clientWidth() : 0
        }
        var _default = {
            defaultOptions: function() {
                return {
                    hoverStateEnabled: false,
                    scrolling: {
                        useNative: "auto"
                    },
                    loadPanel: {
                        enabled: "auto",
                        text: _message.default.format("Loading"),
                        width: 200,
                        height: 90,
                        showIndicator: true,
                        indicatorSrc: "",
                        showPane: true
                    },
                    rowTemplate: null,
                    columnAutoWidth: false,
                    noDataText: _message.default.format("dxDataGrid-noDataText"),
                    wordWrapEnabled: false,
                    showColumnLines: true,
                    showRowLines: false,
                    rowAlternationEnabled: false,
                    activeStateEnabled: false,
                    twoWayBindingEnabled: true
                }
            },
            views: {
                rowsView: _uiGrid_core2.ColumnsView.inherit(function() {
                    var defaultCellTemplate = function($container, options) {
                        var isDataTextEmpty = (0, _string.isEmpty)(options.text) && "data" === options.rowType;
                        var text = options.text;
                        var container = $container.get(0);
                        if (isDataTextEmpty) {
                            _uiGrid_core.default.setEmptyText($container)
                        } else {
                            if (options.column.encodeHtml) {
                                container.textContent = text
                            } else {
                                container.innerHTML = text
                            }
                        }
                    };
                    var getScrollableBottomPadding = function(that) {
                        var scrollable = that.getScrollable();
                        return scrollable ? Math.ceil(parseFloat(scrollable.$content().css("paddingBottom"))) : 0
                    };
                    return {
                        _getDefaultTemplate: function(column) {
                            switch (column.command) {
                                case "empty":
                                    return function(container) {
                                        container.html("&nbsp;")
                                    };
                                default:
                                    return defaultCellTemplate
                            }
                        },
                        _getDefaultGroupTemplate: function(column) {
                            var that = this;
                            var summaryTexts = that.option("summary.texts");
                            return function($container, options) {
                                var data = options.data;
                                var text = options.column.caption + ": " + options.text;
                                var container = $container.get(0);
                                if (options.summaryItems && options.summaryItems.length) {
                                    text += " " + _uiGrid_core.default.getGroupRowSummaryText(options.summaryItems, summaryTexts)
                                }
                                if (data) {
                                    if (options.groupContinuedMessage && options.groupContinuesMessage) {
                                        text += " (" + options.groupContinuedMessage + ". " + options.groupContinuesMessage + ")"
                                    } else {
                                        if (options.groupContinuesMessage) {
                                            text += " (" + options.groupContinuesMessage + ")"
                                        } else {
                                            if (options.groupContinuedMessage) {
                                                text += " (" + options.groupContinuedMessage + ")"
                                            }
                                        }
                                    }
                                }
                                $container.addClass(GROUP_CELL_CLASS);
                                if (column.encodeHtml) {
                                    container.textContent = text
                                } else {
                                    container.innerHTML = text
                                }
                            }
                        },
                        _update: function() {},
                        _getCellTemplate: function(options) {
                            var that = this;
                            var column = options.column;
                            var template;
                            if ("group" === options.rowType && (0, _type.isDefined)(column.groupIndex) && !column.showWhenGrouped && !column.command) {
                                template = column.groupCellTemplate || {
                                    allowRenderToDetachedContainer: true,
                                    render: that._getDefaultGroupTemplate(column)
                                }
                            } else {
                                if (("data" === options.rowType || column.command) && column.cellTemplate) {
                                    template = column.cellTemplate
                                } else {
                                    template = {
                                        allowRenderToDetachedContainer: true,
                                        render: that._getDefaultTemplate(column)
                                    }
                                }
                            }
                            return template
                        },
                        _createRow: function(row) {
                            var $row = this.callBase(row);
                            if (row) {
                                var isGroup = "group" === row.rowType;
                                var isDataRow = "data" === row.rowType;
                                isDataRow && $row.addClass(DATA_ROW_CLASS);
                                isDataRow && this.option("showRowLines") && $row.addClass(ROW_LINES_CLASS);
                                this.option("showColumnLines") && $row.addClass(COLUMN_LINES_CLASS);
                                if (false === row.visible) {
                                    $row.hide()
                                }
                                if (isGroup) {
                                    $row.addClass(GROUP_ROW_CLASS);
                                    var isRowExpanded = row.isExpanded;
                                    this.setAria("role", "row", $row);
                                    this.setAria("expanded", (0, _type.isDefined)(isRowExpanded) && isRowExpanded.toString(), $row)
                                }
                            }
                            return $row
                        },
                        _rowPrepared: function($row, rowOptions, row) {
                            var _this = this;
                            if ("data" === rowOptions.rowType) {
                                if (this.option("rowAlternationEnabled")) {
                                    this._isAltRow(row) && $row.addClass(ROW_ALTERNATION_CLASS);
                                    rowOptions.watch && rowOptions.watch(function() {
                                        return _this._isAltRow(row)
                                    }, function(value) {
                                        $row.toggleClass(ROW_ALTERNATION_CLASS, value)
                                    })
                                }
                                this._setAriaRowIndex(rowOptions, $row);
                                rowOptions.watch && rowOptions.watch(function() {
                                    return rowOptions.rowIndex
                                }, function() {
                                    return _this._setAriaRowIndex(rowOptions, $row)
                                })
                            }
                            this.callBase.apply(this, arguments)
                        },
                        _setAriaRowIndex: function(row, $row) {
                            var component = this.component;
                            var isPagerMode = "standard" === component.option("scrolling.mode") && "virtual" !== component.option("scrolling.rowRenderingMode");
                            var rowIndex = row.rowIndex + 1;
                            if (isPagerMode) {
                                rowIndex = component.pageIndex() * component.pageSize() + rowIndex
                            } else {
                                rowIndex += this._dataController.getRowIndexOffset()
                            }
                            this.setAria("rowindex", rowIndex, $row)
                        },
                        _afterRowPrepared: function(e) {
                            var _this2 = this;
                            var arg = e.args[0];
                            var dataController = this._dataController;
                            var row = dataController.getVisibleRows()[arg.rowIndex];
                            var watch = this.option("integrationOptions.watchMethod");
                            if (!arg.data || "data" !== arg.rowType || arg.isNewRow || !this.option("twoWayBindingEnabled") || !watch || !row) {
                                return
                            }
                            var dispose = watch(function() {
                                return dataController.generateDataValues(arg.data, arg.columns)
                            }, function() {
                                dataController.repaintRows([row.rowIndex], _this2.option("repaintChangesOnly"))
                            }, {
                                deep: true,
                                skipImmediate: true
                            });
                            _events_engine.default.on(arg.rowElement, _remove_event.default, dispose)
                        },
                        _renderScrollable: function(force) {
                            var that = this;
                            var $element = that.element();
                            if (!$element.children().length) {
                                $element.append("<div>")
                            }
                            if (force || !that._loadPanel) {
                                that._renderLoadPanel($element, $element.parent(), that._dataController.isLocalStore())
                            }
                            if ((force || !that.getScrollable()) && that._dataController.isLoaded()) {
                                var columns = that.getColumns();
                                var allColumnsHasWidth = true;
                                for (var i = 0; i < columns.length; i++) {
                                    if (!columns[i].width && !columns[i].minWidth) {
                                        allColumnsHasWidth = false;
                                        break
                                    }
                                }
                                if (that.option("columnAutoWidth") || that._hasHeight || allColumnsHasWidth || that._columnsController._isColumnFixing()) {
                                    that._renderScrollableCore($element)
                                }
                            }
                        },
                        _handleScroll: function(e) {
                            var that = this;
                            var rtlEnabled = that.option("rtlEnabled");
                            that._isScrollByEvent = !!e.event;
                            that._scrollTop = e.scrollOffset.top;
                            that._scrollLeft = e.scrollOffset.left;
                            if (rtlEnabled) {
                                this._scrollRight = getMaxHorizontalScrollOffset(e.component) - this._scrollLeft
                            }
                            that.scrollChanged.fire(e.scrollOffset, that.name)
                        },
                        _renderScrollableCore: function($element) {
                            var that = this;
                            var dxScrollableOptions = that._createScrollableOptions();
                            var scrollHandler = that._handleScroll.bind(that);
                            dxScrollableOptions.onScroll = scrollHandler;
                            dxScrollableOptions.onStop = scrollHandler;
                            that._scrollable = that._createComponent($element, _ui.default, dxScrollableOptions);
                            that._scrollableContainer = that._scrollable && that._scrollable._$container
                        },
                        _renderLoadPanel: _uiGrid_core.default.renderLoadPanel,
                        _renderContent: function(contentElement, tableElement) {
                            contentElement.empty().append(tableElement);
                            return this._findContentElement()
                        },
                        _updateContent: function(newTableElement, change) {
                            var that = this;
                            var tableElement = that.getTableElement();
                            var contentElement = that._findContentElement();
                            var changeType = change && change.changeType;
                            var executors = [];
                            var highlightChanges = this.option("highlightChanges");
                            var rowInsertedClass = this.addWidgetPrefix(ROW_INSERTED_ANIMATION_CLASS);
                            switch (changeType) {
                                case "update":
                                    (0, _iterator.each)(change.rowIndices, function(index, rowIndex) {
                                        var $newRowElement = that._getRowElements(newTableElement).eq(index);
                                        var changeType = change.changeTypes && change.changeTypes[index];
                                        var item = change.items && change.items[index];
                                        executors.push(function() {
                                            var $rowsElement = that._getRowElements();
                                            var $rowElement = $rowsElement.eq(rowIndex);
                                            switch (changeType) {
                                                case "update":
                                                    if (item) {
                                                        var columnIndices = change.columnIndices && change.columnIndices[index];
                                                        if ((0, _type.isDefined)(item.visible) && item.visible !== $rowElement.is(":visible")) {
                                                            $rowElement.toggle(item.visible)
                                                        } else {
                                                            if (columnIndices) {
                                                                that._updateCells($rowElement, $newRowElement, columnIndices)
                                                            } else {
                                                                $rowElement.replaceWith($newRowElement)
                                                            }
                                                        }
                                                    }
                                                    break;
                                                case "insert":
                                                    if (!$rowsElement.length) {
                                                        if (tableElement) {
                                                            var target = $newRowElement.is("tbody") ? tableElement : tableElement.children("tbody");
                                                            $newRowElement.prependTo(target)
                                                        }
                                                    } else {
                                                        if ($rowElement.length) {
                                                            $newRowElement.insertBefore($rowElement)
                                                        } else {
                                                            $newRowElement.insertAfter($rowsElement.last())
                                                        }
                                                    }
                                                    if (highlightChanges && change.isLiveUpdate) {
                                                        $newRowElement.addClass(rowInsertedClass)
                                                    }
                                                    break;
                                                case "remove":
                                                    $rowElement.remove()
                                            }
                                        })
                                    });
                                    (0, _iterator.each)(executors, function() {
                                        this()
                                    });
                                    newTableElement.remove();
                                    break;
                                default:
                                    that.setTableElement(newTableElement);
                                    contentElement.addClass(that.addWidgetPrefix(CONTENT_CLASS));
                                    that._renderContent(contentElement, newTableElement)
                            }
                        },
                        _createEmptyRow: function(className, isFixed, height) {
                            var that = this;
                            var $cell;
                            var $row = that._createRow();
                            var columns = isFixed ? this.getFixedColumns() : this.getColumns();
                            $row.addClass(className).toggleClass(COLUMN_LINES_CLASS, that.option("showColumnLines"));
                            for (var i = 0; i < columns.length; i++) {
                                $cell = that._createCell({
                                    column: columns[i],
                                    rowType: "freeSpace",
                                    columnIndex: i,
                                    columns: columns
                                });
                                (0, _type.isNumeric)(height) && $cell.css("height", height);
                                $row.append($cell)
                            }
                            that.setAria("role", "presentation", $row);
                            return $row
                        },
                        _appendEmptyRow: function($table, $emptyRow, location) {
                            var $tBodies = this._getBodies($table);
                            var isTableContainer = !$tBodies.length || $emptyRow.is("tbody");
                            var $container = isTableContainer ? $table : $tBodies;
                            if ("top" === location) {
                                $container.first().prepend($emptyRow);
                                if (isTableContainer) {
                                    var $colgroup = $container.children("colgroup");
                                    $container.prepend($colgroup)
                                }
                            } else {
                                $container.last().append($emptyRow)
                            }
                        },
                        _renderFreeSpaceRow: function($tableElement) {
                            var $freeSpaceRowElement = this._createEmptyRow(FREE_SPACE_CLASS);
                            $freeSpaceRowElement = this._wrapRowIfNeed($tableElement, $freeSpaceRowElement);
                            this._appendEmptyRow($tableElement, $freeSpaceRowElement)
                        },
                        _checkRowKeys: function(options) {
                            var that = this;
                            var rows = that._getRows(options);
                            var keyExpr = that._dataController.store() && that._dataController.store().key();
                            keyExpr && rows.some(function(row) {
                                if ("data" === row.rowType && void 0 === row.key) {
                                    that._dataController.fireError("E1046", keyExpr);
                                    return true
                                }
                            })
                        },
                        _needUpdateRowHeight: function(itemsCount) {
                            return itemsCount > 0 && !this._rowHeight
                        },
                        _getRowsHeight: function($tableElement) {
                            var $rowElements = $tableElement.children("tbody").children().not(".dx-virtual-row").not("." + FREE_SPACE_CLASS);
                            return $rowElements.toArray().reduce(function(sum, row) {
                                return sum + (0, _position.getBoundingRect)(row).height
                            }, 0)
                        },
                        _updateRowHeight: function() {
                            var that = this;
                            var $tableElement = that.getTableElement();
                            var itemsCount = that._dataController.items().length;
                            if ($tableElement && that._needUpdateRowHeight(itemsCount)) {
                                var rowsHeight = that._getRowsHeight($tableElement);
                                that._rowHeight = rowsHeight / itemsCount
                            }
                        },
                        _findContentElement: function() {
                            var $content = this.element();
                            var scrollable = this.getScrollable();
                            if ($content) {
                                if (scrollable) {
                                    $content = scrollable.$content()
                                }
                                return $content.children().first()
                            }
                        },
                        _getRowElements: function(tableElement) {
                            var $rows = this.callBase(tableElement);
                            return $rows && $rows.not("." + FREE_SPACE_CLASS)
                        },
                        _getFreeSpaceRowElements: function($table) {
                            var tableElements = $table || this.getTableElements();
                            return tableElements && tableElements.children("tbody").children("." + FREE_SPACE_CLASS)
                        },
                        _getNoDataText: function() {
                            return this.option("noDataText")
                        },
                        _rowClick: function(e) {
                            var item = this._dataController.items()[e.rowIndex] || {};
                            this.executeAction("onRowClick", (0, _extend.extend)({
                                evaluate: function(expr) {
                                    var getter = (0, _data.compileGetter)(expr);
                                    return getter(item.data)
                                }
                            }, e, item))
                        },
                        _rowDblClick: function(e) {
                            var item = this._dataController.items()[e.rowIndex] || {};
                            this.executeAction("onRowDblClick", (0, _extend.extend)({}, e, item))
                        },
                        _getColumnsCountBeforeGroups: function(columns) {
                            for (var i = 0; i < columns.length; i++) {
                                if ("groupExpand" === columns[i].type) {
                                    return i
                                }
                            }
                            return 0
                        },
                        _getGroupCellOptions: function(options) {
                            var columnsCountBeforeGroups = this._getColumnsCountBeforeGroups(options.columns);
                            var columnIndex = (options.row.groupIndex || 0) + columnsCountBeforeGroups;
                            return {
                                columnIndex: columnIndex,
                                colspan: options.columns.length - columnIndex - 1
                            }
                        },
                        _renderCells: function($row, options) {
                            if ("group" === options.row.rowType) {
                                this._renderGroupedCells($row, options)
                            } else {
                                if (options.row.values) {
                                    this.callBase($row, options)
                                }
                            }
                        },
                        _renderGroupedCells: function($row, options) {
                            var row = options.row;
                            var expandColumn;
                            var columns = options.columns;
                            var rowIndex = row.rowIndex;
                            var isExpanded;
                            var groupCellOptions = this._getGroupCellOptions(options);
                            for (var i = 0; i <= groupCellOptions.columnIndex; i++) {
                                if (i === groupCellOptions.columnIndex && columns[i].allowCollapsing && "infinite" !== options.scrollingMode) {
                                    isExpanded = !!row.isExpanded;
                                    expandColumn = columns[i]
                                } else {
                                    isExpanded = null;
                                    expandColumn = {
                                        command: "expand",
                                        cssClass: columns[i].cssClass
                                    }
                                }
                                this._renderCell($row, {
                                    value: isExpanded,
                                    row: row,
                                    rowIndex: rowIndex,
                                    column: expandColumn,
                                    columnIndex: i
                                })
                            }
                            var groupColumnAlignment = (0, _position.getDefaultAlignment)(this.option("rtlEnabled"));
                            var groupColumn = (0, _extend.extend)({}, columns[groupCellOptions.columnIndex], {
                                command: null,
                                cssClass: null,
                                width: null,
                                showWhenGrouped: false,
                                alignment: groupColumnAlignment
                            });
                            if (groupCellOptions.colspan > 1) {
                                groupColumn.colspan = groupCellOptions.colspan
                            }
                            this._renderCell($row, {
                                value: row.values[row.groupIndex],
                                row: row,
                                rowIndex: rowIndex,
                                column: groupColumn,
                                columnIndex: groupCellOptions.columnIndex
                            })
                        },
                        _renderRows: function($table, options) {
                            var that = this;
                            var scrollingMode = that.option("scrolling.mode");
                            that.callBase($table, (0, _extend.extend)({
                                scrollingMode: scrollingMode
                            }, options));
                            that._checkRowKeys(options.change);
                            that._renderFreeSpaceRow($table);
                            if (!that._hasHeight) {
                                that.updateFreeSpaceRowHeight($table)
                            }
                        },
                        _renderRow: function($table, options) {
                            var that = this;
                            var row = options.row;
                            var rowTemplate = that.option("rowTemplate");
                            if (("data" === row.rowType || "group" === row.rowType) && !(0, _type.isDefined)(row.groupIndex) && rowTemplate) {
                                that.renderTemplate($table, rowTemplate, (0, _extend.extend)({
                                    columns: options.columns
                                }, row), true)
                            } else {
                                that.callBase($table, options)
                            }
                        },
                        _renderTable: function(options) {
                            var that = this;
                            var $table = that.callBase(options);
                            var resizeCompletedHandler = function resizeCompletedHandler() {
                                var scrollableInstance = that.getScrollable();
                                if (scrollableInstance && that.element().closest((0, _window.getWindow)().document).length) {
                                    that.resizeCompleted.remove(resizeCompletedHandler);
                                    scrollableInstance._visibilityChanged(true)
                                }
                            };
                            if (!(0, _type.isDefined)(that.getTableElement())) {
                                that.setTableElement($table);
                                that._renderScrollable(true);
                                that.resizeCompleted.add(resizeCompletedHandler)
                            } else {
                                that._renderScrollable()
                            }
                            return $table
                        },
                        _createTable: function() {
                            var $table = this.callBase.apply(this, arguments);
                            if (this.option("rowTemplate")) {
                                $table.appendTo(this.component.$element())
                            }
                            return $table
                        },
                        _renderCore: function(change) {
                            var that = this;
                            var $element = that.element();
                            $element.addClass(that.addWidgetPrefix(ROWS_VIEW_CLASS)).toggleClass(that.addWidgetPrefix(NOWRAP_CLASS), !that.option("wordWrapEnabled"));
                            $element.toggleClass(EMPTY_CLASS, 0 === that._dataController.items().length);
                            that.setAria("role", "presentation", $element);
                            var $table = that._renderTable({
                                change: change
                            });
                            that._updateContent($table, change);
                            that.callBase(change);
                            that._lastColumnWidths = null
                        },
                        _getRows: function(change) {
                            return change && change.items || this._dataController.items()
                        },
                        _getCellOptions: function(options) {
                            var that = this;
                            var column = options.column;
                            var row = options.row;
                            var data = row.data;
                            var summaryCells = row && row.summaryCells;
                            var value = options.value;
                            var displayValue = _uiGrid_core.default.getDisplayValue(column, value, data, row.rowType);
                            var parameters = this.callBase(options);
                            parameters.value = value;
                            parameters.oldValue = options.oldValue;
                            parameters.displayValue = displayValue;
                            parameters.row = row;
                            parameters.key = row.key;
                            parameters.data = data;
                            parameters.rowType = row.rowType;
                            parameters.values = row.values;
                            parameters.text = !column.command ? _uiGrid_core.default.formatValue(displayValue, column) : "";
                            parameters.rowIndex = row.rowIndex;
                            parameters.summaryItems = summaryCells && summaryCells[options.columnIndex];
                            parameters.resized = column.resizedCallbacks;
                            if ((0, _type.isDefined)(column.groupIndex) && !column.command) {
                                var groupingTextsOptions = that.option("grouping.texts");
                                var scrollingMode = that.option("scrolling.mode");
                                if ("virtual" !== scrollingMode && "infinite" !== scrollingMode) {
                                    parameters.groupContinuesMessage = data && data.isContinuationOnNextPage && groupingTextsOptions && groupingTextsOptions.groupContinuesMessage;
                                    parameters.groupContinuedMessage = data && data.isContinuation && groupingTextsOptions && groupingTextsOptions.groupContinuedMessage
                                }
                            }
                            return parameters
                        },
                        _setRowsOpacityCore: function($rows, visibleColumns, columnIndex, value) {
                            var columnsController = this._columnsController;
                            var columns = columnsController.getColumns();
                            var column = columns && columns[columnIndex];
                            var columnID = column && column.isBand && column.index;
                            (0, _iterator.each)($rows, function(rowIndex, row) {
                                if (!(0, _renderer.default)(row).hasClass(GROUP_ROW_CLASS)) {
                                    for (var i = 0; i < visibleColumns.length; i++) {
                                        if ((0, _type.isNumeric)(columnID) && columnsController.isParentBandColumn(visibleColumns[i].index, columnID) || visibleColumns[i].index === columnIndex) {
                                            $rows.eq(rowIndex).children().eq(i).css({
                                                opacity: value
                                            });
                                            if (!(0, _type.isNumeric)(columnID)) {
                                                break
                                            }
                                        }
                                    }
                                }
                            })
                        },
                        _getDevicePixelRatio: function() {
                            return (0, _window.getWindow)().devicePixelRatio
                        },
                        renderNoDataText: _uiGrid_core.default.renderNoDataText,
                        getCellOptions: function(rowIndex, columnIdentifier) {
                            var rowOptions = this._dataController.items()[rowIndex];
                            var cellOptions;
                            var column;
                            if (rowOptions) {
                                if ((0, _type.isString)(columnIdentifier)) {
                                    column = this._columnsController.columnOption(columnIdentifier)
                                } else {
                                    column = this._columnsController.getVisibleColumns()[columnIdentifier]
                                }
                                if (column) {
                                    cellOptions = this._getCellOptions({
                                        value: column.calculateCellValue(rowOptions.data),
                                        rowIndex: rowOptions.rowIndex,
                                        row: rowOptions,
                                        column: column
                                    })
                                }
                            }
                            return cellOptions
                        },
                        getRow: function(index) {
                            if (index >= 0) {
                                var rows = this._getRowElements();
                                if (rows.length > index) {
                                    return (0, _renderer.default)(rows[index])
                                }
                            }
                        },
                        updateFreeSpaceRowHeight: function($table) {
                            var _this3 = this;
                            var dataController = this._dataController;
                            var itemCount = dataController.items(true).length;
                            var contentElement = this._findContentElement();
                            var freeSpaceRowElements = this._getFreeSpaceRowElements($table);
                            if (freeSpaceRowElements && contentElement && dataController.totalCount() >= 0) {
                                var isFreeSpaceRowVisible = false;
                                if (itemCount > 0) {
                                    if (!this._hasHeight) {
                                        var freeSpaceRowCount = dataController.pageSize() - itemCount;
                                        var scrollingMode = this.option("scrolling.mode");
                                        if (freeSpaceRowCount > 0 && dataController.pageCount() > 1 && "virtual" !== scrollingMode && "infinite" !== scrollingMode) {
                                            (0, _style.setHeight)(freeSpaceRowElements, freeSpaceRowCount * this._rowHeight);
                                            isFreeSpaceRowVisible = true
                                        }
                                        if (!isFreeSpaceRowVisible && $table) {
                                            (0, _style.setHeight)(freeSpaceRowElements, 0)
                                        } else {
                                            freeSpaceRowElements.toggle(isFreeSpaceRowVisible)
                                        }
                                        this._updateLastRowBorder(isFreeSpaceRowVisible)
                                    } else {
                                        freeSpaceRowElements.hide();
                                        (0, _common.deferUpdate)(function() {
                                            var scrollbarWidth = _this3.getScrollbarWidth(true);
                                            var elementHeightWithoutScrollbar = _this3.element().height() - scrollbarWidth;
                                            var contentHeight = contentElement.outerHeight();
                                            var showFreeSpaceRow = elementHeightWithoutScrollbar - contentHeight > 0;
                                            var rowsHeight = _this3._getRowsHeight(contentElement.children().first());
                                            var $tableElement = $table || _this3.getTableElements();
                                            var borderTopWidth = Math.ceil(parseFloat($tableElement.css("borderTopWidth")));
                                            var heightCorrection = _this3._getHeightCorrection();
                                            var resultHeight = elementHeightWithoutScrollbar - rowsHeight - borderTopWidth - heightCorrection;
                                            if (showFreeSpaceRow) {
                                                (0, _common.deferRender)(function() {
                                                    freeSpaceRowElements.css("height", resultHeight);
                                                    isFreeSpaceRowVisible = true;
                                                    freeSpaceRowElements.show()
                                                })
                                            }(0, _common.deferRender)(function() {
                                                return _this3._updateLastRowBorder(isFreeSpaceRowVisible)
                                            })
                                        })
                                    }
                                } else {
                                    freeSpaceRowElements.css("height", 0);
                                    freeSpaceRowElements.show();
                                    this._updateLastRowBorder(true)
                                }
                            }
                        },
                        _getHeightCorrection: function() {
                            var isZoomedWebkit = _browser.default.webkit && this._getDevicePixelRatio() >= 2;
                            var hasExtraBorderTop = _browser.default.mozilla && _browser.default.version >= 70 && !this.option("showRowLines");
                            return isZoomedWebkit || hasExtraBorderTop ? 1 : 0
                        },
                        _columnOptionChanged: function(e) {
                            var optionNames = e.optionNames;
                            if (e.changeTypes.grouping) {
                                return
                            }
                            if (optionNames.width || optionNames.visibleWidth) {
                                this.callBase(e);
                                this._fireColumnResizedCallbacks()
                            }
                        },
                        getScrollable: function() {
                            return this._scrollable
                        },
                        init: function() {
                            var that = this;
                            var dataController = that.getController("data");
                            that.callBase();
                            that._editorFactoryController = that.getController("editorFactory");
                            that._rowHeight = 0;
                            that._scrollTop = 0;
                            that._scrollLeft = -1;
                            that._scrollRight = 0;
                            that._hasHeight = false;
                            dataController.loadingChanged.add(function(isLoading, messageText) {
                                that.setLoading(isLoading, messageText)
                            });
                            dataController.dataSourceChanged.add(function() {
                                if (that._scrollLeft >= 0) {
                                    that._handleScroll({
                                        component: that.getScrollable(),
                                        scrollOffset: {
                                            top: that._scrollTop,
                                            left: that._scrollLeft
                                        }
                                    })
                                }
                            })
                        },
                        _handleDataChanged: function(change) {
                            var that = this;
                            switch (change.changeType) {
                                case "refresh":
                                case "prepend":
                                case "append":
                                case "update":
                                    that.render(null, change);
                                    break;
                                default:
                                    that._update(change)
                            }
                        },
                        publicMethods: function() {
                            return ["isScrollbarVisible", "getTopVisibleRowData", "getScrollbarWidth", "getCellElement", "getRowElement", "getScrollable"]
                        },
                        contentWidth: function() {
                            return this.element().width() - this.getScrollbarWidth()
                        },
                        getScrollbarWidth: function(isHorizontal) {
                            var scrollableContainer = this._scrollableContainer && this._scrollableContainer.get(0);
                            var scrollbarWidth = 0;
                            if (scrollableContainer) {
                                if (!isHorizontal) {
                                    scrollbarWidth = scrollableContainer.clientWidth ? scrollableContainer.offsetWidth - scrollableContainer.clientWidth : 0
                                } else {
                                    scrollbarWidth = scrollableContainer.clientHeight ? scrollableContainer.offsetHeight - scrollableContainer.clientHeight : 0;
                                    scrollbarWidth += getScrollableBottomPadding(this)
                                }
                            }
                            return scrollbarWidth > 0 ? scrollbarWidth : 0
                        },
                        _fireColumnResizedCallbacks: function() {
                            var that = this;
                            var lastColumnWidths = that._lastColumnWidths || [];
                            var columnWidths = [];
                            var columns = that.getColumns();
                            for (var i = 0; i < columns.length; i++) {
                                columnWidths[i] = columns[i].visibleWidth;
                                if (columns[i].resizedCallbacks && !(0, _type.isDefined)(columns[i].groupIndex) && lastColumnWidths[i] !== columnWidths[i]) {
                                    columns[i].resizedCallbacks.fire(columnWidths[i])
                                }
                            }
                            that._lastColumnWidths = columnWidths
                        },
                        _updateLastRowBorder: function(isFreeSpaceRowVisible) {
                            if (this.option("showBorders") && this.option("showRowLines") && !isFreeSpaceRowVisible) {
                                this.element().addClass(LAST_ROW_BORDER)
                            } else {
                                this.element().removeClass(LAST_ROW_BORDER)
                            }
                        },
                        _updateScrollable: function() {
                            var dxScrollable = _ui.default.getInstance(this.element());
                            if (dxScrollable) {
                                dxScrollable.update();
                                this._updateHorizontalScrollPosition()
                            }
                        },
                        _updateHorizontalScrollPosition: function() {
                            var scrollable = this.getScrollable();
                            var scrollLeft = scrollable && scrollable.scrollOffset().left;
                            var rtlEnabled = this.option("rtlEnabled");
                            if (rtlEnabled) {
                                var maxHorizontalScrollOffset = getMaxHorizontalScrollOffset(scrollable);
                                var scrollRight = maxHorizontalScrollOffset - scrollLeft;
                                if (scrollRight !== this._scrollRight) {
                                    this._scrollLeft = maxHorizontalScrollOffset - this._scrollRight
                                }
                            }
                            if (this._scrollLeft >= 0 && scrollLeft !== this._scrollLeft) {
                                scrollable.scrollTo({
                                    x: this._scrollLeft
                                })
                            }
                        },
                        _resizeCore: function() {
                            var that = this;
                            that._fireColumnResizedCallbacks();
                            that._updateRowHeight();
                            (0, _common.deferRender)(function() {
                                that._renderScrollable();
                                that.renderNoDataText();
                                that.updateFreeSpaceRowHeight();
                                (0, _common.deferUpdate)(function() {
                                    that._updateScrollable()
                                })
                            })
                        },
                        scrollTo: function(location) {
                            var $element = this.element();
                            var dxScrollable = $element && _ui.default.getInstance($element);
                            if (dxScrollable) {
                                dxScrollable.scrollTo(location)
                            }
                        },
                        height: function(_height, hasHeight) {
                            var that = this;
                            var $element = this.element();
                            if (0 === arguments.length) {
                                return $element ? $element.outerHeight(true) : 0
                            }
                            that._hasHeight = void 0 === hasHeight ? "auto" !== _height : hasHeight;
                            if ((0, _type.isDefined)(_height) && $element) {
                                (0, _style.setHeight)($element, _height)
                            }
                        },
                        setLoading: function(isLoading, messageText) {
                            var that = this;
                            var loadPanel = that._loadPanel;
                            var dataController = that._dataController;
                            var loadPanelOptions = that.option("loadPanel") || {};
                            var animation = dataController.isLoaded() ? loadPanelOptions.animation : null;
                            var $element = that.element();
                            if (!(0, _window.hasWindow)()) {
                                return
                            }
                            if (!loadPanel && void 0 !== messageText && dataController.isLocalStore() && "auto" === loadPanelOptions.enabled && $element) {
                                that._renderLoadPanel($element, $element.parent());
                                loadPanel = that._loadPanel
                            }
                            if (loadPanel) {
                                var visibilityOptions = {
                                    message: messageText || loadPanelOptions.text,
                                    animation: animation,
                                    visible: isLoading
                                };
                                clearTimeout(that._hideLoadingTimeoutID);
                                if (loadPanel.option("visible") && !isLoading) {
                                    that._hideLoadingTimeoutID = setTimeout(function() {
                                        loadPanel.option(visibilityOptions)
                                    }, LOADPANEL_HIDE_TIMEOUT)
                                } else {
                                    loadPanel.option(visibilityOptions)
                                }
                            }
                        },
                        setRowsOpacity: function(columnIndex, value) {
                            var $rows = this._getRowElements().not("." + GROUP_ROW_CLASS) || [];
                            this._setRowsOpacityCore($rows, this.getColumns(), columnIndex, value)
                        },
                        _getCellElementsCore: function(rowIndex) {
                            var $cells = this.callBase.apply(this, arguments);
                            if ($cells) {
                                var groupCellIndex = $cells.filter("." + GROUP_CELL_CLASS).index();
                                if (groupCellIndex >= 0 && $cells.length > groupCellIndex + 1) {
                                    return $cells.slice(0, groupCellIndex + 1)
                                }
                            }
                            return $cells
                        },
                        getTopVisibleItemIndex: function(isFloor) {
                            var that = this;
                            var itemIndex = 0;
                            var prevOffsetTop = 0;
                            var offsetTop = 0;
                            var scrollPosition = that._scrollTop;
                            var $contentElement = that._findContentElement();
                            var contentElementOffsetTop = $contentElement && $contentElement.offset().top;
                            var items = that._dataController.items();
                            var tableElement = that.getTableElement();
                            if (items.length && tableElement) {
                                var rowElements = that._getRowElements(tableElement).filter(":visible");
                                for (itemIndex = 0; itemIndex < items.length; itemIndex++) {
                                    prevOffsetTop = offsetTop;
                                    var rowElement = rowElements.eq(itemIndex);
                                    if (rowElement.length) {
                                        offsetTop = rowElement.offset().top - contentElementOffsetTop;
                                        if (offsetTop > scrollPosition) {
                                            if (itemIndex) {
                                                if (isFloor || 2 * scrollPosition < Math.round(offsetTop + prevOffsetTop)) {
                                                    itemIndex--
                                                }
                                            }
                                            break
                                        }
                                    }
                                }
                                if (itemIndex && itemIndex === items.length) {
                                    itemIndex--
                                }
                            }
                            return itemIndex
                        },
                        getTopVisibleRowData: function() {
                            var itemIndex = this.getTopVisibleItemIndex();
                            var items = this._dataController.items();
                            if (items[itemIndex]) {
                                return items[itemIndex].data
                            }
                        },
                        _scrollToElement: function($element, offset) {
                            var scrollable = this.getScrollable();
                            scrollable && scrollable.scrollToElement($element, offset)
                        },
                        optionChanged: function(args) {
                            var that = this;
                            that.callBase(args);
                            switch (args.name) {
                                case "wordWrapEnabled":
                                case "showColumnLines":
                                case "showRowLines":
                                case "rowAlternationEnabled":
                                case "rowTemplate":
                                case "twoWayBindingEnabled":
                                    that._invalidate(true, true);
                                    args.handled = true;
                                    break;
                                case "scrolling":
                                    that._rowHeight = null;
                                    that._tableElement = null;
                                    args.handled = true;
                                    break;
                                case "rtlEnabled":
                                    that._rowHeight = null;
                                    that._tableElement = null;
                                    break;
                                case "loadPanel":
                                    that._tableElement = null;
                                    that._invalidate(true, "loadPanel.enabled" !== args.fullName);
                                    args.handled = true;
                                    break;
                                case "noDataText":
                                    that.renderNoDataText();
                                    args.handled = true
                            }
                        },
                        dispose: function() {
                            clearTimeout(this._hideLoadingTimeoutID);
                            this._scrollable && this._scrollable.dispose()
                        },
                        setScrollerSpacing: function() {}
                    }
                }())
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.context_menu.js ***!
      \****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _element = __webpack_require__( /*! ../../core/element */ 18);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.modules */ 44));
        var _context_menu = _interopRequireDefault(__webpack_require__( /*! ../context_menu */ 107));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var CONTEXT_MENU = "dx-context-menu";
        var viewName = {
            columnHeadersView: "header",
            rowsView: "content",
            footerView: "footer",
            headerPanel: "headerPanel"
        };
        var VIEW_NAMES = ["columnHeadersView", "rowsView", "footerView", "headerPanel"];
        var ContextMenuController = _uiGrid_core.default.ViewController.inherit({
            init: function() {
                this.createAction("onContextMenuPreparing")
            },
            getContextMenuItems: function(dxEvent) {
                if (!dxEvent) {
                    return false
                }
                var that = this;
                var $targetElement = (0, _renderer.default)(dxEvent.target);
                var $element;
                var $targetRowElement;
                var $targetCellElement;
                var menuItems;
                (0, _iterator.each)(VIEW_NAMES, function() {
                    var view = that.getView(this);
                    $element = view && view.element();
                    if ($element && ($element.is($targetElement) || $element.find($targetElement).length)) {
                        $targetCellElement = $targetElement.closest(".dx-row > td, .dx-row > tr");
                        $targetRowElement = $targetCellElement.parent();
                        var rowIndex = view.getRowIndex($targetRowElement);
                        var columnIndex = $targetCellElement[0] && $targetCellElement[0].cellIndex;
                        var rowOptions = $targetRowElement.data("options");
                        var options = {
                            event: dxEvent,
                            targetElement: (0, _element.getPublicElement)($targetElement),
                            target: viewName[this],
                            rowIndex: rowIndex,
                            row: view._getRows()[rowIndex],
                            columnIndex: columnIndex,
                            column: rowOptions && rowOptions.cells[columnIndex].column
                        };
                        options.items = view.getContextMenuItems && view.getContextMenuItems(options);
                        that.executeAction("onContextMenuPreparing", options);
                        that._contextMenuPrepared(options);
                        menuItems = options.items;
                        if (menuItems) {
                            return false
                        }
                    }
                });
                return menuItems
            },
            _contextMenuPrepared: _common.noop
        });
        var ContextMenuView = _uiGrid_core.default.View.inherit({
            _renderCore: function() {
                var that = this;
                var $element = that.element().addClass(CONTEXT_MENU);
                this.setAria("role", "presentation", $element);
                this._createComponent($element, _context_menu.default, {
                    onPositioning: function(actionArgs) {
                        var event = actionArgs.event;
                        var contextMenuInstance = actionArgs.component;
                        var items = that.getController("contextMenu").getContextMenuItems(event);
                        if (items) {
                            contextMenuInstance.option("items", items);
                            event.stopPropagation()
                        } else {
                            actionArgs.cancel = true
                        }
                    },
                    onItemClick: function(params) {
                        params.itemData.onItemClick && params.itemData.onItemClick(params)
                    },
                    cssClass: that.getWidgetContainerClass(),
                    target: that.component.$element()
                })
            }
        });
        var _default = {
            defaultOptions: function() {
                return {
                    onContextMenuPreparing: null
                }
            },
            controllers: {
                contextMenu: ContextMenuController
            },
            views: {
                contextMenuView: ContextMenuView
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.error_handling.js ***!
      \******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _click = __webpack_require__( /*! ../../events/click */ 21);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.modules */ 44));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ERROR_ROW_CLASS = "dx-error-row";
        var ERROR_MESSAGE_CLASS = "dx-error-message";
        var ERROR_CLOSEBUTTON_CLASS = "dx-closebutton";
        var ACTION_CLASS = "action";
        var ErrorHandlingController = _uiGrid_core.default.ViewController.inherit({
            init: function() {
                var that = this;
                that._columnHeadersView = that.getView("columnHeadersView");
                that._rowsView = that.getView("rowsView")
            },
            _createErrorRow: function(error, $tableElements) {
                var that = this;
                var $errorRow;
                var $closeButton;
                var $errorMessage = this._renderErrorMessage(error);
                if ($tableElements) {
                    $errorRow = (0, _renderer.default)("<tr>").addClass(ERROR_ROW_CLASS);
                    $closeButton = (0, _renderer.default)("<div>").addClass(ERROR_CLOSEBUTTON_CLASS).addClass(that.addWidgetPrefix(ACTION_CLASS));
                    _events_engine.default.on($closeButton, _click.name, that.createAction(function(args) {
                        var e = args.event;
                        var $errorRow;
                        var errorRowIndex = (0, _renderer.default)(e.currentTarget).closest("." + ERROR_ROW_CLASS).index();
                        e.stopPropagation();
                        (0, _iterator.each)($tableElements, function(_, tableElement) {
                            $errorRow = (0, _renderer.default)(tableElement).children("tbody").children("tr").eq(errorRowIndex);
                            that.removeErrorRow($errorRow)
                        });
                        that.getController("resizing") && that.getController("resizing").fireContentReadyAction()
                    }));
                    (0, _renderer.default)("<td>").attr({
                        colSpan: that.getController("columns").getVisibleColumns().length,
                        role: "presentation"
                    }).prepend($closeButton).append($errorMessage).appendTo($errorRow);
                    return $errorRow
                }
                return $errorMessage
            },
            _renderErrorMessage: function(error) {
                var message = error.url ? error.message.replace(error.url, "") : error.message || error;
                var $message = (0, _renderer.default)("<div>").addClass(ERROR_MESSAGE_CLASS).text(message);
                if (error.url) {
                    (0, _renderer.default)("<a>").attr("href", error.url).text(error.url).appendTo($message)
                }
                return $message
            },
            renderErrorRow: function(error, rowIndex, $popupContent) {
                var that = this;
                var $errorMessageElement;
                var $firstErrorRow;
                if ($popupContent) {
                    $popupContent.find("." + ERROR_MESSAGE_CLASS).remove();
                    $errorMessageElement = that._createErrorRow(error);
                    $popupContent.prepend($errorMessageElement);
                    return $errorMessageElement
                }
                var viewElement = rowIndex >= 0 || !that._columnHeadersView.isVisible() ? that._rowsView : that._columnHeadersView;
                var $tableElements = $popupContent || viewElement.getTableElements();
                (0, _iterator.each)($tableElements, function(_, tableElement) {
                    $errorMessageElement = that._createErrorRow(error, $tableElements);
                    $firstErrorRow = $firstErrorRow || $errorMessageElement;
                    if (rowIndex >= 0) {
                        var $row = viewElement._getRowElements((0, _renderer.default)(tableElement)).eq(rowIndex);
                        that.removeErrorRow($row.next());
                        $errorMessageElement.insertAfter($row)
                    } else {
                        var $tbody = (0, _renderer.default)(tableElement).children("tbody");
                        var rowElements = $tbody.children("tr");
                        if (that._columnHeadersView.isVisible()) {
                            that.removeErrorRow(rowElements.last());
                            (0, _renderer.default)(tableElement).append($errorMessageElement)
                        } else {
                            that.removeErrorRow(rowElements.first());
                            $tbody.first().prepend($errorMessageElement)
                        }
                    }
                });
                if (!$popupContent) {
                    var resizingController = that.getController("resizing");
                    resizingController && resizingController.fireContentReadyAction()
                }
                return $firstErrorRow
            },
            removeErrorRow: function($row) {
                if (!$row) {
                    var $columnHeaders = this._columnHeadersView && this._columnHeadersView.element();
                    $row = $columnHeaders && $columnHeaders.find("." + ERROR_ROW_CLASS);
                    if (!$row || !$row.length) {
                        var $rowsViewElement = this._rowsView.element();
                        $row = $rowsViewElement && $rowsViewElement.find("." + ERROR_ROW_CLASS)
                    }
                }
                $row && $row.hasClass(ERROR_ROW_CLASS) && $row.remove()
            },
            optionChanged: function(args) {
                var that = this;
                switch (args.name) {
                    case "errorRowEnabled":
                        args.handled = true;
                        break;
                    default:
                        that.callBase(args)
                }
            }
        });
        var _default = {
            defaultOptions: function() {
                return {
                    errorRowEnabled: true
                }
            },
            controllers: {
                errorHandling: ErrorHandlingController
            },
            extenders: {
                controllers: {
                    data: {
                        init: function() {
                            var that = this;
                            var errorHandlingController = that.getController("errorHandling");
                            that.callBase();
                            that.dataErrorOccurred.add(function(error, $popupContent) {
                                if (that.option("errorRowEnabled")) {
                                    errorHandlingController.renderErrorRow(error, void 0, $popupContent)
                                }
                            });
                            that.changed.add(function(e) {
                                if (e && "loadError" === e.changeType) {
                                    return
                                }
                                var errorHandlingController = that.getController("errorHandling");
                                var editingController = that.getController("editing");
                                if (editingController && !editingController.hasChanges()) {
                                    errorHandlingController && errorHandlingController.removeErrorRow()
                                }
                            })
                        }
                    }
                }
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.grid_view.js ***!
      \*************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.modules */ 44));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _position = __webpack_require__( /*! ../../core/utils/position */ 22);
        var _uiGrid_core2 = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.utils */ 35));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));
        var accessibility = _interopRequireWildcard(__webpack_require__( /*! ../shared/accessibility */ 118));

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var TABLE_CLASS = "table";
        var BORDERS_CLASS = "borders";
        var TABLE_FIXED_CLASS = "table-fixed";
        var IMPORTANT_MARGIN_CLASS = "important-margin";
        var TEXT_CONTENT_CLASS = "text-content";
        var HIDDEN_CLASS = "dx-hidden";
        var GRIDBASE_CONTAINER_CLASS = "dx-gridbase-container";
        var HIDDEN_COLUMNS_WIDTH = "adaptiveHidden";
        var EDITORS_INPUT_SELECTOR = "input:not([type='hidden'])";
        var VIEW_NAMES = ["columnsSeparatorView", "blockSeparatorView", "trackerView", "headerPanel", "columnHeadersView", "rowsView", "footerView", "columnChooserView", "filterPanelView", "pagerView", "draggingHeaderView", "contextMenuView", "errorView", "headerFilterView", "filterBuilderView"];
        var isPercentWidth = function(width) {
            return (0, _type.isString)(width) && "%" === width.slice(-1)
        };
        var isPixelWidth = function(width) {
            return (0, _type.isString)(width) && "px" === width.slice(-2)
        };
        var mergeArraysByMaxValue = function(values1, values2) {
            var result = [];
            if (values1 && values2 && values1.length && values1.length === values2.length) {
                for (var i = 0; i < values1.length; i++) {
                    result.push(values1[i] > values2[i] ? values1[i] : values2[i])
                }
            } else {
                if (values1 && values1.length) {
                    result = values1
                } else {
                    if (values2) {
                        result = values2
                    }
                }
            }
            return result
        };
        var getContainerHeight = function($container) {
            var clientHeight = $container.get(0).clientHeight;
            var paddingTop = parseFloat($container.css("paddingTop"));
            var paddingBottom = parseFloat($container.css("paddingBottom"));
            return clientHeight - paddingTop - paddingBottom
        };
        var calculateFreeWidth = function(that, widths) {
            var contentWidth = that._rowsView.contentWidth();
            var totalWidth = that._getTotalWidth(widths, contentWidth);
            return contentWidth - totalWidth
        };
        var calculateFreeWidthWithCurrentMinWidth = function(that, columnIndex, currentMinWidth, widths) {
            return calculateFreeWidth(that, widths.map(function(width, index) {
                return index === columnIndex ? currentMinWidth : width
            }))
        };
        var restoreFocus = function(focusedElement, selectionRange) {
            accessibility.hiddenFocus(focusedElement);
            _uiGrid_core2.default.setSelectionRange(focusedElement, selectionRange)
        };
        var ResizingController = _uiGrid_core.default.ViewController.inherit({
            _initPostRenderHandlers: function() {
                var that = this;
                var dataController = that._dataController;
                if (!that._refreshSizesHandler) {
                    that._refreshSizesHandler = function(e) {
                        dataController.changed.remove(that._refreshSizesHandler);
                        var resizeDeferred;
                        var changeType = e && e.changeType;
                        var isDelayed = e && e.isDelayed;
                        var items = dataController.items();
                        if (!e || "refresh" === changeType || "prepend" === changeType || "append" === changeType) {
                            if (!isDelayed) {
                                resizeDeferred = that.resize()
                            }
                        } else {
                            if ("update" === changeType && e.changeTypes) {
                                if ((items.length > 1 || "insert" !== e.changeTypes[0]) && !(0 === items.length && "remove" === e.changeTypes[0]) && !e.needUpdateDimensions) {
                                    (0, _common.deferUpdate)(function() {
                                        that._rowsView.resize()
                                    })
                                } else {
                                    resizeDeferred = that.resize()
                                }
                            }
                        }
                        if (changeType && "updateSelection" !== changeType && "updateFocusedRow" !== changeType && !isDelayed) {
                            (0, _deferred.when)(resizeDeferred).done(function() {
                                that._setAriaRowColCount();
                                that.fireContentReadyAction()
                            })
                        }
                    };
                    that._dataController.changed.add(function() {
                        that._dataController.changed.add(that._refreshSizesHandler)
                    })
                }
            },
            fireContentReadyAction: function() {
                this.component._fireContentReadyAction()
            },
            _setAriaRowColCount: function() {
                var component = this.component;
                component.setAria({
                    rowCount: this._dataController.totalItemsCount(),
                    colCount: component.columnCount()
                }, component.$element().children("." + GRIDBASE_CONTAINER_CLASS))
            },
            _getBestFitWidths: function() {
                var _this$_footerView;
                var rowsView = this._rowsView;
                var columnHeadersView = this._columnHeadersView;
                if (!this.option("legacyRendering")) {
                    var _widths;
                    var widths = rowsView.getColumnWidths();
                    if (!(null !== (_widths = widths) && void 0 !== _widths && _widths.length)) {
                        var _rowsView$getTableEle;
                        var headersTableElement = columnHeadersView.getTableElement();
                        columnHeadersView.setTableElement(null === (_rowsView$getTableEle = rowsView.getTableElement()) || void 0 === _rowsView$getTableEle ? void 0 : _rowsView$getTableEle.children(".dx-header"));
                        widths = columnHeadersView.getColumnWidths();
                        columnHeadersView.setTableElement(headersTableElement)
                    }
                    return widths
                }
                var rowsColumnWidths = rowsView.getColumnWidths();
                var headerColumnWidths = null === columnHeadersView || void 0 === columnHeadersView ? void 0 : columnHeadersView.getColumnWidths();
                var footerColumnWidths = null === (_this$_footerView = this._footerView) || void 0 === _this$_footerView ? void 0 : _this$_footerView.getColumnWidths();
                var resultWidths = mergeArraysByMaxValue(rowsColumnWidths, headerColumnWidths);
                resultWidths = mergeArraysByMaxValue(resultWidths, footerColumnWidths);
                return resultWidths
            },
            _setVisibleWidths: function(visibleColumns, widths) {
                var columnsController = this._columnsController;
                columnsController.beginUpdate();
                (0, _iterator.each)(visibleColumns, function(index, column) {
                    var columnId = columnsController.getColumnId(column);
                    columnsController.columnOption(columnId, "visibleWidth", widths[index])
                });
                columnsController.endUpdate()
            },
            _toggleBestFitModeForView: function(view, className, isBestFit) {
                var _this = this;
                if (!view || !view.isVisible()) {
                    return
                }
                var $rowsTables = this._rowsView.getTableElements();
                var $viewTables = view.getTableElements();
                (0, _iterator.each)($rowsTables, function(index, tableElement) {
                    var $tableBody;
                    var $rowsTable = (0, _renderer.default)(tableElement);
                    var $viewTable = $viewTables.eq(index);
                    if ($viewTable && $viewTable.length) {
                        if (isBestFit) {
                            $tableBody = $viewTable.children("tbody").appendTo($rowsTable)
                        } else {
                            $tableBody = $rowsTable.children("." + className).appendTo($viewTable)
                        }
                        $tableBody.toggleClass(className, isBestFit);
                        $tableBody.toggleClass(_this.addWidgetPrefix("best-fit"), isBestFit)
                    }
                })
            },
            _toggleBestFitMode: function(isBestFit) {
                var $element = this.component.$element();
                var that = this;
                if (!that.option("legacyRendering")) {
                    var $rowsTable = that._rowsView.getTableElement();
                    var $rowsFixedTable = that._rowsView.getTableElements().eq(1);
                    if (!$rowsTable) {
                        return
                    }
                    $rowsTable.css("tableLayout", isBestFit ? "auto" : "fixed");
                    $rowsTable.children("colgroup").css("display", isBestFit ? "none" : "");
                    $rowsFixedTable.toggleClass(this.addWidgetPrefix(TABLE_FIXED_CLASS), !isBestFit);
                    that._toggleBestFitModeForView(that._columnHeadersView, "dx-header", isBestFit);
                    that._toggleBestFitModeForView(that._footerView, "dx-footer", isBestFit);
                    if (that._needStretch()) {
                        $rowsTable.get(0).style.width = isBestFit ? "auto" : ""
                    }
                    if (_browser.default.msie && 11 === parseInt(_browser.default.version)) {
                        $rowsTable.find("." + this.addWidgetPrefix(TABLE_FIXED_CLASS)).each(function() {
                            this.style.width = isBestFit ? "10px" : ""
                        })
                    }
                } else {
                    $element.find("." + this.addWidgetPrefix(TABLE_CLASS)).toggleClass(this.addWidgetPrefix(TABLE_FIXED_CLASS), !isBestFit);
                    $element.find(EDITORS_INPUT_SELECTOR).toggleClass(HIDDEN_CLASS, isBestFit);
                    $element.find(".dx-group-cell").toggleClass(HIDDEN_CLASS, isBestFit);
                    $element.find(".dx-header-row ." + this.addWidgetPrefix(TEXT_CONTENT_CLASS)).css("maxWidth", "")
                }
            },
            _synchronizeColumns: function() {
                var that = this;
                var columnsController = that._columnsController;
                var visibleColumns = columnsController.getVisibleColumns();
                var columnAutoWidth = that.option("columnAutoWidth");
                var legacyRendering = that.option("legacyRendering");
                var needBestFit = that._needBestFit();
                var hasMinWidth = false;
                var resetBestFitMode;
                var isColumnWidthsCorrected = false;
                var resultWidths = [];
                var focusedElement;
                var selectionRange;
                var normalizeWidthsByExpandColumns = function() {
                    var expandColumnWidth;
                    (0, _iterator.each)(visibleColumns, function(index, column) {
                        if ("groupExpand" === column.type) {
                            expandColumnWidth = resultWidths[index]
                        }
                    });
                    (0, _iterator.each)(visibleColumns, function(index, column) {
                        if ("groupExpand" === column.type && expandColumnWidth) {
                            resultWidths[index] = expandColumnWidth
                        }
                    })
                };
                !needBestFit && (0, _iterator.each)(visibleColumns, function(index, column) {
                    if ("auto" === column.width || legacyRendering && column.fixed) {
                        needBestFit = true;
                        return false
                    }
                });
                (0, _iterator.each)(visibleColumns, function(index, column) {
                    if (column.minWidth) {
                        hasMinWidth = true;
                        return false
                    }
                });
                that._setVisibleWidths(visibleColumns, []);
                if (needBestFit) {
                    focusedElement = _dom_adapter.default.getActiveElement();
                    selectionRange = _uiGrid_core2.default.getSelectionRange(focusedElement);
                    that._toggleBestFitMode(true);
                    resetBestFitMode = true
                }(0, _common.deferUpdate)(function() {
                    if (needBestFit) {
                        resultWidths = that._getBestFitWidths();
                        (0, _iterator.each)(visibleColumns, function(index, column) {
                            var columnId = columnsController.getColumnId(column);
                            columnsController.columnOption(columnId, "bestFitWidth", resultWidths[index], true)
                        })
                    } else {
                        if (hasMinWidth) {
                            resultWidths = that._getBestFitWidths()
                        }
                    }(0, _iterator.each)(visibleColumns, function(index) {
                        var width = this.width;
                        if ("auto" !== width) {
                            if ((0, _type.isDefined)(width)) {
                                resultWidths[index] = (0, _type.isNumeric)(width) || isPixelWidth(width) ? parseFloat(width) : width
                            } else {
                                if (!columnAutoWidth) {
                                    resultWidths[index] = void 0
                                }
                            }
                        }
                    });
                    if (resetBestFitMode) {
                        that._toggleBestFitMode(false);
                        resetBestFitMode = false;
                        if (focusedElement && focusedElement !== _dom_adapter.default.getActiveElement()) {
                            var isFocusOutsideWindow = (0, _position.getBoundingRect)(focusedElement).bottom < 0;
                            if (!isFocusOutsideWindow) {
                                if (_browser.default.msie) {
                                    setTimeout(function() {
                                        restoreFocus(focusedElement, selectionRange)
                                    })
                                } else {
                                    restoreFocus(focusedElement, selectionRange)
                                }
                            }
                        }
                    }
                    isColumnWidthsCorrected = that._correctColumnWidths(resultWidths, visibleColumns);
                    if (columnAutoWidth) {
                        normalizeWidthsByExpandColumns();
                        if (that._needStretch()) {
                            that._processStretch(resultWidths, visibleColumns)
                        }
                    }(0, _common.deferRender)(function() {
                        if (needBestFit || isColumnWidthsCorrected) {
                            that._setVisibleWidths(visibleColumns, resultWidths)
                        }
                    })
                })
            },
            _needBestFit: function() {
                return this.option("columnAutoWidth")
            },
            _needStretch: function() {
                return this.option("legacyRendering") || this._columnsController.getVisibleColumns().some(function(c) {
                    return "auto" === c.width && !c.command
                })
            },
            _getAverageColumnsWidth: function(resultWidths) {
                var freeWidth = calculateFreeWidth(this, resultWidths);
                var columnCountWithoutWidth = resultWidths.filter(function(width) {
                    return void 0 === width
                }).length;
                return freeWidth / columnCountWithoutWidth
            },
            _correctColumnWidths: function(resultWidths, visibleColumns) {
                var that = this;
                var i;
                var hasPercentWidth = false;
                var hasAutoWidth = false;
                var isColumnWidthsCorrected = false;
                var $element = that.component.$element();
                var hasWidth = that._hasWidth;
                var _loop = function() {
                    var index = i;
                    var column = visibleColumns[index];
                    var isHiddenColumn = resultWidths[index] === HIDDEN_COLUMNS_WIDTH;
                    var width = resultWidths[index];
                    var minWidth = column.minWidth;
                    if (minWidth) {
                        if (void 0 === width) {
                            var averageColumnsWidth = that._getAverageColumnsWidth(resultWidths);
                            width = averageColumnsWidth
                        } else {
                            if (isPercentWidth(width)) {
                                var freeWidth = calculateFreeWidthWithCurrentMinWidth(that, index, minWidth, resultWidths);
                                if (freeWidth < 0) {
                                    width = -1
                                }
                            }
                        }
                    }
                    var realColumnWidth = that._getRealColumnWidth(index, resultWidths.map(function(columnWidth, columnIndex) {
                        return index === columnIndex ? width : columnWidth
                    }));
                    if (minWidth && !isHiddenColumn && realColumnWidth < minWidth) {
                        resultWidths[index] = minWidth;
                        isColumnWidthsCorrected = true;
                        i = -1
                    }
                    if (!(0, _type.isDefined)(column.width)) {
                        hasAutoWidth = true
                    }
                    if (isPercentWidth(column.width)) {
                        hasPercentWidth = true
                    }
                };
                for (i = 0; i < visibleColumns.length; i++) {
                    _loop()
                }
                if ($element && that._maxWidth) {
                    delete that._maxWidth;
                    $element.css("maxWidth", "")
                }
                if (!hasAutoWidth && resultWidths.length) {
                    var contentWidth = that._rowsView.contentWidth();
                    var scrollbarWidth = that._rowsView.getScrollbarWidth();
                    var totalWidth = that._getTotalWidth(resultWidths, contentWidth);
                    if (totalWidth < contentWidth) {
                        var lastColumnIndex = _uiGrid_core2.default.getLastResizableColumnIndex(visibleColumns, resultWidths);
                        if (lastColumnIndex >= 0) {
                            resultWidths[lastColumnIndex] = "auto";
                            isColumnWidthsCorrected = true;
                            if (false === hasWidth && !hasPercentWidth) {
                                that._maxWidth = totalWidth + scrollbarWidth + (that.option("showBorders") ? 2 : 0);
                                $element.css("maxWidth", that._maxWidth)
                            }
                        }
                    }
                }
                return isColumnWidthsCorrected
            },
            _processStretch: function(resultSizes, visibleColumns) {
                var groupSize = this._rowsView.contentWidth();
                var tableSize = this._getTotalWidth(resultSizes, groupSize);
                var unusedIndexes = {
                    length: 0
                };
                if (!resultSizes.length) {
                    return
                }(0, _iterator.each)(visibleColumns, function(index) {
                    if (this.width || resultSizes[index] === HIDDEN_COLUMNS_WIDTH) {
                        unusedIndexes[index] = true;
                        unusedIndexes.length++
                    }
                });
                var diff = groupSize - tableSize;
                var diffElement = Math.floor(diff / (resultSizes.length - unusedIndexes.length));
                var onePixelElementsCount = diff - diffElement * (resultSizes.length - unusedIndexes.length);
                if (diff >= 0) {
                    for (var i = 0; i < resultSizes.length; i++) {
                        if (unusedIndexes[i]) {
                            continue
                        }
                        resultSizes[i] += diffElement;
                        if (onePixelElementsCount > 0) {
                            if (onePixelElementsCount < 1) {
                                resultSizes[i] += onePixelElementsCount;
                                onePixelElementsCount = 0
                            } else {
                                resultSizes[i]++;
                                onePixelElementsCount--
                            }
                        }
                    }
                }
            },
            _getRealColumnWidth: function(columnIndex, columnWidths, groupWidth) {
                var ratio = 1;
                var width = columnWidths[columnIndex];
                if (!isPercentWidth(width)) {
                    return parseFloat(width)
                }
                var percentTotalWidth = columnWidths.reduce(function(sum, width, index) {
                    if (!isPercentWidth(width)) {
                        return sum
                    }
                    return sum + parseFloat(width)
                }, 0);
                var pixelTotalWidth = columnWidths.reduce(function(sum, width) {
                    if (!width || width === HIDDEN_COLUMNS_WIDTH || isPercentWidth(width)) {
                        return sum
                    }
                    return sum + parseFloat(width)
                }, 0);
                groupWidth = groupWidth || this._rowsView.contentWidth();
                var freeSpace = groupWidth - pixelTotalWidth;
                var percentTotalWidthInPixel = percentTotalWidth * groupWidth / 100;
                if (pixelTotalWidth > 0 && percentTotalWidthInPixel + pixelTotalWidth >= groupWidth) {
                    ratio = percentTotalWidthInPixel > freeSpace ? freeSpace / percentTotalWidthInPixel : 1
                }
                return parseFloat(width) * groupWidth * ratio / 100
            },
            _getTotalWidth: function(widths, groupWidth) {
                var result = 0;
                for (var i = 0; i < widths.length; i++) {
                    var width = widths[i];
                    if (width && width !== HIDDEN_COLUMNS_WIDTH) {
                        result += this._getRealColumnWidth(i, widths, groupWidth)
                    }
                }
                return Math.ceil(result)
            },
            updateSize: function($rootElement) {
                var that = this;
                var $groupElement;
                var width;
                var importantMarginClass = that.addWidgetPrefix(IMPORTANT_MARGIN_CLASS);
                if (void 0 === that._hasHeight && $rootElement && $rootElement.is(":visible") && $rootElement.width()) {
                    $groupElement = $rootElement.children("." + that.getWidgetContainerClass());
                    if ($groupElement.length) {
                        $groupElement.detach()
                    }
                    that._hasHeight = !!getContainerHeight($rootElement);
                    width = $rootElement.width();
                    $rootElement.addClass(importantMarginClass);
                    that._hasWidth = $rootElement.width() === width;
                    $rootElement.removeClass(importantMarginClass);
                    if ($groupElement.length) {
                        $groupElement.appendTo($rootElement)
                    }
                }
            },
            publicMethods: function() {
                return ["resize", "updateDimensions"]
            },
            resize: function() {
                return !this.component._requireResize && this.updateDimensions()
            },
            updateDimensions: function(checkSize) {
                var that = this;
                that._initPostRenderHandlers();
                if (!that._checkSize(checkSize)) {
                    return
                }
                var prevResult = that._resizeDeferred;
                var result = that._resizeDeferred = new _deferred.Deferred;
                (0, _deferred.when)(prevResult).always(function() {
                    (0, _common.deferRender)(function() {
                        if (that._dataController.isLoaded()) {
                            that._synchronizeColumns()
                        }
                        that._resetGroupElementHeight();
                        (0, _common.deferUpdate)(function() {
                            (0, _common.deferRender)(function() {
                                (0, _common.deferUpdate)(function() {
                                    that._updateDimensionsCore()
                                })
                            })
                        })
                    }).done(result.resolve).fail(result.reject)
                });
                return result.promise()
            },
            _resetGroupElementHeight: function() {
                var groupElement = this.component.$element().children().get(0);
                var scrollable = this._rowsView.getScrollable();
                if (groupElement && groupElement.style.height && (!scrollable || !scrollable.scrollTop())) {
                    groupElement.style.height = ""
                }
            },
            _checkSize: function(checkSize) {
                var $rootElement = this.component.$element();
                if (checkSize && (this._lastWidth === $rootElement.width() && this._lastHeight === $rootElement.height() || !$rootElement.is(":visible"))) {
                    return false
                }
                return true
            },
            _setScrollerSpacingCore: function(hasHeight) {
                var that = this;
                var vScrollbarWidth = hasHeight ? that._rowsView.getScrollbarWidth() : 0;
                var hScrollbarWidth = that._rowsView.getScrollbarWidth(true);
                (0, _common.deferRender)(function() {
                    that._columnHeadersView && that._columnHeadersView.setScrollerSpacing(vScrollbarWidth);
                    that._footerView && that._footerView.setScrollerSpacing(vScrollbarWidth);
                    that._rowsView.setScrollerSpacing(vScrollbarWidth, hScrollbarWidth)
                })
            },
            _setScrollerSpacing: function(hasHeight) {
                var _this2 = this;
                if (true === this.option("scrolling.useNative")) {
                    (0, _common.deferRender)(function() {
                        (0, _common.deferUpdate)(function() {
                            _this2._setScrollerSpacingCore(hasHeight)
                        })
                    })
                } else {
                    this._setScrollerSpacingCore(hasHeight)
                }
            },
            _updateDimensionsCore: function() {
                var that = this;
                var dataController = that._dataController;
                var rowsView = that._rowsView;
                var $rootElement = that.component.$element();
                var groupElement = $rootElement.children().get(0);
                var rootElementHeight = $rootElement && ($rootElement.get(0).clientHeight || $rootElement.height());
                var maxHeight = parseInt($rootElement.css("maxHeight"));
                var maxHeightHappened = maxHeight && rootElementHeight >= maxHeight;
                var height = that.option("height") || $rootElement.get(0).style.height;
                var editorFactory = that.getController("editorFactory");
                var isMaxHeightApplied = maxHeightHappened && groupElement.scrollHeight === groupElement.offsetHeight;
                var $testDiv;
                that.updateSize($rootElement);
                var hasHeight = that._hasHeight || maxHeightHappened;
                if (height && that._hasHeight ^ "auto" !== height) {
                    $testDiv = (0, _renderer.default)("<div>").height(height).appendTo($rootElement);
                    that._hasHeight = !!$testDiv.height();
                    $testDiv.remove()
                }(0, _common.deferRender)(function() {
                    rowsView.height(null, hasHeight);
                    if (maxHeightHappened && !isMaxHeightApplied) {
                        (0, _renderer.default)(groupElement).css("height", maxHeight)
                    }
                    if (!dataController.isLoaded()) {
                        rowsView.setLoading(dataController.isLoading());
                        return
                    }(0, _common.deferUpdate)(function() {
                        that._updateLastSizes($rootElement);
                        that._setScrollerSpacing(hasHeight);
                        (0, _iterator.each)(VIEW_NAMES, function(index, viewName) {
                            var view = that.getView(viewName);
                            if (view) {
                                view.resize()
                            }
                        });
                        editorFactory && editorFactory.resize()
                    })
                })
            },
            _updateLastSizes: function($rootElement) {
                this._lastWidth = $rootElement.width();
                this._lastHeight = $rootElement.height()
            },
            optionChanged: function(args) {
                switch (args.name) {
                    case "width":
                    case "height":
                        this.component._renderDimensions();
                        this.resize();
                    case "legacyRendering":
                    case "renderAsync":
                        args.handled = true;
                        return;
                    default:
                        this.callBase(args)
                }
            },
            init: function() {
                var that = this;
                that._dataController = that.getController("data");
                that._columnsController = that.getController("columns");
                that._columnHeadersView = that.getView("columnHeadersView");
                that._footerView = that.getView("footerView");
                that._rowsView = that.getView("rowsView")
            }
        });
        var SynchronizeScrollingController = _uiGrid_core.default.ViewController.inherit({
            _scrollChangedHandler: function(views, pos, viewName) {
                for (var j = 0; j < views.length; j++) {
                    if (views[j] && views[j].name !== viewName) {
                        views[j].scrollTo({
                            left: pos.left,
                            top: pos.top
                        })
                    }
                }
            },
            init: function() {
                var views = [this.getView("columnHeadersView"), this.getView("footerView"), this.getView("rowsView")];
                for (var i = 0; i < views.length; i++) {
                    var view = views[i];
                    if (view) {
                        view.scrollChanged.add(this._scrollChangedHandler.bind(this, views))
                    }
                }
            }
        });
        var GridView = _uiGrid_core.default.View.inherit({
            _endUpdateCore: function() {
                if (this.component._requireResize) {
                    this.component._requireResize = false;
                    this._resizingController.resize()
                }
            },
            _getWidgetAriaLabel: function() {
                return "dxDataGrid-ariaDataGrid"
            },
            init: function() {
                var that = this;
                that._resizingController = that.getController("resizing");
                that._dataController = that.getController("data")
            },
            getView: function(name) {
                return this.component._views[name]
            },
            element: function() {
                return this._groupElement
            },
            optionChanged: function(args) {
                var that = this;
                if ((0, _type.isDefined)(that._groupElement) && "showBorders" === args.name) {
                    that._groupElement.toggleClass(that.addWidgetPrefix(BORDERS_CLASS), !!args.value);
                    args.handled = true
                } else {
                    that.callBase(args)
                }
            },
            _renderViews: function($groupElement) {
                var that = this;
                (0, _iterator.each)(VIEW_NAMES, function(index, viewName) {
                    var view = that.getView(viewName);
                    if (view) {
                        view.render($groupElement)
                    }
                })
            },
            _getTableRoleName: function() {
                return "grid"
            },
            render: function($rootElement) {
                var that = this;
                var isFirstRender = !that._groupElement;
                var $groupElement = that._groupElement || (0, _renderer.default)("<div>").addClass(that.getWidgetContainerClass());
                $groupElement.addClass(GRIDBASE_CONTAINER_CLASS);
                $groupElement.toggleClass(that.addWidgetPrefix(BORDERS_CLASS), !!that.option("showBorders"));
                that.setAria("role", "presentation", $rootElement);
                that.component.setAria({
                    role: this._getTableRoleName(),
                    label: _message.default.format(that._getWidgetAriaLabel())
                }, $groupElement);
                that._rootElement = $rootElement || that._rootElement;
                if (isFirstRender) {
                    that._groupElement = $groupElement;
                    (0, _window.hasWindow)() && that.getController("resizing").updateSize($rootElement);
                    $groupElement.appendTo($rootElement)
                }
                that._renderViews($groupElement)
            },
            update: function() {
                var that = this;
                var $rootElement = that._rootElement;
                var $groupElement = that._groupElement;
                var resizingController = that.getController("resizing");
                if ($rootElement && $groupElement) {
                    resizingController.resize();
                    if (that._dataController.isLoaded()) {
                        that._resizingController.fireContentReadyAction()
                    }
                }
            }
        });
        var _default = {
            defaultOptions: function() {
                return {
                    showBorders: false,
                    renderAsync: false,
                    legacyRendering: false
                }
            },
            controllers: {
                resizing: ResizingController,
                synchronizeScrolling: SynchronizeScrollingController
            },
            views: {
                gridView: GridView
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.header_panel.js ***!
      \****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _toolbar = _interopRequireDefault(__webpack_require__( /*! ../toolbar */ 157));
        var _uiGrid_core = __webpack_require__( /*! ./ui.grid_core.columns_view */ 183);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _visibility_change = __webpack_require__( /*! ../../events/visibility_change */ 59);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        __webpack_require__( /*! ../drop_down_menu */ 214);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var HEADER_PANEL_CLASS = "header-panel";
        var TOOLBAR_BUTTON_CLASS = "toolbar-button";
        var TOOLBAR_ARIA_LABEL = "-ariaToolbar";
        var HeaderPanel = _uiGrid_core.ColumnsView.inherit({
            _getToolbarItems: function() {
                return []
            },
            _getButtonContainer: function() {
                return (0, _renderer.default)("<div>").addClass(this.addWidgetPrefix(TOOLBAR_BUTTON_CLASS))
            },
            _getToolbarButtonClass: function(specificClass) {
                var secondClass = specificClass ? " " + specificClass : "";
                return this.addWidgetPrefix(TOOLBAR_BUTTON_CLASS) + secondClass
            },
            _getToolbarOptions: function() {
                var options = {
                    toolbarOptions: {
                        items: this._getToolbarItems(),
                        onItemRendered: function(e) {
                            var itemRenderedCallback = e.itemData.onItemRendered;
                            if (itemRenderedCallback) {
                                itemRenderedCallback(e)
                            }
                        }
                    }
                };
                this.executeAction("onToolbarPreparing", options);
                if (options.toolbarOptions && !(0, _type.isDefined)(options.toolbarOptions.visible)) {
                    var toolbarItems = options.toolbarOptions.items;
                    options.toolbarOptions.visible = !!(toolbarItems && toolbarItems.length)
                }
                return options.toolbarOptions
            },
            _renderCore: function() {
                if (!this._toolbar) {
                    var $headerPanel = this.element();
                    $headerPanel.addClass(this.addWidgetPrefix(HEADER_PANEL_CLASS));
                    var label = _message.default.format(this.component.NAME + TOOLBAR_ARIA_LABEL);
                    var $toolbar = (0, _renderer.default)("<div>").attr("aria-label", label).appendTo($headerPanel);
                    this._toolbar = this._createComponent($toolbar, _toolbar.default, this._toolbarOptions)
                } else {
                    this._toolbar.option(this._toolbarOptions)
                }
            },
            _columnOptionChanged: _common.noop,
            _handleDataChanged: function() {
                if (this._requireReady) {
                    this.render()
                }
            },
            init: function() {
                this.callBase();
                this.createAction("onToolbarPreparing", {
                    excludeValidators: ["disabled", "readOnly"]
                })
            },
            render: function() {
                this._toolbarOptions = this._getToolbarOptions();
                this.callBase.apply(this, arguments)
            },
            setToolbarItemDisabled: function(name, optionValue) {
                var toolbarInstance = this._toolbar;
                if (toolbarInstance) {
                    var items = toolbarInstance.option("items") || [];
                    var itemIndex = items.indexOf(items.filter(function(item) {
                        return item.name === name
                    })[0]);
                    if (itemIndex >= 0) {
                        var itemOptionPrefix = "items[" + itemIndex + "]";
                        if (toolbarInstance.option(itemOptionPrefix + ".options")) {
                            toolbarInstance.option(itemOptionPrefix + ".options.disabled", optionValue)
                        } else {
                            toolbarInstance.option(itemOptionPrefix + ".disabled", optionValue)
                        }
                    }
                }
            },
            updateToolbarDimensions: function() {
                if (this._toolbar) {
                    (0, _visibility_change.triggerResizeEvent)(this.getHeaderPanel())
                }
            },
            getHeaderPanel: function() {
                return this.element()
            },
            getHeight: function() {
                return this.getElementHeight()
            },
            optionChanged: function(args) {
                if ("onToolbarPreparing" === args.name) {
                    this._invalidate();
                    args.handled = true
                }
                this.callBase(args)
            },
            isVisible: function() {
                return this._toolbarOptions && this._toolbarOptions.visible
            },
            allowDragging: _common.noop
        });
        var _default = {
            defaultOptions: function() {
                return {}
            },
            views: {
                headerPanel: HeaderPanel
            },
            extenders: {
                controllers: {
                    resizing: {
                        _updateDimensionsCore: function() {
                            this.callBase.apply(this, arguments);
                            this.getView("headerPanel").updateToolbarDimensions()
                        }
                    }
                }
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.state_storing.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _uiGrid_core = __webpack_require__( /*! ./ui.grid_core.state_storing_core */ 392);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var getDataState = function(that) {
            var pagerView = that.getView("pagerView");
            var dataController = that.getController("data");
            var state = {
                allowedPageSizes: pagerView ? pagerView.getPageSizes() : void 0,
                filterPanel: {
                    filterEnabled: that.option("filterPanel.filterEnabled")
                },
                filterValue: that.option("filterValue"),
                focusedRowKey: that.option("focusedRowEnabled") ? that.option("focusedRowKey") : void 0
            };
            return (0, _extend.extend)(state, dataController.getUserState())
        };
        var processLoadState = function(that) {
            var columnsController = that.getController("columns");
            var selectionController = that.getController("selection");
            var exportController = that.getController("export");
            var dataController = that.getController("data");
            if (columnsController) {
                columnsController.columnsChanged.add(function() {
                    that.updateState({
                        columns: columnsController.getUserState()
                    })
                })
            }
            if (selectionController) {
                selectionController.selectionChanged.add(function(e) {
                    that.updateState({
                        selectedRowKeys: e.selectedRowKeys,
                        selectionFilter: e.selectionFilter
                    })
                })
            }
            if (dataController) {
                that._initialPageSize = that.option("paging.pageSize");
                that._initialFilterValue = that.option("filterValue");
                dataController.changed.add(function() {
                    var state = getDataState(that);
                    that.updateState(state)
                })
            }
            if (exportController) {
                exportController.selectionOnlyChanged.add(function() {
                    that.updateState({
                        exportSelectionOnly: exportController.selectionOnly()
                    })
                })
            }
        };
        var DEFAULT_FILTER_VALUE = null;
        var getFilterValue = function(that, state) {
            var filterSyncController = that.getController("filterSync");
            var columnsController = that.getController("columns");
            var hasFilterState = state.columns || void 0 !== state.filterValue;
            if (filterSyncController) {
                if (hasFilterState) {
                    return state.filterValue || filterSyncController.getFilterValueFromColumns(state.columns)
                } else {
                    return that._initialFilterValue || filterSyncController.getFilterValueFromColumns(columnsController.getColumns())
                }
            }
            return DEFAULT_FILTER_VALUE
        };
        var _default = {
            defaultOptions: function() {
                return {
                    stateStoring: {
                        enabled: false,
                        storageKey: null,
                        type: "localStorage",
                        customLoad: null,
                        customSave: null,
                        savingTimeout: 2e3
                    }
                }
            },
            controllers: {
                stateStoring: _uiGrid_core.StateStoringController
            },
            extenders: {
                views: {
                    rowsView: {
                        init: function() {
                            var that = this;
                            var dataController = that.getController("data");
                            that.callBase();
                            dataController.stateLoaded.add(function() {
                                if (dataController.isLoaded() && !dataController.getDataSource()) {
                                    that.setLoading(false);
                                    that.renderNoDataText();
                                    var columnHeadersView = that.component.getView("columnHeadersView");
                                    columnHeadersView && columnHeadersView.render();
                                    that.component._fireContentReadyAction()
                                }
                            })
                        }
                    }
                },
                controllers: {
                    stateStoring: {
                        init: function() {
                            this.callBase.apply(this, arguments);
                            processLoadState(this)
                        },
                        isLoading: function() {
                            return this.callBase() || this.getController("data").isStateLoading()
                        },
                        state: function(_state) {
                            var result = this.callBase.apply(this, arguments);
                            if (void 0 !== _state) {
                                this.applyState((0, _extend.extend)({}, _state))
                            }
                            return result
                        },
                        updateState: function(state) {
                            if (this.isEnabled()) {
                                var oldState = this.state();
                                var newState = (0, _extend.extend)({}, oldState, state);
                                var oldStateHash = (0, _common.getKeyHash)(oldState);
                                var newStateHash = (0, _common.getKeyHash)(newState);
                                if (!(0, _common.equalByValue)(oldStateHash, newStateHash)) {
                                    (0, _extend.extend)(this._state, state);
                                    this.save()
                                }
                            } else {
                                (0, _extend.extend)(this._state, state)
                            }
                        },
                        applyState: function(state) {
                            var that = this;
                            var allowedPageSizes = state.allowedPageSizes;
                            var searchText = state.searchText;
                            var selectedRowKeys = state.selectedRowKeys;
                            var selectionFilter = state.selectionFilter;
                            var exportController = that.getController("export");
                            var columnsController = that.getController("columns");
                            var dataController = that.getController("data");
                            var scrollingMode = that.option("scrolling.mode");
                            var isVirtualScrollingMode = "virtual" === scrollingMode || "infinite" === scrollingMode;
                            var showPageSizeSelector = true === that.option("pager.visible") && that.option("pager.showPageSizeSelector");
                            that.component.beginUpdate();
                            if (columnsController) {
                                columnsController.setUserState(state.columns)
                            }
                            if (exportController) {
                                exportController.selectionOnly(state.exportSelectionOnly)
                            }
                            if (selectedRowKeys) {
                                that.option("selectedRowKeys", selectedRowKeys)
                            }
                            that.option("selectionFilter", selectionFilter);
                            if (allowedPageSizes && "auto" === that.option("pager.allowedPageSizes")) {
                                that.option("pager").allowedPageSizes = allowedPageSizes
                            }
                            if (that.option("focusedRowEnabled") && void 0 !== state.focusedRowKey) {
                                that.option("focusedRowKey", state.focusedRowKey)
                            }
                            that.component.endUpdate();
                            searchText && that.option("searchPanel.text", searchText);
                            that.option("filterValue", getFilterValue(that, state));
                            that.option("filterPanel.filterEnabled", state.filterPanel ? state.filterPanel.filterEnabled : true);
                            that.option("paging.pageSize", (!isVirtualScrollingMode || showPageSizeSelector) && (0, _type.isDefined)(state.pageSize) ? state.pageSize : that._initialPageSize);
                            that.option("paging.pageIndex", state.pageIndex || 0);
                            dataController && dataController.reset()
                        }
                    },
                    columns: {
                        getVisibleColumns: function() {
                            var visibleColumns = this.callBase.apply(this, arguments);
                            var stateStoringController = this.getController("stateStoring");
                            return stateStoringController.isEnabled() && !stateStoringController.isLoaded() ? [] : visibleColumns
                        }
                    },
                    data: {
                        callbackNames: function() {
                            return this.callBase().concat(["stateLoaded"])
                        },
                        _refreshDataSource: function() {
                            var _this = this;
                            var callBase = this.callBase;
                            var stateStoringController = this.getController("stateStoring");
                            if (stateStoringController.isEnabled() && !stateStoringController.isLoaded()) {
                                clearTimeout(this._restoreStateTimeoutID);
                                var deferred = new _deferred.Deferred;
                                this._restoreStateTimeoutID = setTimeout(function() {
                                    stateStoringController.load().always(function() {
                                        _this._restoreStateTimeoutID = null
                                    }).done(function() {
                                        callBase.call(_this);
                                        _this.stateLoaded.fire();
                                        deferred.resolve()
                                    }).fail(function(error) {
                                        _this.stateLoaded.fire();
                                        _this._handleLoadError(error || "Unknown error");
                                        deferred.reject()
                                    })
                                });
                                return deferred.promise()
                            } else {
                                if (!this.isStateLoading()) {
                                    callBase.call(this)
                                }
                            }
                        },
                        isLoading: function() {
                            var that = this;
                            var stateStoringController = that.getController("stateStoring");
                            return this.callBase() || stateStoringController.isLoading()
                        },
                        isStateLoading: function() {
                            return (0, _type.isDefined)(this._restoreStateTimeoutID)
                        },
                        isLoaded: function() {
                            return this.callBase() && !this.isStateLoading()
                        },
                        dispose: function() {
                            clearTimeout(this._restoreStateTimeoutID);
                            this.callBase()
                        }
                    },
                    selection: {
                        _fireSelectionChanged: function(options) {
                            var stateStoringController = this.getController("stateStoring");
                            var isDeferredSelection = this.option("selection.deferred");
                            if (stateStoringController.isLoading() && isDeferredSelection) {
                                return
                            }
                            this.callBase.apply(this, arguments)
                        }
                    }
                }
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.state_storing_core.js ***!
      \**********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.StateStoringController = void 0;
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.modules */ 44));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));
        var _storage = __webpack_require__( /*! ../../core/utils/storage */ 324);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DATE_REGEX = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/;
        var parseDates = function parseDates(state) {
            if (!state) {
                return
            }(0, _iterator.each)(state, function(key, value) {
                if ((0, _type.isPlainObject)(value) || Array.isArray(value)) {
                    parseDates(value)
                } else {
                    if ("string" === typeof value) {
                        var date = DATE_REGEX.exec(value);
                        if (date) {
                            state[key] = new Date(Date.UTC(+date[1], +date[2] - 1, +date[3], +date[4], +date[5], +date[6]))
                        }
                    }
                }
            })
        };
        var StateStoringController = _uiGrid_core.default.ViewController.inherit(function() {
            var getStorage = function(options) {
                var storage = "sessionStorage" === options.type ? (0, _storage.sessionStorage)() : (0, _window.getWindow)().localStorage;
                if (!storage) {
                    if ("file:" === (0, _window.getWindow)().location.protocol && _browser.default.msie) {
                        throw new Error("E1038")
                    } else {
                        throw new Error("E1007")
                    }
                }
                return storage
            };
            var getUniqueStorageKey = function(options) {
                return (0, _type.isDefined)(options.storageKey) ? options.storageKey : "storage"
            };
            return {
                _loadState: function() {
                    var options = this.option("stateStoring");
                    if ("custom" === options.type) {
                        return options.customLoad && options.customLoad()
                    }
                    try {
                        return JSON.parse(getStorage(options).getItem(getUniqueStorageKey(options)))
                    } catch (e) {
                        _ui.default.log(e.message)
                    }
                },
                _saveState: function(state) {
                    var options = this.option("stateStoring");
                    if ("custom" === options.type) {
                        options.customSave && options.customSave(state);
                        return
                    }
                    try {
                        getStorage(options).setItem(getUniqueStorageKey(options), JSON.stringify(state))
                    } catch (e) {
                        _ui.default.log(e.message)
                    }
                },
                publicMethods: function() {
                    return ["state"]
                },
                isEnabled: function() {
                    return this.option("stateStoring.enabled")
                },
                init: function() {
                    var that = this;
                    that._state = {};
                    that._isLoaded = false;
                    that._isLoading = false;
                    that._windowUnloadHandler = function() {
                        if (void 0 !== that._savingTimeoutID) {
                            that._saveState(that.state())
                        }
                    };
                    _events_engine.default.on((0, _window.getWindow)(), "unload", that._windowUnloadHandler);
                    return that
                },
                isLoaded: function() {
                    return this._isLoaded
                },
                isLoading: function() {
                    return this._isLoading
                },
                load: function() {
                    var _this = this;
                    this._isLoading = true;
                    var loadResult = (0, _deferred.fromPromise)(this._loadState());
                    loadResult.always(function() {
                        _this._isLoaded = true;
                        _this._isLoading = false
                    }).done(function(state) {
                        _this.state(state)
                    });
                    return loadResult
                },
                state: function(_state) {
                    var that = this;
                    if (!arguments.length) {
                        return (0, _extend.extend)(true, {}, that._state)
                    } else {
                        that._state = (0, _extend.extend)({}, _state);
                        parseDates(that._state)
                    }
                },
                save: function() {
                    var that = this;
                    clearTimeout(that._savingTimeoutID);
                    that._savingTimeoutID = setTimeout(function() {
                        that._saveState(that.state());
                        that._savingTimeoutID = void 0
                    }, that.option("stateStoring.savingTimeout"))
                },
                optionChanged: function(args) {
                    var that = this;
                    switch (args.name) {
                        case "stateStoring":
                            if (that.isEnabled() && !that.isLoading()) {
                                that.load()
                            }
                            args.handled = true;
                            break;
                        default:
                            that.callBase(args)
                    }
                },
                dispose: function() {
                    clearTimeout(this._savingTimeoutID);
                    _events_engine.default.off((0, _window.getWindow)(), "unload", this._windowUnloadHandler)
                }
            }
        }());
        exports.StateStoringController = StateStoringController
    },
    /*!*************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.selection.js ***!
      \*************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ../data_grid/ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.utils */ 35));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _support = __webpack_require__( /*! ../../core/utils/support */ 45);
        var _click = __webpack_require__( /*! ../../events/click */ 21);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _hold = _interopRequireDefault(__webpack_require__( /*! ../../events/hold */ 104));
        var _selection = _interopRequireDefault(__webpack_require__( /*! ../selection/selection */ 233));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var EDITOR_CELL_CLASS = "dx-editor-cell";
        var ROW_CLASS = "dx-row";
        var ROW_SELECTION_CLASS = "dx-selection";
        var SELECT_CHECKBOX_CLASS = "dx-select-checkbox";
        var CHECKBOXES_HIDDEN_CLASS = "dx-select-checkboxes-hidden";
        var COMMAND_SELECT_CLASS = "dx-command-select";
        var SELECTION_DISABLED_CLASS = "dx-selection-disabled";
        var DATA_ROW_CLASS = "dx-data-row";
        var SHOW_CHECKBOXES_MODE = "selection.showCheckBoxesMode";
        var SELECTION_MODE = "selection.mode";
        var processLongTap = function(that, dxEvent) {
            var selectionController = that.getController("selection");
            var rowsView = that.getView("rowsView");
            var $row = (0, _renderer.default)(dxEvent.target).closest("." + DATA_ROW_CLASS);
            var rowIndex = rowsView.getRowIndex($row);
            if (rowIndex < 0) {
                return
            }
            if ("onLongTap" === that.option(SHOW_CHECKBOXES_MODE)) {
                if (selectionController.isSelectionWithCheckboxes()) {
                    selectionController.stopSelectionWithCheckboxes()
                } else {
                    selectionController.startSelectionWithCheckboxes()
                }
            } else {
                if ("onClick" === that.option(SHOW_CHECKBOXES_MODE)) {
                    selectionController.startSelectionWithCheckboxes()
                }
                if ("always" !== that.option(SHOW_CHECKBOXES_MODE)) {
                    selectionController.changeItemSelection(rowIndex, {
                        control: true
                    })
                }
            }
        };
        var SelectionController = _uiData_grid.default.Controller.inherit(function() {
            var isSeveralRowsSelected = function(that, selectionFilter) {
                var keyIndex = 0;
                var store = that._dataController.store();
                var key = store && store.key();
                var isComplexKey = Array.isArray(key);
                if (!selectionFilter.length) {
                    return false
                }
                if (isComplexKey && Array.isArray(selectionFilter[0]) && "and" === selectionFilter[1]) {
                    for (var i = 0; i < selectionFilter.length; i++) {
                        if (Array.isArray(selectionFilter[i])) {
                            if (selectionFilter[i][0] !== key[keyIndex] || "=" !== selectionFilter[i][1]) {
                                return true
                            }
                            keyIndex++
                        }
                    }
                    return false
                }
                return key !== selectionFilter[0]
            };
            var selectionCellTemplate = function(container, options) {
                var component = options.component;
                var rowsView = component.getView("rowsView");
                if (component.option("renderAsync") && !component.option("selection.deferred")) {
                    options.value = component.isRowSelected(options.row.key)
                }
                rowsView.renderSelectCheckBoxContainer((0, _renderer.default)(container), options)
            };
            var selectionHeaderTemplate = function(container, options) {
                var column = options.column;
                var $cellElement = (0, _renderer.default)(container);
                var columnHeadersView = options.component.getView("columnHeadersView");
                $cellElement.addClass(EDITOR_CELL_CLASS);
                columnHeadersView._renderSelectAllCheckBox($cellElement, column);
                columnHeadersView._attachSelectAllCheckBoxClickEvent($cellElement)
            };
            return {
                init: function() {
                    this._dataController = this.getController("data");
                    this._selectionMode = this.option(SELECTION_MODE);
                    this._isSelectionWithCheckboxes = false;
                    this._selection = this._createSelection();
                    this._updateSelectColumn();
                    this.createAction("onSelectionChanged", {
                        excludeValidators: ["disabled", "readOnly"]
                    })
                },
                _getSelectionConfig: function() {
                    var that = this;
                    var dataController = that._dataController;
                    var selectionOptions = that.option("selection") || {};
                    return {
                        selectedKeys: that.option("selectedRowKeys"),
                        mode: that._selectionMode,
                        deferred: selectionOptions.deferred,
                        maxFilterLengthInRequest: selectionOptions.maxFilterLengthInRequest,
                        selectionFilter: that.option("selectionFilter"),
                        key: function() {
                            return dataController && dataController.key()
                        },
                        keyOf: function(item) {
                            return dataController && dataController.keyOf(item)
                        },
                        dataFields: function() {
                            return dataController.dataSource() && dataController.dataSource().select()
                        },
                        load: function(options) {
                            return dataController.dataSource() && dataController.dataSource().load(options) || (new _deferred.Deferred).resolve([])
                        },
                        plainItems: function() {
                            return dataController.items(true)
                        },
                        isItemSelected: function(item) {
                            return item.selected
                        },
                        isSelectableItem: function(item) {
                            return item && "data" === item.rowType && !item.isNewRow
                        },
                        getItemData: function(item) {
                            return item && (item.oldData || item.data || item)
                        },
                        filter: function() {
                            return dataController.getCombinedFilter(true)
                        },
                        totalCount: function() {
                            return dataController.totalCount()
                        },
                        onSelectionChanged: that._updateSelectedItems.bind(this)
                    }
                },
                _updateSelectColumn: function() {
                    var columnsController = this.getController("columns");
                    var isSelectColumnVisible = this.isSelectColumnVisible();
                    columnsController.addCommandColumn({
                        type: "selection",
                        command: "select",
                        visible: isSelectColumnVisible,
                        visibleIndex: -1,
                        dataType: "boolean",
                        alignment: "center",
                        cssClass: COMMAND_SELECT_CLASS,
                        width: "auto",
                        cellTemplate: selectionCellTemplate,
                        headerCellTemplate: selectionHeaderTemplate
                    });
                    columnsController.columnOption("command:select", "visible", isSelectColumnVisible)
                },
                _createSelection: function() {
                    var options = this._getSelectionConfig();
                    return new _selection.default(options)
                },
                _fireSelectionChanged: function(options) {
                    if (options) {
                        this.executeAction("onSelectionChanged", options)
                    }
                    var argument = this.option("selection.deferred") ? {
                        selectionFilter: this.option("selectionFilter")
                    } : {
                        selectedRowKeys: this.option("selectedRowKeys")
                    };
                    this.selectionChanged.fire(argument)
                },
                _updateCheckboxesState: function(options) {
                    var isDeferredMode = options.isDeferredMode;
                    var selectionFilter = options.selectionFilter;
                    var selectedItemKeys = options.selectedItemKeys;
                    var removedItemKeys = options.removedItemKeys;
                    if ("onClick" === this.option(SHOW_CHECKBOXES_MODE)) {
                        if (isDeferredMode ? selectionFilter && isSeveralRowsSelected(this, selectionFilter) : selectedItemKeys.length > 1) {
                            this.startSelectionWithCheckboxes()
                        } else {
                            if (isDeferredMode ? selectionFilter && !selectionFilter.length : 0 === selectedItemKeys.length && removedItemKeys.length) {
                                this.stopSelectionWithCheckboxes()
                            }
                        }
                    }
                },
                _updateSelectedItems: function(args) {
                    var that = this;
                    var selectionChangedOptions;
                    var isDeferredMode = that.option("selection.deferred");
                    var selectionFilter = that._selection.selectionFilter();
                    var dataController = that._dataController;
                    var items = dataController.items();
                    if (!items) {
                        return
                    }
                    var isSelectionWithCheckboxes = that.isSelectionWithCheckboxes();
                    var changedItemIndexes = that.getChangedItemIndexes(items);
                    that._updateCheckboxesState({
                        selectedItemKeys: args.selectedItemKeys,
                        removedItemKeys: args.removedItemKeys,
                        selectionFilter: selectionFilter,
                        isDeferredMode: isDeferredMode
                    });
                    if (changedItemIndexes.length || isSelectionWithCheckboxes !== that.isSelectionWithCheckboxes()) {
                        dataController.updateItems({
                            changeType: "updateSelection",
                            itemIndexes: changedItemIndexes
                        })
                    }
                    if (isDeferredMode) {
                        that.option("selectionFilter", selectionFilter);
                        selectionChangedOptions = {}
                    } else {
                        if (args.addedItemKeys.length || args.removedItemKeys.length) {
                            that._selectedItemsInternalChange = true;
                            that.option("selectedRowKeys", args.selectedItemKeys.slice(0));
                            that._selectedItemsInternalChange = false;
                            selectionChangedOptions = {
                                selectedRowsData: args.selectedItems.slice(0),
                                selectedRowKeys: args.selectedItemKeys.slice(0),
                                currentSelectedRowKeys: args.addedItemKeys.slice(0),
                                currentDeselectedRowKeys: args.removedItemKeys.slice(0)
                            }
                        }
                    }
                    that._fireSelectionChanged(selectionChangedOptions)
                },
                getChangedItemIndexes: function(items) {
                    var that = this;
                    var itemIndexes = [];
                    var isDeferredSelection = this.option("selection.deferred");
                    for (var i = 0, length = items.length; i < length; i++) {
                        var row = items[i];
                        var isItemSelected = that.isRowSelected(isDeferredSelection ? row.data : row.key);
                        if (that._selection.isDataItem(row) && row.isSelected !== isItemSelected) {
                            itemIndexes.push(i)
                        }
                    }
                    return itemIndexes
                },
                callbackNames: function() {
                    return ["selectionChanged"]
                },
                optionChanged: function(args) {
                    var that = this;
                    that.callBase(args);
                    switch (args.name) {
                        case "selection":
                            var oldSelectionMode = that._selectionMode;
                            that.init();
                            var selectionMode = that._selectionMode;
                            var selectedRowKeys = that.option("selectedRowKeys");
                            if (oldSelectionMode !== selectionMode) {
                                if ("single" === selectionMode) {
                                    if (selectedRowKeys.length > 1) {
                                        selectedRowKeys = [selectedRowKeys[0]]
                                    }
                                } else {
                                    if ("multiple" !== selectionMode) {
                                        selectedRowKeys = []
                                    }
                                }
                            }
                            that.selectRows(selectedRowKeys).always(function() {
                                that._fireSelectionChanged()
                            });
                            that.getController("columns").updateColumns();
                            args.handled = true;
                            break;
                        case "selectionFilter":
                            this._selection.selectionFilter(args.value);
                            args.handled = true;
                            break;
                        case "selectedRowKeys":
                            var value = args.value || [];
                            if (Array.isArray(value) && !that._selectedItemsInternalChange && (that.component.getDataSource() || !value.length)) {
                                that.selectRows(value)
                            }
                            args.handled = true
                    }
                },
                publicMethods: function() {
                    return ["selectRows", "deselectRows", "selectRowsByIndexes", "getSelectedRowKeys", "getSelectedRowsData", "clearSelection", "selectAll", "deselectAll", "startSelectionWithCheckboxes", "stopSelectionWithCheckboxes", "isRowSelected"]
                },
                isRowSelected: function(arg) {
                    return this._selection.isItemSelected(arg)
                },
                isSelectColumnVisible: function() {
                    return "multiple" === this.option(SELECTION_MODE) && ("always" === this.option(SHOW_CHECKBOXES_MODE) || "onClick" === this.option(SHOW_CHECKBOXES_MODE) || this._isSelectionWithCheckboxes)
                },
                _isOnePageSelectAll: function() {
                    return "page" === this.option("selection.selectAllMode")
                },
                isSelectAll: function() {
                    return this._selection.getSelectAllState(this._isOnePageSelectAll())
                },
                selectAll: function() {
                    if ("onClick" === this.option(SHOW_CHECKBOXES_MODE)) {
                        this.startSelectionWithCheckboxes()
                    }
                    return this._selection.selectAll(this._isOnePageSelectAll())
                },
                deselectAll: function() {
                    return this._selection.deselectAll(this._isOnePageSelectAll())
                },
                clearSelection: function() {
                    return this.selectedItemKeys([])
                },
                refresh: function() {
                    var selectedRowKeys = this.option("selectedRowKeys") || [];
                    if (!this.option("selection.deferred") && selectedRowKeys.length) {
                        return this.selectedItemKeys(selectedRowKeys)
                    }
                    return (new _deferred.Deferred).resolve().promise()
                },
                selectedItemKeys: function(value, preserve, isDeselect, isSelectAll) {
                    return this._selection.selectedItemKeys(value, preserve, isDeselect, isSelectAll)
                },
                getSelectedRowKeys: function() {
                    return this._selection.getSelectedItemKeys()
                },
                selectRows: function(keys, preserve) {
                    return this.selectedItemKeys(keys, preserve)
                },
                deselectRows: function(keys) {
                    return this.selectedItemKeys(keys, true, true)
                },
                selectRowsByIndexes: function(indexes) {
                    var items = this._dataController.items();
                    var keys = [];
                    if (!Array.isArray(indexes)) {
                        indexes = Array.prototype.slice.call(arguments, 0)
                    }(0, _iterator.each)(indexes, function() {
                        var item = items[this];
                        if (item && "data" === item.rowType) {
                            keys.push(item.key)
                        }
                    });
                    return this.selectRows(keys)
                },
                getSelectedRowsData: function() {
                    return this._selection.getSelectedItems()
                },
                changeItemSelection: function(itemIndex, keys) {
                    keys = keys || {};
                    if (this.isSelectionWithCheckboxes()) {
                        keys.control = true
                    }
                    return this._selection.changeItemSelection(this._dataController.getRowIndexDelta() + itemIndex, keys)
                },
                focusedItemIndex: function(itemIndex) {
                    var that = this;
                    if ((0, _type.isDefined)(itemIndex)) {
                        that._selection._focusedItemIndex = itemIndex
                    } else {
                        return that._selection._focusedItemIndex
                    }
                },
                isSelectionWithCheckboxes: function() {
                    return "multiple" === this.option(SELECTION_MODE) && ("always" === this.option(SHOW_CHECKBOXES_MODE) || this._isSelectionWithCheckboxes)
                },
                startSelectionWithCheckboxes: function() {
                    var that = this;
                    if ("multiple" === that.option(SELECTION_MODE) && !that.isSelectionWithCheckboxes()) {
                        that._isSelectionWithCheckboxes = true;
                        that._updateSelectColumn();
                        return true
                    }
                    return false
                },
                stopSelectionWithCheckboxes: function() {
                    var that = this;
                    if (that._isSelectionWithCheckboxes) {
                        that._isSelectionWithCheckboxes = false;
                        that._updateSelectColumn();
                        return true
                    }
                    return false
                }
            }
        }());
        var _default = {
            defaultOptions: function() {
                return {
                    selection: {
                        mode: "none",
                        showCheckBoxesMode: "onClick",
                        allowSelectAll: true,
                        selectAllMode: "allPages",
                        maxFilterLengthInRequest: 1500,
                        deferred: false
                    },
                    selectionFilter: [],
                    selectedRowKeys: []
                }
            },
            controllers: {
                selection: SelectionController
            },
            extenders: {
                controllers: {
                    data: {
                        init: function() {
                            var selectionController = this.getController("selection");
                            var isDeferredMode = this.option("selection.deferred");
                            this.callBase.apply(this, arguments);
                            if (isDeferredMode) {
                                selectionController._updateCheckboxesState({
                                    isDeferredMode: true,
                                    selectionFilter: this.option("selectionFilter")
                                })
                            }
                        },
                        _loadDataSource: function() {
                            var that = this;
                            return that.callBase().done(function() {
                                that.getController("selection").refresh()
                            })
                        },
                        _processDataItem: function(item, options) {
                            var that = this;
                            var selectionController = that.getController("selection");
                            var hasSelectColumn = selectionController.isSelectColumnVisible();
                            var isDeferredSelection = options.isDeferredSelection = void 0 === options.isDeferredSelection ? this.option("selection.deferred") : options.isDeferredSelection;
                            var dataItem = this.callBase.apply(this, arguments);
                            dataItem.isSelected = selectionController.isRowSelected(isDeferredSelection ? dataItem.data : dataItem.key);
                            if (hasSelectColumn && dataItem.values) {
                                for (var i = 0; i < options.visibleColumns.length; i++) {
                                    if ("select" === options.visibleColumns[i].command) {
                                        dataItem.values[i] = dataItem.isSelected;
                                        break
                                    }
                                }
                            }
                            return dataItem
                        },
                        refresh: function(options) {
                            var that = this;
                            var d = new _deferred.Deferred;
                            this.callBase.apply(this, arguments).done(function() {
                                if (!options || options.selection) {
                                    that.getController("selection").refresh().done(d.resolve).fail(d.reject)
                                } else {
                                    d.resolve()
                                }
                            }).fail(d.reject);
                            return d.promise()
                        },
                        _handleDataChanged: function(e) {
                            this.callBase.apply(this, arguments);
                            if ((!e || "refresh" === e.changeType) && !this._repaintChangesOnly) {
                                this.getController("selection").focusedItemIndex(-1)
                            }
                        },
                        _applyChange: function(change) {
                            var _this = this;
                            if (change && "updateSelection" === change.changeType) {
                                change.items.forEach(function(item, index) {
                                    var currentItem = _this._items[index];
                                    if (currentItem) {
                                        currentItem.isSelected = item.isSelected;
                                        currentItem.values = item.values
                                    }
                                });
                                return
                            }
                            return this.callBase.apply(this, arguments)
                        },
                        _endUpdateCore: function() {
                            var changes = this._changes;
                            var isUpdateSelection = changes.length > 1 && changes.every(function(change) {
                                return "updateSelection" === change.changeType
                            });
                            if (isUpdateSelection) {
                                var itemIndexes = changes.map(function(change) {
                                    return change.itemIndexes || []
                                }).reduce(function(a, b) {
                                    return a.concat(b)
                                });
                                this._changes = [{
                                    changeType: "updateSelection",
                                    itemIndexes: itemIndexes
                                }]
                            }
                            this.callBase.apply(this, arguments)
                        },
                        push: function(changes) {
                            this.callBase.apply(this, arguments);
                            var removedKeys = changes.filter(function(change) {
                                return "remove" === change.type
                            }).map(function(change) {
                                return change.key
                            });
                            removedKeys.length && this.getController("selection").deselectRows(removedKeys)
                        }
                    },
                    contextMenu: {
                        _contextMenuPrepared: function(options) {
                            var dxEvent = options.event;
                            if (dxEvent.originalEvent && "dxhold" !== dxEvent.originalEvent.type || options.items && options.items.length > 0) {
                                return
                            }
                            processLongTap(this, dxEvent)
                        }
                    }
                },
                views: {
                    columnHeadersView: {
                        init: function() {
                            var that = this;
                            that.callBase();
                            that.getController("selection").selectionChanged.add(that._updateSelectAllValue.bind(that))
                        },
                        _updateSelectAllValue: function() {
                            var that = this;
                            var $element = that.element();
                            var $editor = $element && $element.find("." + SELECT_CHECKBOX_CLASS);
                            if ($element && $editor.length && "multiple" === that.option("selection.mode")) {
                                $editor.dxCheckBox("instance").option({
                                    visible: !that.getController("data").isEmpty(),
                                    value: that.getController("selection").isSelectAll()
                                })
                            }
                        },
                        _handleDataChanged: function(e) {
                            this.callBase(e);
                            if (!e || "refresh" === e.changeType) {
                                this._updateSelectAllValue()
                            }
                        },
                        _renderSelectAllCheckBox: function($container, column) {
                            var that = this;
                            var selectionController = that.getController("selection");
                            var isEmptyData = that.getController("data").isEmpty();
                            var groupElement = (0, _renderer.default)("<div>").appendTo($container).addClass(SELECT_CHECKBOX_CLASS);
                            that.setAria("label", _message.default.format("dxDataGrid-ariaSelectAll"), $container);
                            that.getController("editorFactory").createEditor(groupElement, (0, _extend.extend)({}, column, {
                                parentType: "headerRow",
                                dataType: "boolean",
                                value: selectionController.isSelectAll(),
                                editorOptions: {
                                    visible: !isEmptyData && (that.option("selection.allowSelectAll") || false !== selectionController.isSelectAll())
                                },
                                tabIndex: that.option("useLegacyKeyboardNavigation") ? -1 : that.option("tabIndex") || 0,
                                setValue: function(value, e) {
                                    var allowSelectAll = that.option("selection.allowSelectAll");
                                    e.component.option("visible", allowSelectAll || false !== e.component.option("value"));
                                    if (!e.event || selectionController.isSelectAll() === value) {
                                        return
                                    }
                                    if (e.value && !allowSelectAll) {
                                        e.component.option("value", false)
                                    } else {
                                        e.value ? selectionController.selectAll() : selectionController.deselectAll()
                                    }
                                    e.event.preventDefault()
                                }
                            }));
                            return groupElement
                        },
                        _attachSelectAllCheckBoxClickEvent: function($element) {
                            _events_engine.default.on($element, _click.name, this.createAction(function(e) {
                                var event = e.event;
                                if (!(0, _renderer.default)(event.target).closest("." + SELECT_CHECKBOX_CLASS).length) {
                                    _events_engine.default.trigger((0, _renderer.default)(event.currentTarget).children("." + SELECT_CHECKBOX_CLASS), _click.name)
                                }
                                event.preventDefault()
                            }))
                        }
                    },
                    rowsView: {
                        renderSelectCheckBoxContainer: function($container, options) {
                            if ("data" === options.rowType && !options.row.isNewRow) {
                                $container.addClass(EDITOR_CELL_CLASS);
                                this._attachCheckBoxClickEvent($container);
                                this.setAria("label", _message.default.format("dxDataGrid-ariaSelectRow"), $container);
                                this._renderSelectCheckBox($container, options)
                            } else {
                                _uiGrid_core.default.setEmptyText($container)
                            }
                        },
                        _renderSelectCheckBox: function(container, options) {
                            var groupElement = (0, _renderer.default)("<div>").addClass(SELECT_CHECKBOX_CLASS).appendTo(container);
                            this.getController("editorFactory").createEditor(groupElement, (0, _extend.extend)({}, options.column, {
                                parentType: "dataRow",
                                dataType: "boolean",
                                lookup: null,
                                value: options.value,
                                setValue: function(value, e) {
                                    var _e$event;
                                    if ("keydown" === (null === e || void 0 === e ? void 0 : null === (_e$event = e.event) || void 0 === _e$event ? void 0 : _e$event.type)) {
                                        _events_engine.default.trigger(e.element, _click.name, e)
                                    }
                                },
                                row: options.row
                            }));
                            return groupElement
                        },
                        _attachCheckBoxClickEvent: function($element) {
                            _events_engine.default.on($element, _click.name, this.createAction(function(e) {
                                var selectionController = this.getController("selection");
                                var event = e.event;
                                var rowIndex = this.getRowIndex((0, _renderer.default)(event.currentTarget).closest("." + ROW_CLASS));
                                if (rowIndex >= 0) {
                                    selectionController.startSelectionWithCheckboxes();
                                    selectionController.changeItemSelection(rowIndex, {
                                        shift: event.shiftKey
                                    });
                                    if ((0, _renderer.default)(event.target).closest("." + SELECT_CHECKBOX_CLASS).length) {
                                        this.getController("data").updateItems({
                                            changeType: "updateSelection",
                                            itemIndexes: [rowIndex]
                                        })
                                    }
                                }
                            }))
                        },
                        _update: function(change) {
                            var that = this;
                            var tableElements = that.getTableElements();
                            if ("updateSelection" === change.changeType) {
                                if (tableElements.length > 0) {
                                    (0, _iterator.each)(tableElements, function(_, tableElement) {
                                        (0, _iterator.each)(change.itemIndexes || [], function(_, index) {
                                            var $row;
                                            if (change.items[index]) {
                                                $row = that._getRowElements((0, _renderer.default)(tableElement)).eq(index);
                                                if ($row.length) {
                                                    var isSelected = change.items[index].isSelected;
                                                    $row.toggleClass(ROW_SELECTION_CLASS, void 0 === isSelected ? false : isSelected).find("." + SELECT_CHECKBOX_CLASS).dxCheckBox("option", "value", isSelected);
                                                    that.setAria("selected", isSelected, $row)
                                                }
                                            }
                                        })
                                    });
                                    that._updateCheckboxesClass()
                                }
                            } else {
                                that.callBase(change)
                            }
                        },
                        _createTable: function() {
                            var that = this;
                            var selectionMode = that.option("selection.mode");
                            var $table = that.callBase.apply(that, arguments);
                            if ("none" !== selectionMode) {
                                if ("onLongTap" === that.option(SHOW_CHECKBOXES_MODE) || !_support.touch) {
                                    _events_engine.default.on($table, (0, _index.addNamespace)(_hold.default.name, "dxDataGridRowsView"), "." + DATA_ROW_CLASS, that.createAction(function(e) {
                                        processLongTap(that.component, e.event);
                                        e.event.stopPropagation()
                                    }))
                                }
                                _events_engine.default.on($table, "mousedown selectstart", that.createAction(function(e) {
                                    var event = e.event;
                                    if (event.shiftKey) {
                                        event.preventDefault()
                                    }
                                }))
                            }
                            return $table
                        },
                        _createRow: function(row) {
                            var $row = this.callBase(row);
                            if (row) {
                                var isSelected = !!row.isSelected;
                                if (isSelected) {
                                    $row.addClass(ROW_SELECTION_CLASS)
                                }
                                this.setAria("selected", isSelected, $row)
                            }
                            return $row
                        },
                        _rowClick: function(e) {
                            var that = this;
                            var dxEvent = e.event;
                            var isSelectionDisabled = (0, _renderer.default)(dxEvent.target).closest("." + SELECTION_DISABLED_CLASS).length;
                            if (!that.isClickableElement((0, _renderer.default)(dxEvent.target))) {
                                if (!isSelectionDisabled && ("multiple" !== that.option(SELECTION_MODE) || "always" !== that.option(SHOW_CHECKBOXES_MODE))) {
                                    if (that.getController("selection").changeItemSelection(e.rowIndex, {
                                            control: (0, _index.isCommandKeyPressed)(dxEvent),
                                            shift: dxEvent.shiftKey
                                        })) {
                                        dxEvent.preventDefault();
                                        e.handled = true
                                    }
                                }
                                that.callBase(e)
                            }
                        },
                        isClickableElement: function($target) {
                            var isCommandSelect = $target.closest("." + COMMAND_SELECT_CLASS).length;
                            return !!isCommandSelect
                        },
                        _renderCore: function(change) {
                            this.callBase(change);
                            this._updateCheckboxesClass()
                        },
                        _updateCheckboxesClass: function() {
                            var tableElements = this.getTableElements();
                            var selectionController = this.getController("selection");
                            var isCheckBoxesHidden = selectionController.isSelectColumnVisible() && !selectionController.isSelectionWithCheckboxes();
                            (0, _iterator.each)(tableElements, function(_, tableElement) {
                                (0, _renderer.default)(tableElement).toggleClass(CHECKBOXES_HIDDEN_CLASS, isCheckBoxesHidden)
                            })
                        }
                    }
                }
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.column_chooser.js ***!
      \******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.modules */ 44));
        var _uiGrid_core2 = __webpack_require__( /*! ./ui.grid_core.columns_view */ 183);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _themes = __webpack_require__( /*! ../themes */ 34);
        var _button = _interopRequireDefault(__webpack_require__( /*! ../button */ 37));
        var _tree_view = _interopRequireDefault(__webpack_require__( /*! ../tree_view */ 158));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _popup = _interopRequireDefault(__webpack_require__( /*! ../popup */ 46));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var COLUMN_CHOOSER_CLASS = "column-chooser";
        var COLUMN_CHOOSER_BUTTON_CLASS = "column-chooser-button";
        var NOTOUCH_ACTION_CLASS = "notouch-action";
        var COLUMN_CHOOSER_LIST_CLASS = "column-chooser-list";
        var COLUMN_CHOOSER_PLAIN_CLASS = "column-chooser-plain";
        var COLUMN_CHOOSER_DRAG_CLASS = "column-chooser-mode-drag";
        var COLUMN_CHOOSER_SELECT_CLASS = "column-chooser-mode-select";
        var COLUMN_CHOOSER_ICON_NAME = "column-chooser";
        var COLUMN_CHOOSER_ITEM_CLASS = "dx-column-chooser-item";
        var TREEVIEW_NODE_SELECTOR = ".dx-treeview-node";
        var CHECKBOX_SELECTOR = ".dx-checkbox";
        var CLICK_TIMEOUT = 300;
        var processItems = function(that, chooserColumns) {
            var items = [];
            var isSelectMode = "select" === that.option("columnChooser.mode");
            if (chooserColumns.length) {
                (0, _iterator.each)(chooserColumns, function(index, column) {
                    var item = {
                        text: column.caption,
                        cssClass: column.cssClass,
                        allowHiding: column.allowHiding,
                        expanded: true,
                        id: column.index,
                        disabled: false,
                        disableCheckBox: false === column.allowHiding,
                        parentId: (0, _type.isDefined)(column.ownerBand) ? column.ownerBand : null
                    };
                    if (isSelectMode) {
                        item.selected = column.visible
                    }
                    items.push(item)
                })
            }
            return items
        };
        var ColumnChooserController = _uiGrid_core.default.ViewController.inherit({
            renderShowColumnChooserButton: function($element) {
                var that = this;
                var columnChooserButtonClass = that.addWidgetPrefix(COLUMN_CHOOSER_BUTTON_CLASS);
                var columnChooserEnabled = that.option("columnChooser.enabled");
                var $showColumnChooserButton = $element.find("." + columnChooserButtonClass);
                var $columnChooserButton;
                if (columnChooserEnabled) {
                    if (!$showColumnChooserButton.length) {
                        $columnChooserButton = (0, _renderer.default)("<div>").addClass(columnChooserButtonClass).appendTo($element);
                        that._createComponent($columnChooserButton, _button.default, {
                            icon: COLUMN_CHOOSER_ICON_NAME,
                            onClick: function() {
                                that.getView("columnChooserView").showColumnChooser()
                            },
                            hint: that.option("columnChooser.title"),
                            integrationOptions: {}
                        })
                    } else {
                        $showColumnChooserButton.show()
                    }
                } else {
                    $showColumnChooserButton.hide()
                }
            },
            getPosition: function() {
                var rowsView = this.getView("rowsView");
                return {
                    my: "right bottom",
                    at: "right bottom",
                    of: rowsView && rowsView.element(),
                    collision: "fit",
                    offset: "-2 -2",
                    boundaryOffset: "2 2"
                }
            }
        });
        var ColumnChooserView = _uiGrid_core2.ColumnsView.inherit({
            _resizeCore: _common.noop,
            _isWinDevice: function() {
                return !!_devices.default.real().win
            },
            _updateList: function(change) {
                var items;
                var $popupContent = this._popupContainer.$content();
                var isSelectMode = "select" === this.option("columnChooser.mode");
                var columnChooserList = this._columnChooserList;
                var chooserColumns = this._columnsController.getChooserColumns(isSelectMode);
                if (isSelectMode && columnChooserList && change && "selection" === change.changeType) {
                    items = processItems(this, chooserColumns);
                    for (var i = 0; i < items.length; i++) {
                        var selected = items[i].selected;
                        var id = items[i].id;
                        if (id === change.columnIndex) {
                            if (selected) {
                                columnChooserList.selectItem(id, selected)
                            } else {
                                columnChooserList.unselectItem(id, selected)
                            }
                        }
                    }
                } else {
                    if (!isSelectMode || !columnChooserList || "full" === change) {
                        this._popupContainer._wrapper().toggleClass(this.addWidgetPrefix(COLUMN_CHOOSER_DRAG_CLASS), !isSelectMode).toggleClass(this.addWidgetPrefix(COLUMN_CHOOSER_SELECT_CLASS), isSelectMode);
                        items = processItems(this, chooserColumns);
                        this._renderTreeView($popupContent, items)
                    }
                }
            },
            _initializePopupContainer: function() {
                var that = this;
                var $element = that.element().addClass(that.addWidgetPrefix(COLUMN_CHOOSER_CLASS));
                var columnChooserOptions = that.option("columnChooser");
                var themeName = (0, _themes.current)();
                var isGenericTheme = (0, _themes.isGeneric)(themeName);
                var isMaterial = (0, _themes.isMaterial)(themeName);
                var dxPopupOptions = {
                    visible: false,
                    shading: false,
                    showCloseButton: false,
                    dragEnabled: true,
                    resizeEnabled: true,
                    toolbarItems: [{
                        text: columnChooserOptions.title,
                        toolbar: "top",
                        location: isGenericTheme || isMaterial ? "before" : "center"
                    }],
                    position: that.getController("columnChooser").getPosition(),
                    width: columnChooserOptions.width,
                    height: columnChooserOptions.height,
                    rtlEnabled: that.option("rtlEnabled"),
                    onHidden: function() {
                        if (that._isWinDevice()) {
                            (0, _renderer.default)("body").removeClass(that.addWidgetPrefix(NOTOUCH_ACTION_CLASS))
                        }
                    },
                    container: columnChooserOptions.container
                };
                if (isGenericTheme || isMaterial) {
                    (0, _extend.extend)(dxPopupOptions, {
                        showCloseButton: true
                    })
                } else {
                    dxPopupOptions.toolbarItems[dxPopupOptions.toolbarItems.length] = {
                        shortcut: "cancel"
                    }
                }
                if (!(0, _type.isDefined)(this._popupContainer)) {
                    that._popupContainer = that._createComponent($element, _popup.default, dxPopupOptions);
                    that._popupContainer.on("optionChanged", function(args) {
                        if ("visible" === args.name) {
                            that.renderCompleted.fire()
                        }
                    })
                } else {
                    this._popupContainer.option(dxPopupOptions)
                }
            },
            _renderCore: function(change) {
                if (this._popupContainer) {
                    this._updateList(change)
                }
            },
            _renderTreeView: function($container, items) {
                var that = this;
                var columnChooser = this.option("columnChooser");
                var isSelectMode = "select" === columnChooser.mode;
                var treeViewConfig = {
                    items: items,
                    dataStructure: "plain",
                    activeStateEnabled: true,
                    focusStateEnabled: true,
                    hoverStateEnabled: true,
                    itemTemplate: "item",
                    showCheckBoxesMode: "none",
                    rootValue: null,
                    searchEnabled: columnChooser.allowSearch,
                    searchTimeout: columnChooser.searchTimeout,
                    onItemRendered: function(e) {
                        if (e.itemData.disableCheckBox) {
                            var $treeViewNode = (0, _renderer.default)(e.itemElement).closest(TREEVIEW_NODE_SELECTOR);
                            var $checkBox;
                            if ($treeViewNode.length) {
                                $checkBox = $treeViewNode.find(CHECKBOX_SELECTOR);
                                if ($checkBox.length) {
                                    var checkBoxInstance = $checkBox.data("dxCheckBox");
                                    checkBoxInstance && checkBoxInstance.option("disabled", true)
                                }
                            }
                        }
                    }
                };
                var scrollableInstance = $container.find(".dx-scrollable").data("dxScrollable");
                var scrollTop = scrollableInstance && scrollableInstance.scrollTop();
                if (isSelectMode && !this._columnsController.isBandColumnsUsed()) {
                    $container.addClass(this.addWidgetPrefix(COLUMN_CHOOSER_PLAIN_CLASS))
                }
                treeViewConfig.onContentReady = function(e) {
                    (0, _common.deferUpdate)(function() {
                        if (scrollTop) {
                            var scrollable = (0, _renderer.default)(e.element).find(".dx-scrollable").data("dxScrollable");
                            scrollable && scrollable.scrollTo({
                                y: scrollTop
                            })
                        }
                        that.renderCompleted.fire()
                    })
                };
                if (this._isWinDevice()) {
                    treeViewConfig.useNativeScrolling = false
                }(0, _extend.extend)(treeViewConfig, isSelectMode ? this._prepareSelectModeConfig() : this._prepareDragModeConfig());
                if (this._columnChooserList) {
                    if (!treeViewConfig.searchEnabled) {
                        treeViewConfig.searchValue = ""
                    }
                    this._columnChooserList.option(treeViewConfig)
                } else {
                    this._columnChooserList = this._createComponent($container, _tree_view.default, treeViewConfig);
                    $container.addClass(this.addWidgetPrefix(COLUMN_CHOOSER_LIST_CLASS))
                }
            },
            _prepareDragModeConfig: function() {
                var columnChooserOptions = this.option("columnChooser");
                return {
                    noDataText: columnChooserOptions.emptyPanelText,
                    activeStateEnabled: false,
                    focusStateEnabled: false,
                    hoverStateEnabled: false,
                    itemTemplate: function(data, index, item) {
                        (0, _renderer.default)(item).text(data.text).parent().addClass(data.cssClass).addClass(COLUMN_CHOOSER_ITEM_CLASS)
                    }
                }
            },
            _prepareSelectModeConfig: function() {
                var that = this;
                var selectionChangedHandler = function(e) {
                    var visibleColumns = that._columnsController.getVisibleColumns().filter(function(item) {
                        return !item.command
                    });
                    var isLastColumnUnselected = 1 === visibleColumns.length && !e.itemData.selected;
                    if (isLastColumnUnselected) {
                        e.component.selectItem(e.itemElement)
                    } else {
                        setTimeout(function() {
                            that._columnsController.columnOption(e.itemData.id, "visible", e.itemData.selected)
                        }, CLICK_TIMEOUT)
                    }
                };
                return {
                    selectNodesRecursive: false,
                    showCheckBoxesMode: "normal",
                    onItemSelectionChanged: selectionChangedHandler
                }
            },
            _columnOptionChanged: function(e) {
                var changeTypes = e.changeTypes;
                var optionNames = e.optionNames;
                var isSelectMode = "select" === this.option("columnChooser.mode");
                this.callBase(e);
                if (isSelectMode) {
                    var needPartialRender = optionNames.visible && 1 === optionNames.length && void 0 !== e.columnIndex;
                    var needFullRender = optionNames.showInColumnChooser || optionNames.caption || optionNames.visible || changeTypes.columns && optionNames.all;
                    if (needPartialRender) {
                        this.render(null, {
                            changeType: "selection",
                            columnIndex: e.columnIndex
                        })
                    } else {
                        if (needFullRender) {
                            this.render(null, "full")
                        }
                    }
                }
            },
            optionChanged: function(args) {
                switch (args.name) {
                    case "columnChooser":
                        this._initializePopupContainer();
                        this.render(null, "full");
                        break;
                    default:
                        this.callBase(args)
                }
            },
            getColumnElements: function() {
                var result = [];
                var $node;
                var isSelectMode = "select" === this.option("columnChooser.mode");
                var chooserColumns = this._columnsController.getChooserColumns(isSelectMode);
                var $content = this._popupContainer && this._popupContainer.$content();
                var $nodes = $content && $content.find(".dx-treeview-node");
                if ($nodes) {
                    chooserColumns.forEach(function(column) {
                        $node = $nodes.filter("[data-item-id = '" + column.index + "']");
                        var item = $node.length ? $node.children("." + COLUMN_CHOOSER_ITEM_CLASS).get(0) : null;
                        result.push(item)
                    })
                }
                return (0, _renderer.default)(result)
            },
            getName: function() {
                return "columnChooser"
            },
            getColumns: function() {
                return this._columnsController.getChooserColumns()
            },
            allowDragging: function(column, sourceLocation) {
                var columnVisible = column && column.allowHiding && ("columnChooser" !== sourceLocation || !column.visible && this._columnsController.isParentColumnVisible(column.index));
                return this.isColumnChooserVisible() && columnVisible
            },
            getBoundingRect: function() {
                var that = this;
                var container = that._popupContainer && that._popupContainer._container();
                if (container && container.is(":visible")) {
                    var offset = container.offset();
                    return {
                        left: offset.left,
                        top: offset.top,
                        right: offset.left + container.outerWidth(),
                        bottom: offset.top + container.outerHeight()
                    }
                }
                return null
            },
            showColumnChooser: function() {
                if (!this._popupContainer) {
                    this._initializePopupContainer();
                    this.render()
                }
                this._popupContainer.show();
                if (this._isWinDevice()) {
                    (0, _renderer.default)("body").addClass(this.addWidgetPrefix(NOTOUCH_ACTION_CLASS))
                }
            },
            hideColumnChooser: function() {
                if (this._popupContainer) {
                    this._popupContainer.hide()
                }
            },
            isColumnChooserVisible: function() {
                var popupContainer = this._popupContainer;
                return popupContainer && popupContainer.option("visible")
            },
            publicMethods: function() {
                return ["showColumnChooser", "hideColumnChooser"]
            }
        });
        var _default = {
            defaultOptions: function() {
                return {
                    columnChooser: {
                        enabled: false,
                        allowSearch: false,
                        searchTimeout: 500,
                        mode: "dragAndDrop",
                        width: 250,
                        height: 260,
                        title: _message.default.format("dxDataGrid-columnChooserTitle"),
                        emptyPanelText: _message.default.format("dxDataGrid-columnChooserEmptyText"),
                        container: void 0
                    }
                }
            },
            controllers: {
                columnChooser: ColumnChooserController
            },
            views: {
                columnChooserView: ColumnChooserView
            },
            extenders: {
                views: {
                    headerPanel: {
                        _getToolbarItems: function() {
                            var items = this.callBase();
                            return this._appendColumnChooserItem(items)
                        },
                        _appendColumnChooserItem: function(items) {
                            var that = this;
                            var columnChooserEnabled = that.option("columnChooser.enabled");
                            if (columnChooserEnabled) {
                                var onClickHandler = function() {
                                    that.component.getView("columnChooserView").showColumnChooser()
                                };
                                var onInitialized = function(e) {
                                    (0, _renderer.default)(e.element).addClass(that._getToolbarButtonClass(that.addWidgetPrefix(COLUMN_CHOOSER_BUTTON_CLASS)))
                                };
                                var hintText = that.option("columnChooser.title");
                                var toolbarItem = {
                                    widget: "dxButton",
                                    options: {
                                        icon: COLUMN_CHOOSER_ICON_NAME,
                                        onClick: onClickHandler,
                                        hint: hintText,
                                        text: hintText,
                                        onInitialized: onInitialized
                                    },
                                    showText: "inMenu",
                                    location: "after",
                                    name: "columnChooserButton",
                                    locateInMenu: "auto",
                                    sortIndex: 40
                                };
                                items.push(toolbarItem)
                            }
                            return items
                        },
                        optionChanged: function(args) {
                            switch (args.name) {
                                case "columnChooser":
                                    this._invalidate();
                                    args.handled = true;
                                    break;
                                default:
                                    this.callBase(args)
                            }
                        },
                        isVisible: function() {
                            var that = this;
                            var columnChooserEnabled = that.option("columnChooser.enabled");
                            return that.callBase() || columnChooserEnabled
                        }
                    }
                },
                controllers: {
                    columns: {
                        allowMoveColumn: function(fromVisibleIndex, toVisibleIndex, sourceLocation, targetLocation) {
                            var columnChooserMode = this.option("columnChooser.mode");
                            var isMoveColumnDisallowed = "select" === columnChooserMode && "columnChooser" === targetLocation;
                            return isMoveColumnDisallowed ? false : this.callBase(fromVisibleIndex, toVisibleIndex, sourceLocation, targetLocation)
                        }
                    }
                }
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_view/ui.tree_view.search.js ***!
      \**********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.search_box_mixin */ 274));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _uiTree_view = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_view.base */ 704));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var WIDGET_CLASS = "dx-treeview";
        var NODE_CONTAINER_CLASS = "".concat(WIDGET_CLASS, "-node-container");
        var TreeViewSearch = _uiTree_view.default.inherit(_ui.default).inherit({
            _addWidgetPrefix: function(className) {
                return "".concat(WIDGET_CLASS, "-").concat(className)
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "searchValue":
                        if (this._showCheckboxes() && this._isRecursiveSelection()) {
                            this._removeSelection()
                        }
                        this._initDataAdapter();
                        this._updateSearch();
                        this._repaintContainer();
                        break;
                    case "searchExpr":
                        this._initDataAdapter();
                        this.repaint();
                        break;
                    case "searchMode":
                        this.option("expandNodesRecursive") ? this._updateDataAdapter() : this._initDataAdapter();
                        this.repaint();
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _updateDataAdapter: function() {
                this._setOptionWithoutOptionChange("expandNodesRecursive", false);
                this._initDataAdapter();
                this._setOptionWithoutOptionChange("expandNodesRecursive", true)
            },
            _getDataAdapterOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    searchValue: this.option("searchValue"),
                    searchMode: this.option("searchMode") || "contains",
                    searchExpr: this.option("searchExpr")
                })
            },
            _updateSearch: function() {
                if (this._searchEditor) {
                    var editorOptions = this._getSearchEditorOptions();
                    this._searchEditor.option(editorOptions)
                }
            },
            _repaintContainer: function() {
                var $container = this.$element().find(".".concat(NODE_CONTAINER_CLASS)).first();
                var rootNodes;
                if ($container.length) {
                    $container.empty();
                    rootNodes = this._dataAdapter.getRootNodes();
                    this._renderEmptyMessage(rootNodes);
                    this._renderItems($container, rootNodes);
                    this._fireContentReadyAction()
                }
            },
            _itemContainer: function(isSearchMode) {
                if (this._scrollableContainer && isSearchMode) {
                    return (0, _renderer.default)(this._scrollableContainer.content())
                }
                return this.callBase()
            },
            _addWidgetClass: function() {
                this.$element().addClass(this._widgetClass())
            },
            _clean: function() {
                this.callBase();
                this._removeSearchBox()
            }
        });
        (0, _component_registrator.default)("dxTreeView", TreeViewSearch);
        var _default = TreeViewSearch;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.grouping.core.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.createOffsetFilter = createOffsetFilter;
        exports.GroupingHelper = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _utils = _interopRequireDefault(__webpack_require__( /*! ../../data/utils */ 41));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function createOffsetFilter(path, storeLoadOptions, lastLevelOnly) {
            var groups = _utils.default.normalizeSortingInfo(storeLoadOptions.group);
            var filter = [];
            for (var i = lastLevelOnly ? path.length - 1 : 0; i < path.length; i++) {
                var filterElement = [];
                for (var j = 0; j <= i; j++) {
                    var selector = groups[j].selector;
                    if (i === j && (null === path[j] || false === path[j] || true === path[j])) {
                        if (false === path[j]) {
                            filterElement.push([selector, "=", groups[j].desc ? true : null])
                        } else {
                            if (path[j] ? !groups[j].desc : groups[j].desc) {
                                filterElement.push([selector, "<>", path[j]])
                            } else {
                                filterElement.push([selector, "<>", null]);
                                filterElement.push([selector, "=", null])
                            }
                        }
                    } else {
                        var currentFilter = [selector, i === j ? groups[j].desc ? ">" : "<" : "=", path[j]];
                        if ("<" === currentFilter[1]) {
                            filterElement.push([currentFilter, "or", [selector, "=", null]])
                        } else {
                            filterElement.push(currentFilter)
                        }
                    }
                }
                filter.push(_uiData_grid.default.combineFilters(filterElement))
            }
            filter = _uiData_grid.default.combineFilters(filter, "or");
            return _uiData_grid.default.combineFilters([filter, storeLoadOptions.filter])
        }
        var GroupingHelper = _class.default.inherit(function() {
            var findGroupInfoByKey = function(groupsInfo, key) {
                var hash = groupsInfo.hash;
                return hash && hash[JSON.stringify(key)]
            };
            var getGroupInfoIndexByOffset = function(groupsInfo, offset) {
                var leftIndex = 0;
                var rightIndex = groupsInfo.length - 1;
                if (!groupsInfo.length) {
                    return 0
                }
                do {
                    var middleIndex = rightIndex + leftIndex >> 1;
                    if (groupsInfo[middleIndex].offset > offset) {
                        rightIndex = middleIndex
                    } else {
                        leftIndex = middleIndex
                    }
                } while (rightIndex - leftIndex > 1);
                var index;
                for (index = leftIndex; index <= rightIndex; index++) {
                    if (groupsInfo[index].offset > offset) {
                        break
                    }
                }
                return index
            };
            var cleanGroupsInfo = function cleanGroupsInfo(groupsInfo, groupIndex, groupsCount) {
                for (var i = 0; i < groupsInfo.length; i++) {
                    if (groupIndex + 1 >= groupsCount) {
                        groupsInfo[i].children = []
                    } else {
                        cleanGroupsInfo(groupsInfo[i].children, groupIndex + 1, groupsCount)
                    }
                }
            };
            var calculateItemsCount = function calculateItemsCount(that, items, groupsCount) {
                var result = 0;
                if (items) {
                    if (!groupsCount) {
                        result = items.length
                    } else {
                        for (var i = 0; i < items.length; i++) {
                            if (that.isGroupItemCountable(items[i])) {
                                result++
                            }
                            result += calculateItemsCount(that, items[i].items, groupsCount - 1)
                        }
                    }
                }
                return result
            };
            return {
                ctor: function(dataSourceAdapter) {
                    this._dataSource = dataSourceAdapter;
                    this.reset()
                },
                reset: function() {
                    this._groupsInfo = [];
                    this._totalCountCorrection = 0
                },
                totalCountCorrection: function() {
                    return this._totalCountCorrection
                },
                updateTotalItemsCount: function(totalCountCorrection) {
                    this._totalCountCorrection = totalCountCorrection || 0
                },
                isGroupItemCountable: function(item) {
                    return !this._isVirtualPaging() || !item.isContinuation
                },
                _isVirtualPaging: function() {
                    var scrollingMode = this._dataSource.option("scrolling.mode");
                    return "virtual" === scrollingMode || "infinite" === scrollingMode
                },
                itemsCount: function itemsCount() {
                    var dataSourceAdapter = this._dataSource;
                    var dataSource = dataSourceAdapter._dataSource;
                    var groupCount = _uiData_grid.default.normalizeSortingInfo(dataSource.group() || []).length;
                    var itemsCount = calculateItemsCount(this, dataSource.items(), groupCount);
                    return itemsCount
                },
                foreachGroups: function(callback, childrenAtFirst, foreachCollapsedGroups, updateOffsets, updateParentOffsets) {
                    var that = this;

                    function foreachGroupsCore(groupsInfo, callback, childrenAtFirst, parents) {
                        var callbackResults = [];

                        function executeCallback(callback, data, parents, callbackResults) {
                            var callbackResult = data && callback(data, parents);
                            callbackResult && callbackResults.push(callbackResult);
                            return callbackResult
                        }
                        for (var i = 0; i < groupsInfo.length; i++) {
                            parents.push(groupsInfo[i].data);
                            if (!childrenAtFirst && false === executeCallback(callback, groupsInfo[i].data, parents, callbackResults)) {
                                return false
                            }
                            if (!groupsInfo[i].data || groupsInfo[i].data.isExpanded || foreachCollapsedGroups) {
                                var children = groupsInfo[i].children;
                                var callbackResult = children.length && foreachGroupsCore(children, callback, childrenAtFirst, parents);
                                callbackResult && callbackResults.push(callbackResult);
                                if (false === callbackResult) {
                                    return false
                                }
                            }
                            if (childrenAtFirst && false === executeCallback(callback, groupsInfo[i].data, parents, callbackResults)) {
                                return false
                            }
                            if (!groupsInfo[i].data || groupsInfo[i].data.offset !== groupsInfo[i].offset) {
                                updateOffsets = true
                            }
                            parents.pop()
                        }
                        var currentParents = updateParentOffsets && parents.slice(0);
                        return updateOffsets && _deferred.when.apply(_renderer.default, callbackResults).always(function() {
                            that._updateGroupInfoOffsets(groupsInfo, currentParents)
                        })
                    }
                    return foreachGroupsCore(that._groupsInfo, callback, childrenAtFirst, [])
                },
                _updateGroupInfoOffsets: function(groupsInfo, parents) {
                    parents = parents || [];
                    for (var index = 0; index < groupsInfo.length; index++) {
                        var groupInfo = groupsInfo[index];
                        if (groupInfo.data && groupInfo.data.offset !== groupInfo.offset) {
                            groupInfo.offset = groupInfo.data.offset;
                            for (var parentIndex = 0; parentIndex < parents.length; parentIndex++) {
                                parents[parentIndex].offset = groupInfo.offset
                            }
                        }
                    }
                    groupsInfo.sort(function(a, b) {
                        return a.offset - b.offset
                    })
                },
                findGroupInfo: function(path) {
                    var that = this;
                    var groupInfo;
                    var groupsInfo = that._groupsInfo;
                    for (var pathIndex = 0; groupsInfo && pathIndex < path.length; pathIndex++) {
                        groupInfo = findGroupInfoByKey(groupsInfo, path[pathIndex]);
                        groupsInfo = groupInfo && groupInfo.children
                    }
                    return groupInfo && groupInfo.data
                },
                addGroupInfo: function(groupInfoData) {
                    var that = this;
                    var groupInfo;
                    var path = groupInfoData.path;
                    var groupsInfo = that._groupsInfo;
                    for (var pathIndex = 0; pathIndex < path.length; pathIndex++) {
                        groupInfo = findGroupInfoByKey(groupsInfo, path[pathIndex]);
                        if (!groupInfo) {
                            groupInfo = {
                                key: path[pathIndex],
                                offset: groupInfoData.offset,
                                data: {
                                    offset: groupInfoData.offset,
                                    isExpanded: true,
                                    path: path.slice(0, pathIndex + 1)
                                },
                                children: []
                            };
                            var index = getGroupInfoIndexByOffset(groupsInfo, groupInfoData.offset);
                            groupsInfo.splice(index, 0, groupInfo);
                            groupsInfo.hash = groupsInfo.hash || {};
                            groupsInfo.hash[JSON.stringify(groupInfo.key)] = groupInfo
                        }
                        if (pathIndex === path.length - 1) {
                            groupInfo.data = groupInfoData;
                            if (groupInfo.offset !== groupInfoData.offset) {
                                that._updateGroupInfoOffsets(groupsInfo)
                            }
                        }
                        groupsInfo = groupInfo.children
                    }
                },
                allowCollapseAll: function() {
                    return true
                },
                refresh: function(options) {
                    var that = this;
                    var storeLoadOptions = options.storeLoadOptions;
                    var groups = _utils.default.normalizeSortingInfo(storeLoadOptions.group || []);
                    var oldGroups = "_group" in that ? _utils.default.normalizeSortingInfo(that._group || []) : groups;
                    var groupsCount = Math.min(oldGroups.length, groups.length);
                    that._group = storeLoadOptions.group;
                    for (var groupIndex = 0; groupIndex < groupsCount; groupIndex++) {
                        if (oldGroups[groupIndex].selector !== groups[groupIndex].selector) {
                            groupsCount = groupIndex;
                            break
                        }
                    }
                    if (!groupsCount) {
                        that.reset()
                    } else {
                        cleanGroupsInfo(that._groupsInfo, 0, groupsCount)
                    }
                },
                handleDataLoading: function() {},
                handleDataLoaded: function(options, callBase) {
                    callBase(options)
                },
                handleDataLoadedCore: function(options, callBase) {
                    callBase(options)
                }
            }
        }());
        exports.GroupingHelper = GroupingHelper
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.master_detail.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.utils */ 35));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var MASTER_DETAIL_CELL_CLASS = "dx-master-detail-cell";
        var MASTER_DETAIL_ROW_CLASS = "dx-master-detail-row";
        var CELL_FOCUS_DISABLED_CLASS = "dx-cell-focus-disabled";
        var ROW_LINES_CLASS = "dx-row-lines";
        var _default = {
            defaultOptions: function() {
                return {
                    masterDetail: {
                        enabled: false,
                        autoExpandAll: false,
                        template: null
                    }
                }
            },
            extenders: {
                controllers: {
                    columns: {
                        _getExpandColumnsCore: function() {
                            var expandColumns = this.callBase();
                            if (this.option("masterDetail.enabled")) {
                                expandColumns.push({
                                    type: "detailExpand",
                                    cellTemplate: _uiGrid_core.default.getExpandCellTemplate()
                                })
                            }
                            return expandColumns
                        }
                    },
                    data: function() {
                        var initMasterDetail = function(that) {
                            that._expandedItems = [];
                            that._isExpandAll = that.option("masterDetail.autoExpandAll")
                        };
                        return {
                            init: function() {
                                var that = this;
                                initMasterDetail(that);
                                that.callBase()
                            },
                            expandAll: function(groupIndex) {
                                var that = this;
                                if (groupIndex < 0) {
                                    that._isExpandAll = true;
                                    that._expandedItems = [];
                                    that.updateItems()
                                } else {
                                    that.callBase.apply(that, arguments)
                                }
                            },
                            collapseAll: function(groupIndex) {
                                var that = this;
                                if (groupIndex < 0) {
                                    that._isExpandAll = false;
                                    that._expandedItems = [];
                                    that.updateItems()
                                } else {
                                    that.callBase.apply(that, arguments)
                                }
                            },
                            isRowExpanded: function(key) {
                                var that = this;
                                var expandIndex = _uiGrid_core.default.getIndexByKey(key, that._expandedItems);
                                if (Array.isArray(key)) {
                                    return that.callBase.apply(that, arguments)
                                } else {
                                    return !!(that._isExpandAll ^ (expandIndex >= 0 && that._expandedItems[expandIndex].visible))
                                }
                            },
                            _getRowIndicesForExpand: function(key) {
                                var rowIndex = this.getRowIndexByKey(key);
                                return [rowIndex, rowIndex + 1]
                            },
                            _changeRowExpandCore: function(key) {
                                var that = this;
                                var result;
                                if (Array.isArray(key)) {
                                    result = that.callBase.apply(that, arguments)
                                } else {
                                    var expandIndex = _uiGrid_core.default.getIndexByKey(key, that._expandedItems);
                                    if (expandIndex >= 0) {
                                        var visible = that._expandedItems[expandIndex].visible;
                                        that._expandedItems[expandIndex].visible = !visible
                                    } else {
                                        that._expandedItems.push({
                                            key: key,
                                            visible: true
                                        })
                                    }
                                    that.updateItems({
                                        changeType: "update",
                                        rowIndices: that._getRowIndicesForExpand(key)
                                    });
                                    result = (new _deferred.Deferred).resolve()
                                }
                                return result
                            },
                            _processDataItem: function(data, options) {
                                var that = this;
                                var dataItem = that.callBase.apply(that, arguments);
                                dataItem.isExpanded = that.isRowExpanded(dataItem.key);
                                if (void 0 === options.detailColumnIndex) {
                                    options.detailColumnIndex = -1;
                                    (0, _iterator.each)(options.visibleColumns, function(index, column) {
                                        if ("expand" === column.command && !(0, _type.isDefined)(column.groupIndex)) {
                                            options.detailColumnIndex = index;
                                            return false
                                        }
                                    })
                                }
                                if (options.detailColumnIndex >= 0) {
                                    dataItem.values[options.detailColumnIndex] = dataItem.isExpanded
                                }
                                return dataItem
                            },
                            _processItems: function(items, change) {
                                var that = this;
                                var changeType = change.changeType;
                                var result = [];
                                items = that.callBase.apply(that, arguments);
                                if ("loadingAll" === changeType) {
                                    return items
                                }
                                if ("refresh" === changeType) {
                                    that._expandedItems = (0, _common.grep)(that._expandedItems, function(item) {
                                        return item.visible
                                    })
                                }(0, _iterator.each)(items, function(index, item) {
                                    result.push(item);
                                    var expandIndex = _uiGrid_core.default.getIndexByKey(item.key, that._expandedItems);
                                    if ("data" === item.rowType && (item.isExpanded || expandIndex >= 0) && !item.isNewRow) {
                                        result.push({
                                            visible: item.isExpanded,
                                            rowType: "detail",
                                            key: item.key,
                                            data: item.data,
                                            values: []
                                        })
                                    }
                                });
                                return result
                            },
                            optionChanged: function(args) {
                                var that = this;
                                var isEnabledChanged;
                                var isAutoExpandAllChanged;
                                if ("masterDetail" === args.name) {
                                    args.name = "dataSource";
                                    switch (args.fullName) {
                                        case "masterDetail":
                                            var value = args.value || {};
                                            var previousValue = args.previousValue || {};
                                            isEnabledChanged = value.enabled !== previousValue.enabled;
                                            isAutoExpandAllChanged = value.autoExpandAll !== previousValue.autoExpandAll;
                                            break;
                                        case "masterDetail.enabled":
                                            isEnabledChanged = true;
                                            break;
                                        case "masterDetail.autoExpandAll":
                                            isAutoExpandAllChanged = true
                                    }
                                    if (isEnabledChanged || isAutoExpandAllChanged) {
                                        initMasterDetail(that)
                                    }
                                }
                                that.callBase(args)
                            }
                        }
                    }(),
                    resizing: {
                        fireContentReadyAction: function() {
                            this.callBase.apply(this, arguments);
                            this._updateParentDataGrids(this.component.$element())
                        },
                        _updateParentDataGrids: function($element) {
                            var _this = this;
                            var $masterDetailRow = $element.closest("." + MASTER_DETAIL_ROW_CLASS);
                            if ($masterDetailRow.length) {
                                (0, _deferred.when)(this._updateMasterDataGrid($masterDetailRow, $element)).done(function() {
                                    _this._updateParentDataGrids($masterDetailRow.parent())
                                })
                            }
                        },
                        _updateMasterDataGrid: function($masterDetailRow, $detailElement) {
                            var masterRowOptions = (0, _renderer.default)($masterDetailRow).data("options");
                            var masterDataGrid = (0, _renderer.default)($masterDetailRow).closest("." + this.getWidgetContainerClass()).parent().data("dxDataGrid");
                            if (masterRowOptions && masterDataGrid) {
                                if (masterDataGrid.getView("rowsView").isFixedColumns()) {
                                    this._updateFixedMasterDetailGrids(masterDataGrid, masterRowOptions.rowIndex, $detailElement)
                                } else {
                                    var scrollable = masterDataGrid.getScrollable();
                                    return scrollable && scrollable.update()
                                }
                            }
                        },
                        _updateFixedMasterDetailGrids: function(masterDataGrid, masterRowIndex, $detailElement) {
                            var _this2 = this;
                            var $rows = (0, _renderer.default)(masterDataGrid.getRowElement(masterRowIndex));
                            if ($rows && 2 === $rows.length && $rows.eq(0).height() !== $rows.eq(1).height()) {
                                var detailElementWidth = $detailElement.width();
                                return masterDataGrid.updateDimensions().done(function() {
                                    var isDetailHorizontalScrollCanBeShown = _this2.option("columnAutoWidth") && true === masterDataGrid.option("scrolling.useNative");
                                    var isDetailGridWidthChanged = isDetailHorizontalScrollCanBeShown && detailElementWidth !== $detailElement.width();
                                    if (isDetailHorizontalScrollCanBeShown && isDetailGridWidthChanged) {
                                        _this2.updateDimensions()
                                    }
                                })
                            }
                        },
                        _toggleBestFitMode: function(isBestFit) {
                            this.callBase.apply(this, arguments);
                            if (this.option("masterDetail.template")) {
                                var $rowsTable = this._rowsView.getTableElement();
                                if ($rowsTable) {
                                    $rowsTable.find(".dx-master-detail-cell").css("maxWidth", isBestFit ? 0 : "")
                                }
                            }
                        }
                    }
                },
                views: {
                    rowsView: function() {
                        return {
                            _getCellTemplate: function(options) {
                                var that = this;
                                var column = options.column;
                                var editingController = that.getController("editing");
                                var isEditRow = editingController && editingController.isEditRow(options.rowIndex);
                                var template;
                                if ("detail" === column.command && !isEditRow) {
                                    template = that.option("masterDetail.template") || {
                                        allowRenderToDetachedContainer: false,
                                        render: that._getDefaultTemplate(column)
                                    }
                                } else {
                                    template = that.callBase.apply(that, arguments)
                                }
                                return template
                            },
                            _isDetailRow: function(row) {
                                return row && row.rowType && 0 === row.rowType.indexOf("detail")
                            },
                            _createRow: function(row) {
                                var $row = this.callBase(row);
                                if (row && this._isDetailRow(row)) {
                                    this.option("showRowLines") && $row.addClass(ROW_LINES_CLASS);
                                    $row.addClass(MASTER_DETAIL_ROW_CLASS);
                                    if ((0, _type.isDefined)(row.visible)) {
                                        $row.toggle(row.visible)
                                    }
                                }
                                return $row
                            },
                            _renderCells: function($row, options) {
                                var row = options.row;
                                var $detailCell;
                                var visibleColumns = this._columnsController.getVisibleColumns();
                                if (row.rowType && this._isDetailRow(row)) {
                                    if (this._needRenderCell(0, options.columnIndices)) {
                                        $detailCell = this._renderCell($row, {
                                            value: null,
                                            row: row,
                                            rowIndex: row.rowIndex,
                                            column: {
                                                command: "detail"
                                            },
                                            columnIndex: 0
                                        });
                                        $detailCell.addClass(CELL_FOCUS_DISABLED_CLASS).addClass(MASTER_DETAIL_CELL_CLASS).attr("colSpan", visibleColumns.length)
                                    }
                                } else {
                                    this.callBase.apply(this, arguments)
                                }
                            }
                        }
                    }()
                }
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.editor_factory.js ***!
      \******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.modules */ 44));
        var _click = __webpack_require__( /*! ../../events/click */ 21);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../../events/pointer */ 24));
        var _position = _interopRequireDefault(__webpack_require__( /*! ../../animation/position */ 81));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _position2 = __webpack_require__( /*! ../../core/utils/position */ 22);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../shared/ui.editor_factory_mixin */ 399));
        var _uiGrid_core2 = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.utils */ 35));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var EDITOR_INLINE_BLOCK = "dx-editor-inline-block";
        var CELL_FOCUS_DISABLED_CLASS = "dx-cell-focus-disabled";
        var FOCUS_OVERLAY_CLASS = "focus-overlay";
        var CONTENT_CLASS = "content";
        var FOCUSED_ELEMENT_CLASS = "dx-focused";
        var ROW_CLASS = "dx-row";
        var MODULE_NAMESPACE = "dxDataGridEditorFactory";
        var UPDATE_FOCUS_EVENTS = (0, _index.addNamespace)([_pointer.default.down, "focusin", _click.name].join(" "), MODULE_NAMESPACE);
        var DX_HIDDEN = "dx-hidden";
        var EditorFactory = _uiGrid_core.default.ViewController.inherit({
            _getFocusedElement: function($dataGridElement) {
                var rowSelector = this.option("focusedRowEnabled") ? "tr[tabindex]:focus" : "tr[tabindex]:not(.dx-data-row):focus";
                var focusedElementSelector = "td[tabindex]:focus, ".concat(rowSelector, ", input:focus, textarea:focus, .dx-lookup-field:focus, .dx-checkbox:focus, .dx-switch:focus, .dx-dropdownbutton .dx-buttongroup:focus");
                return $dataGridElement.find(focusedElementSelector)
            },
            _getFocusCellSelector: function() {
                return ".dx-row > td"
            },
            _updateFocusCore: function() {
                var $focus = this._$focusedElement;
                var $dataGridElement = this.component && this.component.$element();
                var $focusCell;
                var hideBorders;
                if ($dataGridElement) {
                    $focus = this._getFocusedElement($dataGridElement);
                    if ($focus.length) {
                        if (!$focus.hasClass(CELL_FOCUS_DISABLED_CLASS) && !$focus.hasClass(ROW_CLASS)) {
                            $focusCell = $focus.closest(this._getFocusCellSelector() + ", ." + CELL_FOCUS_DISABLED_CLASS);
                            hideBorders = $focusCell.get(0) !== $focus.get(0) && $focusCell.hasClass(EDITOR_INLINE_BLOCK);
                            $focus = $focusCell
                        }
                        if ($focus.length && !$focus.hasClass(CELL_FOCUS_DISABLED_CLASS)) {
                            this.focus($focus, hideBorders);
                            return
                        }
                    }
                }
                this.loseFocus()
            },
            _updateFocus: function(e) {
                var that = this;
                var isFocusOverlay = e && e.event && (0, _renderer.default)(e.event.target).hasClass(that.addWidgetPrefix(FOCUS_OVERLAY_CLASS));
                that._isFocusOverlay = that._isFocusOverlay || isFocusOverlay;
                clearTimeout(that._updateFocusTimeoutID);
                that._updateFocusTimeoutID = setTimeout(function() {
                    delete that._updateFocusTimeoutID;
                    if (!that._isFocusOverlay) {
                        that._updateFocusCore()
                    }
                    that._isFocusOverlay = false
                })
            },
            _updateFocusOverlaySize: function($element, position) {
                $element.hide();
                var location = _position.default.calculate($element, (0, _extend.extend)({
                    collision: "fit"
                }, position));
                if (location.h.oversize > 0) {
                    $element.outerWidth($element.outerWidth() - location.h.oversize)
                }
                if (location.v.oversize > 0) {
                    $element.outerHeight($element.outerHeight() - location.v.oversize)
                }
                $element.show()
            },
            callbackNames: function() {
                return ["focused"]
            },
            focus: function($element, hideBorder) {
                var that = this;
                if (void 0 === $element) {
                    return that._$focusedElement
                } else {
                    if ($element) {
                        if (!$element.is(that._$focusedElement)) {
                            that._$focusedElement && that._$focusedElement.removeClass(FOCUSED_ELEMENT_CLASS)
                        }
                        that._$focusedElement = $element;
                        clearTimeout(that._focusTimeoutID);
                        that._focusTimeoutID = setTimeout(function() {
                            delete that._focusTimeoutID;
                            that.renderFocusOverlay($element, hideBorder);
                            $element.addClass(FOCUSED_ELEMENT_CLASS);
                            that.focused.fire($element)
                        })
                    }
                }
            },
            refocus: function() {
                var $focus = this.focus();
                this.focus($focus)
            },
            renderFocusOverlay: function($element, hideBorder) {
                var that = this;
                if (!_uiGrid_core2.default.isElementInCurrentGrid(this, $element)) {
                    return
                }
                if (!that._$focusOverlay) {
                    that._$focusOverlay = (0, _renderer.default)("<div>").addClass(that.addWidgetPrefix(FOCUS_OVERLAY_CLASS))
                }
                if (hideBorder) {
                    that._$focusOverlay.addClass(DX_HIDDEN)
                } else {
                    if ($element.length) {
                        var align = _browser.default.msie ? "left bottom" : _browser.default.mozilla ? "right bottom" : "left top";
                        var $content = $element.closest("." + that.addWidgetPrefix(CONTENT_CLASS));
                        var elemCoord = (0, _position2.getBoundingRect)($element.get(0));
                        that._$focusOverlay.removeClass(DX_HIDDEN).appendTo($content).outerWidth(elemCoord.right - elemCoord.left + 1).outerHeight(elemCoord.bottom - elemCoord.top + 1);
                        var focusOverlayPosition = {
                            precise: true,
                            my: align,
                            at: align,
                            of: $element,
                            boundary: $content.length && $content
                        };
                        that._updateFocusOverlaySize(that._$focusOverlay, focusOverlayPosition);
                        _position.default.setup(that._$focusOverlay, focusOverlayPosition);
                        that._$focusOverlay.css("visibility", "visible")
                    }
                }
            },
            resize: function() {
                var $focusedElement = this._$focusedElement;
                if ($focusedElement) {
                    this.focus($focusedElement)
                }
            },
            loseFocus: function() {
                this._$focusedElement && this._$focusedElement.removeClass(FOCUSED_ELEMENT_CLASS);
                this._$focusedElement = null;
                this._$focusOverlay && this._$focusOverlay.addClass(DX_HIDDEN)
            },
            init: function() {
                this.createAction("onEditorPreparing", {
                    excludeValidators: ["disabled", "readOnly"],
                    category: "rendering"
                });
                this.createAction("onEditorPrepared", {
                    excludeValidators: ["disabled", "readOnly"],
                    category: "rendering"
                });
                this._updateFocusHandler = this._updateFocusHandler || this.createAction(this._updateFocus.bind(this));
                _events_engine.default.on(_dom_adapter.default.getDocument(), UPDATE_FOCUS_EVENTS, this._updateFocusHandler);
                this._attachContainerEventHandlers()
            },
            _attachContainerEventHandlers: function() {
                var that = this;
                var $container = that.component && that.component.$element();
                if ($container) {
                    _events_engine.default.on($container, (0, _index.addNamespace)("keydown", MODULE_NAMESPACE), function(e) {
                        if ("tab" === (0, _index.normalizeKeyName)(e)) {
                            that._updateFocusHandler(e)
                        }
                    })
                }
            },
            dispose: function() {
                clearTimeout(this._focusTimeoutID);
                clearTimeout(this._updateFocusTimeoutID);
                _events_engine.default.off(_dom_adapter.default.getDocument(), UPDATE_FOCUS_EVENTS, this._updateFocusHandler)
            }
        }).include(_ui.default);
        var _default = {
            defaultOptions: function() {
                return {}
            },
            controllers: {
                editorFactory: EditorFactory
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/shared/ui.editor_factory_mixin.js ***!
      \***********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _variable_wrapper = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/variable_wrapper */ 102));
        var _data = __webpack_require__( /*! ../../core/utils/data */ 20);
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _element = __webpack_require__( /*! ../../core/element */ 18);
        var _utils = __webpack_require__( /*! ../../data/data_source/utils */ 69);
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        __webpack_require__( /*! ../text_box */ 97);
        __webpack_require__( /*! ../number_box */ 116);
        __webpack_require__( /*! ../check_box */ 136);
        __webpack_require__( /*! ../select_box */ 117);
        __webpack_require__( /*! ../date_box */ 212);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var isWrapped = _variable_wrapper.default.isWrapped;
        var CHECKBOX_SIZE_CLASS = "checkbox-size";
        var EDITOR_INLINE_BLOCK = "dx-editor-inline-block";
        var EditorFactoryMixin = function() {
            var getResultConfig = function(config, options) {
                return (0, _extend.extend)(config, {
                    readOnly: options.readOnly,
                    placeholder: options.placeholder,
                    inputAttr: {
                        id: options.id
                    },
                    tabIndex: options.tabIndex
                }, options.editorOptions)
            };
            var checkEnterBug = function() {
                return _browser.default.msie || _browser.default.mozilla || _devices.default.real().ios
            };
            var getTextEditorConfig = function(options) {
                var data = {};
                var isEnterBug = checkEnterBug();
                var sharedData = options.sharedData || data;
                return getResultConfig({
                    placeholder: options.placeholder,
                    width: options.width,
                    value: options.value,
                    onValueChanged: function(e) {
                        var needDelayedUpdate = "filterRow" === options.parentType || "searchPanel" === options.parentType;
                        var isInputOrKeyUpEvent = e.event && ("input" === e.event.type || "keyup" === e.event.type);
                        var updateValue = function(e, notFireEvent) {
                            options && options.setValue(e.value, notFireEvent)
                        };
                        clearTimeout(data.valueChangeTimeout);
                        if (isInputOrKeyUpEvent && needDelayedUpdate) {
                            sharedData.valueChangeTimeout = data.valueChangeTimeout = setTimeout(function() {
                                updateValue(e, data.valueChangeTimeout !== sharedData.valueChangeTimeout)
                            }, (0, _type.isDefined)(options.updateValueTimeout) ? options.updateValueTimeout : 0)
                        } else {
                            updateValue(e)
                        }
                    },
                    onKeyDown: function(e) {
                        if (isEnterBug && "enter" === (0, _index.normalizeKeyName)(e.event)) {
                            _events_engine.default.trigger((0, _renderer.default)(e.component._input()), "change")
                        }
                    },
                    valueChangeEvent: "change" + ("filterRow" === options.parentType ? " keyup input" : "")
                }, options)
            };
            var prepareDateBox = function(options) {
                options.editorName = "dxDateBox";
                options.editorOptions = getResultConfig({
                    value: options.value,
                    onValueChanged: function(args) {
                        options.setValue(args.value)
                    },
                    onKeyDown: function(e) {
                        if (checkEnterBug() && "enter" === (0, _index.normalizeKeyName)(e.event)) {
                            e.component.blur();
                            e.component.focus()
                        }
                    },
                    displayFormat: options.format,
                    type: options.dataType,
                    dateSerializationFormat: null,
                    width: "filterBuilder" === options.parentType ? void 0 : "auto"
                }, options)
            };
            var prepareTextBox = function(options) {
                var config = getTextEditorConfig(options);
                var isSearching = "searchPanel" === options.parentType;
                var toString = function(value) {
                    return (0, _type.isDefined)(value) ? value.toString() : ""
                };
                if (options.editorType && "dxTextBox" !== options.editorType) {
                    config.value = options.value
                } else {
                    config.value = toString(options.value)
                }
                config.valueChangeEvent += isSearching ? " keyup input search" : "";
                config.mode = config.mode || (isSearching ? "search" : "text");
                options.editorName = "dxTextBox";
                options.editorOptions = config
            };
            var prepareNumberBox = function(options) {
                var config = getTextEditorConfig(options);
                config.value = (0, _type.isDefined)(options.value) ? options.value : null;
                options.editorName = "dxNumberBox";
                options.editorOptions = config
            };
            var prepareBooleanEditor = function(options) {
                if ("filterRow" === options.parentType || "filterBuilder" === options.parentType) {
                    prepareSelectBox((0, _extend.extend)(options, {
                        lookup: {
                            displayExpr: function(data) {
                                if (true === data) {
                                    return options.trueText || "true"
                                } else {
                                    if (false === data) {
                                        return options.falseText || "false"
                                    }
                                }
                            },
                            dataSource: [true, false]
                        }
                    }))
                } else {
                    prepareCheckBox(options)
                }
            };

            function watchLookupDataSource(options) {
                if (options.row && options.row.watch && "dataRow" === options.parentType) {
                    var editorOptions = options.editorOptions || {};
                    options.editorOptions = editorOptions;
                    var selectBox;
                    var onInitialized = editorOptions.onInitialized;
                    editorOptions.onInitialized = function(e) {
                        onInitialized && onInitialized.apply(this, arguments);
                        selectBox = e.component;
                        selectBox.on("disposing", stopWatch)
                    };
                    var dataSource;
                    var stopWatch = options.row.watch(function() {
                        dataSource = options.lookup.dataSource(options.row);
                        return dataSource && dataSource.filter
                    }, function() {
                        selectBox.option("dataSource", dataSource)
                    }, function(row) {
                        options.row = row
                    })
                }
            }

            function prepareSelectBox(options) {
                var lookup = options.lookup;
                var displayGetter;
                var dataSource;
                var postProcess;
                var isFilterRow = "filterRow" === options.parentType;
                if (lookup) {
                    displayGetter = (0, _data.compileGetter)(lookup.displayExpr);
                    dataSource = lookup.dataSource;
                    if ((0, _type.isFunction)(dataSource) && !isWrapped(dataSource)) {
                        dataSource = dataSource(options.row || {});
                        watchLookupDataSource(options)
                    }
                    if ((0, _type.isObject)(dataSource) || Array.isArray(dataSource)) {
                        dataSource = (0, _utils.normalizeDataSourceOptions)(dataSource);
                        if (isFilterRow) {
                            postProcess = dataSource.postProcess;
                            dataSource.postProcess = function(items) {
                                if (0 === this.pageIndex()) {
                                    items = items.slice(0);
                                    items.unshift(null)
                                }
                                if (postProcess) {
                                    return postProcess.call(this, items)
                                }
                                return items
                            }
                        }
                    }
                    var allowClearing = Boolean(lookup.allowClearing && !isFilterRow);
                    options.editorName = "dxSelectBox";
                    options.editorOptions = getResultConfig({
                        searchEnabled: true,
                        value: options.value,
                        valueExpr: options.lookup.valueExpr,
                        searchExpr: options.lookup.searchExpr || options.lookup.displayExpr,
                        allowClearing: allowClearing,
                        showClearButton: allowClearing,
                        displayExpr: function(data) {
                            if (null === data) {
                                return options.showAllText
                            }
                            return displayGetter(data)
                        },
                        dataSource: dataSource,
                        onValueChanged: function(e) {
                            var params = [e.value];
                            !isFilterRow && params.push(e.component.option("text"));
                            options.setValue.apply(this, params)
                        }
                    }, options)
                }
            }

            function prepareCheckBox(options) {
                options.editorName = "dxCheckBox";
                options.editorOptions = getResultConfig({
                    elementAttr: {
                        id: options.id
                    },
                    value: (0, _type.isDefined)(options.value) ? options.value : void 0,
                    hoverStateEnabled: !options.readOnly,
                    focusStateEnabled: !options.readOnly,
                    activeStateEnabled: false,
                    onValueChanged: function(e) {
                        options.setValue && options.setValue(e.value, e)
                    }
                }, options)
            }
            var createEditorCore = function(that, options) {
                var $editorElement = (0, _renderer.default)(options.editorElement);
                if (options.editorName && options.editorOptions && $editorElement[options.editorName]) {
                    if ("dxCheckBox" === options.editorName || "dxSwitch" === options.editorName) {
                        if (!options.isOnForm) {
                            $editorElement.addClass(that.addWidgetPrefix(CHECKBOX_SIZE_CLASS));
                            $editorElement.parent().addClass(EDITOR_INLINE_BLOCK)
                        }
                    }
                    that._createComponent($editorElement, options.editorName, options.editorOptions);
                    if ("dxTextBox" === options.editorName) {
                        $editorElement.dxTextBox("instance").registerKeyHandler("enter", _common.noop)
                    }
                    if ("dxDateBox" === options.editorName) {
                        var dateBox = $editorElement.dxDateBox("instance");
                        var defaultEnterKeyHandler = dateBox._supportedKeys().enter;
                        dateBox.registerKeyHandler("enter", function(e) {
                            if (dateBox.option("opened")) {
                                defaultEnterKeyHandler(e)
                            }
                            return true
                        })
                    }
                    if ("dxTextArea" === options.editorName) {
                        $editorElement.dxTextArea("instance").registerKeyHandler("enter", function(event) {
                            if ("enter" === (0, _index.normalizeKeyName)(event) && !event.ctrlKey && !event.shiftKey) {
                                event.stopPropagation()
                            }
                        })
                    }
                }
            };
            return {
                createEditor: function($container, options) {
                    options.cancel = false;
                    options.editorElement = (0, _element.getPublicElement)($container);
                    if (!(0, _type.isDefined)(options.tabIndex)) {
                        options.tabIndex = this.option("tabIndex")
                    }
                    if (options.lookup) {
                        prepareSelectBox(options)
                    } else {
                        switch (options.dataType) {
                            case "date":
                            case "datetime":
                                prepareDateBox(options);
                                break;
                            case "boolean":
                                prepareBooleanEditor(options);
                                break;
                            case "number":
                                prepareNumberBox(options);
                                break;
                            default:
                                prepareTextBox(options)
                        }
                    }
                    var editorName = options.editorName;
                    this.executeAction("onEditorPreparing", options);
                    if (options.cancel) {
                        return
                    } else {
                        if ("dataRow" === options.parentType && options.editorType && editorName === options.editorName) {
                            options.editorName = options.editorType
                        }
                    }
                    if ("dataRow" === options.parentType && !options.isOnForm && !(0, _type.isDefined)(options.editorOptions.showValidationMark)) {
                        options.editorOptions.showValidationMark = false
                    }
                    createEditorCore(this, options);
                    this.executeAction("onEditorPrepared", options)
                }
            }
        }();
        var _default = EditorFactoryMixin;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.editing.js ***!
      \***********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _guid = _interopRequireDefault(__webpack_require__( /*! ../../core/guid */ 36));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.modules */ 44));
        var _click = __webpack_require__( /*! ../../events/click */ 21);
        var _double_click = __webpack_require__( /*! ../../events/double_click */ 151);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../../events/pointer */ 24));
        var _uiGrid_core2 = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.utils */ 35));
        var _array_utils = __webpack_require__( /*! ../../data/array_utils */ 93);
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _dialog = __webpack_require__( /*! ../dialog */ 267);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _button = _interopRequireDefault(__webpack_require__( /*! ../button */ 37));
        var _popup = _interopRequireDefault(__webpack_require__( /*! ../popup */ 46));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _form = _interopRequireDefault(__webpack_require__( /*! ../form */ 138));
        var _hold = _interopRequireDefault(__webpack_require__( /*! ../../events/hold */ 104));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var iconUtils = _interopRequireWildcard(__webpack_require__( /*! ../../core/utils/icon */ 56));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../scroll_view/ui.scrollable */ 106));

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }
        var EDIT_FORM_CLASS = "edit-form";
        var EDIT_FORM_ITEM_CLASS = "edit-form-item";
        var FOCUS_OVERLAY_CLASS = "focus-overlay";
        var READONLY_CLASS = "readonly";
        var EDIT_POPUP_CLASS = "edit-popup";
        var FORM_BUTTONS_CONTAINER_CLASS = "form-buttons-container";
        var ADD_ROW_BUTTON_CLASS = "addrow-button";
        var DROPDOWN_EDITOR_OVERLAY_CLASS = "dx-dropdowneditor-overlay";
        var LINK_CLASS = "dx-link";
        var EDITOR_CELL_CLASS = "dx-editor-cell";
        var ROW_SELECTED = "dx-selection";
        var EDIT_ROW = "dx-edit-row";
        var EDIT_BUTTON_CLASS = "dx-edit-button";
        var COMMAND_EDIT_CLASS = "dx-command-edit";
        var COMMAND_EDIT_WITH_ICONS_CLASS = COMMAND_EDIT_CLASS + "-with-icons";
        var SCROLLABLE_CONTAINER_CLASS = "dx-scrollable-container";
        var BUTTON_CLASS = "dx-button";
        var INSERT_INDEX = "__DX_INSERT_INDEX__";
        var ROW_CLASS = "dx-row";
        var ROW_REMOVED = "dx-row-removed";
        var ROW_INSERTED = "dx-row-inserted";
        var ROW_MODIFIED = "dx-row-modified";
        var CELL_MODIFIED = "dx-cell-modified";
        var EDITING_NAMESPACE = "dxDataGridEditing";
        var DATA_ROW_CLASS = "dx-data-row";
        var CELL_FOCUS_DISABLED_CLASS = "dx-cell-focus-disabled";
        var EDITORS_INPUT_SELECTOR = "input:not([type='hidden'])";
        var FOCUSABLE_ELEMENT_SELECTOR = "[tabindex], " + EDITORS_INPUT_SELECTOR;
        var EDIT_MODE_BATCH = "batch";
        var EDIT_MODE_ROW = "row";
        var EDIT_MODE_CELL = "cell";
        var EDIT_MODE_FORM = "form";
        var EDIT_MODE_POPUP = "popup";
        var DATA_EDIT_DATA_INSERT_TYPE = "insert";
        var DATA_EDIT_DATA_UPDATE_TYPE = "update";
        var DATA_EDIT_DATA_REMOVE_TYPE = "remove";
        var DEFAULT_START_EDIT_ACTION = "click";
        var EDIT_MODES = [EDIT_MODE_BATCH, EDIT_MODE_ROW, EDIT_MODE_CELL, EDIT_MODE_FORM, EDIT_MODE_POPUP];
        var ROW_BASED_MODES = [EDIT_MODE_ROW, EDIT_MODE_FORM, EDIT_MODE_POPUP];
        var CELL_BASED_MODES = [EDIT_MODE_BATCH, EDIT_MODE_CELL];
        var FORM_BASED_MODES = [EDIT_MODE_FORM, EDIT_MODE_POPUP];
        var MODES_WITH_DELAYED_FOCUS = [EDIT_MODE_ROW, EDIT_MODE_FORM];
        var TARGET_COMPONENT_NAME = "targetComponent";
        var EDIT_LINK_CLASS = {
            save: "dx-link-save",
            cancel: "dx-link-cancel",
            edit: "dx-link-edit",
            undelete: "dx-link-undelete",
            "delete": "dx-link-delete",
            add: "dx-link-add"
        };
        var EDIT_ICON_CLASS = {
            save: "save",
            cancel: "revert",
            edit: "edit",
            undelete: "revert",
            "delete": "trash",
            add: "add"
        };
        var METHOD_NAMES = {
            edit: "editRow",
            "delete": "deleteRow",
            undelete: "undeleteRow",
            save: "saveEditData",
            cancel: "cancelEditData",
            add: "addRowByRowIndex"
        };
        var ACTION_OPTION_NAMES = {
            add: "allowAdding",
            edit: "allowUpdating",
            "delete": "allowDeleting"
        };
        var BUTTON_NAMES = ["edit", "save", "cancel", "delete", "undelete"];
        var EDITING_POPUP_OPTION_NAME = "editing.popup";
        var EDITING_CHANGES_OPTION_NAME = "editing.changes";
        var EDITING_EDITROWKEY_OPTION_NAME = "editing.editRowKey";
        var EDITING_EDITCOLUMNNAME_OPTION_NAME = "editing.editColumnName";
        var createFailureHandler = function(deferred) {
            return function(arg) {
                var error = arg instanceof Error ? arg : new Error(arg && String(arg) || "Unknown error");
                deferred.reject(error)
            }
        };
        var _getEditMode = function(that) {
            var editMode = that.option("editing.mode");
            if (EDIT_MODES.indexOf(editMode) !== -1) {
                return editMode
            }
            return EDIT_MODE_ROW
        };
        var _isRowEditMode = function(that) {
            var editMode = _getEditMode(that);
            return ROW_BASED_MODES.indexOf(editMode) !== -1
        };
        var isEditingCell = function(isEditRow, cellOptions) {
            return cellOptions.isEditing || isEditRow && cellOptions.column.allowEditing
        };
        var isEditingOrShowEditorAlwaysDataCell = function(isEditRow, cellOptions) {
            var isCommandCell = !!cellOptions.column.command;
            var isEditing = isEditingCell(isEditRow, cellOptions);
            var isEditorCell = !isCommandCell && (isEditing || cellOptions.column.showEditorAlways);
            return "data" === cellOptions.rowType && isEditorCell
        };
        var EditingController = _uiGrid_core.default.ViewController.inherit(function() {
            var getDefaultEditorTemplate = function(that) {
                return function(container, options) {
                    var $editor = (0, _renderer.default)("<div>").appendTo(container);
                    that.getController("editorFactory").createEditor($editor, (0, _extend.extend)({}, options.column, {
                        value: options.value,
                        setValue: options.setValue,
                        row: options.row,
                        parentType: "dataRow",
                        width: null,
                        readOnly: !options.setValue,
                        isOnForm: options.isOnForm,
                        id: options.id
                    }))
                }
            };
            var getEditingTexts = function(options) {
                var editingTexts = options.component.option("editing.texts") || {};
                return {
                    save: editingTexts.saveRowChanges,
                    cancel: editingTexts.cancelRowChanges,
                    edit: editingTexts.editRow,
                    undelete: editingTexts.undeleteRow,
                    "delete": editingTexts.deleteRow,
                    add: editingTexts.addRowToNode
                }
            };
            var getButtonIndex = function(buttons, name) {
                var result = -1;
                buttons.some(function(button, index) {
                    if (getButtonName(button) === name) {
                        result = index;
                        return true
                    }
                });
                return result
            };

            function getButtonName(button) {
                return (0, _type.isObject)(button) ? button.name : button
            }
            var getEditorType = function(item) {
                var column = item.column;
                return item.isCustomEditorType ? item.editorType : column.formItem && column.formItem.editorType
            };
            var forEachFormItems = function forEachFormItems(items, callBack) {
                items.forEach(function(item) {
                    if (item.items || item.tabs) {
                        forEachFormItems(item.items || item.tabs, callBack)
                    } else {
                        callBack(item)
                    }
                })
            };
            return {
                init: function() {
                    var that = this;
                    that._columnsController = that.getController("columns");
                    that._dataController = that.getController("data");
                    that._rowsView = that.getView("rowsView");
                    that._editForm = null;
                    that._updateEditFormDeferred = null;
                    that._lastOperation = null;
                    if (that._deferreds) {
                        that._deferreds.forEach(function(d) {
                            return d.reject("cancel")
                        })
                    }
                    that._deferreds = [];
                    if (!that._dataChangedHandler) {
                        that._dataChangedHandler = that._handleDataChanged.bind(that);
                        that._dataController.changed.add(that._dataChangedHandler)
                    }
                    if (!that._saveEditorHandler) {
                        that.createAction("onInitNewRow", {
                            excludeValidators: ["disabled", "readOnly"]
                        });
                        that.createAction("onRowInserting", {
                            excludeValidators: ["disabled", "readOnly"]
                        });
                        that.createAction("onRowInserted", {
                            excludeValidators: ["disabled", "readOnly"]
                        });
                        that.createAction("onEditingStart", {
                            excludeValidators: ["disabled", "readOnly"]
                        });
                        that.createAction("onRowUpdating", {
                            excludeValidators: ["disabled", "readOnly"]
                        });
                        that.createAction("onRowUpdated", {
                            excludeValidators: ["disabled", "readOnly"]
                        });
                        that.createAction("onRowRemoving", {
                            excludeValidators: ["disabled", "readOnly"]
                        });
                        that.createAction("onRowRemoved", {
                            excludeValidators: ["disabled", "readOnly"]
                        });
                        that.createAction("onSaved", {
                            excludeValidators: ["disabled", "readOnly"]
                        });
                        that.createAction("onSaving", {
                            excludeValidators: ["disabled", "readOnly"]
                        });
                        that.createAction("onEditCanceling", {
                            excludeValidators: ["disabled", "readOnly"]
                        });
                        that.createAction("onEditCanceled", {
                            excludeValidators: ["disabled", "readOnly"]
                        });
                        var $pointerDownTarget;
                        var isResizing;
                        that._pointerUpEditorHandler = function() {
                            var _that$getController;
                            isResizing = null === (_that$getController = that.getController("columnsResizer")) || void 0 === _that$getController ? void 0 : _that$getController.isResizing()
                        };
                        that._pointerDownEditorHandler = function(e) {
                            return $pointerDownTarget = (0, _renderer.default)(e.target)
                        };
                        that._saveEditorHandler = that.createAction(function(e) {
                            var event = e.event;
                            var $target = (0, _renderer.default)(event.target);
                            var targetComponent = event[TARGET_COMPONENT_NAME];
                            if ($pointerDownTarget && $pointerDownTarget.is("input") && !$pointerDownTarget.is($target)) {
                                return
                            }

                            function checkEditorPopup($element) {
                                return $element && !!$element.closest(".".concat(DROPDOWN_EDITOR_OVERLAY_CLASS)).length
                            }
                            if (!_isRowEditMode(that) && !that._editCellInProgress) {
                                var isEditorPopup = checkEditorPopup($target) || checkEditorPopup(null === targetComponent || void 0 === targetComponent ? void 0 : targetComponent.$element());
                                var isDomElement = !!$target.closest((0, _window.getWindow)().document).length;
                                var isAnotherComponent = targetComponent && !targetComponent._disposed && targetComponent !== that.component;
                                var isAddRowButton = !!$target.closest(".".concat(that.addWidgetPrefix(ADD_ROW_BUTTON_CLASS))).length;
                                var isFocusOverlay = $target.hasClass(that.addWidgetPrefix(FOCUS_OVERLAY_CLASS));
                                var isCellEditMode = _getEditMode(that) === EDIT_MODE_CELL;
                                if (!isResizing && !isEditorPopup && !isFocusOverlay && !(isAddRowButton && isCellEditMode && that.isEditing()) && (isDomElement || isAnotherComponent)) {
                                    that._closeEditItem.bind(that)($target)
                                }
                            }
                        });
                        _events_engine.default.on(_dom_adapter.default.getDocument(), _pointer.default.up, that._pointerUpEditorHandler);
                        _events_engine.default.on(_dom_adapter.default.getDocument(), _pointer.default.down, that._pointerDownEditorHandler);
                        _events_engine.default.on(_dom_adapter.default.getDocument(), _click.name, that._saveEditorHandler)
                    }
                    that._updateEditColumn();
                    that._updateEditButtons();
                    if (!this._internalState) {
                        this._internalState = []
                    }
                    this.component._optionsByReference[EDITING_EDITROWKEY_OPTION_NAME] = true;
                    this.component._optionsByReference[EDITING_CHANGES_OPTION_NAME] = true
                },
                getChanges: function() {
                    return this.option(EDITING_CHANGES_OPTION_NAME)
                },
                resetChanges: function() {
                    var changes = this.getChanges();
                    var needReset = null === changes || void 0 === changes ? void 0 : changes.length;
                    if (needReset) {
                        this._silentOption(EDITING_CHANGES_OPTION_NAME, [])
                    }
                },
                _getInternalData: function(key) {
                    return this._internalState.filter(function(item) {
                        return item.key === key
                    })[0]
                },
                _addInternalData: function(params) {
                    var internalData = this._getInternalData(params.key);
                    if (internalData) {
                        return (0, _extend.extend)(internalData, params)
                    }
                    this._internalState.push(params);
                    return params
                },
                _getOldData: function(key) {
                    var _this$_getInternalDat;
                    return null === (_this$_getInternalDat = this._getInternalData(key)) || void 0 === _this$_getInternalDat ? void 0 : _this$_getInternalDat.oldData
                },
                getUpdatedData: function(data) {
                    var key = this._dataController.keyOf(data);
                    var changes = this.getChanges();
                    var editIndex = _uiGrid_core2.default.getIndexByKey(key, changes);
                    if (changes[editIndex]) {
                        return (0, _array_utils.createObjectWithChanges)(data, changes[editIndex].data)
                    }
                    return data
                },
                getInsertedData: function() {
                    return this.getChanges().filter(function(change) {
                        return change.data && change.type === DATA_EDIT_DATA_INSERT_TYPE
                    }).map(function(change) {
                        return change.data
                    })
                },
                getRemovedData: function() {
                    var _this = this;
                    return this.getChanges().filter(function(change) {
                        return _this._getOldData(change.key) && change.type === DATA_EDIT_DATA_REMOVE_TYPE
                    }).map(function(change) {
                        return _this._getOldData(change.key)
                    })
                },
                _fireDataErrorOccurred: function(arg) {
                    if ("cancel" === arg) {
                        return
                    }
                    var $popupContent = this.getPopupContent();
                    this._dataController.dataErrorOccurred.fire(arg, $popupContent)
                },
                _needToCloseEditableCell: function($targetElement) {
                    var $element = this.component.$element();
                    var result = this.isEditing();
                    var isCurrentComponentElement = !$element || !!$targetElement.closest($element).length;
                    if (isCurrentComponentElement) {
                        var isDataRow = $targetElement.closest("." + DATA_ROW_CLASS).length;
                        if (isDataRow) {
                            var rowsView = this.getView("rowsView");
                            var $targetCell = $targetElement.closest("." + ROW_CLASS + "> td");
                            var rowIndex = rowsView.getRowIndex($targetCell.parent());
                            var columnIndex = rowsView.getCellElements(rowIndex).index($targetCell);
                            var visibleColumns = this._columnsController.getVisibleColumns();
                            var allowEditing = visibleColumns[columnIndex] && visibleColumns[columnIndex].allowEditing;
                            result = result && !allowEditing && !this.isEditCell(rowIndex, columnIndex)
                        }
                    }
                    return result
                },
                _closeEditItem: function($targetElement) {
                    if (this._needToCloseEditableCell($targetElement)) {
                        this.closeEditCell()
                    }
                },
                _handleDataChanged: function(args) {
                    var editForm = this._editForm;
                    if ("refresh" === args.changeType && _getEditMode(this) === EDIT_MODE_POPUP && editForm && editForm.option("visible")) {
                        this._repaintEditPopup()
                    }
                },
                _isDefaultButtonVisible: function(button, options) {
                    var result = true;
                    var isRowMode = _isRowEditMode(this);
                    var isBatchMode = _getEditMode(this) === EDIT_MODE_BATCH;
                    var isEditRow = options.row && options.row.rowIndex === this._getVisibleEditRowIndex() && isRowMode;
                    switch (button.name) {
                        case "edit":
                            result = !isEditRow && this.allowUpdating(options) && isRowMode;
                            break;
                        case "save":
                        case "cancel":
                            result = isEditRow;
                            break;
                        case "delete":
                            result = !isEditRow && this.allowDeleting(options) && (!isBatchMode || !options.row.removed);
                            break;
                        case "undelete":
                            result = isBatchMode && this.allowDeleting(options) && options.row.removed
                    }
                    return result
                },
                _isButtonVisible: function(button, options) {
                    var visible = button.visible;
                    if (!(0, _type.isDefined)(visible)) {
                        return this._isDefaultButtonVisible(button, options)
                    }
                    return (0, _type.isFunction)(visible) ? visible.call(button, {
                        component: options.component,
                        row: options.row,
                        column: options.column
                    }) : visible
                },
                _getButtonConfig: function(button, options) {
                    var _this2 = this;
                    var config = (0, _type.isObject)(button) ? button : {};
                    var buttonName = getButtonName(button);
                    var editingTexts = getEditingTexts(options);
                    var methodName = METHOD_NAMES[buttonName];
                    var editingOptions = this.option("editing");
                    var actionName = ACTION_OPTION_NAMES[buttonName];
                    var allowAction = actionName ? editingOptions[actionName] : true;
                    return (0, _extend.extend)({
                        name: buttonName,
                        text: editingTexts[buttonName],
                        cssClass: EDIT_LINK_CLASS[buttonName],
                        onClick: function(e) {
                            var event = e.event;
                            event.stopPropagation();
                            event.preventDefault();
                            setTimeout(function() {
                                options.row && allowAction && _this2[methodName] && _this2[methodName](options.row.rowIndex)
                            })
                        }
                    }, config)
                },
                _getEditingButtons: function(options) {
                    var _this3 = this;
                    var buttonIndex;
                    var haveCustomButtons = !!options.column.buttons;
                    var buttons = (options.column.buttons || []).slice();
                    if (haveCustomButtons) {
                        buttonIndex = getButtonIndex(buttons, "edit");
                        if (buttonIndex >= 0) {
                            if (getButtonIndex(buttons, "save") < 0) {
                                buttons.splice(buttonIndex + 1, 0, "save")
                            }
                            if (getButtonIndex(buttons, "cancel") < 0) {
                                buttons.splice(getButtonIndex(buttons, "save") + 1, 0, "cancel")
                            }
                        }
                        buttonIndex = getButtonIndex(buttons, "delete");
                        if (buttonIndex >= 0 && getButtonIndex(buttons, "undelete") < 0) {
                            buttons.splice(buttonIndex + 1, 0, "undelete")
                        }
                    } else {
                        buttons = BUTTON_NAMES.slice()
                    }
                    return buttons.map(function(button) {
                        return _this3._getButtonConfig(button, options)
                    })
                },
                _renderEditingButtons: function($container, buttons, options) {
                    var _this4 = this;
                    buttons.forEach(function(button) {
                        if (_this4._isButtonVisible(button, options)) {
                            _this4._createButton($container, button, options)
                        }
                    })
                },
                _getEditCommandCellTemplate: function() {
                    var _this5 = this;
                    return function(container, options) {
                        var $container = (0, _renderer.default)(container);
                        if ("data" === options.rowType) {
                            var buttons = _this5._getEditingButtons(options);
                            _this5._renderEditingButtons($container, buttons, options);
                            options.watch && options.watch(function() {
                                return buttons.map(function(button) {
                                    return _this5._isButtonVisible(button, options)
                                })
                            }, function() {
                                $container.empty();
                                _this5._renderEditingButtons($container, buttons, options)
                            })
                        } else {
                            _uiGrid_core2.default.setEmptyText($container)
                        }
                    }
                },
                isRowEditMode: function() {
                    return _isRowEditMode(this)
                },
                isFormEditMode: function() {
                    var editMode = _getEditMode(this);
                    return FORM_BASED_MODES.indexOf(editMode) !== -1
                },
                isCellOrBatchEditMode: function() {
                    var editMode = this.getEditMode();
                    return CELL_BASED_MODES.indexOf(editMode) !== -1
                },
                getEditMode: function() {
                    return _getEditMode(this)
                },
                getFirstEditableColumnIndex: function() {
                    var columnsController = this.getController("columns");
                    var firstFormItem = this._firstFormItem;
                    var columnIndex;
                    if (_getEditMode(this) === EDIT_MODE_FORM && firstFormItem) {
                        var editRowKey = this.option(EDITING_EDITROWKEY_OPTION_NAME);
                        var editRowIndex = this._dataController.getRowIndexByKey(editRowKey);
                        var $editFormElements = this._rowsView.getCellElements(editRowIndex);
                        columnIndex = this._rowsView._getEditFormEditorVisibleIndex($editFormElements, firstFormItem.column)
                    } else {
                        var visibleColumns = columnsController.getVisibleColumns();
                        (0, _iterator.each)(visibleColumns, function(index, column) {
                            if (column.allowEditing) {
                                columnIndex = index;
                                return false
                            }
                        })
                    }
                    return columnIndex
                },
                getFirstEditableCellInRow: function(rowIndex) {
                    var rowsView = this.getView("rowsView");
                    return rowsView && rowsView._getCellElement(rowIndex ? rowIndex : 0, this.getFirstEditableColumnIndex())
                },
                getFocusedCellInRow: function(rowIndex) {
                    return this.getFirstEditableCellInRow(rowIndex)
                },
                getIndexByKey: function(key, items) {
                    return _uiGrid_core2.default.getIndexByKey(key, items)
                },
                hasChanges: function(rowIndex) {
                    var changes = this.getChanges();
                    var result = false;
                    for (var i = 0; i < (null === changes || void 0 === changes ? void 0 : changes.length); i++) {
                        if (changes[i].type && (!(0, _type.isDefined)(rowIndex) || this._dataController.getRowIndexByKey(changes[i].key) === rowIndex)) {
                            result = true;
                            break
                        }
                    }
                    return result
                },
                dispose: function() {
                    this.callBase();
                    clearTimeout(this._inputFocusTimeoutID);
                    _events_engine.default.off(_dom_adapter.default.getDocument(), _pointer.default.up, this._pointerUpEditorHandler);
                    _events_engine.default.off(_dom_adapter.default.getDocument(), _pointer.default.down, this._pointerDownEditorHandler);
                    _events_engine.default.off(_dom_adapter.default.getDocument(), _click.name, this._saveEditorHandler)
                },
                optionChanged: function(args) {
                    if ("editing" === args.name) {
                        var fullName = args.fullName;
                        var editPopup = this._editPopup;
                        if (fullName && 0 === fullName.indexOf(EDITING_POPUP_OPTION_NAME)) {
                            if (editPopup) {
                                var popupOptionName = fullName.slice(EDITING_POPUP_OPTION_NAME.length + 1);
                                if (popupOptionName) {
                                    editPopup.option(popupOptionName, args.value)
                                } else {
                                    editPopup.option(args.value)
                                }
                            }
                        } else {
                            if (editPopup && editPopup.option("visible") && 0 === fullName.indexOf("editing.form")) {
                                this._repaintEditPopup()
                            } else {
                                if (fullName === EDITING_EDITROWKEY_OPTION_NAME) {
                                    this._handleEditRowKeyChange(args)
                                } else {
                                    if (fullName === EDITING_EDITCOLUMNNAME_OPTION_NAME) {
                                        this._handleEditColumnNameChange(args)
                                    } else {
                                        if (fullName === EDITING_CHANGES_OPTION_NAME) {
                                            this._handleChangesChange(args)
                                        } else {
                                            this.init();
                                            this.resetChanges();
                                            this._resetEditColumnName();
                                            this._resetEditRowKey()
                                        }
                                    }
                                }
                            }
                        }
                        args.handled = true
                    } else {
                        this.callBase(args)
                    }
                },
                _handleEditRowKeyChange: function(args) {
                    var rowIndex = this._dataController.getRowIndexByKey(args.value);
                    var oldRowIndexCorrection = this._getEditRowIndexCorrection();
                    var oldRowIndex = this._dataController.getRowIndexByKey(args.previousValue) + oldRowIndexCorrection;
                    var columnIndex = this._getVisibleEditColumnIndex();
                    if (!this.isCellOrBatchEditMode()) {
                        if ((0, _type.isDefined)(args.value)) {
                            if (args.value !== args.previousValue) {
                                this._editRowFromOptionChanged(rowIndex, oldRowIndex)
                            }
                        } else {
                            this.cancelEditData()
                        }
                    } else {
                        if ((0, _type.isDefined)(args.value) && args.value !== args.previousValue) {
                            this._editCellFromOptionChanged(columnIndex, columnIndex, oldRowIndex)
                        }
                    }
                },
                _handleEditColumnNameChange: function(args) {
                    var oldRowIndex = this._getVisibleEditRowIndex(args.previousValue);
                    if (this.isCellOrBatchEditMode() && oldRowIndex !== -1 && (0, _type.isDefined)(args.value) && args.value !== args.previousValue) {
                        var columnIndex = this._columnsController.getVisibleColumnIndex(args.value);
                        var oldColumnIndex = this._columnsController.getVisibleColumnIndex(args.previousValue);
                        this._editCellFromOptionChanged(columnIndex, oldColumnIndex, oldRowIndex)
                    }
                },
                _handleChangesChange: function(args) {
                    var dataController = this._dataController;
                    if (!args.value.length && !args.previousValue.length) {
                        return
                    }
                    dataController.updateItems({
                        repaintChangesOnly: true
                    })
                },
                _editCellFromOptionChanged: function(columnIndex, oldColumnIndex, oldRowIndex) {
                    var _this6 = this;
                    var columns = this._columnsController.getVisibleColumns();
                    if (columnIndex > -1) {
                        (0, _common.deferRender)(function() {
                            _this6._repaintEditCell(columns[columnIndex], columns[oldColumnIndex], oldRowIndex)
                        })
                    }
                },
                publicMethods: function() {
                    return ["addRow", "deleteRow", "undeleteRow", "editRow", "editCell", "closeEditCell", "saveEditData", "cancelEditData", "hasEditData"]
                },
                refresh: function(isPageChanged) {
                    var editMode = _getEditMode(this);
                    var needResetIndexes = editMode === EDIT_MODE_BATCH || isPageChanged && "virtual" !== this.option("scrolling.mode");
                    if (!(0, _type.isDefined)(this._pageIndex)) {
                        return
                    }
                    if (!this.isCellOrBatchEditMode()) {
                        this.resetChanges();
                        this.init();
                        if ((0, _type.isDefined)(this.option(EDITING_EDITROWKEY_OPTION_NAME))) {
                            this._resetEditRowKey()
                        }
                    } else {
                        if (needResetIndexes) {
                            this._resetEditColumnName();
                            this._resetEditRowKey()
                        }
                    }
                },
                isEditing: function() {
                    var isEditRowKeyDefined = (0, _type.isDefined)(this.option(EDITING_EDITROWKEY_OPTION_NAME));
                    var isEditColumnNameDefined = (0, _type.isDefined)(this.option(EDITING_EDITCOLUMNNAME_OPTION_NAME));
                    if (this.isCellOrBatchEditMode()) {
                        return isEditRowKeyDefined && isEditColumnNameDefined
                    }
                    return isEditRowKeyDefined
                },
                isEditRow: function(rowIndex) {
                    var editMode = _getEditMode(this);
                    return this._getVisibleEditRowIndex() === rowIndex && ROW_BASED_MODES.indexOf(editMode) !== -1
                },
                _setEditRowKey: function(value, silent) {
                    if (silent) {
                        this._silentOption(EDITING_EDITROWKEY_OPTION_NAME, value)
                    } else {
                        this.option(EDITING_EDITROWKEY_OPTION_NAME, value)
                    }
                },
                _setEditRowKeyByIndex: function(rowIndex, silent) {
                    var key = this._dataController.getKeyByRowIndex(rowIndex);
                    if (void 0 === key) {
                        this._dataController.fireError("E1043");
                        return
                    }
                    this._setEditRowKey(key, silent)
                },
                getEditRowIndex: function() {
                    return this._getVisibleEditRowIndex()
                },
                getEditFormRowIndex: function() {
                    var editMode = _getEditMode(this);
                    return editMode === EDIT_MODE_FORM || editMode === EDIT_MODE_POPUP ? this._getVisibleEditRowIndex() : -1
                },
                isEditCell: function(visibleRowIndex, columnIndex) {
                    return this._getVisibleEditRowIndex() === visibleRowIndex && this._getVisibleEditColumnIndex() === columnIndex
                },
                getPopupContent: function() {
                    var editMode = _getEditMode(this);
                    var popupVisible = this._editPopup && this._editPopup.option("visible");
                    if (editMode === EDIT_MODE_POPUP && popupVisible) {
                        return this._$popupContent
                    }
                },
                getEditForm: function() {
                    return this._editForm
                },
                _needInsertItem: function(change, changeType) {
                    var that = this;
                    var dataSource = that._dataController.dataSource();
                    var scrollingMode = that.option("scrolling.mode");
                    var pageIndex = dataSource.pageIndex();
                    var beginPageIndex = dataSource.beginPageIndex ? dataSource.beginPageIndex() : pageIndex;
                    var endPageIndex = dataSource.endPageIndex ? dataSource.endPageIndex() : pageIndex;
                    if ("standard" !== scrollingMode) {
                        switch (changeType) {
                            case "append":
                                return change.key.pageIndex === endPageIndex;
                            case "prepend":
                                return change.key.pageIndex === beginPageIndex;
                            case "refresh":
                                change.key.rowIndex = 0;
                                change.key.dataRowIndex = 0;
                                change.key.pageIndex = 0;
                                break;
                            default:
                                return change.key.pageIndex >= beginPageIndex && change.key.pageIndex <= endPageIndex
                        }
                    }
                    return change.key.pageIndex === pageIndex
                },
                _generateNewItem: function(key) {
                    var item = {
                        key: key
                    };
                    if (key && key[INSERT_INDEX]) {
                        item[INSERT_INDEX] = key[INSERT_INDEX]
                    }
                    return item
                },
                _getLoadedRowIndexByInsertKey: function(items, change, key) {
                    var dataController = this._dataController;
                    var loadedRowIndexOffset = dataController.getRowIndexOffset(true);
                    var loadedRowIndex = key.dataRowIndex - loadedRowIndexOffset;
                    if ("append" === change.changeType) {
                        loadedRowIndex -= dataController.items(true).length;
                        if (change.removeCount) {
                            loadedRowIndex += change.removeCount
                        }
                    }
                    for (var i = 0; i < loadedRowIndex; i++) {
                        if (items[i] && items[i][INSERT_INDEX]) {
                            loadedRowIndex++
                        }
                    }
                    return loadedRowIndex
                },
                processItems: function(items, e) {
                    var _this7 = this;
                    var changeType = e.changeType;
                    this.update(changeType);
                    var changes = this.getChanges();
                    changes.forEach(function(change) {
                        var key = change.key;
                        if ((0, _type.isDefined)(key) && change.type === DATA_EDIT_DATA_INSERT_TYPE) {
                            var loadedRowIndex = _this7._getLoadedRowIndexByInsertKey(items, e, key);
                            var item = _this7._generateNewItem(key);
                            if (loadedRowIndex >= 0 && _this7._needInsertItem(change, changeType, items, item)) {
                                items.splice(key.dataRowIndex ? loadedRowIndex : 0, 0, item)
                            }
                        }
                    });
                    return items
                },
                processDataItem: function(item, options, generateDataValues) {
                    var columns = options.visibleColumns;
                    var key = item.data[INSERT_INDEX] ? item.data.key : item.key;
                    var changes = this.getChanges();
                    var editIndex = _uiGrid_core2.default.getIndexByKey(key, changes);
                    item.isEditing = false;
                    if (editIndex >= 0) {
                        var editMode = _getEditMode(this);
                        var _changes$editIndex = changes[editIndex],
                            data = _changes$editIndex.data,
                            type = _changes$editIndex.type;
                        switch (type) {
                            case DATA_EDIT_DATA_INSERT_TYPE:
                                if (editMode === EDIT_MODE_POPUP) {
                                    item.visible = false
                                }
                                item.isNewRow = true;
                                item.key = key;
                                item.data = data;
                                break;
                            case DATA_EDIT_DATA_UPDATE_TYPE:
                                item.modified = true;
                                item.oldData = item.data;
                                item.data = (0, _array_utils.createObjectWithChanges)(item.data, data);
                                item.modifiedValues = generateDataValues(data, columns, true);
                                break;
                            case DATA_EDIT_DATA_REMOVE_TYPE:
                                if (editMode === EDIT_MODE_BATCH) {
                                    item.data = (0, _array_utils.createObjectWithChanges)(item.data, data)
                                }
                                item.removed = true
                        }
                    }
                },
                _initNewRow: function(options) {
                    var _this8 = this;
                    this.executeAction("onInitNewRow", options);
                    if (options.promise) {
                        var deferred = new _deferred.Deferred;
                        (0, _deferred.when)((0, _deferred.fromPromise)(options.promise)).done(deferred.resolve).fail(createFailureHandler(deferred)).fail(function(arg) {
                            return _this8._fireDataErrorOccurred(arg)
                        });
                        return deferred
                    }
                },
                _getInsertKey: function(parentKey) {
                    var that = this;
                    var dataController = that._dataController;
                    var rows = dataController.items();
                    var editMode = _getEditMode(that);
                    var insertKey = {
                        parentKey: parentKey,
                        pageIndex: dataController.pageIndex(),
                        rowIndex: that._getInsertRowIndex(parentKey)
                    };
                    var row = rows[insertKey.rowIndex];
                    if (row && (!row.isEditing && "detail" === row.rowType || "detailAdaptive" === row.rowType)) {
                        insertKey.rowIndex++
                    }
                    insertKey.dataRowIndex = dataController.getRowIndexOffset() + rows.filter(function(row, index) {
                        return index < insertKey.rowIndex && ("data" === row.rowType && !row.isNewRow || "group" === row.rowType)
                    }).length;
                    if (editMode !== EDIT_MODE_BATCH) {
                        this._setEditRowKey(insertKey, true)
                    }
                    insertKey[INSERT_INDEX] = that._getInsertIndex();
                    return insertKey
                },
                _getInsertRowIndex: function(parentKey) {
                    var that = this;
                    var rowsView = that.getView("rowsView");
                    var parentRowIndex = that._dataController.getRowIndexByKey(parentKey);
                    if (parentRowIndex >= 0) {
                        return parentRowIndex + 1
                    }
                    if (rowsView) {
                        return rowsView.getTopVisibleItemIndex(true)
                    }
                    return 0
                },
                _getInsertIndex: function() {
                    var maxInsertIndex = 0;
                    this.getChanges().forEach(function(editItem) {
                        if (editItem.type === DATA_EDIT_DATA_INSERT_TYPE && editItem.key[INSERT_INDEX] > maxInsertIndex) {
                            maxInsertIndex = editItem.key[INSERT_INDEX]
                        }
                    });
                    return maxInsertIndex + 1
                },
                addRow: function(parentKey) {
                    var that = this;
                    var dataController = that._dataController;
                    var store = dataController.store();
                    var key = store && store.key();
                    var param = {
                        data: {}
                    };
                    var editMode = _getEditMode(that);
                    var oldEditRowIndex = that._getVisibleEditRowIndex();
                    var deferred = new _deferred.Deferred;
                    if (!store) {
                        dataController.fireError("E1052", this.component.NAME);
                        return deferred.reject()
                    }
                    if (editMode === EDIT_MODE_CELL && that.hasChanges()) {
                        that.saveEditData().done(function() {
                            if (!that.hasChanges()) {
                                that.addRow(parentKey).done(deferred.resolve).fail(deferred.reject)
                            } else {
                                deferred.reject("cancel")
                            }
                        });
                        return deferred.promise()
                    }
                    that.refresh();
                    if (!that._allowRowAdding()) {
                        return deferred.reject("cancel")
                    }
                    if (!key) {
                        param.data.__KEY__ = String(new _guid.default)
                    }(0, _deferred.when)(that._initNewRow(param, parentKey)).done(function() {
                        if (that._allowRowAdding()) {
                            that._addRowCore(param.data, parentKey, oldEditRowIndex);
                            deferred.resolve()
                        } else {
                            deferred.reject("cancel")
                        }
                    }).fail(deferred.reject);
                    return deferred.promise()
                },
                _allowRowAdding: function() {
                    var that = this;
                    var editMode = _getEditMode(that);
                    var insertIndex = that._getInsertIndex();
                    if (editMode !== EDIT_MODE_BATCH && insertIndex > 1) {
                        return false
                    }
                    return true
                },
                _addRowCore: function(data, parentKey, initialOldEditRowIndex) {
                    var that = this;
                    var oldEditRowIndex = that._getVisibleEditRowIndex();
                    var insertKey = that._getInsertKey(parentKey);
                    var editMode = _getEditMode(that);
                    that._addChange({
                        key: insertKey,
                        data: data,
                        type: DATA_EDIT_DATA_INSERT_TYPE
                    });
                    that._dataController.updateItems({
                        changeType: "update",
                        rowIndices: [initialOldEditRowIndex, oldEditRowIndex, insertKey.rowIndex]
                    });
                    if (editMode === EDIT_MODE_POPUP) {
                        that._showEditPopup(insertKey.rowIndex)
                    } else {
                        that._focusFirstEditableCellInRow(insertKey.rowIndex)
                    }
                    that._afterInsertRow({
                        key: insertKey,
                        data: data
                    })
                },
                _focusFirstEditableCellInRow: function(rowIndex) {
                    var that = this;
                    var $firstCell = that.getFirstEditableCellInRow(rowIndex);
                    that._editCellInProgress = true;
                    that._delayedInputFocus($firstCell, function() {
                        that._editCellInProgress = false;
                        var $cell = that.getFirstEditableCellInRow(rowIndex);
                        var eventToTrigger = "dblClick" === that.option("editing.startEditAction") ? _double_click.name : _click.name;
                        $cell && _events_engine.default.trigger($cell, eventToTrigger)
                    })
                },
                _isEditingStart: function(options) {
                    this.executeAction("onEditingStart", options);
                    return options.cancel
                },
                _beforeEditCell: function(rowIndex, columnIndex, item) {
                    var that = this;
                    if (_getEditMode(that) === EDIT_MODE_CELL && !item.isNewRow && that.hasChanges()) {
                        var d = new _deferred.Deferred;
                        that.saveEditData().always(function() {
                            d.resolve(that.hasChanges())
                        });
                        return d
                    }
                },
                _beforeUpdateItems: function() {},
                _getVisibleEditColumnIndex: function() {
                    var editColumnName = this.option(EDITING_EDITCOLUMNNAME_OPTION_NAME);
                    if (!(0, _type.isDefined)(editColumnName)) {
                        return -1
                    }
                    return this._columnsController.getVisibleColumnIndex(editColumnName)
                },
                _setEditColumnNameByIndex: function(index, silent) {
                    var _visibleColumns$index;
                    var visibleColumns = this._columnsController.getVisibleColumns();
                    this._setEditColumnName(null === (_visibleColumns$index = visibleColumns[index]) || void 0 === _visibleColumns$index ? void 0 : _visibleColumns$index.name, silent)
                },
                _setEditColumnName: function(name, silent) {
                    if (silent) {
                        this._silentOption(EDITING_EDITCOLUMNNAME_OPTION_NAME, name)
                    } else {
                        this.option(EDITING_EDITCOLUMNNAME_OPTION_NAME, name)
                    }
                },
                _resetEditColumnName: function() {
                    this._setEditColumnName(null, true)
                },
                _getEditColumn: function() {
                    var editColumnName = this.option(EDITING_EDITCOLUMNNAME_OPTION_NAME);
                    return this._getColumnByName(editColumnName)
                },
                _getColumnByName: function(name) {
                    var visibleColumns = this._columnsController.getVisibleColumns();
                    var editColumn;
                    (0, _type.isDefined)(name) && visibleColumns.some(function(column) {
                        if (column.name === name) {
                            editColumn = column;
                            return true
                        }
                    });
                    return editColumn
                },
                _getVisibleEditRowIndex: function(columnName) {
                    var dataController = this._dataController;
                    var editRowKey = this.option(EDITING_EDITROWKEY_OPTION_NAME);
                    var rowIndex = dataController.getRowIndexByKey(editRowKey);
                    if (rowIndex === -1) {
                        return rowIndex
                    }
                    return rowIndex + this._getEditRowIndexCorrection(columnName)
                },
                _getEditRowIndexCorrection: function(columnName) {
                    var editColumn = columnName ? this._getColumnByName(columnName) : this._getEditColumn();
                    var isColumnHidden = "adaptiveHidden" === (null === editColumn || void 0 === editColumn ? void 0 : editColumn.visibleWidth);
                    return isColumnHidden ? 1 : 0
                },
                _resetEditRowKey: function() {
                    this._setEditRowKey(null, true)
                },
                _resetEditIndices: function() {
                    this._resetEditColumnName();
                    this._resetEditRowKey()
                },
                editRow: function(rowIndex) {
                    var dataController = this._dataController;
                    var items = dataController.items();
                    var item = items[rowIndex];
                    var params = {
                        data: item && item.data,
                        cancel: false
                    };
                    var oldRowIndex = this._getVisibleEditRowIndex();
                    if (!item) {
                        return
                    }
                    if (rowIndex === oldRowIndex) {
                        return true
                    }
                    if (void 0 === item.key) {
                        this._dataController.fireError("E1043");
                        return
                    }
                    if (!item.isNewRow) {
                        params.key = item.key
                    }
                    if (this._isEditingStart(params)) {
                        return
                    }
                    this.resetChanges();
                    this.init();
                    this._resetEditColumnName();
                    this._pageIndex = dataController.pageIndex();
                    this._addInternalData({
                        key: item.key,
                        oldData: item.data
                    });
                    this._setEditRowKey(item.key)
                },
                _editRowFromOptionChanged: function(rowIndex, oldRowIndex) {
                    var rowIndices = [oldRowIndex, rowIndex];
                    var editMode = _getEditMode(this);
                    this._beforeUpdateItems(rowIndices, rowIndex, oldRowIndex);
                    if (editMode === EDIT_MODE_POPUP) {
                        this._showEditPopup(rowIndex)
                    } else {
                        this._needFocusEditor = true;
                        this._dataController.updateItems({
                            changeType: "update",
                            rowIndices: rowIndices
                        })
                    }
                },
                _focusEditorIfNeed: function() {
                    var _this9 = this;
                    var editMode = _getEditMode(this);
                    if (this._needFocusEditor) {
                        if (MODES_WITH_DELAYED_FOCUS.indexOf(editMode) !== -1) {
                            var $editingCell = this.getFocusedCellInRow(this._getVisibleEditRowIndex());
                            this._delayedInputFocus($editingCell, function() {
                                $editingCell && _this9.component.focus($editingCell)
                            })
                        } else {
                            if (CELL_BASED_MODES.indexOf(editMode) !== -1) {
                                var _this$_rowsView;
                                var editColumnIndex = this._getVisibleEditColumnIndex();
                                var $cell = null === (_this$_rowsView = this._rowsView) || void 0 === _this$_rowsView ? void 0 : _this$_rowsView._getCellElement(this._getVisibleEditRowIndex(), editColumnIndex);
                                if ($cell && !$cell.find(":focus").length) {
                                    this._focusEditingCell(function() {
                                        _this9._editCellInProgress = false
                                    }, $cell, true)
                                } else {
                                    this._editCellInProgress = false
                                }
                            }
                        }
                        this._needFocusEditor = false
                    }
                },
                _showEditPopup: function(rowIndex, repaintForm) {
                    var that = this;
                    var isMobileDevice = "desktop" !== _devices.default.current().deviceType;
                    var popupOptions = (0, _extend.extend)({
                        showTitle: false,
                        fullScreen: isMobileDevice,
                        toolbarItems: [{
                            toolbar: "bottom",
                            location: "after",
                            widget: "dxButton",
                            options: that._getSaveButtonConfig()
                        }, {
                            toolbar: "bottom",
                            location: "after",
                            widget: "dxButton",
                            options: that._getCancelButtonConfig()
                        }],
                        contentTemplate: that._getPopupEditFormTemplate(rowIndex)
                    }, that.option(EDITING_POPUP_OPTION_NAME));
                    if (!that._editPopup) {
                        var $popupContainer = (0, _renderer.default)("<div>").appendTo(that.component.$element()).addClass(that.addWidgetPrefix(EDIT_POPUP_CLASS));
                        that._editPopup = that._createComponent($popupContainer, _popup.default, {});
                        that._editPopup.on("hiding", that._getEditPopupHiddenHandler());
                        that._editPopup.on("shown", function(e) {
                            _events_engine.default.trigger(e.component.$content().find(FOCUSABLE_ELEMENT_SELECTOR).not("." + SCROLLABLE_CONTAINER_CLASS).first(), "focus");
                            if (repaintForm) {
                                that._editForm && that._editForm.repaint()
                            }
                        })
                    }
                    that._editPopup.option(popupOptions);
                    that._editPopup.show()
                },
                _repaintEditPopup: function() {
                    var rowIndex = this._getVisibleEditRowIndex();
                    if (this._editPopup && this._editPopup.option("visible") && rowIndex >= 0) {
                        var defaultAnimation = this._editPopup.option("animation");
                        this._editPopup.option("animation", null);
                        this._showEditPopup(rowIndex, true);
                        this._editPopup.option("animation", defaultAnimation)
                    }
                },
                _getEditPopupHiddenHandler: function() {
                    var that = this;
                    return function(e) {
                        if (that.isEditing()) {
                            that.cancelEditData()
                        }
                    }
                },
                _getPopupEditFormTemplate: function(rowIndex) {
                    var that = this;
                    var row = that.component.getVisibleRows()[rowIndex];
                    var templateOptions = {
                        row: row,
                        rowType: row.rowType,
                        key: row.key
                    };
                    return function(container) {
                        var formTemplate = that.getEditFormTemplate();
                        var scrollable = that._createComponent((0, _renderer.default)("<div>").appendTo(container), _ui.default);
                        that._$popupContent = scrollable.$content();
                        formTemplate(that._$popupContent, templateOptions, true)
                    }
                },
                _getSaveButtonConfig: function() {
                    return {
                        text: this.option("editing.texts.saveRowChanges"),
                        onClick: this.saveEditData.bind(this)
                    }
                },
                _getCancelButtonConfig: function() {
                    return {
                        text: this.option("editing.texts.cancelRowChanges"),
                        onClick: this.cancelEditData.bind(this)
                    }
                },
                _removeInternalData: function(key) {
                    var internalData = this._getInternalData(key);
                    var index = this._internalState.indexOf(internalData);
                    if (index > -1) {
                        this._internalState.splice(index, 1)
                    }
                },
                _removeChange: function(index) {
                    if (index >= 0) {
                        var changes = _toConsumableArray(this.getChanges());
                        var key = changes[index].key;
                        this._removeInternalData(key);
                        changes.splice(index, 1);
                        this._silentOption(EDITING_CHANGES_OPTION_NAME, changes);
                        if ((0, _common.equalByValue)(this.option(EDITING_EDITROWKEY_OPTION_NAME), key)) {
                            this._resetEditIndices()
                        }
                    }
                },
                executeOperation: function(deferred, func) {
                    var _this10 = this;
                    this._lastOperation && this._lastOperation.reject();
                    this._lastOperation = deferred;
                    this.waitForDeferredOperations().done(function() {
                        if ("rejected" === deferred.state()) {
                            return
                        }
                        func();
                        _this10._lastOperation = null
                    }).fail(function() {
                        deferred.reject();
                        _this10._lastOperation = null
                    })
                },
                waitForDeferredOperations: function() {
                    return _deferred.when.apply(void 0, _toConsumableArray(this._deferreds))
                },
                editCell: function(rowIndex, columnIndex) {
                    return this._editCell({
                        rowIndex: rowIndex,
                        columnIndex: columnIndex
                    })
                },
                _editCell: function(options) {
                    var _this11 = this;
                    var d = new _deferred.Deferred;
                    var coreResult;
                    this.executeOperation(d, function() {
                        coreResult = _this11._editCellCore(options);
                        (0, _deferred.when)(coreResult).done(d.resolve).fail(d.reject)
                    });
                    return void 0 !== coreResult ? coreResult : d.promise()
                },
                _getNormalizedEditCellOptions: function(_ref) {
                    var oldColumnIndex = _ref.oldColumnIndex,
                        oldRowIndex = _ref.oldRowIndex,
                        columnIndex = _ref.columnIndex,
                        rowIndex = _ref.rowIndex;
                    var columnsController = this._columnsController;
                    var visibleColumns = columnsController.getVisibleColumns();
                    var items = this._dataController.items();
                    var item = items[rowIndex];
                    var oldColumn;
                    if ((0, _type.isDefined)(oldColumnIndex)) {
                        oldColumn = visibleColumns[oldColumnIndex]
                    } else {
                        oldColumn = this._getEditColumn()
                    }
                    if (!(0, _type.isDefined)(oldRowIndex)) {
                        oldRowIndex = this._getVisibleEditRowIndex()
                    }
                    if ((0, _type.isString)(columnIndex)) {
                        columnIndex = columnsController.columnOption(columnIndex, "index");
                        columnIndex = columnsController.getVisibleIndex(columnIndex)
                    }
                    var column = visibleColumns[columnIndex];
                    return {
                        oldColumn: oldColumn,
                        columnIndex: columnIndex,
                        oldRowIndex: oldRowIndex,
                        rowIndex: rowIndex,
                        column: column,
                        item: item
                    }
                },
                _editCellCore: function(options) {
                    var _this12 = this;
                    var dataController = this._dataController;
                    var isEditByOptionChanged = (0, _type.isDefined)(options.oldColumnIndex) || (0, _type.isDefined)(options.oldRowIndex);
                    var _this$_getNormalizedE = this._getNormalizedEditCellOptions(options),
                        columnIndex = _this$_getNormalizedE.columnIndex,
                        rowIndex = _this$_getNormalizedE.rowIndex,
                        column = _this$_getNormalizedE.column,
                        item = _this$_getNormalizedE.item;
                    var params = {
                        data: null === item || void 0 === item ? void 0 : item.data,
                        cancel: false,
                        column: column
                    };
                    if (void 0 === item.key) {
                        this._dataController.fireError("E1043");
                        return
                    }
                    if (column && item && ("data" === item.rowType || "detailAdaptive" === item.rowType) && !item.removed && !_isRowEditMode(this)) {
                        if (!isEditByOptionChanged && this.isEditCell(rowIndex, columnIndex)) {
                            return true
                        }
                        var editRowIndex = rowIndex + dataController.getRowIndexOffset();
                        return (0, _deferred.when)(this._beforeEditCell(rowIndex, columnIndex, item)).done(function(cancel) {
                            if (cancel) {
                                return
                            }
                            if (!_this12._prepareEditCell(params, item, columnIndex, editRowIndex)) {
                                _this12._processCanceledEditingCell()
                            }
                        })
                    }
                    return false
                },
                _processCanceledEditingCell: function() {},
                _prepareEditCell: function(params, item, editColumnIndex, editRowIndex) {
                    if (!item.isNewRow) {
                        params.key = item.key
                    }
                    if (this._isEditingStart(params)) {
                        return false
                    }
                    this._pageIndex = this._dataController.pageIndex();
                    this._setEditRowKey(item.key);
                    this._setEditColumnNameByIndex(editColumnIndex);
                    if (!params.column.showEditorAlways) {
                        this._addInternalData({
                            key: item.key,
                            oldData: item.data
                        })
                    }
                    return true
                },
                _repaintEditCell: function(column, oldColumn, oldEditRowIndex) {
                    this._needFocusEditor = true;
                    if (!column || !column.showEditorAlways || oldColumn && !oldColumn.showEditorAlways) {
                        this._editCellInProgress = true;
                        this.getController("editorFactory").loseFocus();
                        this._dataController.updateItems({
                            changeType: "update",
                            rowIndices: [oldEditRowIndex, this._getVisibleEditRowIndex()]
                        })
                    } else {
                        if (column !== oldColumn) {
                            this._dataController.updateItems({
                                changeType: "update",
                                rowIndices: []
                            })
                        }
                    }
                },
                _delayedInputFocus: function($cell, beforeFocusCallback, callBeforeFocusCallbackAlways) {
                    var that = this;

                    function inputFocus() {
                        if (beforeFocusCallback) {
                            beforeFocusCallback()
                        }
                        if ($cell) {
                            var $focusableElement = $cell.find(FOCUSABLE_ELEMENT_SELECTOR).first();
                            _uiGrid_core2.default.focusAndSelectElement(that, $focusableElement)
                        }
                        that._beforeFocusCallback = null
                    }
                    if (_devices.default.real().ios || _devices.default.real().android) {
                        inputFocus()
                    } else {
                        if (that._beforeFocusCallback) {
                            that._beforeFocusCallback()
                        }
                        clearTimeout(that._inputFocusTimeoutID);
                        if (callBeforeFocusCallbackAlways) {
                            that._beforeFocusCallback = beforeFocusCallback
                        }
                        that._inputFocusTimeoutID = setTimeout(inputFocus)
                    }
                },
                _focusEditingCell: function(beforeFocusCallback, $editCell, callBeforeFocusCallbackAlways) {
                    var that = this;
                    var rowsView = that.getView("rowsView");
                    var editColumnIndex = this._getVisibleEditColumnIndex();
                    $editCell = $editCell || rowsView && rowsView._getCellElement(that._getVisibleEditRowIndex(), editColumnIndex);
                    that._delayedInputFocus($editCell, beforeFocusCallback, callBeforeFocusCallbackAlways)
                },
                deleteRow: function(rowIndex) {
                    var _this13 = this;
                    if ("cell" === this.option("editing.mode") && this.isEditing()) {
                        var isNewRow = this._dataController.items()[rowIndex].isNewRow;
                        var rowKey = this._dataController.getKeyByRowIndex(rowIndex);
                        this.closeEditCell(null, isNewRow).always(function() {
                            rowIndex = _this13._dataController.getRowIndexByKey(rowKey);
                            _this13._checkAndDeleteRow(rowIndex)
                        })
                    } else {
                        this._checkAndDeleteRow(rowIndex)
                    }
                },
                _checkAndDeleteRow: function(rowIndex) {
                    var that = this;
                    var editingOptions = that.option("editing");
                    var editingTexts = editingOptions && editingOptions.texts;
                    var isBatchMode = editingOptions && editingOptions.mode === EDIT_MODE_BATCH;
                    var confirmDelete = editingOptions && editingOptions.confirmDelete;
                    var confirmDeleteMessage = editingTexts && editingTexts.confirmDeleteMessage;
                    var item = that._dataController.items()[rowIndex];
                    var allowDeleting = isBatchMode || !that.isEditing() || item.isNewRow;
                    if (item && allowDeleting) {
                        if (isBatchMode || !confirmDelete || !confirmDeleteMessage) {
                            that._deleteRowCore(rowIndex)
                        } else {
                            var confirmDeleteTitle = editingTexts && editingTexts.confirmDeleteTitle;
                            var showDialogTitle = (0, _type.isDefined)(confirmDeleteTitle) && confirmDeleteTitle.length > 0;
                            (0, _dialog.confirm)(confirmDeleteMessage, confirmDeleteTitle, showDialogTitle).done(function(confirmResult) {
                                if (confirmResult) {
                                    that._deleteRowCore(rowIndex)
                                }
                            })
                        }
                    }
                },
                _deleteRowCore: function(rowIndex) {
                    var dataController = this._dataController;
                    var item = dataController.items()[rowIndex];
                    var key = item && item.key;
                    var oldEditRowIndex = this._getVisibleEditRowIndex();
                    var isBatchMode = this.option("editing.mode") === EDIT_MODE_BATCH;
                    this.refresh();
                    var changes = this.getChanges();
                    var editIndex = _uiGrid_core2.default.getIndexByKey(key, changes);
                    if (editIndex >= 0) {
                        if (changes[editIndex].type === DATA_EDIT_DATA_INSERT_TYPE) {
                            this._removeChange(editIndex)
                        } else {
                            this._addChange({
                                key: key,
                                type: DATA_EDIT_DATA_REMOVE_TYPE
                            })
                        }
                    } else {
                        this._addChange({
                            key: key,
                            oldData: item.data,
                            type: DATA_EDIT_DATA_REMOVE_TYPE
                        })
                    }
                    if (isBatchMode) {
                        dataController.updateItems({
                            changeType: "update",
                            rowIndices: [oldEditRowIndex, rowIndex]
                        });
                        return (new _deferred.Deferred).resolve()
                    }
                    return this.saveEditData()
                },
                undeleteRow: function(rowIndex) {
                    var that = this;
                    var dataController = that._dataController;
                    var item = dataController.items()[rowIndex];
                    var oldEditRowIndex = that._getVisibleEditRowIndex();
                    var key = item && item.key;
                    var changes = this.getChanges();
                    if (item) {
                        var editIndex = _uiGrid_core2.default.getIndexByKey(key, changes);
                        if (editIndex >= 0) {
                            var data = changes[editIndex].data;
                            if ((0, _type.isEmptyObject)(data)) {
                                that._removeChange(editIndex)
                            } else {
                                that._addChange({
                                    key: key,
                                    type: DATA_EDIT_DATA_UPDATE_TYPE
                                })
                            }
                            dataController.updateItems({
                                changeType: "update",
                                rowIndices: [oldEditRowIndex, rowIndex]
                            })
                        }
                    }
                },
                _fireOnSaving: function() {
                    var _this14 = this;
                    var onSavingParams = {
                        cancel: false,
                        promise: null,
                        changes: _toConsumableArray(this.getChanges())
                    };
                    this.executeAction("onSaving", onSavingParams);
                    var d = new _deferred.Deferred;
                    (0, _deferred.when)((0, _deferred.fromPromise)(onSavingParams.promise)).done(function() {
                        d.resolve(onSavingParams)
                    }).fail(function(arg) {
                        createFailureHandler(d);
                        _this14._fireDataErrorOccurred(arg);
                        d.resolve({
                            cancel: true
                        })
                    });
                    return d
                },
                _executeEditingAction: function(actionName, params, func) {
                    if (this.component._disposed) {
                        return null
                    }
                    var deferred = new _deferred.Deferred;
                    this.executeAction(actionName, params);
                    (0, _deferred.when)((0, _deferred.fromPromise)(params.cancel)).done(function(cancel) {
                        if (cancel) {
                            setTimeout(function() {
                                deferred.resolve("cancel")
                            })
                        } else {
                            func(params).done(deferred.resolve).fail(createFailureHandler(deferred))
                        }
                    }).fail(createFailureHandler(deferred));
                    return deferred
                },
                _processChanges: function(deferreds, results, dataChanges, changes) {
                    var _this15 = this;
                    var store = this._dataController.store();
                    (0, _iterator.each)(changes, function(index, change) {
                        var oldData = _this15._getOldData(change.key);
                        var data = change.data,
                            type = change.type;
                        var changeCopy = _objectSpread({}, change);
                        var deferred;
                        var params;
                        if (_this15._beforeSaveEditData(change, index)) {
                            return
                        }
                        switch (type) {
                            case DATA_EDIT_DATA_REMOVE_TYPE:
                                params = {
                                    data: oldData,
                                    key: change.key,
                                    cancel: false
                                };
                                deferred = _this15._executeEditingAction("onRowRemoving", params, function() {
                                    return store.remove(change.key).done(function(key) {
                                        dataChanges.push({
                                            type: "remove",
                                            key: key
                                        })
                                    })
                                });
                                break;
                            case DATA_EDIT_DATA_INSERT_TYPE:
                                params = {
                                    data: data,
                                    cancel: false
                                };
                                deferred = _this15._executeEditingAction("onRowInserting", params, function() {
                                    return store.insert(params.data).done(function(data, key) {
                                        if ((0, _type.isDefined)(key)) {
                                            changeCopy.key = key
                                        }
                                        if (data && (0, _type.isObject)(data) && data !== params.data) {
                                            changeCopy.data = data
                                        }
                                        dataChanges.push({
                                            type: "insert",
                                            data: data,
                                            index: 0
                                        })
                                    })
                                });
                                break;
                            case DATA_EDIT_DATA_UPDATE_TYPE:
                                params = {
                                    newData: data,
                                    oldData: oldData,
                                    key: change.key,
                                    cancel: false
                                };
                                deferred = _this15._executeEditingAction("onRowUpdating", params, function() {
                                    return store.update(change.key, params.newData).done(function(data, key) {
                                        if (data && (0, _type.isObject)(data) && data !== params.newData) {
                                            changeCopy.data = data
                                        }
                                        dataChanges.push({
                                            type: "update",
                                            key: key,
                                            data: data
                                        })
                                    })
                                })
                        }
                        changes[index] = changeCopy;
                        if (deferred) {
                            var doneDeferred = new _deferred.Deferred;
                            deferred.always(function(data) {
                                results.push({
                                    key: change.key,
                                    result: data
                                })
                            }).always(doneDeferred.resolve);
                            deferreds.push(doneDeferred.promise())
                        }
                    })
                },
                _processSaveEditDataResult: function(results) {
                    var that = this;
                    var hasSavedData = false;
                    var editMode = _getEditMode(that);
                    var changes = _toConsumableArray(this.getChanges());
                    var changesLength = changes.length;
                    for (var i = 0; i < results.length; i++) {
                        var arg = results[i].result;
                        var cancel = "cancel" === arg;
                        var editIndex = _uiGrid_core2.default.getIndexByKey(results[i].key, changes);
                        var change = changes[editIndex];
                        var isError = arg && arg instanceof Error;
                        if (isError) {
                            if (change) {
                                this._addInternalData({
                                    key: change.key,
                                    error: arg
                                })
                            }
                            that._fireDataErrorOccurred(arg);
                            if (editMode !== EDIT_MODE_BATCH) {
                                if ((null === change || void 0 === change ? void 0 : change.type) === DATA_EDIT_DATA_REMOVE_TYPE) {
                                    if (editIndex >= 0) {
                                        changes.splice(editIndex, 1)
                                    }
                                }
                                break
                            }
                        } else {
                            if (!cancel || !change || editMode !== EDIT_MODE_BATCH && change.type === DATA_EDIT_DATA_REMOVE_TYPE) {
                                if (editIndex >= 0) {
                                    changes.splice(editIndex, 1)
                                }
                                hasSavedData = !cancel
                            }
                        }
                    }
                    if (changes.length < changesLength) {
                        this._silentOption(EDITING_CHANGES_OPTION_NAME, changes)
                    }
                    return hasSavedData
                },
                _fireSaveEditDataEvents: function(changes) {
                    var that = this;
                    (0, _iterator.each)(changes, function(_, _ref2) {
                        var data = _ref2.data,
                            key = _ref2.key,
                            type = _ref2.type;
                        var internalData = that._addInternalData({
                            key: key
                        });
                        var params = {
                            key: key,
                            data: data
                        };
                        if (internalData.error) {
                            params.error = internalData.error
                        }
                        switch (type) {
                            case DATA_EDIT_DATA_REMOVE_TYPE:
                                that.executeAction("onRowRemoved", (0, _extend.extend)({}, params, {
                                    data: internalData.oldData
                                }));
                                break;
                            case DATA_EDIT_DATA_INSERT_TYPE:
                                that.executeAction("onRowInserted", params);
                                break;
                            case DATA_EDIT_DATA_UPDATE_TYPE:
                                that.executeAction("onRowUpdated", params)
                        }
                    });
                    this.executeAction("onSaved", {
                        changes: changes
                    })
                },
                saveEditData: function() {
                    var _this16 = this;
                    var deferred = new _deferred.Deferred;
                    this.waitForDeferredOperations().done(function() {
                        if (_this16.isSaving()) {
                            _this16._resolveAfterSave(deferred);
                            return
                        }(0, _deferred.when)(_this16._beforeSaveEditData()).done(function(cancel) {
                            if (cancel) {
                                _this16._resolveAfterSave(deferred, {
                                    cancel: cancel
                                });
                                return
                            }
                            _this16._saving = true;
                            _this16._saveEditDataInner().always(function() {
                                _this16._saving = false
                            }).done(deferred.resolve).fail(deferred.reject)
                        }).fail(deferred.reject)
                    }).fail(deferred.reject);
                    return deferred.promise()
                },
                _resolveAfterSave: function(deferred) {
                    var _ref3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                        cancel = _ref3.cancel,
                        error = _ref3.error;
                    (0, _deferred.when)(this._afterSaveEditData(cancel)).done(function() {
                        deferred.resolve(error)
                    }).fail(deferred.reject)
                },
                _saveEditDataInner: function() {
                    var _this17 = this;
                    var results = [];
                    var deferreds = [];
                    var dataChanges = [];
                    var dataController = this._dataController;
                    var dataSource = dataController.dataSource();
                    var result = new _deferred.Deferred;
                    (0, _deferred.when)(this._fireOnSaving()).done(function(_ref4) {
                        var cancel = _ref4.cancel,
                            changes = _ref4.changes;
                        if (cancel) {
                            return result.resolve().promise()
                        }
                        _this17._processChanges(deferreds, results, dataChanges, changes);
                        if (deferreds.length) {
                            null === dataSource || void 0 === dataSource ? void 0 : dataSource.beginLoading();
                            _deferred.when.apply(void 0, deferreds).done(function() {
                                if (_this17._processSaveEditDataResult(results)) {
                                    _this17._endSaving(dataChanges, changes, result)
                                } else {
                                    null === dataSource || void 0 === dataSource ? void 0 : dataSource.endLoading();
                                    result.resolve()
                                }
                            }).fail(function(error) {
                                null === dataSource || void 0 === dataSource ? void 0 : dataSource.endLoading();
                                result.resolve(error)
                            });
                            return result.always(function() {
                                _this17._focusEditingCell()
                            }).promise()
                        }
                        _this17._cancelSaving(result)
                    }).fail(result.reject);
                    return result.promise()
                },
                _resetModifiedClassCells: function(changes) {
                    var _this18 = this;
                    var editMode = _getEditMode(this);
                    if (editMode === EDIT_MODE_BATCH) {
                        var columnsCount = this._columnsController.getVisibleColumns().length;
                        changes.forEach(function(_ref5) {
                            var key = _ref5.key;
                            var rowIndex = _this18._dataController.getRowIndexByKey(key);
                            if (rowIndex !== -1) {
                                for (var columnIndex = 0; columnIndex < columnsCount; columnIndex++) {
                                    _this18._rowsView._getCellElement(rowIndex, columnIndex).removeClass(CELL_MODIFIED)
                                }
                            }
                        })
                    }
                },
                _endSaving: function(dataChanges, changes, deferred) {
                    var _changes$;
                    var editMode = _getEditMode(this);
                    var dataSource = this._dataController.dataSource();
                    if (editMode !== EDIT_MODE_CELL) {
                        this._resetModifiedClassCells(changes);
                        this._resetEditIndices()
                    } else {
                        if ("update" !== (null === (_changes$ = changes[0]) || void 0 === _changes$ ? void 0 : _changes$.type)) {
                            this._resetEditIndices()
                        }
                    }
                    if (editMode === EDIT_MODE_POPUP && this._editPopup) {
                        this._editPopup.hide()
                    }
                    null === dataSource || void 0 === dataSource ? void 0 : dataSource.endLoading();
                    this._refreshDataAfterSave(dataChanges, changes, deferred)
                },
                _cancelSaving: function(result) {
                    var editMode = _getEditMode(this);
                    var dataController = this._dataController;
                    if (_isRowEditMode(this)) {
                        if (!this.hasChanges()) {
                            this._cancelEditDataCore()
                        }
                    } else {
                        if (this.isCellOrBatchEditMode()) {
                            if (editMode !== EDIT_MODE_CELL) {
                                this._resetEditIndices()
                            }
                            dataController.updateItems()
                        } else {
                            this._focusEditingCell()
                        }
                    }
                    this.executeAction("onSaved", {
                        changes: []
                    });
                    this._resolveAfterSave(result)
                },
                _refreshDataAfterSave: function(dataChanges, changes, deferred) {
                    var _this19 = this;
                    var dataController = this._dataController;
                    var refreshMode = this.option("editing.refreshMode");
                    var isFullRefresh = "reshape" !== refreshMode && "repaint" !== refreshMode;
                    if (!isFullRefresh) {
                        dataController.push(dataChanges)
                    }(0, _deferred.when)(dataController.refresh({
                        selection: isFullRefresh,
                        reload: isFullRefresh,
                        load: "reshape" === refreshMode,
                        changesOnly: this.option("repaintChangesOnly")
                    })).always(function() {
                        _this19._fireSaveEditDataEvents(changes)
                    }).done(function() {
                        _this19._resolveAfterSave(deferred)
                    }).fail(function(error) {
                        _this19._resolveAfterSave(deferred, {
                            error: error
                        })
                    })
                },
                isSaving: function() {
                    return this._saving
                },
                _updateEditColumn: function() {
                    var that = this;
                    var isEditColumnVisible = that._isEditColumnVisible();
                    var useIcons = that.option("editing.useIcons");
                    var cssClass = COMMAND_EDIT_CLASS + (useIcons ? " " + COMMAND_EDIT_WITH_ICONS_CLASS : "");
                    that._columnsController.addCommandColumn({
                        type: "buttons",
                        command: "edit",
                        visible: isEditColumnVisible,
                        cssClass: cssClass,
                        width: "auto",
                        alignment: "center",
                        cellTemplate: that._getEditCommandCellTemplate(),
                        fixedPosition: "right"
                    });
                    that._columnsController.columnOption("command:edit", {
                        visible: isEditColumnVisible,
                        cssClass: cssClass
                    })
                },
                _isEditColumnVisible: function() {
                    var that = this;
                    var editingOptions = that.option("editing");
                    if (editingOptions) {
                        var editMode = _getEditMode(that);
                        var isVisibleWithCurrentEditMode = false;
                        switch (editMode) {
                            case EDIT_MODE_ROW:
                                isVisibleWithCurrentEditMode = editingOptions.allowUpdating || editingOptions.allowAdding;
                                break;
                            case EDIT_MODE_FORM:
                            case EDIT_MODE_POPUP:
                                isVisibleWithCurrentEditMode = editingOptions.allowUpdating
                        }
                        return editingOptions.allowDeleting || isVisibleWithCurrentEditMode
                    }
                },
                _updateEditButtons: function() {
                    var that = this;
                    var headerPanel = that.getView("headerPanel");
                    var hasChanges = that.hasChanges();
                    if (headerPanel) {
                        headerPanel.setToolbarItemDisabled("saveButton", !hasChanges);
                        headerPanel.setToolbarItemDisabled("revertButton", !hasChanges)
                    }
                },
                _applyModified: function($element) {
                    $element && $element.addClass(CELL_MODIFIED)
                },
                _beforeCloseEditCellInBatchMode: function() {},
                cancelEditData: function() {
                    var changes = this.getChanges();
                    var params = {
                        cancel: false,
                        changes: changes
                    };
                    this.executeAction("onEditCanceling", params);
                    if (!params.cancel) {
                        this._cancelEditDataCore();
                        this.executeAction("onEditCanceled", {
                            changes: changes
                        })
                    }
                },
                _cancelEditDataCore: function() {
                    var editMode = _getEditMode(this);
                    var rowIndex = this._getVisibleEditRowIndex();
                    var dataController = this._dataController;
                    this._beforeCancelEditData();
                    this.init();
                    this.resetChanges();
                    this._resetEditColumnName();
                    this._resetEditRowKey();
                    if (ROW_BASED_MODES.indexOf(editMode) !== -1 && rowIndex >= 0) {
                        dataController.updateItems({
                            changeType: "update",
                            rowIndices: [rowIndex, rowIndex + 1]
                        })
                    } else {
                        dataController.updateItems({
                            repaintChangesOnly: this.option("repaintChangesOnly")
                        })
                    }
                    if (editMode === EDIT_MODE_POPUP) {
                        this._hideEditPopup()
                    }
                },
                _hideEditPopup: function() {
                    this._editPopup && this._editPopup.option("visible", false)
                },
                hasEditData: function() {
                    return this.hasChanges()
                },
                closeEditCell: function(isError, withoutSaveEditData) {
                    var _this20 = this;
                    var that = this;
                    var result = (0, _deferred.when)();
                    var oldEditRowIndex = that._getVisibleEditRowIndex();
                    if (!_isRowEditMode(that)) {
                        var deferred = new _deferred.Deferred;
                        result = new _deferred.Deferred;
                        this.executeOperation(deferred, function() {
                            _this20._closeEditCellCore(isError, oldEditRowIndex, withoutSaveEditData).always(result.resolve)
                        })
                    }
                    return result.promise()
                },
                _closeEditCellCore: function(isError, oldEditRowIndex, withoutSaveEditData) {
                    var _this21 = this;
                    var editMode = _getEditMode(this);
                    var dataController = this._dataController;
                    var deferred = new _deferred.Deferred;
                    var promise = deferred.promise();
                    if (editMode === EDIT_MODE_CELL && this.hasChanges()) {
                        if (!withoutSaveEditData) {
                            this.saveEditData().done(function(error) {
                                if (!_this21.hasChanges()) {
                                    _this21.closeEditCell(!!error).always(deferred.resolve);
                                    return
                                }
                                deferred.resolve()
                            });
                            return promise
                        }
                    } else {
                        if (oldEditRowIndex >= 0) {
                            var rowIndices = [oldEditRowIndex];
                            this._resetEditRowKey();
                            this._resetEditColumnName();
                            this._beforeCloseEditCellInBatchMode(rowIndices);
                            if (!isError) {
                                dataController.updateItems({
                                    changeType: "update",
                                    rowIndices: rowIndices
                                })
                            }
                        }
                    }
                    deferred.resolve();
                    return promise
                },
                update: function(changeType) {
                    var that = this;
                    var dataController = that._dataController;
                    if (dataController && that._pageIndex !== dataController.pageIndex()) {
                        if ("refresh" === changeType) {
                            that.refresh(true)
                        }
                        that._pageIndex = dataController.pageIndex()
                    }
                    that._updateEditButtons()
                },
                _getRowIndicesForCascadeUpdating: function(row, skipCurrentRow) {
                    return skipCurrentRow ? [] : [row.rowIndex]
                },
                addDeferred: function(deferred) {
                    var _this22 = this;
                    if (this._deferreds.indexOf(deferred) < 0) {
                        this._deferreds.push(deferred);
                        deferred.always(function() {
                            var index = _this22._deferreds.indexOf(deferred);
                            if (index >= 0) {
                                _this22._deferreds.splice(index, 1)
                            }
                        })
                    }
                },
                _prepareChange: function(options, value, text) {
                    var _options$row;
                    var that = this;
                    var newData = {};
                    var oldData = null === (_options$row = options.row) || void 0 === _options$row ? void 0 : _options$row.data;
                    var rowKey = options.key;
                    var $cellElement = (0, _renderer.default)(options.cellElement);
                    var editMode = _getEditMode(that);
                    var deferred = new _deferred.Deferred;
                    if (void 0 !== rowKey) {
                        if (editMode === EDIT_MODE_BATCH) {
                            that._applyModified($cellElement, options)
                        }
                        options.value = value;
                        var setCellValueResult = (0, _deferred.fromPromise)(options.column.setCellValue(newData, value, (0, _extend.extend)(true, {}, oldData), text));
                        setCellValueResult.done(function() {
                            deferred.resolve({
                                data: newData,
                                key: rowKey,
                                oldData: oldData,
                                type: DATA_EDIT_DATA_UPDATE_TYPE
                            })
                        }).fail(createFailureHandler(deferred)).fail(function(arg) {
                            return that._fireDataErrorOccurred(arg)
                        });
                        if ((0, _type.isDefined)(text) && options.column.displayValueMap) {
                            options.column.displayValueMap[value] = text
                        }
                        that._updateRowValues(options);
                        that.addDeferred(deferred)
                    }
                    return deferred
                },
                _updateRowValues: function(options) {
                    if (options.values) {
                        var dataController = this._dataController;
                        var rowIndex = dataController.getRowIndexByKey(options.key);
                        var row = dataController.getVisibleRows()[rowIndex];
                        if (row) {
                            options.values = row.values
                        }
                        options.values[options.columnIndex] = options.value
                    }
                },
                updateFieldValue: function(options, value, text, forceUpdateRow) {
                    var _this23 = this;
                    var rowKey = options.key;
                    var deferred = new _deferred.Deferred;
                    if (void 0 === rowKey) {
                        this._dataController.fireError("E1043")
                    }
                    if (options.column.setCellValue) {
                        this._prepareChange(options, value, text).done(function(params) {
                            (0, _deferred.when)(_this23._applyChange(options, params, forceUpdateRow)).always(function() {
                                deferred.resolve()
                            })
                        })
                    } else {
                        deferred.resolve()
                    }
                    return deferred.promise()
                },
                _focusPreviousEditingCellIfNeed: function(options) {
                    var that = this;
                    if (that.hasEditData() && !that.isEditCell(options.rowIndex, options.columnIndex)) {
                        that._focusEditingCell();
                        that._updateEditRow(options.row, true);
                        return true
                    }
                },
                _needUpdateRow: function(column) {
                    var visibleColumns = this._columnsController.getVisibleColumns();
                    if (!column) {
                        column = this._getEditColumn()
                    }
                    var isCustomSetCellValue = column && column.setCellValue !== column.defaultSetCellValue;
                    var isCustomCalculateCellValue = visibleColumns.some(function(visibleColumn) {
                        return visibleColumn.calculateCellValue !== visibleColumn.defaultCalculateCellValue
                    });
                    return isCustomSetCellValue || isCustomCalculateCellValue
                },
                _applyChange: function(options, params, forceUpdateRow) {
                    var that = this;
                    var editMode = _getEditMode(that);
                    var isCustomSetCellValue = options.column.setCellValue !== options.column.defaultSetCellValue;
                    var showEditorAlways = options.column.showEditorAlways;
                    var isUpdateInCellMode = editMode === EDIT_MODE_CELL && options.row && !options.row.isNewRow;
                    var focusPreviousEditingCell = showEditorAlways && !forceUpdateRow && isUpdateInCellMode && that.hasEditData() && !that.isEditCell(options.rowIndex, options.columnIndex);
                    if (focusPreviousEditingCell) {
                        that._focusEditingCell();
                        that._updateEditRow(options.row, true, isCustomSetCellValue);
                        return
                    }
                    that._addChange(params, options.row);
                    that._updateEditButtons();
                    if (showEditorAlways && !forceUpdateRow) {
                        if (isUpdateInCellMode) {
                            that._setEditRowKey(options.row.key, true);
                            that._setEditColumnNameByIndex(options.columnIndex, true);
                            return that.saveEditData()
                        } else {
                            if (editMode === EDIT_MODE_BATCH) {
                                forceUpdateRow = that._needUpdateRow(options.column)
                            }
                        }
                    }
                    var row = options.row;
                    if (row) {
                        if (forceUpdateRow || isCustomSetCellValue) {
                            that._updateEditRow(row, forceUpdateRow, isCustomSetCellValue)
                        } else {
                            if (row.update) {
                                row.update()
                            }
                        }
                    }
                },
                _updateEditRowCore: function(row, skipCurrentRow, isCustomSetCellValue) {
                    var that = this;
                    var editForm = that._editForm;
                    var editMode = _getEditMode(that);
                    if (editMode === EDIT_MODE_POPUP) {
                        if (that.option("repaintChangesOnly")) {
                            row.update && row.update(row)
                        } else {
                            if (editForm) {
                                that._updateEditFormDeferred = (new _deferred.Deferred).done(function() {
                                    return editForm.repaint()
                                });
                                if (!that._updateLockCount) {
                                    that._updateEditFormDeferred.resolve()
                                }
                            }
                        }
                    } else {
                        that._dataController.updateItems({
                            changeType: "update",
                            rowIndices: that._getRowIndicesForCascadeUpdating(row, skipCurrentRow)
                        })
                    }
                },
                _endUpdateCore: function() {
                    this._updateEditFormDeferred && this._updateEditFormDeferred.resolve()
                },
                _updateEditRow: function(row, forceUpdateRow, isCustomSetCellValue) {
                    var that = this;
                    if (forceUpdateRow || !_isRowEditMode(that)) {
                        that._updateEditRowCore(row, !forceUpdateRow, isCustomSetCellValue);
                        if (!forceUpdateRow) {
                            that._focusEditingCell()
                        }
                    } else {
                        var deferred = new _deferred.Deferred;
                        that.addDeferred(deferred);
                        setTimeout(function() {
                            var $focusedElement = (0, _renderer.default)(_dom_adapter.default.getActiveElement());
                            var columnIndex = that._rowsView.getCellIndex($focusedElement, row.rowIndex);
                            var focusedElement = $focusedElement.get(0);
                            var selectionRange = _uiGrid_core2.default.getSelectionRange(focusedElement);
                            that._updateEditRowCore(row, false, isCustomSetCellValue);
                            if (columnIndex >= 0) {
                                var $focusedItem = that._rowsView._getCellElement(row.rowIndex, columnIndex);
                                that._delayedInputFocus($focusedItem, function() {
                                    setTimeout(function() {
                                        focusedElement = _dom_adapter.default.getActiveElement();
                                        if (selectionRange.selectionStart >= 0) {
                                            _uiGrid_core2.default.setSelectionRange(focusedElement, selectionRange);
                                        }
                                    })
                                })
                            }
                            deferred.resolve()
                        })
                    }
                },
                _addChange: function(options, row) {
                    var changes = _toConsumableArray(this.getChanges());
                    var index = _uiGrid_core2.default.getIndexByKey(options.key, changes);
                    if (index < 0) {
                        index = changes.length;
                        this._addInternalData({
                            key: options.key,
                            oldData: options.oldData
                        });
                        delete options.oldData;
                        changes.push(options)
                    }
                    var change = _objectSpread({}, changes[index]);
                    if (change) {
                        if (options.data) {
                            change.data = (0, _array_utils.createObjectWithChanges)(change.data, options.data)
                        }
                        if ((!change.type || !options.data) && options.type) {
                            change.type = options.type
                        }
                        if (row) {
                            row.oldData = this._getOldData(row.key);
                            row.data = (0, _array_utils.createObjectWithChanges)(row.data, options.data)
                        }
                    }
                    changes[index] = change;
                    this._silentOption(EDITING_CHANGES_OPTION_NAME, changes);
                    return index
                },
                _getFormEditItemTemplate: function(cellOptions, column) {
                    return column.editCellTemplate || getDefaultEditorTemplate(this)
                },
                renderFormEditTemplate: function(detailCellOptions, item, form, container, isReadOnly) {
                    var that = this;
                    var $container = (0, _renderer.default)(container);
                    var column = item.column;
                    var editorType = getEditorType(item);
                    var rowData = null === detailCellOptions || void 0 === detailCellOptions ? void 0 : detailCellOptions.row.data;
                    var cellOptions = (0, _extend.extend)({}, detailCellOptions, {
                        data: rowData,
                        cellElement: null,
                        isOnForm: true,
                        item: item,
                        column: (0, _extend.extend)({}, column, {
                            editorType: editorType,
                            editorOptions: item.editorOptions
                        }),
                        id: form.getItemID(item.name || item.dataField),
                        columnIndex: column.index,
                        setValue: !isReadOnly && column.allowEditing && function(value) {
                            that.updateFieldValue(cellOptions, value)
                        }
                    });
                    cellOptions.value = column.calculateCellValue(rowData);
                    var template = that._getFormEditItemTemplate.bind(that)(cellOptions, column);
                    that._rowsView.renderTemplate($container, template, cellOptions, !!$container.closest((0, _window.getWindow)().document).length).done(function() {
                        that._rowsView._updateCell($container, cellOptions)
                    });
                    return cellOptions
                },
                getFormEditorTemplate: function(cellOptions, item) {
                    var that = this;
                    var column = this.component.columnOption(item.dataField);
                    return function(options, container) {
                        var $container = (0, _renderer.default)(container);
                        cellOptions.row.watch && cellOptions.row.watch(function() {
                            return column.selector(cellOptions.row.data)
                        }, function() {
                            var _validator;
                            var $editorElement = $container.find(".dx-widget").first();
                            var validator = $editorElement.data("dxValidator");
                            var validatorOptions = null === (_validator = validator) || void 0 === _validator ? void 0 : _validator.option();
                            $container.contents().remove();
                            cellOptions = that.renderFormEditTemplate.bind(that)(cellOptions, item, options.component, $container);
                            $editorElement = $container.find(".dx-widget").first();
                            validator = $editorElement.data("dxValidator");
                            if (validatorOptions && !validator) {
                                $editorElement.dxValidator({
                                    validationRules: validatorOptions.validationRules,
                                    validationGroup: validatorOptions.validationGroup,
                                    dataGetter: validatorOptions.dataGetter
                                })
                            }
                        });
                        cellOptions = that.renderFormEditTemplate.bind(that)(cellOptions, item, options.component, $container)
                    }
                },
                getEditFormOptions: function(detailOptions) {
                    var userCustomizeItem = this.option("editing.form.customizeItem");
                    var editFormItemClass = this.addWidgetPrefix(EDIT_FORM_ITEM_CLASS);
                    var items = this.option("editing.form.items");
                    var isCustomEditorType = {};
                    var that = this;
                    if (!items) {
                        var columns = this.getController("columns").getColumns();
                        items = [];
                        (0, _iterator.each)(columns, function(_, column) {
                            if (!column.isBand && !column.type) {
                                items.push({
                                    column: column,
                                    name: column.name,
                                    dataField: column.dataField
                                })
                            }
                        })
                    } else {
                        forEachFormItems(items, function(item) {
                            var itemId = (null === item || void 0 === item ? void 0 : item.name) || (null === item || void 0 === item ? void 0 : item.dataField);
                            if (itemId) {
                                isCustomEditorType[itemId] = !!item.editorType
                            }
                        })
                    }
                    return {
                        items: items,
                        formID: "dx-" + new _guid.default,
                        customizeItem: function(item) {
                            var column;
                            var itemId = item.name || item.dataField;
                            if (item.column || itemId) {
                                column = item.column || that._columnsController.columnOption(item.name ? "name:" + item.name : "dataField:" + item.dataField)
                            }
                            if (column) {
                                item.label = item.label || {};
                                item.label.text = item.label.text || column.caption;
                                item.template = item.template || that.getFormEditorTemplate(detailOptions, item);
                                item.column = column;
                                item.isCustomEditorType = isCustomEditorType[itemId];
                                if (column.formItem) {
                                    (0, _extend.extend)(item, column.formItem)
                                }
                                if (void 0 === item.isRequired && column.validationRules) {
                                    item.isRequired = column.validationRules.some(function(rule) {
                                        return "required" === rule.type
                                    });
                                    item.validationRules = []
                                }
                                var itemVisible = (0, _type.isDefined)(item.visible) ? item.visible : true;
                                if (!that._firstFormItem && itemVisible) {
                                    that._firstFormItem = item
                                }
                            }
                            userCustomizeItem && userCustomizeItem.call(this, item);
                            item.cssClass = (0, _type.isString)(item.cssClass) ? item.cssClass + " " + editFormItemClass : editFormItemClass
                        }
                    }
                },
                getEditFormTemplate: function() {
                    var that = this;
                    return function($container, detailOptions, renderFormOnly) {
                        var editFormOptions = that.option("editing.form");
                        var baseEditFormOptions = that.getEditFormOptions(detailOptions);
                        that._firstFormItem = void 0;
                        that._editForm = that._createComponent((0, _renderer.default)("<div>").appendTo($container), _form.default, (0, _extend.extend)({}, editFormOptions, baseEditFormOptions));
                        if (!renderFormOnly) {
                            var $buttonsContainer = (0, _renderer.default)("<div>").addClass(that.addWidgetPrefix(FORM_BUTTONS_CONTAINER_CLASS)).appendTo($container);
                            that._createComponent((0, _renderer.default)("<div>").appendTo($buttonsContainer), _button.default, that._getSaveButtonConfig());
                            that._createComponent((0, _renderer.default)("<div>").appendTo($buttonsContainer), _button.default, that._getCancelButtonConfig())
                        }
                        that._editForm.on("contentReady", function() {
                            that._editPopup && that._editPopup.repaint()
                        })
                    }
                },
                getColumnTemplate: function(options) {
                    var that = this;
                    var column = options.column;
                    var rowIndex = options.row && options.row.rowIndex;
                    var template;
                    var isRowMode = _isRowEditMode(that);
                    var isRowEditing = that.isEditRow(rowIndex);
                    var isCellEditing = that.isEditCell(rowIndex, options.columnIndex);
                    var editingStartOptions;
                    if ((column.showEditorAlways || column.setCellValue && (isRowEditing && column.allowEditing || isCellEditing)) && ("data" === options.rowType || "detailAdaptive" === options.rowType) && !column.command) {
                        var allowUpdating = that.allowUpdating(options);
                        if (((allowUpdating || isRowEditing) && column.allowEditing || isCellEditing) && (isRowMode && isRowEditing || !isRowMode)) {
                            if (column.showEditorAlways && !isRowMode) {
                                editingStartOptions = {
                                    cancel: false,
                                    key: options.row.isNewRow ? void 0 : options.row.key,
                                    data: options.row.data,
                                    column: column
                                };
                                that._isEditingStart(editingStartOptions)
                            }
                            if (!editingStartOptions || !editingStartOptions.cancel) {
                                options.setValue = function(value, text) {
                                    that.updateFieldValue(options, value, text)
                                }
                            }
                        }
                        template = column.editCellTemplate || getDefaultEditorTemplate(that)
                    } else {
                        if ("detail" === column.command && "detail" === options.rowType && isRowEditing) {
                            template = that.getEditFormTemplate(options)
                        }
                    }
                    return template
                },
                _createButton: function($container, button, options) {
                    var that = this;
                    var icon = EDIT_ICON_CLASS[button.name];
                    var useIcons = that.option("editing.useIcons");
                    var $button = (0, _renderer.default)("<a>").attr("href", "#").addClass(LINK_CLASS).addClass(button.cssClass);
                    if (button.template) {
                        that._rowsView.renderTemplate($container, button.template, options, true)
                    } else {
                        if (useIcons && icon || button.icon) {
                            icon = button.icon || icon;
                            var iconType = iconUtils.getImageSourceType(icon);
                            if ("image" === iconType || "svg" === iconType) {
                                $button = iconUtils.getImageContainer(icon).addClass(button.cssClass)
                            } else {
                                $button.addClass("dx-icon" + ("dxIcon" === iconType ? "-" : " ") + icon).attr("title", button.text)
                            }
                            $button.addClass("dx-link-icon");
                            $container.addClass(COMMAND_EDIT_WITH_ICONS_CLASS);
                            var localizationName = this.getButtonLocalizationNames()[button.name];
                            localizationName && $button.attr("aria-label", _message.default.format(localizationName))
                        } else {
                            $button.text(button.text)
                        }
                        if ((0, _type.isDefined)(button.hint)) {
                            $button.attr("title", button.hint)
                        }
                        _events_engine.default.on($button, (0, _index.addNamespace)("click", EDITING_NAMESPACE), that.createAction(function(e) {
                            button.onClick.call(button, (0, _extend.extend)({}, e, {
                                row: options.row,
                                column: options.column
                            }));
                            e.event.preventDefault();
                            e.event.stopPropagation()
                        }));
                        $container.append($button, "&nbsp;")
                    }
                },
                getButtonLocalizationNames: function() {
                    return {
                        edit: "dxDataGrid-editingEditRow",
                        save: "dxDataGrid-editingSaveRowChanges",
                        "delete": "dxDataGrid-editingDeleteRow",
                        undelete: "dxDataGrid-editingUndeleteRow",
                        cancel: "dxDataGrid-editingCancelRowChanges"
                    }
                },
                prepareEditButtons: function(headerPanel) {
                    var that = this;
                    var editingOptions = that.option("editing") || {};
                    var editingTexts = that.option("editing.texts") || {};
                    var titleButtonTextByClassNames = {
                        revert: editingTexts.cancelAllChanges,
                        save: editingTexts.saveAllChanges,
                        addRow: editingTexts.addRow
                    };
                    var classNameButtonByNames = {
                        revert: "cancel",
                        save: "save",
                        addRow: "addrow"
                    };
                    var buttonItems = [];
                    var prepareButtonItem = function(name, methodName, sortIndex) {
                        var className = classNameButtonByNames[name];
                        var onInitialized = function(e) {
                            (0, _renderer.default)(e.element).addClass(headerPanel._getToolbarButtonClass(EDIT_BUTTON_CLASS + " " + that.addWidgetPrefix(className) + "-button"))
                        };
                        var hintText = titleButtonTextByClassNames[name];
                        var isButtonDisabled = ("save" === className || "cancel" === className) && !that.hasChanges();
                        return {
                            widget: "dxButton",
                            options: {
                                onInitialized: onInitialized,
                                icon: "edit-button-" + className,
                                disabled: isButtonDisabled,
                                onClick: function() {
                                    setTimeout(function() {
                                        that[methodName]()
                                    })
                                },
                                text: hintText,
                                hint: hintText
                            },
                            showText: "inMenu",
                            name: name + "Button",
                            location: "after",
                            locateInMenu: "auto",
                            sortIndex: sortIndex
                        }
                    };
                    if (editingOptions.allowAdding) {
                        buttonItems.push(prepareButtonItem("addRow", "addRow", 20))
                    }
                    if ((editingOptions.allowUpdating || editingOptions.allowAdding || editingOptions.allowDeleting) && _getEditMode(that) === EDIT_MODE_BATCH) {
                        buttonItems.push(prepareButtonItem("save", "saveEditData", 21));
                        buttonItems.push(prepareButtonItem("revert", "cancelEditData", 22))
                    }
                    return buttonItems
                },
                highlightDataCell: function($cell, parameters) {
                    var cellModified = this.isCellModified(parameters);
                    cellModified && parameters.column.setCellValue && $cell.addClass(CELL_MODIFIED)
                },
                _afterInsertRow: function() {},
                _beforeSaveEditData: function(change) {
                    if (change && !(0, _type.isDefined)(change.key) && (0, _type.isDefined)(change.type)) {
                        return true
                    }
                },
                _afterSaveEditData: function() {},
                _beforeCancelEditData: function() {},
                _allowEditAction: function(actionName, options) {
                    var allowEditAction = this.option("editing." + actionName);
                    if ((0, _type.isFunction)(allowEditAction)) {
                        allowEditAction = allowEditAction({
                            component: this.component,
                            row: options.row
                        })
                    }
                    return allowEditAction
                },
                allowUpdating: function(options, eventName) {
                    var startEditAction = this.option("editing.startEditAction") || DEFAULT_START_EDIT_ACTION;
                    var needCallback = arguments.length > 1 ? startEditAction === eventName || "down" === eventName : true;
                    return needCallback && this._allowEditAction("allowUpdating", options)
                },
                allowDeleting: function(options) {
                    return this._allowEditAction("allowDeleting", options)
                },
                isCellModified: function(parameters) {
                    var columnIndex = parameters.columnIndex;
                    var modifiedValues = parameters.row && (parameters.row.isNewRow ? parameters.row.values : parameters.row.modifiedValues);
                    return !!modifiedValues && void 0 !== modifiedValues[columnIndex]
                }
            }
        }());
        var _default = {
            defaultOptions: function() {
                return {
                    editing: {
                        mode: "row",
                        refreshMode: "full",
                        allowAdding: false,
                        allowUpdating: false,
                        allowDeleting: false,
                        useIcons: false,
                        selectTextOnEditStart: false,
                        confirmDelete: true,
                        texts: {
                            editRow: _message.default.format("dxDataGrid-editingEditRow"),
                            saveAllChanges: _message.default.format("dxDataGrid-editingSaveAllChanges"),
                            saveRowChanges: _message.default.format("dxDataGrid-editingSaveRowChanges"),
                            cancelAllChanges: _message.default.format("dxDataGrid-editingCancelAllChanges"),
                            cancelRowChanges: _message.default.format("dxDataGrid-editingCancelRowChanges"),
                            addRow: _message.default.format("dxDataGrid-editingAddRow"),
                            deleteRow: _message.default.format("dxDataGrid-editingDeleteRow"),
                            undeleteRow: _message.default.format("dxDataGrid-editingUndeleteRow"),
                            confirmDeleteMessage: _message.default.format("dxDataGrid-editingConfirmDeleteMessage"),
                            confirmDeleteTitle: ""
                        },
                        form: {
                            colCount: 2
                        },
                        popup: {},
                        startEditAction: "click",
                        editRowKey: null,
                        editColumnName: null,
                        changes: []
                    }
                }
            },
            controllers: {
                editing: EditingController
            },
            extenders: {
                controllers: {
                    data: {
                        init: function() {
                            this._editingController = this.getController("editing");
                            this.callBase()
                        },
                        reload: function(full, repaintChangesOnly) {
                            !repaintChangesOnly && this._editingController.refresh();
                            return this.callBase.apply(this, arguments)
                        },
                        repaintRows: function() {
                            if (this.getController("editing").isSaving()) {
                                return
                            }
                            return this.callBase.apply(this, arguments)
                        },
                        _updateEditRow: function(items) {
                            var editingController = this._editingController;
                            var editRowKey = this.option(EDITING_EDITROWKEY_OPTION_NAME);
                            var editRowIndex = _uiGrid_core2.default.getIndexByKey(editRowKey, items);
                            var editItem = items[editRowIndex];
                            if (editItem) {
                                editItem.isEditing = true;
                                if (editingController.getEditMode() === EDIT_MODE_FORM) {
                                    editItem.rowType = "detail"
                                }
                            }
                        },
                        _updateItemsCore: function(change) {
                            this.callBase(change);
                            this._updateEditRow(this.items())
                        },
                        _applyChangeUpdate: function(change) {
                            this._updateEditRow(change.items);
                            this.callBase(change)
                        },
                        _applyChangesOnly: function(change) {
                            this._updateEditRow(change.items);
                            this.callBase(change)
                        },
                        _processItems: function(items, change) {
                            items = this._editingController.processItems(items, change);
                            return this.callBase(items, change)
                        },
                        _processDataItem: function(dataItem, options) {
                            this._editingController.processDataItem(dataItem, options, this.generateDataValues);
                            return this.callBase(dataItem, options)
                        },
                        _processItem: function(item, options) {
                            item = this.callBase(item, options);
                            if (item.isNewRow) {
                                options.dataIndex--;
                                delete item.dataIndex
                            }
                            return item
                        },
                        _getChangedColumnIndices: function(oldItem, newItem, rowIndex, isLiveUpdate) {
                            var editingController = this.getController("editing");
                            var isRowEditMode = editingController.isRowEditMode();
                            if (oldItem.isNewRow !== newItem.isNewRow || oldItem.removed !== newItem.removed || isRowEditMode && oldItem.isEditing !== newItem.isEditing) {
                                return
                            }
                            return this.callBase.apply(this, arguments)
                        },
                        _isCellChanged: function(oldRow, newRow, visibleRowIndex, columnIndex, isLiveUpdate) {
                            var editingController = this.getController("editing");
                            var cell = oldRow.cells && oldRow.cells[columnIndex];
                            var isEditing = editingController && editingController.isEditCell(visibleRowIndex, columnIndex);
                            if (isLiveUpdate && isEditing) {
                                return false
                            }
                            if (cell && cell.column && !cell.column.showEditorAlways && cell.isEditing !== isEditing) {
                                return true
                            }
                            return this.callBase.apply(this, arguments)
                        }
                    }
                },
                views: {
                    rowsView: {
                        init: function() {
                            this.callBase();
                            this._editingController = this.getController("editing")
                        },
                        getCellElements: function(rowIndex) {
                            var $cellElements = this.callBase(rowIndex);
                            var editingController = this._editingController;
                            var editForm = editingController.getEditForm();
                            var editFormRowIndex = editingController.getEditFormRowIndex();
                            if (editFormRowIndex === rowIndex && $cellElements && editForm) {
                                return editForm.$element().find("." + this.addWidgetPrefix(EDIT_FORM_ITEM_CLASS) + ", ." + BUTTON_CLASS)
                            }
                            return $cellElements
                        },
                        getCellIndex: function($cell, rowIndex) {
                            if (!$cell.is("td") && rowIndex >= 0) {
                                var $cellElements = this.getCellElements(rowIndex);
                                var cellIndex = -1;
                                (0, _iterator.each)($cellElements, function(index, cellElement) {
                                    if ((0, _renderer.default)(cellElement).find($cell).length) {
                                        cellIndex = index
                                    }
                                });
                                return cellIndex
                            }
                            return this.callBase.apply(this, arguments)
                        },
                        _getVisibleColumnIndex: function($cells, rowIndex, columnIdentifier) {
                            var editFormRowIndex = this._editingController.getEditFormRowIndex();
                            if (editFormRowIndex === rowIndex && (0, _type.isString)(columnIdentifier)) {
                                var column = this._columnsController.columnOption(columnIdentifier);
                                return this._getEditFormEditorVisibleIndex($cells, column)
                            }
                            return this.callBase.apply(this, arguments)
                        },
                        _getEditFormEditorVisibleIndex: function($cells, column) {
                            var visibleIndex = -1;
                            (0, _iterator.each)($cells, function(index, cellElement) {
                                var item = (0, _renderer.default)(cellElement).find(".dx-field-item-content").data("dx-form-item");
                                if (item && item.column && column && item.column.index === column.index) {
                                    visibleIndex = index;
                                    return false
                                }
                            });
                            return visibleIndex
                        },
                        publicMethods: function() {
                            return this.callBase().concat(["cellValue"])
                        },
                        _getCellTemplate: function(options) {
                            var that = this;
                            var template = that._editingController.getColumnTemplate(options);
                            return template || that.callBase(options)
                        },
                        _isNativeClick: function() {
                            return (_devices.default.real().ios || _devices.default.real().android) && this.option("editing.allowUpdating")
                        },
                        _createTable: function() {
                            var that = this;
                            var $table = that.callBase.apply(that, arguments);
                            if (!_isRowEditMode(that) && that.option("editing.allowUpdating")) {
                                _events_engine.default.on($table, (0, _index.addNamespace)(_hold.default.name, "dxDataGridRowsView"), "td:not(." + EDITOR_CELL_CLASS + ")", that.createAction(function() {
                                    var editingController = that._editingController;
                                    if (editingController.isEditing()) {
                                        editingController.closeEditCell()
                                    }
                                }))
                            }
                            return $table
                        },
                        _createRow: function(row) {
                            var $row = this.callBase(row);
                            if (row) {
                                var editingController = this._editingController;
                                var isEditRow = editingController.isEditRow(row.rowIndex);
                                var isRowRemoved = !!row.removed;
                                var isRowInserted = !!row.isNewRow;
                                var isRowModified = !!row.modified;
                                if (_getEditMode(this) === EDIT_MODE_BATCH) {
                                    isRowRemoved && $row.addClass(ROW_REMOVED)
                                } else {
                                    isEditRow && $row.addClass(EDIT_ROW)
                                }
                                isRowInserted && $row.addClass(ROW_INSERTED);
                                isRowModified && $row.addClass(ROW_MODIFIED);
                                if (isEditRow || isRowInserted || isRowRemoved) {
                                    $row.removeClass(ROW_SELECTED)
                                }
                                if (isEditRow && "detail" === row.rowType) {
                                    $row.addClass(this.addWidgetPrefix(EDIT_FORM_CLASS))
                                }
                            }
                            return $row
                        },
                        _getColumnIndexByElement: function($element) {
                            var $tableElement = $element.closest("table");
                            var $tableElements = this.getTableElements();
                            while ($tableElement.length && !$tableElements.filter($tableElement).length) {
                                $element = $tableElement.closest("td");
                                $tableElement = $element.closest("table")
                            }
                            return this._getColumnIndexByElementCore($element)
                        },
                        _getColumnIndexByElementCore: function($element) {
                            var $targetElement = $element.closest("." + ROW_CLASS + "> td:not(.dx-master-detail-cell)");
                            return this.getCellIndex($targetElement)
                        },
                        _editCellByClick: function(e, eventName) {
                            var that = this;
                            var editingController = that._editingController;
                            var $targetElement = (0, _renderer.default)(e.event.target);
                            var columnIndex = that._getColumnIndexByElement($targetElement);
                            var row = that._dataController.items()[e.rowIndex];
                            var allowUpdating = editingController.allowUpdating({
                                row: row
                            }, eventName) || row && row.isNewRow;
                            var column = that._columnsController.getVisibleColumns()[columnIndex];
                            var allowEditing = allowUpdating && column && (column.allowEditing || editingController.isEditCell(e.rowIndex, columnIndex));
                            var startEditAction = that.option("editing.startEditAction") || "click";
                            if ("down" === eventName) {
                                return column && column.showEditorAlways && allowEditing && editingController.editCell(e.rowIndex, columnIndex)
                            }
                            if ("click" === eventName && "dblClick" === startEditAction && !editingController.isEditCell(e.rowIndex, columnIndex)) {
                                editingController.closeEditCell()
                            }
                            if (allowEditing && eventName === startEditAction) {
                                return editingController.editCell(e.rowIndex, columnIndex) || editingController.isEditRow(e.rowIndex)
                            }
                        },
                        _rowPointerDown: function(e) {
                            var _this24 = this;
                            this._pointerDownTimeout = setTimeout(function() {
                                _this24._editCellByClick(e, "down")
                            })
                        },
                        _rowClick: function(e) {
                            var isEditForm = (0, _renderer.default)(e.rowElement).hasClass(this.addWidgetPrefix(EDIT_FORM_CLASS));
                            e.event[TARGET_COMPONENT_NAME] = this.component;
                            if (!this._editCellByClick(e, "click") && !isEditForm) {
                                this.callBase.apply(this, arguments)
                            }
                        },
                        _rowDblClick: function(e) {
                            if (!this._editCellByClick(e, "dblClick")) {
                                this.callBase.apply(this, arguments)
                            }
                        },
                        _cellPrepared: function($cell, parameters) {
                            var editingController = this._editingController;
                            var isCommandCell = !!parameters.column.command;
                            var isEditableCell = parameters.setValue;
                            var isEditRow = editingController.isEditRow(parameters.rowIndex);
                            var isEditing = isEditingCell(isEditRow, parameters);
                            if (isEditingOrShowEditorAlwaysDataCell(isEditRow, parameters)) {
                                var alignment = parameters.column.alignment;
                                $cell.toggleClass(this.addWidgetPrefix(READONLY_CLASS), !isEditableCell).toggleClass(CELL_FOCUS_DISABLED_CLASS, !isEditableCell);
                                if (alignment) {
                                    $cell.find(EDITORS_INPUT_SELECTOR).first().css("textAlign", alignment)
                                }
                            }
                            if (isEditing) {
                                this._editCellPrepared($cell)
                            }
                            if (parameters.column && !isCommandCell) {
                                editingController.highlightDataCell($cell, parameters)
                            }
                            this.callBase.apply(this, arguments)
                        },
                        _editCellPrepared: function($cell) {},
                        _formItemPrepared: function() {},
                        _isFormItem: function(parameters) {
                            var isDetailRow = "detail" === parameters.rowType || "detailAdaptive" === parameters.rowType;
                            var isPopupEditing = "data" === parameters.rowType && "popup" === _getEditMode(this);
                            return (isDetailRow || isPopupEditing) && parameters.item
                        },
                        _updateCell: function($cell, parameters) {
                            if (this._isFormItem(parameters)) {
                                this._formItemPrepared(parameters, $cell)
                            } else {
                                this.callBase($cell, parameters)
                            }
                        },
                        _update: function(change) {
                            this.callBase(change);
                            if ("updateSelection" === change.changeType) {
                                this.getTableElements().children("tbody").children("." + EDIT_ROW).removeClass(ROW_SELECTED)
                            }
                        },
                        _getCellOptions: function(options) {
                            var cellOptions = this.callBase(options);
                            cellOptions.isEditing = this._editingController.isEditCell(cellOptions.rowIndex, cellOptions.columnIndex);
                            return cellOptions
                        },
                        _createCell: function(options) {
                            var $cell = this.callBase(options);
                            var isEditRow = this._editingController.isEditRow(options.rowIndex);
                            isEditingOrShowEditorAlwaysDataCell(isEditRow, options) && $cell.addClass(EDITOR_CELL_CLASS);
                            return $cell
                        },
                        _renderCellContent: function($cell, options) {
                            if ("data" === options.rowType && _getEditMode(this) === EDIT_MODE_POPUP && false === options.row.visible) {
                                return
                            }
                            this.callBase.apply(this, arguments)
                        },
                        cellValue: function(rowIndex, columnIdentifier, value, text) {
                            var cellOptions = this.getCellOptions(rowIndex, columnIdentifier);
                            if (cellOptions) {
                                if (void 0 === value) {
                                    return cellOptions.value
                                } else {
                                    this._editingController.updateFieldValue(cellOptions, value, text, true)
                                }
                            }
                        },
                        dispose: function() {
                            this.callBase.apply(this, arguments);
                            clearTimeout(this._pointerDownTimeout)
                        },
                        _renderCore: function() {
                            this.callBase.apply(this, arguments);
                            this._editingController._focusEditorIfNeed()
                        }
                    },
                    headerPanel: {
                        _getToolbarItems: function() {
                            var items = this.callBase();
                            var editButtonItems = this.getController("editing").prepareEditButtons(this);
                            return editButtonItems.concat(items)
                        },
                        optionChanged: function(args) {
                            var fullName = args.fullName;
                            switch (args.name) {
                                case "editing":
                                    var excludedOptions = [EDITING_POPUP_OPTION_NAME, EDITING_CHANGES_OPTION_NAME, EDITING_EDITCOLUMNNAME_OPTION_NAME, EDITING_EDITROWKEY_OPTION_NAME];
                                    var shouldInvalidate = fullName && !excludedOptions.some(function(optionName) {
                                        return optionName === fullName
                                    });
                                    shouldInvalidate && this._invalidate();
                                    this.callBase(args);
                                    break;
                                default:
                                    this.callBase(args)
                            }
                        },
                        isVisible: function() {
                            var that = this;
                            var editingOptions = that.getController("editing").option("editing");
                            return that.callBase() || editingOptions && (editingOptions.allowAdding || (editingOptions.allowUpdating || editingOptions.allowDeleting) && editingOptions.mode === EDIT_MODE_BATCH)
                        }
                    }
                }
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.validating.js ***!
      \**************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.modules */ 44));
        var _uiGrid_core2 = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.utils */ 35));
        var _array_utils = __webpack_require__( /*! ../../data/array_utils */ 93);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _selectors = __webpack_require__( /*! ../widget/selectors */ 70);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _button = _interopRequireDefault(__webpack_require__( /*! ../button */ 37));
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../../events/pointer */ 24));
        var _validation_engine = _interopRequireDefault(__webpack_require__( /*! ../validation_engine */ 96));
        var _validator = _interopRequireDefault(__webpack_require__( /*! ../validator */ 216));
        var _overlay = _interopRequireDefault(__webpack_require__( /*! ../overlay */ 64));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _load_indicator = _interopRequireDefault(__webpack_require__( /*! ../load_indicator */ 83));
        var _string = __webpack_require__( /*! ../../core/utils/string */ 43);
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }
        var INVALIDATE_CLASS = "invalid";
        var REVERT_TOOLTIP_CLASS = "revert-tooltip";
        var ROWS_VIEW_CLASS = "rowsview";
        var INVALID_MESSAGE_CLASS = "dx-invalid-message";
        var WIDGET_INVALID_MESSAGE_CLASS = "invalid-message";
        var INVALID_MESSAGE_ALWAYS_CLASS = "dx-invalid-message-always";
        var REVERT_BUTTON_CLASS = "dx-revert-button";
        var VALIDATOR_CLASS = "validator";
        var PENDING_INDICATOR_CLASS = "dx-pending-indicator";
        var VALIDATION_PENDING_CLASS = "dx-validation-pending";
        var CONTENT_CLASS = "content";
        var INSERT_INDEX = "__DX_INSERT_INDEX__";
        var PADDING_BETWEEN_TOOLTIPS = 2;
        var EDIT_MODE_ROW = "row";
        var EDIT_MODE_FORM = "form";
        var EDIT_MODE_BATCH = "batch";
        var EDIT_MODE_CELL = "cell";
        var EDIT_MODE_POPUP = "popup";
        var GROUP_CELL_CLASS = "dx-group-cell";
        var FORM_BASED_MODES = [EDIT_MODE_POPUP, EDIT_MODE_FORM];
        var COMMAND_TRANSPARENT = "transparent";
        var VALIDATION_STATUS = {
            valid: "valid",
            invalid: "invalid",
            pending: "pending"
        };
        var EDIT_DATA_INSERT_TYPE = "insert";
        var EDIT_DATA_REMOVE_TYPE = "remove";
        var VALIDATION_CANCELLED = "cancel";
        var validationResultIsValid = function(result) {
            return (0, _type.isDefined)(result) && result !== VALIDATION_CANCELLED
        };
        var cellValueShouldBeValidated = function(value, rowOptions) {
            return void 0 !== value || void 0 === value && rowOptions && !rowOptions.isNewRow
        };
        var ValidatingController = _uiGrid_core.default.Controller.inherit(function() {
            return {
                init: function() {
                    this._editingController = this.getController("editing");
                    this.createAction("onRowValidating");
                    if (!this._validationState) {
                        this._validationState = []
                    }
                },
                _rowIsValidated: function(change) {
                    var validationData = this._getValidationData(null === change || void 0 === change ? void 0 : change.key);
                    return !!validationData && !!validationData.validated
                },
                _getValidationData: function(key, create) {
                    var validationData = this._validationState.filter(function(data) {
                        return (0, _common.equalByValue)(data.key, key)
                    })[0];
                    if (!validationData && create) {
                        validationData = {
                            key: key,
                            isValid: true
                        };
                        this._validationState.push(validationData)
                    }
                    return validationData
                },
                _getBrokenRules: function(validationData, validationResults) {
                    var brokenRules;
                    if (validationResults) {
                        brokenRules = validationResults.brokenRules || validationResults.brokenRule && [validationResults.brokenRule]
                    } else {
                        brokenRules = validationData.brokenRules || []
                    }
                    return brokenRules
                },
                _rowValidating: function(validationData, validationResults) {
                    var deferred = new _deferred.Deferred;
                    var change = this._editingController.getChangeByKey(null === validationData || void 0 === validationData ? void 0 : validationData.key);
                    var brokenRules = this._getBrokenRules(validationData, validationResults);
                    var isValid = validationResults ? validationResults.isValid : validationData.isValid;
                    var parameters = {
                        brokenRules: brokenRules,
                        isValid: isValid,
                        key: change.key,
                        newData: change.data,
                        oldData: this._editingController._getOldData(change.key),
                        promise: null,
                        errorText: this.getHiddenValidatorsErrorText(brokenRules)
                    };
                    this.executeAction("onRowValidating", parameters);
                    (0, _deferred.when)(parameters.promise).always(function() {
                        validationData.isValid = parameters.isValid;
                        validationData.errorText = parameters.errorText;
                        deferred.resolve(parameters)
                    });
                    return deferred.promise()
                },
                getHiddenValidatorsErrorText: function(brokenRules) {
                    var brokenRulesMessages = [];
                    (0, _iterator.each)(brokenRules, function(_, brokenRule) {
                        var column = brokenRule.column;
                        var isGroupExpandColumn = column && void 0 !== column.groupIndex && !column.showWhenGrouped;
                        var isVisibleColumn = column && column.visible;
                        if (!brokenRule.validator.$element().parent().length && (!isVisibleColumn || isGroupExpandColumn)) {
                            brokenRulesMessages.push(brokenRule.message)
                        }
                    });
                    return brokenRulesMessages.join(", ")
                },
                validate: function(isFull) {
                    var _this = this;
                    var isValid = true;
                    var editingController = this._editingController;
                    var deferred = new _deferred.Deferred;
                    var completeList = [];
                    var editMode = editingController.getEditMode();
                    isFull = isFull || editMode === EDIT_MODE_ROW;
                    if (this._isValidationInProgress) {
                        return deferred.resolve(false).promise()
                    }
                    this._isValidationInProgress = true;
                    if (isFull) {
                        editingController.addDeferred(deferred);
                        var changes = editingController.getChanges();
                        (0, _iterator.each)(changes, function(index, _ref) {
                            var type = _ref.type,
                                key = _ref.key;
                            if ("remove" !== type) {
                                var validationData = _this._getValidationData(key, true);
                                var validationResult = _this.validateGroup(validationData);
                                completeList.push(validationResult);
                                validationResult.done(function(validationResult) {
                                    validationData.validated = true;
                                    isValid = isValid && validationResult.isValid
                                })
                            }
                        })
                    } else {
                        if (this._currentCellValidator) {
                            var validationResult = this.validateGroup(this._currentCellValidator._findGroup());
                            completeList.push(validationResult);
                            validationResult.done(function(validationResult) {
                                isValid = validationResult.isValid
                            })
                        }
                    }
                    _deferred.when.apply(void 0, completeList).done(function() {
                        _this._isValidationInProgress = false;
                        deferred.resolve(isValid)
                    });
                    return deferred.promise()
                },
                validateGroup: function validateGroup(validationData) {
                    var _validationResult, _this2 = this;
                    var result = new _deferred.Deferred;
                    var validateGroup = validationData && _validation_engine.default.getGroupConfig(validationData);
                    var validationResult;
                    if (null !== validateGroup && void 0 !== validateGroup && validateGroup.validators.length) {
                        this.resetRowValidationResults(validationData);
                        validationResult = _validation_engine.default.validateGroup(validationData)
                    }(0, _deferred.when)((null === (_validationResult = validationResult) || void 0 === _validationResult ? void 0 : _validationResult.complete) || validationResult).done(function(validationResult) {
                        (0, _deferred.when)(_this2._rowValidating(validationData, validationResult)).done(result.resolve)
                    });
                    return result.promise()
                },
                isRowDataModified: function(change) {
                    return !(0, _type.isEmptyObject)(change.data)
                },
                updateValidationState: function(change) {
                    var editMode = this._editingController.getEditMode();
                    var key = change.key;
                    var validationData = this._getValidationData(key, true);
                    if (FORM_BASED_MODES.indexOf(editMode) === -1) {
                        if (change.type === EDIT_DATA_INSERT_TYPE && !this.isRowDataModified(change)) {
                            validationData.isValid = true;
                            return
                        }
                        this.setDisableApplyValidationResults(true);
                        var groupConfig = _validation_engine.default.getGroupConfig(validationData);
                        if (groupConfig) {
                            var validationResult = _validation_engine.default.validateGroup(validationData);
                            (0, _deferred.when)(validationResult.complete || validationResult).done(function(validationResult) {
                                validationData.isValid = validationResult.isValid;
                                validationData.brokenRules = validationResult.brokenRules
                            })
                        } else {
                            if (!validationData.brokenRules || !validationData.brokenRules.length) {
                                validationData.isValid = true
                            }
                        }
                        this.setDisableApplyValidationResults(false)
                    } else {
                        validationData.isValid = true
                    }
                },
                setValidator: function(validator) {
                    this._currentCellValidator = validator
                },
                renderCellPendingIndicator: function($container) {
                    var $indicator = $container.find("." + PENDING_INDICATOR_CLASS);
                    if (!$indicator.length) {
                        var $indicatorContainer = $container;
                        $indicator = (0, _renderer.default)("<div>").appendTo($indicatorContainer).addClass(PENDING_INDICATOR_CLASS);
                        this._createComponent($indicator, _load_indicator.default);
                        $container.addClass(VALIDATION_PENDING_CLASS)
                    }
                },
                disposeCellPendingIndicator: function($container) {
                    var $indicator = $container.find("." + PENDING_INDICATOR_CLASS);
                    if ($indicator.length) {
                        var indicator = _load_indicator.default.getInstance($indicator);
                        if (indicator) {
                            indicator.dispose();
                            indicator.$element().remove()
                        }
                        $container.removeClass(VALIDATION_PENDING_CLASS)
                    }
                },
                validationStatusChanged: function(result) {
                    var validator = result.validator;
                    var validationGroup = validator.option("validationGroup");
                    var column = validator.option("dataGetter")().column;
                    this.updateCellValidationResult({
                        rowKey: validationGroup.key,
                        columnIndex: column.index,
                        validationResult: result
                    })
                },
                validatorInitialized: function(arg) {
                    arg.component.on("validating", this.validationStatusChanged.bind(this));
                    arg.component.on("validated", this.validationStatusChanged.bind(this))
                },
                validatorDisposing: function(arg) {
                    var validator = arg.component;
                    var validationGroup = validator.option("validationGroup");
                    var column = validator.option("dataGetter")().column;
                    var result = this.getCellValidationResult({
                        rowKey: null === validationGroup || void 0 === validationGroup ? void 0 : validationGroup.key,
                        columnIndex: column.index
                    });
                    if (validationResultIsValid(result) && result.status === VALIDATION_STATUS.pending) {
                        this.cancelCellValidationResult({
                            change: validationGroup,
                            columnIndex: column.index
                        })
                    }
                },
                applyValidationResult: function($container, result) {
                    var validator = result.validator;
                    var validationGroup = validator.option("validationGroup");
                    var column = validator.option("dataGetter")().column;
                    result.brokenRules && result.brokenRules.forEach(function(rule) {
                        rule.columnIndex = column.index;
                        rule.column = column
                    });
                    if ($container) {
                        var validationResult = this.getCellValidationResult({
                            rowKey: validationGroup.key,
                            columnIndex: column.index
                        });
                        var requestIsDisabled = validationResultIsValid(validationResult) && validationResult.disabledPendingId === result.id;
                        if (this._disableApplyValidationResults || requestIsDisabled) {
                            return
                        }
                        if (result.status === VALIDATION_STATUS.invalid) {
                            var $focus = $container.find(":focus");
                            if (!(0, _selectors.focused)($focus)) {
                                _events_engine.default.trigger($focus, "focus");
                                _events_engine.default.trigger($focus, _pointer.default.down)
                            }
                        }
                        var editor = !column.editCellTemplate && this.getController("editorFactory").getEditorInstance($container);
                        if (result.status === VALIDATION_STATUS.pending) {
                            if (editor) {
                                editor.option("validationStatus", VALIDATION_STATUS.pending)
                            } else {
                                this.renderCellPendingIndicator($container)
                            }
                        } else {
                            if (editor) {
                                editor.option("validationStatus", VALIDATION_STATUS.valid)
                            } else {
                                this.disposeCellPendingIndicator($container)
                            }
                        }
                        $container.toggleClass(this.addWidgetPrefix(INVALIDATE_CLASS), result.status === VALIDATION_STATUS.invalid)
                    }
                },
                createValidator: function(parameters, $container) {
                    var _this3 = this;
                    var editingController = this._editingController;
                    var column = parameters.column;
                    var showEditorAlways = column.showEditorAlways;
                    if ((0, _type.isDefined)(column.command) || !column.validationRules || !Array.isArray(column.validationRules) || !column.validationRules.length) {
                        return
                    }
                    var editIndex = editingController.getIndexByKey(parameters.key, editingController.getChanges());
                    var needCreateValidator = editIndex > -1;
                    if (!needCreateValidator) {
                        if (!showEditorAlways) {
                            var columnsController = this.getController("columns");
                            var visibleColumns = (null === columnsController || void 0 === columnsController ? void 0 : columnsController.getVisibleColumns()) || [];
                            showEditorAlways = visibleColumns.some(function(column) {
                                return column.showEditorAlways
                            })
                        }
                        var isEditRow = (0, _common.equalByValue)(this.option("editing.editRowKey"), parameters.key);
                        var isCellOrBatchEditingAllowed = editingController.isCellOrBatchEditMode() && editingController.allowUpdating({
                            row: parameters.row
                        });
                        needCreateValidator = isEditRow || isCellOrBatchEditingAllowed && showEditorAlways;
                        if (isCellOrBatchEditingAllowed && showEditorAlways) {
                            editingController._addInternalData({
                                key: parameters.key,
                                oldData: parameters.data
                            })
                        }
                    }
                    if (needCreateValidator) {
                        if ($container && !$container.length) {
                            _ui.default.log("E1050");
                            return
                        }
                        var validationData = this._getValidationData(parameters.key, true);
                        var getValue = function() {
                            var change = editingController.getChangeByKey(null === validationData || void 0 === validationData ? void 0 : validationData.key);
                            var value = column.calculateCellValue((null === change || void 0 === change ? void 0 : change.data) || {});
                            return void 0 !== value ? value : parameters.value
                        };
                        var useDefaultValidator = $container && $container.hasClass("dx-widget");
                        $container && $container.addClass(this.addWidgetPrefix(VALIDATOR_CLASS));
                        var validator = new _validator.default($container || (0, _renderer.default)("<div>"), {
                            name: column.caption,
                            validationRules: (0, _extend.extend)(true, [], column.validationRules),
                            validationGroup: validationData,
                            adapter: useDefaultValidator ? null : {
                                getValue: getValue,
                                applyValidationResults: function(result) {
                                    _this3.applyValidationResult($container, result)
                                }
                            },
                            dataGetter: function() {
                                var key = null === validationData || void 0 === validationData ? void 0 : validationData.key;
                                var change = editingController.getChangeByKey(key);
                                var oldData = editingController._getOldData(key);
                                return {
                                    data: (0, _array_utils.createObjectWithChanges)(oldData, null === change || void 0 === change ? void 0 : change.data),
                                    column: column
                                }
                            },
                            onInitialized: this.validatorInitialized.bind(this),
                            onDisposing: this.validatorDisposing.bind(this)
                        });
                        if (useDefaultValidator) {
                            var adapter = validator.option("adapter");
                            if (adapter) {
                                adapter.getValue = getValue;
                                adapter.validationRequestsCallbacks = []
                            }
                        }
                        return validator
                    }
                },
                setDisableApplyValidationResults: function(flag) {
                    this._disableApplyValidationResults = flag
                },
                getDisableApplyValidationResults: function() {
                    return this._disableApplyValidationResults
                },
                isCurrentValidatorProcessing: function(_ref2) {
                    var rowKey = _ref2.rowKey,
                        columnIndex = _ref2.columnIndex;
                    return this._currentCellValidator && (0, _common.equalByValue)(this._currentCellValidator.option("validationGroup").key, rowKey) && this._currentCellValidator.option("dataGetter")().column.index === columnIndex
                },
                validateCell: function(validator) {
                    var cellParams = {
                        rowKey: validator.option("validationGroup").key,
                        columnIndex: validator.option("dataGetter")().column.index
                    };
                    var validationResult = this.getCellValidationResult(cellParams);
                    var stateRestored = validationResultIsValid(validationResult);
                    if (!stateRestored) {
                        validationResult = validator.validate()
                    }
                    var deferred = new _deferred.Deferred;
                    var adapter = validator.option("adapter");
                    if (stateRestored && validationResult.status === VALIDATION_STATUS.pending) {
                        this.updateCellValidationResult(cellParams);
                        adapter.applyValidationResults(validationResult)
                    }(0, _deferred.when)(validationResult.complete || validationResult).done(function(validationResult) {
                        stateRestored && adapter.applyValidationResults(validationResult);
                        deferred.resolve(validationResult)
                    });
                    return deferred.promise()
                },
                updateCellValidationResult: function(_ref3) {
                    var rowKey = _ref3.rowKey,
                        columnIndex = _ref3.columnIndex,
                        validationResult = _ref3.validationResult;
                    var validationData = this._getValidationData(rowKey);
                    if (!validationData) {
                        return
                    }
                    if (!validationData.validationResults) {
                        validationData.validationResults = {}
                    }
                    var result;
                    if (validationResult) {
                        result = (0, _extend.extend)({}, validationResult);
                        validationData.validationResults[columnIndex] = result;
                        if (validationResult.status === VALIDATION_STATUS.pending) {
                            if (this._editingController.getEditMode() === EDIT_MODE_CELL) {
                                result.deferred = new _deferred.Deferred;
                                result.complete.always(function() {
                                    result.deferred.resolve()
                                });
                                this._editingController.addDeferred(result.deferred)
                            }
                            if (this._disableApplyValidationResults) {
                                result.disabledPendingId = validationResult.id;
                                return
                            }
                        }
                    } else {
                        result = validationData.validationResults[columnIndex]
                    }
                    if (result && result.disabledPendingId) {
                        delete result.disabledPendingId
                    }
                },
                getCellValidationResult: function(_ref4) {
                    var _validationData$valid;
                    var rowKey = _ref4.rowKey,
                        columnIndex = _ref4.columnIndex;
                    var validationData = this._getValidationData(rowKey, true);
                    return null === validationData || void 0 === validationData ? void 0 : null === (_validationData$valid = validationData.validationResults) || void 0 === _validationData$valid ? void 0 : _validationData$valid[columnIndex]
                },
                removeCellValidationResult: function(_ref5) {
                    var change = _ref5.change,
                        columnIndex = _ref5.columnIndex;
                    var validationData = this._getValidationData(null === change || void 0 === change ? void 0 : change.key);
                    if (validationData && validationData.validationResults) {
                        this.cancelCellValidationResult({
                            change: change,
                            columnIndex: columnIndex
                        });
                        delete validationData.validationResults[columnIndex]
                    }
                },
                cancelCellValidationResult: function(_ref6) {
                    var change = _ref6.change,
                        columnIndex = _ref6.columnIndex;
                    var validationData = this._getValidationData(change.key);
                    if (change && validationData.validationResults) {
                        var result = validationData.validationResults[columnIndex];
                        if (result) {
                            result.deferred && result.deferred.reject(VALIDATION_CANCELLED);
                            validationData.validationResults[columnIndex] = VALIDATION_CANCELLED
                        }
                    }
                },
                resetRowValidationResults: function(validationData) {
                    if (validationData) {
                        validationData.validationResults && delete validationData.validationResults;
                        delete validationData.validated
                    }
                },
                isInvalidCell: function(_ref7) {
                    var rowKey = _ref7.rowKey,
                        columnIndex = _ref7.columnIndex;
                    var result = this.getCellValidationResult({
                        rowKey: rowKey,
                        columnIndex: columnIndex
                    });
                    return validationResultIsValid(result) && result.status === VALIDATION_STATUS.invalid
                },
                getCellValidator: function(_ref8) {
                    var rowKey = _ref8.rowKey,
                        columnIndex = _ref8.columnIndex;
                    var validationData = this._getValidationData(rowKey);
                    var groupConfig = validationData && _validation_engine.default.getGroupConfig(validationData);
                    var validators = groupConfig && groupConfig.validators;
                    return validators && validators.filter(function(v) {
                        var column = v.option("dataGetter")().column;
                        return column ? column.index === columnIndex : false
                    })[0]
                },
                setCellValidationStatus: function(cellOptions) {
                    var validationResult = this.getCellValidationResult({
                        rowKey: cellOptions.key,
                        columnIndex: cellOptions.column.index
                    });
                    if ((0, _type.isDefined)(validationResult)) {
                        cellOptions.validationStatus = validationResult !== VALIDATION_CANCELLED ? validationResult.status : VALIDATION_CANCELLED
                    } else {
                        delete cellOptions.validationStatus
                    }
                }
            }
        }());
        var _default = {
            defaultOptions: function() {
                return {
                    editing: {
                        texts: {
                            validationCancelChanges: _message.default.format("dxDataGrid-validationCancelChanges")
                        }
                    }
                }
            },
            controllers: {
                validating: ValidatingController
            },
            extenders: {
                controllers: {
                    editing: {
                        _addChange: function(options, row) {
                            var index = this.callBase(options, row);
                            var validatingController = this.getController("validating");
                            if (index >= 0 && options.type !== EDIT_DATA_REMOVE_TYPE) {
                                var change = this.getChanges()[index];
                                change && validatingController.updateValidationState(change)
                            }
                            return index
                        },
                        _handleChangesChange: function(args) {
                            this.callBase.apply(this, arguments);
                            var validatingController = this.getController("validating");
                            args.value.forEach(function(change) {
                                if (void 0 === validatingController._getValidationData(change.key)) {
                                    validatingController.updateValidationState(change)
                                }
                            })
                        },
                        _updateRowAndPageIndices: function() {
                            var _this4 = this;
                            var that = this;
                            var startInsertIndex = that.getView("rowsView").getTopVisibleItemIndex();
                            var rowIndex = startInsertIndex;
                            (0, _iterator.each)(that.getChanges(), function(_, _ref9) {
                                var key = _ref9.key,
                                    type = _ref9.type;
                                var validationData = _this4.getController("validating")._getValidationData(key);
                                if (validationData && !validationData.isValid && validationData.pageIndex !== that._pageIndex) {
                                    validationData.pageIndex = that._pageIndex;
                                    if (type === EDIT_DATA_INSERT_TYPE) {
                                        validationData.rowIndex = startInsertIndex
                                    } else {
                                        validationData.rowIndex = rowIndex
                                    }
                                    rowIndex++
                                }
                            })
                        },
                        getEditFormOptions: function(detailOptions) {
                            var editFormOptions = this.callBase.apply(this, arguments);
                            var validatingController = this.getController("validating");
                            var validationData = validatingController._getValidationData(detailOptions.key, true);
                            return (0, _extend.extend)({}, editFormOptions, {
                                validationGroup: validationData
                            })
                        },
                        _updateEditRowCore: function(row, skipCurrentRow, isCustomSetCellValue) {
                            this.callBase.apply(this, arguments);
                            if (isCustomSetCellValue && this._editForm && !row.isNewRow) {
                                this._editForm.validate()
                            }
                        },
                        _needInsertItem: function(_ref10) {
                            var key = _ref10.key;
                            var result = this.callBase.apply(this, arguments);
                            var validationData = this.getController("validating")._getValidationData(key);
                            if (result && !(null !== validationData && void 0 !== validationData && validationData.isValid)) {
                                result = key.pageIndex === this._pageIndex
                            }
                            return result
                        },
                        _prepareEditCell: function(params) {
                            var isNotCanceled = this.callBase.apply(this, arguments);
                            var validatingController = this.getController("validating");
                            if (isNotCanceled && params.column.showEditorAlways) {
                                validatingController.updateValidationState({
                                    key: params.key
                                })
                            }
                            return isNotCanceled
                        },
                        processItems: function(items, changeType) {
                            var that = this;
                            var i;
                            var changes = that.getChanges();
                            var dataController = that.getController("data");
                            var validatingController = this.getController("validating");
                            var getIndexByChange = function(change, items) {
                                var index = -1;
                                var isInsert = change.type === EDIT_DATA_INSERT_TYPE;
                                var key = change.key;
                                (0, _iterator.each)(items, function(i, item) {
                                    if ((0, _common.equalByValue)(key, isInsert ? item : dataController.keyOf(item))) {
                                        index = i;
                                        return false
                                    }
                                });
                                return index
                            };
                            items = that.callBase(items, changeType);
                            var itemsCount = items.length;
                            var addInValidItem = function(change, validationData) {
                                var data = {
                                    key: change.key
                                };
                                var index = getIndexByChange(change, items);
                                if (index >= 0) {
                                    return
                                }
                                validationData.rowIndex = validationData.rowIndex > itemsCount ? validationData.rowIndex % itemsCount : validationData.rowIndex;
                                var rowIndex = validationData.rowIndex;
                                data[INSERT_INDEX] = 1;
                                items.splice(rowIndex, 0, data)
                            };
                            if (that.getEditMode() === EDIT_MODE_BATCH && "prepend" !== changeType && "append" !== changeType) {
                                for (i = 0; i < changes.length; i++) {
                                    var key = changes[i].key;
                                    var validationData = validatingController._getValidationData(key);
                                    if (validationData && changes[i].type && validationData.pageIndex === that._pageIndex && key.pageIndex !== that._pageIndex) {
                                        addInValidItem(changes[i], validationData)
                                    }
                                }
                            }
                            return items
                        },
                        processDataItem: function(item) {
                            var isInserted = item.data[INSERT_INDEX];
                            var key = isInserted ? item.data.key : item.key;
                            var editMode = this.getEditMode();
                            if (editMode === EDIT_MODE_BATCH && isInserted && key) {
                                var changes = this.getChanges();
                                var editIndex = _uiGrid_core2.default.getIndexByKey(key, changes);
                                if (editIndex >= 0) {
                                    var change = changes[editIndex];
                                    if (change.type !== EDIT_DATA_INSERT_TYPE) {
                                        var oldData = this._getOldData(change.key);
                                        item.data = (0, _extend.extend)(true, {}, oldData, change.data);
                                        item.key = key
                                    }
                                }
                            }
                            this.callBase.apply(this, arguments)
                        },
                        _createInvisibleColumnValidators: function(changes) {
                            var _this5 = this;
                            var that = this;
                            var validatingController = this.getController("validating");
                            var columnsController = this.getController("columns");
                            var columns = columnsController.getColumns();
                            var invisibleColumns = columnsController.getInvisibleColumns().filter(function(column) {
                                return !column.isBand
                            });
                            var groupColumns = columnsController.getGroupColumns().filter(function(column) {
                                return !column.showWhenGrouped && invisibleColumns.indexOf(column) === -1
                            });
                            var invisibleColumnValidators = [];
                            var isCellVisible = function(column, rowKey) {
                                return _this5._dataController.getRowIndexByKey(rowKey) >= 0 && invisibleColumns.indexOf(column) < 0
                            };
                            invisibleColumns.push.apply(invisibleColumns, _toConsumableArray(groupColumns));
                            if (FORM_BASED_MODES.indexOf(this.getEditMode()) === -1) {
                                (0, _iterator.each)(columns, function(_, column) {
                                    changes.forEach(function(change) {
                                        var data;
                                        if (isCellVisible(column, change.key)) {
                                            return
                                        }
                                        if (change.type === EDIT_DATA_INSERT_TYPE) {
                                            data = change.data
                                        } else {
                                            if ("update" === change.type) {
                                                var oldData = that._getOldData(change.key);
                                                data = (0, _array_utils.createObjectWithChanges)(oldData, change.data)
                                            }
                                        }
                                        if (data) {
                                            var validator = validatingController.createValidator({
                                                column: column,
                                                key: change.key,
                                                value: column.calculateCellValue(data)
                                            });
                                            if (validator) {
                                                invisibleColumnValidators.push(validator)
                                            }
                                        }
                                    })
                                })
                            }
                            return function() {
                                invisibleColumnValidators.forEach(function(validator) {
                                    validator.dispose()
                                })
                            }
                        },
                        _beforeSaveEditData: function(change, editIndex) {
                            var _this6 = this;
                            var result = this.callBase.apply(this, arguments);
                            var validatingController = this.getController("validating");
                            var validationData = validatingController._getValidationData(null === change || void 0 === change ? void 0 : change.key);
                            if (change) {
                                var isValid = "remove" === change.type || validationData.isValid;
                                result = result || !isValid
                            } else {
                                var disposeValidators = this._createInvisibleColumnValidators(this.getChanges());
                                result = new _deferred.Deferred;
                                this.executeOperation(result, function() {
                                    validatingController.validate(true).done(function(isFullValid) {
                                        disposeValidators();
                                        _this6._updateRowAndPageIndices();
                                        switch (_this6.getEditMode()) {
                                            case EDIT_MODE_CELL:
                                                if (!isFullValid) {
                                                    _this6._focusEditingCell()
                                                }
                                                break;
                                            case EDIT_MODE_BATCH:
                                                if (!isFullValid) {
                                                    _this6._resetEditRowKey();
                                                    _this6._resetEditColumnName();
                                                    _this6.getController("data").updateItems()
                                                }
                                        }
                                        result.resolve(!isFullValid)
                                    })
                                })
                            }
                            return result.promise ? result.promise() : result
                        },
                        _beforeEditCell: function(rowIndex, columnIndex, item) {
                            var result = this.callBase(rowIndex, columnIndex, item);
                            if (this.getEditMode() === EDIT_MODE_CELL) {
                                var $cell = this._rowsView._getCellElement(rowIndex, columnIndex);
                                var validator = $cell && $cell.data("dxValidator");
                                var rowOptions = $cell && $cell.closest(".dx-row").data("options");
                                var value = validator && validator.option("adapter").getValue();
                                if (validator && cellValueShouldBeValidated(value, rowOptions)) {
                                    var validatingController = this.getController("validating");
                                    var deferred = new _deferred.Deferred;
                                    (0, _deferred.when)(validatingController.validateCell(validator), result).done(function(validationResult, result) {
                                        deferred.resolve(validationResult.status === VALIDATION_STATUS.valid && result)
                                    });
                                    return deferred.promise()
                                } else {
                                    if (!validator) {
                                        return result
                                    }
                                }
                            }
                        },
                        _afterSaveEditData: function(cancel) {
                            var _this7 = this;
                            var $firstErrorRow;
                            (0, _iterator.each)(this.getChanges(), function(_, change) {
                                var $errorRow = _this7._showErrorRow(change);
                                $firstErrorRow = $firstErrorRow || $errorRow
                            });
                            if ($firstErrorRow) {
                                var scrollable = this._rowsView.getScrollable();
                                if (scrollable) {
                                    scrollable.update();
                                    scrollable.scrollToElement($firstErrorRow)
                                }
                            }
                            if (cancel && this.getEditMode() === EDIT_MODE_CELL && this._needUpdateRow()) {
                                var editRowIndex = this.getEditRowIndex();
                                this._dataController.updateItems({
                                    changeType: "update",
                                    rowIndices: [editRowIndex]
                                });
                                this._focusEditingCell()
                            } else {
                                if (!cancel) {
                                    this.getController("validating")._validationState = []
                                }
                            }
                        },
                        _handleDataChanged: function(args) {
                            var validationState = this.getController("validating")._validationState;
                            if ("standard" === this.option("scrolling.mode")) {
                                this.resetRowAndPageIndices()
                            }
                            if ("prepend" === args.changeType) {
                                (0, _iterator.each)(validationState, function(_, validationData) {
                                    validationData.rowIndex += args.items.length
                                })
                            }
                            this.callBase(args)
                        },
                        resetRowAndPageIndices: function() {
                            var _this8 = this;
                            var validationState = this.getController("validating")._validationState;
                            (0, _iterator.each)(validationState, function(_, validationData) {
                                if (validationData.pageIndex !== _this8._pageIndex) {
                                    delete validationData.pageIndex;
                                    delete validationData.rowIndex
                                }
                            })
                        },
                        _beforeCancelEditData: function() {
                            var validatingController = this.getController("validating");
                            validatingController._validationState = [];
                            this.callBase()
                        },
                        _showErrorRow: function(change) {
                            var $popupContent;
                            var errorHandling = this.getController("errorHandling");
                            var items = this.getController("data").items();
                            var rowIndex = this.getIndexByKey(change.key, items);
                            var validationData = this.getController("validating")._getValidationData(change.key);
                            if (!(null !== validationData && void 0 !== validationData && validationData.isValid) && null !== validationData && void 0 !== validationData && validationData.errorText && rowIndex >= 0) {
                                $popupContent = this.getPopupContent();
                                return errorHandling && errorHandling.renderErrorRow(null === validationData || void 0 === validationData ? void 0 : validationData.errorText, rowIndex, $popupContent)
                            }
                        },
                        updateFieldValue: function(e) {
                            var _this9 = this;
                            var validatingController = this.getController("validating");
                            var deferred = new _deferred.Deferred;
                            validatingController.removeCellValidationResult({
                                change: this.getChangeByKey(e.key),
                                columnIndex: e.column.index
                            });
                            this.callBase.apply(this, arguments).done(function() {
                                var currentValidator = validatingController.getCellValidator({
                                    rowKey: e.key,
                                    columnIndex: e.column.index
                                });
                                (0, _deferred.when)(currentValidator && validatingController.validateCell(currentValidator)).done(function(validationResult) {
                                    _this9.getController("editorFactory").refocus();
                                    deferred.resolve(validationResult)
                                })
                            });
                            return deferred.promise()
                        },
                        highlightDataCell: function($cell, parameters) {
                            this.callBase.apply(this, arguments);
                            var validatingController = this.getController("validating");
                            validatingController.setCellValidationStatus(parameters);
                            var isEditableCell = !!parameters.setValue;
                            var cellModified = this.isCellModified(parameters);
                            var isValidated = (0, _type.isDefined)(parameters.validationStatus);
                            var needValidation = cellModified && parameters.column.setCellValue || isEditableCell && !cellModified && !(parameters.row.isNewRow || !isValidated);
                            if (needValidation) {
                                var validator = $cell.data("dxValidator");
                                if (validator) {
                                    (0, _deferred.when)(this.getController("validating").validateCell(validator)).done(function() {
                                        validatingController.setCellValidationStatus(parameters)
                                    })
                                }
                            }
                        },
                        getChangeByKey: function(key) {
                            var changes = this.getChanges();
                            return changes[_uiGrid_core2.default.getIndexByKey(key, changes)]
                        },
                        isCellModified: function(parameters) {
                            var cellModified = this.callBase(parameters);
                            var change = this.getChangeByKey(parameters.key);
                            var isCellInvalid = !!parameters.row && this.getController("validating").isInvalidCell({
                                rowKey: parameters.key,
                                columnIndex: parameters.column.index
                            });
                            return cellModified || this.getController("validating")._rowIsValidated(change) && isCellInvalid
                        }
                    },
                    editorFactory: function() {
                        var getWidthOfVisibleCells = function(that, element) {
                            var rowIndex = (0, _renderer.default)(element).closest("tr").index();
                            var $cellElements = (0, _renderer.default)(that._rowsView.getRowElement(rowIndex)).first().children().filter(":not(.dx-hidden-cell)");
                            return that._rowsView._getWidths($cellElements).reduce(function(w1, w2) {
                                return w1 + w2
                            }, 0)
                        };
                        var getBoundaryNonFixedColumnsInfo = function(fixedColumns) {
                            var firstNonFixedColumnIndex;
                            var lastNonFixedColumnIndex;
                            fixedColumns.some(function(column, index) {
                                if (column.command === COMMAND_TRANSPARENT) {
                                    firstNonFixedColumnIndex = 0 === index ? -1 : index;
                                    lastNonFixedColumnIndex = index === fixedColumns.length - 1 ? -1 : index + column.colspan - 1;
                                    return true
                                }
                            });
                            return {
                                startColumnIndex: firstNonFixedColumnIndex,
                                endColumnIndex: lastNonFixedColumnIndex
                            }
                        };
                        return {
                            _showRevertButton: function($container) {
                                var _this10 = this;
                                if (!$container || !$container.length) {
                                    return
                                }
                                var $tooltipElement = $container.find("." + this.addWidgetPrefix(REVERT_TOOLTIP_CLASS));
                                var $overlayContainer = $container.closest(".".concat(this.addWidgetPrefix(CONTENT_CLASS)));
                                $tooltipElement && $tooltipElement.remove();
                                $tooltipElement = (0, _renderer.default)("<div>").addClass(this.addWidgetPrefix(REVERT_TOOLTIP_CLASS)).appendTo($container);
                                var tooltipOptions = {
                                    animation: null,
                                    visible: true,
                                    width: "auto",
                                    height: "auto",
                                    target: $container,
                                    shading: false,
                                    container: $overlayContainer,
                                    propagateOutsideClick: true,
                                    closeOnOutsideClick: false,
                                    closeOnTargetScroll: false,
                                    contentTemplate: function() {
                                        var $buttonElement = (0, _renderer.default)("<div>").addClass(REVERT_BUTTON_CLASS);
                                        var buttonOptions = {
                                            icon: "revert",
                                            hint: _this10.option("editing.texts.validationCancelChanges"),
                                            onClick: function() {
                                                _this10._editingController.cancelEditData()
                                            }
                                        };
                                        return new _button.default($buttonElement, buttonOptions).$element()
                                    },
                                    position: {
                                        my: "left top",
                                        at: "right top",
                                        offset: "1 0",
                                        collision: "flip",
                                        boundaryOffset: "0 0",
                                        boundary: this._rowsView.element()
                                    },
                                    onPositioned: this._positionedHandler.bind(this)
                                };
                                return new _overlay.default($tooltipElement, tooltipOptions)
                            },
                            _hideFixedGroupCell: function($cell, overlayOptions) {
                                var $nextFixedRowElement;
                                var $groupCellElement;
                                var isFixedColumns = this._rowsView.isFixedColumns();
                                var isFormEditMode = this._editingController.isFormEditMode();
                                if (isFixedColumns && !isFormEditMode) {
                                    var nextRowOptions = $cell.closest(".dx-row").next().data("options");
                                    if (nextRowOptions && "group" === nextRowOptions.rowType) {
                                        $nextFixedRowElement = (0, _renderer.default)(this._rowsView.getRowElement(nextRowOptions.rowIndex)).last();
                                        $groupCellElement = $nextFixedRowElement.find("." + GROUP_CELL_CLASS);
                                        if ($groupCellElement.length && "hidden" !== $groupCellElement.get(0).style.visibility) {
                                            $groupCellElement.css("visibility", "hidden");
                                            overlayOptions.onDisposing = function() {
                                                $groupCellElement.css("visibility", "")
                                            }
                                        }
                                    }
                                }
                            },
                            _positionedHandler: function(e, isOverlayVisible) {
                                if (!e.component.__skipPositionProcessing) {
                                    var isRevertButton = (0, _renderer.default)(e.element).hasClass(this.addWidgetPrefix(REVERT_TOOLTIP_CLASS));
                                    var needRepaint = !isRevertButton && this._rowsView.updateFreeSpaceRowHeight();
                                    var normalizedPosition = this._normalizeValidationMessagePositionAndMaxWidth(e, isRevertButton, isOverlayVisible);
                                    e.component.__skipPositionProcessing = !!(needRepaint || normalizedPosition);
                                    if (normalizedPosition) {
                                        e.component.option(normalizedPosition)
                                    } else {
                                        if (needRepaint) {
                                            e.component.repaint()
                                        }
                                    }
                                }
                            },
                            _showValidationMessage: function($cell, messages, alignment, revertTooltip) {
                                var _this11 = this;
                                var editorPopup = $cell.find(".dx-dropdowneditor-overlay").data("dxPopup");
                                var isOverlayVisible = editorPopup && editorPopup.option("visible");
                                var myPosition = isOverlayVisible ? "top right" : "top " + alignment;
                                var atPosition = isOverlayVisible ? "top left" : "bottom " + alignment;
                                var $overlayContainer = $cell.closest(".".concat(this.addWidgetPrefix(CONTENT_CLASS)));
                                var errorMessageText = "";
                                messages && messages.forEach(function(message) {
                                    errorMessageText += (errorMessageText.length ? "<br/>" : "") + (0, _string.encodeHtml)(message)
                                });
                                var $overlayElement = (0, _renderer.default)("<div>").addClass(INVALID_MESSAGE_CLASS).addClass(INVALID_MESSAGE_ALWAYS_CLASS).addClass(this.addWidgetPrefix(WIDGET_INVALID_MESSAGE_CLASS)).html(errorMessageText).appendTo($cell);
                                var overlayOptions = {
                                    target: $cell,
                                    container: $overlayContainer,
                                    shading: false,
                                    width: "auto",
                                    height: "auto",
                                    visible: true,
                                    animation: false,
                                    propagateOutsideClick: true,
                                    closeOnOutsideClick: false,
                                    closeOnTargetScroll: false,
                                    position: {
                                        collision: "flip",
                                        boundary: this._rowsView.element(),
                                        boundaryOffset: "0 0",
                                        offset: {
                                            x: 0,
                                            y: !isOverlayVisible && (_browser.default.mozilla || _browser.default.msie) ? -1 : 0
                                        },
                                        my: myPosition,
                                        at: atPosition
                                    },
                                    onPositioned: function(e) {
                                        _this11._positionedHandler(e, isOverlayVisible);
                                        _this11._shiftValidationMessageIfNeed(e.component.$content(), revertTooltip && revertTooltip.$content(), $cell)
                                    }
                                };
                                this._hideFixedGroupCell($cell, overlayOptions);
                                new _overlay.default($overlayElement, overlayOptions)
                            },
                            _normalizeValidationMessagePositionAndMaxWidth: function(options, isRevertButton, isOverlayVisible) {
                                var fixedColumns = this._columnsController.getFixedColumns();
                                if (!fixedColumns || !fixedColumns.length) {
                                    return
                                }
                                var position;
                                var visibleTableWidth = !isRevertButton && getWidthOfVisibleCells(this, options.element);
                                var $overlayContentElement = options.component.$content();
                                var validationMessageWidth = $overlayContentElement.outerWidth(true);
                                var needMaxWidth = !isRevertButton && validationMessageWidth > visibleTableWidth;
                                var columnIndex = this._rowsView.getCellIndex((0, _renderer.default)(options.element).closest("td"));
                                var boundaryNonFixedColumnsInfo = getBoundaryNonFixedColumnsInfo(fixedColumns);
                                if (!isRevertButton && (columnIndex === boundaryNonFixedColumnsInfo.startColumnIndex || needMaxWidth)) {
                                    position = {
                                        collision: "none flip",
                                        my: "top left",
                                        at: isOverlayVisible ? "top right" : "bottom left"
                                    }
                                } else {
                                    if (columnIndex === boundaryNonFixedColumnsInfo.endColumnIndex) {
                                        position = {
                                            collision: "none flip",
                                            my: "top right",
                                            at: isRevertButton || isOverlayVisible ? "top left" : "bottom right"
                                        };
                                        if (isRevertButton) {
                                            position.offset = "-1 0"
                                        }
                                    }
                                }
                                return position && {
                                    position: position,
                                    maxWidth: needMaxWidth ? visibleTableWidth - 2 : void 0
                                }
                            },
                            _shiftValidationMessageIfNeed: function($content, $revertContent, $cell) {
                                if (!$revertContent) {
                                    return
                                }
                                var contentOffset = $content.offset();
                                var revertContentOffset = $revertContent.offset();
                                if (contentOffset.top === revertContentOffset.top && contentOffset.left + $content.width() > revertContentOffset.left) {
                                    var left = $revertContent.width() + PADDING_BETWEEN_TOOLTIPS;
                                    $content.css("left", revertContentOffset.left < $cell.offset().left ? -left : left)
                                }
                            },
                            _getTooltipsSelector: function() {
                                var invalidMessageClass = this.addWidgetPrefix(WIDGET_INVALID_MESSAGE_CLASS);
                                var revertTooltipClass = this.addWidgetPrefix(REVERT_TOOLTIP_CLASS);
                                return ".dx-editor-cell ." + revertTooltipClass + ", .dx-editor-cell ." + invalidMessageClass + ", .dx-cell-modified ." + invalidMessageClass
                            },
                            init: function() {
                                this.callBase();
                                this._editingController = this.getController("editing");
                                this._columnsController = this.getController("columns");
                                this._rowsView = this.getView("rowsView")
                            },
                            loseFocus: function(skipValidator) {
                                if (!skipValidator) {
                                    this.getController("validating").setValidator(null)
                                }
                                this.callBase()
                            },
                            updateCellState: function($element, validationResult, hideBorder) {
                                var _change$data;
                                var $focus = null === $element || void 0 === $element ? void 0 : $element.closest(this._getFocusCellSelector());
                                var $cell = null !== $focus && void 0 !== $focus && $focus.is("td") ? $focus : null;
                                var rowOptions = null === $focus || void 0 === $focus ? void 0 : $focus.closest(".dx-row").data("options");
                                var change = rowOptions ? this.getController("editing").getChangeByKey(rowOptions.key) : null;
                                var column = $cell && this.getController("columns").getVisibleColumns()[$cell.index()];
                                var isCellModified = void 0 !== (null === change || void 0 === change ? void 0 : null === (_change$data = change.data) || void 0 === _change$data ? void 0 : _change$data[null === column || void 0 === column ? void 0 : column.name]) && !this._editingController.isSaving();
                                var revertTooltip;
                                if ((null === validationResult || void 0 === validationResult ? void 0 : validationResult.status) === VALIDATION_STATUS.invalid || isCellModified) {
                                    if (this._editingController.getEditMode() === EDIT_MODE_CELL) {
                                        revertTooltip = this._showRevertButton($focus)
                                    }
                                }
                                var showValidationMessage = validationResult && validationResult.status === VALIDATION_STATUS.invalid;
                                if (showValidationMessage && $cell && column && validationResult && validationResult.brokenRules) {
                                    var errorMessages = [];
                                    validationResult.brokenRules.forEach(function(rule) {
                                        errorMessages.push(rule.message)
                                    });
                                    this._showValidationMessage($focus, errorMessages, column.alignment || "left", revertTooltip)
                                }!hideBorder && this._rowsView.element() && this._rowsView.updateFreeSpaceRowHeight()
                            },
                            focus: function($element, hideBorder) {
                                var _this12 = this;
                                if (!arguments.length) {
                                    return this.callBase()
                                }
                                var $tooltips = $element && $element.closest("." + this.addWidgetPrefix(ROWS_VIEW_CLASS)).find(this._getTooltipsSelector());
                                $tooltips && $tooltips.remove();
                                if (null !== $element && void 0 !== $element && $element.hasClass("dx-row")) {
                                    return this.callBase($element, hideBorder)
                                }
                                var $focus = null === $element || void 0 === $element ? void 0 : $element.closest(this._getFocusCellSelector());
                                var callBase = this.callBase;
                                var validator = $focus && ($focus.data("dxValidator") || $element.find("." + this.addWidgetPrefix(VALIDATOR_CLASS)).eq(0).data("dxValidator"));
                                var rowOptions = $focus && $focus.closest(".dx-row").data("options");
                                var editingController = this.getController("editing");
                                var change = rowOptions ? editingController.getChangeByKey(rowOptions.key) : null;
                                var validationResult;
                                var validatingController = this.getController("validating");
                                if (validator) {
                                    validatingController.setValidator(validator);
                                    var value = validator.option("adapter").getValue();
                                    if (cellValueShouldBeValidated(value, rowOptions) || validatingController._rowIsValidated(change)) {
                                        editingController.waitForDeferredOperations().done(function() {
                                            (0, _deferred.when)(validatingController.validateCell(validator)).done(function(result) {
                                                validationResult = result;
                                                var column = validationResult.validator.option("dataGetter")().column;
                                                if (change && column && !validatingController.isCurrentValidatorProcessing({
                                                        rowKey: change.key,
                                                        columnIndex: column.index
                                                    })) {
                                                    return
                                                }
                                                if (validationResult.status === VALIDATION_STATUS.invalid) {
                                                    hideBorder = true
                                                }
                                                _this12.updateCellState($element, validationResult, hideBorder);
                                                callBase.call(_this12, $element, hideBorder)
                                            })
                                        });
                                        return this.callBase($element, hideBorder)
                                    }
                                }
                                this.updateCellState($element, validationResult, hideBorder);
                                return this.callBase($element, hideBorder)
                            },
                            getEditorInstance: function($container) {
                                var $editor = $container.find(".dx-texteditor").eq(0);
                                return _uiGrid_core2.default.getWidgetInstance($editor)
                            }
                        }
                    }(),
                    data: {
                        _isCellChanged: function(oldRow, newRow, visibleRowIndex, columnIndex, isLiveUpdate) {
                            var cell = oldRow.cells[columnIndex];
                            var oldValidationStatus = cell && cell.validationStatus;
                            var validatingController = this.getController("validating");
                            var validationResult = validatingController.getCellValidationResult({
                                rowKey: oldRow.key,
                                columnIndex: columnIndex
                            });
                            var validationData = validatingController._getValidationData(oldRow.key);
                            var newValidationStatus = validationResultIsValid(validationResult) ? validationResult.status : validationResult;
                            var rowIsModified = JSON.stringify(newRow.modifiedValues) !== JSON.stringify(oldRow.modifiedValues);
                            var cellIsMarkedAsInvalid = (0, _renderer.default)(null === cell || void 0 === cell ? void 0 : cell.cellElement).hasClass(this.addWidgetPrefix(INVALIDATE_CLASS));
                            if (oldValidationStatus !== newValidationStatus && rowIsModified || validationData.isValid && cellIsMarkedAsInvalid) {
                                return true
                            }
                            return this.callBase.apply(this, arguments)
                        }
                    }
                },
                views: {
                    rowsView: {
                        updateFreeSpaceRowHeight: function($table) {
                            var that = this;
                            var $rowElements;
                            var $freeSpaceRowElement;
                            var $freeSpaceRowElements;
                            var $element = that.element();
                            var $tooltipContent = $element && $element.find("." + that.addWidgetPrefix(WIDGET_INVALID_MESSAGE_CLASS) + " .dx-overlay-content");
                            that.callBase($table);
                            if ($tooltipContent && $tooltipContent.length) {
                                $rowElements = that._getRowElements();
                                $freeSpaceRowElements = that._getFreeSpaceRowElements($table);
                                $freeSpaceRowElement = $freeSpaceRowElements.first();
                                if ($freeSpaceRowElement && 1 === $rowElements.length && (!$freeSpaceRowElement.is(":visible") || $tooltipContent.outerHeight() > $freeSpaceRowElement.outerHeight())) {
                                    $freeSpaceRowElements.show();
                                    $freeSpaceRowElements.height($tooltipContent.outerHeight());
                                    return true
                                }
                            }
                        },
                        _formItemPrepared: function(cellOptions, $container) {
                            var _this13 = this;
                            this.callBase.apply(this, arguments);
                            (0, _common.deferUpdate)(function() {
                                var $editor = $container.find(".dx-widget").first();
                                var isEditorDisposed = $editor.length && !$editor.children().length;
                                if (!isEditorDisposed) {
                                    _this13.getController("validating").createValidator(cellOptions, $editor)
                                }
                            })
                        },
                        _cellPrepared: function($cell, parameters) {
                            if (!this.getController("editing").isFormEditMode()) {
                                this.getController("validating").createValidator(parameters, $cell)
                            }
                            this.callBase.apply(this, arguments)
                        }
                    }
                }
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.virtual_scrolling.js ***!
      \*********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _uiGrid_core = __webpack_require__( /*! ./ui.grid_core.virtual_scrolling_core */ 403);
        var _uiGrid_core2 = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.utils */ 35));
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _translator = __webpack_require__( /*! ../../animation/translator */ 28);
        var _load_indicator = _interopRequireDefault(__webpack_require__( /*! ../load_indicator */ 83));
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));
        var _position = __webpack_require__( /*! ../../core/utils/position */ 22);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var TABLE_CLASS = "table";
        var BOTTOM_LOAD_PANEL_CLASS = "bottom-load-panel";
        var TABLE_CONTENT_CLASS = "table-content";
        var GROUP_SPACE_CLASS = "group-space";
        var CONTENT_CLASS = "content";
        var ROW_CLASS = "dx-row";
        var FREESPACE_CLASS = "dx-freespace-row";
        var COLUMN_LINES_CLASS = "dx-column-lines";
        var VIRTUAL_ROW_CLASS = "dx-virtual-row";
        var SCROLLING_MODE_INFINITE = "infinite";
        var SCROLLING_MODE_VIRTUAL = "virtual";
        var SCROLLING_MODE_STANDARD = "standard";
        var PIXELS_LIMIT = 25e4;
        var LOAD_TIMEOUT = 300;
        var isVirtualMode = function(that) {
            return that.option("scrolling.mode") === SCROLLING_MODE_VIRTUAL
        };
        var isAppendMode = function(that) {
            return that.option("scrolling.mode") === SCROLLING_MODE_INFINITE
        };
        var isVirtualRowRendering = function(that) {
            var rowRenderingMode = that.option("scrolling.rowRenderingMode");
            if (rowRenderingMode === SCROLLING_MODE_VIRTUAL) {
                return true
            } else {
                if (rowRenderingMode === SCROLLING_MODE_STANDARD) {
                    return false
                }
            }
        };
        var _correctCount = function(items, count, fromEnd, isItemCountableFunc) {
            for (var i = 0; i < count + 1; i++) {
                var item = items[fromEnd ? items.length - 1 - i : i];
                if (item && !isItemCountableFunc(item, i === count, fromEnd)) {
                    count++
                }
            }
            return count
        };
        var isItemCountableByDataSource = function(item, dataSource) {
            return "data" === item.rowType && !item.isNewRow || "group" === item.rowType && dataSource.isGroupItemCountable(item.data)
        };
        var VirtualScrollingDataSourceAdapterExtender = function() {
            var _updateLoading = function(that) {
                var beginPageIndex = that._virtualScrollController.beginPageIndex(-1);
                if (isVirtualMode(that)) {
                    if (beginPageIndex < 0 || that.viewportSize() >= 0 && that.getViewportItemIndex() >= 0 && (beginPageIndex * that.pageSize() > that.getViewportItemIndex() || beginPageIndex * that.pageSize() + that.itemsCount() < that.getViewportItemIndex() + that.viewportSize()) && that._dataSource.isLoading()) {
                        if (!that._isLoading) {
                            that._isLoading = true;
                            that.loadingChanged.fire(true)
                        }
                    } else {
                        if (that._isLoading) {
                            that._isLoading = false;
                            that.loadingChanged.fire(false)
                        }
                    }
                }
            };
            var result = {
                init: function(dataSource) {
                    var that = this;
                    that.callBase.apply(that, arguments);
                    that._items = [];
                    that._isLoaded = true;
                    that._virtualScrollController = new _uiGrid_core.VirtualScrollController(that.component, {
                        pageSize: function() {
                            return that.pageSize()
                        },
                        totalItemsCount: function() {
                            return that.totalItemsCount()
                        },
                        hasKnownLastPage: function() {
                            return that.hasKnownLastPage()
                        },
                        pageIndex: function(index) {
                            return dataSource.pageIndex(index)
                        },
                        isLoading: function() {
                            return dataSource.isLoading() && !that.isCustomLoading()
                        },
                        pageCount: function() {
                            return that.pageCount()
                        },
                        load: function() {
                            return dataSource.load()
                        },
                        updateLoading: function() {
                            _updateLoading(that)
                        },
                        itemsCount: function() {
                            return that.itemsCount(true)
                        },
                        items: function() {
                            return dataSource.items()
                        },
                        viewportItems: function(items) {
                            if (items) {
                                that._items = items
                            }
                            return that._items
                        },
                        onChanged: function(e) {
                            that.changed.fire(e)
                        },
                        changingDuration: function(e) {
                            if (that.isLoading()) {
                                return LOAD_TIMEOUT
                            }
                            return that._renderTime || 0
                        }
                    })
                },
                _handleLoadingChanged: function(isLoading) {
                    if (!isVirtualMode(this) || this._isLoadingAll) {
                        this._isLoading = isLoading;
                        this.callBase.apply(this, arguments)
                    }
                    if (isLoading) {
                        this._startLoadTime = new Date
                    } else {
                        this._startLoadTime = void 0
                    }
                },
                _handleLoadError: function() {
                    var that = this;
                    that._isLoading = false;
                    that.loadingChanged.fire(false);
                    that.callBase.apply(that, arguments)
                },
                _handleDataChanged: function(e) {
                    var callBase = this.callBase.bind(this);
                    this._virtualScrollController.handleDataChanged(callBase, e)
                },
                _customizeRemoteOperations: function(options, operationTypes) {
                    var that = this;
                    if (!that.option("legacyRendering") && isVirtualMode(that) && !operationTypes.reload && operationTypes.skip && that._renderTime < that.option("scrolling.renderingThreshold")) {
                        options.delay = void 0
                    }
                    that.callBase.apply(that, arguments)
                },
                items: function() {
                    return this._items
                },
                itemsCount: function(isBase) {
                    if (isBase) {
                        return this.callBase()
                    }
                    return this._virtualScrollController.itemsCount()
                },
                load: function(loadOptions) {
                    if (loadOptions) {
                        return this.callBase(loadOptions)
                    }
                    return this._virtualScrollController.load()
                },
                isLoading: function() {
                    return this._isLoading
                },
                isLoaded: function() {
                    return this._dataSource.isLoaded() && this._isLoaded
                },
                resetPagesCache: function(isLiveUpdate) {
                    if (!isLiveUpdate) {
                        this._virtualScrollController.reset(true)
                    }
                    this.callBase.apply(this, arguments)
                },
                _changeRowExpandCore: function() {
                    var result = this.callBase.apply(this, arguments);
                    this.resetPagesCache();
                    _updateLoading(this);
                    return result
                },
                reload: function() {
                    this._dataSource.pageIndex(this.pageIndex());
                    var virtualScrollController = this._virtualScrollController;
                    if (virtualScrollController) {
                        var d = new _deferred.Deferred;
                        this.callBase.apply(this, arguments).done(function(r) {
                            var delayDeferred = virtualScrollController._delayDeferred;
                            if (delayDeferred) {
                                delayDeferred.done(d.resolve).fail(d.reject)
                            } else {
                                d.resolve(r)
                            }
                        }).fail(d.reject);
                        return d
                    } else {
                        return this.callBase.apply(this, arguments)
                    }
                },
                refresh: function(options, operationTypes) {
                    var that = this;
                    var storeLoadOptions = options.storeLoadOptions;
                    var dataSource = that._dataSource;
                    if (operationTypes.reload) {
                        that._virtualScrollController.reset();
                        dataSource.items().length = 0;
                        that._isLoaded = false;
                        _updateLoading(that);
                        that._isLoaded = true;
                        if (isAppendMode(that)) {
                            that.pageIndex(0);
                            dataSource.pageIndex(0);
                            storeLoadOptions.pageIndex = 0;
                            options.pageIndex = 0;
                            storeLoadOptions.skip = 0
                        } else {
                            dataSource.pageIndex(that.pageIndex());
                            if (dataSource.paginate()) {
                                options.pageIndex = that.pageIndex();
                                storeLoadOptions.skip = that.pageIndex() * that.pageSize()
                            }
                        }
                    } else {
                        if (isAppendMode(that) && storeLoadOptions.skip && that._skipCorrection < 0) {
                            storeLoadOptions.skip += that._skipCorrection
                        }
                    }
                    return that.callBase.apply(that, arguments)
                },
                dispose: function() {
                    this._virtualScrollController.dispose();
                    this.callBase.apply(this, arguments)
                }
            };
            ["virtualItemsCount", "getContentOffset", "getVirtualContentSize", "setContentSize", "setViewportPosition", "getViewportItemIndex", "setViewportItemIndex", "getItemIndexByPosition", "viewportSize", "viewportItemSize", "getItemSize", "getItemSizes", "pageIndex", "beginPageIndex", "endPageIndex", "loadIfNeed"].forEach(function(name) {
                result[name] = function() {
                    var virtualScrollController = this._virtualScrollController;
                    return virtualScrollController[name].apply(virtualScrollController, arguments)
                }
            });
            return result
        }();
        var VirtualScrollingRowsViewExtender = function() {
            var removeEmptyRows = function($emptyRows, className) {
                var getRowParent = function(row) {
                    return (0, _renderer.default)(row).parent("." + className).get(0)
                };
                var tBodies = $emptyRows.toArray().map(getRowParent).filter(function(row) {
                    return row
                });
                if (tBodies.length) {
                    $emptyRows = (0, _renderer.default)(tBodies)
                }
                var rowCount = className === FREESPACE_CLASS ? $emptyRows.length - 1 : $emptyRows.length;
                for (var i = 0; i < rowCount; i++) {
                    $emptyRows.eq(i).remove()
                }
            };
            return {
                init: function() {
                    var _dataController$state, _this = this;
                    var dataController = this.getController("data");
                    this.callBase();
                    dataController.pageChanged.add(function() {
                        _this.scrollToPage(dataController.pageIndex())
                    });
                    dataController.dataSourceChanged.add(function() {
                        !_this._scrollTop && _this._scrollToCurrentPageOnResize()
                    });
                    null === (_dataController$state = dataController.stateLoaded) || void 0 === _dataController$state ? void 0 : _dataController$state.add(function() {
                        _this._scrollToCurrentPageOnResize()
                    });
                    this._scrollToCurrentPageOnResize()
                },
                _scrollToCurrentPageOnResize: function() {
                    var _this2 = this;
                    var dataController = this.getController("data");
                    if (!this.option("legacyRendering") && dataController.pageIndex() > 0) {
                        var resizeHandler = function resizeHandler() {
                            _this2.resizeCompleted.remove(resizeHandler);
                            _this2.scrollToPage(dataController.pageIndex())
                        };
                        this.resizeCompleted.add(resizeHandler)
                    }
                },
                scrollToPage: function(pageIndex) {
                    var that = this;
                    var dataController = that._dataController;
                    var pageSize = dataController ? dataController.pageSize() : 0;
                    var scrollPosition;
                    if (isVirtualMode(that) || isAppendMode(that)) {
                        var itemSize = dataController.getItemSize();
                        var itemSizes = dataController.getItemSizes();
                        var itemIndex = pageIndex * pageSize;
                        scrollPosition = itemIndex * itemSize;
                        for (var index in itemSizes) {
                            if (index < itemIndex) {
                                scrollPosition += itemSizes[index] - itemSize
                            }
                        }
                    } else {
                        scrollPosition = 0
                    }
                    that.scrollTo({
                        y: scrollPosition,
                        x: that._scrollLeft
                    })
                },
                renderDelayedTemplates: function(e) {
                    this._updateContentPosition(true);
                    this.callBase.apply(this, arguments)
                },
                _renderCore: function(e) {
                    var that = this;
                    var startRenderTime = new Date;
                    that.callBase.apply(that, arguments);
                    var dataSource = that._dataController._dataSource;
                    if (dataSource && e) {
                        var itemCount = e.items ? e.items.length : 20;
                        var viewportSize = that._dataController.viewportSize() || 20;
                        if (isVirtualRowRendering(that)) {
                            dataSource._renderTime = (new Date - startRenderTime) * viewportSize / itemCount
                        } else {
                            dataSource._renderTime = new Date - startRenderTime
                        }
                    }
                },
                _getRowElements: function(tableElement) {
                    var $rows = this.callBase(tableElement);
                    return $rows && $rows.not("." + VIRTUAL_ROW_CLASS)
                },
                _renderContent: function(contentElement, tableElement) {
                    var that = this;
                    var virtualItemsCount = that._dataController.virtualItemsCount();
                    if (virtualItemsCount && that.option("legacyRendering")) {
                        if ((0, _window.hasWindow)()) {
                            tableElement.addClass(that.addWidgetPrefix(TABLE_CONTENT_CLASS))
                        }
                        if (!contentElement.children().length) {
                            contentElement.append(tableElement)
                        } else {
                            contentElement.children().first().replaceWith(tableElement)
                        }
                        if (1 === contentElement.children("table").length) {
                            contentElement.append(that._createTable());
                            that._contentHeight = 0
                        }
                        return contentElement
                    }
                    return that.callBase.apply(that, arguments)
                },
                _removeRowsElements: function(contentTable, removeCount, changeType) {
                    var rowElements = this._getRowElements(contentTable).toArray();
                    if ("append" === changeType) {
                        rowElements = rowElements.slice(0, removeCount)
                    } else {
                        rowElements = rowElements.slice(-removeCount)
                    }
                    var errorHandlingController = this.getController("errorHandling");
                    rowElements.map(function(rowElement) {
                        var $rowElement = (0, _renderer.default)(rowElement);
                        errorHandlingController && errorHandlingController.removeErrorRow($rowElement.next());
                        $rowElement.remove()
                    })
                },
                _restoreErrorRow: function(contentTable) {
                    var editingController = this.getController("editing");
                    editingController && editingController.hasChanges() && this._getRowElements(contentTable).each(function(_, item) {
                        var rowOptions = (0, _renderer.default)(item).data("options");
                        if (rowOptions) {
                            var change = editingController.getChangeByKey(rowOptions.key);
                            change && editingController._showErrorRow(change)
                        }
                    })
                },
                _updateContent: function(tableElement, change) {
                    var that = this;
                    var $freeSpaceRowElements;
                    var contentElement = that._findContentElement();
                    var changeType = change && change.changeType;
                    if ("append" === changeType || "prepend" === changeType) {
                        var contentTable = contentElement.children().first();
                        var $tBodies = that._getBodies(tableElement);
                        if (!that.option("legacyRendering") && 1 === $tBodies.length) {
                            that._getBodies(contentTable)["append" === changeType ? "append" : "prepend"]($tBodies.children())
                        } else {
                            $tBodies["append" === changeType ? "appendTo" : "prependTo"](contentTable)
                        }
                        tableElement.remove();
                        $freeSpaceRowElements = that._getFreeSpaceRowElements(contentTable);
                        removeEmptyRows($freeSpaceRowElements, FREESPACE_CLASS);
                        if (change.removeCount) {
                            that._removeRowsElements(contentTable, change.removeCount, changeType)
                        }
                        that._restoreErrorRow(contentTable)
                    } else {
                        that.callBase.apply(that, arguments)
                    }
                    that._updateBottomLoading()
                },
                _addVirtualRow: function($table, isFixed, location, position) {
                    if (!position) {
                        return
                    }
                    var $virtualRow = this._createEmptyRow(VIRTUAL_ROW_CLASS, isFixed, position);
                    $virtualRow = this._wrapRowIfNeed($table, $virtualRow);
                    this._appendEmptyRow($table, $virtualRow, location)
                },
                _getRowHeights: function() {
                    var rowHeights = this._getRowElements(this._tableElement).toArray().map(function(row) {
                        return (0, _position.getBoundingRect)(row).height
                    });
                    return rowHeights
                },
                _correctRowHeights: function(rowHeights) {
                    var dataController = this._dataController;
                    var dataSource = dataController._dataSource;
                    var correctedRowHeights = [];
                    var visibleRows = dataController.getVisibleRows();
                    var itemSize = 0;
                    var firstCountableItem = true;
                    for (var i = 0; i < rowHeights.length; i++) {
                        var currentItem = visibleRows[i];
                        if (!(0, _type.isDefined)(currentItem)) {
                            continue
                        }
                        if (isItemCountableByDataSource(currentItem, dataSource)) {
                            if (firstCountableItem) {
                                firstCountableItem = false
                            } else {
                                correctedRowHeights.push(itemSize);
                                itemSize = 0
                            }
                        }
                        itemSize += rowHeights[i]
                    }
                    itemSize > 0 && correctedRowHeights.push(itemSize);
                    return correctedRowHeights
                },
                _updateContentPosition: function(isRender) {
                    var that = this;
                    var dataController = that._dataController;
                    var rowHeight = that._rowHeight || 20;
                    dataController.viewportItemSize(rowHeight);
                    if (!that.option("legacyRendering") && (isVirtualMode(that) || isVirtualRowRendering(that))) {
                        if (!isRender) {
                            var rowHeights = that._getRowHeights();
                            var correctedRowHeights = that._correctRowHeights(rowHeights);
                            dataController.setContentSize(correctedRowHeights)
                        }
                        var top = dataController.getContentOffset("begin");
                        var bottom = dataController.getContentOffset("end");
                        var $tables = that.getTableElements();
                        var $virtualRows = $tables.children("tbody").children("." + VIRTUAL_ROW_CLASS);
                        removeEmptyRows($virtualRows, VIRTUAL_ROW_CLASS);
                        $tables.each(function(index) {
                            var isFixed = index > 0;
                            that._isFixedTableRendering = isFixed;
                            that._addVirtualRow((0, _renderer.default)(this), isFixed, "top", top);
                            that._addVirtualRow((0, _renderer.default)(this), isFixed, "bottom", bottom);
                            that._isFixedTableRendering = false
                        })
                    } else {
                        (0, _common.deferUpdate)(function() {
                            that._updateContentPositionCore()
                        })
                    }
                },
                _updateContentPositionCore: function() {
                    var that = this;
                    var contentHeight;
                    var $tables;
                    var $contentTable;
                    var rowHeight = that._rowHeight || 20;
                    var virtualItemsCount = that._dataController.virtualItemsCount();
                    if (virtualItemsCount) {
                        var contentElement = that._findContentElement();
                        $tables = contentElement.children();
                        $contentTable = $tables.eq(0);
                        var virtualTable = $tables.eq(1);
                        that._contentTableHeight = $contentTable[0].offsetHeight;
                        that._dataController.viewportItemSize(rowHeight);
                        that._dataController.setContentSize(that._contentTableHeight);
                        contentHeight = that._dataController.getVirtualContentSize();
                        var top = that._dataController.getContentOffset();
                        (0, _common.deferRender)(function() {
                            (0, _translator.move)($contentTable, {
                                left: 0,
                                top: top
                            });
                            var isRenderVirtualTableContentRequired = that._contentHeight !== contentHeight || 0 === contentHeight || !that._isTableLinesDisplaysCorrect(virtualTable) || !that._isColumnElementsEqual($contentTable.find("col"), virtualTable.find("col"));
                            if (isRenderVirtualTableContentRequired) {
                                that._contentHeight = contentHeight;
                                that._renderVirtualTableContent(virtualTable, contentHeight)
                            }
                        })
                    }
                },
                _isTableLinesDisplaysCorrect: function(table) {
                    var hasColumnLines = table.find("." + COLUMN_LINES_CLASS).length > 0;
                    return hasColumnLines === this.option("showColumnLines")
                },
                _isColumnElementsEqual: function($columns, $virtualColumns) {
                    var result = $columns.length === $virtualColumns.length;
                    if (result) {
                        (0, _iterator.each)($columns, function(index, element) {
                            if (element.style.width !== $virtualColumns[index].style.width) {
                                result = false;
                                return result
                            }
                        })
                    }
                    return result
                },
                _renderVirtualTableContent: function(container, height) {
                    var that = this;
                    var columns = that._columnsController.getVisibleColumns();
                    var html = that._createColGroup(columns).prop("outerHTML");
                    var freeSpaceCellsHtml = "";
                    var columnLinesClass = that.option("showColumnLines") ? COLUMN_LINES_CLASS : "";
                    var createFreeSpaceRowHtml = function(height) {
                        return "<tr style='height:" + height + "px;' class='" + FREESPACE_CLASS + " " + ROW_CLASS + " " + columnLinesClass + "' >" + freeSpaceCellsHtml + "</tr>"
                    };
                    for (var i = 0; i < columns.length; i++) {
                        var classes = that._getCellClasses(columns[i]);
                        var classString = classes.length ? " class='" + classes.join(" ") + "'" : "";
                        freeSpaceCellsHtml += "<td" + classString + "/>"
                    }
                    while (height > PIXELS_LIMIT) {
                        html += createFreeSpaceRowHtml(PIXELS_LIMIT);
                        height -= PIXELS_LIMIT
                    }
                    html += createFreeSpaceRowHtml(height);
                    container.addClass(that.addWidgetPrefix(TABLE_CLASS));
                    container.html(html)
                },
                _getCellClasses: function(column) {
                    var classes = [];
                    var cssClass = column.cssClass;
                    var isExpandColumn = "expand" === column.command;
                    cssClass && classes.push(cssClass);
                    isExpandColumn && classes.push(this.addWidgetPrefix(GROUP_SPACE_CLASS));
                    return classes
                },
                _findBottomLoadPanel: function($contentElement) {
                    var $element = $contentElement || this.element();
                    var $bottomLoadPanel = $element && $element.find("." + this.addWidgetPrefix(BOTTOM_LOAD_PANEL_CLASS));
                    if ($bottomLoadPanel && $bottomLoadPanel.length) {
                        return $bottomLoadPanel
                    }
                },
                _updateBottomLoading: function() {
                    var that = this;
                    var scrollingMode = that.option("scrolling.mode");
                    var virtualMode = scrollingMode === SCROLLING_MODE_VIRTUAL;
                    var appendMode = scrollingMode === SCROLLING_MODE_INFINITE;
                    var showBottomLoading = !that._dataController.hasKnownLastPage() && that._dataController.isLoaded() && (virtualMode || appendMode);
                    var $contentElement = that._findContentElement();
                    var bottomLoadPanelElement = that._findBottomLoadPanel($contentElement);
                    if (showBottomLoading) {
                        if (!bottomLoadPanelElement) {
                            (0, _renderer.default)("<div>").addClass(that.addWidgetPrefix(BOTTOM_LOAD_PANEL_CLASS)).append(that._createComponent((0, _renderer.default)("<div>"), _load_indicator.default).$element()).appendTo($contentElement)
                        }
                    } else {
                        if (bottomLoadPanelElement) {
                            bottomLoadPanelElement.remove()
                        }
                    }
                },
                _handleScroll: function(e) {
                    var that = this;
                    if (that._hasHeight && that._rowHeight) {
                        that._dataController.setViewportPosition(e.scrollOffset.top)
                    }
                    that.callBase.apply(that, arguments)
                },
                _needUpdateRowHeight: function(itemsCount) {
                    var that = this;
                    return that.callBase.apply(that, arguments) || itemsCount > 0 && that.option("scrolling.mode") === SCROLLING_MODE_INFINITE && that.option("scrolling.rowRenderingMode") !== SCROLLING_MODE_VIRTUAL
                },
                _updateRowHeight: function() {
                    var that = this;
                    that.callBase.apply(that, arguments);
                    if (that._rowHeight) {
                        that._updateContentPosition();
                        var viewportHeight = that._hasHeight ? that.element().outerHeight() : (0, _renderer.default)((0, _window.getWindow)()).outerHeight();
                        that._dataController.viewportSize(Math.ceil(viewportHeight / that._rowHeight))
                    }
                },
                updateFreeSpaceRowHeight: function() {
                    var result = this.callBase.apply(this, arguments);
                    if (result) {
                        this._updateContentPosition()
                    }
                    return result
                },
                setLoading: function(isLoading, messageText) {
                    var that = this;
                    var callBase = that.callBase;
                    var dataController = that._dataController;
                    var hasBottomLoadPanel = dataController.pageIndex() > 0 && dataController.isLoaded() && !!that._findBottomLoadPanel();
                    if (hasBottomLoadPanel) {
                        isLoading = false
                    }
                    callBase.call(that, isLoading, messageText)
                },
                _resizeCore: function() {
                    var that = this;
                    var $element = that.element();
                    that.callBase();
                    if (that.component.$element() && !that._windowScroll && $element.closest((0, _window.getWindow)().document).length) {
                        that._windowScroll = (0, _uiGrid_core.subscribeToExternalScrollers)($element, function(scrollPos) {
                            if (!that._hasHeight && that._rowHeight) {
                                that._dataController.setViewportPosition(scrollPos)
                            }
                        }, that.component.$element());
                        that.on("disposing", function() {
                            that._windowScroll.dispose()
                        })
                    }
                    that.loadIfNeed()
                },
                loadIfNeed: function() {
                    var dataController = this._dataController;
                    if (dataController && dataController.loadIfNeed) {
                        dataController.loadIfNeed()
                    }
                },
                setColumnWidths: function(widths) {
                    var scrollable = this.getScrollable();
                    var $content;
                    this.callBase.apply(this, arguments);
                    if ("virtual" === this.option("scrolling.mode")) {
                        $content = scrollable ? scrollable.$content() : this.element();
                        this.callBase(widths, $content.children("." + this.addWidgetPrefix(CONTENT_CLASS)).children(":not(." + this.addWidgetPrefix(TABLE_CONTENT_CLASS) + ")"))
                    }
                },
                dispose: function() {
                    clearTimeout(this._scrollTimeoutID);
                    this.callBase()
                }
            }
        }();
        var _default = {
            defaultOptions: function() {
                return {
                    scrolling: {
                        timeout: 300,
                        updateTimeout: 300,
                        minTimeout: 0,
                        renderingThreshold: 100,
                        removeInvisiblePages: true,
                        rowPageSize: 5,
                        mode: "standard",
                        preloadEnabled: false,
                        rowRenderingMode: "standard",
                        loadTwoPagesOnStart: false
                    }
                }
            },
            extenders: {
                dataSourceAdapter: VirtualScrollingDataSourceAdapterExtender,
                controllers: {
                    data: function() {
                        var members = {
                            _refreshDataSource: function() {
                                var baseResult = this.callBase.apply(this, arguments) || (new _deferred.Deferred).resolve().promise();
                                baseResult.done(this.initVirtualRows.bind(this));
                                return baseResult
                            },
                            getRowPageSize: function() {
                                var rowPageSize = this.option("scrolling.rowPageSize");
                                var pageSize = this.pageSize();
                                return pageSize && pageSize < rowPageSize ? pageSize : rowPageSize
                            },
                            reload: function() {
                                var that = this;
                                var rowsScrollController = that._rowsScrollController || that._dataSource;
                                var itemIndex = rowsScrollController && rowsScrollController.getItemIndexByPosition();
                                var result = this.callBase.apply(this, arguments);
                                return result && result.done(function() {
                                    if (isVirtualMode(that) || isVirtualRowRendering(that)) {
                                        var rowIndexOffset = that.getRowIndexOffset();
                                        var rowIndex = Math.floor(itemIndex) - rowIndexOffset;
                                        var component = that.component;
                                        var scrollable = component.getScrollable && component.getScrollable();
                                        var isSortingOperation = that.dataSource().operationTypes().sorting;
                                        if (scrollable && !that.option("legacyRendering") && !isSortingOperation) {
                                            var rowElement = component.getRowElement(rowIndex);
                                            var $rowElement = rowElement && rowElement[0] && (0, _renderer.default)(rowElement[0]);
                                            var top = $rowElement && $rowElement.position().top;
                                            var allowedTopOffset = _browser.default.mozilla || _browser.default.msie ? 1 : 0;
                                            if (top > allowedTopOffset) {
                                                top = Math.round(top + $rowElement.outerHeight() * (itemIndex % 1));
                                                scrollable.scrollTo({
                                                    y: top
                                                })
                                            }
                                        }
                                    }
                                })
                            },
                            initVirtualRows: function() {
                                var that = this;
                                var virtualRowsRendering = isVirtualRowRendering(that);
                                if ("virtual" !== that.option("scrolling.mode") && true !== virtualRowsRendering || false === virtualRowsRendering || that.option("legacyRendering") || !that.option("scrolling.rowPageSize")) {
                                    that._visibleItems = null;
                                    that._rowsScrollController = null;
                                    return
                                }
                                var pageIndex = !isVirtualMode(this) && that.pageIndex() >= that.pageCount() ? that.pageCount() - 1 : that.pageIndex();
                                that._rowPageIndex = Math.ceil(pageIndex * that.pageSize() / that.getRowPageSize());
                                that._visibleItems = [];
                                var isItemCountable = function(item) {
                                    return isItemCountableByDataSource(item, that._dataSource)
                                };
                                that._rowsScrollController = new _uiGrid_core.VirtualScrollController(that.component, {
                                    pageSize: function() {
                                        return that.getRowPageSize()
                                    },
                                    totalItemsCount: function() {
                                        return isVirtualMode(that) ? that.totalItemsCount() : that._items.filter(isItemCountable).length
                                    },
                                    hasKnownLastPage: function() {
                                        return true
                                    },
                                    pageIndex: function(index) {
                                        if (void 0 !== index) {
                                            that._rowPageIndex = index
                                        }
                                        return that._rowPageIndex
                                    },
                                    isLoading: function() {
                                        return that.isLoading()
                                    },
                                    pageCount: function pageCount() {
                                        var pageCount = Math.ceil(this.totalItemsCount() / this.pageSize());
                                        return pageCount ? pageCount : 1
                                    },
                                    load: function() {
                                        if (that._rowsScrollController.pageIndex() >= this.pageCount()) {
                                            that._rowPageIndex = this.pageCount() - 1;
                                            that._rowsScrollController.pageIndex(that._rowPageIndex)
                                        }
                                        if (!that._rowsScrollController._dataSource.items().length && this.totalItemsCount()) {
                                            return
                                        }
                                        that._rowsScrollController.handleDataChanged(function(change) {
                                            change = change || {};
                                            change.changeType = change.changeType || "refresh";
                                            change.items = change.items || that._visibleItems;
                                            that._visibleItems.forEach(function(item, index) {
                                                item.rowIndex = index
                                            });
                                            that._fireChanged(change)
                                        })
                                    },
                                    updateLoading: function() {},
                                    itemsCount: function() {
                                        return that._rowsScrollController._dataSource.items().filter(isItemCountable).length
                                    },
                                    correctCount: function(items, count, fromEnd) {
                                        return _correctCount(items, count, fromEnd, function(item, isNextAfterLast, fromEnd) {
                                            if (item.isNewRow) {
                                                return isNextAfterLast && !fromEnd
                                            }
                                            if (isNextAfterLast && fromEnd) {
                                                return !item.isNewRow
                                            }
                                            return isItemCountable(item)
                                        })
                                    },
                                    items: function(countableOnly) {
                                        var dataSource = that.dataSource();
                                        var virtualItemsCount = dataSource && dataSource.virtualItemsCount();
                                        var begin = virtualItemsCount ? virtualItemsCount.begin : 0;
                                        var rowPageSize = that.getRowPageSize();
                                        var skip = that._rowPageIndex * rowPageSize - begin;
                                        var take = rowPageSize;
                                        var result = that._items;
                                        if (skip < 0) {
                                            return []
                                        }
                                        if (skip) {
                                            skip = this.correctCount(result, skip);
                                            result = result.slice(skip)
                                        }
                                        if (take) {
                                            take = this.correctCount(result, take);
                                            result = result.slice(0, take)
                                        }
                                        return countableOnly ? result.filter(isItemCountable) : result
                                    },
                                    viewportItems: function(items) {
                                        if (items) {
                                            that._visibleItems = items
                                        }
                                        return that._visibleItems
                                    },
                                    onChanged: function() {},
                                    changingDuration: function(e) {
                                        var dataSource = that.dataSource();
                                        if (dataSource.isLoading()) {
                                            return LOAD_TIMEOUT
                                        }
                                        return (null === dataSource || void 0 === dataSource ? void 0 : dataSource._renderTime) || 0
                                    }
                                }, true);
                                that._rowsScrollController.positionChanged.add(function() {
                                    var _that$_dataSource;
                                    null === (_that$_dataSource = that._dataSource) || void 0 === _that$_dataSource ? void 0 : _that$_dataSource.setViewportItemIndex(that._rowsScrollController.getViewportItemIndex())
                                });
                                if (that.isLoaded()) {
                                    that._rowsScrollController.load()
                                }
                            },
                            _updateItemsCore: function(change) {
                                var _this3 = this;
                                var delta = this.getRowIndexDelta();
                                this.callBase.apply(this, arguments);
                                var rowsScrollController = this._rowsScrollController;
                                if (rowsScrollController) {
                                    var visibleItems = this._visibleItems;
                                    var isRefresh = "refresh" === change.changeType || change.isLiveUpdate;
                                    if ("append" === change.changeType && change.items && !change.items.length) {
                                        return
                                    }
                                    if (isRefresh || "append" === change.changeType || "prepend" === change.changeType) {
                                        change.cancel = true;
                                        isRefresh && rowsScrollController.reset(true);
                                        rowsScrollController.load()
                                    } else {
                                        if ("update" === change.changeType) {
                                            change.rowIndices.forEach(function(rowIndex, index) {
                                                var changeType = change.changeTypes[index];
                                                var newItem = change.items[index];
                                                if ("update" === changeType) {
                                                    visibleItems[rowIndex] = newItem
                                                } else {
                                                    if ("insert" === changeType) {
                                                        visibleItems.splice(rowIndex, 0, newItem)
                                                    } else {
                                                        if ("remove" === changeType) {
                                                            visibleItems.splice(rowIndex, 1)
                                                        }
                                                    }
                                                }
                                            })
                                        } else {
                                            visibleItems.forEach(function(item, index) {
                                                visibleItems[index] = _this3._items[index + delta] || visibleItems[index]
                                            });
                                            change.items = visibleItems
                                        }
                                        visibleItems.forEach(function(item, index) {
                                            item.rowIndex = index
                                        })
                                    }
                                }
                            },
                            _applyChange: function(change) {
                                var that = this;
                                var items = change.items;
                                var changeType = change.changeType;
                                var removeCount = change.removeCount;
                                if (removeCount) {
                                    var fromEnd = "prepend" === changeType;
                                    removeCount = _correctCount(that._items, removeCount, fromEnd, function(item, isNextAfterLast) {
                                        return "data" === item.rowType && !item.isNewRow || "group" === item.rowType && (that._dataSource.isGroupItemCountable(item.data) || isNextAfterLast)
                                    });
                                    change.removeCount = removeCount
                                }
                                switch (changeType) {
                                    case "prepend":
                                        that._items.unshift.apply(that._items, items);
                                        if (removeCount) {
                                            that._items.splice(-removeCount)
                                        }
                                        break;
                                    case "append":
                                        that._items.push.apply(that._items, items);
                                        if (removeCount) {
                                            that._items.splice(0, removeCount)
                                        }
                                        break;
                                    default:
                                        that.callBase(change)
                                }
                            },
                            items: function(allItems) {
                                return allItems ? this._items : this._visibleItems || this._items
                            },
                            getRowIndexDelta: function() {
                                var visibleItems = this._visibleItems;
                                var delta = 0;
                                if (visibleItems && visibleItems[0]) {
                                    delta = this._items.indexOf(visibleItems[0])
                                }
                                return delta < 0 ? 0 : delta
                            },
                            getRowIndexOffset: function(byLoadedRows) {
                                var offset = 0;
                                var dataSource = this.dataSource();
                                var rowsScrollController = this._rowsScrollController;
                                if (rowsScrollController && !byLoadedRows) {
                                    offset = rowsScrollController.beginPageIndex() * rowsScrollController._dataSource.pageSize()
                                } else {
                                    if ("virtual" === this.option("scrolling.mode") && dataSource) {
                                        offset = dataSource.beginPageIndex() * dataSource.pageSize()
                                    }
                                }
                                return offset
                            },
                            viewportSize: function() {
                                var rowsScrollController = this._rowsScrollController;
                                rowsScrollController && rowsScrollController.viewportSize.apply(rowsScrollController, arguments);
                                var dataSource = this._dataSource;
                                return dataSource && dataSource.viewportSize.apply(dataSource, arguments)
                            },
                            viewportItemSize: function() {
                                var rowsScrollController = this._rowsScrollController;
                                rowsScrollController && rowsScrollController.viewportItemSize.apply(rowsScrollController, arguments);
                                var dataSource = this._dataSource;
                                return dataSource && dataSource.viewportItemSize.apply(dataSource, arguments)
                            },
                            setViewportPosition: function() {
                                var rowsScrollController = this._rowsScrollController;
                                var dataSource = this._dataSource;
                                if (rowsScrollController) {
                                    rowsScrollController.setViewportPosition.apply(rowsScrollController, arguments)
                                } else {
                                    null === dataSource || void 0 === dataSource ? void 0 : dataSource.setViewportPosition.apply(dataSource, arguments)
                                }
                            },
                            setContentSize: function(sizes) {
                                var rowsScrollController = this._rowsScrollController;
                                rowsScrollController && rowsScrollController.setContentSize(sizes);
                                var dataSource = this._dataSource;
                                return dataSource && dataSource.setContentSize(sizes)
                            },
                            loadIfNeed: function() {
                                var rowsScrollController = this._rowsScrollController;
                                rowsScrollController && rowsScrollController.loadIfNeed();
                                var dataSource = this._dataSource;
                                return dataSource && dataSource.loadIfNeed()
                            },
                            getItemSize: function() {
                                var rowsScrollController = this._rowsScrollController;
                                if (rowsScrollController) {
                                    return rowsScrollController.getItemSize.apply(rowsScrollController, arguments)
                                }
                                var dataSource = this._dataSource;
                                return dataSource && dataSource.getItemSize.apply(dataSource, arguments)
                            },
                            getItemSizes: function() {
                                var rowsScrollController = this._rowsScrollController;
                                if (rowsScrollController) {
                                    return rowsScrollController.getItemSizes.apply(rowsScrollController, arguments)
                                }
                                var dataSource = this._dataSource;
                                return dataSource && dataSource.getItemSizes.apply(dataSource, arguments)
                            },
                            getContentOffset: function() {
                                var rowsScrollController = this._rowsScrollController;
                                if (rowsScrollController) {
                                    return rowsScrollController.getContentOffset.apply(rowsScrollController, arguments)
                                }
                                var dataSource = this._dataSource;
                                return dataSource && dataSource.getContentOffset.apply(dataSource, arguments)
                            },
                            refresh: function(options) {
                                var dataSource = this._dataSource;
                                if (dataSource && options && options.load && isAppendMode(this)) {
                                    dataSource.resetCurrentTotalCount()
                                }
                                return this.callBase.apply(this, arguments)
                            },
                            dispose: function() {
                                var rowsScrollController = this._rowsScrollController;
                                rowsScrollController && rowsScrollController.dispose();
                                this.callBase.apply(this, arguments)
                            }
                        };
                        _uiGrid_core2.default.proxyMethod(members, "virtualItemsCount");
                        _uiGrid_core2.default.proxyMethod(members, "getVirtualContentSize");
                        _uiGrid_core2.default.proxyMethod(members, "setViewportItemIndex");
                        return members
                    }(),
                    resizing: {
                        resize: function() {
                            var that = this;
                            var callBase = that.callBase;
                            var result;
                            if (!that.option("legacyRendering") && (isVirtualMode(that) || isVirtualRowRendering(that))) {
                                clearTimeout(that._resizeTimeout);
                                var diff = new Date - that._lastTime;
                                var updateTimeout = that.option("scrolling.updateTimeout");
                                if (that._lastTime && diff < updateTimeout) {
                                    result = new _deferred.Deferred;
                                    that._resizeTimeout = setTimeout(function() {
                                        callBase.apply(that).done(result.resolve).fail(result.reject);
                                        that._lastTime = new Date
                                    }, updateTimeout);
                                    that._lastTime = new Date
                                } else {
                                    result = callBase.apply(that);
                                    if (that._dataController.isLoaded()) {
                                        that._lastTime = new Date
                                    }
                                }
                            } else {
                                result = callBase.apply(that)
                            }
                            return result
                        },
                        dispose: function() {
                            this.callBase.apply(this, arguments);
                            clearTimeout(this._resizeTimeout)
                        }
                    }
                },
                views: {
                    rowsView: VirtualScrollingRowsViewExtender
                }
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.virtual_scrolling_core.js ***!
      \**************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getContentHeightLimit = getContentHeightLimit;
        exports.subscribeToExternalScrollers = subscribeToExternalScrollers;
        exports.VirtualScrollController = exports.getPixelRatio = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _position = _interopRequireDefault(__webpack_require__( /*! ../../animation/position */ 81));
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/callbacks */ 27));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var SCROLLING_MODE_INFINITE = "infinite";
        var SCROLLING_MODE_VIRTUAL = "virtual";
        var isVirtualMode = function(that) {
            return that.option("scrolling.mode") === SCROLLING_MODE_VIRTUAL || that._isVirtual
        };
        var isAppendMode = function(that) {
            return that.option("scrolling.mode") === SCROLLING_MODE_INFINITE && !that._isVirtual
        };
        var needTwoPagesLoading = function(that) {
            return that.option("scrolling.loadTwoPagesOnStart") || that._isVirtual || that._viewportItemIndex > 0
        };
        var getPixelRatio = function(window) {
            return window.devicePixelRatio || 1
        };
        exports.getPixelRatio = getPixelRatio;

        function getContentHeightLimit(browser) {
            if (browser.msie) {
                return 4e6
            } else {
                if (browser.mozilla) {
                    return 8e6
                }
            }
            return 15e6 / getPixelRatio((0, _window.getWindow)())
        }

        function subscribeToExternalScrollers($element, scrollChangedHandler, $targetElement) {
            var $scrollElement;
            var scrollableArray = [];
            var scrollToArray = [];
            var disposeArray = [];
            $targetElement = $targetElement || $element;

            function getElementOffset(scrollable) {
                var $scrollableElement = scrollable.element ? scrollable.$element() : scrollable;
                var scrollableOffset = _position.default.offset($scrollableElement);
                if (!scrollableOffset) {
                    return $element.offset().top
                }
                return scrollable.scrollTop() - (scrollableOffset.top - $element.offset().top)
            }

            function createWindowScrollHandler(scrollable) {
                return function() {
                    var scrollTop = scrollable.scrollTop() - getElementOffset(scrollable);
                    scrollTop = scrollTop > 0 ? scrollTop : 0;
                    scrollChangedHandler(scrollTop)
                }
            }
            var widgetScrollStrategy = {
                on: function(scrollable, eventName, handler) {
                    scrollable.on("scroll", handler)
                },
                off: function(scrollable, eventName, handler) {
                    scrollable.off("scroll", handler)
                }
            };

            function subscribeToScrollEvents($scrollElement) {
                var isDocument = "#document" === $scrollElement.get(0).nodeName;
                var scrollable = $scrollElement.data("dxScrollable");
                var eventsStrategy = widgetScrollStrategy;
                if (!scrollable) {
                    scrollable = isDocument && (0, _renderer.default)((0, _window.getWindow)()) || "auto" === $scrollElement.css("overflowY") && $scrollElement;
                    eventsStrategy = _events_engine.default;
                    if (!scrollable) {
                        return
                    }
                }
                var handler = createWindowScrollHandler(scrollable);
                eventsStrategy.on(scrollable, "scroll", handler);
                scrollToArray.push(function(pos) {
                    var topOffset = getElementOffset(scrollable);
                    var scrollMethod = scrollable.scrollTo ? "scrollTo" : "scrollTop";
                    if (pos - topOffset >= 0) {
                        scrollable[scrollMethod](pos + topOffset)
                    }
                });
                scrollableArray.push(scrollable);
                disposeArray.push(function() {
                    eventsStrategy.off(scrollable, "scroll", handler)
                })
            }
            for ($scrollElement = $targetElement.parent(); $scrollElement.length; $scrollElement = $scrollElement.parent()) {
                subscribeToScrollEvents($scrollElement)
            }
            return {
                scrollTo: function(pos) {
                    (0, _iterator.each)(scrollToArray, function(_, scrollTo) {
                        scrollTo(pos)
                    })
                },
                dispose: function() {
                    (0, _iterator.each)(disposeArray, function(_, dispose) {
                        dispose()
                    })
                }
            }
        }
        var VirtualScrollController = _class.default.inherit(function() {
            var getViewportPageCount = function(that) {
                var pageSize = that._dataSource.pageSize();
                var preventPreload = that.option("scrolling.preventPreload");
                if (preventPreload) {
                    return 0
                }
                var realViewportSize = that._viewportSize;
                if (isVirtualMode(that) && !that.option("legacyRendering") && that.option("scrolling.removeInvisiblePages")) {
                    realViewportSize = 0;
                    var viewportSize = that._viewportSize * that._viewportItemSize;
                    var offset = that.getContentOffset();
                    var position = that._position || 0;
                    var virtualItemsCount = that.virtualItemsCount();
                    var totalItemsCount = that._dataSource.totalItemsCount();
                    for (var itemIndex = virtualItemsCount.begin; itemIndex < totalItemsCount; itemIndex++) {
                        if (offset >= position + viewportSize) {
                            break
                        }
                        var itemSize = that._itemSizes[itemIndex] || that._viewportItemSize;
                        offset += itemSize;
                        if (offset >= position) {
                            realViewportSize++
                        }
                    }
                }
                return pageSize && realViewportSize > 0 ? Math.ceil(realViewportSize / pageSize) : 1
            };
            var getPreloadPageCount = function(that, previous) {
                var preloadEnabled = that.option("scrolling.preloadEnabled");
                var pageCount = getViewportPageCount(that);
                if (pageCount) {
                    if (previous) {
                        pageCount = preloadEnabled ? 1 : 0
                    } else {
                        if (preloadEnabled) {
                            pageCount++
                        }
                        if (isAppendMode(that) || !needTwoPagesLoading(that)) {
                            pageCount--
                        }
                    }
                }
                return pageCount
            };
            var getPageIndexForLoad = function(that) {
                var result = -1;
                var beginPageIndex = getBeginPageIndex(that);
                var dataSource = that._dataSource;
                if (beginPageIndex < 0) {
                    result = that._pageIndex
                } else {
                    if (!that._cache[that._pageIndex - beginPageIndex]) {
                        result = that._pageIndex
                    } else {
                        if (beginPageIndex >= 0 && that._viewportSize >= 0) {
                            if (beginPageIndex > 0) {
                                var needToLoadPageBeforeLast = getEndPageIndex(that) + 1 === dataSource.pageCount() && that._cache.length < getPreloadPageCount(that) + 1;
                                var needToLoadPrevPage = needToLoadPageBeforeLast || that._pageIndex === beginPageIndex && getPreloadPageCount(that, true);
                                if (needToLoadPrevPage) {
                                    result = beginPageIndex - 1
                                }
                            }
                            if (result < 0) {
                                var needToLoadNextPage = beginPageIndex + that._cache.length <= that._pageIndex + getPreloadPageCount(that);
                                if (needToLoadNextPage) {
                                    result = beginPageIndex + that._cache.length
                                }
                            }
                        }
                    }
                }
                if (that._loadingPageIndexes[result]) {
                    result = -1
                }
                return result
            };

            function getBeginPageIndex(that) {
                return that._cache.length ? that._cache[0].pageIndex : -1
            }

            function getEndPageIndex(that) {
                return that._cache.length ? that._cache[that._cache.length - 1].pageIndex : -1
            }
            var fireChanged = function(that, changed, args) {
                that._isChangedFiring = true;
                changed(args);
                that._isChangedFiring = false
            };
            var processDelayChanged = function(that, changed, args) {
                if (that._isDelayChanged) {
                    that._isDelayChanged = false;
                    fireChanged(that, changed, args);
                    return true
                }
            };
            var processChanged = function(that, changed, changeType, isDelayChanged, removeCacheItem) {
                var dataSource = that._dataSource;
                var items = dataSource.items().slice();
                var change = (0, _type.isObject)(changeType) ? changeType : void 0;
                var isPrepend = "prepend" === changeType;
                var viewportItems = dataSource.viewportItems();
                if (changeType && (0, _type.isString)(changeType) && !that._isDelayChanged) {
                    change = {
                        changeType: changeType,
                        items: items
                    };
                    if (removeCacheItem) {
                        change.removeCount = removeCacheItem.itemsCount;
                        if (change.removeCount && dataSource.correctCount) {
                            change.removeCount = dataSource.correctCount(viewportItems, change.removeCount, isPrepend)
                        }
                    }
                }
                var removeItemCount = removeCacheItem ? removeCacheItem.itemsLength : 0;
                if (removeItemCount && dataSource.correctCount) {
                    removeItemCount = dataSource.correctCount(viewportItems, removeItemCount, isPrepend)
                }
                if ("append" === changeType) {
                    viewportItems.push.apply(viewportItems, items);
                    if (removeCacheItem) {
                        viewportItems.splice(0, removeItemCount)
                    }
                } else {
                    if (isPrepend) {
                        viewportItems.unshift.apply(viewportItems, items);
                        if (removeCacheItem) {
                            viewportItems.splice(-removeItemCount)
                        }
                    } else {
                        that._dataSource.viewportItems(items)
                    }
                }
                dataSource.updateLoading();
                that._lastPageIndex = that.pageIndex();
                that._isDelayChanged = isDelayChanged;
                if (!isDelayChanged) {
                    fireChanged(that, changed, change)
                }
            };
            var loadCore = function(that, pageIndex) {
                var dataSource = that._dataSource;
                if (pageIndex === that.pageIndex() || !dataSource.isLoading() && pageIndex < dataSource.pageCount() || !dataSource.hasKnownLastPage() && pageIndex === dataSource.pageCount()) {
                    dataSource.pageIndex(pageIndex);
                    that._loadingPageIndexes[pageIndex] = true;
                    return (0, _deferred.when)(dataSource.load()).always(function() {
                        that._loadingPageIndexes[pageIndex] = false
                    })
                }
            };
            return {
                ctor: function(component, dataSource, isVirtual) {
                    var that = this;
                    that._dataSource = dataSource;
                    that.component = component;
                    that._pageIndex = that._lastPageIndex = dataSource.pageIndex();
                    that._viewportSize = 0;
                    that._viewportItemSize = 20;
                    that._viewportItemIndex = -1;
                    that._itemSizes = {};
                    that._sizeRatio = 1;
                    that._items = [];
                    that._cache = [];
                    that._isVirtual = isVirtual;
                    that._loadingPageIndexes = {};
                    that.positionChanged = (0, _callbacks.default)()
                },
                getItemSizes: function() {
                    return this._itemSizes
                },
                option: function() {
                    return this.component.option.apply(this.component, arguments)
                },
                virtualItemsCount: function() {
                    var that = this;
                    var pageIndex;
                    var itemsCount = 0;
                    if (isVirtualMode(that)) {
                        pageIndex = getBeginPageIndex(that);
                        if (pageIndex < 0) {
                            pageIndex = that._dataSource.pageIndex()
                        }
                        var beginItemsCount = pageIndex * that._dataSource.pageSize();
                        itemsCount = that._cache.length * that._dataSource.pageSize();
                        var endItemsCount = Math.max(0, that._dataSource.totalItemsCount() - itemsCount - beginItemsCount);
                        return {
                            begin: beginItemsCount,
                            end: endItemsCount
                        }
                    }
                },
                setViewportPosition: function(position) {
                    var that = this;
                    var result = new _deferred.Deferred;
                    var scrollingTimeout = Math.min(that.option("scrolling.timeout") || 0, that._dataSource.changingDuration());
                    if (scrollingTimeout < that.option("scrolling.renderingThreshold")) {
                        scrollingTimeout = that.option("scrolling.minTimeout") || 0
                    }
                    clearTimeout(that._scrollTimeoutID);
                    if (scrollingTimeout > 0) {
                        that._scrollTimeoutID = setTimeout(function() {
                            that._setViewportPositionCore(position);
                            result.resolve()
                        }, scrollingTimeout)
                    } else {
                        that._setViewportPositionCore(position);
                        result.resolve()
                    }
                    return result.promise()
                },
                getViewportPosition: function() {
                    return this._position || 0
                },
                getItemIndexByPosition: function() {
                    var that = this;
                    var position = that._position;
                    var defaultItemSize = that.getItemSize();
                    var offset = 0;
                    var itemOffset = 0;
                    var itemOffsetsWithSize = Object.keys(that._itemSizes).concat(-1);
                    for (var i = 0; i < itemOffsetsWithSize.length && offset < position; i++) {
                        var itemOffsetWithSize = parseInt(itemOffsetsWithSize[i]);
                        var itemOffsetDiff = (position - offset) / defaultItemSize;
                        if (itemOffsetWithSize < 0 || itemOffset + itemOffsetDiff < itemOffsetWithSize) {
                            itemOffset += itemOffsetDiff;
                            break
                        } else {
                            itemOffsetDiff = itemOffsetWithSize - itemOffset;
                            offset += itemOffsetDiff * defaultItemSize;
                            itemOffset += itemOffsetDiff
                        }
                        var itemSize = that._itemSizes[itemOffsetWithSize];
                        offset += itemSize;
                        itemOffset += offset < position ? 1 : (position - offset + itemSize) / itemSize
                    }
                    return Math.round(50 * itemOffset) / 50
                },
                _setViewportPositionCore: function(position) {
                    this._position = position;
                    var itemIndex = this.getItemIndexByPosition();
                    var result = this.setViewportItemIndex(itemIndex);
                    this.positionChanged.fire();
                    return result
                },
                setContentSize: function(size) {
                    var that = this;
                    var sizes = Array.isArray(size) && size;
                    var virtualItemsCount = that.virtualItemsCount();
                    if (sizes) {
                        size = sizes.reduce(function(a, b) {
                            return a + b
                        }, 0)
                    }
                    that._contentSize = size;
                    if (virtualItemsCount) {
                        if (sizes) {
                            sizes.forEach(function(size, index) {
                                that._itemSizes[virtualItemsCount.begin + index] = size
                            })
                        }
                        var virtualContentSize = (virtualItemsCount.begin + virtualItemsCount.end + that.itemsCount()) * that._viewportItemSize;
                        var contentHeightLimit = getContentHeightLimit(_browser.default);
                        if (virtualContentSize > contentHeightLimit) {
                            that._sizeRatio = contentHeightLimit / virtualContentSize
                        } else {
                            that._sizeRatio = 1
                        }
                    }
                },
                getItemSize: function() {
                    return this._viewportItemSize * this._sizeRatio
                },
                getItemOffset: function(itemIndex, isEnd) {
                    var that = this;
                    var virtualItemsCount = that.virtualItemsCount();
                    var itemCount = itemIndex;
                    if (!virtualItemsCount) {
                        return 0
                    }
                    var offset = 0;
                    var totalItemsCount = that._dataSource.totalItemsCount();
                    Object.keys(that._itemSizes).forEach(function(currentItemIndex) {
                        if (!itemCount) {
                            return
                        }
                        if (isEnd ? currentItemIndex >= totalItemsCount - itemIndex : currentItemIndex < itemIndex) {
                            offset += that._itemSizes[currentItemIndex];
                            itemCount--
                        }
                    });
                    return Math.floor(offset + itemCount * that._viewportItemSize * that._sizeRatio)
                },
                getContentOffset: function(type) {
                    var isEnd = "end" === type;
                    var virtualItemsCount = this.virtualItemsCount();
                    if (!virtualItemsCount) {
                        return 0
                    }
                    return this.getItemOffset(isEnd ? virtualItemsCount.end : virtualItemsCount.begin, isEnd)
                },
                getVirtualContentSize: function() {
                    var that = this;
                    var virtualItemsCount = that.virtualItemsCount();
                    return virtualItemsCount ? that.getContentOffset("begin") + that.getContentOffset("end") + that._contentSize : 0
                },
                getViewportItemIndex: function() {
                    return this._viewportItemIndex
                },
                setViewportItemIndex: function(itemIndex) {
                    var that = this;
                    var pageSize = that._dataSource.pageSize();
                    var pageCount = that._dataSource.pageCount();
                    var virtualMode = isVirtualMode(that);
                    var appendMode = isAppendMode(that);
                    var totalItemsCount = that._dataSource.totalItemsCount();
                    var newPageIndex;
                    that._viewportItemIndex = itemIndex;
                    if (pageSize && (virtualMode || appendMode) && totalItemsCount >= 0) {
                        if (that._viewportSize && itemIndex + that._viewportSize >= totalItemsCount && !that._isVirtual) {
                            if (that._dataSource.hasKnownLastPage()) {
                                newPageIndex = pageCount - 1;
                                var lastPageSize = totalItemsCount % pageSize;
                                if (newPageIndex > 0 && lastPageSize > 0 && lastPageSize < that._viewportSize) {
                                    newPageIndex--
                                }
                            } else {
                                newPageIndex = pageCount
                            }
                        } else {
                            newPageIndex = Math.floor(itemIndex / pageSize);
                            var maxPageIndex = pageCount - 1;
                            newPageIndex = Math.max(newPageIndex, 0);
                            newPageIndex = Math.min(newPageIndex, maxPageIndex)
                        }
                        that.pageIndex(newPageIndex);
                        return that.load()
                    }
                },
                viewportItemSize: function(size) {
                    if (void 0 !== size) {
                        this._viewportItemSize = size
                    }
                    return this._viewportItemSize
                },
                viewportSize: function(size) {
                    if (void 0 !== size) {
                        this._viewportSize = size
                    }
                    return this._viewportSize
                },
                pageIndex: function(_pageIndex) {
                    if (isVirtualMode(this) || isAppendMode(this)) {
                        if (void 0 !== _pageIndex) {
                            this._pageIndex = _pageIndex
                        }
                        return this._pageIndex
                    } else {
                        return this._dataSource.pageIndex(_pageIndex)
                    }
                },
                beginPageIndex: function beginPageIndex(defaultPageIndex) {
                    var beginPageIndex = getBeginPageIndex(this);
                    if (beginPageIndex < 0) {
                        beginPageIndex = void 0 !== defaultPageIndex ? defaultPageIndex : this.pageIndex()
                    }
                    return beginPageIndex
                },
                endPageIndex: function endPageIndex() {
                    var endPageIndex = getEndPageIndex(this);
                    return endPageIndex > 0 ? endPageIndex : this._lastPageIndex
                },
                pageSize: function() {
                    return this._dataSource.pageSize()
                },
                load: function() {
                    var that = this;
                    var dataSource = that._dataSource;
                    var result;
                    if (isVirtualMode(that) || isAppendMode(that)) {
                        var pageIndexForLoad = getPageIndexForLoad(that);
                        if (pageIndexForLoad >= 0) {
                            var loadResult = loadCore(that, pageIndexForLoad);
                            if (loadResult) {
                                result = new _deferred.Deferred;
                                loadResult.done(function() {
                                    var delayDeferred = that._delayDeferred;
                                    if (delayDeferred) {
                                        delayDeferred.done(result.resolve).fail(result.reject)
                                    } else {
                                        result.resolve()
                                    }
                                }).fail(result.reject);
                                dataSource.updateLoading()
                            }
                        }
                    } else {
                        result = dataSource.load()
                    }
                    if (!result && that._lastPageIndex !== that.pageIndex()) {
                        that._dataSource.onChanged({
                            changeType: "pageIndex"
                        })
                    }
                    return result || (new _deferred.Deferred).resolve()
                },
                loadIfNeed: function() {
                    var that = this;
                    if ((isVirtualMode(that) || isAppendMode(that)) && !that._dataSource.isLoading() && (!that._isChangedFiring || that._isVirtual)) {
                        var position = that.getViewportPosition();
                        if (position > 0) {
                            that._setViewportPositionCore(position)
                        } else {
                            that.load()
                        }
                    }
                },
                handleDataChanged: function(callBase, e) {
                    var that = this;
                    var dataSource = that._dataSource;
                    var lastCacheLength = that._cache.length;
                    var changeType;
                    var removeInvisiblePages;
                    if (e && e.changes) {
                        fireChanged(that, callBase, e)
                    } else {
                        if (isVirtualMode(that) || isAppendMode(that)) {
                            var beginPageIndex = getBeginPageIndex(that);
                            if (beginPageIndex >= 0) {
                                if (isVirtualMode(that) && beginPageIndex + that._cache.length !== dataSource.pageIndex() && beginPageIndex - 1 !== dataSource.pageIndex()) {
                                    lastCacheLength = 0;
                                    that._cache = []
                                }
                                if (isAppendMode(that)) {
                                    if (0 === dataSource.pageIndex()) {
                                        that._cache = []
                                    } else {
                                        if (dataSource.pageIndex() < getEndPageIndex(that)) {
                                            fireChanged(that, callBase, {
                                                changeType: "append",
                                                items: []
                                            });
                                            return
                                        }
                                    }
                                }
                            }
                            var cacheItem = {
                                pageIndex: dataSource.pageIndex(),
                                itemsLength: dataSource.items(true).length,
                                itemsCount: that.itemsCount(true)
                            };
                            if (!that.option("legacyRendering") && that.option("scrolling.removeInvisiblePages") && isVirtualMode(that)) {
                                removeInvisiblePages = that._cache.length > Math.max(getPreloadPageCount(this) + (that.option("scrolling.preloadEnabled") ? 1 : 0), 2)
                            } else {
                                processDelayChanged(that, callBase, {
                                    isDelayed: true
                                })
                            }
                            var removeCacheItem;
                            if (beginPageIndex === dataSource.pageIndex() + 1) {
                                if (removeInvisiblePages) {
                                    removeCacheItem = that._cache.pop()
                                }
                                changeType = "prepend";
                                that._cache.unshift(cacheItem)
                            } else {
                                if (removeInvisiblePages) {
                                    removeCacheItem = that._cache.shift()
                                }
                                changeType = "append";
                                that._cache.push(cacheItem)
                            }
                            var isDelayChanged = isVirtualMode(that) && 0 === lastCacheLength && needTwoPagesLoading(that);
                            processChanged(that, callBase, that._cache.length > 1 ? changeType : void 0, isDelayChanged, removeCacheItem);
                            that._delayDeferred = that.load().done(function() {
                                if (processDelayChanged(that, callBase)) {
                                    that.load()
                                }
                            })
                        } else {
                            processChanged(that, callBase, e)
                        }
                    }
                },
                itemsCount: function itemsCount(isBase) {
                    var itemsCount = 0;
                    if (!isBase && isVirtualMode(this)) {
                        (0, _iterator.each)(this._cache, function() {
                            itemsCount += this.itemsCount
                        })
                    } else {
                        itemsCount = this._dataSource.itemsCount()
                    }
                    return itemsCount
                },
                reset: function(isRefresh) {
                    this._loadingPageIndexes = {};
                    this._cache = [];
                    if (!isRefresh) {
                        this._itemSizes = {}
                    }
                },
                subscribeToWindowScrollEvents: function($element) {
                    var that = this;
                    that._windowScroll = that._windowScroll || subscribeToExternalScrollers($element, function(scrollTop) {
                        if (that.viewportItemSize()) {
                            that.setViewportPosition(scrollTop)
                        }
                    })
                },
                dispose: function() {
                    clearTimeout(this._scrollTimeoutID);
                    this._windowScroll && this._windowScroll.dispose();
                    this._windowScroll = null
                },
                scrollTo: function(pos) {
                    this._windowScroll && this._windowScroll.scrollTo(pos)
                }
            }
        }());
        exports.VirtualScrollController = VirtualScrollController
    },
    /*!**************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.filter_row.js ***!
      \**************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.modules */ 44));
        var _uiGrid_core2 = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.utils */ 35));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _editor = _interopRequireDefault(__webpack_require__( /*! ../editor/editor */ 52));
        var _overlay = _interopRequireDefault(__webpack_require__( /*! ../overlay */ 64));
        var _menu = _interopRequireDefault(__webpack_require__( /*! ../menu */ 405));
        var _accessibility = __webpack_require__( /*! ../shared/accessibility */ 118);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var OPERATION_ICONS = {
            "=": "filter-operation-equals",
            "<>": "filter-operation-not-equals",
            "<": "filter-operation-less",
            "<=": "filter-operation-less-equal",
            ">": "filter-operation-greater",
            ">=": "filter-operation-greater-equal",
            "default": "filter-operation-default",
            notcontains: "filter-operation-not-contains",
            contains: "filter-operation-contains",
            startswith: "filter-operation-starts-with",
            endswith: "filter-operation-ends-with",
            between: "filter-operation-between"
        };
        var OPERATION_DESCRIPTORS = {
            "=": "equal",
            "<>": "notEqual",
            "<": "lessThan",
            "<=": "lessThanOrEqual",
            ">": "greaterThan",
            ">=": "greaterThanOrEqual",
            startswith: "startsWith",
            contains: "contains",
            notcontains: "notContains",
            endswith: "endsWith",
            between: "between"
        };
        var FILTERING_TIMEOUT = 700;
        var CORRECT_FILTER_RANGE_OVERLAY_WIDTH = 1;
        var FILTER_ROW_CLASS = "filter-row";
        var FILTER_RANGE_OVERLAY_CLASS = "filter-range-overlay";
        var FILTER_RANGE_START_CLASS = "filter-range-start";
        var FILTER_RANGE_END_CLASS = "filter-range-end";
        var MENU_CLASS = "dx-menu";
        var EDITOR_WITH_MENU_CLASS = "dx-editor-with-menu";
        var EDITOR_CONTAINER_CLASS = "dx-editor-container";
        var EDITOR_CELL_CLASS = "dx-editor-cell";
        var FILTER_MENU = "dx-filter-menu";
        var APPLY_BUTTON_CLASS = "dx-apply-button";
        var HIGHLIGHT_OUTLINE_CLASS = "dx-highlight-outline";
        var FOCUSED_CLASS = "dx-focused";
        var CELL_FOCUS_DISABLED_CLASS = "dx-cell-focus-disabled";
        var FILTER_RANGE_CONTENT_CLASS = "dx-filter-range-content";
        var FILTER_MODIFIED_CLASS = "dx-filter-modified";
        var EDITORS_INPUT_SELECTOR = "input:not([type='hidden'])";
        var BETWEEN_OPERATION_DATA_TYPES = ["date", "datetime", "number"];

        function isOnClickApplyFilterMode(that) {
            return "onClick" === that.option("filterRow.applyFilter")
        }
        var ColumnHeadersViewFilterRowExtender = function() {
            var getEditorInstance = function($editorContainer) {
                var $editor = $editorContainer && $editorContainer.children();
                var componentNames = $editor && $editor.data("dxComponents");
                var editor = componentNames && componentNames.length && $editor.data(componentNames[0]);
                if (editor instanceof _editor.default) {
                    return editor
                }
            };
            var getRangeTextByFilterValue = function(that, column) {
                var result = "";
                var rangeEnd = "";
                var filterValue = getColumnFilterValue(that, column);
                var formatOptions = _uiGrid_core2.default.getFormatOptionsByColumn(column, "filterRow");
                if (Array.isArray(filterValue)) {
                    result = _uiGrid_core2.default.formatValue(filterValue[0], formatOptions);
                    rangeEnd = _uiGrid_core2.default.formatValue(filterValue[1], formatOptions);
                    if ("" !== rangeEnd) {
                        result += " - " + rangeEnd
                    }
                } else {
                    if ((0, _type.isDefined)(filterValue)) {
                        result = _uiGrid_core2.default.formatValue(filterValue, formatOptions)
                    }
                }
                return result
            };

            function getColumnFilterValue(that, column) {
                if (column) {
                    return isOnClickApplyFilterMode(that) && void 0 !== column.bufferedFilterValue ? column.bufferedFilterValue : column.filterValue
                }
            }
            var getColumnSelectedFilterOperation = function(that, column) {
                if (column) {
                    return isOnClickApplyFilterMode(that) && void 0 !== column.bufferedSelectedFilterOperation ? column.bufferedSelectedFilterOperation : column.selectedFilterOperation
                }
            };
            var isValidFilterValue = function(filterValue, column) {
                if (column && BETWEEN_OPERATION_DATA_TYPES.indexOf(column.dataType) >= 0 && Array.isArray(filterValue)) {
                    return false
                }
                return void 0 !== filterValue
            };
            var getFilterValue = function(that, columnIndex, $editorContainer) {
                var column = that._columnsController.columnOption(columnIndex);
                var filterValue = getColumnFilterValue(that, column);
                var isFilterRange = $editorContainer.closest("." + that.addWidgetPrefix(FILTER_RANGE_OVERLAY_CLASS)).length;
                var isRangeStart = $editorContainer.hasClass(that.addWidgetPrefix(FILTER_RANGE_START_CLASS));
                if (filterValue && Array.isArray(filterValue) && "between" === getColumnSelectedFilterOperation(that, column)) {
                    if (isRangeStart) {
                        return filterValue[0]
                    } else {
                        return filterValue[1]
                    }
                }
                return !isFilterRange && isValidFilterValue(filterValue, column) ? filterValue : null
            };
            var normalizeFilterValue = function(that, filterValue, column, $editorContainer) {
                if ("between" === getColumnSelectedFilterOperation(that, column)) {
                    var columnFilterValue = getColumnFilterValue(that, column);
                    if ($editorContainer.hasClass(that.addWidgetPrefix(FILTER_RANGE_START_CLASS))) {
                        return [filterValue, Array.isArray(columnFilterValue) ? columnFilterValue[1] : void 0]
                    } else {
                        return [Array.isArray(columnFilterValue) ? columnFilterValue[0] : columnFilterValue, filterValue]
                    }
                }
                return filterValue
            };
            var updateFilterValue = function(that, options) {
                var value = "" === options.value ? null : options.value;
                var $editorContainer = options.container;
                var column = that._columnsController.columnOption(options.column.index);
                var filterValue = getFilterValue(that, column.index, $editorContainer);
                if (!(0, _type.isDefined)(filterValue) && !(0, _type.isDefined)(value)) {
                    return
                }
                that._applyFilterViewController.setHighLight($editorContainer, filterValue !== value);
                that._columnsController.columnOption(column.index, isOnClickApplyFilterMode(that) ? "bufferedFilterValue" : "filterValue", normalizeFilterValue(that, value, column, $editorContainer), options.notFireEvent)
            };
            return {
                _updateEditorValue: function(column, $editorContainer) {
                    var that = this;
                    var editor = getEditorInstance($editorContainer);
                    editor && editor.option("value", getFilterValue(that, column.index, $editorContainer))
                },
                _columnOptionChanged: function(e) {
                    var that = this;
                    var optionNames = e.optionNames;
                    var $cell;
                    var $editorContainer;
                    var $editorRangeElements;
                    var $menu;
                    if (_uiGrid_core2.default.checkChanges(optionNames, ["filterValue", "bufferedFilterValue", "selectedFilterOperation", "bufferedSelectedFilterOperation"]) && void 0 !== e.columnIndex) {
                        var visibleIndex = that._columnsController.getVisibleIndex(e.columnIndex);
                        var column = that._columnsController.columnOption(e.columnIndex);
                        $cell = that._getCellElement(that.element().find("." + that.addWidgetPrefix(FILTER_ROW_CLASS)).index(), visibleIndex) || (0, _renderer.default)();
                        $editorContainer = $cell.find("." + EDITOR_CONTAINER_CLASS).first();
                        if (optionNames.filterValue || optionNames.bufferedFilterValue) {
                            that._updateEditorValue(column, $editorContainer);
                            var overlayInstance = $cell.find("." + that.addWidgetPrefix(FILTER_RANGE_OVERLAY_CLASS)).data("dxOverlay");
                            if (overlayInstance) {
                                $editorRangeElements = overlayInstance.$content().find("." + EDITOR_CONTAINER_CLASS);
                                that._updateEditorValue(column, $editorRangeElements.first());
                                that._updateEditorValue(column, $editorRangeElements.last())
                            }
                            if (!overlayInstance || !overlayInstance.option("visible")) {
                                that._updateFilterRangeContent($cell, getRangeTextByFilterValue(that, column))
                            }
                        }
                        if (optionNames.selectedFilterOperation || optionNames.bufferedSelectedFilterOperation) {
                            if (visibleIndex >= 0 && column) {
                                $menu = $cell.find("." + MENU_CLASS);
                                if ($menu.length) {
                                    that._updateFilterOperationChooser($menu, column, $editorContainer);
                                    if ("between" === getColumnSelectedFilterOperation(that, column)) {
                                        that._renderFilterRangeContent($cell, column)
                                    } else {
                                        if ($editorContainer.find("." + FILTER_RANGE_CONTENT_CLASS).length) {
                                            that._renderEditor($editorContainer, that._getEditorOptions($editorContainer, column));
                                            that._hideFilterRange()
                                        }
                                    }
                                }
                            }
                        }
                        return
                    }
                    that.callBase(e)
                },
                _renderCore: function() {
                    this._filterRangeOverlayInstance = null;
                    this.callBase.apply(this, arguments)
                },
                _resizeCore: function() {
                    this.callBase.apply(this, arguments);
                    this._filterRangeOverlayInstance && this._filterRangeOverlayInstance.repaint()
                },
                isFilterRowVisible: function() {
                    return this._isElementVisible(this.option("filterRow"))
                },
                isVisible: function() {
                    return this.callBase() || this.isFilterRowVisible()
                },
                init: function() {
                    this.callBase();
                    this._applyFilterViewController = this.getController("applyFilter")
                },
                _initFilterRangeOverlay: function($cell, column) {
                    var that = this;
                    var sharedData = {};
                    var $editorContainer = $cell.find(".dx-editor-container");
                    var $overlay = (0, _renderer.default)("<div>").addClass(that.addWidgetPrefix(FILTER_RANGE_OVERLAY_CLASS)).appendTo($cell);
                    return that._createComponent($overlay, _overlay.default, {
                        height: "auto",
                        shading: false,
                        showTitle: false,
                        focusStateEnabled: false,
                        closeOnTargetScroll: false,
                        closeOnOutsideClick: true,
                        animation: false,
                        position: {
                            my: "top",
                            at: "top",
                            of: $editorContainer.length && $editorContainer || $cell,
                            offset: "0 -1"
                        },
                        contentTemplate: function(contentElement) {
                            var editorOptions;
                            var $editor = (0, _renderer.default)("<div>").addClass(EDITOR_CONTAINER_CLASS + " " + that.addWidgetPrefix(FILTER_RANGE_START_CLASS)).appendTo(contentElement);
                            column = that._columnsController.columnOption(column.index);
                            editorOptions = that._getEditorOptions($editor, column);
                            editorOptions.sharedData = sharedData;
                            that._renderEditor($editor, editorOptions);
                            _events_engine.default.on($editor.find(EDITORS_INPUT_SELECTOR), "keydown", function(e) {
                                var $prevElement = $cell.find("[tabindex]").not(e.target).first();
                                if ("tab" === (0, _index.normalizeKeyName)(e) && e.shiftKey) {
                                    e.preventDefault();
                                    that._hideFilterRange();
                                    if (!$prevElement.length) {
                                        $prevElement = $cell.prev().find("[tabindex]").last()
                                    }
                                    _events_engine.default.trigger($prevElement, "focus")
                                }
                            });
                            $editor = (0, _renderer.default)("<div>").addClass(EDITOR_CONTAINER_CLASS + " " + that.addWidgetPrefix(FILTER_RANGE_END_CLASS)).appendTo(contentElement);
                            editorOptions = that._getEditorOptions($editor, column);
                            editorOptions.sharedData = sharedData;
                            that._renderEditor($editor, editorOptions);
                            _events_engine.default.on($editor.find(EDITORS_INPUT_SELECTOR), "keydown", function(e) {
                                if ("tab" === (0, _index.normalizeKeyName)(e) && !e.shiftKey) {
                                    e.preventDefault();
                                    that._hideFilterRange();
                                    _events_engine.default.trigger($cell.next().find("[tabindex]").first(), "focus")
                                }
                            });
                            return (0, _renderer.default)(contentElement).addClass(that.getWidgetContainerClass())
                        },
                        onShown: function(e) {
                            var $editor = e.component.$content().find("." + EDITOR_CONTAINER_CLASS).first();
                            _events_engine.default.trigger($editor.find(EDITORS_INPUT_SELECTOR), "focus")
                        },
                        onHidden: function() {
                            column = that._columnsController.columnOption(column.index);
                            $cell.find("." + MENU_CLASS).parent().addClass(EDITOR_WITH_MENU_CLASS);
                            if ("between" === getColumnSelectedFilterOperation(that, column)) {
                                that._updateFilterRangeContent($cell, getRangeTextByFilterValue(that, column));
                                that.component.updateDimensions()
                            }
                        }
                    })
                },
                _updateFilterRangeOverlay: function(options) {
                    var overlayInstance = this._filterRangeOverlayInstance;
                    overlayInstance && overlayInstance.option(options)
                },
                _showFilterRange: function($cell, column) {
                    var that = this;
                    var $overlay = $cell.children("." + that.addWidgetPrefix(FILTER_RANGE_OVERLAY_CLASS));
                    var overlayInstance = $overlay.length && $overlay.data("dxOverlay");
                    if (!overlayInstance && column) {
                        overlayInstance = that._initFilterRangeOverlay($cell, column)
                    }
                    if (!overlayInstance.option("visible")) {
                        that._filterRangeOverlayInstance && that._filterRangeOverlayInstance.hide();
                        that._filterRangeOverlayInstance = overlayInstance;
                        that._updateFilterRangeOverlay({
                            width: $cell.outerWidth(true) + CORRECT_FILTER_RANGE_OVERLAY_WIDTH
                        });
                        that._filterRangeOverlayInstance && that._filterRangeOverlayInstance.show()
                    }
                },
                _hideFilterRange: function() {
                    var overlayInstance = this._filterRangeOverlayInstance;
                    overlayInstance && overlayInstance.hide()
                },
                getFilterRangeOverlayInstance: function() {
                    return this._filterRangeOverlayInstance
                },
                _createRow: function(row) {
                    var _this = this;
                    var $row = this.callBase(row);
                    if ("filter" === row.rowType) {
                        $row.addClass(this.addWidgetPrefix(FILTER_ROW_CLASS));
                        if (!this.option("useLegacyKeyboardNavigation")) {
                            _events_engine.default.on($row, "keydown", function(event) {
                                return (0, _accessibility.selectView)("filterRow", _this, event)
                            })
                        }
                    }
                    return $row
                },
                _getRows: function() {
                    var result = this.callBase();
                    if (this.isFilterRowVisible()) {
                        result.push({
                            rowType: "filter"
                        })
                    }
                    return result
                },
                _renderFilterCell: function(cell, options) {
                    var that = this;
                    var column = options.column;
                    var $cell = (0, _renderer.default)(cell);
                    if (that.component.option("showColumnHeaders")) {
                        that.setAria("describedby", column.headerId, $cell)
                    }
                    that.setAria("label", _message.default.format("dxDataGrid-ariaFilterCell"), $cell);
                    $cell.addClass(EDITOR_CELL_CLASS);
                    var $container = (0, _renderer.default)("<div>").appendTo($cell);
                    var $editorContainer = (0, _renderer.default)("<div>").addClass(EDITOR_CONTAINER_CLASS).appendTo($container);
                    if ("between" === getColumnSelectedFilterOperation(that, column)) {
                        that._renderFilterRangeContent($cell, column)
                    } else {
                        var editorOptions = that._getEditorOptions($editorContainer, column);
                        that._renderEditor($editorContainer, editorOptions)
                    }
                    var alignment = column.alignment;
                    if (alignment && "center" !== alignment) {
                        $cell.find(EDITORS_INPUT_SELECTOR).first().css("textAlign", column.alignment)
                    }
                    if (column.filterOperations && column.filterOperations.length) {
                        that._renderFilterOperationChooser($container, column, $editorContainer)
                    }
                },
                _renderCellContent: function($cell, options) {
                    var that = this;
                    var column = options.column;
                    if ("filter" === options.rowType) {
                        if (column.command) {
                            $cell.html("&nbsp;")
                        } else {
                            if (column.allowFiltering) {
                                that.renderTemplate($cell, that._renderFilterCell.bind(that), options).done(function() {
                                    that._updateCell($cell, options)
                                });
                                return
                            }
                        }
                    }
                    that.callBase($cell, options)
                },
                _getEditorOptions: function($editorContainer, column) {
                    var that = this;
                    var accessibilityOptions = {
                        editorOptions: {
                            inputAttr: that._getFilterInputAccessibilityAttributes(column)
                        }
                    };
                    var result = (0, _extend.extend)(accessibilityOptions, column, {
                        value: getFilterValue(that, column.index, $editorContainer),
                        parentType: "filterRow",
                        showAllText: that.option("filterRow.showAllText"),
                        updateValueTimeout: "onClick" === that.option("filterRow.applyFilter") ? 0 : FILTERING_TIMEOUT,
                        width: null,
                        setValue: function(value, notFireEvent) {
                            updateFilterValue(that, {
                                column: column,
                                value: value,
                                container: $editorContainer,
                                notFireEvent: notFireEvent
                            })
                        }
                    });
                    if ("between" === getColumnSelectedFilterOperation(that, column)) {
                        if ($editorContainer.hasClass(that.addWidgetPrefix(FILTER_RANGE_START_CLASS))) {
                            result.placeholder = that.option("filterRow.betweenStartText")
                        } else {
                            result.placeholder = that.option("filterRow.betweenEndText")
                        }
                    }
                    return result
                },
                _getFilterInputAccessibilityAttributes: function(column) {
                    var columnAriaLabel = _message.default.format("dxDataGrid-ariaFilterCell");
                    if (this.component.option("showColumnHeaders")) {
                        return {
                            "aria-label": columnAriaLabel,
                            "aria-describedby": column.headerId
                        }
                    }
                    return {
                        "aria-label": columnAriaLabel
                    }
                },
                _renderEditor: function($editorContainer, options) {
                    $editorContainer.empty();
                    return this.getController("editorFactory").createEditor((0, _renderer.default)("<div>").appendTo($editorContainer), options)
                },
                _renderFilterRangeContent: function($cell, column) {
                    var that = this;
                    var $editorContainer = $cell.find("." + EDITOR_CONTAINER_CLASS).first();
                    $editorContainer.empty();
                    var $filterRangeContent = (0, _renderer.default)("<div>").addClass(FILTER_RANGE_CONTENT_CLASS).attr("tabindex", this.option("tabIndex"));
                    _events_engine.default.on($filterRangeContent, "focusin", function() {
                        that._showFilterRange($cell, column)
                    });
                    $filterRangeContent.appendTo($editorContainer);
                    that._updateFilterRangeContent($cell, getRangeTextByFilterValue(that, column))
                },
                _updateFilterRangeContent: function($cell, value) {
                    var $filterRangeContent = $cell.find("." + FILTER_RANGE_CONTENT_CLASS);
                    if ($filterRangeContent.length) {
                        if ("" === value) {
                            $filterRangeContent.html("&nbsp;")
                        } else {
                            $filterRangeContent.text(value)
                        }
                    }
                },
                _updateFilterOperationChooser: function($menu, column, $editorContainer) {
                    var that = this;
                    var isCellWasFocused;
                    var restoreFocus = function() {
                        var menu = _menu.default.getInstance($menu);
                        menu && menu.option("focusedElement", null);
                        isCellWasFocused && that._focusEditor($editorContainer)
                    };
                    that._createComponent($menu, _menu.default, {
                        integrationOptions: {},
                        activeStateEnabled: false,
                        selectionMode: "single",
                        cssClass: that.getWidgetContainerClass() + " " + CELL_FOCUS_DISABLED_CLASS + " " + FILTER_MENU,
                        showFirstSubmenuMode: "onHover",
                        hideSubmenuOnMouseLeave: true,
                        items: [{
                            disabled: column.filterOperations && column.filterOperations.length ? false : true,
                            icon: OPERATION_ICONS[getColumnSelectedFilterOperation(that, column) || "default"],
                            selectable: false,
                            items: that._getFilterOperationMenuItems(column)
                        }],
                        onItemClick: function(properties) {
                            var selectedFilterOperation = properties.itemData.name;
                            var columnSelectedFilterOperation = getColumnSelectedFilterOperation(that, column);
                            var notFocusEditor = false;
                            var isOnClickMode = isOnClickApplyFilterMode(that);
                            var options = {};
                            if (properties.itemData.items || selectedFilterOperation && selectedFilterOperation === columnSelectedFilterOperation) {
                                return
                            }
                            if (selectedFilterOperation) {
                                options[isOnClickMode ? "bufferedSelectedFilterOperation" : "selectedFilterOperation"] = selectedFilterOperation;
                                if ("between" === selectedFilterOperation || "between" === columnSelectedFilterOperation) {
                                    notFocusEditor = "between" === selectedFilterOperation;
                                    options[isOnClickMode ? "bufferedFilterValue" : "filterValue"] = null
                                }
                            } else {
                                options[isOnClickMode ? "bufferedFilterValue" : "filterValue"] = null;
                                options[isOnClickMode ? "bufferedSelectedFilterOperation" : "selectedFilterOperation"] = column.defaultSelectedFilterOperation || null
                            }
                            that._columnsController.columnOption(column.index, options);
                            that._applyFilterViewController.setHighLight($editorContainer, true);
                            if (!selectedFilterOperation) {
                                var editor = getEditorInstance($editorContainer);
                                if (editor && "dxDateBox" === editor.NAME && !editor.option("isValid")) {
                                    editor.reset();
                                    editor.option("isValid", true)
                                }
                            }
                            if (!notFocusEditor) {
                                that._focusEditor($editorContainer)
                            } else {
                                that._showFilterRange($editorContainer.closest("." + EDITOR_CELL_CLASS), column)
                            }
                        },
                        onSubmenuShown: function() {
                            isCellWasFocused = that._isEditorFocused($editorContainer);
                            that.getController("editorFactory").loseFocus()
                        },
                        onSubmenuHiding: function() {
                            _events_engine.default.trigger($menu, "blur");
                            restoreFocus()
                        },
                        onContentReady: function(e) {
                            _events_engine.default.on($menu, "blur", function() {
                                var menu = e.component;
                                menu._hideSubmenu(menu._visibleSubmenu);
                                restoreFocus()
                            })
                        },
                        rtlEnabled: that.option("rtlEnabled")
                    })
                },
                _isEditorFocused: function($container) {
                    return $container.hasClass(FOCUSED_CLASS) || $container.parents("." + FOCUSED_CLASS).length
                },
                _focusEditor: function($container) {
                    this.getController("editorFactory").focus($container);
                    _events_engine.default.trigger($container.find(EDITORS_INPUT_SELECTOR), "focus")
                },
                _renderFilterOperationChooser: function($container, column, $editorContainer) {
                    var that = this;
                    var $menu;
                    if (that.option("filterRow.showOperationChooser")) {
                        $container.addClass(EDITOR_WITH_MENU_CLASS);
                        $menu = (0, _renderer.default)("<div>").prependTo($container);
                        that._updateFilterOperationChooser($menu, column, $editorContainer)
                    }
                },
                _getFilterOperationMenuItems: function(column) {
                    var that = this;
                    var result = [{}];
                    var filterRowOptions = that.option("filterRow");
                    var operationDescriptions = filterRowOptions && filterRowOptions.operationDescriptions || {};
                    if (column.filterOperations && column.filterOperations.length) {
                        var availableFilterOperations = column.filterOperations.filter(function(value) {
                            return (0, _type.isDefined)(OPERATION_DESCRIPTORS[value])
                        });
                        result = (0, _iterator.map)(availableFilterOperations, function(value) {
                            var descriptionName = OPERATION_DESCRIPTORS[value];
                            return {
                                name: value,
                                selected: (getColumnSelectedFilterOperation(that, column) || column.defaultFilterOperation) === value,
                                text: operationDescriptions[descriptionName],
                                icon: OPERATION_ICONS[value]
                            }
                        });
                        result.push({
                            name: null,
                            text: filterRowOptions && filterRowOptions.resetOperationText,
                            icon: OPERATION_ICONS.default
                        })
                    }
                    return result
                },
                optionChanged: function(args) {
                    var that = this;
                    switch (args.name) {
                        case "filterRow":
                        case "showColumnLines":
                            this._invalidate(true, true);
                            args.handled = true;
                            break;
                        default:
                            that.callBase(args)
                    }
                }
            }
        }();
        var DataControllerFilterRowExtender = {
            skipCalculateColumnFilters: function() {
                return false
            },
            _calculateAdditionalFilter: function() {
                if (this.skipCalculateColumnFilters()) {
                    return this.callBase()
                }
                var filters = [this.callBase()];
                var columns = this._columnsController.getVisibleColumns(null, true);
                (0, _iterator.each)(columns, function() {
                    if (this.allowFiltering && this.calculateFilterExpression && (0, _type.isDefined)(this.filterValue)) {
                        var filter = this.createFilterExpression(this.filterValue, this.selectedFilterOperation || this.defaultFilterOperation, "filterRow");
                        filters.push(filter)
                    }
                });
                return _uiGrid_core2.default.combineFilters(filters)
            }
        };
        var ApplyFilterViewController = _uiGrid_core.default.ViewController.inherit({
            _getHeaderPanel: function() {
                if (!this._headerPanel) {
                    this._headerPanel = this.getView("headerPanel")
                }
                return this._headerPanel
            },
            setHighLight: function($element, value) {
                if (isOnClickApplyFilterMode(this)) {
                    $element && $element.toggleClass(HIGHLIGHT_OUTLINE_CLASS, value) && $element.closest("." + EDITOR_CELL_CLASS).toggleClass(FILTER_MODIFIED_CLASS, value);
                    this._getHeaderPanel().enableApplyButton(value)
                }
            },
            applyFilter: function() {
                var columnsController = this.getController("columns");
                var columns = columnsController.getColumns();
                columnsController.beginUpdate();
                for (var i = 0; i < columns.length; i++) {
                    var column = columns[i];
                    if (void 0 !== column.bufferedFilterValue) {
                        columnsController.columnOption(i, "filterValue", column.bufferedFilterValue);
                        column.bufferedFilterValue = void 0
                    }
                    if (void 0 !== column.bufferedSelectedFilterOperation) {
                        columnsController.columnOption(i, "selectedFilterOperation", column.bufferedSelectedFilterOperation);
                        column.bufferedSelectedFilterOperation = void 0
                    }
                }
                columnsController.endUpdate();
                this.removeHighLights()
            },
            removeHighLights: function() {
                if (isOnClickApplyFilterMode(this)) {
                    var columnHeadersViewElement = this.getView("columnHeadersView").element();
                    columnHeadersViewElement.find("." + this.addWidgetPrefix(FILTER_ROW_CLASS) + " ." + HIGHLIGHT_OUTLINE_CLASS).removeClass(HIGHLIGHT_OUTLINE_CLASS);
                    columnHeadersViewElement.find("." + this.addWidgetPrefix(FILTER_ROW_CLASS) + " ." + FILTER_MODIFIED_CLASS).removeClass(FILTER_MODIFIED_CLASS);
                    this._getHeaderPanel().enableApplyButton(false)
                }
            }
        });
        var _default = {
            defaultOptions: function() {
                return {
                    filterRow: {
                        visible: false,
                        showOperationChooser: true,
                        showAllText: _message.default.format("dxDataGrid-filterRowShowAllText"),
                        resetOperationText: _message.default.format("dxDataGrid-filterRowResetOperationText"),
                        applyFilter: "auto",
                        applyFilterText: _message.default.format("dxDataGrid-applyFilterText"),
                        operationDescriptions: {
                            equal: _message.default.format("dxDataGrid-filterRowOperationEquals"),
                            notEqual: _message.default.format("dxDataGrid-filterRowOperationNotEquals"),
                            lessThan: _message.default.format("dxDataGrid-filterRowOperationLess"),
                            lessThanOrEqual: _message.default.format("dxDataGrid-filterRowOperationLessOrEquals"),
                            greaterThan: _message.default.format("dxDataGrid-filterRowOperationGreater"),
                            greaterThanOrEqual: _message.default.format("dxDataGrid-filterRowOperationGreaterOrEquals"),
                            startsWith: _message.default.format("dxDataGrid-filterRowOperationStartsWith"),
                            contains: _message.default.format("dxDataGrid-filterRowOperationContains"),
                            notContains: _message.default.format("dxDataGrid-filterRowOperationNotContains"),
                            endsWith: _message.default.format("dxDataGrid-filterRowOperationEndsWith"),
                            between: _message.default.format("dxDataGrid-filterRowOperationBetween"),
                            isBlank: _message.default.format("dxFilterBuilder-filterOperationIsBlank"),
                            isNotBlank: _message.default.format("dxFilterBuilder-filterOperationIsNotBlank")
                        },
                        betweenStartText: _message.default.format("dxDataGrid-filterRowOperationBetweenStartText"),
                        betweenEndText: _message.default.format("dxDataGrid-filterRowOperationBetweenEndText")
                    }
                }
            },
            controllers: {
                applyFilter: ApplyFilterViewController
            },
            extenders: {
                controllers: {
                    data: DataControllerFilterRowExtender,
                    columnsResizer: {
                        _startResizing: function() {
                            var that = this;
                            that.callBase.apply(that, arguments);
                            if (that.isResizing()) {
                                var overlayInstance = that._columnHeadersView.getFilterRangeOverlayInstance();
                                if (overlayInstance) {
                                    var cellIndex = overlayInstance.$element().closest("td").index();
                                    if (cellIndex === that._targetPoint.columnIndex || cellIndex === that._targetPoint.columnIndex + 1) {
                                        overlayInstance.$content().hide()
                                    }
                                }
                            }
                        },
                        _endResizing: function() {
                            var that = this;
                            var $cell;
                            if (that.isResizing()) {
                                var overlayInstance = that._columnHeadersView.getFilterRangeOverlayInstance();
                                if (overlayInstance) {
                                    $cell = overlayInstance.$element().closest("td");
                                    that._columnHeadersView._updateFilterRangeOverlay({
                                        width: $cell.outerWidth(true) + CORRECT_FILTER_RANGE_OVERLAY_WIDTH
                                    });
                                    overlayInstance.$content().show()
                                }
                            }
                            that.callBase.apply(that, arguments)
                        }
                    }
                },
                views: {
                    columnHeadersView: ColumnHeadersViewFilterRowExtender,
                    headerPanel: {
                        _getToolbarItems: function() {
                            var items = this.callBase();
                            var filterItem = this._prepareFilterItem(items);
                            return filterItem.concat(items)
                        },
                        _prepareFilterItem: function() {
                            var that = this;
                            var filterItem = [];
                            if (that._isShowApplyFilterButton()) {
                                var hintText = that.option("filterRow.applyFilterText");
                                var columns = that._columnsController.getColumns();
                                var disabled = !columns.filter(function(column) {
                                    return void 0 !== column.bufferedFilterValue
                                }).length;
                                var onInitialized = function(e) {
                                    (0, _renderer.default)(e.element).addClass(that._getToolbarButtonClass(APPLY_BUTTON_CLASS))
                                };
                                var onClickHandler = function() {
                                    that._applyFilterViewController.applyFilter()
                                };
                                var toolbarItem = {
                                    widget: "dxButton",
                                    options: {
                                        icon: "apply-filter",
                                        disabled: disabled,
                                        onClick: onClickHandler,
                                        hint: hintText,
                                        text: hintText,
                                        onInitialized: onInitialized
                                    },
                                    showText: "inMenu",
                                    name: "applyFilterButton",
                                    location: "after",
                                    locateInMenu: "auto",
                                    sortIndex: 10
                                };
                                filterItem.push(toolbarItem)
                            }
                            return filterItem
                        },
                        _isShowApplyFilterButton: function() {
                            var filterRowOptions = this.option("filterRow");
                            return filterRowOptions && filterRowOptions.visible && "onClick" === filterRowOptions.applyFilter
                        },
                        init: function() {
                            this.callBase();
                            this._dataController = this.getController("data");
                            this._applyFilterViewController = this.getController("applyFilter")
                        },
                        enableApplyButton: function(value) {
                            this.setToolbarItemDisabled("applyFilterButton", !value)
                        },
                        isVisible: function() {
                            return this.callBase() || this._isShowApplyFilterButton()
                        },
                        optionChanged: function(args) {
                            if ("filterRow" === args.name) {
                                this._invalidate();
                                args.handled = true
                            } else {
                                this.callBase(args)
                            }
                        }
                    }
                }
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************!*\
      !*** ./artifacts/transpiled-npm/ui/menu.js ***!
      \*********************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./menu/ui.menu */ 406));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _ui.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/menu/ui.menu.js ***!
      \*****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _element = __webpack_require__( /*! ../../core/element */ 18);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _utils = __webpack_require__( /*! ../overlay/utils */ 280);
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../../events/pointer */ 24));
        var _hover = __webpack_require__( /*! ../../events/hover */ 155);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../context_menu/ui.menu_base */ 376));
        var _overlay = _interopRequireDefault(__webpack_require__( /*! ../overlay */ 64));
        var _ui2 = _interopRequireDefault(__webpack_require__( /*! ./ui.submenu */ 714));
        var _button = _interopRequireDefault(__webpack_require__( /*! ../button */ 37));
        var _tree_view = _interopRequireDefault(__webpack_require__( /*! ../tree_view */ 158));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var DX_MENU_CLASS = "dx-menu";
        var DX_MENU_VERTICAL_CLASS = DX_MENU_CLASS + "-vertical";
        var DX_MENU_HORIZONTAL_CLASS = DX_MENU_CLASS + "-horizontal";
        var DX_MENU_ITEM_CLASS = DX_MENU_CLASS + "-item";
        var DX_MENU_ITEMS_CONTAINER_CLASS = DX_MENU_CLASS + "-items-container";
        var DX_MENU_ITEM_EXPANDED_CLASS = DX_MENU_ITEM_CLASS + "-expanded";
        var DX_CONTEXT_MENU_CLASS = "dx-context-menu";
        var DX_CONTEXT_MENU_CONTAINER_BORDER_CLASS = DX_CONTEXT_MENU_CLASS + "-container-border";
        var DX_CONTEXT_MENU_CONTENT_DELIMITER_CLASS = "dx-context-menu-content-delimiter";
        var DX_SUBMENU_CLASS = "dx-submenu";
        var DX_STATE_DISABLED_CLASS = "dx-state-disabled";
        var DX_STATE_HOVER_CLASS = "dx-state-hover";
        var DX_STATE_ACTIVE_CLASS = "dx-state-active";
        var DX_ADAPTIVE_MODE_CLASS = DX_MENU_CLASS + "-adaptive-mode";
        var DX_ADAPTIVE_HAMBURGER_BUTTON_CLASS = DX_MENU_CLASS + "-hamburger-button";
        var DX_ADAPTIVE_MODE_OVERLAY_WRAPPER_CLASS = DX_ADAPTIVE_MODE_CLASS + "-overlay-wrapper";
        var FOCUS_UP = "up";
        var FOCUS_DOWN = "down";
        var FOCUS_LEFT = "left";
        var FOCUS_RIGHT = "right";
        var SHOW_SUBMENU_OPERATION = "showSubmenu";
        var NEXTITEM_OPERATION = "nextItem";
        var PREVITEM_OPERATION = "prevItem";
        var DEFAULT_DELAY = {
            show: 50,
            hide: 300
        };
        var ACTIONS = ["onSubmenuShowing", "onSubmenuShown", "onSubmenuHiding", "onSubmenuHidden", "onItemContextMenu", "onItemClick", "onSelectionChanged", "onItemRendered"];
        var Menu = function(_MenuBase) {
            _inheritsLoose(Menu, _MenuBase);

            function Menu() {
                return _MenuBase.apply(this, arguments) || this
            }
            var _proto = Menu.prototype;
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_MenuBase.prototype._getDefaultOptions.call(this), {
                    orientation: "horizontal",
                    submenuDirection: "auto",
                    showFirstSubmenuMode: {
                        name: "onClick",
                        delay: {
                            show: 50,
                            hide: 300
                        }
                    },
                    hideSubmenuOnMouseLeave: false,
                    onSubmenuShowing: null,
                    onSubmenuShown: null,
                    onSubmenuHiding: null,
                    onSubmenuHidden: null,
                    adaptivityEnabled: false
                })
            };
            _proto._setOptionsByReference = function() {
                _MenuBase.prototype._setOptionsByReference.call(this);
                (0, _extend.extend)(this._optionsByReference, {
                    animation: true,
                    selectedItem: true
                })
            };
            _proto._itemElements = function() {
                var rootMenuElements = _MenuBase.prototype._itemElements.call(this);
                var submenuElements = this._submenuItemElements();
                return rootMenuElements.add(submenuElements)
            };
            _proto._submenuItemElements = function() {
                var elements = [];
                var itemSelector = ".".concat(DX_MENU_ITEM_CLASS);
                var currentSubmenu = this._submenus.length && this._submenus[0];
                if (currentSubmenu && currentSubmenu.itemsContainer()) {
                    elements = currentSubmenu.itemsContainer().find(itemSelector)
                }
                return elements
            };
            _proto._focusTarget = function() {
                return this.$element()
            };
            _proto._isMenuHorizontal = function() {
                return "horizontal" === this.option("orientation")
            };
            _proto._moveFocus = function(location) {
                var $items = this._getAvailableItems();
                var isMenuHorizontal = this._isMenuHorizontal();
                var $activeItem = this._getActiveItem(true);
                var argument;
                var operation;
                var navigationAction;
                var $newTarget;
                switch (location) {
                    case FOCUS_UP:
                        operation = isMenuHorizontal ? SHOW_SUBMENU_OPERATION : this._getItemsNavigationOperation(PREVITEM_OPERATION);
                        argument = isMenuHorizontal ? $activeItem : $items;
                        navigationAction = this._getKeyboardNavigationAction(operation, argument);
                        $newTarget = navigationAction();
                        break;
                    case FOCUS_DOWN:
                        operation = isMenuHorizontal ? SHOW_SUBMENU_OPERATION : this._getItemsNavigationOperation(NEXTITEM_OPERATION);
                        argument = isMenuHorizontal ? $activeItem : $items;
                        navigationAction = this._getKeyboardNavigationAction(operation, argument);
                        $newTarget = navigationAction();
                        break;
                    case FOCUS_RIGHT:
                        operation = isMenuHorizontal ? this._getItemsNavigationOperation(NEXTITEM_OPERATION) : SHOW_SUBMENU_OPERATION;
                        argument = isMenuHorizontal ? $items : $activeItem;
                        navigationAction = this._getKeyboardNavigationAction(operation, argument);
                        $newTarget = navigationAction();
                        break;
                    case FOCUS_LEFT:
                        operation = isMenuHorizontal ? this._getItemsNavigationOperation(PREVITEM_OPERATION) : SHOW_SUBMENU_OPERATION;
                        argument = isMenuHorizontal ? $items : $activeItem;
                        navigationAction = this._getKeyboardNavigationAction(operation, argument);
                        $newTarget = navigationAction();
                        break;
                    default:
                        return _MenuBase.prototype._moveFocus.call(this, location)
                }
                if ($newTarget && 0 !== $newTarget.length) {
                    this.option("focusedElement", (0, _element.getPublicElement)($newTarget))
                }
            };
            _proto._getItemsNavigationOperation = function(operation) {
                var navOperation = operation;
                if (this.option("rtlEnabled")) {
                    navOperation = operation === PREVITEM_OPERATION ? NEXTITEM_OPERATION : PREVITEM_OPERATION
                }
                return navOperation
            };
            _proto._getKeyboardNavigationAction = function(operation, argument) {
                var action = _common.noop;
                switch (operation) {
                    case SHOW_SUBMENU_OPERATION:
                        if (!argument.hasClass(DX_STATE_DISABLED_CLASS)) {
                            action = this._showSubmenu.bind(this, argument)
                        }
                        break;
                    case NEXTITEM_OPERATION:
                        action = this._nextItem.bind(this, argument);
                        break;
                    case PREVITEM_OPERATION:
                        action = this._prevItem.bind(this, argument)
                }
                return action
            };
            _proto._clean = function() {
                _MenuBase.prototype._clean.call(this);
                this.option("templatesRenderAsynchronously") && clearTimeout(this._resizeEventTimer)
            };
            _proto._visibilityChanged = function(visible) {
                if (visible) {
                    if (!this._menuItemsWidth) {
                        this._updateItemsWidthCache()
                    }
                    this._dimensionChanged()
                }
            };
            _proto._isAdaptivityEnabled = function() {
                return this.option("adaptivityEnabled") && "horizontal" === this.option("orientation")
            };
            _proto._updateItemsWidthCache = function() {
                var $menuItems = this.$element().find("ul").first().children("li").children(".".concat(DX_MENU_ITEM_CLASS));
                this._menuItemsWidth = this._getSummaryItemsWidth($menuItems, true)
            };
            _proto._dimensionChanged = function() {
                if (!this._isAdaptivityEnabled()) {
                    return
                }
                var containerWidth = this.$element().outerWidth();
                this._toggleAdaptiveMode(this._menuItemsWidth > containerWidth)
            };
            _proto._init = function() {
                _MenuBase.prototype._init.call(this);
                this._submenus = []
            };
            _proto._initActions = function() {
                var _this = this;
                this._actions = {};
                (0, _iterator.each)(ACTIONS, function(index, action) {
                    _this._actions[action] = _this._createActionByOption(action)
                })
            };
            _proto._initMarkup = function() {
                this._visibleSubmenu = null;
                this.$element().addClass(DX_MENU_CLASS);
                _MenuBase.prototype._initMarkup.call(this);
                this.setAria("role", "menubar")
            };
            _proto._render = function() {
                _MenuBase.prototype._render.call(this);
                this._initAdaptivity()
            };
            _proto._renderHamburgerButton = function() {
                this._hamburger = new _button.default((0, _renderer.default)("<div>").addClass(DX_ADAPTIVE_HAMBURGER_BUTTON_CLASS), {
                    icon: "menu",
                    activeStateEnabled: false,
                    onClick: this._toggleTreeView.bind(this)
                });
                return this._hamburger.$element()
            };
            _proto._toggleTreeView = function(state) {
                if ((0, _type.isPlainObject)(state)) {
                    state = !this._overlay.option("visible")
                }
                this._overlay.option("visible", state);
                this._toggleHamburgerActiveState(state)
            };
            _proto._toggleHamburgerActiveState = function(state) {
                this._hamburger && this._hamburger.$element().toggleClass(DX_STATE_ACTIVE_CLASS, state)
            };
            _proto._toggleAdaptiveMode = function(state) {
                var $menuItemsContainer = this.$element().find(".".concat(DX_MENU_HORIZONTAL_CLASS));
                var $adaptiveElements = this.$element().find(".".concat(DX_ADAPTIVE_MODE_CLASS));
                if (state) {
                    this._hideVisibleSubmenu()
                } else {
                    this._treeView && this._treeView.collapseAll();
                    this._overlay && this._toggleTreeView(state)
                }
                $menuItemsContainer.toggle(!state);
                $adaptiveElements.toggle(state)
            };
            _proto._removeAdaptivity = function() {
                if (!this._$adaptiveContainer) {
                    return
                }
                this._toggleAdaptiveMode(false);
                this._$adaptiveContainer.remove();
                this._$adaptiveContainer = null;
                this._treeView = null;
                this._hamburger = null;
                this._overlay = null
            };
            _proto._treeviewItemClickHandler = function(e) {
                this._actions.onItemClick(e);
                if (!e.node.children.length) {
                    this._toggleTreeView(false)
                }
            };
            _proto._getAdaptiveOverlayOptions = function() {
                var _this2 = this;
                var rtl = this.option("rtlEnabled");
                var position = rtl ? "right" : "left";
                return {
                    maxHeight: function() {
                        return (0, _utils.getElementMaxHeightByWindow)(_this2.$element())
                    },
                    deferRendering: false,
                    shading: false,
                    animation: false,
                    closeOnTargetScroll: true,
                    onHidden: function() {
                        _this2._toggleHamburgerActiveState(false)
                    },
                    height: "auto",
                    closeOnOutsideClick: function(e) {
                        return !(0, _renderer.default)(e.target).closest(".".concat(DX_ADAPTIVE_HAMBURGER_BUTTON_CLASS)).length
                    },
                    position: {
                        collision: "flipfit",
                        at: "bottom " + position,
                        my: "top " + position,
                        of: this._hamburger.$element()
                    }
                }
            };
            _proto._getTreeViewOptions = function() {
                var _this3 = this;
                var menuOptions = {};
                var optionsToTransfer = ["rtlEnabled", "width", "accessKey", "activeStateEnabled", "animation", "dataSource", "disabled", "displayExpr", "displayExpr", "focusStateEnabled", "hint", "hoverStateEnabled", "itemsExpr", "items", "itemTemplate", "selectedExpr", "selectionMode", "tabIndex", "visible"];
                var actionsToTransfer = ["onItemContextMenu", "onSelectionChanged"];
                (0, _iterator.each)(optionsToTransfer, function(_, option) {
                    menuOptions[option] = _this3.option(option)
                });
                (0, _iterator.each)(actionsToTransfer, function(_, actionName) {
                    menuOptions[actionName] = function(e) {
                        _this3._actions[actionName](e)
                    }
                });
                return (0, _extend.extend)(menuOptions, {
                    dataSource: this.getDataSource(),
                    animationEnabled: !!this.option("animation"),
                    onItemClick: this._treeviewItemClickHandler.bind(this),
                    onItemExpanded: function(e) {
                        _this3._overlay.repaint();
                        _this3._actions.onSubmenuShown(e)
                    },
                    onItemCollapsed: function(e) {
                        _this3._overlay.repaint();
                        _this3._actions.onSubmenuHidden(e)
                    },
                    selectNodesRecursive: false,
                    selectByClick: this.option("selectByClick"),
                    expandEvent: "click"
                })
            };
            _proto._initAdaptivity = function() {
                if (!this._isAdaptivityEnabled()) {
                    return
                }
                this._$adaptiveContainer = (0, _renderer.default)("<div>").addClass(DX_ADAPTIVE_MODE_CLASS);
                var $hamburger = this._renderHamburgerButton();
                this._treeView = this._createComponent((0, _renderer.default)("<div>"), _tree_view.default, this._getTreeViewOptions());
                this._overlay = this._createComponent((0, _renderer.default)("<div>"), _overlay.default, this._getAdaptiveOverlayOptions());
                this._overlay.$content().append(this._treeView.$element()).addClass(DX_ADAPTIVE_MODE_CLASS).addClass(this.option("cssClass"));
                this._overlay._wrapper().addClass(DX_ADAPTIVE_MODE_OVERLAY_WRAPPER_CLASS);
                this._$adaptiveContainer.append($hamburger);
                this._$adaptiveContainer.append(this._overlay.$element());
                this.$element().append(this._$adaptiveContainer);
                this._updateItemsWidthCache();
                this._dimensionChanged()
            };
            _proto._getDelay = function(delayType) {
                var delay = this.option("showFirstSubmenuMode").delay;
                if (!(0, _type.isDefined)(delay)) {
                    return DEFAULT_DELAY[delayType]
                } else {
                    return (0, _type.isObject)(delay) ? delay[delayType] : delay
                }
            };
            _proto._keyboardHandler = function(e) {
                return _MenuBase.prototype._keyboardHandler.call(this, e, !!this._visibleSubmenu)
            };
            _proto._renderContainer = function() {
                var $wrapper = (0, _renderer.default)("<div>");
                $wrapper.appendTo(this.$element()).addClass(this._isMenuHorizontal() ? DX_MENU_HORIZONTAL_CLASS : DX_MENU_VERTICAL_CLASS);
                return _MenuBase.prototype._renderContainer.call(this, $wrapper)
            };
            _proto._renderSubmenuItems = function(node, $itemFrame) {
                var submenu = this._createSubmenu(node, $itemFrame);
                this._submenus.push(submenu);
                this._renderBorderElement($itemFrame);
                return submenu
            };
            _proto._getKeyboardListeners = function() {
                return _MenuBase.prototype._getKeyboardListeners.call(this).concat(this._visibleSubmenu)
            };
            _proto._createSubmenu = function(node, $rootItem) {
                var $submenuContainer = (0, _renderer.default)("<div>").addClass(DX_CONTEXT_MENU_CLASS).appendTo($rootItem);
                var items = this._getChildNodes(node);
                var result = this._createComponent($submenuContainer, _ui2.default, (0, _extend.extend)(this._getSubmenuOptions(), {
                    _dataAdapter: this._dataAdapter,
                    _parentKey: node.internalFields.key,
                    items: items,
                    onHoverStart: this._clearTimeouts.bind(this),
                    position: this.getSubmenuPosition($rootItem)
                }));
                this._attachSubmenuHandlers($rootItem, result);
                return result
            };
            _proto._getSubmenuOptions = function() {
                var _this4 = this;
                var $submenuTarget = (0, _renderer.default)("<div>");
                var isMenuHorizontal = this._isMenuHorizontal();
                return {
                    itemTemplate: this.option("itemTemplate"),
                    target: $submenuTarget,
                    orientation: this.option("orientation"),
                    selectionMode: this.option("selectionMode"),
                    cssClass: this.option("cssClass"),
                    selectByClick: this.option("selectByClick"),
                    hoverStateEnabled: this.option("hoverStateEnabled"),
                    activeStateEnabled: this.option("activeStateEnabled"),
                    focusStateEnabled: this.option("focusStateEnabled"),
                    animation: this.option("animation"),
                    showSubmenuMode: this.option("showSubmenuMode"),
                    displayExpr: this.option("displayExpr"),
                    disabledExpr: this.option("disabledExpr"),
                    selectedExpr: this.option("selectedExpr"),
                    itemsExpr: this.option("itemsExpr"),
                    onFocusedItemChanged: function(e) {
                        if (!e.component.option("visible")) {
                            return
                        }
                        _this4.option("focusedElement", e.component.option("focusedElement"))
                    },
                    onSelectionChanged: this._nestedItemOnSelectionChangedHandler.bind(this),
                    onItemClick: this._nestedItemOnItemClickHandler.bind(this),
                    onItemRendered: this._nestedItemOnItemRenderedHandler.bind(this),
                    onLeftFirstItem: isMenuHorizontal ? null : this._moveMainMenuFocus.bind(this, PREVITEM_OPERATION),
                    onLeftLastItem: isMenuHorizontal ? null : this._moveMainMenuFocus.bind(this, NEXTITEM_OPERATION),
                    onCloseRootSubmenu: this._moveMainMenuFocus.bind(this, isMenuHorizontal ? PREVITEM_OPERATION : null),
                    onExpandLastSubmenu: isMenuHorizontal ? this._moveMainMenuFocus.bind(this, NEXTITEM_OPERATION) : null
                }
            };
            _proto._getShowFirstSubmenuMode = function() {
                if (!this._isDesktopDevice()) {
                    return "onClick"
                }
                var optionValue = this.option("showFirstSubmenuMode");
                return (0, _type.isObject)(optionValue) ? optionValue.name : optionValue
            };
            _proto._moveMainMenuFocus = function(direction) {
                var $items = this._getAvailableItems();
                var itemCount = $items.length;
                var $currentItem = $items.filter(".".concat(DX_MENU_ITEM_EXPANDED_CLASS)).eq(0);
                var itemIndex = $items.index($currentItem);
                this._hideSubmenu(this._visibleSubmenu);
                itemIndex += direction === PREVITEM_OPERATION ? -1 : 1;
                if (itemIndex >= itemCount) {
                    itemIndex = 0
                } else {
                    if (itemIndex < 0) {
                        itemIndex = itemCount - 1
                    }
                }
                var $newItem = $items.eq(itemIndex);
                this.option("focusedElement", (0, _element.getPublicElement)($newItem))
            };
            _proto._nestedItemOnSelectionChangedHandler = function(args) {
                var selectedItem = args.addedItems.length && args.addedItems[0];
                var submenu = _ui2.default.getInstance(args.element);
                var onSelectionChanged = this._actions.onSelectionChanged;
                onSelectionChanged(args);
                selectedItem && this._clearSelectionInSubmenus(selectedItem[0], submenu);
                this._clearRootSelection();
                this._setOptionWithoutOptionChange("selectedItem", selectedItem)
            };
            _proto._clearSelectionInSubmenus = function(item, targetSubmenu) {
                var _this5 = this;
                var cleanAllSubmenus = !arguments.length;
                (0, _iterator.each)(this._submenus, function(index, submenu) {
                    var $submenu = submenu._itemContainer();
                    var isOtherItem = !$submenu.is(targetSubmenu && targetSubmenu._itemContainer());
                    var $selectedItem = $submenu.find(".".concat(_this5._selectedItemClass()));
                    if (isOtherItem && $selectedItem.length || cleanAllSubmenus) {
                        $selectedItem.removeClass(_this5._selectedItemClass());
                        var selectedItemData = _this5._getItemData($selectedItem);
                        if (selectedItemData) {
                            selectedItemData.selected = false
                        }
                        submenu._clearSelectedItems()
                    }
                })
            };
            _proto._clearRootSelection = function() {
                var $prevSelectedItem = this.$element().find(".".concat(DX_MENU_ITEMS_CONTAINER_CLASS)).first().children().children().filter(".".concat(this._selectedItemClass()));
                if ($prevSelectedItem.length) {
                    var prevSelectedItemData = this._getItemData($prevSelectedItem);
                    prevSelectedItemData.selected = false;
                    $prevSelectedItem.removeClass(this._selectedItemClass())
                }
            };
            _proto._nestedItemOnItemClickHandler = function(e) {
                this._actions.onItemClick(e)
            };
            _proto._nestedItemOnItemRenderedHandler = function(e) {
                this._actions.onItemRendered(e)
            };
            _proto._attachSubmenuHandlers = function($rootItem, submenu) {
                var _this6 = this;
                var $submenuOverlayContent = submenu.getOverlayContent();
                var submenus = $submenuOverlayContent.find(".".concat(DX_SUBMENU_CLASS));
                var submenuMouseLeaveName = (0, _index.addNamespace)(_hover.end, this.NAME + "_submenu");
                submenu.option({
                    onShowing: this._submenuOnShowingHandler.bind(this, $rootItem, submenu),
                    onShown: this._submenuOnShownHandler.bind(this, $rootItem, submenu),
                    onHiding: this._submenuOnHidingHandler.bind(this, $rootItem, submenu),
                    onHidden: this._submenuOnHiddenHandler.bind(this, $rootItem, submenu)
                });
                (0, _iterator.each)(submenus, function(index, submenu) {
                    _events_engine.default.off(submenu, submenuMouseLeaveName);
                    _events_engine.default.on(submenu, submenuMouseLeaveName, null, _this6._submenuMouseLeaveHandler.bind(_this6, $rootItem))
                })
            };
            _proto._submenuOnShowingHandler = function($rootItem, submenu) {
                var $border = $rootItem.children(".".concat(DX_CONTEXT_MENU_CONTAINER_BORDER_CLASS));
                this._actions.onSubmenuShowing({
                    rootItem: (0, _element.getPublicElement)($rootItem),
                    submenu: submenu
                });
                $border.show();
                $rootItem.addClass(DX_MENU_ITEM_EXPANDED_CLASS)
            };
            _proto._submenuOnShownHandler = function($rootItem, submenu) {
                this._actions.onSubmenuShown({
                    rootItem: (0, _element.getPublicElement)($rootItem),
                    submenu: submenu
                })
            };
            _proto._submenuOnHidingHandler = function($rootItem, submenu, eventArgs) {
                var $border = $rootItem.children(".".concat(DX_CONTEXT_MENU_CONTAINER_BORDER_CLASS));
                var args = eventArgs;
                args.rootItem = (0, _element.getPublicElement)($rootItem);
                args.submenu = submenu;
                this._actions.onSubmenuHiding(args);
                eventArgs = args;
                if (!eventArgs.cancel) {
                    if (this._visibleSubmenu === submenu) {
                        this._visibleSubmenu = null
                    }
                    $border.hide();
                    $rootItem.removeClass(DX_MENU_ITEM_EXPANDED_CLASS)
                }
            };
            _proto._submenuOnHiddenHandler = function($rootItem, submenu) {
                this._actions.onSubmenuHidden({
                    rootItem: (0, _element.getPublicElement)($rootItem),
                    submenu: submenu
                })
            };
            _proto._submenuMouseLeaveHandler = function($rootItem, eventArgs) {
                var target = (0, _renderer.default)(eventArgs.relatedTarget).parents(".".concat(DX_CONTEXT_MENU_CLASS))[0];
                var contextMenu = this._getSubmenuByRootElement($rootItem).getOverlayContent()[0];
                if (this.option("hideSubmenuOnMouseLeave") && target !== contextMenu) {
                    this._clearTimeouts();
                    setTimeout(this._hideSubmenuAfterTimeout.bind(this), this._getDelay("hide"))
                }
            };
            _proto._hideSubmenuAfterTimeout = function() {
                if (!this._visibleSubmenu) {
                    return
                }
                var isRootItemHovered = (0, _renderer.default)(this._visibleSubmenu.$element().context).hasClass(DX_STATE_HOVER_CLASS);
                var isSubmenuItemHovered = this._visibleSubmenu.getOverlayContent().find(".".concat(DX_STATE_HOVER_CLASS)).length;
                var hoveredElementFromSubMenu = this._visibleSubmenu.getOverlayContent().get(0).querySelector(":hover");
                if (!hoveredElementFromSubMenu && !isSubmenuItemHovered && !isRootItemHovered) {
                    this._visibleSubmenu.hide()
                }
            };
            _proto._getSubmenuByRootElement = function($rootItem) {
                if (!$rootItem) {
                    return false
                }
                var $submenu = $rootItem.children(".".concat(DX_CONTEXT_MENU_CLASS));
                return $submenu.length && _ui2.default.getInstance($submenu)
            };
            _proto.getSubmenuPosition = function($rootItem) {
                var isHorizontalMenu = this._isMenuHorizontal();
                var submenuDirection = this.option("submenuDirection").toLowerCase();
                var rtlEnabled = this.option("rtlEnabled");
                var submenuPosition = {
                    collision: "flip",
                    of: $rootItem
                };
                switch (submenuDirection) {
                    case "leftortop":
                        submenuPosition.at = "left top";
                        submenuPosition.my = isHorizontalMenu ? "left bottom" : "right top";
                        break;
                    case "rightorbottom":
                        submenuPosition.at = isHorizontalMenu ? "left bottom" : "right top";
                        submenuPosition.my = "left top";
                        break;
                    default:
                        if (isHorizontalMenu) {
                            submenuPosition.at = rtlEnabled ? "right bottom" : "left bottom";
                            submenuPosition.my = rtlEnabled ? "right top" : "left top"
                        } else {
                            submenuPosition.at = rtlEnabled ? "left top" : "right top";
                            submenuPosition.my = rtlEnabled ? "right top" : "left top"
                        }
                }
                return submenuPosition
            };
            _proto._renderBorderElement = function($item) {
                (0, _renderer.default)("<div>").appendTo($item).addClass(DX_CONTEXT_MENU_CONTAINER_BORDER_CLASS).hide()
            };
            _proto._itemPointerDownHandler = function(e) {
                var $target = (0, _renderer.default)(e.target);
                var $closestItem = $target.closest(this._itemElements());
                if ($closestItem.hasClass("dx-menu-item-has-submenu")) {
                    this.option("focusedElement", null);
                    return
                }
                _MenuBase.prototype._itemPointerDownHandler.call(this, e)
            };
            _proto._hoverStartHandler = function(e) {
                var mouseMoveEventName = (0, _index.addNamespace)(_pointer.default.move, this.NAME);
                var $item = this._getItemElementByEventArgs(e);
                var node = this._dataAdapter.getNodeByItem(this._getItemData($item));
                var isSelectionActive = (0, _type.isDefined)(e.buttons) && 1 === e.buttons || !(0, _type.isDefined)(e.buttons) && 1 === e.which;
                if (this._isItemDisabled($item)) {
                    return
                }
                _events_engine.default.off($item, mouseMoveEventName);
                if (!this._hasChildren(node)) {
                    this._showSubmenuTimer = setTimeout(this._hideSubmenuAfterTimeout.bind(this), this._getDelay("hide"));
                    return
                }
                if ("onHover" === this._getShowFirstSubmenuMode() && !isSelectionActive) {
                    var submenu = this._getSubmenuByElement($item);
                    this._clearTimeouts();
                    if (!submenu.isOverlayVisible()) {
                        _events_engine.default.on($item, mouseMoveEventName, this._itemMouseMoveHandler.bind(this));
                        this._showSubmenuTimer = this._getDelay("hide")
                    }
                }
            };
            _proto._hoverEndHandler = function(eventArg) {
                var _this7 = this;
                var $item = this._getItemElementByEventArgs(eventArg);
                var relatedTarget = (0, _renderer.default)(eventArg.relatedTarget);
                _MenuBase.prototype._hoverEndHandler.call(this, eventArg);
                this._clearTimeouts();
                if (this._isItemDisabled($item)) {
                    return
                }
                if (relatedTarget.hasClass(DX_CONTEXT_MENU_CONTENT_DELIMITER_CLASS)) {
                    return
                }
                if (this.option("hideSubmenuOnMouseLeave") && !relatedTarget.hasClass(DX_MENU_ITEMS_CONTAINER_CLASS)) {
                    this._hideSubmenuTimer = setTimeout(function() {
                        _this7._hideSubmenuAfterTimeout()
                    }, this._getDelay("hide"))
                }
            };
            _proto._hideVisibleSubmenu = function() {
                if (!this._visibleSubmenu) {
                    return false
                }
                this._hideSubmenu(this._visibleSubmenu);
                return true
            };
            _proto._showSubmenu = function($itemElement) {
                var submenu = this._getSubmenuByElement($itemElement);
                if (this._visibleSubmenu !== submenu) {
                    this._hideVisibleSubmenu()
                }
                if (submenu) {
                    this._clearTimeouts();
                    submenu.show();
                    this.option("focusedElement", submenu.option("focusedElement"))
                }
                this._visibleSubmenu = submenu;
                this._hoveredRootItem = $itemElement
            };
            _proto._hideSubmenu = function(submenu) {
                submenu && submenu.hide();
                if (this._visibleSubmenu === submenu) {
                    this._visibleSubmenu = null
                }
                this._hoveredRootItem = null
            };
            _proto._itemMouseMoveHandler = function(e) {
                var _this8 = this;
                if (e.pointers && e.pointers.length) {
                    return
                }
                var $item = (0, _renderer.default)(e.currentTarget);
                if (!(0, _type.isDefined)(this._showSubmenuTimer)) {
                    return
                }
                this._clearTimeouts();
                this._showSubmenuTimer = setTimeout(function() {
                    var submenu = _this8._getSubmenuByElement($item);
                    if (submenu && !submenu.isOverlayVisible()) {
                        _this8._showSubmenu($item)
                    }
                }, this._getDelay("show"))
            };
            _proto._clearTimeouts = function() {
                clearTimeout(this._hideSubmenuTimer);
                clearTimeout(this._showSubmenuTimer)
            };
            _proto._getSubmenuByElement = function($itemElement, itemData) {
                var submenu = this._getSubmenuByRootElement($itemElement);
                if (submenu) {
                    return submenu
                } else {
                    itemData = itemData || this._getItemData($itemElement);
                    var node = this._dataAdapter.getNodeByItem(itemData);
                    return this._hasChildren(node) && this._renderSubmenuItems(node, $itemElement)
                }
            };
            _proto._updateSubmenuVisibilityOnClick = function(actionArgs) {
                var args = actionArgs.args.length && actionArgs.args[0];
                if (!args || this._disabledGetter(args.itemData)) {
                    return
                }
                var $itemElement = (0, _renderer.default)(args.itemElement);
                var currentSubmenu = this._getSubmenuByElement($itemElement, args.itemData);
                this._updateSelectedItemOnClick(actionArgs);
                if (this._visibleSubmenu) {
                    if (this._visibleSubmenu === currentSubmenu) {
                        if ("onClick" === this.option("showFirstSubmenuMode")) {
                            this._hideSubmenu(this._visibleSubmenu)
                        }
                        return
                    } else {
                        this._hideSubmenu(this._visibleSubmenu)
                    }
                }
                if (!currentSubmenu) {
                    return
                }
                if (!currentSubmenu.isOverlayVisible()) {
                    this._showSubmenu($itemElement);
                    return
                }
            };
            _proto._optionChanged = function(args) {
                if (ACTIONS.indexOf(args.name) >= 0) {
                    this._initActions();
                    return
                }
                switch (args.name) {
                    case "orientation":
                    case "submenuDirection":
                        this._invalidate();
                        break;
                    case "showFirstSubmenuMode":
                    case "hideSubmenuOnMouseLeave":
                        break;
                    case "showSubmenuMode":
                        this._changeSubmenusOption(args.name, args.value);
                        break;
                    case "adaptivityEnabled":
                        args.value ? this._initAdaptivity() : this._removeAdaptivity();
                        break;
                    case "width":
                        if (this._isAdaptivityEnabled()) {
                            this._treeView.option(args.name, args.value);
                            this._overlay.option(args.name, args.value)
                        }
                        _MenuBase.prototype._optionChanged.call(this, args);
                        this._dimensionChanged();
                        break;
                    case "animation":
                        if (this._isAdaptivityEnabled()) {
                            this._treeView.option("animationEnabled", !!args.value)
                        }
                        _MenuBase.prototype._optionChanged.call(this, args);
                        break;
                    default:
                        if (this._isAdaptivityEnabled()) {
                            this._treeView.option(args.name, args.value)
                        }
                        _MenuBase.prototype._optionChanged.call(this, args)
                }
            };
            _proto._changeSubmenusOption = function(name, value) {
                (0, _iterator.each)(this._submenus, function(index, submenu) {
                    submenu.option(name, value)
                })
            };
            _proto.selectItem = function(itemElement) {
                this._hideSubmenu(this._visibleSubmenu);
                _MenuBase.prototype.selectItem.call(this, itemElement)
            };
            _proto.unselectItem = function(itemElement) {
                this._hideSubmenu(this._visibleSubmenu);
                _MenuBase.prototype.selectItem.call(this, itemElement)
            };
            return Menu
        }(_ui.default);
        (0, _component_registrator.default)("dxMenu", Menu);
        var _default = Menu;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.header_filter.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.modules */ 44));
        var _filtering = _interopRequireDefault(__webpack_require__( /*! ../shared/filtering */ 182));
        var _uiGrid_core2 = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.utils */ 35));
        var _uiGrid_core3 = __webpack_require__( /*! ./ui.grid_core.header_filter_core */ 408);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _click = __webpack_require__( /*! ../../events/click */ 21);
        var _data = __webpack_require__( /*! ../../core/utils/data */ 20);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _position = __webpack_require__( /*! ../../core/utils/position */ 22);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _utils = __webpack_require__( /*! ../../data/data_source/utils */ 69);
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../localization/date */ 32));
        var _variable_wrapper = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/variable_wrapper */ 102));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _accessibility = __webpack_require__( /*! ../shared/accessibility */ 118);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DATE_INTERVAL_FORMATS = {
            month: function(value) {
                return _date.default.getMonthNames()[value - 1]
            },
            quarter: function(value) {
                return _date.default.format(new Date(2e3, 3 * value - 1), "quarter")
            }
        };
        var HeaderFilterController = _uiGrid_core.default.ViewController.inherit(function() {
            var getFormatOptions = function(value, column, currentLevel) {
                var groupInterval = _filtering.default.getGroupInterval(column);
                var result = _uiGrid_core2.default.getFormatOptionsByColumn(column, "headerFilter");
                if (groupInterval) {
                    result.groupInterval = groupInterval[currentLevel];
                    if (_uiGrid_core2.default.isDateType(column.dataType)) {
                        result.format = DATE_INTERVAL_FORMATS[groupInterval[currentLevel]]
                    } else {
                        if ("number" === column.dataType) {
                            result.getDisplayFormat = function() {
                                var formatOptions = {
                                    format: column.format,
                                    target: "headerFilter"
                                };
                                var firstValueText = _uiGrid_core2.default.formatValue(value, formatOptions);
                                var secondValue = value + groupInterval[currentLevel];
                                var secondValueText = _uiGrid_core2.default.formatValue(secondValue, formatOptions);
                                return firstValueText && secondValueText ? firstValueText + " - " + secondValueText : ""
                            }
                        }
                    }
                }
                return result
            };
            return {
                init: function() {
                    this._columnsController = this.getController("columns");
                    this._dataController = this.getController("data");
                    this._headerFilterView = this.getView("headerFilterView")
                },
                _updateSelectedState: function(items, column) {
                    var i = items.length;
                    var isExclude = "exclude" === column.filterType;
                    while (i--) {
                        var item = items[i];
                        if ("items" in items[i]) {
                            this._updateSelectedState(items[i].items, column)
                        }(0, _uiGrid_core3.updateHeaderFilterItemSelectionState)(item, _uiGrid_core2.default.getIndexByKey(items[i].value, column.filterValues, null) > -1, isExclude)
                    }
                },
                _normalizeGroupItem: function(item, currentLevel, options) {
                    var value;
                    var displayValue;
                    var path = options.path;
                    var valueSelector = options.valueSelector;
                    var displaySelector = options.displaySelector;
                    var column = options.column;
                    if (valueSelector && displaySelector) {
                        value = valueSelector(item);
                        displayValue = displaySelector(item)
                    } else {
                        value = item.key;
                        displayValue = value
                    }
                    if (!(0, _type.isObject)(item)) {
                        item = {}
                    } else {
                        item = (0, _extend.extend)({}, item)
                    }
                    path.push(value);
                    if (1 === path.length) {
                        item.value = path[0]
                    } else {
                        item.value = path.join("/")
                    }
                    item.text = this.getHeaderItemText(displayValue, column, currentLevel, options.headerFilterOptions);
                    return item
                },
                getHeaderItemText: function(displayValue, column, currentLevel, headerFilterOptions) {
                    var text = _uiGrid_core2.default.formatValue(displayValue, getFormatOptions(displayValue, column, currentLevel));
                    if (!text) {
                        text = headerFilterOptions.texts.emptyValue
                    }
                    return text
                },
                _processGroupItems: function(groupItems, currentLevel, path, options) {
                    var that = this;
                    var displaySelector;
                    var valueSelector;
                    var column = options.column;
                    var lookup = column.lookup;
                    var level = options.level;
                    path = path || [];
                    currentLevel = currentLevel || 0;
                    if (lookup) {
                        displaySelector = (0, _data.compileGetter)(lookup.displayExpr);
                        valueSelector = (0, _data.compileGetter)(lookup.valueExpr)
                    }
                    for (var i = 0; i < groupItems.length; i++) {
                        groupItems[i] = that._normalizeGroupItem(groupItems[i], currentLevel, {
                            column: options.column,
                            headerFilterOptions: options.headerFilterOptions,
                            displaySelector: displaySelector,
                            valueSelector: valueSelector,
                            path: path
                        });
                        if ("items" in groupItems[i]) {
                            if (currentLevel === level || !(0, _type.isDefined)(groupItems[i].value)) {
                                delete groupItems[i].items
                            } else {
                                that._processGroupItems(groupItems[i].items, currentLevel + 1, path, options)
                            }
                        }
                        path.pop()
                    }
                },
                getDataSource: function(column) {
                    var that = this;
                    var dataSource = that._dataController.dataSource();
                    var group = _uiGrid_core2.default.getHeaderFilterGroupParameters(column, dataSource && dataSource.remoteOperations().grouping);
                    var headerFilterDataSource = column.headerFilter && column.headerFilter.dataSource;
                    var headerFilterOptions = that.option("headerFilter");
                    var isLookup = false;
                    var options = {
                        component: that.component
                    };
                    if (!dataSource) {
                        return
                    }
                    if ((0, _type.isDefined)(headerFilterDataSource) && !(0, _type.isFunction)(headerFilterDataSource)) {
                        options.dataSource = (0, _utils.normalizeDataSourceOptions)(headerFilterDataSource)
                    } else {
                        if (column.lookup) {
                            isLookup = true;
                            var lookupDataSourceOptions;
                            if (column.lookup.items) {
                                lookupDataSourceOptions = column.lookup.items
                            } else {
                                lookupDataSourceOptions = column.lookup.dataSource;
                                if ((0, _type.isFunction)(lookupDataSourceOptions) && !_variable_wrapper.default.isWrapped(lookupDataSourceOptions)) {
                                    lookupDataSourceOptions = lookupDataSourceOptions({})
                                }
                            }
                            options.dataSource = (0, _utils.normalizeDataSourceOptions)(lookupDataSourceOptions)
                        } else {
                            var cutoffLevel = Array.isArray(group) ? group.length - 1 : 0;
                            that._currentColumn = column;
                            var filter = that._dataController.getCombinedFilter();
                            that._currentColumn = null;
                            options.dataSource = {
                                filter: filter,
                                group: group,
                                useDefaultSearch: true,
                                load: function(options) {
                                    var d = new _deferred.Deferred;
                                    options.dataField = column.dataField || column.name;
                                    dataSource.load(options).done(function(data) {
                                        that._processGroupItems(data, null, null, {
                                            level: cutoffLevel,
                                            column: column,
                                            headerFilterOptions: headerFilterOptions
                                        });
                                        d.resolve(data)
                                    }).fail(d.reject);
                                    return d
                                }
                            }
                        }
                    }
                    if ((0, _type.isFunction)(headerFilterDataSource)) {
                        headerFilterDataSource.call(column, options)
                    }
                    var origPostProcess = options.dataSource.postProcess;
                    options.dataSource.postProcess = function(data) {
                        var items = data;
                        if (isLookup) {
                            if (0 === this.pageIndex() && !this.searchValue()) {
                                items = items.slice(0);
                                items.unshift(null)
                            }
                            that._processGroupItems(items, null, null, {
                                level: 0,
                                column: column,
                                headerFilterOptions: headerFilterOptions
                            })
                        }
                        items = origPostProcess && origPostProcess.call(this, items) || items;
                        that._updateSelectedState(items, column);
                        return items
                    };
                    return options.dataSource
                },
                getCurrentColumn: function() {
                    return this._currentColumn
                },
                showHeaderFilterMenu: function(columnIndex, isGroupPanel) {
                    var columnsController = this._columnsController;
                    var column = (0, _extend.extend)(true, {}, this._columnsController.getColumns()[columnIndex]);
                    if (column) {
                        var visibleIndex = columnsController.getVisibleIndex(columnIndex);
                        var view = isGroupPanel ? this.getView("headerPanel") : this.getView("columnHeadersView");
                        var $columnElement = $columnElement || view.getColumnElements().eq(isGroupPanel ? column.groupIndex : visibleIndex);
                        this.showHeaderFilterMenuBase({
                            columnElement: $columnElement,
                            column: column,
                            applyFilter: true,
                            apply: function() {
                                columnsController.columnOption(columnIndex, {
                                    filterValues: this.filterValues,
                                    filterType: this.filterType
                                })
                            }
                        })
                    }
                },
                showHeaderFilterMenuBase: function(options) {
                    var _this = this;
                    var that = this;
                    var column = options.column;
                    if (column) {
                        var groupInterval = _filtering.default.getGroupInterval(column);
                        var dataSource = that._dataController.dataSource();
                        var remoteFiltering = dataSource && dataSource.remoteOperations().filtering;
                        (0, _extend.extend)(options, column, {
                            type: groupInterval && groupInterval.length > 1 ? "tree" : "list",
                            remoteFiltering: remoteFiltering,
                            onShowing: function(e) {
                                var dxResizableInstance = e.component.overlayContent().dxResizable("instance");
                                dxResizableInstance && dxResizableInstance.option("onResizeEnd", function(e) {
                                    var columnsController = that.getController("columns");
                                    var headerFilterByColumn = columnsController.columnOption(options.dataField, "headerFilter");
                                    headerFilterByColumn = headerFilterByColumn || {};
                                    headerFilterByColumn.width = e.width;
                                    headerFilterByColumn.height = e.height;
                                    columnsController.columnOption(options.dataField, "headerFilter", headerFilterByColumn, true)
                                })
                            },
                            onHidden: function() {
                                return (0, _accessibility.restoreFocus)(_this)
                            }
                        });
                        options.dataSource = that.getDataSource(options);
                        if (options.isFilterBuilder) {
                            options.dataSource.filter = null;
                            options.alignment = "right"
                        }
                        that._headerFilterView.showHeaderFilterMenu(options.columnElement, options)
                    }
                },
                hideHeaderFilterMenu: function() {
                    this._headerFilterView.hideHeaderFilterMenu()
                }
            }
        }());
        var ColumnHeadersViewHeaderFilterExtender = (0, _extend.extend)({}, _uiGrid_core3.headerFilterMixin, {
            _renderCellContent: function($cell, options) {
                var that = this;
                var $headerFilterIndicator;
                var column = options.column;
                if (!column.command && (0, _uiGrid_core3.allowHeaderFiltering)(column) && that.option("headerFilter.visible") && "header" === options.rowType) {
                    $headerFilterIndicator = that._applyColumnState({
                        name: "headerFilter",
                        rootElement: $cell,
                        column: column,
                        showColumnLines: that.option("showColumnLines")
                    });
                    $headerFilterIndicator && that._subscribeToIndicatorEvent($headerFilterIndicator, column, "headerFilter")
                }
                that.callBase($cell, options)
            },
            _subscribeToIndicatorEvent: function($indicator, column, indicatorName) {
                var that = this;
                if ("headerFilter" === indicatorName) {
                    _events_engine.default.on($indicator, _click.name, that.createAction(function(e) {
                        e.event.stopPropagation();
                        that.getController("headerFilter").showHeaderFilterMenu(column.index, false)
                    }))
                }
            },
            _updateIndicator: function($cell, column, indicatorName) {
                var $indicator = this.callBase($cell, column, indicatorName);
                $indicator && this._subscribeToIndicatorEvent($indicator, column, indicatorName)
            },
            _updateHeaderFilterIndicators: function() {
                if (this.option("headerFilter.visible")) {
                    this._updateIndicators("headerFilter")
                }
            },
            _needUpdateFilterIndicators: function() {
                return true
            },
            _columnOptionChanged: function(e) {
                var optionNames = e.optionNames;
                if (_uiGrid_core2.default.checkChanges(optionNames, ["filterValues", "filterType"])) {
                    if (this._needUpdateFilterIndicators()) {
                        this._updateHeaderFilterIndicators()
                    }
                    return
                }
                this.callBase(e)
            }
        });
        var HeaderPanelHeaderFilterExtender = (0, _extend.extend)({}, _uiGrid_core3.headerFilterMixin, {
            _createGroupPanelItem: function($rootElement, groupColumn) {
                var that = this;
                var $item = that.callBase.apply(that, arguments);
                var $headerFilterIndicator;
                if (!groupColumn.command && (0, _uiGrid_core3.allowHeaderFiltering)(groupColumn) && that.option("headerFilter.visible")) {
                    $headerFilterIndicator = that._applyColumnState({
                        name: "headerFilter",
                        rootElement: $item,
                        column: {
                            alignment: (0, _position.getDefaultAlignment)(that.option("rtlEnabled")),
                            filterValues: groupColumn.filterValues,
                            allowHeaderFiltering: true
                        },
                        showColumnLines: true
                    });
                    $headerFilterIndicator && _events_engine.default.on($headerFilterIndicator, _click.name, that.createAction(function(e) {
                        var event = e.event;
                        event.stopPropagation();
                        that.getController("headerFilter").showHeaderFilterMenu(groupColumn.index, true)
                    }))
                }
                return $item
            }
        });

        function invertFilterExpression(filter) {
            return ["!", filter]
        }
        var DataControllerFilterRowExtender = {
            skipCalculateColumnFilters: function() {
                return false
            },
            _calculateAdditionalFilter: function() {
                if (this.skipCalculateColumnFilters()) {
                    return this.callBase()
                }
                var that = this;
                var filters = [that.callBase()];
                var columns = that._columnsController.getVisibleColumns(null, true);
                var headerFilterController = that.getController("headerFilter");
                var currentColumn = headerFilterController.getCurrentColumn();
                (0, _iterator.each)(columns, function(_, column) {
                    var filter;
                    if (currentColumn && currentColumn.index === column.index) {
                        return
                    }
                    if ((0, _uiGrid_core3.allowHeaderFiltering)(column) && column.calculateFilterExpression && Array.isArray(column.filterValues) && column.filterValues.length) {
                        var filterValues = [];
                        (0, _iterator.each)(column.filterValues, function(_, filterValue) {
                            if (Array.isArray(filterValue)) {
                                filter = filterValue
                            } else {
                                if (column.deserializeValue && !_uiGrid_core2.default.isDateType(column.dataType) && "number" !== column.dataType) {
                                    filterValue = column.deserializeValue(filterValue)
                                }
                                filter = column.createFilterExpression(filterValue, "=", "headerFilter")
                            }
                            if (filter) {
                                filter.columnIndex = column.index
                            }
                            filterValues.push(filter)
                        });
                        filterValues = _uiGrid_core2.default.combineFilters(filterValues, "or");
                        filters.push("exclude" === column.filterType ? ["!", filterValues] : filterValues)
                    }
                });
                return _uiGrid_core2.default.combineFilters(filters)
            }
        };
        var _default = {
            invertFilterExpression: invertFilterExpression,
            defaultOptions: function() {
                return {
                    headerFilter: {
                        visible: false,
                        width: 252,
                        height: 325,
                        allowSearch: false,
                        searchTimeout: 500,
                        texts: {
                            emptyValue: _message.default.format("dxDataGrid-headerFilterEmptyValue"),
                            ok: _message.default.format("dxDataGrid-headerFilterOK"),
                            cancel: _message.default.format("dxDataGrid-headerFilterCancel")
                        }
                    }
                }
            },
            controllers: {
                headerFilter: HeaderFilterController
            },
            views: {
                headerFilterView: _uiGrid_core3.HeaderFilterView
            },
            extenders: {
                controllers: {
                    data: DataControllerFilterRowExtender
                },
                views: {
                    columnHeadersView: ColumnHeadersViewHeaderFilterExtender,
                    headerPanel: HeaderPanelHeaderFilterExtender
                }
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.header_filter_core.js ***!
      \**********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.updateHeaderFilterItemSelectionState = updateHeaderFilterItemSelectionState;
        exports.headerFilterMixin = exports.allowHeaderFiltering = exports.HeaderFilterView = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.modules */ 44));
        var _uiGrid_core2 = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.utils */ 35));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _popup = _interopRequireDefault(__webpack_require__( /*! ../popup */ 46));
        var _tree_view = _interopRequireDefault(__webpack_require__( /*! ../tree_view */ 158));
        var _list = _interopRequireDefault(__webpack_require__( /*! ../list */ 112));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var HEADER_FILTER_CLASS = "dx-header-filter";
        var HEADER_FILTER_MENU_CLASS = "dx-header-filter-menu";
        var DEFAULT_SEARCH_EXPRESSION = "text";

        function resetChildrenItemSelection(items) {
            items = items || [];
            for (var i = 0; i < items.length; i++) {
                items[i].selected = false;
                resetChildrenItemSelection(items[i].items)
            }
        }

        function updateSelectAllState(e, filterValues) {
            if (e.component.option("searchValue")) {
                return
            }
            var selectAllCheckBox = (0, _renderer.default)(e.element).find(".dx-list-select-all-checkbox").data("dxCheckBox");
            if (selectAllCheckBox && filterValues && filterValues.length) {
                selectAllCheckBox.option("value", void 0)
            }
        }

        function isSearchEnabled(that, options) {
            var headerFilter = options.headerFilter;
            if (headerFilter && (0, _type.isDefined)(headerFilter.allowSearch)) {
                return headerFilter.allowSearch
            }
            return that.option("headerFilter.allowSearch")
        }

        function updateHeaderFilterItemSelectionState(item, filterValuesMatch, isExcludeFilter) {
            if (filterValuesMatch ^ isExcludeFilter) {
                item.selected = true;
                if (isExcludeFilter && item.items) {
                    for (var j = 0; j < item.items.length; j++) {
                        if (!item.items[j].selected) {
                            item.selected = void 0;
                            break
                        }
                    }
                }
            } else {
                if (isExcludeFilter || item.selected) {
                    item.selected = false;
                    resetChildrenItemSelection(item.items)
                }
            }
        }
        var HeaderFilterView = _uiGrid_core.default.View.inherit({
            getPopupContainer: function() {
                return this._popupContainer
            },
            getListContainer: function() {
                return this._listContainer
            },
            applyHeaderFilter: function(options) {
                var that = this;
                var list = that.getListContainer();
                var searchValue = list.option("searchValue");
                var isSelectAll = !searchValue && !options.isFilterBuilder && list.$element().find(".dx-checkbox").eq(0).hasClass("dx-checkbox-checked");
                var filterValues = [];
                var fillSelectedItemKeys = function fillSelectedItemKeys(filterValues, items, isExclude) {
                    (0, _iterator.each)(items, function(_, item) {
                        if (void 0 !== item.selected && !!item.selected ^ isExclude) {
                            var node = list._getNode(item);
                            var hasChildren = list._hasChildren(node);
                            var hasChildrenWithSelection = hasChildren && item.items && item.items.some(function(item) {
                                return item.selected
                            });
                            if (!searchValue || !hasChildrenWithSelection) {
                                filterValues.push(item.value);
                                return
                            }
                        }
                        if (item.items && item.items.length) {
                            fillSelectedItemKeys(filterValues, item.items, isExclude)
                        }
                    })
                };
                if (!isSelectAll) {
                    if ("tree" === options.type) {
                        if (options.filterType) {
                            options.filterType = "include"
                        }
                        fillSelectedItemKeys(filterValues, list.option("items"), false);
                        options.filterValues = filterValues
                    }
                } else {
                    if ("tree" === options.type) {
                        options.filterType = "exclude"
                    }
                    if (Array.isArray(options.filterValues)) {
                        options.filterValues = []
                    }
                }
                if (options.filterValues && !options.filterValues.length) {
                    options.filterValues = null
                }
                options.apply();
                that.hideHeaderFilterMenu()
            },
            showHeaderFilterMenu: function($columnElement, options) {
                var that = this;
                if (options) {
                    that._initializePopupContainer(options);
                    var popupContainer = that.getPopupContainer();
                    that.hideHeaderFilterMenu();
                    that.updatePopup($columnElement, options);
                    popupContainer.show()
                }
            },
            hideHeaderFilterMenu: function() {
                var headerFilterMenu = this.getPopupContainer();
                headerFilterMenu && headerFilterMenu.hide()
            },
            updatePopup: function($element, options) {
                var that = this;
                var alignment = "right" === options.alignment ? "left" : "right";
                if (that._popupContainer) {
                    that._cleanPopupContent();
                    that._popupContainer.option("position", {
                        my: alignment + " top",
                        at: alignment + " bottom",
                        of: $element,
                        collision: "flip fit"
                    })
                }
            },
            _getSearchExpr: function(options) {
                var lookup = options.lookup;
                var useDefaultSearchExpr = options.useDefaultSearchExpr;
                var headerFilterDataSource = options.headerFilter && options.headerFilter.dataSource;
                if (useDefaultSearchExpr || (0, _type.isDefined)(headerFilterDataSource) && !(0, _type.isFunction)(headerFilterDataSource)) {
                    return DEFAULT_SEARCH_EXPRESSION
                }
                if (lookup) {
                    return lookup.displayExpr || "this"
                }
                if (options.dataSource) {
                    var group = options.dataSource.group;
                    if (Array.isArray(group) && group.length > 0) {
                        return group[0].selector
                    } else {
                        if ((0, _type.isFunction)(group) && !options.remoteFiltering) {
                            return group
                        }
                    }
                }
                return options.dataField || options.selector
            },
            _cleanPopupContent: function() {
                this._popupContainer && this._popupContainer.$content().empty()
            },
            _initializePopupContainer: function(options) {
                var that = this;
                var $element = that.element();
                var headerFilterOptions = that.option("headerFilter");
                var width = options.headerFilter && options.headerFilter.width || headerFilterOptions && headerFilterOptions.width;
                var height = options.headerFilter && options.headerFilter.height || headerFilterOptions && headerFilterOptions.height;
                var dxPopupOptions = {
                    width: width,
                    height: height,
                    visible: false,
                    shading: false,
                    showTitle: false,
                    showCloseButton: false,
                    closeOnTargetScroll: false,
                    dragEnabled: false,
                    closeOnOutsideClick: true,
                    focusStateEnabled: false,
                    toolbarItems: [{
                        toolbar: "bottom",
                        location: "after",
                        widget: "dxButton",
                        options: {
                            text: headerFilterOptions.texts.ok,
                            onClick: function() {
                                that.applyHeaderFilter(options)
                            }
                        }
                    }, {
                        toolbar: "bottom",
                        location: "after",
                        widget: "dxButton",
                        options: {
                            text: headerFilterOptions.texts.cancel,
                            onClick: function() {
                                that.hideHeaderFilterMenu()
                            }
                        }
                    }],
                    resizeEnabled: true,
                    onShowing: function(e) {
                        e.component.$content().parent().addClass("dx-dropdowneditor-overlay");
                        that._initializeListContainer(options);
                        options.onShowing && options.onShowing(e)
                    },
                    onShown: function() {
                        that.getListContainer().focus()
                    },
                    onHidden: options.onHidden,
                    onInitialized: function(e) {
                        var component = e.component;
                        component.option("animation", component._getDefaultOptions().animation)
                    }
                };
                if (!(0, _type.isDefined)(that._popupContainer)) {
                    that._popupContainer = that._createComponent($element, _popup.default, dxPopupOptions)
                } else {
                    that._popupContainer.option(dxPopupOptions)
                }
            },
            _initializeListContainer: function(options) {
                var that = this;
                var $content = that._popupContainer.$content();
                var widgetOptions = {
                    searchEnabled: isSearchEnabled(that, options),
                    searchTimeout: that.option("headerFilter.searchTimeout"),
                    searchMode: options.headerFilter && options.headerFilter.searchMode || "",
                    dataSource: options.dataSource,
                    onContentReady: function() {
                        that.renderCompleted.fire()
                    },
                    itemTemplate: function(data, _, element) {
                        var $element = (0, _renderer.default)(element);
                        if (options.encodeHtml) {
                            return $element.text(data.text)
                        }
                        return $element.html(data.text)
                    }
                };

                function onOptionChanged(e) {
                    if ("searchValue" === e.fullName && !options.isFilterBuilder && false !== that.option("headerFilter.hideSelectAllOnSearch")) {
                        if ("tree" === options.type) {
                            e.component.option("showCheckBoxesMode", e.value ? "normal" : "selectAll")
                        } else {
                            e.component.option("selectionMode", e.value ? "multiple" : "all")
                        }
                    }
                }
                if ("tree" === options.type) {
                    that._listContainer = that._createComponent((0, _renderer.default)("<div>").appendTo($content), _tree_view.default, (0, _extend.extend)(widgetOptions, {
                        showCheckBoxesMode: options.isFilterBuilder ? "normal" : "selectAll",
                        onOptionChanged: onOptionChanged,
                        keyExpr: "id"
                    }))
                } else {
                    that._listContainer = that._createComponent((0, _renderer.default)("<div>").appendTo($content), _list.default, (0, _extend.extend)(widgetOptions, {
                        searchExpr: that._getSearchExpr(options),
                        pageLoadMode: "scrollBottom",
                        showSelectionControls: true,
                        selectionMode: options.isFilterBuilder ? "multiple" : "all",
                        onOptionChanged: onOptionChanged,
                        onSelectionChanged: function(e) {
                            var items = e.component.option("items");
                            var selectedItems = e.component.option("selectedItems");
                            if (!e.component._selectedItemsUpdating && !e.component.option("searchValue") && !options.isFilterBuilder) {
                                var filterValues = options.filterValues || [];
                                var isExclude = "exclude" === options.filterType;
                                if (0 === selectedItems.length && items.length && (filterValues.length <= 1 || isExclude && filterValues.length === items.length - 1)) {
                                    options.filterType = "include";
                                    options.filterValues = []
                                } else {
                                    if (selectedItems.length === items.length) {
                                        options.filterType = "exclude";
                                        options.filterValues = []
                                    }
                                }
                            }(0, _iterator.each)(items, function(index, item) {
                                var selected = _uiGrid_core2.default.getIndexByKey(item, selectedItems, null) >= 0;
                                var oldSelected = !!item.selected;
                                if (oldSelected !== selected) {
                                    item.selected = selected;
                                    options.filterValues = options.filterValues || [];
                                    var filterValueIndex = _uiGrid_core2.default.getIndexByKey(item.value, options.filterValues, null);
                                    if (filterValueIndex >= 0) {
                                        options.filterValues.splice(filterValueIndex, 1)
                                    }
                                    if (selected ^ "exclude" === options.filterType) {
                                        options.filterValues.push(item.value)
                                    }
                                }
                            });
                            updateSelectAllState(e, options.filterValues)
                        },
                        onContentReady: function(e) {
                            var component = e.component;
                            var items = component.option("items");
                            var selectedItems = [];
                            (0, _iterator.each)(items, function() {
                                if (this.selected) {
                                    selectedItems.push(this)
                                }
                            });
                            component._selectedItemsUpdating = true;
                            component.option("selectedItems", selectedItems);
                            component._selectedItemsUpdating = false;
                            updateSelectAllState(e, options.filterValues)
                        }
                    }))
                }
            },
            _renderCore: function() {
                this.element().addClass(HEADER_FILTER_MENU_CLASS)
            }
        });
        exports.HeaderFilterView = HeaderFilterView;
        var allowHeaderFiltering = function(column) {
            return (0, _type.isDefined)(column.allowHeaderFiltering) ? column.allowHeaderFiltering : column.allowFiltering
        };
        exports.allowHeaderFiltering = allowHeaderFiltering;
        var headerFilterMixin = {
            _applyColumnState: function(options) {
                var $headerFilterIndicator;
                var rootElement = options.rootElement;
                var column = options.column;
                if ("headerFilter" === options.name) {
                    rootElement.find("." + HEADER_FILTER_CLASS).remove();
                    if (allowHeaderFiltering(column)) {
                        $headerFilterIndicator = this.callBase(options).toggleClass("dx-header-filter-empty", this._isHeaderFilterEmpty(column));
                        if (!this.option("useLegacyKeyboardNavigation")) {
                            $headerFilterIndicator.attr("tabindex", this.option("tabindex") || 0)
                        }
                    }
                    return $headerFilterIndicator
                }
                return this.callBase(options)
            },
            _isHeaderFilterEmpty: function(column) {
                return !column.filterValues || !column.filterValues.length
            },
            _getIndicatorClassName: function(name) {
                if ("headerFilter" === name) {
                    return HEADER_FILTER_CLASS
                }
                return this.callBase(name)
            },
            _renderIndicator: function(options) {
                var $container = options.container;
                var $indicator = options.indicator;
                if ("headerFilter" === options.name) {
                    var rtlEnabled = this.option("rtlEnabled");
                    if ($container.children().length && (!rtlEnabled && "right" === options.columnAlignment || rtlEnabled && "left" === options.columnAlignment)) {
                        $container.prepend($indicator);
                        return
                    }
                }
                this.callBase(options)
            },
            optionChanged: function(args) {
                if ("headerFilter" === args.name) {
                    var requireReady = "columnHeadersView" === this.name;
                    this._invalidate(requireReady, requireReady);
                    args.handled = true
                } else {
                    this.callBase(args)
                }
            }
        };
        exports.headerFilterMixin = headerFilterMixin
    },
    /*!***************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.filter_sync.js ***!
      \***************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.modules */ 44));
        var _utils = __webpack_require__( /*! ../filter_builder/utils */ 219);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _uiGrid_core2 = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.utils */ 35));
        var _filtering = _interopRequireDefault(__webpack_require__( /*! ../shared/filtering */ 182));
        var _uiGrid_core3 = __webpack_require__( /*! ./ui.grid_core.filter_custom_operations */ 719);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var FILTER_ROW_OPERATIONS = ["=", "<>", "<", "<=", ">", ">=", "notcontains", "contains", "startswith", "endswith", "between"];
        var FILTER_TYPES_INCLUDE = "include";
        var FILTER_TYPES_EXCLUDE = "exclude";

        function getColumnIdentifier(column) {
            return column.dataField || column.name
        }

        function checkForErrors(columns) {
            columns.forEach(function(column) {
                var identifier = getColumnIdentifier(column);
                if (!(0, _type.isDefined)(identifier) && column.allowFiltering) {
                    throw new _ui.default.Error("E1049", column.caption)
                }
            })
        }
        var FilterSyncController = _uiGrid_core.default.Controller.inherit(function() {
            var getEmptyFilterValues = function() {
                return {
                    filterType: FILTER_TYPES_INCLUDE,
                    filterValues: void 0
                }
            };
            var canSyncHeaderFilterWithFilterRow = function(column) {
                return !_filtering.default.getGroupInterval(column) && !(column.headerFilter && column.headerFilter.dataSource)
            };
            var getHeaderFilterFromCondition = function(headerFilterCondition, column) {
                if (!headerFilterCondition) {
                    return getEmptyFilterValues()
                }
                var filterType;
                var selectedFilterOperation = headerFilterCondition[1];
                var value = headerFilterCondition[2];
                var hasArrayValue = Array.isArray(value);
                if (!hasArrayValue) {
                    if (!canSyncHeaderFilterWithFilterRow(column)) {
                        return getEmptyFilterValues()
                    }
                }
                switch (selectedFilterOperation) {
                    case "anyof":
                    case "=":
                        filterType = FILTER_TYPES_INCLUDE;
                        break;
                    case "noneof":
                    case "<>":
                        filterType = FILTER_TYPES_EXCLUDE;
                        break;
                    default:
                        return getEmptyFilterValues()
                }
                return {
                    filterType: filterType,
                    filterValues: hasArrayValue ? value : [value]
                }
            };
            var getConditionFromFilterRow = function(column) {
                var value = column.filterValue;
                if ((0, _type.isDefined)(value)) {
                    var operation = column.selectedFilterOperation || column.defaultFilterOperation || (0, _utils.getDefaultOperation)(column);
                    var filter = [getColumnIdentifier(column), operation, column.filterValue];
                    return filter
                } else {
                    return null
                }
            };
            var getConditionFromHeaderFilter = function(column) {
                var selectedOperation;
                var value;
                var filterValues = column.filterValues;
                if (!filterValues) {
                    return null
                }
                if (canSyncHeaderFilterWithFilterRow(column) && 1 === column.filterValues.length && !Array.isArray(filterValues[0])) {
                    column.filterType === FILTER_TYPES_EXCLUDE ? selectedOperation = "<>" : selectedOperation = "=";
                    value = filterValues[0]
                } else {
                    column.filterType === FILTER_TYPES_EXCLUDE ? selectedOperation = "noneof" : selectedOperation = "anyof";
                    value = filterValues
                }
                return [getColumnIdentifier(column), selectedOperation, value]
            };
            var updateHeaderFilterCondition = function(columnsController, column, headerFilterCondition) {
                var headerFilter = getHeaderFilterFromCondition(headerFilterCondition, column);
                columnsController.columnOption(getColumnIdentifier(column), headerFilter)
            };
            var updateFilterRowCondition = function(columnsController, column, condition) {
                var filterRowOptions;
                var selectedFilterOperation = condition && condition[1];
                var filterOperations = column.filterOperations || column.defaultFilterOperations;
                if ((!filterOperations || filterOperations.indexOf(selectedFilterOperation) >= 0 || selectedFilterOperation === column.defaultFilterOperation) && FILTER_ROW_OPERATIONS.indexOf(selectedFilterOperation) >= 0) {
                    if (selectedFilterOperation === column.defaultFilterOperation && !(0, _type.isDefined)(column.selectedFilterOperation)) {
                        selectedFilterOperation = column.selectedFilterOperation
                    }
                    filterRowOptions = {
                        filterValue: condition[2],
                        selectedFilterOperation: selectedFilterOperation
                    }
                } else {
                    filterRowOptions = {
                        filterValue: void 0,
                        selectedFilterOperation: void 0
                    }
                }
                columnsController.columnOption(getColumnIdentifier(column), filterRowOptions)
            };
            return {
                syncFilterValue: function() {
                    var that = this;
                    var columnsController = that.getController("columns");
                    var columns = columnsController.getFilteringColumns();
                    this._skipSyncColumnOptions = true;
                    columns.forEach(function(column) {
                        var filterConditions = (0, _utils.getMatchedConditions)(that.option("filterValue"), getColumnIdentifier(column));
                        if (1 === filterConditions.length) {
                            var filterCondition = filterConditions[0];
                            updateHeaderFilterCondition(columnsController, column, filterCondition);
                            updateFilterRowCondition(columnsController, column, filterCondition)
                        } else {
                            (0, _type.isDefined)(column.filterValues) && updateHeaderFilterCondition(columnsController, column);
                            (0, _type.isDefined)(column.filterValue) && updateFilterRowCondition(columnsController, column)
                        }
                    });
                    this._skipSyncColumnOptions = false
                },
                _initSync: function() {
                    var columns = this.getController("columns").getColumns();
                    var dataController = this.getController("data");
                    var pageIndex = dataController.pageIndex();
                    checkForErrors(columns);
                    if (!this.option("filterValue")) {
                        var filteringColumns = this.getController("columns").getFilteringColumns();
                        var filterValue = this.getFilterValueFromColumns(filteringColumns);
                        this.option("filterValue", filterValue)
                    }
                    this.syncFilterValue();
                    dataController.pageIndex(pageIndex)
                },
                init: function() {
                    var _this = this;
                    var dataController = this.getController("data");
                    if (dataController.isFilterSyncActive()) {
                        if (this.getController("columns").isAllDataTypesDefined()) {
                            this._initSync()
                        } else {
                            dataController.dataSourceChanged.add(function() {
                                return _this._initSync()
                            })
                        }
                    }
                },
                _getSyncFilterRow: function(filterValue, column) {
                    var filter = getConditionFromFilterRow(column);
                    if ((0, _type.isDefined)(filter)) {
                        return (0, _utils.syncFilters)(filterValue, filter)
                    } else {
                        return (0, _utils.removeFieldConditionsFromFilter)(filterValue, getColumnIdentifier(column))
                    }
                },
                _getSyncHeaderFilter: function(filterValue, column) {
                    var filter = getConditionFromHeaderFilter(column);
                    if (filter) {
                        return (0, _utils.syncFilters)(filterValue, filter)
                    } else {
                        return (0, _utils.removeFieldConditionsFromFilter)(filterValue, getColumnIdentifier(column))
                    }
                },
                getFilterValueFromColumns: function(columns) {
                    if (!this.getController("data").isFilterSyncActive()) {
                        return null
                    }
                    var filterValue = ["and"];
                    columns && columns.forEach(function(column) {
                        var headerFilter = getConditionFromHeaderFilter(column);
                        var filterRow = getConditionFromFilterRow(column);
                        headerFilter && (0, _utils.addItem)(headerFilter, filterValue);
                        filterRow && (0, _utils.addItem)(filterRow, filterValue)
                    });
                    return (0, _utils.getNormalizedFilter)(filterValue)
                },
                syncFilterRow: function(column, value) {
                    this.option("filterValue", this._getSyncFilterRow(this.option("filterValue"), column))
                },
                syncHeaderFilter: function(column) {
                    this.option("filterValue", this._getSyncHeaderFilter(this.option("filterValue"), column))
                },
                getCustomFilterOperations: function() {
                    var filterBuilderCustomOperations = this.option("filterBuilder.customOperations") || [];
                    return [(0, _uiGrid_core3.anyOf)(this.component), (0, _uiGrid_core3.noneOf)(this.component)].concat(filterBuilderCustomOperations)
                },
                publicMethods: function() {
                    return ["getCustomFilterOperations"]
                }
            }
        }());
        var DataControllerFilterSyncExtender = {
            isFilterSyncActive: function() {
                var filterSyncEnabledValue = this.option("filterSyncEnabled");
                return "auto" === filterSyncEnabledValue ? this.option("filterPanel.visible") : filterSyncEnabledValue
            },
            skipCalculateColumnFilters: function() {
                return (0, _type.isDefined)(this.option("filterValue")) && this.isFilterSyncActive()
            },
            _calculateAdditionalFilter: function() {
                var that = this;
                if (false === that.option("filterPanel.filterEnabled")) {
                    return that.callBase()
                }
                var filters = [that.callBase()];
                var columns = that.getController("columns").getFilteringColumns();
                var filterValue = that.option("filterValue");
                if (that.isFilterSyncActive()) {
                    var currentColumn = that.getController("headerFilter").getCurrentColumn();
                    if (currentColumn && filterValue) {
                        filterValue = (0, _utils.removeFieldConditionsFromFilter)(filterValue, getColumnIdentifier(currentColumn))
                    }
                }
                var customOperations = that.getController("filterSync").getCustomFilterOperations();
                var calculatedFilterValue = (0, _utils.getFilterExpression)(filterValue, columns, customOperations, "filterBuilder");
                if (calculatedFilterValue) {
                    filters.push(calculatedFilterValue)
                }
                return _uiGrid_core2.default.combineFilters(filters)
            },
            _parseColumnPropertyName: function(fullName) {
                var matched = fullName.match(/.*\.(.*)/);
                return matched[1]
            },
            clearFilter: function(filterName) {
                this.component.beginUpdate();
                if (arguments.length > 0) {
                    if ("filterValue" === filterName) {
                        this.option("filterValue", null)
                    }
                    this.callBase(filterName)
                } else {
                    this.option("filterValue", null);
                    this.callBase()
                }
                this.component.endUpdate()
            },
            optionChanged: function(args) {
                switch (args.name) {
                    case "filterValue":
                        this._applyFilter();
                        this.isFilterSyncActive() && this.getController("filterSync").syncFilterValue();
                        args.handled = true;
                        break;
                    case "filterSyncEnabled":
                        args.handled = true;
                        break;
                    case "columns":
                        if (this.isFilterSyncActive()) {
                            var column = this.getController("columns").getColumnByPath(args.fullName);
                            var filterSyncController = this.getController("filterSync");
                            if (column && !filterSyncController._skipSyncColumnOptions) {
                                var propertyName = this._parseColumnPropertyName(args.fullName);
                                filterSyncController._skipSyncColumnOptions = true;
                                if ("filterType" === propertyName) {
                                    if (FILTER_TYPES_EXCLUDE === args.value || FILTER_TYPES_EXCLUDE === args.previousValue) {
                                        filterSyncController.syncHeaderFilter(column)
                                    }
                                } else {
                                    if ("filterValues" === propertyName) {
                                        filterSyncController.syncHeaderFilter(column)
                                    } else {
                                        if (["filterValue", "selectedFilterOperation"].indexOf(propertyName) > -1) {
                                            filterSyncController.syncFilterRow(column, column.filterValue)
                                        }
                                    }
                                }
                                filterSyncController._skipSyncColumnOptions = false
                            }
                        }
                        this.callBase(args);
                        break;
                    default:
                        this.callBase(args)
                }
            }
        };
        var ColumnHeadersViewFilterSyncExtender = {
            _isHeaderFilterEmpty: function(column) {
                if (this.getController("data").isFilterSyncActive()) {
                    return !(0, _utils.filterHasField)(this.option("filterValue"), getColumnIdentifier(column))
                }
                return this.callBase(column)
            },
            _needUpdateFilterIndicators: function() {
                return !this.getController("data").isFilterSyncActive()
            },
            optionChanged: function(args) {
                if ("filterValue" === args.name) {
                    this._updateHeaderFilterIndicators()
                } else {
                    this.callBase(args)
                }
            }
        };
        var _default = {
            defaultOptions: function() {
                return {
                    filterValue: null,
                    filterSyncEnabled: "auto"
                }
            },
            controllers: {
                filterSync: FilterSyncController
            },
            extenders: {
                controllers: {
                    data: DataControllerFilterSyncExtender
                },
                views: {
                    columnHeadersView: ColumnHeadersViewFilterSyncExtender
                }
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.filter_builder.js ***!
      \******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.modules */ 44));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _filter_builder = _interopRequireDefault(__webpack_require__( /*! ./../filter_builder */ 411));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _scroll_view = _interopRequireDefault(__webpack_require__( /*! ./../scroll_view */ 90));
        var _popup = _interopRequireDefault(__webpack_require__( /*! ./../popup */ 46));
        var _accessibility = __webpack_require__( /*! ../shared/accessibility */ 118);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var FilterBuilderView = _uiGrid_core.default.View.inherit({
            _renderCore: function() {
                this._updatePopupOptions()
            },
            _updatePopupOptions: function() {
                if (this.option("filterBuilderPopup.visible")) {
                    this._initPopup()
                } else {
                    if (this._filterBuilderPopup) {
                        this._filterBuilderPopup.hide()
                    }
                }
            },
            _disposePopup: function() {
                if (this._filterBuilderPopup) {
                    this._filterBuilderPopup.dispose();
                    this._filterBuilderPopup = void 0
                }
                if (this._filterBuilder) {
                    this._filterBuilder.dispose();
                    this._filterBuilder = void 0
                }
            },
            _initPopup: function() {
                var that = this;
                that._disposePopup();
                that._filterBuilderPopup = that._createComponent(that.element(), _popup.default, (0, _extend.extend)({
                    title: _message.default.format("dxDataGrid-filterBuilderPopupTitle"),
                    contentTemplate: function($contentElement) {
                        return that._getPopupContentTemplate($contentElement)
                    },
                    onOptionChanged: function(args) {
                        if ("visible" === args.name) {
                            that.option("filterBuilderPopup.visible", args.value)
                        }
                    },
                    toolbarItems: that._getPopupToolbarItems()
                }, that.option("filterBuilderPopup"), {
                    onHidden: function(e) {
                        (0, _accessibility.restoreFocus)(that);
                        that._disposePopup()
                    }
                }))
            },
            _getPopupContentTemplate: function(contentElement) {
                var $contentElement = (0, _renderer.default)(contentElement);
                var $filterBuilderContainer = (0, _renderer.default)("<div>").appendTo((0, _renderer.default)(contentElement));
                this._filterBuilder = this._createComponent($filterBuilderContainer, _filter_builder.default, (0, _extend.extend)({
                    value: this.option("filterValue"),
                    fields: this.getController("columns").getFilteringColumns()
                }, this.option("filterBuilder"), {
                    customOperations: this.getController("filterSync").getCustomFilterOperations()
                }));
                this._createComponent($contentElement, _scroll_view.default, {
                    direction: "both"
                })
            },
            _getPopupToolbarItems: function() {
                var that = this;
                return [{
                    toolbar: "bottom",
                    location: "after",
                    widget: "dxButton",
                    options: {
                        text: _message.default.format("OK"),
                        onClick: function(e) {
                            var filter = that._filterBuilder.option("value");
                            that.option("filterValue", filter);
                            that._filterBuilderPopup.hide()
                        }
                    }
                }, {
                    toolbar: "bottom",
                    location: "after",
                    widget: "dxButton",
                    options: {
                        text: _message.default.format("Cancel"),
                        onClick: function(e) {
                            that._filterBuilderPopup.hide()
                        }
                    }
                }]
            },
            optionChanged: function(args) {
                switch (args.name) {
                    case "filterBuilder":
                    case "filterBuilderPopup":
                        this._invalidate();
                        args.handled = true;
                        break;
                    default:
                        this.callBase(args)
                }
            }
        });
        var _default = {
            defaultOptions: function() {
                return {
                    filterBuilder: {
                        groupOperationDescriptions: {
                            and: _message.default.format("dxFilterBuilder-and"),
                            or: _message.default.format("dxFilterBuilder-or"),
                            notAnd: _message.default.format("dxFilterBuilder-notAnd"),
                            notOr: _message.default.format("dxFilterBuilder-notOr")
                        },
                        filterOperationDescriptions: {
                            between: _message.default.format("dxFilterBuilder-filterOperationBetween"),
                            equal: _message.default.format("dxFilterBuilder-filterOperationEquals"),
                            notEqual: _message.default.format("dxFilterBuilder-filterOperationNotEquals"),
                            lessThan: _message.default.format("dxFilterBuilder-filterOperationLess"),
                            lessThanOrEqual: _message.default.format("dxFilterBuilder-filterOperationLessOrEquals"),
                            greaterThan: _message.default.format("dxFilterBuilder-filterOperationGreater"),
                            greaterThanOrEqual: _message.default.format("dxFilterBuilder-filterOperationGreaterOrEquals"),
                            startsWith: _message.default.format("dxFilterBuilder-filterOperationStartsWith"),
                            contains: _message.default.format("dxFilterBuilder-filterOperationContains"),
                            notContains: _message.default.format("dxFilterBuilder-filterOperationNotContains"),
                            endsWith: _message.default.format("dxFilterBuilder-filterOperationEndsWith"),
                            isBlank: _message.default.format("dxFilterBuilder-filterOperationIsBlank"),
                            isNotBlank: _message.default.format("dxFilterBuilder-filterOperationIsNotBlank")
                        }
                    },
                    filterBuilderPopup: {}
                }
            },
            views: {
                filterBuilderView: FilterBuilderView
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/filter_builder.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _filter_builder = _interopRequireDefault(__webpack_require__( /*! ./filter_builder/filter_builder */ 721));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _filter_builder.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.filter_panel.js ***!
      \****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.modules */ 44));
        var _uiGrid_core2 = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.utils */ 35));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _check_box = _interopRequireDefault(__webpack_require__( /*! ../check_box */ 136));
        var _utils = __webpack_require__( /*! ../filter_builder/utils */ 219);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _inflector = __webpack_require__( /*! ../../core/utils/inflector */ 39);
        var _uiGrid_core3 = __webpack_require__( /*! ./ui.grid_core.accessibility */ 290);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var FILTER_PANEL_CLASS = "filter-panel";
        var FILTER_PANEL_TEXT_CLASS = FILTER_PANEL_CLASS + "-text";
        var FILTER_PANEL_CHECKBOX_CLASS = FILTER_PANEL_CLASS + "-checkbox";
        var FILTER_PANEL_CLEAR_FILTER_CLASS = FILTER_PANEL_CLASS + "-clear-filter";
        var FILTER_PANEL_LEFT_CONTAINER = FILTER_PANEL_CLASS + "-left";
        var FILTER_PANEL_TARGET = "filterPanel";
        var FilterPanelView = _uiGrid_core.default.View.inherit({
            isVisible: function() {
                return this.option("filterPanel.visible") && this.getController("data").dataSource()
            },
            init: function() {
                var _this = this;
                this.getController("data").dataSourceChanged.add(function() {
                    return _this.render()
                })
            },
            _renderCore: function() {
                var that = this;
                var $element = that.element();
                $element.empty().addClass(that.addWidgetPrefix(FILTER_PANEL_CLASS));
                var $leftContainer = (0, _renderer.default)("<div>").addClass(that.addWidgetPrefix(FILTER_PANEL_LEFT_CONTAINER)).appendTo($element);
                if (that.option("filterValue") || that._filterValueBuffer) {
                    $leftContainer.append(that._getCheckElement()).append(that._getFilterElement()).append(that._getTextElement());
                    $element.append(that._getRemoveButtonElement())
                } else {
                    $leftContainer.append(that._getFilterElement()).append(that._getTextElement())
                }
            },
            _getCheckElement: function() {
                var that = this;
                var $element = (0, _renderer.default)("<div>").addClass(this.addWidgetPrefix(FILTER_PANEL_CHECKBOX_CLASS));
                that._createComponent($element, _check_box.default, {
                    value: that.option("filterPanel.filterEnabled"),
                    onValueChanged: function(e) {
                        that.option("filterPanel.filterEnabled", e.value)
                    }
                });
                $element.attr("title", this.option("filterPanel.texts.filterEnabledHint"));
                return $element
            },
            _getFilterElement: function() {
                var that = this;
                var $element = (0, _renderer.default)("<div>").addClass("dx-icon-filter");
                _events_engine.default.on($element, "click", function() {
                    return that._showFilterBuilder()
                });
                (0, _uiGrid_core3.registerKeyboardAction)("filterPanel", that, $element, void 0, function() {
                    return that._showFilterBuilder()
                });
                that._addTabIndexToElement($element);
                return $element
            },
            _getTextElement: function() {
                var that = this;
                var $textElement = (0, _renderer.default)("<div>").addClass(that.addWidgetPrefix(FILTER_PANEL_TEXT_CLASS));
                var filterText;
                var filterValue = that.option("filterValue");
                if (filterValue) {
                    (0, _deferred.when)(that.getFilterText(filterValue, that.getController("filterSync").getCustomFilterOperations())).done(function(filterText) {
                        var customizeText = that.option("filterPanel.customizeText");
                        if (customizeText) {
                            var customText = customizeText({
                                component: that.component,
                                filterValue: filterValue,
                                text: filterText
                            });
                            if ("string" === typeof customText) {
                                filterText = customText
                            }
                        }
                        $textElement.text(filterText)
                    })
                } else {
                    filterText = that.option("filterPanel.texts.createFilter");
                    $textElement.text(filterText)
                }
                _events_engine.default.on($textElement, "click", function() {
                    return that._showFilterBuilder()
                });
                (0, _uiGrid_core3.registerKeyboardAction)("filterPanel", that, $textElement, void 0, function() {
                    return that._showFilterBuilder()
                });
                that._addTabIndexToElement($textElement);
                return $textElement
            },
            _showFilterBuilder: function() {
                this.option("filterBuilderPopup.visible", true)
            },
            _getRemoveButtonElement: function() {
                var that = this;
                var clearFilterValue = function() {
                    return that.option("filterValue", null)
                };
                var $element = (0, _renderer.default)("<div>").addClass(that.addWidgetPrefix(FILTER_PANEL_CLEAR_FILTER_CLASS)).text(that.option("filterPanel.texts.clearFilter"));
                _events_engine.default.on($element, "click", clearFilterValue);
                (0, _uiGrid_core3.registerKeyboardAction)("filterPanel", this, $element, void 0, clearFilterValue);
                that._addTabIndexToElement($element);
                return $element
            },
            _addTabIndexToElement: function($element) {
                if (!this.option("useLegacyKeyboardNavigation")) {
                    var tabindex = this.option("tabindex") || 0;
                    $element.attr("tabindex", tabindex)
                }
            },
            optionChanged: function(args) {
                switch (args.name) {
                    case "filterValue":
                        this._invalidate();
                        this.option("filterPanel.filterEnabled", true);
                        args.handled = true;
                        break;
                    case "filterPanel":
                        this._invalidate();
                        args.handled = true;
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _getConditionText: function(fieldText, operationText, valueText) {
                var result = "[".concat(fieldText, "] ").concat(operationText);
                if ((0, _type.isDefined)(valueText)) {
                    result += valueText
                }
                return result
            },
            _getValueMaskedText: function(value) {
                return Array.isArray(value) ? "('".concat(value.join("', '"), "')") : " '".concat(value, "'")
            },
            _getValueText: function(field, customOperation, value) {
                var _this2 = this;
                var deferred = new _deferred.Deferred;
                var hasCustomOperation = customOperation && customOperation.customizeText;
                if ((0, _type.isDefined)(value) || hasCustomOperation) {
                    if (!hasCustomOperation && field.lookup) {
                        (0, _utils.getCurrentLookupValueText)(field, value, function(data) {
                            deferred.resolve(_this2._getValueMaskedText(data))
                        })
                    } else {
                        var displayValue = Array.isArray(value) ? value : _uiGrid_core2.default.getDisplayValue(field, value);
                        (0, _deferred.when)((0, _utils.getCurrentValueText)(field, displayValue, customOperation, FILTER_PANEL_TARGET)).done(function(data) {
                            deferred.resolve(_this2._getValueMaskedText(data))
                        })
                    }
                } else {
                    deferred.resolve("")
                }
                return deferred.promise()
            },
            getConditionText: function(filterValue, options) {
                var that = this;
                var operation = filterValue[1];
                var deferred = new _deferred.Deferred;
                var customOperation = (0, _utils.getCustomOperation)(options.customOperations, operation);
                var operationText;
                var field = (0, _utils.getField)(filterValue[0], options.columns);
                var fieldText = field.caption || "";
                var value = filterValue[2];
                if (customOperation) {
                    operationText = customOperation.caption || (0, _inflector.captionize)(customOperation.name)
                } else {
                    if (null === value) {
                        operationText = (0, _utils.getCaptionByOperation)("=" === operation ? "isblank" : "isnotblank", options.filterOperationDescriptions)
                    } else {
                        operationText = (0, _utils.getCaptionByOperation)(operation, options.filterOperationDescriptions)
                    }
                }
                this._getValueText(field, customOperation, value).done(function(valueText) {
                    deferred.resolve(that._getConditionText(fieldText, operationText, valueText))
                });
                return deferred
            },
            getGroupText: function(filterValue, options, isInnerGroup) {
                var that = this;
                var result = new _deferred.Deferred;
                var textParts = [];
                var groupValue = (0, _utils.getGroupValue)(filterValue);
                filterValue.forEach(function(item) {
                    if ((0, _utils.isCondition)(item)) {
                        textParts.push(that.getConditionText(item, options))
                    } else {
                        if ((0, _utils.isGroup)(item)) {
                            textParts.push(that.getGroupText(item, options, true))
                        }
                    }
                });
                _deferred.when.apply(this, textParts).done(function() {
                    var text;
                    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key]
                    }
                    if ("!" === groupValue[0]) {
                        var groupText = options.groupOperationDescriptions["not" + groupValue.substring(1, 2).toUpperCase() + groupValue.substring(2)].split(" ");
                        text = "".concat(groupText[0], " ").concat(args[0])
                    } else {
                        text = args.join(" ".concat(options.groupOperationDescriptions[groupValue], " "))
                    }
                    if (isInnerGroup) {
                        text = "(".concat(text, ")")
                    }
                    result.resolve(text)
                });
                return result
            },
            getFilterText: function(filterValue, customOperations) {
                var that = this;
                var options = {
                    customOperations: customOperations,
                    columns: that.getController("columns").getFilteringColumns(),
                    filterOperationDescriptions: that.option("filterBuilder.filterOperationDescriptions"),
                    groupOperationDescriptions: that.option("filterBuilder.groupOperationDescriptions")
                };
                return (0, _utils.isCondition)(filterValue) ? that.getConditionText(filterValue, options) : that.getGroupText(filterValue, options)
            }
        });
        var _default = {
            defaultOptions: function() {
                return {
                    filterPanel: {
                        visible: false,
                        filterEnabled: true,
                        texts: {
                            createFilter: _message.default.format("dxDataGrid-filterPanelCreateFilter"),
                            clearFilter: _message.default.format("dxDataGrid-filterPanelClearFilter"),
                            filterEnabledHint: _message.default.format("dxDataGrid-filterPanelFilterEnabledHint")
                        }
                    }
                }
            },
            views: {
                filterPanelView: FilterPanelView
            },
            extenders: {
                controllers: {
                    data: {
                        optionChanged: function(args) {
                            switch (args.name) {
                                case "filterPanel":
                                    this._applyFilter();
                                    args.handled = true;
                                    break;
                                default:
                                    this.callBase(args)
                            }
                        }
                    }
                }
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.search.js ***!
      \**********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _data = __webpack_require__( /*! ../../core/utils/data */ 20);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.utils */ 35));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _query = _interopRequireDefault(__webpack_require__( /*! ../../data/query */ 48));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var SEARCH_PANEL_CLASS = "search-panel";
        var SEARCH_TEXT_CLASS = "search-text";
        var HEADER_PANEL_CLASS = "header-panel";
        var FILTERING_TIMEOUT = 700;

        function allowSearch(column) {
            return (0, _type.isDefined)(column.allowSearch) ? column.allowSearch : column.allowFiltering
        }

        function parseValue(column, text) {
            var lookup = column.lookup;
            if (!column.parseValue) {
                return text
            }
            if (lookup) {
                return column.parseValue.call(lookup, text)
            }
            return column.parseValue(text)
        }
        var _default = {
            defaultOptions: function() {
                return {
                    searchPanel: {
                        visible: false,
                        width: 160,
                        placeholder: _message.default.format("dxDataGrid-searchPanelPlaceholder"),
                        highlightSearchText: true,
                        highlightCaseSensitive: false,
                        text: "",
                        searchVisibleColumnsOnly: false
                    }
                }
            },
            extenders: {
                controllers: {
                    data: function() {
                        var calculateSearchFilter = function(that, text) {
                            var i;
                            var column;
                            var columns = that._columnsController.getColumns();
                            var searchVisibleColumnsOnly = that.option("searchPanel.searchVisibleColumnsOnly");
                            var lookup;
                            var filters = [];
                            if (!text) {
                                return null
                            }

                            function onQueryDone(items) {
                                var valueGetter = (0, _data.compileGetter)(lookup.valueExpr);
                                for (var _i = 0; _i < items.length; _i++) {
                                    var value = valueGetter(items[_i]);
                                    filters.push(column.createFilterExpression(value, null, "search"))
                                }
                            }
                            for (i = 0; i < columns.length; i++) {
                                column = columns[i];
                                if (searchVisibleColumnsOnly && !column.visible) {
                                    continue
                                }
                                if (allowSearch(column) && column.calculateFilterExpression) {
                                    lookup = column.lookup;
                                    var filterValue = parseValue(column, text);
                                    if (lookup && lookup.items) {
                                        (0, _query.default)(lookup.items).filter(column.createFilterExpression.call({
                                            dataField: lookup.displayExpr,
                                            dataType: lookup.dataType,
                                            calculateFilterExpression: column.calculateFilterExpression
                                        }, filterValue, null, "search")).enumerate().done(onQueryDone)
                                    } else {
                                        if (void 0 !== filterValue) {
                                            filters.push(column.createFilterExpression(filterValue, null, "search"))
                                        }
                                    }
                                }
                            }
                            return _uiGrid_core.default.combineFilters(filters, "or")
                        };
                        return {
                            publicMethods: function() {
                                return this.callBase().concat(["searchByText"])
                            },
                            _calculateAdditionalFilter: function() {
                                var that = this;
                                var filter = that.callBase();
                                var searchFilter = calculateSearchFilter(that, that.option("searchPanel.text"));
                                return _uiGrid_core.default.combineFilters([filter, searchFilter])
                            },
                            searchByText: function(text) {
                                this.option("searchPanel.text", text)
                            },
                            optionChanged: function(args) {
                                var that = this;
                                switch (args.fullName) {
                                    case "searchPanel.text":
                                    case "searchPanel":
                                        that._applyFilter();
                                        args.handled = true;
                                        break;
                                    default:
                                        that.callBase(args)
                                }
                            }
                        }
                    }()
                },
                views: {
                    headerPanel: function() {
                        var getSearchPanelOptions = function(that) {
                            return that.option("searchPanel")
                        };
                        return {
                            _getToolbarItems: function() {
                                var items = this.callBase();
                                return this._prepareSearchItem(items)
                            },
                            _prepareSearchItem: function(items) {
                                var that = this;
                                var dataController = that.getController("data");
                                var searchPanelOptions = getSearchPanelOptions(that);
                                if (searchPanelOptions && searchPanelOptions.visible) {
                                    var toolbarItem = {
                                        template: function(data, index, container) {
                                            var $search = (0, _renderer.default)("<div>").addClass(that.addWidgetPrefix(SEARCH_PANEL_CLASS)).appendTo(container);
                                            that.getController("editorFactory").createEditor($search, {
                                                width: searchPanelOptions.width,
                                                placeholder: searchPanelOptions.placeholder,
                                                parentType: "searchPanel",
                                                value: that.option("searchPanel.text"),
                                                updateValueTimeout: FILTERING_TIMEOUT,
                                                setValue: function(value) {
                                                    dataController.searchByText(value)
                                                },
                                                editorOptions: {
                                                    inputAttr: {
                                                        "aria-label": _message.default.format("".concat(that.component.NAME, "-ariaSearchInGrid"))
                                                    }
                                                }
                                            });
                                            that.resize()
                                        },
                                        name: "searchPanel",
                                        location: "after",
                                        locateInMenu: "never",
                                        sortIndex: 40
                                    };
                                    items.push(toolbarItem)
                                }
                                return items
                            },
                            getSearchTextEditor: function() {
                                var that = this;
                                var $element = that.element();
                                var $searchPanel = $element.find("." + that.addWidgetPrefix(SEARCH_PANEL_CLASS)).filter(function() {
                                    return (0, _renderer.default)(this).closest("." + that.addWidgetPrefix(HEADER_PANEL_CLASS)).is($element)
                                });
                                if ($searchPanel.length) {
                                    return $searchPanel.dxTextBox("instance")
                                }
                                return null
                            },
                            isVisible: function() {
                                var searchPanelOptions = getSearchPanelOptions(this);
                                return this.callBase() || searchPanelOptions && searchPanelOptions.visible
                            },
                            optionChanged: function(args) {
                                if ("searchPanel" === args.name) {
                                    if ("searchPanel.text" === args.fullName) {
                                        var editor = this.getSearchTextEditor();
                                        if (editor) {
                                            editor.option("value", args.value)
                                        }
                                    } else {
                                        this._invalidate()
                                    }
                                    args.handled = true
                                } else {
                                    this.callBase(args)
                                }
                            }
                        }
                    }(),
                    rowsView: {
                        init: function() {
                            this.callBase.apply(this, arguments);
                            this._searchParams = []
                        },
                        _getFormattedSearchText: function(column, searchText) {
                            var value = parseValue(column, searchText);
                            var formatOptions = _uiGrid_core.default.getFormatOptionsByColumn(column, "search");
                            return _uiGrid_core.default.formatValue(value, formatOptions)
                        },
                        _getStringNormalizer: function() {
                            var isCaseSensitive = this.option("searchPanel.highlightCaseSensitive");
                            return function(str) {
                                return isCaseSensitive ? str : str.toLowerCase()
                            }
                        },
                        _findHighlightingTextNodes: function(column, cellElement, searchText) {
                            var _$items;
                            var that = this;
                            var $parent = cellElement.parent();
                            var $items;
                            var stringNormalizer = this._getStringNormalizer();
                            var normalizedSearchText = stringNormalizer(searchText);
                            if (!$parent.length) {
                                $parent = (0, _renderer.default)("<div>").append(cellElement)
                            } else {
                                if (column) {
                                    if (column.groupIndex >= 0 && !column.showWhenGrouped) {
                                        $items = cellElement
                                    } else {
                                        var columnIndex = that._columnsController.getVisibleIndex(column.index);
                                        $items = $parent.children("td").eq(columnIndex).find("*")
                                    }
                                }
                            }
                            $items = null !== (_$items = $items) && void 0 !== _$items && _$items.length ? $items : $parent.find("*");
                            $items = $items.filter(function(_, element) {
                                var $contents = (0, _renderer.default)(element).contents();
                                for (var i = 0; i < $contents.length; i++) {
                                    var node = $contents.get(i);
                                    if (3 === node.nodeType) {
                                        return stringNormalizer(node.textContent || node.nodeValue).indexOf(normalizedSearchText) > -1
                                    }
                                    return false
                                }
                            });
                            return $items
                        },
                        _highlightSearchTextCore: function($textNode, searchText) {
                            var that = this;
                            var $searchTextSpan = (0, _renderer.default)("<span>").addClass(that.addWidgetPrefix(SEARCH_TEXT_CLASS));
                            var text = $textNode.text();
                            var firstContentElement = $textNode[0];
                            var stringNormalizer = this._getStringNormalizer();
                            var index = stringNormalizer(text).indexOf(stringNormalizer(searchText));
                            if (index >= 0) {
                                if (firstContentElement.textContent) {
                                    firstContentElement.textContent = text.substr(0, index)
                                } else {
                                    firstContentElement.nodeValue = text.substr(0, index)
                                }
                                $textNode.after($searchTextSpan.text(text.substr(index, searchText.length)));
                                $textNode = (0, _renderer.default)(_dom_adapter.default.createTextNode(text.substr(index + searchText.length))).insertAfter($searchTextSpan);
                                return that._highlightSearchTextCore($textNode, searchText)
                            }
                        },
                        _highlightSearchText: function(cellElement, isEquals, column) {
                            var that = this;
                            var stringNormalizer = this._getStringNormalizer();
                            var searchText = that.option("searchPanel.text");
                            if (isEquals && column) {
                                searchText = searchText && that._getFormattedSearchText(column, searchText)
                            }
                            if (searchText && that.option("searchPanel.highlightSearchText")) {
                                var textNodes = that._findHighlightingTextNodes(column, cellElement, searchText);
                                (0, _iterator.each)(textNodes, function(_, element) {
                                    (0, _iterator.each)((0, _renderer.default)(element).contents(), function(_, textNode) {
                                        if (isEquals) {
                                            if (stringNormalizer((0, _renderer.default)(textNode).text()) === stringNormalizer(searchText)) {
                                                (0, _renderer.default)(this).replaceWith((0, _renderer.default)("<span>").addClass(that.addWidgetPrefix(SEARCH_TEXT_CLASS)).text((0, _renderer.default)(textNode).text()))
                                            }
                                        } else {
                                            that._highlightSearchTextCore((0, _renderer.default)(textNode), searchText)
                                        }
                                    })
                                })
                            }
                        },
                        _renderCore: function() {
                            this.callBase.apply(this, arguments);
                            if (this.option("rowTemplate")) {
                                if (this.option("templatesRenderAsynchronously")) {
                                    clearTimeout(this._highlightTimer);
                                    this._highlightTimer = setTimeout(function() {
                                        this._highlightSearchText(this.getTableElement())
                                    }.bind(this))
                                } else {
                                    this._highlightSearchText(this.getTableElement())
                                }
                            }
                        },
                        _updateCell: function($cell, parameters) {
                            var column = parameters.column;
                            var dataType = column.lookup && column.lookup.dataType || column.dataType;
                            var isEquals = "string" !== dataType;
                            if (allowSearch(column) && !parameters.isOnForm) {
                                if (this.option("templatesRenderAsynchronously")) {
                                    if (!this._searchParams.length) {
                                        clearTimeout(this._highlightTimer);
                                        this._highlightTimer = setTimeout(function() {
                                            this._searchParams.forEach(function(params) {
                                                this._highlightSearchText.apply(this, params)
                                            }.bind(this));
                                            this._searchParams = []
                                        }.bind(this))
                                    }
                                    this._searchParams.push([$cell, isEquals, column])
                                } else {
                                    this._highlightSearchText($cell, isEquals, column)
                                }
                            }
                            this.callBase($cell, parameters)
                        },
                        dispose: function() {
                            clearTimeout(this._highlightTimer);
                            this.callBase()
                        }
                    }
                }
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.pager.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.modules */ 44));
        var _pager = _interopRequireDefault(__webpack_require__( /*! ../pager */ 725));
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var PAGER_CLASS = "pager";
        var MAX_PAGES_COUNT = 10;
        var getPageIndex = function(dataController) {
            return 1 + (parseInt(dataController.pageIndex()) || 0)
        };
        var PagerView = _uiGrid_core.default.View.inherit({
            init: function() {
                var that = this;
                var dataController = that.getController("data");
                that._isVisible = false;
                dataController.changed.add(function(e) {
                    if (e && e.repaintChangesOnly) {
                        var pager = that._getPager();
                        if (pager) {
                            pager.option({
                                pageIndex: getPageIndex(dataController),
                                pageSize: dataController.pageSize(),
                                pageCount: dataController.pageCount(),
                                totalCount: dataController.totalCount(),
                                hasKnownLastPage: dataController.hasKnownLastPage()
                            })
                        } else {
                            that.render()
                        }
                    } else {
                        if (!e || "update" !== e.changeType && "updateSelection" !== e.changeType) {
                            that.render()
                        }
                    }
                })
            },
            _getPager: function() {
                var $element = this.element();
                return $element && $element.data("dxPager")
            },
            _renderCore: function() {
                var that = this;
                var $element = that.element().addClass(that.addWidgetPrefix(PAGER_CLASS));
                var pagerOptions = that.option("pager") || {};
                var dataController = that.getController("data");
                var keyboardController = that.getController("keyboardNavigation");
                var options = {
                    maxPagesCount: MAX_PAGES_COUNT,
                    pageIndex: getPageIndex(dataController),
                    pageCount: dataController.pageCount(),
                    pageSize: dataController.pageSize(),
                    showPageSizes: pagerOptions.showPageSizeSelector,
                    showInfo: pagerOptions.showInfo,
                    displayMode: pagerOptions.displayMode,
                    pagesNavigatorVisible: pagerOptions.visible,
                    showNavigationButtons: pagerOptions.showNavigationButtons,
                    pageSizes: that.getPageSizes(),
                    totalCount: dataController.totalCount(),
                    hasKnownLastPage: dataController.hasKnownLastPage(),
                    pageIndexChanged: function(pageIndex) {
                        if (dataController.pageIndex() !== pageIndex - 1) {
                            setTimeout(function() {
                                dataController.pageIndex(pageIndex - 1)
                            })
                        }
                    },
                    pageSizeChanged: function(pageSize) {
                        setTimeout(function() {
                            dataController.pageSize(pageSize)
                        })
                    },
                    onKeyDown: function(e) {
                        return keyboardController && keyboardController.executeAction("onKeyDown", e)
                    },
                    useLegacyKeyboardNavigation: this.option("useLegacyKeyboardNavigation"),
                    useKeyboard: this.option("keyboardNavigation.enabled")
                };
                if ((0, _type.isDefined)(pagerOptions.infoText)) {
                    options.infoText = pagerOptions.infoText
                }
                that._createComponent($element, _pager.default, options)
            },
            getPageSizes: function() {
                var that = this;
                var dataController = that.getController("data");
                var pagerOptions = that.option("pager");
                var allowedPageSizes = pagerOptions && pagerOptions.allowedPageSizes;
                var pageSize = dataController.pageSize();
                if (!(0, _type.isDefined)(that._pageSizes) || (0, _array.inArray)(pageSize, that._pageSizes) === -1) {
                    that._pageSizes = [];
                    if (pagerOptions) {
                        if (Array.isArray(allowedPageSizes)) {
                            that._pageSizes = allowedPageSizes
                        } else {
                            if (allowedPageSizes && pageSize > 1) {
                                that._pageSizes = [Math.floor(pageSize / 2), pageSize, 2 * pageSize]
                            }
                        }
                    }
                }
                return that._pageSizes
            },
            isVisible: function() {
                var that = this;
                var dataController = that.getController("data");
                var pagerOptions = that.option("pager");
                var pagerVisible = pagerOptions && pagerOptions.visible;
                var scrolling = that.option("scrolling");
                if (that._isVisible) {
                    return true
                }
                if ("auto" === pagerVisible) {
                    if (scrolling && ("virtual" === scrolling.mode || "infinite" === scrolling.mode)) {
                        pagerVisible = false
                    } else {
                        pagerVisible = dataController.pageCount() > 1 || dataController.isLoaded() && !dataController.hasKnownLastPage()
                    }
                }
                that._isVisible = pagerVisible;
                return pagerVisible
            },
            getHeight: function() {
                return this.getElementHeight()
            },
            optionChanged: function(args) {
                var that = this;
                var name = args.name;
                var isPager = "pager" === name;
                var isPaging = "paging" === name;
                var isDataSource = "dataSource" === name;
                var isScrolling = "scrolling" === name;
                var dataController = that.getController("data");
                if (isPager || isPaging || isScrolling || isDataSource) {
                    args.handled = true;
                    if (dataController.skipProcessingPagingChange(args.fullName)) {
                        return
                    }
                    if (isPager || isPaging) {
                        that._pageSizes = null
                    }
                    if (isPager || isPaging || isScrolling) {
                        that._isVisible = false
                    }
                    if (!isDataSource) {
                        that._invalidate();
                        if ((0, _window.hasWindow)() && isPager && that.component) {
                            that.component.resize()
                        }
                    }
                }
            }
        });
        var _default = {
            defaultOptions: function() {
                return {
                    pager: {
                        visible: "auto",
                        showPageSizeSelector: false,
                        allowedPageSizes: "auto"
                    }
                }
            },
            views: {
                pagerView: PagerView
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.columns_resizing_reordering.js ***!
      \*******************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/callbacks */ 27));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _position = __webpack_require__( /*! ../../core/utils/position */ 22);
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../../events/pointer */ 24));
        var _drag = __webpack_require__( /*! ../../events/drag */ 76);
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.modules */ 44));
        var _uiGrid_core2 = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.utils */ 35));
        var _fx = _interopRequireDefault(__webpack_require__( /*! ../../animation/fx */ 42));
        var _swatch_container = _interopRequireDefault(__webpack_require__( /*! ../widget/swatch_container */ 170));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var COLUMNS_SEPARATOR_CLASS = "columns-separator";
        var COLUMNS_SEPARATOR_TRANSPARENT = "columns-separator-transparent";
        var DRAGGING_HEADER_CLASS = "drag-header";
        var CELL_CONTENT_CLASS = "text-content";
        var HEADERS_DRAG_ACTION_CLASS = "drag-action";
        var TRACKER_CLASS = "tracker";
        var HEADERS_DROP_HIGHLIGHT_CLASS = "drop-highlight";
        var BLOCK_SEPARATOR_CLASS = "dx-block-separator";
        var HEADER_ROW_CLASS = "dx-header-row";
        var WIDGET_CLASS = "dx-widget";
        var DRAGGING_COMMAND_CELL_CLASS = "dx-drag-command-cell";
        var MODULE_NAMESPACE = "dxDataGridResizingReordering";
        var COLUMNS_SEPARATOR_TOUCH_TRACKER_WIDTH = 10;
        var DRAGGING_DELTA = 5;
        var COLUMN_OPACITY = .5;
        var allowResizing = function(that) {
            return that.option("allowColumnResizing") || that.getController("columns").isColumnOptionUsed("allowResizing")
        };
        var allowReordering = function(that) {
            return that.option("allowColumnReordering") || that.getController("columns").isColumnOptionUsed("allowReordering")
        };
        var TrackerView = _uiGrid_core.default.View.inherit({
            _renderCore: function() {
                this.callBase();
                this.element().addClass(this.addWidgetPrefix(TRACKER_CLASS));
                this.hide()
            },
            _unsubscribeFromCallback: function() {
                if (this._positionChanged) {
                    this._tablePositionController.positionChanged.remove(this._positionChanged)
                }
            },
            _subscribeToCallback: function() {
                var that = this;
                that._positionChanged = function(position) {
                    var $element = that.element();
                    if ($element && $element.hasClass(that.addWidgetPrefix(TRACKER_CLASS))) {
                        $element.css({
                            top: position.top
                        });
                        $element.height(position.height)
                    }
                };
                this._tablePositionController.positionChanged.add(that._positionChanged)
            },
            optionChanged: function(args) {
                if ("allowColumnResizing" === args.name) {
                    this._unsubscribeFromCallback();
                    if (args.value) {
                        this._subscribeToCallback();
                        this._invalidate()
                    }
                }
                this.callBase(args)
            },
            init: function() {
                this.callBase();
                this._tablePositionController = this.getController("tablePosition");
                this._subscribeToCallback()
            },
            isVisible: function() {
                return allowResizing(this)
            },
            show: function() {
                this.element().show()
            },
            hide: function() {
                this.element() && this.element().hide()
            },
            setHeight: function(value) {
                this.element().height(value)
            },
            dispose: function() {
                this._unsubscribeFromCallback();
                this.callBase()
            }
        });
        var SeparatorView = _uiGrid_core.default.View.inherit({
            _renderSeparator: function() {},
            _renderCore: function(options) {
                this.callBase(options);
                this._isShown = true;
                this._renderSeparator();
                this.hide()
            },
            show: function() {
                this._isShown = true
            },
            hide: function() {
                this._isShown = false
            },
            height: function(value) {
                var $element = this.element();
                if ($element) {
                    if ((0, _type.isDefined)(value)) {
                        $element.height(value)
                    } else {
                        return $element.height()
                    }
                }
            },
            width: function(value) {
                var $element = this.element();
                if ($element) {
                    if ((0, _type.isDefined)(value)) {
                        $element.width(value)
                    } else {
                        return $element.width()
                    }
                }
            }
        });
        var ColumnsSeparatorView = SeparatorView.inherit({
            _renderSeparator: function() {
                this.callBase();
                var $element = this.element();
                $element.addClass(this.addWidgetPrefix(COLUMNS_SEPARATOR_CLASS))
            },
            _subscribeToCallback: function() {
                var that = this;
                var $element;
                that._positionChanged = function(position) {
                    $element = that.element();
                    if ($element) {
                        $element.css({
                            top: position.top
                        });
                        $element.height(position.height)
                    }
                };
                that._tablePositionController.positionChanged.add(that._positionChanged)
            },
            _unsubscribeFromCallback: function() {
                this._positionChanged && this._tablePositionController.positionChanged.remove(this._positionChanged)
            },
            _init: function() {
                this._isTransparent = allowResizing(this);
                if (this.isVisible()) {
                    this._subscribeToCallback()
                }
            },
            isVisible: function() {
                return this.option("showColumnHeaders") && (allowReordering(this) || allowResizing(this))
            },
            optionChanged: function(args) {
                if ("allowColumnResizing" === args.name) {
                    if (args.value) {
                        this._init();
                        this._invalidate();
                        this.hide(true)
                    } else {
                        this._unsubscribeFromCallback();
                        this._isTransparent = allowResizing(this);
                        this.hide(true)
                    }
                }
                this.callBase(args)
            },
            init: function() {
                this.callBase();
                this._tablePositionController = this.getController("tablePosition");
                this._init()
            },
            show: function() {
                var that = this;
                var $element = this.element();
                if ($element && !that._isShown) {
                    if (that._isTransparent) {
                        $element.removeClass(that.addWidgetPrefix(COLUMNS_SEPARATOR_TRANSPARENT))
                    } else {
                        $element.show()
                    }
                }
                this.callBase()
            },
            hide: function(force) {
                var $element = this.element();
                var columnsSeparatorTransparent = this.addWidgetPrefix(COLUMNS_SEPARATOR_TRANSPARENT);
                if ($element && (this._isShown || force)) {
                    if (this._isTransparent) {
                        $element.addClass(columnsSeparatorTransparent);
                        $element.css("left", "");
                        $element.show()
                    } else {
                        if ($element.hasClass(columnsSeparatorTransparent)) {
                            $element.removeClass(columnsSeparatorTransparent)
                        }
                        $element.hide()
                    }
                }
                this.callBase()
            },
            moveByX: function(outerX) {
                var $element = this.element();
                if ($element) {
                    $element.css("left", outerX - this._parentElement().offset().left)
                }
            },
            changeCursor: function(cursorName) {
                cursorName = (0, _type.isDefined)(cursorName) ? cursorName : "";
                var $element = this.element();
                if ($element) {
                    $element.css("cursor", cursorName)
                }
            },
            dispose: function() {
                this._unsubscribeFromCallback();
                this.callBase()
            }
        });
        var BlockSeparatorView = SeparatorView.inherit({
            init: function() {
                var that = this;
                this.callBase();
                this.getController("data").loadingChanged.add(function(isLoading) {
                    if (!isLoading) {
                        that.hide()
                    }
                })
            },
            _renderSeparator: function() {
                this.callBase();
                this.element().addClass(BLOCK_SEPARATOR_CLASS).html("&nbsp;")
            },
            hide: function() {
                var that = this;
                var $parent = this._parentElement();
                var $element = this.element();
                if ($element && this._isShown) {
                    $element.css("display", "none")
                }
                if ($parent && !$parent.children("." + BLOCK_SEPARATOR_CLASS).length) {
                    $parent.prepend(that.element())
                }
                that.callBase()
            },
            isVisible: function() {
                var groupPanelOptions = this.option("groupPanel");
                var columnChooserOptions = this.option("columnChooser");
                return groupPanelOptions && groupPanelOptions.visible || columnChooserOptions && columnChooserOptions.enabled
            },
            show: function(targetLocation) {
                var that = this;
                var $element = this.element();
                var startAnimate = function(toOptions) {
                    _fx.default.stop($element, true);
                    _fx.default.animate($element, {
                        type: "slide",
                        from: {
                            width: 0,
                            display: toOptions.display
                        },
                        to: toOptions,
                        duration: 300,
                        easing: "swing"
                    })
                };
                if ($element && !that._isShown) {
                    switch (targetLocation) {
                        case "group":
                            startAnimate({
                                width: "50px",
                                display: "inline-block"
                            });
                            break;
                        case "columnChooser":
                            startAnimate({
                                width: "100%",
                                display: "block"
                            });
                            break;
                        default:
                            $element.css("display", "")
                    }
                }
                that.callBase()
            }
        });
        var DraggingHeaderView = _uiGrid_core.default.View.inherit({
            _isDragging: false,
            isDragging: function() {
                return this._isDragging
            },
            _getDraggingPanelByPos: function(pos) {
                var that = this;
                var result;
                (0, _iterator.each)(that._dragOptions.draggingPanels, function(index, draggingPanel) {
                    if (draggingPanel) {
                        var boundingRect = draggingPanel.getBoundingRect();
                        if (boundingRect && (void 0 === boundingRect.bottom || pos.y < boundingRect.bottom) && (void 0 === boundingRect.top || pos.y > boundingRect.top) && (void 0 === boundingRect.left || pos.x > boundingRect.left) && (void 0 === boundingRect.right || pos.x < boundingRect.right)) {
                            result = draggingPanel;
                            return false
                        }
                    }
                });
                return result
            },
            _renderCore: function() {
                this.element().addClass(this.addWidgetPrefix(DRAGGING_HEADER_CLASS) + " " + this.addWidgetPrefix(CELL_CONTENT_CLASS) + " " + WIDGET_CLASS).hide()
            },
            _resetTargetColumnOptions: function() {
                var params = this._dropOptions;
                params.targetColumnIndex = -1;
                delete params.targetColumnElement;
                delete params.isLast;
                delete params.posX;
                delete params.posY
            },
            _getVisibleIndexObject: function(rowIndex, visibleIndex) {
                if ((0, _type.isDefined)(rowIndex)) {
                    return {
                        columnIndex: visibleIndex,
                        rowIndex: rowIndex
                    }
                }
                return visibleIndex
            },
            dispose: function() {
                var element = this.element();
                this._dragOptions = null;
                element && element.parent().find("." + this.addWidgetPrefix(DRAGGING_HEADER_CLASS)).remove()
            },
            isVisible: function() {
                var columnsController = this.getController("columns");
                var commonColumnSettings = columnsController.getCommonSettings();
                return this.option("showColumnHeaders") && (allowReordering(this) || commonColumnSettings.allowGrouping || commonColumnSettings.allowHiding)
            },
            init: function() {
                var that = this;
                this.callBase();
                this._controller = this.getController("draggingHeader");
                this._columnsResizerViewController = this.getController("columnsResizer");
                this.getController("data").loadingChanged.add(function(isLoading) {
                    var element = that.element();
                    if (!isLoading && element) {
                        element.hide()
                    }
                })
            },
            dragHeader: function(options) {
                var that = this;
                var columnElement = options.columnElement;
                var isCommandColumn = !!options.sourceColumn.type;
                that._isDragging = true;
                that._dragOptions = options;
                that._dropOptions = {
                    sourceIndex: options.index,
                    sourceColumnIndex: that._getVisibleIndexObject(options.rowIndex, options.columnIndex),
                    sourceColumnElement: options.columnElement,
                    sourceLocation: options.sourceLocation
                };
                var document = _dom_adapter.default.getDocument();
                that._onSelectStart = document.onselectstart;
                document.onselectstart = function() {
                    return false
                };
                that._controller.drag(that._dropOptions);
                that.element().css({
                    textAlign: columnElement && columnElement.css("textAlign"),
                    height: columnElement && (isCommandColumn && columnElement.get(0).clientHeight || columnElement.height()),
                    width: columnElement && (isCommandColumn && columnElement.get(0).clientWidth || columnElement.width()),
                    whiteSpace: columnElement && columnElement.css("whiteSpace")
                }).addClass(that.addWidgetPrefix(HEADERS_DRAG_ACTION_CLASS)).toggleClass(DRAGGING_COMMAND_CELL_CLASS, isCommandColumn).text(isCommandColumn ? "" : options.sourceColumn.caption);
                that.element().appendTo(_swatch_container.default.getSwatchContainer(columnElement))
            },
            moveHeader: function(args) {
                var e = args.event;
                var that = e.data.that;
                var eventData = (0, _index.eventData)(e);
                var isResizing = that._columnsResizerViewController ? that._columnsResizerViewController.isResizing() : false;
                var dragOptions = that._dragOptions;
                if (that._isDragging && !isResizing) {
                    var $element = that.element();
                    var moveDeltaX = Math.abs(eventData.x - dragOptions.columnElement.offset().left - dragOptions.deltaX);
                    var moveDeltaY = Math.abs(eventData.y - dragOptions.columnElement.offset().top - dragOptions.deltaY);
                    if ($element.is(":visible") || moveDeltaX > DRAGGING_DELTA || moveDeltaY > DRAGGING_DELTA) {
                        $element.show();
                        var newLeft = eventData.x - dragOptions.deltaX;
                        var newTop = eventData.y - dragOptions.deltaY;
                        $element.css({
                            left: newLeft,
                            top: newTop
                        });
                        that.dockHeader(eventData)
                    }
                    e.preventDefault()
                }
            },
            dockHeader: function(eventData) {
                var that = this;
                var targetDraggingPanel = that._getDraggingPanelByPos(eventData);
                var controller = that._controller;
                var params = that._dropOptions;
                var dragOptions = that._dragOptions;
                if (targetDraggingPanel) {
                    var rtlEnabled = that.option("rtlEnabled");
                    var isVerticalOrientation = "columnChooser" === targetDraggingPanel.getName();
                    var axisName = isVerticalOrientation ? "y" : "x";
                    var targetLocation = targetDraggingPanel.getName();
                    var rowIndex = "headers" === targetLocation ? dragOptions.rowIndex : void 0;
                    var sourceColumn = dragOptions.sourceColumn;
                    var columnElements = targetDraggingPanel.getColumnElements(rowIndex, null === sourceColumn || void 0 === sourceColumn ? void 0 : sourceColumn.ownerBand) || [];
                    var pointsByTarget = dragOptions.pointsByTarget = dragOptions.pointsByTarget || {};
                    var pointsByColumns = "columnChooser" === targetLocation ? [] : pointsByTarget[targetLocation] || controller._generatePointsByColumns((0, _extend.extend)({}, dragOptions, {
                        targetDraggingPanel: targetDraggingPanel,
                        columns: targetDraggingPanel.getColumns(rowIndex),
                        columnElements: columnElements,
                        isVerticalOrientation: isVerticalOrientation,
                        startColumnIndex: "headers" === targetLocation && (0, _renderer.default)(columnElements[0]).index()
                    }));
                    pointsByTarget[targetLocation] = pointsByColumns;
                    params.targetLocation = targetLocation;
                    if (pointsByColumns.length > 0) {
                        for (var i = 0; i < pointsByColumns.length; i++) {
                            var centerPosition = pointsByColumns[i + 1] && (pointsByColumns[i][axisName] + pointsByColumns[i + 1][axisName]) / 2;
                            if (void 0 === centerPosition || (rtlEnabled && "x" === axisName ? eventData[axisName] > centerPosition : eventData[axisName] < centerPosition)) {
                                params.targetColumnIndex = that._getVisibleIndexObject(rowIndex, pointsByColumns[i].columnIndex);
                                if (columnElements[i]) {
                                    params.targetColumnElement = columnElements.eq(i);
                                    params.isLast = false
                                } else {
                                    params.targetColumnElement = columnElements.last();
                                    params.isLast = true
                                }
                                params.posX = pointsByColumns[i].x;
                                params.posY = pointsByColumns[i].y;
                                controller.dock(params);
                                break
                            }
                        }
                    } else {
                        that._resetTargetColumnOptions();
                        controller.dock(params)
                    }
                }
            },
            dropHeader: function(args) {
                var e = args.event;
                var that = e.data.that;
                var controller = that._controller;
                that.element().hide();
                if (controller && that._isDragging) {
                    controller.drop(that._dropOptions)
                }
                that.element().appendTo(that._parentElement());
                that._dragOptions = null;
                that._dropOptions = null;
                that._isDragging = false;
                _dom_adapter.default.getDocument().onselectstart = that._onSelectStart || null
            }
        });
        var isNextColumnResizingMode = function(that) {
            return "widget" !== that.option("columnResizingMode")
        };
        var ColumnsResizerViewController = _uiGrid_core.default.ViewController.inherit({
            _isHeadersRowArea: function(posY) {
                if (this._columnHeadersView) {
                    var element = this._columnHeadersView.element();
                    if (element) {
                        var offsetTop = element.offset().top;
                        var headersRowHeight = this._columnHeadersView.getHeadersRowHeight();
                        return posY >= offsetTop && posY <= offsetTop + headersRowHeight
                    }
                }
                return false
            },
            _isRtlParentStyle: function() {
                var _this$_$parentContain;
                return this.option("rtlEnabled") && "rtl" === (null === (_this$_$parentContain = this._$parentContainer) || void 0 === _this$_$parentContain ? void 0 : _this$_$parentContain.parent().css("direction"))
            },
            _pointCreated: function(point, cellsLength, columns) {
                var isNextColumnMode = isNextColumnResizingMode(this);
                var rtlEnabled = this.option("rtlEnabled");
                var isRtlParentStyle = this._isRtlParentStyle();
                var firstPointColumnIndex = !isNextColumnMode && rtlEnabled && !isRtlParentStyle ? 0 : 1;
                if (point.index >= firstPointColumnIndex && point.index < cellsLength + (!isNextColumnMode && (!rtlEnabled || isRtlParentStyle) ? 1 : 0)) {
                    point.columnIndex -= firstPointColumnIndex;
                    var currentColumn = columns[point.columnIndex] || {};
                    var nextColumn = columns[point.columnIndex + 1] || {};
                    return !(isNextColumnMode ? currentColumn.allowResizing && nextColumn.allowResizing : currentColumn.allowResizing)
                }
                return true
            },
            _getTargetPoint: function(pointsByColumns, currentX, deltaX) {
                if (pointsByColumns) {
                    for (var i = 0; i < pointsByColumns.length; i++) {
                        if (pointsByColumns[i].x === pointsByColumns[0].x && pointsByColumns[i + 1] && pointsByColumns[i].x === pointsByColumns[i + 1].x) {
                            continue
                        }
                        if (pointsByColumns[i].x - deltaX <= currentX && currentX <= pointsByColumns[i].x + deltaX) {
                            return pointsByColumns[i]
                        }
                    }
                }
                return null
            },
            _moveSeparator: function(args) {
                var e = args.event;
                var that = e.data;
                var columnsSeparatorWidth = that._columnsSeparatorView.width();
                var isNextColumnMode = isNextColumnResizingMode(that);
                var deltaX = columnsSeparatorWidth / 2;
                var parentOffset = that._$parentContainer.offset();
                var parentOffsetLeft = parentOffset.left;
                var eventData = (0, _index.eventData)(e);
                var rtlEnabled = that.option("rtlEnabled");
                var isRtlParentStyle = this._isRtlParentStyle();
                if (that._isResizing && that._resizingInfo) {
                    if ((parentOffsetLeft <= eventData.x || !isNextColumnMode && isRtlParentStyle) && (!isNextColumnMode || eventData.x <= parentOffsetLeft + that._$parentContainer.width())) {
                        if (that._updateColumnsWidthIfNeeded(eventData.x)) {
                            var $cell = that._columnHeadersView.getColumnElements().eq(that._resizingInfo.currentColumnIndex);
                            var cell = $cell[0];
                            if (cell) {
                                var outerWidth = cell.getBoundingClientRect().width;
                                that._columnsSeparatorView.moveByX($cell.offset().left + ((isNextColumnMode || isRtlParentStyle) && rtlEnabled ? 0 : outerWidth));
                                that._tablePositionController.update(that._targetPoint.y);
                                e.preventDefault()
                            }
                        }
                    }
                } else {
                    if (that._isHeadersRowArea(eventData.y)) {
                        if (that._previousParentOffset) {
                            if (that._previousParentOffset.left !== parentOffset.left || that._previousParentOffset.top !== parentOffset.top) {
                                that.pointsByColumns(null)
                            }
                        }
                        that._targetPoint = that._getTargetPoint(that.pointsByColumns(), eventData.x, columnsSeparatorWidth);
                        that._previousParentOffset = parentOffset;
                        that._isReadyResizing = false;
                        if (that._targetPoint) {
                            that._columnsSeparatorView.changeCursor("col-resize");
                            that._columnsSeparatorView.moveByX(that._targetPoint.x - deltaX);
                            that._tablePositionController.update(that._targetPoint.y);
                            that._isReadyResizing = true;
                            e.preventDefault()
                        } else {
                            that._columnsSeparatorView.changeCursor()
                        }
                    } else {
                        that.pointsByColumns(null);
                        that._isReadyResizing = false;
                        that._columnsSeparatorView.changeCursor()
                    }
                }
            },
            _endResizing: function(args) {
                var e = args.event;
                var that = e.data;
                if (that._isResizing) {
                    that.pointsByColumns(null);
                    that._resizingInfo = null;
                    that._columnsSeparatorView.hide();
                    that._columnsSeparatorView.changeCursor();
                    that._trackerView.hide();
                    that._isReadyResizing = false;
                    that._isResizing = false
                }
            },
            _getNextColumnIndex: function(currentColumnIndex) {
                return currentColumnIndex + 1
            },
            _setupResizingInfo: function(posX) {
                var that = this;
                var currentColumnIndex = that._targetPoint.columnIndex;
                var nextColumnIndex = that._getNextColumnIndex(currentColumnIndex);
                var currentHeader = that._columnHeadersView.getHeaderElement(currentColumnIndex);
                var nextHeader = that._columnHeadersView.getHeaderElement(nextColumnIndex);
                that._resizingInfo = {
                    startPosX: posX,
                    currentColumnIndex: currentColumnIndex,
                    currentColumnWidth: currentHeader && currentHeader.length > 0 ? (0, _position.getBoundingRect)(currentHeader[0]).width : 0,
                    nextColumnIndex: nextColumnIndex,
                    nextColumnWidth: nextHeader && nextHeader.length > 0 ? (0, _position.getBoundingRect)(nextHeader[0]).width : 0
                }
            },
            _startResizing: function(args) {
                var e = args.event;
                var that = e.data;
                var eventData = (0, _index.eventData)(e);
                if ((0, _index.isTouchEvent)(e)) {
                    if (that._isHeadersRowArea(eventData.y)) {
                        that._targetPoint = that._getTargetPoint(that.pointsByColumns(), eventData.x, COLUMNS_SEPARATOR_TOUCH_TRACKER_WIDTH);
                        if (that._targetPoint) {
                            that._columnsSeparatorView.moveByX(that._targetPoint.x - that._columnsSeparatorView.width() / 2);
                            that._isReadyResizing = true
                        }
                    } else {
                        that._isReadyResizing = false
                    }
                }
                if (that._isReadyResizing) {
                    that._setupResizingInfo(eventData.x);
                    that._isResizing = true;
                    that._tablePositionController.update(that._targetPoint.y);
                    that._columnsSeparatorView.show();
                    that._trackerView.show();
                    var scrollable = that.component.getScrollable();
                    if (scrollable && that._isRtlParentStyle()) {
                        that._scrollRight = scrollable.$content().width() - scrollable._container().width() - scrollable.scrollLeft()
                    }
                    e.preventDefault();
                    e.stopPropagation()
                }
                if (this.isResizing()) {
                    this.getController("editorFactory").loseFocus()
                }
            },
            _generatePointsByColumns: function() {
                var that = this;
                var columns = that._columnsController ? that._columnsController.getVisibleColumns() : [];
                var cells = that._columnHeadersView.getColumnElements();
                var pointsByColumns = [];
                if (cells && cells.length > 0) {
                    pointsByColumns = _uiGrid_core2.default.getPointsByColumns(cells, function(point) {
                        return that._pointCreated(point, cells.length, columns)
                    })
                }
                that._pointsByColumns = pointsByColumns
            },
            _unsubscribeFromEvents: function() {
                this._moveSeparatorHandler && _events_engine.default.off(_dom_adapter.default.getDocument(), (0, _index.addNamespace)(_pointer.default.move, MODULE_NAMESPACE), this._moveSeparatorHandler);
                this._startResizingHandler && _events_engine.default.off(this._$parentContainer, (0, _index.addNamespace)(_pointer.default.down, MODULE_NAMESPACE), this._startResizingHandler);
                if (this._endResizingHandler) {
                    _events_engine.default.off(this._columnsSeparatorView.element(), (0, _index.addNamespace)(_pointer.default.up, MODULE_NAMESPACE), this._endResizingHandler);
                    _events_engine.default.off(_dom_adapter.default.getDocument(), (0, _index.addNamespace)(_pointer.default.up, MODULE_NAMESPACE), this._endResizingHandler)
                }
            },
            _subscribeToEvents: function() {
                this._moveSeparatorHandler = this.createAction(this._moveSeparator);
                this._startResizingHandler = this.createAction(this._startResizing);
                this._endResizingHandler = this.createAction(this._endResizing);
                _events_engine.default.on(_dom_adapter.default.getDocument(), (0, _index.addNamespace)(_pointer.default.move, MODULE_NAMESPACE), this, this._moveSeparatorHandler);
                _events_engine.default.on(this._$parentContainer, (0, _index.addNamespace)(_pointer.default.down, MODULE_NAMESPACE), this, this._startResizingHandler);
                _events_engine.default.on(this._columnsSeparatorView.element(), (0, _index.addNamespace)(_pointer.default.up, MODULE_NAMESPACE), this, this._endResizingHandler);
                _events_engine.default.on(_dom_adapter.default.getDocument(), (0, _index.addNamespace)(_pointer.default.up, MODULE_NAMESPACE), this, this._endResizingHandler)
            },
            _updateColumnsWidthIfNeeded: function(posX) {
                var deltaX;
                var needUpdate = false;
                var nextCellWidth;
                var resizingInfo = this._resizingInfo;
                var columnsController = this._columnsController;
                var visibleColumns = columnsController.getVisibleColumns();
                var columnsSeparatorWidth = this._columnsSeparatorView.width();
                var contentWidth = this._rowsView.contentWidth();
                var isNextColumnMode = isNextColumnResizingMode(this);
                var adaptColumnWidthByRatio = isNextColumnMode && this.option("adaptColumnWidthByRatio") && !this.option("columnAutoWidth");
                var minWidth;
                var nextColumn;
                var cellWidth;
                var rtlEnabled = this.option("rtlEnabled");
                var isRtlParentStyle = this._isRtlParentStyle();

                function isPercentWidth(width) {
                    return (0, _type.isString)(width) && "%" === width.slice(-1)
                }

                function setColumnWidth(column, columnWidth, contentWidth, adaptColumnWidthByRatio) {
                    if (column) {
                        var oldColumnWidth = column.width;
                        if (oldColumnWidth) {
                            adaptColumnWidthByRatio = isPercentWidth(oldColumnWidth)
                        }
                        if (adaptColumnWidthByRatio) {
                            column && columnsController.columnOption(column.index, "visibleWidth", columnWidth);
                            column && columnsController.columnOption(column.index, "width", (columnWidth / contentWidth * 100).toFixed(3) + "%")
                        } else {
                            column && columnsController.columnOption(column.index, "visibleWidth", null);
                            column && columnsController.columnOption(column.index, "width", columnWidth)
                        }
                    }
                }

                function correctContentWidth(contentWidth, visibleColumns) {
                    var allColumnsHaveWidth = visibleColumns.every(function(column) {
                        return column.width
                    });
                    if (allColumnsHaveWidth) {
                        var totalPercent = visibleColumns.reduce(function(sum, column) {
                            if (isPercentWidth(column.width)) {
                                sum += parseFloat(column.width)
                            }
                            return sum
                        }, 0);
                        if (totalPercent > 100) {
                            contentWidth = contentWidth / totalPercent * 100
                        }
                    }
                    return contentWidth
                }
                deltaX = posX - resizingInfo.startPosX;
                if ((isNextColumnMode || isRtlParentStyle) && rtlEnabled) {
                    deltaX = -deltaX
                }
                cellWidth = resizingInfo.currentColumnWidth + deltaX;
                var column = visibleColumns[resizingInfo.currentColumnIndex];
                minWidth = column && column.minWidth || columnsSeparatorWidth;
                needUpdate = cellWidth >= minWidth;
                if (isNextColumnMode) {
                    nextCellWidth = resizingInfo.nextColumnWidth - deltaX;
                    nextColumn = visibleColumns[resizingInfo.nextColumnIndex];
                    minWidth = nextColumn && nextColumn.minWidth || columnsSeparatorWidth;
                    needUpdate = needUpdate && nextCellWidth >= minWidth
                }
                if (needUpdate) {
                    columnsController.beginUpdate();
                    cellWidth = Math.floor(cellWidth);
                    contentWidth = correctContentWidth(contentWidth, visibleColumns);
                    setColumnWidth(column, cellWidth, contentWidth, adaptColumnWidthByRatio);
                    if (isNextColumnMode) {
                        nextCellWidth = Math.floor(nextCellWidth);
                        setColumnWidth(nextColumn, nextCellWidth, contentWidth, adaptColumnWidthByRatio)
                    } else {
                        var columnWidths = this._columnHeadersView.getColumnWidths();
                        columnWidths[resizingInfo.currentColumnIndex] = cellWidth;
                        var hasScroll = columnWidths.reduce(function(totalWidth, width) {
                            return totalWidth + width
                        }, 0) > this._rowsView.contentWidth();
                        if (!hasScroll) {
                            var lastColumnIndex = _uiGrid_core2.default.getLastResizableColumnIndex(visibleColumns);
                            if (lastColumnIndex >= 0) {
                                columnsController.columnOption(visibleColumns[lastColumnIndex].index, "visibleWidth", "auto")
                            }
                        }
                        for (var i = 0; i < columnWidths.length; i++) {
                            if (visibleColumns[i] && visibleColumns[i] !== column && void 0 === visibleColumns[i].width) {
                                columnsController.columnOption(visibleColumns[i].index, "width", columnWidths[i])
                            }
                        }
                    }
                    columnsController.endUpdate();
                    if (!isNextColumnMode) {
                        this.component.updateDimensions();
                        var scrollable = this.component.getScrollable();
                        if (scrollable && isRtlParentStyle) {
                            var left = scrollable.$content().width() - scrollable._container().width() - this._scrollRight;
                            scrollable.scrollTo({
                                left: left
                            })
                        }
                    }
                }
                return needUpdate
            },
            _subscribeToCallback: function(callback, handler) {
                callback.add(handler);
                this._subscribesToCallbacks.push({
                    callback: callback,
                    handler: handler
                })
            },
            _unsubscribeFromCallbacks: function() {
                for (var i = 0; i < this._subscribesToCallbacks.length; i++) {
                    var subscribe = this._subscribesToCallbacks[i];
                    subscribe.callback.remove(subscribe.handler)
                }
                this._subscribesToCallbacks = []
            },
            _unsubscribes: function() {
                this._unsubscribeFromEvents();
                this._unsubscribeFromCallbacks()
            },
            _init: function() {
                var that = this;
                var generatePointsByColumnsHandler = function() {
                    if (!that._isResizing) {
                        that.pointsByColumns(null)
                    }
                };
                var generatePointsByColumnsScrollHandler = function(offset) {
                    if (that._scrollLeft !== offset.left) {
                        that._scrollLeft = offset.left;
                        that.pointsByColumns(null)
                    }
                };
                that._columnsSeparatorView = that.getView("columnsSeparatorView");
                that._columnHeadersView = that.getView("columnHeadersView");
                that._trackerView = that.getView("trackerView");
                that._rowsView = that.getView("rowsView");
                that._columnsController = that.getController("columns");
                that._tablePositionController = that.getController("tablePosition");
                that._$parentContainer = that.component.$element();
                that._subscribeToCallback(that._columnHeadersView.renderCompleted, generatePointsByColumnsHandler);
                that._subscribeToCallback(that._columnHeadersView.resizeCompleted, generatePointsByColumnsHandler);
                that._subscribeToCallback(that._columnsSeparatorView.renderCompleted, function() {
                    that._unsubscribeFromEvents();
                    that._subscribeToEvents()
                });
                that._subscribeToCallback(that._rowsView.renderCompleted, function() {
                    that._rowsView.scrollChanged.remove(generatePointsByColumnsScrollHandler);
                    that._rowsView.scrollChanged.add(generatePointsByColumnsScrollHandler)
                });
                var previousScrollbarVisibility = 0 !== that._rowsView.getScrollbarWidth();
                var previousTableHeight = 0;
                that._subscribeToCallback(that.getController("tablePosition").positionChanged, function(e) {
                    if (that._isResizing && !that._rowsView.isResizing) {
                        var scrollbarVisibility = 0 !== that._rowsView.getScrollbarWidth();
                        if (previousScrollbarVisibility !== scrollbarVisibility || previousTableHeight && previousTableHeight !== e.height) {
                            previousScrollbarVisibility = scrollbarVisibility;
                            previousTableHeight = e.height;
                            that.component.updateDimensions()
                        } else {
                            that._rowsView.updateFreeSpaceRowHeight()
                        }
                    }
                    previousTableHeight = e.height
                })
            },
            optionChanged: function(args) {
                this.callBase(args);
                if ("allowColumnResizing" === args.name) {
                    if (args.value) {
                        this._init();
                        this._subscribeToEvents()
                    } else {
                        this._unsubscribes()
                    }
                }
            },
            isResizing: function() {
                return this._isResizing
            },
            init: function() {
                this._subscribesToCallbacks = [];
                if (allowResizing(this)) {
                    this._init()
                }
            },
            pointsByColumns: function(value) {
                if (void 0 !== value) {
                    this._pointsByColumns = value
                } else {
                    if (!this._pointsByColumns) {
                        this._generatePointsByColumns()
                    }
                    return this._pointsByColumns
                }
            },
            dispose: function() {
                this._unsubscribes();
                this.callBase()
            }
        });
        var TablePositionViewController = _uiGrid_core.default.ViewController.inherit({
            update: function(top) {
                var that = this;
                var params = {};
                var $element = that._columnHeadersView.element();
                var offset = $element && $element.offset();
                var offsetTop = offset && offset.top || 0;
                var diffOffsetTop = (0, _type.isDefined)(top) ? Math.abs(top - offsetTop) : 0;
                var columnsHeadersHeight = that._columnHeadersView ? that._columnHeadersView.getHeight() : 0;
                var scrollBarWidth = that._rowsView.getScrollbarWidth(true);
                var rowsHeight = that._rowsView ? that._rowsView.height() - scrollBarWidth : 0;
                var columnsResizerController = that.component.getController("columnsResizer");
                var draggingHeaderView = that.component.getView("draggingHeaderView");
                params.height = columnsHeadersHeight;
                var isDraggingOrResizing = false !== columnsResizerController.isResizing() || draggingHeaderView.isDragging();
                if (isDraggingOrResizing) {
                    params.height += rowsHeight - diffOffsetTop
                }
                if (null !== top && $element && $element.length) {
                    params.top = $element[0].offsetTop + diffOffsetTop
                }
                that.positionChanged.fire(params)
            },
            init: function() {
                var that = this;
                that.callBase();
                that._columnHeadersView = this.getView("columnHeadersView");
                that._rowsView = this.getView("rowsView");
                that._pagerView = this.getView("pagerView");
                that._rowsView.resizeCompleted.add(function() {
                    if (that.option("allowColumnResizing")) {
                        var targetPoint = that.getController("columnsResizer")._targetPoint;
                        that.update(targetPoint ? targetPoint.y : null)
                    }
                })
            },
            ctor: function(component) {
                this.callBase(component);
                this.positionChanged = (0, _callbacks.default)()
            }
        });
        var DraggingHeaderViewController = _uiGrid_core.default.ViewController.inherit({
            _generatePointsByColumns: function(options) {
                var that = this;
                return _uiGrid_core2.default.getPointsByColumns(options.columnElements, function(point) {
                    return that._pointCreated(point, options.columns, options.targetDraggingPanel.getName(), options.sourceColumn)
                }, options.isVerticalOrientation, options.startColumnIndex)
            },
            _pointCreated: function(point, columns, location, sourceColumn) {
                var targetColumn = columns[point.columnIndex];
                var prevColumn = columns[point.columnIndex - 1];
                switch (location) {
                    case "columnChooser":
                        return true;
                    case "headers":
                        return sourceColumn && !sourceColumn.allowReordering || (!targetColumn || !targetColumn.allowReordering) && (!prevColumn || !prevColumn.allowReordering);
                    default:
                        return 0 === columns.length
                }
            },
            _subscribeToEvents: function(draggingHeader, draggingPanels) {
                var that = this;
                (0, _iterator.each)(draggingPanels, function(_, draggingPanel) {
                    if (draggingPanel) {
                        var columns;
                        var rowCount = draggingPanel.getRowCount ? draggingPanel.getRowCount() : 1;
                        var nameDraggingPanel = draggingPanel.getName();
                        var subscribeToEvents = function(index, columnElement) {
                            if (!columnElement) {
                                return
                            }
                            var $columnElement = (0, _renderer.default)(columnElement);
                            var column = columns[index];
                            if (draggingPanel.allowDragging(column, nameDraggingPanel, draggingPanels)) {
                                $columnElement.addClass(that.addWidgetPrefix(HEADERS_DRAG_ACTION_CLASS));
                                _events_engine.default.on($columnElement, (0, _index.addNamespace)(_drag.start, MODULE_NAMESPACE), that.createAction(function(args) {
                                    var e = args.event;
                                    var eventData = (0, _index.eventData)(e);
                                    draggingHeader.dragHeader({
                                        deltaX: eventData.x - (0, _renderer.default)(e.currentTarget).offset().left,
                                        deltaY: eventData.y - (0, _renderer.default)(e.currentTarget).offset().top,
                                        sourceColumn: column,
                                        index: column.index,
                                        columnIndex: index,
                                        columnElement: $columnElement,
                                        sourceLocation: nameDraggingPanel,
                                        draggingPanels: draggingPanels,
                                        rowIndex: that._columnsController.getRowIndex(column.index, true)
                                    })
                                }));
                                _events_engine.default.on($columnElement, (0, _index.addNamespace)(_drag.move, MODULE_NAMESPACE), {
                                    that: draggingHeader
                                }, that.createAction(draggingHeader.moveHeader));
                                _events_engine.default.on($columnElement, (0, _index.addNamespace)(_drag.end, MODULE_NAMESPACE), {
                                    that: draggingHeader
                                }, that.createAction(draggingHeader.dropHeader))
                            }
                        };
                        for (var i = 0; i < rowCount; i++) {
                            var columnElements = draggingPanel.getColumnElements(i) || [];
                            if (columnElements.length) {
                                columns = draggingPanel.getColumns(i) || [];
                                (0, _iterator.each)(columnElements, subscribeToEvents)
                            }
                        }
                    }
                })
            },
            _unsubscribeFromEvents: function(draggingHeader, draggingPanels) {
                var that = this;
                (0, _iterator.each)(draggingPanels, function(_, draggingPanel) {
                    if (draggingPanel) {
                        var columnElements = draggingPanel.getColumnElements() || [];
                        (0, _iterator.each)(columnElements, function(index, columnElement) {
                            var $columnElement = (0, _renderer.default)(columnElement);
                            _events_engine.default.off($columnElement, (0, _index.addNamespace)(_drag.start, MODULE_NAMESPACE));
                            _events_engine.default.off($columnElement, (0, _index.addNamespace)(_drag.move, MODULE_NAMESPACE));
                            _events_engine.default.off($columnElement, (0, _index.addNamespace)(_drag.end, MODULE_NAMESPACE));
                            $columnElement.removeClass(that.addWidgetPrefix(HEADERS_DRAG_ACTION_CLASS))
                        })
                    }
                })
            },
            _getSeparator: function(targetLocation) {
                return "headers" === targetLocation ? this._columnsSeparatorView : this._blockSeparatorView
            },
            hideSeparators: function(type) {
                var blockSeparator = this._blockSeparatorView;
                var columnsSeparator = this._columnsSeparatorView;
                this._animationColumnIndex = null;
                blockSeparator && blockSeparator.hide();
                "block" !== type && columnsSeparator && columnsSeparator.hide()
            },
            init: function() {
                var that = this;
                that.callBase();
                that._columnsController = that.getController("columns");
                that._columnHeadersView = that.getView("columnHeadersView");
                that._columnsSeparatorView = that.getView("columnsSeparatorView");
                that._draggingHeaderView = that.getView("draggingHeaderView");
                that._rowsView = that.getView("rowsView");
                that._blockSeparatorView = that.getView("blockSeparatorView");
                that._headerPanelView = that.getView("headerPanel");
                that._columnChooserView = that.getView("columnChooserView");
                var subscribeToEvents = function() {
                    if (that._draggingHeaderView) {
                        var draggingPanels = [that._columnChooserView, that._columnHeadersView, that._headerPanelView];
                        that._unsubscribeFromEvents(that._draggingHeaderView, draggingPanels);
                        that._subscribeToEvents(that._draggingHeaderView, draggingPanels)
                    }
                };
                that._columnHeadersView.renderCompleted.add(subscribeToEvents);
                that._headerPanelView && that._headerPanelView.renderCompleted.add(subscribeToEvents);
                that._columnChooserView && that._columnChooserView.renderCompleted.add(subscribeToEvents)
            },
            allowDrop: function(parameters) {
                return this._columnsController.allowMoveColumn(parameters.sourceColumnIndex, parameters.targetColumnIndex, parameters.sourceLocation, parameters.targetLocation)
            },
            drag: function(parameters) {
                var sourceIndex = parameters.sourceIndex;
                var sourceLocation = parameters.sourceLocation;
                var sourceColumnElement = parameters.sourceColumnElement;
                var headersView = this._columnHeadersView;
                var rowsView = this._rowsView;
                if (sourceColumnElement) {
                    sourceColumnElement.css({
                        opacity: COLUMN_OPACITY
                    });
                    if ("headers" === sourceLocation) {
                        headersView && headersView.setRowsOpacity(sourceIndex, COLUMN_OPACITY);
                        rowsView && rowsView.setRowsOpacity(sourceIndex, COLUMN_OPACITY)
                    }
                }
            },
            dock: function(parameters) {
                var that = this;
                var targetColumnIndex = (0, _type.isObject)(parameters.targetColumnIndex) ? parameters.targetColumnIndex.columnIndex : parameters.targetColumnIndex;
                var sourceLocation = parameters.sourceLocation;
                var targetLocation = parameters.targetLocation;
                var separator = that._getSeparator(targetLocation);
                var hasTargetVisibleIndex = targetColumnIndex >= 0;
                var showSeparator = function() {
                    if (that._animationColumnIndex !== targetColumnIndex) {
                        that.hideSeparators();
                        separator.element()[parameters.isLast ? "insertAfter" : "insertBefore"](parameters.targetColumnElement);
                        that._animationColumnIndex = targetColumnIndex;
                        separator.show(targetLocation)
                    }
                };
                that._columnHeadersView.element().find("." + HEADER_ROW_CLASS).toggleClass(that.addWidgetPrefix(HEADERS_DROP_HIGHLIGHT_CLASS), "headers" !== sourceLocation && "headers" === targetLocation && !hasTargetVisibleIndex);
                if (separator) {
                    if (that.allowDrop(parameters) && hasTargetVisibleIndex) {
                        if ("group" === targetLocation || "columnChooser" === targetLocation) {
                            showSeparator()
                        } else {
                            that.hideSeparators("block");
                            that.getController("tablePosition").update(parameters.posY);
                            separator.moveByX(parameters.posX - separator.width());
                            separator.show()
                        }
                    } else {
                        that.hideSeparators()
                    }
                }
            },
            drop: function(parameters) {
                var sourceColumnElement = parameters.sourceColumnElement;
                if (sourceColumnElement) {
                    sourceColumnElement.css({
                        opacity: ""
                    });
                    this._columnHeadersView.setRowsOpacity(parameters.sourceIndex, "");
                    this._rowsView.setRowsOpacity(parameters.sourceIndex, "");
                    this._columnHeadersView.element().find("." + HEADER_ROW_CLASS).removeClass(this.addWidgetPrefix(HEADERS_DROP_HIGHLIGHT_CLASS))
                }
                if (this.allowDrop(parameters)) {
                    var separator = this._getSeparator(parameters.targetLocation);
                    if (separator) {
                        separator.hide()
                    }
                    this._columnsController.moveColumn(parameters.sourceColumnIndex, parameters.targetColumnIndex, parameters.sourceLocation, parameters.targetLocation)
                }
            },
            dispose: function() {
                if (this._draggingHeaderView) {
                    this._unsubscribeFromEvents(this._draggingHeaderView, [this._columnChooserView, this._columnHeadersView, this._headerPanelView])
                }
            }
        });
        var _default = {
            views: {
                columnsSeparatorView: ColumnsSeparatorView,
                blockSeparatorView: BlockSeparatorView,
                draggingHeaderView: DraggingHeaderView,
                trackerView: TrackerView
            },
            controllers: {
                draggingHeader: DraggingHeaderViewController,
                tablePosition: TablePositionViewController,
                columnsResizer: ColumnsResizerViewController
            },
            extenders: {
                views: {
                    rowsView: {
                        _needUpdateRowHeight: function(itemCount) {
                            var wordWrapEnabled = this.option("wordWrapEnabled");
                            var columnsResizerController = this.getController("columnsResizer");
                            var isResizing = columnsResizerController.isResizing();
                            return this.callBase.apply(this, arguments) || itemCount > 0 && wordWrapEnabled && isResizing
                        }
                    }
                },
                controllers: {
                    editorFactory: {
                        renderFocusOverlay: function() {
                            if (this.getController("columnsResizer").isResizing()) {
                                return
                            }
                            return this.callBase.apply(this, arguments)
                        }
                    }
                }
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.keyboard_navigation.js ***!
      \***********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.modules */ 44));
        var _uiGrid_core2 = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.utils */ 35));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _selectors = __webpack_require__( /*! ../widget/selectors */ 70);
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../../events/pointer */ 24));
        var _click = __webpack_require__( /*! ../../events/click */ 21);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var accessibility = _interopRequireWildcard(__webpack_require__( /*! ../shared/accessibility */ 118));
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));
        var _short = __webpack_require__( /*! ../../events/short */ 128);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ROWS_VIEW_CLASS = "rowsview";
        var EDIT_FORM_CLASS = "edit-form";
        var GROUP_FOOTER_CLASS = "group-footer";
        var ROW_CLASS = "dx-row";
        var DATA_ROW_CLASS = "dx-data-row";
        var GROUP_ROW_CLASS = "dx-group-row";
        var HEADER_ROW_CLASS = "dx-header-row";
        var EDIT_FORM_ITEM_CLASS = "edit-form-item";
        var MASTER_DETAIL_ROW_CLASS = "dx-master-detail-row";
        var FREESPACE_ROW_CLASS = "dx-freespace-row";
        var VIRTUAL_ROW_CLASS = "dx-virtual-row";
        var MASTER_DETAIL_CELL_CLASS = "dx-master-detail-cell";
        var EDITOR_CELL_CLASS = "dx-editor-cell";
        var DROPDOWN_EDITOR_OVERLAY_CLASS = "dx-dropdowneditor-overlay";
        var COMMAND_EXPAND_CLASS = "dx-command-expand";
        var COMMAND_SELECT_CLASS = "dx-command-select";
        var COMMAND_EDIT_CLASS = "dx-command-edit";
        var COMMAND_CELL_SELECTOR = "[class^=dx-command]";
        var CELL_FOCUS_DISABLED_CLASS = "dx-cell-focus-disabled";
        var DATEBOX_WIDGET_NAME = "dxDateBox";
        var FOCUS_STATE_CLASS = "dx-state-focused";
        var WIDGET_CLASS = "dx-widget";
        var REVERT_BUTTON_CLASS = "dx-revert-button";
        var FAST_EDITING_DELETE_KEY = "delete";
        var INTERACTIVE_ELEMENTS_SELECTOR = "input:not([type='hidden']), textarea, a, select, button, [tabindex]";
        var EDIT_MODE_ROW = "row";
        var EDIT_MODE_FORM = "form";
        var EDIT_MODE_BATCH = "batch";
        var EDIT_MODE_CELL = "cell";
        var FOCUS_TYPE_ROW = "row";
        var FOCUS_TYPE_CELL = "cell";
        var COLUMN_HEADERS_VIEW = "columnHeadersView";

        function isGroupRow($row) {
            return $row && $row.hasClass(GROUP_ROW_CLASS)
        }

        function isDetailRow($row) {
            return $row && $row.hasClass(MASTER_DETAIL_ROW_CLASS)
        }

        function isDataRow($row) {
            return $row && !isGroupRow($row) && !isDetailRow($row)
        }

        function isNotFocusedRow($row) {
            return !$row || $row.hasClass(FREESPACE_ROW_CLASS) || $row.hasClass(VIRTUAL_ROW_CLASS)
        }

        function isCellElement($element) {
            return $element.length && "TD" === $element[0].tagName
        }

        function isEditorCell(that, $cell) {
            return !that._isRowEditMode() && $cell && !$cell.hasClass(COMMAND_SELECT_CLASS) && $cell.hasClass(EDITOR_CELL_CLASS)
        }

        function isElementDefined($element) {
            return (0, _type.isDefined)($element) && $element.length > 0
        }

        function isMobile() {
            return "desktop" !== _devices.default.current().deviceType
        }

        function isCellInHeaderRow($cell) {
            return !!$cell.parent(".".concat(HEADER_ROW_CLASS)).length
        }

        function isFixedColumnIndexOffsetRequired(that, column) {
            var rtlEnabled = that.option("rtlEnabled");
            var result = false;
            if (rtlEnabled) {
                result = !("right" === column.fixedPosition || (0, _type.isDefined)(column.command) && !(0, _type.isDefined)(column.fixedPosition))
            } else {
                result = !(!(0, _type.isDefined)(column.fixedPosition) || "left" === column.fixedPosition)
            }
            return result
        }

        function shouldPreventScroll(that) {
            var keyboardController = that.getController("keyboardNavigation");
            return keyboardController._isVirtualScrolling() ? that.option("focusedRowIndex") === keyboardController.getRowIndex() : false
        }
        var KeyboardNavigationController = _uiGrid_core.default.ViewController.inherit({
            init: function() {
                var _this = this;
                this._dataController = this.getController("data");
                this._selectionController = this.getController("selection");
                this._editingController = this.getController("editing");
                this._headerPanel = this.getView("headerPanel");
                this._columnsController = this.getController("columns");
                this._editorFactory = this.getController("editorFactory");
                if (this.isKeyboardEnabled()) {
                    accessibility.subscribeVisibilityChange();
                    this._updateFocusTimeout = null;
                    this._fastEditingStarted = false;
                    this._focusedCellPosition = {};
                    this._canceledCellPosition = null;
                    var elementFocused = function($element) {
                        _this.setupFocusedView();
                        if (_this._isNeedScroll) {
                            if ($element.is(":visible") && _this._focusedView && _this._focusedView.getScrollable) {
                                _this._focusedView._scrollToElement($element);
                                _this._isNeedScroll = false
                            }
                        }
                    };
                    this._editorFactory.focused.add(elementFocused);
                    this._initViewHandlers();
                    this._initDocumentHandlers();
                    this.createAction("onKeyDown")
                }
            },
            _initViewHandlers: function() {
                var _this2 = this;
                var rowsView = this.getView("rowsView");
                var rowsViewFocusHandler = function(event) {
                    var $element = (0, _renderer.default)(event.target);
                    var isRelatedTargetInRowsView = (0, _renderer.default)(event.relatedTarget).closest(rowsView.element()).length;
                    var isCommandButton = $element.hasClass("dx-link");
                    if (isCommandButton && !isRelatedTargetInRowsView && _this2._isEventInCurrentGrid(event)) {
                        var $focusedCell = _this2._getFocusedCell();
                        $focusedCell = !isElementDefined($focusedCell) ? rowsView.getCellElements(0).filter("[tabindex]").eq(0) : $focusedCell;
                        if (!$element.closest($focusedCell).length) {
                            event.preventDefault();
                            _events_engine.default.trigger($focusedCell, "focus")
                        }
                    }
                };
                rowsView.renderCompleted.add(function(e) {
                    var $rowsView = rowsView.element();
                    var isFullUpdate = !e || "refresh" === e.changeType;
                    var isFocusedViewCorrect = _this2._focusedView && _this2._focusedView.name === rowsView.name;
                    var needUpdateFocus = false;
                    var isAppend = e && ("append" === e.changeType || "prepend" === e.changeType);
                    var $focusedElement = (0, _renderer.default)(":focus");
                    var isFocusedElementCorrect = !$focusedElement.length || $focusedElement.closest($rowsView).length || _browser.default.msie && $focusedElement.is("body");
                    _events_engine.default.off($rowsView, "focusin", rowsViewFocusHandler);
                    _events_engine.default.on($rowsView, "focusin", rowsViewFocusHandler);
                    _this2._initPointerEventHandler();
                    _this2._initKeyDownHandler();
                    _this2._setRowsViewAttributes();
                    if (isFocusedViewCorrect && isFocusedElementCorrect) {
                        needUpdateFocus = _this2._isNeedFocus ? !isAppend : _this2._isHiddenFocus && isFullUpdate;
                        needUpdateFocus && _this2._updateFocus(true)
                    }
                })
            },
            _initDocumentHandlers: function() {
                var _this3 = this;
                var document = _dom_adapter.default.getDocument();
                this._documentClickHandler = this.createAction(function(e) {
                    var $target = (0, _renderer.default)(e.event.target);
                    var isCurrentRowsViewClick = _this3._isEventInCurrentGrid(e.event) && $target.closest(".".concat(_this3.addWidgetPrefix(ROWS_VIEW_CLASS))).length;
                    var isEditorOverlay = $target.closest(".".concat(DROPDOWN_EDITOR_OVERLAY_CLASS)).length;
                    var columnsResizerController = _this3.getController("columnsResizer");
                    var isColumnResizing = !!columnsResizerController && columnsResizerController.isResizing();
                    if (!isCurrentRowsViewClick && !isEditorOverlay && !isColumnResizing) {
                        var targetInsideFocusedView = _this3._focusedView ? $target.parents().filter(_this3._focusedView.element()).length > 0 : false;
                        !targetInsideFocusedView && _this3._resetFocusedCell(true);
                        _this3._resetFocusedView()
                    }
                });
                _events_engine.default.on(document, (0, _index.addNamespace)(_pointer.default.down, "dxDataGridKeyboardNavigation"), this._documentClickHandler)
            },
            _setRowsViewAttributes: function() {
                var $rowsView = this._getRowsViewElement();
                var isGridEmpty = !this._dataController.getVisibleRows().length;
                if (isGridEmpty) {
                    this._applyTabIndexToElement($rowsView)
                }
            },
            _initPointerEventHandler: function() {
                var pointerEventName = !isMobile() ? _pointer.default.down : _click.name;
                var clickSelector = ".".concat(ROW_CLASS, " > td, .").concat(ROW_CLASS);
                var $rowsView = this._getRowsViewElement();
                if (!(0, _type.isDefined)(this._pointerEventAction)) {
                    this._pointerEventAction = this.createAction(this._pointerEventHandler)
                }
                _events_engine.default.off($rowsView, (0, _index.addNamespace)(pointerEventName, "dxDataGridKeyboardNavigation"), this._pointerEventAction);
                _events_engine.default.on($rowsView, (0, _index.addNamespace)(pointerEventName, "dxDataGridKeyboardNavigation"), clickSelector, this._pointerEventAction)
            },
            _initKeyDownHandler: function() {
                var _this4 = this;
                var $rowsView = this._getRowsViewElement();
                _short.keyboard.off(this._keyDownListener);
                this._keyDownListener = _short.keyboard.on($rowsView, null, function(e) {
                    return _this4._keyDownHandler(e)
                })
            },
            dispose: function() {
                this.callBase();
                this._resetFocusedView();
                _short.keyboard.off(this._keyDownListener);
                _events_engine.default.off(_dom_adapter.default.getDocument(), (0, _index.addNamespace)(_pointer.default.down, "dxDataGridKeyboardNavigation"), this._documentClickHandler);
                clearTimeout(this._updateFocusTimeout);
                accessibility.unsubscribeVisibilityChange()
            },
            optionChanged: function(args) {
                var that = this;
                switch (args.name) {
                    case "keyboardNavigation":
                    case "useLegacyKeyboardNavigation":
                        args.handled = true;
                        break;
                    default:
                        that.callBase(args)
                }
            },
            isRowFocusType: function() {
                return this.focusType === FOCUS_TYPE_ROW
            },
            isCellFocusType: function() {
                return this.focusType === FOCUS_TYPE_CELL
            },
            setRowFocusType: function() {
                if (this.option("focusedRowEnabled")) {
                    this.focusType = FOCUS_TYPE_ROW
                }
            },
            setCellFocusType: function() {
                this.focusType = FOCUS_TYPE_CELL
            },
            _keyDownHandler: function(e) {
                var isEditing = this._editingController.isEditing();
                var needStopPropagation = true;
                var originalEvent = e.originalEvent;
                var isHandled = this._processOnKeyDown(e);
                if (originalEvent.isDefaultPrevented()) {
                    return
                }
                this._isNeedFocus = true;
                this._isNeedScroll = true;
                this._updateFocusedCellPositionByTarget(originalEvent.target);
                if (!isHandled) {
                    switch (e.keyName) {
                        case "leftArrow":
                        case "rightArrow":
                            this._leftRightKeysHandler(e, isEditing);
                            break;
                        case "upArrow":
                        case "downArrow":
                            if (e.ctrl) {
                                accessibility.selectView("rowsView", this, originalEvent)
                            } else {
                                this._upDownKeysHandler(e, isEditing)
                            }
                            break;
                        case "pageUp":
                        case "pageDown":
                            this._pageUpDownKeyHandler(e);
                            break;
                        case "space":
                            this._spaceKeyHandler(e, isEditing);
                            break;
                        case "A":
                            if (e.ctrl) {
                                this._ctrlAKeyHandler(e, isEditing)
                            } else {
                                this._beginFastEditing(e.originalEvent)
                            }
                            break;
                        case "tab":
                            this._tabKeyHandler(e, isEditing);
                            break;
                        case "enter":
                            this._enterKeyHandler(e, isEditing);
                            break;
                        case "escape":
                            this._escapeKeyHandler(e, isEditing);
                            break;
                        case "F":
                            if (e.ctrl) {
                                this._ctrlFKeyHandler(e)
                            } else {
                                this._beginFastEditing(e.originalEvent)
                            }
                            break;
                        case "F2":
                            this._f2KeyHandler();
                            break;
                        case "del":
                        case "backspace":
                            if (this._isFastEditingAllowed() && !this._isFastEditingStarted()) {
                                this._beginFastEditing(originalEvent, true)
                            }
                            break;
                        default:
                            if (!this._beginFastEditing(originalEvent)) {
                                this._isNeedFocus = false;
                                this._isNeedScroll = false;
                                needStopPropagation = false
                            }
                    }
                    if (needStopPropagation) {
                        originalEvent.stopPropagation()
                    }
                }
            },
            _processOnKeyDown: function(eventArgs) {
                var originalEvent = eventArgs.originalEvent;
                var args = {
                    handled: false,
                    event: originalEvent
                };
                this.executeAction("onKeyDown", args);
                eventArgs.ctrl = originalEvent.ctrlKey;
                eventArgs.alt = originalEvent.altKey;
                eventArgs.shift = originalEvent.shiftKey;
                return !!args.handled
            },
            _closeEditCell: function() {
                var _this5 = this;
                setTimeout(function() {
                    _this5._editingController.closeEditCell()
                })
            },
            _leftRightKeysHandler: function(eventArgs, isEditing) {
                var rowIndex = this.getVisibleRowIndex();
                var $event = eventArgs.originalEvent;
                var $row = this._focusedView && this._focusedView.getRow(rowIndex);
                var directionCode = this._getDirectionCodeByKey(eventArgs.keyName);
                var isEditingNavigationMode = this._isFastEditingStarted();
                var allowNavigate = (!isEditing || isEditingNavigationMode) && isDataRow($row);
                if (allowNavigate) {
                    this.setCellFocusType();
                    isEditingNavigationMode && this._closeEditCell();
                    if (this._isVirtualColumnRender()) {
                        this._processVirtualHorizontalPosition(directionCode)
                    }
                    var $cell = this._getNextCell(directionCode);
                    if (isElementDefined($cell)) {
                        this._arrowKeysHandlerFocusCell($event, $cell, directionCode)
                    }
                    $event && $event.preventDefault()
                }
            },
            _upDownKeysHandler: function(eventArgs, isEditing) {
                var rowIndex = this._focusedCellPosition.rowIndex;
                var visibleRowIndex = this.getVisibleRowIndex();
                var $row = this._focusedView && this._focusedView.getRow(visibleRowIndex);
                var $event = eventArgs.originalEvent;
                var isUpArrow = "upArrow" === eventArgs.keyName;
                var dataSource = this._dataController.dataSource();
                var isEditingNavigationMode = this._isFastEditingStarted();
                var allowNavigate = (!isEditing || isEditingNavigationMode) && $row && !isDetailRow($row);
                if (allowNavigate) {
                    isEditingNavigationMode && this._closeEditCell();
                    if (!this._navigateNextCell($event, eventArgs.keyName)) {
                        if (this._isVirtualRowRender() && isUpArrow && dataSource && !dataSource.isLoading()) {
                            var rowHeight = $row.outerHeight();
                            rowIndex = this._focusedCellPosition.rowIndex - 1;
                            this._scrollBy(0, -rowHeight, rowIndex, $event)
                        }
                    }
                    $event && $event.preventDefault()
                }
            },
            _pageUpDownKeyHandler: function(eventArgs) {
                var pageIndex = this._dataController.pageIndex();
                var pageCount = this._dataController.pageCount();
                var pagingEnabled = this.option("paging.enabled");
                var isPageUp = "pageUp" === eventArgs.keyName;
                var pageStep = isPageUp ? -1 : 1;
                var scrollable = this.getView("rowsView").getScrollable();
                if (pagingEnabled && !this._isVirtualScrolling()) {
                    if ((isPageUp ? pageIndex > 0 : pageIndex < pageCount - 1) && !this._isVirtualScrolling()) {
                        this._dataController.pageIndex(pageIndex + pageStep);
                        eventArgs.originalEvent.preventDefault()
                    }
                } else {
                    if (scrollable && scrollable._container().height() < scrollable.$content().height()) {
                        this._scrollBy(0, scrollable._container().height() * pageStep);
                        eventArgs.originalEvent.preventDefault()
                    }
                }
            },
            _spaceKeyHandler: function(eventArgs, isEditing) {
                var rowIndex = this.getVisibleRowIndex();
                var $target = (0, _renderer.default)(eventArgs.originalEvent && eventArgs.originalEvent.target);
                if (this.option("selection") && "none" !== this.option("selection").mode && !isEditing) {
                    var isFocusedRowElement = "row" === this._getElementType($target) && this.isRowFocusType() && isDataRow($target);
                    var isFocusedSelectionCell = $target.hasClass(COMMAND_SELECT_CLASS);
                    if (isFocusedSelectionCell && "onClick" === this.option("selection.showCheckBoxesMode")) {
                        this._selectionController.startSelectionWithCheckboxes()
                    }
                    if (isFocusedRowElement || $target.parent().hasClass(DATA_ROW_CLASS) || $target.hasClass(this.addWidgetPrefix(ROWS_VIEW_CLASS))) {
                        this._selectionController.changeItemSelection(rowIndex, {
                            shift: eventArgs.shift,
                            control: eventArgs.ctrl
                        });
                        eventArgs.originalEvent.preventDefault()
                    }
                } else {
                    this._beginFastEditing(eventArgs.originalEvent)
                }
            },
            _ctrlAKeyHandler: function(eventArgs, isEditing) {
                if (!isEditing && eventArgs.ctrl && !eventArgs.alt && "multiple" === this.option("selection.mode") && this.option("selection.allowSelectAll")) {
                    this._selectionController.selectAll();
                    eventArgs.originalEvent.preventDefault()
                }
            },
            _tabKeyHandler: function(eventArgs, isEditing) {
                var editingOptions = this.option("editing");
                var direction = eventArgs.shift ? "previous" : "next";
                var isCellPositionDefined = (0, _type.isDefined)(this._focusedCellPosition) && !(0, _type.isEmptyObject)(this._focusedCellPosition);
                var isOriginalHandlerRequired = !isCellPositionDefined || !eventArgs.shift && this._isLastValidCell(this._focusedCellPosition) || eventArgs.shift && this._isFirstValidCell(this._focusedCellPosition);
                var eventTarget = eventArgs.originalEvent.target;
                var focusedViewElement = this._focusedView && this._focusedView.element();
                if (this._handleTabKeyOnMasterDetailCell(eventTarget, direction)) {
                    return
                }(0, _renderer.default)(focusedViewElement).addClass(FOCUS_STATE_CLASS);
                if (editingOptions && eventTarget && !isOriginalHandlerRequired) {
                    if ((0, _renderer.default)(eventTarget).hasClass(this.addWidgetPrefix(ROWS_VIEW_CLASS))) {
                        this._resetFocusedCell()
                    }
                    if (this._isVirtualColumnRender()) {
                        this._processVirtualHorizontalPosition(direction)
                    }
                    if (isEditing) {
                        if (!this._editingCellTabHandler(eventArgs, direction)) {
                            return
                        }
                    } else {
                        if (this._targetCellTabHandler(eventArgs, direction)) {
                            isOriginalHandlerRequired = true
                        }
                    }
                }
                if (isOriginalHandlerRequired) {
                    this._editorFactory.loseFocus();
                    if (this._editingController.isEditing() && !this._isRowEditMode()) {
                        this._resetFocusedCell(true);
                        this._resetFocusedView();
                        this._closeEditCell()
                    }
                } else {
                    eventArgs.originalEvent.preventDefault()
                }
            },
            _getMaxHorizontalOffset: function() {
                var scrollable = this.component.getScrollable();
                var rowsView = this.getView("rowsView");
                var offset = scrollable ? scrollable.scrollWidth() - (0, _renderer.default)(rowsView.element()).width() : 0;
                return offset
            },
            _isColumnRendered: function(columnIndex) {
                var allVisibleColumns = this._columnsController.getVisibleColumns(null, true);
                var renderedVisibleColumns = this._columnsController.getVisibleColumns();
                var column = allVisibleColumns[columnIndex];
                var result = false;
                if (column) {
                    result = renderedVisibleColumns.indexOf(column) >= 0
                }
                return result
            },
            _isFixedColumn: function(columnIndex) {
                var allVisibleColumns = this._columnsController.getVisibleColumns(null, true);
                var column = allVisibleColumns[columnIndex];
                return !!column && !!column.fixed
            },
            _isColumnVirtual: function(columnIndex) {
                var localColumnIndex = columnIndex - this._columnsController.getColumnIndexOffset();
                var visibleColumns = this._columnsController.getVisibleColumns();
                var column = visibleColumns[localColumnIndex];
                return !!column && "virtual" === column.command
            },
            _processVirtualHorizontalPosition: function(direction) {
                var scrollable = this.component.getScrollable();
                var columnIndex = this.getColumnIndex();
                var nextColumnIndex;
                var horizontalScrollPosition = 0;
                var needToScroll = false;
                switch (direction) {
                    case "next":
                    case "nextInRow":
                        var columnsCount = this._getVisibleColumnCount();
                        nextColumnIndex = columnIndex + 1;
                        horizontalScrollPosition = this.option("rtlEnabled") ? this._getMaxHorizontalOffset() : 0;
                        if ("next" === direction) {
                            needToScroll = columnsCount === nextColumnIndex || this._isFixedColumn(columnIndex) && !this._isColumnRendered(nextColumnIndex)
                        } else {
                            needToScroll = columnsCount > nextColumnIndex && this._isFixedColumn(columnIndex) && !this._isColumnRendered(nextColumnIndex)
                        }
                        break;
                    case "previous":
                    case "previousInRow":
                        nextColumnIndex = columnIndex - 1;
                        horizontalScrollPosition = this.option("rtlEnabled") ? 0 : this._getMaxHorizontalOffset();
                        if ("previous" === direction) {
                            var columnIndexOffset = this._columnsController.getColumnIndexOffset();
                            var leftEdgePosition = nextColumnIndex < 0 && 0 === columnIndexOffset;
                            needToScroll = leftEdgePosition || this._isFixedColumn(columnIndex) && !this._isColumnRendered(nextColumnIndex)
                        } else {
                            needToScroll = nextColumnIndex >= 0 && this._isFixedColumn(columnIndex) && !this._isColumnRendered(nextColumnIndex)
                        }
                }
                if (needToScroll) {
                    scrollable.scrollTo({
                        left: horizontalScrollPosition
                    })
                } else {
                    if ((0, _type.isDefined)(nextColumnIndex) && (0, _type.isDefined)(direction) && this._isColumnVirtual(nextColumnIndex)) {
                        horizontalScrollPosition = this._getHorizontalScrollPositionOffset(direction);
                        0 !== horizontalScrollPosition && scrollable.scrollBy({
                            left: horizontalScrollPosition,
                            top: 0
                        })
                    }
                }
            },
            _getHorizontalScrollPositionOffset: function(direction) {
                var positionOffset = 0;
                var $currentCell = this._getCell(this._focusedCellPosition);
                var currentCellWidth = $currentCell && $currentCell.outerWidth();
                if (currentCellWidth > 0) {
                    var rtlMultiplier = this.option("rtlEnabled") ? -1 : 1;
                    positionOffset = "nextInRow" === direction || "next" === direction ? currentCellWidth * rtlMultiplier : currentCellWidth * rtlMultiplier * -1
                }
                return positionOffset
            },
            _editingCellTabHandler: function(eventArgs, direction) {
                var eventTarget = eventArgs.originalEvent.target;
                var $cell = this._getCellElementFromTarget(eventTarget);
                var isEditingAllowed;
                var $event = eventArgs.originalEvent;
                var elementType = this._getElementType(eventTarget);
                if ($cell.is(COMMAND_CELL_SELECTOR)) {
                    return !this._targetCellTabHandler(eventArgs, direction)
                }
                this._updateFocusedCellPosition($cell);
                var nextCellInfo = this._getNextCellByTabKey($event, direction, elementType);
                $cell = nextCellInfo.$cell;
                if (!$cell || this._handleTabKeyOnMasterDetailCell($cell, direction)) {
                    return false
                }
                var columnsController = this._columnsController;
                var cellIndex = this.getView("rowsView").getCellIndex($cell);
                var columnIndex = cellIndex + columnsController.getColumnIndexOffset();
                var column = columnsController.getVisibleColumns(null, true)[columnIndex];
                var $row = $cell && $cell.parent();
                var rowIndex = this._getRowIndex($row);
                var row = this._dataController.items()[rowIndex];
                var editingController = this._editingController;
                if (column && column.allowEditing) {
                    var _isDataRow = !row || "data" === row.rowType;
                    isEditingAllowed = editingController.allowUpdating({
                        row: row
                    }) ? _isDataRow : row && row.isNewRow
                }
                if (!isEditingAllowed) {
                    this._closeEditCell()
                }
                if (this._focusCell($cell, !nextCellInfo.isHighlighted)) {
                    if (!this._isRowEditMode() && isEditingAllowed) {
                        this._editFocusedCell()
                    } else {
                        this._focusInteractiveElement($cell, eventArgs.shift)
                    }
                }
                return true
            },
            _targetCellTabHandler: function(eventArgs, direction) {
                var $event = eventArgs.originalEvent;
                var eventTarget = $event.target;
                var $cell = this._getCellElementFromTarget(eventTarget);
                var $lastInteractiveElement = this._getInteractiveElement($cell, !eventArgs.shift);
                var isOriginalHandlerRequired = false;
                var elementType;
                if (!isEditorCell(this, $cell) && $lastInteractiveElement.length && eventTarget !== $lastInteractiveElement.get(0)) {
                    isOriginalHandlerRequired = true
                } else {
                    if (void 0 === this._focusedCellPosition.rowIndex && (0, _renderer.default)(eventTarget).hasClass(ROW_CLASS)) {
                        this._updateFocusedCellPosition($cell)
                    }
                    elementType = this._getElementType(eventTarget);
                    if (this.isRowFocusType()) {
                        this.setCellFocusType();
                        if ("row" === elementType && isDataRow((0, _renderer.default)(eventTarget))) {
                            eventTarget = this.getFirstValidCellInRow((0, _renderer.default)(eventTarget));
                            elementType = this._getElementType(eventTarget)
                        }
                    }
                    var nextCellInfo = this._getNextCellByTabKey($event, direction, elementType);
                    $cell = nextCellInfo.$cell;
                    if (!$cell) {
                        return false
                    }
                    $cell = this._checkNewLineTransition($event, $cell);
                    if (!$cell) {
                        return false
                    }
                    this._focusCell($cell, !nextCellInfo.isHighlighted);
                    if (!isEditorCell(this, $cell)) {
                        this._focusInteractiveElement($cell, eventArgs.shift)
                    }
                }
                return isOriginalHandlerRequired
            },
            _getNextCellByTabKey: function($event, direction, elementType) {
                var $cell = this._getNextCell(direction, elementType);
                var args = $cell && this._fireFocusedCellChanging($event, $cell, true);
                if (!args || args.cancel) {
                    return {}
                }
                if (args.$newCellElement) {
                    $cell = args.$newCellElement
                }
                return {
                    $cell: $cell,
                    isHighlighted: args.isHighlighted
                }
            },
            _checkNewLineTransition: function($event, $cell) {
                var rowIndex = this.getVisibleRowIndex();
                var $row = $cell.parent();
                if (rowIndex !== this._getRowIndex($row)) {
                    var cellPosition = this._getCellPosition($cell);
                    var args = this._fireFocusedRowChanging($event, $row);
                    if (args.cancel) {
                        return
                    }
                    if (args.rowIndexChanged) {
                        this.setFocusedColumnIndex(cellPosition.columnIndex);
                        $cell = this._getFocusedCell()
                    }
                }
                return $cell
            },
            _enterKeyHandler: function(eventArgs, isEditing) {
                var $cell = this._getFocusedCell();
                var rowIndex = this.getVisibleRowIndex();
                var $row = this._focusedView && this._focusedView.getRow(rowIndex);
                if (this.option("grouping.allowCollapsing") && isGroupRow($row) || this.option("masterDetail.enabled") && $cell && $cell.hasClass(COMMAND_EXPAND_CLASS)) {
                    var key = this._dataController.getKeyByRowIndex(rowIndex);
                    var item = this._dataController.items()[rowIndex];
                    if (void 0 !== key && item && item.data && !item.data.isContinuation) {
                        this._dataController.changeRowExpand(key)
                    }
                } else {
                    this._processEnterKeyForDataCell(eventArgs, isEditing)
                }
            },
            _processEnterKeyForDataCell: function(eventArgs, isEditing) {
                var direction = this._getEnterKeyDirection(eventArgs);
                var allowEditingOnEnterKey = this._allowEditingOnEnterKey();
                if (isEditing || !allowEditingOnEnterKey && direction) {
                    this._handleEnterKeyEditingCell(eventArgs.originalEvent);
                    if ("next" === direction || "previous" === direction) {
                        this._targetCellTabHandler(eventArgs, direction)
                    } else {
                        if ("upArrow" === direction || "downArrow" === direction) {
                            this._navigateNextCell(eventArgs.originalEvent, direction)
                        }
                    }
                } else {
                    if (allowEditingOnEnterKey) {
                        this._startEditing(eventArgs)
                    }
                }
            },
            _getEnterKeyDirection: function(eventArgs) {
                var enterKeyDirection = this.option("keyboardNavigation.enterKeyDirection");
                var isShift = eventArgs.shift;
                if ("column" === enterKeyDirection) {
                    return isShift ? "upArrow" : "downArrow"
                }
                if ("row" === enterKeyDirection) {
                    return isShift ? "previous" : "next"
                }
            },
            _handleEnterKeyEditingCell: function(event) {
                var target = event.target;
                var $cell = this._getCellElementFromTarget(target);
                var isRowEditMode = this._isRowEditMode();
                this._updateFocusedCellPosition($cell);
                if (isRowEditMode) {
                    this._focusEditFormCell($cell);
                    setTimeout(this._editingController.saveEditData.bind(this._editingController))
                } else {
                    _events_engine.default.trigger((0, _renderer.default)(target), "change");
                    this._closeEditCell();
                    event.preventDefault()
                }
            },
            _escapeKeyHandler: function(eventArgs, isEditing) {
                var $cell = this._getCellElementFromTarget(eventArgs.originalEvent.target);
                if (isEditing) {
                    this._updateFocusedCellPosition($cell);
                    if (!this._isRowEditMode()) {
                        if ("cell" === this._editingController.getEditMode()) {
                            this._editingController.cancelEditData()
                        } else {
                            this._closeEditCell()
                        }
                    } else {
                        this._focusEditFormCell($cell);
                        this._editingController.cancelEditData();
                        if (0 === this._dataController.items().length) {
                            this._resetFocusedCell();
                            this._editorFactory.loseFocus()
                        }
                    }
                    eventArgs.originalEvent.preventDefault()
                }
            },
            _ctrlFKeyHandler: function(eventArgs) {
                if (this.option("searchPanel.visible")) {
                    var searchTextEditor = this._headerPanel.getSearchTextEditor();
                    if (searchTextEditor) {
                        searchTextEditor.focus();
                        eventArgs.originalEvent.preventDefault()
                    }
                }
            },
            _f2KeyHandler: function() {
                var isEditing = this._editingController.isEditing();
                var rowIndex = this.getVisibleRowIndex();
                var $row = this._focusedView && this._focusedView.getRow(rowIndex);
                if (!isEditing && isDataRow($row)) {
                    this._startEditing()
                }
            },
            _navigateNextCell: function($event, keyCode) {
                var $cell = this._getNextCell(keyCode);
                var directionCode = this._getDirectionCodeByKey(keyCode);
                var isCellValid = $cell && this._isCellValid($cell);
                var result = isCellValid ? this._arrowKeysHandlerFocusCell($event, $cell, directionCode) : false;
                return result
            },
            _arrowKeysHandlerFocusCell: function($event, $nextCell, direction) {
                var isVerticalDirection = "prevRow" === direction || "nextRow" === direction;
                var args = this._fireFocusChangingEvents($event, $nextCell, isVerticalDirection, true);
                $nextCell = args.$newCellElement;
                if (!args.cancel && this._isCellValid($nextCell)) {
                    this._focus($nextCell, !args.isHighlighted);
                    return true
                }
                return false
            },
            _beginFastEditing: function(originalEvent, isDeleting) {
                if (!this._isFastEditingAllowed() || originalEvent.altKey || originalEvent.ctrlKey || this._editingController.isEditing()) {
                    return false
                }
                if (isDeleting) {
                    this._startEditing(originalEvent, FAST_EDITING_DELETE_KEY)
                } else {
                    var key = originalEvent.key;
                    var keyCode = originalEvent.keyCode || originalEvent.which;
                    var fastEditingKey = key || keyCode && String.fromCharCode(keyCode);
                    if (fastEditingKey && (1 === fastEditingKey.length || fastEditingKey === FAST_EDITING_DELETE_KEY)) {
                        this._startEditing(originalEvent, fastEditingKey)
                    }
                }
                return true
            },
            _pointerEventHandler: function(e) {
                var event = e.event || e;
                var $target = (0, _renderer.default)(event.currentTarget);
                var rowsView = this.getView("rowsView");
                var focusedViewElement = rowsView && rowsView.element();
                var $parent = $target.parent();
                var isInteractiveElement = (0, _renderer.default)(event.target).is(INTERACTIVE_ELEMENTS_SELECTOR);
                var isRevertButton = !!(0, _renderer.default)(event.target).closest(".".concat(REVERT_BUTTON_CLASS)).length;
                var isExpandCommandCell = $target.hasClass(COMMAND_EXPAND_CLASS);
                if (!this._isEventInCurrentGrid(event)) {
                    return
                }
                if (!isRevertButton && (this._isCellValid($target, !isInteractiveElement) || isExpandCommandCell)) {
                    $target = this._isInsideEditForm($target) ? (0, _renderer.default)(event.target) : $target;
                    this._focusView();
                    (0, _renderer.default)(focusedViewElement).removeClass(FOCUS_STATE_CLASS);
                    if ($parent.hasClass(FREESPACE_ROW_CLASS)) {
                        this._updateFocusedCellPosition($target);
                        this._applyTabIndexToElement(this._focusedView.element());
                        this._focusedView.focus()
                    } else {
                        if (!this._isMasterDetailCell($target)) {
                            this._clickTargetCellHandler(event, $target)
                        } else {
                            this._updateFocusedCellPosition($target)
                        }
                    }
                } else {
                    if ($target.is("td")) {
                        this._resetFocusedCell()
                    }
                }
            },
            _clickTargetCellHandler: function(event, $cell) {
                var columnIndex = this.getView("rowsView").getCellIndex($cell);
                var column = this._columnsController.getVisibleColumns()[columnIndex];
                var isCellEditMode = this._isCellEditMode();
                this.setCellFocusType();
                var args = this._fireFocusChangingEvents(event, $cell, true);
                $cell = args.$newCellElement;
                if (!args.cancel) {
                    if (args.resetFocusedRow) {
                        this.getController("focus")._resetFocusedRow();
                        return
                    }
                    if (args.rowIndexChanged) {
                        $cell = this._getFocusedCell()
                    }
                    if (!args.isHighlighted && !isCellEditMode) {
                        this.setRowFocusType()
                    }
                    this._updateFocusedCellPosition($cell);
                    if (this._allowRowUpdating() && isCellEditMode && column && column.allowEditing) {
                        this._isNeedFocus = false;
                        this._isHiddenFocus = false
                    } else {
                        var $target = event && (0, _renderer.default)(event.target).closest(INTERACTIVE_ELEMENTS_SELECTOR + ", td");
                        var isInteractiveTarget = $target && $target.not($cell).is(INTERACTIVE_ELEMENTS_SELECTOR);
                        var isEditor = !!column && !column.command && $cell.hasClass(EDITOR_CELL_CLASS);
                        var isDisabled = !isEditor && (!args.isHighlighted || isInteractiveTarget);
                        this._focus($cell, isDisabled, isInteractiveTarget)
                    }
                } else {
                    this.setRowFocusType();
                    this.setFocusedRowIndex(args.prevRowIndex);
                    $cell = this._getFocusedCell();
                    if (this._editingController.isEditing() && isCellEditMode) {
                        this._closeEditCell()
                    }
                }
            },
            _allowRowUpdating: function() {
                var rowIndex = this.getVisibleRowIndex();
                var row = this._dataController.items()[rowIndex];
                return this._editingController.allowUpdating({
                    row: row
                }, "click")
            },
            focus: function(element) {
                var activeElementSelector;
                var focusedRowEnabled = this.option("focusedRowEnabled");
                var isHighlighted = isCellElement((0, _renderer.default)(element));
                if (!element) {
                    activeElementSelector = ".dx-datagrid-rowsview .dx-row[tabindex]";
                    if (!focusedRowEnabled) {
                        activeElementSelector += ", .dx-datagrid-rowsview .dx-row > td[tabindex]"
                    }
                    element = this.component.$element().find(activeElementSelector).first()
                }
                element && this._focusElement((0, _renderer.default)(element), isHighlighted)
            },
            getFocusedView: function() {
                return this._focusedView
            },
            setupFocusedView: function() {
                if (this.isKeyboardEnabled() && !(0, _type.isDefined)(this._focusedView)) {
                    this._focusView()
                }
            },
            _focusElement: function($element, isHighlighted) {
                var rowsViewElement = (0, _renderer.default)(this._getRowsViewElement());
                var $focusedView = $element.closest(rowsViewElement);
                var isRowFocusType = this.isRowFocusType();
                var args = {};
                if (!$focusedView.length || isCellElement($element) && !this._isCellValid($element)) {
                    return
                }
                this._focusView();
                this._isNeedFocus = true;
                this._isNeedScroll = true;
                if (isCellElement($element) || isGroupRow($element)) {
                    this.setCellFocusType();
                    args = this._fireFocusChangingEvents(null, $element, false, isHighlighted);
                    $element = args.$newCellElement;
                    if (isRowFocusType && !args.isHighlighted) {
                        this.setRowFocusType()
                    }
                }
                if (!args.cancel) {
                    this._focus($element, !args.isHighlighted);
                    this._focusInteractiveElement($element)
                }
            },
            _getFocusedViewByElement: function($element) {
                var view = this.getFocusedView();
                var $view = view && (0, _renderer.default)(view.element());
                return $element && 0 !== $element.closest($view).length
            },
            _focusView: function() {
                this._focusedView = this.getView("rowsView")
            },
            _resetFocusedView: function() {
                this.setRowFocusType();
                this._focusedView = null
            },
            _focusInteractiveElement: function($cell, isLast) {
                if (!$cell) {
                    return
                }
                var $focusedElement = this._getInteractiveElement($cell, isLast);
                _uiGrid_core2.default.focusAndSelectElement(this, $focusedElement)
            },
            _focus: function($cell, disableFocus, isInteractiveElement) {
                var $row = $cell && !$cell.hasClass(ROW_CLASS) ? $cell.closest(".".concat(ROW_CLASS)) : $cell;
                if ($row && isNotFocusedRow($row)) {
                    return
                }
                var focusedView = this._focusedView;
                var $focusViewElement = focusedView && focusedView.element();
                var $focusElement;
                this._isHiddenFocus = disableFocus;
                if (isGroupRow($row) || this.isRowFocusType()) {
                    $focusElement = $row;
                    if (focusedView) {
                        this.setFocusedRowIndex(this._getRowIndex($row))
                    }
                } else {
                    if (isCellElement($cell)) {
                        $focusElement = $cell;
                        this._updateFocusedCellPosition($cell)
                    }
                }
                if ($focusElement) {
                    if ($focusViewElement) {
                        $focusViewElement.find(".dx-row[tabindex], .dx-row > td[tabindex]").not($focusElement).removeClass(CELL_FOCUS_DISABLED_CLASS).removeAttr("tabindex")
                    }
                    _events_engine.default.one($focusElement, "blur", function(e) {
                        if (e.relatedTarget) {
                            $focusElement.removeClass(CELL_FOCUS_DISABLED_CLASS)
                        }
                    });
                    if (!isInteractiveElement) {
                        this._applyTabIndexToElement($focusElement);
                        _events_engine.default.trigger($focusElement, "focus")
                    }
                    if (disableFocus) {
                        $focusElement.addClass(CELL_FOCUS_DISABLED_CLASS)
                    } else {
                        this._editorFactory.focus($focusElement)
                    }
                }
            },
            _updateFocus: function(isRenderView) {
                var _this6 = this;
                this._updateFocusTimeout = setTimeout(function() {
                    var editingController = _this6._editingController;
                    var isCellEditMode = editingController.getEditMode() === EDIT_MODE_CELL;
                    if (!_this6.option("repaintChangesOnly") && isCellEditMode && editingController.hasChanges()) {
                        editingController._focusEditingCell();
                        return
                    }
                    var $cell = _this6._getFocusedCell();
                    var isEditing = editingController.isEditing();
                    if ($cell && !(_this6._isMasterDetailCell($cell) && !_this6._isRowEditMode())) {
                        if (_this6._hasSkipRow($cell.parent())) {
                            var direction = _this6._focusedCellPosition && _this6._focusedCellPosition.rowIndex > 0 ? "upArrow" : "downArrow";
                            $cell = _this6._getNextCell(direction)
                        }
                        if (isElementDefined($cell)) {
                            if (isRenderView && !isEditing && _this6._checkCellOverlapped($cell)) {
                                return
                            }
                            if ($cell.is("td") || $cell.hasClass(_this6.addWidgetPrefix(EDIT_FORM_ITEM_CLASS))) {
                                var isCommandCell = $cell.is(COMMAND_CELL_SELECTOR);
                                var $focusedElementInsideCell = $cell.find(":focus");
                                var isFocusedElementDefined = isElementDefined($focusedElementInsideCell);
                                if ((isRenderView || !isCommandCell) && _this6._editorFactory.focus()) {
                                    if (isCommandCell && isFocusedElementDefined) {
                                        _uiGrid_core2.default.focusAndSelectElement(_this6, $focusedElementInsideCell);
                                        return
                                    }!isFocusedElementDefined && _this6._focus($cell)
                                } else {
                                    if (!isFocusedElementDefined && (_this6._isNeedFocus || _this6._isHiddenFocus)) {
                                        _this6._focus($cell, _this6._isHiddenFocus)
                                    }
                                }
                                if (isEditing) {
                                    _this6._focusInteractiveElement.bind(_this6)($cell)
                                }
                            } else {
                                _events_engine.default.trigger($cell, "focus")
                            }
                        }
                    }
                })
            },
            _checkCellOverlapped: function($cell) {
                var cellOffset = $cell.offset();
                var hasScrollable = this.component.getScrollable && this.component.getScrollable();
                var isOverlapped = false;
                if (hasScrollable) {
                    if (cellOffset.left < 0) {
                        isOverlapped = $cell.width() + cellOffset.left <= 0
                    } else {
                        if (cellOffset.top < 0) {
                            isOverlapped = $cell.height() + cellOffset.top <= 0
                        }
                    }
                }
                return isOverlapped
            },
            _getFocusedCell: function() {
                return (0, _renderer.default)(this._getCell(this._focusedCellPosition))
            },
            _updateFocusedCellPositionByTarget: function(target) {
                var _this$_focusedCellPos;
                var elementType = this._getElementType(target);
                if ("row" === elementType && (0, _type.isDefined)(null === (_this$_focusedCellPos = this._focusedCellPosition) || void 0 === _this$_focusedCellPos ? void 0 : _this$_focusedCellPos.columnIndex)) {
                    var $row = (0, _renderer.default)(target);
                    this._focusedView && isGroupRow($row) && this.setFocusedRowIndex(this._getRowIndex($row))
                } else {
                    this._updateFocusedCellPosition(this._getCellElementFromTarget(target))
                }
            },
            _updateFocusedCellPosition: function($cell, direction) {
                var position = this._getCellPosition($cell, direction);
                if (position) {
                    if (!$cell.length || position.rowIndex >= 0 && position.columnIndex >= 0) {
                        this.setFocusedCellPosition(position.rowIndex, position.columnIndex)
                    }
                }
                return position
            },
            _getFocusedColumnIndexOffset: function(columnIndex) {
                var offset = 0;
                var column = this._columnsController.getVisibleColumns()[columnIndex];
                if (column && column.fixed) {
                    offset = this._getFixedColumnIndexOffset(column)
                } else {
                    if (columnIndex >= 0) {
                        offset = this._columnsController.getColumnIndexOffset()
                    }
                }
                return offset
            },
            _getFixedColumnIndexOffset: function(column) {
                var offset = isFixedColumnIndexOffsetRequired(this, column) ? this._getVisibleColumnCount() - this._columnsController.getVisibleColumns().length : 0;
                return offset
            },
            _getCellPosition: function($cell, direction) {
                var columnIndex;
                var $row = isElementDefined($cell) && $cell.closest("tr");
                var rowsView = this.getView("rowsView");
                if (isElementDefined($row)) {
                    var rowIndex = this._getRowIndex($row);
                    columnIndex = rowsView.getCellIndex($cell, rowIndex);
                    columnIndex += this._getFocusedColumnIndexOffset(columnIndex);
                    if (direction) {
                        columnIndex = "previous" === direction ? columnIndex - 1 : columnIndex + 1;
                        columnIndex = this._applyColumnIndexBoundaries(columnIndex)
                    }
                    return {
                        rowIndex: rowIndex,
                        columnIndex: columnIndex
                    }
                }
            },
            _focusCell: function($cell, isDisabled) {
                if (this._isCellValid($cell)) {
                    this._focus($cell, isDisabled);
                    return true
                }
            },
            _focusEditFormCell: function($cell) {
                if ($cell.hasClass(MASTER_DETAIL_CELL_CLASS)) {
                    this._editorFactory.focus($cell, true)
                }
            },
            _resetFocusedCell: function(preventScroll) {
                var _this$_focusedView;
                var $cell = this._getFocusedCell();
                isElementDefined($cell) && $cell.removeAttr("tabindex");
                this._isNeedFocus = false;
                this._isNeedScroll = false;
                this._focusedCellPosition = {};
                clearTimeout(this._updateFocusTimeout);
                null === (_this$_focusedView = this._focusedView) || void 0 === _this$_focusedView ? void 0 : _this$_focusedView.renderFocusState(preventScroll)
            },
            restoreFocusableElement: function(rowIndex, $event) {
                var that = this;
                var args;
                var $rowElement;
                var isUpArrow = (0, _type.isDefined)(rowIndex);
                var rowsView = that.getView("rowsView");
                var $rowsViewElement = rowsView.element();
                var columnIndex = that._focusedCellPosition.columnIndex;
                var rowIndexOffset = that._dataController.getRowIndexOffset();
                rowIndex = isUpArrow ? rowIndex : rowsView.getTopVisibleItemIndex() + rowIndexOffset;
                if (!isUpArrow) {
                    that._editorFactory.loseFocus();
                    that._applyTabIndexToElement($rowsViewElement);
                    _events_engine.default.trigger($rowsViewElement, "focus")
                } else {
                    $rowElement = rowsView.getRow(rowIndex - rowIndexOffset);
                    args = that._fireFocusedRowChanging($event, $rowElement);
                    if (!args.cancel && args.rowIndexChanged) {
                        rowIndex = args.newRowIndex
                    }
                }
                if (!isUpArrow || !args.cancel) {
                    that.setFocusedCellPosition(rowIndex, columnIndex)
                }
                isUpArrow && that._updateFocus()
            },
            _getNewPositionByCode: function(cellPosition, elementType, code) {
                var columnIndex = cellPosition.columnIndex;
                var rowIndex = cellPosition.rowIndex;
                var visibleColumnsCount;
                if (void 0 === cellPosition.rowIndex && "next" === code) {
                    return {
                        columnIndex: 0,
                        rowIndex: 0
                    }
                }
                switch (code) {
                    case "nextInRow":
                    case "next":
                        visibleColumnsCount = this._getVisibleColumnCount();
                        if (columnIndex < visibleColumnsCount - 1 && "row" !== elementType && this._hasValidCellAfterPosition({
                                columnIndex: columnIndex,
                                rowIndex: rowIndex
                            })) {
                            columnIndex++
                        } else {
                            if (!this._isLastRow(rowIndex) && "next" === code) {
                                columnIndex = 0;
                                rowIndex++
                            }
                        }
                        break;
                    case "previousInRow":
                    case "previous":
                        if (columnIndex > 0 && "row" !== elementType && this._hasValidCellBeforePosition({
                                columnIndex: columnIndex,
                                rowIndex: rowIndex
                            })) {
                            columnIndex--
                        } else {
                            if (rowIndex > 0 && "previous" === code) {
                                rowIndex--;
                                visibleColumnsCount = this._getVisibleColumnCount();
                                columnIndex = visibleColumnsCount - 1
                            }
                        }
                        break;
                    case "upArrow":
                        rowIndex = rowIndex > 0 ? rowIndex - 1 : rowIndex;
                        break;
                    case "downArrow":
                        rowIndex = !this._isLastRow(rowIndex) ? rowIndex + 1 : rowIndex
                }
                return {
                    columnIndex: columnIndex,
                    rowIndex: rowIndex
                }
            },
            setFocusedCellPosition: function(rowIndex, columnIndex) {
                this.setFocusedRowIndex(rowIndex);
                this.setFocusedColumnIndex(columnIndex)
            },
            setFocusedRowIndex: function(rowIndex) {
                if (!this._focusedCellPosition) {
                    this._focusedCellPosition = {}
                }
                this._focusedCellPosition.rowIndex = rowIndex
            },
            setFocusedColumnIndex: function(columnIndex) {
                if (!this._focusedCellPosition) {
                    this._focusedCellPosition = {}
                }
                this._focusedCellPosition.columnIndex = columnIndex
            },
            getRowIndex: function() {
                return this._focusedCellPosition ? this._focusedCellPosition.rowIndex : -1
            },
            getColumnIndex: function() {
                return this._focusedCellPosition ? this._focusedCellPosition.columnIndex : -1
            },
            getVisibleRowIndex: function() {
                var rowIndex = this._focusedCellPosition && this._focusedCellPosition.rowIndex;
                if (!(0, _type.isDefined)(rowIndex)) {
                    return -1
                }
                return rowIndex - this._dataController.getRowIndexOffset()
            },
            getVisibleColumnIndex: function() {
                var columnIndex = this._focusedCellPosition && this._focusedCellPosition.columnIndex;
                if (!(0, _type.isDefined)(columnIndex)) {
                    return -1
                }
                return columnIndex - this._columnsController.getColumnIndexOffset()
            },
            _applyColumnIndexBoundaries: function(columnIndex) {
                var visibleColumnsCount = this._getVisibleColumnCount();
                if (columnIndex < 0) {
                    columnIndex = 0
                } else {
                    if (columnIndex >= visibleColumnsCount) {
                        columnIndex = visibleColumnsCount - 1
                    }
                }
                return columnIndex
            },
            _isCellByPositionValid: function(cellPosition) {
                var $cell = (0, _renderer.default)(this._getCell(cellPosition));
                return this._isCellValid($cell)
            },
            _isLastRow: function(rowIndex) {
                if (this._isVirtualRowRender()) {
                    return rowIndex >= this._dataController.totalItemsCount() - 1
                }
                return rowIndex === this._dataController.items().length - 1
            },
            _isFirstValidCell: function(cellPosition) {
                var isFirstValidCell = false;
                if (0 === cellPosition.rowIndex && cellPosition.columnIndex >= 0) {
                    isFirstValidCell = isFirstValidCell || !this._hasValidCellBeforePosition(cellPosition)
                }
                return isFirstValidCell
            },
            _hasValidCellBeforePosition: function(cellPosition) {
                var columnIndex = cellPosition.columnIndex;
                var hasValidCells = false;
                while (columnIndex > 0 && !hasValidCells) {
                    var checkingPosition = {
                        columnIndex: --columnIndex,
                        rowIndex: cellPosition.rowIndex
                    };
                    hasValidCells = this._isCellByPositionValid(checkingPosition)
                }
                return hasValidCells
            },
            _hasValidCellAfterPosition: function(cellPosition) {
                var columnIndex = cellPosition.columnIndex;
                var hasValidCells = false;
                var visibleColumnCount = this._getVisibleColumnCount();
                while (columnIndex < visibleColumnCount - 1 && !hasValidCells) {
                    var checkingPosition = {
                        columnIndex: ++columnIndex,
                        rowIndex: cellPosition.rowIndex
                    };
                    hasValidCells = this._isCellByPositionValid(checkingPosition)
                }
                return hasValidCells
            },
            _isLastValidCell: function(cellPosition) {
                var nextColumnIndex = cellPosition.columnIndex >= 0 ? cellPosition.columnIndex + 1 : 0;
                var rowIndex = cellPosition.rowIndex;
                var checkingPosition = {
                    columnIndex: nextColumnIndex,
                    rowIndex: rowIndex
                };
                var visibleRows = this._dataController.getVisibleRows();
                var row = visibleRows && visibleRows[rowIndex];
                var isLastRow = this._isLastRow(rowIndex);
                if (!isLastRow) {
                    return false
                }
                if (row && "group" === row.rowType && cellPosition.columnIndex > 0) {
                    return true
                }
                if (cellPosition.columnIndex === this._getVisibleColumnCount() - 1) {
                    return true
                }
                if (this._isCellByPositionValid(checkingPosition)) {
                    return false
                }
                return this._isLastValidCell(checkingPosition)
            },
            _isCellValid: function($cell, isClick) {
                if (isElementDefined($cell)) {
                    var rowsView = this.getView("rowsView");
                    var $row = $cell.parent();
                    var columnsController = this._columnsController;
                    var columnIndex = rowsView.getCellIndex($cell) + columnsController.getColumnIndexOffset();
                    var column = columnsController.getVisibleColumns(null, true)[columnIndex];
                    var visibleColumnCount = this._getVisibleColumnCount();
                    var editingController = this._editingController;
                    var isMasterDetailRow = isDetailRow($row);
                    var isShowWhenGrouped = column && column.showWhenGrouped;
                    var isDataCell = column && !$cell.hasClass(COMMAND_EXPAND_CLASS) && isDataRow($row);
                    var isValidGroupSpaceColumn = function() {
                        return !isMasterDetailRow && column && (!(0, _type.isDefined)(column.groupIndex) || isShowWhenGrouped && isDataCell) || parseInt($cell.attr("colspan")) > 1
                    };
                    if (this._isMasterDetailCell($cell)) {
                        return true
                    }
                    if (visibleColumnCount > columnIndex && isValidGroupSpaceColumn()) {
                        var rowItems = this._dataController.items();
                        var visibleRowIndex = rowsView.getRowIndex($row);
                        var row = rowItems[visibleRowIndex];
                        var isCellEditing = editingController && this._isCellEditMode() && editingController.isEditing();
                        var isRowEditingInCurrentRow = editingController && editingController.isEditRow(visibleRowIndex);
                        var isEditing = isRowEditingInCurrentRow || isCellEditing;
                        if (column.command) {
                            if (this._isLegacyNavigation()) {
                                return !isEditing && "expand" === column.command
                            }
                            if (isCellEditing) {
                                return false
                            }
                            if (isRowEditingInCurrentRow) {
                                return "select" !== column.command
                            }
                            return !isEditing
                        }
                        if (isCellEditing && row && "data" !== row.rowType) {
                            return false
                        }
                        return !isEditing || column.allowEditing || isClick
                    }
                }
            },
            getFirstValidCellInRow: function($row, columnIndex) {
                var that = this;
                var $cells = $row.find("> td");
                var $cell;
                var $result;
                columnIndex = columnIndex || 0;
                for (var i = columnIndex; i < $cells.length; ++i) {
                    $cell = $cells.eq(i);
                    if (that._isCellValid($cell)) {
                        $result = $cell;
                        break
                    }
                }
                return $result
            },
            _getNextCell: function(keyCode, elementType, cellPosition) {
                var focusedCellPosition = cellPosition || this._focusedCellPosition;
                var isRowFocusType = this.isRowFocusType();
                var includeCommandCells = isRowFocusType || (0, _array.inArray)(keyCode, ["next", "previous"]) > -1;
                var $cell;
                var $row;
                if (this._focusedView && focusedCellPosition) {
                    var newFocusedCellPosition = this._getNewPositionByCode(focusedCellPosition, elementType, keyCode);
                    $cell = (0, _renderer.default)(this._getCell(newFocusedCellPosition));
                    var isLastCellOnDirection = "previous" === keyCode ? this._isFirstValidCell(newFocusedCellPosition) : this._isLastValidCell(newFocusedCellPosition);
                    if (isElementDefined($cell) && !this._isCellValid($cell) && this._isCellInRow(newFocusedCellPosition, includeCommandCells) && !isLastCellOnDirection) {
                        if (isRowFocusType) {
                            $cell = this.getFirstValidCellInRow($cell.parent(), newFocusedCellPosition.columnIndex)
                        } else {
                            $cell = this._getNextCell(keyCode, "cell", newFocusedCellPosition)
                        }
                    }
                    $row = isElementDefined($cell) && $cell.parent();
                    if (this._hasSkipRow($row)) {
                        var rowIndex = this._getRowIndex($row);
                        if (!this._isLastRow(rowIndex)) {
                            $cell = this._getNextCell(keyCode, "row", {
                                columnIndex: focusedCellPosition.columnIndex,
                                rowIndex: rowIndex
                            })
                        } else {
                            return null
                        }
                    }
                    return isElementDefined($cell) ? $cell : null
                }
                return null
            },
            _startEditing: function(eventArgs, fastEditingKey) {
                var focusedCellPosition = this._focusedCellPosition;
                var visibleRowIndex = this.getVisibleRowIndex();
                var visibleColumnIndex = this.getVisibleColumnIndex();
                var row = this._dataController.items()[visibleRowIndex];
                var column = this._columnsController.getVisibleColumns()[visibleColumnIndex];
                if (this._isAllowEditing(row, column)) {
                    if (this._isRowEditMode()) {
                        this._editingController.editRow(visibleRowIndex)
                    } else {
                        if (focusedCellPosition) {
                            this._startEditCell(eventArgs, fastEditingKey)
                        }
                    }
                }
            },
            _isAllowEditing: function(row, column) {
                return this._editingController.allowUpdating({
                    row: row
                }) && column && column.allowEditing
            },
            _editFocusedCell: function() {
                var rowIndex = this.getVisibleRowIndex();
                var colIndex = this.getVisibleColumnIndex();
                return this._editingController.editCell(rowIndex, colIndex)
            },
            _startEditCell: function(eventArgs, fastEditingKey) {
                var _this7 = this;
                this._fastEditingStarted = (0, _type.isDefined)(fastEditingKey);
                var editResult = this._editFocusedCell();
                if (this._isFastEditingStarted()) {
                    if (true === editResult) {
                        this._editingCellHandler(eventArgs, fastEditingKey)
                    } else {
                        if (editResult && editResult.done) {
                            var editorValue = fastEditingKey !== FAST_EDITING_DELETE_KEY ? fastEditingKey : "";
                            editResult.done(function() {
                                return _this7._editingCellHandler(eventArgs, editorValue)
                            })
                        }
                    }
                }
            },
            _editingCellHandler: function(eventArgs, editorValue) {
                var $input = this._getFocusedCell().find(".dx-texteditor-input").eq(0);
                var keyDownEvent = (0, _index.createEvent)(eventArgs, {
                    type: "keydown",
                    target: $input.get(0)
                });
                var keyPressEvent = (0, _index.createEvent)(eventArgs, {
                    type: "keypress",
                    target: $input.get(0)
                });
                var inputEvent = (0, _index.createEvent)(eventArgs, {
                    type: "input",
                    target: $input.get(0)
                });
                _events_engine.default.trigger($input, keyDownEvent);
                if (!keyDownEvent.isDefaultPrevented()) {
                    _events_engine.default.trigger($input, keyPressEvent);
                    if (!keyPressEvent.isDefaultPrevented()) {
                        var timeout = _browser.default.mozilla ? 25 : 0;
                        setTimeout(function() {
                            $input.val(editorValue);
                            var $widgetContainer = $input.closest(".".concat(WIDGET_CLASS));
                            _events_engine.default.off($widgetContainer, "focusout");
                            _events_engine.default.one($widgetContainer, "focusout", function() {
                                _events_engine.default.trigger($input, "change")
                            });
                            _events_engine.default.trigger($input, inputEvent)
                        }, timeout)
                    }
                }
            },
            _fireFocusChangingEvents: function($event, $cell, fireRowEvent, isHighlighted) {
                var args = {};
                var cellPosition = this._getCellPosition($cell) || {};
                if (this.isCellFocusType()) {
                    args = this._fireFocusedCellChanging($event, $cell, isHighlighted);
                    if (!args.cancel) {
                        cellPosition.columnIndex = args.newColumnIndex;
                        cellPosition.rowIndex = args.newRowIndex;
                        isHighlighted = args.isHighlighted;
                        $cell = (0, _renderer.default)(this._getCell(cellPosition))
                    }
                }
                if (!args.cancel && fireRowEvent && $cell) {
                    args = this._fireFocusedRowChanging($event, $cell.parent());
                    if (!args.cancel) {
                        cellPosition.rowIndex = args.newRowIndex;
                        args.isHighlighted = isHighlighted
                    }
                }
                args.$newCellElement = (0, _renderer.default)(this._getCell(cellPosition));
                if (!args.$newCellElement.length) {
                    args.$newCellElement = $cell
                }
                return args
            },
            _fireFocusedCellChanging: function($event, $cellElement, isHighlighted) {
                var that = this;
                var prevCellIndex = that.option("focusedColumnIndex");
                var prevRowIndex = that.option("focusedRowIndex");
                var cellPosition = that._getCellPosition($cellElement);
                var columnIndex = cellPosition ? cellPosition.columnIndex : -1;
                var rowIndex = cellPosition ? cellPosition.rowIndex : -1;
                var args = {
                    cellElement: $cellElement,
                    prevColumnIndex: prevCellIndex,
                    prevRowIndex: prevRowIndex,
                    newColumnIndex: columnIndex,
                    newRowIndex: rowIndex,
                    rows: that._dataController.getVisibleRows(),
                    columns: that._columnsController.getVisibleColumns(),
                    event: $event,
                    isHighlighted: isHighlighted || false,
                    cancel: false
                };
                this._canceledCellPosition = null;
                that.executeAction("onFocusedCellChanging", args);
                if (args.newColumnIndex !== columnIndex || args.newRowIndex !== rowIndex) {
                    args.$newCellElement = (0, _renderer.default)(this._getCell({
                        columnIndex: args.newColumnIndex,
                        rowIndex: args.newRowIndex
                    }))
                }
                if (args.cancel) {
                    this._canceledCellPosition = {
                        rowIndex: rowIndex,
                        columnIndex: columnIndex
                    }
                }
                return args
            },
            _fireFocusedCellChanged: function($cellElement, prevCellIndex, prevRowIndex) {
                var that = this;
                var dataController = that._dataController;
                var columnIndex = that.getView("rowsView").getCellIndex($cellElement);
                var rowIndex = this._getRowIndex($cellElement && $cellElement.parent());
                var localRowIndex = Math.min(rowIndex - dataController.getRowIndexOffset(), dataController.items().length - 1);
                var isEditingCell = that._editingController.isEditCell(localRowIndex, columnIndex);
                var row = dataController.items()[localRowIndex];
                if (!isEditingCell && (prevCellIndex !== columnIndex || prevRowIndex !== rowIndex)) {
                    that.executeAction("onFocusedCellChanged", {
                        cellElement: $cellElement,
                        columnIndex: columnIndex,
                        rowIndex: rowIndex,
                        row: row,
                        column: that._columnsController.getVisibleColumns()[columnIndex]
                    })
                }
            },
            _fireFocusedRowChanging: function(eventArgs, $newFocusedRow) {
                var newRowIndex = this._getRowIndex($newFocusedRow);
                var dataController = this._dataController;
                var prevFocusedRowIndex = this.option("focusedRowIndex");
                var loadingOperationTypes = dataController.loadingOperationTypes();
                var args = {
                    rowElement: $newFocusedRow,
                    prevRowIndex: prevFocusedRowIndex,
                    newRowIndex: newRowIndex,
                    event: eventArgs,
                    rows: dataController.getVisibleRows(),
                    cancel: false
                };
                if (!dataController || dataController.isLoading() && (loadingOperationTypes.reload || loadingOperationTypes.paging)) {
                    args.cancel = true;
                    return args
                }
                if (this.option("focusedRowEnabled")) {
                    this.executeAction("onFocusedRowChanging", args);
                    if (!args.cancel && args.newRowIndex !== newRowIndex) {
                        args.resetFocusedRow = args.newRowIndex < 0;
                        if (!args.resetFocusedRow) {
                            this.setFocusedRowIndex(args.newRowIndex)
                        }
                        args.rowIndexChanged = true
                    }
                }
                return args
            },
            _fireFocusedRowChanged: function($rowElement) {
                var row;
                var focusedRowKey = this.option("focusedRowKey");
                var focusController = this.getController("focus");
                var focusedRowIndex = null === focusController || void 0 === focusController ? void 0 : focusController.getFocusedRowIndexByKey(focusedRowKey);
                if (this.option("focusedRowEnabled")) {
                    if (focusedRowIndex >= 0) {
                        var dataController = this._dataController;
                        row = focusedRowIndex >= 0 && dataController.getVisibleRows()[focusedRowIndex - dataController.getRowIndexOffset()]
                    }
                    this.executeAction("onFocusedRowChanged", {
                        rowElement: $rowElement,
                        rowIndex: focusedRowIndex,
                        row: row
                    })
                }
            },
            _isEventInCurrentGrid: function(event) {
                return _uiGrid_core2.default.isElementInCurrentGrid(this, (0, _renderer.default)(event.target))
            },
            _isRowEditMode: function() {
                var editMode = this._editingController.getEditMode();
                return editMode === EDIT_MODE_ROW || editMode === EDIT_MODE_FORM
            },
            _isCellEditMode: function() {
                var editMode = this._editingController.getEditMode();
                return editMode === EDIT_MODE_CELL || editMode === EDIT_MODE_BATCH
            },
            _isFastEditingAllowed: function() {
                return this._isCellEditMode() && this.option("keyboardNavigation.editOnKeyPress")
            },
            _getInteractiveElement: function($cell, isLast) {
                var $focusedElement = $cell.find(INTERACTIVE_ELEMENTS_SELECTOR).filter(":visible");
                return isLast ? $focusedElement.last() : $focusedElement.first()
            },
            _applyTabIndexToElement: function($element) {
                var tabIndex = this.option("tabIndex") || 0;
                $element.attr("tabindex", (0, _type.isDefined)(tabIndex) ? tabIndex : 0)
            },
            _getCell: function(cellPosition) {
                if (this._focusedView && cellPosition) {
                    var rowIndexOffset = this._dataController.getRowIndexOffset();
                    var column = this._columnsController.getVisibleColumns(null, true)[cellPosition.columnIndex];
                    var columnIndexOffset = column && column.fixed ? this._getFixedColumnIndexOffset(column) : this._columnsController.getColumnIndexOffset();
                    var rowIndex = cellPosition.rowIndex >= 0 ? cellPosition.rowIndex - rowIndexOffset : -1;
                    var columnIndex = cellPosition.columnIndex >= 0 ? cellPosition.columnIndex - columnIndexOffset : -1;
                    return this._focusedView.getCell({
                        rowIndex: rowIndex,
                        columnIndex: columnIndex
                    })
                }
            },
            _getRowIndex: function($row) {
                var rowsView = this.getView("rowsView");
                var rowIndex = rowsView.getRowIndex($row);
                if (rowIndex >= 0) {
                    rowIndex += this._dataController.getRowIndexOffset()
                }
                return rowIndex
            },
            _hasSkipRow: function($row) {
                var row = $row && $row.get(0);
                return row && ("none" === row.style.display || $row.hasClass(this.addWidgetPrefix(GROUP_FOOTER_CLASS)) || isDetailRow($row) && !$row.hasClass(this.addWidgetPrefix(EDIT_FORM_CLASS)))
            },
            _allowEditingOnEnterKey: function() {
                return "startEdit" === this.option("keyboardNavigation.enterKeyAction")
            },
            _isLegacyNavigation: function() {
                return this.option("useLegacyKeyboardNavigation")
            },
            _getDirectionCodeByKey: function(key) {
                var directionCode;
                switch (key) {
                    case "upArrow":
                        directionCode = "prevRow";
                        break;
                    case "downArrow":
                        directionCode = "nextRow";
                        break;
                    case "leftArrow":
                        directionCode = this.option("rtlEnabled") ? "nextInRow" : "previousInRow";
                        break;
                    case "rightArrow":
                        directionCode = this.option("rtlEnabled") ? "previousInRow" : "nextInRow"
                }
                return directionCode
            },
            _isVirtualScrolling: function() {
                var scrollingMode = this.option("scrolling.mode");
                return "virtual" === scrollingMode || "infinite" === scrollingMode
            },
            _isVirtualRowRender: function() {
                return this._isVirtualScrolling() || "virtual" === this.option("scrolling.rowRenderingMode")
            },
            _isVirtualColumnRender: function() {
                return "virtual" === this.option("scrolling.columnRenderingMode")
            },
            _scrollBy: function(left, top, rowIndex, $event) {
                var that = this;
                var scrollable = this.getView("rowsView").getScrollable();
                if (that._focusedCellPosition) {
                    var scrollHandler = function scrollHandler() {
                        scrollable.off("scroll", scrollHandler);
                        setTimeout(that.restoreFocusableElement.bind(that, rowIndex, $event))
                    };
                    scrollable.on("scroll", scrollHandler)
                }
                return scrollable.scrollBy({
                    left: left,
                    top: top
                })
            },
            _isInsideEditForm: function(element) {
                return (0, _renderer.default)(element).closest("." + this.addWidgetPrefix(EDIT_FORM_CLASS)).length > 0
            },
            _isMasterDetailCell: function(element) {
                var $masterDetailCell = (0, _renderer.default)(element).closest("." + MASTER_DETAIL_CELL_CLASS);
                var $masterDetailGrid = $masterDetailCell.closest("." + this.getWidgetContainerClass()).parent();
                return $masterDetailCell.length && $masterDetailGrid.is(this.component.$element())
            },
            _processNextCellInMasterDetail: function($nextCell) {
                if (!this._isInsideEditForm($nextCell) && $nextCell) {
                    this._applyTabIndexToElement($nextCell)
                }
            },
            _handleTabKeyOnMasterDetailCell: function(target, direction) {
                if (this._isMasterDetailCell(target)) {
                    this._updateFocusedCellPosition((0, _renderer.default)(target), direction);
                    var $nextCell = this._getNextCell(direction, "row");
                    this._processNextCellInMasterDetail($nextCell);
                    return true
                }
                return false
            },
            _getElementType: function(target) {
                return (0, _renderer.default)(target).is("tr") ? "row" : "cell"
            },
            _isFastEditingStarted: function() {
                return this._isFastEditingAllowed() && this._fastEditingStarted
            },
            _getVisibleColumnCount: function() {
                return this._columnsController.getVisibleColumns(null, true).length
            },
            _isCellInRow: function(cellPosition, includeCommandCells) {
                var columnIndex = cellPosition.columnIndex;
                var visibleColumnsCount = this._getVisibleColumnCount();
                return includeCommandCells ? columnIndex >= 0 && columnIndex <= visibleColumnsCount - 1 : columnIndex > 0 && columnIndex < visibleColumnsCount - 1
            },
            _getCellElementFromTarget: function(target) {
                var elementType = this._getElementType(target);
                var $targetElement = (0, _renderer.default)(target);
                var $cell;
                if ("cell" === elementType) {
                    $cell = $targetElement.closest(".".concat(ROW_CLASS, " > td"))
                } else {
                    $cell = $targetElement.children().not("." + COMMAND_EXPAND_CLASS).first()
                }
                return $cell
            },
            _getRowsViewElement: function() {
                var rowsView = this.getView("rowsView");
                return rowsView && rowsView.element()
            },
            isKeyboardEnabled: function() {
                return this.option("keyboardNavigation.enabled")
            },
            _processCanceledEditCellPosition: function(rowIndex, columnIndex) {
                if (this._canceledCellPosition) {
                    var isCanceled = this._canceledCellPosition.rowIndex === rowIndex && this._canceledCellPosition.columnIndex === columnIndex;
                    this._canceledCellPosition = null;
                    return isCanceled
                }
            }
        });
        var _default = {
            defaultOptions: function() {
                return {
                    useLegacyKeyboardNavigation: false,
                    keyboardNavigation: {
                        enabled: true,
                        enterKeyAction: "startEdit",
                        enterKeyDirection: "none",
                        editOnKeyPress: false
                    }
                }
            },
            controllers: {
                keyboardNavigation: KeyboardNavigationController
            },
            extenders: {
                views: {
                    rowsView: {
                        _rowClick: function(e) {
                            var editRowIndex = this.getController("editing").getEditRowIndex();
                            var keyboardController = this.getController("keyboardNavigation");
                            if (editRowIndex === e.rowIndex) {
                                keyboardController.setCellFocusType()
                            }
                            var needTriggerPointerEventHandler = isMobile() && this.option("focusedRowEnabled");
                            if (needTriggerPointerEventHandler) {
                                this._triggerPointerDownEventHandler(e)
                            }
                            this.callBase.apply(this, arguments)
                        },
                        _triggerPointerDownEventHandler: function(e) {
                            var originalEvent = e.event.originalEvent;
                            if (originalEvent) {
                                var keyboardController = this.getController("keyboardNavigation");
                                var $cell = (0, _renderer.default)(originalEvent.target);
                                var columnIndex = this.getCellIndex($cell);
                                var column = this.getController("columns").getVisibleColumns()[columnIndex];
                                var row = this.getController("data").items()[e.rowIndex];
                                if (keyboardController._isAllowEditing(row, column)) {
                                    var eventArgs = (0, _index.createEvent)(originalEvent, {
                                        currentTarget: originalEvent.target
                                    });
                                    keyboardController._pointerEventHandler(eventArgs)
                                }
                            }
                        },
                        renderFocusState: function(preventScroll) {
                            var keyboardController = this.getController("keyboardNavigation");
                            var $rowsViewElement = this.element();
                            if ($rowsViewElement && !(0, _selectors.focused)($rowsViewElement)) {
                                $rowsViewElement.attr("tabindex", null)
                            }
                            var rowIndex = keyboardController.getVisibleRowIndex();
                            if (!(0, _type.isDefined)(rowIndex) || rowIndex < 0) {
                                rowIndex = 0
                            }
                            var cellElements = this.getCellElements(rowIndex);
                            if (keyboardController.isKeyboardEnabled() && cellElements.length) {
                                this.updateFocusElementTabIndex(cellElements, preventScroll)
                            }
                        },
                        updateFocusElementTabIndex: function(cellElements) {
                            var keyboardController = this.getController("keyboardNavigation");
                            var $row = cellElements.eq(0).parent();
                            if (isGroupRow($row)) {
                                keyboardController._applyTabIndexToElement($row)
                            } else {
                                var columnIndex = keyboardController.getColumnIndex();
                                if (!(0, _type.isDefined)(columnIndex) || columnIndex < 0) {
                                    columnIndex = 0
                                }
                                this._updateFocusedCellTabIndex(cellElements, columnIndex)
                            }
                        },
                        _updateFocusedCellTabIndex: function(cellElements, columnIndex) {
                            var keyboardController = this.getController("keyboardNavigation");
                            var cellElementsLength = cellElements ? cellElements.length : -1;
                            var updateCellTabIndex = function($cell) {
                                var isMasterDetailCell = keyboardController._isMasterDetailCell($cell);
                                var isValidCell = keyboardController._isCellValid($cell);
                                if (!isMasterDetailCell && isValidCell && isCellElement($cell)) {
                                    keyboardController._applyTabIndexToElement($cell);
                                    keyboardController.setCellFocusType();
                                    return true
                                }
                            };
                            var $cell = cellElements.filter("[aria-colindex='".concat(columnIndex + 1, "']"));
                            if ($cell.length) {
                                updateCellTabIndex($cell)
                            } else {
                                if (cellElementsLength <= columnIndex) {
                                    columnIndex = cellElementsLength - 1
                                }
                                for (var i = columnIndex; i < cellElementsLength; ++i) {
                                    if (updateCellTabIndex((0, _renderer.default)(cellElements[i]))) {
                                        break
                                    }
                                }
                            }
                        },
                        renderDelayedTemplates: function(change) {
                            this.callBase.apply(this, arguments);
                            this._renderFocusByChange(change)
                        },
                        _renderFocusByChange: function(change) {
                            if (!change || !change.repaintChangesOnly) {
                                var preventScroll = shouldPreventScroll(this);
                                this.renderFocusState(preventScroll)
                            }
                        },
                        _renderCore: function(change) {
                            this.callBase.apply(this, arguments);
                            this._renderFocusByChange(change)
                        },
                        _editCellPrepared: function($cell) {
                            var editorInstance = this._getEditorInstance($cell);
                            var keyboardController = this.getController("keyboardNavigation");
                            var isEditingNavigationMode = keyboardController && keyboardController._isFastEditingStarted();
                            if (editorInstance && isEditingNavigationMode) {
                                this._handleEditingNavigationMode(editorInstance)
                            }
                            this.callBase.apply(this, arguments)
                        },
                        _handleEditingNavigationMode: function(editorInstance) {
                            ["downArrow", "upArrow"].forEach(function(keyName) {
                                var originalKeyHandler = editorInstance._supportedKeys()[keyName];
                                editorInstance.registerKeyHandler(keyName, function(e) {
                                    var isDropDownOpened = "true" === editorInstance._input().attr("aria-expanded");
                                    if (isDropDownOpened) {
                                        return originalKeyHandler && originalKeyHandler.call(editorInstance, e)
                                    }
                                })
                            });
                            editorInstance.registerKeyHandler("leftArrow", _common.noop);
                            editorInstance.registerKeyHandler("rightArrow", _common.noop);
                            var isDateBoxWithMask = editorInstance.NAME === DATEBOX_WIDGET_NAME && editorInstance.option("useMaskBehavior");
                            if (isDateBoxWithMask) {
                                editorInstance.registerKeyHandler("enter", _common.noop)
                            }
                        },
                        _getEditorInstance: function($cell) {
                            var $editor = $cell.find(".dx-texteditor").eq(0);
                            return _uiGrid_core2.default.getWidgetInstance($editor)
                        }
                    }
                },
                controllers: {
                    editing: {
                        editCell: function(rowIndex, columnIndex) {
                            var keyboardController = this.getController("keyboardNavigation");
                            if (keyboardController._processCanceledEditCellPosition(rowIndex, columnIndex)) {
                                return false
                            }
                            var isCellEditing = this.callBase(rowIndex, columnIndex);
                            if (isCellEditing) {
                                keyboardController.setupFocusedView()
                            }
                            return isCellEditing
                        },
                        editRow: function(rowIndex) {
                            var keyboardController = this.getController("keyboardNavigation");
                            var visibleColumnIndex = keyboardController.getVisibleColumnIndex();
                            var column = this._columnsController.getVisibleColumns()[visibleColumnIndex];
                            if (column && column.type || this.option("editing.mode") === EDIT_MODE_FORM) {
                                keyboardController._resetFocusedCell()
                            }
                            this.callBase(rowIndex)
                        },
                        addRow: function(parentKey) {
                            var keyboardController = this.getController("keyboardNavigation");
                            keyboardController.setupFocusedView();
                            keyboardController.setCellFocusType();
                            return this.callBase.apply(this, arguments)
                        },
                        getFocusedCellInRow: function(rowIndex) {
                            var keyboardNavigationController = this.getController("keyboardNavigation");
                            var $cell = this.callBase(rowIndex);
                            if (keyboardNavigationController.isKeyboardEnabled() && keyboardNavigationController._focusedCellPosition.rowIndex === rowIndex) {
                                var $focusedCell = keyboardNavigationController._getFocusedCell();
                                if (isElementDefined($focusedCell) && !$focusedCell.hasClass(COMMAND_EDIT_CLASS)) {
                                    $cell = $focusedCell
                                }
                            }
                            return $cell
                        },
                        _processCanceledEditingCell: function() {
                            var _this8 = this;
                            this.closeEditCell().done(function() {
                                var keyboardNavigation = _this8.getController("keyboardNavigation");
                                keyboardNavigation._updateFocus()
                            })
                        },
                        init: function() {
                            this.callBase();
                            this._keyboardNavigationController = this.getController("keyboardNavigation")
                        },
                        closeEditCell: function() {
                            var keyboardNavigation = this._keyboardNavigationController;
                            keyboardNavigation._fastEditingStarted = false;
                            var result = this.callBase.apply(this, arguments);
                            keyboardNavigation._updateFocus();
                            return result
                        },
                        _delayedInputFocus: function() {
                            this._keyboardNavigationController._isNeedScroll = true;
                            this.callBase.apply(this, arguments)
                        },
                        _isEditingStart: function() {
                            var keyboardNavigation = this.getController("keyboardNavigation");
                            var cancel = this.callBase.apply(this, arguments);
                            if (cancel && !keyboardNavigation._isNeedFocus) {
                                var $cell = keyboardNavigation._getFocusedCell();
                                keyboardNavigation._focus($cell, true)
                            }
                            return cancel
                        }
                    },
                    data: {
                        _correctRowIndices: function(getRowIndexCorrection) {
                            var that = this;
                            var keyboardNavigationController = that.getController("keyboardNavigation");
                            var editorFactory = that.getController("editorFactory");
                            var focusedCellPosition = keyboardNavigationController._focusedCellPosition;
                            that.callBase.apply(that, arguments);
                            if (focusedCellPosition && focusedCellPosition.rowIndex >= 0) {
                                var focusedRowIndexCorrection = getRowIndexCorrection(focusedCellPosition.rowIndex);
                                if (focusedRowIndexCorrection) {
                                    focusedCellPosition.rowIndex += focusedRowIndexCorrection;
                                    editorFactory.refocus()
                                }
                            }
                        }
                    },
                    adaptiveColumns: {
                        _showHiddenCellsInView: function(_ref) {
                            var viewName = _ref.viewName,
                                $cells = _ref.$cells,
                                isCommandColumn = _ref.isCommandColumn;
                            this.callBase.apply(this, arguments);
                            viewName === COLUMN_HEADERS_VIEW && !isCommandColumn && $cells.each(function(_, cellElement) {
                                var $cell = (0, _renderer.default)(cellElement);
                                isCellInHeaderRow($cell) && $cell.attr("tabindex", 0)
                            })
                        },
                        _hideVisibleCellInView: function(_ref2) {
                            var viewName = _ref2.viewName,
                                $cell = _ref2.$cell,
                                isCommandColumn = _ref2.isCommandColumn;
                            this.callBase.apply(this, arguments);
                            if (viewName === COLUMN_HEADERS_VIEW && !isCommandColumn && isCellInHeaderRow($cell)) {
                                $cell.removeAttr("tabindex")
                            }
                        }
                    }
                }
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.column_fixing.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _wheel = __webpack_require__( /*! ../../events/core/wheel */ 148);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.utils */ 35));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));
        var _position = __webpack_require__( /*! ../../core/utils/position */ 22);
        var _translator = __webpack_require__( /*! ../../animation/translator */ 28);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var CONTENT_CLASS = "content";
        var CONTENT_FIXED_CLASS = "content-fixed";
        var MASTER_DETAIL_CELL_CLASS = "dx-master-detail-cell";
        var FIRST_CELL_CLASS = "dx-first-cell";
        var LAST_CELL_CLASS = "dx-last-cell";
        var HOVER_STATE_CLASS = "dx-state-hover";
        var FIXED_COL_CLASS = "dx-col-fixed";
        var FIXED_COLUMNS_CLASS = "dx-fixed-columns";
        var POINTER_EVENTS_NONE_CLASS = "dx-pointer-events-none";
        var COMMAND_TRANSPARENT = "transparent";
        var GROUP_ROW_CLASS = "dx-group-row";
        var getTransparentColumnIndex = function(fixedColumns) {
            var transparentColumnIndex = -1;
            (0, _iterator.each)(fixedColumns, function(index, column) {
                if (column.command === COMMAND_TRANSPARENT) {
                    transparentColumnIndex = index;
                    return false
                }
            });
            return transparentColumnIndex
        };
        var normalizeColumnWidths = function(fixedColumns, widths, fixedWidths) {
            var fixedColumnIndex = 0;
            if (fixedColumns && widths && fixedWidths) {
                for (var i = 0; i < fixedColumns.length; i++) {
                    if (fixedColumns[i].command === COMMAND_TRANSPARENT) {
                        fixedColumnIndex += fixedColumns[i].colspan
                    } else {
                        if (widths[fixedColumnIndex] < fixedWidths[i]) {
                            widths[fixedColumnIndex] = fixedWidths[i]
                        }
                        fixedColumnIndex++
                    }
                }
            }
            return widths
        };
        var baseFixedColumns = {
            init: function() {
                this.callBase();
                this._isFixedTableRendering = false;
                this._isFixedColumns = false
            },
            _createCol: function(column) {
                return this.callBase(column).toggleClass(FIXED_COL_CLASS, !!(this._isFixedTableRendering && (column.fixed || column.command && column.command !== COMMAND_TRANSPARENT)))
            },
            _correctColumnIndicesForFixedColumns: function(fixedColumns, change) {
                var transparentColumnIndex = getTransparentColumnIndex(fixedColumns);
                var transparentColspan = fixedColumns[transparentColumnIndex].colspan;
                var columnIndices = change && change.columnIndices;
                if (columnIndices) {
                    change.columnIndices = columnIndices.map(function(columnIndices) {
                        if (columnIndices) {
                            return columnIndices.map(function(columnIndex) {
                                if (columnIndex < transparentColumnIndex) {
                                    return columnIndex
                                } else {
                                    if (columnIndex >= transparentColumnIndex + transparentColspan) {
                                        return columnIndex - transparentColspan + 1
                                    }
                                }
                                return -1
                            }).filter(function(columnIndex) {
                                return columnIndex >= 0
                            })
                        }
                    })
                }
            },
            _renderTable: function(options) {
                var that = this;
                var $fixedTable;
                var fixedColumns = that.getFixedColumns();
                that._isFixedColumns = !!fixedColumns.length;
                var $table = that.callBase(options);
                if (that._isFixedColumns) {
                    that._isFixedTableRendering = true;
                    var change = options && options.change;
                    var columnIndices = change && change.columnIndices;
                    that._correctColumnIndicesForFixedColumns(fixedColumns, change);
                    $fixedTable = that._createTable(fixedColumns);
                    that._renderRows($fixedTable, (0, _extend.extend)({}, options, {
                        columns: fixedColumns
                    }));
                    that._updateContent($fixedTable, change);
                    if (columnIndices) {
                        change.columnIndices = columnIndices
                    }
                    that._isFixedTableRendering = false
                } else {
                    that._fixedTableElement && that._fixedTableElement.parent().remove();
                    that._fixedTableElement = null
                }
                return $table
            },
            _renderRow: function($table, options) {
                var fixedCorrection;
                var cells = options.row.cells;
                this.callBase.apply(this, arguments);
                if (this._isFixedTableRendering && cells && cells.length) {
                    fixedCorrection = 0;
                    var fixedCells = options.row.cells || [];
                    cells = cells.slice();
                    options.row.cells = cells;
                    for (var i = 0; i < fixedCells.length; i++) {
                        if (fixedCells[i].column && fixedCells[i].column.command === COMMAND_TRANSPARENT) {
                            fixedCorrection = (fixedCells[i].column.colspan || 1) - 1;
                            continue
                        }
                        cells[i + fixedCorrection] = fixedCells[i]
                    }
                }
            },
            _createCell: function(options) {
                var that = this;
                var column = options.column;
                var columnCommand = column && column.command;
                var rowType = options.rowType;
                var $cell = that.callBase.apply(that, arguments);
                var fixedColumns;
                var prevFixedColumn;
                var transparentColumnIndex;
                if (that._isFixedTableRendering || "filter" === rowType) {
                    fixedColumns = that.getFixedColumns();
                    transparentColumnIndex = getTransparentColumnIndex(fixedColumns);
                    prevFixedColumn = fixedColumns[transparentColumnIndex - 1]
                }
                if (that._isFixedTableRendering) {
                    if (columnCommand === COMMAND_TRANSPARENT) {
                        $cell.addClass(POINTER_EVENTS_NONE_CLASS).toggleClass(FIRST_CELL_CLASS, 0 === transparentColumnIndex || prevFixedColumn && "expand" === prevFixedColumn.command).toggleClass(LAST_CELL_CLASS, fixedColumns.length && transparentColumnIndex === fixedColumns.length - 1);
                        if ("freeSpace" !== rowType) {
                            _uiGrid_core.default.setEmptyText($cell)
                        }
                    }
                } else {
                    if ("filter" === rowType) {
                        $cell.toggleClass(FIRST_CELL_CLASS, options.columnIndex === transparentColumnIndex)
                    }
                }
                var isRowAltStyle = that.option("rowAlternationEnabled") && options.isAltRow;
                if (_browser.default.mozilla && options.column.fixed && "group" !== options.rowType && !isRowAltStyle) {
                    $cell.addClass(FIXED_COL_CLASS)
                }
                return $cell
            },
            _wrapTableInScrollContainer: function() {
                var $scrollContainer = this.callBase.apply(this, arguments);
                if (this._isFixedTableRendering) {
                    $scrollContainer.addClass(this.addWidgetPrefix(CONTENT_FIXED_CLASS))
                }
                return $scrollContainer
            },
            _renderCellContent: function($cell, options) {
                var that = this;
                var isEmptyCell;
                var column = options.column;
                var isFixedTableRendering = that._isFixedTableRendering;
                var isGroupCell = "group" === options.rowType && (0, _type.isDefined)(column.groupIndex);
                if (isFixedTableRendering && isGroupCell && !column.command && !column.groupCellTemplate) {
                    $cell.css("pointerEvents", "none")
                }
                if (!isFixedTableRendering && that._isFixedColumns) {
                    isEmptyCell = column.fixed || column.command && false !== column.fixed;
                    if (isGroupCell) {
                        isEmptyCell = false;
                        if (options.row.summaryCells && options.row.summaryCells.length) {
                            var columns = that._columnsController.getVisibleColumns();
                            var alignByFixedColumnCellCount = that._getAlignByColumnCellCount ? that._getAlignByColumnCellCount(column.colspan, {
                                columns: columns,
                                row: options.row,
                                isFixed: true
                            }) : 0;
                            if (alignByFixedColumnCellCount > 0) {
                                var transparentColumnIndex = getTransparentColumnIndex(that._columnsController.getFixedColumns());
                                isEmptyCell = columns.length - alignByFixedColumnCellCount < transparentColumnIndex
                            }
                        }
                    }
                    if (isEmptyCell) {
                        if (that.option("legacyRendering") || column.command && "buttons" !== column.type || "group" === options.rowType) {
                            $cell.html("&nbsp;").addClass(column.cssClass);
                            return
                        } else {
                            $cell.addClass("dx-hidden-cell")
                        }
                    }
                }
                if (column.command !== COMMAND_TRANSPARENT) {
                    that.callBase($cell, options)
                }
            },
            _getCellElementsCore: function(rowIndex) {
                var _this = this;
                var cellElements = this.callBase.apply(this, arguments);
                var isGroupRow = cellElements.parent().hasClass(GROUP_ROW_CLASS);
                var index = "columnHeadersView" === this.name ? rowIndex : void 0;
                if (this._fixedTableElement && cellElements) {
                    var fixedColumns = this.getFixedColumns(index);
                    var fixedCellElements = this._getRowElements(this._fixedTableElement).eq(rowIndex).children("td");
                    (0, _iterator.each)(fixedCellElements, function(columnIndex, cell) {
                        if (isGroupRow) {
                            if (cellElements[columnIndex] && "hidden" !== cell.style.visibility) {
                                cellElements[columnIndex] = cell
                            }
                        } else {
                            var fixedColumn = fixedColumns[columnIndex];
                            if (fixedColumn) {
                                if (fixedColumn.command === COMMAND_TRANSPARENT) {
                                    if (fixedCellElements.eq(columnIndex).hasClass(MASTER_DETAIL_CELL_CLASS)) {
                                        cellElements[columnIndex] = cell || cellElements[columnIndex]
                                    }
                                } else {
                                    var fixedColumnIndex = _this._columnsController.getVisibleIndexByColumn(fixedColumn, rowIndex);
                                    cellElements[fixedColumnIndex] = cell || cellElements[fixedColumnIndex]
                                }
                            }
                        }
                    })
                }
                return cellElements
            },
            getColumnWidths: function() {
                var that = this;
                var fixedWidths;
                var result = that.callBase();
                var fixedColumns = that.getFixedColumns();
                if (that._fixedTableElement && result.length) {
                    fixedWidths = that.callBase(that._fixedTableElement)
                }
                return normalizeColumnWidths(fixedColumns, result, fixedWidths)
            },
            getTableElement: function() {
                var tableElement = this._isFixedTableRendering ? this._fixedTableElement : this.callBase();
                return tableElement
            },
            setTableElement: function(tableElement) {
                if (this._isFixedTableRendering) {
                    this._fixedTableElement = tableElement.addClass(POINTER_EVENTS_NONE_CLASS)
                } else {
                    this.callBase(tableElement)
                }
            },
            getColumns: function(rowIndex, $tableElement) {
                $tableElement = $tableElement || this.getTableElement();
                if (this._isFixedTableRendering || $tableElement && $tableElement.closest("table").parent("." + this.addWidgetPrefix(CONTENT_FIXED_CLASS)).length) {
                    return this.getFixedColumns(rowIndex)
                }
                return this.callBase(rowIndex, $tableElement)
            },
            getRowIndex: function($row) {
                var $fixedTable = this._fixedTableElement;
                if ($fixedTable && $fixedTable.find($row).length) {
                    return this._getRowElements($fixedTable).index($row)
                }
                return this.callBase($row)
            },
            getTableElements: function() {
                var result = this.callBase.apply(this, arguments);
                if (this._fixedTableElement) {
                    result = (0, _renderer.default)([result.get(0), this._fixedTableElement.get(0)])
                }
                return result
            },
            getFixedColumns: function(rowIndex) {
                return this._columnsController.getFixedColumns(rowIndex)
            },
            getFixedColumnsOffset: function() {
                var offset = {
                    left: 0,
                    right: 0
                };
                var $transparentColumn;
                if (this._fixedTableElement) {
                    $transparentColumn = this.getTransparentColumnElement();
                    var positionTransparentColumn = $transparentColumn.position();
                    offset = {
                        left: positionTransparentColumn.left,
                        right: this.element().outerWidth(true) - ($transparentColumn.outerWidth(true) + positionTransparentColumn.left)
                    }
                }
                return offset
            },
            getTransparentColumnElement: function() {
                return this._fixedTableElement && this._fixedTableElement.find("." + POINTER_EVENTS_NONE_CLASS).first()
            },
            getFixedTableElement: function() {
                return this._fixedTableElement
            },
            isFixedColumns: function() {
                return this._isFixedColumns
            },
            _resizeCore: function() {
                this.callBase();
                this.synchronizeRows()
            },
            setColumnWidths: function(options) {
                var columns;
                var visibleColumns = this._columnsController.getVisibleColumns();
                var widths = options.widths;
                var isWidthsSynchronized = widths && widths.length && (0, _type.isDefined)(visibleColumns[0].visibleWidth);
                var optionNames = options.optionNames;
                var isColumnWidthChanged = optionNames && optionNames.width;
                var useVisibleColumns = false;
                this.callBase.apply(this, arguments);
                if (this._fixedTableElement) {
                    if (this.option("legacyRendering")) {
                        useVisibleColumns = widths && widths.length && !this.isScrollbarVisible(true)
                    } else {
                        var hasAutoWidth = widths && widths.some(function(width) {
                            return "auto" === width
                        });
                        useVisibleColumns = hasAutoWidth && (!isWidthsSynchronized || !this.isScrollbarVisible(true))
                    }
                    if (useVisibleColumns) {
                        columns = visibleColumns
                    }
                    this.callBase((0, _extend.extend)({}, options, {
                        $tableElement: this._fixedTableElement,
                        columns: columns,
                        fixed: true
                    }))
                }
                if (isWidthsSynchronized || isColumnWidthChanged && this.option("wordWrapEnabled")) {
                    this.synchronizeRows()
                }
            },
            _createColGroup: function(columns) {
                if (!this.option("legacyRendering") && this._isFixedTableRendering && !this.option("columnAutoWidth")) {
                    var visibleColumns = this._columnsController.getVisibleColumns();
                    var useVisibleColumns = visibleColumns.filter(function(column) {
                        return !column.width
                    }).length;
                    if (useVisibleColumns) {
                        columns = visibleColumns
                    }
                }
                return this.callBase(columns)
            },
            _getClientHeight: function(element) {
                var boundingClientRectElement = element.getBoundingClientRect && (0, _position.getBoundingRect)(element);
                return boundingClientRectElement && boundingClientRectElement.height ? boundingClientRectElement.height : element.clientHeight
            },
            synchronizeRows: function() {
                var that = this;
                var rowHeights = [];
                var fixedRowHeights = [];
                var rowIndex;
                var $rowElements;
                var $fixedRowElements;
                var $contentElement;
                if (that._isFixedColumns && that._tableElement && that._fixedTableElement) {
                    var heightTable = that._getClientHeight(that._tableElement.get(0));
                    var heightFixedTable = that._getClientHeight(that._fixedTableElement.get(0));
                    $rowElements = that._getRowElements(that._tableElement);
                    $fixedRowElements = that._getRowElements(that._fixedTableElement);
                    $contentElement = that._findContentElement();
                    if (heightTable !== heightFixedTable) {
                        $contentElement && $contentElement.css("height", heightTable);
                        $rowElements.css("height", "");
                        $fixedRowElements.css("height", "");
                        for (rowIndex = 0; rowIndex < $rowElements.length; rowIndex++) {
                            rowHeights.push(that._getClientHeight($rowElements.get(rowIndex)));
                            fixedRowHeights.push(that._getClientHeight($fixedRowElements.get(rowIndex)))
                        }
                        for (rowIndex = 0; rowIndex < $rowElements.length; rowIndex++) {
                            var rowHeight = rowHeights[rowIndex];
                            var fixedRowHeight = fixedRowHeights[rowIndex];
                            if (rowHeight > fixedRowHeight) {
                                $fixedRowElements.eq(rowIndex).css("height", rowHeight)
                            } else {
                                if (rowHeight < fixedRowHeight) {
                                    $rowElements.eq(rowIndex).css("height", fixedRowHeight)
                                }
                            }
                        }
                        $contentElement && $contentElement.css("height", "")
                    }
                }
            },
            setScrollerSpacing: function(width) {
                var rtlEnabled = this.option("rtlEnabled");
                this.callBase(width);
                this.element().children("." + this.addWidgetPrefix(CONTENT_FIXED_CLASS)).css({
                    paddingLeft: rtlEnabled ? width : "",
                    paddingRight: !rtlEnabled ? width : ""
                })
            }
        };
        var ColumnHeadersViewFixedColumnsExtender = (0, _extend.extend)({}, baseFixedColumns, {
            _getRowVisibleColumns: function(rowIndex) {
                if (this._isFixedTableRendering) {
                    return this.getFixedColumns(rowIndex)
                }
                return this.callBase(rowIndex)
            },
            getContextMenuItems: function(options) {
                var that = this;
                var column = options.column;
                var columnFixingOptions = that.option("columnFixing");
                var items = that.callBase(options);
                if (options.row && "header" === options.row.rowType) {
                    if (column && column.allowFixing) {
                        var onItemClick = function(params) {
                            switch (params.itemData.value) {
                                case "none":
                                    that._columnsController.columnOption(column.index, "fixed", false);
                                    break;
                                case "left":
                                    that._columnsController.columnOption(column.index, {
                                        fixed: true,
                                        fixedPosition: "left"
                                    });
                                    break;
                                case "right":
                                    that._columnsController.columnOption(column.index, {
                                        fixed: true,
                                        fixedPosition: "right"
                                    })
                            }
                        };
                        items = items || [];
                        items.push({
                            text: columnFixingOptions.texts.fix,
                            beginGroup: true,
                            items: [{
                                text: columnFixingOptions.texts.leftPosition,
                                value: "left",
                                disabled: column.fixed && (!column.fixedPosition || "left" === column.fixedPosition),
                                onItemClick: onItemClick
                            }, {
                                text: columnFixingOptions.texts.rightPosition,
                                value: "right",
                                disabled: column.fixed && "right" === column.fixedPosition,
                                onItemClick: onItemClick
                            }]
                        }, {
                            text: columnFixingOptions.texts.unfix,
                            value: "none",
                            disabled: !column.fixed,
                            onItemClick: onItemClick
                        })
                    }
                }
                return items
            },
            getFixedColumnElements: function(rowIndex) {
                var that = this;
                if ((0, _type.isDefined)(rowIndex)) {
                    return this._fixedTableElement && this._getRowElements(this._fixedTableElement).eq(rowIndex).children()
                }
                var columnElements = that.getColumnElements();
                var $transparentColumnElement = that.getTransparentColumnElement();
                if (columnElements && $transparentColumnElement && $transparentColumnElement.length) {
                    var transparentColumnIndex = getTransparentColumnIndex(that.getFixedColumns());
                    columnElements.splice(transparentColumnIndex, $transparentColumnElement.get(0).colSpan, $transparentColumnElement.get(0))
                }
                return columnElements
            },
            getColumnWidths: function() {
                var that = this;
                var fixedWidths;
                var result = that.callBase();
                var $fixedColumnElements = that.getFixedColumnElements();
                var fixedColumns = that.getFixedColumns();
                if (that._fixedTableElement) {
                    if ($fixedColumnElements && $fixedColumnElements.length) {
                        fixedWidths = that._getWidths($fixedColumnElements)
                    } else {
                        fixedWidths = that.callBase(that._fixedTableElement)
                    }
                }
                return normalizeColumnWidths(fixedColumns, result, fixedWidths)
            }
        });
        var RowsViewFixedColumnsExtender = (0, _extend.extend)({}, baseFixedColumns, {
            _detachHoverEvents: function() {
                this._fixedTableElement && _events_engine.default.off(this._fixedTableElement, "mouseover mouseout", ".dx-data-row");
                this._tableElement && _events_engine.default.off(this._tableElement, "mouseover mouseout", ".dx-data-row")
            },
            _attachHoverEvents: function() {
                var that = this;
                var attachHoverEvent = function($table) {
                    _events_engine.default.on($table, "mouseover mouseout", ".dx-data-row", that.createAction(function(args) {
                        var event = args.event;
                        var rowIndex = that.getRowIndex((0, _renderer.default)(event.target).closest(".dx-row"));
                        var isHover = "mouseover" === event.type;
                        if (rowIndex >= 0) {
                            that._tableElement && that._getRowElements(that._tableElement).eq(rowIndex).toggleClass(HOVER_STATE_CLASS, isHover);
                            that._fixedTableElement && that._getRowElements(that._fixedTableElement).eq(rowIndex).toggleClass(HOVER_STATE_CLASS, isHover)
                        }
                    }))
                };
                if (that._fixedTableElement && that._tableElement) {
                    attachHoverEvent(that._fixedTableElement);
                    attachHoverEvent(that._tableElement)
                }
            },
            _findContentElement: function() {
                var that = this;
                var $content;
                var scrollTop;
                var contentClass = that.addWidgetPrefix(CONTENT_CLASS);
                var element = that.element();
                var scrollDelay = _browser.default.mozilla ? 60 : 0;
                if (element && that._isFixedTableRendering) {
                    $content = element.children("." + contentClass);
                    var scrollable = that.getScrollable();
                    if (!$content.length && scrollable) {
                        $content = (0, _renderer.default)("<div>").addClass(contentClass);
                        _events_engine.default.on($content, "scroll", function(e) {
                            clearTimeout(that._fixedScrollTimeout);
                            that._fixedScrollTimeout = setTimeout(function() {
                                scrollTop = (0, _renderer.default)(e.target).scrollTop();
                                scrollable.scrollTo({
                                    y: scrollTop
                                })
                            }, scrollDelay)
                        });
                        _events_engine.default.on($content, _wheel.name, function(e) {
                            var $nearestScrollable = (0, _renderer.default)(e.target).closest(".dx-scrollable");
                            if (scrollable && scrollable.$element().is($nearestScrollable)) {
                                scrollTop = scrollable.scrollTop();
                                scrollable.scrollTo({
                                    y: scrollTop - e.delta
                                });
                                if (scrollable.scrollTop() > 0 && scrollable.scrollTop() + scrollable.clientHeight() < scrollable.scrollHeight() + that.getScrollbarWidth()) {
                                    return false
                                }
                            }
                        });
                        $content.appendTo(element)
                    }
                    return $content
                }
                return that.callBase()
            },
            _updateScrollable: function() {
                this.callBase();
                var scrollable = this.getScrollable();
                var scrollTop = scrollable && scrollable.scrollOffset().top;
                this._updateFixedTablePosition(scrollTop)
            },
            _renderContent: function(contentElement, tableElement) {
                if (this._isFixedTableRendering) {
                    return contentElement.empty().addClass(this.addWidgetPrefix(CONTENT_CLASS) + " " + this.addWidgetPrefix(CONTENT_FIXED_CLASS)).append(tableElement)
                }
                return this.callBase(contentElement, tableElement)
            },
            _getGroupCellOptions: function(options) {
                if (this._isFixedTableRendering) {
                    return this.callBase((0, _extend.extend)({}, options, {
                        columns: this._columnsController.getVisibleColumns()
                    }))
                }
                return this.callBase(options)
            },
            _renderGroupedCells: function($row, options) {
                return this.callBase($row, (0, _extend.extend)({}, options, {
                    columns: this._columnsController.getVisibleColumns()
                }))
            },
            _renderGroupSummaryCells: function($row, options) {
                if (this._isFixedTableRendering) {
                    this.callBase($row, (0, _extend.extend)({}, options, {
                        columns: this._columnsController.getVisibleColumns()
                    }))
                } else {
                    this.callBase($row, options)
                }
            },
            _hasAlignByColumnSummaryItems: function(columnIndex, options) {
                var result = this.callBase.apply(this, arguments);
                var column = options.columns[columnIndex];
                if (options.isFixed) {
                    return column.fixed && (result || "right" === column.fixedPosition)
                }
                return result && !column.fixed
            },
            _renderGroupSummaryCellsCore: function($groupCell, options, groupCellColSpan, alignByColumnCellCount) {
                var alignByFixedColumnCellCount;
                if (this._isFixedTableRendering) {
                    options.isFixed = true;
                    alignByFixedColumnCellCount = this._getAlignByColumnCellCount(groupCellColSpan, options);
                    options.isFixed = false;
                    var startColumnIndex = options.columns.length - alignByFixedColumnCellCount;
                    options = (0, _extend.extend)({}, options, {
                        columns: this.getFixedColumns()
                    });
                    var transparentColumnIndex = getTransparentColumnIndex(options.columns);
                    if (startColumnIndex < transparentColumnIndex) {
                        alignByFixedColumnCellCount -= options.columns[transparentColumnIndex].colspan - 1 || 0;
                        groupCellColSpan -= options.columns[transparentColumnIndex].colspan - 1 || 0
                    } else {
                        if (alignByColumnCellCount > 0) {
                            $groupCell.css("visibility", "hidden")
                        }
                    }
                    alignByColumnCellCount = alignByFixedColumnCellCount
                }
                this.callBase($groupCell, options, groupCellColSpan, alignByColumnCellCount)
            },
            _getSummaryCellIndex: function(columnIndex, columns) {
                if (this._isFixedTableRendering) {
                    var transparentColumnIndex = getTransparentColumnIndex(columns);
                    if (columnIndex > transparentColumnIndex) {
                        columnIndex += columns[transparentColumnIndex].colspan - 1
                    }
                    return columnIndex
                }
                return this.callBase.apply(this, arguments)
            },
            _renderCore: function(change) {
                this._detachHoverEvents();
                this.callBase(change);
                var isFixedColumns = this._isFixedColumns;
                this.element().toggleClass(FIXED_COLUMNS_CLASS, isFixedColumns);
                if (this.option("hoverStateEnabled") && isFixedColumns) {
                    this._attachHoverEvents()
                }
            },
            setRowsOpacity: function(columnIndex, value) {
                this.callBase(columnIndex, value);
                var $rows = this._getRowElements(this._fixedTableElement);
                this._setRowsOpacityCore($rows, this.getFixedColumns(), columnIndex, value)
            },
            optionChanged: function(args) {
                var that = this;
                that.callBase(args);
                if ("hoverStateEnabled" === args.name && that._isFixedColumns) {
                    args.value ? this._attachHoverEvents() : this._detachHoverEvents()
                }
            },
            getCellIndex: function($cell) {
                var $fixedTable = this._fixedTableElement;
                var cellIndex = 0;
                if ($fixedTable && $cell.is("td") && $cell.closest($fixedTable).length) {
                    var columns = this.getFixedColumns();
                    (0, _iterator.each)(columns, function(index, column) {
                        if (index === $cell[0].cellIndex) {
                            return false
                        }
                        if (column.colspan) {
                            cellIndex += column.colspan;
                            return
                        }
                        cellIndex++
                    });
                    return cellIndex
                }
                return this.callBase.apply(this, arguments)
            },
            _updateFixedTablePosition: function(scrollTop, needFocus) {
                if (this._fixedTableElement && this._tableElement) {
                    var $focusedElement;
                    var editorFactory = this.getController("editorFactory");
                    this._fixedTableElement.parent().scrollTop(scrollTop);
                    if (needFocus && editorFactory) {
                        $focusedElement = editorFactory.focus();
                        $focusedElement && editorFactory.focus($focusedElement)
                    }
                }
            },
            setScrollerSpacing: function(vWidth, hWidth) {
                var that = this;
                var styles = {
                    marginBottom: 0
                };
                var $fixedContent = that.element().children("." + this.addWidgetPrefix(CONTENT_FIXED_CLASS));
                if ($fixedContent.length && that._fixedTableElement) {
                    $fixedContent.css(styles);
                    that._fixedTableElement.css(styles);
                    styles[that.option("rtlEnabled") ? "marginLeft" : "marginRight"] = vWidth;
                    styles.marginBottom = hWidth;
                    var useNativeScrolling = that._scrollable && that._scrollable.option("useNative");
                    (useNativeScrolling ? $fixedContent : that._fixedTableElement).css(styles)
                }
            },
            _getElasticScrollTop: function(e) {
                var elasticScrollTop = 0;
                var scrollbarWidth = this.getScrollbarWidth(true);
                if (e.scrollOffset.top < 0) {
                    elasticScrollTop = -e.scrollOffset.top
                } else {
                    if (e.reachedBottom) {
                        var scrollableContent = this._findContentElement();
                        var scrollableContainer = e.component._container();
                        var maxScrollTop = Math.max(scrollableContent.height() + scrollbarWidth - scrollableContainer.height(), 0);
                        elasticScrollTop = maxScrollTop - e.scrollOffset.top
                    }
                }
                return elasticScrollTop
            },
            _applyElasticScrolling: function(e) {
                if (this._fixedTableElement) {
                    var elasticScrollTop = this._getElasticScrollTop(e);
                    if (0 !== Math.ceil(elasticScrollTop)) {
                        (0, _translator.move)(this._fixedTableElement, {
                            top: elasticScrollTop
                        })
                    } else {
                        this._fixedTableElement.css("transform", "")
                    }
                }
            },
            _handleScroll: function(e) {
                this._updateFixedTablePosition(e.scrollOffset.top, true);
                this._applyElasticScrolling(e);
                this.callBase(e)
            },
            _updateContentPosition: function(isRender) {
                this.callBase.apply(this, arguments);
                if (!isRender) {
                    this._updateFixedTablePosition(this._scrollTop)
                }
            },
            _afterRowPrepared: function(e) {
                if (this._isFixedTableRendering) {
                    return
                }
                this.callBase(e)
            },
            _scrollToElement: function($element) {
                this.callBase($element, this.getFixedColumnsOffset())
            },
            dispose: function() {
                this.callBase.apply(this, arguments);
                clearTimeout(this._fixedScrollTimeout)
            }
        });
        var FooterViewFixedColumnsExtender = baseFixedColumns;
        var _default = {
            defaultOptions: function() {
                return {
                    columnFixing: {
                        enabled: false,
                        texts: {
                            fix: _message.default.format("dxDataGrid-columnFixingFix"),
                            unfix: _message.default.format("dxDataGrid-columnFixingUnfix"),
                            leftPosition: _message.default.format("dxDataGrid-columnFixingLeftPosition"),
                            rightPosition: _message.default.format("dxDataGrid-columnFixingRightPosition")
                        }
                    }
                }
            },
            extenders: {
                views: {
                    columnHeadersView: ColumnHeadersViewFixedColumnsExtender,
                    rowsView: RowsViewFixedColumnsExtender,
                    footerView: FooterViewFixedColumnsExtender
                },
                controllers: function() {
                    var normalizeColumnIndicesByPoints = function(columns, fixedColumns, pointsByColumns) {
                        var transparentColumnIndex = getTransparentColumnIndex(fixedColumns);
                        var correctIndex = columns.length - fixedColumns.length;
                        (0, _iterator.each)(pointsByColumns, function(_, point) {
                            if (point.index > transparentColumnIndex) {
                                point.columnIndex += correctIndex;
                                point.index += correctIndex
                            }
                        });
                        return pointsByColumns
                    };
                    return {
                        draggingHeader: {
                            _generatePointsByColumns: function(options) {
                                var visibleColumns = options.columns;
                                var targetDraggingPanel = options.targetDraggingPanel;
                                if (targetDraggingPanel && "headers" === targetDraggingPanel.getName() && targetDraggingPanel.isFixedColumns()) {
                                    if (options.sourceColumn.fixed) {
                                        if (!options.rowIndex) {
                                            options.columnElements = targetDraggingPanel.getFixedColumnElements(0)
                                        }
                                        options.columns = targetDraggingPanel.getFixedColumns(options.rowIndex);
                                        var pointsByColumns = this.callBase(options);
                                        normalizeColumnIndicesByPoints(visibleColumns, options.columns, pointsByColumns);
                                        return pointsByColumns
                                    }
                                }
                                return this.callBase(options)
                            },
                            _pointCreated: function(point, columns, location, sourceColumn) {
                                var result = this.callBase.apply(this, arguments);
                                var targetColumn = columns[point.columnIndex];
                                var $transparentColumn = this._columnHeadersView.getTransparentColumnElement();
                                if (!result && "headers" === location && $transparentColumn && $transparentColumn.length) {
                                    var boundingRect = (0, _position.getBoundingRect)($transparentColumn.get(0));
                                    if (sourceColumn && sourceColumn.fixed) {
                                        return "right" === sourceColumn.fixedPosition ? point.x < boundingRect.right : point.x > boundingRect.left
                                    } else {
                                        if (targetColumn && targetColumn.fixed && "right" !== targetColumn.fixedPosition) {
                                            return true
                                        }
                                        return point.x < boundingRect.left || point.x > boundingRect.right
                                    }
                                }
                                return result
                            }
                        },
                        columnsResizer: {
                            _generatePointsByColumns: function() {
                                var that = this;
                                var columnsController = that._columnsController;
                                var columns = columnsController && that._columnsController.getVisibleColumns();
                                var fixedColumns = columnsController && that._columnsController.getFixedColumns();
                                var cells = that._columnHeadersView.getFixedColumnElements();
                                var pointsByFixedColumns = [];
                                that.callBase();
                                if (cells && cells.length > 0) {
                                    pointsByFixedColumns = _uiGrid_core.default.getPointsByColumns(cells, function(point) {
                                        return that._pointCreated(point, cells.length, fixedColumns)
                                    });
                                    that._pointsByFixedColumns = normalizeColumnIndicesByPoints(columns, fixedColumns, pointsByFixedColumns)
                                }
                            },
                            _pointCreated: function(point, cellsLength, columns) {
                                var isWidgetResizingMode = "widget" === this.option("columnResizingMode");
                                if (point.index > 0 && point.index < cellsLength) {
                                    var currentColumn = columns[point.columnIndex - 1] || {};
                                    var nextColumn = columns[point.columnIndex] || {};
                                    if (currentColumn.fixed || nextColumn.fixed) {
                                        point.columnIndex -= 1;
                                        return !((currentColumn.allowResizing || currentColumn.command === COMMAND_TRANSPARENT) && (isWidgetResizingMode || nextColumn.allowResizing || nextColumn.command === COMMAND_TRANSPARENT))
                                    }
                                }
                                return this.callBase.apply(this, arguments)
                            },
                            _getTargetPoint: function(pointsByColumns, currentX, deltaX) {
                                var $transparentColumn = this._columnHeadersView.getTransparentColumnElement();
                                if ($transparentColumn && $transparentColumn.length) {
                                    var boundingRect = (0, _position.getBoundingRect)($transparentColumn.get(0));
                                    if (currentX <= boundingRect.left || currentX >= boundingRect.right) {
                                        return this.callBase(this._pointsByFixedColumns, currentX, deltaX)
                                    }
                                }
                                return this.callBase(pointsByColumns, currentX, deltaX)
                            }
                        }
                    }
                }()
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.adaptivity.js ***!
      \**************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _click = __webpack_require__( /*! ../../events/click */ 21);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));
        var _guid = _interopRequireDefault(__webpack_require__( /*! ../../core/guid */ 36));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.modules */ 44));
        var _form = _interopRequireDefault(__webpack_require__( /*! ../form */ 138));
        var _uiGrid_core2 = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.utils */ 35));
        var _themes = __webpack_require__( /*! ../themes */ 34);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var COLUMN_HEADERS_VIEW = "columnHeadersView";
        var ROWS_VIEW = "rowsView";
        var FOOTER_VIEW = "footerView";
        var COLUMN_VIEWS = [COLUMN_HEADERS_VIEW, ROWS_VIEW, FOOTER_VIEW];
        var ADAPTIVE_NAMESPACE = "dxDataGridAdaptivity";
        var HIDDEN_COLUMNS_WIDTH = "adaptiveHidden";
        var ADAPTIVE_ROW_TYPE = "detailAdaptive";
        var FORM_ITEM_CONTENT_CLASS = "dx-field-item-content";
        var FORM_ITEM_MODIFIED = "dx-item-modified";
        var HIDDEN_COLUMN_CLASS = "hidden-column";
        var ADAPTIVE_COLUMN_BUTTON_CLASS = "adaptive-more";
        var ADAPTIVE_COLUMN_NAME_CLASS = "dx-command-adaptive";
        var COMMAND_ADAPTIVE_HIDDEN_CLASS = "dx-command-adaptive-hidden";
        var ADAPTIVE_DETAIL_ROW_CLASS = "dx-adaptive-detail-row";
        var ADAPTIVE_ITEM_TEXT_CLASS = "dx-adaptive-item-text";
        var MASTER_DETAIL_CELL_CLASS = "dx-master-detail-cell";
        var LAST_DATA_CELL_CLASS = "dx-last-data-cell";
        var ADAPTIVE_COLUMN_NAME = "adaptive";
        var EDIT_MODE_BATCH = "batch";
        var EDIT_MODE_ROW = "row";
        var EDIT_MODE_FORM = "form";
        var EDIT_MODE_POPUP = "popup";
        var REVERT_TOOLTIP_CLASS = "revert-tooltip";
        var GROUP_CELL_CLASS = "dx-group-cell";
        var GROUP_ROW_CLASS = "dx-group-row";
        var EXPAND_ARIA_NAME = "dxDataGrid-ariaAdaptiveExpand";
        var COLLAPSE_ARIA_NAME = "dxDataGrid-ariaAdaptiveCollapse";

        function getColumnId(that, column) {
            return that._columnsController.getColumnId(column)
        }

        function getDataCellElements($row) {
            return $row.find("td:not(.dx-datagrid-hidden-column):not([class*='dx-command-'])")
        }

        function adaptiveCellTemplate(container, options) {
            var $adaptiveColumnButton;
            var $container = (0, _renderer.default)(container);
            var adaptiveColumnsController = options.component.getController("adaptiveColumns");
            if ("data" === options.rowType) {
                $adaptiveColumnButton = (0, _renderer.default)("<span>").addClass(adaptiveColumnsController.addWidgetPrefix(ADAPTIVE_COLUMN_BUTTON_CLASS));
                _events_engine.default.on($adaptiveColumnButton, (0, _index.addNamespace)(_click.name, ADAPTIVE_NAMESPACE), adaptiveColumnsController.createAction(function() {
                    adaptiveColumnsController.toggleExpandAdaptiveDetailRow(options.key)
                }));
                $adaptiveColumnButton.appendTo($container)
            } else {
                _uiGrid_core2.default.setEmptyText($container)
            }
        }
        var AdaptiveColumnsController = _uiGrid_core.default.ViewController.inherit({
            _isRowEditMode: function() {
                var editMode = this._getEditMode();
                return editMode === EDIT_MODE_ROW
            },
            _isItemModified: function(item, cellOptions) {
                var columnIndex = this._columnsController.getVisibleIndex(item.column.index);
                var rowIndex = this._dataController.getRowIndexByKey(cellOptions.key);
                var row = this._dataController.items()[rowIndex + 1];
                return row && row.modifiedValues && (0, _type.isDefined)(row.modifiedValues[columnIndex])
            },
            _renderFormViewTemplate: function(item, cellOptions, $container) {
                var that = this;
                var column = item.column;
                var focusAction = that.createAction(function() {
                    _events_engine.default.trigger($container, _click.name)
                });
                var value = column.calculateCellValue(cellOptions.data);
                var displayValue = _uiGrid_core2.default.getDisplayValue(column, value, cellOptions.data, cellOptions.rowType);
                var text = _uiGrid_core2.default.formatValue(displayValue, column);
                var isCellOrBatchEditMode = this._editingController.isCellOrBatchEditMode();
                var rowsView = that._rowsView;
                if (column.allowEditing && that.getController("keyboardNavigation").isKeyboardEnabled()) {
                    $container.attr("tabIndex", that.option("tabIndex"));
                    if (isCellOrBatchEditMode) {
                        _events_engine.default.off($container, "focus", focusAction);
                        _events_engine.default.on($container, "focus", focusAction)
                    }
                }
                if (column.cellTemplate) {
                    var templateOptions = (0, _extend.extend)({}, cellOptions, {
                        value: value,
                        displayValue: displayValue,
                        text: text,
                        column: column
                    });
                    var isDomElement = !!$container.closest((0, _window.getWindow)().document).length;
                    rowsView.renderTemplate($container, column.cellTemplate, templateOptions, isDomElement).done(function() {
                        rowsView._cellPrepared($container, cellOptions)
                    })
                } else {
                    var container = $container.get(0);
                    if (column.encodeHtml) {
                        container.textContent = text
                    } else {
                        container.innerHTML = text
                    }
                    $container.addClass(ADAPTIVE_ITEM_TEXT_CLASS);
                    if (!(0, _type.isDefined)(text) || "" === text) {
                        $container.html("&nbsp;")
                    }
                    if (!that._isRowEditMode()) {
                        if (that._isItemModified(item, cellOptions)) {
                            $container.addClass(FORM_ITEM_MODIFIED)
                        }
                    }
                    rowsView._cellPrepared($container, cellOptions)
                }
            },
            _getTemplate: function(item, cellOptions) {
                var that = this;
                var column = item.column;
                var editingController = this.getController("editing");
                return function(options, container) {
                    var $container = (0, _renderer.default)(container);
                    var columnIndex = that._columnsController.getVisibleIndex(column.index);
                    var templateOptions = (0, _extend.extend)({}, cellOptions);
                    var renderFormTemplate = function() {
                        var isItemEdited = that._isItemEdited(item);
                        templateOptions.value = cellOptions.row.values[columnIndex];
                        if (isItemEdited || column.showEditorAlways) {
                            editingController.renderFormEditTemplate(templateOptions, item, options.component, $container, !isItemEdited)
                        } else {
                            templateOptions.column = column;
                            templateOptions.columnIndex = columnIndex;
                            that._renderFormViewTemplate(item, templateOptions, $container)
                        }
                    };
                    renderFormTemplate();
                    templateOptions.watch && templateOptions.watch(function() {
                        return {
                            isItemEdited: that._isItemEdited(item),
                            value: cellOptions.row.values[columnIndex]
                        }
                    }, function() {
                        $container.contents().remove();
                        $container.removeClass(ADAPTIVE_ITEM_TEXT_CLASS);
                        renderFormTemplate()
                    })
                }
            },
            _isVisibleColumnsValid: function(visibleColumns) {
                var getCommandColumnsCount = function() {
                    var result = 0;
                    for (var j = 0; j < visibleColumns.length; j++) {
                        var visibleColumn = visibleColumns[j];
                        if (visibleColumn.command) {
                            result++
                        }
                    }
                    return result
                };
                if (visibleColumns < 2) {
                    return false
                }
                if (visibleColumns.length - getCommandColumnsCount() <= 1) {
                    return false
                }
                return true
            },
            _calculatePercentWidths: function(widths, visibleColumns) {
                var that = this;
                var percentWidths = 0;
                visibleColumns.forEach(function(item, index) {
                    if (widths[index] !== HIDDEN_COLUMNS_WIDTH) {
                        percentWidths += that._getItemPercentWidth(item)
                    }
                });
                return percentWidths
            },
            _isPercentWidth: function(width) {
                return (0, _type.isString)(width) && "%" === width.slice(-1)
            },
            _isColumnHidden: function(column) {
                return this._hiddenColumns.filter(function(hiddenColumn) {
                    return hiddenColumn.index === column.index
                }).length > 0
            },
            _getAverageColumnsWidth: function(containerWidth, columns, columnsCanFit) {
                var that = this;
                var fixedColumnsWidth = 0;
                var columnsWithoutFixedWidthCount = 0;
                columns.forEach(function(column) {
                    if (!that._isColumnHidden(column)) {
                        var width = column.width;
                        if ((0, _type.isDefined)(width) && !isNaN(parseFloat(width))) {
                            fixedColumnsWidth += that._isPercentWidth(width) ? that._calculatePercentWidth({
                                visibleIndex: column.visibleIndex,
                                columnsCount: columns.length,
                                columnsCanFit: columnsCanFit,
                                bestFitWidth: column.bestFitWidth,
                                columnWidth: width,
                                containerWidth: containerWidth
                            }) : parseFloat(width)
                        } else {
                            columnsWithoutFixedWidthCount++
                        }
                    }
                });
                return (containerWidth - fixedColumnsWidth) / columnsWithoutFixedWidthCount
            },
            _calculateColumnWidth: function(column, containerWidth, contentColumns, columnsCanFit) {
                var columnId = getColumnId(this, column);
                var widthOption = this._columnsController.columnOption(columnId, "width");
                var bestFitWidth = this._columnsController.columnOption(columnId, "bestFitWidth");
                var columnsCount = contentColumns.length;
                var colWidth;
                if (widthOption && "auto" !== widthOption) {
                    if (this._isPercentWidth(widthOption)) {
                        colWidth = this._calculatePercentWidth({
                            visibleIndex: column.visibleIndex,
                            columnsCount: columnsCount,
                            columnsCanFit: columnsCanFit,
                            bestFitWidth: bestFitWidth,
                            columnWidth: widthOption,
                            containerWidth: containerWidth
                        })
                    } else {
                        return widthOption
                    }
                } else {
                    var columnAutoWidth = this.option("columnAutoWidth");
                    colWidth = columnAutoWidth || !!column.command ? bestFitWidth : this._getAverageColumnsWidth(containerWidth, contentColumns, columnsCanFit)
                }
                return colWidth
            },
            _calculatePercentWidth: function(options) {
                var columnFitted = options.visibleIndex < options.columnsCount - 1 && options.columnsCanFit;
                var partialWidth = options.containerWidth * parseFloat(options.columnWidth) / 100;
                var resultWidth = options.columnsCanFit && partialWidth < options.bestFitWidth ? options.bestFitWidth : partialWidth;
                return columnFitted ? options.containerWidth * parseFloat(options.columnWidth) / 100 : resultWidth
            },
            _getNotTruncatedColumnWidth: function(column, containerWidth, contentColumns, columnsCanFit) {
                var columnId = getColumnId(this, column);
                var widthOption = this._columnsController.columnOption(columnId, "width");
                var bestFitWidth = this._columnsController.columnOption(columnId, "bestFitWidth");
                if (widthOption && "auto" !== widthOption && !this._isPercentWidth(widthOption)) {
                    return parseFloat(widthOption)
                }
                var colWidth = this._calculateColumnWidth(column, containerWidth, contentColumns, columnsCanFit);
                return colWidth < bestFitWidth ? null : colWidth
            },
            _getItemPercentWidth: function(item) {
                var result = 0;
                if (item.width && this._isPercentWidth(item.width)) {
                    result = parseFloat(item.width)
                }
                return result
            },
            _getCommandColumnsWidth: function() {
                var that = this;
                var columns = that._columnsController.getVisibleColumns();
                var colWidth = 0;
                (0, _iterator.each)(columns, function(index, column) {
                    if (column.index < 0 || column.command) {
                        colWidth += that._columnsController.columnOption(getColumnId(that, column), "bestFitWidth") || 0
                    }
                });
                return colWidth
            },
            _isItemEdited: function(item) {
                if (this.isFormEditMode()) {
                    return false
                }
                if (this._isRowEditMode()) {
                    var editRowKey = this.option("editing.editRowKey");
                    if ((0, _common.equalByValue)(editRowKey, this._dataController.adaptiveExpandedKey())) {
                        return true
                    }
                } else {
                    var rowIndex = this._dataController.getRowIndexByKey(this._dataController.adaptiveExpandedKey()) + 1;
                    var columnIndex = this._columnsController.getVisibleIndex(item.column.index);
                    return this._editingController.isEditCell(rowIndex, columnIndex)
                }
            },
            _getFormItemsByHiddenColumns: function(hiddenColumns) {
                var items = [];
                (0, _iterator.each)(hiddenColumns, function(_, column) {
                    items.push({
                        column: column,
                        name: column.name,
                        dataField: column.dataField,
                        visibleIndex: column.visibleIndex
                    })
                });
                return items
            },
            _getAdaptiveColumnVisibleIndex: function(visibleColumns) {
                for (var i = 0; i < visibleColumns.length; i++) {
                    var column = visibleColumns[i];
                    if (column.command === ADAPTIVE_COLUMN_NAME) {
                        return i
                    }
                }
            },
            _hideAdaptiveColumn: function(resultWidths, visibleColumns) {
                var visibleIndex = this._getAdaptiveColumnVisibleIndex(visibleColumns);
                if ((0, _type.isDefined)(visibleIndex)) {
                    resultWidths[visibleIndex] = HIDDEN_COLUMNS_WIDTH;
                    this._hideVisibleColumn({
                        isCommandColumn: true,
                        visibleIndex: visibleIndex
                    })
                }
            },
            _showHiddenCellsInView: function(_ref) {
                var $cells = _ref.$cells,
                    isCommandColumn = _ref.isCommandColumn;
                var cssClassNameToRemove = isCommandColumn ? COMMAND_ADAPTIVE_HIDDEN_CLASS : this.addWidgetPrefix(HIDDEN_COLUMN_CLASS);
                $cells.removeClass(cssClassNameToRemove)
            },
            _showHiddenColumns: function() {
                for (var i = 0; i < COLUMN_VIEWS.length; i++) {
                    var view = this.getView(COLUMN_VIEWS[i]);
                    if (view && view.isVisible() && view.element()) {
                        var viewName = view.name;
                        var $hiddenCommandCells = view.element().find("." + COMMAND_ADAPTIVE_HIDDEN_CLASS);
                        this._showHiddenCellsInView({
                            viewName: viewName,
                            $cells: $hiddenCommandCells,
                            isCommandColumn: true
                        });
                        var $hiddenCells = view.element().find("." + this.addWidgetPrefix(HIDDEN_COLUMN_CLASS));
                        this._showHiddenCellsInView({
                            viewName: viewName,
                            $cells: $hiddenCells
                        })
                    }
                }
            },
            _isCellValid: function($cell) {
                return $cell && $cell.length && !$cell.hasClass(MASTER_DETAIL_CELL_CLASS) && !$cell.hasClass(GROUP_CELL_CLASS)
            },
            _hideVisibleColumn: function(_ref2) {
                var isCommandColumn = _ref2.isCommandColumn,
                    visibleIndex = _ref2.visibleIndex;
                var that = this;
                COLUMN_VIEWS.forEach(function(viewName) {
                    var view = that.getView(viewName);
                    view && that._hideVisibleColumnInView({
                        view: view,
                        isCommandColumn: isCommandColumn,
                        visibleIndex: visibleIndex
                    })
                })
            },
            _hideVisibleColumnInView: function(_ref3) {
                var view = _ref3.view,
                    isCommandColumn = _ref3.isCommandColumn,
                    visibleIndex = _ref3.visibleIndex;
                var viewName = view.name;
                var $cellElement;
                var column = this._columnsController.getVisibleColumns()[visibleIndex];
                var editFormRowIndex = this._editingController && this._editingController.getEditFormRowIndex();
                if (view && view.isVisible() && column) {
                    var rowsCount = view.getRowsCount();
                    var $rowElements = view._getRowElements();
                    for (var rowIndex = 0; rowIndex < rowsCount; rowIndex++) {
                        var cancelClassAdding = rowIndex === editFormRowIndex && viewName === ROWS_VIEW && "popup" !== this.option("editing.mode");
                        if (!cancelClassAdding) {
                            var currentVisibleIndex = viewName === COLUMN_HEADERS_VIEW ? this._columnsController.getVisibleIndex(column.index, rowIndex) : visibleIndex;
                            if (currentVisibleIndex >= 0) {
                                var $rowElement = $rowElements.eq(rowIndex);
                                $cellElement = this._findCellElementInRow($rowElement, currentVisibleIndex);
                                this._isCellValid($cellElement) && this._hideVisibleCellInView({
                                    viewName: viewName,
                                    isCommandColumn: isCommandColumn,
                                    $cell: $cellElement
                                })
                            }
                        }
                    }
                }
            },
            _findCellElementInRow: function($rowElement, visibleColumnIndex) {
                var $rowCells = $rowElement.children();
                var visibleIndex = visibleColumnIndex;
                var cellIsInsideGroup = false;
                if ($rowElement.hasClass(GROUP_ROW_CLASS)) {
                    var $groupCell = $rowElement.find(".".concat(GROUP_CELL_CLASS));
                    var colSpan = $groupCell.attr("colspan");
                    if ($groupCell.length && (0, _type.isDefined)(colSpan)) {
                        var groupCellLength = parseInt(colSpan);
                        var endGroupIndex = $groupCell.index() + groupCellLength - 1;
                        if (visibleColumnIndex > endGroupIndex) {
                            visibleIndex = visibleColumnIndex - groupCellLength + 1
                        } else {
                            cellIsInsideGroup = true
                        }
                    }
                }
                var $cellElement = !cellIsInsideGroup ? $rowCells.eq(visibleIndex) : void 0;
                return $cellElement
            },
            _hideVisibleCellInView: function(_ref4) {
                var $cell = _ref4.$cell,
                    isCommandColumn = _ref4.isCommandColumn;
                var cssClassNameToAdd = isCommandColumn ? COMMAND_ADAPTIVE_HIDDEN_CLASS : this.addWidgetPrefix(HIDDEN_COLUMN_CLASS);
                $cell.addClass(cssClassNameToAdd)
            },
            _getEditMode: function() {
                return this._editingController.getEditMode()
            },
            isFormEditMode: function() {
                var editMode = this._getEditMode();
                return editMode === EDIT_MODE_FORM || editMode === EDIT_MODE_POPUP
            },
            hideRedundantColumns: function(resultWidths, visibleColumns, hiddenQueue) {
                var that = this;
                this._hiddenColumns = [];
                if (that._isVisibleColumnsValid(visibleColumns) && hiddenQueue.length) {
                    var totalWidth = 0;
                    var $rootElement = that.component.$element();
                    var rootElementWidth = $rootElement.width() - that._getCommandColumnsWidth();
                    var getVisibleContentColumns = function() {
                        var _this = this;
                        return visibleColumns.filter(function(item) {
                            return !item.command && 0 === _this._hiddenColumns.filter(function(i) {
                                return i.index === item.index
                            }).length
                        })
                    }.bind(this);
                    var visibleContentColumns = getVisibleContentColumns();
                    var contentColumnsCount = visibleContentColumns.length;
                    var i;
                    var hasHiddenColumns;
                    var needHideColumn;
                    do {
                        needHideColumn = false;
                        totalWidth = 0;
                        var percentWidths = that._calculatePercentWidths(resultWidths, visibleColumns);
                        var columnsCanFit = percentWidths < 100 && 0 !== percentWidths;
                        for (i = 0; i < visibleColumns.length; i++) {
                            var visibleColumn = visibleColumns[i];
                            var columnWidth = that._getNotTruncatedColumnWidth(visibleColumn, rootElementWidth, visibleContentColumns, columnsCanFit);
                            var columnId = getColumnId(that, visibleColumn);
                            var widthOption = that._columnsController.columnOption(columnId, "width");
                            var minWidth = that._columnsController.columnOption(columnId, "minWidth");
                            var columnBestFitWidth = that._columnsController.columnOption(columnId, "bestFitWidth");
                            if (resultWidths[i] === HIDDEN_COLUMNS_WIDTH) {
                                hasHiddenColumns = true;
                                continue
                            }
                            if (!columnWidth && !visibleColumn.command && !visibleColumn.fixed) {
                                needHideColumn = true;
                                break
                            }
                            if (!widthOption || "auto" === widthOption) {
                                columnWidth = Math.max(columnBestFitWidth || 0, minWidth || 0)
                            }
                            if (visibleColumn.command !== ADAPTIVE_COLUMN_NAME || hasHiddenColumns) {
                                totalWidth += columnWidth
                            }
                        }
                        needHideColumn = needHideColumn || totalWidth > $rootElement.width();
                        if (needHideColumn) {
                            var column = hiddenQueue.pop();
                            var visibleIndex = that._columnsController.getVisibleIndex(column.index);
                            rootElementWidth += that._calculateColumnWidth(column, rootElementWidth, visibleContentColumns, columnsCanFit);
                            that._hideVisibleColumn({
                                visibleIndex: visibleIndex
                            });
                            resultWidths[visibleIndex] = HIDDEN_COLUMNS_WIDTH;
                            this._hiddenColumns.push(column);
                            visibleContentColumns = getVisibleContentColumns()
                        }
                    } while (needHideColumn && visibleContentColumns.length > 1 && hiddenQueue.length);
                    if (contentColumnsCount === visibleContentColumns.length) {
                        that._hideAdaptiveColumn(resultWidths, visibleColumns)
                    }
                } else {
                    that._hideAdaptiveColumn(resultWidths, visibleColumns)
                }
            },
            getItemContentByColumnIndex: function(visibleColumnIndex) {
                var $itemContent;
                for (var i = 0; i < this._$itemContents.length; i++) {
                    $itemContent = this._$itemContents.eq(i);
                    var item = $itemContent.data("dx-form-item");
                    if (item && item.column && this._columnsController.getVisibleIndex(item.column.index) === visibleColumnIndex) {
                        return $itemContent
                    }
                }
            },
            toggleExpandAdaptiveDetailRow: function(key, alwaysExpanded) {
                if (!(this.isFormEditMode() && this._editingController.isEditing())) {
                    this.getController("data").toggleExpandAdaptiveDetailRow(key, alwaysExpanded)
                }
            },
            createFormByHiddenColumns: function(container, options) {
                var that = this;
                var $container = (0, _renderer.default)(container);
                var userFormOptions = {
                    items: that._getFormItemsByHiddenColumns(that._hiddenColumns),
                    formID: "dx-" + new _guid.default
                };
                var defaultFormOptions = (0, _themes.isMaterial)() ? {
                    colCount: 2
                } : {};
                this.executeAction("onAdaptiveDetailRowPreparing", {
                    formOptions: userFormOptions
                });
                that._$itemContents = null;
                that._form = that._createComponent((0, _renderer.default)("<div>").appendTo($container), _form.default, (0, _extend.extend)(defaultFormOptions, userFormOptions, {
                    customizeItem: function(item) {
                        var column = item.column || that._columnsController.columnOption(item.name || item.dataField);
                        if (column) {
                            item.label = item.label || {};
                            item.label.text = item.label.text || column.caption;
                            item.column = column;
                            item.template = that._getTemplate(item, options, that.updateForm.bind(that))
                        }
                        userFormOptions.customizeItem && userFormOptions.customizeItem.call(this, item)
                    },
                    onContentReady: function(e) {
                        userFormOptions.onContentReady && userFormOptions.onContentReady.call(this, e);
                        that._$itemContents = $container.find("." + FORM_ITEM_CONTENT_CLASS)
                    }
                }))
            },
            hasAdaptiveDetailRowExpanded: function() {
                return (0, _type.isDefined)(this._dataController.adaptiveExpandedKey())
            },
            updateForm: function(hiddenColumns) {
                if (this.hasAdaptiveDetailRowExpanded()) {
                    if (this._form && (0, _type.isDefined)(this._form._contentReadyAction)) {
                        if (hiddenColumns && hiddenColumns.length) {
                            this._form.option("items", this._getFormItemsByHiddenColumns(hiddenColumns))
                        } else {
                            this._form.repaint()
                        }
                    }
                }
            },
            updateHidingQueue: function(columns) {
                var that = this;
                var hideableColumns = columns.filter(function(column) {
                    return column.visible && !column.type && !column.fixed && !((0, _type.isDefined)(column.groupIndex) && column.groupIndex >= 0)
                });
                var columnsHasHidingPriority;
                var i;
                that._hidingColumnsQueue = [];
                if (that.option("allowColumnResizing") && "widget" === that.option("columnResizingMode")) {
                    return that._hidingColumnsQueue
                }
                for (i = 0; i < hideableColumns.length; i++) {
                    if ((0, _type.isDefined)(hideableColumns[i].hidingPriority) && hideableColumns[i].hidingPriority >= 0) {
                        columnsHasHidingPriority = true;
                        that._hidingColumnsQueue[hideableColumns[i].hidingPriority] = hideableColumns[i]
                    }
                }
                if (columnsHasHidingPriority) {
                    that._hidingColumnsQueue.reverse()
                } else {
                    if (that.option("columnHidingEnabled")) {
                        for (i = 0; i < hideableColumns.length; i++) {
                            var visibleIndex = that._columnsController.getVisibleIndex(hideableColumns[i].index);
                            that._hidingColumnsQueue[visibleIndex] = hideableColumns[i]
                        }
                    }
                }
                that._hidingColumnsQueue = that._hidingColumnsQueue.filter(Object);
                return that._hidingColumnsQueue
            },
            getHiddenColumns: function() {
                return this._hiddenColumns
            },
            hasHiddenColumns: function() {
                return this._hiddenColumns.length > 0
            },
            getHidingColumnsQueue: function() {
                return this._hidingColumnsQueue
            },
            init: function() {
                var that = this;
                that._columnsController = that.getController("columns");
                that._dataController = that.getController("data");
                that._rowsView = that.getView("rowsView");
                that._columnsController.addCommandColumn({
                    type: ADAPTIVE_COLUMN_NAME,
                    command: ADAPTIVE_COLUMN_NAME,
                    visible: true,
                    adaptiveHidden: true,
                    cssClass: ADAPTIVE_COLUMN_NAME_CLASS,
                    alignment: "center",
                    width: "auto",
                    cellTemplate: adaptiveCellTemplate,
                    fixedPosition: "right"
                });
                that._columnsController.columnsChanged.add(function() {
                    var isAdaptiveVisible = !!that.updateHidingQueue(that._columnsController.getColumns()).length;
                    that._columnsController.columnOption("command:adaptive", "adaptiveHidden", !isAdaptiveVisible, true)
                });
                that._editingController = that.getController("editing");
                that._hidingColumnsQueue = [];
                that._hiddenColumns = [];
                that.createAction("onAdaptiveDetailRowPreparing");
                that.callBase()
            },
            optionChanged: function(args) {
                if ("columnHidingEnabled" === args.name) {
                    this._columnsController.columnOption("command:adaptive", "adaptiveHidden", !args.value)
                }
                this.callBase(args)
            },
            publicMethods: function() {
                return ["isAdaptiveDetailRowExpanded", "expandAdaptiveDetailRow", "collapseAdaptiveDetailRow"]
            },
            isAdaptiveDetailRowExpanded: function(key) {
                return this._dataController.adaptiveExpandedKey() && (0, _common.equalByValue)(this._dataController.adaptiveExpandedKey(), key)
            },
            expandAdaptiveDetailRow: function(key) {
                if (!this.hasAdaptiveDetailRowExpanded()) {
                    this.toggleExpandAdaptiveDetailRow(key)
                }
            },
            collapseAdaptiveDetailRow: function() {
                if (this.hasAdaptiveDetailRowExpanded()) {
                    this.toggleExpandAdaptiveDetailRow()
                }
            },
            updateCommandAdaptiveAriaLabel: function(key, label) {
                var rowIndex = this._dataController.getRowIndexByKey(key);
                if (rowIndex === -1) {
                    return
                }
                var $row = (0, _renderer.default)(this.component.getRowElement(rowIndex));
                this.setCommandAdaptiveAriaLabel($row, label)
            },
            setCommandAdaptiveAriaLabel: function($row, labelName) {
                var $adaptiveCommand = $row.find(".dx-command-adaptive");
                $adaptiveCommand.attr("aria-label", _message.default.format(labelName))
            }
        });
        var _default = {
            defaultOptions: function() {
                return {
                    columnHidingEnabled: false,
                    onAdaptiveDetailRowPreparing: null
                }
            },
            controllers: {
                adaptiveColumns: AdaptiveColumnsController
            },
            extenders: {
                views: {
                    rowsView: {
                        _getCellTemplate: function(options) {
                            var that = this;
                            var column = options.column;
                            if (options.rowType === ADAPTIVE_ROW_TYPE && "detail" === column.command) {
                                return function(container, options) {
                                    that._adaptiveColumnsController.createFormByHiddenColumns((0, _renderer.default)(container), options)
                                }
                            }
                            return that.callBase(options)
                        },
                        _createRow: function(row) {
                            var $row = this.callBase(row);
                            if (row && row.rowType === ADAPTIVE_ROW_TYPE && row.key === this._dataController.adaptiveExpandedKey()) {
                                $row.addClass(ADAPTIVE_DETAIL_ROW_CLASS)
                            }
                            return $row
                        },
                        _renderCells: function($row, options) {
                            this.callBase($row, options);
                            var adaptiveColumnsController = this._adaptiveColumnsController;
                            var hidingColumnsQueueLength = adaptiveColumnsController.getHidingColumnsQueue().length;
                            var hiddenColumnsLength = adaptiveColumnsController.getHiddenColumns().length;
                            if (hidingColumnsQueueLength && !hiddenColumnsLength) {
                                getDataCellElements($row).last().addClass(LAST_DATA_CELL_CLASS)
                            }
                            if ("data" === options.row.rowType) {
                                adaptiveColumnsController.setCommandAdaptiveAriaLabel($row, EXPAND_ARIA_NAME)
                            }
                        },
                        _getColumnIndexByElementCore: function($element) {
                            var $itemContent = $element.closest("." + FORM_ITEM_CONTENT_CLASS);
                            if ($itemContent.length && $itemContent.closest(this.component.$element()).length) {
                                var formItem = $itemContent.length ? $itemContent.first().data("dx-form-item") : null;
                                return formItem && formItem.column && this._columnsController.getVisibleIndex(formItem.column.index)
                            } else {
                                return this.callBase($element)
                            }
                        },
                        _cellPrepared: function($cell, options) {
                            this.callBase.apply(this, arguments);
                            if (options.row.rowType !== ADAPTIVE_ROW_TYPE && options.column.visibleWidth === HIDDEN_COLUMNS_WIDTH) {
                                $cell.addClass(this.addWidgetPrefix(HIDDEN_COLUMN_CLASS))
                            }
                        },
                        _getCellElement: function(rowIndex, columnIdentifier) {
                            var item = this._dataController.items()[rowIndex];
                            if (item && item.rowType === ADAPTIVE_ROW_TYPE) {
                                return this._adaptiveColumnsController.getItemContentByColumnIndex(columnIdentifier)
                            } else {
                                return this.callBase.apply(this, arguments)
                            }
                        },
                        getContextMenuItems: function(options) {
                            if (options.row && "detailAdaptive" === options.row.rowType) {
                                var view = this.component.getView("columnHeadersView");
                                var formItem = (0, _renderer.default)(options.targetElement).closest(".dx-field-item-label").next().data("dx-form-item");
                                options.column = formItem ? formItem.column : options.column;
                                return view.getContextMenuItems && view.getContextMenuItems(options)
                            }
                            return this.callBase && this.callBase(options)
                        },
                        isClickableElement: function($target) {
                            var isClickable = this.callBase ? this.callBase($target) : false;
                            return isClickable || !!$target.closest("." + ADAPTIVE_COLUMN_NAME_CLASS).length
                        },
                        init: function() {
                            this.callBase();
                            this._adaptiveColumnsController = this.getController("adaptiveColumns")
                        }
                    }
                },
                controllers: {
                    "export": {
                        _updateColumnWidth: function(column, width) {
                            this.callBase(column, column.visibleWidth === HIDDEN_COLUMNS_WIDTH ? column.bestFitWidth : width)
                        }
                    },
                    columnsResizer: {
                        _pointCreated: function(point, cellsLength, columns) {
                            var result = this.callBase(point, cellsLength, columns);
                            var currentColumn = columns[point.columnIndex] || {};
                            var nextColumnIndex = this._getNextColumnIndex(point.columnIndex);
                            var nextColumn = columns[nextColumnIndex] || {};
                            var hasHiddenColumnsOnly = nextColumnIndex !== point.columnIndex + 1 && nextColumn.command;
                            var hasAdaptiveHiddenWidth = currentColumn.visibleWidth === HIDDEN_COLUMNS_WIDTH || hasHiddenColumnsOnly;
                            return result || hasAdaptiveHiddenWidth
                        },
                        _getNextColumnIndex: function(currentColumnIndex) {
                            var visibleColumns = this._columnsController.getVisibleColumns();
                            var index = this.callBase(currentColumnIndex);
                            while (visibleColumns[index] && visibleColumns[index].visibleWidth === HIDDEN_COLUMNS_WIDTH) {
                                index++
                            }
                            return index
                        }
                    },
                    draggingHeader: {
                        _pointCreated: function(point, columns, location, sourceColumn) {
                            var result = this.callBase(point, columns, location, sourceColumn);
                            var column = columns[point.columnIndex - 1] || {};
                            var hasAdaptiveHiddenWidth = column.visibleWidth === HIDDEN_COLUMNS_WIDTH;
                            return result || hasAdaptiveHiddenWidth
                        }
                    },
                    editing: {
                        _isRowEditMode: function() {
                            return this.getEditMode() === EDIT_MODE_ROW
                        },
                        _getFormEditItemTemplate: function(cellOptions, column) {
                            if (this.getEditMode() !== EDIT_MODE_ROW && "detailAdaptive" === cellOptions.rowType) {
                                cellOptions.columnIndex = this._columnsController.getVisibleIndex(column.index);
                                return this.getColumnTemplate(cellOptions)
                            }
                            return this.callBase(cellOptions, column)
                        },
                        _closeEditItem: function($targetElement) {
                            var $itemContents = $targetElement.closest("." + FORM_ITEM_CONTENT_CLASS);
                            var rowIndex = this._dataController.getRowIndexByKey(this._dataController.adaptiveExpandedKey()) + 1;
                            var formItem = $itemContents.length ? $itemContents.first().data("dx-form-item") : null;
                            var columnIndex = formItem && formItem.column && this._columnsController.getVisibleIndex(formItem.column.index);
                            if (!this.isEditCell(rowIndex, columnIndex)) {
                                this.callBase($targetElement)
                            }
                        },
                        _beforeUpdateItems: function(rowIndices, rowIndex) {
                            if (!this._adaptiveController.isFormEditMode() && this._adaptiveController.hasHiddenColumns()) {
                                var items = this._dataController.items();
                                var item = items[rowIndex];
                                var oldExpandRowIndex = _uiGrid_core2.default.getIndexByKey(this._dataController.adaptiveExpandedKey(), items);
                                this._isForceRowAdaptiveExpand = !this._adaptiveController.hasAdaptiveDetailRowExpanded();
                                if (oldExpandRowIndex >= 0) {
                                    rowIndices.push(oldExpandRowIndex + 1)
                                }
                                rowIndices.push(rowIndex + 1);
                                this._dataController.adaptiveExpandedKey(item.key)
                            }
                        },
                        _afterInsertRow: function(options) {
                            this.callBase(options);
                            if (this._adaptiveController.hasHiddenColumns()) {
                                this._adaptiveController.toggleExpandAdaptiveDetailRow(options.key, this.isRowEditMode());
                                this._isForceRowAdaptiveExpand = true
                            }
                        },
                        _collapseAdaptiveDetailRow: function() {
                            if (this._isRowEditMode() && this._isForceRowAdaptiveExpand) {
                                this._adaptiveController.collapseAdaptiveDetailRow();
                                this._isForceRowAdaptiveExpand = false
                            }
                        },
                        _cancelEditAdaptiveDetailRow: function() {
                            if (this._adaptiveController.hasHiddenColumns()) {
                                this._collapseAdaptiveDetailRow()
                            }
                        },
                        _afterSaveEditData: function() {
                            var _this2 = this;
                            this.callBase.apply(this, arguments);
                            var deferred = new _deferred.Deferred;
                            if (this._isRowEditMode() && this._adaptiveController.hasHiddenColumns()) {
                                (0, _deferred.when)(this.getController("validating").validate(true)).done(function(isValid) {
                                    if (isValid) {
                                        _this2._cancelEditAdaptiveDetailRow()
                                    }
                                    deferred.resolve()
                                })
                            } else {
                                deferred.resolve()
                            }
                            return deferred.promise()
                        },
                        _beforeCancelEditData: function() {
                            this.callBase();
                            this._cancelEditAdaptiveDetailRow()
                        },
                        _getRowIndicesForCascadeUpdating: function(row) {
                            var rowIndices = this.callBase.apply(this, arguments);
                            if (this._adaptiveController.isAdaptiveDetailRowExpanded(row.key)) {
                                rowIndices.push(row.rowType === ADAPTIVE_ROW_TYPE ? row.rowIndex - 1 : row.rowIndex + 1)
                            }
                            return rowIndices
                        },
                        _beforeCloseEditCellInBatchMode: function(rowIndices) {
                            var expandedKey = this._dataController._adaptiveExpandedKey;
                            if (expandedKey) {
                                var rowIndex = _uiGrid_core2.default.getIndexByKey(expandedKey, this._dataController.items());
                                if (rowIndex > -1) {
                                    rowIndices.unshift(rowIndex)
                                }
                            }
                        },
                        editRow: function(rowIndex) {
                            if (this._adaptiveController.isFormEditMode()) {
                                this._adaptiveController.collapseAdaptiveDetailRow()
                            }
                            this.callBase(rowIndex)
                        },
                        deleteRow: function(rowIndex) {
                            var rowKey = this._dataController.getKeyByRowIndex(rowIndex);
                            if (this.getEditMode() === EDIT_MODE_BATCH && this._adaptiveController.isAdaptiveDetailRowExpanded(rowKey)) {
                                this._adaptiveController.collapseAdaptiveDetailRow()
                            }
                            this.callBase(rowIndex)
                        },
                        init: function() {
                            this.callBase();
                            this._adaptiveController = this.getController("adaptiveColumns")
                        }
                    },
                    resizing: {
                        _needBestFit: function() {
                            return this.callBase() || !!this._adaptiveColumnsController.getHidingColumnsQueue().length
                        },
                        _updateScrollableForIE: function() {
                            var that = this;
                            if (_browser.default.msie && parseInt(_browser.default.version) <= 11) {
                                this._updateScrollableTimeoutID = setTimeout(function() {
                                    that.getView("rowsView")._updateScrollable()
                                })
                            }
                        },
                        _correctColumnWidths: function(resultWidths, visibleColumns) {
                            var adaptiveController = this._adaptiveColumnsController;
                            var columnAutoWidth = this.option("columnAutoWidth");
                            var oldHiddenColumns = adaptiveController.getHiddenColumns();
                            var hidingColumnsQueue = adaptiveController.updateHidingQueue(this._columnsController.getColumns());
                            adaptiveController.hideRedundantColumns(resultWidths, visibleColumns, hidingColumnsQueue);
                            var hiddenColumns = adaptiveController.getHiddenColumns();
                            if (adaptiveController.hasAdaptiveDetailRowExpanded()) {
                                if (oldHiddenColumns.length !== hiddenColumns.length) {
                                    adaptiveController.updateForm(hiddenColumns)
                                }
                            }!hiddenColumns.length && adaptiveController.collapseAdaptiveDetailRow();
                            if (columnAutoWidth && hidingColumnsQueue.length && !hiddenColumns.length) {
                                this._updateScrollableForIE()
                            }
                            return this.callBase.apply(this, arguments)
                        },
                        _toggleBestFitMode: function(isBestFit) {
                            isBestFit && this._adaptiveColumnsController._showHiddenColumns();
                            this.callBase(isBestFit)
                        },
                        _needStretch: function() {
                            var adaptiveColumnsController = this._adaptiveColumnsController;
                            return this.callBase.apply(this, arguments) || adaptiveColumnsController.getHidingColumnsQueue().length || adaptiveColumnsController.hasHiddenColumns()
                        },
                        init: function() {
                            this._adaptiveColumnsController = this.getController("adaptiveColumns");
                            this.callBase()
                        },
                        dispose: function() {
                            this.callBase.apply(this, arguments);
                            clearTimeout(this._updateScrollableTimeoutID)
                        }
                    },
                    data: {
                        _processItems: function(items, change) {
                            var that = this;
                            var changeType = change.changeType;
                            items = that.callBase.apply(that, arguments);
                            if ("loadingAll" === changeType || !(0, _type.isDefined)(that._adaptiveExpandedKey)) {
                                return items
                            }
                            var expandRowIndex = _uiGrid_core2.default.getIndexByKey(that._adaptiveExpandedKey, items);
                            if (expandRowIndex >= 0) {
                                var item = items[expandRowIndex];
                                items.splice(expandRowIndex + 1, 0, {
                                    visible: true,
                                    rowType: ADAPTIVE_ROW_TYPE,
                                    key: item.key,
                                    data: item.data,
                                    node: item.node,
                                    modifiedValues: item.modifiedValues,
                                    isNewRow: item.isNewRow,
                                    values: item.values
                                })
                            } else {
                                if ("refresh" === changeType) {
                                    that._adaptiveExpandedKey = void 0
                                }
                            }
                            return items
                        },
                        _getRowIndicesForExpand: function(key) {
                            var rowIndices = this.callBase.apply(this, arguments);
                            if (this.getController("adaptiveColumns").isAdaptiveDetailRowExpanded(key)) {
                                var lastRowIndex = rowIndices[rowIndices.length - 1];
                                rowIndices.push(lastRowIndex + 1)
                            }
                            return rowIndices
                        },
                        adaptiveExpandedKey: function(value) {
                            if ((0, _type.isDefined)(value)) {
                                this._adaptiveExpandedKey = value
                            } else {
                                return this._adaptiveExpandedKey
                            }
                        },
                        toggleExpandAdaptiveDetailRow: function(key, alwaysExpanded) {
                            var that = this;
                            var oldExpandLoadedRowIndex = _uiGrid_core2.default.getIndexByKey(that._adaptiveExpandedKey, that._items);
                            var newExpandLoadedRowIndex = _uiGrid_core2.default.getIndexByKey(key, that._items);
                            if (oldExpandLoadedRowIndex >= 0 && oldExpandLoadedRowIndex === newExpandLoadedRowIndex && !alwaysExpanded) {
                                key = void 0;
                                newExpandLoadedRowIndex = -1
                            }
                            var oldKey = that._adaptiveExpandedKey;
                            that._adaptiveExpandedKey = key;
                            if (oldExpandLoadedRowIndex >= 0) {
                                oldExpandLoadedRowIndex++
                            }
                            if (newExpandLoadedRowIndex >= 0) {
                                newExpandLoadedRowIndex++
                            }
                            var rowIndexDelta = that.getRowIndexDelta();
                            that.updateItems({
                                allowInvisibleRowIndices: true,
                                changeType: "update",
                                rowIndices: [oldExpandLoadedRowIndex - rowIndexDelta, newExpandLoadedRowIndex - rowIndexDelta]
                            });
                            var adaptiveColumnsController = this.getController("adaptiveColumns");
                            adaptiveColumnsController.updateCommandAdaptiveAriaLabel(key, COLLAPSE_ARIA_NAME);
                            adaptiveColumnsController.updateCommandAdaptiveAriaLabel(oldKey, EXPAND_ARIA_NAME)
                        },
                        init: function() {
                            this.callBase();
                            this._adaptiveExpandedKey = void 0
                        }
                    },
                    editorFactory: {
                        _getFocusCellSelector: function() {
                            return this.callBase() + ", .dx-adaptive-detail-row .dx-field-item > .dx-field-item-content"
                        },
                        _getTooltipsSelector: function() {
                            return this.callBase() + ", .dx-field-item-content ." + this.addWidgetPrefix(REVERT_TOOLTIP_CLASS)
                        }
                    },
                    columns: {
                        _isColumnVisible: function(column) {
                            return this.callBase(column) && !column.adaptiveHidden
                        }
                    },
                    keyboardNavigation: {
                        _isCellValid: function($cell) {
                            return this.callBase.apply(this, arguments) && !$cell.hasClass(this.addWidgetPrefix(HIDDEN_COLUMN_CLASS))
                        },
                        _processNextCellInMasterDetail: function($nextCell) {
                            this.callBase($nextCell);
                            var isCellOrBatchMode = this._editingController.isCellOrBatchEditMode();
                            if (!this._isInsideEditForm($nextCell) && $nextCell && isCellOrBatchMode) {
                                var focusHandler = function focusHandler() {
                                    _events_engine.default.off($nextCell, "focus", focusHandler);
                                    _events_engine.default.trigger($nextCell, "dxclick")
                                };
                                _events_engine.default.on($nextCell, "focus", focusHandler)
                            }
                        },
                        _handleTabKeyOnMasterDetailCell: function(eventTarget, direction) {
                            var result = this.callBase(eventTarget, direction);
                            var $currentCell = this._getFocusedCell();
                            var $row = $currentCell && $currentCell.parent();
                            if (!result && $row && $row.length) {
                                var $dataCells = getDataCellElements($row);
                                var $targetCell = "next" === direction ? $dataCells.last() : $dataCells.first();
                                var rowIndex = $row.get(0).rowIndex;
                                var adaptiveController = this._adaptiveController;
                                var key = this._dataController.getKeyByRowIndex("next" === direction ? rowIndex : rowIndex - 1);
                                var isCellElementsEquals = $currentCell && $targetCell && $currentCell.get(0) === $targetCell.get(0);
                                return adaptiveController.isAdaptiveDetailRowExpanded(key) && isCellElementsEquals
                            }
                            return result
                        },
                        init: function() {
                            this.callBase();
                            this._adaptiveController = this.getController("adaptiveColumns")
                        }
                    }
                }
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.virtual_columns.js ***!
      \*******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _uiGrid_core = __webpack_require__( /*! ./ui.grid_core.virtual_columns_core */ 420);
        var DEFAULT_COLUMN_WIDTH = 50;
        var VirtualScrollingRowsViewExtender = {
            _resizeCore: function() {
                this.callBase.apply(this, arguments);
                this._columnsController.resize()
            },
            _handleScroll: function(e) {
                var that = this;
                var scrollable = this.getScrollable();
                var left = e.scrollOffset.left;
                that.callBase.apply(that, arguments);
                if (that.option("rtlEnabled") && scrollable) {
                    left = scrollable.$content().width() - scrollable.$element().width() - left
                }
                that._columnsController.setScrollPosition(left)
            }
        };
        var HeaderFooterViewExtender = {
            _renderCore: function() {
                var that = this;
                var scrollLeft = that._scrollLeft;
                that.callBase.apply(that, arguments);
                if (that._columnsController.isVirtualMode() && scrollLeft >= 0) {
                    that._scrollLeft = 0;
                    that.scrollTo({
                        left: scrollLeft
                    })
                }
            }
        };
        var ColumnsControllerExtender = function() {
            var getWidths = function(columns) {
                return columns.map(function(column) {
                    return column.visibleWidth || parseFloat(column.width) || DEFAULT_COLUMN_WIDTH
                })
            };
            var members = {
                init: function() {
                    var that = this;
                    that.callBase();
                    that._beginPageIndex = 0;
                    that._endPageIndex = 0;
                    that._position = 0;
                    that._virtualVisibleColumns = {}
                },
                resetColumnsCache: function() {
                    this.callBase();
                    this._virtualVisibleColumns = {}
                },
                getBeginPageIndex: function(position) {
                    var visibleColumns = this.getVisibleColumns(void 0, true);
                    var widths = getWidths(visibleColumns);
                    var currentPosition = 0;
                    for (var index = 0; index < widths.length; index++) {
                        if (currentPosition >= position) {
                            return Math.floor(index / this.getColumnPageSize())
                        }
                        currentPosition += widths[index]
                    }
                    return 0
                },
                getTotalWidth: function() {
                    var width = this.option("width");
                    if ("number" === typeof width) {
                        return width
                    }
                    return this.getController("resizing")._lastWidth || this.component.$element().outerWidth()
                },
                getEndPageIndex: function(position) {
                    var visibleColumns = this.getVisibleColumns(void 0, true);
                    var widths = getWidths(visibleColumns);
                    var currentPosition = 0;
                    position += this.getTotalWidth();
                    for (var index = 0; index < widths.length; index++) {
                        if (currentPosition >= position) {
                            return Math.ceil(index / this.getColumnPageSize())
                        }
                        currentPosition += widths[index]
                    }
                    return Math.ceil(widths.length / this.getColumnPageSize())
                },
                getColumnPageSize: function() {
                    return this.option("scrolling.columnPageSize")
                },
                _fireColumnsChanged: function() {
                    var date = new Date;
                    this.columnsChanged.fire({
                        optionNames: {
                            all: true,
                            length: 1
                        },
                        changeTypes: {
                            columns: true,
                            length: 1
                        }
                    });
                    this._renderTime = new Date - date
                },
                setScrollPosition: function(position) {
                    var that = this;
                    var renderingThreshold = that.option("scrolling.columnRenderingThreshold");
                    if (that._renderTime > renderingThreshold) {
                        clearTimeout(that._changedTimeout);
                        that._changedTimeout = setTimeout(function() {
                            that._setScrollPositionCore(position)
                        }, that.option("scrolling.timeout"))
                    } else {
                        that._setScrollPositionCore(position)
                    }
                },
                isVirtualMode: function() {
                    return (0, _window.hasWindow)() && "virtual" === this.option("scrolling.columnRenderingMode")
                },
                resize: function() {
                    this._setScrollPositionCore(this._position)
                },
                _setScrollPositionCore: function(position) {
                    var that = this;
                    if (that.isVirtualMode()) {
                        var beginPageIndex = that.getBeginPageIndex(position);
                        var endPageIndex = that.getEndPageIndex(position);
                        var needColumnsChanged = position < that._position ? that._beginPageIndex > beginPageIndex : that._endPageIndex < endPageIndex;
                        that._position = position;
                        if (needColumnsChanged) {
                            that._beginPageIndex = beginPageIndex;
                            that._endPageIndex = endPageIndex;
                            that._fireColumnsChanged()
                        }
                    }
                },
                getFixedColumns: function(rowIndex, isBase) {
                    var fixedColumns = this.callBase(rowIndex);
                    if (this.isVirtualMode() && !isBase && fixedColumns.length) {
                        var transparentColumnIndex = fixedColumns.map(function(c) {
                            return c.command
                        }).indexOf("transparent");
                        fixedColumns[transparentColumnIndex].colspan = this.getVisibleColumns().length - this.callBase().length + 1;
                        return fixedColumns
                    }
                    return fixedColumns
                },
                getVisibleColumns: function(rowIndex, isBase) {
                    if (isBase || !this.isVirtualMode()) {
                        return this.callBase(rowIndex)
                    }
                    if (!this._beginPageIndex && !this._endPageIndex) {
                        this._beginPageIndex = this.getBeginPageIndex(this._position);
                        this._endPageIndex = this.getEndPageIndex(this._position)
                    }
                    var beginPageIndex = this._beginPageIndex;
                    var endPageIndex = this._endPageIndex;
                    var visibleColumnsHash = rowIndex + "-" + beginPageIndex + "-" + endPageIndex;
                    if (this._virtualVisibleColumns[visibleColumnsHash]) {
                        return this._virtualVisibleColumns[visibleColumnsHash]
                    }
                    var visibleColumns = this.callBase();
                    var rowCount = this.getRowCount();
                    var pageSize = this.getColumnPageSize();
                    var startIndex = beginPageIndex * pageSize;
                    var endIndex = endPageIndex * pageSize;
                    var fixedColumns = this.getFixedColumns(void 0, true);
                    var transparentColumnIndex = fixedColumns.map(function(c) {
                        return c.command
                    }).indexOf("transparent");
                    var beginFixedColumnCount = fixedColumns.length ? transparentColumnIndex : 0;
                    var beginFixedColumns = visibleColumns.slice(0, beginFixedColumnCount);
                    var beginColumns = visibleColumns.slice(beginFixedColumnCount, startIndex);
                    var beginWidth = getWidths(beginColumns).reduce(function(a, b) {
                        return a + b
                    }, 0);
                    if (!beginWidth) {
                        startIndex = 0
                    }
                    var endFixedColumnCount = fixedColumns.length ? fixedColumns.length - transparentColumnIndex - 1 : 0;
                    var endFixedColumns = visibleColumns.slice(visibleColumns.length - endFixedColumnCount);
                    var endColumns = visibleColumns.slice(endIndex, visibleColumns.length - endFixedColumnCount);
                    var endWidth = getWidths(endColumns).reduce(function(a, b) {
                        return a + b
                    }, 0);
                    if (!endWidth) {
                        endIndex = visibleColumns.length
                    }
                    if (rowCount > 1 && "number" === typeof rowIndex) {
                        var columnsInfo = [];
                        for (var i = 0; i < rowCount; i++) {
                            columnsInfo.push(this.callBase(i))
                        }
                        beginFixedColumns = (0, _uiGrid_core.createColumnsInfo)(columnsInfo, 0, beginFixedColumns.length)[rowIndex] || [];
                        endFixedColumns = (0, _uiGrid_core.createColumnsInfo)(columnsInfo, visibleColumns.length - endFixedColumns.length, visibleColumns.length)[rowIndex] || [];
                        visibleColumns = (0, _uiGrid_core.createColumnsInfo)(columnsInfo, startIndex, endIndex)[rowIndex] || []
                    } else {
                        visibleColumns = visibleColumns.slice(startIndex, endIndex)
                    }
                    if (beginWidth) {
                        visibleColumns.unshift({
                            command: "virtual",
                            width: beginWidth
                        });
                        visibleColumns = beginFixedColumns.concat(visibleColumns)
                    }
                    if (endWidth) {
                        visibleColumns.push({
                            command: "virtual",
                            width: endWidth
                        });
                        visibleColumns = visibleColumns.concat(endFixedColumns)
                    }
                    this._virtualVisibleColumns[visibleColumnsHash] = visibleColumns;
                    return visibleColumns
                },
                getColumnIndexOffset: function() {
                    var offset = 0;
                    if (this._beginPageIndex > 0) {
                        var fixedColumns = this.getFixedColumns();
                        var transparentColumnIndex = fixedColumns.map(function(c) {
                            return c.command
                        }).indexOf("transparent");
                        var leftFixedColumnCount = transparentColumnIndex >= 0 ? transparentColumnIndex : 0;
                        offset = this._beginPageIndex * this.getColumnPageSize() - leftFixedColumnCount - 1
                    }
                    return offset > 0 ? offset : 0
                },
                dispose: function() {
                    clearTimeout(this._changedTimeout);
                    this.callBase.apply(this, arguments)
                }
            };
            return members
        }();
        var _default = {
            defaultOptions: function() {
                return {
                    scrolling: {
                        columnRenderingMode: "standard",
                        columnPageSize: 5,
                        columnRenderingThreshold: 300
                    }
                }
            },
            extenders: {
                controllers: {
                    columns: ColumnsControllerExtender
                },
                views: {
                    columnHeadersView: HeaderFooterViewExtender,
                    footerView: HeaderFooterViewExtender,
                    rowsView: VirtualScrollingRowsViewExtender
                }
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.virtual_columns_core.js ***!
      \************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.foreachColumnInfo = foreachColumnInfo;
        exports.createColumnsInfo = createColumnsInfo;
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);

        function foreachColumnInfo(info, callback, rowIndex, offsets, columnCount, lastProcessedIndexes) {
            rowIndex = rowIndex || 0;
            offsets = offsets || [];
            lastProcessedIndexes = lastProcessedIndexes || [];
            offsets[rowIndex] = offsets[rowIndex] || 0;
            var row = info[rowIndex];
            var startIndex = lastProcessedIndexes[rowIndex] + 1 || 0;
            var processedColumnCount = 0;
            var colIndex;
            if (!row) {
                return
            }
            for (colIndex = startIndex; colIndex < row.length; colIndex++) {
                var cell = row[colIndex];
                var visibleIndex = colIndex + offsets[rowIndex];
                var colspan = cell.colspan || 1;
                foreachColumnInfo(info, callback, rowIndex + (cell.rowspan || 1), offsets, colspan, lastProcessedIndexes);
                offsets[rowIndex] += colspan - 1;
                processedColumnCount += colspan;
                if (cell.rowspan) {
                    for (var i = rowIndex + 1; i < rowIndex + cell.rowspan; i++) {
                        offsets[i] = offsets[i] || 0;
                        offsets[i] += cell.colspan || 1
                    }
                }
                if (false === callback(cell, visibleIndex, rowIndex, colIndex)) {
                    break
                }
                if (void 0 !== columnCount && processedColumnCount >= columnCount) {
                    break
                }
            }
            lastProcessedIndexes[rowIndex] = colIndex
        }

        function createColumnsInfo(info, startIndex, endIndex) {
            var newInfo = [];
            foreachColumnInfo(info, function(columnInfo, visibleIndex, rowIndex) {
                var cell = columnInfo;
                var colspan;
                var cellColspan = cell.colspan || 1;
                var isVisible = visibleIndex + cellColspan - 1 >= startIndex && visibleIndex < endIndex;
                newInfo[rowIndex] = newInfo[rowIndex] || [];
                if (isVisible) {
                    if (visibleIndex < startIndex) {
                        colspan = cellColspan - (startIndex - visibleIndex);
                        visibleIndex = startIndex
                    } else {
                        colspan = cellColspan
                    }
                    if (visibleIndex + colspan > endIndex) {
                        colspan = endIndex - visibleIndex
                    }
                    if (colspan !== cellColspan) {
                        cell = (0, _extend.extend)({}, cell, {
                            colspan: colspan
                        })
                    }
                    newInfo[rowIndex].push(cell)
                } else {
                    if (visibleIndex > endIndex) {
                        return false
                    }
                }
            });
            for (var i = 0; i < newInfo.length; i++) {
                newInfo[i] = newInfo[i] || []
            }
            return newInfo
        }
    },
    /*!****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.export_mixin.js ***!
      \****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _default = {
            _getEmptyCell: function() {
                return {
                    text: "",
                    value: void 0,
                    colspan: 1,
                    rowspan: 1
                }
            },
            _defaultSetter: function(value) {
                return !value ? 1 : value
            },
            _cloneItem: function(item) {
                return (0, _extend.extend)({}, item, this._getEmptyCell())
            },
            _prepareItems: function(items) {
                var that = this;
                var resultItems = [];
                var cols = (items[0] || []).reduce(function(sum, item) {
                    return sum + that._defaultSetter(item.colspan)
                }, 0);
                var getItem = function(items) {
                    var rowIndex = 0;
                    var cellIndex = 0;
                    return function() {
                        var row = items[rowIndex] || [];
                        var item = row[cellIndex++];
                        if (cellIndex >= row.length) {
                            rowIndex++;
                            cellIndex = 0
                        }
                        if (item) {
                            item.colspan = that._defaultSetter(item.colspan);
                            item.rowspan = that._defaultSetter(item.rowspan)
                        }
                        return item
                    }
                }(items);

                function addItem(rowIndex, cellIndex, item) {
                    var row = resultItems[rowIndex] = resultItems[rowIndex] || [];
                    row[cellIndex] = item;
                    if (item.colspan > 1 || item.rowspan > 1) {
                        var clone = that._cloneItem(item);
                        for (var c = 1; c < item.colspan; c++) {
                            addItem(rowIndex, cellIndex + c, clone)
                        }
                        for (var r = 1; r < item.rowspan; r++) {
                            for (var _c = 0; _c < item.colspan; _c++) {
                                addItem(rowIndex + r, cellIndex + _c, clone)
                            }
                        }
                    }
                }
                var item = getItem();
                var rowIndex = 0;
                while (item) {
                    for (var cellIndex = 0; cellIndex < cols; cellIndex++) {
                        if (!item) {
                            break
                        }
                        if (resultItems[rowIndex] && resultItems[rowIndex][cellIndex]) {
                            continue
                        }
                        addItem(rowIndex, cellIndex, item);
                        cellIndex += item.colspan - 1;
                        item = getItem()
                    }
                    rowIndex++
                }
                return resultItems
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.focus.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.modules */ 44));
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _uiGrid_core2 = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.utils */ 35));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ROW_FOCUSED_CLASS = "dx-row-focused";
        var FOCUSED_ROW_SELECTOR = ".dx-row." + ROW_FOCUSED_CLASS;
        var TABLE_POSTFIX_CLASS = "table";
        var CELL_FOCUS_DISABLED_CLASS = "dx-cell-focus-disabled";
        var FocusController = _uiGrid_core.default.ViewController.inherit(function() {
            return {
                init: function() {
                    this._dataController = this.getController("data");
                    this._keyboardController = this.getController("keyboardNavigation");
                    this.component._optionsByReference.focusedRowKey = true
                },
                optionChanged: function(args) {
                    if ("focusedRowIndex" === args.name) {
                        var focusedRowKey = this.option("focusedRowKey");
                        this._focusRowByIndex(args.value);
                        this._triggerFocusedRowChangedIfNeed(focusedRowKey, args.value);
                        args.handled = true
                    } else {
                        if ("focusedRowKey" === args.name) {
                            var focusedRowIndex = this.option("focusedRowIndex");
                            this._focusRowByKey(args.value);
                            this._triggerFocusedRowChangedIfNeed(args.value, focusedRowIndex);
                            args.handled = true
                        } else {
                            if ("focusedColumnIndex" === args.name) {
                                args.handled = true
                            } else {
                                if ("focusedRowEnabled" === args.name) {
                                    args.handled = true
                                } else {
                                    if ("autoNavigateToFocusedRow" === args.name) {
                                        args.handled = true
                                    } else {
                                        this.callBase(args)
                                    }
                                }
                            }
                        }
                    }
                },
                _triggerFocusedRowChangedIfNeed: function(focusedRowKey, focusedRowIndex) {
                    var focusedRowIndexByKey = this.getFocusedRowIndexByKey(focusedRowKey);
                    if (focusedRowIndex === focusedRowIndexByKey) {
                        var rowIndex = this._dataController.getRowIndexByKey(focusedRowKey);
                        if (rowIndex >= 0) {
                            var $rowElement = (0, _renderer.default)(this.getView("rowsView").getRowElement(rowIndex));
                            this.getController("keyboardNavigation")._fireFocusedRowChanged($rowElement, focusedRowIndex)
                        }
                    }
                },
                isAutoNavigateToFocusedRow: function() {
                    return "infinite" !== this.option("scrolling.mode") && this.option("autoNavigateToFocusedRow")
                },
                _focusRowByIndex: function(index) {
                    if (!this.option("focusedRowEnabled")) {
                        return
                    }
                    index = void 0 !== index ? index : this.option("focusedRowIndex");
                    if (index < 0) {
                        if (this.isAutoNavigateToFocusedRow()) {
                            this._resetFocusedRow()
                        }
                    } else {
                        this._focusRowByIndexCore(index)
                    }
                },
                _focusRowByIndexCore: function(index) {
                    var _this = this;
                    var dataController = this.getController("data");
                    var pageSize = dataController.pageSize();
                    var setKeyByIndex = function() {
                        if (_this._isValidFocusedRowIndex(index)) {
                            var visibleIndex = index - dataController.getRowIndexOffset(true);
                            var lastItemIndex = dataController._getLastItemIndex();
                            var rowIndex = Math.min(visibleIndex, lastItemIndex);
                            var focusedRowKey = dataController.getKeyByRowIndex(rowIndex, true);
                            if ((0, _type.isDefined)(focusedRowKey) && !_this.isRowFocused(focusedRowKey)) {
                                _this.option("focusedRowKey", focusedRowKey)
                            }
                        }
                    };
                    if (pageSize >= 0) {
                        if (!this._isLocalRowIndex(index)) {
                            var pageIndex = Math.floor(index / dataController.pageSize());
                            (0, _deferred.when)(dataController.pageIndex(pageIndex), dataController.waitReady()).done(function() {
                                setKeyByIndex()
                            })
                        } else {
                            setKeyByIndex()
                        }
                    }
                },
                _isLocalRowIndex: function(index) {
                    var dataController = this.getController("data");
                    var isVirtualScrolling = this.getController("keyboardNavigation")._isVirtualScrolling();
                    if (isVirtualScrolling) {
                        var pageIndex = Math.floor(index / dataController.pageSize());
                        var virtualItems = dataController.virtualItemsCount();
                        var virtualItemsBegin = virtualItems ? virtualItems.begin : -1;
                        var visibleRowsCount = dataController.getVisibleRows().length + dataController.getRowIndexOffset();
                        var visiblePagesCount = Math.ceil(visibleRowsCount / dataController.pageSize());
                        return virtualItemsBegin <= index && visiblePagesCount > pageIndex
                    }
                    return true
                },
                _setFocusedRowKeyByIndex: function(index) {
                    var dataController = this.getController("data");
                    if (this._isValidFocusedRowIndex(index)) {
                        var rowIndex = Math.min(index - dataController.getRowIndexOffset(), dataController.items().length - 1);
                        var focusedRowKey = dataController.getKeyByRowIndex(rowIndex);
                        if ((0, _type.isDefined)(focusedRowKey) && !this.isRowFocused(focusedRowKey)) {
                            this.option("focusedRowKey", focusedRowKey)
                        }
                    }
                },
                _focusRowByKey: function(key) {
                    if (!(0, _type.isDefined)(key)) {
                        this._resetFocusedRow()
                    } else {
                        this._navigateToRow(key, true)
                    }
                },
                _resetFocusedRow: function() {
                    var focusedRowKey = this.option("focusedRowKey");
                    var isFocusedRowKeyDefined = (0, _type.isDefined)(focusedRowKey);
                    if (!isFocusedRowKeyDefined && this.option("focusedRowIndex") < 0) {
                        return
                    }
                    var keyboardController = this.getController("keyboardNavigation");
                    if (isFocusedRowKeyDefined) {
                        this.option("focusedRowKey", void 0)
                    }
                    keyboardController.setFocusedRowIndex(-1);
                    this.option("focusedRowIndex", -1);
                    this.getController("data").updateItems({
                        changeType: "updateFocusedRow",
                        focusedRowKey: void 0
                    });
                    keyboardController._fireFocusedRowChanged(void 0, -1)
                },
                _isValidFocusedRowIndex: function(rowIndex) {
                    var dataController = this.getController("data");
                    var row = dataController.getVisibleRows()[rowIndex];
                    return !row || "data" === row.rowType || "group" === row.rowType
                },
                publicMethods: function() {
                    return ["navigateToRow", "isRowFocused"]
                },
                navigateToRow: function(key) {
                    if (!this.isAutoNavigateToFocusedRow()) {
                        this.option("focusedRowIndex", -1)
                    }
                    this._navigateToRow(key)
                },
                _navigateToRow: function(key, needFocusRow) {
                    var that = this;
                    var dataController = that.getController("data");
                    var isAutoNavigate = that.isAutoNavigateToFocusedRow();
                    var d = new _deferred.Deferred;
                    if (void 0 === key || !dataController.dataSource()) {
                        return d.reject().promise()
                    }
                    var rowIndexByKey = that.getFocusedRowIndexByKey(key);
                    if (!isAutoNavigate && needFocusRow || rowIndexByKey >= 0) {
                        that._navigateTo(key, d, needFocusRow)
                    } else {
                        dataController.getPageIndexByKey(key).done(function(pageIndex) {
                            if (pageIndex < 0) {
                                d.resolve(-1);
                                return
                            }
                            if (pageIndex === dataController.pageIndex()) {
                                dataController.reload().done(function() {
                                    if (that.isRowFocused(key)) {
                                        d.resolve(that.getFocusedRowIndexByKey(key))
                                    } else {
                                        that._navigateTo(key, d, needFocusRow)
                                    }
                                }).fail(d.reject)
                            } else {
                                dataController.pageIndex(pageIndex).done(function() {
                                    that._navigateTo(key, d, needFocusRow)
                                }).fail(d.reject)
                            }
                        }).fail(d.reject)
                    }
                    return d.promise()
                },
                _navigateTo: function(key, deferred, needFocusRow) {
                    var visibleRowIndex = this.getController("data").getRowIndexByKey(key);
                    var isVirtualRowRenderingMode = "virtual" === this.option("scrolling.rowRenderingMode");
                    var isAutoNavigate = this.isAutoNavigateToFocusedRow();
                    if (isAutoNavigate && isVirtualRowRenderingMode && visibleRowIndex < 0) {
                        this._navigateToVirtualRow(key, deferred, needFocusRow)
                    } else {
                        this._navigateToVisibleRow(key, deferred, needFocusRow)
                    }
                },
                _navigateToVisibleRow: function(key, deferred, needFocusRow) {
                    if (needFocusRow) {
                        this._triggerUpdateFocusedRow(key, deferred)
                    } else {
                        this.getView("rowsView").scrollToRowElement(key)
                    }
                },
                _navigateToVirtualRow: function(key, deferred, needFocusRow) {
                    var that = this;
                    var dataController = this.getController("data");
                    var rowsScrollController = dataController._rowsScrollController;
                    var rowIndex = _uiGrid_core2.default.getIndexByKey(key, dataController.items(true));
                    var scrollable = that.getView("rowsView").getScrollable();
                    if (rowsScrollController && scrollable && rowIndex >= 0) {
                        var focusedRowIndex = rowIndex + dataController.getRowIndexOffset(true);
                        var offset = rowsScrollController.getItemOffset(focusedRowIndex);
                        if (needFocusRow) {
                            var triggerUpdateFocusedRow = function triggerUpdateFocusedRow() {
                                that.component.off("contentReady", triggerUpdateFocusedRow);
                                that._triggerUpdateFocusedRow(key, deferred)
                            };
                            that.component.on("contentReady", triggerUpdateFocusedRow)
                        }
                        scrollable.scrollTo({
                            y: offset
                        })
                    }
                },
                _triggerUpdateFocusedRow: function(key, deferred) {
                    var dataController = this.getController("data");
                    var focusedRowIndex = this.getFocusedRowIndexByKey(key);
                    if (this._isValidFocusedRowIndex(focusedRowIndex)) {
                        if (this.option("focusedRowEnabled")) {
                            dataController.updateItems({
                                changeType: "updateFocusedRow",
                                focusedRowKey: key
                            })
                        } else {
                            this.getView("rowsView").scrollToRowElement(key)
                        }
                        this.getController("keyboardNavigation").setFocusedRowIndex(focusedRowIndex);
                        deferred && deferred.resolve(focusedRowIndex)
                    } else {
                        deferred && deferred.resolve(-1)
                    }
                },
                getFocusedRowIndexByKey: function(key) {
                    var dataController = this.getController("data");
                    var loadedRowIndex = dataController.getRowIndexByKey(key, true);
                    return loadedRowIndex >= 0 ? loadedRowIndex + dataController.getRowIndexOffset(true) : -1
                },
                _focusRowByKeyOrIndex: function() {
                    var _this2 = this;
                    var focusedRowKey = this.option("focusedRowKey");
                    var currentFocusedRowIndex = this.option("focusedRowIndex");
                    var keyboardController = this.getController("keyboardNavigation");
                    var dataController = this.getController("data");
                    if ((0, _type.isDefined)(focusedRowKey)) {
                        var visibleRowIndex = dataController.getRowIndexByKey(focusedRowKey);
                        if (visibleRowIndex >= 0) {
                            if (keyboardController._isVirtualScrolling()) {
                                currentFocusedRowIndex = visibleRowIndex + dataController.getRowIndexOffset()
                            }
                            keyboardController.setFocusedRowIndex(currentFocusedRowIndex);
                            this._triggerUpdateFocusedRow(focusedRowKey)
                        } else {
                            this._navigateToRow(focusedRowKey, true).done(function(focusedRowIndex) {
                                if (currentFocusedRowIndex >= 0 && focusedRowIndex < 0) {
                                    _this2._focusRowByIndex()
                                }
                            })
                        }
                    } else {
                        if (currentFocusedRowIndex >= 0) {
                            this.getController("focus")._focusRowByIndex(currentFocusedRowIndex)
                        }
                    }
                },
                isRowFocused: function(key) {
                    var focusedRowKey = this.option("focusedRowKey");
                    if ((0, _type.isDefined)(focusedRowKey)) {
                        return (0, _common.equalByValue)(key, this.option("focusedRowKey"))
                    }
                },
                updateFocusedRow: function(change) {
                    var that = this;
                    var focusedRowIndex = that._dataController.getRowIndexByKey(change.focusedRowKey);
                    var rowsView = that.getView("rowsView");
                    var $tableElement;
                    (0, _iterator.each)(rowsView.getTableElements(), function(index, element) {
                        var _change$items;
                        var isMainTable = 0 === index;
                        $tableElement = (0, _renderer.default)(element);
                        that._clearPreviousFocusedRow($tableElement, focusedRowIndex);
                        that._prepareFocusedRow({
                            changedItem: null === change || void 0 === change ? void 0 : null === (_change$items = change.items) || void 0 === _change$items ? void 0 : _change$items[focusedRowIndex],
                            $tableElement: $tableElement,
                            focusedRowIndex: focusedRowIndex,
                            isMainTable: isMainTable
                        })
                    })
                },
                _clearPreviousFocusedRow: function($tableElement, focusedRowIndex) {
                    var _this3 = this;
                    var isNotMasterDetailFocusedRow = function(_, focusedRow) {
                        var $focusedRowTable = (0, _renderer.default)(focusedRow).closest(".".concat(_this3.addWidgetPrefix(TABLE_POSTFIX_CLASS)));
                        return $tableElement.is($focusedRowTable)
                    };
                    var $prevRowFocusedElement = $tableElement.find(FOCUSED_ROW_SELECTOR).filter(isNotMasterDetailFocusedRow);
                    $prevRowFocusedElement.removeClass(ROW_FOCUSED_CLASS).removeClass(CELL_FOCUS_DISABLED_CLASS).removeAttr("tabindex");
                    $prevRowFocusedElement.children("td").removeAttr("tabindex");
                    if (0 !== focusedRowIndex) {
                        var $firstRow = (0, _renderer.default)(this.getView("rowsView").getRowElement(0));
                        $firstRow.removeClass(CELL_FOCUS_DISABLED_CLASS).removeAttr("tabIndex")
                    }
                },
                _prepareFocusedRow: function(options) {
                    var $row;
                    var changedItem = options.changedItem;
                    if (changedItem && ("data" === changedItem.rowType || "group" === changedItem.rowType)) {
                        var focusedRowIndex = options.focusedRowIndex;
                        var $tableElement = options.$tableElement;
                        var isMainTable = options.isMainTable;
                        var tabIndex = this.option("tabindex") || 0;
                        var rowsView = this.getView("rowsView");
                        $row = (0, _renderer.default)(rowsView._getRowElements($tableElement).eq(focusedRowIndex));
                        $row.addClass(ROW_FOCUSED_CLASS).attr("tabindex", tabIndex);
                        if (isMainTable) {
                            rowsView.scrollToElementVertically($row)
                        }
                    }
                    return $row
                }
            }
        }());
        var _default = {
            defaultOptions: function() {
                return {
                    focusedRowEnabled: false,
                    autoNavigateToFocusedRow: true,
                    focusedRowKey: void 0,
                    focusedRowIndex: -1,
                    focusedColumnIndex: -1
                }
            },
            controllers: {
                focus: FocusController
            },
            extenders: {
                controllers: {
                    keyboardNavigation: {
                        init: function() {
                            var rowIndex = this.option("focusedRowIndex");
                            var columnIndex = this.option("focusedColumnIndex");
                            this.createAction("onFocusedRowChanging", {
                                excludeValidators: ["disabled", "readOnly"]
                            });
                            this.createAction("onFocusedRowChanged", {
                                excludeValidators: ["disabled", "readOnly"]
                            });
                            this.createAction("onFocusedCellChanging", {
                                excludeValidators: ["disabled", "readOnly"]
                            });
                            this.createAction("onFocusedCellChanged", {
                                excludeValidators: ["disabled", "readOnly"]
                            });
                            this.callBase();
                            this.setRowFocusType();
                            this._focusedCellPosition = {};
                            if ((0, _type.isDefined)(rowIndex)) {
                                this._focusedCellPosition.rowIndex = this.option("focusedRowIndex")
                            }
                            if ((0, _type.isDefined)(columnIndex)) {
                                this._focusedCellPosition.columnIndex = this.option("focusedColumnIndex")
                            }
                        },
                        setFocusedRowIndex: function(rowIndex) {
                            var dataController = this.getController("data");
                            this.callBase(rowIndex);
                            var visibleRowIndex = rowIndex - dataController.getRowIndexOffset();
                            var visibleRow = dataController.getVisibleRows()[visibleRowIndex];
                            if (!visibleRow || !visibleRow.isNewRow) {
                                this.option("focusedRowIndex", rowIndex)
                            }
                        },
                        setFocusedColumnIndex: function(columnIndex) {
                            this.callBase(columnIndex);
                            this.option("focusedColumnIndex", columnIndex)
                        },
                        _escapeKeyHandler: function(eventArgs, isEditing) {
                            if (isEditing || !this.option("focusedRowEnabled")) {
                                this.callBase(eventArgs, isEditing);
                                return
                            }
                            if (this.isCellFocusType()) {
                                this.setRowFocusType();
                                this._focus(this._getCellElementFromTarget(eventArgs.originalEvent.target), true)
                            }
                        },
                        _updateFocusedCellPosition: function($cell, direction) {
                            var prevRowIndex = this.option("focusedRowIndex");
                            var prevColumnIndex = this.option("focusedColumnIndex");
                            var position = this.callBase($cell, direction);
                            if (position && position.columnIndex >= 0) {
                                this._fireFocusedCellChanged($cell, prevColumnIndex, prevRowIndex)
                            }
                        }
                    },
                    editorFactory: {
                        renderFocusOverlay: function($element, hideBorder) {
                            var keyboardController = this.getController("keyboardNavigation");
                            var focusedRowEnabled = this.option("focusedRowEnabled");
                            var editingController = this.getController("editing");
                            var isRowElement = "row" === keyboardController._getElementType($element);
                            var $cell;
                            if (!focusedRowEnabled || !keyboardController.isRowFocusType() || editingController.isEditing()) {
                                this.callBase($element, hideBorder)
                            } else {
                                if (focusedRowEnabled) {
                                    if (isRowElement && !$element.hasClass(ROW_FOCUSED_CLASS)) {
                                        $cell = keyboardController.getFirstValidCellInRow($element);
                                        keyboardController.focus($cell)
                                    }
                                }
                            }
                        }
                    },
                    columns: {
                        getSortDataSourceParameters: function(_, sortByKey) {
                            var _this4 = this;
                            var result = this.callBase.apply(this, arguments);
                            var dataController = this.getController("data");
                            var dataSource = dataController._dataSource;
                            var store = dataController.store();
                            var key = store && store.key();
                            var remoteOperations = dataSource && dataSource.remoteOperations() || {};
                            var isLocalOperations = Object.keys(remoteOperations).every(function(operationName) {
                                return !remoteOperations[operationName]
                            });
                            if (key && (this.option("focusedRowEnabled") && false !== this.getController("focus").isAutoNavigateToFocusedRow() || sortByKey)) {
                                key = Array.isArray(key) ? key : [key];
                                var notSortedKeys = key.filter(function(key) {
                                    return !_this4.columnOption(key, "sortOrder")
                                });
                                if (notSortedKeys.length) {
                                    result = result || [];
                                    if (isLocalOperations) {
                                        result.push({
                                            selector: dataSource.getDataIndexGetter(),
                                            desc: false
                                        })
                                    } else {
                                        notSortedKeys.forEach(function(notSortedKey) {
                                            return result.push({
                                                selector: notSortedKey,
                                                desc: false
                                            })
                                        })
                                    }
                                }
                            }
                            return result
                        }
                    },
                    data: {
                        _applyChange: function(change) {
                            if (change && "updateFocusedRow" === change.changeType) {
                                return
                            }
                            return this.callBase.apply(this, arguments)
                        },
                        _fireChanged: function(e) {
                            this.callBase(e);
                            if (this.option("focusedRowEnabled") && this._dataSource) {
                                var isPartialUpdate = "update" === e.changeType && e.repaintChangesOnly;
                                var isPartialUpdateWithDeleting = isPartialUpdate && e.changeTypes && e.changeTypes.indexOf("remove") >= 0;
                                if ("refresh" === e.changeType && e.items.length || isPartialUpdateWithDeleting) {
                                    this._updatePageIndexes();
                                    this.processUpdateFocusedRow(e)
                                } else {
                                    if ("append" === e.changeType || "prepend" === e.changeType) {
                                        this._updatePageIndexes()
                                    }
                                }
                            }
                        },
                        _updatePageIndexes: function() {
                            var prevRenderingPageIndex = this._lastRenderingPageIndex || 0;
                            var renderingPageIndex = this._rowsScrollController ? this._rowsScrollController.pageIndex() : 0;
                            this._lastRenderingPageIndex = renderingPageIndex;
                            this._isPagingByRendering = renderingPageIndex !== prevRenderingPageIndex
                        },
                        isPagingByRendering: function() {
                            return this._isPagingByRendering
                        },
                        processUpdateFocusedRow: function(e) {
                            var operationTypes = e.operationTypes || {};
                            var focusController = this.getController("focus");
                            var reload = operationTypes.reload,
                                fullReload = operationTypes.fullReload;
                            var keyboardController = this.getController("keyboardNavigation");
                            var isVirtualScrolling = keyboardController._isVirtualScrolling();
                            var focusedRowKey = this.option("focusedRowKey");
                            var isAutoNavigate = focusController.isAutoNavigateToFocusedRow();
                            if (reload && !fullReload && (0, _type.isDefined)(focusedRowKey)) {
                                focusController._navigateToRow(focusedRowKey, true).done(function(focusedRowIndex) {
                                    if (focusedRowIndex < 0) {
                                        focusController._focusRowByIndex()
                                    }
                                })
                            } else {
                                if (operationTypes.paging && !isVirtualScrolling) {
                                    if (isAutoNavigate) {
                                        var rowIndexByKey = this.getRowIndexByKey(focusedRowKey);
                                        var isValidRowIndexByKey = rowIndexByKey >= 0;
                                        var focusedRowIndex = this.option("focusedRowIndex");
                                        var needFocusRowByIndex = focusedRowIndex >= 0 && (focusedRowIndex === rowIndexByKey || !isValidRowIndexByKey);
                                        if (needFocusRowByIndex) {
                                            focusController._focusRowByIndex()
                                        }
                                    } else {
                                        if (this.getRowIndexByKey(focusedRowKey) < 0) {
                                            this.option("focusedRowIndex", -1)
                                        }
                                    }
                                } else {
                                    if (operationTypes.fullReload) {
                                        focusController._focusRowByKeyOrIndex()
                                    }
                                }
                            }
                        },
                        getPageIndexByKey: function(key) {
                            var that = this;
                            var d = new _deferred.Deferred;
                            that.getGlobalRowIndexByKey(key).done(function(globalIndex) {
                                d.resolve(globalIndex >= 0 ? Math.floor(globalIndex / that.pageSize()) : -1)
                            }).fail(d.reject);
                            return d.promise()
                        },
                        getGlobalRowIndexByKey: function(key) {
                            if (this._dataSource.group()) {
                                return this._calculateGlobalRowIndexByGroupedData(key)
                            }
                            return this._calculateGlobalRowIndexByFlatData(key)
                        },
                        _calculateGlobalRowIndexByFlatData: function(key, groupFilter, useGroup) {
                            var that = this;
                            var deferred = new _deferred.Deferred;
                            var dataSource = that._dataSource;
                            var filter = that._generateFilterByKey(key);
                            dataSource.load({
                                filter: that._concatWithCombinedFilter(filter),
                                skip: 0,
                                take: 1
                            }).done(function(data) {
                                if (data.length > 0) {
                                    filter = that._generateOperationFilterByKey(key, data[0], useGroup);
                                    dataSource.load({
                                        filter: that._concatWithCombinedFilter(filter, groupFilter),
                                        skip: 0,
                                        take: 1,
                                        requireTotalCount: true
                                    }).done(function(_, extra) {
                                        deferred.resolve(extra.totalCount)
                                    })
                                } else {
                                    deferred.resolve(-1)
                                }
                            });
                            return deferred.promise()
                        },
                        _concatWithCombinedFilter: function(filter, groupFilter) {
                            var combinedFilter = this.getCombinedFilter();
                            return _uiGrid_core2.default.combineFilters([filter, combinedFilter, groupFilter])
                        },
                        _generateBooleanFilter: function(selector, value, sortInfo) {
                            var result;
                            if (false === value) {
                                result = [selector, "=", sortInfo.desc ? true : null]
                            } else {
                                if (true === value ? !sortInfo.desc : sortInfo.desc) {
                                    result = [selector, "<>", value]
                                }
                            }
                            return result
                        },
                        _generateOperationFilterByKey: function(key, rowData, useGroup) {
                            var that = this;
                            var dataSource = that._dataSource;
                            var filter = that._generateFilterByKey(key, "<");
                            var sort = that._columnsController.getSortDataSourceParameters(!dataSource.remoteOperations().filtering, true);
                            if (useGroup) {
                                var group = that._columnsController.getGroupDataSourceParameters(!dataSource.remoteOperations().filtering);
                                if (group) {
                                    sort = sort ? group.concat(sort) : group
                                }
                            }
                            if (sort) {
                                sort.slice().reverse().forEach(function(sortInfo) {
                                    var selector = sortInfo.selector;
                                    var getter;
                                    if ("function" === typeof selector) {
                                        getter = selector
                                    } else {
                                        getter = that._columnsController.columnOption(selector, "selector")
                                    }
                                    var value = getter ? getter(rowData) : rowData[selector];
                                    filter = [
                                        [selector, "=", value], "and", filter
                                    ];
                                    if (null === value || (0, _type.isBoolean)(value)) {
                                        var booleanFilter = that._generateBooleanFilter(selector, value, sortInfo);
                                        if (booleanFilter) {
                                            filter = [booleanFilter, "or", filter]
                                        }
                                    } else {
                                        var filterOperation = sortInfo.desc ? ">" : "<";
                                        var sortFilter = [selector, filterOperation, value];
                                        if (!sortInfo.desc) {
                                            sortFilter = [sortFilter, "or", [selector, "=", null]]
                                        }
                                        filter = [sortFilter, "or", filter]
                                    }
                                })
                            }
                            return filter
                        },
                        _generateFilterByKey: function(key, operation) {
                            var dataSourceKey = this._dataSource.key();
                            var filter = [];
                            if (!operation) {
                                operation = "="
                            }
                            if (Array.isArray(dataSourceKey)) {
                                for (var i = 0; i < dataSourceKey.length; ++i) {
                                    var keyPart = key[dataSourceKey[i]];
                                    if (keyPart) {
                                        if (filter.length > 0) {
                                            filter.push("and")
                                        }
                                        filter.push([dataSourceKey[i], operation, keyPart])
                                    }
                                }
                            } else {
                                filter = [dataSourceKey, operation, key]
                            }
                            return filter
                        },
                        _getLastItemIndex: function() {
                            return this.items(true).length - 1
                        }
                    },
                    editing: {
                        _deleteRowCore: function(rowIndex) {
                            var _this5 = this;
                            var deferred = this.callBase.apply(this, arguments);
                            var dataController = this.getController("data");
                            var rowKey = dataController.getKeyByRowIndex(rowIndex);
                            deferred.done(function() {
                                var rowIndex = dataController.getRowIndexByKey(rowKey);
                                var visibleRows = dataController.getVisibleRows();
                                if (rowIndex === -1 && !visibleRows.length) {
                                    _this5.getController("focus")._resetFocusedRow()
                                }
                            })
                        }
                    }
                },
                views: {
                    rowsView: {
                        _createRow: function(row) {
                            var $row = this.callBase(row);
                            if (this.option("focusedRowEnabled") && row) {
                                if (this.getController("focus").isRowFocused(row.key)) {
                                    $row.addClass(ROW_FOCUSED_CLASS)
                                }
                            }
                            return $row
                        },
                        _checkRowKeys: function(options) {
                            this.callBase.apply(this, arguments);
                            if (this.option("focusedRowEnabled") && this.option("dataSource")) {
                                var store = this._dataController.store();
                                if (store && !store.key()) {
                                    this._dataController.fireError("E1042", "Row focusing")
                                }
                            }
                        },
                        _update: function(change) {
                            if ("updateFocusedRow" === change.changeType) {
                                if (this.option("focusedRowEnabled")) {
                                    this.getController("focus").updateFocusedRow(change)
                                }
                            } else {
                                this.callBase(change)
                            }
                        },
                        updateFocusElementTabIndex: function($cellElements, preventScroll) {
                            if (this.option("focusedRowEnabled")) {
                                this._setFocusedRowElementTabIndex(preventScroll)
                            } else {
                                this.callBase($cellElements)
                            }
                        },
                        _setFocusedRowElementTabIndex: function(preventScroll) {
                            var _this6 = this;
                            var focusedRowKey = this.option("focusedRowKey");
                            var tabIndex = this.option("tabIndex") || 0;
                            var dataController = this._dataController;
                            var columnsController = this._columnsController;
                            var rowIndex = dataController.getRowIndexByKey(focusedRowKey);
                            var columnIndex = this.option("focusedColumnIndex");
                            var $row = this._findRowElementForTabIndex();
                            if (!(0, _type.isDefined)(this._scrollToFocusOnResize)) {
                                this._scrollToFocusOnResize = function() {
                                    _this6.scrollToElementVertically(_this6._findRowElementForTabIndex());
                                    _this6.resizeCompleted.remove(_this6._scrollToFocusOnResize)
                                }
                            }
                            $row.attr("tabIndex", tabIndex);
                            if (rowIndex >= 0 && !preventScroll) {
                                if (columnIndex < 0) {
                                    columnIndex = 0
                                }
                                rowIndex += dataController.getRowIndexOffset();
                                columnIndex += columnsController.getColumnIndexOffset();
                                this.getController("keyboardNavigation").setFocusedCellPosition(rowIndex, columnIndex);
                                if (this.getController("focus").isAutoNavigateToFocusedRow()) {
                                    var dataSource = dataController.dataSource();
                                    var operationTypes = dataSource && dataSource.operationTypes();
                                    if (operationTypes && !operationTypes.paging && !dataController.isPagingByRendering()) {
                                        this.resizeCompleted.remove(this._scrollToFocusOnResize);
                                        this.resizeCompleted.add(this._scrollToFocusOnResize)
                                    }
                                }
                            }
                        },
                        _findRowElementForTabIndex: function() {
                            var focusedRowKey = this.option("focusedRowKey");
                            var rowIndex = this._dataController.getRowIndexByKey(focusedRowKey);
                            return (0, _renderer.default)(this.getRowElement(rowIndex >= 0 ? rowIndex : 0))
                        },
                        scrollToRowElement: function(key) {
                            var rowIndex = this.getController("data").getRowIndexByKey(key);
                            var $row = (0, _renderer.default)(this.getRow(rowIndex));
                            this.scrollToElementVertically($row)
                        },
                        scrollToElementVertically: function($row) {
                            var scrollable = this.getScrollable();
                            if (scrollable) {
                                var position = scrollable.getScrollElementPosition($row, "vertical");
                                scrollable.scrollTo({
                                    top: position
                                })
                            }
                        }
                    }
                }
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.row_dragging.js ***!
      \****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _sortable = _interopRequireDefault(__webpack_require__( /*! ../sortable */ 273));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ./ui.grid_core.utils */ 35));
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var COMMAND_HANDLE_CLASS = "dx-command-drag";
        var CELL_FOCUS_DISABLED_CLASS = "dx-cell-focus-disabled";
        var HANDLE_ICON_CLASS = "drag-icon";
        var ROWS_VIEW = "rowsview";
        var SORTABLE_WITHOUT_HANDLE_CLASS = "dx-sortable-without-handle";
        var RowDraggingExtender = {
            init: function() {
                this.callBase.apply(this, arguments);
                this._updateHandleColumn()
            },
            _allowReordering: function() {
                var rowDragging = this.option("rowDragging");
                return !!(rowDragging && (rowDragging.allowReordering || rowDragging.allowDropInsideItem || rowDragging.group))
            },
            _updateHandleColumn: function() {
                var rowDragging = this.option("rowDragging");
                var allowReordering = this._allowReordering();
                var columnsController = this._columnsController;
                var isHandleColumnVisible = allowReordering && rowDragging.showDragIcons;
                columnsController && columnsController.addCommandColumn({
                    type: "drag",
                    command: "drag",
                    visibleIndex: -2,
                    alignment: "center",
                    cssClass: COMMAND_HANDLE_CLASS,
                    width: "auto",
                    cellTemplate: this._getHandleTemplate(),
                    visible: isHandleColumnVisible
                });
                columnsController.columnOption("type:drag", "visible", isHandleColumnVisible)
            },
            _renderContent: function() {
                var _this = this;
                var rowDragging = this.option("rowDragging");
                var allowReordering = this._allowReordering();
                var $content = this.callBase.apply(this, arguments);
                var isFixedTableRendering = this._isFixedTableRendering;
                var sortableName = "_sortable";
                var sortableFixedName = "_sortableFixed";
                var currentSortableName = isFixedTableRendering ? sortableFixedName : sortableName;
                var anotherSortableName = isFixedTableRendering ? sortableName : sortableFixedName;
                var togglePointerEventsStyle = function(toggle) {
                    var _this$sortableFixedNa;
                    null === (_this$sortableFixedNa = _this[sortableFixedName]) || void 0 === _this$sortableFixedNa ? void 0 : _this$sortableFixedNa.$element().css("pointerEvents", toggle ? "auto" : "")
                };
                if ((allowReordering || this[currentSortableName]) && $content.length) {
                    this[currentSortableName] = this._createComponent($content, _sortable.default, (0, _extend.extend)({
                        component: this.component,
                        contentTemplate: null,
                        filter: "> table > tbody > .dx-row:not(.dx-freespace-row):not(.dx-virtual-row)",
                        dragTemplate: this._getDraggableRowTemplate(),
                        handle: rowDragging.showDragIcons && ".".concat(COMMAND_HANDLE_CLASS),
                        dropFeedbackMode: "indicate"
                    }, rowDragging, {
                        onDragStart: function(e) {
                            var _rowDragging$onDragSt;
                            var row = e.component.getVisibleRows()[e.fromIndex];
                            e.itemData = row && row.data;
                            var isDataRow = row && "data" === row.rowType;
                            e.cancel = !allowReordering || !isDataRow;
                            null === (_rowDragging$onDragSt = rowDragging.onDragStart) || void 0 === _rowDragging$onDragSt ? void 0 : _rowDragging$onDragSt.call(rowDragging, e)
                        },
                        onDragEnter: function() {
                            togglePointerEventsStyle(true)
                        },
                        onDragLeave: function() {
                            togglePointerEventsStyle(false)
                        },
                        onDragEnd: function(e) {
                            var _rowDragging$onDragEn;
                            togglePointerEventsStyle(false);
                            null === (_rowDragging$onDragEn = rowDragging.onDragEnd) || void 0 === _rowDragging$onDragEn ? void 0 : _rowDragging$onDragEn.call(rowDragging, e)
                        },
                        dropFeedbackMode: _browser.default.msie ? "indicate" : rowDragging.dropFeedbackMode,
                        onOptionChanged: function(e) {
                            var hasFixedSortable = _this[sortableFixedName];
                            if (hasFixedSortable) {
                                if ("fromIndex" === e.name || "toIndex" === e.name) {
                                    _this[anotherSortableName].option(e.name, e.value)
                                }
                            }
                        }
                    }));
                    $content.toggleClass(SORTABLE_WITHOUT_HANDLE_CLASS, allowReordering && !rowDragging.showDragIcons)
                }
                return $content
            },
            _resizeCore: function() {
                this.callBase.apply(this, arguments);
                var offset = this._dataController.getRowIndexOffset();
                [this._sortable, this._sortableFixed].forEach(function(sortable) {
                    null === sortable || void 0 === sortable ? void 0 : sortable.option("offset", offset);
                    null === sortable || void 0 === sortable ? void 0 : sortable.update()
                })
            },
            _getDraggableGridOptions: function(options) {
                var gridOptions = this.option();
                var columns = this.getColumns();
                var $rowElement = (0, _renderer.default)(this.getRowElement(options.rowIndex));
                return {
                    dataSource: [{
                        id: 1,
                        parentId: 0
                    }],
                    showBorders: true,
                    showColumnHeaders: false,
                    scrolling: {
                        useNative: false,
                        showScrollbar: false
                    },
                    pager: {
                        visible: false
                    },
                    loadingTimeout: void 0,
                    columnFixing: gridOptions.columnFixing,
                    columnAutoWidth: gridOptions.columnAutoWidth,
                    showColumnLines: gridOptions.showColumnLines,
                    columns: columns.map(function(column) {
                        return {
                            width: column.width || column.visibleWidth,
                            fixed: column.fixed,
                            fixedPosition: column.fixedPosition
                        }
                    }),
                    onRowPrepared: function(e) {
                        var rowsView = e.component.getView("rowsView");
                        (0, _renderer.default)(e.rowElement).replaceWith($rowElement.eq(rowsView._isFixedTableRendering ? 1 : 0).clone())
                    }
                }
            },
            _getDraggableRowTemplate: function() {
                var _this2 = this;
                return function(options) {
                    var $rootElement = _this2.component.$element();
                    var $dataGridContainer = (0, _renderer.default)("<div>").width($rootElement.width());
                    var items = _this2._dataController.items();
                    var row = items && items[options.fromIndex];
                    var gridOptions = _this2._getDraggableGridOptions(row);
                    _this2._createComponent($dataGridContainer, _this2.component.NAME, gridOptions);
                    $dataGridContainer.find(".dx-gridbase-container").children(":not(.".concat(_this2.addWidgetPrefix(ROWS_VIEW), ")")).hide();
                    return $dataGridContainer
                }
            },
            _getHandleTemplate: function() {
                var _this3 = this;
                return function(container, options) {
                    if ("data" === options.rowType) {
                        (0, _renderer.default)(container).addClass(CELL_FOCUS_DISABLED_CLASS);
                        return (0, _renderer.default)("<span>").addClass(_this3.addWidgetPrefix(HANDLE_ICON_CLASS))
                    } else {
                        _uiGrid_core.default.setEmptyText((0, _renderer.default)(container))
                    }
                }
            },
            optionChanged: function(args) {
                if ("rowDragging" === args.name) {
                    this._updateHandleColumn();
                    this._invalidate(true, true);
                    args.handled = true
                }
                this.callBase.apply(this, arguments)
            }
        };
        var _default = {
            defaultOptions: function() {
                return {
                    rowDragging: {
                        showDragIcons: true,
                        dropFeedbackMode: "indicate",
                        allowReordering: false,
                        allowDropInsideItem: false
                    }
                }
            },
            extenders: {
                views: {
                    rowsView: RowDraggingExtender
                }
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./tree_list/ui.tree_list */ 736));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _ui.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.data_source_adapter.js ***!
      \***********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _data = __webpack_require__( /*! ../../core/utils/data */ 20);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.utils */ 35));
        var _array_utils = __webpack_require__( /*! ../../data/array_utils */ 93);
        var _array_store = _interopRequireDefault(__webpack_require__( /*! ../../data/array_store */ 77));
        var _query = _interopRequireDefault(__webpack_require__( /*! ../../data/query */ 48));
        var _uiGrid_core2 = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.data_source_adapter */ 382));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _store_helper = _interopRequireDefault(__webpack_require__( /*! ../../data/store_helper */ 94));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var queryByOptions = _store_helper.default.queryByOptions;
        var DEFAULT_KEY_EXPRESSION = "id";
        var isFullBranchFilterMode = function(that) {
            return "fullBranch" === that.option("filterMode")
        };
        var DataSourceAdapterTreeList = _uiGrid_core2.default.inherit(function() {
            var getChildKeys = function(that, keys) {
                var childKeys = [];
                keys.forEach(function(key) {
                    var node = that.getNodeByKey(key);
                    node && node.children.forEach(function(child) {
                        childKeys.push(child.key)
                    })
                });
                return childKeys
            };
            return {
                _createKeyGetter: function() {
                    var keyExpr = this.getKeyExpr();
                    return (0, _data.compileGetter)(keyExpr)
                },
                _createKeySetter: function() {
                    var keyExpr = this.getKeyExpr();
                    if ((0, _type.isFunction)(keyExpr)) {
                        return keyExpr
                    }
                    return (0, _data.compileSetter)(keyExpr)
                },
                _createParentIdGetter: function() {
                    return (0, _data.compileGetter)(this.option("parentIdExpr"))
                },
                createParentIdSetter: function() {
                    var parentIdExpr = this.option("parentIdExpr");
                    if ((0, _type.isFunction)(parentIdExpr)) {
                        return parentIdExpr
                    }
                    return (0, _data.compileSetter)(parentIdExpr)
                },
                _createItemsGetter: function() {
                    return (0, _data.compileGetter)(this.option("itemsExpr"))
                },
                _createHasItemsGetter: function() {
                    var hasItemsExpr = this.option("hasItemsExpr");
                    return hasItemsExpr && (0, _data.compileGetter)(hasItemsExpr)
                },
                _createHasItemsSetter: function() {
                    var hasItemsExpr = this.option("hasItemsExpr");
                    if ((0, _type.isFunction)(hasItemsExpr)) {
                        return hasItemsExpr
                    }
                    return hasItemsExpr && (0, _data.compileSetter)(hasItemsExpr)
                },
                _updateIndexByKeyObject: function(items) {
                    var that = this;
                    that._indexByKey = {};
                    (0, _iterator.each)(items, function(index, item) {
                        that._indexByKey[item.key] = index
                    })
                },
                _calculateHasItems: function(node, options) {
                    var that = this;
                    var parentIds = options.storeLoadOptions.parentIds;
                    var hasItems;
                    var isFullBranch = isFullBranchFilterMode(that);
                    if (that._hasItemsGetter && (parentIds || !options.storeLoadOptions.filter || isFullBranch)) {
                        hasItems = that._hasItemsGetter(node.data)
                    }
                    if (void 0 === hasItems) {
                        if (!that._isChildrenLoaded[node.key] && options.remoteOperations.filtering && (parentIds || isFullBranch)) {
                            hasItems = true
                        } else {
                            if (options.loadOptions.filter && !options.remoteOperations.filtering && isFullBranch) {
                                hasItems = node.children.length
                            } else {
                                hasItems = node.hasChildren
                            }
                        }
                    }
                    return !!hasItems
                },
                _createVisibleItemsByNodes: function(nodes, options) {
                    var that = this;
                    var result = [];
                    for (var i = 0; i < nodes.length; i++) {
                        if (nodes[i].visible) {
                            result.push(nodes[i])
                        }
                        if ((that.isRowExpanded(nodes[i].key, options) || !nodes[i].visible) && nodes[i].hasChildren && nodes[i].children.length) {
                            result = result.concat(that._createVisibleItemsByNodes(nodes[i].children, options))
                        }
                    }
                    return result
                },
                _convertItemToNode: function(item, rootValue, nodeByKey) {
                    var key = this._keyGetter(item);
                    var parentId = this._parentIdGetter(item);
                    parentId = (0, _type.isDefined)(parentId) ? parentId : rootValue;
                    var parentNode = nodeByKey[parentId] = nodeByKey[parentId] || {
                        key: parentId,
                        children: []
                    };
                    var node = nodeByKey[key] = nodeByKey[key] || {
                        key: key,
                        children: []
                    };
                    node.data = item;
                    node.parent = parentNode;
                    return node
                },
                _createNodesByItems: function(items, visibleItems) {
                    var that = this;
                    var rootValue = that.option("rootValue");
                    var visibleByKey = {};
                    var nodeByKey = that._nodeByKey = {};
                    var i;
                    if (visibleItems) {
                        for (i = 0; i < visibleItems.length; i++) {
                            visibleByKey[this._keyGetter(visibleItems[i])] = true
                        }
                    }
                    for (i = 0; i < items.length; i++) {
                        var node = that._convertItemToNode(items[i], rootValue, nodeByKey);
                        if (void 0 === node.key) {
                            return
                        }
                        node.visible = !visibleItems || !!visibleByKey[node.key];
                        if (node.parent) {
                            node.parent.children.push(node)
                        }
                    }
                    var rootNode = nodeByKey[rootValue] || {
                        key: rootValue,
                        children: []
                    };
                    rootNode.level = -1;
                    return rootNode
                },
                _convertDataToPlainStructure: function(data, parentId, result) {
                    var key;
                    if (this._itemsGetter && !data.isConverted) {
                        result = result || [];
                        for (var i = 0; i < data.length; i++) {
                            var item = (0, _array_utils.createObjectWithChanges)(data[i]);
                            key = this._keyGetter(item);
                            if (void 0 === key) {
                                key = result.length + 1;
                                this._keySetter(item, key)
                            }
                            this._parentIdSetter(item, void 0 === parentId ? this.option("rootValue") : parentId);
                            result.push(item);
                            var childItems = this._itemsGetter(item);
                            if (childItems && childItems.length) {
                                this._convertDataToPlainStructure(childItems, key, result);
                                var itemsExpr = this.option("itemsExpr");
                                if (!(0, _type.isFunction)(itemsExpr)) {
                                    delete item[itemsExpr]
                                }
                            }
                        }
                        result.isConverted = true;
                        return result
                    }
                    return data
                },
                _createIdFilter: function(field, keys) {
                    var parentIdFilters = [];
                    for (var i = 0; i < keys.length; i++) {
                        parentIdFilters.push([field, "=", keys[i]])
                    }
                    return _uiGrid_core.default.combineFilters(parentIdFilters, "or")
                },
                _customizeRemoteOperations: function(options, operationTypes) {
                    this.callBase.apply(this, arguments);
                    options.remoteOperations.paging = false;
                    var expandVisibleNodes = false;
                    if (this.option("autoExpandAll")) {
                        options.remoteOperations.sorting = false;
                        options.remoteOperations.filtering = false;
                        if ((!this._lastLoadOptions || operationTypes.filtering && !options.storeLoadOptions.filter) && !options.isCustomLoading) {
                            expandVisibleNodes = true
                        }
                    }
                    if (!options.isCustomLoading) {
                        this._isReload = this._isReload || operationTypes.reload;
                        if (!options.cachedStoreData) {
                            this._isChildrenLoaded = {};
                            if (this._isReload) {
                                this._nodeByKey = {}
                            }
                        }
                        if (this.option("expandNodesOnFiltering") && (operationTypes.filtering || this._isReload && options.storeLoadOptions.filter)) {
                            if (options.storeLoadOptions.filter) {
                                expandVisibleNodes = true
                            } else {
                                options.collapseVisibleNodes = true
                            }
                        }
                    }
                    options.expandVisibleNodes = expandVisibleNodes
                },
                _getParentIdsToLoad: function(parentIds) {
                    var parentIdsToLoad = [];
                    for (var i = 0; i < parentIds.length; i++) {
                        var node = this.getNodeByKey(parentIds[i]);
                        if (!node || node.hasChildren && !node.children.length) {
                            parentIdsToLoad.push(parentIds[i])
                        }
                    }
                    return parentIdsToLoad
                },
                _handleDataLoading: function(options) {
                    var rootValue = this.option("rootValue");
                    var parentIdExpr = this.option("parentIdExpr");
                    var parentIds = options.storeLoadOptions.parentIds;
                    if (parentIds) {
                        options.isCustomLoading = false
                    }
                    this.callBase.apply(this, arguments);
                    if (options.remoteOperations.filtering && !options.isCustomLoading) {
                        if (isFullBranchFilterMode(this) && options.cachedStoreData || !options.storeLoadOptions.filter) {
                            var expandedRowKeys = options.collapseVisibleNodes ? [] : this.option("expandedRowKeys");
                            parentIds = [rootValue].concat(expandedRowKeys).concat(parentIds || []);
                            var parentIdsToLoad = options.data ? this._getParentIdsToLoad(parentIds) : parentIds;
                            if (parentIdsToLoad.length) {
                                options.cachedPagingData = void 0;
                                options.data = void 0;
                                options.mergeStoreLoadData = true
                            }
                            options.storeLoadOptions.parentIds = parentIdsToLoad;
                            options.storeLoadOptions.filter = this._createIdFilter(parentIdExpr, parentIdsToLoad)
                        }
                    }
                },
                _generateInfoToLoad: function(data, needChildren) {
                    var that = this;
                    var key;
                    var keyMap = {};
                    var resultKeyMap = {};
                    var resultKeys = [];
                    var rootValue = that.option("rootValue");
                    var i;
                    for (i = 0; i < data.length; i++) {
                        key = needChildren ? that._parentIdGetter(data[i]) : that._keyGetter(data[i]);
                        keyMap[key] = true
                    }
                    for (i = 0; i < data.length; i++) {
                        key = needChildren ? that._keyGetter(data[i]) : that._parentIdGetter(data[i]);
                        var needToLoad = needChildren ? that.isRowExpanded(key) : key !== rootValue;
                        if (!keyMap[key] && !resultKeyMap[key] && needToLoad) {
                            resultKeyMap[key] = true;
                            resultKeys.push(key)
                        }
                    }
                    return {
                        keyMap: resultKeyMap,
                        keys: resultKeys
                    }
                },
                _loadParentsOrChildren: function(data, options, needChildren) {
                    var _this = this;
                    var that = this;
                    var filter;
                    var needLocalFiltering;
                    var _that$_generateInfoTo = that._generateInfoToLoad(data, needChildren),
                        keys = _that$_generateInfoTo.keys,
                        keyMap = _that$_generateInfoTo.keyMap;
                    var d = new _deferred.Deferred;
                    var isRemoteFiltering = options.remoteOperations.filtering;
                    var maxFilterLengthInRequest = that.option("maxFilterLengthInRequest");
                    var loadOptions = isRemoteFiltering ? options.storeLoadOptions : options.loadOptions;

                    function concatLoadedData(loadedData) {
                        if (isRemoteFiltering) {
                            that._cachedStoreData = that._cachedStoreData.concat(loadedData)
                        }
                        return data.concat(loadedData)
                    }
                    if (!keys.length) {
                        return d.resolve(data)
                    }
                    var cachedNodes = keys.map(function(id) {
                        return _this.getNodeByKey(id)
                    }).filter(function(node) {
                        return node && node.data
                    });
                    if (cachedNodes.length === keys.length) {
                        if (needChildren) {
                            cachedNodes = cachedNodes.reduce(function(result, node) {
                                return result.concat(node.children)
                            }, [])
                        }
                        if (cachedNodes.length) {
                            return that._loadParentsOrChildren(concatLoadedData(cachedNodes.map(function(node) {
                                return node.data
                            })), options, needChildren)
                        }
                    }
                    var keyExpr = needChildren ? that.option("parentIdExpr") : that.getKeyExpr();
                    filter = that._createIdFilter(keyExpr, keys);
                    var filterLength = encodeURI(JSON.stringify(filter)).length;
                    if (filterLength > maxFilterLengthInRequest) {
                        filter = function(itemData) {
                            return keyMap[that._keyGetter(itemData)]
                        };
                        needLocalFiltering = isRemoteFiltering
                    }
                    loadOptions = (0, _extend.extend)({}, loadOptions, {
                        filter: !needLocalFiltering ? filter : null
                    });
                    var store = options.fullData ? new _array_store.default(options.fullData) : that._dataSource.store();
                    that.loadFromStore(loadOptions, store).done(function(loadedData) {
                        if (loadedData.length) {
                            if (needLocalFiltering) {
                                loadedData = (0, _query.default)(loadedData).filter(filter).toArray()
                            }
                            that._loadParentsOrChildren(concatLoadedData(loadedData), options, needChildren).done(d.resolve).fail(d.reject)
                        } else {
                            d.resolve(data)
                        }
                    }).fail(d.reject);
                    return d
                },
                _loadParents: function(data, options) {
                    return this._loadParentsOrChildren(data, options)
                },
                _loadChildrenIfNeed: function(data, options) {
                    if (isFullBranchFilterMode(this)) {
                        return this._loadParentsOrChildren(data, options, true)
                    }
                    return (0, _deferred.when)(data)
                },
                _updateHasItemsMap: function(options) {
                    var parentIds = options.storeLoadOptions.parentIds;
                    if (parentIds) {
                        for (var i = 0; i < parentIds.length; i++) {
                            this._isChildrenLoaded[parentIds[i]] = true
                        }
                    }
                },
                _getKeyInfo: function() {
                    return {
                        key: function() {
                            return "key"
                        },
                        keyOf: function(data) {
                            return data.key
                        }
                    }
                },
                _applyBatch: function(changes) {
                    var _this2 = this;
                    var baseChanges = [];
                    changes.forEach(function(change) {
                        if ("insert" === change.type) {
                            baseChanges = baseChanges.concat(_this2._applyInsert(change))
                        } else {
                            if ("remove" === change.type) {
                                baseChanges = baseChanges.concat(_this2._applyRemove(change))
                            } else {
                                if ("update" === change.type) {
                                    baseChanges.push({
                                        type: change.type,
                                        key: change.key,
                                        data: {
                                            data: change.data
                                        }
                                    })
                                }
                            }
                        }
                    });
                    this.callBase(baseChanges)
                },
                _setHasItems: function(node, value) {
                    var hasItemsSetter = this._hasItemsSetter;
                    node.hasChildren = value;
                    if (hasItemsSetter && node.data) {
                        hasItemsSetter(node.data, value)
                    }
                },
                _applyInsert: function(change) {
                    var that = this;
                    var baseChanges = [];
                    var parentId = that.parentKeyOf(change.data);
                    var parentNode = that.getNodeByKey(parentId);
                    if (parentNode) {
                        var rootValue = that.option("rootValue");
                        var node = that._convertItemToNode(change.data, rootValue, that._nodeByKey);
                        node.hasChildren = false;
                        node.level = parentNode.level + 1;
                        node.visible = true;
                        parentNode.children.push(node);
                        that._isChildrenLoaded[node.key] = true;
                        that._setHasItems(parentNode, true);
                        if ((!parentNode.parent || that.isRowExpanded(parentNode.key)) && void 0 !== change.index) {
                            var index = that.items().indexOf(parentNode) + 1;
                            index += change.index >= 0 ? Math.min(change.index, parentNode.children.length) : parentNode.children.length;
                            baseChanges.push({
                                type: change.type,
                                data: node,
                                index: index
                            })
                        }
                    }
                    return baseChanges
                },
                _applyRemove: function(change) {
                    var baseChanges = [];
                    var node = this.getNodeByKey(change.key);
                    var parentNode = node && node.parent;
                    if (parentNode) {
                        var index = parentNode.children.indexOf(node);
                        if (index >= 0) {
                            parentNode.children.splice(index, 1);
                            if (!parentNode.children.length) {
                                this._setHasItems(parentNode, false)
                            }
                            baseChanges.push(change);
                            baseChanges = baseChanges.concat(this.getChildNodeKeys(change.key).map(function(key) {
                                return {
                                    type: change.type,
                                    key: key
                                }
                            }))
                        }
                    }
                    return baseChanges
                },
                _handleDataLoaded: function(options) {
                    var data = options.data = this._convertDataToPlainStructure(options.data);
                    if (!options.remoteOperations.filtering && options.loadOptions.filter) {
                        options.fullData = queryByOptions((0, _query.default)(options.data), {
                            sort: options.loadOptions && options.loadOptions.sort
                        }).toArray()
                    }
                    this._updateHasItemsMap(options);
                    this.callBase(options);
                    if (data.isConverted && this._cachedStoreData) {
                        this._cachedStoreData.isConverted = true
                    }
                },
                _fillNodes: function(nodes, options, expandedRowKeys, level) {
                    var isFullBranch = isFullBranchFilterMode(this);
                    level = level || 0;
                    for (var i = 0; i < nodes.length; i++) {
                        var node = nodes[i];
                        var needToExpand = false;
                        this._fillNodes(nodes[i].children, options, expandedRowKeys, level + 1);
                        node.level = level;
                        node.hasChildren = this._calculateHasItems(node, options);
                        if (node.visible && node.hasChildren) {
                            if (isFullBranch) {
                                if (node.children.filter(function(node) {
                                        return node.visible
                                    }).length) {
                                    needToExpand = true
                                } else {
                                    if (node.children.length) {
                                        _uiTree_list.default.foreachNodes(node.children, function(node) {
                                            node.visible = true
                                        })
                                    }
                                }
                            } else {
                                needToExpand = true
                            }
                            if (options.expandVisibleNodes && needToExpand) {
                                expandedRowKeys.push(node.key)
                            }
                        }
                        if (node.visible || node.hasChildren) {
                            node.parent.hasChildren = true
                        }
                    }
                },
                _processTreeStructure: function(options, visibleItems) {
                    var data = options.data;
                    var parentIds = options.storeLoadOptions.parentIds;
                    var expandedRowKeys = [];
                    if (parentIds && parentIds.length || this._isReload) {
                        if (options.fullData && options.fullData.length > options.data.length) {
                            data = options.fullData;
                            visibleItems = visibleItems || options.data
                        }
                        this._rootNode = this._createNodesByItems(data, visibleItems);
                        if (!this._rootNode) {
                            options.data = (new _deferred.Deferred).reject(_ui.default.Error("E1046", this.getKeyExpr()));
                            return
                        }
                        this._fillNodes(this._rootNode.children, options, expandedRowKeys);
                        this._isNodesInitializing = true;
                        if (options.collapseVisibleNodes || expandedRowKeys.length) {
                            this.option("expandedRowKeys", expandedRowKeys)
                        }
                        this._isReload = false;
                        this.executeAction("onNodesInitialized", {
                            root: this._rootNode
                        });
                        this._isNodesInitializing = false
                    }
                    data = this._createVisibleItemsByNodes(this._rootNode.children, options);
                    options.data = data;
                    this._totalItemsCount = data.length
                },
                _handleDataLoadedCore: function(options) {
                    var that = this;
                    var data = options.data;
                    var callBase = that.callBase;
                    var filter = options.storeLoadOptions.filter || options.loadOptions.filter;
                    var filterMode = that.option("filterMode");
                    var visibleItems;
                    var parentIds = options.storeLoadOptions.parentIds;
                    var needLoadParents = filter && (!parentIds || !parentIds.length) && "standard" !== filterMode;
                    if (!options.isCustomLoading) {
                        if (needLoadParents) {
                            var d = options.data = new _deferred.Deferred;
                            if ("matchOnly" === filterMode) {
                                visibleItems = data
                            }
                            return that._loadParents(data, options).done(function(data) {
                                that._loadChildrenIfNeed(data, options).done(function(data) {
                                    options.data = data;
                                    that._processTreeStructure(options, visibleItems);
                                    callBase.call(that, options);
                                    d.resolve(options.data)
                                })
                            }).fail(d.reject)
                        } else {
                            that._processTreeStructure(options)
                        }
                    }
                    that.callBase(options)
                },
                _handlePush: function(changes) {
                    var reshapeOnPush = this._dataSource._reshapeOnPush;
                    var isNeedReshape = reshapeOnPush && !!changes.length;
                    if (isNeedReshape) {
                        this._isReload = true
                    }
                    this.callBase.apply(this, arguments)
                },
                init: function(dataSource, remoteOperations) {
                    this.callBase.apply(this, arguments);
                    var dataStructure = this.option("dataStructure");
                    this._keyGetter = this._createKeyGetter();
                    this._parentIdGetter = this._createParentIdGetter();
                    this._hasItemsGetter = this._createHasItemsGetter();
                    this._hasItemsSetter = this._createHasItemsSetter();
                    if ("tree" === dataStructure) {
                        this._itemsGetter = this._createItemsGetter();
                        this._keySetter = this._createKeySetter();
                        this._parentIdSetter = this.createParentIdSetter()
                    }
                    this._nodeByKey = {};
                    this._isChildrenLoaded = {};
                    this._totalItemsCount = 0;
                    this.createAction("onNodesInitialized")
                },
                getKeyExpr: function() {
                    var store = this.store();
                    var key = store && store.key();
                    var keyExpr = this.option("keyExpr");
                    if ((0, _type.isDefined)(key) && (0, _type.isDefined)(keyExpr)) {
                        if (!(0, _common.equalByValue)(key, keyExpr)) {
                            throw _ui.default.Error("E1044")
                        }
                    }
                    return key || keyExpr || DEFAULT_KEY_EXPRESSION
                },
                keyOf: function(data) {
                    return this._keyGetter && this._keyGetter(data)
                },
                parentKeyOf: function(data) {
                    return this._parentIdGetter && this._parentIdGetter(data)
                },
                getRootNode: function() {
                    return this._rootNode
                },
                totalItemsCount: function() {
                    return this._totalItemsCount
                },
                isRowExpanded: function(key, cache) {
                    if (cache) {
                        var isExpandedByKey = cache.isExpandedByKey;
                        if (!isExpandedByKey) {
                            isExpandedByKey = cache.isExpandedByKey = {};
                            this.option("expandedRowKeys").forEach(function(key) {
                                isExpandedByKey[key] = true
                            })
                        }
                        return !!isExpandedByKey[key]
                    }
                    var indexExpandedNodeKey = _uiGrid_core.default.getIndexByKey(key, this.option("expandedRowKeys"), null);
                    return indexExpandedNodeKey >= 0
                },
                _changeRowExpandCore: function(key) {
                    var expandedRowKeys = this.option("expandedRowKeys").slice();
                    var indexExpandedNodeKey = _uiGrid_core.default.getIndexByKey(key, expandedRowKeys, null);
                    if (indexExpandedNodeKey < 0) {
                        expandedRowKeys.push(key)
                    } else {
                        expandedRowKeys.splice(indexExpandedNodeKey, 1)
                    }
                    this.option("expandedRowKeys", expandedRowKeys)
                },
                changeRowExpand: function(key) {
                    this._changeRowExpandCore(key);
                    return this._isNodesInitializing ? (new _deferred.Deferred).resolve() : this.load()
                },
                getNodeByKey: function(key) {
                    if (this._nodeByKey) {
                        return this._nodeByKey[key]
                    }
                },
                getNodeLeafKeys: function() {
                    var that = this;
                    var result = [];
                    var keys = that._rootNode ? [that._rootNode.key] : [];
                    keys.forEach(function(key) {
                        var node = that.getNodeByKey(key);
                        node && _uiTree_list.default.foreachNodes([node], function(childNode) {
                            !childNode.children.length && result.push(childNode.key)
                        })
                    });
                    return result
                },
                getChildNodeKeys: function(parentKey) {
                    var node = this.getNodeByKey(parentKey);
                    var childrenKeys = [];
                    node && _uiTree_list.default.foreachNodes(node.children, function(childNode) {
                        childrenKeys.push(childNode.key)
                    });
                    return childrenKeys
                },
                loadDescendants: function(keys, childrenOnly) {
                    var that = this;
                    var d = new _deferred.Deferred;
                    var remoteOperations = that.remoteOperations();
                    if ((0, _type.isDefined)(keys)) {
                        keys = Array.isArray(keys) ? keys : [keys]
                    } else {
                        keys = that.getNodeLeafKeys()
                    }
                    if (!remoteOperations.filtering || !keys.length) {
                        return d.resolve()
                    }
                    var loadOptions = that._dataSource._createStoreLoadOptions();
                    loadOptions.parentIds = keys;
                    that.load(loadOptions).done(function() {
                        if (!childrenOnly) {
                            var childKeys = getChildKeys(that, keys);
                            if (childKeys.length) {
                                that.loadDescendants(childKeys, childrenOnly).done(d.resolve).fail(d.reject);
                                return
                            }
                        }
                        d.resolve()
                    }).fail(d.reject);
                    return d.promise()
                },
                forEachNode: function() {
                    var nodes = [];
                    var callback;
                    if (1 === arguments.length) {
                        callback = arguments[0];
                        var rootNode = this.getRootNode();
                        nodes = rootNode && rootNode.children || []
                    } else {
                        if (2 === arguments.length) {
                            callback = arguments[1];
                            nodes = arguments[0];
                            nodes = Array.isArray(nodes) ? nodes : [nodes]
                        }
                    }
                    _uiTree_list.default.foreachNodes(nodes, callback)
                }
            }
        }());
        var _default = {
            extend: function(extender) {
                DataSourceAdapterTreeList = DataSourceAdapterTreeList.inherit(extender)
            },
            create: function(component) {
                return new DataSourceAdapterTreeList(component)
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/pivot_grid/xmla_store/xmla_store.js ***!
      \*************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.XmlaStore = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../../core/renderer */ 2));
        var _window = __webpack_require__( /*! ../../../core/utils/window */ 7);
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../../core/class */ 15));
        var _string = __webpack_require__( /*! ../../../core/utils/string */ 43);
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../../../data/errors */ 38));
        var _common = __webpack_require__( /*! ../../../core/utils/common */ 4);
        var _extend = __webpack_require__( /*! ../../../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../../core/utils/iterator */ 3);
        var _array = __webpack_require__( /*! ../../../core/utils/array */ 12);
        var _uiPivot_grid = __webpack_require__( /*! ../ui.pivot_grid.utils */ 84);
        var _deferred = __webpack_require__( /*! ../../../core/utils/deferred */ 6);
        var _language_codes = __webpack_require__( /*! ../../../localization/language_codes */ 204);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }
        var errors = _errors.default.errors;
        var window = (0, _window.getWindow)();
        var XmlaStore = _class.default.inherit(function() {
            var discover = '<Envelope xmlns="http://schemas.xmlsoap.org/soap/envelope/"><Body><Discover xmlns="urn:schemas-microsoft-com:xml-analysis"><RequestType>{2}</RequestType><Restrictions><RestrictionList><CATALOG_NAME>{0}</CATALOG_NAME><CUBE_NAME>{1}</CUBE_NAME></RestrictionList></Restrictions><Properties><PropertyList><Catalog>{0}</Catalog>{3}</PropertyList></Properties></Discover></Body></Envelope>';
            var execute = '<Envelope xmlns="http://schemas.xmlsoap.org/soap/envelope/"><Body><Execute xmlns="urn:schemas-microsoft-com:xml-analysis"><Command><Statement>{0}</Statement></Command><Properties><PropertyList><Catalog>{1}</Catalog><ShowHiddenCubes>True</ShowHiddenCubes><SspropInitAppName>Microsoft SQL Server Management Studio</SspropInitAppName><Timeout>3600</Timeout>{2}</PropertyList></Properties></Execute></Body></Envelope>';
            var mdx = "SELECT {2} FROM {0} {1} CELL PROPERTIES VALUE, FORMAT_STRING, LANGUAGE, BACK_COLOR, FORE_COLOR, FONT_FLAGS";
            var mdxFilterSelect = "(SELECT {0} FROM {1})";
            var mdxSubset = "Subset({0}, {1}, {2})";
            var mdxOrder = "Order({0}, {1}, {2})";
            var mdxWith = "{0} {1} as {2}";
            var mdxSlice = "WHERE ({0})";
            var mdxNonEmpty = "NonEmpty({0}, {1})";
            var mdxAxis = "{0} DIMENSION PROPERTIES PARENT_UNIQUE_NAME,HIERARCHY_UNIQUE_NAME, MEMBER_VALUE ON {1}";
            var mdxCrossJoin = "CrossJoin({0})";
            var mdxSet = "{{0}}";
            var MEASURE_DEMENSION_KEY = "DX_MEASURES";
            var MD_DIMTYPE_MEASURE = "2";

            function execXMLA(requestOptions, data) {
                var deferred = new _deferred.Deferred;
                var beforeSend = requestOptions.beforeSend;
                var ajaxSettings = {
                    url: requestOptions.url,
                    dataType: "text",
                    data: data,
                    headers: {
                        "Content-Type": "text/xml"
                    },
                    xhrFields: {},
                    method: "POST"
                };
                if ((0, _type.isFunction)(beforeSend)) {
                    beforeSend(ajaxSettings)
                }(0, _uiPivot_grid.sendRequest)(ajaxSettings).fail(function() {
                    deferred.reject(arguments)
                }).done(function(text) {
                    var parser = new window.DOMParser;
                    var xml;
                    try {
                        try {
                            xml = parser.parseFromString(text, "text/xml")
                        } catch (e) {
                            xml = void 0
                        }
                        if (!xml || xml.getElementsByTagName("parsererror").length || 0 === xml.childNodes.length) {
                            throw new errors.Error("E4023", text)
                        }
                    } catch (e) {
                        deferred.reject({
                            statusText: e.message,
                            stack: e.stack,
                            responseText: text
                        })
                    }
                    deferred.resolve(xml)
                });
                return deferred
            }

            function getLocaleIdProperty() {
                var languageId = (0, _language_codes.getLanguageId)();
                if (void 0 !== languageId) {
                    return (0, _string.format)("<LocaleIdentifier>{0}</LocaleIdentifier>", languageId)
                }
                return ""
            }

            function mdxDescendants(level, levelMember, nextLevel) {
                var memberExpression = levelMember ? levelMember : level;
                return "Descendants({" + memberExpression + "}, " + nextLevel + ", SELF_AND_BEFORE)"
            }

            function getAllMember(dimension) {
                return (dimension.hierarchyName || dimension.dataField) + ".[All]"
            }

            function getAllMembers(field) {
                var result = field.dataField + ".allMembers";
                var searchValue = field.searchValue;
                if (searchValue) {
                    searchValue = searchValue.replace(/'/g, "''");
                    result = "Filter(" + result + ", instr(" + field.dataField + ".currentmember.member_caption,'" + searchValue + "') > 0)"
                }
                return result
            }

            function crossJoinElements(elements) {
                var elementsString = elements.join(",");
                return elements.length > 1 ? (0, _string.format)(mdxCrossJoin, elementsString) : elementsString
            }

            function union(elements) {
                var elementsString = elements.join(",");
                return elements.length > 1 ? "Union(" + elementsString + ")" : elementsString
            }

            function generateCrossJoin(path, expandLevel, expandAllCount, expandIndex, slicePath, options, axisName, take) {
                var crossJoinArgs = [];
                var dimensions = options[axisName];
                var fields = [];
                var arg;
                var prevDimension;
                var member;
                for (var i = expandIndex; i <= expandLevel; i++) {
                    var field = dimensions[i];
                    var dataField = field.dataField;
                    var prevHierarchyName = dimensions[i - 1] && dimensions[i - 1].hierarchyName;
                    var hierarchyName = field.hierarchyName;
                    var isLastDimensionInGroup = !hierarchyName || !dimensions[i + 1] || dimensions[i + 1].hierarchyName !== hierarchyName;
                    var expandAllIndex = path.length + expandAllCount + expandIndex;
                    arg = null;
                    fields.push(field);
                    if (i < path.length) {
                        if (isLastDimensionInGroup) {
                            arg = "(" + dataField + "." + preparePathValue(path[i], dataField) + ")"
                        }
                    } else {
                        if (i <= expandAllIndex) {
                            if (0 === i && 0 === expandAllCount) {
                                var allMember = getAllMember(dimensions[expandIndex]);
                                if (!hierarchyName) {
                                    arg = getAllMembers(dimensions[expandIndex])
                                } else {
                                    arg = allMember + "," + dimensions[expandIndex].dataField
                                }
                            } else {
                                if (hierarchyName) {
                                    member = preparePathValue(slicePath[slicePath.length - 1]);
                                    if (isLastDimensionInGroup || i === expandAllIndex) {
                                        if (prevHierarchyName === hierarchyName) {
                                            if (slicePath.length) {
                                                prevDimension = dimensions[slicePath.length - 1]
                                            }
                                            if (!prevDimension || prevDimension.hierarchyName !== hierarchyName) {
                                                prevDimension = dimensions[i - 1];
                                                member = ""
                                            }
                                            arg = mdxDescendants(prevDimension.dataField, member, dataField)
                                        } else {
                                            arg = getAllMembers(field)
                                        }
                                    }
                                } else {
                                    arg = getAllMembers(field)
                                }
                            }
                        } else {
                            var isFirstDimensionInGroup = !hierarchyName || prevHierarchyName !== hierarchyName;
                            if (isFirstDimensionInGroup) {
                                arg = "(" + getAllMember(field) + ")"
                            }
                        }
                    }
                    if (arg) {
                        arg = (0, _string.format)(mdxSet, arg);
                        if (take) {
                            var sortBy = (field.hierarchyName || field.dataField) + ("displayText" === field.sortBy ? ".MEMBER_CAPTION" : ".MEMBER_VALUE");
                            arg = (0, _string.format)(mdxOrder, arg, sortBy, "desc" === field.sortOrder ? "DESC" : "ASC")
                        }
                        crossJoinArgs.push(arg)
                    }
                }
                return crossJoinElements(crossJoinArgs)
            }

            function fillCrossJoins(crossJoins, path, expandLevel, expandIndex, slicePath, options, axisName, cellsString, take, totalsOnly) {
                var expandAllCount = -1;
                var dimensions = options[axisName];
                var dimensionIndex;
                do {
                    expandAllCount++;
                    dimensionIndex = path.length + expandAllCount + expandIndex;
                    var crossJoin = generateCrossJoin(path, expandLevel, expandAllCount, expandIndex, slicePath, options, axisName, take);
                    if (!take && !totalsOnly) {
                        crossJoin = (0, _string.format)(mdxNonEmpty, crossJoin, cellsString)
                    }
                    crossJoins.push(crossJoin)
                } while (dimensions[dimensionIndex] && dimensions[dimensionIndex + 1] && dimensions[dimensionIndex].expanded)
            }

            function declare(expression, withArray, name, type) {
                name = name || "[DX_Set_" + withArray.length + "]";
                type = type || "set";
                withArray.push((0, _string.format)(mdxWith, type, name, expression));
                return name
            }

            function generateAxisMdx(options, axisName, cells, withArray, parseOptions) {
                var dimensions = options[axisName];
                var crossJoins = [];
                var path = [];
                var expandedPaths = [];
                var expandIndex = 0;
                var expandLevel = 0;
                var result = [];
                var cellsString = (0, _string.format)(mdxSet, cells.join(","));
                if (dimensions && dimensions.length) {
                    if (options.headerName === axisName) {
                        path = options.path;
                        expandIndex = path.length
                    } else {
                        if (options.headerName && options.oppositePath) {
                            path = options.oppositePath;
                            expandIndex = path.length
                        } else {
                            expandedPaths = ("columns" === axisName ? options.columnExpandedPaths : options.rowExpandedPaths) || expandedPaths
                        }
                    }
                    expandLevel = (0, _uiPivot_grid.getExpandedLevel)(options, axisName);
                    fillCrossJoins(crossJoins, [], expandLevel, expandIndex, path, options, axisName, cellsString, "rows" === axisName ? options.rowTake : options.columnTake, options.totalsOnly);
                    (0, _iterator.each)(expandedPaths, function(_, expandedPath) {
                        fillCrossJoins(crossJoins, expandedPath, expandLevel, expandIndex, expandedPath, options, axisName, cellsString)
                    });
                    for (var i = expandLevel; i >= path.length; i--) {
                        if (dimensions[i].hierarchyName) {
                            parseOptions.visibleLevels[dimensions[i].hierarchyName] = parseOptions.visibleLevels[dimensions[i].hierarchyName] || [];
                            parseOptions.visibleLevels[dimensions[i].hierarchyName].push(dimensions[i].dataField)
                        }
                    }
                }
                if (crossJoins.length) {
                    var expression = union(crossJoins);
                    if ("rows" === axisName && options.rowTake) {
                        expression = (0, _string.format)(mdxSubset, expression, options.rowSkip > 0 ? options.rowSkip + 1 : 0, options.rowSkip > 0 ? options.rowTake : options.rowTake + 1)
                    }
                    if ("columns" === axisName && options.columnTake) {
                        expression = (0, _string.format)(mdxSubset, expression, options.columnSkip > 0 ? options.columnSkip + 1 : 0, options.columnSkip > 0 ? options.columnTake : options.columnTake + 1)
                    }
                    var axisSet = "[DX_".concat(axisName, "]");
                    result.push(declare(expression, withArray, axisSet));
                    if (options.totalsOnly) {
                        result.push(declare("COUNT(".concat(axisSet, ")"), withArray, "[DX_".concat(axisName, "_count]"), "member"))
                    }
                }
                if ("columns" === axisName && cells.length && !options.skipValues) {
                    result.push(cellsString)
                }
                return (0, _string.format)(mdxAxis, crossJoinElements(result), axisName)
            }

            function generateAxisFieldsFilter(fields) {
                var filterMembers = [];
                (0, _iterator.each)(fields, function(_, field) {
                    var dataField = field.dataField;
                    var filterExpression = [];
                    var filterValues = field.filterValues || [];
                    var filterStringExpression;
                    if (field.hierarchyName && (0, _type.isNumeric)(field.groupIndex)) {
                        return
                    }(0, _iterator.each)(filterValues, function(_, filterValue) {
                        var filterMdx = dataField + "." + preparePathValue(Array.isArray(filterValue) ? filterValue[filterValue.length - 1] : filterValue, dataField);
                        if ("exclude" === field.filterType) {
                            filterExpression.push(filterMdx + ".parent");
                            filterMdx = "Descendants(" + filterMdx + ")"
                        }
                        filterExpression.push(filterMdx)
                    });
                    if (filterValues.length) {
                        filterStringExpression = (0, _string.format)(mdxSet, filterExpression.join(","));
                        if ("exclude" === field.filterType) {
                            filterStringExpression = "Except(" + getAllMembers(field) + "," + filterStringExpression + ")"
                        }
                        filterMembers.push(filterStringExpression)
                    }
                });
                return filterMembers.length ? crossJoinElements(filterMembers) : ""
            }

            function generateFrom(columnsFilter, rowsFilter, filter, cubeName) {
                var from = "[" + cubeName + "]";
                (0, _iterator.each)([columnsFilter, rowsFilter, filter], function(_, filter) {
                    if (filter) {
                        from = (0, _string.format)(mdxFilterSelect, filter + "on 0", from)
                    }
                });
                return from
            }

            function generateMdxCore(axisStrings, withArray, columns, rows, filters, slice, cubeName) {
                var options = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : {};
                var mdxString = "";
                var withString = (withArray.length ? "with " + withArray.join(" ") : "") + " ";
                if (axisStrings.length) {
                    var select;
                    if (options.totalsOnly) {
                        var countMembers = [];
                        if (rows.length) {
                            countMembers.push("[DX_rows_count]")
                        }
                        if (columns.length) {
                            countMembers.push("[DX_columns_count]")
                        }
                        select = "{".concat(countMembers.join(","), "} on columns")
                    } else {
                        select = axisStrings.join(",")
                    }
                    mdxString = withString + (0, _string.format)(mdx, generateFrom(generateAxisFieldsFilter(columns), generateAxisFieldsFilter(rows), generateAxisFieldsFilter(filters || []), cubeName), slice.length ? (0, _string.format)(mdxSlice, slice.join(",")) : "", select)
                }
                return mdxString
            }

            function prepareDataFields(withArray, valueFields) {
                return (0, _iterator.map)(valueFields, function(cell) {
                    if ((0, _type.isString)(cell.expression)) {
                        declare(cell.expression, withArray, cell.dataField, "member")
                    }
                    return cell.dataField
                })
            }

            function addSlices(slices, options, headerName, path) {
                (0, _iterator.each)(path, function(index, value) {
                    var dimension = options[headerName][index];
                    if (!dimension.hierarchyName || dimension.hierarchyName !== options[headerName][index + 1].hierarchyName) {
                        slices.push(dimension.dataField + "." + preparePathValue(value, dimension.dataField))
                    }
                })
            }

            function generateMDX(options, cubeName, parseOptions) {
                var columns = options.columns || [];
                var rows = options.rows || [];
                var values = options.values && options.values.length ? options.values : [{
                    dataField: "[Measures]"
                }];
                var slice = [];
                var withArray = [];
                var axisStrings = [];
                var dataFields = prepareDataFields(withArray, values);
                parseOptions.measureCount = options.skipValues ? 1 : values.length;
                parseOptions.visibleLevels = {};
                if (options.headerName && options.path) {
                    addSlices(slice, options, options.headerName, options.path)
                }
                if (options.headerName && options.oppositePath) {
                    addSlices(slice, options, "rows" === options.headerName ? "columns" : "rows", options.oppositePath)
                }
                if (columns.length || dataFields.length) {
                    axisStrings.push(generateAxisMdx(options, "columns", dataFields, withArray, parseOptions))
                }
                if (rows.length) {
                    axisStrings.push(generateAxisMdx(options, "rows", dataFields, withArray, parseOptions))
                }
                return generateMdxCore(axisStrings, withArray, columns, rows, options.filters, slice, cubeName, options)
            }

            function createDrillDownAxisSlice(slice, fields, path) {
                (0, _iterator.each)(path, function(index, value) {
                    var field = fields[index];
                    if (field.hierarchyName && (fields[index + 1] || {}).hierarchyName === field.hierarchyName) {
                        return
                    }
                    slice.push(field.dataField + "." + preparePathValue(value, field.dataField))
                })
            }

            function generateDrillDownMDX(options, cubeName, params) {
                var columns = options.columns || [];
                var rows = options.rows || [];
                var values = options.values && options.values.length ? options.values : [{
                    dataField: "[Measures]"
                }];
                var slice = [];
                var withArray = [];
                var axisStrings = [];
                var dataFields = prepareDataFields(withArray, values);
                var maxRowCount = params.maxRowCount;
                var customColumns = params.customColumns || [];
                var customColumnsString = customColumns.length > 0 ? " return " + customColumns.join(",") : "";
                createDrillDownAxisSlice(slice, columns, params.columnPath || []);
                createDrillDownAxisSlice(slice, rows, params.rowPath || []);
                if (columns.length || columns.length || dataFields.length) {
                    axisStrings.push([(dataFields[params.dataIndex] || dataFields[0]) + " on 0"])
                }
                var coreMDX = generateMdxCore(axisStrings, withArray, columns, rows, options.filters, slice, cubeName);
                return coreMDX ? "drillthrough" + (maxRowCount > 0 ? " maxrows " + maxRowCount : "") + coreMDX + customColumnsString : coreMDX
            }

            function getNumber(str) {
                return parseInt(str, 10)
            }

            function parseValue(valueText) {
                return (0, _type.isNumeric)(valueText) ? parseFloat(valueText) : valueText
            }

            function getFirstChild(node, tagName) {
                return (node.getElementsByTagName(tagName) || [])[0]
            }

            function getFirstChildText(node, childTagName) {
                return getNodeText(getFirstChild(node, childTagName))
            }

            function parseAxes(xml, skipValues) {
                var axes = [];
                (0, _iterator.each)(xml.getElementsByTagName("Axis"), function(_, axisElement) {
                    var name = axisElement.getAttribute("name");
                    var axis = [];
                    var index = 0;
                    if (0 === name.indexOf("Axis") && (0, _type.isNumeric)(getNumber(name.substr(4)))) {
                        axes.push(axis);
                        (0, _iterator.each)(axisElement.getElementsByTagName("Tuple"), function(_, tupleElement) {
                            var tupleMembers = tupleElement.childNodes;
                            var levelSum = 0;
                            var members = [];
                            var membersCount = skipValues ? tupleMembers.length : tupleMembers.length - 1;
                            var isAxisWithMeasure = 1 === axes.length;
                            if (isAxisWithMeasure) {
                                membersCount--
                            }
                            axis.push(members);
                            for (var i = membersCount; i >= 0; i--) {
                                var tuple = tupleMembers[i];
                                var level = getNumber(getFirstChildText(tuple, "LNum"));
                                members[i] = {
                                    caption: getFirstChildText(tuple, "Caption"),
                                    value: parseValue(getFirstChildText(tuple, "MEMBER_VALUE")),
                                    level: level,
                                    index: index++,
                                    hasValue: !levelSum && (!!level || 0 === i),
                                    name: getFirstChildText(tuple, "UName"),
                                    hierarchyName: tupleMembers[i].getAttribute("Hierarchy"),
                                    parentName: getFirstChildText(tuple, "PARENT_UNIQUE_NAME"),
                                    levelName: getFirstChildText(tuple, "LName")
                                };
                                levelSum += level
                            }
                        })
                    }
                });
                while (axes.length < 2) {
                    axes.push([
                        [{
                            level: 0
                        }]
                    ])
                }
                return axes
            }

            function getNodeText(node) {
                return node && node && (node.textContent || node.text || node.innerHTML) || ""
            }

            function parseCells(xml, axes, measureCount) {
                var cells = [];
                var cell = [];
                var index = 0;
                var cellsOriginal = [];
                var cellElements = xml.getElementsByTagName("Cell");
                var errorDictionary = {};
                for (var i = 0; i < cellElements.length; i++) {
                    var xmlCell = cellElements[i];
                    var valueElement = xmlCell.getElementsByTagName("Value")[0];
                    var errorElements = valueElement && valueElement.getElementsByTagName("Error") || [];
                    var text = 0 === errorElements.length ? getNodeText(valueElement) : "#N/A";
                    var value = parseFloat(text);
                    var _isNumeric = text - value + 1 > 0;
                    var cellOrdinal = getNumber(xmlCell.getAttribute("CellOrdinal"));
                    if (errorElements.length) {
                        errorDictionary[getNodeText(errorElements[0].getElementsByTagName("ErrorCode")[0])] = getNodeText(errorElements[0].getElementsByTagName("Description")[0])
                    }
                    cellsOriginal[cellOrdinal] = {
                        value: _isNumeric ? value : text || null
                    }
                }(0, _iterator.each)(axes[1], function() {
                    var row = [];
                    cells.push(row);
                    (0, _iterator.each)(axes[0], function() {
                        var measureIndex = index % measureCount;
                        if (0 === measureIndex) {
                            cell = [];
                            row.push(cell)
                        }
                        cell.push(cellsOriginal[index] ? cellsOriginal[index].value : null);
                        index++
                    })
                });
                Object.keys(errorDictionary).forEach(function(key) {
                    errors.log("W4002", errorDictionary[key])
                });
                return cells
            }

            function preparePathValue(pathValue, dataField) {
                if (pathValue) {
                    pathValue = (0, _type.isString)(pathValue) && pathValue.indexOf("&") !== -1 ? pathValue : "[" + pathValue + "]";
                    if (dataField && 0 === pathValue.indexOf(dataField + ".")) {
                        pathValue = pathValue.slice(dataField.length + 1, pathValue.length)
                    }
                }
                return pathValue
            }

            function getItem(hash, name, member, index) {
                var item = hash[name];
                if (!item) {
                    item = {};
                    hash[name] = item
                }
                if (!(0, _type.isDefined)(item.value) && member) {
                    item.text = member.caption;
                    item.value = member.value;
                    item.key = name ? name : "";
                    item.levelName = member.levelName;
                    item.hierarchyName = member.hierarchyName;
                    item.parentName = member.parentName;
                    item.index = index;
                    item.level = member.level
                }
                return item
            }

            function getVisibleChildren(item, visibleLevels) {
                var result = [];
                var children = item.children && (item.children.length ? item.children : Object.keys(item.children.grandTotalHash || {}).reduce(function(result, name) {
                    return result.concat(item.children.grandTotalHash[name].children)
                }, []));
                var firstChild = children && children[0];
                if (firstChild && (visibleLevels[firstChild.hierarchyName] && (0, _array.inArray)(firstChild.levelName, visibleLevels[firstChild.hierarchyName]) !== -1 || !visibleLevels[firstChild.hierarchyName] || 0 === firstChild.level)) {
                    var newChildren = children.filter(function(child) {
                        return child.hierarchyName === firstChild.hierarchyName
                    });
                    newChildren.grandTotalHash = children.grandTotalHash;
                    return newChildren
                } else {
                    if (firstChild) {
                        for (var i = 0; i < children.length; i++) {
                            if (children[i].hierarchyName === firstChild.hierarchyName) {
                                result.push.apply(result, getVisibleChildren(children[i], visibleLevels))
                            }
                        }
                    }
                }
                return result
            }

            function processMember(dataIndex, member, parentItem) {
                var children = parentItem.children = parentItem.children || [];
                var hash = children.hash = children.hash || {};
                var grandTotalHash = children.grandTotalHash = children.grandTotalHash || {};
                if (member.parentName) {
                    parentItem = getItem(hash, member.parentName);
                    children = parentItem.children = parentItem.children || []
                }
                var currentItem = getItem(hash, member.name, member, dataIndex);
                if (member.hasValue && !currentItem.added) {
                    currentItem.index = dataIndex;
                    currentItem.added = true;
                    children.push(currentItem)
                }
                if ((!parentItem.value || !parentItem.parentName) && member.parentName) {
                    grandTotalHash[member.parentName] = parentItem
                } else {
                    if (grandTotalHash[parentItem.name]) {
                        delete grandTotalHash[member.parentName]
                    }
                }
                return currentItem
            }

            function getGrandTotalIndex(parentItem, visibleLevels) {
                var grandTotalIndex;
                if (1 === parentItem.children.length && "" === parentItem.children[0].parentName) {
                    grandTotalIndex = parentItem.children[0].index;
                    var grandTotalHash = parentItem.children.grandTotalHash;
                    parentItem.children = parentItem.children[0].children || [];
                    parentItem.children.grandTotalHash = grandTotalHash;
                    parentItem.children = getVisibleChildren(parentItem, visibleLevels)
                } else {
                    if (0 === parentItem.children.length) {
                        grandTotalIndex = 0
                    }
                }
                return grandTotalIndex
            }

            function fillDataSourceAxes(dataSourceAxis, axisTuples, measureCount, visibleLevels) {
                var result = [];
                (0, _iterator.each)(axisTuples, function(tupleIndex, members) {
                    var parentItem = {
                        children: result
                    };
                    var dataIndex = (0, _type.isDefined)(measureCount) ? Math.floor(tupleIndex / measureCount) : tupleIndex;
                    (0, _iterator.each)(members, function(_, member) {
                        parentItem = processMember(dataIndex, member, parentItem)
                    })
                });
                var parentItem = {
                    children: result
                };
                parentItem.children = getVisibleChildren(parentItem, visibleLevels);
                var grandTotalIndex = getGrandTotalIndex(parentItem, visibleLevels);
                (0, _uiPivot_grid.foreachTree)(parentItem.children, function(items) {
                    var item = items[0];
                    var children = getVisibleChildren(item, visibleLevels);
                    if (children.length) {
                        item.children = children
                    } else {
                        delete item.children
                    }
                    delete item.levelName;
                    delete item.hierarchyName;
                    delete item.added;
                    delete item.parentName;
                    delete item.level
                }, true);
                (0, _iterator.each)(parentItem.children || [], function(_, e) {
                    dataSourceAxis.push(e)
                });
                return grandTotalIndex
            }

            function checkError(xml) {
                var faultElementNS = xml.getElementsByTagName("soap:Fault");
                var faultElement = xml.getElementsByTagName("Fault");
                var errorElement = (0, _renderer.default)([].slice.call(faultElement.length ? faultElement : faultElementNS)).find("Error");
                if (errorElement.length) {
                    var description = errorElement.attr("Description");
                    var error = new errors.Error("E4000", description);
                    errors.log("E4000", description);
                    return error
                }
                return null
            }

            function parseResult(xml, parseOptions) {
                var dataSource = {
                    columns: [],
                    rows: []
                };
                var measureCount = parseOptions.measureCount;
                var axes = parseAxes(xml, parseOptions.skipValues);
                dataSource.grandTotalColumnIndex = fillDataSourceAxes(dataSource.columns, axes[0], measureCount, parseOptions.visibleLevels);
                dataSource.grandTotalRowIndex = fillDataSourceAxes(dataSource.rows, axes[1], void 0, parseOptions.visibleLevels);
                dataSource.values = parseCells(xml, axes, measureCount);
                return dataSource
            }

            function parseDiscoverRowSet(xml, schema, dimensions, translatedDisplayFolders) {
                var result = [];
                var isMeasure = "MEASURE" === schema;
                var displayFolderField = isMeasure ? "MEASUREGROUP_NAME" : schema + "_DISPLAY_FOLDER";
                (0, _iterator.each)(xml.getElementsByTagName("row"), function(_, row) {
                    var hierarchyName = "LEVEL" === schema ? getFirstChildText(row, "HIERARCHY_UNIQUE_NAME") : void 0;
                    var levelNumber = getFirstChildText(row, "LEVEL_NUMBER");
                    var displayFolder = getFirstChildText(row, displayFolderField);
                    if (isMeasure) {
                        displayFolder = translatedDisplayFolders[displayFolder] || displayFolder
                    }
                    if (("0" !== levelNumber || "true" !== getFirstChildText(row, schema + "_IS_VISIBLE")) && getFirstChildText(row, "DIMENSION_TYPE") !== MD_DIMTYPE_MEASURE) {
                        var dimension = isMeasure ? MEASURE_DEMENSION_KEY : getFirstChildText(row, "DIMENSION_UNIQUE_NAME");
                        var dataField = getFirstChildText(row, schema + "_UNIQUE_NAME");
                        result.push({
                            dimension: dimensions.names[dimension] || dimension,
                            groupIndex: levelNumber ? getNumber(levelNumber) - 1 : void 0,
                            dataField: dataField,
                            caption: getFirstChildText(row, schema + "_CAPTION"),
                            hierarchyName: hierarchyName,
                            groupName: hierarchyName,
                            displayFolder: displayFolder,
                            isMeasure: isMeasure,
                            isDefault: !!dimensions.defaultHierarchies[dataField]
                        })
                    }
                });
                return result
            }

            function parseMeasureGroupDiscoverRowSet(xml) {
                var measureGroups = {};
                (0, _iterator.each)(xml.getElementsByTagName("row"), function(_, row) {
                    measureGroups[getFirstChildText(row, "MEASUREGROUP_NAME")] = getFirstChildText(row, "MEASUREGROUP_CAPTION")
                });
                return measureGroups
            }

            function parseDimensionsDiscoverRowSet(xml) {
                var result = {
                    names: {},
                    defaultHierarchies: {}
                };
                (0, _iterator.each)((0, _renderer.default)(xml).find("row"), function() {
                    var $row = (0, _renderer.default)(this);
                    var type = $row.children("DIMENSION_TYPE").text();
                    var dimensionName = type === MD_DIMTYPE_MEASURE ? MEASURE_DEMENSION_KEY : $row.children("DIMENSION_UNIQUE_NAME").text();
                    result.names[dimensionName] = $row.children("DIMENSION_CAPTION").text();
                    result.defaultHierarchies[$row.children("DEFAULT_HIERARCHY").text()] = true
                });
                return result
            }

            function parseStringWithUnicodeSymbols(str) {
                str = str.replace(/_x(....)_/g, function(whole, group1) {
                    return String.fromCharCode(parseInt(group1, 16))
                });
                var stringArray = str.match(/\[.+?\]/gi);
                if (stringArray && stringArray.length) {
                    str = stringArray[stringArray.length - 1]
                }
                return str.replace(/\[/gi, "").replace(/\]/gi, "").replace(/\$/gi, "").replace(/\./gi, " ")
            }

            function parseDrillDownRowSet(xml) {
                var rows = xml.getElementsByTagName("row");
                var result = [];
                var columnNames = {};
                for (var i = 0; i < rows.length; i++) {
                    var children = rows[i].childNodes;
                    var item = {};
                    for (var j = 0; j < children.length; j++) {
                        var tagName = children[j].tagName;
                        var name = columnNames[tagName] = columnNames[tagName] || parseStringWithUnicodeSymbols(tagName);
                        item[name] = getNodeText(children[j])
                    }
                    result.push(item)
                }
                return result
            }

            function sendQuery(storeOptions, mdxString) {
                mdxString = (0, _renderer.default)("<div>").text(mdxString).html();
                return execXMLA(storeOptions, (0, _string.format)(execute, mdxString, storeOptions.catalog, getLocaleIdProperty()))
            }

            function processTotalCount(data, options, totalCountXml) {
                var axes = [];
                var columnOptions = options.columns || [];
                var rowOptions = options.rows || [];
                if (columnOptions.length) {
                    axes.push({})
                }
                if (rowOptions.length) {
                    axes.push({})
                }
                var cells = parseCells(totalCountXml, [
                    [{}],
                    [{}, {}]
                ], 1);
                if (!columnOptions.length && rowOptions.length) {
                    data.rowCount = Math.max(cells[0][0][0] - 1, 0)
                }
                if (!rowOptions.length && columnOptions.length) {
                    data.columnCount = Math.max(cells[0][0][0] - 1, 0)
                }
                if (rowOptions.length && columnOptions.length) {
                    data.rowCount = Math.max(cells[0][0][0] - 1, 0);
                    data.columnCount = Math.max(cells[1][0][0] - 1, 0)
                }
                if (void 0 !== data.rowCount && options.rowTake) {
                    data.rows = _toConsumableArray(Array(options.rowSkip)).concat(data.rows);
                    data.rows.length = data.rowCount;
                    for (var i = 0; i < data.rows.length; i++) {
                        data.rows[i] = data.rows[i] || {}
                    }
                }
                if (void 0 !== data.columnCount && options.columnTake) {
                    data.columns = _toConsumableArray(Array(options.columnSkip)).concat(data.columns);
                    data.columns.length = data.columnCount;
                    for (var _i = 0; _i < data.columns.length; _i++) {
                        data.columns[_i] = data.columns[_i] || {}
                    }
                }
            }
            return {
                ctor: function(options) {
                    this._options = options
                },
                getFields: function() {
                    var options = this._options;
                    var catalog = options.catalog;
                    var cube = options.cube;
                    var localeIdProperty = getLocaleIdProperty();
                    var dimensionsRequest = execXMLA(options, (0, _string.format)(discover, catalog, cube, "MDSCHEMA_DIMENSIONS", localeIdProperty));
                    var measuresRequest = execXMLA(options, (0, _string.format)(discover, catalog, cube, "MDSCHEMA_MEASURES", localeIdProperty));
                    var hierarchiesRequest = execXMLA(options, (0, _string.format)(discover, catalog, cube, "MDSCHEMA_HIERARCHIES", localeIdProperty));
                    var levelsRequest = execXMLA(options, (0, _string.format)(discover, catalog, cube, "MDSCHEMA_LEVELS", localeIdProperty));
                    var result = new _deferred.Deferred;
                    (0, _deferred.when)(dimensionsRequest, measuresRequest, hierarchiesRequest, levelsRequest).then(function(dimensionsResponse, measuresResponse, hierarchiesResponse, levelsResponse) {
                        execXMLA(options, (0, _string.format)(discover, catalog, cube, "MDSCHEMA_MEASUREGROUPS", localeIdProperty)).done(function(measureGroupsResponse) {
                            var dimensions = parseDimensionsDiscoverRowSet(dimensionsResponse);
                            var hierarchies = parseDiscoverRowSet(hierarchiesResponse, "HIERARCHY", dimensions);
                            var levels = parseDiscoverRowSet(levelsResponse, "LEVEL", dimensions);
                            var measureGroups = parseMeasureGroupDiscoverRowSet(measureGroupsResponse);
                            var fields = parseDiscoverRowSet(measuresResponse, "MEASURE", dimensions, measureGroups).concat(hierarchies);
                            var levelsByHierarchy = {};
                            (0, _iterator.each)(levels, function(_, level) {
                                levelsByHierarchy[level.hierarchyName] = levelsByHierarchy[level.hierarchyName] || [];
                                levelsByHierarchy[level.hierarchyName].push(level)
                            });
                            (0, _iterator.each)(hierarchies, function(_, hierarchy) {
                                if (levelsByHierarchy[hierarchy.dataField] && levelsByHierarchy[hierarchy.dataField].length > 1) {
                                    hierarchy.groupName = hierarchy.hierarchyName = hierarchy.dataField;
                                    fields.push.apply(fields, levelsByHierarchy[hierarchy.hierarchyName])
                                }
                            });
                            result.resolve(fields)
                        }).fail(result.reject)
                    }).fail(result.reject);
                    return result
                },
                load: function load(options) {
                    var result = new _deferred.Deferred;
                    var storeOptions = this._options;
                    var parseOptions = {
                        skipValues: options.skipValues
                    };
                    var mdxString = generateMDX(options, storeOptions.cube, parseOptions);
                    var rowCountMdx;
                    if (options.rowSkip || options.rowTake || options.columnTake || options.columnSkip) {
                        rowCountMdx = generateMDX((0, _extend.extend)({}, options, {
                            totalsOnly: true,
                            rowSkip: null,
                            rowTake: null,
                            columnSkip: null,
                            columnTake: null
                        }), storeOptions.cube, {})
                    }
                    var load = function() {
                        if (mdxString) {
                            (0, _deferred.when)(sendQuery(storeOptions, mdxString), rowCountMdx && sendQuery(storeOptions, rowCountMdx)).done(function(executeXml, rowCountXml) {
                                var error = checkError(executeXml) || rowCountXml && checkError(rowCountXml);
                                if (!error) {
                                    var response = parseResult(executeXml, parseOptions);
                                    if (rowCountXml) {
                                        processTotalCount(response, options, rowCountXml)
                                    }
                                    result.resolve(response)
                                } else {
                                    result.reject(error)
                                }
                            }).fail(result.reject)
                        } else {
                            result.resolve({
                                columns: [],
                                rows: [],
                                values: [],
                                grandTotalColumnIndex: 0,
                                grandTotalRowIndex: 0
                            })
                        }
                    };
                    if (options.delay) {
                        setTimeout(load, options.delay)
                    } else {
                        load()
                    }
                    return result
                },
                supportPaging: function() {
                    return true
                },
                getDrillDownItems: function(options, params) {
                    var result = new _deferred.Deferred;
                    var storeOptions = this._options;
                    var mdxString = generateDrillDownMDX(options, storeOptions.cube, params);
                    if (mdxString) {
                        (0, _deferred.when)(sendQuery(storeOptions, mdxString)).done(function(executeXml) {
                            var error = checkError(executeXml);
                            if (!error) {
                                result.resolve(parseDrillDownRowSet(executeXml))
                            } else {
                                result.reject(error)
                            }
                        }).fail(result.reject)
                    } else {
                        result.resolve([])
                    }
                    return result
                },
                key: _common.noop,
                filter: _common.noop
            }
        }()).include(_uiPivot_grid.storeDrillDownMixin);
        exports.XmlaStore = XmlaStore
    },
    /*!*******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/pivot_grid/ui.pivot_grid.field_chooser.js ***!
      \*******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _icon = __webpack_require__( /*! ../../core/utils/icon */ 56);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _uiPivot_grid = __webpack_require__( /*! ./ui.pivot_grid.utils */ 84);
        var _tree_view = _interopRequireDefault(__webpack_require__( /*! ../tree_view */ 158));
        var _context_menu = _interopRequireDefault(__webpack_require__( /*! ../context_menu */ 107));
        var _uiPivot_grid2 = _interopRequireDefault(__webpack_require__( /*! ./ui.pivot_grid.field_chooser_base */ 294));
        __webpack_require__( /*! ./data_source */ 292);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DIV = "<div>";
        var hasWindow = (0, _window.hasWindow)();
        var FIELDCHOOSER_CLASS = "dx-pivotgridfieldchooser";
        var FIELDCHOOSER_CONTAINER_CLASS = "dx-pivotgridfieldchooser-container";
        var FIELDS_CONTAINER_CLASS = "dx-pivotgrid-fields-container";
        var AREA_DRAG_CLASS = "dx-pivotgrid-drag-action";

        function getDimensionFields(item, fields) {
            var result = [];
            if (item.items) {
                for (var i = 0; i < item.items.length; i++) {
                    result.push.apply(result, getDimensionFields(item.items[i], fields))
                }
            } else {
                if ((0, _type.isDefined)(item.index)) {
                    result.push(fields[item.index])
                }
            }
            return result
        }

        function getFirstItem(item, condition) {
            if (item.items) {
                for (var i = 0; i < item.items.length; i++) {
                    var childrenItem = getFirstItem(item.items[i], condition);
                    if (childrenItem) {
                        return childrenItem
                    }
                }
            }
            if (condition(item)) {
                return item
            }
        }
        var compareOrder = [function(a, b) {
            var aValue = -!!a.isMeasure;
            var bValue = +!!b.isMeasure;
            return aValue + bValue
        }, function(a, b) {
            var aValue = -!!(a.items && a.items.length);
            var bValue = +!!(b.items && b.items.length);
            return aValue + bValue
        }, function(a, b) {
            var aValue = +!!(false === a.isMeasure && a.field && a.field.levels && a.field.levels.length);
            var bValue = -!!(false === b.isMeasure && b.field && b.field.levels && b.field.levels.length);
            return aValue + bValue
        }, (0, _uiPivot_grid.getCompareFunction)(function(item) {
            return item.text
        })];

        function compareItems(a, b) {
            var result = 0;
            var i = 0;
            while (!result && compareOrder[i]) {
                result = compareOrder[i++](a, b)
            }
            return result
        }

        function getScrollable(container) {
            return container.find(".dx-scrollable").dxScrollable("instance")
        }
        var FieldChooser = _uiPivot_grid2.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    height: 400,
                    layout: 0,
                    dataSource: null,
                    onContextMenuPreparing: null,
                    allowSearch: false,
                    searchTimeout: 500,
                    texts: {
                        columnFields: _message.default.format("dxPivotGrid-columnFields"),
                        rowFields: _message.default.format("dxPivotGrid-rowFields"),
                        dataFields: _message.default.format("dxPivotGrid-dataFields"),
                        filterFields: _message.default.format("dxPivotGrid-filterFields"),
                        allFields: _message.default.format("dxPivotGrid-allFields")
                    }
                })
            },
            _refreshDataSource: function() {
                var that = this;
                that._expandedPaths = [];
                that._changedHandler = that._changedHandler || function() {
                    (0, _iterator.each)(that._dataChangedHandlers, function(_, func) {
                        func()
                    });
                    that._fireContentReadyAction();
                    that._skipStateChange = true;
                    that.option("state", that._dataSource.state());
                    that._skipStateChange = false
                };
                that._disposeDataSource();
                that.callBase();
                that._dataSource && that._dataSource.on("changed", that._changedHandler)
            },
            _disposeDataSource: function() {
                var that = this;
                var dataSource = that._dataSource;
                if (dataSource) {
                    dataSource.off("changed", that._changedHandler);
                    that._dataSource = void 0
                }
            },
            _dispose: function() {
                this._disposeDataSource();
                this.callBase.apply(this, arguments)
            },
            _init: function() {
                this.callBase();
                this._refreshDataSource();
                this._dataChangedHandlers = [];
                this._initActions()
            },
            _initActions: function() {
                this._actions = {
                    onContextMenuPreparing: this._createActionByOption("onContextMenuPreparing")
                }
            },
            _trigger: function(eventName, eventArg) {
                this._actions[eventName](eventArg)
            },
            _setOptionsByReference: function() {
                this.callBase();
                (0, _extend.extend)(this._optionsByReference, {
                    dataSource: true
                })
            },
            _optionChanged: function(args) {
                var that = this;
                switch (args.name) {
                    case "dataSource":
                        that._refreshDataSource();
                        that._invalidate();
                        break;
                    case "layout":
                    case "texts":
                    case "allowSearch":
                    case "searchTimeout":
                        that._invalidate();
                        break;
                    case "onContextMenuPreparing":
                        that._actions[args.name] = that._createActionByOption(args.name);
                        break;
                    default:
                        that.callBase(args)
                }
            },
            _clean: function(skipStateSetting) {
                !skipStateSetting && this._dataSource && this.option("state", this._dataSource.state());
                this.$element().children("." + FIELDCHOOSER_CONTAINER_CLASS).remove()
            },
            _renderLayout0: function($container) {
                var that = this;
                $container.addClass("dx-layout-0");
                var $row1 = (0, _renderer.default)(DIV).addClass("dx-row").appendTo($container);
                var $row2 = (0, _renderer.default)(DIV).addClass("dx-row").appendTo($container);
                var $col1 = (0, _renderer.default)(DIV).addClass("dx-col").appendTo($row1);
                var $col2 = (0, _renderer.default)(DIV).addClass("dx-col").appendTo($row1);
                var $col3 = (0, _renderer.default)(DIV).addClass("dx-col").appendTo($row2);
                var $col4 = (0, _renderer.default)(DIV).addClass("dx-col").appendTo($row2);
                that._renderArea($col1, "all");
                that._renderArea($col2, "row");
                that._renderArea($col2, "column");
                that._renderArea($col3, "filter");
                that._renderArea($col4, "data")
            },
            _renderLayout1: function($container) {
                var that = this;
                var $col1 = (0, _renderer.default)(DIV).addClass("dx-col").appendTo($container);
                var $col2 = (0, _renderer.default)(DIV).addClass("dx-col").appendTo($container);
                that._renderArea($col1, "all");
                that._renderArea($col2, "filter");
                that._renderArea($col2, "row");
                that._renderArea($col2, "column");
                that._renderArea($col2, "data")
            },
            _renderLayout2: function($container) {
                var that = this;
                $container.addClass("dx-layout-2");
                var $row1 = (0, _renderer.default)(DIV).addClass("dx-row").appendTo($container);
                that._renderArea($row1, "all");
                var $row2 = (0, _renderer.default)(DIV).addClass("dx-row").appendTo($container);
                var $col1 = (0, _renderer.default)(DIV).addClass("dx-col").appendTo($row2);
                var $col2 = (0, _renderer.default)(DIV).addClass("dx-col").appendTo($row2);
                that._renderArea($col1, "filter");
                that._renderArea($col1, "row");
                that._renderArea($col2, "column");
                that._renderArea($col2, "data")
            },
            _initMarkup: function() {
                var that = this;
                var $element = this.$element();
                var $container = (0, _renderer.default)(DIV).addClass(FIELDCHOOSER_CONTAINER_CLASS).appendTo($element);
                var layout = that.option("layout");
                that.callBase();
                $element.addClass(FIELDCHOOSER_CLASS).addClass(FIELDS_CONTAINER_CLASS);
                that._dataChangedHandlers = [];
                var dataSource = this._dataSource;
                var currentState = "instantly" !== that.option("applyChangesMode") && dataSource && dataSource.state();
                currentState && that.option("state") && dataSource.state(that.option("state"), true);
                if (0 === layout) {
                    that._renderLayout0($container)
                } else {
                    if (1 === layout) {
                        that._renderLayout1($container)
                    } else {
                        that._renderLayout2($container)
                    }
                }
                currentState && dataSource.state(currentState, true)
            },
            _renderContentImpl: function() {
                this.callBase();
                this.renderSortable();
                this._renderContextMenu();
                this.updateDimensions()
            },
            _fireContentReadyAction: function() {
                if (!this._dataSource || !this._dataSource.isLoading()) {
                    this.callBase()
                }
            },
            _getContextMenuArgs: function(dxEvent) {
                var targetFieldElement = (0, _renderer.default)(dxEvent.target).closest(".dx-area-field");
                var targetGroupElement = (0, _renderer.default)(dxEvent.target).closest(".dx-area-fields");
                var field;
                var area;
                if (targetFieldElement.length) {
                    var fieldCopy = targetFieldElement.data("field");
                    if (fieldCopy) {
                        field = this.getDataSource().field(fieldCopy.index) || fieldCopy
                    }
                }
                if (targetGroupElement.length) {
                    area = targetGroupElement.attr("group")
                }
                return {
                    event: dxEvent,
                    field: field,
                    area: area,
                    items: []
                }
            },
            _renderContextMenu: function() {
                var that = this;
                var $container = that.$element();
                if (that._contextMenu) {
                    that._contextMenu.$element().remove()
                }
                that._contextMenu = that._createComponent((0, _renderer.default)(DIV).appendTo($container), _context_menu.default, {
                    onPositioning: function(actionArgs) {
                        var event = actionArgs.event;
                        if (!event) {
                            return
                        }
                        var args = that._getContextMenuArgs(event);
                        that._trigger("onContextMenuPreparing", args);
                        if (args.items && args.items.length) {
                            actionArgs.component.option("items", args.items)
                        } else {
                            actionArgs.cancel = true
                        }
                    },
                    target: $container,
                    onItemClick: function(params) {
                        params.itemData.onItemClick && params.itemData.onItemClick(params)
                    },
                    cssClass: "dx-pivotgridfieldchooser-context-menu"
                })
            },
            _createTreeItems: function(fields, groupFieldNames, path) {
                var that = this;
                var isMeasure;
                var resultItems = [];
                var groupedItems = [];
                var groupFieldName = groupFieldNames[0];
                var fieldsByGroup = {};
                if (!groupFieldName) {
                    (0, _iterator.each)(fields, function(index, field) {
                        var icon;
                        if (true === field.isMeasure) {
                            icon = "measure"
                        }
                        if (false === field.isMeasure) {
                            icon = field.groupName ? "hierarchy" : "dimension"
                        }
                        resultItems.push({
                            index: field.index,
                            field: field,
                            key: field.dataField,
                            selected: (0, _type.isDefined)(field.area),
                            text: field.caption || field.dataField,
                            icon: icon,
                            isMeasure: field.isMeasure,
                            isDefault: field.isDefault
                        })
                    })
                } else {
                    (0, _iterator.each)(fields, function(index, field) {
                        var groupName = field[groupFieldName] || "";
                        fieldsByGroup[groupName] = fieldsByGroup[groupName] || [];
                        fieldsByGroup[groupName].push(field);
                        if (void 0 === isMeasure) {
                            isMeasure = true
                        }
                        isMeasure = isMeasure && true === field.isMeasure
                    });
                    (0, _iterator.each)(fieldsByGroup, function(groupName, fields) {
                        var currentPath = path ? path + "." + groupName : groupName;
                        var items = that._createTreeItems(fields, groupFieldNames.slice(1), currentPath);
                        if (groupName) {
                            groupedItems.push({
                                key: groupName,
                                text: groupName,
                                path: currentPath,
                                isMeasure: items.isMeasure,
                                expanded: (0, _array.inArray)(currentPath, that._expandedPaths) >= 0,
                                items: items
                            })
                        } else {
                            resultItems = items
                        }
                    });
                    resultItems = groupedItems.concat(resultItems);
                    resultItems.isMeasure = isMeasure
                }
                return resultItems
            },
            _createFieldsDataSource: function(dataSource) {
                var fields = dataSource && dataSource.fields() || [];
                fields = fields.filter(function(field) {
                    return false !== field.visible && !(0, _type.isDefined)(field.groupIndex)
                });
                var treeItems = this._createTreeItems(fields, ["dimension", "displayFolder"]);
                (0, _uiPivot_grid.foreachDataLevel)(treeItems, function(items) {
                    items.sort(compareItems)
                }, 0, "items");
                return treeItems
            },
            _renderFieldsTreeView: function(container) {
                var that = this;
                var dataSource = that._dataSource;
                var treeView = that._createComponent(container, _tree_view.default, {
                    dataSource: that._createFieldsDataSource(dataSource),
                    showCheckBoxesMode: "normal",
                    expandNodesRecursive: false,
                    searchEnabled: that.option("allowSearch"),
                    searchTimeout: that.option("searchTimeout"),
                    itemTemplate: function(itemData, itemIndex, itemElement) {
                        if (itemData.icon) {
                            (0, _icon.getImageContainer)(itemData.icon).appendTo(itemElement)
                        }(0, _renderer.default)("<span>").toggleClass("dx-area-field", !itemData.items).data("field", itemData.field).text(itemData.text).appendTo(itemElement)
                    },
                    onItemCollapsed: function(e) {
                        var index = (0, _array.inArray)(e.itemData.path, that._expandedPaths);
                        if (index >= 0) {
                            that._expandedPaths.splice(index, 1)
                        }
                    },
                    onItemExpanded: function(e) {
                        var index = (0, _array.inArray)(e.itemData.path, that._expandedPaths);
                        if (index < 0) {
                            that._expandedPaths.push(e.itemData.path)
                        }
                    },
                    onItemSelectionChanged: function(e) {
                        var data = e.itemData;
                        var field;
                        var fields;
                        var needSelectDefaultItem = true;
                        var area;
                        if (data.items) {
                            if (data.selected) {
                                treeView.unselectItem(data);
                                return
                            }
                            that._processDemandState(function() {
                                fields = getDimensionFields(data, dataSource.fields());
                                for (var i = 0; i < fields.length; i++) {
                                    if (fields[i].area) {
                                        needSelectDefaultItem = false;
                                        break
                                    }
                                }
                            });
                            if (needSelectDefaultItem) {
                                var item = getFirstItem(data, function(item) {
                                    return item.isDefault
                                }) || getFirstItem(data, function(item) {
                                    return (0, _type.isDefined)(item.index)
                                });
                                item && treeView.selectItem(item);
                                return
                            }
                        } else {
                            field = dataSource.fields()[data.index];
                            if (data.selected) {
                                area = field.isMeasure ? "data" : "column"
                            }
                            if (field) {
                                fields = [field]
                            }
                        }
                        that._applyChanges(fields, {
                            area: area,
                            areaIndex: void 0
                        })
                    }
                });
                var dataChanged = function() {
                    var scrollable = getScrollable(container);
                    var scrollTop = scrollable ? scrollable.scrollTop() : 0;
                    treeView.option({
                        dataSource: that._createFieldsDataSource(dataSource)
                    });
                    scrollable = getScrollable(container);
                    if (scrollable) {
                        scrollable.scrollTo({
                            y: scrollTop
                        });
                        scrollable.update()
                    }
                };
                that._dataChangedHandlers.push(dataChanged)
            },
            _renderAreaFields: function($container, area) {
                var that = this;
                var dataSource = that._dataSource;
                var fields = dataSource ? (0, _extend.extend)(true, [], dataSource.getAreaFields(area, true)) : [];
                $container.empty();
                (0, _iterator.each)(fields, function(_, field) {
                    if (false !== field.visible) {
                        that.renderField(field, true).appendTo($container)
                    }
                })
            },
            _renderArea: function(container, area) {
                var that = this;
                var $areaContainer = (0, _renderer.default)(DIV).addClass("dx-area").appendTo(container);
                var $fieldsHeaderContainer = (0, _renderer.default)(DIV).addClass("dx-area-fields-header").appendTo($areaContainer);
                var caption = that.option("texts." + area + "Fields");
                var $fieldsContent;
                var render;
                (0, _renderer.default)("<span>").addClass("dx-area-icon").addClass("dx-area-icon-" + area).appendTo($fieldsHeaderContainer);
                (0, _renderer.default)("<span>").html("&nbsp;").appendTo($fieldsHeaderContainer);
                (0, _renderer.default)("<span>").addClass("dx-area-caption").text(caption).appendTo($fieldsHeaderContainer);
                var $fieldsContainer = (0, _renderer.default)(DIV).addClass("dx-area-fields").addClass(AREA_DRAG_CLASS).appendTo($areaContainer);
                if ("all" !== area) {
                    $fieldsContainer.attr("group", area).attr("allow-scrolling", true);
                    $fieldsContent = (0, _renderer.default)(DIV).addClass("dx-area-field-container").appendTo($fieldsContainer);
                    render = function() {
                        that._renderAreaFields($fieldsContent, area)
                    };
                    that._dataChangedHandlers.push(render);
                    render();
                    $fieldsContainer.dxScrollable()
                } else {
                    $areaContainer.addClass("dx-all-fields");
                    $fieldsContainer.addClass("dx-treeview-border-visible");
                    that._renderFieldsTreeView($fieldsContainer)
                }
            },
            _getSortableOptions: function() {
                return {}
            },
            _adjustSortableOnChangedArgs: function() {},
            resetTreeView: function() {
                var treeView = this.$element().find(".dx-treeview").dxTreeView("instance");
                if (treeView) {
                    treeView.option("searchValue", "");
                    treeView.collapseAll()
                }
            },
            applyChanges: function() {
                var state = this.option("state");
                if ((0, _type.isDefined)(state)) {
                    this._dataSource.state(state)
                }
            },
            cancelChanges: function() {
                var dataSource = this._dataSource;
                if (!dataSource.isLoading()) {
                    this.option("state", dataSource.state());
                    return true
                }
                return false
            },
            getDataSource: function() {
                return this._dataSource
            },
            updateDimensions: function() {
                var $scrollableElements = this.$element().find(".dx-area .dx-scrollable");
                $scrollableElements.dxScrollable("update")
            },
            _visibilityChanged: function(visible) {
                if (visible && hasWindow) {
                    this.updateDimensions()
                }
            }
        });
        (0, _component_registrator.default)("dxPivotGridFieldChooser", FieldChooser);
        var _default = FieldChooser;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/parseoptions.js ***!
      \*********************************************************/
    /*! exports provided: initializeOptions, parseOptions, buildTimeset */
    /*! exports used: buildTimeset, initializeOptions, parseOptions */
    function(module, __webpack_exports__, __webpack_require__) {
        __webpack_exports__.b = initializeOptions;
        __webpack_exports__.c = parseOptions;
        __webpack_exports__.a = buildTimeset;
        var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__( /*! tslib */ 120);
        var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__( /*! ./types */ 140);
        var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__( /*! ./helpers */ 63);
        var __WEBPACK_IMPORTED_MODULE_3__rrule__ = __webpack_require__( /*! ./rrule */ 119);
        var __WEBPACK_IMPORTED_MODULE_4__dateutil__ = __webpack_require__( /*! ./dateutil */ 62);
        var __WEBPACK_IMPORTED_MODULE_5__weekday__ = __webpack_require__( /*! ./weekday */ 159);
        var __WEBPACK_IMPORTED_MODULE_6__datetime__ = __webpack_require__( /*! ./datetime */ 296);

        function initializeOptions(options) {
            var invalid = [];
            var keys = Object.keys(options);
            for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                var key = keys_1[_i];
                if (!Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.c)(__WEBPACK_IMPORTED_MODULE_3__rrule__.d, key)) {
                    invalid.push(key)
                }
                if (__WEBPACK_IMPORTED_MODULE_4__dateutil__.b.isDate(options[key]) && !__WEBPACK_IMPORTED_MODULE_4__dateutil__.b.isValidDate(options[key])) {
                    invalid.push(key)
                }
            }
            if (invalid.length) {
                throw new Error("Invalid options: " + invalid.join(", "))
            }
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__.a)({}, options)
        }

        function parseOptions(options) {
            var opts = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__.a)(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__.a)({}, __WEBPACK_IMPORTED_MODULE_3__rrule__.a), initializeOptions(options));
            if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.f)(opts.byeaster)) {
                opts.freq = __WEBPACK_IMPORTED_MODULE_3__rrule__.c.YEARLY
            }
            if (!(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.f)(opts.freq) && __WEBPACK_IMPORTED_MODULE_3__rrule__.c.FREQUENCIES[opts.freq])) {
                throw new Error("Invalid frequency: " + opts.freq + " " + options.freq)
            }
            if (!opts.dtstart) {
                opts.dtstart = new Date((new Date).setMilliseconds(0))
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.f)(opts.wkst)) {
                opts.wkst = __WEBPACK_IMPORTED_MODULE_3__rrule__.c.MO.weekday
            } else {
                if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.e)(opts.wkst)) {} else {
                    opts.wkst = opts.wkst.weekday
                }
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.f)(opts.bysetpos)) {
                if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.e)(opts.bysetpos)) {
                    opts.bysetpos = [opts.bysetpos]
                }
                for (var i = 0; i < opts.bysetpos.length; i++) {
                    var v = opts.bysetpos[i];
                    if (0 === v || !(v >= -366 && v <= 366)) {
                        throw new Error("bysetpos must be between 1 and 366, or between -366 and -1")
                    }
                }
            }
            if (!(Boolean(opts.byweekno) || Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.h)(opts.byweekno) || Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.h)(opts.byyearday) || Boolean(opts.bymonthday) || Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.h)(opts.bymonthday) || Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.f)(opts.byweekday) || Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.f)(opts.byeaster))) {
                switch (opts.freq) {
                    case __WEBPACK_IMPORTED_MODULE_3__rrule__.c.YEARLY:
                        if (!opts.bymonth) {
                            opts.bymonth = opts.dtstart.getUTCMonth() + 1
                        }
                        opts.bymonthday = opts.dtstart.getUTCDate();
                        break;
                    case __WEBPACK_IMPORTED_MODULE_3__rrule__.c.MONTHLY:
                        opts.bymonthday = opts.dtstart.getUTCDate();
                        break;
                    case __WEBPACK_IMPORTED_MODULE_3__rrule__.c.WEEKLY:
                        opts.byweekday = [__WEBPACK_IMPORTED_MODULE_4__dateutil__.b.getWeekday(opts.dtstart)]
                }
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.f)(opts.bymonth) && !Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.d)(opts.bymonth)) {
                opts.bymonth = [opts.bymonth]
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.f)(opts.byyearday) && !Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.d)(opts.byyearday) && Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.e)(opts.byyearday)) {
                opts.byyearday = [opts.byyearday]
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.f)(opts.bymonthday)) {
                opts.bymonthday = [];
                opts.bynmonthday = []
            } else {
                if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.d)(opts.bymonthday)) {
                    var bymonthday = [];
                    var bynmonthday = [];
                    for (var i = 0; i < opts.bymonthday.length; i++) {
                        var v = opts.bymonthday[i];
                        if (v > 0) {
                            bymonthday.push(v)
                        } else {
                            if (v < 0) {
                                bynmonthday.push(v)
                            }
                        }
                    }
                    opts.bymonthday = bymonthday;
                    opts.bynmonthday = bynmonthday
                } else {
                    if (opts.bymonthday < 0) {
                        opts.bynmonthday = [opts.bymonthday];
                        opts.bymonthday = []
                    } else {
                        opts.bynmonthday = [];
                        opts.bymonthday = [opts.bymonthday]
                    }
                }
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.f)(opts.byweekno) && !Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.d)(opts.byweekno)) {
                opts.byweekno = [opts.byweekno]
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.f)(opts.byweekday)) {
                opts.bynweekday = null
            } else {
                if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.e)(opts.byweekday)) {
                    opts.byweekday = [opts.byweekday];
                    opts.bynweekday = null
                } else {
                    if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.g)(opts.byweekday)) {
                        opts.byweekday = [__WEBPACK_IMPORTED_MODULE_5__weekday__.b.fromStr(opts.byweekday).weekday];
                        opts.bynweekday = null
                    } else {
                        if (opts.byweekday instanceof __WEBPACK_IMPORTED_MODULE_5__weekday__.b) {
                            if (!opts.byweekday.n || opts.freq > __WEBPACK_IMPORTED_MODULE_3__rrule__.c.MONTHLY) {
                                opts.byweekday = [opts.byweekday.weekday];
                                opts.bynweekday = null
                            } else {
                                opts.bynweekday = [
                                    [opts.byweekday.weekday, opts.byweekday.n]
                                ];
                                opts.byweekday = null
                            }
                        } else {
                            var byweekday = [];
                            var bynweekday = [];
                            for (var i = 0; i < opts.byweekday.length; i++) {
                                var wday = opts.byweekday[i];
                                if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.e)(wday)) {
                                    byweekday.push(wday);
                                    continue
                                } else {
                                    if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.g)(wday)) {
                                        byweekday.push(__WEBPACK_IMPORTED_MODULE_5__weekday__.b.fromStr(wday).weekday);
                                        continue
                                    }
                                }
                                if (!wday.n || opts.freq > __WEBPACK_IMPORTED_MODULE_3__rrule__.c.MONTHLY) {
                                    byweekday.push(wday.weekday)
                                } else {
                                    bynweekday.push([wday.weekday, wday.n])
                                }
                            }
                            opts.byweekday = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.h)(byweekday) ? byweekday : null;
                            opts.bynweekday = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.h)(bynweekday) ? bynweekday : null
                        }
                    }
                }
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.f)(opts.byhour)) {
                opts.byhour = opts.freq < __WEBPACK_IMPORTED_MODULE_3__rrule__.c.HOURLY ? [opts.dtstart.getUTCHours()] : null
            } else {
                if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.e)(opts.byhour)) {
                    opts.byhour = [opts.byhour]
                }
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.f)(opts.byminute)) {
                opts.byminute = opts.freq < __WEBPACK_IMPORTED_MODULE_3__rrule__.c.MINUTELY ? [opts.dtstart.getUTCMinutes()] : null
            } else {
                if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.e)(opts.byminute)) {
                    opts.byminute = [opts.byminute]
                }
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.f)(opts.bysecond)) {
                opts.bysecond = opts.freq < __WEBPACK_IMPORTED_MODULE_3__rrule__.c.SECONDLY ? [opts.dtstart.getUTCSeconds()] : null
            } else {
                if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.e)(opts.bysecond)) {
                    opts.bysecond = [opts.bysecond]
                }
            }
            return {
                parsedOptions: opts
            }
        }

        function buildTimeset(opts) {
            var millisecondModulo = opts.dtstart.getTime() % 1e3;
            if (!Object(__WEBPACK_IMPORTED_MODULE_1__types__.b)(opts.freq)) {
                return []
            }
            var timeset = [];
            opts.byhour.forEach(function(hour) {
                opts.byminute.forEach(function(minute) {
                    opts.bysecond.forEach(function(second) {
                        timeset.push(new __WEBPACK_IMPORTED_MODULE_6__datetime__.b(hour, minute, second, millisecondModulo))
                    })
                })
            });
            return timeset
        }
    },
    /*!********************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/parsestring.js ***!
      \********************************************************/
    /*! exports provided: parseString, parseDtstart */
    /*! exports used: parseDtstart, parseString */
    function(module, __webpack_exports__, __webpack_require__) {
        __webpack_exports__.b = parseString;
        __webpack_exports__.a = parseDtstart;
        var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__( /*! tslib */ 120);
        var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__( /*! ./types */ 140);
        var __WEBPACK_IMPORTED_MODULE_2__weekday__ = __webpack_require__( /*! ./weekday */ 159);
        var __WEBPACK_IMPORTED_MODULE_3__dateutil__ = __webpack_require__( /*! ./dateutil */ 62);
        var __WEBPACK_IMPORTED_MODULE_4__rrule__ = __webpack_require__( /*! ./rrule */ 119);

        function parseString(rfcString) {
            var options = rfcString.split("\n").map(parseLine).filter(function(x) {
                return null !== x
            });
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__.a)(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__.a)({}, options[0]), options[1])
        }

        function parseDtstart(line) {
            var options = {};
            var dtstartWithZone = /DTSTART(?:;TZID=([^:=]+?))?(?::|=)([^;\s]+)/i.exec(line);
            if (!dtstartWithZone) {
                return options
            }
            var tzid = (dtstartWithZone[0], dtstartWithZone[1]),
                dtstart = dtstartWithZone[2];
            if (tzid) {
                options.tzid = tzid
            }
            options.dtstart = __WEBPACK_IMPORTED_MODULE_3__dateutil__.b.untilStringToDate(dtstart);
            return options
        }

        function parseLine(rfcString) {
            rfcString = rfcString.replace(/^\s+|\s+$/, "");
            if (!rfcString.length) {
                return null
            }
            var header = /^([A-Z]+?)[:;]/.exec(rfcString.toUpperCase());
            if (!header) {
                return parseRrule(rfcString)
            }
            var key = (header[0], header[1]);
            switch (key.toUpperCase()) {
                case "RRULE":
                case "EXRULE":
                    return parseRrule(rfcString);
                case "DTSTART":
                    return parseDtstart(rfcString);
                default:
                    throw new Error("Unsupported RFC prop " + key + " in " + rfcString)
            }
        }

        function parseRrule(line) {
            var strippedLine = line.replace(/^RRULE:/i, "");
            var options = parseDtstart(strippedLine);
            var attrs = line.replace(/^(?:RRULE|EXRULE):/i, "").split(";");
            attrs.forEach(function(attr) {
                var _a = attr.split("="),
                    key = _a[0],
                    value = _a[1];
                switch (key.toUpperCase()) {
                    case "FREQ":
                        options.freq = __WEBPACK_IMPORTED_MODULE_1__types__.a[value.toUpperCase()];
                        break;
                    case "WKST":
                        options.wkst = __WEBPACK_IMPORTED_MODULE_4__rrule__.b[value.toUpperCase()];
                        break;
                    case "COUNT":
                    case "INTERVAL":
                    case "BYSETPOS":
                    case "BYMONTH":
                    case "BYMONTHDAY":
                    case "BYYEARDAY":
                    case "BYWEEKNO":
                    case "BYHOUR":
                    case "BYMINUTE":
                    case "BYSECOND":
                        var num = parseNumber(value);
                        var optionKey = key.toLowerCase();
                        options[optionKey] = num;
                        break;
                    case "BYWEEKDAY":
                    case "BYDAY":
                        options.byweekday = parseWeekday(value);
                        break;
                    case "DTSTART":
                    case "TZID":
                        var dtstart = parseDtstart(line);
                        options.tzid = dtstart.tzid;
                        options.dtstart = dtstart.dtstart;
                        break;
                    case "UNTIL":
                        options.until = __WEBPACK_IMPORTED_MODULE_3__dateutil__.b.untilStringToDate(value);
                        break;
                    case "BYEASTER":
                        options.byeaster = Number(value);
                        break;
                    default:
                        throw new Error("Unknown RRULE property '" + key + "'")
                }
            });
            return options
        }

        function parseNumber(value) {
            if (value.indexOf(",") !== -1) {
                var values = value.split(",");
                return values.map(parseIndividualNumber)
            }
            return parseIndividualNumber(value)
        }

        function parseIndividualNumber(value) {
            if (/^[+-]?\d+$/.test(value)) {
                return Number(value)
            }
            return value
        }

        function parseWeekday(value) {
            var days = value.split(",");
            return days.map(function(day) {
                if (2 === day.length) {
                    return __WEBPACK_IMPORTED_MODULE_4__rrule__.b[day]
                }
                var parts = day.match(/^([+-]?\d{1,2})([A-Z]{2})$/);
                var n = Number(parts[1]);
                var wdaypart = parts[2];
                var wday = __WEBPACK_IMPORTED_MODULE_4__rrule__.b[wdaypart].weekday;
                return new __WEBPACK_IMPORTED_MODULE_2__weekday__.b(wday, n)
            })
        }
    },
    /*!************************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/optionstostring.js ***!
      \************************************************************/
    /*! exports provided: optionsToString */
    /*! exports used: optionsToString */
    function(module, __webpack_exports__, __webpack_require__) {
        __webpack_exports__.a = optionsToString;
        var __WEBPACK_IMPORTED_MODULE_0__rrule__ = __webpack_require__( /*! ./rrule */ 119);
        var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__( /*! ./helpers */ 63);
        var __WEBPACK_IMPORTED_MODULE_2__weekday__ = __webpack_require__( /*! ./weekday */ 159);
        var __WEBPACK_IMPORTED_MODULE_3__dateutil__ = __webpack_require__( /*! ./dateutil */ 62);
        var __WEBPACK_IMPORTED_MODULE_4__datewithzone__ = __webpack_require__( /*! ./datewithzone */ 297);

        function optionsToString(options) {
            var rrule = [];
            var dtstart = "";
            var keys = Object.keys(options);
            var defaultKeys = Object.keys(__WEBPACK_IMPORTED_MODULE_0__rrule__.a);
            for (var i = 0; i < keys.length; i++) {
                if ("tzid" === keys[i]) {
                    continue
                }
                if (!Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.c)(defaultKeys, keys[i])) {
                    continue
                }
                var key = keys[i].toUpperCase();
                var value = options[keys[i]];
                var outValue = "";
                if (!Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.f)(value) || Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.d)(value) && !value.length) {
                    continue
                }
                switch (key) {
                    case "FREQ":
                        outValue = __WEBPACK_IMPORTED_MODULE_0__rrule__.c.FREQUENCIES[options.freq];
                        break;
                    case "WKST":
                        if (Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.e)(value)) {
                            outValue = new __WEBPACK_IMPORTED_MODULE_2__weekday__.b(value).toString()
                        } else {
                            outValue = value.toString()
                        }
                        break;
                    case "BYWEEKDAY":
                        key = "BYDAY";
                        outValue = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.n)(value).map(function(wday) {
                            if (wday instanceof __WEBPACK_IMPORTED_MODULE_2__weekday__.b) {
                                return wday
                            }
                            if (Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.d)(wday)) {
                                return new __WEBPACK_IMPORTED_MODULE_2__weekday__.b(wday[0], wday[1])
                            }
                            return new __WEBPACK_IMPORTED_MODULE_2__weekday__.b(wday)
                        }).toString();
                        break;
                    case "DTSTART":
                        dtstart = buildDtstart(value, options.tzid);
                        break;
                    case "UNTIL":
                        outValue = __WEBPACK_IMPORTED_MODULE_3__dateutil__.b.timeToUntilString(value, !options.tzid);
                        break;
                    default:
                        if (Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.d)(value)) {
                            var strValues = [];
                            for (var j = 0; j < value.length; j++) {
                                strValues[j] = String(value[j])
                            }
                            outValue = strValues.toString()
                        } else {
                            outValue = String(value)
                        }
                }
                if (outValue) {
                    rrule.push([key, outValue])
                }
            }
            var rules = rrule.map(function(_a) {
                var key = _a[0],
                    value = _a[1];
                return key + "=" + value.toString()
            }).join(";");
            var ruleString = "";
            if ("" !== rules) {
                ruleString = "RRULE:" + rules
            }
            return [dtstart, ruleString].filter(function(x) {
                return !!x
            }).join("\n")
        }

        function buildDtstart(dtstart, tzid) {
            if (!dtstart) {
                return ""
            }
            return "DTSTART" + new __WEBPACK_IMPORTED_MODULE_4__datewithzone__.a(new Date(dtstart), tzid).toString()
        }
    },
    /*!*******************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/iter/index.js ***!
      \*******************************************************/
    /*! exports provided: iter */
    /*! exports used: iter */
    function(module, __webpack_exports__, __webpack_require__) {
        __webpack_exports__.a = iter;
        var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__( /*! ../types */ 140);
        var __WEBPACK_IMPORTED_MODULE_1__dateutil__ = __webpack_require__( /*! ../dateutil */ 62);
        var __WEBPACK_IMPORTED_MODULE_2__iterinfo_index__ = __webpack_require__( /*! ../iterinfo/index */ 793);
        var __WEBPACK_IMPORTED_MODULE_3__rrule__ = __webpack_require__( /*! ../rrule */ 119);
        var __WEBPACK_IMPORTED_MODULE_4__parseoptions__ = __webpack_require__( /*! ../parseoptions */ 428);
        var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__( /*! ../helpers */ 63);
        var __WEBPACK_IMPORTED_MODULE_6__datewithzone__ = __webpack_require__( /*! ../datewithzone */ 297);
        var __WEBPACK_IMPORTED_MODULE_7__poslist__ = __webpack_require__( /*! ./poslist */ 798);
        var __WEBPACK_IMPORTED_MODULE_8__datetime__ = __webpack_require__( /*! ../datetime */ 296);

        function iter(iterResult, options) {
            var dtstart = options.dtstart,
                freq = options.freq,
                interval = options.interval,
                until = options.until,
                bysetpos = options.bysetpos;
            var count = options.count;
            if (0 === count || 0 === interval) {
                return emitResult(iterResult)
            }
            var counterDate = __WEBPACK_IMPORTED_MODULE_8__datetime__.a.fromDate(dtstart);
            var ii = new __WEBPACK_IMPORTED_MODULE_2__iterinfo_index__.a(options);
            ii.rebuild(counterDate.year, counterDate.month);
            var timeset = makeTimeset(ii, counterDate, options);
            while (true) {
                var _a = ii.getdayset(freq)(counterDate.year, counterDate.month, counterDate.day),
                    dayset = _a[0],
                    start = _a[1],
                    end = _a[2];
                var filtered = removeFilteredDays(dayset, start, end, ii, options);
                if (Object(__WEBPACK_IMPORTED_MODULE_5__helpers__.h)(bysetpos)) {
                    var poslist = Object(__WEBPACK_IMPORTED_MODULE_7__poslist__.a)(bysetpos, timeset, start, end, ii, dayset);
                    for (var j = 0; j < poslist.length; j++) {
                        var res = poslist[j];
                        if (until && res > until) {
                            return emitResult(iterResult)
                        }
                        if (res >= dtstart) {
                            var rezonedDate = rezoneIfNeeded(res, options);
                            if (!iterResult.accept(rezonedDate)) {
                                return emitResult(iterResult)
                            }
                            if (count) {
                                --count;
                                if (!count) {
                                    return emitResult(iterResult)
                                }
                            }
                        }
                    }
                } else {
                    for (var j = start; j < end; j++) {
                        var currentDay = dayset[j];
                        if (!Object(__WEBPACK_IMPORTED_MODULE_5__helpers__.f)(currentDay)) {
                            continue
                        }
                        var date = __WEBPACK_IMPORTED_MODULE_1__dateutil__.b.fromOrdinal(ii.yearordinal + currentDay);
                        for (var k = 0; k < timeset.length; k++) {
                            var time = timeset[k];
                            var res = __WEBPACK_IMPORTED_MODULE_1__dateutil__.b.combine(date, time);
                            if (until && res > until) {
                                return emitResult(iterResult)
                            }
                            if (res >= dtstart) {
                                var rezonedDate = rezoneIfNeeded(res, options);
                                if (!iterResult.accept(rezonedDate)) {
                                    return emitResult(iterResult)
                                }
                                if (count) {
                                    --count;
                                    if (!count) {
                                        return emitResult(iterResult)
                                    }
                                }
                            }
                        }
                    }
                }
                if (0 === options.interval) {
                    return emitResult(iterResult)
                }
                counterDate.add(options, filtered);
                if (counterDate.year > __WEBPACK_IMPORTED_MODULE_1__dateutil__.b.MAXYEAR) {
                    return emitResult(iterResult)
                }
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__types__.b)(freq)) {
                    timeset = ii.gettimeset(freq)(counterDate.hour, counterDate.minute, counterDate.second, 0)
                }
                ii.rebuild(counterDate.year, counterDate.month)
            }
        }

        function isFiltered(ii, currentDay, options) {
            var bymonth = options.bymonth,
                byweekno = options.byweekno,
                byweekday = options.byweekday,
                byeaster = options.byeaster,
                bymonthday = options.bymonthday,
                bynmonthday = options.bynmonthday,
                byyearday = options.byyearday;
            return Object(__WEBPACK_IMPORTED_MODULE_5__helpers__.h)(bymonth) && !Object(__WEBPACK_IMPORTED_MODULE_5__helpers__.c)(bymonth, ii.mmask[currentDay]) || Object(__WEBPACK_IMPORTED_MODULE_5__helpers__.h)(byweekno) && !ii.wnomask[currentDay] || Object(__WEBPACK_IMPORTED_MODULE_5__helpers__.h)(byweekday) && !Object(__WEBPACK_IMPORTED_MODULE_5__helpers__.c)(byweekday, ii.wdaymask[currentDay]) || Object(__WEBPACK_IMPORTED_MODULE_5__helpers__.h)(ii.nwdaymask) && !ii.nwdaymask[currentDay] || null !== byeaster && !Object(__WEBPACK_IMPORTED_MODULE_5__helpers__.c)(ii.eastermask, currentDay) || (Object(__WEBPACK_IMPORTED_MODULE_5__helpers__.h)(bymonthday) || Object(__WEBPACK_IMPORTED_MODULE_5__helpers__.h)(bynmonthday)) && !Object(__WEBPACK_IMPORTED_MODULE_5__helpers__.c)(bymonthday, ii.mdaymask[currentDay]) && !Object(__WEBPACK_IMPORTED_MODULE_5__helpers__.c)(bynmonthday, ii.nmdaymask[currentDay]) || Object(__WEBPACK_IMPORTED_MODULE_5__helpers__.h)(byyearday) && (currentDay < ii.yearlen && !Object(__WEBPACK_IMPORTED_MODULE_5__helpers__.c)(byyearday, currentDay + 1) && !Object(__WEBPACK_IMPORTED_MODULE_5__helpers__.c)(byyearday, -ii.yearlen + currentDay) || currentDay >= ii.yearlen && !Object(__WEBPACK_IMPORTED_MODULE_5__helpers__.c)(byyearday, currentDay + 1 - ii.yearlen) && !Object(__WEBPACK_IMPORTED_MODULE_5__helpers__.c)(byyearday, -ii.nextyearlen + currentDay - ii.yearlen))
        }

        function rezoneIfNeeded(date, options) {
            return new __WEBPACK_IMPORTED_MODULE_6__datewithzone__.a(date, options.tzid).rezonedDate()
        }

        function emitResult(iterResult) {
            return iterResult.getValue()
        }

        function removeFilteredDays(dayset, start, end, ii, options) {
            var filtered = false;
            for (var dayCounter = start; dayCounter < end; dayCounter++) {
                var currentDay = dayset[dayCounter];
                filtered = isFiltered(ii, currentDay, options);
                if (filtered) {
                    dayset[currentDay] = null
                }
            }
            return filtered
        }

        function makeTimeset(ii, counterDate, options) {
            var freq = options.freq,
                byhour = options.byhour,
                byminute = options.byminute,
                bysecond = options.bysecond;
            if (Object(__WEBPACK_IMPORTED_MODULE_0__types__.b)(freq)) {
                return Object(__WEBPACK_IMPORTED_MODULE_4__parseoptions__.a)(options)
            }
            if (freq >= __WEBPACK_IMPORTED_MODULE_3__rrule__.c.HOURLY && Object(__WEBPACK_IMPORTED_MODULE_5__helpers__.h)(byhour) && !Object(__WEBPACK_IMPORTED_MODULE_5__helpers__.c)(byhour, counterDate.hour) || freq >= __WEBPACK_IMPORTED_MODULE_3__rrule__.c.MINUTELY && Object(__WEBPACK_IMPORTED_MODULE_5__helpers__.h)(byminute) && !Object(__WEBPACK_IMPORTED_MODULE_5__helpers__.c)(byminute, counterDate.minute) || freq >= __WEBPACK_IMPORTED_MODULE_3__rrule__.c.SECONDLY && Object(__WEBPACK_IMPORTED_MODULE_5__helpers__.h)(bysecond) && !Object(__WEBPACK_IMPORTED_MODULE_5__helpers__.c)(bysecond, counterDate.second)) {
                return []
            }
            return ii.gettimeset(freq)(counterDate.hour, counterDate.minute, counterDate.second, counterDate.millisecond)
        }
    },
    /*!*****************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/rruleset.js ***!
      \*****************************************************/
    /*! exports provided: default */
    /*! exports used: default */
    function(module, __webpack_exports__, __webpack_require__) {
        var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__( /*! tslib */ 120);
        var __WEBPACK_IMPORTED_MODULE_1__rrule__ = __webpack_require__( /*! ./rrule */ 119);
        var __WEBPACK_IMPORTED_MODULE_2__dateutil__ = __webpack_require__( /*! ./dateutil */ 62);
        var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__( /*! ./helpers */ 63);
        var __WEBPACK_IMPORTED_MODULE_4__iterset__ = __webpack_require__( /*! ./iterset */ 802);
        var __WEBPACK_IMPORTED_MODULE_5__rrulestr__ = __webpack_require__( /*! ./rrulestr */ 433);
        var __WEBPACK_IMPORTED_MODULE_6__optionstostring__ = __webpack_require__( /*! ./optionstostring */ 430);

        function createGetterSetter(fieldName) {
            var _this = this;
            return function(field) {
                if (void 0 !== field) {
                    _this["_" + fieldName] = field
                }
                if (void 0 !== _this["_" + fieldName]) {
                    return _this["_" + fieldName]
                }
                for (var i = 0; i < _this._rrule.length; i++) {
                    var field_1 = _this._rrule[i].origOptions[fieldName];
                    if (field_1) {
                        return field_1
                    }
                }
            }
        }
        var RRuleSet = function(_super) {
            Object(__WEBPACK_IMPORTED_MODULE_0_tslib__.b)(RRuleSet, _super);

            function RRuleSet(noCache) {
                if (void 0 === noCache) {
                    noCache = false
                }
                var _this = _super.call(this, {}, noCache) || this;
                _this.dtstart = createGetterSetter.apply(_this, ["dtstart"]);
                _this.tzid = createGetterSetter.apply(_this, ["tzid"]);
                _this._rrule = [];
                _this._rdate = [];
                _this._exrule = [];
                _this._exdate = [];
                return _this
            }
            RRuleSet.prototype._iter = function(iterResult) {
                return Object(__WEBPACK_IMPORTED_MODULE_4__iterset__.a)(iterResult, this._rrule, this._exrule, this._rdate, this._exdate, this.tzid())
            };
            RRuleSet.prototype.rrule = function(rrule) {
                _addRule(rrule, this._rrule)
            };
            RRuleSet.prototype.exrule = function(rrule) {
                _addRule(rrule, this._exrule)
            };
            RRuleSet.prototype.rdate = function(date) {
                _addDate(date, this._rdate)
            };
            RRuleSet.prototype.exdate = function(date) {
                _addDate(date, this._exdate)
            };
            RRuleSet.prototype.rrules = function() {
                return this._rrule.map(function(e) {
                    return Object(__WEBPACK_IMPORTED_MODULE_5__rrulestr__.a)(e.toString())
                })
            };
            RRuleSet.prototype.exrules = function() {
                return this._exrule.map(function(e) {
                    return Object(__WEBPACK_IMPORTED_MODULE_5__rrulestr__.a)(e.toString())
                })
            };
            RRuleSet.prototype.rdates = function() {
                return this._rdate.map(function(e) {
                    return new Date(e.getTime())
                })
            };
            RRuleSet.prototype.exdates = function() {
                return this._exdate.map(function(e) {
                    return new Date(e.getTime())
                })
            };
            RRuleSet.prototype.valueOf = function() {
                var result = [];
                if (!this._rrule.length && this._dtstart) {
                    result = result.concat(Object(__WEBPACK_IMPORTED_MODULE_6__optionstostring__.a)({
                        dtstart: this._dtstart
                    }))
                }
                this._rrule.forEach(function(rrule) {
                    result = result.concat(rrule.toString().split("\n"))
                });
                this._exrule.forEach(function(exrule) {
                    result = result.concat(exrule.toString().split("\n").map(function(line) {
                        return line.replace(/^RRULE:/, "EXRULE:")
                    }).filter(function(line) {
                        return !/^DTSTART/.test(line)
                    }))
                });
                if (this._rdate.length) {
                    result.push(rdatesToString("RDATE", this._rdate, this.tzid()))
                }
                if (this._exdate.length) {
                    result.push(rdatesToString("EXDATE", this._exdate, this.tzid()))
                }
                return result
            };
            RRuleSet.prototype.toString = function() {
                return this.valueOf().join("\n")
            };
            RRuleSet.prototype.clone = function() {
                var rrs = new RRuleSet((!!this._cache));
                this._rrule.forEach(function(rule) {
                    return rrs.rrule(rule.clone())
                });
                this._exrule.forEach(function(rule) {
                    return rrs.exrule(rule.clone())
                });
                this._rdate.forEach(function(date) {
                    return rrs.rdate(new Date(date.getTime()))
                });
                this._exdate.forEach(function(date) {
                    return rrs.exdate(new Date(date.getTime()))
                });
                return rrs
            };
            return RRuleSet
        }(__WEBPACK_IMPORTED_MODULE_1__rrule__.c);
        __webpack_exports__.a = RRuleSet;

        function _addRule(rrule, collection) {
            if (!(rrule instanceof __WEBPACK_IMPORTED_MODULE_1__rrule__.c)) {
                throw new TypeError(String(rrule) + " is not RRule instance")
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_3__helpers__.c)(collection.map(String), String(rrule))) {
                collection.push(rrule)
            }
        }

        function _addDate(date, collection) {
            if (!(date instanceof Date)) {
                throw new TypeError(String(date) + " is not Date instance")
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_3__helpers__.c)(collection.map(Number), Number(date))) {
                collection.push(date);
                __WEBPACK_IMPORTED_MODULE_2__dateutil__.b.sort(collection)
            }
        }

        function rdatesToString(param, rdates, tzid) {
            var isUTC = !tzid || "UTC" === tzid.toUpperCase();
            var header = isUTC ? param + ":" : param + ";TZID=" + tzid + ":";
            var dateString = rdates.map(function(rdate) {
                return __WEBPACK_IMPORTED_MODULE_2__dateutil__.b.timeToUntilString(rdate.valueOf(), isUTC)
            }).join(",");
            return "" + header + dateString
        }
    },
    /*!*****************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/rrulestr.js ***!
      \*****************************************************/
    /*! exports provided: parseInput, rrulestr */
    /*! exports used: rrulestr */
    function(module, __webpack_exports__, __webpack_require__) {
        __webpack_exports__.a = rrulestr;
        var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__( /*! tslib */ 120);
        var __WEBPACK_IMPORTED_MODULE_1__rrule__ = __webpack_require__( /*! ./rrule */ 119);
        var __WEBPACK_IMPORTED_MODULE_2__rruleset__ = __webpack_require__( /*! ./rruleset */ 432);
        var __WEBPACK_IMPORTED_MODULE_3__dateutil__ = __webpack_require__( /*! ./dateutil */ 62);
        var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__( /*! ./helpers */ 63);
        var __WEBPACK_IMPORTED_MODULE_5__parsestring__ = __webpack_require__( /*! ./parsestring */ 429);
        var DEFAULT_OPTIONS = {
            dtstart: null,
            cache: false,
            unfold: false,
            forceset: false,
            compatible: false,
            tzid: null
        };

        function parseInput(s, options) {
            var rrulevals = [];
            var rdatevals = [];
            var exrulevals = [];
            var exdatevals = [];
            var _a = Object(__WEBPACK_IMPORTED_MODULE_5__parsestring__.a)(s),
                dtstart = _a.dtstart,
                tzid = _a.tzid;
            var lines = splitIntoLines(s, options.unfold);
            lines.forEach(function(line) {
                if (!line) {
                    return
                }
                var _a = breakDownLine(line),
                    name = _a.name,
                    parms = _a.parms,
                    value = _a.value;
                switch (name.toUpperCase()) {
                    case "RRULE":
                        if (parms.length) {
                            throw new Error("unsupported RRULE parm: " + parms.join(","))
                        }
                        rrulevals.push(Object(__WEBPACK_IMPORTED_MODULE_5__parsestring__.b)(line));
                        break;
                    case "RDATE":
                        var _b = /RDATE(?:;TZID=([^:=]+))?/i.exec(line),
                            rdateTzid = (_b[0], _b[1]);
                        if (rdateTzid && !tzid) {
                            tzid = rdateTzid
                        }
                        rdatevals = rdatevals.concat(parseRDate(value, parms));
                        break;
                    case "EXRULE":
                        if (parms.length) {
                            throw new Error("unsupported EXRULE parm: " + parms.join(","))
                        }
                        exrulevals.push(Object(__WEBPACK_IMPORTED_MODULE_5__parsestring__.b)(value));
                        break;
                    case "EXDATE":
                        exdatevals = exdatevals.concat(parseRDate(value, parms));
                        break;
                    case "DTSTART":
                        break;
                    default:
                        throw new Error("unsupported property: " + name)
                }
            });
            return {
                dtstart: dtstart,
                tzid: tzid,
                rrulevals: rrulevals,
                rdatevals: rdatevals,
                exrulevals: exrulevals,
                exdatevals: exdatevals
            }
        }

        function buildRule(s, options) {
            var _a = parseInput(s, options),
                rrulevals = _a.rrulevals,
                rdatevals = _a.rdatevals,
                exrulevals = _a.exrulevals,
                exdatevals = _a.exdatevals,
                dtstart = _a.dtstart,
                tzid = _a.tzid;
            var noCache = false === options.cache;
            if (options.compatible) {
                options.forceset = true;
                options.unfold = true
            }
            if (options.forceset || rrulevals.length > 1 || rdatevals.length || exrulevals.length || exdatevals.length) {
                var rset_1 = new __WEBPACK_IMPORTED_MODULE_2__rruleset__.a(noCache);
                rset_1.dtstart(dtstart);
                rset_1.tzid(tzid || void 0);
                rrulevals.forEach(function(val) {
                    rset_1.rrule(new __WEBPACK_IMPORTED_MODULE_1__rrule__.c(groomRruleOptions(val, dtstart, tzid), noCache))
                });
                rdatevals.forEach(function(date) {
                    rset_1.rdate(date)
                });
                exrulevals.forEach(function(val) {
                    rset_1.exrule(new __WEBPACK_IMPORTED_MODULE_1__rrule__.c(groomRruleOptions(val, dtstart, tzid), noCache))
                });
                exdatevals.forEach(function(date) {
                    rset_1.exdate(date)
                });
                if (options.compatible && options.dtstart) {
                    rset_1.rdate(dtstart)
                }
                return rset_1
            }
            var val = rrulevals[0] || {};
            return new __WEBPACK_IMPORTED_MODULE_1__rrule__.c(groomRruleOptions(val, val.dtstart || options.dtstart || dtstart, val.tzid || options.tzid || tzid), noCache)
        }

        function rrulestr(s, options) {
            if (void 0 === options) {
                options = {}
            }
            return buildRule(s, initializeOptions(options))
        }

        function groomRruleOptions(val, dtstart, tzid) {
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__.a)(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__.a)({}, val), {
                dtstart: dtstart,
                tzid: tzid
            })
        }

        function initializeOptions(options) {
            var invalid = [];
            var keys = Object.keys(options);
            var defaultKeys = Object.keys(DEFAULT_OPTIONS);
            keys.forEach(function(key) {
                if (!Object(__WEBPACK_IMPORTED_MODULE_4__helpers__.c)(defaultKeys, key)) {
                    invalid.push(key)
                }
            });
            if (invalid.length) {
                throw new Error("Invalid options: " + invalid.join(", "))
            }
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__.a)(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__.a)({}, DEFAULT_OPTIONS), options)
        }

        function extractName(line) {
            if (line.indexOf(":") === -1) {
                return {
                    name: "RRULE",
                    value: line
                }
            }
            var _a = Object(__WEBPACK_IMPORTED_MODULE_4__helpers__.m)(line, ":", 1),
                name = _a[0],
                value = _a[1];
            return {
                name: name,
                value: value
            }
        }

        function breakDownLine(line) {
            var _a = extractName(line),
                name = _a.name,
                value = _a.value;
            var parms = name.split(";");
            if (!parms) {
                throw new Error("empty property name")
            }
            return {
                name: parms[0].toUpperCase(),
                parms: parms.slice(1),
                value: value
            }
        }

        function splitIntoLines(s, unfold) {
            if (void 0 === unfold) {
                unfold = false
            }
            s = s && s.trim();
            if (!s) {
                throw new Error("Invalid empty string")
            }
            if (!unfold) {
                return s.split(/\s/)
            }
            var lines = s.split("\n");
            var i = 0;
            while (i < lines.length) {
                var line = lines[i] = lines[i].replace(/\s+$/g, "");
                if (!line) {
                    lines.splice(i, 1)
                } else {
                    if (i > 0 && " " === line[0]) {
                        lines[i - 1] += line.slice(1);
                        lines.splice(i, 1)
                    } else {
                        i += 1
                    }
                }
            }
            return lines
        }

        function validateDateParm(parms) {
            parms.forEach(function(parm) {
                if (!/(VALUE=DATE(-TIME)?)|(TZID=)/.test(parm)) {
                    throw new Error("unsupported RDATE/EXDATE parm: " + parm)
                }
            })
        }

        function parseRDate(rdateval, parms) {
            validateDateParm(parms);
            return rdateval.split(",").map(function(datestr) {
                return __WEBPACK_IMPORTED_MODULE_3__dateutil__.b.untilStringToDate(datestr)
            })
        }
    },
    /*!*************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/ui.loading.js ***!
      \*************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.show = show;
        exports.hide = hide;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _view_port = __webpack_require__( /*! ../../core/utils/view_port */ 80);
        var _load_panel = _interopRequireDefault(__webpack_require__( /*! ../load_panel */ 180));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var loading = null;
        var createLoadPanel = function(options) {
            return new _load_panel.default((0, _renderer.default)("<div>").appendTo(options && options.container || (0, _view_port.value)()), options)
        };
        var removeLoadPanel = function() {
            if (!loading) {
                return
            }
            loading.$element().remove();
            loading = null
        };

        function show(options) {
            removeLoadPanel();
            loading = createLoadPanel(options);
            return loading.show()
        }

        function hide() {
            if (!loading) {
                return (new _deferred.Deferred).resolve()
            }
            return loading.hide().done(removeLoadPanel).promise()
        }
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/dataStructures.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.AppointmentTooltipInfo = void 0;
        var AppointmentTooltipInfo = function(appointment) {
            var targetedAppointment = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
            var color = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
            var settings = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : [];
            this.appointment = appointment;
            this.targetedAppointment = targetedAppointment;
            this.color = color;
            this.settings = settings
        };
        exports.AppointmentTooltipInfo = AppointmentTooltipInfo
    },
    /*!*****************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/tooltip_strategies/tooltipStrategyBase.js ***!
      \*****************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.TooltipStrategyBase = void 0;
        var _button = _interopRequireDefault(__webpack_require__( /*! ../../button */ 37));
        var _function_template = __webpack_require__( /*! ../../../core/templates/function_template */ 126);
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../../core/renderer */ 2));
        var _uiList = _interopRequireDefault(__webpack_require__( /*! ../../list/ui.list.edit */ 345));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }
        var TOOLTIP_APPOINTMENT_ITEM = "dx-tooltip-appointment-item";
        var TOOLTIP_APPOINTMENT_ITEM_CONTENT = TOOLTIP_APPOINTMENT_ITEM + "-content";
        var TOOLTIP_APPOINTMENT_ITEM_CONTENT_SUBJECT = TOOLTIP_APPOINTMENT_ITEM + "-content-subject";
        var TOOLTIP_APPOINTMENT_ITEM_CONTENT_DATE = TOOLTIP_APPOINTMENT_ITEM + "-content-date";
        var TOOLTIP_APPOINTMENT_ITEM_MARKER = TOOLTIP_APPOINTMENT_ITEM + "-marker";
        var TOOLTIP_APPOINTMENT_ITEM_MARKER_BODY = TOOLTIP_APPOINTMENT_ITEM + "-marker-body";
        var TOOLTIP_APPOINTMENT_ITEM_DELETE_BUTTON_CONTAINER = TOOLTIP_APPOINTMENT_ITEM + "-delete-button-container";
        var TOOLTIP_APPOINTMENT_ITEM_DELETE_BUTTON = TOOLTIP_APPOINTMENT_ITEM + "-delete-button";
        var TooltipStrategyBase = function() {
            function TooltipStrategyBase(options) {
                this._tooltip = null;
                this._options = options;
                this._extraOptions = null
            }
            var _proto = TooltipStrategyBase.prototype;
            _proto.show = function(target, dataList, extraOptions) {
                if (this._canShowTooltip(dataList)) {
                    this.hide();
                    this._extraOptions = extraOptions;
                    this._showCore(target, dataList)
                }
            };
            _proto._showCore = function(target, dataList) {
                if (!this._tooltip) {
                    this._tooltip = this._createTooltip(target, dataList)
                } else {
                    this._shouldUseTarget() && this._tooltip.option("target", target);
                    this._list.option("dataSource", dataList)
                }
                this._prepareBeforeVisibleChanged(dataList);
                this._tooltip.option("visible", true)
            };
            _proto._prepareBeforeVisibleChanged = function(dataList) {};
            _proto._getContentTemplate = function(dataList) {
                var _this = this;
                return function(container) {
                    var listElement = (0, _renderer.default)("<div>");
                    (0, _renderer.default)(container).append(listElement);
                    _this._list = _this._createList(listElement, dataList)
                }
            };
            _proto.isAlreadyShown = function(target) {
                if (this._tooltip && this._tooltip.option("visible")) {
                    return this._tooltip.option("target")[0] === target[0]
                }
            };
            _proto._onShown = function() {
                this._list.option("focusStateEnabled", this._extraOptions.focusStateEnabled)
            };
            _proto.dispose = function() {};
            _proto.hide = function() {
                if (this._tooltip) {
                    this._tooltip.option("visible", false)
                }
            };
            _proto._shouldUseTarget = function() {
                return true
            };
            _proto._createTooltip = function() {};
            _proto._canShowTooltip = function(dataList) {
                if (!dataList.length) {
                    return false
                }
                return true
            };
            _proto._createListOption = function(dataList) {
                var _this2 = this;
                return {
                    dataSource: dataList,
                    onContentReady: this._onListRender.bind(this),
                    onItemClick: function(e) {
                        return _this2._onListItemClick(e)
                    },
                    itemTemplate: function(item, index) {
                        return _this2._renderTemplate(item.appointment, item.targetedAppointment, index, item.color)
                    },
                    _swipeEnabled: false
                }
            };
            _proto._onListRender = function() {};
            _proto._createTooltipElement = function(wrapperClass) {
                return (0, _renderer.default)("<div>").appendTo(this._options.container).addClass(wrapperClass)
            };
            _proto._createList = function(listElement, dataList) {
                return this._options.createComponent(listElement, _uiList.default, this._createListOption(dataList))
            };
            _proto._renderTemplate = function(appointment, targetedAppointment, index, color) {
                var itemListContent = this._createItemListContent(appointment, targetedAppointment, color);
                this._options.addDefaultTemplates(_defineProperty({}, this._getItemListTemplateName(), new _function_template.FunctionTemplate(function(options) {
                    var $container = (0, _renderer.default)(options.container);
                    $container.append(itemListContent);
                    return $container
                })));
                var template = this._options.getAppointmentTemplate(this._getItemListTemplateName() + "Template");
                return this._createFunctionTemplate(template, appointment, targetedAppointment, index)
            };
            _proto._createFunctionTemplate = function(template, data, targetData, index) {
                var isEmptyDropDownAppointmentTemplate = this._isEmptyDropDownAppointmentTemplate();
                return new _function_template.FunctionTemplate(function(options) {
                    return template.render({
                        model: isEmptyDropDownAppointmentTemplate ? {
                            appointmentData: data,
                            targetedAppointmentData: targetData
                        } : data,
                        container: options.container,
                        index: index
                    })
                })
            };
            _proto._getItemListTemplateName = function() {
                return this._isEmptyDropDownAppointmentTemplate() ? "appointmentTooltip" : "dropDownAppointment"
            };
            _proto._isEmptyDropDownAppointmentTemplate = function() {
                return !this._extraOptions.dropDownAppointmentTemplate || "dropDownAppointment" === this._extraOptions.dropDownAppointmentTemplate
            };
            _proto._onListItemClick = function(e) {
                this.hide();
                this._extraOptions.clickEvent && this._extraOptions.clickEvent(e);
                this._options.showAppointmentPopup(e.itemData.appointment, false, e.itemData.targetedAppointment)
            };
            _proto._createItemListContent = function(appointment, targetedAppointment, color) {
                var editing = this._extraOptions.editing;
                var $itemElement = (0, _renderer.default)("<div>").addClass(TOOLTIP_APPOINTMENT_ITEM);
                $itemElement.append(this._createItemListMarker(color));
                $itemElement.append(this._createItemListInfo(this._options.createFormattedDateText(appointment, targetedAppointment)));
                var disabled = this._options.getAppointmentDisabled(appointment);
                if (!disabled && (editing && true === editing.allowDeleting || true === editing)) {
                    $itemElement.append(this._createDeleteButton(appointment, targetedAppointment))
                }
                return $itemElement
            };
            _proto._createItemListMarker = function(color) {
                var $marker = (0, _renderer.default)("<div>").addClass(TOOLTIP_APPOINTMENT_ITEM_MARKER);
                var $markerBody = (0, _renderer.default)("<div>").addClass(TOOLTIP_APPOINTMENT_ITEM_MARKER_BODY);
                $marker.append($markerBody);
                color && color.done(function(value) {
                    return $markerBody.css("background", value)
                });
                return $marker
            };
            _proto._createItemListInfo = function(object) {
                var result = (0, _renderer.default)("<div>").addClass(TOOLTIP_APPOINTMENT_ITEM_CONTENT);
                var $title = (0, _renderer.default)("<div>").addClass(TOOLTIP_APPOINTMENT_ITEM_CONTENT_SUBJECT).text(object.text);
                var $date = (0, _renderer.default)("<div>").addClass(TOOLTIP_APPOINTMENT_ITEM_CONTENT_DATE).text(object.formatDate);
                return result.append($title).append($date)
            };
            _proto._createDeleteButton = function(appointment, targetedAppointment) {
                var _this3 = this;
                var $container = (0, _renderer.default)("<div>").addClass(TOOLTIP_APPOINTMENT_ITEM_DELETE_BUTTON_CONTAINER);
                var $deleteButton = (0, _renderer.default)("<div>").addClass(TOOLTIP_APPOINTMENT_ITEM_DELETE_BUTTON);
                $container.append($deleteButton);
                this._options.createComponent($deleteButton, _button.default, {
                    icon: "trash",
                    stylingMode: "text",
                    onClick: function(e) {
                        _this3.hide();
                        e.event.stopPropagation();
                        _this3._options.checkAndDeleteAppointment(appointment, targetedAppointment)
                    }
                });
                return $container
            };
            return TooltipStrategyBase
        }();
        exports.TooltipStrategyBase = TooltipStrategyBase
    },
    /*!**************************************************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/rendering_strategies/ui.scheduler.appointmentsPositioning.strategy.base.js ***!
      \**************************************************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _type = __webpack_require__( /*! ../../../core/utils/type */ 1);
        var COLLECTOR_DEFAULT_WIDTH = 24;
        var COLLECTOR_DEFAULT_OFFSET = 3;
        var COMPACT_THEME_APPOINTMENT_DEFAULT_OFFSET = 22;
        var APPOINTMENT_MIN_COUNT = 1;
        var APPOINTMENT_DEFAULT_WIDTH = 40;
        var COLLECTOR_WIDTH_IN_PERCENTS = 75;
        var APPOINTMENT_INCREASED_WIDTH = 50;
        var AppointmentPositioningStrategy = function() {
            function AppointmentPositioningStrategy(renderingStrategy) {
                this._renderingStrategy = renderingStrategy
            }
            var _proto = AppointmentPositioningStrategy.prototype;
            _proto.getRenderingStrategy = function() {
                return this._renderingStrategy
            };
            _proto.getDropDownAppointmentWidth = function(intervalCount, isAllDay) {
                if (isAllDay || !(0, _type.isDefined)(isAllDay)) {
                    return COLLECTOR_WIDTH_IN_PERCENTS * this.getRenderingStrategy().getDefaultCellWidth() / 100
                } else {
                    return COLLECTOR_DEFAULT_WIDTH
                }
            };
            _proto.getCollectorTopOffset = function() {
                return COLLECTOR_DEFAULT_OFFSET
            };
            _proto.getCollectorLeftOffset = function() {
                return COLLECTOR_DEFAULT_OFFSET
            };
            _proto.getAppointmentDefaultOffset = function() {
                if (this.getRenderingStrategy()._isCompactTheme()) {
                    return COMPACT_THEME_APPOINTMENT_DEFAULT_OFFSET
                }
                return this.getRenderingStrategy().instance.option("_appointmentOffset")
            };
            _proto.getDynamicAppointmentCountPerCell = function() {
                var renderingStrategy = this.getRenderingStrategy();
                var cellHeight = renderingStrategy.instance.fire("getCellHeight");
                var allDayCount = Math.floor((cellHeight - renderingStrategy._getAppointmentDefaultOffset()) / renderingStrategy._getAppointmentDefaultHeight()) || this._getAppointmentMinCount();
                if (renderingStrategy.hasAllDayAppointments()) {
                    return {
                        allDay: "vertical" === renderingStrategy.instance._groupOrientation ? allDayCount : renderingStrategy.instance.option("_appointmentCountPerCell"),
                        simple: this._calculateDynamicAppointmentCountPerCell() || this._getAppointmentMinCount()
                    }
                } else {
                    return allDayCount
                }
            };
            _proto.getDropDownAppointmentHeight = function() {
                return
            };
            _proto._getAppointmentMinCount = function() {
                return APPOINTMENT_MIN_COUNT
            };
            _proto._calculateDynamicAppointmentCountPerCell = function() {
                return Math.floor(this.getRenderingStrategy()._getAppointmentMaxWidth() / APPOINTMENT_INCREASED_WIDTH)
            };
            _proto._getAppointmentDefaultWidth = function() {
                return APPOINTMENT_DEFAULT_WIDTH
            };
            return AppointmentPositioningStrategy
        }();
        var _default = AppointmentPositioningStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/rendering_strategies/ui.scheduler.appointments.strategy.horizontal.js ***!
      \*********************************************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiSchedulerAppointmentsStrategy = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.appointments.strategy.base */ 299));
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../../core/utils/date */ 19));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var DEFAULT_APPOINTMENT_HEIGHT = 60;
        var MIN_APPOINTMENT_HEIGHT = 35;
        var DROP_DOWN_BUTTON_OFFSET = 2;
        var toMs = _date.default.dateToMilliseconds;
        var HorizontalRenderingStrategy = function(_BaseAppointmentsStra) {
            _inheritsLoose(HorizontalRenderingStrategy, _BaseAppointmentsStra);

            function HorizontalRenderingStrategy() {
                return _BaseAppointmentsStra.apply(this, arguments) || this
            }
            var _proto = HorizontalRenderingStrategy.prototype;
            _proto._needVerifyItemSize = function() {
                return true
            };
            _proto.calculateAppointmentWidth = function(appointment, position) {
                var cellWidth = this.getDefaultCellWidth() || this.getAppointmentMinSize();
                var allDay = this.instance.fire("getField", "allDay", appointment);
                var startDate = position.info.appointment.startDate;
                var endDate = this.normalizeEndDateByViewEnd(appointment, position.info.appointment.endDate);
                var appointmentDuration = this._getAppointmentDurationInMs(startDate, endDate, allDay);
                appointmentDuration = this._adjustDurationByDaylightDiff(appointmentDuration, startDate, endDate);
                var cellDuration = this.instance.getAppointmentDurationInMinutes() * toMs("minute");
                var durationInCells = appointmentDuration / cellDuration;
                var width = this.cropAppointmentWidth(durationInCells * cellWidth, cellWidth);
                return width
            };
            _proto._needAdjustDuration = function(diff) {
                return diff < 0
            };
            _proto.getAppointmentGeometry = function(coordinates) {
                var result = this._customizeAppointmentGeometry(coordinates);
                return _BaseAppointmentsStra.prototype.getAppointmentGeometry.call(this, result)
            };
            _proto._customizeAppointmentGeometry = function(coordinates) {
                var config = this._calculateGeometryConfig(coordinates);
                return this._customizeCoordinates(coordinates, config.height, config.appointmentCountPerCell, config.offset)
            };
            _proto._getOffsets = function() {
                return {
                    unlimited: 0,
                    auto: 0
                }
            };
            _proto._getCompactLeftCoordinate = function(itemLeft, index) {
                var cellWidth = this.getDefaultCellWidth() || this.getAppointmentMinSize();
                return itemLeft + cellWidth * index
            };
            _proto._getMaxHeight = function() {
                return this.getDefaultCellHeight() || this.getAppointmentMinSize()
            };
            _proto._getAppointmentCount = function(overlappingMode, coordinates) {
                return this._getMaxAppointmentCountPerCellByType(false)
            };
            _proto._getAppointmentDefaultHeight = function() {
                return DEFAULT_APPOINTMENT_HEIGHT
            };
            _proto._getAppointmentMinHeight = function() {
                return MIN_APPOINTMENT_HEIGHT
            };
            _proto._sortCondition = function(a, b) {
                return this._columnCondition(a, b)
            };
            _proto._getOrientation = function() {
                return ["left", "right", "top"]
            };
            _proto._getMaxAppointmentWidth = function(startDate) {
                return this.instance.fire("getMaxAppointmentWidth", {
                    date: startDate
                })
            };
            _proto.getDropDownAppointmentWidth = function() {
                return this.getDefaultCellWidth() - 2 * DROP_DOWN_BUTTON_OFFSET
            };
            _proto.getDeltaTime = function(args, initialSize) {
                var deltaTime = 0;
                var deltaWidth = args.width - initialSize.width;
                deltaTime = toMs("minute") * Math.round(deltaWidth / this.getDefaultCellWidth() * this.instance.getAppointmentDurationInMinutes());
                return deltaTime
            };
            _proto.isAllDay = function(appointmentData) {
                return this.instance.fire("getField", "allDay", appointmentData)
            };
            _proto.needSeparateAppointment = function() {
                return this.instance.fire("isGroupedByDate")
            };
            return HorizontalRenderingStrategy
        }(_uiSchedulerAppointmentsStrategy.default);
        var _default = HorizontalRenderingStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/rendering_strategies/ui.scheduler.appointments.strategy.horizontal_month_line.js ***!
      \********************************************************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiSchedulerAppointmentsStrategy = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.appointments.strategy.horizontal */ 438));
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../../core/utils/date */ 19));
        var _query = _interopRequireDefault(__webpack_require__( /*! ../../../data/query */ 48));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var HOURS_IN_DAY = 24;
        var MINUTES_IN_HOUR = 60;
        var MILLISECONDS_IN_MINUTE = 6e4;
        var ZERO_APPOINTMENT_DURATION_IN_DAYS = 1;
        var HorizontalMonthLineRenderingStrategy = function(_HorizontalAppointmen) {
            _inheritsLoose(HorizontalMonthLineRenderingStrategy, _HorizontalAppointmen);

            function HorizontalMonthLineRenderingStrategy() {
                return _HorizontalAppointmen.apply(this, arguments) || this
            }
            var _proto = HorizontalMonthLineRenderingStrategy.prototype;
            _proto.calculateAppointmentWidth = function(appointment, position) {
                var startDate = _date.default.trimTime(position.info.appointment.startDate);
                var endDate = this.normalizeEndDateByViewEnd(appointment, position.info.appointment.endDate);
                var cellWidth = this.getDefaultCellWidth() || this.getAppointmentMinSize();
                var duration = this._getDurationInDays(startDate, endDate);
                var width = this.cropAppointmentWidth(Math.ceil(duration) * cellWidth, cellWidth);
                return width
            };
            _proto._getDurationInDays = function(startDate, endDate) {
                var adjustedDuration = this._adjustDurationByDaylightDiff(endDate.getTime() - startDate.getTime(), startDate, endDate);
                return adjustedDuration / _date.default.dateToMilliseconds("day") || ZERO_APPOINTMENT_DURATION_IN_DAYS
            };
            _proto.getDeltaTime = function(args, initialSize) {
                return HOURS_IN_DAY * MINUTES_IN_HOUR * MILLISECONDS_IN_MINUTE * this._getDeltaWidth(args, initialSize)
            };
            _proto.isAllDay = function() {
                return false
            };
            _proto.createTaskPositionMap = function(items, skipSorting) {
                if (!skipSorting) {
                    this.instance.getAppointmentsInstance()._sortAppointmentsByStartDate(items)
                }
                return _HorizontalAppointmen.prototype.createTaskPositionMap.call(this, items)
            };
            _proto._getSortedPositions = function(map, skipSorting) {
                var result = _HorizontalAppointmen.prototype._getSortedPositions.call(this, map);
                if (!skipSorting) {
                    result = (0, _query.default)(result).sortBy("top").thenBy("left").thenBy("cellPosition").thenBy("i").toArray()
                }
                return result
            };
            _proto.needCorrectAppointmentDates = function() {
                return false
            };
            return HorizontalMonthLineRenderingStrategy
        }(_uiSchedulerAppointmentsStrategy.default);
        var _default = HorizontalMonthLineRenderingStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/utils.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var KEYS = {
            SETTINGS: "dxAppointmentSettings"
        };
        var utils = {
            dataAccessors: {
                getAppointmentSettings: function(element) {
                    return (0, _renderer.default)(element).data(KEYS.SETTINGS)
                },
                getAppointmentInfo: function(element) {
                    var settings = utils.dataAccessors.getAppointmentSettings(element);
                    return null === settings || void 0 === settings ? void 0 : settings.info
                }
            }
        };
        var _default = utils;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/workspaces/ui.scheduler.work_space.js ***!
      \*************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../../core/renderer */ 2));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../../core/dom_adapter */ 11));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../../events/core/events_engine */ 5));
        var _element_data = __webpack_require__( /*! ../../../core/element_data */ 40);
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../../core/utils/date */ 19));
        var _window = __webpack_require__( /*! ../../../core/utils/window */ 7);
        var _element = __webpack_require__( /*! ../../../core/element */ 18);
        var _extend = __webpack_require__( /*! ../../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../../core/utils/iterator */ 3);
        var _position = __webpack_require__( /*! ../../../core/utils/position */ 22);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../../localization/message */ 10));
        var _date2 = _interopRequireDefault(__webpack_require__( /*! ../../../localization/date */ 32));
        var _common = __webpack_require__( /*! ../../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../../core/utils/type */ 1);
        var _index = __webpack_require__( /*! ../../../events/utils/index */ 8);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../../../events/pointer */ 24));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../../widget/ui.errors */ 17));
        var _click = __webpack_require__( /*! ../../../events/click */ 21);
        var _contextmenu = __webpack_require__( /*! ../../../events/contextmenu */ 179);
        var _drag = __webpack_require__( /*! ../../../events/drag */ 76);
        var _ui2 = _interopRequireDefault(__webpack_require__( /*! ../../scroll_view/ui.scrollable */ 106));
        var _uiSchedulerWork_spaceGroupedStrategy = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.work_space.grouped.strategy.horizontal */ 820));
        var _uiSchedulerWork_spaceGroupedStrategy2 = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.work_space.grouped.strategy.vertical */ 821));
        var _uiScheduler = _interopRequireDefault(__webpack_require__( /*! ../ui.scheduler.table_creator */ 300));
        var _uiSchedulerCurrent_time_shader = _interopRequireDefault(__webpack_require__( /*! ../shaders/ui.scheduler.current_time_shader.vertical */ 822));
        var _appointmentDragBehavior = _interopRequireDefault(__webpack_require__( /*! ../appointmentDragBehavior */ 823));
        var _constants = __webpack_require__( /*! ../constants */ 160);
        var _utils = _interopRequireDefault(__webpack_require__( /*! ../utils.timeZone */ 86));
        var _widgetObserver = _interopRequireDefault(__webpack_require__( /*! ../base/widgetObserver */ 824));
        var _translator = __webpack_require__( /*! ../../../animation/translator */ 28);
        var _uiScheduler2 = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.virtual_scrolling */ 825));
        var _view_data_provider = _interopRequireDefault(__webpack_require__( /*! ./view_data_provider */ 826));
        var _layout = _interopRequireDefault(__webpack_require__( /*! ../../../renovation/ui/scheduler/workspaces/base/date_table/all_day_panel/layout.j */ 827));
        var _title = _interopRequireDefault(__webpack_require__( /*! ../../../renovation/ui/scheduler/workspaces/base/date_table/all_day_panel/title.j */ 835));
        var _layout2 = _interopRequireDefault(__webpack_require__( /*! ../../../renovation/ui/scheduler/workspaces/base/time_panel/layout.j */ 836));
        var _virtual_selection_state = _interopRequireDefault(__webpack_require__( /*! ./virtual_selection_state */ 839));
        var _cache = __webpack_require__( /*! ./cache */ 443);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _objectWithoutProperties(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = _objectWithoutPropertiesLoose(source, excluded);
            var key, i;
            if (Object.getOwnPropertySymbols) {
                var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
                for (i = 0; i < sourceSymbolKeys.length; i++) {
                    key = sourceSymbolKeys[i];
                    if (excluded.indexOf(key) >= 0) {
                        continue
                    }
                    if (!Object.prototype.propertyIsEnumerable.call(source, key)) {
                        continue
                    }
                    target[key] = source[key]
                }
            }
            return target
        }

        function _objectWithoutPropertiesLoose(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = {};
            var sourceKeys = Object.keys(source);
            var key, i;
            for (i = 0; i < sourceKeys.length; i++) {
                key = sourceKeys[i];
                if (excluded.indexOf(key) >= 0) {
                    continue
                }
                target[key] = source[key]
            }
            return target
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var tableCreator = _uiScheduler.default.tableCreator;
        var abstract = _widgetObserver.default.abstract;
        var toMs = _date.default.dateToMilliseconds;
        var COMPONENT_CLASS = "dx-scheduler-work-space";
        var GROUPED_WORKSPACE_CLASS = "dx-scheduler-work-space-grouped";
        var VERTICAL_GROUPED_WORKSPACE_CLASS = "dx-scheduler-work-space-vertical-grouped";
        var WORKSPACE_VERTICAL_GROUP_TABLE_CLASS = "dx-scheduler-work-space-vertical-group-table";
        var WORKSPACE_WITH_BOTH_SCROLLS_CLASS = "dx-scheduler-work-space-both-scrollbar";
        var WORKSPACE_WITH_COUNT_CLASS = "dx-scheduler-work-space-count";
        var WORKSPACE_WITH_GROUP_BY_DATE_CLASS = "dx-scheduler-work-space-group-by-date";
        var WORKSPACE_WITH_ODD_CELLS_CLASS = "dx-scheduler-work-space-odd-cells";
        var TIME_PANEL_CLASS = "dx-scheduler-time-panel";
        var TIME_PANEL_CELL_CLASS = "dx-scheduler-time-panel-cell";
        var TIME_PANEL_ROW_CLASS = "dx-scheduler-time-panel-row";
        var ALL_DAY_PANEL_CLASS = "dx-scheduler-all-day-panel";
        var ALL_DAY_TABLE_CLASS = "dx-scheduler-all-day-table";
        var ALL_DAY_CONTAINER_CLASS = "dx-scheduler-all-day-appointments";
        var ALL_DAY_TITLE_CLASS = "dx-scheduler-all-day-title";
        var ALL_DAY_TITLE_HIDDEN_CLASS = "dx-scheduler-all-day-title-hidden";
        var ALL_DAY_TABLE_CELL_CLASS = "dx-scheduler-all-day-table-cell";
        var ALL_DAY_TABLE_ROW_CLASS = "dx-scheduler-all-day-table-row";
        var WORKSPACE_WITH_ALL_DAY_CLASS = "dx-scheduler-work-space-all-day";
        var WORKSPACE_WITH_COLLAPSED_ALL_DAY_CLASS = "dx-scheduler-work-space-all-day-collapsed";
        var WORKSPACE_WITH_MOUSE_SELECTION_CLASS = "dx-scheduler-work-space-mouse-selection";
        var HORIZONTAL_SIZES_CLASS = "dx-scheduler-cell-sizes-horizontal";
        var VERTICAL_SIZES_CLASS = "dx-scheduler-cell-sizes-vertical";
        var HEADER_PANEL_CLASS = "dx-scheduler-header-panel";
        var HEADER_PANEL_CELL_CLASS = "dx-scheduler-header-panel-cell";
        var HEADER_ROW_CLASS = "dx-scheduler-header-row";
        var GROUP_ROW_CLASS = "dx-scheduler-group-row";
        var GROUP_HEADER_CLASS = "dx-scheduler-group-header";
        var GROUP_HEADER_CONTENT_CLASS = "dx-scheduler-group-header-content";
        var DATE_TABLE_CLASS = "dx-scheduler-date-table";
        var DATE_TABLE_CELL_CLASS = "dx-scheduler-date-table-cell";
        var DATE_TABLE_ROW_CLASS = "dx-scheduler-date-table-row";
        var DATE_TABLE_FOCUSED_CELL_CLASS = "dx-scheduler-focused-cell";
        var VIRTUAL_ROW_CLASS = "dx-scheduler-virtual-row";
        var VIRTUAL_CELL_CLASS = "dx-scheduler-virtual-cell";
        var DATE_TABLE_DROPPABLE_CELL_CLASS = "dx-scheduler-date-table-droppable-cell";
        var SCHEDULER_HEADER_SCROLLABLE_CLASS = "dx-scheduler-header-scrollable";
        var SCHEDULER_SIDEBAR_SCROLLABLE_CLASS = "dx-scheduler-sidebar-scrollable";
        var SCHEDULER_DATE_TABLE_SCROLLABLE_CLASS = "dx-scheduler-date-table-scrollable";
        var SCHEDULER_WORKSPACE_DXPOINTERDOWN_EVENT_NAME = (0, _index.addNamespace)(_pointer.default.down, "dxSchedulerWorkSpace");
        var SCHEDULER_CELL_DXDRAGENTER_EVENT_NAME = (0, _index.addNamespace)(_drag.enter, "dxSchedulerDateTable");
        var SCHEDULER_CELL_DXDROP_EVENT_NAME = (0, _index.addNamespace)(_drag.drop, "dxSchedulerDateTable");
        var SCHEDULER_CELL_DXDRAGLEAVE_EVENT_NAME = (0, _index.addNamespace)(_drag.leave, "dxSchedulerDateTable");
        var SCHEDULER_CELL_DXCLICK_EVENT_NAME = (0, _index.addNamespace)(_click.name, "dxSchedulerDateTable");
        var SCHEDULER_CELL_DXPOINTERDOWN_EVENT_NAME = (0, _index.addNamespace)(_pointer.default.down, "dxSchedulerDateTable");
        var SCHEDULER_CELL_DXPOINTERUP_EVENT_NAME = (0, _index.addNamespace)(_pointer.default.up, "dxSchedulerDateTable");
        var SCHEDULER_CELL_DXPOINTERMOVE_EVENT_NAME = (0, _index.addNamespace)(_pointer.default.move, "dxSchedulerDateTable");
        var CELL_DATA = "dxCellData";
        var DATE_TABLE_CELL_BORDER = 1;
        var DATE_TABLE_MIN_CELL_WIDTH = 75;
        var DAY_MS = toMs("day");
        var HOUR_MS = toMs("hour");
        var SCHEDULER_DRAG_AND_DROP_SELECTOR = ".".concat(DATE_TABLE_CLASS, " td, .").concat(ALL_DAY_TABLE_CLASS, " td");
        var CELL_SELECTOR = ".".concat(DATE_TABLE_CELL_CLASS, ", .").concat(ALL_DAY_TABLE_CELL_CLASS);
        var ScrollSemaphore = function() {
            function ScrollSemaphore() {
                this.counter = 0
            }
            var _proto = ScrollSemaphore.prototype;
            _proto.isFree = function() {
                return 0 === this.counter
            };
            _proto.take = function() {
                this.counter++
            };
            _proto.release = function() {
                this.counter--;
                if (this.counter < 0) {
                    this.counter = 0
                }
            };
            return ScrollSemaphore
        }();
        var formatWeekday = function(date) {
            return _date2.default.getDayNames("abbreviated")[date.getDay()]
        };
        var SchedulerWorkSpace = function(_WidgetObserver) {
            _inheritsLoose(SchedulerWorkSpace, _WidgetObserver);

            function SchedulerWorkSpace() {
                return _WidgetObserver.apply(this, arguments) || this
            }
            var _proto2 = SchedulerWorkSpace.prototype;
            _proto2._supportedKeys = function() {
                var clickHandler = function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (this._selectedCells && this._selectedCells.length) {
                        var $itemElement = (0, _renderer.default)(this.option("focusedElement"));
                        var $cellElement = (0, _renderer.default)($itemElement.length ? $itemElement : this._selectedCells);
                        e.target = this._selectedCells;
                        this._showPopup = true;
                        this._cellClickAction({
                            event: e,
                            cellElement: (0, _renderer.default)(this._selectedCells),
                            cellData: this.getCellData($cellElement)
                        })
                    }
                };
                var arrowPressHandler = function(e, cell) {
                    e.preventDefault();
                    e.stopPropagation();
                    this._moveToCell(cell, e.shiftKey)
                };
                return (0, _extend.extend)(_WidgetObserver.prototype._supportedKeys.call(this), {
                    enter: clickHandler,
                    space: clickHandler,
                    downArrow: function(e) {
                        var $cell = this._getCellFromNextRow("next", e.shiftKey);
                        arrowPressHandler.call(this, e, $cell)
                    },
                    upArrow: function(e) {
                        var $cell = this._getCellFromNextRow("prev", e.shiftKey);
                        arrowPressHandler.call(this, e, $cell)
                    },
                    rightArrow: function(e) {
                        var $rightCell = this._getCellFromNextColumn("next", e.shiftKey);
                        arrowPressHandler.call(this, e, $rightCell)
                    },
                    leftArrow: function(e) {
                        var $leftCell = this._getCellFromNextColumn("prev", e.shiftKey);
                        arrowPressHandler.call(this, e, $leftCell)
                    }
                })
            };
            _proto2._dispose = function() {
                var _this$virtualScrollin;
                _WidgetObserver.prototype._dispose.call(this);
                null === (_this$virtualScrollin = this.virtualScrollingDispatcher) || void 0 === _this$virtualScrollin ? void 0 : _this$virtualScrollin.dispose();
                this._disposeRenovatedComponents()
            };
            _proto2._isRTL = function() {
                return this.option("rtlEnabled")
            };
            _proto2._getFocusedCell = function() {
                return this._$focusedCell || this._$dateTable.find("." + DATE_TABLE_CELL_CLASS).eq(0)
            };
            _proto2._getAllFocusedCells = function() {
                return this._selectedCells || this._$dateTable.find("." + DATE_TABLE_CELL_CLASS).eq(0)
            };
            _proto2._getCellFromNextRow = function(direction) {
                var $currentCell = this._$focusedCell;
                if ((0, _type.isDefined)($currentCell)) {
                    var cellIndex = $currentCell.index();
                    var $row = $currentCell.parent();
                    var $cell = $row[direction]().children().eq(cellIndex);
                    $cell = this._checkForViewBounds($cell);
                    return $cell
                }
            };
            _proto2._checkForViewBounds = function($item) {
                if (!$item.length) {
                    $item = this._$focusedCell
                }
                return $item
            };
            _proto2._getCellFromNextColumn = function(direction, isMultiSelection) {
                var $focusedCell = this._$focusedCell;
                if (!(0, _type.isDefined)($focusedCell)) {
                    return
                }
                var $nextCell;
                var $row = $focusedCell.parent();
                var nextColumnDirection = direction;
                var isDirectionNext = "next" === direction;
                var previousColumnDirection = isDirectionNext ? "prev" : "next";
                var isRTL = this._isRTL();
                var groupCount = this._getGroupCount();
                var isHorizontalGrouping = this._isHorizontalGroupedWorkSpace();
                var isGroupedByDate = this.isGroupedByDate();
                var totalCellCount = this._getTotalCellCount(groupCount);
                var rowCellCount = isMultiSelection && !isGroupedByDate ? this._getCellCount() : totalCellCount;
                var lastIndexInRow = rowCellCount - 1;
                var currentIndex = $focusedCell.index();
                var step = isGroupedByDate && isMultiSelection ? groupCount : 1;
                var isEdgeCell = this._isEdgeCell(isHorizontalGrouping ? totalCellCount - 1 : lastIndexInRow, currentIndex, step, direction);
                var sign = isRTL ? 1 : -1;
                var directionSign = isDirectionNext ? 1 : -1;
                var resultingSign = sign * directionSign;
                if (isEdgeCell || isMultiSelection && this._isGroupEndCell($focusedCell, direction)) {
                    var nextIndex = currentIndex - resultingSign * step + resultingSign * rowCellCount;
                    var rowDirection = isRTL ? previousColumnDirection : nextColumnDirection;
                    $nextCell = $row[rowDirection]().children().eq(nextIndex);
                    $nextCell = this._checkForViewBounds($nextCell)
                } else {
                    $nextCell = $row.children().eq(currentIndex - resultingSign * step)
                }
                return $nextCell
            };
            _proto2._isEdgeCell = function(lastIndexInRow, cellIndex, step, direction) {
                var isRTL = this._isRTL();
                var isDirectionNext = "next" === direction;
                var rightEdgeCellIndex = isRTL ? 0 : lastIndexInRow;
                var leftEdgeCellIndex = isRTL ? lastIndexInRow : 0;
                var edgeCellIndex = isDirectionNext ? rightEdgeCellIndex : leftEdgeCellIndex;
                var isNextCellGreaterThanEdge = cellIndex + step > edgeCellIndex;
                var isNextCellLessThanEdge = cellIndex - step < edgeCellIndex;
                var isRightEdgeCell = isRTL ? isNextCellLessThanEdge : isNextCellGreaterThanEdge;
                var isLeftEdgeCell = isRTL ? isNextCellGreaterThanEdge : isNextCellLessThanEdge;
                return isDirectionNext ? isRightEdgeCell : isLeftEdgeCell
            };
            _proto2._isGroupEndCell = function($cell, direction) {
                if (this.isGroupedByDate()) {
                    return false
                }
                var isDirectionNext = "next" === direction;
                var cellsInRow = this._getCellCount();
                var currentCellIndex = $cell.index();
                var result = currentCellIndex % cellsInRow;
                var endCell = isDirectionNext ? cellsInRow - 1 : 0;
                var startCell = isDirectionNext ? 0 : cellsInRow - 1;
                return this._isRTL() ? result === startCell : result === endCell
            };
            _proto2._moveToCell = function($cell, isMultiSelection) {
                isMultiSelection = isMultiSelection && this.option("allowMultipleCellSelection");
                this._setSelectedAndFocusedCells($cell, isMultiSelection);
                this._dateTableScrollable.scrollToElement($cell)
            };
            _proto2._setSelectedAndFocusedCells = function($cell, isMultiSelection) {
                if (!(0, _type.isDefined)($cell) || !$cell.length) {
                    return
                }
                var updateViewData = this.isVirtualScrolling();
                var $correctedCell = $cell;
                if (isMultiSelection) {
                    $correctedCell = this._correctCellForGroup($cell)
                }
                if ($correctedCell.hasClass(DATE_TABLE_FOCUSED_CELL_CLASS)) {
                    return
                }
                this._setSelectedCells($correctedCell, isMultiSelection);
                this._setFocusedCell($correctedCell, updateViewData)
            };
            _proto2._setFocusedCell = function($cell) {
                var updateViewData = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : false;
                this._releaseFocusedCell();
                var $correctedCell = $cell;
                if (updateViewData) {
                    var _this$_getCoordinates = this._getCoordinatesByCell($cell),
                        rowIndex = _this$_getCoordinates.rowIndex,
                        columnIndex = _this$_getCoordinates.columnIndex;
                    var isAllDayCell = this._hasAllDayClass($cell);
                    this.virtualSelectionState.setFocusedCell(rowIndex, columnIndex, isAllDayCell);
                    var focusedCell = this.virtualSelectionState.getFocusedCell(this._isVerticalGroupedWorkSpace());
                    var cellData = focusedCell.cellData,
                        coordinates = focusedCell.coordinates;
                    var allDay = cellData.allDay;
                    $correctedCell = allDay && !this._isVerticalGroupedWorkSpace() ? this._dom_getAllDayPanelCell(coordinates.cellIndex) : this._dom_getDateCell(coordinates)
                }
                this._toggleFocusedCellClass(true, $correctedCell);
                this._$focusedCell = $correctedCell
            };
            _proto2._setSelectedCells = function($firstCell, isMultiSelection) {
                this._releaseSelectedCells();
                this._selectedCells = [];
                if (this.isVirtualScrolling()) {
                    this._setSelectedCellsInVirtualMode($firstCell, isMultiSelection)
                } else {
                    this._setSelectedCellsInStandardMode($firstCell, isMultiSelection)
                }
                var $selectedCells = (0, _renderer.default)(this._selectedCells);
                this._toggleFocusClass(true, $selectedCells);
                this.setAria("label", "Add appointment", $selectedCells);
                var selectedCellData = this.getSelectedCellData().map(function(_ref) {
                    var startDate = _ref.startDate,
                        endDate = _ref.endDate,
                        allDay = _ref.allDay,
                        groups = _ref.groups,
                        groupIndex = _ref.groupIndex;
                    return {
                        startDate: startDate,
                        endDate: endDate,
                        allDay: allDay,
                        groups: groups,
                        groupIndex: groupIndex || 0
                    }
                });
                this.option("selectedCellData", selectedCellData);
                this._selectionChangedAction({
                    selectedCellData: selectedCellData
                })
            };
            _proto2._setSelectedCellsInStandardMode = function($firstCell, isMultiSelection) {
                if (isMultiSelection) {
                    var $previousCell = this._$prevCell;
                    var orientation = "day" === this.option("type") && (!this.option("groups").length || "vertical" === this.option("groupOrientation")) ? "vertical" : "horizontal";
                    var $targetCells = this._getCellsBetween($firstCell, $previousCell, orientation);
                    this._selectedCells = $targetCells.toArray()
                } else {
                    this._selectedCells = [$firstCell.get(0)];
                    this._$prevCell = $firstCell
                }
            };
            _proto2._setSelectedCellsInVirtualMode = function($firstCell, isMultiSelection) {
                if (isMultiSelection) {
                    var _this$_getCoordinates2 = this._getCoordinatesByCell($firstCell),
                        firstRow = _this$_getCoordinates2.rowIndex,
                        firstColumn = _this$_getCoordinates2.columnIndex;
                    var isFirstAllDay = this._hasAllDayClass($firstCell);
                    var firstCell = {
                        rowIndex: firstRow,
                        columnIndex: firstColumn,
                        allDay: isFirstAllDay
                    };
                    this.virtualSelectionState.setSelectedCells(firstCell)
                } else {
                    this._selectedCells = [$firstCell.get(0)];
                    this._$prevCell = $firstCell;
                    var _this$_getCoordinates3 = this._getCoordinatesByCell($firstCell),
                        rowIndex = _this$_getCoordinates3.rowIndex,
                        columnIndex = _this$_getCoordinates3.columnIndex;
                    var isAllDayCell = this._hasAllDayClass($firstCell);
                    var _firstCell = {
                        rowIndex: rowIndex,
                        columnIndex: columnIndex,
                        allDay: isAllDayCell
                    };
                    this.virtualSelectionState.setSelectedCells(_firstCell, _firstCell)
                }
                this._setSelectedCellsByCellData(this.virtualSelectionState.getSelectedCells())
            };
            _proto2._correctCellForGroup = function($cell) {
                if (this.isVirtualScrolling()) {
                    var cellData = this.getCellData($cell);
                    var isValidFocusedCell = this.virtualSelectionState.isValidFocusedCell(cellData);
                    return isValidFocusedCell ? $cell : this._$focusedCell
                }
                var $focusedCell = this._$focusedCell;
                var cellGroupIndex = this._getGroupIndexByCell($cell);
                var focusedCellGroupIndex = this._getGroupIndexByCell($focusedCell);
                var isDifferentTables = this._hasAllDayClass($cell) !== this._hasAllDayClass($focusedCell);
                return focusedCellGroupIndex !== cellGroupIndex || isDifferentTables ? $focusedCell : $cell
            };
            _proto2._getCellsBetween = function($first, $last, direction) {
                var isAllDayTable = this._hasAllDayClass($last);
                var $cells = this._getCells(isAllDayTable, direction);
                var firstIndex = $cells.index($first);
                var lastIndex = $cells.index($last);
                if (firstIndex > lastIndex) {
                    var buffer = firstIndex;
                    firstIndex = lastIndex;
                    lastIndex = buffer
                }
                $cells = $cells.slice(firstIndex, lastIndex + 1);
                if (this._getGroupCount() > 1) {
                    var result = [];
                    var focusedGroupIndex = this._getGroupIndexByCell($first);
                    (0, _iterator.each)($cells, function(_, cell) {
                        var groupIndex = this._getGroupIndexByCell((0, _renderer.default)(cell));
                        if (focusedGroupIndex === groupIndex) {
                            result.push(cell)
                        }
                    }.bind(this));
                    $cells = (0, _renderer.default)(result)
                }
                return $cells
            };
            _proto2._hasAllDayClass = function($cell) {
                return $cell.hasClass(ALL_DAY_TABLE_CELL_CLASS)
            };
            _proto2._getGroupIndexByCell = function($cell) {
                if (this.isVirtualScrolling()) {
                    var _this$_getCoordinates4 = this._getCoordinatesByCell($cell),
                        rowIndex = _this$_getCoordinates4.rowIndex,
                        columnIndex = _this$_getCoordinates4.columnIndex;
                    var isAllDayCell = $cell.hasClass(ALL_DAY_TABLE_CELL_CLASS);
                    return this.viewDataProvider.getCellData(rowIndex, columnIndex, isAllDayCell).groupIndex
                }
                return this._groupedStrategy.getGroupIndexByCell($cell)
            };
            _proto2._toggleFocusedCellClass = function(isFocused, $element) {
                var $focusTarget = $element && $element.length ? $element : this._focusTarget();
                $focusTarget.toggleClass(DATE_TABLE_FOCUSED_CELL_CLASS, isFocused)
            };
            _proto2._releaseSelectedAndFocusedCells = function() {
                this._releaseFocusedCell();
                this._releaseSelectedCells();
                this.option("selectedCellData", [])
            };
            _proto2._releaseFocusedCell = function() {
                var $cell = this._$focusedCell;
                if ((0, _type.isDefined)($cell) && $cell.length) {
                    this._toggleFocusedCellClass(false, $cell);
                    this.setAria("label", void 0, $cell)
                }
            };
            _proto2._releaseSelectedCells = function() {
                var $cells = (0, _renderer.default)(this._selectedCells);
                if ((0, _type.isDefined)($cells) && $cells.length) {
                    this._toggleFocusClass(false, $cells);
                    this.setAria("label", void 0, $cells)
                }
            };
            _proto2._focusInHandler = function(e) {
                if ((0, _renderer.default)(e.target).is(this._focusTarget()) && false !== this._isCellClick) {
                    delete this._isCellClick;
                    delete this._contextMenuHandled;
                    _WidgetObserver.prototype._focusInHandler.apply(this, arguments);
                    var $cell = this._getFocusedCell();
                    this._setSelectedAndFocusedCells($cell)
                }
            };
            _proto2._focusOutHandler = function() {
                _WidgetObserver.prototype._focusOutHandler.apply(this, arguments);
                if (!this._contextMenuHandled) {
                    var _this$virtualSelectio;
                    this._releaseSelectedAndFocusedCells();
                    null === (_this$virtualSelectio = this.virtualSelectionState) || void 0 === _this$virtualSelectio ? void 0 : _this$virtualSelectio.releaseSelectedAndFocusedCells()
                }
            };
            _proto2._focusTarget = function() {
                return this.$element()
            };
            _proto2._getDefaultOptions = function() {
                return (0, _extend.extend)(_WidgetObserver.prototype._getDefaultOptions.call(this), {
                    currentDate: new Date,
                    intervalCount: 1,
                    startDate: null,
                    firstDayOfWeek: void 0,
                    startDayHour: 0,
                    endDayHour: 24,
                    hoursInterval: .5,
                    activeStateEnabled: true,
                    hoverStateEnabled: true,
                    groups: [],
                    showAllDayPanel: true,
                    allDayExpanded: false,
                    onCellClick: null,
                    crossScrollingEnabled: false,
                    dataCellTemplate: null,
                    timeCellTemplate: null,
                    resourceCellTemplate: null,
                    dateCellTemplate: null,
                    allowMultipleCellSelection: true,
                    indicatorTime: new Date,
                    indicatorUpdateInterval: 5 * toMs("minute"),
                    shadeUntilCurrentTime: true,
                    groupOrientation: "horizontal",
                    selectedCellData: [],
                    groupByDate: false,
                    scrolling: {
                        mode: "standard"
                    },
                    renovateRender: false,
                    height: void 0
                })
            };
            _proto2._optionChanged = function(args) {
                switch (args.name) {
                    case "startDayHour":
                    case "endDayHour":
                        this.invoke("validateDayHours");
                        this._cleanWorkSpace();
                        break;
                    case "dateCellTemplate":
                    case "resourceCellTemplate":
                    case "dataCellTemplate":
                    case "timeCellTemplate":
                    case "hoursInterval":
                    case "firstDayOfWeek":
                    case "currentDate":
                    case "startDate":
                        this._cleanWorkSpace();
                        break;
                    case "groups":
                        this._cleanView();
                        this._disposeRenovatedComponents();
                        this._removeAllDayElements();
                        this._initGrouping();
                        this.repaint();
                        break;
                    case "groupOrientation":
                        this._initGroupedStrategy();
                        this._createAllDayPanelElements();
                        this._removeAllDayElements();
                        this._cleanWorkSpace();
                        this._toggleGroupByDateClass();
                        break;
                    case "showAllDayPanel":
                        if (this._isVerticalGroupedWorkSpace()) {
                            this._cleanView();
                            this._disposeRenovatedComponents();
                            this._removeAllDayElements();
                            this._initGrouping();
                            this.repaint()
                        } else {
                            this._toggleAllDayVisibility()
                        }
                        break;
                    case "allDayExpanded":
                        this._changeAllDayVisibility();
                        this._attachTablesEvents();
                        this.headerPanelOffsetRecalculate();
                        this._updateScrollable();
                        break;
                    case "onSelectionChanged":
                        this._createSelectionChangedAction();
                        break;
                    case "onCellClick":
                        this._createCellClickAction();
                        break;
                    case "onCellContextMenu":
                        this._attachContextMenuEvent();
                        break;
                    case "intervalCount":
                        this._cleanWorkSpace();
                        this._toggleWorkSpaceCountClass();
                        this._toggleFixedScrollableClass();
                        break;
                    case "groupByDate":
                        this._cleanWorkSpace();
                        this._toggleGroupByDateClass();
                        break;
                    case "crossScrollingEnabled":
                        this._toggleHorizontalScrollClass();
                        this._dateTableScrollable.option(this._dateTableScrollableConfig());
                        break;
                    case "width":
                        _WidgetObserver.prototype._optionChanged.call(this, args);
                        this._dimensionChanged();
                        break;
                    case "allowMultipleCellSelection":
                        break;
                    case "selectedCellData":
                        break;
                    case "scrolling":
                        this.option("renovateRender", this._isVirtualModeOn());
                        break;
                    case "renovateRender":
                        this._disposeRenovatedComponents();
                        this.repaint();
                        break;
                    default:
                        _WidgetObserver.prototype._optionChanged.call(this, args)
                }
            };
            _proto2._cleanWorkSpace = function() {
                this._cleanView();
                this._toggleGroupedClass();
                this._toggleWorkSpaceWithOddCells();
                this._renderView()
            };
            _proto2._init = function() {
                this._headerSemaphore = new ScrollSemaphore;
                this._sideBarSemaphore = new ScrollSemaphore;
                this._dataTableSemaphore = new ScrollSemaphore;
                this._viewDataProvider = null;
                this._virtualSelectionState = null;
                this._activeStateUnit = CELL_SELECTOR;
                this._maxAllowedVerticalPosition = [];
                this._maxAllowedPosition = [];
                _WidgetObserver.prototype._init.call(this);
                this._initGrouping();
                this._toggleHorizontalScrollClass();
                this._toggleWorkSpaceCountClass();
                this._toggleGroupByDateClass();
                this._toggleWorkSpaceWithOddCells();
                this.$element().addClass(COMPONENT_CLASS).addClass(this._getElementClass())
            };
            _proto2._initGrouping = function() {
                this._initGroupedStrategy();
                this._toggleGroupingDirectionClass();
                this._toggleGroupByDateClass()
            };
            _proto2._initGroupedStrategy = function() {
                var strategyName = this.option("groups").length ? this.option("groupOrientation") : this._getDefaultGroupStrategy();
                var Strategy = "vertical" === strategyName ? _uiSchedulerWork_spaceGroupedStrategy2.default : _uiSchedulerWork_spaceGroupedStrategy.default;
                this._groupedStrategy = new Strategy(this)
            };
            _proto2._getDefaultGroupStrategy = function() {
                return "horizontal"
            };
            _proto2._isVerticalGroupedWorkSpace = function() {
                return !!this.option("groups").length && "vertical" === this.option("groupOrientation")
            };
            _proto2._isHorizontalGroupedWorkSpace = function() {
                return !!this.option("groups").length && "horizontal" === this.option("groupOrientation")
            };
            _proto2._toggleHorizontalScrollClass = function() {
                this.$element().toggleClass(WORKSPACE_WITH_BOTH_SCROLLS_CLASS, this.option("crossScrollingEnabled"))
            };
            _proto2._toggleGroupByDateClass = function() {
                this.$element().toggleClass(WORKSPACE_WITH_GROUP_BY_DATE_CLASS, this.isGroupedByDate())
            };
            _proto2._toggleWorkSpaceCountClass = function() {
                this.$element().toggleClass(WORKSPACE_WITH_COUNT_CLASS, this._isWorkSpaceWithCount())
            };
            _proto2._isWorkSpaceWithCount = function() {
                return this.option("intervalCount") > 1
            };
            _proto2._toggleWorkSpaceWithOddCells = function() {
                this.$element().toggleClass(WORKSPACE_WITH_ODD_CELLS_CLASS, this._isWorkspaceWithOddCells())
            };
            _proto2._isWorkspaceWithOddCells = function() {
                return .5 === this.option("hoursInterval") && !this.isVirtualScrolling()
            };
            _proto2._toggleGroupingDirectionClass = function() {
                this.$element().toggleClass(VERTICAL_GROUPED_WORKSPACE_CLASS, this._isVerticalGroupedWorkSpace())
            };
            _proto2._getRealGroupOrientation = function() {
                return this._isVerticalGroupedWorkSpace() ? "vertical" : "horizontal"
            };
            _proto2._getTimePanelClass = function() {
                return TIME_PANEL_CLASS
            };
            _proto2._getDateTableClass = function() {
                return DATE_TABLE_CLASS
            };
            _proto2._getDateTableRowClass = function() {
                return DATE_TABLE_ROW_CLASS
            };
            _proto2._getDateTableCellClass = function(i, j) {
                var cellClass = DATE_TABLE_CELL_CLASS + " " + HORIZONTAL_SIZES_CLASS + " " + VERTICAL_SIZES_CLASS;
                return this._needApplyLastGroupCellClass() ? this._groupedStrategy.addAdditionalGroupCellClasses(cellClass, j + 1, i, j) : cellClass
            };
            _proto2._needApplyLastGroupCellClass = function() {
                return true
            };
            _proto2._getGroupRowClass = function() {
                return GROUP_ROW_CLASS
            };
            _proto2._getGroupHeaderClass = function(i) {
                var cellClass = GROUP_HEADER_CLASS;
                return this._groupedStrategy.addAdditionalGroupCellClasses(cellClass, i + 1)
            };
            _proto2._getGroupHeaderContentClass = function() {
                return GROUP_HEADER_CONTENT_CLASS
            };
            _proto2._initWorkSpaceUnits = function() {
                this._$headerPanel = (0, _renderer.default)("<table>");
                this._$thead = (0, _renderer.default)("<thead>").appendTo(this._$headerPanel);
                this._$fixedContainer = (0, _renderer.default)("<div>").addClass(_constants.FIXED_CONTAINER_CLASS);
                this._$allDayContainer = (0, _renderer.default)("<div>").addClass(ALL_DAY_CONTAINER_CLASS);
                this._initAllDayPanelElements();
                if (this.isRenovatedRender()) {
                    this.createRAllDayPanelElements()
                } else {
                    this._createAllDayPanelElements()
                }
                this._$timePanel = (0, _renderer.default)("<table>").addClass(this._getTimePanelClass());
                this._$dateTable = (0, _renderer.default)("<table>");
                this._$groupTable = (0, _renderer.default)("<div>").addClass(WORKSPACE_VERTICAL_GROUP_TABLE_CLASS)
            };
            _proto2._initAllDayPanelElements = function() {
                this._allDayTitles = [];
                this._allDayTables = [];
                this._allDayPanels = []
            };
            _proto2.createRAllDayPanelElements = function() {
                this._$allDayPanel = (0, _renderer.default)("<div>");
                this._$allDayTitle = (0, _renderer.default)("<div>").appendTo(this.$element())
            };
            _proto2._createAllDayPanelElements = function() {
                var groupCount = this._getGroupCount();
                if (this._isVerticalGroupedWorkSpace() && 0 !== groupCount) {
                    for (var i = 0; i < groupCount; i++) {
                        var $allDayTitle = (0, _renderer.default)("<div>").addClass(ALL_DAY_TITLE_CLASS).text(_message.default.format("dxScheduler-allDay"));
                        this._allDayTitles.push($allDayTitle);
                        this._$allDayTable = (0, _renderer.default)("<table>");
                        this._allDayTables.push(this._$allDayTable);
                        this._$allDayPanel = (0, _renderer.default)("<div>").addClass(ALL_DAY_PANEL_CLASS).append(this._$allDayTable);
                        this._allDayPanels.push(this._$allDayPanel)
                    }
                } else {
                    this._$allDayTitle = (0, _renderer.default)("<div>").addClass(ALL_DAY_TITLE_CLASS).text(_message.default.format("dxScheduler-allDay")).appendTo(this.$element());
                    this._$allDayTable = (0, _renderer.default)("<table>");
                    this._$allDayPanel = (0, _renderer.default)("<div>").addClass(ALL_DAY_PANEL_CLASS).append(this._$allDayTable)
                }
            };
            _proto2._initDateTableScrollable = function() {
                var $dateTableScrollable = (0, _renderer.default)("<div>").addClass(SCHEDULER_DATE_TABLE_SCROLLABLE_CLASS);
                this._dateTableScrollable = this._createComponent($dateTableScrollable, _ui2.default, this._dateTableScrollableConfig())
            };
            _proto2._dateTableScrollableConfig = function() {
                var config = {
                    useKeyboard: false,
                    bounceEnabled: false,
                    updateManually: true,
                    pushBackValue: 0
                };
                if (this._needCreateCrossScrolling()) {
                    config = (0, _extend.extend)(config, this._createCrossScrollingConfig())
                }
                return config
            };
            _proto2._createCrossScrollingConfig = function() {
                var _this = this;
                var config = {};
                config.direction = "both";
                config.onScroll = function(e) {
                    _this._dataTableSemaphore.take();
                    _this._sideBarSemaphore.isFree() && _this._sidebarScrollable && _this._sidebarScrollable.scrollTo({
                        top: e.scrollOffset.top
                    });
                    _this._headerSemaphore.isFree() && _this._headerScrollable && _this._headerScrollable.scrollTo({
                        left: e.scrollOffset.left
                    });
                    _this._dataTableSemaphore.release()
                };
                config.onEnd = function() {
                    _this.notifyObserver("updateResizableArea", {})
                };
                return config
            };
            _proto2._createWorkSpaceElements = function() {
                if (this.option("crossScrollingEnabled")) {
                    this._createWorkSpaceScrollableElements()
                } else {
                    this._createWorkSpaceStaticElements()
                }
            };
            _proto2._createWorkSpaceStaticElements = function() {
                if (this._isVerticalGroupedWorkSpace()) {
                    this._dateTableScrollable.$content().append(this._$allDayContainer, this._$groupTable, this._$timePanel, this._$dateTable);
                    this.$element().append(this._$fixedContainer, this._$headerPanel, this._dateTableScrollable.$element())
                } else {
                    this._dateTableScrollable.$content().append(this._$timePanel, this._$dateTable);
                    this.$element().append(this._$fixedContainer, this._$headerPanel, this._$allDayContainer, this._$allDayPanel, this._dateTableScrollable.$element())
                }
            };
            _proto2._createWorkSpaceScrollableElements = function() {
                this.$element().append(this._$fixedContainer);
                this._createHeaderScrollable();
                this._createSidebarScrollable();
                this.$element().append(this._dateTableScrollable.$element());
                this._headerScrollable.$content().append(this._$headerPanel);
                this._dateTableScrollable.$content().append(this._$dateTable);
                if (this._isVerticalGroupedWorkSpace()) {
                    this._dateTableScrollable.$content().prepend(this._$allDayContainer);
                    this._sidebarScrollable.$content().append(this._$groupTable, this._$timePanel)
                } else {
                    this._headerScrollable.$content().append(this._$allDayContainer, this._$allDayPanel)
                }
                this._sidebarScrollable.$content().append(this._$timePanel)
            };
            _proto2._createHeaderScrollable = function() {
                var $headerScrollable = (0, _renderer.default)("<div>").addClass(SCHEDULER_HEADER_SCROLLABLE_CLASS).appendTo(this.$element());
                this._headerScrollable = this._createComponent($headerScrollable, _ui2.default, this._headerScrollableConfig())
            };
            _proto2._headerScrollableConfig = function() {
                var _this2 = this;
                var config = {
                    useKeyboard: false,
                    showScrollbar: false,
                    direction: "horizontal",
                    useNative: false,
                    updateManually: true,
                    bounceEnabled: false,
                    pushBackValue: 0,
                    onScroll: function(e) {
                        _this2._headerSemaphore.take();
                        _this2._dataTableSemaphore.isFree() && _this2._dateTableScrollable.scrollTo({
                            left: e.scrollOffset.left
                        });
                        _this2._headerSemaphore.release()
                    }
                };
                return config
            };
            _proto2._createSidebarScrollable = function() {
                var _this3 = this;
                var $timePanelScrollable = (0, _renderer.default)("<div>").addClass(SCHEDULER_SIDEBAR_SCROLLABLE_CLASS).appendTo(this.$element());
                this._sidebarScrollable = this._createComponent($timePanelScrollable, _ui2.default, {
                    useKeyboard: false,
                    showScrollbar: false,
                    direction: "vertical",
                    useNative: false,
                    updateManually: true,
                    bounceEnabled: false,
                    pushBackValue: 0,
                    onScroll: function(e) {
                        _this3._sideBarSemaphore.take();
                        _this3._dataTableSemaphore.isFree() && _this3._dateTableScrollable.scrollTo({
                            top: e.scrollOffset.top
                        });
                        _this3._sideBarSemaphore.release()
                    }
                })
            };
            _proto2._visibilityChanged = function(visible) {
                this.cache.clear();
                if (visible && this._isVerticalGroupedWorkSpace()) {
                    this._setHorizontalGroupHeaderCellsHeight()
                }
                if (visible && this._needCreateCrossScrolling()) {
                    this._setTableSizes()
                }
            };
            _proto2._attachTableClasses = function() {
                this._addTableClass(this._$dateTable, this._getDateTableClass());
                if (this._isVerticalGroupedWorkSpace()) {
                    var groupCount = this._getGroupCount();
                    for (var i = 0; i < groupCount; i++) {
                        this._addTableClass(this._allDayTables[i], ALL_DAY_TABLE_CLASS)
                    }
                } else {
                    this._addTableClass(this._$allDayTable, ALL_DAY_TABLE_CLASS)
                }
            };
            _proto2._attachHeaderTableClasses = function() {
                this._addTableClass(this._$headerPanel, HEADER_PANEL_CLASS)
            };
            _proto2._addTableClass = function($el, className) {
                $el && !$el.hasClass(className) && $el.addClass(className)
            };
            _proto2._setTableSizes = function() {
                this._attachTableClasses();
                var cellWidth = this.getCellWidth();
                if (cellWidth < this.getCellMinWidth()) {
                    cellWidth = this.getCellMinWidth()
                }
                var minWidth = this.getWorkSpaceMinWidth();
                var $headerCells = this._$headerPanel.find("tr").last().find("th");
                var width = cellWidth * $headerCells.length;
                if (width < minWidth) {
                    width = minWidth
                }
                this._$headerPanel.width(width);
                this._$dateTable.width(width);
                this._$allDayTable && this._$allDayTable.width(width);
                this._attachHeaderTableClasses();
                if (this._isVerticalGroupedWorkSpace()) {
                    this._setHorizontalGroupHeaderCellsHeight()
                }
            };
            _proto2.getWorkSpaceMinWidth = function() {
                return this._groupedStrategy.getWorkSpaceMinWidth()
            };
            _proto2._dimensionChanged = function() {
                if (this.option("crossScrollingEnabled")) {
                    this._setTableSizes()
                }
                this.headerPanelOffsetRecalculate();
                this.cache.clear();
                this._cleanAllowedPositions()
            };
            _proto2._needCreateCrossScrolling = function() {
                return this.option("crossScrollingEnabled")
            };
            _proto2._getElementClass = function() {
                return (0, _common.noop)()
            };
            _proto2._getRowCount = function() {
                return (0, _common.noop)()
            };
            _proto2._getRowCountWithAllDayRows = function() {
                var allDayRowCount = this._isShowAllDayPanel() ? 1 : 0;
                return this._getRowCount() + allDayRowCount
            };
            _proto2._getCellCount = function() {
                return (0, _common.noop)()
            };
            _proto2._initMarkup = function() {
                this.cache.clear();
                this._initWorkSpaceUnits();
                this._initDateTableScrollable();
                this._createWorkSpaceElements();
                this._initVirtualScrolling();
                _WidgetObserver.prototype._initMarkup.call(this);
                if (!this.option("crossScrollingEnabled")) {
                    this._attachTableClasses();
                    this._attachHeaderTableClasses()
                }
                this._toggleGroupedClass();
                this._toggleFixedScrollableClass();
                this._renderView();
                this._attachEvents();
                this._setFocusOnCellByOption(this.option("selectedCellData"))
            };
            _proto2.isRenovatedRender = function() {
                return this.renovatedRenderSupported() && this.option("renovateRender")
            };
            _proto2._isVirtualModeOn = function() {
                return "virtual" === this.option("scrolling.mode")
            };
            _proto2.isVirtualScrolling = function() {
                return this.isRenovatedRender() && this._isVirtualModeOn()
            };
            _proto2._initVirtualScrolling = function() {
                if (this.virtualScrollingDispatcher) {
                    this.virtualScrollingDispatcher.dispose();
                    this.virtualScrollingDispatcher = null
                }
                if (this.isVirtualScrolling()) {
                    this.virtualScrollingDispatcher = new _uiScheduler2.default(this)
                }
            };
            _proto2._render = function() {
                _WidgetObserver.prototype._render.call(this);
                this._renderDateTimeIndication();
                this._setIndicationUpdateInterval()
            };
            _proto2._toggleGroupedClass = function() {
                this.$element().toggleClass(GROUPED_WORKSPACE_CLASS, this._getGroupCount() > 0)
            };
            _proto2._toggleFixedScrollableClass = function() {
                return (0, _common.noop)()
            };
            _proto2._renderView = function() {
                this._setFirstViewDate();
                this._applyCellTemplates(this._renderGroupHeader());
                this._renderDateHeader();
                if (this.isRenovatedRender()) {
                    this.renderRWorkspace()
                } else {
                    this._renderTimePanel();
                    this._renderGroupAllDayPanel();
                    this._renderDateTable();
                    this._renderAllDayPanel()
                }
                this._updateGroupTableHeight();
                this._shader = new _uiSchedulerCurrent_time_shader.default(this)
            };
            _proto2.isGroupedAllDayPanel = function() {
                return this._isShowAllDayPanel() && this._isVerticalGroupedWorkSpace()
            };
            _proto2.generateRenderOptions = function() {
                var groupCount = this._getGroupCount();
                var verticalGroupCount = !this._isVerticalGroupedWorkSpace() ? 1 : groupCount;
                var horizontalGroupCount = this._isVerticalGroupedWorkSpace() ? 1 : groupCount;
                var allDayElements = this._insertAllDayRowsIntoDateTable() ? this._allDayTitles : void 0;
                var rowCountInGroup = this._getRowCount();
                var cellCount = this._getTotalCellCount(groupCount);
                var options = {
                    horizontalGroupCount: horizontalGroupCount,
                    verticalGroupCount: verticalGroupCount,
                    rowCountInGroup: rowCountInGroup,
                    cellCount: cellCount,
                    cellCountInGroupRow: this._getCellCount(),
                    cellDataGetters: [this._getCellData.bind(this)],
                    allDayElements: allDayElements,
                    startRowIndex: 0,
                    groupOrientation: this.option("groupOrientation"),
                    nonVirtualRowCount: this._getRowCount(),
                    groupCount: groupCount
                };
                if (this.isVirtualScrolling()) {
                    (0, _extend.extend)(options, this.virtualScrollingDispatcher.renderState)
                } else {
                    options.rowCount = this._getTotalRowCount(groupCount, this._isVerticalGroupedWorkSpace())
                }
                return options
            };
            _proto2.renovatedRenderSupported = function() {
                return false
            };
            _proto2.renderRWorkspace = function() {
                var _this$virtualScrollin2;
                var isGenerateNewViewData = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : true;
                this._cleanAllowedPositions();
                this.viewDataProvider.update(isGenerateNewViewData);
                this.renderRAllDayPanel();
                this.renderRTimeTable();
                this.renderRDateTable();
                this.updateRSelection();
                null === (_this$virtualScrollin2 = this.virtualScrollingDispatcher) || void 0 === _this$virtualScrollin2 ? void 0 : _this$virtualScrollin2.updateDimensions()
            };
            _proto2.renderRAllDayPanel = function() {
                var visible = this._isShowAllDayPanel() && !this.isGroupedAllDayPanel();
                if (visible) {
                    var options = {
                        viewData: this.viewDataProvider.viewData,
                        visible: visible,
                        dataCellTemplate: this.option("dataCellTemplate")
                    };
                    this.renderRComponent(this._$allDayPanel, _layout.default, "renovatedAllDayPanel", options);
                    this.renderRComponent(this._$allDayTitle, _title.default, "renovatedAllDayPanelTitle", {
                        visible: visible
                    });
                    this._$allDayTable = this.renovatedAllDayPanel.$element().find(".".concat(ALL_DAY_TABLE_CLASS))
                }
                this._toggleAllDayVisibility()
            };
            _proto2.renderRTimeTable = function() {
                this.renderRComponent(this._$timePanel, _layout2.default, "renovatedTimePanel", {
                    viewData: this.viewDataProvider.viewData,
                    timeCellTemplate: this.option("timeCellTemplate")
                })
            };
            _proto2.renderRDateTable = function() {};
            _proto2.renderRComponent = function(parentElement, componentClass, componentName, viewModel) {
                var component = this[componentName];
                if (!component) {
                    var container = (0, _element.getPublicElement)(parentElement);
                    component = this._createComponent(container, componentClass, _objectSpread(_objectSpread({}, viewModel), {}, {
                        groupOrientation: this.option("groupOrientation")
                    }));
                    this[componentName] = component
                } else {
                    Object.getOwnPropertyNames(viewModel).forEach(function(optionName) {
                        component.option(optionName, viewModel[optionName])
                    })
                }
            };
            _proto2.updateRSelection = function() {
                var isVerticalGrouping = this._isVerticalGroupedWorkSpace();
                var focusedCell = this.virtualSelectionState.getFocusedCell(isVerticalGrouping);
                var selectedCells = this.virtualSelectionState.getSelectedCells();
                if (focusedCell) {
                    var coordinates = focusedCell.coordinates,
                        cellData = focusedCell.cellData;
                    var $cell = !isVerticalGrouping && cellData.allDay ? this._dom_getAllDayPanelCell(coordinates.cellIndex) : this._dom_getDateCell(coordinates);
                    $cell && this._setFocusedCell($cell)
                }
                selectedCells && this._setSelectedCellsByCellData(selectedCells)
            };
            _proto2._updateGroupTableHeight = function() {
                if (this._isVerticalGroupedWorkSpace() && (0, _window.hasWindow)()) {
                    this._setHorizontalGroupHeaderCellsHeight()
                }
            };
            _proto2._renderDateTimeIndication = function() {
                return (0, _common.noop)()
            };
            _proto2._setIndicationUpdateInterval = function() {
                return (0, _common.noop)()
            };
            _proto2._refreshDateTimeIndication = function() {
                return (0, _common.noop)()
            };
            _proto2._setFocusOnCellByOption = function(data) {
                this._releaseSelectedAndFocusedCells();
                this._setSelectedCellsByCellData(data)
            };
            _proto2._setSelectedCellsByCellData = function(data) {
                var _data$, _this4 = this;
                var cells = [];
                var $cells = this._getAllCells(null === data || void 0 === data ? void 0 : null === (_data$ = data[0]) || void 0 === _data$ ? void 0 : _data$.allDay);
                var cellsInRow = this._getTotalCellCount(this._getGroupCount());
                data.forEach(function(cellData) {
                    var groups = cellData.groups,
                        startDate = cellData.startDate,
                        allDay = cellData.allDay;
                    var groupIndex = cellData.groupIndex;
                    if (!groupIndex) {
                        groupIndex = _this4._isGroupsSpecified(groups) ? _this4._getGroupIndexByResourceId(groups) : 0
                    }
                    var coordinates = _this4.isVirtualScrolling() ? _this4.viewDataProvider.findCellPositionInMap(groupIndex, startDate, allDay) : _this4.getCoordinatesByDate(startDate, groupIndex, allDay);
                    if (coordinates) {
                        var rowIndex = coordinates.rowIndex,
                            cellIndex = coordinates.cellIndex;
                        var index = rowIndex * cellsInRow + cellIndex;
                        var $cell = $cells[index];
                        if ((0, _type.isDefined)($cell)) {
                            _this4._toggleFocusClass(true, (0, _renderer.default)($cell));
                            cells.push($cell)
                        }
                    }
                });
                this._selectedCells = cells
            };
            _proto2._isGroupsSpecified = function(resources) {
                return this.option("groups").length && resources
            };
            _proto2._getGroupIndexByResourceId = function(id) {
                var groups = this.option("groups");
                var resourceTree = this.invoke("createResourcesTree", groups);
                if (!resourceTree.length) {
                    return 0
                }
                return this._getGroupIndexRecursively(resourceTree, id)
            };
            _proto2._getGroupIndexRecursively = function(resourceTree, id) {
                var _this5 = this;
                var currentKey = resourceTree[0].name;
                var currentValue = id[currentKey];
                return resourceTree.reduce(function(prevIndex, _ref2) {
                    var leafIndex = _ref2.leafIndex,
                        value = _ref2.value,
                        children = _ref2.children;
                    var areValuesEqual = currentValue === value;
                    if (areValuesEqual && void 0 !== leafIndex) {
                        return leafIndex
                    }
                    if (areValuesEqual) {
                        return _this5._getGroupIndexRecursively(children, id)
                    }
                    return prevIndex
                }, 0)
            };
            _proto2._getCalculatedFirstDayOfWeek = function() {
                var firstDayOfWeekOption = this._firstDayOfWeek();
                var firstDayOfWeek = (0, _type.isDefined)(firstDayOfWeekOption) ? firstDayOfWeekOption : _date2.default.firstDayOfWeekIndex();
                return firstDayOfWeek
            };
            _proto2._setFirstViewDate = function() {
                var firstDayOfWeek = this._getCalculatedFirstDayOfWeek();
                this._firstViewDate = _date.default.getFirstWeekDate(this._getViewStartByOptions(), firstDayOfWeek);
                this._setStartDayHour(this._firstViewDate)
            };
            _proto2._getViewStartByOptions = function() {
                if (!this.option("startDate")) {
                    return this.option("currentDate")
                } else {
                    var startDate = _date.default.trimTime(this._getStartViewDate());
                    var currentDate = this.option("currentDate");
                    var diff = startDate.getTime() <= currentDate.getTime() ? 1 : -1;
                    var endDate = new Date(startDate.getTime() + this._getIntervalDuration() * diff);
                    while (!this._dateInRange(currentDate, startDate, endDate, diff)) {
                        startDate = endDate;
                        endDate = new Date(startDate.getTime() + this._getIntervalDuration() * diff)
                    }
                    return diff > 0 ? startDate : endDate
                }
            };
            _proto2._getHeaderDate = function() {
                return this.getStartViewDate()
            };
            _proto2._getStartViewDate = function() {
                return this.option("startDate")
            };
            _proto2._dateInRange = function(date, startDate, endDate, diff) {
                return diff > 0 ? _date.default.dateInRange(date, startDate, new Date(endDate.getTime() - 1)) : _date.default.dateInRange(date, endDate, startDate, "date")
            };
            _proto2._getIntervalDuration = function() {
                return toMs("day") * this.option("intervalCount")
            };
            _proto2._setStartDayHour = function(date) {
                var startDayHour = this.option("startDayHour");
                if ((0, _type.isDefined)(startDayHour)) {
                    date.setHours(startDayHour, startDayHour % 1 * 60, 0, 0)
                }
            };
            _proto2._firstDayOfWeek = function() {
                return this.option("firstDayOfWeek")
            };
            _proto2._attachEvents = function() {
                this._createSelectionChangedAction();
                this._attachClickEvent();
                this._attachContextMenuEvent()
            };
            _proto2._attachClickEvent = function() {
                var that = this;
                var pointerDownAction = this._createAction(function(e) {
                    that._pointerDownHandler(e.event)
                });
                this._createCellClickAction();
                var cellSelector = "." + DATE_TABLE_CELL_CLASS + ",." + ALL_DAY_TABLE_CELL_CLASS;
                var $element = this.$element();
                _events_engine.default.off($element, SCHEDULER_WORKSPACE_DXPOINTERDOWN_EVENT_NAME);
                _events_engine.default.off($element, SCHEDULER_CELL_DXCLICK_EVENT_NAME);
                _events_engine.default.on($element, SCHEDULER_WORKSPACE_DXPOINTERDOWN_EVENT_NAME, function(e) {
                    if ((0, _index.isMouseEvent)(e) && e.which > 1) {
                        e.preventDefault();
                        return
                    }
                    pointerDownAction({
                        event: e
                    })
                });
                _events_engine.default.on($element, SCHEDULER_CELL_DXCLICK_EVENT_NAME, cellSelector, function(e) {
                    var $cell = (0, _renderer.default)(e.target);
                    that._cellClickAction({
                        event: e,
                        cellElement: (0, _element.getPublicElement)($cell),
                        cellData: that.getCellData($cell)
                    })
                })
            };
            _proto2._createCellClickAction = function() {
                var _this6 = this;
                this._cellClickAction = this._createActionByOption("onCellClick", {
                    afterExecute: function(e) {
                        return _this6._cellClickHandler(e.args[0].event)
                    }
                })
            };
            _proto2._createSelectionChangedAction = function() {
                this._selectionChangedAction = this._createActionByOption("onSelectionChanged")
            };
            _proto2._cellClickHandler = function(e) {
                var $target = (0, _renderer.default)(e.target);
                if (this._showPopup && this._hasFocusClass($target)) {
                    delete this._showPopup;
                    this._showAddAppointmentPopup($target)
                }
            };
            _proto2._pointerDownHandler = function(e) {
                var $target = (0, _renderer.default)(e.target);
                if (!$target.hasClass(DATE_TABLE_CELL_CLASS) && !$target.hasClass(ALL_DAY_TABLE_CELL_CLASS)) {
                    this._isCellClick = false;
                    return
                }
                this._isCellClick = true;
                if ($target.hasClass(DATE_TABLE_FOCUSED_CELL_CLASS)) {
                    this._showPopup = true
                } else {
                    this._setSelectedAndFocusedCells($target)
                }
            };
            _proto2._showAddAppointmentPopup = function($cell) {
                var firstCellData = this.getCellData($cell.first());
                var lastCellData = this.getCellData($cell.last());
                if (this.isVirtualScrolling()) {
                    var selectedCells = this.virtualSelectionState.getSelectedCells();
                    firstCellData = selectedCells[0];
                    lastCellData = selectedCells[selectedCells.length - 1]
                }
                var result = {
                    startDate: firstCellData.startDate,
                    endDate: lastCellData.endDate
                };
                if (void 0 !== lastCellData.allDay) {
                    result.allDay = lastCellData.allDay
                }
                this.invoke("showAddAppointmentPopup", result, lastCellData.groups)
            };
            _proto2._attachContextMenuEvent = function() {
                this._createContextMenuAction();
                var cellSelector = "." + DATE_TABLE_CELL_CLASS + ",." + ALL_DAY_TABLE_CELL_CLASS;
                var $element = this.$element();
                var eventName = (0, _index.addNamespace)(_contextmenu.name, this.NAME);
                _events_engine.default.off($element, eventName, cellSelector);
                _events_engine.default.on($element, eventName, cellSelector, this._contextMenuHandler.bind(this))
            };
            _proto2._contextMenuHandler = function(e) {
                var $cell = (0, _renderer.default)(e.target);
                this._contextMenuAction({
                    event: e,
                    cellElement: (0, _element.getPublicElement)($cell),
                    cellData: this.getCellData($cell)
                });
                this._contextMenuHandled = true
            };
            _proto2._createContextMenuAction = function() {
                this._contextMenuAction = this._createActionByOption("onCellContextMenu")
            };
            _proto2._getGroupHeaderContainer = function() {
                if (this._isVerticalGroupedWorkSpace()) {
                    return this._$groupTable
                }
                return this._$thead
            };
            _proto2._getDateHeaderContainer = function() {
                return this._$thead
            };
            _proto2._renderGroupHeader = function() {
                var $container = this._getGroupHeaderContainer();
                var groupCount = this._getGroupCount();
                var cellTemplates = [];
                if (groupCount) {
                    var groupRows = this._makeGroupRows(this.option("groups"), this.option("groupByDate"));
                    this._attachGroupCountAttr(groupCount, groupRows);
                    $container.append(groupRows.elements);
                    cellTemplates = groupRows.cellTemplates
                } else {
                    this._detachGroupCountAttr()
                }
                return cellTemplates
            };
            _proto2._applyCellTemplates = function(templates) {
                templates.forEach(function(template) {
                    template()
                })
            };
            _proto2._detachGroupCountAttr = function() {
                var groupedAttr = this._groupedStrategy.getGroupCountAttr();
                this.$element().removeAttr(groupedAttr.attr)
            };
            _proto2._attachGroupCountAttr = function(groupRowCount, groupRows) {
                var groupedAttr = this._groupedStrategy.getGroupCountAttr(groupRowCount, groupRows);
                this.$element().attr(groupedAttr.attr, groupedAttr.count)
            };
            _proto2.headerPanelOffsetRecalculate = function() {
                if (!this.option("resourceCellTemplate") && !this.option("dateCellTemplate")) {
                    return
                }
                var headerPanelHeight = this.getHeaderPanelHeight();
                var headerHeight = this.invoke("getHeaderHeight");
                var allDayPanelHeight = this.supportAllDayRow() && this._isShowAllDayPanel() ? this._groupedStrategy.getAllDayTableHeight() : 0;
                headerPanelHeight && this._headerScrollable && this._headerScrollable.$element().height(headerPanelHeight + allDayPanelHeight);
                headerPanelHeight && this._dateTableScrollable.$element().css({
                    paddingBottom: allDayPanelHeight + headerPanelHeight + "px",
                    marginBottom: -1 * (parseInt(headerPanelHeight, 10) + allDayPanelHeight) + "px"
                });
                headerPanelHeight && this._sidebarScrollable && this._sidebarScrollable.$element().css({
                    paddingBottom: allDayPanelHeight + headerPanelHeight + "px",
                    marginBottom: -1 * (parseInt(headerPanelHeight, 10) + allDayPanelHeight) + "px"
                });
                this._$allDayTitle && this._$allDayTitle.css("top", headerHeight + headerPanelHeight + "px")
            };
            _proto2._makeGroupRows = function(groups, groupByDate) {
                var tableCreatorStrategy = this._isVerticalGroupedWorkSpace() ? tableCreator.VERTICAL : tableCreator.HORIZONTAL;
                return tableCreator.makeGroupedTable(tableCreatorStrategy, groups, {
                    groupHeaderRowClass: this._getGroupRowClass(),
                    groupRowClass: this._getGroupRowClass(),
                    groupHeaderClass: this._getGroupHeaderClass.bind(this),
                    groupHeaderContentClass: this._getGroupHeaderContentClass()
                }, this._getCellCount() || 1, this.option("resourceCellTemplate"), this._getGroupCount(), groupByDate)
            };
            _proto2._getDateHeaderTemplate = function() {
                return this.option("dateCellTemplate")
            };
            _proto2._renderDateHeader = function() {
                var container = this._getDateHeaderContainer();
                var $headerRow = (0, _renderer.default)("<tr>").addClass(HEADER_ROW_CLASS);
                var count = this._getCellCount();
                var cellTemplate = this._getDateHeaderTemplate();
                var repeatCount = this._getCalculateHeaderCellRepeatCount();
                var templateCallbacks = [];
                var groupByDate = this.isGroupedByDate();
                if (!groupByDate) {
                    for (var rowIndex = 0; rowIndex < repeatCount; rowIndex++) {
                        for (var cellIndex = 0; cellIndex < count; cellIndex++) {
                            var templateIndex = rowIndex * repeatCount + cellIndex;
                            this._renderDateHeaderTemplate($headerRow, cellIndex, templateIndex, cellTemplate, templateCallbacks)
                        }
                    }
                    container.append($headerRow)
                } else {
                    var colSpan = groupByDate ? this._getGroupCount() : 1;
                    for (var _cellIndex = 0; _cellIndex < count; _cellIndex++) {
                        var _templateIndex = _cellIndex * repeatCount;
                        var cellElement = this._renderDateHeaderTemplate($headerRow, _cellIndex, _templateIndex, cellTemplate, templateCallbacks);
                        cellElement.attr("colSpan", colSpan)
                    }
                    container.prepend($headerRow)
                }
                this._applyCellTemplates(templateCallbacks);
                return $headerRow
            };
            _proto2._renderDateHeaderTemplate = function(container, panelCellIndex, templateIndex, cellTemplate, templateCallbacks) {
                var text = this._getHeaderText(panelCellIndex);
                var $cell = (0, _renderer.default)("<th>").addClass(this._getHeaderPanelCellClass(panelCellIndex)).attr("title", text);
                if (null !== cellTemplate && void 0 !== cellTemplate && cellTemplate.render) {
                    templateCallbacks.push(cellTemplate.render.bind(cellTemplate, {
                        model: {
                            text: text,
                            date: this._getDateByIndex(panelCellIndex)
                        },
                        index: templateIndex,
                        container: (0, _element.getPublicElement)($cell)
                    }))
                } else {
                    $cell.text(text)
                }
                container.append($cell);
                return $cell
            };
            _proto2._getHeaderPanelCellClass = function(i) {
                var cellClass = HEADER_PANEL_CELL_CLASS + " " + HORIZONTAL_SIZES_CLASS;
                return this._groupedStrategy.addAdditionalGroupCellClasses(cellClass, i + 1, void 0, void 0, this.isGroupedByDate())
            };
            _proto2._getCalculateHeaderCellRepeatCount = function() {
                return this._groupedStrategy.calculateHeaderCellRepeatCount()
            };
            _proto2._renderAllDayPanel = function(index) {
                var cellCount = this._getCellCount();
                if (!this._isVerticalGroupedWorkSpace()) {
                    cellCount *= this._getGroupCount() || 1
                }
                var cellTemplates = this._renderTableBody({
                    container: this._allDayPanels.length ? (0, _element.getPublicElement)(this._allDayTables[index]) : (0, _element.getPublicElement)(this._$allDayTable),
                    rowCount: 1,
                    cellCount: cellCount,
                    cellClass: this._getAllDayPanelCellClass.bind(this),
                    rowClass: ALL_DAY_TABLE_ROW_CLASS,
                    cellTemplate: this.option("dataCellTemplate"),
                    getCellData: this._getAllDayCellData.bind(this),
                    groupIndex: index
                }, true);
                this._toggleAllDayVisibility();
                this._applyCellTemplates(cellTemplates)
            };
            _proto2._renderGroupAllDayPanel = function() {
                if (this._isVerticalGroupedWorkSpace()) {
                    var groupCount = this._getGroupCount();
                    for (var i = 0; i < groupCount; i++) {
                        this._renderAllDayPanel(i)
                    }
                }
            };
            _proto2._getAllDayPanelCellClass = function(i, j) {
                var cellClass = ALL_DAY_TABLE_CELL_CLASS + " " + HORIZONTAL_SIZES_CLASS;
                return this._groupedStrategy.addAdditionalGroupCellClasses(cellClass, j + 1)
            };
            _proto2._getAllDayCellData = function(cell, rowIndex, cellIndex, groupIndex) {
                var startDate = this._getDateByCellIndexes(rowIndex, cellIndex);
                var cellGroupIndex = groupIndex || this._getGroupIndex(rowIndex, cellIndex);
                startDate = _date.default.trimTime(startDate);
                var data = {
                    startDate: startDate,
                    endDate: startDate,
                    allDay: true,
                    groupIndex: cellGroupIndex
                };
                var groups = this._getCellGroups(cellGroupIndex);
                if (groups.length) {
                    data.groups = {}
                }
                for (var i = 0; i < groups.length; i++) {
                    data.groups[groups[i].name] = groups[i].id
                }
                return {
                    key: CELL_DATA,
                    value: data
                }
            };
            _proto2._toggleAllDayVisibility = function() {
                var showAllDayPanel = this._isShowAllDayPanel();
                this._$allDayPanel.toggle(showAllDayPanel);
                this._$allDayTitle && this._$allDayTitle.toggleClass(ALL_DAY_TITLE_HIDDEN_CLASS, !showAllDayPanel);
                this.$element().toggleClass(WORKSPACE_WITH_ALL_DAY_CLASS, showAllDayPanel);
                this._changeAllDayVisibility();
                this._updateScrollable()
            };
            _proto2._changeAllDayVisibility = function() {
                this.$element().toggleClass(WORKSPACE_WITH_COLLAPSED_ALL_DAY_CLASS, !this.option("allDayExpanded") && this._isShowAllDayPanel())
            };
            _proto2._updateScrollable = function() {
                this._dateTableScrollable.update();
                this._headerScrollable && this._headerScrollable.update();
                this._sidebarScrollable && this._sidebarScrollable.update()
            };
            _proto2._renderTimePanel = function() {
                var _this7 = this;
                var repeatCount = this._groupedStrategy.calculateTimeCellRepeatCount();
                var startViewDate = _utils.default.getDateWithoutTimezoneChange(this.getStartViewDate());
                var _getTimeText = function(i) {
                    var index = i % _this7._getRowCount();
                    if (index % 2 === 0) {
                        return _date2.default.format(_this7._getTimeCellDateCore(startViewDate, i), "shorttime")
                    }
                    return ""
                };
                this._renderTableBody({
                    container: (0, _element.getPublicElement)(this._$timePanel),
                    rowCount: this._getTimePanelRowCount() * repeatCount,
                    cellCount: 1,
                    cellClass: this._getTimeCellClass.bind(this),
                    rowClass: TIME_PANEL_ROW_CLASS,
                    cellTemplate: this.option("timeCellTemplate"),
                    getCellText: _getTimeText.bind(this),
                    getCellDate: this._getTimeCellDate.bind(this),
                    groupCount: this._getGroupCount(),
                    allDayElements: this._insertAllDayRowsIntoDateTable() ? this._allDayTitles : void 0
                })
            };
            _proto2._getTimePanelRowCount = function() {
                return this._getCellCountInDay()
            };
            _proto2._getCellCountInDay = function(skipRound) {
                var result = this._calculateDayDuration() / this.option("hoursInterval");
                return skipRound ? result : Math.ceil(result)
            };
            _proto2._calculateDayDuration = function() {
                return this.option("endDayHour") - this.option("startDayHour")
            };
            _proto2._getTimeCellClass = function(i) {
                var cellClass = TIME_PANEL_CELL_CLASS + " " + VERTICAL_SIZES_CLASS;
                return this._isVerticalGroupedWorkSpace() ? this._groupedStrategy.addAdditionalGroupCellClasses(cellClass, i, i) : cellClass
            };
            _proto2._getTimeCellDate = function(i) {
                return this._getTimeCellDateCore(this.getStartViewDate(), i)
            };
            _proto2._getTimeCellDateCore = function(startViewDate, i) {
                var result = new Date(startViewDate);
                var timeCellDuration = Math.round(this.getCellDuration());
                var cellCountInDay = this._getCellCountInDay(true);
                result.setMilliseconds(result.getMilliseconds() + timeCellDuration * (i % cellCountInDay));
                return result
            };
            _proto2._renderDateTable = function() {
                var groupCount = this._getGroupCount();
                this._renderTableBody({
                    container: (0, _element.getPublicElement)(this._$dateTable),
                    rowCount: this._getTotalRowCount(groupCount),
                    cellCount: this._getTotalCellCount(groupCount),
                    cellClass: this._getDateTableCellClass.bind(this),
                    rowClass: this._getDateTableRowClass(),
                    cellTemplate: this.option("dataCellTemplate"),
                    getCellData: this._getCellData.bind(this),
                    allDayElements: this._insertAllDayRowsIntoDateTable() ? this._allDayPanels : void 0,
                    groupCount: groupCount,
                    groupByDate: this.option("groupByDate")
                })
            };
            _proto2._insertAllDayRowsIntoDateTable = function() {
                return this._groupedStrategy.insertAllDayRowsIntoDateTable()
            };
            _proto2._getTotalCellCount = function(groupCount) {
                return this._groupedStrategy.getTotalCellCount(groupCount)
            };
            _proto2._getTotalRowCount = function(groupCount, includeAllDayPanelRows) {
                var result = this._groupedStrategy.getTotalRowCount(groupCount);
                if (includeAllDayPanelRows && groupCount > 1 && this._isShowAllDayPanel()) {
                    result += groupCount
                }
                return result
            };
            _proto2._getCellData = function(cell, rowIndex, cellIndex) {
                var data = this._prepareCellData(rowIndex, cellIndex, cell);
                return {
                    key: CELL_DATA,
                    value: data
                }
            };
            _proto2._prepareCellData = function(rowIndex, cellIndex) {
                var startDate = this._getDateByCellIndexes(rowIndex, cellIndex);
                var endDate = this.calculateEndDate(startDate);
                var groupIndex = this._getGroupIndex(rowIndex, cellIndex);
                var data = {
                    startDate: startDate,
                    endDate: endDate,
                    allDay: this._getTableAllDay(),
                    groupIndex: groupIndex
                };
                var groups = this._getCellGroups(groupIndex);
                if (groups.length) {
                    data.groups = {}
                }
                for (var i = 0; i < groups.length; i++) {
                    data.groups[groups[i].name] = groups[i].id
                }
                return data
            };
            _proto2._getGroupIndex = function(rowIndex, cellIndex) {
                return this._groupedStrategy.getGroupIndex(rowIndex, cellIndex)
            };
            _proto2._getTableAllDay = function() {
                return false
            };
            _proto2.calculateEndDate = function(startDate) {
                var result = new Date(startDate);
                result.setMilliseconds(result.getMilliseconds() + Math.round(this._getInterval()));
                return result
            };
            _proto2._getGroupCount = function() {
                var groups = this.option("groups");
                var result = 0;
                for (var i = 0, len = groups.length; i < len; i++) {
                    if (!i) {
                        result = groups[i].items.length
                    } else {
                        result *= groups[i].items.length
                    }
                }
                return result
            };
            _proto2._getPathToLeaf = function(leafIndex) {
                var tree = this.invoke("createResourcesTree", this.option("groups"));

                function findLeafByIndex(data, index) {
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].leafIndex === index) {
                            return data[i]
                        } else {
                            var _leaf = findLeafByIndex(data[i].children, index);
                            if (_leaf) {
                                return _leaf
                            }
                        }
                    }
                }

                function makeBranch(leaf, result) {
                    result = result || [];
                    result.push(leaf.value);
                    if (leaf.parent) {
                        makeBranch(leaf.parent, result)
                    }
                    return result
                }
                var leaf = findLeafByIndex(tree, leafIndex);
                return makeBranch(leaf).reverse()
            };
            _proto2._getCellGroups = function(groupIndex) {
                var result = [];
                if (this._getGroupCount()) {
                    var groups = this.option("groups");
                    if (groupIndex < 0) {
                        return
                    }
                    var path = this._getPathToLeaf(groupIndex);
                    for (var i = 0; i < groups.length; i++) {
                        result.push({
                            name: groups[i].name,
                            id: path[i]
                        })
                    }
                }
                return result
            };
            _proto2._attachTablesEvents = function() {
                var _this8 = this;
                var that = this;
                var isPointerDown = false;
                var cellHeight;
                var cellWidth;
                var $element = this.$element();
                _events_engine.default.off($element, SCHEDULER_CELL_DXDRAGENTER_EVENT_NAME);
                _events_engine.default.off($element, SCHEDULER_CELL_DXDRAGLEAVE_EVENT_NAME);
                _events_engine.default.off($element, SCHEDULER_CELL_DXDROP_EVENT_NAME);
                _events_engine.default.off($element, SCHEDULER_CELL_DXPOINTERMOVE_EVENT_NAME);
                _events_engine.default.off($element, SCHEDULER_CELL_DXPOINTERDOWN_EVENT_NAME);
                _events_engine.default.on($element, SCHEDULER_CELL_DXDRAGENTER_EVENT_NAME, SCHEDULER_DRAG_AND_DROP_SELECTOR, {
                    itemSizeFunc: function($element) {
                        if (!cellHeight) {
                            cellHeight = (0, _position.getBoundingRect)($element.get(0)).height
                        }
                        if (!cellWidth) {
                            cellWidth = (0, _position.getBoundingRect)($element.get(0)).width
                        }
                        return {
                            width: cellWidth,
                            height: cellHeight
                        }
                    },
                    checkDropTarget: function(target, event) {
                        return !_this8._isOutsideScrollable(target, event)
                    }
                }, function(e) {
                    if (that._$currentTableTarget) {
                        that.removeDroppableCellClass(that._$currentTableTarget)
                    }
                    that._$currentTableTarget = (0, _renderer.default)(e.target);
                    that._$currentTableTarget.addClass(DATE_TABLE_DROPPABLE_CELL_CLASS)
                });
                _events_engine.default.on($element, SCHEDULER_CELL_DXDRAGLEAVE_EVENT_NAME, function(e) {
                    if (!$element.find((0, _renderer.default)(e.draggingElement)).length) {
                        that.removeDroppableCellClass()
                    }
                });
                _events_engine.default.on($element, SCHEDULER_CELL_DXDROP_EVENT_NAME, SCHEDULER_DRAG_AND_DROP_SELECTOR, function(e) {
                    that.removeDroppableCellClass((0, _renderer.default)(e.target));
                    cellHeight = 0;
                    cellWidth = 0
                });
                _events_engine.default.on($element, SCHEDULER_CELL_DXPOINTERDOWN_EVENT_NAME, SCHEDULER_DRAG_AND_DROP_SELECTOR, function(e) {
                    if ((0, _index.isMouseEvent)(e) && 1 === e.which) {
                        isPointerDown = true;
                        that.$element().addClass(WORKSPACE_WITH_MOUSE_SELECTION_CLASS);
                        _events_engine.default.off(_dom_adapter.default.getDocument(), SCHEDULER_CELL_DXPOINTERUP_EVENT_NAME);
                        _events_engine.default.on(_dom_adapter.default.getDocument(), SCHEDULER_CELL_DXPOINTERUP_EVENT_NAME, function() {
                            isPointerDown = false;
                            that.$element().removeClass(WORKSPACE_WITH_MOUSE_SELECTION_CLASS)
                        })
                    }
                });
                _events_engine.default.on($element, SCHEDULER_CELL_DXPOINTERMOVE_EVENT_NAME, SCHEDULER_DRAG_AND_DROP_SELECTOR, function(e) {
                    if (isPointerDown && that._dateTableScrollable && !that._dateTableScrollable.option("scrollByContent")) {
                        e.preventDefault();
                        e.stopPropagation();
                        that._moveToCell((0, _renderer.default)(e.target), true)
                    }
                })
            };
            _proto2._getDateTables = function() {
                return this._$dateTable.add(this._$allDayTable)
            };
            _proto2._getDateTable = function() {
                return this._$dateTable
            };
            _proto2._getAllDayTable = function() {
                return this._$allDayTable
            };
            _proto2._getInterval = function() {
                if (void 0 === this._interval) {
                    this._interval = this.option("hoursInterval") * HOUR_MS
                }
                return this._interval
            };
            _proto2._getHeaderText = function(headerIndex) {
                return _date2.default.format(this._getDateForHeaderText(headerIndex), this._getFormat())
            };
            _proto2._getDateForHeaderText = function(index) {
                return this._getDateByIndex(index)
            };
            _proto2._getDateByIndex = function() {
                return abstract()
            };
            _proto2._getFormat = function() {
                return abstract()
            };
            _proto2._calculateCellIndex = function(rowIndex, cellIndex) {
                return this._groupedStrategy.calculateCellIndex(rowIndex, cellIndex)
            };
            _proto2._renderTableBody = function(options, delayCellTemplateRendering) {
                var result = [];
                if (!delayCellTemplateRendering) {
                    this._applyCellTemplates(tableCreator.makeTable(options))
                } else {
                    result = tableCreator.makeTable(options)
                }
                return result
            };
            _proto2._removeAllDayElements = function() {
                this._$allDayTable && this._$allDayTable.remove();
                this._$allDayTitle && this._$allDayTitle.remove()
            };
            _proto2._cleanView = function() {
                var _this$virtualSelectio2;
                this.cache.clear();
                this._cleanAllowedPositions();
                null === (_this$virtualSelectio2 = this.virtualSelectionState) || void 0 === _this$virtualSelectio2 ? void 0 : _this$virtualSelectio2.releaseSelectedAndFocusedCells();
                this._$thead.empty();
                this._$dateTable.empty();
                this._shader && this._shader.clean();
                this._$timePanel.empty();
                this._$allDayTable && this._$allDayTable.empty();
                this._$groupTable.empty();
                delete this._hiddenInterval;
                delete this._interval
            };
            _proto2._clean = function() {
                _events_engine.default.off(_dom_adapter.default.getDocument(), SCHEDULER_CELL_DXPOINTERUP_EVENT_NAME);
                _WidgetObserver.prototype._clean.call(this)
            };
            _proto2._disposeRenovatedComponents = function() {
                var _this$renovatedAllDay, _this$renovatedDateTa, _this$renovatedTimePa;
                null === (_this$renovatedAllDay = this.renovatedAllDayPanel) || void 0 === _this$renovatedAllDay ? void 0 : _this$renovatedAllDay.dispose();
                this.renovatedAllDayPanel = void 0;
                null === (_this$renovatedDateTa = this.renovatedDateTable) || void 0 === _this$renovatedDateTa ? void 0 : _this$renovatedDateTa.dispose();
                this.renovatedDateTable = void 0;
                null === (_this$renovatedTimePa = this.renovatedTimePanel) || void 0 === _this$renovatedTimePa ? void 0 : _this$renovatedTimePa.dispose();
                this.renovatedTimePanel = void 0
            };
            _proto2.getWorkArea = function() {
                return this._dateTableScrollable.$content()
            };
            _proto2.getScrollable = function() {
                return this._dateTableScrollable
            };
            _proto2.getScrollableScrollTop = function() {
                return this._dateTableScrollable.scrollTop()
            };
            _proto2.getGroupedScrollableScrollTop = function(allDay) {
                return this._groupedStrategy.getScrollableScrollTop(allDay)
            };
            _proto2.getScrollableScrollLeft = function() {
                return this._dateTableScrollable.scrollLeft()
            };
            _proto2.getScrollableOuterWidth = function() {
                return this._dateTableScrollable.scrollWidth()
            };
            _proto2.getScrollableContainer = function() {
                return this._dateTableScrollable._container()
            };
            _proto2.getHeaderPanelHeight = function() {
                return this._$headerPanel && this._$headerPanel.outerHeight(true)
            };
            _proto2.getTimePanelWidth = function() {
                return this._$timePanel && (0, _position.getBoundingRect)(this._$timePanel.get(0)).width
            };
            _proto2.getGroupTableWidth = function() {
                return this._$groupTable ? this._$groupTable.outerWidth() : 0
            };
            _proto2.getWorkSpaceLeftOffset = function() {
                return this._groupedStrategy.getLeftOffset()
            };
            _proto2.getGroupedStrategy = function() {
                return this._groupedStrategy
            };
            _proto2._getCellCoordinatesByIndex = function(index) {
                var cellIndex = Math.floor(index / this._getRowCount());
                var rowIndex = index - this._getRowCount() * cellIndex;
                return {
                    cellIndex: cellIndex,
                    rowIndex: rowIndex
                }
            };
            _proto2._getDateByCellIndexes = function(rowIndex, cellIndex, patchedIndexes) {
                cellIndex = !patchedIndexes ? this._patchCellIndex(cellIndex) : cellIndex;
                var firstViewDate = this.getStartViewDate();
                var currentDate = new Date(firstViewDate.getTime() + this._getMillisecondsOffset(rowIndex, cellIndex) + this._getOffsetByCount(cellIndex));
                currentDate.setTime(currentDate.getTime() + _date.default.getTimezonesDifference(firstViewDate, currentDate));
                return currentDate
            };
            _proto2._patchCellIndex = function(cellIndex) {
                if (this.isGroupedByDate()) {
                    cellIndex = Math.floor(cellIndex / this._getGroupCount())
                }
                return cellIndex
            };
            _proto2._getOffsetByCount = function() {
                return 0
            };
            _proto2._getMillisecondsOffset = function(rowIndex, cellIndex) {
                return this._getInterval() * this._calculateCellIndex(rowIndex, cellIndex) + this._calculateHiddenInterval(rowIndex, cellIndex)
            };
            _proto2._calculateHiddenInterval = function(rowIndex, cellIndex) {
                var dayCount = cellIndex % this._getCellCount();
                return dayCount * this._getHiddenInterval()
            };
            _proto2._getHiddenInterval = function() {
                if (void 0 === this._hiddenInterval) {
                    this._hiddenInterval = DAY_MS - this.getVisibleDayDuration()
                }
                return this._hiddenInterval
            };
            _proto2._getIntervalBetween = function(currentDate, allDay) {
                var firstViewDate = this.getStartViewDate();
                var startDayTime = this.option("startDayHour") * HOUR_MS;
                var timeZoneOffset = _date.default.getTimezonesDifference(firstViewDate, currentDate);
                var fullInterval = currentDate.getTime() - firstViewDate.getTime() - timeZoneOffset;
                var days = this._getDaysOfInterval(fullInterval, startDayTime);
                var weekendsCount = this._getWeekendsCount(days);
                var result = (days - weekendsCount) * DAY_MS;
                if (!allDay) {
                    result = fullInterval - days * this._getHiddenInterval() - weekendsCount * this.getVisibleDayDuration()
                }
                return result
            };
            _proto2._getWeekendsCount = function() {
                return 0
            };
            _proto2._getDaysOfInterval = function(fullInterval, startDayTime) {
                return Math.floor((fullInterval + startDayTime) / DAY_MS)
            };
            _proto2._getGroupIndexes = function(appointmentResources) {
                var result = [];
                if (this._isGroupsSpecified(appointmentResources)) {
                    var tree = this.invoke("createResourcesTree", this.option("groups"));
                    result = this.invoke("getResourceTreeLeaves", tree, appointmentResources)
                }
                return result
            };
            _proto2._updateIndex = function(index) {
                return index * this._getRowCount()
            };
            _proto2._getDroppableCell = function() {
                return this._getDateTables().find("." + DATE_TABLE_DROPPABLE_CELL_CLASS)
            };
            _proto2._getWorkSpaceWidth = function() {
                var _this9 = this;
                return this.cache.get("workspaceWidth", function() {
                    if (_this9._needCreateCrossScrolling()) {
                        return (0, _position.getBoundingRect)(_this9._$dateTable.get(0)).width
                    }
                    return (0, _position.getBoundingRect)(_this9.$element().get(0)).width - _this9.getTimePanelWidth()
                })
            };
            _proto2._getCellPositionByIndex = function(index, groupIndex, inAllDayRow) {
                var cellCoordinates = this._getCellCoordinatesByIndex(index);
                var $cell = this._getCellByCoordinates(cellCoordinates, groupIndex, inAllDayRow);
                return this._getCellPositionWithCache($cell, cellCoordinates, groupIndex)
            };
            _proto2._getCellPositionWithCache = function($cell, cellCoordinates, groupIndex) {
                var result = this._getCellPosition($cell);
                this.setCellDataCache(cellCoordinates, groupIndex, $cell);
                if (result) {
                    result.rowIndex = cellCoordinates.rowIndex;
                    result.cellIndex = cellCoordinates.cellIndex
                }
                return result
            };
            _proto2._getCellPosition = function($cell) {
                var position = $cell.position();
                if (this.option("rtlEnabled")) {
                    position.left += (0, _position.getBoundingRect)($cell.get(0)).width
                }
                return position
            };
            _proto2._getCellByCoordinates = function(cellCoordinates, groupIndex, inAllDayRow) {
                var indexes = this._groupedStrategy.prepareCellIndexes(cellCoordinates, groupIndex, inAllDayRow);
                return this._dom_getDateCell(indexes)
            };
            _proto2._dom_getDateCell = function(position) {
                return this._$dateTable.find("tr:not(.".concat(VIRTUAL_ROW_CLASS, ")")).eq(position.rowIndex).find("td").eq(position.cellIndex)
            };
            _proto2._dom_getAllDayPanelCell = function(cellIndex) {
                return this._$allDayPanel.find("tr").eq(0).find("td").eq(cellIndex)
            };
            _proto2._getCells = function(allDay, direction) {
                var cellClass = allDay ? ALL_DAY_TABLE_CELL_CLASS : DATE_TABLE_CELL_CLASS;
                if ("vertical" === direction) {
                    var result = [];
                    for (var i = 1;; i++) {
                        var cells = this.$element().find("tr .".concat(cellClass, ":nth-child(").concat(i, ")"));
                        if (!cells.length) {
                            break
                        }
                        result = result.concat(cells.toArray())
                    }
                    return (0, _renderer.default)(result)
                } else {
                    return this.$element().find("." + cellClass)
                }
            };
            _proto2._getAllCells = function(allDay) {
                if (this._isVerticalGroupedWorkSpace()) {
                    return this._$dateTable.find("td:not(.".concat(VIRTUAL_CELL_CLASS, ")"))
                }
                var cellClass = allDay && this.supportAllDayRow() ? ALL_DAY_TABLE_CELL_CLASS : DATE_TABLE_CELL_CLASS;
                return this.$element().find("." + cellClass)
            };
            _proto2._setHorizontalGroupHeaderCellsHeight = function() {
                var height = (0, _position.getBoundingRect)(this._$dateTable.get(0)).height;
                this._$groupTable.outerHeight(height)
            };
            _proto2._getDateTableBorder = function() {
                return DATE_TABLE_CELL_BORDER
            };
            _proto2._getDateTableBorderOffset = function() {
                return 2 * this._getDateTableBorder()
            };
            _proto2._getGroupHeaderCellsContent = function() {
                return this.$element().find("." + GROUP_HEADER_CONTENT_CLASS)
            };
            _proto2._getGroupHeaderCells = function() {
                return this.$element().find("." + GROUP_HEADER_CLASS)
            };
            _proto2._getScrollCoordinates = function(hours, minutes, date, groupIndex, allDay) {
                var currentDate = date || new Date(this.option("currentDate"));
                var startDayHour = this.option("startDayHour");
                var endDayHour = this.option("endDayHour");
                if (hours < startDayHour) {
                    hours = startDayHour
                }
                if (hours >= endDayHour) {
                    hours = endDayHour - 1
                }
                currentDate.setHours(hours, minutes, 0, 0);
                if (!this.isVirtualScrolling()) {
                    return this.getCoordinatesByDate(currentDate, groupIndex, allDay)
                }
                var cell = this.viewDataProvider.findGlobalCellPosition(currentDate, groupIndex, allDay);
                var position = cell.position,
                    cellData = cell.cellData;
                return this.virtualScrollingDispatcher.calculateCoordinatesByDataAndPosition(cellData, position, currentDate)
            };
            _proto2._isOutsideScrollable = function(target, event) {
                var $dateTableScrollableElement = this._dateTableScrollable.$element();
                var scrollableSize = (0, _position.getBoundingRect)($dateTableScrollableElement.get(0));
                var window = (0, _window.getWindow)();
                var isTargetInAllDayPanel = !(0, _renderer.default)(target).closest($dateTableScrollableElement).length;
                var isOutsideHorizontalScrollable = event.pageX < scrollableSize.left || event.pageX > scrollableSize.left + scrollableSize.width + (window.scrollX || 0);
                var isOutsideVerticalScrollable = event.pageY < scrollableSize.top || event.pageY > scrollableSize.top + scrollableSize.height + (window.scrollY || 0);
                if (isTargetInAllDayPanel && !isOutsideHorizontalScrollable) {
                    return false
                }
                return isOutsideVerticalScrollable || isOutsideHorizontalScrollable
            };
            _proto2.setCellDataCache = function(cellCoordinates, groupIndex, $cell) {
                var key = JSON.stringify({
                    rowIndex: cellCoordinates.rowIndex,
                    cellIndex: cellCoordinates.cellIndex,
                    groupIndex: groupIndex
                });
                this.cache.set(key, this.getCellData($cell))
            };
            _proto2.setCellDataCacheAlias = function(appointment, geometry) {
                var key = JSON.stringify({
                    rowIndex: appointment.rowIndex,
                    cellIndex: appointment.cellIndex,
                    groupIndex: appointment.groupIndex
                });
                var aliasKey = JSON.stringify({
                    top: geometry.top,
                    left: geometry.left
                });
                this.cache.set(aliasKey, this.cache.get(key))
            };
            _proto2._cleanAllowedPositions = function() {
                this._maxAllowedVerticalPosition = [];
                this._maxAllowedPosition = []
            };
            _proto2.supportAllDayRow = function() {
                return true
            };
            _proto2.keepOriginalHours = function() {
                return false
            };
            _proto2.getSelectedCellData = function() {
                if (this.isVirtualScrolling()) {
                    return this.virtualSelectionState.getSelectedCells()
                }
                var $focusedCells = this._getAllFocusedCells();
                var result = [];
                if ($focusedCells.length > 1) {
                    result = this._getMultipleCellsData($focusedCells)
                } else {
                    var data = this.getCellData((0, _renderer.default)($focusedCells[0]));
                    data && result.push(data)
                }
                return result
            };
            _proto2._getMultipleCellsData = function($cells) {
                var data = [];
                for (var i = 0; i < $cells.length; i++) {
                    data.push(this.getCellData((0, _renderer.default)($cells[i])))
                }
                return data
            };
            _proto2.getCellData = function($cell) {
                var data;
                var currentCell = $cell[0];
                if (currentCell) {
                    if (this.isRenovatedRender()) {
                        data = this._getCellDataInRenovatedView($cell)
                    } else {
                        data = (0, _element_data.data)(currentCell, CELL_DATA)
                    }
                }
                return (0, _extend.extend)(true, {}, data)
            };
            _proto2._getVirtualRowOffset = function() {
                return this.isVirtualScrolling() ? this.virtualScrollingDispatcher.verticalScrollingState.virtualItemSizeBefore : 0
            };
            _proto2._getCellDataInRenovatedView = function($cell) {
                var rowIndex = $cell.parent().index();
                if (this.isVirtualScrolling()) {
                    rowIndex -= this.virtualScrollingDispatcher.topVirtualRowsCount
                }
                var columnIndex = $cell.index();
                var viewDataProvider = this.viewDataProvider;
                var isAllDayCell = this._hasAllDayClass($cell);
                var cellData = viewDataProvider.getCellData(rowIndex, columnIndex, isAllDayCell);
                return cellData ? {
                    startDate: cellData.startDate,
                    endDate: cellData.endDate,
                    groups: cellData.groups,
                    groupIndex: cellData.groupIndex,
                    allDay: cellData.allDay,
                    text: cellData.text
                } : void 0
            };
            _proto2._getHorizontalMax = function(groupIndex) {
                groupIndex = this.isGroupedByDate() ? this._getGroupCount() - 1 : groupIndex;
                return this._groupedStrategy.getHorizontalMax(groupIndex)
            };
            _proto2.getCoordinatesByDate = function(date, groupIndex, inAllDayRow) {
                groupIndex = groupIndex || 0;
                var position;
                var shouldFindPositionByViewData = this.isVirtualScrolling() && (!inAllDayRow || this._isVerticalGroupedWorkSpace());
                if (shouldFindPositionByViewData) {
                    var positionByMap = this.viewDataProvider.findCellPositionInMap(groupIndex, date, inAllDayRow);
                    if (!positionByMap) {
                        return
                    }
                    var $cell = this._dom_getDateCell(positionByMap);
                    position = this._getCellPositionWithCache($cell, positionByMap, groupIndex)
                } else {
                    position = this.calculateCellPositionByView(date, groupIndex, inAllDayRow)
                }
                var shift = this.getPositionShift(inAllDayRow ? 0 : this.getTimeShift(date), inAllDayRow);
                var horizontalHMax = this._getHorizontalMax(groupIndex, date);
                if (!position) {
                    throw _ui.default.Error("E1039")
                }
                return {
                    cellPosition: position.left + shift.cellPosition,
                    top: position.top + shift.top,
                    left: position.left + shift.left,
                    rowIndex: position.rowIndex,
                    cellIndex: position.cellIndex,
                    hMax: horizontalHMax,
                    vMax: this.getVerticalMax(groupIndex),
                    groupIndex: groupIndex
                }
            };
            _proto2.calculateCellPositionByView = function(date, groupIndex, inAllDayRow) {
                var index = this.getCellIndexByDate(date, inAllDayRow);
                var position = this._getCellPositionByIndex(index, groupIndex, inAllDayRow);
                if (position) {
                    position.top -= this._getVirtualRowOffset()
                }
                return position
            };
            _proto2.getVerticalMax = function(groupIndex) {
                return this._groupedStrategy.getVerticalMax(groupIndex)
            };
            _proto2._getOffsetByAllDayPanel = function(groupIndex) {
                return this._groupedStrategy._getOffsetByAllDayPanel(groupIndex)
            };
            _proto2._getGroupTop = function(groupIndex) {
                return this._groupedStrategy._getGroupTop(groupIndex)
            };
            _proto2.isGroupedByDate = function() {
                return this.option("groupByDate") && this._isHorizontalGroupedWorkSpace() && this._getGroupCount() > 0
            };
            _proto2.getCellIndexByDate = function(date, inAllDayRow) {
                var timeInterval = inAllDayRow ? 864e5 : this._getInterval();
                var dateTimeStamp = this._getIntervalBetween(date, inAllDayRow);
                var index = Math.floor(dateTimeStamp / timeInterval);
                if (inAllDayRow) {
                    index = this._updateIndex(index)
                }
                if (index < 0) {
                    index = 0
                }
                return index
            };
            _proto2.getPositionShift = function(timeShift, isAllDay) {
                return {
                    top: timeShift * this.getCellHeight(),
                    left: 0,
                    cellPosition: 0
                }
            };
            _proto2.getTimeShift = function(date) {
                var currentDayStart = new Date(date);
                var cellDuration = this.getCellDuration();
                var currentDayEndHour = new Date(new Date(date).setHours(this.option("endDayHour"), 0, 0));
                if (date.getTime() <= currentDayEndHour.getTime()) {
                    currentDayStart.setHours(this.option("startDayHour"), 0, 0, 0)
                }
                var timeZoneDifference = _date.default.getTimezonesDifference(date, currentDayStart);
                var currentDateTime = date.getTime();
                var currentDayStartTime = currentDayStart.getTime();
                var minTime = this._firstViewDate.getTime();
                return currentDateTime > minTime ? (currentDateTime - currentDayStartTime + timeZoneDifference) % cellDuration / cellDuration : 0
            };
            _proto2._isSkippedData = function() {
                return false
            };
            _proto2.getCoordinatesByDateInGroup = function(startDate, appointmentResources, inAllDayRow) {
                var _this10 = this;
                var result = [];
                if (this._isSkippedData(startDate)) {
                    return result
                }
                var groupIndices = this._getGroupCount() ? this._getGroupIndexes(appointmentResources) : [0];
                groupIndices.forEach(function(groupIndex) {
                    var coordinates = _this10.getCoordinatesByDate(startDate, groupIndex, inAllDayRow);
                    coordinates && result.push(coordinates)
                });
                return result
            };
            _proto2.getDroppableCellIndex = function() {
                var $droppableCell = this._getDroppableCell();
                var $row = $droppableCell.parent();
                var rowIndex = $row.index();
                return rowIndex * $row.find("td").length + $droppableCell.index()
            };
            _proto2.getDataByDroppableCell = function() {
                var cellData = this.getCellData((0, _renderer.default)(this._getDroppableCell()));
                var allDay = cellData.allDay;
                var startDate = cellData.startDate;
                var endDate = startDate && this.invoke("calculateAppointmentEndDate", allDay, startDate);
                return {
                    startDate: startDate,
                    endDate: endDate,
                    allDay: allDay,
                    groups: cellData.groups
                }
            };
            _proto2.getDateRange = function() {
                return [this.getStartViewDate(), this.getEndViewDateByEndDayHour()]
            };
            _proto2.getCellWidth = function() {
                var _this11 = this;
                return this.cache.get("cellWidth", function() {
                    var cell = _this11._getCells().first().get(0);
                    return cell && (0, _position.getBoundingRect)(cell).width
                })
            };
            _proto2.getCellMinWidth = function() {
                return DATE_TABLE_MIN_CELL_WIDTH
            };
            _proto2.getRoundedCellWidth = function(groupIndex, startIndex, cellCount) {
                if (groupIndex < 0) {
                    return 0
                }
                var $row = this.$element().find("." + this._getDateTableRowClass()).eq(0);
                var width = 0;
                var $cells = $row.find("." + DATE_TABLE_CELL_CLASS);
                var totalCellCount = this._getCellCount() * groupIndex;
                cellCount = cellCount || this._getCellCount();
                if (!(0, _type.isDefined)(startIndex)) {
                    startIndex = totalCellCount
                }
                for (var i = startIndex; i < totalCellCount + cellCount; i++) {
                    width += (0, _position.getBoundingRect)((0, _renderer.default)($cells).eq(i).get(0)).width
                }
                return width / (totalCellCount + cellCount - startIndex)
            };
            _proto2.getCellHeight = function() {
                var _this12 = this;
                var useCache = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : true;
                var callbackResult = function() {
                    var cell = _this12._getCells().first().get(0);
                    return cell && (0, _position.getBoundingRect)(cell).height
                };
                return useCache ? this.cache.get("cellHeight", callbackResult) : callbackResult()
            };
            _proto2.getAllDayHeight = function() {
                var cell = this._getCells(true).first().get(0);
                return this._isShowAllDayPanel() ? cell && (0, _position.getBoundingRect)(cell).height || 0 : 0
            };
            _proto2.getAllDayOffset = function() {
                return this._groupedStrategy.getAllDayOffset()
            };
            _proto2.getMaxAllowedPosition = function() {
                if (0 === this._maxAllowedPosition.length) {
                    var isRtl = this.option("rtlEnabled");
                    this._maxAllowedPosition = [];
                    this._$dateTable.find("tr:not(.".concat(VIRTUAL_ROW_CLASS, ")")).first().find("td:nth-child(".concat(this._getCellCount(), "n)")).each(function(_, cell) {
                        var maxPosition = (0, _renderer.default)(cell).position().left;
                        if (!isRtl) {
                            maxPosition += (0, _position.getBoundingRect)(cell).width
                        }
                        this._maxAllowedPosition.push(Math.round(maxPosition))
                    }.bind(this))
                }
                return this._maxAllowedPosition
            };
            _proto2.getMaxAllowedVerticalPosition = function(groupIndex) {
                if (this.isVirtualScrolling()) {
                    return this.getMaxAllowedVerticalPositionVirtual(groupIndex)
                }
                return this.getMaxAllowedVerticalPositionStandard(groupIndex)
            };
            _proto2.getMaxAllowedVerticalPositionStandard = function(groupIndex) {
                var _this13 = this;
                if (0 === this._maxAllowedVerticalPosition.length) {
                    var rowCount = this._getRowCount();
                    this._$dateTable.find("tr:not(.".concat(VIRTUAL_ROW_CLASS, "):nth-child(").concat(rowCount, "n)")).each(function(_, row) {
                        var maxPosition = (0, _renderer.default)(row).position().top + (0, _position.getBoundingRect)(row).height;
                        _this13._maxAllowedVerticalPosition.push(Math.round(maxPosition))
                    })
                }
                return this._maxAllowedVerticalPosition[groupIndex]
            };
            _proto2.getMaxAllowedVerticalPositionVirtual = function(groupIndex) {
                var _this14 = this;
                var getMaxPosition = function(rowIndex) {
                    var row = _this14._$dateTable.find("tr:not(.".concat(VIRTUAL_ROW_CLASS, ")")).get(rowIndex);
                    var maxPosition = (0, _renderer.default)(row).position().top + (0, _position.getBoundingRect)(row).height;
                    if (_this14.isGroupedAllDayPanel()) {
                        maxPosition -= (groupIndex + 1) * _this14.getAllDayHeight()
                    }
                    _this14._maxAllowedVerticalPosition[groupIndex] = Math.round(maxPosition)
                };
                if (!this._maxAllowedVerticalPosition[groupIndex]) {
                    var _this$viewDataProvide = this.viewDataProvider.getLasGroupCellPosition(groupIndex),
                        rowIndex = _this$viewDataProvide.rowIndex;
                    getMaxPosition(rowIndex)
                }
                return this._maxAllowedVerticalPosition[groupIndex]
            };
            _proto2.getFixedContainer = function() {
                return this._$fixedContainer
            };
            _proto2.getAllDayContainer = function() {
                return this._$allDayContainer
            };
            _proto2.getCellIndexByCoordinates = function(coordinates, allDay) {
                var cellCount = this._getTotalCellCount(this._getGroupCount());
                var cellWidth = Math.floor(this._getWorkSpaceWidth() / cellCount);
                var cellHeight = allDay ? this.getAllDayHeight() : this.getCellHeight();
                var leftOffset = this._isRTL() || this.option("crossScrollingEnabled") ? 0 : this.getWorkSpaceLeftOffset();
                var topIndex = Math.floor(Math.floor(coordinates.top) / Math.floor(cellHeight));
                var leftIndex = Math.floor((coordinates.left + 5 - leftOffset) / cellWidth);
                if (this._isRTL()) {
                    leftIndex = cellCount - leftIndex - 1
                }
                return cellCount * topIndex + leftIndex
            };
            _proto2.getStartViewDate = function() {
                return this._firstViewDate
            };
            _proto2.getEndViewDate = function() {
                var dateOfLastViewCell = this.getDateOfLastViewCell();
                var endDateOfLastViewCell = this.calculateEndViewDate(dateOfLastViewCell);
                return this._adjustEndViewDateByDaylightDiff(dateOfLastViewCell, endDateOfLastViewCell)
            };
            _proto2.getEndViewDateByEndDayHour = function() {
                var dateOfLastViewCell = this.getDateOfLastViewCell();
                var endTime = _date.default.dateTimeFromDecimal(this.option("endDayHour"));
                var endDateOfLastViewCell = new Date(dateOfLastViewCell.setHours(endTime.hours, endTime.minutes));
                return this._adjustEndViewDateByDaylightDiff(dateOfLastViewCell, endDateOfLastViewCell)
            };
            _proto2.calculateEndViewDate = function(dateOfLastViewCell) {
                return new Date(dateOfLastViewCell.getTime() + this.getCellDuration())
            };
            _proto2._adjustEndViewDateByDaylightDiff = function(startDate, endDate) {
                var daylightDiff = _utils.default.getDaylightOffsetInMs(startDate, endDate);
                var endDateOfLastViewCell = new Date(endDate.getTime() - daylightDiff);
                return new Date(endDateOfLastViewCell.getTime() - this._getEndViewDateTimeDiff())
            };
            _proto2._getEndViewDateTimeDiff = function() {
                return toMs("minute")
            };
            _proto2.getDateOfLastViewCell = function() {
                var rowIndex = this._getRowCount() - 1;
                var cellIndex = this._getCellCount();
                if (this.isGroupedByDate()) {
                    cellIndex = cellIndex * this._getGroupCount() - 1
                } else {
                    cellIndex -= 1
                }
                return this._getDateByCellIndexes(rowIndex, cellIndex, true)
            };
            _proto2.getCellDuration = function() {
                return 36e5 * this.option("hoursInterval")
            };
            _proto2.getIntervalDuration = function(allDay) {
                return allDay ? toMs("day") : this.getCellDuration()
            };
            _proto2.getVisibleDayDuration = function() {
                return this.option("hoursInterval") * this._getCellCountInDay() * HOUR_MS
            };
            _proto2.getGroupBounds = function(coordinates) {
                var cellCount = this._getCellCount();
                var $cells = this._getCells();
                var cellWidth = this.getCellWidth();
                var result = this._groupedStrategy.getGroupBoundsOffset(cellCount, $cells, cellWidth, coordinates);
                if (this._isRTL()) {
                    var startOffset = result.left;
                    result.left = result.right - 2 * cellWidth;
                    result.right = startOffset + 2 * cellWidth
                }
                return result
            };
            _proto2.needRecalculateResizableArea = function() {
                return this._isVerticalGroupedWorkSpace() && 0 !== this.getScrollable().scrollTop()
            };
            _proto2.getCellDataByCoordinates = function(coordinates, allDay) {
                var _this15 = this;
                var key = JSON.stringify({
                    top: coordinates.top,
                    left: coordinates.left
                });
                return this.cache.get(key, function() {
                    var $cells = _this15._getCells(allDay);
                    var cellIndex = _this15.getCellIndexByCoordinates(coordinates, allDay);
                    var $cell = $cells.eq(cellIndex);
                    return _this15.getCellData($cell)
                })
            };
            _proto2.getVisibleBounds = function() {
                var result = {};
                var $scrollable = this.getScrollable().$element();
                var cellHeight = this.getCellHeight();
                var scrolledCellCount = this.getScrollableScrollTop() / cellHeight;
                var totalCellCount = scrolledCellCount + $scrollable.height() / cellHeight;
                result.top = {
                    hours: Math.floor(scrolledCellCount * this.option("hoursInterval")) + this.option("startDayHour"),
                    minutes: scrolledCellCount % 2 ? 30 : 0
                };
                result.bottom = {
                    hours: Math.floor(totalCellCount * this.option("hoursInterval")) + this.option("startDayHour"),
                    minutes: Math.floor(totalCellCount) % 2 ? 30 : 0
                };
                return result
            };
            _proto2.updateScrollPosition = function(date, groups) {
                var allDay = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : false;
                var scheduler = this.option("observer");
                var newDate = scheduler.timeZoneCalculator.createDate(date, {
                    path: "toGrid"
                });
                var inAllDayRow = allDay && this.supportAllDayRow() && this._isShowAllDayPanel();
                if (this.needUpdateScrollPosition(newDate, groups, inAllDayRow)) {
                    this.scrollTo(newDate, groups, inAllDayRow, false)
                }
            };
            _proto2.needUpdateScrollPosition = function(date, groups, inAllDayRow) {
                var _this16 = this;
                var cells = this._getCellsInViewport(inAllDayRow);
                var groupIndex = this._isGroupsSpecified(groups) ? this._getGroupIndexByResourceId(groups) : 0;
                var time = date.getTime();
                var trimmedTime = _date.default.trimTime(date).getTime();
                return cells.reduce(function(currentResult, cell) {
                    var _this16$getCellData = _this16.getCellData(cell),
                        cellStartDate = _this16$getCellData.startDate,
                        cellEndDate = _this16$getCellData.endDate,
                        cellGroupIndex = _this16$getCellData.groupIndex;
                    var cellStartTime = cellStartDate.getTime();
                    var cellEndTime = cellEndDate.getTime();
                    if ((!inAllDayRow && cellStartTime <= time && time < cellEndTime || inAllDayRow && trimmedTime === cellStartTime) && groupIndex === cellGroupIndex) {
                        return false
                    }
                    return currentResult
                }, true)
            };
            _proto2._getCellsInViewport = function(inAllDayRow) {
                var $scrollable = this.getScrollable().$element();
                var cellHeight = this.getCellHeight();
                var cellWidth = this.getCellWidth();
                var totalColumnCount = this._getTotalCellCount(this._getGroupCount());
                var scrollableScrollTop = this.getScrollableScrollTop();
                var scrollableScrollLeft = this.getScrollableScrollLeft();
                var fullScrolledRowCount = scrollableScrollTop / cellHeight;
                if (this.isVirtualScrolling()) {
                    fullScrolledRowCount -= this.virtualScrollingDispatcher.topVirtualRowsCount
                }
                var scrolledRowCount = Math.floor(fullScrolledRowCount);
                if (scrollableScrollTop % cellHeight !== 0) {
                    scrolledRowCount += 1
                }
                var fullScrolledColumnCount = scrollableScrollLeft / cellWidth;
                var scrolledColumnCount = Math.floor(fullScrolledColumnCount);
                if (scrollableScrollLeft % cellWidth !== 0) {
                    scrolledColumnCount += 1
                }
                var rowCount = Math.floor(fullScrolledRowCount + $scrollable.height() / cellHeight);
                var columnCount = Math.floor(fullScrolledColumnCount + $scrollable.width() / cellWidth);
                var $cells = this._getAllCells(inAllDayRow);
                var result = [];
                $cells.each(function(index) {
                    var $cell = (0, _renderer.default)(this);
                    var columnIndex = index % totalColumnCount;
                    var rowIndex = index / totalColumnCount;
                    if (scrolledColumnCount <= columnIndex && columnIndex < columnCount && scrolledRowCount <= rowIndex && rowIndex < rowCount) {
                        result.push($cell)
                    }
                });
                return result
            };
            _proto2.getGroupWidth = function(groupIndex) {
                var result = this._getCellCount() * this.getCellWidth();
                var position = this.getMaxAllowedPosition();
                var currentPosition = position[groupIndex];
                if (position.length && currentPosition) {
                    if (this._isRTL()) {
                        result = currentPosition - position[groupIndex + 1]
                    } else {
                        if (0 === groupIndex) {
                            result = currentPosition
                        } else {
                            result = currentPosition - position[groupIndex - 1]
                        }
                    }
                }
                return result
            };
            _proto2.scrollToTime = function(hours, minutes, date) {
                if (!this._isValidScrollDate(date)) {
                    return
                }
                var coordinates = this._getScrollCoordinates(hours, minutes, date);
                var scrollable = this.getScrollable();
                scrollable.scrollBy({
                    top: coordinates.top - scrollable.scrollTop(),
                    left: 0
                })
            };
            _proto2.scrollTo = function(date, groups) {
                var allDay = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : false;
                var throwWarning = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : true;
                if (!this._isValidScrollDate(date, throwWarning)) {
                    return
                }
                var groupIndex = this._getGroupCount() && groups ? this._getGroupIndexByResourceId(groups) : 0;
                var isScrollToAllDay = allDay && this.supportAllDayRow() && this._isShowAllDayPanel();
                var coordinates = this._getScrollCoordinates(date.getHours(), date.getMinutes(), date, groupIndex, isScrollToAllDay);
                var scrollable = this.getScrollable();
                var $scrollable = scrollable.$element();
                var offset = this.option("rtlEnabled") ? this.getCellWidth() : 0;
                var scrollableHeight = $scrollable.height();
                var scrollableWidth = $scrollable.width();
                var cellWidth = this.getCellWidth();
                var cellHeight = this.getCellHeight();
                var xShift = (scrollableWidth - cellWidth) / 2;
                var yShift = (scrollableHeight - cellHeight) / 2;
                var left = coordinates.left - scrollable.scrollLeft() - xShift - offset;
                var top = coordinates.top - scrollable.scrollTop() - yShift;
                if (isScrollToAllDay && !this._isVerticalGroupedWorkSpace()) {
                    top = 0
                }
                if (this.option("templatesRenderAsynchronously")) {
                    setTimeout(function() {
                        scrollable.scrollBy({
                            left: left,
                            top: top
                        })
                    })
                } else {
                    scrollable.scrollBy({
                        left: left,
                        top: top
                    })
                }
            };
            _proto2._isValidScrollDate = function(date) {
                var throwWarning = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : true;
                var min = this.getStartViewDate();
                var max = this.getEndViewDate();
                if (date < min || date > max) {
                    throwWarning && _ui.default.log("W1008", date);
                    return false
                }
                return true
            };
            _proto2.getDistanceBetweenCells = function(startIndex, endIndex) {
                var result = 0;
                this.$element().find("." + this._getDateTableRowClass()).first().find("." + DATE_TABLE_CELL_CLASS).each(function(index) {
                    if (index < startIndex || index > endIndex) {
                        return true
                    }
                    result += (0, _position.getBoundingRect)(this).width
                });
                return result
            };
            _proto2.needApplyCollectorOffset = function() {
                return false
            };
            _proto2.initDragBehavior = function(scheduler) {
                if (!this.dragBehavior && scheduler) {
                    this.dragBehavior = new _appointmentDragBehavior.default(scheduler);
                    this._createDragBehavior(this.getWorkArea());
                    this._createDragBehavior(this.getAllDayContainer());
                    this._createDragBehavior(this._$allDayPanel)
                }
            };
            _proto2._createDragBehavior = function($element) {
                var getItemData = function(itemElement, appointments) {
                    return appointments._getItemData(itemElement)
                };
                var getItemSettings = function($itemElement) {
                    return $itemElement.data(_constants.APPOINTMENT_SETTINGS_KEY)
                };
                this._createDragBehaviorBase($element, getItemData, getItemSettings)
            };
            _proto2._createDragBehaviorBase = function($element, getItemData, getItemSettings) {
                var _this17 = this;
                var _ref3 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
                    isSetCursorOffset = _ref3.isSetCursorOffset,
                    restOptions = _objectWithoutProperties(_ref3, ["isSetCursorOffset"]);
                var dragElement;
                var dragBehavior = this.dragBehavior;
                var itemData;
                dragBehavior.addTo($element, _objectSpread({
                    container: this.$element().find(".".concat(_constants.FIXED_CONTAINER_CLASS)),
                    dragTemplate: function() {
                        return dragElement
                    },
                    onDragStart: function(e) {
                        var canceled = e.cancel;
                        var event = e.event;
                        var $itemElement = (0, _renderer.default)(e.itemElement);
                        var appointments = e.component._appointments;
                        itemData = getItemData(e.itemElement, appointments);
                        var settings = getItemSettings($itemElement, e);
                        if (itemData && !itemData.disabled) {
                            event.data = event.data || {};
                            if (!canceled) {
                                if (!settings.isCompact) {
                                    dragBehavior.updateDragSource(itemData, settings)
                                }
                                dragElement = _this17._createDragAppointment(itemData, settings, appointments);
                                event.data.itemElement = dragElement;
                                event.data.initialPosition = (0, _translator.locate)((0, _renderer.default)(dragElement));
                                event.data.itemData = itemData;
                                event.data.itemSettings = settings;
                                dragBehavior.onDragStart(event.data);
                                (0, _translator.resetPosition)((0, _renderer.default)(dragElement))
                            }
                        }
                    },
                    onDragEnd: function(e) {
                        var _dragElement;
                        if (itemData && !itemData.disabled) {
                            dragBehavior.onDragEnd(e)
                        }
                        null === (_dragElement = dragElement) || void 0 === _dragElement ? void 0 : _dragElement.remove()
                    },
                    cursorOffset: isSetCursorOffset ? function() {
                        var $dragElement = (0, _renderer.default)(dragElement);
                        return {
                            x: $dragElement.width() / 2,
                            y: $dragElement.height() / 2
                        }
                    } : void 0
                }, restOptions))
            };
            _proto2._createDragAppointment = function(itemData, settings, appointments) {
                var appointmentIndex = appointments.option("items").length;
                settings.isCompact = false;
                settings.virtual = false;
                var items = appointments._renderItem(appointmentIndex, {
                    itemData: itemData,
                    settings: [settings]
                });
                return items[0]
            };
            _proto2._isApplyCompactAppointmentOffset = function() {
                return this._supportCompactDropDownAppointments()
            };
            _proto2._supportCompactDropDownAppointments = function() {
                return true
            };
            _proto2._formatWeekday = function(date) {
                return formatWeekday(date)
            };
            _proto2._formatWeekdayAndDay = function(date) {
                return formatWeekday(date) + " " + _date2.default.format(date, "day")
            };
            _proto2.removeDroppableCellClass = function($cellElement) {
                ($cellElement || this._getDroppableCell()).removeClass(DATE_TABLE_DROPPABLE_CELL_CLASS)
            };
            _proto2._getCoordinatesByCell = function($cell) {
                var columnIndex = $cell.index();
                var rowIndex = $cell.parent().index();
                var isAllDayCell = this._hasAllDayClass($cell);
                var isVerticalGrouping = this._isVerticalGroupedWorkSpace();
                if (this.isVirtualScrolling() && !(isAllDayCell && !isVerticalGrouping)) {
                    rowIndex -= this.virtualScrollingDispatcher.topVirtualRowsCount
                }
                return {
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                }
            };
            _proto2._isShowAllDayPanel = function() {
                return this.option("showAllDayPanel")
            };
            _proto2.updateAppointments = function() {
                var _this$dragBehavior;
                this.invoke("renderAppointments");
                null === (_this$dragBehavior = this.dragBehavior) || void 0 === _this$dragBehavior ? void 0 : _this$dragBehavior.updateDragSource()
            };
            _createClass(SchedulerWorkSpace, [{
                key: "viewDataProvider",
                get: function() {
                    if (!this._viewDataProvider) {
                        this._viewDataProvider = new _view_data_provider.default(this)
                    }
                    return this._viewDataProvider
                }
            }, {
                key: "cache",
                get: function() {
                    return _cache.cache
                }
            }, {
                key: "virtualSelectionState",
                get: function() {
                    if (!this._virtualSelectionState) {
                        this._virtualSelectionState = new _virtual_selection_state.default(this.viewDataProvider)
                    }
                    return this._virtualSelectionState
                }
            }]);
            return SchedulerWorkSpace
        }(_widgetObserver.default);
        var _default = SchedulerWorkSpace;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/workspaces/ui.scheduler.work_space.grouped.strategy.js ***!
      \******************************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var LAST_GROUP_CELL_CLASS = "dx-scheduler-last-group-cell";
        var FIRST_GROUP_CELL_CLASS = "dx-scheduler-first-group-cell";
        var GroupedStrategy = function() {
            function GroupedStrategy(workSpace) {
                this._workSpace = workSpace
            }
            var _proto = GroupedStrategy.prototype;
            _proto.getLastGroupCellClass = function() {
                return LAST_GROUP_CELL_CLASS
            };
            _proto.getFirstGroupCellClass = function() {
                return FIRST_GROUP_CELL_CLASS
            };
            _proto._getOffsetByAllDayPanel = function() {
                return 0
            };
            _proto._getGroupTop = function() {
                return 0
            };
            return GroupedStrategy
        }();
        var _default = GroupedStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/workspaces/cache.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.cache = exports.Cache = void 0;
        var _type = __webpack_require__( /*! ../../../core/utils/type */ 1);

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }
        var Cache = function() {
            function Cache() {
                this._init()
            }
            var _proto = Cache.prototype;
            _proto._init = function() {
                this._cache = new Map
            };
            _proto.clear = function() {
                this._init()
            };
            _proto.get = function(name, callback) {
                if (!this._cache.has(name) && callback) {
                    this.set(name, callback())
                }
                return this._cache.get(name)
            };
            _proto.set = function(name, value) {
                (0, _type.isDefined)(value) && this._cache.set(name, value)
            };
            _createClass(Cache, [{
                key: "size",
                get: function() {
                    return this._cache.size
                }
            }]);
            return Cache
        }();
        exports.Cache = Cache;
        var cache = new Cache;
        exports.cache = cache
    },
    /*!*******************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/shaders/ui.scheduler.current_time_shader.js ***!
      \*******************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _position = __webpack_require__( /*! ../../../core/utils/position */ 22);
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../../core/renderer */ 2));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DATE_TIME_SHADER_CLASS = "dx-scheduler-date-time-shader";
        var CurrentTimeShader = function() {
            function CurrentTimeShader(workSpace) {
                this._workSpace = workSpace;
                this._$container = this._workSpace._dateTableScrollable.$content()
            }
            var _proto = CurrentTimeShader.prototype;
            _proto.render = function() {
                var _this = this;
                this.initShaderElements();
                this.renderShader();
                this.applyShaderMargin(this._$shader);
                this._shader.forEach(function(shader, index) {
                    _this._$container.append(shader)
                })
            };
            _proto.initShaderElements = function() {
                this._$shader = this.createShader();
                this._shader = [];
                this._shader.push(this._$shader)
            };
            _proto.renderShader = function() {};
            _proto.applyShaderMargin = function($shader) {
                if ($shader && this._workSpace.option("crossScrollingEnabled")) {
                    $shader.css("marginTop", -(0, _position.getBoundingRect)(this._$container.get(0)).height);
                    $shader.css("height", (0, _position.getBoundingRect)(this._$container.get(0)).height)
                }
            };
            _proto.createShader = function() {
                return (0, _renderer.default)("<div>").addClass(DATE_TIME_SHADER_CLASS)
            };
            _proto.clean = function() {
                this._$container && this._$container.find("." + DATE_TIME_SHADER_CLASS).remove()
            };
            return CurrentTimeShader
        }();
        var _default = CurrentTimeShader;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/ui/scheduler/workspaces/base/date_table/all_day_panel/table_body.js ***!
      \*****************************************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.AllDayPanelTableBody = AllDayPanelTableBody;
        exports.AllDayPanelTableBodyProps = exports.viewFunction = void 0;
        var _row = __webpack_require__( /*! ../../row */ 223);
        var _cell = __webpack_require__( /*! ./cell */ 833);
        var Preact = _interopRequireWildcard(__webpack_require__( /*! preact */ 50));
        var _hooks = __webpack_require__( /*! preact/hooks */ 53);

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function _objectWithoutProperties(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = _objectWithoutPropertiesLoose(source, excluded);
            var key, i;
            if (Object.getOwnPropertySymbols) {
                var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
                for (i = 0; i < sourceSymbolKeys.length; i++) {
                    key = sourceSymbolKeys[i];
                    if (excluded.indexOf(key) >= 0) {
                        continue
                    }
                    if (!Object.prototype.propertyIsEnumerable.call(source, key)) {
                        continue
                    }
                    target[key] = source[key]
                }
            }
            return target
        }

        function _objectWithoutPropertiesLoose(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = {};
            var sourceKeys = Object.keys(source);
            var key, i;
            for (i = 0; i < sourceKeys.length; i++) {
                key = sourceKeys[i];
                if (excluded.indexOf(key) >= 0) {
                    continue
                }
                target[key] = source[key]
            }
            return target
        }

        function _extends() {
            _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key]
                        }
                    }
                }
                return target
            };
            return _extends.apply(this, arguments)
        }
        var viewFunction = function(viewModel) {
            return Preact.h(_row.Row, _extends({}, viewModel.restAttributes, {
                className: "dx-scheduler-all-day-table-row ".concat(viewModel.props.className)
            }), viewModel.props.viewData.map(function(_ref) {
                var endDate = _ref.endDate,
                    cellGroupIndex = _ref.groupIndex,
                    groups = _ref.groups,
                    cellIndex = _ref.index,
                    isFirstGroupCell = _ref.isFirstGroupCell,
                    isLastGroupCell = _ref.isLastGroupCell,
                    key = _ref.key,
                    startDate = _ref.startDate;
                return Preact.h(_cell.AllDayPanelCell, {
                    isFirstGroupCell: !viewModel.props.isVerticalGroupOrientation && isFirstGroupCell,
                    isLastGroupCell: !viewModel.props.isVerticalGroupOrientation && isLastGroupCell,
                    startDate: startDate,
                    endDate: endDate,
                    groups: groups,
                    groupIndex: cellGroupIndex,
                    index: cellIndex,
                    dataCellTemplate: viewModel.props.dataCellTemplate,
                    key: key
                })
            }))
        };
        exports.viewFunction = viewFunction;
        var AllDayPanelTableBodyProps = {
            viewData: [],
            isVerticalGroupOrientation: false,
            className: ""
        };
        exports.AllDayPanelTableBodyProps = AllDayPanelTableBodyProps;
        var getTemplate = function(TemplateProp) {
            return TemplateProp && (TemplateProp.defaultProps ? function(props) {
                return Preact.h(TemplateProp, _extends({}, props))
            } : TemplateProp)
        };

        function AllDayPanelTableBody(props) {
            var __restAttributes = (0, _hooks.useCallback)(function() {
                var restProps = (props.className, props.dataCellTemplate, props.isVerticalGroupOrientation, props.viewData, _objectWithoutProperties(props, ["className", "dataCellTemplate", "isVerticalGroupOrientation", "viewData"]));
                return restProps
            }, [props]);
            return viewFunction({
                props: _objectSpread(_objectSpread({}, props), {}, {
                    dataCellTemplate: getTemplate(props.dataCellTemplate)
                }),
                restAttributes: __restAttributes()
            })
        }
        AllDayPanelTableBody.defaultProps = _objectSpread({}, AllDayPanelTableBodyProps)
    },
    /*!************************************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/ui/scheduler/workspaces/base/date_table/all_day_panel/title.js ***!
      \************************************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.AllDayPanelTitle = AllDayPanelTitle;
        exports.AllDayPanelTitleProps = exports.viewFunction = void 0;
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../../../../../../localization/message */ 10));
        var _combine_classes = __webpack_require__( /*! ../../../../../../utils/combine_classes */ 222);
        var Preact = _interopRequireWildcard(__webpack_require__( /*! preact */ 50));
        var _hooks = __webpack_require__( /*! preact/hooks */ 53);

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _objectWithoutProperties(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = _objectWithoutPropertiesLoose(source, excluded);
            var key, i;
            if (Object.getOwnPropertySymbols) {
                var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
                for (i = 0; i < sourceSymbolKeys.length; i++) {
                    key = sourceSymbolKeys[i];
                    if (excluded.indexOf(key) >= 0) {
                        continue
                    }
                    if (!Object.prototype.propertyIsEnumerable.call(source, key)) {
                        continue
                    }
                    target[key] = source[key]
                }
            }
            return target
        }

        function _objectWithoutPropertiesLoose(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = {};
            var sourceKeys = Object.keys(source);
            var key, i;
            for (i = 0; i < sourceKeys.length; i++) {
                key = sourceKeys[i];
                if (excluded.indexOf(key) >= 0) {
                    continue
                }
                target[key] = source[key]
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function _extends() {
            _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key]
                        }
                    }
                }
                return target
            };
            return _extends.apply(this, arguments)
        }
        var viewFunction = function(viewModel) {
            return Preact.h("div", _extends({}, viewModel.restAttributes, {
                className: viewModel.classes
            }), viewModel.text)
        };
        exports.viewFunction = viewFunction;
        var AllDayPanelTitleProps = {
            className: "",
            visible: true
        };
        exports.AllDayPanelTitleProps = AllDayPanelTitleProps;

        function AllDayPanelTitle(props) {
            var __text = (0, _hooks.useCallback)(function() {
                return _message.default.format("dxScheduler-allDay")
            }, []);
            var __classes = (0, _hooks.useCallback)(function() {
                return (0, _combine_classes.combineClasses)(_defineProperty({
                    "dx-scheduler-all-day-title": true,
                    "dx-scheduler-all-day-title-hidden": !props.visible
                }, props.className, !!props.className))
            }, [props.visible, props.className]);
            var __restAttributes = (0, _hooks.useCallback)(function() {
                var restProps = (props.className, props.visible, _objectWithoutProperties(props, ["className", "visible"]));
                return restProps
            }, [props]);
            return viewFunction({
                props: _objectSpread({}, props),
                text: __text(),
                classes: __classes(),
                restAttributes: __restAttributes()
            })
        }
        AllDayPanelTitle.defaultProps = _objectSpread({}, AllDayPanelTitleProps)
    },
    /*!****************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/workspaces/ui.scheduler.timeline_week.js ***!
      \****************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../../core/component_registrator */ 9));
        var _uiScheduler = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.timeline */ 304));
        var _position = __webpack_require__( /*! ../../../core/utils/position */ 22);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var TIMELINE_CLASS = "dx-scheduler-timeline-week";
        var SchedulerTimelineWeek = function(_SchedulerTimeline) {
            _inheritsLoose(SchedulerTimelineWeek, _SchedulerTimeline);

            function SchedulerTimelineWeek() {
                return _SchedulerTimeline.apply(this, arguments) || this
            }
            var _proto = SchedulerTimelineWeek.prototype;
            _proto._getElementClass = function() {
                return TIMELINE_CLASS
            };
            _proto._getCellCount = function() {
                return _SchedulerTimeline.prototype._getCellCount.call(this) * this._getWeekDuration()
            };
            _proto._getHeaderPanelCellWidth = function($headerRow) {
                return (0, _position.getBoundingRect)($headerRow.children().first().get(0)).width
            };
            _proto._getWeekDuration = function() {
                return 7
            };
            _proto._needRenderWeekHeader = function() {
                return true
            };
            _proto._incrementDate = function(date) {
                date.setDate(date.getDate() + 1)
            };
            return SchedulerTimelineWeek
        }(_uiScheduler.default);
        exports.default = SchedulerTimelineWeek;
        (0, _component_registrator.default)("dxSchedulerTimelineWeek", SchedulerTimelineWeek);
        module.exports = exports.default
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/workspaces/utils.work_week.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../../core/utils/date */ 19));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var MONDAY_INDEX = 1;
        var SATURDAY_INDEX = 6;
        var SUNDAY_INDEX = 0;
        var workWeekUtils = function() {
            function workWeekUtils() {}
            workWeekUtils.isDataOnWeekend = function(date) {
                var day = date.getDay();
                return day === SATURDAY_INDEX || day === SUNDAY_INDEX
            };
            workWeekUtils.getFirstDayOfWeek = function(firstDayOfWeekOption) {
                return firstDayOfWeekOption || MONDAY_INDEX
            };
            workWeekUtils.getWeekendsCount = function(days) {
                return 2 * Math.floor(days / 7)
            };
            workWeekUtils.getFirstViewDate = function(viewStart, firstDayOfWeek) {
                var firstViewDate = _date.default.getFirstWeekDate(viewStart, firstDayOfWeek);
                return _date.default.normalizeDateByWeek(firstViewDate, viewStart)
            };
            return workWeekUtils
        }();
        var _default = workWeekUtils;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/workspaces/ui.scheduler.work_space_vertical.js ***!
      \**********************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../../core/renderer */ 2));
        var _iterator = __webpack_require__( /*! ../../../core/utils/iterator */ 3);
        var _uiSchedulerWork_space = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.work_space.indicator */ 305));
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../../localization/date */ 32));
        var _utils = _interopRequireDefault(__webpack_require__( /*! ../utils.timeZone */ 86));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var SchedulerWorkspaceVertical = function(_SchedulerWorkSpaceIn) {
            _inheritsLoose(SchedulerWorkspaceVertical, _SchedulerWorkSpaceIn);

            function SchedulerWorkspaceVertical() {
                return _SchedulerWorkSpaceIn.apply(this, arguments) || this
            }
            var _proto = SchedulerWorkspaceVertical.prototype;
            _proto._getCellsBetween = function($first, $last) {
                if (this._hasAllDayClass($last)) {
                    return _SchedulerWorkSpaceIn.prototype._getCellsBetween.call(this, $first, $last)
                }
                var $cells = this._getCells();
                var firstColumn = $first.index();
                var firstRow = $first.parent().index();
                var lastColumn = $last.index();
                var lastRow = $last.parent().index();
                var groupCount = this._getGroupCount();
                var cellCount = groupCount > 0 ? this._getTotalCellCount(groupCount) : this._getCellCount();
                var rowCount = this._getTotalRowCount(groupCount);
                var result = [];
                for (var i = 0; i < cellCount; i++) {
                    for (var j = 0; j < rowCount; j++) {
                        var cell = $cells.get(cellCount * j + i);
                        result.push(cell)
                    }
                }
                var lastCellGroup = this.getCellData($last).groups;
                var indexesDifference = this.option("showAllDayPanel") && this._isVerticalGroupedWorkSpace() ? this._getGroupIndexByResourceId(lastCellGroup) + 1 : 0;
                var newFirstIndex = rowCount * firstColumn + firstRow - indexesDifference;
                var newLastIndex = rowCount * lastColumn + lastRow - indexesDifference;
                if (newFirstIndex > newLastIndex) {
                    var buffer = newFirstIndex;
                    newFirstIndex = newLastIndex;
                    newLastIndex = buffer
                }
                $cells = (0, _renderer.default)(result).slice(newFirstIndex, newLastIndex + 1);
                if (this._getGroupCount()) {
                    var arr = [];
                    var focusedGroupIndex = this._getGroupIndexByCell($first);
                    (0, _iterator.each)($cells, function(_, cell) {
                        var groupIndex = this._getGroupIndexByCell((0, _renderer.default)(cell));
                        if (focusedGroupIndex === groupIndex) {
                            arr.push(cell)
                        }
                    }.bind(this));
                    $cells = (0, _renderer.default)(arr)
                }
                return $cells
            };
            _proto._getCellFromNextColumn = function(direction, isMultiSelection) {
                var $nextCell = _SchedulerWorkSpaceIn.prototype._getCellFromNextColumn.call(this, direction, isMultiSelection);
                var $focusedCell = this._$focusedCell;
                if ($focusedCell.parent().index() !== $nextCell.parent().index() && isMultiSelection) {
                    $nextCell = $focusedCell
                }
                return $nextCell
            };
            _proto._getFormat = function() {
                return this._formatWeekdayAndDay
            };
            _proto.renovatedRenderSupported = function() {
                return true
            };
            _proto.generateRenderOptions = function() {
                var _this = this;
                var startViewDate = _utils.default.getDateWithoutTimezoneChange(this.getStartViewDate());
                var _getTimeText = function(row, column) {
                    var index = row % _this._getRowCount();
                    if (index % 2 === 0 && 0 === column) {
                        return _date.default.format(_this._getTimeCellDateCore(startViewDate, row), "shorttime")
                    }
                    return ""
                };
                var options = _SchedulerWorkSpaceIn.prototype.generateRenderOptions.call(this);
                options.cellDataGetters.push(function(_, rowIndex, cellIndex) {
                    return {
                        value: {
                            text: _getTimeText(rowIndex, cellIndex)
                        }
                    }
                });
                return options
            };
            return SchedulerWorkspaceVertical
        }(_uiSchedulerWork_space.default);
        var _default = SchedulerWorkspaceVertical;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/ui/scheduler/workspaces/base/date_table/layout.js ***!
      \***********************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.DateTableLayoutBase = DateTableLayoutBase;
        exports.DateTableLayoutBaseProps = exports.viewFunction = void 0;
        var _table = __webpack_require__( /*! ../table */ 301);
        var _table_body = __webpack_require__( /*! ./table_body */ 847);
        var _layout_props = __webpack_require__( /*! ../layout_props */ 161);
        var Preact = _interopRequireWildcard(__webpack_require__( /*! preact */ 50));
        var _hooks = __webpack_require__( /*! preact/hooks */ 53);

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function _objectWithoutProperties(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = _objectWithoutPropertiesLoose(source, excluded);
            var key, i;
            if (Object.getOwnPropertySymbols) {
                var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
                for (i = 0; i < sourceSymbolKeys.length; i++) {
                    key = sourceSymbolKeys[i];
                    if (excluded.indexOf(key) >= 0) {
                        continue
                    }
                    if (!Object.prototype.propertyIsEnumerable.call(source, key)) {
                        continue
                    }
                    target[key] = source[key]
                }
            }
            return target
        }

        function _objectWithoutPropertiesLoose(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = {};
            var sourceKeys = Object.keys(source);
            var key, i;
            for (i = 0; i < sourceKeys.length; i++) {
                key = sourceKeys[i];
                if (excluded.indexOf(key) >= 0) {
                    continue
                }
                target[key] = source[key]
            }
            return target
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function _extends() {
            _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key]
                        }
                    }
                }
                return target
            };
            return _extends.apply(this, arguments)
        }
        var viewFunction = function(viewModel) {
            return Preact.h(_table.Table, _extends({}, viewModel.restAttributes, {
                isVirtual: viewModel.isVirtual,
                topVirtualRowHeight: viewModel.topVirtualRowHeight,
                bottomVirtualRowHeight: viewModel.bottomVirtualRowHeight,
                virtualCellsCount: viewModel.virtualCellsCount,
                className: viewModel.classes
            }), Preact.h(_table_body.DateTableBody, {
                viewType: viewModel.props.viewType,
                viewData: viewModel.props.viewData,
                dataCellTemplate: viewModel.props.dataCellTemplate
            }))
        };
        exports.viewFunction = viewFunction;
        var DateTableLayoutBaseProps = _objectSpread({}, _layout_props.LayoutProps);
        exports.DateTableLayoutBaseProps = DateTableLayoutBaseProps;
        var getTemplate = function(TemplateProp) {
            return TemplateProp && (TemplateProp.defaultProps ? function(props) {
                return Preact.h(TemplateProp, _extends({}, props))
            } : TemplateProp)
        };

        function DateTableLayoutBase(props) {
            var __classes = (0, _hooks.useCallback)(function() {
                return "dx-scheduler-date-table ".concat(props.className)
            }, [props.className]);
            var __isVirtual = (0, _hooks.useCallback)(function() {
                var viewData = props.viewData;
                return !!viewData.isVirtual
            }, [props.viewData]);
            var __topVirtualRowHeight = (0, _hooks.useCallback)(function() {
                return props.viewData.topVirtualRowHeight || 0
            }, [props.viewData]);
            var __bottomVirtualRowHeight = (0, _hooks.useCallback)(function() {
                return props.viewData.bottomVirtualRowHeight || 0
            }, [props.viewData]);
            var __virtualCellsCount = (0, _hooks.useCallback)(function() {
                return props.viewData.groupedData[0].dateTable[0].length
            }, [props.viewData]);
            var __restAttributes = (0, _hooks.useCallback)(function() {
                var restProps = (props.className, props.dataCellTemplate, props.groupOrientation, props.viewData, props.viewType, _objectWithoutProperties(props, ["className", "dataCellTemplate", "groupOrientation", "viewData", "viewType"]));
                return restProps
            }, [props]);
            return viewFunction({
                props: _objectSpread(_objectSpread({}, props), {}, {
                    dataCellTemplate: getTemplate(props.dataCellTemplate)
                }),
                classes: __classes(),
                isVirtual: __isVirtual(),
                topVirtualRowHeight: __topVirtualRowHeight(),
                bottomVirtualRowHeight: __bottomVirtualRowHeight(),
                virtualCellsCount: __virtualCellsCount(),
                restAttributes: __restAttributes()
            })
        }
        DateTableLayoutBase.defaultProps = _objectSpread({}, DateTableLayoutBaseProps)
    },
    /*!******************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/workspaces/ui.scheduler.work_space_week.js ***!
      \******************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../../core/component_registrator */ 9));
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../../core/utils/date */ 19));
        var _date2 = _interopRequireDefault(__webpack_require__( /*! ../../../localization/date */ 32));
        var _uiScheduler = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.work_space_vertical */ 449));
        var _layout = _interopRequireDefault(__webpack_require__( /*! ../../../renovation/ui/scheduler/workspaces/week/date_table/layout.j */ 850));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var WEEK_CLASS = "dx-scheduler-work-space-week";
        var toMs = _date.default.dateToMilliseconds;
        var SchedulerWorkSpaceWeek = function(_SchedulerWorkSpaceVe) {
            _inheritsLoose(SchedulerWorkSpaceWeek, _SchedulerWorkSpaceVe);

            function SchedulerWorkSpaceWeek() {
                return _SchedulerWorkSpaceVe.apply(this, arguments) || this
            }
            var _proto = SchedulerWorkSpaceWeek.prototype;
            _proto._getElementClass = function() {
                return WEEK_CLASS
            };
            _proto._getRowCount = function() {
                return this._getCellCountInDay()
            };
            _proto._getCellCount = function() {
                return 7 * this.option("intervalCount")
            };
            _proto._getDateByIndex = function(headerIndex) {
                var resultDate = new Date(this._firstViewDate);
                resultDate.setDate(this._firstViewDate.getDate() + headerIndex);
                return resultDate
            };
            _proto._getStartViewDate = function() {
                return _date.default.getFirstWeekDate(this.option("startDate"), this._firstDayOfWeek() || _date2.default.firstDayOfWeekIndex())
            };
            _proto._getIntervalDuration = function() {
                return 7 * toMs("day") * this.option("intervalCount")
            };
            _proto.getPositionShift = function(timeShift, isAllDay) {
                if (!isAllDay && this.invoke("isAdaptive") && 0 === this.invoke("getMaxAppointmentCountPerCellByType")) {
                    return {
                        top: 0,
                        left: 0,
                        cellPosition: 0
                    }
                }
                return _SchedulerWorkSpaceVe.prototype.getPositionShift.call(this, timeShift, isAllDay)
            };
            _proto._isApplyCompactAppointmentOffset = function() {
                if (this.invoke("isAdaptive") && 0 === this.invoke("getMaxAppointmentCountPerCellByType")) {
                    return false
                }
                return _SchedulerWorkSpaceVe.prototype._isApplyCompactAppointmentOffset.call(this)
            };
            _proto.renderRDateTable = function() {
                this.renderRComponent(this._$dateTable, _layout.default, "renovatedDateTable", {
                    viewData: this.viewDataProvider.viewData,
                    dataCellTemplate: this.option("dataCellTemplate")
                })
            };
            return SchedulerWorkSpaceWeek
        }(_uiScheduler.default);
        (0, _component_registrator.default)("dxSchedulerWorkSpaceWeek", SchedulerWorkSpaceWeek);
        var _default = SchedulerWorkSpaceWeek;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/file_manager/ui.file_manager.files_tree_view.js ***!
      \*************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _icon = __webpack_require__( /*! ../../core/utils/icon */ 56);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _uiTree_view = _interopRequireDefault(__webpack_require__( /*! ../tree_view/ui.tree_view.search */ 395));
        var _uiFile_manager = _interopRequireDefault(__webpack_require__( /*! ./ui.file_manager.file_actions_button */ 453));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var FILE_MANAGER_DIRS_TREE_CLASS = "dx-filemanager-dirs-tree";
        var FILE_MANAGER_DIRS_TREE_FOCUSED_ITEM_CLASS = "dx-filemanager-focused-item";
        var FILE_MANAGER_DIRS_TREE_ITEM_TEXT_CLASS = "dx-filemanager-dirs-tree-item-text";
        var TREE_VIEW_ITEM_CLASS = "dx-treeview-item";
        var FileManagerFilesTreeView = function(_Widget) {
            _inheritsLoose(FileManagerFilesTreeView, _Widget);

            function FileManagerFilesTreeView() {
                return _Widget.apply(this, arguments) || this
            }
            var _proto = FileManagerFilesTreeView.prototype;
            _proto._initMarkup = function() {
                var _this = this;
                this._initActions();
                this._getCurrentDirectory = this.option("getCurrentDirectory");
                this._createFileActionsButton = _common.noop;
                this._storeExpandedState = this.option("storeExpandedState") || false;
                var $treeView = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_DIRS_TREE_CLASS).appendTo(this.$element());
                var treeViewOptions = {
                    dataStructure: "plain",
                    rootValue: "",
                    createChildren: this._onFilesTreeViewCreateSubDirectories.bind(this),
                    itemTemplate: this._createFilesTreeViewItemTemplate.bind(this),
                    keyExpr: "getInternalKey",
                    parentIdExpr: "parentDirectory.getInternalKey",
                    displayExpr: function(itemInfo) {
                        return itemInfo.getDisplayName()
                    },
                    hasItemsExpr: "fileItem.hasSubDirectories",
                    onItemClick: function(e) {
                        return _this._actions.onDirectoryClick(e)
                    },
                    onItemExpanded: function(e) {
                        return _this._onFilesTreeViewItemExpanded(e)
                    },
                    onItemCollapsed: function(e) {
                        return _this._onFilesTreeViewItemCollapsed(e)
                    },
                    onItemRendered: function(e) {
                        return _this._onFilesTreeViewItemRendered(e)
                    },
                    onContentReady: function() {
                        return _this._actions.onFilesTreeViewContentReady()
                    }
                };
                if (this._contextMenu) {
                    this._contextMenu.option("onContextMenuHidden", function() {
                        return _this._onContextMenuHidden()
                    });
                    treeViewOptions.onItemContextMenu = function(e) {
                        return _this._onFilesTreeViewItemContextMenu(e)
                    };
                    this._createFileActionsButton = function(element, options) {
                        return _this._createComponent(element, _uiFile_manager.default, options)
                    }
                }
                this._filesTreeView = this._createComponent($treeView, _uiTree_view.default, treeViewOptions);
                _events_engine.default.on($treeView, "click", function() {
                    return _this._actions.onClick()
                })
            };
            _proto._initActions = function() {
                this._actions = {
                    onClick: this._createActionByOption("onClick"),
                    onDirectoryClick: this._createActionByOption("onDirectoryClick"),
                    onFilesTreeViewContentReady: this._createActionByOption("onFilesTreeViewContentReady")
                }
            };
            _proto._render = function() {
                _Widget.prototype._render.call(this);
                var that = this;
                setTimeout(function() {
                    that._updateFocusedElement()
                })
            };
            _proto._onFilesTreeViewCreateSubDirectories = function(rootItem) {
                var getDirectories = this.option("getDirectories");
                var directoryInfo = rootItem && rootItem.itemData || null;
                return getDirectories && getDirectories(directoryInfo, true)
            };
            _proto._onFilesTreeViewItemRendered = function(_ref) {
                var itemData = _ref.itemData;
                var currentDirectory = this._getCurrentDirectory();
                if (currentDirectory && currentDirectory.fileItem.equals(itemData.fileItem)) {
                    this._updateFocusedElement();
                    this._restoreScrollTopPosition()
                }
            };
            _proto._onFilesTreeViewItemExpanded = function(_ref2) {
                var itemData = _ref2.itemData;
                if (this._storeExpandedState) {
                    itemData.expanded = true
                }
            };
            _proto._onFilesTreeViewItemCollapsed = function(_ref3) {
                var itemData = _ref3.itemData;
                if (this._storeExpandedState) {
                    itemData.expanded = false
                }
            };
            _proto._createFilesTreeViewItemTemplate = function(itemData, itemIndex, itemElement) {
                var _this2 = this;
                var $itemElement = (0, _renderer.default)(itemElement);
                var $itemWrapper = $itemElement.closest(this._filesTreeViewItemSelector);
                $itemWrapper.data("item", itemData);
                var $image = (0, _icon.getImageContainer)(itemData.icon);
                var $text = (0, _renderer.default)("<span>").text(itemData.getDisplayName()).addClass(FILE_MANAGER_DIRS_TREE_ITEM_TEXT_CLASS);
                var $button = (0, _renderer.default)("<div>");
                $itemElement.append($image, $text, $button);
                this._createFileActionsButton($button, {
                    onClick: function(e) {
                        return _this2._onFileItemActionButtonClick(e)
                    }
                })
            };
            _proto._onFilesTreeViewItemContextMenu = function(_ref4) {
                var itemElement = _ref4.itemElement,
                    event = _ref4.event;
                event.preventDefault();
                var itemData = (0, _renderer.default)(itemElement).data("item");
                this._contextMenu.showAt([itemData], itemElement, event)
            };
            _proto._onFileItemActionButtonClick = function(_ref5) {
                var component = _ref5.component,
                    element = _ref5.element,
                    event = _ref5.event;
                event.stopPropagation();
                var $item = component.$element().closest(this._filesTreeViewItemSelector);
                var item = $item.data("item");
                this._contextMenu.showAt([item], element);
                this._activeFileActionsButton = component;
                this._activeFileActionsButton.setActive(true)
            };
            _proto._onContextMenuHidden = function() {
                if (this._activeFileActionsButton) {
                    this._activeFileActionsButton.setActive(false)
                }
            };
            _proto.toggleNodeDisabledState = function(key, state) {
                var node = this._getNodeByKey(key);
                if (!node) {
                    return
                }
                var items = this._filesTreeView.option("items");
                var itemIndex = items.map(function(item) {
                    return item.getInternalKey()
                }).indexOf(node.getInternalKey());
                if (itemIndex !== -1) {
                    this._filesTreeView.option("items[".concat(itemIndex, "].disabled"), state)
                }
            };
            _proto._saveScrollTopPosition = function() {
                if (!(0, _window.hasWindow)()) {
                    return
                }
                this._scrollTopPosition = this._filesTreeView._scrollableContainer.scrollTop()
            };
            _proto._restoreScrollTopPosition = function() {
                var _this3 = this;
                if (!(0, _window.hasWindow)() || !(0, _type.isNumeric)(this._scrollTopPosition)) {
                    return
                }
                setTimeout(function() {
                    return _this3._filesTreeView._scrollableContainer.scrollTo(_this3._scrollTopPosition)
                })
            };
            _proto._updateFocusedElement = function() {
                var directoryInfo = this._getCurrentDirectory();
                var $element = this._getItemElementByKey(null === directoryInfo || void 0 === directoryInfo ? void 0 : directoryInfo.getInternalKey());
                if (this._$focusedElement) {
                    this._$focusedElement.toggleClass(FILE_MANAGER_DIRS_TREE_FOCUSED_ITEM_CLASS, false)
                }
                this._$focusedElement = $element || (0, _renderer.default)();
                this._$focusedElement.toggleClass(FILE_MANAGER_DIRS_TREE_FOCUSED_ITEM_CLASS, true)
            };
            _proto._getNodeByKey = function(key) {
                var _this$_filesTreeView;
                return null === (_this$_filesTreeView = this._filesTreeView) || void 0 === _this$_filesTreeView ? void 0 : _this$_filesTreeView._getNode(key)
            };
            _proto._getItemElementByKey = function(key) {
                var node = this._getNodeByKey(key);
                if (node) {
                    var $node = this._filesTreeView._getNodeElement(node);
                    if ($node) {
                        return $node.children(this._filesTreeViewItemSelector)
                    }
                }
                return null
            };
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_Widget.prototype._getDefaultOptions.call(this), {
                    storeExpandedState: false,
                    initialFolder: null,
                    contextMenu: null,
                    getItems: null,
                    getCurrentDirectory: null,
                    onDirectoryClick: null
                })
            };
            _proto._optionChanged = function(args) {
                var name = args.name;
                switch (name) {
                    case "storeExpandedState":
                        this._storeExpandedState = this.option(name);
                        break;
                    case "getItems":
                    case "rootFolderDisplayName":
                    case "initialFolder":
                    case "contextMenu":
                        this.repaint();
                        break;
                    case "getCurrentDirectory":
                        this.getCurrentDirectory = this.option(name);
                        break;
                    case "onClick":
                    case "onDirectoryClick":
                    case "onFilesTreeViewContentReady":
                        this._actions[name] = this._createActionByOption(name);
                        break;
                    default:
                        _Widget.prototype._optionChanged.call(this, args)
                }
            };
            _proto.toggleDirectoryExpandedState = function(directoryInfo, state) {
                var deferred = new _deferred.Deferred;
                var treeViewNode = this._getNodeByKey(null === directoryInfo || void 0 === directoryInfo ? void 0 : directoryInfo.getInternalKey());
                if (!treeViewNode) {
                    return deferred.reject().promise()
                }
                if (treeViewNode.expanded === state || treeViewNode.itemsLoaded && !treeViewNode.fileItem.hasSubDirectories) {
                    return deferred.resolve().promise()
                }
                var action = state ? "expandItem" : "collapseItem";
                return this._filesTreeView[action](directoryInfo.getInternalKey())
            };
            _proto.refresh = function() {
                this._$focusedElement = null;
                this._saveScrollTopPosition();
                this._filesTreeView.option("dataSource", [])
            };
            _proto.updateCurrentDirectory = function() {
                if (this._disposed) {
                    return
                }
                this._updateFocusedElement();
                this._storeExpandedState && this._updateExpandedStateToCurrentDirectory()
            };
            _proto._updateExpandedStateToCurrentDirectory = function() {
                return this.toggleDirectoryExpandedStateRecursive(this._getCurrentDirectory(), true)
            };
            _proto.toggleDirectoryExpandedStateRecursive = function(directoryInfo, state) {
                var dirLine = [];
                for (var dirInfo = directoryInfo; dirInfo; dirInfo = dirInfo.parentDirectory) {
                    dirLine.unshift(dirInfo)
                }
                return this.toggleDirectoryLineExpandedState(dirLine, state)
            };
            _proto.toggleDirectoryLineExpandedState = function(dirLine, state) {
                var _this4 = this;
                if (!dirLine.length) {
                    return (new _deferred.Deferred).resolve().promise()
                }
                return this.toggleDirectoryExpandedState(dirLine.shift(), state).then(function() {
                    return _this4.toggleDirectoryLineExpandedState(dirLine, state)
                })
            };
            _createClass(FileManagerFilesTreeView, [{
                key: "_filesTreeViewItemSelector",
                get: function() {
                    return ".".concat(TREE_VIEW_ITEM_CLASS)
                }
            }, {
                key: "_contextMenu",
                get: function() {
                    return this.option("contextMenu")
                }
            }]);
            return FileManagerFilesTreeView
        }(_ui.default);
        var _default = FileManagerFilesTreeView;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/file_manager/ui.file_manager.file_actions_button.js ***!
      \*****************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _button = _interopRequireDefault(__webpack_require__( /*! ../button */ 37));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var FILE_MANAGER_FILE_ACTIONS_BUTTON = "dx-filemanager-file-actions-button";
        var FILE_MANAGER_FILE_ACTIONS_BUTTON_ACTIVATED = "dx-filemanager-file-actions-button-activated";
        var ACTIVE_STATE_CLASS = "dx-state-active";
        var FileManagerFileActionsButton = function(_Widget) {
            _inheritsLoose(FileManagerFileActionsButton, _Widget);

            function FileManagerFileActionsButton() {
                return _Widget.apply(this, arguments) || this
            }
            var _proto = FileManagerFileActionsButton.prototype;
            _proto._initMarkup = function() {
                var _this = this;
                this._createClickAction();
                var $button = (0, _renderer.default)("<div>");
                this.$element().append($button).addClass(FILE_MANAGER_FILE_ACTIONS_BUTTON);
                this._button = this._createComponent($button, _button.default, {
                    icon: "overflow",
                    stylingMode: "text",
                    onClick: function(e) {
                        return _this._raiseClick(e)
                    }
                });
                _Widget.prototype._initMarkup.call(this)
            };
            _proto._createClickAction = function() {
                this._clickAction = this._createActionByOption("onClick")
            };
            _proto._raiseClick = function(e) {
                this._clickAction(e)
            };
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_Widget.prototype._getDefaultOptions.call(this), {
                    cssClass: "",
                    onClick: null
                })
            };
            _proto._optionChanged = function(args) {
                var name = args.name;
                switch (name) {
                    case "cssClass":
                        this.repaint();
                        break;
                    case "onClick":
                        this._createClickAction();
                        break;
                    default:
                        _Widget.prototype._optionChanged.call(this, args)
                }
            };
            _proto.setActive = function(active) {
                var _this2 = this;
                this.$element().toggleClass(FILE_MANAGER_FILE_ACTIONS_BUTTON_ACTIVATED, active);
                setTimeout(function() {
                    return _this2._button.$element().toggleClass(ACTIVE_STATE_CLASS, active)
                })
            };
            return FileManagerFileActionsButton
        }(_ui.default);
        var _default = FileManagerFileActionsButton;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/file_manager/ui.file_manager.item_list.js ***!
      \*******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _double_click = __webpack_require__( /*! ../../events/double_click */ 151);
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _icon = __webpack_require__( /*! ../../core/utils/icon */ 56);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _custom_store = _interopRequireDefault(__webpack_require__( /*! ../../data/custom_store */ 130));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var FILE_MANAGER_FILES_VIEW_CLASS = "dx-filemanager-files-view";
        var FILE_MANAGER_ITEM_LIST_ITEM_OPEN_EVENT_NAMESPACE = "dxFileManager_open";
        var FileManagerItemListBase = function(_Widget) {
            _inheritsLoose(FileManagerItemListBase, _Widget);

            function FileManagerItemListBase() {
                return _Widget.apply(this, arguments) || this
            }
            var _proto = FileManagerItemListBase.prototype;
            _proto._init = function() {
                this._initActions();
                this._lockFocusedItemProcessing = false;
                this._focusedItemKey = this.option("focusedItemKey");
                _Widget.prototype._init.call(this)
            };
            _proto._initMarkup = function() {
                this.$element().addClass(FILE_MANAGER_FILES_VIEW_CLASS);
                var dblClickEventName = (0, _index.addNamespace)(_double_click.name, FILE_MANAGER_ITEM_LIST_ITEM_OPEN_EVENT_NAMESPACE);
                _events_engine.default.on(this.$element(), dblClickEventName, this._getItemSelector(), this._onItemDblClick.bind(this));
                _Widget.prototype._initMarkup.call(this)
            };
            _proto._initActions = function() {
                this._actions = {
                    onError: this._createActionByOption("onError"),
                    onSelectionChanged: this._createActionByOption("onSelectionChanged"),
                    onFocusedItemChanged: this._createActionByOption("onFocusedItemChanged"),
                    onSelectedItemOpened: this._createActionByOption("onSelectedItemOpened"),
                    onContextMenuShowing: this._createActionByOption("onContextMenuShowing")
                }
            };
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_Widget.prototype._getDefaultOptions.call(this), {
                    selectionMode: "single",
                    selectedItemKeys: [],
                    focusedItemKey: void 0,
                    contextMenu: null,
                    getItems: null,
                    getItemThumbnail: null,
                    onError: null,
                    onSelectionChanged: null,
                    onFocusedItemChanged: null,
                    onSelectedItemOpened: null,
                    onContextMenuShowing: null
                })
            };
            _proto._optionChanged = function(args) {
                var name = args.name;
                switch (name) {
                    case "selectionMode":
                    case "contextMenu":
                    case "getItems":
                    case "getItemThumbnail":
                        this.repaint();
                        break;
                    case "selectedItemKeys":
                        this._setSelectedItemKeys(args.value);
                        break;
                    case "focusedItemKey":
                        if (!this._lockFocusedItemProcessing) {
                            this._setFocusedItemKey(args.value)
                        }
                        break;
                    case "onError":
                    case "onSelectedItemOpened":
                    case "onSelectionChanged":
                    case "onFocusedItemChanged":
                    case "onContextMenuShowing":
                        this._actions[name] = this._createActionByOption(name);
                        break;
                    default:
                        _Widget.prototype._optionChanged.call(this, args)
                }
            };
            _proto._getItems = function() {
                var _this = this;
                return this._getItemsInternal().done(function(itemInfos) {
                    _this._itemCount = itemInfos.length;
                    var parentDirectoryItem = _this._findParentDirectoryItem(itemInfos);
                    _this._hasParentDirectoryItem = !!parentDirectoryItem;
                    _this._parentDirectoryItemKey = parentDirectoryItem ? parentDirectoryItem.fileItem.key : null
                })
            };
            _proto._getItemsInternal = function() {
                var itemsGetter = this.option("getItems");
                var itemsResult = itemsGetter ? itemsGetter() : [];
                return (0, _deferred.when)(itemsResult)
            };
            _proto._raiseOnError = function(error) {
                this._actions.onError({
                    error: error
                })
            };
            _proto._raiseSelectionChanged = function(args) {
                this._actions.onSelectionChanged(args)
            };
            _proto._raiseFocusedItemChanged = function(args) {
                this._actions.onFocusedItemChanged(args)
            };
            _proto._raiseSelectedItemOpened = function(fileItemInfo) {
                this._actions.onSelectedItemOpened({
                    fileItemInfo: fileItemInfo
                })
            };
            _proto._raiseContextMenuShowing = function() {
                this._actions.onContextMenuShowing()
            };
            _proto._tryRaiseSelectionChanged = function(_ref) {
                var _this2 = this;
                var selectedItemInfos = _ref.selectedItemInfos,
                    selectedItems = _ref.selectedItems,
                    selectedItemKeys = _ref.selectedItemKeys,
                    currentSelectedItemKeys = _ref.currentSelectedItemKeys,
                    currentDeselectedItemKeys = _ref.currentDeselectedItemKeys;
                var parentDirectoryItem = this._findParentDirectoryItem(this.getSelectedItems());
                if (parentDirectoryItem) {
                    this._deselectItem(parentDirectoryItem)
                }
                var raiseEvent = !this._hasParentDirectoryItem;
                raiseEvent = raiseEvent || this._hasValidKeys(currentSelectedItemKeys) || this._hasValidKeys(currentDeselectedItemKeys);
                if (raiseEvent) {
                    selectedItemInfos = this._filterOutItemByPredicate(selectedItemInfos, function(item) {
                        return item.fileItem.key === _this2._parentDirectoryItemKey
                    });
                    selectedItems = this._filterOutParentDirectory(selectedItems);
                    selectedItemKeys = this._filterOutParentDirectoryKey(selectedItemKeys, true);
                    currentSelectedItemKeys = this._filterOutParentDirectoryKey(currentSelectedItemKeys, true);
                    currentDeselectedItemKeys = this._filterOutParentDirectoryKey(currentDeselectedItemKeys, true);
                    this._raiseSelectionChanged({
                        selectedItemInfos: selectedItemInfos,
                        selectedItems: selectedItems,
                        selectedItemKeys: selectedItemKeys,
                        currentSelectedItemKeys: currentSelectedItemKeys,
                        currentDeselectedItemKeys: currentDeselectedItemKeys
                    })
                }
            };
            _proto._onFocusedItemChanged = function(args) {
                if (this._focusedItemKey === args.itemKey) {
                    return
                }
                this._focusedItemKey = args.itemKey;
                this._lockFocusedItemProcessing = true;
                this.option("focusedItemKey", args.itemKey);
                this._lockFocusedItemProcessing = false;
                this._raiseFocusedItemChanged(args)
            };
            _proto._getItemThumbnail = function(fileInfo) {
                var itemThumbnailGetter = this.option("getItemThumbnail");
                return itemThumbnailGetter ? itemThumbnailGetter(fileInfo) : {
                    thumbnail: ""
                }
            };
            _proto._getItemThumbnailContainer = function(fileInfo) {
                var _this$_getItemThumbna = this._getItemThumbnail(fileInfo),
                    thumbnail = _this$_getItemThumbna.thumbnail,
                    cssClass = _this$_getItemThumbna.cssClass;
                var $itemThumbnail = (0, _icon.getImageContainer)(thumbnail).addClass(this._getItemThumbnailCssClass());
                if (cssClass) {
                    $itemThumbnail.addClass(cssClass)
                }
                return $itemThumbnail
            };
            _proto._getItemThumbnailCssClass = function() {
                return ""
            };
            _proto._getItemSelector = function() {};
            _proto._onItemDblClick = function(e) {};
            _proto._isDesktop = function() {
                return "desktop" === _devices.default.real().deviceType
            };
            _proto._showContextMenu = function(items, element, offset, targetFileItem) {
                this._contextMenu.showAt(items, element, offset, targetFileItem)
            };
            _proto._findParentDirectoryItem = function(itemInfos) {
                for (var i = 0; i < itemInfos.length; i++) {
                    var itemInfo = itemInfos[i];
                    if (this._isParentDirectoryItem(itemInfo)) {
                        return itemInfo
                    }
                }
                return null
            };
            _proto._getFileItemsForContextMenu = function(fileItem) {
                var result = this.getSelectedItems();
                if (this._isParentDirectoryItem(fileItem)) {
                    result.push(fileItem)
                }
                return result
            };
            _proto._isParentDirectoryItem = function(itemInfo) {
                return itemInfo.fileItem.isParentFolder
            };
            _proto._hasValidKeys = function(keys) {
                return keys.length > 1 || 1 === keys.length && keys[0] !== this._parentDirectoryItemKey
            };
            _proto._filterOutParentDirectory = function(array, createNewArray) {
                var _this3 = this;
                return this._filterOutItemByPredicate(array, function(item) {
                    return item.key === _this3._parentDirectoryItemKey
                }, createNewArray)
            };
            _proto._filterOutParentDirectoryKey = function(array, createNewArray) {
                var _this4 = this;
                return this._filterOutItemByPredicate(array, function(key) {
                    return key === _this4._parentDirectoryItemKey
                }, createNewArray)
            };
            _proto._filterOutItemByPredicate = function(array, predicate, createNewArray) {
                var result = array;
                var index = -1;
                for (var i = 0; i < array.length; i++) {
                    if (predicate(array[i])) {
                        index = i;
                        break
                    }
                }
                if (index !== -1) {
                    if (createNewArray) {
                        result = _toConsumableArray(array)
                    }
                    result.splice(index, 1)
                }
                return result
            };
            _proto._isMultipleSelectionMode = function() {
                return "multiple" === this.option("selectionMode")
            };
            _proto._deselectItem = function(item) {};
            _proto._setSelectedItemKeys = function(itemKeys) {};
            _proto._setFocusedItemKey = function(itemKey) {};
            _proto._createDataSource = function() {
                return {
                    store: new _custom_store.default({
                        key: "fileItem.key",
                        load: this._getItems.bind(this)
                    })
                }
            };
            _proto.getSelectedItems = function() {};
            _proto.clearSelection = function() {};
            _proto.selectItem = function() {};
            _createClass(FileManagerItemListBase, [{
                key: "_contextMenu",
                get: function() {
                    return this.option("contextMenu")
                }
            }]);
            return FileManagerItemListBase
        }(_ui.default);
        var _default = FileManagerItemListBase;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/splitter.js ***!
      \*************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./widget/ui.widget */ 16));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../core/dom_adapter */ 11));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../events/pointer */ 24));
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _index = __webpack_require__( /*! ../events/utils/index */ 8);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var window = (0, _window.getWindow)();
        var SPLITTER_CLASS = "dx-splitter";
        var SPLITTER_WRAPPER_CLASS = "".concat(SPLITTER_CLASS, "-wrapper");
        var SPLITTER_INACTIVE_CLASS = "".concat(SPLITTER_CLASS, "-inactive");
        var SPLITTER_BORDER_CLASS = "".concat(SPLITTER_CLASS, "-border");
        var SPLITTER_INITIAL_STATE_CLASS = "".concat(SPLITTER_CLASS, "-initial");
        var STATE_DISABLED_CLASS = "dx-state-disabled";
        var SPLITTER_MODULE_NAMESPACE = "dxSplitterResizing";
        var SPLITTER_POINTER_DOWN_EVENT_NAME = (0, _index.addNamespace)(_pointer.default.down, SPLITTER_MODULE_NAMESPACE);
        var SPLITTER_POINTER_MOVE_EVENT_NAME = (0, _index.addNamespace)(_pointer.default.move, SPLITTER_MODULE_NAMESPACE);
        var SPLITTER_POINTER_UP_EVENT_NAME = (0, _index.addNamespace)(_pointer.default.up, SPLITTER_MODULE_NAMESPACE);
        var SplitterControl = function(_Widget) {
            _inheritsLoose(SplitterControl, _Widget);

            function SplitterControl() {
                return _Widget.apply(this, arguments) || this
            }
            var _proto = SplitterControl.prototype;
            _proto._initMarkup = function() {
                _Widget.prototype._initMarkup.call(this);
                this._initActions();
                this._$container = this.option("container");
                this._$leftElement = this.option("leftElement");
                this._$rightElement = this.option("rightElement");
                this.$element().addClass(SPLITTER_WRAPPER_CLASS).addClass(SPLITTER_INITIAL_STATE_CLASS);
                this._$splitterBorder = (0, _renderer.default)("<div>").addClass(SPLITTER_BORDER_CLASS).appendTo(this.$element());
                this._$splitter = (0, _renderer.default)("<div>").addClass(SPLITTER_CLASS).addClass(SPLITTER_INACTIVE_CLASS).appendTo(this._$splitterBorder)
            };
            _proto._initActions = function() {
                this._actions = {
                    onApplyPanelSize: this._createActionByOption("onApplyPanelSize"),
                    onActiveStateChanged: this._createActionByOption("onActiveStateChanged")
                }
            };
            _proto._render = function() {
                _Widget.prototype._render.call(this);
                this._detachEventHandlers();
                this._attachEventHandlers()
            };
            _proto._clean = function() {
                this._detachEventHandlers();
                _Widget.prototype._clean.call(this)
            };
            _proto._attachEventHandlers = function() {
                var document = _dom_adapter.default.getDocument();
                _events_engine.default.on(this._$splitterBorder, SPLITTER_POINTER_DOWN_EVENT_NAME, this._onMouseDownHandler.bind(this));
                _events_engine.default.on(document, SPLITTER_POINTER_MOVE_EVENT_NAME, this._onMouseMoveHandler.bind(this));
                _events_engine.default.on(document, SPLITTER_POINTER_UP_EVENT_NAME, this._onMouseUpHandler.bind(this))
            };
            _proto._detachEventHandlers = function() {
                var document = _dom_adapter.default.getDocument();
                _events_engine.default.off(this._$splitterBorder, SPLITTER_POINTER_DOWN_EVENT_NAME);
                _events_engine.default.off(document, SPLITTER_POINTER_MOVE_EVENT_NAME);
                _events_engine.default.off(document, SPLITTER_POINTER_UP_EVENT_NAME)
            };
            _proto._dimensionChanged = function(dimension) {
                if (!dimension || "height" !== dimension) {
                    this._containerWidth = this._$container.get(0).clientWidth;
                    this._setSplitterPositionLeft({
                        needUpdatePanels: true,
                        usePercentagePanelsWidth: true
                    })
                }
            };
            _proto._onMouseDownHandler = function(e) {
                e.preventDefault();
                this._offsetX = e.pageX - this._$splitterBorder.offset().left <= this._getSplitterBorderWidth() ? e.pageX - this._$splitterBorder.offset().left : 0;
                this._containerWidth = this._$container.get(0).clientWidth;
                this.$element().removeClass(SPLITTER_INITIAL_STATE_CLASS);
                this._toggleActive(true);
                this._setSplitterPositionLeft({
                    needUpdatePanels: true
                })
            };
            _proto._onMouseMoveHandler = function(e) {
                if (!this._isSplitterActive) {
                    return
                }
                this._setSplitterPositionLeft({
                    splitterPositionLeft: this._getNewSplitterPositionLeft(e),
                    needUpdatePanels: true
                })
            };
            _proto._onMouseUpHandler = function() {
                if (!this._isSplitterActive) {
                    return
                }
                this._leftPanelPercentageWidth = null;
                this._toggleActive(false);
                this._setSplitterPositionLeft({
                    needUpdatePanels: true,
                    usePercentagePanelsWidth: true
                })
            };
            _proto._getNewSplitterPositionLeft = function(e) {
                var newSplitterPositionLeft = e.pageX - this._getContainerLeftOffset() - this._offsetX;
                newSplitterPositionLeft = Math.max(0 - this._getSplitterOffset(), newSplitterPositionLeft);
                newSplitterPositionLeft = Math.min(this._containerWidth - this._getSplitterOffset() - this._getSplitterWidth(), newSplitterPositionLeft);
                return newSplitterPositionLeft
            };
            _proto._getContainerLeftOffset = function() {
                var offsetLeft = this._$container.offset().left;
                if (window) {
                    var style = window.getComputedStyle(this._$container.get(0));
                    var paddingLeft = parseFloat(style.paddingLeft) || 0;
                    var borderLeft = parseFloat(style.borderLeftWidth) || 0;
                    offsetLeft += paddingLeft + borderLeft
                }
                return offsetLeft
            };
            _proto._getSplitterOffset = function() {
                return (this._getSplitterBorderWidth() - this._getSplitterWidth()) / 2
            };
            _proto._getSplitterWidth = function() {
                return this._$splitter.get(0).clientWidth
            };
            _proto._getSplitterBorderWidth = function() {
                return this._$splitterBorder.get(0).clientWidth
            };
            _proto._getLeftPanelWidth = function() {
                return this._$leftElement.get(0).clientWidth
            };
            _proto._toggleActive = function(isActive) {
                this.$element().toggleClass(SPLITTER_INACTIVE_CLASS, !isActive);
                this._$splitter.toggleClass(SPLITTER_INACTIVE_CLASS, !isActive);
                this._isSplitterActive = isActive;
                this._actions.onActiveStateChanged({
                    isActive: isActive
                })
            };
            _proto.toggleDisabled = function(isDisabled) {
                this.$element().toggleClass(STATE_DISABLED_CLASS, isDisabled);
                this._$splitter.toggleClass(STATE_DISABLED_CLASS, isDisabled)
            };
            _proto.isSplitterMoved = function() {
                return !this.$element().hasClass(SPLITTER_INITIAL_STATE_CLASS)
            };
            _proto.disableSplitterCalculation = function(value) {
                this._isSplitterCalculationDisabled = value
            };
            _proto._setSplitterPositionLeft = function() {
                var _ref = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                    _ref$splitterPosition = _ref.splitterPositionLeft,
                    splitterPositionLeft = void 0 === _ref$splitterPosition ? null : _ref$splitterPosition,
                    _ref$needUpdatePanels = _ref.needUpdatePanels,
                    needUpdatePanels = void 0 === _ref$needUpdatePanels ? false : _ref$needUpdatePanels,
                    _ref$usePercentagePan = _ref.usePercentagePanelsWidth,
                    usePercentagePanelsWidth = void 0 === _ref$usePercentagePan ? false : _ref$usePercentagePan;
                splitterPositionLeft = splitterPositionLeft || this._getLeftPanelWidth() - this._getSplitterOffset();
                var leftPanelWidth = splitterPositionLeft + this._getSplitterOffset();
                var rightPanelWidth = this._containerWidth - leftPanelWidth;
                if (!this._isSplitterCalculationDisabled) {
                    this.$element().css("left", splitterPositionLeft)
                }
                this._leftPanelPercentageWidth = this._leftPanelPercentageWidth || this._convertToPercentage(leftPanelWidth);
                var rightPanelPercentageWidth = this._convertToPercentage(this._containerWidth - this._convertToPixels(this._leftPanelPercentageWidth));
                if (!needUpdatePanels) {
                    return
                }
                this._actions.onApplyPanelSize({
                    leftPanelWidth: usePercentagePanelsWidth ? "".concat(this._leftPanelPercentageWidth, "%") : leftPanelWidth,
                    rightPanelWidth: usePercentagePanelsWidth ? "".concat(rightPanelPercentageWidth, "%") : rightPanelWidth
                })
            };
            _proto._optionChanged = function(args) {
                switch (args.name) {
                    case "initialLeftPanelWidth":
                        this._leftPanelPercentageWidth = this._convertToPercentage(args.value);
                        this._dimensionChanged();
                        break;
                    case "leftElement":
                        this.repaint();
                        break;
                    case "onActiveStateChanged":
                    case "onApplyPanelSize":
                        this._actions[args.name] = this._createActionByOption(args.name);
                        break;
                    default:
                        _Widget.prototype._optionChanged.call(this, args)
                }
            };
            _proto._convertToPercentage = function(pixelWidth) {
                return pixelWidth / this._$container.get(0).clientWidth * 100
            };
            _proto._convertToPixels = function(percentageWidth) {
                return percentageWidth / 100 * this._$container.get(0).clientWidth
            };
            return SplitterControl
        }(_ui.default);
        exports.default = SplitterControl;
        module.exports = exports.default
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/diagram/ui.diagram.panel.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../../events/pointer */ 24));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var POINTERUP_EVENT_NAME = (0, _index.addNamespace)(_pointer.default.up, "dxDiagramPanel");
        var PREVENT_REFOCUS_SELECTOR = ".dx-textbox";
        var DiagramPanel = function(_Widget) {
            _inheritsLoose(DiagramPanel, _Widget);

            function DiagramPanel() {
                return _Widget.apply(this, arguments) || this
            }
            var _proto = DiagramPanel.prototype;
            _proto._init = function() {
                _Widget.prototype._init.call(this);
                this._createOnPointerUpAction()
            };
            _proto._render = function() {
                _Widget.prototype._render.call(this);
                this._attachPointerUpEvent()
            };
            _proto._getPointerUpElements = function() {
                return [this.$element()]
            };
            _proto._attachPointerUpEvent = function() {
                var _this = this;
                var elements = this._getPointerUpElements();
                elements.forEach(function(element) {
                    _events_engine.default.off(element, POINTERUP_EVENT_NAME);
                    _events_engine.default.on(element, POINTERUP_EVENT_NAME, function(e) {
                        if (!(0, _renderer.default)(e.target).closest(PREVENT_REFOCUS_SELECTOR).length) {
                            _this._onPointerUpAction()
                        }
                    })
                })
            };
            _proto._createOnPointerUpAction = function() {
                this._onPointerUpAction = this._createActionByOption("onPointerUp")
            };
            _proto._optionChanged = function(args) {
                switch (args.name) {
                    case "onPointerUp":
                        this._createOnPointerUpAction();
                        break;
                    default:
                        _Widget.prototype._optionChanged.call(this, args)
                }
            };
            return DiagramPanel
        }(_ui.default);
        var _default = DiagramPanel;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/diagram/ui.diagram.menu_helper.js ***!
      \***********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _icon = __webpack_require__( /*! ../../core/utils/icon */ 56);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        var DIAGRAM_CONTEXT_MENU_CLASS = "dx-diagram-contextmenu";
        var DiagramMenuHelper = {
            getContextMenuItemTemplate: function(contextMenu, itemData, itemIndex, itemElement) {
                var $itemElement = (0, _renderer.default)(itemElement);
                $itemElement.empty();
                var itemKey = void 0 !== itemData.rootCommand ? itemData.rootCommand : -1;
                if (itemData.icon && !itemData.checked) {
                    var $iconElement = (0, _icon.getImageContainer)(itemData.icon);
                    $itemElement.append($iconElement)
                } else {
                    if (contextMenu._menuHasCheckedItems && true === contextMenu._menuHasCheckedItems[itemKey]) {
                        var $checkElement = (0, _icon.getImageContainer)("check");
                        $checkElement.css("visibility", !itemData.checked ? "hidden" : "visible");
                        $itemElement.append($checkElement)
                    }
                }
                $itemElement.append('<span class="dx-menu-item-text">' + itemData.text + "</span>");
                if (Array.isArray(itemData.items) && itemData.items.length > 0) {
                    $itemElement.append('<span class="dx-menu-item-popout-container"><div class="dx-menu-item-popout"></div></span>')
                }
            },
            getContextMenuCssClass: function() {
                return DIAGRAM_CONTEXT_MENU_CLASS
            },
            onContextMenuItemClick: function(widget, itemData, actionHandler) {
                if ((void 0 !== itemData.command || void 0 !== itemData.name) && (!Array.isArray(itemData.items) || !itemData.items.length)) {
                    var parameter = DiagramMenuHelper.getItemCommandParameter(widget, itemData);
                    actionHandler.call(this, itemData.command, itemData.name, parameter)
                } else {
                    if (void 0 !== itemData.rootCommand && void 0 !== itemData.value) {
                        var _parameter = DiagramMenuHelper.getItemCommandParameter(widget, itemData, itemData.value);
                        actionHandler.call(this, itemData.rootCommand, void 0, _parameter)
                    }
                }
            },
            getItemValue: function(item) {
                return "object" === _typeof(item.value) ? JSON.stringify(item.value) : item.value
            },
            getItemOptionText: function(contextMenu, indexPath) {
                if (contextMenu) {
                    indexPath = indexPath.slice();
                    var parentItemOptionText = this._getParentItemOptionText(indexPath);
                    if (contextMenu && contextMenu._originalItemsInfo && contextMenu._originalItemsInfo[parentItemOptionText]) {
                        indexPath[indexPath.length - 1] += contextMenu._originalItemsInfo[parentItemOptionText].indexPathCorrection
                    }
                }
                return this._getItemOptionTextCore(indexPath)
            },
            _getParentItemOptionText: function(indexPath) {
                var parentIndexPath = indexPath.slice(0, indexPath.length - 1);
                return this._getItemOptionTextCore(parentIndexPath)
            },
            _getItemOptionTextCore: function(indexPath) {
                return indexPath.reduce(function(r, i) {
                    return r + "items[".concat(i, "].")
                }, "")
            },
            getItemCommandParameter: function(widget, item, value) {
                if (item.getParameter) {
                    return item.getParameter(widget)
                }
                return value
            },
            updateContextMenuItems: function(contextMenu, itemOptionText, rootCommandKey, items) {
                var _this = this;
                if (!contextMenu._originalItemsInfo) {
                    contextMenu._originalItemsInfo = {}
                }
                if (!contextMenu._originalItemsInfo[itemOptionText]) {
                    contextMenu._originalItemsInfo[itemOptionText] = {
                        items: contextMenu.option(itemOptionText + "items") || []
                    }
                }
                items = items.map(function(item) {
                    return {
                        value: _this.getItemValue(item),
                        text: item.text,
                        checked: item.checked,
                        widget: contextMenu,
                        rootCommand: rootCommandKey
                    }
                });
                var originalItems = contextMenu._originalItemsInfo[itemOptionText].items;
                contextMenu.option(itemOptionText + "items", items.concat(originalItems));
                if (contextMenu._originalItemsInfo[itemOptionText] && originalItems.length) {
                    contextMenu._originalItemsInfo[itemOptionText].indexPathCorrection = items.length
                }
            },
            updateContextMenuItemVisible: function(contextMenu, itemOptionText, visible) {
                contextMenu.option(itemOptionText + "visible", visible)
            },
            updateContextMenuItemValue: function(contextMenu, itemOptionText, rootCommandKey, value) {
                var items = contextMenu.option(itemOptionText + "items");
                if ("boolean" === typeof value && (!items || !items.length)) {
                    this._setContextMenuHasCheckedItems(contextMenu, -1);
                    contextMenu.option(itemOptionText + "checked", value)
                } else {
                    if (void 0 !== value) {
                        this._setContextMenuHasCheckedItems(contextMenu, rootCommandKey);
                        if (Array.isArray(items)) {
                            items.forEach(function(item, index) {
                                item.checked = item.value === value
                            })
                        }
                    }
                }
            },
            _setContextMenuHasCheckedItems: function(contextMenu, key) {
                if (!contextMenu._menuHasCheckedItems) {
                    contextMenu._menuHasCheckedItems = {}
                }
                contextMenu._menuHasCheckedItems[key] = true
            }
        };
        var _default = DiagramMenuHelper;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/diagram/ui.diagram.floating_panel.js ***!
      \**************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _popup = _interopRequireDefault(__webpack_require__( /*! ../popup */ 46));
        var _uiDiagram = _interopRequireDefault(__webpack_require__( /*! ./ui.diagram.panel */ 456));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var DIAGRAM_MOBILE_POPUP_CLASS = "dx-diagram-mobile-popup";
        var DiagramFloatingPanel = function(_DiagramPanel) {
            _inheritsLoose(DiagramFloatingPanel, _DiagramPanel);

            function DiagramFloatingPanel() {
                return _DiagramPanel.apply(this, arguments) || this
            }
            var _proto = DiagramFloatingPanel.prototype;
            _proto._init = function() {
                _DiagramPanel.prototype._init.call(this);
                this._createOnVisibilityChangingAction();
                this._createOnVisibilityChangedAction()
            };
            _proto.isVisible = function() {
                return this.option("isVisible")
            };
            _proto.isMobileView = function() {
                return this.option("isMobileView")
            };
            _proto._initMarkup = function() {
                _DiagramPanel.prototype._initMarkup.call(this);
                var $parent = this.$element();
                var $popupElement = (0, _renderer.default)("<div>").addClass(this._getPopupClass()).addClass(this.isMobileView() && DIAGRAM_MOBILE_POPUP_CLASS).appendTo($parent);
                this._popup = this._createComponent($popupElement, _popup.default, this._getPopupOptions());
                this._updatePopupVisible()
            };
            _proto.show = function() {
                this.option("isVisible", true)
            };
            _proto.hide = function() {
                this.option("isVisible", false)
            };
            _proto.toggle = function() {
                this.option("isVisible", !this.isVisible())
            };
            _proto.repaint = function() {
                this._popup.repaint()
            };
            _proto._getPopupContent = function() {
                return this._popup.content()
            };
            _proto._getPopupTitle = function() {
                var $content = (0, _renderer.default)(this._getPopupContent());
                return $content.parent().find(".dx-popup-title")
            };
            _proto._getPointerUpElements = function() {
                return [this._getPopupContent(), this._getPopupTitle()]
            };
            _proto._getVerticalPaddingsAndBorders = function() {
                var $content = (0, _renderer.default)(this._getPopupContent());
                return $content.outerHeight() - $content.height()
            };
            _proto._getHorizontalPaddingsAndBorders = function() {
                var $content = (0, _renderer.default)(this._getPopupContent());
                return $content.outerWidth() - $content.width()
            };
            _proto._getPopupClass = function() {
                return ""
            };
            _proto._getPopupWidth = function() {
                return this.option("width") || "auto"
            };
            _proto._getPopupMaxWidth = function() {
                return this.option("maxWidth")
            };
            _proto._getPopupMinWidth = function() {
                return this.option("minWidth")
            };
            _proto._getPopupHeight = function() {
                return this.option("height") || "auto"
            };
            _proto._getPopupMaxHeight = function() {
                return this.option("maxHeight")
            };
            _proto._getPopupMinHeight = function() {
                return this.option("minHeight")
            };
            _proto._getPopupPosition = function() {
                return {}
            };
            _proto._getPopupContainer = function() {
                return this.option("container")
            };
            _proto._getPopupSlideAnimationObject = function(properties) {
                return (0, _extend.extend)({
                    type: "slide",
                    start: function() {
                        (0, _renderer.default)("body").css("overflow", "hidden")
                    },
                    complete: function() {
                        (0, _renderer.default)("body").css("overflow", "")
                    }
                }, properties)
            };
            _proto._getPopupAnimation = function() {
                return {
                    hide: {
                        type: "fadeOut"
                    },
                    show: {
                        type: "fadeIn"
                    }
                }
            };
            _proto._getPopupOptions = function() {
                var _this = this;
                var that = this;
                return {
                    animation: (0, _window.hasWindow)() ? this._getPopupAnimation() : null,
                    shading: false,
                    showTitle: false,
                    focusStateEnabled: false,
                    container: this._getPopupContainer(),
                    width: this._getPopupWidth(),
                    height: this._getPopupHeight(),
                    maxWidth: this._getPopupMaxWidth(),
                    maxHeight: this._getPopupMaxHeight(),
                    minWidth: this._getPopupMinWidth(),
                    minHeight: this._getPopupMinHeight(),
                    position: this._getPopupPosition(),
                    onContentReady: function() {
                        that._renderPopupContent(that._popup.content())
                    },
                    onShowing: function() {
                        _this._onVisibilityChangingAction({
                            visible: true,
                            component: _this
                        })
                    },
                    onShown: function() {
                        _this.option("isVisible", true);
                        _this._onVisibilityChangedAction({
                            visible: true,
                            component: _this
                        })
                    },
                    onHiding: function() {
                        _this._onVisibilityChangingAction({
                            visible: false,
                            component: _this
                        })
                    },
                    onHidden: function() {
                        _this.option("isVisible", false);
                        _this._onVisibilityChangedAction({
                            visible: false,
                            component: _this
                        })
                    }
                }
            };
            _proto._renderPopupContent = function($parent) {};
            _proto._updatePopupVisible = function() {
                this._popup.option("visible", this.isVisible())
            };
            _proto._createOnVisibilityChangingAction = function() {
                this._onVisibilityChangingAction = this._createActionByOption("onVisibilityChanging")
            };
            _proto._createOnVisibilityChangedAction = function() {
                this._onVisibilityChangedAction = this._createActionByOption("onVisibilityChanged")
            };
            _proto._optionChanged = function(args) {
                switch (args.name) {
                    case "onVisibilityChanging":
                        this._createOnVisibilityChangingAction();
                        break;
                    case "onVisibilityChanged":
                        this._createOnVisibilityChangedAction();
                        break;
                    case "container":
                        this._popup.option("container", this._getPopupContainer());
                        break;
                    case "width":
                        this._popup.option("width", this._getPopupWidth());
                        break;
                    case "height":
                        this._popup.option("height", this._getPopupHeight());
                        break;
                    case "maxWidth":
                        this._popup.option("maxWidth", this._getPopupMaxWidth());
                        break;
                    case "maxHeight":
                        this._popup.option("maxHeight", this._getPopupMaxHeight());
                        break;
                    case "minWidth":
                        this._popup.option("minWidth", this._getPopupMinWidth());
                        break;
                    case "minHeight":
                        this._popup.option("minHeight", this._getPopupMinHeight());
                        break;
                    case "isMobileView":
                        this._invalidate();
                        break;
                    case "isVisible":
                        this._updatePopupVisible();
                        break;
                    default:
                        _DiagramPanel.prototype._optionChanged.call(this, args)
                }
            };
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_DiagramPanel.prototype._getDefaultOptions.call(this), {
                    isVisible: true,
                    isMobileView: false,
                    offsetX: 0,
                    offsetY: 0
                })
            };
            return DiagramFloatingPanel
        }(_uiDiagram.default);
        var _default = DiagramFloatingPanel;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/diagram/diagram.items_option.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _component = _interopRequireDefault(__webpack_require__( /*! ../../core/component */ 127));
        var _data_helper = _interopRequireDefault(__webpack_require__( /*! ../../data_helper */ 92));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var ItemsOption = function(_Component) {
            _inheritsLoose(ItemsOption, _Component);

            function ItemsOption(diagramWidget) {
                var _this;
                _this = _Component.call(this) || this;
                _this._diagramWidget = diagramWidget;
                _this._resetCache();
                return _this
            }
            var _proto = ItemsOption.prototype;
            _proto._dataSourceChangedHandler = function(newItems, e) {
                this._resetCache();
                this._items = newItems.map(function(item) {
                    return (0, _extend.extend)(true, {}, item)
                });
                this._dataSourceItems = newItems.slice();
                if (e && e.changes) {
                    var internalChanges = e.changes.filter(function(change) {
                        return change.internalChange
                    });
                    var externalChanges = e.changes.filter(function(change) {
                        return !change.internalChange
                    });
                    if (internalChanges.length) {
                        this._reloadContentByChanges(internalChanges, false)
                    }
                    if (externalChanges.length) {
                        this._reloadContentByChanges(externalChanges, true)
                    }
                } else {
                    this._diagramWidget._onDataSourceChanged()
                }
            };
            _proto._dataSourceLoadingChangedHandler = function(isLoading) {
                if (isLoading && !this._dataSource.isLoaded()) {
                    this._diagramWidget._showLoadingIndicator()
                } else {
                    this._diagramWidget._hideLoadingIndicator()
                }
            };
            _proto._prepareData = function(dataObj) {
                for (var key in dataObj) {
                    if (!Object.prototype.hasOwnProperty.call(dataObj, key)) {
                        continue
                    }
                    if (void 0 === dataObj[key]) {
                        dataObj[key] = null
                    }
                }
                return dataObj
            };
            _proto.insert = function(data, callback, errorCallback) {
                var _this2 = this;
                this._resetCache();
                var store = this._getStore();
                store.insert(this._prepareData(data)).done(function(data, key) {
                    store.push([{
                        type: "insert",
                        key: key,
                        data: data,
                        internalChange: true
                    }]);
                    if (callback) {
                        callback(data)
                    }
                    _this2._resetCache()
                }).fail(function(error) {
                    if (errorCallback) {
                        errorCallback(error)
                    }
                    _this2._resetCache()
                })
            };
            _proto.update = function(key, data, callback, errorCallback) {
                var store = this._getStore();
                var storeKey = this._getStoreKey(store, key, data);
                store.update(storeKey, this._prepareData(data)).done(function(data, key) {
                    store.push([{
                        type: "update",
                        key: key,
                        data: data,
                        internalChange: true
                    }]);
                    if (callback) {
                        callback(key, data)
                    }
                }).fail(function(error) {
                    if (errorCallback) {
                        errorCallback(error)
                    }
                })
            };
            _proto.remove = function(key, data, callback, errorCallback) {
                var _this3 = this;
                this._resetCache();
                var store = this._getStore();
                var storeKey = this._getStoreKey(store, key, data);
                store.remove(storeKey).done(function(key) {
                    store.push([{
                        type: "remove",
                        key: key,
                        internalChange: true
                    }]);
                    if (callback) {
                        callback(key)
                    }
                    _this3._resetCache()
                }).fail(function(error) {
                    if (errorCallback) {
                        errorCallback(error)
                    }
                    _this3._resetCache()
                })
            };
            _proto.findItem = function(itemKey) {
                if (!this._items) {
                    return null
                }
                return this._getItemByKey(itemKey)
            };
            _proto.getItems = function() {
                return this._items
            };
            _proto.hasItems = function() {
                return !!this._items
            };
            _proto._reloadContentByChanges = function(changes, isExternalChanges) {
                var _this4 = this;
                changes = changes.map(function(change) {
                    return (0, _extend.extend)(change, {
                        internalKey: _this4._getInternalKey(change.key)
                    })
                });
                this._diagramWidget._reloadContentByChanges(changes, isExternalChanges)
            };
            _proto._getItemByKey = function(key) {
                this._ensureCache();
                var cache = this._cache;
                var index = this._getIndexByKey(key);
                return cache.items[index]
            };
            _proto._getIndexByKey = function(key) {
                this._ensureCache();
                var cache = this._cache;
                if ("object" === _typeof(key)) {
                    for (var i = 0, length = cache.keys.length; i < length; i++) {
                        if (cache.keys[i] === key) {
                            return i
                        }
                    }
                } else {
                    var keySet = cache.keySet || cache.keys.reduce(function(accumulator, key, index) {
                        accumulator[key] = index;
                        return accumulator
                    }, {});
                    if (!cache.keySet) {
                        cache.keySet = keySet
                    }
                    return keySet[key]
                }
                return -1
            };
            _proto._ensureCache = function() {
                var cache = this._cache;
                if (!cache.keys) {
                    cache.keys = [];
                    cache.items = [];
                    this._fillCache(cache, this._items)
                }
            };
            _proto._fillCache = function(cache, items) {
                var _this5 = this;
                if (!items || !items.length) {
                    return
                }
                var keyExpr = this._getKeyExpr();
                if (keyExpr) {
                    items.forEach(function(item) {
                        cache.keys.push(keyExpr(item));
                        cache.items.push(item)
                    })
                }
                var itemsExpr = this._getItemsExpr();
                if (itemsExpr) {
                    items.forEach(function(item) {
                        return _this5._fillCache(cache, itemsExpr(item))
                    })
                }
                var containerChildrenExpr = this._getContainerChildrenExpr();
                if (containerChildrenExpr) {
                    items.forEach(function(item) {
                        return _this5._fillCache(cache, containerChildrenExpr(item))
                    })
                }
            };
            _proto._getKeyExpr = function() {
                throw "Not Implemented"
            };
            _proto._getItemsExpr = function() {};
            _proto._getContainerChildrenExpr = function() {};
            _proto._dataSourceOptions = function() {
                return {
                    paginate: false
                }
            };
            _proto._getStore = function() {
                return this._dataSource && this._dataSource.store()
            };
            _proto._getStoreKey = function(store, internalKey, data) {
                var storeKey = store.keyOf(data);
                if (storeKey === data) {
                    var keyExpr = this._getKeyExpr();
                    this._dataSourceItems.forEach(function(item) {
                        if (keyExpr(item) === internalKey) {
                            storeKey = item
                        }
                    })
                }
                return storeKey
            };
            _proto._getInternalKey = function(storeKey) {
                if ("object" === _typeof(storeKey)) {
                    var keyExpr = this._getKeyExpr();
                    return keyExpr(storeKey)
                }
                return storeKey
            };
            _proto._resetCache = function() {
                this._cache = {}
            };
            return ItemsOption
        }(_component.default);
        ItemsOption.include(_data_helper.default);
        var _default = ItemsOption;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/core/errors_warnings.js ***!
      \**************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _error = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/error */ 146));
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../../core/errors */ 25));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = (0, _error.default)(_errors.default.ERROR_MESSAGES, {
            E2001: "Invalid data source",
            E2002: "Axis type and data type are incompatible",
            E2003: 'The "{0}" data source field contains data of unsupported type',
            E2004: 'The "{0}" data source field is inconsistent',
            E2005: 'The value field "{0}" is absent in the data source or all its values are negative',
            E2006: "A cycle is detected in provided data",
            E2007: 'The value field "{0}" is absent in the data source',
            E2008: 'The value field "{0}" must be a string',
            E2009: 'The value field "{0}" must be a positive numeric value',
            E2101: "Unknown series type: {0}",
            E2102: "Ambiguity occurred between two value axes with the same name",
            E2103: 'The "{0}" option is given an invalid value. Assign a function instead',
            E2104: "Invalid logarithm base",
            E2105: 'Invalid value of a "{0}"',
            E2202: "Invalid {0} scale value",
            E2203: "The range you are trying to set is invalid",
            W2002: "The {0} series cannot be drawn because the {1} data field is missing",
            W2003: "Tick interval is too small",
            W2101: 'The "{0}" pane does not exist; the last pane is used by default',
            W2102: 'A value axis with the "{0}" name was created automatically',
            W2103: "The chart title was hidden due to the container size",
            W2104: "The legend was hidden due to the container size",
            W2105: 'The title of the "{0}" axis was hidden due to the container size',
            W2106: 'The labels of the "{0}" axis were hidden due to the container size',
            W2107: "The export menu was hidden due to the container size",
            W2108: "The browser does not support exporting images to {0} format.",
            W2301: "Invalid value range"
        });
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/series/points/pie_point.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _extend2 = __webpack_require__( /*! ../../../core/utils/extend */ 0);
        var _symbol_point = _interopRequireDefault(__webpack_require__( /*! ./symbol_point */ 144));
        var _utils = __webpack_require__( /*! ../../core/utils */ 14);
        var _type = __webpack_require__( /*! ../../../core/utils/type */ 1);
        var _consts = _interopRequireDefault(__webpack_require__( /*! ../../components/consts */ 143));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _extend = _extend2.extend;
        var _round = Math.round;
        var _sqrt = Math.sqrt;
        var _acos = Math.acos;
        var DEG = 180 / Math.PI;
        var _abs = Math.abs;
        var RADIAL_LABEL_INDENT = _consts.default.radialLabelIndent;
        var _default = _extend({}, _symbol_point.default, {
            _updateData: function(data, argumentChanged) {
                var that = this;
                _symbol_point.default._updateData.call(this, data);
                if (argumentChanged || !(0, _type.isDefined)(that._visible)) {
                    that._visible = true
                }
                that.minValue = that.initialMinValue = that.originalMinValue = (0, _type.isDefined)(data.minValue) ? data.minValue : 0
            },
            animate: function(complete, duration, delay) {
                var that = this;
                that.graphic.animate({
                    x: that.centerX,
                    y: that.centerY,
                    outerRadius: that.radiusOuter,
                    innerRadius: that.radiusInner,
                    startAngle: that.toAngle,
                    endAngle: that.fromAngle
                }, {
                    delay: delay,
                    partitionDuration: duration
                }, complete)
            },
            correctPosition: function(correction) {
                var that = this;
                that.correctRadius(correction);
                that.correctLabelRadius(correction.radiusOuter + RADIAL_LABEL_INDENT);
                that.centerX = correction.centerX;
                that.centerY = correction.centerY
            },
            correctRadius: function(correction) {
                this.radiusInner = correction.radiusInner;
                this.radiusOuter = correction.radiusOuter
            },
            correctLabelRadius: function(radiusLabels) {
                this.radiusLabels = radiusLabels
            },
            correctValue: function(correction, percent, base) {
                var that = this;
                that.value = (base || that.normalInitialValue) + correction;
                that.minValue = correction;
                that.percent = percent;
                that._label.setDataField("percent", percent)
            },
            _updateLabelData: function() {
                this._label.setData(this._getLabelFormatObject())
            },
            _getShiftLabelCoords: function() {
                var that = this;
                var bBox = that._label.getBoundingRect();
                var coord = that._getLabelCoords(that._label);
                var visibleArea = that._getVisibleArea();
                if (that._isLabelDrawingWithoutPoints) {
                    return that._checkLabelPosition(coord, bBox, visibleArea)
                } else {
                    return that._getLabelExtraCoord(coord, that._checkVerticalLabelPosition(coord, bBox, visibleArea), bBox)
                }
            },
            _getLabelPosition: function(options) {
                return options.position
            },
            getAnnotationCoords: function(location) {
                return this._getElementCoords("edge" !== location ? "inside" : "outside", this.radiusOuter, 0)
            },
            _getElementCoords: function(position, elementRadius, radialOffset) {
                var bBox = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                };
                var that = this;
                var angleFunctions = (0, _utils.getCosAndSin)(that.middleAngle);
                var radiusInner = that.radiusInner;
                var radiusOuter = that.radiusOuter;
                var columnsPosition = "columns" === position;
                var rad;
                var x;
                if ("inside" === position) {
                    rad = radiusInner + (radiusOuter - radiusInner) / 2 + radialOffset;
                    x = that.centerX + rad * angleFunctions.cos - bBox.width / 2
                } else {
                    rad = elementRadius + radialOffset;
                    if (angleFunctions.cos > .1 || columnsPosition && angleFunctions.cos >= 0) {
                        x = that.centerX + rad * angleFunctions.cos
                    } else {
                        if (angleFunctions.cos < -.1 || columnsPosition && angleFunctions.cos < 0) {
                            x = that.centerX + rad * angleFunctions.cos - bBox.width
                        } else {
                            x = that.centerX + rad * angleFunctions.cos - bBox.width / 2
                        }
                    }
                }
                return {
                    x: x,
                    y: _round(that.centerY - rad * angleFunctions.sin - bBox.height / 2)
                }
            },
            _getLabelCoords: function(label) {
                var that = this;
                var bBox = label.getBoundingRect();
                var options = label.getLayoutOptions();
                var position = that._getLabelPosition(options);
                return that._getElementCoords(position, that.radiusLabels, options.radialOffset, bBox)
            },
            _correctLabelCoord: function(coord, moveLabelsFromCenter) {
                var that = this;
                var label = that._label;
                var bBox = label.getBoundingRect();
                var labelWidth = bBox.width;
                var options = label.getLayoutOptions();
                var visibleArea = that._getVisibleArea();
                var rightBorderX = visibleArea.maxX - labelWidth;
                var leftBorderX = visibleArea.minX;
                var angleOfPoint = (0, _utils.normalizeAngle)(that.middleAngle);
                var centerX = that.centerX;
                var connectorOffset = options.connectorOffset;
                var x = coord.x;
                if ("columns" === options.position) {
                    if (angleOfPoint <= 90 || angleOfPoint >= 270) {
                        x = rightBorderX
                    } else {
                        x = leftBorderX
                    }
                    coord.x = x
                } else {
                    if ("inside" !== options.position && moveLabelsFromCenter) {
                        if (angleOfPoint <= 90 || angleOfPoint >= 270) {
                            if (x - connectorOffset < centerX) {
                                x = centerX + connectorOffset
                            }
                        } else {
                            if (x + labelWidth + connectorOffset > centerX) {
                                x = centerX - labelWidth - connectorOffset
                            }
                        }
                        coord.x = x
                    }
                }
                return coord
            },
            drawLabel: function() {
                this.translate();
                this._isLabelDrawingWithoutPoints = true;
                this._drawLabel();
                this._isLabelDrawingWithoutPoints = false
            },
            updateLabelCoord: function(moveLabelsFromCenter) {
                var that = this;
                var bBox = that._label.getBoundingRect();
                var coord = that._correctLabelCoord(bBox, moveLabelsFromCenter);
                coord = that._checkHorizontalLabelPosition(coord, bBox, that._getVisibleArea());
                that._label.shift(_round(coord.x), _round(bBox.y))
            },
            _checkVerticalLabelPosition: function(coord, box, visibleArea) {
                var x = coord.x;
                var y = coord.y;
                if (coord.y + box.height > visibleArea.maxY) {
                    y = visibleArea.maxY - box.height
                } else {
                    if (coord.y < visibleArea.minY) {
                        y = visibleArea.minY
                    }
                }
                return {
                    x: x,
                    y: y
                }
            },
            _getLabelExtraCoord: function(coord, shiftCoord, box) {
                return coord.y !== shiftCoord.y ? (0, _utils.getVerticallyShiftedAngularCoords)({
                    x: coord.x,
                    y: coord.y,
                    width: box.width,
                    height: box.height
                }, shiftCoord.y - coord.y, {
                    x: this.centerX,
                    y: this.centerY
                }) : coord
            },
            _checkHorizontalLabelPosition: function(coord, box, visibleArea) {
                var x = coord.x;
                var y = coord.y;
                if (coord.x + box.width > visibleArea.maxX) {
                    x = visibleArea.maxX - box.width
                } else {
                    if (coord.x < visibleArea.minX) {
                        x = visibleArea.minX
                    }
                }
                return {
                    x: x,
                    y: y
                }
            },
            applyWordWrap: function(moveLabelsFromCenter) {
                var that = this;
                var label = that._label;
                var box = label.getBoundingRect();
                var visibleArea = that._getVisibleArea();
                var position = label.getLayoutOptions().position;
                var width = box.width;
                var rowCountChanged = false;
                if ("columns" === position && that.series.index > 0) {
                    width = visibleArea.maxX - that.centerX - that.radiusLabels
                } else {
                    if ("inside" === position) {
                        if (width > visibleArea.maxX - visibleArea.minX) {
                            width = visibleArea.maxX - visibleArea.minX
                        }
                    } else {
                        if (moveLabelsFromCenter && box.x < that.centerX && box.width + box.x > that.centerX) {
                            width = Math.floor((visibleArea.maxX - visibleArea.minX) / 2)
                        } else {
                            if (box.x + width > visibleArea.maxX) {
                                width = visibleArea.maxX - box.x
                            } else {
                                if (box.x < visibleArea.minX) {
                                    width = box.x + width - visibleArea.minX
                                }
                            }
                        }
                    }
                }
                if (width < box.width) {
                    rowCountChanged = label.fit(width)
                }
                return rowCountChanged
            },
            setLabelTrackerData: function() {
                this._label.setTrackerData(this)
            },
            _checkLabelPosition: function(coord, bBox, visibleArea) {
                coord = this._checkHorizontalLabelPosition(coord, bBox, visibleArea);
                return this._checkVerticalLabelPosition(coord, bBox, visibleArea)
            },
            _getLabelConnector: function() {
                var that = this;
                var rad = that.radiusOuter;
                var seriesStyle = that._options.styles.normal;
                var strokeWidthBy2 = seriesStyle["stroke-width"] / 2;
                var borderWidth = that.series.getOptions().containerBackgroundColor === seriesStyle.stroke ? _round(strokeWidthBy2) : _round(-strokeWidthBy2);
                var angleFunctions = (0, _utils.getCosAndSin)(_round(that.middleAngle));
                return {
                    x: _round(that.centerX + (rad - borderWidth) * angleFunctions.cos),
                    y: _round(that.centerY - (rad - borderWidth) * angleFunctions.sin),
                    angle: that.middleAngle
                }
            },
            _drawMarker: function(renderer, group, animationEnabled, firstDrawing) {
                var that = this;
                var radiusOuter = that.radiusOuter;
                var radiusInner = that.radiusInner;
                var fromAngle = that.fromAngle;
                var toAngle = that.toAngle;
                if (animationEnabled) {
                    radiusInner = radiusOuter = 0;
                    if (!firstDrawing) {
                        fromAngle = toAngle = that.shiftedAngle
                    }
                }
                that.graphic = renderer.arc(that.centerX, that.centerY, radiusInner, radiusOuter, toAngle, fromAngle).attr({
                    "stroke-linejoin": "round"
                }).smartAttr(that._getStyle()).data({
                    "chart-data-point": that
                }).sharp().append(group)
            },
            getTooltipParams: function() {
                var that = this;
                var angleFunctions = (0, _utils.getCosAndSin)(that.middleAngle);
                var radiusInner = that.radiusInner;
                var radiusOuter = that.radiusOuter;
                return {
                    x: that.centerX + (radiusInner + (radiusOuter - radiusInner) / 2) * angleFunctions.cos,
                    y: that.centerY - (radiusInner + (radiusOuter - radiusInner) / 2) * angleFunctions.sin,
                    offset: 0
                }
            },
            _translate: function() {
                var that = this;
                var angle = that.shiftedAngle || 0;
                var value = that.value;
                var minValue = that.minValue;
                var translator = that._getValTranslator();
                that.fromAngle = translator.translate(minValue) + angle;
                that.toAngle = translator.translate(value) + angle;
                that.middleAngle = translator.translate((value - minValue) / 2 + minValue) + angle;
                if (!that.isVisible()) {
                    that.middleAngle = that.toAngle = that.fromAngle = that.fromAngle || angle
                }
            },
            getMarkerVisibility: function() {
                return true
            },
            _updateMarker: function(animationEnabled, style, _, callback) {
                var that = this;
                if (!animationEnabled) {
                    style = _extend({
                        x: that.centerX,
                        y: that.centerY,
                        outerRadius: that.radiusOuter,
                        innerRadius: that.radiusInner,
                        startAngle: that.toAngle,
                        endAngle: that.fromAngle
                    }, style)
                }
                that.graphic.smartAttr(style).sharp();
                callback && callback()
            },
            getLegendStyles: function() {
                return this._styles.legendStyles
            },
            isInVisibleArea: function() {
                return true
            },
            hide: function() {
                var that = this;
                if (that._visible) {
                    that._visible = false;
                    that.hideTooltip();
                    that._options.visibilityChanged()
                }
            },
            show: function() {
                var that = this;
                if (!that._visible) {
                    that._visible = true;
                    that._options.visibilityChanged()
                }
            },
            setInvisibility: function() {
                this._label.draw(false)
            },
            isVisible: function() {
                return this._visible
            },
            _getFormatObject: function(tooltip) {
                var formatObject = _symbol_point.default._getFormatObject.call(this, tooltip);
                var percent = this.percent;
                formatObject.percent = percent;
                formatObject.percentText = tooltip.formatValue(percent, "percent");
                return formatObject
            },
            getColor: function() {
                return this._styles.normal.fill
            },
            coordsIn: function(x, y) {
                var that = this;
                var lx = x - that.centerX;
                var ly = y - that.centerY;
                var r = _sqrt(lx * lx + ly * ly);
                var fromAngle = that.fromAngle % 360;
                var toAngle = that.toAngle % 360;
                var angle;
                if (r < that.radiusInner || r > that.radiusOuter || 0 === r) {
                    return false
                }
                angle = _acos(lx / r) * DEG * (ly > 0 ? -1 : 1);
                if (angle < 0) {
                    angle += 360
                }
                if (fromAngle === toAngle && _abs(that.toAngle - that.fromAngle) > 1e-4) {
                    return true
                } else {
                    return fromAngle >= toAngle ? angle <= fromAngle && angle >= toAngle : !(angle >= fromAngle && angle <= toAngle)
                }
            }
        });
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/series/points/range_symbol_point.js ***!
      \**************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _iterator = __webpack_require__( /*! ../../../core/utils/iterator */ 3);
        var _extend2 = __webpack_require__( /*! ../../../core/utils/extend */ 0);
        var _common = __webpack_require__( /*! ../../../core/utils/common */ 4);
        var _label = __webpack_require__( /*! ./label */ 315);
        var _symbol_point = _interopRequireDefault(__webpack_require__( /*! ./symbol_point */ 144));
        var _type = __webpack_require__( /*! ../../../core/utils/type */ 1);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _extend = _extend2.extend;
        var _math = Math;
        var _abs = _math.abs;
        var _min = _math.min;
        var _max = _math.max;
        var _round = _math.round;
        var DEFAULT_IMAGE_WIDTH = 20;
        var DEFAULT_IMAGE_HEIGHT = 20;
        var _default = _extend({}, _symbol_point.default, {
            deleteLabel: function() {
                var that = this;
                that._topLabel.dispose();
                that._topLabel = null;
                that._bottomLabel.dispose();
                that._bottomLabel = null
            },
            hideMarker: function(type) {
                var graphic = this.graphic;
                var marker = graphic && graphic[type + "Marker"];
                var label = this["_" + type + "Label"];
                if (marker && "hidden" !== marker.attr("visibility")) {
                    marker.attr({
                        visibility: "hidden"
                    })
                }
                label.draw(false)
            },
            setInvisibility: function() {
                this.hideMarker("top");
                this.hideMarker("bottom")
            },
            clearVisibility: function() {
                var that = this;
                var graphic = that.graphic;
                var topMarker = graphic && graphic.topMarker;
                var bottomMarker = graphic && graphic.bottomMarker;
                if (topMarker && topMarker.attr("visibility")) {
                    topMarker.attr({
                        visibility: null
                    })
                }
                if (bottomMarker && bottomMarker.attr("visibility")) {
                    bottomMarker.attr({
                        visibility: null
                    })
                }
            },
            clearMarker: function() {
                var that = this;
                var graphic = that.graphic;
                var topMarker = graphic && graphic.topMarker;
                var bottomMarker = graphic && graphic.bottomMarker;
                var emptySettings = that._emptySettings;
                topMarker && topMarker.attr(emptySettings);
                bottomMarker && bottomMarker.attr(emptySettings)
            },
            _getLabelPosition: function(markerType) {
                var position;
                var labelsInside = "inside" === this._options.label.position;
                if (!this._options.rotated) {
                    position = "top" === markerType ^ labelsInside ? "top" : "bottom"
                } else {
                    position = "top" === markerType ^ labelsInside ? "right" : "left"
                }
                return position
            },
            _getLabelMinFormatObject: function() {
                var that = this;
                return {
                    index: 0,
                    argument: that.initialArgument,
                    value: that.initialMinValue,
                    seriesName: that.series.name,
                    originalValue: that.originalMinValue,
                    originalArgument: that.originalArgument,
                    point: that
                }
            },
            _updateLabelData: function() {
                var maxFormatObject = this._getLabelFormatObject();
                maxFormatObject.index = 1;
                this._topLabel.setData(maxFormatObject);
                this._bottomLabel.setData(this._getLabelMinFormatObject())
            },
            _updateLabelOptions: function() {
                var that = this;
                var options = this._options.label;
                (!that._topLabel || !that._bottomLabel) && that._createLabel();
                that._topLabel.setOptions(options);
                that._bottomLabel.setOptions(options)
            },
            _createLabel: function() {
                var options = {
                    renderer: this.series._renderer,
                    labelsGroup: this.series._labelsGroup,
                    point: this
                };
                this._topLabel = new _label.Label(options);
                this._bottomLabel = new _label.Label(options)
            },
            _getGraphicBBox: function(location) {
                var options = this._options;
                var images = this._getImage(options.image);
                var image = "top" === location ? this._checkImage(images.top) : this._checkImage(images.bottom);
                var bBox;
                var coord = this._getPositionFromLocation(location);
                if (options.visible) {
                    bBox = image ? this._getImageBBox(coord.x, coord.y) : this._getSymbolBBox(coord.x, coord.y, options.styles.normal.r)
                } else {
                    bBox = {
                        x: coord.x,
                        y: coord.y,
                        width: 0,
                        height: 0
                    }
                }
                return bBox
            },
            _getPositionFromLocation: function(location) {
                var x;
                var y;
                var isTop = "top" === location;
                if (!this._options.rotated) {
                    x = this.x;
                    y = isTop ? _min(this.y, this.minY) : _max(this.y, this.minY)
                } else {
                    x = isTop ? _max(this.x, this.minX) : _min(this.x, this.minX);
                    y = this.y
                }
                return {
                    x: x,
                    y: y
                }
            },
            _checkOverlay: function(bottomCoord, topCoord, topValue) {
                return bottomCoord < topCoord + topValue
            },
            _getOverlayCorrections: function(topCoords, bottomCoords) {
                var rotated = this._options.rotated;
                var coordSelector = !rotated ? "y" : "x";
                var valueSelector = !rotated ? "height" : "width";
                var visibleArea = this.series.getValueAxis().getVisibleArea();
                var minBound = visibleArea[0];
                var maxBound = visibleArea[1];
                var delta = _round((topCoords[coordSelector] + topCoords[valueSelector] - bottomCoords[coordSelector]) / 2);
                var coord1 = topCoords[coordSelector] - delta;
                var coord2 = bottomCoords[coordSelector] + delta;
                if (coord1 < minBound) {
                    delta = minBound - coord1;
                    coord1 += delta;
                    coord2 += delta
                } else {
                    if (coord2 + bottomCoords[valueSelector] > maxBound) {
                        delta = maxBound - coord2 - bottomCoords[valueSelector];
                        coord1 += delta;
                        coord2 += delta
                    }
                }
                return {
                    coord1: coord1,
                    coord2: coord2
                }
            },
            _checkLabelsOverlay: function(topLocation) {
                var that = this;
                var topCoords = that._topLabel.getBoundingRect();
                var bottomCoords = that._bottomLabel.getBoundingRect();
                var corrections = {};
                if (!that._options.rotated) {
                    if ("top" === topLocation) {
                        if (this._checkOverlay(bottomCoords.y, topCoords.y, topCoords.height)) {
                            corrections = this._getOverlayCorrections(topCoords, bottomCoords);
                            that._topLabel.shift(topCoords.x, corrections.coord1);
                            that._bottomLabel.shift(bottomCoords.x, corrections.coord2)
                        }
                    } else {
                        if (this._checkOverlay(topCoords.y, bottomCoords.y, bottomCoords.height)) {
                            corrections = this._getOverlayCorrections(bottomCoords, topCoords);
                            that._topLabel.shift(topCoords.x, corrections.coord2);
                            that._bottomLabel.shift(bottomCoords.x, corrections.coord1)
                        }
                    }
                } else {
                    if ("top" === topLocation) {
                        if (this._checkOverlay(topCoords.x, bottomCoords.x, bottomCoords.width)) {
                            corrections = this._getOverlayCorrections(bottomCoords, topCoords);
                            that._topLabel.shift(corrections.coord2, topCoords.y);
                            that._bottomLabel.shift(corrections.coord1, bottomCoords.y)
                        }
                    } else {
                        if (this._checkOverlay(bottomCoords.x, topCoords.x, topCoords.width)) {
                            corrections = this._getOverlayCorrections(topCoords, bottomCoords);
                            that._topLabel.shift(corrections.coord1, topCoords.y);
                            that._bottomLabel.shift(corrections.coord2, bottomCoords.y)
                        }
                    }
                }
            },
            _drawLabel: function() {
                var that = this;
                var labels = [];
                var notInverted = that._options.rotated ? that.x >= that.minX : that.y < that.minY;
                var customVisibility = that._getCustomLabelVisibility();
                var topLabel = that._topLabel;
                var bottomLabel = that._bottomLabel;
                topLabel.pointPosition = notInverted ? "top" : "bottom";
                bottomLabel.pointPosition = notInverted ? "bottom" : "top";
                if ((that.series.getLabelVisibility() || customVisibility) && that.hasValue() && false !== customVisibility) {
                    false !== that.visibleTopMarker && labels.push(topLabel);
                    false !== that.visibleBottomMarker && labels.push(bottomLabel);
                    (0, _iterator.each)(labels, function(_, label) {
                        label.draw(true)
                    });
                    that._checkLabelsOverlay(that._topLabel.pointPosition)
                } else {
                    topLabel.draw(false);
                    bottomLabel.draw(false)
                }
            },
            _getImage: function(imageOption) {
                var image = {};
                if ((0, _type.isDefined)(imageOption)) {
                    if ("string" === typeof imageOption) {
                        image.top = image.bottom = imageOption
                    } else {
                        image.top = {
                            url: "string" === typeof imageOption.url ? imageOption.url : imageOption.url && imageOption.url.rangeMaxPoint,
                            width: "number" === typeof imageOption.width ? imageOption.width : imageOption.width && imageOption.width.rangeMaxPoint,
                            height: "number" === typeof imageOption.height ? imageOption.height : imageOption.height && imageOption.height.rangeMaxPoint
                        };
                        image.bottom = {
                            url: "string" === typeof imageOption.url ? imageOption.url : imageOption.url && imageOption.url.rangeMinPoint,
                            width: "number" === typeof imageOption.width ? imageOption.width : imageOption.width && imageOption.width.rangeMinPoint,
                            height: "number" === typeof imageOption.height ? imageOption.height : imageOption.height && imageOption.height.rangeMinPoint
                        }
                    }
                }
                return image
            },
            _checkSymbol: function(oldOptions, newOptions) {
                var that = this;
                var oldSymbol = oldOptions.symbol;
                var newSymbol = newOptions.symbol;
                var symbolChanged = "circle" === oldSymbol && "circle" !== newSymbol || "circle" !== oldSymbol && "circle" === newSymbol;
                var oldImages = that._getImage(oldOptions.image);
                var newImages = that._getImage(newOptions.image);
                var topImageChanged = that._checkImage(oldImages.top) !== that._checkImage(newImages.top);
                var bottomImageChanged = that._checkImage(oldImages.bottom) !== that._checkImage(newImages.bottom);
                return symbolChanged || topImageChanged || bottomImageChanged
            },
            _getSettingsForTwoMarkers: function(style) {
                var that = this;
                var options = that._options;
                var settings = {};
                var x = options.rotated ? _min(that.x, that.minX) : that.x;
                var y = options.rotated ? that.y : _min(that.y, that.minY);
                var radius = style.r;
                var points = that._populatePointShape(options.symbol, radius);
                settings.top = _extend({
                    translateX: x + that.width,
                    translateY: y,
                    r: radius
                }, style);
                settings.bottom = _extend({
                    translateX: x,
                    translateY: y + that.height,
                    r: radius
                }, style);
                if (points) {
                    settings.top.points = settings.bottom.points = points
                }
                return settings
            },
            _hasGraphic: function() {
                return this.graphic && this.graphic.topMarker && this.graphic.bottomMarker
            },
            _drawOneMarker: function(renderer, markerType, imageSettings, settings) {
                var that = this;
                var graphic = that.graphic;
                if (graphic[markerType]) {
                    that._updateOneMarker(markerType, settings)
                } else {
                    graphic[markerType] = that._createMarker(renderer, graphic, imageSettings, settings)
                }
            },
            _drawMarker: function(renderer, group, animationEnabled, firstDrawing, style) {
                var that = this;
                var settings = that._getSettingsForTwoMarkers(style || that._getStyle());
                var image = that._getImage(that._options.image);
                if (that._checkImage(image.top)) {
                    settings.top = that._getImageSettings(settings.top, image.top)
                }
                if (that._checkImage(image.bottom)) {
                    settings.bottom = that._getImageSettings(settings.bottom, image.bottom)
                }
                that.graphic = that.graphic || renderer.g().append(group);
                that.visibleTopMarker && that._drawOneMarker(renderer, "topMarker", image.top, settings.top);
                that.visibleBottomMarker && that._drawOneMarker(renderer, "bottomMarker", image.bottom, settings.bottom)
            },
            _getSettingsForTracker: function(radius) {
                var that = this;
                var rotated = that._options.rotated;
                return {
                    translateX: rotated ? _min(that.x, that.minX) - radius : that.x - radius,
                    translateY: rotated ? that.y - radius : _min(that.y, that.minY) - radius,
                    width: that.width + 2 * radius,
                    height: that.height + 2 * radius
                }
            },
            isInVisibleArea: function() {
                var that = this;
                var rotated = that._options.rotated;
                var argument = !rotated ? that.x : that.y;
                var maxValue = !rotated ? _max(that.minY, that.y) : _max(that.minX, that.x);
                var minValue = !rotated ? _min(that.minY, that.y) : _min(that.minX, that.x);
                var tmp;
                var visibleTopMarker = true;
                var visibleBottomMarker = true;
                var visibleRangeArea = true;
                var visibleArgArea = that.series.getArgumentAxis().getVisibleArea();
                var visibleValArea = that.series.getValueAxis().getVisibleArea();
                var notVisibleByArg = visibleArgArea[1] < argument || visibleArgArea[0] > argument;
                var notVisibleByVal = visibleValArea[0] > minValue && visibleValArea[0] > maxValue || visibleValArea[1] < minValue && visibleValArea[1] < maxValue;
                if (notVisibleByArg || notVisibleByVal) {
                    visibleTopMarker = visibleBottomMarker = visibleRangeArea = false
                } else {
                    visibleTopMarker = visibleValArea[0] <= minValue && visibleValArea[1] > minValue;
                    visibleBottomMarker = visibleValArea[0] < maxValue && visibleValArea[1] >= maxValue;
                    if (rotated) {
                        tmp = visibleTopMarker;
                        visibleTopMarker = visibleBottomMarker;
                        visibleBottomMarker = tmp
                    }
                }
                that.visibleTopMarker = visibleTopMarker;
                that.visibleBottomMarker = visibleBottomMarker;
                return visibleRangeArea
            },
            getTooltipParams: function() {
                var that = this;
                var x;
                var y;
                var rotated = that._options.rotated;
                var minValue = !rotated ? _min(that.y, that.minY) : _min(that.x, that.minX);
                var side = !rotated ? "height" : "width";
                var visibleArea = that._getVisibleArea();
                var minVisible = rotated ? visibleArea.minX : visibleArea.minY;
                var maxVisible = rotated ? visibleArea.maxX : visibleArea.maxY;
                var min = _max(minVisible, minValue);
                var max = _min(maxVisible, minValue + that[side]);
                if (!rotated) {
                    x = that.x;
                    y = min + (max - min) / 2
                } else {
                    y = that.y;
                    x = min + (max - min) / 2
                }
                return {
                    x: x,
                    y: y,
                    offset: 0
                }
            },
            _translate: function() {
                var that = this;
                var rotated = that._options.rotated;
                _symbol_point.default._translate.call(that);
                that.height = rotated ? 0 : _abs(that.minY - that.y);
                that.width = rotated ? _abs(that.x - that.minX) : 0
            },
            hasCoords: function() {
                return _symbol_point.default.hasCoords.call(this) && !(null === this.minX || null === this.minY)
            },
            _updateData: function(data) {
                var that = this;
                _symbol_point.default._updateData.call(that, data);
                that.minValue = that.initialMinValue = that.originalMinValue = data.minValue
            },
            _getImageSettings: function(settings, image) {
                return {
                    href: image.url || image.toString(),
                    width: image.width || DEFAULT_IMAGE_WIDTH,
                    height: image.height || DEFAULT_IMAGE_HEIGHT,
                    translateX: settings.translateX,
                    translateY: settings.translateY
                }
            },
            getCrosshairData: function(x, y) {
                var that = this;
                var rotated = that._options.rotated;
                var minX = that.minX;
                var minY = that.minY;
                var vx = that.vx;
                var vy = that.vy;
                var value = that.value;
                var minValue = that.minValue;
                var argument = that.argument;
                var coords = {
                    axis: that.series.axis,
                    x: vx,
                    y: vy,
                    yValue: value,
                    xValue: argument
                };
                if (rotated) {
                    coords.yValue = argument;
                    if (_abs(vx - x) < _abs(minX - x)) {
                        coords.xValue = value
                    } else {
                        coords.x = minX;
                        coords.xValue = minValue
                    }
                } else {
                    if (_abs(vy - y) >= _abs(minY - y)) {
                        coords.y = minY;
                        coords.yValue = minValue
                    }
                }
                return coords
            },
            _updateOneMarker: function(markerType, settings) {
                this.graphic && this.graphic[markerType] && this.graphic[markerType].attr(settings)
            },
            _updateMarker: function(animationEnabled, style) {
                this._drawMarker(void 0, void 0, false, false, style)
            },
            _getFormatObject: function(tooltip) {
                var that = this;
                var initialMinValue = that.initialMinValue;
                var initialValue = that.initialValue;
                var initialArgument = that.initialArgument;
                var minValue = tooltip.formatValue(initialMinValue);
                var value = tooltip.formatValue(initialValue);
                return {
                    argument: initialArgument,
                    argumentText: tooltip.formatValue(initialArgument, "argument"),
                    valueText: minValue + " - " + value,
                    rangeValue1Text: minValue,
                    rangeValue2Text: value,
                    rangeValue1: initialMinValue,
                    rangeValue2: initialValue,
                    seriesName: that.series.name,
                    point: that,
                    originalMinValue: that.originalMinValue,
                    originalValue: that.originalValue,
                    originalArgument: that.originalArgument
                }
            },
            getLabel: function() {
                return [this._topLabel, this._bottomLabel]
            },
            getLabels: function() {
                return [this._topLabel, this._bottomLabel]
            },
            getBoundingRect: _common.noop,
            coordsIn: function(x, y) {
                var trackerRadius = this._storeTrackerR();
                var xCond = x >= this.x - trackerRadius && x <= this.x + trackerRadius;
                var yCond = y >= this.y - trackerRadius && y <= this.y + trackerRadius;
                if (this._options.rotated) {
                    return yCond && (xCond || x >= this.minX - trackerRadius && x <= this.minX + trackerRadius)
                } else {
                    return xCond && (yCond || y >= this.minY - trackerRadius && y <= this.minY + trackerRadius)
                }
            },
            getMaxValue: function() {
                if ("discrete" !== this.series.valueAxisType) {
                    return this.minValue > this.value ? this.minValue : this.value
                }
                return this.value
            },
            getMinValue: function() {
                if ("discrete" !== this.series.valueAxisType) {
                    return this.minValue < this.value ? this.minValue : this.value
                }
                return this.minValue
            }
        });
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/series/points/candlestick_point.js ***!
      \*************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _extend2 = __webpack_require__( /*! ../../../core/utils/extend */ 0);
        var _symbol_point = _interopRequireDefault(__webpack_require__( /*! ./symbol_point */ 144));
        var _bar_point = _interopRequireDefault(__webpack_require__( /*! ./bar_point */ 225));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _math = Math;
        var _abs = _math.abs;
        var _min = _math.min;
        var _max = _math.max;
        var _round = _math.round;
        var DEFAULT_FINANCIAL_TRACKER_MARGIN = 2;
        var _default = (0, _extend2.extend)({}, _bar_point.default, {
            _getContinuousPoints: function(openCoord, closeCoord) {
                var that = this;
                var x = that.x;
                var createPoint = that._options.rotated ? function(x, y) {
                    return [y, x]
                } : function(x, y) {
                    return [x, y]
                };
                var width = that.width;
                var highCoord = that.highY;
                var max = _abs(highCoord - openCoord) < _abs(highCoord - closeCoord) ? openCoord : closeCoord;
                var min = max === closeCoord ? openCoord : closeCoord;
                var points;
                if (min === max) {
                    points = [].concat(createPoint(x, that.highY)).concat(createPoint(x, that.lowY)).concat(createPoint(x, that.closeY)).concat(createPoint(x - width / 2, that.closeY)).concat(createPoint(x + width / 2, that.closeY)).concat(createPoint(x, that.closeY))
                } else {
                    points = [].concat(createPoint(x, that.highY)).concat(createPoint(x, max)).concat(createPoint(x + width / 2, max)).concat(createPoint(x + width / 2, min)).concat(createPoint(x, min)).concat(createPoint(x, that.lowY)).concat(createPoint(x, min)).concat(createPoint(x - width / 2, min)).concat(createPoint(x - width / 2, max)).concat(createPoint(x, max))
                }
                return points
            },
            _getCrockPoints: function(y) {
                var that = this;
                var x = that.x;
                var createPoint = that._options.rotated ? function(x, y) {
                    return [y, x]
                } : function(x, y) {
                    return [x, y]
                };
                return [].concat(createPoint(x, that.highY)).concat(createPoint(x, that.lowY)).concat(createPoint(x, y)).concat(createPoint(x - that.width / 2, y)).concat(createPoint(x + that.width / 2, y)).concat(createPoint(x, y))
            },
            _getPoints: function() {
                var that = this;
                var points;
                var closeCoord = that.closeY;
                var openCoord = that.openY;
                if (null !== closeCoord && null !== openCoord) {
                    points = that._getContinuousPoints(openCoord, closeCoord)
                } else {
                    if (openCoord === closeCoord) {
                        points = [that.x, that.highY, that.x, that.lowY]
                    } else {
                        points = that._getCrockPoints(null !== openCoord ? openCoord : closeCoord)
                    }
                }
                return points
            },
            getColor: function() {
                var that = this;
                return that._isReduction ? that._options.reduction.color : that._styles.normal.stroke || that.series.getColor()
            },
            _drawMarkerInGroup: function(group, attributes, renderer) {
                var that = this;
                that.graphic = renderer.path(that._getPoints(), "area").attr({
                    "stroke-linecap": "square"
                }).attr(attributes).data({
                    "chart-data-point": that
                }).sharp().append(group)
            },
            _fillStyle: function() {
                var that = this;
                var styles = that._options.styles;
                if (that._isReduction && that._isPositive) {
                    that._styles = styles.reductionPositive
                } else {
                    if (that._isReduction) {
                        that._styles = styles.reduction
                    } else {
                        if (that._isPositive) {
                            that._styles = styles.positive
                        } else {
                            that._styles = styles
                        }
                    }
                }
            },
            _getMinTrackerWidth: function() {
                return 2 + 2 * this._styles.normal["stroke-width"]
            },
            correctCoordinates: function(correctOptions) {
                var minWidth = this._getMinTrackerWidth();
                var maxWidth = 10;
                var width = correctOptions.width;
                width = width < minWidth ? minWidth : width > maxWidth ? maxWidth : width;
                this.width = width + width % 2;
                this.xCorrection = correctOptions.offset
            },
            _getMarkerGroup: function(group) {
                var that = this;
                var markerGroup;
                if (that._isReduction && that._isPositive) {
                    markerGroup = group.reductionPositiveMarkersGroup
                } else {
                    if (that._isReduction) {
                        markerGroup = group.reductionMarkersGroup
                    } else {
                        if (that._isPositive) {
                            markerGroup = group.defaultPositiveMarkersGroup
                        } else {
                            markerGroup = group.defaultMarkersGroup
                        }
                    }
                }
                return markerGroup
            },
            _drawMarker: function(renderer, group) {
                this._drawMarkerInGroup(this._getMarkerGroup(group), this._getStyle(), renderer)
            },
            _getSettingsForTracker: function() {
                var that = this;
                var highY = that.highY;
                var lowY = that.lowY;
                var rotated = that._options.rotated;
                var x;
                var y;
                var width;
                var height;
                if (highY === lowY) {
                    highY = rotated ? highY + DEFAULT_FINANCIAL_TRACKER_MARGIN : highY - DEFAULT_FINANCIAL_TRACKER_MARGIN;
                    lowY = rotated ? lowY - DEFAULT_FINANCIAL_TRACKER_MARGIN : lowY + DEFAULT_FINANCIAL_TRACKER_MARGIN
                }
                if (rotated) {
                    x = _min(lowY, highY);
                    y = that.x - that.width / 2;
                    width = _abs(lowY - highY);
                    height = that.width
                } else {
                    x = that.x - that.width / 2;
                    y = _min(lowY, highY);
                    width = that.width;
                    height = _abs(lowY - highY)
                }
                return {
                    x: x,
                    y: y,
                    width: width,
                    height: height
                }
            },
            _getGraphicBBox: function(location) {
                var that = this;
                var rotated = that._options.rotated;
                var x = that.x;
                var width = that.width;
                var lowY = that.lowY;
                var highY = that.highY;
                if (location) {
                    var valVisibleArea = that.series.getValueAxis().getVisibleArea();
                    highY = that._truncateCoord(highY, valVisibleArea);
                    lowY = that._truncateCoord(lowY, valVisibleArea)
                }
                var bBox = {
                    x: !rotated ? x - _round(width / 2) : lowY,
                    y: !rotated ? highY : x - _round(width / 2),
                    width: !rotated ? width : highY - lowY,
                    height: !rotated ? lowY - highY : width
                };
                if (location) {
                    var isTop = "top" === location;
                    if (!this._options.rotated) {
                        bBox.y = isTop ? bBox.y : bBox.y + bBox.height;
                        bBox.height = 0
                    } else {
                        bBox.x = isTop ? bBox.x + bBox.width : bBox.x;
                        bBox.width = 0
                    }
                }
                return bBox
            },
            getTooltipParams: function(location) {
                var that = this;
                if (that.graphic) {
                    var minValue = _min(that.lowY, that.highY);
                    var maxValue = _max(that.lowY, that.highY);
                    var visibleArea = that._getVisibleArea();
                    var rotated = that._options.rotated;
                    var minVisible = rotated ? visibleArea.minX : visibleArea.minY;
                    var maxVisible = rotated ? visibleArea.maxX : visibleArea.maxY;
                    var min = _max(minVisible, minValue);
                    var max = _min(maxVisible, maxValue);
                    var centerCoord = that.getCenterCoord();
                    if ("edge" === location) {
                        centerCoord[rotated ? "x" : "y"] = rotated ? max : min
                    }
                    centerCoord.offset = 0;
                    return centerCoord
                }
            },
            getCenterCoord: function() {
                if (this.graphic) {
                    var that = this;
                    var x;
                    var y;
                    var minValue = _min(that.lowY, that.highY);
                    var maxValue = _max(that.lowY, that.highY);
                    var visibleArea = that._getVisibleArea();
                    var rotated = that._options.rotated;
                    var minVisible = rotated ? visibleArea.minX : visibleArea.minY;
                    var maxVisible = rotated ? visibleArea.maxX : visibleArea.maxY;
                    var min = _max(minVisible, minValue);
                    var max = _min(maxVisible, maxValue);
                    var center = min + (max - min) / 2;
                    if (rotated) {
                        y = that.x;
                        x = center
                    } else {
                        x = that.x;
                        y = center
                    }
                    return {
                        x: x,
                        y: y
                    }
                }
            },
            hasValue: function() {
                return null !== this.highValue && null !== this.lowValue
            },
            hasCoords: function() {
                return null !== this.x && null !== this.lowY && null !== this.highY
            },
            _translate: function() {
                var that = this;
                var rotated = that._options.rotated;
                var valTranslator = that._getValTranslator();
                var x = that._getArgTranslator().translate(that.argument);
                that.vx = that.vy = that.x = null === x ? x : x + (that.xCorrection || 0);
                that.openY = null !== that.openValue ? valTranslator.translate(that.openValue) : null;
                that.highY = valTranslator.translate(that.highValue);
                that.lowY = valTranslator.translate(that.lowValue);
                that.closeY = null !== that.closeValue ? valTranslator.translate(that.closeValue) : null;
                var centerValue = _min(that.lowY, that.highY) + _abs(that.lowY - that.highY) / 2;
                that._calculateVisibility(!rotated ? that.x : centerValue, !rotated ? centerValue : that.x)
            },
            getCrosshairData: function(x, y) {
                var that = this;
                var rotated = that._options.rotated;
                var origY = rotated ? x : y;
                var yValue;
                var argument = that.argument;
                var coords;
                var coord = "low";
                if (_abs(that.lowY - origY) < _abs(that.closeY - origY)) {
                    yValue = that.lowY
                } else {
                    yValue = that.closeY;
                    coord = "close"
                }
                if (_abs(yValue - origY) >= _abs(that.openY - origY)) {
                    yValue = that.openY;
                    coord = "open"
                }
                if (_abs(yValue - origY) >= _abs(that.highY - origY)) {
                    yValue = that.highY;
                    coord = "high"
                }
                if (rotated) {
                    coords = {
                        y: that.vy,
                        x: yValue,
                        xValue: that[coord + "Value"],
                        yValue: argument
                    }
                } else {
                    coords = {
                        x: that.vx,
                        y: yValue,
                        xValue: argument,
                        yValue: that[coord + "Value"]
                    }
                }
                coords.axis = that.series.axis;
                return coords
            },
            _updateData: function(data) {
                var that = this;
                var label = that._label;
                var reductionColor = this._options.reduction.color;
                that.value = that.initialValue = data.reductionValue;
                that.originalValue = data.value;
                that.lowValue = that.originalLowValue = data.lowValue;
                that.highValue = that.originalHighValue = data.highValue;
                that.openValue = that.originalOpenValue = data.openValue;
                that.closeValue = that.originalCloseValue = data.closeValue;
                that._isPositive = data.openValue < data.closeValue;
                that._isReduction = data.isReduction;
                if (that._isReduction) {
                    label.setColor(reductionColor)
                }
            },
            _updateMarker: function(animationEnabled, style, group) {
                var that = this;
                var graphic = that.graphic;
                graphic.attr({
                    points: that._getPoints()
                }).smartAttr(style).sharp();
                group && graphic.append(that._getMarkerGroup(group))
            },
            _getLabelFormatObject: function() {
                var that = this;
                return {
                    openValue: that.openValue,
                    highValue: that.highValue,
                    lowValue: that.lowValue,
                    closeValue: that.closeValue,
                    reductionValue: that.initialValue,
                    argument: that.initialArgument,
                    value: that.initialValue,
                    seriesName: that.series.name,
                    originalOpenValue: that.originalOpenValue,
                    originalCloseValue: that.originalCloseValue,
                    originalLowValue: that.originalLowValue,
                    originalHighValue: that.originalHighValue,
                    originalArgument: that.originalArgument,
                    point: that
                }
            },
            _getFormatObject: function(tooltip) {
                var that = this;
                var highValue = tooltip.formatValue(that.highValue);
                var openValue = tooltip.formatValue(that.openValue);
                var closeValue = tooltip.formatValue(that.closeValue);
                var lowValue = tooltip.formatValue(that.lowValue);
                var symbolMethods = _symbol_point.default;
                var formatObject = symbolMethods._getFormatObject.call(that, tooltip);
                return (0, _extend2.extend)({}, formatObject, {
                    valueText: "h: " + highValue + ("" !== openValue ? " o: " + openValue : "") + ("" !== closeValue ? " c: " + closeValue : "") + " l: " + lowValue,
                    highValueText: highValue,
                    openValueText: openValue,
                    closeValueText: closeValue,
                    lowValueText: lowValue
                })
            },
            getMaxValue: function() {
                return this.highValue
            },
            getMinValue: function() {
                return this.lowValue
            }
        });
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/components/chart_theme_manager.js ***!
      \************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.ThemeManager = void 0;
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _base_theme_manager = __webpack_require__( /*! ../core/base_theme_manager */ 310);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var ThemeManager = _base_theme_manager.BaseThemeManager.inherit(function() {
            var ctor = function(params) {
                var that = this;
                that.callBase.apply(that, arguments);
                var options = params.options || {};
                that._userOptions = options;
                that._mergeAxisTitleOptions = [];
                that._multiPieColors = {};
                that._callback = _common.noop
            };
            var dispose = function() {
                var that = this;
                that.palette && that.palette.dispose();
                that.palette = that._userOptions = that._mergedSettings = that._multiPieColors = null;
                return that.callBase.apply(that, arguments)
            };
            var resetPalette = function() {
                this.palette.reset();
                this._multiPieColors = {}
            };
            var processTitleOptions = function(options) {
                return (0, _type.isString)(options) ? {
                    text: options
                } : options
            };
            var processAxisOptions = function(axisOptions) {
                if (!axisOptions) {
                    return {}
                }
                axisOptions = (0, _extend.extend)(true, {}, axisOptions);
                axisOptions.title = processTitleOptions(axisOptions.title);
                if ("logarithmic" === axisOptions.type && axisOptions.logarithmBase <= 0 || axisOptions.logarithmBase && !(0, _type.isNumeric)(axisOptions.logarithmBase)) {
                    axisOptions.logarithmBase = void 0;
                    axisOptions.logarithmBaseError = true
                }
                if (axisOptions.label) {
                    if (axisOptions.label.alignment) {
                        axisOptions.label.userAlignment = true
                    }
                }
                return axisOptions
            };
            var applyParticularAxisOptions = function(name, userOptions, rotated) {
                var theme = this._theme;
                var position = !(rotated ^ "valueAxis" === name) ? "horizontalAxis" : "verticalAxis";
                var processedUserOptions = processAxisOptions(userOptions, name);
                var commonAxisSettings = processAxisOptions(this._userOptions.commonAxisSettings, name);
                var mergeOptions = (0, _extend.extend)(true, {}, theme.commonAxisSettings, theme[position], theme[name], commonAxisSettings, processedUserOptions);
                mergeOptions.workWeek = processedUserOptions.workWeek || theme[name].workWeek;
                mergeOptions.forceUserTickInterval |= (0, _type.isDefined)(processedUserOptions.tickInterval) && !(0, _type.isDefined)(processedUserOptions.axisDivisionFactor);
                return mergeOptions
            };
            var mergeOptions = function(name, userOptions) {
                userOptions = userOptions || this._userOptions[name];
                var theme = this._theme[name];
                var result = this._mergedSettings[name];
                if (result) {
                    return result
                }
                if ((0, _type.isPlainObject)(theme) && (0, _type.isPlainObject)(userOptions)) {
                    result = (0, _extend.extend)(true, {}, theme, userOptions)
                } else {
                    result = (0, _type.isDefined)(userOptions) ? userOptions : theme
                }
                this._mergedSettings[name] = result;
                return result
            };
            var applyParticularTheme = {
                base: mergeOptions,
                argumentAxis: applyParticularAxisOptions,
                valueAxisRangeSelector: function() {
                    return mergeOptions.call(this, "valueAxis")
                },
                valueAxis: applyParticularAxisOptions,
                series: function(name, userOptions, seriesCount) {
                    var that = this;
                    var theme = that._theme;
                    var userCommonSettings = that._userOptions.commonSeriesSettings || {};
                    var themeCommonSettings = theme.commonSeriesSettings;
                    var widgetType = that._themeSection.split(".").slice(-1)[0];
                    var type = (0, _utils.normalizeEnum)(userOptions.type || userCommonSettings.type || themeCommonSettings.type || "pie" === widgetType && theme.type);
                    var palette = that.palette;
                    var isBar = ~type.indexOf("bar");
                    var isLine = ~type.indexOf("line");
                    var isArea = ~type.indexOf("area");
                    var isBubble = "bubble" === type;
                    var mainSeriesColor;
                    var resolveLabelsOverlapping = that.getOptions("resolveLabelsOverlapping");
                    var containerBackgroundColor = that.getOptions("containerBackgroundColor");
                    var seriesTemplate = applyParticularTheme.seriesTemplate.call(this);
                    var seriesVisibility;
                    if (isBar || isBubble) {
                        userOptions = (0, _extend.extend)(true, {}, userCommonSettings, userCommonSettings[type], userOptions);
                        seriesVisibility = userOptions.visible;
                        userCommonSettings = {
                            type: {}
                        };
                        (0, _extend.extend)(true, userOptions, userOptions.point);
                        userOptions.visible = seriesVisibility
                    }
                    var settings = (0, _extend.extend)(true, {
                        aggregation: {}
                    }, themeCommonSettings, themeCommonSettings[type], userCommonSettings, userCommonSettings[type], userOptions);
                    settings.aggregation.enabled = "chart" === widgetType && !!settings.aggregation.enabled;
                    settings.type = type;
                    settings.widgetType = widgetType;
                    settings.containerBackgroundColor = containerBackgroundColor;
                    if ("pie" !== widgetType) {
                        mainSeriesColor = settings.color || palette.getNextColor(seriesCount)
                    } else {
                        mainSeriesColor = function(argument, index, count) {
                            var cat = "".concat(argument, "-").concat(index);
                            if (!that._multiPieColors[cat]) {
                                that._multiPieColors[cat] = palette.getNextColor(count)
                            }
                            return that._multiPieColors[cat]
                        }
                    }
                    settings.mainSeriesColor = mainSeriesColor;
                    settings.resolveLabelsOverlapping = resolveLabelsOverlapping;
                    if (settings.label && (isLine || isArea && "rangearea" !== type || "scatter" === type)) {
                        settings.label.position = "outside"
                    }
                    if (seriesTemplate) {
                        settings.nameField = seriesTemplate.nameField
                    }
                    return settings
                },
                animation: function(name) {
                    var userOptions = this._userOptions[name];
                    userOptions = (0, _type.isPlainObject)(userOptions) ? userOptions : (0, _type.isDefined)(userOptions) ? {
                        enabled: !!userOptions
                    } : {};
                    return mergeOptions.call(this, name, userOptions)
                },
                seriesTemplate: function() {
                    var value = mergeOptions.call(this, "seriesTemplate");
                    if (value) {
                        value.nameField = value.nameField || "series"
                    }
                    return value
                },
                zoomAndPan: function() {
                    function parseOption(option) {
                        option = (0, _utils.normalizeEnum)(option);
                        var pan = "pan" === option || "both" === option;
                        var zoom = "zoom" === option || "both" === option;
                        return {
                            pan: pan,
                            zoom: zoom,
                            none: !pan && !zoom
                        }
                    }
                    var options = mergeOptions.call(this, "zoomAndPan");
                    return {
                        valueAxis: parseOption(options.valueAxis),
                        argumentAxis: parseOption(options.argumentAxis),
                        dragToZoom: !!options.dragToZoom,
                        dragBoxStyle: {
                            "class": "dxc-shutter",
                            fill: options.dragBoxStyle.color,
                            opacity: options.dragBoxStyle.opacity
                        },
                        panKey: options.panKey,
                        allowMouseWheel: !!options.allowMouseWheel,
                        allowTouchGestures: !!options.allowTouchGestures
                    }
                }
            };
            return {
                _themeSection: "chart",
                ctor: ctor,
                dispose: dispose,
                resetPalette: resetPalette,
                getOptions: function(name) {
                    return (applyParticularTheme[name] || applyParticularTheme.base).apply(this, arguments)
                },
                refresh: function() {
                    this._mergedSettings = {};
                    return this.callBase.apply(this, arguments)
                },
                _initializeTheme: function() {
                    var that = this;
                    that.callBase.apply(that, arguments);
                    that.updatePalette()
                },
                resetOptions: function(name) {
                    this._mergedSettings[name] = null
                },
                update: function(options) {
                    this._userOptions = options
                },
                updatePalette: function() {
                    var that = this;
                    that.palette = that.createPalette(that.getOptions("palette"), {
                        useHighlight: true,
                        extensionMode: that.getOptions("paletteExtensionMode")
                    })
                }
            }
        }());
        exports.ThemeManager = ThemeManager
    },
    /*!*************************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/chart_components/layout_manager.js ***!
      \*************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.LayoutManager = LayoutManager;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _consts = _interopRequireDefault(__webpack_require__( /*! ../components/consts */ 143));
        var _layout_element = __webpack_require__( /*! ../core/layout_element */ 311);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var floor = Math.floor,
            sqrt = Math.sqrt;
        var _min = Math.min;
        var _max = Math.max;
        var DEFAULT_INNER_RADIUS = .5;
        var RADIAL_LABEL_INDENT = _consts.default.radialLabelIndent;

        function getNearestCoord(firstCoord, secondCoord, pointCenterCoord) {
            var nearestCoord;
            if (pointCenterCoord < firstCoord) {
                nearestCoord = firstCoord
            } else {
                if (secondCoord < pointCenterCoord) {
                    nearestCoord = secondCoord
                } else {
                    nearestCoord = pointCenterCoord
                }
            }
            return nearestCoord
        }

        function getLabelLayout(point) {
            if (point._label.isVisible() && "inside" !== point._label.getLayoutOptions().position) {
                return point._label.getBoundingRect()
            }
        }

        function getPieRadius(series, paneCenterX, paneCenterY, accessibleRadius, minR) {
            series.some(function(singleSeries) {
                return singleSeries.getVisiblePoints().reduce(function(radiusIsFound, point) {
                    var labelBBox = getLabelLayout(point);
                    if (labelBBox) {
                        var xCoords = getNearestCoord(labelBBox.x, labelBBox.x + labelBBox.width, paneCenterX);
                        var yCoords = getNearestCoord(labelBBox.y, labelBBox.y + labelBBox.height, paneCenterY);
                        accessibleRadius = _min(_max(getLengthFromCenter(xCoords, yCoords, paneCenterX, paneCenterY) - RADIAL_LABEL_INDENT, minR), accessibleRadius);
                        radiusIsFound = true
                    }
                    return radiusIsFound
                }, false)
            });
            return accessibleRadius
        }

        function getSizeLabels(series) {
            return series.reduce(function(res, singleSeries) {
                var maxWidth = singleSeries.getVisiblePoints().reduce(function(width, point) {
                    var labelBBox = getLabelLayout(point);
                    if (labelBBox && labelBBox.width > width) {
                        width = labelBBox.width
                    }
                    return width
                }, 0);
                var rWidth = maxWidth;
                if (maxWidth) {
                    res.outerLabelsCount++;
                    if (res.outerLabelsCount > 1) {
                        maxWidth += _consts.default.pieLabelSpacing
                    }
                    rWidth += _consts.default.pieLabelSpacing
                }
                res.sizes.push(maxWidth);
                res.rSizes.push(rWidth);
                res.common += maxWidth;
                return res
            }, {
                sizes: [],
                rSizes: [],
                common: 0,
                outerLabelsCount: 0
            })
        }

        function correctLabelRadius(labelSizes, radius, series, canvas, averageWidthLabels, centerX) {
            var curRadius;
            var i;
            var runningWidth = 0;
            var sizes = labelSizes.sizes;
            var rSizes = labelSizes.rSizes;
            for (i = 0; i < series.length; i++) {
                if (0 === sizes[i]) {
                    curRadius && (curRadius += rSizes[i - 1]);
                    continue
                }
                curRadius = floor(curRadius ? curRadius + rSizes[i - 1] : radius);
                series[i].correctLabelRadius(curRadius);
                runningWidth += averageWidthLabels || sizes[i];
                rSizes[i] = averageWidthLabels || rSizes[i];
                series[i].setVisibleArea({
                    left: floor(centerX - radius - runningWidth),
                    right: floor(canvas.width - (centerX + radius + runningWidth)),
                    top: canvas.top,
                    bottom: canvas.bottom,
                    width: canvas.width,
                    height: canvas.height
                })
            }
        }

        function getLengthFromCenter(x, y, paneCenterX, paneCenterY) {
            return sqrt((x - paneCenterX) * (x - paneCenterX) + (y - paneCenterY) * (y - paneCenterY))
        }

        function getInnerRadius(_ref) {
            var type = _ref.type,
                innerRadius = _ref.innerRadius;
            return "pie" === type ? 0 : (0, _type.isNumeric)(innerRadius) ? Number(innerRadius) : DEFAULT_INNER_RADIUS
        }

        function LayoutManager() {}

        function getAverageLabelWidth(centerX, radius, canvas, sizeLabels) {
            return (centerX - radius - RADIAL_LABEL_INDENT - canvas.left) / sizeLabels.outerLabelsCount
        }

        function getFullRadiusWithLabels(centerX, canvas, sizeLabels) {
            return centerX - canvas.left - (sizeLabels.outerLabelsCount > 0 ? sizeLabels.common + RADIAL_LABEL_INDENT : 0)
        }

        function correctAvailableRadius(availableRadius, canvas, series, minR, paneCenterX, paneCenterY) {
            var sizeLabels = getSizeLabels(series);
            var averageWidthLabels;
            var fullRadiusWithLabels = getFullRadiusWithLabels(paneCenterX, canvas, sizeLabels);
            if (fullRadiusWithLabels < minR) {
                availableRadius = minR;
                averageWidthLabels = getAverageLabelWidth(paneCenterX, availableRadius, canvas, sizeLabels)
            } else {
                availableRadius = _min(getPieRadius(series, paneCenterX, paneCenterY, availableRadius, minR), fullRadiusWithLabels)
            }
            correctLabelRadius(sizeLabels, availableRadius + RADIAL_LABEL_INDENT, series, canvas, averageWidthLabels, paneCenterX);
            return availableRadius
        }

        function toLayoutElementCoords(canvas) {
            return new _layout_element.WrapperLayoutElement(null, {
                x: canvas.left,
                y: canvas.top,
                width: canvas.width - canvas.left - canvas.right,
                height: canvas.height - canvas.top - canvas.bottom
            })
        }
        LayoutManager.prototype = {
            constructor: LayoutManager,
            setOptions: function(options) {
                this._options = options
            },
            applyPieChartSeriesLayout: function(canvas, series, hideLayoutLabels) {
                var paneSpaceHeight = canvas.height - canvas.top - canvas.bottom;
                var paneSpaceWidth = canvas.width - canvas.left - canvas.right;
                var paneCenterX = paneSpaceWidth / 2 + canvas.left;
                var paneCenterY = paneSpaceHeight / 2 + canvas.top;
                var piePercentage = this._options.piePercentage;
                var availableRadius;
                var minR;
                if ((0, _type.isNumeric)(piePercentage)) {
                    availableRadius = minR = piePercentage * _min(canvas.height, canvas.width) / 2
                } else {
                    availableRadius = _min(paneSpaceWidth, paneSpaceHeight) / 2;
                    minR = this._options.minPiePercentage * availableRadius
                }
                if (!hideLayoutLabels) {
                    availableRadius = correctAvailableRadius(availableRadius, canvas, series, minR, paneCenterX, paneCenterY)
                }
                return {
                    centerX: floor(paneCenterX),
                    centerY: floor(paneCenterY),
                    radiusInner: floor(availableRadius * getInnerRadius(series[0])),
                    radiusOuter: floor(availableRadius)
                }
            },
            applyEqualPieChartLayout: function(series, layout) {
                var radius = layout.radius;
                return {
                    centerX: floor(layout.x),
                    centerY: floor(layout.y),
                    radiusInner: floor(radius * getInnerRadius(series[0])),
                    radiusOuter: floor(radius)
                }
            },
            correctPieLabelRadius: function(series, layout, canvas) {
                var sizeLabels = getSizeLabels(series);
                var averageWidthLabels;
                var radius = layout.radiusOuter + RADIAL_LABEL_INDENT;
                var availableLabelWidth = layout.centerX - canvas.left - radius;
                if (sizeLabels.common + RADIAL_LABEL_INDENT > availableLabelWidth) {
                    averageWidthLabels = getAverageLabelWidth(layout.centerX, layout.radiusOuter, canvas, sizeLabels)
                }
                correctLabelRadius(sizeLabels, radius, series, canvas, averageWidthLabels, layout.centerX)
            },
            needMoreSpaceForPanesCanvas: function(panes, rotated, fixedSizeCallback) {
                var options = this._options;
                var width = options.width;
                var height = options.height;
                var piePercentage = options.piePercentage;
                var percentageIsValid = (0, _type.isNumeric)(piePercentage);
                var needHorizontalSpace = 0;
                var needVerticalSpace = 0;
                panes.forEach(function(pane) {
                    var paneCanvas = pane.canvas;
                    var minSize = percentageIsValid ? _min(paneCanvas.width, paneCanvas.height) * piePercentage : void 0;
                    var paneSized = fixedSizeCallback ? fixedSizeCallback(pane) : {
                        width: false,
                        height: false
                    };
                    var needPaneHorizontalSpace = !paneSized.width ? (percentageIsValid ? minSize : width) - (paneCanvas.width - paneCanvas.left - paneCanvas.right) : 0;
                    var needPaneVerticalSpace = !paneSized.height ? (percentageIsValid ? minSize : height) - (paneCanvas.height - paneCanvas.top - paneCanvas.bottom) : 0;
                    if (rotated) {
                        needHorizontalSpace += needPaneHorizontalSpace > 0 ? needPaneHorizontalSpace : 0;
                        needVerticalSpace = _max(needPaneVerticalSpace > 0 ? needPaneVerticalSpace : 0, needVerticalSpace)
                    } else {
                        needHorizontalSpace = _max(needPaneHorizontalSpace > 0 ? needPaneHorizontalSpace : 0, needHorizontalSpace);
                        needVerticalSpace += needPaneVerticalSpace > 0 ? needPaneVerticalSpace : 0
                    }
                });
                return needHorizontalSpace > 0 || needVerticalSpace > 0 ? {
                    width: needHorizontalSpace,
                    height: needVerticalSpace
                } : false
            },
            layoutInsideLegend: function(legend, canvas) {
                var inverseAlign = {
                    left: "right",
                    right: "left",
                    top: "bottom",
                    bottom: "top",
                    center: "center"
                };
                var layoutOptions = legend.getLayoutOptions();
                if (!layoutOptions) {
                    return
                }
                var position = layoutOptions.position;
                var cutSide = layoutOptions.cutSide;
                var my = {
                    horizontal: position.horizontal,
                    vertical: position.vertical
                };
                canvas[layoutOptions.cutLayoutSide] += "horizontal" === layoutOptions.cutSide ? layoutOptions.width : layoutOptions.height;
                my[cutSide] = inverseAlign[my[cutSide]];
                legend.position({
                    of: toLayoutElementCoords(canvas),
                    my: my,
                    at: position
                })
            }
        }
    },
    /*!*****************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/core/plaque.js ***!
      \*****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.Plaque = void 0;
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function _objectWithoutProperties(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = _objectWithoutPropertiesLoose(source, excluded);
            var key, i;
            if (Object.getOwnPropertySymbols) {
                var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
                for (i = 0; i < sourceSymbolKeys.length; i++) {
                    key = sourceSymbolKeys[i];
                    if (excluded.indexOf(key) >= 0) {
                        continue
                    }
                    if (!Object.prototype.propertyIsEnumerable.call(source, key)) {
                        continue
                    }
                    target[key] = source[key]
                }
            }
            return target
        }

        function _objectWithoutPropertiesLoose(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = {};
            var sourceKeys = Object.keys(source);
            var key, i;
            for (i = 0; i < sourceKeys.length; i++) {
                key = sourceKeys[i];
                if (excluded.indexOf(key) >= 0) {
                    continue
                }
                target[key] = source[key]
            }
            return target
        }
        var math = Math;
        var round = math.round;
        var max = math.max;
        var min = math.min;
        var sin = math.sin;
        var cos = math.cos;
        var asin = math.asin;
        var PI = math.PI;
        var buildPath = function() {
            for (var _len = arguments.length, points = new Array(_len), _key = 0; _key < _len; _key++) {
                points[_key] = arguments[_key]
            }
            return points.join("")
        };

        function getArc(cornerRadius, xDirection, yDirection) {
            return "a ".concat(cornerRadius, " ").concat(cornerRadius, " 0 0 1 ").concat(xDirection * cornerRadius, " ").concat(yDirection * cornerRadius)
        }

        function getAbsoluteArc(cornerRadius, x, y) {
            return "A ".concat(cornerRadius, " ").concat(cornerRadius, " 0 0 1 ").concat(x, " ").concat(y)
        }

        function rotateX(x, y, angle, x0, y0) {
            return (x - x0) * round(cos(angle)) + (y - y0) * round(sin(angle)) + x0
        }

        function rotateY(x, y, angle, x0, y0) {
            return -(x - x0) * round(sin(angle)) + (y - y0) * round(cos(angle)) + y0
        }

        function rotateSize(options, angle) {
            if (angle % 90 === 0 && angle % 180 !== 0) {
                return {
                    width: options.height,
                    height: options.width
                }
            }
            return options
        }

        function getCloudAngle(_ref, x, y, anchorX, anchorY) {
            var width = _ref.width,
                height = _ref.height;
            var halfWidth = width / 2;
            var halfHeight = height / 2;
            var xr = Math.ceil(x + halfWidth);
            var xl = Math.floor(x - halfWidth);
            var yt = Math.floor(y - halfHeight);
            var yb = Math.ceil(y + halfHeight);
            if (anchorX < xl && anchorY < yt || anchorX >= xl && anchorX <= xr && anchorY < yt) {
                return 270
            }
            if (anchorX > xr && anchorY > yb || anchorX >= xl && anchorX <= xr && anchorY > yb) {
                return 90
            } else {
                if (anchorX < xl && anchorY > yb || anchorX < xl && anchorY >= yt && anchorY <= yb) {
                    return 180
                }
            }
            return 0
        }

        function getCloudPoints(_ref2, x, y, anchorX, anchorY, _ref3, bounded) {
            var width = _ref2.width,
                height = _ref2.height;
            var arrowWidth = _ref3.arrowWidth,
                _ref3$cornerRadius = _ref3.cornerRadius,
                cornerRadius = void 0 === _ref3$cornerRadius ? 0 : _ref3$cornerRadius;
            var halfArrowWidth = arrowWidth / 2;
            var halfWidth = width / 2;
            var halfHeight = height / 2;
            var xr = Math.ceil(x + halfWidth);
            var xl = Math.floor(x - halfWidth);
            var yt = Math.floor(y - halfHeight);
            var yb = Math.ceil(y + halfHeight);
            var leftTopCorner = [xl, yt];
            var rightTopCorner = [xr, yt];
            var rightBottomCorner = [xr, yb];
            var leftBottomCorner = [xl, yb];
            var arrowX = anchorX <= xl ? xl : xr <= anchorX ? xr : anchorX;
            var arrowY = anchorY <= yt ? yt : yb <= anchorY ? yb : anchorY;
            var arrowBaseBottom = min(arrowY + halfArrowWidth, yb);
            var arrowBaseTop = max(arrowY - halfArrowWidth, yt);
            var arrowBaseLeft = max(arrowX - halfArrowWidth, xl);
            cornerRadius = Math.min(width / 2, height / 2, cornerRadius);
            var points;
            leftTopCorner[1] += cornerRadius;
            rightTopCorner[0] -= cornerRadius;
            rightBottomCorner[1] -= cornerRadius;
            leftBottomCorner[0] += cornerRadius;
            if (!bounded || xl <= anchorX && anchorX <= xr && yt <= anchorY && anchorY <= yb) {
                points = buildPath(leftTopCorner, getArc(cornerRadius, 1, -1), "L", rightTopCorner, getArc(cornerRadius, 1, 1), "L", rightBottomCorner, getArc(cornerRadius, -1, 1), "L", leftBottomCorner, getArc(cornerRadius, -1, -1))
            } else {
                if (anchorX > xr && anchorY < yt) {
                    var arrowAngle = arrowWidth / cornerRadius || 0;
                    var angle = PI / 4 + arrowAngle / 2;
                    var endAngle = PI / 4 - arrowAngle / 2;
                    var arrowEndPointX = rightTopCorner[0] + cos(endAngle) * cornerRadius;
                    var arrowEndPointY = rightTopCorner[1] + (1 - sin(endAngle)) * cornerRadius;
                    var arrowArc = buildPath("L", rightTopCorner, getArc(cornerRadius, cos(angle), 1 - sin(angle)), "L", [anchorX, anchorY, arrowEndPointX, arrowEndPointY], getAbsoluteArc(cornerRadius, rightTopCorner[0] + cornerRadius, rightTopCorner[1] + cornerRadius));
                    if (Math.abs(angle) > PI / 2) {
                        arrowArc = buildPath("L", [arrowBaseLeft, yt, anchorX, anchorY, xr, arrowBaseBottom])
                    }
                    points = buildPath(leftTopCorner, getArc(cornerRadius, 1, -1), arrowArc, "L", rightBottomCorner, getArc(cornerRadius, -1, 1), "L", leftBottomCorner, getArc(cornerRadius, -1, -1))
                } else {
                    if (anchorX > xr && anchorY >= yt && anchorY <= yb) {
                        var _arrowArc;
                        if (arrowBaseTop >= rightTopCorner[1] + cornerRadius && arrowBaseBottom <= rightBottomCorner[1]) {
                            _arrowArc = buildPath(getArc(cornerRadius, 1, 1), "L", [xr, arrowBaseTop, anchorX, anchorY, xr, arrowBaseBottom], "L", rightBottomCorner, getArc(cornerRadius, -1, 1))
                        } else {
                            if (arrowBaseTop < rightTopCorner[1] + cornerRadius && arrowBaseBottom >= rightTopCorner[1] + cornerRadius && arrowBaseBottom <= rightBottomCorner[1]) {
                                var arrowWidthRest = rightTopCorner[1] + cornerRadius - arrowBaseTop;
                                var _angle = arrowWidthRest / cornerRadius;
                                var arrowBaseTopX = rightTopCorner[0] + cos(_angle) * cornerRadius;
                                var arrowBaseTopY = rightTopCorner[1] + (1 - sin(_angle)) * cornerRadius;
                                _arrowArc = buildPath(getArc(cornerRadius, cos(_angle), 1 - sin(_angle)), "L", [arrowBaseTopX, arrowBaseTopY, anchorX, anchorY, xr, arrowBaseBottom], "L", rightBottomCorner, getArc(cornerRadius, -1, 1))
                            } else {
                                if (arrowBaseTop < rightTopCorner[1] + cornerRadius && arrowBaseBottom < rightTopCorner[1] + cornerRadius) {
                                    var _arrowWidthRest = rightTopCorner[1] + cornerRadius - arrowBaseTop;
                                    var _arrowAngle = _arrowWidthRest / cornerRadius;
                                    var _angle2 = _arrowAngle;
                                    var _arrowBaseTopX = rightTopCorner[0] + cos(_angle2) * cornerRadius;
                                    var _arrowBaseTopY = rightTopCorner[1] + (1 - sin(_angle2)) * cornerRadius;
                                    var bottomAngle = Math.sin((rightTopCorner[1] + cornerRadius - arrowBaseBottom) / cornerRadius);
                                    var arrowBaseBottomX = rightTopCorner[0] + cornerRadius * cos(bottomAngle);
                                    var arrowBaseBottomY = rightTopCorner[1] + cornerRadius * (1 - sin(bottomAngle));
                                    _arrowArc = buildPath(getArc(cornerRadius, cos(_angle2), 1 - sin(_angle2)), "L", [_arrowBaseTopX, _arrowBaseTopY, anchorX, anchorY, arrowBaseBottomX, arrowBaseBottomY], getAbsoluteArc(cornerRadius, rightTopCorner[0] + cornerRadius, rightTopCorner[1] + cornerRadius), "L", rightBottomCorner, getArc(cornerRadius, -1, 1))
                                } else {
                                    if (arrowBaseTop <= rightTopCorner[1] + cornerRadius && arrowBaseBottom >= rightBottomCorner[1]) {
                                        var topAngle = asin((rightTopCorner[1] + cornerRadius - arrowBaseTop) / cornerRadius);
                                        var _arrowBaseTopX2 = rightTopCorner[0] + cornerRadius * cos(topAngle);
                                        var _arrowBaseTopY2 = rightTopCorner[1] + cornerRadius * (1 - sin(topAngle));
                                        var _bottomAngle = asin((arrowBaseBottom - rightBottomCorner[1]) / cornerRadius);
                                        var _arrowBaseBottomX = rightBottomCorner[0] + cornerRadius * (cos(_bottomAngle) - 1);
                                        var _arrowBaseBottomY = rightBottomCorner[1] + cornerRadius * sin(_bottomAngle);
                                        _arrowArc = buildPath(getArc(cornerRadius, cos(topAngle), 1 - sin(topAngle)), "L", [_arrowBaseTopX2, _arrowBaseTopY2, anchorX, anchorY, _arrowBaseBottomX, _arrowBaseBottomY], getAbsoluteArc(cornerRadius, rightBottomCorner[0] - cornerRadius, rightBottomCorner[1] + cornerRadius))
                                    } else {
                                        if (arrowBaseTop > rightTopCorner[1] + cornerRadius && arrowBaseTop <= rightBottomCorner[1] && arrowBaseBottom > rightBottomCorner[1]) {
                                            var _bottomAngle2 = asin((arrowBaseBottom - rightBottomCorner[1]) / cornerRadius);
                                            var _arrowBaseBottomX2 = rightBottomCorner[0] + cornerRadius * (cos(_bottomAngle2) - 1);
                                            var _arrowBaseBottomY2 = rightBottomCorner[1] + cornerRadius * sin(_bottomAngle2);
                                            _arrowArc = buildPath(getArc(cornerRadius, 1, 1), "L", [xr, arrowBaseTop, anchorX, anchorY, _arrowBaseBottomX2, _arrowBaseBottomY2], getAbsoluteArc(cornerRadius, rightBottomCorner[0] - cornerRadius, rightBottomCorner[1] + cornerRadius))
                                        } else {
                                            if (arrowBaseTop > rightTopCorner[1] + cornerRadius && arrowBaseBottom > rightBottomCorner[1]) {
                                                var _bottomAngle3 = asin((arrowBaseBottom - rightBottomCorner[1]) / cornerRadius);
                                                var _arrowBaseBottomX3 = rightBottomCorner[0] + cornerRadius * (cos(_bottomAngle3) - 1);
                                                var _arrowBaseBottomY3 = rightBottomCorner[1] + cornerRadius * sin(_bottomAngle3);
                                                var _topAngle = asin((arrowBaseTop - rightBottomCorner[1]) / cornerRadius);
                                                var _arrowBaseTopX3 = rightBottomCorner[0] + cornerRadius * (cos(_topAngle) - 1);
                                                var _arrowBaseTopY3 = rightBottomCorner[1] + cornerRadius * sin(_topAngle);
                                                _arrowArc = buildPath(getArc(cornerRadius, 1, 1), "L", rightBottomCorner, getArc(cornerRadius, cos(_topAngle) - 1, sin(_topAngle)), "L", [_arrowBaseTopX3, _arrowBaseTopY3, anchorX, anchorY, _arrowBaseBottomX3, _arrowBaseBottomY3], getAbsoluteArc(cornerRadius, rightBottomCorner[0] - cornerRadius, rightBottomCorner[1] + cornerRadius))
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        points = buildPath(leftTopCorner, getArc(cornerRadius, 1, -1), "L", rightTopCorner, _arrowArc, "L", leftBottomCorner, getArc(cornerRadius, -1, -1))
                    }
                }
            }
            return buildPath("M", points, "Z")
        }
        var Plaque = function() {
            function Plaque(options, widget, root, contentTemplate) {
                var bounded = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : true;
                var measureContent = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : function(_, g) {
                    return g.getBBox()
                };
                var moveContentGroup = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : function(_, g, x, y) {
                    return g.move(x, y)
                };
                this.widget = widget;
                this.options = options;
                this.root = root;
                this.contentTemplate = contentTemplate;
                this.bonded = bounded;
                this.measureContent = measureContent;
                this.moveContentGroup = moveContentGroup
            }
            var _proto = Plaque.prototype;
            _proto.draw = function(_ref4) {
                var _this = this;
                var anchorX = _ref4.x,
                    anchorY = _ref4.y,
                    _ref4$canvas = _ref4.canvas,
                    canvas = void 0 === _ref4$canvas ? {} : _ref4$canvas,
                    offsetX = _ref4.offsetX,
                    offsetY = _ref4.offsetY,
                    _ref4$offset = _ref4.offset,
                    offset = void 0 === _ref4$offset ? 0 : _ref4$offset,
                    restProps = _objectWithoutProperties(_ref4, ["x", "y", "canvas", "offsetX", "offsetY", "offset"]);
                var options = this.options;
                var x = options.x,
                    y = options.y;
                var bounds = {
                    xl: canvas.left,
                    xr: canvas.width - canvas.right,
                    width: canvas.width - canvas.right - canvas.left,
                    yt: canvas.top,
                    yb: canvas.height - canvas.bottom,
                    height: canvas.height - canvas.bottom - canvas.top
                };
                if (!((0, _type.isDefined)(anchorX) && (0, _type.isDefined)(anchorY)) && !((0, _type.isDefined)(x) && (0, _type.isDefined)(y))) {
                    return false
                }
                if ((0, _type.isDefined)(anchorX) && (anchorX < bounds.xl || bounds.xr < anchorX || anchorY < bounds.yt || bounds.yb < anchorY)) {
                    return false
                }
                if (!this._root) {
                    this._draw()
                }
                var shadowSettings = (0, _extend.extend)({
                    x: "-50%",
                    y: "-50%",
                    width: "200%",
                    height: "200%"
                }, options.shadow);
                var contentWidth = options.width > 0 ? options.width : null;
                var contentHeight = options.height > 0 ? options.height : null;
                var onRender = function() {
                    var _this$_root;
                    var bBox = _this._contentBBox = _this.measureContent(_this.widget, _this._contentGroup);
                    var size = _this._size = {
                        width: max(contentWidth, bBox.width) + 2 * options.paddingLeftRight,
                        height: max(contentHeight, bBox.height) + 2 * options.paddingTopBottom,
                        offset: offset
                    };
                    var xOff = shadowSettings.offsetX;
                    var yOff = shadowSettings.offsetY;
                    var blur = 2 * shadowSettings.blur + 1;
                    var lm = max(blur - xOff, 0);
                    var rm = max(blur + xOff, 0);
                    var tm = max(blur - yOff, 0);
                    var bm = max(blur + yOff, 0);
                    _this.margins = {
                        lm: lm,
                        rm: rm,
                        tm: tm,
                        bm: bm
                    };
                    if (!(0, _type.isDefined)(x)) {
                        if ((0, _type.isDefined)(offsetX)) {
                            x = anchorX + offsetX
                        } else {
                            if (bounds.width < size.width) {
                                x = round(bounds.xl + bounds.width / 2)
                            } else {
                                x = min(max(anchorX, Math.ceil(bounds.xl + size.width / 2 + lm)), Math.floor(bounds.xr - size.width / 2 - rm))
                            }
                        }
                    } else {
                        x += offsetX || 0;
                        if (!(0, _type.isDefined)(anchorX)) {
                            anchorX = x
                        }
                    }
                    if (!(0, _type.isDefined)(y)) {
                        if ((0, _type.isDefined)(offsetY)) {
                            y = anchorY + offsetY
                        } else {
                            var y_top = anchorY - options.arrowLength - size.height / 2 - offset;
                            var y_bottom = anchorY + options.arrowLength + size.height / 2 + offset;
                            if (bounds.height < size.height + options.arrowLength) {
                                y = round(bounds.yt + size.height / 2)
                            } else {
                                if (y_top - size.height / 2 - tm < bounds.yt) {
                                    if (y_bottom + size.height / 2 + bm < bounds.yb) {
                                        y = y_bottom;
                                        anchorY += offset
                                    } else {
                                        y = round(bounds.yt + size.height / 2)
                                    }
                                } else {
                                    y = y_top;
                                    anchorY -= offset
                                }
                            }
                        }
                    } else {
                        y += offsetY || 0;
                        if (!(0, _type.isDefined)(anchorY)) {
                            anchorY = y + size.height / 2
                        }
                    }
                    _this.anchorX = anchorX;
                    _this.anchorY = anchorY;
                    _this.move(x, y);
                    null === (_this$_root = _this._root) || void 0 === _this$_root ? void 0 : _this$_root.append(_this.root)
                };
                if (this.contentTemplate.render) {
                    this.contentTemplate.render({
                        model: options,
                        container: this._contentGroup.element,
                        onRendered: onRender
                    })
                } else {
                    return this.contentTemplate(_objectSpread({
                        group: this._contentGroup,
                        onRender: onRender
                    }, restProps))
                }
                return true
            };
            _proto._draw = function() {
                var renderer = this.widget._renderer;
                var options = this.options;
                var shadowSettings = (0, _extend.extend)({
                    x: "-50%",
                    y: "-50%",
                    width: "200%",
                    height: "200%"
                }, options.shadow);
                var shadow = this._shadow = renderer.shadowFilter().attr(shadowSettings);
                var cloudSettings = {
                    opacity: options.opacity,
                    "stroke-width": 0,
                    fill: options.color
                };
                var borderOptions = options.border || {};
                if (borderOptions.visible) {
                    (0, _extend.extend)(cloudSettings, {
                        "stroke-width": borderOptions.width,
                        stroke: borderOptions.color,
                        "stroke-opacity": borderOptions.opacity,
                        dashStyle: borderOptions.dashStyle
                    })
                }
                var group = this._root = renderer.g().append(this.root);
                if (options.type) {
                    group.attr({
                        "class": "dxc-".concat(options.type, "-annotation")
                    })
                }
                var cloudGroup = renderer.g().attr({
                    filter: shadow.id
                }).append(group);
                this._cloud = renderer.path([], "area").attr(cloudSettings).sharp().append(cloudGroup);
                this._contentGroup = renderer.g().append(group)
            };
            _proto.getBBox = function() {
                var size = this._size || {};
                var margins = this.margins || {};
                var rotationAngle = getCloudAngle(size, this.x, this.y, this.anchorX, this.anchorY);
                return {
                    x: Math.floor(this.x - size.width / 2 - margins.lm),
                    y: Math.floor(this.y - size.height / 2 - margins.tm - (270 === rotationAngle ? this.options.arrowLength : 0)),
                    width: size.width + margins.lm + margins.rm,
                    height: size.height + margins.tm + margins.bm + (90 === rotationAngle || 270 === rotationAngle ? this.options.arrowLength : 0)
                }
            };
            _proto.clear = function() {
                if (this._root) {
                    this._root.remove();
                    this._shadow.remove();
                    this._root = null
                }
                return this
            };
            _proto.customizeCloud = function(attr) {
                if (this._cloud) {
                    this._cloud.attr(attr)
                }
            };
            _proto.moveRoot = function(x, y) {
                if (this._root) {
                    this._root.move(x, y)
                }
            };
            _proto.move = function(x, y) {
                x = round(x);
                y = round(y);
                this.x = x;
                this.y = y;
                var rotationAngle = getCloudAngle(this._size, x, y, this.anchorX, this.anchorY);
                var radRotationAngle = rotationAngle * PI / 180;
                this._cloud.attr({
                    d: getCloudPoints(rotateSize(this._size, rotationAngle), x, y, rotateX(this.anchorX, this.anchorY, radRotationAngle, x, y), rotateY(this.anchorX, this.anchorY, radRotationAngle, x, y), this.options, this.bonded)
                }).rotate(rotationAngle, x, y);
                this.moveContentGroup(this.widget, this._contentGroup, x - this._contentBBox.x - this._contentBBox.width / 2, y - this._contentBBox.y - this._contentBBox.height / 2)
            };
            _proto.hitTest = function(x, y) {
                var _ref5 = this._size || {},
                    width = _ref5.width,
                    height = _ref5.height;
                return Math.abs(x - this.x) <= width / 2 && Math.abs(y - this.y) <= height / 2
            };
            return Plaque
        }();
        exports.Plaque = Plaque
    },
    /*!*************************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/chart_components/advanced_chart.js ***!
      \*************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.AdvancedChart = void 0;
        var _extend2 = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _range = __webpack_require__( /*! ../translators/range */ 124);
        var _base_axis = __webpack_require__( /*! ../axes/base_axis */ 316);
        var _series_family = __webpack_require__( /*! ../core/series_family */ 473);
        var _base_chart = __webpack_require__( /*! ./base_chart */ 309);
        var _crosshair = __webpack_require__( /*! ./crosshair */ 474);
        var _range_data_calculator = _interopRequireDefault(__webpack_require__( /*! ../series/helpers/range_data_calculator */ 226));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }
        var _isArray = Array.isArray;
        var DEFAULT_AXIS_NAME = "defaultAxisName";
        var FONT = "font";
        var COMMON_AXIS_SETTINGS = "commonAxisSettings";
        var DEFAULT_PANE_NAME = "default";
        var VISUAL_RANGE = "VISUAL_RANGE";

        function prepareAxis(axisOptions) {
            return _isArray(axisOptions) ? 0 === axisOptions.length ? [{}] : axisOptions : [axisOptions]
        }

        function processBubbleMargin(opt, bubbleSize) {
            if (opt.processBubbleSize) {
                opt.size = bubbleSize
            }
            return opt
        }

        function estimateBubbleSize(size, panesCount, maxSize, rotated) {
            var width = rotated ? size.width / panesCount : size.width;
            var height = rotated ? size.height : size.height / panesCount;
            return Math.min(width, height) * maxSize
        }

        function setAxisVisualRangeByOption(arg, axis, isDirectOption, index) {
            var options;
            var visualRange;
            if (isDirectOption) {
                visualRange = arg.value;
                options = {
                    skipEventRising: true
                };
                var wrappedVisualRange = wrapVisualRange(arg.fullName, visualRange);
                if (wrappedVisualRange) {
                    options = {
                        allowPartialUpdate: true
                    };
                    visualRange = wrappedVisualRange
                }
            } else {
                visualRange = ((0, _type.isDefined)(index) ? arg.value[index] : arg.value).visualRange
            }
            axis.visualRange(visualRange, options)
        }

        function getAxisTypes(groupsData, axis, isArgumentAxes) {
            if (isArgumentAxes) {
                return {
                    argumentAxisType: groupsData.argumentAxisType,
                    argumentType: groupsData.argumentType
                }
            }
            var _groupsData$groups$fi = groupsData.groups.filter(function(g) {
                    return g.valueAxis === axis
                })[0],
                valueAxisType = _groupsData$groups$fi.valueAxisType,
                valueType = _groupsData$groups$fi.valueType;
            return {
                valueAxisType: valueAxisType,
                valueType: valueType
            }
        }

        function wrapVisualRange(fullName, value) {
            var pathElements = fullName.split(".");
            var destElem = pathElements[pathElements.length - 1];
            if ("endValue" === destElem || "startValue" === destElem) {
                return _defineProperty({}, destElem, value)
            }
        }
        var AdvancedChart = _base_chart.BaseChart.inherit({
            _fontFields: [COMMON_AXIS_SETTINGS + ".label." + FONT, COMMON_AXIS_SETTINGS + ".title." + FONT],
            _partialOptionChangesMap: {
                visualRange: VISUAL_RANGE,
                _customVisualRange: VISUAL_RANGE,
                strips: "REFRESH_AXES",
                constantLines: "REFRESH_AXES"
            },
            _partialOptionChangesPath: {
                argumentAxis: ["strips", "constantLines", "visualRange", "_customVisualRange"],
                valueAxis: ["strips", "constantLines", "visualRange", "_customVisualRange"]
            },
            _initCore: function() {
                this._panesClipRects = {};
                this.callBase()
            },
            _disposeCore: function() {
                var disposeObjectsInArray = this._disposeObjectsInArray;
                var panesClipRects = this._panesClipRects;
                this.callBase();
                disposeObjectsInArray.call(panesClipRects, "fixed");
                disposeObjectsInArray.call(panesClipRects, "base");
                disposeObjectsInArray.call(panesClipRects, "wide");
                this._panesClipRects = null
            },
            _dispose: function() {
                var that = this;
                var disposeObjectsInArray = this._disposeObjectsInArray;
                that.callBase();
                that.panes = null;
                if (that._legend) {
                    that._legend.dispose();
                    that._legend = null
                }
                disposeObjectsInArray.call(that, "panesBackground");
                disposeObjectsInArray.call(that, "seriesFamilies");
                that._disposeAxes()
            },
            _createPanes: function() {
                this._cleanPanesClipRects("fixed");
                this._cleanPanesClipRects("base");
                this._cleanPanesClipRects("wide")
            },
            _cleanPanesClipRects: function(clipArrayName) {
                var clipArray = this._panesClipRects[clipArrayName];
                (clipArray || []).forEach(function(clipRect) {
                    return clipRect && clipRect.dispose()
                });
                this._panesClipRects[clipArrayName] = []
            },
            _getElementsClipRectID: function(paneName) {
                var clipShape = this._panesClipRects.fixed[this._getPaneIndex(paneName)];
                return clipShape && clipShape.id
            },
            _getPaneIndex: function(paneName) {
                var paneIndex;
                var name = paneName || DEFAULT_PANE_NAME;
                (0, _iterator.each)(this.panes, function(index, pane) {
                    if (pane.name === name) {
                        paneIndex = index;
                        return false
                    }
                });
                return paneIndex
            },
            _updateSize: function() {
                this.callBase();
                (0, _utils.setCanvasValues)(this._canvas)
            },
            _reinitAxes: function() {
                this.panes = this._createPanes();
                this._populateAxes();
                this._axesReinitialized = true
            },
            _getCrosshairMargins: function() {
                var crosshairOptions = this._getCrosshairOptions() || {};
                var crosshairEnabled = crosshairOptions.enabled;
                var margins = (0, _crosshair.getMargins)();
                return {
                    x: crosshairEnabled && crosshairOptions.horizontalLine.visible ? margins.x : 0,
                    y: crosshairEnabled && crosshairOptions.verticalLine.visible ? margins.y : 0
                }
            },
            _populateAxes: function() {
                var that = this;
                var panes = that.panes;
                var rotated = that._isRotated();
                var argumentAxesOptions = prepareAxis(that.option("argumentAxis") || {})[0];
                var valueAxisOption = that.option("valueAxis");
                var valueAxesOptions = prepareAxis(valueAxisOption || {});
                var argumentAxesPopulatedOptions = [];
                var valueAxesPopulatedOptions = [];
                var axisNames = [];
                var valueAxesCounter = 0;
                var paneWithNonVirtualAxis;
                var crosshairMargins = that._getCrosshairMargins();

                function getNextAxisName() {
                    return DEFAULT_AXIS_NAME + valueAxesCounter++
                }
                if (rotated) {
                    paneWithNonVirtualAxis = "right" === argumentAxesOptions.position ? panes[panes.length - 1].name : panes[0].name
                } else {
                    paneWithNonVirtualAxis = "top" === argumentAxesOptions.position ? panes[0].name : panes[panes.length - 1].name
                }
                argumentAxesPopulatedOptions = (0, _utils.map)(panes, function(pane) {
                    var virtual = pane.name !== paneWithNonVirtualAxis;
                    return that._populateAxesOptions("argumentAxis", argumentAxesOptions, {
                        pane: pane.name,
                        name: null,
                        optionPath: "argumentAxis",
                        crosshairMargin: rotated ? crosshairMargins.x : crosshairMargins.y
                    }, rotated, virtual)
                });
                (0, _iterator.each)(valueAxesOptions, function(priority, axisOptions) {
                    var _axisOptions$panes;
                    var axisPanes = [];
                    var name = axisOptions.name;
                    if (name && (0, _array.inArray)(name, axisNames) !== -1) {
                        that._incidentOccurred("E2102");
                        return
                    }
                    name && axisNames.push(name);
                    if (axisOptions.pane) {
                        axisPanes.push(axisOptions.pane)
                    }
                    if (null !== (_axisOptions$panes = axisOptions.panes) && void 0 !== _axisOptions$panes && _axisOptions$panes.length) {
                        axisPanes = axisPanes.concat(axisOptions.panes.slice(0))
                    }
                    axisPanes = (0, _utils.unique)(axisPanes);
                    if (!axisPanes.length) {
                        axisPanes.push(void 0)
                    }(0, _iterator.each)(axisPanes, function(_, pane) {
                        var optionPath = _isArray(valueAxisOption) ? "valueAxis[".concat(priority, "]") : "valueAxis";
                        valueAxesPopulatedOptions.push(that._populateAxesOptions("valueAxis", axisOptions, {
                            name: name || getNextAxisName(),
                            pane: pane,
                            priority: priority,
                            optionPath: optionPath,
                            crosshairMargin: rotated ? crosshairMargins.y : crosshairMargins.x
                        }, rotated))
                    })
                });
                that._redesignAxes(argumentAxesPopulatedOptions, true, paneWithNonVirtualAxis);
                that._redesignAxes(valueAxesPopulatedOptions, false)
            },
            _redesignAxes: function(options, isArgumentAxes, paneWithNonVirtualAxis) {
                var that = this;
                var axesBasis = [];
                var axes = isArgumentAxes ? that._argumentAxes : that._valueAxes;
                (0, _iterator.each)(options, function(_, opt) {
                    var curAxes = axes && axes.filter(function(a) {
                        return a.name === opt.name && (!(0, _type.isDefined)(opt.pane) && that.panes.some(function(p) {
                            return p.name === a.pane
                        }) || a.pane === opt.pane)
                    });
                    if (curAxes && curAxes.length > 0) {
                        (0, _iterator.each)(curAxes, function(_, axis) {
                            var axisTypes = getAxisTypes(that._groupsData, axis, isArgumentAxes);
                            axis.updateOptions(opt);
                            if (isArgumentAxes) {
                                axis.setTypes(axisTypes.argumentAxisType, axisTypes.argumentType, "argumentType")
                            } else {
                                axis.setTypes(axisTypes.valueAxisType, axisTypes.valueType, "valueType")
                            }
                            axis.validate();
                            axesBasis.push({
                                axis: axis
                            })
                        })
                    } else {
                        axesBasis.push({
                            options: opt
                        })
                    }
                });
                if (axes) {
                    (0, _iterator.reverseEach)(axes, function(index, axis) {
                        if (!axesBasis.some(function(basis) {
                                return basis.axis && basis.axis === axis
                            })) {
                            that._disposeAxis(index, isArgumentAxes)
                        }
                    })
                } else {
                    if (isArgumentAxes) {
                        axes = that._argumentAxes = []
                    } else {
                        axes = that._valueAxes = []
                    }
                }(0, _iterator.each)(axesBasis, function(_, basis) {
                    var axis = basis.axis;
                    if (basis.axis && isArgumentAxes) {
                        basis.axis.isVirtual = basis.axis.pane !== paneWithNonVirtualAxis
                    } else {
                        if (basis.options) {
                            axis = that._createAxis(isArgumentAxes, basis.options, isArgumentAxes ? basis.options.pane !== paneWithNonVirtualAxis : void 0);
                            axes.push(axis)
                        }
                    }
                    axis.applyVisualRangeSetter(that._getVisualRangeSetter())
                })
            },
            _disposeAxis: function(index, isArgumentAxis) {
                var axes = isArgumentAxis ? this._argumentAxes : this._valueAxes;
                var axis = axes[index];
                if (!axis) {
                    return
                }
                axis.dispose();
                axes.splice(index, 1)
            },
            _disposeAxes: function() {
                var that = this;
                var disposeObjectsInArray = that._disposeObjectsInArray;
                disposeObjectsInArray.call(that, "_argumentAxes");
                disposeObjectsInArray.call(that, "_valueAxes")
            },
            _appendAdditionalSeriesGroups: function() {
                this._crosshairCursorGroup.linkAppend();
                this._scrollBar && this._scrollBarGroup.linkAppend()
            },
            _getLegendTargets: function() {
                var _this = this;
                return (this.series || []).map(function(s) {
                    var item = _this._getLegendOptions(s);
                    item.legendData.series = s;
                    if (!s.getOptions().showInLegend) {
                        item.legendData.visible = false
                    }
                    return item
                })
            },
            _legendItemTextField: "name",
            _seriesPopulatedHandlerCore: function() {
                this._processSeriesFamilies();
                this._processValueAxisFormat()
            },
            _renderTrackers: function() {
                var that = this;
                var i;
                for (i = 0; i < that.series.length; ++i) {
                    that.series[i].drawTrackers()
                }
            },
            _specialProcessSeries: function() {
                this._processSeriesFamilies()
            },
            _processSeriesFamilies: function() {
                var _that$seriesFamilies;
                var that = this;
                var types = [];
                var families = [];
                var paneSeries;
                var themeManager = that._themeManager;
                var negativesAsZeroes = themeManager.getOptions("negativesAsZeroes");
                var negativesAsZeros = themeManager.getOptions("negativesAsZeros");
                var familyOptions = {
                    minBubbleSize: themeManager.getOptions("minBubbleSize"),
                    maxBubbleSize: themeManager.getOptions("maxBubbleSize"),
                    barGroupPadding: themeManager.getOptions("barGroupPadding"),
                    barGroupWidth: themeManager.getOptions("barGroupWidth"),
                    negativesAsZeroes: (0, _type.isDefined)(negativesAsZeroes) ? negativesAsZeroes : negativesAsZeros
                };
                if (null !== (_that$seriesFamilies = that.seriesFamilies) && void 0 !== _that$seriesFamilies && _that$seriesFamilies.length) {
                    (0, _iterator.each)(that.seriesFamilies, function(_, family) {
                        family.updateOptions(familyOptions);
                        family.adjustSeriesValues()
                    });
                    return
                }(0, _iterator.each)(that.series, function(_, item) {
                    if ((0, _array.inArray)(item.type, types) === -1) {
                        types.push(item.type)
                    }
                });
                (0, _iterator.each)(that._getLayoutTargets(), function(_, pane) {
                    paneSeries = that._getSeriesForPane(pane.name);
                    (0, _iterator.each)(types, function(_, type) {
                        var family = new _series_family.SeriesFamily({
                            type: type,
                            pane: pane.name,
                            minBubbleSize: familyOptions.minBubbleSize,
                            maxBubbleSize: familyOptions.maxBubbleSize,
                            barGroupPadding: familyOptions.barGroupPadding,
                            barGroupWidth: familyOptions.barGroupWidth,
                            negativesAsZeroes: familyOptions.negativesAsZeroes,
                            rotated: that._isRotated()
                        });
                        family.add(paneSeries);
                        family.adjustSeriesValues();
                        families.push(family)
                    })
                });
                that.seriesFamilies = families
            },
            _updateSeriesDimensions: function() {
                var that = this;
                var i;
                var seriesFamilies = that.seriesFamilies || [];
                for (i = 0; i < seriesFamilies.length; i++) {
                    var family = seriesFamilies[i];
                    family.updateSeriesValues();
                    family.adjustSeriesDimensions()
                }
            },
            _getLegendCallBack: function(series) {
                return this._legend && this._legend.getActionCallback(series)
            },
            _appendAxesGroups: function() {
                var that = this;
                that._stripsGroup.linkAppend();
                that._gridGroup.linkAppend();
                that._axesGroup.linkAppend();
                that._constantLinesGroup.linkAppend();
                that._labelAxesGroup.linkAppend();
                that._scaleBreaksGroup.linkAppend()
            },
            _populateMarginOptions: function() {
                var that = this;
                var bubbleSize = estimateBubbleSize(that.getSize(), that.panes.length, that._themeManager.getOptions("maxBubbleSize"), that._isRotated());
                var argumentMarginOptions = {};
                that._valueAxes.forEach(function(valueAxis) {
                    var groupSeries = that.series.filter(function(series) {
                        return series.getValueAxis() === valueAxis
                    });
                    var marginOptions = {};
                    groupSeries.forEach(function(series) {
                        if (series.isVisible()) {
                            var seriesMarginOptions = processBubbleMargin(series.getMarginOptions(), bubbleSize);
                            marginOptions = (0, _utils.mergeMarginOptions)(marginOptions, seriesMarginOptions);
                            argumentMarginOptions = (0, _utils.mergeMarginOptions)(argumentMarginOptions, seriesMarginOptions)
                        }
                    });
                    valueAxis.setMarginOptions(marginOptions)
                });
                that._argumentAxes.forEach(function(a) {
                    return a.setMarginOptions(argumentMarginOptions)
                })
            },
            _populateBusinessRange: function(updatedAxis, keepRange) {
                var that = this;
                var rotated = that._isRotated();
                var series = that._getVisibleSeries();
                var argRanges = {};
                var commonArgRange = new _range.Range({
                    rotated: !!rotated
                });
                var getPaneName = function(axis) {
                    return axis.pane || DEFAULT_PANE_NAME
                };
                that.panes.forEach(function(p) {
                    return argRanges[p.name] = new _range.Range({
                        rotated: !!rotated
                    })
                });
                that._valueAxes.forEach(function(valueAxis) {
                    var groupRange = new _range.Range({
                        rotated: !!rotated,
                        pane: valueAxis.pane,
                        axis: valueAxis.name
                    });
                    var groupSeries = series.filter(function(series) {
                        return series.getValueAxis() === valueAxis
                    });
                    groupSeries.forEach(function(series) {
                        var seriesRange = series.getRangeData();
                        groupRange.addRange(seriesRange.val);
                        argRanges[getPaneName(valueAxis)].addRange(seriesRange.arg)
                    });
                    if (!updatedAxis || updatedAxis && groupSeries.length && valueAxis === updatedAxis) {
                        valueAxis.setGroupSeries(groupSeries);
                        valueAxis.setBusinessRange(groupRange, that._axesReinitialized || keepRange, that._argumentAxes[0]._lastVisualRangeUpdateMode)
                    }
                });
                if (!updatedAxis || updatedAxis && series.length) {
                    Object.keys(argRanges).forEach(function(p) {
                        return commonArgRange.addRange(argRanges[p])
                    });
                    var commonInterval = commonArgRange.interval;
                    that._argumentAxes.forEach(function(a) {
                        var _argRanges$getPaneNam;
                        var currentInterval = null !== (_argRanges$getPaneNam = argRanges[getPaneName(a)].interval) && void 0 !== _argRanges$getPaneNam ? _argRanges$getPaneNam : commonInterval;
                        a.setBusinessRange(new _range.Range(_objectSpread(_objectSpread({}, commonArgRange), {}, {
                            interval: currentInterval
                        })), that._axesReinitialized, void 0, that._groupsData.categories)
                    })
                }
                that._populateMarginOptions()
            },
            getArgumentAxis: function() {
                return (this._argumentAxes || []).filter(function(a) {
                    return !a.isVirtual
                })[0]
            },
            getValueAxis: function(name) {
                var _this2 = this;
                return (this._valueAxes || []).filter((0, _type.isDefined)(name) ? function(a) {
                    return a.name === name
                } : function(a) {
                    return a.pane === _this2.defaultPane
                })[0]
            },
            _getGroupsData: function() {
                var that = this;
                var groups = [];
                that._valueAxes.forEach(function(axis) {
                    groups.push({
                        series: that.series.filter(function(series) {
                            return series.getValueAxis() === axis
                        }),
                        valueAxis: axis,
                        valueOptions: axis.getOptions()
                    })
                });
                return {
                    groups: groups,
                    argumentAxes: that._argumentAxes,
                    argumentOptions: that._argumentAxes[0].getOptions()
                }
            },
            _groupSeries: function() {
                var that = this;
                that._correctValueAxes(false);
                that._groupsData = that._getGroupsData()
            },
            _processValueAxisFormat: function() {
                var axesWithFullStackedFormat = [];
                this.series.forEach(function(series) {
                    var axis = series.getValueAxis();
                    if (series.isFullStackedSeries()) {
                        axis.setPercentLabelFormat();
                        axesWithFullStackedFormat.push(axis)
                    }
                });
                this._valueAxes.forEach(function(axis) {
                    if (axesWithFullStackedFormat.indexOf(axis) === -1) {
                        axis.resetAutoLabelFormat()
                    }
                })
            },
            _populateAxesOptions: function(typeSelector, userOptions, axisOptions, rotated, virtual) {
                var that = this;
                var preparedUserOptions = that._prepareStripsAndConstantLines(typeSelector, userOptions, rotated);
                var options = (0, _extend2.extend)(true, {}, preparedUserOptions, axisOptions, that._prepareAxisOptions(typeSelector, preparedUserOptions, rotated));
                if (virtual) {
                    options.visible = options.tick.visible = options.minorTick.visible = options.label.visible = false;
                    options.title = {}
                }
                return options
            },
            _getValFilter: function(series) {
                return _range_data_calculator.default.getViewPortFilter(series.getValueAxis().visualRange() || {})
            },
            _createAxis: function(isArgumentAxes, options, virtual) {
                var that = this;
                var typeSelector = isArgumentAxes ? "argumentAxis" : "valueAxis";
                var renderingSettings = (0, _extend2.extend)({
                    renderer: that._renderer,
                    incidentOccurred: that._incidentOccurred,
                    eventTrigger: that._eventTrigger,
                    axisClass: isArgumentAxes ? "arg" : "val",
                    widgetClass: "dxc",
                    stripsGroup: that._stripsGroup,
                    labelAxesGroup: that._labelAxesGroup,
                    constantLinesGroup: that._constantLinesGroup,
                    scaleBreaksGroup: that._scaleBreaksGroup,
                    axesContainerGroup: that._axesGroup,
                    gridGroup: that._gridGroup,
                    isArgumentAxis: isArgumentAxes,
                    getTemplate: function() {
                        return that._getTemplate(options.label.template)
                    }
                }, that._getAxisRenderingOptions(typeSelector));
                var axis = new _base_axis.Axis(renderingSettings);
                axis.updateOptions(options);
                axis.isVirtual = virtual;
                return axis
            },
            _applyVisualRangeByVirtualAxes: function(axis, range) {
                return false
            },
            _applyCustomVisualRangeOption: function(axis, range) {
                var that = this;
                if (axis.getOptions().optionPath) {
                    that._parseVisualRangeOption("".concat(axis.getOptions().optionPath, ".visualRange"), range)
                }
            },
            _getVisualRangeSetter: function() {
                var chart = this;
                return function(axis, _ref2) {
                    var skipEventRising = _ref2.skipEventRising,
                        range = _ref2.range;
                    chart._applyCustomVisualRangeOption(axis, range);
                    axis.setCustomVisualRange(range);
                    axis.skipEventRising = skipEventRising;
                    if (!chart._applyVisualRangeByVirtualAxes(axis, range)) {
                        if (chart._applyingChanges) {
                            chart._change_VISUAL_RANGE()
                        } else {
                            chart._requestChange([VISUAL_RANGE])
                        }
                    }
                }
            },
            _getTrackerSettings: function() {
                return (0, _extend2.extend)(this.callBase(), {
                    argumentAxis: this.getArgumentAxis()
                })
            },
            _prepareStripsAndConstantLines: function(typeSelector, userOptions, rotated) {
                userOptions = this._themeManager.getOptions(typeSelector, userOptions, rotated);
                if (userOptions.strips) {
                    (0, _iterator.each)(userOptions.strips, function(i) {
                        userOptions.strips[i] = (0, _extend2.extend)(true, {}, userOptions.stripStyle, userOptions.strips[i])
                    })
                }
                if (userOptions.constantLines) {
                    (0, _iterator.each)(userOptions.constantLines, function(i, line) {
                        userOptions.constantLines[i] = (0, _extend2.extend)(true, {}, userOptions.constantLineStyle, line)
                    })
                }
                return userOptions
            },
            refresh: function() {
                this._disposeAxes();
                this.callBase()
            },
            _layoutAxes: function(drawAxes) {
                var that = this;
                drawAxes();
                var needSpace = that.checkForMoreSpaceForPanesCanvas();
                if (needSpace) {
                    var rect = this._rect.slice();
                    var size = this._layout.backward(rect, rect, [needSpace.width, needSpace.height]);
                    needSpace.width = Math.max(0, size[0]);
                    needSpace.height = Math.max(0, size[1]);
                    this._canvas = this._createCanvasFromRect(rect);
                    drawAxes(needSpace)
                }
            },
            checkForMoreSpaceForPanesCanvas: function() {
                return this.layoutManager.needMoreSpaceForPanesCanvas(this._getLayoutTargets(), this._isRotated())
            },
            _parseVisualRangeOption: function(fullName, value) {
                var that = this;
                var name = fullName.split(/[.[]/)[0];
                var index = fullName.match(/\d+/g);
                index = (0, _type.isDefined)(index) ? parseInt(index[0]) : index;
                if (fullName.indexOf("visualRange") > 0) {
                    if ("object" !== (0, _type.type)(value)) {
                        value = wrapVisualRange(fullName, value) || value
                    }
                    that._setCustomVisualRange(name, index, value)
                } else {
                    if (("object" === (0, _type.type)(value) || _isArray(value)) && name.indexOf("Axis") > 0 && JSON.stringify(value).indexOf("visualRange") > 0) {
                        if ((0, _type.isDefined)(value.visualRange)) {
                            that._setCustomVisualRange(name, index, value.visualRange)
                        } else {
                            if (_isArray(value)) {
                                value.forEach(function(a, i) {
                                    return (0, _type.isDefined)(a.visualRange) && that._setCustomVisualRange(name, i, a.visualRange)
                                })
                            }
                        }
                    }
                }
            },
            _setCustomVisualRange: function(axesName, index, value) {
                var that = this;
                var options = that._options.silent(axesName);
                if (!options) {
                    return
                }
                if (!(0, _type.isDefined)(index)) {
                    options._customVisualRange = value
                } else {
                    options[index]._customVisualRange = value
                }
                that._axesReinitialized = true
            },
            _raiseZoomEndHandlers: function() {
                this._valueAxes.forEach(function(axis) {
                    return axis.handleZoomEnd()
                })
            },
            _setOptionsByReference: function() {
                this.callBase();
                (0, _extend2.extend)(this._optionsByReference, {
                    "valueAxis.visualRange": true
                })
            },
            _notifyOptionChanged: function(option, value, previousValue) {
                this.callBase.apply(this, arguments);
                if (!this._optionChangedLocker) {
                    this._parseVisualRangeOption(option, value)
                }
            },
            _notifyVisualRange: function() {
                var that = this;
                that._valueAxes.forEach(function(axis) {
                    var axisPath = axis.getOptions().optionPath;
                    if (axisPath) {
                        var path = "".concat(axisPath, ".visualRange");
                        var visualRange = (0, _utils.convertVisualRangeObject)(axis.visualRange(), !_isArray(that.option(path)));
                        if (!axis.skipEventRising || !(0, _utils.rangesAreEqual)(visualRange, that.option(path))) {
                            if (!that.option(axisPath) && "valueAxis" !== axisPath) {
                                that.option(axisPath, {
                                    name: axis.name,
                                    visualRange: visualRange
                                })
                            } else {
                                that.option(path, visualRange)
                            }
                        } else {
                            axis.skipEventRising = null
                        }
                    }
                })
            },
            _notify: function() {
                this.callBase();
                this._axesReinitialized = false;
                if (true !== this.option("disableTwoWayBinding")) {
                    this._notifyVisualRange()
                }
            },
            _getAxesForScaling: function() {
                return this._valueAxes
            },
            _getAxesByOptionPath: function(arg, isDirectOption, optionName) {
                var that = this;
                var sourceAxes = that._getAxesForScaling();
                var axes = [];
                if (isDirectOption) {
                    var axisPath;
                    if (arg.fullName) {
                        axisPath = arg.fullName.slice(0, arg.fullName.indexOf("."))
                    }
                    axes = sourceAxes.filter(function(a) {
                        return a.getOptions().optionPath === axisPath
                    })
                } else {
                    if ("object" === (0, _type.type)(arg.value)) {
                        axes = sourceAxes.filter(function(a) {
                            return a.getOptions().optionPath === arg.name
                        })
                    } else {
                        if (_isArray(arg.value)) {
                            arg.value.forEach(function(v, index) {
                                var axis = sourceAxes.filter(function(a) {
                                    return a.getOptions().optionPath === "".concat(arg.name, "[").concat(index, "]")
                                })[0];
                                (0, _type.isDefined)(v[optionName]) && (0, _type.isDefined)(axis) && (axes[index] = axis)
                            })
                        }
                    }
                }
                return axes
            },
            _optionChanged: function(arg) {
                var that = this;
                if (!that._optionChangedLocker) {
                    var optionName = "visualRange";
                    var axes;
                    var isDirectOption = arg.fullName.indexOf(optionName) > 0 ? true : that.getPartialChangeOptionsName(arg).indexOf(optionName) > -1 ? false : void 0;
                    if ((0, _type.isDefined)(isDirectOption)) {
                        axes = that._getAxesByOptionPath(arg, isDirectOption, optionName);
                        if (axes) {
                            if (axes.length > 1 || _isArray(arg.value)) {
                                axes.forEach(function(a, index) {
                                    return setAxisVisualRangeByOption(arg, a, isDirectOption, index)
                                })
                            } else {
                                if (1 === axes.length) {
                                    setAxisVisualRangeByOption(arg, axes[0], isDirectOption)
                                }
                            }
                        }
                    }
                }
                that.callBase(arg)
            },
            _change_VISUAL_RANGE: function() {
                var that = this;
                that._recreateSizeDependentObjects(false);
                if (!that._changes.has("FULL_RENDER")) {
                    var resizePanesOnZoom = that.option("resizePanesOnZoom");
                    that._doRender({
                        force: true,
                        drawTitle: false,
                        drawLegend: false,
                        adjustAxes: null !== resizePanesOnZoom && void 0 !== resizePanesOnZoom ? resizePanesOnZoom : that.option("adjustAxesOnZoom") || false,
                        animate: false
                    });
                    that._raiseZoomEndHandlers()
                }
            },
            resetVisualRange: function() {
                var that = this;
                that._valueAxes.forEach(function(axis) {
                    axis.resetVisualRange(false);
                    that._applyCustomVisualRangeOption(axis)
                });
                that._requestChange([VISUAL_RANGE])
            },
            _legendDataField: "series",
            _adjustSeriesLabels: _common.noop,
            _correctValueAxes: _common.noop
        });
        exports.AdvancedChart = AdvancedChart
    },
    /*!**************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/axes/smart_formatter.js ***!
      \**************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.smartFormatter = smartFormatter;
        exports.formatRange = formatRange;
        var _format_helper = _interopRequireDefault(__webpack_require__( /*! ../../format_helper */ 71));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));
        var _math = __webpack_require__( /*! ../../core/utils/math */ 29);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _format = _format_helper.default.format;
        var abs = Math.abs,
            floor = Math.floor;
        var EXPONENTIAL = "exponential";
        var formats = ["fixedPoint", "thousands", "millions", "billions", "trillions", EXPONENTIAL];
        var dateUnitIntervals = ["millisecond", "second", "minute", "hour", "day", "month", "year"];

        function getDatesDifferences(prevDate, curDate, nextDate, tickFormat) {
            var prevDifferences;
            var nextDifferences;
            var dateUnitInterval;
            var dateUnitsLength = dateUnitIntervals.length;
            var i;
            var j;
            if ("week" === tickFormat) {
                tickFormat = "day"
            } else {
                if ("quarter" === tickFormat) {
                    tickFormat = "month"
                } else {
                    if ("shorttime" === tickFormat) {
                        tickFormat = "hour"
                    } else {
                        if ("longtime" === tickFormat) {
                            tickFormat = "second"
                        }
                    }
                }
            }
            var tickFormatIndex = dateUnitIntervals.indexOf(tickFormat);
            if (nextDate) {
                nextDifferences = _date.default.getDatesDifferences(curDate, nextDate);
                prevDifferences = _date.default.getDatesDifferences(curDate, prevDate);
                if (nextDifferences[tickFormat]) {
                    for (i = dateUnitsLength - 1; i >= tickFormatIndex; i--) {
                        dateUnitInterval = dateUnitIntervals[i];
                        if (i === tickFormatIndex) {
                            setDateUnitInterval(nextDifferences, tickFormatIndex + (nextDifferences.millisecond ? 2 : 1))
                        } else {
                            if (nextDifferences[dateUnitInterval]) {
                                resetDateUnitInterval(nextDifferences, i);
                                break
                            }
                        }
                    }
                }
            } else {
                prevDifferences = _date.default.getDatesDifferences(prevDate, curDate);
                for (i = dateUnitsLength - 1; i >= tickFormatIndex; i--) {
                    dateUnitInterval = dateUnitIntervals[i];
                    if (prevDifferences[dateUnitInterval]) {
                        if (i - tickFormatIndex > 1) {
                            for (j = tickFormatIndex + 1; j >= 0; j--) {
                                resetDateUnitInterval(prevDifferences, j)
                            }
                            break
                        } else {
                            if (isDateTimeStart(curDate, dateUnitInterval)) {
                                for (j = i - 1; j > 0; j--) {
                                    resetDateUnitInterval(prevDifferences, j)
                                }
                                break
                            }
                        }
                    }
                }
            }
            return nextDate ? nextDifferences : prevDifferences
        }

        function isDateTimeStart(date, dateUnitInterval) {
            var unitNumbers = [date.getMilliseconds(), date.getSeconds(), date.getMinutes(), date.getHours(), date.getDate(), date.getMonth()];
            var unitIndex = dateUnitIntervals.indexOf(dateUnitInterval);
            var i;
            for (i = 0; i < unitIndex; i++) {
                if (4 === i && 1 !== unitNumbers[i] || 4 !== i && 0 !== unitNumbers[i]) {
                    return false
                }
            }
            return true
        }

        function resetDateUnitInterval(differences, intervalIndex) {
            var dateUnitInterval = dateUnitIntervals[intervalIndex];
            if (differences[dateUnitInterval]) {
                differences[dateUnitInterval] = false;
                differences.count--
            }
        }

        function setDateUnitInterval(differences, intervalIndex) {
            var dateUnitInterval = dateUnitIntervals[intervalIndex];
            if (false === differences[dateUnitInterval]) {
                differences[dateUnitInterval] = true;
                differences.count++
            }
        }

        function getNoZeroIndex(str) {
            return str.length - parseInt(str).toString().length
        }

        function getTransitionTickIndex(ticks, value) {
            var i;
            var curDiff;
            var minDiff;
            var nearestTickIndex = 0;
            minDiff = abs(value - ticks[0]);
            for (i = 1; i < ticks.length; i++) {
                curDiff = abs(value - ticks[i]);
                if (curDiff < minDiff) {
                    minDiff = curDiff;
                    nearestTickIndex = i
                }
            }
            return nearestTickIndex
        }

        function splitDecimalNumber(value) {
            return value.toString().split(".")
        }

        function createFormat(type) {
            var formatter;
            if ((0, _type.isFunction)(type)) {
                formatter = type;
                type = null
            }
            return {
                type: type,
                formatter: formatter
            }
        }

        function smartFormatter(tick, options) {
            var tickInterval = options.tickInterval;
            var tickIntervalIndex;
            var tickIndex;
            var actualIndex;
            var stringTick = abs(tick).toString();
            var precision = 0;
            var typeFormat;
            var offset = 0;
            var separatedTickInterval;
            var indexOfFormat = 0;
            var indexOfTick = -1;
            var datesDifferences;
            var format = options.labelOptions.format;
            var ticks = options.ticks;
            var log10Tick;
            var prevDateIndex;
            var nextDateIndex;
            var isLogarithmic = "logarithmic" === options.type;
            if (1 === ticks.length && 0 === ticks.indexOf(tick) && !(0, _type.isDefined)(tickInterval)) {
                tickInterval = abs(tick) >= 1 ? 1 : (0, _math.adjust)(1 - abs(tick), tick)
            }
            if (!(0, _type.isDefined)(format) && "discrete" !== options.type && tick && (10 === options.logarithmBase || !isLogarithmic)) {
                if ("datetime" !== options.dataType && (0, _type.isDefined)(tickInterval)) {
                    if (ticks.length && ticks.indexOf(tick) === -1) {
                        indexOfTick = getTransitionTickIndex(ticks, tick);
                        tickInterval = (0, _math.adjust)(abs(tick - ticks[indexOfTick]), tick)
                    }
                    separatedTickInterval = splitDecimalNumber(tickInterval);
                    if (separatedTickInterval < 2) {
                        separatedTickInterval = splitDecimalNumber(tick)
                    }
                    if (isLogarithmic) {
                        log10Tick = (0, _utils.getAdjustedLog10)(abs(tick));
                        if (log10Tick > 0) {
                            typeFormat = formats[floor(log10Tick / 3)] || EXPONENTIAL
                        } else {
                            if (log10Tick < -4) {
                                typeFormat = EXPONENTIAL
                            } else {
                                return _format((0, _math.adjust)(tick))
                            }
                        }
                    } else {
                        if (separatedTickInterval.length > 1 && !(0, _type.isExponential)(tickInterval)) {
                            precision = separatedTickInterval[1].length;
                            typeFormat = formats[indexOfFormat]
                        } else {
                            if ((0, _type.isExponential)(tickInterval) && (stringTick.indexOf(".") !== -1 || (0, _type.isExponential)(tick))) {
                                typeFormat = EXPONENTIAL;
                                if (!(0, _type.isExponential)(tick)) {
                                    precision = abs(getNoZeroIndex(stringTick.split(".")[1]) - (0, _math.getExponent)(tickInterval) + 1)
                                } else {
                                    precision = Math.max(abs((0, _math.getExponent)(tick) - (0, _math.getExponent)(tickInterval)), abs((0, _math.getPrecision)(tick) - (0, _math.getPrecision)(tickInterval)))
                                }
                            } else {
                                tickIntervalIndex = floor((0, _utils.getAdjustedLog10)(tickInterval));
                                actualIndex = tickIndex = floor((0, _utils.getAdjustedLog10)(abs(tick)));
                                if (tickIndex - tickIntervalIndex >= 2) {
                                    actualIndex = tickIntervalIndex
                                }
                                indexOfFormat = floor(actualIndex / 3);
                                offset = 3 * indexOfFormat;
                                if (indexOfFormat < 5) {
                                    if (tickIntervalIndex - offset === 2 && tickIndex >= 3) {
                                        indexOfFormat++;
                                        offset = 3 * indexOfFormat
                                    }
                                    typeFormat = formats[indexOfFormat]
                                } else {
                                    typeFormat = formats[formats.length - 1]
                                }
                                if (offset > 0) {
                                    separatedTickInterval = splitDecimalNumber(tickInterval / Math.pow(10, offset));
                                    if (separatedTickInterval[1]) {
                                        precision = separatedTickInterval[1].length
                                    }
                                }
                            }
                        }
                    }
                    if (void 0 !== typeFormat || void 0 !== precision) {
                        format = {
                            type: typeFormat,
                            precision: precision
                        }
                    }
                } else {
                    if ("datetime" === options.dataType) {
                        typeFormat = _date.default.getDateFormatByTickInterval(tickInterval);
                        if (options.showTransition && ticks.length) {
                            indexOfTick = ticks.map(Number).indexOf(+tick);
                            if (1 === ticks.length && 0 === indexOfTick) {
                                typeFormat = _format_helper.default.getDateFormatByTicks(ticks)
                            } else {
                                if (indexOfTick === -1) {
                                    prevDateIndex = getTransitionTickIndex(ticks, tick)
                                } else {
                                    prevDateIndex = 0 === indexOfTick ? ticks.length - 1 : indexOfTick - 1;
                                    nextDateIndex = 0 === indexOfTick ? 1 : -1
                                }
                                datesDifferences = getDatesDifferences(ticks[prevDateIndex], tick, ticks[nextDateIndex], typeFormat);
                                typeFormat = _format_helper.default.getDateFormatByDifferences(datesDifferences, typeFormat)
                            }
                        }
                        format = createFormat(typeFormat)
                    }
                }
            }
            return _format(tick, format)
        }

        function getHighDiffFormat(diff) {
            var stop = false;
            for (var i in diff) {
                if (true === diff[i] || "hour" === i || stop) {
                    diff[i] = false;
                    stop = true
                } else {
                    if (false === diff[i]) {
                        diff[i] = true
                    }
                }
            }
            return createFormat(_format_helper.default.getDateFormatByDifferences(diff))
        }

        function getHighAndSelfDiffFormat(diff, interval) {
            var stop = false;
            for (var i in diff) {
                if (stop) {
                    diff[i] = false
                } else {
                    if (i === interval) {
                        stop = true
                    } else {
                        diff[i] = true
                    }
                }
            }
            return createFormat(_format_helper.default.getDateFormatByDifferences(diff))
        }

        function formatDateRange(startValue, endValue, tickInterval) {
            var diff = getDatesDifferences(startValue, endValue);
            var typeFormat = _date.default.getDateFormatByTickInterval(tickInterval);
            var diffFormatType = _format_helper.default.getDateFormatByDifferences(diff, typeFormat);
            var diffFormat = createFormat(diffFormatType);
            var values = [];
            if (tickInterval in diff) {
                var rangeFormat = getHighAndSelfDiffFormat(getDatesDifferences(startValue, endValue), tickInterval);
                var value = _format(startValue, rangeFormat);
                if (value) {
                    values.push(value)
                }
            } else {
                var _rangeFormat = getHighDiffFormat(getDatesDifferences(startValue, endValue));
                var highValue = _format(startValue, _rangeFormat);
                if (highValue) {
                    values.push(highValue)
                }
                values.push("".concat(_format(startValue, diffFormat), " - ").concat(_format(endValue, diffFormat)))
            }
            return values.join(", ")
        }

        function processDateInterval(interval) {
            if ((0, _type.isObject)(interval)) {
                var dateUnits = Object.keys(interval);
                var sum = dateUnits.reduce(function(sum, k) {
                    return interval[k] + sum
                }, 0);
                if (1 === sum) {
                    var dateUnit = dateUnits.filter(function(k) {
                        return 1 === interval[k]
                    })[0];
                    return dateUnit.slice(0, dateUnit.length - 1)
                }
            }
            return interval
        }

        function formatRange(startValue, endValue, tickInterval, _ref) {
            var dataType = _ref.dataType,
                type = _ref.type,
                logarithmBase = _ref.logarithmBase;
            if ("discrete" === type) {
                return ""
            }
            if ("datetime" === dataType) {
                return formatDateRange(startValue, endValue, processDateInterval(tickInterval))
            }
            var formatOptions = {
                ticks: [],
                type: type,
                dataType: dataType,
                tickInterval: tickInterval,
                logarithmBase: logarithmBase,
                labelOptions: {}
            };
            return "".concat(smartFormatter(startValue, formatOptions), " - ").concat(smartFormatter(endValue, formatOptions))
        }
    },
    /*!*************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/axes/tick_generator.js ***!
      \*************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.tickGenerator = void 0;
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _math = __webpack_require__( /*! ../../core/utils/math */ 29);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _slicedToArray(arr, i) {
            return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest()
        }

        function _nonIterableRest() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }

        function _iterableToArrayLimit(arr, i) {
            var _i = arr && ("undefined" !== typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]);
            if (null == _i) {
                return
            }
            var _arr = [];
            var _n = true;
            var _d = false;
            var _s, _e;
            try {
                for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
                    _arr.push(_s.value);
                    if (i && _arr.length === i) {
                        break
                    }
                }
            } catch (err) {
                _d = true;
                _e = err
            } finally {
                try {
                    if (!_n && null != _i.return) {
                        _i.return()
                    }
                } finally {
                    if (_d) {
                        throw _e
                    }
                }
            }
            return _arr
        }

        function _arrayWithHoles(arr) {
            if (Array.isArray(arr)) {
                return arr
            }
        }
        var convertDateUnitToMilliseconds = _date.default.convertDateUnitToMilliseconds;
        var dateToMilliseconds = _date.default.dateToMilliseconds;
        var math = Math;
        var mathAbs = math.abs;
        var mathFloor = math.floor;
        var mathCeil = math.ceil;
        var mathPow = math.pow;
        var NUMBER_MULTIPLIERS = [1, 2, 2.5, 5];
        var LOGARITHMIC_MULTIPLIERS = [1, 2, 3, 5];
        var DATETIME_MULTIPLIERS = {
            millisecond: [1, 2, 5, 10, 25, 50, 100, 250, 500],
            second: [1, 2, 3, 5, 10, 15, 20, 30],
            minute: [1, 2, 3, 5, 10, 15, 20, 30],
            hour: [1, 2, 3, 4, 6, 8, 12],
            day: [1, 2],
            week: [1, 2],
            month: [1, 2, 3, 6]
        };
        var DATETIME_MULTIPLIERS_WITH_BIG_WEEKEND = (0, _extend.extend)({}, DATETIME_MULTIPLIERS, {
            day: [1]
        });
        var DATETIME_MINOR_MULTIPLIERS = {
            millisecond: [1, 2, 5, 10, 25, 50, 100, 250, 500],
            second: [1, 2, 3, 5, 10, 15, 20, 30],
            minute: [1, 2, 3, 5, 10, 15, 20, 30],
            hour: [1, 2, 3, 4, 6, 8, 12],
            day: [1, 2, 3, 7, 14],
            month: [1, 2, 3, 6]
        };
        var MINOR_DELIMITERS = [2, 4, 5, 8, 10];
        var VISIBILITY_DELIMITER = 3;
        var MINUTE = 6e4;

        function dummyGenerator(options) {
            return function(data, screenDelta, tickInterval, forceTickInterval) {
                var count = mathFloor(screenDelta / options.axisDivisionFactor);
                count = count < 1 ? 1 : count;
                var interval = screenDelta / count;
                return {
                    ticks: interval > 0 ? Array.apply(null, new Array(count + 1)).map(function(_, i) {
                        return interval * i
                    }) : [],
                    tickInterval: interval
                }
            }
        }

        function discreteGenerator(options) {
            return function(data, screenDelta, tickInterval, forceTickInterval) {
                var categories = (0, _utils.getCategoriesInfo)(data.categories, data.min, data.max).categories;
                return {
                    ticks: categories,
                    tickInterval: mathCeil(categories.length * options.axisDivisionFactor / screenDelta)
                }
            }
        }
        var getValue = function(value) {
            return value
        };
        var getLogValue = function(base, allowNegatives, linearThreshold) {
            return function(value) {
                return (0, _utils.getLogExt)(value, base, allowNegatives, linearThreshold)
            }
        };
        var raiseTo = function(base, allowNegatives, linearThreshold) {
            return function(value) {
                return (0, _utils.raiseToExt)(value, base, allowNegatives, linearThreshold)
            }
        };
        var mathRaiseTo = function(base) {
            return function(value) {
                return (0, _utils.raiseTo)(value, base)
            }
        };
        var logAbsValue = function(base) {
            return function(value) {
                return 0 === value ? 0 : (0, _utils.getLog)(mathAbs(value), base)
            }
        };
        var correctValueByInterval = function(post, round, getValue) {
            return function(value, interval) {
                return (0, _math.adjust)(post(round((0, _math.adjust)(getValue(value) / interval)) * interval))
            }
        };

        function correctMinValueByEndOnTick(floorFunc, ceilFunc, resolveEndOnTick, endOnTick) {
            if ((0, _type.isDefined)(endOnTick)) {
                return endOnTick ? floorFunc : ceilFunc
            }
            return function(value, interval, businessViewInfo, forceEndOnTick) {
                var floorTickValue = floorFunc(value, interval);
                if (value - floorTickValue === 0 || !(0, _type.isDefined)(businessViewInfo) || resolveEndOnTick(value, floorTickValue, interval, businessViewInfo) || forceEndOnTick) {
                    return floorTickValue
                }
                return ceilFunc(value, interval)
            }
        }

        function resolveEndOnTick(curValue, tickValue, interval, businessViewInfo) {
            var prevTickDataDiff = interval - mathAbs(tickValue - curValue);
            var intervalCount = math.max(mathCeil(businessViewInfo.businessDelta / interval), 2);
            var businessRatio = businessViewInfo.screenDelta / (intervalCount * interval);
            var potentialTickScreenDiff = math.round(businessRatio * prevTickDataDiff);
            var delimiterFactor = (0, _utils.getLogExt)(businessRatio * interval / businessViewInfo.axisDivisionFactor, 2) + 1;
            var delimiterMultiplier = (businessViewInfo.isSpacedMargin ? 2 : 1) * delimiterFactor;
            var screenDelimiter = math.round(VISIBILITY_DELIMITER * delimiterMultiplier);
            return businessViewInfo.businessDelta > businessViewInfo.interval && potentialTickScreenDiff >= screenDelimiter
        }

        function resolveEndOnTickLog(base) {
            return function(curValue, tickValue, interval, businessViewInfo) {
                return resolveEndOnTick((0, _utils.getLogExt)(curValue, base), (0, _utils.getLogExt)(tickValue, base), interval, businessViewInfo)
            }
        }

        function resolveEndOnTickDate(curValue, tickValue, interval, businessViewInfo) {
            return resolveEndOnTick(curValue.valueOf(), tickValue.valueOf(), dateToMilliseconds(interval), businessViewInfo)
        }

        function getBusinessDelta(data, breaks) {
            var spacing = 0;
            if (breaks) {
                spacing = breaks.reduce(function(prev, item) {
                    return prev + (item.to - item.from)
                }, 0)
            }
            return mathAbs(data.max - data.min - spacing)
        }

        function getBusinessDeltaLog(base, allowNegatives, linearThreshold) {
            var getLog = getLogValue(base, allowNegatives, linearThreshold);
            return function(data, breaks) {
                var spacing = 0;
                if (breaks) {
                    spacing = breaks.reduce(function(prev, item) {
                        return prev + mathAbs(getLog(item.to / item.from))
                    }, 0)
                }
                return mathCeil(mathAbs(getLog(data.max) - getLog(data.min)) - spacing)
            }
        }

        function getIntervalByFactor(businessDelta, screenDelta, axisDivisionFactor, addTickCount) {
            var count = screenDelta / axisDivisionFactor - (addTickCount || 0);
            count = count < 1 ? 1 : count;
            return businessDelta / count
        }

        function getMultiplierFactor(interval, factorDelta) {
            return mathPow(10, mathFloor((0, _utils.getLogExt)(interval, 10)) + (factorDelta || 0))
        }

        function calculateTickInterval(businessDelta, screenDelta, tickInterval, forceTickInterval, axisDivisionFactor, multipliers, allowDecimals, addTickCount, _, minTickInterval) {
            var interval = getIntervalByFactor(businessDelta, screenDelta, axisDivisionFactor, addTickCount);
            var result = 1;
            var onlyIntegers = false === allowDecimals;
            if (!forceTickInterval || !tickInterval) {
                if (interval >= 1 || !onlyIntegers && interval > 0) {
                    result = adjustInterval(interval, multipliers, onlyIntegers)
                }
                if (!tickInterval || !forceTickInterval && tickInterval < result) {
                    tickInterval = result
                }
            }
            if (!forceTickInterval && minTickInterval) {
                minTickInterval = adjustInterval(minTickInterval, multipliers, onlyIntegers);
                if (minTickInterval > tickInterval) {
                    tickInterval = minTickInterval
                }
            }
            return tickInterval
        }

        function adjustInterval(interval, multipliers, onlyIntegers) {
            var factor = getMultiplierFactor(interval, -1);
            var result = 1;
            multipliers = multipliers || NUMBER_MULTIPLIERS;
            if (interval > 0) {
                interval /= factor;
                result = multipliers.concat(10 * multipliers[0]).map(function(m) {
                    return 10 * m
                }).reduce(function(r, m) {
                    if (.1 === factor && onlyIntegers && 25 === m) {
                        return r
                    }
                    return r < interval ? m : r
                }, 0);
                result = (0, _math.adjust)(result * factor, factor)
            }
            return result
        }

        function calculateMinorTickInterval(businessDelta, screenDelta, tickInterval, axisDivisionFactor) {
            var interval = getIntervalByFactor(businessDelta, screenDelta, axisDivisionFactor);
            return tickInterval || MINOR_DELIMITERS.reduce(function(r, d) {
                var cur = businessDelta / d;
                return cur >= interval ? cur : r
            }, 0)
        }

        function getCalculateTickIntervalLog(skipCalculationLimits) {
            return function(businessDelta, screenDelta, tickInterval, forceTickInterval, axisDivisionFactor, multipliers, allowDecimals, _, __, minTickInterval) {
                var interval = getIntervalByFactor(businessDelta, screenDelta, axisDivisionFactor);
                var result = 0;
                var adjustInterval = getAdjustIntervalLog(skipCalculationLimits);
                if (!forceTickInterval || !tickInterval) {
                    if (interval > 0) {
                        result = adjustInterval(interval, multipliers)
                    }
                    if (!tickInterval || !forceTickInterval && tickInterval < result) {
                        tickInterval = result
                    }
                }
                if (!forceTickInterval && minTickInterval) {
                    minTickInterval = adjustInterval(minTickInterval, multipliers);
                    if (minTickInterval > tickInterval) {
                        tickInterval = minTickInterval
                    }
                }
                return tickInterval
            }
        }

        function getAdjustIntervalLog(skipCalculationLimits) {
            return function(interval, multipliers) {
                var factor = getMultiplierFactor(interval);
                multipliers = multipliers || LOGARITHMIC_MULTIPLIERS;
                if (!skipCalculationLimits && factor < 1) {
                    factor = 1
                }
                return multipliers.concat(10 * multipliers[0]).reduce(function(r, m) {
                    return r < interval ? m * factor : r
                }, 0)
            }
        }

        function getDataTimeMultipliers(gapSize) {
            if (gapSize && gapSize > 2) {
                return DATETIME_MULTIPLIERS_WITH_BIG_WEEKEND
            } else {
                return DATETIME_MULTIPLIERS
            }
        }

        function numbersReducer(interval, key) {
            return function(r, m) {
                if (!r && interval <= convertDateUnitToMilliseconds(key, m)) {
                    r = {};
                    r[key + "s"] = m
                }
                return r
            }
        }

        function yearsReducer(interval, factor) {
            return function(r, m) {
                var years = factor * m;
                if (!r && interval <= convertDateUnitToMilliseconds("year", years) && 2.5 !== years) {
                    r = {
                        years: years
                    }
                }
                return r
            }
        }

        function calculateTickIntervalDateTime(businessDelta, screenDelta, tickInterval, forceTickInterval, axisDivisionFactor, multipliers, allowDecimals, addTickCount, gapSize, minTickInterval) {
            if (!forceTickInterval || !tickInterval) {
                var result = adjustIntervalDateTime(getIntervalByFactor(businessDelta, screenDelta, axisDivisionFactor), multipliers, null, gapSize);
                if (!tickInterval || !forceTickInterval && dateToMilliseconds(tickInterval) <= dateToMilliseconds(result)) {
                    tickInterval = result
                }
            }
            if (!forceTickInterval && minTickInterval) {
                minTickInterval = adjustIntervalDateTime(minTickInterval, multipliers, null, gapSize);
                if (dateToMilliseconds(minTickInterval) > dateToMilliseconds(tickInterval)) {
                    tickInterval = minTickInterval
                }
            }
            return tickInterval
        }

        function adjustIntervalDateTime(interval, multipliers, _, gapSize) {
            var result;
            multipliers = multipliers || getDataTimeMultipliers(gapSize);
            for (var key in multipliers) {
                result = multipliers[key].reduce(numbersReducer(interval, key), result);
                if (result) {
                    break
                }
            }
            if (!result) {
                for (var factor = 1;; factor *= 10) {
                    result = NUMBER_MULTIPLIERS.reduce(yearsReducer(interval, factor), result);
                    if (result) {
                        break
                    }
                }
            }
            return result
        }

        function calculateMinorTickIntervalDateTime(businessDelta, screenDelta, tickInterval, axisDivisionFactor) {
            return calculateTickIntervalDateTime(businessDelta, screenDelta, tickInterval, true, axisDivisionFactor, DATETIME_MINOR_MULTIPLIERS)
        }

        function getTickIntervalByCustomTicks(getValue, postProcess) {
            return function(ticks) {
                return ticks ? postProcess(mathAbs((0, _math.adjust)(getValue(ticks[1]) - getValue(ticks[0])))) || void 0 : void 0
            }
        }

        function addInterval(value, interval, isNegative) {
            return _date.default.addInterval(value, interval, isNegative)
        }

        function addIntervalLog(log, raise) {
            return function(value, interval, isNegative) {
                return raise(addInterval(log(value), interval, isNegative))
            }
        }

        function addIntervalDate(value, interval, isNegative) {
            return addInterval(value, interval, isNegative)
        }

        function addIntervalWithBreaks(addInterval, breaks, correctValue) {
            breaks = breaks.filter(function(b) {
                return !b.gapSize
            });
            return function(value, interval, isNegative) {
                var breakSize;
                value = addInterval(value, interval, isNegative);
                if (!breaks.every(function(item) {
                        if (value >= addInterval(item.from, interval) && addInterval(value, interval) < item.to) {
                            breakSize = item.to - item.from - 2 * (addInterval(item.from, interval) - item.from)
                        }
                        return !breakSize
                    })) {
                    value = correctValue(addInterval(value, breakSize), interval)
                }
                return value
            }
        }

        function calculateTicks(addInterval, correctMinValue, adjustInterval, resolveEndOnTick) {
            return function(data, tickInterval, endOnTick, gaps, breaks, businessDelta, screenDelta, axisDivisionFactor, generateExtraTick) {
                var correctTickValue = correctTickValueOnGapSize(addInterval, gaps);
                var min = data.min;
                var max = data.max;
                var businessViewInfo = {
                    screenDelta: screenDelta,
                    businessDelta: businessDelta,
                    axisDivisionFactor: axisDivisionFactor,
                    isSpacedMargin: data.isSpacedMargin,
                    interval: tickInterval
                };
                var cur = correctMinValue(min, tickInterval, businessViewInfo);
                var ticks = [];
                if (null !== breaks && void 0 !== breaks && breaks.length) {
                    addInterval = addIntervalWithBreaks(addInterval, breaks, correctMinValue)
                }
                if (cur > max) {
                    cur = correctMinValue(min, adjustInterval(businessDelta / 2), businessViewInfo);
                    if (cur > max) {
                        endOnTick = true;
                        cur = correctMinValue(min, tickInterval, businessViewInfo, endOnTick)
                    }
                }
                cur = correctTickValue(cur);
                var prev;
                while (cur < max && cur !== prev || generateExtraTick && cur <= max) {
                    ticks.push(cur);
                    prev = cur;
                    cur = correctTickValue(addInterval(cur, tickInterval))
                }
                if (endOnTick || cur - max === 0 || !(0, _type.isDefined)(endOnTick) && resolveEndOnTick(max, cur, tickInterval, businessViewInfo)) {
                    ticks.push(cur)
                }
                return ticks
            }
        }

        function calculateMinorTicks(updateTickInterval, addInterval, correctMinValue, correctTickValue, ceil) {
            return function(min, max, majorTicks, minorTickInterval, tickInterval, breaks, maxCount) {
                var factor = tickInterval / minorTickInterval;
                var lastMajor = majorTicks[majorTicks.length - 1];
                var firstMajor = majorTicks[0];
                var tickBalance = maxCount - 1;
                if (null !== breaks && void 0 !== breaks && breaks.length) {
                    addInterval = addIntervalWithBreaks(addInterval, breaks, correctMinValue)
                }
                minorTickInterval = updateTickInterval(minorTickInterval, firstMajor, firstMajor, factor);
                if (0 === minorTickInterval) {
                    return []
                }
                var cur = correctTickValue(correctMinValue(min, tickInterval, min), minorTickInterval);
                minorTickInterval = updateTickInterval(minorTickInterval, firstMajor, cur, factor);
                var ticks = [];
                while (cur < firstMajor && (!tickBalance || tickBalance > 0)) {
                    cur >= min && ticks.push(cur);
                    tickBalance--;
                    cur = addInterval(cur, minorTickInterval)
                }
                var middleTicks = majorTicks.reduce(function(r, tick) {
                    tickBalance = maxCount - 1;
                    if (null === r.prevTick) {
                        r.prevTick = tick;
                        return r
                    }
                    minorTickInterval = updateTickInterval(minorTickInterval, tick, r.prevTick, factor);
                    var cur = correctTickValue(r.prevTick, minorTickInterval);
                    while (cur < tick && (!tickBalance || tickBalance > 0)) {
                        cur !== r.prevTick && r.minors.push(cur);
                        tickBalance--;
                        cur = addInterval(cur, minorTickInterval)
                    }
                    r.prevTick = tick;
                    return r
                }, {
                    prevTick: null,
                    minors: []
                });
                ticks = ticks.concat(middleTicks.minors);
                var maxValue = ceil(max, tickInterval, min);
                minorTickInterval = updateTickInterval(minorTickInterval, maxValue, maxValue, factor);
                cur = correctTickValue(lastMajor, minorTickInterval);
                var prev;
                while (cur < max && cur !== prev) {
                    ticks.push(cur);
                    prev = cur;
                    cur = addInterval(cur, minorTickInterval)
                }
                if (lastMajor - max !== 0 && cur - max === 0) {
                    ticks.push(cur)
                }
                return ticks
            }
        }

        function filterTicks(ticks, breaks) {
            if (breaks.length) {
                var result = breaks.reduce(function(result, b) {
                    var tmpTicks = [];
                    var i;
                    for (i = result[1]; i < ticks.length; i++) {
                        var tickValue = ticks[i];
                        if (tickValue < b.from) {
                            tmpTicks.push(tickValue)
                        }
                        if (tickValue >= b.to) {
                            break
                        }
                    }
                    return [result[0].concat(tmpTicks), i]
                }, [
                    [], 0
                ]);
                return result[0].concat(ticks.slice(result[1]))
            }
            return ticks
        }

        function correctTickValueOnGapSize(addInterval, breaks) {
            return function(value) {
                var gapSize;
                if (!breaks.every(function(item) {
                        if (value >= item.from && value < item.to) {
                            gapSize = item.gapSize
                        }
                        return !gapSize
                    })) {
                    value = addInterval(value, gapSize)
                }
                return value
            }
        }

        function generator(options, getBusinessDelta, calculateTickInterval, calculateMinorTickInterval, getMajorTickIntervalByCustomTicks, getMinorTickIntervalByCustomTicks, convertTickInterval, calculateTicks, calculateMinorTicks, processScaleBreaks) {
            function processCustomTicks(customTicks) {
                return {
                    tickInterval: getMajorTickIntervalByCustomTicks(customTicks.majors),
                    ticks: customTicks.majors || [],
                    minorTickInterval: getMinorTickIntervalByCustomTicks(customTicks.minors),
                    minorTicks: customTicks.minors || []
                }
            }

            function correctUserTickInterval(tickInterval, businessDelta, limit) {
                if (tickInterval && businessDelta / convertTickInterval(tickInterval) >= limit + 1) {
                    options.incidentOccurred("W2003");
                    tickInterval = void 0
                }
                return tickInterval
            }

            function generateMajorTicks(ticks, data, businessDelta, screenDelta, tickInterval, forceTickInterval, customTicks, breaks) {
                if (customTicks.majors) {
                    ticks.breaks = breaks;
                    return ticks
                }
                var gaps = breaks.filter(function(b) {
                    return b.gapSize
                });
                var majorTicks;
                tickInterval = options.skipCalculationLimits ? tickInterval : correctUserTickInterval(tickInterval, businessDelta, screenDelta);
                tickInterval = calculateTickInterval(businessDelta, screenDelta, tickInterval, forceTickInterval, options.axisDivisionFactor, options.numberMultipliers, options.allowDecimals, breaks.length, gaps[0] && gaps[0].gapSize.days, options.minTickInterval);
                if (!options.skipTickGeneration) {
                    majorTicks = calculateTicks(data, tickInterval, options.endOnTick, gaps, breaks, businessDelta, screenDelta, options.axisDivisionFactor, options.generateExtraTick);
                    breaks = processScaleBreaks(breaks, majorTicks, tickInterval);
                    majorTicks = filterTicks(majorTicks, breaks);
                    ticks.breaks = breaks;
                    ticks.ticks = ticks.ticks.concat(majorTicks)
                }
                ticks.tickInterval = tickInterval;
                return ticks
            }

            function generateMinorTicks(ticks, data, businessDelta, screenDelta, minorTickInterval, minorTickCount, customTicks) {
                if (!options.calculateMinors) {
                    return ticks
                }
                if (customTicks.minors) {
                    return ticks
                }
                var minorBusinessDelta = convertTickInterval(ticks.tickInterval);
                var minorScreenDelta = screenDelta * minorBusinessDelta / businessDelta;
                var breaks = ticks.breaks;
                if (!minorTickInterval && minorTickCount) {
                    minorTickInterval = getMinorTickIntervalByCustomTicks([minorBusinessDelta / (minorTickCount + 1), minorBusinessDelta / (minorTickCount + 1) * 2])
                } else {
                    minorTickCount = void 0
                }
                minorTickInterval = correctUserTickInterval(minorTickInterval, minorBusinessDelta, minorScreenDelta);
                minorTickInterval = calculateMinorTickInterval(minorBusinessDelta, minorScreenDelta, minorTickInterval, options.minorAxisDivisionFactor);
                ticks.minorTicks = filterTicks(ticks.minorTicks.concat(calculateMinorTicks(data.min, data.max, ticks.ticks, minorTickInterval, ticks.tickInterval, breaks, minorTickCount)), breaks);
                ticks.minorTickInterval = minorTickInterval;
                return ticks
            }
            return function(data, screenDelta, tickInterval, forceTickInterval, customTicks, minorTickInterval, minorTickCount, breaks) {
                customTicks = customTicks || {};
                var businessDelta = getBusinessDelta(data, breaks);
                var result = processCustomTicks(customTicks);
                if (!isNaN(businessDelta)) {
                    if (0 === businessDelta && !customTicks.majors) {
                        result.ticks = [data.min]
                    } else {
                        result = generateMajorTicks(result, data, businessDelta, screenDelta, tickInterval, forceTickInterval, customTicks, breaks || []);
                        if (!options.skipTickGeneration && businessDelta > 0) {
                            result = generateMinorTicks(result, data, businessDelta, screenDelta, minorTickInterval, minorTickCount, customTicks)
                        }
                    }
                }
                return result
            }
        }

        function getBaseTick(breakValue, _ref, interval, getValue) {
            var _ref2 = _slicedToArray(_ref, 2),
                tick = _ref2[0],
                insideTick = _ref2[1];
            if (!(0, _type.isDefined)(tick) || mathAbs(getValue(breakValue) - getValue(tick)) / interval > .25) {
                if ((0, _type.isDefined)(insideTick)) {
                    tick = insideTick
                } else {
                    if (!(0, _type.isDefined)(tick)) {
                        tick = breakValue
                    }
                }
            }
            return tick
        }

        function getScaleBreaksProcessor(convertTickInterval, getValue, addCorrection) {
            return function(breaks, ticks, tickInterval) {
                var interval = convertTickInterval(tickInterval);
                var correction = .5 * interval;
                return breaks.reduce(function(result, b) {
                    var breakTicks = ticks.filter(function(tick) {
                        return tick <= b.from
                    });
                    var from = addCorrection(getBaseTick(b.from, [].concat(breakTicks[breakTicks.length - 1], ticks[breakTicks.length]), interval, getValue), correction);
                    breakTicks = ticks.filter(function(tick) {
                        return tick >= b.to
                    });
                    var to = addCorrection(getBaseTick(b.to, [].concat(breakTicks[0], ticks[ticks.length - breakTicks.length - 1]), interval, getValue), -correction);
                    if (getValue(to) - getValue(from) < interval && !b.gapSize) {
                        return result
                    }
                    if (b.gapSize) {
                        return result.concat([b])
                    }
                    return result.concat([{
                        from: from,
                        to: to,
                        cumulativeWidth: b.cumulativeWidth
                    }])
                }, [])
            }
        }

        function numericGenerator(options) {
            var floor = correctValueByInterval(getValue, mathFloor, getValue);
            var ceil = correctValueByInterval(getValue, mathCeil, getValue);
            var calculateTickIntervalByCustomTicks = getTickIntervalByCustomTicks(getValue, getValue);
            return generator(options, getBusinessDelta, calculateTickInterval, calculateMinorTickInterval, calculateTickIntervalByCustomTicks, calculateTickIntervalByCustomTicks, getValue, calculateTicks(addInterval, correctMinValueByEndOnTick(floor, ceil, resolveEndOnTick, options.endOnTick), adjustInterval, resolveEndOnTick), calculateMinorTicks(getValue, addInterval, floor, addInterval, getValue), getScaleBreaksProcessor(getValue, getValue, function(value, correction) {
                return value + correction
            }))
        }
        var correctValueByIntervalLog = function(post, getRound, getValue) {
            return function(value, interval) {
                return (0, _math.sign)(value) * (0, _math.adjust)(post(getRound(value)((0, _math.adjust)(getValue(value) / interval)) * interval))
            }
        };

        function logarithmicGenerator(options) {
            var base = options.logBase;
            var raise = raiseTo(base, options.allowNegatives, options.linearThreshold);
            var log = getLogValue(base, options.allowNegatives, options.linearThreshold);
            var absLog = logAbsValue(base);
            var absRaise = mathRaiseTo(base);
            var absFloor = function(value) {
                return value < 0 ? mathCeil : mathFloor
            };
            var absCeil = function(value) {
                return value < 0 ? mathFloor : mathCeil
            };
            var floor = correctValueByIntervalLog(absRaise, absFloor, absLog);
            var ceil = correctValueByIntervalLog(absRaise, absCeil, absLog);
            var ceilNumber = correctValueByInterval(getValue, mathCeil, getValue);
            return generator(options, getBusinessDeltaLog(base, options.allowNegatives, options.linearThreshold), getCalculateTickIntervalLog(options.skipCalculationLimits), calculateMinorTickInterval, getTickIntervalByCustomTicks(log, getValue), getTickIntervalByCustomTicks(getValue, getValue), getValue, calculateTicks(addIntervalLog(log, raise), correctMinValueByEndOnTick(floor, ceil, resolveEndOnTickLog(base), options.endOnTick), getAdjustIntervalLog(options.skipCalculationLimits), resolveEndOnTickLog(base)), calculateMinorTicks(function(_, tick, prevTick, factor) {
                return Math.max(Math.abs(tick), Math.abs(prevTick)) / factor
            }, addInterval, floor, ceilNumber, ceil), getScaleBreaksProcessor(getValue, log, function(value, correction) {
                return raise(log(value) + correction)
            }))
        }

        function dateGenerator(options) {
            function floor(value, interval) {
                var floorNumber = correctValueByInterval(getValue, mathFloor, getValue);
                var intervalObject = (0, _type.isString)(interval) ? _date.default.getDateIntervalByString(interval.toLowerCase()) : interval;
                var divider = dateToMilliseconds(interval);
                if (intervalObject.days % 7 === 0 || interval.quarters) {
                    intervalObject = adjustIntervalDateTime(divider)
                }
                var correctDateWithUnitBeginning = function(v) {
                    return _date.default.correctDateWithUnitBeginning(v, intervalObject, null, options.firstDayOfWeek)
                };
                var floorAtStartDate = function(v) {
                    return new Date(mathFloor((v.getTime() - v.getTimezoneOffset() * MINUTE) / divider) * divider + v.getTimezoneOffset() * MINUTE)
                };
                value = correctDateWithUnitBeginning(value);
                if ("years" in intervalObject) {
                    value.setFullYear(floorNumber(value.getFullYear(), intervalObject.years, 0))
                } else {
                    if ("quarters" in intervalObject) {
                        value = correctDateWithUnitBeginning(floorAtStartDate(value))
                    } else {
                        if ("months" in intervalObject) {
                            value.setMonth(floorNumber(value.getMonth(), intervalObject.months, 0))
                        } else {
                            if ("weeks" in intervalObject || "days" in intervalObject) {
                                value = correctDateWithUnitBeginning(floorAtStartDate(value))
                            } else {
                                if ("hours" in intervalObject) {
                                    value.setHours(floorNumber(value.getHours(), intervalObject.hours, 0))
                                } else {
                                    if ("minutes" in intervalObject) {
                                        value.setMinutes(floorNumber(value.getMinutes(), intervalObject.minutes, 0))
                                    } else {
                                        if ("seconds" in intervalObject) {
                                            value.setSeconds(floorNumber(value.getSeconds(), intervalObject.seconds, 0))
                                        } else {
                                            if ("milliseconds" in intervalObject) {
                                                value = floorAtStartDate(value)
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return value
            }

            function ceil(value, interval) {
                var newValue = floor(value, interval);
                while (value - newValue > 0) {
                    newValue = addIntervalDate(newValue, interval)
                }
                return newValue
            }
            var calculateTickIntervalByCustomTicks = getTickIntervalByCustomTicks(getValue, _date.default.convertMillisecondsToDateUnits);
            return generator(options, getBusinessDelta, calculateTickIntervalDateTime, calculateMinorTickIntervalDateTime, calculateTickIntervalByCustomTicks, calculateTickIntervalByCustomTicks, dateToMilliseconds, calculateTicks(addIntervalDate, correctMinValueByEndOnTick(floor, ceil, resolveEndOnTickDate, options.endOnTick), adjustIntervalDateTime, resolveEndOnTickDate), calculateMinorTicks(getValue, addIntervalDate, floor, addIntervalDate, getValue), getScaleBreaksProcessor(dateToMilliseconds, getValue, function(value, correction) {
                return new Date(value.getTime() + correction)
            }))
        }
        var tickGenerator = function(options) {
            var result;
            if (options.rangeIsEmpty) {
                result = dummyGenerator(options)
            } else {
                if ("discrete" === options.axisType) {
                    result = discreteGenerator(options)
                } else {
                    if ("logarithmic" === options.axisType) {
                        result = logarithmicGenerator(options)
                    } else {
                        if ("datetime" === options.dataType) {
                            result = dateGenerator(options)
                        } else {
                            result = numericGenerator(options)
                        }
                    }
                }
            }
            return result
        };
        exports.tickGenerator = tickGenerator
    },
    /*!***************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/axes/tick.js ***!
      \***************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.tick = createTick;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function getPathStyle(options) {
            return {
                stroke: options.color,
                "stroke-width": options.width,
                "stroke-opacity": options.opacity,
                opacity: 1
            }
        }

        function createTick(axis, renderer, tickOptions, gridOptions, skippedCategory, skipLabels, offset) {
            var tickOffset = offset || axis._tickOffset;
            var lineGroup = axis._axisLineGroup;
            var elementsGroup = axis._axisElementsGroup;
            var tickStyle = getPathStyle(tickOptions);
            var gridStyle = getPathStyle(gridOptions);
            var emptyStrRegExp = /^\s+$/;
            var axisOptions = axis.getOptions();
            var labelOptions = axisOptions.label;
            var labelStyle = axis._textOptions;

            function getLabelFontStyle(tick) {
                var fontStyle = axis._textFontStyles;
                var customizeColor = labelOptions.customizeColor;
                if (customizeColor && customizeColor.call) {
                    fontStyle = (0, _extend.extend)({}, axis._textFontStyles, {
                        fill: customizeColor.call(tick, tick)
                    })
                }
                return fontStyle
            }

            function createLabelHint(tick, range) {
                var labelHint = axis.formatHint(tick.value, labelOptions, range);
                if ((0, _type.isDefined)(labelHint) && "" !== labelHint) {
                    tick.getContentContainer().setTitle(labelHint)
                }
            }
            return function(value) {
                var tick = {
                    value: value,
                    updateValue: function(newValue) {
                        this.value = value = newValue
                    },
                    initCoords: function() {
                        this.coords = axis._getTranslatedValue(value, tickOffset);
                        this.labelCoords = axis._getTranslatedValue(value)
                    },
                    saveCoords: function() {
                        this._lastStoredCoordinates = {
                            coords: this._storedCoords,
                            labelCoords: this._storedLabelsCoords
                        };
                        this._storedCoords = this.coords;
                        this._storedLabelsCoords = this.templateContainer ? this._getTemplateCoords() : this.labelCoords
                    },
                    resetCoordinates: function() {
                        this._storedCoords = this._lastStoredCoordinates.coords;
                        this._storedLabelsCoords = this._lastStoredCoordinates.labelCoords
                    },
                    drawMark: function(options) {
                        if (!tickOptions.visible || skippedCategory === value) {
                            return
                        }
                        if (axis.areCoordsOutsideAxis(this.coords)) {
                            return
                        }
                        if (this.mark) {
                            this.mark.append(lineGroup);
                            axis.sharp(this.mark, axis.getSharpDirectionByCoords(this.coords));
                            this.updateTickPosition(options)
                        } else {
                            this.mark = axis._createPathElement([], tickStyle, axis.getSharpDirectionByCoords(this.coords)).append(lineGroup);
                            this.updateTickPosition(options)
                        }
                    },
                    setSkippedCategory: function(category) {
                        skippedCategory = category
                    },
                    _updateLine: function(lineElement, settings, storedSettings, animate, isGridLine) {
                        if (!lineElement) {
                            return
                        }
                        if (null === settings.points || null === settings.r) {
                            lineElement.remove();
                            return
                        }
                        if (animate && storedSettings && null !== storedSettings.points) {
                            settings.opacity = 1;
                            lineElement.attr(storedSettings);
                            lineElement.animate(settings)
                        } else {
                            settings.opacity = animate ? 0 : 1;
                            lineElement.attr(settings);
                            animate && lineElement.animate({
                                opacity: 1
                            }, {
                                delay: .5,
                                partitionDuration: .5
                            })
                        }
                        this.coords.angle && axis._rotateTick(lineElement, this.coords, isGridLine)
                    },
                    updateTickPosition: function(options, animate) {
                        this._updateLine(this.mark, {
                            points: axis._getTickMarkPoints(tick.coords, tickOptions.length, options)
                        }, this._storedCoords && {
                            points: axis._getTickMarkPoints(tick._storedCoords, tickOptions.length, options)
                        }, animate, false)
                    },
                    drawLabel: function(range, template) {
                        var _this = this;
                        if (this.templateContainer && axis.isRendered()) {
                            this.updateLabelPosition();
                            return
                        }
                        var labelIsVisible = labelOptions.visible && !skipLabels && !axis.getTranslator().getBusinessRange().isEmpty() && !axis.areCoordsOutsideAxis(this.labelCoords);
                        if (!labelIsVisible) {
                            if (this.label) {
                                this.removeLabel()
                            }
                            return
                        }
                        var templateOption = labelOptions.template;
                        var text = axis.formatLabel(value, labelOptions, range);
                        if (this.label) {
                            this.label.attr({
                                text: text,
                                rotate: 0
                            }).append(elementsGroup);
                            createLabelHint(this, range);
                            this.updateLabelPosition();
                            return
                        }
                        if (templateOption) {
                            this.templateContainer = renderer.g().append(elementsGroup);
                            this._templateDef && this._templateDef.reject();
                            this._templateDef = new _deferred.Deferred;
                            template.render({
                                model: {
                                    valueText: text,
                                    value: this.value,
                                    labelFontStyle: getLabelFontStyle(this),
                                    labelStyle: labelStyle
                                },
                                container: this.templateContainer.element,
                                onRendered: function() {
                                    _this.updateLabelPosition();
                                    _this._templateDef.resolve()
                                }
                            })
                        } else {
                            if ((0, _type.isDefined)(text) && "" !== text && !emptyStrRegExp.test(text)) {
                                this.label = renderer.text(text).css(getLabelFontStyle(this)).attr(labelStyle).append(elementsGroup);
                                this.updateLabelPosition();
                                createLabelHint(this, range)
                            }
                        }
                        var containerForData = this.getContentContainer();
                        containerForData && containerForData.data("chart-data-argument", this.value);
                        this.templateContainer && createLabelHint(this, range)
                    },
                    getTemplateDeferred: function() {
                        return this._templateDef
                    },
                    getContentContainer: function() {
                        return this.templateContainer || this.label
                    },
                    fadeOutElements: function() {
                        var startSettings = {
                            opacity: 1
                        };
                        var endSettings = {
                            opacity: 0
                        };
                        var animationSettings = {
                            partitionDuration: .5
                        };
                        if (this.getContentContainer()) {
                            this._fadeOutLabel()
                        }
                        if (this.grid) {
                            this.grid.append(axis._axisGridGroup).attr(startSettings).animate(endSettings, animationSettings)
                        }
                        if (this.mark) {
                            this.mark.append(axis._axisLineGroup).attr(startSettings).animate(endSettings, animationSettings)
                        }
                    },
                    _fadeInLabel: function() {
                        var group = axis._renderer.g().attr({
                            opacity: 0
                        }).append(axis._axisElementsGroup).animate({
                            opacity: 1
                        }, {
                            delay: .5,
                            partitionDuration: .5
                        });
                        this.getContentContainer().append(group)
                    },
                    _fadeOutLabel: function() {
                        var group = axis._renderer.g().attr({
                            opacity: 1
                        }).animate({
                            opacity: 0
                        }, {
                            partitionDuration: .5
                        }).append(axis._axisElementsGroup).toBackground();
                        this.getContentContainer().append(group)
                    },
                    _getTemplateCoords: function() {
                        return axis._getLabelAdjustedCoord(this, (axis._constantLabelOffset || 0) + (tick.labelOffset || 0))
                    },
                    updateLabelPosition: function(animate) {
                        var templateContainer = this.templateContainer;
                        if (!this.getContentContainer()) {
                            return
                        }
                        if (animate && this._storedLabelsCoords) {
                            if (templateContainer) {
                                templateContainer.attr(this._storedLabelsCoords);
                                var lCoords = this._getTemplateCoords();
                                templateContainer.animate(lCoords)
                            } else {
                                this.label.attr({
                                    x: this._storedLabelsCoords.x,
                                    y: this._storedLabelsCoords.y
                                });
                                this.label.animate({
                                    x: this.labelCoords.x,
                                    y: this.labelCoords.y
                                })
                            }
                        } else {
                            if (templateContainer) {
                                var _lCoords = this._getTemplateCoords();
                                templateContainer.attr(_lCoords)
                            } else {
                                this.label.attr({
                                    x: this.labelCoords.x,
                                    y: this.labelCoords.y
                                })
                            }
                            if (animate) {
                                this._fadeInLabel()
                            }
                        }
                    },
                    updateMultilineTextAlignment: function() {
                        if (labelOptions.template || !this.label) {
                            return
                        }
                        this.label.attr({
                            textsAlignment: this.labelAlignment || axis.getOptions().label.alignment
                        })
                    },
                    drawGrid: function(drawLine) {
                        if (gridOptions.visible && skippedCategory !== this.value) {
                            if (this.grid) {
                                this.grid.append(axis._axisGridGroup);
                                axis.sharp(this.grid, axis.getSharpDirectionByCoords(this.coords));
                                this.updateGridPosition()
                            } else {
                                this.grid = drawLine(this, gridStyle);
                                this.grid && this.grid.append(axis._axisGridGroup)
                            }
                        }
                    },
                    updateGridPosition: function(animate) {
                        this._updateLine(this.grid, axis._getGridPoints(tick.coords), this._storedCoords && axis._getGridPoints(this._storedCoords), animate, true)
                    },
                    removeLabel: function() {
                        var contentContainer = this.getContentContainer();
                        contentContainer && contentContainer.remove();
                        this._templateDef && this._templateDef.reject();
                        this._templateDef = this.templateContainer = this.label = null
                    }
                };
                return tick
            }
        }
    },
    /*!******************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/axes/xy_axes.js ***!
      \******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _range = __webpack_require__( /*! ../translators/range */ 124);
        var _format_helper = _interopRequireDefault(__webpack_require__( /*! ../../format_helper */ 71));
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _datetime_breaks = __webpack_require__( /*! ./datetime_breaks */ 934);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _axes_constants = _interopRequireDefault(__webpack_require__( /*! ./axes_constants */ 317));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var getNextDateUnit = _date.default.getNextDateUnit;
        var correctDateWithUnitBeginning = _date.default.correctDateWithUnitBeginning;
        var _math = Math;
        var _max = _math.max;
        var TOP = _axes_constants.default.top;
        var BOTTOM = _axes_constants.default.bottom;
        var LEFT = _axes_constants.default.left;
        var RIGHT = _axes_constants.default.right;
        var CENTER = _axes_constants.default.center;
        var SCALE_BREAK_OFFSET = 3;
        var RANGE_RATIO = .3;
        var WAVED_LINE_CENTER = 2;
        var WAVED_LINE_TOP = 0;
        var WAVED_LINE_BOTTOM = 4;
        var WAVED_LINE_LENGTH = 24;
        var TICKS_CORRECTIONS = {
            left: -1,
            top: -1,
            right: 0,
            bottom: 0,
            center: -.5
        };

        function prepareDatesDifferences(datesDifferences, tickInterval) {
            var dateUnitInterval;
            var i;
            if ("week" === tickInterval) {
                tickInterval = "day"
            }
            if ("quarter" === tickInterval) {
                tickInterval = "month"
            }
            if (datesDifferences[tickInterval]) {
                for (i = 0; i < _date.default.dateUnitIntervals.length; i++) {
                    dateUnitInterval = _date.default.dateUnitIntervals[i];
                    if (datesDifferences[dateUnitInterval]) {
                        datesDifferences[dateUnitInterval] = false;
                        datesDifferences.count--
                    }
                    if (dateUnitInterval === tickInterval) {
                        break
                    }
                }
            }
        }

        function sortingBreaks(breaks) {
            return breaks.sort(function(a, b) {
                return a.from - b.from
            })
        }

        function getMarkerDates(min, max, markerInterval) {
            var origMin = min;
            var dates;
            min = correctDateWithUnitBeginning(min, markerInterval);
            max = correctDateWithUnitBeginning(max, markerInterval);
            dates = _date.default.getSequenceByInterval(min, max, markerInterval);
            if (dates.length && origMin > dates[0]) {
                dates = dates.slice(1)
            }
            return dates
        }

        function getStripHorizontalAlignmentPosition(alignment) {
            var position = "start";
            if ("center" === alignment) {
                position = "center"
            }
            if ("right" === alignment) {
                position = "end"
            }
            return position
        }

        function getStripVerticalAlignmentPosition(alignment) {
            var position = "start";
            if ("center" === alignment) {
                position = "center"
            }
            if ("bottom" === alignment) {
                position = "end"
            }
            return position
        }

        function getMarkerInterval(tickInterval) {
            var markerInterval = getNextDateUnit(tickInterval);
            if ("quarter" === markerInterval) {
                markerInterval = getNextDateUnit(markerInterval)
            }
            return markerInterval
        }

        function getMarkerFormat(curDate, prevDate, tickInterval, markerInterval) {
            var format = markerInterval;
            var datesDifferences = prevDate && _date.default.getDatesDifferences(prevDate, curDate);
            if (prevDate && "year" !== tickInterval) {
                prepareDatesDifferences(datesDifferences, tickInterval);
                format = _format_helper.default.getDateFormatByDifferences(datesDifferences)
            }
            return format
        }

        function getMaxSide(act, boxes) {
            return boxes.reduce(function(prevValue, box) {
                return _max(prevValue, act(box))
            }, 0)
        }

        function getDistanceByAngle(bBox, rotationAngle) {
            rotationAngle = _math.abs(rotationAngle);
            rotationAngle = rotationAngle % 180 >= 90 ? 90 - rotationAngle % 90 : rotationAngle % 90;
            var a = rotationAngle * (_math.PI / 180);
            if (a >= _math.atan(bBox.height / bBox.width)) {
                return bBox.height / _math.abs(_math.sin(a))
            } else {
                return bBox.width
            }
        }

        function getMaxConstantLinePadding(constantLines) {
            return constantLines.reduce(function(padding, options) {
                return _max(padding, options.paddingTopBottom)
            }, 0)
        }

        function getConstantLineLabelMarginForVerticalAlignment(constantLines, alignment, labelHeight) {
            return constantLines.some(function(options) {
                return options.label.verticalAlignment === alignment
            }) && labelHeight || 0
        }

        function getLeftMargin(bBox) {
            return _math.abs(bBox.x) || 0
        }

        function getRightMargin(bBox) {
            return _math.abs(bBox.width - _math.abs(bBox.x)) || 0
        }

        function generateRangesOnPoints(points, edgePoints, getRange) {
            var i;
            var length;
            var maxRange = null;
            var ranges = [];
            var curValue;
            var prevValue;
            var curRange;
            for (i = 1, length = points.length; i < length; i++) {
                curValue = points[i];
                prevValue = points[i - 1];
                curRange = getRange(curValue, prevValue);
                if (edgePoints.indexOf(curValue) >= 0) {
                    if (!maxRange || curRange > maxRange.length) {
                        maxRange = {
                            start: curValue,
                            end: prevValue,
                            length: curRange
                        }
                    }
                } else {
                    if (maxRange && curRange < maxRange.length) {
                        ranges.push(maxRange)
                    } else {
                        ranges.push({
                            start: curValue,
                            end: prevValue,
                            length: curRange
                        })
                    }
                    maxRange = null
                }
            }
            if (maxRange) {
                ranges.push(maxRange)
            }
            return ranges
        }

        function generateAutoBreaks(_ref, series, _ref2) {
            var logarithmBase = _ref.logarithmBase,
                type = _ref.type,
                maxAutoBreakCount = _ref.maxAutoBreakCount;
            var minVisible = _ref2.minVisible,
                maxVisible = _ref2.maxVisible;
            var breaks = [];
            var getRange = "logarithmic" === type ? function(min, max) {
                return (0, _utils.getLog)(max / min, logarithmBase)
            } : function(min, max) {
                return max - min
            };
            var visibleRange = getRange(minVisible, maxVisible);
            var points = series.reduce(function(result, s) {
                var points = s.getPointsInViewPort();
                result[0] = result[0].concat(points[0]);
                result[1] = result[1].concat(points[1]);
                return result
            }, [
                [],
                []
            ]);
            var sortedAllPoints = points[0].concat(points[1]).sort(function(a, b) {
                return b - a
            });
            var edgePoints = points[1].filter(function(p) {
                return points[0].indexOf(p) < 0
            });
            var minDiff = RANGE_RATIO * visibleRange;
            var ranges = generateRangesOnPoints(sortedAllPoints, edgePoints, getRange).sort(function(a, b) {
                return b.length - a.length
            });
            var epsilon = _math.min.apply(null, ranges.map(function(r) {
                return r.length
            })) / 1e3;
            var _maxAutoBreakCount = (0, _type.isDefined)(maxAutoBreakCount) ? _math.min(maxAutoBreakCount, ranges.length) : ranges.length;
            for (var i = 0; i < _maxAutoBreakCount; i++) {
                if (ranges[i].length >= minDiff) {
                    if (visibleRange <= ranges[i].length) {
                        break
                    }
                    visibleRange -= ranges[i].length;
                    if (visibleRange > epsilon || visibleRange < -epsilon) {
                        breaks.push({
                            from: ranges[i].start,
                            to: ranges[i].end
                        });
                        minDiff = RANGE_RATIO * visibleRange
                    }
                } else {
                    break
                }
            }
            sortingBreaks(breaks);
            return breaks
        }
        var _default = {
            linear: {
                _getStep: function(boxes, rotationAngle) {
                    var spacing = this._options.label.minSpacing;
                    var func = this._isHorizontal ? function(box) {
                        return box.width + spacing
                    } : function(box) {
                        return box.height
                    };
                    var maxLabelLength = getMaxSide(func, boxes);
                    if (rotationAngle) {
                        maxLabelLength = getDistanceByAngle({
                            width: maxLabelLength,
                            height: this._getMaxLabelHeight(boxes, 0)
                        }, rotationAngle)
                    }
                    return _axes_constants.default.getTicksCountInRange(this._majorTicks, this._isHorizontal ? "x" : "y", maxLabelLength)
                },
                _getMaxLabelHeight: function(boxes, spacing) {
                    return getMaxSide(function(box) {
                        return box.height
                    }, boxes) + spacing
                },
                _validateOverlappingMode: function(mode, displayMode) {
                    if (this._isHorizontal && ("rotate" === displayMode || "stagger" === displayMode) || !this._isHorizontal) {
                        return _axes_constants.default.validateOverlappingMode(mode)
                    }
                    return mode
                },
                _validateDisplayMode: function(mode) {
                    return this._isHorizontal ? mode : "standard"
                },
                getMarkerTrackers: function() {
                    return this._markerTrackers
                },
                _getSharpParam: function(opposite) {
                    return this._isHorizontal ^ opposite ? "h" : "v"
                },
                _createAxisElement: function() {
                    return this._renderer.path([], "line")
                },
                _updateAxisElementPosition: function() {
                    var axisCoord = this._axisPosition;
                    var canvas = this._getCanvasStartEnd();
                    this._axisElement.attr({
                        points: this._isHorizontal ? [canvas.start, axisCoord, canvas.end, axisCoord] : [axisCoord, canvas.start, axisCoord, canvas.end]
                    })
                },
                _getTranslatedCoord: function(value, offset) {
                    return this._translator.translate(value, offset)
                },
                _initAxisPositions: function() {
                    var that = this;
                    if (that.customPositionIsAvailable()) {
                        that._customBoundaryPosition = that.getCustomBoundaryPosition()
                    }
                    if (!that.customPositionIsAvailable() || that.customPositionIsBoundary()) {
                        that._axisPosition = that.getPredefinedPosition(that.getResolvedBoundaryPosition())
                    } else {
                        that._axisPosition = that.getCustomPosition()
                    }
                },
                _getTickMarkPoints: function(coords, length, tickOptions) {
                    var isHorizontal = this._isHorizontal;
                    var tickOrientation = this._options.tickOrientation;
                    var labelPosition = this._options.label.position;
                    var tickStartCoord;
                    if ((0, _type.isDefined)(tickOrientation)) {
                        tickStartCoord = TICKS_CORRECTIONS[tickOrientation] * length
                    } else {
                        var shift = tickOptions.shift || 0;
                        if (!isHorizontal && labelPosition === LEFT || isHorizontal && labelPosition !== BOTTOM) {
                            shift = -shift
                        }
                        tickStartCoord = shift + this.getTickStartPositionShift(length)
                    }
                    return [coords.x + (isHorizontal ? 0 : tickStartCoord), coords.y + (isHorizontal ? tickStartCoord : 0), coords.x + (isHorizontal ? 0 : tickStartCoord + length), coords.y + (isHorizontal ? tickStartCoord + length : 0)]
                },
                getTickStartPositionShift: function(length) {
                    var width = this._options.width;
                    var position = this.getResolvedBoundaryPosition();
                    return length % 2 === 1 ? width % 2 === 0 && (position === LEFT || position === TOP) || width % 2 === 1 && (position === RIGHT || position === BOTTOM) && !this.hasNonBoundaryPosition() ? Math.floor(-length / 2) : -Math.floor(length / 2) : -length / 2 + (width % 2 === 0 ? 0 : position === BOTTOM || position === RIGHT ? -1 : 1)
                },
                _getTitleCoords: function() {
                    var that = this;
                    var horizontal = that._isHorizontal;
                    var x = that._axisPosition;
                    var y = that._axisPosition;
                    var align = that._options.title.alignment;
                    var canvas = that._getCanvasStartEnd();
                    var fromStartToEnd = horizontal || that._options.position === LEFT;
                    var canvasStart = fromStartToEnd ? canvas.start : canvas.end;
                    var canvasEnd = fromStartToEnd ? canvas.end : canvas.start;
                    var coord = align === LEFT ? canvasStart : align === RIGHT ? canvasEnd : canvas.start + (canvas.end - canvas.start) / 2;
                    if (horizontal) {
                        x = coord
                    } else {
                        y = coord
                    }
                    return {
                        x: x,
                        y: y
                    }
                },
                _drawTitleText: function(group, coords) {
                    var options = this._options;
                    var titleOptions = options.title;
                    var attrs = {
                        opacity: titleOptions.opacity,
                        align: titleOptions.alignment,
                        "class": titleOptions.cssClass
                    };
                    if (!titleOptions.text || !group) {
                        return
                    }
                    coords = coords || this._getTitleCoords();
                    if (!this._isHorizontal) {
                        attrs.rotate = options.position === LEFT ? 270 : 90
                    }
                    var text = this._renderer.text(titleOptions.text, coords.x, coords.y).css((0, _utils.patchFontOptions)(titleOptions.font)).attr(attrs).append(group);
                    this._checkTitleOverflow(text);
                    return text
                },
                _updateTitleCoords: function() {
                    this._title && this._title.element.attr(this._getTitleCoords())
                },
                _drawTitle: function() {
                    var title = this._drawTitleText(this._axisTitleGroup);
                    if (title) {
                        this._title = {
                            element: title
                        }
                    }
                },
                _measureTitle: function() {
                    if (this._title) {
                        if (this._title.bBox && !this._title.originalSize) {
                            this._title.originalSize = this._title.bBox
                        }
                        this._title.bBox = this._title.element.getBBox()
                    }
                },
                _drawDateMarker: function(date, options, range) {
                    var that = this;
                    var markerOptions = that._options.marker;
                    var invert = that._translator.getBusinessRange().invert;
                    var textIndent = markerOptions.width + markerOptions.textLeftIndent;
                    var pathElement;
                    if (null === options.x) {
                        return
                    }
                    if (!options.withoutStick) {
                        pathElement = that._renderer.path([options.x, options.y, options.x, options.y + markerOptions.separatorHeight], "line").attr({
                            "stroke-width": markerOptions.width,
                            stroke: markerOptions.color,
                            "stroke-opacity": markerOptions.opacity,
                            sharp: "h"
                        }).append(that._axisElementsGroup)
                    }
                    var text = String(that.formatLabel(date, options.labelOptions, range));
                    return {
                        date: date,
                        x: options.x,
                        y: options.y,
                        cropped: options.withoutStick,
                        label: that._renderer.text(text, options.x, options.y).css((0, _utils.patchFontOptions)(markerOptions.label.font)).append(that._axisElementsGroup),
                        line: pathElement,
                        getContentContainer: function() {
                            return this.label
                        },
                        getEnd: function() {
                            return this.x + (invert ? -1 : 1) * (textIndent + this.labelBBox.width)
                        },
                        setTitle: function() {
                            this.title = text
                        },
                        hideLabel: function() {
                            this.label.dispose();
                            this.label = null;
                            this.title = text
                        },
                        hide: function() {
                            if (pathElement) {
                                pathElement.dispose();
                                pathElement = null
                            }
                            this.label.dispose();
                            this.label = null;
                            this.hidden = true
                        }
                    }
                },
                _drawDateMarkers: function() {
                    var that = this;
                    var options = that._options;
                    var translator = that._translator;
                    var viewport = that._getViewportRange();
                    var minBound = viewport.minVisible;
                    var dateMarkers = [];
                    var dateMarker;

                    function draw(markerDate, format, withoutStick) {
                        return that._drawDateMarker(markerDate, {
                            x: translator.translate(markerDate),
                            y: markersAreaTop,
                            labelOptions: that._getLabelFormatOptions(format),
                            withoutStick: withoutStick
                        }, viewport)
                    }
                    if (viewport.isEmpty() || !options.marker.visible || "datetime" !== options.argumentType || "discrete" === options.type || that._majorTicks.length <= 1) {
                        return []
                    }
                    var markersAreaTop = that._axisPosition + options.marker.topIndent;
                    var tickInterval = _date.default.getDateUnitInterval(this._tickInterval);
                    var markerInterval = getMarkerInterval(tickInterval);
                    var markerDates = getMarkerDates(minBound, viewport.maxVisible, markerInterval);
                    if (markerDates.length > 1 || 1 === markerDates.length && minBound < markerDates[0]) {
                        dateMarkers = markerDates.reduce(function(markers, curDate, i, dates) {
                            var marker = draw(curDate, getMarkerFormat(curDate, dates[i - 1] || minBound < curDate && minBound, tickInterval, markerInterval));
                            marker && markers.push(marker);
                            return markers
                        }, []);
                        if (minBound < markerDates[0]) {
                            dateMarker = draw(minBound, getMarkerFormat(minBound, markerDates[0], tickInterval, markerInterval), true);
                            dateMarker && dateMarkers.unshift(dateMarker)
                        }
                    }
                    return dateMarkers
                },
                _adjustDateMarkers: function(offset) {
                    offset = offset || 0;
                    var that = this;
                    var markerOptions = this._options.marker;
                    var textIndent = markerOptions.width + markerOptions.textLeftIndent;
                    var invert = this._translator.getBusinessRange().invert;
                    var canvas = that._getCanvasStartEnd();
                    var dateMarkers = this._dateMarkers;
                    if (!dateMarkers.length) {
                        return offset
                    }
                    if (dateMarkers[0].cropped) {
                        if (!this._checkMarkersPosition(invert, dateMarkers[1], dateMarkers[0])) {
                            dateMarkers[0].hideLabel()
                        }
                    }
                    var prevDateMarker;
                    dateMarkers.forEach(function(marker, i, markers) {
                        if (marker.cropped) {
                            return
                        }
                        if (invert ? marker.getEnd() < canvas.end : marker.getEnd() > canvas.end) {
                            marker.hideLabel()
                        } else {
                            if (that._checkMarkersPosition(invert, marker, prevDateMarker)) {
                                prevDateMarker = marker
                            } else {
                                marker.hide()
                            }
                        }
                    });
                    this._dateMarkers.forEach(function(marker) {
                        if (marker.label) {
                            var labelBBox = marker.labelBBox;
                            var dy = marker.y + markerOptions.textTopIndent - labelBBox.y;
                            marker.label.attr({
                                translateX: invert ? marker.x - textIndent - labelBBox.x - labelBBox.width : marker.x + textIndent - labelBBox.x,
                                translateY: dy + offset
                            })
                        }
                        if (marker.line) {
                            marker.line.attr({
                                translateY: offset
                            })
                        }
                    });
                    that._initializeMarkersTrackers(offset);
                    return offset + markerOptions.topIndent + markerOptions.separatorHeight
                },
                _checkMarkersPosition: function(invert, dateMarker, prevDateMarker) {
                    if (void 0 === prevDateMarker) {
                        return true
                    }
                    return invert ? dateMarker.x < prevDateMarker.getEnd() : dateMarker.x > prevDateMarker.getEnd()
                },
                _initializeMarkersTrackers: function(offset) {
                    var that = this;
                    var separatorHeight = that._options.marker.separatorHeight;
                    var renderer = that._renderer;
                    var businessRange = this._translator.getBusinessRange();
                    var canvas = that._getCanvasStartEnd();
                    var group = that._axisElementsGroup;
                    that._markerTrackers = this._dateMarkers.filter(function(marker) {
                        return !marker.hidden
                    }).map(function(marker, i, markers) {
                        var nextMarker = markers[i + 1] || {
                            x: canvas.end,
                            date: businessRange.max
                        };
                        var x = marker.x;
                        var y = marker.y + offset;
                        var markerTracker = renderer.path([x, y, x, y + separatorHeight, nextMarker.x, y + separatorHeight, nextMarker.x, y, x, y], "area").attr({
                            "stroke-width": 1,
                            stroke: "grey",
                            fill: "grey",
                            opacity: 1e-4
                        }).append(group);
                        markerTracker.data("range", {
                            startValue: marker.date,
                            endValue: nextMarker.date
                        });
                        if (marker.title) {
                            markerTracker.setTitle(marker.title)
                        }
                        return markerTracker
                    })
                },
                _getLabelFormatOptions: function(formatString) {
                    var that = this;
                    var markerLabelOptions = that._markerLabelOptions;
                    if (!markerLabelOptions) {
                        that._markerLabelOptions = markerLabelOptions = (0, _extend.extend)(true, {}, that._options.marker.label)
                    }
                    if (!(0, _type.isDefined)(that._options.marker.label.format)) {
                        markerLabelOptions.format = formatString
                    }
                    return markerLabelOptions
                },
                _adjustConstantLineLabels: function(constantLines) {
                    var that = this;
                    var axisPosition = that._options.position;
                    var canvas = that.getCanvas();
                    var canvasLeft = canvas.left;
                    var canvasRight = canvas.width - canvas.right;
                    var canvasTop = canvas.top;
                    var canvasBottom = canvas.height - canvas.bottom;
                    var verticalCenter = canvasTop + (canvasBottom - canvasTop) / 2;
                    var horizontalCenter = canvasLeft + (canvasRight - canvasLeft) / 2;
                    var maxLabel = 0;
                    constantLines.forEach(function(item) {
                        var isHorizontal = that._isHorizontal;
                        var linesOptions = item.options;
                        var paddingTopBottom = linesOptions.paddingTopBottom;
                        var paddingLeftRight = linesOptions.paddingLeftRight;
                        var labelOptions = linesOptions.label;
                        var labelVerticalAlignment = labelOptions.verticalAlignment;
                        var labelHorizontalAlignment = labelOptions.horizontalAlignment;
                        var labelIsInside = "inside" === labelOptions.position;
                        var label = item.label;
                        var box = item.labelBBox;
                        var translateX;
                        var translateY;
                        if (null === label || box.isEmpty) {
                            return
                        }
                        if (isHorizontal) {
                            if (labelIsInside) {
                                if (labelHorizontalAlignment === LEFT) {
                                    translateX = item.coord - paddingLeftRight - box.x - box.width
                                } else {
                                    translateX = item.coord + paddingLeftRight - box.x
                                }
                                switch (labelVerticalAlignment) {
                                    case CENTER:
                                        translateY = verticalCenter - box.y - box.height / 2;
                                        break;
                                    case BOTTOM:
                                        translateY = canvasBottom - paddingTopBottom - box.y - box.height;
                                        break;
                                    default:
                                        translateY = canvasTop + paddingTopBottom - box.y
                                }
                            } else {
                                if (axisPosition === labelVerticalAlignment) {
                                    maxLabel = _max(maxLabel, box.height + paddingTopBottom)
                                }
                                translateX = item.coord - box.x - box.width / 2;
                                if (labelVerticalAlignment === BOTTOM) {
                                    translateY = canvasBottom + paddingTopBottom - box.y
                                } else {
                                    translateY = canvasTop - paddingTopBottom - box.y - box.height
                                }
                            }
                        } else {
                            if (labelIsInside) {
                                if (labelVerticalAlignment === BOTTOM) {
                                    translateY = item.coord + paddingTopBottom - box.y
                                } else {
                                    translateY = item.coord - paddingTopBottom - box.y - box.height
                                }
                                switch (labelHorizontalAlignment) {
                                    case CENTER:
                                        translateX = horizontalCenter - box.x - box.width / 2;
                                        break;
                                    case RIGHT:
                                        translateX = canvasRight - paddingLeftRight - box.x - box.width;
                                        break;
                                    default:
                                        translateX = canvasLeft + paddingLeftRight - box.x
                                }
                            } else {
                                if (axisPosition === labelHorizontalAlignment) {
                                    maxLabel = _max(maxLabel, box.width + paddingLeftRight)
                                }
                                translateY = item.coord - box.y - box.height / 2;
                                if (labelHorizontalAlignment === RIGHT) {
                                    translateX = canvasRight + paddingLeftRight - box.x
                                } else {
                                    translateX = canvasLeft - paddingLeftRight - box.x - box.width
                                }
                            }
                        }
                        label.attr({
                            translateX: translateX,
                            translateY: translateY
                        })
                    });
                    return maxLabel
                },
                _drawConstantLinesForEstimating: function(constantLines) {
                    var that = this;
                    var renderer = this._renderer;
                    var group = renderer.g();
                    constantLines.forEach(function(options) {
                        that._drawConstantLineLabelText(options.label.text, 0, 0, options.label, group).attr({
                            align: "center"
                        })
                    });
                    return group.append(renderer.root)
                },
                _estimateLabelHeight: function(bBox, labelOptions) {
                    var height = bBox.height;
                    var drawingType = labelOptions.drawingType;
                    if ("stagger" === this._validateDisplayMode(drawingType) || "stagger" === this._validateOverlappingMode(labelOptions.overlappingBehavior, drawingType)) {
                        height = 2 * height + labelOptions.staggeringSpacing
                    }
                    if ("rotate" === this._validateDisplayMode(drawingType) || "rotate" === this._validateOverlappingMode(labelOptions.overlappingBehavior, drawingType)) {
                        var sinCos = (0, _utils.getCosAndSin)(labelOptions.rotationAngle);
                        height = height * sinCos.cos + bBox.width * sinCos.sin
                    }
                    return height && (height + labelOptions.indentFromAxis || 0) || 0
                },
                estimateMargins: function(canvas) {
                    this.updateCanvas(canvas);
                    var that = this;
                    var range = that._getViewportRange();
                    var ticksData = this._createTicksAndLabelFormat(range);
                    var ticks = ticksData.ticks;
                    var tickInterval = ticksData.tickInterval;
                    var options = this._options;
                    var constantLineOptions = that._outsideConstantLines.filter(function(l) {
                        return l.labelOptions.visible
                    }).map(function(l) {
                        return l.options
                    });
                    var rootElement = that._renderer.root;
                    var labelIsVisible = options.label.visible && !range.isEmpty() && ticks.length;
                    var labelValue = labelIsVisible && that.formatLabel(ticks[ticks.length - 1], options.label, void 0, void 0, tickInterval, ticks);
                    var labelElement = labelIsVisible && that._renderer.text(labelValue, 0, 0).css(that._textFontStyles).attr(that._textOptions).append(rootElement);
                    var titleElement = that._drawTitleText(rootElement, {
                        x: 0,
                        y: 0
                    });
                    var constantLinesLabelsElement = that._drawConstantLinesForEstimating(constantLineOptions);
                    var labelBox = !options.label.template && labelElement && labelElement.getBBox() || {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                    var titleBox = titleElement && titleElement.getBBox() || {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                    var constantLinesBox = constantLinesLabelsElement.getBBox();
                    var titleHeight = titleBox.height ? titleBox.height + options.title.margin : 0;
                    var labelHeight = that._estimateLabelHeight(labelBox, options.label);
                    var constantLinesHeight = constantLinesBox.height ? constantLinesBox.height + getMaxConstantLinePadding(constantLineOptions) : 0;
                    var height = labelHeight + titleHeight;
                    var margins = {
                        left: _max(getLeftMargin(labelBox), getLeftMargin(constantLinesBox)),
                        right: _max(getRightMargin(labelBox), getRightMargin(constantLinesBox)),
                        top: ("top" === options.position ? height : 0) + getConstantLineLabelMarginForVerticalAlignment(constantLineOptions, "top", constantLinesHeight),
                        bottom: ("top" !== options.position ? height : 0) + getConstantLineLabelMarginForVerticalAlignment(constantLineOptions, "bottom", constantLinesHeight)
                    };
                    labelElement && labelElement.remove();
                    titleElement && titleElement.remove();
                    constantLinesLabelsElement && constantLinesLabelsElement.remove();
                    return margins
                },
                _checkAlignmentConstantLineLabels: function(labelOptions) {
                    var position = labelOptions.position;
                    var verticalAlignment = (labelOptions.verticalAlignment || "").toLowerCase();
                    var horizontalAlignment = (labelOptions.horizontalAlignment || "").toLowerCase();
                    if (this._isHorizontal) {
                        if ("outside" === position) {
                            verticalAlignment = verticalAlignment === BOTTOM ? BOTTOM : TOP;
                            horizontalAlignment = CENTER
                        } else {
                            verticalAlignment = verticalAlignment === CENTER ? CENTER : verticalAlignment === BOTTOM ? BOTTOM : TOP;
                            horizontalAlignment = horizontalAlignment === LEFT ? LEFT : RIGHT
                        }
                    } else {
                        if ("outside" === position) {
                            verticalAlignment = CENTER;
                            horizontalAlignment = horizontalAlignment === LEFT ? LEFT : RIGHT
                        } else {
                            verticalAlignment = verticalAlignment === BOTTOM ? BOTTOM : TOP;
                            horizontalAlignment = horizontalAlignment === RIGHT ? RIGHT : horizontalAlignment === CENTER ? CENTER : LEFT
                        }
                    }
                    labelOptions.verticalAlignment = verticalAlignment;
                    labelOptions.horizontalAlignment = horizontalAlignment
                },
                _getConstantLineLabelsCoords: function(value, lineLabelOptions) {
                    var that = this;
                    var x = value;
                    var y = value;
                    if (that._isHorizontal) {
                        y = that._orthogonalPositions["top" === lineLabelOptions.verticalAlignment ? "start" : "end"]
                    } else {
                        x = that._orthogonalPositions["right" === lineLabelOptions.horizontalAlignment ? "end" : "start"]
                    }
                    return {
                        x: x,
                        y: y
                    }
                },
                _getAdjustedStripLabelCoords: function(strip) {
                    var stripOptions = strip.options;
                    var paddingTopBottom = stripOptions.paddingTopBottom;
                    var paddingLeftRight = stripOptions.paddingLeftRight;
                    var horizontalAlignment = stripOptions.label.horizontalAlignment;
                    var verticalAlignment = stripOptions.label.verticalAlignment;
                    var box = strip.labelBBox;
                    var labelHeight = box.height;
                    var labelWidth = box.width;
                    var labelCoords = strip.labelCoords;
                    var y = labelCoords.y - box.y;
                    var x = labelCoords.x - box.x;
                    if (verticalAlignment === TOP) {
                        y += paddingTopBottom
                    } else {
                        if (verticalAlignment === CENTER) {
                            y -= labelHeight / 2
                        } else {
                            if (verticalAlignment === BOTTOM) {
                                y -= paddingTopBottom + labelHeight
                            }
                        }
                    }
                    if (horizontalAlignment === LEFT) {
                        x += paddingLeftRight
                    } else {
                        if (horizontalAlignment === CENTER) {
                            x -= labelWidth / 2
                        } else {
                            if (horizontalAlignment === RIGHT) {
                                x -= paddingLeftRight + labelWidth
                            }
                        }
                    }
                    return {
                        translateX: x,
                        translateY: y
                    }
                },
                _adjustTitle: function(offset) {
                    offset = offset || 0;
                    if (!this._title) {
                        return
                    }
                    var that = this;
                    var options = that._options;
                    var position = options.position;
                    var margin = options.title.margin;
                    var title = that._title;
                    var boxTitle = title.bBox;
                    var x = boxTitle.x;
                    var y = boxTitle.y;
                    var width = boxTitle.width;
                    var height = boxTitle.height;
                    var axisPosition = that._axisPosition;
                    var loCoord = axisPosition - margin - offset;
                    var hiCoord = axisPosition + margin + offset;
                    var params = {};
                    if (that._isHorizontal) {
                        if (position === TOP) {
                            params.translateY = loCoord - (y + height)
                        } else {
                            params.translateY = hiCoord - y
                        }
                    } else {
                        if (position === LEFT) {
                            params.translateX = loCoord - (x + width)
                        } else {
                            params.translateX = hiCoord - x
                        }
                    }
                    title.element.attr(params)
                },
                _checkTitleOverflow: function(titleElement) {
                    if (!this._title && !titleElement) {
                        return
                    }
                    var canvasLength = this._getScreenDelta();
                    var title = titleElement ? {
                        bBox: titleElement.getBBox(),
                        element: titleElement
                    } : this._title;
                    var titleOptions = this._options.title;
                    var boxTitle = title.bBox;
                    if ((this._isHorizontal ? boxTitle.width : boxTitle.height) > canvasLength) {
                        title.element.setMaxSize(canvasLength, void 0, {
                            wordWrap: titleOptions.wordWrap || "none",
                            textOverflow: titleOptions.textOverflow || "ellipsis"
                        });
                        this._wrapped = titleOptions.wordWrap && "none" !== titleOptions.wordWrap
                    } else {
                        var moreThanOriginalSize = title.originalSize && canvasLength > (this._isHorizontal ? title.originalSize.width : title.originalSize.height);
                        !this._wrapped && moreThanOriginalSize && title.element.restoreText()
                    }
                },
                coordsIn: function(x, y) {
                    var canvas = this.getCanvas();
                    var isHorizontal = this._options.isHorizontal;
                    var position = this._options.position;
                    var coord = isHorizontal ? y : x;
                    if (isHorizontal && (x < canvas.left || x > canvas.width - canvas.right) || !isHorizontal && (y < canvas.top || y > canvas.height - canvas.bottom)) {
                        return false
                    }
                    if (isHorizontal && position === _axes_constants.default.top || !isHorizontal && position === _axes_constants.default.left) {
                        return coord < canvas[position]
                    }
                    return coord > canvas[isHorizontal ? "height" : "width"] - canvas[position]
                },
                _boundaryTicksVisibility: {
                    min: true,
                    max: true
                },
                adjust: function(alignToBounds) {
                    var that = this;
                    var seriesData = that._seriesData;
                    var viewport = {
                        min: seriesData.min,
                        max: seriesData.max
                    };
                    if (!alignToBounds) {
                        viewport = that._series.filter(function(s) {
                            return s.isVisible()
                        }).reduce(function(range, s) {
                            var seriesRange = s.getViewport();
                            range.min = (0, _type.isDefined)(seriesRange.min) ? range.min < seriesRange.min ? range.min : seriesRange.min : range.min;
                            range.max = (0, _type.isDefined)(seriesRange.max) ? range.max > seriesRange.max ? range.max : seriesRange.max : range.max;
                            if (s.showZero) {
                                range = new _range.Range(range);
                                range.correctValueZeroLevel()
                            }
                            return range
                        }, {})
                    }
                    if ((0, _type.isDefined)(viewport.min) && (0, _type.isDefined)(viewport.max)) {
                        seriesData.minVisible = viewport.min;
                        seriesData.maxVisible = viewport.max
                    }
                    seriesData.userBreaks = that._getScaleBreaks(that._options, {
                        minVisible: seriesData.minVisible,
                        maxVisible: seriesData.maxVisible
                    }, that._series, that.isArgumentAxis);
                    that._translator.updateBusinessRange(that._getViewportRange())
                },
                hasWrap: function() {
                    return this._wrapped
                },
                getAxisPosition: function() {
                    return this._axisPosition
                },
                _getStick: function() {
                    return !this._options.valueMarginsEnabled
                },
                _getStripLabelCoords: function(from, to, stripLabelOptions) {
                    var that = this;
                    var orthogonalPositions = that._orthogonalPositions;
                    var isHorizontal = that._isHorizontal;
                    var horizontalAlignment = stripLabelOptions.horizontalAlignment;
                    var verticalAlignment = stripLabelOptions.verticalAlignment;
                    var x;
                    var y;
                    if (isHorizontal) {
                        if (horizontalAlignment === CENTER) {
                            x = from + (to - from) / 2
                        } else {
                            if (horizontalAlignment === LEFT) {
                                x = from
                            } else {
                                if (horizontalAlignment === RIGHT) {
                                    x = to
                                }
                            }
                        }
                        y = orthogonalPositions[getStripVerticalAlignmentPosition(verticalAlignment)]
                    } else {
                        x = orthogonalPositions[getStripHorizontalAlignmentPosition(horizontalAlignment)];
                        if (verticalAlignment === TOP) {
                            y = from
                        } else {
                            if (verticalAlignment === CENTER) {
                                y = to + (from - to) / 2
                            } else {
                                if (verticalAlignment === BOTTOM) {
                                    y = to
                                }
                            }
                        }
                    }
                    return {
                        x: x,
                        y: y
                    }
                },
                _getTranslatedValue: function(value, offset) {
                    var pos1 = this._translator.translate(value, offset, "semidiscrete" === this._options.type && this._options.tickInterval);
                    var pos2 = this._axisPosition;
                    var isHorizontal = this._isHorizontal;
                    return {
                        x: isHorizontal ? pos1 : pos2,
                        y: isHorizontal ? pos2 : pos1
                    }
                },
                areCoordsOutsideAxis: function(coords) {
                    var coord = this._isHorizontal ? coords.x : coords.y;
                    var visibleArea = this.getVisibleArea();
                    if (coord < visibleArea[0] || coord > visibleArea[1]) {
                        return true
                    }
                    return false
                },
                _getSkippedCategory: function(ticks) {
                    var skippedCategory;
                    if (this._options.type === _axes_constants.default.discrete && this._tickOffset && 0 !== ticks.length) {
                        skippedCategory = ticks[ticks.length - 1]
                    }
                    return skippedCategory
                },
                _filterBreaks: function(breaks, viewport, breakStyle) {
                    var minVisible = viewport.minVisible;
                    var maxVisible = viewport.maxVisible;
                    var breakSize = breakStyle ? breakStyle.width : 0;
                    return breaks.reduce(function(result, currentBreak) {
                        var from = currentBreak.from;
                        var to = currentBreak.to;
                        var lastResult = result[result.length - 1];
                        var newBreak;
                        if (!(0, _type.isDefined)(from) || !(0, _type.isDefined)(to)) {
                            return result
                        }
                        if (from > to) {
                            to = [from, from = to][0]
                        }
                        if (result.length && from < lastResult.to) {
                            if (to > lastResult.to) {
                                lastResult.to = to > maxVisible ? maxVisible : to;
                                if (lastResult.gapSize) {
                                    lastResult.gapSize = void 0;
                                    lastResult.cumulativeWidth += breakSize
                                }
                            }
                        } else {
                            if (from >= minVisible && from < maxVisible || to <= maxVisible && to > minVisible) {
                                from = from >= minVisible ? from : minVisible;
                                to = to <= maxVisible ? to : maxVisible;
                                if (to - from < maxVisible - minVisible) {
                                    var _lastResult$cumulativ;
                                    newBreak = {
                                        from: from,
                                        to: to,
                                        cumulativeWidth: (null !== (_lastResult$cumulativ = null === lastResult || void 0 === lastResult ? void 0 : lastResult.cumulativeWidth) && void 0 !== _lastResult$cumulativ ? _lastResult$cumulativ : 0) + breakSize
                                    };
                                    if (currentBreak.gapSize) {
                                        var _lastResult$cumulativ2;
                                        newBreak.gapSize = _date.default.convertMillisecondsToDateUnits(to - from);
                                        newBreak.cumulativeWidth = null !== (_lastResult$cumulativ2 = null === lastResult || void 0 === lastResult ? void 0 : lastResult.cumulativeWidth) && void 0 !== _lastResult$cumulativ2 ? _lastResult$cumulativ2 : 0
                                    }
                                    result.push(newBreak)
                                }
                            }
                        }
                        return result
                    }, [])
                },
                _getScaleBreaks: function(axisOptions, viewport, series, isArgumentAxis) {
                    var that = this;
                    var breaks = (axisOptions.breaks || []).map(function(b) {
                        return {
                            from: that.parser(b.startValue),
                            to: that.parser(b.endValue)
                        }
                    });
                    if ("discrete" !== axisOptions.type && "datetime" === axisOptions.dataType && axisOptions.workdaysOnly) {
                        breaks = breaks.concat((0, _datetime_breaks.generateDateBreaks)(viewport.minVisible, viewport.maxVisible, axisOptions.workWeek, axisOptions.singleWorkdays, axisOptions.holidays))
                    }
                    if (!isArgumentAxis && "discrete" !== axisOptions.type && "datetime" !== axisOptions.dataType && axisOptions.autoBreaksEnabled && 0 !== axisOptions.maxAutoBreakCount) {
                        breaks = breaks.concat(generateAutoBreaks(axisOptions, series, viewport))
                    }
                    return sortingBreaks(breaks)
                },
                _drawBreak: function(translatedEnd, positionFrom, positionTo, width, options, group) {
                    var that = this;
                    var breakStart = translatedEnd - (!that._translator.isInverted() ? width + 1 : 0);
                    var attr = {
                        "stroke-width": 1,
                        stroke: options.borderColor,
                        sharp: !options.isWaved ? options.isHorizontal ? "h" : "v" : void 0
                    };
                    var spaceAttr = {
                        stroke: options.color,
                        "stroke-width": width
                    };
                    var getPoints = that._isHorizontal ? rotateLine : function(p) {
                        return p
                    };
                    var drawer = getLineDrawer(that._renderer, group, getPoints, positionFrom, breakStart, positionTo, options.isWaved);
                    drawer(width / 2, spaceAttr);
                    drawer(0, attr);
                    drawer(width, attr)
                },
                _createBreakClipRect: function(from, to) {
                    var that = this;
                    var canvas = that._canvas;
                    var clipWidth = to - from;
                    var clipRect;
                    if (that._isHorizontal) {
                        clipRect = that._renderer.clipRect(canvas.left, from, canvas.width, clipWidth)
                    } else {
                        clipRect = that._renderer.clipRect(from, canvas.top, clipWidth, canvas.height)
                    }
                    that._breaksElements = that._breaksElements || [];
                    that._breaksElements.push(clipRect);
                    return clipRect.id
                },
                _createBreaksGroup: function(clipFrom, clipTo) {
                    var that = this;
                    var group = that._renderer.g().attr({
                        "class": that._axisCssPrefix + "breaks",
                        "clip-path": that._createBreakClipRect(clipFrom, clipTo)
                    }).append(that._scaleBreaksGroup);
                    that._breaksElements = that._breaksElements || [];
                    that._breaksElements.push(group);
                    return group
                },
                _disposeBreaksGroup: function() {
                    (this._breaksElements || []).forEach(function(clipRect) {
                        clipRect.dispose()
                    });
                    this._breaksElements = null
                },
                drawScaleBreaks: function(customCanvas) {
                    var that = this;
                    var options = that._options;
                    var breakStyle = options.breakStyle;
                    var position = options.position;
                    var positionFrom;
                    var positionTo;
                    var breaks = that._translator.getBusinessRange().breaks || [];
                    var additionGroup;
                    var additionBreakFrom;
                    var additionBreakTo;
                    that._disposeBreaksGroup();
                    if (!(breaks && breaks.length)) {
                        return
                    }
                    var breakOptions = {
                        color: that._options.containerColor,
                        borderColor: breakStyle.color,
                        isHorizontal: that._isHorizontal,
                        isWaved: "straight" !== breakStyle.line.toLowerCase()
                    };
                    if (customCanvas) {
                        positionFrom = customCanvas.start;
                        positionTo = customCanvas.end
                    } else {
                        positionFrom = that._orthogonalPositions.start - (options.visible && !that._axisShift && (position === LEFT || position === TOP) ? SCALE_BREAK_OFFSET : 0);
                        positionTo = that._orthogonalPositions.end + (options.visible && (position === RIGHT || position === BOTTOM) ? SCALE_BREAK_OFFSET : 0)
                    }
                    var mainGroup = that._createBreaksGroup(positionFrom, positionTo);
                    if (that._axisShift && options.visible) {
                        additionBreakFrom = that._axisPosition - that._axisShift - SCALE_BREAK_OFFSET;
                        additionBreakTo = additionBreakFrom + 2 * SCALE_BREAK_OFFSET;
                        additionGroup = that._createBreaksGroup(additionBreakFrom, additionBreakTo);
                    }
                    breaks.forEach(function(br) {
                        if (!br.gapSize) {
                            var breakCoord = that._getTranslatedCoord(br.to);
                            that._drawBreak(breakCoord, positionFrom, positionTo, breakStyle.width, breakOptions, mainGroup);
                            if (that._axisShift && options.visible) {
                                that._drawBreak(breakCoord, additionBreakFrom, additionBreakTo, breakStyle.width, breakOptions, additionGroup)
                            }
                        }
                    })
                },
                _getSpiderCategoryOption: _common.noop,
                shift: function(margins) {
                    var that = this;
                    var options = that._options;
                    var isHorizontal = options.isHorizontal;
                    var axesSpacing = that.getMultipleAxesSpacing();
                    var constantLinesGroups = that._axisConstantLineGroups;

                    function shiftGroup(side, group) {
                        var attr = {
                            translateX: 0,
                            translateY: 0
                        };
                        var shift = margins[side] ? margins[side] + axesSpacing : 0;
                        attr[isHorizontal ? "translateY" : "translateX"] = (side === LEFT || side === TOP ? -1 : 1) * shift;
                        (group[side] || group).attr(attr);
                        return shift
                    }
                    that._axisShift = shiftGroup(options.position, that._axisGroup);
                    (isHorizontal ? [TOP, BOTTOM] : [LEFT, RIGHT]).forEach(function(side) {
                        shiftGroup(side, constantLinesGroups.above);
                        shiftGroup(side, constantLinesGroups.under)
                    })
                },
                getCustomPosition: function(position) {
                    var that = this;
                    var orthogonalAxis = that.getOrthogonalAxis();
                    var resolvedPosition = null !== position && void 0 !== position ? position : that.getResolvedPositionOption();
                    var offset = that.getOptions().offset;
                    var orthogonalTranslator = orthogonalAxis.getTranslator();
                    var orthogonalAxisType = orthogonalAxis.getOptions().type;
                    var validPosition = orthogonalAxis.validateUnit(resolvedPosition);
                    var currentPosition;
                    if ("discrete" === orthogonalAxisType && (!orthogonalTranslator._categories || orthogonalTranslator._categories.indexOf(validPosition) < 0)) {
                        validPosition = void 0
                    }
                    if (that.positionIsBoundary(resolvedPosition)) {
                        currentPosition = that.getPredefinedPosition(resolvedPosition)
                    } else {
                        if (!(0, _type.isDefined)(validPosition)) {
                            currentPosition = that.getPredefinedPosition(that.getOptions().position)
                        } else {
                            currentPosition = orthogonalTranslator.to(validPosition, -1)
                        }
                    }
                    if (isFinite(currentPosition) && isFinite(offset)) {
                        currentPosition += offset
                    }
                    return currentPosition
                },
                getCustomBoundaryPosition: function(position) {
                    var that = this;
                    var _that$getOptions = that.getOptions(),
                        customPosition = _that$getOptions.customPosition,
                        offset = _that$getOptions.offset;
                    var resolvedPosition = null !== position && void 0 !== position ? position : that.getResolvedPositionOption();
                    var orthogonalAxis = that.getOrthogonalAxis();
                    var orthogonalTranslator = orthogonalAxis.getTranslator();
                    var visibleArea = orthogonalTranslator.getCanvasVisibleArea();
                    if (!(0, _type.isDefined)(orthogonalAxis._orthogonalPositions) || 0 === orthogonalTranslator.canvasLength) {
                        return
                    }
                    var currentPosition = that.getCustomPosition(resolvedPosition);
                    if (!(0, _type.isDefined)(currentPosition)) {
                        return that.getResolvedBoundaryPosition()
                    } else {
                        if ((0, _type.isDefined)(customPosition)) {
                            if (currentPosition <= visibleArea.min) {
                                return that._isHorizontal ? TOP : LEFT
                            } else {
                                if (currentPosition >= visibleArea.max) {
                                    return that._isHorizontal ? BOTTOM : RIGHT
                                }
                            }
                        } else {
                            if ((0, _type.isDefined)(offset)) {
                                if (currentPosition <= that._orthogonalPositions.start) {
                                    return that._isHorizontal ? TOP : LEFT
                                } else {
                                    if (currentPosition >= that._orthogonalPositions.end) {
                                        return that._isHorizontal ? BOTTOM : RIGHT
                                    }
                                }
                            }
                        }
                    }
                    return currentPosition
                },
                getResolvedPositionOption: function() {
                    var _options$customPositi;
                    var options = this.getOptions();
                    return null !== (_options$customPositi = options.customPosition) && void 0 !== _options$customPositi ? _options$customPositi : options.position
                },
                customPositionIsAvailable: function() {
                    var options = this.getOptions();
                    return (0, _type.isDefined)(this.getOrthogonalAxis()) && ((0, _type.isDefined)(options.customPosition) || isFinite(options.offset))
                },
                hasNonBoundaryPosition: function() {
                    return this.customPositionIsAvailable() && !this.customPositionIsBoundary()
                },
                getResolvedBoundaryPosition: function() {
                    return this.customPositionIsBoundary() ? this._customBoundaryPosition : this.getOptions().position
                },
                customPositionEqualsToPredefined: function() {
                    return this.customPositionIsBoundary() && this._customBoundaryPosition === this.getOptions().position
                },
                customPositionIsBoundary: function() {
                    return this.positionIsBoundary(this._customBoundaryPosition)
                },
                positionIsBoundary: function(position) {
                    return [TOP, LEFT, BOTTOM, RIGHT].indexOf(position) >= 0
                },
                getPredefinedPosition: function(position) {
                    var _this$_orthogonalPosi;
                    return null === (_this$_orthogonalPosi = this._orthogonalPositions) || void 0 === _this$_orthogonalPosi ? void 0 : _this$_orthogonalPosi[position === TOP || position === LEFT ? "start" : "end"]
                },
                resolveOverlappingForCustomPositioning: function(oppositeAxes) {
                    var that = this;
                    if (!that.hasNonBoundaryPosition() && !that.customPositionIsBoundary() && !oppositeAxes.some(function(a) {
                            return a.hasNonBoundaryPosition()
                        })) {
                        return
                    }
                    var overlappingObj = {
                        axes: [],
                        ticks: []
                    };
                    oppositeAxes.filter(function(orthogonalAxis) {
                        return orthogonalAxis.pane === that.pane
                    }).forEach(function(orthogonalAxis) {
                        for (var i = 0; i < that._majorTicks.length; i++) {
                            var tick = that._majorTicks[i];
                            var label = tick.label;
                            if (label) {
                                if (overlappingObj.axes.indexOf(orthogonalAxis) < 0 && that._detectElementsOverlapping(label, orthogonalAxis._axisElement)) {
                                    overlappingObj.axes.push(orthogonalAxis);
                                    that._shiftThroughOrthogonalAxisOverlappedTick(label, orthogonalAxis)
                                }
                                for (var j = 0; j < orthogonalAxis._majorTicks.length; j++) {
                                    var oppositeTick = orthogonalAxis._majorTicks[j];
                                    var oppositeLabel = oppositeTick.label;
                                    if (oppositeLabel && that._detectElementsOverlapping(label, oppositeLabel)) {
                                        overlappingObj.ticks.push(tick);
                                        that._shiftThroughAxisOverlappedTick(tick);
                                        i = that._majorTicks.length;
                                        break
                                    }
                                }
                            }
                            if (tick.mark && overlappingObj.ticks.indexOf(tick) < 0) {
                                if (that._isHorizontal && tick.mark.attr("translateY")) {
                                    tick.mark.attr({
                                        translateY: 0
                                    })
                                } else {
                                    if (!that._isHorizontal && tick.mark.attr("translateX")) {
                                        tick.mark.attr({
                                            translateX: 0
                                        })
                                    }
                                }
                            }
                        }
                    })
                },
                _shiftThroughOrthogonalAxisOverlappedTick: function(label, orthogonalAxis) {
                    var that = this;
                    var labelBBox = label.getBBox();
                    var orthogonalAxisPosition = orthogonalAxis.getAxisPosition();
                    var orthogonalAxisLabelOptions = orthogonalAxis.getOptions().label;
                    var orthogonalAxisLabelPosition = orthogonalAxisLabelOptions.position;
                    var orthogonalAxisLabelIndent = orthogonalAxisLabelOptions.indentFromAxis / 2;
                    var translateCoordName = that._isHorizontal ? "translateX" : "translateY";
                    var defaultOrthogonalAxisLabelPosition = that._isHorizontal ? LEFT : TOP;
                    var translate = label.attr(translateCoordName);
                    var labelCoord = (that._isHorizontal ? labelBBox.x : labelBBox.y) + translate;
                    var labelSize = that._isHorizontal ? labelBBox.width : labelBBox.height;
                    var outsidePart = orthogonalAxisPosition - labelCoord;
                    var insidePart = labelCoord + labelSize - orthogonalAxisPosition;
                    var attr = {};
                    attr[translateCoordName] = translate;
                    if (outsidePart > 0 && insidePart > 0) {
                        if (insidePart - outsidePart > 1) {
                            attr[translateCoordName] += outsidePart + orthogonalAxisLabelIndent
                        } else {
                            if (outsidePart - insidePart > 1) {
                                attr[translateCoordName] -= insidePart + orthogonalAxisLabelIndent
                            } else {
                                attr[translateCoordName] += orthogonalAxisLabelPosition === defaultOrthogonalAxisLabelPosition ? outsidePart + orthogonalAxisLabelIndent : -(insidePart + orthogonalAxisLabelIndent)
                            }
                        }
                        label.attr(attr)
                    }
                },
                _shiftThroughAxisOverlappedTick: function(tick) {
                    var _tick$mark;
                    var that = this;
                    var label = tick.label;
                    if (!label) {
                        return
                    }
                    var labelBBox = label.getBBox();
                    var tickMarkBBox = null === (_tick$mark = tick.mark) || void 0 === _tick$mark ? void 0 : _tick$mark.getBBox();
                    var axisPosition = that.getAxisPosition();
                    var labelOptions = that.getOptions().label;
                    var labelIndent = labelOptions.indentFromAxis;
                    var labelPosition = labelOptions.position;
                    var defaultLabelPosition = that._isHorizontal ? TOP : LEFT;
                    var translateCoordName = that._isHorizontal ? "translateY" : "translateX";
                    var translate = label.attr(translateCoordName);
                    var labelCoord = (that._isHorizontal ? labelBBox.y : labelBBox.x) + translate;
                    var labelSize = that._isHorizontal ? labelBBox.height : labelBBox.width;
                    var attr = {};
                    attr[translateCoordName] = translate + (labelPosition === defaultLabelPosition ? axisPosition - labelCoord + labelIndent : -(labelCoord - axisPosition + labelSize + labelIndent));
                    label.attr(attr);
                    if (tick.mark) {
                        var markerSize = that._isHorizontal ? tickMarkBBox.height : tickMarkBBox.width;
                        var dir = labelPosition === defaultLabelPosition ? 1 : -1;
                        attr[translateCoordName] = dir * (markerSize - 1);
                        tick.mark.attr(attr)
                    }
                },
                _detectElementsOverlapping: function(element1, element2) {
                    if (!element1 || !element2) {
                        return false
                    }
                    var bBox1 = element1.getBBox();
                    var x1 = bBox1.x + element1.attr("translateX");
                    var y1 = bBox1.y + element1.attr("translateY");
                    var bBox2 = element2.getBBox();
                    var x2 = bBox2.x + element2.attr("translateX");
                    var y2 = bBox2.y + element2.attr("translateY");
                    return (x2 >= x1 && x2 <= x1 + bBox1.width || x1 >= x2 && x1 <= x2 + bBox2.width) && (y2 >= y1 && y2 <= y1 + bBox1.height || y1 >= y2 && y1 <= y2 + bBox2.height)
                }
            }
        };
        exports.default = _default;

        function getLineDrawer(renderer, root, rotatePoints, positionFrom, breakStart, positionTo, isWaved) {
            var elementType = isWaved ? "bezier" : "line";
            var group = renderer.g().append(root);
            return function(offset, attr) {
                renderer.path(rotatePoints(getPoints(positionFrom, breakStart, positionTo, offset, isWaved)), elementType).attr(attr).append(group)
            }
        }

        function getPoints(positionFrom, breakStart, positionTo, offset, isWaved) {
            if (!isWaved) {
                return [positionFrom, breakStart + offset, positionTo, breakStart + offset]
            }
            breakStart += offset;
            var currentPosition;
            var topPoint = breakStart + WAVED_LINE_TOP;
            var centerPoint = breakStart + WAVED_LINE_CENTER;
            var bottomPoint = breakStart + WAVED_LINE_BOTTOM;
            var points = [
                [positionFrom, centerPoint]
            ];
            for (currentPosition = positionFrom; currentPosition < positionTo + WAVED_LINE_LENGTH; currentPosition += WAVED_LINE_LENGTH) {
                points.push([currentPosition + 6, topPoint, currentPosition + 6, topPoint, currentPosition + 12, centerPoint, currentPosition + 18, bottomPoint, currentPosition + 18, bottomPoint, currentPosition + 24, centerPoint])
            }
            return [].concat.apply([], points)
        }

        function rotateLine(lineCoords) {
            var points = [];
            var i;
            for (i = 0; i < lineCoords.length; i += 2) {
                points.push(lineCoords[i + 1]);
                points.push(lineCoords[i])
            }
            return points
        }
        module.exports = exports.default
    },
    /*!*********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/axes/axes_utils.js ***!
      \*********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.measureLabels = exports.calculateCanvasMargins = void 0;
        var _max = Math.max;
        var calculateCanvasMargins = function(bBoxes, canvas) {
            var cLeft = canvas.left;
            var cTop = canvas.top;
            var cRight = canvas.width - canvas.right;
            var cBottom = canvas.height - canvas.bottom;
            return bBoxes.reduce(function(margins, bBox) {
                if (!bBox || bBox.isEmpty) {
                    return margins
                }
                return {
                    left: _max(margins.left, cLeft - bBox.x),
                    top: _max(margins.top, cTop - bBox.y),
                    right: _max(margins.right, bBox.x + bBox.width - cRight),
                    bottom: _max(margins.bottom, bBox.y + bBox.height - cBottom)
                }
            }, {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            })
        };
        exports.calculateCanvasMargins = calculateCanvasMargins;
        var measureLabels = function(items) {
            items.forEach(function(item) {
                var label = item.getContentContainer();
                item.labelBBox = label ? label.getBBox() : {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                }
            })
        };
        exports.measureLabels = measureLabels
    },
    /*!************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/core/series_family.js ***!
      \************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.SeriesFamily = SeriesFamily;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _math = __webpack_require__( /*! ../../core/utils/math */ 29);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _utils = __webpack_require__( /*! ./utils */ 14);
        var round = Math.round,
            abs = Math.abs,
            pow = Math.pow,
            sqrt = Math.sqrt;
        var _min = Math.min;
        var DEFAULT_BAR_GROUP_PADDING = .3;

        function validateBarPadding(barPadding) {
            return barPadding < 0 || barPadding > 1 ? void 0 : barPadding
        }

        function validateBarGroupPadding(barGroupPadding) {
            return barGroupPadding < 0 || barGroupPadding > 1 ? DEFAULT_BAR_GROUP_PADDING : barGroupPadding
        }

        function isStackExist(series, arg) {
            return series.some(function(s) {
                return !s.getOptions().ignoreEmptyPoints || s.getPointsByArg(arg, true).some(function(point) {
                    return point.hasValue()
                })
            })
        }

        function correctStackCoordinates(series, currentStacks, arg, stack, parameters, barsArea, seriesStackIndexCallback) {
            series.forEach(function(series) {
                var stackIndex = seriesStackIndexCallback(currentStacks.indexOf(stack), currentStacks.length);
                var points = series.getPointsByArg(arg, true);
                var barPadding = validateBarPadding(series.getOptions().barPadding);
                var barWidth = series.getOptions().barWidth;
                var offset = getOffset(stackIndex, parameters);
                var width = parameters.width;
                var extraParameters;
                if (stackIndex === -1) {
                    return
                }
                if ((0, _type.isDefined)(barPadding) || (0, _type.isDefined)(barWidth)) {
                    extraParameters = calculateParams(barsArea, currentStacks.length, 1 - barPadding, barWidth);
                    width = extraParameters.width;
                    offset = getOffset(stackIndex, extraParameters)
                }
                correctPointCoordinates(points, width, offset)
            })
        }

        function adjustBarSeriesDimensionsCore(series, options, seriesStackIndexCallback) {
            var commonStacks = [];
            var allArguments = [];
            var seriesInStacks = {};
            var barGroupWidth = options.barGroupWidth;
            var interval = series[0] && series[0].getArgumentAxis().getTranslator().getInterval();
            var barsArea = barGroupWidth ? interval > barGroupWidth ? barGroupWidth : interval : interval * (1 - validateBarGroupPadding(options.barGroupPadding));
            series.forEach(function(s, i) {
                var stackName = s.getStackName() || s.getBarOverlapGroup() || i.toString();
                var argument;
                for (argument in s.pointsByArgument) {
                    if (allArguments.indexOf(argument.valueOf()) === -1) {
                        allArguments.push(argument.valueOf())
                    }
                }
                if (commonStacks.indexOf(stackName) === -1) {
                    commonStacks.push(stackName);
                    seriesInStacks[stackName] = []
                }
                seriesInStacks[stackName].push(s)
            });
            allArguments.forEach(function(arg) {
                var currentStacks = commonStacks.reduce(function(stacks, stack) {
                    if (isStackExist(seriesInStacks[stack], arg)) {
                        stacks.push(stack)
                    }
                    return stacks
                }, []);
                var parameters = calculateParams(barsArea, currentStacks.length);
                commonStacks.forEach(function(stack) {
                    correctStackCoordinates(seriesInStacks[stack], currentStacks, arg, stack, parameters, barsArea, seriesStackIndexCallback)
                })
            })
        }

        function calculateParams(barsArea, count, percentWidth, fixedBarWidth) {
            var spacing;
            var width;
            if (fixedBarWidth) {
                width = _min(fixedBarWidth, barsArea / count);
                spacing = count > 1 ? round((barsArea - round(width) * count) / (count - 1)) : 0
            } else {
                if ((0, _type.isDefined)(percentWidth)) {
                    width = barsArea * percentWidth / count;
                    spacing = count > 1 ? round((barsArea - barsArea * percentWidth) / (count - 1)) : 0
                } else {
                    spacing = round(barsArea / count * .2);
                    width = (barsArea - spacing * (count - 1)) / count
                }
            }
            return {
                width: width > 1 ? round(width) : 1,
                spacing: spacing,
                middleIndex: count / 2,
                rawWidth: width
            }
        }

        function getOffset(stackIndex, parameters) {
            var width = parameters.rawWidth < 1 ? parameters.rawWidth : parameters.width;
            return (stackIndex - parameters.middleIndex + .5) * width - (parameters.middleIndex - stackIndex - .5) * parameters.spacing
        }

        function correctPointCoordinates(points, width, offset) {
            (0, _iterator.each)(points, function(_, point) {
                point.correctCoordinates({
                    width: width,
                    offset: offset
                })
            })
        }

        function getValueType(value) {
            return value >= 0 ? "positive" : "negative"
        }

        function getVisibleSeries(that) {
            return that.series.filter(function(s) {
                return s.isVisible()
            })
        }

        function getAbsStackSumByArg(stackKeepers, stackName, argument) {
            var positiveStackValue = (stackKeepers.positive[stackName] || {})[argument] || 0;
            var negativeStackValue = -(stackKeepers.negative[stackName] || {})[argument] || 0;
            return positiveStackValue + negativeStackValue
        }

        function getStackSumByArg(stackKeepers, stackName, argument) {
            var positiveStackValue = (stackKeepers.positive[stackName] || {})[argument] || 0;
            var negativeStackValue = (stackKeepers.negative[stackName] || {})[argument] || 0;
            return positiveStackValue + negativeStackValue
        }

        function getSeriesStackIndexCallback(inverted) {
            if (!inverted) {
                return function(index) {
                    return index
                }
            } else {
                return function(index, stackCount) {
                    return stackCount - index - 1
                }
            }
        }

        function isInverted(series) {
            return series[0] && series[0].getArgumentAxis().getTranslator().isInverted()
        }

        function adjustBarSeriesDimensions() {
            var series = getVisibleSeries(this);
            adjustBarSeriesDimensionsCore(series, this._options, getSeriesStackIndexCallback(isInverted(series)))
        }

        function getFirstValueSign(series) {
            var points = series.getPoints();
            var value;
            for (var i = 0; i < points.length; i++) {
                var point = points[i];
                value = point.initialValue && point.initialValue.valueOf();
                if (abs(value) > 0) {
                    break
                }
            }
            return (0, _math.sign)(value)
        }

        function adjustStackedSeriesValues() {
            var that = this;
            var negativesAsZeroes = that._options.negativesAsZeroes;
            var series = getVisibleSeries(that);
            var stackKeepers = {
                positive: {},
                negative: {}
            };
            var holesStack = {
                left: {},
                right: {}
            };
            var lastSeriesInPositiveStack = {};
            var lastSeriesInNegativeStack = {};
            series.forEach(function(singleSeries) {
                var stackName = singleSeries.getStackName() || singleSeries.getBarOverlapGroup();
                var hole = false;
                var stack = getFirstValueSign(singleSeries) < 0 ? lastSeriesInNegativeStack : lastSeriesInPositiveStack;
                singleSeries._prevSeries = stack[stackName];
                stack[stackName] = singleSeries;
                singleSeries.holes = (0, _extend.extend)(true, {}, holesStack);
                singleSeries.getPoints().forEach(function(point, index, points) {
                    var value = point.initialValue && point.initialValue.valueOf();
                    var argument = point.argument.valueOf();
                    var stacks = value >= 0 ? stackKeepers.positive : stackKeepers.negative;
                    var isNotBarSeries = "bar" !== singleSeries.type;
                    if (negativesAsZeroes && value < 0) {
                        stacks = stackKeepers.positive;
                        value = 0;
                        point.resetValue()
                    }
                    stacks[stackName] = stacks[stackName] || {};
                    var currentStack = stacks[stackName];
                    if (currentStack[argument]) {
                        if (isNotBarSeries) {
                            point.correctValue(currentStack[argument])
                        }
                        currentStack[argument] += value
                    } else {
                        currentStack[argument] = value;
                        if (isNotBarSeries) {
                            point.resetCorrection()
                        }
                    }
                    if (!point.hasValue()) {
                        var prevPoint = points[index - 1];
                        if (!hole && prevPoint && prevPoint.hasValue()) {
                            argument = prevPoint.argument.valueOf();
                            prevPoint._skipSetRightHole = true;
                            holesStack.right[argument] = (holesStack.right[argument] || 0) + (prevPoint.value.valueOf() - (isFinite(prevPoint.minValue) ? prevPoint.minValue.valueOf() : 0))
                        }
                        hole = true
                    } else {
                        if (hole) {
                            hole = false;
                            holesStack.left[argument] = (holesStack.left[argument] || 0) + (point.value.valueOf() - (isFinite(point.minValue) ? point.minValue.valueOf() : 0));
                            point._skipSetLeftHole = true
                        }
                    }
                })
            });
            series.forEach(function(singleSeries) {
                var holes = singleSeries.holes;
                singleSeries.getPoints().forEach(function(point) {
                    var argument = point.argument.valueOf();
                    point.resetHoles();
                    !point._skipSetLeftHole && point.setHole(holes.left[argument] || holesStack.left[argument] && 0, "left");
                    !point._skipSetRightHole && point.setHole(holes.right[argument] || holesStack.right[argument] && 0, "right");
                    point._skipSetLeftHole = null;
                    point._skipSetRightHole = null
                })
            });
            that._stackKeepers = stackKeepers;
            series.forEach(function(singleSeries) {
                singleSeries.getPoints().forEach(function(point) {
                    var argument = point.argument.valueOf();
                    var stackName = singleSeries.getStackName() || singleSeries.getBarOverlapGroup();
                    var absTotal = getAbsStackSumByArg(stackKeepers, stackName, argument);
                    var total = getStackSumByArg(stackKeepers, stackName, argument);
                    point.setPercentValue(absTotal, total, holesStack.left[argument], holesStack.right[argument])
                })
            })
        }

        function updateStackedSeriesValues() {
            var that = this;
            var series = getVisibleSeries(that);
            var stack = that._stackKeepers;
            var stackKeepers = {
                positive: {},
                negative: {}
            };
            (0, _iterator.each)(series, function(_, singleSeries) {
                var minBarSize = singleSeries.getOptions().minBarSize;
                var valueAxisTranslator = singleSeries.getValueAxis().getTranslator();
                var minShownBusinessValue = minBarSize && valueAxisTranslator.getMinBarSize(minBarSize);
                var stackName = singleSeries.getStackName();
                (0, _iterator.each)(singleSeries.getPoints(), function(index, point) {
                    if (!point.hasValue()) {
                        return
                    }
                    var value = point.initialValue && point.initialValue.valueOf();
                    var argument = point.argument.valueOf();
                    if (that.fullStacked) {
                        value = value / getAbsStackSumByArg(stack, stackName, argument) || 0
                    }
                    var updateValue = valueAxisTranslator.checkMinBarSize(value, minShownBusinessValue, point.value);
                    var valueType = getValueType(updateValue);
                    var currentStack = stackKeepers[valueType][stackName] = stackKeepers[valueType][stackName] || {};
                    if (currentStack[argument]) {
                        point.minValue = currentStack[argument];
                        currentStack[argument] += updateValue
                    } else {
                        currentStack[argument] = updateValue
                    }
                    point.value = currentStack[argument]
                })
            });
            if (that.fullStacked) {
                updateFullStackedSeriesValues(series, stackKeepers)
            }
        }

        function updateFullStackedSeriesValues(series, stackKeepers) {
            (0, _iterator.each)(series, function(_, singleSeries) {
                var stackName = singleSeries.getStackName ? singleSeries.getStackName() : "default";
                (0, _iterator.each)(singleSeries.getPoints(), function(index, point) {
                    var stackSum = getAbsStackSumByArg(stackKeepers, stackName, point.argument.valueOf());
                    if (0 !== stackSum) {
                        point.value = point.value / stackSum;
                        if ((0, _type.isNumeric)(point.minValue)) {
                            point.minValue = point.minValue / stackSum
                        }
                    }
                })
            })
        }

        function updateBarSeriesValues() {
            (0, _iterator.each)(this.series, function(_, singleSeries) {
                var minBarSize = singleSeries.getOptions().minBarSize;
                var valueAxisTranslator = singleSeries.getValueAxis().getTranslator();
                var minShownBusinessValue = minBarSize && valueAxisTranslator.getMinBarSize(minBarSize);
                if (minShownBusinessValue) {
                    (0, _iterator.each)(singleSeries.getPoints(), function(index, point) {
                        if (point.hasValue()) {
                            point.value = valueAxisTranslator.checkMinBarSize(point.initialValue, minShownBusinessValue)
                        }
                    })
                }
            })
        }

        function adjustCandlestickSeriesDimensions() {
            var series = getVisibleSeries(this);
            adjustBarSeriesDimensionsCore(series, {
                barGroupPadding: .3
            }, getSeriesStackIndexCallback(isInverted(series)))
        }

        function adjustBubbleSeriesDimensions() {
            var series = getVisibleSeries(this);
            if (!series.length) {
                return
            }
            var options = this._options;
            var visibleAreaX = series[0].getArgumentAxis().getVisibleArea();
            var visibleAreaY = series[0].getValueAxis().getVisibleArea();
            var min = _min(visibleAreaX[1] - visibleAreaX[0], visibleAreaY[1] - visibleAreaY[0]);
            var minBubbleArea = pow(options.minBubbleSize, 2);
            var maxBubbleArea = pow(min * options.maxBubbleSize, 2);
            var equalBubbleSize = (min * options.maxBubbleSize + options.minBubbleSize) / 2;
            var minPointSize = 1 / 0;
            var maxPointSize = -(1 / 0);
            var pointSize;
            var bubbleArea;
            var sizeProportion;
            (0, _iterator.each)(series, function(_, seriesItem) {
                (0, _iterator.each)(seriesItem.getPoints(), function(_, point) {
                    maxPointSize = maxPointSize > point.size ? maxPointSize : point.size;
                    minPointSize = minPointSize < point.size ? minPointSize : point.size
                })
            });
            var sizeDispersion = maxPointSize - minPointSize;
            var areaDispersion = abs(maxBubbleArea - minBubbleArea);
            (0, _iterator.each)(series, function(_, seriesItem) {
                (0, _iterator.each)(seriesItem.getPoints(), function(_, point) {
                    if (maxPointSize === minPointSize) {
                        pointSize = round(equalBubbleSize)
                    } else {
                        sizeProportion = abs(point.size - minPointSize) / sizeDispersion;
                        bubbleArea = areaDispersion * sizeProportion + minBubbleArea;
                        pointSize = round(sqrt(bubbleArea))
                    }
                    point.correctCoordinates(pointSize)
                })
            })
        }

        function SeriesFamily(options) {
            var that = this;
            that.type = (0, _utils.normalizeEnum)(options.type);
            that.pane = options.pane;
            that.series = [];
            that.updateOptions(options);
            switch (that.type) {
                case "bar":
                    that.adjustSeriesDimensions = adjustBarSeriesDimensions;
                    that.updateSeriesValues = updateBarSeriesValues;
                    that.adjustSeriesValues = adjustStackedSeriesValues;
                    break;
                case "rangebar":
                    that.adjustSeriesDimensions = adjustBarSeriesDimensions;
                    break;
                case "fullstackedbar":
                    that.fullStacked = true;
                    that.adjustSeriesDimensions = adjustBarSeriesDimensions;
                    that.adjustSeriesValues = adjustStackedSeriesValues;
                    that.updateSeriesValues = updateStackedSeriesValues;
                    break;
                case "stackedbar":
                    that.adjustSeriesDimensions = adjustBarSeriesDimensions;
                    that.adjustSeriesValues = adjustStackedSeriesValues;
                    that.updateSeriesValues = updateStackedSeriesValues;
                    break;
                case "fullstackedarea":
                case "fullstackedline":
                case "fullstackedspline":
                case "fullstackedsplinearea":
                    that.fullStacked = true;
                    that.adjustSeriesValues = adjustStackedSeriesValues;
                    break;
                case "stackedarea":
                case "stackedsplinearea":
                case "stackedline":
                case "stackedspline":
                    that.adjustSeriesValues = adjustStackedSeriesValues;
                    break;
                case "candlestick":
                case "stock":
                    that.adjustSeriesDimensions = adjustCandlestickSeriesDimensions;
                    break;
                case "bubble":
                    that.adjustSeriesDimensions = adjustBubbleSeriesDimensions
            }
        }
        SeriesFamily.prototype = {
            constructor: SeriesFamily,
            adjustSeriesDimensions: _common.noop,
            adjustSeriesValues: _common.noop,
            updateSeriesValues: _common.noop,
            updateOptions: function(options) {
                this._options = options
            },
            dispose: function() {
                this.series = null
            },
            add: function(series) {
                var type = this.type;
                this.series = (0, _utils.map)(series, function(singleSeries) {
                    return singleSeries.type === type ? singleSeries : null
                })
            }
        }
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/chart_components/crosshair.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getMargins = getMargins;
        exports.Crosshair = Crosshair;
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var math = Math;
        var mathAbs = math.abs;
        var mathMin = math.min;
        var mathMax = math.max;
        var mathFloor = math.floor;
        var HORIZONTAL = "horizontal";
        var VERTICAL = "vertical";
        var LABEL_BACKGROUND_PADDING_X = 8;
        var LABEL_BACKGROUND_PADDING_Y = 4;
        var CENTER = "center";
        var RIGHT = "right";
        var LEFT = "left";
        var TOP = "top";
        var BOTTOM = "bottom";

        function getMargins() {
            return {
                x: LABEL_BACKGROUND_PADDING_X,
                y: LABEL_BACKGROUND_PADDING_Y
            }
        }

        function getRectangleBBox(bBox) {
            return {
                x: bBox.x - LABEL_BACKGROUND_PADDING_X,
                y: bBox.y - LABEL_BACKGROUND_PADDING_Y,
                width: bBox.width + 2 * LABEL_BACKGROUND_PADDING_X,
                height: bBox.height + 2 * LABEL_BACKGROUND_PADDING_Y
            }
        }

        function getLabelCheckerPosition(x, y, isHorizontal, canvas) {
            var params = isHorizontal ? ["x", "width", "y", "height", y, 0] : ["y", "height", "x", "width", x, 1];
            return function(bBox, position, coord) {
                var labelCoord = {
                    x: coord.x,
                    y: coord.y
                };
                var rectangleBBox = getRectangleBBox(bBox);
                var delta = isHorizontal ? coord.y - bBox.y - bBox.height / 2 : coord.y - bBox.y;
                labelCoord.y = isHorizontal || !isHorizontal && position === BOTTOM ? coord.y + delta : coord.y;
                if (rectangleBBox[params[0]] < 0) {
                    labelCoord[params[0]] -= rectangleBBox[params[0]]
                } else {
                    if (rectangleBBox[params[0]] + rectangleBBox[params[1]] + delta * params[5] > canvas[params[1]]) {
                        labelCoord[params[0]] -= rectangleBBox[params[0]] + rectangleBBox[params[1]] + delta * params[5] - canvas[params[1]]
                    }
                }
                if (params[4] - rectangleBBox[params[3]] / 2 < 0) {
                    labelCoord[params[2]] -= params[4] - rectangleBBox[params[3]] / 2
                } else {
                    if (params[4] + rectangleBBox[params[3]] / 2 > canvas[params[3]]) {
                        labelCoord[params[2]] -= params[4] + rectangleBBox[params[3]] / 2 - canvas[params[3]]
                    }
                }
                return labelCoord
            }
        }

        function Crosshair(renderer, options, params, group) {
            var that = this;
            that._renderer = renderer;
            that._crosshairGroup = group;
            that._options = {};
            that.update(options, params)
        }
        Crosshair.prototype = {
            constructor: Crosshair,
            update: function(options, params) {
                var that = this;
                var canvas = params.canvas;
                that._canvas = {
                    top: canvas.top,
                    bottom: canvas.height - canvas.bottom,
                    left: canvas.left,
                    right: canvas.width - canvas.right,
                    width: canvas.width,
                    height: canvas.height
                };
                that._axes = params.axes;
                that._panes = params.panes;
                that._prepareOptions(options, HORIZONTAL);
                that._prepareOptions(options, VERTICAL)
            },
            dispose: function() {
                var that = this;
                that._renderer = that._crosshairGroup = that._options = that._axes = that._canvas = that._horizontalGroup = that._verticalGroup = that._horizontal = that._vertical = that._circle = that._panes = null
            },
            _prepareOptions: function(options, direction) {
                var lineOptions = options[direction + "Line"];
                this._options[direction] = {
                    visible: lineOptions.visible,
                    line: {
                        stroke: lineOptions.color || options.color,
                        "stroke-width": lineOptions.width || options.width,
                        dashStyle: lineOptions.dashStyle || options.dashStyle,
                        opacity: lineOptions.opacity || options.opacity,
                        "stroke-linecap": "butt"
                    },
                    label: (0, _extend.extend)(true, {}, options.label, lineOptions.label)
                }
            },
            _createLines: function(options, sharpParam, group) {
                var lines = [];
                var canvas = this._canvas;
                var points = [canvas.left, canvas.top, canvas.left, canvas.top];
                for (var i = 0; i < 2; i++) {
                    lines.push(this._renderer.path(points, "line").attr(options).sharp(sharpParam).append(group))
                }
                return lines
            },
            render: function() {
                var that = this;
                var renderer = that._renderer;
                var options = that._options;
                var verticalOptions = options.vertical;
                var horizontalOptions = options.horizontal;
                var extraOptions = horizontalOptions.visible ? horizontalOptions.line : verticalOptions.line;
                var circleOptions = {
                    stroke: extraOptions.stroke,
                    "stroke-width": extraOptions["stroke-width"],
                    dashStyle: extraOptions.dashStyle,
                    opacity: extraOptions.opacity
                };
                var canvas = that._canvas;
                that._horizontal = {};
                that._vertical = {};
                that._circle = renderer.circle(canvas.left, canvas.top, 0).attr(circleOptions).append(that._crosshairGroup);
                that._horizontalGroup = renderer.g().append(that._crosshairGroup);
                that._verticalGroup = renderer.g().append(that._crosshairGroup);
                if (verticalOptions.visible) {
                    that._vertical.lines = that._createLines(verticalOptions.line, "h", that._verticalGroup);
                    that._vertical.labels = that._createLabels(that._axes[0], verticalOptions, false, that._verticalGroup)
                }
                if (horizontalOptions.visible) {
                    that._horizontal.lines = that._createLines(horizontalOptions.line, "v", that._horizontalGroup);
                    that._horizontal.labels = that._createLabels(that._axes[1], horizontalOptions, true, that._horizontalGroup)
                }
                that.hide()
            },
            _createLabels: function(axes, options, isHorizontal, group) {
                var that = this;
                var canvas = that._canvas;
                var renderer = that._renderer;
                var x;
                var y;
                var text;
                var labels = [];
                var background;
                var currentLabelPos;
                var labelOptions = options.label;
                if (labelOptions.visible) {
                    axes.forEach(function(axis) {
                        var position = axis.getOptions().position;
                        if (axis.getTranslator().getBusinessRange().isEmpty()) {
                            return
                        }
                        currentLabelPos = axis.getLabelsPosition();
                        if (isHorizontal) {
                            y = canvas.top;
                            x = currentLabelPos
                        } else {
                            x = canvas.left;
                            y = currentLabelPos
                        }
                        var align = position === TOP || position === BOTTOM ? CENTER : position === RIGHT ? LEFT : RIGHT;
                        background = renderer.rect(0, 0, 0, 0).attr({
                            fill: labelOptions.backgroundColor || options.line.stroke
                        }).append(group);
                        text = renderer.text("0", 0, 0).css((0, _utils.patchFontOptions)(options.label.font)).attr({
                            align: align,
                            "class": labelOptions.cssClass
                        }).append(group);
                        labels.push({
                            text: text,
                            background: background,
                            axis: axis,
                            options: labelOptions,
                            pos: {
                                coord: currentLabelPos,
                                side: position
                            },
                            startXY: {
                                x: x,
                                y: y
                            }
                        })
                    })
                }
                return labels
            },
            _updateText: function(value, axisName, labels, point, func) {
                var that = this;
                labels.forEach(function(label) {
                    var axis = label.axis;
                    var coord = label.startXY;
                    var textElement = label.text;
                    var backgroundElement = label.background;
                    var text = "";
                    if (!axis.name || axis.name === axisName) {
                        text = axis.getFormattedValue(value, label.options, point)
                    }
                    if (text) {
                        textElement.attr({
                            text: text,
                            x: coord.x,
                            y: coord.y
                        });
                        textElement.attr(func(textElement.getBBox(), label.pos.side, coord));
                        that._updateLinesCanvas(label);
                        backgroundElement.attr(getRectangleBBox(textElement.getBBox()))
                    } else {
                        textElement.attr({
                            text: ""
                        });
                        backgroundElement.attr({
                            x: 0,
                            y: 0,
                            width: 0,
                            height: 0
                        })
                    }
                })
            },
            hide: function() {
                this._crosshairGroup.attr({
                    visibility: "hidden"
                })
            },
            _updateLinesCanvas: function(label) {
                var position = label.pos.side;
                var labelCoord = label.pos.coord;
                var coords = this._linesCanvas;
                var canvas = this._canvas;
                coords[position] = coords[position] !== canvas[position] && mathAbs(coords[position] - canvas[position]) < mathAbs(labelCoord - canvas[position]) ? coords[position] : labelCoord
            },
            _updateLines: function(lines, x, y, r, isHorizontal) {
                var coords = this._linesCanvas;
                var canvas = this._canvas;
                var points = isHorizontal ? [
                    [mathMin(x - r, coords.left), canvas.top, x - r, canvas.top],
                    [x + r, canvas.top, mathMax(coords.right, x + r), canvas.top]
                ] : [
                    [canvas.left, mathMin(coords.top, y - r), canvas.left, y - r],
                    [canvas.left, y + r, canvas.left, mathMax(coords.bottom, y + r)]
                ];
                for (var i = 0; i < 2; i++) {
                    lines[i].attr({
                        points: points[i]
                    }).sharp(isHorizontal ? "v" : "h", isHorizontal ? y === canvas.bottom ? -1 : 1 : x === canvas.right ? -1 : 1)
                }
            },
            _resetLinesCanvas: function() {
                var canvas = this._canvas;
                this._linesCanvas = {
                    left: canvas.left,
                    right: canvas.right,
                    top: canvas.top,
                    bottom: canvas.bottom
                }
            },
            _getClipRectForPane: function(x, y) {
                var panes = this._panes;
                var i;
                var coords;
                for (i = 0; i < panes.length; i++) {
                    coords = panes[i].coords;
                    if (coords.left <= x && coords.right >= x && coords.top <= y && coords.bottom >= y) {
                        return panes[i].clipRect
                    }
                }
                return {
                    id: null
                }
            },
            show: function(data) {
                var that = this;
                var point = data.point;
                var pointData = point.getCrosshairData(data.x, data.y);
                var r = point.getPointRadius();
                var horizontal = that._horizontal;
                var vertical = that._vertical;
                var rad = !r ? 0 : r + 3;
                var canvas = that._canvas;
                var x = mathFloor(pointData.x);
                var y = mathFloor(pointData.y);
                if (x >= canvas.left && x <= canvas.right && y >= canvas.top && y <= canvas.bottom) {
                    that._crosshairGroup.attr({
                        visibility: "visible"
                    });
                    that._resetLinesCanvas();
                    that._circle.attr({
                        cx: x,
                        cy: y,
                        r: rad,
                        "clip-path": that._getClipRectForPane(x, y).id
                    });
                    if (horizontal.lines) {
                        that._updateText(pointData.yValue, pointData.axis, horizontal.labels, point, getLabelCheckerPosition(x, y, true, canvas));
                        that._updateLines(horizontal.lines, x, y, rad, true);
                        that._horizontalGroup.attr({
                            translateY: y - canvas.top
                        })
                    }
                    if (vertical.lines) {
                        that._updateText(pointData.xValue, pointData.axis, vertical.labels, point, getLabelCheckerPosition(x, y, false, canvas));
                        that._updateLines(vertical.lines, x, y, rad, false);
                        that._verticalGroup.attr({
                            translateX: x - canvas.left
                        })
                    }
                } else {
                    that.hide()
                }
            }
        }
    },
    /*!******************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/translators/translator1d.js ***!
      \******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.Translator1D = Translator1D;
        var _Number = Number;

        function Translator1D() {
            this.setDomain(arguments[0], arguments[1]).setCodomain(arguments[2], arguments[3]).setInverted(false)
        }
        Translator1D.prototype = {
            constructor: Translator1D,
            setDomain: function(domain1, domain2) {
                var that = this;
                that._domain1 = _Number(domain1);
                that._domain2 = _Number(domain2);
                that._domainDelta = that._domain2 - that._domain1;
                return that
            },
            setCodomain: function(codomain1, codomain2) {
                var that = this;
                that._codomain1 = _Number(codomain1);
                that._codomain2 = _Number(codomain2);
                that._codomainDelta = that._codomain2 - that._codomain1;
                return that
            },
            setInverted: function(state) {
                this.inverted = state
            },
            getDomain: function() {
                return [this._domain1, this._domain2]
            },
            getCodomain: function() {
                return [this._codomain1, this._codomain2]
            },
            getDomainStart: function() {
                return this._domain1
            },
            getDomainEnd: function() {
                return this._domain2
            },
            getCodomainStart: function() {
                return this._codomain1
            },
            getCodomainEnd: function() {
                return this._codomain2
            },
            getDomainRange: function() {
                return this._domainDelta
            },
            getCodomainRange: function() {
                return this._codomainDelta
            },
            translate: function(value) {
                var ratio = (_Number(value) - this._domain1) / this._domainDelta;
                this.inverted && (ratio = 1 - ratio);
                return 0 <= ratio && ratio <= 1 ? this._codomain1 + ratio * this._codomainDelta : NaN
            },
            adjust: function(value) {
                var ratio = (_Number(value) - this._domain1) / this._domainDelta;
                var result = NaN;
                if (ratio < 0) {
                    result = this._domain1
                } else {
                    if (ratio > 1) {
                        result = this._domain2
                    } else {
                        if (0 <= ratio && ratio <= 1) {
                            result = _Number(value)
                        }
                    }
                }
                return result
            }
        }
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/gauges/common.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.createIndicatorCreator = createIndicatorCreator;
        exports.dxGauge = void 0;
        var _base_gauge = __webpack_require__( /*! ./base_gauge */ 189);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _extend2 = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _base_axis = __webpack_require__( /*! ../axes/base_axis */ 316);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _isArray = Array.isArray;
        var _isFinite = isFinite;
        var _Number = Number;
        var _min = Math.min;
        var _max = Math.max;
        var _extend = _extend2.extend;
        var _each = _iterator.each;
        var SHIFT_ANGLE = 90;
        var OPTION_VALUE = "value";
        var OPTION_SUBVALUES = "subvalues";
        var DEFAULT_MINOR_AXIS_DIVISION_FACTOR = 5;
        var DEFAULT_NUMBER_MULTIPLIERS = [1, 2, 5];

        function processValue(value, fallbackValue) {
            if (null === value) {
                return value
            }
            return _isFinite(value) ? _Number(value) : fallbackValue
        }

        function parseArrayOfNumbers(arg) {
            return _isArray(arg) ? arg : (0, _type.isNumeric)(arg) ? [arg] : null
        }
        var dxGauge = _base_gauge.dxBaseGauge.inherit({
            _initCore: function() {
                var that = this;
                var renderer = that._renderer;
                that._setupValue(that.option(OPTION_VALUE));
                that.__subvalues = parseArrayOfNumbers(that.option(OPTION_SUBVALUES));
                that._setupSubvalues(that.__subvalues);
                selectMode(that);
                that.callBase.apply(that, arguments);
                that._rangeContainer = new that._factory.RangeContainer({
                    renderer: renderer,
                    container: renderer.root,
                    translator: that._translator,
                    themeManager: that._themeManager
                });
                that._initScale();
                that._subvalueIndicatorContainer = that._renderer.g().attr({
                    "class": "dxg-subvalue-indicators"
                }).linkOn(that._renderer.root, "valueIndicator").enableLinks()
            },
            _fontFields: ["scale.label.font", "valueIndicators.rangebar.text.font", "valueIndicators.textcloud.text.font", "indicator.text.font"],
            _initScale: function() {
                var that = this;
                that._scaleGroup = that._renderer.g().attr({
                    "class": "dxg-scale"
                }).linkOn(that._renderer.root, "scale");
                that._scale = new _base_axis.Axis({
                    incidentOccurred: that._incidentOccurred,
                    renderer: that._renderer,
                    axesContainerGroup: that._scaleGroup,
                    axisType: that._scaleTypes.type,
                    drawingType: that._scaleTypes.drawingType,
                    widgetClass: "dxg",
                    getTemplate: function() {}
                })
            },
            _disposeCore: function() {
                var that = this;
                that.callBase.apply(that, arguments);
                that._scale.dispose();
                that._scaleGroup.linkOff();
                that._rangeContainer.dispose();
                that._disposeValueIndicators();
                that._subvalueIndicatorContainer.linkOff();
                that._scale = that._scaleGroup = that._rangeContainer = null
            },
            _disposeValueIndicators: function() {
                var that = this;
                that._valueIndicator && that._valueIndicator.dispose();
                that._subvalueIndicatorsSet && that._subvalueIndicatorsSet.dispose();
                that._valueIndicator = that._subvalueIndicatorsSet = null
            },
            _setupDomainCore: function() {
                var that = this;
                var scaleOption = that.option("scale") || {};
                var startValue = that.option("startValue");
                var endValue = that.option("endValue");
                startValue = (0, _type.isNumeric)(startValue) ? _Number(startValue) : (0, _type.isNumeric)(scaleOption.startValue) ? _Number(scaleOption.startValue) : 0;
                endValue = (0, _type.isNumeric)(endValue) ? _Number(endValue) : (0, _type.isNumeric)(scaleOption.endValue) ? _Number(scaleOption.endValue) : 100;
                that._baseValue = startValue < endValue ? startValue : endValue;
                that._translator.setDomain(startValue, endValue)
            },
            _cleanContent: function() {
                var that = this;
                that._rangeContainer.clean();
                that._cleanValueIndicators()
            },
            _measureScale: function(scaleOptions) {
                var that = this;
                var majorTick = scaleOptions.tick;
                var majorTickEnabled = majorTick.visible && majorTick.length > 0 && majorTick.width > 0;
                var minorTick = scaleOptions.minorTick;
                var minorTickEnabled = minorTick.visible && minorTick.length > 0 && minorTick.width > 0;
                var label = scaleOptions.label;
                var indentFromTick = Number(label.indentFromTick);
                if (!majorTickEnabled && !minorTickEnabled && !label.visible) {
                    return {}
                }
                var textParams = that._scale.measureLabels((0, _extend2.extend)({}, that._canvas));
                var layoutValue = that._getScaleLayoutValue();
                var result = {
                    min: layoutValue,
                    max: layoutValue
                };
                var coefs = that._getTicksCoefficients(scaleOptions);
                var innerCoef = coefs.inner;
                var outerCoef = coefs.outer;
                if (majorTickEnabled) {
                    result.min = _min(result.min, layoutValue - innerCoef * majorTick.length);
                    result.max = _max(result.max, layoutValue + outerCoef * majorTick.length)
                }
                if (minorTickEnabled) {
                    result.min = _min(result.min, layoutValue - innerCoef * minorTick.length);
                    result.max = _max(result.max, layoutValue + outerCoef * minorTick.length)
                }
                label.visible && that._correctScaleIndents(result, indentFromTick, textParams);
                return result
            },
            _renderContent: function() {
                var that = this;
                var scaleOptions = that._prepareScaleSettings();
                that._rangeContainer.render(_extend(that._getOption("rangeContainer"), {
                    vertical: that._area.vertical
                }));
                that._renderScale(scaleOptions);
                that._subvalueIndicatorContainer.linkAppend();
                var elements = (0, _utils.map)([that._rangeContainer].concat(that._prepareValueIndicators()), function(element) {
                    return element && element.enabled ? element : null
                });
                that._applyMainLayout(elements, that._measureScale(scaleOptions));
                _each(elements, function(_, element) {
                    element.resize(that._getElementLayout(element.getOffset()))
                });
                that._shiftScale(that._getElementLayout(0), scaleOptions);
                that._beginValueChanging();
                that._updateActiveElements();
                that._endValueChanging()
            },
            _prepareScaleSettings: function() {
                var that = this;
                var userOptions = that.option("scale");
                var scaleOptions = (0, _extend2.extend)(true, {}, that._themeManager.theme("scale"), userOptions);
                scaleOptions.label.indentFromAxis = 0;
                scaleOptions.isHorizontal = !that._area.vertical;
                scaleOptions.forceUserTickInterval |= (0, _type.isDefined)(userOptions) && (0, _type.isDefined)(userOptions.tickInterval) && !(0, _type.isDefined)(userOptions.scaleDivisionFactor);
                scaleOptions.axisDivisionFactor = scaleOptions.scaleDivisionFactor || that._gridSpacingFactor;
                scaleOptions.minorAxisDivisionFactor = scaleOptions.minorScaleDivisionFactor || DEFAULT_MINOR_AXIS_DIVISION_FACTOR;
                scaleOptions.numberMultipliers = DEFAULT_NUMBER_MULTIPLIERS;
                scaleOptions.tickOrientation = that._getTicksOrientation(scaleOptions);
                if (scaleOptions.label.useRangeColors) {
                    scaleOptions.label.customizeColor = function() {
                        return that._rangeContainer.getColorForValue(this.value)
                    }
                }
                return scaleOptions
            },
            _renderScale: function(scaleOptions) {
                var that = this;
                var bounds = that._translator.getDomain();
                var startValue = bounds[0];
                var endValue = bounds[1];
                var angles = that._translator.getCodomain();
                var invert = !!(startValue > endValue ^ scaleOptions.inverted);
                var min = _min(startValue, endValue);
                var max = _max(startValue, endValue);
                scaleOptions.min = min;
                scaleOptions.max = max;
                scaleOptions.startAngle = SHIFT_ANGLE - angles[0];
                scaleOptions.endAngle = SHIFT_ANGLE - angles[1];
                scaleOptions.skipViewportExtending = true;
                scaleOptions.inverted = invert;
                that._scale.updateOptions(scaleOptions);
                that._scale.setBusinessRange({
                    axisType: "continuous",
                    dataType: "numeric",
                    min: min,
                    max: max,
                    invert: invert
                });
                that._updateScaleTickIndent(scaleOptions);
                that._scaleGroup.linkAppend();
                that._scale.draw((0, _extend2.extend)({}, that._canvas))
            },
            _updateIndicatorSettings: function(settings) {
                var that = this;
                settings.currentValue = settings.baseValue = _isFinite(that._translator.translate(settings.baseValue)) ? _Number(settings.baseValue) : that._baseValue;
                settings.vertical = that._area.vertical;
                if (settings.text && !settings.text.format) {
                    settings.text.format = that._defaultFormatOptions
                }
            },
            _prepareIndicatorSettings: function(options, defaultTypeField) {
                var that = this;
                var theme = that._themeManager.theme("valueIndicators");
                var type = (0, _utils.normalizeEnum)(options.type || that._themeManager.theme(defaultTypeField));
                var settings = _extend(true, {}, theme._default, theme[type], options);
                settings.type = type;
                settings.animation = that._animationSettings;
                settings.containerBackgroundColor = that._containerBackgroundColor;
                that._updateIndicatorSettings(settings);
                return settings
            },
            _cleanValueIndicators: function() {
                this._valueIndicator && this._valueIndicator.clean();
                this._subvalueIndicatorsSet && this._subvalueIndicatorsSet.clean()
            },
            _prepareValueIndicators: function() {
                var that = this;
                that._prepareValueIndicator();
                null !== that.__subvalues && that._prepareSubvalueIndicators();
                return [that._valueIndicator, that._subvalueIndicatorsSet]
            },
            _updateActiveElements: function() {
                this._updateValueIndicator();
                this._updateSubvalueIndicators()
            },
            _prepareValueIndicator: function() {
                var that = this;
                var target = that._valueIndicator;
                var settings = that._prepareIndicatorSettings(that.option("valueIndicator") || {}, "valueIndicatorType");
                if (target && target.type !== settings.type) {
                    target.dispose();
                    target = null
                }
                if (!target) {
                    target = that._valueIndicator = that._createIndicator(settings.type, that._renderer.root, "dxg-value-indicator", "value-indicator")
                }
                target.render(settings)
            },
            _createSubvalueIndicatorsSet: function() {
                var that = this;
                var root = that._subvalueIndicatorContainer;
                return new ValueIndicatorsSet({
                    createIndicator: function(type, i) {
                        return that._createIndicator(type, root, "dxg-subvalue-indicator", "subvalue-indicator", i)
                    },
                    createPalette: function(palette) {
                        return that._themeManager.createPalette(palette)
                    }
                })
            },
            _prepareSubvalueIndicators: function() {
                var that = this;
                var target = that._subvalueIndicatorsSet;
                var settings = that._prepareIndicatorSettings(that.option("subvalueIndicator") || {}, "subvalueIndicatorType");
                if (!target) {
                    target = that._subvalueIndicatorsSet = that._createSubvalueIndicatorsSet()
                }
                var isRecreate = settings.type !== target.type;
                target.type = settings.type;
                var dummy = that._createIndicator(settings.type, that._renderer.root);
                if (dummy) {
                    dummy.dispose();
                    target.render(settings, isRecreate)
                }
            },
            _setupValue: function(value) {
                this.__value = processValue(value, this.__value)
            },
            _setupSubvalues: function(subvalues) {
                var vals = void 0 === subvalues ? this.__subvalues : parseArrayOfNumbers(subvalues);
                var i;
                var ii;
                var list;
                if (null === vals) {
                    return
                }
                for (i = 0, ii = vals.length, list = []; i < ii; ++i) {
                    list.push(processValue(vals[i], this.__subvalues[i]))
                }
                this.__subvalues = list
            },
            _updateValueIndicator: function() {
                var that = this;
                that._valueIndicator && that._valueIndicator.value(that.__value, that._noAnimation)
            },
            _updateSubvalueIndicators: function() {
                var that = this;
                that._subvalueIndicatorsSet && that._subvalueIndicatorsSet.values(that.__subvalues, that._noAnimation)
            },
            value: function(arg) {
                if (void 0 !== arg) {
                    this._changeValue(arg);
                    return this
                }
                return this.__value
            },
            subvalues: function(arg) {
                if (void 0 !== arg) {
                    this._changeSubvalues(arg);
                    return this
                }
                return null !== this.__subvalues ? this.__subvalues.slice() : void 0
            },
            _changeValue: function(value) {
                var that = this;
                that._setupValue(value);
                that._beginValueChanging();
                that._updateValueIndicator();
                if (that.__value !== that.option(OPTION_VALUE)) {
                    that.option(OPTION_VALUE, that.__value)
                }
                that._endValueChanging()
            },
            _changeSubvalues: function(subvalues) {
                var that = this;
                if (null !== that.__subvalues) {
                    that._setupSubvalues(subvalues);
                    that._beginValueChanging();
                    that._updateSubvalueIndicators();
                    that._endValueChanging()
                } else {
                    that.__subvalues = parseArrayOfNumbers(subvalues);
                    that._setContentSize();
                    that._renderContent()
                }
                if (!(0, _base_gauge.compareArrays)(that.__subvalues, that.option(OPTION_SUBVALUES))) {
                    that.option(OPTION_SUBVALUES, that.__subvalues)
                }
            },
            _optionChangesMap: {
                scale: "DOMAIN",
                rangeContainer: "MOSTLY_TOTAL",
                valueIndicator: "MOSTLY_TOTAL",
                subvalueIndicator: "MOSTLY_TOTAL",
                containerBackgroundColor: "MOSTLY_TOTAL",
                value: "VALUE",
                subvalues: "SUBVALUES",
                valueIndicators: "MOSTLY_TOTAL"
            },
            _customChangesOrder: ["VALUE", "SUBVALUES"],
            _change_VALUE: function() {
                this._changeValue(this.option(OPTION_VALUE))
            },
            _change_SUBVALUES: function() {
                this._changeSubvalues(this.option(OPTION_SUBVALUES))
            },
            _applyMainLayout: null,
            _getElementLayout: null,
            _createIndicator: function(type, owner, className, trackerType, trackerIndex, _strict) {
                var that = this;
                var indicator = that._factory.createIndicator({
                    renderer: that._renderer,
                    translator: that._translator,
                    owner: owner,
                    tracker: that._tracker,
                    className: className
                }, type, _strict);
                if (indicator) {
                    indicator.type = type;
                    indicator._trackerInfo = {
                        type: trackerType,
                        index: trackerIndex
                    }
                }
                return indicator
            },
            _getApproximateScreenRange: null
        });
        exports.dxGauge = dxGauge;

        function valueGetter(arg) {
            return arg ? arg.value : null
        }

        function setupValues(that, fieldName, optionItems) {
            var currentValues = that[fieldName];
            var newValues = _isArray(optionItems) ? (0, _utils.map)(optionItems, valueGetter) : [];
            var i = 0;
            var ii = newValues.length;
            var list = [];
            for (; i < ii; ++i) {
                list.push(processValue(newValues[i], currentValues[i]))
            }
            that[fieldName] = list
        }

        function selectMode(gauge) {
            if (void 0 === gauge.option(OPTION_VALUE) && void 0 === gauge.option(OPTION_SUBVALUES)) {
                if (void 0 !== gauge.option("valueIndicators")) {
                    disableDefaultMode(gauge);
                    selectHardMode(gauge)
                }
            }
        }

        function disableDefaultMode(that) {
            that.value = that.subvalues = _common.noop;
            that._setupValue = that._setupSubvalues = that._updateValueIndicator = that._updateSubvalueIndicators = null
        }

        function selectHardMode(that) {
            that._indicatorValues = [];
            setupValues(that, "_indicatorValues", that.option("valueIndicators"));
            that._valueIndicators = [];
            var _applyMostlyTotalChange = that._applyMostlyTotalChange;
            that._applyMostlyTotalChange = function() {
                setupValues(this, "_indicatorValues", this.option("valueIndicators"));
                _applyMostlyTotalChange.call(this)
            };
            that._updateActiveElements = updateActiveElements_hardMode;
            that._prepareValueIndicators = prepareValueIndicators_hardMode;
            that._disposeValueIndicators = disposeValueIndicators_hardMode;
            that._cleanValueIndicators = cleanValueIndicators_hardMode;
            that.indicatorValue = indicatorValue_hardMode
        }

        function updateActiveElements_hardMode() {
            var that = this;
            _each(that._valueIndicators, function(_, valueIndicator) {
                valueIndicator.value(that._indicatorValues[valueIndicator.index], that._noAnimation)
            })
        }

        function prepareValueIndicators_hardMode() {
            var that = this;
            var valueIndicators = that._valueIndicators || [];
            var userOptions = that.option("valueIndicators");
            var optionList = [];
            var i = 0;
            var ii;
            for (ii = _isArray(userOptions) ? userOptions.length : 0; i < ii; ++i) {
                optionList.push(userOptions[i])
            }
            for (ii = valueIndicators.length; i < ii; ++i) {
                optionList.push(null)
            }
            var newValueIndicators = [];
            _each(optionList, function(i, userSettings) {
                var valueIndicator = valueIndicators[i];
                if (!userSettings) {
                    valueIndicator && valueIndicator.dispose();
                    return
                }
                var settings = that._prepareIndicatorSettings(userSettings, "valueIndicatorType");
                if (valueIndicator && valueIndicator.type !== settings.type) {
                    valueIndicator.dispose();
                    valueIndicator = null
                }
                if (!valueIndicator) {
                    valueIndicator = that._createIndicator(settings.type, that._renderer.root, "dxg-value-indicator", "value-indicator", i, true)
                }
                if (valueIndicator) {
                    valueIndicator.index = i;
                    valueIndicator.render(settings);
                    newValueIndicators.push(valueIndicator)
                }
            });
            that._valueIndicators = newValueIndicators;
            return that._valueIndicators
        }

        function disposeValueIndicators_hardMode() {
            _each(this._valueIndicators, function(_, valueIndicator) {
                valueIndicator.dispose()
            });
            this._valueIndicators = null
        }

        function cleanValueIndicators_hardMode() {
            _each(this._valueIndicators, function(_, valueIndicator) {
                valueIndicator.clean()
            })
        }

        function indicatorValue_hardMode(index, value) {
            return accessPointerValue(this, this._valueIndicators, this._indicatorValues, index, value)
        }

        function accessPointerValue(that, pointers, values, index, value) {
            if (void 0 !== value) {
                if (void 0 !== values[index]) {
                    values[index] = processValue(value, values[index]);
                    pointers[index] && pointers[index].value(values[index])
                }
                return that
            } else {
                return values[index]
            }
        }

        function ValueIndicatorsSet(parameters) {
            this._parameters = parameters;
            this._indicators = []
        }
        ValueIndicatorsSet.prototype = {
            constructor: ValueIndicatorsSet,
            dispose: function() {
                var that = this;
                _each(that._indicators, function(_, indicator) {
                    indicator.dispose()
                });
                that._parameters = that._options = that._indicators = that._colorPalette = that._palette = null;
                return that
            },
            clean: function() {
                var that = this;
                that._sample && that._sample.clean().dispose();
                _each(that._indicators, function(_, indicator) {
                    indicator.clean()
                });
                that._sample = that._options = that._palette = null;
                return that
            },
            render: function(options, isRecreate) {
                var that = this;
                that._options = options;
                that._sample = that._parameters.createIndicator(that.type);
                that._sample.render(options);
                that.enabled = that._sample.enabled;
                that._palette = (0, _type.isDefined)(options.palette) ? that._parameters.createPalette(options.palette) : null;
                if (that.enabled) {
                    that._generatePalette(that._indicators.length);
                    that._indicators = (0, _utils.map)(that._indicators, function(indicator, i) {
                        if (isRecreate) {
                            indicator.dispose();
                            indicator = that._parameters.createIndicator(that.type, i)
                        }
                        indicator.render(that._getIndicatorOptions(i));
                        return indicator
                    })
                }
                return that
            },
            getOffset: function() {
                return this._sample.getOffset()
            },
            resize: function(layout) {
                var that = this;
                that._layout = layout;
                _each(that._indicators, function(_, indicator) {
                    indicator.resize(layout)
                });
                return that
            },
            measure: function(layout) {
                return this._sample.measure(layout)
            },
            _getIndicatorOptions: function(index) {
                var result = this._options;
                if (this._colorPalette) {
                    result = _extend({}, result, {
                        color: this._colorPalette[index]
                    })
                }
                return result
            },
            _generatePalette: function(count) {
                var that = this;
                var colors = null;
                if (that._palette) {
                    that._palette.reset();
                    colors = that._palette.generateColors(count, {
                        repeat: true
                    })
                }
                that._colorPalette = colors
            },
            _adjustIndicatorsCount: function(count) {
                var that = this;
                var indicators = that._indicators;
                var i;
                var ii;
                var indicator;
                var indicatorsLen = indicators.length;
                if (indicatorsLen > count) {
                    for (i = count, ii = indicatorsLen; i < ii; ++i) {
                        indicators[i].clean().dispose()
                    }
                    that._indicators = indicators.slice(0, count);
                    that._generatePalette(indicators.length)
                } else {
                    if (indicatorsLen < count) {
                        that._generatePalette(count);
                        for (i = indicatorsLen, ii = count; i < ii; ++i) {
                            indicator = that._parameters.createIndicator(that.type, i);
                            indicator.render(that._getIndicatorOptions(i)).resize(that._layout);
                            indicators.push(indicator)
                        }
                    }
                }
            },
            values: function(arg, _noAnimation) {
                var that = this;
                if (!that.enabled) {
                    return
                }
                if (void 0 !== arg) {
                    if (!_isArray(arg)) {
                        arg = _isFinite(arg) ? [Number(arg)] : null
                    }
                    if (arg) {
                        that._adjustIndicatorsCount(arg.length);
                        _each(that._indicators, function(i, indicator) {
                            indicator.value(arg[i], _noAnimation)
                        })
                    }
                    return that
                }
                return (0, _utils.map)(that._indicators, function(indicator) {
                    return indicator.value()
                })
            }
        };

        function createIndicatorCreator(indicators) {
            return function(parameters, type, _strict) {
                var indicatorType = indicators[(0, _utils.normalizeEnum)(type)] || !_strict && indicators._default;
                return indicatorType ? new indicatorType(parameters) : null
            }
        }
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/gauges/base_range_container.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _base_indicators = __webpack_require__( /*! ./base_indicators */ 319);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _Number = Number;
        var _isArray = Array.isArray;
        var _isFinite = isFinite;
        var BaseRangeContainer = _base_indicators.BaseElement.inherit({
            _init: function() {
                this._root = this._renderer.g().attr({
                    "class": "dxg-range-container"
                }).linkOn(this._container, "range-container")
            },
            _dispose: function() {
                this._root.linkOff()
            },
            clean: function() {
                this._root.linkRemove().clear();
                this._options = this.enabled = null;
                return this
            },
            _getRanges: function() {
                var that = this;
                var options = that._options;
                var translator = that._translator;
                var totalStart = translator.getDomain()[0];
                var totalEnd = translator.getDomain()[1];
                var totalDelta = totalEnd - totalStart;
                var isValidSegment = totalDelta >= 0 ? isValidSegmentAsc : isValidSegmentDesc;
                var subtractSegment = totalDelta >= 0 ? subtractSegmentAsc : subtractSegmentDesc;
                var list = [];
                var ranges = [];
                var backgroundRanges = [{
                    start: totalStart,
                    end: totalEnd
                }];
                var backgroundColor = (0, _type.isString)(options.backgroundColor) ? options.backgroundColor : "none";
                var width = options.width || {};
                var startWidth = _Number(width > 0 ? width : width.start);
                var endWidth = _Number(width > 0 ? width : width.end);
                var deltaWidth = endWidth - startWidth;
                if (void 0 !== options.ranges && !_isArray(options.ranges)) {
                    return null
                }
                if (!(startWidth >= 0 && endWidth >= 0 && startWidth + endWidth > 0)) {
                    return null
                }
                list = (_isArray(options.ranges) ? options.ranges : []).reduce(function(result, rangeOptions, i) {
                    rangeOptions = rangeOptions || {};
                    var start = translator.adjust(rangeOptions.startValue);
                    var end = translator.adjust(rangeOptions.endValue);
                    if (_isFinite(start) && _isFinite(end) && isValidSegment(start, end, rangeOptions)) {
                        result.push({
                            start: start,
                            end: end,
                            color: rangeOptions.color,
                            classIndex: i
                        })
                    }
                    return result
                }, []);
                var palette = that._themeManager.createPalette(options.palette, {
                    type: "indicatingSet",
                    extensionMode: options.paletteExtensionMode,
                    keepLastColorInEnd: true,
                    count: list.length
                });
                (0, _iterator.each)(list, function(_, item) {
                    var paletteColor = palette.getNextColor();
                    item.color = (0, _type.isString)(item.color) && item.color || paletteColor || "none";
                    item.className = "dxg-range dxg-range-" + item.classIndex;
                    delete item.classIndex
                });
                (0, _iterator.each)(list, function(_, item) {
                    var i;
                    var ii;
                    var sub;
                    var subs;
                    var range;
                    var newRanges = [];
                    var newBackgroundRanges = [];
                    for (i = 0, ii = ranges.length; i < ii; ++i) {
                        range = ranges[i];
                        subs = subtractSegment(range.start, range.end, item.start, item.end);
                        (sub = subs[0]) && (sub.color = range.color) && (sub.className = range.className) && newRanges.push(sub);
                        (sub = subs[1]) && (sub.color = range.color) && (sub.className = range.className) && newRanges.push(sub)
                    }
                    newRanges.push(item);
                    ranges = newRanges;
                    for (i = 0, ii = backgroundRanges.length; i < ii; ++i) {
                        range = backgroundRanges[i];
                        subs = subtractSegment(range.start, range.end, item.start, item.end);
                        (sub = subs[0]) && newBackgroundRanges.push(sub);
                        (sub = subs[1]) && newBackgroundRanges.push(sub)
                    }
                    backgroundRanges = newBackgroundRanges
                });
                (0, _iterator.each)(backgroundRanges, function(_, range) {
                    range.color = backgroundColor;
                    range.className = "dxg-range dxg-background-range";
                    ranges.push(range)
                });
                (0, _iterator.each)(ranges, function(_, range) {
                    range.startWidth = (range.start - totalStart) / totalDelta * deltaWidth + startWidth;
                    range.endWidth = (range.end - totalStart) / totalDelta * deltaWidth + startWidth
                });
                return ranges
            },
            render: function(options) {
                var that = this;
                that._options = options;
                that._processOptions();
                that._ranges = that._getRanges();
                if (that._ranges) {
                    that.enabled = true;
                    that._root.linkAppend()
                }
                return that
            },
            resize: function(layout) {
                var that = this;
                that._root.clear();
                if (that._isVisible(layout)) {
                    (0, _iterator.each)(that._ranges, function(_, range) {
                        that._createRange(range, layout).attr({
                            fill: range.color,
                            "class": range.className
                        }).append(that._root)
                    })
                }
                return that
            },
            _processOptions: null,
            _isVisible: null,
            _createRange: null,
            getColorForValue: function(value) {
                var color = null;
                (0, _iterator.each)(this._ranges, function(_, range) {
                    if (range.start <= value && value <= range.end || range.start >= value && value >= range.end) {
                        color = range.color;
                        return false
                    }
                });
                return color
            }
        });

        function subtractSegmentAsc(segmentStart, segmentEnd, otherStart, otherEnd) {
            var result;
            if (otherStart > segmentStart && otherEnd < segmentEnd) {
                result = [{
                    start: segmentStart,
                    end: otherStart
                }, {
                    start: otherEnd,
                    end: segmentEnd
                }]
            } else {
                if (otherStart >= segmentEnd || otherEnd <= segmentStart) {
                    result = [{
                        start: segmentStart,
                        end: segmentEnd
                    }]
                } else {
                    if (otherStart <= segmentStart && otherEnd >= segmentEnd) {
                        result = []
                    } else {
                        if (otherStart > segmentStart) {
                            result = [{
                                start: segmentStart,
                                end: otherStart
                            }]
                        } else {
                            if (otherEnd < segmentEnd) {
                                result = [{
                                    start: otherEnd,
                                    end: segmentEnd
                                }]
                            }
                        }
                    }
                }
            }
            return result
        }

        function subtractSegmentDesc(segmentStart, segmentEnd, otherStart, otherEnd) {
            var result;
            if (otherStart < segmentStart && otherEnd > segmentEnd) {
                result = [{
                    start: segmentStart,
                    end: otherStart
                }, {
                    start: otherEnd,
                    end: segmentEnd
                }]
            } else {
                if (otherStart <= segmentEnd || otherEnd >= segmentStart) {
                    result = [{
                        start: segmentStart,
                        end: segmentEnd
                    }]
                } else {
                    if (otherStart >= segmentStart && otherEnd <= segmentEnd) {
                        result = []
                    } else {
                        if (otherStart < segmentStart) {
                            result = [{
                                start: segmentStart,
                                end: otherStart
                            }]
                        } else {
                            if (otherEnd > segmentEnd) {
                                result = [{
                                    start: otherEnd,
                                    end: segmentEnd
                                }]
                            }
                        }
                    }
                }
            }
            return result
        }

        function areEqualValues(start, end, _ref) {
            var startValue = _ref.startValue,
                endValue = _ref.endValue;
            return endValue === startValue && startValue === start && end === start
        }

        function isValidSegmentAsc(start, end, options) {
            return end - start > 0 || areEqualValues(start, end, options)
        }

        function isValidSegmentDesc(start, end, options) {
            return start - end > 0 || areEqualValues(start, end, options)
        }
        var _default = BaseRangeContainer;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/gauges/circular_gauge.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.default = void 0;
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _object = __webpack_require__( /*! ../../core/utils/object */ 51);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _base_gauge = __webpack_require__( /*! ./base_gauge */ 189);
        var _common = __webpack_require__( /*! ./common */ 476);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var circularIndicators = _interopRequireWildcard(__webpack_require__( /*! ./circular_indicators */ 950));
        var _circular_range_container = _interopRequireDefault(__webpack_require__( /*! ./circular_range_container */ 951));

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _isFinite = isFinite;
        var _normalizeAngle = _utils.normalizeAngle;
        var _getCosAndSin = _utils.getCosAndSin;
        var _abs = Math.abs;
        var _max = Math.max;
        var _min = Math.min;
        var _round = Math.round;
        var _each = _iterator.each;
        var PI = Math.PI;

        function getSides(startAngle, endAngle) {
            var startCosSin = _getCosAndSin(startAngle);
            var endCosSin = _getCosAndSin(endAngle);
            var startCos = startCosSin.cos;
            var startSin = startCosSin.sin;
            var endCos = endCosSin.cos;
            var endSin = endCosSin.sin;
            return {
                left: startSin <= 0 && endSin >= 0 || startSin <= 0 && endSin <= 0 && startCos <= endCos || startSin >= 0 && endSin >= 0 && startCos >= endCos ? -1 : _min(startCos, endCos, 0),
                right: startSin >= 0 && endSin <= 0 || startSin >= 0 && endSin >= 0 && startCos >= endCos || startSin <= 0 && endSin <= 0 && startCos <= endCos ? 1 : _max(startCos, endCos, 0),
                up: startCos <= 0 && endCos >= 0 || startCos <= 0 && endCos <= 0 && startSin >= endSin || startCos >= 0 && endCos >= 0 && startSin <= endSin ? -1 : -_max(startSin, endSin, 0),
                down: startCos >= 0 && endCos <= 0 || startCos >= 0 && endCos >= 0 && startSin <= endSin || startCos <= 0 && endCos <= 0 && startSin >= endSin ? 1 : -_min(startSin, endSin, 0)
            }
        }
        var dxCircularGauge = _common.dxGauge.inherit({
            _rootClass: "dxg-circular-gauge",
            _factoryMethods: {
                rangeContainer: "createCircularRangeContainer",
                indicator: "createCircularIndicator"
            },
            _gridSpacingFactor: 17,
            _scaleTypes: {
                type: "polarAxes",
                drawingType: "circular"
            },
            _getThemeManagerOptions: function() {
                var options = this.callBase.apply(this, arguments);
                options.subTheme = "_circular";
                return options
            },
            _updateScaleTickIndent: function(scaleOptions) {
                var indentFromTick = scaleOptions.label.indentFromTick;
                var length = scaleOptions.tick.visible ? scaleOptions.tick.length : 0;
                var textParams = this._scale.measureLabels((0, _extend.extend)({}, this._canvas));
                var tickCorrection = length;
                if ("inside" === scaleOptions.orientation) {
                    tickCorrection = 0
                } else {
                    if ("center" === scaleOptions.orientation) {
                        tickCorrection = .5 * length
                    }
                }
                scaleOptions.label.indentFromAxis = indentFromTick >= 0 ? indentFromTick + tickCorrection : indentFromTick - tickCorrection - _max(textParams.width, textParams.height);
                this._scale.updateOptions(scaleOptions)
            },
            _setupCodomain: function() {
                var that = this;
                var geometry = that.option("geometry") || {};
                var startAngle = geometry.startAngle;
                var endAngle = geometry.endAngle;
                var sides;
                startAngle = _isFinite(startAngle) ? _normalizeAngle(startAngle) : 225;
                endAngle = _isFinite(endAngle) ? _normalizeAngle(endAngle) : -45;
                if (_abs(startAngle - endAngle) < 1) {
                    endAngle -= 360;
                    sides = {
                        left: -1,
                        up: -1,
                        right: 1,
                        down: 1
                    }
                } else {
                    startAngle < endAngle && (endAngle -= 360);
                    sides = getSides(startAngle, endAngle)
                }
                that._area = {
                    x: 0,
                    y: 0,
                    radius: 100,
                    startCoord: startAngle,
                    endCoord: endAngle,
                    sides: sides
                };
                that._translator.setCodomain(startAngle, endAngle)
            },
            _shiftScale: function(layout) {
                var scale = this._scale;
                var canvas = scale.getCanvas();
                canvas.width = canvas.height = 2 * layout.radius;
                scale.draw(canvas);
                var centerCoords = scale.getCenter();
                scale.shift({
                    right: layout.x - centerCoords.x,
                    bottom: layout.y - centerCoords.y
                })
            },
            _getScaleLayoutValue: function() {
                return this._area.radius
            },
            _getTicksOrientation: function(scaleOptions) {
                return scaleOptions.orientation
            },
            _getTicksCoefficients: function(options) {
                var coefs = {
                    inner: 0,
                    outer: 1
                };
                if ("inside" === options.orientation) {
                    coefs.inner = 1;
                    coefs.outer = 0
                } else {
                    if ("center" === options.orientation) {
                        coefs.inner = coefs.outer = .5
                    }
                }
                return coefs
            },
            _correctScaleIndents: function(result, indentFromTick, textParams) {
                if (indentFromTick >= 0) {
                    result.horizontalOffset = indentFromTick + textParams.width;
                    result.verticalOffset = indentFromTick + textParams.height
                } else {
                    result.horizontalOffset = result.verticalOffset = 0;
                    result.min -= -indentFromTick + _max(textParams.width, textParams.height)
                }
                result.inverseHorizontalOffset = textParams.width / 2;
                result.inverseVerticalOffset = textParams.height / 2
            },
            _measureMainElements: function(elements, scaleMeasurement) {
                var that = this;
                var radius = that._area.radius;
                var maxRadius = 0;
                var minRadius = 1 / 0;
                var maxHorizontalOffset = 0;
                var maxVerticalOffset = 0;
                var maxInverseHorizontalOffset = 0;
                var maxInverseVerticalOffset = 0;
                var scale = that._scale;
                _each(elements.concat(scale), function(_, element) {
                    var bounds = element.measure ? element.measure({
                        radius: radius - element.getOffset()
                    }) : scaleMeasurement;
                    bounds.min > 0 && (minRadius = _min(minRadius, bounds.min));
                    bounds.max > 0 && (maxRadius = _max(maxRadius, bounds.max));
                    bounds.horizontalOffset > 0 && (maxHorizontalOffset = _max(maxHorizontalOffset, bounds.max + bounds.horizontalOffset));
                    bounds.verticalOffset > 0 && (maxVerticalOffset = _max(maxVerticalOffset, bounds.max + bounds.verticalOffset));
                    bounds.inverseHorizontalOffset > 0 && (maxInverseHorizontalOffset = _max(maxInverseHorizontalOffset, bounds.inverseHorizontalOffset));
                    bounds.inverseVerticalOffset > 0 && (maxInverseVerticalOffset = _max(maxInverseVerticalOffset, bounds.inverseVerticalOffset))
                });
                maxHorizontalOffset = _max(maxHorizontalOffset - maxRadius, 0);
                maxVerticalOffset = _max(maxVerticalOffset - maxRadius, 0);
                return {
                    minRadius: minRadius,
                    maxRadius: maxRadius,
                    horizontalMargin: maxHorizontalOffset,
                    verticalMargin: maxVerticalOffset,
                    inverseHorizontalMargin: maxInverseHorizontalOffset,
                    inverseVerticalMargin: maxInverseVerticalOffset
                }
            },
            _applyMainLayout: function(elements, scaleMeasurement) {
                var measurements = this._measureMainElements(elements, scaleMeasurement);
                var area = this._area;
                var sides = area.sides;
                var margins = {
                    left: (sides.left < -.1 ? measurements.horizontalMargin : measurements.inverseHorizontalMargin) || 0,
                    right: (sides.right > .1 ? measurements.horizontalMargin : measurements.inverseHorizontalMargin) || 0,
                    top: (sides.up < -.1 ? measurements.verticalMargin : measurements.inverseVerticalMargin) || 0,
                    bottom: (sides.down > .1 ? measurements.verticalMargin : measurements.inverseVerticalMargin) || 0
                };
                var rect = selectRectByAspectRatio(this._innerRect, (sides.down - sides.up) / (sides.right - sides.left), margins);
                var radius = _min(getWidth(rect) / (sides.right - sides.left), getHeight(rect) / (sides.down - sides.up));
                radius = radius - measurements.maxRadius + area.radius;
                var x = rect.left - getWidth(rect) * sides.left / (sides.right - sides.left);
                var y = rect.top - getHeight(rect) * sides.up / (sides.down - sides.up);
                area.x = _round(x);
                area.y = _round(y);
                area.radius = radius;
                rect.left -= margins.left;
                rect.right += margins.right;
                rect.top -= margins.top;
                rect.bottom += margins.bottom;
                this._innerRect = rect
            },
            _getElementLayout: function(offset) {
                return {
                    x: this._area.x,
                    y: this._area.y,
                    radius: _round(this._area.radius - offset)
                }
            },
            _getApproximateScreenRange: function() {
                var that = this;
                var area = that._area;
                var r = _min(that._canvas.width / (area.sides.right - area.sides.left), that._canvas.height / (area.sides.down - area.sides.up));
                r > area.totalRadius && (r = area.totalRadius);
                r = .8 * r;
                return -that._translator.getCodomainRange() * r * PI / 180
            },
            _getDefaultSize: function() {
                return {
                    width: 300,
                    height: 300
                }
            },
            _factory: (0, _object.clone)(_base_gauge.dxBaseGauge.prototype._factory)
        });

        function getWidth(rect) {
            return rect.right - rect.left
        }

        function getHeight(rect) {
            return rect.bottom - rect.top
        }

        function selectRectByAspectRatio(srcRect, aspectRatio, margins) {
            var rect = (0, _extend.extend)({}, srcRect);
            var selfAspectRatio;
            var width = 0;
            var height = 0;
            margins = margins || {};
            if (aspectRatio > 0) {
                rect.left += margins.left || 0;
                rect.right -= margins.right || 0;
                rect.top += margins.top || 0;
                rect.bottom -= margins.bottom || 0;
                if (getWidth(rect) > 0 && getHeight(rect) > 0) {
                    selfAspectRatio = getHeight(rect) / getWidth(rect);
                    if (selfAspectRatio > 1) {
                        aspectRatio < selfAspectRatio ? width = getWidth(rect) : height = getHeight(rect)
                    } else {
                        aspectRatio > selfAspectRatio ? height = getHeight(rect) : width = getWidth(rect)
                    }
                    width > 0 || (width = height / aspectRatio);
                    height > 0 || (height = width * aspectRatio);
                    width = (getWidth(rect) - width) / 2;
                    height = (getHeight(rect) - height) / 2;
                    rect.left += width;
                    rect.right -= width;
                    rect.top += height;
                    rect.bottom -= height
                } else {
                    rect.left = rect.right = (rect.left + rect.right) / 2;
                    rect.top = rect.bottom = (rect.top + rect.bottom) / 2
                }
            }
            return rect
        }
        var indicators = dxCircularGauge.prototype._factory.indicators = {};
        dxCircularGauge.prototype._factory.createIndicator = (0, _common.createIndicatorCreator)(indicators);
        indicators._default = circularIndicators._default;
        indicators.rectangleneedle = circularIndicators.rectangleneedle;
        indicators.triangleneedle = circularIndicators.triangleneedle;
        indicators.twocolorneedle = circularIndicators.twocolorneedle;
        indicators.trianglemarker = circularIndicators.trianglemarker;
        indicators.textcloud = circularIndicators.textcloud;
        indicators.rangebar = circularIndicators.rangebar;
        dxCircularGauge.prototype._factory.RangeContainer = _circular_range_container.default;
        (0, _component_registrator.default)("dxCircularGauge", dxCircularGauge);
        var _default = dxCircularGauge;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/vector_map/projection.main.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.projection = exports.Projection = void 0;
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _event_emitter = __webpack_require__( /*! ./event_emitter */ 480);

        function _slicedToArray(arr, i) {
            return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest()
        }

        function _nonIterableRest() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }

        function _iterableToArrayLimit(arr, i) {
            var _i = arr && ("undefined" !== typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]);
            if (null == _i) {
                return
            }
            var _arr = [];
            var _n = true;
            var _d = false;
            var _s, _e;
            try {
                for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
                    _arr.push(_s.value);
                    if (i && _arr.length === i) {
                        break
                    }
                }
            } catch (err) {
                _d = true;
                _e = err
            } finally {
                try {
                    if (!_n && null != _i.return) {
                        _i.return()
                    }
                } finally {
                    if (_d) {
                        throw _e
                    }
                }
            }
            return _arr
        }

        function _arrayWithHoles(arr) {
            if (Array.isArray(arr)) {
                return arr
            }
        }
        var _Number = Number;
        var _min = Math.min;
        var _max = Math.max;
        var _abs = Math.abs;
        var _round = Math.round;
        var _ln = Math.log;
        var _pow = Math.pow;
        var TWO_TO_LN2 = 2 / Math.LN2;
        var MIN_BOUNDS_RANGE = 1 / 3600 / 180 / 10;
        var DEFAULT_MIN_ZOOM = 1;
        var DEFAULT_MAX_ZOOM = 256;
        var DEFAULT_CENTER = [NaN, NaN];
        var DEFAULT_ENGINE_NAME = "mercator";

        function floatsEqual(f1, f2) {
            return _abs(f1 - f2) < 1e-8
        }

        function arraysEqual(a1, a2) {
            return floatsEqual(a1[0], a2[0]) && floatsEqual(a1[1], a2[1])
        }

        function parseAndClamp(value, minValue, maxValue, defaultValue) {
            var val = _Number(value);
            return isFinite(val) ? _min(_max(val, minValue), maxValue) : defaultValue
        }

        function parseAndClampArray(value, minValue, maxValue, defaultValue) {
            return [parseAndClamp(value[0], minValue[0], maxValue[0], defaultValue[0]), parseAndClamp(value[1], minValue[1], maxValue[1], defaultValue[1])]
        }

        function getEngine(engine) {
            return engine instanceof Engine && engine || projection.get(engine) || projection(engine) || projection.get(DEFAULT_ENGINE_NAME)
        }
        var Projection = function(parameters) {
            var that = this;
            that._initEvents();
            that._params = parameters;
            that._engine = getEngine();
            that._center = that._engine.center();
            that._adjustCenter()
        };
        exports.Projection = Projection;
        Projection.prototype = {
            constructor: Projection,
            _minZoom: DEFAULT_MIN_ZOOM,
            _maxZoom: DEFAULT_MAX_ZOOM,
            _zoom: DEFAULT_MIN_ZOOM,
            _center: DEFAULT_CENTER,
            _canvas: {},
            _scale: [],
            dispose: function() {
                this._disposeEvents()
            },
            setEngine: function(value) {
                var that = this;
                var engine = getEngine(value);
                if (that._engine !== engine) {
                    that._engine = engine;
                    that._fire("engine");
                    if (that._changeCenter(engine.center())) {
                        that._triggerCenterChanged()
                    }
                    if (that._changeZoom(that._minZoom)) {
                        that._triggerZoomChanged()
                    }
                    that._adjustCenter();
                    that._setupScreen()
                }
            },
            setBounds: function(bounds) {
                if (void 0 !== bounds) {
                    this.setEngine(this._engine.original().bounds(bounds))
                }
            },
            _setupScreen: function() {
                var that = this;
                var canvas = that._canvas;
                var width = canvas.width;
                var height = canvas.height;
                var engine = that._engine;
                var aspectRatio = engine.ar();
                that._x0 = canvas.left + width / 2;
                that._y0 = canvas.top + height / 2;
                var min = [that.project([engine.min()[0], 0])[0], that.project([0, engine.min()[1]])[1]];
                var max = [that.project([engine.max()[0], 0])[0], that.project([0, engine.max()[1]])[1]];
                var screenAR = width / height;
                var boundsAR = _abs(max[0] - min[0]) / _abs(max[1] - min[1]);
                var correction;
                if (isNaN(boundsAR) || 0 === boundsAR || _min(screenAR, aspectRatio) <= aspectRatio * boundsAR && aspectRatio * boundsAR <= _max(screenAR, aspectRatio)) {
                    correction = 1
                } else {
                    correction = boundsAR > 1 ? boundsAR : 1 / boundsAR
                }
                if (aspectRatio * boundsAR >= screenAR) {
                    that._xRadius = width / 2 / correction;
                    that._yRadius = width / 2 / (aspectRatio * correction)
                } else {
                    that._xRadius = height / 2 * (aspectRatio / correction);
                    that._yRadius = height / 2 / correction
                }
                that._fire("screen")
            },
            setSize: function(canvas) {
                this._canvas = canvas;
                this._setupScreen()
            },
            getCanvas: function() {
                return this._canvas
            },
            _toScreen: function(coordinates) {
                return [this._x0 + this._xRadius * coordinates[0], this._y0 + this._yRadius * coordinates[1]]
            },
            _fromScreen: function(coordinates) {
                return [(coordinates[0] - this._x0) / this._xRadius, (coordinates[1] - this._y0) / this._yRadius]
            },
            _toTransformed: function(coordinates) {
                return [coordinates[0] * this._zoom + this._xCenter, coordinates[1] * this._zoom + this._yCenter]
            },
            _toTransformedFast: function(coordinates) {
                return [coordinates[0] * this._zoom, coordinates[1] * this._zoom]
            },
            _fromTransformed: function(coordinates) {
                return [(coordinates[0] - this._xCenter) / this._zoom, (coordinates[1] - this._yCenter) / this._zoom]
            },
            _adjustCenter: function() {
                var that = this;
                var center = that._engine.project(that._center);
                that._xCenter = -center[0] * that._zoom || 0;
                that._yCenter = -center[1] * that._zoom || 0
            },
            project: function(coordinates) {
                return this._engine.project(coordinates)
            },
            transform: function(coordinates) {
                return this._toScreen(this._toTransformedFast(coordinates))
            },
            isInvertible: function() {
                return this._engine.isInvertible()
            },
            getSquareSize: function(size) {
                return [size[0] * this._zoom * this._xRadius, size[1] * this._zoom * this._yRadius]
            },
            getZoom: function() {
                return this._zoom
            },
            _changeZoom: function(value) {
                var that = this;
                var oldZoom = that._zoom;
                var newZoom = that._zoom = parseAndClamp(value, that._minZoom, that._maxZoom, that._minZoom);
                var isChanged = !floatsEqual(oldZoom, newZoom);
                if (isChanged) {
                    that._adjustCenter();
                    that._fire("zoom")
                }
                return isChanged
            },
            setZoom: function(value) {
                if (this._engine.isInvertible() && this._changeZoom(value)) {
                    this._triggerZoomChanged()
                }
            },
            getScaledZoom: function() {
                return _round((this._scale.length - 1) * _ln(this._zoom) / _ln(this._maxZoom))
            },
            setScaledZoom: function(scaledZoom) {
                this.setZoom(this._scale[_round(scaledZoom)])
            },
            changeScaledZoom: function(deltaZoom) {
                this.setZoom(this._scale[_max(_min(_round(this.getScaledZoom() + deltaZoom), this._scale.length - 1), 0)])
            },
            getZoomScalePartition: function() {
                return this._scale.length - 1
            },
            _setupScaling: function() {
                var that = this;
                var k = _max(_round(TWO_TO_LN2 * _ln(that._maxZoom)), 4);
                var step = _pow(that._maxZoom, 1 / k);
                var zoom = that._minZoom;
                that._scale = [zoom];
                for (var i = 1; i <= k; ++i) {
                    that._scale.push(zoom *= step)
                }
            },
            setMaxZoom: function(maxZoom) {
                var that = this;
                that._minZoom = DEFAULT_MIN_ZOOM;
                that._maxZoom = parseAndClamp(maxZoom, that._minZoom, _Number.MAX_VALUE, DEFAULT_MAX_ZOOM);
                that._setupScaling();
                if (that._zoom > that._maxZoom) {
                    that.setZoom(that._maxZoom)
                }
                that._fire("max-zoom")
            },
            getCenter: function() {
                return this._center.slice()
            },
            setCenter: function(value) {
                if (this._engine.isInvertible() && this._changeCenter(value || [])) {
                    this._triggerCenterChanged()
                }
            },
            _changeCenter: function(value) {
                var that = this;
                var engine = that._engine;
                var oldCenter = that._center;
                var newCenter = that._center = parseAndClampArray(value, engine.min(), engine.max(), engine.center());
                var isChanged = !arraysEqual(oldCenter, newCenter);
                if (isChanged) {
                    that._adjustCenter();
                    that._fire("center")
                }
                return isChanged
            },
            _triggerCenterChanged: function() {
                this._params.centerChanged(this.getCenter())
            },
            _triggerZoomChanged: function() {
                this._params.zoomChanged(this.getZoom())
            },
            setCenterByPoint: function(coordinates, screenPosition) {
                var that = this;
                var p = that._engine.project(coordinates);
                var q = that._fromScreen(screenPosition);
                that.setCenter(that._engine.unproject([-q[0] / that._zoom + p[0], -q[1] / that._zoom + p[1]]))
            },
            beginMoveCenter: function() {
                if (this._engine.isInvertible()) {
                    this._moveCenter = this._center
                }
            },
            endMoveCenter: function() {
                var that = this;
                if (that._moveCenter) {
                    if (!arraysEqual(that._moveCenter, that._center)) {
                        that._triggerCenterChanged()
                    }
                    that._moveCenter = null
                }
            },
            moveCenter: function(shift) {
                var that = this;
                if (that._moveCenter) {
                    var current = that.toScreenPoint(that._center);
                    that._changeCenter(that.fromScreenPoint([current[0] + shift[0], current[1] + shift[1]]))
                }
            },
            getViewport: function() {
                var that = this;
                var unproject = that._engine.unproject;
                var lt = unproject(that._fromTransformed([-1, -1]));
                var lb = unproject(that._fromTransformed([-1, 1]));
                var rt = unproject(that._fromTransformed([1, -1]));
                var rb = unproject(that._fromTransformed([1, 1]));
                var minMax = findMinMax([selectFarthestPoint(lt[0], lb[0], rt[0], rb[0]), selectFarthestPoint(lt[1], rt[1], lb[1], rb[1])], [selectFarthestPoint(rt[0], rb[0], lt[0], lb[0]), selectFarthestPoint(lb[1], rb[1], lt[1], rt[1])]);
                return [].concat(minMax.min, minMax.max)
            },
            setViewport: function(viewport) {
                var engine = this._engine;
                var data = viewport ? getZoomAndCenterFromViewport(engine.project, engine.unproject, viewport) : [this._minZoom, engine.center()];
                this.setZoom(data[0]);
                this.setCenter(data[1])
            },
            getTransform: function() {
                return {
                    translateX: this._xCenter * this._xRadius,
                    translateY: this._yCenter * this._yRadius
                }
            },
            fromScreenPoint: function(coordinates) {
                return this._engine.unproject(this._fromTransformed(this._fromScreen(coordinates)))
            },
            toScreenPoint: function(coordinates) {
                return this._toScreen(this._toTransformed(this._engine.project(coordinates)))
            },
            _eventNames: ["engine", "screen", "center", "zoom", "max-zoom"]
        };
        (0, _event_emitter.makeEventEmitter)(Projection);

        function selectFarthestPoint(point1, point2, basePoint1, basePoint2) {
            var basePoint = (basePoint1 + basePoint2) / 2;
            return _abs(point1 - basePoint) > _abs(point2 - basePoint) ? point1 : point2
        }

        function selectClosestPoint(point1, point2, basePoint1, basePoint2) {
            var basePoint = (basePoint1 + basePoint2) / 2;
            return _abs(point1 - basePoint) < _abs(point2 - basePoint) ? point1 : point2
        }

        function getZoomAndCenterFromViewport(project, unproject, viewport) {
            var lt = project([viewport[0], viewport[3]]);
            var lb = project([viewport[0], viewport[1]]);
            var rt = project([viewport[2], viewport[3]]);
            var rb = project([viewport[2], viewport[1]]);
            var l = selectClosestPoint(lt[0], lb[0], rt[0], rb[0]);
            var r = selectClosestPoint(rt[0], rb[0], lt[0], lb[0]);
            var t = selectClosestPoint(lt[1], rt[1], lb[1], rb[1]);
            var b = selectClosestPoint(lb[1], rb[1], lt[1], rt[1]);
            return [2 / _max(_abs(l - r), _abs(t - b)), unproject([(l + r) / 2, (t + b) / 2])]
        }

        function setMinMax(engine, p1, p2) {
            var _findMinMax = findMinMax(p1, p2),
                min = _findMinMax.min,
                max = _findMinMax.max;
            engine.min = returnArray(min);
            engine.max = returnArray(max)
        }
        var Engine = function() {
            function Engine(parameters) {
                var that = this;
                var project = createProjectMethod(parameters.to);
                var unproject = parameters.from ? createUnprojectMethod(parameters.from) : returnValue(DEFAULT_CENTER);
                that.project = project;
                that.unproject = unproject;
                that.original = returnValue(that);
                that.source = function() {
                    return (0, _extend.extend)({}, parameters)
                };
                that.isInvertible = returnValue(!!parameters.from);
                that.ar = returnValue(parameters.aspectRatio > 0 ? _Number(parameters.aspectRatio) : 1);
                that.center = returnArray(unproject([0, 0]));
                setMinMax(that, [unproject([-1, 0])[0], unproject([0, 1])[1]], [unproject([1, 0])[0], unproject([0, -1])[1]])
            }
            var _proto = Engine.prototype;
            _proto.aspectRatio = function(_aspectRatio) {
                var engine = new Engine((0, _extend.extend)(this.source(), {
                    aspectRatio: _aspectRatio
                }));
                engine.original = this.original;
                engine.min = this.min;
                engine.max = this.max;
                return engine
            };
            _proto.bounds = function(_bounds) {
                _bounds = _bounds || [];
                var parameters = this.source();
                var min = this.min();
                var max = this.max();
                var b1 = parseAndClampArray([_bounds[0], _bounds[1]], min, max, min);
                var b2 = parseAndClampArray([_bounds[2], _bounds[3]], min, max, max);
                var p1 = parameters.to(b1);
                var p2 = parameters.to(b2);
                var delta = _min(_abs(p2[0] - p1[0]) > MIN_BOUNDS_RANGE ? _abs(p2[0] - p1[0]) : 2, _abs(p2[1] - p1[1]) > MIN_BOUNDS_RANGE ? _abs(p2[1] - p1[1]) : 2);
                if (delta < 2) {
                    (0, _extend.extend)(parameters, createProjectUnprojectMethods(parameters.to, parameters.from, p1, p2, delta))
                }
                var engine = new Engine(parameters);
                engine.original = this.original;
                setMinMax(engine, b1, b2);
                return engine
            };
            return Engine
        }();

        function invertVerticalAxis(pair) {
            return [pair[0], -pair[1]]
        }

        function createProjectMethod(method) {
            return function(arg) {
                return invertVerticalAxis(method(arg))
            }
        }

        function createUnprojectMethod(method) {
            return function(arg) {
                return method(invertVerticalAxis(arg))
            }
        }

        function returnValue(value) {
            return function() {
                return value
            }
        }

        function returnArray(value) {
            return function() {
                return value.slice()
            }
        }

        function findMinMax(p1, p2) {
            return {
                min: [_min(p1[0], p2[0]), _min(p1[1], p2[1])],
                max: [_max(p1[0], p2[0]), _max(p1[1], p2[1])]
            }
        }
        var projection = function(parameters) {
            return parameters && parameters.to ? new Engine(parameters) : null
        };
        exports.projection = projection;
        var projectionsCache = {};
        projection.get = function(name) {
            return projectionsCache[name] || null
        };
        projection.add = function(name, engine) {
            engine = engine instanceof Engine && engine || projection(engine);
            if (!projectionsCache[name] && engine) {
                projectionsCache[name] = engine
            }
            return projection
        };

        function createProjectUnprojectMethods(project, unproject, p1, p2, delta) {
            var x0 = (p1[0] + p2[0]) / 2 - delta / 2;
            var y0 = (p1[1] + p2[1]) / 2 - delta / 2;
            var k = 2 / delta;
            return {
                to: function(coordinates) {
                    var _project = project(coordinates),
                        _project2 = _slicedToArray(_project, 2),
                        p0 = _project2[0],
                        p1 = _project2[1];
                    return [-1 + (p0 - x0) * k, -1 + (p1 - y0) * k]
                },
                from: function(coordinates) {
                    return unproject([x0 + (coordinates[0] + 1) / k, y0 + (coordinates[1] + 1) / k])
                }
            }
        }
    },
    /*!******************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/vector_map/event_emitter.js ***!
      \******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.makeEventEmitter = makeEventEmitter;
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/callbacks */ 27));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var eventEmitterMethods = {
            _initEvents: function() {
                var names = this._eventNames;
                var i;
                var ii = names.length;
                var events = this._events = {};
                for (i = 0; i < ii; ++i) {
                    events[names[i]] = (0, _callbacks.default)()
                }
            },
            _disposeEvents: function() {
                var events = this._events;
                var name;
                for (name in events) {
                    events[name].empty()
                }
                this._events = null
            },
            on: function(handlers) {
                var events = this._events;
                var name;
                for (name in handlers) {
                    events[name].add(handlers[name])
                }
                return dispose;

                function dispose() {
                    for (name in handlers) {
                        events[name].remove(handlers[name])
                    }
                }
            },
            _fire: function(name, arg) {
                this._events[name].fire(arg)
            }
        };

        function makeEventEmitter(target) {
            var proto = target.prototype;
            var name;
            for (name in eventEmitterMethods) {
                proto[name] = eventEmitterMethods[name]
            }
        }
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/vector_map/projection.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        Object.defineProperty(exports, "projection", {
            enumerable: true,
            get: function() {
                return _projection.projection
            }
        });
        var _projection = __webpack_require__( /*! ./projection.main */ 479);
        var _min = Math.min;
        var _max = Math.max;
        var _sin = Math.sin;
        var _asin = Math.asin;
        var _tan = Math.tan;
        var _atan = Math.atan;
        var _exp = Math.exp;
        var _log = Math.log;
        var PI = Math.PI;
        var PI_DIV_4 = PI / 4;
        var GEO_LON_BOUND = 180;
        var GEO_LAT_BOUND = 90;
        var RADIANS = PI / 180;
        var MERCATOR_LAT_BOUND = (2 * _atan(_exp(PI)) - PI / 2) / RADIANS;
        var MILLER_LAT_BOUND = (2.5 * _atan(_exp(.8 * PI)) - .625 * PI) / RADIANS;

        function clamp(value, threshold) {
            return _max(_min(value, +threshold), -threshold)
        }
        _projection.projection.add("mercator", (0, _projection.projection)({
            aspectRatio: 1,
            to: function(coordinates) {
                return [coordinates[0] / GEO_LON_BOUND, _log(_tan(PI_DIV_4 + clamp(coordinates[1], MERCATOR_LAT_BOUND) * RADIANS / 2)) / PI]
            },
            from: function(coordinates) {
                return [coordinates[0] * GEO_LON_BOUND, (2 * _atan(_exp(coordinates[1] * PI)) - PI / 2) / RADIANS]
            }
        }));
        _projection.projection.add("equirectangular", (0, _projection.projection)({
            aspectRatio: 2,
            to: function(coordinates) {
                return [coordinates[0] / GEO_LON_BOUND, coordinates[1] / GEO_LAT_BOUND]
            },
            from: function(coordinates) {
                return [coordinates[0] * GEO_LON_BOUND, coordinates[1] * GEO_LAT_BOUND]
            }
        }));
        _projection.projection.add("lambert", (0, _projection.projection)({
            aspectRatio: 2,
            to: function(coordinates) {
                return [coordinates[0] / GEO_LON_BOUND, _sin(clamp(coordinates[1], GEO_LAT_BOUND) * RADIANS)]
            },
            from: function(coordinates) {
                return [coordinates[0] * GEO_LON_BOUND, _asin(clamp(coordinates[1], 1)) / RADIANS]
            }
        }));
        _projection.projection.add("miller", (0, _projection.projection)({
            aspectRatio: 1,
            to: function(coordinates) {
                return [coordinates[0] / GEO_LON_BOUND, 1.25 * _log(_tan(PI_DIV_4 + clamp(coordinates[1], MILLER_LAT_BOUND) * RADIANS * .4)) / PI]
            },
            from: function(coordinates) {
                return [coordinates[0] * GEO_LON_BOUND, (2.5 * _atan(_exp(.8 * coordinates[1] * PI)) - .625 * PI) / RADIANS]
            }
        }))
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/sparklines/base_sparkline.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _base_widget = _interopRequireDefault(__webpack_require__( /*! ../core/base_widget */ 113));
        var _extend2 = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../../events/pointer */ 24));
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _translator2d = __webpack_require__( /*! ../translators/translator2d */ 318);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _tooltip = __webpack_require__( /*! ../core/tooltip */ 123);
        var _export = __webpack_require__( /*! ../core/export */ 108);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DEFAULT_LINE_SPACING = 2;
        var EVENT_NS = "sparkline-tooltip";
        var POINTER_ACTION = (0, _index.addNamespace)([_pointer.default.down, _pointer.default.move], EVENT_NS);
        var _extend = _extend2.extend;
        var _floor = Math.floor;

        function inCanvas(_ref, x, y) {
            var left = _ref.left,
                top = _ref.top,
                bottom = _ref.bottom,
                right = _ref.right,
                width = _ref.width,
                height = _ref.height;
            return (0, _utils.pointInCanvas)({
                left: left,
                top: top,
                right: width - right,
                bottom: height - bottom,
                width: width,
                height: height
            }, x, y)
        }

        function pointerHandler(_ref2) {
            var data = _ref2.data;
            var that = data.widget;
            that._enableOutHandler();
            that._showTooltip()
        }

        function generateDefaultCustomizeTooltipCallback(fontOptions, rtlEnabled) {
            var lineSpacing = fontOptions.lineSpacing;
            var lineHeight = (void 0 !== lineSpacing && null !== lineSpacing ? lineSpacing : DEFAULT_LINE_SPACING) + fontOptions.size;
            return function(customizeObject) {
                var html = "";
                var vt = customizeObject.valueText;
                for (var i = 0; i < vt.length; i += 2) {
                    html += "<tr><td>" + vt[i] + "</td><td style='width: 15px'></td><td style='text-align: " + (rtlEnabled ? "left" : "right") + "'>" + vt[i + 1] + "</td></tr>"
                }
                return {
                    html: "<table style='border-spacing:0px; line-height: " + lineHeight + "px'>" + html + "</table>"
                }
            }
        }

        function generateCustomizeTooltipCallback(customizeTooltip, fontOptions, rtlEnabled) {
            var defaultCustomizeTooltip = generateDefaultCustomizeTooltipCallback(fontOptions, rtlEnabled);
            if ((0, _type.isFunction)(customizeTooltip)) {
                return function(customizeObject) {
                    var res = customizeTooltip.call(customizeObject, customizeObject);
                    if (!("html" in res) && !("text" in res)) {
                        _extend(res, defaultCustomizeTooltip.call(customizeObject, customizeObject))
                    }
                    return res
                }
            } else {
                return defaultCustomizeTooltip
            }
        }

        function createAxis(isHorizontal) {
            var translator = new _translator2d.Translator2D({}, {}, {
                shiftZeroValue: !isHorizontal,
                isHorizontal: !!isHorizontal
            });
            return {
                getTranslator: function() {
                    return translator
                },
                update: function(range, canvas, options) {
                    translator.update(range, canvas, options)
                },
                getVisibleArea: function() {
                    var visibleArea = translator.getCanvasVisibleArea();
                    return [visibleArea.min, visibleArea.max]
                },
                visualRange: _common.noop,
                calculateInterval: _common.noop,
                getMarginOptions: function() {
                    return {}
                }
            }
        }
        var _initTooltip;
        var BaseSparkline = _base_widget.default.inherit({
            _getLayoutItems: _common.noop,
            _useLinks: false,
            _themeDependentChanges: ["OPTIONS"],
            _initCore: function() {
                var that = this;
                that._tooltipTracker = that._renderer.root;
                that._tooltipTracker.attr({
                    "pointer-events": "visible"
                });
                that._createHtmlElements();
                that._initTooltipEvents();
                that._argumentAxis = createAxis(true);
                that._valueAxis = createAxis()
            },
            _getDefaultSize: function() {
                return this._defaultSize
            },
            _disposeCore: function() {
                this._disposeWidgetElements();
                this._disposeTooltipEvents();
                this._ranges = null
            },
            _optionChangesOrder: ["OPTIONS"],
            _change_OPTIONS: function() {
                this._prepareOptions();
                this._change(["UPDATE"])
            },
            _customChangesOrder: ["UPDATE"],
            _change_UPDATE: function() {
                this._update()
            },
            _update: function() {
                var that = this;
                if (that._tooltipShown) {
                    that._tooltipShown = false;
                    that._tooltip.hide()
                }
                that._cleanWidgetElements();
                that._updateWidgetElements();
                that._drawWidgetElements()
            },
            _updateWidgetElements: function() {
                var canvas = this._getCorrectCanvas();
                this._updateRange();
                this._argumentAxis.update(this._ranges.arg, canvas, this._getStick());
                this._valueAxis.update(this._ranges.val, canvas)
            },
            _getStick: function() {},
            _applySize: function(rect) {
                this._allOptions.size = {
                    width: rect[2] - rect[0],
                    height: rect[3] - rect[1]
                };
                this._change(["UPDATE"])
            },
            _setupResizeHandler: _common.noop,
            _prepareOptions: function() {
                return _extend(true, {}, this._themeManager.theme(), this.option())
            },
            _getTooltipCoords: function() {
                var canvas = this._canvas;
                var rootOffset = this._renderer.getRootOffset();
                return {
                    x: canvas.width / 2 + rootOffset.left,
                    y: canvas.height / 2 + rootOffset.top
                }
            },
            _initTooltipEvents: function() {
                var data = {
                    widget: this
                };
                this._renderer.root.off("." + EVENT_NS).on(POINTER_ACTION, data, pointerHandler)
            },
            _showTooltip: function() {
                var that = this;
                var tooltip;
                if (!that._tooltipShown) {
                    that._tooltipShown = true;
                    tooltip = that._getTooltip();
                    tooltip.isEnabled() && that._tooltip.show(that._getTooltipData(), that._getTooltipCoords(), {})
                }
            },
            _hideTooltip: function() {
                if (this._tooltipShown) {
                    this._tooltipShown = false;
                    this._tooltip.hide()
                }
            },
            _stopCurrentHandling: function() {
                this._hideTooltip()
            },
            _enableOutHandler: function() {
                var that = this;
                if (that._outHandler) {
                    return
                }
                var handler = function(_ref3) {
                    var pageX = _ref3.pageX,
                        pageY = _ref3.pageY;
                    var _that$_renderer$getRo = that._renderer.getRootOffset(),
                        left = _that$_renderer$getRo.left,
                        top = _that$_renderer$getRo.top;
                    var x = _floor(pageX - left);
                    var y = _floor(pageY - top);
                    if (!inCanvas(that._canvas, x, y)) {
                        that._hideTooltip();
                        that._disableOutHandler()
                    }
                };
                _events_engine.default.on(_dom_adapter.default.getDocument(), POINTER_ACTION, handler);
                this._outHandler = handler
            },
            _disableOutHandler: function() {
                this._outHandler && _events_engine.default.off(_dom_adapter.default.getDocument(), POINTER_ACTION, this._outHandler);
                this._outHandler = null
            },
            _disposeTooltipEvents: function() {
                this._tooltipTracker.off();
                this._disableOutHandler();
                this._renderer.root.off("." + EVENT_NS)
            },
            _getTooltip: function() {
                var that = this;
                if (!that._tooltip) {
                    _initTooltip.apply(this, arguments);
                    that._setTooltipRendererOptions(that._tooltipRendererOptions);
                    that._tooltipRendererOptions = null;
                    that._setTooltipOptions()
                }
                return that._tooltip
            }
        });
        var _default = BaseSparkline;
        exports.default = _default;
        BaseSparkline.addPlugin(_tooltip.plugin);
        _initTooltip = BaseSparkline.prototype._initTooltip;
        BaseSparkline.prototype._initTooltip = _common.noop;
        var _disposeTooltip = BaseSparkline.prototype._disposeTooltip;
        BaseSparkline.prototype._disposeTooltip = function() {
            if (this._tooltip) {
                _disposeTooltip.apply(this, arguments)
            }
        };
        BaseSparkline.prototype._setTooltipRendererOptions = function() {
            var options = this._getRendererOptions();
            if (this._tooltip) {
                this._tooltip.setRendererOptions(options)
            } else {
                this._tooltipRendererOptions = options
            }
        };
        BaseSparkline.prototype._setTooltipOptions = function() {
            var tooltip = this._tooltip;
            var options = tooltip && this._getOption("tooltip");
            tooltip && tooltip.update(_extend({}, options, {
                customizeTooltip: generateCustomizeTooltipCallback(options.customizeTooltip, options.font, this.option("rtlEnabled")),
                enabled: options.enabled && this._isTooltipEnabled()
            }))
        };
        var exportPlugin = (0, _extend2.extend)(true, {}, _export.plugin, {
            init: _common.noop,
            dispose: _common.noop,
            customize: null,
            members: {
                _getExportMenuOptions: null
            }
        });
        BaseSparkline.addPlugin(exportPlugin);
        module.exports = exports.default
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/tree_map/tiling.squarified.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _tilingSquarified = _interopRequireDefault(__webpack_require__( /*! ./tiling.squarified.base */ 484));
        var _tiling = __webpack_require__( /*! ./tiling */ 165);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _max = Math.max;

        function accumulate(total, current) {
            return _max(total, current)
        }

        function squarified(data) {
            return (0, _tilingSquarified.default)(data, accumulate, false)
        }(0, _tiling.addAlgorithm)("squarified", squarified);
        var _default = squarified;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/tree_map/tiling.squarified.base.js ***!
      \*************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = _default;
        var _tiling = __webpack_require__( /*! ./tiling */ 165);
        var _max = Math.max;
        var _round = Math.round;

        function compare(a, b) {
            return b.value - a.value
        }

        function getAspectRatio(value) {
            return _max(value, 1 / value)
        }

        function findAppropriateCollection(nodes, head, context) {
            var bestAspectRatio = 1 / 0;
            var nextAspectRatio;
            var sum = 0;
            var nextSum;
            var i;
            var j;
            var ii = nodes.length;
            var coeff = context.areaToValue / context.staticSide;
            var totalAspectRatio;
            for (i = head; i < ii;) {
                nextSum = sum + nodes[i].value;
                totalAspectRatio = context.staticSide / coeff / nextSum;
                nextAspectRatio = 0;
                for (j = head; j <= i; ++j) {
                    nextAspectRatio = context.accumulate(nextAspectRatio, getAspectRatio(totalAspectRatio * nodes[j].value / nextSum), j - head + 1)
                }
                if (nextAspectRatio < bestAspectRatio) {
                    bestAspectRatio = nextAspectRatio;
                    sum = nextSum;
                    ++i
                } else {
                    break
                }
            }
            return {
                sum: sum,
                count: i - head,
                side: _round(coeff * sum)
            }
        }

        function getArea(rect) {
            return (rect[2] - rect[0]) * (rect[3] - rect[1])
        }

        function doStep(nodes, head, context) {
            var sidesData = (0, _tiling.buildSidesData)(context.rect, context.directions, context.staticSideIndex);
            var area = getArea(context.rect);
            var rowData = area > 0 ? findAppropriateCollection(nodes, head, {
                areaToValue: area / context.sum,
                accumulate: context.accumulate,
                staticSide: sidesData.staticSide
            }) : {
                sum: 1,
                side: sidesData.variedSide,
                count: nodes.length - head
            };
            (0, _tiling.calculateRectangles)(nodes, head, context.rect, sidesData, rowData);
            context.sum -= rowData.sum;
            return head + rowData.count
        }

        function _default(data, accumulate, isFixedStaticSide) {
            var items = data.items;
            var ii = items.length;
            var i;
            var context = {
                sum: data.sum,
                rect: data.rect,
                directions: data.directions,
                accumulate: accumulate
            };
            if (isFixedStaticSide) {
                context.staticSideIndex = (0, _tiling.getStaticSideIndex)(context.rect)
            }
            items.sort(compare);
            for (i = 0; i < ii;) {
                i = doStep(items, i, context)
            }
        }
        module.exports = exports.default
    },
    /*!**********************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/tree_map/colorizing.discrete.js ***!
      \**********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _colorizing = __webpack_require__( /*! ./colorizing */ 230);

        function discreteColorizer(options, themeManager, root) {
            var palette = themeManager.createPalette(options.palette, {
                useHighlight: true,
                extensionMode: options.paletteExtensionMode,
                count: options.colorizeGroups ? getNodesCount(root) : getLeafsCount(root)
            });
            return (options.colorizeGroups ? discreteGroupColorizer : discreteLeafColorizer)(palette, root)
        }

        function getLeafsCount(root) {
            var allNodes = root.nodes.slice();
            var i;
            var ii = allNodes.length;
            var count = 0;
            var node;
            for (i = 0; i < ii; ++i) {
                node = allNodes[i];
                if (node.isNode()) {
                    count = Math.max(count, getLeafsCount(node))
                } else {
                    count += 1
                }
            }
            return count
        }

        function discreteLeafColorizer(palette) {
            var colors = palette.generateColors();
            return function(node) {
                return colors[node.index]
            }
        }

        function getNodesCount(root) {
            var allNodes = root.nodes.slice();
            var i;
            var ii = allNodes.length;
            var count = 0;
            var node;
            for (i = 0; i < ii; ++i) {
                node = allNodes[i];
                if (node.isNode()) {
                    count += getNodesCount(node) + 1
                }
            }
            return count
        }

        function prepareDiscreteGroupColors(palette, root) {
            var colors = {};
            var allNodes = root.nodes.slice();
            var i;
            var ii = allNodes.length;
            var node;
            for (i = 0; i < ii; ++i) {
                node = allNodes[i];
                if (node.isNode()) {
                    allNodes = allNodes.concat(node.nodes);
                    ii = allNodes.length
                } else {
                    if (!colors[node.parent._id]) {
                        colors[node.parent._id] = palette.getNextColor()
                    }
                }
            }
            return colors
        }

        function discreteGroupColorizer(palette, root) {
            var colors = prepareDiscreteGroupColors(palette, root);
            return function(node) {
                return colors[node._id]
            }
        }(0, _colorizing.addColorizer)("discrete", discreteColorizer);
        var _default = discreteColorizer;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/tree_map/hover.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _tree_map = _interopRequireDefault(__webpack_require__( /*! ./tree_map.base */ 109));
        var _node = _interopRequireDefault(__webpack_require__( /*! ./node */ 190));
        var _helpers = __webpack_require__( /*! ../core/helpers */ 162);
        var _common = __webpack_require__( /*! ./common */ 320);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        __webpack_require__( /*! ./api */ 166);
        __webpack_require__( /*! ./states */ 487);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var proto = _tree_map.default.prototype;
        var nodeProto = _node.default.prototype;
        var STATE_CODE = 1;
        proto._eventsMap.onHoverChanged = {
            name: "hoverChanged"
        };
        (0, _helpers.expand)(proto._handlers, "calculateAdditionalStates", function(states, options) {
            states[1] = options.hoverStyle ? (0, _common.buildRectAppearance)(options.hoverStyle) : {}
        });
        _tree_map.default.addChange({
            code: "HOVER_ENABLED",
            handler: function() {
                var hoverEnabled = (0, _utils.parseScalar)(this._getOption("hoverEnabled", true), true);
                if (!hoverEnabled) {
                    this.clearHover()
                }
                this._hoverEnabled = hoverEnabled
            },
            isThemeDependent: true,
            isOptionChange: true,
            option: "hoverEnabled"
        });
        nodeProto.statesMap[1] = 1;
        nodeProto.additionalStates.push(1);
        (0, _helpers.expand)(proto, "_extendProxyType", function(proto) {
            var that = this;
            proto.setHover = function() {
                that._hoverNode(this._id)
            };
            proto.isHovered = function() {
                return that._hoverIndex === this._id
            }
        });
        (0, _helpers.expand)(proto, "_onNodesCreated", function() {
            this._hoverIndex = -1
        });
        (0, _helpers.expand)(proto, "_changeGroupSettings", function() {
            var that = this;
            that._groupHoverEnabled = (0, _utils.parseScalar)(that._getOption("group").hoverEnabled, true);
            if (!that._groupHoverEnabled) {
                that.clearHover()
            }
        });
        proto._applyHoverState = function(index, state) {
            setNodeStateRecursive(this._nodes[index], STATE_CODE, state);
            this._eventTrigger("hoverChanged", {
                node: this._nodes[index].proxy
            })
        };

        function setNodeStateRecursive(node, code, state) {
            var nodes = node.isNode() && node.nodes;
            var i;
            var ii = nodes && nodes.length;
            node.setState(code, state);
            for (i = 0; i < ii; ++i) {
                setNodeStateRecursive(nodes[i], code, state)
            }
        }
        proto._hoverNode = function(index) {
            var that = this;
            var currentIndex = that._hoverIndex;
            if (that._hoverEnabled && currentIndex !== index) {
                if (!that._groupHoverEnabled && index >= 0 && that._nodes[index].isNode()) {
                    that.clearHover();
                    return
                }
                that._context.suspend();
                that._hoverIndex = -1;
                if (currentIndex >= 0) {
                    that._applyHoverState(currentIndex, false)
                }
                that._hoverIndex = index;
                if (index >= 0) {
                    that._applyHoverState(index, true)
                }
                that._context.resume()
            }
        };
        proto.clearHover = function() {
            this._hoverNode(-1)
        }
    },
    /*!*********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/tree_map/states.js ***!
      \*********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _tree_map = _interopRequireDefault(__webpack_require__( /*! ./tree_map.base */ 109));
        var _node = _interopRequireDefault(__webpack_require__( /*! ./node */ 190));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _extend2 = __webpack_require__( /*! ../../core/utils/extend */ 0);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var proto = _tree_map.default.prototype;
        var nodeProto = _node.default.prototype;
        var handlers = proto._handlers;
        var _calculateState = handlers.calculateState;
        var _buildState = nodeProto._buildState;
        handlers.calculateState = function(options) {
            var states = {
                0: _calculateState(options)
            };
            handlers.calculateAdditionalStates(states, options);
            return states
        };
        handlers.calculateAdditionalStates = _common.noop;
        nodeProto.code = 0;
        nodeProto.statesMap = {
            0: 0
        };
        nodeProto.additionalStates = [];
        nodeProto._buildState = function(state, extra) {
            var states = {
                0: _buildState(state[0], extra)
            };
            if (this.additionalStates.length) {
                buildAdditionalStates(states, states[0], state, this.additionalStates)
            }
            return states
        };
        nodeProto._getState = function() {
            return this.state[this.statesMap[this.code]]
        };
        nodeProto.setState = function(code, state) {
            if (state) {
                this.code |= code
            } else {
                this.code &= ~code
            }
            this.ctx.change(["TILES"])
        };

        function buildAdditionalStates(states, base, source, list) {
            var i;
            var ii = list.length;
            for (i = 0; i < ii; ++i) {
                states[list[i]] = (0, _extend2.extend)({}, base, source[list[i]])
            }
        }
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/tree_map/tooltip.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _helpers = __webpack_require__( /*! ../core/helpers */ 162);
        var _tree_map = _interopRequireDefault(__webpack_require__( /*! ./tree_map.base */ 109));
        __webpack_require__( /*! ./api */ 166);
        var _tooltip = __webpack_require__( /*! ../core/tooltip */ 123);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var proto = _tree_map.default.prototype;
        (0, _helpers.expand)(proto, "_extendProxyType", function(proto) {
            var that = this;
            proto.showTooltip = function(coords) {
                that._showTooltip(this._id, coords)
            }
        });
        (0, _helpers.expand)(proto, "_onNodesCreated", function() {
            if (this._tooltipIndex >= 0) {
                this._tooltip.hide()
            }
            this._tooltipIndex = -1
        });
        (0, _helpers.expand)(proto, "_onTilingPerformed", function() {
            if (this._tooltipIndex >= 0) {
                this._moveTooltip(this._nodes[this._tooltipIndex])
            }
        });

        function getCoords(coords, rect, renderer) {
            var offset = renderer.getRootOffset();
            return coords || rect && [(rect[0] + rect[2]) / 2 + offset.left, (rect[1] + rect[3]) / 2 + offset.top] || [-1e3, -1e3]
        }
        proto._showTooltip = function(index, coords) {
            var that = this;
            var tooltip = that._tooltip;
            var node = that._nodes[index];
            if (that._tooltipIndex === index) {
                that._moveTooltip(node, coords);
                return
            }
            var callback = function(result) {
                if (void 0 === result) {
                    return
                }
                if (!result) {
                    tooltip.hide()
                }
                that._tooltipIndex = result ? index : -1
            };
            var xy = getCoords(coords, node.rect, this._renderer);
            callback(tooltip.show({
                value: node.value,
                valueText: tooltip.formatValue(node.value),
                node: node.proxy
            }, {
                x: xy[0],
                y: xy[1],
                offset: 0
            }, {
                node: node.proxy
            }, void 0, callback))
        };
        proto._moveTooltip = function(node, coords) {
            var xy = getCoords(coords, node.rect, this._renderer);
            this._tooltip.move(xy[0], xy[1], 0)
        };
        proto.hideTooltip = function() {
            if (this._tooltipIndex >= 0) {
                this._tooltipIndex = -1;
                this._tooltip.hide()
            }
        };
        _tree_map.default.addPlugin(_tooltip.plugin)
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/funnel/funnel.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _tiling = __webpack_require__( /*! ./tiling */ 989);
        var _tiling2 = _interopRequireDefault(__webpack_require__( /*! ./tiling.funnel */ 990));
        var _tiling3 = _interopRequireDefault(__webpack_require__( /*! ./tiling.pyramid */ 991));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _base_widget = _interopRequireDefault(__webpack_require__( /*! ../core/base_widget */ 113));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _item = _interopRequireDefault(__webpack_require__( /*! ./item */ 992));
        var _data_source = __webpack_require__( /*! ../core/data_source */ 164);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var NODES_CREATE_CHANGE = "NODES_CREATE";
        (0, _tiling.addAlgorithm)("dynamicslope", _tiling2.default, true);
        (0, _tiling.addAlgorithm)("dynamicheight", _tiling3.default);

        function invertFigure(figure) {
            return figure.map(function(coord, index) {
                return index % 2 ? 1 - coord : coord
            })
        }

        function getLegendItemState(itemState) {
            return {
                fill: itemState.fill,
                hatching: itemState.hatching
            }
        }
        var dxFunnel = _base_widget.default.inherit({
            _rootClass: "dxf-funnel",
            _rootClassPrefix: "dxf",
            _proxyData: [],
            _optionChangesMap: {
                dataSource: "DATA_SOURCE",
                neckWidth: NODES_CREATE_CHANGE,
                neckHeight: NODES_CREATE_CHANGE,
                inverted: NODES_CREATE_CHANGE,
                algorithm: NODES_CREATE_CHANGE,
                item: NODES_CREATE_CHANGE,
                valueField: NODES_CREATE_CHANGE,
                argumentField: NODES_CREATE_CHANGE,
                colorField: NODES_CREATE_CHANGE,
                palette: NODES_CREATE_CHANGE,
                paletteExtensionMode: NODES_CREATE_CHANGE,
                sortData: NODES_CREATE_CHANGE
            },
            _themeDependentChanges: [NODES_CREATE_CHANGE],
            _getDefaultSize: function() {
                return {
                    width: 400,
                    height: 400
                }
            },
            _themeSection: "funnel",
            _fontFields: ["legend.title.font", "legend.title.subtitle.font", "legend.font"],
            _optionChangesOrder: ["DATA_SOURCE"],
            _initialChanges: ["DATA_SOURCE"],
            _initCore: function() {
                this._group = this._renderer.g().append(this._renderer.root);
                this._items = []
            },
            _eventsMap: {
                onHoverChanged: {
                    name: "hoverChanged"
                },
                onSelectionChanged: {
                    name: "selectionChanged"
                }
            },
            _disposeCore: _common.noop,
            _applySize: function(rect) {
                this._rect = rect.slice();
                this._change(["TILING"]);
                return this._rect
            },
            _getAlignmentRect: function() {
                return this._rect
            },
            _change_TILING: function() {
                var that = this;
                var items = that._items;
                var rect = that._rect;
                var convertCoord = function(coord, index) {
                    var offset = index % 2;
                    return rect[0 + offset] + (rect[2 + offset] - rect[0 + offset]) * coord
                };
                this._group.clear();
                items.forEach(function(item, index) {
                    var coords = item.figure.map(convertCoord);
                    var element = that._renderer.path([], "area").attr({
                        points: coords
                    }).append(that._group);
                    item.coords = coords;
                    item.element = element
                });
                this._requestChange(["TILES"])
            },
            _customChangesOrder: [NODES_CREATE_CHANGE, "LAYOUT", "TILING", "TILES", "DRAWN"],
            _dataSourceChangedHandler: function() {
                this._requestChange([NODES_CREATE_CHANGE])
            },
            _change_DRAWN: function() {
                this._drawn()
            },
            _change_DATA_SOURCE: function() {
                this._change(["DRAWN"]);
                this._updateDataSource()
            },
            _change_NODES_CREATE: function() {
                this._buildNodes()
            },
            _change_TILES: function() {
                this._applyTilesAppearance()
            },
            _suspend: function() {
                if (!this._applyingChanges) {
                    this._suspendChanges()
                }
            },
            _resume: function() {
                if (!this._applyingChanges) {
                    this._resumeChanges()
                }
            },
            _applyTilesAppearance: function() {
                this._items.forEach(function(item) {
                    var state = item.getState();
                    item.element.smartAttr(item.states[state])
                })
            },
            _hitTestTargets: function(x, y) {
                var that = this;
                var data;
                this._proxyData.some(function(callback) {
                    data = callback.call(that, x, y);
                    if (data) {
                        return true
                    }
                });
                return data
            },
            clearHover: function() {
                this._suspend();
                this._items.forEach(function(item) {
                    item.isHovered() && item.hover(false)
                });
                this._resume()
            },
            clearSelection: function() {
                this._suspend();
                this._items.forEach(function(item) {
                    item.isSelected() && item.select(false)
                });
                this._resume()
            },
            _getData: function() {
                var that = this;
                var data = that._dataSourceItems() || [];
                var valueField = that._getOption("valueField", true);
                var argumentField = that._getOption("argumentField", true);
                var colorField = that._getOption("colorField", true);
                var processedData = data.reduce(function(d, item) {
                    var value = Number(item[valueField]);
                    if (value >= 0) {
                        d[0].push({
                            value: value,
                            color: item[colorField],
                            argument: item[argumentField],
                            dataItem: item
                        });
                        d[1] += value
                    }
                    return d
                }, [
                    [], 0
                ]);
                var items = processedData[0];
                if (data.length > 0 && 0 === items.length) {
                    that._incidentOccurred("E2005", valueField)
                }
                if (!processedData[1]) {
                    return []
                }
                if (that._getOption("sortData", true)) {
                    items.sort(function(a, b) {
                        return b.value - a.value
                    })
                }
                return items
            },
            _buildNodes: function() {
                var that = this;
                var data = that._getData();
                var algorithm = (0, _tiling.getAlgorithm)(that._getOption("algorithm", true));
                var percents = algorithm.normalizeValues(data);
                var itemOptions = that._getOption("item");
                var figures = algorithm.getFigures(percents, that._getOption("neckWidth", true), that._getOption("neckHeight", true));
                var palette = that._themeManager.createPalette(that._getOption("palette", true), {
                    useHighlight: true,
                    extensionMode: that._getOption("paletteExtensionMode", true),
                    count: figures.length
                });
                that._items = figures.map(function(figure, index) {
                    var curData = data[index];
                    var node = new _item.default(that, {
                        figure: figure,
                        data: curData,
                        percent: percents[index],
                        id: index,
                        color: curData.color || palette.getNextColor(),
                        itemOptions: itemOptions
                    });
                    return node
                });
                if (that._getOption("inverted", true)) {
                    that._items.forEach(function(item) {
                        item.figure = invertFigure(item.figure)
                    })
                }
                that._renderer.initHatching();
                that._change(["TILING", "DRAWN"])
            },
            _showTooltip: _common.noop,
            hideTooltip: _common.noop,
            getAllItems: function() {
                return this._items.slice()
            },
            _getLegendData: function() {
                return this._items.map(function(item) {
                    var states = item.states;
                    return {
                        id: item.id,
                        visible: true,
                        text: item.argument,
                        item: item,
                        states: {
                            normal: getLegendItemState(states.normal),
                            hover: getLegendItemState(states.hover),
                            selection: getLegendItemState(states.selection)
                        }
                    }
                })
            },
            _getMinSize: function() {
                var adaptiveLayout = this._getOption("adaptiveLayout");
                return [adaptiveLayout.width, adaptiveLayout.height]
            }
        });
        (0, _component_registrator.default)("dxFunnel", dxFunnel);
        var _default = dxFunnel;
        exports.default = _default;
        dxFunnel.addPlugin(_data_source.plugin);
        module.exports = exports.default
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/sankey/sankey.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _constants = __webpack_require__( /*! ./constants */ 491);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _node_item = _interopRequireDefault(__webpack_require__( /*! ./node_item */ 997));
        var _link_item = _interopRequireDefault(__webpack_require__( /*! ./link_item */ 998));
        var _layout = _interopRequireDefault(__webpack_require__( /*! ./layout */ 999));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _base_widget = _interopRequireDefault(__webpack_require__( /*! ../core/base_widget */ 113));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _data_source = __webpack_require__( /*! ../core/data_source */ 164);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function moveLabel(node, labelOptions, availableLabelWidth, rect) {
            if (node._label.getBBox().width > availableLabelWidth) {
                node.labelText.applyEllipsis(availableLabelWidth)
            }
            var bBox = node._label.getBBox();
            var verticalOffset = labelOptions.verticalOffset;
            var horizontalOffset = labelOptions.horizontalOffset;
            var labelOffsetY = Math.round(node.rect.y + node.rect.height / 2 - bBox.y - bBox.height / 2) + verticalOffset;
            var labelOffsetX = node.rect.x + horizontalOffset + node.rect.width - bBox.x;
            if (labelOffsetX + bBox.width >= rect[2] - rect[0]) {
                labelOffsetX = node.rect.x - horizontalOffset - bBox.x - bBox.width
            }
            if (labelOffsetY >= rect[3]) {
                labelOffsetY = rect[3]
            }
            if (labelOffsetY - bBox.height < rect[1]) {
                labelOffsetY = node.rect.y - bBox.y + verticalOffset
            }
            node.labelText.attr({
                translateX: labelOffsetX,
                translateY: labelOffsetY
            })
        }

        function getConnectedLinks(layout, nodeName, linkType) {
            var result = [];
            var attrName = "in" === linkType ? "_to" : "_from";
            var invertedAttrName = "in" === linkType ? "_from" : "_to";
            layout.links.map(function(link) {
                return link[attrName]._name === nodeName
            }).forEach(function(connected, idx) {
                connected && result.push({
                    index: idx,
                    weight: layout.links[idx]._weight,
                    node: layout.links[idx][invertedAttrName]._name
                })
            });
            return result
        }
        var dxSankey = _base_widget.default.inherit({
            _rootClass: "dxs-sankey",
            _rootClassPrefix: "dxs",
            _proxyData: [],
            _optionChangesMap: {
                dataSource: "DATA_SOURCE",
                sortData: "DATA_SOURCE",
                alignment: "DATA_SOURCE",
                node: "BUILD_LAYOUT",
                link: "BUILD_LAYOUT",
                palette: "BUILD_LAYOUT",
                paletteExtensionMode: "BUILD_LAYOUT"
            },
            _themeDependentChanges: ["BUILD_LAYOUT"],
            _getDefaultSize: function() {
                return {
                    width: 400,
                    height: 400
                }
            },
            _themeSection: "sankey",
            _fontFields: ["label.font"],
            _optionChangesOrder: ["DATA_SOURCE"],
            _initialChanges: ["DATA_SOURCE"],
            _initCore: function() {
                this._groupLinks = this._renderer.g().append(this._renderer.root);
                this._groupNodes = this._renderer.g().append(this._renderer.root);
                this._groupLabels = this._renderer.g().attr({
                    "class": this._rootClassPrefix + "-labels"
                }).append(this._renderer.root);
                this._drawLabels = true;
                this._nodes = [];
                this._links = [];
                this._gradients = []
            },
            _disposeCore: _common.noop,
            _applySize: function(rect) {
                this._rect = rect.slice();
                var adaptiveLayout = this._getOption("adaptiveLayout");
                if (adaptiveLayout.keepLabels || this._rect[2] - this._rect[0] > adaptiveLayout.width) {
                    this._drawLabels = true
                } else {
                    this._drawLabels = false
                }
                this._change(["BUILD_LAYOUT"]);
                return this._rect
            },
            _eventsMap: {
                onNodeHoverChanged: {
                    name: "nodeHoverChanged"
                },
                onLinkHoverChanged: {
                    name: "linkHoverChanged"
                }
            },
            _customChangesOrder: ["BUILD_LAYOUT", "NODES_DRAW", "LINKS_DRAW", "LABELS", "DRAWN"],
            _dataSourceChangedHandler: function() {
                this._requestChange(["BUILD_LAYOUT"])
            },
            _change_DRAWN: function() {
                this._drawn()
            },
            _change_DATA_SOURCE: function() {
                this._change(["DRAWN"]);
                this._updateDataSource()
            },
            _change_LABELS: function() {
                this._applyLabelsAppearance()
            },
            _change_BUILD_LAYOUT: function() {
                this._groupNodes.clear();
                this._groupLinks.clear();
                this._groupLabels.clear();
                this._buildLayout()
            },
            _change_NODES_DRAW: function() {
                var that = this;
                var nodes = that._nodes;
                nodes.forEach(function(node, index) {
                    var element = that._renderer.rect().attr(node.rect).append(that._groupNodes);
                    node.element = element
                });
                this._applyNodesAppearance()
            },
            _change_LINKS_DRAW: function() {
                var that = this;
                var links = that._links;
                links.forEach(function(link, index) {
                    var group = that._renderer.g().attr({
                        "class": "link",
                        "data-link-idx": index
                    }).append(that._groupLinks);
                    link.overlayElement = that._renderer.path([], "area").attr({
                        d: link.d
                    }).append(group);
                    link.element = that._renderer.path([], "area").attr({
                        d: link.d
                    }).append(group)
                });
                this._applyLinksAppearance()
            },
            _suspend: function() {
                if (!this._applyingChanges) {
                    this._suspendChanges()
                }
            },
            _resume: function() {
                if (!this._applyingChanges) {
                    this._resumeChanges()
                }
            },
            _showTooltip: _common.noop,
            hideTooltip: _common.noop,
            clearHover: function() {
                this._suspend();
                this._nodes.forEach(function(node) {
                    node.isHovered() && node.hover(false)
                });
                this._links.forEach(function(link) {
                    link.isHovered() && link.hover(false);
                    link.isAdjacentNodeHovered() && link.adjacentNodeHover(false)
                });
                this._resume()
            },
            _applyNodesAppearance: function() {
                this._nodes.forEach(function(node) {
                    var state = node.getState();
                    node.element.smartAttr(node.states[state])
                })
            },
            _applyLinksAppearance: function() {
                this._links.forEach(function(link) {
                    var state = link.getState();
                    link.element.smartAttr(link.states[state]);
                    link.overlayElement.smartAttr(link.overlayStates[state])
                })
            },
            _hitTestTargets: function(x, y) {
                var that = this;
                var data;
                this._proxyData.some(function(callback) {
                    data = callback.call(that, x, y);
                    if (data) {
                        return true
                    }
                });
                return data
            },
            _getData: function() {
                var that = this;
                var data = that._dataSourceItems() || [];
                var sourceField = that._getOption("sourceField", true);
                var targetField = that._getOption("targetField", true);
                var weightField = that._getOption("weightField", true);
                var processedData = [];
                data.forEach(function(item) {
                    var hasItemOwnProperty = Object.prototype.hasOwnProperty.bind(item);
                    if (!hasItemOwnProperty(sourceField)) {
                        that._incidentOccurred("E2007", sourceField)
                    } else {
                        if (!hasItemOwnProperty(targetField)) {
                            that._incidentOccurred("E2007", targetField)
                        } else {
                            if (!hasItemOwnProperty(weightField)) {
                                that._incidentOccurred("E2007", weightField)
                            } else {
                                if (!(0, _type.isString)(item[sourceField])) {
                                    that._incidentOccurred("E2008", sourceField)
                                } else {
                                    if (!(0, _type.isString)(item[targetField])) {
                                        that._incidentOccurred("E2008", targetField)
                                    } else {
                                        if (!(0, _type.isNumeric)(item[weightField]) || item[weightField] <= 0) {
                                            that._incidentOccurred("E2009", weightField)
                                        } else {
                                            processedData.push([item[sourceField], item[targetField], item[weightField]])
                                        }
                                    }
                                }
                            }
                        }
                    }
                });
                return processedData
            },
            _buildLayout: function() {
                var _this = this;
                var that = this;
                var data = that._getData();
                var availableRect = this._rect;
                var nodeOptions = that._getOption("node");
                var sortData = that._getOption("sortData");
                var layoutBuilder = that._getOption("layoutBuilder", true) || _layout.default;
                var rect = {
                    x: availableRect[0],
                    y: availableRect[1],
                    width: availableRect[2] - availableRect[0],
                    height: availableRect[3] - availableRect[1]
                };
                var layout = layoutBuilder.computeLayout(data, sortData, {
                    availableRect: rect,
                    nodePadding: nodeOptions.padding,
                    nodeWidth: nodeOptions.width,
                    nodeAlign: that._getOption("alignment", true)
                }, that._incidentOccurred);
                that._layoutMap = layout;
                if (!Object.prototype.hasOwnProperty.call(layout, "error")) {
                    var nodeColors = {};
                    var nodeIdx = 0;
                    var linkOptions = that._getOption("link");
                    var totalNodesNum = layout.nodes.map(function(item) {
                        return item.length
                    }).reduce(function(previousValue, currentValue) {
                        return previousValue + currentValue
                    }, 0);
                    var palette = that._themeManager.createPalette(that._getOption("palette", true), {
                        useHighlight: true,
                        extensionMode: that._getOption("paletteExtensionMode", true),
                        count: totalNodesNum
                    });
                    that._nodes = [];
                    that._links = [];
                    that._gradients.forEach(function(gradient) {
                        gradient.dispose()
                    });
                    that._gradients = [];
                    that._shadowFilter && that._shadowFilter.dispose();
                    layout.nodes.forEach(function(cascadeNodes) {
                        cascadeNodes.forEach(function(node) {
                            var color = nodeOptions.color || palette.getNextColor();
                            var nodeItem = new _node_item.default(that, {
                                id: nodeIdx,
                                color: color,
                                rect: node,
                                options: nodeOptions,
                                linksIn: getConnectedLinks(layout, node._name, "in"),
                                linksOut: getConnectedLinks(layout, node._name, "out")
                            });
                            that._nodes.push(nodeItem);
                            nodeIdx++;
                            nodeColors[node._name] = color
                        })
                    });
                    layout.links.forEach(function(link) {
                        var gradient = null;
                        if (linkOptions.colorMode === _constants.COLOR_MODE_GRADIENT) {
                            gradient = that._renderer.linearGradient([{
                                offset: "0%",
                                "stop-color": nodeColors[link._from._name]
                            }, {
                                offset: "100%",
                                "stop-color": nodeColors[link._to._name]
                            }]);
                            _this._gradients.push(gradient)
                        }
                        var color = linkOptions.color;
                        if (linkOptions.colorMode === _constants.COLOR_MODE_SOURCE) {
                            color = nodeColors[link._from._name]
                        } else {
                            if (linkOptions.colorMode === _constants.COLOR_MODE_TARGET) {
                                color = nodeColors[link._to._name]
                            }
                        }
                        var linkItem = new _link_item.default(that, {
                            d: link.d,
                            boundingRect: link._boundingRect,
                            color: color,
                            options: linkOptions,
                            connection: {
                                source: link._from._name,
                                target: link._to._name,
                                weight: link._weight
                            },
                            gradient: gradient
                        });
                        that._links.push(linkItem)
                    });
                    that._renderer.initHatching();
                    that._change(["NODES_DRAW", "LINKS_DRAW", "LABELS"])
                }
                that._change(["DRAWN"])
            },
            _applyLabelsAppearance: function() {
                var that = this;
                var labelOptions = that._getOption("label");
                var availableWidth = that._rect[2] - that._rect[0];
                var nodeOptions = that._getOption("node");
                that._shadowFilter = that._renderer.shadowFilter("-50%", "-50%", "200%", "200%").attr(labelOptions.shadow);
                that._groupLabels.clear();
                if (that._drawLabels && labelOptions.visible) {
                    var availableLabelWidth = (availableWidth - (nodeOptions.width + labelOptions.horizontalOffset) - that._layoutMap.cascades.length * nodeOptions.width) / (that._layoutMap.cascades.length - 1) - labelOptions.horizontalOffset;
                    that._nodes.forEach(function(node) {
                        that._createLabel(node, labelOptions, that._shadowFilter.id);
                        moveLabel(node, labelOptions, availableLabelWidth, that._rect)
                    });
                    if ("none" !== labelOptions.overlappingBehavior) {
                        that._nodes.forEach(function(thisNode) {
                            var thisBox = thisNode._label.getBBox();
                            that._nodes.forEach(function(otherNode) {
                                var otherBox = otherNode._label.getBBox();
                                if (thisNode.id !== otherNode.id && _layout.default.overlap(thisBox, otherBox)) {
                                    if ("ellipsis" === labelOptions.overlappingBehavior) {
                                        thisNode.labelText.applyEllipsis(otherBox.x - thisBox.x)
                                    } else {
                                        if ("hide" === labelOptions.overlappingBehavior) {
                                            thisNode.labelText.remove()
                                        }
                                    }
                                }
                            })
                        })
                    }
                }
            },
            _createLabel: function(node, labelOptions, filter) {
                var textData = labelOptions.customizeText(node);
                var settings = node.getLabelAttributes(labelOptions, filter);
                if (textData) {
                    node._label = this._renderer.g().append(this._groupLabels);
                    node.labelText = this._renderer.text(textData).attr(settings.attr).css(settings.css);
                    node.labelText.append(node._label)
                }
            },
            _getMinSize: function() {
                var adaptiveLayout = this._getOption("adaptiveLayout");
                return [adaptiveLayout.width, adaptiveLayout.height]
            },
            getAllNodes: function() {
                return this._nodes.slice()
            },
            getAllLinks: function() {
                return this._links.slice()
            }
        });
        (0, _component_registrator.default)("dxSankey", dxSankey);
        var _default = dxSankey;
        exports.default = _default;
        dxSankey.addPlugin(_data_source.plugin);
        module.exports = exports.default
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/sankey/constants.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.COLOR_MODE_NONE = exports.COLOR_MODE_TARGET = exports.COLOR_MODE_SOURCE = exports.COLOR_MODE_GRADIENT = void 0;
        var COLOR_MODE_GRADIENT = "gradient";
        exports.COLOR_MODE_GRADIENT = COLOR_MODE_GRADIENT;
        var COLOR_MODE_SOURCE = "source";
        exports.COLOR_MODE_SOURCE = COLOR_MODE_SOURCE;
        var COLOR_MODE_TARGET = "target";
        exports.COLOR_MODE_TARGET = COLOR_MODE_TARGET;
        var COLOR_MODE_NONE = "none";
        exports.COLOR_MODE_NONE = COLOR_MODE_NONE
    },
    /*!******************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/sankey/graph.js ***!
      \******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var WHITE = "white";
        var GRAY = "gray";
        var BLACK = "black";
        var routines = {
            maxOfArray: function(arr, callback) {
                var m = 0;
                var callback_function = function(v) {
                    return v
                };
                if (callback) {
                    callback_function = callback
                }
                for (var i = 0; i < arr.length; i++) {
                    if (callback_function(arr[i]) > m) {
                        m = callback_function(arr[i])
                    }
                }
                return m
            }
        };
        var getVertices = function(links) {
            var vert = [];
            links.forEach(function(link) {
                if (vert.indexOf(link[0]) === -1) {
                    vert.push(link[0])
                }
                if (vert.indexOf(link[1]) === -1) {
                    vert.push(link[1])
                }
            });
            return vert
        };
        var getAdjacentVertices = function(links, vertex) {
            var avert = [];
            links.forEach(function(link) {
                if (link[0] === vertex && avert.indexOf(link[1]) === -1) {
                    avert.push(link[1])
                }
            });
            return avert
        };
        var getReverseAdjacentVertices = function(links, vertex) {
            var avert = [];
            links.forEach(function(link) {
                if (link[1] === vertex && avert.indexOf(link[0]) === -1) {
                    avert.push(link[0])
                }
            });
            return avert
        };
        var struct = {
            _hasCycle: false,
            _sortedList: [],
            hasCycle: function(links) {
                var _this = this;
                this._hasCycle = false;
                this._sortedList = [];
                var vertices = {};
                var allVertices = getVertices(links);
                allVertices.forEach(function(vertex) {
                    vertices[vertex] = {
                        color: WHITE
                    }
                });
                allVertices.forEach(function(vertex) {
                    if (vertices[vertex].color === WHITE) {
                        _this._depthFirstSearch(links, vertices, vertex)
                    }
                });
                this._sortedList.reverse();
                return this._hasCycle
            },
            _depthFirstSearch: function(links, vertices, vertex) {
                vertices[vertex].color = GRAY;
                var averts = getAdjacentVertices(links, vertex);
                for (var a = 0; a < averts.length; a++) {
                    if (vertices[averts[a]].color === WHITE) {
                        this._depthFirstSearch(links, vertices, averts[a])
                    } else {
                        if (vertices[averts[a]].color === GRAY) {
                            this._hasCycle = true
                        }
                    }
                }
                this._sortedList.push({
                    name: vertex,
                    lp: null,
                    incoming: getReverseAdjacentVertices(links, vertex),
                    outgoing: getAdjacentVertices(links, vertex)
                });
                vertices[vertex].color = BLACK
            },
            computeLongestPaths: function(links) {
                var sortedVertices = this._sortedList;
                sortedVertices.forEach(function(vertex) {
                    var averts = getReverseAdjacentVertices(links, vertex.name);
                    if (0 === averts.length) {
                        vertex.lp = 0
                    } else {
                        var maxLP = [];
                        averts.forEach(function(adjacentVertex) {
                            maxLP.push(sortedVertices.filter(function(sv) {
                                return sv.name === adjacentVertex
                            })[0].lp)
                        });
                        vertex.lp = routines.maxOfArray(maxLP) + 1
                    }
                });
                return this._sortedList
            }
        };
        var _default = {
            struct: struct,
            routines: routines,
            getVertices: getVertices,
            getAdjacentVertices: getAdjacentVertices,
            getReverseAdjacentVertices: getReverseAdjacentVertices
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************************!*\
      !*** ./artifacts/transpiled-npm/exporter/excel_creator.js ***!
      \************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getData = getData;
        exports.ExcelCreator = void 0;
        var _class = _interopRequireDefault(__webpack_require__( /*! ../core/class */ 15));
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../ui/widget/ui.errors */ 17));
        var _string = __webpack_require__( /*! ../core/utils/string */ 43);
        var _jszip = _interopRequireDefault(__webpack_require__( /*! jszip */ 322));
        var _file_saver = __webpack_require__( /*! ./file_saver */ 178);
        var _excel_format_converter = _interopRequireDefault(__webpack_require__( /*! ./excel_format_converter */ 239));
        var _excel = _interopRequireDefault(__webpack_require__( /*! ./excel/excel.file */ 500));
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        var XML_TAG = '<?xml version="1.0" encoding="utf-8"?>';
        var GROUP_SHEET_PR_XML = '<sheetPr><outlinePr summaryBelow="0"/></sheetPr>';
        var SINGLE_SHEET_PR_XML = "<sheetPr/>";
        var BASE_STYLE_XML2 = '<borders count="1"><border><left style="thin"><color rgb="FFD3D3D3"/></left><right style="thin"><color rgb="FFD3D3D3"/></right><top style="thin"><color rgb="FFD3D3D3"/></top><bottom style="thin"><color rgb="FFD3D3D3"/></bottom></border></borders><cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';
        var OPEN_XML_FORMAT_URL = "http://schemas.openxmlformats.org";
        var RELATIONSHIP_PART_NAME = "rels";
        var XL_FOLDER_NAME = "xl";
        var WORKBOOK_FILE_NAME = "workbook.xml";
        var CONTENTTYPES_FILE_NAME = "[Content_Types].xml";
        var SHAREDSTRING_FILE_NAME = "sharedStrings.xml";
        var STYLE_FILE_NAME = "styles.xml";
        var WORKSHEETS_FOLDER = "worksheets";
        var WORKSHEET_FILE_NAME = "sheet1.xml";
        var WORKSHEET_HEADER_XML = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" mc:Ignorable="x14ac" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac">';
        var VALID_TYPES = {
            "boolean": "b",
            date: "d",
            number: "n",
            string: "s"
        };
        var EXCEL_START_TIME = Date.UTC(1899, 11, 30);
        var DAYS_COUNT_BEFORE_29_FEB_1900 = 60;
        var MAX_DIGIT_WIDTH_IN_PIXELS = 7;
        var UNSUPPORTED_FORMAT_MAPPING = {
            quarter: "shortDate",
            quarterAndYear: "shortDate",
            minute: "longTime",
            millisecond: "longTime"
        };
        var ExcelCreator = _class.default.inherit({
            _getXMLTag: function(tagName, attributes, content) {
                var result = "<" + tagName;
                var i;
                var length = attributes.length;
                var attr;
                for (i = 0; i < length; i++) {
                    attr = attributes[i];
                    if (void 0 !== attr.value) {
                        result = result + " " + attr.name + '="' + attr.value + '"'
                    }
                }
                return (0, _type.isDefined)(content) ? result + ">" + content + "</" + tagName + ">" : result + " />"
            },
            _convertToExcelCellRef: function(zeroBasedRowIndex, zeroBasedCellIndex) {
                var columnName = "";
                var max = 26;
                var charCode;
                var isCellIndexFound;
                while (!isCellIndexFound) {
                    charCode = 65 + (zeroBasedCellIndex >= max ? zeroBasedCellIndex % max : Math.ceil(zeroBasedCellIndex));
                    columnName = String.fromCharCode(charCode) + columnName;
                    if (zeroBasedCellIndex >= max) {
                        zeroBasedCellIndex = Math.floor(zeroBasedCellIndex / max) - 1
                    } else {
                        isCellIndexFound = true
                    }
                }
                return columnName + (zeroBasedRowIndex + 1)
            },
            _convertToExcelCellRefAndTrackMaxIndex: function(rowIndex, cellIndex) {
                if (this._maxRowIndex < Number(rowIndex)) {
                    this._maxRowIndex = Number(rowIndex)
                }
                if (this._maxColumnIndex < Number(cellIndex)) {
                    this._maxColumnIndex = Number(cellIndex)
                }
                return this._convertToExcelCellRef(rowIndex, cellIndex)
            },
            _getDataType: function(dataType) {
                return VALID_TYPES[dataType] || VALID_TYPES.string
            },
            _tryGetExcelCellDataType: function(object) {
                if ((0, _type.isDefined)(object)) {
                    if ("number" === typeof object) {
                        if (isFinite(object)) {
                            return VALID_TYPES.number
                        } else {
                            return VALID_TYPES.string
                        }
                    } else {
                        if ((0, _type.isString)(object)) {
                            return VALID_TYPES.string
                        } else {
                            if ((0, _type.isDate)(object)) {
                                return VALID_TYPES.number
                            } else {
                                if ((0, _type.isBoolean)(object)) {
                                    return VALID_TYPES.boolean
                                }
                            }
                        }
                    }
                }
            },
            _formatObjectConverter: function(format, dataType) {
                var result = {
                    format: format,
                    precision: format && format.precision,
                    dataType: dataType
                };
                if ((0, _type.isObject)(format)) {
                    return (0, _extend.extend)(result, format, {
                        format: format.formatter || format.type,
                        currency: format.currency
                    })
                }
                return result
            },
            _tryConvertToExcelNumberFormat: function(format, dataType) {
                var newFormat = this._formatObjectConverter(format, dataType);
                format = newFormat.format;
                var currency = newFormat.currency;
                dataType = newFormat.dataType;
                if ((0, _type.isDefined)(format) && "date" === dataType) {
                    format = UNSUPPORTED_FORMAT_MAPPING[format && format.type || format] || format
                }
                return _excel_format_converter.default.convertFormat(format, newFormat.precision, dataType, currency)
            },
            _appendString: function(value) {
                if ((0, _type.isDefined)(value)) {
                    value = String(value);
                    if (value.length) {
                        value = (0, _string.encodeHtml)(value);
                        if (void 0 === this._stringHash[value]) {
                            this._stringHash[value] = this._stringArray.length;
                            this._stringArray.push(value)
                        }
                        return this._stringHash[value]
                    }
                }
            },
            _tryGetExcelDateValue: function(date) {
                var days;
                var totalTime;
                if ((0, _type.isDate)(date)) {
                    days = Math.floor((Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) - EXCEL_START_TIME) / 864e5);
                    if (days < DAYS_COUNT_BEFORE_29_FEB_1900) {
                        days--
                    }
                    totalTime = (3600 * date.getHours() + 60 * date.getMinutes() + date.getSeconds()) / 86400;
                    return days + totalTime
                }
            },
            _prepareValue: function(rowIndex, cellIndex) {
                var dataProvider = this._dataProvider;
                var _ref = dataProvider.getCellData(rowIndex, cellIndex) || {},
                    cellSourceData = _ref.cellSourceData;
                var _ref2 = dataProvider.getCellData(rowIndex, cellIndex) || {},
                    value = _ref2.value;
                var sourceValue;
                var type = this._getDataType(dataProvider.getCellType(rowIndex, cellIndex));
                if (type === VALID_TYPES.date && !(0, _type.isDate)(value)) {
                    type = VALID_TYPES.string
                }
                switch (type) {
                    case VALID_TYPES.string:
                        sourceValue = value;
                        value = this._appendString(value);
                        break;
                    case VALID_TYPES.date:
                        sourceValue = value;
                        value = this._tryGetExcelDateValue(value);
                        type = VALID_TYPES.number
                }
                return {
                    value: value,
                    type: type,
                    sourceValue: sourceValue,
                    cellSourceData: cellSourceData
                }
            },
            _callCustomizeExcelCell: function(_ref3) {
                var dataProvider = _ref3.dataProvider,
                    value = _ref3.value,
                    style = _ref3.style,
                    sourceData = _ref3.sourceData;
                var styleCopy = _excel.default.copyCellFormat(style);
                var args = {
                    value: value,
                    numberFormat: styleCopy.numberFormat,
                    clearStyle: function() {
                        this.horizontalAlignment = null;
                        this.verticalAlignment = null;
                        this.wrapTextEnabled = null;
                        this.font = null;
                        this.numberFormat = null
                    }
                };
                if ((0, _type.isDefined)(styleCopy)) {
                    if ((0, _type.isDefined)(styleCopy.alignment)) {
                        args.horizontalAlignment = styleCopy.alignment.horizontal;
                        args.verticalAlignment = styleCopy.alignment.vertical;
                        args.wrapTextEnabled = styleCopy.alignment.wrapText
                    }
                    args.backgroundColor = styleCopy.backgroundColor;
                    args.fillPatternType = styleCopy.fillPatternType;
                    args.fillPatternColor = styleCopy.fillPatternColor;
                    args.font = styleCopy.font
                }
                dataProvider.customizeExcelCell(args, sourceData);
                var newStyle = styleCopy || {};
                newStyle.font = args.font;
                newStyle.alignment = newStyle.alignment || {};
                newStyle.alignment.horizontal = args.horizontalAlignment;
                newStyle.alignment.vertical = args.verticalAlignment;
                newStyle.alignment.wrapText = args.wrapTextEnabled;
                newStyle.backgroundColor = args.backgroundColor;
                newStyle.fillPatternType = args.fillPatternType;
                newStyle.fillPatternColor = args.fillPatternColor;
                newStyle.numberFormat = args.numberFormat;
                return {
                    value: args.value,
                    style: newStyle
                }
            },
            _getDataArray: function() {
                var that = this;
                var rowIndex;
                var cellIndex;
                var cellsArray;
                var cellData;
                var result = [];
                var dataProvider = that._dataProvider;
                var rowsLength = dataProvider.getRowsCount();
                var columns = dataProvider.getColumns();
                var cellsLength;
                for (rowIndex = 0; rowIndex < rowsLength; rowIndex++) {
                    cellsArray = [];
                    cellsLength = columns.length;
                    for (cellIndex = 0; cellIndex !== cellsLength; cellIndex++) {
                        cellData = that._prepareValue(rowIndex, cellIndex);
                        var styleArrayIndex = dataProvider.getStyleId(rowIndex, cellIndex);
                        var cellStyleId = this._styleArrayIndexToCellStyleIdMap[styleArrayIndex];
                        if (dataProvider.hasCustomizeExcelCell && dataProvider.hasCustomizeExcelCell()) {
                            var value = cellData.sourceValue || cellData.value;
                            var modifiedExcelCell = this._callCustomizeExcelCell({
                                dataProvider: dataProvider,
                                value: value,
                                style: that._styleArray[styleArrayIndex],
                                sourceData: cellData.cellSourceData
                            });
                            if (modifiedExcelCell.value !== value) {
                                if (_typeof(modifiedExcelCell.value) !== _typeof(value) || "number" === typeof modifiedExcelCell.value && !isFinite(modifiedExcelCell.value)) {
                                    var cellDataType = this._tryGetExcelCellDataType(modifiedExcelCell.value);
                                    if ((0, _type.isDefined)(cellDataType)) {
                                        cellData.type = cellDataType
                                    }
                                }
                                switch (cellData.type) {
                                    case VALID_TYPES.string:
                                        cellData.value = this._appendString(modifiedExcelCell.value);
                                        break;
                                    case VALID_TYPES.date:
                                        cellData.value = modifiedExcelCell.value;
                                        break;
                                    case VALID_TYPES.number:
                                        var newValue = modifiedExcelCell.value;
                                        var excelDateValue = this._tryGetExcelDateValue(newValue);
                                        if ((0, _type.isDefined)(excelDateValue)) {
                                            newValue = excelDateValue
                                        }
                                        cellData.value = newValue;
                                        break;
                                    default:
                                        cellData.value = modifiedExcelCell.value
                                }
                            }
                            cellStyleId = this._excelFile.registerCellFormat(modifiedExcelCell.style)
                        }
                        cellsArray.push({
                            style: cellStyleId,
                            value: cellData.value,
                            type: cellData.type
                        })
                    }
                    if (!that._needSheetPr && dataProvider.getGroupLevel(rowIndex) > 0) {
                        that._needSheetPr = true
                    }
                    result.push(cellsArray)
                }
                return result
            },
            _calculateWidth: function(pixelsWidth) {
                pixelsWidth = parseInt(pixelsWidth, 10);
                if (!pixelsWidth || pixelsWidth < 5) {
                    pixelsWidth = 100
                }
                return Math.min(255, Math.floor((pixelsWidth - 5) / MAX_DIGIT_WIDTH_IN_PIXELS * 100 + .5) / 100)
            },
            _prepareStyleData: function() {
                var _this = this;
                var that = this;
                var styles = that._dataProvider.getStyles();
                that._dataProvider.getColumns().forEach(function(column) {
                    that._colsArray.push(that._calculateWidth(column.width))
                });
                var fonts = [{
                    size: 11,
                    color: {
                        theme: 1
                    },
                    name: "Calibri",
                    family: 2,
                    scheme: "minor",
                    bold: false
                }, {
                    size: 11,
                    color: {
                        theme: 1
                    },
                    name: "Calibri",
                    family: 2,
                    scheme: "minor",
                    bold: true
                }];
                this._excelFile.registerFont(fonts[0]);
                this._excelFile.registerFont(fonts[1]);
                styles.forEach(function(style) {
                    var numberFormat = that._tryConvertToExcelNumberFormat(style.format, style.dataType);
                    if (!(0, _type.isDefined)(numberFormat)) {
                        numberFormat = 0
                    }
                    that._styleArray.push({
                        font: fonts[Number(!!style.bold)],
                        numberFormat: numberFormat,
                        alignment: {
                            vertical: "top",
                            wrapText: !!style.wrapText,
                            horizontal: style.alignment || "left"
                        }
                    })
                });
                that._styleArrayIndexToCellStyleIdMap = that._styleArray.map(function(item) {
                    return _this._excelFile.registerCellFormat(item)
                })
            },
            _prepareCellData: function() {
                this._cellsArray = this._getDataArray()
            },
            _createXMLRelationships: function(xmlRelationships) {
                return this._getXMLTag("Relationships", [{
                    name: "xmlns",
                    value: OPEN_XML_FORMAT_URL + "/package/2006/relationships"
                }], xmlRelationships)
            },
            _createXMLRelationship: function(id, type, target) {
                return this._getXMLTag("Relationship", [{
                    name: "Id",
                    value: "rId" + id
                }, {
                    name: "Type",
                    value: OPEN_XML_FORMAT_URL + "/officeDocument/2006/relationships/" + type
                }, {
                    name: "Target",
                    value: target
                }])
            },
            _getWorkbookContent: function() {
                var content = '<bookViews><workbookView xWindow="0" yWindow="0" windowWidth="0" windowHeight="0"/></bookViews><sheets><sheet name="Sheet" sheetId="1" r:id="rId1" /></sheets><definedNames><definedName name="_xlnm.Print_Titles" localSheetId="0">Sheet!$1:$1</definedName><definedName name="_xlnm._FilterDatabase" hidden="0" localSheetId="0">Sheet!$A$1:$F$6332</definedName></definedNames>';
                return XML_TAG + this._getXMLTag("workbook", [{
                    name: "xmlns:r",
                    value: OPEN_XML_FORMAT_URL + "/officeDocument/2006/relationships"
                }, {
                    name: "xmlns",
                    value: OPEN_XML_FORMAT_URL + "/spreadsheetml/2006/main"
                }], content)
            },
            _getContentTypesContent: function() {
                return XML_TAG + '<Types xmlns="' + OPEN_XML_FORMAT_URL + '/package/2006/content-types"><Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml" /><Default Extension="xml" ContentType="application/xml" /><Override PartName="/xl/worksheets/sheet1.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml" /><Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml" /><Override PartName="/xl/sharedStrings.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml" /><Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml" /></Types>'
            },
            _generateStylesXML: function() {
                var that = this;
                var folder = that._zip.folder(XL_FOLDER_NAME);
                var XML = "";
                XML += this._excelFile.generateNumberFormatsXml();
                XML += this._excelFile.generateFontsXml();
                XML += this._excelFile.generateFillsXml();
                XML += BASE_STYLE_XML2;
                XML += this._excelFile.generateCellFormatsXml();
                XML += that._getXMLTag("cellStyles", [{
                    name: "count",
                    value: 1
                }], that._getXMLTag("cellStyle", [{
                    name: "name",
                    value: "Normal"
                }, {
                    name: "xfId",
                    value: 0
                }, {
                    name: "builtinId",
                    value: 0
                }]));
                XML = XML_TAG + that._getXMLTag("styleSheet", [{
                    name: "xmlns",
                    value: OPEN_XML_FORMAT_URL + "/spreadsheetml/2006/main"
                }], XML);
                folder.file(STYLE_FILE_NAME, XML);
                that._styleArray = []
            },
            _generateStringsXML: function() {
                var folder = this._zip.folder(XL_FOLDER_NAME);
                var stringIndex;
                var stringsLength = this._stringArray.length;
                var sharedStringXml = XML_TAG;
                for (stringIndex = 0; stringIndex < stringsLength; stringIndex++) {
                    this._stringArray[stringIndex] = this._getXMLTag("si", [], this._getXMLTag("t", [], this._stringArray[stringIndex]))
                }
                sharedStringXml += this._getXMLTag("sst", [{
                    name: "xmlns",
                    value: OPEN_XML_FORMAT_URL + "/spreadsheetml/2006/main"
                }, {
                    name: "count",
                    value: this._stringArray.length
                }, {
                    name: "uniqueCount",
                    value: this._stringArray.length
                }], this._stringArray.join(""));
                folder.file(SHAREDSTRING_FILE_NAME, sharedStringXml);
                this._stringArray = []
            },
            _getPaneXML: function() {
                var attributes = [{
                    name: "activePane",
                    value: "bottomLeft"
                }, {
                    name: "state",
                    value: "frozen"
                }];
                var frozenArea = this._dataProvider.getFrozenArea();
                if (!(frozenArea.x || frozenArea.y)) {
                    return ""
                }
                if (frozenArea.x) {
                    attributes.push({
                        name: "xSplit",
                        value: frozenArea.x
                    })
                }
                if (frozenArea.y) {
                    attributes.push({
                        name: "ySplit",
                        value: frozenArea.y
                    })
                }
                attributes.push({
                    name: "topLeftCell",
                    value: this._convertToExcelCellRefAndTrackMaxIndex(frozenArea.y, frozenArea.x)
                });
                return this._getXMLTag("pane", attributes)
            },
            _getAutoFilterXML: function(maxCellIndex) {
                if (this._options.autoFilterEnabled) {
                    return '<autoFilter ref="A' + this._dataProvider.getHeaderRowCount() + ":" + maxCellIndex + '" />'
                }
                return ""
            },
            _getIgnoredErrorsXML: function(maxCellIndex) {
                if (this._options.ignoreErrors) {
                    return '<ignoredErrors><ignoredError sqref="A1:' + maxCellIndex + '" numberStoredAsText="1" /></ignoredErrors>'
                }
                return ""
            },
            _generateWorksheetXML: function() {
                var colIndex;
                var rowIndex;
                var cellData;
                var xmlCells;
                var xmlRows = [];
                var rowsLength = this._cellsArray.length;
                var cellsLength;
                var colsLength = this._colsArray.length;
                var rSpans = "1:" + colsLength;
                var headerRowCount = this._dataProvider.getHeaderRowCount ? this._dataProvider.getHeaderRowCount() : 1;
                var xmlResult = [WORKSHEET_HEADER_XML];
                xmlResult.push(this._needSheetPr ? GROUP_SHEET_PR_XML : SINGLE_SHEET_PR_XML);
                xmlResult.push('<dimension ref="A1:C1"/>');
                xmlResult.push("<sheetViews><sheetView ");
                xmlResult.push(this._rtlEnabled ? 'rightToLeft="1" ' : "");
                xmlResult.push('tabSelected="1" workbookViewId="0">');
                xmlResult.push(this._getPaneXML());
                xmlResult.push("</sheetView></sheetViews>");
                xmlResult.push('<sheetFormatPr defaultRowHeight="15"');
                xmlResult.push(' outlineLevelRow="' + (this._dataProvider.getRowsCount() > 0 ? this._dataProvider.getGroupLevel(0) : 0) + '"');
                xmlResult.push(' x14ac:dyDescent="0.25"/>');
                for (colIndex = 0; colIndex < colsLength; colIndex++) {
                    this._colsArray[colIndex] = this._getXMLTag("col", [{
                        name: "width",
                        value: this._colsArray[colIndex]
                    }, {
                        name: "min",
                        value: Number(colIndex) + 1
                    }, {
                        name: "max",
                        value: Number(colIndex) + 1
                    }, {
                        name: "customWidth",
                        value: 1
                    }])
                }
                xmlResult.push(this._getXMLTag("cols", [], this._colsArray.join("")) + "<sheetData>");
                for (rowIndex = 0; rowIndex < rowsLength; rowIndex++) {
                    xmlCells = [];
                    cellsLength = this._cellsArray[rowIndex].length;
                    for (colIndex = 0; colIndex < cellsLength; colIndex++) {
                        rowIndex = Number(rowIndex);
                        cellData = this._cellsArray[rowIndex][colIndex];
                        xmlCells.push(this._getXMLTag("c", [{
                            name: "r",
                            value: this._convertToExcelCellRefAndTrackMaxIndex(rowIndex, colIndex)
                        }, {
                            name: "s",
                            value: cellData.style
                        }, {
                            name: "t",
                            value: cellData.type
                        }], (0, _type.isDefined)(cellData.value) ? this._getXMLTag("v", [], cellData.value) : null))
                    }
                    xmlRows.push(this._getXMLTag("row", [{
                        name: "r",
                        value: Number(rowIndex) + 1
                    }, {
                        name: "spans",
                        value: rSpans
                    }, {
                        name: "outlineLevel",
                        value: rowIndex >= headerRowCount ? this._dataProvider.getGroupLevel(rowIndex) : 0
                    }, {
                        name: "x14ac:dyDescent",
                        value: "0.25"
                    }], xmlCells.join("")));
                    this._cellsArray[rowIndex] = null;
                    if (xmlRows.length > 1e4) {
                        xmlResult.push(xmlRows.join(""));
                        xmlRows = []
                    }
                }
                xmlResult.push(xmlRows.join(""));
                xmlRows = [];
                var rightBottomCellRef = this._convertToExcelCellRef(this._maxRowIndex, this._maxColumnIndex);
                xmlResult.push("</sheetData>" + this._getAutoFilterXML(rightBottomCellRef) + this._generateMergingXML() + this._getIgnoredErrorsXML(rightBottomCellRef) + "</worksheet>");
                this._zip.folder(XL_FOLDER_NAME).folder(WORKSHEETS_FOLDER).file(WORKSHEET_FILE_NAME, xmlResult.join(""));
                this._colsArray = [];
                this._cellsArray = [];
                xmlResult = []
            },
            _generateMergingXML: function() {
                var k;
                var l;
                var cellIndex;
                var rowIndex;
                var rowsLength = (0, _type.isDefined)(this._dataProvider.getHeaderRowCount) ? this._dataProvider.getHeaderRowCount() : this._dataProvider.getRowsCount();
                var columnsLength = this._dataProvider.getColumns().length;
                var usedArea = [];
                var mergeArray = [];
                var mergeIndex;
                var mergeXML = "";
                for (rowIndex = 0; rowIndex < rowsLength; rowIndex++) {
                    for (cellIndex = 0; cellIndex !== columnsLength; cellIndex++) {
                        if (!(0, _type.isDefined)(usedArea[rowIndex]) || !(0, _type.isDefined)(usedArea[rowIndex][cellIndex])) {
                            var cellMerge = this._dataProvider.getCellMerging(rowIndex, cellIndex);
                            if (cellMerge.colspan || cellMerge.rowspan) {
                                mergeArray.push({
                                    start: this._convertToExcelCellRefAndTrackMaxIndex(rowIndex, cellIndex),
                                    end: this._convertToExcelCellRefAndTrackMaxIndex(rowIndex + (cellMerge.rowspan || 0), cellIndex + (cellMerge.colspan || 0))
                                });
                                for (k = rowIndex; k <= rowIndex + cellMerge.rowspan || 0; k++) {
                                    for (l = cellIndex; l <= cellIndex + cellMerge.colspan || 0; l++) {
                                        if (!(0, _type.isDefined)(usedArea[k])) {
                                            usedArea[k] = []
                                        }
                                        usedArea[k][l] = true
                                    }
                                }
                            }
                        }
                    }
                }
                var mergeArrayLength = mergeArray.length;
                for (mergeIndex = 0; mergeIndex < mergeArrayLength; mergeIndex++) {
                    mergeXML += this._getXMLTag("mergeCell", [{
                        name: "ref",
                        value: mergeArray[mergeIndex].start + ":" + mergeArray[mergeIndex].end
                    }])
                }
                return mergeXML.length ? this._getXMLTag("mergeCells", [{
                    name: "count",
                    value: mergeArrayLength
                }], mergeXML) : ""
            },
            _generateCommonXML: function() {
                var relsFileContent = XML_TAG + this._createXMLRelationships(this._createXMLRelationship(1, "officeDocument", "xl/" + WORKBOOK_FILE_NAME));
                var folder = this._zip.folder(XL_FOLDER_NAME);
                var relsXML = XML_TAG;
                this._zip.folder("_" + RELATIONSHIP_PART_NAME).file("." + RELATIONSHIP_PART_NAME, relsFileContent);
                var xmlRelationships = this._createXMLRelationship(1, "worksheet", "worksheets/" + WORKSHEET_FILE_NAME) + this._createXMLRelationship(2, "styles", STYLE_FILE_NAME) + this._createXMLRelationship(3, "sharedStrings", SHAREDSTRING_FILE_NAME);
                relsXML += this._createXMLRelationships(xmlRelationships);
                folder.folder("_" + RELATIONSHIP_PART_NAME).file(WORKBOOK_FILE_NAME + ".rels", relsXML);
                folder.file(WORKBOOK_FILE_NAME, this._getWorkbookContent());
                this._zip.file(CONTENTTYPES_FILE_NAME, this._getContentTypesContent())
            },
            _generateContent: function() {
                this._prepareStyleData();
                this._prepareCellData();
                this._generateWorkXML();
                this._generateCommonXML()
            },
            _generateWorkXML: function() {
                this._generateStylesXML();
                this._generateStringsXML();
                this._generateWorksheetXML()
            },
            ctor: function(dataProvider, options) {
                this._rtlEnabled = options && !!options.rtlEnabled;
                this._options = options;
                this._maxRowIndex = 0;
                this._maxColumnIndex = 0;
                this._stringArray = [];
                this._stringHash = {};
                this._styleArray = [];
                this._colsArray = [];
                this._cellsArray = [];
                this._needSheetPr = false;
                this._dataProvider = dataProvider;
                this._excelFile = new _excel.default;
                if ((0, _type.isDefined)(ExcelCreator.JSZip)) {
                    this._zip = new ExcelCreator.JSZip
                } else {
                    this._zip = null
                }
            },
            _checkZipState: function() {
                if (!this._zip) {
                    throw _ui.default.Error("E1041", "JSZip")
                }
            },
            ready: function() {
                return this._dataProvider.ready()
            },
            getData: function(isBlob) {
                var options = {
                    type: isBlob ? "blob" : "base64",
                    compression: "DEFLATE",
                    mimeType: _file_saver.MIME_TYPES.EXCEL
                };
                var deferred = new _deferred.Deferred;
                this._checkZipState();
                this._generateContent();
                if (this._zip.generateAsync) {
                    this._zip.generateAsync(options).then(deferred.resolve)
                } else {
                    deferred.resolve(this._zip.generate(options))
                }
                return deferred
            }
        });
        exports.ExcelCreator = ExcelCreator;
        ExcelCreator.JSZip = _jszip.default;

        function getData(data, options) {
            var excelCreator = new ExcelCreator(data, options);
            excelCreator._checkZipState();
            return excelCreator.ready().then(function() {
                return excelCreator.getData((0, _type.isFunction)((0, _window.getWindow)().Blob))
            })
        }
    },
    /*!**************************************************************!*\
      !*** ./artifacts/transpiled-npm/localization/intl/number.js ***!
      \**************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _config = _interopRequireDefault(__webpack_require__( /*! ../../core/config */ 31));
        var _core = _interopRequireDefault(__webpack_require__( /*! ../core */ 87));
        var _open_xml_currency_format = _interopRequireDefault(__webpack_require__( /*! ../open_xml_currency_format */ 241));
        var _accounting_formats = _interopRequireDefault(__webpack_require__( /*! ../cldr-data/accounting_formats */ 497));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var detectCurrencySymbolRegex = /([^\s0]+)?(\s*)0*[.,]*0*(\s*)([^\s0]+)?/;
        var formattersCache = {};
        var getFormatter = function(format) {
            var key = _core.default.locale() + "/" + JSON.stringify(format);
            if (!formattersCache[key]) {
                formattersCache[key] = new Intl.NumberFormat(_core.default.locale(), format).format
            }
            return formattersCache[key]
        };
        var getCurrencyFormatter = function(currency) {
            return new Intl.NumberFormat(_core.default.locale(), {
                style: "currency",
                currency: currency
            })
        };
        var _default = {
            engine: function() {
                return "intl"
            },
            _formatNumberCore: function(value, format, formatConfig) {
                if ("exponential" === format) {
                    return this.callBase.apply(this, arguments)
                }
                return getFormatter(this._normalizeFormatConfig(format, formatConfig, value))(value)
            },
            _normalizeFormatConfig: function(format, formatConfig, value) {
                var config;
                if ("decimal" === format) {
                    config = {
                        minimumIntegerDigits: formatConfig.precision || void 0,
                        useGrouping: false,
                        maximumFractionDigits: String(value).length,
                        round: value < 0 ? "ceil" : "floor"
                    }
                } else {
                    config = this._getPrecisionConfig(formatConfig.precision)
                }
                if ("percent" === format) {
                    config.style = "percent"
                } else {
                    if ("currency" === format) {
                        config.style = "currency";
                        config.currency = formatConfig.currency || (0, _config.default)().defaultCurrency
                    }
                }
                return config
            },
            _getPrecisionConfig: function(precision) {
                var config;
                if (null === precision) {
                    config = {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 20
                    }
                } else {
                    config = {
                        minimumFractionDigits: precision || 0,
                        maximumFractionDigits: precision || 0
                    }
                }
                return config
            },
            format: function(value, _format) {
                if ("number" !== typeof value) {
                    return value
                }
                _format = this._normalizeFormat(_format);
                if ("default" === _format.currency) {
                    _format.currency = (0, _config.default)().defaultCurrency
                }
                if (!_format || "function" !== typeof _format && !_format.type && !_format.formatter) {
                    return getFormatter(_format)(value)
                }
                return this.callBase.apply(this, arguments)
            },
            _getCurrencySymbolInfo: function(currency) {
                var formatter = getCurrencyFormatter(currency);
                return this._extractCurrencySymbolInfo(formatter.format(0))
            },
            _extractCurrencySymbolInfo: function(currencyValueString) {
                var match = detectCurrencySymbolRegex.exec(currencyValueString) || [];
                var position = match[1] ? "before" : "after";
                var symbol = match[1] || match[4] || "";
                var delimiter = match[2] || match[3] || "";
                return {
                    position: position,
                    symbol: symbol,
                    delimiter: delimiter
                }
            },
            getCurrencySymbol: function(currency) {
                if (!currency) {
                    currency = (0, _config.default)().defaultCurrency
                }
                var symbolInfo = this._getCurrencySymbolInfo(currency);
                return {
                    symbol: symbolInfo.symbol
                }
            },
            getOpenXmlCurrencyFormat: function(currency) {
                var targetCurrency = currency || (0, _config.default)().defaultCurrency;
                var currencySymbol = this._getCurrencySymbolInfo(targetCurrency).symbol;
                var closestAccountingFormat = _core.default.getValueByClosestLocale(function(locale) {
                    return _accounting_formats.default[locale]
                });
                return (0, _open_xml_currency_format.default)(currencySymbol, closestAccountingFormat)
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************************!*\
      !*** ./artifacts/transpiled-npm/localization/cldr-data/parent_locales.js ***!
      \***************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _default = {
            "en-150": "en-001",
            "en-AG": "en-001",
            "en-AI": "en-001",
            "en-AU": "en-001",
            "en-BB": "en-001",
            "en-BM": "en-001",
            "en-BS": "en-001",
            "en-BW": "en-001",
            "en-BZ": "en-001",
            "en-CA": "en-001",
            "en-CC": "en-001",
            "en-CK": "en-001",
            "en-CM": "en-001",
            "en-CX": "en-001",
            "en-CY": "en-001",
            "en-DG": "en-001",
            "en-DM": "en-001",
            "en-ER": "en-001",
            "en-FJ": "en-001",
            "en-FK": "en-001",
            "en-FM": "en-001",
            "en-GB": "en-001",
            "en-GD": "en-001",
            "en-GG": "en-001",
            "en-GH": "en-001",
            "en-GI": "en-001",
            "en-GM": "en-001",
            "en-GY": "en-001",
            "en-HK": "en-001",
            "en-IE": "en-001",
            "en-IL": "en-001",
            "en-IM": "en-001",
            "en-IN": "en-001",
            "en-IO": "en-001",
            "en-JE": "en-001",
            "en-JM": "en-001",
            "en-KE": "en-001",
            "en-KI": "en-001",
            "en-KN": "en-001",
            "en-KY": "en-001",
            "en-LC": "en-001",
            "en-LR": "en-001",
            "en-LS": "en-001",
            "en-MG": "en-001",
            "en-MO": "en-001",
            "en-MS": "en-001",
            "en-MT": "en-001",
            "en-MU": "en-001",
            "en-MW": "en-001",
            "en-MY": "en-001",
            "en-NA": "en-001",
            "en-NF": "en-001",
            "en-NG": "en-001",
            "en-NR": "en-001",
            "en-NU": "en-001",
            "en-NZ": "en-001",
            "en-PG": "en-001",
            "en-PH": "en-001",
            "en-PK": "en-001",
            "en-PN": "en-001",
            "en-PW": "en-001",
            "en-RW": "en-001",
            "en-SB": "en-001",
            "en-SC": "en-001",
            "en-SD": "en-001",
            "en-SG": "en-001",
            "en-SH": "en-001",
            "en-SL": "en-001",
            "en-SS": "en-001",
            "en-SX": "en-001",
            "en-SZ": "en-001",
            "en-TC": "en-001",
            "en-TK": "en-001",
            "en-TO": "en-001",
            "en-TT": "en-001",
            "en-TV": "en-001",
            "en-TZ": "en-001",
            "en-UG": "en-001",
            "en-VC": "en-001",
            "en-VG": "en-001",
            "en-VU": "en-001",
            "en-WS": "en-001",
            "en-ZA": "en-001",
            "en-ZM": "en-001",
            "en-ZW": "en-001",
            "en-AT": "en-150",
            "en-BE": "en-150",
            "en-CH": "en-150",
            "en-DE": "en-150",
            "en-DK": "en-150",
            "en-FI": "en-150",
            "en-NL": "en-150",
            "en-SE": "en-150",
            "en-SI": "en-150",
            "es-AR": "es-419",
            "es-BO": "es-419",
            "es-BR": "es-419",
            "es-BZ": "es-419",
            "es-CL": "es-419",
            "es-CO": "es-419",
            "es-CR": "es-419",
            "es-CU": "es-419",
            "es-DO": "es-419",
            "es-EC": "es-419",
            "es-GT": "es-419",
            "es-HN": "es-419",
            "es-MX": "es-419",
            "es-NI": "es-419",
            "es-PA": "es-419",
            "es-PE": "es-419",
            "es-PR": "es-419",
            "es-PY": "es-419",
            "es-SV": "es-419",
            "es-US": "es-419",
            "es-UY": "es-419",
            "es-VE": "es-419",
            "pt-AO": "pt-PT",
            "pt-CH": "pt-PT",
            "pt-CV": "pt-PT",
            "pt-FR": "pt-PT",
            "pt-GQ": "pt-PT",
            "pt-GW": "pt-PT",
            "pt-LU": "pt-PT",
            "pt-MO": "pt-PT",
            "pt-MZ": "pt-PT",
            "pt-ST": "pt-PT",
            "pt-TL": "pt-PT",
            "az-Arab": "root",
            "az-Cyrl": "root",
            "blt-Latn": "root",
            "bm-Nkoo": "root",
            "bs-Cyrl": "root",
            "byn-Latn": "root",
            "cu-Glag": "root",
            "dje-Arab": "root",
            "dyo-Arab": "root",
            "en-Dsrt": "root",
            "en-Shaw": "root",
            "ff-Adlm": "root",
            "ff-Arab": "root",
            "ha-Arab": "root",
            "hi-Latn": "root",
            "iu-Latn": "root",
            "kk-Arab": "root",
            "ks-Deva": "root",
            "ku-Arab": "root",
            "ky-Arab": "root",
            "ky-Latn": "root",
            "ml-Arab": "root",
            "mn-Mong": "root",
            "mni-Mtei": "root",
            "ms-Arab": "root",
            "pa-Arab": "root",
            "sat-Deva": "root",
            "sd-Deva": "root",
            "sd-Khoj": "root",
            "sd-Sind": "root",
            "shi-Latn": "root",
            "so-Arab": "root",
            "sr-Latn": "root",
            "sw-Arab": "root",
            "tg-Arab": "root",
            "ug-Cyrl": "root",
            "uz-Arab": "root",
            "uz-Cyrl": "root",
            "vai-Latn": "root",
            "wo-Arab": "root",
            "yo-Arab": "root",
            "yue-Hans": "root",
            "zh-Hant": "root",
            "zh-Hant-MO": "zh-Hant-HK"
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/localization/parentLocale.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var PARENT_LOCALE_SEPARATOR = "-";
        var _default = function(parentLocales, locale) {
            var parentLocale = parentLocales[locale];
            if (parentLocale) {
                return "root" !== parentLocale && parentLocale
            }
            return locale.substr(0, locale.lastIndexOf(PARENT_LOCALE_SEPARATOR))
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/localization/cldr-data/accounting_formats.js ***!
      \*******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _default = {
            af: "\xa4#,##0.00;(\xa4#,##0.00)",
            "af-NA": "\xa4#,##0.00;(\xa4#,##0.00)",
            agq: "#,##0.00\xa4",
            ak: "\xa4#,##0.00",
            am: "\xa4#,##0.00;(\xa4#,##0.00)",
            ar: "\xa4#,##0.00;(\xa4#,##0.00)",
            "ar-AE": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ar-BH": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ar-DJ": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ar-DZ": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ar-EG": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ar-EH": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ar-ER": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ar-IL": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ar-IQ": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ar-JO": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ar-KM": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ar-KW": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ar-LB": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ar-LY": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ar-MA": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ar-MR": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ar-OM": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ar-PS": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ar-QA": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ar-SA": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ar-SD": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ar-SO": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ar-SS": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ar-SY": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ar-TD": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ar-TN": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ar-YE": "\xa4#,##0.00;(\xa4#,##0.00)",
            as: "\xa4\xa0#,##,##0.00",
            asa: "#,##0.00\xa0\xa4",
            ast: "#,##0.00\xa0\xa4",
            az: "#,##0.00\xa0\xa4",
            "az-Cyrl": "#,##0.00\xa0\xa4",
            "az-Latn": "#,##0.00\xa0\xa4",
            bas: "#,##0.00\xa0\xa4",
            be: "#,##0.00\xa0\xa4",
            bem: "\xa4#,##0.00;(\xa4#,##0.00)",
            bez: "#,##0.00\xa4",
            bg: "0.00\xa0\xa4;(0.00\xa0\xa4)",
            bm: "\xa4#,##0.00;(\xa4#,##0.00)",
            bn: "#,##,##0.00\xa4;(#,##,##0.00\xa4)",
            "bn-IN": "#,##,##0.00\xa4;(#,##,##0.00\xa4)",
            bo: "\xa4\xa0#,##0.00",
            "bo-IN": "\xa4\xa0#,##0.00",
            br: "#,##0.00\xa0\xa4",
            brx: "\xa4\xa0#,##,##0.00",
            bs: "#,##0.00\xa0\xa4",
            "bs-Cyrl": "#,##0.00\xa0\xa4",
            "bs-Latn": "#,##0.00\xa0\xa4",
            ca: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "ca-AD": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "ca-ES-VALENCIA": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "ca-FR": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "ca-IT": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            ccp: "#,##,##0.00\xa4;(#,##,##0.00\xa4)",
            "ccp-IN": "#,##,##0.00\xa4;(#,##,##0.00\xa4)",
            ce: "#,##0.00\xa0\xa4",
            ceb: "\xa4#,##0.00;(\xa4#,##0.00)",
            cgg: "\xa4#,##0.00",
            chr: "\xa4#,##0.00;(\xa4#,##0.00)",
            ckb: "\xa4\xa0#,##0.00",
            "ckb-IR": "\xa4\xa0#,##0.00",
            cs: "#,##0.00\xa0\xa4",
            cy: "\xa4#,##0.00;(\xa4#,##0.00)",
            da: "#,##0.00\xa0\xa4",
            "da-GL": "#,##0.00\xa0\xa4",
            dav: "\xa4#,##0.00;(\xa4#,##0.00)",
            de: "#,##0.00\xa0\xa4",
            "de-AT": "#,##0.00\xa0\xa4",
            "de-BE": "#,##0.00\xa0\xa4",
            "de-CH": "#,##0.00\xa0\xa4",
            "de-IT": "#,##0.00\xa0\xa4",
            "de-LI": "#,##0.00\xa0\xa4",
            "de-LU": "#,##0.00\xa0\xa4",
            dje: "#,##0.00\xa4",
            doi: "\xa4#,##0.00",
            dsb: "#,##0.00\xa0\xa4",
            dua: "#,##0.00\xa0\xa4",
            dyo: "#,##0.00\xa0\xa4",
            dz: "\xa4#,##,##0.00",
            ebu: "\xa4#,##0.00;(\xa4#,##0.00)",
            ee: "\xa4#,##0.00;(\xa4#,##0.00)",
            "ee-TG": "\xa4#,##0.00;(\xa4#,##0.00)",
            el: "#,##0.00\xa0\xa4",
            "el-CY": "#,##0.00\xa0\xa4",
            en: "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-001": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-150": "#,##0.00\xa0\xa4",
            "en-AE": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-AG": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-AI": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-AS": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-AT": "\xa4\xa0#,##0.00",
            "en-AU": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-BB": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-BE": "#,##0.00\xa0\xa4",
            "en-BI": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-BM": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-BS": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-BW": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-BZ": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-CA": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-CC": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-CH": "\xa4\xa0#,##0.00;\xa4-#,##0.00",
            "en-CK": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-CM": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-CX": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-CY": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-DE": "#,##0.00\xa0\xa4",
            "en-DG": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-DK": "#,##0.00\xa0\xa4",
            "en-DM": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-ER": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-FI": "#,##0.00\xa0\xa4",
            "en-FJ": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-FK": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-FM": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-GB": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-GD": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-GG": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-GH": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-GI": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-GM": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-GU": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-GY": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-HK": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-IE": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-IL": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-IM": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-IN": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-IO": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-JE": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-JM": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-KE": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-KI": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-KN": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-KY": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-LC": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-LR": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-LS": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-MG": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-MH": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-MO": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-MP": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-MS": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-MT": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-MU": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-MW": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-MY": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-NA": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-NF": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-NG": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-NL": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
            "en-NR": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-NU": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-NZ": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-PG": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-PH": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-PK": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-PN": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-PR": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-PW": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-RW": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-SB": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-SC": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-SD": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-SE": "#,##0.00\xa0\xa4",
            "en-SG": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-SH": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-SI": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "en-SL": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-SS": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-SX": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-SZ": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-TC": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-TK": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-TO": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-TT": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-TV": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-TZ": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-UG": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-UM": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-US-POSIX": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-VC": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-VG": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-VI": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-VU": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-WS": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-ZA": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-ZM": "\xa4#,##0.00;(\xa4#,##0.00)",
            "en-ZW": "\xa4#,##0.00;(\xa4#,##0.00)",
            eo: "\xa4\xa0#,##0.00",
            es: "#,##0.00\xa0\xa4",
            "es-419": "\xa4#,##0.00",
            "es-AR": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
            "es-BO": "\xa4#,##0.00",
            "es-BR": "\xa4#,##0.00",
            "es-BZ": "\xa4#,##0.00",
            "es-CL": "\xa4#,##0.00",
            "es-CO": "\xa4#,##0.00",
            "es-CR": "\xa4#,##0.00",
            "es-CU": "\xa4#,##0.00",
            "es-DO": "\xa4#,##0.00;(\xa4#,##0.00)",
            "es-EA": "#,##0.00\xa0\xa4",
            "es-EC": "\xa4#,##0.00",
            "es-GQ": "#,##0.00\xa0\xa4",
            "es-GT": "\xa4#,##0.00",
            "es-HN": "\xa4#,##0.00",
            "es-IC": "#,##0.00\xa0\xa4",
            "es-MX": "\xa4#,##0.00",
            "es-NI": "\xa4#,##0.00",
            "es-PA": "\xa4#,##0.00",
            "es-PE": "\xa4#,##0.00",
            "es-PH": "#,##0.00\xa0\xa4",
            "es-PR": "\xa4#,##0.00",
            "es-PY": "\xa4#,##0.00",
            "es-SV": "\xa4#,##0.00",
            "es-US": "\xa4#,##0.00",
            "es-UY": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
            "es-VE": "\xa4#,##0.00",
            et: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            eu: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            ewo: "#,##0.00\xa0\xa4",
            fa: "\u200e\xa4\xa0#,##0.00;\u200e(\xa4\xa0#,##0.00)",
            "fa-AF": "\xa4\xa0#,##0.00;\u200e(\xa4\xa0#,##0.00)",
            ff: "#,##0.00\xa0\xa4",
            "ff-Adlm": "\xa4\xa0#,##0.00",
            "ff-Adlm-BF": "\xa4\xa0#,##0.00",
            "ff-Adlm-CM": "\xa4\xa0#,##0.00",
            "ff-Adlm-GH": "\xa4\xa0#,##0.00",
            "ff-Adlm-GM": "\xa4\xa0#,##0.00",
            "ff-Adlm-GW": "\xa4\xa0#,##0.00",
            "ff-Adlm-LR": "\xa4\xa0#,##0.00",
            "ff-Adlm-MR": "\xa4\xa0#,##0.00",
            "ff-Adlm-NE": "\xa4\xa0#,##0.00",
            "ff-Adlm-NG": "\xa4\xa0#,##0.00",
            "ff-Adlm-SL": "\xa4\xa0#,##0.00",
            "ff-Adlm-SN": "\xa4\xa0#,##0.00",
            "ff-Latn": "#,##0.00\xa0\xa4",
            "ff-Latn-BF": "#,##0.00\xa0\xa4",
            "ff-Latn-CM": "#,##0.00\xa0\xa4",
            "ff-Latn-GH": "#,##0.00\xa0\xa4",
            "ff-Latn-GM": "#,##0.00\xa0\xa4",
            "ff-Latn-GN": "#,##0.00\xa0\xa4",
            "ff-Latn-GW": "#,##0.00\xa0\xa4",
            "ff-Latn-LR": "#,##0.00\xa0\xa4",
            "ff-Latn-MR": "#,##0.00\xa0\xa4",
            "ff-Latn-NE": "#,##0.00\xa0\xa4",
            "ff-Latn-NG": "#,##0.00\xa0\xa4",
            "ff-Latn-SL": "#,##0.00\xa0\xa4",
            fi: "#,##0.00\xa0\xa4",
            fil: "\xa4#,##0.00;(\xa4#,##0.00)",
            fo: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fo-DK": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            fr: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-BE": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-BF": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-BI": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-BJ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-BL": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-CA": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-CD": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-CF": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-CG": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-CH": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-CI": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-CM": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-DJ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-DZ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-GA": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-GF": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-GN": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-GP": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-GQ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-HT": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-KM": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-LU": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-MA": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-MC": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-MF": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-MG": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-ML": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-MQ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-MR": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-MU": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-NC": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-NE": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-PF": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-PM": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-RE": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-RW": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-SC": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-SN": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-SY": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-TD": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-TG": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-TN": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-VU": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-WF": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "fr-YT": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            fur: "\xa4\xa0#,##0.00",
            fy: "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
            ga: "\xa4#,##0.00;(\xa4#,##0.00)",
            "ga-GB": "\xa4#,##0.00;(\xa4#,##0.00)",
            gd: "\xa4#,##0.00;(\xa4#,##0.00)",
            gl: "#,##0.00\xa0\xa4",
            gsw: "#,##0.00\xa0\xa4",
            "gsw-FR": "#,##0.00\xa0\xa4",
            "gsw-LI": "#,##0.00\xa0\xa4",
            gu: "\xa4#,##,##0.00;(\xa4#,##,##0.00)",
            guz: "\xa4#,##0.00;(\xa4#,##0.00)",
            gv: "\xa4#,##0.00",
            ha: "\xa4\xa0#,##0.00",
            "ha-GH": "\xa4\xa0#,##0.00",
            "ha-NE": "\xa4\xa0#,##0.00",
            haw: "\xa4#,##0.00;(\xa4#,##0.00)",
            he: "#,##0.00\xa0\xa4",
            hi: "\xa4#,##,##0.00",
            hr: "#,##0.00\xa0\xa4",
            "hr-BA": "#,##0.00\xa0\xa4",
            hsb: "#,##0.00\xa0\xa4",
            hu: "#,##0.00\xa0\xa4",
            hy: "#,##0.00\xa0\xa4",
            ia: "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
            id: "\xa4#,##0.00",
            ig: "\xa4#,##0.00;(\xa4#,##0.00)",
            ii: "\xa4\xa0#,##0.00",
            is: "#,##0.00\xa0\xa4",
            it: "#,##0.00\xa0\xa4",
            "it-CH": "#,##0.00\xa0\xa4",
            "it-SM": "#,##0.00\xa0\xa4",
            "it-VA": "#,##0.00\xa0\xa4",
            ja: "\xa4#,##0.00;(\xa4#,##0.00)",
            jgo: "\xa4\xa0#,##0.00",
            jmc: "\xa4#,##0.00",
            jv: "\xa4\xa0#,##0.00",
            ka: "#,##0.00\xa0\xa4",
            kab: "#,##0.00\xa4",
            kam: "\xa4#,##0.00;(\xa4#,##0.00)",
            kde: "\xa4#,##0.00;(\xa4#,##0.00)",
            kea: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            khq: "#,##0.00\xa4",
            ki: "\xa4#,##0.00;(\xa4#,##0.00)",
            kk: "#,##0.00\xa0\xa4",
            kkj: "\xa4\xa0#,##0.00",
            kl: "\xa4#,##0.00;\xa4-#,##0.00",
            kln: "\xa4#,##0.00;(\xa4#,##0.00)",
            km: "#,##0.00\xa4;(#,##0.00\xa4)",
            kn: "\xa4#,##0.00;(\xa4#,##0.00)",
            ko: "\xa4#,##0.00;(\xa4#,##0.00)",
            "ko-KP": "\xa4#,##0.00;(\xa4#,##0.00)",
            kok: "\xa4#,##0.00;(\xa4#,##0.00)",
            ks: "\xa4\xa0#,##,##0.00",
            "ks-Arab": "\xa4\xa0#,##,##0.00",
            ksb: "#,##0.00\xa4",
            ksf: "#,##0.00\xa0\xa4",
            ksh: "#,##0.00\xa0\xa4",
            ku: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            kw: "\xa4#,##0.00",
            ky: "#,##0.00\xa0\xa4",
            lag: "\xa4\xa0#,##0.00",
            lb: "#,##0.00\xa0\xa4",
            lg: "#,##0.00\xa4",
            lkt: "\xa4\xa0#,##0.00",
            ln: "#,##0.00\xa0\xa4",
            "ln-AO": "#,##0.00\xa0\xa4",
            "ln-CF": "#,##0.00\xa0\xa4",
            "ln-CG": "#,##0.00\xa0\xa4",
            lo: "\xa4#,##0.00;\xa4-#,##0.00",
            lrc: "\xa4\xa0#,##0.00",
            "lrc-IQ": "\xa4\xa0#,##0.00",
            lt: "#,##0.00\xa0\xa4",
            lu: "#,##0.00\xa4",
            luo: "#,##0.00\xa4",
            luy: "\xa4#,##0.00;\xa4-\xa0#,##0.00",
            lv: "#,##0.00\xa0\xa4",
            mai: "\xa4\xa0#,##0.00",
            mas: "\xa4#,##0.00;(\xa4#,##0.00)",
            "mas-TZ": "\xa4#,##0.00;(\xa4#,##0.00)",
            mer: "\xa4#,##0.00;(\xa4#,##0.00)",
            mfe: "\xa4\xa0#,##0.00",
            mg: "\xa4#,##0.00",
            mgh: "\xa4\xa0#,##0.00",
            mgo: "\xa4\xa0#,##0.00",
            mi: "\xa4\xa0#,##0.00",
            mk: "#,##0.00\xa0\xa4",
            ml: "\xa4#,##0.00;(\xa4#,##0.00)",
            mn: "\xa4\xa0#,##0.00",
            mni: "\xa4\xa0#,##0.00",
            "mni-Beng": "\xa4\xa0#,##0.00",
            mr: "\xa4#,##0.00;(\xa4#,##0.00)",
            ms: "\xa4#,##0.00;(\xa4#,##0.00)",
            "ms-BN": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ms-ID": "\xa4#,##0.00",
            "ms-SG": "\xa4#,##0.00;(\xa4#,##0.00)",
            mt: "\xa4#,##0.00",
            mua: "\xa4#,##0.00;(\xa4#,##0.00)",
            my: "\xa4\xa0#,##0.00",
            mzn: "\xa4\xa0#,##0.00",
            naq: "\xa4#,##0.00",
            nb: "\xa4\xa0#,##0.00",
            "nb-SJ": "\xa4\xa0#,##0.00",
            nd: "\xa4#,##0.00;(\xa4#,##0.00)",
            nds: "\xa4\xa0#,##0.00",
            "nds-NL": "\xa4\xa0#,##0.00",
            ne: "\xa4\xa0#,##,##0.00",
            "ne-IN": "\xa4\xa0#,##,##0.00",
            nl: "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
            "nl-AW": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
            "nl-BE": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
            "nl-BQ": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
            "nl-CW": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
            "nl-SR": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
            "nl-SX": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
            nmg: "#,##0.00\xa0\xa4",
            nn: "#,##0.00\xa0\xa4",
            nnh: "\xa4\xa0#,##0.00",
            nus: "\xa4#,##0.00;(\xa4#,##0.00)",
            nyn: "\xa4#,##0.00",
            om: "\xa4#,##0.00",
            "om-KE": "\xa4#,##0.00",
            or: "\xa4#,##0.00;(\xa4#,##0.00)",
            os: "\xa4\xa0#,##0.00",
            "os-RU": "\xa4\xa0#,##0.00",
            pa: "\xa4\xa0#,##0.00",
            "pa-Arab": "\xa4\xa0#,##0.00",
            "pa-Guru": "\xa4\xa0#,##0.00",
            pcm: "\xa4#,##0.00",
            pl: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            ps: "\xa4#,##0.00;(\xa4#,##0.00)",
            "ps-PK": "\xa4#,##0.00;(\xa4#,##0.00)",
            pt: "\xa4\xa0#,##0.00",
            "pt-AO": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "pt-CH": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "pt-CV": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "pt-GQ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "pt-GW": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "pt-LU": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "pt-MO": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "pt-MZ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "pt-PT": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "pt-ST": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "pt-TL": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            qu: "\xa4\xa0#,##0.00",
            "qu-BO": "\xa4\xa0#,##0.00",
            "qu-EC": "\xa4\xa0#,##0.00",
            rm: "#,##0.00\xa0\xa4",
            rn: "#,##0.00\xa4",
            ro: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "ro-MD": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            rof: "\xa4#,##0.00",
            root: "\xa4\xa0#,##0.00",
            ru: "#,##0.00\xa0\xa4",
            "ru-BY": "#,##0.00\xa0\xa4",
            "ru-KG": "#,##0.00\xa0\xa4",
            "ru-KZ": "#,##0.00\xa0\xa4",
            "ru-MD": "#,##0.00\xa0\xa4",
            "ru-UA": "#,##0.00\xa0\xa4",
            rw: "\xa4\xa0#,##0.00",
            rwk: "#,##0.00\xa4",
            sa: "\xa4\xa0#,##0.00",
            sah: "#,##0.00\xa0\xa4",
            saq: "\xa4#,##0.00;(\xa4#,##0.00)",
            sat: "\xa4\xa0#,##0.00",
            "sat-Olck": "\xa4\xa0#,##0.00",
            sbp: "#,##0.00\xa4",
            sd: "\xa4\xa0#,##0.00",
            "sd-Arab": "\xa4\xa0#,##0.00",
            "sd-Deva": "\xa4\xa0#,##0.00",
            se: "#,##0.00\xa0\xa4",
            "se-FI": "#,##0.00\xa0\xa4",
            "se-SE": "#,##0.00\xa0\xa4",
            seh: "#,##0.00\xa4",
            ses: "#,##0.00\xa4",
            sg: "\xa4#,##0.00;\xa4-#,##0.00",
            shi: "#,##0.00\xa4",
            "shi-Latn": "#,##0.00\xa4",
            "shi-Tfng": "#,##0.00\xa4",
            si: "\xa4#,##0.00;(\xa4#,##0.00)",
            sk: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            sl: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            smn: "#,##0.00\xa0\xa4",
            sn: "\xa4#,##0.00;(\xa4#,##0.00)",
            so: "\xa4#,##0.00;(\xa4#,##0.00)",
            "so-DJ": "\xa4#,##0.00;(\xa4#,##0.00)",
            "so-ET": "\xa4#,##0.00;(\xa4#,##0.00)",
            "so-KE": "\xa4#,##0.00;(\xa4#,##0.00)",
            sq: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "sq-MK": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "sq-XK": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            sr: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "sr-Cyrl": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "sr-Cyrl-BA": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "sr-Cyrl-ME": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "sr-Cyrl-XK": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "sr-Latn": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "sr-Latn-BA": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "sr-Latn-ME": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            "sr-Latn-XK": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            su: "\xa4#,##0.00",
            "su-Latn": "\xa4#,##0.00",
            sv: "#,##0.00\xa0\xa4",
            "sv-AX": "#,##0.00\xa0\xa4",
            "sv-FI": "#,##0.00\xa0\xa4",
            sw: "\xa4\xa0#,##0.00",
            "sw-CD": "\xa4\xa0#,##0.00",
            "sw-KE": "\xa4\xa0#,##0.00",
            "sw-UG": "\xa4\xa0#,##0.00",
            ta: "\xa4#,##0.00;(\xa4#,##0.00)",
            "ta-LK": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ta-MY": "\xa4#,##0.00;(\xa4#,##0.00)",
            "ta-SG": "\xa4#,##0.00;(\xa4#,##0.00)",
            te: "\xa4#,##0.00;(\xa4#,##0.00)",
            teo: "\xa4#,##0.00;(\xa4#,##0.00)",
            "teo-KE": "\xa4#,##0.00;(\xa4#,##0.00)",
            tg: "#,##0.00\xa0\xa4",
            th: "\xa4#,##0.00;(\xa4#,##0.00)",
            ti: "\xa4#,##0.00",
            "ti-ER": "\xa4#,##0.00",
            tk: "#,##0.00\xa0\xa4",
            to: "\xa4\xa0#,##0.00",
            tr: "\xa4#,##0.00;(\xa4#,##0.00)",
            "tr-CY": "\xa4#,##0.00;(\xa4#,##0.00)",
            tt: "#,##0.00\xa0\xa4",
            twq: "#,##0.00\xa4",
            tzm: "#,##0.00\xa0\xa4",
            ug: "\xa4#,##0.00;(\xa4#,##0.00)",
            uk: "#,##0.00\xa0\xa4",
            ur: "\xa4#,##0.00;(\xa4#,##0.00)",
            "ur-IN": "\xa4#,##0.00;(\xa4#,##0.00)",
            uz: "#,##0.00\xa0\xa4",
            "uz-Arab": "\xa4\xa0#,##0.00",
            "uz-Cyrl": "#,##0.00\xa0\xa4",
            "uz-Latn": "#,##0.00\xa0\xa4",
            vai: "\xa4#,##0.00;(\xa4#,##0.00)",
            "vai-Latn": "\xa4#,##0.00;(\xa4#,##0.00)",
            "vai-Vaii": "\xa4#,##0.00;(\xa4#,##0.00)",
            vi: "#,##0.00\xa0\xa4",
            vun: "\xa4#,##0.00",
            wae: "\xa4\xa0#,##0.00",
            wo: "\xa4\xa0#,##0.00",
            xh: "\xa4#,##0.00",
            xog: "#,##0.00\xa0\xa4",
            yav: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
            yi: "\xa4\xa0#,##0.00",
            yo: "\xa4#,##0.00;(\xa4#,##0.00)",
            "yo-BJ": "\xa4#,##0.00;(\xa4#,##0.00)",
            yue: "\xa4#,##0.00;(\xa4#,##0.00)",
            "yue-Hans": "\xa4#,##0.00;(\xa4#,##0.00)",
            "yue-Hant": "\xa4#,##0.00;(\xa4#,##0.00)",
            zgh: "#,##0.00\xa4",
            zh: "\xa4#,##0.00;(\xa4#,##0.00)",
            "zh-Hans": "\xa4#,##0.00;(\xa4#,##0.00)",
            "zh-Hans-HK": "\xa4#,##0.00;(\xa4#,##0.00)",
            "zh-Hans-MO": "\xa4#,##0.00;(\xa4#,##0.00)",
            "zh-Hans-SG": "\xa4#,##0.00;(\xa4#,##0.00)",
            "zh-Hant": "\xa4#,##0.00;(\xa4#,##0.00)",
            "zh-Hant-HK": "\xa4#,##0.00;(\xa4#,##0.00)",
            "zh-Hant-MO": "\xa4#,##0.00;(\xa4#,##0.00)",
            zu: "\xa4#,##0.00;(\xa4#,##0.00)"
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/localization/cldr-data/first_day_of_week_data.js ***!
      \***********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _default = {
            "af-NA": 1,
            agq: 1,
            ak: 1,
            ar: 6,
            "ar-EH": 1,
            "ar-ER": 1,
            "ar-KM": 1,
            "ar-LB": 1,
            "ar-MA": 1,
            "ar-MR": 1,
            "ar-PS": 1,
            "ar-SO": 1,
            "ar-SS": 1,
            "ar-TD": 1,
            "ar-TN": 1,
            asa: 1,
            ast: 1,
            az: 1,
            "az-Cyrl": 1,
            bas: 1,
            be: 1,
            bem: 1,
            bez: 1,
            bg: 1,
            bm: 1,
            br: 1,
            bs: 1,
            "bs-Cyrl": 1,
            ca: 1,
            ce: 1,
            cgg: 1,
            ckb: 6,
            cs: 1,
            cy: 1,
            da: 1,
            de: 1,
            dje: 1,
            dsb: 1,
            dua: 1,
            dyo: 1,
            ee: 1,
            el: 1,
            "en-001": 1,
            "en-AE": 6,
            "en-BI": 1,
            "en-MP": 1,
            "en-SD": 6,
            eo: 1,
            es: 1,
            et: 1,
            eu: 1,
            ewo: 1,
            fa: 6,
            ff: 1,
            "ff-Adlm": 1,
            fi: 1,
            fo: 1,
            fr: 1,
            "fr-DJ": 6,
            "fr-DZ": 6,
            "fr-SY": 6,
            fur: 1,
            fy: 1,
            ga: 1,
            gd: 1,
            gl: 1,
            gsw: 1,
            gv: 1,
            ha: 1,
            hr: 1,
            hsb: 1,
            hu: 1,
            hy: 1,
            ia: 1,
            ig: 1,
            is: 1,
            it: 1,
            jgo: 1,
            jmc: 1,
            ka: 1,
            kab: 6,
            kde: 1,
            kea: 1,
            khq: 1,
            kk: 1,
            kkj: 1,
            kl: 1,
            "ko-KP": 1,
            ksb: 1,
            ksf: 1,
            ksh: 1,
            ku: 1,
            kw: 1,
            ky: 1,
            lag: 1,
            lb: 1,
            lg: 1,
            ln: 1,
            lrc: 6,
            lt: 1,
            lu: 1,
            lv: 1,
            "mas-TZ": 1,
            mfe: 1,
            mg: 1,
            mgo: 1,
            mi: 1,
            mk: 1,
            mn: 1,
            ms: 1,
            mua: 1,
            mzn: 6,
            naq: 1,
            nb: 1,
            nds: 1,
            nl: 1,
            nmg: 1,
            nn: 1,
            nnh: 1,
            nus: 1,
            nyn: 1,
            os: 1,
            pcm: 1,
            pl: 1,
            ps: 6,
            "pt-AO": 1,
            "pt-CH": 1,
            "pt-CV": 1,
            "pt-GQ": 1,
            "pt-GW": 1,
            "pt-LU": 1,
            "pt-ST": 1,
            "pt-TL": 1,
            "qu-BO": 1,
            "qu-EC": 1,
            rm: 1,
            rn: 1,
            ro: 1,
            rof: 1,
            ru: 1,
            rw: 1,
            rwk: 1,
            sah: 1,
            sbp: 1,
            se: 1,
            ses: 1,
            sg: 1,
            shi: 1,
            "shi-Latn": 1,
            si: 1,
            sk: 1,
            sl: 1,
            smn: 1,
            so: 1,
            "so-DJ": 6,
            sq: 1,
            sr: 1,
            "sr-Latn": 1,
            sv: 1,
            sw: 1,
            "ta-LK": 1,
            "ta-MY": 1,
            teo: 1,
            tg: 1,
            "ti-ER": 1,
            tk: 1,
            to: 1,
            tr: 1,
            tt: 1,
            twq: 1,
            tzm: 1,
            uk: 1,
            uz: 1,
            "uz-Arab": 6,
            "uz-Cyrl": 1,
            vai: 1,
            "vai-Latn": 1,
            vi: 1,
            vun: 1,
            wae: 1,
            wo: 1,
            xog: 1,
            yav: 1,
            yi: 1,
            yo: 1,
            zgh: 1
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************************!*\
      !*** ./artifacts/transpiled-npm/localization/intl/date.js ***!
      \************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _core = _interopRequireDefault(__webpack_require__( /*! ../core */ 87));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        var SYMBOLS_TO_REMOVE_REGEX = /[\u200E\u200F]/g;
        var getIntlFormatter = function(format) {
            return function(date) {
                if (!format.timeZoneName) {
                    var year = date.getFullYear();
                    var recognizableAsTwentyCentury = String(year).length < 3;
                    var safeYearShift = 400;
                    var temporaryYearValue = recognizableAsTwentyCentury ? year + safeYearShift : year;
                    var utcDate = new Date(Date.UTC(temporaryYearValue, date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
                    if (recognizableAsTwentyCentury) {
                        utcDate.setFullYear(year)
                    }
                    var utcFormat = (0, _extend.extend)({
                        timeZone: "UTC"
                    }, format);
                    return formatDateTime(utcDate, utcFormat)
                }
                return formatDateTime(date, format)
            }
        };
        var formattersCache = {};
        var getFormatter = function(format) {
            var key = _core.default.locale() + "/" + JSON.stringify(format);
            if (!formattersCache[key]) {
                formattersCache[key] = new Intl.DateTimeFormat(_core.default.locale(), format).format
            }
            return formattersCache[key]
        };

        function formatDateTime(date, format) {
            return getFormatter(format)(date).replace(SYMBOLS_TO_REMOVE_REGEX, "")
        }
        var formatNumber = function(number) {
            return new Intl.NumberFormat(_core.default.locale()).format(number)
        };
        var getAlternativeNumeralsMap = function() {
            var numeralsMapCache = {};
            return function(locale) {
                if (!(locale in numeralsMapCache)) {
                    if ("0" === formatNumber(0)) {
                        numeralsMapCache[locale] = false;
                        return false
                    }
                    numeralsMapCache[locale] = {};
                    for (var i = 0; i < 10; ++i) {
                        numeralsMapCache[locale][formatNumber(i)] = i
                    }
                }
                return numeralsMapCache[locale]
            }
        }();
        var normalizeNumerals = function(dateString) {
            var alternativeNumeralsMap = getAlternativeNumeralsMap(_core.default.locale());
            if (!alternativeNumeralsMap) {
                return dateString
            }
            return dateString.split("").map(function(sign) {
                return sign in alternativeNumeralsMap ? String(alternativeNumeralsMap[sign]) : sign
            }).join("")
        };
        var removeLeadingZeroes = function(str) {
            return str.replace(/(\D)0+(\d)/g, "$1$2")
        };
        var dateStringEquals = function(actual, expected) {
            return removeLeadingZeroes(actual) === removeLeadingZeroes(expected)
        };
        var normalizeMonth = function(text) {
            return text.replace("d\u2019", "de ")
        };
        var intlFormats = {
            day: {
                day: "numeric"
            },
            dayofweek: {
                weekday: "long"
            },
            longdate: {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric"
            },
            longdatelongtime: {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            longtime: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            month: {
                month: "long"
            },
            monthandday: {
                month: "long",
                day: "numeric"
            },
            monthandyear: {
                year: "numeric",
                month: "long"
            },
            shortdate: {},
            shorttime: {
                hour: "numeric",
                minute: "numeric"
            },
            shortyear: {
                year: "2-digit"
            },
            year: {
                year: "numeric"
            }
        };
        Object.defineProperty(intlFormats, "shortdateshorttime", {
            get: function() {
                var defaultOptions = Intl.DateTimeFormat(_core.default.locale()).resolvedOptions();
                return {
                    year: defaultOptions.year,
                    month: defaultOptions.month,
                    day: defaultOptions.day,
                    hour: "numeric",
                    minute: "numeric"
                }
            }
        });
        var getIntlFormat = function(format) {
            return "string" === typeof format && intlFormats[format.toLowerCase()]
        };
        var monthNameStrategies = {
            standalone: function(monthIndex, monthFormat) {
                var date = new Date(1999, monthIndex, 13, 1);
                var dateString = getIntlFormatter({
                    month: monthFormat
                })(date);
                return dateString
            },
            format: function(monthIndex, monthFormat) {
                var date = new Date(0, monthIndex, 13, 1);
                var dateString = normalizeMonth(getIntlFormatter({
                    day: "numeric",
                    month: monthFormat
                })(date));
                var parts = dateString.split(" ").filter(function(part) {
                    return part.indexOf("13") < 0
                });
                if (1 === parts.length) {
                    return parts[0]
                } else {
                    if (2 === parts.length) {
                        return parts[0].length > parts[1].length ? parts[0] : parts[1]
                    }
                }
                return monthNameStrategies.standalone(monthIndex, monthFormat)
            }
        };
        var _default = {
            engine: function() {
                return "intl"
            },
            getMonthNames: function(format, type) {
                var intlFormats = {
                    wide: "long",
                    abbreviated: "short",
                    narrow: "narrow"
                };
                var monthFormat = intlFormats[format || "wide"];
                type = "format" === type ? type : "standalone";
                return Array.apply(null, new Array(12)).map(function(_, monthIndex) {
                    return monthNameStrategies[type](monthIndex, monthFormat)
                })
            },
            getDayNames: function(format) {
                var intlFormats = {
                    wide: "long",
                    abbreviated: "short",
                    "short": "narrow",
                    narrow: "narrow"
                };
                var getIntlDayNames = function(format) {
                    return Array.apply(null, new Array(7)).map(function(_, dayIndex) {
                        return getIntlFormatter({
                            weekday: format
                        })(new Date(0, 0, dayIndex))
                    })
                };
                var result = getIntlDayNames(intlFormats[format || "wide"]);
                return result
            },
            getPeriodNames: function() {
                var hour12Formatter = getIntlFormatter({
                    hour: "numeric",
                    hour12: true
                });
                return [1, 13].map(function(hours) {
                    var hourNumberText = formatNumber(1);
                    var timeParts = hour12Formatter(new Date(0, 0, 1, hours)).split(hourNumberText);
                    if (2 !== timeParts.length) {
                        return ""
                    }
                    var biggerPart = timeParts[0].length > timeParts[1].length ? timeParts[0] : timeParts[1];
                    return biggerPart.trim()
                })
            },
            format: function(date, _format) {
                if (!date) {
                    return
                }
                if (!_format) {
                    return date
                }
                if ("function" !== typeof _format && !_format.formatter) {
                    _format = _format.type || _format
                }
                var intlFormat = getIntlFormat(_format);
                if (intlFormat) {
                    return getIntlFormatter(intlFormat)(date)
                }
                var formatType = _typeof(_format);
                if (_format.formatter || "function" === formatType || "string" === formatType) {
                    return this.callBase.apply(this, arguments)
                }
                return getIntlFormatter(_format)(date)
            },
            parse: function(dateString, format) {
                var _this = this;
                var formatter;
                if (format && !format.parser && "string" === typeof dateString) {
                    dateString = normalizeMonth(dateString);
                    formatter = function(date) {
                        return normalizeMonth(_this.format(date, format))
                    }
                }
                return this.callBase(dateString, formatter || format)
            },
            _parseDateBySimpleFormat: function(dateString, format) {
                var _this2 = this;
                dateString = normalizeNumerals(dateString);
                var formatParts = this.getFormatParts(format);
                var dateParts = dateString.split(/\D+/).filter(function(part) {
                    return part.length > 0
                });
                if (formatParts.length !== dateParts.length) {
                    return
                }
                var dateArgs = this._generateDateArgs(formatParts, dateParts);
                var constructDate = function(dateArgs, ampmShift) {
                    var hoursShift = ampmShift ? 12 : 0;
                    return new Date(dateArgs.year, dateArgs.month, dateArgs.day, (dateArgs.hours + hoursShift) % 24, dateArgs.minutes, dateArgs.seconds)
                };
                var constructValidDate = function(ampmShift) {
                    var parsedDate = constructDate(dateArgs, ampmShift);
                    if (dateStringEquals(normalizeNumerals(_this2.format(parsedDate, format)), dateString)) {
                        return parsedDate
                    }
                };
                return constructValidDate(false) || constructValidDate(true)
            },
            _generateDateArgs: function(formatParts, dateParts) {
                var currentDate = new Date;
                var dateArgs = {
                    year: currentDate.getFullYear(),
                    month: currentDate.getMonth(),
                    day: currentDate.getDate(),
                    hours: 0,
                    minutes: 0,
                    seconds: 0
                };
                formatParts.forEach(function(formatPart, index) {
                    var datePart = dateParts[index];
                    var parsed = parseInt(datePart, 10);
                    if ("month" === formatPart) {
                        parsed -= 1
                    }
                    dateArgs[formatPart] = parsed
                });
                return dateArgs
            },
            formatUsesMonthName: function(format) {
                if ("object" === _typeof(format) && !(format.type || format.format)) {
                    return "long" === format.month
                }
                return this.callBase.apply(this, arguments)
            },
            formatUsesDayName: function(format) {
                if ("object" === _typeof(format) && !(format.type || format.format)) {
                    return "long" === format.weekday
                }
                return this.callBase.apply(this, arguments)
            },
            getFormatParts: function(format) {
                if ("string" === typeof format) {
                    return this.callBase(format)
                }
                var intlFormat = (0, _extend.extend)({}, intlFormats[format.toLowerCase()]);
                var date = new Date(2001, 2, 4, 5, 6, 7);
                var formattedDate = getIntlFormatter(intlFormat)(date);
                formattedDate = normalizeNumerals(formattedDate);
                var formatParts = [{
                    name: "year",
                    value: 1
                }, {
                    name: "month",
                    value: 3
                }, {
                    name: "day",
                    value: 4
                }, {
                    name: "hours",
                    value: 5
                }, {
                    name: "minutes",
                    value: 6
                }, {
                    name: "seconds",
                    value: 7
                }];
                return formatParts.map(function(part) {
                    return {
                        name: part.name,
                        index: formattedDate.indexOf(part.value)
                    }
                }).filter(function(part) {
                    return part.index > -1
                }).sort(function(a, b) {
                    return a.index - b.index
                }).map(function(part) {
                    return part.name
                })
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/exporter/excel/excel.file.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _excel = _interopRequireDefault(__webpack_require__( /*! ./excel.tag_helper */ 88));
        var _excel2 = _interopRequireDefault(__webpack_require__( /*! ./excel.cell_format_helper */ 501));
        var _excel3 = _interopRequireDefault(__webpack_require__( /*! ./excel.fill_helper */ 244));
        var _excel4 = _interopRequireDefault(__webpack_require__( /*! ./excel.font_helper */ 246));
        var _excel5 = _interopRequireDefault(__webpack_require__( /*! ./excel.number_format_helper */ 504));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ExcelFile = function() {
            function ExcelFile() {
                this._cellFormatTags = [];
                this._fillTags = [];
                this._fontTags = [];
                this._numberFormatTags = [];
                this._fillTags.push(_excel3.default.tryCreateTag({
                    patternFill: {
                        patternType: "none"
                    }
                }))
            }
            var _proto = ExcelFile.prototype;
            _proto.registerCellFormat = function(cellFormat) {
                var result;
                var cellFormatTag = _excel2.default.tryCreateTag(cellFormat, {
                    registerFill: this.registerFill.bind(this),
                    registerFont: this.registerFont.bind(this),
                    registerNumberFormat: this.registerNumberFormat.bind(this)
                });
                if ((0, _type.isDefined)(cellFormatTag)) {
                    for (var i = 0; i < this._cellFormatTags.length; i++) {
                        if (_excel2.default.areEqual(this._cellFormatTags[i], cellFormatTag)) {
                            result = i;
                            break
                        }
                    }
                    if (void 0 === result) {
                        result = this._cellFormatTags.push(cellFormatTag) - 1
                    }
                }
                return result
            };
            ExcelFile.copyCellFormat = function(source) {
                return _excel2.default.copy(source)
            };
            _proto.generateCellFormatsXml = function() {
                var cellFormatTagsAsXmlStringsArray = this._cellFormatTags.map(function(tag) {
                    return _excel2.default.toXml(tag)
                });
                return _excel.default.toXml("cellXfs", {
                    count: cellFormatTagsAsXmlStringsArray.length
                }, cellFormatTagsAsXmlStringsArray.join(""))
            };
            _proto.registerFill = function(fill) {
                var result;
                var fillTag = _excel3.default.tryCreateTag(fill);
                if ((0, _type.isDefined)(fillTag)) {
                    for (var i = 0; i < this._fillTags.length; i++) {
                        if (_excel3.default.areEqual(this._fillTags[i], fillTag)) {
                            result = i;
                            break
                        }
                    }
                    if (void 0 === result) {
                        if (this._fillTags.length < 2) {
                            this._fillTags.push(_excel3.default.tryCreateTag({
                                patternFill: {
                                    patternType: "Gray125"
                                }
                            }))
                        }
                        result = this._fillTags.push(fillTag) - 1
                    }
                }
                return result
            };
            _proto.generateFillsXml = function() {
                var tagsAsXmlStringsArray = this._fillTags.map(function(tag) {
                    return _excel3.default.toXml(tag)
                });
                return _excel.default.toXml("fills", {
                    count: tagsAsXmlStringsArray.length
                }, tagsAsXmlStringsArray.join(""))
            };
            _proto.registerFont = function(font) {
                var result;
                var fontTag = _excel4.default.tryCreateTag(font);
                if ((0, _type.isDefined)(fontTag)) {
                    for (var i = 0; i < this._fontTags.length; i++) {
                        if (_excel4.default.areEqual(this._fontTags[i], fontTag)) {
                            result = i;
                            break
                        }
                    }
                    if (void 0 === result) {
                        result = this._fontTags.push(fontTag) - 1
                    }
                }
                return result
            };
            _proto.generateFontsXml = function() {
                var xmlStringsArray = this._fontTags.map(function(tag) {
                    return _excel4.default.toXml(tag)
                });
                return _excel.default.toXml("fonts", {
                    count: xmlStringsArray.length
                }, xmlStringsArray.join(""))
            };
            _proto._convertNumberFormatIndexToId = function(index) {
                var CUSTOM_FORMAT_ID_START_VALUE = 165;
                return CUSTOM_FORMAT_ID_START_VALUE + index
            };
            _proto.registerNumberFormat = function(numberFormat) {
                var result;
                var tag = _excel5.default.tryCreateTag(numberFormat);
                if ((0, _type.isDefined)(tag)) {
                    for (var i = 0; i < this._numberFormatTags.length; i++) {
                        if (_excel5.default.areEqual(this._numberFormatTags[i], tag)) {
                            result = this._numberFormatTags[i][_excel5.default.ID_PROPERTY_NAME];
                            break
                        }
                    }
                    if (void 0 === result) {
                        tag[_excel5.default.ID_PROPERTY_NAME] = this._convertNumberFormatIndexToId(this._numberFormatTags.length);
                        result = tag[_excel5.default.ID_PROPERTY_NAME];
                        this._numberFormatTags.push(tag)
                    }
                }
                return result
            };
            _proto.generateNumberFormatsXml = function() {
                if (this._numberFormatTags.length > 0) {
                    var xmlStringsArray = this._numberFormatTags.map(function(tag) {
                        return _excel5.default.toXml(tag)
                    });
                    return _excel.default.toXml("numFmts", {
                        count: xmlStringsArray.length
                    }, xmlStringsArray.join(""))
                } else {
                    return ""
                }
            };
            return ExcelFile
        }();
        exports.default = ExcelFile;
        module.exports = exports.default
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/exporter/excel/excel.cell_format_helper.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _excel = _interopRequireDefault(__webpack_require__( /*! ./excel.tag_helper */ 88));
        var _excel2 = _interopRequireDefault(__webpack_require__( /*! ./excel.cell_alignment_helper */ 502));
        var _excel3 = _interopRequireDefault(__webpack_require__( /*! ./excel.fill_helper */ 244));
        var _excel4 = _interopRequireDefault(__webpack_require__( /*! ./excel.font_helper */ 246));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var cellFormatHelper = {
            tryCreateTag: function(sourceObj, sharedItemsContainer) {
                var result = null;
                if ((0, _type.isDefined)(sourceObj)) {
                    var numberFormatId;
                    if ("number" === typeof sourceObj.numberFormat) {
                        numberFormatId = sourceObj.numberFormat
                    } else {
                        numberFormatId = sharedItemsContainer.registerNumberFormat(sourceObj.numberFormat)
                    }
                    var fill = sourceObj.fill;
                    if (!(0, _type.isDefined)(fill)) {
                        fill = _excel3.default.tryCreateFillFromSimpleFormat(sourceObj)
                    }
                    result = {
                        numberFormatId: numberFormatId,
                        alignment: _excel2.default.tryCreateTag(sourceObj.alignment),
                        fontId: sharedItemsContainer.registerFont(sourceObj.font),
                        fillId: sharedItemsContainer.registerFill(fill)
                    };
                    if (cellFormatHelper.isEmpty(result)) {
                        result = null
                    }
                }
                return result
            },
            copy: function(source) {
                var result;
                if (null === source) {
                    result = null
                } else {
                    if ((0, _type.isDefined)(source)) {
                        result = {};
                        if (void 0 !== source.numberFormat) {
                            result.numberFormat = source.numberFormat
                        }
                        if (void 0 !== source.fill) {
                            result.fill = _excel3.default.copy(source.fill)
                        } else {
                            _excel3.default.copySimpleFormat(source, result)
                        }
                        if (void 0 !== source.alignment) {
                            result.alignment = _excel2.default.copy(source.alignment)
                        }
                        if (void 0 !== source.font) {
                            result.font = _excel4.default.copy(source.font)
                        }
                    }
                }
                return result
            },
            areEqual: function(leftTag, rightTag) {
                return cellFormatHelper.isEmpty(leftTag) && cellFormatHelper.isEmpty(rightTag) || (0, _type.isDefined)(leftTag) && (0, _type.isDefined)(rightTag) && leftTag.fontId === rightTag.fontId && leftTag.numberFormatId === rightTag.numberFormatId && leftTag.fillId === rightTag.fillId && _excel2.default.areEqual(leftTag.alignment, rightTag.alignment)
            },
            isEmpty: function(tag) {
                return !(0, _type.isDefined)(tag) || !(0, _type.isDefined)(tag.fontId) && !(0, _type.isDefined)(tag.numberFormatId) && !(0, _type.isDefined)(tag.fillId) && _excel2.default.isEmpty(tag.alignment)
            },
            toXml: function(tag) {
                var isAlignmentEmpty = _excel2.default.isEmpty(tag.alignment);
                var applyNumberFormat;
                if ((0, _type.isDefined)(tag.numberFormatId)) {
                    applyNumberFormat = tag.numberFormatId > 0 ? 1 : 0
                }
                return _excel.default.toXml("xf", {
                    xfId: 0,
                    applyAlignment: isAlignmentEmpty ? null : 1,
                    fontId: tag.fontId,
                    applyNumberFormat: applyNumberFormat,
                    fillId: tag.fillId,
                    numFmtId: tag.numberFormatId
                }, isAlignmentEmpty ? null : _excel2.default.toXml(tag.alignment))
            }
        };
        var _default = cellFormatHelper;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/exporter/excel/excel.cell_alignment_helper.js ***!
      \********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _excel = _interopRequireDefault(__webpack_require__( /*! ./excel.tag_helper */ 88));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var cellAlignmentHelper = {
            tryCreateTag: function(sourceObj) {
                var result = null;
                if ((0, _type.isDefined)(sourceObj)) {
                    result = {
                        vertical: sourceObj.vertical,
                        wrapText: sourceObj.wrapText,
                        horizontal: sourceObj.horizontal
                    };
                    if (cellAlignmentHelper.isEmpty(result)) {
                        result = null
                    }
                }
                return result
            },
            copy: function(source) {
                var result = null;
                if ((0, _type.isDefined)(source)) {
                    result = {};
                    if (void 0 !== source.horizontal) {
                        result.horizontal = source.horizontal
                    }
                    if (void 0 !== source.vertical) {
                        result.vertical = source.vertical
                    }
                    if (void 0 !== source.wrapText) {
                        result.wrapText = source.wrapText
                    }
                }
                return result
            },
            areEqual: function(leftTag, rightTag) {
                return cellAlignmentHelper.isEmpty(leftTag) && cellAlignmentHelper.isEmpty(rightTag) || (0, _type.isDefined)(leftTag) && (0, _type.isDefined)(rightTag) && leftTag.vertical === rightTag.vertical && leftTag.wrapText === rightTag.wrapText && leftTag.horizontal === rightTag.horizontal
            },
            isEmpty: function(tag) {
                return !(0, _type.isDefined)(tag) || !(0, _type.isDefined)(tag.vertical) && !(0, _type.isDefined)(tag.wrapText) && !(0, _type.isDefined)(tag.horizontal)
            },
            toXml: function(tag) {
                return _excel.default.toXml("alignment", {
                    vertical: tag.vertical,
                    wrapText: (0, _type.isDefined)(tag.wrapText) ? Number(tag.wrapText) : void 0,
                    horizontal: tag.horizontal
                })
            }
        };
        var _default = cellAlignmentHelper;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/exporter/excel/excel.pattern_fill_helper.js ***!
      \******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _excel = _interopRequireDefault(__webpack_require__( /*! ./excel.tag_helper */ 88));
        var _excel2 = _interopRequireDefault(__webpack_require__( /*! ./excel.color_helper */ 245));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var patternFillHelper = {
            tryCreateTag: function(sourceObj) {
                var result = null;
                if ((0, _type.isDefined)(sourceObj)) {
                    result = {
                        patternType: sourceObj.patternType,
                        backgroundColor: _excel2.default.tryCreateTag(sourceObj.backgroundColor),
                        foregroundColor: _excel2.default.tryCreateTag(sourceObj.foregroundColor)
                    };
                    if (patternFillHelper.isEmpty(result)) {
                        result = null
                    }
                }
                return result
            },
            copy: function(source) {
                var result = null;
                if ((0, _type.isDefined)(source)) {
                    result = {};
                    if (void 0 !== source.patternType) {
                        result.patternType = source.patternType
                    }
                    if (void 0 !== source.backgroundColor) {
                        result.backgroundColor = _excel2.default.copy(source.backgroundColor)
                    }
                    if (void 0 !== source.foregroundColor) {
                        result.foregroundColor = _excel2.default.copy(source.foregroundColor)
                    }
                }
                return result
            },
            areEqual: function(leftTag, rightTag) {
                return patternFillHelper.isEmpty(leftTag) && patternFillHelper.isEmpty(rightTag) || (0, _type.isDefined)(leftTag) && (0, _type.isDefined)(rightTag) && leftTag.patternType === rightTag.patternType && _excel2.default.areEqual(leftTag.backgroundColor, rightTag.backgroundColor) && _excel2.default.areEqual(leftTag.foregroundColor, rightTag.foregroundColor)
            },
            isEmpty: function(tag) {
                return !(0, _type.isDefined)(tag) || !(0, _type.isDefined)(tag.patternType)
            },
            toXml: function(tag) {
                var content = [(0, _type.isDefined)(tag.foregroundColor) ? _excel2.default.toXml("fgColor", tag.foregroundColor) : "", (0, _type.isDefined)(tag.backgroundColor) ? _excel2.default.toXml("bgColor", tag.backgroundColor) : ""].join("");
                return _excel.default.toXml("patternFill", {
                    patternType: tag.patternType
                }, content)
            }
        };
        var _default = patternFillHelper;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/exporter/excel/excel.number_format_helper.js ***!
      \*******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _excel = _interopRequireDefault(__webpack_require__( /*! ./excel.tag_helper */ 88));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var numberFormatHelper = {
            ID_PROPERTY_NAME: "id",
            tryCreateTag: function(sourceObj) {
                var result = null;
                if ("string" === typeof sourceObj) {
                    result = {
                        formatCode: sourceObj
                    };
                    if (numberFormatHelper.isEmpty(result)) {
                        result = null
                    }
                }
                return result
            },
            areEqual: function(leftTag, rightTag) {
                return numberFormatHelper.isEmpty(leftTag) && numberFormatHelper.isEmpty(rightTag) || (0, _type.isDefined)(leftTag) && (0, _type.isDefined)(rightTag) && leftTag.formatCode === rightTag.formatCode
            },
            isEmpty: function(tag) {
                return !(0, _type.isDefined)(tag) || !(0, _type.isDefined)(tag.formatCode) || "" === tag.formatCode
            },
            toXml: function(tag) {
                return _excel.default.toXml("numFmt", {
                    numFmtId: tag[numberFormatHelper.ID_PROPERTY_NAME],
                    formatCode: tag.formatCode
                })
            }
        };
        var _default = numberFormatHelper;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/exporter/svg_creator.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getData = getData;
        exports.svgCreator = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _ajax = _interopRequireDefault(__webpack_require__( /*! ../core/utils/ajax */ 79));
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _svg = __webpack_require__( /*! ../core/utils/svg */ 205);
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var svgCreator = {
            _markup: "",
            _imageArray: {},
            _imageDeferreds: [],
            _getBinaryFile: function(src, callback) {
                _ajax.default.sendRequest({
                    url: src,
                    method: "GET",
                    responseType: "arraybuffer"
                }).done(callback).fail(function() {
                    callback(false)
                })
            },
            _loadImages: function() {
                var that = this;
                (0, _iterator.each)(that._imageArray, function(src) {
                    var deferred = new _deferred.Deferred;
                    that._imageDeferreds.push(deferred);
                    that._getBinaryFile(src, function(response) {
                        if (!response) {
                            delete that._imageArray[src];
                            deferred.resolve();
                            return
                        }
                        var i;
                        var binary = "";
                        var bytes = new Uint8Array(response);
                        var length = bytes.byteLength;
                        for (i = 0; i < length; i++) {
                            binary += String.fromCharCode(bytes[i])
                        }
                        that._imageArray[src] = "data:image/png;base64," + window.btoa(binary);
                        deferred.resolve()
                    })
                })
            },
            _parseImages: function(element) {
                var href;
                var that = this;
                if ("image" === element.tagName) {
                    href = (0, _renderer.default)(element).attr("href") || (0, _renderer.default)(element).attr("xlink:href");
                    if (!that._imageArray[href]) {
                        that._imageArray[href] = ""
                    }
                }(0, _iterator.each)(element.childNodes, function(_, element) {
                    that._parseImages(element)
                })
            },
            _prepareImages: function(svgElem) {
                this._parseImages(svgElem);
                this._loadImages();
                return _deferred.when.apply(_renderer.default, this._imageDeferreds)
            },
            getData: function(data, options) {
                var markup;
                var that = this;
                var xmlVersion = '<?xml version="1.0" encoding="UTF-8" standalone="yes" ?>';
                var svgElem = (0, _svg.getSvgElement)(data);
                var $svgObject = (0, _renderer.default)(svgElem);
                markup = xmlVersion + (0, _svg.getSvgMarkup)($svgObject.get(0), options.backgroundColor);
                return that._prepareImages(svgElem).then(function() {
                    (0, _iterator.each)(that._imageArray, function(href, dataURI) {
                        var regexpString = "href=['|\"]".concat(href, "['|\"]");
                        markup = markup.replace(new RegExp(regexpString, "gi"), 'href="'.concat(dataURI, '"'))
                    });
                    return (0, _type.isFunction)(window.Blob) ? that._getBlob(markup) : that._getBase64(markup)
                })
            },
            _getBlob: function(markup) {
                return new window.Blob([markup], {
                    type: "image/svg+xml"
                })
            },
            _getBase64: function(markup) {
                return window.btoa(markup)
            }
        };
        exports.svgCreator = svgCreator;

        function getData(data, options) {
            return svgCreator.getData(data, options)
        }
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/core/http_request.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _window = __webpack_require__( /*! ./utils/window */ 7);
        var _dependency_injector = _interopRequireDefault(__webpack_require__( /*! ./utils/dependency_injector */ 58));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var nativeXMLHttpRequest = {
            getXhr: function() {
                return new window.XMLHttpRequest
            }
        };
        var _default = (0, _dependency_injector.default)(nativeXMLHttpRequest);
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/exporter/pdf_creator.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getData = getData;
        var _version = _interopRequireDefault(__webpack_require__( /*! ../core/version */ 173));
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _image_creator = __webpack_require__( /*! ./image_creator */ 247);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var mainPageTemplate = "%PDF-1.3\r\n2 0 obj\r\n<</ProcSet[/PDF/ImageB/ImageC/ImageI]/XObject<</I0 5 0 R>>>>\r\nendobj\r\n4 0 obj\r\n<</Type/Pages/Kids[1 0 R]/Count 1>>\r\nendobj\r\n7 0 obj\r\n<</OpenAction[1 0 R /FitH null]/Type/Catalog/Pages 4 0 R/PageLayout/OneColumn>>\r\nendobj\r\n1 0 obj\r\n<</Type/Page/Resources 2 0 R/MediaBox[0 0 _width_ _height_]/Contents 3 0 R/Parent 4 0 R>>\r\nendobj\r\n";
        var contentTemplate = "3 0 obj\r\n<</Length 52>>stream\r\n0.20 w\n0 G\nq _width_ 0 0 _height_ 0.00 0.00 cm /I0 Do Q\r\nendstream\r\nendobj\r\n";
        var infoTemplate = "6 0 obj\r\n<</CreationDate _date_/Producer(DevExtreme _version_)>>\r\nendobj\r\n";
        var imageStartTemplate = "5 0 obj\r\n<</Type/XObject/Subtype/Image/Width _width_/Height _height_/ColorSpace/DeviceRGB/BitsPerComponent 8/Filter/DCTDecode/Length _length_>>stream\r\n";
        var imageEndTemplate = "\r\nendstream\r\nendobj\r\n";
        var trailerTemplate = "trailer\r\n<<\r\n/Size 8\r\n/Root 7 0 R\r\n/Info 6 0 R\r\n>>\r\nstartxref\r\n_length_\r\n%%EOF";
        var xrefTemplate = "xref\r\n0 8\r\n0000000000 65535 f\r\n0000000241 00000 n\r\n0000000010 00000 n\r\n_main_ 00000 n\r\n0000000089 00000 n\r\n_image_ 00000 n\r\n_info_ 00000 n\r\n0000000143 00000 n\r\n";
        var pad = function pad(str, len) {
            return str.length < len ? pad("0" + str, len) : str
        };
        var composePdfString = function(imageString, options, curDate) {
            var margin = 2 * (options.margin || 0);
            var width = options.width + margin;
            var height = options.height + margin;
            var widthPt = (.75 * width).toFixed(2);
            var heightPt = (.75 * height).toFixed(2);
            var mainPage = mainPageTemplate.replace("_width_", widthPt).replace("_height_", heightPt);
            var content = contentTemplate.replace("_width_", widthPt).replace("_height_", heightPt);
            var info = infoTemplate.replace("_date_", curDate).replace("_version_", _version.default);
            var image = imageStartTemplate.replace("_width_", width).replace("_height_", height).replace("_length_", imageString.length) + imageString + imageEndTemplate;
            var xref = getXref(mainPage.length, content.length, info.length);
            var mainContent = mainPage + content + info + image;
            var trailer = trailerTemplate.replace("_length_", mainContent.length);
            return mainContent + xref + trailer
        };

        function getXref(mainPageLength, contentLength, infoLength) {
            return xrefTemplate.replace("_main_", pad(mainPageLength + "", 10)).replace("_info_", pad(mainPageLength + contentLength + "", 10)).replace("_image_", pad(mainPageLength + contentLength + infoLength + "", 10))
        }
        var getCurDate = function() {
            return new Date
        };
        var getBlob = function(binaryData) {
            var i = 0;
            var dataArray = new Uint8Array(binaryData.length);
            for (; i < binaryData.length; i++) {
                dataArray[i] = binaryData.charCodeAt(i)
            }
            return new window.Blob([dataArray.buffer], {
                type: "application/pdf"
            })
        };
        var getBase64 = function(binaryData) {
            return window.btoa(binaryData)
        };

        function getData(data, options) {
            return _image_creator.imageCreator.getImageData(data, (0, _extend.extend)({}, options, {
                format: "JPEG"
            })).then(function(imageString) {
                var binaryData = composePdfString(imageString, options, getCurDate());
                var pdfData = (0, _type.isFunction)(window.Blob) ? getBlob(binaryData) : getBase64(binaryData);
                return pdfData
            })
        }
    },
    /*!****************************************************!*\
      !*** ./artifacts/transpiled-npm/excel_exporter.js ***!
      \****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        Object.defineProperty(exports, "exportDataGrid", {
            enumerable: true,
            get: function() {
                return _export_data_grid.exportDataGrid
            }
        });
        Object.defineProperty(exports, "exportPivotGrid", {
            enumerable: true,
            get: function() {
                return _export_pivot_grid.exportPivotGrid
            }
        });
        var _export_data_grid = __webpack_require__( /*! ./exporter/exceljs/export_data_grid */ 509);
        var _export_pivot_grid = __webpack_require__( /*! ./exporter/exceljs/export_pivot_grid */ 513)
    },
    /*!***********************************************************************!*\
      !*** ./artifacts/transpiled-npm/exporter/exceljs/export_data_grid.js ***!
      \***********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.exportDataGrid = exportDataGrid;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _export = __webpack_require__( /*! ./export */ 248);
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../../core/errors */ 25));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var helpers = {
            _trySetAutoFilter: function(dataProvider, worksheet, cellRange, autoFilterEnabled) {
                if (autoFilterEnabled) {
                    if (!(0, _type.isDefined)(worksheet.autoFilter) && dataProvider.getRowsCount() > 0) {
                        var dataRange = {
                            from: {
                                row: cellRange.from.row + dataProvider.getHeaderRowCount() - 1,
                                column: cellRange.from.column
                            },
                            to: cellRange.to
                        };
                        worksheet.autoFilter = dataRange
                    }
                }
            },
            _trySetFont: function(excelCell, bold) {
                if ((0, _type.isDefined)(bold)) {
                    excelCell.font = excelCell.font || {};
                    excelCell.font.bold = bold
                }
            },
            _getWorksheetFrozenState: function(dataProvider, cellRange) {
                return {
                    state: "frozen",
                    ySplit: cellRange.from.row + dataProvider.getFrozenArea().y - 1
                }
            },
            _trySetOutlineLevel: function(dataProvider, row, rowIndex) {
                if (rowIndex >= dataProvider.getHeaderRowCount()) {
                    row.outlineLevel = dataProvider.getGroupLevel(rowIndex)
                }
            },
            _getCustomizeCellOptions: function(excelCell, gridCell) {
                var options = {
                    excelCell: excelCell,
                    gridCell: gridCell
                };
                Object.defineProperty(options, "cell", {
                    get: function() {
                        _errors.default.log("W0003", "CustomizeCell handler argument", "cell", "20.1", "Use the 'excelCell' field instead");
                        return excelCell
                    }
                });
                return options
            },
            _isFrozenZone: function(dataProvider) {
                return dataProvider.getHeaderRowCount() > 0
            },
            _isHeaderCell: function(dataProvider, rowIndex) {
                return rowIndex < dataProvider.getHeaderRowCount()
            },
            _allowToMergeRange: function() {
                return true
            },
            _renderLoadPanel: function(component) {
                var rowsView = component.getView("rowsView");
                rowsView._renderLoadPanel(rowsView.element(), rowsView.element().parent())
            }
        };

        function exportDataGrid(options) {
            return _export.Export.export(_getFullOptions(options), helpers)
        }

        function _getFullOptions(options) {
            if (!((0, _type.isDefined)(options) && (0, _type.isObject)(options))) {
                throw Error('The "exportDataGrid" method requires a configuration object.')
            }
            if (!((0, _type.isDefined)(options.component) && (0, _type.isObject)(options.component) && "dxDataGrid" === options.component.NAME)) {
                throw Error('The "component" field must contain a DataGrid instance.')
            }
            if (!(0, _type.isDefined)(options.selectedRowsOnly)) {
                options.selectedRowsOnly = false
            }
            if (!(0, _type.isDefined)(options.autoFilterEnabled)) {
                options.autoFilterEnabled = false
            }
            return _export.Export.getFullOptions(options)
        }
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/localization/default_messages.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _default = {
            en: {
                Yes: "Yes",
                No: "No",
                Cancel: "Cancel",
                Clear: "Clear",
                Done: "Done",
                Loading: "Loading...",
                Select: "Select...",
                Search: "Search",
                Back: "Back",
                OK: "OK",
                "dxCollectionWidget-noDataText": "No data to display",
                "dxDropDownEditor-selectLabel": "Select",
                "validation-required": "Required",
                "validation-required-formatted": "{0} is required",
                "validation-numeric": "Value must be a number",
                "validation-numeric-formatted": "{0} must be a number",
                "validation-range": "Value is out of range",
                "validation-range-formatted": "{0} is out of range",
                "validation-stringLength": "The length of the value is not correct",
                "validation-stringLength-formatted": "The length of {0} is not correct",
                "validation-custom": "Value is invalid",
                "validation-custom-formatted": "{0} is invalid",
                "validation-async": "Value is invalid",
                "validation-async-formatted": "{0} is invalid",
                "validation-compare": "Values do not match",
                "validation-compare-formatted": "{0} does not match",
                "validation-pattern": "Value does not match pattern",
                "validation-pattern-formatted": "{0} does not match pattern",
                "validation-email": "Email is invalid",
                "validation-email-formatted": "{0} is invalid",
                "validation-mask": "Value is invalid",
                "dxLookup-searchPlaceholder": "Minimum character number: {0}",
                "dxList-pullingDownText": "Pull down to refresh...",
                "dxList-pulledDownText": "Release to refresh...",
                "dxList-refreshingText": "Refreshing...",
                "dxList-pageLoadingText": "Loading...",
                "dxList-nextButtonText": "More",
                "dxList-selectAll": "Select All",
                "dxListEditDecorator-delete": "Delete",
                "dxListEditDecorator-more": "More",
                "dxScrollView-pullingDownText": "Pull down to refresh...",
                "dxScrollView-pulledDownText": "Release to refresh...",
                "dxScrollView-refreshingText": "Refreshing...",
                "dxScrollView-reachBottomText": "Loading...",
                "dxDateBox-simulatedDataPickerTitleTime": "Select time",
                "dxDateBox-simulatedDataPickerTitleDate": "Select date",
                "dxDateBox-simulatedDataPickerTitleDateTime": "Select date and time",
                "dxDateBox-validation-datetime": "Value must be a date or time",
                "dxFileUploader-selectFile": "Select file",
                "dxFileUploader-dropFile": "or Drop file here",
                "dxFileUploader-bytes": "bytes",
                "dxFileUploader-kb": "kb",
                "dxFileUploader-Mb": "Mb",
                "dxFileUploader-Gb": "Gb",
                "dxFileUploader-upload": "Upload",
                "dxFileUploader-uploaded": "Uploaded",
                "dxFileUploader-readyToUpload": "Ready to upload",
                "dxFileUploader-uploadAbortedMessage": "Upload cancelled",
                "dxFileUploader-uploadFailedMessage": "Upload failed",
                "dxFileUploader-invalidFileExtension": "File type is not allowed",
                "dxFileUploader-invalidMaxFileSize": "File is too large",
                "dxFileUploader-invalidMinFileSize": "File is too small",
                "dxRangeSlider-ariaFrom": "From",
                "dxRangeSlider-ariaTill": "Till",
                "dxSwitch-switchedOnText": "ON",
                "dxSwitch-switchedOffText": "OFF",
                "dxForm-optionalMark": "optional",
                "dxForm-requiredMessage": "{0} is required",
                "dxNumberBox-invalidValueMessage": "Value must be a number",
                "dxNumberBox-noDataText": "No data",
                "dxDataGrid-columnChooserTitle": "Column Chooser",
                "dxDataGrid-columnChooserEmptyText": "Drag a column here to hide it",
                "dxDataGrid-groupContinuesMessage": "Continues on the next page",
                "dxDataGrid-groupContinuedMessage": "Continued from the previous page",
                "dxDataGrid-groupHeaderText": "Group by This Column",
                "dxDataGrid-ungroupHeaderText": "Ungroup",
                "dxDataGrid-ungroupAllText": "Ungroup All",
                "dxDataGrid-editingEditRow": "Edit",
                "dxDataGrid-editingSaveRowChanges": "Save",
                "dxDataGrid-editingCancelRowChanges": "Cancel",
                "dxDataGrid-editingDeleteRow": "Delete",
                "dxDataGrid-editingUndeleteRow": "Undelete",
                "dxDataGrid-editingConfirmDeleteMessage": "Are you sure you want to delete this record?",
                "dxDataGrid-validationCancelChanges": "Cancel changes",
                "dxDataGrid-groupPanelEmptyText": "Drag a column header here to group by that column",
                "dxDataGrid-noDataText": "No data",
                "dxDataGrid-searchPanelPlaceholder": "Search...",
                "dxDataGrid-filterRowShowAllText": "(All)",
                "dxDataGrid-filterRowResetOperationText": "Reset",
                "dxDataGrid-filterRowOperationEquals": "Equals",
                "dxDataGrid-filterRowOperationNotEquals": "Does not equal",
                "dxDataGrid-filterRowOperationLess": "Less than",
                "dxDataGrid-filterRowOperationLessOrEquals": "Less than or equal to",
                "dxDataGrid-filterRowOperationGreater": "Greater than",
                "dxDataGrid-filterRowOperationGreaterOrEquals": "Greater than or equal to",
                "dxDataGrid-filterRowOperationStartsWith": "Starts with",
                "dxDataGrid-filterRowOperationContains": "Contains",
                "dxDataGrid-filterRowOperationNotContains": "Does not contain",
                "dxDataGrid-filterRowOperationEndsWith": "Ends with",
                "dxDataGrid-filterRowOperationBetween": "Between",
                "dxDataGrid-filterRowOperationBetweenStartText": "Start",
                "dxDataGrid-filterRowOperationBetweenEndText": "End",
                "dxDataGrid-applyFilterText": "Apply filter",
                "dxDataGrid-trueText": "true",
                "dxDataGrid-falseText": "false",
                "dxDataGrid-sortingAscendingText": "Sort Ascending",
                "dxDataGrid-sortingDescendingText": "Sort Descending",
                "dxDataGrid-sortingClearText": "Clear Sorting",
                "dxDataGrid-editingSaveAllChanges": "Save changes",
                "dxDataGrid-editingCancelAllChanges": "Discard changes",
                "dxDataGrid-editingAddRow": "Add a row",
                "dxDataGrid-summaryMin": "Min: {0}",
                "dxDataGrid-summaryMinOtherColumn": "Min of {1} is {0}",
                "dxDataGrid-summaryMax": "Max: {0}",
                "dxDataGrid-summaryMaxOtherColumn": "Max of {1} is {0}",
                "dxDataGrid-summaryAvg": "Avg: {0}",
                "dxDataGrid-summaryAvgOtherColumn": "Avg of {1} is {0}",
                "dxDataGrid-summarySum": "Sum: {0}",
                "dxDataGrid-summarySumOtherColumn": "Sum of {1} is {0}",
                "dxDataGrid-summaryCount": "Count: {0}",
                "dxDataGrid-columnFixingFix": "Fix",
                "dxDataGrid-columnFixingUnfix": "Unfix",
                "dxDataGrid-columnFixingLeftPosition": "To the left",
                "dxDataGrid-columnFixingRightPosition": "To the right",
                "dxDataGrid-exportTo": "Export",
                "dxDataGrid-exportToExcel": "Export to Excel file",
                "dxDataGrid-exporting": "Exporting...",
                "dxDataGrid-excelFormat": "Excel file",
                "dxDataGrid-selectedRows": "Selected rows",
                "dxDataGrid-exportSelectedRows": "Export selected rows",
                "dxDataGrid-exportAll": "Export all data",
                "dxDataGrid-headerFilterEmptyValue": "(Blanks)",
                "dxDataGrid-headerFilterOK": "OK",
                "dxDataGrid-headerFilterCancel": "Cancel",
                "dxDataGrid-ariaAdaptiveCollapse": "Hide additional data",
                "dxDataGrid-ariaAdaptiveExpand": "Display additional data",
                "dxDataGrid-ariaColumn": "Column",
                "dxDataGrid-ariaValue": "Value",
                "dxDataGrid-ariaFilterCell": "Filter cell",
                "dxDataGrid-ariaCollapse": "Collapse",
                "dxDataGrid-ariaExpand": "Expand",
                "dxDataGrid-ariaDataGrid": "Data grid",
                "dxDataGrid-ariaSearchInGrid": "Search in the data grid",
                "dxDataGrid-ariaSelectAll": "Select all",
                "dxDataGrid-ariaSelectRow": "Select row",
                "dxDataGrid-ariaToolbar": "Data grid toolbar",
                "dxDataGrid-filterBuilderPopupTitle": "Filter Builder",
                "dxDataGrid-filterPanelCreateFilter": "Create Filter",
                "dxDataGrid-filterPanelClearFilter": "Clear",
                "dxDataGrid-filterPanelFilterEnabledHint": "Enable the filter",
                "dxTreeList-ariaTreeList": "Tree list",
                "dxTreeList-ariaSearchInGrid": "Search in the tree list",
                "dxTreeList-ariaToolbar": "Tree list toolbar",
                "dxTreeList-editingAddRowToNode": "Add",
                "dxPager-infoText": "Page {0} of {1} ({2} items)",
                "dxPager-pagesCountText": "of",
                "dxPager-pageSizesAllText": "All",
                "dxPivotGrid-grandTotal": "Grand Total",
                "dxPivotGrid-total": "{0} Total",
                "dxPivotGrid-fieldChooserTitle": "Field Chooser",
                "dxPivotGrid-showFieldChooser": "Show Field Chooser",
                "dxPivotGrid-expandAll": "Expand All",
                "dxPivotGrid-collapseAll": "Collapse All",
                "dxPivotGrid-sortColumnBySummary": 'Sort "{0}" by This Column',
                "dxPivotGrid-sortRowBySummary": 'Sort "{0}" by This Row',
                "dxPivotGrid-removeAllSorting": "Remove All Sorting",
                "dxPivotGrid-dataNotAvailable": "N/A",
                "dxPivotGrid-rowFields": "Row Fields",
                "dxPivotGrid-columnFields": "Column Fields",
                "dxPivotGrid-dataFields": "Data Fields",
                "dxPivotGrid-filterFields": "Filter Fields",
                "dxPivotGrid-allFields": "All Fields",
                "dxPivotGrid-columnFieldArea": "Drop Column Fields Here",
                "dxPivotGrid-dataFieldArea": "Drop Data Fields Here",
                "dxPivotGrid-rowFieldArea": "Drop Row Fields Here",
                "dxPivotGrid-filterFieldArea": "Drop Filter Fields Here",
                "dxScheduler-editorLabelTitle": "Subject",
                "dxScheduler-editorLabelStartDate": "Start Date",
                "dxScheduler-editorLabelEndDate": "End Date",
                "dxScheduler-editorLabelDescription": "Description",
                "dxScheduler-editorLabelRecurrence": "Repeat",
                "dxScheduler-openAppointment": "Open appointment",
                "dxScheduler-recurrenceNever": "Never",
                "dxScheduler-recurrenceMinutely": "Every minute",
                "dxScheduler-recurrenceHourly": "Hourly",
                "dxScheduler-recurrenceDaily": "Daily",
                "dxScheduler-recurrenceWeekly": "Weekly",
                "dxScheduler-recurrenceMonthly": "Monthly",
                "dxScheduler-recurrenceYearly": "Yearly",
                "dxScheduler-recurrenceRepeatEvery": "Repeat Every",
                "dxScheduler-recurrenceRepeatOn": "Repeat On",
                "dxScheduler-recurrenceEnd": "End repeat",
                "dxScheduler-recurrenceAfter": "After",
                "dxScheduler-recurrenceOn": "On",
                "dxScheduler-recurrenceRepeatMinutely": "minute(s)",
                "dxScheduler-recurrenceRepeatHourly": "hour(s)",
                "dxScheduler-recurrenceRepeatDaily": "day(s)",
                "dxScheduler-recurrenceRepeatWeekly": "week(s)",
                "dxScheduler-recurrenceRepeatMonthly": "month(s)",
                "dxScheduler-recurrenceRepeatYearly": "year(s)",
                "dxScheduler-switcherDay": "Day",
                "dxScheduler-switcherWeek": "Week",
                "dxScheduler-switcherWorkWeek": "Work Week",
                "dxScheduler-switcherMonth": "Month",
                "dxScheduler-switcherAgenda": "Agenda",
                "dxScheduler-switcherTimelineDay": "Timeline Day",
                "dxScheduler-switcherTimelineWeek": "Timeline Week",
                "dxScheduler-switcherTimelineWorkWeek": "Timeline Work Week",
                "dxScheduler-switcherTimelineMonth": "Timeline Month",
                "dxScheduler-recurrenceRepeatOnDate": "on date",
                "dxScheduler-recurrenceRepeatCount": "occurrence(s)",
                "dxScheduler-allDay": "All day",
                "dxScheduler-confirmRecurrenceEditMessage": "Do you want to edit only this appointment or the whole series?",
                "dxScheduler-confirmRecurrenceDeleteMessage": "Do you want to delete only this appointment or the whole series?",
                "dxScheduler-confirmRecurrenceEditSeries": "Edit series",
                "dxScheduler-confirmRecurrenceDeleteSeries": "Delete series",
                "dxScheduler-confirmRecurrenceEditOccurrence": "Edit appointment",
                "dxScheduler-confirmRecurrenceDeleteOccurrence": "Delete appointment",
                "dxScheduler-noTimezoneTitle": "No timezone",
                "dxScheduler-moreAppointments": "{0} more",
                "dxCalendar-todayButtonText": "Today",
                "dxCalendar-ariaWidgetName": "Calendar",
                "dxColorView-ariaRed": "Red",
                "dxColorView-ariaGreen": "Green",
                "dxColorView-ariaBlue": "Blue",
                "dxColorView-ariaAlpha": "Transparency",
                "dxColorView-ariaHex": "Color code",
                "dxTagBox-selected": "{0} selected",
                "dxTagBox-allSelected": "All selected ({0})",
                "dxTagBox-moreSelected": "{0} more",
                "vizExport-printingButtonText": "Print",
                "vizExport-titleMenuText": "Exporting/Printing",
                "vizExport-exportButtonText": "{0} file",
                "dxFilterBuilder-and": "And",
                "dxFilterBuilder-or": "Or",
                "dxFilterBuilder-notAnd": "Not And",
                "dxFilterBuilder-notOr": "Not Or",
                "dxFilterBuilder-addCondition": "Add Condition",
                "dxFilterBuilder-addGroup": "Add Group",
                "dxFilterBuilder-enterValueText": "<enter a value>",
                "dxFilterBuilder-filterOperationEquals": "Equals",
                "dxFilterBuilder-filterOperationNotEquals": "Does not equal",
                "dxFilterBuilder-filterOperationLess": "Is less than",
                "dxFilterBuilder-filterOperationLessOrEquals": "Is less than or equal to",
                "dxFilterBuilder-filterOperationGreater": "Is greater than",
                "dxFilterBuilder-filterOperationGreaterOrEquals": "Is greater than or equal to",
                "dxFilterBuilder-filterOperationStartsWith": "Starts with",
                "dxFilterBuilder-filterOperationContains": "Contains",
                "dxFilterBuilder-filterOperationNotContains": "Does not contain",
                "dxFilterBuilder-filterOperationEndsWith": "Ends with",
                "dxFilterBuilder-filterOperationIsBlank": "Is blank",
                "dxFilterBuilder-filterOperationIsNotBlank": "Is not blank",
                "dxFilterBuilder-filterOperationBetween": "Is between",
                "dxFilterBuilder-filterOperationAnyOf": "Is any of",
                "dxFilterBuilder-filterOperationNoneOf": "Is none of",
                "dxHtmlEditor-dialogColorCaption": "Change Font Color",
                "dxHtmlEditor-dialogBackgroundCaption": "Change Background Color",
                "dxHtmlEditor-dialogLinkCaption": "Add Link",
                "dxHtmlEditor-dialogLinkUrlField": "URL",
                "dxHtmlEditor-dialogLinkTextField": "Text",
                "dxHtmlEditor-dialogLinkTargetField": "Open link in new window",
                "dxHtmlEditor-dialogImageCaption": "Add Image",
                "dxHtmlEditor-dialogImageUrlField": "URL",
                "dxHtmlEditor-dialogImageAltField": "Alternate text",
                "dxHtmlEditor-dialogImageWidthField": "Width (px)",
                "dxHtmlEditor-dialogImageHeightField": "Height (px)",
                "dxHtmlEditor-dialogInsertTableRowsField": "Rows",
                "dxHtmlEditor-dialogInsertTableColumnsField": "Columns",
                "dxHtmlEditor-dialogInsertTableCaption": "Insert Table",
                "dxHtmlEditor-heading": "Heading",
                "dxHtmlEditor-normalText": "Normal text",
                "dxFileManager-newDirectoryName": "Untitled directory",
                "dxFileManager-rootDirectoryName": "Files",
                "dxFileManager-errorNoAccess": "Access Denied. Operation could not be completed.",
                "dxFileManager-errorDirectoryExistsFormat": "Directory '{0}' already exists.",
                "dxFileManager-errorFileExistsFormat": "File '{0}' already exists.",
                "dxFileManager-errorFileNotFoundFormat": "File '{0}' not found.",
                "dxFileManager-errorDirectoryNotFoundFormat": "Directory '{0}' not found.",
                "dxFileManager-errorWrongFileExtension": "File extension is not allowed.",
                "dxFileManager-errorMaxFileSizeExceeded": "File size exceeds the maximum allowed size.",
                "dxFileManager-errorInvalidSymbols": "This name contains invalid characters.",
                "dxFileManager-errorDefault": "Unspecified error.",
                "dxFileManager-errorDirectoryOpenFailed": "The directory cannot be opened",
                "dxFileManager-commandCreate": "New directory",
                "dxFileManager-commandRename": "Rename",
                "dxFileManager-commandMove": "Move to",
                "dxFileManager-commandCopy": "Copy to",
                "dxFileManager-commandDelete": "Delete",
                "dxFileManager-commandDownload": "Download",
                "dxFileManager-commandUpload": "Upload files",
                "dxFileManager-commandRefresh": "Refresh",
                "dxFileManager-commandThumbnails": "Thumbnails View",
                "dxFileManager-commandDetails": "Details View",
                "dxFileManager-commandClearSelection": "Clear selection",
                "dxFileManager-commandShowNavPane": "Toggle navigation pane",
                "dxFileManager-dialogDirectoryChooserMoveTitle": "Move to",
                "dxFileManager-dialogDirectoryChooserMoveButtonText": "Move",
                "dxFileManager-dialogDirectoryChooserCopyTitle": "Copy to",
                "dxFileManager-dialogDirectoryChooserCopyButtonText": "Copy",
                "dxFileManager-dialogRenameItemTitle": "Rename",
                "dxFileManager-dialogRenameItemButtonText": "Save",
                "dxFileManager-dialogCreateDirectoryTitle": "New directory",
                "dxFileManager-dialogCreateDirectoryButtonText": "Create",
                "dxFileManager-dialogDeleteItemTitle": "Delete",
                "dxFileManager-dialogDeleteItemButtonText": "Delete",
                "dxFileManager-dialogDeleteItemSingleItemConfirmation": "Are you sure you want to delete {0}?",
                "dxFileManager-dialogDeleteItemMultipleItemsConfirmation": "Are you sure you want to delete {0} items?",
                "dxFileManager-dialogButtonCancel": "Cancel",
                "dxFileManager-editingCreateSingleItemProcessingMessage": "Creating a directory inside {0}",
                "dxFileManager-editingCreateSingleItemSuccessMessage": "Created a directory inside {0}",
                "dxFileManager-editingCreateSingleItemErrorMessage": "Directory was not created",
                "dxFileManager-editingCreateCommonErrorMessage": "Directory was not created",
                "dxFileManager-editingRenameSingleItemProcessingMessage": "Renaming an item inside {0}",
                "dxFileManager-editingRenameSingleItemSuccessMessage": "Renamed an item inside {0}",
                "dxFileManager-editingRenameSingleItemErrorMessage": "Item was not renamed",
                "dxFileManager-editingRenameCommonErrorMessage": "Item was not renamed",
                "dxFileManager-editingDeleteSingleItemProcessingMessage": "Deleting an item from {0}",
                "dxFileManager-editingDeleteMultipleItemsProcessingMessage": "Deleting {0} items from {1}",
                "dxFileManager-editingDeleteSingleItemSuccessMessage": "Deleted an item from {0}",
                "dxFileManager-editingDeleteMultipleItemsSuccessMessage": "Deleted {0} items from {1}",
                "dxFileManager-editingDeleteSingleItemErrorMessage": "Item was not deleted",
                "dxFileManager-editingDeleteMultipleItemsErrorMessage": "{0} items were not deleted",
                "dxFileManager-editingDeleteCommonErrorMessage": "Some items were not deleted",
                "dxFileManager-editingMoveSingleItemProcessingMessage": "Moving an item to {0}",
                "dxFileManager-editingMoveMultipleItemsProcessingMessage": "Moving {0} items to {1}",
                "dxFileManager-editingMoveSingleItemSuccessMessage": "Moved an item to {0}",
                "dxFileManager-editingMoveMultipleItemsSuccessMessage": "Moved {0} items to {1}",
                "dxFileManager-editingMoveSingleItemErrorMessage": "Item was not moved",
                "dxFileManager-editingMoveMultipleItemsErrorMessage": "{0} items were not moved",
                "dxFileManager-editingMoveCommonErrorMessage": "Some items were not moved",
                "dxFileManager-editingCopySingleItemProcessingMessage": "Copying an item to {0}",
                "dxFileManager-editingCopyMultipleItemsProcessingMessage": "Copying {0} items to {1}",
                "dxFileManager-editingCopySingleItemSuccessMessage": "Copied an item to {0}",
                "dxFileManager-editingCopyMultipleItemsSuccessMessage": "Copied {0} items to {1}",
                "dxFileManager-editingCopySingleItemErrorMessage": "Item was not copied",
                "dxFileManager-editingCopyMultipleItemsErrorMessage": "{0} items were not copied",
                "dxFileManager-editingCopyCommonErrorMessage": "Some items were not copied",
                "dxFileManager-editingUploadSingleItemProcessingMessage": "Uploading an item to {0}",
                "dxFileManager-editingUploadMultipleItemsProcessingMessage": "Uploading {0} items to {1}",
                "dxFileManager-editingUploadSingleItemSuccessMessage": "Uploaded an item to {0}",
                "dxFileManager-editingUploadMultipleItemsSuccessMessage": "Uploaded {0} items to {1}",
                "dxFileManager-editingUploadSingleItemErrorMessage": "Item was not uploaded",
                "dxFileManager-editingUploadMultipleItemsErrorMessage": "{0} items were not uploaded",
                "dxFileManager-editingUploadCanceledMessage": "Canceled",
                "dxFileManager-listDetailsColumnCaptionName": "Name",
                "dxFileManager-listDetailsColumnCaptionDateModified": "Date Modified",
                "dxFileManager-listDetailsColumnCaptionFileSize": "File Size",
                "dxFileManager-listThumbnailsTooltipTextSize": "Size",
                "dxFileManager-listThumbnailsTooltipTextDateModified": "Date Modified",
                "dxFileManager-notificationProgressPanelTitle": "Progress",
                "dxFileManager-notificationProgressPanelEmptyListText": "No operations",
                "dxFileManager-notificationProgressPanelOperationCanceled": "Canceled",
                "dxDiagram-categoryGeneral": "General",
                "dxDiagram-categoryFlowchart": "Flowchart",
                "dxDiagram-categoryOrgChart": "Org Chart",
                "dxDiagram-categoryContainers": "Containers",
                "dxDiagram-categoryCustom": "Custom",
                "dxDiagram-commandExportToSvg": "Export to SVG",
                "dxDiagram-commandExportToPng": "Export to PNG",
                "dxDiagram-commandExportToJpg": "Export to JPEG",
                "dxDiagram-commandUndo": "Undo",
                "dxDiagram-commandRedo": "Redo",
                "dxDiagram-commandFontName": "Font Name",
                "dxDiagram-commandFontSize": "Font Size",
                "dxDiagram-commandBold": "Bold",
                "dxDiagram-commandItalic": "Italic",
                "dxDiagram-commandUnderline": "Underline",
                "dxDiagram-commandTextColor": "Font Color",
                "dxDiagram-commandLineColor": "Line Color",
                "dxDiagram-commandLineWidth": "Line Width",
                "dxDiagram-commandLineStyle": "Line Style",
                "dxDiagram-commandLineStyleSolid": "Solid",
                "dxDiagram-commandLineStyleDotted": "Dotted",
                "dxDiagram-commandLineStyleDashed": "Dashed",
                "dxDiagram-commandFillColor": "Fill Color",
                "dxDiagram-commandAlignLeft": "Align Left",
                "dxDiagram-commandAlignCenter": "Align Center",
                "dxDiagram-commandAlignRight": "Align Right",
                "dxDiagram-commandConnectorLineType": "Connector Line Type",
                "dxDiagram-commandConnectorLineStraight": "Straight",
                "dxDiagram-commandConnectorLineOrthogonal": "Orthogonal",
                "dxDiagram-commandConnectorLineStart": "Connector Line Start",
                "dxDiagram-commandConnectorLineEnd": "Connector Line End",
                "dxDiagram-commandConnectorLineNone": "None",
                "dxDiagram-commandConnectorLineArrow": "Arrow",
                "dxDiagram-commandFullscreen": "Full Screen",
                "dxDiagram-commandUnits": "Units",
                "dxDiagram-commandPageSize": "Page Size",
                "dxDiagram-commandPageOrientation": "Page Orientation",
                "dxDiagram-commandPageOrientationLandscape": "Landscape",
                "dxDiagram-commandPageOrientationPortrait": "Portrait",
                "dxDiagram-commandPageColor": "Page Color",
                "dxDiagram-commandShowGrid": "Show Grid",
                "dxDiagram-commandSnapToGrid": "Snap to Grid",
                "dxDiagram-commandGridSize": "Grid Size",
                "dxDiagram-commandZoomLevel": "Zoom Level",
                "dxDiagram-commandAutoZoom": "Auto Zoom",
                "dxDiagram-commandFitToContent": "Fit to Content",
                "dxDiagram-commandFitToWidth": "Fit to Width",
                "dxDiagram-commandAutoZoomByContent": "Auto Zoom by Content",
                "dxDiagram-commandAutoZoomByWidth": "Auto Zoom by Width",
                "dxDiagram-commandSimpleView": "Simple View",
                "dxDiagram-commandCut": "Cut",
                "dxDiagram-commandCopy": "Copy",
                "dxDiagram-commandPaste": "Paste",
                "dxDiagram-commandSelectAll": "Select All",
                "dxDiagram-commandDelete": "Delete",
                "dxDiagram-commandBringToFront": "Bring to Front",
                "dxDiagram-commandSendToBack": "Send to Back",
                "dxDiagram-commandLock": "Lock",
                "dxDiagram-commandUnlock": "Unlock",
                "dxDiagram-commandInsertShapeImage": "Insert Image...",
                "dxDiagram-commandEditShapeImage": "Change Image...",
                "dxDiagram-commandDeleteShapeImage": "Delete Image",
                "dxDiagram-commandLayoutLeftToRight": "Left-to-right",
                "dxDiagram-commandLayoutRightToLeft": "Right-to-left",
                "dxDiagram-commandLayoutTopToBottom": "Top-to-bottom",
                "dxDiagram-commandLayoutBottomToTop": "Bottom-to-top",
                "dxDiagram-unitIn": "in",
                "dxDiagram-unitCm": "cm",
                "dxDiagram-unitPx": "px",
                "dxDiagram-dialogButtonOK": "OK",
                "dxDiagram-dialogButtonCancel": "Cancel",
                "dxDiagram-dialogInsertShapeImageTitle": "Insert Image",
                "dxDiagram-dialogEditShapeImageTitle": "Change Image",
                "dxDiagram-dialogEditShapeImageSelectButton": "Select image",
                "dxDiagram-dialogEditShapeImageLabelText": "or drop file here",
                "dxDiagram-uiExport": "Export",
                "dxDiagram-uiProperties": "Properties",
                "dxDiagram-uiSettings": "Settings",
                "dxDiagram-uiShowToolbox": "Show Toolbox",
                "dxDiagram-uiSearch": "Search",
                "dxDiagram-uiStyle": "Style",
                "dxDiagram-uiLayout": "Layout",
                "dxDiagram-uiLayoutTree": "Tree",
                "dxDiagram-uiLayoutLayered": "Layered",
                "dxDiagram-uiDiagram": "Diagram",
                "dxDiagram-uiText": "Text",
                "dxDiagram-uiObject": "Object",
                "dxDiagram-uiConnector": "Connector",
                "dxDiagram-uiPage": "Page",
                "dxDiagram-shapeText": "Text",
                "dxDiagram-shapeRectangle": "Rectangle",
                "dxDiagram-shapeEllipse": "Ellipse",
                "dxDiagram-shapeCross": "Cross",
                "dxDiagram-shapeTriangle": "Triangle",
                "dxDiagram-shapeDiamond": "Diamond",
                "dxDiagram-shapeHeart": "Heart",
                "dxDiagram-shapePentagon": "Pentagon",
                "dxDiagram-shapeHexagon": "Hexagon",
                "dxDiagram-shapeOctagon": "Octagon",
                "dxDiagram-shapeStar": "Star",
                "dxDiagram-shapeArrowLeft": "Left Arrow",
                "dxDiagram-shapeArrowUp": "Up Arrow",
                "dxDiagram-shapeArrowRight": "Right Arrow",
                "dxDiagram-shapeArrowDown": "Down Arrow",
                "dxDiagram-shapeArrowUpDown": "Up Down Arrow",
                "dxDiagram-shapeArrowLeftRight": "Left Right Arrow",
                "dxDiagram-shapeProcess": "Process",
                "dxDiagram-shapeDecision": "Decision",
                "dxDiagram-shapeTerminator": "Terminator",
                "dxDiagram-shapePredefinedProcess": "Predefined Process",
                "dxDiagram-shapeDocument": "Document",
                "dxDiagram-shapeMultipleDocuments": "Multiple Documents",
                "dxDiagram-shapeManualInput": "Manual Input",
                "dxDiagram-shapePreparation": "Preparation",
                "dxDiagram-shapeData": "Data",
                "dxDiagram-shapeDatabase": "Database",
                "dxDiagram-shapeHardDisk": "Hard Disk",
                "dxDiagram-shapeInternalStorage": "Internal Storage",
                "dxDiagram-shapePaperTape": "Paper Tape",
                "dxDiagram-shapeManualOperation": "Manual Operation",
                "dxDiagram-shapeDelay": "Delay",
                "dxDiagram-shapeStoredData": "Stored Data",
                "dxDiagram-shapeDisplay": "Display",
                "dxDiagram-shapeMerge": "Merge",
                "dxDiagram-shapeConnector": "Connector",
                "dxDiagram-shapeOr": "Or",
                "dxDiagram-shapeSummingJunction": "Summing Junction",
                "dxDiagram-shapeContainerDefaultText": "Container",
                "dxDiagram-shapeVerticalContainer": "Vertical Container",
                "dxDiagram-shapeHorizontalContainer": "Horizontal Container",
                "dxDiagram-shapeCardDefaultText": "Person's Name",
                "dxDiagram-shapeCardWithImageOnLeft": "Card with Image on the Left",
                "dxDiagram-shapeCardWithImageOnTop": "Card with Image on the Top",
                "dxDiagram-shapeCardWithImageOnRight": "Card with Image on the Right",
                "dxGantt-dialogTitle": "Title",
                "dxGantt-dialogStartTitle": "Start",
                "dxGantt-dialogEndTitle": "End",
                "dxGantt-dialogProgressTitle": "Progress",
                "dxGantt-dialogResourcesTitle": "Resources",
                "dxGantt-dialogResourceManagerTitle": "Resource Manager",
                "dxGantt-dialogTaskDetailsTitle": "Task Details",
                "dxGantt-dialogEditResourceListHint": "Edit Resource List",
                "dxGantt-dialogEditNoResources": "No resources",
                "dxGantt-dialogButtonAdd": "Add",
                "dxGantt-contextMenuNewTask": "New Task",
                "dxGantt-contextMenuNewSubtask": "New Subtask",
                "dxGantt-contextMenuDeleteTask": "Delete Task",
                "dxGantt-contextMenuDeleteDependency": "Delete Dependency",
                "dxGantt-dialogTaskDeleteConfirmation": "Deleting a task also deletes all its dependencies and subtasks. Are you sure you want to delete this task?",
                "dxGantt-dialogDependencyDeleteConfirmation": "Are you sure you want to delete the dependency from the task?",
                "dxGantt-dialogResourcesDeleteConfirmation": "Deleting a resource also deletes it from tasks to which this resource is assigned. Are you sure you want to delete these resources? Resources: {0}",
                "dxGantt-dialogConstraintCriticalViolationMessage": "The task you are attempting to move is linked to a second task by a dependency relation. This change would conflict with dependency rules. How would you like to proceed?",
                "dxGantt-dialogConstraintViolationMessage": "The task you are attempting to move is linked to a second task by a dependency relation. How would you like to proceed?",
                "dxGantt-dialogCancelOperationMessage": "Cancel the operation",
                "dxGantt-dialogDeleteDependencyMessage": "Delete the dependency",
                "dxGantt-dialogMoveTaskAndKeepDependencyMessage": "Move the task and keep the dependency",
                "dxGantt-undo": "Undo",
                "dxGantt-redo": "Redo",
                "dxGantt-expandAll": "Expand All",
                "dxGantt-collapseAll": "Collapse All",
                "dxGantt-addNewTask": "Add New Task",
                "dxGantt-deleteSelectedTask": "Delete Selected Task",
                "dxGantt-zoomIn": "Zoom In",
                "dxGantt-zoomOut": "Zoom Out",
                "dxGantt-fullScreen": "Full Screen"
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/exporter/exceljs/export_format.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.ExportFormat = void 0;
        var _string = __webpack_require__( /*! ../../core/utils/string */ 43);
        var _number = _interopRequireDefault(__webpack_require__( /*! ../../localization/number */ 47));
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../localization/date */ 32));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _date2 = __webpack_require__( /*! ../../localization/ldml/date.format */ 174);
        var _language_codes = __webpack_require__( /*! ../../localization/language_codes */ 204);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        __webpack_require__( /*! ../../localization/currency */ 114);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ARABIC_ZERO_CODE = 1632;
        var DEFINED_NUMBER_FORMTATS = {
            thousands: "#,##0{0},&quot;K&quot;",
            millions: "#,##0{0},,&quot;M&quot;",
            billions: "#,##0{0},,,&quot;B&quot;",
            trillions: "#,##0{0},,,,&quot;T&quot;",
            percent: "0{0}%",
            decimal: "#{0}",
            fixedpoint: "#,##0{0}",
            exponential: "0{0}E+00",
            currency: " "
        };
        var PERIOD_REGEXP = /a+/g;
        var DAY_REGEXP = /E/g;
        var DO_REGEXP = /dE+/g;
        var STANDALONE_MONTH_REGEXP = /L/g;
        var HOUR_REGEXP = /h/g;
        var ANY_REGEXP = /./g;

        function _applyPrecision(format, precision) {
            var result;
            var i;
            if (precision > 0) {
                result = "decimal" !== format ? "." : "";
                for (i = 0; i < precision; i++) {
                    result += "0"
                }
                return result
            }
            return ""
        }

        function _hasArabicDigits(text) {
            var code;
            for (var i = 0; i < text.length; i++) {
                code = text.charCodeAt(i);
                if (code >= ARABIC_ZERO_CODE && code < ARABIC_ZERO_CODE + 10) {
                    return true
                }
            }
            return false
        }

        function _convertDateFormat(format) {
            var formattedValue = (_date.default.format(new Date(2009, 8, 8, 6, 5, 4), format) || "").toString();
            var result = (0, _date2.getFormat)(function(value) {
                return _date.default.format(value, format)
            });
            if (result) {
                result = _convertDateFormatToOpenXml(result);
                result = _getLanguageInfo(formattedValue) + result
            }
            return result
        }

        function _getLanguageInfo(defaultPattern) {
            var languageID = (0, _language_codes.getLanguageId)();
            var languageIDStr = languageID ? languageID.toString(16) : "";
            var languageInfo = "";
            if (_hasArabicDigits(defaultPattern)) {
                while (languageIDStr.length < 3) {
                    languageIDStr = "0" + languageIDStr
                }
                languageInfo = "[$-2010" + languageIDStr + "]"
            } else {
                if (languageIDStr) {
                    languageInfo = "[$-" + languageIDStr + "]"
                }
            }
            return languageInfo
        }

        function _convertDateFormatToOpenXml(format) {
            return format.split("/").join("\\/").split("'").map(function(datePart, index) {
                if (index % 2 === 0) {
                    return datePart.replace(PERIOD_REGEXP, "AM/PM").replace(DO_REGEXP, "d").replace(DAY_REGEXP, "d").replace(STANDALONE_MONTH_REGEXP, "M").replace(HOUR_REGEXP, "H").split("[").join("\\[").split("]").join("\\]")
                }
                if (datePart) {
                    return datePart.replace(ANY_REGEXP, "\\$&")
                }
                return "'"
            }).join("")
        }

        function _convertNumberFormat(format, precision, currency) {
            var result;
            var excelFormat;
            if ("currency" === format) {
                excelFormat = _number.default.getOpenXmlCurrencyFormat(currency)
            } else {
                excelFormat = DEFINED_NUMBER_FORMTATS[format.toLowerCase()]
            }
            if (excelFormat) {
                result = (0, _string.format)(excelFormat, _applyPrecision(format, precision))
            }
            return result
        }
        var ExportFormat = {
            formatObjectConverter: function(format, dataType) {
                var result = {
                    format: format,
                    precision: format && format.precision,
                    dataType: dataType
                };
                if ((0, _type.isObject)(format)) {
                    return (0, _extend.extend)(result, format, {
                        format: format.formatter || format.type,
                        currency: format.currency
                    })
                }
                return result
            },
            convertFormat: function(format, precision, type, currency) {
                if ((0, _type.isDefined)(format)) {
                    if ("date" === type) {
                        return _convertDateFormat(format)
                    } else {
                        if ((0, _type.isString)(format) && DEFINED_NUMBER_FORMTATS[format.toLowerCase()]) {
                            return _convertNumberFormat(format, precision, currency)
                        }
                    }
                }
            }
        };
        exports.ExportFormat = ExportFormat
    },
    /*!***********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/exporter/exceljs/export_merged_ranges_manager.js ***!
      \***********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.MergedRangesManager = void 0;

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }
        var MergedRangesManager = function() {
            function MergedRangesManager(dataProvider, helpers, mergeRowFieldValues, mergeColumnFieldValues) {
                this.mergedCells = [];
                this.mergedRanges = [];
                this.dataProvider = dataProvider;
                this.helpers = helpers;
                this.mergeRowFieldValues = mergeRowFieldValues;
                this.mergeColumnFieldValues = mergeColumnFieldValues
            }
            var _proto = MergedRangesManager.prototype;
            _proto.updateMergedRanges = function(excelCell, rowIndex, cellIndex) {
                if (this.helpers._isHeaderCell(this.dataProvider, rowIndex, cellIndex)) {
                    if (!this.isCellInMergedRanges(rowIndex, cellIndex)) {
                        var _this$dataProvider$ge = this.dataProvider.getCellMerging(rowIndex, cellIndex),
                            rowspan = _this$dataProvider$ge.rowspan,
                            colspan = _this$dataProvider$ge.colspan;
                        var isMasterCellOfMergedRange = colspan || rowspan;
                        if (isMasterCellOfMergedRange) {
                            var allowToMergeRange = this.helpers._allowToMergeRange(this.dataProvider, rowIndex, cellIndex, rowspan, colspan, this.mergeRowFieldValues, this.mergeColumnFieldValues);
                            this.updateMergedCells(excelCell, rowIndex, cellIndex, rowspan, colspan, allowToMergeRange);
                            if (allowToMergeRange) {
                                this.mergedRanges.push(_objectSpread({
                                    masterCell: excelCell
                                }, {
                                    rowspan: rowspan,
                                    colspan: colspan
                                }))
                            }
                        }
                    }
                }
            };
            _proto.isCellInMergedRanges = function(rowIndex, cellIndex) {
                return this.mergedCells[rowIndex] && this.mergedCells[rowIndex][cellIndex]
            };
            _proto.findMergedCellInfo = function(rowIndex, cellIndex) {
                if (this.helpers._isHeaderCell(this.dataProvider, rowIndex, cellIndex)) {
                    if (this.isCellInMergedRanges(rowIndex, cellIndex)) {
                        return this.mergedCells[rowIndex][cellIndex]
                    }
                }
            };
            _proto.updateMergedCells = function(excelCell, rowIndex, cellIndex, rowspan, colspan, allowToMergeRange) {
                for (var i = rowIndex; i <= rowIndex + rowspan; i++) {
                    for (var j = cellIndex; j <= cellIndex + colspan; j++) {
                        if (!this.mergedCells[i]) {
                            this.mergedCells[i] = []
                        }
                        this.mergedCells[i][j] = {
                            masterCell: excelCell,
                            unmerged: !allowToMergeRange
                        }
                    }
                }
            };
            _proto.applyMergedRages = function(worksheet) {
                this.mergedRanges.forEach(function(range) {
                    var startRowIndex = range.masterCell.fullAddress.row;
                    var startColumnIndex = range.masterCell.fullAddress.col;
                    var endRowIndex = startRowIndex + range.rowspan;
                    var endColumnIndex = startColumnIndex + range.colspan;
                    worksheet.mergeCells(startRowIndex, startColumnIndex, endRowIndex, endColumnIndex)
                })
            };
            return MergedRangesManager
        }();
        exports.MergedRangesManager = MergedRangesManager
    },
    /*!************************************************************************!*\
      !*** ./artifacts/transpiled-npm/exporter/exceljs/export_pivot_grid.js ***!
      \************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.exportPivotGrid = exportPivotGrid;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _export = __webpack_require__( /*! ./export */ 248);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var helpers = {
            _getWorksheetFrozenState: function(dataProvider, cellRange) {
                return {
                    state: "frozen",
                    xSplit: cellRange.from.column + dataProvider.getFrozenArea().x - 1,
                    ySplit: cellRange.from.row + dataProvider.getFrozenArea().y - 1
                }
            },
            _getCustomizeCellOptions: function(excelCell, pivotCell) {
                return {
                    excelCell: excelCell,
                    pivotCell: pivotCell
                }
            },
            _isFrozenZone: function() {
                return true
            },
            _isHeaderCell: function(dataProvider, rowIndex, cellIndex) {
                return rowIndex < dataProvider.getColumnAreaRowCount() || cellIndex < dataProvider.getRowAreaColCount()
            },
            _allowToMergeRange: function(dataProvider, rowIndex, cellIndex, rowspan, colspan, mergeRowFieldValues, mergeColumnFieldValues) {
                return !(dataProvider.isColumnAreaCell(rowIndex, cellIndex) && !mergeColumnFieldValues && !!colspan || dataProvider.isRowAreaCell(rowIndex, cellIndex) && !mergeRowFieldValues && !!rowspan)
            },
            _renderLoadPanel: function(component) {
                component._renderLoadPanel(component._dataArea.groupElement(), component.$element())
            },
            _trySetAutoFilter: _common.noop,
            _trySetFont: _common.noop,
            _trySetOutlineLevel: _common.noop
        };

        function exportPivotGrid(options) {
            return _export.Export.export(_getFullOptions(options), helpers)
        }

        function _getFullOptions(options) {
            if (!((0, _type.isDefined)(options) && (0, _type.isObject)(options))) {
                throw Error('The "exportPivotGrid" method requires a configuration object.')
            }
            if (!((0, _type.isDefined)(options.component) && (0, _type.isObject)(options.component) && "dxPivotGrid" === options.component.NAME)) {
                throw Error('The "component" field must contain a PivotGrid instance.')
            }
            if (!(0, _type.isDefined)(options.mergeRowFieldValues)) {
                options.mergeRowFieldValues = true
            }
            if (!(0, _type.isDefined)(options.mergeColumnFieldValues)) {
                options.mergeColumnFieldValues = true
            }
            return _export.Export.getFullOptions(options)
        }
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/pdf_exporter.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        Object.defineProperty(exports, "exportDataGrid", {
            enumerable: true,
            get: function() {
                return _export_data_grid.exportDataGrid
            }
        });
        var _export_data_grid = __webpack_require__( /*! ./exporter/jspdf/export_data_grid */ 515)
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/exporter/jspdf/export_data_grid.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.exportDataGrid = exportDataGrid;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _export = __webpack_require__( /*! ./export */ 516);

        function _getFullOptions(options) {
            if (!((0, _type.isDefined)(options) && (0, _type.isObject)(options))) {
                throw Error('The "exportDataGrid" method requires a configuration object.')
            }
            if (!((0, _type.isDefined)(options.component) && (0, _type.isObject)(options.component) && "dxDataGrid" === options.component.NAME)) {
                throw Error('The "component" field must contain a DataGrid instance.')
            }
            if (!(0, _type.isDefined)(options.selectedRowsOnly)) {
                options.selectedRowsOnly = false
            }
            return _export.Export.getFullOptions(options)
        }

        function exportDataGrid(options) {
            return _export.Export.export(_getFullOptions(options))
        }
    },
    /*!***********************************************************!*\
      !*** ./artifacts/transpiled-npm/exporter/jspdf/export.js ***!
      \***********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.Export = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../localization/date */ 32));
        var _number = _interopRequireDefault(__webpack_require__( /*! ../../localization/number */ 47));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var Export = {
            getFullOptions: function(options) {
                var fullOptions = (0, _extend.extend)({}, options);
                if (!((0, _type.isDefined)(fullOptions.jsPDFDocument) && (0, _type.isObject)(fullOptions.jsPDFDocument))) {
                    throw Error('The "jsPDFDocument" field must contain a jsPDF instance.')
                }
                if (!((0, _type.isDefined)(fullOptions.jsPDFDocument.autoTable) && (0, _type.isFunction)(fullOptions.jsPDFDocument.autoTable))) {
                    throw Error('The "exportDataGrid" method requires a autoTable plugin for jsPDF object.')
                }
                if (!(0, _type.isDefined)(fullOptions.keepColumnWidths)) {
                    fullOptions.keepColumnWidths = true
                }
                if (!(0, _type.isDefined)(fullOptions.autoTableOptions)) {
                    fullOptions.autoTableOptions = this._getDefaultAutoTableOptions()
                } else {
                    if (!(0, _type.isObject)(fullOptions.autoTableOptions)) {
                        throw Error('The "autoTableOptions" option must be of object type.')
                    }
                    fullOptions.autoTableOptions = (0, _extend.extend)(true, {}, this._getDefaultAutoTableOptions(), fullOptions.autoTableOptions)
                }
                if (!(0, _type.isDefined)(fullOptions.loadPanel)) {
                    fullOptions.loadPanel = {}
                }
                if (!(0, _type.isDefined)(fullOptions.loadPanel.enabled)) {
                    fullOptions.loadPanel.enabled = true
                }
                if (!(0, _type.isDefined)(fullOptions.loadPanel.text)) {
                    fullOptions.loadPanel.text = _message.default.format("dxDataGrid-exporting")
                }
                return fullOptions
            },
            _getDefaultAutoTableOptions: function() {
                return {
                    theme: "plain",
                    tableLineColor: 149,
                    tableLineWidth: .1,
                    styles: {
                        textColor: 51,
                        lineColor: 149,
                        lineWidth: 0
                    },
                    columnStyles: {},
                    headStyles: {
                        fontStyle: "normal",
                        textColor: 149,
                        lineWidth: .1
                    },
                    bodyStyles: {
                        lineWidth: .1
                    },
                    head: [],
                    body: []
                }
            },
            _setLoadPanelOptions: function(component, options) {
                if (!(0, _window.hasWindow)()) {
                    return
                }
                component._setOptionWithoutOptionChange("loadPanel", options);
                this._renderLoadPanel(component)
            },
            _renderLoadPanel: function(component) {
                var rowsView = component.getView("rowsView");
                rowsView._renderLoadPanel(rowsView.element(), rowsView.element().parent())
            },
            "export": function(options) {
                var _this = this;
                var jsPDFDocument = options.jsPDFDocument,
                    autoTableOptions = options.autoTableOptions,
                    component = options.component,
                    customizeCell = options.customizeCell,
                    keepColumnWidths = options.keepColumnWidths,
                    selectedRowsOnly = options.selectedRowsOnly,
                    loadPanel = options.loadPanel;
                var initialLoadPanelOptions = (0, _extend.extend)({}, component.option("loadPanel"));
                if ("animation" in component.option("loadPanel")) {
                    loadPanel.animation = null
                }
                this._setLoadPanelOptions(component, loadPanel);
                var dataProvider = component.getDataProvider(selectedRowsOnly);
                var wrapText = !!component.option("wordWrapEnabled");
                return new Promise(function(resolve) {
                    dataProvider.ready().done(function() {
                        var columns = dataProvider.getColumns();
                        var styles = dataProvider.getStyles();
                        var dataRowsCount = dataProvider.getRowsCount();
                        var headerRowCount = dataProvider.getHeaderRowCount();
                        var mergedCells = [];
                        if (keepColumnWidths) {
                            var pdfColumnWidths = _this._tryGetPdfColumnWidths(autoTableOptions.tableWidth, dataProvider.getColumnsWidths());
                            if ((0, _type.isDefined)(pdfColumnWidths) && (0, _type.isDefined)(autoTableOptions.columnStyles)) {
                                _this._setColumnWidths(autoTableOptions.columnStyles, pdfColumnWidths)
                            }
                        }
                        for (var rowIndex = 0; rowIndex < dataRowsCount; rowIndex++) {
                            var row = [];
                            for (var cellIndex = 0; cellIndex < columns.length; cellIndex++) {
                                var _dataProvider$getCell = dataProvider.getCellData(rowIndex, cellIndex, true),
                                    value = _dataProvider$getCell.value,
                                    gridCell = _dataProvider$getCell.cellSourceData;
                                var cellStyle = styles[dataProvider.getStyleId(rowIndex, cellIndex)];
                                var pdfCell = {
                                    content: _this._getFormattedValue(value, cellStyle.format),
                                    styles: _this._getPDFCellStyles(gridCell.rowType, columns[cellIndex].alignment, cellStyle, wrapText)
                                };
                                if ("header" === gridCell.rowType) {
                                    var mergedRange = _this._tryGetMergeRange(rowIndex, cellIndex, mergedCells, dataProvider);
                                    if (mergedRange && mergedRange.rowSpan > 0) {
                                        pdfCell.rowSpan = mergedRange.rowSpan + 1
                                    }
                                    if (mergedRange && mergedRange.colSpan > 0) {
                                        pdfCell.colSpan = mergedRange.colSpan + 1
                                    }
                                    var isMergedCell = mergedCells[rowIndex] && mergedCells[rowIndex][cellIndex];
                                    if (!isMergedCell || pdfCell.rowSpan > 1 || pdfCell.colSpan > 1) {
                                        if ((0, _type.isFunction)(customizeCell)) {
                                            customizeCell({
                                                gridCell: gridCell,
                                                pdfCell: pdfCell
                                            })
                                        }
                                        row.push(pdfCell)
                                    }
                                } else {
                                    if ("group" === gridCell.rowType && !(0, _type.isDefined)(pdfCell.content) && 1 === row.length) {
                                        var _row$0$colSpan;
                                        row[0].colSpan = null !== (_row$0$colSpan = row[0].colSpan) && void 0 !== _row$0$colSpan ? _row$0$colSpan : 1;
                                        row[0].colSpan++
                                    } else {
                                        var _pdfCell$content;
                                        pdfCell.content = null !== (_pdfCell$content = pdfCell.content) && void 0 !== _pdfCell$content ? _pdfCell$content : "";
                                        if ((0, _type.isFunction)(customizeCell)) {
                                            customizeCell({
                                                gridCell: gridCell,
                                                pdfCell: pdfCell
                                            })
                                        }
                                        row.push(pdfCell)
                                    }
                                }
                            }
                            if (rowIndex < headerRowCount) {
                                autoTableOptions.head.push(row)
                            } else {
                                autoTableOptions.body.push(row)
                            }
                        }
                        jsPDFDocument.autoTable(autoTableOptions);
                        resolve()
                    }).always(function() {
                        _this._setLoadPanelOptions(component, initialLoadPanelOptions)
                    })
                })
            },
            _getFormattedValue: function(value, format) {
                if ((0, _type.isDefined)(format)) {
                    if ((0, _type.isDate)(value)) {
                        return _date.default.format(value, format)
                    }
                    if ((0, _type.isNumeric)(value)) {
                        return _number.default.format(value, format)
                    }
                }
                return value
            },
            _getPDFCellStyles: function(rowType, columnAlignment, cellStyle, wrapText) {
                var cellAlignment = cellStyle.alignment,
                    bold = cellStyle.bold;
                var align = "header" === rowType ? columnAlignment : cellAlignment;
                var pdfCellStyle = {};
                if (align) {
                    pdfCellStyle.halign = align
                }
                if (bold && "header" !== rowType) {
                    pdfCellStyle.fontStyle = "bold"
                }
                if (wrapText) {
                    pdfCellStyle.cellWidth = "wrap"
                }
                return pdfCellStyle
            },
            _tryGetMergeRange: function(rowIndex, cellIndex, mergedCells, dataProvider) {
                if (!mergedCells[rowIndex] || !mergedCells[rowIndex][cellIndex]) {
                    var _dataProvider$getCell2 = dataProvider.getCellMerging(rowIndex, cellIndex),
                        colspan = _dataProvider$getCell2.colspan,
                        rowspan = _dataProvider$getCell2.rowspan;
                    if (colspan || rowspan) {
                        for (var i = rowIndex; i <= rowIndex + rowspan || 0; i++) {
                            for (var j = cellIndex; j <= cellIndex + colspan || 0; j++) {
                                if (!mergedCells[i]) {
                                    mergedCells[i] = []
                                }
                                mergedCells[i][j] = true
                            }
                        }
                        return {
                            rowSpan: rowspan,
                            colSpan: colspan
                        }
                    }
                }
            },
            _tryGetPdfColumnWidths: function(autoTableWidth, columnWidths) {
                if ((0, _type.isNumeric)(autoTableWidth) && (0, _type.isDefined)(columnWidths)) {
                    var tableWidth = columnWidths.reduce(function(a, b) {
                        return a + b
                    }, 0);
                    return columnWidths.map(function(columnWidth) {
                        return autoTableWidth * columnWidth / tableWidth
                    })
                }
            },
            _setColumnWidths: function(autoTableColumnStyles, pdfColumnWidths) {
                pdfColumnWidths.forEach(function(width, index) {
                    autoTableColumnStyles[index] = autoTableColumnStyles[index] || {};
                    autoTableColumnStyles[index].cellWidth = width
                })
            }
        };
        exports.Export = Export
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/core/options/option_manager.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.OptionManager = void 0;
        var _data = __webpack_require__( /*! ../utils/data */ 20);
        var _common = __webpack_require__( /*! ../utils/common */ 4);
        var _comparator = __webpack_require__( /*! ../utils/comparator */ 249);
        var _extend = __webpack_require__( /*! ../utils/extend */ 0);
        var _type = __webpack_require__( /*! ../utils/type */ 1);
        var _utils = __webpack_require__( /*! ./utils */ 198);
        var cachedGetters = {};
        var cachedSetters = {};
        var OptionManager = function() {
            function OptionManager(options, optionsByReference) {
                this._options = options;
                this._optionsByReference = optionsByReference;
                this._changingCallback;
                this._changedCallback;
                this._namePreparedCallbacks
            }
            var _proto = OptionManager.prototype;
            _proto._setByReference = function(options, rulesOptions) {
                (0, _extend.extend)(true, options, rulesOptions);
                for (var fieldName in this._optionsByReference) {
                    if (Object.prototype.hasOwnProperty.call(rulesOptions, fieldName)) {
                        options[fieldName] = rulesOptions[fieldName]
                    }
                }
            };
            _proto._setPreparedValue = function(name, value, merge, silent) {
                var previousValue = this.get(this._options, name, false);
                if (!(0, _comparator.equals)(previousValue, value)) {
                    var path = name.split(/[.[]/);
                    !silent && this._changingCallback(name, previousValue, value);
                    cachedSetters[name] = cachedSetters[name] || (0, _data.compileSetter)(name);
                    cachedSetters[name](this._options, value, {
                        functionsAsIs: true,
                        merge: (0, _type.isDefined)(merge) ? merge : !this._optionsByReference[name],
                        unwrapObservables: path.length > 1 && !!this._optionsByReference[path[0]]
                    });
                    !silent && this._changedCallback(name, value, previousValue)
                }
            };
            _proto._prepareRelevantNames = function(options, name, value, silent) {
                if ((0, _type.isPlainObject)(value)) {
                    for (var valueName in value) {
                        this._prepareRelevantNames(options, "".concat(name, ".").concat(valueName), value[valueName])
                    }
                }
                this._namePreparedCallbacks(options, name, value, silent)
            };
            _proto.get = function() {
                var options = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this._options;
                var name = arguments.length > 1 ? arguments[1] : void 0;
                var unwrapObservables = arguments.length > 2 ? arguments[2] : void 0;
                cachedGetters[name] = cachedGetters[name] || (0, _data.compileGetter)(name);
                return cachedGetters[name](options, {
                    functionsAsIs: true,
                    unwrapObservables: unwrapObservables
                })
            };
            _proto.set = function(options, value, merge, silent) {
                options = (0, _utils.normalizeOptions)(options, value);
                for (var name in options) {
                    this._prepareRelevantNames(options, name, options[name], silent)
                }
                for (var _name in options) {
                    this._setPreparedValue(_name, options[_name], merge, silent)
                }
            };
            _proto.onRelevantNamesPrepared = function(callBack) {
                this._namePreparedCallbacks = callBack
            };
            _proto.onChanging = function(callBack) {
                this._changingCallback = callBack
            };
            _proto.onChanged = function(callBack) {
                this._changedCallback = callBack
            };
            _proto.dispose = function() {
                this._changingCallback = _common.noop;
                this._changedCallback = _common.noop
            };
            return OptionManager
        }();
        exports.OptionManager = OptionManager
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/core/postponed_operations.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.PostponedOperations = void 0;
        var _deferred = __webpack_require__( /*! ./utils/deferred */ 6);
        var _type = __webpack_require__( /*! ./utils/type */ 1);

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }
        var PostponedOperations = function() {
            function PostponedOperations() {
                this._postponedOperations = {}
            }
            var _proto = PostponedOperations.prototype;
            _proto.add = function(key, fn, postponedPromise) {
                if (key in this._postponedOperations) {
                    postponedPromise && this._postponedOperations[key].promises.push(postponedPromise)
                } else {
                    var completePromise = new _deferred.Deferred;
                    this._postponedOperations[key] = {
                        fn: fn,
                        completePromise: completePromise,
                        promises: postponedPromise ? [postponedPromise] : []
                    }
                }
                return this._postponedOperations[key].completePromise.promise()
            };
            _proto.callPostponedOperations = function() {
                for (var key in this._postponedOperations) {
                    var operation = this._postponedOperations[key];
                    if ((0, _type.isDefined)(operation)) {
                        if (operation.promises && operation.promises.length) {
                            _deferred.when.apply(void 0, _toConsumableArray(operation.promises)).done(operation.fn).then(operation.completePromise.resolve)
                        } else {
                            operation.fn().done(operation.completePromise.resolve)
                        }
                    }
                }
                this._postponedOperations = {}
            };
            return PostponedOperations
        }();
        exports.PostponedOperations = PostponedOperations
    },
    /*!***********************************************************!*\
      !*** ./artifacts/transpiled-npm/core/template_manager.js ***!
      \***********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.TemplateManager = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ./renderer */ 2));
        var _type = __webpack_require__( /*! ./utils/type */ 1);
        var _common = __webpack_require__( /*! ./utils/common */ 4);
        var _extend = __webpack_require__( /*! ./utils/extend */ 0);
        var _function_template = __webpack_require__( /*! ./templates/function_template */ 126);
        var _empty_template = __webpack_require__( /*! ./templates/empty_template */ 91);
        var _template_manager = __webpack_require__( /*! ./utils/template_manager */ 250);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }
        var TEXT_NODE = 3;
        var ANONYMOUS_TEMPLATE_NAME = "template";
        var TEMPLATE_OPTIONS_NAME = "dxTemplate";
        var TEMPLATE_WRAPPER_CLASS = "dx-template-wrapper";
        var DX_POLYMORPH_WIDGET_TEMPLATE = new _function_template.FunctionTemplate(function(_ref) {
            var model = _ref.model,
                parent = _ref.parent;
            var widgetName = model.widget;
            if (!widgetName) {
                return (0, _renderer.default)()
            }
            var widgetElement = (0, _renderer.default)("<div>");
            var widgetOptions = model.options || {};
            if (parent) {
                parent._createComponent(widgetElement, widgetName, widgetOptions)
            } else {
                widgetElement[widgetName](widgetOptions)
            }
            return widgetElement
        });
        var TemplateManager = function() {
            function TemplateManager(createElement, anonymousTemplateName) {
                this._tempTemplates = [];
                this._defaultTemplates = {};
                this._anonymousTemplateName = anonymousTemplateName || ANONYMOUS_TEMPLATE_NAME;
                this._createElement = createElement || _template_manager.defaultCreateElement;
                this._createTemplateIfNeeded = this._createTemplateIfNeeded.bind(this)
            }
            TemplateManager.createDefaultOptions = function() {
                return {
                    integrationOptions: {
                        watchMethod: function(fn, callback) {
                            var options = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                            if (!options.skipImmediate) {
                                callback(fn())
                            }
                            return _common.noop
                        },
                        templates: {
                            "dx-polymorph-widget": DX_POLYMORPH_WIDGET_TEMPLATE
                        },
                        useDeferUpdateForTemplates: true
                    }
                }
            };
            var _proto = TemplateManager.prototype;
            _proto.addDefaultTemplates = function(templates) {
                this._defaultTemplates = (0, _extend.extend)({}, this._defaultTemplates, templates)
            };
            _proto.dispose = function() {
                this._tempTemplates.forEach(function(tempTemplate) {
                    tempTemplate.template.dispose && tempTemplate.template.dispose()
                });
                this._tempTemplates = []
            };
            _proto.extractTemplates = function($el) {
                var templates = this._extractTemplates($el);
                var anonymousTemplateMeta = this._extractAnonymousTemplate($el);
                return {
                    templates: templates,
                    anonymousTemplateMeta: anonymousTemplateMeta
                }
            };
            _proto._extractTemplates = function($el) {
                var _this = this;
                var templates = (0, _template_manager.findTemplates)($el, TEMPLATE_OPTIONS_NAME);
                var suitableTemplates = (0, _template_manager.suitableTemplatesByName)(templates);
                templates.forEach(function(_ref2) {
                    var element = _ref2.element,
                        name = _ref2.options.name;
                    if (element === suitableTemplates[name]) {
                        (0, _renderer.default)(element).addClass(TEMPLATE_WRAPPER_CLASS).detach()
                    } else {
                        (0, _renderer.default)(element).remove()
                    }
                });
                return Object.keys(suitableTemplates).map(function(name) {
                    return {
                        name: name,
                        template: _this._createTemplate(suitableTemplates[name])
                    }
                })
            };
            _proto._extractAnonymousTemplate = function($el) {
                var $anonymousTemplate = $el.contents().detach();
                var $notJunkTemplateContent = $anonymousTemplate.filter(function(_, element) {
                    var isTextNode = element.nodeType === TEXT_NODE;
                    var isEmptyText = (0, _renderer.default)(element).text().trim().length < 1;
                    return !(isTextNode && isEmptyText)
                });
                return $notJunkTemplateContent.length > 0 ? {
                    template: this._createTemplate($anonymousTemplate),
                    name: this._anonymousTemplateName
                } : {}
            };
            _proto._createTemplateIfNeeded = function(templateSource) {
                var cachedTemplate = this._tempTemplates.filter(function(tempTemplate) {
                    return tempTemplate.source === (0, _template_manager.templateKey)(templateSource)
                })[0];
                if (cachedTemplate) {
                    return cachedTemplate.template
                }
                var template = this._createTemplate(templateSource);
                this._tempTemplates.push({
                    template: template,
                    source: (0, _template_manager.templateKey)(templateSource)
                });
                return template
            };
            _proto._createTemplate = function(templateSource) {
                return this._createElement((0, _template_manager.validateTemplateSource)(templateSource))
            };
            _proto.getTemplate = function(templateSource, templates, _ref3, context) {
                var _this2 = this;
                var isAsyncTemplate = _ref3.isAsyncTemplate,
                    skipTemplates = _ref3.skipTemplates;
                if (!(0, _type.isFunction)(templateSource)) {
                    return (0, _template_manager.acquireTemplate)(templateSource, this._createTemplateIfNeeded, templates, isAsyncTemplate, skipTemplates, this._defaultTemplates)
                }
                return new _function_template.FunctionTemplate(function(options) {
                    var templateSourceResult = templateSource.apply(context, (0, _template_manager.getNormalizedTemplateArgs)(options));
                    if (!(0, _type.isDefined)(templateSourceResult)) {
                        return new _empty_template.EmptyTemplate
                    }
                    var dispose = false;
                    var template = (0, _template_manager.acquireTemplate)(templateSourceResult, function(templateSource) {
                        if (templateSource.nodeType || (0, _type.isRenderer)(templateSource) && !(0, _renderer.default)(templateSource).is("script")) {
                            return new _function_template.FunctionTemplate(function() {
                                return templateSource
                            })
                        }
                        dispose = true;
                        return _this2._createTemplate(templateSource)
                    }, templates, isAsyncTemplate, skipTemplates, _this2._defaultTemplates);
                    var result = template.render(options);
                    dispose && template.dispose && template.dispose();
                    return result
                })
            };
            _createClass(TemplateManager, [{
                key: "anonymousTemplateName",
                get: function() {
                    return this._anonymousTemplateName
                }
            }]);
            return TemplateManager
        }();
        exports.TemplateManager = TemplateManager
    },
    /*!*************************************************************!*\
      !*** ./artifacts/transpiled-npm/core/templates/template.js ***!
      \*************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.Template = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../renderer */ 2));
        var _template_base = __webpack_require__( /*! ./template_base */ 75);
        var _dom = __webpack_require__( /*! ../utils/dom */ 33);
        var _template_engine_registry = __webpack_require__( /*! ./template_engine_registry */ 175);
        __webpack_require__( /*! ./template_engines */ 521);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }(0, _template_engine_registry.registerTemplateEngine)("default", {
            compile: function(element) {
                return (0, _dom.normalizeTemplateElement)(element)
            },
            render: function(template, model, index) {
                return template.clone()
            }
        });
        (0, _template_engine_registry.setTemplateEngine)("default");
        var Template = function(_TemplateBase) {
            _inheritsLoose(Template, _TemplateBase);

            function Template(element) {
                var _this;
                _this = _TemplateBase.call(this) || this;
                _this._element = element;
                return _this
            }
            var _proto = Template.prototype;
            _proto._renderCore = function(options) {
                var transclude = options.transclude;
                if (!transclude && !this._compiledTemplate) {
                    this._compiledTemplate = (0, _template_engine_registry.getCurrentTemplateEngine)().compile(this._element)
                }
                return (0, _renderer.default)("<div>").append(transclude ? this._element : (0, _template_engine_registry.getCurrentTemplateEngine)().render(this._compiledTemplate, options.model, options.index)).contents()
            };
            _proto.source = function() {
                return (0, _renderer.default)(this._element).clone()
            };
            return Template
        }(_template_base.TemplateBase);
        exports.Template = Template
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/core/templates/template_engines.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _dom = __webpack_require__( /*! ../utils/dom */ 33);
        var _template_engine_registry = __webpack_require__( /*! ./template_engine_registry */ 175);
        (0, _template_engine_registry.registerTemplateEngine)("jquery-tmpl", {
            compile: function(element) {
                return (0, _dom.extractTemplateMarkup)(element)
            },
            render: function(template, data) {
                return jQuery.tmpl(template, data)
            }
        });
        (0, _template_engine_registry.registerTemplateEngine)("jsrender", {
            compile: function(element) {
                return (jQuery ? jQuery : jsrender).templates((0, _dom.extractTemplateMarkup)(element))
            },
            render: function(template, data) {
                return template.render(data)
            }
        });
        (0, _template_engine_registry.registerTemplateEngine)("mustache", {
            compile: function(element) {
                return (0, _dom.extractTemplateMarkup)(element)
            },
            render: function(template, data) {
                return Mustache.render(template, data)
            }
        });
        (0, _template_engine_registry.registerTemplateEngine)("hogan", {
            compile: function(element) {
                return Hogan.compile((0, _dom.extractTemplateMarkup)(element))
            },
            render: function(template, data) {
                return template.render(data)
            }
        });
        (0, _template_engine_registry.registerTemplateEngine)("underscore", {
            compile: function(element) {
                return _.template((0, _dom.extractTemplateMarkup)(element))
            },
            render: function(template, data) {
                return template(data)
            }
        });
        (0, _template_engine_registry.registerTemplateEngine)("handlebars", {
            compile: function(element) {
                return Handlebars.compile((0, _dom.extractTemplateMarkup)(element))
            },
            render: function(template, data) {
                return template(data)
            }
        });
        (0, _template_engine_registry.registerTemplateEngine)("doT", {
            compile: function(element) {
                return doT.template((0, _dom.extractTemplateMarkup)(element))
            },
            render: function(template, data) {
                return template(data)
            }
        })
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/events/core/keyboard_processor.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var COMPOSITION_START_EVENT = "compositionstart";
        var COMPOSITION_END_EVENT = "compositionend";
        var KEYDOWN_EVENT = "keydown";
        var NAMESPACE = "KeyboardProcessor";
        var KeyboardProcessor = _class.default.inherit({
            _keydown: (0, _index.addNamespace)(KEYDOWN_EVENT, NAMESPACE),
            _compositionStart: (0, _index.addNamespace)(COMPOSITION_START_EVENT, NAMESPACE),
            _compositionEnd: (0, _index.addNamespace)(COMPOSITION_END_EVENT, NAMESPACE),
            ctor: function(options) {
                var _this = this;
                options = options || {};
                if (options.element) {
                    this._element = (0, _renderer.default)(options.element)
                }
                if (options.focusTarget) {
                    this._focusTarget = options.focusTarget
                }
                this._handler = options.handler;
                if (this._element) {
                    this._processFunction = function(e) {
                        var isNotFocusTarget = _this._focusTarget && _this._focusTarget !== e.target && (0, _array.inArray)(e.target, _this._focusTarget) < 0;
                        var shouldSkipProcessing = _this._isComposingJustFinished && 229 === e.which || _this._isComposing || isNotFocusTarget;
                        _this._isComposingJustFinished = false;
                        if (!shouldSkipProcessing) {
                            _this.process(e)
                        }
                    };
                    this._toggleProcessingWithContext = this.toggleProcessing.bind(this);
                    _events_engine.default.on(this._element, this._keydown, this._processFunction);
                    _events_engine.default.on(this._element, this._compositionStart, this._toggleProcessingWithContext);
                    _events_engine.default.on(this._element, this._compositionEnd, this._toggleProcessingWithContext)
                }
            },
            dispose: function() {
                if (this._element) {
                    _events_engine.default.off(this._element, this._keydown, this._processFunction);
                    _events_engine.default.off(this._element, this._compositionStart, this._toggleProcessingWithContext);
                    _events_engine.default.off(this._element, this._compositionEnd, this._toggleProcessingWithContext)
                }
                this._element = void 0;
                this._handler = void 0
            },
            process: function(e) {
                this._handler({
                    keyName: (0, _index.normalizeKeyName)(e),
                    key: e.key,
                    code: e.code,
                    ctrl: e.ctrlKey,
                    location: e.location,
                    metaKey: e.metaKey,
                    shift: e.shiftKey,
                    alt: e.altKey,
                    which: e.which,
                    originalEvent: e
                })
            },
            toggleProcessing: function(_ref) {
                var type = _ref.type;
                this._isComposing = type === COMPOSITION_START_EVENT;
                this._isComposingJustFinished = !this._isComposing
            }
        });
        var _default = KeyboardProcessor;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************!*\
      !*** ./artifacts/transpiled-npm/events/utils/add_namespace.js ***!
      \****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../../core/errors */ 25));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var addNamespace = function addNamespace(eventNames, namespace) {
            if (!namespace) {
                throw _errors.default.Error("E0017")
            }
            if (Array.isArray(eventNames)) {
                return eventNames.map(function(eventName) {
                    return addNamespace(eventName, namespace)
                }).join(" ")
            }
            if (eventNames.indexOf(" ") !== -1) {
                return addNamespace(eventNames.split(/\s+/g), namespace)
            }
            return "".concat(eventNames, ".").concat(namespace)
        };
        var _default = addNamespace;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/mobile/init_mobile_viewport/init_mobile_viewport.js ***!
      \**************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.initMobileViewport = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _resize_callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/resize_callbacks */ 125));
        var _support = __webpack_require__( /*! ../../core/utils/support */ 45);
        var _style = __webpack_require__( /*! ../../core/utils/style */ 99);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var initMobileViewport = function(options) {
            options = (0, _extend.extend)({}, options);
            var realDevice = _devices.default.real();
            var allowZoom = options.allowZoom;
            var allowPan = options.allowPan;
            var allowSelection = "allowSelection" in options ? options.allowSelection : "generic" === realDevice.platform;
            var metaSelector = "meta[name=viewport]";
            if (!(0, _renderer.default)(metaSelector).length) {
                (0, _renderer.default)("<meta>").attr("name", "viewport").appendTo("head")
            }
            var metaVerbs = ["width=device-width"];
            var msTouchVerbs = [];
            if (allowZoom) {
                msTouchVerbs.push("pinch-zoom")
            } else {
                metaVerbs.push("initial-scale=1.0", "maximum-scale=1.0, user-scalable=no")
            }
            if (allowPan) {
                msTouchVerbs.push("pan-x", "pan-y")
            }
            if (!allowPan && !allowZoom) {
                (0, _renderer.default)("html, body").css({
                    msContentZooming: "none",
                    msUserSelect: "none",
                    overflow: "hidden"
                })
            } else {
                (0, _renderer.default)("html").css("msOverflowStyle", "-ms-autohiding-scrollbar")
            }
            if (!allowSelection && (0, _support.supportProp)("userSelect")) {
                (0, _renderer.default)(".dx-viewport").css((0, _style.styleProp)("userSelect"), "none")
            }(0, _renderer.default)(metaSelector).attr("content", metaVerbs.join());
            (0, _renderer.default)("html").css("msTouchAction", msTouchVerbs.join(" ") || "none");
            realDevice = _devices.default.real();
            if (_support.touch) {
                _events_engine.default.off(_dom_adapter.default.getDocument(), ".dxInitMobileViewport");
                _events_engine.default.on(_dom_adapter.default.getDocument(), "dxpointermove.dxInitMobileViewport", function(e) {
                    var count = e.pointers.length;
                    var isTouchEvent = "touch" === e.pointerType;
                    var zoomDisabled = !allowZoom && count > 1;
                    var panDisabled = !allowPan && 1 === count && !e.isScrollingEvent;
                    if (isTouchEvent && (zoomDisabled || panDisabled)) {
                        e.preventDefault()
                    }
                })
            }
            if (realDevice.ios) {
                var isPhoneGap = "file:" === _dom_adapter.default.getLocation().protocol;
                if (!isPhoneGap) {
                    _resize_callbacks.default.add(function() {
                        var windowWidth = (0, _renderer.default)(window).width();
                        (0, _renderer.default)("body").width(windowWidth)
                    })
                }
            }
            if (realDevice.android) {
                _resize_callbacks.default.add(function() {
                    setTimeout(function() {
                        var activeElement = _dom_adapter.default.getActiveElement();
                        activeElement.scrollIntoViewIfNeeded ? activeElement.scrollIntoViewIfNeeded() : activeElement.scrollIntoView(false)
                    })
                })
            }
        };
        exports.initMobileViewport = initMobileViewport
    },
    /*!*****************************************************!*\
      !*** ./artifacts/transpiled-npm/time_zone_utils.js ***!
      \*****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getTimeZones = void 0;
        var _utils = _interopRequireDefault(__webpack_require__( /*! ./ui/scheduler/utils.timeZone */ 86));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var getTimeZones = _utils.default.getTimeZones;
        exports.getTimeZones = getTimeZones
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/data/remote_query.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _query_adapters = _interopRequireDefault(__webpack_require__( /*! ./query_adapters */ 199));
        var _errors = _interopRequireDefault(__webpack_require__( /*! ./errors */ 38));
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);
        var _array_query = _interopRequireDefault(__webpack_require__( /*! ./array_query */ 168));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var remoteQueryImpl = function remoteQueryImpl(url, queryOptions, tasks) {
            tasks = tasks || [];
            queryOptions = queryOptions || {};
            var createTask = function(name, args) {
                return {
                    name: name,
                    args: args
                }
            };
            var exec = function(executorTask) {
                var d = new _deferred.Deferred;
                var _adapterFactory;
                var _adapter;
                var _taskQueue;
                var _currentTask;
                var _mergedSortArgs;
                var rejectWithNotify = function(error) {
                    var handler = queryOptions.errorHandler;
                    if (handler) {
                        handler(error)
                    }
                    _errors.default._errorHandler(error);
                    d.reject(error)
                };

                function mergeSortTask(task) {
                    switch (task.name) {
                        case "sortBy":
                            _mergedSortArgs = [task.args];
                            return true;
                        case "thenBy":
                            if (!_mergedSortArgs) {
                                throw _errors.default.errors.Error("E4004")
                            }
                            _mergedSortArgs.push(task.args);
                            return true
                    }
                    return false
                }

                function unmergeSortTasks() {
                    var head = _taskQueue[0];
                    var unmergedTasks = [];
                    if (head && "multiSort" === head.name) {
                        _taskQueue.shift();
                        (0, _iterator.each)(head.args[0], function() {
                            unmergedTasks.push(createTask(unmergedTasks.length ? "thenBy" : "sortBy", this))
                        })
                    }
                    _taskQueue = unmergedTasks.concat(_taskQueue)
                }
                try {
                    _adapterFactory = queryOptions.adapter;
                    if (!(0, _type.isFunction)(_adapterFactory)) {
                        _adapterFactory = _query_adapters.default[_adapterFactory]
                    }
                    _adapter = _adapterFactory(queryOptions);
                    _taskQueue = [].concat(tasks).concat(executorTask);
                    var optimize = _adapter.optimize;
                    if (optimize) {
                        optimize(_taskQueue)
                    }
                    while (_taskQueue.length) {
                        _currentTask = _taskQueue[0];
                        if (!mergeSortTask(_currentTask)) {
                            if (_mergedSortArgs) {
                                _taskQueue.unshift(createTask("multiSort", [_mergedSortArgs]));
                                _mergedSortArgs = null;
                                continue
                            }
                            if ("enumerate" !== String(_currentTask.name)) {
                                if (!_adapter[_currentTask.name] || false === _adapter[_currentTask.name].apply(_adapter, _currentTask.args)) {
                                    break
                                }
                            }
                        }
                        _taskQueue.shift()
                    }
                    unmergeSortTasks();
                    _adapter.exec(url).done(function(result, extra) {
                        if (!_taskQueue.length) {
                            d.resolve(result, extra)
                        } else {
                            var clientChain = (0, _array_query.default)(result, {
                                errorHandler: queryOptions.errorHandler
                            });
                            (0, _iterator.each)(_taskQueue, function() {
                                clientChain = clientChain[this.name].apply(clientChain, this.args)
                            });
                            clientChain.done(d.resolve).fail(d.reject)
                        }
                    }).fail(rejectWithNotify)
                } catch (x) {
                    rejectWithNotify(x)
                }
                return d.promise()
            };
            var query = {};
            (0, _iterator.each)(["sortBy", "thenBy", "filter", "slice", "select", "groupBy"], function() {
                var name = String(this);
                query[name] = function() {
                    return remoteQueryImpl(url, queryOptions, tasks.concat(createTask(name, arguments)))
                }
            });
            (0, _iterator.each)(["count", "min", "max", "sum", "avg", "aggregate", "enumerate"], function() {
                var name = String(this);
                query[name] = function() {
                    return exec.call(this, createTask(name, arguments))
                }
            });
            return query
        };
        var _default = remoteQueryImpl;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/timezones/timezones_data.js ***!
      \***************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _default = {
            zones: [{
                id: "Africa/Abidjan",
                untils: "-u9rgl4|Infinity",
                offsets: "16.1333|0",
                offsetIndices: "01"
            }, {
                id: "Africa/Accra",
                untils: "-r507yk|1e3pak|681qo|cjvlc|681qo|cjvlc|681qo|cjvlc|681qo|clq9c|681qo|cjvlc|681qo|cjvlc|681qo|cjvlc|681qo|clq9c|681qo|cjvlc|681qo|cjvlc|681qo|cjvlc|681qo|clq9c|681qo|cjvlc|681qo|cjvlc|681qo|cjvlc|681qo|clq9c|681qo|cjvlc|681qo|cjvlc|681qo|cjvlc|681qo|clq9c|681qo|cjvlc|681qo|cjvlc|681qo|Infinity",
                offsets: "0.8667|0|-20",
                offsetIndices: "012121212121212121212121212121212121212121212121"
            }, {
                id: "Africa/Addis_Ababa",
                untils: "-lnsetg|s8mhg|57v020|afrrb0|Infinity",
                offsets: "-147.2667|-180|-150|-165",
                offsetIndices: "01231"
            }, {
                id: "Africa/Algiers",
                untils: "-uozn3l|2qx1nl|5luo0|8y800|a4tc0|7vc00|auqo0|7idc0|b7pc0|6sg00|cyo00|7ayo0|53c00|9idxc0|3i040|51mw0|253uk0|9o2k0|92040|8l3s0|jutc0|4uy840|3rdzw0|46xc00|7x6o0|2xco40|8n180|7x9g0|9d440|kiqg0|9d440|9q2s0|9cyk0|Infinity",
                offsets: "-9.35|0|-60|-120",
                offsetIndices: "0121212121212121232321212122321212"
            }, {
                id: "Africa/Asmara",
                untils: "-lnsetg|s8mhg|57v020|afrrb0|Infinity",
                offsets: "-147.2667|-180|-150|-165",
                offsetIndices: "01231"
            }, {
                id: "Africa/Asmera",
                untils: "-lnsetg|s8mhg|57v020|afrrb0|Infinity",
                offsets: "-147.2667|-180|-150|-165",
                offsetIndices: "01231"
            }, {
                id: "Africa/Bamako",
                untils: "-u9rgl4|Infinity",
                offsets: "16.1333|0",
                offsetIndices: "01"
            }, {
                id: "Africa/Bangui",
                untils: "-q9qbao|Infinity",
                offsets: "-13.6|-60",
                offsetIndices: "01"
            }, {
                id: "Africa/Banjul",
                untils: "-u9rgl4|Infinity",
                offsets: "16.1333|0",
                offsetIndices: "01"
            }, {
                id: "Africa/Bissau",
                untils: "-u9rek0|wvoyo0|Infinity",
                offsets: "62.3333|60|0",
                offsetIndices: "012"
            }, {
                id: "Africa/Blantyre",
                untils: "-yvtfd8|Infinity",
                offsets: "-130.3333|-120",
                offsetIndices: "01"
            }, {
                id: "Africa/Brazzaville",
                untils: "-q9qbao|Infinity",
                offsets: "-13.6|-60",
                offsetIndices: "01"
            }, {
                id: "Africa/Bujumbura",
                untils: "-yvtfd8|Infinity",
                offsets: "-130.3333|-120",
                offsetIndices: "01"
            }, {
                id: "Africa/Cairo",
                untils: "-fdls80|40d80|a31g0|7x3w0|a4w40|aqyk0|80ys0|b07w0|7tk40|b07w0|8jhg0|a8fw0|60go40|7el80|awo40|7v980|awqw0|7tk40|b07w0|7tk40|ayd80|7tk40|ayd80|7tk40|ayd80|7tk40|b07w0|7tk40|ayd80|7tk40|ayd80|7ves0|awik0|7ves0|ayd80|7ves0|awik0|7ves0|awik0|7ves0|awik0|7ves0|ayd80|7ves0|awik0|7ves0|awik0|7ves0|awik0|7ves0|ayd80|7ves0|awik0|7ves0|awik0|7ves0|awik0|7ves0|ayd80|7ves0|awik0|7ves0|f9x80|3i040|eluk0|462s0|ayd80|7ves0|awik0|7ves0|awik0|7ves0|awik0|7ves0|ayd80|7ves0|b5rw0|7m5g0|awik0|7ves0|awik0|7ves0|ayd80|7ves0|awik0|7ves0|awik0|7ves0|aqvs0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7x3w0|asys0|7x3w0|asys0|7k580|b5xg0|6u7w0|bvus0|6h980|c8tg0|64ak0|cyqs0|5anw0|1jms0|12t80|1w22s0|25p80|1sw40|2vmk0|Infinity",
                offsets: "-120|-180",
                offsetIndices: "0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Africa/Casablanca",
                untils: "-tblt9g|di7nxg|3huk0|51k40|2znuk0|2dp9g0|776k0|8nt2s0|657w0|3ifxg0|3jp80|va040|4qak0|e1ms0|7pp80|cnms0|3afw0|2xi840|xqqk0|bp56s0|4qak0|e1ms0|45x80|d2g40|51ek0|c8tg0|64ak0|e1sc0|47uo0|1leo0|23xc0|asw00|3lmo0|1qyo0|40g00|7x6o0|4mo00|1stc0|4deo0|7x6o0|3ylc0|1stc0|51hc0|7x6o0|3lmo0|1stc0|5reo0|7k800|2vpc0|25s00|64dc0|7k800|2iqo0|1stc0|gkao0|1stc0|g7c00|25s00|g7c00|1stc0|g7c00|25s00|g7c00|1stc0|gkao0|1stc0|g7c00|25s00|g7c00|1stc0|gkao0|1stc0|g7c00|25s00|g7c00|1stc0|g7c00|25s00|g7c00|1stc0|gkao0|1stc0|g7c00|25s00|g7c00|1stc0|g7c00|25s00|g7c00|25s00|g7c00|1stc0|g7c00|25s00|Infinity",
                offsets: "30.3333|0|-60",
                offsetIndices: "01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212"
            }, {
                id: "Africa/Ceuta",
                untils: "-qyiys0|7x3w0|2vt440|8sqs0|ssyk0|8n6s0|9px80|905g0|a2yo0|902o0|k69dc0|657w0|3ifxg0|3jp80|va040|4qak0|e1ms0|7pp80|cnms0|3afw0|2xi840|129us0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "0|-60|-120",
                offsetIndices: "010101010101010101010121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Africa/Conakry",
                untils: "-u9rgl4|Infinity",
                offsets: "16.1333|0",
                offsetIndices: "01"
            }, {
                id: "Africa/Dakar",
                untils: "-u9rgl4|Infinity",
                offsets: "16.1333|0",
                offsetIndices: "01"
            }, {
                id: "Africa/Dar_es_Salaam",
                untils: "-lnsetg|s8mhg|57v020|afrrb0|Infinity",
                offsets: "-147.2667|-180|-150|-165",
                offsetIndices: "01231"
            }, {
                id: "Africa/Djibouti",
                untils: "-lnsetg|s8mhg|57v020|afrrb0|Infinity",
                offsets: "-147.2667|-180|-150|-165",
                offsetIndices: "01231"
            }, {
                id: "Africa/Douala",
                untils: "-q9qbao|Infinity",
                offsets: "-13.6|-60",
                offsetIndices: "01"
            }, {
                id: "Africa/El_Aaiun",
                untils: "-isdxk0|m2g0c0|vek0|4qak0|e1ms0|7pp80|cnms0|3afw0|fke5g0|4qak0|e1ms0|45x80|d2g40|51ek0|c8tg0|64ak0|e1sc0|47uo0|1leo0|23xc0|asw00|3lmo0|1qyo0|40g00|7x6o0|4mo00|1stc0|4deo0|7x6o0|3ylc0|1stc0|51hc0|7x6o0|3lmo0|1stc0|5reo0|7k800|2vpc0|25s00|64dc0|7k800|2iqo0|1stc0|gkao0|1stc0|g7c00|25s00|g7c00|1stc0|g7c00|25s00|g7c00|1stc0|gkao0|1stc0|g7c00|25s00|g7c00|1stc0|gkao0|1stc0|g7c00|25s00|g7c00|1stc0|g7c00|25s00|g7c00|1stc0|gkao0|1stc0|g7c00|25s00|g7c00|1stc0|g7c00|25s00|g7c00|25s00|g7c00|1stc0|g7c00|25s00|Infinity",
                offsets: "52.8|60|0|-60",
                offsetIndices: "012323232323232323232323232323232323232323232323232323232323232323232323232323232323"
            }, {
                id: "Africa/Freetown",
                untils: "-u9rgl4|Infinity",
                offsets: "16.1333|0",
                offsetIndices: "01"
            }, {
                id: "Africa/Gaborone",
                untils: "-yvtfd8|Infinity",
                offsets: "-130.3333|-120",
                offsetIndices: "01"
            }, {
                id: "Africa/Harare",
                untils: "-yvtfd8|Infinity",
                offsets: "-130.3333|-120",
                offsetIndices: "01"
            }, {
                id: "Africa/Johannesburg",
                untils: "-yvtdi0|kn7o60|9cyk0|9d440|9cyk0|Infinity",
                offsets: "-90|-120|-180",
                offsetIndices: "012121"
            }, {
                id: "Africa/Juba",
                untils: "-kcrsis|kixuys|8l6k0|a4w40|8n180|a6qs0|8n180|a31g0|8ovw0|a16s0|8qqk0|9zc40|8sl80|9xhg0|8wak0|9ts40|8y580|a4w40|8n180|a31g0|8ovw0|a16s0|8sl80|9xhg0|8ufw0|9vms0|8wak0|9ts40|8y580|a4w40|8ovw0|a16s0|8qqk0|7frw40|Infinity",
                offsets: "-126.4667|-120|-180",
                offsetIndices: "01212121212121212121212121212121212"
            }, {
                id: "Africa/Kampala",
                untils: "-lnsetg|s8mhg|57v020|afrrb0|Infinity",
                offsets: "-147.2667|-180|-150|-165",
                offsetIndices: "01231"
            }, {
                id: "Africa/Khartoum",
                untils: "-kcrsow|kixv4w|8l6k0|a4w40|8n180|a6qs0|8n180|a31g0|8ovw0|a16s0|8qqk0|9zc40|8sl80|9xhg0|8wak0|9ts40|8y580|a4w40|8n180|a31g0|8ovw0|a16s0|8sl80|9xhg0|8ufw0|9vms0|8wak0|9ts40|8y580|a4w40|8ovw0|a16s0|8qqk0|7frw40|9ac180|Infinity",
                offsets: "-130.1333|-120|-180",
                offsetIndices: "012121212121212121212121212121212121"
            }, {
                id: "Africa/Kigali",
                untils: "-yvtfd8|Infinity",
                offsets: "-130.3333|-120",
                offsetIndices: "01"
            }, {
                id: "Africa/Kinshasa",
                untils: "-q9qbao|Infinity",
                offsets: "-13.6|-60",
                offsetIndices: "01"
            }, {
                id: "Africa/Lagos",
                untils: "-q9qbao|Infinity",
                offsets: "-13.6|-60",
                offsetIndices: "01"
            }, {
                id: "Africa/Libreville",
                untils: "-q9qbao|Infinity",
                offsets: "-13.6|-60",
                offsetIndices: "01"
            }, {
                id: "Africa/Lome",
                untils: "-u9rgl4|Infinity",
                offsets: "16.1333|0",
                offsetIndices: "01"
            }, {
                id: "Africa/Luanda",
                untils: "-q9qbao|Infinity",
                offsets: "-13.6|-60",
                offsetIndices: "01"
            }, {
                id: "Africa/Lubumbashi",
                untils: "-yvtfd8|Infinity",
                offsets: "-130.3333|-120",
                offsetIndices: "01"
            }, {
                id: "Africa/Lusaka",
                untils: "-yvtfd8|Infinity",
                offsets: "-130.3333|-120",
                offsetIndices: "01"
            }, {
                id: "Africa/Malabo",
                untils: "-q9qbao|Infinity",
                offsets: "-13.6|-60",
                offsetIndices: "01"
            }, {
                id: "Africa/Maputo",
                untils: "-yvtfd8|Infinity",
                offsets: "-130.3333|-120",
                offsetIndices: "01"
            }, {
                id: "Africa/Maseru",
                untils: "-yvtdi0|kn7o60|9cyk0|9d440|9cyk0|Infinity",
                offsets: "-90|-120|-180",
                offsetIndices: "012121"
            }, {
                id: "Africa/Mbabane",
                untils: "-yvtdi0|kn7o60|9cyk0|9d440|9cyk0|Infinity",
                offsets: "-90|-120|-180",
                offsetIndices: "012121"
            }, {
                id: "Africa/Mogadishu",
                untils: "-lnsetg|s8mhg|57v020|afrrb0|Infinity",
                offsets: "-147.2667|-180|-150|-165",
                offsetIndices: "01231"
            }, {
                id: "Africa/Monrovia",
                untils: "-qj6zc4|rl202a|Infinity",
                offsets: "43.1333|44.5|0",
                offsetIndices: "012"
            }, {
                id: "Africa/Nairobi",
                untils: "-lnsetg|s8mhg|57v020|afrrb0|Infinity",
                offsets: "-147.2667|-180|-150|-165",
                offsetIndices: "01231"
            }, {
                id: "Africa/Ndjamena",
                untils: "-u9rk4c|zdk5cc|7iak0|Infinity",
                offsets: "-60.2|-60|-120",
                offsetIndices: "0121"
            }, {
                id: "Africa/Niamey",
                untils: "-q9qbao|Infinity",
                offsets: "-13.6|-60",
                offsetIndices: "01"
            }, {
                id: "Africa/Nouakchott",
                untils: "-u9rgl4|Infinity",
                offsets: "16.1333|0",
                offsetIndices: "01"
            }, {
                id: "Africa/Ouagadougou",
                untils: "-u9rgl4|Infinity",
                offsets: "16.1333|0",
                offsetIndices: "01"
            }, {
                id: "Africa/Porto-Novo",
                untils: "-q9qbao|Infinity",
                offsets: "-13.6|-60",
                offsetIndices: "01"
            }, {
                id: "Africa/Sao_Tome",
                untils: "-u9rhc0|1jbm840|irxc0|Infinity",
                offsets: "36.75|0|-60",
                offsetIndices: "0121"
            }, {
                id: "Africa/Timbuktu",
                untils: "-u9rgl4|Infinity",
                offsets: "16.1333|0",
                offsetIndices: "01"
            }, {
                id: "Africa/Tripoli",
                untils: "-q3gfrw|gl6ajw|422c0|xado0|4bbo0|wrpg0|4s580|1kdpg0|c05bw0|4mqs0|9et80|9d440|9et80|9eys0|9et80|9mdg0|95jw0|9io40|9cyk0|99es0|9et80|9eys0|9et80|9d440|9et80|b2840|3cf3w0|9kis0|9et80|7vqyw0|75eo0|asw00|Infinity",
                offsets: "-52.7333|-60|-120",
                offsetIndices: "012121212121212121212121212122122"
            }, {
                id: "Africa/Tunis",
                untils: "-uozn3l|enxevl|b5uo0|53c00|u8w00|7x9g0|c8w80|7k800|z3w0|ew40|8bx80|9d440|9nx00|925o0|8l100|gi3440|7k800|b9k00|7vc00|51mw00|5ytc0|9d1c0|9d1c0|b9k00|7thc0|7m0tc0|7tk40|93us0|b5uo0|7k800|b5uo0|7x6o0|asw00|Infinity",
                offsets: "-9.35|-60|-120",
                offsetIndices: "0121212121212121212121212121212121"
            }, {
                id: "Africa/Windhoek",
                untils: "-yvtdi0|kn7o60|9cyk0|oj2nw0|235k00|8lho0|ast80|7x9g0|b5rw0|7kas0|b5rw0|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|b5rw0|7kas0|b5rw0|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|b5rw0|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|b5rw0|7kas0|b5rw0|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|Infinity",
                offsets: "-90|-120|-180|-60",
                offsetIndices: "01211313131313131313131313131313131313131313131313131"
            }, {
                id: "America/Adak",
                untils: "-ek1nw0|1tyug0|2e6s0|b7yik0|12y080|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|1l940|7rs80|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "660|600|540",
                offsetIndices: "011001010101010101010101010101010111212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Anchorage",
                untils: "-ek1qo0|1tyx80|2e400|b7yik0|12y080|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|1l940|7rs80|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "600|540|480",
                offsetIndices: "011001010101010101010101010101010111212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Anguilla",
                untils: "-u6m79w|Infinity",
                offsets: "246.0667|240",
                offsetIndices: "01"
            }, {
                id: "America/Antigua",
                untils: "-u6m79w|Infinity",
                offsets: "246.0667|240",
                offsetIndices: "01"
            }, {
                id: "America/Araguaina",
                untils: "-t85j2o|99k8mo|9a9c0|9io40|99980|8p65g0|6zuo0|bs2o0|67zw0|cjxg0|69uk0|cjxg0|4ml80|5mf440|49mk0|haas0|316k0|cls40|4ml80|cls40|66580|cls40|67zw0|981s40|6u7w0|biw40|5rbw0|d0lg0|5ed80|cyqs0|5ed80|dbpg0|64ak0|2yl440|64ak0|c8tg0|6u7w0|bxpg0|7iak0|biw40|6u7w0|biw40|7k580|biw40|6u7w0|c8tg0|6h980|dbpg0|5ed80|51udg0|64ak0|Infinity",
                offsets: "192.8|180|120",
                offsetIndices: "0121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Argentina/Buenos_Aires",
                untils: "-px7ys0|5iv8k0|67zw0|a4w40|73h80|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|6a040|hy7w0|6a040|xovw0|3uys0|18nbw0|b0dg0|8ve2k0|3uys0|3yik0|bqas0|71mk0|bqas0|71mk0|bqas0|8ovw0|9d440|9px80|9d440|9cyk0|9d440|28t6k0|51ek0|7m2qs0|4tzw0|biw40|776k0|bvus0|6u7w0|bvus0|6u7w0|bvus0|776k0|7qcg40|3yik0|b5xg0|7k580|Infinity",
                offsets: "256.8|240|180|120",
                offsetIndices: "01212121212121212121212121212121212121212123232323232323232"
            }, {
                id: "America/Argentina/Catamarca",
                untils: "-px7ys0|5iv8k0|67zw0|a4w40|73h80|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|6a040|hy7w0|6a040|xovw0|3uys0|18nbw0|b0dg0|8ve2k0|3uys0|3yik0|bqas0|71mk0|bqas0|71mk0|bqas0|8ovw0|9d440|9px80|9d440|9cyk0|9d440|28t6k0|51ek0|7m2qs0|4tzw0|biw40|776k0|bvus0|6u7w0|bvxk0|6u540|bvus0|776k0|5v42s0|z9g0|1u93w0|3yik0|Infinity",
                offsets: "256.8|240|180|120",
                offsetIndices: "01212121212121212121212121212121212121212123232323132321232"
            }, {
                id: "America/Argentina/ComodRivadavia",
                untils: "-px7ys0|5iv8k0|67zw0|a4w40|73h80|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|6a040|hy7w0|6a040|xovw0|3uys0|18nbw0|b0dg0|8ve2k0|3uys0|3yik0|bqas0|71mk0|bqas0|71mk0|bqas0|8ovw0|9d440|9px80|9d440|9cyk0|9d440|28t6k0|51ek0|7m2qs0|4tzw0|biw40|776k0|bvus0|6u7w0|bvxk0|6u540|bvus0|776k0|5v42s0|z9g0|1u93w0|3yik0|Infinity",
                offsets: "256.8|240|180|120",
                offsetIndices: "01212121212121212121212121212121212121212123232323132321232"
            }, {
                id: "America/Argentina/Cordoba",
                untils: "-px7ys0|5iv8k0|67zw0|a4w40|73h80|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|6a040|hy7w0|6a040|xovw0|3uys0|18nbw0|b0dg0|8ve2k0|3uys0|3yik0|bqas0|71mk0|bqas0|71mk0|bqas0|8ovw0|9d440|9px80|9d440|9cyk0|9d440|28t6k0|51ek0|7m2qs0|4tzw0|biw40|776k0|bvus0|6u7w0|bvxk0|6u540|bvus0|776k0|7qcg40|3yik0|b5xg0|7k580|Infinity",
                offsets: "256.8|240|180|120",
                offsetIndices: "01212121212121212121212121212121212121212123232323132323232"
            }, {
                id: "America/Argentina/Jujuy",
                untils: "-px7ys0|5iv8k0|67zw0|a4w40|73h80|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|6a040|hy7w0|6a040|xovw0|3uys0|18nbw0|b0dg0|8ve2k0|3uys0|3yik0|bqas0|71mk0|bqas0|71mk0|bqas0|8ovw0|9d440|9px80|9d440|9cyk0|9d440|28t6k0|51ek0|7m2qs0|4tzw0|biw40|776k0|c8w80|776k0|ag040|7k2g0|bvus0|776k0|7qcg40|3yik0|Infinity",
                offsets: "256.8|240|180|120",
                offsetIndices: "012121212121212121212121212121212121212121232323121323232"
            }, {
                id: "America/Argentina/La_Rioja",
                untils: "-px7ys0|5iv8k0|67zw0|a4w40|73h80|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|6a040|hy7w0|6a040|xovw0|3uys0|18nbw0|b0dg0|8ve2k0|3uys0|3yik0|bqas0|71mk0|bqas0|71mk0|bqas0|8ovw0|9d440|9px80|9d440|9cyk0|9d440|28t6k0|51ek0|7m2qs0|4tzw0|biw40|776k0|bvus0|6qik0|3g880|8jbw0|6u7w0|bvus0|776k0|5v42s0|z9g0|1u93w0|3yik0|Infinity",
                offsets: "256.8|240|180|120",
                offsetIndices: "012121212121212121212121212121212121212121232323231232321232"
            }, {
                id: "America/Argentina/Mendoza",
                untils: "-px7ys0|5iv8k0|67zw0|a4w40|73h80|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|6a040|hy7w0|6a040|xovw0|3uys0|18nbw0|b0dg0|8ve2k0|3uys0|3yik0|bqas0|71mk0|bqas0|71mk0|bqas0|8ovw0|9d440|9px80|9d440|9cyk0|9d440|28t6k0|51ek0|7m2qs0|4tzw0|biw40|776k0|bktk0|71mk0|bqas0|73h80|bvus0|773s0|5unes0|6hes0|1p7mk0|3yik0|Infinity",
                offsets: "256.8|240|180|120",
                offsetIndices: "01212121212121212121212121212121212121212123232312121321232"
            }, {
                id: "America/Argentina/Rio_Gallegos",
                untils: "-px7ys0|5iv8k0|67zw0|a4w40|73h80|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|6a040|hy7w0|6a040|xovw0|3uys0|18nbw0|b0dg0|8ve2k0|3uys0|3yik0|bqas0|71mk0|bqas0|71mk0|bqas0|8ovw0|9d440|9px80|9d440|9cyk0|9d440|28t6k0|51ek0|7m2qs0|4tzw0|biw40|776k0|bvus0|6u7w0|bvus0|6u7w0|bvus0|776k0|5v42s0|z9g0|1u93w0|3yik0|Infinity",
                offsets: "256.8|240|180|120",
                offsetIndices: "01212121212121212121212121212121212121212123232323232321232"
            }, {
                id: "America/Argentina/Salta",
                untils: "-px7ys0|5iv8k0|67zw0|a4w40|73h80|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|6a040|hy7w0|6a040|xovw0|3uys0|18nbw0|b0dg0|8ve2k0|3uys0|3yik0|bqas0|71mk0|bqas0|71mk0|bqas0|8ovw0|9d440|9px80|9d440|9cyk0|9d440|28t6k0|51ek0|7m2qs0|4tzw0|biw40|776k0|bvus0|6u7w0|bvxk0|6u540|bvus0|776k0|7qcg40|3yik0|Infinity",
                offsets: "256.8|240|180|120",
                offsetIndices: "012121212121212121212121212121212121212121232323231323232"
            }, {
                id: "America/Argentina/San_Juan",
                untils: "-px7ys0|5iv8k0|67zw0|a4w40|73h80|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|6a040|hy7w0|6a040|xovw0|3uys0|18nbw0|b0dg0|8ve2k0|3uys0|3yik0|bqas0|71mk0|bqas0|71mk0|bqas0|8ovw0|9d440|9px80|9d440|9cyk0|9d440|28t6k0|51ek0|7m2qs0|4tzw0|biw40|776k0|bvus0|6qik0|3g880|8jbw0|6u7w0|bvus0|776k0|5v2840|2txg0|1sgak0|3yik0|Infinity",
                offsets: "256.8|240|180|120",
                offsetIndices: "012121212121212121212121212121212121212121232323231232321232"
            }, {
                id: "America/Argentina/San_Luis",
                untils: "-px7ys0|5iv8k0|67zw0|a4w40|73h80|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|6a040|hy7w0|6a040|xovw0|3uys0|18nbw0|b0dg0|8ve2k0|3uys0|3yik0|bqas0|71mk0|bqas0|71mk0|bqas0|8ovw0|9d440|9px80|9d440|9cyk0|9d440|28t6k0|51ek0|7m2qs0|4tzw0|biw40|7pp80|b2aw0|71mk0|4qg40|6s8ik0|2txg0|1sgak0|14nw0|2gys0|b5xg0|7k580|b5xg0|Infinity",
                offsets: "256.8|240|180|120",
                offsetIndices: "012121212121212121212121212121212121212121232323121212321212"
            }, {
                id: "America/Argentina/Tucuman",
                untils: "-px7ys0|5iv8k0|67zw0|a4w40|73h80|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|6a040|hy7w0|6a040|xovw0|3uys0|18nbw0|b0dg0|8ve2k0|3uys0|3yik0|bqas0|71mk0|bqas0|71mk0|bqas0|8ovw0|9d440|9px80|9d440|9cyk0|9d440|28t6k0|51ek0|7m2qs0|4tzw0|biw40|776k0|bvus0|6u7w0|bvxk0|6u540|bvus0|776k0|5v42s0|mas0|1um2k0|3yik0|b5xg0|7k580|Infinity",
                offsets: "256.8|240|180|120",
                offsetIndices: "0121212121212121212121212121212121212121212323232313232123232"
            }, {
                id: "America/Argentina/Ushuaia",
                untils: "-px7ys0|5iv8k0|67zw0|a4w40|73h80|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|6a040|hy7w0|6a040|xovw0|3uys0|18nbw0|b0dg0|8ve2k0|3uys0|3yik0|bqas0|71mk0|bqas0|71mk0|bqas0|8ovw0|9d440|9px80|9d440|9cyk0|9d440|28t6k0|51ek0|7m2qs0|4tzw0|biw40|776k0|bvus0|6u7w0|bvus0|6u7w0|bvus0|776k0|5v0dg0|12ys0|1u93w0|3yik0|Infinity",
                offsets: "256.8|240|180|120",
                offsetIndices: "01212121212121212121212121212121212121212123232323232321232"
            }, {
                id: "America/Aruba",
                untils: "-u7lckd|rlo7qd|Infinity",
                offsets: "275.7833|270|240",
                offsetIndices: "012"
            }, {
                id: "America/Asuncion",
                untils: "-jy93zk|ldwofk|s4vw0|s6w40|7tek0|b0dg0|7rjw0|b0dg0|7rjw0|b0dg0|9cyk0|9eys0|9et80|9eys0|9cyk0|9eys0|9cyk0|9eys0|9cyk0|9eys0|9et80|9eys0|9cyk0|9eys0|9cyk0|9eys0|9cyk0|9eys0|9et80|9eys0|9cyk0|ahus0|8a2k0|9eys0|9cyk0|9o840|7k580|b7s40|93p80|9gtg0|7nuk0|b42s0|7lzw0|b5xg0|7tek0|b9ms0|776k0|biw40|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|9cyk0|7kas0|b5rw0|7x9g0|ast80|a31g0|7k580|b5xg0|7k580|b5xg0|7k580|biw40|776k0|biw40|776k0|biw40|8zzw0|905g0|9px80|905g0|9px80|9d440|8n180|a31g0|8n180|a31g0|8n180|a31g0|8zzw0|9q2s0|8zzw0|9q2s0|8zzw0|a31g0|8n180|a31g0|8n180|a31g0|8zzw0|9q2s0|8zzw0|9q2s0|8zzw0|9q2s0|8zzw0|a31g0|8n180|a31g0|8n180|a31g0|8zzw0|9q2s0|8zzw0|9q2s0|8zzw0|a31g0|8n180|a31g0|8n180|a31g0|8zzw0|9q2s0|8zzw0|9q2s0|8zzw0|9q2s0|8zzw0|a31g0|8n180|a31g0|8n180|a31g0|Infinity",
                offsets: "230.6667|240|180",
                offsetIndices: "012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212"
            }, {
                id: "America/Atikokan",
                untils: "-qzov40|a2vw0|bfxjw0|pmdk0|1tz8c0|2dsw0|Infinity",
                offsets: "360|300",
                offsetIndices: "0101111"
            }, {
                id: "America/Atka",
                untils: "-ek1nw0|1tyug0|2e6s0|b7yik0|12y080|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|1l940|7rs80|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "660|600|540",
                offsetIndices: "011001010101010101010101010101010111212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Bahia_Banderas",
                untils: "-p1u4k0|2u7jw0|1sgdc0|8n400|7thc0|9eys0|591h80|3ie2s0|axvpg0|dpgw40|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|9q2s0|7k580|9q2s0|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|asqg0|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|Infinity",
                offsets: "421|420|360|480|300",
                offsetIndices: "0121212131212121212121212121212121212142424242424242424242424242424242424242424242424242424242"
            }, {
                id: "America/Bahia",
                untils: "-t85kv8|99kaf8|9a9c0|9io40|99980|8p65g0|6zuo0|bs2o0|67zw0|cjxg0|69uk0|cjxg0|4ml80|5mf440|49mk0|haas0|316k0|cls40|4ml80|cls40|66580|cls40|67zw0|981s40|6u7w0|biw40|5rbw0|d0lg0|5ed80|cyqs0|5ed80|dbpg0|64ak0|cyqs0|64ak0|cls40|5rbw0|dbpg0|51ek0|dbpg0|6h980|c8tg0|6h980|c8tg0|64ak0|c8tg0|6u7w0|bxpg0|7iak0|biw40|6u7w0|biw40|7k580|biw40|6u7w0|c8tg0|6h980|dbpg0|5ed80|4irc40|6u7w0|Infinity",
                offsets: "154.0667|180|120",
                offsetIndices: "01212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Barbados",
                untils: "-o0aiaj|46b400|npv1mj|5rbw0|a31g0|8n180|a31g0|8n180|ag040|84ik0|Infinity",
                offsets: "238.4833|240|180",
                offsetIndices: "00121212121"
            }, {
                id: "America/Belem",
                untils: "-t85j0s|99k8ks|9a9c0|9io40|99980|8p65g0|6zuo0|bs2o0|67zw0|cjxg0|69uk0|cjxg0|4ml80|5mf440|49mk0|haas0|316k0|cls40|4ml80|cls40|66580|cls40|67zw0|981s40|6u7w0|biw40|5rbw0|d0lg0|5ed80|Infinity",
                offsets: "193.9333|180|120",
                offsetIndices: "012121212121212121212121212121"
            }, {
                id: "America/Belize",
                untils: "-u52ic0|3edkc0|6ham0|c8s20|6u9a0|bvte0|6u9a0|bvte0|6u9a0|c8s20|6ham0|c8s20|6ham0|c8s20|6u9a0|bvte0|6u9a0|bvte0|6u9a0|bvte0|6u9a0|c8s20|6ham0|c8s20|6ham0|c8s20|6u9a0|bvte0|6u9a0|bvte0|6u9a0|c8s20|6ham0|c8s20|6ham0|c8s20|6ham0|c8s20|6u9a0|bvte0|6u9a0|bvte0|6u9a0|c8s20|6ham0|c8s20|6ham0|c8s20|6u9a0|bvte0|6u9a0|g2t2q0|3e580|4mcys0|2vmk0|Infinity",
                offsets: "352.8|360|330|300",
                offsetIndices: "01212121212121212121212121212121212121212121212121213131"
            }, {
                id: "America/Blanc-Sablon",
                untils: "-qzp0o0|a2vw0|c5jxg0|1tzdw0|2dnc0|Infinity",
                offsets: "240|180",
                offsetIndices: "010110"
            }, {
                id: "America/Boa_Vista",
                untils: "-t85grk|99k93k|9a9c0|9io40|99980|8p65g0|6zuo0|bs2o0|67zw0|cjxg0|69uk0|cjxg0|4ml80|5mf440|49mk0|haas0|316k0|cls40|4ml80|cls40|66580|cls40|67zw0|981s40|6u7w0|biw40|5rbw0|d0lg0|5ed80|62xk40|7k580|biw40|cvw0|Infinity",
                offsets: "242.6667|240|180",
                offsetIndices: "0121212121212121212121212121212121"
            }, {
                id: "America/Bogota",
                untils: "-srdoy8|14f1hi8|ha580|Infinity",
                offsets: "296.2667|300|240",
                offsetIndices: "0121"
            }, {
                id: "America/Boise",
                untils: "-r0emw0|ast80|7x9g0|ast80|1um840|9s7jw0|1tz5k0|2dvo0|b9gdg0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|51k40|doik0|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "480|420|360",
                offsetIndices: "0101012212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Buenos_Aires",
                untils: "-px7ys0|5iv8k0|67zw0|a4w40|73h80|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|6a040|hy7w0|6a040|xovw0|3uys0|18nbw0|b0dg0|8ve2k0|3uys0|3yik0|bqas0|71mk0|bqas0|71mk0|bqas0|8ovw0|9d440|9px80|9d440|9cyk0|9d440|28t6k0|51ek0|7m2qs0|4tzw0|biw40|776k0|bvus0|6u7w0|bvus0|6u7w0|bvus0|776k0|7qcg40|3yik0|b5xg0|7k580|Infinity",
                offsets: "256.8|240|180|120",
                offsetIndices: "01212121212121212121212121212121212121212123232323232323232"
            }, {
                id: "America/Cambridge_Bay",
                untils: "-q3gdc0|bjeec0|1tz5k0|2dvo0|a7n3w0|9q000|7k85k0|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x6o0|ast80|ct40|7kj40|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "0|420|360|300",
                offsetIndices: "0122131212121212121212121212121212121212121212233221212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Campo_Grande",
                untils: "-t85hvw|99ka7w|9a9c0|9io40|99980|8p65g0|6zuo0|bs2o0|67zw0|cjxg0|69uk0|cjxg0|4ml80|5mf440|49mk0|haas0|316k0|cls40|4ml80|cls40|66580|cls40|67zw0|981s40|6u7w0|biw40|5rbw0|d0lg0|5ed80|cyqs0|5ed80|dbpg0|64ak0|cyqs0|64ak0|cls40|5rbw0|dbpg0|51ek0|dbpg0|6h980|c8tg0|6h980|c8tg0|64ak0|c8tg0|6u7w0|bxpg0|7iak0|biw40|6u7w0|biw40|7k580|biw40|6u7w0|c8tg0|6h980|dbpg0|5ed80|cls40|64ak0|dfes0|5nmk0|c8tg0|6h980|dbpg0|5rbw0|bvus0|6h980|cls40|64ak0|cls40|6h980|c8tg0|6h980|c8tg0|6u7w0|c8tg0|64ak0|cls40|64ak0|cls40|6h980|c8tg0|6h980|c8tg0|6h980|c8tg0|6h980|dbpg0|5ed80|Infinity",
                offsets: "218.4667|240|180",
                offsetIndices: "01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Cancun",
                untils: "-p1u7c0|vauo00|7ggw40|afuk0|8a840|afuk0|8a840|64ak0|4bms0|8a840|ast80|7x9g0|ast80|9q2s0|7k580|9q2s0|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|51k40|Infinity",
                offsets: "347.0667|360|300|240",
                offsetIndices: "0123232321212121212121212121212121212121212"
            }, {
                id: "America/Caracas",
                untils: "-u7lcxw|rlo83w|meoxm0|4dps00|Infinity",
                offsets: "267.6667|270|240",
                offsetIndices: "01212"
            }, {
                id: "America/Catamarca",
                untils: "-px7ys0|5iv8k0|67zw0|a4w40|73h80|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|6a040|hy7w0|6a040|xovw0|3uys0|18nbw0|b0dg0|8ve2k0|3uys0|3yik0|bqas0|71mk0|bqas0|71mk0|bqas0|8ovw0|9d440|9px80|9d440|9cyk0|9d440|28t6k0|51ek0|7m2qs0|4tzw0|biw40|776k0|bvus0|6u7w0|bvxk0|6u540|bvus0|776k0|5v42s0|z9g0|1u93w0|3yik0|Infinity",
                offsets: "256.8|240|180|120",
                offsetIndices: "01212121212121212121212121212121212121212123232323132321232"
            }, {
                id: "America/Cayenne",
                untils: "-uj7yb4|tcw6r4|Infinity",
                offsets: "209.3333|240|180",
                offsetIndices: "012"
            }, {
                id: "America/Cayman",
                untils: "-w757vc|Infinity",
                offsets: "319.6|300",
                offsetIndices: "01"
            }, {
                id: "America/Chicago",
                untils: "-r0esg0|ast80|7x9g0|ast80|bvus0|776k0|7kas0|b5rw0|9d440|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|7x9g0|dbjw0|8a840|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|6w840|1tz8c0|2dsw0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "360|300",
                offsetIndices: "01010101010101010101010101010101010101010101010101101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "America/Chihuahua",
                untils: "-p1u4k0|2u7jw0|1sgdc0|8n400|7thc0|9eys0|xes2s0|afuk0|8a840|afuk0|8aaw0|afuk0|8a840|ast80|7x9g0|ast80|9q2s0|7k580|9q2s0|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|Infinity",
                offsets: "424.3333|420|360|300",
                offsetIndices: "0121212323221212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Coral_Harbour",
                untils: "-qzov40|a2vw0|bfxjw0|pmdk0|1tz8c0|2dsw0|Infinity",
                offsets: "360|300",
                offsetIndices: "0101111"
            }, {
                id: "America/Cordoba",
                untils: "-px7ys0|5iv8k0|67zw0|a4w40|73h80|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|6a040|hy7w0|6a040|xovw0|3uys0|18nbw0|b0dg0|8ve2k0|3uys0|3yik0|bqas0|71mk0|bqas0|71mk0|bqas0|8ovw0|9d440|9px80|9d440|9cyk0|9d440|28t6k0|51ek0|7m2qs0|4tzw0|biw40|776k0|bvus0|6u7w0|bvxk0|6u540|bvus0|776k0|7qcg40|3yik0|b5xg0|7k580|Infinity",
                offsets: "256.8|240|180|120",
                offsetIndices: "01212121212121212121212121212121212121212123232323132323232"
            }, {
                id: "America/Costa_Rica",
                untils: "-pjw8fn|ubtl3n|51ek0|doo40|51ek0|5jso40|8drw0|acas0|2xh80|Infinity",
                offsets: "336.2167|360|300",
                offsetIndices: "0121212121"
            }, {
                id: "America/Creston",
                untils: "-rshz80|vbus0|Infinity",
                offsets: "420|480",
                offsetIndices: "010"
            }, {
                id: "America/Cuiaba",
                untils: "-t85hm4|99k9y4|9a9c0|9io40|99980|8p65g0|6zuo0|bs2o0|67zw0|cjxg0|69uk0|cjxg0|4ml80|5mf440|49mk0|haas0|316k0|cls40|4ml80|cls40|66580|cls40|67zw0|981s40|6u7w0|biw40|5rbw0|d0lg0|5ed80|cyqs0|5ed80|dbpg0|64ak0|cyqs0|64ak0|cls40|5rbw0|dbpg0|51ek0|dbpg0|6h980|c8tg0|6h980|c8tg0|64ak0|c8tg0|6u7w0|bxpg0|7iak0|biw40|6u7w0|biw40|7k580|biw40|6u7w0|c8tg0|6h980|dbpg0|5ed80|w5hg0|5nmk0|c8tg0|6h980|dbpg0|5rbw0|bvus0|6h980|cls40|64ak0|cls40|6h980|c8tg0|6h980|c8tg0|6u7w0|c8tg0|64ak0|cls40|64ak0|cls40|6h980|c8tg0|6h980|c8tg0|6h980|c8tg0|6h980|dbpg0|5ed80|Infinity",
                offsets: "224.3333|240|180",
                offsetIndices: "012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Curacao",
                untils: "-u7lckd|rlo7qd|Infinity",
                offsets: "275.7833|270|240",
                offsetIndices: "012"
            }, {
                id: "America/Danmarkshavn",
                untils: "-rvusjk|x8nx3k|8zrk0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|53hk0|Infinity",
                offsets: "74.6667|180|120|0",
                offsetIndices: "01212121212121212121212121212121213"
            }, {
                id: "America/Dawson_Creek",
                untils: "-qzopk0|a2vw0|c5jxg0|1tz2s0|2dyg0|tj1g0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|69uk0|Infinity",
                offsets: "480|420",
                offsetIndices: "0101101010101010101010101010101010101010101010101010101011"
            }, {
                id: "America/Dawson",
                untils: "-qzoms0|a2vw0|asys0|882c0|bmiwc0|1tz000|2e180|a7n3w0|9q000|465k00|3e2is0|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|Infinity",
                offsets: "540|480|420",
                offsetIndices: "01010110201212121212121212121212121212121212121212121212121212121212121212121212121212121212"
            }, {
                id: "America/Denver",
                untils: "-r0epo0|ast80|7x9g0|ast80|7x9g0|b5rw0|7kas0|2vmk0|ataw40|1tz5k0|2dvo0|a7n9g0|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "420|360",
                offsetIndices: "01010101011010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "America/Detroit",
                untils: "-xx8dyd|5eraud|dyeyk0|1tzb40|2dq40|1c9440|7x3w0|9rlbxo|71s2c|9d440|9cyk0|2cmdg0|9cyk0|3lpg0|f4d80|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "332.1833|360|300|240",
                offsetIndices: "0123323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232"
            }, {
                id: "America/Dominica",
                untils: "-u6m79w|Infinity",
                offsets: "246.0667|240",
                offsetIndices: "01"
            }, {
                id: "America/Edmonton",
                untils: "-x1yazk|629ink|a2vw0|8n6s0|29ek0|h6lg0|9px80|905g0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|9l0g40|1tz5k0|2dvo0|tj1g0|7x3w0|ctzk40|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "453.8667|420|360",
                offsetIndices: "0121212121212122121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Eirunepe",
                untils: "-t85f28|99ka68|9a9c0|9io40|99980|8p65g0|6zuo0|bs2o0|67zw0|cjxg0|69uk0|cjxg0|4ml80|5mf440|49mk0|haas0|316k0|cls40|4ml80|cls40|66580|cls40|67zw0|981s40|6u7w0|biw40|5rbw0|d0lg0|5ed80|2yy2s0|6h980|7hg2s0|2t2t80|Infinity",
                offsets: "279.4667|300|240",
                offsetIndices: "0121212121212121212121212121212121"
            }, {
                id: "America/El_Salvador",
                untils: "-pkm4tc|ymao5c|7k580|b5xg0|7k580|Infinity",
                offsets: "356.8|360|300",
                offsetIndices: "012121"
            }, {
                id: "America/Ensenada",
                untils: "-p1u1s0|11jrw0|1sns00|1sgdc0|71s40|9cyk0|5iidg0|1q6700|4lfk0|190g40|eluk0|2r4o80|7x6o0|asw00|7x6o0|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|84qys0|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|77c40|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "468.0667|420|480",
                offsetIndices: "012121211212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212"
            }, {
                id: "America/Fort_Nelson",
                untils: "-qzopk0|a2vw0|c5jxg0|1tz2s0|2dyg0|tj1g0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|Infinity",
                offsets: "480|420",
                offsetIndices: "01011010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101"
            }, {
                id: "America/Fort_Wayne",
                untils: "-r0esg0|ast80|7x9g0|ast80|baw840|51ek0|6w840|1tz8c0|2dsw0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|19q7w0|asys0|5qonw0|9cyk0|9d440|9cyk0|ihslg0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "360|300|240",
                offsetIndices: "010101011010101010101010101010121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Fortaleza",
                untils: "-t85kvc|99kafc|9a9c0|9io40|99980|8p65g0|6zuo0|bs2o0|67zw0|cjxg0|69uk0|cjxg0|4ml80|5mf440|49mk0|haas0|316k0|cls40|4ml80|cls40|66580|cls40|67zw0|981s40|6u7w0|biw40|5rbw0|d0lg0|5ed80|cyqs0|5ed80|dbpg0|64ak0|514g40|7k580|biw40|puk0|id6s0|6h980|Infinity",
                offsets: "154|180|120",
                offsetIndices: "0121212121212121212121212121212121212121"
            }, {
                id: "America/Glace_Bay",
                untils: "-z94kwc|89fk8c|a2vw0|c5jxg0|1tzdw0|2dnc0|3y8g40|7x3w0|9pa5g0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "239.8|240|180",
                offsetIndices: "012122121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Godthab",
                untils: "-rvumf4|x8nqz4|8zrk0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "206.9333|180|120",
                offsetIndices: "0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Goose_Bay",
                untils: "-qzp20k|a2vw0|8kjbw0|kzjyk|7k580|b5xg0|7k580|b5xg0|7k580|biw40|776k0|biw40|7k580|b5xg0|7k580|b5xg0|1pb260|2dly0|biw40|7k580|b5xg0|7k580|b5xg0|7k580|b5xg0|7k580|biw40|7k580|ag040|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|6y2s0|22420|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a2lo|afuk0|8a840|asqg0|7xc80|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8tec|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "210.8667|150.8667|210|150|240|180|120",
                offsetIndices: "010232323232323233232323232323232323232323232323232323232324545454545454545454545454545454545454545454546454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454"
            }, {
                id: "America/Grand_Turk",
                untils: "-u85og2|z3brw2|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|18ais0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "307.1667|300|240",
                offsetIndices: "01212121212121212121212121212121212121212121212121212121212121212121212121222121212121212121212121212121212121212121"
            }, {
                id: "America/Grenada",
                untils: "-u6m79w|Infinity",
                offsets: "246.0667|240",
                offsetIndices: "01"
            }, {
                id: "America/Guadeloupe",
                untils: "-u6m79w|Infinity",
                offsets: "246.0667|240",
                offsetIndices: "01"
            }, {
                id: "America/Guatemala",
                untils: "-qqqskk|ss0akk|4ofw0|4tidg0|6djw0|3wwas0|8n180|7n5ms0|7x3w0|Infinity",
                offsets: "362.0667|360|300",
                offsetIndices: "0121212121"
            }, {
                id: "America/Guayaquil",
                untils: "-kcr84o|wb620o|3jp80|Infinity",
                offsets: "314|300|240",
                offsetIndices: "0121"
            }, {
                id: "America/Guyana",
                untils: "-smcak8|vj4sz8|81rf90|Infinity",
                offsets: "232.6667|225|180|240",
                offsetIndices: "0123"
            }, {
                id: "America/Halifax",
                untils: "-z94k80|777go0|9et80|st9o0|a2vw0|ssyk0|5rbw0|cv1g0|69uk0|c6ys0|6kyk0|ci2s0|67zw0|ci2s0|6w2k0|bu040|7lzw0|bu040|66580|bu040|7lzw0|bu040|64ak0|cls40|5v180|cv1g0|6j3w0|c6ys0|79180|b42s0|7lzw0|b42s0|7yyk0|bu040|64ak0|dbpg0|66580|cls40|5ed80|bu040|7lzw0|b42s0|7lzw0|cjxg0|66580|bh1g0|7lzw0|b42s0|7lzw0|6uj00|1tzdw0|2dnc0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|tw040|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|tw040|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|1cm2s0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "254.4|240|180",
                offsetIndices: "0121212121212121212121212121212121212121212121212122121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Havana",
                untils: "-n7762o|1icfyo|69uk0|62s040|4ofw0|e1ms0|51ek0|e1ms0|4ofw0|1fhs40|4ofw0|e1ms0|4ofw0|9s9k40|67zw0|cedg0|6h980|9o840|7yyk0|b5xg0|7k580|bvus0|9cyk0|9d440|9cyk0|9d440|9px80|9d440|8a2k0|ag040|8bx80|ae5g0|8drw0|acas0|9cyk0|9d440|9px80|905g0|9px80|9q2s0|7x3w0|8a840|ast80|7x9g0|ast80|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|8a2k0|ag040|8a2k0|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|905g0|a2vw0|905g0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9d1c0|9d1c0|9q000|8n400|asw00|7x6o0|b5uo0|7x6o0|asw00|7x6o0|asw00|8a5c0|afxc0|8a5c0|afxc0|7x6o0|1cm000|6uao0|bvs00|779c0|bitc0|6uao0|bvs00|779c0|bvs00|779c0|c8qo0|779c0|b5uo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|Infinity",
                offsets: "329.6|300|240",
                offsetIndices: "012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Hermosillo",
                untils: "-p1u4k0|2u7jw0|1sgdc0|8n400|7thc0|9eys0|591h80|3ie2s0|axvpg0|dpgw40|afuk0|8a840|afuk0|8a840|afuk0|Infinity",
                offsets: "443.8667|420|360|480",
                offsetIndices: "0121212131212121"
            }, {
                id: "America/Indiana/Indianapolis",
                untils: "-r0esg0|ast80|7x9g0|ast80|baw840|51ek0|6w840|1tz8c0|2dsw0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|19q7w0|asys0|5qonw0|9cyk0|9d440|9cyk0|ihslg0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "360|300|240",
                offsetIndices: "010101011010101010101010101010121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Indiana/Knox",
                untils: "-r0esg0|ast80|7x9g0|ast80|bmtus0|1tz8c0|2dsw0|tj1g0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|9px80|9d440|9cyk0|9d440|7x3w0|asys0|7x3w0|asys0|9cyk0|9d440|9px80|9d440|9cyk0|9d440|s3180|1twas0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|7j5400|asw00|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "360|300",
                offsetIndices: "0101011010101010101010101010101010101010101010101010101010101010101010101010101010101010111010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "America/Indiana/Marengo",
                untils: "-r0esg0|ast80|7x9g0|ast80|bmtus0|1tz8c0|2dsw0|2wsas0|7x3w0|1c9440|7x3w0|asys0|7x3w0|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|465h80|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4g00|64dc0|clmk0|fvt9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "360|300|240",
                offsetIndices: "0101011010101010101010101212121212111212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Indiana/Petersburg",
                untils: "-r0esg0|ast80|7x9g0|ast80|bmtus0|1tz8c0|2dsw0|501ek0|7kas0|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|sfzw0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|eu02o0|asw00|6udg0|c8nw0|6hc00|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "360|300|240",
                offsetIndices: "01010110101010101010101010101010101010101010101010111011212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Indiana/Tell_City",
                untils: "-r0esg0|ast80|7x9g0|ast80|bmtus0|1tz8c0|2dsw0|501ek0|7kas0|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|1tw580|9d440|9cyk0|9d440|9cvs0|9d440|9cyk0|ihslg0|asw00|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "360|300|240",
                offsetIndices: "01010110101010101010101010101021211010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "America/Indiana/Vevay",
                untils: "-r0esg0|ast80|7x9g0|ast80|bmtus0|1tz8c0|2dsw0|4gyis0|7txx80|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|hfzhg0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "360|300|240",
                offsetIndices: "010101101212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Indiana/Vincennes",
                untils: "-r0esg0|ast80|7x9g0|ast80|bmtus0|1tz8c0|2dsw0|asys0|7x3w0|3fidg0|7x3w0|asys0|7x3w0|b5rw0|7kas0|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|9px80|9d440|7k580|b5xg0|9cyk0|9d440|9cyk0|9d440|2lz980|9cyk0|9d440|9cyk0|ihslg0|asw00|6udg0|c8nw0|6hc00|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "360|300|240",
                offsetIndices: "01010110101010101010101010101010121211011212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Indiana/Winamac",
                untils: "-r0esg0|ast80|7x9g0|ast80|bmtus0|1tz8c0|2dsw0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|9px80|9d440|9cyk0|9d440|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|465h80|9cyk0|9d440|9cyk0|ihslg0|asw00|6udg0|c8l40|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "360|300|240",
                offsetIndices: "01010110101010101010101010101010101010121211021212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Indianapolis",
                untils: "-r0esg0|ast80|7x9g0|ast80|baw840|51ek0|6w840|1tz8c0|2dsw0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|19q7w0|asys0|5qonw0|9cyk0|9d440|9cyk0|ihslg0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "360|300|240",
                offsetIndices: "010101011010101010101010101010121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Inuvik",
                untils: "-8ve5c0|6fce80|9q000|71i2w0|ipzw0|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "0|480|360|420",
                offsetIndices: "0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323"
            }, {
                id: "America/Iqaluit",
                untils: "-eb6ao0|1l3h80|2dq40|a7n3w0|9q000|7k85k0|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7xc80|ast80|7x6o0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "0|240|300|180|360",
                offsetIndices: "01123212121212121212121212121212121212121212142212121212121212121212121212121212121212121212121212121212121212121212121212"
            }, {
                id: "America/Jamaica",
                untils: "-u85og2|wbl182|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|Infinity",
                offsets: "307.1667|300|240",
                offsetIndices: "0121212121212121212121"
            }, {
                id: "America/Jujuy",
                untils: "-px7ys0|5iv8k0|67zw0|a4w40|73h80|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|6a040|hy7w0|6a040|xovw0|3uys0|18nbw0|b0dg0|8ve2k0|3uys0|3yik0|bqas0|71mk0|bqas0|71mk0|bqas0|8ovw0|9d440|9px80|9d440|9cyk0|9d440|28t6k0|51ek0|7m2qs0|4tzw0|biw40|776k0|c8w80|776k0|ag040|7k2g0|bvus0|776k0|7qcg40|3yik0|Infinity",
                offsets: "256.8|240|180|120",
                offsetIndices: "012121212121212121212121212121212121212121232323121323232"
            }, {
                id: "America/Juneau",
                untils: "-ek1w80|1tz2s0|2dyg0|cawis0|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9d1c0|9d1c0|9cyk0|9d440|9px80|905g0|9px80|1leo0|7rs80|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "480|420|540",
                offsetIndices: "01101010101010101010101010001010122020202020202020202020202020202020202020202020202020202020202020202020202020202020202020202020202020202020202"
            }, {
                id: "America/Kentucky/Louisville",
                untils: "-r0esg0|ast80|7x9g0|ast80|sg5g0|6bp80|a98o40|7x3w0|6w840|1tz8c0|2dsw0|ast9o|1sw2c|21gis0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|4bh80|3j3xc0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4g00|64dc0|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "360|300|240",
                offsetIndices: "0101010101101010101010101010101010101121212121212111212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Kentucky/Monticello",
                untils: "-r0esg0|ast80|7x9g0|ast80|bmtus0|1tz8c0|2dsw0|bs6g40|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x6o0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "360|300|240",
                offsetIndices: "0101011010101010101010101010101010101010101010101010101010101010101010101121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Knox_IN",
                untils: "-r0esg0|ast80|7x9g0|ast80|bmtus0|1tz8c0|2dsw0|tj1g0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|9px80|9d440|9cyk0|9d440|7x3w0|asys0|7x3w0|asys0|9cyk0|9d440|9px80|9d440|9cyk0|9d440|s3180|1twas0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|7j5400|asw00|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "360|300",
                offsetIndices: "0101011010101010101010101010101010101010101010101010101010101010101010101010101010101010111010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "America/Kralendijk",
                untils: "-u7lckd|rlo7qd|Infinity",
                offsets: "275.7833|270|240",
                offsetIndices: "012"
            }, {
                id: "America/La_Paz",
                untils: "-jxzspo|84ik0|Infinity",
                offsets: "272.6|212.6|240",
                offsetIndices: "012"
            }, {
                id: "America/Lima",
                untils: "-w25lpo|fcxjlo|4ml80|93us0|9cyk0|9d440|9cyk0|nw16s0|4ml80|e5c40|4ml80|1fr1g0|4ml80|1yiys0|4ml80|Infinity",
                offsets: "308.6|300|240",
                offsetIndices: "0121212121212121"
            }, {
                id: "America/Los_Angeles",
                untils: "-r0emw0|ast80|7x9g0|ast80|bmtus0|1tz2s0|2dyg0|1a3c5o|f2iic|owao0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|902o0|9q000|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "480|420",
                offsetIndices: "010101101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "America/Louisville",
                untils: "-r0esg0|ast80|7x9g0|ast80|sg5g0|6bp80|a98o40|7x3w0|6w840|1tz8c0|2dsw0|ast9o|1sw2c|21gis0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|4bh80|3j3xc0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4g00|64dc0|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "360|300|240",
                offsetIndices: "0101010101101010101010101010101010101121212121212111212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Lower_Princes",
                untils: "-u7lckd|rlo7qd|Infinity",
                offsets: "275.7833|270|240",
                offsetIndices: "012"
            }, {
                id: "America/Maceio",
                untils: "-t85ldw|99kaxw|9a9c0|9io40|99980|8p65g0|6zuo0|bs2o0|67zw0|cjxg0|69uk0|cjxg0|4ml80|5mf440|49mk0|haas0|316k0|cls40|4ml80|cls40|66580|cls40|67zw0|981s40|6u7w0|biw40|5rbw0|d0lg0|5ed80|cyqs0|5ed80|dbpg0|64ak0|2yl440|64ak0|1wf1g0|7k580|biw40|puk0|id6s0|6h980|Infinity",
                offsets: "142.8667|180|120",
                offsetIndices: "012121212121212121212121212121212121212121"
            }, {
                id: "America/Managua",
                untils: "-ijh6oo|ka1i0o|xqqk0|24p6s0|53980|dmtg0|53980|60itw0|dq240|53es0|235h80|4beis0|8zzw0|at4c0|7x140|Infinity",
                offsets: "345.2|360|300",
                offsetIndices: "0121212121212121"
            }, {
                id: "America/Manaus",
                untils: "-t85gvw|99k97w|9a9c0|9io40|99980|8p65g0|6zuo0|bs2o0|67zw0|cjxg0|69uk0|cjxg0|4ml80|5mf440|49mk0|haas0|316k0|cls40|4ml80|cls40|66580|cls40|67zw0|981s40|6u7w0|biw40|5rbw0|d0lg0|5ed80|2yy2s0|6h980|Infinity",
                offsets: "240.0667|240|180",
                offsetIndices: "01212121212121212121212121212121"
            }, {
                id: "America/Marigot",
                untils: "-u6m79w|Infinity",
                offsets: "246.0667|240",
                offsetIndices: "01"
            }, {
                id: "America/Martinique",
                untils: "-umcvcs|zz5x4s|8zzw0|Infinity",
                offsets: "244.3333|240|180",
                offsetIndices: "0121"
            }, {
                id: "America/Matamoros",
                untils: "-p1u7c0|ykt480|ast80|3vppg0|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|9q2s0|7k580|9q2s0|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|77c40|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "400|360|300",
                offsetIndices: "0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Mazatlan",
                untils: "-p1u4k0|2u7jw0|1sgdc0|8n400|7thc0|9eys0|591h80|3ie2s0|axvpg0|dpgw40|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|9q2s0|7k580|9q2s0|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|Infinity",
                offsets: "425.6667|420|360|480",
                offsetIndices: "0121212131212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Mendoza",
                untils: "-px7ys0|5iv8k0|67zw0|a4w40|73h80|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|6a040|hy7w0|6a040|xovw0|3uys0|18nbw0|b0dg0|8ve2k0|3uys0|3yik0|bqas0|71mk0|bqas0|71mk0|bqas0|8ovw0|9d440|9px80|9d440|9cyk0|9d440|28t6k0|51ek0|7m2qs0|4tzw0|biw40|776k0|bktk0|71mk0|bqas0|73h80|bvus0|773s0|5unes0|6hes0|1p7mk0|3yik0|Infinity",
                offsets: "256.8|240|180|120",
                offsetIndices: "01212121212121212121212121212121212121212123232312121321232"
            }, {
                id: "America/Menominee",
                untils: "-r0esg0|ast80|7x9g0|ast80|bmtus0|1tz8c0|2dsw0|asys0|7x3w0|a7n9g0|9px80|1at9g0|2396k0|9d1c0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "360|300",
                offsetIndices: "01010110101011010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "America/Merida",
                untils: "-p1u7c0|vauo00|hoyk0|6ys0c0|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|9q2s0|7k580|9q2s0|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|Infinity",
                offsets: "358.4667|360|300",
                offsetIndices: "0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Metlakatla",
                untils: "-ek1w80|1tz2s0|2dyg0|cawis0|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|gpc840|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|3ylc0|2itg0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "480|420|540",
                offsetIndices: "01101010101010101010101010101010102020200202020202020202020202020202020202020202"
            }, {
                id: "America/Mexico_City",
                untils: "-p1u4k0|2u7jw0|1sgdc0|8n400|7thc0|9eys0|3knek0|776k0|rf440|5t6k0|1evk40|71mk0|30p1g0|8n180|nufxo0|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|9q2s0|7k580|9q2s0|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|Infinity",
                offsets: "396.6|420|360|300",
                offsetIndices: "012121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232"
            }, {
                id: "America/Miquelon",
                untils: "-ulmyxk|zzqbdk|3m59g0|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "224.6667|240|180|120",
                offsetIndices: "012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232"
            }, {
                id: "America/Moncton",
                untils: "-z94i40|89fhg0|a2vw0|7mqqo0|4ofw0|e1ms0|4ofw0|e1ms0|4ofw0|e1ms0|4ofw0|e1ms0|4ofw0|e1ms0|4ofw0|dmtg0|64ak0|cao40|6fek0|bkqs0|7iak0|6y5k0|1tzdw0|2dnc0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7x3w0|asys0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|s36s0|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a2lo|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6uiyc|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "300|240|180",
                offsetIndices: "012121212121212121212122121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Monterrey",
                untils: "-p1u7c0|ykt480|ast80|3vppg0|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|9q2s0|7k580|9q2s0|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|Infinity",
                offsets: "401.2667|360|300",
                offsetIndices: "0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Montevideo",
                untils: "-w4mll9|67elc0|1s74p9|9et80|9exe0|9czy0|9exe0|9czy0|3ydyq0|7x5a0|asxe0|7x5a0|asxe0|7x5a0|asxe0|7x5a0|b5w20|7k6m0|b5w20|7k6m0|9q1e0|9czy0|asxe0|7x5a0|6do20|ppvy0|4mmm0|8g9qq0|901a0|38pe0|2inw0|2nf9g0|8zzw0|1e3s40|9o3y0|q8he0|2kik0|yxhg0|4bh80|s36s0|2vl60|905g0|5rg20|51ek0|weqs0|3yik0|e1ms0|4ofw0|erk40|3yik0|2vs40|gk7w0|41iys0|3wnw0|erk40|4bh80|c8tg0|64ak0|c8tg0|6u7w0|c8tg0|6h980|bvus0|6u7w0|614qs0|9q2s0|a31g0|7x3w0|ag040|8a2k0|asys0|7x3w0|asys0|7x3w0|asys0|8a2k0|ag040|8a2k0|ag040|8a2k0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|Infinity",
                offsets: "224.85|240|180|210|150|120|90",
                offsetIndices: "001232323232323232323232324242525242525264252525252525252525252525252525252525252525252"
            }, {
                id: "America/Montreal",
                untils: "-qzoxw0|a2vw0|7yx60|aqzy0|9q8c0|7jzo0|bw0c0|6bp80|cedg0|6h980|c8tg0|6h980|bvus0|776k0|biw40|776k0|biw40|776k0|biw40|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|xjeo0|1tzb40|2dq40|asys0|7x3w0|ast80|7x3w0|asys0|7x3w0|asys0|b5rw0|7xf00|ast80|7x9g0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7x3w0|asys0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "300|240",
                offsetIndices: "01010101010101010101010101010101010101010101011101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "America/Montserrat",
                untils: "-u6m79w|Infinity",
                offsets: "246.0667|240",
                offsetIndices: "01"
            }, {
                id: "America/Nassau",
                untils: "-u6m4c6|r7u7s6|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "309.5|300|240",
                offsetIndices: "012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/New_York",
                untils: "-r0ev80|ast80|7x9g0|ast80|7x9g0|b5rw0|905g0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|6w840|1tzb40|2dq40|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "300|240",
                offsetIndices: "01010101010101010101010101010101010101010101010101101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "America/Nipigon",
                untils: "-qzoxw0|a2vw0|bfxjw0|pmdk0|1tzb40|2dq40|ewvus0|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "300|240",
                offsetIndices: "010111010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "America/Nome",
                untils: "-ek1nw0|1tyug0|2e6s0|b7yik0|12y080|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|1l6c0|7rs80|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "660|600|540|480",
                offsetIndices: "011001010101010101010101010101010122323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232"
            }, {
                id: "America/Noronha",
                untils: "-t85lzw|99k8rw|9a9c0|9io40|99980|8p65g0|6zuo0|bs2o0|67zw0|cjxg0|69uk0|cjxg0|4ml80|5mf440|49mk0|haas0|316k0|cls40|4ml80|cls40|66580|cls40|67zw0|981s40|6u7w0|biw40|5rbw0|d0lg0|5ed80|cyqs0|5ed80|dbpg0|64ak0|514g40|7k580|biw40|cvw0|iq5g0|6h980|Infinity",
                offsets: "129.6667|120|60",
                offsetIndices: "0121212121212121212121212121212121212121"
            }, {
                id: "America/North_Dakota/Beulah",
                untils: "-r0epo0|ast80|7x9g0|ast80|bmtus0|1tz5k0|2dvo0|b9gdg0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hc00|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "420|360|300",
                offsetIndices: "010101101010101010101010101010101010101010101010101010101010101010101010101010101010101010101011212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/North_Dakota/Center",
                untils: "-r0epo0|ast80|7x9g0|ast80|bmtus0|1tz5k0|2dvo0|b9gdg0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a5c0|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "420|360|300",
                offsetIndices: "010101101010101010101010101010101010101010101010101010101011212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/North_Dakota/New_Salem",
                untils: "-r0epo0|ast80|7x9g0|ast80|bmtus0|1tz5k0|2dvo0|b9gdg0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a5c0|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "420|360|300",
                offsetIndices: "010101101010101010101010101010101010101010101010101010101010101010101010101010101121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Nuuk",
                untils: "-rvumf4|x8nqz4|8zrk0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "206.9333|180|120",
                offsetIndices: "0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Ojinaga",
                untils: "-p1u4k0|2u7jw0|1sgdc0|8n400|7thc0|9eys0|xes2s0|afuk0|8a840|afuk0|8aaw0|afuk0|8a840|ast80|7x9g0|ast80|9q2s0|7k580|9q2s0|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|77c40|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "417.6667|420|360|300",
                offsetIndices: "0121212323221212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Panama",
                untils: "-w757vc|Infinity",
                offsets: "319.6|300",
                offsetIndices: "01"
            }, {
                id: "America/Pangnirtung",
                untils: "-pkmlc0|b0ke00|1tzdw0|2dnc0|a7n3w0|9q000|7k85k0|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|asw00|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7xc80|ast80|7x6o0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "0|240|180|120|300|360",
                offsetIndices: "012213121212121212121212121212121212114141414154414141414141414141414141414141414141414141414141414141414141414141414141414"
            }, {
                id: "America/Paramaribo",
                untils: "-usj4g8|cixc0c|5lydbk|kcrm6c|Infinity",
                offsets: "220.6667|220.8667|220.6|210|180",
                offsetIndices: "01234"
            }, {
                id: "America/Phoenix",
                untils: "-r0epo0|ast80|7x9g0|ast80|bmtus0|zjedo|4olg0|9et80|bs6lmc|9cyk0|Infinity",
                offsets: "420|360",
                offsetIndices: "01010101010"
            }, {
                id: "America/Port_of_Spain",
                untils: "-u6m79w|Infinity",
                offsets: "246.0667|240",
                offsetIndices: "01"
            }, {
                id: "America/Port-au-Prince",
                untils: "-rmk9ac|ylcf6c|8zzw0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8aaw0|asw00|7x6o0|asw00|7x6o0|asw00|8a5c0|afxc0|8a5c0|afxc0|8a5c0|asw00|7x6o0|asw00|7x6o0|asw00|8a5c0|afxc0|8a5c0|afxc0|3vpjw0|ast80|7x9g0|ast80|2stv00|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|pkg40|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "289|300|240",
                offsetIndices: "01212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Porto_Acre",
                untils: "-t85fg0|99kak0|9a9c0|9io40|99980|8p65g0|6zuo0|bs2o0|67zw0|cjxg0|69uk0|cjxg0|4ml80|5mf440|49mk0|haas0|316k0|cls40|4ml80|cls40|66580|cls40|67zw0|981s40|6u7w0|biw40|5rbw0|d0lg0|5ed80|amves0|2t2t80|Infinity",
                offsets: "271.2|300|240",
                offsetIndices: "01212121212121212121212121212121"
            }, {
                id: "America/Porto_Velho",
                untils: "-t85g60|99k8i0|9a9c0|9io40|99980|8p65g0|6zuo0|bs2o0|67zw0|cjxg0|69uk0|cjxg0|4ml80|5mf440|49mk0|haas0|316k0|cls40|4ml80|cls40|66580|cls40|67zw0|981s40|6u7w0|biw40|5rbw0|d0lg0|5ed80|Infinity",
                offsets: "255.6|240|180",
                offsetIndices: "012121212121212121212121212121"
            }, {
                id: "America/Puerto_Rico",
                untils: "-efsnk0|1ppu40|2dnc0|Infinity",
                offsets: "240|180",
                offsetIndices: "0110"
            }, {
                id: "America/Punta_Arenas",
                untils: "-vauawq|3dlssq|157b7a|f4e0q|49hzba|aye0q|7ves0|awik0|7ves0|awik0|7ves0|awik0|7ves0|ayd80|7ves0|534ik0|351g0|2fnh80|2mg00|b73400|7k580|c8tg0|6h980|a31g0|7x3w0|asys0|7x3w0|b5xg0|7k580|ag040|8a2k0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7k580|b5xg0|9cyk0|9d440|7x3w0|asys0|7x3w0|b5xg0|7k580|9q2s0|8zzw0|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|8n180|a31g0|7x3w0|a31g0|9px80|9q2s0|7x3w0|b5xg0|7k580|b5xg0|7k580|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|8n180|a31g0|7x3w0|asys0|8zzw0|9q2s0|ast80|5eis0|cyl80|6hes0|c8nw0|6udg0|bvp80|6udg0|vonw0|4olg0|Infinity",
                offsets: "282.7667|300|240|180",
                offsetIndices: "0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323"
            }, {
                id: "America/Rainy_River",
                untils: "-qzov40|a2vw0|bfxjw0|pmdk0|1tz8c0|2dsw0|ewvus0|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "360|300",
                offsetIndices: "010111010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "America/Rankin_Inlet",
                untils: "-6s8lc0|4c6oo0|9q000|7k85k0|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "0|360|240|300",
                offsetIndices: "012131313131313131313131313131313131313131313331313131313131313131313131313131313131313131313131313131313131313131313131"
            }, {
                id: "America/Recife",
                untils: "-t85ljc|99kb3c|9a9c0|9io40|99980|8p65g0|6zuo0|bs2o0|67zw0|cjxg0|69uk0|cjxg0|4ml80|5mf440|49mk0|haas0|316k0|cls40|4ml80|cls40|66580|cls40|67zw0|981s40|6u7w0|biw40|5rbw0|d0lg0|5ed80|cyqs0|5ed80|dbpg0|64ak0|514g40|7k580|biw40|cvw0|iq5g0|6h980|Infinity",
                offsets: "139.6|180|120",
                offsetIndices: "0121212121212121212121212121212121212121"
            }, {
                id: "America/Regina",
                untils: "-xkq9yc|6l1hmc|a2vw0|60enw0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|1b6840|9cyk0|9d440|8zzw0|9q2s0|9cyk0|9q2s0|9cyk0|9d440|9cyk0|66gc0|1tz5k0|2dvo0|a31g0|9cyk0|a31g0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7x3w0|asys0|7x3w0|tj1g0|9cyk0|9d440|Infinity",
                offsets: "418.6|420|360",
                offsetIndices: "012121212121212121212121221212121212121212121212121212"
            }, {
                id: "America/Resolute",
                untils: "-bnp9c0|97nco0|9q000|7k85k0|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "0|360|240|300",
                offsetIndices: "012131313131313131313131313131313131313131313331313131313331313131313131313131313131313131313131313131313131313131313131"
            }, {
                id: "America/Rio_Branco",
                untils: "-t85fg0|99kak0|9a9c0|9io40|99980|8p65g0|6zuo0|bs2o0|67zw0|cjxg0|69uk0|cjxg0|4ml80|5mf440|49mk0|haas0|316k0|cls40|4ml80|cls40|66580|cls40|67zw0|981s40|6u7w0|biw40|5rbw0|d0lg0|5ed80|amves0|2t2t80|Infinity",
                offsets: "271.2|300|240",
                offsetIndices: "01212121212121212121212121212121"
            }, {
                id: "America/Rosario",
                untils: "-px7ys0|5iv8k0|67zw0|a4w40|73h80|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|cls40|66580|cls40|66580|cls40|66580|cls40|67zw0|6a040|hy7w0|6a040|xovw0|3uys0|18nbw0|b0dg0|8ve2k0|3uys0|3yik0|bqas0|71mk0|bqas0|71mk0|bqas0|8ovw0|9d440|9px80|9d440|9cyk0|9d440|28t6k0|51ek0|7m2qs0|4tzw0|biw40|776k0|bvus0|6u7w0|bvxk0|6u540|bvus0|776k0|7qcg40|3yik0|b5xg0|7k580|Infinity",
                offsets: "256.8|240|180|120",
                offsetIndices: "01212121212121212121212121212121212121212123232323132323232"
            }, {
                id: "America/Santa_Isabel",
                untils: "-p1u1s0|11jrw0|1sns00|1sgdc0|71s40|9cyk0|5iidg0|1q6700|4lfk0|190g40|eluk0|2r4o80|7x6o0|asw00|7x6o0|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|84qys0|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|77c40|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "468.0667|420|480",
                offsetIndices: "012121211212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212"
            }, {
                id: "America/Santarem",
                untils: "-t85hvc|99ka7c|9a9c0|9io40|99980|8p65g0|6zuo0|bs2o0|67zw0|cjxg0|69uk0|cjxg0|4ml80|5mf440|49mk0|haas0|316k0|cls40|4ml80|cls40|66580|cls40|67zw0|981s40|6u7w0|biw40|5rbw0|d0lg0|5ed80|amves0|Infinity",
                offsets: "218.8|240|180",
                offsetIndices: "0121212121212121212121212121212"
            }, {
                id: "America/Santiago",
                untils: "-vauawq|3dlssq|157b7a|f4e0q|49hzba|aye0q|7ves0|awik0|7ves0|awik0|7ves0|awik0|7ves0|ayd80|7ves0|534ik0|351g0|229zw0|2gt80|awo40|2mg00|b73400|7k580|c8tg0|6h980|a31g0|7x3w0|asys0|7x3w0|b5xg0|7k580|ag040|8a2k0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7k580|b5xg0|9cyk0|9d440|7x3w0|asys0|7x3w0|b5xg0|7k580|9q2s0|8zzw0|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|8n180|a31g0|7x3w0|a31g0|9px80|9q2s0|7x3w0|b5xg0|7k580|b5xg0|7k580|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|8n180|a31g0|7x3w0|asys0|8zzw0|9q2s0|ast80|5eis0|cyl80|6hes0|c8nw0|6udg0|bvp80|6udg0|vonw0|4olg0|e1h80|4olg0|e1h80|4olg0|c8nw0|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|b5rw0|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|b5rw0|7kas0|b5rw0|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|b5rw0|7kas0|b5rw0|7x9g0|ast80|7x9g0|Infinity",
                offsets: "282.7667|300|240|180",
                offsetIndices: "010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323"
            }, {
                id: "America/Santo_Domingo",
                untils: "-j6hz1c|hiw29c|67zw0|1dy840|62ha0|cnle0|4h2m0|elyq0|47ta0|ei9e0|4bim0|eek20|4dda0|ecpe0|dkmtg0|1stc0|Infinity",
                offsets: "280|300|240|270",
                offsetIndices: "01213131313131212"
            }, {
                id: "America/Sao_Paulo",
                untils: "-t85jd8|99k8x8|9a9c0|9io40|99980|8p65g0|6zuo0|bs2o0|67zw0|cjxg0|69uk0|cjxg0|4ml80|5k02s0|6onw0|haas0|316k0|cls40|4ml80|cls40|66580|cls40|67zw0|981s40|6u7w0|biw40|5rbw0|d0lg0|5ed80|cyqs0|5ed80|dbpg0|64ak0|cyqs0|64ak0|cls40|5rbw0|dbpg0|51ek0|dbpg0|6h980|c8tg0|6h980|c8tg0|64ak0|c8tg0|6u7w0|bxpg0|7iak0|biw40|6u7w0|biw40|7k580|biw40|6u7w0|c8tg0|6h980|dbpg0|5ed80|cls40|64ak0|dfes0|5nmk0|c8tg0|6h980|dbpg0|5rbw0|bvus0|6h980|cls40|64ak0|cls40|6h980|c8tg0|6h980|c8tg0|6u7w0|c8tg0|64ak0|cls40|64ak0|cls40|6h980|c8tg0|6h980|c8tg0|6h980|c8tg0|6h980|dbpg0|5ed80|Infinity",
                offsets: "186.4667|180|120",
                offsetIndices: "01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Scoresbysund",
                untils: "-rvurxk|x8ntpk|902o0|9cvs0|9cyk0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "87.8667|120|60|0",
                offsetIndices: "0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232"
            }, {
                id: "America/Shiprock",
                untils: "-r0epo0|ast80|7x9g0|ast80|7x9g0|b5rw0|7kas0|2vmk0|ataw40|1tz5k0|2dvo0|a7n9g0|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "420|360",
                offsetIndices: "01010101011010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "America/Sitka",
                untils: "-ek1w80|1tz2s0|2dyg0|cawis0|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|1leo0|7rs80|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "480|420|540",
                offsetIndices: "01101010101010101010101010101010122020202020202020202020202020202020202020202020202020202020202020202020202020202020202020202020202020202020202"
            }, {
                id: "America/St_Barthelemy",
                untils: "-u6m79w|Infinity",
                offsets: "246.0667|240",
                offsetIndices: "01"
            }, {
                id: "America/St_Johns",
                untils: "-ris3ck|8bx80|ar440|a2vw0|9tjs0|53980|dkys0|9cyk0|9d440|9cyk0|9q2s0|8zzw0|9q2s0|8zzw0|9q2s0|8zzw0|9q2s0|8zzw0|9q2s0|9cyk0|9d440|9cyk0|9q2s0|8zzw0|9q2s0|8zzw0|9q2s0|8zzw0|9q2s0|8zzw0|9q2s0|9cyk0|9q2s0|8zzw0|9q2s0|8zzw0|7tmw0|1wfuk|8zzw0|a3480|7k580|b5xg0|7k580|b5xg0|7k580|biw40|776k0|biw40|7k580|b5xg0|7k580|b5xg0|1pb260|2dly0|biw40|7k580|b5xg0|7k580|b5xg0|7k580|b5xg0|7k580|biw40|7k580|ag040|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a2lo|afuk0|8a840|asqg0|7xc80|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8tec|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "210.8667|150.8667|210|150|90",
                offsetIndices: "01010101010101010101010101010101010102323232323232323323232323232323232323232323232323232323232323232323232323232323232323232323232323232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232"
            }, {
                id: "America/St_Kitts",
                untils: "-u6m79w|Infinity",
                offsets: "246.0667|240",
                offsetIndices: "01"
            }, {
                id: "America/St_Lucia",
                untils: "-u6m79w|Infinity",
                offsets: "246.0667|240",
                offsetIndices: "01"
            }, {
                id: "America/St_Thomas",
                untils: "-u6m79w|Infinity",
                offsets: "246.0667|240",
                offsetIndices: "01"
            }, {
                id: "America/St_Vincent",
                untils: "-u6m79w|Infinity",
                offsets: "246.0667|240",
                offsetIndices: "01"
            }, {
                id: "America/Swift_Current",
                untils: "-xkq9d4|6l1h14|a2vw0|c5jxg0|1tz5k0|2dvo0|asys0|8n180|a31g0|7x3w0|asys0|7x3w0|asys0|7x3w0|3yles0|9cyk0|s36s0|9cyk0|9d440|7x3w0|b5xg0|7k580|5j4lg0|Infinity",
                offsets: "431.3333|420|360",
                offsetIndices: "012122121212121212121212"
            }, {
                id: "America/Tegucigalpa",
                untils: "-pfzh6k|yho0ik|7k580|b5xg0|7k580|96x1g0|4qak0|Infinity",
                offsets: "348.8667|360|300",
                offsetIndices: "01212121"
            }, {
                id: "America/Thule",
                untils: "-rvuj9g|12yzilg|9cyk0|9d440|9cyk0|9q2s0|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "275.1333|240|180",
                offsetIndices: "012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Thunder_Bay",
                untils: "-vbavc0|gr8qs0|1tzb40|2dq40|ctmlg0|9cyk0|9d440|9px80|9d440|9cyk0|s36s0|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "360|300|240",
                offsetIndices: "0122121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "America/Tijuana",
                untils: "-p1u1s0|11jrw0|1sns00|1sgdc0|71s40|9cyk0|5iidg0|1q6700|4lfk0|190g40|eluk0|2r4o80|7x6o0|asw00|7x6o0|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|84qys0|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|77c40|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "468.0667|420|480",
                offsetIndices: "012121211212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212"
            }, {
                id: "America/Toronto",
                untils: "-qzoxw0|a2vw0|7yx60|aqzy0|9q8c0|7jzo0|bw0c0|6bp80|cedg0|6h980|c8tg0|6h980|bvus0|776k0|biw40|776k0|biw40|776k0|biw40|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|xjeo0|1tzb40|2dq40|asys0|7x3w0|ast80|7x3w0|asys0|7x3w0|asys0|b5rw0|7xf00|ast80|7x9g0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7x3w0|asys0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "300|240",
                offsetIndices: "01010101010101010101010101010101010101010101011101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "America/Tortola",
                untils: "-u6m79w|Infinity",
                offsets: "246.0667|240",
                offsetIndices: "01"
            }, {
                id: "America/Vancouver",
                untils: "-qzopk0|a2vw0|c5jxg0|1tz2s0|2dyg0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "480|420",
                offsetIndices: "0101101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "America/Virgin",
                untils: "-u6m79w|Infinity",
                offsets: "246.0667|240",
                offsetIndices: "01"
            }, {
                id: "America/Whitehorse",
                untils: "-qzoms0|a2vw0|asys0|882c0|bmiwc0|1tz000|2e180|a7n3w0|9q000|tiyo0|6qp440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|Infinity",
                offsets: "540|480|420",
                offsetIndices: "01010110201212121212121212121212121212121212121212121212121212121212121212121212121212121212"
            }, {
                id: "America/Winnipeg",
                untils: "-s0s7c0|7k580|tj700|a2vw0|9ok840|6u7w0|2a5hg0|1tz8c0|2dsw0|biw40|7x3w0|a31g0|7x3w0|asys0|7x3w0|asys0|7x3w0|b7s40|7tek0|autg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|9cyk0|9d440|7x3w0|1cm2s0|7k580|1cm2s0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|902o0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|902o0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|8a5c0|afxc0|8a5c0|asw00|7x6o0|asw00|7x6o0|asw00|8a5c0|afxc0|8a5c0|afxc0|8a5c0|asw00|7x6o0|asw00|7x6o0|asw00|8a5c0|afxc0|8a5c0|afxc0|8a5c0|afxc0|8a5c0|asw00|7x6o0|asw00|7x6o0|asw00|8a5c0|afxc0|8a5c0|afxc0|8a5c0|asw00|7x6o0|asw00|7x6o0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "360|300",
                offsetIndices: "010101011010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "America/Yakutat",
                untils: "-ek1tg0|1tz000|2e180|cawis0|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|1lbw0|7rs80|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "540|480",
                offsetIndices: "01101010101010101010101010101010100101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "America/Yellowknife",
                untils: "-i9m2o0|3pk3o0|1tz5k0|2dvo0|a7n3w0|9q000|7k85k0|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "0|420|360|300",
                offsetIndices: "012213121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Antarctica/Casey",
                untils: "-irxc0|lag4o0|73bo0|uz1o0|60l80|2fnh80|pz9g0|Infinity",
                offsets: "0|-480|-660",
                offsetIndices: "01212121"
            }, {
                id: "Antarctica/Davis",
                untils: "-6rmdc0|42jdw0|27wgs0|l8uss0|7eqs0|unmk0|60qs0|Infinity",
                offsets: "0|-420|-300",
                offsetIndices: "01012121"
            }, {
                id: "Antarctica/DumontDUrville",
                untils: "-c05eo0|2mks80|2i72g0|Infinity",
                offsets: "0|-600",
                offsetIndices: "0101"
            }, {
                id: "Antarctica/Macquarie",
                untils: "-rsj4w0|8zzw0|11wqk0|f4kh40|a6p8g0|9d1c0|asw00|6uao0|bvs00|6uao0|bvs00|779c0|bvs00|64dc0|clpc0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|7x6o0|b5uo0|7k800|b5uo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|bvs00|7k800|bitc0|7k800|bitc0|779c0|bitc0|779c0|bitc0|7x6o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|7x6o0|asw00|a2yo0|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9d1c0|902o0|a2yo0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|Infinity",
                offsets: "-600|-660|0",
                offsetIndices: "0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101011"
            }, {
                id: "Antarctica/Mawson",
                untils: "-8aelc0|t22y80|Infinity",
                offsets: "0|-360|-300",
                offsetIndices: "012"
            }, {
                id: "Antarctica/McMurdo",
                untils: "-m01p20|64ak0|biw40|7x5a0|asxe0|7x5a0|asxe0|7x5a0|asxe0|8a3y0|afyq0|8a3y0|afyq0|afvy0|7x820|asum0|7x820|asum0|7x820|asum0|7x820|asum0|7x820|b5ta0|7k9e0|b5ta0|7x820|hsl2m0|5reo0|clpc0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|b5uo0|8a5c0|afxc0|8a5c0|afxc0|8a5c0|afxc0|8n400|a2yo0|8n400|a2yo0|8n400|a2yo0|8n400|afxc0|8a5c0|afxc0|8a5c0|afxc0|8n400|a2yo0|8n400|a2yo0|8n400|afxc0|8a5c0|afxc0|8a5c0|afxc0|8n400|a2yo0|8n400|a2yo0|8n400|a2yo0|8n400|a2yo0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|a2yo0|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|Infinity",
                offsets: "-690|-750|-720|-780",
                offsetIndices: "01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323"
            }, {
                id: "Antarctica/Palmer",
                untils: "-2lxhc0|31ho0|bqas0|71mk0|bqas0|8ovw0|9d440|9px80|9d440|9cyk0|9d440|28t6k0|51ek0|46b6s0|8c2s0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7k580|b5xg0|9cyk0|9d440|7x3w0|asys0|7x3w0|b5xg0|7k580|9q2s0|8zzw0|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|8n180|a31g0|7x3w0|a31g0|9px80|9q2s0|7x3w0|b5xg0|7k580|b5xg0|7k580|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|8n180|a31g0|7x3w0|asys0|8zzw0|9q2s0|ast80|5eis0|cyl80|6hes0|c8nw0|6udg0|bvp80|6udg0|vonw0|4olg0|Infinity",
                offsets: "0|180|240|120",
                offsetIndices: "0121212121213121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Antarctica/Rothera",
                untils: "3lxs00|Infinity",
                offsets: "0|180",
                offsetIndices: "01"
            }, {
                id: "Antarctica/South_Pole",
                untils: "-m01p20|64ak0|biw40|7x5a0|asxe0|7x5a0|asxe0|7x5a0|asxe0|8a3y0|afyq0|8a3y0|afyq0|afvy0|7x820|asum0|7x820|asum0|7x820|asum0|7x820|asum0|7x820|b5ta0|7k9e0|b5ta0|7x820|hsl2m0|5reo0|clpc0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|b5uo0|8a5c0|afxc0|8a5c0|afxc0|8a5c0|afxc0|8n400|a2yo0|8n400|a2yo0|8n400|a2yo0|8n400|afxc0|8a5c0|afxc0|8a5c0|afxc0|8n400|a2yo0|8n400|a2yo0|8n400|afxc0|8a5c0|afxc0|8a5c0|afxc0|8n400|a2yo0|8n400|a2yo0|8n400|a2yo0|8n400|a2yo0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|a2yo0|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|Infinity",
                offsets: "-690|-750|-720|-780",
                offsetIndices: "01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323"
            }, {
                id: "Antarctica/Syowa",
                untils: "-6qsqo0|Infinity",
                offsets: "0|-180",
                offsetIndices: "01"
            }, {
                id: "Antarctica/Troll",
                untils: "ibruo0|27pg0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "0|-120",
                offsetIndices: "00101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Antarctica/Vostok",
                untils: "-6aaao0|Infinity",
                offsets: "0|-360",
                offsetIndices: "01"
            }, {
                id: "Arctic/Longyearbyen",
                untils: "-rzayo0|6qfs0|cgcqo0|15tsc0|7k800|9q000|9d1c0|9d1c0|9d1c0|9d1c0|70q5c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|b5uo0|7k800|7law00|902o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-60|-120",
                offsetIndices: "010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Asia/Aden",
                untils: "-bwgbbg|Infinity",
                offsets: "-186.8667|-180",
                offsetIndices: "01"
            }, {
                id: "Asia/Almaty",
                untils: "-nu1a90|37a0d0|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|5reo0|3ljw0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|Infinity",
                offsets: "-307.8|-300|-360|-420",
                offsetIndices: "012323232323232323232321232323232323232323232323232"
            }, {
                id: "Asia/Amman",
                untils: "-kcrtbk|m566fk|60l80|awo40|7v980|awo40|7v980|ayis0|9gnw0|9b9g0|7v980|autg0|7v980|3e6840|9et80|9io40|9cyk0|9d440|9cyk0|9d440|9px80|ayis0|7rjw0|ag040|8a2k0|9zc40|8drw0|a31g0|8zzw0|9d440|9cyk0|9d440|8n180|ag040|8a5c0|afxc0|8n400|a2yo0|8n400|a2yo0|8n400|epmo0|4deo0|9o5c0|9ew00|9b6o0|9ew00|9d1c0|9d1c0|9d1c0|asw00|7x6o0|afxc0|8n400|9d1c0|9d1c0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|wel80|51k40|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|Infinity",
                offsets: "-143.7333|-120|-180",
                offsetIndices: "0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Asia/Anadyr",
                untils: "-nu1sv8|379zj8|qi27w0|9et80|is040|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|5reo0|3ljw0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|j3440|7k800|Infinity",
                offsets: "-709.9333|-720|-780|-840|-660",
                offsetIndices: "01232121212121212121214121212121212121212121212121212121212141"
            }, {
                id: "Asia/Aqtau",
                untils: "-nu15b4|379y74|qrh3w0|iruk0|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|5reo0|3ljw0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d440|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|Infinity",
                offsets: "-201.0667|-240|-300|-360",
                offsetIndices: "012323232323232323232123232312121212121212121212"
            }, {
                id: "Asia/Aqtobe",
                untils: "-nu16l4|379zh4|qi27w0|s6qk0|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|5reo0|3ljw0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|Infinity",
                offsets: "-228.6667|-240|-300|-360",
                offsetIndices: "0123232323232323232321232323232323232323232323232"
            }, {
                id: "Asia/Ashgabat",
                untils: "-nu16t8|379zp8|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|5reo0|Infinity",
                offsets: "-233.5333|-240|-300|-360",
                offsetIndices: "0123232323232323232323212"
            }, {
                id: "Asia/Ashkhabad",
                untils: "-nu16t8|379zp8|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|5reo0|Infinity",
                offsets: "-233.5333|-240|-300|-360",
                offsetIndices: "0123232323232323232323212"
            }, {
                id: "Asia/Atyrau",
                untils: "-nu15m8|37a1a8|qrh140|iruk0|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|5reo0|3ljw0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|j3440|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|Infinity",
                offsets: "-207.7333|-180|-300|-360|-240",
                offsetIndices: "01232323232323232323242323232323232324242424242"
            }, {
                id: "Asia/Baghdad",
                untils: "-r50g80|xkn3w0|7v980|9b9g0|9gnw0|9eys0|9et80|9d440|9b9g0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9f1k0|9ew00|9ew00|9ew00|9d1c0|9ew00|9d1c0|9ew00|9d1c0|9ew00|9ew00|9ew00|9d1c0|9ew00|9d1c0|9ew00|9d1c0|9ew00|9ew00|9ew00|9d1c0|9ew00|9d1c0|9ew00|9d1c0|9ew00|9ew00|9ew00|9d1c0|9ew00|9d1c0|9ew00|9d1c0|9ew00|Infinity",
                offsets: "-177.6|-180|-240",
                offsetIndices: "012121212121212121212121212121212121212121212121212121"
            }, {
                id: "Asia/Bahrain",
                untils: "-q3gmvk|rctnrk|Infinity",
                offsets: "-206.1333|-240|-180",
                offsetIndices: "012"
            }, {
                id: "Asia/Baku",
                untils: "-nu158c|h4tkwc|ckinw0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|9d1c0|239ew0|asw00|7x3w0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-199.4|-180|-240|-300",
                offsetIndices: "01232323232323232323232123232323232323232323232323232323232323232"
            }, {
                id: "Asia/Bangkok",
                untils: "-pysda4|Infinity",
                offsets: "-402.0667|-420",
                offsetIndices: "01"
            }, {
                id: "Asia/Barnaul",
                untils: "-q4ljic|5hu6uc|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|5reo0|3ljw0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|38fo0|64og0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|1vbzw0|qnc40|Infinity",
                offsets: "-335|-360|-420|-480",
                offsetIndices: "0123232323232323232323212323232321212121212121212121212121212121212"
            }, {
                id: "Asia/Beirut",
                untils: "-pyzew0|aunw0|88dg0|9et80|8yas0|a2vw0|a31g0|7k580|hjqo40|7v980|awo40|7v980|awo40|7v980|ayis0|7v980|awo40|7v980|5lhs40|56yk0|awo40|7v980|awo40|7v980|awo40|7v980|ayis0|7v980|awo40|7v980|autg0|7v980|2wxus0|8n180|a4w40|8n180|a4w40|8n180|a4w40|8n180|bs5g0|71mk0|alk40|86d80|a4w40|8n180|a4w40|8n180|a6qs0|80t80|905g0|9cyk0|9d440|9cyk0|9d440|9cyk0|9q2s0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|b5rw0|7kas0|b5rw0|7kas0|b5rw0|7x9g0|ast80|7x9g0|ast80|7x9g0|b5rw0|7kas0|b5rw0|7kas0|b5rw0|7kas0|b5rw0|7x9g0|ast80|7x9g0|ast80|7x9g0|b5rw0|7kas0|b5rw0|7kas0|b5rw0|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|b5rw0|7kas0|b5rw0|7kas0|b5rw0|7x9g0|ast80|7x9g0|ast80|7x9g0|b5rw0|7kas0|b5rw0|7kas0|b5rw0|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|b5rw0|7kas0|b5rw0|7kas0|b5rw0|7x9g0|ast80|7x9g0|ast80|7x9g0|b5rw0|7kas0|b5rw0|7kas0|b5rw0|7kas0|b5rw0|7x9g0|ast80|7x9g0|ast80|Infinity",
                offsets: "-120|-180",
                offsetIndices: "010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Asia/Bishkek",
                untils: "-nu19tc|379zxc|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|h8dc0|bkl80|8n180|a31g0|8n180|a31g0|8n180|a31g0|8n180|a31g0|8zzw0|9db20|ast80|7x9g0|ast80|7x9g0|b5rw0|7kas0|b5rw0|7kas0|b5rw0|7x9g0|ast80|7x9g0|ast80|7x9g0|b5rw0|7kas0|Infinity",
                offsets: "-298.4|-300|-360|-420",
                offsetIndices: "012323232323232323232321212121212121212121212121212"
            }, {
                id: "Asia/Brunei",
                untils: "-mvofy4|3khxs4|Infinity",
                offsets: "-459.6667|-450|-480",
                offsetIndices: "012"
            }, {
                id: "Asia/Calcutta",
                untils: "-xehava|innm9a|bmfw0|5lxg0|1mn180|Infinity",
                offsets: "-321.1667|-330|-390",
                offsetIndices: "012121"
            }, {
                id: "Asia/Chita",
                untils: "-q4cfog|5hkxgg|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|5reo0|3ljw0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|1vbzw0|qnew0|Infinity",
                offsets: "-453.8667|-480|-540|-600",
                offsetIndices: "012323232323232323232321232323232323232323232323232323232323232312"
            }, {
                id: "Asia/Choibalsan",
                untils: "-xmct7c|11sndrc|2qk2k0|9eqg0|9eys0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9q2s0|9cyk0|9d440|9cyk0|9d440|9cyk0|1ckdo0|7x3w0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|s6qk0|3nc0c0|9ct00|9d9o0|9ct00|Infinity",
                offsets: "-458|-420|-480|-600|-540",
                offsetIndices: "0123434343434343434343434343434343434343434343424242"
            }, {
                id: "Asia/Chongqing",
                untils: "-qh00w0|8sl80|asbpg0|6w2k0|7ves0|bxjw0|4mqs0|1vduk0|d4as0|75bw0|a31g0|aaak0|9d440|7v980|awo40|1dx80|j9xpo0|6u7w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|Infinity",
                offsets: "-480|-540",
                offsetIndices: "01010101010101010101010101010"
            }, {
                id: "Asia/Chungking",
                untils: "-qh00w0|8sl80|asbpg0|6w2k0|7ves0|bxjw0|4mqs0|1vduk0|d4as0|75bw0|a31g0|aaak0|9d440|7v980|awo40|1dx80|j9xpo0|6u7w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|Infinity",
                offsets: "-480|-540",
                offsetIndices: "01010101010101010101010101010"
            }, {
                id: "Asia/Colombo",
                untils: "-xehask|isle6k|cajy0|1mp2u0|qetjw0|7x5a0|4xvqq0|Infinity",
                offsets: "-319.5333|-330|-360|-390",
                offsetIndices: "01231321"
            }, {
                id: "Asia/Dacca",
                untils: "-eqtpow|bmgyw|5lxg0|4qknw0|u4ijy0|a1400|Infinity",
                offsets: "-353.3333|-390|-330|-360|-420",
                offsetIndices: "0121343"
            }, {
                id: "Asia/Damascus",
                untils: "-q3gk20|5k6q0|8n180|a31g0|8n180|a31g0|8n180|a31g0|8zzw0|k4hk40|7yyk0|awo40|7tek0|b0dg0|7v980|awo40|7tek0|alk40|887w0|awo40|7v980|ayis0|7v980|awo40|7v980|awo40|7v980|awo40|7v980|ayis0|7v980|awo40|7v980|awo40|7v980|awo40|7v980|ayis0|7v980|awo40|6bp80|cg840|6bp80|2eh1g0|8zzw0|9ts40|8zzw0|pvk40|c33w0|7cw40|cjrw0|6zxg0|btuk0|7rpg0|9gnw0|9d440|9cyk0|9et80|9et80|9rxg0|91uk0|92040|9et80|9o840|9et80|9d440|9et80|9eys0|9et80|9b9g0|9gnw0|99es0|9iik0|9d440|9et80|9eys0|9et80|9d440|9et80|9d440|9et80|9d440|9et80|9eys0|9et80|9d440|9et80|9d440|8y580|9q2s0|b5rw0|7x9g0|aunw0|7ig40|b5rw0|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|b5rw0|7kas0|b5rw0|7kas0|b5rw0|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|b5rw0|7kas0|b5rw0|7kas0|b5rw0|7x9g0|ast80|7x9g0|ast80|7x9g0|b5rw0|7kas0|b5rw0|7kas0|b5rw0|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|b5rw0|7kas0|b5rw0|7kas0|b5rw0|7x9g0|ast80|7x9g0|ast80|7x9g0|b5rw0|7kas0|b5rw0|Infinity",
                offsets: "-145.2|-120|-180",
                offsetIndices: "01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Asia/Dhaka",
                untils: "-eqtpow|bmgyw|5lxg0|4qknw0|u4ijy0|a1400|Infinity",
                offsets: "-353.3333|-390|-330|-360|-420",
                offsetIndices: "0121343"
            }, {
                id: "Asia/Dili",
                untils: "-u9s4l8|fqcu98|hufs00|cpz440|Infinity",
                offsets: "-502.3333|-480|-540",
                offsetIndices: "01212"
            }, {
                id: "Asia/Dubai",
                untils: "-q3gnko|Infinity",
                offsets: "-221.2|-240",
                offsetIndices: "01"
            }, {
                id: "Asia/Dushanbe",
                untils: "-nu18qo|379yuo|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|hp440|Infinity",
                offsets: "-275.2|-300|-360|-420",
                offsetIndices: "012323232323232323232321"
            }, {
                id: "Asia/Famagusta",
                untils: "-p4bqac|rvhy2c|9cyk0|b42s0|7nuk0|8yas0|8zzw0|9q2s0|9et80|9b9g0|9cyk0|9q2s0|8zzw0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9q2s0|9cyk0|9d440|9cyk0|9d440|at4c0|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|8h8w0|leog0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-135.8|-120|-180",
                offsetIndices: "0121212121212121212121212121212121212121212121212121212121212121212121212121212121212212121212121212121212121212121212121212121"
            }, {
                id: "Asia/Gaza",
                untils: "-ffv9k0|19f3w0|7rv00|b02c0|7tk40|b07w0|8jhg0|a8lg0|8jhg0|a8ac0|5hoqs0|7el80|awo40|7v980|awqw0|7tk40|b07w0|7tk40|ayd80|7tk40|ayd80|7tk40|ayd80|7tk40|b07w0|7tk40|ayd80|7tk40|ayd80|7ves0|awik0|1sns0|3p6is0|51ek0|9q2s0|6u7w0|2khpg0|25s00|1weyo0|5reo0|bxmo0|7x3w0|cls40|5rbw0|bbhg0|7rjw0|asys0|7k580|c8tg0|6h980|ag040|7x3w0|asys0|8a2k0|asys0|8a2k0|ap9g0|80t80|ap9g0|7nuk0|b2840|80t80|66as0|4vxc0|8n400|a2yo0|8n400|a2yo0|8n400|asw00|9cyk0|9q2s0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|8n400|a2yo0|8ulg0|97ek0|8y580|9ts40|8hms0|a4qk0|7x3w0|asys0|8a5c0|ahs1o|71mic|bzk5o|69uic|cg840|902o0|9q000|9cyk0|9d440|ast80|7z440|aqyk0|7z6w0|b5rw0|7kas0|b5rw0|7kas0|b5rw0|7vc00|auqo0|7vc00|b7pc0|7idc0|b7pc0|7idc0|b7pc0|7vc00|auqo0|7vc00|auqo0|7vc00|auqo0|7vc00|b7pc0|7idc0|b7pc0|7vc00|auqo0|7vc00|auqo0|7vc00|auqo0|7vc00|auqo0|7vc00|b7pc0|7idc0|b7pc0|7vc00|auqo0|7vc00|auqo0|7vc00|auqo0|7vc00|b7pc0|Infinity",
                offsets: "-120|-180",
                offsetIndices: "0101010101010101010101010101010101010101010101010101010101010100101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Asia/Harbin",
                untils: "-qh00w0|8sl80|asbpg0|6w2k0|7ves0|bxjw0|4mqs0|1vduk0|d4as0|75bw0|a31g0|aaak0|9d440|7v980|awo40|1dx80|j9xpo0|6u7w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|Infinity",
                offsets: "-480|-540",
                offsetIndices: "01010101010101010101010101010"
            }, {
                id: "Asia/Hebron",
                untils: "-ffv9k0|19f3w0|7rv00|b02c0|7tk40|b07w0|8jhg0|a8lg0|8jhg0|a8ac0|5hoqs0|7el80|awo40|7v980|awqw0|7tk40|b07w0|7tk40|ayd80|7tk40|ayd80|7tk40|ayd80|7tk40|b07w0|7tk40|ayd80|7tk40|ayd80|7ves0|awik0|1sns0|3p6is0|51ek0|9q2s0|6u7w0|2khpg0|25s00|1weyo0|5reo0|bxmo0|7x3w0|cls40|5rbw0|bbhg0|7rjw0|asys0|7k580|c8tg0|6h980|ag040|7x3w0|asys0|8a2k0|asys0|8a2k0|ap9g0|80t80|ap9g0|7nuk0|b2840|80t80|66as0|4vxc0|8n400|a2yo0|8n400|a2yo0|8n400|asw00|9cyk0|9q2s0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|8n400|a2yo0|8ulg0|97ek0|8y580|9ts40|8hms0|a4qk0|82nw0|anes0|8a5c0|afxc0|73h80|bzk5o|69uic|1hs40|1lbw0|9d440|902o0|9q000|9cyk0|9d440|ast80|7z440|aqyk0|7z6w0|b5rw0|7kas0|b5rw0|7kas0|b5rw0|7vc00|auqo0|7vc00|b7pc0|7idc0|b7pc0|7idc0|b7pc0|7vc00|auqo0|7vc00|auqo0|7vc00|auqo0|7vc00|b7pc0|7idc0|b7pc0|7vc00|auqo0|7vc00|auqo0|7vc00|auqo0|7vc00|auqo0|7vc00|b7pc0|7idc0|b7pc0|7vc00|auqo0|7vc00|auqo0|7vc00|auqo0|7vc00|b7pc0|Infinity",
                offsets: "-120|-180",
                offsetIndices: "010101010101010101010101010101010101010101010101010101010101010010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Asia/Ho_Chi_Minh",
                untils: "-x56934|2isioa|gj25iu|15ct80|8so00|tmtk0|4azjw0|2cmao0|8285c0|Infinity",
                offsets: "-426.6667|-426.5|-420|-480|-540",
                offsetIndices: "0123423232"
            }, {
                id: "Asia/Hong_Kong",
                untils: "-y0i0s0|j44dk0|5k000|4d4y0|2195i0|7x3w0|bj320|6uao0|bvs00|7x6o0|9d1c0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|8a5c0|asw00|7x6o0|ast80|77c40|biqk0|77c40|bvp80|6udg0|bvp80|77c40|biqk0|77c40|biqk0|77c40|biqk0|77c40|bvp80|6udg0|bvp80|6udg0|bvp80|77c40|biqk0|77c40|biqk0|8n6s0|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|3lpg0|f4d80|9d440|9cyk0|9d440|9cyk0|1c9440|8a2k0|Infinity",
                offsets: "-456.7|-480|-540|-510",
                offsetIndices: "0123212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Asia/Hovd",
                untils: "-xmcoz0|11sncb0|2qk2k0|9et80|9eys0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9q2s0|9cyk0|9d440|9cyk0|9d440|9cyk0|1ckdo0|7x3w0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|4fio40|9ct00|9d9o0|9ct00|Infinity",
                offsets: "-366.6|-360|-420|-480",
                offsetIndices: "012323232323232323232323232323232323232323232323232"
            }, {
                id: "Asia/Irkutsk",
                untils: "-q28gn5|5fh175|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|5reo0|3ljw0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|1vbzw0|Infinity",
                offsets: "-417.0833|-420|-480|-540",
                offsetIndices: "01232323232323232323232123232323232323232323232323232323232323232"
            }, {
                id: "Asia/Istanbul",
                untils: "-ux9xew|2wvx6w|7v980|1tjc40|aunw0|88dg0|9et80|8yas0|a2vw0|tzpg0|79180|awo40|7v980|7p4040|4zjw0|2vs40|f4d80|9vms0|1u5ek0|c5440|69uk0|acas0|8n180|a31g0|8n180|9q2s0|8zzw0|a31g0|8zzw0|a31g0|8n180|5md9g0|o9zw0|a6qs0|75bw0|4iwyw0|7x6o0|7kas0|b5rw0|75hg0|bkl80|77c40|biqk0|7x9g0|a2vw0|8n6s0|4iqc0|2nkw80|38l80|kdes0|8qtc0|8a5c0|9ew00|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|902o0|9q000|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7kdk0|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7m2o0|b4000|7k800|b5uo0|7x6o0|asw00|7z1c0|ar1c0|7x6o0|bitc0|779c0|8fe80|Infinity",
                offsets: "-116.9333|-120|-180|-240",
                offsetIndices: "0121212121212121212121212121212121212121212121223212121212121212121212121212121212121212121212121212121212121212122"
            }, {
                id: "Asia/Jakarta",
                untils: "-o0bdpc|4lzxc0|4wdzjc|1tu960|1cx860|11jta0|74uc20|Infinity",
                offsets: "-427.2|-440|-450|-540|-480|-420",
                offsetIndices: "01232425"
            }, {
                id: "Asia/Jayapura",
                untils: "-jebm20|66bqe0|a37vy0|Infinity",
                offsets: "-562.8|-540|-570",
                offsetIndices: "0121"
            }, {
                id: "Asia/Jerusalem",
                untils: "-r50eig|bp54yg|19f3w0|7rv00|b02c0|7tk40|b07w0|8jhg0|a8lg0|8jhg0|a8ac0|t9s40|56vs0|35700|9b3w0|9gtg0|8jbw0|7tmw0|a6ig0|biyw0|8a5c0|9d1c0|902o0|7x6o0|e1eg0|4ofw0|dzxo0|4q500|doo40|64iw0|auqo0|7i500|8rfms0|51ek0|9q2s0|6u7w0|2khpg0|25s00|1weyo0|5reo0|bxmo0|7x3w0|cls40|5rbw0|bbhg0|7rjw0|asys0|7k580|c8tg0|6h980|ag040|7x3w0|asys0|8a2k0|asys0|8a2k0|ap9g0|80t80|ap9g0|7nuk0|b2840|80t80|9zc40|9iik0|9kis0|93p80|9mdg0|8qqk0|apf00|7x3w0|biw40|8zx40|9io40|8n180|9kis0|9vh80|8ulg0|9px80|9mdg0|8n180|9tuw0|9tmk0|8wg40|9gnw0|99es0|8qqk0|9zc40|9tmk0|8wg40|9gnw0|99es0|8qqk0|acas0|9gnw0|99es0|93p80|9mdg0|awik0|7tk40|awik0|7tk40|awik0|7tk40|b9h80|7glg0|b9h80|7glg0|b9h80|7tk40|awik0|7tk40|awik0|7tk40|b9h80|7glg0|b9h80|7glg0|b9h80|7tk40|awik0|7tk40|awik0|7tk40|awik0|7tk40|b9h80|7glg0|b9h80|7glg0|b9h80|7tk40|awik0|7tk40|awik0|7tk40|b9h80|7glg0|b9h80|7glg0|b9h80|7glg0|b9h80|7tk40|awik0|7tk40|awik0|Infinity",
                offsets: "-140.6667|-120|-180|-240",
                offsetIndices: "012121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Asia/Kabul",
                untils: "-d1pkg0|Infinity",
                offsets: "-240|-270",
                offsetIndices: "01"
            }, {
                id: "Asia/Kamchatka",
                untils: "-olrupo|3z045o|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|5reo0|3ljw0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|j3440|7k800|Infinity",
                offsets: "-634.6|-660|-720|-780",
                offsetIndices: "012323232323232323232321232323232323232323232323232323232323212"
            }, {
                id: "Asia/Karachi",
                untils: "-wvpb30|im3zt0|1mn180|33xpg0|a63o20|g72qo0|9cyk0|2y85g0|7v980|8hms0|aaak0|Infinity",
                offsets: "-268.2|-330|-390|-300|-360",
                offsetIndices: "012133434343"
            }, {
                id: "Asia/Kashgar",
                untils: "-lx5pjw|Infinity",
                offsets: "-350.3333|-360",
                offsetIndices: "01"
            }, {
                id: "Asia/Kathmandu",
                untils: "-q3gt4s|yg2lus|Infinity",
                offsets: "-341.2667|-330|-345",
                offsetIndices: "012"
            }, {
                id: "Asia/Katmandu",
                untils: "-q3gt4s|yg2lus|Infinity",
                offsets: "-341.2667|-330|-345",
                offsetIndices: "012"
            }, {
                id: "Asia/Khandyga",
                untils: "-q4cjrp|5hl1jp|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|5reo0|3ljw0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|3fx40|4h6s0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|8ql00|1mlho0|Infinity",
                offsets: "-542.2167|-480|-540|-600|-660",
                offsetIndices: "0123232323232323232323212323232323232323232323232343434343434343432"
            }, {
                id: "Asia/Kolkata",
                untils: "-xehava|innm9a|bmfw0|5lxg0|1mn180|Infinity",
                offsets: "-321.1667|-330|-390",
                offsetIndices: "012121"
            }, {
                id: "Asia/Krasnoyarsk",
                untils: "-q37l72|5gg8j2|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|5reo0|3ljw0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|1vbzw0|Infinity",
                offsets: "-371.4333|-360|-420|-480",
                offsetIndices: "01232323232323232323232123232323232323232323232323232323232323232"
            }, {
                id: "Asia/Kuala_Lumpur",
                untils: "-xphpwd|eeb94d|4it32o|8n3jc|1v2p60|iy3o60|Infinity",
                offsets: "-415.4167|-420|-440|-450|-540|-480",
                offsetIndices: "0123435"
            }, {
                id: "Asia/Kuching",
                untils: "-mvof3k|3khwxk|1epvy0|4ohqo|e5a9c|4ohqo|e3flc|4ohqo|e3flc|4ohqo|e3flc|4ohqo|e5a9c|4ohqo|e3flc|4ohqo|3ajlc|1v2qk0|Infinity",
                offsets: "-441.3333|-450|-480|-500|-540",
                offsetIndices: "0123232323232323242"
            }, {
                id: "Asia/Kuwait",
                untils: "-bwgbbg|Infinity",
                offsets: "-186.8667|-180",
                offsetIndices: "01"
            }, {
                id: "Asia/Macao",
                untils: "-y0i2cy|jdvyoy|6onw0|ac580|8fs40|7v980|11luw0|awlc0|7vc00|ac800|bko00|7x6o0|9d1c0|7vc00|asw00|7x6o0|asw00|7x6o0|auqo0|88ao0|asw00|7x6o0|asw00|779c0|bitc0|779c0|bvs00|6uao0|bw1q0|77c40|biqk0|77c40|biqk0|77c40|biqk0|77c40|bvp80|6udg0|bvp80|6udg0|bvp80|77c40|biqk0|77c40|biqk0|8n6s0|9cvs0|9d6w0|9cvs0|9d6w0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|3lpg0|f4d80|9d440|9cyk0|9d440|9cyk0|1c9440|8a2k0|Infinity",
                offsets: "-454.1667|-480|-540|-600",
                offsetIndices: "012323212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Asia/Macau",
                untils: "-y0i2cy|jdvyoy|6onw0|ac580|8fs40|7v980|11luw0|awlc0|7vc00|ac800|bko00|7x6o0|9d1c0|7vc00|asw00|7x6o0|asw00|7x6o0|auqo0|88ao0|asw00|7x6o0|asw00|779c0|bitc0|779c0|bvs00|6uao0|bw1q0|77c40|biqk0|77c40|biqk0|77c40|biqk0|77c40|bvp80|6udg0|bvp80|6udg0|bvp80|77c40|biqk0|77c40|biqk0|8n6s0|9cvs0|9d6w0|9cvs0|9d6w0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|3lpg0|f4d80|9d440|9cyk0|9d440|9cyk0|1c9440|8a2k0|Infinity",
                offsets: "-454.1667|-480|-540|-600",
                offsetIndices: "012323212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Asia/Magadan",
                untils: "-nu1nxc|37a05c|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|5reo0|3ljw0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|1vbzw0|s39k0|Infinity",
                offsets: "-603.2|-600|-660|-720",
                offsetIndices: "012323232323232323232321232323232323232323232323232323232323232312"
            }, {
                id: "Asia/Makassar",
                untils: "-q3gzg0|6p5hc0|4u87w0|1w02k0|Infinity",
                offsets: "-477.6|-480|-540",
                offsetIndices: "00121"
            }, {
                id: "Asia/Manila",
                untils: "-hb5y80|4qak0|2qidg0|1b2d80|4xf440|442k0|cdqdg0|9et80|Infinity",
                offsets: "-480|-540",
                offsetIndices: "010101010"
            }, {
                id: "Asia/Muscat",
                untils: "-q3gnko|Infinity",
                offsets: "-221.2|-240",
                offsetIndices: "01"
            }, {
                id: "Asia/Nicosia",
                untils: "-p4bq6g|rvhxyg|9cyk0|b42s0|7nuk0|8yas0|8zzw0|9q2s0|9et80|9b9g0|9cyk0|9q2s0|8zzw0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9q2s0|9cyk0|9d440|9cyk0|9d440|at4c0|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-133.4667|-120|-180",
                offsetIndices: "01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Asia/Novokuznetsk",
                untils: "-nu36tc|37bu5c|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|5reo0|3ljw0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|j3440|7k800|Infinity",
                offsets: "-348.8|-360|-420|-480",
                offsetIndices: "012323232323232323232321232323232323232323232323232323232323212"
            }, {
                id: "Asia/Novosibirsk",
                untils: "-q4do0s|5hmbcs|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|5reo0|3ljw0|9d1c0|9d1c0|2vh00|6hn40|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|1vbzw0|wrpg0|Infinity",
                offsets: "-331.6667|-360|-420|-480",
                offsetIndices: "0123232323232323232323212323212121212121212121212121212121212121212"
            }, {
                id: "Asia/Omsk",
                untils: "-q5xmx6|5j6d16|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|5reo0|3ljw0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|1vbzw0|Infinity",
                offsets: "-293.5|-300|-360|-420",
                offsetIndices: "01232323232323232323232123232323232323232323232323232323232323232"
            }, {
                id: "Asia/Oral",
                untils: "-nu15ic|37a16c|qi2540|s6qk0|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|iq5g0|9d1c0|9q000|9d1c0|9d1c0|5reo0|cyo00|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|Infinity",
                offsets: "-205.4|-180|-300|-360|-240",
                offsetIndices: "01232323232323232424242424242424242424242424242"
            }, {
                id: "Asia/Phnom_Penh",
                untils: "-pysda4|Infinity",
                offsets: "-402.0667|-420",
                offsetIndices: "01"
            }, {
                id: "Asia/Pontianak",
                untils: "-w6piww|cse2o0|4tnu2w|1wkei0|1cx860|11jta0|74uc20|cixam0|Infinity",
                offsets: "-437.3333|-450|-540|-480|-420",
                offsetIndices: "001213134"
            }, {
                id: "Asia/Pyongyang",
                untils: "-w895yc|1yh10c|hk5da0|10ipmo0|1f4qo0|Infinity",
                offsets: "-503|-510|-540",
                offsetIndices: "012212"
            }, {
                id: "Asia/Qatar",
                untils: "-q3gmvk|rctnrk|Infinity",
                offsets: "-206.1333|-240|-180",
                offsetIndices: "012"
            }, {
                id: "Asia/Qostanay",
                untils: "-nu17s4|37a0o4|qi27w0|s6qk0|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|5reo0|3ljw0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|Infinity",
                offsets: "-254.4667|-240|-300|-360",
                offsetIndices: "012323232323232323232123232323232323232323232323"
            }, {
                id: "Asia/Qyzylorda",
                untils: "-nu184g|37a10g|qi27w0|s6qk0|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|ohhc0|cyo00|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|7osl00|Infinity",
                offsets: "-261.8667|-240|-300|-360",
                offsetIndices: "01232323232323232323232323232323232323232323232"
            }, {
                id: "Asia/Rangoon",
                untils: "-q3gv5b|bnjp3b|1kh520|Infinity",
                offsets: "-384.7833|-390|-540",
                offsetIndices: "0121"
            }, {
                id: "Asia/Riyadh",
                untils: "-bwgbbg|Infinity",
                offsets: "-186.8667|-180",
                offsetIndices: "01"
            }, {
                id: "Asia/Saigon",
                untils: "-x56934|2isioa|gj25iu|15ct80|8so00|tmtk0|4azjw0|2cmao0|8285c0|Infinity",
                offsets: "-426.6667|-426.5|-420|-480|-540",
                offsetIndices: "0123423232"
            }, {
                id: "Asia/Sakhalin",
                untils: "-xl87rc|kvnarc|ikvh40|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|5reo0|3ljw0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|iq5g0|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|1vbzw0|qnc40|Infinity",
                offsets: "-570.8|-540|-660|-720|-600",
                offsetIndices: "01232323232323232323232423232323232424242424242424242424242424242"
            }, {
                id: "Asia/Samarkand",
                untils: "-nu18eh|37a1ah|qi27w0|s6qk0|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|Infinity",
                offsets: "-267.8833|-240|-300|-360",
                offsetIndices: "01232323232323232323232"
            }, {
                id: "Asia/Seoul",
                untils: "-w8966g|1yh18g|hkx5a0|1faao0|5cik0|ae5g0|8a2k0|ae5g0|8bx80|c8tg0|6h980|1bj6s0|l3aq0|6j3w0|d2g40|6u7w0|b5xg0|776k0|biw40|776k0|biw40|776k0|biw40|776k0|grs40|dfqxi0|7x6o0|asw00|7x6o0|Infinity",
                offsets: "-507.8667|-510|-540|-600|-570",
                offsetIndices: "012232323232141414141414123232"
            }, {
                id: "Asia/Shanghai",
                untils: "-qh00w0|8sl80|asbpg0|6w2k0|7ves0|bxjw0|4mqs0|1vduk0|d4as0|75bw0|a31g0|aaak0|9d440|7v980|awo40|1dx80|j9xpo0|6u7w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|Infinity",
                offsets: "-480|-540",
                offsetIndices: "01010101010101010101010101010"
            }, {
                id: "Asia/Singapore",
                untils: "-xphpwd|eeb94d|4it32o|8n3jc|1v2p60|iy3o60|Infinity",
                offsets: "-415.4167|-420|-440|-450|-540|-480",
                offsetIndices: "0123435"
            }, {
                id: "Asia/Srednekolymsk",
                untils: "-nu1ogs|37a0os|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|5reo0|3ljw0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|1vbzw0|Infinity",
                offsets: "-614.8667|-600|-660|-720",
                offsetIndices: "01232323232323232323232123232323232323232323232323232323232323232"
            }, {
                id: "Asia/Taipei",
                untils: "-gtzfk0|45slc0|c51c0|75bw0|a31g0|aaak0|9d440|7v980|awo40|7v980|awo40|7v980|awo40|7v980|7tk40|clmk0|7rpg0|b07w0|7rpg0|b07w0|7rpg0|9et80|9eys0|9et80|9d440|9et80|9d440|9et80|9d440|9et80|cjxg0|69uk0|ci2s0|69uk0|6its40|9et80|9d440|9et80|1yf9g0|4qak0|Infinity",
                offsets: "-480|-540",
                offsetIndices: "01010101010101010101010101010101010101010"
            }, {
                id: "Asia/Tashkent",
                untils: "-nu18tz|379yxz|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|Infinity",
                offsets: "-277.1833|-300|-360|-420",
                offsetIndices: "012323232323232323232321"
            }, {
                id: "Asia/Tbilisi",
                untils: "-nu14an|h4tjyn|ckinw0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|9cvs0|9cyk0|9d440|9cyk0|9d440|ipzw0|9cyk0|9q2s0|tivw0|7x9g0|ast80|7x9g0|b5rw0|7kas0|b5rw0|7kas0|b5rw0|7x9g0|ast80|7x9g0|ast80|7x9g0|4ofw0|6hn40|7k800|Infinity",
                offsets: "-179.1833|-180|-240|-300",
                offsetIndices: "0123232323232323232323212121232323232323232323212"
            }, {
                id: "Asia/Tehran",
                untils: "-s6m6uw|fnolc0|gm3h4w|777y0|b07w0|3pes0|42c20|9cyk0|9gtg0|9kd80|5ja5g0|7avw0|9d440|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9d440|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9d440|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9d440|9gnw0|1av440|9gnw0|9d440|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9d440|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9d440|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9d440|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9d440|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9d440|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9d440|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|Infinity",
                offsets: "-205.7333|-210|-240|-300|-270",
                offsetIndices: "00123214141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141"
            }, {
                id: "Asia/Tel_Aviv",
                untils: "-r50eig|bp54yg|19f3w0|7rv00|b02c0|7tk40|b07w0|8jhg0|a8lg0|8jhg0|a8ac0|t9s40|56vs0|35700|9b3w0|9gtg0|8jbw0|7tmw0|a6ig0|biyw0|8a5c0|9d1c0|902o0|7x6o0|e1eg0|4ofw0|dzxo0|4q500|doo40|64iw0|auqo0|7i500|8rfms0|51ek0|9q2s0|6u7w0|2khpg0|25s00|1weyo0|5reo0|bxmo0|7x3w0|cls40|5rbw0|bbhg0|7rjw0|asys0|7k580|c8tg0|6h980|ag040|7x3w0|asys0|8a2k0|asys0|8a2k0|ap9g0|80t80|ap9g0|7nuk0|b2840|80t80|9zc40|9iik0|9kis0|93p80|9mdg0|8qqk0|apf00|7x3w0|biw40|8zx40|9io40|8n180|9kis0|9vh80|8ulg0|9px80|9mdg0|8n180|9tuw0|9tmk0|8wg40|9gnw0|99es0|8qqk0|9zc40|9tmk0|8wg40|9gnw0|99es0|8qqk0|acas0|9gnw0|99es0|93p80|9mdg0|awik0|7tk40|awik0|7tk40|awik0|7tk40|b9h80|7glg0|b9h80|7glg0|b9h80|7tk40|awik0|7tk40|awik0|7tk40|b9h80|7glg0|b9h80|7glg0|b9h80|7tk40|awik0|7tk40|awik0|7tk40|awik0|7tk40|b9h80|7glg0|b9h80|7glg0|b9h80|7tk40|awik0|7tk40|awik0|7tk40|b9h80|7glg0|b9h80|7glg0|b9h80|7glg0|b9h80|7tk40|awik0|7tk40|awik0|Infinity",
                offsets: "-140.6667|-120|-180|-240",
                offsetIndices: "012121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Asia/Thimbu",
                untils: "-bojclo|kxymno|Infinity",
                offsets: "-358.6|-330|-360",
                offsetIndices: "012"
            }, {
                id: "Asia/Thimphu",
                untils: "-bojclo|kxymno|Infinity",
                offsets: "-358.6|-330|-360",
                offsetIndices: "012"
            }, {
                id: "Asia/Tokyo",
                untils: "-bb4900|6uao0|afxc0|8a5c0|c8qo0|6hc00|c8qo0|6hc00|Infinity",
                offsets: "-540|-600",
                offsetIndices: "010101010"
            }, {
                id: "Asia/Tomsk",
                untils: "-q3zbqf|5h7z2f|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|5reo0|3ljw0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|1leo0|97k40|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|1vbzw0|tw040|Infinity",
                offsets: "-339.85|-360|-420|-480",
                offsetIndices: "0123232323232323232323212323232323232323232323212121212121212121212"
            }, {
                id: "Asia/Ujung_Pandang",
                untils: "-q3gzg0|6p5hc0|4u87w0|1w02k0|Infinity",
                offsets: "-477.6|-480|-540",
                offsetIndices: "00121"
            }, {
                id: "Asia/Ulaanbaatar",
                untils: "-xmcrsk|11sncck|2qk2k0|9et80|9eys0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9q2s0|9cyk0|9d440|9cyk0|9d440|9cyk0|1ckdo0|7x3w0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|4fio40|9ct00|9d9o0|9ct00|Infinity",
                offsets: "-427.5333|-420|-480|-540",
                offsetIndices: "012323232323232323232323232323232323232323232323232"
            }, {
                id: "Asia/Ulan_Bator",
                untils: "-xmcrsk|11sncck|2qk2k0|9et80|9eys0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9q2s0|9cyk0|9d440|9cyk0|9d440|9cyk0|1ckdo0|7x3w0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|4fio40|9ct00|9d9o0|9ct00|Infinity",
                offsets: "-427.5333|-420|-480|-540",
                offsetIndices: "012323232323232323232323232323232323232323232323232"
            }, {
                id: "Asia/Urumqi",
                untils: "-lx5pjw|Infinity",
                offsets: "-350.3333|-360",
                offsetIndices: "01"
            }, {
                id: "Asia/Ust-Nera",
                untils: "-q4cl6u|5hl2yu|qi27w0|9eno0|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|5reo0|3ljw0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|8ql00|1mlho0|Infinity",
                offsets: "-572.9|-480|-540|-720|-660|-600",
                offsetIndices: "012343434343434343434345434343434343434343434343434343434343434345"
            }, {
                id: "Asia/Vientiane",
                untils: "-pysda4|Infinity",
                offsets: "-402.0667|-420",
                offsetIndices: "01"
            }, {
                id: "Asia/Vladivostok",
                untils: "-oligf7|3yqvf7|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|5reo0|3ljw0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|1vbzw0|Infinity",
                offsets: "-527.5167|-540|-600|-660",
                offsetIndices: "01232323232323232323232123232323232323232323232323232323232323232"
            }, {
                id: "Asia/Yakutsk",
                untils: "-q4cioy|5hl0gy|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|5reo0|3ljw0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|1vbzw0|Infinity",
                offsets: "-518.9667|-480|-540|-600",
                offsetIndices: "01232323232323232323232123232323232323232323232323232323232323232"
            }, {
                id: "Asia/Yangon",
                untils: "-q3gv5b|bnjp3b|1kh520|Infinity",
                offsets: "-384.7833|-390|-540",
                offsetIndices: "0121"
            }, {
                id: "Asia/Yekaterinburg",
                untils: "-rx5hw9|1kybx4|5pfyv5|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|5reo0|3ljw0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|1vbzw0|Infinity",
                offsets: "-242.55|-225.0833|-240|-300|-360",
                offsetIndices: "012343434343434343434343234343434343434343434343434343434343434343"
            }, {
                id: "Asia/Yerevan",
                untils: "-nu148o|h4tjwo|ckinw0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|iq5g0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|11t180|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|Infinity",
                offsets: "-178|-180|-240|-300",
                offsetIndices: "0123232323232323232323212121212323232323232323232323232323232"
            }, {
                id: "Atlantic/Azores",
                untils: "-u9rbs0|2bufw0|6zxg0|66580|bq800|73k00|bodc0|71pc0|bq800|73k00|bq800|71pc0|bq800|1b2g00|9b6o0|saio0|8n400|9q000|902o0|a2yo0|902o0|a2yo0|8n400|st1c0|8n400|9d1c0|9d1c0|sg2o0|9d1c0|902o0|9q000|a2yo0|8n400|9d1c0|9d1c0|902o0|9q000|a2yo0|b5uo0|51hc0|bitc0|9d1c0|9ew00|88ao0|25p80|5reo0|3lpg0|779c0|1sqk0|6uao0|38qs0|6uao0|25p80|6hc00|38qs0|6uao0|25p80|6hc00|38qs0|8a5c0|9d1c0|9d9o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|s3400|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|5qbjo0|9d1c0|9q000|9d1c0|9d1c0|9d440|9cyk0|9d440|9d1c0|9d1c0|9d1c0|9d1c0|9d440|9cyk0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9cyk0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "114.5333|120|60|0",
                offsetIndices: "01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323233323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232"
            }, {
                id: "Atlantic/Bermuda",
                untils: "-kvj2fu|n4pr3u|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "259.3|240|180",
                offsetIndices: "0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Atlantic/Canary",
                untils: "-oytbtc|ctvupc|hhq7s0|905g0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "61.6|60|0|-60",
                offsetIndices: "01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232"
            }, {
                id: "Atlantic/Cape_Verde",
                untils: "-u9rbs0|g06lc0|1mn180|fpqwc0|Infinity",
                offsets: "94.0667|120|60",
                offsetIndices: "01212"
            }, {
                id: "Atlantic/Faeroe",
                untils: "-wcehew|127keuw|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "27.0667|0|-60",
                offsetIndices: "01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Atlantic/Faroe",
                untils: "-wcehew|127keuw|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "27.0667|0|-60",
                offsetIndices: "01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Atlantic/Jan_Mayen",
                untils: "-rzayo0|6qfs0|cgcqo0|15tsc0|7k800|9q000|9d1c0|9d1c0|9d1c0|9d1c0|70q5c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|b5uo0|7k800|7law00|902o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-60|-120",
                offsetIndices: "010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Atlantic/Madeira",
                untils: "-u9rek0|2bufw0|6zxg0|66580|bq800|73k00|bodc0|71pc0|bq800|73k00|bq800|71pc0|bq800|1b2g00|9b6o0|saio0|8n400|9q000|902o0|a2yo0|902o0|a2yo0|8n400|st1c0|8n400|9d1c0|9d1c0|sg2o0|9d1c0|902o0|9q000|a2yo0|8n400|9d1c0|9d1c0|902o0|9q000|a2yo0|b5uo0|51hc0|bitc0|9d1c0|9ew00|88ao0|25p80|5reo0|3lpg0|779c0|1sqk0|6uao0|38qs0|6uao0|25p80|6hc00|38qs0|6uao0|25p80|6hc00|38qs0|8a5c0|9d1c0|9d9o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|s3400|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|5qbjo0|9d1c0|9q000|9d1c0|9d1c0|9d440|9cyk0|9d440|9d1c0|9d1c0|9d1c0|9d1c0|9d440|9cyk0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "67.6|60|0|-60",
                offsetIndices: "01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232"
            }, {
                id: "Atlantic/Reykjavik",
                untils: "-wcwx9c|4rpd9c|ci2s0|69uk0|du840|4xp80|du840|p7bw0|4w040|9bdzw0|9d6w0|64g40|cyl80|64dc0|clpc0|6hc00|bvs00|6uao0|bvs00|6uao0|bvs00|6uao0|c8qo0|6hc00|c8qo0|8a5c0|afxc0|8a5c0|afxc0|8a5c0|asw00|7x6o0|afxc0|8a5c0|asw00|8a5c0|afxc0|8a5c0|afxc0|8a5c0|afxc0|8a5c0|afxc0|8a5c0|asw00|8a5c0|afxc0|8a5c0|afxc0|8a5c0|afxc0|8a5c0|afxc0|8a5c0|afxc0|8a5c0|asw00|8a5c0|afxc0|8a5c0|afxc0|8a5c0|afxc0|8a5c0|afxc0|8a5c0|asw00|8a5c0|Infinity",
                offsets: "88|60|0",
                offsetIndices: "012121212121212121212121212121212121212121212121212121212121212121212"
            }, {
                id: "Atlantic/South_Georgia",
                untils: "Infinity",
                offsets: "120",
                offsetIndices: "0"
            }, {
                id: "Atlantic/St_Helena",
                untils: "-u9rgl4|Infinity",
                offsets: "16.1333|0",
                offsetIndices: "01"
            }, {
                id: "Atlantic/Stanley",
                untils: "-u63pac|dbvxqc|8zzw0|9q2s0|8zzw0|a31g0|8zzw0|9q2s0|8zzw0|9q2s0|8zzw0|9q2s0|4xp80|l1pus0|7k580|b5rw0|77c40|biqk0|id6s0|7kas0|b5rw0|7kas0|b5rw0|7kas0|b5rw0|7kas0|biqk0|77c40|biqk0|7kas0|b5rw0|7kas0|b5rw0|7kas0|b5rw0|7kas0|b5rw0|7kas0|biqk0|7kas0|b5rw0|7kas0|b5rw0|7kas0|b5rw0|7kas0|b5rw0|7kas0|b5xg0|77c40|bvp80|6udg0|bvp80|77c40|biqk0|77c40|biqk0|77c40|biqk0|77c40|biqk0|77c40|bvp80|77c40|biqk0|77c40|biqk0|77c40|Infinity",
                offsets: "231.4|240|180|120",
                offsetIndices: "012121212121212323212121212121212121212121212121212121212121212121212"
            }, {
                id: "Australia/ACT",
                untils: "-rnsx2c|49s2c|cxfms0|4h180|9d440|9cyk0|9q2s0|8zzw0|eeiqs0|64dc0|clpc0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|8a5c0|asw00|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|779c0|b5uo0|7k800|bitc0|7k800|bitc0|779c0|bitc0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|7x6o0|asw00|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7k800|b5uo0|8a5c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|Infinity",
                offsets: "-600|-660",
                offsetIndices: "0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101"
            }, {
                id: "Australia/Adelaide",
                untils: "-rnsvoc|49s2c|cxfms0|4h180|9d440|9cyk0|9q2s0|8zzw0|eeiqs0|64dc0|clpc0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|779c0|b5uo0|7k800|bitc0|7k800|bitc0|779c0|bitc0|779c0|bitc0|6hc00|c8qo0|7k800|b5uo0|6uao0|c8qo0|779c0|bitc0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7k800|b5uo0|8a5c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|Infinity",
                offsets: "-570|-630",
                offsetIndices: "0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101"
            }, {
                id: "Australia/Brisbane",
                untils: "-rnsx2c|49s2c|cxfms0|4h180|9d440|9cyk0|9q2s0|8zzw0|eeiqs0|64dc0|97zuo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|Infinity",
                offsets: "-600|-660",
                offsetIndices: "01010101010101010"
            }, {
                id: "Australia/Broken_Hill",
                untils: "-rnsvoc|49s2c|cxfms0|4h180|9d440|9cyk0|9q2s0|8zzw0|eeiqs0|64dc0|clpc0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|8a5c0|asw00|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|779c0|b5uo0|7k800|bitc0|7k800|bitc0|779c0|bitc0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7k800|b5uo0|8a5c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|Infinity",
                offsets: "-570|-630",
                offsetIndices: "0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101"
            }, {
                id: "Australia/Canberra",
                untils: "-rnsx2c|49s2c|cxfms0|4h180|9d440|9cyk0|9q2s0|8zzw0|eeiqs0|64dc0|clpc0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|8a5c0|asw00|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|779c0|b5uo0|7k800|bitc0|7k800|bitc0|779c0|bitc0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|7x6o0|asw00|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7k800|b5uo0|8a5c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|Infinity",
                offsets: "-600|-660",
                offsetIndices: "0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101"
            }, {
                id: "Australia/Currie",
                untils: "-rsj4w0|8zzw0|cxfms0|4h180|9d440|9cyk0|9q2s0|8zzw0|eeiqs0|64dc0|clpc0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|7x6o0|b5uo0|7k800|b5uo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|bvs00|7k800|bitc0|7k800|bitc0|779c0|bitc0|779c0|bitc0|7x6o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|7x6o0|asw00|a2yo0|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9d1c0|902o0|a2yo0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|Infinity",
                offsets: "-600|-660",
                offsetIndices: "0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101"
            }, {
                id: "Australia/Darwin",
                untils: "-rnsvoc|49s2c|cxfms0|4h180|9d440|9cyk0|9q2s0|8zzw0|Infinity",
                offsets: "-570|-630",
                offsetIndices: "010101010"
            }, {
                id: "Australia/Eucla",
                untils: "-rnstlc|49s2c|cxfms0|4h180|9d440|9cyk0|ghf1g0|6hc00|4ir9c0|6hc00|40r400|5eg00|7p9hc0|5reo0|b5uo0|7x6o0|asw00|7x6o0|Infinity",
                offsets: "-525|-585",
                offsetIndices: "0101010101010101010"
            }, {
                id: "Australia/Hobart",
                untils: "-rsj4w0|8zzw0|cxfms0|4h180|9d440|9cyk0|9q2s0|8zzw0|c9tms0|9d1c0|asw00|6uao0|bvs00|6uao0|bvs00|779c0|bvs00|64dc0|clpc0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|7x6o0|b5uo0|7k800|b5uo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|bvs00|7k800|bitc0|7k800|bitc0|779c0|bitc0|779c0|bitc0|7x6o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|7x6o0|asw00|a2yo0|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9d1c0|902o0|a2yo0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|Infinity",
                offsets: "-600|-660",
                offsetIndices: "010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101"
            }, {
                id: "Australia/LHI",
                untils: "5tp880|c8uu0|6u7w0|c8tg0|6h980|c8tg0|6h980|c8tg0|6h980|c8tg0|777y0|b5w20|7k6m0|biuq0|7k6m0|biuq0|777y0|biuq0|6ham0|c8s20|6ham0|c8s20|6ham0|c8s20|6u9a0|c8s20|6ham0|c8s20|6ham0|c8s20|7x5a0|asxe0|7x5a0|asxe0|7x5a0|asxe0|7x5a0|b5w20|7k6m0|7x820|asum0|b5w20|7x5a0|asxe0|7x5a0|asxe0|7x5a0|b5w20|7k6m0|b5w20|7x5a0|asxe0|7k6m0|b5w20|8a3y0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9q1e0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9q1e0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9pym0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9q1e0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9q1e0|9czy0|9d2q0|9czy0|9d2q0|Infinity",
                offsets: "-600|-630|-690|-660",
                offsetIndices: "0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313"
            }, {
                id: "Australia/Lindeman",
                untils: "-rnsx2c|49s2c|cxfms0|4h180|9d440|9cyk0|9q2s0|8zzw0|eeiqs0|64dc0|97zuo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|Infinity",
                offsets: "-600|-660",
                offsetIndices: "010101010101010101010"
            }, {
                id: "Australia/Lord_Howe",
                untils: "5tp880|c8uu0|6u7w0|c8tg0|6h980|c8tg0|6h980|c8tg0|6h980|c8tg0|777y0|b5w20|7k6m0|biuq0|7k6m0|biuq0|777y0|biuq0|6ham0|c8s20|6ham0|c8s20|6ham0|c8s20|6u9a0|c8s20|6ham0|c8s20|6ham0|c8s20|7x5a0|asxe0|7x5a0|asxe0|7x5a0|asxe0|7x5a0|b5w20|7k6m0|7x820|asum0|b5w20|7x5a0|asxe0|7x5a0|asxe0|7x5a0|b5w20|7k6m0|b5w20|7x5a0|asxe0|7k6m0|b5w20|8a3y0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9q1e0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9q1e0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9pym0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9q1e0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9d2q0|9czy0|9q1e0|9czy0|9d2q0|9czy0|9d2q0|Infinity",
                offsets: "-600|-630|-690|-660",
                offsetIndices: "0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313"
            }, {
                id: "Australia/Melbourne",
                untils: "-rnsx2c|49s2c|cxfms0|4h180|9d440|9cyk0|9q2s0|8zzw0|eeiqs0|64dc0|clpc0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|779c0|b5uo0|7k800|b5uo0|7x6o0|bitc0|779c0|bitc0|779c0|bitc0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|7x6o0|asw00|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7k800|b5uo0|8a5c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|Infinity",
                offsets: "-600|-660",
                offsetIndices: "0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101"
            }, {
                id: "Australia/North",
                untils: "-rnsvoc|49s2c|cxfms0|4h180|9d440|9cyk0|9q2s0|8zzw0|Infinity",
                offsets: "-570|-630",
                offsetIndices: "010101010"
            }, {
                id: "Australia/NSW",
                untils: "-rnsx2c|49s2c|cxfms0|4h180|9d440|9cyk0|9q2s0|8zzw0|eeiqs0|64dc0|clpc0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|8a5c0|asw00|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|779c0|b5uo0|7k800|bitc0|7k800|bitc0|779c0|bitc0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|7x6o0|asw00|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7k800|b5uo0|8a5c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|Infinity",
                offsets: "-600|-660",
                offsetIndices: "0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101"
            }, {
                id: "Australia/Perth",
                untils: "-rnsric|49s2c|cxfms0|4h180|9d440|9cyk0|ghf1g0|6hc00|4ir9c0|6hc00|40r400|5eg00|7p9hc0|5reo0|b5uo0|7x6o0|asw00|7x6o0|Infinity",
                offsets: "-480|-540",
                offsetIndices: "0101010101010101010"
            }, {
                id: "Australia/Queensland",
                untils: "-rnsx2c|49s2c|cxfms0|4h180|9d440|9cyk0|9q2s0|8zzw0|eeiqs0|64dc0|97zuo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|Infinity",
                offsets: "-600|-660",
                offsetIndices: "01010101010101010"
            }, {
                id: "Australia/South",
                untils: "-rnsvoc|49s2c|cxfms0|4h180|9d440|9cyk0|9q2s0|8zzw0|eeiqs0|64dc0|clpc0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|779c0|b5uo0|7k800|bitc0|7k800|bitc0|779c0|bitc0|779c0|bitc0|6hc00|c8qo0|7k800|b5uo0|6uao0|c8qo0|779c0|bitc0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7k800|b5uo0|8a5c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|Infinity",
                offsets: "-570|-630",
                offsetIndices: "0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101"
            }, {
                id: "Australia/Sydney",
                untils: "-rnsx2c|49s2c|cxfms0|4h180|9d440|9cyk0|9q2s0|8zzw0|eeiqs0|64dc0|clpc0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|8a5c0|asw00|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|779c0|b5uo0|7k800|bitc0|7k800|bitc0|779c0|bitc0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|7x6o0|asw00|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7k800|b5uo0|8a5c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|Infinity",
                offsets: "-600|-660",
                offsetIndices: "0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101"
            }, {
                id: "Australia/Tasmania",
                untils: "-rsj4w0|8zzw0|cxfms0|4h180|9d440|9cyk0|9q2s0|8zzw0|c9tms0|9d1c0|asw00|6uao0|bvs00|6uao0|bvs00|779c0|bvs00|64dc0|clpc0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|7x6o0|b5uo0|7k800|b5uo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|bvs00|7k800|bitc0|7k800|bitc0|779c0|bitc0|779c0|bitc0|7x6o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|7x6o0|asw00|a2yo0|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9d1c0|902o0|a2yo0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|Infinity",
                offsets: "-600|-660",
                offsetIndices: "010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101"
            }, {
                id: "Australia/Victoria",
                untils: "-rnsx2c|49s2c|cxfms0|4h180|9d440|9cyk0|9q2s0|8zzw0|eeiqs0|64dc0|clpc0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|779c0|b5uo0|7k800|b5uo0|7x6o0|bitc0|779c0|bitc0|779c0|bitc0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|7x6o0|asw00|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7k800|b5uo0|8a5c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|Infinity",
                offsets: "-600|-660",
                offsetIndices: "0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101"
            }, {
                id: "Australia/West",
                untils: "-rnsric|49s2c|cxfms0|4h180|9d440|9cyk0|ghf1g0|6hc00|4ir9c0|6hc00|40r400|5eg00|7p9hc0|5reo0|b5uo0|7x6o0|asw00|7x6o0|Infinity",
                offsets: "-480|-540",
                offsetIndices: "0101010101010101010"
            }, {
                id: "Australia/Yancowinna",
                untils: "-rnsvoc|49s2c|cxfms0|4h180|9d440|9cyk0|9q2s0|8zzw0|eeiqs0|64dc0|clpc0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|8a5c0|asw00|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|779c0|b5uo0|7k800|bitc0|7k800|bitc0|779c0|bitc0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7k800|b5uo0|8a5c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|Infinity",
                offsets: "-570|-630",
                offsetIndices: "0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101"
            }, {
                id: "Brazil/Acre",
                untils: "-t85fg0|99kak0|9a9c0|9io40|99980|8p65g0|6zuo0|bs2o0|67zw0|cjxg0|69uk0|cjxg0|4ml80|5mf440|49mk0|haas0|316k0|cls40|4ml80|cls40|66580|cls40|67zw0|981s40|6u7w0|biw40|5rbw0|d0lg0|5ed80|amves0|2t2t80|Infinity",
                offsets: "271.2|300|240",
                offsetIndices: "01212121212121212121212121212121"
            }, {
                id: "Brazil/DeNoronha",
                untils: "-t85lzw|99k8rw|9a9c0|9io40|99980|8p65g0|6zuo0|bs2o0|67zw0|cjxg0|69uk0|cjxg0|4ml80|5mf440|49mk0|haas0|316k0|cls40|4ml80|cls40|66580|cls40|67zw0|981s40|6u7w0|biw40|5rbw0|d0lg0|5ed80|cyqs0|5ed80|dbpg0|64ak0|514g40|7k580|biw40|cvw0|iq5g0|6h980|Infinity",
                offsets: "129.6667|120|60",
                offsetIndices: "0121212121212121212121212121212121212121"
            }, {
                id: "Brazil/East",
                untils: "-t85jd8|99k8x8|9a9c0|9io40|99980|8p65g0|6zuo0|bs2o0|67zw0|cjxg0|69uk0|cjxg0|4ml80|5k02s0|6onw0|haas0|316k0|cls40|4ml80|cls40|66580|cls40|67zw0|981s40|6u7w0|biw40|5rbw0|d0lg0|5ed80|cyqs0|5ed80|dbpg0|64ak0|cyqs0|64ak0|cls40|5rbw0|dbpg0|51ek0|dbpg0|6h980|c8tg0|6h980|c8tg0|64ak0|c8tg0|6u7w0|bxpg0|7iak0|biw40|6u7w0|biw40|7k580|biw40|6u7w0|c8tg0|6h980|dbpg0|5ed80|cls40|64ak0|dfes0|5nmk0|c8tg0|6h980|dbpg0|5rbw0|bvus0|6h980|cls40|64ak0|cls40|6h980|c8tg0|6h980|c8tg0|6u7w0|c8tg0|64ak0|cls40|64ak0|cls40|6h980|c8tg0|6h980|c8tg0|6h980|c8tg0|6h980|dbpg0|5ed80|Infinity",
                offsets: "186.4667|180|120",
                offsetIndices: "01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Brazil/West",
                untils: "-t85gvw|99k97w|9a9c0|9io40|99980|8p65g0|6zuo0|bs2o0|67zw0|cjxg0|69uk0|cjxg0|4ml80|5mf440|49mk0|haas0|316k0|cls40|4ml80|cls40|66580|cls40|67zw0|981s40|6u7w0|biw40|5rbw0|d0lg0|5ed80|2yy2s0|6h980|Infinity",
                offsets: "240.0667|240|180",
                offsetIndices: "01212121212121212121212121212121"
            }, {
                id: "Canada/Atlantic",
                untils: "-z94k80|777go0|9et80|st9o0|a2vw0|ssyk0|5rbw0|cv1g0|69uk0|c6ys0|6kyk0|ci2s0|67zw0|ci2s0|6w2k0|bu040|7lzw0|bu040|66580|bu040|7lzw0|bu040|64ak0|cls40|5v180|cv1g0|6j3w0|c6ys0|79180|b42s0|7lzw0|b42s0|7yyk0|bu040|64ak0|dbpg0|66580|cls40|5ed80|bu040|7lzw0|b42s0|7lzw0|cjxg0|66580|bh1g0|7lzw0|b42s0|7lzw0|6uj00|1tzdw0|2dnc0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|tw040|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|tw040|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|1cm2s0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "254.4|240|180",
                offsetIndices: "0121212121212121212121212121212121212121212121212122121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Canada/Central",
                untils: "-s0s7c0|7k580|tj700|a2vw0|9ok840|6u7w0|2a5hg0|1tz8c0|2dsw0|biw40|7x3w0|a31g0|7x3w0|asys0|7x3w0|asys0|7x3w0|b7s40|7tek0|autg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|9cyk0|9d440|7x3w0|1cm2s0|7k580|1cm2s0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|902o0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|902o0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|8a5c0|afxc0|8a5c0|asw00|7x6o0|asw00|7x6o0|asw00|8a5c0|afxc0|8a5c0|afxc0|8a5c0|asw00|7x6o0|asw00|7x6o0|asw00|8a5c0|afxc0|8a5c0|afxc0|8a5c0|afxc0|8a5c0|asw00|7x6o0|asw00|7x6o0|asw00|8a5c0|afxc0|8a5c0|afxc0|8a5c0|asw00|7x6o0|asw00|7x6o0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "360|300",
                offsetIndices: "010101011010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Canada/Eastern",
                untils: "-qzoxw0|a2vw0|7yx60|aqzy0|9q8c0|7jzo0|bw0c0|6bp80|cedg0|6h980|c8tg0|6h980|bvus0|776k0|biw40|776k0|biw40|776k0|biw40|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|xjeo0|1tzb40|2dq40|asys0|7x3w0|ast80|7x3w0|asys0|7x3w0|asys0|b5rw0|7xf00|ast80|7x9g0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7x3w0|asys0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "300|240",
                offsetIndices: "01010101010101010101010101010101010101010101011101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Canada/Mountain",
                untils: "-x1yazk|629ink|a2vw0|8n6s0|29ek0|h6lg0|9px80|905g0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|9l0g40|1tz5k0|2dvo0|tj1g0|7x3w0|ctzk40|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "453.8667|420|360",
                offsetIndices: "0121212121212122121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Canada/Newfoundland",
                untils: "-ris3ck|8bx80|ar440|a2vw0|9tjs0|53980|dkys0|9cyk0|9d440|9cyk0|9q2s0|8zzw0|9q2s0|8zzw0|9q2s0|8zzw0|9q2s0|8zzw0|9q2s0|9cyk0|9d440|9cyk0|9q2s0|8zzw0|9q2s0|8zzw0|9q2s0|8zzw0|9q2s0|8zzw0|9q2s0|9cyk0|9q2s0|8zzw0|9q2s0|8zzw0|7tmw0|1wfuk|8zzw0|a3480|7k580|b5xg0|7k580|b5xg0|7k580|biw40|776k0|biw40|7k580|b5xg0|7k580|b5xg0|1pb260|2dly0|biw40|7k580|b5xg0|7k580|b5xg0|7k580|b5xg0|7k580|biw40|7k580|ag040|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a2lo|afuk0|8a840|asqg0|7xc80|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8tec|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "210.8667|150.8667|210|150|90",
                offsetIndices: "01010101010101010101010101010101010102323232323232323323232323232323232323232323232323232323232323232323232323232323232323232323232323232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232"
            }, {
                id: "Canada/Pacific",
                untils: "-qzopk0|a2vw0|c5jxg0|1tz2s0|2dyg0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "480|420",
                offsetIndices: "0101101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Canada/Saskatchewan",
                untils: "-xkq9yc|6l1hmc|a2vw0|60enw0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|1b6840|9cyk0|9d440|8zzw0|9q2s0|9cyk0|9q2s0|9cyk0|9d440|9cyk0|66gc0|1tz5k0|2dvo0|a31g0|9cyk0|a31g0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7x3w0|asys0|7x3w0|tj1g0|9cyk0|9d440|Infinity",
                offsets: "418.6|420|360",
                offsetIndices: "012121212121212121212121221212121212121212121212121212"
            }, {
                id: "Canada/Yukon",
                untils: "-qzoms0|a2vw0|asys0|882c0|bmiwc0|1tz000|2e180|a7n3w0|9q000|tiyo0|6qp440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|Infinity",
                offsets: "540|480|420",
                offsetIndices: "01010110201212121212121212121212121212121212121212121212121212121212121212121212121212121212"
            }, {
                id: "CET",
                untils: "-s0e080|7ves0|a4yw0|7x6o0|asw00|7x6o0|b8qdc0|1cm000|7k800|9q000|9d1c0|9d1c0|9d1c0|8l9c0|ggp1c0|902o0|9q000|9d1c0|9d1c0|9d1c0|9q000|902o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-60|-120",
                offsetIndices: "01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Chile/Continental",
                untils: "-vauawq|3dlssq|157b7a|f4e0q|49hzba|aye0q|7ves0|awik0|7ves0|awik0|7ves0|awik0|7ves0|ayd80|7ves0|534ik0|351g0|229zw0|2gt80|awo40|2mg00|b73400|7k580|c8tg0|6h980|a31g0|7x3w0|asys0|7x3w0|b5xg0|7k580|ag040|8a2k0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7k580|b5xg0|9cyk0|9d440|7x3w0|asys0|7x3w0|b5xg0|7k580|9q2s0|8zzw0|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|8n180|a31g0|7x3w0|a31g0|9px80|9q2s0|7x3w0|b5xg0|7k580|b5xg0|7k580|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|8n180|a31g0|7x3w0|asys0|8zzw0|9q2s0|ast80|5eis0|cyl80|6hes0|c8nw0|6udg0|bvp80|6udg0|vonw0|4olg0|e1h80|4olg0|e1h80|4olg0|c8nw0|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|b5rw0|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|b5rw0|7kas0|b5rw0|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|b5rw0|7kas0|b5rw0|7x9g0|ast80|7x9g0|Infinity",
                offsets: "282.7667|300|240|180",
                offsetIndices: "010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323"
            }, {
                id: "Chile/EasterIsland",
                untils: "-jhfaew|ivmeuw|7k580|c8tg0|6h980|a31g0|7x3w0|asys0|7x3w0|b5xg0|7k580|ag040|8a2k0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7k580|b5xg0|7x3w0|asys0|iq2o0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7k580|b5xg0|9cyk0|9d440|7x3w0|asys0|7x3w0|b5xg0|7k580|9q2s0|8zzw0|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|8n180|a31g0|7x3w0|a31g0|9px80|9q2s0|7x3w0|b5xg0|7k580|b5xg0|7k580|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|8n180|a31g0|7x3w0|asys0|8zzw0|9q2s0|ast80|5eis0|cyl80|6hes0|c8nw0|6udg0|bvp80|6udg0|vonw0|4olg0|e1h80|4olg0|e1h80|4olg0|c8nw0|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|b5rw0|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|b5rw0|7kas0|b5rw0|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|b5rw0|7kas0|b5rw0|7x9g0|ast80|7x9g0|Infinity",
                offsets: "437.4667|420|360|300",
                offsetIndices: "012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323"
            }, {
                id: "CST6CDT",
                untils: "-r0esg0|ast80|7x9g0|ast80|bmtus0|1tz8c0|2dsw0|b9gdg0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "360|300",
                offsetIndices: "010101101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Cuba",
                untils: "-n7762o|1icfyo|69uk0|62s040|4ofw0|e1ms0|51ek0|e1ms0|4ofw0|1fhs40|4ofw0|e1ms0|4ofw0|9s9k40|67zw0|cedg0|6h980|9o840|7yyk0|b5xg0|7k580|bvus0|9cyk0|9d440|9cyk0|9d440|9px80|9d440|8a2k0|ag040|8bx80|ae5g0|8drw0|acas0|9cyk0|9d440|9px80|905g0|9px80|9q2s0|7x3w0|8a840|ast80|7x9g0|ast80|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|8a2k0|ag040|8a2k0|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|905g0|a2vw0|905g0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9d1c0|9d1c0|9q000|8n400|asw00|7x6o0|b5uo0|7x6o0|asw00|7x6o0|asw00|8a5c0|afxc0|8a5c0|afxc0|7x6o0|1cm000|6uao0|bvs00|779c0|bitc0|6uao0|bvs00|779c0|bvs00|779c0|c8qo0|779c0|b5uo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|Infinity",
                offsets: "329.6|300|240",
                offsetIndices: "012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "EET",
                untils: "3s9ms0|902o0|9q000|9d1c0|9d1c0|9d1c0|9q000|902o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-120|-180",
                offsetIndices: "010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Egypt",
                untils: "-fdls80|40d80|a31g0|7x3w0|a4w40|aqyk0|80ys0|b07w0|7tk40|b07w0|8jhg0|a8fw0|60go40|7el80|awo40|7v980|awqw0|7tk40|b07w0|7tk40|ayd80|7tk40|ayd80|7tk40|ayd80|7tk40|b07w0|7tk40|ayd80|7tk40|ayd80|7ves0|awik0|7ves0|ayd80|7ves0|awik0|7ves0|awik0|7ves0|awik0|7ves0|ayd80|7ves0|awik0|7ves0|awik0|7ves0|awik0|7ves0|ayd80|7ves0|awik0|7ves0|awik0|7ves0|awik0|7ves0|ayd80|7ves0|awik0|7ves0|f9x80|3i040|eluk0|462s0|ayd80|7ves0|awik0|7ves0|awik0|7ves0|awik0|7ves0|ayd80|7ves0|b5rw0|7m5g0|awik0|7ves0|awik0|7ves0|ayd80|7ves0|awik0|7ves0|awik0|7ves0|aqvs0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7x3w0|asys0|7x3w0|asys0|7k580|b5xg0|6u7w0|bvus0|6h980|c8tg0|64ak0|cyqs0|5anw0|1jms0|12t80|1w22s0|25p80|1sw40|2vmk0|Infinity",
                offsets: "-120|-180",
                offsetIndices: "0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Eire",
                untils: "-rzcmlr|6uao0|9pytr|8c000|9o5c0|9ruo0|9b6o0|9ew00|9b6o0|auqo0|88ao0|9ew00|8y800|a2yo0|a2yo0|7k800|asw00|8a5c0|asw00|8n400|a2yo0|8n400|9q000|902o0|afxc0|8n400|a2yo0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|9d1c0|a2yo0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|902o0|a2yo0|b5uo0|51hc0|3g8800|8a5c0|bvs00|8n400|a2yo0|7x6o0|asw00|8n400|9q000|902o0|9q000|9d1c0|9q000|902o0|8n400|9q000|902o0|a2yo0|8n400|afxc0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|902o0|902o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|bitc0|5reo0|1xhuo0|779c0|bitc0|779c0|bitc0|779c0|bitc0|779c0|bitc0|7k800|b5uo0|7k800|b5uo0|7k800|bitc0|779c0|bitc0|779c0|bitc0|7x3w0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|8a5c0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "25.35|-34.65|0|-60",
                offsetIndices: "01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232"
            }, {
                id: "EST",
                untils: "Infinity",
                offsets: "300",
                offsetIndices: "0"
            }, {
                id: "EST5EDT",
                untils: "-r0ev80|ast80|7x9g0|ast80|bmtus0|1tzb40|2dq40|b9gdg0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "300|240",
                offsetIndices: "010101101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Etc/GMT-0",
                untils: "Infinity",
                offsets: "0",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT-1",
                untils: "Infinity",
                offsets: "-60",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT-10",
                untils: "Infinity",
                offsets: "-600",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT-11",
                untils: "Infinity",
                offsets: "-660",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT-12",
                untils: "Infinity",
                offsets: "-720",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT-13",
                untils: "Infinity",
                offsets: "-780",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT-14",
                untils: "Infinity",
                offsets: "-840",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT-2",
                untils: "Infinity",
                offsets: "-120",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT-3",
                untils: "Infinity",
                offsets: "-180",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT-4",
                untils: "Infinity",
                offsets: "-240",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT-5",
                untils: "Infinity",
                offsets: "-300",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT-6",
                untils: "Infinity",
                offsets: "-360",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT-7",
                untils: "Infinity",
                offsets: "-420",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT-8",
                untils: "Infinity",
                offsets: "-480",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT-9",
                untils: "Infinity",
                offsets: "-540",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT",
                untils: "Infinity",
                offsets: "0",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT+0",
                untils: "Infinity",
                offsets: "0",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT+1",
                untils: "Infinity",
                offsets: "60",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT+10",
                untils: "Infinity",
                offsets: "600",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT+11",
                untils: "Infinity",
                offsets: "660",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT+12",
                untils: "Infinity",
                offsets: "720",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT+2",
                untils: "Infinity",
                offsets: "120",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT+3",
                untils: "Infinity",
                offsets: "180",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT+4",
                untils: "Infinity",
                offsets: "240",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT+5",
                untils: "Infinity",
                offsets: "300",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT+6",
                untils: "Infinity",
                offsets: "360",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT+7",
                untils: "Infinity",
                offsets: "420",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT+8",
                untils: "Infinity",
                offsets: "480",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT+9",
                untils: "Infinity",
                offsets: "540",
                offsetIndices: "0"
            }, {
                id: "Etc/GMT0",
                untils: "Infinity",
                offsets: "0",
                offsetIndices: "0"
            }, {
                id: "Etc/Greenwich",
                untils: "Infinity",
                offsets: "0",
                offsetIndices: "0"
            }, {
                id: "Etc/UCT",
                untils: "Infinity",
                offsets: "0",
                offsetIndices: "0"
            }, {
                id: "Etc/Universal",
                untils: "Infinity",
                offsets: "0",
                offsetIndices: "0"
            }, {
                id: "Etc/UTC",
                untils: "Infinity",
                offsets: "0",
                offsetIndices: "0"
            }, {
                id: "Etc/Zulu",
                untils: "Infinity",
                offsets: "0",
                offsetIndices: "0"
            }, {
                id: "Europe/Amsterdam",
                untils: "-s0dvkk|7v980|a51o0|7x6o0|a2yo0|9d1c0|9q000|902o0|9q000|902o0|9q000|902o0|9b6o0|a2yo0|c51c0|6l1c0|902o0|9q000|ci000|682o0|bgyo0|79400|bitc0|779c0|bmio0|7gio0|bbeo0|7eo00|bd9c0|7ctc0|bf400|7ayo0|bvs00|6uao0|bko00|7idc0|b9k00|7gio0|bbeo0|7eo00|bf400|7ayo0|btxc0|21uc0|4uaz8|bitc0|779c0|bko00|7idc0|bd3s0|1aarpc|7k800|9q000|9d1c0|9d1c0|9d1c0|8l9c0|ggp1c0|902o0|9q000|9d1c0|9d1c0|9d1c0|9q000|902o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-19.5333|-79.5333|-80|-20|-120|-60",
                offsetIndices: "010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545"
            }, {
                id: "Europe/Andorra",
                untils: "-c4xmo0|k3ctg0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "0|-60|-120",
                offsetIndices: "012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Europe/Astrakhan",
                untils: "-nu2zkc|37bv8c|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|iq5g0|9d1c0|9q000|9d1c0|s3400|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|1vbzw0|qnc40|Infinity",
                offsets: "-192.2|-180|-240|-300",
                offsetIndices: "012323232323232323212121212121212121212121212121212121212121212"
            }, {
                id: "Europe/Athens",
                untils: "-rvv0cg|8bjasg|2vmk0|4hiw40|16ik0|scog0|7lx40|9o2k0|9eys0|4atzw0|6djw0|bplus0|bq800|71uw0|9d1c0|902o0|91xc0|9o5c0|905g0|9qgo0|9akg0|9iik0|99980|9dcg0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-94.8667|-120|-180|-60",
                offsetIndices: "012121313121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Europe/Belfast",
                untils: "-rzcns0|6uao0|9q000|8c000|9o5c0|9ruo0|9b6o0|9ew00|9b6o0|auqo0|88ao0|9ew00|8y800|a2yo0|a2yo0|7k800|asw00|8a5c0|asw00|8n400|a2yo0|8n400|9q000|902o0|afxc0|8n400|a2yo0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|9d1c0|a2yo0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|902o0|a2yo0|b5uo0|51hc0|mbmk0|51hc0|c8qo0|6hc00|c8qo0|6uao0|bvs00|8n400|a4tc0|5clc0|4bms0|9q000|902o0|8a5c0|1frw0|64dc0|4bms0|6uao0|bvs00|7x6o0|asw00|8n400|9q000|902o0|9q000|9d1c0|9q000|902o0|8n400|9q000|902o0|a2yo0|8n400|afxc0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|902o0|902o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|bitc0|5reo0|1xhuo0|779c0|bitc0|779c0|bitc0|779c0|bitc0|779c0|bitc0|7k800|b5uo0|7k800|b5uo0|7k800|bitc0|779c0|bitc0|779c0|bitc0|7x3w0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|8a5c0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "0|-60|-120",
                offsetIndices: "0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Europe/Belgrade",
                untils: "-ezayw0|swz00|7k800|9q000|9d1c0|9d1c0|b7pc0|6qlc0|jl1hc0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-60|-120",
                offsetIndices: "01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Europe/Berlin",
                untils: "-s0e080|7ves0|a4yw0|7x6o0|asw00|7x6o0|b8qdc0|1cm000|7k800|9q000|9d1c0|9d1c0|9d1c0|2o7w0|6bs00|2txg0|7k800|91xc0|9b9g0|1sqk0|2inw0|51k40|a2yo0|8n400|9q000|902o0|fx91c0|902o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-60|-120|-180",
                offsetIndices: "01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Europe/Bratislava",
                untils: "-s0e080|7ves0|a4yw0|7x6o0|asw00|7x6o0|b8qdc0|1cm000|7k800|9q000|9d1c0|9d1c0|9d1c0|9d1c0|b5uo0|7vc00|2vs40|4bk00|2vmk0|8n400|a2yo0|8n400|9o5c0|91xc0|fe6000|9d1c0|9q000|902o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-60|-120|0",
                offsetIndices: "01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Europe/Brussels",
                untils: "-ss5uo0|rrx80|7vc00|a4yw0|7x6o0|asw00|7x6o0|2wh40|5omo0|b5uo0|6uao0|cyo00|7ayo0|bko00|7rmo0|a2yo0|a2yo0|8n400|902o0|9q000|9d1c0|9d1c0|a2yo0|8n400|9q000|902o0|a2yo0|90b00|a2yo0|8n400|9q000|902o0|a2yo0|8n400|9d1c0|9d1c0|902o0|a2yo0|9d1c0|9d1c0|902o0|9q000|a2yo0|8n400|9d1c0|9d1c0|902o0|9q000|a2yo0|b5uo0|51hc0|4deo0|1a36k0|7k800|9q000|9d1c0|8l9c0|a4tc0|8l9c0|clpc0|79400|fwu800|902o0|9q000|9d1c0|9d1c0|9d1c0|9q000|902o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "0|-60|-120",
                offsetIndices: "0121212101010101010101010101010101010101010101010101212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Europe/Bucharest",
                untils: "-k29zi0|fj8m0|6w5c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|kp0dc0|6h980|9q000|905g0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9cvs0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9cyk0|9d440|9cyk0|9q2s0|ast80|7xhs0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-104.4|-120|-180",
                offsetIndices: "0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Europe/Budapest",
                untils: "-s0e080|7ves0|a4yw0|7x6o0|a31g0|8n180|autg0|bgvw0|b5jeg0|th9k0|7k800|9q000|9d1c0|9d1c0|awd00|9ew00|7q0c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9q000|902o0|a4tc0|9q000|1va2g0|6u7w0|bxpg0|6u7w0|cjxg0|64ak0|cluw0|64g40|br3ek0|905g0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-60|-120",
                offsetIndices: "0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Europe/Busingen",
                untils: "-eyh6o0|7x6o0|asw00|7x6o0|k2zus0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-60|-120",
                offsetIndices: "01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Europe/Chisinau",
                untils: "-r2p1bo|70f1to|fj8m0|6w5c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|geqo0|ha580|oc8g0|7k800|9q000|9d1c0|7cl00|j3pbw0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|25p80|7kdk0|9d1c0|9d1c0|9cvs0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9q2s0|ast80|7xf00|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-115|-104.4|-120|-180|-60|-240",
                offsetIndices: "012323232323232323232424235353535353535353535323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232"
            }, {
                id: "Europe/Copenhagen",
                untils: "-rzo2w0|75bw0|cbs2w0|1aco80|7k800|9q000|9d1c0|9d1c0|9d1c0|6y000|dbmo0|6bs00|clpc0|51hc0|e1k00|4oio0|giutc0|902o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-60|-120",
                offsetIndices: "0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Europe/Dublin",
                untils: "-rzcmlr|6uao0|9pytr|8c000|9o5c0|9ruo0|9b6o0|9ew00|9b6o0|auqo0|88ao0|9ew00|8y800|a2yo0|a2yo0|7k800|asw00|8a5c0|asw00|8n400|a2yo0|8n400|9q000|902o0|afxc0|8n400|a2yo0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|9d1c0|a2yo0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|902o0|a2yo0|b5uo0|51hc0|3g8800|8a5c0|bvs00|8n400|a2yo0|7x6o0|asw00|8n400|9q000|902o0|9q000|9d1c0|9q000|902o0|8n400|9q000|902o0|a2yo0|8n400|afxc0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|902o0|902o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|bitc0|5reo0|1xhuo0|779c0|bitc0|779c0|bitc0|779c0|bitc0|779c0|bitc0|7k800|b5uo0|7k800|b5uo0|7k800|bitc0|779c0|bitc0|779c0|bitc0|7x3w0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|8a5c0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "25.35|-34.65|0|-60",
                offsetIndices: "01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232"
            }, {
                id: "Europe/Gibraltar",
                untils: "-rzcns0|6uao0|9q000|8c000|9o5c0|9ruo0|9b6o0|9ew00|9b6o0|auqo0|88ao0|9ew00|8y800|a2yo0|a2yo0|7k800|asw00|8a5c0|asw00|8n400|a2yo0|8n400|9q000|902o0|afxc0|8n400|a2yo0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|9d1c0|a2yo0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|902o0|a2yo0|b5uo0|51hc0|mbmk0|51hc0|c8qo0|6hc00|c8qo0|6uao0|bvs00|8n400|a4tc0|5clc0|4bms0|9q000|902o0|8a5c0|1frw0|64dc0|4bms0|6uao0|bvs00|7x6o0|asw00|8n400|9q000|902o0|9q000|9d1c0|9q000|902o0|8n400|9q000|902o0|a2yo0|8n400|afxc0|8n400|9q000|d0tp80|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "0|-60|-120",
                offsetIndices: "010101010101010101010101010101010101010101010101012121212121010121010101010101010101012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Europe/Guernsey",
                untils: "-rzcns0|6uao0|9q000|8c000|9o5c0|9ruo0|9b6o0|9ew00|9b6o0|auqo0|88ao0|9ew00|8y800|a2yo0|a2yo0|7k800|asw00|8a5c0|asw00|8n400|a2yo0|8n400|9q000|902o0|afxc0|8n400|a2yo0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|9d1c0|a2yo0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|902o0|a2yo0|b5uo0|51hc0|mbmk0|51hc0|c8qo0|6hc00|c8qo0|6uao0|bvs00|8n400|a4tc0|5clc0|4bms0|9q000|902o0|8a5c0|1frw0|64dc0|4bms0|6uao0|bvs00|7x6o0|asw00|8n400|9q000|902o0|9q000|9d1c0|9q000|902o0|8n400|9q000|902o0|a2yo0|8n400|afxc0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|902o0|902o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|bitc0|5reo0|1xhuo0|779c0|bitc0|779c0|bitc0|779c0|bitc0|779c0|bitc0|7k800|b5uo0|7k800|b5uo0|7k800|bitc0|779c0|bitc0|779c0|bitc0|7x3w0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|8a5c0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "0|-60|-120",
                offsetIndices: "0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Europe/Helsinki",
                untils: "-peghyd|ax3tqd|9gqo0|k31s80|9d1c0|9d1c0|9d1c0|9d440|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-99.8167|-120|-180",
                offsetIndices: "0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Europe/Isle_of_Man",
                untils: "-rzcns0|6uao0|9q000|8c000|9o5c0|9ruo0|9b6o0|9ew00|9b6o0|auqo0|88ao0|9ew00|8y800|a2yo0|a2yo0|7k800|asw00|8a5c0|asw00|8n400|a2yo0|8n400|9q000|902o0|afxc0|8n400|a2yo0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|9d1c0|a2yo0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|902o0|a2yo0|b5uo0|51hc0|mbmk0|51hc0|c8qo0|6hc00|c8qo0|6uao0|bvs00|8n400|a4tc0|5clc0|4bms0|9q000|902o0|8a5c0|1frw0|64dc0|4bms0|6uao0|bvs00|7x6o0|asw00|8n400|9q000|902o0|9q000|9d1c0|9q000|902o0|8n400|9q000|902o0|a2yo0|8n400|afxc0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|902o0|902o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|bitc0|5reo0|1xhuo0|779c0|bitc0|779c0|bitc0|779c0|bitc0|779c0|bitc0|7k800|b5uo0|7k800|b5uo0|7k800|bitc0|779c0|bitc0|779c0|bitc0|7x3w0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|8a5c0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "0|-60|-120",
                offsetIndices: "0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Europe/Istanbul",
                untils: "-ux9xew|2wvx6w|7v980|1tjc40|aunw0|88dg0|9et80|8yas0|a2vw0|tzpg0|79180|awo40|7v980|7p4040|4zjw0|2vs40|f4d80|9vms0|1u5ek0|c5440|69uk0|acas0|8n180|a31g0|8n180|9q2s0|8zzw0|a31g0|8zzw0|a31g0|8n180|5md9g0|o9zw0|a6qs0|75bw0|4iwyw0|7x6o0|7kas0|b5rw0|75hg0|bkl80|77c40|biqk0|7x9g0|a2vw0|8n6s0|4iqc0|2nkw80|38l80|kdes0|8qtc0|8a5c0|9ew00|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|902o0|9q000|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7kdk0|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7m2o0|b4000|7k800|b5uo0|7x6o0|asw00|7z1c0|ar1c0|7x6o0|bitc0|779c0|8fe80|Infinity",
                offsets: "-116.9333|-120|-180|-240",
                offsetIndices: "0121212121212121212121212121212121212121212121223212121212121212121212121212121212121212121212121212121212121212122"
            }, {
                id: "Europe/Jersey",
                untils: "-rzcns0|6uao0|9q000|8c000|9o5c0|9ruo0|9b6o0|9ew00|9b6o0|auqo0|88ao0|9ew00|8y800|a2yo0|a2yo0|7k800|asw00|8a5c0|asw00|8n400|a2yo0|8n400|9q000|902o0|afxc0|8n400|a2yo0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|9d1c0|a2yo0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|902o0|a2yo0|b5uo0|51hc0|mbmk0|51hc0|c8qo0|6hc00|c8qo0|6uao0|bvs00|8n400|a4tc0|5clc0|4bms0|9q000|902o0|8a5c0|1frw0|64dc0|4bms0|6uao0|bvs00|7x6o0|asw00|8n400|9q000|902o0|9q000|9d1c0|9q000|902o0|8n400|9q000|902o0|a2yo0|8n400|afxc0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|902o0|902o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|bitc0|5reo0|1xhuo0|779c0|bitc0|779c0|bitc0|779c0|bitc0|779c0|bitc0|7k800|b5uo0|7k800|b5uo0|7k800|bitc0|779c0|bitc0|779c0|bitc0|7x3w0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|8a5c0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "0|-60|-120",
                offsetIndices: "0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Europe/Kaliningrad",
                untils: "-s0e080|7ves0|a4yw0|7x6o0|asw00|7x6o0|b8qdc0|1cm000|7k800|9q000|9d1c0|9d1c0|9d1c0|el00|z6o0|9kd80|82tg0|i9avw0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d440|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|1vbzw0|Infinity",
                offsets: "-60|-120|-180|-240",
                offsetIndices: "01010101010101121232323232323232322121212121212121212121212121212121212121212121"
            }, {
                id: "Europe/Kiev",
                untils: "-nu11ng|37a03g|5vd6k0|kzv40|7k800|9q000|1oyg0|jipzs0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|51ek0|neqw0|9cvs0|9cyk0|9d440|9cyk0|9d440|9cyk0|9dcg0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-122.0667|-120|-180|-60|-240",
                offsetIndices: "0121313242424242424242424242121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Europe/Kirov",
                untils: "-qcx400|5q5zo0|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|iq5g0|9d1c0|9q000|9d1c0|s3400|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|1vbzw0|Infinity",
                offsets: "-198.8|-180|-240|-300",
                offsetIndices: "01232323232323232321212121212121212121212121212121212121212121"
            }, {
                id: "Europe/Lisbon",
                untils: "-u9rhc0|2bufw0|6zxg0|66580|bq800|73k00|bodc0|71pc0|bq800|73k00|bq800|71pc0|bq800|1b2g00|9b6o0|saio0|8n400|9q000|902o0|a2yo0|902o0|a2yo0|8n400|st1c0|8n400|9d1c0|9d1c0|sg2o0|9d1c0|902o0|9q000|a2yo0|8n400|9d1c0|9d1c0|902o0|9q000|a2yo0|b5uo0|51hc0|bitc0|9d1c0|9ew00|88ao0|25p80|5reo0|3lpg0|779c0|1sqk0|6uao0|38qs0|6uao0|25p80|6hc00|38qs0|6uao0|25p80|6hc00|38qs0|8a5c0|9d1c0|9d9o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|s3400|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|5gyl40|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d440|9cyk0|9d440|9d1c0|9d1c0|9d1c0|9d1c0|9d440|9cyk0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "36.75|0|-60|-120",
                offsetIndices: "012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121212121212121212121212121212121212122323232212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Europe/Ljubljana",
                untils: "-ezayw0|swz00|7k800|9q000|9d1c0|9d1c0|b7pc0|6qlc0|jl1hc0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-60|-120",
                offsetIndices: "01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Europe/London",
                untils: "-rzcns0|6uao0|9q000|8c000|9o5c0|9ruo0|9b6o0|9ew00|9b6o0|auqo0|88ao0|9ew00|8y800|a2yo0|a2yo0|7k800|asw00|8a5c0|asw00|8n400|a2yo0|8n400|9q000|902o0|afxc0|8n400|a2yo0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|9d1c0|a2yo0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|902o0|a2yo0|b5uo0|51hc0|mbmk0|51hc0|c8qo0|6hc00|c8qo0|6uao0|bvs00|8n400|a4tc0|5clc0|4bms0|9q000|902o0|8a5c0|1frw0|64dc0|4bms0|6uao0|bvs00|7x6o0|asw00|8n400|9q000|902o0|9q000|9d1c0|9q000|902o0|8n400|9q000|902o0|a2yo0|8n400|afxc0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|902o0|902o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|bitc0|5reo0|1xhuo0|779c0|bitc0|779c0|bitc0|779c0|bitc0|779c0|bitc0|7k800|b5uo0|7k800|b5uo0|7k800|bitc0|779c0|bitc0|779c0|bitc0|7x3w0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|8a5c0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "0|-60|-120",
                offsetIndices: "0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Europe/Luxembourg",
                untils: "-y89550|68l290|75hg0|ast80|796s0|at1k0|7x6o0|3lh40|4zmo0|b6300|6u2c0|cytk0|7at40|bktk0|7rh40|a31g0|a2vw0|8n9k0|8zx40|9q2s0|9et80|9b9g0|a2vw0|8n6s0|9px80|905g0|a2vw0|905g0|a2vw0|8ncc0|9q000|902o0|a2yo0|8n400|9d1c0|9d1c0|902o0|a2yo0|9d1c0|9d1c0|902o0|9q000|a2yo0|8n400|9d1c0|9d1c0|902o0|9q000|a2yo0|b5uo0|51hc0|42ao0|1aeak0|7k800|9q000|9d1c0|8n400|a2yo0|8l9c0|clpc0|79400|fwu800|902o0|9q000|9d1c0|9d1c0|9d1c0|9q000|902o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-24.6|-60|-120|0",
                offsetIndices: "0121212131313131313131313131313131313131313131313131212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Europe/Madrid",
                untils: "-qzlus0|8yas0|9cyk0|9eys0|2d2vw0|8sqs0|ssyk0|8n6s0|9px80|905g0|a2yo0|902o0|a2vw0|8n6s0|40lh80|5k2s0|9cyk0|1frw0|7z1c0|j1c80|8a2k0|13yt80|685g0|brzw0|8n6s0|a2vw0|8n6s0|a2vw0|8n6s0|a2vw0|8n6s0|1clx80|7x9g0|cswik0|905g0|9px80|905g0|8zzw0|9d440|9px80|905g0|9q5k0|9d1c0|9d1c0|9d1c0|9q000|902o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "0|-60|-120",
                offsetIndices: "010101010101010101210121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Europe/Malta",
                untils: "-rymys0|64ak0|9d440|9et80|88dg0|aunw0|7ig40|b5rw0|8n6s0|9cyk0|aau2s0|18r9k0|7k800|9q000|9b6o0|8n400|a4tc0|8j940|9f1k0|afxc0|89zs0|afxc0|7kdk0|b5uo0|979rs0|6h980|cls40|64dc0|clpc0|64dc0|cyo00|64dc0|clpc0|64dc0|c8qo0|6hc00|clpc0|6hc00|9b6o0|9d1c0|ahs00|7m2o0|b45k0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|a4w40|8y580|9q2s0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-60|-120",
                offsetIndices: "0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Europe/Mariehamn",
                untils: "-peghyd|ax3tqd|9gqo0|k31s80|9d1c0|9d1c0|9d1c0|9d440|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-99.8167|-120|-180",
                offsetIndices: "0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Europe/Minsk",
                untils: "-nu113c|379zjc|5r1mk0|pbf40|7k800|9q000|9d1c0|4oac0|j6dmk0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|sg2o0|9d440|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|Infinity",
                offsets: "-110|-120|-180|-60|-240",
                offsetIndices: "01213131242424242424242424221212121212121212121212121212121212121212"
            }, {
                id: "Europe/Monaco",
                untils: "-uozn3l|2qx1nl|5luo0|8y800|a4tc0|7vc00|auqo0|7idc0|b7pc0|6sg00|cyo00|7ayo0|bko00|7rmo0|a2yo0|bvs00|6uao0|902o0|9q000|9d1c0|9d1c0|a2yo0|8n400|9q000|902o0|a2yo0|902o0|a2yo0|8n400|9q000|902o0|a2yo0|8n400|9d1c0|9d1c0|902o0|a2yo0|9d1c0|9d1c0|902o0|9q000|a2yo0|8n400|9d1c0|9d1c0|902o0|9q000|a2yo0|b5uo0|51po0|mdbo0|7x3w0|7x9g0|c8w80|7k800|9q000|9d1c0|9nzs0|922w0|8l9c0|fxlx80|9cyk0|9q5k0|902o0|9q000|9d1c0|9d1c0|9d1c0|9q000|902o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-9.35|0|-60|-120",
                offsetIndices: "01212121212121212121212121212121212121212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232"
            }, {
                id: "Europe/Moscow",
                untils: "-rx5dmh|ipzua|97hc0|7yyk0|5i840|d9p80|1jwk7|2cvk0|s8o00|1qvw0|8fpc0|1jms0|is040|412as0|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d440|5reo0|3ljw0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|1vbzw0|Infinity",
                offsets: "-150.2833|-151.3167|-211.3167|-271.3167|-240|-180|-300|-120",
                offsetIndices: "012132345464575454545454545454545455754545454545454545454545454545454545454545"
            }, {
                id: "Europe/Nicosia",
                untils: "-p4bq6g|rvhxyg|9cyk0|b42s0|7nuk0|8yas0|8zzw0|9q2s0|9et80|9b9g0|9cyk0|9q2s0|8zzw0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9q2s0|9cyk0|9d440|9cyk0|9d440|at4c0|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-133.4667|-120|-180",
                offsetIndices: "01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Europe/Oslo",
                untils: "-rzayo0|6qfs0|cgcqo0|15tsc0|7k800|9q000|9d1c0|9d1c0|9d1c0|9d1c0|70q5c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|b5uo0|7k800|7law00|902o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-60|-120",
                offsetIndices: "010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Europe/Paris",
                untils: "-uozn1x|2qx1lx|5luo0|8y800|a4tc0|7vc00|auqo0|7idc0|b7pc0|6sg00|cyo00|7ayo0|bko00|7rmo0|a2yo0|bvs00|6uao0|902o0|9q000|9d1c0|9d1c0|a2yo0|8n400|9q000|902o0|a2yo0|902o0|a2yo0|8n400|9q000|902o0|a2yo0|8n400|9d1c0|9d1c0|902o0|a2yo0|9d1c0|9d1c0|902o0|9q000|a2yo0|8n400|9d1c0|9d1c0|902o0|9q000|a2yo0|b5uo0|51po0|5p8w0|18rcc0|7k800|9q000|9d1c0|7efo0|29k40|922w0|8l9c0|fxlx80|9cyk0|9q5k0|902o0|9q000|9d1c0|9d1c0|9d1c0|9q000|902o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-9.35|0|-60|-120",
                offsetIndices: "0121212121212121212121212121212121212121212121212123232332323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232"
            }, {
                id: "Europe/Podgorica",
                untils: "-ezayw0|swz00|7k800|9q000|9d1c0|9d1c0|b7pc0|6qlc0|jl1hc0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-60|-120",
                offsetIndices: "01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Europe/Prague",
                untils: "-s0e080|7ves0|a4yw0|7x6o0|asw00|7x6o0|b8qdc0|1cm000|7k800|9q000|9d1c0|9d1c0|9d1c0|9d1c0|b5uo0|7vc00|2vs40|4bk00|2vmk0|8n400|a2yo0|8n400|9o5c0|91xc0|fe6000|9d1c0|9q000|902o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-60|-120|0",
                offsetIndices: "01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Europe/Riga",
                untils: "-qznlky|7x6o0|a4tc0|2mg00|3myns0|7fhlky|gz180|p5v40|7k800|9q000|9d1c0|9d1c0|k7s0|j14ns0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d440|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d440|asw00|7x6o0|asw00|7x6o0|b5uo0|qaao0|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-96.5667|-156.5667|-120|-180|-60|-240",
                offsetIndices: "010102324242435353535353535353323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232"
            }, {
                id: "Europe/Rome",
                untils: "-rymys0|64ak0|9d440|9et80|88dg0|aunw0|7ig40|b5rw0|8n6s0|9cyk0|aau2s0|18r9k0|7k800|9q000|9d1c0|8l9c0|a4tc0|8j940|9f1k0|afxc0|89zs0|afxc0|7kdk0|b5uo0|979rs0|6h980|cls40|64dc0|clpc0|64dc0|cyo00|64dc0|clpc0|64dc0|c8qo0|6hc00|clpc0|6hc00|clpc0|64dc0|c8qo0|6hc00|clpc0|64dc0|clpc0|64dc0|c8qo0|6hc00|clpc0|6hc00|c8qo0|6hc00|9q5k0|902o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-60|-120",
                offsetIndices: "0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Europe/Samara",
                untils: "-qcx400|5q5zo0|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|iq5g0|9d1c0|9q000|jt1g0|89zs0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|j3440|7k800|Infinity",
                offsets: "-200.3333|-180|-240|-300",
                offsetIndices: "0123232323232323232121232323232323232323232323232323232323212"
            }, {
                id: "Europe/San_Marino",
                untils: "-rymys0|64ak0|9d440|9et80|88dg0|aunw0|7ig40|b5rw0|8n6s0|9cyk0|aau2s0|18r9k0|7k800|9q000|9d1c0|8l9c0|a4tc0|8j940|9f1k0|afxc0|89zs0|afxc0|7kdk0|b5uo0|979rs0|6h980|cls40|64dc0|clpc0|64dc0|cyo00|64dc0|clpc0|64dc0|c8qo0|6hc00|clpc0|6hc00|clpc0|64dc0|c8qo0|6hc00|clpc0|64dc0|clpc0|64dc0|c8qo0|6hc00|clpc0|6hc00|c8qo0|6hc00|9q5k0|902o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-60|-120",
                offsetIndices: "0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Europe/Sarajevo",
                untils: "-ezayw0|swz00|7k800|9q000|9d1c0|9d1c0|b7pc0|6qlc0|jl1hc0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-60|-120",
                offsetIndices: "01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Europe/Saratov",
                untils: "-qcx400|5q5zo0|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|iq5g0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|s3400|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|1vbzw0|13m040|Infinity",
                offsets: "-184.3|-180|-240|-300",
                offsetIndices: "012323232323232321212121212121212121212121212121212121212121212"
            }, {
                id: "Europe/Simferopol",
                untils: "-nu12ao|37a0qo|5xiyk0|iu340|7k800|9q000|9d1c0|iac0|jajmk0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|eeio0|wrjw0|9cyk0|9d440|9cyk0|9d440|1sqk0|7k580|9d440|9cyk0|9q2s0|at4c0|7x9g0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x3w0|asqg0|Infinity",
                offsets: "-136|-120|-180|-60|-240",
                offsetIndices: "012131312424242424242424242121212424242212121212121212121212121212121212142"
            }, {
                id: "Europe/Skopje",
                untils: "-ezayw0|swz00|7k800|9q000|9d1c0|9d1c0|b7pc0|6qlc0|jl1hc0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-60|-120",
                offsetIndices: "01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Europe/Sofia",
                untils: "-e6dzw0|7k800|9q000|9d1c0|9d1c0|9d440|hqq240|9eys0|9o2k0|92040|9o2k0|90880|9pug0|90b00|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9cvs0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9q2s0|ast80|7xhs0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-120|-60|-180",
                offsetIndices: "01010102020202020202020202020202020202020202020202020202020202020202020202020202020202020202020202020202020202020202020202020"
            }, {
                id: "Europe/Stockholm",
                untils: "-rzo2w0|75hg0|x5bew0|902o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-60|-120",
                offsetIndices: "01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Europe/Tallinn",
                untils: "-r3exx0|3re10|7x6o0|et6g0|ygov0|a1zgd0|ktx80|l94g0|7k800|9q000|9d1c0|8uac0|j27mk0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d440|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asys0|7x6o0|b5uo0|19dc00|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-99|-60|-120|-180|-240",
                offsetIndices: "012102321212343434343434343433232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232"
            }, {
                id: "Europe/Tirane",
                untils: "-t85vo8|dt2gw8|18pew0|7k800|m800|g7ot40|7rjw0|autg0|7x3w0|ayis0|7x3w0|b5xg0|7k580|b42s0|7lzw0|b42s0|7lzw0|b42s0|7x3w0|ahus0|7x3w0|b5xg0|7x3w0|a4w40|8jbw0|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-79.3333|-60|-120",
                offsetIndices: "01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Europe/Tiraspol",
                untils: "-r2p1bo|70f1to|fj8m0|6w5c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|geqo0|ha580|oc8g0|7k800|9q000|9d1c0|7cl00|j3pbw0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|25p80|7kdk0|9d1c0|9d1c0|9cvs0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9q2s0|ast80|7xf00|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-115|-104.4|-120|-180|-60|-240",
                offsetIndices: "012323232323232323232424235353535353535353535323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232"
            }, {
                id: "Europe/Ulyanovsk",
                untils: "-qcx400|5q5zo0|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|iq5g0|9d1c0|9q000|iq5g0|5reo0|3ljw0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|1vbzw0|qnc40|Infinity",
                offsets: "-193.6|-180|-240|-300|-120",
                offsetIndices: "01232323232323232321214121212121212121212121212121212121212121212"
            }, {
                id: "Europe/Uzhgorod",
                untils: "-fizzw0|1cm000|7k800|9q000|9d1c0|al900|cnms0|int140|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|eeio0|e1sc0|iprk0|9cyk0|9d440|9cyk0|9d440|9cyk0|9dcg0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-60|-120|-180|-240",
                offsetIndices: "010101023232323232323232320121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Europe/Vaduz",
                untils: "-eyh6o0|7x6o0|asw00|7x6o0|k2zus0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-60|-120",
                offsetIndices: "01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Europe/Vatican",
                untils: "-rymys0|64ak0|9d440|9et80|88dg0|aunw0|7ig40|b5rw0|8n6s0|9cyk0|aau2s0|18r9k0|7k800|9q000|9d1c0|8l9c0|a4tc0|8j940|9f1k0|afxc0|89zs0|afxc0|7kdk0|b5uo0|979rs0|6h980|cls40|64dc0|clpc0|64dc0|cyo00|64dc0|clpc0|64dc0|c8qo0|6hc00|clpc0|6hc00|clpc0|64dc0|c8qo0|6hc00|clpc0|64dc0|clpc0|64dc0|c8qo0|6hc00|clpc0|6hc00|c8qo0|6hc00|9q5k0|902o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-60|-120",
                offsetIndices: "0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Europe/Vienna",
                untils: "-s0e080|7ves0|a4yw0|7x6o0|asw00|7x6o0|t6000|8a5c0|a7a800|1cm000|7k800|9q000|9d1c0|9d1c0|9d1c0|iio0|ivmo0|91xc0|9b6o0|9d1c0|a2yo0|8n400|gfyyg0|8zzw0|9d9o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-60|-120",
                offsetIndices: "0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Europe/Vilnius",
                untils: "-rns980|1g224o|e75nc|4kqk0|acbs40|gpp40|pits0|7k800|9q000|9d1c0|65zo0|j4vx80|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d440|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x9g0|asw00|7x6o0|b5uo0|1s3eo0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-84|-95.6|-60|-120|-180|-240",
                offsetIndices: "012324323234545454545454545443434343434343434332334343434343434343434343434343434343434343434343434343434343434343434343"
            }, {
                id: "Europe/Volgograd",
                untils: "-q3cw84|5glrw4|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|iq5g0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|s3400|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|1vbzw0|239c40|Infinity",
                offsets: "-177.6667|-180|-240|-300",
                offsetIndices: "012323232323232321212121212121212121212121212121212121212121212"
            }, {
                id: "Europe/Warsaw",
                untils: "-se9yk0|dvyc0|7ves0|a4yw0|7x6o0|asw00|7x6o0|aunw0|7x6o0|1evbs0|9fcwc0|18cao0|7k800|9q000|9d1c0|9gnw0|an980|9kd80|8fs40|922w0|ar1c0|7x6o0|a2yo0|8n400|9q000|902o0|4013w0|64dc0|9d1c0|9d1c0|clpc0|6hc00|9d1c0|9d1c0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|clpc0|64dc0|6j4tc0|902o0|9q000|9d1c0|9d1c0|9d1c0|9q000|902o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d440|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-84|-60|-120|-180",
                offsetIndices: "012121223212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Europe/Zagreb",
                untils: "-ezayw0|swz00|7k800|9q000|9d1c0|9d1c0|b7pc0|6qlc0|jl1hc0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-60|-120",
                offsetIndices: "01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Europe/Zaporozhye",
                untils: "-nu12hc|37a0xc|5u1180|mc0g0|7k800|9q000|12qg0|jjc7s0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9cvs0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9dcg0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-140|-120|-180|-60|-240",
                offsetIndices: "01213132424242424242424242422121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Europe/Zurich",
                untils: "-eyh6o0|7x6o0|asw00|7x6o0|k2zus0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-60|-120",
                offsetIndices: "01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "GB-Eire",
                untils: "-rzcns0|6uao0|9q000|8c000|9o5c0|9ruo0|9b6o0|9ew00|9b6o0|auqo0|88ao0|9ew00|8y800|a2yo0|a2yo0|7k800|asw00|8a5c0|asw00|8n400|a2yo0|8n400|9q000|902o0|afxc0|8n400|a2yo0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|9d1c0|a2yo0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|902o0|a2yo0|b5uo0|51hc0|mbmk0|51hc0|c8qo0|6hc00|c8qo0|6uao0|bvs00|8n400|a4tc0|5clc0|4bms0|9q000|902o0|8a5c0|1frw0|64dc0|4bms0|6uao0|bvs00|7x6o0|asw00|8n400|9q000|902o0|9q000|9d1c0|9q000|902o0|8n400|9q000|902o0|a2yo0|8n400|afxc0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|902o0|902o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|bitc0|5reo0|1xhuo0|779c0|bitc0|779c0|bitc0|779c0|bitc0|779c0|bitc0|7k800|b5uo0|7k800|b5uo0|7k800|bitc0|779c0|bitc0|779c0|bitc0|7x3w0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|8a5c0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "0|-60|-120",
                offsetIndices: "0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "GB",
                untils: "-rzcns0|6uao0|9q000|8c000|9o5c0|9ruo0|9b6o0|9ew00|9b6o0|auqo0|88ao0|9ew00|8y800|a2yo0|a2yo0|7k800|asw00|8a5c0|asw00|8n400|a2yo0|8n400|9q000|902o0|afxc0|8n400|a2yo0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|9d1c0|a2yo0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|902o0|a2yo0|b5uo0|51hc0|mbmk0|51hc0|c8qo0|6hc00|c8qo0|6uao0|bvs00|8n400|a4tc0|5clc0|4bms0|9q000|902o0|8a5c0|1frw0|64dc0|4bms0|6uao0|bvs00|7x6o0|asw00|8n400|9q000|902o0|9q000|9d1c0|9q000|902o0|8n400|9q000|902o0|a2yo0|8n400|afxc0|8n400|9q000|902o0|a2yo0|8n400|a2yo0|8n400|9q000|902o0|902o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|bitc0|5reo0|1xhuo0|779c0|bitc0|779c0|bitc0|779c0|bitc0|779c0|bitc0|7k800|b5uo0|7k800|b5uo0|7k800|bitc0|779c0|bitc0|779c0|bitc0|7x3w0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|8a5c0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "0|-60|-120",
                offsetIndices: "0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "GMT-0",
                untils: "Infinity",
                offsets: "0",
                offsetIndices: "0"
            }, {
                id: "GMT",
                untils: "Infinity",
                offsets: "0",
                offsetIndices: "0"
            }, {
                id: "GMT+0",
                untils: "Infinity",
                offsets: "0",
                offsetIndices: "0"
            }, {
                id: "GMT0",
                untils: "Infinity",
                offsets: "0",
                offsetIndices: "0"
            }, {
                id: "Greenwich",
                untils: "Infinity",
                offsets: "0",
                offsetIndices: "0"
            }, {
                id: "Hongkong",
                untils: "-y0i0s0|j44dk0|5k000|4d4y0|2195i0|7x3w0|bj320|6uao0|bvs00|7x6o0|9d1c0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|8a5c0|asw00|7x6o0|ast80|77c40|biqk0|77c40|bvp80|6udg0|bvp80|77c40|biqk0|77c40|biqk0|77c40|biqk0|77c40|bvp80|6udg0|bvp80|6udg0|bvp80|77c40|biqk0|77c40|biqk0|8n6s0|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|3lpg0|f4d80|9d440|9cyk0|9d440|9cyk0|1c9440|8a2k0|Infinity",
                offsets: "-456.7|-480|-540|-510",
                offsetIndices: "0123212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "HST",
                untils: "Infinity",
                offsets: "600",
                offsetIndices: "0"
            }, {
                id: "Iceland",
                untils: "-wcwx9c|4rpd9c|ci2s0|69uk0|du840|4xp80|du840|p7bw0|4w040|9bdzw0|9d6w0|64g40|cyl80|64dc0|clpc0|6hc00|bvs00|6uao0|bvs00|6uao0|bvs00|6uao0|c8qo0|6hc00|c8qo0|8a5c0|afxc0|8a5c0|afxc0|8a5c0|asw00|7x6o0|afxc0|8a5c0|asw00|8a5c0|afxc0|8a5c0|afxc0|8a5c0|afxc0|8a5c0|afxc0|8a5c0|asw00|8a5c0|afxc0|8a5c0|afxc0|8a5c0|afxc0|8a5c0|afxc0|8a5c0|afxc0|8a5c0|asw00|8a5c0|afxc0|8a5c0|afxc0|8a5c0|afxc0|8a5c0|afxc0|8a5c0|asw00|8a5c0|Infinity",
                offsets: "88|60|0",
                offsetIndices: "012121212121212121212121212121212121212121212121212121212121212121212"
            }, {
                id: "Indian/Antananarivo",
                untils: "-lnsetg|s8mhg|57v020|afrrb0|Infinity",
                offsets: "-147.2667|-180|-150|-165",
                offsetIndices: "01231"
            }, {
                id: "Indian/Chagos",
                untils: "-wvpc2s|1ag64us|Infinity",
                offsets: "-289.6667|-300|-360",
                offsetIndices: "012"
            }, {
                id: "Indian/Christmas",
                untils: "Infinity",
                offsets: "-420",
                offsetIndices: "0"
            }, {
                id: "Indian/Cocos",
                untils: "Infinity",
                offsets: "-390",
                offsetIndices: "0"
            }, {
                id: "Indian/Comoro",
                untils: "-lnsetg|s8mhg|57v020|afrrb0|Infinity",
                offsets: "-147.2667|-180|-150|-165",
                offsetIndices: "01231"
            }, {
                id: "Indian/Kerguelen",
                untils: "-afrs00|Infinity",
                offsets: "0|-300",
                offsetIndices: "01"
            }, {
                id: "Indian/Mahe",
                untils: "-x6pjlo|Infinity",
                offsets: "-221.8|-240",
                offsetIndices: "01"
            }, {
                id: "Indian/Maldives",
                untils: "-57x6y0|Infinity",
                offsets: "-294|-300",
                offsetIndices: "01"
            }, {
                id: "Indian/Mauritius",
                untils: "-wvp9bc|13jnu7c|8bx80|dd0wc0|7x3w0|Infinity",
                offsets: "-230|-240|-300",
                offsetIndices: "012121"
            }, {
                id: "Indian/Mayotte",
                untils: "-lnsetg|s8mhg|57v020|afrrb0|Infinity",
                offsets: "-147.2667|-180|-150|-165",
                offsetIndices: "01231"
            }, {
                id: "Indian/Reunion",
                untils: "-uks29s|Infinity",
                offsets: "-221.8667|-240",
                offsetIndices: "01"
            }, {
                id: "Iran",
                untils: "-s6m6uw|fnolc0|gm3h4w|777y0|b07w0|3pes0|42c20|9cyk0|9gtg0|9kd80|5ja5g0|7avw0|9d440|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9d440|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9d440|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9d440|9gnw0|1av440|9gnw0|9d440|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9d440|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9d440|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9d440|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9d440|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9d440|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9d440|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|9b9g0|9gnw0|Infinity",
                offsets: "-205.7333|-210|-240|-300|-270",
                offsetIndices: "00123214141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141"
            }, {
                id: "Israel",
                untils: "-r50eig|bp54yg|19f3w0|7rv00|b02c0|7tk40|b07w0|8jhg0|a8lg0|8jhg0|a8ac0|t9s40|56vs0|35700|9b3w0|9gtg0|8jbw0|7tmw0|a6ig0|biyw0|8a5c0|9d1c0|902o0|7x6o0|e1eg0|4ofw0|dzxo0|4q500|doo40|64iw0|auqo0|7i500|8rfms0|51ek0|9q2s0|6u7w0|2khpg0|25s00|1weyo0|5reo0|bxmo0|7x3w0|cls40|5rbw0|bbhg0|7rjw0|asys0|7k580|c8tg0|6h980|ag040|7x3w0|asys0|8a2k0|asys0|8a2k0|ap9g0|80t80|ap9g0|7nuk0|b2840|80t80|9zc40|9iik0|9kis0|93p80|9mdg0|8qqk0|apf00|7x3w0|biw40|8zx40|9io40|8n180|9kis0|9vh80|8ulg0|9px80|9mdg0|8n180|9tuw0|9tmk0|8wg40|9gnw0|99es0|8qqk0|9zc40|9tmk0|8wg40|9gnw0|99es0|8qqk0|acas0|9gnw0|99es0|93p80|9mdg0|awik0|7tk40|awik0|7tk40|awik0|7tk40|b9h80|7glg0|b9h80|7glg0|b9h80|7tk40|awik0|7tk40|awik0|7tk40|b9h80|7glg0|b9h80|7glg0|b9h80|7tk40|awik0|7tk40|awik0|7tk40|awik0|7tk40|b9h80|7glg0|b9h80|7glg0|b9h80|7tk40|awik0|7tk40|awik0|7tk40|b9h80|7glg0|b9h80|7glg0|b9h80|7glg0|b9h80|7tk40|awik0|7tk40|awik0|Infinity",
                offsets: "-140.6667|-120|-180|-240",
                offsetIndices: "012121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Jamaica",
                untils: "-u85og2|wbl182|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|Infinity",
                offsets: "307.1667|300|240",
                offsetIndices: "0121212121212121212121"
            }, {
                id: "Japan",
                untils: "-bb4900|6uao0|afxc0|8a5c0|c8qo0|6hc00|c8qo0|6hc00|Infinity",
                offsets: "-540|-600",
                offsetIndices: "010101010"
            }, {
                id: "Kwajalein",
                untils: "-h817w0|27sas0|1hjus0|ddxug0|cgv6k0|Infinity",
                offsets: "-660|-600|-540|720|-720",
                offsetIndices: "012034"
            }, {
                id: "Libya",
                untils: "-q3gfrw|gl6ajw|422c0|xado0|4bbo0|wrpg0|4s580|1kdpg0|c05bw0|4mqs0|9et80|9d440|9et80|9eys0|9et80|9mdg0|95jw0|9io40|9cyk0|99es0|9et80|9eys0|9et80|9d440|9et80|b2840|3cf3w0|9kis0|9et80|7vqyw0|75eo0|asw00|Infinity",
                offsets: "-52.7333|-60|-120",
                offsetIndices: "012121212121212121212121212122122"
            }, {
                id: "MET",
                untils: "-s0e080|7ves0|a4yw0|7x6o0|asw00|7x6o0|b8qdc0|1cm000|7k800|9q000|9d1c0|9d1c0|9d1c0|8l9c0|ggp1c0|902o0|9q000|9d1c0|9d1c0|9d1c0|9q000|902o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-60|-120",
                offsetIndices: "01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Mexico/BajaNorte",
                untils: "-p1u1s0|11jrw0|1sns00|1sgdc0|71s40|9cyk0|5iidg0|1q6700|4lfk0|190g40|eluk0|2r4o80|7x6o0|asw00|7x6o0|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|84qys0|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|77c40|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "468.0667|420|480",
                offsetIndices: "012121211212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212"
            }, {
                id: "Mexico/BajaSur",
                untils: "-p1u4k0|2u7jw0|1sgdc0|8n400|7thc0|9eys0|591h80|3ie2s0|axvpg0|dpgw40|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|9q2s0|7k580|9q2s0|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|Infinity",
                offsets: "425.6667|420|360|480",
                offsetIndices: "0121212131212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Mexico/General",
                untils: "-p1u4k0|2u7jw0|1sgdc0|8n400|7thc0|9eys0|3knek0|776k0|rf440|5t6k0|1evk40|71mk0|30p1g0|8n180|nufxo0|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|9q2s0|7k580|9q2s0|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|Infinity",
                offsets: "396.6|420|360|300",
                offsetIndices: "012121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232"
            }, {
                id: "MST",
                untils: "Infinity",
                offsets: "420",
                offsetIndices: "0"
            }, {
                id: "MST7MDT",
                untils: "-r0epo0|ast80|7x9g0|ast80|bmtus0|1tz5k0|2dvo0|b9gdg0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "420|360",
                offsetIndices: "010101101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Navajo",
                untils: "-r0epo0|ast80|7x9g0|ast80|7x9g0|b5rw0|7kas0|2vmk0|ataw40|1tz5k0|2dvo0|a7n9g0|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "420|360",
                offsetIndices: "01010101011010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "NZ-CHAT",
                untils: "-ciya10|f1tq90|5reo0|clpc0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|b5uo0|8a5c0|afxc0|8a5c0|afxc0|8a5c0|afxc0|8n400|a2yo0|8n400|a2yo0|8n400|a2yo0|8n400|afxc0|8a5c0|afxc0|8a5c0|afxc0|8n400|a2yo0|8n400|a2yo0|8n400|afxc0|8a5c0|afxc0|8a5c0|afxc0|8n400|a2yo0|8n400|a2yo0|8n400|a2yo0|8n400|a2yo0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|a2yo0|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|Infinity",
                offsets: "-735|-765|-825",
                offsetIndices: "012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212"
            }, {
                id: "NZ",
                untils: "-m01p20|64ak0|biw40|7x5a0|asxe0|7x5a0|asxe0|7x5a0|asxe0|8a3y0|afyq0|8a3y0|afyq0|afvy0|7x820|asum0|7x820|asum0|7x820|asum0|7x820|asum0|7x820|b5ta0|7k9e0|b5ta0|7x820|hsl2m0|5reo0|clpc0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|b5uo0|8a5c0|afxc0|8a5c0|afxc0|8a5c0|afxc0|8n400|a2yo0|8n400|a2yo0|8n400|a2yo0|8n400|afxc0|8a5c0|afxc0|8a5c0|afxc0|8n400|a2yo0|8n400|a2yo0|8n400|afxc0|8a5c0|afxc0|8a5c0|afxc0|8n400|a2yo0|8n400|a2yo0|8n400|a2yo0|8n400|a2yo0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|a2yo0|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|Infinity",
                offsets: "-690|-750|-720|-780",
                offsetIndices: "01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323"
            }, {
                id: "Pacific/Apia",
                untils: "-usiiv4|kcrmt4|vp3la0|9odo0|902o0|4zbk0|4qog0|9d1c0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|a2yo0|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|Infinity",
                offsets: "686.9333|690|660|600|-840|-780",
                offsetIndices: "01232345454545454545454545454545454545454545454545454545454"
            }, {
                id: "Pacific/Auckland",
                untils: "-m01p20|64ak0|biw40|7x5a0|asxe0|7x5a0|asxe0|7x5a0|asxe0|8a3y0|afyq0|8a3y0|afyq0|afvy0|7x820|asum0|7x820|asum0|7x820|asum0|7x820|asum0|7x820|b5ta0|7k9e0|b5ta0|7x820|hsl2m0|5reo0|clpc0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|b5uo0|8a5c0|afxc0|8a5c0|afxc0|8a5c0|afxc0|8n400|a2yo0|8n400|a2yo0|8n400|a2yo0|8n400|afxc0|8a5c0|afxc0|8a5c0|afxc0|8n400|a2yo0|8n400|a2yo0|8n400|afxc0|8a5c0|afxc0|8a5c0|afxc0|8n400|a2yo0|8n400|a2yo0|8n400|a2yo0|8n400|a2yo0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|a2yo0|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|Infinity",
                offsets: "-690|-750|-720|-780",
                offsetIndices: "01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323"
            }, {
                id: "Pacific/Bougainville",
                untils: "-ecsh40|1n05g0|1071c40|Infinity",
                offsets: "-600|-540|-660",
                offsetIndices: "0102"
            }, {
                id: "Pacific/Chatham",
                untils: "-ciya10|f1tq90|5reo0|clpc0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6uao0|c8qo0|6hc00|b5uo0|8a5c0|afxc0|8a5c0|afxc0|8a5c0|afxc0|8n400|a2yo0|8n400|a2yo0|8n400|a2yo0|8n400|afxc0|8a5c0|afxc0|8a5c0|afxc0|8n400|a2yo0|8n400|a2yo0|8n400|afxc0|8a5c0|afxc0|8a5c0|afxc0|8n400|a2yo0|8n400|a2yo0|8n400|a2yo0|8n400|a2yo0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|a2yo0|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|902o0|9q000|9d1c0|9q000|902o0|9q000|902o0|Infinity",
                offsets: "-735|-765|-825",
                offsetIndices: "012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212"
            }, {
                id: "Pacific/Chuuk",
                untils: "-su4zs0|29hes0|bkenw0|29fk40|Infinity",
                offsets: "-600|-540",
                offsetIndices: "01010"
            }, {
                id: "Pacific/Easter",
                untils: "-jhfaew|ivmeuw|7k580|c8tg0|6h980|a31g0|7x3w0|asys0|7x3w0|b5xg0|7k580|ag040|8a2k0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7k580|b5xg0|7x3w0|asys0|iq2o0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7k580|b5xg0|9cyk0|9d440|7x3w0|asys0|7x3w0|b5xg0|7k580|9q2s0|8zzw0|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|8n180|a31g0|7x3w0|a31g0|9px80|9q2s0|7x3w0|b5xg0|7k580|b5xg0|7k580|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|8n180|a31g0|7x3w0|asys0|8zzw0|9q2s0|ast80|5eis0|cyl80|6hes0|c8nw0|6udg0|bvp80|6udg0|vonw0|4olg0|e1h80|4olg0|e1h80|4olg0|c8nw0|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|b5rw0|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|b5rw0|7kas0|b5rw0|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|ast80|7x9g0|b5rw0|7kas0|b5rw0|7x9g0|ast80|7x9g0|Infinity",
                offsets: "437.4667|420|360|300",
                offsetIndices: "012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323"
            }, {
                id: "Pacific/Efate",
                untils: "-u964i4|11f4ba4|9cyk0|awo40|7tek0|9q2s0|8zzw0|9q2s0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9q2s0|64ak0|e1ms0|4ofw0|Infinity",
                offsets: "-673.2667|-660|-720",
                offsetIndices: "0121212121212121212121"
            }, {
                id: "Pacific/Enderbury",
                untils: "535io0|7yiqk0|Infinity",
                offsets: "720|660|-780",
                offsetIndices: "012"
            }, {
                id: "Pacific/Fakaofo",
                untils: "lx0jw0|Infinity",
                offsets: "660|-780",
                offsetIndices: "01"
            }, {
                id: "Pacific/Fiji",
                untils: "-sa2x4w|17bs00w|64dc0|cyo00|5reo0|53a5c0|64dc0|asw00|6uao0|bvs00|4oio0|e1k00|4oio0|eeio0|4bh80|erk40|3ylc0|erhc0|3ylc0|f4g00|3lmo0|f4g00|3lmo0|f4g00|3lmo0|fheo0|38o00|fheo0|3lmo0|fheo0|38o00|fheo0|38o00|fheo0|38o00|fheo0|38o00|fheo0|3lmo0|f4g00|3lmo0|fheo0|38o00|fheo0|38o00|fheo0|38o00|fheo0|38o00|fheo0|3lmo0|fheo0|38o00|fheo0|38o00|fheo0|38o00|fheo0|38o00|fheo0|3lmo0|f4g00|3lmo0|Infinity",
                offsets: "-715.7333|-720|-780",
                offsetIndices: "0121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Pacific/Funafuti",
                untils: "Infinity",
                offsets: "-720",
                offsetIndices: "0"
            }, {
                id: "Pacific/Galapagos",
                untils: "-kcr62o|spdryo|3lsas0|3jp80|Infinity",
                offsets: "358.4|300|360",
                offsetIndices: "01212"
            }, {
                id: "Pacific/Gambier",
                untils: "-tvndoc|Infinity",
                offsets: "539.8|540",
                offsetIndices: "01"
            }, {
                id: "Pacific/Guadalcanal",
                untils: "-tvowac|Infinity",
                offsets: "-639.8|-660",
                offsetIndices: "01"
            }, {
                id: "Pacific/Guam",
                untils: "-en8eg0|1dl9g0|7s1k40|txp80|3frms0|qdrpo|7kgac|3ljw0|c8tg0|6u7w0|bvus0|6u7w0|16uo40|3ljw0|16aas0|4ivxo|cls2c|6h980|c65zw0|Infinity",
                offsets: "-600|-540|-660",
                offsetIndices: "01020202020202020200"
            }, {
                id: "Pacific/Honolulu",
                untils: "-j50la0|13l00|4jvb00|1tyvu0|2e5e0|votg0|Infinity",
                offsets: "630|570|600",
                offsetIndices: "0101102"
            }, {
                id: "Pacific/Johnston",
                untils: "-j50la0|13l00|4jvb00|1tyvu0|2e5e0|votg0|Infinity",
                offsets: "630|570|600",
                offsetIndices: "0101102"
            }, {
                id: "Pacific/Kiritimati",
                untils: "535eyo|7yirhc|Infinity",
                offsets: "640|600|-840",
                offsetIndices: "012"
            }, {
                id: "Pacific/Kosrae",
                untils: "-su52k0|29hhk0|9cmd40|27sas0|29fk40|cm2540|f9l3w0|Infinity",
                offsets: "-660|-540|-600|-720",
                offsetIndices: "01021030"
            }, {
                id: "Pacific/Kwajalein",
                untils: "-h817w0|27sas0|1hjus0|ddxug0|cgv6k0|Infinity",
                offsets: "-660|-600|-540|720|-720",
                offsetIndices: "012034"
            }, {
                id: "Pacific/Majuro",
                untils: "-su52k0|29hhk0|9cmd40|27sas0|1h6w40|deat40|Infinity",
                offsets: "-660|-540|-600|-720",
                offsetIndices: "0102103"
            }, {
                id: "Pacific/Marquesas",
                untils: "-tvncu0|Infinity",
                offsets: "558|570",
                offsetIndices: "01"
            }, {
                id: "Pacific/Midway",
                untils: "-usij20|Infinity",
                offsets: "682.8|660",
                offsetIndices: "01"
            }, {
                id: "Pacific/Nauru",
                untils: "-pjxiws|ba66ys|1kwca0|hfzda0|Infinity",
                offsets: "-667.6667|-690|-540|-720",
                offsetIndices: "01213"
            }, {
                id: "Pacific/Niue",
                untils: "-9wyz6o|ehcj4o|Infinity",
                offsets: "680|690|660",
                offsetIndices: "012"
            }, {
                id: "Pacific/Norfolk",
                untils: "-9x0ps0|cfj8q0|6hc00|l6nk00|239aq0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|Infinity",
                offsets: "-672|-690|-750|-660|-720",
                offsetIndices: "012134343434343434343434343434343434343434"
            }, {
                id: "Pacific/Noumea",
                untils: "-u9645o|ye0ixo|4dbw0|ecqs0|4f6k0|99p700|4oio0|Infinity",
                offsets: "-665.8|-660|-720",
                offsetIndices: "01212121"
            }, {
                id: "Pacific/Pago_Pago",
                untils: "-usij20|Infinity",
                offsets: "682.8|660",
                offsetIndices: "01"
            }, {
                id: "Pacific/Palau",
                untils: "Infinity",
                offsets: "-540",
                offsetIndices: "0"
            }, {
                id: "Pacific/Pitcairn",
                untils: "es2cy0|Infinity",
                offsets: "510|480",
                offsetIndices: "01"
            }, {
                id: "Pacific/Pohnpei",
                untils: "-su52k0|29hhk0|9cmd40|27sas0|29fk40|Infinity",
                offsets: "-660|-540|-600",
                offsetIndices: "010210"
            }, {
                id: "Pacific/Ponape",
                untils: "-su52k0|29hhk0|9cmd40|27sas0|29fk40|Infinity",
                offsets: "-660|-540|-600",
                offsetIndices: "010210"
            }, {
                id: "Pacific/Port_Moresby",
                untils: "Infinity",
                offsets: "-600",
                offsetIndices: "0"
            }, {
                id: "Pacific/Rarotonga",
                untils: "4mj960|5rbw0|c8s20|6ham0|c8s20|6ham0|c8s20|6u9a0|c8s20|6ham0|c8s20|6ham0|c8s20|6ham0|c8s20|6ham0|c8s20|6ham0|c8s20|6u9a0|c8s20|6ham0|c8s20|6ham0|c8s20|6ham0|Infinity",
                offsets: "630|570|600",
                offsetIndices: "012121212121212121212121212"
            }, {
                id: "Pacific/Saipan",
                untils: "-en8eg0|1dl9g0|7s1k40|txp80|3frms0|qdrpo|7kgac|3ljw0|c8tg0|6u7w0|bvus0|6u7w0|16uo40|3ljw0|16aas0|4ivxo|cls2c|6h980|c65zw0|Infinity",
                offsets: "-600|-540|-660",
                offsetIndices: "01020202020202020200"
            }, {
                id: "Pacific/Samoa",
                untils: "-usij20|Infinity",
                offsets: "682.8|660",
                offsetIndices: "01"
            }, {
                id: "Pacific/Tahiti",
                untils: "-tvnayw|Infinity",
                offsets: "598.2667|600",
                offsetIndices: "01"
            }, {
                id: "Pacific/Tarawa",
                untils: "Infinity",
                offsets: "-720",
                offsetIndices: "0"
            }, {
                id: "Pacific/Tongatapu",
                untils: "-f4vrlc|uo2edc|8fpc0|bvs00|4bh80|eelg0|4bh80|7pmis0|3lmo0|Infinity",
                offsets: "-740|-780|-840",
                offsetIndices: "0121212121"
            }, {
                id: "Pacific/Truk",
                untils: "-su4zs0|29hes0|bkenw0|29fk40|Infinity",
                offsets: "-600|-540",
                offsetIndices: "01010"
            }, {
                id: "Pacific/Wake",
                untils: "Infinity",
                offsets: "-720",
                offsetIndices: "0"
            }, {
                id: "Pacific/Wallis",
                untils: "Infinity",
                offsets: "-720",
                offsetIndices: "0"
            }, {
                id: "Pacific/Yap",
                untils: "-su4zs0|29hes0|bkenw0|29fk40|Infinity",
                offsets: "-600|-540",
                offsetIndices: "01010"
            }, {
                id: "Poland",
                untils: "-se9yk0|dvyc0|7ves0|a4yw0|7x6o0|asw00|7x6o0|aunw0|7x6o0|1evbs0|9fcwc0|18cao0|7k800|9q000|9d1c0|9gnw0|an980|9kd80|8fs40|922w0|ar1c0|7x6o0|a2yo0|8n400|9q000|902o0|4013w0|64dc0|9d1c0|9d1c0|clpc0|6hc00|9d1c0|9d1c0|c8qo0|6hc00|c8qo0|6hc00|c8qo0|6hc00|clpc0|64dc0|6j4tc0|902o0|9q000|9d1c0|9d1c0|9d1c0|9q000|902o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d440|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "-84|-60|-120|-180",
                offsetIndices: "012121223212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "Portugal",
                untils: "-u9rhc0|2bufw0|6zxg0|66580|bq800|73k00|bodc0|71pc0|bq800|73k00|bq800|71pc0|bq800|1b2g00|9b6o0|saio0|8n400|9q000|902o0|a2yo0|902o0|a2yo0|8n400|st1c0|8n400|9d1c0|9d1c0|sg2o0|9d1c0|902o0|9q000|a2yo0|8n400|9d1c0|9d1c0|902o0|9q000|a2yo0|b5uo0|51hc0|bitc0|9d1c0|9ew00|88ao0|25p80|5reo0|3lpg0|779c0|1sqk0|6uao0|38qs0|6uao0|25p80|6hc00|38qs0|6uao0|25p80|6hc00|38qs0|8a5c0|9d1c0|9d9o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|s3400|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|5gyl40|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d440|9cyk0|9d440|9d1c0|9d1c0|9d1c0|9d1c0|9d440|9cyk0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "36.75|0|-60|-120",
                offsetIndices: "012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121212121212121212121212121212121212122323232212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "PRC",
                untils: "-qh00w0|8sl80|asbpg0|6w2k0|7ves0|bxjw0|4mqs0|1vduk0|d4as0|75bw0|a31g0|aaak0|9d440|7v980|awo40|1dx80|j9xpo0|6u7w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|Infinity",
                offsets: "-480|-540",
                offsetIndices: "01010101010101010101010101010"
            }, {
                id: "PST8PDT",
                untils: "-r0emw0|ast80|7x9g0|ast80|bmtus0|1tz2s0|2dyg0|b9gdg0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "480|420",
                offsetIndices: "010101101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "ROC",
                untils: "-gtzfk0|45slc0|c51c0|75bw0|a31g0|aaak0|9d440|7v980|awo40|7v980|awo40|7v980|awo40|7v980|7tk40|clmk0|7rpg0|b07w0|7rpg0|b07w0|7rpg0|9et80|9eys0|9et80|9d440|9et80|9d440|9et80|9d440|9et80|cjxg0|69uk0|ci2s0|69uk0|6its40|9et80|9d440|9et80|1yf9g0|4qak0|Infinity",
                offsets: "-480|-540",
                offsetIndices: "01010101010101010101010101010101010101010"
            }, {
                id: "ROK",
                untils: "-w8966g|1yh18g|hkx5a0|1faao0|5cik0|ae5g0|8a2k0|ae5g0|8bx80|c8tg0|6h980|1bj6s0|l3aq0|6j3w0|d2g40|6u7w0|b5xg0|776k0|biw40|776k0|biw40|776k0|biw40|776k0|grs40|dfqxi0|7x6o0|asw00|7x6o0|Infinity",
                offsets: "-507.8667|-510|-540|-600|-570",
                offsetIndices: "012232323232141414141414123232"
            }, {
                id: "Singapore",
                untils: "-xphpwd|eeb94d|4it32o|8n3jc|1v2p60|iy3o60|Infinity",
                offsets: "-415.4167|-420|-440|-450|-540|-480",
                offsetIndices: "0123435"
            }, {
                id: "Turkey",
                untils: "-ux9xew|2wvx6w|7v980|1tjc40|aunw0|88dg0|9et80|8yas0|a2vw0|tzpg0|79180|awo40|7v980|7p4040|4zjw0|2vs40|f4d80|9vms0|1u5ek0|c5440|69uk0|acas0|8n180|a31g0|8n180|9q2s0|8zzw0|a31g0|8zzw0|a31g0|8n180|5md9g0|o9zw0|a6qs0|75bw0|4iwyw0|7x6o0|7kas0|b5rw0|75hg0|bkl80|77c40|biqk0|7x9g0|a2vw0|8n6s0|4iqc0|2nkw80|38l80|kdes0|8qtc0|8a5c0|9ew00|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|902o0|9q000|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7kdk0|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7m2o0|b4000|7k800|b5uo0|7x6o0|asw00|7z1c0|ar1c0|7x6o0|bitc0|779c0|8fe80|Infinity",
                offsets: "-116.9333|-120|-180|-240",
                offsetIndices: "0121212121212121212121212121212121212121212121223212121212121212121212121212121212121212121212121212121212121212122"
            }, {
                id: "UCT",
                untils: "Infinity",
                offsets: "0",
                offsetIndices: "0"
            }, {
                id: "Universal",
                untils: "Infinity",
                offsets: "0",
                offsetIndices: "0"
            }, {
                id: "US/Alaska",
                untils: "-ek1qo0|1tyx80|2e400|b7yik0|12y080|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|1l940|7rs80|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "600|540|480",
                offsetIndices: "011001010101010101010101010101010111212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "US/Aleutian",
                untils: "-ek1nw0|1tyug0|2e6s0|b7yik0|12y080|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|1l940|7rs80|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "660|600|540",
                offsetIndices: "011001010101010101010101010101010111212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "US/Arizona",
                untils: "-r0epo0|ast80|7x9g0|ast80|bmtus0|zjedo|4olg0|9et80|bs6lmc|9cyk0|Infinity",
                offsets: "420|360",
                offsetIndices: "01010101010"
            }, {
                id: "US/Central",
                untils: "-r0esg0|ast80|7x9g0|ast80|bvus0|776k0|7kas0|b5rw0|9d440|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|7x9g0|dbjw0|8a840|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|6w840|1tz8c0|2dsw0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "360|300",
                offsetIndices: "01010101010101010101010101010101010101010101010101101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "US/East-Indiana",
                untils: "-r0esg0|ast80|7x9g0|ast80|baw840|51ek0|6w840|1tz8c0|2dsw0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|19q7w0|asys0|5qonw0|9cyk0|9d440|9cyk0|ihslg0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "360|300|240",
                offsetIndices: "010101011010101010101010101010121212121212121212121212121212121212121212121212121212121212121212121"
            }, {
                id: "US/Eastern",
                untils: "-r0ev80|ast80|7x9g0|ast80|7x9g0|b5rw0|905g0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|6w840|1tzb40|2dq40|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "300|240",
                offsetIndices: "01010101010101010101010101010101010101010101010101101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "US/Hawaii",
                untils: "-j50la0|13l00|4jvb00|1tyvu0|2e5e0|votg0|Infinity",
                offsets: "630|570|600",
                offsetIndices: "0101102"
            }, {
                id: "US/Indiana-Starke",
                untils: "-r0esg0|ast80|7x9g0|ast80|bmtus0|1tz8c0|2dsw0|tj1g0|7x3w0|asys0|7x3w0|asys0|7x3w0|b5xg0|7k580|b5xg0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|7x3w0|asys0|9px80|9d440|9cyk0|9d440|7x3w0|asys0|7x3w0|asys0|9cyk0|9d440|9px80|9d440|9cyk0|9d440|s3180|1twas0|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|7j5400|asw00|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "360|300",
                offsetIndices: "0101011010101010101010101010101010101010101010101010101010101010101010101010101010101010111010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "US/Michigan",
                untils: "-xx8dyd|5eraud|dyeyk0|1tzb40|2dq40|1c9440|7x3w0|9rlbxo|71s2c|9d440|9cyk0|2cmdg0|9cyk0|3lpg0|f4d80|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "332.1833|360|300|240",
                offsetIndices: "0123323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232"
            }, {
                id: "US/Mountain",
                untils: "-r0epo0|ast80|7x9g0|ast80|7x9g0|b5rw0|7kas0|2vmk0|ataw40|1tz5k0|2dvo0|a7n9g0|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "420|360",
                offsetIndices: "01010101011010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "US/Pacific-New",
                untils: "-r0emw0|ast80|7x9g0|ast80|bmtus0|1tz2s0|2dyg0|1a3c5o|f2iic|owao0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|902o0|9q000|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "480|420",
                offsetIndices: "010101101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "US/Pacific",
                untils: "-r0emw0|ast80|7x9g0|ast80|bmtus0|1tz2s0|2dyg0|1a3c5o|f2iic|owao0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|902o0|9q000|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|9d440|9cyk0|9d440|9cyk0|3lpg0|f4d80|64g40|clmk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|9d440|9px80|905g0|9px80|9d440|9cyk0|9d440|9cyk0|9d440|9cyk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|8a840|afuk0|8a840|afuk0|8a840|ast80|7x9g0|ast80|7x9g0|ast80|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6udg0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|6hes0|c8nw0|Infinity",
                offsets: "480|420",
                offsetIndices: "010101101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "US/Samoa",
                untils: "-usij20|Infinity",
                offsets: "682.8|660",
                offsetIndices: "01"
            }, {
                id: "UTC",
                untils: "Infinity",
                offsets: "0",
                offsetIndices: "0"
            }, {
                id: "W-SU",
                untils: "-rx5dmh|ipzua|97hc0|7yyk0|5i840|d9p80|1jwk7|2cvk0|s8o00|1qvw0|8fpc0|1jms0|is040|412as0|qi27w0|9et80|9d440|9et80|9d440|9et80|9eys0|9d6w0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d440|5reo0|3ljw0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|1vbzw0|Infinity",
                offsets: "-150.2833|-151.3167|-211.3167|-271.3167|-240|-180|-300|-120",
                offsetIndices: "012132345464575454545454545454545455754545454545454545454545454545454545454545"
            }, {
                id: "WET",
                untils: "3s9ms0|902o0|9q000|9d1c0|9d1c0|9d1c0|9q000|902o0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9d1c0|9q000|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|7x6o0|b5uo0|7k800|b5uo0|7k800|b5uo0|7k800|b5uo0|7x6o0|asw00|7x6o0|asw00|Infinity",
                offsets: "0|-60",
                offsetIndices: "010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010"
            }, {
                id: "Zulu",
                untils: "Infinity",
                offsets: "0",
                offsetIndices: "0"
            }]
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/dateAdapter.js ***!
      \**************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }
        var toMs = _date.default.dateToMilliseconds;
        var DateAdapterCore = function() {
            function DateAdapterCore(source) {
                this._source = new Date(source.getTime ? source.getTime() : source)
            }
            var _proto = DateAdapterCore.prototype;
            _proto.result = function() {
                return this._source
            };
            _proto.getTimezoneOffset = function() {
                var format = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0;
                var value = this._source.getTimezoneOffset();
                if ("minute" === format) {
                    return value * toMs("minute")
                }
                return value
            };
            _proto.getTime = function() {
                return this._source.getTime()
            };
            _proto.setTime = function(value) {
                this._source.setTime(value);
                return this
            };
            _proto.addTime = function(value) {
                this._source.setTime(this._source.getTime() + value);
                return this
            };
            _proto.setMinutes = function(value) {
                this._source.setMinutes(value);
                return this
            };
            _proto.addMinutes = function(value) {
                this._source.setMinutes(this._source.getMinutes() + value);
                return this
            };
            _proto.subtractMinutes = function(value) {
                this._source.setMinutes(this._source.getMinutes() - value);
                return this
            };
            _createClass(DateAdapterCore, [{
                key: "source",
                get: function() {
                    return this._source
                }
            }]);
            return DateAdapterCore
        }();
        var DateAdapter = function(date) {
            return new DateAdapterCore(date)
        };
        var _default = DateAdapter;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************************!*\
      !*** ./artifacts/transpiled-npm/mobile/hide_top_overlay.js ***!
      \*************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = _default;
        var _hide_callback = __webpack_require__( /*! ./hide_callback */ 232);

        function _default() {
            return _hide_callback.hideCallback.fire()
        }
        module.exports = exports.default
    },
    /*!************************************************************************!*\
      !*** ./artifacts/transpiled-npm/events/utils/event_nodes_disposing.js ***!
      \************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.unsubscribeNodesDisposing = exports.subscribeNodesDisposing = void 0;
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../core/events_engine */ 5));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var REMOVE_EVENT_NAME = "dxremove";

        function nodesByEvent(event) {
            return event && [event.target, event.delegateTarget, event.relatedTarget, event.currentTarget].filter(function(node) {
                return !!node
            })
        }
        var subscribeNodesDisposing = function(event, callback) {
            _events_engine.default.one(nodesByEvent(event), REMOVE_EVENT_NAME, callback)
        };
        exports.subscribeNodesDisposing = subscribeNodesDisposing;
        var unsubscribeNodesDisposing = function(event, callback) {
            _events_engine.default.off(nodesByEvent(event), REMOVE_EVENT_NAME, callback)
        };
        exports.unsubscribeNodesDisposing = unsubscribeNodesDisposing
    },
    /*!**************************************************************!*\
      !*** ./artifacts/transpiled-npm/events/pointer/mspointer.js ***!
      \**************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _base = _interopRequireDefault(__webpack_require__( /*! ./base */ 169));
        var _observer = _interopRequireDefault(__webpack_require__( /*! ./observer */ 255));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var eventMap = {
            dxpointerdown: "pointerdown",
            dxpointermove: "pointermove",
            dxpointerup: "pointerup",
            dxpointercancel: "pointercancel",
            dxpointerover: "pointerover",
            dxpointerout: "pointerout",
            dxpointerenter: "pointerenter",
            dxpointerleave: "pointerleave"
        };
        var observer;
        var activated = false;
        var activateStrategy = function() {
            if (activated) {
                return
            }
            observer = new _observer.default(eventMap, function(a, b) {
                return a.pointerId === b.pointerId
            }, function(e) {
                if (e.isPrimary) {
                    observer.reset()
                }
            });
            activated = true
        };
        var MsPointerStrategy = _base.default.inherit({
            ctor: function() {
                this.callBase.apply(this, arguments);
                activateStrategy()
            },
            _fireEvent: function(args) {
                return this.callBase((0, _extend.extend)({
                    pointers: observer.pointers(),
                    pointerId: args.originalEvent.pointerId
                }, args))
            }
        });
        MsPointerStrategy.map = eventMap;
        MsPointerStrategy.resetObserver = function() {
            observer.reset()
        };
        var _default = MsPointerStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/events/pointer/mouse_and_touch.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _base = _interopRequireDefault(__webpack_require__( /*! ./base */ 169));
        var _mouse = _interopRequireDefault(__webpack_require__( /*! ./mouse */ 256));
        var _touch = _interopRequireDefault(__webpack_require__( /*! ./touch */ 254));
        var _index = __webpack_require__( /*! ../utils/index */ 8);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var eventMap = {
            dxpointerdown: "touchstart mousedown",
            dxpointermove: "touchmove mousemove",
            dxpointerup: "touchend mouseup",
            dxpointercancel: "touchcancel",
            dxpointerover: "mouseover",
            dxpointerout: "mouseout",
            dxpointerenter: "mouseenter",
            dxpointerleave: "mouseleave"
        };
        var activated = false;
        var activateStrategy = function() {
            if (activated) {
                return
            }
            _mouse.default.activate();
            activated = true
        };
        var MouseAndTouchStrategy = _base.default.inherit({
            EVENT_LOCK_TIMEOUT: 100,
            ctor: function() {
                this.callBase.apply(this, arguments);
                activateStrategy()
            },
            _handler: function(e) {
                var isMouse = (0, _index.isMouseEvent)(e);
                if (!isMouse) {
                    this._skipNextEvents = true
                }
                if (isMouse && this._mouseLocked) {
                    return
                }
                if (isMouse && this._skipNextEvents) {
                    this._skipNextEvents = false;
                    this._mouseLocked = true;
                    clearTimeout(this._unlockMouseTimer);
                    var that = this;
                    this._unlockMouseTimer = setTimeout(function() {
                        that._mouseLocked = false
                    }, this.EVENT_LOCK_TIMEOUT);
                    return
                }
                return this.callBase(e)
            },
            _fireEvent: function(args) {
                var normalizer = (0, _index.isMouseEvent)(args.originalEvent) ? _mouse.default.normalize : _touch.default.normalize;
                return this.callBase((0, _extend.extend)(normalizer(args.originalEvent), args))
            },
            dispose: function() {
                this.callBase();
                this._skipNextEvents = false;
                this._mouseLocked = false;
                clearTimeout(this._unlockMouseTimer)
            }
        });
        MouseAndTouchStrategy.map = eventMap;
        MouseAndTouchStrategy.resetObserver = _mouse.default.resetObserver;
        var _default = MouseAndTouchStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/localization.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.disableIntl = disableIntl;
        Object.defineProperty(exports, "message", {
            enumerable: true,
            get: function() {
                return _message.default
            }
        });
        Object.defineProperty(exports, "number", {
            enumerable: true,
            get: function() {
                return _number.default
            }
        });
        Object.defineProperty(exports, "date", {
            enumerable: true,
            get: function() {
                return _date.default
            }
        });
        exports.parseDate = exports.formatDate = exports.parseNumber = exports.formatNumber = exports.formatMessage = exports.loadMessages = exports.locale = void 0;
        var _core = _interopRequireDefault(__webpack_require__( /*! ./localization/core */ 87));
        var _message = _interopRequireDefault(__webpack_require__( /*! ./localization/message */ 10));
        var _number = _interopRequireDefault(__webpack_require__( /*! ./localization/number */ 47));
        var _date = _interopRequireDefault(__webpack_require__( /*! ./localization/date */ 32));
        __webpack_require__( /*! ./localization/currency */ 114);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var locale = _core.default.locale.bind(_core.default);
        exports.locale = locale;
        var loadMessages = _message.default.load.bind(_message.default);
        exports.loadMessages = loadMessages;
        var formatMessage = _message.default.format.bind(_message.default);
        exports.formatMessage = formatMessage;
        var formatNumber = _number.default.format.bind(_number.default);
        exports.formatNumber = formatNumber;
        var parseNumber = _number.default.parse.bind(_number.default);
        exports.parseNumber = parseNumber;
        var formatDate = _date.default.format.bind(_date.default);
        exports.formatDate = formatDate;
        var parseDate = _date.default.parse.bind(_date.default);
        exports.parseDate = parseDate;

        function disableIntl() {
            if ("intl" === _number.default.engine()) {
                _number.default.resetInjection()
            }
            if ("intl" === _date.default.engine()) {
                _date.default.resetInjection()
            }
        }
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/jquery/renderer.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _jquery = _interopRequireDefault(__webpack_require__( /*! jquery */ 60));
        var _renderer_base = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer_base */ 236));
        var _use_jquery = _interopRequireDefault(__webpack_require__( /*! ./use_jquery */ 89));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var useJQuery = (0, _use_jquery.default)();
        if (useJQuery) {
            _renderer_base.default.set(_jquery.default)
        }
    },
    /*!**************************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/jquery/hooks.js ***!
      \**************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _jquery = _interopRequireDefault(__webpack_require__( /*! jquery */ 60));
        var _use_jquery = _interopRequireDefault(__webpack_require__( /*! ./use_jquery */ 89));
        var _version = __webpack_require__( /*! ../../core/utils/version */ 72);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _event_registrator = _interopRequireDefault(__webpack_require__( /*! ../../events/core/event_registrator */ 74));
        var _hook_touch_props = _interopRequireDefault(__webpack_require__( /*! ../../events/core/hook_touch_props */ 237));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var useJQuery = (0, _use_jquery.default)();
        if (useJQuery) {
            if ((0, _version.compare)(_jquery.default.fn.jquery, [3]) < 0) {
                var POINTER_TYPE_MAP = {
                    2: "touch",
                    3: "pen",
                    4: "mouse"
                };
                (0, _iterator.each)(["MSPointerDown", "MSPointerMove", "MSPointerUp", "MSPointerCancel", "MSPointerOver", "MSPointerOut", "mouseenter", "mouseleave", "pointerdown", "pointermove", "pointerup", "pointercancel", "pointerover", "pointerout", "pointerenter", "pointerleave"], function() {
                    _jquery.default.event.fixHooks[this] = {
                        filter: function(event, originalEvent) {
                            var pointerType = originalEvent.pointerType;
                            if ((0, _type.isNumeric)(pointerType)) {
                                event.pointerType = POINTER_TYPE_MAP[pointerType]
                            }
                            return event
                        },
                        props: _jquery.default.event.mouseHooks.props.concat(["pointerId", "pointerType", "originalTarget", "width", "height", "pressure", "result", "tiltX", "charCode", "tiltY", "detail", "isPrimary", "prevValue"])
                    }
                });
                (0, _iterator.each)(["touchstart", "touchmove", "touchend", "touchcancel"], function() {
                    _jquery.default.event.fixHooks[this] = {
                        filter: function(event, originalEvent) {
                            (0, _hook_touch_props.default)(function(name, hook) {
                                event[name] = hook(originalEvent)
                            });
                            return event
                        },
                        props: _jquery.default.event.mouseHooks.props.concat(["touches", "changedTouches", "targetTouches", "detail", "result", "originalTarget", "charCode", "prevValue"])
                    }
                });
                _jquery.default.event.fixHooks.wheel = _jquery.default.event.mouseHooks;
                var DX_EVENT_HOOKS = {
                    props: _jquery.default.event.mouseHooks.props.concat(["pointerType", "pointerId", "pointers"])
                };
                _event_registrator.default.callbacks.add(function(name) {
                    _jquery.default.event.fixHooks[name] = DX_EVENT_HOOKS
                });
                var fix = function(event, originalEvent) {
                    var fixHook = _jquery.default.event.fixHooks[originalEvent.type] || _jquery.default.event.mouseHooks;
                    var props = fixHook.props ? _jquery.default.event.props.concat(fixHook.props) : _jquery.default.event.props;
                    var propIndex = props.length;
                    while (propIndex--) {
                        var prop = props[propIndex];
                        event[prop] = originalEvent[prop]
                    }
                    return fixHook.filter ? fixHook.filter(event, originalEvent) : event
                };
                (0, _index.setEventFixMethod)(fix)
            } else {
                (0, _hook_touch_props.default)(function(name, hook) {
                    _jquery.default.event.addProp(name, hook)
                })
            }
        }
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/jquery/deferred.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _jquery = _interopRequireDefault(__webpack_require__( /*! jquery */ 60));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _version = __webpack_require__( /*! ../../core/utils/version */ 72);
        var _use_jquery = _interopRequireDefault(__webpack_require__( /*! ./use_jquery */ 89));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var useJQuery = (0, _use_jquery.default)();
        if (useJQuery) {
            var Deferred = _jquery.default.Deferred;
            var strategy = {
                Deferred: Deferred
            };
            strategy.when = (0, _version.compare)(_jquery.default.fn.jquery, [3]) < 0 ? _jquery.default.when : function(singleArg) {
                if (0 === arguments.length) {
                    return (new Deferred).resolve()
                } else {
                    if (1 === arguments.length) {
                        return singleArg && singleArg.then ? singleArg : (new Deferred).resolve(singleArg)
                    } else {
                        return _jquery.default.when.apply(_jquery.default, arguments)
                    }
                }
            };
            (0, _deferred.setStrategy)(strategy)
        }
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/jquery/hold_ready.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _jquery = _interopRequireDefault(__webpack_require__( /*! jquery */ 60));
        var _themes_callback = __webpack_require__( /*! ../../ui/themes_callback */ 258);
        var _ready_callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/ready_callbacks */ 49));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        if (_jquery.default && !_themes_callback.themeReadyCallback.fired()) {
            var holdReady = _jquery.default.holdReady || _jquery.default.fn.holdReady;
            holdReady(true);
            _themes_callback.themeReadyCallback.add(function() {
                _ready_callbacks.default.add(function() {
                    holdReady(false)
                })
            })
        }
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/jquery/events.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _jquery = _interopRequireDefault(__webpack_require__( /*! jquery */ 60));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _use_jquery = _interopRequireDefault(__webpack_require__( /*! ./use_jquery */ 89));
        var _event_registrator_callbacks = _interopRequireDefault(__webpack_require__( /*! ../../events/core/event_registrator_callbacks */ 131));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var useJQuery = (0, _use_jquery.default)();
        if (useJQuery) {
            _event_registrator_callbacks.default.add(function(name, eventObject) {
                _jquery.default.event.special[name] = eventObject
            });
            if (_events_engine.default.passiveEventHandlersSupported()) {
                _events_engine.default.forcePassiveFalseEventNames.forEach(function(eventName) {
                    _jquery.default.event.special[eventName] = {
                        setup: function(data, namespaces, handler) {
                            _dom_adapter.default.listen(this, eventName, handler, {
                                passive: false
                            })
                        }
                    }
                })
            }
            _events_engine.default.set({
                on: function(element) {
                    (0, _jquery.default)(element).on.apply((0, _jquery.default)(element), Array.prototype.slice.call(arguments, 1))
                },
                one: function(element) {
                    (0, _jquery.default)(element).one.apply((0, _jquery.default)(element), Array.prototype.slice.call(arguments, 1))
                },
                off: function(element) {
                    (0, _jquery.default)(element).off.apply((0, _jquery.default)(element), Array.prototype.slice.call(arguments, 1))
                },
                trigger: function(element) {
                    (0, _jquery.default)(element).trigger.apply((0, _jquery.default)(element), Array.prototype.slice.call(arguments, 1))
                },
                triggerHandler: function(element) {
                    (0, _jquery.default)(element).triggerHandler.apply((0, _jquery.default)(element), Array.prototype.slice.call(arguments, 1))
                },
                Event: _jquery.default.Event
            })
        }
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/jquery/easing.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _jquery = _interopRequireDefault(__webpack_require__( /*! jquery */ 60));
        var _easing = __webpack_require__( /*! ../../animation/easing */ 253);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        if (_jquery.default) {
            (0, _easing.setEasing)(_jquery.default.easing)
        }
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/jquery/element_data.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _jquery = _interopRequireDefault(__webpack_require__( /*! jquery */ 60));
        var _element_data = __webpack_require__( /*! ../../core/element_data */ 40);
        var _use_jquery = _interopRequireDefault(__webpack_require__( /*! ./use_jquery */ 89));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var useJQuery = (0, _use_jquery.default)();
        if (useJQuery) {
            (0, _element_data.setDataStrategy)(_jquery.default)
        }
    },
    /*!****************************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/jquery/element.js ***!
      \****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _element = __webpack_require__( /*! ../../core/element */ 18);
        var _use_jquery = _interopRequireDefault(__webpack_require__( /*! ./use_jquery */ 89));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var useJQuery = (0, _use_jquery.default)();
        var getPublicElement = function($element) {
            return $element
        };
        if (useJQuery) {
            (0, _element.setPublicElementWrapper)(getPublicElement)
        }
    },
    /*!******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/jquery/component_registrator.js ***!
      \******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _jquery = _interopRequireDefault(__webpack_require__( /*! jquery */ 60));
        var _component_registrator_callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator_callbacks */ 167));
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../../core/errors */ 25));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        if (_jquery.default) {
            var registerJQueryComponent = function(name, componentClass) {
                _jquery.default.fn[name] = function(options) {
                    var isMemberInvoke = "string" === typeof options;
                    var result;
                    if (isMemberInvoke) {
                        var memberName = options;
                        var memberArgs = [].slice.call(arguments).slice(1);
                        this.each(function() {
                            var instance = componentClass.getInstance(this);
                            if (!instance) {
                                throw _errors.default.Error("E0009", name)
                            }
                            var member = instance[memberName];
                            var memberValue = member.apply(instance, memberArgs);
                            if (void 0 === result) {
                                result = memberValue
                            }
                        })
                    } else {
                        this.each(function() {
                            var instance = componentClass.getInstance(this);
                            if (instance) {
                                instance.option(options)
                            } else {
                                new componentClass(this, options)
                            }
                        });
                        result = this
                    }
                    return result
                }
            };
            _component_registrator_callbacks.default.add(registerJQueryComponent)
        }
    },
    /*!*************************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/jquery/ajax.js ***!
      \*************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _jquery = _interopRequireDefault(__webpack_require__( /*! jquery */ 60));
        var _ajax = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/ajax */ 79));
        var _use_jquery = _interopRequireDefault(__webpack_require__( /*! ./use_jquery */ 89));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var useJQuery = (0, _use_jquery.default)();
        if (useJQuery) {
            _ajax.default.inject({
                sendRequest: function(options) {
                    if (!options.responseType && !options.upload) {
                        return _jquery.default.ajax(options)
                    }
                    return this.callBase.apply(this, [options])
                }
            })
        }
    },
    /*!*********************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/angular.js ***!
      \*********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        __webpack_require__( /*! ./jquery */ 257);
        __webpack_require__( /*! ./angular/component_registrator */ 545);
        __webpack_require__( /*! ./angular/event_registrator */ 553);
        __webpack_require__( /*! ./angular/components */ 554);
        __webpack_require__( /*! ./angular/action_executors */ 555)
    },
    /*!*******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/angular/component_registrator.js ***!
      \*******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _angular = _interopRequireDefault(__webpack_require__( /*! angular */ 133));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _config = _interopRequireDefault(__webpack_require__( /*! ../../core/config */ 31));
        var _component_registrator_callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator_callbacks */ 167));
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/callbacks */ 27));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _locker = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/locker */ 259));
        var _editor = _interopRequireDefault(__webpack_require__( /*! ../../ui/editor/editor */ 52));
        var _template = __webpack_require__( /*! ./template */ 547);
        var _module = _interopRequireDefault(__webpack_require__( /*! ./module */ 201));
        var _uiCollection_widget = _interopRequireDefault(__webpack_require__( /*! ../../ui/collection/ui.collection_widget.edit */ 54));
        var _data = __webpack_require__( /*! ../../core/utils/data */ 20);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _comparator = __webpack_require__( /*! ../../core/utils/comparator */ 249);
        var _inflector = __webpack_require__( /*! ../../core/utils/inflector */ 39);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        var ITEM_ALIAS_ATTRIBUTE_NAME = "dxItemAlias";
        var SKIP_APPLY_ACTION_CATEGORIES = ["rendering"];
        var NG_MODEL_OPTION = "value";
        if (_angular.default) {
            var safeApply = function(func, scope) {
                if (scope.$root.$$phase) {
                    return func(scope)
                } else {
                    return scope.$apply(function() {
                        return func(scope)
                    })
                }
            };
            var getClassMethod = function getClassMethod(initClass, methodName) {
                var hasParentProperty = Object.prototype.hasOwnProperty.bind(initClass)("parent");
                var isES6Class = !hasParentProperty && initClass.parent;
                if (isES6Class) {
                    var baseClass = Object.getPrototypeOf(initClass);
                    return baseClass.prototype[methodName] ? function() {
                        return baseClass.prototype[methodName]()
                    } : getClassMethod(baseClass, methodName)
                } else {
                    var method = initClass.parent.prototype[methodName];
                    if (method) {
                        return function() {
                            return method()
                        }
                    }
                    if (!method || !initClass.parent.subclassOf) {
                        return function() {
                            return
                        }
                    }
                    return getClassMethod(initClass.parent, methodName)
                }
            };
            var ComponentBuilder = _class.default.inherit({
                ctor: function(options) {
                    this._componentDisposing = (0, _callbacks.default)();
                    this._optionChangedCallbacks = (0, _callbacks.default)();
                    this._ngLocker = new _locker.default;
                    this._scope = options.scope;
                    this._$element = options.$element;
                    this._$templates = options.$templates;
                    this._componentClass = options.componentClass;
                    this._parse = options.parse;
                    this._compile = options.compile;
                    this._itemAlias = options.itemAlias;
                    this._transcludeFn = options.transcludeFn;
                    this._digestCallbacks = options.dxDigestCallbacks;
                    this._normalizeOptions(options.ngOptions);
                    this._initComponentBindings();
                    this._initComponent(this._scope);
                    if (!options.ngOptions) {
                        this._addOptionsStringWatcher(options.ngOptionsString)
                    }
                },
                _addOptionsStringWatcher: function(optionsString) {
                    var _this = this;
                    var clearOptionsStringWatcher = this._scope.$watch(optionsString, function(newOptions) {
                        if (!newOptions) {
                            return
                        }
                        clearOptionsStringWatcher();
                        _this._normalizeOptions(newOptions);
                        _this._initComponentBindings();
                        _this._component.option(_this._evalOptions(_this._scope))
                    });
                    this._componentDisposing.add(clearOptionsStringWatcher)
                },
                _normalizeOptions: function(options) {
                    var _this2 = this;
                    this._ngOptions = (0, _extend.extendFromObject)({}, options);
                    if (!options) {
                        return
                    }
                    if (!Object.prototype.hasOwnProperty.call(options, "bindingOptions") && options.bindingOptions) {
                        this._ngOptions.bindingOptions = options.bindingOptions
                    }
                    if (options.bindingOptions) {
                        (0, _iterator.each)(options.bindingOptions, function(key, value) {
                            if ("string" === (0, _type.type)(value)) {
                                _this2._ngOptions.bindingOptions[key] = {
                                    dataPath: value
                                }
                            }
                        })
                    }
                },
                _initComponent: function(scope) {
                    this._component = new this._componentClass(this._$element, this._evalOptions(scope));
                    this._component._isHidden = true;
                    this._handleDigestPhase()
                },
                _handleDigestPhase: function() {
                    var _this3 = this;
                    var beginUpdate = function() {
                        _this3._component.beginUpdate()
                    };
                    var endUpdate = function() {
                        _this3._component.endUpdate()
                    };
                    this._digestCallbacks.begin.add(beginUpdate);
                    this._digestCallbacks.end.add(endUpdate);
                    this._componentDisposing.add(function() {
                        _this3._digestCallbacks.begin.remove(beginUpdate);
                        _this3._digestCallbacks.end.remove(endUpdate)
                    })
                },
                _initComponentBindings: function() {
                    var _this4 = this;
                    var optionDependencies = {};
                    if (!this._ngOptions.bindingOptions) {
                        return
                    }(0, _iterator.each)(this._ngOptions.bindingOptions, function(optionPath, value) {
                        var separatorIndex = optionPath.search(/\[|\./);
                        var optionForSubscribe = separatorIndex > -1 ? optionPath.substring(0, separatorIndex) : optionPath;
                        var prevWatchMethod;
                        var clearWatcher;
                        var valuePath = value.dataPath;
                        var deepWatch = true;
                        var forcePlainWatchMethod = false;
                        if (void 0 !== value.deep) {
                            forcePlainWatchMethod = deepWatch = !!value.deep
                        }
                        if (!optionDependencies[optionForSubscribe]) {
                            optionDependencies[optionForSubscribe] = {}
                        }
                        optionDependencies[optionForSubscribe][optionPath] = valuePath;
                        var updateWatcher = function updateWatcher() {
                            var watchCallback = function(newValue, oldValue) {
                                if (_this4._ngLocker.locked(optionPath)) {
                                    return
                                }
                                _this4._ngLocker.obtain(optionPath);
                                _this4._component.option(optionPath, newValue);
                                updateWatcher();
                                if ((0, _comparator.equals)(oldValue, newValue) && _this4._ngLocker.locked(optionPath)) {
                                    _this4._ngLocker.release(optionPath)
                                }
                            };
                            var watchMethod = Array.isArray(_this4._scope.$eval(valuePath)) && !forcePlainWatchMethod ? "$watchCollection" : "$watch";
                            if (prevWatchMethod !== watchMethod) {
                                if (clearWatcher) {
                                    clearWatcher()
                                }
                                clearWatcher = _this4._scope[watchMethod](valuePath, watchCallback, deepWatch);
                                prevWatchMethod = watchMethod
                            }
                        };
                        updateWatcher();
                        _this4._componentDisposing.add(clearWatcher)
                    });
                    this._optionChangedCallbacks.add(function(args) {
                        var optionName = args.name;
                        var fullName = args.fullName;
                        var component = args.component;
                        if (_this4._ngLocker.locked(fullName)) {
                            _this4._ngLocker.release(fullName);
                            return
                        }
                        if (!optionDependencies || !optionDependencies[optionName]) {
                            return
                        }
                        var isActivePhase = _this4._scope.$root.$$phase;
                        var obtainOption = function() {
                            _this4._ngLocker.obtain(fullName)
                        };
                        if (isActivePhase) {
                            _this4._digestCallbacks.begin.add(obtainOption)
                        } else {
                            obtainOption()
                        }
                        safeApply(function() {
                            (0, _iterator.each)(optionDependencies[optionName], function(optionPath, valuePath) {
                                if (!_this4._optionsAreLinked(fullName, optionPath)) {
                                    return
                                }
                                var value = component.option(optionPath);
                                _this4._parse(valuePath).assign(_this4._scope, value);
                                var scopeValue = _this4._parse(valuePath)(_this4._scope);
                                if (scopeValue !== value) {
                                    args.component.option(optionPath, scopeValue)
                                }
                            })
                        }, _this4._scope);
                        var releaseOption = function releaseOption() {
                            if (_this4._ngLocker.locked(fullName)) {
                                _this4._ngLocker.release(fullName)
                            }
                            _this4._digestCallbacks.begin.remove(obtainOption);
                            _this4._digestCallbacks.end.remove(releaseOption)
                        };
                        if (isActivePhase) {
                            _this4._digestCallbacks.end.addPrioritized(releaseOption)
                        } else {
                            releaseOption()
                        }
                    })
                },
                _optionsAreNested: function(optionPath1, optionPath2) {
                    var parentSeparator = optionPath1[optionPath2.length];
                    return 0 === optionPath1.indexOf(optionPath2) && ("." === parentSeparator || "[" === parentSeparator)
                },
                _optionsAreLinked: function(optionPath1, optionPath2) {
                    if (optionPath1 === optionPath2) {
                        return true
                    }
                    return optionPath1.length > optionPath2.length ? this._optionsAreNested(optionPath1, optionPath2) : this._optionsAreNested(optionPath2, optionPath1)
                },
                _compilerByTemplate: function(template) {
                    var _this5 = this;
                    var scopeItemsPath = this._getScopeItemsPath();
                    return function(options) {
                        var $resultMarkup = (0, _renderer.default)(template).clone();
                        var dataIsScope = options.model && options.model.constructor === _this5._scope.$root.constructor;
                        var templateScope = dataIsScope ? options.model : options.noModel ? _this5._scope : _this5._createScopeWithData(options);
                        if (scopeItemsPath) {
                            _this5._synchronizeScopes(templateScope, scopeItemsPath, options.index)
                        }
                        $resultMarkup.appendTo(options.container);
                        if (!options.noModel) {
                            _events_engine.default.on($resultMarkup, "$destroy", function() {
                                var destroyAlreadyCalled = !templateScope.$parent;
                                if (destroyAlreadyCalled) {
                                    return
                                }
                                templateScope.$destroy()
                            })
                        }
                        var ngTemplate = _this5._compile($resultMarkup, _this5._transcludeFn);
                        _this5._applyAsync(function(scope) {
                            ngTemplate(scope, null, {
                                parentBoundTranscludeFn: _this5._transcludeFn
                            })
                        }, templateScope);
                        return $resultMarkup
                    }
                },
                _applyAsync: function(func, scope) {
                    var _this6 = this;
                    func(scope);
                    if (!scope.$root.$$phase) {
                        if (!this._renderingTimer) {
                            var clearRenderingTimer = function() {
                                clearTimeout(_this6._renderingTimer)
                            };
                            this._renderingTimer = setTimeout(function() {
                                scope.$apply();
                                _this6._renderingTimer = null;
                                _this6._componentDisposing.remove(clearRenderingTimer)
                            });
                            this._componentDisposing.add(clearRenderingTimer)
                        }
                    }
                },
                _getScopeItemsPath: function() {
                    if (this._componentClass.subclassOf(_uiCollection_widget.default) && this._ngOptions.bindingOptions && this._ngOptions.bindingOptions.items) {
                        return this._ngOptions.bindingOptions.items.dataPath
                    }
                },
                _createScopeWithData: function(options) {
                    var newScope = this._scope.$new();
                    if (this._itemAlias) {
                        newScope[this._itemAlias] = options.model
                    }
                    if ((0, _type.isDefined)(options.index)) {
                        newScope.$index = options.index
                    }
                    return newScope
                },
                _synchronizeScopes: function(itemScope, parentPrefix, itemIndex) {
                    if (this._itemAlias && "object" !== _typeof(itemScope[this._itemAlias])) {
                        this._synchronizeScopeField({
                            parentScope: this._scope,
                            childScope: itemScope,
                            fieldPath: this._itemAlias,
                            parentPrefix: parentPrefix,
                            itemIndex: itemIndex
                        })
                    }
                },
                _synchronizeScopeField: function(args) {
                    var parentScope = args.parentScope;
                    var childScope = args.childScope;
                    var fieldPath = args.fieldPath;
                    var parentPrefix = args.parentPrefix;
                    var itemIndex = args.itemIndex;
                    var innerPathSuffix = fieldPath === this._itemAlias ? "" : "." + fieldPath;
                    var collectionField = void 0 !== itemIndex;
                    var optionOuterBag = [parentPrefix];
                    if (collectionField) {
                        if (!(0, _type.isNumeric)(itemIndex)) {
                            return
                        }
                        optionOuterBag.push("[", itemIndex, "]")
                    }
                    optionOuterBag.push(innerPathSuffix);
                    var optionOuterPath = optionOuterBag.join("");
                    var clearParentWatcher = parentScope.$watch(optionOuterPath, function(newValue, oldValue) {
                        if (newValue !== oldValue) {
                            (0, _data.compileSetter)(fieldPath)(childScope, newValue)
                        }
                    });
                    var clearItemWatcher = childScope.$watch(fieldPath, function(newValue, oldValue) {
                        if (newValue !== oldValue) {
                            if (collectionField && !(0, _data.compileGetter)(parentPrefix)(parentScope)[itemIndex]) {
                                clearItemWatcher();
                                return
                            }(0, _data.compileSetter)(optionOuterPath)(parentScope, newValue)
                        }
                    });
                    this._componentDisposing.add([clearParentWatcher, clearItemWatcher])
                },
                _evalOptions: function(scope) {
                    var _this8 = this;
                    var result = (0, _extend.extendFromObject)({}, this._ngOptions);
                    delete result.bindingOptions;
                    if (this._ngOptions.bindingOptions) {
                        (0, _iterator.each)(this._ngOptions.bindingOptions, function(key, value) {
                            result[key] = scope.$eval(value.dataPath)
                        })
                    }
                    result._optionChangedCallbacks = this._optionChangedCallbacks;
                    result._disposingCallbacks = this._componentDisposing;
                    result.onActionCreated = function(component, action, config) {
                        if (config && (0, _array.inArray)(config.category, SKIP_APPLY_ACTION_CATEGORIES) > -1) {
                            return action
                        }
                        var wrappedAction = function() {
                            var _this7 = this;
                            var args = arguments;
                            if (!scope || !scope.$root || scope.$root.$$phase) {
                                return action.apply(this, args)
                            }
                            return safeApply(function() {
                                return action.apply(_this7, args)
                            }, scope)
                        };
                        return wrappedAction
                    };
                    result.beforeActionExecute = result.onActionCreated;
                    result.nestedComponentOptions = function(component) {
                        return {
                            templatesRenderAsynchronously: component.option("templatesRenderAsynchronously"),
                            forceApplyBindings: component.option("forceApplyBindings"),
                            modelByElement: component.option("modelByElement"),
                            onActionCreated: component.option("onActionCreated"),
                            beforeActionExecute: component.option("beforeActionExecute"),
                            nestedComponentOptions: component.option("nestedComponentOptions")
                        }
                    };
                    result.templatesRenderAsynchronously = true;
                    if ((0, _config.default)().wrapActionsBeforeExecute) {
                        result.forceApplyBindings = function() {
                            safeApply(function() {}, scope)
                        }
                    }
                    result.integrationOptions = {
                        createTemplate: function(element) {
                            return new _template.NgTemplate(element, _this8._compilerByTemplate.bind(_this8))
                        },
                        watchMethod: function(fn, callback, options) {
                            options = options || {};
                            var immediateValue;
                            var skipCallback = options.skipImmediate;
                            var disposeWatcher = scope.$watch(function() {
                                var value = fn();
                                if (value instanceof Date) {
                                    value = value.valueOf()
                                }
                                return value
                            }, function(newValue) {
                                var isSameValue = immediateValue === newValue;
                                if (!skipCallback && (!isSameValue || isSameValue && options.deep)) {
                                    callback(newValue)
                                }
                                skipCallback = false
                            }, options.deep);
                            if (!skipCallback) {
                                immediateValue = fn();
                                callback(immediateValue)
                            }
                            if ((0, _config.default)().wrapActionsBeforeExecute) {
                                _this8._applyAsync(function() {}, scope)
                            }
                            return disposeWatcher
                        },
                        templates: {
                            "dx-polymorph-widget": {
                                render: function(options) {
                                    var widgetName = options.model.widget;
                                    if (!widgetName) {
                                        return
                                    }
                                    var markup = (0, _renderer.default)("<div>").attr((0, _inflector.dasherize)(widgetName), "options").get(0);
                                    var newScope = _this8._scope.$new();
                                    newScope.options = options.model.options;
                                    options.container.append(markup);
                                    _this8._compile(markup)(newScope)
                                }
                            }
                        }
                    };
                    result.modelByElement = function() {
                        return scope
                    };
                    return result
                }
            });
            ComponentBuilder = ComponentBuilder.inherit({
                ctor: function(options) {
                    this._componentName = options.componentName;
                    this._ngModel = options.ngModel;
                    this._ngModelController = options.ngModelController;
                    this.callBase.apply(this, arguments)
                },
                _isNgModelRequired: function() {
                    return (this._componentClass.subclassOf(_editor.default) || this._componentClass.prototype instanceof _editor.default) && this._ngModel
                },
                _initComponentBindings: function() {
                    this.callBase.apply(this, arguments);
                    this._initNgModelBinding()
                },
                _initNgModelBinding: function() {
                    var _this9 = this;
                    if (!this._isNgModelRequired()) {
                        return
                    }
                    var clearNgModelWatcher = this._scope.$watch(this._ngModel, function(newValue, oldValue) {
                        if (_this9._ngLocker.locked(NG_MODEL_OPTION)) {
                            return
                        }
                        if (newValue === oldValue) {
                            return
                        }
                        _this9._component.option(NG_MODEL_OPTION, newValue)
                    });
                    this._optionChangedCallbacks.add(function(args) {
                        _this9._ngLocker.obtain(NG_MODEL_OPTION);
                        try {
                            if (args.name !== NG_MODEL_OPTION) {
                                return
                            }
                            _this9._ngModelController.$setViewValue(args.value)
                        } finally {
                            if (_this9._ngLocker.locked(NG_MODEL_OPTION)) {
                                _this9._ngLocker.release(NG_MODEL_OPTION)
                            }
                        }
                    });
                    this._componentDisposing.add(clearNgModelWatcher)
                },
                _evalOptions: function() {
                    if (!this._isNgModelRequired()) {
                        return this.callBase.apply(this, arguments)
                    }
                    var result = this.callBase.apply(this, arguments);
                    result[NG_MODEL_OPTION] = this._parse(this._ngModel)(this._scope);
                    return result
                }
            });
            var registeredComponents = {};
            var registerComponentDirective = function(name) {
                var priority = "dxValidator" !== name ? 1 : 10;
                _module.default.directive(name, ["$compile", "$parse", "dxDigestCallbacks", function($compile, $parse, dxDigestCallbacks) {
                    return {
                        restrict: "A",
                        require: "^?ngModel",
                        priority: priority,
                        compile: function($element) {
                            var componentClass = registeredComponents[name];
                            var useTemplates = componentClass.prototype._useTemplates ? componentClass.prototype._useTemplates() : getClassMethod(componentClass, "_useTemplates")();
                            var $content = useTemplates ? $element.contents().detach() : null;
                            return function(scope, $element, attrs, ngModelController, transcludeFn) {
                                $element.append($content);
                                safeApply(function() {
                                    new ComponentBuilder({
                                        componentClass: componentClass,
                                        componentName: name,
                                        compile: $compile,
                                        parse: $parse,
                                        $element: $element,
                                        scope: scope,
                                        ngOptionsString: attrs[name],
                                        ngOptions: attrs[name] ? scope.$eval(attrs[name]) : {},
                                        ngModel: attrs.ngModel,
                                        ngModelController: ngModelController,
                                        transcludeFn: transcludeFn,
                                        itemAlias: attrs[ITEM_ALIAS_ATTRIBUTE_NAME],
                                        dxDigestCallbacks: dxDigestCallbacks
                                    })
                                }, scope)
                            }
                        }
                    }
                }])
            };
            _component_registrator_callbacks.default.add(function(name, componentClass) {
                if (!registeredComponents[name]) {
                    registerComponentDirective(name)
                }
                registeredComponents[name] = componentClass
            })
        }
    },
    /*!***********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/validation_message.js ***!
      \***********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _overlay = _interopRequireDefault(__webpack_require__( /*! ./overlay */ 64));
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _string = __webpack_require__( /*! ../core/utils/string */ 43);
        var _position = __webpack_require__( /*! ../core/utils/position */ 22);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var INVALID_MESSAGE = "dx-invalid-message";
        var INVALID_MESSAGE_AUTO = "dx-invalid-message-auto";
        var INVALID_MESSAGE_ALWAYS = "dx-invalid-message-always";
        var INVALID_MESSAGE_CONTENT = "dx-invalid-message-content";
        var VALIDATION_MESSAGE_MIN_WIDTH = 100;
        var ValidationMessage = _overlay.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    integrationOptions: {},
                    templatesRenderAsynchronously: false,
                    shading: false,
                    width: "auto",
                    height: "auto",
                    closeOnOutsideClick: false,
                    closeOnTargetScroll: false,
                    animation: null,
                    visible: true,
                    propagateOutsideClick: true,
                    _checkParentVisibility: false,
                    rtlEnabled: false,
                    contentTemplate: this._renderInnerHtml,
                    maxWidth: "100%",
                    mode: "auto",
                    validationErrors: void 0,
                    positionRequest: void 0,
                    describedElement: void 0,
                    boundary: void 0,
                    offset: {
                        h: 0,
                        v: 0
                    }
                })
            },
            _init: function() {
                this.callBase();
                this.updateMaxWidth();
                this._updatePosition()
            },
            _initMarkup: function() {
                this.callBase();
                this.$element().addClass(INVALID_MESSAGE);
                this._wrapper().addClass(INVALID_MESSAGE);
                this._toggleModeClass();
                this._updateContentId()
            },
            _updateContentId: function() {
                var describedElement = this.option("describedElement") || this.option("container");
                var contentId = (0, _renderer.default)(describedElement).attr("aria-describedby");
                this.$content().addClass(INVALID_MESSAGE_CONTENT).attr("id", contentId)
            },
            _renderInnerHtml: function(element) {
                var $element = element && (0, _renderer.default)(element);
                var validationErrors = this.option("validationErrors") || [];
                var validationErrorMessage = "";
                validationErrors.forEach(function(err) {
                    var separator = validationErrorMessage ? "<br />" : "";
                    validationErrorMessage += separator + (0, _string.encodeHtml)((null === err || void 0 === err ? void 0 : err.message) || "")
                });
                null === $element || void 0 === $element ? void 0 : $element.html(validationErrorMessage)
            },
            _toggleModeClass: function() {
                var mode = this.option("mode");
                this._wrapper().toggleClass(INVALID_MESSAGE_AUTO, "auto" === mode).toggleClass(INVALID_MESSAGE_ALWAYS, "always" === mode)
            },
            updateMaxWidth: function() {
                var _target$outerWidth;
                var target = this.option("target");
                var targetWidth = (null === target || void 0 === target ? void 0 : null === (_target$outerWidth = target.outerWidth) || void 0 === _target$outerWidth ? void 0 : _target$outerWidth.call(target)) || (0, _renderer.default)(target).outerWidth();
                var maxWidth = "100%";
                if (targetWidth) {
                    maxWidth = Math.max(targetWidth, VALIDATION_MESSAGE_MIN_WIDTH)
                }
                this.option({
                    maxWidth: maxWidth
                })
            },
            _updatePosition: function() {
                var _this$option = this.option(),
                    positionRequest = _this$option.positionRequest,
                    rtlEnabled = _this$option.rtlEnabled,
                    offset = _this$option.offset,
                    boundary = _this$option.boundary;
                var positionSide = (0, _position.getDefaultAlignment)(rtlEnabled);
                var verticalPositions = "below" === positionRequest ? [" top", " bottom"] : [" bottom", " top"];
                if (rtlEnabled) {
                    offset.h = -offset.h
                }
                if ("below" !== positionRequest) {
                    offset.v = -offset.v
                }
                this.option("position", {
                    offset: offset,
                    boundary: boundary,
                    my: positionSide + verticalPositions[0],
                    at: positionSide + verticalPositions[1],
                    collision: "none flip"
                })
            },
            _optionChanged: function(args) {
                var name = args.name,
                    value = args.value;
                switch (name) {
                    case "target":
                        this.updateMaxWidth();
                        this.callBase(args);
                        break;
                    case "boundary":
                        this.option("position.boundary", value);
                        break;
                    case "mode":
                        this._toggleModeClass(value);
                        break;
                    case "rtlEnabled":
                    case "offset":
                    case "positionRequest":
                        this._updatePosition();
                        break;
                    case "validationErrors":
                        this._renderInnerHtml(this.$content());
                        break;
                    default:
                        this.callBase(args)
                }
            }
        });
        (0, _component_registrator.default)("dxValidationMessage", ValidationMessage);
        var _default = ValidationMessage;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/angular/template.js ***!
      \******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.NgTemplate = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _template_base = __webpack_require__( /*! ../../core/templates/template_base */ 75);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _dom = __webpack_require__( /*! ../../core/utils/dom */ 33);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var NgTemplate = function(_TemplateBase) {
            _inheritsLoose(NgTemplate, _TemplateBase);

            function NgTemplate(element, templateCompiler) {
                var _this;
                _this = _TemplateBase.call(this) || this;
                _this._element = element;
                _this._compiledTemplate = templateCompiler((0, _dom.normalizeTemplateElement)(_this._element));
                return _this
            }
            var _proto = NgTemplate.prototype;
            _proto._renderCore = function(options) {
                var compiledTemplate = this._compiledTemplate;
                return (0, _type.isFunction)(compiledTemplate) ? compiledTemplate(options) : compiledTemplate
            };
            _proto.source = function() {
                return (0, _renderer.default)(this._element).clone()
            };
            return NgTemplate
        }(_template_base.TemplateBase);
        exports.NgTemplate = NgTemplate
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/collection/ui.collection_widget.base.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _template_manager = __webpack_require__( /*! ../../core/utils/template_manager */ 250);
        var _element = __webpack_require__( /*! ../../core/element */ 18);
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _action = _interopRequireDefault(__webpack_require__( /*! ../../core/action */ 111));
        var _guid = _interopRequireDefault(__webpack_require__( /*! ../../core/guid */ 36));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../../events/pointer */ 24));
        var _data_helper = _interopRequireDefault(__webpack_require__( /*! ../../data_helper */ 92));
        var _item = _interopRequireDefault(__webpack_require__( /*! ./item */ 150));
        var _selectors = __webpack_require__( /*! ../widget/selectors */ 70);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _hold = _interopRequireDefault(__webpack_require__( /*! ../../events/hold */ 104));
        var _data = __webpack_require__( /*! ../../core/utils/data */ 20);
        var _click = __webpack_require__( /*! ../../events/click */ 21);
        var _contextmenu = __webpack_require__( /*! ../../events/contextmenu */ 179);
        var _bindable_template = __webpack_require__( /*! ../../core/templates/bindable_template */ 65);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var COLLECTION_CLASS = "dx-collection";
        var ITEM_CLASS = "dx-item";
        var CONTENT_CLASS_POSTFIX = "-content";
        var ITEM_CONTENT_PLACEHOLDER_CLASS = "dx-item-content-placeholder";
        var ITEM_DATA_KEY = "dxItemData";
        var ITEM_INDEX_KEY = "dxItemIndex";
        var ITEM_TEMPLATE_ID_PREFIX = "tmpl-";
        var ITEMS_OPTIONS_NAME = "dxItem";
        var SELECTED_ITEM_CLASS = "dx-item-selected";
        var ITEM_RESPONSE_WAIT_CLASS = "dx-item-response-wait";
        var EMPTY_COLLECTION = "dx-empty-collection";
        var TEMPLATE_WRAPPER_CLASS = "dx-template-wrapper";
        var ITEM_PATH_REGEX = /^([^.]+\[\d+\]\.)+([\w.]+)$/;
        var ANONYMOUS_TEMPLATE_NAME = "item";
        var FOCUS_UP = "up";
        var FOCUS_DOWN = "down";
        var FOCUS_LEFT = "left";
        var FOCUS_RIGHT = "right";
        var FOCUS_PAGE_UP = "pageup";
        var FOCUS_PAGE_DOWN = "pagedown";
        var FOCUS_LAST = "last";
        var FOCUS_FIRST = "first";
        var CollectionWidget = _ui.default.inherit({
            _activeStateUnit: "." + ITEM_CLASS,
            _supportedKeys: function() {
                var enter = function(e) {
                    var $itemElement = (0, _renderer.default)(this.option("focusedElement"));
                    if (!$itemElement.length) {
                        return
                    }
                    this._itemClickHandler((0, _extend.extend)({}, e, {
                        target: $itemElement.get(0),
                        currentTarget: $itemElement.get(0)
                    }))
                };
                var space = function(e) {
                    e.preventDefault();
                    enter.call(this, e)
                };
                var move = function(location, e) {
                    if (!(0, _index.isCommandKeyPressed)(e)) {
                        e.preventDefault();
                        e.stopPropagation();
                        this._moveFocus(location, e)
                    }
                };
                return (0, _extend.extend)(this.callBase(), {
                    space: space,
                    enter: enter,
                    leftArrow: move.bind(this, FOCUS_LEFT),
                    rightArrow: move.bind(this, FOCUS_RIGHT),
                    upArrow: move.bind(this, FOCUS_UP),
                    downArrow: move.bind(this, FOCUS_DOWN),
                    pageUp: move.bind(this, FOCUS_UP),
                    pageDown: move.bind(this, FOCUS_DOWN),
                    home: move.bind(this, FOCUS_FIRST),
                    end: move.bind(this, FOCUS_LAST)
                })
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    selectOnFocus: false,
                    loopItemFocus: true,
                    items: [],
                    itemTemplate: "item",
                    onItemRendered: null,
                    onItemClick: null,
                    onItemHold: null,
                    itemHoldTimeout: 750,
                    onItemContextMenu: null,
                    onFocusedItemChanged: null,
                    noDataText: _message.default.format("dxCollectionWidget-noDataText"),
                    dataSource: null,
                    _itemAttributes: {},
                    itemTemplateProperty: "template",
                    focusOnSelectedItem: true,
                    focusedElement: null,
                    displayExpr: void 0,
                    disabledExpr: function(data) {
                        return data ? data.disabled : void 0
                    },
                    visibleExpr: function(data) {
                        return data ? data.visible : void 0
                    }
                })
            },
            _init: function() {
                this._compileDisplayGetter();
                this.callBase();
                this._cleanRenderedItems();
                this._refreshDataSource()
            },
            _compileDisplayGetter: function() {
                var displayExpr = this.option("displayExpr");
                this._displayGetter = displayExpr ? (0, _data.compileGetter)(this.option("displayExpr")) : void 0
            },
            _initTemplates: function() {
                this._initItemsFromMarkup();
                this._initDefaultItemTemplate();
                this.callBase()
            },
            _getAnonymousTemplateName: function() {
                return ANONYMOUS_TEMPLATE_NAME
            },
            _initDefaultItemTemplate: function() {
                var fieldsMap = this._getFieldsMap();
                this._templateManager.addDefaultTemplates({
                    item: new _bindable_template.BindableTemplate(function($container, data) {
                        if ((0, _type.isPlainObject)(data)) {
                            this._prepareDefaultItemTemplate(data, $container)
                        } else {
                            if (fieldsMap && (0, _type.isFunction)(fieldsMap.text)) {
                                data = fieldsMap.text(data)
                            }
                            $container.text(String((0, _common.ensureDefined)(data, "")))
                        }
                    }.bind(this), this._getBindableFields(), this.option("integrationOptions.watchMethod"), fieldsMap)
                })
            },
            _getBindableFields: function() {
                return ["text", "html"]
            },
            _getFieldsMap: function() {
                if (this._displayGetter) {
                    return {
                        text: this._displayGetter
                    }
                }
            },
            _prepareDefaultItemTemplate: function(data, $container) {
                if ((0, _type.isDefined)(data.text)) {
                    $container.text(data.text)
                }
                if ((0, _type.isDefined)(data.html)) {
                    $container.html(data.html)
                }
            },
            _initItemsFromMarkup: function() {
                var _this = this;
                var rawItems = (0, _template_manager.findTemplates)(this.$element(), ITEMS_OPTIONS_NAME);
                if (!rawItems.length || this.option("items").length) {
                    return
                }
                var items = rawItems.map(function(_ref) {
                    var element = _ref.element,
                        options = _ref.options;
                    var isTemplateRequired = /\S/.test(element.innerHTML) && !options.template;
                    if (isTemplateRequired) {
                        options.template = _this._prepareItemTemplate(element)
                    } else {
                        (0, _renderer.default)(element).remove()
                    }
                    return options
                });
                this.option("items", items)
            },
            _prepareItemTemplate: function(item) {
                var templateId = ITEM_TEMPLATE_ID_PREFIX + new _guid.default;
                var $template = (0, _renderer.default)(item).detach().clone().removeAttr("data-options").addClass(TEMPLATE_WRAPPER_CLASS);
                this._saveTemplate(templateId, $template);
                return templateId
            },
            _dataSourceOptions: function() {
                return {
                    paginate: false
                }
            },
            _cleanRenderedItems: function() {
                this._renderedItemsCount = 0
            },
            _focusTarget: function() {
                return this.$element()
            },
            _focusInHandler: function(e) {
                this.callBase.apply(this, arguments);
                if ((0, _array.inArray)(e.target, this._focusTarget()) === -1) {
                    return
                }
                var $focusedElement = (0, _renderer.default)(this.option("focusedElement"));
                if ($focusedElement.length) {
                    this._setFocusedItem($focusedElement)
                } else {
                    var $activeItem = this._getActiveItem();
                    if ($activeItem.length) {
                        this.option("focusedElement", (0, _element.getPublicElement)($activeItem))
                    }
                }
            },
            _focusOutHandler: function() {
                this.callBase.apply(this, arguments);
                var $target = (0, _renderer.default)(this.option("focusedElement"));
                this._updateFocusedItemState($target, false)
            },
            _getActiveItem: function(last) {
                var $focusedElement = (0, _renderer.default)(this.option("focusedElement"));
                if ($focusedElement.length) {
                    return $focusedElement
                }
                var index = this.option("focusOnSelectedItem") ? this.option("selectedIndex") : 0;
                var activeElements = this._getActiveElement();
                var lastIndex = activeElements.length - 1;
                if (index < 0) {
                    index = last ? lastIndex : 0
                }
                return activeElements.eq(index)
            },
            _moveFocus: function(location) {
                var $items = this._getAvailableItems();
                var $newTarget;
                switch (location) {
                    case FOCUS_PAGE_UP:
                    case FOCUS_UP:
                        $newTarget = this._prevItem($items);
                        break;
                    case FOCUS_PAGE_DOWN:
                    case FOCUS_DOWN:
                        $newTarget = this._nextItem($items);
                        break;
                    case FOCUS_RIGHT:
                        $newTarget = this.option("rtlEnabled") ? this._prevItem($items) : this._nextItem($items);
                        break;
                    case FOCUS_LEFT:
                        $newTarget = this.option("rtlEnabled") ? this._nextItem($items) : this._prevItem($items);
                        break;
                    case FOCUS_FIRST:
                        $newTarget = $items.first();
                        break;
                    case FOCUS_LAST:
                        $newTarget = $items.last();
                        break;
                    default:
                        return false
                }
                if (0 !== $newTarget.length) {
                    this.option("focusedElement", (0, _element.getPublicElement)($newTarget))
                }
            },
            _getVisibleItems: function($itemElements) {
                $itemElements = $itemElements || this._itemElements();
                return $itemElements.filter(":visible")
            },
            _getAvailableItems: function($itemElements) {
                return this._getVisibleItems($itemElements).not(".dx-state-disabled")
            },
            _prevItem: function($items) {
                var $target = this._getActiveItem();
                var targetIndex = $items.index($target);
                var $last = $items.last();
                var $item = (0, _renderer.default)($items[targetIndex - 1]);
                var loop = this.option("loopItemFocus");
                if (0 === $item.length && loop) {
                    $item = $last
                }
                return $item
            },
            _nextItem: function($items) {
                var $target = this._getActiveItem(true);
                var targetIndex = $items.index($target);
                var $first = $items.first();
                var $item = (0, _renderer.default)($items[targetIndex + 1]);
                var loop = this.option("loopItemFocus");
                if (0 === $item.length && loop) {
                    $item = $first
                }
                return $item
            },
            _selectFocusedItem: function($target) {
                this.selectItem($target)
            },
            _updateFocusedItemState: function(target, isFocused, needCleanItemId) {
                var $target = (0, _renderer.default)(target);
                if ($target.length) {
                    this._refreshActiveDescendant();
                    this._refreshItemId($target, needCleanItemId);
                    this._toggleFocusClass(isFocused, $target)
                }
                this._updateParentActiveDescendant()
            },
            _refreshActiveDescendant: function($target) {
                this.setAria("activedescendant", (0, _type.isDefined)(this.option("focusedElement")) ? this.getFocusedItemId() : null, $target)
            },
            _refreshItemId: function($target, needCleanItemId) {
                if (!needCleanItemId && this.option("focusedElement")) {
                    this.setAria("id", this.getFocusedItemId(), $target)
                } else {
                    this.setAria("id", null, $target)
                }
            },
            _setFocusedItem: function($target) {
                if (!$target || !$target.length) {
                    return
                }
                this._updateFocusedItemState($target, true);
                this.onFocusedItemChanged(this.getFocusedItemId());
                if (this.option("selectOnFocus")) {
                    this._selectFocusedItem($target)
                }
            },
            _findItemElementByItem: function(item) {
                var result = (0, _renderer.default)();
                var that = this;
                this.itemElements().each(function() {
                    var $item = (0, _renderer.default)(this);
                    if ($item.data(that._itemDataKey()) === item) {
                        result = $item;
                        return false
                    }
                });
                return result
            },
            _getIndexByItem: function(item) {
                return this.option("items").indexOf(item)
            },
            _itemOptionChanged: function(item, property, value, oldValue) {
                var $item = this._findItemElementByItem(item);
                if (!$item.length) {
                    return
                }
                if (!this.constructor.ItemClass.getInstance($item).setDataField(property, value)) {
                    this._refreshItem($item, item)
                }
                var isDisabling = "disabled" === property && value;
                if (isDisabling) {
                    this._resetItemFocus($item)
                }
            },
            _resetItemFocus: function($item) {
                if ($item.is(this.option("focusedElement"))) {
                    this.option("focusedElement", null)
                }
            },
            _refreshItem: function($item) {
                var itemData = this._getItemData($item);
                var index = $item.data(this._itemIndexKey());
                this._renderItem(this._renderedItemsCount + index, itemData, null, $item)
            },
            _updateParentActiveDescendant: _common.noop,
            _optionChanged: function(args) {
                if ("items" === args.name) {
                    var matches = args.fullName.match(ITEM_PATH_REGEX);
                    if (matches && matches.length) {
                        var property = matches[matches.length - 1];
                        var itemPath = args.fullName.replace("." + property, "");
                        var item = this.option(itemPath);
                        this._itemOptionChanged(item, property, args.value, args.previousValue);
                        return
                    }
                }
                switch (args.name) {
                    case "items":
                    case "_itemAttributes":
                    case "itemTemplateProperty":
                    case "showItemDataTitle":
                        this._cleanRenderedItems();
                        this._invalidate();
                        break;
                    case "dataSource":
                        this._refreshDataSource();
                        this._renderEmptyMessage();
                        break;
                    case "noDataText":
                        this._renderEmptyMessage();
                        break;
                    case "itemTemplate":
                        this._invalidate();
                        break;
                    case "onItemRendered":
                        this._createItemRenderAction();
                        break;
                    case "onItemClick":
                        break;
                    case "onItemHold":
                    case "itemHoldTimeout":
                        this._attachHoldEvent();
                        break;
                    case "onItemContextMenu":
                        this._attachContextMenuEvent();
                        break;
                    case "onFocusedItemChanged":
                        this.onFocusedItemChanged = this._createActionByOption("onFocusedItemChanged");
                        break;
                    case "selectOnFocus":
                    case "loopItemFocus":
                    case "focusOnSelectedItem":
                        break;
                    case "focusedElement":
                        this._updateFocusedItemState(args.previousValue, false, true);
                        this._setFocusedItem((0, _renderer.default)(args.value));
                        break;
                    case "displayExpr":
                        this._compileDisplayGetter();
                        this._initDefaultItemTemplate();
                        this._invalidate();
                        break;
                    case "visibleExpr":
                    case "disabledExpr":
                        this._invalidate();
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _invalidate: function() {
                this.option("focusedElement", null);
                return this.callBase.apply(this, arguments)
            },
            _loadNextPage: function() {
                var dataSource = this._dataSource;
                this._expectNextPageLoading();
                dataSource.pageIndex(1 + dataSource.pageIndex());
                return dataSource.load()
            },
            _expectNextPageLoading: function() {
                this._startIndexForAppendedItems = 0
            },
            _expectLastItemLoading: function() {
                this._startIndexForAppendedItems = -1
            },
            _forgetNextPageLoading: function() {
                this._startIndexForAppendedItems = null
            },
            _dataSourceChangedHandler: function(newItems) {
                var items = this.option("items");
                if (this._initialized && items && this._shouldAppendItems()) {
                    this._renderedItemsCount = items.length;
                    if (!this._isLastPage() || this._startIndexForAppendedItems !== -1) {
                        this.option().items = items.concat(newItems.slice(this._startIndexForAppendedItems))
                    }
                    this._forgetNextPageLoading();
                    this._refreshContent()
                } else {
                    this.option("items", newItems.slice())
                }
            },
            _refreshContent: function() {
                this._prepareContent();
                this._renderContent()
            },
            _dataSourceLoadErrorHandler: function() {
                this._forgetNextPageLoading();
                this.option("items", this.option("items"))
            },
            _shouldAppendItems: function() {
                return null != this._startIndexForAppendedItems && this._allowDynamicItemsAppend()
            },
            _allowDynamicItemsAppend: function() {
                return false
            },
            _clean: function() {
                this._cleanFocusState();
                this._cleanItemContainer()
            },
            _cleanItemContainer: function() {
                (0, _renderer.default)(this._itemContainer()).empty()
            },
            _dispose: function() {
                this.callBase();
                clearTimeout(this._itemFocusTimeout)
            },
            _refresh: function() {
                this._cleanRenderedItems();
                this.callBase.apply(this, arguments)
            },
            _itemContainer: function() {
                return this.$element()
            },
            _itemClass: function() {
                return ITEM_CLASS
            },
            _itemContentClass: function() {
                return this._itemClass() + CONTENT_CLASS_POSTFIX
            },
            _selectedItemClass: function() {
                return SELECTED_ITEM_CLASS
            },
            _itemResponseWaitClass: function() {
                return ITEM_RESPONSE_WAIT_CLASS
            },
            _itemSelector: function() {
                return "." + this._itemClass()
            },
            _itemDataKey: function() {
                return ITEM_DATA_KEY
            },
            _itemIndexKey: function() {
                return ITEM_INDEX_KEY
            },
            _itemElements: function() {
                return this._itemContainer().find(this._itemSelector())
            },
            _initMarkup: function() {
                this.callBase();
                this.onFocusedItemChanged = this._createActionByOption("onFocusedItemChanged");
                this.$element().addClass(COLLECTION_CLASS);
                this._prepareContent()
            },
            _prepareContent: (0, _common.deferRenderer)(function() {
                this._renderContentImpl()
            }),
            _renderContent: function() {
                this._fireContentReadyAction()
            },
            _render: function() {
                this.callBase();
                this._attachClickEvent();
                this._attachHoldEvent();
                this._attachContextMenuEvent()
            },
            _attachClickEvent: function() {
                var itemSelector = this._itemSelector();
                var clickEventNamespace = (0, _index.addNamespace)(_click.name, this.NAME);
                var pointerDownEventNamespace = (0, _index.addNamespace)(_pointer.default.down, this.NAME);
                var that = this;
                var pointerDownAction = new _action.default(function(args) {
                    var event = args.event;
                    that._itemPointerDownHandler(event)
                });
                _events_engine.default.off(this._itemContainer(), clickEventNamespace, itemSelector);
                _events_engine.default.off(this._itemContainer(), pointerDownEventNamespace, itemSelector);
                _events_engine.default.on(this._itemContainer(), clickEventNamespace, itemSelector, function(e) {
                    this._itemClickHandler(e)
                }.bind(this));
                _events_engine.default.on(this._itemContainer(), pointerDownEventNamespace, itemSelector, function(e) {
                    pointerDownAction.execute({
                        element: (0, _renderer.default)(e.target),
                        event: e
                    })
                })
            },
            _itemClickHandler: function(e, args, config) {
                this._itemDXEventHandler(e, "onItemClick", args, config)
            },
            _itemPointerDownHandler: function(e) {
                if (!this.option("focusStateEnabled")) {
                    return
                }
                this._itemFocusHandler = function() {
                    clearTimeout(this._itemFocusTimeout);
                    this._itemFocusHandler = null;
                    if (e.isDefaultPrevented()) {
                        return
                    }
                    var $target = (0, _renderer.default)(e.target);
                    var $closestItem = $target.closest(this._itemElements());
                    var $closestFocusable = this._closestFocusable($target);
                    if ($closestItem.length && $closestFocusable && (0, _array.inArray)($closestFocusable.get(0), this._focusTarget()) !== -1) {
                        this.option("focusedElement", (0, _element.getPublicElement)($closestItem))
                    }
                }.bind(this);
                this._itemFocusTimeout = setTimeout(this._forcePointerDownFocus.bind(this))
            },
            _closestFocusable: function($target) {
                if ($target.is(_selectors.focusable)) {
                    return $target
                } else {
                    $target = $target.parent();
                    while ($target.length && !_dom_adapter.default.isDocument($target.get(0))) {
                        if ($target.is(_selectors.focusable)) {
                            return $target
                        }
                        $target = $target.parent()
                    }
                }
            },
            _forcePointerDownFocus: function() {
                this._itemFocusHandler && this._itemFocusHandler()
            },
            _updateFocusState: function() {
                this.callBase.apply(this, arguments);
                this._forcePointerDownFocus()
            },
            _attachHoldEvent: function() {
                var $itemContainer = this._itemContainer();
                var itemSelector = this._itemSelector();
                var eventName = (0, _index.addNamespace)(_hold.default.name, this.NAME);
                _events_engine.default.off($itemContainer, eventName, itemSelector);
                _events_engine.default.on($itemContainer, eventName, itemSelector, {
                    timeout: this._getHoldTimeout()
                }, this._itemHoldHandler.bind(this))
            },
            _getHoldTimeout: function() {
                return this.option("itemHoldTimeout")
            },
            _shouldFireHoldEvent: function() {
                return this.hasActionSubscription("onItemHold")
            },
            _itemHoldHandler: function(e) {
                if (this._shouldFireHoldEvent()) {
                    this._itemDXEventHandler(e, "onItemHold")
                } else {
                    e.cancel = true
                }
            },
            _attachContextMenuEvent: function() {
                var $itemContainer = this._itemContainer();
                var itemSelector = this._itemSelector();
                var eventName = (0, _index.addNamespace)(_contextmenu.name, this.NAME);
                _events_engine.default.off($itemContainer, eventName, itemSelector);
                _events_engine.default.on($itemContainer, eventName, itemSelector, this._itemContextMenuHandler.bind(this))
            },
            _shouldFireContextMenuEvent: function() {
                return this.hasActionSubscription("onItemContextMenu")
            },
            _itemContextMenuHandler: function(e) {
                if (this._shouldFireContextMenuEvent()) {
                    this._itemDXEventHandler(e, "onItemContextMenu")
                } else {
                    e.cancel = true
                }
            },
            _renderContentImpl: function() {
                var items = this.option("items") || [];
                if (this._renderedItemsCount) {
                    this._renderItems(items.slice(this._renderedItemsCount))
                } else {
                    this._renderItems(items)
                }
            },
            _renderItems: function(items) {
                if (items.length) {
                    (0, _iterator.each)(items, function(index, itemData) {
                        this._renderItem(this._renderedItemsCount + index, itemData)
                    }.bind(this))
                }
                this._renderEmptyMessage()
            },
            _renderItem: function(index, itemData, $container, $itemToReplace) {
                $container = $container || this._itemContainer();
                var $itemFrame = this._renderItemFrame(index, itemData, $container, $itemToReplace);
                this._setElementData($itemFrame, itemData, index);
                $itemFrame.attr(this.option("_itemAttributes"));
                this._attachItemClickEvent(itemData, $itemFrame);
                var $itemContent = this._getItemContent($itemFrame);
                var renderContentPromise = this._renderItemContent({
                    index: index,
                    itemData: itemData,
                    container: (0, _element.getPublicElement)($itemContent),
                    contentClass: this._itemContentClass(),
                    defaultTemplateName: this.option("itemTemplate")
                });
                var that = this;
                (0, _deferred.when)(renderContentPromise).done(function($itemContent) {
                    that._postprocessRenderItem({
                        itemElement: $itemFrame,
                        itemContent: $itemContent,
                        itemData: itemData,
                        itemIndex: index
                    });
                    that._executeItemRenderAction(index, itemData, (0, _element.getPublicElement)($itemFrame))
                });
                return $itemFrame
            },
            _getItemContent: function($itemFrame) {
                var $itemContent = $itemFrame.find("." + ITEM_CONTENT_PLACEHOLDER_CLASS);
                $itemContent.removeClass(ITEM_CONTENT_PLACEHOLDER_CLASS);
                return $itemContent
            },
            _attachItemClickEvent: function(itemData, $itemElement) {
                if (!itemData || !itemData.onClick) {
                    return
                }
                _events_engine.default.on($itemElement, _click.name, function(e) {
                    this._itemEventHandlerByHandler($itemElement, itemData.onClick, {
                        event: e
                    })
                }.bind(this))
            },
            _renderItemContent: function(args) {
                var itemTemplateName = this._getItemTemplateName(args);
                var itemTemplate = this._getTemplate(itemTemplateName);
                this._addItemContentClasses(args);
                var $templateResult = (0, _renderer.default)(this._createItemByTemplate(itemTemplate, args));
                if (!$templateResult.hasClass(TEMPLATE_WRAPPER_CLASS)) {
                    return args.container
                }
                return this._renderItemContentByNode(args, $templateResult)
            },
            _renderItemContentByNode: function(args, $node) {
                (0, _renderer.default)(args.container).replaceWith($node);
                args.container = (0, _element.getPublicElement)($node);
                this._addItemContentClasses(args);
                return $node
            },
            _addItemContentClasses: function(args) {
                var classes = [ITEM_CLASS + CONTENT_CLASS_POSTFIX, args.contentClass];
                (0, _renderer.default)(args.container).addClass(classes.join(" "))
            },
            _appendItemToContainer: function($container, $itemFrame, index) {
                $itemFrame.appendTo($container)
            },
            _renderItemFrame: function(index, itemData, $container, $itemToReplace) {
                var $itemFrame = (0, _renderer.default)("<div>");
                new this.constructor.ItemClass($itemFrame, this._itemOptions(), itemData || {});
                if ($itemToReplace && $itemToReplace.length) {
                    $itemToReplace.replaceWith($itemFrame)
                } else {
                    this._appendItemToContainer.call(this, $container, $itemFrame, index)
                }
                if (this.option("showItemDataTitle")) {
                    var displayValue = this._displayGetter ? this._displayGetter(itemData) : itemData;
                    $itemFrame.attr("title", displayValue)
                }
                return $itemFrame
            },
            _itemOptions: function() {
                var that = this;
                return {
                    watchMethod: function() {
                        return that.option("integrationOptions.watchMethod")
                    },
                    owner: that,
                    fieldGetter: function(field) {
                        var expr = that.option(field + "Expr");
                        var getter = (0, _data.compileGetter)(expr);
                        return getter
                    }
                }
            },
            _postprocessRenderItem: _common.noop,
            _executeItemRenderAction: function(index, itemData, itemElement) {
                this._getItemRenderAction()({
                    itemElement: itemElement,
                    itemIndex: index,
                    itemData: itemData
                })
            },
            _setElementData: function(element, data, index) {
                element.addClass([ITEM_CLASS, this._itemClass()].join(" ")).data(this._itemDataKey(), data).data(this._itemIndexKey(), index)
            },
            _createItemRenderAction: function() {
                return this._itemRenderAction = this._createActionByOption("onItemRendered", {
                    element: this.element(),
                    excludeValidators: ["disabled", "readOnly"],
                    category: "rendering"
                })
            },
            _getItemRenderAction: function() {
                return this._itemRenderAction || this._createItemRenderAction()
            },
            _getItemTemplateName: function(args) {
                var data = args.itemData;
                var templateProperty = args.templateProperty || this.option("itemTemplateProperty");
                var template = data && data[templateProperty];
                return template || args.defaultTemplateName
            },
            _createItemByTemplate: function(itemTemplate, renderArgs) {
                return itemTemplate.render({
                    model: renderArgs.itemData,
                    container: renderArgs.container,
                    index: renderArgs.index
                })
            },
            _emptyMessageContainer: function() {
                return this._itemContainer()
            },
            _renderEmptyMessage: function(items) {
                items = items || this.option("items");
                var noDataText = this.option("noDataText");
                var hideNoData = !noDataText || items && items.length || this._isDataSourceLoading();
                if (hideNoData && this._$noData) {
                    this._$noData.remove();
                    this._$noData = null;
                    this.setAria("label", void 0)
                }
                if (!hideNoData) {
                    this._$noData = this._$noData || (0, _renderer.default)("<div>").addClass("dx-empty-message");
                    this._$noData.appendTo(this._emptyMessageContainer()).html(noDataText);
                    this.setAria("label", noDataText)
                }
                this.$element().toggleClass(EMPTY_COLLECTION, !hideNoData)
            },
            _itemDXEventHandler: function(dxEvent, handlerOptionName, actionArgs, actionConfig) {
                this._itemEventHandler(dxEvent.target, handlerOptionName, (0, _extend.extend)(actionArgs, {
                    event: dxEvent
                }), actionConfig)
            },
            _itemEventHandler: function(initiator, handlerOptionName, actionArgs, actionConfig) {
                var action = this._createActionByOption(handlerOptionName, (0, _extend.extend)({
                    validatingTargetName: "itemElement"
                }, actionConfig));
                return this._itemEventHandlerImpl(initiator, action, actionArgs)
            },
            _itemEventHandlerByHandler: function(initiator, handler, actionArgs, actionConfig) {
                var action = this._createAction(handler, (0, _extend.extend)({
                    validatingTargetName: "itemElement"
                }, actionConfig));
                return this._itemEventHandlerImpl(initiator, action, actionArgs)
            },
            _itemEventHandlerImpl: function(initiator, action, actionArgs) {
                var $itemElement = this._closestItemElement((0, _renderer.default)(initiator));
                var args = (0, _extend.extend)({}, actionArgs);
                return action((0, _extend.extend)(actionArgs, this._extendActionArgs($itemElement), args))
            },
            _extendActionArgs: function($itemElement) {
                return {
                    itemElement: (0, _element.getPublicElement)($itemElement),
                    itemIndex: this._itemElements().index($itemElement),
                    itemData: this._getItemData($itemElement)
                }
            },
            _closestItemElement: function($element) {
                return (0, _renderer.default)($element).closest(this._itemSelector())
            },
            _getItemData: function(itemElement) {
                return (0, _renderer.default)(itemElement).data(this._itemDataKey())
            },
            _getSummaryItemsWidth: function(items, includeMargin) {
                var result = 0;
                if (items) {
                    (0, _iterator.each)(items, function(_, item) {
                        result += (0, _renderer.default)(item).outerWidth(includeMargin || false)
                    })
                }
                return result
            },
            getFocusedItemId: function() {
                if (!this._focusedItemId) {
                    this._focusedItemId = "dx-" + new _guid.default
                }
                return this._focusedItemId
            },
            itemElements: function() {
                return this._itemElements()
            },
            itemsContainer: function() {
                return this._itemContainer()
            }
        }).include(_data_helper.default);
        CollectionWidget.ItemClass = _item.default;
        var _default = CollectionWidget;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************************************!*\
      !*** ./artifacts/transpiled-npm/data/data_source/operation_manager.js ***!
      \************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _utils = __webpack_require__( /*! ./utils */ 69);
        var OperationManager = function() {
            function OperationManager() {
                this._counter = -1;
                this._deferreds = {}
            }
            var _proto = OperationManager.prototype;
            _proto.add = function(deferred) {
                this._counter++;
                this._deferreds[this._counter] = deferred;
                return this._counter
            };
            _proto.remove = function(operationId) {
                return delete this._deferreds[operationId]
            };
            _proto.cancel = function(operationId) {
                if (operationId in this._deferreds) {
                    this._deferreds[operationId].reject(_utils.CANCELED_TOKEN);
                    return true
                }
                return false
            };
            _proto.cancelAll = function() {
                while (this._counter > -1) {
                    this.cancel(this._counter);
                    this._counter--
                }
            };
            return OperationManager
        }();
        exports.default = OperationManager;
        module.exports = exports.default
    },
    /*!**************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/collection/ui.collection_widget.edit.strategy.js ***!
      \**************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var abstract = _class.default.abstract;
        var EditStrategy = _class.default.inherit({
            ctor: function(collectionWidget) {
                this._collectionWidget = collectionWidget
            },
            getIndexByItemData: abstract,
            getItemDataByIndex: abstract,
            getKeysByItems: abstract,
            getItemsByKeys: abstract,
            itemsGetter: abstract,
            getKeyByIndex: function(index) {
                var resultIndex = this._denormalizeItemIndex(index);
                return this.getKeysByItems([this.getItemDataByIndex(resultIndex)])[0]
            },
            _equalKeys: function(key1, key2) {
                if (this._collectionWidget._isKeySpecified()) {
                    return (0, _common.equalByValue)(key1, key2)
                } else {
                    return key1 === key2
                }
            },
            beginCache: function() {
                this._cache = {}
            },
            endCache: function() {
                this._cache = null
            },
            getIndexByKey: abstract,
            getNormalizedIndex: function(value) {
                if (this._isNormalizedItemIndex(value)) {
                    return value
                }
                if (this._isItemIndex(value)) {
                    return this._normalizeItemIndex(value)
                }
                if (this._isNode(value)) {
                    return this._getNormalizedItemIndex(value)
                }
                return this._normalizeItemIndex(this.getIndexByItemData(value))
            },
            getIndex: function(value) {
                if (this._isNormalizedItemIndex(value)) {
                    return this._denormalizeItemIndex(value)
                }
                if (this._isItemIndex(value)) {
                    return value
                }
                if (this._isNode(value)) {
                    return this._denormalizeItemIndex(this._getNormalizedItemIndex(value))
                }
                return this.getIndexByItemData(value)
            },
            getItemElement: function(value) {
                if (this._isNormalizedItemIndex(value)) {
                    return this._getItemByNormalizedIndex(value)
                }
                if (this._isItemIndex(value)) {
                    return this._getItemByNormalizedIndex(this._normalizeItemIndex(value))
                }
                if (this._isNode(value)) {
                    return (0, _renderer.default)(value)
                }
                var normalizedItemIndex = this._normalizeItemIndex(this.getIndexByItemData(value));
                return this._getItemByNormalizedIndex(normalizedItemIndex)
            },
            _isNode: function(el) {
                return _dom_adapter.default.isNode(el && el.get ? el.get(0) : el)
            },
            deleteItemAtIndex: abstract,
            itemPlacementFunc: function(movingIndex, destinationIndex) {
                return this._itemsFromSameParent(movingIndex, destinationIndex) && movingIndex < destinationIndex ? "after" : "before"
            },
            moveItemAtIndexToIndex: abstract,
            _isNormalizedItemIndex: function(index) {
                return "number" === typeof index && Math.round(index) === index
            },
            _isItemIndex: abstract,
            _getNormalizedItemIndex: abstract,
            _normalizeItemIndex: abstract,
            _denormalizeItemIndex: abstract,
            _getItemByNormalizedIndex: abstract,
            _itemsFromSameParent: abstract
        });
        var _default = EditStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/selection/selection.strategy.deferred.js ***!
      \******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _selection = _interopRequireDefault(__webpack_require__( /*! ./selection.strategy */ 260));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _query = _interopRequireDefault(__webpack_require__( /*! ../../data/query */ 48));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _selection.default.inherit({
            getSelectedItems: function() {
                return this._loadFilteredData(this.options.selectionFilter)
            },
            getSelectedItemKeys: function() {
                var d = new _deferred.Deferred;
                var that = this;
                var key = this.options.key();
                var select = (0, _type.isString)(key) ? [key] : key;
                this._loadFilteredData(this.options.selectionFilter, null, select).done(function(items) {
                    var keys = items.map(function(item) {
                        return that.options.keyOf(item)
                    });
                    d.resolve(keys)
                }).fail(d.reject);
                return d.promise()
            },
            selectedItemKeys: function(keys, preserve, isDeselect, isSelectAll) {
                if (isSelectAll) {
                    var filter = this.options.filter();
                    var needResetSelectionFilter = !filter || JSON.stringify(filter) === JSON.stringify(this.options.selectionFilter) && isDeselect;
                    if (needResetSelectionFilter) {
                        this._setOption("selectionFilter", isDeselect ? [] : null)
                    } else {
                        this._addSelectionFilter(isDeselect, filter, isSelectAll)
                    }
                } else {
                    if (!preserve) {
                        this._setOption("selectionFilter", [])
                    }
                    for (var i = 0; i < keys.length; i++) {
                        if (isDeselect) {
                            this.removeSelectedItem(keys[i])
                        } else {
                            this.addSelectedItem(keys[i])
                        }
                    }
                }
                this.onSelectionChanged();
                return (new _deferred.Deferred).resolve()
            },
            setSelectedItems: function(keys) {
                this._setOption("selectionFilter", null);
                for (var i = 0; i < keys.length; i++) {
                    this.addSelectedItem(keys[i])
                }
            },
            isItemDataSelected: function(itemData) {
                return this.isItemKeySelected(itemData)
            },
            isItemKeySelected: function(itemData) {
                var selectionFilter = this.options.selectionFilter;
                if (!selectionFilter) {
                    return true
                }
                return !!(0, _query.default)([itemData]).filter(selectionFilter).toArray().length
            },
            _getKeyExpr: function() {
                var keyField = this.options.key();
                if (Array.isArray(keyField) && 1 === keyField.length) {
                    return keyField[0]
                }
                return keyField
            },
            _normalizeKey: function(key) {
                var keyExpr = this.options.key();
                if (Array.isArray(keyExpr) && 1 === keyExpr.length) {
                    return key[keyExpr[0]]
                }
                return key
            },
            _getFilterByKey: function(key) {
                var keyField = this._getKeyExpr();
                var filter = [keyField, "=", this._normalizeKey(key)];
                if (Array.isArray(keyField)) {
                    filter = [];
                    for (var i = 0; i < keyField.length; i++) {
                        filter.push([keyField[i], "=", key[keyField[i]]]);
                        if (i !== keyField.length - 1) {
                            filter.push("and")
                        }
                    }
                }
                return filter
            },
            addSelectedItem: function(key) {
                var filter = this._getFilterByKey(key);
                this._addSelectionFilter(false, filter)
            },
            removeSelectedItem: function(key) {
                var filter = this._getFilterByKey(key);
                this._addSelectionFilter(true, filter)
            },
            validate: function() {
                var key = this.options.key;
                if (key && void 0 === key()) {
                    throw _ui.default.Error("E1042", "Deferred selection")
                }
            },
            _findSubFilter: function(selectionFilter, filter) {
                if (!selectionFilter) {
                    return -1
                }
                var filterString = JSON.stringify(filter);
                for (var index = 0; index < selectionFilter.length; index++) {
                    var subFilter = selectionFilter[index];
                    if (subFilter && JSON.stringify(subFilter) === filterString) {
                        return index
                    }
                }
                return -1
            },
            _isLastSubFilter: function(selectionFilter, filter) {
                if (selectionFilter && filter) {
                    return this._findSubFilter(selectionFilter, filter) === selectionFilter.length - 1 || 0 === this._findSubFilter([selectionFilter], filter)
                }
                return false
            },
            _addFilterOperator: function(selectionFilter, filterOperator) {
                if (selectionFilter.length > 1 && (0, _type.isString)(selectionFilter[1]) && selectionFilter[1] !== filterOperator) {
                    selectionFilter = [selectionFilter]
                }
                if (selectionFilter.length) {
                    selectionFilter.push(filterOperator)
                }
                return selectionFilter
            },
            _denormalizeFilter: function(filter) {
                if (filter && (0, _type.isString)(filter[0])) {
                    filter = [filter]
                }
                return filter
            },
            _addSelectionFilter: function(isDeselect, filter, isSelectAll) {
                var that = this;
                var currentFilter = isDeselect ? ["!", filter] : filter;
                var currentOperation = isDeselect ? "and" : "or";
                var needAddFilter = true;
                var selectionFilter = that.options.selectionFilter || [];
                selectionFilter = that._denormalizeFilter(selectionFilter);
                if (selectionFilter && selectionFilter.length) {
                    that._removeSameFilter(selectionFilter, filter, isDeselect, isSelectAll);
                    var filterIndex = that._removeSameFilter(selectionFilter, filter, !isDeselect);
                    var isKeyOperatorsAfterRemoved = this._isKeyFilter(filter) && this._hasKeyFiltersOnlyStartingFromIndex(selectionFilter, filterIndex);
                    needAddFilter = filter.length && !isKeyOperatorsAfterRemoved;
                    if (needAddFilter) {
                        selectionFilter = that._addFilterOperator(selectionFilter, currentOperation)
                    }
                }
                if (needAddFilter) {
                    selectionFilter.push(currentFilter)
                }
                selectionFilter = that._normalizeFilter(selectionFilter);
                that._setOption("selectionFilter", !isDeselect && !selectionFilter.length ? null : selectionFilter)
            },
            _normalizeFilter: function(filter) {
                if (filter && 1 === filter.length) {
                    filter = filter[0]
                }
                return filter
            },
            _removeFilterByIndex: function(filter, filterIndex, isSelectAll) {
                var operation = filter[1];
                if (filterIndex > 0) {
                    filter.splice(filterIndex - 1, 2)
                } else {
                    filter.splice(filterIndex, 2)
                }
                if (isSelectAll && "and" === operation) {
                    filter.splice(0, filter.length)
                }
            },
            _isSimpleKeyFilter: function(filter, key) {
                return 3 === filter.length && filter[0] === key && "=" === filter[1]
            },
            _isKeyFilter: function(filter) {
                if (2 === filter.length && "!" === filter[0]) {
                    return this._isKeyFilter(filter[1])
                }
                var keyField = this._getKeyExpr();
                if (Array.isArray(keyField)) {
                    if (filter.length !== 2 * keyField.length - 1) {
                        return false
                    }
                    for (var i = 0; i < keyField.length; i++) {
                        if (i > 0 && "and" !== filter[2 * i - 1]) {
                            return false
                        }
                        if (!this._isSimpleKeyFilter(filter[2 * i], keyField[i])) {
                            return false
                        }
                    }
                    return true
                }
                return this._isSimpleKeyFilter(filter, keyField)
            },
            _hasKeyFiltersOnlyStartingFromIndex: function(selectionFilter, filterIndex) {
                if (filterIndex >= 0) {
                    for (var i = filterIndex; i < selectionFilter.length; i++) {
                        if ("string" !== typeof selectionFilter[i] && !this._isKeyFilter(selectionFilter[i])) {
                            return false
                        }
                    }
                    return true
                }
                return false
            },
            _removeSameFilter: function(selectionFilter, filter, inverted, isSelectAll) {
                filter = inverted ? ["!", filter] : filter;
                if (JSON.stringify(filter) === JSON.stringify(selectionFilter)) {
                    selectionFilter.splice(0, selectionFilter.length);
                    return 0
                }
                var filterIndex = this._findSubFilter(selectionFilter, filter);
                if (filterIndex >= 0) {
                    this._removeFilterByIndex(selectionFilter, filterIndex, isSelectAll);
                    return filterIndex
                } else {
                    for (var i = 0; i < selectionFilter.length; i++) {
                        if (Array.isArray(selectionFilter[i]) && selectionFilter[i].length > 2) {
                            var _filterIndex = this._removeSameFilter(selectionFilter[i], filter, false, isSelectAll);
                            if (_filterIndex >= 0) {
                                if (!selectionFilter[i].length) {
                                    this._removeFilterByIndex(selectionFilter, i, isSelectAll)
                                } else {
                                    if (1 === selectionFilter[i].length) {
                                        selectionFilter[i] = selectionFilter[i][0]
                                    }
                                }
                                return _filterIndex
                            }
                        }
                    }
                    return -1
                }
            },
            getSelectAllState: function() {
                var filter = this.options.filter();
                var selectionFilter = this.options.selectionFilter;
                if (!selectionFilter) {
                    return true
                }
                if (!selectionFilter.length) {
                    return false
                }
                if (!filter || !filter.length) {
                    return
                }
                selectionFilter = this._denormalizeFilter(selectionFilter);
                if (this._isLastSubFilter(selectionFilter, filter)) {
                    return true
                }
                if (this._isLastSubFilter(selectionFilter, ["!", filter])) {
                    return false
                }
                return
            }
        });
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/selection/selection.strategy.standard.js ***!
      \******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _array_compare = __webpack_require__( /*! ../../core/utils/array_compare */ 234);
        var _query = _interopRequireDefault(__webpack_require__( /*! ../../data/query */ 48));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _selection_filter = __webpack_require__( /*! ../../core/utils/selection_filter */ 330);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _selection = _interopRequireDefault(__webpack_require__( /*! ./selection.strategy */ 260));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _selection.default.inherit({
            ctor: function(options) {
                this.callBase(options);
                this._initSelectedItemKeyHash()
            },
            _initSelectedItemKeyHash: function() {
                this._setOption("keyHashIndices", this.options.equalByReference ? null : {})
            },
            getSelectedItemKeys: function() {
                return this.options.selectedItemKeys.slice(0)
            },
            getSelectedItems: function() {
                return this.options.selectedItems.slice(0)
            },
            _preserveSelectionUpdate: function(items, isDeselect) {
                var keyOf = this.options.keyOf;
                var keyIndicesToRemoveMap;
                var keyIndex;
                var i;
                if (!keyOf) {
                    return
                }
                var isBatchDeselect = isDeselect && items.length > 1 && !this.options.equalByReference;
                if (isBatchDeselect) {
                    keyIndicesToRemoveMap = {}
                }
                for (i = 0; i < items.length; i++) {
                    var item = items[i];
                    var key = keyOf(item);
                    if (isDeselect) {
                        keyIndex = this.removeSelectedItem(key, keyIndicesToRemoveMap);
                        if (keyIndicesToRemoveMap && keyIndex >= 0) {
                            keyIndicesToRemoveMap[keyIndex] = true
                        }
                    } else {
                        this.addSelectedItem(key, item)
                    }
                }
                if (isBatchDeselect) {
                    this._batchRemoveSelectedItems(keyIndicesToRemoveMap)
                }
            },
            _batchRemoveSelectedItems: function(keyIndicesToRemoveMap) {
                var selectedItemKeys = this.options.selectedItemKeys.slice(0);
                var selectedItems = this.options.selectedItems.slice(0);
                this.options.selectedItemKeys.length = 0;
                this.options.selectedItems.length = 0;
                for (var i = 0; i < selectedItemKeys.length; i++) {
                    if (!keyIndicesToRemoveMap[i]) {
                        this.options.selectedItemKeys.push(selectedItemKeys[i]);
                        this.options.selectedItems.push(selectedItems[i])
                    }
                }
                this._initSelectedItemKeyHash();
                this.updateSelectedItemKeyHash(this.options.selectedItemKeys)
            },
            _loadSelectedItemsCore: function(keys, isDeselect, isSelectAll) {
                var deferred = new _deferred.Deferred;
                var key = this.options.key();
                if (!keys.length && !isSelectAll) {
                    deferred.resolve([]);
                    return deferred
                }
                var filter = this.options.filter();
                if (isSelectAll && isDeselect && !filter) {
                    deferred.resolve(this.getSelectedItems());
                    return deferred
                }
                var selectionFilterCreator = new _selection_filter.SelectionFilterCreator(keys, isSelectAll);
                var combinedFilter = selectionFilterCreator.getCombinedFilter(key, filter);
                var deselectedItems = [];
                if (isDeselect) {
                    deselectedItems = combinedFilter ? (0, _query.default)(this.options.selectedItems).filter(combinedFilter).toArray() : this.options.selectedItems.slice(0)
                }
                var filteredItems = deselectedItems.length ? deselectedItems : this.options.plainItems(true).filter(this.options.isSelectableItem).map(this.options.getItemData);
                var localFilter = selectionFilterCreator.getLocalFilter(this.options.keyOf, this.equalKeys.bind(this), this.options.equalByReference, key);
                filteredItems = filteredItems.filter(localFilter);
                if (deselectedItems.length || !isSelectAll && filteredItems.length === keys.length) {
                    deferred.resolve(filteredItems)
                } else {
                    deferred = this._loadFilteredData(combinedFilter, localFilter, null, isSelectAll)
                }
                return deferred
            },
            _replaceSelectionUpdate: function(items) {
                var internalKeys = [];
                var keyOf = this.options.keyOf;
                if (!keyOf) {
                    return
                }
                for (var i = 0; i < items.length; i++) {
                    var item = items[i];
                    var key = keyOf(item);
                    internalKeys.push(key)
                }
                this.setSelectedItems(internalKeys, items)
            },
            _warnOnIncorrectKeys: function(keys) {
                var allowNullValue = this.options.allowNullValue;
                for (var i = 0; i < keys.length; i++) {
                    var key = keys[i];
                    if ((!allowNullValue || null !== key) && !this.isItemKeySelected(key)) {
                        _ui.default.log("W1002", key)
                    }
                }
            },
            _isMultiSelectEnabled: function() {
                var mode = this.options.mode;
                return "all" === mode || "multiple" === mode
            },
            _requestInProgress: function() {
                var _this$_lastLoadDeferr;
                return "pending" === (null === (_this$_lastLoadDeferr = this._lastLoadDeferred) || void 0 === _this$_lastLoadDeferr ? void 0 : _this$_lastLoadDeferr.state())
            },
            _concatRequestsItems: function(keys, isDeselect, oldRequestItems) {
                var deselectedItems = isDeselect ? keys : [];
                return {
                    addedItems: oldRequestItems.added.concat((0, _array.removeDuplicates)(keys, this.options.selectedItemKeys)),
                    removedItems: oldRequestItems.removed.concat(deselectedItems),
                    keys: keys
                }
            },
            _collectLastRequestData: function(keys, isDeselect, isSelectAll) {
                var isDeselectAll = isDeselect && isSelectAll;
                var oldRequestItems = {
                    added: [],
                    removed: []
                };
                var multiSelectEnabled = this._isMultiSelectEnabled();
                var lastRequestData = multiSelectEnabled ? this._lastRequestData : {};
                if (multiSelectEnabled) {
                    if (this._requestInProgress()) {
                        if (isDeselectAll) {
                            this._lastLoadDeferred.reject();
                            lastRequestData = {}
                        } else {
                            if (!(0, _array_compare.isKeysEqual)(keys, this.options.selectedItemKeys)) {
                                oldRequestItems.added = lastRequestData.addedItems;
                                oldRequestItems.removed = lastRequestData.removedItems;
                                if (!isDeselect) {
                                    this._lastLoadDeferred.reject()
                                }
                            } else {
                                lastRequestData = {}
                            }
                        }
                    }
                    lastRequestData = this._concatRequestsItems(keys, isDeselect, oldRequestItems)
                }
                return lastRequestData
            },
            _updateKeysByLastRequestData: function(keys, isDeselect, isSelectAll) {
                var currentKeys = keys;
                if (this._isMultiSelectEnabled() && !isDeselect && !isSelectAll) {
                    var _this$_lastRequestDat, _this$_lastRequestDat2;
                    currentKeys = (0, _array.removeDuplicates)(keys.concat(null === (_this$_lastRequestDat = this._lastRequestData) || void 0 === _this$_lastRequestDat ? void 0 : _this$_lastRequestDat.addedItems), null === (_this$_lastRequestDat2 = this._lastRequestData) || void 0 === _this$_lastRequestDat2 ? void 0 : _this$_lastRequestDat2.removedItems);
                    currentKeys = (0, _array.uniqueValues)(currentKeys)
                }
                return currentKeys
            },
            _loadSelectedItems: function(keys, isDeselect, isSelectAll) {
                var that = this;
                var deferred = new _deferred.Deferred;
                this._lastRequestData = this._collectLastRequestData(keys, isDeselect, isSelectAll);
                (0, _deferred.when)(that._lastLoadDeferred).always(function() {
                    var currentKeys = that._updateKeysByLastRequestData(keys, isDeselect, isSelectAll);
                    that._loadSelectedItemsCore(currentKeys, isDeselect, isSelectAll).done(deferred.resolve).fail(deferred.reject)
                });
                that._lastLoadDeferred = deferred;
                return deferred
            },
            selectedItemKeys: function(keys, preserve, isDeselect, isSelectAll) {
                var that = this;
                var deferred = that._loadSelectedItems(keys, isDeselect, isSelectAll);
                deferred.done(function(items) {
                    if (preserve) {
                        that._preserveSelectionUpdate(items, isDeselect)
                    } else {
                        that._replaceSelectionUpdate(items)
                    }
                    that.onSelectionChanged()
                });
                return deferred
            },
            addSelectedItem: function(key, itemData) {
                if ((0, _type.isDefined)(itemData) && itemData.disabled) {
                    if (this.options.disabledItemKeys.indexOf(key) === -1) {
                        this.options.disabledItemKeys.push(key)
                    }
                    return
                }
                var keyHash = this._getKeyHash(key);
                if (this._indexOfSelectedItemKey(keyHash) === -1) {
                    if (!(0, _type.isObject)(keyHash) && this.options.keyHashIndices) {
                        this.options.keyHashIndices[keyHash] = [this.options.selectedItemKeys.length]
                    }
                    this.options.selectedItemKeys.push(key);
                    this.options.addedItemKeys.push(key);
                    this.options.addedItems.push(itemData);
                    this.options.selectedItems.push(itemData)
                }
            },
            _getSelectedIndexByKey: function(key, ignoreIndicesMap) {
                var selectedItemKeys = this.options.selectedItemKeys;
                for (var index = 0; index < selectedItemKeys.length; index++) {
                    if ((!ignoreIndicesMap || !ignoreIndicesMap[index]) && this.equalKeys(selectedItemKeys[index], key)) {
                        return index
                    }
                }
                return -1
            },
            _getSelectedIndexByHash: function(key, ignoreIndicesMap) {
                var indices = this.options.keyHashIndices[key];
                if (indices && indices.length > 1 && ignoreIndicesMap) {
                    indices = indices.filter(function(index) {
                        return !ignoreIndicesMap[index]
                    })
                }
                return indices && indices[0] >= 0 ? indices[0] : -1
            },
            _indexOfSelectedItemKey: function(key, ignoreIndicesMap) {
                var selectedIndex;
                if (this.options.equalByReference) {
                    selectedIndex = this.options.selectedItemKeys.indexOf(key)
                } else {
                    if ((0, _type.isObject)(key)) {
                        selectedIndex = this._getSelectedIndexByKey(key, ignoreIndicesMap)
                    } else {
                        selectedIndex = this._getSelectedIndexByHash(key, ignoreIndicesMap)
                    }
                }
                return selectedIndex
            },
            _shiftSelectedKeyIndices: function(keyIndex) {
                for (var currentKeyIndex = keyIndex; currentKeyIndex < this.options.selectedItemKeys.length; currentKeyIndex++) {
                    var currentKey = this.options.selectedItemKeys[currentKeyIndex];
                    var currentKeyHash = (0, _common.getKeyHash)(currentKey);
                    var currentKeyIndices = this.options.keyHashIndices[currentKeyHash];
                    if (!currentKeyIndices) {
                        continue
                    }
                    for (var i = 0; i < currentKeyIndices.length; i++) {
                        if (currentKeyIndices[i] > keyIndex) {
                            currentKeyIndices[i]--
                        }
                    }
                }
            },
            removeSelectedItem: function(key, keyIndicesToRemoveMap) {
                var keyHash = this._getKeyHash(key);
                var isBatchDeselect = !!keyIndicesToRemoveMap;
                var keyIndex = this._indexOfSelectedItemKey(keyHash, keyIndicesToRemoveMap);
                if (keyIndex < 0) {
                    return keyIndex
                }
                this.options.removedItemKeys.push(key);
                this.options.removedItems.push(this.options.selectedItems[keyIndex]);
                if (isBatchDeselect) {
                    return keyIndex
                }
                this.options.selectedItemKeys.splice(keyIndex, 1);
                this.options.selectedItems.splice(keyIndex, 1);
                if ((0, _type.isObject)(keyHash) || !this.options.keyHashIndices) {
                    return keyIndex
                }
                var keyIndices = this.options.keyHashIndices[keyHash];
                if (!keyIndices) {
                    return keyIndex
                }
                keyIndices.shift();
                if (!keyIndices.length) {
                    delete this.options.keyHashIndices[keyHash]
                }
                this._shiftSelectedKeyIndices(keyIndex);
                return keyIndex
            },
            _updateAddedItemKeys: function(keys, items) {
                for (var i = 0; i < keys.length; i++) {
                    if (!this.isItemKeySelected(keys[i])) {
                        this.options.addedItemKeys.push(keys[i]);
                        this.options.addedItems.push(items[i])
                    }
                }
            },
            _updateRemovedItemKeys: function(keys, oldSelectedKeys, oldSelectedItems) {
                for (var i = 0; i < oldSelectedKeys.length; i++) {
                    if (!this.isItemKeySelected(oldSelectedKeys[i])) {
                        this.options.removedItemKeys.push(oldSelectedKeys[i]);
                        this.options.removedItems.push(oldSelectedItems[i])
                    }
                }
            },
            _isItemSelectionInProgress: function(key, checkPending) {
                var shouldCheckPending = checkPending && this._lastRequestData && this._requestInProgress();
                if (shouldCheckPending) {
                    return this._lastRequestData.addedItems && this._lastRequestData.addedItems.indexOf(key) !== -1
                } else {
                    return false
                }
            },
            _getKeyHash: function(key) {
                return this.options.equalByReference ? key : (0, _common.getKeyHash)(key)
            },
            setSelectedItems: function(keys, items) {
                this._updateAddedItemKeys(keys, items);
                var oldSelectedKeys = this.options.selectedItemKeys;
                var oldSelectedItems = this.options.selectedItems;
                if (!this.options.equalByReference) {
                    this._initSelectedItemKeyHash();
                    this.updateSelectedItemKeyHash(keys)
                }
                this._setOption("selectedItemKeys", keys);
                this._setOption("selectedItems", items);
                this._updateRemovedItemKeys(keys, oldSelectedKeys, oldSelectedItems)
            },
            isItemDataSelected: function(itemData) {
                var options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                var key = this.options.keyOf(itemData);
                return this.isItemKeySelected(key, options)
            },
            isItemKeySelected: function(key) {
                var options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                var result = this._isItemSelectionInProgress(key, options.checkPending);
                if (!result) {
                    var keyHash = this._getKeyHash(key);
                    var index = this._indexOfSelectedItemKey(keyHash);
                    result = index !== -1
                }
                return result
            },
            getSelectAllState: function(visibleOnly) {
                if (visibleOnly) {
                    return this._getVisibleSelectAllState()
                } else {
                    return this._getFullSelectAllState()
                }
            }
        });
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/angular/event_registrator.js ***!
      \***************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _event_registrator_callbacks = _interopRequireDefault(__webpack_require__( /*! ../../events/core/event_registrator_callbacks */ 131));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _module = _interopRequireDefault(__webpack_require__( /*! ./module */ 201));
        var _angular = _interopRequireDefault(__webpack_require__( /*! angular */ 133));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        if (_angular.default) {
            _event_registrator_callbacks.default.add(function(name) {
                var ngEventName = name.slice(0, 2) + name.charAt(2).toUpperCase() + name.slice(3);
                _module.default.directive(ngEventName, ["$parse", function($parse) {
                    return function(scope, element, attr) {
                        var attrValue = attr[ngEventName].trim();
                        var handler;
                        var eventOptions = {};
                        if ("{" === attrValue.charAt(0)) {
                            eventOptions = scope.$eval(attrValue);
                            handler = $parse(eventOptions.execute)
                        } else {
                            handler = $parse(attr[ngEventName])
                        }
                        _events_engine.default.on(element, name, eventOptions, function(e) {
                            scope.$apply(function() {
                                handler(scope, {
                                    $event: e
                                })
                            })
                        })
                    }
                }])
            })
        }
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/angular/components.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/callbacks */ 27));
        var _module = _interopRequireDefault(__webpack_require__( /*! ./module */ 201));
        var _angular = _interopRequireDefault(__webpack_require__( /*! angular */ 133));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        if (_angular.default) {
            _module.default.service("dxDigestCallbacks", ["$rootScope", function($rootScope) {
                var begin = (0, _callbacks.default)();
                var prioritizedEnd = (0, _callbacks.default)();
                var end = (0, _callbacks.default)();
                var digestPhase = false;
                $rootScope.$watch(function() {
                    if (digestPhase) {
                        return
                    }
                    digestPhase = true;
                    begin.fire();
                    $rootScope.$$postDigest(function() {
                        digestPhase = false;
                        prioritizedEnd.fire();
                        end.fire()
                    })
                });
                return {
                    begin: {
                        add: function(callback) {
                            if (digestPhase) {
                                callback()
                            }
                            begin.add(callback)
                        },
                        remove: begin.remove.bind(begin)
                    },
                    end: {
                        add: end.add.bind(end),
                        addPrioritized: prioritizedEnd.add.bind(prioritizedEnd),
                        remove: end.remove.bind(end)
                    }
                }
            }])
        }
    },
    /*!**************************************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/angular/action_executors.js ***!
      \**************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _action = _interopRequireDefault(__webpack_require__( /*! ../../core/action */ 111));
        var _angular = _interopRequireDefault(__webpack_require__( /*! angular */ 133));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        if (_angular.default) {
            _action.default.registerExecutor({
                ngExpression: {
                    execute: function(e) {
                        if ("string" === typeof e.action) {
                            e.context.$eval(e.action)
                        }
                    }
                }
            })
        }
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/knockout.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _knockout = _interopRequireDefault(__webpack_require__( /*! knockout */ 66));
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../core/errors */ 25));
        var _version = __webpack_require__( /*! ../core/utils/version */ 72);
        __webpack_require__( /*! ./knockout/component_registrator */ 557);
        __webpack_require__( /*! ./knockout/event_registrator */ 559);
        __webpack_require__( /*! ./knockout/components */ 560);
        __webpack_require__( /*! ./knockout/validation */ 561);
        __webpack_require__( /*! ./knockout/variable_wrapper_utils */ 562);
        __webpack_require__( /*! ./knockout/clean_node */ 563);
        __webpack_require__( /*! ./knockout/clean_node_old */ 564);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        if (_knockout.default) {
            if ((0, _version.compare)(_knockout.default.version, [2, 3]) < 0) {
                throw _errors.default.Error("E0013")
            }
        }
    },
    /*!********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/knockout/component_registrator.js ***!
      \********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _knockout = _interopRequireDefault(__webpack_require__( /*! knockout */ 66));
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/callbacks */ 27));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _component_registrator_callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator_callbacks */ 167));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../../ui/widget/ui.widget */ 16));
        var _template = __webpack_require__( /*! ./template */ 558);
        var _editor = _interopRequireDefault(__webpack_require__( /*! ../../ui/editor/editor */ 52));
        var _locker = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/locker */ 259));
        var _utils = __webpack_require__( /*! ./utils */ 261);
        var _config = _interopRequireDefault(__webpack_require__( /*! ../../core/config */ 31));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        if (_knockout.default) {
            var LOCKS_DATA_KEY = "dxKoLocks";
            var CREATED_WITH_KO_DATA_KEY = "dxKoCreation";
            var editorsBindingHandlers = [];
            var registerComponentKoBinding = function(componentName, componentClass) {
                if (componentClass.subclassOf(_editor.default)) {
                    editorsBindingHandlers.push(componentName)
                }
                _knockout.default.bindingHandlers[componentName] = {
                    init: function(domNode, valueAccessor) {
                        var $element = (0, _renderer.default)(domNode);
                        var optionChangedCallbacks = (0, _callbacks.default)();
                        var optionsByReference = {};
                        var component;
                        var knockoutConfig = (0, _config.default)().knockout;
                        var isBindingPropertyPredicateName = knockoutConfig && knockoutConfig.isBindingPropertyPredicateName;
                        var isBindingPropertyPredicate;
                        var ctorOptions = {
                            onInitializing: function() {
                                optionsByReference = this._getOptionsByReference();
                                _knockout.default.computed(function() {
                                    var model = _knockout.default.unwrap(valueAccessor());
                                    if (component) {
                                        component.beginUpdate()
                                    }
                                    isBindingPropertyPredicate = isBindingPropertyPredicateName && model && model[isBindingPropertyPredicateName];
                                    unwrapModel(model);
                                    if (component) {
                                        component.endUpdate()
                                    }
                                }, null, {
                                    disposeWhenNodeIsRemoved: domNode
                                });
                                component = this
                            },
                            modelByElement: function($element) {
                                if ($element.length) {
                                    var node = (0, _utils.getClosestNodeWithContext)($element.get(0));
                                    return _knockout.default.dataFor(node)
                                }
                            },
                            nestedComponentOptions: function(component) {
                                return {
                                    modelByElement: component.option("modelByElement"),
                                    nestedComponentOptions: component.option("nestedComponentOptions")
                                }
                            },
                            _optionChangedCallbacks: optionChangedCallbacks,
                            integrationOptions: {
                                watchMethod: function(fn, callback, options) {
                                    options = options || {};
                                    var skipCallback = options.skipImmediate;
                                    var watcher = _knockout.default.computed(function() {
                                        var newValue = _knockout.default.unwrap(fn());
                                        if (!skipCallback) {
                                            callback(newValue)
                                        }
                                        skipCallback = false
                                    });
                                    return function() {
                                        watcher.dispose()
                                    }
                                },
                                templates: {
                                    "dx-polymorph-widget": {
                                        render: function(options) {
                                            var widgetName = _knockout.default.utils.unwrapObservable(options.model.widget);
                                            if (!widgetName) {
                                                return
                                            }
                                            var markup = (0, _renderer.default)("<div>").attr("data-bind", widgetName + ": options").get(0);
                                            (0, _renderer.default)(options.container).append(markup);
                                            _knockout.default.applyBindings(options.model, markup)
                                        }
                                    }
                                },
                                createTemplate: function(element) {
                                    return new _template.KoTemplate(element)
                                }
                            }
                        };
                        var optionNameToModelMap = {};
                        var applyModelValueToOption = function(optionName, modelValue, unwrap) {
                            var locks = $element.data(LOCKS_DATA_KEY);
                            var optionValue = unwrap ? _knockout.default.unwrap(modelValue) : modelValue;
                            if (_knockout.default.isWriteableObservable(modelValue)) {
                                optionNameToModelMap[optionName] = modelValue
                            }
                            if (component) {
                                if (locks.locked(optionName)) {
                                    return
                                }
                                locks.obtain(optionName);
                                try {
                                    if (_knockout.default.ignoreDependencies) {
                                        _knockout.default.ignoreDependencies(component.option, component, [optionName, optionValue])
                                    } else {
                                        component.option(optionName, optionValue)
                                    }
                                } finally {
                                    locks.release(optionName)
                                }
                            } else {
                                ctorOptions[optionName] = optionValue
                            }
                        };
                        var handleOptionChanged = function(args) {
                            var optionName = args.fullName;
                            var optionValue = args.value;
                            if (!(optionName in optionNameToModelMap)) {
                                return
                            }
                            var $element = this._$element;
                            var locks = $element.data(LOCKS_DATA_KEY);
                            if (locks.locked(optionName)) {
                                return
                            }
                            locks.obtain(optionName);
                            try {
                                optionNameToModelMap[optionName](optionValue)
                            } finally {
                                locks.release(optionName)
                            }
                        };
                        var createComponent = function() {
                            optionChangedCallbacks.add(handleOptionChanged);
                            $element.data(CREATED_WITH_KO_DATA_KEY, true).data(LOCKS_DATA_KEY, new _locker.default);
                            new componentClass($element, ctorOptions);
                            ctorOptions = null
                        };
                        var unwrapModelValue = function(currentModel, propertyName, propertyPath) {
                            if (propertyPath === isBindingPropertyPredicateName) {
                                return
                            }
                            if (!isBindingPropertyPredicate || isBindingPropertyPredicate(propertyPath, propertyName, currentModel)) {
                                var unwrappedPropertyValue;
                                _knockout.default.computed(function() {
                                    var propertyValue = currentModel[propertyName];
                                    applyModelValueToOption(propertyPath, propertyValue, true);
                                    unwrappedPropertyValue = _knockout.default.unwrap(propertyValue)
                                }, null, {
                                    disposeWhenNodeIsRemoved: domNode
                                });
                                if ((0, _type.isPlainObject)(unwrappedPropertyValue)) {
                                    if (!optionsByReference[propertyPath]) {
                                        unwrapModel(unwrappedPropertyValue, propertyPath)
                                    }
                                }
                            } else {
                                applyModelValueToOption(propertyPath, currentModel[propertyName], false)
                            }
                        };

                        function unwrapModel(model, propertyPath) {
                            for (var propertyName in model) {
                                if (Object.prototype.hasOwnProperty.call(model, propertyName)) {
                                    unwrapModelValue(model, propertyName, propertyPath ? [propertyPath, propertyName].join(".") : propertyName)
                                }
                            }
                        }
                        createComponent();
                        return {
                            controlsDescendantBindings: componentClass.subclassOf(_ui.default)
                        }
                    }
                };
                if ("dxValidator" === componentName) {
                    _knockout.default.bindingHandlers.dxValidator.after = editorsBindingHandlers
                }
            };
            _component_registrator_callbacks.default.add(function(name, componentClass) {
                registerComponentKoBinding(name, componentClass)
            })
        }
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/knockout/template.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.KoTemplate = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _knockout = _interopRequireDefault(__webpack_require__( /*! knockout */ 66));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _template_base = __webpack_require__( /*! ../../core/templates/template_base */ 75);
        var _dom = __webpack_require__( /*! ../../core/utils/dom */ 33);
        var _utils = __webpack_require__( /*! ./utils */ 261);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var getParentContext = function(data) {
            var parentNode = _dom_adapter.default.createElement("div");
            _knockout.default.applyBindingsToNode(parentNode, null, data);
            var parentContext = _knockout.default.contextFor(parentNode);
            _knockout.default.cleanNode(parentNode);
            return parentContext
        };
        var KoTemplate = function(_TemplateBase) {
            _inheritsLoose(KoTemplate, _TemplateBase);

            function KoTemplate(element) {
                var _this;
                _this = _TemplateBase.call(this) || this;
                _this._element = element;
                _this._template = (0, _renderer.default)("<div>").append((0, _dom.normalizeTemplateElement)(element));
                _this._registerKoTemplate();
                return _this
            }
            var _proto = KoTemplate.prototype;
            _proto._registerKoTemplate = function() {
                var template = this._template.get(0);
                new _knockout.default.templateSources.anonymousTemplate(template).nodes(template)
            };
            _proto._prepareDataForContainer = function(data, container) {
                if (container && container.length) {
                    var node = (0, _utils.getClosestNodeWithContext)(container.get(0));
                    var containerContext = _knockout.default.contextFor(node);
                    data = void 0 !== data ? data : _knockout.default.dataFor(node) || {};
                    if (containerContext) {
                        return data === containerContext.$data ? containerContext : containerContext.createChildContext(data)
                    }
                }
                return getParentContext(data).createChildContext(data)
            };
            _proto._renderCore = function(options) {
                var model = this._prepareDataForContainer(options.model, (0, _renderer.default)(options.container));
                if ((0, _type.isDefined)(options.index)) {
                    model.$index = options.index
                }
                var $placeholder = (0, _renderer.default)("<div>").appendTo(options.container);
                var $result;
                _knockout.default.renderTemplate(this._template.get(0), model, {
                    afterRender: function(nodes) {
                        $result = (0, _renderer.default)(nodes)
                    }
                }, $placeholder.get(0), "replaceNode");
                return $result
            };
            _proto.source = function() {
                return (0, _renderer.default)(this._element).clone()
            };
            _proto.dispose = function() {
                this._template.remove()
            };
            return KoTemplate
        }(_template_base.TemplateBase);
        exports.KoTemplate = KoTemplate
    },
    /*!****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/knockout/event_registrator.js ***!
      \****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _knockout = _interopRequireDefault(__webpack_require__( /*! knockout */ 66));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _event_registrator_callbacks = _interopRequireDefault(__webpack_require__( /*! ../../events/core/event_registrator_callbacks */ 131));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        if (_knockout.default) {
            _event_registrator_callbacks.default.add(function(name) {
                var koBindingEventName = (0, _index.addNamespace)(name, name + "Binding");
                _knockout.default.bindingHandlers[name] = {
                    update: function(element, valueAccessor, allBindingsAccessor, viewModel) {
                        var $element = (0, _renderer.default)(element);
                        var unwrappedValue = _knockout.default.utils.unwrapObservable(valueAccessor());
                        var eventSource = unwrappedValue.execute ? unwrappedValue.execute : unwrappedValue;
                        _events_engine.default.off($element, koBindingEventName);
                        _events_engine.default.on($element, koBindingEventName, (0, _type.isPlainObject)(unwrappedValue) ? unwrappedValue : {}, function(e) {
                            eventSource.call(viewModel, viewModel, e)
                        })
                    }
                }
            })
        }
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/knockout/components.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _knockout = _interopRequireDefault(__webpack_require__( /*! knockout */ 66));
        var _icon = __webpack_require__( /*! ../../core/utils/icon */ 56);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        if (_knockout.default) {
            _knockout.default.bindingHandlers.dxControlsDescendantBindings = {
                init: function(_, valueAccessor) {
                    return {
                        controlsDescendantBindings: _knockout.default.unwrap(valueAccessor())
                    }
                }
            };
            _knockout.default.bindingHandlers.dxIcon = {
                init: function(element, valueAccessor) {
                    var options = _knockout.default.utils.unwrapObservable(valueAccessor()) || {};
                    var iconElement = (0, _icon.getImageContainer)(options);
                    _knockout.default.virtualElements.emptyNode(element);
                    if (iconElement) {
                        _knockout.default.virtualElements.prepend(element, iconElement.get(0))
                    }
                },
                update: function(element, valueAccessor) {
                    var options = _knockout.default.utils.unwrapObservable(valueAccessor()) || {};
                    var iconElement = (0, _icon.getImageContainer)(options);
                    _knockout.default.virtualElements.emptyNode(element);
                    if (iconElement) {
                        _knockout.default.virtualElements.prepend(element, iconElement.get(0))
                    }
                }
            };
            _knockout.default.virtualElements.allowedBindings.dxIcon = true
        }
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/knockout/validation.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _events_strategy = __webpack_require__( /*! ../../core/events_strategy */ 100);
        var _validation_engine = _interopRequireDefault(__webpack_require__( /*! ../../ui/validation_engine */ 96));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _guid = _interopRequireDefault(__webpack_require__( /*! ../../core/guid */ 36));
        var _knockout = _interopRequireDefault(__webpack_require__( /*! knockout */ 66));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        if (_knockout.default) {
            var VALIDATION_STATUS_VALID = "valid";
            var VALIDATION_STATUS_PENDING = "pending";
            var koDxValidator = _class.default.inherit({
                ctor: function(target, _ref) {
                    var _this = this;
                    var name = _ref.name,
                        validationRules = _ref.validationRules;
                    this.target = target;
                    this.name = name;
                    this.isValid = _knockout.default.observable(true);
                    this.validationError = _knockout.default.observable();
                    this.validationErrors = _knockout.default.observable();
                    this.validationStatus = _knockout.default.observable(VALIDATION_STATUS_VALID);
                    this._eventsStrategy = new _events_strategy.EventsStrategy(this);
                    this.validationRules = (0, _iterator.map)(validationRules, function(rule, index) {
                        return (0, _extend.extend)({}, rule, {
                            validator: _this,
                            index: index
                        })
                    });
                    this._validationInfo = {
                        result: null,
                        deferred: null
                    }
                },
                _updateValidationResult: function(result) {
                    if (!this._validationInfo.result || this._validationInfo.result.id !== result.id) {
                        var complete = this._validationInfo.deferred && this._validationInfo.result.complete;
                        this._validationInfo.result = (0, _extend.extend)({}, result, {
                            complete: complete
                        })
                    } else {
                        for (var prop in result) {
                            if ("id" !== prop && "complete" !== prop) {
                                this._validationInfo.result[prop] = result[prop]
                            }
                        }
                    }
                },
                validate: function() {
                    var _this2 = this;
                    var currentResult = this._validationInfo && this._validationInfo.result;
                    var value = this.target();
                    if (currentResult && currentResult.status === VALIDATION_STATUS_PENDING && currentResult.value === value) {
                        return (0, _extend.extend)({}, currentResult)
                    }
                    var result = _validation_engine.default.validate(value, this.validationRules, this.name);
                    result.id = (new _guid.default).toString();
                    this._applyValidationResult(result);
                    result.complete && result.complete.then(function(res) {
                        if (res.id === _this2._validationInfo.result.id) {
                            _this2._applyValidationResult(res)
                        }
                    });
                    return (0, _extend.extend)({}, this._validationInfo.result)
                },
                reset: function() {
                    this.target(null);
                    var result = {
                        id: null,
                        isValid: true,
                        brokenRule: null,
                        pendingRules: null,
                        status: VALIDATION_STATUS_VALID,
                        complete: null
                    };
                    this._applyValidationResult(result);
                    return result
                },
                _applyValidationResult: function(result) {
                    result.validator = this;
                    this._updateValidationResult(result);
                    this.target.dxValidator.isValid(this._validationInfo.result.isValid);
                    this.target.dxValidator.validationError(this._validationInfo.result.brokenRule);
                    this.target.dxValidator.validationErrors(this._validationInfo.result.brokenRules);
                    this.target.dxValidator.validationStatus(this._validationInfo.result.status);
                    if (result.status === VALIDATION_STATUS_PENDING) {
                        if (!this._validationInfo.deferred) {
                            this._validationInfo.deferred = new _deferred.Deferred;
                            this._validationInfo.result.complete = this._validationInfo.deferred.promise()
                        }
                        this._eventsStrategy.fireEvent("validating", [this._validationInfo.result]);
                        return
                    }
                    if (result.status !== VALIDATION_STATUS_PENDING) {
                        this._eventsStrategy.fireEvent("validated", [result]);
                        if (this._validationInfo.deferred) {
                            this._validationInfo.deferred.resolve(result);
                            this._validationInfo.deferred = null
                        }
                    }
                },
                on: function(eventName, eventHandler) {
                    this._eventsStrategy.on(eventName, eventHandler);
                    return this
                },
                off: function(eventName, eventHandler) {
                    this._eventsStrategy.off(eventName, eventHandler);
                    return this
                }
            });
            _knockout.default.extenders.dxValidator = function(target, option) {
                target.dxValidator = new koDxValidator(target, option);
                target.subscribe(target.dxValidator.validate.bind(target.dxValidator));
                return target
            };
            _validation_engine.default.registerModelForValidation = function(model) {
                (0, _iterator.each)(model, function(name, member) {
                    if (_knockout.default.isObservable(member) && member.dxValidator) {
                        _validation_engine.default.registerValidatorInGroup(model, member.dxValidator)
                    }
                })
            };
            _validation_engine.default.unregisterModelForValidation = function(model) {
                (0, _iterator.each)(model, function(name, member) {
                    if (_knockout.default.isObservable(member) && member.dxValidator) {
                        _validation_engine.default.removeRegisteredValidator(model, member.dxValidator)
                    }
                })
            };
            _validation_engine.default.validateModel = _validation_engine.default.validateGroup
        }
    },
    /*!*********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/knockout/variable_wrapper_utils.js ***!
      \*********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _knockout = _interopRequireDefault(__webpack_require__( /*! knockout */ 66));
        var _variable_wrapper = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/variable_wrapper */ 102));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        if (_knockout.default) {
            _variable_wrapper.default.inject({
                isWrapped: _knockout.default.isObservable,
                isWritableWrapped: _knockout.default.isWritableObservable,
                wrap: _knockout.default.observable,
                unwrap: function(value) {
                    if (_knockout.default.isObservable(value)) {
                        return _knockout.default.utils.unwrapObservable(value)
                    }
                    return this.callBase(value)
                },
                assign: function(variable, value) {
                    if (_knockout.default.isObservable(variable)) {
                        variable(value)
                    } else {
                        this.callBase(variable, value)
                    }
                }
            })
        }
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/knockout/clean_node.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _element_data = __webpack_require__( /*! ../../core/element_data */ 40);
        var _knockout = _interopRequireDefault(__webpack_require__( /*! knockout */ 66));
        var _version = __webpack_require__( /*! ../../core/utils/version */ 72);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        if (_knockout.default) {
            var originalKOCleanExternalData = _knockout.default.utils.domNodeDisposal.cleanExternalData;
            var patchCleanData = function() {
                (0, _element_data.afterCleanData)(function(nodes) {
                    var i;
                    for (i = 0; i < nodes.length; i++) {
                        nodes[i].cleanedByJquery = true
                    }
                    for (i = 0; i < nodes.length; i++) {
                        if (!nodes[i].cleanedByKo) {
                            _knockout.default.cleanNode(nodes[i])
                        }
                        delete nodes[i].cleanedByKo
                    }
                    for (i = 0; i < nodes.length; i++) {
                        delete nodes[i].cleanedByJquery
                    }
                });
                _knockout.default.utils.domNodeDisposal.cleanExternalData = function(node) {
                    node.cleanedByKo = true;
                    if (!node.cleanedByJquery) {
                        (0, _element_data.cleanData)([node])
                    }
                }
            };
            var restoreOriginCleanData = function() {
                (0, _element_data.afterCleanData)(function() {});
                _knockout.default.utils.domNodeDisposal.cleanExternalData = originalKOCleanExternalData
            };
            patchCleanData();
            _element_data.strategyChanging.add(function(strategy) {
                var isJQuery = !!strategy.fn;
                if (isJQuery && (0, _version.compare)(strategy.fn.jquery, [2, 0]) < 0) {
                    restoreOriginCleanData()
                }
            })
        }
    },
    /*!*************************************************************************!*\
      !*** ./artifacts/transpiled-npm/integration/knockout/clean_node_old.js ***!
      \*************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _knockout = _interopRequireDefault(__webpack_require__( /*! knockout */ 66));
        var _version = __webpack_require__( /*! ../../core/utils/version */ 72);
        var _element_data = __webpack_require__( /*! ../../core/element_data */ 40);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        if (_knockout.default) {
            var patchCleanData = function(jQuery) {
                var cleanKoData = function(element, andSelf) {
                    var cleanNode = function() {
                        _knockout.default.cleanNode(this)
                    };
                    if (andSelf) {
                        element.each(cleanNode)
                    } else {
                        element.find("*").each(cleanNode)
                    }
                };
                var originalEmpty = jQuery.fn.empty;
                jQuery.fn.empty = function() {
                    cleanKoData(this, false);
                    return originalEmpty.apply(this, arguments)
                };
                var originalRemove = jQuery.fn.remove;
                jQuery.fn.remove = function(selector, keepData) {
                    if (!keepData) {
                        var subject = this;
                        if (selector) {
                            subject = subject.filter(selector)
                        }
                        cleanKoData(subject, true)
                    }
                    return originalRemove.call(this, selector, keepData)
                };
                var originalHtml = jQuery.fn.html;
                jQuery.fn.html = function(value) {
                    if ("string" === typeof value) {
                        cleanKoData(this, false)
                    }
                    return originalHtml.apply(this, arguments)
                };
                var originalReplaceWith = jQuery.fn.replaceWith;
                jQuery.fn.replaceWith = function() {
                    var result = originalReplaceWith.apply(this, arguments);
                    if (!this.parent().length) {
                        cleanKoData(this, true)
                    }
                    return result
                }
            };
            _element_data.strategyChanging.add(function(strategy) {
                var isJQuery = !!strategy.fn;
                if (isJQuery && (0, _version.compare)(strategy.fn.jquery, [2, 0]) < 0) {
                    patchCleanData(strategy)
                }
            })
        }
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/localization/globalize/message.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        __webpack_require__( /*! ./core */ 134);
        var _globalize = _interopRequireDefault(__webpack_require__( /*! globalize */ 78));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../message */ 10));
        var _core2 = _interopRequireDefault(__webpack_require__( /*! ../core */ 87));
        __webpack_require__( /*! globalize/message */ 78);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        if (_globalize.default && _globalize.default.formatMessage) {
            var DEFAULT_LOCALE = "en";
            var originalLoadMessages = _globalize.default.loadMessages;
            _globalize.default.loadMessages = function(messages) {
                _message.default.load(messages)
            };
            var globalizeMessageLocalization = {
                engine: function() {
                    return "globalize"
                },
                ctor: function() {
                    this.load(this._dictionary)
                },
                load: function(messages) {
                    this.callBase(messages);
                    originalLoadMessages(messages)
                },
                getMessagesByLocales: function() {
                    return _globalize.default.cldr.get("globalize-messages")
                },
                getFormatter: function(key, locale) {
                    var currentLocale = locale || _core2.default.locale();
                    var formatter = this._getFormatterBase(key, locale);
                    if (!formatter) {
                        formatter = this._formatterByGlobalize(key, locale)
                    }
                    if (!formatter && currentLocale !== DEFAULT_LOCALE) {
                        formatter = this.getFormatter(key, DEFAULT_LOCALE)
                    }
                    return formatter
                },
                _formatterByGlobalize: function(key, locale) {
                    var currentGlobalize = !locale || locale === _core2.default.locale() ? _globalize.default : new _globalize.default(locale);
                    var result;
                    if (this._messageLoaded(key, locale)) {
                        result = currentGlobalize.messageFormatter(key)
                    }
                    return result
                },
                _messageLoaded: function(key, locale) {
                    var currentCldr = locale ? new _globalize.default(locale).cldr : _globalize.default.locale();
                    var value = currentCldr.get(["globalize-messages/{bundle}", key]);
                    return !!value
                },
                _loadSingle: function(key, value, locale) {
                    var data = {};
                    data[locale] = {};
                    data[locale][key] = value;
                    this.load(data)
                }
            };
            _message.default.inject(globalizeMessageLocalization)
        }
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/localization/globalize/date.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        __webpack_require__( /*! ./core */ 134);
        __webpack_require__( /*! ./number */ 203);
        __webpack_require__( /*! globalize/date */ 78);
        var _globalize = _interopRequireDefault(__webpack_require__( /*! globalize */ 78));
        var _date2 = _interopRequireDefault(__webpack_require__( /*! ../date */ 32));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var iteratorUtils = _interopRequireWildcard(__webpack_require__( /*! ../../core/utils/iterator */ 3));

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var timeData = {
            supplemental: {
                version: {
                    _cldrVersion: "28",
                    _unicodeVersion: "8.0.0",
                    _number: "$Revision: 11969 $"
                },
                timeData: {
                    "001": {
                        _allowed: "H h",
                        _preferred: "H"
                    },
                    DE: {
                        _allowed: "H",
                        _preferred: "H"
                    },
                    JP: {
                        _allowed: "H K h",
                        _preferred: "H"
                    },
                    RU: {
                        _allowed: "H",
                        _preferred: "H"
                    },
                    US: {
                        _allowed: "H h",
                        _preferred: "h"
                    }
                }
            }
        };
        var enCaGregorian = {
            main: {
                en: {
                    identity: {
                        version: {
                            _cldrVersion: "28",
                            _number: "$Revision: 11972 $"
                        },
                        language: "en"
                    },
                    dates: {
                        calendars: {
                            gregorian: {
                                months: {
                                    format: {
                                        abbreviated: {
                                            1: "Jan",
                                            2: "Feb",
                                            3: "Mar",
                                            4: "Apr",
                                            5: "May",
                                            6: "Jun",
                                            7: "Jul",
                                            8: "Aug",
                                            9: "Sep",
                                            10: "Oct",
                                            11: "Nov",
                                            12: "Dec"
                                        },
                                        narrow: {
                                            1: "J",
                                            2: "F",
                                            3: "M",
                                            4: "A",
                                            5: "M",
                                            6: "J",
                                            7: "J",
                                            8: "A",
                                            9: "S",
                                            10: "O",
                                            11: "N",
                                            12: "D"
                                        },
                                        wide: {
                                            1: "January",
                                            2: "February",
                                            3: "March",
                                            4: "April",
                                            5: "May",
                                            6: "June",
                                            7: "July",
                                            8: "August",
                                            9: "September",
                                            10: "October",
                                            11: "November",
                                            12: "December"
                                        }
                                    },
                                    "stand-alone": {
                                        abbreviated: {
                                            1: "Jan",
                                            2: "Feb",
                                            3: "Mar",
                                            4: "Apr",
                                            5: "May",
                                            6: "Jun",
                                            7: "Jul",
                                            8: "Aug",
                                            9: "Sep",
                                            10: "Oct",
                                            11: "Nov",
                                            12: "Dec"
                                        },
                                        narrow: {
                                            1: "J",
                                            2: "F",
                                            3: "M",
                                            4: "A",
                                            5: "M",
                                            6: "J",
                                            7: "J",
                                            8: "A",
                                            9: "S",
                                            10: "O",
                                            11: "N",
                                            12: "D"
                                        },
                                        wide: {
                                            1: "January",
                                            2: "February",
                                            3: "March",
                                            4: "April",
                                            5: "May",
                                            6: "June",
                                            7: "July",
                                            8: "August",
                                            9: "September",
                                            10: "October",
                                            11: "November",
                                            12: "December"
                                        }
                                    }
                                },
                                days: {
                                    format: {
                                        abbreviated: {
                                            sun: "Sun",
                                            mon: "Mon",
                                            tue: "Tue",
                                            wed: "Wed",
                                            thu: "Thu",
                                            fri: "Fri",
                                            sat: "Sat"
                                        },
                                        narrow: {
                                            sun: "S",
                                            mon: "M",
                                            tue: "T",
                                            wed: "W",
                                            thu: "T",
                                            fri: "F",
                                            sat: "S"
                                        },
                                        "short": {
                                            sun: "Su",
                                            mon: "Mo",
                                            tue: "Tu",
                                            wed: "We",
                                            thu: "Th",
                                            fri: "Fr",
                                            sat: "Sa"
                                        },
                                        wide: {
                                            sun: "Sunday",
                                            mon: "Monday",
                                            tue: "Tuesday",
                                            wed: "Wednesday",
                                            thu: "Thursday",
                                            fri: "Friday",
                                            sat: "Saturday"
                                        }
                                    },
                                    "stand-alone": {
                                        abbreviated: {
                                            sun: "Sun",
                                            mon: "Mon",
                                            tue: "Tue",
                                            wed: "Wed",
                                            thu: "Thu",
                                            fri: "Fri",
                                            sat: "Sat"
                                        },
                                        narrow: {
                                            sun: "S",
                                            mon: "M",
                                            tue: "T",
                                            wed: "W",
                                            thu: "T",
                                            fri: "F",
                                            sat: "S"
                                        },
                                        "short": {
                                            sun: "Su",
                                            mon: "Mo",
                                            tue: "Tu",
                                            wed: "We",
                                            thu: "Th",
                                            fri: "Fr",
                                            sat: "Sa"
                                        },
                                        wide: {
                                            sun: "Sunday",
                                            mon: "Monday",
                                            tue: "Tuesday",
                                            wed: "Wednesday",
                                            thu: "Thursday",
                                            fri: "Friday",
                                            sat: "Saturday"
                                        }
                                    }
                                },
                                quarters: {
                                    format: {
                                        abbreviated: {
                                            1: "Q1",
                                            2: "Q2",
                                            3: "Q3",
                                            4: "Q4"
                                        },
                                        narrow: {
                                            1: "1",
                                            2: "2",
                                            3: "3",
                                            4: "4"
                                        },
                                        wide: {
                                            1: "1st quarter",
                                            2: "2nd quarter",
                                            3: "3rd quarter",
                                            4: "4th quarter"
                                        }
                                    },
                                    "stand-alone": {
                                        abbreviated: {
                                            1: "Q1",
                                            2: "Q2",
                                            3: "Q3",
                                            4: "Q4"
                                        },
                                        narrow: {
                                            1: "1",
                                            2: "2",
                                            3: "3",
                                            4: "4"
                                        },
                                        wide: {
                                            1: "1st quarter",
                                            2: "2nd quarter",
                                            3: "3rd quarter",
                                            4: "4th quarter"
                                        }
                                    }
                                },
                                dayPeriods: {
                                    format: {
                                        abbreviated: {
                                            midnight: "midnight",
                                            am: "AM",
                                            "am-alt-variant": "am",
                                            noon: "noon",
                                            pm: "PM",
                                            "pm-alt-variant": "pm",
                                            morning1: "in the morning",
                                            afternoon1: "in the afternoon",
                                            evening1: "in the evening",
                                            night1: "at night"
                                        },
                                        narrow: {
                                            midnight: "mi",
                                            am: "a",
                                            "am-alt-variant": "am",
                                            noon: "n",
                                            pm: "p",
                                            "pm-alt-variant": "pm",
                                            morning1: "in the morning",
                                            afternoon1: "in the afternoon",
                                            evening1: "in the evening",
                                            night1: "at night"
                                        },
                                        wide: {
                                            midnight: "midnight",
                                            am: "AM",
                                            "am-alt-variant": "am",
                                            noon: "noon",
                                            pm: "PM",
                                            "pm-alt-variant": "pm",
                                            morning1: "in the morning",
                                            afternoon1: "in the afternoon",
                                            evening1: "in the evening",
                                            night1: "at night"
                                        }
                                    },
                                    "stand-alone": {
                                        abbreviated: {
                                            midnight: "midnight",
                                            am: "AM",
                                            "am-alt-variant": "am",
                                            noon: "noon",
                                            pm: "PM",
                                            "pm-alt-variant": "pm",
                                            morning1: "in the morning",
                                            afternoon1: "in the afternoon",
                                            evening1: "in the evening",
                                            night1: "at night"
                                        },
                                        narrow: {
                                            midnight: "midnight",
                                            am: "AM",
                                            "am-alt-variant": "am",
                                            noon: "noon",
                                            pm: "PM",
                                            "pm-alt-variant": "pm",
                                            morning1: "in the morning",
                                            afternoon1: "in the afternoon",
                                            evening1: "in the evening",
                                            night1: "at night"
                                        },
                                        wide: {
                                            midnight: "midnight",
                                            am: "AM",
                                            "am-alt-variant": "am",
                                            noon: "noon",
                                            pm: "PM",
                                            "pm-alt-variant": "pm",
                                            morning1: "morning",
                                            afternoon1: "afternoon",
                                            evening1: "evening",
                                            night1: "night"
                                        }
                                    }
                                },
                                eras: {
                                    eraNames: {
                                        0: "Before Christ",
                                        "0-alt-variant": "Before Common Era",
                                        1: "Anno Domini",
                                        "1-alt-variant": "Common Era"
                                    },
                                    eraAbbr: {
                                        0: "BC",
                                        "0-alt-variant": "BCE",
                                        1: "AD",
                                        "1-alt-variant": "CE"
                                    },
                                    eraNarrow: {
                                        0: "B",
                                        "0-alt-variant": "BCE",
                                        1: "A",
                                        "1-alt-variant": "CE"
                                    }
                                },
                                dateFormats: {
                                    full: "EEEE, MMMM d, y",
                                    "long": "MMMM d, y",
                                    medium: "MMM d, y",
                                    "short": "M/d/yy"
                                },
                                timeFormats: {
                                    full: "h:mm:ss a zzzz",
                                    "long": "h:mm:ss a z",
                                    medium: "h:mm:ss a",
                                    "short": "h:mm a"
                                },
                                dateTimeFormats: {
                                    full: "{1} 'at' {0}",
                                    "long": "{1} 'at' {0}",
                                    medium: "{1}, {0}",
                                    "short": "{1}, {0}",
                                    availableFormats: {
                                        d: "d",
                                        E: "ccc",
                                        Ed: "d E",
                                        Ehm: "E h:mm a",
                                        EHm: "E HH:mm",
                                        Ehms: "E h:mm:ss a",
                                        EHms: "E HH:mm:ss",
                                        Gy: "y G",
                                        GyMMM: "MMM y G",
                                        GyMMMd: "MMM d, y G",
                                        GyMMMEd: "E, MMM d, y G",
                                        h: "h a",
                                        H: "HH",
                                        hm: "h:mm a",
                                        Hm: "HH:mm",
                                        hms: "h:mm:ss a",
                                        Hms: "HH:mm:ss",
                                        hmsv: "h:mm:ss a v",
                                        Hmsv: "HH:mm:ss v",
                                        hmv: "h:mm a v",
                                        Hmv: "HH:mm v",
                                        M: "L",
                                        Md: "M/d",
                                        MEd: "E, M/d",
                                        MMM: "LLL",
                                        MMMd: "MMM d",
                                        MMMEd: "E, MMM d",
                                        MMMMd: "MMMM d",
                                        ms: "mm:ss",
                                        y: "y",
                                        yM: "M/y",
                                        yMd: "M/d/y",
                                        yMEd: "E, M/d/y",
                                        yMMM: "MMM y",
                                        yMMMd: "MMM d, y",
                                        yMMMEd: "E, MMM d, y",
                                        yMMMM: "MMMM y",
                                        yQQQ: "QQQ y",
                                        yQQQQ: "QQQQ y"
                                    },
                                    appendItems: {
                                        Day: "{0} ({2}: {1})",
                                        "Day-Of-Week": "{0} {1}",
                                        Era: "{0} {1}",
                                        Hour: "{0} ({2}: {1})",
                                        Minute: "{0} ({2}: {1})",
                                        Month: "{0} ({2}: {1})",
                                        Quarter: "{0} ({2}: {1})",
                                        Second: "{0} ({2}: {1})",
                                        Timezone: "{0} {1}",
                                        Week: "{0} ({2}: {1})",
                                        Year: "{0} {1}"
                                    },
                                    intervalFormats: {
                                        intervalFormatFallback: "{0} \u2013 {1}",
                                        d: {
                                            d: "d \u2013 d"
                                        },
                                        h: {
                                            a: "h a \u2013 h a",
                                            h: "h \u2013 h a"
                                        },
                                        H: {
                                            H: "HH \u2013 HH"
                                        },
                                        hm: {
                                            a: "h:mm a \u2013 h:mm a",
                                            h: "h:mm \u2013 h:mm a",
                                            m: "h:mm \u2013 h:mm a"
                                        },
                                        Hm: {
                                            H: "HH:mm \u2013 HH:mm",
                                            m: "HH:mm \u2013 HH:mm"
                                        },
                                        hmv: {
                                            a: "h:mm a \u2013 h:mm a v",
                                            h: "h:mm \u2013 h:mm a v",
                                            m: "h:mm \u2013 h:mm a v"
                                        },
                                        Hmv: {
                                            H: "HH:mm \u2013 HH:mm v",
                                            m: "HH:mm \u2013 HH:mm v"
                                        },
                                        hv: {
                                            a: "h a \u2013 h a v",
                                            h: "h \u2013 h a v"
                                        },
                                        Hv: {
                                            H: "HH \u2013 HH v"
                                        },
                                        M: {
                                            M: "M \u2013 M"
                                        },
                                        Md: {
                                            d: "M/d \u2013 M/d",
                                            M: "M/d \u2013 M/d"
                                        },
                                        MEd: {
                                            d: "E, M/d \u2013 E, M/d",
                                            M: "E, M/d \u2013 E, M/d"
                                        },
                                        MMM: {
                                            M: "MMM \u2013 MMM"
                                        },
                                        MMMd: {
                                            d: "MMM d \u2013 d",
                                            M: "MMM d \u2013 MMM d"
                                        },
                                        MMMEd: {
                                            d: "E, MMM d \u2013 E, MMM d",
                                            M: "E, MMM d \u2013 E, MMM d"
                                        },
                                        y: {
                                            y: "y \u2013 y"
                                        },
                                        yM: {
                                            M: "M/y \u2013 M/y",
                                            y: "M/y \u2013 M/y"
                                        },
                                        yMd: {
                                            d: "M/d/y \u2013 M/d/y",
                                            M: "M/d/y \u2013 M/d/y",
                                            y: "M/d/y \u2013 M/d/y"
                                        },
                                        yMEd: {
                                            d: "E, M/d/y \u2013 E, M/d/y",
                                            M: "E, M/d/y \u2013 E, M/d/y",
                                            y: "E, M/d/y \u2013 E, M/d/y"
                                        },
                                        yMMM: {
                                            M: "MMM \u2013 MMM y",
                                            y: "MMM y \u2013 MMM y"
                                        },
                                        yMMMd: {
                                            d: "MMM d \u2013 d, y",
                                            M: "MMM d \u2013 MMM d, y",
                                            y: "MMM d, y \u2013 MMM d, y"
                                        },
                                        yMMMEd: {
                                            d: "E, MMM d \u2013 E, MMM d, y",
                                            M: "E, MMM d \u2013 E, MMM d, y",
                                            y: "E, MMM d, y \u2013 E, MMM d, y"
                                        },
                                        yMMMM: {
                                            M: "MMMM \u2013 MMMM y",
                                            y: "MMMM y \u2013 MMMM y"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        };
        var weekData = {
            supplemental: {
                version: {
                    _cldrVersion: "28",
                    _unicodeVersion: "8.0.0",
                    _number: "$Revision: 11969 $"
                },
                weekData: {
                    minDays: {
                        "001": "1",
                        US: "1",
                        DE: "4"
                    },
                    firstDay: {
                        "001": "mon",
                        DE: "mon",
                        RU: "mon",
                        JP: "sun",
                        US: "sun"
                    },
                    weekendStart: {
                        "001": "sat"
                    },
                    weekendEnd: {
                        "001": "sun"
                    }
                }
            }
        };
        var ACCEPTABLE_JSON_FORMAT_PROPERTIES = ["skeleton", "date", "time", "datetime", "raw"];
        var RTL_MARKS_REGEX = /[\u200E\u200F]/g;
        if (_globalize.default && _globalize.default.formatDate) {
            if ("en" === _globalize.default.locale().locale) {
                _globalize.default.load(weekData, timeData, enCaGregorian);
                _globalize.default.locale("en")
            }
            var formattersCache = {};
            var FORMATS_TO_GLOBALIZE_MAP = {
                shortdate: {
                    path: "dateTimeFormats/availableFormats/yMd"
                },
                shorttime: {
                    path: "timeFormats/short"
                },
                longdate: {
                    path: "dateFormats/full"
                },
                longtime: {
                    path: "timeFormats/medium"
                },
                monthandday: {
                    path: "dateTimeFormats/availableFormats/MMMMd"
                },
                monthandyear: {
                    path: "dateTimeFormats/availableFormats/yMMMM"
                },
                quarterandyear: {
                    path: "dateTimeFormats/availableFormats/yQQQ"
                },
                day: {
                    path: "dateTimeFormats/availableFormats/d"
                },
                year: {
                    path: "dateTimeFormats/availableFormats/y"
                },
                shortdateshorttime: {
                    path: "dateTimeFormats/short",
                    parts: ["shorttime", "shortdate"]
                },
                longdatelongtime: {
                    path: "dateTimeFormats/medium",
                    parts: ["longtime", "longdate"]
                },
                month: {
                    pattern: "LLLL"
                },
                shortyear: {
                    pattern: "yy"
                },
                dayofweek: {
                    pattern: "EEEE"
                },
                quarter: {
                    pattern: "QQQ"
                },
                millisecond: {
                    pattern: "SSS"
                },
                hour: {
                    pattern: "HH"
                },
                minute: {
                    pattern: "mm"
                },
                second: {
                    pattern: "ss"
                }
            };
            var globalizeDateLocalization = {
                engine: function() {
                    return "globalize"
                },
                _getPatternByFormat: function(format) {
                    var that = this;
                    var lowerFormat = format.toLowerCase();
                    var globalizeFormat = FORMATS_TO_GLOBALIZE_MAP[lowerFormat];
                    if ("datetime-local" === lowerFormat) {
                        return "yyyy-MM-ddTHH':'mm':'ss"
                    }
                    if (!globalizeFormat) {
                        return
                    }
                    var result = globalizeFormat.path && that._getFormatStringByPath(globalizeFormat.path) || globalizeFormat.pattern;
                    if (globalizeFormat.parts) {
                        iteratorUtils.each(globalizeFormat.parts, function(index, part) {
                            result = result.replace("{" + index + "}", that._getPatternByFormat(part))
                        })
                    }
                    return result
                },
                _getFormatStringByPath: function(path) {
                    return _globalize.default.locale().main("dates/calendars/gregorian/" + path)
                },
                getPeriodNames: function() {
                    var json = _globalize.default.locale().main("dates/calendars/gregorian/dayPeriods/stand-alone/wide");
                    return [json.am, json.pm]
                },
                getMonthNames: function(format, type) {
                    var months = _globalize.default.locale().main("dates/calendars/gregorian/months/" + ("format" === type ? type : "stand-alone") + "/" + (format || "wide"));
                    return iteratorUtils.map(months, function(month) {
                        return month
                    })
                },
                getDayNames: function(format) {
                    var days = _globalize.default.locale().main("dates/calendars/gregorian/days/stand-alone/" + (format || "wide"));
                    return iteratorUtils.map(days, function(day) {
                        return day
                    })
                },
                getTimeSeparator: function() {
                    return _globalize.default.locale().main("numbers/symbols-numberSystem-latn/timeSeparator")
                },
                removeRtlMarks: function(text) {
                    return text.replace(RTL_MARKS_REGEX, "")
                },
                format: function(date, _format) {
                    if (!date) {
                        return
                    }
                    if (!_format) {
                        return date
                    }
                    var formatter;
                    var formatCacheKey;
                    if ("function" === typeof _format) {
                        return _format(date)
                    }
                    if (_format.formatter) {
                        return _format.formatter(date)
                    }
                    _format = _format.type || _format;
                    if ("string" === typeof _format) {
                        formatCacheKey = _globalize.default.locale().locale + ":" + _format;
                        formatter = formattersCache[formatCacheKey];
                        if (!formatter) {
                            _format = {
                                raw: this._getPatternByFormat(_format) || _format
                            };
                            formatter = formattersCache[formatCacheKey] = _globalize.default.dateFormatter(_format)
                        }
                    } else {
                        if (!this._isAcceptableFormat(_format)) {
                            return
                        }
                        formatter = _globalize.default.dateFormatter(_format)
                    }
                    return this.removeRtlMarks(formatter(date))
                },
                parse: function(text, format) {
                    if (!text) {
                        return
                    }
                    if (!format || "function" === typeof format || (0, _type.isObject)(format) && !this._isAcceptableFormat(format)) {
                        if (format) {
                            var parsedValue = this.callBase(text, format);
                            if (parsedValue) {
                                return parsedValue
                            }
                        }
                        return _globalize.default.parseDate(text)
                    }
                    if (format.parser) {
                        return format.parser(text)
                    }
                    if ("string" === typeof format) {
                        format = {
                            raw: this._getPatternByFormat(format) || format
                        }
                    }
                    return _globalize.default.parseDate(text, format)
                },
                _isAcceptableFormat: function(format) {
                    if (format.parser) {
                        return true
                    }
                    for (var i = 0; i < ACCEPTABLE_JSON_FORMAT_PROPERTIES.length; i++) {
                        if (Object.prototype.hasOwnProperty.call(format, ACCEPTABLE_JSON_FORMAT_PROPERTIES[i])) {
                            return true
                        }
                    }
                },
                firstDayOfWeekIndex: function() {
                    var firstDay = _globalize.default.locale().supplemental.weekData.firstDay();
                    return (0, _array.inArray)(firstDay, this._getDayKeys())
                },
                _getDayKeys: function() {
                    var days = _globalize.default.locale().main("dates/calendars/gregorian/days/format/short");
                    return iteratorUtils.map(days, function(day, key) {
                        return key
                    })
                }
            };
            _date2.default.resetInjection();
            _date2.default.inject(globalizeDateLocalization)
        }
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/localization/globalize/currency.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _open_xml_currency_format = _interopRequireDefault(__webpack_require__( /*! ../open_xml_currency_format */ 241));
        __webpack_require__( /*! ./core */ 134);
        __webpack_require__( /*! ./number */ 203);
        __webpack_require__( /*! ../currency */ 114);
        __webpack_require__( /*! globalize/currency */ 78);
        var _globalize = _interopRequireDefault(__webpack_require__( /*! globalize */ 78));
        var _config = _interopRequireDefault(__webpack_require__( /*! ../../core/config */ 31));
        var _number2 = _interopRequireDefault(__webpack_require__( /*! ../number */ 47));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        var enCurrencyUSD = {
            main: {
                en: {
                    identity: {
                        version: {
                            _cldrVersion: "28",
                            _number: "$Revision: 11972 $"
                        },
                        language: "en"
                    },
                    numbers: {
                        currencies: {
                            USD: {
                                displayName: "US Dollar",
                                "displayName-count-one": "US dollar",
                                "displayName-count-other": "US dollars",
                                symbol: "$",
                                "symbol-alt-narrow": "$"
                            }
                        }
                    }
                }
            }
        };
        var currencyData = {
            supplemental: {
                version: {
                    _cldrVersion: "28",
                    _unicodeVersion: "8.0.0",
                    _number: "$Revision: 11969 $"
                },
                currencyData: {
                    fractions: {
                        DEFAULT: {
                            _rounding: "0",
                            _digits: "2"
                        }
                    }
                }
            }
        };
        if (_globalize.default && _globalize.default.formatCurrency) {
            if ("en" === _globalize.default.locale().locale) {
                _globalize.default.load(enCurrencyUSD, currencyData);
                _globalize.default.locale("en")
            }
            var formattersCache = {};
            var getFormatter = function(currency, format) {
                var formatter;
                var formatCacheKey;
                if ("object" === _typeof(format)) {
                    formatCacheKey = _globalize.default.locale().locale + ":" + currency + ":" + JSON.stringify(format)
                } else {
                    formatCacheKey = _globalize.default.locale().locale + ":" + currency + ":" + format
                }
                formatter = formattersCache[formatCacheKey];
                if (!formatter) {
                    formatter = formattersCache[formatCacheKey] = _globalize.default.currencyFormatter(currency, format)
                }
                return formatter
            };
            var globalizeCurrencyLocalization = {
                _formatNumberCore: function(value, format, formatConfig) {
                    if ("currency" === format) {
                        var currency = formatConfig && formatConfig.currency || (0, _config.default)().defaultCurrency;
                        return getFormatter(currency, this._normalizeFormatConfig(format, formatConfig, value))(value)
                    }
                    return this.callBase.apply(this, arguments)
                },
                _normalizeFormatConfig: function(format, formatConfig, value) {
                    var config = this.callBase(format, formatConfig, value);
                    if ("currency" === format) {
                        config.style = "accounting"
                    }
                    return config
                },
                format: function(value, _format) {
                    if ("number" !== typeof value) {
                        return value
                    }
                    _format = this._normalizeFormat(_format);
                    if (_format) {
                        if ("default" === _format.currency) {
                            _format.currency = (0, _config.default)().defaultCurrency
                        }
                        if ("currency" === _format.type) {
                            return this._formatNumber(value, this._parseNumberFormatString("currency"), _format)
                        } else {
                            if (!_format.type && _format.currency) {
                                return getFormatter(_format.currency, _format)(value)
                            }
                        }
                    }
                    return this.callBase.apply(this, arguments)
                },
                getCurrencySymbol: function(currency) {
                    if (!currency) {
                        currency = (0, _config.default)().defaultCurrency
                    }
                    return _globalize.default.cldr.main("numbers/currencies/" + currency)
                },
                getOpenXmlCurrencyFormat: function(currency) {
                    var currencySymbol = this.getCurrencySymbol(currency).symbol;
                    var accountingFormat = _globalize.default.cldr.main("numbers/currencyFormats-numberSystem-latn").accounting;
                    return (0, _open_xml_currency_format.default)(currencySymbol, accountingFormat)
                }
            };
            _number2.default.inject(globalizeCurrencyLocalization)
        }
    },
    /*!******************************************************!*\
      !*** ./artifacts/transpiled-npm/data/local_store.js ***!
      \******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../core/dom_adapter */ 11));
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _class = _interopRequireDefault(__webpack_require__( /*! ../core/class */ 15));
        var _errors = _interopRequireDefault(__webpack_require__( /*! ./errors */ 38));
        var _array_store = _interopRequireDefault(__webpack_require__( /*! ./array_store */ 77));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var abstract = _class.default.abstract;
        var LocalStoreBackend = _class.default.inherit({
            ctor: function(store, storeOptions) {
                this._store = store;
                this._dirty = !!storeOptions.data;
                this.save();
                var immediate = this._immediate = storeOptions.immediate;
                var flushInterval = Math.max(100, storeOptions.flushInterval || 1e4);
                if (!immediate) {
                    var saveProxy = this.save.bind(this);
                    setInterval(saveProxy, flushInterval);
                    _events_engine.default.on(window, "beforeunload", saveProxy);
                    if (window.cordova) {
                        _dom_adapter.default.listen(_dom_adapter.default.getDocument(), "pause", saveProxy, false)
                    }
                }
            },
            notifyChanged: function() {
                this._dirty = true;
                if (this._immediate) {
                    this.save()
                }
            },
            load: function() {
                this._store._array = this._loadImpl();
                this._dirty = false
            },
            save: function() {
                if (!this._dirty) {
                    return
                }
                this._saveImpl(this._store._array);
                this._dirty = false
            },
            _loadImpl: abstract,
            _saveImpl: abstract
        });
        var DomLocalStoreBackend = LocalStoreBackend.inherit({
            ctor: function(store, storeOptions) {
                var name = storeOptions.name;
                if (!name) {
                    throw _errors.default.errors.Error("E4013")
                }
                this._key = "dx-data-localStore-" + name;
                this.callBase(store, storeOptions)
            },
            _loadImpl: function() {
                var raw = window.localStorage.getItem(this._key);
                if (raw) {
                    return JSON.parse(raw)
                }
                return []
            },
            _saveImpl: function(array) {
                if (!array.length) {
                    window.localStorage.removeItem(this._key)
                } else {
                    window.localStorage.setItem(this._key, JSON.stringify(array))
                }
            }
        });
        var localStoreBackends = {
            dom: DomLocalStoreBackend
        };
        var LocalStore = _array_store.default.inherit({
            ctor: function(options) {
                if ("string" === typeof options) {
                    options = {
                        name: options
                    }
                } else {
                    options = options || {}
                }
                this.callBase(options);
                this._backend = new localStoreBackends[options.backend || "dom"](this, options);
                this._backend.load()
            },
            clear: function() {
                this.callBase();
                this._backend.notifyChanged()
            },
            _insertImpl: function(values) {
                var b = this._backend;
                return this.callBase(values).done(b.notifyChanged.bind(b))
            },
            _updateImpl: function(key, values) {
                var b = this._backend;
                return this.callBase(key, values).done(b.notifyChanged.bind(b))
            },
            _removeImpl: function(key) {
                var b = this._backend;
                return this.callBase(key).done(b.notifyChanged.bind(b))
            }
        }, "local");
        var _default = LocalStore;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/data/apply_changes.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _array_utils = __webpack_require__( /*! ./array_utils */ 93);
        var _default = _array_utils.applyChanges;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************************!*\
      !*** ./artifacts/transpiled-npm/data/endpoint_selector.js ***!
      \************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../core/errors */ 25));
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var IS_WINJS_ORIGIN;
        var IS_LOCAL_ORIGIN;

        function isLocalHostName(url) {
            return /^(localhost$|127\.)/i.test(url)
        }
        var EndpointSelector = function(config) {
            this.config = config;
            IS_WINJS_ORIGIN = "ms-appx:" === window.location.protocol;
            IS_LOCAL_ORIGIN = isLocalHostName(window.location.hostname)
        };
        EndpointSelector.prototype = {
            urlFor: function(key) {
                var bag = this.config[key];
                if (!bag) {
                    throw _errors.default.Error("E0006")
                }
                if (bag.production) {
                    if (IS_WINJS_ORIGIN && !Debug.debuggerEnabled || !IS_WINJS_ORIGIN && !IS_LOCAL_ORIGIN) {
                        return bag.production
                    }
                }
                return bag.local
            }
        };
        var _default = EndpointSelector;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************!*\
      !*** ./artifacts/transpiled-npm/bundles/modules/data.odata.js ***!
      \****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        __webpack_require__( /*! ./data */ 262);
        DevExpress.data.ODataStore = __webpack_require__( /*! ../../data/odata/store */ 263);
        DevExpress.data.ODataContext = __webpack_require__( /*! ../../data/odata/context */ 572);
        DevExpress.data.utils = DevExpress.data.utils || {};
        DevExpress.data.utils.odata = {};
        DevExpress.data.utils.odata.keyConverters = __webpack_require__( /*! ../../data/odata/utils */ 101).keyConverters;
        DevExpress.data.EdmLiteral = __webpack_require__( /*! ../../data/odata/utils */ 101).EdmLiteral;
        var ODataUtilsModule = __webpack_require__( /*! ../../data/odata/utils */ 101);
        DevExpress.data.utils.odata.serializePropName = ODataUtilsModule.serializePropName;
        DevExpress.data.utils.odata.serializeValue = ODataUtilsModule.serializeValue;
        DevExpress.data.utils.odata.serializeKey = ODataUtilsModule.serializeKey;
        DevExpress.data.utils.odata.sendRequest = ODataUtilsModule.sendRequest;
        DevExpress.data.queryAdapters = DevExpress.data.queryAdapters || {};
        DevExpress.data.queryAdapters.odata = __webpack_require__( /*! ../../data/odata/query_adapter */ 171).odata
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/data/odata/context.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../errors */ 38));
        var _store = _interopRequireDefault(__webpack_require__( /*! ./store */ 263));
        var _request_dispatcher = _interopRequireDefault(__webpack_require__( /*! ./request_dispatcher */ 264));
        var _utils = __webpack_require__( /*! ./utils */ 101);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        __webpack_require__( /*! ./query_adapter */ 171);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ODataContext = _class.default.inherit({
            ctor: function(options) {
                var _this = this;
                this._requestDispatcher = new _request_dispatcher.default(options);
                this._errorHandler = options.errorHandler;
                (0, _iterator.each)(options.entities || [], function(entityAlias, entityOptions) {
                    _this[entityAlias] = new _store.default((0, _extend.extend)({}, options, {
                        url: "".concat(_this._requestDispatcher.url, "/").concat(encodeURIComponent(entityOptions.name || entityAlias))
                    }, entityOptions))
                })
            },
            get: function(operationName, params) {
                return this.invoke(operationName, params, "GET")
            },
            invoke: function(operationName) {
                var params = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                var httpMethod = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "POST";
                httpMethod = httpMethod.toLowerCase();
                var d = new _deferred.Deferred;
                var url = "".concat(this._requestDispatcher.url, "/").concat(encodeURIComponent(operationName));
                var payload;
                if (4 === this.version()) {
                    if ("get" === httpMethod) {
                        url = (0, _utils.formatFunctionInvocationUrl)(url, (0, _utils.escapeServiceOperationParams)(params, this.version()));
                        params = null
                    } else {
                        if ("post" === httpMethod) {
                            payload = params;
                            params = null
                        }
                    }
                }(0, _deferred.when)(this._requestDispatcher.sendRequest(url, httpMethod, (0, _utils.escapeServiceOperationParams)(params, this.version()), payload)).done(function(r) {
                    if ((0, _type.isPlainObject)(r) && operationName in r) {
                        r = r[operationName]
                    }
                    d.resolve(r)
                }).fail(this._errorHandler).fail(_errors.default._errorHandler).fail(d.reject);
                return d.promise()
            },
            objectLink: function(entityAlias, key) {
                var store = this[entityAlias];
                if (!store) {
                    throw _errors.default.errors.Error("E4015", entityAlias)
                }
                if (!(0, _type.isDefined)(key)) {
                    return null
                }
                return {
                    __metadata: {
                        uri: store._byKeyUrl(key)
                    }
                }
            },
            version: function() {
                return this._requestDispatcher.version
            }
        });
        var _default = ODataContext;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/file_management/object_provider.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _array = __webpack_require__( /*! ../core/utils/array */ 12);
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _data = __webpack_require__( /*! ../core/utils/data */ 20);
        var _guid = _interopRequireDefault(__webpack_require__( /*! ../core/guid */ 36));
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../data/errors */ 38));
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _file_saver = __webpack_require__( /*! ../exporter/file_saver */ 178);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../ui/widget/ui.errors */ 17));
        var _jszip = _interopRequireDefault(__webpack_require__( /*! jszip */ 322));
        var _provider_base = _interopRequireDefault(__webpack_require__( /*! ./provider_base */ 206));
        var _errors2 = _interopRequireDefault(__webpack_require__( /*! ./errors */ 266));
        var _utils = __webpack_require__( /*! ./utils */ 265);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var window = (0, _window.getWindow)();
        var ObjectFileSystemProvider = function(_FileSystemProviderBa) {
            _inheritsLoose(ObjectFileSystemProvider, _FileSystemProviderBa);

            function ObjectFileSystemProvider(options) {
                var _this;
                options = (0, _common.ensureDefined)(options, {});
                _this = _FileSystemProviderBa.call(this, options) || this;
                var initialArray = options.data;
                if (initialArray && !Array.isArray(initialArray)) {
                    throw _errors.default.errors.Error("E4006")
                }
                var itemsExpr = options.itemsExpr || "items";
                _this._subFileItemsGetter = (0, _data.compileGetter)(itemsExpr);
                _this._subFileItemsSetter = _this._getSetter(itemsExpr);
                var contentExpr = options.contentExpr || "content";
                _this._contentGetter = (0, _data.compileGetter)(contentExpr);
                _this._contentSetter = _this._getSetter(contentExpr);
                var nameExpr = _this._getNameExpr(options);
                _this._nameSetter = _this._getSetter(nameExpr);
                var isDirExpr = _this._getIsDirExpr(options);
                _this._getIsDirSetter = _this._getSetter(isDirExpr);
                var keyExpr = _this._getKeyExpr(options);
                _this._keySetter = _this._getSetter(keyExpr);
                var sizeExpr = _this._getSizeExpr(options);
                _this._sizeSetter = _this._getSetter(sizeExpr);
                var dateModifiedExpr = _this._getDateModifiedExpr(options);
                _this._dateModifiedSetter = _this._getSetter(dateModifiedExpr);
                _this._data = initialArray || [];
                return _this
            }
            var _proto = ObjectFileSystemProvider.prototype;
            _proto.getItems = function(parentDir) {
                var _this2 = this;
                return this._executeActionAsDeferred(function() {
                    return _this2._getItems(parentDir)
                }, true)
            };
            _proto.renameItem = function(item, name) {
                var _this3 = this;
                return this._executeActionAsDeferred(function() {
                    return _this3._renameItemCore(item, name)
                })
            };
            _proto._renameItemCore = function(item, name) {
                if (!item) {
                    return
                }
                var dataItem = this._findDataObject(item);
                this._nameSetter(dataItem, name);
                item.name = name;
                item.key = this._ensureDataObjectKey(dataItem)
            };
            _proto.createDirectory = function(parentDir, name) {
                var _this4 = this;
                return this._executeActionAsDeferred(function() {
                    _this4._validateDirectoryExists(parentDir);
                    _this4._createDataObject(parentDir, name, true)
                })
            };
            _proto.deleteItems = function(items) {
                var _this5 = this;
                return items.map(function(item) {
                    return _this5._executeActionAsDeferred(function() {
                        return _this5._deleteItem(item)
                    })
                })
            };
            _proto.moveItems = function(items, destinationDir) {
                var _this6 = this;
                var destinationDataItem = this._findDataObject(destinationDir);
                var array = this._getDirectoryDataItems(destinationDataItem);
                var deferreds = items.map(function(item) {
                    return _this6._executeActionAsDeferred(function() {
                        _this6._checkAbilityToMoveOrCopyItem(item, destinationDir);
                        var dataItem = _this6._findDataObject(item);
                        _this6._deleteItem(item);
                        array.push(dataItem)
                    })
                });
                return deferreds
            };
            _proto.copyItems = function(items, destinationDir) {
                var _this7 = this;
                var destinationDataItem = this._findDataObject(destinationDir);
                var array = this._getDirectoryDataItems(destinationDataItem);
                var deferreds = items.map(function(item) {
                    return _this7._executeActionAsDeferred(function() {
                        _this7._checkAbilityToMoveOrCopyItem(item, destinationDir);
                        var dataItem = _this7._findDataObject(item);
                        var copiedItem = _this7._createCopy(dataItem);
                        array.push(copiedItem)
                    })
                });
                return deferreds
            };
            _proto.uploadFileChunk = function(fileData, chunksInfo, destinationDirectory) {
                var _this8 = this;
                if (chunksInfo.chunkIndex > 0) {
                    return chunksInfo.customData.deferred
                }
                this._validateDirectoryExists(destinationDirectory);
                var deferred = chunksInfo.customData.deferred = new _deferred.Deferred;
                var reader = this._createFileReader();
                reader.readAsDataURL(fileData);
                reader.onload = function() {
                    var content = reader.result.split(",")[1];
                    var dataObj = _this8._createDataObject(destinationDirectory, fileData.name, false);
                    _this8._sizeSetter(dataObj, fileData.size);
                    _this8._dateModifiedSetter(dataObj, fileData.lastModifiedDate);
                    _this8._contentSetter(dataObj, content);
                    deferred.resolve()
                };
                reader.onerror = function(error) {
                    return deferred.reject(error)
                };
                return deferred
            };
            _proto.downloadItems = function(items) {
                if (1 === items.length) {
                    this._downloadSingleFile(items[0])
                } else {
                    this._downloadMultipleFiles(items)
                }
            };
            _proto._downloadSingleFile = function(file) {
                var content = this._getFileContent(file);
                var byteString = window.atob(content);
                var arrayBuffer = new ArrayBuffer(byteString.length);
                var array = new Uint8Array(arrayBuffer);
                for (var i = 0; i < byteString.length; i++) {
                    array[i] = byteString.charCodeAt(i)
                }
                var blob = new window.Blob([arrayBuffer], {
                    type: "application/octet-stream"
                });
                _file_saver.fileSaver.saveAs(file.name, null, blob)
            };
            _proto._downloadMultipleFiles = function(files) {
                var _this9 = this;
                var jsZip = getJSZip();
                var zip = new jsZip;
                files.forEach(function(file) {
                    return zip.file(file.name, _this9._getFileContent(file), {
                        base64: true
                    })
                });
                var options = {
                    type: "blob",
                    compression: "DEFLATE",
                    mimeType: "application/zip"
                };
                var deferred = new _deferred.Deferred;
                if (zip.generateAsync) {
                    zip.generateAsync(options).then(deferred.resolve)
                } else {
                    deferred.resolve(zip.generate(options))
                }
                deferred.done(function(blob) {
                    return _file_saver.fileSaver.saveAs("files.zip", null, blob)
                })
            };
            _proto._getFileContent = function(file) {
                var dataItem = this._findDataObject(file);
                return this._contentGetter(dataItem) || ""
            };
            _proto._validateDirectoryExists = function(directoryInfo) {
                if (!this._isFileItemExists(directoryInfo) || this._isDirGetter(directoryInfo.fileItem)) {
                    throw {
                        errorId: _errors2.default.DirectoryNotFound,
                        fileItem: directoryInfo
                    }
                }
            };
            _proto._checkAbilityToMoveOrCopyItem = function(item, destinationDir) {
                var _this10 = this;
                var dataItem = this._findDataObject(item);
                var itemKey = this._getKeyFromDataObject(dataItem, item.parentPath);
                var pathInfo = destinationDir.getFullPathInfo();
                var currentPath = "";
                pathInfo.forEach(function(info) {
                    currentPath = (0, _utils.pathCombine)(currentPath, info.name);
                    var pathKey = _this10._getDataObjectKey(info.key, currentPath);
                    if (pathKey === itemKey) {
                        throw {
                            errorId: _errors2.default.Other,
                            fileItem: item
                        }
                    }
                })
            };
            _proto._createDataObject = function(parentDir, name, isDirectory) {
                var dataObj = {};
                this._nameSetter(dataObj, name);
                this._getIsDirSetter(dataObj, isDirectory);
                this._keySetter(dataObj, String(new _guid.default));
                var parentDataItem = this._findDataObject(parentDir);
                var array = this._getDirectoryDataItems(parentDataItem);
                array.push(dataObj);
                return dataObj
            };
            _proto._createCopy = function(dataObj) {
                var _this11 = this;
                var copyObj = {};
                this._nameSetter(copyObj, this._nameGetter(dataObj));
                this._getIsDirSetter(copyObj, this._isDirGetter(dataObj));
                var items = this._subFileItemsGetter(dataObj);
                if (Array.isArray(items)) {
                    var itemsCopy = [];
                    items.forEach(function(childItem) {
                        var childCopy = _this11._createCopy(childItem);
                        itemsCopy.push(childCopy)
                    });
                    this._subFileItemsSetter(copyObj, itemsCopy)
                }
                return copyObj
            };
            _proto._deleteItem = function(fileItem) {
                var dataItem = this._findDataObject(fileItem);
                var parentDirDataObj = this._findFileItemObj(fileItem.pathInfo);
                var array = this._getDirectoryDataItems(parentDirDataObj);
                var index = array.indexOf(dataItem);
                array.splice(index, 1)
            };
            _proto._getDirectoryDataItems = function(directoryDataObj) {
                if (!directoryDataObj) {
                    return this._data
                }
                var dataItems = this._subFileItemsGetter(directoryDataObj);
                if (!Array.isArray(dataItems)) {
                    dataItems = [];
                    this._subFileItemsSetter(directoryDataObj, dataItems)
                }
                return dataItems
            };
            _proto._getItems = function(parentDir) {
                this._validateDirectoryExists(parentDir);
                var pathInfo = parentDir.getFullPathInfo();
                var parentDirKey = pathInfo && pathInfo.length > 0 ? pathInfo[pathInfo.length - 1].key : null;
                var dirFileObjects = this._data;
                if (parentDirKey) {
                    var directoryEntry = this._findFileItemObj(pathInfo);
                    dirFileObjects = directoryEntry && this._subFileItemsGetter(directoryEntry) || []
                }
                this._ensureKeysForDuplicateNameItems(dirFileObjects);
                return this._convertDataObjectsToFileItems(dirFileObjects, pathInfo)
            };
            _proto._ensureKeysForDuplicateNameItems = function(dataObjects) {
                var _this12 = this;
                var names = {};
                dataObjects.forEach(function(obj) {
                    var name = _this12._nameGetter(obj);
                    if (names[name]) {
                        _this12._ensureDataObjectKey(obj)
                    } else {
                        names[name] = true
                    }
                })
            };
            _proto._findDataObject = function(item) {
                if (item.isRoot()) {
                    return null
                }
                var result = this._findFileItemObj(item.getFullPathInfo());
                if (!result) {
                    throw {
                        errorId: item.isDirectory ? _errors2.default.DirectoryNotFound : _errors2.default.FileNotFound,
                        fileItem: item
                    }
                }
                return result
            };
            _proto._findFileItemObj = function(pathInfo) {
                var _this13 = this;
                if (!Array.isArray(pathInfo)) {
                    pathInfo = []
                }
                var currentPath = "";
                var fileItemObj = null;
                var fileItemObjects = this._data;
                var _loop = function(i) {
                    fileItemObj = (0, _array.find)(fileItemObjects, function(item) {
                        var hasCorrectFileItemType = _this13._isDirGetter(item) || i === pathInfo.length - 1;
                        return _this13._getKeyFromDataObject(item, currentPath) === pathInfo[i].key && _this13._nameGetter(item) === pathInfo[i].name && hasCorrectFileItemType
                    });
                    if (fileItemObj) {
                        currentPath = (0, _utils.pathCombine)(currentPath, _this13._nameGetter(fileItemObj));
                        fileItemObjects = _this13._subFileItemsGetter(fileItemObj)
                    }
                };
                for (var i = 0; i < pathInfo.length && (0 === i || fileItemObj); i++) {
                    _loop(i)
                }
                return fileItemObj
            };
            _proto._getKeyFromDataObject = function(dataObj, defaultKeyPrefix) {
                var key = this._keyGetter(dataObj);
                var relativeName = (0, _utils.pathCombine)(defaultKeyPrefix, this._nameGetter(dataObj));
                return this._getDataObjectKey(key, relativeName)
            };
            _proto._getDataObjectKey = function(key, relativeName) {
                return key ? key : relativeName
            };
            _proto._ensureDataObjectKey = function(dataObj) {
                var key = this._keyGetter(dataObj);
                if (!key) {
                    key = String(new _guid.default);
                    this._keySetter(dataObj, key)
                }
                return key
            };
            _proto._hasSubDirs = function(dataObj) {
                var subItems = (0, _common.ensureDefined)(this._subFileItemsGetter(dataObj), []);
                if (!Array.isArray(subItems)) {
                    return true
                }
                for (var i = 0; i < subItems.length; i++) {
                    if (true === this._isDirGetter(subItems[i])) {
                        return true
                    }
                }
                return false
            };
            _proto._getSetter = function(expr) {
                return (0, _type.isFunction)(expr) ? expr : (0, _data.compileSetter)(expr)
            };
            _proto._isFileItemExists = function(fileItem) {
                return fileItem.isDirectory && fileItem.isRoot() || !!this._findFileItemObj(fileItem.getFullPathInfo())
            };
            _proto._createFileReader = function() {
                return new window.FileReader
            };
            return ObjectFileSystemProvider
        }(_provider_base.default);

        function getJSZip() {
            if (!_jszip.default) {
                throw _ui.default.Error("E1041", "JSZip")
            }
            return _jszip.default
        }
        var _default = ObjectFileSystemProvider;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/file_management/remote_provider.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _ajax = _interopRequireDefault(__webpack_require__( /*! ../core/utils/ajax */ 79));
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _guid = _interopRequireDefault(__webpack_require__( /*! ../core/guid */ 36));
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _provider_base = _interopRequireDefault(__webpack_require__( /*! ./provider_base */ 206));
        var _data = __webpack_require__( /*! ../core/utils/data */ 20);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var window = (0, _window.getWindow)();
        var FILE_CHUNK_BLOB_NAME = "chunk";
        var RemoteFileSystemProvider = function(_FileSystemProviderBa) {
            _inheritsLoose(RemoteFileSystemProvider, _FileSystemProviderBa);

            function RemoteFileSystemProvider(options) {
                var _this;
                options = (0, _common.ensureDefined)(options, {});
                _this = _FileSystemProviderBa.call(this, options) || this;
                _this._endpointUrl = options.endpointUrl;
                _this._hasSubDirsGetter = (0, _data.compileGetter)(options.hasSubDirectoriesExpr || "hasSubDirectories");
                return _this
            }
            var _proto = RemoteFileSystemProvider.prototype;
            _proto.getItems = function(parentDir) {
                var _this2 = this;
                var pathInfo = parentDir.getFullPathInfo();
                return this._getEntriesByPath(pathInfo).then(function(result) {
                    return _this2._convertDataObjectsToFileItems(result.result, pathInfo)
                })
            };
            _proto.renameItem = function(item, name) {
                return this._executeRequest("Rename", {
                    pathInfo: item.getFullPathInfo(),
                    isDirectory: item.isDirectory,
                    name: name
                })
            };
            _proto.createDirectory = function(parentDir, name) {
                return this._executeRequest("CreateDir", {
                    pathInfo: parentDir.getFullPathInfo(),
                    name: name
                })
            };
            _proto.deleteItems = function(items) {
                var _this3 = this;
                return items.map(function(item) {
                    return _this3._executeRequest("Remove", {
                        pathInfo: item.getFullPathInfo(),
                        isDirectory: item.isDirectory
                    })
                })
            };
            _proto.moveItems = function(items, destinationDirectory) {
                var _this4 = this;
                return items.map(function(item) {
                    return _this4._executeRequest("Move", {
                        sourcePathInfo: item.getFullPathInfo(),
                        sourceIsDirectory: item.isDirectory,
                        destinationPathInfo: destinationDirectory.getFullPathInfo()
                    })
                })
            };
            _proto.copyItems = function(items, destinationFolder) {
                var _this5 = this;
                return items.map(function(item) {
                    return _this5._executeRequest("Copy", {
                        sourcePathInfo: item.getFullPathInfo(),
                        sourceIsDirectory: item.isDirectory,
                        destinationPathInfo: destinationFolder.getFullPathInfo()
                    })
                })
            };
            _proto.uploadFileChunk = function(fileData, chunksInfo, destinationDirectory) {
                if (0 === chunksInfo.chunkIndex) {
                    chunksInfo.customData.uploadId = new _guid.default
                }
                var args = {
                    destinationPathInfo: destinationDirectory.getFullPathInfo(),
                    chunkMetadata: JSON.stringify({
                        UploadId: chunksInfo.customData.uploadId,
                        FileName: fileData.name,
                        Index: chunksInfo.chunkIndex,
                        TotalCount: chunksInfo.chunkCount,
                        FileSize: fileData.size
                    })
                };
                var formData = new window.FormData;
                formData.append(FILE_CHUNK_BLOB_NAME, chunksInfo.chunkBlob);
                formData.append("arguments", JSON.stringify(args));
                formData.append("command", "UploadChunk");
                var deferred = new _deferred.Deferred;
                _ajax.default.sendRequest({
                    url: this._endpointUrl,
                    method: "POST",
                    dataType: "json",
                    data: formData,
                    upload: {
                        onprogress: _common.noop,
                        onloadstart: _common.noop,
                        onabort: _common.noop
                    },
                    cache: false
                }).done(function(result) {
                    !result.success && deferred.reject(result) || deferred.resolve()
                }).fail(deferred.reject);
                return deferred.promise()
            };
            _proto.abortFileUpload = function(fileData, chunksInfo, destinationDirectory) {
                return this._executeRequest("AbortUpload", {
                    uploadId: chunksInfo.customData.uploadId
                })
            };
            _proto.downloadItems = function(items) {
                var args = this._getDownloadArgs(items);
                var $form = (0, _renderer.default)("<form>").css({
                    display: "none"
                }).attr({
                    method: "post",
                    action: args.url
                });
                ["command", "arguments"].forEach(function(name) {
                    (0, _renderer.default)("<input>").attr({
                        type: "hidden",
                        name: name,
                        value: args[name]
                    }).appendTo($form)
                });
                $form.appendTo("body");
                _events_engine.default.trigger($form, "submit");
                setTimeout(function() {
                    return $form.remove()
                })
            };
            _proto.getItemsContent = function(items) {
                var args = this._getDownloadArgs(items);
                var formData = new window.FormData;
                formData.append("command", args.command);
                formData.append("arguments", args.arguments);
                return _ajax.default.sendRequest({
                    url: args.url,
                    method: "POST",
                    responseType: "arraybuffer",
                    data: formData,
                    upload: {
                        onprogress: _common.noop,
                        onloadstart: _common.noop,
                        onabort: _common.noop
                    },
                    cache: false
                })
            };
            _proto._getDownloadArgs = function(items) {
                var pathInfoList = items.map(function(item) {
                    return item.getFullPathInfo()
                });
                var args = {
                    pathInfoList: pathInfoList
                };
                var argsStr = JSON.stringify(args);
                return {
                    url: this._endpointUrl,
                    arguments: argsStr,
                    command: "Download"
                }
            };
            _proto._getItemsIds = function(items) {
                return items.map(function(it) {
                    return it.relativeName
                })
            };
            _proto._getEntriesByPath = function(pathInfo) {
                return this._executeRequest("GetDirContents", {
                    pathInfo: pathInfo
                })
            };
            _proto._executeRequest = function(command, args) {
                var method = "GetDirContents" === command ? "GET" : "POST";
                var deferred = new _deferred.Deferred;
                _ajax.default.sendRequest({
                    url: this._getEndpointUrl(command, args),
                    method: method,
                    dataType: "json",
                    cache: false
                }).then(function(result) {
                    !result.success && deferred.reject(result) || deferred.resolve(result)
                }, function(e) {
                    return deferred.reject(e)
                });
                return deferred.promise()
            };
            _proto._getEndpointUrl = function(command, args) {
                var queryString = this._getQueryString({
                    command: command,
                    arguments: JSON.stringify(args)
                });
                var separator = this._endpointUrl && this._endpointUrl.indexOf("?") > 0 ? "&" : "?";
                return this._endpointUrl + separator + queryString
            };
            _proto._getQueryString = function(params) {
                var pairs = [];
                var keys = Object.keys(params);
                for (var i = 0; i < keys.length; i++) {
                    var key = keys[i];
                    var value = params[key];
                    if (void 0 === value) {
                        continue
                    }
                    if (null === value) {
                        value = ""
                    }
                    if (Array.isArray(value)) {
                        this._processQueryStringArrayParam(key, value, pairs)
                    } else {
                        var pair = this._getQueryStringPair(key, value);
                        pairs.push(pair)
                    }
                }
                return pairs.join("&")
            };
            _proto._processQueryStringArrayParam = function(key, array, pairs) {
                var _this6 = this;
                (0, _iterator.each)(array, function(_, item) {
                    var pair = _this6._getQueryStringPair(key, item);
                    pairs.push(pair)
                })
            };
            _proto._getQueryStringPair = function(key, value) {
                return encodeURIComponent(key) + "=" + encodeURIComponent(value)
            };
            _proto._hasSubDirs = function(dataObj) {
                var hasSubDirs = this._hasSubDirsGetter(dataObj);
                return "boolean" === typeof hasSubDirs ? hasSubDirs : true
            };
            _proto._getKeyExpr = function(options) {
                return options.keyExpr || "key"
            };
            return RemoteFileSystemProvider
        }(_provider_base.default);
        var _default = RemoteFileSystemProvider;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/file_management/custom_provider.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _data = __webpack_require__( /*! ../core/utils/data */ 20);
        var _provider_base = _interopRequireDefault(__webpack_require__( /*! ./provider_base */ 206));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var CustomFileSystemProvider = function(_FileSystemProviderBa) {
            _inheritsLoose(CustomFileSystemProvider, _FileSystemProviderBa);

            function CustomFileSystemProvider(options) {
                var _this;
                options = (0, _common.ensureDefined)(options, {});
                _this = _FileSystemProviderBa.call(this, options) || this;
                _this._hasSubDirsGetter = (0, _data.compileGetter)(options.hasSubDirectoriesExpr || "hasSubDirectories");
                _this._getItemsFunction = _this._ensureFunction(options.getItems, function() {
                    return []
                });
                _this._renameItemFunction = _this._ensureFunction(options.renameItem);
                _this._createDirectoryFunction = _this._ensureFunction(options.createDirectory);
                _this._deleteItemFunction = _this._ensureFunction(options.deleteItem);
                _this._moveItemFunction = _this._ensureFunction(options.moveItem);
                _this._copyItemFunction = _this._ensureFunction(options.copyItem);
                _this._uploadFileChunkFunction = _this._ensureFunction(options.uploadFileChunk);
                _this._abortFileUploadFunction = _this._ensureFunction(options.abortFileUpload);
                _this._downloadItemsFunction = _this._ensureFunction(options.downloadItems);
                _this._getItemsContentFunction = _this._ensureFunction(options.getItemsContent);
                return _this
            }
            var _proto = CustomFileSystemProvider.prototype;
            _proto.getItems = function(parentDir) {
                var _this2 = this;
                var pathInfo = parentDir.getFullPathInfo();
                return this._executeActionAsDeferred(function() {
                    return _this2._getItemsFunction(parentDir)
                }, true).then(function(dataItems) {
                    return _this2._convertDataObjectsToFileItems(dataItems, pathInfo)
                })
            };
            _proto.renameItem = function(item, name) {
                var _this3 = this;
                return this._executeActionAsDeferred(function() {
                    return _this3._renameItemFunction(item, name)
                })
            };
            _proto.createDirectory = function(parentDir, name) {
                var _this4 = this;
                return this._executeActionAsDeferred(function() {
                    return _this4._createDirectoryFunction(parentDir, name)
                })
            };
            _proto.deleteItems = function(items) {
                var _this5 = this;
                return items.map(function(item) {
                    return _this5._executeActionAsDeferred(function() {
                        return _this5._deleteItemFunction(item)
                    })
                })
            };
            _proto.moveItems = function(items, destinationDirectory) {
                var _this6 = this;
                return items.map(function(item) {
                    return _this6._executeActionAsDeferred(function() {
                        return _this6._moveItemFunction(item, destinationDirectory)
                    })
                })
            };
            _proto.copyItems = function(items, destinationFolder) {
                var _this7 = this;
                return items.map(function(item) {
                    return _this7._executeActionAsDeferred(function() {
                        return _this7._copyItemFunction(item, destinationFolder)
                    })
                })
            };
            _proto.uploadFileChunk = function(fileData, chunksInfo, destinationDirectory) {
                var _this8 = this;
                return this._executeActionAsDeferred(function() {
                    return _this8._uploadFileChunkFunction(fileData, chunksInfo, destinationDirectory)
                })
            };
            _proto.abortFileUpload = function(fileData, chunksInfo, destinationDirectory) {
                var _this9 = this;
                return this._executeActionAsDeferred(function() {
                    return _this9._abortFileUploadFunction(fileData, chunksInfo, destinationDirectory)
                })
            };
            _proto.downloadItems = function(items) {
                return this._downloadItemsFunction(items)
            };
            _proto.getItemsContent = function(items) {
                var _this10 = this;
                return this._executeActionAsDeferred(function() {
                    return _this10._getItemsContentFunction(items)
                })
            };
            _proto._hasSubDirs = function(dataObj) {
                var hasSubDirs = this._hasSubDirsGetter(dataObj);
                return "boolean" === typeof hasSubDirs ? hasSubDirs : true
            };
            _proto._getKeyExpr = function(options) {
                return options.keyExpr || "key"
            };
            _proto._ensureFunction = function(functionObject, defaultFunction) {
                defaultFunction = defaultFunction || _common.noop;
                return (0, _type.isFunction)(functionObject) ? functionObject : defaultFunction
            };
            return CustomFileSystemProvider
        }(_provider_base.default);
        var _default = CustomFileSystemProvider;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************!*\
      !*** ./artifacts/transpiled-npm/viz/utils.js ***!
      \***********************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        Object.defineProperty(exports, "refreshPaths", {
            enumerable: true,
            get: function() {
                return _renderer.refreshPaths
            }
        });
        exports.prepareSegmentRectPoints = void 0;
        var _renderer = __webpack_require__( /*! ./core/renderers/renderer */ 177);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var prepareSegmentRectPoints = function(left, top, width, height, borderOptions) {
            var maxSW = ~~((width < height ? width : height) / 2);
            var sw = borderOptions.width || 0;
            var newSW = sw < maxSW ? sw : maxSW;
            left += newSW / 2;
            top += newSW / 2;
            width -= newSW;
            height -= newSW;
            var right = left + width;
            var bottom = top + height;
            var points = [];
            var segments = [];
            var segmentSequence;
            var visiblyOpt = 0;
            var prevSegmentVisibility = 0;
            var allSegment = {
                top: [
                    [left, top],
                    [right, top]
                ],
                right: [
                    [right, top],
                    [right, bottom]
                ],
                bottom: [
                    [right, bottom],
                    [left, bottom]
                ],
                left: [
                    [left, bottom],
                    [left, top]
                ]
            };
            (0, _iterator.each)(allSegment, function(seg) {
                var visibility = !!borderOptions[seg];
                visiblyOpt = 2 * visiblyOpt + ~~visibility
            });
            switch (visiblyOpt) {
                case 13:
                case 9:
                    segmentSequence = ["left", "top", "right", "bottom"];
                    break;
                case 11:
                    segmentSequence = ["bottom", "left", "top", "right"];
                    break;
                default:
                    segmentSequence = ["top", "right", "bottom", "left"]
            }(0, _iterator.each)(segmentSequence, function(_, seg) {
                var segmentVisibility = !!borderOptions[seg];
                if (!prevSegmentVisibility && segments.length) {
                    points.push(segments);
                    segments = []
                }
                if (segmentVisibility) {
                    (0, _iterator.each)(allSegment[seg].slice(prevSegmentVisibility), function(_, segment) {
                        segments = segments.concat(segment)
                    })
                }
                prevSegmentVisibility = ~~segmentVisibility
            });
            segments.length && points.push(segments);
            1 === points.length && (points = points[0]);
            return {
                points: points,
                pathType: 15 === visiblyOpt ? "area" : "line"
            }
        };
        exports.prepareSegmentRectPoints = prepareSegmentRectPoints
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/bundles/modules/ui.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        __webpack_require__( /*! ./core */ 154);
        module.exports = DevExpress.ui = {}
    },
    /*!******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/collection/ui.collection_widget.async.js ***!
      \******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiCollection_widget = _interopRequireDefault(__webpack_require__( /*! ./ui.collection_widget.edit */ 54));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var AsyncCollectionWidget = _uiCollection_widget.default.inherit({
            _initMarkup: function() {
                this._deferredItems = [];
                this.callBase()
            },
            _renderItemContent: function(args) {
                var renderContentDeferred = new _deferred.Deferred;
                var itemDeferred = new _deferred.Deferred;
                var that = this;
                this._deferredItems[args.index] = itemDeferred;
                var $itemContent = this.callBase.call(that, args);
                itemDeferred.done(function() {
                    renderContentDeferred.resolve($itemContent)
                });
                return renderContentDeferred.promise()
            },
            _createItemByTemplate: function(itemTemplate, renderArgs) {
                var _this = this;
                return itemTemplate.render({
                    model: renderArgs.itemData,
                    container: renderArgs.container,
                    index: renderArgs.index,
                    onRendered: function() {
                        _this._deferredItems[renderArgs.index].resolve()
                    }
                })
            },
            _postProcessRenderItems: _common.noop,
            _renderItemsAsync: function() {
                var _this2 = this;
                var d = new _deferred.Deferred;
                _deferred.when.apply(this, this._deferredItems).done(function() {
                    _this2._postProcessRenderItems();
                    d.resolve()
                });
                return d.promise()
            },
            _clean: function() {
                this.callBase();
                this._deferredItems = []
            }
        });
        var _default = AsyncCollectionWidget;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/speed_dial_action/repaint_floating_action_button.js ***!
      \*****************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _speed_dial_main_item = __webpack_require__( /*! ./speed_dial_main_item */ 341);
        var _default = _speed_dial_main_item.repaint;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/speed_dial_action/speed_dial_item.js ***!
      \**************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _click = __webpack_require__( /*! ../../events/click */ 21);
        var _icon = __webpack_require__( /*! ../../core/utils/icon */ 56);
        var _overlay = _interopRequireDefault(__webpack_require__( /*! ../overlay */ 64));
        var _utils = __webpack_require__( /*! ../widget/utils.ink_ripple */ 82);
        var _themes = __webpack_require__( /*! ../themes */ 34);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var FAB_CLASS = "dx-fa-button";
        var FAB_ICON_CLASS = "dx-fa-button-icon";
        var FAB_LABEL_CLASS = "dx-fa-button-label";
        var FAB_LABEL_WRAPPER_CLASS = "dx-fa-button-label-wrapper";
        var FAB_CONTENT_REVERSE_CLASS = "dx-fa-button-content-reverse";
        var OVERLAY_CONTENT_SELECTOR = ".dx-overlay-content";
        var SpeedDialItem = function(_Overlay) {
            _inheritsLoose(SpeedDialItem, _Overlay);

            function SpeedDialItem() {
                return _Overlay.apply(this, arguments) || this
            }
            var _proto = SpeedDialItem.prototype;
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_Overlay.prototype._getDefaultOptions.call(this), {
                    shading: false,
                    useInkRipple: false,
                    callOverlayRenderShading: false,
                    width: "auto",
                    zIndex: 1500
                })
            };
            _proto._defaultOptionsRules = function() {
                return _Overlay.prototype._defaultOptionsRules.call(this).concat([{
                    device: function() {
                        return (0, _themes.isMaterial)()
                    },
                    options: {
                        useInkRipple: true
                    }
                }])
            };
            _proto._render = function() {
                this.$element().addClass(FAB_CLASS);
                this._renderIcon();
                this._renderLabel();
                _Overlay.prototype._render.call(this);
                this.option("useInkRipple") && this._renderInkRipple();
                this._renderClick()
            };
            _proto._renderLabel = function() {
                !!this._$label && this._$label.remove();
                var labelText = this.option("label");
                if (!labelText) {
                    this._$label = null;
                    return
                }
                var $element = (0, _renderer.default)("<div>").addClass(FAB_LABEL_CLASS);
                var $wrapper = (0, _renderer.default)("<div>").addClass(FAB_LABEL_WRAPPER_CLASS);
                this._$label = $wrapper.prependTo(this.$content()).append($element.text(labelText));
                this.$content().toggleClass(FAB_CONTENT_REVERSE_CLASS, this._isPositionLeft(this.option("parentPosition")))
            };
            _proto._isPositionLeft = function(position) {
                var currentLocation = position ? position.at ? position.at.x ? position.at.x : position.at : "string" === typeof position ? position : "" : "";
                return "left" === currentLocation.split(" ")[0]
            };
            _proto._renderButtonIcon = function($element, icon, iconClass) {
                !!$element && $element.remove();
                $element = (0, _renderer.default)("<div>").addClass(iconClass);
                var $iconElement = (0, _icon.getImageContainer)(icon);
                $element.append($iconElement).appendTo(this.$content());
                return $element
            };
            _proto._renderIcon = function() {
                this._$icon = this._renderButtonIcon(this._$icon, this._options.silent("icon"), FAB_ICON_CLASS)
            };
            _proto._renderWrapper = function() {
                if (this._options.silent("callOverlayRenderShading")) {
                    _Overlay.prototype._renderWrapper.call(this)
                }
            };
            _proto._getVisibleActions = function(actions) {
                var currentActions = actions || this.option("actions") || [];
                return currentActions.filter(function(action) {
                    return action.option("visible")
                })
            };
            _proto._getActionComponent = function() {
                if (1 === this._getVisibleActions().length) {
                    return this._getVisibleActions()[0]
                } else {
                    return this.option("actionComponent") || this.option("actions")[0]
                }
            };
            _proto._initContentReadyAction = function() {
                this._contentReadyAction = this._getActionComponent()._createActionByOption("onContentReady", {
                    excludeValidators: ["disabled", "readOnly"]
                }, true)
            };
            _proto._fireContentReadyAction = function() {
                this._contentReadyAction({
                    actionElement: this.$element()
                })
            };
            _proto._updateZIndexStackPosition = function() {
                var zIndex = this.option("zIndex");
                this._$wrapper.css("zIndex", zIndex);
                this._$content.css("zIndex", zIndex)
            };
            _proto._fixWrapperPosition = function() {
                var $wrapper = this._$wrapper;
                var $container = this._getContainer();
                $wrapper.css("position", this._isWindow($container) ? "fixed" : "absolute")
            };
            _proto._setClickAction = function() {
                var _this = this;
                var eventName = (0, _index.addNamespace)(_click.name, this.NAME);
                var overlayContent = this.$element().find(OVERLAY_CONTENT_SELECTOR);
                _events_engine.default.off(overlayContent, eventName);
                _events_engine.default.on(overlayContent, eventName, function(e) {
                    var clickActionArgs = {
                        event: e,
                        actionElement: _this.element(),
                        element: _this._getActionComponent().$element()
                    };
                    _this._clickAction(clickActionArgs)
                })
            };
            _proto._defaultActionArgs = function() {
                return {
                    component: this._getActionComponent()
                }
            };
            _proto._renderClick = function() {
                this._clickAction = this._getActionComponent()._createActionByOption("onClick");
                this._setClickAction()
            };
            _proto._renderInkRipple = function() {
                this._inkRipple = (0, _utils.render)()
            };
            _proto._getInkRippleContainer = function() {
                return this._$icon
            };
            _proto._toggleActiveState = function($element, value, e) {
                _Overlay.prototype._toggleActiveState.apply(this, arguments);
                if (!this._inkRipple) {
                    return
                }
                var config = {
                    element: this._getInkRippleContainer(),
                    event: e
                };
                if (value) {
                    this._inkRipple.showWave(config)
                } else {
                    this._inkRipple.hideWave(config)
                }
            };
            _proto._optionChanged = function(args) {
                switch (args.name) {
                    case "icon":
                        this._renderIcon();
                        break;
                    case "onClick":
                        this._renderClick();
                        break;
                    case "label":
                        this._renderLabel();
                        break;
                    case "visible":
                        this._currentVisible = args.previousValue;
                        args.value ? this._show() : this._hide();
                        break;
                    case "useInkRipple":
                        this._render();
                        break;
                    default:
                        _Overlay.prototype._optionChanged.call(this, args)
                }
            };
            return SpeedDialItem
        }(_overlay.default);
        var _default = SpeedDialItem;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/autocomplete.js ***!
      \*****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./drop_down_editor/ui.drop_down_list */ 269));
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);
        var _index = __webpack_require__( /*! ../events/utils/index */ 8);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var AUTOCOMPLETE_CLASS = "dx-autocomplete";
        var AUTOCOMPLETE_POPUP_WRAPPER_CLASS = "dx-autocomplete-popup-wrapper";
        var Autocomplete = _ui.default.inherit({
            _supportedKeys: function() {
                var item = this._list ? this._list.option("focusedElement") : null;
                var parent = this.callBase();
                item = item && (0, _renderer.default)(item);
                return (0, _extend.extend)({}, parent, {
                    upArrow: function(e) {
                        if (!(0, _index.isCommandKeyPressed)(e)) {
                            e.preventDefault();
                            e.stopPropagation();
                            if (item && !this._calcNextItem(-1)) {
                                this._clearFocusedItem();
                                return false
                            }
                        }
                        return true
                    },
                    downArrow: function(e) {
                        if (!(0, _index.isCommandKeyPressed)(e)) {
                            e.preventDefault();
                            e.stopPropagation();
                            if (item && !this._calcNextItem(1)) {
                                this._clearFocusedItem();
                                return false
                            }
                        }
                        return true
                    },
                    enter: function(e) {
                        if (!item) {
                            this.close()
                        }
                        var opened = this.option("opened");
                        if (opened) {
                            e.preventDefault()
                        }
                        return opened
                    }
                })
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    minSearchLength: 1,
                    maxItemCount: 10,
                    noDataText: "",
                    showDropDownButton: false,
                    searchEnabled: true
                })
            },
            _initMarkup: function() {
                this.callBase();
                this.$element().addClass(AUTOCOMPLETE_CLASS);
                this.setAria("autocomplete", "inline")
            },
            _displayGetterExpr: function() {
                return this.option("valueExpr")
            },
            _closeOutsideDropDownHandler: function(_ref) {
                var target = _ref.target;
                return !(0, _renderer.default)(target).closest(this.$element()).length
            },
            _renderDimensions: function() {
                this.callBase();
                this._dimensionChanged()
            },
            _popupWrapperClass: function() {
                return this.callBase() + " " + AUTOCOMPLETE_POPUP_WRAPPER_CLASS
            },
            _listConfig: function() {
                return (0, _extend.extend)(this.callBase(), {
                    pageLoadMode: "none"
                })
            },
            _listItemClickHandler: function(e) {
                this._saveValueChangeEvent(e.event);
                var value = this._displayGetter(e.itemData);
                this.option("value", value);
                this.close()
            },
            _setListDataSource: function() {
                if (!this._list) {
                    return
                }
                this._list.option("selectedItems", []);
                this.callBase()
            },
            _refreshSelected: _common.noop,
            _searchCanceled: function() {
                this.callBase();
                this.close()
            },
            _loadItem: function(value, cache) {
                var selectedItem = this._getItemFromPlain(value, cache);
                return (new _deferred.Deferred).resolve(selectedItem).promise()
            },
            _dataSourceOptions: function() {
                return {
                    paginate: true,
                    pageSize: this.option("maxItemCount")
                }
            },
            _searchDataSource: function() {
                this._dataSource.pageSize(this.option("maxItemCount"));
                this.callBase();
                this._clearFocusedItem()
            },
            _clearFocusedItem: function() {
                if (this._list) {
                    this._list.option("focusedElement", null);
                    this._list.option("selectedIndex", -1)
                }
            },
            _renderValueEventName: function() {
                return "input keyup"
            },
            _valueChangeEventHandler: function(e) {
                var value = this._input().val() || null;
                return this.callBase(e, value)
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "maxItemCount":
                        this._searchDataSource();
                        break;
                    case "valueExpr":
                        this._compileDisplayGetter();
                        this._setListOption("displayExpr", this._displayGetterExpr());
                        this.callBase(args);
                        break;
                    default:
                        this.callBase(args)
                }
            },
            reset: function() {
                this.callBase();
                this.close()
            }
        });
        (0, _component_registrator.default)("dxAutocomplete", Autocomplete);
        var _default = Autocomplete;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/drop_down_editor/ui.drop_down_button.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _button = _interopRequireDefault(__webpack_require__( /*! ../text_box/texteditor_button_collection/button */ 207));
        var _button2 = _interopRequireDefault(__webpack_require__( /*! ../button */ 37));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var DROP_DOWN_EDITOR_BUTTON_CLASS = "dx-dropdowneditor-button";
        var DROP_DOWN_EDITOR_BUTTON_VISIBLE = "dx-dropdowneditor-button-visible";
        var BUTTON_MESSAGE = "dxDropDownEditor-selectLabel";
        var DropDownButton = function(_TextEditorButton) {
            _inheritsLoose(DropDownButton, _TextEditorButton);

            function DropDownButton(name, editor, options) {
                var _this;
                _this = _TextEditorButton.call(this, name, editor, options) || this;
                _this.currentTemplate = null;
                return _this
            }
            var _proto = DropDownButton.prototype;
            _proto._attachEvents = function(instance) {
                var editor = this.editor;
                instance.option("onClick", function(e) {
                    !editor.option("openOnFieldClick") && editor._openHandler(e)
                });
                _events_engine.default.on(instance.$element(), "mousedown", function(e) {
                    if (editor.$element().is(".dx-state-focused")) {
                        e.preventDefault()
                    }
                })
            };
            _proto._create = function() {
                var editor = this.editor;
                var $element = (0, _renderer.default)("<div>");
                var options = this._getOptions();
                this._addToContainer($element);
                var instance = editor._createComponent($element, _button2.default, (0, _extend.extend)({}, options, {
                    elementAttr: {
                        "aria-label": _message.default.format(BUTTON_MESSAGE)
                    }
                }));
                this._legacyRender(editor.$element(), $element, options.visible);
                return {
                    $element: $element,
                    instance: instance
                }
            };
            _proto._getOptions = function() {
                var editor = this.editor;
                var visible = this._isVisible();
                var isReadOnly = editor.option("readOnly");
                var options = {
                    focusStateEnabled: false,
                    hoverStateEnabled: false,
                    activeStateEnabled: false,
                    useInkRipple: false,
                    disabled: isReadOnly,
                    visible: visible
                };
                this._addTemplate(options);
                return options
            };
            _proto._isVisible = function() {
                var editor = this.editor;
                return _TextEditorButton.prototype._isVisible.call(this) && editor.option("showDropDownButton")
            };
            _proto._legacyRender = function($editor, $element, isVisible) {
                $editor.toggleClass(DROP_DOWN_EDITOR_BUTTON_VISIBLE, isVisible);
                if ($element) {
                    $element.removeClass("dx-button").addClass(DROP_DOWN_EDITOR_BUTTON_CLASS)
                }
            };
            _proto._isSameTemplate = function() {
                return this.editor.option("dropDownButtonTemplate") === this.currentTemplate
            };
            _proto._addTemplate = function(options) {
                if (!this._isSameTemplate()) {
                    options.template = this.editor._getTemplateByOption("dropDownButtonTemplate");
                    this.currentTemplate = this.editor.option("dropDownButtonTemplate")
                }
            };
            _proto.update = function() {
                var shouldUpdate = _TextEditorButton.prototype.update.call(this);
                if (shouldUpdate) {
                    var editor = this.editor,
                        instance = this.instance;
                    var $editor = editor.$element();
                    var options = this._getOptions();
                    null === instance || void 0 === instance ? void 0 : instance.option(options);
                    this._legacyRender($editor, null === instance || void 0 === instance ? void 0 : instance.$element(), options.visible)
                }
            };
            return DropDownButton
        }(_button.default);
        exports.default = DropDownButton;
        module.exports = exports.default
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/text_box/text_box.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./ui.text_editor */ 342));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var navigator = (0, _window.getNavigator)();
        var ua = navigator.userAgent;
        var ignoreKeys = ["backspace", "tab", "enter", "pageUp", "pageDown", "end", "home", "leftArrow", "rightArrow", "downArrow", "upArrow", "del"];
        var TEXTBOX_CLASS = "dx-textbox";
        var SEARCHBOX_CLASS = "dx-searchbox";
        var ICON_CLASS = "dx-icon";
        var SEARCH_ICON_CLASS = "dx-icon-search";
        var TextBox = _ui.default.inherit({
            ctor: function(element, options) {
                if (options) {
                    this._showClearButton = options.showClearButton
                }
                this.callBase.apply(this, arguments)
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    value: "",
                    mode: "text",
                    maxLength: null
                })
            },
            _initMarkup: function() {
                this.$element().addClass(TEXTBOX_CLASS);
                this.callBase();
                this.setAria("role", "textbox")
            },
            _renderContentImpl: function() {
                this._renderMaxLengthHandlers();
                this.callBase()
            },
            _renderInputType: function() {
                this.callBase();
                this._renderSearchMode()
            },
            _renderMaxLengthHandlers: function() {
                if (this._isAndroidOrIE()) {
                    _events_engine.default.on(this._input(), (0, _index.addNamespace)("keydown", this.NAME), this._onKeyDownCutOffHandler.bind(this));
                    _events_engine.default.on(this._input(), (0, _index.addNamespace)("change", this.NAME), this._onChangeCutOffHandler.bind(this))
                }
            },
            _useTemplates: function() {
                return false
            },
            _renderProps: function() {
                this.callBase();
                this._toggleMaxLengthProp()
            },
            _toggleMaxLengthProp: function() {
                var maxLength = this._getMaxLength();
                if (maxLength && maxLength > 0) {
                    this._input().attr("maxLength", maxLength)
                } else {
                    this._input().removeAttr("maxLength")
                }
            },
            _renderSearchMode: function() {
                var $element = this._$element;
                if ("search" === this.option("mode")) {
                    $element.addClass(SEARCHBOX_CLASS);
                    this._renderSearchIcon();
                    if (void 0 === this._showClearButton) {
                        this._showClearButton = this.option("showClearButton");
                        this.option("showClearButton", true)
                    }
                } else {
                    $element.removeClass(SEARCHBOX_CLASS);
                    this._$searchIcon && this._$searchIcon.remove();
                    this.option("showClearButton", void 0 === this._showClearButton ? this.option("showClearButton") : this._showClearButton);
                    delete this._showClearButton
                }
            },
            _renderSearchIcon: function() {
                var $searchIcon = (0, _renderer.default)("<div>").addClass(ICON_CLASS).addClass(SEARCH_ICON_CLASS);
                $searchIcon.prependTo(this._input().parent());
                this._$searchIcon = $searchIcon
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "maxLength":
                        this._toggleMaxLengthProp();
                        this._renderMaxLengthHandlers();
                        break;
                    case "mask":
                        this.callBase(args);
                        this._toggleMaxLengthProp();
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _onKeyDownCutOffHandler: function(e) {
                var actualMaxLength = this._getMaxLength();
                if (actualMaxLength && !e.ctrlKey && !this._hasSelection()) {
                    var $input = (0, _renderer.default)(e.target);
                    var key = (0, _index.normalizeKeyName)(e);
                    this._cutOffExtraChar($input);
                    return $input.val().length < actualMaxLength || (0, _array.inArray)(key, ignoreKeys) !== -1 || "" !== window.getSelection().toString()
                } else {
                    return true
                }
            },
            _onChangeCutOffHandler: function(e) {
                var $input = (0, _renderer.default)(e.target);
                if (this.option("maxLength")) {
                    this._cutOffExtraChar($input)
                }
            },
            _cutOffExtraChar: function($input) {
                var actualMaxLength = this._getMaxLength();
                var textInput = $input.val();
                if (actualMaxLength && textInput.length > actualMaxLength) {
                    $input.val(textInput.substr(0, actualMaxLength))
                }
            },
            _getMaxLength: function() {
                var isMaskSpecified = !!this.option("mask");
                return isMaskSpecified ? null : this.option("maxLength")
            },
            _isAndroidOrIE: function() {
                var realDevice = _devices.default.real();
                var version = realDevice.version.join(".");
                return _browser.default.msie || "android" === realDevice.platform && version && /^(2\.|4\.1)/.test(version) && !/chrome/i.test(ua)
            }
        });
        (0, _component_registrator.default)("dxTextBox", TextBox);
        var _default = TextBox;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/text_box/ui.text_editor.mask.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _utils = _interopRequireDefault(__webpack_require__( /*! ./utils.caret */ 343));
        var _utils2 = __webpack_require__( /*! ./utils.support */ 585);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _selectors = __webpack_require__( /*! ../widget/selectors */ 70);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _string = __webpack_require__( /*! ../../core/utils/string */ 43);
        var _wheel = __webpack_require__( /*! ../../events/core/wheel */ 148);
        var _uiText_editorMask = __webpack_require__( /*! ./ui.text_editor.mask.rule */ 586);
        var _uiText_editor = _interopRequireDefault(__webpack_require__( /*! ./ui.text_editor.base */ 587));
        var _uiText_editorMaskStrategy = _interopRequireDefault(__webpack_require__( /*! ./ui.text_editor.mask.strategy.default */ 591));
        var _uiText_editorMaskStrategy2 = _interopRequireDefault(__webpack_require__( /*! ./ui.text_editor.mask.strategy.input_events */ 592));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var stubCaret = function() {
            return {}
        };
        var caret = _utils.default;
        var EMPTY_CHAR = " ";
        var ESCAPED_CHAR = "\\";
        var TEXTEDITOR_MASKED_CLASS = "dx-texteditor-masked";
        var FORWARD_DIRECTION = "forward";
        var BACKWARD_DIRECTION = "backward";
        var buildInMaskRules = {
            0: /[0-9]/,
            9: /[0-9\s]/,
            "#": /[-+0-9\s]/,
            L: function(char) {
                return isLiteralChar(char)
            },
            l: function(char) {
                return isLiteralChar(char) || isSpaceChar(char)
            },
            C: /\S/,
            c: /./,
            A: function(char) {
                return isLiteralChar(char) || isNumericChar(char)
            },
            a: function(char) {
                return isLiteralChar(char) || isNumericChar(char) || isSpaceChar(char)
            }
        };

        function isNumericChar(char) {
            return /[0-9]/.test(char)
        }

        function isLiteralChar(char) {
            var code = char.charCodeAt();
            return 64 < code && code < 91 || 96 < code && code < 123 || code > 127
        }

        function isSpaceChar(char) {
            return " " === char
        }
        var TextEditorMask = _uiText_editor.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    mask: "",
                    maskChar: "_",
                    maskRules: {},
                    maskInvalidMessage: _message.default.format("validation-mask"),
                    useMaskedValue: false,
                    showMaskMode: "always"
                })
            },
            _supportedKeys: function() {
                var that = this;
                var keyHandlerMap = {
                    backspace: that._maskStrategy.getHandler("backspace"),
                    del: that._maskStrategy.getHandler("del"),
                    enter: that._changeHandler
                };
                var result = that.callBase();
                (0, _iterator.each)(keyHandlerMap, function(key, callback) {
                    var parentHandler = result[key];
                    result[key] = function(e) {
                        that.option("mask") && callback.call(that, e);
                        parentHandler && parentHandler(e)
                    }
                });
                return result
            },
            _getSubmitElement: function() {
                return !this.option("mask") ? this.callBase() : this._$hiddenElement
            },
            _init: function() {
                this.callBase();
                this._initMaskStrategy()
            },
            _initMaskStrategy: function() {
                this._maskStrategy = (0, _utils2.isInputEventsL2Supported)() ? new _uiText_editorMaskStrategy2.default(this) : new _uiText_editorMaskStrategy.default(this)
            },
            _initMarkup: function() {
                this._renderHiddenElement();
                this.callBase()
            },
            _attachMouseWheelEventHandlers: function() {
                var hasMouseWheelHandler = this._onMouseWheel !== _common.noop;
                if (!hasMouseWheelHandler) {
                    return
                }
                var input = this._input();
                var eventName = (0, _index.addNamespace)(_wheel.name, this.NAME);
                var mouseWheelAction = this._createAction(function(e) {
                    var event = e.event;
                    if ((0, _selectors.focused)(input) && !(0, _index.isCommandKeyPressed)(event)) {
                        this._onMouseWheel(event);
                        event.preventDefault();
                        event.stopPropagation()
                    }
                }.bind(this));
                _events_engine.default.off(input, eventName);
                _events_engine.default.on(input, eventName, function(e) {
                    mouseWheelAction({
                        event: e
                    })
                })
            },
            _onMouseWheel: _common.noop,
            _render: function() {
                this._renderMask();
                this.callBase();
                this._attachMouseWheelEventHandlers()
            },
            _renderHiddenElement: function() {
                if (this.option("mask")) {
                    this._$hiddenElement = (0, _renderer.default)("<input>").attr("type", "hidden").appendTo(this._inputWrapper())
                }
            },
            _removeHiddenElement: function() {
                this._$hiddenElement && this._$hiddenElement.remove()
            },
            _renderMask: function() {
                this.$element().removeClass(TEXTEDITOR_MASKED_CLASS);
                this._maskRulesChain = null;
                this._maskStrategy.detachEvents();
                if (!this.option("mask")) {
                    return
                }
                this.$element().addClass(TEXTEDITOR_MASKED_CLASS);
                this._maskStrategy.attachEvents();
                this._parseMask();
                this._renderMaskedValue()
            },
            _suppressCaretChanging: function(callback, args) {
                caret = stubCaret;
                try {
                    callback.apply(this, args)
                } finally {
                    caret = _utils.default
                }
            },
            _changeHandler: function(e) {
                var $input = this._input();
                var inputValue = $input.val();
                if (inputValue === this._changedValue) {
                    return
                }
                this._changedValue = inputValue;
                var changeEvent = (0, _index.createEvent)(e, {
                    type: "change"
                });
                _events_engine.default.trigger($input, changeEvent)
            },
            _parseMask: function() {
                this._maskRules = (0, _extend.extend)({}, buildInMaskRules, this.option("maskRules"));
                this._maskRulesChain = this._parseMaskRule(0)
            },
            _parseMaskRule: function(index) {
                var mask = this.option("mask");
                if (index >= mask.length) {
                    return new _uiText_editorMask.EmptyMaskRule
                }
                var currentMaskChar = mask[index];
                var isEscapedChar = currentMaskChar === ESCAPED_CHAR;
                var result = isEscapedChar ? new _uiText_editorMask.StubMaskRule({
                    maskChar: mask[index + 1]
                }) : this._getMaskRule(currentMaskChar);
                result.next(this._parseMaskRule(index + 1 + isEscapedChar));
                return result
            },
            _getMaskRule: function(pattern) {
                var ruleConfig;
                (0, _iterator.each)(this._maskRules, function(rulePattern, allowedChars) {
                    if (rulePattern === pattern) {
                        ruleConfig = {
                            pattern: rulePattern,
                            allowedChars: allowedChars
                        };
                        return false
                    }
                });
                return (0, _type.isDefined)(ruleConfig) ? new _uiText_editorMask.MaskRule((0, _extend.extend)({
                    maskChar: this.option("maskChar")
                }, ruleConfig)) : new _uiText_editorMask.StubMaskRule({
                    maskChar: pattern
                })
            },
            _renderMaskedValue: function() {
                if (!this._maskRulesChain) {
                    return
                }
                var value = this.option("value") || "";
                this._maskRulesChain.clear(this._normalizeChainArguments());
                var chainArgs = {
                    length: value.length
                };
                chainArgs[this._isMaskedValueMode() ? "text" : "value"] = value;
                this._handleChain(chainArgs);
                this._displayMask()
            },
            _replaceSelectedText: function(text, selection, char) {
                if (void 0 === char) {
                    return text
                }
                var textBefore = text.slice(0, selection.start);
                var textAfter = text.slice(selection.end);
                var edited = textBefore + char + textAfter;
                return edited
            },
            _isMaskedValueMode: function() {
                return this.option("useMaskedValue")
            },
            _displayMask: function(caret) {
                caret = caret || this._caret();
                this._renderValue();
                this._caret(caret)
            },
            _isValueEmpty: function() {
                return (0, _string.isEmpty)(this._value)
            },
            _shouldShowMask: function() {
                var showMaskMode = this.option("showMaskMode");
                if ("onFocus" === showMaskMode) {
                    return (0, _selectors.focused)(this._input()) || !this._isValueEmpty()
                }
                return true
            },
            _showMaskPlaceholder: function() {
                if (this._shouldShowMask()) {
                    var text = this._maskRulesChain.text();
                    this.option("text", text);
                    if ("onFocus" === this.option("showMaskMode")) {
                        this._renderDisplayText(text)
                    }
                }
            },
            _renderValue: function() {
                if (this._maskRulesChain) {
                    this._showMaskPlaceholder();
                    if (this._$hiddenElement) {
                        var value = this._maskRulesChain.value();
                        var submitElementValue = !(0, _string.isEmpty)(value) ? this._getPreparedValue() : "";
                        this._$hiddenElement.val(submitElementValue)
                    }
                }
                return this.callBase()
            },
            _getPreparedValue: function() {
                return this._convertToValue().replace(/\s+$/, "")
            },
            _valueChangeEventHandler: function(e) {
                if (!this._maskRulesChain) {
                    this.callBase.apply(this, arguments);
                    return
                }
                this._saveValueChangeEvent(e);
                this.option("value", this._getPreparedValue())
            },
            _isControlKeyFired: function(e) {
                return this._isControlKey((0, _index.normalizeKeyName)(e)) || (0, _index.isCommandKeyPressed)(e)
            },
            _handleChain: function(args) {
                var handledCount = this._maskRulesChain.handle(this._normalizeChainArguments(args));
                this._value = this._maskRulesChain.value();
                this._textValue = this._maskRulesChain.text();
                return handledCount
            },
            _normalizeChainArguments: function(args) {
                args = args || {};
                args.index = 0;
                args.fullText = this._maskRulesChain.text();
                return args
            },
            _convertToValue: function(text) {
                if (this._isMaskedValueMode()) {
                    text = this._replaceMaskCharWithEmpty(text || this._textValue || "")
                } else {
                    text = text || this._value || ""
                }
                return text
            },
            _replaceMaskCharWithEmpty: function(text) {
                return text.replace(new RegExp(this.option("maskChar"), "g"), EMPTY_CHAR)
            },
            _maskKeyHandler: function(e, keyHandler) {
                var _this = this;
                if (this.option("readOnly")) {
                    return
                }
                this.setForwardDirection();
                e.preventDefault();
                this._handleSelection();
                var previousText = this._input().val();
                var raiseInputEvent = function() {
                    if (previousText !== _this._input().val()) {
                        _this._maskStrategy.runWithoutEventProcessing(function() {
                            return _events_engine.default.trigger(_this._input(), "input")
                        })
                    }
                };
                var handled = keyHandler();
                if (handled) {
                    handled.then(raiseInputEvent)
                } else {
                    this.setForwardDirection();
                    this._adjustCaret();
                    this._displayMask();
                    this._maskRulesChain.reset();
                    raiseInputEvent()
                }
            },
            _handleKey: function(key, direction) {
                this._direction(direction || FORWARD_DIRECTION);
                this._adjustCaret(key);
                this._handleKeyChain(key);
                this._moveCaret()
            },
            _handleSelection: function() {
                if (!this._hasSelection()) {
                    return
                }
                var caret = this._caret();
                var emptyChars = new Array(caret.end - caret.start + 1).join(EMPTY_CHAR);
                this._handleKeyChain(emptyChars)
            },
            _handleKeyChain: function(chars) {
                var caret = this._caret();
                var start = this.isForwardDirection() ? caret.start : caret.start - 1;
                var end = this.isForwardDirection() ? caret.end : caret.end - 1;
                var length = start === end ? 1 : end - start;
                this._handleChain({
                    text: chars,
                    start: start,
                    length: length
                })
            },
            _tryMoveCaretBackward: function() {
                this.setBackwardDirection();
                var currentCaret = this._caret().start;
                this._adjustCaret();
                return !currentCaret || currentCaret !== this._caret().start
            },
            _adjustCaret: function(char) {
                var caret = this._maskRulesChain.adjustedCaret(this._caret().start, this.isForwardDirection(), char);
                this._caret({
                    start: caret,
                    end: caret
                })
            },
            _moveCaret: function() {
                var currentCaret = this._caret().start;
                var maskRuleIndex = currentCaret + (this.isForwardDirection() ? 0 : -1);
                var caret = this._maskRulesChain.isAccepted(maskRuleIndex) ? currentCaret + (this.isForwardDirection() ? 1 : -1) : currentCaret;
                this._caret({
                    start: caret,
                    end: caret
                })
            },
            _caret: function(position, force) {
                var $input = this._input();
                if (!$input.length) {
                    return
                }
                if (!arguments.length) {
                    return caret($input)
                }
                caret($input, position, force)
            },
            _hasSelection: function() {
                var caret = this._caret();
                return caret.start !== caret.end
            },
            _direction: function(direction) {
                if (!arguments.length) {
                    return this._typingDirection
                }
                this._typingDirection = direction
            },
            setForwardDirection: function() {
                this._direction(FORWARD_DIRECTION)
            },
            setBackwardDirection: function() {
                this._direction(BACKWARD_DIRECTION)
            },
            isForwardDirection: function() {
                return this._direction() === FORWARD_DIRECTION
            },
            _clean: function() {
                this._maskStrategy && this._maskStrategy.clean();
                this.callBase()
            },
            _validateMask: function() {
                if (!this._maskRulesChain) {
                    return
                }
                var isValid = (0, _string.isEmpty)(this.option("value")) || this._maskRulesChain.isValid(this._normalizeChainArguments());
                this.option({
                    isValid: isValid,
                    validationError: isValid ? null : {
                        editorSpecific: true,
                        message: this.option("maskInvalidMessage")
                    }
                })
            },
            _updateHiddenElement: function() {
                this._removeHiddenElement();
                if (this.option("mask")) {
                    this._input().removeAttr("name");
                    this._renderHiddenElement()
                }
                this._setSubmitElementName(this.option("name"))
            },
            _updateMaskOption: function() {
                this._updateHiddenElement();
                this._renderMask();
                this._validateMask()
            },
            _processEmptyMask: function(mask) {
                if (mask) {
                    return
                }
                var value = this.option("value");
                this.option({
                    text: value,
                    isValid: true
                });
                this.validationRequest.fire({
                    value: value,
                    editor: this
                });
                this._renderValue()
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "mask":
                        this._updateMaskOption();
                        this._processEmptyMask(args.value);
                        break;
                    case "maskChar":
                    case "maskRules":
                    case "useMaskedValue":
                        this._updateMaskOption();
                        break;
                    case "value":
                        this._renderMaskedValue();
                        this._validateMask();
                        this.callBase(args);
                        this._changedValue = this._input().val();
                        break;
                    case "maskInvalidMessage":
                        break;
                    case "showMaskMode":
                        this.option("text", "");
                        this._renderValue();
                        break;
                    default:
                        this.callBase(args)
                }
            }
        });
        var _default = TextEditorMask;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/text_box/utils.support.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.isInputEventsL2Supported = isInputEventsL2Supported;
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function isModernAndroidDevice() {
            var _devices$real = _devices.default.real(),
                android = _devices$real.android,
                version = _devices$real.version;
            return android && version[0] > 4
        }

        function isInputEventsL2Supported() {
            return "onbeforeinput" in _dom_adapter.default.createElement("input") || isModernAndroidDevice()
        }
    },
    /*!**************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/text_box/ui.text_editor.mask.rule.js ***!
      \**************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.StubMaskRule = exports.MaskRule = exports.EmptyMaskRule = void 0;
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var EMPTY_CHAR = " ";
        var BaseMaskRule = _class.default.inherit({
            ctor: function(config) {
                this._value = EMPTY_CHAR;
                (0, _extend.extend)(this, config)
            },
            next: function(rule) {
                if (!arguments.length) {
                    return this._next
                }
                this._next = rule
            },
            text: _common.noop,
            value: _common.noop,
            rawValue: _common.noop,
            handle: _common.noop,
            _prepareHandlingArgs: function(args, config) {
                var _config$str, _config$start, _config$length;
                config = config || {};
                var handlingProperty = Object.prototype.hasOwnProperty.call(args, "value") ? "value" : "text";
                args[handlingProperty] = null !== (_config$str = config.str) && void 0 !== _config$str ? _config$str : args[handlingProperty];
                args.start = null !== (_config$start = config.start) && void 0 !== _config$start ? _config$start : args.start;
                args.length = null !== (_config$length = config.length) && void 0 !== _config$length ? _config$length : args.length;
                args.index = args.index + 1;
                return args
            },
            reset: _common.noop,
            clear: _common.noop,
            first: function(index) {
                index = index || 0;
                return this.next().first(index + 1)
            },
            isAccepted: function() {
                return false
            },
            adjustedCaret: function(caret, isForwardDirection, char) {
                return isForwardDirection ? this._adjustedForward(caret, 0, char) : this._adjustedBackward(caret, 0, char)
            },
            _adjustedForward: _common.noop,
            _adjustedBackward: _common.noop,
            isValid: _common.noop
        });
        var EmptyMaskRule = BaseMaskRule.inherit({
            next: _common.noop,
            handle: function() {
                return 0
            },
            text: function() {
                return ""
            },
            value: function() {
                return ""
            },
            first: function() {
                return 0
            },
            rawValue: function() {
                return ""
            },
            adjustedCaret: function() {
                return 0
            },
            isValid: function() {
                return true
            }
        });
        exports.EmptyMaskRule = EmptyMaskRule;
        var MaskRule = BaseMaskRule.inherit({
            text: function() {
                return (this._value !== EMPTY_CHAR ? this._value : this.maskChar) + this.next().text()
            },
            value: function() {
                return this._value + this.next().value()
            },
            rawValue: function() {
                return this._value + this.next().rawValue()
            },
            handle: function(args) {
                var str = Object.prototype.hasOwnProperty.call(args, "value") ? args.value : args.text;
                if (!str || !str.length || !args.length) {
                    return 0
                }
                if (args.start) {
                    return this.next().handle(this._prepareHandlingArgs(args, {
                        start: args.start - 1
                    }))
                }
                var char = str[0];
                var rest = str.substring(1);
                this._tryAcceptChar(char, args);
                return this._accepted() ? this.next().handle(this._prepareHandlingArgs(args, {
                    str: rest,
                    length: args.length - 1
                })) + 1 : this.handle(this._prepareHandlingArgs(args, {
                    str: rest,
                    length: args.length - 1
                }))
            },
            clear: function(args) {
                this._tryAcceptChar(EMPTY_CHAR, args);
                this.next().clear(this._prepareHandlingArgs(args))
            },
            reset: function() {
                this._accepted(false);
                this.next().reset()
            },
            _tryAcceptChar: function(char, args) {
                this._accepted(false);
                if (!this._isAllowed(char, args)) {
                    return
                }
                var acceptedChar = char === EMPTY_CHAR ? this.maskChar : char;
                args.fullText = args.fullText.substring(0, args.index) + acceptedChar + args.fullText.substring(args.index + 1);
                this._accepted(true);
                this._value = char
            },
            _accepted: function(value) {
                if (!arguments.length) {
                    return !!this._isAccepted
                }
                this._isAccepted = !!value
            },
            first: function(index) {
                return this._value === EMPTY_CHAR ? index || 0 : this.callBase(index)
            },
            _isAllowed: function(char, args) {
                if (char === EMPTY_CHAR) {
                    return true
                }
                return this._isValid(char, args)
            },
            _isValid: function(char, args) {
                var allowedChars = this.allowedChars;
                if (allowedChars instanceof RegExp) {
                    return allowedChars.test(char)
                }
                if ((0, _type.isFunction)(allowedChars)) {
                    return allowedChars(char, args.index, args.fullText)
                }
                if (Array.isArray(allowedChars)) {
                    return (0, _array.inArray)(char, allowedChars) > -1
                }
                return allowedChars === char
            },
            isAccepted: function(caret) {
                return 0 === caret ? this._accepted() : this.next().isAccepted(caret - 1)
            },
            _adjustedForward: function(caret, index, char) {
                if (index >= caret) {
                    return index
                }
                return this.next()._adjustedForward(caret, index + 1, char) || index + 1
            },
            _adjustedBackward: function(caret, index) {
                if (index >= caret - 1) {
                    return caret
                }
                return this.next()._adjustedBackward(caret, index + 1) || index + 1
            },
            isValid: function(args) {
                return this._isValid(this._value, args) && this.next().isValid(this._prepareHandlingArgs(args))
            }
        });
        exports.MaskRule = MaskRule;
        var StubMaskRule = MaskRule.inherit({
            value: function() {
                return this.next().value()
            },
            handle: function(args) {
                var hasValueProperty = Object.prototype.hasOwnProperty.call(args, "value");
                var str = hasValueProperty ? args.value : args.text;
                if (!str.length || !args.length) {
                    return 0
                }
                if (args.start || hasValueProperty) {
                    return this.next().handle(this._prepareHandlingArgs(args, {
                        start: args.start && args.start - 1
                    }))
                }
                var char = str[0];
                var rest = str.substring(1);
                this._tryAcceptChar(char);
                var nextArgs = this._isAllowed(char) ? this._prepareHandlingArgs(args, {
                    str: rest,
                    length: args.length - 1
                }) : args;
                return this.next().handle(nextArgs) + 1
            },
            clear: function(args) {
                this._accepted(false);
                this.next().clear(this._prepareHandlingArgs(args))
            },
            _tryAcceptChar: function(char) {
                this._accepted(this._isValid(char))
            },
            _isValid: function(char) {
                return char === this.maskChar
            },
            first: function(index) {
                index = index || 0;
                return this.next().first(index + 1)
            },
            _adjustedForward: function(caret, index, char) {
                if (index >= caret && char === this.maskChar) {
                    return index
                }
                if (caret === index + 1 && this._accepted()) {
                    return caret
                }
                return this.next()._adjustedForward(caret, index + 1, char)
            },
            _adjustedBackward: function(caret, index) {
                if (index >= caret - 1) {
                    return 0
                }
                return this.next()._adjustedBackward(caret, index + 1)
            },
            isValid: function(args) {
                return this.next().isValid(this._prepareHandlingArgs(args))
            }
        });
        exports.StubMaskRule = StubMaskRule
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/text_box/ui.text_editor.base.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _dom = __webpack_require__( /*! ../../core/utils/dom */ 33);
        var _selectors = __webpack_require__( /*! ../widget/selectors */ 70);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _themes = __webpack_require__( /*! ../themes */ 34);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _editor = _interopRequireDefault(__webpack_require__( /*! ../editor/editor */ 52));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../../events/pointer */ 24));
        var _uiText_editor = _interopRequireDefault(__webpack_require__( /*! ./ui.text_editor.clear */ 588));
        var _index2 = _interopRequireDefault(__webpack_require__( /*! ./texteditor_button_collection/index */ 589));
        var _config = _interopRequireDefault(__webpack_require__( /*! ../../core/config */ 31));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _load_indicator = _interopRequireDefault(__webpack_require__( /*! ../load_indicator */ 83));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var TEXTEDITOR_CLASS = "dx-texteditor";
        var TEXTEDITOR_INPUT_CONTAINER_CLASS = "dx-texteditor-input-container";
        var TEXTEDITOR_INPUT_CLASS = "dx-texteditor-input";
        var TEXTEDITOR_INPUT_SELECTOR = "." + TEXTEDITOR_INPUT_CLASS;
        var TEXTEDITOR_CONTAINER_CLASS = "dx-texteditor-container";
        var TEXTEDITOR_BUTTONS_CONTAINER_CLASS = "dx-texteditor-buttons-container";
        var TEXTEDITOR_PLACEHOLDER_CLASS = "dx-placeholder";
        var TEXTEDITOR_EMPTY_INPUT_CLASS = "dx-texteditor-empty";
        var TEXTEDITOR_STYLING_MODE_PREFIX = "dx-editor-";
        var ALLOWED_STYLE_CLASSES = [TEXTEDITOR_STYLING_MODE_PREFIX + "outlined", TEXTEDITOR_STYLING_MODE_PREFIX + "filled", TEXTEDITOR_STYLING_MODE_PREFIX + "underlined"];
        var STATE_INVISIBLE_CLASS = "dx-state-invisible";
        var TEXTEDITOR_PENDING_INDICATOR_CLASS = "dx-pending-indicator";
        var TEXTEDITOR_VALIDATION_PENDING_CLASS = "dx-validation-pending";
        var TEXTEDITOR_VALID_CLASS = "dx-valid";
        var EVENTS_LIST = ["KeyDown", "KeyPress", "KeyUp", "Change", "Cut", "Copy", "Paste", "Input"];
        var CONTROL_KEYS = ["tab", "enter", "shift", "control", "alt", "escape", "pageUp", "pageDown", "end", "home", "leftArrow", "upArrow", "rightArrow", "downArrow"];

        function checkButtonsOptionType(buttons) {
            if ((0, _type.isDefined)(buttons) && !Array.isArray(buttons)) {
                throw _ui.default.Error("E1053")
            }
        }
        var TextEditorBase = _editor.default.inherit({
            ctor: function(_, options) {
                if (options) {
                    checkButtonsOptionType(options.buttons)
                }
                this._buttonCollection = new _index2.default(this, this._getDefaultButtons());
                this._$beforeButtonsContainer = null;
                this._$afterButtonsContainer = null;
                this.callBase.apply(this, arguments)
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    buttons: void 0,
                    value: "",
                    spellcheck: false,
                    showClearButton: false,
                    valueChangeEvent: "change",
                    placeholder: "",
                    inputAttr: {},
                    onFocusIn: null,
                    onFocusOut: null,
                    onKeyDown: null,
                    onKeyPress: null,
                    onKeyUp: null,
                    onChange: null,
                    onInput: null,
                    onCut: null,
                    onCopy: null,
                    onPaste: null,
                    onEnterKey: null,
                    mode: "text",
                    hoverStateEnabled: true,
                    focusStateEnabled: true,
                    text: void 0,
                    displayValueFormatter: function(value) {
                        return (0, _type.isDefined)(value) && false !== value ? value : ""
                    },
                    stylingMode: (0, _config.default)().editorStylingMode || "outlined",
                    showValidationMark: true
                })
            },
            _defaultOptionsRules: function() {
                var themeName = (0, _themes.current)();
                return this.callBase().concat([{
                    device: function() {
                        return (0, _themes.isMaterial)(themeName)
                    },
                    options: {
                        stylingMode: (0, _config.default)().editorStylingMode || "underlined"
                    }
                }])
            },
            _setDeprecatedOptions: function() {
                this.callBase();
                (0, _extend.extend)(this._deprecatedOptions, {
                    onKeyPress: {
                        since: "20.1",
                        message: "This event is removed from the web standards and will be deprecated in modern browsers soon."
                    }
                })
            },
            _getDefaultButtons: function() {
                return [{
                    name: "clear",
                    Ctor: _uiText_editor.default
                }]
            },
            _isClearButtonVisible: function() {
                return this.option("showClearButton") && !this.option("readOnly")
            },
            _input: function() {
                return this.$element().find(TEXTEDITOR_INPUT_SELECTOR).first()
            },
            _isFocused: function() {
                return (0, _selectors.focused)(this._input()) || this.callBase()
            },
            _inputWrapper: function() {
                return this.$element()
            },
            _buttonsContainer: function() {
                return this._inputWrapper().find("." + TEXTEDITOR_BUTTONS_CONTAINER_CLASS).eq(0)
            },
            _isControlKey: function(key) {
                return CONTROL_KEYS.indexOf(key) !== -1
            },
            _renderStylingMode: function() {
                var _this = this;
                var optionName = "stylingMode";
                var optionValue = this.option(optionName);
                ALLOWED_STYLE_CLASSES.forEach(function(className) {
                    return _this.$element().removeClass(className)
                });
                var stylingModeClass = TEXTEDITOR_STYLING_MODE_PREFIX + optionValue;
                if (ALLOWED_STYLE_CLASSES.indexOf(stylingModeClass) === -1) {
                    var defaultOptionValue = this._getDefaultOptions()[optionName];
                    var platformOptionValue = this._convertRulesToOptions(this._defaultOptionsRules())[optionName];
                    stylingModeClass = TEXTEDITOR_STYLING_MODE_PREFIX + (platformOptionValue || defaultOptionValue)
                }
                this.$element().addClass(stylingModeClass);
                this._updateButtonsStyling(optionValue)
            },
            _initMarkup: function() {
                this.$element().addClass(TEXTEDITOR_CLASS);
                this._renderInput();
                this._renderStylingMode();
                this._renderInputType();
                this._renderPlaceholder();
                this._renderProps();
                this.callBase();
                this._renderValue()
            },
            _render: function() {
                this._renderPlaceholder();
                this._refreshValueChangeEvent();
                this._renderEvents();
                this._renderEnterKeyAction();
                this._renderEmptinessEvent();
                this.callBase()
            },
            _renderInput: function() {
                this._$buttonsContainer = this._$textEditorContainer = (0, _renderer.default)("<div>").addClass(TEXTEDITOR_CONTAINER_CLASS).appendTo(this.$element());
                this._$textEditorInputContainer = (0, _renderer.default)("<div>").addClass(TEXTEDITOR_INPUT_CONTAINER_CLASS).appendTo(this._$textEditorContainer);
                this._$textEditorInputContainer.append(this._createInput());
                this._renderButtonContainers()
            },
            _getInputContainer: function() {
                return this._$textEditorInputContainer
            },
            _renderPendingIndicator: function() {
                this.$element().addClass(TEXTEDITOR_VALIDATION_PENDING_CLASS);
                var $inputContainer = this._getInputContainer();
                var $indicatorElement = (0, _renderer.default)("<div>").addClass(TEXTEDITOR_PENDING_INDICATOR_CLASS).appendTo($inputContainer);
                this._pendingIndicator = this._createComponent($indicatorElement, _load_indicator.default)
            },
            _disposePendingIndicator: function() {
                if (!this._pendingIndicator) {
                    return
                }
                this._pendingIndicator.dispose();
                this._pendingIndicator.$element().remove();
                this._pendingIndicator = null;
                this.$element().removeClass(TEXTEDITOR_VALIDATION_PENDING_CLASS)
            },
            _renderValidationState: function() {
                this.callBase();
                var isPending = "pending" === this.option("validationStatus");
                var $element = this.$element();
                if (isPending) {
                    !this._pendingIndicator && this._renderPendingIndicator();
                    this._showValidMark = false
                } else {
                    if ("invalid" === this.option("validationStatus")) {
                        this._showValidMark = false
                    }
                    if (!this._showValidMark && true === this.option("showValidationMark")) {
                        this._showValidMark = "valid" === this.option("validationStatus") && !!this._pendingIndicator
                    }
                    this._disposePendingIndicator()
                }
                $element.toggleClass(TEXTEDITOR_VALID_CLASS, !!this._showValidMark)
            },
            _renderButtonContainers: function() {
                var buttons = this.option("buttons");
                this._$beforeButtonsContainer = this._buttonCollection.renderBeforeButtons(buttons, this._$buttonsContainer);
                this._$afterButtonsContainer = this._buttonCollection.renderAfterButtons(buttons, this._$buttonsContainer)
            },
            _clean: function() {
                this._buttonCollection.clean();
                this._disposePendingIndicator();
                this._$beforeButtonsContainer = null;
                this._$afterButtonsContainer = null;
                this._$textEditorContainer = null;
                this._$buttonsContainer = null;
                this.callBase()
            },
            _createInput: function() {
                var $input = (0, _renderer.default)("<input>");
                this._applyInputAttributes($input, this.option("inputAttr"));
                return $input
            },
            _setSubmitElementName: function(name) {
                var inputAttrName = this.option("inputAttr.name");
                return this.callBase(name || inputAttrName || "")
            },
            _applyInputAttributes: function($input, customAttributes) {
                var inputAttributes = (0, _extend.extend)(this._getDefaultAttributes(), customAttributes);
                $input.attr(inputAttributes).addClass(TEXTEDITOR_INPUT_CLASS).css("minHeight", this.option("height") ? "0" : "")
            },
            _getDefaultAttributes: function() {
                var defaultAttributes = {
                    autocomplete: "off"
                };
                var _devices$real = _devices.default.real(),
                    ios = _devices$real.ios,
                    mac = _devices$real.mac;
                if (ios || mac) {
                    defaultAttributes.placeholder = " "
                }
                return defaultAttributes
            },
            _updateButtons: function(names) {
                this._buttonCollection.updateButtons(names)
            },
            _updateButtonsStyling: function(editorStylingMode) {
                var _this2 = this;
                (0, _iterator.each)(this.option("buttons"), function(_, buttonOptions) {
                    if (buttonOptions.options && !buttonOptions.options.stylingMode) {
                        var buttonInstance = _this2.getButton(buttonOptions.name);
                        buttonInstance.option && buttonInstance.option("stylingMode", "underlined" === editorStylingMode ? "text" : "contained")
                    }
                })
            },
            _renderValue: function() {
                var renderInputPromise = this._renderInputValue();
                return renderInputPromise.promise()
            },
            _renderInputValue: function(value) {
                var _value;
                value = null !== (_value = value) && void 0 !== _value ? _value : this.option("value");
                var text = this.option("text");
                var displayValue = this.option("displayValue");
                var displayValueFormatter = this.option("displayValueFormatter");
                if (void 0 !== displayValue && null !== value) {
                    text = displayValueFormatter(displayValue)
                } else {
                    if (!(0, _type.isDefined)(text)) {
                        text = displayValueFormatter(value)
                    }
                }
                this.option("text", text);
                if (this._input().val() !== ((0, _type.isDefined)(text) ? text : "")) {
                    this._renderDisplayText(text)
                } else {
                    this._toggleEmptinessEventHandler()
                }
                return (new _deferred.Deferred).resolve()
            },
            _renderDisplayText: function(text) {
                this._input().val(text);
                this._toggleEmptinessEventHandler()
            },
            _isValueValid: function() {
                if (this._input().length) {
                    var validity = this._input().get(0).validity;
                    if (validity) {
                        return validity.valid
                    }
                }
                return true
            },
            _toggleEmptiness: function(isEmpty) {
                this.$element().toggleClass(TEXTEDITOR_EMPTY_INPUT_CLASS, isEmpty);
                this._togglePlaceholder(isEmpty)
            },
            _togglePlaceholder: function(isEmpty) {
                this.$element().find(".".concat(TEXTEDITOR_PLACEHOLDER_CLASS)).eq(0).toggleClass(STATE_INVISIBLE_CLASS, !isEmpty)
            },
            _renderProps: function() {
                this._toggleReadOnlyState();
                this._toggleSpellcheckState();
                this._toggleTabIndex()
            },
            _toggleDisabledState: function(value) {
                this.callBase.apply(this, arguments);
                var $input = this._input();
                $input.prop("disabled", value)
            },
            _toggleTabIndex: function() {
                var $input = this._input();
                var disabled = this.option("disabled");
                var focusStateEnabled = this.option("focusStateEnabled");
                if (disabled || !focusStateEnabled) {
                    $input.attr("tabIndex", -1)
                } else {
                    $input.removeAttr("tabIndex")
                }
            },
            _toggleReadOnlyState: function() {
                this._input().prop("readOnly", this._readOnlyPropValue());
                this.callBase()
            },
            _readOnlyPropValue: function() {
                return this.option("readOnly")
            },
            _toggleSpellcheckState: function() {
                this._input().prop("spellcheck", this.option("spellcheck"))
            },
            _renderPlaceholder: function() {
                this._renderPlaceholderMarkup();
                this._attachPlaceholderEvents()
            },
            _renderPlaceholderMarkup: function() {
                if (this._$placeholder) {
                    this._$placeholder.remove();
                    this._$placeholder = null
                }
                var $input = this._input();
                var placeholderText = this.option("placeholder");
                var $placeholder = this._$placeholder = (0, _renderer.default)("<div>").attr("data-dx_placeholder", placeholderText);
                $placeholder.insertAfter($input);
                $placeholder.addClass(TEXTEDITOR_PLACEHOLDER_CLASS)
            },
            _attachPlaceholderEvents: function() {
                var _this3 = this;
                var startEvent = (0, _index.addNamespace)(_pointer.default.up, this.NAME);
                _events_engine.default.on(this._$placeholder, startEvent, function() {
                    _events_engine.default.trigger(_this3._input(), "focus")
                });
                this._toggleEmptinessEventHandler()
            },
            _placeholder: function() {
                return this._$placeholder || (0, _renderer.default)()
            },
            _clearValueHandler: function(e) {
                var $input = this._input();
                e.stopPropagation();
                this._saveValueChangeEvent(e);
                this._clearValue();
                !this._isFocused() && _events_engine.default.trigger($input, "focus");
                _events_engine.default.trigger($input, "input")
            },
            _clearValue: function() {
                this.reset()
            },
            _renderEvents: function() {
                var _this4 = this;
                var $input = this._input();
                (0, _iterator.each)(EVENTS_LIST, function(_, event) {
                    if (_this4.hasActionSubscription("on" + event)) {
                        var action = _this4._createActionByOption("on" + event, {
                            excludeValidators: ["readOnly"]
                        });
                        _events_engine.default.on($input, (0, _index.addNamespace)(event.toLowerCase(), _this4.NAME), function(e) {
                            if (_this4._disposed) {
                                return
                            }
                            action({
                                event: e
                            })
                        })
                    }
                })
            },
            _refreshEvents: function() {
                var _this5 = this;
                var $input = this._input();
                (0, _iterator.each)(EVENTS_LIST, function(_, event) {
                    _events_engine.default.off($input, (0, _index.addNamespace)(event.toLowerCase(), _this5.NAME))
                });
                this._renderEvents()
            },
            _keyPressHandler: function() {
                this.option("text", this._input().val())
            },
            _keyDownHandler: function(e) {
                var $input = this._input();
                var isCtrlEnter = e.ctrlKey && "enter" === (0, _index.normalizeKeyName)(e);
                var isNewValue = $input.val() !== this.option("value");
                if (isCtrlEnter && isNewValue) {
                    _events_engine.default.trigger($input, "change")
                }
            },
            _renderValueChangeEvent: function() {
                var keyPressEvent = (0, _index.addNamespace)(this._renderValueEventName(), "".concat(this.NAME, "TextChange"));
                var valueChangeEvent = (0, _index.addNamespace)(this.option("valueChangeEvent"), "".concat(this.NAME, "ValueChange"));
                var keyDownEvent = (0, _index.addNamespace)("keydown", "".concat(this.NAME, "TextChange"));
                var $input = this._input();
                _events_engine.default.on($input, keyPressEvent, this._keyPressHandler.bind(this));
                _events_engine.default.on($input, valueChangeEvent, this._valueChangeEventHandler.bind(this));
                _events_engine.default.on($input, keyDownEvent, this._keyDownHandler.bind(this))
            },
            _cleanValueChangeEvent: function() {
                var valueChangeNamespace = ".".concat(this.NAME, "ValueChange");
                var textChangeNamespace = ".".concat(this.NAME, "TextChange");
                _events_engine.default.off(this._input(), valueChangeNamespace);
                _events_engine.default.off(this._input(), textChangeNamespace)
            },
            _refreshValueChangeEvent: function() {
                this._cleanValueChangeEvent();
                this._renderValueChangeEvent()
            },
            _renderValueEventName: function() {
                return "input change keypress"
            },
            _focusTarget: function() {
                return this._input()
            },
            _focusEventTarget: function() {
                return this.element()
            },
            _isInput: function(element) {
                return element === this._input().get(0)
            },
            _preventNestedFocusEvent: function(event) {
                if (event.isDefaultPrevented()) {
                    return true
                }
                var result = this._isNestedTarget(event.relatedTarget);
                if ("focusin" === event.type) {
                    result = result && this._isNestedTarget(event.target) && !this._isInput(event.target)
                }
                result && event.preventDefault();
                return result
            },
            _isNestedTarget: function(target) {
                return !!this.$element().find(target).length
            },
            _focusClassTarget: function() {
                return this.$element()
            },
            _focusInHandler: function(event) {
                this._preventNestedFocusEvent(event);
                this.callBase.apply(this, arguments)
            },
            _focusOutHandler: function(event) {
                this._preventNestedFocusEvent(event);
                this.callBase.apply(this, arguments)
            },
            _toggleFocusClass: function(isFocused, $element) {
                this.callBase(isFocused, this._focusClassTarget($element))
            },
            _hasFocusClass: function(element) {
                return this.callBase((0, _renderer.default)(element || this.$element()))
            },
            _renderEmptinessEvent: function() {
                var $input = this._input();
                _events_engine.default.on($input, "input blur", this._toggleEmptinessEventHandler.bind(this))
            },
            _toggleEmptinessEventHandler: function() {
                var text = this._input().val();
                var isEmpty = ("" === text || null === text) && this._isValueValid();
                this._toggleEmptiness(isEmpty)
            },
            _valueChangeEventHandler: function(e, formattedValue) {
                this._saveValueChangeEvent(e);
                this.option("value", arguments.length > 1 ? formattedValue : this._input().val());
                this._saveValueChangeEvent(void 0)
            },
            _renderEnterKeyAction: function() {
                this._enterKeyAction = this._createActionByOption("onEnterKey", {
                    excludeValidators: ["readOnly"]
                });
                _events_engine.default.off(this._input(), "keyup.onEnterKey.dxTextEditor");
                _events_engine.default.on(this._input(), "keyup.onEnterKey.dxTextEditor", this._enterKeyHandlerUp.bind(this))
            },
            _enterKeyHandlerUp: function(e) {
                if (this._disposed) {
                    return
                }
                if ("enter" === (0, _index.normalizeKeyName)(e)) {
                    this._enterKeyAction({
                        event: e
                    })
                }
            },
            _updateValue: function() {
                this._options.silent("text", null);
                this._renderValue()
            },
            _dispose: function() {
                this._enterKeyAction = void 0;
                this.callBase()
            },
            _getSubmitElement: function() {
                return this._input()
            },
            _optionChanged: function(args) {
                var name = args.name,
                    fullName = args.fullName,
                    value = args.value;
                if ((0, _array.inArray)(name.replace("on", ""), EVENTS_LIST) > -1) {
                    this._refreshEvents();
                    return
                }
                switch (name) {
                    case "valueChangeEvent":
                        this._refreshValueChangeEvent();
                        this._refreshFocusEvent();
                        this._refreshEvents();
                        break;
                    case "onValueChanged":
                        this._createValueChangeAction();
                        break;
                    case "focusStateEnabled":
                        this.callBase(args);
                        this._toggleTabIndex();
                        break;
                    case "spellcheck":
                        this._toggleSpellcheckState();
                        break;
                    case "mode":
                        this._renderInputType();
                        break;
                    case "onEnterKey":
                        this._renderEnterKeyAction();
                        break;
                    case "placeholder":
                        this._renderPlaceholder();
                        break;
                    case "readOnly":
                    case "disabled":
                        this._updateButtons();
                        this.callBase(args);
                        break;
                    case "showClearButton":
                        this._updateButtons(["clear"]);
                        break;
                    case "text":
                        break;
                    case "value":
                        this._updateValue();
                        this.callBase(args);
                        break;
                    case "inputAttr":
                        this._applyInputAttributes(this._input(), this.option(name));
                        break;
                    case "stylingMode":
                        this._renderStylingMode();
                        break;
                    case "buttons":
                        if (fullName === name) {
                            checkButtonsOptionType(value)
                        }
                        this._$beforeButtonsContainer && this._$beforeButtonsContainer.remove();
                        this._$afterButtonsContainer && this._$afterButtonsContainer.remove();
                        this._buttonCollection.clean();
                        this._renderButtonContainers();
                        break;
                    case "displayValueFormatter":
                        this._invalidate();
                        break;
                    case "showValidationMark":
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _renderInputType: function() {
                this._setInputType(this.option("mode"))
            },
            _setInputType: function(type) {
                var input = this._input();
                if ("search" === type) {
                    type = "text"
                }
                try {
                    input.prop("type", type)
                } catch (e) {
                    input.prop("type", "text")
                }
            },
            getButton: function(name) {
                return this._buttonCollection.getButton(name)
            },
            focus: function() {
                _events_engine.default.trigger(this._input(), "focus")
            },
            blur: function() {
                if (this._input().is(_dom_adapter.default.getActiveElement())) {
                    (0, _dom.resetActiveElement)()
                }
            },
            reset: function() {
                if (this._showValidMark) {
                    this._showValidMark = false;
                    this._renderValidationState()
                }
                var defaultOptions = this._getDefaultOptions();
                if (this.option("value") === defaultOptions.value) {
                    this._options.silent("text", "");
                    this._renderValue()
                } else {
                    this.option("value", defaultOptions.value)
                }
            },
            on: function(eventName, eventHandler) {
                var result = this.callBase(eventName, eventHandler);
                var event = eventName.charAt(0).toUpperCase() + eventName.substr(1);
                if (EVENTS_LIST.indexOf(event) >= 0) {
                    this._refreshEvents()
                }
                return result
            }
        });
        var _default = TextEditorBase;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/text_box/ui.text_editor.clear.js ***!
      \**********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _button = _interopRequireDefault(__webpack_require__( /*! ./texteditor_button_collection/button */ 207));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../../events/pointer */ 24));
        var _click = __webpack_require__( /*! ../../events/click */ 21);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var pointerDown = _pointer.default.down;
        var STATE_INVISIBLE_CLASS = "dx-state-invisible";
        var TEXTEDITOR_CLEAR_BUTTON_CLASS = "dx-clear-button-area";
        var TEXTEDITOR_CLEAR_ICON_CLASS = "dx-icon-clear";
        var TEXTEDITOR_ICON_CLASS = "dx-icon";
        var TEXTEDITOR_SHOW_CLEAR_BUTTON_CLASS = "dx-show-clear-button";
        var ClearButton = function(_TextEditorButton) {
            _inheritsLoose(ClearButton, _TextEditorButton);

            function ClearButton() {
                return _TextEditorButton.apply(this, arguments) || this
            }
            var _proto = ClearButton.prototype;
            _proto._create = function() {
                var $element = (0, _renderer.default)("<span>").addClass(TEXTEDITOR_CLEAR_BUTTON_CLASS).append((0, _renderer.default)("<span>").addClass(TEXTEDITOR_ICON_CLASS).addClass(TEXTEDITOR_CLEAR_ICON_CLASS));
                this._addToContainer($element);
                this.update(true);
                return {
                    instance: $element,
                    $element: $element
                }
            };
            _proto._isVisible = function() {
                var editor = this.editor;
                return editor._isClearButtonVisible()
            };
            _proto._attachEvents = function(instance, $button) {
                var editor = this.editor;
                var editorName = editor.NAME;
                _events_engine.default.on($button, (0, _index.addNamespace)(pointerDown, editorName), function(e) {
                    e.preventDefault();
                    if ("mouse" !== e.pointerType) {
                        editor._clearValueHandler(e)
                    }
                });
                _events_engine.default.on($button, (0, _index.addNamespace)(_click.name, editorName), function(e) {
                    return editor._clearValueHandler(e)
                })
            };
            _proto._legacyRender = function($editor, isVisible) {
                $editor.toggleClass(TEXTEDITOR_SHOW_CLEAR_BUTTON_CLASS, isVisible)
            };
            _proto.update = function() {
                var rendered = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : false;
                !rendered && _TextEditorButton.prototype.update.call(this);
                var editor = this.editor,
                    instance = this.instance;
                var $editor = editor.$element();
                var isVisible = this._isVisible();
                instance && instance.toggleClass(STATE_INVISIBLE_CLASS, !isVisible);
                this._legacyRender($editor, isVisible)
            };
            return ClearButton
        }(_button.default);
        exports.default = ClearButton;
        module.exports = exports.default
    },
    /*!************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/text_box/texteditor_button_collection/index.js ***!
      \************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../../core/renderer */ 2));
        var _custom = _interopRequireDefault(__webpack_require__( /*! ./custom */ 590));
        var _extend = __webpack_require__( /*! ../../../core/utils/extend */ 0);
        var _array = __webpack_require__( /*! ../../../core/utils/array */ 12);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../../widget/ui.errors */ 17));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        var TEXTEDITOR_BUTTONS_CONTAINER_CLASS = "dx-texteditor-buttons-container";

        function checkButtonInfo(buttonInfo) {
            var checkButtonType = function() {
                if (!buttonInfo || "object" !== _typeof(buttonInfo) || Array.isArray(buttonInfo)) {
                    throw _ui.default.Error("E1053")
                }
            };
            var checkLocation = function() {
                var location = buttonInfo.location;
                if ("location" in buttonInfo && "after" !== location && "before" !== location) {
                    buttonInfo.location = "after"
                }
            };
            var checkNameIsDefined = function() {
                if (!("name" in buttonInfo)) {
                    throw _ui.default.Error("E1054")
                }
            };
            var checkNameIsString = function() {
                var name = buttonInfo.name;
                if ("string" !== typeof name) {
                    throw _ui.default.Error("E1055")
                }
            };
            checkButtonType();
            checkNameIsDefined();
            checkNameIsString();
            checkLocation()
        }

        function checkNamesUniqueness(existingNames, newName) {
            if (existingNames.indexOf(newName) !== -1) {
                throw _ui.default.Error("E1055", newName)
            }
            existingNames.push(newName)
        }

        function isPredefinedButtonName(name, predefinedButtonsInfo) {
            return !!(0, _array.find)(predefinedButtonsInfo, function(info) {
                return info.name === name
            })
        }
        var TextEditorButtonCollection = function() {
            function TextEditorButtonCollection(editor, defaultButtonsInfo) {
                this.buttons = [];
                this.defaultButtonsInfo = defaultButtonsInfo;
                this.editor = editor
            }
            var _proto = TextEditorButtonCollection.prototype;
            _proto._compileButtonInfo = function(buttons) {
                var _this = this;
                var names = [];
                return buttons.map(function(button) {
                    var isStringButton = "string" === typeof button;
                    if (!isStringButton) {
                        checkButtonInfo(button)
                    }
                    var isDefaultButton = isStringButton || isPredefinedButtonName(button.name, _this.defaultButtonsInfo);
                    if (isDefaultButton) {
                        var defaultButtonInfo = (0, _array.find)(_this.defaultButtonsInfo, function(_ref) {
                            var name = _ref.name;
                            return name === button || name === button.name
                        });
                        if (!defaultButtonInfo) {
                            throw _ui.default.Error("E1056", _this.editor.NAME, button)
                        }
                        checkNamesUniqueness(names, button);
                        return defaultButtonInfo
                    } else {
                        var name = button.name;
                        checkNamesUniqueness(names, name);
                        return (0, _extend.extend)(button, {
                            Ctor: _custom.default
                        })
                    }
                })
            };
            _proto._createButton = function(buttonsInfo) {
                var Ctor = buttonsInfo.Ctor,
                    options = buttonsInfo.options,
                    name = buttonsInfo.name;
                var button = new Ctor(name, this.editor, options);
                this.buttons.push(button);
                return button
            };
            _proto._renderButtons = function(buttons, $container, targetLocation) {
                var _this2 = this;
                var $buttonsContainer = null;
                var buttonsInfo = buttons ? this._compileButtonInfo(buttons) : this.defaultButtonsInfo;
                var getButtonsContainer = function() {
                    $buttonsContainer = $buttonsContainer || (0, _renderer.default)("<div>").addClass(TEXTEDITOR_BUTTONS_CONTAINER_CLASS);
                    "before" === targetLocation ? $container.prepend($buttonsContainer) : $container.append($buttonsContainer);
                    return $buttonsContainer
                };
                buttonsInfo.forEach(function(buttonsInfo) {
                    var _buttonsInfo$location = buttonsInfo.location,
                        location = void 0 === _buttonsInfo$location ? "after" : _buttonsInfo$location;
                    if (location === targetLocation) {
                        _this2._createButton(buttonsInfo).render(getButtonsContainer())
                    }
                });
                return $buttonsContainer
            };
            _proto.clean = function() {
                this.buttons.forEach(function(button) {
                    return button.dispose()
                });
                this.buttons = []
            };
            _proto.getButton = function(buttonName) {
                var button = (0, _array.find)(this.buttons, function(_ref2) {
                    var name = _ref2.name;
                    return name === buttonName
                });
                return button && button.instance
            };
            _proto.renderAfterButtons = function(buttons, $container) {
                return this._renderButtons(buttons, $container, "after")
            };
            _proto.renderBeforeButtons = function(buttons, $container) {
                return this._renderButtons(buttons, $container, "before")
            };
            _proto.updateButtons = function(names) {
                this.buttons.forEach(function(button) {
                    if (!names || names.indexOf(button.name) !== -1) {
                        button.update()
                    }
                })
            };
            return TextEditorButtonCollection
        }();
        exports.default = TextEditorButtonCollection;
        module.exports = exports.default
    },
    /*!*************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/text_box/texteditor_button_collection/custom.js ***!
      \*************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../../core/renderer */ 2));
        var _button = _interopRequireDefault(__webpack_require__( /*! ./button */ 207));
        var _button2 = _interopRequireDefault(__webpack_require__( /*! ../../button */ 37));
        var _extend = __webpack_require__( /*! ../../../core/utils/extend */ 0);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../../events/core/events_engine */ 5));
        var _hover = __webpack_require__( /*! ../../../events/hover */ 155);
        var _click = __webpack_require__( /*! ../../../events/click */ 21);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var CUSTOM_BUTTON_HOVERED_CLASS = "dx-custom-button-hovered";
        var CustomButton = function(_TextEditorButton) {
            _inheritsLoose(CustomButton, _TextEditorButton);

            function CustomButton() {
                return _TextEditorButton.apply(this, arguments) || this
            }
            var _proto = CustomButton.prototype;
            _proto._attachEvents = function(instance, $element) {
                var editor = this.editor;
                _events_engine.default.on($element, _hover.start, function() {
                    editor.$element().addClass(CUSTOM_BUTTON_HOVERED_CLASS)
                });
                _events_engine.default.on($element, _hover.end, function() {
                    editor.$element().removeClass(CUSTOM_BUTTON_HOVERED_CLASS)
                });
                _events_engine.default.on($element, _click.name, function(e) {
                    e.stopPropagation()
                })
            };
            _proto._create = function() {
                var editor = this.editor;
                var $element = (0, _renderer.default)("<div>");
                this._addToContainer($element);
                var instance = editor._createComponent($element, _button2.default, (0, _extend.extend)({}, this.options, {
                    ignoreParentReadOnly: true,
                    disabled: this._isDisabled(),
                    integrationOptions: this._prepareIntegrationOptions(editor)
                }));
                return {
                    $element: $element,
                    instance: instance
                }
            };
            _proto._prepareIntegrationOptions = function(editor) {
                return (0, _extend.extend)({}, editor.option("integrationOptions"), {
                    skipTemplates: ["content"]
                })
            };
            _proto.update = function() {
                var isUpdated = _TextEditorButton.prototype.update.call(this);
                if (this.instance) {
                    this.instance.option("disabled", this._isDisabled())
                }
                return isUpdated
            };
            _proto._isVisible = function() {
                var editor = this.editor;
                return editor.option("visible")
            };
            _proto._isDisabled = function() {
                var isDefinedByUser = void 0 !== this.options.disabled;
                if (isDefinedByUser) {
                    return this.instance ? this.instance.option("disabled") : this.options.disabled
                } else {
                    return this.editor.option("readOnly")
                }
            };
            return CustomButton
        }(_button.default);
        exports.default = CustomButton;
        module.exports = exports.default
    },
    /*!**************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/text_box/ui.text_editor.mask.strategy.default.js ***!
      \**************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiText_editorMaskStrategy = _interopRequireDefault(__webpack_require__( /*! ./ui.text_editor.mask.strategy.base */ 344));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _promise = _interopRequireDefault(__webpack_require__( /*! ../../core/polyfills/promise */ 73));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var BACKSPACE_INPUT_TYPE = "deleteContentBackward";
        var EMPTY_CHAR = " ";
        var DefaultMaskStrategy = function(_BaseMaskStrategy) {
            _inheritsLoose(DefaultMaskStrategy, _BaseMaskStrategy);

            function DefaultMaskStrategy() {
                return _BaseMaskStrategy.apply(this, arguments) || this
            }
            var _proto = DefaultMaskStrategy.prototype;
            _proto._getStrategyName = function() {
                return "default"
            };
            _proto.getHandleEventNames = function() {
                return [].concat(_toConsumableArray(_BaseMaskStrategy.prototype.getHandleEventNames.call(this)), ["keyPress"])
            };
            _proto._keyPressHandler = function(event) {
                if (this._keyPressHandled) {
                    return
                }
                this._keyPressHandled = true;
                if (this.editor._isControlKeyFired(event)) {
                    return
                }
                var editor = this.editor;
                editor._maskKeyHandler(event, function() {
                    return editor._handleKey((0, _index.getChar)(event))
                })
            };
            _proto._inputHandler = function(event) {
                if (this._backspaceInputHandled(event.originalEvent && event.originalEvent.inputType)) {
                    this._handleBackspaceInput(event)
                }
                if (event.originalEvent) {
                    this._autoFillHandler(event)
                }
                if (this._keyPressHandled) {
                    return
                }
                this._keyPressHandled = true;
                var inputValue = this.editorInput().val();
                var caret = this.editorCaret();
                if (!caret.end) {
                    return
                }
                caret.start = caret.end - 1;
                var oldValue = inputValue.substring(0, caret.start) + inputValue.substring(caret.end);
                var char = inputValue[caret.start];
                var editor = this.editor;
                this.editorInput().val(oldValue);
                editor._caret({
                    start: caret.start,
                    end: caret.start
                });
                editor._maskKeyHandler(event, function() {
                    return editor._handleKey(char)
                })
            };
            _proto._backspaceHandler = function(event) {
                var _this = this;
                var editor = this.editor;
                this._keyPressHandled = true;
                var afterBackspaceHandler = function(needAdjustCaret, callBack) {
                    if (needAdjustCaret) {
                        editor._direction(_this.DIRECTION.FORWARD);
                        editor._adjustCaret()
                    }
                    var currentCaret = _this.editorCaret();
                    return new _promise.default(function(resolve) {
                        clearTimeout(_this._backspaceHandlerTimeout);
                        _this._backspaceHandlerTimeout = setTimeout(function() {
                            callBack(currentCaret);
                            resolve()
                        })
                    })
                };
                editor._maskKeyHandler(event, function() {
                    if (editor._hasSelection()) {
                        return afterBackspaceHandler(true, function(currentCaret) {
                            editor._displayMask(currentCaret);
                            editor._maskRulesChain.reset()
                        })
                    }
                    if (editor._tryMoveCaretBackward()) {
                        return afterBackspaceHandler(false, function(currentCaret) {
                            _this.editorCaret(currentCaret)
                        })
                    }
                    editor._handleKey(EMPTY_CHAR, _this.DIRECTION.BACKWARD);
                    return afterBackspaceHandler(true, function(currentCaret) {
                        editor._displayMask(currentCaret);
                        editor._maskRulesChain.reset()
                    })
                })
            };
            _proto._backspaceInputHandled = function(inputType) {
                return inputType === BACKSPACE_INPUT_TYPE && !this._keyPressHandled
            };
            _proto._handleBackspaceInput = function(event) {
                var _this$editorCaret = this.editorCaret(),
                    start = _this$editorCaret.start,
                    end = _this$editorCaret.end;
                this.editorCaret({
                    start: start + 1,
                    end: end + 1
                });
                this._backspaceHandler(event)
            };
            return DefaultMaskStrategy
        }(_uiText_editorMaskStrategy.default);
        var _default = DefaultMaskStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/text_box/ui.text_editor.mask.strategy.input_events.js ***!
      \*******************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiText_editorMaskStrategy = _interopRequireDefault(__webpack_require__( /*! ./ui.text_editor.mask.strategy.base */ 344));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var DELETE_INPUT_TYPE = "deleteContentBackward";
        var InputEventsMaskStrategy = function(_BaseMaskStrategy) {
            _inheritsLoose(InputEventsMaskStrategy, _BaseMaskStrategy);

            function InputEventsMaskStrategy() {
                return _BaseMaskStrategy.apply(this, arguments) || this
            }
            var _proto = InputEventsMaskStrategy.prototype;
            _proto._getStrategyName = function() {
                return "inputEvents"
            };
            _proto.getHandleEventNames = function() {
                return [].concat(_toConsumableArray(_BaseMaskStrategy.prototype.getHandleEventNames.call(this)), ["beforeInput"])
            };
            _proto._beforeInputHandler = function() {
                this._prevCaret = this.editorCaret()
            };
            _proto._inputHandler = function(_ref) {
                var originalEvent = _ref.originalEvent;
                if (!originalEvent) {
                    return
                }
                var inputType = originalEvent.inputType,
                    data = originalEvent.data;
                var currentCaret = this.editorCaret();
                if (inputType === DELETE_INPUT_TYPE) {
                    var length = this._prevCaret.end - this._prevCaret.start || 1;
                    this.editor.setBackwardDirection();
                    this._updateEditorMask({
                        start: currentCaret.start,
                        length: length,
                        text: this._getEmptyString(length)
                    })
                } else {
                    if (!currentCaret.end) {
                        return
                    }
                    this._autoFillHandler(originalEvent);
                    this.editorCaret(currentCaret);
                    var _length = this._prevCaret.end - this._prevCaret.start;
                    var newData = data + (_length ? this._getEmptyString(_length - data.length) : "");
                    this.editor.setForwardDirection();
                    var hasValidChars = this._updateEditorMask({
                        start: this._prevCaret.start,
                        length: _length || newData.length,
                        text: newData
                    });
                    if (!hasValidChars) {
                        this.editorCaret(this._prevCaret)
                    }
                }
            };
            _proto._getEmptyString = function(length) {
                return Array(length + 1).join(" ")
            };
            _proto._updateEditorMask = function(args) {
                var textLength = args.text.length;
                var updatedCharsCount = this.editor._handleChain(args);
                if (this.editor.isForwardDirection()) {
                    var _this$editorCaret = this.editorCaret(),
                        start = _this$editorCaret.start,
                        end = _this$editorCaret.end;
                    var correction = updatedCharsCount - textLength;
                    if (start <= updatedCharsCount && updatedCharsCount > 1) {
                        this.editorCaret({
                            start: start + correction,
                            end: end + correction
                        })
                    }
                    this.editor.isForwardDirection() && this.editor._adjustCaret()
                }
                this.editor._displayMask();
                return !!updatedCharsCount
            };
            return InputEventsMaskStrategy
        }(_uiText_editorMaskStrategy.default);
        var _default = InputEventsMaskStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/list/ui.list.edit.search.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiList = _interopRequireDefault(__webpack_require__( /*! ./ui.list.edit */ 345));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.search_box_mixin */ 274));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ListSearch = _uiList.default.inherit(_ui.default).inherit({
            _addWidgetPrefix: function(className) {
                return "dx-list-" + className
            },
            _getCombinedFilter: function() {
                var filter;
                var storeLoadOptions;
                var dataSource = this._dataSource;
                if (dataSource) {
                    storeLoadOptions = {
                        filter: dataSource.filter()
                    };
                    dataSource._addSearchFilter(storeLoadOptions);
                    filter = storeLoadOptions.filter
                }
                return filter
            },
            _initDataSource: function() {
                var value = this.option("searchValue");
                var expr = this.option("searchExpr");
                var mode = this.option("searchMode");
                this.callBase();
                if (this._dataSource) {
                    value && value.length && this._dataSource.searchValue(value);
                    mode.length && this._dataSource.searchOperation(_ui.default.getOperationBySearchMode(mode));
                    expr && this._dataSource.searchExpr(expr)
                }
            }
        });
        var _default = ListSearch;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/list/ui.list.edit.strategy.grouped.js ***!
      \***************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _store_helper = _interopRequireDefault(__webpack_require__( /*! ../../data/store_helper */ 94));
        var _query = _interopRequireDefault(__webpack_require__( /*! ../../data/query */ 48));
        var _uiCollection_widgetEditStrategy = _interopRequireDefault(__webpack_require__( /*! ../collection/ui.collection_widget.edit.strategy.plain */ 202));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var LIST_ITEM_CLASS = "dx-list-item";
        var LIST_GROUP_CLASS = "dx-list-group";
        var SELECTION_SHIFT = 20;
        var SELECTION_MASK = 2303;
        var combineIndex = function(indices) {
            return (indices.group << SELECTION_SHIFT) + indices.item
        };
        var splitIndex = function(combinedIndex) {
            return {
                group: combinedIndex >> SELECTION_SHIFT,
                item: combinedIndex & SELECTION_MASK
            }
        };
        var GroupedEditStrategy = _uiCollection_widgetEditStrategy.default.inherit({
            _groupElements: function() {
                return this._collectionWidget._itemContainer().find("." + LIST_GROUP_CLASS)
            },
            _groupItemElements: function($group) {
                return $group.find("." + LIST_ITEM_CLASS)
            },
            getIndexByItemData: function(itemData) {
                var groups = this._collectionWidget.option("items");
                var index = false;
                if (!itemData) {
                    return false
                }
                if (itemData.items && itemData.items.length) {
                    itemData = itemData.items[0]
                }(0, _iterator.each)(groups, function(groupIndex, group) {
                    if (!group.items) {
                        return false
                    }(0, _iterator.each)(group.items, function(itemIndex, item) {
                        if (item !== itemData) {
                            return true
                        }
                        index = {
                            group: groupIndex,
                            item: itemIndex
                        };
                        return false
                    });
                    if (index) {
                        return false
                    }
                });
                return index
            },
            getItemDataByIndex: function(index) {
                var items = this._collectionWidget.option("items");
                if ((0, _type.isNumeric)(index)) {
                    return this.itemsGetter()[index]
                }
                return index && items[index.group] && items[index.group].items[index.item] || null
            },
            itemsGetter: function() {
                var resultItems = [];
                var items = this._collectionWidget.option("items");
                for (var i = 0; i < items.length; i++) {
                    if (items[i] && items[i].items) {
                        resultItems = resultItems.concat(items[i].items)
                    } else {
                        resultItems.push(items[i])
                    }
                }
                return resultItems
            },
            deleteItemAtIndex: function(index) {
                var indices = splitIndex(index);
                var itemGroup = this._collectionWidget.option("items")[indices.group].items;
                itemGroup.splice(indices.item, 1)
            },
            getKeysByItems: function(items) {
                var plainItems = [];
                var i;
                for (i = 0; i < items.length; i++) {
                    if (items[i] && items[i].items) {
                        plainItems = plainItems.concat(items[i].items)
                    } else {
                        plainItems.push(items[i])
                    }
                }
                var result = [];
                for (i = 0; i < plainItems.length; i++) {
                    result.push(this._collectionWidget.keyOf(plainItems[i]))
                }
                return result
            },
            getIndexByKey: function(key, items) {
                var groups = items || this._collectionWidget.option("items");
                var index = -1;
                var that = this;
                (0, _iterator.each)(groups, function(groupIndex, group) {
                    if (!group.items) {
                        return
                    }
                    var keys = that.getKeysByItems(group.items);
                    (0, _iterator.each)(keys, function(keyIndex, itemKey) {
                        if (that._equalKeys(itemKey, key)) {
                            index = {
                                group: groupIndex,
                                item: keyIndex
                            };
                            return false
                        }
                    });
                    if (index !== -1) {
                        return false
                    }
                });
                return index
            },
            _getGroups: function(items) {
                var dataSource = this._collectionWidget.getDataSource();
                var group = dataSource && dataSource.group();
                if (group) {
                    return _store_helper.default.queryByOptions((0, _query.default)(items), {
                        group: group
                    }).toArray()
                }
                return this._collectionWidget.option("items")
            },
            getItemsByKeys: function(keys, items) {
                var result = [];
                (0, _iterator.each)(keys, function(_, key) {
                    var getItemMeta = function(groups) {
                        var index = this.getIndexByKey(key, groups);
                        var group = index && groups[index.group];
                        if (!group) {
                            return
                        }
                        return {
                            groupKey: group.key,
                            item: group.items[index.item]
                        }
                    }.bind(this);
                    var itemMeta = getItemMeta(this._getGroups(items));
                    if (!itemMeta) {
                        return
                    }
                    var groupKey = itemMeta.groupKey;
                    var item = itemMeta.item;
                    var selectedGroup;
                    (0, _iterator.each)(result, function(_, item) {
                        if (item.key === groupKey) {
                            selectedGroup = item;
                            return false
                        }
                    });
                    if (!selectedGroup) {
                        selectedGroup = {
                            key: groupKey,
                            items: []
                        };
                        result.push(selectedGroup)
                    }
                    selectedGroup.items.push(item)
                }.bind(this));
                return result
            },
            moveItemAtIndexToIndex: function(movingIndex, destinationIndex) {
                var items = this._collectionWidget.option("items");
                var movingIndices = splitIndex(movingIndex);
                var destinationIndices = splitIndex(destinationIndex);
                var movingItemGroup = items[movingIndices.group].items;
                var destinationItemGroup = items[destinationIndices.group].items;
                var movedItemData = movingItemGroup[movingIndices.item];
                movingItemGroup.splice(movingIndices.item, 1);
                destinationItemGroup.splice(destinationIndices.item, 0, movedItemData)
            },
            _isItemIndex: function(index) {
                return index && (0, _type.isNumeric)(index.group) && (0, _type.isNumeric)(index.item)
            },
            _getNormalizedItemIndex: function(itemElement) {
                var $item = (0, _renderer.default)(itemElement);
                var $group = $item.closest("." + LIST_GROUP_CLASS);
                if (!$group.length) {
                    return -1
                }
                return combineIndex({
                    group: this._groupElements().index($group),
                    item: this._groupItemElements($group).index($item)
                })
            },
            _normalizeItemIndex: function(index) {
                return combineIndex(index)
            },
            _denormalizeItemIndex: function(index) {
                return splitIndex(index)
            },
            _getItemByNormalizedIndex: function(index) {
                var indices = splitIndex(index);
                var $group = this._groupElements().eq(indices.group);
                return this._groupItemElements($group).eq(indices.item)
            },
            _itemsFromSameParent: function(firstIndex, secondIndex) {
                return splitIndex(firstIndex).group === splitIndex(secondIndex).group
            }
        });
        var _default = GroupedEditStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/list/ui.list.edit.provider.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _uiListEdit = __webpack_require__( /*! ./ui.list.edit.decorator_registry */ 115);
        __webpack_require__( /*! ./ui.list.edit.decorator.static */ 596);
        __webpack_require__( /*! ./ui.list.edit.decorator.switchable.button */ 597);
        __webpack_require__( /*! ./ui.list.edit.decorator.switchable.slide */ 598);
        __webpack_require__( /*! ./ui.list.edit.decorator.swipe */ 599);
        __webpack_require__( /*! ./ui.list.edit.decorator.context */ 600);
        __webpack_require__( /*! ./ui.list.edit.decorator.selection */ 606);
        __webpack_require__( /*! ./ui.list.edit.decorator.reorder */ 608);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var editOptionsRegistry = [];
        var registerOption = function(enabledFunc, decoratorTypeFunc, decoratorSubTypeFunc) {
            editOptionsRegistry.push({
                enabled: enabledFunc,
                decoratorType: decoratorTypeFunc,
                decoratorSubType: decoratorSubTypeFunc
            })
        };
        registerOption(function() {
            return this.option("menuItems").length
        }, function() {
            return "menu"
        }, function() {
            return this.option("menuMode")
        });
        registerOption(function() {
            return !this.option("menuItems").length && this.option("allowItemDeleting")
        }, function() {
            var mode = this.option("itemDeleteMode");
            return "toggle" === mode || "slideButton" === mode || "swipe" === mode || "static" === mode ? "delete" : "menu"
        }, function() {
            var mode = this.option("itemDeleteMode");
            if ("slideItem" === mode) {
                mode = "slide"
            }
            if ("hold" === mode) {
                mode = "context"
            }
            return mode
        });
        registerOption(function() {
            return "none" !== this.option("selectionMode") && this.option("showSelectionControls")
        }, function() {
            return "selection"
        }, function() {
            return "default"
        });
        registerOption(function() {
            return this.option("itemDragging.allowReordering") || this.option("itemDragging.allowDropInsideItem") || this.option("itemDragging.group")
        }, function() {
            return "reorder"
        }, function() {
            return "default"
        });
        var LIST_ITEM_BEFORE_BAG_CLASS = "dx-list-item-before-bag";
        var LIST_ITEM_AFTER_BAG_CLASS = "dx-list-item-after-bag";
        var DECORATOR_BEFORE_BAG_CREATE_METHOD = "beforeBag";
        var DECORATOR_AFTER_BAG_CREATE_METHOD = "afterBag";
        var DECORATOR_MODIFY_ELEMENT_METHOD = "modifyElement";
        var DECORATOR_AFTER_RENDER_METHOD = "afterRender";
        var DECORATOR_GET_EXCLUDED_SELECTORS_METHOD = "getExcludedSelectors";
        var EditProvider = _class.default.inherit({
            ctor: function(list) {
                this._list = list;
                this._fetchRequiredDecorators()
            },
            dispose: function() {
                if (this._decorators && this._decorators.length) {
                    (0, _iterator.each)(this._decorators, function(_, decorator) {
                        decorator.dispose()
                    })
                }
            },
            _fetchRequiredDecorators: function() {
                this._decorators = [];
                (0, _iterator.each)(editOptionsRegistry, function(_, option) {
                    var optionEnabled = option.enabled.call(this._list);
                    if (optionEnabled) {
                        var decoratorType = option.decoratorType.call(this._list);
                        var decoratorSubType = option.decoratorSubType.call(this._list);
                        var decorator = this._createDecorator(decoratorType, decoratorSubType);
                        this._decorators.push(decorator)
                    }
                }.bind(this))
            },
            _createDecorator: function(type, subType) {
                var decoratorClass = this._findDecorator(type, subType);
                return new decoratorClass(this._list)
            },
            _findDecorator: function(type, subType) {
                var foundDecorator = _uiListEdit.registry[type][subType];
                if (!foundDecorator) {
                    throw _ui.default.Error("E1012", type, subType)
                }
                return foundDecorator
            },
            modifyItemElement: function(args) {
                var $itemElement = (0, _renderer.default)(args.itemElement);
                var config = {
                    $itemElement: $itemElement
                };
                this._prependBeforeBags($itemElement, config);
                this._appendAfterBags($itemElement, config);
                this._applyDecorators(DECORATOR_MODIFY_ELEMENT_METHOD, config)
            },
            afterItemsRendered: function() {
                this._applyDecorators(DECORATOR_AFTER_RENDER_METHOD)
            },
            _prependBeforeBags: function($itemElement, config) {
                var $beforeBags = this._collectDecoratorsMarkup(DECORATOR_BEFORE_BAG_CREATE_METHOD, config, LIST_ITEM_BEFORE_BAG_CLASS);
                $itemElement.prepend($beforeBags)
            },
            _appendAfterBags: function($itemElement, config) {
                var $afterBags = this._collectDecoratorsMarkup(DECORATOR_AFTER_BAG_CREATE_METHOD, config, LIST_ITEM_AFTER_BAG_CLASS);
                $itemElement.append($afterBags)
            },
            _collectDecoratorsMarkup: function(method, config, containerClass) {
                var $collector = (0, _renderer.default)("<div>");
                (0, _iterator.each)(this._decorators, function() {
                    var $container = (0, _renderer.default)("<div>").addClass(containerClass);
                    this[method]((0, _extend.extend)({
                        $container: $container
                    }, config));
                    if ($container.children().length) {
                        $collector.append($container)
                    }
                });
                return $collector.children()
            },
            _applyDecorators: function(method, config) {
                (0, _iterator.each)(this._decorators, function() {
                    this[method](config)
                })
            },
            _handlerExists: function(name) {
                if (!this._decorators) {
                    return false
                }
                var decorators = this._decorators;
                var length = decorators.length;
                for (var i = 0; i < length; i++) {
                    if (decorators[i][name] !== _common.noop) {
                        return true
                    }
                }
                return false
            },
            _eventHandler: function(name, $itemElement, e) {
                if (!this._decorators) {
                    return false
                }
                var response = false;
                var decorators = this._decorators;
                var length = decorators.length;
                for (var i = 0; i < length; i++) {
                    response = decorators[i][name]($itemElement, e);
                    if (response) {
                        break
                    }
                }
                return response
            },
            handleClick: function($itemElement, e) {
                return this._eventHandler("handleClick", $itemElement, e)
            },
            handleKeyboardEvents: function(currentFocusedIndex, moveFocusUp) {
                return this._eventHandler("handleKeyboardEvents", currentFocusedIndex, moveFocusUp)
            },
            handleEnterPressing: function(e) {
                return this._eventHandler("handleEnterPressing", e)
            },
            contextMenuHandlerExists: function() {
                return this._handlerExists("handleContextMenu")
            },
            handleContextMenu: function($itemElement, e) {
                return this._eventHandler("handleContextMenu", $itemElement, e)
            },
            getExcludedItemSelectors: function() {
                var excludedSelectors = [];
                this._applyDecorators(DECORATOR_GET_EXCLUDED_SELECTORS_METHOD, excludedSelectors);
                return excludedSelectors.join(",")
            }
        });
        var _default = EditProvider;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/list/ui.list.edit.decorator.static.js ***!
      \***************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _button = _interopRequireDefault(__webpack_require__( /*! ../button */ 37));
        var _uiListEdit = __webpack_require__( /*! ./ui.list.edit.decorator_registry */ 115);
        var _uiListEdit2 = _interopRequireDefault(__webpack_require__( /*! ./ui.list.edit.decorator */ 156));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var STATIC_DELETE_BUTTON_CONTAINER_CLASS = "dx-list-static-delete-button-container";
        var STATIC_DELETE_BUTTON_CLASS = "dx-list-static-delete-button";
        (0, _uiListEdit.register)("delete", "static", _uiListEdit2.default.inherit({
            afterBag: function(config) {
                var $itemElement = config.$itemElement;
                var $container = config.$container;
                var $button = (0, _renderer.default)("<div>").addClass(STATIC_DELETE_BUTTON_CLASS);
                this._list._createComponent($button, _button.default, {
                    icon: "remove",
                    onClick: function(args) {
                        args.event.stopPropagation();
                        this._deleteItem($itemElement)
                    }.bind(this),
                    integrationOptions: {}
                });
                $container.addClass(STATIC_DELETE_BUTTON_CONTAINER_CLASS).append($button)
            },
            _deleteItem: function($itemElement) {
                if ($itemElement.is(".dx-state-disabled, .dx-state-disabled *")) {
                    return
                }
                this._list.deleteItem($itemElement)
            }
        }))
    },
    /*!**************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/list/ui.list.edit.decorator.switchable.button.js ***!
      \**************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _fx = _interopRequireDefault(__webpack_require__( /*! ../../animation/fx */ 42));
        var _button = _interopRequireDefault(__webpack_require__( /*! ../button */ 37));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _uiListEdit = __webpack_require__( /*! ./ui.list.edit.decorator_registry */ 115);
        var _uiListEditDecorator = _interopRequireDefault(__webpack_require__( /*! ./ui.list.edit.decorator.switchable */ 346));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var SWITCHABLE_DELETE_BUTTON_CONTAINER_CLASS = "dx-list-switchable-delete-button-container";
        var SWITCHABLE_DELETE_BUTTON_WRAPPER_CLASS = "dx-list-switchable-delete-button-wrapper";
        var SWITCHABLE_DELETE_BUTTON_INNER_WRAPPER_CLASS = "dx-list-switchable-delete-button-inner-wrapper";
        var SWITCHABLE_DELETE_BUTTON_CLASS = "dx-list-switchable-delete-button";
        var SWITCHABLE_DELETE_BUTTON_ANIMATION_DURATION = 200;
        var SwitchableButtonEditDecorator = _uiListEditDecorator.default.inherit({
            _init: function() {
                this.callBase.apply(this, arguments);
                var $buttonContainer = (0, _renderer.default)("<div>").addClass(SWITCHABLE_DELETE_BUTTON_CONTAINER_CLASS);
                var $buttonWrapper = (0, _renderer.default)("<div>").addClass(SWITCHABLE_DELETE_BUTTON_WRAPPER_CLASS);
                var $buttonInnerWrapper = (0, _renderer.default)("<div>").addClass(SWITCHABLE_DELETE_BUTTON_INNER_WRAPPER_CLASS);
                var $button = (0, _renderer.default)("<div>").addClass(SWITCHABLE_DELETE_BUTTON_CLASS);
                this._list._createComponent($button, _button.default, {
                    text: _message.default.format("dxListEditDecorator-delete"),
                    type: "danger",
                    onClick: function(e) {
                        this._deleteItem();
                        e.event.stopPropagation()
                    }.bind(this),
                    integrationOptions: {}
                });
                $buttonContainer.append($buttonWrapper);
                $buttonWrapper.append($buttonInnerWrapper);
                $buttonInnerWrapper.append($button);
                this._$buttonContainer = $buttonContainer
            },
            _enablePositioning: function($itemElement) {
                this.callBase.apply(this, arguments);
                _fx.default.stop(this._$buttonContainer, true);
                this._$buttonContainer.appendTo($itemElement)
            },
            _disablePositioning: function() {
                this.callBase.apply(this, arguments);
                this._$buttonContainer.detach()
            },
            _animatePrepareDeleteReady: function() {
                var rtl = this._isRtlEnabled();
                var listWidth = this._list.$element().width();
                var buttonWidth = this._buttonWidth();
                var fromValue = rtl ? listWidth : -buttonWidth;
                var toValue = rtl ? listWidth - buttonWidth : 0;
                return _fx.default.animate(this._$buttonContainer, {
                    type: "custom",
                    duration: SWITCHABLE_DELETE_BUTTON_ANIMATION_DURATION,
                    from: {
                        right: fromValue
                    },
                    to: {
                        right: toValue
                    }
                })
            },
            _animateForgetDeleteReady: function() {
                var rtl = this._isRtlEnabled();
                var listWidth = this._list.$element().width();
                var buttonWidth = this._buttonWidth();
                var fromValue = rtl ? listWidth - buttonWidth : 0;
                var toValue = rtl ? listWidth : -buttonWidth;
                return _fx.default.animate(this._$buttonContainer, {
                    type: "custom",
                    duration: SWITCHABLE_DELETE_BUTTON_ANIMATION_DURATION,
                    from: {
                        right: fromValue
                    },
                    to: {
                        right: toValue
                    }
                })
            },
            _buttonWidth: function() {
                if (!this._buttonContainerWidth) {
                    this._buttonContainerWidth = this._$buttonContainer.outerWidth()
                }
                return this._buttonContainerWidth
            },
            dispose: function() {
                if (this._$buttonContainer) {
                    this._$buttonContainer.remove()
                }
                this.callBase.apply(this, arguments)
            }
        });
        var TOGGLE_DELETE_SWITCH_CONTAINER_CLASS = "dx-list-toggle-delete-switch-container";
        var TOGGLE_DELETE_SWITCH_CLASS = "dx-list-toggle-delete-switch";
        (0, _uiListEdit.register)("delete", "toggle", SwitchableButtonEditDecorator.inherit({
            beforeBag: function(config) {
                var $itemElement = config.$itemElement;
                var $container = config.$container;
                var $toggle = (0, _renderer.default)("<div>").addClass(TOGGLE_DELETE_SWITCH_CLASS);
                this._list._createComponent($toggle, _button.default, {
                    icon: "toggle-delete",
                    onClick: function(e) {
                        _fx.default.stop(this._$buttonContainer, false);
                        this._toggleDeleteReady($itemElement);
                        e.event.stopPropagation()
                    }.bind(this),
                    integrationOptions: {}
                });
                $container.addClass(TOGGLE_DELETE_SWITCH_CONTAINER_CLASS);
                $container.append($toggle)
            }
        }));
        (0, _uiListEdit.register)("delete", "slideButton", SwitchableButtonEditDecorator.inherit({
            _shouldHandleSwipe: true,
            _swipeEndHandler: function($itemElement, args) {
                if (0 !== args.targetOffset) {
                    _fx.default.stop(this._$buttonContainer, false);
                    this._toggleDeleteReady($itemElement)
                }
                return true
            }
        }));
        var _default = SwitchableButtonEditDecorator;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/list/ui.list.edit.decorator.switchable.slide.js ***!
      \*************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _click = __webpack_require__( /*! ../../events/click */ 21);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _translator = __webpack_require__( /*! ../../animation/translator */ 28);
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _emitter = __webpack_require__( /*! ../../events/core/emitter.feedback */ 149);
        var _uiListEdit = _interopRequireDefault(__webpack_require__( /*! ./ui.list.edit.decorator_menu_helper */ 347));
        var _uiListEdit2 = __webpack_require__( /*! ./ui.list.edit.decorator_registry */ 115);
        var _uiListEditDecorator = _interopRequireDefault(__webpack_require__( /*! ./ui.list.edit.decorator.switchable */ 346));
        var _fx = _interopRequireDefault(__webpack_require__( /*! ../../animation/fx */ 42));
        var _themes = __webpack_require__( /*! ../themes */ 34);
        var _action_sheet = _interopRequireDefault(__webpack_require__( /*! ../action_sheet */ 268));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var LIST_EDIT_DECORATOR = "dxListEditDecorator";
        var CLICK_EVENT_NAME = (0, _index.addNamespace)(_click.name, LIST_EDIT_DECORATOR);
        var ACTIVE_EVENT_NAME = (0, _index.addNamespace)(_emitter.active, LIST_EDIT_DECORATOR);
        var SLIDE_MENU_CLASS = "dx-list-slide-menu";
        var SLIDE_MENU_WRAPPER_CLASS = "dx-list-slide-menu-wrapper";
        var SLIDE_MENU_CONTENT_CLASS = "dx-list-slide-menu-content";
        var SLIDE_MENU_BUTTONS_CONTAINER_CLASS = "dx-list-slide-menu-buttons-container";
        var SLIDE_MENU_BUTTONS_CLASS = "dx-list-slide-menu-buttons";
        var SLIDE_MENU_BUTTON_CLASS = "dx-list-slide-menu-button";
        var SLIDE_MENU_BUTTON_MENU_CLASS = "dx-list-slide-menu-button-menu";
        var SLIDE_MENU_BUTTON_DELETE_CLASS = "dx-list-slide-menu-button-delete";
        var SLIDE_MENU_ANIMATION_DURATION = 400;
        var SLIDE_MENU_ANIMATION_EASING = "cubic-bezier(0.075, 0.82, 0.165, 1)";
        (0, _uiListEdit2.register)("menu", "slide", _uiListEditDecorator.default.inherit({
            _shouldHandleSwipe: true,
            _init: function() {
                this.callBase.apply(this, arguments);
                this._$buttonsContainer = (0, _renderer.default)("<div>").addClass(SLIDE_MENU_BUTTONS_CONTAINER_CLASS);
                _events_engine.default.on(this._$buttonsContainer, ACTIVE_EVENT_NAME, _common.noop);
                this._$buttons = (0, _renderer.default)("<div>").addClass(SLIDE_MENU_BUTTONS_CLASS).appendTo(this._$buttonsContainer);
                this._renderMenu();
                this._renderDeleteButton()
            },
            _renderMenu: function() {
                if (!this._menuEnabled()) {
                    return
                }
                var menuItems = this._menuItems();
                if (1 === menuItems.length) {
                    var menuItem = menuItems[0];
                    this._renderMenuButton(menuItem.text, function(e) {
                        e.stopPropagation();
                        this._fireAction(menuItem)
                    }.bind(this))
                } else {
                    var $menu = (0, _renderer.default)("<div>").addClass(SLIDE_MENU_CLASS);
                    this._menu = this._list._createComponent($menu, _action_sheet.default, {
                        showTitle: false,
                        items: menuItems,
                        onItemClick: function(args) {
                            this._fireAction(args.itemData)
                        }.bind(this),
                        integrationOptions: {}
                    });
                    $menu.appendTo(this._list.$element());
                    var $menuButton = this._renderMenuButton(_message.default.format("dxListEditDecorator-more"), function(e) {
                        e.stopPropagation();
                        this._menu.show()
                    }.bind(this));
                    this._menu.option("target", $menuButton)
                }
            },
            _renderMenuButton: function(text, action) {
                var $menuButton = (0, _renderer.default)("<div>").addClass(SLIDE_MENU_BUTTON_CLASS).addClass(SLIDE_MENU_BUTTON_MENU_CLASS).text(text);
                this._$buttons.append($menuButton);
                _events_engine.default.on($menuButton, CLICK_EVENT_NAME, action);
                return $menuButton
            },
            _renderDeleteButton: function() {
                if (!this._deleteEnabled()) {
                    return
                }
                var $deleteButton = (0, _renderer.default)("<div>").addClass(SLIDE_MENU_BUTTON_CLASS).addClass(SLIDE_MENU_BUTTON_DELETE_CLASS).text((0, _themes.isMaterial)() ? "" : _message.default.format("dxListEditDecorator-delete"));
                _events_engine.default.on($deleteButton, CLICK_EVENT_NAME, function(e) {
                    e.stopPropagation();
                    this._deleteItem()
                }.bind(this));
                this._$buttons.append($deleteButton)
            },
            _fireAction: function(menuItem) {
                this._fireMenuAction((0, _renderer.default)(this._cachedNode), menuItem.action);
                this._cancelDeleteReadyItem()
            },
            modifyElement: function(config) {
                this.callBase.apply(this, arguments);
                var $itemElement = config.$itemElement;
                $itemElement.addClass(SLIDE_MENU_WRAPPER_CLASS);
                var $slideMenuContent = (0, _renderer.default)("<div>").addClass(SLIDE_MENU_CONTENT_CLASS);
                $itemElement.wrapInner($slideMenuContent)
            },
            _getDeleteButtonContainer: function() {
                return this._$buttonsContainer
            },
            handleClick: function(_, e) {
                if ((0, _renderer.default)(e.target).closest("." + SLIDE_MENU_CONTENT_CLASS).length) {
                    return this.callBase.apply(this, arguments)
                }
                return false
            },
            _swipeStartHandler: function($itemElement) {
                this._enablePositioning($itemElement);
                this._cacheItemData($itemElement);
                this._setPositions(this._getPositions(0))
            },
            _swipeUpdateHandler: function($itemElement, args) {
                var rtl = this._isRtlEnabled();
                var signCorrection = rtl ? -1 : 1;
                var isItemReadyToDelete = this._isReadyToDelete($itemElement);
                var moveJustStarted = this._getCurrentPositions().content === this._getStartPositions().content;
                if (moveJustStarted && !isItemReadyToDelete && args.offset * signCorrection > 0) {
                    args.cancel = true;
                    return
                }
                var offset = this._cachedItemWidth * args.offset;
                var startOffset = isItemReadyToDelete ? -this._cachedButtonWidth * signCorrection : 0;
                var correctedOffset = (offset + startOffset) * signCorrection;
                var percent = correctedOffset < 0 ? Math.abs((offset + startOffset) / this._cachedButtonWidth) : 0;
                this._setPositions(this._getPositions(percent));
                return true
            },
            _getStartPositions: function() {
                var rtl = this._isRtlEnabled();
                var signCorrection = rtl ? -1 : 1;
                return {
                    content: 0,
                    buttonsContainer: rtl ? -this._cachedButtonWidth : this._cachedItemWidth,
                    buttons: -this._cachedButtonWidth * signCorrection
                }
            },
            _getPositions: function(percent) {
                var rtl = this._isRtlEnabled();
                var signCorrection = rtl ? -1 : 1;
                var startPositions = this._getStartPositions();
                return {
                    content: startPositions.content - percent * this._cachedButtonWidth * signCorrection,
                    buttonsContainer: startPositions.buttonsContainer - Math.min(percent, 1) * this._cachedButtonWidth * signCorrection,
                    buttons: startPositions.buttons + Math.min(percent, 1) * this._cachedButtonWidth * signCorrection
                }
            },
            _getCurrentPositions: function() {
                return {
                    content: (0, _translator.locate)(this._$cachedContent).left,
                    buttonsContainer: (0, _translator.locate)(this._$buttonsContainer).left,
                    buttons: (0, _translator.locate)(this._$buttons).left
                }
            },
            _setPositions: function(positions) {
                (0, _translator.move)(this._$cachedContent, {
                    left: positions.content
                });
                (0, _translator.move)(this._$buttonsContainer, {
                    left: positions.buttonsContainer
                });
                (0, _translator.move)(this._$buttons, {
                    left: positions.buttons
                })
            },
            _cacheItemData: function($itemElement) {
                if ($itemElement[0] === this._cachedNode) {
                    return
                }
                this._$cachedContent = $itemElement.find("." + SLIDE_MENU_CONTENT_CLASS);
                this._cachedItemWidth = $itemElement.outerWidth();
                this._cachedButtonWidth = this._cachedButtonWidth || this._$buttons.outerWidth();
                this._$buttonsContainer.width(this._cachedButtonWidth);
                if (this._$cachedContent.length) {
                    this._cachedNode = $itemElement[0]
                }
            },
            _minButtonContainerLeftOffset: function() {
                return this._cachedItemWidth - this._cachedButtonWidth
            },
            _swipeEndHandler: function($itemElement, args) {
                this._cacheItemData($itemElement);
                var signCorrection = this._isRtlEnabled() ? 1 : -1;
                var offset = this._cachedItemWidth * args.offset;
                var endedAtReadyToDelete = !this._isReadyToDelete($itemElement) && offset * signCorrection > .2 * this._cachedButtonWidth;
                var readyToDelete = args.targetOffset === signCorrection && endedAtReadyToDelete;
                this._toggleDeleteReady($itemElement, readyToDelete);
                return true
            },
            _enablePositioning: function($itemElement) {
                _fx.default.stop(this._$cachedContent, true);
                this.callBase.apply(this, arguments);
                this._$buttonsContainer.appendTo($itemElement)
            },
            _disablePositioning: function() {
                this.callBase.apply(this, arguments);
                this._$buttonsContainer.detach()
            },
            _animatePrepareDeleteReady: function() {
                return this._animateToPositions(this._getPositions(1))
            },
            _animateForgetDeleteReady: function($itemElement) {
                this._cacheItemData($itemElement);
                return this._animateToPositions(this._getPositions(0))
            },
            _animateToPositions: function(positions) {
                var that = this;
                var currentPosition = this._getCurrentPositions();
                var durationTimePart = Math.min(Math.abs(currentPosition.content - positions.content) / this._cachedButtonWidth, 1);
                return _fx.default.animate(this._$cachedContent, {
                    from: currentPosition,
                    to: positions,
                    easing: SLIDE_MENU_ANIMATION_EASING,
                    duration: SLIDE_MENU_ANIMATION_DURATION * durationTimePart,
                    strategy: "frame",
                    draw: function(positions) {
                        that._setPositions(positions)
                    }
                })
            },
            dispose: function() {
                if (this._menu) {
                    this._menu.$element().remove()
                }
                if (this._$buttonsContainer) {
                    this._$buttonsContainer.remove()
                }
                this.callBase.apply(this, arguments)
            }
        }).include(_uiListEdit.default))
    },
    /*!**************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/list/ui.list.edit.decorator.swipe.js ***!
      \**************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _translator = __webpack_require__( /*! ../../animation/translator */ 28);
        var _fx = _interopRequireDefault(__webpack_require__( /*! ../../animation/fx */ 42));
        var _uiListEdit = __webpack_require__( /*! ./ui.list.edit.decorator_registry */ 115);
        var _uiListEdit2 = _interopRequireDefault(__webpack_require__( /*! ./ui.list.edit.decorator */ 156));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }(0, _uiListEdit.register)("delete", "swipe", _uiListEdit2.default.inherit({
            _shouldHandleSwipe: true,
            _renderItemPosition: function($itemElement, offset, animate) {
                var deferred = new _deferred.Deferred;
                var itemOffset = offset * this._itemElementWidth;
                if (animate) {
                    _fx.default.animate($itemElement, {
                        to: {
                            left: itemOffset
                        },
                        type: "slide",
                        complete: function() {
                            deferred.resolve($itemElement, offset)
                        }
                    })
                } else {
                    (0, _translator.move)($itemElement, {
                        left: itemOffset
                    });
                    deferred.resolve()
                }
                return deferred.promise()
            },
            _swipeStartHandler: function($itemElement) {
                this._itemElementWidth = $itemElement.width();
                return true
            },
            _swipeUpdateHandler: function($itemElement, args) {
                this._renderItemPosition($itemElement, args.offset);
                return true
            },
            _swipeEndHandler: function($itemElement, args) {
                var offset = args.targetOffset;
                this._renderItemPosition($itemElement, offset, true).done(function($itemElement, offset) {
                    if (Math.abs(offset)) {
                        this._list.deleteItem($itemElement).fail(function() {
                            this._renderItemPosition($itemElement, 0, true)
                        }.bind(this))
                    }
                }.bind(this));
                return true
            }
        }))
    },
    /*!****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/list/ui.list.edit.decorator.context.js ***!
      \****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _uiListEdit = _interopRequireDefault(__webpack_require__( /*! ./ui.list.edit.decorator_menu_helper */ 347));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _uiListEdit2 = __webpack_require__( /*! ./ui.list.edit.decorator_registry */ 115);
        var _uiListEdit3 = _interopRequireDefault(__webpack_require__( /*! ./ui.list.edit.decorator */ 156));
        var _overlay = _interopRequireDefault(__webpack_require__( /*! ../overlay */ 64));
        var _uiList = __webpack_require__( /*! ./ui.list.base */ 270);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var CONTEXTMENU_CLASS = "dx-list-context-menu";
        var CONTEXTMENU_MENUCONTENT_CLASS = "dx-list-context-menucontent";
        (0, _uiListEdit2.register)("menu", "context", _uiListEdit3.default.inherit({
            _init: function() {
                var $menu = (0, _renderer.default)("<div>").addClass(CONTEXTMENU_CLASS);
                this._list.$element().append($menu);
                this._menu = this._renderOverlay($menu)
            },
            _renderOverlay: function($element) {
                return this._list._createComponent($element, _overlay.default, {
                    shading: false,
                    deferRendering: true,
                    closeOnTargetScroll: true,
                    closeOnOutsideClick: function(e) {
                        return !(0, _renderer.default)(e.target).closest("." + CONTEXTMENU_CLASS).length
                    },
                    animation: {
                        show: {
                            type: "slide",
                            duration: 300,
                            from: {
                                height: 0,
                                opacity: 1
                            },
                            to: {
                                height: function() {
                                    return this._$menuList.outerHeight()
                                }.bind(this),
                                opacity: 1
                            }
                        },
                        hide: {
                            type: "slide",
                            duration: 0,
                            from: {
                                opacity: 1
                            },
                            to: {
                                opacity: 0
                            }
                        }
                    },
                    height: function() {
                        return this._$menuList ? this._$menuList.outerHeight() : 0
                    }.bind(this),
                    width: function() {
                        return this._list.$element().outerWidth()
                    }.bind(this),
                    onContentReady: this._renderMenuContent.bind(this)
                })
            },
            _renderMenuContent: function(e) {
                var $overlayContent = e.component.$content();
                var items = this._menuItems().slice();
                if (this._deleteEnabled()) {
                    items.push({
                        text: _message.default.format("dxListEditDecorator-delete"),
                        action: this._deleteItem.bind(this)
                    })
                }
                this._$menuList = (0, _renderer.default)("<div>");
                this._list._createComponent(this._$menuList, _uiList.ListBase, {
                    items: items,
                    onItemClick: this._menuItemClickHandler.bind(this),
                    height: "auto",
                    integrationOptions: {}
                });
                $overlayContent.addClass(CONTEXTMENU_MENUCONTENT_CLASS);
                $overlayContent.append(this._$menuList)
            },
            _menuItemClickHandler: function(args) {
                this._menu.hide();
                this._fireMenuAction(this._$itemWithMenu, args.itemData.action)
            },
            _deleteItem: function() {
                this._list.deleteItem(this._$itemWithMenu)
            },
            handleContextMenu: function($itemElement) {
                this._$itemWithMenu = $itemElement;
                this._menu.option({
                    position: {
                        my: "top",
                        at: "bottom",
                        of: $itemElement,
                        collision: "flip"
                    }
                });
                this._menu.show();
                return true
            },
            dispose: function() {
                if (this._menu) {
                    this._menu.$element().remove()
                }
                this.callBase.apply(this, arguments)
            }
        }).include(_uiListEdit.default))
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/list/item.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _item = _interopRequireDefault(__webpack_require__( /*! ../collection/item */ 150));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var LIST_ITEM_BADGE_CONTAINER_CLASS = "dx-list-item-badge-container";
        var LIST_ITEM_BADGE_CLASS = "dx-list-item-badge";
        var BADGE_CLASS = "dx-badge";
        var LIST_ITEM_CHEVRON_CONTAINER_CLASS = "dx-list-item-chevron-container";
        var LIST_ITEM_CHEVRON_CLASS = "dx-list-item-chevron";
        var ListItem = _item.default.inherit({
            _renderWatchers: function() {
                this.callBase();
                this._startWatcher("badge", this._renderBadge.bind(this));
                this._startWatcher("showChevron", this._renderShowChevron.bind(this))
            },
            _renderBadge: function(badge) {
                this._$element.children("." + LIST_ITEM_BADGE_CONTAINER_CLASS).remove();
                if (!badge) {
                    return
                }
                var $badge = (0, _renderer.default)("<div>").addClass(LIST_ITEM_BADGE_CONTAINER_CLASS).append((0, _renderer.default)("<div>").addClass(LIST_ITEM_BADGE_CLASS).addClass(BADGE_CLASS).text(badge));
                var $chevron = this._$element.children("." + LIST_ITEM_CHEVRON_CONTAINER_CLASS).first();
                $chevron.length > 0 ? $badge.insertBefore($chevron) : $badge.appendTo(this._$element)
            },
            _renderShowChevron: function(showChevron) {
                this._$element.children("." + LIST_ITEM_CHEVRON_CONTAINER_CLASS).remove();
                if (!showChevron) {
                    return
                }
                var $chevronContainer = (0, _renderer.default)("<div>").addClass(LIST_ITEM_CHEVRON_CONTAINER_CLASS);
                var $chevron = (0, _renderer.default)("<div>").addClass(LIST_ITEM_CHEVRON_CLASS);
                $chevronContainer.append($chevron).appendTo(this._$element)
            }
        });
        var _default = ListItem;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scroll_view/ui.scroll_view.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _element = __webpack_require__( /*! ../../core/element */ 18);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _uiScroll_viewNative = _interopRequireDefault(__webpack_require__( /*! ./ui.scroll_view.native.pull_down */ 603));
        var _uiScroll_viewNative2 = _interopRequireDefault(__webpack_require__( /*! ./ui.scroll_view.native.swipe_down */ 604));
        var _uiScroll_view = _interopRequireDefault(__webpack_require__( /*! ./ui.scroll_view.simulated */ 605));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./ui.scrollable */ 106));
        var _load_indicator = _interopRequireDefault(__webpack_require__( /*! ../load_indicator */ 83));
        var _themes = __webpack_require__( /*! ./../themes */ 34);
        var _load_panel = _interopRequireDefault(__webpack_require__( /*! ../load_panel */ 180));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var SCROLLVIEW_CLASS = "dx-scrollview";
        var SCROLLVIEW_CONTENT_CLASS = SCROLLVIEW_CLASS + "-content";
        var SCROLLVIEW_TOP_POCKET_CLASS = SCROLLVIEW_CLASS + "-top-pocket";
        var SCROLLVIEW_BOTTOM_POCKET_CLASS = SCROLLVIEW_CLASS + "-bottom-pocket";
        var SCROLLVIEW_PULLDOWN_CLASS = SCROLLVIEW_CLASS + "-pull-down";
        var SCROLLVIEW_REACHBOTTOM_CLASS = SCROLLVIEW_CLASS + "-scrollbottom";
        var SCROLLVIEW_REACHBOTTOM_INDICATOR_CLASS = SCROLLVIEW_REACHBOTTOM_CLASS + "-indicator";
        var SCROLLVIEW_REACHBOTTOM_TEXT_CLASS = SCROLLVIEW_REACHBOTTOM_CLASS + "-text";
        var SCROLLVIEW_LOADPANEL = SCROLLVIEW_CLASS + "-loadpanel";
        var refreshStrategies = {
            pullDown: _uiScroll_viewNative.default,
            swipeDown: _uiScroll_viewNative2.default,
            simulated: _uiScroll_view.default
        };
        var isServerSide = !(0, _window.hasWindow)();
        var scrollViewServerConfig = {
            finishLoading: _common.noop,
            release: _common.noop,
            refresh: _common.noop,
            _optionChanged: function(args) {
                if ("onUpdated" !== args.name) {
                    return this.callBase.apply(this, arguments)
                }
            }
        };
        var ScrollView = _ui.default.inherit(isServerSide ? scrollViewServerConfig : {
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    pullingDownText: _message.default.format("dxScrollView-pullingDownText"),
                    pulledDownText: _message.default.format("dxScrollView-pulledDownText"),
                    refreshingText: _message.default.format("dxScrollView-refreshingText"),
                    reachBottomText: _message.default.format("dxScrollView-reachBottomText"),
                    onPullDown: null,
                    onReachBottom: null,
                    refreshStrategy: "pullDown"
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: function() {
                        var realDevice = _devices.default.real();
                        return "android" === realDevice.platform
                    },
                    options: {
                        refreshStrategy: "swipeDown"
                    }
                }, {
                    device: function() {
                        return (0, _themes.isMaterial)()
                    },
                    options: {
                        pullingDownText: "",
                        pulledDownText: "",
                        refreshingText: "",
                        reachBottomText: ""
                    }
                }])
            },
            _init: function() {
                this.callBase();
                this._loadingIndicatorEnabled = true
            },
            _initScrollableMarkup: function() {
                this.callBase();
                this.$element().addClass(SCROLLVIEW_CLASS);
                this._initContent();
                this._initTopPocket();
                this._initBottomPocket();
                this._initLoadPanel()
            },
            _initContent: function() {
                var $content = (0, _renderer.default)("<div>").addClass(SCROLLVIEW_CONTENT_CLASS);
                this._$content.wrapInner($content)
            },
            _initTopPocket: function() {
                var $topPocket = this._$topPocket = (0, _renderer.default)("<div>").addClass(SCROLLVIEW_TOP_POCKET_CLASS);
                var $pullDown = this._$pullDown = (0, _renderer.default)("<div>").addClass(SCROLLVIEW_PULLDOWN_CLASS);
                $topPocket.append($pullDown);
                this._$content.prepend($topPocket)
            },
            _initBottomPocket: function() {
                var $bottomPocket = this._$bottomPocket = (0, _renderer.default)("<div>").addClass(SCROLLVIEW_BOTTOM_POCKET_CLASS);
                var $reachBottom = this._$reachBottom = (0, _renderer.default)("<div>").addClass(SCROLLVIEW_REACHBOTTOM_CLASS);
                var $loadContainer = (0, _renderer.default)("<div>").addClass(SCROLLVIEW_REACHBOTTOM_INDICATOR_CLASS);
                var $loadIndicator = new _load_indicator.default((0, _renderer.default)("<div>")).$element();
                var $text = this._$reachBottomText = (0, _renderer.default)("<div>").addClass(SCROLLVIEW_REACHBOTTOM_TEXT_CLASS);
                this._updateReachBottomText();
                $reachBottom.append($loadContainer.append($loadIndicator)).append($text);
                $bottomPocket.append($reachBottom);
                this._$content.append($bottomPocket)
            },
            _initLoadPanel: function() {
                var $loadPanelElement = (0, _renderer.default)("<div>").addClass(SCROLLVIEW_LOADPANEL).appendTo(this.$element());
                var loadPanelOptions = {
                    shading: false,
                    delay: 400,
                    message: this.option("refreshingText"),
                    position: {
                        of: this.$element()
                    }
                };
                this._loadPanel = this._createComponent($loadPanelElement, _load_panel.default, loadPanelOptions)
            },
            _updateReachBottomText: function() {
                this._$reachBottomText.text(this.option("reachBottomText"))
            },
            _createStrategy: function() {
                var strategyName = this.option("useNative") ? this.option("refreshStrategy") : "simulated";
                var strategyClass = refreshStrategies[strategyName];
                if (!strategyClass) {
                    throw Error("E1030", this.option("refreshStrategy"))
                }
                this._strategy = new strategyClass(this);
                this._strategy.pullDownCallbacks.add(this._pullDownHandler.bind(this));
                this._strategy.releaseCallbacks.add(this._releaseHandler.bind(this));
                this._strategy.reachBottomCallbacks.add(this._reachBottomHandler.bind(this))
            },
            _createActions: function() {
                this.callBase();
                this._pullDownAction = this._createActionByOption("onPullDown");
                this._reachBottomAction = this._createActionByOption("onReachBottom");
                this._tryRefreshPocketState()
            },
            _tryRefreshPocketState: function() {
                this._pullDownEnable(this.hasActionSubscription("onPullDown"));
                this._reachBottomEnable(this.hasActionSubscription("onReachBottom"))
            },
            on: function(eventName) {
                var result = this.callBase.apply(this, arguments);
                if ("pullDown" === eventName || "reachBottom" === eventName) {
                    this._tryRefreshPocketState()
                }
                return result
            },
            _pullDownEnable: function(enabled) {
                if (0 === arguments.length) {
                    return this._pullDownEnabled
                }
                if (this._$pullDown && this._strategy) {
                    this._$pullDown.toggle(enabled);
                    this._strategy.pullDownEnable(enabled);
                    this._pullDownEnabled = enabled
                }
            },
            _reachBottomEnable: function(enabled) {
                if (0 === arguments.length) {
                    return this._reachBottomEnabled
                }
                if (this._$reachBottom && this._strategy) {
                    this._$reachBottom.toggle(enabled);
                    this._strategy.reachBottomEnable(enabled);
                    this._reachBottomEnabled = enabled
                }
            },
            _pullDownHandler: function() {
                this._loadingIndicator(false);
                this._pullDownLoading()
            },
            _loadingIndicator: function(value) {
                if (arguments.length < 1) {
                    return this._loadingIndicatorEnabled
                }
                this._loadingIndicatorEnabled = value
            },
            _pullDownLoading: function() {
                this.startLoading();
                this._pullDownAction()
            },
            _reachBottomHandler: function() {
                this._loadingIndicator(false);
                this._reachBottomLoading()
            },
            _reachBottomLoading: function() {
                this.startLoading();
                this._reachBottomAction()
            },
            _releaseHandler: function() {
                this.finishLoading();
                this._loadingIndicator(true)
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "onPullDown":
                    case "onReachBottom":
                        this._createActions();
                        break;
                    case "pullingDownText":
                    case "pulledDownText":
                    case "refreshingText":
                    case "refreshStrategy":
                        this._invalidate();
                        break;
                    case "reachBottomText":
                        this._updateReachBottomText();
                        break;
                    default:
                        this.callBase(args)
                }
            },
            isEmpty: function() {
                return !(0, _renderer.default)(this.content()).children().length
            },
            content: function() {
                return (0, _element.getPublicElement)(this._$content.children().eq(1))
            },
            release: function(preventReachBottom) {
                if (void 0 !== preventReachBottom) {
                    this.toggleLoading(!preventReachBottom)
                }
                return this._strategy.release()
            },
            toggleLoading: function(showOrHide) {
                this._reachBottomEnable(showOrHide)
            },
            isFull: function() {
                return (0, _renderer.default)(this.content()).height() > this._$container.height()
            },
            refresh: function() {
                if (!this.hasActionSubscription("onPullDown")) {
                    return
                }
                this._strategy.pendingRelease();
                this._pullDownLoading()
            },
            startLoading: function() {
                if (this._loadingIndicator() && this.$element().is(":visible")) {
                    this._loadPanel.show()
                }
                this._lock()
            },
            finishLoading: function() {
                this._loadPanel.hide();
                this._unlock()
            },
            _dispose: function() {
                this._strategy.dispose();
                this.callBase();
                if (this._loadPanel) {
                    this._loadPanel.$element().remove()
                }
            }
        });
        (0, _component_registrator.default)("dxScrollView", ScrollView);
        var _default = ScrollView;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scroll_view/ui.scroll_view.native.pull_down.js ***!
      \************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/callbacks */ 27));
        var _translator = __webpack_require__( /*! ../../animation/translator */ 28);
        var _uiScrollable = _interopRequireDefault(__webpack_require__( /*! ./ui.scrollable.native */ 271));
        var _load_indicator = _interopRequireDefault(__webpack_require__( /*! ../load_indicator */ 83));
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var SCROLLVIEW_PULLDOWN_REFRESHING_CLASS = "dx-scrollview-pull-down-loading";
        var SCROLLVIEW_PULLDOWN_READY_CLASS = "dx-scrollview-pull-down-ready";
        var SCROLLVIEW_PULLDOWN_IMAGE_CLASS = "dx-scrollview-pull-down-image";
        var SCROLLVIEW_PULLDOWN_INDICATOR_CLASS = "dx-scrollview-pull-down-indicator";
        var SCROLLVIEW_PULLDOWN_TEXT_CLASS = "dx-scrollview-pull-down-text";
        var SCROLLVIEW_PULLDOWN_VISIBLE_TEXT_CLASS = "dx-scrollview-pull-down-text-visible";
        var STATE_RELEASED = 0;
        var STATE_READY = 1;
        var STATE_REFRESHING = 2;
        var STATE_LOADING = 3;
        var PULLDOWN_RELEASE_TIME = 400;
        var PullDownNativeScrollViewStrategy = _uiScrollable.default.inherit({
            _init: function(scrollView) {
                this.callBase(scrollView);
                this._$topPocket = scrollView._$topPocket;
                this._$pullDown = scrollView._$pullDown;
                this._$bottomPocket = scrollView._$bottomPocket;
                this._$refreshingText = scrollView._$refreshingText;
                this._$scrollViewContent = (0, _renderer.default)(scrollView.content());
                this._initCallbacks()
            },
            _initCallbacks: function() {
                this.pullDownCallbacks = (0, _callbacks.default)();
                this.releaseCallbacks = (0, _callbacks.default)();
                this.reachBottomCallbacks = (0, _callbacks.default)()
            },
            render: function() {
                this.callBase();
                this._renderPullDown();
                this._releaseState()
            },
            _renderPullDown: function() {
                var $image = (0, _renderer.default)("<div>").addClass(SCROLLVIEW_PULLDOWN_IMAGE_CLASS);
                var $loadContainer = (0, _renderer.default)("<div>").addClass(SCROLLVIEW_PULLDOWN_INDICATOR_CLASS);
                var $loadIndicator = new _load_indicator.default((0, _renderer.default)("<div>")).$element();
                var $text = this._$pullDownText = (0, _renderer.default)("<div>").addClass(SCROLLVIEW_PULLDOWN_TEXT_CLASS);
                this._$pullingDownText = (0, _renderer.default)("<div>").text(this.option("pullingDownText")).appendTo($text);
                this._$pulledDownText = (0, _renderer.default)("<div>").text(this.option("pulledDownText")).appendTo($text);
                this._$refreshingText = (0, _renderer.default)("<div>").text(this.option("refreshingText")).appendTo($text);
                this._$pullDown.empty().append($image).append($loadContainer.append($loadIndicator)).append($text)
            },
            _releaseState: function() {
                this._state = STATE_RELEASED;
                this._refreshPullDownText()
            },
            _pushBackFromBoundary: function() {
                if (!this._isLocked() && !this._component.isEmpty()) {
                    this.callBase()
                }
            },
            _refreshPullDownText: function() {
                var that = this;
                var pullDownTextItems = [{
                    element: this._$pullingDownText,
                    visibleState: STATE_RELEASED
                }, {
                    element: this._$pulledDownText,
                    visibleState: STATE_READY
                }, {
                    element: this._$refreshingText,
                    visibleState: STATE_REFRESHING
                }];
                (0, _iterator.each)(pullDownTextItems, function(_, item) {
                    var action = that._state === item.visibleState ? "addClass" : "removeClass";
                    item.element[action](SCROLLVIEW_PULLDOWN_VISIBLE_TEXT_CLASS)
                })
            },
            update: function() {
                this.callBase();
                this._setTopPocketOffset()
            },
            _updateDimensions: function() {
                this.callBase();
                this._topPocketSize = this._$topPocket.height();
                this._bottomPocketSize = this._$bottomPocket.height();
                if (_browser.default.msie) {
                    this._scrollOffset = Math.round(100 * (this._$container.height() - this._$content.height())) / 100
                } else {
                    this._scrollOffset = this._$container.height() - this._$content.height()
                }
            },
            _allowedDirections: function() {
                var allowedDirections = this.callBase();
                allowedDirections.vertical = allowedDirections.vertical || this._pullDownEnabled;
                return allowedDirections
            },
            _setTopPocketOffset: function() {
                this._$topPocket.css({
                    top: -this._topPocketSize
                })
            },
            handleEnd: function() {
                this.callBase();
                this._complete()
            },
            handleStop: function() {
                this.callBase();
                this._complete()
            },
            _complete: function() {
                if (this._state === STATE_READY) {
                    this._setPullDownOffset(this._topPocketSize);
                    clearTimeout(this._pullDownRefreshTimeout);
                    this._pullDownRefreshTimeout = setTimeout(function() {
                        this._pullDownRefreshing()
                    }.bind(this), 400)
                }
            },
            _setPullDownOffset: function(offset) {
                (0, _translator.move)(this._$topPocket, {
                    top: offset
                });
                (0, _translator.move)(this._$scrollViewContent, {
                    top: offset
                })
            },
            handleScroll: function(e) {
                this.callBase(e);
                if (this._state === STATE_REFRESHING) {
                    return
                }
                var currentLocation = this.location().top;
                var scrollDelta = (this._location || 0) - currentLocation;
                this._location = currentLocation;
                if (this._isPullDown()) {
                    this._pullDownReady()
                } else {
                    if (scrollDelta > 0 && this._isReachBottom()) {
                        this._reachBottom()
                    } else {
                        this._stateReleased()
                    }
                }
            },
            _isPullDown: function() {
                return this._pullDownEnabled && this._location >= this._topPocketSize
            },
            _isReachBottom: function() {
                return this._reachBottomEnabled && this._location - (this._scrollOffset + this._bottomPocketSize) <= .5
            },
            _reachBottom: function() {
                if (this._state === STATE_LOADING) {
                    return
                }
                this._state = STATE_LOADING;
                this.reachBottomCallbacks.fire()
            },
            _pullDownReady: function() {
                if (this._state === STATE_READY) {
                    return
                }
                this._state = STATE_READY;
                this._$pullDown.addClass(SCROLLVIEW_PULLDOWN_READY_CLASS);
                this._refreshPullDownText()
            },
            _stateReleased: function() {
                if (this._state === STATE_RELEASED) {
                    return
                }
                this._$pullDown.removeClass(SCROLLVIEW_PULLDOWN_REFRESHING_CLASS).removeClass(SCROLLVIEW_PULLDOWN_READY_CLASS);
                this._releaseState()
            },
            _pullDownRefreshing: function() {
                if (this._state === STATE_REFRESHING) {
                    return
                }
                this._state = STATE_REFRESHING;
                this._$pullDown.addClass(SCROLLVIEW_PULLDOWN_REFRESHING_CLASS).removeClass(SCROLLVIEW_PULLDOWN_READY_CLASS);
                this._refreshPullDownText();
                this.pullDownCallbacks.fire()
            },
            pullDownEnable: function(enabled) {
                if (enabled) {
                    this._updateDimensions();
                    this._setTopPocketOffset()
                }
                this._pullDownEnabled = enabled
            },
            reachBottomEnable: function(enabled) {
                this._reachBottomEnabled = enabled
            },
            pendingRelease: function() {
                this._state = STATE_READY
            },
            release: function() {
                var deferred = new _deferred.Deferred;
                this._updateDimensions();
                clearTimeout(this._releaseTimeout);
                if (this._state === STATE_LOADING) {
                    this._state = STATE_RELEASED
                }
                this._releaseTimeout = setTimeout(function() {
                    this._setPullDownOffset(0);
                    this._stateReleased();
                    this.releaseCallbacks.fire();
                    this._updateAction();
                    deferred.resolve()
                }.bind(this), PULLDOWN_RELEASE_TIME);
                return deferred.promise()
            },
            dispose: function() {
                clearTimeout(this._pullDownRefreshTimeout);
                clearTimeout(this._releaseTimeout);
                this.callBase()
            }
        });
        var _default = PullDownNativeScrollViewStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scroll_view/ui.scroll_view.native.swipe_down.js ***!
      \*************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/callbacks */ 27));
        var _translator = __webpack_require__( /*! ../../animation/translator */ 28);
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _uiScrollable = _interopRequireDefault(__webpack_require__( /*! ./ui.scrollable.native */ 271));
        var _load_indicator = _interopRequireDefault(__webpack_require__( /*! ../load_indicator */ 83));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var SCROLLVIEW_PULLDOWN_DOWN_LOADING_CLASS = "dx-scrollview-pull-down-loading";
        var SCROLLVIEW_PULLDOWN_INDICATOR_CLASS = "dx-scrollview-pull-down-indicator";
        var SCROLLVIEW_PULLDOWN_REFRESHING_CLASS = "dx-scrollview-pull-down-refreshing";
        var PULLDOWN_ICON_CLASS = "dx-icon-pulldown";
        var STATE_RELEASED = 0;
        var STATE_READY = 1;
        var STATE_REFRESHING = 2;
        var STATE_TOUCHED = 4;
        var STATE_PULLED = 5;
        var SwipeDownNativeScrollViewStrategy = _uiScrollable.default.inherit({
            _init: function(scrollView) {
                this.callBase(scrollView);
                this._$topPocket = scrollView._$topPocket;
                this._$bottomPocket = scrollView._$bottomPocket;
                this._$pullDown = scrollView._$pullDown;
                this._$scrollViewContent = scrollView.content();
                this._initCallbacks();
                this._location = 0
            },
            _initCallbacks: function() {
                this.pullDownCallbacks = (0, _callbacks.default)();
                this.releaseCallbacks = (0, _callbacks.default)();
                this.reachBottomCallbacks = (0, _callbacks.default)()
            },
            render: function() {
                this.callBase();
                this._renderPullDown();
                this._releaseState()
            },
            _renderPullDown: function() {
                var $loadContainer = (0, _renderer.default)("<div>").addClass(SCROLLVIEW_PULLDOWN_INDICATOR_CLASS);
                var $loadIndicator = new _load_indicator.default((0, _renderer.default)("<div>")).$element();
                this._$icon = (0, _renderer.default)("<div>").addClass(PULLDOWN_ICON_CLASS);
                this._$pullDown.empty().append(this._$icon).append($loadContainer.append($loadIndicator))
            },
            _releaseState: function() {
                this._state = STATE_RELEASED;
                this._releasePullDown();
                this._updateDimensions()
            },
            _releasePullDown: function() {
                this._$pullDown.css({
                    opacity: 0
                })
            },
            _updateDimensions: function() {
                this.callBase();
                this._topPocketSize = this._$topPocket.height();
                this._bottomPocketSize = this._$bottomPocket.height();
                this._scrollOffset = this._$container.height() - this._$content.height()
            },
            _allowedDirections: function() {
                var allowedDirections = this.callBase();
                allowedDirections.vertical = allowedDirections.vertical || this._pullDownEnabled;
                return allowedDirections
            },
            handleInit: function(e) {
                this.callBase(e);
                if (this._state === STATE_RELEASED && 0 === this._location) {
                    this._startClientY = (0, _index.eventData)(e.originalEvent).y;
                    this._state = STATE_TOUCHED
                }
            },
            handleMove: function(e) {
                this.callBase(e);
                this._deltaY = (0, _index.eventData)(e.originalEvent).y - this._startClientY;
                if (this._state === STATE_TOUCHED) {
                    if (this._pullDownEnabled && this._deltaY > 0) {
                        this._state = STATE_PULLED
                    } else {
                        this._complete()
                    }
                }
                if (this._state === STATE_PULLED) {
                    e.preventDefault();
                    this._movePullDown()
                }
            },
            _movePullDown: function() {
                var pullDownHeight = this._getPullDownHeight();
                var top = Math.min(3 * pullDownHeight, this._deltaY + this._getPullDownStartPosition());
                var angle = 180 * top / pullDownHeight / 3;
                this._$pullDown.css({
                    opacity: 1
                }).toggleClass(SCROLLVIEW_PULLDOWN_REFRESHING_CLASS, top < pullDownHeight);
                (0, _translator.move)(this._$pullDown, {
                    top: top
                });
                this._$icon.css({
                    transform: "rotate(" + angle + "deg)"
                })
            },
            _isPullDown: function() {
                return this._pullDownEnabled && this._state === STATE_PULLED && this._deltaY >= this._getPullDownHeight() - this._getPullDownStartPosition()
            },
            _getPullDownHeight: function() {
                return Math.round(.05 * this._$element.outerHeight())
            },
            _getPullDownStartPosition: function() {
                return -Math.round(1.5 * this._$pullDown.outerHeight())
            },
            handleEnd: function() {
                if (this._isPullDown()) {
                    this._pullDownRefreshing()
                }
                this._complete()
            },
            handleStop: function() {
                this._complete()
            },
            _complete: function() {
                if (this._state === STATE_TOUCHED || this._state === STATE_PULLED) {
                    this._releaseState()
                }
            },
            handleScroll: function(e) {
                this.callBase(e);
                if (this._state === STATE_REFRESHING) {
                    return
                }
                var currentLocation = this.location().top;
                var scrollDelta = this._location - currentLocation;
                this._location = currentLocation;
                if (scrollDelta > 0 && this._isReachBottom()) {
                    this._reachBottom()
                } else {
                    this._stateReleased()
                }
            },
            _isReachBottom: function() {
                return this._reachBottomEnabled && this._location <= this._scrollOffset + this._bottomPocketSize
            },
            _reachBottom: function() {
                this.reachBottomCallbacks.fire()
            },
            _stateReleased: function() {
                if (this._state === STATE_RELEASED) {
                    return
                }
                this._$pullDown.removeClass(SCROLLVIEW_PULLDOWN_DOWN_LOADING_CLASS);
                this._releaseState()
            },
            _pullDownRefreshing: function() {
                this._state = STATE_REFRESHING;
                this._pullDownRefreshHandler()
            },
            _pullDownRefreshHandler: function() {
                this._refreshPullDown();
                this.pullDownCallbacks.fire()
            },
            _refreshPullDown: function() {
                this._$pullDown.addClass(SCROLLVIEW_PULLDOWN_DOWN_LOADING_CLASS);
                (0, _translator.move)(this._$pullDown, {
                    top: this._getPullDownHeight()
                })
            },
            pullDownEnable: function(enabled) {
                this._$topPocket.toggle(enabled);
                this._pullDownEnabled = enabled
            },
            reachBottomEnable: function(enabled) {
                this._reachBottomEnabled = enabled
            },
            pendingRelease: function() {
                this._state = STATE_READY
            },
            release: function() {
                var deferred = new _deferred.Deferred;
                this._updateDimensions();
                clearTimeout(this._releaseTimeout);
                this._releaseTimeout = setTimeout(function() {
                    this._stateReleased();
                    this.releaseCallbacks.fire();
                    this._updateAction();
                    deferred.resolve()
                }.bind(this), 800);
                return deferred.promise()
            },
            dispose: function() {
                clearTimeout(this._pullDownRefreshTimeout);
                clearTimeout(this._releaseTimeout);
                this.callBase()
            }
        });
        var _default = SwipeDownNativeScrollViewStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scroll_view/ui.scroll_view.simulated.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/callbacks */ 27));
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _uiScrollable = __webpack_require__( /*! ./ui.scrollable.simulated */ 349);
        var _load_indicator = _interopRequireDefault(__webpack_require__( /*! ../load_indicator */ 83));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var math = Math;
        var SCROLLVIEW_PULLDOWN_REFRESHING_CLASS = "dx-scrollview-pull-down-loading";
        var SCROLLVIEW_PULLDOWN_READY_CLASS = "dx-scrollview-pull-down-ready";
        var SCROLLVIEW_PULLDOWN_IMAGE_CLASS = "dx-scrollview-pull-down-image";
        var SCROLLVIEW_PULLDOWN_INDICATOR_CLASS = "dx-scrollview-pull-down-indicator";
        var SCROLLVIEW_PULLDOWN_TEXT_CLASS = "dx-scrollview-pull-down-text";
        var SCROLLVIEW_PULLDOWN_VISIBLE_TEXT_CLASS = "dx-scrollview-pull-down-text-visible";
        var STATE_RELEASED = 0;
        var STATE_READY = 1;
        var STATE_REFRESHING = 2;
        var STATE_LOADING = 3;
        var ScrollViewScroller = _uiScrollable.Scroller.inherit({
            ctor: function() {
                this._topPocketSize = 0;
                this.callBase.apply(this, arguments);
                this._initCallbacks();
                this._releaseState()
            },
            _releaseState: function() {
                this._state = STATE_RELEASED;
                this._refreshPullDownText()
            },
            _refreshPullDownText: function() {
                var that = this;
                var pullDownTextItems = [{
                    element: this._$pullingDownText,
                    visibleState: STATE_RELEASED
                }, {
                    element: this._$pulledDownText,
                    visibleState: STATE_READY
                }, {
                    element: this._$refreshingText,
                    visibleState: STATE_REFRESHING
                }];
                (0, _iterator.each)(pullDownTextItems, function(_, item) {
                    var action = that._state === item.visibleState ? "addClass" : "removeClass";
                    item.element[action](SCROLLVIEW_PULLDOWN_VISIBLE_TEXT_CLASS)
                })
            },
            _initCallbacks: function() {
                this.pullDownCallbacks = (0, _callbacks.default)();
                this.releaseCallbacks = (0, _callbacks.default)();
                this.reachBottomCallbacks = (0, _callbacks.default)()
            },
            _updateBounds: function() {
                var considerPockets = "horizontal" !== this._direction;
                this._topPocketSize = considerPockets ? Math.round(this._$topPocket[this._dimension]()) : 0;
                this._bottomPocketSize = considerPockets ? Math.round(this._$bottomPocket[this._dimension]()) : 0;
                this.callBase();
                this._bottomBound = this._minOffset + this._bottomPocketSize
            },
            _updateScrollbar: function() {
                this._scrollbar.option({
                    containerSize: this._containerSize(),
                    contentSize: this._contentSize() - this._topPocketSize - this._bottomPocketSize,
                    scaleRatio: this._getScaleRatio()
                })
            },
            _moveContent: function() {
                this.callBase();
                if (this._isPullDown()) {
                    this._pullDownReady()
                } else {
                    if (this._isReachBottom()) {
                        this._reachBottomReady()
                    } else {
                        if (this._state !== STATE_RELEASED) {
                            this._stateReleased()
                        }
                    }
                }
            },
            _moveScrollbar: function() {
                this._scrollbar.moveTo(this._topPocketSize + this._location)
            },
            _isPullDown: function() {
                return this._pullDownEnabled && this._location >= 0
            },
            _isReachBottom: function() {
                return this._reachBottomEnabled && this._location - this._bottomBound <= .5
            },
            _scrollComplete: function() {
                if (this._inBounds() && this._state === STATE_READY) {
                    this._pullDownRefreshing()
                } else {
                    if (this._inBounds() && this._state === STATE_LOADING) {
                        this._reachBottomLoading()
                    } else {
                        this.callBase()
                    }
                }
            },
            _reachBottomReady: function() {
                if (this._state === STATE_LOADING) {
                    return
                }
                this._state = STATE_LOADING;
                this._minOffset = this._getMinOffset()
            },
            _getMaxOffset: function() {
                return -this._topPocketSize
            },
            _getMinOffset: function() {
                return math.min(this.callBase(), -this._topPocketSize)
            },
            _reachBottomLoading: function() {
                this.reachBottomCallbacks.fire()
            },
            _pullDownReady: function() {
                if (this._state === STATE_READY) {
                    return
                }
                this._state = STATE_READY;
                this._maxOffset = 0;
                this._$pullDown.addClass(SCROLLVIEW_PULLDOWN_READY_CLASS);
                this._refreshPullDownText()
            },
            _stateReleased: function() {
                if (this._state === STATE_RELEASED) {
                    return
                }
                this._releaseState();
                this._updateBounds();
                this._$pullDown.removeClass(SCROLLVIEW_PULLDOWN_REFRESHING_CLASS).removeClass(SCROLLVIEW_PULLDOWN_READY_CLASS);
                this.releaseCallbacks.fire()
            },
            _pullDownRefreshing: function() {
                if (this._state === STATE_REFRESHING) {
                    return
                }
                this._state = STATE_REFRESHING;
                this._$pullDown.addClass(SCROLLVIEW_PULLDOWN_REFRESHING_CLASS).removeClass(SCROLLVIEW_PULLDOWN_READY_CLASS);
                this._refreshPullDownText();
                this.pullDownCallbacks.fire()
            },
            _releaseHandler: function() {
                if (this._state === STATE_RELEASED) {
                    this._moveToBounds()
                }
                this._update();
                if (this._releaseTask) {
                    this._releaseTask.abort()
                }
                this._releaseTask = (0, _common.executeAsync)(this._release.bind(this));
                return this._releaseTask.promise
            },
            _release: function() {
                this._stateReleased();
                this._scrollComplete()
            },
            _reachBottomEnablingHandler: function(enabled) {
                if (this._reachBottomEnabled === enabled) {
                    return
                }
                this._reachBottomEnabled = enabled;
                this._updateBounds()
            },
            _pullDownEnablingHandler: function(enabled) {
                if (this._pullDownEnabled === enabled) {
                    return
                }
                this._pullDownEnabled = enabled;
                this._considerTopPocketChange();
                this._updateHandler()
            },
            _considerTopPocketChange: function() {
                this._location -= this._$topPocket.height() || -this._topPocketSize;
                this._maxOffset = 0;
                this._move()
            },
            _pendingReleaseHandler: function() {
                this._state = STATE_READY
            },
            dispose: function() {
                if (this._releaseTask) {
                    this._releaseTask.abort()
                }
                this.callBase()
            }
        });
        var SimulatedScrollViewStrategy = _uiScrollable.SimulatedStrategy.inherit({
            _init: function(scrollView) {
                this.callBase(scrollView);
                this._$pullDown = scrollView._$pullDown;
                this._$topPocket = scrollView._$topPocket;
                this._$bottomPocket = scrollView._$bottomPocket;
                this._initCallbacks()
            },
            _initCallbacks: function() {
                this.pullDownCallbacks = (0, _callbacks.default)();
                this.releaseCallbacks = (0, _callbacks.default)();
                this.reachBottomCallbacks = (0, _callbacks.default)()
            },
            render: function() {
                this._renderPullDown();
                this.callBase()
            },
            _renderPullDown: function() {
                var $image = (0, _renderer.default)("<div>").addClass(SCROLLVIEW_PULLDOWN_IMAGE_CLASS);
                var $loadContainer = (0, _renderer.default)("<div>").addClass(SCROLLVIEW_PULLDOWN_INDICATOR_CLASS);
                var $loadIndicator = new _load_indicator.default((0, _renderer.default)("<div>")).$element();
                var $text = this._$pullDownText = (0, _renderer.default)("<div>").addClass(SCROLLVIEW_PULLDOWN_TEXT_CLASS);
                this._$pullingDownText = (0, _renderer.default)("<div>").text(this.option("pullingDownText")).appendTo($text);
                this._$pulledDownText = (0, _renderer.default)("<div>").text(this.option("pulledDownText")).appendTo($text);
                this._$refreshingText = (0, _renderer.default)("<div>").text(this.option("refreshingText")).appendTo($text);
                this._$pullDown.empty().append($image).append($loadContainer.append($loadIndicator)).append($text)
            },
            pullDownEnable: function(enabled) {
                this._eventHandler("pullDownEnabling", enabled)
            },
            reachBottomEnable: function(enabled) {
                this._eventHandler("reachBottomEnabling", enabled)
            },
            _createScroller: function(direction) {
                var that = this;
                var scroller = that._scrollers[direction] = new ScrollViewScroller(that._scrollerOptions(direction));
                scroller.pullDownCallbacks.add(function() {
                    that.pullDownCallbacks.fire()
                });
                scroller.releaseCallbacks.add(function() {
                    that.releaseCallbacks.fire()
                });
                scroller.reachBottomCallbacks.add(function() {
                    that.reachBottomCallbacks.fire()
                })
            },
            _scrollerOptions: function(direction) {
                return (0, _extend.extend)(this.callBase(direction), {
                    $topPocket: this._$topPocket,
                    $bottomPocket: this._$bottomPocket,
                    $pullDown: this._$pullDown,
                    $pullDownText: this._$pullDownText,
                    $pullingDownText: this._$pullingDownText,
                    $pulledDownText: this._$pulledDownText,
                    $refreshingText: this._$refreshingText
                })
            },
            pendingRelease: function() {
                this._eventHandler("pendingRelease")
            },
            release: function() {
                return this._eventHandler("release").done(this._updateAction)
            },
            location: function location() {
                var location = this.callBase();
                location.top += this._$topPocket.height();
                return location
            },
            dispose: function() {
                (0, _iterator.each)(this._scrollers, function() {
                    this.dispose()
                });
                this.callBase()
            }
        });
        var _default = SimulatedScrollViewStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/list/ui.list.edit.decorator.selection.js ***!
      \******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _click = __webpack_require__( /*! ../../events/click */ 21);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _check_box = _interopRequireDefault(__webpack_require__( /*! ../check_box */ 136));
        var _radio_button = _interopRequireDefault(__webpack_require__( /*! ../radio_group/radio_button */ 607));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _uiListEdit = __webpack_require__( /*! ./ui.list.edit.decorator_registry */ 115);
        var _uiListEdit2 = _interopRequireDefault(__webpack_require__( /*! ./ui.list.edit.decorator */ 156));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var SELECT_DECORATOR_ENABLED_CLASS = "dx-list-select-decorator-enabled";
        var SELECT_DECORATOR_SELECT_ALL_CLASS = "dx-list-select-all";
        var SELECT_DECORATOR_SELECT_ALL_CHECKBOX_CLASS = "dx-list-select-all-checkbox";
        var SELECT_DECORATOR_SELECT_ALL_LABEL_CLASS = "dx-list-select-all-label";
        var SELECT_CHECKBOX_CONTAINER_CLASS = "dx-list-select-checkbox-container";
        var SELECT_CHECKBOX_CLASS = "dx-list-select-checkbox";
        var SELECT_RADIO_BUTTON_CONTAINER_CLASS = "dx-list-select-radiobutton-container";
        var SELECT_RADIO_BUTTON_CLASS = "dx-list-select-radiobutton";
        var FOCUSED_STATE_CLASS = "dx-state-focused";
        var CLICK_EVENT_NAME = (0, _index.addNamespace)(_click.name, "dxListEditDecorator");
        (0, _uiListEdit.register)("selection", "default", _uiListEdit2.default.inherit({
            _init: function() {
                this.callBase.apply(this, arguments);
                var selectionMode = this._list.option("selectionMode");
                this._singleStrategy = "single" === selectionMode;
                this._containerClass = this._singleStrategy ? SELECT_RADIO_BUTTON_CONTAINER_CLASS : SELECT_CHECKBOX_CONTAINER_CLASS;
                this._controlClass = this._singleStrategy ? SELECT_RADIO_BUTTON_CLASS : SELECT_CHECKBOX_CLASS;
                this._controlWidget = this._singleStrategy ? _radio_button.default : _check_box.default;
                this._list.$element().addClass(SELECT_DECORATOR_ENABLED_CLASS)
            },
            beforeBag: function(config) {
                var $itemElement = config.$itemElement;
                var $container = config.$container.addClass(this._containerClass);
                var $control = (0, _renderer.default)("<div>").addClass(this._controlClass).appendTo($container);
                new this._controlWidget($control, (0, _extend.extend)(this._commonOptions(), {
                    value: this._isSelected($itemElement),
                    focusStateEnabled: false,
                    hoverStateEnabled: false,
                    onValueChanged: function(e) {
                        e.event && this._list._saveSelectionChangeEvent(e.event);
                        this._processCheckedState($itemElement, e.value);
                        e.event && e.event.stopPropagation()
                    }.bind(this)
                }))
            },
            modifyElement: function(config) {
                this.callBase.apply(this, arguments);
                var $itemElement = config.$itemElement;
                var control = this._controlWidget.getInstance($itemElement.find("." + this._controlClass));
                _events_engine.default.on($itemElement, "stateChanged", function(e, state) {
                    control.option("value", state)
                }.bind(this))
            },
            _updateSelectAllState: function() {
                if (!this._$selectAll) {
                    return
                }
                this._selectAllCheckBox.option("value", this._list.isSelectAll())
            },
            afterRender: function() {
                if ("all" !== this._list.option("selectionMode")) {
                    return
                }
                if (!this._$selectAll) {
                    this._renderSelectAll()
                } else {
                    this._updateSelectAllState()
                }
            },
            handleKeyboardEvents: function(currentFocusedIndex, moveFocusUp) {
                var moveFocusDown = !moveFocusUp;
                var list = this._list;
                var $selectAll = this._$selectAll;
                var lastItemIndex = list._getLastItemIndex();
                var isFocusOutOfList = moveFocusUp && 0 === currentFocusedIndex || moveFocusDown && currentFocusedIndex === lastItemIndex;
                var hasSelectAllItem = !!$selectAll;
                if (hasSelectAllItem && isFocusOutOfList) {
                    list.option("focusedElement", $selectAll);
                    list.scrollToItem(list.option("focusedElement"));
                    return true
                }
                return false
            },
            handleEnterPressing: function(e) {
                if (this._$selectAll && this._$selectAll.hasClass(FOCUSED_STATE_CLASS)) {
                    e.target = this._$selectAll.get(0);
                    this._list._saveSelectionChangeEvent(e);
                    this._selectAllCheckBox.option("value", !this._selectAllCheckBox.option("value"));
                    return true
                }
            },
            _renderSelectAll: function() {
                var $selectAll = this._$selectAll = (0, _renderer.default)("<div>").addClass(SELECT_DECORATOR_SELECT_ALL_CLASS);
                var list = this._list;
                var downArrowHandler = list._supportedKeys().downArrow.bind(list);
                this._selectAllCheckBox = list._createComponent((0, _renderer.default)("<div>").addClass(SELECT_DECORATOR_SELECT_ALL_CHECKBOX_CLASS).appendTo($selectAll), _check_box.default, {
                    focusStateEnabled: false,
                    hoverStateEnabled: false
                });
                this._selectAllCheckBox.registerKeyHandler("downArrow", downArrowHandler);
                (0, _renderer.default)("<div>").addClass(SELECT_DECORATOR_SELECT_ALL_LABEL_CLASS).text(this._list.option("selectAllText")).appendTo($selectAll);
                this._list.itemsContainer().prepend($selectAll);
                this._updateSelectAllState();
                this._attachSelectAllHandler()
            },
            _attachSelectAllHandler: function() {
                this._selectAllCheckBox.option("onValueChanged", this._selectAllHandler.bind(this));
                _events_engine.default.off(this._$selectAll, CLICK_EVENT_NAME);
                _events_engine.default.on(this._$selectAll, CLICK_EVENT_NAME, this._selectAllClickHandler.bind(this))
            },
            _selectAllHandler: function(e) {
                e.event && e.event.stopPropagation();
                var isSelectedAll = this._selectAllCheckBox.option("value");
                var result = this._list._createActionByOption("onSelectAllValueChanged")({
                    value: isSelectedAll
                });
                if (false === result) {
                    return
                }
                e.event && this._list._saveSelectionChangeEvent(e.event);
                if (true === isSelectedAll) {
                    this._selectAllItems()
                } else {
                    if (false === isSelectedAll) {
                        this._unselectAllItems()
                    }
                }
            },
            _checkSelectAllCapability: function() {
                var list = this._list;
                var dataSource = list.getDataSource();
                if ("allPages" === list.option("selectAllMode") && list.option("grouped") && (!dataSource || !dataSource.group())) {
                    _ui.default.log("W1010");
                    return false
                }
                return true
            },
            _selectAllItems: function() {
                if (!this._checkSelectAllCapability()) {
                    return
                }
                this._list._selection.selectAll("page" === this._list.option("selectAllMode"))
            },
            _unselectAllItems: function() {
                if (!this._checkSelectAllCapability()) {
                    return
                }
                this._list._selection.deselectAll("page" === this._list.option("selectAllMode"))
            },
            _selectAllClickHandler: function(e) {
                this._list._saveSelectionChangeEvent(e);
                this._selectAllCheckBox.option("value", !this._selectAllCheckBox.option("value"))
            },
            _isSelected: function($itemElement) {
                return this._list.isItemSelected($itemElement)
            },
            _processCheckedState: function($itemElement, checked) {
                if (checked) {
                    this._list.selectItem($itemElement)
                } else {
                    this._list.unselectItem($itemElement)
                }
            },
            dispose: function() {
                this._disposeSelectAll();
                this._list.$element().removeClass(SELECT_DECORATOR_ENABLED_CLASS);
                this.callBase.apply(this, arguments)
            },
            _disposeSelectAll: function() {
                if (this._$selectAll) {
                    this._$selectAll.remove();
                    this._$selectAll = null
                }
            }
        }))
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/radio_group/radio_button.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _utils = __webpack_require__( /*! ../widget/utils.ink_ripple */ 82);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _editor = _interopRequireDefault(__webpack_require__( /*! ../editor/editor */ 52));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _click = __webpack_require__( /*! ../../events/click */ 21);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var RADIO_BUTTON_CLASS = "dx-radiobutton";
        var RADIO_BUTTON_ICON_CLASS = "dx-radiobutton-icon";
        var RADIO_BUTTON_ICON_DOT_CLASS = "dx-radiobutton-icon-dot";
        var RADIO_BUTTON_CHECKED_CLASS = "dx-radiobutton-checked";
        var RADIO_BUTTON_ICON_CHECKED_CLASS = "dx-radiobutton-icon-checked";
        var RadioButton = _editor.default.inherit({
            _supportedKeys: function() {
                var click = function(e) {
                    e.preventDefault();
                    this._clickAction({
                        event: e
                    })
                };
                return (0, _extend.extend)(this.callBase(), {
                    space: click
                })
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    hoverStateEnabled: true,
                    activeStateEnabled: true,
                    value: false,
                    useInkRipple: false
                })
            },
            _canValueBeChangedByClick: function() {
                return true
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: function() {
                        return "desktop" === _devices.default.real().deviceType && !_devices.default.isSimulator()
                    },
                    options: {
                        focusStateEnabled: true
                    }
                }])
            },
            _init: function() {
                this.callBase();
                this.$element().addClass(RADIO_BUTTON_CLASS)
            },
            _initMarkup: function() {
                this.callBase();
                this._renderIcon();
                this.option("useInkRipple") && this._renderInkRipple();
                this._renderCheckedState(this.option("value"));
                this._renderClick();
                this.setAria("role", "radio")
            },
            _renderInkRipple: function() {
                this._inkRipple = (0, _utils.render)({
                    waveSizeCoefficient: 3.3,
                    useHoldAnimation: false,
                    wavesNumber: 2,
                    isCentered: true
                })
            },
            _renderInkWave: function(element, dxEvent, doRender, waveIndex) {
                if (!this._inkRipple) {
                    return
                }
                var config = {
                    element: element,
                    event: dxEvent,
                    wave: waveIndex
                };
                if (doRender) {
                    this._inkRipple.showWave(config)
                } else {
                    this._inkRipple.hideWave(config)
                }
            },
            _updateFocusState: function(e, value) {
                this.callBase.apply(this, arguments);
                this._renderInkWave(this._$icon, e, value, 0)
            },
            _toggleActiveState: function($element, value, e) {
                this.callBase.apply(this, arguments);
                this._renderInkWave(this._$icon, e, value, 1)
            },
            _renderIcon: function() {
                this._$icon = (0, _renderer.default)("<div>").addClass(RADIO_BUTTON_ICON_CLASS);
                (0, _renderer.default)("<div>").addClass(RADIO_BUTTON_ICON_DOT_CLASS).appendTo(this._$icon);
                this.$element().append(this._$icon)
            },
            _renderCheckedState: function(checked) {
                this.$element().toggleClass(RADIO_BUTTON_CHECKED_CLASS, checked).find("." + RADIO_BUTTON_ICON_CLASS).toggleClass(RADIO_BUTTON_ICON_CHECKED_CLASS, checked);
                this.setAria("checked", checked)
            },
            _renderClick: function() {
                var eventName = (0, _index.addNamespace)(_click.name, this.NAME);
                this._clickAction = this._createAction(function(args) {
                    this._clickHandler(args.event)
                }.bind(this));
                _events_engine.default.off(this.$element(), eventName);
                _events_engine.default.on(this.$element(), eventName, function(e) {
                    this._clickAction({
                        event: e
                    })
                }.bind(this))
            },
            _clickHandler: function(e) {
                this._saveValueChangeEvent(e);
                this.option("value", true)
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "useInkRipple":
                        this._invalidate();
                        break;
                    case "value":
                        this._renderCheckedState(args.value);
                        this.callBase(args);
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _clean: function() {
                delete this._inkRipple;
                this.callBase()
            }
        });
        (0, _component_registrator.default)("dxRadioButton", RadioButton);
        var _default = RadioButton;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/list/ui.list.edit.decorator.reorder.js ***!
      \****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _uiListEdit = __webpack_require__( /*! ./ui.list.edit.decorator_registry */ 115);
        var _uiListEdit2 = _interopRequireDefault(__webpack_require__( /*! ./ui.list.edit.decorator */ 156));
        var _sortable = _interopRequireDefault(__webpack_require__( /*! ../sortable */ 273));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var REORDER_HANDLE_CONTAINER_CLASS = "dx-list-reorder-handle-container";
        var REORDER_HANDLE_CLASS = "dx-list-reorder-handle";
        var REORDERING_ITEM_GHOST_CLASS = "dx-list-item-ghost-reordering";
        var STATE_HOVER_CLASS = "dx-state-hover";
        (0, _uiListEdit.register)("reorder", "default", _uiListEdit2.default.inherit({
            _init: function() {
                var list = this._list;
                this._groupedEnabled = this._list.option("grouped");
                this._lockedDrag = false;
                var filter = this._groupedEnabled ? "> .dx-list-group > .dx-list-group-body > .dx-list-item" : "> .dx-list-item";
                this._sortable = list._createComponent(list._scrollView.content(), _sortable.default, (0, _extend.extend)({
                    component: list,
                    contentTemplate: null,
                    allowReordering: false,
                    filter: filter,
                    container: list.$element(),
                    dragDirection: list.option("itemDragging.group") ? "both" : "vertical",
                    handle: ".".concat(REORDER_HANDLE_CLASS),
                    dragTemplate: this._dragTemplate,
                    onDragStart: this._dragStartHandler.bind(this),
                    onDragChange: this._dragChangeHandler.bind(this),
                    onReorder: this._reorderHandler.bind(this)
                }, list.option("itemDragging")))
            },
            afterRender: function() {
                this._sortable.update()
            },
            _dragTemplate: function(e) {
                return (0, _renderer.default)(e.itemElement).clone().width((0, _renderer.default)(e.itemElement).width()).addClass(REORDERING_ITEM_GHOST_CLASS).addClass(STATE_HOVER_CLASS)
            },
            _dragStartHandler: function(e) {
                if (this._lockedDrag) {
                    e.cancel = true;
                    return
                }
            },
            _dragChangeHandler: function(e) {
                if (this._groupedEnabled && !this._sameParent(e.fromIndex, e.toIndex)) {
                    e.cancel = true;
                    return
                }
            },
            _sameParent: function(fromIndex, toIndex) {
                var $dragging = this._list.getItemElementByFlatIndex(fromIndex);
                var $over = this._list.getItemElementByFlatIndex(toIndex);
                return $over.parent().get(0) === $dragging.parent().get(0)
            },
            _reorderHandler: function(e) {
                var $targetElement = this._list.getItemElementByFlatIndex(e.toIndex);
                this._list.reorderItem((0, _renderer.default)(e.itemElement), $targetElement)
            },
            afterBag: function(config) {
                var _this = this;
                var $handle = (0, _renderer.default)("<div>").addClass(REORDER_HANDLE_CLASS);
                _events_engine.default.on($handle, "dxpointerdown", function(e) {
                    _this._lockedDrag = !(0, _index.isMouseEvent)(e)
                });
                _events_engine.default.on($handle, "dxhold", {
                    timeout: 30
                }, function(e) {
                    e.cancel = true;
                    _this._lockedDrag = false
                });
                config.$container.addClass(REORDER_HANDLE_CONTAINER_CLASS).append($handle)
            }
        }))
    },
    /*!*************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/calendar/ui.calendar.js ***!
      \*************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _guid = _interopRequireDefault(__webpack_require__( /*! ../../core/guid */ 36));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _math = __webpack_require__( /*! ../../core/utils/math */ 29);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _button = _interopRequireDefault(__webpack_require__( /*! ../button */ 37));
        var _editor = _interopRequireDefault(__webpack_require__( /*! ../editor/editor */ 52));
        var _swipeable = _interopRequireDefault(__webpack_require__( /*! ../../events/gesture/swipeable */ 172));
        var _uiCalendar = _interopRequireDefault(__webpack_require__( /*! ./ui.calendar.navigator */ 610));
        var _uiCalendar2 = _interopRequireDefault(__webpack_require__( /*! ./ui.calendar.views */ 611));
        var _translator = __webpack_require__( /*! ../../animation/translator */ 28);
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));
        var _date2 = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));
        var _date_serialization = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date_serialization */ 57));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _fx = _interopRequireDefault(__webpack_require__( /*! ../../animation/fx */ 42));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _function_template = __webpack_require__( /*! ../../core/templates/function_template */ 126);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var CALENDAR_CLASS = "dx-calendar";
        var CALENDAR_BODY_CLASS = "dx-calendar-body";
        var CALENDAR_CELL_CLASS = "dx-calendar-cell";
        var CALENDAR_FOOTER_CLASS = "dx-calendar-footer";
        var CALENDAR_TODAY_BUTTON_CLASS = "dx-calendar-today-button";
        var CALENDAR_HAS_FOOTER_CLASS = "dx-calendar-with-footer";
        var CALENDAR_VIEWS_WRAPPER_CLASS = "dx-calendar-views-wrapper";
        var CALENDAR_VIEW_CLASS = "dx-calendar-view";
        var FOCUSED_STATE_CLASS = "dx-state-focused";
        var ANIMATION_DURATION_SHOW_VIEW = 250;
        var POP_ANIMATION_FROM = .6;
        var POP_ANIMATION_TO = 1;
        var CALENDAR_INPUT_STANDARD_PATTERN = "yyyy-MM-dd";
        var CALENDAR_DATE_VALUE_KEY = "dxDateValueKey";
        var LEVEL_COMPARE_MAP = {
            month: 3,
            year: 2,
            decade: 1,
            century: 0
        };
        var ZOOM_LEVEL = {
            MONTH: "month",
            YEAR: "year",
            DECADE: "decade",
            CENTURY: "century"
        };
        var isIE11 = _browser.default.msie && parseInt(_browser.default.version) <= 11;
        var Calendar = _editor.default.inherit({
            _activeStateUnit: "." + CALENDAR_CELL_CLASS,
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    hoverStateEnabled: true,
                    activeStateEnabled: true,
                    currentDate: new Date,
                    value: null,
                    dateSerializationFormat: void 0,
                    min: new Date(1e3, 0),
                    max: new Date(3e3, 0),
                    firstDayOfWeek: void 0,
                    zoomLevel: ZOOM_LEVEL.MONTH,
                    maxZoomLevel: ZOOM_LEVEL.MONTH,
                    minZoomLevel: ZOOM_LEVEL.CENTURY,
                    showTodayButton: false,
                    cellTemplate: "cell",
                    disabledDates: null,
                    onCellClick: null,
                    onContouredChanged: null,
                    hasFocus: function(element) {
                        return element.hasClass(FOCUSED_STATE_CLASS)
                    },
                    _todayDate: function() {
                        return new Date
                    }
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: function() {
                        return "desktop" === _devices.default.real().deviceType && !_devices.default.isSimulator()
                    },
                    options: {
                        focusStateEnabled: true
                    }
                }])
            },
            _supportedKeys: function() {
                return (0, _extend.extend)(this.callBase(), {
                    rightArrow: function(e) {
                        e.preventDefault();
                        if (e.ctrlKey) {
                            this._waitRenderView(1)
                        } else {
                            this._moveCurrentDateByOffset(1 * this._getRtlCorrection())
                        }
                    },
                    leftArrow: function(e) {
                        e.preventDefault();
                        if (e.ctrlKey) {
                            this._waitRenderView(-1)
                        } else {
                            this._moveCurrentDateByOffset(-1 * this._getRtlCorrection())
                        }
                    },
                    upArrow: function(e) {
                        e.preventDefault();
                        if (e.ctrlKey) {
                            this._navigateUp()
                        } else {
                            if (_fx.default.isAnimating(this._view.$element())) {
                                return
                            }
                            this._moveCurrentDateByOffset(-1 * this._view.option("colCount"))
                        }
                    },
                    downArrow: function(e) {
                        e.preventDefault();
                        if (e.ctrlKey) {
                            this._navigateDown()
                        } else {
                            if (_fx.default.isAnimating(this._view.$element())) {
                                return
                            }
                            this._moveCurrentDateByOffset(1 * this._view.option("colCount"))
                        }
                    },
                    home: function(e) {
                        e.preventDefault();
                        var zoomLevel = this.option("zoomLevel");
                        var currentDate = this.option("currentDate");
                        var min = this._dateOption("min");
                        if (this._view.isDateDisabled(currentDate)) {
                            return
                        }
                        var date = _date2.default.sameView(zoomLevel, currentDate, min) ? min : _date2.default.getViewFirstCellDate(zoomLevel, currentDate);
                        this._moveToClosestAvailableDate(date)
                    },
                    end: function(e) {
                        e.preventDefault();
                        var zoomLevel = this.option("zoomLevel");
                        var currentDate = this.option("currentDate");
                        var max = this._dateOption("max");
                        if (this._view.isDateDisabled(currentDate)) {
                            return
                        }
                        var date = _date2.default.sameView(zoomLevel, currentDate, max) ? max : _date2.default.getViewLastCellDate(zoomLevel, currentDate);
                        this._moveToClosestAvailableDate(date)
                    },
                    pageUp: function(e) {
                        e.preventDefault();
                        this._waitRenderView(-1 * this._getRtlCorrection())
                    },
                    pageDown: function(e) {
                        e.preventDefault();
                        this._waitRenderView(1 * this._getRtlCorrection())
                    },
                    tab: _common.noop,
                    enter: function(e) {
                        if (!this._isMaxZoomLevel()) {
                            this._navigateDown()
                        } else {
                            if (!this._view.isDateDisabled(this.option("currentDate"))) {
                                var value = this._updateTimeComponent(this.option("currentDate"));
                                this._dateValue(value, e)
                            }
                        }
                    }
                })
            },
            _getSerializationFormat: function(optionName) {
                var value = this.option(optionName || "value");
                if (this.option("dateSerializationFormat")) {
                    return this.option("dateSerializationFormat")
                }
                if ((0, _type.isNumeric)(value)) {
                    return "number"
                }
                if (!(0, _type.isString)(value)) {
                    return
                }
                return _date_serialization.default.getDateSerializationFormat(value)
            },
            _convertToDate: function(value, optionName) {
                return _date_serialization.default.deserializeDate(value)
            },
            _dateValue: function(value, event) {
                if (event) {
                    if ("keydown" === event.type) {
                        var cellElement = this._view._getContouredCell().get(0);
                        event.target = cellElement
                    }
                    this._saveValueChangeEvent(event)
                }
                this._dateOption("value", value)
            },
            _dateOption: function(optionName, optionValue) {
                if (1 === arguments.length) {
                    return this._convertToDate(this.option(optionName), optionName)
                }
                var serializationFormat = this._getSerializationFormat(optionName);
                this.option(optionName, _date_serialization.default.serializeDate(optionValue, serializationFormat))
            },
            _shiftDate: function(zoomLevel, date, offset, reverse) {
                switch (zoomLevel) {
                    case ZOOM_LEVEL.MONTH:
                        date.setDate(date.getDate() + offset * reverse);
                        break;
                    case ZOOM_LEVEL.YEAR:
                        date.setMonth(date.getMonth() + offset * reverse);
                        break;
                    case ZOOM_LEVEL.DECADE:
                        date.setFullYear(date.getFullYear() + offset * reverse);
                        break;
                    case ZOOM_LEVEL.CENTURY:
                        date.setFullYear(date.getFullYear() + 10 * offset * reverse)
                }
            },
            _moveCurrentDateByOffset: function(offset) {
                var baseDate = this.option("currentDate");
                var currentDate = new Date(baseDate);
                var zoomLevel = this.option("zoomLevel");
                this._shiftDate(zoomLevel, currentDate, offset, 1);
                var maxDate = this._getMaxDate();
                var minDate = this._getMinDate();
                var isDateForwardInNeighborView = this._areDatesInNeighborView(zoomLevel, currentDate, baseDate);
                var isDateForwardInRange = (0, _math.inRange)(currentDate, minDate, maxDate) && isDateForwardInNeighborView;
                var dateForward = new Date(currentDate);
                while (isDateForwardInRange) {
                    if (isDateForwardInRange && !this._view.isDateDisabled(dateForward)) {
                        currentDate = dateForward;
                        break
                    }
                    this._shiftDate(zoomLevel, dateForward, offset, 1);
                    isDateForwardInNeighborView = this._areDatesInNeighborView(zoomLevel, dateForward, baseDate);
                    isDateForwardInRange = (0, _math.inRange)(dateForward, minDate, maxDate) && isDateForwardInNeighborView
                }
                if (this._view.isDateDisabled(baseDate) || this._view.isDateDisabled(currentDate)) {
                    this._waitRenderView(offset > 0 ? 1 : -1)
                } else {
                    this.option("currentDate", currentDate)
                }
            },
            _areDatesInSameView: function(zoomLevel, date1, date2) {
                switch (zoomLevel) {
                    case ZOOM_LEVEL.MONTH:
                        return date1.getMonth() === date2.getMonth();
                    case ZOOM_LEVEL.YEAR:
                        return date1.getYear() === date2.getYear();
                    case ZOOM_LEVEL.DECADE:
                        return parseInt(date1.getYear() / 10) === parseInt(date2.getYear() / 10);
                    case ZOOM_LEVEL.CENTURY:
                        return parseInt(date1.getYear() / 100) === parseInt(date2.getYear() / 100)
                }
            },
            _areDatesInNeighborView: function(zoomLevel, date1, date2) {
                var monthMinDistance = function(a, b) {
                    var abs = Math.abs(a - b);
                    return Math.min(abs, 12 - abs)
                };
                switch (zoomLevel) {
                    case ZOOM_LEVEL.MONTH:
                        return monthMinDistance(date1.getMonth(), date2.getMonth()) <= 1;
                    case ZOOM_LEVEL.YEAR:
                        return Math.abs(date1.getYear() - date2.getYear()) <= 1;
                    case ZOOM_LEVEL.DECADE:
                        return Math.abs(date1.getYear() - date2.getYear()) <= 10;
                    case ZOOM_LEVEL.CENTURY:
                        return Math.abs(date1.getYear() - date2.getYear()) <= 100
                }
            },
            _moveToClosestAvailableDate: function() {
                var baseDate = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.option("currentDate");
                var currentDate = _date2.default.createDate(baseDate);
                var zoomLevel = this.option("zoomLevel");
                var isCurrentDateAvailable = !this._isDateNotAvailable(currentDate);
                var isDateForwardAvailable = isCurrentDateAvailable;
                var isDateBackwardAvailable = isCurrentDateAvailable;
                var isDateForwardInStartView;
                var isDateBackwardInStartView;
                var dateForward = _date2.default.createDate(currentDate);
                var dateBackward = _date2.default.createDate(currentDate);
                do {
                    if (isDateForwardAvailable) {
                        currentDate = dateForward;
                        break
                    }
                    if (isDateBackwardAvailable) {
                        currentDate = dateBackward;
                        break
                    }
                    this._shiftDate(zoomLevel, dateForward, 1, 1);
                    this._shiftDate(zoomLevel, dateBackward, 1, -1);
                    isDateForwardInStartView = this._areDatesInSameView(zoomLevel, dateForward, baseDate);
                    isDateBackwardInStartView = this._areDatesInSameView(zoomLevel, dateBackward, baseDate);
                    isDateForwardAvailable = isDateForwardInStartView && !this._isDateNotAvailable(dateForward);
                    isDateBackwardAvailable = isDateBackwardInStartView && !this._isDateNotAvailable(dateBackward)
                } while (isDateForwardInStartView || isDateBackwardInStartView);
                this.option("currentDate", currentDate)
            },
            _isDateNotAvailable: function(date) {
                var maxDate = this._getMaxDate();
                var minDate = this._getMinDate();
                return !(0, _math.inRange)(date, minDate, maxDate) || this._view.isDateDisabled(date)
            },
            _init: function() {
                this.callBase();
                this._correctZoomLevel();
                this._initCurrentDate();
                this._initActions()
            },
            _correctZoomLevel: function() {
                var minZoomLevel = this.option("minZoomLevel");
                var maxZoomLevel = this.option("maxZoomLevel");
                var zoomLevel = this.option("zoomLevel");
                if (LEVEL_COMPARE_MAP[maxZoomLevel] < LEVEL_COMPARE_MAP[minZoomLevel]) {
                    return
                }
                if (LEVEL_COMPARE_MAP[zoomLevel] > LEVEL_COMPARE_MAP[maxZoomLevel]) {
                    this.option("zoomLevel", maxZoomLevel)
                } else {
                    if (LEVEL_COMPARE_MAP[zoomLevel] < LEVEL_COMPARE_MAP[minZoomLevel]) {
                        this.option("zoomLevel", minZoomLevel)
                    }
                }
            },
            _initCurrentDate: function() {
                var currentDate = this._getNormalizedDate(this._dateOption("value")) || this._getNormalizedDate(this.option("currentDate"));
                this.option("currentDate", currentDate)
            },
            _getNormalizedDate: function(date) {
                date = _date2.default.normalizeDate(date, this._getMinDate(), this._getMaxDate());
                return (0, _type.isDefined)(date) ? this._getDate(date) : date
            },
            _initActions: function() {
                this._cellClickAction = this._createActionByOption("onCellClick");
                this._onContouredChanged = this._createActionByOption("onContouredChanged")
            },
            _initTemplates: function() {
                this._templateManager.addDefaultTemplates({
                    cell: new _function_template.FunctionTemplate(function(options) {
                        var data = options.model;
                        (0, _renderer.default)(options.container).append((0, _renderer.default)("<span>").text(data && data.text || String(data)))
                    })
                });
                this.callBase()
            },
            _updateCurrentDate: function(date) {
                if (_fx.default.isAnimating(this._$viewsWrapper)) {
                    _fx.default.stop(this._$viewsWrapper, true)
                }
                var min = this._getMinDate();
                var max = this._getMaxDate();
                if (min > max) {
                    this.option("currentDate", new Date);
                    return
                }
                var normalizedDate = this._getNormalizedDate(date);
                if (date.getTime() !== normalizedDate.getTime()) {
                    this.option("currentDate", _date2.default.createDate(normalizedDate));
                    return
                }
                var offset = this._getViewsOffset(this._view.option("date"), normalizedDate);
                if (0 !== offset && !this._isMaxZoomLevel() && this._isOtherViewCellClicked) {
                    offset = 0
                }
                if (this._view && 0 !== offset && !this._suppressNavigation) {
                    this._navigate(offset, normalizedDate)
                } else {
                    this._renderNavigator();
                    this._setViewContoured(normalizedDate);
                    this._updateAriaId(normalizedDate)
                }
            },
            _setViewContoured: function(date) {
                if (this.option("hasFocus")(this._focusTarget())) {
                    this._view.option("contouredDate", date)
                }
            },
            _getMinDate: function() {
                if (this.min) {
                    return this.min
                }
                this.min = this._dateOption("min") || new Date(1e3, 0);
                return this.min
            },
            _getMaxDate: function() {
                if (this.max) {
                    return this.max
                }
                this.max = this._dateOption("max") || new Date(3e3, 0);
                return this.max
            },
            _getViewsOffset: function(startDate, endDate) {
                var zoomLevel = this.option("zoomLevel");
                if (zoomLevel === ZOOM_LEVEL.MONTH) {
                    return this._getMonthsOffset(startDate, endDate)
                }
                var zoomCorrection;
                switch (zoomLevel) {
                    case ZOOM_LEVEL.CENTURY:
                        zoomCorrection = 100;
                        break;
                    case ZOOM_LEVEL.DECADE:
                        zoomCorrection = 10;
                        break;
                    default:
                        zoomCorrection = 1
                }
                return parseInt(endDate.getFullYear() / zoomCorrection) - parseInt(startDate.getFullYear() / zoomCorrection)
            },
            _getMonthsOffset: function(startDate, endDate) {
                var yearOffset = endDate.getFullYear() - startDate.getFullYear();
                var monthOffset = endDate.getMonth() - startDate.getMonth();
                return 12 * yearOffset + monthOffset
            },
            _waitRenderView: function(offset) {
                var _this = this;
                if (this._alreadyViewRender) {
                    return
                }
                this._alreadyViewRender = true;
                var date = this._getDateByOffset(offset * this._getRtlCorrection());
                this._moveToClosestAvailableDate(date);
                this._waitRenderViewTimeout = setTimeout(function() {
                    _this._alreadyViewRender = false
                })
            },
            _getRtlCorrection: function() {
                return this.option("rtlEnabled") ? -1 : 1
            },
            _getDateByOffset: function(offset, date) {
                var _date;
                date = this._getDate(null !== (_date = date) && void 0 !== _date ? _date : this.option("currentDate"));
                var currentDay = date.getDate();
                var difference = _date2.default.getDifferenceInMonth(this.option("zoomLevel")) * offset;
                date.setDate(1);
                date.setMonth(date.getMonth() + difference);
                var lastDay = _date2.default.getLastMonthDate(date).getDate();
                date.setDate(currentDay > lastDay ? lastDay : currentDay);
                return date
            },
            _focusTarget: function() {
                return this.$element()
            },
            _initMarkup: function() {
                this._renderSubmitElement();
                this.callBase();
                var $element = this.$element();
                $element.addClass(CALENDAR_CLASS);
                this._renderBody();
                $element.append(this.$body);
                this._renderViews();
                this._renderNavigator();
                $element.append(this._navigator.$element());
                this._renderSwipeable();
                this._renderFooter();
                this._updateAriaSelected();
                this._updateAriaId();
                this._moveToClosestAvailableDate()
            },
            _render: function() {
                this.callBase();
                this._setViewContoured(this.option("currentDate"))
            },
            _renderBody: function() {
                if (!this._$viewsWrapper) {
                    this.$body = (0, _renderer.default)("<div>").addClass(CALENDAR_BODY_CLASS);
                    this._$viewsWrapper = (0, _renderer.default)("<div>").addClass(CALENDAR_VIEWS_WRAPPER_CLASS);
                    this.$body.append(this._$viewsWrapper)
                }
            },
            _getKeyboardListeners: function() {
                return this.callBase().concat([this._view])
            },
            _renderViews: function() {
                this.$element().addClass(CALENDAR_VIEW_CLASS + "-" + this.option("zoomLevel"));
                var currentDate = this.option("currentDate");
                this._view = this._renderSpecificView(currentDate);
                if ((0, _window.hasWindow)()) {
                    var beforeDate = this._getDateByOffset(-1, currentDate);
                    this._beforeView = this._isViewAvailable(beforeDate) ? this._renderSpecificView(beforeDate) : null;
                    var afterDate = this._getDateByOffset(1, currentDate);
                    afterDate.setDate(1);
                    this._afterView = this._isViewAvailable(afterDate) ? this._renderSpecificView(afterDate) : null
                }
                this._translateViews()
            },
            _renderSpecificView: function(date) {
                var specificView = _uiCalendar2.default[this.option("zoomLevel")];
                var $view = (0, _renderer.default)("<div>").appendTo(this._$viewsWrapper);
                var config = this._viewConfig(date);
                return this._createComponent($view, specificView, config)
            },
            _viewConfig: function(date) {
                var disabledDates = this.option("disabledDates");
                disabledDates = (0, _type.isFunction)(disabledDates) ? this._injectComponent(disabledDates.bind(this)) : disabledDates;
                return {
                    date: date,
                    min: this._getMinDate(),
                    max: this._getMaxDate(),
                    firstDayOfWeek: this.option("firstDayOfWeek"),
                    value: this._dateOption("value"),
                    tabIndex: void 0,
                    focusStateEnabled: this.option("focusStateEnabled"),
                    hoverStateEnabled: this.option("hoverStateEnabled"),
                    disabledDates: disabledDates,
                    onCellClick: this._cellClickHandler.bind(this),
                    cellTemplate: this._getTemplateByOption("cellTemplate"),
                    allowValueSelection: this._isMaxZoomLevel(),
                    _todayDate: this.option("_todayDate")
                }
            },
            _injectComponent: function(func) {
                var that = this;
                return function(params) {
                    (0, _extend.extend)(params, {
                        component: that
                    });
                    return func(params)
                }
            },
            _isViewAvailable: function(date) {
                var zoomLevel = this.option("zoomLevel");
                var min = _date2.default.getViewMinBoundaryDate(zoomLevel, this._getMinDate());
                var max = _date2.default.getViewMaxBoundaryDate(zoomLevel, this._getMaxDate());
                return _date2.default.dateInRange(date, min, max)
            },
            _translateViews: function() {
                (0, _translator.move)(this._view.$element(), {
                    left: 0,
                    top: 0
                });
                this._beforeView && (0, _translator.move)(this._beforeView.$element(), {
                    left: this._getViewPosition(-1),
                    top: 0
                });
                this._afterView && (0, _translator.move)(this._afterView.$element(), {
                    left: this._getViewPosition(1),
                    top: 0
                })
            },
            _getViewPosition: function(coefficient) {
                var rtlCorrection = this.option("rtlEnabled") && !_browser.default.msie ? -1 : 1;
                return 100 * coefficient * rtlCorrection + "%"
            },
            _cellClickHandler: function(e) {
                var zoomLevel = this.option("zoomLevel");
                var nextView = _date2.default.getViewDown(zoomLevel);
                var isMaxZoomLevel = this._isMaxZoomLevel();
                if (nextView && !isMaxZoomLevel) {
                    this._navigateDown(e.event.currentTarget)
                } else {
                    var newValue = this._updateTimeComponent(e.value);
                    this._dateValue(newValue, e.event);
                    this._cellClickAction(e)
                }
            },
            _updateTimeComponent: function(date) {
                var result = _date2.default.createDate(date);
                var currentValue = this._dateOption("value");
                if (currentValue) {
                    result.setHours(currentValue.getHours());
                    result.setMinutes(currentValue.getMinutes());
                    result.setSeconds(currentValue.getSeconds());
                    result.setMilliseconds(currentValue.getMilliseconds())
                }
                return result
            },
            _isMaxZoomLevel: function() {
                return this.option("zoomLevel") === this.option("maxZoomLevel")
            },
            _navigateDown: function(cell) {
                var zoomLevel = this.option("zoomLevel");
                if (this._isMaxZoomLevel()) {
                    return
                }
                var nextView = _date2.default.getViewDown(zoomLevel);
                if (!nextView) {
                    return
                }
                var newCurrentDate = this._view.option("contouredDate") || this._view.option("date");
                if (cell) {
                    newCurrentDate = (0, _renderer.default)(cell).data(CALENDAR_DATE_VALUE_KEY)
                }
                this._isOtherViewCellClicked = true;
                this.option("currentDate", newCurrentDate);
                this.option("zoomLevel", nextView);
                this._isOtherViewCellClicked = false;
                this._renderNavigator();
                this._animateShowView();
                this._moveToClosestAvailableDate();
                this._setViewContoured(this._getNormalizedDate(this.option("currentDate")))
            },
            _renderNavigator: function() {
                if (!this._navigator) {
                    this._navigator = new _uiCalendar.default((0, _renderer.default)("<div>"), this._navigatorConfig())
                }
                this._navigator.option("text", this._view.getNavigatorCaption());
                this._updateButtonsVisibility()
            },
            _navigatorConfig: function() {
                return {
                    text: this._view.getNavigatorCaption(),
                    onClick: this._navigatorClickHandler.bind(this),
                    onCaptionClick: this._navigateUp.bind(this),
                    rtlEnabled: this.option("rtlEnabled")
                }
            },
            _navigatorClickHandler: function(e) {
                var currentDate = this._getDateByOffset(e.direction, this.option("currentDate"));
                this._moveToClosestAvailableDate(currentDate)
            },
            _navigateUp: function() {
                var zoomLevel = this.option("zoomLevel");
                var nextView = _date2.default.getViewUp(zoomLevel);
                if (!nextView || this._isMinZoomLevel(zoomLevel)) {
                    return
                }
                this.option("zoomLevel", nextView);
                this._renderNavigator();
                this._animateShowView();
                this._moveToClosestAvailableDate();
                this._setViewContoured(this._getNormalizedDate(this.option("currentDate")))
            },
            _isMinZoomLevel: function(zoomLevel) {
                var min = this._getMinDate();
                var max = this._getMaxDate();
                return _date2.default.sameView(zoomLevel, min, max) || this.option("minZoomLevel") === zoomLevel
            },
            _updateButtonsVisibility: function() {
                this._navigator.toggleButton("next", !(0, _type.isDefined)(this._getRequiredView("next")));
                this._navigator.toggleButton("prev", !(0, _type.isDefined)(this._getRequiredView("prev")))
            },
            _renderSwipeable: function() {
                if (!this._swipeable) {
                    this._swipeable = this._createComponent(this.$element(), _swipeable.default, {
                        onStart: this._swipeStartHandler.bind(this),
                        onUpdated: this._swipeUpdateHandler.bind(this),
                        onEnd: this._swipeEndHandler.bind(this),
                        itemSizeFunc: this._viewWidth.bind(this)
                    })
                }
            },
            _swipeStartHandler: function(e) {
                _fx.default.stop(this._$viewsWrapper, true);
                e.event.maxLeftOffset = this._getRequiredView("next") ? 1 : 0;
                e.event.maxRightOffset = this._getRequiredView("prev") ? 1 : 0
            },
            _getRequiredView: function(name) {
                var view;
                var isRtl = this.option("rtlEnabled");
                if ("next" === name) {
                    view = isRtl ? this._beforeView : this._afterView
                } else {
                    if ("prev" === name) {
                        view = isRtl ? this._afterView : this._beforeView
                    }
                }
                return view
            },
            _swipeUpdateHandler: function(e) {
                var offset = e.event.offset;
                (0, _translator.move)(this._$viewsWrapper, {
                    left: offset * this._viewWidth(),
                    top: 0
                });
                this._updateNavigatorCaption(offset)
            },
            _swipeEndHandler: function(e) {
                var targetOffset = e.event.targetOffset;
                var moveOffset = !targetOffset ? 0 : targetOffset / Math.abs(targetOffset);
                if (0 === moveOffset) {
                    this._animateWrapper(0, ANIMATION_DURATION_SHOW_VIEW);
                    return
                }
                var date = this._getDateByOffset(-moveOffset * this._getRtlCorrection());
                if (this._isDateInInvalidRange(date)) {
                    if (moveOffset >= 0) {
                        date = new Date(this._getMinDate())
                    } else {
                        date = new Date(this._getMaxDate())
                    }
                }
                this.option("currentDate", date)
            },
            _viewWidth: function() {
                if (!this._viewWidthValue) {
                    this._viewWidthValue = this.$element().width()
                }
                return this._viewWidthValue
            },
            _updateNavigatorCaption: function(offset) {
                offset *= this._getRtlCorrection();
                var view = this._view;
                if (offset > .5 && this._beforeView) {
                    view = this._beforeView
                } else {
                    if (offset < -.5 && this._afterView) {
                        view = this._afterView
                    }
                }
                this._navigator.option("text", view.getNavigatorCaption())
            },
            _isDateInInvalidRange: function(date) {
                if (this._view.isBoundary(date)) {
                    return
                }
                var min = this._getMinDate();
                var max = this._getMaxDate();
                var normalizedDate = _date2.default.normalizeDate(date, min, max);
                return normalizedDate === min || normalizedDate === max
            },
            _renderFooter: function() {
                var showTodayButton = this.option("showTodayButton");
                if (showTodayButton) {
                    var $todayButton = this._createComponent((0, _renderer.default)("<a>"), _button.default, {
                        focusStateEnabled: false,
                        text: _message.default.format("dxCalendar-todayButtonText"),
                        onClick: function(args) {
                            this._toTodayView(args)
                        }.bind(this),
                        integrationOptions: {}
                    }).$element().addClass(CALENDAR_TODAY_BUTTON_CLASS);
                    this._$footer = (0, _renderer.default)("<div>").addClass(CALENDAR_FOOTER_CLASS).append($todayButton);
                    this.$element().append(this._$footer)
                }
                this.$element().toggleClass(CALENDAR_HAS_FOOTER_CLASS, showTodayButton)
            },
            _renderSubmitElement: function() {
                this._$submitElement = (0, _renderer.default)("<input>").attr("type", "hidden").appendTo(this.$element());
                this._setSubmitValue(this.option("value"))
            },
            _setSubmitValue: function(value) {
                var dateValue = this._convertToDate(value);
                this._getSubmitElement().val(_date_serialization.default.serializeDate(dateValue, CALENDAR_INPUT_STANDARD_PATTERN))
            },
            _getSubmitElement: function() {
                return this._$submitElement
            },
            _animateShowView: function() {
                _fx.default.stop(this._view.$element(), true);
                return this._popAnimationView(this._view, POP_ANIMATION_FROM, POP_ANIMATION_TO, ANIMATION_DURATION_SHOW_VIEW).promise()
            },
            _popAnimationView: function(view, from, to, duration) {
                return _fx.default.animate(view.$element(), {
                    type: "pop",
                    from: {
                        scale: from,
                        opacity: from
                    },
                    to: {
                        scale: to,
                        opacity: to
                    },
                    duration: duration
                })
            },
            _navigate: function(offset, value) {
                if (0 !== offset && 1 !== Math.abs(offset) && this._isViewAvailable(value)) {
                    var newView = this._renderSpecificView(value);
                    if (offset > 0) {
                        this._afterView && this._afterView.$element().remove();
                        this._afterView = newView
                    } else {
                        this._beforeView && this._beforeView.$element().remove();
                        this._beforeView = newView
                    }
                    this._translateViews()
                }
                var rtlCorrection = this._getRtlCorrection();
                var offsetSign = offset > 0 ? 1 : offset < 0 ? -1 : 0;
                var endPosition = -rtlCorrection * offsetSign * this._viewWidth();
                var viewsWrapperPosition = this._$viewsWrapper.position().left;
                if (viewsWrapperPosition !== endPosition) {
                    if (this._preventViewChangeAnimation) {
                        this._wrapperAnimationEndHandler(offset, value)
                    } else {
                        this._animateWrapper(endPosition, ANIMATION_DURATION_SHOW_VIEW).done(this._wrapperAnimationEndHandler.bind(this, offset, value))
                    }
                }
            },
            _animateWrapper: function(to, duration) {
                return _fx.default.animate(this._$viewsWrapper, {
                    type: "slide",
                    from: {
                        left: this._$viewsWrapper.position().left
                    },
                    to: {
                        left: to
                    },
                    duration: duration
                })
            },
            _getDate: function(value) {
                var result = _date2.default.createDate(value);
                if (isIE11 && (0, _type.isDate)(value)) {
                    result.setMilliseconds(0)
                }
                return result
            },
            _toTodayView: function(args) {
                this._saveValueChangeEvent(args.event);
                var today = new Date;
                if (this._isMaxZoomLevel()) {
                    this._dateOption("value", today);
                    return
                }
                this._preventViewChangeAnimation = true;
                this.option("zoomLevel", this.option("maxZoomLevel"));
                this._dateOption("value", today);
                this._animateShowView();
                this._preventViewChangeAnimation = false
            },
            _wrapperAnimationEndHandler: function(offset, newDate) {
                this._rearrangeViews(offset);
                this._translateViews();
                this._resetLocation();
                this._renderNavigator();
                this._setViewContoured(newDate);
                this._updateAriaId(newDate)
            },
            _rearrangeViews: function(offset) {
                if (0 === offset) {
                    return
                }
                var viewOffset;
                var viewToCreateKey;
                var viewToRemoveKey;
                if (offset < 0) {
                    viewOffset = 1;
                    viewToCreateKey = "_beforeView";
                    viewToRemoveKey = "_afterView"
                } else {
                    viewOffset = -1;
                    viewToCreateKey = "_afterView";
                    viewToRemoveKey = "_beforeView"
                }
                if (!this[viewToCreateKey]) {
                    return
                }
                var destinationDate = this[viewToCreateKey].option("date");
                if (this[viewToRemoveKey]) {
                    this[viewToRemoveKey].$element().remove()
                }
                if (offset === viewOffset) {
                    this[viewToRemoveKey] = this._view
                } else {
                    this[viewToRemoveKey] = this._renderSpecificView(this._getDateByOffset(viewOffset, destinationDate));
                    this._view.$element().remove()
                }
                this._view = this[viewToCreateKey];
                var dateByOffset = this._getDateByOffset(-viewOffset, destinationDate);
                this[viewToCreateKey] = this._isViewAvailable(dateByOffset) ? this._renderSpecificView(dateByOffset) : null
            },
            _resetLocation: function() {
                (0, _translator.move)(this._$viewsWrapper, {
                    left: 0,
                    top: 0
                })
            },
            _clean: function() {
                this.callBase();
                this._clearViewWidthCache();
                delete this._$viewsWrapper;
                delete this._navigator;
                delete this._$footer
            },
            _clearViewWidthCache: function() {
                delete this._viewWidthValue
            },
            _disposeViews: function() {
                this._view.$element().remove();
                this._beforeView && this._beforeView.$element().remove();
                this._afterView && this._afterView.$element().remove();
                delete this._view;
                delete this._beforeView;
                delete this._afterView
            },
            _dispose: function() {
                clearTimeout(this._waitRenderViewTimeout);
                this.callBase()
            },
            _refreshViews: function() {
                this._disposeViews();
                this._renderViews()
            },
            _visibilityChanged: function() {
                this._translateViews()
            },
            _focusInHandler: function() {
                this.callBase.apply(this, arguments);
                this._view.option("contouredDate", this.option("currentDate"))
            },
            _focusOutHandler: function() {
                this.callBase.apply(this, arguments);
                this._view.option("contouredDate", null)
            },
            _updateViewsValue: function(value) {
                var newValue = value ? new Date(value) : null;
                this._view.option("value", newValue);
                this._beforeView && this._beforeView.option("value", newValue);
                this._afterView && this._afterView.option("value", newValue)
            },
            _updateAriaSelected: function(value, previousValue) {
                var _value;
                value = null !== (_value = value) && void 0 !== _value ? _value : this._dateOption("value");
                var $prevSelectedCell = this._view._getCellByDate(previousValue);
                var $selectedCell = this._view._getCellByDate(value);
                this.setAria("selected", void 0, $prevSelectedCell);
                this.setAria("selected", true, $selectedCell);
                if (value && this.option("currentDate").getTime() === value.getTime()) {
                    this._updateAriaId(value)
                }
            },
            _updateAriaId: function(value) {
                var _value2;
                value = null !== (_value2 = value) && void 0 !== _value2 ? _value2 : this.option("currentDate");
                var ariaId = "dx-" + new _guid.default;
                var $newCell = this._view._getCellByDate(value);
                this.setAria("id", ariaId, $newCell);
                this.setAria("activedescendant", ariaId);
                this._onContouredChanged(ariaId)
            },
            _suppressingNavigation: function(callback, args) {
                this._suppressNavigation = true;
                callback.apply(this, args);
                delete this._suppressNavigation
            },
            _optionChanged: function(args) {
                var value = args.value;
                var previousValue = args.previousValue;
                switch (args.name) {
                    case "width":
                        this.callBase(args);
                        this._clearViewWidthCache();
                        break;
                    case "min":
                    case "max":
                        this.min = void 0;
                        this.max = void 0;
                        this._suppressingNavigation(this._updateCurrentDate, [this.option("currentDate")]);
                        this._refreshViews();
                        this._renderNavigator();
                        break;
                    case "firstDayOfWeek":
                        this._refreshViews();
                        this._updateButtonsVisibility();
                        break;
                    case "currentDate":
                        this.setAria("id", void 0, this._view._getCellByDate(previousValue));
                        this._updateCurrentDate(value);
                        break;
                    case "zoomLevel":
                        this.$element().removeClass(CALENDAR_VIEW_CLASS + "-" + previousValue);
                        this._correctZoomLevel();
                        this._refreshViews();
                        this._renderNavigator();
                        this._updateAriaId();
                        break;
                    case "minZoomLevel":
                    case "maxZoomLevel":
                        this._correctZoomLevel();
                        this._updateButtonsVisibility();
                        break;
                    case "value":
                        value = this._convertToDate(value);
                        previousValue = this._convertToDate(previousValue);
                        this._updateAriaSelected(value, previousValue);
                        this.option("currentDate", (0, _type.isDefined)(value) ? _date2.default.createDate(value) : new Date);
                        this._updateViewsValue(value);
                        this._setSubmitValue(value);
                        this.callBase(args);
                        break;
                    case "onCellClick":
                        this._view.option("onCellClick", value);
                        break;
                    case "onContouredChanged":
                        this._onContouredChanged = this._createActionByOption("onContouredChanged");
                        break;
                    case "disabledDates":
                    case "dateSerializationFormat":
                    case "cellTemplate":
                    case "showTodayButton":
                        this._invalidate();
                        break;
                    case "hasFocus":
                        break;
                    case "_todayDate":
                        this._refreshViews();
                        break;
                    default:
                        this.callBase(args)
                }
            }
        });
        (0, _component_registrator.default)("dxCalendar", Calendar);
        var _default = Calendar;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/calendar/ui.calendar.navigator.js ***!
      \***********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _button = _interopRequireDefault(__webpack_require__( /*! ../button */ 37));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var CALENDAR_NAVIGATOR_CLASS = "dx-calendar-navigator";
        var CALENDAR_NAVIGATOR_PREVIOUS_MONTH_CLASS = "dx-calendar-navigator-previous-month";
        var CALENDAR_NAVIGATOR_NEXT_MONTH_CLASS = "dx-calendar-navigator-next-month";
        var CALENDAR_NAVIGATOR_PREVIOUS_VIEW_CLASS = "dx-calendar-navigator-previous-view";
        var CALENDAR_NAVIGATOR_NEXT_VIEW_CLASS = "dx-calendar-navigator-next-view";
        var CALENDAR_NAVIGATOR_DISABLED_LINK_CLASS = "dx-calendar-disabled-navigator-link";
        var CALENDAR_NAVIGATOR_CAPTION_BUTTON_CLASS = "dx-calendar-caption-button";
        var Navigator = _ui.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    onClick: null,
                    onCaptionClick: null,
                    text: ""
                })
            },
            _init: function() {
                this.callBase();
                this._initActions()
            },
            _initActions: function() {
                this._clickAction = this._createActionByOption("onClick");
                this._captionClickAction = this._createActionByOption("onCaptionClick")
            },
            _initMarkup: function() {
                this.callBase();
                this.$element().addClass(CALENDAR_NAVIGATOR_CLASS);
                this._renderButtons();
                this._renderCaption()
            },
            _renderButtons: function() {
                var that = this;
                var direction = this.option("rtlEnabled") ? -1 : 1;
                this._prevButton = this._createComponent((0, _renderer.default)("<a>"), _button.default, {
                    focusStateEnabled: false,
                    icon: "chevronleft",
                    onClick: function(e) {
                        that._clickAction({
                            direction: -direction,
                            event: e
                        })
                    },
                    integrationOptions: {}
                });
                var $prevButton = this._prevButton.$element().addClass(CALENDAR_NAVIGATOR_PREVIOUS_VIEW_CLASS).addClass(CALENDAR_NAVIGATOR_PREVIOUS_MONTH_CLASS);
                this._nextButton = this._createComponent((0, _renderer.default)("<a>"), _button.default, {
                    focusStateEnabled: false,
                    icon: "chevronright",
                    onClick: function(e) {
                        that._clickAction({
                            direction: direction,
                            event: e
                        })
                    },
                    integrationOptions: {}
                });
                var $nextButton = this._nextButton.$element().addClass(CALENDAR_NAVIGATOR_NEXT_VIEW_CLASS).addClass(CALENDAR_NAVIGATOR_NEXT_MONTH_CLASS);
                this._caption = this._createComponent((0, _renderer.default)("<a>").addClass(CALENDAR_NAVIGATOR_CAPTION_BUTTON_CLASS), _button.default, {
                    focusStateEnabled: false,
                    onClick: function(e) {
                        that._captionClickAction({
                            event: e
                        })
                    },
                    integrationOptions: {}
                });
                var $caption = this._caption.$element();
                this.$element().append($prevButton, $caption, $nextButton)
            },
            _renderCaption: function() {
                this._caption.option("text", this.option("text"))
            },
            toggleButton: function(buttonPrefix, value) {
                var buttonName = "_" + buttonPrefix + "Button";
                var button = this[buttonName];
                if (button) {
                    button.option("disabled", value);
                    button.$element().toggleClass(CALENDAR_NAVIGATOR_DISABLED_LINK_CLASS, value)
                }
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "text":
                        this._renderCaption();
                        break;
                    default:
                        this.callBase(args)
                }
            }
        });
        var _default = Navigator;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/calendar/ui.calendar.views.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _uiCalendar = _interopRequireDefault(__webpack_require__( /*! ./ui.calendar.base_view */ 612));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _date2 = _interopRequireDefault(__webpack_require__( /*! ../../localization/date */ 32));
        var _date_serialization = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date_serialization */ 57));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var CALENDAR_OTHER_MONTH_CLASS = "dx-calendar-other-month";
        var CALENDAR_OTHER_VIEW_CLASS = "dx-calendar-other-view";
        var Views = {
            month: _uiCalendar.default.inherit({
                _getViewName: function() {
                    return "month"
                },
                _getDefaultOptions: function() {
                    return (0, _extend.extend)(this.callBase(), {
                        firstDayOfWeek: void 0,
                        rowCount: 6,
                        colCount: 7
                    })
                },
                _renderImpl: function() {
                    this.callBase();
                    this._renderHeader()
                },
                _renderBody: function() {
                    this.callBase();
                    this._$table.find(".".concat(CALENDAR_OTHER_VIEW_CLASS)).addClass(CALENDAR_OTHER_MONTH_CLASS)
                },
                _renderFocusTarget: _common.noop,
                getCellAriaLabel: function(date) {
                    return _date2.default.format(date, "longdate")
                },
                _renderHeader: function() {
                    var $headerRow = (0, _renderer.default)("<tr>");
                    var $header = (0, _renderer.default)("<thead>").append($headerRow);
                    this._$table.prepend($header);
                    for (var colIndex = 0, colCount = this.option("colCount"); colIndex < colCount; colIndex++) {
                        this._renderHeaderCell(colIndex, $headerRow)
                    }
                },
                _renderHeaderCell: function(cellIndex, $headerRow) {
                    var _this$_getDayCaption = this._getDayCaption(this._getFirstDayOfWeek() + cellIndex),
                        fullCaption = _this$_getDayCaption.full,
                        abbrCaption = _this$_getDayCaption.abbreviated;
                    var $cell = (0, _renderer.default)("<th>").attr({
                        scope: "col",
                        abbr: fullCaption
                    }).text(abbrCaption);
                    this._appendCell($headerRow, $cell)
                },
                getNavigatorCaption: function() {
                    return _date2.default.format(this.option("date"), "monthandyear")
                },
                _isTodayCell: function(cellDate) {
                    var today = this.option("_todayDate")();
                    return _date.default.sameDate(cellDate, today)
                },
                _isDateOutOfRange: function(cellDate) {
                    var minDate = this.option("min");
                    var maxDate = this.option("max");
                    return !_date.default.dateInRange(cellDate, minDate, maxDate, "date")
                },
                _isOtherView: function(cellDate) {
                    return cellDate.getMonth() !== this.option("date").getMonth()
                },
                _getCellText: function(cellDate) {
                    return _date2.default.format(cellDate, "d")
                },
                _getDayCaption: function(day) {
                    var daysInWeek = this.option("colCount");
                    var dayIndex = day % daysInWeek;
                    return {
                        full: _date2.default.getDayNames()[dayIndex],
                        abbreviated: _date2.default.getDayNames("abbreviated")[dayIndex]
                    }
                },
                _getFirstCellData: function() {
                    var firstDay = _date.default.getFirstMonthDate(this.option("date"));
                    var firstMonthDayOffset = this._getFirstDayOfWeek() - firstDay.getDay();
                    var daysInWeek = this.option("colCount");
                    if (firstMonthDayOffset >= 0) {
                        firstMonthDayOffset -= daysInWeek
                    }
                    firstDay.setDate(firstDay.getDate() + firstMonthDayOffset);
                    return firstDay
                },
                _getNextCellData: function(date) {
                    date = _date.default.createDate(date);
                    date.setDate(date.getDate() + 1);
                    return date
                },
                _getFirstDayOfWeek: function() {
                    return (0, _type.isDefined)(this.option("firstDayOfWeek")) ? this.option("firstDayOfWeek") : _date2.default.firstDayOfWeekIndex()
                },
                _getCellByDate: function(date) {
                    return this._$table.find("td[data-value='".concat(_date_serialization.default.serializeDate(date, _date.default.getShortDateFormat()), "']"))
                },
                isBoundary: function(date) {
                    return _date.default.sameMonthAndYear(date, this.option("min")) || _date.default.sameMonthAndYear(date, this.option("max"))
                },
                _getDefaultDisabledDatesHandler: function(disabledDates) {
                    return function(args) {
                        var isDisabledDate = disabledDates.some(function(item) {
                            return _date.default.sameDate(item, args.date)
                        });
                        if (isDisabledDate) {
                            return true
                        }
                    }
                }
            }),
            year: _uiCalendar.default.inherit({
                _getViewName: function() {
                    return "year"
                },
                _isTodayCell: function(cellDate) {
                    var today = this.option("_todayDate")();
                    return _date.default.sameMonthAndYear(cellDate, today)
                },
                _isDateOutOfRange: function(cellDate) {
                    return !_date.default.dateInRange(cellDate, _date.default.getFirstMonthDate(this.option("min")), _date.default.getLastMonthDate(this.option("max")))
                },
                _isOtherView: function() {
                    return false
                },
                _getCellText: function(cellDate) {
                    return _date2.default.getMonthNames("abbreviated")[cellDate.getMonth()]
                },
                _getFirstCellData: function() {
                    var currentDate = this.option("date");
                    var data = _date.default.createDate(currentDate);
                    data.setDate(1);
                    data.setMonth(0);
                    return data
                },
                _getNextCellData: function(date) {
                    date = _date.default.createDate(date);
                    date.setMonth(date.getMonth() + 1);
                    return date
                },
                _getCellByDate: function(date) {
                    var foundDate = _date.default.createDate(date);
                    foundDate.setDate(1);
                    return this._$table.find("td[data-value='".concat(_date_serialization.default.serializeDate(foundDate, _date.default.getShortDateFormat()), "']"))
                },
                getCellAriaLabel: function(date) {
                    return _date2.default.format(date, "monthandyear")
                },
                getNavigatorCaption: function() {
                    return _date2.default.format(this.option("date"), "yyyy")
                },
                isBoundary: function(date) {
                    return _date.default.sameYear(date, this.option("min")) || _date.default.sameYear(date, this.option("max"))
                }
            }),
            decade: _uiCalendar.default.inherit({
                _getViewName: function() {
                    return "decade"
                },
                _isTodayCell: function(cellDate) {
                    var today = this.option("_todayDate")();
                    return _date.default.sameYear(cellDate, today)
                },
                _isDateOutOfRange: function(cellDate) {
                    var min = this.option("min");
                    var max = this.option("max");
                    return !_date.default.dateInRange(cellDate.getFullYear(), min && min.getFullYear(), max && max.getFullYear())
                },
                _isOtherView: function(cellDate) {
                    var date = _date.default.createDate(cellDate);
                    date.setMonth(1);
                    return !_date.default.sameDecade(date, this.option("date"))
                },
                _getCellText: function(cellDate) {
                    return _date2.default.format(cellDate, "yyyy")
                },
                _getFirstCellData: function() {
                    var year = _date.default.getFirstYearInDecade(this.option("date")) - 1;
                    return _date.default.createDateWithFullYear(year, 0, 1)
                },
                _getNextCellData: function(date) {
                    date = _date.default.createDate(date);
                    date.setFullYear(date.getFullYear() + 1);
                    return date
                },
                getNavigatorCaption: function() {
                    var currentDate = this.option("date");
                    var firstYearInDecade = _date.default.getFirstYearInDecade(currentDate);
                    var startDate = _date.default.createDate(currentDate);
                    var endDate = _date.default.createDate(currentDate);
                    startDate.setFullYear(firstYearInDecade);
                    endDate.setFullYear(firstYearInDecade + 9);
                    return _date2.default.format(startDate, "yyyy") + "-" + _date2.default.format(endDate, "yyyy")
                },
                _isValueOnCurrentView: function(currentDate, value) {
                    return _date.default.sameDecade(currentDate, value)
                },
                _getCellByDate: function(date) {
                    var foundDate = _date.default.createDate(date);
                    foundDate.setDate(1);
                    foundDate.setMonth(0);
                    return this._$table.find("td[data-value='".concat(_date_serialization.default.serializeDate(foundDate, _date.default.getShortDateFormat()), "']"))
                },
                isBoundary: function(date) {
                    return _date.default.sameDecade(date, this.option("min")) || _date.default.sameDecade(date, this.option("max"))
                }
            }),
            century: _uiCalendar.default.inherit({
                _getViewName: function() {
                    return "century"
                },
                _isTodayCell: function(cellDate) {
                    var today = this.option("_todayDate")();
                    return _date.default.sameDecade(cellDate, today)
                },
                _isDateOutOfRange: function(cellDate) {
                    var decade = _date.default.getFirstYearInDecade(cellDate);
                    var minDecade = _date.default.getFirstYearInDecade(this.option("min"));
                    var maxDecade = _date.default.getFirstYearInDecade(this.option("max"));
                    return !_date.default.dateInRange(decade, minDecade, maxDecade)
                },
                _isOtherView: function(cellDate) {
                    var date = _date.default.createDate(cellDate);
                    date.setMonth(1);
                    return !_date.default.sameCentury(date, this.option("date"))
                },
                _getCellText: function(cellDate) {
                    var startDate = _date2.default.format(cellDate, "yyyy");
                    var endDate = _date.default.createDate(cellDate);
                    endDate.setFullYear(endDate.getFullYear() + 9);
                    return startDate + " - " + _date2.default.format(endDate, "yyyy")
                },
                _getFirstCellData: function() {
                    var decade = _date.default.getFirstDecadeInCentury(this.option("date")) - 10;
                    return _date.default.createDateWithFullYear(decade, 0, 1)
                },
                _getNextCellData: function(date) {
                    date = _date.default.createDate(date);
                    date.setFullYear(date.getFullYear() + 10);
                    return date
                },
                _getCellByDate: function(date) {
                    var foundDate = _date.default.createDate(date);
                    foundDate.setDate(1);
                    foundDate.setMonth(0);
                    foundDate.setFullYear(_date.default.getFirstYearInDecade(foundDate));
                    return this._$table.find("td[data-value='".concat(_date_serialization.default.serializeDate(foundDate, _date.default.getShortDateFormat()), "']"))
                },
                getNavigatorCaption: function() {
                    var currentDate = this.option("date");
                    var firstDecadeInCentury = _date.default.getFirstDecadeInCentury(currentDate);
                    var startDate = _date.default.createDate(currentDate);
                    var endDate = _date.default.createDate(currentDate);
                    startDate.setFullYear(firstDecadeInCentury);
                    endDate.setFullYear(firstDecadeInCentury + 99);
                    return _date2.default.format(startDate, "yyyy") + "-" + _date2.default.format(endDate, "yyyy")
                },
                isBoundary: function(date) {
                    return _date.default.sameCentury(date, this.option("min")) || _date.default.sameCentury(date, this.option("max"))
                }
            })
        };
        var _default = Views;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/calendar/ui.calendar.base_view.js ***!
      \***********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _element_data = __webpack_require__( /*! ../../core/element_data */ 40);
        var _element = __webpack_require__( /*! ../../core/element */ 18);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _date_serialization = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date_serialization */ 57));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _click = __webpack_require__( /*! ../../events/click */ 21);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var abstract = _ui.default.abstract;
        var CALENDAR_OTHER_VIEW_CLASS = "dx-calendar-other-view";
        var CALENDAR_CELL_CLASS = "dx-calendar-cell";
        var CALENDAR_EMPTY_CELL_CLASS = "dx-calendar-empty-cell";
        var CALENDAR_TODAY_CLASS = "dx-calendar-today";
        var CALENDAR_SELECTED_DATE_CLASS = "dx-calendar-selected-date";
        var CALENDAR_CONTOURED_DATE_CLASS = "dx-calendar-contoured-date";
        var CALENDAR_DXCLICK_EVENT_NAME = (0, _index.addNamespace)(_click.name, "dxCalendar");
        var CALENDAR_DATE_VALUE_KEY = "dxDateValueKey";
        var BaseView = _ui.default.inherit({
            _getViewName: function() {
                return "base"
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    date: new Date,
                    focusStateEnabled: false,
                    cellTemplate: null,
                    disabledDates: null,
                    onCellClick: null,
                    rowCount: 3,
                    colCount: 4,
                    allowValueSelection: true,
                    _todayDate: function() {
                        return new Date
                    }
                })
            },
            _initMarkup: function() {
                this.callBase();
                this._renderImpl()
            },
            _renderImpl: function() {
                this.$element().append(this._createTable());
                this._createDisabledDatesHandler();
                this._renderBody();
                this._renderContouredDate();
                this._renderValue();
                this._renderEvents()
            },
            _createTable: function() {
                this._$table = (0, _renderer.default)("<table>");
                this.setAria({
                    label: _message.default.format("dxCalendar-ariaWidgetName"),
                    role: "grid"
                }, this._$table);
                return this._$table
            },
            _renderBody: function() {
                this.$body = (0, _renderer.default)("<tbody>").appendTo(this._$table);
                var rowData = {
                    cellDate: this._getFirstCellData(),
                    prevCellDate: null
                };
                for (var rowIndex = 0, rowCount = this.option("rowCount"); rowIndex < rowCount; rowIndex++) {
                    rowData.row = this._createRow();
                    for (var colIndex = 0, colCount = this.option("colCount"); colIndex < colCount; colIndex++) {
                        this._renderCell(rowData, colIndex)
                    }
                }
            },
            _createRow: function() {
                var row = _dom_adapter.default.createElement("tr");
                this.setAria("role", "row", (0, _renderer.default)(row));
                this.$body.get(0).appendChild(row);
                return row
            },
            _appendCell: function(row, cell) {
                if (!this._appendMethodName) {
                    this._cacheAppendMethodName()
                }(0, _renderer.default)(row)[this._appendMethodName](cell)
            },
            _cacheAppendMethodName: function(rtlEnabled) {
                this._appendMethodName = (null !== rtlEnabled && void 0 !== rtlEnabled ? rtlEnabled : this.option("rtlEnabled")) ? "prepend" : "append"
            },
            _createCell: function(cellDate) {
                var cell = _dom_adapter.default.createElement("td");
                var $cell = (0, _renderer.default)(cell);
                cell.className = this._getClassNameByDate(cellDate);
                cell.setAttribute("data-value", _date_serialization.default.serializeDate(cellDate, _date.default.getShortDateFormat()));
                (0, _element_data.data)(cell, CALENDAR_DATE_VALUE_KEY, cellDate);
                this.setAria({
                    role: "gridcell",
                    label: this.getCellAriaLabel(cellDate)
                }, $cell);
                return {
                    cell: cell,
                    $cell: $cell
                }
            },
            _renderCell: function(params, cellIndex) {
                var cellDate = params.cellDate,
                    prevCellDate = params.prevCellDate,
                    row = params.row;
                if (prevCellDate) {
                    _date.default.fixTimezoneGap(prevCellDate, cellDate)
                }
                params.prevCellDate = cellDate;
                var _this$_createCell = this._createCell(cellDate),
                    cell = _this$_createCell.cell,
                    $cell = _this$_createCell.$cell;
                var cellTemplate = this.option("cellTemplate");
                this._appendCell(row, cell);
                if (cellTemplate) {
                    cellTemplate.render(this._prepareCellTemplateData(cellDate, cellIndex, $cell))
                } else {
                    cell.innerHTML = this._getCellText(cellDate)
                }
                params.cellDate = this._getNextCellData(cellDate)
            },
            _getClassNameByDate: function(cellDate) {
                var className = CALENDAR_CELL_CLASS;
                if (this._isTodayCell(cellDate)) {
                    className += " ".concat(CALENDAR_TODAY_CLASS)
                }
                if (this._isDateOutOfRange(cellDate) || this.isDateDisabled(cellDate)) {
                    className += " ".concat(CALENDAR_EMPTY_CELL_CLASS)
                }
                if (this._isOtherView(cellDate)) {
                    className += " ".concat(CALENDAR_OTHER_VIEW_CLASS)
                }
                return className
            },
            _prepareCellTemplateData: function(cellDate, cellIndex, $cell) {
                return {
                    model: {
                        text: this._getCellText(cellDate),
                        date: cellDate,
                        view: this._getViewName()
                    },
                    container: (0, _element.getPublicElement)($cell),
                    index: cellIndex
                }
            },
            _renderEvents: function() {
                var _this = this;
                this._createCellClickAction();
                _events_engine.default.off(this._$table, CALENDAR_DXCLICK_EVENT_NAME);
                _events_engine.default.on(this._$table, CALENDAR_DXCLICK_EVENT_NAME, "td", function(e) {
                    if (!(0, _renderer.default)(e.currentTarget).hasClass(CALENDAR_EMPTY_CELL_CLASS)) {
                        _this._cellClickAction({
                            event: e,
                            value: (0, _renderer.default)(e.currentTarget).data(CALENDAR_DATE_VALUE_KEY)
                        })
                    }
                })
            },
            _createCellClickAction: function() {
                this._cellClickAction = this._createActionByOption("onCellClick")
            },
            _createDisabledDatesHandler: function() {
                var disabledDates = this.option("disabledDates");
                this._disabledDatesHandler = Array.isArray(disabledDates) ? this._getDefaultDisabledDatesHandler(disabledDates) : disabledDates || _common.noop
            },
            _getDefaultDisabledDatesHandler: function(disabledDates) {
                return _common.noop
            },
            _isTodayCell: abstract,
            _isDateOutOfRange: abstract,
            isDateDisabled: function(cellDate) {
                var dateParts = {
                    date: cellDate,
                    view: this._getViewName()
                };
                return this._disabledDatesHandler(dateParts)
            },
            _isOtherView: abstract,
            _getCellText: abstract,
            _getFirstCellData: abstract,
            _getNextCellData: abstract,
            _renderContouredDate: function(contouredDate) {
                if (!this.option("focusStateEnabled")) {
                    return
                }
                contouredDate = contouredDate || this.option("contouredDate");
                var $oldContouredCell = this._getContouredCell();
                var $newContouredCell = this._getCellByDate(contouredDate);
                $oldContouredCell.removeClass(CALENDAR_CONTOURED_DATE_CLASS);
                $newContouredCell.addClass(CALENDAR_CONTOURED_DATE_CLASS)
            },
            _getContouredCell: function() {
                return this._$table.find(".".concat(CALENDAR_CONTOURED_DATE_CLASS))
            },
            _changeValue: function(cellDate) {
                if (cellDate) {
                    var value = this.option("value");
                    var newValue = value ? new Date(value) : new Date;
                    newValue.setDate(cellDate.getDate());
                    newValue.setMonth(cellDate.getMonth());
                    newValue.setFullYear(cellDate.getFullYear());
                    newValue.setDate(cellDate.getDate());
                    this.option("value", newValue)
                } else {
                    this.option("value", null)
                }
            },
            _renderValue: function() {
                if (!this.option("allowValueSelection")) {
                    return
                }
                var value = this.option("value");
                var selectedCell = this._getCellByDate(value);
                if (this._selectedCell) {
                    this._selectedCell.removeClass(CALENDAR_SELECTED_DATE_CLASS)
                }
                selectedCell.addClass(CALENDAR_SELECTED_DATE_CLASS);
                this._selectedCell = selectedCell
            },
            getCellAriaLabel: function(date) {
                return this._getCellText(date)
            },
            _getFirstAvailableDate: function() {
                var date = this.option("date");
                var min = this.option("min");
                date = _date.default.getFirstDateView(this._getViewName(), date);
                return new Date(min && date < min ? min : date)
            },
            _getCellByDate: abstract,
            isBoundary: abstract,
            _optionChanged: function(args) {
                var name = args.name,
                    value = args.value;
                switch (name) {
                    case "value":
                        this._renderValue();
                        break;
                    case "contouredDate":
                        this._renderContouredDate(value);
                        break;
                    case "onCellClick":
                        this._createCellClickAction();
                        break;
                    case "disabledDates":
                    case "cellTemplate":
                        this._invalidate();
                        break;
                    case "rtlEnabled":
                        this._cacheAppendMethodName(value);
                        this.callBase(args);
                        break;
                    case "_todayDate":
                        this._renderBody();
                        break;
                    default:
                        this.callBase(args)
                }
            }
        });
        var _default = BaseView;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/color_box/color_box.js ***!
      \************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _color = _interopRequireDefault(__webpack_require__( /*! ../../color */ 95));
        var _color_view = _interopRequireDefault(__webpack_require__( /*! ./color_view */ 354));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../drop_down_editor/ui.drop_down_editor */ 195));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var COLOR_BOX_CLASS = "dx-colorbox";
        var COLOR_BOX_INPUT_CLASS = COLOR_BOX_CLASS + "-input";
        var COLOR_BOX_INPUT_CONTAINER_CLASS = COLOR_BOX_INPUT_CLASS + "-container";
        var COLOR_BOX_COLOR_RESULT_PREVIEW_CLASS = COLOR_BOX_CLASS + "-color-result-preview";
        var COLOR_BOX_COLOR_IS_NOT_DEFINED = COLOR_BOX_CLASS + "-color-is-not-defined";
        var COLOR_BOX_OVERLAY_CLASS = COLOR_BOX_CLASS + "-overlay";
        var COLOR_BOX_CONTAINER_CELL_CLASS = "dx-colorview-container-cell";
        var COLOR_BOX_BUTTON_CELL_CLASS = "dx-colorview-button-cell";
        var COLOR_BOX_BUTTONS_CONTAINER_CLASS = "dx-colorview-buttons-container";
        var COLOR_BOX_APPLY_BUTTON_CLASS = "dx-colorview-apply-button";
        var COLOR_BOX_CANCEL_BUTTON_CLASS = "dx-colorview-cancel-button";
        var colorEditorPrototype = _color_view.default.prototype;
        var colorUtils = {
            makeTransparentBackground: colorEditorPrototype._makeTransparentBackground.bind(colorEditorPrototype),
            makeRgba: colorEditorPrototype._makeRgba.bind(colorEditorPrototype)
        };
        var ColorBox = _ui.default.inherit({
            _supportedKeys: function() {
                var arrowHandler = function(e) {
                    e.stopPropagation();
                    if (this.option("opened")) {
                        e.preventDefault();
                        return true
                    }
                };
                var upArrowHandler = function(e) {
                    if (!this.option("opened")) {
                        e.preventDefault();
                        return false
                    }
                    if (e.altKey) {
                        this.close();
                        return false
                    }
                    return true
                };
                var downArrowHandler = function(e) {
                    if (!this.option("opened") && !e.altKey) {
                        e.preventDefault();
                        return false
                    }
                    if (!this.option("opened") && e.altKey) {
                        this._validatedOpening();
                        return false
                    }
                    return true
                };
                return (0, _extend.extend)(this.callBase(), {
                    tab: function(e) {
                        if (this.option("opened")) {
                            e.preventDefault();
                            this._colorView._rgbInputs[0].focus()
                        }
                    },
                    enter: this._enterKeyHandler,
                    leftArrow: arrowHandler,
                    rightArrow: arrowHandler,
                    upArrow: upArrowHandler,
                    downArrow: downArrowHandler
                })
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    editAlphaChannel: false,
                    applyValueMode: "useButtons",
                    keyStep: 1,
                    fieldTemplate: null,
                    buttonsLocation: "bottom after"
                })
            },
            _popupHidingHandler: function() {
                this.callBase();
                if ("useButtons" === this.option("applyValueMode")) {
                    this._updateColorViewValue(this.option("value"))
                }
            },
            _popupConfig: function() {
                return (0, _extend.extend)(this.callBase(), {
                    width: ""
                })
            },
            _contentReadyHandler: function() {
                this._createColorView();
                this._addPopupBottomClasses()
            },
            _addPopupBottomClasses: function() {
                var $popupBottom = this._popup.bottomToolbar();
                if ($popupBottom) {
                    $popupBottom.addClass(COLOR_BOX_CONTAINER_CELL_CLASS).addClass(COLOR_BOX_BUTTON_CELL_CLASS).find(".dx-toolbar-items-container").addClass(COLOR_BOX_BUTTONS_CONTAINER_CLASS);
                    $popupBottom.find(".dx-popup-done").addClass(COLOR_BOX_APPLY_BUTTON_CLASS);
                    $popupBottom.find(".dx-popup-cancel").addClass(COLOR_BOX_CANCEL_BUTTON_CLASS)
                }
            },
            _createColorView: function() {
                this._popup.overlayContent().addClass(COLOR_BOX_OVERLAY_CLASS);
                var $colorView = (0, _renderer.default)("<div>").appendTo(this._popup.$content());
                this._colorView = this._createComponent($colorView, _color_view.default, this._colorViewConfig());
                this._colorView.registerKeyHandler("escape", this._escapeHandler.bind(this));
                _events_engine.default.on($colorView, "focus", function() {
                    this.focus()
                }.bind(this))
            },
            _escapeHandler: function() {
                this.close();
                this.focus()
            },
            _applyNewColor: function(value) {
                this.option("value", value);
                if (value) {
                    colorUtils.makeTransparentBackground(this._$colorResultPreview, value)
                }
                if (this._colorViewEnterKeyPressed) {
                    this.close();
                    this._colorViewEnterKeyPressed = false
                }
            },
            _colorViewConfig: function() {
                var that = this;
                return {
                    value: that.option("value"),
                    matchValue: that.option("value"),
                    editAlphaChannel: that.option("editAlphaChannel"),
                    applyValueMode: that.option("applyValueMode"),
                    focusStateEnabled: that.option("focusStateEnabled"),
                    stylingMode: this.option("stylingMode"),
                    onEnterKeyPressed: function(_ref) {
                        var event = _ref.event;
                        that._colorViewEnterKeyPressed = true;
                        if (that._colorView.option("value") !== that.option("value")) {
                            that._saveValueChangeEvent(event);
                            that._applyNewColor(that._colorView.option("value"));
                            that.close()
                        }
                    },
                    onValueChanged: function(_ref2) {
                        var event = _ref2.event,
                            value = _ref2.value,
                            previousValue = _ref2.previousValue;
                        var instantlyMode = "instantly" === that.option("applyValueMode");
                        var isOldValue = colorUtils.makeRgba(value) === previousValue;
                        var changesApplied = instantlyMode || that._colorViewEnterKeyPressed;
                        var valueCleared = that._shouldSaveEmptyValue;
                        if (isOldValue || !changesApplied || valueCleared) {
                            return
                        }
                        if (event) {
                            that._saveValueChangeEvent(event)
                        }
                        that._applyNewColor(value)
                    }
                }
            },
            _enterKeyHandler: function(e) {
                var newValue = this._input().val();
                var value = this.option("value");
                var oldValue = this.option("editAlphaChannel") ? colorUtils.makeRgba(value) : value;
                if (!newValue) {
                    return false
                }
                var color = new _color.default(newValue);
                if (color.colorIsInvalid) {
                    this._input().val(oldValue);
                    return
                }
                if (newValue !== oldValue) {
                    this._applyColorFromInput(newValue);
                    this._saveValueChangeEvent(e);
                    this.option("value", this.option("editAlphaChannel") ? colorUtils.makeRgba(newValue) : newValue)
                }
                if (this._colorView) {
                    var colorViewValue = this._colorView.option("value");
                    if (value !== colorViewValue) {
                        this._saveValueChangeEvent(e);
                        this.option("value", colorViewValue)
                    }
                }
                this.close();
                return false
            },
            _applyButtonHandler: function(e) {
                this._saveValueChangeEvent(e.event);
                this._applyNewColor(this._colorView.option("value"));
                this.callBase()
            },
            _cancelButtonHandler: function() {
                this._resetInputValue();
                this.callBase()
            },
            _getKeyboardListeners: function() {
                return this.callBase().concat([this._colorView])
            },
            _init: function() {
                this.callBase()
            },
            _initMarkup: function() {
                this.$element().addClass(COLOR_BOX_CLASS);
                this.callBase()
            },
            _renderInput: function() {
                this.callBase();
                this._input().addClass(COLOR_BOX_INPUT_CLASS);
                this._renderColorPreview()
            },
            _renderColorPreview: function() {
                this.$element().wrapInner((0, _renderer.default)("<div>").addClass(COLOR_BOX_INPUT_CONTAINER_CLASS));
                this._$colorBoxInputContainer = this.$element().children().eq(0);
                this._$colorResultPreview = (0, _renderer.default)("<div>").addClass(COLOR_BOX_COLOR_RESULT_PREVIEW_CLASS).appendTo(this._$textEditorInputContainer);
                if (!this.option("value")) {
                    this._$colorBoxInputContainer.addClass(COLOR_BOX_COLOR_IS_NOT_DEFINED)
                } else {
                    colorUtils.makeTransparentBackground(this._$colorResultPreview, this.option("value"))
                }
            },
            _renderValue: function() {
                var value = this.option("value");
                var convertToColor = null !== value && this.option("editAlphaChannel");
                var text = convertToColor ? colorUtils.makeRgba(value) : value;
                this.option("text", text);
                return this.callBase()
            },
            _resetInputValue: function() {
                var $input = this._input();
                var value = this.option("value");
                $input.val(value);
                this._updateColorViewValue(value)
            },
            _updateColorViewValue: function(value) {
                if (this._colorView) {
                    this._colorView.option({
                        value: value,
                        matchValue: value
                    })
                }
            },
            _valueChangeEventHandler: function(e) {
                var value = this._input().val();
                if (value) {
                    value = this._applyColorFromInput(value);
                    this._updateColorViewValue(value)
                }
                this.callBase(e, value)
            },
            _applyColorFromInput: function(value) {
                var newColor = new _color.default(value);
                if (newColor.colorIsInvalid) {
                    this._resetInputValue();
                    value = this.option("value")
                }
                return value
            },
            _clean: function() {
                this.callBase();
                delete this._shouldSaveEmptyValue
            },
            _optionChanged: function(args) {
                var value = args.value;
                var name = args.name;
                switch (name) {
                    case "value":
                        this._$colorBoxInputContainer.toggleClass(COLOR_BOX_COLOR_IS_NOT_DEFINED, !value);
                        if (value) {
                            colorUtils.makeTransparentBackground(this._$colorResultPreview, value)
                        } else {
                            this._$colorResultPreview.removeAttr("style")
                        }
                        if (null === value) {
                            this._shouldSaveEmptyValue = true
                        }
                        this._updateColorViewValue(value);
                        this._shouldSaveEmptyValue = false;
                        this.callBase(args);
                        break;
                    case "applyButtonText":
                    case "cancelButtonText":
                        this.callBase(args);
                        this._popup && this._addPopupBottomClasses();
                        break;
                    case "editAlphaChannel":
                    case "keyStep":
                        if (this._colorView) {
                            this._colorView.option(name, value)
                        }
                        break;
                    default:
                        this.callBase(args)
                }
            }
        });
        (0, _component_registrator.default)("dxColorBox", ColorBox);
        var _default = ColorBox;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/number_box/number_box.js ***!
      \**************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _number_box = _interopRequireDefault(__webpack_require__( /*! ./number_box.mask */ 615));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }(0, _component_registrator.default)("dxNumberBox", _number_box.default);
        var _default = _number_box.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/number_box/number_box.mask.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _math = __webpack_require__( /*! ../../core/utils/math */ 29);
        var _number = _interopRequireDefault(__webpack_require__( /*! ../../localization/number */ 47));
        var _number_box = __webpack_require__( /*! ./number_box.caret */ 616);
        var _number2 = __webpack_require__( /*! ../../localization/ldml/number */ 323);
        var _number_box2 = _interopRequireDefault(__webpack_require__( /*! ./number_box.base */ 617));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _utils = __webpack_require__( /*! ./utils */ 355);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var NUMBER_FORMATTER_NAMESPACE = "dxNumberFormatter";
        var MOVE_FORWARD = 1;
        var MOVE_BACKWARD = -1;
        var MINUS = "-";
        var MINUS_KEY = "minus";
        var NUMPUD_MINUS_KEY_IE = "Subtract";
        var INPUT_EVENT = "input";
        var CARET_TIMEOUT_DURATION = _browser.default.msie ? 300 : 0;
        var NumberBoxMask = _number_box2.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    useMaskBehavior: true,
                    format: null
                })
            },
            _isDeleteKey: function(key) {
                return "del" === key
            },
            _supportedKeys: function() {
                if (!this._useMaskBehavior()) {
                    return this.callBase()
                }
                var that = this;
                return (0, _extend.extend)(this.callBase(), {
                    minus: that._revertSign.bind(that),
                    del: that._removeHandler.bind(that),
                    backspace: that._removeHandler.bind(that),
                    leftArrow: that._arrowHandler.bind(that, MOVE_BACKWARD),
                    rightArrow: that._arrowHandler.bind(that, MOVE_FORWARD),
                    home: that._moveCaretToBoundaryEventHandler.bind(that, MOVE_FORWARD),
                    enter: that._updateFormattedValue.bind(that),
                    end: that._moveCaretToBoundaryEventHandler.bind(that, MOVE_BACKWARD)
                })
            },
            _getTextSeparatorIndex: function(text) {
                var decimalSeparator = _number.default.getDecimalSeparator();
                var realSeparatorOccurrenceIndex = (0, _utils.getRealSeparatorIndex)(this.option("format")).occurrence;
                return (0, _utils.getNthOccurrence)(text, decimalSeparator, realSeparatorOccurrenceIndex)
            },
            _focusInHandler: function(e) {
                if (!this._preventNestedFocusEvent(e)) {
                    this.clearCaretTimeout();
                    this._caretTimeout = setTimeout(function() {
                        this._caretTimeout = null;
                        var caret = this._caret();
                        if (caret.start === caret.end && this._useMaskBehavior()) {
                            var text = this._getInputVal();
                            var decimalSeparatorIndex = this._getTextSeparatorIndex(text);
                            if (decimalSeparatorIndex >= 0) {
                                this._caret({
                                    start: decimalSeparatorIndex,
                                    end: decimalSeparatorIndex
                                })
                            } else {
                                this._moveCaretToBoundaryEventHandler(MOVE_BACKWARD, e)
                            }
                        }
                    }.bind(this), CARET_TIMEOUT_DURATION)
                }
                this.callBase(e)
            },
            _focusOutHandler: function(e) {
                var shouldHandleEvent = !this._preventNestedFocusEvent(e);
                if (shouldHandleEvent) {
                    this._focusOutOccurs = true;
                    if (this._useMaskBehavior()) {
                        this._updateFormattedValue()
                    }
                }
                this.callBase(e);
                if (shouldHandleEvent) {
                    this._focusOutOccurs = false
                }
            },
            _hasValueBeenChanged: function(inputValue) {
                var format = this._getFormatPattern();
                var value = this.option("value");
                var formatted = this._format(value, format) || "";
                return formatted !== inputValue
            },
            _updateFormattedValue: function() {
                var inputValue = this._getInputVal();
                if (this._hasValueBeenChanged(inputValue)) {
                    this._updateParsedValue();
                    this._adjustParsedValue();
                    this._setTextByParsedValue();
                    if (this._parsedValue !== this.option("value")) {
                        _events_engine.default.trigger(this._input(), "change")
                    }
                }
            },
            _arrowHandler: function(step, e) {
                if (!this._useMaskBehavior()) {
                    return
                }
                var text = this._getInputVal();
                var format = this._getFormatPattern();
                var nextCaret = (0, _number_box.getCaretWithOffset)(this._caret(), step);
                if (!(0, _number_box.isCaretInBoundaries)(nextCaret, text, format)) {
                    nextCaret = step === MOVE_FORWARD ? nextCaret.end : nextCaret.start;
                    e.preventDefault();
                    this._caret((0, _number_box.getCaretInBoundaries)(nextCaret, text, format))
                }
            },
            _moveCaretToBoundary: function(direction) {
                var boundaries = (0, _number_box.getCaretBoundaries)(this._getInputVal(), this._getFormatPattern());
                var newCaret = (0, _number_box.getCaretWithOffset)(direction === MOVE_FORWARD ? boundaries.start : boundaries.end, 0);
                this._caret(newCaret)
            },
            _moveCaretToBoundaryEventHandler: function(direction, e) {
                if (!this._useMaskBehavior() || e && e.shiftKey) {
                    return
                }
                this._moveCaretToBoundary(direction);
                e && e.preventDefault()
            },
            _shouldMoveCaret: function(text, caret) {
                var decimalSeparator = _number.default.getDecimalSeparator();
                var isDecimalSeparatorNext = text.charAt(caret.end) === decimalSeparator;
                var isZeroNext = "0" === text.charAt(caret.end);
                var moveToFloat = (this._lastKey === decimalSeparator || "." === this._lastKey) && isDecimalSeparatorNext;
                var zeroToZeroReplace = "0" === this._lastKey && isZeroNext;
                return moveToFloat || zeroToZeroReplace
            },
            _getInputVal: function() {
                return _number.default.convertDigits(this._input().val(), true)
            },
            _keyboardHandler: function(e) {
                this.clearCaretTimeout();
                this._lastKey = _number.default.convertDigits((0, _index.getChar)(e), true);
                this._lastKeyName = (0, _index.normalizeKeyName)(e);
                if (!this._shouldHandleKey(e.originalEvent)) {
                    return this.callBase(e)
                }
                var normalizedText = this._getInputVal();
                var caret = this._caret();
                var enteredChar = this._lastKeyName === MINUS_KEY ? "" : this._lastKey;
                var newValue = this._tryParse(normalizedText, caret, enteredChar);
                if (this._shouldMoveCaret(normalizedText, caret)) {
                    this._moveCaret(1);
                    e.originalEvent.preventDefault()
                }
                if (void 0 === newValue) {
                    if (this._lastKeyName !== MINUS_KEY) {
                        e.originalEvent.preventDefault()
                    }
                } else {
                    this._parsedValue = newValue
                }
                return this.callBase(e)
            },
            _keyPressHandler: function(e) {
                if (!this._useMaskBehavior()) {
                    this.callBase(e)
                }
            },
            _removeHandler: function(e) {
                var caret = this._caret();
                var text = this._getInputVal();
                var start = caret.start;
                var end = caret.end;
                this._lastKey = (0, _index.getChar)(e);
                this._lastKeyName = (0, _index.normalizeKeyName)(e);
                var isDeleteKey = this._isDeleteKey(this._lastKeyName);
                var isBackspaceKey = !isDeleteKey;
                if (start === end) {
                    var caretPosition = start;
                    var canDelete = isBackspaceKey && caretPosition > 0 || isDeleteKey && caretPosition < text.length;
                    if (canDelete) {
                        isDeleteKey && end++;
                        isBackspaceKey && start--
                    } else {
                        e.preventDefault();
                        return
                    }
                }
                var char = text.slice(start, end);
                if (this._isStub(char)) {
                    this._moveCaret(isDeleteKey ? 1 : -1);
                    if (this._parsedValue < 0 || 1 / this._parsedValue === -(1 / 0)) {
                        this._revertSign(e);
                        this._setTextByParsedValue()
                    }
                    e.preventDefault();
                    return
                }
                var decimalSeparator = _number.default.getDecimalSeparator();
                if (char === decimalSeparator) {
                    var decimalSeparatorIndex = text.indexOf(decimalSeparator);
                    if (this._isNonStubAfter(decimalSeparatorIndex + 1)) {
                        this._moveCaret(isDeleteKey ? 1 : -1);
                        e.preventDefault()
                    }
                    return
                }
                if (end - start < text.length) {
                    var editedText = this._replaceSelectedText(text, {
                        start: start,
                        end: end
                    }, "");
                    var noDigits = editedText.search(/[0-9]/) < 0;
                    if (noDigits && this._isValueInRange(0)) {
                        this._parsedValue = this._parsedValue < 0 || 1 / this._parsedValue === -(1 / 0) ? -0 : 0;
                        return
                    }
                }
                var valueAfterRemoving = this._tryParse(text, {
                    start: start,
                    end: end
                }, "");
                if (void 0 === valueAfterRemoving) {
                    e.preventDefault()
                } else {
                    this._parsedValue = valueAfterRemoving
                }
            },
            _isPercentFormat: function() {
                var format = this._getFormatPattern();
                var noEscapedFormat = format.replace(/'[^']+'/g, "");
                return noEscapedFormat.indexOf("%") !== -1
            },
            _parse: function(text, format) {
                var formatOption = this.option("format");
                var isCustomParser = (0, _type.isFunction)(formatOption.parser);
                var parser = isCustomParser ? formatOption.parser : _number.default.parse;
                var integerPartStartIndex = 0;
                if (!isCustomParser) {
                    var formatPointIndex = (0, _utils.getRealSeparatorIndex)(format).index;
                    var textPointIndex = this._getTextSeparatorIndex(text);
                    var formatIntegerPartLength = formatPointIndex !== -1 ? formatPointIndex : format.length;
                    var textIntegerPartLength = textPointIndex !== -1 ? textPointIndex : text.length;
                    if (textIntegerPartLength > formatIntegerPartLength && format.indexOf("#") === -1) {
                        integerPartStartIndex = textIntegerPartLength - formatIntegerPartLength
                    }
                }
                text = this._removeStubs(text, true);
                text = text.substr(integerPartStartIndex);
                return parser(text, format)
            },
            _format: function(value, format) {
                var formatOption = this.option("format");
                var isCustomFormatter = (0, _type.isFunction)(null === formatOption || void 0 === formatOption ? void 0 : formatOption.formatter);
                var formatter = isCustomFormatter ? formatOption.formatter : _number.default.format;
                return formatter(value, format)
            },
            _getFormatPattern: function() {
                if (!this._currentFormat) {
                    this._updateFormat()
                }
                return this._currentFormat
            },
            _updateFormat: function() {
                var _this = this;
                var format = this.option("format");
                var isCustomParser = (0, _type.isFunction)(null === format || void 0 === format ? void 0 : format.parser);
                var isLDMLPattern = (0, _type.isString)(format) && (format.indexOf("0") >= 0 || format.indexOf("#") >= 0);
                this._currentFormat = isCustomParser || isLDMLPattern ? format : (0, _number2.getFormat)(function(value) {
                    var text = _this._format(value, format);
                    return _number.default.convertDigits(text, true)
                })
            },
            _getFormatForSign: function(text) {
                var format = this._getFormatPattern();
                if ((0, _type.isString)(format)) {
                    var signParts = format.split(";");
                    var sign = _number.default.getSign(text, format);
                    signParts[1] = signParts[1] || "-" + signParts[0];
                    return sign < 0 ? signParts[1] : signParts[0]
                } else {
                    var _sign = _number.default.getSign(text);
                    return _sign < 0 ? "-" : ""
                }
            },
            _removeStubs: function(text, excludeComma) {
                var format = this._getFormatForSign(text);
                var thousandsSeparator = _number.default.getThousandsSeparator();
                var stubs = this._getStubs(format);
                var result = text;
                if (stubs.length) {
                    var prefixStubs = stubs[0];
                    var postfixRegex = new RegExp("(" + (0, _common.escapeRegExp)(stubs[1] || "") + ")$", "g");
                    var decoratorsRegex = new RegExp("[-" + (0, _common.escapeRegExp)(excludeComma ? "" : thousandsSeparator) + "]", "g");
                    result = result.replace(prefixStubs, "").replace(postfixRegex, "").replace(decoratorsRegex, "")
                }
                return result
            },
            _getStubs: function(format) {
                var regExpResult = /[^']([#0.,]+)/g.exec(format);
                var pattern = regExpResult && regExpResult[0].trim();
                return format.split(pattern).map(function(stub) {
                    return stub.replace(/'/g, "")
                })
            },
            _truncateToPrecision: function(value, maxPrecision) {
                if ((0, _type.isDefined)(value)) {
                    var strValue = value.toString();
                    var decimalSeparatorIndex = strValue.indexOf(".");
                    if (strValue && decimalSeparatorIndex > -1) {
                        var parsedValue = parseFloat(strValue.substr(0, decimalSeparatorIndex + maxPrecision + 1));
                        return isNaN(parsedValue) ? value : parsedValue
                    }
                }
                return value
            },
            _tryParse: function(text, selection, char) {
                var editedText = this._replaceSelectedText(text, selection, char);
                var format = this._getFormatPattern();
                var isTextSelected = selection.start !== selection.end;
                var parsedValue = this._getParsedValue(editedText, format);
                var maxPrecision = !format.parser && this._getPrecisionLimits(editedText).max;
                var isValueChanged = parsedValue !== this._parsedValue;
                var decimalSeparator = _number.default.getDecimalSeparator();
                var isDecimalPointRestricted = char === decimalSeparator && 0 === maxPrecision;
                var isUselessCharRestricted = !isTextSelected && !isValueChanged && char !== MINUS && !this._isValueIncomplete(editedText) && this._isStub(char);
                if (isDecimalPointRestricted || isUselessCharRestricted) {
                    return
                }
                if ("" === this._removeStubs(editedText)) {
                    parsedValue = Math.abs(0 * this._parsedValue)
                }
                if (isNaN(parsedValue)) {
                    return
                }
                var value = null === parsedValue ? this._parsedValue : parsedValue;
                parsedValue = maxPrecision ? this._truncateToPrecision(value, maxPrecision) : parsedValue;
                return !format.parser && this._isPercentFormat() ? parsedValue && parsedValue / 100 : parsedValue
            },
            _getParsedValue: function(text, format) {
                var sign = _number.default.getSign(text, (null === format || void 0 === format ? void 0 : format.formatter) || format);
                var parsedValue = this._parse(text, format);
                var parsedValueSign = parsedValue < 0 ? -1 : 1;
                var parsedValueWithSign = (0, _type.isNumeric)(parsedValue) && sign !== parsedValueSign ? sign * parsedValue : parsedValue;
                return parsedValueWithSign
            },
            _isValueIncomplete: function(text) {
                if (!this._useMaskBehavior()) {
                    return this.callBase(text)
                }
                var caret = this._caret();
                var point = _number.default.getDecimalSeparator();
                var pointIndex = this._getTextSeparatorIndex(text);
                var isCaretOnFloat = pointIndex >= 0 && pointIndex < caret.start;
                var textParts = this._removeStubs(text, true).split(point);
                if (!isCaretOnFloat || 2 !== textParts.length) {
                    return false
                }
                var floatLength = textParts[1].length;
                var format = this._getFormatPattern();
                var isCustomParser = !!format.parser;
                var precision = !isCustomParser && this._getPrecisionLimits(this._getFormatPattern(), text);
                var isPrecisionInRange = isCustomParser ? true : (0, _math.inRange)(floatLength, precision.min, precision.max);
                var endsWithZero = "0" === textParts[1].charAt(floatLength - 1);
                return isPrecisionInRange && (endsWithZero || !floatLength)
            },
            _isValueInRange: function(value) {
                var min = (0, _common.ensureDefined)(this.option("min"), -(1 / 0));
                var max = (0, _common.ensureDefined)(this.option("max"), 1 / 0);
                return (0, _math.inRange)(value, min, max)
            },
            _setInputText: function(text) {
                var normalizedText = _number.default.convertDigits(text, true);
                var newCaret = (0, _number_box.getCaretAfterFormat)(this._getInputVal(), normalizedText, this._caret(), this._getFormatPattern());
                this._input().val(text);
                this._toggleEmptinessEventHandler();
                this._formattedValue = text;
                if (!this._focusOutOccurs) {
                    this._caret(newCaret)
                }
            },
            _useMaskBehavior: function() {
                return !!this.option("format") && this.option("useMaskBehavior")
            },
            _renderInputType: function() {
                var isNumberType = "number" === this.option("mode");
                var isDesktop = "desktop" === _devices.default.real().deviceType;
                if (this._useMaskBehavior() && isNumberType) {
                    this._setInputType(isDesktop || this._isSupportInputMode() ? "text" : "tel")
                } else {
                    this.callBase()
                }
            },
            _isChar: function(str) {
                return (0, _type.isString)(str) && 1 === str.length
            },
            _moveCaret: function(offset) {
                if (!offset) {
                    return
                }
                var newCaret = (0, _number_box.getCaretWithOffset)(this._caret(), offset);
                var adjustedCaret = (0, _number_box.getCaretInBoundaries)(newCaret, this._getInputVal(), this._getFormatPattern());
                this._caret(adjustedCaret)
            },
            _shouldHandleKey: function(e) {
                var keyName = (0, _index.normalizeKeyName)(e);
                var isSpecialChar = e.ctrlKey || e.shiftKey || e.altKey || !this._isChar(keyName);
                var isMinusKey = keyName === MINUS_KEY;
                var useMaskBehavior = this._useMaskBehavior();
                return useMaskBehavior && !isSpecialChar && !isMinusKey
            },
            _renderInput: function() {
                this.callBase();
                this._renderFormatter()
            },
            _renderFormatter: function() {
                this._clearCache();
                this._detachFormatterEvents();
                if (this._useMaskBehavior()) {
                    this._attachFormatterEvents()
                }
            },
            _detachFormatterEvents: function() {
                _events_engine.default.off(this._input(), "." + NUMBER_FORMATTER_NAMESPACE)
            },
            _isInputFromPaste: function(e) {
                var inputType = e.originalEvent && e.originalEvent.inputType;
                if ((0, _type.isDefined)(inputType)) {
                    return "insertFromPaste" === inputType
                } else {
                    return this._isValuePasted
                }
            },
            _attachFormatterEvents: function() {
                var $input = this._input();
                _events_engine.default.on($input, (0, _index.addNamespace)(INPUT_EVENT, NUMBER_FORMATTER_NAMESPACE), function(e) {
                    this._formatValue(e);
                    this._isValuePasted = false
                }.bind(this));
                if (_browser.default.msie && _browser.default.version < 12) {
                    _events_engine.default.on($input, (0, _index.addNamespace)("paste", NUMBER_FORMATTER_NAMESPACE), function() {
                        this._isValuePasted = true
                    }.bind(this))
                }
                _events_engine.default.on($input, (0, _index.addNamespace)("dxclick", NUMBER_FORMATTER_NAMESPACE), function() {
                    if (!this._caretTimeout) {
                        this._caretTimeout = setTimeout(function() {
                            this._caret((0, _number_box.getCaretInBoundaries)(this._caret(), this._getInputVal(), this._getFormatPattern()))
                        }.bind(this), CARET_TIMEOUT_DURATION)
                    }
                }.bind(this));
                _events_engine.default.on($input, "dxdblclick", function() {
                    this.clearCaretTimeout()
                }.bind(this))
            },
            clearCaretTimeout: function() {
                clearTimeout(this._caretTimeout);
                this._caretTimeout = null
            },
            _forceRefreshInputValue: function() {
                if (!this._useMaskBehavior()) {
                    return this.callBase()
                }
            },
            _isNonStubAfter: function(index) {
                var text = this._getInputVal().slice(index);
                return text && !this._isStub(text, true)
            },
            _isStub: function(str, isString) {
                var escapedDecimalSeparator = (0, _common.escapeRegExp)(_number.default.getDecimalSeparator());
                var regExpString = "^[^0-9" + escapedDecimalSeparator + "]+$";
                var stubRegExp = new RegExp(regExpString, "g");
                return stubRegExp.test(str) && (isString || this._isChar(str))
            },
            _parseValue: function(text) {
                if (!this._useMaskBehavior()) {
                    return this.callBase(text)
                }
                return this._parsedValue
            },
            _getPrecisionLimits: function(text) {
                var currentFormat = this._getFormatForSign(text);
                var realSeparatorIndex = (0, _utils.getRealSeparatorIndex)(currentFormat).index;
                var floatPart = ((0, _utils.splitByIndex)(currentFormat, realSeparatorIndex)[1] || "").replace(/[^#0]/g, "");
                var minPrecision = floatPart.replace(/^(0*)#*/, "$1").length;
                var maxPrecision = floatPart.length;
                return {
                    min: minPrecision,
                    max: maxPrecision
                }
            },
            _revertSign: function(e) {
                if (!this._useMaskBehavior()) {
                    return
                }
                var caret = this._caret();
                if (caret.start !== caret.end) {
                    if ((0, _index.normalizeKeyName)(e) === MINUS_KEY) {
                        this._applyRevertedSign(e, caret, true);
                        return
                    } else {
                        this._caret((0, _number_box.getCaretInBoundaries)(0, this._getInputVal(), this._getFormatPattern()))
                    }
                }
                this._applyRevertedSign(e, caret)
            },
            _applyRevertedSign: function(e, caret, preserveSelectedText) {
                var newValue = -1 * (0, _common.ensureDefined)(this._parsedValue, null);
                if (this._isValueInRange(newValue)) {
                    this._parsedValue = newValue;
                    if (preserveSelectedText) {
                        var format = this._getFormatPattern();
                        var previousText = this._getInputVal();
                        this._setTextByParsedValue();
                        e.preventDefault();
                        var currentText = this._getInputVal();
                        var offset = (0, _number_box.getCaretOffset)(previousText, currentText, format);
                        caret = (0, _number_box.getCaretWithOffset)(caret, offset);
                        var caretInBoundaries = (0, _number_box.getCaretInBoundaries)(caret, currentText, format);
                        if (_browser.default.msie) {
                            clearTimeout(this._caretTimeout);
                            this._caretTimeout = setTimeout(this._caret.bind(this, caretInBoundaries))
                        } else {
                            this._caret(caretInBoundaries)
                        }
                    }
                    if (e.key === NUMPUD_MINUS_KEY_IE) {
                        _events_engine.default.trigger(this._input(), INPUT_EVENT)
                    }
                }
            },
            _removeMinusFromText: function(text, caret) {
                var isMinusPressed = this._lastKeyName === MINUS_KEY && text.charAt(caret.start - 1) === MINUS;
                return isMinusPressed ? this._replaceSelectedText(text, {
                    start: caret.start - 1,
                    end: caret.start
                }, "") : text
            },
            _setTextByParsedValue: function() {
                var format = this._getFormatPattern();
                var parsed = this._parseValue();
                var formatted = this._format(parsed, format) || "";
                this._setInputText(formatted)
            },
            _formatValue: function(e) {
                var normalizedText = this._getInputVal();
                var caret = this._caret();
                var textWithoutMinus = this._removeMinusFromText(normalizedText, caret);
                var wasMinusRemoved = textWithoutMinus !== normalizedText;
                normalizedText = textWithoutMinus;
                if (!this._isInputFromPaste(e) && this._isValueIncomplete(textWithoutMinus)) {
                    this._formattedValue = normalizedText;
                    if (wasMinusRemoved) {
                        this._setTextByParsedValue()
                    }
                    return
                }
                var textWasChanged = _number.default.convertDigits(this._formattedValue, true) !== normalizedText;
                if (textWasChanged) {
                    var value = this._tryParse(normalizedText, caret, "");
                    if ((0, _type.isDefined)(value)) {
                        this._parsedValue = value
                    }
                }
                this._setTextByParsedValue()
            },
            _renderDisplayText: function() {
                if (this._useMaskBehavior()) {
                    this._toggleEmptinessEventHandler()
                } else {
                    this.callBase.apply(this, arguments)
                }
            },
            _renderValue: function() {
                if (this._useMaskBehavior()) {
                    this._parsedValue = this.option("value");
                    this._setTextByParsedValue()
                }
                return this.callBase()
            },
            _updateParsedValue: function() {
                var inputValue = this._getInputVal();
                this._parsedValue = this._tryParse(inputValue, this._caret())
            },
            _adjustParsedValue: function() {
                if (!this._useMaskBehavior()) {
                    return
                }
                var clearedText = this._removeStubs(this._getInputVal());
                var parsedValue = clearedText ? this._parseValue() : null;
                if (!(0, _type.isNumeric)(parsedValue)) {
                    this._parsedValue = parsedValue;
                    return
                }
                this._parsedValue = (0, _math.fitIntoRange)(parsedValue, this.option("min"), this.option("max"))
            },
            _valueChangeEventHandler: function(e) {
                if (!this._useMaskBehavior()) {
                    return this.callBase(e)
                }
                var caret = this._caret();
                this._saveValueChangeEvent(e);
                this._lastKey = null;
                this._lastKeyName = null;
                this._updateParsedValue();
                this._adjustParsedValue();
                this.option("value", this._parsedValue);
                if (caret) {
                    this._caret(caret)
                }
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "format":
                    case "useMaskBehavior":
                        this._renderInputType();
                        this._updateFormat();
                        this._renderFormatter();
                        this._renderValue();
                        this._refreshValueChangeEvent();
                        this._refreshEvents();
                        break;
                    case "min":
                    case "max":
                        this._adjustParsedValue();
                        this.callBase(args);
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _clearCache: function() {
                delete this._formattedValue;
                delete this._lastKey;
                delete this._lastKeyName;
                delete this._parsedValue;
                delete this._focusOutOccurs;
                clearTimeout(this._caretTimeout);
                delete this._caretTimeout
            },
            _clean: function() {
                this._clearCache();
                this.callBase()
            }
        });
        var _default = NumberBoxMask;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/number_box/number_box.caret.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getCaretInBoundaries = getCaretInBoundaries;
        exports.getCaretOffset = exports.isCaretInBoundaries = exports.getCaretAfterFormat = exports.getCaretWithOffset = exports.getCaretBoundaries = void 0;
        var _math = __webpack_require__( /*! ../../core/utils/math */ 29);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _number = _interopRequireDefault(__webpack_require__( /*! ../../localization/number */ 47));
        var _utils = __webpack_require__( /*! ./utils */ 355);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var getCaretBoundaries = function(text, format) {
            if ("string" === typeof format) {
                var signParts = format.split(";");
                var sign = _number.default.getSign(text, format);
                signParts[1] = signParts[1] || "-" + signParts[0];
                format = signParts[sign < 0 ? 1 : 0];
                var mockEscapedStubs = function(str) {
                    return str.replace(/'([^']*)'/g, function(str) {
                        return str.split("").map(function() {
                            return " "
                        }).join("").substr(2)
                    })
                };
                format = mockEscapedStubs(format);
                var prefixStubLength = /^[^#0.,]*/.exec(format)[0].length;
                var postfixStubLength = /[^#0.,]*$/.exec(format)[0].length;
                return {
                    start: prefixStubLength,
                    end: text.length - postfixStubLength
                }
            } else {
                return {
                    start: 0,
                    end: text.length
                }
            }
        };
        exports.getCaretBoundaries = getCaretBoundaries;
        var _getDigitCountBeforeIndex = function(index, text) {
            var decimalSeparator = _number.default.getDecimalSeparator();
            var regExp = new RegExp("[^0-9" + (0, _common.escapeRegExp)(decimalSeparator) + "]", "g");
            var textBeforePosition = text.slice(0, index);
            return textBeforePosition.replace(regExp, "").length
        };
        var _reverseText = function(text) {
            return text.split("").reverse().join("")
        };
        var _getDigitPositionByIndex = function(digitIndex, text) {
            if (!digitIndex) {
                return -1
            }
            var regExp = /[0-9]/g;
            var counter = 1;
            var index = null;
            var result = regExp.exec(text);
            while (result) {
                index = result.index;
                if (!digitIndex || counter >= digitIndex) {
                    return index
                }
                counter++;
                result = regExp.exec(text)
            }
            return null === index ? text.length : index
        };
        var _trimNonNumericCharsFromEnd = function(text) {
            return text.replace(/[^0-9e]+$/, "")
        };
        var getCaretWithOffset = function(caret, offset) {
            if (void 0 === caret.start) {
                caret = {
                    start: caret,
                    end: caret
                }
            }
            return {
                start: caret.start + offset,
                end: caret.end + offset
            }
        };
        exports.getCaretWithOffset = getCaretWithOffset;
        var getCaretAfterFormat = function(text, formatted, caret, format) {
            caret = getCaretWithOffset(caret, 0);
            var point = _number.default.getDecimalSeparator();
            var isSeparatorBasedText = isSeparatorBasedString(text);
            var realSeparatorOccurrenceIndex = (0, _utils.getRealSeparatorIndex)(format).occurrence;
            var pointPosition = isSeparatorBasedText ? 0 : (0, _utils.getNthOccurrence)(text, point, realSeparatorOccurrenceIndex);
            var newPointPosition = (0, _utils.getNthOccurrence)(formatted, point, realSeparatorOccurrenceIndex);
            var textParts = (0, _utils.splitByIndex)(text, pointPosition);
            var formattedParts = (0, _utils.splitByIndex)(formatted, newPointPosition);
            var isCaretOnFloat = pointPosition !== -1 && caret.start > pointPosition;
            if (isCaretOnFloat) {
                var relativeIndex = caret.start - pointPosition - 1;
                var digitsBefore = _getDigitCountBeforeIndex(relativeIndex, textParts[1]);
                var newPosition = formattedParts[1] ? newPointPosition + 1 + _getDigitPositionByIndex(digitsBefore, formattedParts[1]) + 1 : formatted.length;
                return getCaretInBoundaries(newPosition, formatted, format)
            } else {
                var formattedIntPart = _trimNonNumericCharsFromEnd(formattedParts[0]);
                var positionFromEnd = textParts[0].length - caret.start;
                var digitsFromEnd = _getDigitCountBeforeIndex(positionFromEnd, _reverseText(textParts[0]));
                var newPositionFromEnd = _getDigitPositionByIndex(digitsFromEnd, _reverseText(formattedIntPart));
                var newPositionFromBegin = formattedIntPart.length - (newPositionFromEnd + 1);
                return getCaretInBoundaries(newPositionFromBegin, formatted, format)
            }
        };
        exports.getCaretAfterFormat = getCaretAfterFormat;

        function isSeparatorBasedString(text) {
            return 1 === text.length && !!text.match(/^[,.][0-9]*$/g)
        }
        var isCaretInBoundaries = function(caret, text, format) {
            caret = getCaretWithOffset(caret, 0);
            var boundaries = getCaretInBoundaries(caret, text, format);
            return caret.start >= boundaries.start && caret.end <= boundaries.end
        };
        exports.isCaretInBoundaries = isCaretInBoundaries;

        function getCaretInBoundaries(caret, text, format) {
            caret = getCaretWithOffset(caret, 0);
            var boundaries = getCaretBoundaries(text, format);
            var adjustedCaret = {
                start: (0, _math.fitIntoRange)(caret.start, boundaries.start, boundaries.end),
                end: (0, _math.fitIntoRange)(caret.end, boundaries.start, boundaries.end)
            };
            return adjustedCaret
        }
        var getCaretOffset = function(previousText, newText, format) {
            var previousBoundaries = getCaretBoundaries(previousText, format);
            var newBoundaries = getCaretBoundaries(newText, format);
            return newBoundaries.start - previousBoundaries.start
        };
        exports.getCaretOffset = getCaretOffset
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/number_box/number_box.base.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _math = __webpack_require__( /*! ../../core/utils/math */ 29);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../text_box/ui.text_editor */ 342));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _number_box = _interopRequireDefault(__webpack_require__( /*! ./number_box.spins */ 618));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var math = Math;
        var WIDGET_CLASS = "dx-numberbox";
        var FIREFOX_CONTROL_KEYS = ["tab", "del", "backspace", "leftArrow", "rightArrow", "home", "end", "enter"];
        var FORCE_VALUECHANGE_EVENT_NAMESPACE = "NumberBoxForceValueChange";
        var NumberBoxBase = _ui.default.inherit({
            _supportedKeys: function() {
                return (0, _extend.extend)(this.callBase(), {
                    upArrow: function(e) {
                        if (!(0, _index.isCommandKeyPressed)(e)) {
                            e.preventDefault();
                            e.stopPropagation();
                            this._spinUpChangeHandler(e)
                        }
                    },
                    downArrow: function(e) {
                        if (!(0, _index.isCommandKeyPressed)(e)) {
                            e.preventDefault();
                            e.stopPropagation();
                            this._spinDownChangeHandler(e)
                        }
                    },
                    enter: function() {}
                })
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    value: 0,
                    min: void 0,
                    max: void 0,
                    step: 1,
                    showSpinButtons: false,
                    useLargeSpinButtons: true,
                    mode: "text",
                    invalidValueMessage: _message.default.format("dxNumberBox-invalidValueMessage"),
                    buttons: void 0
                })
            },
            _useTemplates: function() {
                return false
            },
            _getDefaultButtons: function() {
                return this.callBase().concat([{
                    name: "spins",
                    Ctor: _number_box.default
                }])
            },
            _isSupportInputMode: function() {
                var version = parseFloat(_browser.default.version);
                return _browser.default.chrome && version >= 66 || _browser.default.safari && version >= 12 || _browser.default.msie && version >= 75
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: function() {
                        return _devices.default.real().generic && !_devices.default.isSimulator()
                    },
                    options: {
                        useLargeSpinButtons: false
                    }
                }, {
                    device: function() {
                        return "desktop" !== _devices.default.real().deviceType && !this._isSupportInputMode()
                    }.bind(this),
                    options: {
                        mode: "number"
                    }
                }])
            },
            _initMarkup: function() {
                this._renderSubmitElement();
                this.$element().addClass(WIDGET_CLASS);
                this.callBase()
            },
            _getDefaultAttributes: function() {
                var attributes = this.callBase();
                attributes.inputmode = "decimal";
                return attributes
            },
            _renderContentImpl: function() {
                this.option("isValid") && this._validateValue(this.option("value"));
                this.setAria("role", "spinbutton")
            },
            _renderSubmitElement: function() {
                this._$submitElement = (0, _renderer.default)("<input>").attr("type", "hidden").appendTo(this.$element());
                this._setSubmitValue(this.option("value"))
            },
            _setSubmitValue: function(value) {
                this._getSubmitElement().val((0, _common.applyServerDecimalSeparator)(value))
            },
            _getSubmitElement: function() {
                return this._$submitElement
            },
            _keyPressHandler: function(e) {
                this.callBase(e);
                var char = (0, _index.getChar)(e);
                var validCharRegExp = /[\d.,eE\-+]|Subtract/;
                var isInputCharValid = validCharRegExp.test(char);
                if (!isInputCharValid) {
                    var keyName = (0, _index.normalizeKeyName)(e);
                    if ((0, _index.isCommandKeyPressed)(e) || keyName && (0, _array.inArray)(keyName, FIREFOX_CONTROL_KEYS) >= 0) {
                        return
                    }
                    e.preventDefault();
                    return false
                }
                this._keyPressed = true
            },
            _onMouseWheel: function(dxEvent) {
                dxEvent.delta > 0 ? this._spinValueChange(1, dxEvent) : this._spinValueChange(-1, dxEvent)
            },
            _renderValue: function() {
                var inputValue = this._input().val();
                var value = this.option("value");
                if (!inputValue.length || Number(inputValue) !== value) {
                    this._forceValueRender();
                    this._toggleEmptinessEventHandler()
                }
                var valueText = (0, _type.isDefined)(value) ? null : _message.default.format("dxNumberBox-noDataText");
                this.setAria({
                    valuenow: (0, _common.ensureDefined)(value, ""),
                    valuetext: valueText
                });
                this.option("text", this._input().val());
                this._updateButtons();
                return (new _deferred.Deferred).resolve()
            },
            _forceValueRender: function() {
                var value = this.option("value");
                var number = Number(value);
                var formattedValue = isNaN(number) ? "" : this._applyDisplayValueFormatter(value);
                this._renderDisplayText(formattedValue)
            },
            _applyDisplayValueFormatter: function(value) {
                return this.option("displayValueFormatter")(value)
            },
            _renderProps: function() {
                this.callBase();
                this._input().prop({
                    min: this.option("min"),
                    max: this.option("max"),
                    step: this.option("step")
                });
                this.setAria({
                    valuemin: (0, _common.ensureDefined)(this.option("min"), ""),
                    valuemax: (0, _common.ensureDefined)(this.option("max"), "")
                })
            },
            _spinButtonsPointerDownHandler: function() {
                var $input = this._input();
                if (!this.option("useLargeSpinButtons") && _dom_adapter.default.getActiveElement() !== $input[0]) {
                    _events_engine.default.trigger($input, "focus")
                }
            },
            _spinUpChangeHandler: function(e) {
                if (!this.option("readOnly")) {
                    this._spinValueChange(1, e.event || e)
                }
            },
            _spinDownChangeHandler: function(e) {
                if (!this.option("readOnly")) {
                    this._spinValueChange(-1, e.event || e)
                }
            },
            _spinValueChange: function(sign, dxEvent) {
                var step = parseFloat(this.option("step"));
                if (0 === step) {
                    return
                }
                var value = parseFloat(this._normalizeInputValue()) || 0;
                value = this._correctRounding(value, step * sign);
                var min = this.option("min");
                var max = this.option("max");
                if ((0, _type.isDefined)(min)) {
                    value = Math.max(min, value)
                }
                if ((0, _type.isDefined)(max)) {
                    value = Math.min(max, value)
                }
                this._saveValueChangeEvent(dxEvent);
                this.option("value", value)
            },
            _correctRounding: function(value, step) {
                var regex = /[,.](.*)/;
                var isFloatValue = regex.test(value);
                var isFloatStep = regex.test(step);
                if (isFloatValue || isFloatStep) {
                    var valueAccuracy = isFloatValue ? regex.exec(value)[0].length : 0;
                    var stepAccuracy = isFloatStep ? regex.exec(step)[0].length : 0;
                    var accuracy = math.max(valueAccuracy, stepAccuracy);
                    value = this._round(value + step, accuracy);
                    return value
                }
                return value + step
            },
            _round: function(value, precision) {
                precision = precision || 0;
                var multiplier = Math.pow(10, precision);
                value *= multiplier;
                value = Math.round(value) / multiplier;
                return value
            },
            _renderValueChangeEvent: function() {
                this.callBase();
                var forceValueChangeEvent = (0, _index.addNamespace)("focusout", FORCE_VALUECHANGE_EVENT_NAMESPACE);
                _events_engine.default.off(this.element(), forceValueChangeEvent);
                _events_engine.default.on(this.element(), forceValueChangeEvent, this._forceRefreshInputValue.bind(this))
            },
            _forceRefreshInputValue: function() {
                if ("number" === this.option("mode")) {
                    return
                }
                var $input = this._input();
                var formattedValue = this._applyDisplayValueFormatter(this.option("value"));
                $input.val(null);
                $input.val(formattedValue)
            },
            _valueChangeEventHandler: function(e) {
                var $input = this._input();
                var inputValue = this._normalizeText();
                var value = this._parseValue(inputValue);
                var valueHasDigits = "." !== inputValue && "-" !== inputValue;
                if (this._isValueValid() && !this._validateValue(value)) {
                    $input.val(this._applyDisplayValueFormatter(value));
                    return
                }
                if (valueHasDigits) {
                    this.callBase(e, isNaN(value) ? null : value)
                }
                this._applyValueBoundaries(inputValue, value);
                this.validationRequest.fire({
                    value: value,
                    editor: this
                })
            },
            _applyValueBoundaries: function(inputValue, parsedValue) {
                var isValueIncomplete = this._isValueIncomplete(inputValue);
                var isValueCorrect = this._isValueInRange(inputValue);
                if (!isValueIncomplete && !isValueCorrect && null !== parsedValue) {
                    if (Number(inputValue) !== parsedValue) {
                        this._input().val(this._applyDisplayValueFormatter(parsedValue))
                    }
                }
            },
            _replaceCommaWithPoint: function(value) {
                return value.replace(",", ".")
            },
            _inputIsInvalid: function() {
                var isNumberMode = "number" === this.option("mode");
                var validityState = this._input().get(0).validity;
                return isNumberMode && validityState && validityState.badInput
            },
            _renderDisplayText: function(text) {
                if (this._inputIsInvalid()) {
                    return
                }
                this.callBase(text)
            },
            _isValueIncomplete: function(value) {
                var incompleteRegex = /(^-$)|(^-?\d*\.$)|(\d+e-?$)/i;
                return incompleteRegex.test(value)
            },
            _isValueInRange: function(value) {
                return (0, _math.inRange)(value, this.option("min"), this.option("max"))
            },
            _isNumber: function(value) {
                return null !== this._parseValue(value)
            },
            _validateValue: function(value) {
                var inputValue = this._normalizeText();
                var isValueValid = this._isValueValid();
                var isValid = true;
                var isNumber = this._isNumber(inputValue);
                if (isNaN(Number(value))) {
                    isValid = false
                }
                if (!value && isValueValid) {
                    isValid = true
                } else {
                    if (!isNumber && !isValueValid) {
                        isValid = false
                    }
                }
                this.option({
                    isValid: isValid,
                    validationError: isValid ? null : {
                        editorSpecific: true,
                        message: this.option("invalidValueMessage")
                    }
                });
                return isValid
            },
            _normalizeInputValue: function() {
                return this._parseValue(this._normalizeText())
            },
            _normalizeText: function() {
                var value = this._input().val().trim();
                return this._replaceCommaWithPoint(value)
            },
            _parseValue: function(value) {
                var number = parseFloat(value);
                if (isNaN(number)) {
                    return null
                }
                return (0, _math.fitIntoRange)(number, this.option("min"), this.option("max"))
            },
            _clearValue: function() {
                if (this._inputIsInvalid()) {
                    this._input().val("");
                    this._validateValue()
                }
                this.callBase()
            },
            reset: function() {
                if (null === this.option("value")) {
                    this.option("text", "");
                    this._renderValue()
                } else {
                    this.option("value", null)
                }
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "value":
                        this._validateValue(args.value);
                        this._setSubmitValue(args.value);
                        this.callBase(args);
                        this._resumeValueChangeAction();
                        break;
                    case "step":
                        this._renderProps();
                        break;
                    case "min":
                    case "max":
                        this._renderProps();
                        this.option("value", this._parseValue(this.option("value")));
                        break;
                    case "showSpinButtons":
                    case "useLargeSpinButtons":
                        this._updateButtons(["spins"]);
                        break;
                    case "invalidValueMessage":
                        break;
                    default:
                        this.callBase(args)
                }
            }
        });
        var _default = NumberBoxBase;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/number_box/number_box.spins.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _button = _interopRequireDefault(__webpack_require__( /*! ../text_box/texteditor_button_collection/button */ 207));
        var _number_box = _interopRequireDefault(__webpack_require__( /*! ./number_box.spin */ 619));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../../events/pointer */ 24));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var SPIN_CLASS = "dx-numberbox-spin";
        var SPIN_CONTAINER_CLASS = "dx-numberbox-spin-container";
        var SPIN_TOUCH_FRIENDLY_CLASS = "dx-numberbox-spin-touch-friendly";
        var SpinButtons = function(_TextEditorButton) {
            _inheritsLoose(SpinButtons, _TextEditorButton);

            function SpinButtons() {
                return _TextEditorButton.apply(this, arguments) || this
            }
            var _proto = SpinButtons.prototype;
            _proto._attachEvents = function(instance, $spinContainer) {
                var editor = this.editor;
                var eventName = (0, _index.addNamespace)(_pointer.default.down, editor.NAME);
                var $spinContainerChildren = $spinContainer.children();
                var pointerDownAction = editor._createAction(function(e) {
                    return editor._spinButtonsPointerDownHandler(e)
                });
                _events_engine.default.off($spinContainer, eventName);
                _events_engine.default.on($spinContainer, eventName, function(e) {
                    return pointerDownAction({
                        event: e
                    })
                });
                _number_box.default.getInstance($spinContainerChildren.eq(0)).option("onChange", function(e) {
                    return editor._spinUpChangeHandler(e)
                });
                _number_box.default.getInstance($spinContainerChildren.eq(1)).option("onChange", function(e) {
                    return editor._spinDownChangeHandler(e)
                })
            };
            _proto._create = function() {
                var editor = this.editor;
                var $spinContainer = (0, _renderer.default)("<div>").addClass(SPIN_CONTAINER_CLASS);
                var $spinUp = (0, _renderer.default)("<div>").appendTo($spinContainer);
                var $spinDown = (0, _renderer.default)("<div>").appendTo($spinContainer);
                var options = this._getOptions();
                this._addToContainer($spinContainer);
                editor._createComponent($spinUp, _number_box.default, (0, _extend.extend)({
                    direction: "up"
                }, options));
                editor._createComponent($spinDown, _number_box.default, (0, _extend.extend)({
                    direction: "down"
                }, options));
                this._legacyRender(editor.$element(), this._isTouchFriendly(), options.visible);
                return {
                    instance: $spinContainer,
                    $element: $spinContainer
                }
            };
            _proto._getOptions = function() {
                var editor = this.editor;
                var visible = this._isVisible();
                var disabled = editor.option("disabled");
                return {
                    visible: visible,
                    disabled: disabled
                }
            };
            _proto._isVisible = function() {
                var editor = this.editor;
                return _TextEditorButton.prototype._isVisible.call(this) && editor.option("showSpinButtons")
            };
            _proto._isTouchFriendly = function() {
                var editor = this.editor;
                return editor.option("showSpinButtons") && editor.option("useLargeSpinButtons")
            };
            _proto._legacyRender = function($editor, isTouchFriendly, isVisible) {
                $editor.toggleClass(SPIN_TOUCH_FRIENDLY_CLASS, isTouchFriendly);
                $editor.toggleClass(SPIN_CLASS, isVisible)
            };
            _proto.update = function() {
                var shouldUpdate = _TextEditorButton.prototype.update.call(this);
                if (shouldUpdate) {
                    var editor = this.editor,
                        instance = this.instance;
                    var $editor = editor.$element();
                    var isVisible = this._isVisible();
                    var isTouchFriendly = this._isTouchFriendly();
                    var $spinButtons = instance.children();
                    var spinUp = _number_box.default.getInstance($spinButtons.eq(0));
                    var spinDown = _number_box.default.getInstance($spinButtons.eq(1));
                    var options = this._getOptions();
                    spinUp.option(options);
                    spinDown.option(options);
                    this._legacyRender($editor, isTouchFriendly, isVisible)
                }
            };
            return SpinButtons
        }(_button.default);
        exports.default = SpinButtons;
        module.exports = exports.default
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/number_box/number_box.spin.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../../events/pointer */ 24));
        var _emitter = __webpack_require__( /*! ../../events/core/emitter.feedback */ 149);
        var _hold = _interopRequireDefault(__webpack_require__( /*! ../../events/hold */ 104));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var SPIN_CLASS = "dx-numberbox-spin";
        var SPIN_BUTTON_CLASS = "dx-numberbox-spin-button";
        var SPIN_HOLD_DELAY = 100;
        var NUMBER_BOX = "dxNumberBox";
        var POINTERUP_EVENT_NAME = (0, _index.addNamespace)(_pointer.default.up, NUMBER_BOX);
        var POINTERCANCEL_EVENT_NAME = (0, _index.addNamespace)(_pointer.default.cancel, NUMBER_BOX);
        var SpinButton = _ui.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    direction: "up",
                    onChange: null,
                    activeStateEnabled: true,
                    hoverStateEnabled: true
                })
            },
            _initMarkup: function() {
                this.callBase();
                var direction = SPIN_CLASS + "-" + this.option("direction");
                this.$element().addClass(SPIN_BUTTON_CLASS).addClass(direction);
                this._spinIcon = (0, _renderer.default)("<div>").addClass(direction + "-icon").appendTo(this.$element())
            },
            _render: function() {
                this.callBase();
                var eventName = (0, _index.addNamespace)(_pointer.default.down, this.NAME);
                var $element = this.$element();
                _events_engine.default.off($element, eventName);
                _events_engine.default.on($element, eventName, this._spinDownHandler.bind(this));
                this._spinChangeHandler = this._createActionByOption("onChange")
            },
            _spinDownHandler: function(e) {
                e.preventDefault();
                this._clearTimer();
                _events_engine.default.on(this.$element(), _hold.default.name, function() {
                    this._feedBackDeferred = new _deferred.Deferred;
                    (0, _emitter.lock)(this._feedBackDeferred);
                    this._spinChangeHandler({
                        event: e
                    });
                    this._holdTimer = setInterval(this._spinChangeHandler, SPIN_HOLD_DELAY, {
                        event: e
                    })
                }.bind(this));
                var document = _dom_adapter.default.getDocument();
                _events_engine.default.on(document, POINTERUP_EVENT_NAME, this._clearTimer.bind(this));
                _events_engine.default.on(document, POINTERCANCEL_EVENT_NAME, this._clearTimer.bind(this));
                this._spinChangeHandler({
                    event: e
                })
            },
            _dispose: function() {
                this._clearTimer();
                this.callBase()
            },
            _clearTimer: function() {
                _events_engine.default.off(this.$element(), _hold.default.name);
                var document = _dom_adapter.default.getDocument();
                _events_engine.default.off(document, POINTERUP_EVENT_NAME);
                _events_engine.default.off(document, POINTERCANCEL_EVENT_NAME);
                if (this._feedBackDeferred) {
                    this._feedBackDeferred.resolve()
                }
                if (this._holdTimer) {
                    clearInterval(this._holdTimer)
                }
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "onChange":
                    case "direction":
                        this._invalidate();
                        break;
                    default:
                        this.callBase(args)
                }
            }
        });
        var _default = SpinButton;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/date_box/ui.date_box.js ***!
      \*************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _uiDate_box = _interopRequireDefault(__webpack_require__( /*! ./ui.date_box.mask */ 621));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }(0, _component_registrator.default)("dxDateBox", _uiDate_box.default);
        var _default = _uiDate_box.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/date_box/ui.date_box.mask.js ***!
      \******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _dom = __webpack_require__( /*! ../../core/utils/dom */ 33);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _math = __webpack_require__( /*! ../../core/utils/math */ 29);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _uiDate_boxMask = __webpack_require__( /*! ./ui.date_box.mask.parts */ 622);
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../localization/date */ 32));
        var _date2 = __webpack_require__( /*! ../../localization/ldml/date.parser */ 231);
        var _date3 = __webpack_require__( /*! ../../localization/ldml/date.format */ 174);
        var _uiDate_box = _interopRequireDefault(__webpack_require__( /*! ./ui.date_box.base */ 623));
        var _number = _interopRequireDefault(__webpack_require__( /*! ../../localization/number */ 47));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var MASK_EVENT_NAMESPACE = "dateBoxMask";
        var FORWARD = 1;
        var BACKWARD = -1;
        var DateBoxMask = _uiDate_box.default.inherit({
            _supportedKeys: function(e) {
                var _this = this;
                var originalHandlers = this.callBase(e);
                var callOriginalHandler = function(e) {
                    var originalHandler = originalHandlers[(0, _index.normalizeKeyName)(e)];
                    return originalHandler && originalHandler.apply(_this, [e])
                };
                var applyHandler = function(e, maskHandler) {
                    if (_this._shouldUseOriginalHandler(e)) {
                        return callOriginalHandler.apply(_this, [e])
                    } else {
                        return maskHandler.apply(_this, [e])
                    }
                };
                return (0, _extend.extend)({}, originalHandlers, {
                    del: function(e) {
                        return applyHandler(e, function(event) {
                            _this._revertPart(FORWARD);
                            _this._isAllSelected() || event.preventDefault()
                        })
                    },
                    backspace: function(e) {
                        return applyHandler(e, function(event) {
                            _this._revertPart(BACKWARD);
                            _this._isAllSelected() || event.preventDefault()
                        })
                    },
                    home: function(e) {
                        return applyHandler(e, function(event) {
                            _this._selectFirstPart();
                            event.preventDefault()
                        })
                    },
                    end: function(e) {
                        return applyHandler(e, function(event) {
                            _this._selectLastPart();
                            event.preventDefault()
                        })
                    },
                    escape: function(e) {
                        return applyHandler(e, function(event) {
                            _this._revertChanges(event)
                        })
                    },
                    enter: function(e) {
                        return applyHandler(e, function(event) {
                            _this._enterHandler(event)
                        })
                    },
                    leftArrow: function(e) {
                        return applyHandler(e, function(event) {
                            _this._selectNextPart(BACKWARD);
                            event.preventDefault()
                        })
                    },
                    rightArrow: function(e) {
                        return applyHandler(e, function(event) {
                            _this._selectNextPart(FORWARD);
                            event.preventDefault()
                        })
                    },
                    upArrow: function(e) {
                        return applyHandler(e, function(event) {
                            _this._upDownArrowHandler(FORWARD);
                            event.preventDefault()
                        })
                    },
                    downArrow: function(e) {
                        return applyHandler(e, function(event) {
                            _this._upDownArrowHandler(BACKWARD);
                            event.preventDefault()
                        })
                    }
                })
            },
            _shouldUseOriginalHandler: function(e) {
                var keysToHandleByMask = ["backspace", "del"];
                var isNotDeletingInCalendar = this.option("opened") && e && keysToHandleByMask.indexOf((0, _index.normalizeKeyName)(e)) === -1;
                return !this._useMaskBehavior() || isNotDeletingInCalendar || e && e.altKey
            },
            _upDownArrowHandler: function(step) {
                this._setNewDateIfEmpty();
                var originalValue = this._getActivePartValue(this._initialMaskValue);
                var currentValue = this._getActivePartValue();
                var delta = currentValue - originalValue;
                this._loadMaskValue(this._initialMaskValue);
                this._partIncrease(delta + step, true)
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    useMaskBehavior: false,
                    emptyDateValue: new Date(2e3, 0, 1, 0, 0, 0)
                })
            },
            _isSingleCharKey: function(_ref) {
                var originalEvent = _ref.originalEvent,
                    ctrl = _ref.ctrl,
                    alt = _ref.alt;
                var key = originalEvent.data || ("space" === (0, _index.normalizeKeyName)(originalEvent) ? " " : originalEvent.key);
                return "string" === typeof key && 1 === key.length && !ctrl && !alt
            },
            _isSingleDigitKey: function(e) {
                var _e$originalEvent;
                var data = null === (_e$originalEvent = e.originalEvent) || void 0 === _e$originalEvent ? void 0 : _e$originalEvent.data;
                return 1 === (null === data || void 0 === data ? void 0 : data.length) && parseInt(data, 10)
            },
            _useBeforeInputEvent: function() {
                var device = _devices.default.real();
                return device.android && device.version[0] > 4
            },
            _keyboardHandler: function(e) {
                var _this2 = this;
                var key = e.originalEvent.key;
                var result = this.callBase(e);
                if (!this._useMaskBehavior() || this._useBeforeInputEvent()) {
                    return result
                }
                if (_browser.default.chrome && "Process" === e.key && 0 === e.code.indexOf("Digit")) {
                    key = e.code.replace("Digit", "");
                    this._processInputKey(key);
                    this._maskInputHandler = function() {
                        _this2._renderSelectedPart()
                    }
                } else {
                    if (this._isSingleCharKey(e)) {
                        this._processInputKey(key);
                        e.originalEvent.preventDefault()
                    }
                }
                return result
            },
            _maskBeforeInputHandler: function(e) {
                var _this3 = this;
                this._maskInputHandler = null;
                var inputType = e.originalEvent.inputType;
                if ("insertCompositionText" === inputType) {
                    this._maskInputHandler = function() {
                        _this3._renderSelectedPart()
                    }
                }
                var isBackwardDeletion = "deleteContentBackward" === inputType;
                var isForwardDeletion = "deleteContentForward" === inputType;
                if (isBackwardDeletion || isForwardDeletion) {
                    var direction = isBackwardDeletion ? BACKWARD : FORWARD;
                    this._maskInputHandler = function() {
                        _this3._revertPart();
                        _this3._selectNextPart(direction)
                    }
                }
                if (!this._useMaskBehavior() || !this._isSingleCharKey(e)) {
                    return
                }
                var key = e.originalEvent.data;
                this._processInputKey(key);
                e.preventDefault();
                return true
            },
            _keyPressHandler: function(e) {
                var event = e.originalEvent;
                if ("insertCompositionText" === (null === event || void 0 === event ? void 0 : event.inputType) && this._isSingleDigitKey(e)) {
                    this._processInputKey(event.data);
                    this._renderDisplayText(this._getDisplayedText(this._maskValue));
                    this._selectNextPart()
                }
                this.callBase(e);
                if (this._maskInputHandler) {
                    this._maskInputHandler();
                    this._maskInputHandler = null
                }
            },
            _processInputKey: function(key) {
                if (this._isAllSelected()) {
                    this._activePartIndex = 0
                }
                this._setNewDateIfEmpty();
                if (isNaN(parseInt(key))) {
                    this._searchString(key)
                } else {
                    this._searchNumber(key)
                }
            },
            _isAllSelected: function() {
                var caret = this._caret();
                return caret.end - caret.start === this.option("text").length
            },
            _getFormatPattern: function() {
                if (this._formatPattern) {
                    return this._formatPattern
                }
                var format = this._strategy.getDisplayFormat(this.option("displayFormat"));
                var isLDMLPattern = (0, _type.isString)(format) && !_date.default._getPatternByFormat(format);
                if (isLDMLPattern) {
                    this._formatPattern = format
                } else {
                    this._formatPattern = (0, _date3.getFormat)(function(value) {
                        return _date.default.format(value, format)
                    })
                }
                return this._formatPattern
            },
            _setNewDateIfEmpty: function() {
                if (!this._maskValue) {
                    var value = "time" === this.option("type") ? new Date(null) : new Date;
                    this._maskValue = value;
                    this._initialMaskValue = value;
                    this._renderDateParts()
                }
            },
            _partLimitsReached: function(max) {
                var maxLimitLength = String(max).length;
                var formatLength = this._getActivePartProp("pattern").length;
                var isShortFormat = 1 === formatLength;
                var maxSearchLength = isShortFormat ? maxLimitLength : Math.min(formatLength, maxLimitLength);
                var isLengthExceeded = this._searchValue.length === maxSearchLength;
                var isValueOverflowed = parseInt(this._searchValue + "0") > max;
                return isLengthExceeded || isValueOverflowed
            },
            _searchNumber: function(char) {
                var _this$_getActivePartL = this._getActivePartLimits(),
                    max = _this$_getActivePartL.max;
                var maxLimitLength = String(max).length;
                this._searchValue = (this._searchValue + char).substr(-maxLimitLength);
                if (isNaN(this._searchValue)) {
                    this._searchValue = char
                }
                this._setActivePartValue(this._searchValue);
                if (this._partLimitsReached(max)) {
                    this._selectNextPart(FORWARD)
                }
            },
            _searchString: function(char) {
                if (!isNaN(parseInt(this._getActivePartProp("text")))) {
                    return
                }
                var limits = this._getActivePartProp("limits")(this._maskValue);
                var startString = this._searchValue + char.toLowerCase();
                var endLimit = limits.max - limits.min;
                for (var i = 0; i <= endLimit; i++) {
                    this._loadMaskValue(this._initialMaskValue);
                    this._partIncrease(i + 1);
                    if (0 === this._getActivePartProp("text").toLowerCase().indexOf(startString)) {
                        this._searchValue = startString;
                        return
                    }
                }
                this._setNewDateIfEmpty();
                if (this._searchValue) {
                    this._clearSearchValue();
                    this._searchString(char)
                }
            },
            _clearSearchValue: function() {
                this._searchValue = ""
            },
            _revertPart: function(direction) {
                if (!this._isAllSelected()) {
                    var actual = this._getActivePartValue(this.option("emptyDateValue"));
                    this._setActivePartValue(actual);
                    this._selectNextPart(direction)
                }
                this._clearSearchValue()
            },
            _useMaskBehavior: function() {
                return this.option("useMaskBehavior") && "text" === this.option("mode")
            },
            _prepareRegExpInfo: function() {
                this._regExpInfo = (0, _date2.getRegExpInfo)(this._getFormatPattern(), _date.default);
                var regExp = this._regExpInfo.regexp;
                var flags = regExp.flags;
                var convertedRegExp = _number.default.convertDigits(this._regExpInfo.regexp.source, false);
                this._regExpInfo.regexp = RegExp(convertedRegExp, flags)
            },
            _initMaskState: function() {
                this._activePartIndex = 0;
                this._formatPattern = null;
                this._prepareRegExpInfo();
                this._loadMaskValue()
            },
            _renderMask: function() {
                this.callBase();
                this._detachMaskEvents();
                this._clearMaskState();
                if (this._useMaskBehavior()) {
                    this._attachMaskEvents();
                    this._initMaskState();
                    this._renderDateParts()
                }
            },
            _renderDateParts: function() {
                if (!this._useMaskBehavior()) {
                    return
                }
                var text = this.option("text") || this._getDisplayedText(this._maskValue);
                if (text) {
                    this._dateParts = (0, _uiDate_boxMask.renderDateParts)(text, this._regExpInfo);
                    if (!this._input().is(":hidden")) {
                        this._selectNextPart()
                    }
                }
            },
            _detachMaskEvents: function() {
                _events_engine.default.off(this._input(), "." + MASK_EVENT_NAMESPACE)
            },
            _attachMaskEvents: function() {
                var _this4 = this;
                _events_engine.default.on(this._input(), (0, _index.addNamespace)("dxclick", MASK_EVENT_NAMESPACE), this._maskClickHandler.bind(this));
                _events_engine.default.on(this._input(), (0, _index.addNamespace)("paste", MASK_EVENT_NAMESPACE), this._maskPasteHandler.bind(this));
                _events_engine.default.on(this._input(), (0, _index.addNamespace)("drop", MASK_EVENT_NAMESPACE), function() {
                    _this4._renderSelectedPart()
                });
                _events_engine.default.on(this._input(), (0, _index.addNamespace)("compositionend", MASK_EVENT_NAMESPACE), this._maskCompositionEndHandler.bind(this));
                if (this._useBeforeInputEvent()) {
                    _events_engine.default.on(this._input(), (0, _index.addNamespace)("beforeinput", MASK_EVENT_NAMESPACE), this._maskBeforeInputHandler.bind(this))
                }
            },
            _renderSelectedPart: function() {
                this._renderDisplayText(this._getDisplayedText(this._maskValue));
                this._selectNextPart()
            },
            _selectLastPart: function() {
                if (this.option("text")) {
                    this._activePartIndex = this._dateParts.length;
                    this._selectNextPart(BACKWARD)
                }
            },
            _selectFirstPart: function() {
                if (this.option("text")) {
                    this._activePartIndex = -1;
                    this._selectNextPart(FORWARD)
                }
            },
            _onMouseWheel: function(e) {
                if (this._useMaskBehavior()) {
                    this._partIncrease(e.delta > 0 ? FORWARD : BACKWARD, e)
                }
            },
            _selectNextPart: function() {
                var step = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                if (!this.option("text") || this._disposed) {
                    return
                }
                if (step) {
                    this._initialMaskValue = new Date(this._maskValue)
                }
                var index = (0, _math.fitIntoRange)(this._activePartIndex + step, 0, this._dateParts.length - 1);
                if (this._dateParts[index].isStub) {
                    var isBoundaryIndex = 0 === index && step < 0 || index === this._dateParts.length - 1 && step > 0;
                    if (!isBoundaryIndex) {
                        this._selectNextPart(step >= 0 ? step + 1 : step - 1);
                        return
                    } else {
                        index = this._activePartIndex
                    }
                }
                if (this._activePartIndex !== index) {
                    this._clearSearchValue()
                }
                this._activePartIndex = index;
                this._caret(this._getActivePartProp("caret"))
            },
            _getRealLimitsPattern: function() {
                if ("d" === this._getActivePartProp("pattern")[0]) {
                    return "dM"
                }
            },
            _getActivePartLimits: function(lockOtherParts) {
                var limitFunction = this._getActivePartProp("limits");
                return limitFunction(this._maskValue, lockOtherParts && this._getRealLimitsPattern())
            },
            _getActivePartValue: function(dateValue) {
                dateValue = dateValue || this._maskValue;
                var getter = this._getActivePartProp("getter");
                return (0, _type.isFunction)(getter) ? getter(dateValue) : dateValue[getter]()
            },
            _addLeadingZeroes: function(value) {
                var zeroes = this._searchValue.match(/^0+/);
                var limits = this._getActivePartLimits();
                var maxLimitLength = String(limits.max).length;
                return ((zeroes && zeroes[0] || "") + String(value)).substr(-maxLimitLength)
            },
            _setActivePartValue: function(value, dateValue) {
                dateValue = dateValue || this._maskValue;
                var setter = this._getActivePartProp("setter");
                var limits = this._getActivePartLimits();
                value = (0, _math.inRange)(value, limits.min, limits.max) ? value : value % 10;
                value = this._addLeadingZeroes((0, _math.fitIntoRange)(value, limits.min, limits.max));
                (0, _type.isFunction)(setter) ? setter(dateValue, value): dateValue[setter](value);
                this._renderDisplayText(this._getDisplayedText(dateValue));
                this._renderDateParts()
            },
            _getActivePartProp: function(property) {
                if (!this._dateParts || !this._dateParts[this._activePartIndex]) {
                    return
                }
                return this._dateParts[this._activePartIndex][property]
            },
            _loadMaskValue: function() {
                var value = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.dateOption("value");
                this._maskValue = value && new Date(value);
                this._initialMaskValue = value && new Date(value)
            },
            _saveMaskValue: function() {
                var value = this._maskValue && new Date(this._maskValue);
                if (value && "date" === this.option("type")) {
                    value.setHours(0, 0, 0, 0)
                }
                this._initialMaskValue = new Date(value);
                this.dateOption("value", value)
            },
            _revertChanges: function() {
                this._loadMaskValue();
                this._renderDisplayText(this._getDisplayedText(this._maskValue));
                this._renderDateParts()
            },
            _renderDisplayText: function(text) {
                this.callBase(text);
                if (this._useMaskBehavior()) {
                    this.option("text", text)
                }
            },
            _partIncrease: function(step, lockOtherParts) {
                this._setNewDateIfEmpty();
                var _this$_getActivePartL2 = this._getActivePartLimits(lockOtherParts),
                    max = _this$_getActivePartL2.max,
                    min = _this$_getActivePartL2.min;
                var limitDelta = max - min;
                if (1 === limitDelta) {
                    limitDelta++
                }
                var newValue = step + this._getActivePartValue();
                if (newValue > max) {
                    newValue = this._applyLimits(newValue, {
                        limitBase: min,
                        limitClosest: max,
                        limitDelta: limitDelta
                    })
                } else {
                    if (newValue < min) {
                        newValue = this._applyLimits(newValue, {
                            limitBase: max,
                            limitClosest: min,
                            limitDelta: limitDelta
                        })
                    }
                }
                this._setActivePartValue(newValue)
            },
            _applyLimits: function(newValue, _ref2) {
                var limitBase = _ref2.limitBase,
                    limitClosest = _ref2.limitClosest,
                    limitDelta = _ref2.limitDelta;
                var delta = (newValue - limitClosest) % limitDelta;
                return delta ? limitBase + delta - 1 * (0, _math.sign)(delta) : limitClosest
            },
            _maskClickHandler: function() {
                if (this.option("text")) {
                    this._activePartIndex = (0, _uiDate_boxMask.getDatePartIndexByPosition)(this._dateParts, this._caret().start);
                    if ((0, _type.isDefined)(this._activePartIndex)) {
                        this._caret(this._getActivePartProp("caret"))
                    } else {
                        this._selectLastPart()
                    }
                }
            },
            _maskCompositionEndHandler: function(e) {
                var _this5 = this;
                if (_browser.default.msie && this._isSingleDigitKey(e)) {
                    var key = e.originalEvent.data;
                    this._processInputKey(key)
                } else {
                    this._input().val(this._getDisplayedText(this._maskValue));
                    this._selectNextPart();
                    this._maskInputHandler = function() {
                        _this5._renderSelectedPart()
                    }
                }
            },
            _maskPasteHandler: function(e) {
                var newText = this._replaceSelectedText(this.option("text"), this._caret(), (0, _dom.clipboardText)(e));
                var date = _date.default.parse(newText, this._getFormatPattern());
                if (date && this._isDateValid(date)) {
                    this._maskValue = date;
                    this._renderDisplayText(this._getDisplayedText(this._maskValue));
                    this._renderDateParts();
                    this._selectNextPart()
                }
                e.preventDefault()
            },
            _isDateValid: function(date) {
                return (0, _type.isDate)(date) && !isNaN(date)
            },
            _isValueDirty: function() {
                var value = this.dateOption("value");
                return (this._maskValue && this._maskValue.getTime()) !== (value && value.getTime())
            },
            _fireChangeEvent: function() {
                this._clearSearchValue();
                if (this._isValueDirty()) {
                    _events_engine.default.trigger(this._input(), "change")
                }
            },
            _enterHandler: function(e) {
                this._fireChangeEvent();
                this._selectNextPart(FORWARD);
                e.preventDefault()
            },
            _focusOutHandler: function(e) {
                this.callBase(e);
                if (this._useMaskBehavior() && !e.isDefaultPrevented()) {
                    this._fireChangeEvent();
                    this._selectFirstPart(e)
                }
            },
            _valueChangeEventHandler: function(e) {
                var text = this.option("text");
                if (this._useMaskBehavior()) {
                    this._saveValueChangeEvent(e);
                    if (!text) {
                        this._maskValue = null
                    } else {
                        if (null === this._maskValue) {
                            this._loadMaskValue(text)
                        }
                    }
                    this._saveMaskValue()
                } else {
                    this.callBase(e)
                }
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "useMaskBehavior":
                        this._renderMask();
                        break;
                    case "displayFormat":
                    case "mode":
                        this.callBase(args);
                        this._renderMask();
                        break;
                    case "value":
                        this._loadMaskValue();
                        this.callBase(args);
                        this._renderDateParts();
                        break;
                    case "emptyDateValue":
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _clearMaskState: function() {
                this._clearSearchValue();
                delete this._dateParts;
                delete this._activePartIndex;
                delete this._maskValue
            },
            reset: function() {
                this.callBase();
                this._clearMaskState();
                this._activePartIndex = 0
            },
            _clean: function() {
                this.callBase();
                this._detachMaskEvents();
                this._clearMaskState()
            }
        });
        var _default = DateBoxMask;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/date_box/ui.date_box.mask.parts.js ***!
      \************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getDatePartIndexByPosition = exports.renderDateParts = void 0;
        var _date = __webpack_require__( /*! ../../localization/ldml/date.parser */ 231);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _math = __webpack_require__( /*! ../../core/utils/math */ 29);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _this = void 0;
        var monthGetter = function(date) {
            return date.getMonth() + 1
        };
        var monthSetter = function(date, value) {
            var day = date.getDate();
            var monthLimits = getLimits("M", date);
            var newValue = (0, _math.fitIntoRange)(parseInt(value), monthLimits.min, monthLimits.max);
            date.setMonth(newValue - 1, 1);
            var _getLimits = getLimits("dM", date),
                min = _getLimits.min,
                max = _getLimits.max;
            var newDay = (0, _math.fitIntoRange)(day, min, max);
            date.setDate(newDay)
        };
        var PATTERN_GETTERS = {
            a: function(date) {
                return date.getHours() < 12 ? 0 : 1
            },
            E: "getDay",
            y: "getFullYear",
            M: monthGetter,
            L: monthGetter,
            d: "getDate",
            H: "getHours",
            h: "getHours",
            m: "getMinutes",
            s: "getSeconds",
            S: "getMilliseconds"
        };
        var PATTERN_SETTERS = (0, _extend.extend)({}, (0, _date.getPatternSetters)(), {
            a: function(date, value) {
                var hours = date.getHours();
                var current = hours >= 12;
                if (current === !!parseInt(value)) {
                    return
                }
                date.setHours((hours + 12) % 24)
            },
            d: function(date, value) {
                var lastDayInMonth = getLimits("dM", date).max;
                if (value > lastDayInMonth) {
                    date.setMonth(date.getMonth() + 1)
                }
                date.setDate(value)
            },
            h: function(date, value) {
                var isPM = date.getHours() >= 12;
                date.setHours(+value % 12 + (isPM ? 12 : 0))
            },
            M: monthSetter,
            L: monthSetter,
            E: function(date, value) {
                if (value < 0) {
                    return
                }
                date.setDate(date.getDate() - date.getDay() + parseInt(value))
            },
            y: function(date, value) {
                var currentYear = date.getFullYear();
                var valueLength = String(value).length;
                var maxLimitLength = String(getLimits("y", date).max).length;
                var newValue = parseInt(String(currentYear).substr(0, maxLimitLength - valueLength) + value);
                date.setFullYear(newValue)
            }
        });
        var getPatternGetter = function(patternChar) {
            var unsupportedCharGetter = function() {
                return patternChar
            };
            return PATTERN_GETTERS[patternChar] || unsupportedCharGetter
        };
        var renderDateParts = function(text, regExpInfo) {
            var result = regExpInfo.regexp.exec(text);
            var start = 0;
            var end = 0;
            var sections = [];
            for (var i = 1; i < result.length; i++) {
                start = end;
                end = start + result[i].length;
                var pattern = regExpInfo.patterns[i - 1].replace(/^'|'$/g, "");
                var getter = getPatternGetter(pattern[0]);
                sections.push({
                    index: i - 1,
                    isStub: pattern === result[i],
                    caret: {
                        start: start,
                        end: end
                    },
                    pattern: pattern,
                    text: result[i],
                    limits: getLimits.bind(_this, pattern[0]),
                    setter: PATTERN_SETTERS[pattern[0]] || _common.noop,
                    getter: getter
                })
            }
            return sections
        };
        exports.renderDateParts = renderDateParts;
        var getLimits = function(pattern, date, forcedPattern) {
            var limits = {
                y: {
                    min: 0,
                    max: 9999
                },
                M: {
                    min: 1,
                    max: 12
                },
                L: {
                    min: 1,
                    max: 12
                },
                d: {
                    min: 1,
                    max: 31
                },
                dM: {
                    min: 1,
                    max: new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()
                },
                E: {
                    min: 0,
                    max: 6
                },
                H: {
                    min: 0,
                    max: 23
                },
                h: {
                    min: 0,
                    max: 23
                },
                m: {
                    min: 0,
                    max: 59
                },
                s: {
                    min: 0,
                    max: 59
                },
                S: {
                    min: 0,
                    max: 999
                },
                a: {
                    min: 0,
                    max: 1
                }
            };
            return limits[forcedPattern || pattern] || limits.getAmPm
        };
        var getDatePartIndexByPosition = function(dateParts, position) {
            for (var i = 0; i < dateParts.length; i++) {
                var caretInGroup = dateParts[i].caret.end >= position;
                if (!dateParts[i].isStub && caretInGroup) {
                    return i
                }
            }
            return null
        };
        exports.getDatePartIndexByPosition = getDatePartIndexByPosition
    },
    /*!******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/date_box/ui.date_box.base.js ***!
      \******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _dom = __webpack_require__( /*! ../../core/utils/dom */ 33);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _version = __webpack_require__( /*! ../../core/utils/version */ 72);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _support = __webpack_require__( /*! ../../core/utils/support */ 45);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _config = _interopRequireDefault(__webpack_require__( /*! ../../core/config */ 31));
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./ui.date_utils */ 137));
        var _date_serialization = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date_serialization */ 57));
        var _ui2 = _interopRequireDefault(__webpack_require__( /*! ../drop_down_editor/ui.drop_down_editor */ 195));
        var _date2 = _interopRequireDefault(__webpack_require__( /*! ../../localization/date */ 32));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _uiDate_boxStrategy = _interopRequireDefault(__webpack_require__( /*! ./ui.date_box.strategy.calendar */ 356));
        var _uiDate_boxStrategy2 = _interopRequireDefault(__webpack_require__( /*! ./ui.date_box.strategy.date_view */ 624));
        var _uiDate_boxStrategy3 = _interopRequireDefault(__webpack_require__( /*! ./ui.date_box.strategy.native */ 627));
        var _uiDate_boxStrategy4 = _interopRequireDefault(__webpack_require__( /*! ./ui.date_box.strategy.calendar_with_time */ 628));
        var _uiDate_boxStrategy5 = _interopRequireDefault(__webpack_require__( /*! ./ui.date_box.strategy.list */ 630));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var DATEBOX_CLASS = "dx-datebox";
        var DX_AUTO_WIDTH_CLASS = "dx-auto-width";
        var DX_INVALID_BADGE_CLASS = "dx-show-invalid-badge";
        var DX_CLEAR_BUTTON_CLASS = "dx-clear-button-area";
        var DATEBOX_WRAPPER_CLASS = "dx-datebox-wrapper";
        var PICKER_TYPE = {
            calendar: "calendar",
            rollers: "rollers",
            list: "list",
            "native": "native"
        };
        var TYPE = {
            date: "date",
            datetime: "datetime",
            time: "time"
        };
        var STRATEGY_NAME = {
            calendar: "Calendar",
            dateView: "DateView",
            "native": "Native",
            calendarWithTime: "CalendarWithTime",
            list: "List"
        };
        var STRATEGY_CLASSES = {
            Calendar: _uiDate_boxStrategy.default,
            DateView: _uiDate_boxStrategy2.default,
            Native: _uiDate_boxStrategy3.default,
            CalendarWithTime: _uiDate_boxStrategy4.default,
            List: _uiDate_boxStrategy5.default
        };
        var DateBox = _ui2.default.inherit({
            _supportedKeys: function() {
                return (0, _extend.extend)(this.callBase(), this._strategy.supportedKeys())
            },
            _renderButtonContainers: function() {
                this.callBase.apply(this, arguments);
                this._strategy.customizeButtons()
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    type: "date",
                    showAnalogClock: true,
                    value: null,
                    dateSerializationFormat: void 0,
                    min: void 0,
                    max: void 0,
                    displayFormat: null,
                    interval: 30,
                    disabledDates: null,
                    pickerType: PICKER_TYPE.calendar,
                    invalidDateMessage: _message.default.format("dxDateBox-validation-datetime"),
                    dateOutOfRangeMessage: _message.default.format("validation-range"),
                    applyButtonText: _message.default.format("OK"),
                    adaptivityEnabled: false,
                    calendarOptions: {},
                    useHiddenSubmitElement: true
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: {
                        platform: "ios"
                    },
                    options: {
                        "dropDownOptions.showTitle": true
                    }
                }, {
                    device: {
                        platform: "android"
                    },
                    options: {
                        buttonsLocation: "bottom after"
                    }
                }, {
                    device: function() {
                        var realDevice = _devices.default.real();
                        var platform = realDevice.platform;
                        return "ios" === platform || "android" === platform
                    },
                    options: {
                        pickerType: PICKER_TYPE.native
                    }
                }, {
                    device: function(currentDevice) {
                        var realDevice = _devices.default.real();
                        var platform = realDevice.platform;
                        var version = realDevice.version;
                        return "generic" === platform && "desktop" !== currentDevice.deviceType || "android" === platform && (0, _version.compare)(version, [4, 4]) < 0
                    },
                    options: {
                        pickerType: PICKER_TYPE.rollers
                    }
                }, {
                    device: {
                        platform: "generic",
                        deviceType: "desktop"
                    },
                    options: {
                        buttonsLocation: "bottom after"
                    }
                }])
            },
            _initOptions: function(options) {
                this._userOptions = (0, _extend.extend)({}, options);
                this.callBase(options);
                this._updatePickerOptions()
            },
            _updatePickerOptions: function() {
                var pickerType = this.option("pickerType");
                var type = this.option("type");
                if (pickerType === PICKER_TYPE.list && (type === TYPE.datetime || type === TYPE.date)) {
                    pickerType = PICKER_TYPE.calendar
                }
                if (type === TYPE.time && pickerType === PICKER_TYPE.calendar) {
                    pickerType = PICKER_TYPE.list
                }
                this.option("showDropDownButton", "generic" !== _devices.default.real().platform || pickerType !== PICKER_TYPE.native);
                this._pickerType = pickerType
            },
            _init: function() {
                this._initStrategy();
                this.option((0, _extend.extend)({}, this._strategy.getDefaultOptions(), this._userOptions));
                delete this._userOptions;
                this.callBase()
            },
            _toLowerCaseFirstLetter: function(string) {
                return string.charAt(0).toLowerCase() + string.substr(1)
            },
            _initStrategy: function() {
                var strategyName = this._getStrategyName(this._getFormatType());
                var strategy = STRATEGY_CLASSES[strategyName];
                if (!(this._strategy && this._strategy.NAME === strategyName)) {
                    this._strategy = new strategy(this)
                }
            },
            _getFormatType: function() {
                var currentType = this.option("type");
                var isTime = /h|m|s/g.test(currentType);
                var isDate = /d|M|Y/g.test(currentType);
                var type = "";
                if (isDate) {
                    type += TYPE.date
                }
                if (isTime) {
                    type += TYPE.time
                }
                return type
            },
            _getStrategyName: function(type) {
                var pickerType = this._pickerType;
                if (pickerType === PICKER_TYPE.rollers) {
                    return STRATEGY_NAME.dateView
                } else {
                    if (pickerType === PICKER_TYPE.native) {
                        return STRATEGY_NAME.native
                    }
                }
                if (type === TYPE.date) {
                    return STRATEGY_NAME.calendar
                }
                if (type === TYPE.datetime) {
                    return STRATEGY_NAME.calendarWithTime
                }
                return STRATEGY_NAME.list
            },
            _initMarkup: function() {
                this.$element().addClass(DATEBOX_CLASS);
                this.callBase();
                this._refreshFormatClass();
                this._refreshPickerTypeClass();
                this._strategy.renderInputMinMax(this._input())
            },
            _render: function() {
                this.callBase();
                this._formatValidationIcon()
            },
            _renderDimensions: function() {
                this.callBase();
                this.$element().toggleClass(DX_AUTO_WIDTH_CLASS, !this.option("width"));
                this._dimensionChanged()
            },
            _dimensionChanged: function() {
                this.callBase(arguments);
                if (this._popup) {
                    var _this$_strategy$_upda, _this$_strategy;
                    null === (_this$_strategy$_upda = (_this$_strategy = this._strategy)._updatePopupHeight) || void 0 === _this$_strategy$_upda ? void 0 : _this$_strategy$_upda.call(_this$_strategy)
                }
            },
            _refreshFormatClass: function() {
                var $element = this.$element();
                (0, _iterator.each)(TYPE, function(_, item) {
                    $element.removeClass(DATEBOX_CLASS + "-" + item)
                });
                $element.addClass(DATEBOX_CLASS + "-" + this.option("type"))
            },
            _refreshPickerTypeClass: function() {
                var $element = this.$element();
                (0, _iterator.each)(PICKER_TYPE, function(_, item) {
                    $element.removeClass(DATEBOX_CLASS + "-" + item)
                });
                $element.addClass(DATEBOX_CLASS + "-" + this._pickerType)
            },
            _formatValidationIcon: function() {
                if (!(0, _window.hasWindow)()) {
                    return
                }
                var inputElement = this._input().get(0);
                var isRtlEnabled = this.option("rtlEnabled");
                var clearButtonWidth = this._getClearButtonWidth();
                var longestElementDimensions = this._getLongestElementDimensions();
                var curWidth = parseFloat(window.getComputedStyle(inputElement).width) - clearButtonWidth;
                var shouldHideValidationIcon = longestElementDimensions.width > curWidth;
                var style = inputElement.style;
                this.$element().toggleClass(DX_INVALID_BADGE_CLASS, !shouldHideValidationIcon);
                if (shouldHideValidationIcon) {
                    if (void 0 === this._storedPadding) {
                        this._storedPadding = isRtlEnabled ? longestElementDimensions.leftPadding : longestElementDimensions.rightPadding
                    }
                    isRtlEnabled ? style.paddingLeft = 0 : style.paddingRight = 0
                } else {
                    isRtlEnabled ? style.paddingLeft = this._storedPadding + "px" : style.paddingRight = this._storedPadding + "px"
                }
            },
            _getClearButtonWidth: function() {
                var clearButtonWidth = 0;
                if (this._isClearButtonVisible() && "" === this._input().val()) {
                    var clearButtonElement = this.$element().find("." + DX_CLEAR_BUTTON_CLASS).get(0);
                    clearButtonWidth = parseFloat(window.getComputedStyle(clearButtonElement).width)
                }
                return clearButtonWidth
            },
            _getLongestElementDimensions: function() {
                var format = this._strategy.getDisplayFormat(this.option("displayFormat"));
                var longestValue = _date2.default.format(_ui.default.getLongestDate(format, _date2.default.getMonthNames(), _date2.default.getDayNames()), format);
                var $input = this._input();
                var inputElement = $input.get(0);
                var $longestValueElement = (0, _dom.createTextElementHiddenCopy)($input, longestValue);
                var isPaddingStored = void 0 !== this._storedPadding;
                var storedPadding = !isPaddingStored ? 0 : this._storedPadding;
                $longestValueElement.appendTo(this.$element());
                var elementWidth = parseFloat(window.getComputedStyle($longestValueElement.get(0)).width);
                var rightPadding = parseFloat(window.getComputedStyle(inputElement).paddingRight);
                var leftPadding = parseFloat(window.getComputedStyle(inputElement).paddingLeft);
                var necessaryWidth = elementWidth + leftPadding + rightPadding + storedPadding;
                $longestValueElement.remove();
                return {
                    width: necessaryWidth,
                    leftPadding: leftPadding,
                    rightPadding: rightPadding
                }
            },
            _getKeyboardListeners: function() {
                return this.callBase().concat([this._strategy && this._strategy.getKeyboardListener()])
            },
            _renderPopup: function() {
                this.callBase();
                this._popup._wrapper().addClass(DATEBOX_WRAPPER_CLASS);
                this._renderPopupWrapper()
            },
            _popupConfig: function() {
                var popupConfig = this.callBase();
                return (0, _extend.extend)(this._strategy.popupConfig(popupConfig), {
                    title: this._getPopupTitle(),
                    dragEnabled: false
                })
            },
            _renderPopupWrapper: function() {
                if (!this._popup) {
                    return
                }
                var $element = this.$element();
                var classPostfixes = (0, _extend.extend)({}, TYPE, PICKER_TYPE);
                (0, _iterator.each)(classPostfixes, function(_, item) {
                    $element.removeClass(DATEBOX_WRAPPER_CLASS + "-" + item)
                }.bind(this));
                this._popup._wrapper().addClass(DATEBOX_WRAPPER_CLASS + "-" + this.option("type")).addClass(DATEBOX_WRAPPER_CLASS + "-" + this._pickerType)
            },
            _renderPopupContent: function() {
                this.callBase();
                this._strategy.renderPopupContent()
            },
            _getFirstPopupElement: function() {
                return this._strategy.getFirstPopupElement() || this.callBase()
            },
            _getLastPopupElement: function() {
                return this._strategy.getLastPopupElement() || this.callBase()
            },
            _popupShowingHandler: function() {
                this.callBase();
                this._strategy.popupShowingHandler()
            },
            _popupShownHandler: function() {
                this.callBase();
                this._strategy.renderOpenedState()
            },
            _popupHiddenHandler: function() {
                this.callBase();
                this._strategy.renderOpenedState();
                this._strategy.popupHiddenHandler()
            },
            _visibilityChanged: function(visible) {
                if (visible) {
                    this._formatValidationIcon()
                }
            },
            _clearValueHandler: function(e) {
                this.option("text", "");
                this.callBase(e)
            },
            _readOnlyPropValue: function() {
                if (this._pickerType === PICKER_TYPE.rollers) {
                    return true
                }
                var platform = _devices.default.real().platform;
                var isCustomValueDisabled = this._isNativeType() && ("ios" === platform || "android" === platform);
                if (isCustomValueDisabled) {
                    return this.option("readOnly")
                }
                return this.callBase()
            },
            _isClearButtonVisible: function() {
                return this.callBase() && !this._isNativeType()
            },
            _renderValue: function() {
                var value = this.dateOption("value");
                this.option("text", this._getDisplayedText(value));
                this._strategy.renderValue();
                return this.callBase()
            },
            _setSubmitValue: function() {
                var value = this.dateOption("value");
                var dateSerializationFormat = this.option("dateSerializationFormat");
                var submitFormat = _ui.default.SUBMIT_FORMATS_MAP[this.option("type")];
                var submitValue = dateSerializationFormat ? _date_serialization.default.serializeDate(value, dateSerializationFormat) : _ui.default.toStandardDateFormat(value, submitFormat);
                this._getSubmitElement().val(submitValue)
            },
            _getDisplayedText: function(value) {
                var mode = this.option("mode");
                var displayedText;
                if ("text" === mode) {
                    var displayFormat = this._strategy.getDisplayFormat(this.option("displayFormat"));
                    displayedText = _date2.default.format(value, displayFormat)
                } else {
                    var format = this._getFormatByMode(mode);
                    if (format) {
                        displayedText = _date2.default.format(value, format)
                    } else {
                        displayedText = _ui.default.toStandardDateFormat(value, mode)
                    }
                }
                return displayedText
            },
            _getFormatByMode: function(mode) {
                return (0, _support.inputType)(mode) ? null : _ui.default.FORMATS_MAP[mode]
            },
            _valueChangeEventHandler: function(e) {
                var text = this.option("text");
                var currentValue = this.dateOption("value");
                if (text === this._getDisplayedText(currentValue)) {
                    this._applyInternalValidation(currentValue);
                    return
                }
                var parsedDate = this._getParsedDate(text);
                var value = null !== currentValue && void 0 !== currentValue ? currentValue : this._getDateByDefault();
                var type = this.option("type");
                var newValue = _ui.default.mergeDates(value, parsedDate, type);
                var date = parsedDate && "time" === type ? newValue : parsedDate;
                if (this._applyInternalValidation(date).isValid) {
                    var displayedText = this._getDisplayedText(newValue);
                    if (value && newValue && value.getTime() === newValue.getTime() && displayedText !== text) {
                        this._renderValue()
                    } else {
                        this.dateValue(newValue, e)
                    }
                }
            },
            _getDateByDefault: function() {
                return this._strategy.useCurrentDateByDefault() && this._strategy.getDefaultDate()
            },
            _getParsedDate: function(text) {
                var displayFormat = this._strategy.getDisplayFormat(this.option("displayFormat"));
                var parsedText = this._strategy.getParsedText(text, displayFormat);
                return null !== parsedText && void 0 !== parsedText ? parsedText : void 0
            },
            _applyInternalValidation: function(value) {
                var text = this.option("text");
                var hasText = !!text && null !== value;
                var isDate = !!value && (0, _type.isDate)(value) && !isNaN(value.getTime());
                var isDateInRange = isDate && _date.default.dateInRange(value, this.dateOption("min"), this.dateOption("max"), this.option("type"));
                var isValid = !hasText && !value || isDateInRange;
                var validationMessage = "";
                if (!isDate) {
                    validationMessage = this.option("invalidDateMessage")
                } else {
                    if (!isDateInRange) {
                        validationMessage = this.option("dateOutOfRangeMessage")
                    }
                }
                this.option({
                    isValid: isValid,
                    validationError: isValid ? null : {
                        editorSpecific: true,
                        message: validationMessage
                    }
                });
                return {
                    isValid: isValid,
                    isDate: isDate
                }
            },
            _applyCustomValidation: function(value) {
                this.validationRequest.fire({
                    editor: this,
                    value: this._serializeDate(value)
                })
            },
            _isValueChanged: function(newValue) {
                var oldValue = this.dateOption("value");
                var oldTime = oldValue && oldValue.getTime();
                var newTime = newValue && newValue.getTime();
                return oldTime !== newTime
            },
            _isTextChanged: function(newValue) {
                var oldText = this.option("text");
                var newText = newValue && this._getDisplayedText(newValue) || "";
                return oldText !== newText
            },
            _renderProps: function() {
                this.callBase();
                this._input().attr("autocomplete", "off")
            },
            _renderOpenedState: function() {
                if (!this._isNativeType()) {
                    this.callBase()
                }
                if (this._strategy.isAdaptivityChanged()) {
                    this._refreshStrategy()
                }
            },
            _getPopupTitle: function() {
                var placeholder = this.option("placeholder");
                if (placeholder) {
                    return placeholder
                }
                var type = this.option("type");
                if (type === TYPE.time) {
                    return _message.default.format("dxDateBox-simulatedDataPickerTitleTime")
                }
                if (type === TYPE.date || type === TYPE.datetime) {
                    return _message.default.format("dxDateBox-simulatedDataPickerTitleDate")
                }
                return ""
            },
            _renderPlaceholder: function() {
                this._popup && this._popup.option("title", this._getPopupTitle());
                this.callBase()
            },
            _refreshStrategy: function() {
                this._strategy.dispose();
                this._initStrategy();
                this.option(this._strategy.getDefaultOptions());
                this._refresh()
            },
            _applyButtonHandler: function(e) {
                var value = this._strategy.getValue();
                var _this$_applyInternalV = this._applyInternalValidation(value),
                    isValid = _this$_applyInternalV.isValid,
                    isDate = _this$_applyInternalV.isDate;
                if (isValid) {
                    this.dateValue(value, e.event)
                } else {
                    if (isDate) {
                        var displayedText = this._getDisplayedText(value);
                        this.option("text", displayedText);
                        this._renderDisplayText(displayedText)
                    }
                }
                this.callBase()
            },
            _dispose: function() {
                var _this$_strategy2;
                this.callBase();
                null === (_this$_strategy2 = this._strategy) || void 0 === _this$_strategy2 ? void 0 : _this$_strategy2.dispose()
            },
            _isNativeType: function() {
                return this._pickerType === PICKER_TYPE.native
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "showClearButton":
                    case "buttons":
                        this.callBase.apply(this, arguments);
                        this._formatValidationIcon();
                        break;
                    case "pickerType":
                        this._updatePickerOptions({
                            pickerType: args.value
                        });
                        this._refreshStrategy();
                        this._refreshPickerTypeClass();
                        this._invalidate();
                        break;
                    case "type":
                        this._updatePickerOptions({
                            format: args.value
                        });
                        this._refreshStrategy();
                        this._refreshFormatClass();
                        this._renderPopupWrapper();
                        this._formatValidationIcon();
                        this._updateValue();
                        break;
                    case "placeholder":
                        this._renderPlaceholder();
                        break;
                    case "min":
                    case "max":
                        var isValid = this.option("isValid");
                        this._applyInternalValidation(this.dateOption("value"));
                        if (!isValid) {
                            this._applyCustomValidation(this.dateOption("value"))
                        }
                        this._invalidate();
                        break;
                    case "dateSerializationFormat":
                    case "interval":
                    case "disabledDates":
                    case "calendarOptions":
                        this._invalidate();
                        break;
                    case "displayFormat":
                        this.option("text", this._getDisplayedText(this.dateOption("value")));
                        this._renderInputValue();
                        break;
                    case "text":
                        this._strategy.textChangedHandler(args.value);
                        this.callBase.apply(this, arguments);
                        break;
                    case "isValid":
                        this.callBase.apply(this, arguments);
                        this._formatValidationIcon();
                        break;
                    case "showDropDownButton":
                        this._formatValidationIcon();
                        this.callBase.apply(this, arguments);
                        break;
                    case "readOnly":
                        this.callBase.apply(this, arguments);
                        this._formatValidationIcon();
                        break;
                    case "invalidDateMessage":
                    case "dateOutOfRangeMessage":
                    case "adaptivityEnabled":
                    case "showAnalogClock":
                        break;
                    default:
                        this.callBase.apply(this, arguments)
                }
            },
            _getSerializationFormat: function() {
                var value = this.option("value");
                if (this.option("dateSerializationFormat") && (0, _config.default)().forceIsoDateParsing) {
                    return this.option("dateSerializationFormat")
                }
                if ((0, _type.isNumeric)(value)) {
                    return "number"
                }
                if (!(0, _type.isString)(value)) {
                    return
                }
                return _date_serialization.default.getDateSerializationFormat(value)
            },
            _updateValue: function(value) {
                this.callBase();
                this._applyInternalValidation(null !== value && void 0 !== value ? value : this.dateOption("value"))
            },
            dateValue: function(value, dxEvent) {
                var isValueChanged = this._isValueChanged(value);
                if (isValueChanged && dxEvent) {
                    this._saveValueChangeEvent(dxEvent)
                }
                if (!isValueChanged) {
                    if (this._isTextChanged(value)) {
                        this._updateValue(value)
                    } else {
                        if ("" === this.option("text")) {
                            this._applyCustomValidation(value)
                        }
                    }
                }
                return this.dateOption("value", value)
            },
            dateOption: function(optionName, value) {
                if (1 === arguments.length) {
                    return _date_serialization.default.deserializeDate(this.option(optionName))
                }
                this.option(optionName, this._serializeDate(value))
            },
            _serializeDate: function(date) {
                var serializationFormat = this._getSerializationFormat();
                return _date_serialization.default.serializeDate(date, serializationFormat)
            },
            reset: function() {
                this.callBase();
                this._updateValue(this.dateOption("value"))
            }
        });
        (0, _component_registrator.default)("dxDateBox", DateBox);
        var _default = DateBox;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/date_box/ui.date_box.strategy.date_view.js ***!
      \********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./ui.date_view */ 625));
        var _uiDate_box = _interopRequireDefault(__webpack_require__( /*! ./ui.date_box.strategy */ 213));
        var _support = __webpack_require__( /*! ../../core/utils/support */ 45);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _ui2 = _interopRequireDefault(__webpack_require__( /*! ./ui.date_utils */ 137));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var DateViewStrategy = _uiDate_box.default.inherit({
            NAME: "DateView",
            getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    openOnFieldClick: true,
                    applyButtonText: _message.default.format("OK"),
                    "dropDownOptions.showTitle": true
                })
            },
            getDisplayFormat: function(displayFormat) {
                return displayFormat || _ui2.default.FORMATS_MAP[this.dateBox.option("type")]
            },
            popupConfig: function(config) {
                return {
                    toolbarItems: this.dateBox._popupToolbarItemsConfig(),
                    onInitialized: config.onInitialized,
                    defaultOptionsRules: [{
                        device: {
                            platform: "android"
                        },
                        options: {
                            width: 333,
                            height: 331
                        }
                    }, {
                        device: function(_device) {
                            var platform = _device.platform;
                            return "generic" === platform || "ios" === platform
                        },
                        options: {
                            width: "auto",
                            height: "auto"
                        }
                    }, {
                        device: function(_device2) {
                            var platform = _device2.platform;
                            var phone = _device2.phone;
                            return "generic" === platform && phone
                        },
                        options: {
                            width: 333,
                            maxWidth: "100%",
                            maxHeight: "100%",
                            height: "auto",
                            position: {
                                collision: "flipfit flip"
                            }
                        }
                    }, {
                        device: {
                            platform: "ios",
                            phone: true
                        },
                        options: {
                            width: "100%",
                            position: {
                                my: "bottom",
                                at: "bottom",
                                of: window
                            }
                        }
                    }]
                }
            },
            _renderWidget: function() {
                if ((0, _support.inputType)(this.dateBox.option("mode")) && this.dateBox._isNativeType() || this.dateBox.option("readOnly")) {
                    if (this._widget) {
                        this._widget.$element().remove();
                        this._widget = null
                    }
                    return
                }
                var popup = this._getPopup();
                if (this._widget) {
                    this._widget.option(this._getWidgetOptions())
                } else {
                    var element = (0, _renderer.default)("<div>").appendTo(popup.$content());
                    this._widget = this._createWidget(element)
                }
                this._widget.$element().appendTo(this._getWidgetContainer())
            },
            _getWidgetName: function() {
                return _ui.default
            },
            renderOpenedState: function() {
                this.callBase();
                if (this._widget) {
                    this._widget.option("value", this._widget._getCurrentDate())
                }
            },
            _getWidgetOptions: function() {
                return {
                    value: this.dateBoxValue() || new Date,
                    type: this.dateBox.option("type"),
                    minDate: this.dateBox.dateOption("min") || new Date(1900, 0, 1),
                    maxDate: this.dateBox.dateOption("max") || new Date(Date.now() + 50 * _ui2.default.ONE_YEAR),
                    onDisposing: function() {
                        this._widget = null
                    }.bind(this)
                }
            }
        });
        var _default = DateViewStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/date_box/ui.date_view.js ***!
      \**************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _editor = _interopRequireDefault(__webpack_require__( /*! ../editor/editor */ 52));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./ui.date_view_roller */ 626));
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _ui2 = _interopRequireDefault(__webpack_require__( /*! ./ui.date_utils */ 137));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _date2 = _interopRequireDefault(__webpack_require__( /*! ../../localization/date */ 32));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DATEVIEW_CLASS = "dx-dateview";
        var DATEVIEW_COMPACT_CLASS = "dx-dateview-compact";
        var DATEVIEW_WRAPPER_CLASS = "dx-dateview-wrapper";
        var DATEVIEW_ROLLER_CONTAINER_CLASS = "dx-dateview-rollers";
        var DATEVIEW_ROLLER_CLASS = "dx-dateviewroller";
        var TYPE = {
            date: "date",
            datetime: "datetime",
            time: "time"
        };
        var ROLLER_TYPE = {
            year: "year",
            month: "month",
            day: "day",
            hours: "hours"
        };
        var DateView = _editor.default.inherit({
            _valueOption: function() {
                var value = this.option("value");
                var date = new Date(value);
                return !value || isNaN(date) ? this._getDefaultDate() : date
            },
            _getDefaultDate: function() {
                var date = new Date;
                if (this.option("type") === TYPE.date) {
                    return new Date(date.getFullYear(), date.getMonth(), date.getDate())
                }
                return date
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    minDate: _ui2.default.MIN_DATEVIEW_DEFAULT_DATE,
                    maxDate: _ui2.default.MAX_DATEVIEW_DEFAULT_DATE,
                    type: TYPE.date,
                    value: new Date,
                    applyCompactClass: false
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: function(_device) {
                        return "desktop" !== _device.deviceType
                    },
                    options: {
                        applyCompactClass: true
                    }
                }])
            },
            _render: function() {
                this.callBase();
                this.$element().addClass(DATEVIEW_CLASS);
                this._toggleFormatClasses(this.option("type"));
                this._toggleCompactClass()
            },
            _toggleFormatClasses: function(currentFormat, previousFormat) {
                this.$element().addClass(DATEVIEW_CLASS + "-" + currentFormat);
                previousFormat && this.$element().removeClass(DATEVIEW_CLASS + "-" + previousFormat)
            },
            _toggleCompactClass: function() {
                this.$element().toggleClass(DATEVIEW_COMPACT_CLASS, this.option("applyCompactClass"))
            },
            _wrapper: function() {
                return this._$wrapper
            },
            _renderContentImpl: function() {
                this._$wrapper = (0, _renderer.default)("<div>").addClass(DATEVIEW_WRAPPER_CLASS);
                this._renderRollers();
                this._$wrapper.appendTo(this.$element())
            },
            _renderRollers: function() {
                if (!this._$rollersContainer) {
                    this._$rollersContainer = (0, _renderer.default)("<div>").addClass(DATEVIEW_ROLLER_CONTAINER_CLASS)
                }
                this._$rollersContainer.empty();
                this._createRollerConfigs();
                this._rollers = {};
                var that = this;
                (0, _iterator.each)(that._rollerConfigs, function(name) {
                    var $roller = (0, _renderer.default)("<div>").appendTo(that._$rollersContainer).addClass(DATEVIEW_ROLLER_CLASS + "-" + that._rollerConfigs[name].type);
                    that._rollers[that._rollerConfigs[name].type] = that._createComponent($roller, _ui.default, {
                        items: that._rollerConfigs[name].displayItems,
                        selectedIndex: that._rollerConfigs[name].selectedIndex,
                        showScrollbar: false,
                        onStart: function(e) {
                            var roller = e.component;
                            roller._toggleActive(true);
                            that._setActiveRoller(that._rollerConfigs[name], roller.option("selectedIndex"))
                        },
                        onEnd: function(e) {
                            var roller = e.component;
                            roller._toggleActive(false)
                        },
                        onClick: function(e) {
                            var roller = e.component;
                            roller._toggleActive(true);
                            that._setActiveRoller(that._rollerConfigs[name], roller.option("selectedIndex"));
                            that._setRollerState(that._rollerConfigs[name], roller.option("selectedIndex"));
                            roller._toggleActive(false)
                        },
                        onSelectedIndexChanged: function(e) {
                            var roller = e.component;
                            that._setRollerState(that._rollerConfigs[name], roller.option("selectedIndex"))
                        }
                    })
                });
                that._$rollersContainer.appendTo(that._wrapper())
            },
            _createRollerConfigs: function(type) {
                var that = this;
                type = type || that.option("type");
                that._rollerConfigs = {};
                _date2.default.getFormatParts(_ui2.default.FORMATS_MAP[type]).forEach(function(partName) {
                    that._createRollerConfig(partName)
                })
            },
            _createRollerConfig: function(componentName) {
                var componentInfo = _ui2.default.DATE_COMPONENTS_INFO[componentName];
                var valueRange = this._calculateRollerConfigValueRange(componentName);
                var startValue = valueRange.startValue;
                var endValue = valueRange.endValue;
                var formatter = componentInfo.formatter;
                var curDate = this._getCurrentDate();
                var config = {
                    type: componentName,
                    setValue: componentInfo.setter,
                    valueItems: [],
                    displayItems: [],
                    getIndex: function(value) {
                        return value[componentInfo.getter]() - startValue
                    }
                };
                for (var i = startValue; i <= endValue; i++) {
                    config.valueItems.push(i);
                    config.displayItems.push(formatter(i, curDate))
                }
                config.selectedIndex = config.getIndex(curDate);
                this._rollerConfigs[componentName] = config
            },
            _setActiveRoller: function(currentRoller) {
                var activeRoller = currentRoller && this._rollers[currentRoller.type];
                (0, _iterator.each)(this._rollers, function() {
                    this.toggleActiveState(this === activeRoller)
                })
            },
            _updateRollersPosition: function() {
                var that = this;
                (0, _iterator.each)(this._rollers, function(type) {
                    var correctIndex = that._rollerConfigs[type].getIndex(that._getCurrentDate());
                    this.option("selectedIndex", correctIndex)
                })
            },
            _setRollerState: function(roller, selectedIndex) {
                if (selectedIndex !== roller.selectedIndex) {
                    var rollerValue = roller.valueItems[selectedIndex];
                    var setValue = roller.setValue;
                    var currentValue = new Date(this._getCurrentDate());
                    var currentDate = currentValue.getDate();
                    var minDate = this.option("minDate");
                    var maxDate = this.option("maxDate");
                    if (roller.type === ROLLER_TYPE.month) {
                        currentDate = Math.min(currentDate, _ui2.default.getMaxMonthDay(currentValue.getFullYear(), rollerValue))
                    } else {
                        if (roller.type === ROLLER_TYPE.year) {
                            currentDate = Math.min(currentDate, _ui2.default.getMaxMonthDay(rollerValue, currentValue.getMonth()))
                        }
                    }
                    currentValue.setDate(currentDate);
                    currentValue[setValue](rollerValue);
                    var normalizedDate = _date.default.normalizeDate(currentValue, minDate, maxDate);
                    currentValue = _ui2.default.mergeDates(normalizedDate, currentValue, "time");
                    currentValue = _date.default.normalizeDate(currentValue, minDate, maxDate);
                    this.option("value", currentValue);
                    roller.selectedIndex = selectedIndex
                }
                if (roller.type === ROLLER_TYPE.year) {
                    this._refreshRollers()
                }
                if (roller.type === ROLLER_TYPE.month) {
                    this._refreshRoller(ROLLER_TYPE.day);
                    this._refreshRoller(ROLLER_TYPE.hours)
                }
            },
            _refreshRoller: function(rollerType) {
                var roller = this._rollers[rollerType];
                if (roller) {
                    this._createRollerConfig(rollerType);
                    var rollerConfig = this._rollerConfigs[rollerType];
                    if (rollerType === ROLLER_TYPE.day || rollerConfig.displayItems.toString() !== roller.option("items").toString()) {
                        roller.option({
                            items: rollerConfig.displayItems,
                            selectedIndex: rollerConfig.selectedIndex
                        })
                    }
                }
            },
            _getCurrentDate: function() {
                var curDate = this._valueOption();
                var minDate = this.option("minDate");
                var maxDate = this.option("maxDate");
                return _date.default.normalizeDate(curDate, minDate, maxDate)
            },
            _calculateRollerConfigValueRange: function(componentName) {
                var curDate = this._getCurrentDate();
                var minDate = this.option("minDate");
                var maxDate = this.option("maxDate");
                var minYear = _date.default.sameYear(curDate, minDate);
                var minMonth = minYear && curDate.getMonth() === minDate.getMonth();
                var maxYear = _date.default.sameYear(curDate, maxDate);
                var maxMonth = maxYear && curDate.getMonth() === maxDate.getMonth();
                var minHour = minMonth && curDate.getDate() === minDate.getDate();
                var maxHour = maxMonth && curDate.getDate() === maxDate.getDate();
                var componentInfo = _ui2.default.DATE_COMPONENTS_INFO[componentName];
                var startValue = componentInfo.startValue;
                var endValue = componentInfo.endValue;
                if (componentName === ROLLER_TYPE.year) {
                    startValue = minDate.getFullYear();
                    endValue = maxDate.getFullYear()
                }
                if (componentName === ROLLER_TYPE.month) {
                    if (minYear) {
                        startValue = minDate.getMonth()
                    }
                    if (maxYear) {
                        endValue = maxDate.getMonth()
                    }
                }
                if (componentName === ROLLER_TYPE.day) {
                    endValue = _ui2.default.getMaxMonthDay(curDate.getFullYear(), curDate.getMonth());
                    if (minYear && minMonth) {
                        startValue = minDate.getDate()
                    }
                    if (maxYear && maxMonth) {
                        endValue = maxDate.getDate()
                    }
                }
                if (componentName === ROLLER_TYPE.hours) {
                    startValue = minHour ? minDate.getHours() : startValue;
                    endValue = maxHour ? maxDate.getHours() : endValue
                }
                return {
                    startValue: startValue,
                    endValue: endValue
                }
            },
            _refreshRollers: function() {
                this._refreshRoller(ROLLER_TYPE.month);
                this._refreshRoller(ROLLER_TYPE.day);
                this._refreshRoller(ROLLER_TYPE.hours)
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "minDate":
                    case "maxDate":
                    case "type":
                        this._renderRollers();
                        this._toggleFormatClasses(args.value, args.previousValue);
                        break;
                    case "visible":
                        this.callBase(args);
                        if (args.value) {
                            this._renderRollers()
                        }
                        break;
                    case "value":
                        this.option("value", this._valueOption());
                        this._refreshRollers();
                        this._updateRollersPosition();
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _clean: function() {
                this.callBase();
                delete this._$rollersContainer
            }
        });
        (0, _component_registrator.default)("dxDateView", DateView);
        var _default = DateView;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/date_box/ui.date_view_roller.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _click = __webpack_require__( /*! ../../events/click */ 21);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../scroll_view/ui.scrollable */ 106));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _fx = _interopRequireDefault(__webpack_require__( /*! ../../animation/fx */ 42));
        var _translator = __webpack_require__( /*! ../../animation/translator */ 28);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DATEVIEW_ROLLER_CLASS = "dx-dateviewroller";
        var DATEVIEW_ROLLER_ACTIVE_CLASS = "dx-state-active";
        var DATEVIEW_ROLLER_CURRENT_CLASS = "dx-dateviewroller-current";
        var DATEVIEW_ROLLER_ITEM_CLASS = "dx-dateview-item";
        var DATEVIEW_ROLLER_ITEM_SELECTED_CLASS = "dx-dateview-item-selected";
        var DATEVIEW_ROLLER_ITEM_SELECTED_FRAME_CLASS = "dx-dateview-item-selected-frame";
        var DATEVIEW_ROLLER_ITEM_SELECTED_BORDER_CLASS = "dx-dateview-item-selected-border";
        var DateViewRoller = _ui.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    showScrollbar: false,
                    useNative: false,
                    selectedIndex: 0,
                    bounceEnabled: false,
                    items: [],
                    showOnClick: false,
                    onClick: null,
                    onSelectedIndexChanged: null
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: {
                        platform: "generic"
                    },
                    options: {
                        scrollByContent: true
                    }
                }])
            },
            _init: function() {
                this.callBase();
                this._renderSelectedItemFrame()
            },
            _render: function() {
                this.callBase();
                this.$element().addClass(DATEVIEW_ROLLER_CLASS);
                this._renderContainerClick();
                this._renderItems();
                this._renderSelectedValue();
                this._renderItemsClick();
                this._renderWheelEvent();
                this._wrapAction("_endAction", this._endActionHandler.bind(this));
                this._renderSelectedIndexChanged()
            },
            _renderSelectedIndexChanged: function() {
                this._selectedIndexChanged = this._createActionByOption("onSelectedIndexChanged")
            },
            _renderWheelEvent: function() {
                var _this = this;
                _events_engine.default.on(this._$container, "dxmousewheel", function(e) {
                    _this._isWheelScrolled = true
                })
            },
            _renderContainerClick: function() {
                if (!this.option("showOnClick")) {
                    return
                }
                var eventName = (0, _index.addNamespace)(_click.name, this.NAME);
                var clickAction = this._createActionByOption("onClick");
                _events_engine.default.off(this._$container, eventName);
                _events_engine.default.on(this._$container, eventName, function(e) {
                    clickAction({
                        event: e
                    })
                })
            },
            _wrapAction: function(actionName, callback) {
                var strategy = this._strategy;
                var originalAction = strategy[actionName];
                strategy[actionName] = function() {
                    callback.apply(this, arguments);
                    return originalAction.apply(this, arguments)
                }
            },
            _renderItems: function() {
                var items = this.option("items") || [];
                var $items = (0, _renderer.default)();
                this._$content.empty();
                items.forEach(function(item) {
                    $items = $items.add((0, _renderer.default)("<div>").addClass(DATEVIEW_ROLLER_ITEM_CLASS).append(item))
                });
                this._$content.append($items);
                this._$items = $items;
                this.update()
            },
            _renderSelectedItemFrame: function() {
                (0, _renderer.default)("<div>").addClass(DATEVIEW_ROLLER_ITEM_SELECTED_FRAME_CLASS).append((0, _renderer.default)("<div>").addClass(DATEVIEW_ROLLER_ITEM_SELECTED_BORDER_CLASS)).appendTo(this._$container)
            },
            _renderSelectedValue: function(selectedIndex) {
                var index = this._fitIndex(null !== selectedIndex && void 0 !== selectedIndex ? selectedIndex : this.option("selectedIndex"));
                this._moveTo({
                    top: this._getItemPosition(index)
                });
                this._renderActiveStateItem()
            },
            _fitIndex: function(index) {
                var items = this.option("items") || [];
                var itemCount = items.length;
                if (index >= itemCount) {
                    return itemCount - 1
                }
                if (index < 0) {
                    return 0
                }
                return index
            },
            _getItemPosition: function(index) {
                return Math.round(this._itemHeight() * index)
            },
            _renderItemsClick: function() {
                var itemSelector = this._getItemSelector();
                var eventName = (0, _index.addNamespace)(_click.name, this.NAME);
                _events_engine.default.off(this.$element(), eventName, itemSelector);
                _events_engine.default.on(this.$element(), eventName, itemSelector, this._itemClickHandler.bind(this))
            },
            _getItemSelector: function() {
                return "." + DATEVIEW_ROLLER_ITEM_CLASS
            },
            _itemClickHandler: function(e) {
                this.option("selectedIndex", this._itemElementIndex(e.currentTarget))
            },
            _itemElementIndex: function(itemElement) {
                return this._itemElements().index(itemElement)
            },
            _itemElements: function() {
                return this.$element().find(this._getItemSelector())
            },
            _renderActiveStateItem: function() {
                var selectedIndex = this.option("selectedIndex");
                (0, _iterator.each)(this._$items, function(index) {
                    (0, _renderer.default)(this).toggleClass(DATEVIEW_ROLLER_ITEM_SELECTED_CLASS, selectedIndex === index)
                })
            },
            _shouldScrollToNeighborItem: function() {
                return "desktop" === _devices.default.real().deviceType && this._isWheelScrolled
            },
            _moveTo: function(targetLocation) {
                targetLocation = this._normalizeLocation(targetLocation);
                var location = this._location();
                var delta = {
                    x: -(location.left - targetLocation.left),
                    y: -(location.top - targetLocation.top)
                };
                if (this._isVisible() && (delta.x || delta.y)) {
                    this._strategy._prepareDirections(true);
                    if (this._animation && !this._shouldScrollToNeighborItem()) {
                        var that = this;
                        _fx.default.stop(this._$content);
                        _fx.default.animate(this._$content, {
                            duration: 200,
                            type: "slide",
                            to: {
                                top: Math.floor(delta.y)
                            },
                            complete: function() {
                                (0, _translator.resetPosition)(that._$content);
                                that._strategy.handleMove({
                                    delta: delta
                                })
                            }
                        });
                        delete this._animation
                    } else {
                        this._strategy.handleMove({
                            delta: delta
                        })
                    }
                }
            },
            _validate: function(e) {
                return this._strategy.validate(e)
            },
            _fitSelectedIndexInRange: function(index) {
                var itemsCount = this.option("items").length;
                return Math.max(Math.min(index, itemsCount - 1), 0)
            },
            _isInNullNeighborhood: function(x) {
                var EPS = .1;
                return -EPS <= x && x <= EPS
            },
            _getSelectedIndexAfterScroll: function(currentSelectedIndex) {
                var locationTop = -this._location().top;
                var currentSelectedIndexPosition = currentSelectedIndex * this._itemHeight();
                var dy = locationTop - currentSelectedIndexPosition;
                if (this._isInNullNeighborhood(dy)) {
                    return currentSelectedIndex
                }
                var direction = dy > 0 ? 1 : -1;
                var newSelectedIndex = this._fitSelectedIndexInRange(currentSelectedIndex + direction);
                return newSelectedIndex
            },
            _getNewSelectedIndex: function(currentSelectedIndex) {
                if (this._shouldScrollToNeighborItem()) {
                    return this._getSelectedIndexAfterScroll(currentSelectedIndex)
                }
                this._animation = true;
                var ratio = -this._location().top / this._itemHeight();
                return Math.round(ratio)
            },
            _endActionHandler: function() {
                var currentSelectedIndex = this.option("selectedIndex");
                var newSelectedIndex = this._getNewSelectedIndex(currentSelectedIndex);
                if (newSelectedIndex === currentSelectedIndex) {
                    this._renderSelectedValue(newSelectedIndex)
                } else {
                    this.option("selectedIndex", newSelectedIndex)
                }
                this._isWheelScrolled = false
            },
            _itemHeight: function() {
                var $item = this._$items.first();
                return $item.height()
            },
            _toggleActive: function(state) {
                this.$element().toggleClass(DATEVIEW_ROLLER_ACTIVE_CLASS, state)
            },
            _isVisible: function() {
                return this._$container.is(":visible")
            },
            _fireSelectedIndexChanged: function(value, previousValue) {
                this._selectedIndexChanged({
                    value: value,
                    previousValue: previousValue,
                    event: void 0
                })
            },
            _visibilityChanged: function(visible) {
                this.callBase(visible);
                if (visible) {
                    this._renderSelectedValue(this.option("selectedIndex"))
                }
                this.toggleActiveState(false)
            },
            toggleActiveState: function(state) {
                this.$element().toggleClass(DATEVIEW_ROLLER_CURRENT_CLASS, state)
            },
            _refreshSelectedIndex: function() {
                var selectedIndex = this.option("selectedIndex");
                var fitIndex = this._fitIndex(selectedIndex);
                if (fitIndex === selectedIndex) {
                    this._renderActiveStateItem()
                } else {
                    this.option("selectedIndex", fitIndex)
                }
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "selectedIndex":
                        this._fireSelectedIndexChanged(args.value, args.previousValue);
                        this._renderSelectedValue(args.value);
                        break;
                    case "items":
                        this._renderItems();
                        this._refreshSelectedIndex();
                        break;
                    case "onClick":
                    case "showOnClick":
                        this._renderContainerClick();
                        break;
                    case "onSelectedIndexChanged":
                        this._renderSelectedIndexChanged();
                        break;
                    default:
                        this.callBase(args)
                }
            }
        });
        (0, _component_registrator.default)("dxDateViewRoller", DateViewRoller);
        var _default = DateViewRoller;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/date_box/ui.date_box.strategy.native.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _uiDate_box = _interopRequireDefault(__webpack_require__( /*! ./ui.date_box.strategy */ 213));
        var _support = __webpack_require__( /*! ../../core/utils/support */ 45);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./ui.date_utils */ 137));
        var _date_serialization = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date_serialization */ 57));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var NativeStrategy = _uiDate_box.default.inherit({
            NAME: "Native",
            popupConfig: function(_popupConfig) {
                return (0, _extend.extend)({}, _popupConfig, {
                    width: "auto"
                })
            },
            getParsedText: function(text, format) {
                if (!text) {
                    return null
                }
                if ("datetime" === this.dateBox.option("type")) {
                    return new Date(text.replace(/-/g, "/").replace("T", " ").split(".")[0])
                }
                if (this._isTextInput()) {
                    return this.callBase(text, format)
                } else {
                    return _ui.default.fromStandardDateFormat(text)
                }
            },
            _isTextInput: function() {
                return "text" === this.dateBox._input().prop("type")
            },
            renderPopupContent: _common.noop,
            _getWidgetName: _common.noop,
            _getWidgetOptions: _common.noop,
            _getDateBoxType: function() {
                var type = this.dateBox.option("type");
                if ((0, _array.inArray)(type, _ui.default.SUPPORTED_FORMATS) === -1) {
                    type = "date"
                } else {
                    if ("datetime" === type && !(0, _support.inputType)(type)) {
                        type = "datetime-local"
                    }
                }
                return type
            },
            customizeButtons: function() {
                var dropDownButton = this.dateBox.getButton("dropDown");
                if (_devices.default.real().android && dropDownButton) {
                    dropDownButton.on("click", function() {
                        this.dateBox._input().get(0).click()
                    }.bind(this))
                }
            },
            getDefaultOptions: function() {
                return {
                    mode: this._getDateBoxType()
                }
            },
            getDisplayFormat: function(displayFormat) {
                var type = this._getDateBoxType();
                return displayFormat || _ui.default.FORMATS_MAP[type]
            },
            renderInputMinMax: function($input) {
                $input.attr({
                    min: _date_serialization.default.serializeDate(this.dateBox.dateOption("min"), "yyyy-MM-dd"),
                    max: _date_serialization.default.serializeDate(this.dateBox.dateOption("max"), "yyyy-MM-dd")
                })
            }
        });
        var _default = NativeStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/date_box/ui.date_box.strategy.calendar_with_time.js ***!
      \*****************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _uiDate_boxStrategy = _interopRequireDefault(__webpack_require__( /*! ./ui.date_box.strategy.calendar */ 356));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./ui.time_view */ 629));
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../localization/date */ 32));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _box = _interopRequireDefault(__webpack_require__( /*! ../box */ 211));
        var _ui2 = _interopRequireDefault(__webpack_require__( /*! ./ui.date_utils */ 137));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var SHRINK_VIEW_SCREEN_WIDTH = 573;
        var DATEBOX_ADAPTIVITY_MODE_CLASS = "dx-datebox-adaptivity-mode";
        var CalendarWithTimeStrategy = _uiDate_boxStrategy.default.inherit({
            NAME: "CalendarWithTime",
            getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    applyValueMode: "useButtons",
                    buttonsLocation: "bottom after",
                    "dropDownOptions.showTitle": false
                })
            },
            getDisplayFormat: function(displayFormat) {
                return displayFormat || "shortdateshorttime"
            },
            _is24HourFormat: function() {
                return _date.default.is24HourFormat(this.getDisplayFormat(this.dateBox.option("displayFormat")))
            },
            _getContouredValue: function() {
                var viewDate = this.callBase();
                return this._updateDateTime(viewDate)
            },
            _renderWidget: function() {
                this.callBase();
                this._timeView = this.dateBox._createComponent((0, _renderer.default)("<div>"), _ui.default, {
                    value: this.dateBoxValue(),
                    _showClock: !this._isShrinkView(),
                    use24HourFormat: this._is24HourFormat(),
                    onValueChanged: this._valueChangedHandler.bind(this),
                    stylingMode: this.dateBox.option("stylingMode")
                });
                this._timeView.registerKeyHandler("escape", this._escapeHandler.bind(this))
            },
            renderOpenedState: function() {
                this.callBase();
                var popup = this._getPopup();
                if (popup) {
                    popup._wrapper().toggleClass(DATEBOX_ADAPTIVITY_MODE_CLASS, this._isSmallScreen())
                }
                clearTimeout(this._repaintTimer);
                this._repaintTimer = setTimeout(function() {
                    this._getPopup() && this._getPopup().repaint()
                }.bind(this), 0)
            },
            isAdaptivityChanged: function() {
                var isAdaptiveMode = this._isShrinkView();
                var currentAdaptiveMode = this._currentAdaptiveMode;
                if (isAdaptiveMode !== currentAdaptiveMode) {
                    this._currentAdaptiveMode = isAdaptiveMode;
                    return void 0 !== currentAdaptiveMode
                }
                return this.callBase()
            },
            _updateValue: function(preventDefaultValue) {
                var date = this.dateBoxValue();
                if (!date && !preventDefaultValue) {
                    date = new Date;
                    _ui2.default.normalizeTime(date)
                }
                this.callBase();
                if (this._timeView) {
                    date && this._timeView.option("value", date);
                    this._timeView.option("use24HourFormat", this._is24HourFormat())
                }
            },
            _isSmallScreen: function() {
                return (0, _renderer.default)(window).width() <= SHRINK_VIEW_SCREEN_WIDTH
            },
            _isShrinkView: function() {
                return !this.dateBox.option("showAnalogClock") || this.dateBox.option("adaptivityEnabled") && this._isSmallScreen()
            },
            _getBoxItems: function() {
                var items = [{
                    ratio: 0,
                    shrink: 0,
                    baseSize: "auto",
                    name: "calendar"
                }];
                if (!this._isShrinkView()) {
                    items.push({
                        ratio: 0,
                        shrink: 0,
                        baseSize: "auto",
                        name: "time"
                    })
                }
                return items
            },
            renderPopupContent: function() {
                this.callBase();
                this._currentAdaptiveMode = this._isShrinkView();
                var $popupContent = this._getPopup().$content();
                this._box = this.dateBox._createComponent((0, _renderer.default)("<div>").appendTo($popupContent), _box.default, {
                    direction: "row",
                    crossAlign: "start",
                    items: this._getBoxItems(),
                    itemTemplate: function(data) {
                        var $container = (0, _renderer.default)("<div>");
                        switch (data.name) {
                            case "calendar":
                                $container.append(this._widget.$element());
                                if (this._isShrinkView()) {
                                    $container.append(this._timeView.$element())
                                }
                                break;
                            case "time":
                                $container.append(this._timeView.$element())
                        }
                        return $container
                    }.bind(this)
                });
                this._attachTabHandler()
            },
            popupConfig: function(_popupConfig) {
                var calendarPopupConfig = this.callBase(_popupConfig);
                var result = (0, _extend.extend)(calendarPopupConfig, {
                    width: "auto",
                    onShowing: function() {
                        if ("fallback" === this._box.option("_layoutStrategy")) {
                            var clockMinWidth = this._getPopup().$content().find(".dx-timeview-clock").css("minWidth");
                            this._timeView.$element().css("maxWidth", clockMinWidth)
                        }
                    }.bind(this)
                });
                return result
            },
            getFirstPopupElement: function() {
                return this._timeView._hourBox.$element().find("input")
            },
            _attachTabHandler: function() {
                var dateBox = this.dateBox;
                var handler = function(e) {
                    if (e.shiftKey) {
                        e.preventDefault();
                        dateBox.focus()
                    }
                };
                this._timeView._hourBox.registerKeyHandler("tab", handler)
            },
            _preventFocusOnPopup: function(e) {
                if (!(0, _renderer.default)(e.target).hasClass("dx-texteditor-input")) {
                    this.callBase.apply(this, arguments);
                    if (!this.dateBox._hasFocusClass()) {
                        this.dateBox.focus()
                    }
                }
            },
            _updateDateTime: function(date) {
                var time = this._timeView.option("value");
                date.setHours(time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds());
                return date
            },
            getValue: function() {
                var date = this._widget.option("value");
                date = date ? new Date(date) : new Date;
                return this._updateDateTime(date)
            },
            dispose: function() {
                clearTimeout(this._removeMinWidthTimer);
                clearTimeout(this._repaintTimer);
                this.callBase()
            }
        });
        var _default = CalendarWithTimeStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/date_box/ui.time_view.js ***!
      \**************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _editor = _interopRequireDefault(__webpack_require__( /*! ../editor/editor */ 52));
        var _number_box = _interopRequireDefault(__webpack_require__( /*! ../number_box */ 116));
        var _select_box = _interopRequireDefault(__webpack_require__( /*! ../select_box */ 117));
        var _box = _interopRequireDefault(__webpack_require__( /*! ../box */ 211));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../localization/date */ 32));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./ui.date_utils */ 137));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var TIMEVIEW_CLASS = "dx-timeview";
        var TIMEVIEW_CLOCK_CLASS = "dx-timeview-clock";
        var TIMEVIEW_FIELD_CLASS = "dx-timeview-field";
        var TIMEVIEW_HOURARROW_CLASS = "dx-timeview-hourarrow";
        var TIMEVIEW_TIME_SEPARATOR_CLASS = "dx-timeview-time-separator";
        var TIMEVIEW_FORMAT12_CLASS = "dx-timeview-format12";
        var TIMEVIEW_FORMAT12_AM = -1;
        var TIMEVIEW_FORMAT12_PM = 1;
        var TIMEVIEW_MINUTEARROW_CLASS = "dx-timeview-minutearrow";
        var rotateArrow = function($arrow, angle, offset) {
            cssRotate($arrow, angle, offset)
        };
        var cssRotate = function($arrow, angle, offset) {
            $arrow.css("transform", "rotate(" + angle + "deg) translate(0," + offset + "px)")
        };
        var TimeView = _editor.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    value: new Date(Date.now()),
                    use24HourFormat: true,
                    _showClock: true,
                    _arrowOffset: 0,
                    stylingMode: void 0
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: {
                        platform: "android"
                    },
                    options: {
                        _arrowOffset: 15
                    }
                }, {
                    device: {
                        platform: "generic"
                    },
                    options: {
                        _arrowOffset: 5
                    }
                }])
            },
            _getValue: function() {
                return this.option("value") || new Date
            },
            _init: function() {
                this.callBase();
                this.$element().addClass(TIMEVIEW_CLASS)
            },
            _render: function() {
                this.callBase();
                this._renderBox();
                this._updateTime()
            },
            _renderBox: function() {
                var $box = (0, _renderer.default)("<div>").appendTo(this.$element());
                var items = [];
                if (this.option("_showClock")) {
                    items.push({
                        ratio: 1,
                        shrink: 0,
                        baseSize: "auto",
                        template: this._renderClock.bind(this)
                    })
                }
                items.push({
                    ratio: 0,
                    shrink: 0,
                    baseSize: 50,
                    template: this._renderField.bind(this)
                });
                this._createComponent($box, _box.default, {
                    height: "100%",
                    width: "100%",
                    direction: "col",
                    items: items
                })
            },
            _renderClock: function(_, __, container) {
                this._$hourArrow = (0, _renderer.default)("<div>").addClass(TIMEVIEW_HOURARROW_CLASS);
                this._$minuteArrow = (0, _renderer.default)("<div>").addClass(TIMEVIEW_MINUTEARROW_CLASS);
                var $container = (0, _renderer.default)(container);
                $container.addClass(TIMEVIEW_CLOCK_CLASS).append(this._$hourArrow).append(this._$minuteArrow);
                this.setAria("role", "presentation", $container)
            },
            _updateClock: function() {
                var time = this._getValue();
                var hourArrowAngle = time.getHours() / 12 * 360 + time.getMinutes() / 60 * 30;
                var minuteArrowAngle = time.getMinutes() / 60 * 360;
                rotateArrow(this._$hourArrow, hourArrowAngle, this.option("_arrowOffset"));
                rotateArrow(this._$minuteArrow, minuteArrowAngle, this.option("_arrowOffset"))
            },
            _getBoxItems: function(is12HourFormat) {
                var _this = this;
                var items = [{
                    ratio: 0,
                    shrink: 0,
                    baseSize: "auto",
                    template: function() {
                        return _this._hourBox.$element()
                    }
                }, {
                    ratio: 0,
                    shrink: 0,
                    baseSize: "auto",
                    template: (0, _renderer.default)("<div>").addClass(TIMEVIEW_TIME_SEPARATOR_CLASS).text(_date.default.getTimeSeparator())
                }, {
                    ratio: 0,
                    shrink: 0,
                    baseSize: "auto",
                    template: function() {
                        return _this._minuteBox.$element()
                    }
                }];
                if (is12HourFormat) {
                    items.push({
                        ratio: 0,
                        shrink: 0,
                        baseSize: "auto",
                        template: function() {
                            return _this._format12.$element()
                        }
                    })
                }
                return items
            },
            _renderField: function() {
                var is12HourFormat = !this.option("use24HourFormat");
                this._createHourBox(is12HourFormat);
                this._createMinuteBox();
                if (is12HourFormat) {
                    this._createFormat12Box()
                }
                return this._createComponent((0, _renderer.default)("<div>").addClass(TIMEVIEW_FIELD_CLASS), _box.default, {
                    direction: "row",
                    align: "center",
                    crossAlign: "center",
                    items: this._getBoxItems(is12HourFormat)
                }).$element()
            },
            _createHourBox: function(is12HourFormat) {
                var _this2 = this;
                var editor = this._hourBox = this._createComponent((0, _renderer.default)("<div>"), _number_box.default, (0, _extend.extend)({
                    min: -1,
                    max: is12HourFormat ? 13 : 24,
                    value: this._getValue().getHours(),
                    onValueChanged: this._onHourBoxValueChanged.bind(this),
                    onKeyboardHandled: function(opts) {
                        return _this2._keyboardHandler(opts)
                    }
                }, this._getNumberBoxConfig()));
                editor.setAria("label", "hours")
            },
            _isPM: function() {
                return !this.option("use24HourFormat") && 1 === this._format12.option("value")
            },
            _onHourBoxValueChanged: function(_ref) {
                var value = _ref.value,
                    component = _ref.component;
                var currentValue = this._getValue();
                var newValue = new Date(currentValue);
                var newHours = this._convertMaxHourToMin(value);
                component.option("value", newHours);
                if (this._isPM()) {
                    newHours += 12
                }
                newValue.setHours(newHours);
                _ui.default.normalizeTime(newValue);
                this.option("value", newValue)
            },
            _convertMaxHourToMin: function(hours) {
                var maxHoursValue = this.option("use24HourFormat") ? 24 : 12;
                return (maxHoursValue + hours) % maxHoursValue
            },
            _createMinuteBox: function() {
                var _this3 = this;
                var editor = this._minuteBox = this._createComponent((0, _renderer.default)("<div>"), _number_box.default, (0, _extend.extend)({
                    min: -1,
                    max: 60,
                    value: this._getValue().getMinutes(),
                    onKeyboardHandled: function(opts) {
                        return _this3._keyboardHandler(opts)
                    },
                    onValueChanged: function(_ref2) {
                        var value = _ref2.value,
                            component = _ref2.component;
                        var newMinutes = (60 + value) % 60;
                        component.option("value", newMinutes);
                        var time = new Date(_this3._getValue());
                        time.setMinutes(newMinutes);
                        _ui.default.normalizeTime(time);
                        _this3.option("value", time)
                    }
                }, this._getNumberBoxConfig()));
                editor.setAria("label", "minutes")
            },
            _createFormat12Box: function() {
                var _this4 = this;
                var periodNames = _date.default.getPeriodNames();
                var editor = this._format12 = this._createComponent((0, _renderer.default)("<div>").addClass(TIMEVIEW_FORMAT12_CLASS), _select_box.default, {
                    items: [{
                        value: TIMEVIEW_FORMAT12_AM,
                        text: periodNames[0]
                    }, {
                        value: TIMEVIEW_FORMAT12_PM,
                        text: periodNames[1]
                    }],
                    valueExpr: "value",
                    displayExpr: "text",
                    onKeyboardHandled: function(opts) {
                        return _this4._keyboardHandler(opts)
                    },
                    onValueChanged: function(_ref3) {
                        var value = _ref3.value;
                        var hours = _this4._getValue().getHours();
                        var time = new Date(_this4._getValue());
                        var newHours = (hours + 12 * value) % 24;
                        time.setHours(newHours);
                        _this4.option("value", time)
                    },
                    value: this._getValue().getHours() >= 12 ? TIMEVIEW_FORMAT12_PM : TIMEVIEW_FORMAT12_AM,
                    stylingMode: this.option("stylingMode")
                });
                editor.setAria("label", "type")
            },
            _refreshFormat12: function() {
                if (this.option("use24HourFormat")) {
                    return
                }
                var value = this._getValue();
                var hours = value.getHours();
                var isPM = hours >= 12;
                var newValue = isPM ? TIMEVIEW_FORMAT12_PM : TIMEVIEW_FORMAT12_AM;
                this._silentEditorValueUpdate(this._format12, newValue)
            },
            _silentEditorValueUpdate: function(editor, value) {
                if (editor) {
                    editor._suppressValueChangeAction();
                    editor.option("value", value);
                    editor._resumeValueChangeAction()
                }
            },
            _getNumberBoxConfig: function() {
                return {
                    showSpinButtons: true,
                    displayValueFormatter: function(value) {
                        return (value < 10 ? "0" : "") + value
                    },
                    stylingMode: this.option("stylingMode")
                }
            },
            _normalizeHours: function(hours) {
                return this.option("use24HourFormat") ? hours : hours % 12 || 12
            },
            _updateField: function() {
                var hours = this._normalizeHours(this._getValue().getHours());
                this._silentEditorValueUpdate(this._hourBox, hours);
                this._silentEditorValueUpdate(this._minuteBox, this._getValue().getMinutes());
                this._refreshFormat12()
            },
            _updateTime: function() {
                if (this.option("_showClock")) {
                    this._updateClock()
                }
                this._updateField()
            },
            _visibilityChanged: function(visible) {
                if (visible) {
                    this._updateTime()
                }
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "value":
                        this._updateTime();
                        this.callBase(args);
                        break;
                    case "_arrowOffset":
                        break;
                    case "use24HourFormat":
                    case "_showClock":
                    case "stylingMode":
                        this._invalidate();
                        break;
                    default:
                        this.callBase(args)
                }
            }
        });
        (0, _component_registrator.default)("dxTimeView", TimeView);
        var _default = TimeView;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/date_box/ui.date_box.strategy.list.js ***!
      \***************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _list = _interopRequireDefault(__webpack_require__( /*! ../list */ 112));
        var _uiDate_box = _interopRequireDefault(__webpack_require__( /*! ./ui.date_box.strategy */ 213));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./ui.date_utils */ 137));
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../localization/date */ 32));
        var _date_serialization = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date_serialization */ 57));
        var _utils = __webpack_require__( /*! ../drop_down_editor/utils */ 208);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var DATE_FORMAT = "date";
        var BOUNDARY_VALUES = {
            min: new Date(0, 0, 0, 0, 0),
            max: new Date(0, 0, 0, 23, 59)
        };
        var ListStrategy = _uiDate_box.default.inherit({
            NAME: "List",
            supportedKeys: function() {
                return {
                    tab: function() {
                        if (this.option("opened")) {
                            this.close()
                        }
                    },
                    space: _common.noop,
                    home: _common.noop,
                    end: _common.noop
                }
            },
            getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    applyValueMode: "instantly"
                })
            },
            getDisplayFormat: function(displayFormat) {
                return displayFormat || "shorttime"
            },
            popupConfig: function(_popupConfig) {
                return _popupConfig
            },
            useCurrentDateByDefault: function() {
                return true
            },
            getDefaultDate: function() {
                return new Date(null)
            },
            popupShowingHandler: function() {
                this.dateBox._dimensionChanged()
            },
            _renderWidget: function() {
                this.callBase();
                this._refreshItems()
            },
            _getWidgetName: function() {
                return _list.default
            },
            _getWidgetOptions: function() {
                return {
                    itemTemplate: this._timeListItemTemplate.bind(this),
                    onItemClick: this._listItemClickHandler.bind(this),
                    tabIndex: -1,
                    onFocusedItemChanged: this._refreshActiveDescendant.bind(this),
                    selectionMode: "single"
                }
            },
            _refreshActiveDescendant: function(e) {
                this.dateBox.setAria("activedescendant", "");
                this.dateBox.setAria("activedescendant", e.actionValue)
            },
            _refreshItems: function() {
                this._widgetItems = this._getTimeListItems();
                this._widget.option("items", this._widgetItems)
            },
            renderOpenedState: function() {
                if (!this._widget) {
                    return
                }
                this._widget.option("focusedElement", null);
                this._setSelectedItemsByValue();
                if (this._widget.option("templatesRenderAsynchronously")) {
                    this._asyncScrollTimeout = setTimeout(this._scrollToSelectedItem.bind(this))
                } else {
                    this._scrollToSelectedItem()
                }
            },
            dispose: function() {
                this.callBase();
                clearTimeout(this._asyncScrollTimeout)
            },
            _updateValue: function() {
                if (!this._widget) {
                    return
                }
                this._refreshItems();
                this._setSelectedItemsByValue();
                this._scrollToSelectedItem()
            },
            _setSelectedItemsByValue: function() {
                var value = this.dateBoxValue();
                var dateIndex = this._getDateIndex(value);
                if (dateIndex === -1) {
                    this._widget.option("selectedItems", [])
                } else {
                    this._widget.option("selectedIndex", dateIndex)
                }
            },
            _scrollToSelectedItem: function() {
                this._widget.scrollToItem(this._widget.option("selectedIndex"))
            },
            _getDateIndex: function(date) {
                var result = -1;
                for (var i = 0, n = this._widgetItems.length; i < n; i++) {
                    if (this._areDatesEqual(date, this._widgetItems[i])) {
                        result = i;
                        break
                    }
                }
                return result
            },
            _areDatesEqual: function(first, second) {
                return (0, _type.isDate)(first) && (0, _type.isDate)(second) && first.getHours() === second.getHours() && first.getMinutes() === second.getMinutes()
            },
            _getTimeListItems: function() {
                var min = this.dateBox.dateOption("min") || this._getBoundaryDate("min");
                var max = this.dateBox.dateOption("max") || this._getBoundaryDate("max");
                var value = this.dateBox.dateOption("value") || null;
                var delta = max - min;
                var minutes = min.getMinutes() % this.dateBox.option("interval");
                if (delta < 0) {
                    return []
                }
                if (delta > _ui.default.ONE_DAY) {
                    delta = _ui.default.ONE_DAY
                }
                if (value - min < _ui.default.ONE_DAY) {
                    return this._getRangeItems(min, new Date(min), delta)
                }
                min = this._getBoundaryDate("min");
                min.setMinutes(minutes);
                if (value && Math.abs(value - max) < _ui.default.ONE_DAY) {
                    delta = (60 * max.getHours() + Math.abs(max.getMinutes() - minutes)) * _ui.default.ONE_MINUTE
                }
                return this._getRangeItems(min, new Date(min), delta)
            },
            _getRangeItems: function(startValue, currentValue, rangeDuration) {
                var rangeItems = [];
                var interval = this.dateBox.option("interval");
                while (currentValue - startValue <= rangeDuration) {
                    rangeItems.push(new Date(currentValue));
                    currentValue.setMinutes(currentValue.getMinutes() + interval)
                }
                return rangeItems
            },
            _getBoundaryDate: function(boundary) {
                var boundaryValue = BOUNDARY_VALUES[boundary];
                var currentValue = new Date((0, _common.ensureDefined)(this.dateBox.dateOption("value"), 0));
                return new Date(currentValue.getFullYear(), currentValue.getMonth(), currentValue.getDate(), boundaryValue.getHours(), boundaryValue.getMinutes())
            },
            _timeListItemTemplate: function(itemData) {
                var displayFormat = this.dateBox.option("displayFormat");
                return _date.default.format(itemData, this.getDisplayFormat(displayFormat))
            },
            _listItemClickHandler: function(e) {
                this.dateBox.option("opened", false);
                var date = this.dateBox.option("value");
                var itemData = e.itemData;
                var hours = itemData.getHours();
                var minutes = itemData.getMinutes();
                var seconds = itemData.getSeconds();
                var year = itemData.getFullYear();
                var month = itemData.getMonth();
                var day = itemData.getDate();
                if (date) {
                    if (this.dateBox.option("dateSerializationFormat")) {
                        date = _date_serialization.default.deserializeDate(date)
                    } else {
                        date = new Date(date)
                    }
                    date.setHours(hours);
                    date.setMinutes(minutes);
                    date.setSeconds(seconds);
                    date.setFullYear(year);
                    date.setMonth(month);
                    date.setDate(day)
                } else {
                    date = new Date(year, month, day, hours, minutes, 0, 0)
                }
                this.dateBoxValue(date, e.event)
            },
            getKeyboardListener: function() {
                return this._widget
            },
            _updatePopupHeight: function() {
                var dropDownOptionsHeight = (0, _utils.getSizeValue)(this.dateBox.option("dropDownOptions.height"));
                if (void 0 === dropDownOptionsHeight || "auto" === dropDownOptionsHeight) {
                    this.dateBox._setPopupOption("height", "auto");
                    var popupHeight = this._widget.$element().outerHeight();
                    var maxHeight = .45 * (0, _renderer.default)(window).height();
                    this.dateBox._setPopupOption("height", Math.min(popupHeight, maxHeight))
                }
                this.dateBox._timeList && this.dateBox._timeList.updateDimensions()
            },
            getParsedText: function(text, format) {
                var value = this.callBase(text, format);
                if (value) {
                    value = _ui.default.mergeDates(value, new Date(null), DATE_FORMAT)
                }
                return value
            }
        });
        var _default = ListStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************!*\
      !*** ./artifacts/transpiled-npm/ui/drawer.js ***!
      \***********************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./drawer/ui.drawer */ 278));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _ui.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/drawer/ui.drawer.rendering.strategy.push.js ***!
      \*********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiDrawer = __webpack_require__( /*! ./ui.drawer.animation */ 181);
        var _uiDrawerRendering = _interopRequireDefault(__webpack_require__( /*! ./ui.drawer.rendering.strategy */ 279));
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _translator = __webpack_require__( /*! ../../animation/translator */ 28);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var PushStrategy = function(_DrawerStrategy) {
            _inheritsLoose(PushStrategy, _DrawerStrategy);

            function PushStrategy() {
                return _DrawerStrategy.apply(this, arguments) || this
            }
            var _proto = PushStrategy.prototype;
            _proto._internalRenderPosition = function(changePositionUsingFxAnimation, whenAnimationCompleted) {
                var drawer = this.getDrawerInstance();
                var openedPanelSize = this._getPanelSize(true);
                var contentPosition = this._getPanelSize(drawer.option("opened")) * drawer._getPositionCorrection();
                (0, _renderer.default)(drawer.content()).css(drawer.isHorizontalDirection() ? "width" : "height", openedPanelSize);
                if (drawer.getMinSize()) {
                    var paddingCssPropertyName = "padding";
                    switch (drawer.calcTargetPosition()) {
                        case "left":
                            paddingCssPropertyName += "Right";
                            break;
                        case "right":
                            paddingCssPropertyName += "Left";
                            break;
                        case "top":
                            paddingCssPropertyName += "Bottom";
                            break;
                        case "bottom":
                            paddingCssPropertyName += "Top"
                    }(0, _renderer.default)(drawer.viewContent()).css(paddingCssPropertyName, drawer.getMinSize())
                } else {}
                if (changePositionUsingFxAnimation) {
                    _uiDrawer.animation.moveTo({
                        $element: (0, _renderer.default)(drawer.viewContent()),
                        position: contentPosition,
                        direction: drawer.calcTargetPosition(),
                        duration: drawer.option("animationDuration"),
                        complete: function() {
                            whenAnimationCompleted.resolve()
                        }
                    })
                } else {
                    if (drawer.isHorizontalDirection()) {
                        (0, _translator.move)((0, _renderer.default)(drawer.viewContent()), {
                            left: contentPosition
                        })
                    } else {
                        (0, _translator.move)((0, _renderer.default)(drawer.viewContent()), {
                            top: contentPosition
                        })
                    }
                }
            };
            _proto.onPanelContentRendered = function() {
                (0, _renderer.default)(this.getDrawerInstance().viewContent()).addClass("dx-theme-background-color")
            };
            return PushStrategy
        }(_uiDrawerRendering.default);
        var _default = PushStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/drawer/ui.drawer.rendering.strategy.shrink.js ***!
      \***********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiDrawer = __webpack_require__( /*! ./ui.drawer.animation */ 181);
        var _uiDrawerRendering = _interopRequireDefault(__webpack_require__( /*! ./ui.drawer.rendering.strategy */ 279));
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _inflector = __webpack_require__( /*! ../../core/utils/inflector */ 39);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var ShrinkStrategy = function(_DrawerStrategy) {
            _inheritsLoose(ShrinkStrategy, _DrawerStrategy);

            function ShrinkStrategy() {
                return _DrawerStrategy.apply(this, arguments) || this
            }
            var _proto = ShrinkStrategy.prototype;
            _proto._internalRenderPosition = function(changePositionUsingFxAnimation, whenAnimationCompleted) {
                var drawer = this.getDrawerInstance();
                var direction = drawer.calcTargetPosition();
                var $panel = (0, _renderer.default)(drawer.content());
                var panelSize = this._getPanelSize(drawer.option("opened"));
                var panelOffset = this._getPanelOffset(drawer.option("opened"));
                var revealMode = drawer.option("revealMode");
                if (changePositionUsingFxAnimation) {
                    if ("slide" === revealMode) {
                        _uiDrawer.animation.margin({
                            complete: function() {
                                whenAnimationCompleted.resolve()
                            },
                            $element: $panel,
                            duration: drawer.option("animationDuration"),
                            direction: direction,
                            margin: panelOffset
                        })
                    } else {
                        if ("expand" === revealMode) {
                            _uiDrawer.animation.size({
                                complete: function() {
                                    whenAnimationCompleted.resolve()
                                },
                                $element: $panel,
                                duration: drawer.option("animationDuration"),
                                direction: direction,
                                size: panelSize
                            })
                        }
                    }
                } else {
                    if ("slide" === revealMode) {
                        $panel.css("margin" + (0, _inflector.camelize)(direction, true), panelOffset)
                    } else {
                        if ("expand" === revealMode) {
                            $panel.css(drawer.isHorizontalDirection() ? "width" : "height", panelSize)
                        }
                    }
                }
            };
            _proto.isViewContentFirst = function(position, isRtl) {
                return (isRtl ? "left" === position : "right" === position) || "bottom" === position
            };
            return ShrinkStrategy
        }(_uiDrawerRendering.default);
        var _default = ShrinkStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/drawer/ui.drawer.rendering.strategy.overlap.js ***!
      \************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiDrawer = __webpack_require__( /*! ./ui.drawer.animation */ 181);
        var _uiDrawerRendering = _interopRequireDefault(__webpack_require__( /*! ./ui.drawer.rendering.strategy */ 279));
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _translator = __webpack_require__( /*! ../../animation/translator */ 28);
        var _overlay = _interopRequireDefault(__webpack_require__( /*! ../overlay */ 64));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _inflector = __webpack_require__( /*! ../../core/utils/inflector */ 39);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var OverlapStrategy = function(_DrawerStrategy) {
            _inheritsLoose(OverlapStrategy, _DrawerStrategy);

            function OverlapStrategy() {
                return _DrawerStrategy.apply(this, arguments) || this
            }
            var _proto = OverlapStrategy.prototype;
            _proto.renderPanelContent = function(whenPanelContentRendered) {
                var _this = this;
                delete this._initialPosition;
                var drawer = this.getDrawerInstance();
                var _drawer$option = drawer.option(),
                    opened = _drawer$option.opened,
                    minSize = _drawer$option.minSize;
                drawer._overlay = drawer._createComponent(drawer.content(), _overlay.default, {
                    shading: false,
                    container: drawer.getOverlayTarget(),
                    position: this._getOverlayPosition(),
                    width: opened ? "auto" : minSize || 0,
                    height: "100%",
                    templatesRenderAsynchronously: drawer.option("templatesRenderAsynchronously"),
                    animation: {
                        show: {
                            duration: 0
                        }
                    },
                    onPositioned: function(e) {
                        this._fixOverlayPosition(e.component.$content())
                    }.bind(this),
                    contentTemplate: drawer.option("template"),
                    onContentReady: function(args) {
                        whenPanelContentRendered.resolve();
                        _this._processOverlayZIndex(args.component.content())
                    },
                    visible: true,
                    propagateOutsideClick: true
                })
            };
            _proto._fixOverlayPosition = function($overlayContent) {
                var position = (0, _common.ensureDefined)(this._initialPosition, {
                    left: 0,
                    top: 0
                });
                (0, _translator.move)($overlayContent, position);
                if ("right" === this.getDrawerInstance().calcTargetPosition()) {
                    $overlayContent.css("left", "auto")
                }
                if ("bottom" === this.getDrawerInstance().calcTargetPosition()) {
                    $overlayContent.css("top", "auto");
                    $overlayContent.css("bottom", "0px")
                }
            };
            _proto._getOverlayPosition = function() {
                var drawer = this.getDrawerInstance();
                var panelPosition = drawer.calcTargetPosition();
                var result = {};
                switch (panelPosition) {
                    case "left":
                        result = {
                            my: "top left",
                            at: "top left"
                        };
                        break;
                    case "right":
                        result = {
                            my: drawer.option("rtlEnabled") ? "top left" : "top right",
                            at: "top right"
                        };
                        break;
                    case "top":
                    case "bottom":
                        result = {
                            my: panelPosition,
                            at: panelPosition
                        }
                }
                result.of = drawer.getOverlayTarget();
                return result
            };
            _proto.refreshPanelElementSize = function(calcFromRealPanelSize) {
                var drawer = this.getDrawerInstance();
                var overlay = drawer.getOverlay();
                if (drawer.isHorizontalDirection()) {
                    overlay.option("height", "100%");
                    overlay.option("width", calcFromRealPanelSize ? drawer.getRealPanelWidth() : this._getPanelSize(drawer.option("opened")))
                } else {
                    overlay.option("width", overlay.option("container").width());
                    overlay.option("height", calcFromRealPanelSize ? drawer.getRealPanelHeight() : this._getPanelSize(drawer.option("opened")))
                }
            };
            _proto.onPanelContentRendered = function() {
                this._updateViewContentStyles()
            };
            _proto._updateViewContentStyles = function() {
                var drawer = this.getDrawerInstance();
                (0, _renderer.default)(drawer.viewContent()).css("padding" + (0, _inflector.camelize)(drawer.calcTargetPosition(), true), drawer.option("minSize"));
                (0, _renderer.default)(drawer.viewContent()).css("transform", "inherit")
            };
            _proto._internalRenderPosition = function(changePositionUsingFxAnimation, whenAnimationCompleted) {
                var drawer = this.getDrawerInstance();
                var $panel = (0, _renderer.default)(drawer.content());
                var $panelOverlayContent = drawer.getOverlay().$content();
                var revealMode = drawer.option("revealMode");
                var targetPanelPosition = drawer.calcTargetPosition();
                var panelSize = this._getPanelSize(drawer.option("opened"));
                var panelOffset = this._getPanelOffset(drawer.option("opened")) * drawer._getPositionCorrection();
                var marginTop = drawer.getRealPanelHeight() - panelSize;
                this._updateViewContentStyles();
                if (changePositionUsingFxAnimation) {
                    if ("slide" === revealMode) {
                        this._initialPosition = drawer.isHorizontalDirection() ? {
                            left: panelOffset
                        } : {
                            top: panelOffset
                        };
                        _uiDrawer.animation.moveTo({
                            complete: function() {
                                whenAnimationCompleted.resolve()
                            },
                            duration: drawer.option("animationDuration"),
                            direction: targetPanelPosition,
                            $element: $panel,
                            position: panelOffset
                        })
                    } else {
                        if ("expand" === revealMode) {
                            this._initialPosition = {
                                left: 0
                            };
                            (0, _translator.move)($panelOverlayContent, this._initialPosition);
                            _uiDrawer.animation.size({
                                complete: function() {
                                    whenAnimationCompleted.resolve()
                                },
                                duration: drawer.option("animationDuration"),
                                direction: targetPanelPosition,
                                $element: $panelOverlayContent,
                                size: panelSize,
                                marginTop: marginTop
                            })
                        }
                    }
                } else {
                    if ("slide" === revealMode) {
                        this._initialPosition = drawer.isHorizontalDirection() ? {
                            left: panelOffset
                        } : {
                            top: panelOffset
                        };
                        (0, _translator.move)($panel, this._initialPosition)
                    } else {
                        if ("expand" === revealMode) {
                            this._initialPosition = {
                                left: 0
                            };
                            (0, _translator.move)($panelOverlayContent, this._initialPosition);
                            if (drawer.isHorizontalDirection()) {
                                (0, _renderer.default)($panelOverlayContent).css("width", panelSize)
                            } else {
                                (0, _renderer.default)($panelOverlayContent).css("height", panelSize);
                                if ("bottom" === targetPanelPosition) {
                                    (0, _renderer.default)($panelOverlayContent).css("marginTop", marginTop)
                                }
                            }
                        }
                    }
                }
            };
            _proto.getPanelContent = function() {
                return (0, _renderer.default)(this.getDrawerInstance().getOverlay().content())
            };
            _proto._processOverlayZIndex = function($element) {
                var styles = (0, _renderer.default)($element).get(0).style;
                var zIndex = styles.zIndex || 1;
                this.getDrawerInstance().setZIndex(zIndex)
            };
            _proto.isViewContentFirst = function(position) {
                return "right" === position || "bottom" === position
            };
            return OverlapStrategy
        }(_uiDrawerRendering.default);
        var _default = OverlapStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/defer_rendering.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _transition_executor = __webpack_require__( /*! ../animation/transition_executor/transition_executor */ 326);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../core/dom_adapter */ 11));
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _visibility_change = __webpack_require__( /*! ../events/visibility_change */ 59);
        var _load_indicator = _interopRequireDefault(__webpack_require__( /*! ./load_indicator */ 83));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./widget/ui.widget */ 16));
        var _position = __webpack_require__( /*! ../core/utils/position */ 22);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var WIDGET_CLASS = "dx-widget";
        var DEFER_RENDERING_CLASS = "dx-deferrendering";
        var PENDING_RENDERING_CLASS = "dx-pending-rendering";
        var PENDING_RENDERING_MANUAL_CLASS = "dx-pending-rendering-manual";
        var PENDING_RENDERING_ACTIVE_CLASS = "dx-pending-rendering-active";
        var VISIBLE_WHILE_PENDING_RENDERING_CLASS = "dx-visible-while-pending-rendering";
        var INVISIBLE_WHILE_PENDING_RENDERING_CLASS = "dx-invisible-while-pending-rendering";
        var LOADINDICATOR_CONTAINER_CLASS = "dx-loadindicator-container";
        var DEFER_RENDERING_LOADINDICATOR_CONTAINER_CLASS = "dx-deferrendering-loadindicator-container";
        var DEFER_DEFER_RENDERING_LOAD_INDICATOR = "dx-deferrendering-load-indicator";
        var ANONYMOUS_TEMPLATE_NAME = "content";
        var ACTIONS = ["onRendered", "onShown"];
        var DeferRendering = _ui.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    showLoadIndicator: false,
                    renderWhen: void 0,
                    animation: void 0,
                    staggerItemSelector: void 0,
                    onRendered: null,
                    onShown: null
                })
            },
            _getAnonymousTemplateName: function() {
                return ANONYMOUS_TEMPLATE_NAME
            },
            _init: function() {
                this.transitionExecutor = new _transition_executor.TransitionExecutor;
                this._initElement();
                this._initRender();
                this._$initialContent = this.$element().clone().contents();
                this._initActions();
                this.callBase()
            },
            _initElement: function() {
                this.$element().addClass(DEFER_RENDERING_CLASS)
            },
            _initRender: function() {
                var that = this;
                var $element = this.$element();
                var renderWhen = this.option("renderWhen");
                var doRender = function() {
                    return that._renderDeferredContent()
                };
                if ((0, _type.isPromise)(renderWhen)) {
                    (0, _deferred.fromPromise)(renderWhen).done(doRender)
                } else {
                    $element.data("dx-render-delegate", doRender);
                    if (void 0 === renderWhen) {
                        $element.addClass(PENDING_RENDERING_MANUAL_CLASS)
                    }
                }
            },
            _initActions: function() {
                var _this = this;
                this._actions = {};
                (0, _iterator.each)(ACTIONS, function(_, action) {
                    _this._actions[action] = _this._createActionByOption(action) || _common.noop
                })
            },
            _initMarkup: function() {
                this.callBase();
                if (!this._initContent) {
                    this._initContent = this._renderContent;
                    this._renderContent = function() {}
                }
                this._initContent()
            },
            _renderContentImpl: function() {
                this.$element().removeClass(WIDGET_CLASS);
                this.$element().append(this._$initialContent);
                this._setLoadingState()
            },
            _renderDeferredContent: function() {
                var that = this;
                var $element = this.$element();
                var result = new _deferred.Deferred;
                $element.removeClass(PENDING_RENDERING_MANUAL_CLASS);
                $element.addClass(PENDING_RENDERING_ACTIVE_CLASS);
                this._abortRenderTask();
                this._renderTask = (0, _common.executeAsync)(function() {
                    that._renderImpl().done(function() {
                        var shownArgs = {
                            element: $element
                        };
                        that._actions.onShown([shownArgs]);
                        result.resolve(shownArgs)
                    }).fail(function() {
                        result.rejectWith(result, arguments)
                    })
                });
                return result.promise()
            },
            _isElementInViewport: function(element) {
                var rect = (0, _position.getBoundingRect)(element);
                return rect.bottom >= 0 && rect.right >= 0 && rect.top <= (window.innerHeight || _dom_adapter.default.getDocumentElement().clientHeight) && rect.left <= (window.innerWidth || _dom_adapter.default.getDocumentElement().clientWidth)
            },
            _animate: function() {
                var that = this;
                var $element = this.$element();
                var animation = (0, _window.hasWindow)() && this.option("animation");
                var staggerItemSelector = this.option("staggerItemSelector");
                var animatePromise;
                that.transitionExecutor.stop();
                if (animation) {
                    if (staggerItemSelector) {
                        $element.find(staggerItemSelector).each(function() {
                            if (that._isElementInViewport(this)) {
                                that.transitionExecutor.enter((0, _renderer.default)(this), animation)
                            }
                        })
                    } else {
                        that.transitionExecutor.enter($element, animation)
                    }
                    animatePromise = that.transitionExecutor.start()
                } else {
                    animatePromise = (new _deferred.Deferred).resolve().promise()
                }
                return animatePromise
            },
            _renderImpl: function() {
                var $element = this.$element();
                var renderedArgs = {
                    element: $element
                };
                var contentTemplate = this._getTemplate(this._templateManager.anonymousTemplateName);
                if (contentTemplate) {
                    contentTemplate.render({
                        container: $element.empty(),
                        noModel: true
                    })
                }
                this._setRenderedState($element);
                _events_engine.default.trigger($element, "dxcontentrendered");
                this._actions.onRendered([renderedArgs]);
                this._isRendered = true;
                return this._animate()
            },
            _setLoadingState: function() {
                var $element = this.$element();
                var hasCustomLoadIndicator = !!$element.find("." + VISIBLE_WHILE_PENDING_RENDERING_CLASS).length;
                $element.addClass(PENDING_RENDERING_CLASS);
                if (!hasCustomLoadIndicator) {
                    $element.children().addClass(INVISIBLE_WHILE_PENDING_RENDERING_CLASS)
                }
                if (this.option("showLoadIndicator")) {
                    this._showLoadIndicator($element)
                }
            },
            _showLoadIndicator: function($container) {
                this._$loadIndicator = new _load_indicator.default((0, _renderer.default)("<div>"), {
                    visible: true
                }).$element().addClass(DEFER_DEFER_RENDERING_LOAD_INDICATOR);
                (0, _renderer.default)("<div>").addClass(LOADINDICATOR_CONTAINER_CLASS).addClass(DEFER_RENDERING_LOADINDICATOR_CONTAINER_CLASS).append(this._$loadIndicator).appendTo($container)
            },
            _setRenderedState: function() {
                var $element = this.$element();
                if (this._$loadIndicator) {
                    this._$loadIndicator.remove()
                }
                $element.removeClass(PENDING_RENDERING_CLASS);
                $element.removeClass(PENDING_RENDERING_ACTIVE_CLASS);
                (0, _visibility_change.triggerShownEvent)($element.children())
            },
            _optionChanged: function(args) {
                var value = args.value;
                var previousValue = args.previousValue;
                switch (args.name) {
                    case "renderWhen":
                        if (false === previousValue && true === value) {
                            this._renderOrAnimate()
                        } else {
                            if (true === previousValue && false === value) {
                                this.transitionExecutor.stop();
                                this._setLoadingState()
                            }
                        }
                        break;
                    case "showLoadIndicator":
                    case "onRendered":
                    case "onShown":
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _renderOrAnimate: function() {
                var result;
                if (this._isRendered) {
                    this._setRenderedState();
                    result = this._animate()
                } else {
                    result = this._renderDeferredContent()
                }
                return result
            },
            renderContent: function() {
                return this._renderOrAnimate()
            },
            _abortRenderTask: function() {
                if (this._renderTask) {
                    this._renderTask.abort();
                    this._renderTask = void 0
                }
            },
            _dispose: function() {
                this.transitionExecutor.stop(true);
                this._abortRenderTask();
                this._actions = void 0;
                this._$initialContent = void 0;
                this.callBase()
            }
        });
        (0, _component_registrator.default)("dxDeferRendering", DeferRendering);
        var _default = DeferRendering;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/drop_down_box.js ***!
      \******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./drop_down_editor/ui.drop_down_editor */ 195));
        var _ui2 = _interopRequireDefault(__webpack_require__( /*! ./editor/ui.data_expression */ 275));
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _selectors = __webpack_require__( /*! ./widget/selectors */ 70);
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _utils = __webpack_require__( /*! ../ui/overlay/utils */ 280);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _index = __webpack_require__( /*! ../events/utils/index */ 8);
        var _short = __webpack_require__( /*! ../events/short */ 128);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../core/devices */ 13));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../core/dom_adapter */ 11));
        var _element = __webpack_require__( /*! ../core/element */ 18);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var getActiveElement = _dom_adapter.default.getActiveElement;
        var DROP_DOWN_BOX_CLASS = "dx-dropdownbox";
        var ANONYMOUS_TEMPLATE_NAME = "content";
        var realDevice = _devices.default.real();
        var DropDownBox = _ui.default.inherit({
            _supportedKeys: function() {
                return (0, _extend.extend)({}, this.callBase(), {
                    tab: function(e) {
                        if (!this.option("opened")) {
                            return
                        }
                        var $tabbableElements = this._getTabbableElements();
                        var $focusableElement = e.shiftKey ? $tabbableElements.last() : $tabbableElements.first();
                        $focusableElement && _events_engine.default.trigger($focusableElement, "focus");
                        e.preventDefault()
                    }
                })
            },
            _getTabbableElements: function() {
                return this._getElements().filter(_selectors.tabbable)
            },
            _getElements: function() {
                return (0, _renderer.default)(this.content()).find("*")
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    acceptCustomValue: false,
                    contentTemplate: ANONYMOUS_TEMPLATE_NAME,
                    openOnFieldClick: true,
                    displayValueFormatter: function(value) {
                        return Array.isArray(value) ? value.join(", ") : value
                    },
                    useHiddenSubmitElement: true
                })
            },
            _getAnonymousTemplateName: function() {
                return ANONYMOUS_TEMPLATE_NAME
            },
            _initTemplates: function() {
                this.callBase()
            },
            _initMarkup: function() {
                this._initDataExpressions();
                this.$element().addClass(DROP_DOWN_BOX_CLASS);
                this.callBase()
            },
            _setSubmitValue: function() {
                var value = this.option("value");
                var submitValue = this._shouldUseDisplayValue(value) ? this._displayGetter(value) : value;
                this._getSubmitElement().val(submitValue)
            },
            _shouldUseDisplayValue: function(value) {
                return "this" === this.option("valueExpr") && (0, _type.isObject)(value)
            },
            _renderInputValue: function() {
                var callBase = this.callBase.bind(this);
                var values = [];
                if (!this._dataSource) {
                    callBase(values);
                    return (new _deferred.Deferred).resolve()
                }
                var currentValue = this._getCurrentValue();
                var keys = (0, _common.ensureDefined)(currentValue, []);
                keys = Array.isArray(keys) ? keys : [keys];
                var itemLoadDeferreds = (0, _iterator.map)(keys, function(key) {
                    return this._loadItem(key).always(function(item) {
                        var displayValue = this._displayGetter(item);
                        values.push((0, _common.ensureDefined)(displayValue, key))
                    }.bind(this))
                }.bind(this));
                return _deferred.when.apply(this, itemLoadDeferreds).always(function() {
                    this.option("displayValue", values);
                    callBase(values.length && values)
                }.bind(this))
            },
            _loadItem: function(value) {
                var deferred = new _deferred.Deferred;
                var that = this;
                var selectedItem = (0, _common.grep)(this.option("items") || [], function(item) {
                    return this._isValueEquals(this._valueGetter(item), value)
                }.bind(this))[0];
                if (void 0 !== selectedItem) {
                    deferred.resolve(selectedItem)
                } else {
                    this._loadValue(value).done(function(item) {
                        deferred.resolve(item)
                    }).fail(function(args) {
                        if (that.option("acceptCustomValue")) {
                            deferred.resolve(value)
                        } else {
                            deferred.reject()
                        }
                    })
                }
                return deferred.promise()
            },
            _popupElementTabHandler: function(e) {
                if ("tab" !== (0, _index.normalizeKeyName)(e)) {
                    return
                }
                var $firstTabbable = this._getTabbableElements().first().get(0);
                var $lastTabbable = this._getTabbableElements().last().get(0);
                var $target = e.originalEvent.target;
                var moveBackward = !!($target === $firstTabbable && e.shift);
                var moveForward = !!($target === $lastTabbable && !e.shift);
                if (moveBackward || moveForward) {
                    this.close();
                    _events_engine.default.trigger(this._input(), "focus");
                    if (moveBackward) {
                        e.originalEvent.preventDefault()
                    }
                }
            },
            _renderPopup: function(e) {
                var _this = this;
                this.callBase();
                if (this.option("focusStateEnabled")) {
                    _short.keyboard.on(this.content(), null, function(e) {
                        return _this._popupElementTabHandler(e)
                    })
                }
            },
            _renderPopupContent: function() {
                if (this.option("contentTemplate") === ANONYMOUS_TEMPLATE_NAME) {
                    return
                }
                var contentTemplate = this._getTemplateByOption("contentTemplate");
                if (!(contentTemplate && this.option("contentTemplate"))) {
                    return
                }
                var $popupContent = this._popup.$content();
                var templateData = {
                    value: this._fieldRenderData(),
                    component: this
                };
                $popupContent.empty();
                contentTemplate.render({
                    container: (0, _element.getPublicElement)($popupContent),
                    model: templateData
                })
            },
            _canShowVirtualKeyboard: function() {
                return realDevice.mac
            },
            _isNestedElementActive: function() {
                var activeElement = getActiveElement();
                return activeElement && this._popup.$content().get(0).contains(activeElement)
            },
            _shouldCloseOnTargetScroll: function() {
                return "desktop" === realDevice.deviceType && this._canShowVirtualKeyboard() && this._isNestedElementActive()
            },
            _popupHiddenHandler: function() {
                this.callBase();
                this._popupPosition = void 0
            },
            _popupPositionedHandler: function(e) {
                this.callBase(e);
                this._popupPosition = e.position
            },
            _getDefaultPopupPosition: function(isRtlEnabled) {
                var _this$callBase = this.callBase(isRtlEnabled),
                    my = _this$callBase.my,
                    at = _this$callBase.at;
                return {
                    my: my,
                    at: at,
                    offset: {
                        v: -1
                    },
                    collision: "flipfit"
                }
            },
            _popupConfig: function() {
                var _this2 = this;
                var _this$option = this.option(),
                    focusStateEnabled = _this$option.focusStateEnabled;
                return (0, _extend.extend)(this.callBase(), {
                    tabIndex: -1,
                    dragEnabled: false,
                    focusStateEnabled: focusStateEnabled,
                    contentTemplate: ANONYMOUS_TEMPLATE_NAME,
                    closeOnTargetScroll: this._shouldCloseOnTargetScroll.bind(this),
                    position: (0, _extend.extend)(this.option("popupPosition"), {
                        of: this.$element()
                    }),
                    onKeyboardHandled: function(opts) {
                        return _this2.option("focusStateEnabled") && _this2._popupElementTabHandler(opts)
                    },
                    maxHeight: function() {
                        var _this$_popupPosition;
                        var popupLocation = null === (_this$_popupPosition = this._popupPosition) || void 0 === _this$_popupPosition ? void 0 : _this$_popupPosition.v.location;
                        return (0, _utils.getElementMaxHeightByWindow)(this.$element(), popupLocation)
                    }.bind(this)
                })
            },
            _popupShownHandler: function() {
                this.callBase();
                var $firstElement = this._getTabbableElements().first();
                _events_engine.default.trigger($firstElement, "focus")
            },
            _setCollectionWidgetOption: _common.noop,
            _optionChanged: function(args) {
                this._dataExpressionOptionChanged(args);
                switch (args.name) {
                    case "dataSource":
                        this._renderInputValue();
                        break;
                    case "displayValue":
                        this.option("text", args.value);
                        break;
                    case "displayExpr":
                        this._renderValue();
                        break;
                    case "contentTemplate":
                        this._invalidate();
                        break;
                    default:
                        this.callBase(args)
                }
            }
        }).include(_ui2.default);
        (0, _component_registrator.default)("dxDropDownBox", DropDownBox);
        var _default = DropDownBox;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/form/ui.form.js ***!
      \*****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _guid = _interopRequireDefault(__webpack_require__( /*! ../../core/guid */ 36));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _string = __webpack_require__( /*! ../../core/utils/string */ 43);
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));
        var _visibility_change = __webpack_require__( /*! ../../events/visibility_change */ 59);
        var _element = __webpack_require__( /*! ../../core/element */ 18);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _editor = _interopRequireDefault(__webpack_require__( /*! ../editor/editor */ 52));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _validation_engine = _interopRequireDefault(__webpack_require__( /*! ../validation_engine */ 96));
        var _uiForm = _interopRequireDefault(__webpack_require__( /*! ./ui.form.items_runtime_info */ 357));
        var _tab_panel = _interopRequireDefault(__webpack_require__( /*! ../tab_panel */ 284));
        var _ui2 = _interopRequireDefault(__webpack_require__( /*! ../scroll_view/ui.scrollable */ 106));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _themes = __webpack_require__( /*! ../themes */ 34);
        var _uiForm2 = _interopRequireDefault(__webpack_require__( /*! ./ui.form.item_options_actions */ 640));
        __webpack_require__( /*! ./ui.form.layout_manager */ 642);
        var _uiForm4 = __webpack_require__( /*! ./ui.form.utils */ 361);
        __webpack_require__( /*! ../validation_summary */ 285);
        __webpack_require__( /*! ../validation_group */ 364);
        var _constants = __webpack_require__( /*! ./constants */ 363);
        var _constants2 = __webpack_require__( /*! ../toolbar/constants */ 338);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }
        var WIDGET_CLASS = "dx-widget";
        var FOCUSED_STATE_CLASS = "dx-state-focused";
        var ITEM_OPTIONS_FOR_VALIDATION_UPDATING = ["items", "isRequired", "validationRules", "visible"];
        var Form = _ui.default.inherit({
            _init: function() {
                this.callBase();
                this._cachedColCountOptions = [];
                this._itemsRunTimeInfo = new _uiForm.default;
                this._groupsColCount = [];
                this._attachSyncSubscriptions()
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    formID: "dx-" + new _guid.default,
                    formData: {},
                    colCount: 1,
                    screenByWidth: _window.defaultScreenFactorFunc,
                    colCountByScreen: void 0,
                    labelLocation: "left",
                    readOnly: false,
                    onFieldDataChanged: null,
                    customizeItem: null,
                    onEditorEnterKey: null,
                    minColWidth: 200,
                    alignItemLabels: true,
                    alignItemLabelsInAllGroups: true,
                    alignRootItemLabels: true,
                    showColonAfterLabel: true,
                    showRequiredMark: true,
                    showOptionalMark: false,
                    requiredMark: "*",
                    optionalMark: _message.default.format("dxForm-optionalMark"),
                    requiredMessage: _message.default.getFormatter("dxForm-requiredMessage"),
                    showValidationSummary: false,
                    items: void 0,
                    scrollingEnabled: false,
                    validationGroup: void 0,
                    stylingMode: void 0
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: function() {
                        return (0, _themes.isMaterial)()
                    },
                    options: {
                        showColonAfterLabel: false,
                        labelLocation: "top"
                    }
                }])
            },
            _setOptionsByReference: function() {
                this.callBase();
                (0, _extend.extend)(this._optionsByReference, {
                    formData: true,
                    validationGroup: true
                })
            },
            _getGroupColCount: function($element) {
                return parseInt($element.attr(_constants.GROUP_COL_COUNT_ATTR))
            },
            _createHiddenElement: function(rootLayoutManager) {
                this._$hiddenElement = (0, _renderer.default)("<div>").addClass(WIDGET_CLASS).addClass(_constants.HIDDEN_LABEL_CLASS).appendTo("body");
                var $hiddenLabel = rootLayoutManager._renderLabel({
                    text: " ",
                    location: this._labelLocation()
                }).appendTo(this._$hiddenElement);
                this._hiddenLabelText = $hiddenLabel.find("." + _constants.FIELD_ITEM_LABEL_TEXT_CLASS)[0]
            },
            _removeHiddenElement: function() {
                this._$hiddenElement.remove();
                this._hiddenLabelText = null
            },
            _getLabelWidthByText: function(text) {
                this._hiddenLabelText.innerHTML = text;
                return this._hiddenLabelText.offsetWidth
            },
            _getLabelsSelectorByCol: function(index, options) {
                options = options || {};
                var fieldItemClass = options.inOneColumn ? _constants.FIELD_ITEM_CLASS : _constants.FORM_FIELD_ITEM_COL_CLASS + index;
                var cssExcludeTabbedSelector = options.excludeTabbed ? ":not(." + _constants.FIELD_ITEM_TAB_CLASS + ")" : "";
                var childLabelContentSelector = "> ." + _constants.FIELD_ITEM_LABEL_CLASS + " > ." + _constants.FIELD_ITEM_LABEL_CONTENT_CLASS;
                return "." + fieldItemClass + cssExcludeTabbedSelector + childLabelContentSelector
            },
            _getLabelText: function(labelText) {
                var length = labelText.children.length;
                var child;
                var result = "";
                var i;
                for (i = 0; i < length; i++) {
                    child = labelText.children[i];
                    result += !(0, _string.isEmpty)(child.innerText) ? child.innerText : child.innerHTML
                }
                return result
            },
            _applyLabelsWidthByCol: function($container, index, options) {
                var $labelTexts = $container.find(this._getLabelsSelectorByCol(index, options));
                var $labelTextsLength = $labelTexts.length;
                var labelWidth;
                var i;
                var maxWidth = 0;
                for (i = 0; i < $labelTextsLength; i++) {
                    labelWidth = this._getLabelWidthByText(this._getLabelText($labelTexts[i]));
                    if (labelWidth > maxWidth) {
                        maxWidth = labelWidth
                    }
                }
                for (i = 0; i < $labelTextsLength; i++) {
                    $labelTexts[i].style.width = maxWidth + "px"
                }
            },
            _applyLabelsWidth: function($container, excludeTabbed, inOneColumn, colCount) {
                colCount = inOneColumn ? 1 : colCount || this._getGroupColCount($container);
                var applyLabelsOptions = {
                    excludeTabbed: excludeTabbed,
                    inOneColumn: inOneColumn
                };
                var i;
                for (i = 0; i < colCount; i++) {
                    this._applyLabelsWidthByCol($container, i, applyLabelsOptions)
                }
            },
            _getGroupElementsInColumn: function($container, columnIndex, colCount) {
                var cssColCountSelector = (0, _type.isDefined)(colCount) ? "." + _constants.GROUP_COL_COUNT_CLASS + colCount : "";
                var groupSelector = "." + _constants.FORM_FIELD_ITEM_COL_CLASS + columnIndex + " > ." + _constants.FIELD_ITEM_CONTENT_CLASS + " > ." + _constants.FORM_GROUP_CLASS + cssColCountSelector;
                return $container.find(groupSelector)
            },
            _applyLabelsWidthWithGroups: function($container, colCount, excludeTabbed) {
                if (true === this.option("alignRootItemLabels")) {
                    this._alignRootSimpleItems($container, colCount, excludeTabbed)
                }
                var alignItemLabelsInAllGroups = this.option("alignItemLabelsInAllGroups");
                if (alignItemLabelsInAllGroups) {
                    this._applyLabelsWidthWithNestedGroups($container, colCount, excludeTabbed)
                } else {
                    var $groups = this.$element().find("." + _constants.FORM_GROUP_CLASS);
                    var i;
                    for (i = 0; i < $groups.length; i++) {
                        this._applyLabelsWidth($groups.eq(i), excludeTabbed)
                    }
                }
            },
            _alignRootSimpleItems: function($container, colCount, excludeTabbed) {
                var $rootSimpleItems = $container.find(".".concat(_constants.ROOT_SIMPLE_ITEM_CLASS));
                for (var colIndex = 0; colIndex < colCount; colIndex++) {
                    this._applyLabelsWidthByCol($rootSimpleItems, colIndex, excludeTabbed)
                }
            },
            _applyLabelsWidthWithNestedGroups: function($container, colCount, excludeTabbed) {
                var applyLabelsOptions = {
                    excludeTabbed: excludeTabbed
                };
                var colIndex;
                var groupsColIndex;
                var groupColIndex;
                var $groupsByCol;
                for (colIndex = 0; colIndex < colCount; colIndex++) {
                    $groupsByCol = this._getGroupElementsInColumn($container, colIndex);
                    this._applyLabelsWidthByCol($groupsByCol, 0, applyLabelsOptions);
                    for (groupsColIndex = 0; groupsColIndex < this._groupsColCount.length; groupsColIndex++) {
                        $groupsByCol = this._getGroupElementsInColumn($container, colIndex, this._groupsColCount[groupsColIndex]);
                        var groupColCount = this._getGroupColCount($groupsByCol);
                        for (groupColIndex = 1; groupColIndex < groupColCount; groupColIndex++) {
                            this._applyLabelsWidthByCol($groupsByCol, groupColIndex, applyLabelsOptions)
                        }
                    }
                }
            },
            _labelLocation: function() {
                return this.option("labelLocation")
            },
            _alignLabelsInColumn: function(_ref) {
                var layoutManager = _ref.layoutManager,
                    inOneColumn = _ref.inOneColumn,
                    $container = _ref.$container,
                    excludeTabbed = _ref.excludeTabbed,
                    items = _ref.items;
                if (!(0, _window.hasWindow)() || "top" === this._labelLocation()) {
                    return
                }
                this._createHiddenElement(layoutManager);
                if (inOneColumn) {
                    this._applyLabelsWidth($container, excludeTabbed, true)
                } else {
                    if (this._checkGrouping(items)) {
                        this._applyLabelsWidthWithGroups($container, layoutManager._getColCount(), excludeTabbed)
                    } else {
                        this._applyLabelsWidth($container, excludeTabbed, false, layoutManager._getColCount())
                    }
                }
                this._removeHiddenElement()
            },
            _prepareFormData: function() {
                if (!(0, _type.isDefined)(this.option("formData"))) {
                    this.option("formData", {})
                }
            },
            _initMarkup: function() {
                _validation_engine.default.addGroup(this._getValidationGroup());
                this._clearCachedInstances();
                this._prepareFormData();
                this.$element().addClass(_constants.FORM_CLASS);
                this.callBase();
                this.setAria("role", "form", this.$element());
                if (this.option("scrollingEnabled")) {
                    this._renderScrollable()
                }
                this._renderLayout();
                this._renderValidationSummary();
                this._lastMarkupScreenFactor = this._targetScreenFactor || this._getCurrentScreenFactor()
            },
            _getCurrentScreenFactor: function() {
                return (0, _window.hasWindow)() ? (0, _window.getCurrentScreenFactor)(this.option("screenByWidth")) : "lg"
            },
            _clearCachedInstances: function() {
                this._itemsRunTimeInfo.clear();
                this._cachedLayoutManagers = []
            },
            _alignLabels: function(layoutManager, inOneColumn) {
                this._alignLabelsInColumn({
                    $container: this.$element(),
                    layoutManager: layoutManager,
                    excludeTabbed: true,
                    items: this.option("items"),
                    inOneColumn: inOneColumn
                });
                (0, _visibility_change.triggerResizeEvent)(this.$element().find(".".concat(_constants2.TOOLBAR_CLASS)))
            },
            _clean: function() {
                this.callBase();
                this._groupsColCount = [];
                this._cachedColCountOptions = [];
                this._lastMarkupScreenFactor = void 0
            },
            _renderScrollable: function() {
                var useNativeScrolling = this.option("useNativeScrolling");
                this._scrollable = new _ui2.default(this.$element(), {
                    useNative: !!useNativeScrolling,
                    useSimulatedScrollbar: !useNativeScrolling,
                    useKeyboard: false,
                    direction: "both",
                    bounceEnabled: false
                })
            },
            _getContent: function() {
                return this.option("scrollingEnabled") ? this._scrollable.$content() : this.$element()
            },
            _renderValidationSummary: function() {
                var $validationSummary = this.$element().find("." + _constants.FORM_VALIDATION_SUMMARY);
                if ($validationSummary.length > 0) {
                    $validationSummary.remove()
                }
                if (this.option("showValidationSummary")) {
                    var _$validationSummary = (0, _renderer.default)("<div>").addClass(_constants.FORM_VALIDATION_SUMMARY).appendTo(this._getContent());
                    this._validationSummary = _$validationSummary.dxValidationSummary({
                        validationGroup: this._getValidationGroup()
                    }).dxValidationSummary("instance")
                }
            },
            _prepareItems: function(items, parentIsTabbedItem, currentPath, isTabs) {
                if (items) {
                    var result = [];
                    for (var i = 0; i < items.length; i++) {
                        var item = items[i];
                        var path = (0, _uiForm4.concatPaths)(currentPath, (0, _uiForm4.createItemPathByIndex)(i, isTabs));
                        var guid = this._itemsRunTimeInfo.add({
                            item: item,
                            itemIndex: i,
                            path: path
                        });
                        if ((0, _type.isString)(item)) {
                            item = {
                                dataField: item
                            }
                        }
                        if ((0, _type.isObject)(item)) {
                            var itemCopy = (0, _extend.extend)({}, item);
                            itemCopy.guid = guid;
                            this._tryPrepareGroupItem(itemCopy);
                            this._tryPrepareTabbedItem(itemCopy, path);
                            this._tryPrepareItemTemplate(itemCopy);
                            if (parentIsTabbedItem) {
                                itemCopy.cssItemClass = _constants.FIELD_ITEM_TAB_CLASS
                            }
                            if (itemCopy.items) {
                                itemCopy.items = this._prepareItems(itemCopy.items, parentIsTabbedItem, path)
                            }
                            result.push(itemCopy)
                        } else {
                            result.push(item)
                        }
                    }
                    return result
                }
            },
            _tryPrepareGroupItem: function(item) {
                if ("group" === item.itemType) {
                    item.alignItemLabels = (0, _common.ensureDefined)(item.alignItemLabels, true);
                    if (item.template) {
                        item.groupContentTemplate = this._getTemplate(item.template)
                    }
                    item.template = this._itemGroupTemplate.bind(this, item)
                }
            },
            _tryPrepareTabbedItem: function(item, path) {
                if ("tabbed" === item.itemType) {
                    item.template = this._itemTabbedTemplate.bind(this, item);
                    item.tabs = this._prepareItems(item.tabs, true, path, true)
                }
            },
            _tryPrepareItemTemplate: function(item) {
                if (item.template) {
                    item.template = this._getTemplate(item.template)
                }
            },
            _checkGrouping: function(items) {
                if (items) {
                    for (var i = 0; i < items.length; i++) {
                        var item = items[i];
                        if ("group" === item.itemType) {
                            return true
                        }
                    }
                }
            },
            _renderLayout: function() {
                var that = this;
                var items = that.option("items");
                var $content = that._getContent();
                items = that._prepareItems(items);
                that._rootLayoutManager = that._renderLayoutManager(items, $content, {
                    isRoot: true,
                    colCount: that.option("colCount"),
                    alignItemLabels: that.option("alignItemLabels"),
                    screenByWidth: this.option("screenByWidth"),
                    colCountByScreen: this.option("colCountByScreen"),
                    onLayoutChanged: function(inOneColumn) {
                        that._alignLabels.bind(that)(that._rootLayoutManager, inOneColumn)
                    },
                    onContentReady: function(e) {
                        that._alignLabels(e.component, e.component.isSingleColumnMode())
                    }
                })
            },
            _tryGetItemsForTemplate: function(item) {
                return item.items || []
            },
            _itemTabbedTemplate: function(item, e, $container) {
                var _this = this;
                var $tabPanel = (0, _renderer.default)("<div>").appendTo($container);
                var tabPanelOptions = (0, _extend.extend)({}, item.tabPanelOptions, {
                    dataSource: item.tabs,
                    onItemRendered: function(args) {
                        return (0, _visibility_change.triggerShownEvent)(args.itemElement)
                    },
                    itemTemplate: function(itemData, e, container) {
                        var $container = (0, _renderer.default)(container);
                        var alignItemLabels = (0, _common.ensureDefined)(itemData.alignItemLabels, true);
                        var layoutManager = _this._renderLayoutManager(_this._tryGetItemsForTemplate(itemData), $container, {
                            colCount: itemData.colCount,
                            alignItemLabels: alignItemLabels,
                            screenByWidth: _this.option("screenByWidth"),
                            colCountByScreen: itemData.colCountByScreen,
                            cssItemClass: itemData.cssItemClass,
                            onLayoutChanged: function(inOneColumn) {
                                _this._alignLabelsInColumn({
                                    $container: $container,
                                    layoutManager: layoutManager,
                                    items: itemData.items,
                                    inOneColumn: inOneColumn
                                })
                            }
                        });
                        if (_this._itemsRunTimeInfo) {
                            _this._itemsRunTimeInfo.extendRunTimeItemInfoByKey(itemData.guid, {
                                layoutManager: layoutManager
                            })
                        }
                        if (alignItemLabels) {
                            _this._alignLabelsInColumn({
                                $container: $container,
                                layoutManager: layoutManager,
                                items: itemData.items,
                                inOneColumn: layoutManager.isSingleColumnMode()
                            })
                        }
                    }
                });
                var tryUpdateTabPanelInstance = function(items, instance) {
                    if (Array.isArray(items)) {
                        items.forEach(function(item) {
                            return _this._itemsRunTimeInfo.extendRunTimeItemInfoByKey(item.guid, {
                                widgetInstance: instance
                            })
                        })
                    }
                };
                var tabPanel = this._createComponent($tabPanel, _tab_panel.default, tabPanelOptions);
                (0, _renderer.default)($container).parent().addClass(_constants.FIELD_ITEM_CONTENT_HAS_TABS_CLASS);
                tabPanel.on("optionChanged", function(e) {
                    if ("dataSource" === e.fullName) {
                        tryUpdateTabPanelInstance(e.value, e.component)
                    }
                });
                tryUpdateTabPanelInstance([{
                    guid: item.guid
                }].concat(_toConsumableArray(item.tabs)), tabPanel)
            },
            _itemGroupTemplate: function(item, e, $container) {
                var $group = (0, _renderer.default)("<div>").toggleClass(_constants.FORM_GROUP_WITH_CAPTION_CLASS, (0, _type.isDefined)(item.caption) && item.caption.length).addClass(_constants.FORM_GROUP_CLASS).appendTo($container);
                (0, _renderer.default)($container).parent().addClass(_constants.FIELD_ITEM_CONTENT_HAS_GROUP_CLASS);
                var colCount;
                var layoutManager;
                if (item.caption) {
                    (0, _renderer.default)("<span>").addClass(_constants.FORM_GROUP_CAPTION_CLASS).text(item.caption).appendTo($group)
                }
                var $groupContent = (0, _renderer.default)("<div>").addClass(_constants.FORM_GROUP_CONTENT_CLASS).appendTo($group);
                if (item.groupContentTemplate) {
                    var data = {
                        formData: this.option("formData"),
                        component: this
                    };
                    item.groupContentTemplate.render({
                        model: data,
                        container: (0, _element.getPublicElement)($groupContent)
                    })
                } else {
                    layoutManager = this._renderLayoutManager(this._tryGetItemsForTemplate(item), $groupContent, {
                        colCount: item.colCount,
                        colCountByScreen: item.colCountByScreen,
                        alignItemLabels: item.alignItemLabels,
                        cssItemClass: item.cssItemClass
                    });
                    this._itemsRunTimeInfo && this._itemsRunTimeInfo.extendRunTimeItemInfoByKey(item.guid, {
                        layoutManager: layoutManager
                    });
                    colCount = layoutManager._getColCount();
                    if ((0, _array.inArray)(colCount, this._groupsColCount) === -1) {
                        this._groupsColCount.push(colCount)
                    }
                    $group.addClass(_constants.GROUP_COL_COUNT_CLASS + colCount);
                    $group.attr(_constants.GROUP_COL_COUNT_ATTR, colCount)
                }
            },
            _renderLayoutManager: function(items, $rootElement, options) {
                var $element = (0, _renderer.default)("<div>");
                var that = this;
                var config = that._getLayoutManagerConfig(items, options);
                var baseColCountByScreen = {
                    lg: options.colCount,
                    md: options.colCount,
                    sm: options.colCount,
                    xs: 1
                };
                that._cachedColCountOptions.push({
                    colCountByScreen: (0, _extend.extend)(baseColCountByScreen, options.colCountByScreen)
                });
                $element.appendTo($rootElement);
                var instance = that._createComponent($element, "dxLayoutManager", config);
                instance.on("autoColCountChanged", function() {
                    that._refresh()
                });
                that._cachedLayoutManagers.push(instance);
                return instance
            },
            _getValidationGroup: function() {
                return this.option("validationGroup") || this
            },
            _getLayoutManagerConfig: function(items, options) {
                var _this2 = this;
                var baseConfig = {
                    form: this,
                    isRoot: options.isRoot,
                    validationGroup: this._getValidationGroup(),
                    showRequiredMark: this.option("showRequiredMark"),
                    showOptionalMark: this.option("showOptionalMark"),
                    requiredMark: this.option("requiredMark"),
                    optionalMark: this.option("optionalMark"),
                    requiredMessage: this.option("requiredMessage"),
                    screenByWidth: this.option("screenByWidth"),
                    layoutData: this.option("formData"),
                    labelLocation: this.option("labelLocation"),
                    customizeItem: this.option("customizeItem"),
                    minColWidth: this.option("minColWidth"),
                    showColonAfterLabel: this.option("showColonAfterLabel"),
                    onEditorEnterKey: this.option("onEditorEnterKey"),
                    onFieldDataChanged: function(args) {
                        if (!_this2._isDataUpdating) {
                            _this2._triggerOnFieldDataChanged(args)
                        }
                    },
                    validationBoundary: this.option("scrollingEnabled") ? this.$element() : void 0
                };
                return (0, _extend.extend)(baseConfig, {
                    items: items,
                    onContentReady: function(args) {
                        _this2._itemsRunTimeInfo.addItemsOrExtendFrom(args.component._itemsRunTimeInfo);
                        options.onContentReady && options.onContentReady(args)
                    },
                    onDisposing: function(_ref2) {
                        var component = _ref2.component;
                        var nestedItemsRunTimeInfo = component.getItemsRunTimeInfo();
                        _this2._itemsRunTimeInfo.removeItemsByItems(nestedItemsRunTimeInfo)
                    },
                    colCount: options.colCount,
                    alignItemLabels: options.alignItemLabels,
                    cssItemClass: options.cssItemClass,
                    colCountByScreen: options.colCountByScreen,
                    onLayoutChanged: options.onLayoutChanged,
                    width: options.width
                })
            },
            _createComponent: function($element, type, config) {
                var that = this;
                config = config || {};
                that._extendConfig(config, {
                    readOnly: that.option("readOnly")
                });
                return that.callBase($element, type, config)
            },
            _attachSyncSubscriptions: function() {
                var that = this;
                that.on("optionChanged", function(args) {
                    var optionFullName = args.fullName;
                    if ("formData" === optionFullName) {
                        if (!(0, _type.isDefined)(args.value)) {
                            that._options.silent("formData", args.value = {})
                        }
                        that._triggerOnFieldDataChangedByDataSet(args.value)
                    }
                    if (that._cachedLayoutManagers.length) {
                        (0, _iterator.each)(that._cachedLayoutManagers, function(index, layoutManager) {
                            if ("formData" === optionFullName) {
                                that._isDataUpdating = true;
                                layoutManager.option("layoutData", args.value);
                                that._isDataUpdating = false
                            }
                            if ("readOnly" === args.name || "disabled" === args.name) {
                                layoutManager.option(optionFullName, args.value)
                            }
                        })
                    }
                })
            },
            _optionChanged: function(args) {
                var rootNameOfComplexOption = this._getRootLevelOfExpectedComplexOption(args.fullName, ["formData", "items"]);
                if (rootNameOfComplexOption) {
                    this._customHandlerOfComplexOption(args, rootNameOfComplexOption);
                    return
                }
                switch (args.name) {
                    case "formData":
                        if (!this.option("items")) {
                            this._invalidate()
                        } else {
                            if ((0, _type.isEmptyObject)(args.value)) {
                                this._resetValues()
                            }
                        }
                        break;
                    case "items":
                    case "colCount":
                    case "onFieldDataChanged":
                    case "onEditorEnterKey":
                    case "labelLocation":
                    case "alignItemLabels":
                    case "showColonAfterLabel":
                    case "customizeItem":
                    case "alignItemLabelsInAllGroups":
                    case "showRequiredMark":
                    case "showOptionalMark":
                    case "requiredMark":
                    case "optionalMark":
                    case "requiredMessage":
                    case "scrollingEnabled":
                    case "formID":
                    case "colCountByScreen":
                    case "screenByWidth":
                    case "stylingMode":
                        this._invalidate();
                        break;
                    case "showValidationSummary":
                        this._renderValidationSummary();
                        break;
                    case "minColWidth":
                        if ("auto" === this.option("colCount")) {
                            this._invalidate()
                        }
                        break;
                    case "alignRootItemLabels":
                    case "readOnly":
                        break;
                    case "width":
                        this.callBase(args);
                        this._rootLayoutManager.option(args.name, args.value);
                        this._alignLabels(this._rootLayoutManager, this._rootLayoutManager.isSingleColumnMode());
                        break;
                    case "visible":
                        this.callBase(args);
                        if (args.value) {
                            (0, _visibility_change.triggerShownEvent)(this.$element())
                        }
                        break;
                    case "validationGroup":
                        _validation_engine.default.removeGroup(args.previousValue || this);
                        this._invalidate();
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _getRootLevelOfExpectedComplexOption: function(fullOptionName, expectedRootNames) {
                var splitFullName = fullOptionName.split(".");
                var result;
                if (splitFullName.length > 1) {
                    var i;
                    var rootOptionName = splitFullName[0];
                    for (i = 0; i < expectedRootNames.length; i++) {
                        if (rootOptionName.search(expectedRootNames[i]) !== -1) {
                            result = expectedRootNames[i]
                        }
                    }
                }
                return result
            },
            _tryCreateItemOptionAction: function(optionName, item, value, previousValue, itemPath) {
                if ("tabs" === optionName) {
                    this._itemsRunTimeInfo.removeItemsByPathStartWith("".concat(itemPath, ".tabs"));
                    value = this._prepareItems(value, true, itemPath, true)
                }
                return (0, _uiForm2.default)(optionName, {
                    item: item,
                    value: value,
                    previousValue: previousValue,
                    itemsRunTimeInfo: this._itemsRunTimeInfo
                })
            },
            _tryExecuteItemOptionAction: function(action) {
                return action && action.tryExecute()
            },
            _updateValidationGroupAndSummaryIfNeeded: function(fullName) {
                var optionName = (0, _uiForm4.getOptionNameFromFullName)(fullName);
                if (ITEM_OPTIONS_FOR_VALIDATION_UPDATING.indexOf(optionName) > -1) {
                    _validation_engine.default.addGroup(this._getValidationGroup());
                    if (this.option("showValidationSummary")) {
                        this._validationSummary && this._validationSummary._initGroupRegistration()
                    }
                }
            },
            _setLayoutManagerItemOption: function(layoutManager, optionName, value, path) {
                var _this3 = this;
                if (this._updateLockCount > 0) {
                    !layoutManager._updateLockCount && layoutManager.beginUpdate();
                    var key = this._itemsRunTimeInfo.getKeyByPath(path);
                    this.postponedOperations.add(key, function() {
                        !layoutManager._disposed && layoutManager.endUpdate();
                        return (new _deferred.Deferred).resolve()
                    })
                }
                var contentReadyHandler = function contentReadyHandler(e) {
                    e.component.off("contentReady", contentReadyHandler);
                    if ((0, _uiForm4.isFullPathContainsTabs)(path)) {
                        var tabPath = (0, _uiForm4.tryGetTabPath)(path);
                        var tabLayoutManager = _this3._itemsRunTimeInfo.getGroupOrTabLayoutManagerByPath(tabPath);
                        _this3._alignLabelsInColumn({
                            items: tabLayoutManager.option("items"),
                            layoutManager: tabLayoutManager,
                            $container: tabLayoutManager.$element(),
                            inOneColumn: tabLayoutManager.isSingleColumnMode()
                        })
                    } else {
                        _this3._alignLabels(_this3._rootLayoutManager, _this3._rootLayoutManager.isSingleColumnMode())
                    }
                };
                layoutManager.on("contentReady", contentReadyHandler);
                layoutManager.option(optionName, value);
                this._updateValidationGroupAndSummaryIfNeeded(optionName)
            },
            _tryChangeLayoutManagerItemOption: function(fullName, value) {
                var nameParts = fullName.split(".");
                var optionName = (0, _uiForm4.getOptionNameFromFullName)(fullName);
                if ("items" === optionName && nameParts.length > 1) {
                    var itemPath = this._getItemPath(nameParts);
                    var layoutManager = this._itemsRunTimeInfo.getGroupOrTabLayoutManagerByPath(itemPath);
                    if (layoutManager) {
                        this._itemsRunTimeInfo.removeItemsByItems(layoutManager.getItemsRunTimeInfo());
                        var items = this._prepareItems(value, false, itemPath);
                        this._setLayoutManagerItemOption(layoutManager, optionName, items, itemPath);
                        return true
                    }
                } else {
                    if (nameParts.length > 2) {
                        var endPartIndex = nameParts.length - 2;
                        var _itemPath = this._getItemPath(nameParts.slice(0, endPartIndex));
                        var _layoutManager = this._itemsRunTimeInfo.getGroupOrTabLayoutManagerByPath(_itemPath);
                        if (_layoutManager) {
                            var fullOptionName = (0, _uiForm4.getFullOptionName)(nameParts[endPartIndex], optionName);
                            if ("editorType" === optionName) {
                                if (_layoutManager.option(fullOptionName) !== value) {
                                    return false
                                }
                            }
                            if ("visible" === optionName) {
                                var formItems = this.option((0, _uiForm4.getFullOptionName)(_itemPath, "items"));
                                if (formItems && formItems.length) {
                                    var layoutManagerItems = _layoutManager.option("items");
                                    formItems.forEach(function(item, index) {
                                        var layoutItem = layoutManagerItems[index];
                                        layoutItem.visibleIndex = item.visibleIndex
                                    })
                                }
                            }
                            this._setLayoutManagerItemOption(_layoutManager, fullOptionName, value, _itemPath);
                            return true
                        }
                    }
                }
                return false
            },
            _tryChangeLayoutManagerItemOptions: function(itemPath, options) {
                var _this4 = this;
                var result;
                this.beginUpdate();
                (0, _iterator.each)(options, function(optionName, optionValue) {
                    result = _this4._tryChangeLayoutManagerItemOption((0, _uiForm4.getFullOptionName)(itemPath, optionName), optionValue);
                    if (!result) {
                        return false
                    }
                });
                this.endUpdate();
                return result
            },
            _customHandlerOfComplexOption: function(args, rootOptionName) {
                var nameParts = args.fullName.split(".");
                var value = args.value;
                if ("items" === rootOptionName) {
                    var itemPath = this._getItemPath(nameParts);
                    var item = this.option(itemPath);
                    var optionNameWithoutPath = args.fullName.replace(itemPath + ".", "");
                    var simpleOptionName = optionNameWithoutPath.split(".")[0].replace(/\[\d+]/, "");
                    var itemAction = this._tryCreateItemOptionAction(simpleOptionName, item, item[simpleOptionName], args.previousValue, itemPath);
                    if (!this._tryExecuteItemOptionAction(itemAction) && !this._tryChangeLayoutManagerItemOption(args.fullName, value)) {
                        if (item) {
                            this._changeItemOption(item, optionNameWithoutPath, value);
                            var items = this._generateItemsFromData(this.option("items"));
                            this.option("items", items)
                        }
                    }
                }
                if ("formData" === rootOptionName) {
                    var dataField = nameParts.slice(1).join(".");
                    var editor = this.getEditor(dataField);
                    if (editor) {
                        editor.option("value", value)
                    } else {
                        this._triggerOnFieldDataChanged({
                            dataField: dataField,
                            value: value
                        })
                    }
                }
            },
            _getItemPath: function(nameParts) {
                var itemPath = nameParts[0];
                var i;
                for (i = 1; i < nameParts.length; i++) {
                    if (nameParts[i].search(/items\[\d+]|tabs\[\d+]/) !== -1) {
                        itemPath += "." + nameParts[i]
                    } else {
                        break
                    }
                }
                return itemPath
            },
            _triggerOnFieldDataChanged: function(args) {
                this._createActionByOption("onFieldDataChanged")(args)
            },
            _triggerOnFieldDataChangedByDataSet: function(data) {
                var that = this;
                if (data && (0, _type.isObject)(data)) {
                    (0, _iterator.each)(data, function(dataField, value) {
                        that._triggerOnFieldDataChanged({
                            dataField: dataField,
                            value: value
                        })
                    })
                }
            },
            _updateFieldValue: function(dataField, value) {
                if ((0, _type.isDefined)(this.option("formData"))) {
                    var editor = this.getEditor(dataField);
                    this.option("formData." + dataField, value);
                    if (editor) {
                        var editorValue = editor.option("value");
                        if (editorValue !== value) {
                            editor.option("value", value)
                        }
                    }
                }
            },
            _generateItemsFromData: function(items) {
                var formData = this.option("formData");
                var result = [];
                if (!items && (0, _type.isDefined)(formData)) {
                    (0, _iterator.each)(formData, function(dataField) {
                        result.push({
                            dataField: dataField
                        })
                    })
                }
                if (items) {
                    (0, _iterator.each)(items, function(index, item) {
                        if ((0, _type.isObject)(item)) {
                            result.push(item)
                        } else {
                            result.push({
                                dataField: item
                            })
                        }
                    })
                }
                return result
            },
            _getItemByField: function(field, items) {
                var that = this;
                var fieldParts = (0, _type.isObject)(field) ? field : that._getFieldParts(field);
                var fieldName = fieldParts.fieldName;
                var fieldPath = fieldParts.fieldPath;
                var resultItem;
                if (items.length) {
                    (0, _iterator.each)(items, function(index, item) {
                        var itemType = item.itemType;
                        if (fieldPath.length) {
                            var path = fieldPath.slice();
                            item = that._getItemByFieldPath(path, fieldName, item)
                        } else {
                            if ("group" === itemType && !(item.caption || item.name) || "tabbed" === itemType && !item.name) {
                                var subItemsField = that._getSubItemField(itemType);
                                item.items = that._generateItemsFromData(item.items);
                                item = that._getItemByField({
                                    fieldName: fieldName,
                                    fieldPath: fieldPath
                                }, item[subItemsField])
                            }
                        }
                        if ((0, _uiForm4.isExpectedItem)(item, fieldName)) {
                            resultItem = item;
                            return false
                        }
                    })
                }
                return resultItem
            },
            _getFieldParts: function(field) {
                var fieldSeparator = ".";
                var fieldName = field;
                var separatorIndex = fieldName.indexOf(fieldSeparator);
                var resultPath = [];
                while (separatorIndex !== -1) {
                    resultPath.push(fieldName.substr(0, separatorIndex));
                    fieldName = fieldName.substr(separatorIndex + 1);
                    separatorIndex = fieldName.indexOf(fieldSeparator)
                }
                return {
                    fieldName: fieldName,
                    fieldPath: resultPath.reverse()
                }
            },
            _getItemByFieldPath: function(path, fieldName, item) {
                var that = this;
                var itemType = item.itemType;
                var subItemsField = that._getSubItemField(itemType);
                var isItemWithSubItems = "group" === itemType || "tabbed" === itemType || item.title;
                var result;
                do {
                    if (isItemWithSubItems) {
                        var name = item.name || item.caption || item.title;
                        var isGroupWithName = (0, _type.isDefined)(name);
                        var nameWithoutSpaces = (0, _uiForm4.getTextWithoutSpaces)(name);
                        var pathNode = void 0;
                        item[subItemsField] = that._generateItemsFromData(item[subItemsField]);
                        if (isGroupWithName) {
                            pathNode = path.pop()
                        }
                        if (!path.length) {
                            result = that._getItemByField(fieldName, item[subItemsField]);
                            if (result) {
                                break
                            }
                        }
                        if (!isGroupWithName || isGroupWithName && nameWithoutSpaces === pathNode) {
                            if (path.length) {
                                result = that._searchItemInEverySubItem(path, fieldName, item[subItemsField])
                            }
                        }
                    } else {
                        break
                    }
                } while (path.length && !(0, _type.isDefined)(result));
                return result
            },
            _getSubItemField: function(itemType) {
                return "tabbed" === itemType ? "tabs" : "items"
            },
            _searchItemInEverySubItem: function(path, fieldName, items) {
                var that = this;
                var result;
                (0, _iterator.each)(items, function(index, groupItem) {
                    result = that._getItemByFieldPath(path.slice(), fieldName, groupItem);
                    if (result) {
                        return false
                    }
                });
                if (!result) {
                    result = false
                }
                return result
            },
            _changeItemOption: function(item, option, value) {
                if ((0, _type.isObject)(item)) {
                    item[option] = value
                }
            },
            _dimensionChanged: function() {
                var currentScreenFactor = this._getCurrentScreenFactor();
                if (this._lastMarkupScreenFactor !== currentScreenFactor) {
                    if (this._isColCountChanged(this._lastMarkupScreenFactor, currentScreenFactor)) {
                        this._targetScreenFactor = currentScreenFactor;
                        this._refresh();
                        this._targetScreenFactor = void 0
                    }
                    this._lastMarkupScreenFactor = currentScreenFactor
                }
            },
            _isColCountChanged: function(oldScreenSize, newScreenSize) {
                var isChanged = false;
                (0, _iterator.each)(this._cachedColCountOptions, function(index, item) {
                    if (item.colCountByScreen[oldScreenSize] !== item.colCountByScreen[newScreenSize]) {
                        isChanged = true;
                        return false
                    }
                });
                return isChanged
            },
            _refresh: function() {
                var editorSelector = "." + FOCUSED_STATE_CLASS + " input, ." + FOCUSED_STATE_CLASS + " textarea";
                _events_engine.default.trigger(this.$element().find(editorSelector), "change");
                this.callBase()
            },
            _resetValues: function() {
                this._itemsRunTimeInfo.each(function(_, itemRunTimeInfo) {
                    if ((0, _type.isDefined)(itemRunTimeInfo.widgetInstance) && itemRunTimeInfo.widgetInstance instanceof _editor.default) {
                        itemRunTimeInfo.widgetInstance.reset();
                        itemRunTimeInfo.widgetInstance.option("isValid", true)
                    }
                });
                _validation_engine.default.resetGroup(this._getValidationGroup())
            },
            _updateData: function(data, value, isComplexData) {
                var that = this;
                var _data = isComplexData ? value : data;
                if ((0, _type.isObject)(_data)) {
                    (0, _iterator.each)(_data, function(dataField, fieldValue) {
                        that._updateData(isComplexData ? data + "." + dataField : dataField, fieldValue, (0, _type.isObject)(fieldValue))
                    })
                } else {
                    if ((0, _type.isString)(data)) {
                        that._updateFieldValue(data, value)
                    }
                }
            },
            registerKeyHandler: function(key, handler) {
                this.callBase(key, handler);
                this._itemsRunTimeInfo.each(function(_, itemRunTimeInfo) {
                    if ((0, _type.isDefined)(itemRunTimeInfo.widgetInstance)) {
                        itemRunTimeInfo.widgetInstance.registerKeyHandler(key, handler)
                    }
                })
            },
            _focusTarget: function() {
                return this.$element().find("." + _constants.FIELD_ITEM_CONTENT_CLASS + " [tabindex]").first();
            },
            _visibilityChanged: function(visible) {
                if (visible && _browser.default.msie) {
                    this._refresh()
                }
            },
            _dispose: function() {
                _validation_engine.default.removeGroup(this._getValidationGroup());
                this.callBase()
            },
            resetValues: function() {
                this._resetValues()
            },
            updateData: function(data, value) {
                this._updateData(data, value)
            },
            getEditor: function(dataField) {
                return this._itemsRunTimeInfo.findWidgetInstanceByDataField(dataField) || this._itemsRunTimeInfo.findWidgetInstanceByName(dataField)
            },
            getButton: function(name) {
                return this._itemsRunTimeInfo.findWidgetInstanceByName(name)
            },
            updateDimensions: function() {
                var that = this;
                var deferred = new _deferred.Deferred;
                if (that._scrollable) {
                    that._scrollable.update().done(function() {
                        deferred.resolveWith(that)
                    })
                } else {
                    deferred.resolveWith(that)
                }
                return deferred.promise()
            },
            itemOption: function(id, option, value) {
                var _this5 = this;
                var items = this._generateItemsFromData(this.option("items"));
                var item = this._getItemByField(id, items);
                var path = (0, _uiForm4.getItemPath)(items, item);
                if (!item) {
                    return
                }
                switch (arguments.length) {
                    case 1:
                        return item;
                    case 3:
                        var itemAction = this._tryCreateItemOptionAction(option, item, value, item[option], path);
                        this._changeItemOption(item, option, value);
                        var fullName = (0, _uiForm4.getFullOptionName)(path, option);
                        if (!this._tryExecuteItemOptionAction(itemAction) && !this._tryChangeLayoutManagerItemOption(fullName, value)) {
                            this.option("items", items)
                        }
                        break;
                    default:
                        if ((0, _type.isObject)(option)) {
                            if (!this._tryChangeLayoutManagerItemOptions(path, option)) {
                                var allowUpdateItems;
                                (0, _iterator.each)(option, function(optionName, optionValue) {
                                    var itemAction = _this5._tryCreateItemOptionAction(optionName, item, optionValue, item[optionName], path);
                                    _this5._changeItemOption(item, optionName, optionValue);
                                    if (!allowUpdateItems && !_this5._tryExecuteItemOptionAction(itemAction)) {
                                        allowUpdateItems = true
                                    }
                                });
                                allowUpdateItems && this.option("items", items)
                            }
                        }
                }
            },
            validate: function() {
                return _validation_engine.default.validateGroup(this._getValidationGroup())
            },
            getItemID: function(name) {
                return "dx_" + this.option("formID") + "_" + (name || new _guid.default)
            },
            getTargetScreenFactor: function() {
                return this._targetScreenFactor
            }
        });
        (0, _component_registrator.default)("dxForm", Form);
        var _default = Form;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/multi_view/ui.multi_view.animation.js ***!
      \***************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.animation = exports._translator = void 0;
        var _fx = _interopRequireDefault(__webpack_require__( /*! ../../animation/fx */ 42));
        var _translator2 = __webpack_require__( /*! ../../animation/translator */ 28);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _translator = {
            move: function($element, position) {
                (0, _translator2.move)($element, {
                    left: position
                })
            }
        };
        exports._translator = _translator;
        var animation = {
            moveTo: function($element, position, duration, completeAction) {
                _fx.default.animate($element, {
                    type: "slide",
                    to: {
                        left: position
                    },
                    duration: duration,
                    complete: completeAction
                })
            },
            complete: function($element) {
                _fx.default.stop($element, true)
            }
        };
        exports.animation = animation
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tab_panel/item.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _item = _interopRequireDefault(__webpack_require__( /*! ../collection/item */ 150));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var TabPanelItem = function(_CollectionWidgetItem) {
            _inheritsLoose(TabPanelItem, _CollectionWidgetItem);

            function TabPanelItem() {
                return _CollectionWidgetItem.apply(this, arguments) || this
            }
            var _proto = TabPanelItem.prototype;
            _proto._renderWatchers = function() {
                this._startWatcher("badge", _common.noop);
                return _CollectionWidgetItem.prototype._renderWatchers.call(this)
            };
            return TabPanelItem
        }(_item.default);
        exports.default = TabPanelItem;
        module.exports = exports.default
    },
    /*!**************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/form/ui.form.item_options_actions.js ***!
      \**************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiForm = _interopRequireDefault(__webpack_require__( /*! ./ui.form.item_option_action */ 641));
        var _element_data = __webpack_require__( /*! ../../core/element_data */ 40);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _uiForm2 = __webpack_require__( /*! ./ui.form.utils */ 361);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var WidgetOptionItemOptionAction = function(_ItemOptionAction) {
            _inheritsLoose(WidgetOptionItemOptionAction, _ItemOptionAction);

            function WidgetOptionItemOptionAction() {
                return _ItemOptionAction.apply(this, arguments) || this
            }
            var _proto = WidgetOptionItemOptionAction.prototype;
            _proto.tryExecute = function() {
                var value = this._options.value;
                var instance = this.findInstance();
                if (instance) {
                    instance.option(value);
                    return true
                }
                return false
            };
            return WidgetOptionItemOptionAction
        }(_uiForm.default);
        var TabOptionItemOptionAction = function(_ItemOptionAction2) {
            _inheritsLoose(TabOptionItemOptionAction, _ItemOptionAction2);

            function TabOptionItemOptionAction() {
                return _ItemOptionAction2.apply(this, arguments) || this
            }
            var _proto2 = TabOptionItemOptionAction.prototype;
            _proto2.tryExecute = function() {
                var tabPanel = this.findInstance();
                if (tabPanel) {
                    var _this$_options = this._options,
                        optionName = _this$_options.optionName,
                        item = _this$_options.item,
                        value = _this$_options.value;
                    var itemIndex = this._itemsRunTimeInfo.findItemIndexByItem(item);
                    if (itemIndex >= 0) {
                        tabPanel.option((0, _uiForm2.getFullOptionName)("items[".concat(itemIndex, "]"), optionName), value);
                        return true
                    }
                }
                return false
            };
            return TabOptionItemOptionAction
        }(_uiForm.default);
        var TabsOptionItemOptionAction = function(_ItemOptionAction3) {
            _inheritsLoose(TabsOptionItemOptionAction, _ItemOptionAction3);

            function TabsOptionItemOptionAction() {
                return _ItemOptionAction3.apply(this, arguments) || this
            }
            var _proto3 = TabsOptionItemOptionAction.prototype;
            _proto3.tryExecute = function() {
                var tabPanel = this.findInstance();
                if (tabPanel) {
                    var value = this._options.value;
                    tabPanel.option("dataSource", value);
                    return true
                }
                return false
            };
            return TabsOptionItemOptionAction
        }(_uiForm.default);
        var ValidationRulesItemOptionAction = function(_ItemOptionAction4) {
            _inheritsLoose(ValidationRulesItemOptionAction, _ItemOptionAction4);

            function ValidationRulesItemOptionAction() {
                return _ItemOptionAction4.apply(this, arguments) || this
            }
            var _proto4 = ValidationRulesItemOptionAction.prototype;
            _proto4.tryExecute = function() {
                var item = this._options.item;
                var instance = this.findInstance();
                var validator = instance && (0, _element_data.data)(instance.$element()[0], "dxValidator");
                if (validator && item) {
                    var filterRequired = function(item) {
                        return "required" === item.type
                    };
                    var oldContainsRequired = (validator.option("validationRules") || []).some(filterRequired);
                    var newContainsRequired = (item.validationRules || []).some(filterRequired);
                    if (!oldContainsRequired && !newContainsRequired || oldContainsRequired && newContainsRequired) {
                        validator.option("validationRules", item.validationRules);
                        return true
                    }
                }
                return false
            };
            return ValidationRulesItemOptionAction
        }(_uiForm.default);
        var CssClassItemOptionAction = function(_ItemOptionAction5) {
            _inheritsLoose(CssClassItemOptionAction, _ItemOptionAction5);

            function CssClassItemOptionAction() {
                return _ItemOptionAction5.apply(this, arguments) || this
            }
            var _proto5 = CssClassItemOptionAction.prototype;
            _proto5.tryExecute = function() {
                var $itemContainer = this.findItemContainer();
                var _this$_options2 = this._options,
                    previousValue = _this$_options2.previousValue,
                    value = _this$_options2.value;
                if ($itemContainer) {
                    $itemContainer.removeClass(previousValue).addClass(value);
                    return true
                }
                return false
            };
            return CssClassItemOptionAction
        }(_uiForm.default);
        var tryCreateItemOptionAction = function(optionName, itemActionOptions) {
            switch (optionName) {
                case "editorOptions":
                case "buttonOptions":
                    return new WidgetOptionItemOptionAction(itemActionOptions);
                case "validationRules":
                    return new ValidationRulesItemOptionAction(itemActionOptions);
                case "cssClass":
                    return new CssClassItemOptionAction(itemActionOptions);
                case "badge":
                case "disabled":
                case "icon":
                case "template":
                case "tabTemplate":
                case "title":
                    return new TabOptionItemOptionAction((0, _extend.extend)(itemActionOptions, {
                        optionName: optionName
                    }));
                case "tabs":
                    return new TabsOptionItemOptionAction(itemActionOptions);
                default:
                    return null
            }
        };
        var _default = tryCreateItemOptionAction;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/form/ui.form.item_option_action.js ***!
      \************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ItemOptionAction = function() {
            function ItemOptionAction(options) {
                this._options = options;
                this._itemsRunTimeInfo = this._options.itemsRunTimeInfo
            }
            var _proto = ItemOptionAction.prototype;
            _proto.findInstance = function() {
                return this._itemsRunTimeInfo.findWidgetInstanceByItem(this._options.item)
            };
            _proto.findItemContainer = function() {
                return this._itemsRunTimeInfo.findItemContainerByItem(this._options.item)
            };
            _proto.tryExecute = function() {
                _class.default.abstract()
            };
            return ItemOptionAction
        }();
        exports.default = ItemOptionAction;
        module.exports = exports.default
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/form/ui.form.layout_manager.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _guid = _interopRequireDefault(__webpack_require__( /*! ../../core/guid */ 36));
        var _uiForm = _interopRequireDefault(__webpack_require__( /*! ./ui.form.items_runtime_info */ 357));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _element = __webpack_require__( /*! ../../core/element */ 18);
        var _variable_wrapper = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/variable_wrapper */ 102));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _string = __webpack_require__( /*! ../../core/utils/string */ 43);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _data = __webpack_require__( /*! ../../core/utils/data */ 20);
        var _remove_event = _interopRequireDefault(__webpack_require__( /*! ../../core/remove_event */ 152));
        var _click = __webpack_require__( /*! ../../events/click */ 21);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _style = __webpack_require__( /*! ../../core/utils/style */ 99);
        var _inflector = __webpack_require__( /*! ../../core/utils/inflector */ 39);
        var _ui2 = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _validator = _interopRequireDefault(__webpack_require__( /*! ../validator */ 216));
        var _responsive_box = _interopRequireDefault(__webpack_require__( /*! ../responsive_box */ 362));
        var _themes = __webpack_require__( /*! ../themes */ 34);
        var _constants = __webpack_require__( /*! ./constants */ 363);
        __webpack_require__( /*! ../text_box */ 97);
        __webpack_require__( /*! ../number_box */ 116);
        __webpack_require__( /*! ../check_box */ 136);
        __webpack_require__( /*! ../date_box */ 212);
        __webpack_require__( /*! ../button */ 37);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }
        var FORM_EDITOR_BY_DEFAULT = "dxTextBox";
        var LAYOUT_MANAGER_FIRST_ROW_CLASS = "dx-first-row";
        var LAYOUT_MANAGER_LAST_ROW_CLASS = "dx-last-row";
        var LAYOUT_MANAGER_FIRST_COL_CLASS = "dx-first-col";
        var LAYOUT_MANAGER_LAST_COL_CLASS = "dx-last-col";
        var INVALID_CLASS = "dx-invalid";
        var LAYOUT_STRATEGY_FLEX = "flex";
        var LAYOUT_STRATEGY_FALLBACK = "fallback";
        var SIMPLE_ITEM_TYPE = "simple";
        var TEMPLATE_WRAPPER_CLASS = "dx-template-wrapper";
        var DATA_OPTIONS = ["dataSource", "items"];
        var EDITORS_WITH_ARRAY_VALUE = ["dxTagBox", "dxRangeSlider"];
        var LayoutManager = _ui2.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    layoutData: {},
                    readOnly: false,
                    colCount: 1,
                    colCountByScreen: void 0,
                    labelLocation: "left",
                    onFieldDataChanged: null,
                    onEditorEnterKey: null,
                    customizeItem: null,
                    alignItemLabels: true,
                    minColWidth: 200,
                    showRequiredMark: true,
                    screenByWidth: null,
                    showOptionalMark: false,
                    requiredMark: "*",
                    optionalMark: _message.default.format("dxForm-optionalMark"),
                    requiredMessage: _message.default.getFormatter("dxForm-requiredMessage")
                })
            },
            _setOptionsByReference: function() {
                this.callBase();
                (0, _extend.extend)(this._optionsByReference, {
                    layoutData: true,
                    validationGroup: true
                })
            },
            _init: function() {
                var layoutData = this.option("layoutData");
                this.callBase();
                this._itemWatchers = [];
                this._itemsRunTimeInfo = new _uiForm.default;
                this._updateReferencedOptions(layoutData);
                this._initDataAndItems(layoutData)
            },
            _dispose: function() {
                this.callBase();
                this._cleanItemWatchers()
            },
            _initDataAndItems: function(initialData) {
                this._syncDataWithItems();
                this._updateItems(initialData)
            },
            _syncDataWithItems: function() {
                var _this = this;
                var layoutData = this.option("layoutData");
                var userItems = this.option("items");
                if ((0, _type.isDefined)(userItems)) {
                    userItems.forEach(function(item) {
                        if (item.dataField && void 0 === _this._getDataByField(item.dataField)) {
                            var value;
                            if (item.editorOptions) {
                                value = item.editorOptions.value
                            }
                            if ((0, _type.isDefined)(value) || item.dataField in layoutData) {
                                _this._updateFieldValue(item.dataField, value)
                            }
                        }
                    })
                }
            },
            _getDataByField: function(dataField) {
                return dataField ? this.option("layoutData." + dataField) : null
            },
            _isCheckboxUndefinedStateEnabled: function(editorOption) {
                if (true === editorOption.allowIndeterminateState && "dxCheckBox" === editorOption.editorType) {
                    var nameParts = ["layoutData"].concat(_toConsumableArray(editorOption.dataField.split(".")));
                    var propertyName = nameParts.pop();
                    var layoutData = this.option(nameParts.join("."));
                    return layoutData && propertyName in layoutData
                }
                return false
            },
            _updateFieldValue: function(dataField, value) {
                var layoutData = this.option("layoutData");
                var newValue = value;
                if (!_variable_wrapper.default.isWrapped(layoutData[dataField]) && (0, _type.isDefined)(dataField)) {
                    this.option("layoutData." + dataField, newValue)
                } else {
                    if (_variable_wrapper.default.isWritableWrapped(layoutData[dataField])) {
                        newValue = (0, _type.isFunction)(newValue) ? newValue() : newValue;
                        layoutData[dataField](newValue)
                    }
                }
                this._triggerOnFieldDataChanged({
                    dataField: dataField,
                    value: newValue
                })
            },
            _triggerOnFieldDataChanged: function(args) {
                this._createActionByOption("onFieldDataChanged")(args)
            },
            _updateItems: function(layoutData) {
                var that = this;
                var userItems = this.option("items");
                var isUserItemsExist = (0, _type.isDefined)(userItems);
                var customizeItem = that.option("customizeItem");
                var items = isUserItemsExist ? userItems : this._generateItemsByData(layoutData);
                if ((0, _type.isDefined)(items)) {
                    var processedItems = [];
                    (0, _iterator.each)(items, function(index, item) {
                        if (that._isAcceptableItem(item)) {
                            item = that._processItem(item);
                            customizeItem && customizeItem(item);
                            if ((0, _type.isObject)(item) && false !== _variable_wrapper.default.unwrap(item.visible)) {
                                processedItems.push(item)
                            }
                        }
                    });
                    if (!that._itemWatchers.length || !isUserItemsExist) {
                        that._updateItemWatchers(items)
                    }
                    this._setItems(processedItems);
                    this._sortItems()
                }
            },
            _cleanItemWatchers: function() {
                this._itemWatchers.forEach(function(dispose) {
                    dispose()
                });
                this._itemWatchers = []
            },
            _updateItemWatchers: function(items) {
                var that = this;
                var watch = that._getWatch();
                items.forEach(function(item) {
                    if ((0, _type.isObject)(item) && (0, _type.isDefined)(item.visible) && (0, _type.isFunction)(watch)) {
                        that._itemWatchers.push(watch(function() {
                            return _variable_wrapper.default.unwrap(item.visible)
                        }, function() {
                            that._updateItems(that.option("layoutData"));
                            that.repaint()
                        }, {
                            skipImmediate: true
                        }))
                    }
                })
            },
            _generateItemsByData: function(layoutData) {
                var result = [];
                if ((0, _type.isDefined)(layoutData)) {
                    (0, _iterator.each)(layoutData, function(dataField) {
                        result.push({
                            dataField: dataField
                        })
                    })
                }
                return result
            },
            _isAcceptableItem: function(item) {
                var itemField = item.dataField || item;
                var itemData = this._getDataByField(itemField);
                return !((0, _type.isFunction)(itemData) && !_variable_wrapper.default.isWrapped(itemData))
            },
            _processItem: function(item) {
                if ("string" === typeof item) {
                    item = {
                        dataField: item
                    }
                }
                if ("object" === _typeof(item) && !item.itemType) {
                    item.itemType = SIMPLE_ITEM_TYPE
                }
                if (!(0, _type.isDefined)(item.editorType) && (0, _type.isDefined)(item.dataField)) {
                    var value = this._getDataByField(item.dataField);
                    item.editorType = (0, _type.isDefined)(value) ? this._getEditorTypeByDataType((0, _type.type)(value)) : FORM_EDITOR_BY_DEFAULT
                }
                if ("dxCheckBox" === item.editorType) {
                    var _item$allowIndetermin;
                    item.allowIndeterminateState = null !== (_item$allowIndetermin = item.allowIndeterminateState) && void 0 !== _item$allowIndetermin ? _item$allowIndetermin : true
                }
                return item
            },
            _getEditorTypeByDataType: function(dataType) {
                switch (dataType) {
                    case "number":
                        return "dxNumberBox";
                    case "date":
                        return "dxDateBox";
                    case "boolean":
                        return "dxCheckBox";
                    default:
                        return "dxTextBox"
                }
            },
            _sortItems: function() {
                (0, _array.normalizeIndexes)(this._items, "visibleIndex");
                this._sortIndexes()
            },
            _sortIndexes: function() {
                this._items.sort(function(itemA, itemB) {
                    var indexA = itemA.visibleIndex;
                    var indexB = itemB.visibleIndex;
                    var result;
                    if (indexA > indexB) {
                        result = 1
                    } else {
                        if (indexA < indexB) {
                            result = -1
                        } else {
                            result = 0
                        }
                    }
                    return result
                })
            },
            _initMarkup: function() {
                this._itemsRunTimeInfo.clear();
                this.$element().addClass(_constants.FORM_LAYOUT_MANAGER_CLASS);
                this.callBase();
                this._renderResponsiveBox()
            },
            _hasBrowserFlex: function() {
                return (0, _style.styleProp)(LAYOUT_STRATEGY_FLEX) === LAYOUT_STRATEGY_FLEX
            },
            _renderResponsiveBox: function() {
                var that = this;
                var templatesInfo = [];
                if (that._items && that._items.length) {
                    var colCount = that._getColCount();
                    var $container = (0, _renderer.default)("<div>").appendTo(that.$element());
                    that._prepareItemsWithMerging(colCount);
                    var layoutItems = that._generateLayoutItems();
                    that._extendItemsWithDefaultTemplateOptions(layoutItems, that._items);
                    that._responsiveBox = that._createComponent($container, _responsive_box.default, that._getResponsiveBoxConfig(layoutItems, colCount, templatesInfo));
                    if (!(0, _window.hasWindow)()) {
                        that._renderTemplates(templatesInfo)
                    }
                }
            },
            _extendItemsWithDefaultTemplateOptions: function(targetItems, sourceItems) {
                sourceItems.forEach(function(item) {
                    if (!item.merged) {
                        if ((0, _type.isDefined)(item.disabled)) {
                            targetItems[item.visibleIndex].disabled = item.disabled
                        }
                        if ((0, _type.isDefined)(item.visible)) {
                            targetItems[item.visibleIndex].visible = item.visible
                        }
                    }
                })
            },
            _itemStateChangedHandler: function(e) {
                this._refresh()
            },
            _renderTemplate: function($container, item) {
                switch (item.itemType) {
                    case "empty":
                        this._renderEmptyItem($container);
                        break;
                    case "button":
                        this._renderButtonItem(item, $container);
                        break;
                    default:
                        this._renderFieldItem(item, $container)
                }
            },
            _renderTemplates: function(templatesInfo) {
                var that = this;
                (0, _iterator.each)(templatesInfo, function(index, info) {
                    that._renderTemplate(info.container, info.formItem)
                })
            },
            _getResponsiveBoxConfig: function(layoutItems, colCount, templatesInfo) {
                var that = this;
                var colCountByScreen = that.option("colCountByScreen");
                var xsColCount = colCountByScreen && colCountByScreen.xs;
                return {
                    onItemStateChanged: this._itemStateChangedHandler.bind(this),
                    _layoutStrategy: that._hasBrowserFlex() ? LAYOUT_STRATEGY_FLEX : LAYOUT_STRATEGY_FALLBACK,
                    onLayoutChanged: function onLayoutChanged() {
                        var onLayoutChanged = that.option("onLayoutChanged");
                        var isSingleColumnMode = that.isSingleColumnMode();
                        if (onLayoutChanged) {
                            that.$element().toggleClass(_constants.LAYOUT_MANAGER_ONE_COLUMN, isSingleColumnMode);
                            onLayoutChanged(isSingleColumnMode)
                        }
                    },
                    onContentReady: function(e) {
                        if ((0, _window.hasWindow)()) {
                            that._renderTemplates(templatesInfo)
                        }
                        if (that.option("onLayoutChanged")) {
                            that.$element().toggleClass(_constants.LAYOUT_MANAGER_ONE_COLUMN, that.isSingleColumnMode(e.component))
                        }
                    },
                    itemTemplate: function(e, itemData, itemElement) {
                        if (!e.location) {
                            return
                        }
                        var $itemElement = (0, _renderer.default)(itemElement);
                        var itemRenderedCountInPreviousRows = e.location.row * colCount;
                        var item = that._items[e.location.col + itemRenderedCountInPreviousRows];
                        var $fieldItem = (0, _renderer.default)("<div>").addClass(item.cssClass).appendTo($itemElement);
                        templatesInfo.push({
                            container: $fieldItem,
                            formItem: item
                        });
                        $itemElement.toggleClass(_constants.SINGLE_COLUMN_ITEM_CONTENT, that.isSingleColumnMode(this));
                        if (0 === e.location.row) {
                            $fieldItem.addClass(LAYOUT_MANAGER_FIRST_ROW_CLASS)
                        }
                        if (0 === e.location.col) {
                            $fieldItem.addClass(LAYOUT_MANAGER_FIRST_COL_CLASS)
                        }
                        if (item.itemType === SIMPLE_ITEM_TYPE && that.option("isRoot")) {
                            $itemElement.addClass(_constants.ROOT_SIMPLE_ITEM_CLASS)
                        }
                        var isLastColumn = e.location.col === colCount - 1 || e.location.col + e.location.colspan === colCount;
                        var rowsCount = that._getRowsCount();
                        var isLastRow = e.location.row === rowsCount - 1;
                        if (isLastColumn) {
                            $fieldItem.addClass(LAYOUT_MANAGER_LAST_COL_CLASS)
                        }
                        if (isLastRow) {
                            $fieldItem.addClass(LAYOUT_MANAGER_LAST_ROW_CLASS)
                        }
                    },
                    cols: that._generateRatio(colCount),
                    rows: that._generateRatio(that._getRowsCount(), true),
                    dataSource: layoutItems,
                    screenByWidth: that.option("screenByWidth"),
                    singleColumnScreen: xsColCount ? false : "xs"
                }
            },
            _getColCount: function() {
                var colCount = this.option("colCount");
                var colCountByScreen = this.option("colCountByScreen");
                if (colCountByScreen) {
                    var screenFactor = this.option("form").getTargetScreenFactor();
                    if (!screenFactor) {
                        screenFactor = (0, _window.hasWindow)() ? (0, _window.getCurrentScreenFactor)(this.option("screenByWidth")) : "lg"
                    }
                    colCount = colCountByScreen[screenFactor] || colCount
                }
                if ("auto" === colCount) {
                    if (this._cashedColCount) {
                        return this._cashedColCount
                    }
                    this._cashedColCount = colCount = this._getMaxColCount()
                }
                return colCount < 1 ? 1 : colCount
            },
            _getMaxColCount: function() {
                if (!(0, _window.hasWindow)()) {
                    return 1
                }
                var minColWidth = this.option("minColWidth");
                var width = this.$element().width();
                var itemsCount = this._items.length;
                var maxColCount = Math.floor(width / minColWidth) || 1;
                return itemsCount < maxColCount ? itemsCount : maxColCount
            },
            isCachedColCountObsolete: function() {
                return this._cashedColCount && this._getMaxColCount() !== this._cashedColCount
            },
            _prepareItemsWithMerging: function(colCount) {
                var items = this._items.slice(0);
                var item;
                var itemsMergedByCol;
                var result = [];
                var j;
                var i;
                for (i = 0; i < items.length; i++) {
                    item = items[i];
                    result.push(item);
                    if (this.option("alignItemLabels") || item.alignItemLabels || item.colSpan) {
                        item.col = this._getColByIndex(result.length - 1, colCount)
                    }
                    if (item.colSpan > 1 && item.col + item.colSpan <= colCount) {
                        itemsMergedByCol = [];
                        for (j = 0; j < item.colSpan - 1; j++) {
                            itemsMergedByCol.push({
                                merged: true
                            })
                        }
                        result = result.concat(itemsMergedByCol)
                    } else {
                        delete item.colSpan
                    }
                }
                this._setItems(result)
            },
            _getColByIndex: function(index, colCount) {
                return index % colCount
            },
            _setItems: function(items) {
                this._items = items;
                this._cashedColCount = null
            },
            _generateLayoutItems: function() {
                var items = this._items;
                var colCount = this._getColCount();
                var result = [];
                var item;
                var i;
                for (i = 0; i < items.length; i++) {
                    item = items[i];
                    if (!item.merged) {
                        var generatedItem = {
                            location: {
                                row: parseInt(i / colCount),
                                col: this._getColByIndex(i, colCount)
                            }
                        };
                        if ((0, _type.isDefined)(item.colSpan)) {
                            generatedItem.location.colspan = item.colSpan
                        }
                        if ((0, _type.isDefined)(item.rowSpan)) {
                            generatedItem.location.rowspan = item.rowSpan
                        }
                        result.push(generatedItem)
                    }
                }
                return result
            },
            _renderEmptyItem: function($container) {
                return $container.addClass(_constants.FIELD_EMPTY_ITEM_CLASS).html("&nbsp;")
            },
            _getButtonHorizontalAlignment: function(item) {
                if ((0, _type.isDefined)(item.horizontalAlignment)) {
                    return item.horizontalAlignment
                }
                return "right"
            },
            _getButtonVerticalAlignment: function(item) {
                switch (item.verticalAlignment) {
                    case "center":
                        return "center";
                    case "bottom":
                        return "flex-end";
                    default:
                        return "flex-start"
                }
            },
            _renderButtonItem: function(item, $container) {
                var $button = (0, _renderer.default)("<div>").appendTo($container);
                var defaultOptions = {
                    validationGroup: this.option("validationGroup")
                };
                $container.addClass(_constants.FIELD_BUTTON_ITEM_CLASS).css("textAlign", this._getButtonHorizontalAlignment(item));
                $container.parent().css("justifyContent", this._getButtonVerticalAlignment(item));
                var instance = this._createComponent($button, "dxButton", (0, _extend.extend)(defaultOptions, item.buttonOptions));
                this._itemsRunTimeInfo.add({
                    item: item,
                    widgetInstance: instance,
                    guid: item.guid,
                    $itemContainer: $container
                });
                this._addItemClasses($container, item.col);
                return $button
            },
            _addItemClasses: function($item, column) {
                $item.addClass(_constants.FIELD_ITEM_CLASS).addClass(this.option("cssItemClass")).addClass((0, _type.isDefined)(column) ? "dx-col-" + column : "")
            },
            _renderFieldItem: function(item, $container) {
                var that = this;
                var name = that._getName(item);
                var id = that.getItemID(name);
                var isRequired = (0, _type.isDefined)(item.isRequired) ? item.isRequired : !!that._hasRequiredRuleInSet(item.validationRules);
                var labelOptions = that._getLabelOptions(item, id, isRequired);
                var $editor = (0, _renderer.default)("<div>");
                var helpID = item.helpText ? "dx-" + new _guid.default : null;
                var $label;
                this._addItemClasses($container, item.col);
                $container.addClass(isRequired ? _constants.FIELD_ITEM_REQUIRED_CLASS : _constants.FIELD_ITEM_OPTIONAL_CLASS);
                if (labelOptions.visible && labelOptions.text) {
                    $label = that._renderLabel(labelOptions).appendTo($container)
                }
                if (item.itemType === SIMPLE_ITEM_TYPE) {
                    if (that._isLabelNeedBaselineAlign(item) && "top" !== labelOptions.location) {
                        $container.addClass(_constants.FIELD_ITEM_LABEL_ALIGN_CLASS)
                    }
                    that._hasBrowserFlex() && $container.addClass(_constants.FLEX_LAYOUT_CLASS)
                }
                $editor.data("dx-form-item", item);
                that._appendEditorToField({
                    $fieldItem: $container,
                    $label: $label,
                    $editor: $editor,
                    labelOptions: labelOptions
                });
                var instance = that._renderEditor({
                    $container: $editor,
                    dataField: item.dataField,
                    name: item.name,
                    editorType: item.editorType,
                    editorOptions: item.editorOptions,
                    template: that._getTemplateByFieldItem(item),
                    isRequired: isRequired,
                    helpID: helpID,
                    labelID: labelOptions.labelID,
                    id: id,
                    validationBoundary: that.option("validationBoundary"),
                    allowIndeterminateState: item.allowIndeterminateState
                });
                this._itemsRunTimeInfo.add({
                    item: item,
                    widgetInstance: instance,
                    guid: item.guid,
                    $itemContainer: $container
                });
                var editorElem = $editor.children().first();
                var $validationTarget = editorElem.hasClass(TEMPLATE_WRAPPER_CLASS) ? editorElem.children().first() : editorElem;
                var validationTargetInstance = $validationTarget && $validationTarget.data("dx-validation-target");
                if (validationTargetInstance) {
                    that._renderValidator($validationTarget, item);
                    if ((0, _themes.isMaterial)()) {
                        that._addWrapperInvalidClass(validationTargetInstance)
                    }
                }
                that._renderHelpText(item, $editor, helpID);
                that._attachClickHandler($label, $editor, item.editorType)
            },
            _hasRequiredRuleInSet: function(rules) {
                var hasRequiredRule;
                if (rules && rules.length) {
                    (0, _iterator.each)(rules, function(index, rule) {
                        if ("required" === rule.type) {
                            hasRequiredRule = true;
                            return false
                        }
                    })
                }
                return hasRequiredRule
            },
            _getName: function(item) {
                return item.dataField || item.name
            },
            _isLabelNeedBaselineAlign: function(item) {
                var largeEditors = ["dxTextArea", "dxRadioGroup", "dxCalendar", "dxHtmlEditor"];
                return !!item.helpText && !this._hasBrowserFlex() || (0, _array.inArray)(item.editorType, largeEditors) !== -1
            },
            _isLabelNeedId: function(item) {
                var editorsRequiringIdForLabel = ["dxRadioGroup", "dxCheckBox", "dxLookup", "dxSlider", "dxRangeSlider", "dxSwitch", "dxHtmlEditor"];
                return (0, _array.inArray)(item.editorType, editorsRequiringIdForLabel) !== -1
            },
            _getLabelOptions: function(item, id, isRequired) {
                var labelOptions = (0, _extend.extend)({
                    showColon: this.option("showColonAfterLabel"),
                    location: this.option("labelLocation"),
                    id: id,
                    visible: true,
                    isRequired: isRequired
                }, item ? item.label : {});
                if (this._isLabelNeedId(item)) {
                    labelOptions.labelID = "dx-label-".concat(new _guid.default)
                }
                if (!labelOptions.text && item.dataField) {
                    labelOptions.text = (0, _inflector.captionize)(item.dataField)
                }
                if (labelOptions.text) {
                    labelOptions.text += labelOptions.showColon ? ":" : ""
                }
                return labelOptions
            },
            _renderLabel: function(options) {
                var text = options.text,
                    id = options.id,
                    location = options.location,
                    alignment = options.alignment,
                    isRequired = options.isRequired,
                    _options$labelID = options.labelID,
                    labelID = void 0 === _options$labelID ? null : _options$labelID;
                if ((0, _type.isDefined)(text) && text.length > 0) {
                    var labelClasses = _constants.FIELD_ITEM_LABEL_CLASS + " " + _constants.FIELD_ITEM_LABEL_LOCATION_CLASS + location;
                    var $label = (0, _renderer.default)("<label>").addClass(labelClasses).attr("for", id).attr("id", labelID);
                    var $labelContent = (0, _renderer.default)("<span>").addClass(_constants.FIELD_ITEM_LABEL_CONTENT_CLASS).appendTo($label);
                    (0, _renderer.default)("<span>").addClass(_constants.FIELD_ITEM_LABEL_TEXT_CLASS).text(text).appendTo($labelContent);
                    if (alignment) {
                        $label.css("textAlign", alignment)
                    }
                    $labelContent.append(this._renderLabelMark(isRequired));
                    return $label
                }
            },
            _renderLabelMark: function(isRequired) {
                var $mark;
                var requiredMarksConfig = this._getRequiredMarksConfig();
                var isRequiredMark = requiredMarksConfig.showRequiredMark && isRequired;
                var isOptionalMark = requiredMarksConfig.showOptionalMark && !isRequired;
                if (isRequiredMark || isOptionalMark) {
                    var markClass = isRequiredMark ? _constants.FIELD_ITEM_REQUIRED_MARK_CLASS : _constants.FIELD_ITEM_OPTIONAL_MARK_CLASS;
                    var markText = isRequiredMark ? requiredMarksConfig.requiredMark : requiredMarksConfig.optionalMark;
                    $mark = (0, _renderer.default)("<span>").addClass(markClass).html("&nbsp" + markText)
                }
                return $mark
            },
            _getRequiredMarksConfig: function() {
                if (!this._cashedRequiredConfig) {
                    this._cashedRequiredConfig = {
                        showRequiredMark: this.option("showRequiredMark"),
                        showOptionalMark: this.option("showOptionalMark"),
                        requiredMark: this.option("requiredMark"),
                        optionalMark: this.option("optionalMark")
                    }
                }
                return this._cashedRequiredConfig
            },
            _renderEditor: function(options) {
                var dataValue = this._getDataByField(options.dataField);
                var defaultEditorOptions = void 0 !== dataValue || this._isCheckboxUndefinedStateEnabled(options) ? {
                    value: dataValue
                } : {};
                var isDeepExtend = true;
                if (EDITORS_WITH_ARRAY_VALUE.indexOf(options.editorType) !== -1) {
                    defaultEditorOptions.value = defaultEditorOptions.value || []
                }
                var formInstance = this.option("form");
                var editorOptions = (0, _extend.extend)(isDeepExtend, defaultEditorOptions, options.editorOptions, {
                    inputAttr: {
                        id: options.id
                    },
                    validationBoundary: options.validationBoundary,
                    stylingMode: formInstance && formInstance.option("stylingMode")
                });
                this._replaceDataOptions(options.editorOptions, editorOptions);
                var renderOptions = {
                    editorType: options.editorType,
                    dataField: options.dataField,
                    template: options.template,
                    name: options.name,
                    helpID: options.helpID,
                    labelID: options.labelID,
                    isRequired: options.isRequired
                };
                return this._createEditor(options.$container, renderOptions, editorOptions)
            },
            _replaceDataOptions: function(originalOptions, resultOptions) {
                if (originalOptions) {
                    DATA_OPTIONS.forEach(function(item) {
                        if (resultOptions[item]) {
                            resultOptions[item] = originalOptions[item]
                        }
                    })
                }
            },
            _renderValidator: function($editor, item) {
                var fieldName = this._getFieldLabelName(item);
                var validationRules = this._prepareValidationRules(item.validationRules, item.isRequired, item.itemType, fieldName);
                if (Array.isArray(validationRules) && validationRules.length) {
                    this._createComponent($editor, _validator.default, {
                        validationRules: validationRules,
                        validationGroup: this.option("validationGroup"),
                        dataGetter: function() {
                            return {
                                formItem: item
                            }
                        }
                    })
                }
            },
            _getFieldLabelName: function(item) {
                var isItemHaveCustomLabel = item.label && item.label.text;
                var itemName = isItemHaveCustomLabel ? null : this._getName(item);
                return isItemHaveCustomLabel ? item.label.text : itemName && (0, _inflector.captionize)(itemName)
            },
            _prepareValidationRules: function(userValidationRules, isItemRequired, itemType, itemName) {
                var isSimpleItem = itemType === SIMPLE_ITEM_TYPE;
                var validationRules;
                if (isSimpleItem) {
                    if (userValidationRules) {
                        validationRules = userValidationRules
                    } else {
                        var requiredMessage = (0, _string.format)(this.option("requiredMessage"), itemName || "");
                        validationRules = isItemRequired ? [{
                            type: "required",
                            message: requiredMessage
                        }] : null
                    }
                }
                return validationRules
            },
            _addWrapperInvalidClass: function(editorInstance) {
                var wrapperClass = "." + _constants.FIELD_ITEM_CONTENT_WRAPPER_CLASS;
                var toggleInvalidClass = function(e) {
                    (0, _renderer.default)(e.element).parents(wrapperClass).toggleClass(INVALID_CLASS, e.component._isFocused() && false === e.component.option("isValid"))
                };
                editorInstance.on("focusIn", toggleInvalidClass).on("focusOut", toggleInvalidClass).on("enterKey", toggleInvalidClass)
            },
            _createEditor: function($container, renderOptions, editorOptions) {
                var that = this;
                var template = renderOptions.template;
                var editorInstance;
                if (renderOptions.dataField && !editorOptions.name) {
                    editorOptions.name = renderOptions.dataField
                }
                that._addItemContentClasses($container);
                if (template) {
                    var data = {
                        dataField: renderOptions.dataField,
                        editorType: renderOptions.editorType,
                        editorOptions: editorOptions,
                        component: that._getComponentOwner(),
                        name: renderOptions.name
                    };
                    template.render({
                        model: data,
                        container: (0, _element.getPublicElement)($container)
                    })
                } else {
                    var $editor = (0, _renderer.default)("<div>").appendTo($container);
                    try {
                        editorInstance = that._createComponent($editor, renderOptions.editorType, editorOptions);
                        editorInstance.setAria("describedby", renderOptions.helpID);
                        editorInstance.setAria("labelledby", renderOptions.labelID);
                        editorInstance.setAria("required", renderOptions.isRequired);
                        if (renderOptions.dataField) {
                            that._bindDataField(editorInstance, renderOptions, $container)
                        }
                    } catch (e) {
                        _ui.default.log("E1035", e.message)
                    }
                }
                return editorInstance
            },
            _getComponentOwner: function() {
                return this.option("form") || this
            },
            _bindDataField: function(editorInstance, renderOptions, $container) {
                var componentOwner = this._getComponentOwner();
                editorInstance.on("enterKey", function(args) {
                    componentOwner._createActionByOption("onEditorEnterKey")((0, _extend.extend)(args, {
                        dataField: renderOptions.dataField
                    }))
                });
                this._createWatcher(editorInstance, $container, renderOptions);
                this.linkEditorToDataField(editorInstance, renderOptions.dataField, renderOptions.editorType)
            },
            _createWatcher: function(editorInstance, $container, renderOptions) {
                var that = this;
                var watch = that._getWatch();
                if (!(0, _type.isFunction)(watch)) {
                    return
                }
                var dispose = watch(function() {
                    return that._getDataByField(renderOptions.dataField)
                }, function() {
                    editorInstance.option("value", that._getDataByField(renderOptions.dataField))
                }, {
                    deep: true,
                    skipImmediate: true
                });
                _events_engine.default.on($container, _remove_event.default, dispose)
            },
            _getWatch: function() {
                if (!(0, _type.isDefined)(this._watch)) {
                    var formInstance = this.option("form");
                    this._watch = formInstance && formInstance.option("integrationOptions.watchMethod")
                }
                return this._watch
            },
            _addItemContentClasses: function($itemContent) {
                var locationSpecificClass = this._getItemContentLocationSpecificClass();
                $itemContent.addClass([_constants.FIELD_ITEM_CONTENT_CLASS, locationSpecificClass].join(" "))
            },
            _getItemContentLocationSpecificClass: function() {
                var labelLocation = this.option("labelLocation");
                var oppositeClasses = {
                    right: "left",
                    left: "right",
                    top: "bottom"
                };
                return _constants.FIELD_ITEM_CONTENT_LOCATION_CLASS + oppositeClasses[labelLocation]
            },
            _createComponent: function($editor, type, editorOptions) {
                var that = this;
                var readOnlyState = this.option("readOnly");
                var instance = that.callBase($editor, type, editorOptions);
                readOnlyState && instance.option("readOnly", readOnlyState);
                that.on("optionChanged", function(args) {
                    if ("readOnly" === args.name && !(0, _type.isDefined)(editorOptions.readOnly)) {
                        instance.option(args.name, args.value)
                    }
                });
                return instance
            },
            _getTemplateByFieldItem: function(fieldItem) {
                return fieldItem.template ? this._getTemplate(fieldItem.template) : null
            },
            _appendEditorToField: function(params) {
                if (params.$label) {
                    var location = params.labelOptions.location;
                    if ("top" === location || "left" === location) {
                        params.$fieldItem.append(params.$editor)
                    }
                    if ("right" === location) {
                        params.$fieldItem.prepend(params.$editor)
                    }
                    this._addInnerItemAlignmentClass(params.$fieldItem, location)
                } else {
                    params.$fieldItem.append(params.$editor)
                }
            },
            _addInnerItemAlignmentClass: function($fieldItem, location) {
                if ("top" === location) {
                    $fieldItem.addClass(_constants.LABEL_VERTICAL_ALIGNMENT_CLASS)
                } else {
                    $fieldItem.addClass(_constants.LABEL_HORIZONTAL_ALIGNMENT_CLASS)
                }
            },
            _renderHelpText: function(fieldItem, $editor, helpID) {
                var helpText = fieldItem.helpText;
                var isSimpleItem = fieldItem.itemType === SIMPLE_ITEM_TYPE;
                if (helpText && isSimpleItem) {
                    var $editorWrapper = (0, _renderer.default)("<div>").addClass(_constants.FIELD_ITEM_CONTENT_WRAPPER_CLASS);
                    $editor.wrap($editorWrapper);
                    (0, _renderer.default)("<div>").addClass(_constants.FIELD_ITEM_HELP_TEXT_CLASS).attr("id", helpID).text(helpText).appendTo($editor.parent())
                }
            },
            _attachClickHandler: function($label, $editor, editorType) {
                var isBooleanEditors = "dxCheckBox" === editorType || "dxSwitch" === editorType;
                if ($label && isBooleanEditors) {
                    _events_engine.default.on($label, _click.name, function() {
                        _events_engine.default.trigger($editor.children(), _click.name)
                    })
                }
            },
            _generateRatio: function(count, isAutoSize) {
                var result = [];
                var ratio;
                var i;
                for (i = 0; i < count; i++) {
                    ratio = {
                        ratio: 1
                    };
                    if (isAutoSize) {
                        ratio.baseSize = "auto"
                    }
                    result.push(ratio)
                }
                return result
            },
            _getRowsCount: function() {
                return Math.ceil(this._items.length / this._getColCount())
            },
            _updateReferencedOptions: function(newLayoutData) {
                var _this2 = this;
                var layoutData = this.option("layoutData");
                if ((0, _type.isObject)(layoutData)) {
                    Object.getOwnPropertyNames(layoutData).forEach(function(property) {
                        return delete _this2._optionsByReference["layoutData." + property]
                    })
                }
                if ((0, _type.isObject)(newLayoutData)) {
                    Object.getOwnPropertyNames(newLayoutData).forEach(function(property) {
                        return _this2._optionsByReference["layoutData." + property] = true
                    })
                }
            },
            _resetWidget: function(instance) {
                this._disableEditorValueChangedHandler = true;
                instance.reset();
                this._disableEditorValueChangedHandler = false;
                instance.option("isValid", true)
            },
            _optionChanged: function(args) {
                var _this3 = this;
                if (0 === args.fullName.search("layoutData.")) {
                    return
                }
                switch (args.name) {
                    case "showRequiredMark":
                    case "showOptionalMark":
                    case "requiredMark":
                    case "optionalMark":
                        this._cashedRequiredConfig = null;
                        this._invalidate();
                        break;
                    case "layoutData":
                        this._updateReferencedOptions(args.value);
                        if (this.option("items")) {
                            if (!(0, _type.isEmptyObject)(args.value)) {
                                this._itemsRunTimeInfo.each(function(_, itemRunTimeInfo) {
                                    if ((0, _type.isDefined)(itemRunTimeInfo.item)) {
                                        var dataField = itemRunTimeInfo.item.dataField;
                                        if (dataField && (0, _type.isDefined)(itemRunTimeInfo.widgetInstance)) {
                                            var valueGetter = (0, _data.compileGetter)(dataField);
                                            var dataValue = valueGetter(args.value);
                                            if (void 0 !== dataValue || _this3._isCheckboxUndefinedStateEnabled(itemRunTimeInfo.item)) {
                                                itemRunTimeInfo.widgetInstance.option("value", dataValue)
                                            } else {
                                                _this3._resetWidget(itemRunTimeInfo.widgetInstance)
                                            }
                                        }
                                    }
                                })
                            }
                        } else {
                            this._initDataAndItems(args.value);
                            this._invalidate()
                        }
                        break;
                    case "items":
                        this._cleanItemWatchers();
                        this._initDataAndItems(args.value);
                        this._invalidate();
                        break;
                    case "alignItemLabels":
                    case "labelLocation":
                    case "requiredMessage":
                        this._invalidate();
                        break;
                    case "customizeItem":
                        this._updateItems(this.option("layoutData"));
                        this._invalidate();
                        break;
                    case "colCount":
                        this._resetColCount();
                        break;
                    case "minColWidth":
                        if ("auto" === this.option("colCount")) {
                            this._resetColCount()
                        }
                        break;
                    case "readOnly":
                        break;
                    case "width":
                        this.callBase(args);
                        if ("auto" === this.option("colCount")) {
                            this._resetColCount()
                        }
                        break;
                    case "onFieldDataChanged":
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _resetColCount: function() {
                this._cashedColCount = null;
                this._invalidate()
            },
            linkEditorToDataField: function(editorInstance, dataField) {
                var _this4 = this;
                this.on("optionChanged", function(args) {
                    if (args.fullName === "layoutData.".concat(dataField)) {
                        editorInstance._setOptionWithoutOptionChange("value", args.value)
                    }
                });
                editorInstance.on("valueChanged", function(args) {
                    var isValueReferenceType = (0, _type.isObject)(args.value) || Array.isArray(args.value);
                    if (!_this4._disableEditorValueChangedHandler && !(isValueReferenceType && args.value === args.previousValue)) {
                        _this4._updateFieldValue(dataField, args.value)
                    }
                })
            },
            _dimensionChanged: function() {
                if ("auto" === this.option("colCount") && this.isCachedColCountObsolete()) {
                    this._eventsStrategy.fireEvent("autoColCountChanged")
                }
            },
            getItemID: function(name) {
                var formInstance = this.option("form");
                return formInstance && formInstance.getItemID(name)
            },
            updateData: function(data, value) {
                var that = this;
                if ((0, _type.isObject)(data)) {
                    (0, _iterator.each)(data, function(dataField, fieldValue) {
                        that._updateFieldValue(dataField, fieldValue)
                    })
                } else {
                    if ("string" === typeof data) {
                        that._updateFieldValue(data, value);
                    }
                }
            },
            getEditor: function(field) {
                return this._itemsRunTimeInfo.findWidgetInstanceByDataField(field) || this._itemsRunTimeInfo.findWidgetInstanceByName(field)
            },
            isSingleColumnMode: function(component) {
                var responsiveBox = this._responsiveBox || component;
                if (responsiveBox) {
                    return responsiveBox.option("currentScreenFactor") === responsiveBox.option("singleColumnScreen")
                }
            },
            getItemsRunTimeInfo: function() {
                return this._itemsRunTimeInfo
            }
        });
        (0, _component_registrator.default)("dxLayoutManager", LayoutManager);
        var _default = LayoutManager;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/validation/default_adapter.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DefaultAdapter = _class.default.inherit({
            ctor: function(editor, validator) {
                var _this = this;
                this.editor = editor;
                this.validator = validator;
                this.validationRequestsCallbacks = [];
                var handler = function(args) {
                    _this.validationRequestsCallbacks.forEach(function(item) {
                        return item(args)
                    })
                };
                editor.validationRequest.add(handler);
                editor.on("disposing", function() {
                    editor.validationRequest.remove(handler)
                })
            },
            getValue: function() {
                return this.editor.option("value")
            },
            getCurrentValidationError: function() {
                return this.editor.option("validationError")
            },
            bypass: function() {
                return this.editor.option("disabled")
            },
            applyValidationResults: function(params) {
                this.editor.option({
                    validationErrors: params.brokenRules,
                    validationStatus: params.status
                })
            },
            reset: function() {
                this.editor.reset()
            },
            focus: function() {
                this.editor.focus()
            }
        });
        var _default = DefaultAdapter;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/gallery.js ***!
      \************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _element = __webpack_require__( /*! ../core/element */ 18);
        var _fx = _interopRequireDefault(__webpack_require__( /*! ../animation/fx */ 42));
        var _click = __webpack_require__( /*! ../events/click */ 21);
        var _translator = __webpack_require__( /*! ../animation/translator */ 28);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../core/devices */ 13));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./widget/ui.widget */ 16));
        var _index = __webpack_require__( /*! ../events/utils/index */ 8);
        var _uiCollection_widget = _interopRequireDefault(__webpack_require__( /*! ./collection/ui.collection_widget.edit */ 54));
        var _swipeable = _interopRequireDefault(__webpack_require__( /*! ../events/gesture/swipeable */ 172));
        var _bindable_template = __webpack_require__( /*! ../core/templates/bindable_template */ 65);
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var GALLERY_CLASS = "dx-gallery";
        var GALLERY_WRAPPER_CLASS = GALLERY_CLASS + "-wrapper";
        var GALLERY_LOOP_CLASS = "dx-gallery-loop";
        var GALLERY_ITEM_CONTAINER_CLASS = GALLERY_CLASS + "-container";
        var GALLERY_ACTIVE_CLASS = GALLERY_CLASS + "-active";
        var GALLERY_ITEM_CLASS = GALLERY_CLASS + "-item";
        var GALLERY_INVISIBLE_ITEM_CLASS = GALLERY_CLASS + "-item-invisible";
        var GALLERY_LOOP_ITEM_CLASS = GALLERY_ITEM_CLASS + "-loop";
        var GALLERY_ITEM_SELECTOR = "." + GALLERY_ITEM_CLASS;
        var GALLERY_ITEM_SELECTED_CLASS = GALLERY_ITEM_CLASS + "-selected";
        var GALLERY_INDICATOR_CLASS = GALLERY_CLASS + "-indicator";
        var GALLERY_INDICATOR_ITEM_CLASS = GALLERY_INDICATOR_CLASS + "-item";
        var GALLERY_INDICATOR_ITEM_SELECTOR = "." + GALLERY_INDICATOR_ITEM_CLASS;
        var GALLERY_INDICATOR_ITEM_SELECTED_CLASS = GALLERY_INDICATOR_ITEM_CLASS + "-selected";
        var GALLERY_IMAGE_CLASS = "dx-gallery-item-image";
        var GALLERY_ITEM_DATA_KEY = "dxGalleryItemData";
        var MAX_CALC_ERROR = 1;
        var GalleryNavButton = _ui.default.inherit({
            _supportedKeys: function() {
                return (0, _extend.extend)(this.callBase(), {
                    pageUp: _common.noop,
                    pageDown: _common.noop
                })
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    direction: "next",
                    onClick: null,
                    hoverStateEnabled: true,
                    activeStateEnabled: true
                })
            },
            _render: function() {
                this.callBase();
                var that = this;
                var $element = this.$element();
                var eventName = (0, _index.addNamespace)(_click.name, this.NAME);
                $element.addClass(GALLERY_CLASS + "-nav-button-" + this.option("direction"));
                _events_engine.default.off($element, eventName);
                _events_engine.default.on($element, eventName, function(e) {
                    that._createActionByOption("onClick")({
                        event: e
                    })
                })
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "onClick":
                    case "direction":
                        this._invalidate();
                        break;
                    default:
                        this.callBase(args)
                }
            }
        });
        var Gallery = _uiCollection_widget.default.inherit({
            _activeStateUnit: GALLERY_ITEM_SELECTOR,
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    activeStateEnabled: false,
                    animationDuration: 400,
                    animationEnabled: true,
                    loop: false,
                    swipeEnabled: true,
                    indicatorEnabled: true,
                    showIndicator: true,
                    selectedIndex: 0,
                    slideshowDelay: 0,
                    showNavButtons: false,
                    wrapAround: false,
                    initialItemWidth: void 0,
                    stretchImages: false,
                    _itemAttributes: {
                        role: "option"
                    },
                    loopItemFocus: false,
                    selectOnFocus: true,
                    selectionMode: "single",
                    selectionRequired: true,
                    selectionByClick: false
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: function() {
                        return "desktop" === _devices.default.real().deviceType && !_devices.default.isSimulator()
                    },
                    options: {
                        focusStateEnabled: true
                    }
                }])
            },
            _init: function() {
                this.callBase();
                this.option("loopItemFocus", this.option("loop"))
            },
            _initTemplates: function() {
                this.callBase();
                this._templateManager.addDefaultTemplates({
                    item: new _bindable_template.BindableTemplate(function($container, data) {
                        var $img = (0, _renderer.default)("<img>").addClass(GALLERY_IMAGE_CLASS);
                        if ((0, _type.isPlainObject)(data)) {
                            this._prepareDefaultItemTemplate(data, $container);
                            $img.attr({
                                src: data.imageSrc,
                                alt: data.imageAlt
                            }).appendTo($container)
                        } else {
                            $img.attr("src", String(data)).appendTo($container)
                        }
                    }.bind(this), ["imageSrc", "imageAlt", "text", "html"], this.option("integrationOptions.watchMethod"))
                })
            },
            _dataSourceOptions: function() {
                return {
                    paginate: false
                }
            },
            _itemContainer: function() {
                return this._$container
            },
            _itemClass: function() {
                return GALLERY_ITEM_CLASS
            },
            _itemDataKey: function() {
                return GALLERY_ITEM_DATA_KEY
            },
            _actualItemWidth: function() {
                var isWrapAround = this.option("wrapAround");
                if (this.option("stretchImages")) {
                    var itemPerPage = isWrapAround ? this._itemsPerPage() + 1 : this._itemsPerPage();
                    return 1 / itemPerPage
                }
                if (isWrapAround) {
                    return this._itemPercentWidth() * this._itemsPerPage() / (this._itemsPerPage() + 1)
                }
                return this._itemPercentWidth()
            },
            _itemPercentWidth: function() {
                var percentWidth;
                var elementWidth = this.$element().outerWidth();
                var initialItemWidth = this.option("initialItemWidth");
                if (initialItemWidth && initialItemWidth <= elementWidth) {
                    percentWidth = initialItemWidth / elementWidth
                } else {
                    percentWidth = 1
                }
                return percentWidth
            },
            _itemsPerPage: function() {
                var itemsPerPage = (0, _window.hasWindow)() ? Math.floor(1 / this._itemPercentWidth()) : 1;
                return Math.min(itemsPerPage, this._itemsCount())
            },
            _pagesCount: function() {
                return Math.ceil(this._itemsCount() / this._itemsPerPage())
            },
            _itemsCount: function() {
                return (this.option("items") || []).length
            },
            _offsetDirection: function() {
                return this.option("rtlEnabled") ? -1 : 1
            },
            _initMarkup: function() {
                this._renderWrapper();
                this._renderItemsContainer();
                this.$element().addClass(GALLERY_CLASS);
                this.$element().toggleClass(GALLERY_LOOP_CLASS, this.option("loop"));
                this.callBase();
                this.setAria({
                    role: "listbox",
                    label: "gallery"
                })
            },
            _render: function() {
                this._renderDragHandler();
                this._renderContainerPosition();
                this._renderItemSizes();
                this._renderItemPositions();
                this._renderNavButtons();
                this._renderIndicator();
                this._renderSelectedItem();
                this._renderItemVisibility();
                this._renderUserInteraction();
                this._setupSlideShow();
                this._reviseDimensions();
                this.callBase()
            },
            _dimensionChanged: function() {
                var selectedIndex = this.option("selectedIndex") || 0;
                this._stopItemAnimations();
                this._clearCacheWidth();
                this._cloneDuplicateItems();
                this._renderItemSizes();
                this._renderItemPositions();
                this._renderIndicator();
                this._renderContainerPosition(this._calculateIndexOffset(selectedIndex), true);
                this._renderItemVisibility()
            },
            _renderDragHandler: function() {
                var eventName = (0, _index.addNamespace)("dragstart", this.NAME);
                _events_engine.default.off(this.$element(), eventName);
                _events_engine.default.on(this.$element(), eventName, "img", function() {
                    return false
                })
            },
            _renderWrapper: function() {
                if (this._$wrapper) {
                    return
                }
                this._$wrapper = (0, _renderer.default)("<div>").addClass(GALLERY_WRAPPER_CLASS).appendTo(this.$element())
            },
            _renderItems: function(items) {
                if (!(0, _window.hasWindow)()) {
                    var selectedIndex = this.option("selectedIndex");
                    items = items.length > selectedIndex ? items.slice(selectedIndex, selectedIndex + 1) : items.slice(0, 1)
                }
                this.callBase(items);
                this._loadNextPageIfNeeded()
            },
            _renderItemsContainer: function() {
                if (this._$container) {
                    return
                }
                this._$container = (0, _renderer.default)("<div>").addClass(GALLERY_ITEM_CONTAINER_CLASS).appendTo(this._$wrapper)
            },
            _cloneDuplicateItems: function() {
                if (!this.option("loop")) {
                    return
                }
                var items = this.option("items") || [];
                var itemsCount = items.length;
                var lastItemIndex = itemsCount - 1;
                var i;
                if (!itemsCount) {
                    return
                }
                this._getLoopedItems().remove();
                var duplicateCount = Math.min(this._itemsPerPage(), itemsCount);
                var $items = this._getRealItems();
                var $container = this._itemContainer();
                for (i = 0; i < duplicateCount; i++) {
                    this._cloneItemForDuplicate($items[i], $container)
                }
                for (i = 0; i < duplicateCount; i++) {
                    this._cloneItemForDuplicate($items[lastItemIndex - i], $container)
                }
            },
            _cloneItemForDuplicate: function(item, $container) {
                if (item) {
                    (0, _renderer.default)(item).clone(true).addClass(GALLERY_LOOP_ITEM_CLASS).css("margin", 0).appendTo($container)
                }
            },
            _getRealItems: function() {
                var selector = "." + GALLERY_ITEM_CLASS + ":not(." + GALLERY_LOOP_ITEM_CLASS + ")";
                return this.$element().find(selector)
            },
            _getLoopedItems: function() {
                return this.$element().find("." + GALLERY_LOOP_ITEM_CLASS)
            },
            _emptyMessageContainer: function() {
                return this._$wrapper
            },
            _renderItemSizes: function(startIndex) {
                var $items = this._itemElements();
                var itemWidth = this._actualItemWidth();
                if (void 0 !== startIndex) {
                    $items = $items.slice(startIndex)
                }
                $items.each(function(index) {
                    (0, _renderer.default)($items[index]).outerWidth(100 * itemWidth + "%")
                })
            },
            _renderItemPositions: function() {
                var itemWidth = this._actualItemWidth();
                var itemsCount = this._itemsCount();
                var itemsPerPage = this._itemsPerPage();
                var loopItemsCount = this.$element().find("." + GALLERY_LOOP_ITEM_CLASS).length;
                var lastItemDuplicateIndex = itemsCount + loopItemsCount - 1;
                var offsetRatio = this.option("wrapAround") ? .5 : 0;
                var freeSpace = this._itemFreeSpace();
                var isGapBetweenImages = !!freeSpace;
                var rtlEnabled = this.option("rtlEnabled");
                var selectedIndex = this.option("selectedIndex");
                var side = rtlEnabled ? "Right" : "Left";
                this._itemElements().each(function(index) {
                    var realIndex = index;
                    var isLoopItem = (0, _renderer.default)(this).hasClass(GALLERY_LOOP_ITEM_CLASS);
                    if (index > itemsCount + itemsPerPage - 1) {
                        realIndex = lastItemDuplicateIndex - realIndex - itemsPerPage
                    }
                    if (!isLoopItem && 0 !== realIndex) {
                        if (isGapBetweenImages) {
                            (0, _renderer.default)(this).css("margin" + side, 100 * freeSpace + "%")
                        }
                        return
                    }
                    var itemPosition = itemWidth * (realIndex + offsetRatio) + freeSpace * (realIndex + 1 - offsetRatio);
                    var property = isLoopItem ? side.toLowerCase() : "margin" + side;
                    (0, _renderer.default)(this).css(property, 100 * itemPosition + "%")
                });
                this._relocateItems(selectedIndex, selectedIndex, true)
            },
            _itemFreeSpace: function() {
                var itemsPerPage = this._itemsPerPage();
                if (this.option("wrapAround")) {
                    itemsPerPage += 1
                }
                return (1 - this._actualItemWidth() * itemsPerPage) / (itemsPerPage + 1)
            },
            _renderContainerPosition: function(offset, hideItems, animate) {
                this._releaseInvisibleItems();
                offset = offset || 0;
                var that = this;
                var itemWidth = this._actualItemWidth();
                var targetIndex = offset;
                var targetPosition = this._offsetDirection() * targetIndex * (itemWidth + this._itemFreeSpace());
                var positionReady;
                if ((0, _type.isDefined)(this._animationOverride)) {
                    animate = this._animationOverride;
                    delete this._animationOverride
                }
                if (animate) {
                    that._startSwipe();
                    positionReady = that._animate(targetPosition).done(that._endSwipe.bind(that))
                } else {
                    (0, _translator.move)(this._$container, {
                        left: targetPosition * this._elementWidth(),
                        top: 0
                    });
                    positionReady = (new _deferred.Deferred).resolveWith(that)
                }
                positionReady.done(function() {
                    this._deferredAnimate && that._deferredAnimate.resolveWith(that);
                    hideItems && this._renderItemVisibility()
                });
                return positionReady.promise()
            },
            _startSwipe: function() {
                this.$element().addClass(GALLERY_ACTIVE_CLASS)
            },
            _endSwipe: function() {
                this.$element().removeClass(GALLERY_ACTIVE_CLASS)
            },
            _animate: function(targetPosition, extraConfig) {
                var that = this;
                var $container = this._$container;
                var animationComplete = new _deferred.Deferred;
                _fx.default.animate(this._$container, (0, _extend.extend)({
                    type: "slide",
                    to: {
                        left: targetPosition * this._elementWidth()
                    },
                    duration: that.option("animationDuration"),
                    complete: function() {
                        if (that._needMoveContainerForward()) {
                            (0, _translator.move)($container, {
                                left: 0,
                                top: 0
                            })
                        }
                        if (that._needMoveContainerBack()) {
                            (0, _translator.move)($container, {
                                left: that._maxContainerOffset() * that._elementWidth(),
                                top: 0
                            })
                        }
                        animationComplete.resolveWith(that)
                    }
                }, extraConfig || {}));
                return animationComplete
            },
            _needMoveContainerForward: function() {
                var expectedPosition = this._$container.position().left * this._offsetDirection();
                var actualPosition = -this._maxItemWidth() * this._elementWidth() * this._itemsCount();
                return expectedPosition <= actualPosition + MAX_CALC_ERROR
            },
            _needMoveContainerBack: function() {
                var expectedPosition = this._$container.position().left * this._offsetDirection();
                var actualPosition = this._actualItemWidth() * this._elementWidth();
                return expectedPosition >= actualPosition - MAX_CALC_ERROR
            },
            _maxContainerOffset: function() {
                return -this._maxItemWidth() * (this._itemsCount() - this._itemsPerPage()) * this._offsetDirection()
            },
            _maxItemWidth: function() {
                return this._actualItemWidth() + this._itemFreeSpace()
            },
            _reviseDimensions: function() {
                var that = this;
                var $firstItem = that._itemElements().first().find(".dx-item-content");
                if (!$firstItem || $firstItem.is(":hidden")) {
                    return
                }
                if (!that.option("height")) {
                    that.option("height", $firstItem.outerHeight())
                }
                if (!that.option("width")) {
                    that.option("width", $firstItem.outerWidth())
                }
                this._dimensionChanged()
            },
            _renderIndicator: function() {
                this._cleanIndicators();
                if (!this.option("showIndicator")) {
                    return
                }
                var indicator = this._$indicator = (0, _renderer.default)("<div>").addClass(GALLERY_INDICATOR_CLASS).appendTo(this._$wrapper);
                var isIndicatorEnabled = this.option("indicatorEnabled");
                for (var i = 0; i < this._pagesCount(); i++) {
                    var $indicatorItem = (0, _renderer.default)("<div>").addClass(GALLERY_INDICATOR_ITEM_CLASS).appendTo(indicator);
                    if (isIndicatorEnabled) {
                        this._attachIndicatorClickHandler($indicatorItem, i)
                    }
                }
                this._renderSelectedPageIndicator()
            },
            _attachIndicatorClickHandler: function($element, index) {
                _events_engine.default.on($element, (0, _index.addNamespace)(_click.name, this.NAME), function(event) {
                    this._indicatorSelectHandler(event, index)
                }.bind(this))
            },
            _detachIndicatorClickHandler: function($element) {
                _events_engine.default.off($element, (0, _index.addNamespace)(_click.name, this.NAME))
            },
            _toggleIndicatorInteraction: function(clickEnabled) {
                var _this$_$indicator;
                var $indicatorItems = (null === (_this$_$indicator = this._$indicator) || void 0 === _this$_$indicator ? void 0 : _this$_$indicator.find(GALLERY_INDICATOR_ITEM_SELECTOR)) || [];
                if ($indicatorItems.length) {
                    $indicatorItems.each(function(index, element) {
                        clickEnabled ? this._attachIndicatorClickHandler((0, _renderer.default)(element), index) : this._detachIndicatorClickHandler((0, _renderer.default)(element))
                    }.bind(this))
                }
            },
            _cleanIndicators: function() {
                if (this._$indicator) {
                    this._$indicator.remove()
                }
            },
            _renderSelectedItem: function() {
                var selectedIndex = this.option("selectedIndex");
                this._itemElements().removeClass(GALLERY_ITEM_SELECTED_CLASS).eq(selectedIndex).addClass(GALLERY_ITEM_SELECTED_CLASS)
            },
            _renderItemVisibility: function() {
                if (this.option("initialItemWidth") || this.option("wrapAround")) {
                    this._releaseInvisibleItems();
                    return
                }
                this._itemElements().each(function(index, item) {
                    if (this.option("selectedIndex") === index) {
                        (0, _renderer.default)(item).removeClass(GALLERY_INVISIBLE_ITEM_CLASS)
                    } else {
                        (0, _renderer.default)(item).addClass(GALLERY_INVISIBLE_ITEM_CLASS)
                    }
                }.bind(this));
                this._getLoopedItems().addClass(GALLERY_INVISIBLE_ITEM_CLASS)
            },
            _releaseInvisibleItems: function() {
                this._itemElements().removeClass(GALLERY_INVISIBLE_ITEM_CLASS);
                this._getLoopedItems().removeClass(GALLERY_INVISIBLE_ITEM_CLASS)
            },
            _renderSelectedPageIndicator: function() {
                if (!this._$indicator) {
                    return
                }
                var itemIndex = this.option("selectedIndex");
                var lastIndex = this._pagesCount() - 1;
                var pageIndex = Math.ceil(itemIndex / this._itemsPerPage());
                pageIndex = Math.min(lastIndex, pageIndex);
                this._$indicator.find(GALLERY_INDICATOR_ITEM_SELECTOR).removeClass(GALLERY_INDICATOR_ITEM_SELECTED_CLASS).eq(pageIndex).addClass(GALLERY_INDICATOR_ITEM_SELECTED_CLASS)
            },
            _renderUserInteraction: function() {
                var rootElement = this.$element();
                var swipeEnabled = this.option("swipeEnabled") && this._itemsCount() > 1;
                this._createComponent(rootElement, _swipeable.default, {
                    disabled: this.option("disabled") || !swipeEnabled,
                    onStart: this._swipeStartHandler.bind(this),
                    onUpdated: this._swipeUpdateHandler.bind(this),
                    onEnd: this._swipeEndHandler.bind(this),
                    itemSizeFunc: this._elementWidth.bind(this)
                })
            },
            _indicatorSelectHandler: function(e, indicatorIndex) {
                if (!this.option("indicatorEnabled")) {
                    return
                }
                var itemIndex = this._fitPaginatedIndex(indicatorIndex * this._itemsPerPage());
                this._needLongMove = true;
                this.option("selectedIndex", itemIndex);
                this._loadNextPageIfNeeded(itemIndex)
            },
            _renderNavButtons: function() {
                var that = this;
                if (!that.option("showNavButtons")) {
                    that._cleanNavButtons();
                    return
                }
                that._prevNavButton = (0, _renderer.default)("<div>").appendTo(this._$wrapper);
                that._createComponent(that._prevNavButton, GalleryNavButton, {
                    direction: "prev",
                    onClick: function() {
                        that._prevPage()
                    }
                });
                that._nextNavButton = (0, _renderer.default)("<div>").appendTo(this._$wrapper);
                that._createComponent(that._nextNavButton, GalleryNavButton, {
                    direction: "next",
                    onClick: function() {
                        that._nextPage()
                    }
                });
                this._renderNavButtonsVisibility()
            },
            _prevPage: function() {
                var visiblePageSize = this._itemsPerPage();
                var newSelectedIndex = this.option("selectedIndex") - visiblePageSize;
                if (newSelectedIndex === -visiblePageSize && visiblePageSize === this._itemsCount()) {
                    return this._relocateItems(newSelectedIndex, 0)
                } else {
                    return this.goToItem(this._fitPaginatedIndex(newSelectedIndex))
                }
            },
            _nextPage: function() {
                var visiblePageSize = this._itemsPerPage();
                var newSelectedIndex = this.option("selectedIndex") + visiblePageSize;
                if (newSelectedIndex === visiblePageSize && visiblePageSize === this._itemsCount()) {
                    return this._relocateItems(newSelectedIndex, 0)
                } else {
                    return this.goToItem(this._fitPaginatedIndex(newSelectedIndex)).done(this._loadNextPageIfNeeded)
                }
            },
            _loadNextPageIfNeeded: function(selectedIndex) {
                selectedIndex = void 0 === selectedIndex ? this.option("selectedIndex") : selectedIndex;
                if (this._dataSource && this._dataSource.paginate() && this._shouldLoadNextPage(selectedIndex) && !this._isDataSourceLoading() && !this._isLastPage()) {
                    this._loadNextPage().done(function() {
                        this._renderIndicator();
                        this._cloneDuplicateItems();
                        this._renderItemPositions();
                        this._renderNavButtonsVisibility();
                        this._renderItemSizes(selectedIndex)
                    }.bind(this))
                }
            },
            _shouldLoadNextPage: function(selectedIndex) {
                var visiblePageSize = this._itemsPerPage();
                return selectedIndex + 2 * visiblePageSize > this.option("items").length
            },
            _allowDynamicItemsAppend: function() {
                return true
            },
            _fitPaginatedIndex: function(itemIndex) {
                var itemsPerPage = this._itemsPerPage();
                var restItemsCount = itemIndex < 0 ? itemsPerPage + itemIndex : this._itemsCount() - itemIndex;
                if (itemIndex > this._itemsCount() - 1) {
                    itemIndex = 0;
                    this._goToGhostItem = true
                } else {
                    if (restItemsCount < itemsPerPage && restItemsCount > 0) {
                        if (itemIndex > 0) {
                            itemIndex -= itemsPerPage - restItemsCount
                        } else {
                            itemIndex += itemsPerPage - restItemsCount
                        }
                    }
                }
                return itemIndex
            },
            _cleanNavButtons: function() {
                if (this._prevNavButton) {
                    this._prevNavButton.remove();
                    delete this._prevNavButton
                }
                if (this._nextNavButton) {
                    this._nextNavButton.remove();
                    delete this._nextNavButton
                }
            },
            _renderNavButtonsVisibility: function() {
                if (!this.option("showNavButtons") || !this._prevNavButton || !this._nextNavButton) {
                    return
                }
                var selectedIndex = this.option("selectedIndex");
                var loop = this.option("loop");
                var itemsCount = this._itemsCount();
                this._prevNavButton.show();
                this._nextNavButton.show();
                if (0 === itemsCount) {
                    this._prevNavButton.hide();
                    this._nextNavButton.hide()
                }
                if (loop) {
                    return
                }
                var nextHidden = selectedIndex === itemsCount - this._itemsPerPage();
                var prevHidden = itemsCount < 2 || 0 === selectedIndex;
                if (this._dataSource && this._dataSource.paginate()) {
                    nextHidden = nextHidden && this._isLastPage()
                } else {
                    nextHidden = nextHidden || itemsCount < 2
                }
                if (prevHidden) {
                    this._prevNavButton.hide()
                }
                if (nextHidden) {
                    this._nextNavButton.hide()
                }
            },
            _setupSlideShow: function() {
                var that = this;
                var slideshowDelay = that.option("slideshowDelay");
                clearTimeout(that._slideshowTimer);
                if (!slideshowDelay) {
                    return
                }
                that._slideshowTimer = setTimeout(function() {
                    if (that._userInteraction) {
                        that._setupSlideShow();
                        return
                    }
                    that.nextItem(true).done(that._setupSlideShow)
                }, slideshowDelay)
            },
            _elementWidth: function() {
                if (!this._cacheElementWidth) {
                    this._cacheElementWidth = this.$element().width()
                }
                return this._cacheElementWidth
            },
            _clearCacheWidth: function() {
                delete this._cacheElementWidth
            },
            _swipeStartHandler: function(e) {
                this._releaseInvisibleItems();
                this._clearCacheWidth();
                this._elementWidth();
                var itemsCount = this._itemsCount();
                if (!itemsCount) {
                    e.event.cancel = true;
                    return
                }
                this._stopItemAnimations();
                this._startSwipe();
                this._userInteraction = true;
                if (!this.option("loop")) {
                    var selectedIndex = this.option("selectedIndex");
                    var startOffset = itemsCount - selectedIndex - this._itemsPerPage();
                    var endOffset = selectedIndex;
                    var rtlEnabled = this.option("rtlEnabled");
                    e.event.maxLeftOffset = rtlEnabled ? endOffset : startOffset;
                    e.event.maxRightOffset = rtlEnabled ? startOffset : endOffset
                }
            },
            _stopItemAnimations: function() {
                _fx.default.stop(this._$container, true)
            },
            _swipeUpdateHandler: function(e) {
                var wrapAroundRatio = this.option("wrapAround") ? 1 : 0;
                var offset = this._offsetDirection() * e.event.offset * (this._itemsPerPage() + wrapAroundRatio) - this.option("selectedIndex");
                if (offset < 0) {
                    this._loadNextPageIfNeeded(Math.ceil(Math.abs(offset)))
                }
                this._renderContainerPosition(offset)
            },
            _swipeEndHandler: function(e) {
                var targetOffset = e.event.targetOffset * this._offsetDirection() * this._itemsPerPage();
                var selectedIndex = this.option("selectedIndex");
                var newIndex = this._fitIndex(selectedIndex - targetOffset);
                var paginatedIndex = this._fitPaginatedIndex(newIndex);
                if (Math.abs(targetOffset) < this._itemsPerPage()) {
                    this._relocateItems(selectedIndex);
                    return
                }
                if (this._itemsPerPage() === this._itemsCount()) {
                    if (targetOffset > 0) {
                        this._relocateItems(-targetOffset)
                    } else {
                        this._relocateItems(0)
                    }
                    return
                }
                this.option("selectedIndex", paginatedIndex)
            },
            _setFocusOnSelect: function() {
                this._userInteraction = true;
                var selectedItem = this.itemElements().filter("." + GALLERY_ITEM_SELECTED_CLASS);
                this.option("focusedElement", (0, _element.getPublicElement)(selectedItem));
                this._userInteraction = false
            },
            _flipIndex: function(index) {
                var itemsCount = this._itemsCount();
                index %= itemsCount;
                if (index > (itemsCount + 1) / 2) {
                    index -= itemsCount
                }
                if (index < -(itemsCount - 1) / 2) {
                    index += itemsCount
                }
                return index
            },
            _fitIndex: function(index) {
                if (!this.option("loop")) {
                    return index
                }
                var itemsCount = this._itemsCount();
                if (index >= itemsCount || index < 0) {
                    this._goToGhostItem = true
                }
                if (index >= itemsCount) {
                    index = itemsCount - index
                }
                index %= itemsCount;
                if (index < 0) {
                    index += itemsCount
                }
                return index
            },
            _clean: function() {
                this.callBase();
                this._cleanIndicators();
                this._cleanNavButtons()
            },
            _dispose: function() {
                clearTimeout(this._slideshowTimer);
                this.callBase()
            },
            _updateSelection: function(addedSelection, removedSelection) {
                this._stopItemAnimations();
                this._renderNavButtonsVisibility();
                this._renderSelectedItem();
                this._relocateItems(addedSelection[0], removedSelection[0]);
                this._renderSelectedPageIndicator()
            },
            _relocateItems: function(newIndex, prevIndex, withoutAnimation) {
                if (void 0 === prevIndex) {
                    prevIndex = newIndex
                }
                var indexOffset = this._calculateIndexOffset(newIndex, prevIndex);
                this._renderContainerPosition(indexOffset, true, this.option("animationEnabled") && !withoutAnimation).done(function() {
                    this._setFocusOnSelect();
                    this._userInteraction = false;
                    this._setupSlideShow()
                })
            },
            _focusInHandler: function() {
                if (_fx.default.isAnimating(this._$container) || this._userInteraction) {
                    return
                }
                this.callBase.apply(this, arguments)
            },
            _focusOutHandler: function() {
                if (_fx.default.isAnimating(this._$container) || this._userInteraction) {
                    return
                }
                this.callBase.apply(this, arguments)
            },
            _selectFocusedItem: _common.noop,
            _moveFocus: function() {
                this._stopItemAnimations();
                this.callBase.apply(this, arguments);
                var index = this.itemElements().index((0, _renderer.default)(this.option("focusedElement")));
                this.goToItem(index, this.option("animationEnabled"))
            },
            _visibilityChanged: function(visible) {
                if (visible) {
                    this._reviseDimensions()
                }
            },
            _calculateIndexOffset: function(newIndex, lastIndex) {
                if (void 0 === lastIndex) {
                    lastIndex = newIndex
                }
                var indexOffset = lastIndex - newIndex;
                if (this.option("loop") && !this._needLongMove && this._goToGhostItem) {
                    if (this._isItemOnFirstPage(newIndex) && this._isItemOnLastPage(lastIndex)) {
                        indexOffset = -this._itemsPerPage()
                    } else {
                        if (this._isItemOnLastPage(newIndex) && this._isItemOnFirstPage(lastIndex)) {
                            indexOffset = this._itemsPerPage()
                        }
                    }
                    this._goToGhostItem = false
                }
                this._needLongMove = false;
                indexOffset -= lastIndex;
                return indexOffset
            },
            _isItemOnLastPage: function(itemIndex) {
                return itemIndex >= this._itemsCount() - this._itemsPerPage()
            },
            _isItemOnFirstPage: function(itemIndex) {
                return itemIndex <= this._itemsPerPage()
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "width":
                    case "initialItemWidth":
                        this.callBase.apply(this, arguments);
                        this._dimensionChanged();
                        break;
                    case "animationDuration":
                        this._renderNavButtonsVisibility();
                        break;
                    case "animationEnabled":
                        break;
                    case "loop":
                        this.$element().toggleClass(GALLERY_LOOP_CLASS, args.value);
                        this.option("loopItemFocus", args.value);
                        if ((0, _window.hasWindow)()) {
                            this._cloneDuplicateItems();
                            this._renderItemPositions();
                            this._renderNavButtonsVisibility()
                        }
                        break;
                    case "showIndicator":
                        this._renderIndicator();
                        break;
                    case "showNavButtons":
                        this._renderNavButtons();
                        break;
                    case "slideshowDelay":
                        this._setupSlideShow();
                        break;
                    case "wrapAround":
                    case "stretchImages":
                        if ((0, _window.hasWindow)()) {
                            this._renderItemSizes();
                            this._renderItemPositions();
                            this._renderItemVisibility()
                        }
                        break;
                    case "swipeEnabled":
                        this._renderUserInteraction();
                        break;
                    case "indicatorEnabled":
                        this._toggleIndicatorInteraction(args.value);
                        break;
                    default:
                        this.callBase(args)
                }
            },
            goToItem: function(itemIndex, animation) {
                var selectedIndex = this.option("selectedIndex");
                var itemsCount = this._itemsCount();
                if (void 0 !== animation) {
                    this._animationOverride = animation
                }
                itemIndex = this._fitIndex(itemIndex);
                this._deferredAnimate = new _deferred.Deferred;
                if (itemIndex > itemsCount - 1 || itemIndex < 0 || selectedIndex === itemIndex) {
                    return this._deferredAnimate.resolveWith(this).promise()
                }
                this.option("selectedIndex", itemIndex);
                return this._deferredAnimate.promise()
            },
            prevItem: function(animation) {
                return this.goToItem(this.option("selectedIndex") - 1, animation)
            },
            nextItem: function(animation) {
                return this.goToItem(this.option("selectedIndex") + 1, animation)
            }
        });
        (0, _component_registrator.default)("dxGallery", Gallery);
        var _default = Gallery;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/html_editor.js ***!
      \****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./html_editor/ui.html_editor */ 646));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _ui.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/html_editor/ui.html_editor.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _element = __webpack_require__( /*! ../../core/element */ 18);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _empty_template = __webpack_require__( /*! ../../core/templates/empty_template */ 91);
        var _editor = _interopRequireDefault(__webpack_require__( /*! ../editor/editor */ 52));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/callbacks */ 27));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _index2 = __webpack_require__( /*! ../../events/index */ 327);
        var _uiEventsEmitterGesture = _interopRequireDefault(__webpack_require__( /*! ../scroll_view/ui.events.emitter.gesture.scroll */ 272));
        var _utils = __webpack_require__( /*! ../text_box/utils.scroll */ 286);
        var _quill_registrator = _interopRequireDefault(__webpack_require__( /*! ./quill_registrator */ 647));
        __webpack_require__( /*! ./converters/delta */ 666);
        var _converterController = _interopRequireDefault(__webpack_require__( /*! ./converterController */ 287));
        var _wordLists = _interopRequireDefault(__webpack_require__( /*! ./matchers/wordLists */ 667));
        var _formDialog = _interopRequireDefault(__webpack_require__( /*! ./ui/formDialog */ 668));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }
        var HTML_EDITOR_CLASS = "dx-htmleditor";
        var QUILL_CONTAINER_CLASS = "dx-quill-container";
        var QUILL_CLIPBOARD_CLASS = "ql-clipboard";
        var HTML_EDITOR_SUBMIT_ELEMENT_CLASS = "dx-htmleditor-submit-element";
        var HTML_EDITOR_CONTENT_CLASS = "dx-htmleditor-content";
        var MARKDOWN_VALUE_TYPE = "markdown";
        var ANONYMOUS_TEMPLATE_NAME = "htmlContent";
        var HtmlEditor = _editor.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    focusStateEnabled: true,
                    valueType: "html",
                    placeholder: "",
                    toolbar: null,
                    variables: null,
                    mediaResizing: null,
                    mentions: null,
                    customizeModules: null,
                    formDialogOptions: null
                })
            },
            _init: function() {
                this.callBase();
                this._cleanCallback = (0, _callbacks.default)();
                this._contentInitializedCallback = (0, _callbacks.default)()
            },
            _getAnonymousTemplateName: function() {
                return ANONYMOUS_TEMPLATE_NAME
            },
            _initTemplates: function() {
                this._templateManager.addDefaultTemplates(_defineProperty({}, ANONYMOUS_TEMPLATE_NAME, new _empty_template.EmptyTemplate));
                this.callBase()
            },
            _focusTarget: function() {
                return this._getContent()
            },
            _getContent: function() {
                return this.$element().find(".".concat(HTML_EDITOR_CONTENT_CLASS))
            },
            _focusInHandler: function(_ref) {
                var relatedTarget = _ref.relatedTarget;
                if (this._shouldSkipFocusEvent(relatedTarget)) {
                    return
                }
                this._toggleFocusClass(true, this.$element());
                this.callBase.apply(this, arguments)
            },
            _focusOutHandler: function(_ref2) {
                var relatedTarget = _ref2.relatedTarget;
                if (this._shouldSkipFocusEvent(relatedTarget)) {
                    return
                }
                this._toggleFocusClass(false, this.$element());
                this.callBase.apply(this, arguments)
            },
            _shouldSkipFocusEvent: function(relatedTarget) {
                return (0, _renderer.default)(relatedTarget).hasClass(QUILL_CLIPBOARD_CLASS)
            },
            _initMarkup: function() {
                this._$htmlContainer = (0, _renderer.default)("<div>").addClass(QUILL_CONTAINER_CLASS);
                this.$element().addClass(HTML_EDITOR_CLASS).wrapInner(this._$htmlContainer);
                var template = this._getTemplate(ANONYMOUS_TEMPLATE_NAME);
                var transclude = true;
                this._$templateResult = template && template.render({
                    container: (0, _element.getPublicElement)(this._$htmlContainer),
                    noModel: true,
                    transclude: transclude
                });
                this._renderSubmitElement();
                this.callBase();
                this._updateContainerMarkup()
            },
            _renderSubmitElement: function() {
                this._$submitElement = (0, _renderer.default)("<textarea>").addClass(HTML_EDITOR_SUBMIT_ELEMENT_CLASS).attr("hidden", true).appendTo(this.$element());
                this._setSubmitValue(this.option("value"))
            },
            _setSubmitValue: function(value) {
                this._getSubmitElement().val(value)
            },
            _getSubmitElement: function() {
                return this._$submitElement
            },
            _updateContainerMarkup: function() {
                var markup = this.option("value");
                if (this._isMarkdownValue()) {
                    this._prepareMarkdownConverter();
                    markup = this._markdownConverter.toHtml(markup)
                }
                if (markup) {
                    this._$htmlContainer.html(markup)
                }
            },
            _prepareMarkdownConverter: function() {
                var MarkdownConverter = _converterController.default.getConverter("markdown");
                if (MarkdownConverter) {
                    this._markdownConverter = new MarkdownConverter
                } else {
                    throw _ui.default.Error("E1051", "markdown")
                }
            },
            _render: function() {
                this._prepareConverters();
                this.callBase()
            },
            _prepareQuillRegistrator: function() {
                if (!this._quillRegistrator) {
                    this._quillRegistrator = new _quill_registrator.default
                }
            },
            _getRegistrator: function() {
                this._prepareQuillRegistrator();
                return this._quillRegistrator
            },
            _prepareConverters: function() {
                if (!this._deltaConverter) {
                    var DeltaConverter = _converterController.default.getConverter("delta");
                    if (DeltaConverter) {
                        this._deltaConverter = new DeltaConverter
                    }
                }
                if (this.option("valueType") === MARKDOWN_VALUE_TYPE && !this._markdownConverter) {
                    this._prepareMarkdownConverter()
                }
            },
            _renderContentImpl: function() {
                this._contentRenderedDeferred = new _deferred.Deferred;
                var renderContentPromise = this._contentRenderedDeferred.promise();
                this.callBase();
                this._renderHtmlEditor();
                this._renderFormDialog();
                this._addKeyPressHandler();
                return renderContentPromise
            },
            _attachFocusEvents: function() {
                (0, _common.deferRender)(this.callBase.bind(this))
            },
            _addKeyPressHandler: function() {
                var keyDownEvent = (0, _index.addNamespace)("keydown", "".concat(this.NAME, "TextChange"));
                _events_engine.default.on(this._$htmlContainer, keyDownEvent, this._keyDownHandler.bind(this))
            },
            _keyDownHandler: function(e) {
                this._saveValueChangeEvent(e)
            },
            _renderHtmlEditor: function() {
                var _this = this;
                var customizeModules = this.option("customizeModules");
                var modulesConfig = this._getModulesConfig();
                if ((0, _type.isFunction)(customizeModules)) {
                    customizeModules(modulesConfig)
                }
                this._quillInstance = this._getRegistrator().createEditor(this._$htmlContainer[0], {
                    placeholder: this.option("placeholder"),
                    readOnly: this.option("readOnly") || this.option("disabled"),
                    modules: modulesConfig,
                    theme: "basic"
                });
                this._deltaConverter.setQuillInstance(this._quillInstance);
                this._textChangeHandlerWithContext = this._textChangeHandler.bind(this);
                this._quillInstance.on("text-change", this._textChangeHandlerWithContext);
                this._renderScrollHandler();
                if (this._hasTranscludedContent()) {
                    this._updateContentTask = (0, _common.executeAsync)(function() {
                        _this._applyTranscludedContent()
                    })
                } else {
                    this._finalizeContentRendering()
                }
            },
            _renderScrollHandler: function() {
                var $scrollContainer = this._getContent();
                var initScrollData = (0, _utils.prepareScrollData)($scrollContainer);
                _events_engine.default.on($scrollContainer, (0, _index.addNamespace)(_uiEventsEmitterGesture.default.init, this.NAME), initScrollData, _common.noop)
            },
            _applyTranscludedContent: function() {
                var valueOption = this.option("value");
                if (!(0, _type.isDefined)(valueOption)) {
                    var html = this._deltaConverter.toHtml();
                    var newDelta = this._quillInstance.clipboard.convert({
                        html: html
                    });
                    if (newDelta.ops.length) {
                        this._quillInstance.setContents(newDelta);
                        return
                    }
                }
                this._finalizeContentRendering()
            },
            _hasTranscludedContent: function() {
                return this._$templateResult && this._$templateResult.length
            },
            _getModulesConfig: function() {
                var _this2 = this;
                var quill = this._getRegistrator().getQuill();
                var wordListMatcher = (0, _wordLists.default)(quill);
                var modulesConfig = (0, _extend.extend)({}, {
                    table: true,
                    toolbar: this._getModuleConfigByOption("toolbar"),
                    variables: this._getModuleConfigByOption("variables"),
                    resizing: this._getModuleConfigByOption("mediaResizing"),
                    mentions: this._getModuleConfigByOption("mentions"),
                    uploader: {
                        onDrop: function(e) {
                            return _this2._saveValueChangeEvent((0, _index2.Event)(e))
                        },
                        imageBlot: "extendedImage"
                    },
                    keyboard: {
                        onKeydown: function(e) {
                            return _this2._saveValueChangeEvent((0, _index2.Event)(e))
                        }
                    },
                    clipboard: {
                        onPaste: function(e) {
                            return _this2._saveValueChangeEvent((0, _index2.Event)(e))
                        },
                        onCut: function(e) {
                            return _this2._saveValueChangeEvent((0, _index2.Event)(e))
                        },
                        matchers: [
                            ["p.MsoListParagraphCxSpFirst", wordListMatcher],
                            ["p.MsoListParagraphCxSpMiddle", wordListMatcher],
                            ["p.MsoListParagraphCxSpLast", wordListMatcher]
                        ]
                    }
                }, this._getCustomModules());
                return modulesConfig
            },
            _getModuleConfigByOption: function(userOptionName) {
                var optionValue = this.option(userOptionName);
                var config = {};
                if (!(0, _type.isDefined)(optionValue)) {
                    return
                }
                if (Array.isArray(optionValue)) {
                    config[userOptionName] = optionValue
                } else {
                    config = optionValue
                }
                return (0, _extend.extend)(this._getBaseModuleConfig(), config)
            },
            _getBaseModuleConfig: function() {
                return {
                    editorInstance: this
                }
            },
            _getCustomModules: function() {
                var _this3 = this;
                var modules = {};
                var moduleNames = this._getRegistrator().getRegisteredModuleNames();
                moduleNames.forEach(function(modulePath) {
                    modules[modulePath] = _this3._getBaseModuleConfig()
                });
                return modules
            },
            _textChangeHandler: function(newDelta, oldDelta, source) {
                var htmlMarkup = this._deltaConverter.toHtml();
                var convertedValue = this._isMarkdownValue() ? this._updateValueByType(MARKDOWN_VALUE_TYPE, htmlMarkup) : htmlMarkup;
                var currentValue = this.option("value");
                if (currentValue !== convertedValue && !this._isNullValueConverted(currentValue, convertedValue)) {
                    this._isEditorUpdating = true;
                    this.option("value", convertedValue)
                }
                this._finalizeContentRendering()
            },
            _isNullValueConverted: function(currentValue, convertedValue) {
                return null === currentValue && "" === convertedValue
            },
            _finalizeContentRendering: function() {
                if (this._contentRenderedDeferred) {
                    this.clearHistory();
                    this._contentInitializedCallback.fire();
                    this._contentRenderedDeferred.resolve();
                    this._contentRenderedDeferred = void 0
                }
            },
            _updateValueByType: function(valueType, value) {
                var converter = this._markdownConverter;
                if (!(0, _type.isDefined)(converter)) {
                    return
                }
                var currentValue = (0, _common.ensureDefined)(value, this.option("value"));
                return valueType === MARKDOWN_VALUE_TYPE ? converter.toMarkdown(currentValue) : converter.toHtml(currentValue)
            },
            _isMarkdownValue: function() {
                return this.option("valueType") === MARKDOWN_VALUE_TYPE
            },
            _resetEnabledState: function() {
                if (this._quillInstance) {
                    var isEnabled = !(this.option("readOnly") || this.option("disabled"));
                    this._quillInstance.enable(isEnabled)
                }
            },
            _renderFormDialog: function() {
                var userOptions = (0, _extend.extend)(true, {
                    width: "auto",
                    height: "auto",
                    closeOnOutsideClick: true
                }, this.option("formDialogOptions"));
                this._formDialog = new _formDialog.default(this, userOptions)
            },
            _getQuillContainer: function() {
                return this._$htmlContainer
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "value":
                        if (this._quillInstance) {
                            if (this._isEditorUpdating) {
                                this._isEditorUpdating = false
                            } else {
                                var updatedValue = this._isMarkdownValue() ? this._updateValueByType("HTML", args.value) : args.value;
                                this._updateHtmlContent(updatedValue)
                            }
                        } else {
                            this._$htmlContainer.html(args.value)
                        }
                        this._setSubmitValue(args.value);
                        this.callBase(args);
                        break;
                    case "placeholder":
                    case "variables":
                    case "toolbar":
                    case "mentions":
                    case "customizeModules":
                        this._invalidate();
                        break;
                    case "valueType":
                        this._prepareConverters();
                        var newValue = this._updateValueByType(args.value);
                        if ("html" === args.value && this._quillInstance) {
                            this._updateHtmlContent(newValue)
                        } else {
                            this.option("value", newValue)
                        }
                        break;
                    case "readOnly":
                    case "disabled":
                        this.callBase(args);
                        this._resetEnabledState();
                        break;
                    case "formDialogOptions":
                        this._renderFormDialog();
                        break;
                    case "mediaResizing":
                        if (!args.previousValue || !args.value) {
                            this._invalidate()
                        } else {
                            this._quillInstance.getModule("resizing").option(args.name, args.value)
                        }
                        break;
                    case "width":
                        this.callBase(args);
                        this._repaintToolbar();
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _repaintToolbar: function() {
                var toolbar = this._quillInstance.getModule("toolbar");
                toolbar && toolbar.repaint()
            },
            _updateHtmlContent: function(html) {
                var newDelta = this._quillInstance.clipboard.convert({
                    html: html
                });
                this._quillInstance.setContents(newDelta)
            },
            _clean: function() {
                if (this._quillInstance) {
                    _events_engine.default.off(this._getContent(), ".".concat(this.NAME));
                    this._quillInstance.off("text-change", this._textChangeHandlerWithContext);
                    this._cleanCallback.fire()
                }
                this._abortUpdateContentTask();
                this._cleanCallback.empty();
                this._contentInitializedCallback.empty();
                this.callBase()
            },
            _abortUpdateContentTask: function() {
                if (this._updateContentTask) {
                    this._updateContentTask.abort();
                    this._updateContentTask = void 0
                }
            },
            _applyQuillMethod: function(methodName, args) {
                if (this._quillInstance) {
                    return this._quillInstance[methodName].apply(this._quillInstance, args)
                }
            },
            _applyQuillHistoryMethod: function(methodName) {
                if (this._quillInstance && this._quillInstance.history) {
                    this._quillInstance.history[methodName]()
                }
            },
            addCleanCallback: function(callback) {
                this._cleanCallback.add(callback)
            },
            addContentInitializedCallback: function(callback) {
                this._contentInitializedCallback.add(callback)
            },
            register: function(components) {
                this._getRegistrator().registerModules(components);
                if (this._quillInstance) {
                    this.repaint()
                }
            },
            get: function(modulePath) {
                return this._getRegistrator().getQuill().import(modulePath)
            },
            getModule: function(moduleName) {
                return this._applyQuillMethod("getModule", arguments)
            },
            getQuillInstance: function() {
                return this._quillInstance
            },
            getSelection: function() {
                return this._applyQuillMethod("getSelection")
            },
            setSelection: function(index, length) {
                this._applyQuillMethod("setSelection", arguments)
            },
            format: function(formatName, formatValue) {
                this._applyQuillMethod("format", arguments)
            },
            formatText: function(index, length, formatName, formatValue) {
                this._applyQuillMethod("formatText", arguments)
            },
            formatLine: function(index, length, formatName, formatValue) {
                this._applyQuillMethod("formatLine", arguments)
            },
            getFormat: function(index, length) {
                return this._applyQuillMethod("getFormat", arguments)
            },
            removeFormat: function(index, length) {
                return this._applyQuillMethod("removeFormat", arguments)
            },
            clearHistory: function() {
                this._applyQuillHistoryMethod("clear")
            },
            undo: function() {
                this._applyQuillHistoryMethod("undo")
            },
            redo: function() {
                this._applyQuillHistoryMethod("redo")
            },
            getLength: function() {
                return this._applyQuillMethod("getLength")
            },
            "delete": function(index, length) {
                this._applyQuillMethod("deleteText", arguments)
            },
            insertText: function(index, text, formats) {
                this._applyQuillMethod("insertText", arguments)
            },
            insertEmbed: function(index, type, config) {
                this._applyQuillMethod("insertEmbed", arguments)
            },
            showFormDialog: function(formConfig) {
                return this._formDialog.show(formConfig)
            },
            formDialogOption: function(optionName, optionValue) {
                return this._formDialog.popupOption.apply(this._formDialog, arguments)
            },
            focus: function() {
                this.callBase();
                this._applyQuillMethod("focus")
            }
        });
        (0, _component_registrator.default)("dxHtmlEditor", HtmlEditor);
        var _default = HtmlEditor;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/html_editor/quill_registrator.js ***!
      \**********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _quill_importer = __webpack_require__( /*! ./quill_importer */ 648);
        var _base = _interopRequireDefault(__webpack_require__( /*! ./themes/base */ 649));
        var _image = _interopRequireDefault(__webpack_require__( /*! ./formats/image */ 650));
        var _link = _interopRequireDefault(__webpack_require__( /*! ./formats/link */ 651));
        var _font = _interopRequireDefault(__webpack_require__( /*! ./formats/font */ 652));
        var _size = _interopRequireDefault(__webpack_require__( /*! ./formats/size */ 653));
        var _align = _interopRequireDefault(__webpack_require__( /*! ./formats/align */ 654));
        var _toolbar = _interopRequireDefault(__webpack_require__( /*! ./modules/toolbar */ 655));
        var _dropImage = _interopRequireDefault(__webpack_require__( /*! ./modules/dropImage */ 660));
        var _variables = _interopRequireDefault(__webpack_require__( /*! ./modules/variables */ 661));
        var _resizing = _interopRequireDefault(__webpack_require__( /*! ./modules/resizing */ 663));
        var _mentions = _interopRequireDefault(__webpack_require__( /*! ./modules/mentions */ 664));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var QuillRegistrator = function() {
            function QuillRegistrator() {
                if (QuillRegistrator.initialized) {
                    return
                }
                var quill = this.getQuill();
                var DirectionStyle = quill.import("attributors/style/direction");
                quill.register({
                    "formats/align": _align.default,
                    "formats/direction": DirectionStyle,
                    "formats/font": _font.default,
                    "formats/size": _size.default,
                    "formats/extendedImage": _image.default,
                    "formats/link": _link.default,
                    "modules/toolbar": _toolbar.default,
                    "modules/dropImage": _dropImage.default,
                    "modules/variables": _variables.default,
                    "modules/resizing": _resizing.default,
                    "modules/mentions": _mentions.default,
                    "themes/basic": _base.default
                }, true);
                this._customModules = [];
                QuillRegistrator._initialized = true
            }
            var _proto = QuillRegistrator.prototype;
            _proto.createEditor = function(container, config) {
                var quill = this.getQuill();
                return new quill(container, config)
            };
            _proto.registerModules = function(modulesConfig) {
                var isModule = RegExp("modules/*");
                var quill = this.getQuill();
                var isRegisteredModule = function(modulePath) {
                    return !!quill.imports[modulePath]
                };
                for (var modulePath in modulesConfig) {
                    if (isModule.test(modulePath) && !isRegisteredModule(modulePath)) {
                        this._customModules.push(modulePath.slice(8))
                    }
                }
                quill.register(modulesConfig, true)
            };
            _proto.getRegisteredModuleNames = function() {
                return this._customModules
            };
            _proto.getQuill = function() {
                return (0, _quill_importer.getQuill)()
            };
            return QuillRegistrator
        }();
        var _default = QuillRegistrator;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/html_editor/quill_importer.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getQuill = getQuill;
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _devextremeQuill = _interopRequireDefault(__webpack_require__( /*! devextreme-quill */ 61));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function getQuill() {
            if (!_devextremeQuill.default) {
                throw _ui.default.Error("E1041", "Quill")
            }
            return _devextremeQuill.default
        }
    },
    /*!****************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/html_editor/themes/base.js ***!
      \****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _devextremeQuill = _interopRequireDefault(__webpack_require__( /*! devextreme-quill */ 61));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var BaseTheme;
        if (_devextremeQuill.default) {
            var Theme = _devextremeQuill.default.import("core/theme");
            BaseTheme = function(_Theme) {
                _inheritsLoose(BaseTheme, _Theme);

                function BaseTheme(quill, options) {
                    var _this;
                    _this = _Theme.call(this, quill, options) || this;
                    _this.quill.root.classList.add("dx-htmleditor-content");
                    return _this
                }
                return BaseTheme
            }(Theme)
        } else {
            BaseTheme = {}
        }
        var _default = BaseTheme;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/html_editor/formats/image.js ***!
      \******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _devextremeQuill = _interopRequireDefault(__webpack_require__( /*! devextreme-quill */ 61));
        var _type = __webpack_require__( /*! ../../../core/utils/type */ 1);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var ExtImage = {};
        if (_devextremeQuill.default) {
            var Image = _devextremeQuill.default.import("formats/image");
            ExtImage = function(_Image) {
                _inheritsLoose(ExtImage, _Image);

                function ExtImage() {
                    return _Image.apply(this, arguments) || this
                }
                ExtImage.create = function(data) {
                    var SRC = data && data.src || data;
                    var node = _Image.create.call(this, SRC);
                    if ((0, _type.isObject)(data)) {
                        var setAttribute = function(attr, value) {
                            data[attr] && node.setAttribute(attr, value)
                        };
                        setAttribute("alt", data.alt);
                        setAttribute("width", data.width);
                        setAttribute("height", data.height)
                    }
                    return node
                };
                ExtImage.formats = function formats(domNode) {
                    var formats = _Image.formats.call(this, domNode);
                    formats.imageSrc = domNode.getAttribute("src");
                    return formats
                };
                var _proto = ExtImage.prototype;
                _proto.formats = function formats() {
                    var formats = _Image.prototype.formats.call(this);
                    var floatValue = this.domNode.style.float;
                    if (floatValue) {
                        formats.float = floatValue
                    }
                    return formats
                };
                _proto.format = function(name, value) {
                    if ("float" === name) {
                        this.domNode.style[name] = value
                    } else {
                        _Image.prototype.format.call(this, name, value)
                    }
                };
                ExtImage.value = function(domNode) {
                    return {
                        src: domNode.getAttribute("src"),
                        width: domNode.getAttribute("width"),
                        height: domNode.getAttribute("height"),
                        alt: domNode.getAttribute("alt")
                    }
                };
                return ExtImage
            }(Image);
            ExtImage.blotName = "extendedImage"
        }
        var _default = ExtImage;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/html_editor/formats/link.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _devextremeQuill = _interopRequireDefault(__webpack_require__( /*! devextreme-quill */ 61));
        var _type = __webpack_require__( /*! ../../../core/utils/type */ 1);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var ExtLink = {};
        if (_devextremeQuill.default) {
            var Link = _devextremeQuill.default.import("formats/link");
            ExtLink = function(_Link) {
                _inheritsLoose(ExtLink, _Link);

                function ExtLink() {
                    return _Link.apply(this, arguments) || this
                }
                ExtLink.create = function(data) {
                    var HREF = data && data.href || data;
                    var node = _Link.create.call(this, HREF);
                    if ((0, _type.isObject)(data)) {
                        if (data.text) {
                            node.innerText = data.text
                        }
                        if (!data.target) {
                            node.removeAttribute("target")
                        }
                    }
                    return node
                };
                ExtLink.formats = function(domNode) {
                    return {
                        href: domNode.getAttribute("href"),
                        target: domNode.getAttribute("target")
                    }
                };
                var _proto = ExtLink.prototype;
                _proto.formats = function formats() {
                    var formats = _Link.prototype.formats.call(this);
                    var _ExtLink$formats = ExtLink.formats(this.domNode),
                        href = _ExtLink$formats.href,
                        target = _ExtLink$formats.target;
                    formats.link = href;
                    formats.target = target;
                    return formats
                };
                _proto.format = function(name, value) {
                    if ("link" === name && (0, _type.isObject)(value)) {
                        if (value.text) {
                            this.domNode.innerText = value.text
                        }
                        if (value.target) {
                            this.domNode.setAttribute("target", "_blank")
                        } else {
                            this.domNode.removeAttribute("target")
                        }
                        this.domNode.setAttribute("href", value.href)
                    } else {
                        _Link.prototype.format.call(this, name, value)
                    }
                };
                ExtLink.value = function(domNode) {
                    return {
                        href: domNode.getAttribute("href"),
                        text: domNode.innerText,
                        target: !!domNode.getAttribute("target")
                    }
                };
                return ExtLink
            }(Link)
        }
        var _default = ExtLink;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/html_editor/formats/font.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _devextremeQuill = _interopRequireDefault(__webpack_require__( /*! devextreme-quill */ 61));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var FontStyle = {};
        if (_devextremeQuill.default) {
            FontStyle = _devextremeQuill.default.import("attributors/style/font");
            FontStyle.whitelist = null
        }
        var _default = FontStyle;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/html_editor/formats/size.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _devextremeQuill = _interopRequireDefault(__webpack_require__( /*! devextreme-quill */ 61));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var SizeStyle = {};
        if (_devextremeQuill.default) {
            SizeStyle = _devextremeQuill.default.import("attributors/style/size");
            SizeStyle.whitelist = null
        }
        var _default = SizeStyle;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/html_editor/formats/align.js ***!
      \******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _devextremeQuill = _interopRequireDefault(__webpack_require__( /*! devextreme-quill */ 61));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var AlignStyle = {};
        if (_devextremeQuill.default) {
            AlignStyle = _devextremeQuill.default.import("attributors/style/align");
            AlignStyle.whitelist.push("left")
        }
        var _default = AlignStyle;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/html_editor/modules/toolbar.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _devextremeQuill = _interopRequireDefault(__webpack_require__( /*! devextreme-quill */ 61));
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../../core/renderer */ 2));
        var _toolbar = _interopRequireDefault(__webpack_require__( /*! ../../toolbar */ 157));
        __webpack_require__( /*! ../../select_box */ 117);
        __webpack_require__( /*! ../../color_box/color_view */ 354);
        __webpack_require__( /*! ../../number_box */ 116);
        var _widget_collector = _interopRequireDefault(__webpack_require__( /*! ./widget_collector */ 659));
        var _iterator = __webpack_require__( /*! ../../../core/utils/iterator */ 3);
        var _type = __webpack_require__( /*! ../../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../../core/utils/extend */ 0);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../../localization/message */ 10));
        var _inflector = __webpack_require__( /*! ../../../core/utils/inflector */ 39);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../../events/core/events_engine */ 5));
        var _index = __webpack_require__( /*! ../../../events/utils/index */ 8);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var ToolbarModule = {};
        if (_devextremeQuill.default) {
            var BaseModule = _devextremeQuill.default.import("core/module");
            var TOOLBAR_WRAPPER_CLASS = "dx-htmleditor-toolbar-wrapper";
            var TOOLBAR_CLASS = "dx-htmleditor-toolbar";
            var TOOLBAR_FORMAT_WIDGET_CLASS = "dx-htmleditor-toolbar-format";
            var TOOLBAR_SEPARATOR_CLASS = "dx-htmleditor-toolbar-separator";
            var TOOLBAR_MENU_SEPARATOR_CLASS = "dx-htmleditor-toolbar-menu-separator";
            var ACTIVE_FORMAT_CLASS = "dx-format-active";
            var BOX_ITEM_CONTENT_CLASS = "dx-box-item-content";
            var ICON_CLASS = "dx-icon";
            var SELECTION_CHANGE_EVENT = "selection-change";
            var DIALOG_COLOR_CAPTION = "dxHtmlEditor-dialogColorCaption";
            var DIALOG_BACKGROUND_CAPTION = "dxHtmlEditor-dialogBackgroundCaption";
            var DIALOG_LINK_CAPTION = "dxHtmlEditor-dialogLinkCaption";
            var DIALOG_LINK_FIELD_URL = "dxHtmlEditor-dialogLinkUrlField";
            var DIALOG_LINK_FIELD_TEXT = "dxHtmlEditor-dialogLinkTextField";
            var DIALOG_LINK_FIELD_TARGET = "dxHtmlEditor-dialogLinkTargetField";
            var DIALOG_LINK_FIELD_TARGET_CLASS = "dx-formdialog-field-target";
            var DIALOG_IMAGE_CAPTION = "dxHtmlEditor-dialogImageCaption";
            var DIALOG_IMAGE_FIELD_URL = "dxHtmlEditor-dialogImageUrlField";
            var DIALOG_IMAGE_FIELD_ALT = "dxHtmlEditor-dialogImageAltField";
            var DIALOG_IMAGE_FIELD_WIDTH = "dxHtmlEditor-dialogImageWidthField";
            var DIALOG_IMAGE_FIELD_HEIGHT = "dxHtmlEditor-dialogImageHeightField";
            var DIALOG_TABLE_FIELD_COLUMNS = "dxHtmlEditor-dialogInsertTableRowsField";
            var DIALOG_TABLE_FIELD_ROWS = "dxHtmlEditor-dialogInsertTableColumnsField";
            var DIALOG_TABLE_CAPTION = "dxHtmlEditor-dialogInsertTableCaption";
            var TABLE_OPERATIONS = ["insertTable", "insertRowAbove", "insertRowBelow", "insertColumnLeft", "insertColumnRight", "deleteColumn", "deleteRow", "deleteTable"];
            var USER_ACTION = "user";
            var SILENT_ACTION = "silent";
            var HEADING_TEXT = _message.default.format("dxHtmlEditor-heading");
            var NORMAL_TEXT = _message.default.format("dxHtmlEditor-normalText");
            ToolbarModule = function(_BaseModule) {
                _inheritsLoose(ToolbarModule, _BaseModule);

                function ToolbarModule(quill, options) {
                    var _this;
                    _this = _BaseModule.call(this, quill, options) || this;
                    _this._editorInstance = options.editorInstance;
                    _this._toolbarWidgets = new _widget_collector.default;
                    _this._formatHandlers = _this._getFormatHandlers();
                    if ((0, _type.isDefined)(options.items)) {
                        _this._addCallbacks();
                        _this._renderToolbar();
                        _this.quill.on("editor-change", function(eventName) {
                            var isSelectionChanged = eventName === SELECTION_CHANGE_EVENT;
                            _this._updateToolbar(isSelectionChanged)
                        })
                    }
                    return _this
                }
                var _proto = ToolbarModule.prototype;
                _proto._applyFormat = function(formatArgs, event) {
                    var _this$quill;
                    this._editorInstance._saveValueChangeEvent(event);
                    (_this$quill = this.quill).format.apply(_this$quill, _toConsumableArray(formatArgs))
                };
                _proto._addCallbacks = function() {
                    this._editorInstance.addCleanCallback(this.clean.bind(this));
                    this._editorInstance.addContentInitializedCallback(this.updateHistoryWidgets.bind(this))
                };
                _proto._updateToolbar = function(isSelectionChanged) {
                    this.updateFormatWidgets(isSelectionChanged);
                    this.updateHistoryWidgets();
                    this.updateTableWidgets()
                };
                _proto._getDefaultClickHandler = function(formatName) {
                    var _this2 = this;
                    return function(_ref) {
                        var event = _ref.event;
                        var formats = _this2.quill.getFormat();
                        var value = formats[formatName];
                        var newValue = !((0, _type.isBoolean)(value) ? value : (0, _type.isDefined)(value));
                        _this2._applyFormat([formatName, newValue, USER_ACTION], event);
                        _this2._updateFormatWidget(formatName, newValue, formats)
                    }
                };
                _proto._updateFormatWidget = function(formatName, isApplied, formats) {
                    var widget = this._toolbarWidgets.getByName(formatName);
                    if (!widget) {
                        return
                    }
                    if (isApplied) {
                        this._markActiveFormatWidget(formatName, widget, formats)
                    } else {
                        this._resetFormatWidget(formatName, widget);
                        if (Object.prototype.hasOwnProperty.call(formatName)) {
                            delete formats[formatName]
                        }
                    }
                    this._toggleClearFormatting(isApplied || !(0, _type.isEmptyObject)(formats))
                };
                _proto._getFormatHandlers = function() {
                    var _this3 = this;
                    return {
                        clear: function(_ref2) {
                            var event = _ref2.event;
                            var range = _this3.quill.getSelection();
                            if (range) {
                                _this3._editorInstance._saveValueChangeEvent(event);
                                _this3.quill.removeFormat(range);
                                _this3.updateFormatWidgets()
                            }
                        },
                        link: this._prepareLinkHandler(),
                        image: this._prepareImageHandler(),
                        color: this._prepareColorClickHandler("color"),
                        background: this._prepareColorClickHandler("background"),
                        orderedList: this._prepareShortcutHandler("list", "ordered"),
                        bulletList: this._prepareShortcutHandler("list", "bullet"),
                        alignLeft: this._prepareShortcutHandler("align", "left"),
                        alignCenter: this._prepareShortcutHandler("align", "center"),
                        alignRight: this._prepareShortcutHandler("align", "right"),
                        alignJustify: this._prepareShortcutHandler("align", "justify"),
                        codeBlock: this._getDefaultClickHandler("code-block"),
                        undo: function(_ref3) {
                            var event = _ref3.event;
                            _this3._editorInstance._saveValueChangeEvent(event);
                            _this3.quill.history.undo()
                        },
                        redo: function(_ref4) {
                            var event = _ref4.event;
                            _this3._editorInstance._saveValueChangeEvent(event);
                            _this3.quill.history.redo()
                        },
                        increaseIndent: function(_ref5) {
                            var event = _ref5.event;
                            _this3._applyFormat(["indent", "+1", USER_ACTION], event)
                        },
                        decreaseIndent: function(_ref6) {
                            var event = _ref6.event;
                            _this3._applyFormat(["indent", "-1", USER_ACTION], event)
                        },
                        superscript: this._prepareShortcutHandler("script", "super"),
                        subscript: this._prepareShortcutHandler("script", "sub"),
                        insertTable: this._prepareInsertTableHandler(),
                        insertRowAbove: this._getTableOperationHandler("insertRowAbove"),
                        insertRowBelow: this._getTableOperationHandler("insertRowBelow"),
                        insertColumnLeft: this._getTableOperationHandler("insertColumnLeft"),
                        insertColumnRight: this._getTableOperationHandler("insertColumnRight"),
                        deleteColumn: this._getTableOperationHandler("deleteColumn"),
                        deleteRow: this._getTableOperationHandler("deleteRow"),
                        deleteTable: this._getTableOperationHandler("deleteTable")
                    }
                };
                _proto._prepareShortcutHandler = function(formatName, shortcutValue) {
                    var _this4 = this;
                    return function(_ref7) {
                        var event = _ref7.event;
                        var formats = _this4.quill.getFormat();
                        var value = formats[formatName] === shortcutValue ? false : shortcutValue;
                        _this4._applyFormat([formatName, value, USER_ACTION], event);
                        _this4.updateFormatWidgets(true)
                    }
                };
                _proto._prepareLinkHandler = function() {
                    var _this5 = this;
                    return function() {
                        _this5.quill.focus();
                        var selection = _this5.quill.getSelection();
                        var hasEmbedContent = _this5._hasEmbedContent(selection);
                        var formats = selection ? _this5.quill.getFormat() : {};
                        var formData = {
                            href: formats.link || "",
                            text: selection && !hasEmbedContent ? _this5.quill.getText(selection) : "",
                            target: Object.prototype.hasOwnProperty.call(formats, "target") ? !!formats.target : true
                        };
                        _this5._editorInstance.formDialogOption("title", _message.default.format(DIALOG_LINK_CAPTION));
                        var promise = _this5._editorInstance.showFormDialog({
                            formData: formData,
                            items: _this5._getLinkFormItems(selection)
                        });
                        promise.done(function(formData, event) {
                            if (selection && !hasEmbedContent) {
                                var text = formData.text || formData.href;
                                var index = selection.index,
                                    length = selection.length;
                                formData.text = void 0;
                                _this5._editorInstance._saveValueChangeEvent(event);
                                length && _this5.quill.deleteText(index, length, SILENT_ACTION);
                                _this5.quill.insertText(index, text, "link", formData, USER_ACTION);
                                _this5.quill.setSelection(index + text.length, 0, USER_ACTION)
                            } else {
                                formData.text = !selection && !formData.text ? formData.href : formData.text;
                                _this5._applyFormat(["link", formData, USER_ACTION], event)
                            }
                        });
                        promise.fail(function() {
                            _this5.quill.focus()
                        })
                    }
                };
                _proto._hasEmbedContent = function(selection) {
                    return !!selection && this.quill.getText(selection).trim().length < selection.length
                };
                _proto._getLinkFormItems = function(selection) {
                    return [{
                        dataField: "href",
                        label: {
                            text: _message.default.format(DIALOG_LINK_FIELD_URL)
                        }
                    }, {
                        dataField: "text",
                        label: {
                            text: _message.default.format(DIALOG_LINK_FIELD_TEXT)
                        },
                        visible: !this._hasEmbedContent(selection)
                    }, {
                        dataField: "target",
                        editorType: "dxCheckBox",
                        editorOptions: {
                            text: _message.default.format(DIALOG_LINK_FIELD_TARGET)
                        },
                        cssClass: DIALOG_LINK_FIELD_TARGET_CLASS,
                        label: {
                            visible: false
                        }
                    }]
                };
                _proto._prepareImageHandler = function() {
                    var _this6 = this;
                    return function() {
                        var formData = _this6.quill.getFormat();
                        var isUpdateDialog = Object.prototype.hasOwnProperty.call(formData, "imageSrc");
                        var defaultIndex = _this6._defaultPasteIndex;
                        if (isUpdateDialog) {
                            var _this6$quill$getForma = _this6.quill.getFormat(defaultIndex - 1, 1),
                                imageSrc = _this6$quill$getForma.imageSrc;
                            formData.src = formData.imageSrc;
                            delete formData.imageSrc;
                            if (!imageSrc || 0 === defaultIndex) {
                                _this6.quill.setSelection(defaultIndex + 1, 0, SILENT_ACTION)
                            }
                        }
                        var formatIndex = _this6._embedFormatIndex;
                        _this6._editorInstance.formDialogOption("title", _message.default.format(DIALOG_IMAGE_CAPTION));
                        var promise = _this6._editorInstance.showFormDialog({
                            formData: formData,
                            items: _this6._imageFormItems
                        });
                        promise.done(function(formData, event) {
                            var index = defaultIndex;
                            _this6._editorInstance._saveValueChangeEvent(event);
                            if (isUpdateDialog) {
                                index = formatIndex;
                                _this6.quill.deleteText(index, 1, SILENT_ACTION)
                            }
                            _this6.quill.insertEmbed(index, "extendedImage", formData, USER_ACTION);
                            _this6.quill.setSelection(index + 1, 0, USER_ACTION)
                        }).always(function() {
                            _this6.quill.focus()
                        })
                    }
                };
                _proto._prepareInsertTableHandler = function() {
                    var _this7 = this;
                    return function() {
                        var formats = _this7.quill.getFormat();
                        var isTableFocused = Object.prototype.hasOwnProperty.call(formats, "table");
                        var formData = {
                            rows: 1,
                            columns: 1
                        };
                        if (isTableFocused) {
                            _this7.quill.focus();
                            return
                        }
                        _this7._editorInstance.formDialogOption("title", _message.default.format(DIALOG_TABLE_CAPTION));
                        var promise = _this7._editorInstance.showFormDialog({
                            formData: formData,
                            items: _this7._insertTableFormItems
                        });
                        promise.done(function(formData, event) {
                            _this7.quill.focus();
                            var table = _this7.quill.getModule("table");
                            if (table) {
                                _this7._editorInstance._saveValueChangeEvent(event);
                                var columns = formData.columns,
                                    rows = formData.rows;
                                table.insertTable(columns, rows)
                            }
                        }).always(function() {
                            _this7.quill.focus()
                        })
                    }
                };
                _proto._getTableOperationHandler = function(operationName) {
                    var _this8 = this;
                    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                        rest[_key - 1] = arguments[_key]
                    }
                    return function() {
                        var table = _this8.quill.getModule("table");
                        if (!table) {
                            return
                        }
                        _this8.quill.focus();
                        return table[operationName].apply(table, rest)
                    }
                };
                _proto._renderToolbar = function() {
                    var _this9 = this;
                    var container = this.options.container || this._getContainer();
                    this._$toolbar = (0, _renderer.default)("<div>").addClass(TOOLBAR_CLASS).appendTo(container);
                    this._$toolbarContainer = (0, _renderer.default)(container).addClass(TOOLBAR_WRAPPER_CLASS);
                    _events_engine.default.on(this._$toolbarContainer, (0, _index.addNamespace)("mousedown", this._editorInstance.NAME), function(e) {
                        e.preventDefault()
                    });
                    this.toolbarInstance = this._editorInstance._createComponent(this._$toolbar, _toolbar.default, this.toolbarConfig);
                    this._editorInstance.on("optionChanged", function(_ref8) {
                        var name = _ref8.name;
                        if ("readOnly" === name || "disabled" === name) {
                            _this9.toolbarInstance.option("disabled", _this9.isInteractionDisabled)
                        }
                    })
                };
                _proto.isMultilineMode = function() {
                    var _this$options$multili;
                    return null !== (_this$options$multili = this.options.multiline) && void 0 !== _this$options$multili ? _this$options$multili : true
                };
                _proto.clean = function() {
                    this._toolbarWidgets.clear();
                    if (this._$toolbarContainer) {
                        this._$toolbarContainer.empty().removeClass(TOOLBAR_WRAPPER_CLASS)
                    }
                };
                _proto.repaint = function() {
                    this.toolbarInstance && this.toolbarInstance.repaint()
                };
                _proto._getContainer = function() {
                    var $container = (0, _renderer.default)("<div>");
                    this._editorInstance.$element().prepend($container);
                    return $container
                };
                _proto._prepareToolbarItems = function() {
                    var _this10 = this;
                    var resultItems = [];
                    (0, _iterator.each)(this.options.items, function(index, item) {
                        var newItem;
                        if ((0, _type.isObject)(item)) {
                            newItem = _this10._handleObjectItem(item)
                        } else {
                            if ((0, _type.isString)(item)) {
                                var buttonItemConfig = _this10._prepareButtonItemConfig(item);
                                newItem = _this10._getToolbarItem(buttonItemConfig)
                            }
                        }
                        if (newItem) {
                            resultItems.push(newItem)
                        }
                    });
                    return resultItems
                };
                _proto._handleObjectItem = function(item) {
                    if (item.formatName && item.formatValues && this._isAcceptableItem(item.widget, "dxSelectBox")) {
                        var selectItemConfig = this._prepareSelectItemConfig(item);
                        return this._getToolbarItem(selectItemConfig)
                    } else {
                        if (item.formatName && this._isAcceptableItem(item.widget, "dxButton")) {
                            var defaultButtonItemConfig = this._prepareButtonItemConfig(item.formatName);
                            var buttonItemConfig = (0, _extend.extend)(true, defaultButtonItemConfig, item);
                            return this._getToolbarItem(buttonItemConfig)
                        } else {
                            return this._getToolbarItem(item)
                        }
                    }
                };
                _proto._isAcceptableItem = function(widget, acceptableWidgetName) {
                    return !widget || widget === acceptableWidgetName
                };
                _proto._prepareButtonItemConfig = function(formatName) {
                    var iconName = "clear" === formatName ? "clearformat" : formatName;
                    var buttonText = (0, _inflector.titleize)(formatName);
                    return {
                        widget: "dxButton",
                        formatName: formatName,
                        options: {
                            hint: buttonText,
                            text: buttonText,
                            icon: iconName.toLowerCase(),
                            onClick: this._formatHandlers[formatName] || this._getDefaultClickHandler(formatName),
                            stylingMode: "text"
                        },
                        showText: "inMenu"
                    }
                };
                _proto._prepareSelectItemConfig = function(item) {
                    var _this11 = this;
                    return (0, _extend.extend)(true, {
                        widget: "dxSelectBox",
                        formatName: item.formatName,
                        options: {
                            stylingMode: "filled",
                            dataSource: item.formatValues,
                            placeholder: (0, _inflector.titleize)(item.formatName),
                            onValueChanged: function(e) {
                                if (!_this11._isReset) {
                                    _this11._applyFormat([item.formatName, e.value, USER_ACTION], e.event);
                                    _this11._setValueSilent(e.component, e.value)
                                }
                            }
                        }
                    }, item)
                };
                _proto._prepareColorClickHandler = function(formatName) {
                    var _this12 = this;
                    return function() {
                        var formData = _this12.quill.getFormat();
                        var caption = "color" === formatName ? DIALOG_COLOR_CAPTION : DIALOG_BACKGROUND_CAPTION;
                        _this12._editorInstance.formDialogOption("title", _message.default.format(caption));
                        var promise = _this12._editorInstance.showFormDialog({
                            formData: formData,
                            items: [{
                                dataField: formatName,
                                editorType: "dxColorView",
                                editorOptions: {
                                    onContentReady: function(e) {
                                        (0, _renderer.default)(e.element).closest(".".concat(BOX_ITEM_CONTENT_CLASS)).css("flexBasis", "auto")
                                    },
                                    focusStateEnabled: false
                                },
                                label: {
                                    visible: false
                                }
                            }]
                        });
                        promise.done(function(formData, event) {
                            _this12._applyFormat([formatName, formData[formatName], USER_ACTION], event)
                        });
                        promise.fail(function() {
                            _this12.quill.focus()
                        })
                    }
                };
                _proto._getToolbarItem = function(item) {
                    var _this13 = this;
                    var baseItem = {
                        options: {
                            onInitialized: function(e) {
                                if (item.formatName) {
                                    e.component.$element().addClass(TOOLBAR_FORMAT_WIDGET_CLASS);
                                    e.component.$element().toggleClass("dx-".concat(item.formatName.toLowerCase(), "-format"), !!item.formatName);
                                    _this13._toolbarWidgets.add(item.formatName, e.component)
                                }
                            }
                        }
                    };
                    var multilineItem = this.isMultilineMode() ? {
                        location: "before",
                        locateInMenu: "never"
                    } : {};
                    return (0, _extend.extend)(true, {
                        location: "before",
                        locateInMenu: "auto"
                    }, this._getDefaultConfig(item.formatName), item, baseItem, multilineItem)
                };
                _proto._getDefaultItemsConfig = function() {
                    return {
                        header: {
                            options: {
                                displayExpr: function(item) {
                                    var isHeaderValue = (0, _type.isDefined)(item) && false !== item;
                                    return isHeaderValue ? "".concat(HEADING_TEXT, " ").concat(item) : NORMAL_TEXT
                                }
                            }
                        },
                        clear: {
                            options: {
                                disabled: true
                            }
                        },
                        undo: {
                            options: {
                                disabled: true
                            }
                        },
                        redo: {
                            options: {
                                disabled: true
                            }
                        },
                        insertRowAbove: {
                            options: {
                                disabled: true
                            }
                        },
                        insertRowBelow: {
                            options: {
                                disabled: true
                            }
                        },
                        insertColumnLeft: {
                            options: {
                                disabled: true
                            }
                        },
                        insertColumnRight: {
                            options: {
                                disabled: true
                            }
                        },
                        deleteRow: {
                            options: {
                                disabled: true
                            }
                        },
                        deleteColumn: {
                            options: {
                                disabled: true
                            }
                        },
                        deleteTable: {
                            options: {
                                disabled: true
                            }
                        },
                        separator: {
                            template: function(data, index, element) {
                                (0, _renderer.default)(element).addClass(TOOLBAR_SEPARATOR_CLASS)
                            },
                            menuItemTemplate: function(data, index, element) {
                                (0, _renderer.default)(element).addClass(TOOLBAR_MENU_SEPARATOR_CLASS)
                            }
                        }
                    }
                };
                _proto._getDefaultConfig = function(formatName) {
                    return this._getDefaultItemsConfig()[formatName]
                };
                _proto.updateHistoryWidgets = function() {
                    var historyModule = this.quill.history;
                    if (!historyModule) {
                        return
                    }
                    var _historyModule$stack = historyModule.stack,
                        undoOps = _historyModule$stack.undo,
                        redoOps = _historyModule$stack.redo;
                    this._updateManipulationWidget(this._toolbarWidgets.getByName("undo"), Boolean(undoOps.length));
                    this._updateManipulationWidget(this._toolbarWidgets.getByName("redo"), Boolean(redoOps.length))
                };
                _proto.updateTableWidgets = function() {
                    var _this$quill$getFormat, _this14 = this;
                    var table = this.quill.getModule("table");
                    if (!table) {
                        return
                    }
                    var selection = this.quill.getSelection();
                    var isTableOperationsEnabled = selection && Boolean(null === (_this$quill$getFormat = this.quill.getFormat(selection)) || void 0 === _this$quill$getFormat ? void 0 : _this$quill$getFormat.table);
                    TABLE_OPERATIONS.forEach(function(operationName) {
                        var isInsertTable = "insertTable" === operationName;
                        var widget = _this14._toolbarWidgets.getByName(operationName);
                        _this14._updateManipulationWidget(widget, isInsertTable ? !isTableOperationsEnabled : isTableOperationsEnabled)
                    })
                };
                _proto._updateManipulationWidget = function(widget, isOperationEnabled) {
                    if (!widget) {
                        return
                    }
                    widget.option("disabled", !isOperationEnabled)
                };
                _proto.updateFormatWidgets = function(isResetRequired) {
                    var selection = this.quill.getSelection();
                    if (!selection) {
                        return
                    }
                    var formats = this.quill.getFormat(selection);
                    var hasFormats = !(0, _type.isEmptyObject)(formats);
                    if (!hasFormats || isResetRequired) {
                        this._resetFormatWidgets()
                    }
                    for (var formatName in formats) {
                        var widgetName = this._getFormatWidgetName(formatName, formats);
                        var formatWidget = this._toolbarWidgets.getByName(widgetName) || this._toolbarWidgets.getByName(formatName);
                        if (!formatWidget) {
                            continue
                        }
                        this._markActiveFormatWidget(formatName, formatWidget, formats)
                    }
                    this._toggleClearFormatting(hasFormats || selection.length > 1)
                };
                _proto._markActiveFormatWidget = function(name, widget, formats) {
                    if (this._isColorFormat(name)) {
                        this._updateColorWidget(name, formats[name])
                    }
                    if ("value" in widget.option()) {
                        this._setValueSilent(widget, formats[name])
                    } else {
                        widget.$element().addClass(ACTIVE_FORMAT_CLASS)
                    }
                };
                _proto._toggleClearFormatting = function(hasFormats) {
                    var clearWidget = this._toolbarWidgets.getByName("clear");
                    if (clearWidget) {
                        clearWidget.option("disabled", !hasFormats)
                    }
                };
                _proto._isColorFormat = function(formatName) {
                    return "color" === formatName || "background" === formatName
                };
                _proto._updateColorWidget = function(formatName, color) {
                    var formatWidget = this._toolbarWidgets.getByName(formatName);
                    if (!formatWidget) {
                        return
                    }
                    formatWidget.$element().find(".".concat(ICON_CLASS)).css("borderBottomColor", color || "transparent")
                };
                _proto._getFormatWidgetName = function(formatName, formats) {
                    var widgetName;
                    switch (formatName) {
                        case "align":
                            widgetName = formatName + (0, _inflector.titleize)(formats[formatName]);
                            break;
                        case "list":
                            widgetName = formats[formatName] + (0, _inflector.titleize)(formatName);
                            break;
                        case "code-block":
                            widgetName = "codeBlock";
                            break;
                        case "script":
                            widgetName = formats[formatName] + formatName;
                            break;
                        case "imageSrc":
                            widgetName = "image";
                            break;
                        default:
                            widgetName = formatName
                    }
                    return widgetName
                };
                _proto._setValueSilent = function(widget, value) {
                    this._isReset = true;
                    widget.option("value", value);
                    this._isReset = false
                };
                _proto._resetFormatWidgets = function() {
                    var _this15 = this;
                    this._toolbarWidgets.each(function(name, widget) {
                        _this15._resetFormatWidget(name, widget)
                    })
                };
                _proto._resetFormatWidget = function(name, widget) {
                    widget.$element().removeClass(ACTIVE_FORMAT_CLASS);
                    if (this._isColorFormat(name)) {
                        this._updateColorWidget(name)
                    }
                    if ("clear" === name) {
                        widget.option("disabled", true)
                    }
                    if ("dxSelectBox" === widget.NAME) {
                        this._setValueSilent(widget, null)
                    }
                };
                _proto.addClickHandler = function(formatName, handler) {
                    this._formatHandlers[formatName] = handler;
                    var formatWidget = this._toolbarWidgets.getByName(formatName);
                    if (formatWidget && "dxButton" === formatWidget.NAME) {
                        formatWidget.option("onClick", handler)
                    }
                };
                _createClass(ToolbarModule, [{
                    key: "_insertTableFormItems",
                    get: function() {
                        return [{
                            dataField: "columns",
                            editorType: "dxNumberBox",
                            editorOptions: {
                                min: 1
                            },
                            label: {
                                text: _message.default.format(DIALOG_TABLE_FIELD_COLUMNS)
                            }
                        }, {
                            dataField: "rows",
                            editorType: "dxNumberBox",
                            editorOptions: {
                                min: 1
                            },
                            label: {
                                text: _message.default.format(DIALOG_TABLE_FIELD_ROWS)
                            }
                        }]
                    }
                }, {
                    key: "_embedFormatIndex",
                    get: function() {
                        var selection = this.quill.getSelection();
                        if (selection) {
                            if (selection.length) {
                                return selection.index
                            } else {
                                return selection.index - 1
                            }
                        } else {
                            return this.quill.getLength()
                        }
                    }
                }, {
                    key: "_defaultPasteIndex",
                    get: function() {
                        var _selection$index;
                        var selection = this.quill.getSelection();
                        return null !== (_selection$index = null === selection || void 0 === selection ? void 0 : selection.index) && void 0 !== _selection$index ? _selection$index : this.quill.getLength()
                    }
                }, {
                    key: "_imageFormItems",
                    get: function() {
                        return [{
                            dataField: "src",
                            label: {
                                text: _message.default.format(DIALOG_IMAGE_FIELD_URL)
                            }
                        }, {
                            dataField: "width",
                            label: {
                                text: _message.default.format(DIALOG_IMAGE_FIELD_WIDTH)
                            }
                        }, {
                            dataField: "height",
                            label: {
                                text: _message.default.format(DIALOG_IMAGE_FIELD_HEIGHT)
                            }
                        }, {
                            dataField: "alt",
                            label: {
                                text: _message.default.format(DIALOG_IMAGE_FIELD_ALT)
                            }
                        }]
                    }
                }, {
                    key: "toolbarConfig",
                    get: function() {
                        return {
                            dataSource: this._prepareToolbarItems(),
                            disabled: this.isInteractionDisabled,
                            menuContainer: this._$toolbarContainer,
                            multiline: this.isMultilineMode()
                        }
                    }
                }, {
                    key: "isInteractionDisabled",
                    get: function() {
                        return this._editorInstance.option("readOnly") || this._editorInstance.option("disabled")
                    }
                }]);
                return ToolbarModule
            }(BaseModule)
        }
        var _default = ToolbarModule;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/toolbar/ui.toolbar.strategy.action_sheet.js ***!
      \*********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiToolbar = _interopRequireDefault(__webpack_require__( /*! ./ui.toolbar.strategy */ 365));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _action_sheet = _interopRequireDefault(__webpack_require__( /*! ../action_sheet */ 268));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ActionSheetStrategy = _uiToolbar.default.inherit({
            NAME: "actionSheet",
            _getMenuItemTemplate: function() {
                return this._toolbar._getTemplate("actionSheetItem")
            },
            render: function() {
                if (!this._hasVisibleMenuItems()) {
                    return
                }
                this.callBase()
            },
            _menuWidgetClass: function() {
                return _action_sheet.default
            },
            _menuContainer: function() {
                return this._toolbar.$element()
            },
            _widgetOptions: function() {
                return (0, _extend.extend)({}, this.callBase(), {
                    target: this._$button,
                    showTitle: false
                })
            },
            _menuButtonOptions: function() {
                return (0, _extend.extend)({}, this.callBase(), {
                    icon: "overflow"
                })
            },
            _toggleMenu: function() {
                this.callBase.apply(this, arguments);
                this._menu.toggle(this._menuShown);
                this._menuShown = false
            }
        });
        var _default = ActionSheetStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/toolbar/ui.toolbar.strategy.drop_down_menu.js ***!
      \***********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _uiToolbar = _interopRequireDefault(__webpack_require__( /*! ./ui.toolbar.strategy */ 365));
        var _uiToolbar2 = _interopRequireDefault(__webpack_require__( /*! ./ui.toolbar.menu */ 658));
        var _drop_down_menu = _interopRequireDefault(__webpack_require__( /*! ../drop_down_menu */ 214));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var MENU_INVISIBLE_CLASS = "dx-state-invisible";
        var DropDownMenuStrategy = _uiToolbar.default.inherit({
            NAME: "dropDownMenu",
            render: function() {
                if (!this._hasVisibleMenuItems()) {
                    return
                }
                this._renderMenuButtonContainer();
                this._renderWidget()
            },
            renderMenuItems: function() {
                if (!this._menu) {
                    this.render()
                }
                this.callBase();
                if (this._menu && !this._menu.option("items").length) {
                    this._menu.close()
                }
            },
            _menuWidgetClass: function() {
                return _drop_down_menu.default
            },
            _widgetOptions: function() {
                var that = this;
                return (0, _extend.extend)(this.callBase(), {
                    deferRendering: true,
                    container: that._toolbar.option("menuContainer"),
                    menuWidget: _uiToolbar2.default,
                    onOptionChanged: function(e) {
                        if ("items" === e.name) {
                            that._updateMenuVisibility(e.value)
                        }
                    },
                    popupPosition: {
                        at: "bottom right",
                        my: "top right"
                    }
                })
            },
            _updateMenuVisibility: function(menuItems) {
                var items = menuItems || this._getMenuItems();
                var isMenuVisible = items.length && this._hasVisibleMenuItems(items);
                this._toggleMenuVisibility(isMenuVisible)
            },
            _toggleMenuVisibility: function(value) {
                if (!this._menuContainer()) {
                    return
                }
                this._menuContainer().toggleClass(MENU_INVISIBLE_CLASS, !value)
            },
            _menuContainer: function() {
                return this._$menuButtonContainer
            }
        });
        var _default = DropDownMenuStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/toolbar/ui.toolbar.menu.js ***!
      \****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _uiList = __webpack_require__( /*! ../list/ui.list.base */ 270);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var TOOLBAR_MENU_ACTION_CLASS = "dx-toolbar-menu-action";
        var TOOLBAR_HIDDEN_BUTTON_CLASS = "dx-toolbar-hidden-button";
        var TOOLBAR_HIDDEN_BUTTON_GROUP_CLASS = "dx-toolbar-hidden-button-group";
        var TOOLBAR_MENU_SECTION_CLASS = "dx-toolbar-menu-section";
        var TOOLBAR_MENU_LAST_SECTION_CLASS = "dx-toolbar-menu-last-section";
        var ToolbarMenu = _uiList.ListBase.inherit({
            _activeStateUnit: "." + TOOLBAR_MENU_ACTION_CLASS,
            _initMarkup: function() {
                this._renderSections();
                this.callBase()
            },
            _getSections: function() {
                return this._itemContainer().children()
            },
            _itemElements: function() {
                return this._getSections().children(this._itemSelector())
            },
            _renderSections: function() {
                var that = this;
                var $container = this._itemContainer();
                (0, _iterator.each)(["before", "center", "after", "menu"], function() {
                    var sectionName = "_$" + this + "Section";
                    var $section = that[sectionName];
                    if (!$section) {
                        that[sectionName] = $section = (0, _renderer.default)("<div>").addClass(TOOLBAR_MENU_SECTION_CLASS)
                    }
                    $section.appendTo($container)
                })
            },
            _renderItems: function() {
                this.callBase.apply(this, arguments);
                this._updateSections()
            },
            _updateSections: function() {
                var $sections = this.$element().find("." + TOOLBAR_MENU_SECTION_CLASS);
                $sections.removeClass(TOOLBAR_MENU_LAST_SECTION_CLASS);
                $sections.not(":empty").eq(-1).addClass(TOOLBAR_MENU_LAST_SECTION_CLASS)
            },
            _renderItem: function(index, item, itemContainer, $after) {
                var location = item.location || "menu";
                var $container = this["_$" + location + "Section"];
                var itemElement = this.callBase(index, item, $container, $after);
                if (this._getItemTemplateName({
                        itemData: item
                    })) {
                    itemElement.addClass("dx-toolbar-menu-custom")
                }
                if ("menu" === location || "dxButton" === item.widget || "dxButtonGroup" === item.widget || item.isAction) {
                    itemElement.addClass(TOOLBAR_MENU_ACTION_CLASS)
                }
                if ("dxButton" === item.widget) {
                    itemElement.addClass(TOOLBAR_HIDDEN_BUTTON_CLASS)
                }
                if ("dxButtonGroup" === item.widget) {
                    itemElement.addClass(TOOLBAR_HIDDEN_BUTTON_GROUP_CLASS)
                }
                itemElement.addClass(item.cssClass);
                return itemElement
            },
            _getItemTemplateName: function(args) {
                var template = this.callBase(args);
                var data = args.itemData;
                var menuTemplate = data && data.menuItemTemplate;
                return menuTemplate || template
            },
            _itemClickHandler: function(e, args, config) {
                if ((0, _renderer.default)(e.target).closest("." + TOOLBAR_MENU_ACTION_CLASS).length) {
                    this.callBase(e, args, config)
                }
            },
            _clean: function() {
                this._getSections().empty();
                this.callBase()
            }
        });
        (0, _component_registrator.default)("dxToolbarMenu", ToolbarMenu);
        var _default = ToolbarMenu;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/html_editor/modules/widget_collector.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _iterator = __webpack_require__( /*! ../../../core/utils/iterator */ 3);
        var WidgetCollector = function() {
            function WidgetCollector() {
                this._collection = []
            }
            var _proto = WidgetCollector.prototype;
            _proto.clear = function() {
                this._collection = []
            };
            _proto.add = function(name, instance) {
                this._collection.push({
                    name: name,
                    instance: instance
                })
            };
            _proto.getByName = function(widgetName) {
                var widget = null;
                (0, _iterator.each)(this._collection, function(index, _ref) {
                    var name = _ref.name,
                        instance = _ref.instance;
                    if (name === widgetName) {
                        widget = instance;
                        return false
                    }
                });
                return widget
            };
            _proto.each = function(handler) {
                this._collection.forEach(function(_ref2) {
                    var name = _ref2.name,
                        instance = _ref2.instance;
                    return instance && handler(name, instance)
                })
            };
            return WidgetCollector
        }();
        exports.default = WidgetCollector;
        module.exports = exports.default
    },
    /*!**********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/html_editor/modules/dropImage.js ***!
      \**********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _devextremeQuill = _interopRequireDefault(__webpack_require__( /*! devextreme-quill */ 61));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../../events/core/events_engine */ 5));
        var _index = __webpack_require__( /*! ../../../events/utils/index */ 8);
        var _iterator = __webpack_require__( /*! ../../../core/utils/iterator */ 3);
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../../core/utils/browser */ 23));
        var _window = __webpack_require__( /*! ../../../core/utils/window */ 7);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _assertThisInitialized(self) {
            if (void 0 === self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called")
            }
            return self
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var DropImageModule = {};
        if (_devextremeQuill.default) {
            var BaseModule = _devextremeQuill.default.import("core/module");
            DropImageModule = function(_BaseModule) {
                _inheritsLoose(DropImageModule, _BaseModule);

                function DropImageModule(quill, options) {
                    var _this;
                    _this = _BaseModule.call(this, quill, options) || this;
                    _this.editorInstance = options.editorInstance;
                    var widgetName = _this.editorInstance.NAME;
                    _events_engine.default.on(_this.quill.root, (0, _index.addNamespace)("dragover", widgetName), _this._dragOverHandler.bind(_assertThisInitialized(_this)));
                    _events_engine.default.on(_this.quill.root, (0, _index.addNamespace)("drop", widgetName), _this._dropHandler.bind(_assertThisInitialized(_this)));
                    _events_engine.default.on(_this.quill.root, (0, _index.addNamespace)("paste", widgetName), _this._pasteHandler.bind(_assertThisInitialized(_this)));
                    return _this
                }
                var _proto = DropImageModule.prototype;
                _proto._dragOverHandler = function(e) {
                    if (_browser.default.msie) {
                        e.preventDefault()
                    }
                };
                _proto._dropHandler = function(e) {
                    var _dataTransfer$files;
                    var dataTransfer = e.originalEvent.dataTransfer;
                    var hasFiles = null === dataTransfer || void 0 === dataTransfer ? void 0 : null === (_dataTransfer$files = dataTransfer.files) || void 0 === _dataTransfer$files ? void 0 : _dataTransfer$files.length;
                    this.editorInstance._saveValueChangeEvent(e);
                    e.preventDefault();
                    if (hasFiles) {
                        this._getImage(dataTransfer.files, this._addImage.bind(this))
                    }
                };
                _proto._pasteHandler = function(e) {
                    var _clipboardData$items, _this2 = this;
                    var clipboardData = e.originalEvent.clipboardData;
                    this.editorInstance._saveValueChangeEvent(e);
                    if (!clipboardData) {
                        return
                    }
                    var hasDataItems = null === (_clipboardData$items = clipboardData.items) || void 0 === _clipboardData$items ? void 0 : _clipboardData$items.length;
                    var isHtmlData = clipboardData.getData("text/html");
                    if (!isHtmlData && hasDataItems) {
                        this._getImage(clipboardData.items, function(imageData) {
                            if (_this2._isBrowserSupportImagePaste(_browser.default)) {
                                return
                            }
                            if (_browser.default.msie) {
                                setTimeout(function() {
                                    _this2._addImage(imageData)
                                })
                            } else {
                                _this2._addImage(imageData)
                            }
                        })
                    }
                };
                _proto._isBrowserSupportImagePaste = function(_ref) {
                    var mozilla = _ref.mozilla,
                        chrome = _ref.chrome,
                        version = _ref.version;
                    return mozilla || chrome && version > 82
                };
                _proto._isImage = function(file) {
                    return !!file.type.match(/^image\/(a?png|bmp|gif|p?jpe?g|svg|vnd\.microsoft\.icon|webp)/i)
                };
                _proto._getImage = function(files, callback) {
                    var _this3 = this;
                    var window = (0, _window.getWindow)();
                    (0, _iterator.each)(files, function(index, file) {
                        if (!_this3._isImage(file)) {
                            return
                        }
                        var reader = new window.FileReader;
                        reader.onload = function(_ref2) {
                            var target = _ref2.target;
                            callback(target.result)
                        };
                        var readableFile = file.getAsFile ? file.getAsFile() : file;
                        if (readableFile instanceof window.Blob) {
                            reader.readAsDataURL(readableFile)
                        }
                    })
                };
                _proto._addImage = function(data) {
                    var selection = this.quill.getSelection();
                    var pasteIndex = selection ? selection.index : this.quill.getLength();
                    this.quill.insertEmbed(pasteIndex, "extendedImage", data, "user")
                };
                return DropImageModule
            }(BaseModule)
        }
        var _default = DropImageModule;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/html_editor/modules/variables.js ***!
      \**********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _devextremeQuill = _interopRequireDefault(__webpack_require__( /*! devextreme-quill */ 61));
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../../core/renderer */ 2));
        var _position = __webpack_require__( /*! ../../../core/utils/position */ 22);
        var _popup = _interopRequireDefault(__webpack_require__( /*! ./popup */ 366));
        var _variable = _interopRequireDefault(__webpack_require__( /*! ../formats/variable */ 662));
        var _extend = __webpack_require__( /*! ../../../core/utils/extend */ 0);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _assertThisInitialized(self) {
            if (void 0 === self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called")
            }
            return self
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var VariableModule = {};
        if (_devextremeQuill.default) {
            var VARIABLE_FORMAT_CLASS = "dx-variable-format";
            var ACTIVE_FORMAT_CLASS = "dx-format-active";
            _devextremeQuill.default.register({
                "formats/variable": _variable.default
            }, true);
            VariableModule = function(_PopupModule) {
                _inheritsLoose(VariableModule, _PopupModule);
                var _proto = VariableModule.prototype;
                _proto._getDefaultOptions = function() {
                    var baseConfig = _PopupModule.prototype._getDefaultOptions.call(this);
                    return (0, _extend.extend)(baseConfig, {
                        escapeChar: ""
                    })
                };

                function VariableModule(quill, options) {
                    var _this;
                    _this = _PopupModule.call(this, quill, options) || this;
                    var toolbar = quill.getModule("toolbar");
                    if (toolbar) {
                        toolbar.addClickHandler("variable", _this.showPopup.bind(_assertThisInitialized(_this)))
                    }
                    quill.keyboard.addBinding({
                        key: "P",
                        altKey: true
                    }, _this.showPopup.bind(_assertThisInitialized(_this)));
                    _this._popup.on("shown", function(e) {
                        var $ofElement = (0, _renderer.default)(e.component.option("position").of);
                        if ($ofElement.hasClass(VARIABLE_FORMAT_CLASS)) {
                            $ofElement.addClass(ACTIVE_FORMAT_CLASS)
                        }
                    });
                    return _this
                }
                _proto.showPopup = function(event) {
                    var selection = this.quill.getSelection();
                    var position = selection ? selection.index : this.quill.getLength();
                    this.savePosition(position);
                    this._resetPopupPosition(event, position);
                    _PopupModule.prototype.showPopup.call(this)
                };
                _proto._resetPopupPosition = function(event, position) {
                    if (event && event.element) {
                        this._popup.option("position", {
                            of: event.element,
                            offset: {
                                h: 0,
                                v: 0
                            },
                            my: "top center",
                            at: "bottom center",
                            collision: "fit"
                        })
                    } else {
                        var mentionBounds = this.quill.getBounds(position);
                        var rootRect = (0, _position.getBoundingRect)(this.quill.root);
                        this._popup.option("position", {
                            of: this.quill.root,
                            offset: {
                                h: mentionBounds.left,
                                v: mentionBounds.bottom - rootRect.height
                            },
                            my: "top center",
                            at: "bottom left",
                            collision: "fit flip"
                        })
                    }
                };
                _proto.insertEmbedContent = function(selectionChangedEvent) {
                    var caretPosition = this.getPosition();
                    var selectedItem = selectionChangedEvent.component.option("selectedItem");
                    var variableData = (0, _extend.extend)({}, {
                        value: selectedItem,
                        escapeChar: this.options.escapeChar
                    });
                    setTimeout(function() {
                        this.quill.insertEmbed(caretPosition, "variable", variableData);
                        this.quill.setSelection(caretPosition + 1)
                    }.bind(this))
                };
                return VariableModule
            }(_popup.default)
        }
        var _default = VariableModule;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/html_editor/formats/variable.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _devextremeQuill = _interopRequireDefault(__webpack_require__( /*! devextreme-quill */ 61));
        var _common = __webpack_require__( /*! ../../../core/utils/common */ 4);
        var _extend = __webpack_require__( /*! ../../../core/utils/extend */ 0);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var Variable = {};
        if (_devextremeQuill.default) {
            var Embed = _devextremeQuill.default.import("blots/embed");
            var VARIABLE_CLASS = "dx-variable";
            Variable = function(_Embed) {
                _inheritsLoose(Variable, _Embed);

                function Variable() {
                    return _Embed.apply(this, arguments) || this
                }
                Variable.create = function(data) {
                    var node = _Embed.create.call(this);
                    var startEscapeChar;
                    var endEscapeChar;
                    var text = data.value;
                    if (Array.isArray(data.escapeChar)) {
                        startEscapeChar = (0, _common.ensureDefined)(data.escapeChar[0], "");
                        endEscapeChar = (0, _common.ensureDefined)(data.escapeChar[1], "")
                    } else {
                        startEscapeChar = endEscapeChar = data.escapeChar
                    }
                    node.innerText = startEscapeChar + text + endEscapeChar;
                    node.dataset.varStartEscChar = startEscapeChar;
                    node.dataset.varEndEscChar = endEscapeChar;
                    node.dataset.varValue = data.value;
                    return node
                };
                Variable.value = function(node) {
                    return (0, _extend.extend)({}, {
                        value: node.dataset.varValue,
                        escapeChar: [node.dataset.varStartEscChar || "", node.dataset.varEndEscChar || ""]
                    })
                };
                return Variable
            }(Embed);
            Variable.blotName = "variable";
            Variable.tagName = "span";
            Variable.className = VARIABLE_CLASS
        }
        var _default = Variable;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/html_editor/modules/resizing.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../../events/core/events_engine */ 5));
        var _click = __webpack_require__( /*! ../../../events/click */ 21);
        var _index = __webpack_require__( /*! ../../../events/utils/index */ 8);
        var _translator = __webpack_require__( /*! ../../../animation/translator */ 28);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../../core/devices */ 13));
        var _resizable = _interopRequireDefault(__webpack_require__( /*! ../../resizable */ 193));
        var _position = __webpack_require__( /*! ../../../core/utils/position */ 22);
        var _devextremeQuill = _interopRequireDefault(__webpack_require__( /*! devextreme-quill */ 61));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DX_RESIZE_FRAME_CLASS = "dx-resize-frame";
        var DX_TOUCH_DEVICE_CLASS = "dx-touch-device";
        var MODULE_NAMESPACE = "dxHtmlResizingModule";
        var KEYDOWN_EVENT = (0, _index.addNamespace)("keydown", MODULE_NAMESPACE);
        var SCROLL_EVENT = (0, _index.addNamespace)("scroll", MODULE_NAMESPACE);
        var MOUSEDOWN_EVENT = (0, _index.addNamespace)("mousedown", MODULE_NAMESPACE);
        var FRAME_PADDING = 1;
        var ResizingModule = function() {
            function ResizingModule(quill, options) {
                this.quill = quill;
                this.editorInstance = options.editorInstance;
                this.allowedTargets = options.allowedTargets || ["image"];
                this.enabled = !!options.enabled;
                this._hideFrameWithContext = this.hideFrame.bind(this);
                this._framePositionChangedHandler = this._prepareFramePositionChangedHandler();
                if (this.enabled) {
                    this._attachEvents();
                    this._createResizeFrame()
                }
            }
            var _proto = ResizingModule.prototype;
            _proto._attachEvents = function() {
                _events_engine.default.on(this.quill.root, (0, _index.addNamespace)(_click.name, MODULE_NAMESPACE), this._clickHandler.bind(this));
                _events_engine.default.on(this.quill.root, SCROLL_EVENT, this._framePositionChangedHandler);
                this.editorInstance.on("focusOut", this._hideFrameWithContext);
                this.quill.on("text-change", this._framePositionChangedHandler)
            };
            _proto._detachEvents = function() {
                _events_engine.default.off(this.quill.root, MODULE_NAMESPACE);
                this.editorInstance.off("focusOut", this._hideFrameWithContext);
                this.quill.off("text-change", this._framePositionChangedHandler)
            };
            _proto._clickHandler = function(e) {
                if (this._isAllowedTarget(e.target)) {
                    if (this._$target === e.target) {
                        return
                    }
                    this._$target = e.target;
                    this.updateFramePosition();
                    this.showFrame();
                    this._adjustSelection()
                } else {
                    if (this._$target) {
                        this.hideFrame()
                    }
                }
            };
            _proto._prepareFramePositionChangedHandler = function(e) {
                var _this = this;
                return function() {
                    if (_this._$target) {
                        _this.updateFramePosition()
                    }
                }
            };
            _proto._adjustSelection = function() {
                if (!this.quill.getSelection()) {
                    this.quill.setSelection(0, 0)
                }
            };
            _proto._isAllowedTarget = function(targetElement) {
                return this._isImage(targetElement)
            };
            _proto._isImage = function(targetElement) {
                return this.allowedTargets.indexOf("image") !== -1 && "IMG" === targetElement.tagName.toUpperCase()
            };
            _proto.showFrame = function() {
                this._$resizeFrame.show();
                _events_engine.default.on(this.quill.root, KEYDOWN_EVENT, this._handleFrameKeyDown.bind(this))
            };
            _proto._handleFrameKeyDown = function(e) {
                var keyName = (0, _index.normalizeKeyName)(e);
                if ("del" === keyName || "backspace" === keyName) {
                    this._deleteImage()
                }
                this.hideFrame()
            };
            _proto.hideFrame = function() {
                this._$target = null;
                this._$resizeFrame.hide();
                _events_engine.default.off(this.quill.root, KEYDOWN_EVENT)
            };
            _proto.updateFramePosition = function() {
                var _getBoundingRect = (0, _position.getBoundingRect)(this._$target),
                    height = _getBoundingRect.height,
                    width = _getBoundingRect.width,
                    targetTop = _getBoundingRect.top,
                    targetLeft = _getBoundingRect.left;
                var _getBoundingRect2 = (0, _position.getBoundingRect)(this.quill.root),
                    containerTop = _getBoundingRect2.top,
                    containerLeft = _getBoundingRect2.left;
                var borderWidth = this._getBorderWidth();
                this._$resizeFrame.css({
                    height: height,
                    width: width,
                    padding: FRAME_PADDING,
                    top: targetTop - containerTop - borderWidth - FRAME_PADDING,
                    left: targetLeft - containerLeft - borderWidth - FRAME_PADDING
                });
                (0, _translator.move)(this._$resizeFrame, {
                    left: 0,
                    top: 0
                })
            };
            _proto._getBorderWidth = function() {
                return parseInt(this._$resizeFrame.css("borderTopWidth"))
            };
            _proto._createResizeFrame = function() {
                var _this2 = this;
                if (this._$resizeFrame) {
                    return
                }
                var _devices$current = _devices.default.current(),
                    deviceType = _devices$current.deviceType;
                this._$resizeFrame = (0, _renderer.default)("<div>").addClass(DX_RESIZE_FRAME_CLASS).toggleClass(DX_TOUCH_DEVICE_CLASS, "desktop" !== deviceType).appendTo(this.editorInstance._getQuillContainer()).hide();
                _events_engine.default.on(this._$resizeFrame, MOUSEDOWN_EVENT, function(e) {
                    e.preventDefault()
                });
                this.editorInstance._createComponent(this._$resizeFrame, _resizable.default, {
                    onResize: function(e) {
                        if (!_this2._$target) {
                            return
                        }
                        var correction = 2 * (FRAME_PADDING + _this2._getBorderWidth());
                        (0, _renderer.default)(_this2._$target).attr({
                            height: e.height - correction,
                            width: e.width - correction
                        });
                        _this2.updateFramePosition()
                    }
                })
            };
            _proto._deleteImage = function() {
                if (this._isAllowedTarget(this._$target)) {
                    _devextremeQuill.default.find(this._$target).deleteAt(0)
                }
            };
            _proto.option = function(_option, value) {
                var _this3 = this;
                if ("mediaResizing" === _option) {
                    Object.keys(value).forEach(function(optionName) {
                        return _this3.option(optionName, value[optionName])
                    });
                    return
                }
                if ("enabled" === _option) {
                    this.enabled = value;
                    value ? this._attachEvents() : this._detachEvents()
                } else {
                    if ("allowedTargets" === _option && Array.isArray(value)) {
                        this.allowedTargets = value
                    }
                }
            };
            _proto.clean = function() {
                this._detachEvents();
                this._$resizeFrame.remove();
                this._$resizeFrame = void 0
            };
            return ResizingModule
        }();
        exports.default = ResizingModule;
        module.exports = exports.default
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/html_editor/modules/mentions.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../../core/renderer */ 2));
        var _devextremeQuill = _interopRequireDefault(__webpack_require__( /*! devextreme-quill */ 61));
        var _data = __webpack_require__( /*! ../../../core/utils/data */ 20);
        var _type = __webpack_require__( /*! ../../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../../core/utils/extend */ 0);
        var _element = __webpack_require__( /*! ../../../core/element */ 18);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../../events/core/events_engine */ 5));
        var _popup = _interopRequireDefault(__webpack_require__( /*! ./popup */ 366));
        var _mention = _interopRequireDefault(__webpack_require__( /*! ../formats/mention */ 665));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }

        function _assertThisInitialized(self) {
            if (void 0 === self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called")
            }
            return self
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var MentionModule = {};
        if (_devextremeQuill.default) {
            var USER_ACTION = "user";
            var SILENT_ACTION = "silent";
            var DEFAULT_MARKER = "@";
            var KEYS = {
                ARROW_UP: "upArrow",
                ARROW_DOWN: "downArrow",
                ARROW_LEFT: "leftArrow",
                ARROW_RIGHT: "rightArrow",
                ENTER: "enter",
                ESCAPE: "escape",
                SPACE: "space",
                PAGE_UP: "pageUp",
                PAGE_DOWN: "pageDown",
                END: "end",
                HOME: "home"
            };
            var NAVIGATION_KEYS = [KEYS.ARROW_LEFT, KEYS.ARROW_RIGHT, KEYS.PAGE_UP, KEYS.PAGE_DOWN, KEYS.END, KEYS.HOME];
            var ALLOWED_PREFIX_CHARS = [" ", "\n"];
            var DISABLED_STATE_CLASS = "dx-state-disabled";
            _devextremeQuill.default.register({
                "formats/mention": _mention.default
            }, true);
            MentionModule = function(_PopupModule) {
                _inheritsLoose(MentionModule, _PopupModule);
                var _proto = MentionModule.prototype;
                _proto._getDefaultOptions = function() {
                    var baseConfig = _PopupModule.prototype._getDefaultOptions.call(this);
                    return (0, _extend.extend)(baseConfig, {
                        itemTemplate: "item",
                        valueExpr: "this",
                        displayExpr: "this",
                        template: null,
                        searchExpr: null,
                        searchTimeout: 500,
                        minSearchLength: 0
                    })
                };

                function MentionModule(quill, options) {
                    var _this;
                    _this = _PopupModule.call(this, quill, options) || this;
                    _this._mentions = {};
                    _this.editorInstance = options.editorInstance;
                    options.mentions.forEach(function(item) {
                        var marker = item.marker;
                        if (!marker) {
                            item.marker = marker = DEFAULT_MARKER
                        }
                        var template = item.template;
                        if (template) {
                            var preparedTemplate = _this.editorInstance._getTemplate(template);
                            preparedTemplate && _mention.default.addTemplate(marker, preparedTemplate)
                        }
                        _this._mentions[marker] = (0, _extend.extend)({}, _this._getDefaultOptions(), item)
                    });
                    _this._attachKeyboardHandlers();
                    _this.editorInstance.addCleanCallback(_this.clean.bind(_assertThisInitialized(_this)));
                    _this.quill.on("text-change", _this.onTextChange.bind(_assertThisInitialized(_this)));
                    return _this
                }
                _proto._attachKeyboardHandlers = function() {
                    this.quill.keyboard.addBinding({
                        key: KEYS.ARROW_UP
                    }, this._moveToItem.bind(this, "prev"));
                    this.quill.keyboard.addBinding({
                        key: KEYS.ARROW_DOWN
                    }, this._moveToItem.bind(this, "next"));
                    this.quill.keyboard.addBinding({
                        key: [KEYS.ENTER, KEYS.SPACE]
                    }, this._selectItemHandler.bind(this));
                    var enterBindings = this.quill.keyboard.bindings[KEYS.ENTER];
                    enterBindings.unshift(enterBindings.pop());
                    this.quill.keyboard.addBinding({
                        key: KEYS.ESCAPE
                    }, this._escapeKeyHandler.bind(this));
                    this.quill.keyboard.addBinding({
                        key: [KEYS.ARROW_LEFT, KEYS.ARROW_RIGHT],
                        shiftKey: true
                    }, this._ignoreKeyHandler.bind(this));
                    this.quill.keyboard.addBinding({
                        key: NAVIGATION_KEYS
                    }, this._ignoreKeyHandler.bind(this))
                };
                _proto._moveToItem = function(direction) {
                    var dataSource = this._list.getDataSource();
                    if (this._isMentionActive && !dataSource.isLoading()) {
                        var $focusedItem = (0, _renderer.default)(this._list.option("focusedElement"));
                        var defaultItemPosition = "next" === direction ? "first" : "last";
                        var $nextItem = $focusedItem[direction]();
                        $nextItem = $nextItem.length ? $nextItem : this._activeListItems[defaultItemPosition]();
                        this._list.option("focusedElement", (0, _element.getPublicElement)($nextItem));
                        this._list.scrollToItem($nextItem)
                    }
                    return !this._isMentionActive
                };
                _proto._ignoreKeyHandler = function() {
                    return !this._isMentionActive
                };
                _proto._fitIntoRange = function(value, start, end) {
                    if (value > end) {
                        return start
                    }
                    if (value < start) {
                        return end
                    }
                    return value
                };
                _proto._selectItemHandler = function() {
                    if (this._isMentionActive) {
                        this._list.selectItem(this._list.option("focusedElement"))
                    }
                    return !this._isMentionActive
                };
                _proto._escapeKeyHandler = function() {
                    if (this._isMentionActive) {
                        this._popup.hide()
                    }
                    return !this._isMentionActive
                };
                _proto.renderList = function($container, options) {
                    this.compileGetters(this.options);
                    _PopupModule.prototype.renderList.call(this, $container, options)
                };
                _proto.compileGetters = function(_ref) {
                    var displayExpr = _ref.displayExpr,
                        valueExpr = _ref.valueExpr;
                    this._valueGetter = (0, _data.compileGetter)(displayExpr);
                    this._idGetter = (0, _data.compileGetter)(valueExpr)
                };
                _proto._getListConfig = function(options) {
                    var _this2 = this;
                    var baseConfig = _PopupModule.prototype._getListConfig.call(this, options);
                    return (0, _extend.extend)(baseConfig, {
                        itemTemplate: this.options.itemTemplate,
                        onContentReady: function() {
                            if (_this2._hasSearch) {
                                _this2._popup.repaint();
                                _this2._focusFirstElement();
                                _this2._hasSearch = false
                            }
                        }
                    })
                };
                _proto.insertEmbedContent = function() {
                    var markerLength = this._activeMentionConfig.marker.length;
                    var textLength = markerLength + this._searchValue.length;
                    var caretPosition = this.getPosition();
                    var startIndex = Math.max(0, caretPosition - markerLength);
                    var selectedItem = this._list.option("selectedItem");
                    var value = {
                        value: this._valueGetter(selectedItem),
                        id: this._idGetter(selectedItem),
                        marker: this._activeMentionConfig.marker
                    };
                    setTimeout(function() {
                        this.quill.insertText(startIndex, " ", SILENT_ACTION);
                        this.quill.deleteText(startIndex + 1, textLength, SILENT_ACTION);
                        this.quill.insertEmbed(startIndex, "mention", value);
                        this.quill.setSelection(startIndex + 2)
                    }.bind(this))
                };
                _proto._getLastInsertOperation = function(ops) {
                    var lastOperation = ops[ops.length - 1];
                    var isLastOperationInsert = "insert" in lastOperation;
                    if (isLastOperationInsert) {
                        return lastOperation
                    }
                    var isLastOperationDelete = "delete" in lastOperation;
                    if (isLastOperationDelete && ops.length >= 2) {
                        var penultOperation = ops[ops.length - 2];
                        var isPenultOperationInsert = "insert" in penultOperation;
                        var isSelectionReplacing = isLastOperationDelete && isPenultOperationInsert;
                        if (isSelectionReplacing) {
                            return penultOperation
                        }
                    }
                    return null
                };
                _proto.onTextChange = function(newDelta, oldDelta, source) {
                    if (source === USER_ACTION) {
                        var lastOperation = newDelta.ops[newDelta.ops.length - 1];
                        if (this._isMentionActive && this._isPopupVisible) {
                            this._processSearchValue(lastOperation) && this._filterList(this._searchValue)
                        } else {
                            var ops = newDelta.ops;
                            var lastInsertOperation = this._getLastInsertOperation(ops);
                            if (lastInsertOperation) {
                                this.checkMentionRequest(lastInsertOperation, ops)
                            }
                        }
                    }
                };
                _proto._processSearchValue = function(operation) {
                    var isInsertOperation = "insert" in operation;
                    if (isInsertOperation) {
                        this._searchValue += operation.insert
                    } else {
                        if (!this._searchValue.length || operation.delete > 1) {
                            this._popup.hide();
                            return false
                        } else {
                            this._searchValue = this._searchValue.slice(0, -1)
                        }
                    }
                    return true
                };
                _proto.checkMentionRequest = function(_ref2, ops) {
                    var insert = _ref2.insert;
                    var caret = this.quill.getSelection();
                    if (!insert || !(0, _type.isString)(insert) || !caret || this._isMarkerPartOfText(ops[0].retain)) {
                        return
                    }
                    this._activeMentionConfig = this._mentions[insert];
                    if (this._activeMentionConfig) {
                        this._updateList(this._activeMentionConfig);
                        this.savePosition(caret.index);
                        this._popup.option("position", this._popupPosition);
                        this._searchValue = "";
                        this._popup.show()
                    }
                };
                _proto._isMarkerPartOfText = function(retain) {
                    if (!retain || ALLOWED_PREFIX_CHARS.indexOf(this._getCharByIndex(retain - 1)) !== -1) {
                        return false
                    }
                    return true
                };
                _proto._getCharByIndex = function(index) {
                    return this.quill.getContents(index, 1).ops[0].insert
                };
                _proto._updateList = function(_ref3) {
                    var dataSource = _ref3.dataSource,
                        displayExpr = _ref3.displayExpr,
                        valueExpr = _ref3.valueExpr,
                        itemTemplate = _ref3.itemTemplate,
                        searchExpr = _ref3.searchExpr;
                    this.compileGetters({
                        displayExpr: displayExpr,
                        valueExpr: valueExpr
                    });
                    this._list.unselectAll();
                    this._list.option({
                        dataSource: dataSource,
                        displayExpr: displayExpr,
                        itemTemplate: itemTemplate,
                        searchExpr: searchExpr
                    })
                };
                _proto._filterList = function(searchValue) {
                    var _this3 = this;
                    if (!this._isMinSearchLengthExceeded(searchValue)) {
                        this._resetFilter();
                        return
                    }
                    var searchTimeout = this._activeMentionConfig.searchTimeout;
                    if (searchTimeout) {
                        clearTimeout(this._searchTimer);
                        this._searchTimer = setTimeout(function() {
                            _this3._search(searchValue)
                        }, searchTimeout)
                    } else {
                        this._search(searchValue)
                    }
                };
                _proto._isMinSearchLengthExceeded = function(searchValue) {
                    return searchValue.length >= this._activeMentionConfig.minSearchLength
                };
                _proto._resetFilter = function() {
                    clearTimeout(this._searchTimer);
                    this._search(null)
                };
                _proto._search = function(searchValue) {
                    this._hasSearch = true;
                    this._list.option("searchValue", searchValue)
                };
                _proto._focusFirstElement = function() {
                    if (!this._list) {
                        return
                    }
                    var $firstItem = this._activeListItems.first();
                    this._list.option("focusedElement", (0, _element.getPublicElement)($firstItem));
                    this._list.scrollToItem($firstItem)
                };
                _proto._getPopupConfig = function() {
                    var _this4 = this;
                    return (0, _extend.extend)(_PopupModule.prototype._getPopupConfig.call(this), {
                        closeOnTargetScroll: false,
                        onShown: function() {
                            _this4._isMentionActive = true;
                            _this4._hasSearch = false;
                            _this4._focusFirstElement()
                        },
                        onHidden: function() {
                            _this4._list.unselectAll();
                            _this4._list.option("focusedElement", null);
                            _this4._isMentionActive = false;
                            _this4._search(null)
                        },
                        focusStateEnabled: false
                    })
                };
                _proto.clean = function() {
                    var _this5 = this;
                    Object.keys(this._mentions).forEach(function(marker) {
                        if (_this5._mentions[marker].template) {
                            _mention.default.removeTemplate(marker)
                        }
                    })
                };
                _createClass(MentionModule, [{
                    key: "_isPopupVisible",
                    get: function() {
                        var _this$_popup;
                        return null === (_this$_popup = this._popup) || void 0 === _this$_popup ? void 0 : _this$_popup.option("visible")
                    }
                }, {
                    key: "_popupPosition",
                    get: function() {
                        var position = this.getPosition();
                        var _this$quill$getBounds = this.quill.getBounds(position ? position - 1 : position),
                            mentionLeft = _this$quill$getBounds.left,
                            mentionTop = _this$quill$getBounds.top,
                            mentionHeight = _this$quill$getBounds.height;
                        var _$$offset = (0, _renderer.default)(this.quill.root).offset(),
                            leftOffset = _$$offset.left,
                            topOffset = _$$offset.top;
                        var positionEvent = _events_engine.default.Event("positionEvent", {
                            pageX: leftOffset + mentionLeft,
                            pageY: topOffset + mentionTop
                        });
                        return {
                            of: positionEvent,
                            offset: {
                                v: mentionHeight
                            },
                            my: "top left",
                            at: "top left",
                            collision: {
                                y: "flip",
                                x: "flipfit"
                            }
                        }
                    }
                }, {
                    key: "_activeListItems",
                    get: function() {
                        return this._list.itemElements().filter(":not(.".concat(DISABLED_STATE_CLASS, ")"))
                    }
                }]);
                return MentionModule
            }(_popup.default)
        }
        var _default = MentionModule;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/html_editor/formats/mention.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _devextremeQuill = _interopRequireDefault(__webpack_require__( /*! devextreme-quill */ 61));
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../../core/renderer */ 2));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var Mention = {};
        if (_devextremeQuill.default) {
            var Embed = _devextremeQuill.default.import("blots/embed");
            var MENTION_CLASS = "dx-mention";
            Mention = function(_Embed) {
                _inheritsLoose(Mention, _Embed);

                function Mention() {
                    return _Embed.apply(this, arguments) || this
                }
                Mention.create = function(data) {
                    var node = _Embed.create.call(this);
                    node.setAttribute("spellcheck", false);
                    node.dataset.marker = data.marker;
                    node.dataset.mentionValue = data.value;
                    node.dataset.id = data.id;
                    this.renderContent(node, data);
                    return node
                };
                Mention.value = function(node) {
                    return {
                        marker: node.dataset.marker,
                        id: node.dataset.id,
                        value: node.dataset.mentionValue
                    }
                };
                Mention.renderContent = function(node, data) {
                    var template = this._templates.get(data.marker);
                    if (template) {
                        template.render({
                            model: data,
                            container: node
                        })
                    } else {
                        this.baseContentRender(node, data)
                    }
                };
                Mention.baseContentRender = function(node, data) {
                    var $marker = (0, _renderer.default)("<span>").text(data.marker);
                    (0, _renderer.default)(node).append($marker).append(data.value)
                };
                Mention.addTemplate = function(marker, template) {
                    this._templates.set(marker, template)
                };
                Mention.removeTemplate = function(marker) {
                    this._templates.delete(marker)
                };
                return Mention
            }(Embed);
            Mention.blotName = "mention";
            Mention.tagName = "span";
            Mention.className = MENTION_CLASS;
            Mention._templates = new Map
        }
        var _default = Mention;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/html_editor/converters/delta.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _converterController = _interopRequireDefault(__webpack_require__( /*! ../converterController */ 287));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DeltaConverter = function() {
            function DeltaConverter() {}
            var _proto = DeltaConverter.prototype;
            _proto.setQuillInstance = function(quillInstance) {
                this.quillInstance = quillInstance
            };
            _proto.toHtml = function() {
                if (!this.quillInstance) {
                    return
                }
                return this._isQuillEmpty() ? "" : this.quillInstance.getSemanticHTML(0, this.quillInstance.getLength() + 1)
            };
            _proto._isQuillEmpty = function() {
                var delta = this.quillInstance.getContents();
                return 1 === delta.length() && this._isDeltaEmpty(delta)
            };
            _proto._isDeltaEmpty = function(delta) {
                return delta.reduce(function(__, _ref) {
                    var insert = _ref.insert;
                    return insert.indexOf("\n") !== -1
                })
            };
            return DeltaConverter
        }();
        _converterController.default.addConverter("delta", DeltaConverter);
        var _default = DeltaConverter;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/html_editor/matchers/wordLists.js ***!
      \***********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;

        function getListType(matches) {
            var prefix = matches[1];
            return prefix.match(/\S+\./) ? "ordered" : "bullet"
        }

        function getIndent(node) {
            var style = node.getAttribute("style");
            if (style) {
                var level = style.replace(/\n+/g, "").match(/level(\d+)/);
                return level ? level[1] - 1 : 0
            } else {
                return false
            }
        }

        function removeNewLineChar(operations) {
            var newLineOperation = operations[operations.length - 1];
            newLineOperation.insert = newLineOperation.insert.trim()
        }
        var getMatcher = function(quill) {
            var Delta = quill.import("delta");
            return function(node, delta) {
                var ops = delta.ops.slice();
                var insertOperation = ops[0];
                insertOperation.insert = insertOperation.insert.replace(/^\s+/, "");
                var listDecoratorMatches = insertOperation.insert.match(/^(\S+)\s+/);
                var indent = listDecoratorMatches && getIndent(node);
                if (!listDecoratorMatches || false === indent) {
                    return delta
                }
                insertOperation.insert = insertOperation.insert.substring(listDecoratorMatches[0].length, insertOperation.insert.length);
                removeNewLineChar(ops);
                ops.push({
                    insert: "\n",
                    attributes: {
                        list: getListType(listDecoratorMatches),
                        indent: indent
                    }
                });
                return new Delta(ops)
            }
        };
        var _default = getMatcher;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/html_editor/ui/formDialog.js ***!
      \******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../../core/utils/extend */ 0);
        var _popup = _interopRequireDefault(__webpack_require__( /*! ../../popup */ 46));
        var _form = _interopRequireDefault(__webpack_require__( /*! ../../form */ 138));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../../core/dom_adapter */ 11));
        var _dom = __webpack_require__( /*! ../../../core/utils/dom */ 33);
        var _deferred = __webpack_require__( /*! ../../../core/utils/deferred */ 6);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../../localization/message */ 10));
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../../core/utils/browser */ 23));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var getActiveElement = _dom_adapter.default.getActiveElement;
        var DIALOG_CLASS = "dx-formdialog";
        var FORM_CLASS = "dx-formdialog-form";
        var FormDialog = function() {
            function FormDialog(editorInstance, popupConfig) {
                this._editorInstance = editorInstance;
                this._popupUserConfig = popupConfig;
                this._renderPopup()
            }
            var _proto = FormDialog.prototype;
            _proto._renderPopup = function() {
                var editorInstance = this._editorInstance;
                var $container = (0, _renderer.default)("<div>").addClass(DIALOG_CLASS).appendTo(editorInstance.$element());
                var popupConfig = this._getPopupConfig();
                return editorInstance._createComponent($container, _popup.default, popupConfig)
            };
            _proto._escKeyHandler = function() {
                this._popup.hide()
            };
            _proto._addEscapeHandler = function(e) {
                e.component.registerKeyHandler("escape", this._escKeyHandler.bind(this))
            };
            _proto._getPopupConfig = function() {
                var _this = this;
                return (0, _extend.extend)({
                    onInitialized: function(e) {
                        _this._popup = e.component;
                        _this._popup.on("hiding", function() {
                            _this.deferred.reject()
                        });
                        _this._popup.on("shown", function() {
                            _this._form.focus()
                        })
                    },
                    deferRendering: false,
                    focusStateEnabled: false,
                    showCloseButton: false,
                    contentTemplate: function(contentElem) {
                        var $formContainer = (0, _renderer.default)("<div>").appendTo(contentElem);
                        _this._renderForm($formContainer, {
                            onEditorEnterKey: function(_ref) {
                                var component = _ref.component,
                                    dataField = _ref.dataField,
                                    event = _ref.event;
                                _this._updateEditorValue(component, dataField);
                                _this.hide(component.option("formData"), event)
                            },
                            customizeItem: function(item) {
                                if ("simple" === item.itemType) {
                                    item.editorOptions = (0, _extend.extend)(true, {}, item.editorOptions, {
                                        onInitialized: _this._addEscapeHandler.bind(_this)
                                    })
                                }
                            }
                        })
                    },
                    toolbarItems: [{
                        toolbar: "bottom",
                        location: "after",
                        widget: "dxButton",
                        options: {
                            onInitialized: this._addEscapeHandler.bind(this),
                            text: _message.default.format("OK"),
                            onClick: function(_ref2) {
                                var event = _ref2.event;
                                _this.hide(_this._form.option("formData"), event)
                            }
                        }
                    }, {
                        toolbar: "bottom",
                        location: "after",
                        widget: "dxButton",
                        options: {
                            onInitialized: this._addEscapeHandler.bind(this),
                            text: _message.default.format("Cancel"),
                            onClick: function() {
                                _this._popup.hide()
                            }
                        }
                    }]
                }, this._popupUserConfig)
            };
            _proto._updateEditorValue = function(component, dataField) {
                if (_browser.default.msie && parseInt(_browser.default.version) <= 11) {
                    var editor = component.getEditor(dataField);
                    var activeElement = getActiveElement();
                    if (editor.$element().find(activeElement).length) {
                        (0, _dom.resetActiveElement)()
                    }
                }
            };
            _proto._renderForm = function($container, options) {
                $container.addClass(FORM_CLASS);
                this._form = this._editorInstance._createComponent($container, _form.default, options)
            };
            _proto.show = function(formUserConfig) {
                if (this._popup.option("visible")) {
                    return
                }
                this.deferred = new _deferred.Deferred;
                var formConfig = (0, _extend.extend)({}, formUserConfig);
                this._form.option(formConfig);
                this._popup.show();
                return this.deferred.promise()
            };
            _proto.hide = function(formData, event) {
                this.deferred.resolve(formData, event);
                this._popup.hide()
            };
            _proto.popupOption = function(optionName, optionValue) {
                return this._popup.option.apply(this._popup, arguments)
            };
            return FormDialog
        }();
        var _default = FormDialog;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************!*\
      !*** ./artifacts/transpiled-npm/ui/lookup.js ***!
      \***********************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _support = __webpack_require__( /*! ../core/utils/support */ 45);
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _element = __webpack_require__( /*! ../core/element */ 18);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _utils = __webpack_require__( /*! ./widget/utils.ink_ripple */ 82);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../localization/message */ 10));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../core/devices */ 13));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _index = __webpack_require__( /*! ../events/utils/index */ 8);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./drop_down_editor/ui.drop_down_list */ 269));
        var _themes = __webpack_require__( /*! ./themes */ 34);
        var _click = __webpack_require__( /*! ../events/click */ 21);
        var _popover = _interopRequireDefault(__webpack_require__( /*! ./popover */ 135));
        var _text_box = _interopRequireDefault(__webpack_require__( /*! ./text_box */ 97));
        var _child_default_template = __webpack_require__( /*! ../core/templates/child_default_template */ 153);
        var _translator = __webpack_require__( /*! ../animation/translator */ 28);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _utils2 = __webpack_require__( /*! ./drop_down_editor/utils */ 208);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var LOOKUP_CLASS = "dx-lookup";
        var LOOKUP_SEARCH_CLASS = "dx-lookup-search";
        var LOOKUP_SEARCH_WRAPPER_CLASS = "dx-lookup-search-wrapper";
        var LOOKUP_FIELD_CLASS = "dx-lookup-field";
        var LOOKUP_ARROW_CLASS = "dx-lookup-arrow";
        var LOOKUP_FIELD_WRAPPER_CLASS = "dx-lookup-field-wrapper";
        var LOOKUP_POPUP_CLASS = "dx-lookup-popup";
        var LOOKUP_POPUP_WRAPPER_CLASS = "dx-lookup-popup-wrapper";
        var LOOKUP_POPUP_SEARCH_CLASS = "dx-lookup-popup-search";
        var LOOKUP_POPOVER_MODE = "dx-lookup-popover-mode";
        var LOOKUP_EMPTY_CLASS = "dx-lookup-empty";
        var LOOKUP_POPOVER_FLIP_VERTICAL_CLASS = "dx-popover-flipped-vertical";
        var TEXTEDITOR_INPUT_CLASS = "dx-texteditor-input";
        var LIST_ITEM_CLASS = "dx-list-item";
        var LIST_ITEM_SELECTED_CLASS = "dx-list-item-selected";
        var GROUP_LIST_HEADER_CLASS = "dx-list-group-header";
        var MATERIAL_LOOKUP_LIST_ITEMS_COUNT = 5;
        var MATERIAL_LOOKUP_LIST_PADDING = 8;
        var Lookup = _ui.default.inherit({
            _supportedKeys: function() {
                return (0, _extend.extend)(this.callBase(), {
                    space: function(e) {
                        e.preventDefault();
                        this._validatedOpening()
                    },
                    enter: function() {
                        this._validatedOpening()
                    }
                })
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    placeholder: _message.default.format("Select"),
                    searchPlaceholder: _message.default.format("Search"),
                    searchEnabled: true,
                    cleanSearchOnOpening: true,
                    showCancelButton: true,
                    showClearButton: false,
                    clearButtonText: _message.default.format("Clear"),
                    applyButtonText: _message.default.format("OK"),
                    pullRefreshEnabled: false,
                    useNativeScrolling: true,
                    pullingDownText: _message.default.format("dxList-pullingDownText"),
                    pulledDownText: _message.default.format("dxList-pulledDownText"),
                    refreshingText: _message.default.format("dxList-refreshingText"),
                    pageLoadingText: _message.default.format("dxList-pageLoadingText"),
                    onScroll: null,
                    onPullRefresh: null,
                    onPageLoading: null,
                    pageLoadMode: "scrollBottom",
                    nextButtonText: _message.default.format("dxList-nextButtonText"),
                    grouped: false,
                    groupTemplate: "group",
                    usePopover: false,
                    showDropDownButton: false,
                    focusStateEnabled: false,
                    animation: {},
                    dropDownOptions: {
                        showTitle: true,
                        width: function() {
                            return .8 * (0, _renderer.default)(window).width()
                        },
                        height: function() {
                            return .8 * (0, _renderer.default)(window).height()
                        },
                        shading: true,
                        closeOnOutsideClick: false,
                        position: void 0,
                        animation: {},
                        title: "",
                        titleTemplate: "title",
                        onTitleRendered: null,
                        fullScreen: false
                    },
                    dropDownCentered: false,
                    _scrollToSelectedItemEnabled: false,
                    useHiddenSubmitElement: true
                })
            },
            _defaultOptionsRules: function() {
                var _this = this;
                var themeName = (0, _themes.current)();
                return this.callBase().concat([{
                    device: function() {
                        return !_support.nativeScrolling
                    },
                    options: {
                        useNativeScrolling: false
                    }
                }, {
                    device: function(_device) {
                        return !_devices.default.isSimulator() && "desktop" === _devices.default.real().deviceType && "generic" === _device.platform
                    },
                    options: {
                        usePopover: true,
                        dropDownOptions: {
                            height: "auto"
                        }
                    }
                }, {
                    device: {
                        platform: "ios",
                        phone: true
                    },
                    options: {
                        dropDownOptions: {
                            fullScreen: true
                        }
                    }
                }, {
                    device: {
                        platform: "ios",
                        tablet: true
                    },
                    options: {
                        dropDownOptions: {
                            width: function() {
                                return .4 * Math.min((0, _renderer.default)(window).width(), (0, _renderer.default)(window).height())
                            },
                            height: "auto"
                        },
                        usePopover: true,
                        useInkRipple: false
                    }
                }, {
                    device: function() {
                        return "desktop" === _devices.default.real().deviceType && !_devices.default.isSimulator()
                    },
                    options: {
                        focusStateEnabled: true
                    }
                }, {
                    device: function() {
                        return (0, _themes.isMaterial)(themeName)
                    },
                    options: {
                        usePopover: false,
                        searchEnabled: false,
                        showCancelButton: false,
                        dropDownCentered: true,
                        _scrollToSelectedItemEnabled: true,
                        dropDownOptions: {
                            closeOnOutsideClick: true,
                            width: function() {
                                return (0, _utils2.getElementWidth)(_this.$element())
                            },
                            height: function() {
                                return this._getPopupHeight()
                            }.bind(this),
                            showTitle: false,
                            shading: false
                        }
                    }
                }])
            },
            _init: function() {
                this.callBase();
                this._initActions()
            },
            _initActions: function() {
                this.callBase();
                this._initScrollAction();
                this._initPageLoadingAction();
                this._initPullRefreshAction()
            },
            _initPageLoadingAction: function() {
                this._pageLoadingAction = this._createActionByOption("onPageLoading")
            },
            _initPullRefreshAction: function() {
                this._pullRefreshAction = this._createActionByOption("onPullRefresh")
            },
            _initScrollAction: function() {
                this._scrollAction = this._createActionByOption("onScroll")
            },
            _scrollHandler: function(e) {
                this._scrollAction(e)
            },
            _pullRefreshHandler: function(e) {
                this._pullRefreshAction(e)
            },
            _pageLoadingHandler: function(e) {
                this._pageLoadingAction(e)
            },
            _initTemplates: function() {
                this.callBase();
                this._templateManager.addDefaultTemplates({
                    group: new _child_default_template.ChildDefaultTemplate("group"),
                    title: new _child_default_template.ChildDefaultTemplate("title")
                })
            },
            _initMarkup: function() {
                this.$element().addClass(LOOKUP_CLASS).toggleClass(LOOKUP_POPOVER_MODE, this.option("usePopover"));
                this.callBase()
            },
            _inputWrapper: function() {
                return this.$element().find("." + LOOKUP_FIELD_WRAPPER_CLASS)
            },
            _dataSourceOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    paginate: true
                })
            },
            _fireContentReadyAction: _common.noop,
            _popupWrapperClass: function() {
                return ""
            },
            _renderInput: function() {
                var _this2 = this;
                var fieldClickAction = this._createAction(function() {
                    _this2._toggleOpenState()
                });
                this._$field = (0, _renderer.default)("<div>").addClass(LOOKUP_FIELD_CLASS);
                _events_engine.default.on(this._$field, (0, _index.addNamespace)(_click.name, this.NAME), function(e) {
                    fieldClickAction({
                        event: e
                    })
                });
                var $arrow = (0, _renderer.default)("<div>").addClass(LOOKUP_ARROW_CLASS);
                this._$fieldWrapper = (0, _renderer.default)("<div>").addClass(LOOKUP_FIELD_WRAPPER_CLASS).append(this._$field).append($arrow).appendTo(this.$element());
                this.option("useInkRipple") && this._renderInkRipple()
            },
            _getInputContainer: function() {
                return this._$fieldWrapper
            },
            _renderInkRipple: function() {
                this._inkRipple = (0, _utils.render)()
            },
            _toggleOpenState: function() {
                this.callBase();
                if (!this.option("dropDownOptions.fullScreen") && this.option("_scrollToSelectedItemEnabled")) {
                    this._setPopupPosition()
                }
            },
            _toggleActiveState: function($element, value, e) {
                this.callBase.apply(this, arguments);
                if (!this._inkRipple) {
                    return
                }
                var config = {
                    element: this._inputWrapper(),
                    event: e
                };
                if (value) {
                    this._inkRipple.showWave(config)
                } else {
                    this._inkRipple.hideWave(config)
                }
            },
            _renderField: function() {
                var fieldTemplate = this._getTemplateByOption("fieldTemplate");
                if (fieldTemplate && this.option("fieldTemplate")) {
                    this._renderFieldTemplate(fieldTemplate);
                    return
                }
                var displayValue = this.option("displayValue");
                this._updateField((0, _type.isDefined)(displayValue) && String(displayValue) || this.option("placeholder"));
                this.$element().toggleClass(LOOKUP_EMPTY_CLASS, !this.option("selectedItem"))
            },
            _renderDisplayText: function(text) {
                if (this._input().length) {
                    this.callBase(text)
                } else {
                    this._updateField(text)
                }
            },
            _updateField: function(text) {
                this._$field.text(text)
            },
            _renderFieldTemplate: function(template) {
                this._$field.empty();
                var data = this._fieldRenderData();
                template.render({
                    model: data,
                    container: (0, _element.getPublicElement)(this._$field)
                })
            },
            _fieldRenderData: function() {
                return this.option("selectedItem")
            },
            _popupShowingHandler: function() {
                this.callBase.apply(this, arguments);
                if (this.option("cleanSearchOnOpening")) {
                    if (this.option("searchEnabled") && this._searchBox.option("value")) {
                        this._searchBox.option("value", "");
                        this._searchCanceled()
                    }
                    this._list && this._list.option("focusedElement", null)
                }
                if (this.option("dropDownOptions.fullScreen") && this.option("_scrollToSelectedItemEnabled")) {
                    this._popup.option("position").of = (0, _renderer.default)(window)
                }
            },
            _scrollToSelectedItem: function() {
                var selectedIndex = this._list.option("selectedIndex");
                var listItems = this._list.option("items");
                var itemsCount = listItems.length;
                if (0 !== itemsCount) {
                    if (this._list.option("grouped")) {
                        this._list.scrollToItem({
                            group: itemsCount - 1,
                            item: listItems[itemsCount - 1].items.length - 1
                        })
                    } else {
                        this._list.scrollToItem(itemsCount - 1)
                    }
                    this._list.scrollToItem(selectedIndex)
                }
            },
            _getDifferenceOffsets: function(selectedListItem) {
                return selectedListItem.offset().top - (0, _renderer.default)(this.element()).offset().top
            },
            _isCenteringEnabled: function(index, count) {
                return 1 < index && index < count - 2
            },
            _getPopupOffset: function() {
                var listItemsCount = this._listItemElements().length;
                if (0 === listItemsCount) {
                    return
                }
                var selectedListItem = (0, _renderer.default)(this._list.element()).find("." + LIST_ITEM_SELECTED_CLASS);
                var selectedIndex = this._listItemElements().index(selectedListItem);
                var differenceOfHeights = (selectedListItem.height() - (0, _renderer.default)(this.element()).height()) / 2;
                var lookupOffset = (0, _renderer.default)(this._list.element()).offset().top;
                var dropDownHeightOption = this.option("dropDownOptions.height");
                var popupHeight = "function" === typeof dropDownHeightOption ? dropDownHeightOption() : dropDownHeightOption;
                var windowHeight = (0, _renderer.default)(window).height();
                var offsetTop = 0;
                if (selectedIndex !== -1) {
                    if (this._isCenteringEnabled(selectedIndex, listItemsCount)) {
                        this._scrollToSelectedItem();
                        var scrollOffsetTop = (popupHeight - selectedListItem.height()) / 2 - this._getDifferenceOffsets(selectedListItem);
                        this._list.scrollTo(this._list.scrollTop() + MATERIAL_LOOKUP_LIST_PADDING / 2 - scrollOffsetTop);
                        offsetTop = differenceOfHeights + this._getDifferenceOffsets(selectedListItem);
                        if (lookupOffset < offsetTop && selectedIndex !== listItemsCount - 3) {
                            this._list.scrollTo(this._list.scrollTop() + this._getDifferenceOffsets(selectedListItem) / 2);
                            offsetTop = differenceOfHeights + this._getDifferenceOffsets(selectedListItem)
                        }
                    } else {
                        if (selectedIndex <= 1) {
                            this._list.scrollTo(0);
                            offsetTop = differenceOfHeights + this._getDifferenceOffsets(selectedListItem)
                        } else {
                            if (selectedIndex >= listItemsCount - 2) {
                                this._scrollToSelectedItem();
                                offsetTop = differenceOfHeights + this._getDifferenceOffsets(selectedListItem)
                            }
                        }
                    }
                    if (lookupOffset < offsetTop) {
                        this._scrollToSelectedItem();
                        offsetTop = differenceOfHeights + MATERIAL_LOOKUP_LIST_PADDING
                    }
                }
                var offsetBottom = popupHeight - offsetTop - (0, _renderer.default)(this.element()).height();
                if (windowHeight - lookupOffset < offsetBottom) {
                    this._list.scrollTo(this._list.scrollTop() + differenceOfHeights - offsetBottom);
                    offsetTop = popupHeight - (0, _renderer.default)(this.element()).height() - MATERIAL_LOOKUP_LIST_PADDING
                }
                return offsetTop
            },
            _setPopupPosition: function() {
                if (!this.option("dropDownCentered")) {
                    return
                }
                var flipped = this._popup._$wrapper.hasClass(LOOKUP_POPOVER_FLIP_VERTICAL_CLASS);
                if (flipped) {
                    return
                }
                var popupContentParent = (0, _renderer.default)(this._popup.content()).parent();
                var popupOffset = this._getPopupOffset();
                var position = (0, _translator.locate)(popupContentParent);
                (0, _translator.move)(popupContentParent, {
                    top: position.top - popupOffset
                })
            },
            _listItemGroupedElements: function() {
                var groups = this._list._itemContainer().children();
                var items = [];
                groups.each(function(_, group) {
                    items.push((0, _renderer.default)(group).find("." + GROUP_LIST_HEADER_CLASS)[0]);
                    var groupedItems = (0, _renderer.default)(group).find("." + LIST_ITEM_CLASS);
                    groupedItems.each(function(_, item) {
                        items.push(item)
                    })
                });
                return (0, _renderer.default)(items)
            },
            _calculateListHeight: function(grouped) {
                var listItems = grouped ? this._listItemGroupedElements() : this._listItemElements();
                var selectedListItem = (0, _renderer.default)("." + LIST_ITEM_SELECTED_CLASS);
                var selectedIndex = listItems.index(selectedListItem);
                var listHeight = 0;
                var requireListItems = [];
                if (0 === listItems.length) {
                    listHeight += MATERIAL_LOOKUP_LIST_PADDING
                } else {
                    if (listItems.length < MATERIAL_LOOKUP_LIST_ITEMS_COUNT) {
                        listItems.each(function(_, item) {
                            listHeight += (0, _renderer.default)(item).outerHeight()
                        })
                    } else {
                        if (selectedIndex <= 1) {
                            requireListItems = listItems.slice(0, MATERIAL_LOOKUP_LIST_ITEMS_COUNT)
                        } else {
                            if (this._isCenteringEnabled(selectedIndex, listItems.length)) {
                                requireListItems = listItems.slice(selectedIndex - 2, selectedIndex + 3)
                            } else {
                                requireListItems = listItems.slice(listItems.length - MATERIAL_LOOKUP_LIST_ITEMS_COUNT, listItems.length)
                            }
                        }
                        requireListItems.each(function(_, item) {
                            listHeight += (0, _renderer.default)(item).outerHeight()
                        })
                    }
                }
                return listHeight + (grouped ? MATERIAL_LOOKUP_LIST_PADDING : 2 * MATERIAL_LOOKUP_LIST_PADDING)
            },
            _getPopupHeight: function() {
                if (this._list && this._list.itemElements()) {
                    return this._calculateListHeight(this.option("grouped")) + (this._$searchWrapper ? this._$searchWrapper.outerHeight() : 0) + (this._popup._$bottom ? this._popup._$bottom.outerHeight() : 0) + (this._popup._$title ? this._popup._$title.outerHeight() : 0)
                } else {
                    return "auto"
                }
            },
            _renderPopup: function() {
                if (this.option("usePopover") && !this.option("dropDownOptions.fullScreen")) {
                    if (this.option("_scrollToSelectedItemEnabled")) {
                        this.callBase()
                    } else {
                        this._renderPopover()
                    }
                } else {
                    this.callBase()
                }
                this._$popup.addClass(LOOKUP_POPUP_CLASS);
                this._popup._wrapper().addClass(LOOKUP_POPUP_WRAPPER_CLASS)
            },
            _renderPopover: function() {
                this._popup = this._createComponent(this._$popup, _popover.default, (0, _extend.extend)(this._popupConfig(), this._options.cache("dropDownOptions"), {
                    showEvent: null,
                    hideEvent: null,
                    target: this.$element(),
                    _fixedPosition: false,
                    fullScreen: false,
                    shading: false,
                    closeOnTargetScroll: true,
                    width: this._isInitialOptionValue("dropDownOptions.width") ? function() {
                        return this.$element().outerWidth()
                    }.bind(this) : this._popupConfig().width
                }));
                this._popup.on({
                    showing: this._popupShowingHandler.bind(this),
                    shown: this._popupShownHandler.bind(this),
                    hiding: this._popupHidingHandler.bind(this),
                    hidden: this._popupHiddenHandler.bind(this),
                    contentReady: this._contentReadyHandler.bind(this)
                });
                if (this.option("_scrollToSelectedItemEnabled")) {
                    this._popup._$arrow.remove()
                }
                this._setPopupContentId(this._popup.$content());
                this._contentReadyHandler()
            },
            _popupHidingHandler: function() {
                this.callBase();
                this.option("focusStateEnabled") && this.focus()
            },
            _popupHiddenHandler: function() {
                this.callBase();
                if (this.option("_scrollToSelectedItemEnabled")) {
                    (0, _translator.resetPosition)((0, _renderer.default)(this._popup.content()).parent())
                }
            },
            _preventFocusOnPopup: _common.noop,
            _popupConfig: function() {
                var _this3 = this;
                var result = (0, _extend.extend)(this.callBase(), {
                    toolbarItems: this._getPopupToolbarItems(),
                    closeOnTargetScroll: false,
                    onPositioned: null,
                    maxHeight: function() {
                        return (0, _renderer.default)(window).height()
                    },
                    showTitle: this.option("dropDownOptions.showTitle"),
                    title: this.option("dropDownOptions.title"),
                    titleTemplate: this._getTemplateByOption("dropDownOptions.titleTemplate"),
                    onTitleRendered: this.option("dropDownOptions.onTitleRendered"),
                    fullScreen: this.option("dropDownOptions.fullScreen"),
                    shading: this.option("dropDownOptions.shading"),
                    closeOnOutsideClick: this.option("dropDownOptions.closeOnOutsideClick")
                });
                delete result.animation;
                delete result.position;
                if (this.option("_scrollToSelectedItemEnabled")) {
                    result.position = this.option("dropDownCentered") ? {
                        my: "left top",
                        at: "left top",
                        of: this.element()
                    } : {
                        my: "left top",
                        at: "left bottom",
                        of: this.element()
                    };
                    result.closeOnTargetScroll = true
                }(0, _iterator.each)(["position", "animation", "width", "height"], function(_, optionName) {
                    var popupOptionValue = _this3.option("dropDownOptions.".concat(optionName));
                    if (void 0 !== popupOptionValue) {
                        result[optionName] = popupOptionValue
                    }
                });
                return result
            },
            _getPopupToolbarItems: function() {
                var buttonsConfig = "useButtons" === this.option("applyValueMode") ? this._popupToolbarItemsConfig() : [];
                var cancelButton = this._getCancelButtonConfig();
                if (cancelButton) {
                    buttonsConfig.push(cancelButton)
                }
                var clearButton = this._getClearButtonConfig();
                if (clearButton) {
                    buttonsConfig.push(clearButton)
                }
                return this._applyButtonsLocation(buttonsConfig)
            },
            _popupToolbarItemsConfig: function() {
                return [{
                    shortcut: "done",
                    options: {
                        onClick: this._applyButtonHandler.bind(this),
                        text: this.option("applyButtonText")
                    }
                }]
            },
            _getCancelButtonConfig: function() {
                var _this4 = this;
                return this.option("showCancelButton") ? {
                    shortcut: "cancel",
                    onClick: this._cancelButtonHandler.bind(this),
                    options: {
                        onInitialized: function(e) {
                            e.component.registerKeyHandler("escape", _this4.close.bind(_this4))
                        },
                        text: this.option("cancelButtonText")
                    }
                } : null
            },
            _getClearButtonConfig: function() {
                return this.option("showClearButton") ? {
                    shortcut: "clear",
                    onClick: this._resetValue.bind(this),
                    options: {
                        text: this.option("clearButtonText")
                    }
                } : null
            },
            _applyButtonHandler: function(args) {
                if (args) {
                    this._saveValueChangeEvent(args.event)
                }
                this.option("value", this._valueGetter(this._currentSelectedItem()));
                this.callBase()
            },
            _cancelButtonHandler: function() {
                this._refreshSelected();
                this.callBase()
            },
            _refreshPopupVisibility: function() {
                if (this.option("opened")) {
                    this._updatePopupDimensions()
                }
            },
            _dimensionChanged: function() {
                if (this.option("usePopover") && !this.option("dropDownOptions.width")) {
                    this.option("dropDownOptions.width", this.$element().width())
                }
                this._popup && this._updatePopupDimensions()
            },
            _input: function() {
                return this._$searchBox || this.callBase()
            },
            _renderPopupContent: function() {
                this.callBase();
                this._renderSearch()
            },
            _renderSearch: function() {
                var _this5 = this;
                var isSearchEnabled = this.option("searchEnabled");
                this._toggleSearchClass(isSearchEnabled);
                if (isSearchEnabled) {
                    var $searchWrapper = this._$searchWrapper = (0, _renderer.default)("<div>").addClass(LOOKUP_SEARCH_WRAPPER_CLASS);
                    var $searchBox = this._$searchBox = (0, _renderer.default)("<div>").addClass(LOOKUP_SEARCH_CLASS).appendTo($searchWrapper);
                    var currentDevice = _devices.default.current();
                    var searchMode = currentDevice.android && currentDevice.version[0] >= 5 ? "text" : "search";
                    var isKeyboardListeningEnabled = false;
                    this._searchBox = this._createComponent($searchBox, _text_box.default, {
                        onDisposing: function() {
                            return isKeyboardListeningEnabled = false
                        },
                        onFocusIn: function() {
                            return isKeyboardListeningEnabled = true
                        },
                        onFocusOut: function() {
                            return isKeyboardListeningEnabled = false
                        },
                        onKeyboardHandled: function(opts) {
                            return isKeyboardListeningEnabled && _this5._list._keyboardHandler(opts)
                        },
                        mode: searchMode,
                        showClearButton: true,
                        valueChangeEvent: this.option("valueChangeEvent"),
                        onValueChanged: this._searchHandler.bind(this)
                    });
                    this._registerSearchKeyHandlers();
                    $searchWrapper.insertBefore(this._$list);
                    this._setSearchPlaceholder()
                }
            },
            _removeSearch: function() {
                this._$searchWrapper && this._$searchWrapper.remove();
                delete this._$searchWrapper;
                this._$searchBox && this._$searchBox.remove();
                delete this._$searchBox;
                delete this._searchBox
            },
            _selectListItemHandler: function(e) {
                var $itemElement = (0, _renderer.default)(this._list.option("focusedElement"));
                if (!$itemElement.length) {
                    return
                }
                e.preventDefault();
                e.target = $itemElement.get(0);
                this._saveValueChangeEvent(e);
                this._selectListItem(e.itemData, $itemElement)
            },
            _registerSearchKeyHandlers: function() {
                this._searchBox.registerKeyHandler("escape", this.close.bind(this));
                this._searchBox.registerKeyHandler("enter", this._selectListItemHandler.bind(this));
                this._searchBox.registerKeyHandler("space", this._selectListItemHandler.bind(this));
                this._searchBox.registerKeyHandler("end", _common.noop);
                this._searchBox.registerKeyHandler("home", _common.noop)
            },
            _toggleSearchClass: function(isSearchEnabled) {
                if (this._popup) {
                    this._popup._wrapper().toggleClass(LOOKUP_POPUP_SEARCH_CLASS, isSearchEnabled)
                }
            },
            _setSearchPlaceholder: function() {
                if (!this._$searchBox) {
                    return
                }
                var minSearchLength = this.option("minSearchLength");
                var placeholder = this.option("searchPlaceholder");
                if (minSearchLength && placeholder === _message.default.format("Search")) {
                    placeholder = _message.default.getFormatter("dxLookup-searchPlaceholder")(minSearchLength)
                }
                this._searchBox.option("placeholder", placeholder)
            },
            _setAriaTargetForList: _common.noop,
            _renderList: function() {
                var _this6 = this;
                this.callBase();
                this._list.registerKeyHandler("escape", function() {
                    _this6.close()
                })
            },
            _listConfig: function() {
                return (0, _extend.extend)(this.callBase(), {
                    tabIndex: 0,
                    grouped: this.option("grouped"),
                    groupTemplate: this._getTemplateByOption("groupTemplate"),
                    pullRefreshEnabled: this.option("pullRefreshEnabled"),
                    useNativeScrolling: this.option("useNativeScrolling"),
                    pullingDownText: this.option("pullingDownText"),
                    pulledDownText: this.option("pulledDownText"),
                    refreshingText: this.option("refreshingText"),
                    pageLoadingText: this.option("pageLoadingText"),
                    onScroll: this._scrollHandler.bind(this),
                    onPullRefresh: this._pullRefreshHandler.bind(this),
                    onPageLoading: this._pageLoadingHandler.bind(this),
                    pageLoadMode: this.option("pageLoadMode"),
                    nextButtonText: this.option("nextButtonText"),
                    indicateLoading: this.option("searchEnabled"),
                    onSelectionChanged: this._getSelectionChangedHandler()
                })
            },
            _getSelectionChangedHandler: function() {
                return this.option("showSelectionControls") ? this._selectionChangeHandler.bind(this) : _common.noop
            },
            _listContentReadyHandler: function() {
                this.callBase.apply(this, arguments);
                this._refreshSelected()
            },
            _setFocusPolicy: function() {
                if (!this.option("focusStateEnabled")) {
                    return
                }
                if (this.option("searchEnabled")) {
                    this._searchBox.focus()
                } else {
                    _events_engine.default.trigger(this._$list, "focus")
                }
            },
            _focusTarget: function() {
                return this._$field
            },
            _keyboardEventBindingTarget: function() {
                return this._$field
            },
            _listItemClickHandler: function(e) {
                this._saveValueChangeEvent(e.event);
                this._selectListItem(e.itemData, e.event.currentTarget)
            },
            _selectListItem: function(itemData, target) {
                this._list.selectItem(target);
                if ("instantly" === this.option("applyValueMode")) {
                    this._applyButtonHandler()
                }
            },
            _currentSelectedItem: function() {
                return this.option("grouped") ? this._list.option("selectedItems[0]").items[0] : this._list.option("selectedItems[0]")
            },
            _resetValue: function(e) {
                this._saveValueChangeEvent(e.event);
                this.option("value", null);
                this.option("opened", false)
            },
            _searchValue: function() {
                return this.option("searchEnabled") && this._searchBox ? this._searchBox.option("value") : ""
            },
            _renderInputValue: function() {
                var _this7 = this;
                return this.callBase().always(function() {
                    _this7._refreshSelected()
                })
            },
            _renderPlaceholder: function() {
                if (0 === this.$element().find("." + TEXTEDITOR_INPUT_CLASS).length) {
                    return
                }
                this.callBase()
            },
            _clean: function() {
                this._$fieldWrapper.remove();
                this._$searchBox = null;
                delete this._inkRipple;
                this.callBase()
            },
            _setDeprecatedOptions: function() {
                this.callBase();
                (0, _extend.extend)(this._deprecatedOptions, {
                    title: {
                        since: "20.1",
                        alias: "dropDownOptions.title"
                    },
                    titleTemplate: {
                        since: "20.1",
                        alias: "dropDownOptions.titleTemplate"
                    },
                    onTitleRendered: {
                        since: "20.1",
                        alias: "dropDownOptions.onTitleRendered"
                    },
                    fullScreen: {
                        since: "20.1",
                        alias: "dropDownOptions.fullScreen"
                    },
                    popupWidth: {
                        since: "20.1",
                        alias: "dropDownOptions.width"
                    },
                    popupHeight: {
                        since: "20.1",
                        alias: "dropDownOptions.height"
                    },
                    shading: {
                        since: "20.1",
                        alias: "dropDownOptions.shading"
                    },
                    closeOnOutsideClick: {
                        since: "20.1",
                        alias: "dropDownOptions.closeOnOutsideClick"
                    },
                    position: {
                        since: "20.1",
                        alias: "dropDownOptions.position"
                    },
                    animation: {
                        since: "20.1",
                        alias: "dropDownOptions.animation"
                    }
                })
            },
            _optionChanged: function(args) {
                var name = args.name;
                var value = args.value;
                switch (name) {
                    case "dataSource":
                        this.callBase.apply(this, arguments);
                        this._renderField();
                        break;
                    case "searchEnabled":
                        if (this._popup) {
                            this._removeSearch();
                            this._renderSearch()
                        }
                        break;
                    case "searchPlaceholder":
                        this._setSearchPlaceholder();
                        break;
                    case "minSearchLength":
                        this._setSearchPlaceholder();
                        this.callBase.apply(this, arguments);
                        break;
                    case "title":
                    case "titleTemplate":
                    case "onTitleRendered":
                    case "shading":
                    case "animation":
                    case "position":
                    case "closeOnOutsideClick":
                    case "fullScreen":
                        this._setPopupOption(name, value);
                        break;
                    case "usePopover":
                    case "placeholder":
                        this._invalidate();
                        break;
                    case "clearButtonText":
                    case "showClearButton":
                    case "showCancelButton":
                        this._setPopupOption("toolbarItems", this._getPopupToolbarItems());
                        break;
                    case "applyValueMode":
                        this.callBase.apply(this, arguments);
                        break;
                    case "popupWidth":
                        this._setPopupOption("width", "auto" === value ? this.initialOption("dropDownOptions").width : value);
                        break;
                    case "popupHeight":
                        this._setPopupOption("height", "auto" === value ? this.initialOption("dropDownOptions").height : value);
                        break;
                    case "onPageLoading":
                        this._initPageLoadingAction();
                        break;
                    case "onPullRefresh":
                        this._initPullRefreshAction();
                        break;
                    case "pullRefreshEnabled":
                    case "useNativeScrolling":
                    case "pullingDownText":
                    case "pulledDownText":
                    case "refreshingText":
                    case "pageLoadingText":
                    case "nextButtonText":
                    case "grouped":
                    case "groupTemplate":
                        this._setListOption(name);
                        break;
                    case "onScroll":
                        this._initScrollAction();
                        break;
                    case "pageLoadMode":
                        this._setListOption("pageLoadMode", this.option("pageLoadMode"));
                        break;
                    case "cleanSearchOnOpening":
                    case "_scrollToSelectedItemEnabled":
                        break;
                    case "dropDownCentered":
                        if (this.option("_scrollToSelectedItemEnabled")) {
                            this.option("dropDownOptions.position", void 0);
                            this._renderPopup()
                        }
                        break;
                    default:
                        this.callBase.apply(this, arguments)
                }
            },
            focus: function() {
                this.option("opened") ? this._setFocusPolicy() : _events_engine.default.trigger(this._focusTarget(), "focus")
            },
            field: function() {
                return this._$field
            }
        });
        (0, _component_registrator.default)("dxLookup", Lookup);
        var _default = Lookup;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************!*\
      !*** ./artifacts/transpiled-npm/ui/map.js ***!
      \********************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _promise = _interopRequireDefault(__webpack_require__( /*! ../core/polyfills/promise */ 73));
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./widget/ui.errors */ 17));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../core/devices */ 13));
        var _ui2 = _interopRequireDefault(__webpack_require__( /*! ./widget/ui.widget */ 16));
        var _inflector = __webpack_require__( /*! ../core/utils/inflector */ 39);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _array = __webpack_require__( /*! ../core/utils/array */ 12);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _index = __webpack_require__( /*! ../events/utils/index */ 8);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../events/pointer */ 24));
        var _provider = _interopRequireDefault(__webpack_require__( /*! ./map/provider.google_static */ 671));
        var _providerDynamic = _interopRequireDefault(__webpack_require__( /*! ./map/provider.dynamic.google */ 672));
        var _providerDynamic2 = _interopRequireDefault(__webpack_require__( /*! ./map/provider.dynamic.bing */ 673));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var PROVIDERS = {
            googleStatic: _provider.default,
            google: _providerDynamic.default,
            bing: _providerDynamic2.default
        };
        var MAP_CLASS = "dx-map";
        var MAP_CONTAINER_CLASS = "dx-map-container";
        var MAP_SHIELD_CLASS = "dx-map-shield";
        var NATIVE_CLICK_CLASS = "dx-native-click";
        var Map = _ui2.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    bounds: {
                        northEast: null,
                        southWest: null
                    },
                    center: {
                        lat: 0,
                        lng: 0
                    },
                    zoom: 1,
                    width: 300,
                    height: 300,
                    type: "roadmap",
                    provider: "google",
                    autoAdjust: true,
                    markers: [],
                    markerIconSrc: null,
                    onMarkerAdded: null,
                    onMarkerRemoved: null,
                    routes: [],
                    onRouteAdded: null,
                    onRouteRemoved: null,
                    key: {
                        bing: "",
                        google: "",
                        googleStatic: ""
                    },
                    apiKey: {
                        bing: "",
                        google: "",
                        googleStatic: ""
                    },
                    controls: false,
                    onReady: null,
                    onUpdated: null,
                    onClick: null
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: function() {
                        return "desktop" === _devices.default.real().deviceType && !_devices.default.isSimulator()
                    },
                    options: {
                        focusStateEnabled: true
                    }
                }])
            },
            _setDeprecatedOptions: function() {
                this.callBase();
                (0, _extend.extend)(this._deprecatedOptions, {
                    key: {
                        since: "20.2",
                        alias: "apiKey"
                    }
                })
            },
            _init: function() {
                this.callBase();
                this.$element().addClass(MAP_CLASS).addClass(NATIVE_CLICK_CLASS);
                this._lastAsyncAction = _promise.default.resolve();
                this._checkOption("provider");
                this._checkOption("markers");
                this._checkOption("routes");
                this._initContainer();
                this._grabEvents();
                this._rendered = {}
            },
            _useTemplates: function() {
                return false
            },
            _checkOption: function(option) {
                var value = this.option(option);
                if ("markers" === option && !Array.isArray(value)) {
                    throw _ui.default.Error("E1022")
                }
                if ("routes" === option && !Array.isArray(value)) {
                    throw _ui.default.Error("E1023")
                }
            },
            _initContainer: function() {
                this._$container = (0, _renderer.default)("<div>").addClass(MAP_CONTAINER_CLASS);
                this.$element().append(this._$container)
            },
            _grabEvents: function() {
                var eventName = (0, _index.addNamespace)(_pointer.default.down, this.NAME);
                _events_engine.default.on(this.$element(), eventName, this._cancelEvent.bind(this))
            },
            _cancelEvent: function(e) {
                var cancelByProvider = this._provider && this._provider.isEventsCanceled(e) && !this.option("disabled");
                if (cancelByProvider) {
                    e.stopPropagation()
                }
            },
            _saveRendered: function(option) {
                var value = this.option(option);
                this._rendered[option] = value.slice()
            },
            _render: function() {
                this.callBase();
                this._renderShield();
                this._saveRendered("markers");
                this._saveRendered("routes");
                this._provider = new(PROVIDERS[this.option("provider")])(this, this._$container);
                this._queueAsyncAction("render", this._rendered.markers, this._rendered.routes)
            },
            _renderShield: function() {
                var $shield;
                if (this.option("disabled")) {
                    $shield = (0, _renderer.default)("<div>").addClass(MAP_SHIELD_CLASS);
                    this.$element().append($shield)
                } else {
                    $shield = this.$element().find("." + MAP_SHIELD_CLASS);
                    $shield.remove()
                }
            },
            _clean: function() {
                this._cleanFocusState();
                if (this._provider) {
                    this._provider.clean()
                }
                this._provider = null;
                this._lastAsyncAction = _promise.default.resolve();
                this.setOptionSilent("bounds", {
                    northEast: null,
                    southWest: null
                });
                delete this._suppressAsyncAction
            },
            _optionChanged: function(args) {
                var name = args.name;
                var changeBag = this._optionChangeBag;
                this._optionChangeBag = null;
                switch (name) {
                    case "disabled":
                        this._renderShield();
                        this.callBase(args);
                        break;
                    case "width":
                    case "height":
                        this.callBase(args);
                        this._dimensionChanged();
                        break;
                    case "provider":
                        this._suppressAsyncAction = true;
                        this._invalidate();
                        break;
                    case "key":
                    case "apiKey":
                        _ui.default.log("W1001");
                        break;
                    case "bounds":
                        this._queueAsyncAction("updateBounds");
                        break;
                    case "center":
                        this._queueAsyncAction("updateCenter");
                        break;
                    case "zoom":
                        this._queueAsyncAction("updateZoom");
                        break;
                    case "type":
                        this._queueAsyncAction("updateMapType");
                        break;
                    case "controls":
                        this._queueAsyncAction("updateControls", this._rendered.markers, this._rendered.routes);
                        break;
                    case "autoAdjust":
                        this._queueAsyncAction("adjustViewport");
                        break;
                    case "markers":
                    case "routes":
                        this._checkOption(name);
                        var prevValue = this._rendered[name];
                        this._saveRendered(name);
                        this._queueAsyncAction("update" + (0, _inflector.titleize)(name), changeBag ? changeBag.removed : prevValue, changeBag ? changeBag.added : this._rendered[name]).then(function(result) {
                            if (changeBag) {
                                changeBag.resolve(result)
                            }
                        });
                        break;
                    case "markerIconSrc":
                        this._queueAsyncAction("updateMarkers", this._rendered.markers, this._rendered.markers);
                        break;
                    case "onReady":
                    case "onUpdated":
                    case "onMarkerAdded":
                    case "onMarkerRemoved":
                    case "onRouteAdded":
                    case "onRouteRemoved":
                    case "onClick":
                        break;
                    default:
                        this.callBase.apply(this, arguments)
                }
            },
            _visibilityChanged: function(visible) {
                if (visible) {
                    this._dimensionChanged()
                }
            },
            _dimensionChanged: function() {
                this._queueAsyncAction("updateDimensions")
            },
            _queueAsyncAction: function(name) {
                var options = [].slice.call(arguments).slice(1);
                var isActionSuppressed = this._suppressAsyncAction;
                this._lastAsyncAction = this._lastAsyncAction.then(function() {
                    if (!this._provider || isActionSuppressed) {
                        return _promise.default.resolve()
                    }
                    return this._provider[name].apply(this._provider, options).then(function(result) {
                        result = (0, _array.wrapToArray)(result);
                        var mapRefreshed = result[0];
                        if (mapRefreshed && !this._disposed) {
                            this._triggerReadyAction()
                        }
                        return result[1]
                    }.bind(this))
                }.bind(this));
                return this._lastAsyncAction
            },
            _triggerReadyAction: function() {
                this._createActionByOption("onReady")({
                    originalMap: this._provider.map()
                })
            },
            _triggerUpdateAction: function() {
                this._createActionByOption("onUpdated")()
            },
            setOptionSilent: function(name, value) {
                this._setOptionWithoutOptionChange(name, value)
            },
            addMarker: function(marker) {
                return this._addFunction("markers", marker)
            },
            removeMarker: function(marker) {
                return this._removeFunction("markers", marker)
            },
            addRoute: function(route) {
                return this._addFunction("routes", route)
            },
            removeRoute: function(route) {
                return this._removeFunction("routes", route)
            },
            _addFunction: function(optionName, addingValue) {
                var optionValue = this.option(optionName);
                var addingValues = (0, _array.wrapToArray)(addingValue);
                optionValue.push.apply(optionValue, addingValues);
                return this._partialArrayOptionChange(optionName, optionValue, addingValues, [])
            },
            _removeFunction: function(optionName, removingValue) {
                var optionValue = this.option(optionName);
                var removingValues = (0, _array.wrapToArray)(removingValue);
                (0, _iterator.each)(removingValues, function(removingIndex, removingValue) {
                    var index = (0, _type.isNumeric)(removingValue) ? removingValue : (0, _array.inArray)(removingValue, optionValue);
                    if (index !== -1) {
                        var removing = optionValue.splice(index, 1)[0];
                        removingValues.splice(removingIndex, 1, removing)
                    } else {
                        throw _ui.default.log("E1021", (0, _inflector.titleize)(optionName.substring(0, optionName.length - 1)), removingValue)
                    }
                });
                return this._partialArrayOptionChange(optionName, optionValue, [], removingValues)
            },
            _partialArrayOptionChange: function(optionName, optionValue, addingValues, removingValues) {
                return (0, _deferred.fromPromise)(new _promise.default(function(resolve) {
                    this._optionChangeBag = {
                        resolve: resolve,
                        added: addingValues,
                        removed: removingValues
                    };
                    this.option(optionName, optionValue)
                }.bind(this)).then(function(result) {
                    return result && 1 === result.length ? result[0] : result
                }), this)
            }
        });
        (0, _component_registrator.default)("dxMap", Map);
        var _default = Map;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/map/provider.google_static.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _promise = _interopRequireDefault(__webpack_require__( /*! ../../core/polyfills/promise */ 73));
        var _provider = _interopRequireDefault(__webpack_require__( /*! ./provider */ 367));
        var _color = _interopRequireDefault(__webpack_require__( /*! ../../color */ 95));
        var _click = __webpack_require__( /*! ../../events/click */ 21);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var GOOGLE_STATIC_URL = "https://maps.google.com/maps/api/staticmap?";
        var GoogleStaticProvider = _provider.default.inherit({
            _locationToString: function(location) {
                var latLng = this._getLatLng(location);
                return latLng ? latLng.lat + "," + latLng.lng : location.toString().replace(/ /g, "+")
            },
            _renderImpl: function() {
                return this._updateMap()
            },
            updateDimensions: function() {
                return this._updateMap()
            },
            updateMapType: function() {
                return this._updateMap()
            },
            updateBounds: function() {
                return _promise.default.resolve()
            },
            updateCenter: function() {
                return this._updateMap()
            },
            updateZoom: function() {
                return this._updateMap()
            },
            updateControls: function() {
                return _promise.default.resolve()
            },
            addMarkers: function(options) {
                var that = this;
                return this._updateMap().then(function(result) {
                    (0, _iterator.each)(options, function(_, options) {
                        that._fireMarkerAddedAction({
                            options: options
                        })
                    });
                    return result
                })
            },
            removeMarkers: function(options) {
                var that = this;
                return this._updateMap().then(function(result) {
                    (0, _iterator.each)(options, function(_, options) {
                        that._fireMarkerRemovedAction({
                            options: options
                        })
                    });
                    return result
                })
            },
            adjustViewport: function() {
                return _promise.default.resolve()
            },
            addRoutes: function(options) {
                var that = this;
                return this._updateMap().then(function(result) {
                    (0, _iterator.each)(options, function(_, options) {
                        that._fireRouteAddedAction({
                            options: options
                        })
                    });
                    return result
                })
            },
            removeRoutes: function(options) {
                var that = this;
                return this._updateMap().then(function(result) {
                    (0, _iterator.each)(options, function(_, options) {
                        that._fireRouteRemovedAction({
                            options: options
                        })
                    });
                    return result
                })
            },
            clean: function() {
                this._$container.css("backgroundImage", "none");
                _events_engine.default.off(this._$container, this._addEventNamespace(_click.name));
                return _promise.default.resolve()
            },
            mapRendered: function() {
                return true
            },
            _updateMap: function() {
                var key = this._keyOption("googleStatic");
                var $container = this._$container;
                var requestOptions = ["sensor=false", "size=" + Math.round($container.width()) + "x" + Math.round($container.height()), "maptype=" + this._option("type"), "center=" + this._locationToString(this._option("center")), "zoom=" + this._option("zoom"), this._markersSubstring()];
                requestOptions.push.apply(requestOptions, this._routeSubstrings());
                if (key) {
                    requestOptions.push("key=" + key)
                }
                var request = GOOGLE_STATIC_URL + requestOptions.join("&");
                this._$container.css("background", 'url("' + request + '") no-repeat 0 0');
                this._attachClickEvent();
                return _promise.default.resolve(true)
            },
            _markersSubstring: function() {
                var that = this;
                var markers = [];
                var markerIcon = this._option("markerIconSrc");
                if (markerIcon) {
                    markers.push("icon:" + markerIcon)
                }(0, _iterator.each)(this._option("markers"), function(_, marker) {
                    markers.push(that._locationToString(marker.location))
                });
                return "markers=" + markers.join("|")
            },
            _routeSubstrings: function() {
                var that = this;
                var routes = [];
                (0, _iterator.each)(this._option("routes"), function(_, route) {
                    var color = new _color.default(route.color || that._defaultRouteColor()).toHex().replace("#", "0x");
                    var opacity = Math.round(255 * (route.opacity || that._defaultRouteOpacity())).toString(16);
                    var width = route.weight || that._defaultRouteWeight();
                    var locations = [];
                    (0, _iterator.each)(route.locations, function(_, routePoint) {
                        locations.push(that._locationToString(routePoint))
                    });
                    routes.push("path=color:" + color + opacity + "|weight:" + width + "|" + locations.join("|"))
                });
                return routes
            },
            _attachClickEvent: function() {
                var that = this;
                var eventName = this._addEventNamespace(_click.name);
                _events_engine.default.off(this._$container, eventName);
                _events_engine.default.on(this._$container, eventName, function(e) {
                    that._fireClickAction({
                        event: e
                    })
                })
            }
        });
        var _default = GoogleStaticProvider;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/map/provider.dynamic.google.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _promise = _interopRequireDefault(__webpack_require__( /*! ../../core/polyfills/promise */ 73));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _provider = _interopRequireDefault(__webpack_require__( /*! ./provider.dynamic */ 368));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _color = _interopRequireDefault(__webpack_require__( /*! ../../color */ 95));
        var _ajax = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/ajax */ 79));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var GOOGLE_MAP_READY = "_googleScriptReady";
        var GOOGLE_URL = "https://maps.googleapis.com/maps/api/js?callback=" + GOOGLE_MAP_READY;
        var INFO_WINDOW_CLASS = "gm-style-iw";
        var CustomMarker;
        var initCustomMarkerClass = function() {
            CustomMarker = function(options) {
                this._position = options.position;
                this._offset = options.offset;
                this._$overlayContainer = (0, _renderer.default)("<div>").css({
                    position: "absolute",
                    display: "none",
                    cursor: "pointer"
                }).append(options.html);
                this.setMap(options.map)
            };
            CustomMarker.prototype = new google.maps.OverlayView;
            CustomMarker.prototype.onAdd = function() {
                var $pane = (0, _renderer.default)(this.getPanes().overlayMouseTarget);
                $pane.append(this._$overlayContainer);
                this._clickListener = google.maps.event.addDomListener(this._$overlayContainer.get(0), "click", function(e) {
                    google.maps.event.trigger(this, "click");
                    e.preventDefault()
                }.bind(this));
                this.draw()
            };
            CustomMarker.prototype.onRemove = function() {
                google.maps.event.removeListener(this._clickListener);
                this._$overlayContainer.remove()
            };
            CustomMarker.prototype.draw = function() {
                var position = this.getProjection().fromLatLngToDivPixel(this._position);
                this._$overlayContainer.css({
                    left: position.x + this._offset.left,
                    top: position.y + this._offset.top,
                    display: "block"
                })
            }
        };
        var googleMapsLoaded = function() {
            return window.google && window.google.maps
        };
        var googleMapsLoader;
        var GoogleProvider = _provider.default.inherit({
            _mapType: function(type) {
                var mapTypes = {
                    hybrid: google.maps.MapTypeId.HYBRID,
                    roadmap: google.maps.MapTypeId.ROADMAP,
                    satellite: google.maps.MapTypeId.SATELLITE
                };
                return mapTypes[type] || mapTypes.hybrid
            },
            _movementMode: function(type) {
                var movementTypes = {
                    driving: google.maps.TravelMode.DRIVING,
                    walking: google.maps.TravelMode.WALKING
                };
                return movementTypes[type] || movementTypes.driving
            },
            _resolveLocation: function(location) {
                return new _promise.default(function(resolve) {
                    var latLng = this._getLatLng(location);
                    if (latLng) {
                        resolve(new google.maps.LatLng(latLng.lat, latLng.lng))
                    } else {
                        this._geocodeLocation(location).then(function(geocodedLocation) {
                            resolve(geocodedLocation)
                        })
                    }
                }.bind(this))
            },
            _geocodedLocations: {},
            _geocodeLocationImpl: function(location) {
                return new _promise.default(function(resolve) {
                    if (!(0, _type.isDefined)(location)) {
                        resolve(new google.maps.LatLng(0, 0));
                        return
                    }
                    var geocoder = new google.maps.Geocoder;
                    geocoder.geocode({
                        address: location
                    }, function(results, status) {
                        if (status === google.maps.GeocoderStatus.OK) {
                            resolve(results[0].geometry.location)
                        } else {
                            _ui.default.log("W1006", status);
                            resolve(new google.maps.LatLng(0, 0))
                        }
                    })
                })
            },
            _normalizeLocation: function(location) {
                return {
                    lat: location.lat(),
                    lng: location.lng()
                }
            },
            _normalizeLocationRect: function(locationRect) {
                return {
                    northEast: this._normalizeLocation(locationRect.getNorthEast()),
                    southWest: this._normalizeLocation(locationRect.getSouthWest())
                }
            },
            _loadImpl: function() {
                return new _promise.default(function(resolve) {
                    if (googleMapsLoaded()) {
                        resolve()
                    } else {
                        if (!googleMapsLoader) {
                            googleMapsLoader = this._loadMapScript()
                        }
                        googleMapsLoader.then(function() {
                            if (googleMapsLoaded()) {
                                resolve();
                                return
                            }
                            this._loadMapScript().then(resolve)
                        }.bind(this))
                    }
                }.bind(this)).then(function() {
                    initCustomMarkerClass()
                })
            },
            _loadMapScript: function() {
                return new _promise.default(function(resolve) {
                    var key = this._keyOption("google");
                    window[GOOGLE_MAP_READY] = resolve;
                    _ajax.default.sendRequest({
                        url: GOOGLE_URL + (key ? "&key=" + key : ""),
                        dataType: "script"
                    })
                }.bind(this)).then(function() {
                    try {
                        delete window[GOOGLE_MAP_READY]
                    } catch (e) {
                        window[GOOGLE_MAP_READY] = void 0
                    }
                })
            },
            _init: function() {
                return new _promise.default(function(resolve) {
                    this._resolveLocation(this._option("center")).then(function(center) {
                        var showDefaultUI = this._option("controls");
                        this._map = new google.maps.Map(this._$container[0], {
                            zoom: this._option("zoom"),
                            center: center,
                            disableDefaultUI: !showDefaultUI
                        });
                        var listener = google.maps.event.addListener(this._map, "idle", function() {
                            resolve(listener)
                        })
                    }.bind(this))
                }.bind(this)).then(function(listener) {
                    google.maps.event.removeListener(listener)
                })
            },
            _attachHandlers: function() {
                this._boundsChangeListener = google.maps.event.addListener(this._map, "bounds_changed", this._boundsChangeHandler.bind(this));
                this._clickListener = google.maps.event.addListener(this._map, "click", this._clickActionHandler.bind(this))
            },
            _boundsChangeHandler: function() {
                var bounds = this._map.getBounds();
                this._option("bounds", this._normalizeLocationRect(bounds));
                var center = this._map.getCenter();
                this._option("center", this._normalizeLocation(center));
                if (!this._preventZoomChangeEvent) {
                    this._option("zoom", this._map.getZoom())
                }
            },
            _clickActionHandler: function(e) {
                this._fireClickAction({
                    location: this._normalizeLocation(e.latLng)
                })
            },
            updateDimensions: function() {
                var center = this._option("center");
                google.maps.event.trigger(this._map, "resize");
                this._option("center", center);
                return this.updateCenter()
            },
            updateMapType: function() {
                this._map.setMapTypeId(this._mapType(this._option("type")));
                return _promise.default.resolve()
            },
            updateBounds: function() {
                return _promise.default.all([this._resolveLocation(this._option("bounds.northEast")), this._resolveLocation(this._option("bounds.southWest"))]).then(function(result) {
                    var bounds = new google.maps.LatLngBounds;
                    bounds.extend(result[0]);
                    bounds.extend(result[1]);
                    this._map.fitBounds(bounds)
                }.bind(this))
            },
            updateCenter: function() {
                return this._resolveLocation(this._option("center")).then(function(center) {
                    this._map.setCenter(center);
                    this._option("center", this._normalizeLocation(center))
                }.bind(this))
            },
            updateZoom: function() {
                this._map.setZoom(this._option("zoom"));
                return _promise.default.resolve()
            },
            updateControls: function() {
                var showDefaultUI = this._option("controls");
                this._map.setOptions({
                    disableDefaultUI: !showDefaultUI
                });
                return _promise.default.resolve()
            },
            isEventsCanceled: function(e) {
                var gestureHandling = this._map && this._map.get("gestureHandling");
                var isInfoWindowContent = (0, _renderer.default)(e.target).closest(".".concat(INFO_WINDOW_CLASS)).length > 0;
                if (isInfoWindowContent || "desktop" !== _devices.default.real().deviceType && "cooperative" === gestureHandling) {
                    return false
                }
                return this.callBase()
            },
            _renderMarker: function(options) {
                return this._resolveLocation(options.location).then(function(location) {
                    var marker;
                    if (options.html) {
                        marker = new CustomMarker({
                            map: this._map,
                            position: location,
                            html: options.html,
                            offset: (0, _extend.extend)({
                                top: 0,
                                left: 0
                            }, options.htmlOffset)
                        })
                    } else {
                        marker = new google.maps.Marker({
                            position: location,
                            map: this._map,
                            icon: options.iconSrc || this._option("markerIconSrc")
                        })
                    }
                    var infoWindow = this._renderTooltip(marker, options.tooltip);
                    var listener;
                    if (options.onClick || options.tooltip) {
                        var markerClickAction = this._mapWidget._createAction(options.onClick || _common.noop);
                        var markerNormalizedLocation = this._normalizeLocation(location);
                        listener = google.maps.event.addListener(marker, "click", function() {
                            markerClickAction({
                                location: markerNormalizedLocation
                            });
                            if (infoWindow) {
                                infoWindow.open(this._map, marker)
                            }
                        }.bind(this))
                    }
                    return {
                        location: location,
                        marker: marker,
                        listener: listener
                    }
                }.bind(this))
            },
            _renderTooltip: function(marker, options) {
                if (!options) {
                    return
                }
                options = this._parseTooltipOptions(options);
                var infoWindow = new google.maps.InfoWindow({
                    content: options.text
                });
                if (options.visible) {
                    infoWindow.open(this._map, marker)
                }
                return infoWindow
            },
            _destroyMarker: function(marker) {
                marker.marker.setMap(null);
                if (marker.listener) {
                    google.maps.event.removeListener(marker.listener)
                }
            },
            _renderRoute: function(options) {
                return _promise.default.all((0, _iterator.map)(options.locations, function(point) {
                    return this._resolveLocation(point)
                }.bind(this))).then(function(locations) {
                    return new _promise.default(function(resolve) {
                        var origin = locations.shift();
                        var destination = locations.pop();
                        var waypoints = (0, _iterator.map)(locations, function(location) {
                            return {
                                location: location,
                                stopover: true
                            }
                        });
                        var request = {
                            origin: origin,
                            destination: destination,
                            waypoints: waypoints,
                            optimizeWaypoints: true,
                            travelMode: this._movementMode(options.mode)
                        };
                        (new google.maps.DirectionsService).route(request, function(response, status) {
                            if (status === google.maps.DirectionsStatus.OK) {
                                var color = new _color.default(options.color || this._defaultRouteColor()).toHex();
                                var directionOptions = {
                                    directions: response,
                                    map: this._map,
                                    suppressMarkers: true,
                                    preserveViewport: true,
                                    polylineOptions: {
                                        strokeWeight: options.weight || this._defaultRouteWeight(),
                                        strokeOpacity: options.opacity || this._defaultRouteOpacity(),
                                        strokeColor: color
                                    }
                                };
                                var route = new google.maps.DirectionsRenderer(directionOptions);
                                var bounds = response.routes[0].bounds;
                                resolve({
                                    instance: route,
                                    northEast: bounds.getNorthEast(),
                                    southWest: bounds.getSouthWest()
                                })
                            } else {
                                _ui.default.log("W1006", status);
                                resolve({
                                    instance: new google.maps.DirectionsRenderer({})
                                })
                            }
                        }.bind(this))
                    }.bind(this))
                }.bind(this))
            },
            _destroyRoute: function(routeObject) {
                routeObject.instance.setMap(null)
            },
            _fitBounds: function() {
                this._updateBounds();
                if (this._bounds && this._option("autoAdjust")) {
                    var zoomBeforeFitting = this._map.getZoom();
                    this._preventZoomChangeEvent = true;
                    this._map.fitBounds(this._bounds);
                    this._boundsChangeHandler();
                    var zoomAfterFitting = this._map.getZoom();
                    if (zoomBeforeFitting < zoomAfterFitting) {
                        this._map.setZoom(zoomBeforeFitting)
                    } else {
                        this._option("zoom", zoomAfterFitting)
                    }
                    delete this._preventZoomChangeEvent
                }
                return _promise.default.resolve()
            },
            _extendBounds: function(location) {
                if (this._bounds) {
                    this._bounds.extend(location)
                } else {
                    this._bounds = new google.maps.LatLngBounds;
                    this._bounds.extend(location)
                }
            },
            clean: function() {
                if (this._map) {
                    google.maps.event.removeListener(this._boundsChangeListener);
                    google.maps.event.removeListener(this._clickListener);
                    this._clearMarkers();
                    this._clearRoutes();
                    delete this._map;
                    this._$container.empty()
                }
                return _promise.default.resolve()
            }
        });
        var _default = GoogleProvider;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/map/provider.dynamic.bing.js ***!
      \******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _promise = _interopRequireDefault(__webpack_require__( /*! ../../core/polyfills/promise */ 73));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _provider = _interopRequireDefault(__webpack_require__( /*! ./provider.dynamic */ 368));
        var _color = _interopRequireDefault(__webpack_require__( /*! ../../color */ 95));
        var _ajax = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/ajax */ 79));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var BING_MAP_READY = "_bingScriptReady";
        var BING_URL_V8 = "https://www.bing.com/api/maps/mapcontrol?callback=" + BING_MAP_READY;
        var INFOBOX_V_OFFSET_V8 = 13;
        var BING_CREDENTIALS = "AhuxC0dQ1DBTNo8L-H9ToVMQStmizZzBJdraTSgCzDSWPsA1Qd8uIvFSflzxdaLH";
        var MIN_LOCATION_RECT_LENGTH = 1e-16;
        var msMapsLoaded = function() {
            return window.Microsoft && window.Microsoft.Maps
        };
        var msMapsLoader;
        var BingProvider = _provider.default.inherit({
            _mapType: function(type) {
                var mapTypes = {
                    roadmap: Microsoft.Maps.MapTypeId.road,
                    hybrid: Microsoft.Maps.MapTypeId.aerial,
                    satellite: Microsoft.Maps.MapTypeId.aerial
                };
                return mapTypes[type] || mapTypes.road
            },
            _movementMode: function(type) {
                var movementTypes = {
                    driving: Microsoft.Maps.Directions.RouteMode.driving,
                    walking: Microsoft.Maps.Directions.RouteMode.walking
                };
                return movementTypes[type] || movementTypes.driving
            },
            _resolveLocation: function(location) {
                return new _promise.default(function(resolve) {
                    var latLng = this._getLatLng(location);
                    if (latLng) {
                        resolve(new Microsoft.Maps.Location(latLng.lat, latLng.lng))
                    } else {
                        this._geocodeLocation(location).then(function(geocodedLocation) {
                            resolve(geocodedLocation)
                        })
                    }
                }.bind(this))
            },
            _geocodedLocations: {},
            _geocodeLocationImpl: function(location) {
                return new _promise.default(function(resolve) {
                    if (!(0, _type.isDefined)(location)) {
                        resolve(new Microsoft.Maps.Location(0, 0));
                        return
                    }
                    var searchManager = new Microsoft.Maps.Search.SearchManager(this._map);
                    var searchRequest = {
                        where: location,
                        count: 1,
                        callback: function(searchResponse) {
                            var result = searchResponse.results[0];
                            if (result) {
                                var boundsBox = searchResponse.results[0].location;
                                resolve(new Microsoft.Maps.Location(boundsBox.latitude, boundsBox.longitude))
                            } else {
                                resolve(new Microsoft.Maps.Location(0, 0))
                            }
                        }
                    };
                    searchManager.geocode(searchRequest)
                }.bind(this))
            },
            _normalizeLocation: function(location) {
                return {
                    lat: location.latitude,
                    lng: location.longitude
                }
            },
            _normalizeLocationRect: function(locationRect) {
                var northWest = this._normalizeLocation(locationRect.getNorthwest());
                var southEast = this._normalizeLocation(locationRect.getSoutheast());
                return {
                    northEast: {
                        lat: northWest.lat,
                        lng: southEast.lng
                    },
                    southWest: {
                        lat: southEast.lat,
                        lng: northWest.lng
                    }
                }
            },
            _loadImpl: function() {
                return new _promise.default(function(resolve) {
                    if (msMapsLoaded()) {
                        resolve()
                    } else {
                        if (!msMapsLoader) {
                            msMapsLoader = this._loadMapScript()
                        }
                        msMapsLoader.then(function() {
                            if (msMapsLoaded()) {
                                resolve();
                                return
                            }
                            this._loadMapScript().then(resolve)
                        }.bind(this))
                    }
                }.bind(this)).then(function() {
                    return _promise.default.all([new _promise.default(function(resolve) {
                        Microsoft.Maps.loadModule("Microsoft.Maps.Search", {
                            callback: resolve
                        })
                    }), new _promise.default(function(resolve) {
                        Microsoft.Maps.loadModule("Microsoft.Maps.Directions", {
                            callback: resolve
                        })
                    })])
                })
            },
            _loadMapScript: function() {
                return new _promise.default(function(resolve) {
                    window[BING_MAP_READY] = resolve;
                    _ajax.default.sendRequest({
                        url: BING_URL_V8,
                        dataType: "script"
                    })
                }).then(function() {
                    try {
                        delete window[BING_MAP_READY]
                    } catch (e) {
                        window[BING_MAP_READY] = void 0
                    }
                })
            },
            _init: function() {
                this._createMap();
                return _promise.default.resolve()
            },
            _createMap: function() {
                var controls = this._option("controls");
                this._map = new Microsoft.Maps.Map(this._$container[0], {
                    credentials: this._keyOption("bing") || BING_CREDENTIALS,
                    zoom: this._option("zoom"),
                    showDashboard: controls,
                    showMapTypeSelector: controls,
                    showScalebar: controls
                })
            },
            _attachHandlers: function() {
                this._providerViewChangeHandler = Microsoft.Maps.Events.addHandler(this._map, "viewchange", this._viewChangeHandler.bind(this));
                this._providerClickHandler = Microsoft.Maps.Events.addHandler(this._map, "click", this._clickActionHandler.bind(this))
            },
            _viewChangeHandler: function() {
                var bounds = this._map.getBounds();
                this._option("bounds", this._normalizeLocationRect(bounds));
                var center = this._map.getCenter();
                this._option("center", this._normalizeLocation(center));
                if (!this._preventZoomChangeEvent) {
                    this._option("zoom", this._map.getZoom())
                }
            },
            _clickActionHandler: function(e) {
                if ("map" === e.targetType) {
                    this._fireClickAction({
                        location: this._normalizeLocation(e.location)
                    })
                }
            },
            updateDimensions: function() {
                var $container = this._$container;
                this._map.setOptions({
                    width: $container.width(),
                    height: $container.height()
                });
                return _promise.default.resolve()
            },
            updateMapType: function() {
                var type = this._option("type");
                var labelOverlay = Microsoft.Maps.LabelOverlay;
                this._map.setView({
                    animate: false,
                    mapTypeId: this._mapType(type),
                    labelOverlay: "satellite" === type ? labelOverlay.hidden : labelOverlay.visible
                });
                return _promise.default.resolve()
            },
            updateBounds: function() {
                return _promise.default.all([this._resolveLocation(this._option("bounds.northEast")), this._resolveLocation(this._option("bounds.southWest"))]).then(function(result) {
                    var bounds = new Microsoft.Maps.LocationRect.fromLocations(result[0], result[1]);
                    this._map.setView({
                        animate: false,
                        bounds: bounds
                    })
                }.bind(this))
            },
            updateCenter: function() {
                return this._resolveLocation(this._option("center")).then(function(center) {
                    this._map.setView({
                        animate: false,
                        center: center
                    })
                }.bind(this))
            },
            updateZoom: function() {
                this._map.setView({
                    animate: false,
                    zoom: this._option("zoom")
                });
                return _promise.default.resolve()
            },
            updateControls: function() {
                this.clean();
                return this.render.apply(this, arguments)
            },
            _renderMarker: function(options) {
                return this._resolveLocation(options.location).then(function(location) {
                    var pushpinOptions = {
                        icon: options.iconSrc || this._option("markerIconSrc")
                    };
                    if (options.html) {
                        (0, _extend.extend)(pushpinOptions, {
                            htmlContent: options.html,
                            width: null,
                            height: null
                        });
                        var htmlOffset = options.htmlOffset;
                        if (htmlOffset) {
                            pushpinOptions.anchor = new Microsoft.Maps.Point((-htmlOffset.left), (-htmlOffset.top))
                        }
                    }
                    var pushpin = new Microsoft.Maps.Pushpin(location, pushpinOptions);
                    this._map.entities.push(pushpin);
                    var infobox = this._renderTooltip(location, options.tooltip);
                    var handler;
                    if (options.onClick || options.tooltip) {
                        var markerClickAction = this._mapWidget._createAction(options.onClick || _common.noop);
                        var markerNormalizedLocation = this._normalizeLocation(location);
                        handler = Microsoft.Maps.Events.addHandler(pushpin, "click", function() {
                            markerClickAction({
                                location: markerNormalizedLocation
                            });
                            if (infobox) {
                                infobox.setOptions({
                                    visible: true
                                })
                            }
                        })
                    }
                    return {
                        location: location,
                        marker: pushpin,
                        infobox: infobox,
                        handler: handler
                    }
                }.bind(this))
            },
            _renderTooltip: function(location, options) {
                if (!options) {
                    return
                }
                options = this._parseTooltipOptions(options);
                var infobox = new Microsoft.Maps.Infobox(location, {
                    description: options.text,
                    offset: new Microsoft.Maps.Point(0, INFOBOX_V_OFFSET_V8),
                    visible: options.visible
                });
                infobox.setMap(this._map);
                return infobox
            },
            _destroyMarker: function(marker) {
                this._map.entities.remove(marker.marker);
                if (marker.infobox) {
                    marker.infobox.setMap(null)
                }
                if (marker.handler) {
                    Microsoft.Maps.Events.removeHandler(marker.handler)
                }
            },
            _renderRoute: function(options) {
                return _promise.default.all((0, _iterator.map)(options.locations, function(point) {
                    return this._resolveLocation(point)
                }.bind(this))).then(function(locations) {
                    return new _promise.default(function(resolve) {
                        var direction = new Microsoft.Maps.Directions.DirectionsManager(this._map);
                        var color = new _color.default(options.color || this._defaultRouteColor()).toHex();
                        var routeColor = new Microsoft.Maps.Color.fromHex(color);
                        routeColor.a = 255 * (options.opacity || this._defaultRouteOpacity());
                        direction.setRenderOptions({
                            autoUpdateMapView: false,
                            displayRouteSelector: false,
                            waypointPushpinOptions: {
                                visible: false
                            },
                            drivingPolylineOptions: {
                                strokeColor: routeColor,
                                strokeThickness: options.weight || this._defaultRouteWeight()
                            },
                            walkingPolylineOptions: {
                                strokeColor: routeColor,
                                strokeThickness: options.weight || this._defaultRouteWeight()
                            }
                        });
                        direction.setRequestOptions({
                            routeMode: this._movementMode(options.mode),
                            routeDraggable: false
                        });
                        (0, _iterator.each)(locations, function(_, location) {
                            var waypoint = new Microsoft.Maps.Directions.Waypoint({
                                location: location
                            });
                            direction.addWaypoint(waypoint)
                        });
                        var directionHandlers = [];
                        directionHandlers.push(Microsoft.Maps.Events.addHandler(direction, "directionsUpdated", function(args) {
                            while (directionHandlers.length) {
                                Microsoft.Maps.Events.removeHandler(directionHandlers.pop())
                            }
                            var routeSummary = args.routeSummary[0];
                            resolve({
                                instance: direction,
                                northEast: routeSummary.northEast,
                                southWest: routeSummary.southWest
                            })
                        }));
                        directionHandlers.push(Microsoft.Maps.Events.addHandler(direction, "directionsError", function(args) {
                            while (directionHandlers.length) {
                                Microsoft.Maps.Events.removeHandler(directionHandlers.pop())
                            }
                            var status = "RouteResponseCode: " + args.responseCode + " - " + args.message;
                            _ui.default.log("W1006", status);
                            resolve({
                                instance: direction
                            })
                        }));
                        direction.calculateDirections()
                    }.bind(this))
                }.bind(this))
            },
            _destroyRoute: function(routeObject) {
                routeObject.instance.dispose()
            },
            _fitBounds: function() {
                this._updateBounds();
                if (this._bounds && this._option("autoAdjust")) {
                    var zoomBeforeFitting = this._map.getZoom();
                    this._preventZoomChangeEvent = true;
                    var bounds = this._bounds.clone();
                    bounds.height = 1.1 * bounds.height;
                    bounds.width = 1.1 * bounds.width;
                    this._map.setView({
                        animate: false,
                        bounds: bounds,
                        zoom: zoomBeforeFitting
                    });
                    var zoomAfterFitting = this._map.getZoom();
                    if (zoomBeforeFitting < zoomAfterFitting) {
                        this._map.setView({
                            animate: false,
                            zoom: zoomBeforeFitting
                        })
                    } else {
                        this._option("zoom", zoomAfterFitting)
                    }
                    delete this._preventZoomChangeEvent
                }
                return _promise.default.resolve()
            },
            _extendBounds: function(location) {
                if (this._bounds) {
                    this._bounds = new Microsoft.Maps.LocationRect.fromLocations(this._bounds.getNorthwest(), this._bounds.getSoutheast(), location)
                } else {
                    this._bounds = new Microsoft.Maps.LocationRect(location, MIN_LOCATION_RECT_LENGTH, MIN_LOCATION_RECT_LENGTH)
                }
            },
            clean: function() {
                if (this._map) {
                    Microsoft.Maps.Events.removeHandler(this._providerViewChangeHandler);
                    Microsoft.Maps.Events.removeHandler(this._providerClickHandler);
                    this._clearMarkers();
                    this._clearRoutes();
                    this._map.dispose()
                }
                return _promise.default.resolve()
            }
        });
        var _default = BingProvider;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/nav_bar.js ***!
      \************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _item = _interopRequireDefault(__webpack_require__( /*! ./nav_bar/item */ 675));
        var _tabs = _interopRequireDefault(__webpack_require__( /*! ./tabs */ 215));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var NAVBAR_CLASS = "dx-navbar";
        var ITEM_CLASS = "dx-item-content";
        var NAVBAR_ITEM_CLASS = "dx-nav-item";
        var NAVBAR_ITEM_CONTENT_CLASS = "dx-nav-item-content";
        var NavBar = _tabs.default.inherit({
            ctor: function(element, options) {
                this.callBase(element, options);
                this._logDeprecatedComponentWarning("20.1", "dxTabs")
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    scrollingEnabled: false
                })
            },
            _render: function() {
                this.callBase();
                this.$element().addClass(NAVBAR_CLASS)
            },
            _postprocessRenderItem: function(args) {
                this.callBase(args);
                var $itemElement = args.itemElement;
                var itemData = args.itemData;
                $itemElement.addClass(NAVBAR_ITEM_CLASS);
                $itemElement.find("." + ITEM_CLASS).addClass(NAVBAR_ITEM_CONTENT_CLASS);
                if (!itemData.icon) {
                    $itemElement.addClass("dx-navbar-text-item")
                }
            }
        });
        NavBar.ItemClass = _item.default;
        (0, _component_registrator.default)("dxNavBar", NavBar);
        var _default = NavBar;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/nav_bar/item.js ***!
      \*****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _item = _interopRequireDefault(__webpack_require__( /*! ../tabs/item */ 359));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var TABS_ITEM_BADGE_CLASS = "dx-tabs-item-badge";
        var NAVBAR_ITEM_BADGE_CLASS = "dx-navbar-item-badge";
        var NavBarItem = _item.default.inherit({
            _renderBadge: function(badge) {
                this.callBase(badge);
                this._$element.children("." + TABS_ITEM_BADGE_CLASS).removeClass(TABS_ITEM_BADGE_CLASS).addClass(NAVBAR_ITEM_BADGE_CLASS)
            }
        });
        var _default = NavBarItem;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/radio_group/radio_group.js ***!
      \****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var inkRipple = _interopRequireWildcard(__webpack_require__( /*! ../widget/utils.ink_ripple */ 82));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _uiCollection_widget = _interopRequireDefault(__webpack_require__( /*! ../collection/ui.collection_widget.edit */ 54));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../editor/ui.data_expression */ 275));
        var _editor = _interopRequireDefault(__webpack_require__( /*! ../editor/editor */ 52));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var RADIO_BUTTON_CHECKED_CLASS = "dx-radiobutton-checked";
        var RADIO_BUTTON_CLASS = "dx-radiobutton";
        var RADIO_BUTTON_ICON_CHECKED_CLASS = "dx-radiobutton-icon-checked";
        var RADIO_BUTTON_ICON_CLASS = "dx-radiobutton-icon";
        var RADIO_BUTTON_ICON_DOT_CLASS = "dx-radiobutton-icon-dot";
        var RADIO_GROUP_HORIZONTAL_CLASS = "dx-radiogroup-horizontal";
        var RADIO_GROUP_VERTICAL_CLASS = "dx-radiogroup-vertical";
        var RADIO_VALUE_CONTAINER_CLASS = "dx-radio-value-container";
        var RADIO_GROUP_CLASS = "dx-radiogroup";
        var RADIO_FEEDBACK_HIDE_TIMEOUT = 100;
        var RadioCollection = function(_CollectionWidget) {
            _inheritsLoose(RadioCollection, _CollectionWidget);

            function RadioCollection() {
                return _CollectionWidget.apply(this, arguments) || this
            }
            var _proto = RadioCollection.prototype;
            _proto._focusTarget = function() {
                return this.$element().parent()
            };
            _proto._nullValueSelectionSupported = function() {
                return true
            };
            _proto._getDefaultOptions = function() {
                var defaultOptions = _CollectionWidget.prototype._getDefaultOptions.call(this);
                return (0, _extend.extend)(defaultOptions, _ui.default._dataExpressionDefaultOptions(), {
                    _itemAttributes: {
                        role: "radio"
                    }
                })
            };
            _proto._initMarkup = function() {
                var _this = this;
                _CollectionWidget.prototype._initMarkup.call(this);
                (0, _common.deferRender)(function() {
                    _this.itemElements().addClass(RADIO_BUTTON_CLASS)
                })
            };
            _proto._keyboardEventBindingTarget = function() {
                return this._focusTarget()
            };
            _proto._postprocessRenderItem = function(args) {
                var html = args.itemData.html,
                    itemElement = args.itemElement;
                if (!html) {
                    var $radio = (0, _renderer.default)("<div>").addClass(RADIO_BUTTON_ICON_CLASS);
                    (0, _renderer.default)("<div>").addClass(RADIO_BUTTON_ICON_DOT_CLASS).appendTo($radio);
                    var $radioContainer = (0, _renderer.default)("<div>").append($radio).addClass(RADIO_VALUE_CONTAINER_CLASS);
                    (0, _renderer.default)(itemElement).prepend($radioContainer)
                }
                _CollectionWidget.prototype._postprocessRenderItem.call(this, args)
            };
            _proto._processSelectableItem = function($itemElement, isSelected) {
                _CollectionWidget.prototype._processSelectableItem.call(this, $itemElement, isSelected);
                $itemElement.toggleClass(RADIO_BUTTON_CHECKED_CLASS, isSelected).find(".".concat(RADIO_BUTTON_ICON_CLASS)).first().toggleClass(RADIO_BUTTON_ICON_CHECKED_CLASS, isSelected);
                this.setAria("checked", isSelected, $itemElement)
            };
            _proto._refreshContent = function() {
                this._prepareContent();
                this._renderContent()
            };
            _proto._supportedKeys = function() {
                var parent = _CollectionWidget.prototype._supportedKeys.call(this);
                return (0, _extend.extend)({}, parent, {
                    enter: function(e) {
                        e.preventDefault();
                        return parent.enter.apply(this, arguments)
                    },
                    space: function(e) {
                        e.preventDefault();
                        return parent.space.apply(this, arguments)
                    }
                })
            };
            _proto._itemElements = function() {
                return this._itemContainer().children(this._itemSelector())
            };
            return RadioCollection
        }(_uiCollection_widget.default);
        var RadioGroup = function(_Editor) {
            _inheritsLoose(RadioGroup, _Editor);

            function RadioGroup() {
                return _Editor.apply(this, arguments) || this
            }
            var _proto2 = RadioGroup.prototype;
            _proto2._clean = function() {
                delete this._inkRipple;
                _Editor.prototype._clean.call(this)
            };
            _proto2._dataSourceOptions = function() {
                return {
                    paginate: false
                }
            };
            _proto2._defaultOptionsRules = function() {
                var defaultOptionsRules = _Editor.prototype._defaultOptionsRules.call(this);
                return defaultOptionsRules.concat([{
                    device: {
                        tablet: true
                    },
                    options: {
                        layout: "horizontal"
                    }
                }, {
                    device: function() {
                        return "desktop" === _devices.default.real().deviceType && !_devices.default.isSimulator()
                    },
                    options: {
                        focusStateEnabled: true
                    }
                }])
            };
            _proto2._fireContentReadyAction = function(force) {
                force && _Editor.prototype._fireContentReadyAction.call(this)
            };
            _proto2._focusTarget = function() {
                return this.$element()
            };
            _proto2._getAriaTarget = function() {
                return this.$element()
            };
            _proto2._getDefaultOptions = function() {
                var defaultOptions = _Editor.prototype._getDefaultOptions.call(this);
                return (0, _extend.extend)(defaultOptions, (0, _extend.extend)(_ui.default._dataExpressionDefaultOptions(), {
                    hoverStateEnabled: true,
                    activeStateEnabled: true,
                    layout: "vertical",
                    useInkRipple: false
                }))
            };
            _proto2._getItemValue = function(item) {
                return this._valueGetter ? this._valueGetter(item) : item.text
            };
            _proto2._getSubmitElement = function() {
                return this._$submitElement
            };
            _proto2._init = function() {
                _Editor.prototype._init.call(this);
                this._activeStateUnit = ".".concat(RADIO_BUTTON_CLASS);
                this._feedbackHideTimeout = RADIO_FEEDBACK_HIDE_TIMEOUT;
                this._initDataExpressions()
            };
            _proto2._initMarkup = function() {
                this.$element().addClass(RADIO_GROUP_CLASS);
                this._renderSubmitElement();
                this.setAria("role", "radiogroup");
                this._renderRadios();
                this.option("useInkRipple") && this._renderInkRipple();
                this._renderLayout();
                _Editor.prototype._initMarkup.call(this)
            };
            _proto2._itemClickHandler = function(_ref) {
                var itemElement = _ref.itemElement,
                    event = _ref.event,
                    itemData = _ref.itemData;
                if (this.itemElements().is(itemElement)) {
                    var newValue = this._getItemValue(itemData);
                    if (newValue !== this.option("value")) {
                        this._saveValueChangeEvent(event);
                        this.option("value", newValue)
                    }
                }
            };
            _proto2._setSelection = function(currentValue) {
                this._setCollectionWidgetOption("selectedItemKeys", [this._unwrappedValue(currentValue)])
            };
            _proto2._optionChanged = function(args) {
                var name = args.name,
                    value = args.value;
                this._dataExpressionOptionChanged(args);
                switch (name) {
                    case "useInkRipple":
                    case "dataSource":
                        this._invalidate();
                        break;
                    case "focusStateEnabled":
                    case "accessKey":
                    case "tabIndex":
                        this._setCollectionWidgetOption(name, value);
                        break;
                    case "disabled":
                        _Editor.prototype._optionChanged.call(this, args);
                        this._setCollectionWidgetOption(name, value);
                        break;
                    case "valueExpr":
                        this._setCollectionWidgetOption("keyExpr", this._getCollectionKeyExpr());
                        break;
                    case "value":
                        this._setSelection(value);
                        this._setSubmitValue(value);
                        _Editor.prototype._optionChanged.call(this, args);
                        break;
                    case "items":
                        this._setSelection(this.option("value"));
                        break;
                    case "itemTemplate":
                    case "displayExpr":
                        break;
                    case "layout":
                        this._renderLayout();
                        this._updateItemsSize();
                        break;
                    default:
                        _Editor.prototype._optionChanged.call(this, args)
                }
            };
            _proto2._render = function() {
                _Editor.prototype._render.call(this);
                this._updateItemsSize()
            };
            _proto2._renderInkRipple = function() {
                this._inkRipple = inkRipple.render({
                    waveSizeCoefficient: 3.3,
                    useHoldAnimation: false,
                    isCentered: true
                })
            };
            _proto2._renderLayout = function() {
                var layout = this.option("layout");
                var $element = this.$element();
                $element.toggleClass(RADIO_GROUP_VERTICAL_CLASS, "vertical" === layout);
                $element.toggleClass(RADIO_GROUP_HORIZONTAL_CLASS, "horizontal" === layout)
            };
            _proto2._renderRadios = function() {
                var _this2 = this;
                this._areRadiosCreated = new _deferred.Deferred;
                var $radios = (0, _renderer.default)("<div>").appendTo(this.$element());
                var _this$option = this.option(),
                    value = _this$option.value,
                    displayExpr = _this$option.displayExpr,
                    accessKey = _this$option.accessKey,
                    focusStateEnabled = _this$option.focusStateEnabled,
                    itemTemplate = _this$option.itemTemplate,
                    tabIndex = _this$option.tabIndex,
                    valueExpr = _this$option.valueExpr;
                var isNullSelectable = "this" !== valueExpr;
                this._createComponent($radios, RadioCollection, {
                    onInitialized: function(_ref2) {
                        var component = _ref2.component;
                        _this2._radios = component
                    },
                    onContentReady: function(e) {
                        _this2._fireContentReadyAction(true)
                    },
                    onItemClick: this._itemClickHandler.bind(this),
                    displayExpr: displayExpr,
                    accessKey: accessKey,
                    dataSource: this._dataSource,
                    focusStateEnabled: focusStateEnabled,
                    itemTemplate: itemTemplate,
                    keyExpr: this._getCollectionKeyExpr(),
                    noDataText: "",
                    scrollingEnabled: false,
                    selectionByClick: false,
                    selectionMode: "single",
                    selectedItemKeys: isNullSelectable || (0, _type.isDefined)(value) ? [value] : [],
                    tabIndex: tabIndex
                });
                this._areRadiosCreated.resolve()
            };
            _proto2._renderSubmitElement = function() {
                this._$submitElement = (0, _renderer.default)("<input>").attr("type", "hidden").appendTo(this.$element());
                this._setSubmitValue()
            };
            _proto2._setOptionsByReference = function() {
                _Editor.prototype._setOptionsByReference.call(this);
                (0, _extend.extend)(this._optionsByReference, {
                    value: true
                })
            };
            _proto2._setSubmitValue = function(value) {
                var _value;
                value = null !== (_value = value) && void 0 !== _value ? _value : this.option("value");
                var submitValue = "this" === this.option("valueExpr") ? this._displayGetter(value) : value;
                this._$submitElement.val(submitValue)
            };
            _proto2._setCollectionWidgetOption = function() {
                this._areRadiosCreated.done(this._setWidgetOption.bind(this, "_radios", arguments))
            };
            _proto2._toggleActiveState = function($element, value, e) {
                _Editor.prototype._toggleActiveState.call(this, $element, value, e);
                if (this._inkRipple) {
                    var event = {
                        element: $element.find(".".concat(RADIO_BUTTON_ICON_CLASS)),
                        event: e
                    };
                    value ? this._inkRipple.showWave(event) : this._inkRipple.hideWave(event)
                }
            };
            _proto2._updateItemsSize = function() {
                if ("horizontal" === this.option("layout")) {
                    this.itemElements().css("height", "auto")
                } else {
                    var itemsCount = this.option("items").length;
                    this.itemElements().css("height", 100 / itemsCount + "%")
                }
            };
            _proto2.focus = function() {
                var _this$_radios;
                null === (_this$_radios = this._radios) || void 0 === _this$_radios ? void 0 : _this$_radios.focus()
            };
            _proto2.itemElements = function() {
                var _this$_radios2;
                return null === (_this$_radios2 = this._radios) || void 0 === _this$_radios2 ? void 0 : _this$_radios2.itemElements()
            };
            return RadioGroup
        }(_editor.default);
        RadioGroup.include(_ui.default);
        (0, _component_registrator.default)("dxRadioGroup", RadioGroup);
        var _default = RadioGroup;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/range_slider.js ***!
      \*****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _slider = _interopRequireDefault(__webpack_require__( /*! ./slider */ 369));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./slider/ui.slider_handle */ 370));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _index = __webpack_require__( /*! ../events/utils/index */ 8);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../localization/message */ 10));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var RANGE_SLIDER_CLASS = "dx-rangeslider";
        var RANGE_SLIDER_START_HANDLE_CLASS = RANGE_SLIDER_CLASS + "-start-handle";
        var RANGE_SLIDER_END_HANDLE_CLASS = RANGE_SLIDER_CLASS + "-end-handle";
        var RangeSlider = _slider.default.inherit({
            _supportedKeys: function() {
                var isRTL = this.option("rtlEnabled");
                var that = this;
                var _changeHandle = function(e, capturedHandle) {
                    if (that.option("start") === that.option("end")) {
                        that._capturedHandle = capturedHandle;
                        e.target = that._capturedHandle;
                        _events_engine.default.trigger(that._capturedHandle, "focus")
                    }
                };
                var _setHandleValue = function(e, step, sign) {
                    var isStart = (0, _renderer.default)(e.target).hasClass(RANGE_SLIDER_START_HANDLE_CLASS);
                    var valueOption = isStart ? "start" : "end";
                    var val = that.option(valueOption);
                    step = that._valueStep(step);
                    val += sign * (isRTL ? -step : step);
                    that.option(valueOption, val)
                };
                var moveHandleRight = function(e, step) {
                    _changeHandle(e, isRTL ? that._$handleStart : that._$handleEnd);
                    _setHandleValue(e, step, 1)
                };
                var moveHandleLeft = function(e, step) {
                    _changeHandle(e, isRTL ? that._$handleEnd : that._$handleStart);
                    _setHandleValue(e, step, -1)
                };
                return (0, _extend.extend)(this.callBase(), {
                    leftArrow: function(e) {
                        this._processKeyboardEvent(e);
                        moveHandleLeft(e, this.option("step"))
                    },
                    rightArrow: function(e) {
                        this._processKeyboardEvent(e);
                        moveHandleRight(e, this.option("step"))
                    },
                    pageUp: function(e) {
                        this._processKeyboardEvent(e);
                        moveHandleRight(e, this.option("step") * this.option("keyStep"))
                    },
                    pageDown: function(e) {
                        this._processKeyboardEvent(e);
                        moveHandleLeft(e, this.option("step") * this.option("keyStep"))
                    },
                    home: function(e) {
                        this._processKeyboardEvent(e);
                        var isStart = (0, _renderer.default)(e.target).hasClass(RANGE_SLIDER_START_HANDLE_CLASS);
                        var valueOption = isStart ? "start" : "end";
                        var startOption = isStart ? "min" : "start";
                        var val = this.option(startOption);
                        this.option(valueOption, val)
                    },
                    end: function(e) {
                        this._processKeyboardEvent(e);
                        var isStart = (0, _renderer.default)(e.target).hasClass(RANGE_SLIDER_START_HANDLE_CLASS);
                        var valueOption = isStart ? "start" : "end";
                        var endOption = isStart ? "end" : "max";
                        var val = this.option(endOption);
                        this.option(valueOption, val)
                    }
                })
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    start: 40,
                    end: 60,
                    value: [40, 60],
                    startName: "",
                    endName: ""
                })
            },
            _renderSubmitElement: function() {
                var $element = this.$element();
                this._$submitStartElement = (0, _renderer.default)("<input>").attr("type", "hidden").attr("name", this.option("startName")).appendTo($element);
                this._$submitEndElement = (0, _renderer.default)("<input>").attr("type", "hidden").attr("name", this.option("endName")).appendTo($element)
            },
            _initOptions: function(options) {
                this.callBase(options);
                var initialValue = this.initialOption("value");
                var value = this.option("value");
                if (value[0] === initialValue[0] && value[1] === initialValue[1]) {
                    this.option("value", [this.option("start"), this.option("end")])
                } else {
                    this.option({
                        start: value[0],
                        end: value[1]
                    })
                }
            },
            _initMarkup: function() {
                this.$element().addClass(RANGE_SLIDER_CLASS);
                this.callBase()
            },
            _renderContentImpl: function() {
                this._callHandlerMethod("repaint");
                this.callBase()
            },
            _renderHandle: function() {
                this._$handleStart = this._renderHandleImpl(this.option("start"), this._$handleStart).addClass(RANGE_SLIDER_START_HANDLE_CLASS);
                this._$handleEnd = this._renderHandleImpl(this.option("end"), this._$handleEnd).addClass(RANGE_SLIDER_END_HANDLE_CLASS);
                this._updateHandleAriaLabels()
            },
            _startHandler: function(args) {
                var e = args.event;
                var $range = this._$range;
                var rangeWidth = $range.width();
                var eventOffsetX = (0, _index.eventData)(e).x - this._$bar.offset().left;
                var startHandleX = $range.position().left;
                var endHandleX = $range.position().left + rangeWidth;
                var rtlEnabled = this.option("rtlEnabled");
                var startHandleIsClosest = (rtlEnabled ? -1 : 1) * ((startHandleX + endHandleX) / 2 - eventOffsetX) > 0;
                this._capturedHandle = startHandleIsClosest ? this._$handleStart : this._$handleEnd;
                this.callBase(args)
            },
            _updateHandleAriaLabels: function() {
                this.setAria("label", _message.default.getFormatter("dxRangeSlider-ariaFrom")(this.option("dxRangeSlider-ariaFrom")), this._$handleStart);
                this.setAria("label", _message.default.getFormatter("dxRangeSlider-ariaTill")(this.option("dxRangeSlider-ariaTill")), this._$handleEnd)
            },
            _activeHandle: function() {
                return this._capturedHandle
            },
            _updateHandlePosition: function(e) {
                var rtlEnabled = this.option("rtlEnabled");
                var offsetDirection = rtlEnabled ? -1 : 1;
                var max = this.option("max");
                var min = this.option("min");
                var newRatio = this._startOffset + offsetDirection * e.event.offset / this._swipePixelRatio();
                newRatio = newRatio.toPrecision(12);
                var newValue = newRatio * (max - min) + min;
                this._updateSelectedRangePosition(newRatio, newRatio);
                _ui.default.getInstance(this._activeHandle()).fitTooltipPosition;
                this._changeValueOnSwipe(newRatio);
                var startValue = this.option("start");
                var endValue = this.option("end");
                var $nextHandle;
                if (startValue === endValue) {
                    if (newValue < startValue) {
                        $nextHandle = this._$handleStart
                    } else {
                        $nextHandle = this._$handleEnd
                    }
                    _events_engine.default.trigger($nextHandle, "focus");
                    if ($nextHandle && $nextHandle !== this._capturedHandle) {
                        this._updateSelectedRangePosition((startValue - min) / (max - min), (endValue - min) / (max - min));
                        this._toggleActiveState(this._activeHandle(), false);
                        this._toggleActiveState($nextHandle, true);
                        this._capturedHandle = $nextHandle
                    }
                    this._updateSelectedRangePosition(newRatio, newRatio);
                    this._changeValueOnSwipe(newRatio)
                }
            },
            _updateSelectedRangePosition: function(leftRatio, rightRatio) {
                var rtlEnabled = this.option("rtlEnabled");
                var moveRight = this._capturedHandle === this._$handleStart && rtlEnabled || this._capturedHandle === this._$handleEnd && !rtlEnabled;
                var prop = moveRight ? "right" : "left";
                if (rtlEnabled ^ moveRight) {
                    this._$range.css(prop, 100 - 100 * rightRatio + "%")
                } else {
                    this._$range.css(prop, 100 * leftRatio + "%")
                }
            },
            _setValueOnSwipe: function(value) {
                var option = this._capturedHandle === this._$handleStart ? "start" : "end";
                var start = this.option("start");
                var end = this.option("end");
                var max = this.option("max");
                var min = this.option("min");
                start = Math.min(Math.max(start, min), max);
                end = Math.min(Math.max(end, min), max);
                if ("start" === option) {
                    start = value > end ? end : value
                } else {
                    end = value < start ? start : value
                }
                this.option("value", [start, end])
            },
            _renderValue: function() {
                var valStart = this.option("start");
                var valEnd = this.option("end");
                var min = this.option("min");
                var max = this.option("max");
                var rtlEnabled = this.option("rtlEnabled");
                valStart = Math.max(min, Math.min(valStart, max));
                valEnd = Math.max(valStart, Math.min(valEnd, max));
                this._setOptionWithoutOptionChange("start", valStart);
                this._setOptionWithoutOptionChange("end", valEnd);
                this._setOptionWithoutOptionChange("value", [valStart, valEnd]);
                this._$submitStartElement.val((0, _common.applyServerDecimalSeparator)(valStart));
                this._$submitEndElement.val((0, _common.applyServerDecimalSeparator)(valEnd));
                var ratio1 = max === min ? 0 : (valStart - min) / (max - min);
                var ratio2 = max === min ? 0 : (valEnd - min) / (max - min);
                var startOffset = parseFloat((100 * ratio1).toPrecision(12)) + "%";
                var endOffset = parseFloat((100 * (1 - ratio2)).toPrecision(12)) + "%";
                !this._needPreventAnimation && this._setRangeStyles({
                    right: rtlEnabled ? startOffset : endOffset,
                    left: rtlEnabled ? endOffset : startOffset
                });
                _ui.default.getInstance(this._$handleStart).option("value", valStart);
                _ui.default.getInstance(this._$handleEnd).option("value", valEnd)
            },
            _callHandlerMethod: function(name, args) {
                _ui.default.getInstance(this._$handleStart)[name](args);
                _ui.default.getInstance(this._$handleEnd)[name](args)
            },
            _setValueOption: function() {
                var start = this.option("start");
                var end = this.option("end");
                this.option("value", [start, end])
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "value":
                        if (args.value[0] === args.previousValue[0] && args.value[1] === args.previousValue[1]) {
                            break
                        }
                        this._setOptionWithoutOptionChange("start", args.value[0]);
                        this._setOptionWithoutOptionChange("end", args.value[1]);
                        this._renderValue();
                        var start = this.option("start");
                        var end = this.option("end");
                        this._createActionByOption("onValueChanged", {
                            excludeValidators: ["disabled", "readOnly"]
                        })({
                            start: start,
                            end: end,
                            value: [start, end],
                            event: this._valueChangeEventInstance
                        });
                        this.validationRequest.fire({
                            value: [start, end],
                            editor: this
                        });
                        this._saveValueChangeEvent(void 0);
                        break;
                    case "start":
                    case "end":
                        this._setValueOption();
                        break;
                    case "startName":
                        this._$submitStartElement.attr("name", args.value);
                        break;
                    case "endName":
                        this._$submitEndElement.attr("name", args.value);
                        break;
                    case "name":
                        break;
                    default:
                        this.callBase(args)
                }
            }
        });
        (0, _component_registrator.default)("dxRangeSlider", RangeSlider);
        var _default = RangeSlider;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/slider/ui.slider.js ***!
      \*********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _click = __webpack_require__( /*! ../../events/click */ 21);
        var _emitter = __webpack_require__( /*! ../../events/core/emitter.feedback */ 149);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _swipeable = _interopRequireDefault(__webpack_require__( /*! ../../events/gesture/swipeable */ 172));
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../../events/pointer */ 24));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _number = _interopRequireDefault(__webpack_require__( /*! ../../localization/number */ 47));
        var _themes = __webpack_require__( /*! ../themes */ 34);
        var _track_bar = _interopRequireDefault(__webpack_require__( /*! ../track_bar */ 283));
        var _utils = __webpack_require__( /*! ../widget/utils.ink_ripple */ 82);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./ui.slider_handle */ 370));
        var _math = __webpack_require__( /*! ../../core/utils/math */ 29);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var SLIDER_CLASS = "dx-slider";
        var SLIDER_WRAPPER_CLASS = "dx-slider-wrapper";
        var SLIDER_HANDLE_SELECTOR = ".dx-slider-handle";
        var SLIDER_BAR_CLASS = "dx-slider-bar";
        var SLIDER_RANGE_CLASS = "dx-slider-range";
        var SLIDER_RANGE_VISIBLE_CLASS = "dx-slider-range-visible";
        var SLIDER_LABEL_CLASS = "dx-slider-label";
        var SLIDER_LABEL_POSITION_CLASS_PREFIX = "dx-slider-label-position-";
        var SLIDER_TOOLTIP_POSITION_CLASS_PREFIX = "dx-slider-tooltip-position-";
        var INVALID_MESSAGE_VISIBLE_CLASS = "dx-invalid-message-visible";
        var SLIDER_VALIDATION_NAMESPACE = "Validation";
        var Slider = _track_bar.default.inherit({
            _activeStateUnit: SLIDER_HANDLE_SELECTOR,
            _supportedKeys: function() {
                var _this = this;
                var isRTL = this.option("rtlEnabled");
                var roundedValue = function(offset, isLeftDirection) {
                    offset = _this._valueStep(offset);
                    var step = _this.option("step");
                    var value = _this.option("value");
                    var currentPosition = value - _this.option("min");
                    var remainder = (0, _math.getRemainderByDivision)(currentPosition, step, _this._getValueExponentLength());
                    var result = isLeftDirection ? value - offset + (remainder ? step - remainder : 0) : value + offset - remainder;
                    var min = _this.option("min");
                    var max = _this.option("max");
                    if (result < min) {
                        result = min
                    } else {
                        if (result > max) {
                            result = max
                        }
                    }
                    return _this._roundToExponentLength(result)
                };
                var moveHandleRight = function(offset) {
                    _this.option("value", roundedValue(offset, isRTL))
                };
                var moveHandleLeft = function(offset) {
                    _this.option("value", roundedValue(offset, !isRTL))
                };
                return (0, _extend.extend)(this.callBase(), {
                    leftArrow: function(e) {
                        this._processKeyboardEvent(e);
                        moveHandleLeft(this.option("step"))
                    },
                    rightArrow: function(e) {
                        this._processKeyboardEvent(e);
                        moveHandleRight(this.option("step"))
                    },
                    pageUp: function(e) {
                        this._processKeyboardEvent(e);
                        moveHandleRight(this.option("step") * this.option("keyStep"))
                    },
                    pageDown: function(e) {
                        this._processKeyboardEvent(e);
                        moveHandleLeft(this.option("step") * this.option("keyStep"))
                    },
                    home: function(e) {
                        this._processKeyboardEvent(e);
                        var min = this.option("min");
                        this.option("value", min)
                    },
                    end: function(e) {
                        this._processKeyboardEvent(e);
                        var max = this.option("max");
                        this.option("value", max)
                    }
                })
            },
            _processKeyboardEvent: function(e) {
                e.preventDefault();
                e.stopPropagation();
                this._saveValueChangeEvent(e)
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    value: 50,
                    hoverStateEnabled: true,
                    activeStateEnabled: true,
                    step: 1,
                    showRange: true,
                    tooltip: {
                        enabled: false,
                        format: function(value) {
                            return value
                        },
                        position: "top",
                        showMode: "onHover"
                    },
                    label: {
                        visible: false,
                        position: "bottom",
                        format: function(value) {
                            return value
                        }
                    },
                    keyStep: 1,
                    useInkRipple: false,
                    validationMessageOffset: (0, _themes.isMaterial)() ? {
                        h: 18,
                        v: 0
                    } : {
                        h: 7,
                        v: 4
                    },
                    focusStateEnabled: true
                })
            },
            _toggleValidationMessage: function(visible) {
                if (!this.option("isValid")) {
                    this.$element().toggleClass(INVALID_MESSAGE_VISIBLE_CLASS, visible)
                }
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: function() {
                        return "desktop" === _devices.default.real().deviceType && !_devices.default.isSimulator()
                    },
                    options: {
                        focusStateEnabled: true
                    }
                }, {
                    device: function() {
                        var themeName = (0, _themes.current)();
                        return (0, _themes.isMaterial)(themeName)
                    },
                    options: {
                        useInkRipple: true
                    }
                }])
            },
            _initMarkup: function() {
                this.$element().addClass(SLIDER_CLASS);
                this._renderSubmitElement();
                this.option("useInkRipple") && this._renderInkRipple();
                this.callBase();
                this._renderLabels();
                this._renderStartHandler();
                this._renderAriaMinAndMax()
            },
            _attachFocusEvents: function() {
                this.callBase();
                var namespace = this.NAME + SLIDER_VALIDATION_NAMESPACE;
                var focusInEvent = (0, _index.addNamespace)("focusin", namespace);
                var focusOutEvent = (0, _index.addNamespace)("focusout", namespace);
                var $focusTarget = this._focusTarget();
                _events_engine.default.on($focusTarget, focusInEvent, this._toggleValidationMessage.bind(this, true));
                _events_engine.default.on($focusTarget, focusOutEvent, this._toggleValidationMessage.bind(this, false))
            },
            _detachFocusEvents: function() {
                this.callBase();
                var $focusTarget = this._focusTarget();
                this._toggleValidationMessage(false);
                _events_engine.default.off($focusTarget, this.NAME + SLIDER_VALIDATION_NAMESPACE)
            },
            _render: function() {
                this.callBase();
                this._repaintHandle()
            },
            _renderSubmitElement: function() {
                this._$submitElement = (0, _renderer.default)("<input>").attr("type", "hidden").appendTo(this.$element())
            },
            _getSubmitElement: function() {
                return this._$submitElement
            },
            _renderInkRipple: function() {
                this._inkRipple = (0, _utils.render)({
                    waveSizeCoefficient: .7,
                    isCentered: true,
                    wavesNumber: 2,
                    useHoldAnimation: false
                })
            },
            _renderInkWave: function(element, dxEvent, doRender, waveIndex) {
                if (!this._inkRipple) {
                    return
                }
                var config = {
                    element: element,
                    event: dxEvent,
                    wave: waveIndex
                };
                if (doRender) {
                    this._inkRipple.showWave(config)
                } else {
                    this._inkRipple.hideWave(config)
                }
            },
            _visibilityChanged: function() {
                this.repaint()
            },
            _renderWrapper: function() {
                this.callBase();
                this._$wrapper.addClass(SLIDER_WRAPPER_CLASS);
                this._createComponent(this._$wrapper, _swipeable.default, {
                    elastic: false,
                    immediate: true,
                    onStart: this._swipeStartHandler.bind(this),
                    onUpdated: this._swipeUpdateHandler.bind(this),
                    onEnd: this._swipeEndHandler.bind(this),
                    itemSizeFunc: this._itemWidthFunc.bind(this)
                })
            },
            _renderContainer: function() {
                this.callBase();
                this._$bar.addClass(SLIDER_BAR_CLASS)
            },
            _renderRange: function() {
                this.callBase();
                this._$range.addClass(SLIDER_RANGE_CLASS);
                this._renderHandle();
                this._renderRangeVisibility()
            },
            _renderRangeVisibility: function() {
                this._$range.toggleClass(SLIDER_RANGE_VISIBLE_CLASS, Boolean(this.option("showRange")))
            },
            _renderHandle: function() {
                this._$handle = this._renderHandleImpl(this.option("value"), this._$handle)
            },
            _renderHandleImpl: function(value, $element) {
                var $handle = $element || (0, _renderer.default)("<div>").appendTo(this._$range);
                var format = this.option("tooltip.format");
                var tooltipEnabled = this.option("tooltip.enabled");
                var tooltipPosition = this.option("tooltip.position");
                this.$element().toggleClass(SLIDER_TOOLTIP_POSITION_CLASS_PREFIX + "bottom", tooltipEnabled && "bottom" === tooltipPosition).toggleClass(SLIDER_TOOLTIP_POSITION_CLASS_PREFIX + "top", tooltipEnabled && "top" === tooltipPosition);
                this._createComponent($handle, _ui.default, {
                    value: value,
                    tooltipEnabled: tooltipEnabled,
                    tooltipPosition: tooltipPosition,
                    tooltipFormat: format,
                    tooltipShowMode: this.option("tooltip.showMode"),
                    tooltipFitIn: this.$element()
                });
                return $handle
            },
            _renderAriaMinAndMax: function() {
                this.setAria({
                    valuemin: this.option("min"),
                    valuemax: this.option("max")
                }, this._$handle)
            },
            _hoverStartHandler: function(e) {
                _ui.default.getInstance((0, _renderer.default)(e.currentTarget)).updateTooltip()
            },
            _toggleActiveState: function($element, value) {
                this.callBase($element, value);
                if (value) {
                    _ui.default.getInstance($element).updateTooltip()
                }
                this._renderInkWave($element, null, !!value, 1)
            },
            _toggleFocusClass: function(isFocused, $element) {
                this.callBase(isFocused, $element);
                if (this._disposed) {
                    return
                }
                var $focusTarget = (0, _renderer.default)($element || this._focusTarget());
                this._renderInkWave($focusTarget, null, isFocused, 0)
            },
            _renderLabels: function() {
                this.$element().removeClass(SLIDER_LABEL_POSITION_CLASS_PREFIX + "bottom").removeClass(SLIDER_LABEL_POSITION_CLASS_PREFIX + "top");
                if (this.option("label.visible")) {
                    var min = this.option("min");
                    var max = this.option("max");
                    var position = this.option("label.position");
                    var labelFormat = this.option("label.format");
                    if (!this._$minLabel) {
                        this._$minLabel = (0, _renderer.default)("<div>").addClass(SLIDER_LABEL_CLASS).appendTo(this._$wrapper)
                    }
                    this._$minLabel.html(_number.default.format(min, labelFormat));
                    if (!this._$maxLabel) {
                        this._$maxLabel = (0, _renderer.default)("<div>").addClass(SLIDER_LABEL_CLASS).appendTo(this._$wrapper)
                    }
                    this._$maxLabel.html(_number.default.format(max, labelFormat));
                    this.$element().addClass(SLIDER_LABEL_POSITION_CLASS_PREFIX + position)
                } else {
                    if (this._$minLabel) {
                        this._$minLabel.remove();
                        delete this._$minLabel
                    }
                    if (this._$maxLabel) {
                        this._$maxLabel.remove();
                        delete this._$maxLabel
                    }
                }
            },
            _renderStartHandler: function() {
                var _this2 = this;
                var pointerDownEventName = (0, _index.addNamespace)(_pointer.default.down, this.NAME);
                var clickEventName = (0, _index.addNamespace)(_click.name, this.NAME);
                var startAction = this._createAction(this._startHandler.bind(this));
                var $element = this.$element();
                _events_engine.default.off($element, pointerDownEventName);
                _events_engine.default.on($element, pointerDownEventName, function(e) {
                    if ((0, _index.isMouseEvent)(e)) {
                        startAction({
                            event: e
                        })
                    }
                });
                _events_engine.default.off($element, clickEventName);
                _events_engine.default.on($element, clickEventName, function(e) {
                    var $handle = _this2._activeHandle();
                    if ($handle) {
                        _events_engine.default.trigger($handle, "focusin");
                        _events_engine.default.trigger($handle, "focus")
                    }
                    startAction({
                        event: e
                    })
                })
            },
            _itemWidthFunc: function() {
                return this._itemWidthRatio
            },
            _swipeStartHandler: function(e) {
                var rtlEnabled = this.option("rtlEnabled");
                if ((0, _index.isTouchEvent)(e.event)) {
                    this._createAction(this._startHandler.bind(this))({
                        event: e.event
                    })
                }
                this._feedbackDeferred = new _deferred.Deferred;
                (0, _emitter.lock)(this._feedbackDeferred);
                this._toggleActiveState(this._activeHandle(), this.option("activeStateEnabled"));
                this._startOffset = this._currentRatio;
                var startOffset = this._startOffset * this._swipePixelRatio();
                var endOffset = (1 - this._startOffset) * this._swipePixelRatio();
                e.event.maxLeftOffset = rtlEnabled ? endOffset : startOffset;
                e.event.maxRightOffset = rtlEnabled ? startOffset : endOffset;
                this._itemWidthRatio = this.$element().width() / this._swipePixelRatio();
                this._needPreventAnimation = true
            },
            _swipeEndHandler: function(e) {
                this._feedbackDeferred.resolve();
                this._toggleActiveState(this._activeHandle(), false);
                var offsetDirection = this.option("rtlEnabled") ? -1 : 1;
                delete this._needPreventAnimation;
                this._saveValueChangeEvent(e.event);
                this._changeValueOnSwipe(this._startOffset + offsetDirection * e.event.targetOffset / this._swipePixelRatio());
                delete this._startOffset;
                this._renderValue()
            },
            _activeHandle: function() {
                return this._$handle
            },
            _swipeUpdateHandler: function(e) {
                this._saveValueChangeEvent(e.event);
                this._updateHandlePosition(e)
            },
            _updateHandlePosition: function(e) {
                var offsetDirection = this.option("rtlEnabled") ? -1 : 1;
                var newRatio = Math.min(this._startOffset + offsetDirection * e.event.offset / this._swipePixelRatio(), 1);
                this._$range.width(100 * newRatio + "%");
                _ui.default.getInstance(this._activeHandle()).fitTooltipPosition;
                this._changeValueOnSwipe(newRatio)
            },
            _swipePixelRatio: function() {
                var min = this.option("min");
                var max = this.option("max");
                var step = this._valueStep(this.option("step"));
                return (max - min) / step
            },
            _valueStep: function(step) {
                if (!step || isNaN(step)) {
                    step = 1
                }
                return step
            },
            _getValueExponentLength: function() {
                var _this$option = this.option(),
                    step = _this$option.step,
                    min = _this$option.min;
                return Math.max((0, _math.getExponentLength)(step), (0, _math.getExponentLength)(min))
            },
            _roundToExponentLength: function(value) {
                var valueExponentLength = this._getValueExponentLength();
                return (0, _math.roundFloatPart)(value, valueExponentLength)
            },
            _changeValueOnSwipe: function(ratio) {
                var min = this.option("min");
                var max = this.option("max");
                var step = this._valueStep(this.option("step"));
                var newChange = ratio * (max - min);
                var newValue = min + newChange;
                if (step < 0) {
                    return
                }
                if (newValue === max || newValue === min) {
                    this._setValueOnSwipe(newValue)
                } else {
                    var stepCount = Math.round((newValue - min) / step);
                    newValue = this._roundToExponentLength(stepCount * step + min);
                    this._setValueOnSwipe(Math.max(Math.min(newValue, max), min))
                }
            },
            _setValueOnSwipe: function(value) {
                this.option("value", value);
                this._saveValueChangeEvent(void 0)
            },
            _startHandler: function(args) {
                var e = args.event;
                this._currentRatio = ((0, _index.eventData)(e).x - this._$bar.offset().left) / this._$bar.width();
                if (this.option("rtlEnabled")) {
                    this._currentRatio = 1 - this._currentRatio
                }
                this._saveValueChangeEvent(e);
                this._changeValueOnSwipe(this._currentRatio)
            },
            _renderValue: function() {
                this.callBase();
                var value = this.option("value");
                this._getSubmitElement().val((0, _common.applyServerDecimalSeparator)(value));
                _ui.default.getInstance(this._activeHandle()).option("value", value)
            },
            _setRangeStyles: function(options) {
                options && this._$range.css(options)
            },
            _callHandlerMethod: function(name, args) {
                _ui.default.getInstance(this._$handle)[name](args)
            },
            _repaintHandle: function() {
                this._callHandlerMethod("repaint")
            },
            _fitTooltip: function() {
                this._callHandlerMethod("fitTooltipPosition")
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "visible":
                        this.callBase(args);
                        this._renderHandle();
                        this._repaintHandle();
                        break;
                    case "min":
                    case "max":
                        this._renderValue();
                        this.callBase(args);
                        this._renderLabels();
                        this._renderAriaMinAndMax();
                        this._fitTooltip();
                        break;
                    case "step":
                        this._renderValue();
                        break;
                    case "keyStep":
                        break;
                    case "showRange":
                        this._renderRangeVisibility();
                        break;
                    case "tooltip":
                        this._renderHandle();
                        break;
                    case "label":
                        this._renderLabels();
                        break;
                    case "useInkRipple":
                        this._invalidate();
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _refresh: function() {
                this._toggleRTLDirection(this.option("rtlEnabled"));
                this._renderDimensions();
                this._renderValue();
                this._renderHandle();
                this._repaintHandle()
            },
            _clean: function() {
                delete this._inkRipple;
                this.callBase()
            }
        });
        (0, _component_registrator.default)("dxSlider", Slider);
        var _default = Slider;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/speed_dial_action.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _speed_dial_action = _interopRequireDefault(__webpack_require__( /*! ./speed_dial_action/speed_dial_action */ 680));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _speed_dial_action.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/speed_dial_action/speed_dial_action.js ***!
      \****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _guid = _interopRequireDefault(__webpack_require__( /*! ../../core/guid */ 36));
        var _ready_callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/ready_callbacks */ 49));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _speed_dial_main_item = __webpack_require__( /*! ./speed_dial_main_item */ 341);
        var _swatch_container = _interopRequireDefault(__webpack_require__( /*! ../widget/swatch_container */ 170));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var getSwatchContainer = _swatch_container.default.getSwatchContainer;
        var ready = _ready_callbacks.default.add;
        var SpeedDialAction = function(_Widget) {
            _inheritsLoose(SpeedDialAction, _Widget);

            function SpeedDialAction() {
                return _Widget.apply(this, arguments) || this
            }
            var _proto = SpeedDialAction.prototype;
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_Widget.prototype._getDefaultOptions.call(this), {
                    icon: "",
                    onClick: null,
                    label: "",
                    visible: true,
                    index: 0,
                    onContentReady: null,
                    activeStateEnabled: true,
                    hoverStateEnabled: true,
                    animation: {
                        show: {
                            type: "pop",
                            duration: 200,
                            easing: "cubic-bezier(0.4, 0, 0.2, 1)",
                            from: {
                                scale: 0,
                                opacity: 0
                            },
                            to: {
                                scale: 1,
                                opacity: 1
                            }
                        },
                        hide: {
                            type: "pop",
                            duration: 200,
                            easing: "cubic-bezier(0.4, 0, 0.2, 1)",
                            from: {
                                scale: 1,
                                opacity: 1
                            },
                            to: {
                                scale: 0,
                                opacity: 0
                            }
                        }
                    },
                    id: new _guid.default
                })
            };
            _proto._optionChanged = function(args) {
                switch (args.name) {
                    case "onClick":
                    case "icon":
                    case "label":
                    case "visible":
                    case "index":
                    case "onInitializing":
                        (0, _speed_dial_main_item.initAction)(this);
                        break;
                    case "animation":
                    case "id":
                        break;
                    default:
                        _Widget.prototype._optionChanged.call(this, args)
                }
            };
            _proto._render = function() {
                var _this = this;
                this._toggleVisibility(false);
                if (!getSwatchContainer(this.$element())) {
                    ready(function() {
                        return (0, _speed_dial_main_item.initAction)(_this)
                    })
                } else {
                    (0, _speed_dial_main_item.initAction)(this)
                }
            };
            _proto._dispose = function() {
                (0, _speed_dial_main_item.disposeAction)(this._options.silent("id"));
                _Widget.prototype._dispose.call(this)
            };
            return SpeedDialAction
        }(_ui.default);
        (0, _component_registrator.default)("dxSpeedDialAction", SpeedDialAction);
        var _default = SpeedDialAction;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/core/utils/scroll_rtl_behavior.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../dom_adapter */ 11));
        var _call_once = _interopRequireDefault(__webpack_require__( /*! ./call_once */ 85));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var getScrollRtlBehavior = (0, _call_once.default)(function() {
            var document = _dom_adapter.default.getDocument();
            document.body.insertAdjacentHTML("beforeend", "<div style='direction: rtl;\n       position: absolute; left: 0; top: -1; overflow: hidden; width: 1px;\n       height: 1px;'><div style='width: 2px; height: 1px;'></div></div>");
            var scroller = document.body.lastElementChild;
            var initiallyPositive = scroller.scrollLeft > 0;
            scroller.scrollLeft = -1;
            var hasNegative = scroller.scrollLeft < 0;
            var result = {
                decreasing: hasNegative || initiallyPositive,
                positive: !hasNegative
            };
            document.body.removeChild(scroller);
            return result
        });
        var _default = getScrollRtlBehavior;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tile_view.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../core/devices */ 13));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _inflector = __webpack_require__( /*! ../core/utils/inflector */ 39);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _element = __webpack_require__( /*! ../core/element */ 18);
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _scroll_view = _interopRequireDefault(__webpack_require__( /*! ./scroll_view */ 90));
        var _uiCollection_widget = _interopRequireDefault(__webpack_require__( /*! ./collection/ui.collection_widget.edit */ 54));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var TILEVIEW_CLASS = "dx-tileview";
        var TILEVIEW_CONTAINER_CLASS = "dx-tileview-wrapper";
        var TILEVIEW_ITEM_CLASS = "dx-tile";
        var TILEVIEW_ITEM_SELECTOR = "." + TILEVIEW_ITEM_CLASS;
        var TILEVIEW_ITEM_DATA_KEY = "dxTileData";
        var CONFIGS = {
            horizontal: {
                itemMainRatio: "widthRatio",
                itemCrossRatio: "heightRatio",
                baseItemMainDimension: "baseItemWidth",
                baseItemCrossDimension: "baseItemHeight",
                mainDimension: "width",
                crossDimension: "height",
                mainPosition: "left",
                crossPosition: "top"
            },
            vertical: {
                itemMainRatio: "heightRatio",
                itemCrossRatio: "widthRatio",
                baseItemMainDimension: "baseItemHeight",
                baseItemCrossDimension: "baseItemWidth",
                mainDimension: "height",
                crossDimension: "width",
                mainPosition: "top",
                crossPosition: "left"
            }
        };
        var TileView = _uiCollection_widget.default.inherit({
            _activeStateUnit: TILEVIEW_ITEM_SELECTOR,
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    items: null,
                    direction: "horizontal",
                    hoverStateEnabled: true,
                    showScrollbar: false,
                    height: 500,
                    baseItemWidth: 100,
                    baseItemHeight: 100,
                    itemMargin: 20,
                    activeStateEnabled: true,
                    indicateLoading: true
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: function() {
                        return "desktop" === _devices.default.real().deviceType && !_devices.default.isSimulator()
                    },
                    options: {
                        focusStateEnabled: true
                    }
                }])
            },
            _itemClass: function() {
                return TILEVIEW_ITEM_CLASS
            },
            _itemDataKey: function() {
                return TILEVIEW_ITEM_DATA_KEY
            },
            _itemContainer: function() {
                return this._$container
            },
            _init: function() {
                this.callBase();
                this.$element().addClass(TILEVIEW_CLASS);
                this._initScrollView()
            },
            _dataSourceLoadingChangedHandler: function(isLoading) {
                var scrollView = this._scrollView;
                if (!scrollView || !scrollView.startLoading) {
                    return
                }
                if (isLoading && this.option("indicateLoading")) {
                    scrollView.startLoading()
                } else {
                    scrollView.finishLoading()
                }
            },
            _hideLoadingIfLoadIndicationOff: function() {
                if (!this.option("indicateLoading")) {
                    this._dataSourceLoadingChangedHandler(false)
                }
            },
            _initScrollView: function() {
                this._scrollView = this._createComponent(this.$element(), _scroll_view.default, {
                    direction: this.option("direction"),
                    scrollByContent: true,
                    useKeyboard: false,
                    showScrollbar: this.option("showScrollbar")
                });
                this._$container = (0, _renderer.default)(this._scrollView.content());
                this._$container.addClass(TILEVIEW_CONTAINER_CLASS);
                this._scrollView.option("onUpdated", this._renderGeometry.bind(this))
            },
            _initMarkup: function() {
                this.callBase();
                (0, _common.deferRender)(function() {
                    this._cellsPerDimension = 1;
                    this._renderGeometry();
                    this._updateScrollView();
                    this._fireContentReadyAction()
                }.bind(this))
            },
            _updateScrollView: function() {
                this._scrollView.option("direction", this.option("direction"));
                this._scrollView.update();
                this._indicateLoadingIfAlreadyStarted()
            },
            _indicateLoadingIfAlreadyStarted: function() {
                if (this._isDataSourceLoading()) {
                    this._dataSourceLoadingChangedHandler(true)
                }
            },
            _renderGeometry: function() {
                this._config = CONFIGS[this.option("direction")];
                var items = this.option("items") || [];
                var config = this._config;
                var itemMargin = this.option("itemMargin");
                var maxItemCrossRatio = Math.max.apply(Math, (0, _iterator.map)(items || [], function(item) {
                    return Math.round(item[config.itemCrossRatio] || 1)
                }));
                var crossDimensionValue = (0, _window.hasWindow)() ? this.$element()[config.crossDimension]() : parseInt(this.$element().get(0).style[config.crossDimension]);
                this._cellsPerDimension = Math.floor(crossDimensionValue / (this.option(config.baseItemCrossDimension) + itemMargin));
                this._cellsPerDimension = Math.max(this._cellsPerDimension, maxItemCrossRatio);
                this._cells = [];
                this._cells.push(new Array(this._cellsPerDimension));
                this._arrangeItems(items);
                this._renderContentSize(config, itemMargin)
            },
            _renderContentSize: function(_ref, itemMargin) {
                var mainDimension = _ref.mainDimension,
                    baseItemMainDimension = _ref.baseItemMainDimension;
                if ((0, _window.hasWindow)()) {
                    var actualContentSize = this._cells.length * this.option(baseItemMainDimension) + (this._cells.length + 1) * itemMargin;
                    var elementSize = this.$element()[mainDimension]();
                    this._$container[mainDimension](Math.max(actualContentSize, elementSize))
                }
            },
            _arrangeItems: function(items) {
                var config = this._config;
                var itemMainRatio = config.itemMainRatio;
                var itemCrossRatio = config.itemCrossRatio;
                var mainPosition = config.mainPosition;
                this._itemsPositions = [];
                (0, _iterator.each)(items, function(index, item) {
                    var currentItem = {};
                    currentItem[itemMainRatio] = item[itemMainRatio] || 1;
                    currentItem[itemCrossRatio] = item[itemCrossRatio] || 1;
                    currentItem.index = index;
                    currentItem[itemMainRatio] = currentItem[itemMainRatio] <= 0 ? 0 : Math.round(currentItem[config.itemMainRatio]);
                    currentItem[itemCrossRatio] = currentItem[itemCrossRatio] <= 0 ? 0 : Math.round(currentItem[config.itemCrossRatio]);
                    var itemPosition = this._getItemPosition(currentItem);
                    if (itemPosition[mainPosition] === -1) {
                        itemPosition[mainPosition] = this._cells.push(new Array(this._cellsPerDimension)) - 1
                    }
                    this._occupyCells(currentItem, itemPosition);
                    this._arrangeItem(currentItem, itemPosition);
                    this._itemsPositions.push(itemPosition)
                }.bind(this))
            },
            _getItemPosition: function(item) {
                var config = this._config;
                var mainPosition = config.mainPosition;
                var crossPosition = config.crossPosition;
                var position = {};
                position[mainPosition] = -1;
                position[crossPosition] = 0;
                for (var main = 0; main < this._cells.length; main++) {
                    for (var cross = 0; cross < this._cellsPerDimension; cross++) {
                        if (this._itemFit(main, cross, item)) {
                            position[mainPosition] = main;
                            position[crossPosition] = cross;
                            break
                        }
                    }
                    if (position[mainPosition] > -1) {
                        break
                    }
                }
                return position
            },
            _itemFit: function(mainPosition, crossPosition, item) {
                var result = true;
                var config = this._config;
                var itemRatioMain = item[config.itemMainRatio];
                var itemRatioCross = item[config.itemCrossRatio];
                if (crossPosition + itemRatioCross > this._cellsPerDimension) {
                    return false
                }
                for (var main = mainPosition; main < mainPosition + itemRatioMain; main++) {
                    for (var cross = crossPosition; cross < crossPosition + itemRatioCross; cross++) {
                        if (this._cells.length - 1 < main) {
                            this._cells.push(new Array(this._cellsPerDimension))
                        } else {
                            if (void 0 !== this._cells[main][cross]) {
                                result = false;
                                break
                            }
                        }
                    }
                }
                return result
            },
            _occupyCells: function(item, itemPosition) {
                var config = this._config;
                var itemPositionMain = itemPosition[config.mainPosition];
                var itemPositionCross = itemPosition[config.crossPosition];
                var itemRatioMain = item[config.itemMainRatio];
                var itemRatioCross = item[config.itemCrossRatio];
                for (var main = itemPositionMain; main < itemPositionMain + itemRatioMain; main++) {
                    for (var cross = itemPositionCross; cross < itemPositionCross + itemRatioCross; cross++) {
                        this._cells[main][cross] = item.index
                    }
                }
            },
            _arrangeItem: function(item, itemPosition) {
                var config = this._config;
                var itemPositionMain = itemPosition[config.mainPosition];
                var itemPositionCross = itemPosition[config.crossPosition];
                var itemRatioMain = item[config.itemMainRatio];
                var itemRatioCross = item[config.itemCrossRatio];
                var baseItemCross = this.option(config.baseItemCrossDimension);
                var baseItemMain = this.option(config.baseItemMainDimension);
                var itemMargin = this.option("itemMargin");
                var cssProps = {
                    display: itemRatioMain <= 0 || itemRatioCross <= 0 ? "none" : ""
                };
                var mainDimension = itemRatioMain * baseItemMain + (itemRatioMain - 1) * itemMargin;
                var crossDimension = itemRatioCross * baseItemCross + (itemRatioCross - 1) * itemMargin;
                cssProps[config.mainDimension] = mainDimension < 0 ? 0 : mainDimension;
                cssProps[config.crossDimension] = crossDimension < 0 ? 0 : crossDimension;
                cssProps[config.mainPosition] = itemPositionMain * baseItemMain + (itemPositionMain + 1) * itemMargin;
                cssProps[config.crossPosition] = itemPositionCross * baseItemCross + (itemPositionCross + 1) * itemMargin;
                if (this.option("rtlEnabled")) {
                    var offsetCorrection = this._$container.width();
                    var baseItemWidth = this.option("baseItemWidth");
                    var itemPositionX = itemPosition.left;
                    var offsetPosition = itemPositionX * baseItemWidth;
                    var itemBaseOffset = baseItemWidth + itemMargin;
                    var itemWidth = itemBaseOffset * item.widthRatio;
                    var subItemMargins = itemPositionX * itemMargin;
                    cssProps.left = offsetCorrection - (offsetPosition + itemWidth + subItemMargins)
                }
                this._itemElements().eq(item.index).css(cssProps)
            },
            _moveFocus: function(location) {
                var FOCUS_UP = "up";
                var FOCUS_DOWN = "down";
                var FOCUS_LEFT = this.option("rtlEnabled") ? "right" : "left";
                var FOCUS_RIGHT = this.option("rtlEnabled") ? "left" : "right";
                var FOCUS_PAGE_UP = "pageup";
                var FOCUS_PAGE_DOWN = "pagedown";
                var horizontalDirection = "horizontal" === this.option("direction");
                var cells = this._cells;
                var index = (0, _renderer.default)(this.option("focusedElement")).index();
                var targetCol = this._itemsPositions[index].left;
                var targetRow = this._itemsPositions[index].top;
                var colCount = (horizontalDirection ? cells : cells[0]).length;
                var rowCount = (horizontalDirection ? cells[0] : cells).length;
                var getCell = function(col, row) {
                    if (horizontalDirection) {
                        return cells[col][row]
                    }
                    return cells[row][col]
                };
                switch (location) {
                    case FOCUS_PAGE_UP:
                    case FOCUS_UP:
                        while (targetRow > 0 && index === getCell(targetCol, targetRow)) {
                            targetRow--
                        }
                        if (targetRow < 0) {
                            targetRow = 0
                        }
                        break;
                    case FOCUS_PAGE_DOWN:
                    case FOCUS_DOWN:
                        while (targetRow < rowCount && index === getCell(targetCol, targetRow)) {
                            targetRow++
                        }
                        if (targetRow === rowCount) {
                            targetRow = rowCount - 1
                        }
                        break;
                    case FOCUS_RIGHT:
                        while (targetCol < colCount && index === getCell(targetCol, targetRow)) {
                            targetCol++
                        }
                        if (targetCol === colCount) {
                            targetCol = colCount - 1
                        }
                        break;
                    case FOCUS_LEFT:
                        while (targetCol >= 0 && index === getCell(targetCol, targetRow)) {
                            targetCol--
                        }
                        if (targetCol < 0) {
                            targetCol = 0
                        }
                        break;
                    default:
                        this.callBase.apply(this, arguments);
                        return
                }
                var newTargetIndex = getCell(targetCol, targetRow);
                if (!(0, _type.isDefined)(newTargetIndex)) {
                    return
                }
                var $newTarget = this._itemElements().eq(newTargetIndex);
                this.option("focusedElement", (0, _element.getPublicElement)($newTarget));
                this._scrollToItem($newTarget)
            },
            _scrollToItem: function($itemElement) {
                if (!$itemElement.length) {
                    return
                }
                var config = this._config;
                var outerMainProp = "outer" + (0, _inflector.captionize)(config.mainDimension);
                var itemMargin = this.option("itemMargin");
                var itemPosition = $itemElement.position()[config.mainPosition];
                var itemDimension = $itemElement[outerMainProp]();
                var itemTail = itemPosition + itemDimension;
                var scrollPosition = this.scrollPosition();
                var clientWidth = this.$element()[outerMainProp]();
                if (scrollPosition <= itemPosition && itemTail <= scrollPosition + clientWidth) {
                    return
                }
                if (scrollPosition > itemPosition) {
                    this._scrollView.scrollTo(itemPosition - itemMargin)
                } else {
                    this._scrollView.scrollTo(itemPosition + itemDimension - clientWidth + itemMargin)
                }
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "items":
                        this.callBase(args);
                        this._renderGeometry();
                        this._updateScrollView();
                        break;
                    case "showScrollbar":
                        this._initScrollView();
                        break;
                    case "disabled":
                        this._scrollView.option("disabled", args.value);
                        this.callBase(args);
                        break;
                    case "baseItemWidth":
                    case "baseItemHeight":
                    case "itemMargin":
                        this._renderGeometry();
                        break;
                    case "width":
                    case "height":
                        this.callBase(args);
                        this._renderGeometry();
                        this._updateScrollView();
                        break;
                    case "direction":
                        this._renderGeometry();
                        this._updateScrollView();
                        break;
                    case "indicateLoading":
                        this._hideLoadingIfLoadIndicationOff();
                        break;
                    default:
                        this.callBase(args)
                }
            },
            scrollPosition: function() {
                return this._scrollView.scrollOffset()[this._config.mainPosition]
            }
        });
        (0, _component_registrator.default)("dxTileView", TileView);
        var _default = TileView;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/html_editor/converters/markdown.js ***!
      \************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _turndown = _interopRequireDefault(__webpack_require__( /*! turndown */ 684));
        var _showdown = _interopRequireDefault(__webpack_require__( /*! showdown */ 685));
        var _window = __webpack_require__( /*! ../../../core/utils/window */ 7);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../../widget/ui.errors */ 17));
        var _converterController = _interopRequireDefault(__webpack_require__( /*! ../converterController */ 287));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var MarkdownConverter = function() {
            function MarkdownConverter() {
                var _this$_html2Markdown;
                var window = (0, _window.getWindow)();
                var turndown = window && window.TurndownService || _turndown.default;
                var showdown = window && window.showdown || _showdown.default;
                if (!turndown) {
                    throw _ui.default.Error("E1041", "Turndown")
                }
                if (!showdown) {
                    throw _ui.default.Error("E1041", "Showdown")
                }
                this._html2Markdown = new turndown;
                if (null !== (_this$_html2Markdown = this._html2Markdown) && void 0 !== _this$_html2Markdown && _this$_html2Markdown.addRule) {
                    this._html2Markdown.addRule("emptyLine", {
                        filter: function(element) {
                            return "p" === element.nodeName.toLowerCase() && "<br>" === element.innerHTML
                        },
                        replacement: function() {
                            return "<br>"
                        }
                    })
                }
                this._markdown2Html = new showdown.Converter({
                    simpleLineBreaks: true,
                    strikethrough: true
                })
            }
            var _proto = MarkdownConverter.prototype;
            _proto.toMarkdown = function(htmlMarkup) {
                return this._html2Markdown.turndown(htmlMarkup || "")
            };
            _proto.toHtml = function(markdownMarkup) {
                var markup = this._markdown2Html.makeHtml(markdownMarkup);
                if (markup) {
                    markup = markup.replace(new RegExp("\\r?\\n", "g"), "")
                }
                return markup
            };
            return MarkdownConverter
        }();
        _converterController.default.addConverter("markdown", MarkdownConverter);
        var _default = MarkdownConverter;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************!*\
      !*** external "window.TurndownService" ***!
      \*****************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports) {
        module.exports = window.TurndownService
    },
    /*!**********************************!*\
      !*** external "window.showdown" ***!
      \**********************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports) {
        module.exports = window.showdown
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/slide_out_view.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _click = __webpack_require__( /*! ../events/click */ 21);
        var _translator = __webpack_require__( /*! ../animation/translator */ 28);
        var _element = __webpack_require__( /*! ../core/element */ 18);
        var _hide_callback = __webpack_require__( /*! ../mobile/hide_callback */ 232);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./widget/ui.widget */ 16));
        var _swipeable = _interopRequireDefault(__webpack_require__( /*! ../events/gesture/swipeable */ 172));
        var _empty_template = __webpack_require__( /*! ../core/templates/empty_template */ 91);
        var _deferred = __webpack_require__( /*! ../core/utils/deferred */ 6);
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _uiSlide_out_view = __webpack_require__( /*! ./slide_out_view/ui.slide_out_view.animation */ 1007);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var SLIDEOUTVIEW_CLASS = "dx-slideoutview";
        var SLIDEOUTVIEW_WRAPPER_CLASS = "dx-slideoutview-wrapper";
        var SLIDEOUTVIEW_MENU_CONTENT_CLASS = "dx-slideoutview-menu-content";
        var SLIDEOUTVIEW_CONTENT_CLASS = "dx-slideoutview-content";
        var SLIDEOUTVIEW_SHIELD_CLASS = "dx-slideoutview-shield";
        var INVISIBLE_STATE_CLASS = "dx-state-invisible";
        var ANONYMOUS_TEMPLATE_NAME = "content";
        var SlideOutView = _ui.default.inherit({
            ctor: function(element, options) {
                this.callBase(element, options);
                this._logDeprecatedComponentWarning("20.1", "dxDrawer")
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    menuPosition: "normal",
                    menuVisible: false,
                    swipeEnabled: true,
                    menuTemplate: "menu",
                    contentTemplate: "content",
                    contentOffset: 45
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: {
                        android: true
                    },
                    options: {
                        contentOffset: 54
                    }
                }, {
                    device: function(_device) {
                        return "generic" === _device.platform && "desktop" !== _device.deviceType
                    },
                    options: {
                        contentOffset: 56
                    }
                }, {
                    device: {
                        win: true,
                        phone: false
                    },
                    options: {
                        contentOffset: 76
                    }
                }])
            },
            _init: function() {
                this.callBase();
                this.$element().addClass(SLIDEOUTVIEW_CLASS);
                this._whenAnimationComplete = void 0;
                this._whenMenuRendered = void 0;
                this._initHideTopOverlayHandler()
            },
            _initHideTopOverlayHandler: function() {
                this._hideMenuHandler = this.hideMenu.bind(this)
            },
            _getAnonymousTemplateName: function() {
                return ANONYMOUS_TEMPLATE_NAME
            },
            _initTemplates: function() {
                this._templateManager.addDefaultTemplates({
                    menu: new _empty_template.EmptyTemplate,
                    content: new _empty_template.EmptyTemplate
                });
                this.callBase()
            },
            _initMarkup: function() {
                var _this = this;
                this.callBase();
                this._renderMarkup();
                this._whenMenuRendered = new _deferred.Deferred;
                var menuTemplate = this._getTemplate(this.option("menuTemplate"));
                menuTemplate && menuTemplate.render({
                    container: this.menuContent(),
                    onRendered: function() {
                        _this._whenMenuRendered.resolve()
                    }
                });
                var contentTemplateOption = this.option("contentTemplate");
                var contentTemplate = this._getTemplate(contentTemplateOption);
                var transclude = this._templateManager.anonymousTemplateName === contentTemplateOption;
                contentTemplate && contentTemplate.render({
                    container: this.content(),
                    noModel: true,
                    transclude: transclude
                });
                this._renderShield();
                this._toggleMenuPositionClass()
            },
            _render: function() {
                var _this2 = this;
                this.callBase();
                this._whenMenuRendered.always(function() {
                    _this2._initSwipeHandlers();
                    _this2._dimensionChanged()
                })
            },
            _renderMarkup: function() {
                var $wrapper = (0, _renderer.default)("<div>").addClass(SLIDEOUTVIEW_WRAPPER_CLASS);
                this._$menu = (0, _renderer.default)("<div>").addClass(SLIDEOUTVIEW_MENU_CONTENT_CLASS);
                this._$container = (0, _renderer.default)("<div>").addClass(SLIDEOUTVIEW_CONTENT_CLASS);
                $wrapper.append(this._$menu);
                $wrapper.append(this._$container);
                this.$element().append($wrapper);
                _events_engine.default.on(this._$container, "MSPointerDown", _common.noop)
            },
            _renderShield: function() {
                this._$shield = this._$shield || (0, _renderer.default)("<div>").addClass(SLIDEOUTVIEW_SHIELD_CLASS);
                this._$shield.appendTo(this.content());
                _events_engine.default.off(this._$shield, _click.name);
                _events_engine.default.on(this._$shield, _click.name, this.hideMenu.bind(this));
                this._toggleShieldVisibility(this.option("menuVisible"))
            },
            _initSwipeHandlers: function() {
                this._createComponent((0, _renderer.default)(this.content()), _swipeable.default, {
                    disabled: !this.option("swipeEnabled"),
                    elastic: false,
                    itemSizeFunc: this._getMenuWidth.bind(this),
                    onStart: this._swipeStartHandler.bind(this),
                    onUpdated: this._swipeUpdateHandler.bind(this),
                    onEnd: this._swipeEndHandler.bind(this)
                })
            },
            _isRightMenuPosition: function() {
                var invertedPosition = "inverted" === this.option("menuPosition");
                var rtl = this.option("rtlEnabled");
                return rtl && !invertedPosition || !rtl && invertedPosition
            },
            _swipeStartHandler: function(e) {
                _uiSlide_out_view.animation.complete((0, _renderer.default)(this.content()));
                var event = e.event;
                var menuVisible = this.option("menuVisible");
                var rtl = this._isRightMenuPosition();
                event.maxLeftOffset = +(rtl ? !menuVisible : menuVisible);
                event.maxRightOffset = +(rtl ? menuVisible : !menuVisible);
                this._toggleShieldVisibility(true)
            },
            _swipeUpdateHandler: function(e) {
                var event = e.event;
                var offset = this.option("menuVisible") ? event.offset + 1 * this._getRTLSignCorrection() : event.offset;
                offset *= this._getRTLSignCorrection();
                this._renderPosition(offset, false)
            },
            _swipeEndHandler: function(e) {
                var targetOffset = e.event.targetOffset * this._getRTLSignCorrection() + this.option("menuVisible");
                var menuVisible = 0 !== targetOffset;
                if (this.option("menuVisible") === menuVisible) {
                    this._renderPosition(this.option("menuVisible"), true)
                } else {
                    this.option("menuVisible", menuVisible)
                }
            },
            _toggleMenuPositionClass: function() {
                var left = SLIDEOUTVIEW_CLASS + "-left";
                var right = SLIDEOUTVIEW_CLASS + "-right";
                var menuPosition = this._isRightMenuPosition() ? "right" : "left";
                this._$menu.removeClass(left + " " + right);
                this._$menu.addClass(SLIDEOUTVIEW_CLASS + "-" + menuPosition)
            },
            _renderPosition: function(offset, animate) {
                if (!(0, _window.hasWindow)()) {
                    return
                }
                var pos = this._calculatePixelOffset(offset) * this._getRTLSignCorrection();
                this._toggleHideMenuCallback(offset);
                if (animate) {
                    this._toggleShieldVisibility(true);
                    _uiSlide_out_view.animation.moveTo((0, _renderer.default)(this.content()), pos, this._animationCompleteHandler.bind(this))
                } else {
                    (0, _translator.move)((0, _renderer.default)(this.content()), {
                        left: pos
                    })
                }
            },
            _calculatePixelOffset: function(offset) {
                offset = offset || 0;
                return offset * this._getMenuWidth()
            },
            _getMenuWidth: function() {
                if (!this._menuWidth) {
                    var maxMenuWidth = this.$element().width() - this.option("contentOffset");
                    var menuContent = (0, _renderer.default)(this.menuContent());
                    menuContent.css("maxWidth", maxMenuWidth < 0 ? 0 : maxMenuWidth);
                    var currentMenuWidth = menuContent.width();
                    this._menuWidth = Math.min(currentMenuWidth, maxMenuWidth)
                }
                return this._menuWidth
            },
            _animationCompleteHandler: function() {
                this._toggleShieldVisibility(this.option("menuVisible"));
                if (this._whenAnimationComplete) {
                    this._whenAnimationComplete.resolveWith(this)
                }
            },
            _toggleHideMenuCallback: function(subscribe) {
                if (subscribe) {
                    _hide_callback.hideCallback.add(this._hideMenuHandler)
                } else {
                    _hide_callback.hideCallback.remove(this._hideMenuHandler)
                }
            },
            _getRTLSignCorrection: function() {
                return this._isRightMenuPosition() ? -1 : 1
            },
            _dispose: function() {
                _uiSlide_out_view.animation.complete((0, _renderer.default)(this.content()));
                this._toggleHideMenuCallback(false);
                this.callBase()
            },
            _visibilityChanged: function(visible) {
                if (visible) {
                    this._dimensionChanged()
                }
            },
            _dimensionChanged: function() {
                delete this._menuWidth;
                this._renderPosition(this.option("menuVisible"), false)
            },
            _toggleShieldVisibility: function(visible) {
                this._$shield.toggleClass(INVISIBLE_STATE_CLASS, !visible)
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "width":
                        this.callBase(args);
                        this._dimensionChanged();
                        break;
                    case "contentOffset":
                        this._dimensionChanged();
                        break;
                    case "menuVisible":
                        this._renderPosition(args.value, true);
                        break;
                    case "menuPosition":
                        this._renderPosition(this.option("menuVisible"), true);
                        this._toggleMenuPositionClass();
                        break;
                    case "swipeEnabled":
                        this._initSwipeHandlers();
                        break;
                    case "contentTemplate":
                    case "menuTemplate":
                        this._invalidate();
                        break;
                    default:
                        this.callBase(args)
                }
            },
            menuContent: function() {
                return (0, _element.getPublicElement)(this._$menu)
            },
            content: function() {
                return (0, _element.getPublicElement)(this._$container)
            },
            showMenu: function() {
                return this.toggleMenuVisibility(true)
            },
            hideMenu: function() {
                return this.toggleMenuVisibility(false)
            },
            toggleMenuVisibility: function(showing) {
                showing = void 0 === showing ? !this.option("menuVisible") : showing;
                this._whenAnimationComplete = new _deferred.Deferred;
                this.option("menuVisible", showing);
                return this._whenAnimationComplete.promise()
            }
        });
        (0, _component_registrator.default)("dxSlideOutView", SlideOutView);
        var _default = SlideOutView;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/hierarchical_collection/ui.data_adapter.js ***!
      \********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../../ui/widget/ui.errors */ 17));
        var _ui2 = _interopRequireDefault(__webpack_require__( /*! ../../ui/widget/ui.search_box_mixin */ 274));
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _query = _interopRequireDefault(__webpack_require__( /*! ../../data/query */ 48));
        var _store_helper = _interopRequireDefault(__webpack_require__( /*! ../../data/store_helper */ 94));
        var _ui3 = _interopRequireDefault(__webpack_require__( /*! ./ui.data_converter */ 688));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var EXPANDED = "expanded";
        var SELECTED = "selected";
        var DISABLED = "disabled";
        var DataAdapter = _class.default.inherit({
            ctor: function(options) {
                this.options = {};
                (0, _extend.extend)(this.options, this._defaultOptions(), options);
                this.options.dataConverter.setDataAccessors(this.options.dataAccessors);
                this._selectedNodesKeys = [];
                this._expandedNodesKeys = [];
                this._dataStructure = [];
                this._createInternalDataStructure();
                this.getTreeNodes()
            },
            setOption: function(name, value) {
                this.options[name] = value;
                if ("recursiveSelection" === name) {
                    this._updateSelection()
                }
            },
            _defaultOptions: function() {
                return {
                    dataAccessors: void 0,
                    items: [],
                    multipleSelection: true,
                    recursiveSelection: false,
                    recursiveExpansion: false,
                    rootValue: 0,
                    searchValue: "",
                    dataType: "tree",
                    searchMode: "contains",
                    dataConverter: new _ui3.default,
                    onNodeChanged: _common.noop,
                    sort: null
                }
            },
            _createInternalDataStructure: function() {
                this._initialDataStructure = this.options.dataConverter.createPlainStructure(this.options.items, this.options.rootValue, this.options.dataType);
                this._dataStructure = this.options.searchValue.length ? this.search(this.options.searchValue) : this._initialDataStructure;
                this.options.dataConverter._dataStructure = this._dataStructure;
                this._updateSelection();
                this._updateExpansion()
            },
            _updateSelection: function() {
                if (this.options.recursiveSelection) {
                    this._setChildrenSelection();
                    this._setParentSelection()
                }
                this._selectedNodesKeys = this._updateNodesKeysArray(SELECTED)
            },
            _updateExpansion: function(key) {
                if (this.options.recursiveExpansion) {
                    key ? this._updateOneBranch(key) : this._setParentExpansion()
                }
                this._expandedNodesKeys = this._updateNodesKeysArray(EXPANDED)
            },
            _updateNodesKeysArray: function(property) {
                var that = this;
                var array = [];
                (0, _iterator.each)(that._getDataBySelectionMode(), function(_, node) {
                    if (!that._isNodeVisible(node)) {
                        return
                    }
                    if (node.internalFields[property]) {
                        if (property === EXPANDED || that.options.multipleSelection) {
                            array.push(node.internalFields.key)
                        } else {
                            array.length && that.toggleSelection(array[0], false, true);
                            array = [node.internalFields.key]
                        }
                    }
                });
                return array
            },
            _getDataBySelectionMode: function() {
                return this.options.multipleSelection ? this.getData() : this.getFullData()
            },
            _isNodeVisible: function(node) {
                return false !== node.internalFields.item.visible
            },
            _getByKey: function(data, key) {
                return data === this._dataStructure ? this.options.dataConverter._getByKey(key) : this.options.dataConverter.getByKey(data, key)
            },
            _setChildrenSelection: function() {
                var that = this;
                (0, _iterator.each)(this._dataStructure, function(_, node) {
                    if (!node.internalFields.childrenKeys.length) {
                        return
                    }
                    var isSelected = node.internalFields.selected;
                    true === isSelected && that._toggleChildrenSelection(node, isSelected)
                })
            },
            _setParentSelection: function() {
                var that = this;
                (0, _iterator.each)(this._dataStructure, function(_, node) {
                    var parent = that.options.dataConverter.getParentNode(node);
                    if (parent && node.internalFields.parentKey !== that.options.rootValue) {
                        that._iterateParents(node, function(parent) {
                            var newParentState = that._calculateSelectedState(parent);
                            that._setFieldState(parent, SELECTED, newParentState)
                        })
                    }
                })
            },
            _setParentExpansion: function() {
                var that = this;
                (0, _iterator.each)(this._dataStructure, function(_, node) {
                    if (!node.internalFields.expanded) {
                        return
                    }
                    that._updateOneBranch(node.internalFields.key)
                })
            },
            _updateOneBranch: function(key) {
                var that = this;
                var node = this.getNodeByKey(key);
                that._iterateParents(node, function(parent) {
                    that._setFieldState(parent, EXPANDED, true)
                })
            },
            _iterateChildren: function(node, recursive, callback, processedKeys) {
                if (!(0, _type.isFunction)(callback)) {
                    return
                }
                var that = this;
                var nodeKey = node.internalFields.key;
                processedKeys = processedKeys || [];
                if (processedKeys.indexOf(nodeKey) === -1) {
                    processedKeys.push(nodeKey);
                    (0, _iterator.each)(node.internalFields.childrenKeys, function(_, key) {
                        var child = that.getNodeByKey(key);
                        callback(child);
                        if (child.internalFields.childrenKeys.length && recursive) {
                            that._iterateChildren(child, recursive, callback, processedKeys)
                        }
                    })
                }
            },
            _iterateParents: function(node, callback, processedKeys) {
                if (node.internalFields.parentKey === this.options.rootValue || !(0, _type.isFunction)(callback)) {
                    return
                }
                processedKeys = processedKeys || [];
                var key = node.internalFields.key;
                if (processedKeys.indexOf(key) === -1) {
                    processedKeys.push(key);
                    var parent = this.options.dataConverter.getParentNode(node);
                    if (parent) {
                        callback(parent);
                        if (parent.internalFields.parentKey !== this.options.rootValue) {
                            this._iterateParents(parent, callback, processedKeys)
                        }
                    }
                }
            },
            _calculateSelectedState: function(node) {
                var itemsCount = node.internalFields.childrenKeys.length;
                var selectedItemsCount = 0;
                var invisibleItemsCount = 0;
                var result = false;
                for (var i = 0; i <= itemsCount - 1; i++) {
                    var childNode = this.getNodeByKey(node.internalFields.childrenKeys[i]);
                    var isChildInvisible = false === childNode.internalFields.item.visible;
                    var childState = childNode.internalFields.selected;
                    if (isChildInvisible) {
                        invisibleItemsCount++;
                        continue
                    }
                    if (childState) {
                        selectedItemsCount++
                    } else {
                        if (void 0 === childState) {
                            selectedItemsCount += .5
                        }
                    }
                }
                if (selectedItemsCount) {
                    result = selectedItemsCount === itemsCount - invisibleItemsCount ? true : void 0
                }
                return result
            },
            _toggleChildrenSelection: function(node, state) {
                var that = this;
                this._iterateChildren(node, true, function(child) {
                    if (that._isNodeVisible(child)) {
                        that._setFieldState(child, SELECTED, state)
                    }
                })
            },
            _setFieldState: function(node, field, state) {
                if (node.internalFields[field] === state) {
                    return
                }
                node.internalFields[field] = state;
                if (node.internalFields.publicNode) {
                    node.internalFields.publicNode[field] = state
                }
                this.options.dataAccessors.setters[field](node.internalFields.item, state);
                this.options.onNodeChanged(node)
            },
            _markChildren: function(keys) {
                var that = this;
                (0, _iterator.each)(keys, function(_, key) {
                    var index = that.getIndexByKey(key);
                    var node = that.getNodeByKey(key);
                    that._dataStructure[index] = 0;
                    node.internalFields.childrenKeys.length && that._markChildren(node.internalFields.childrenKeys)
                })
            },
            _removeNode: function(key) {
                var node = this.getNodeByKey(key);
                this._dataStructure[this.getIndexByKey(key)] = 0;
                this._markChildren(node.internalFields.childrenKeys);
                var that = this;
                var counter = 0;
                var items = (0, _extend.extend)([], this._dataStructure);
                (0, _iterator.each)(items, function(index, item) {
                    if (!item) {
                        that._dataStructure.splice(index - counter, 1);
                        counter++
                    }
                })
            },
            _addNode: function(item) {
                var dataConverter = this.options.dataConverter;
                var node = dataConverter._convertItemToNode(item, this.options.dataAccessors.getters.parentKey(item));
                this._dataStructure = this._dataStructure.concat(node);
                this._initialDataStructure = this._initialDataStructure.concat(node);
                dataConverter._dataStructure = dataConverter._dataStructure.concat(node)
            },
            _updateFields: function() {
                this.options.dataConverter.updateChildrenKeys();
                this._updateSelection();
                this._updateExpansion()
            },
            getSelectedNodesKeys: function() {
                return this._selectedNodesKeys
            },
            getExpandedNodesKeys: function() {
                return this._expandedNodesKeys
            },
            getData: function() {
                return this._dataStructure
            },
            getFullData: function() {
                return this._initialDataStructure
            },
            getNodeByItem: function(item) {
                var result = null;
                (0, _iterator.each)(this._dataStructure, function(_, node) {
                    if (node.internalFields.item === item) {
                        result = node;
                        return false
                    }
                });
                return result
            },
            getNodesByItems: function(items) {
                var that = this;
                var nodes = [];
                (0, _iterator.each)(items, function(_, item) {
                    var node = that.getNodeByItem(item);
                    node && nodes.push(node)
                });
                return nodes
            },
            getNodeByKey: function(key, data) {
                return this._getByKey(data || this._getDataBySelectionMode(), key)
            },
            getTreeNodes: function() {
                return this.options.dataConverter.convertToPublicNodes(this.getRootNodes())
            },
            getItemsCount: function() {
                return this.options.dataConverter.getItemsCount()
            },
            getVisibleItemsCount: function() {
                return this.options.dataConverter.getVisibleItemsCount()
            },
            getPublicNode: function(node) {
                return node.internalFields.publicNode
            },
            getRootNodes: function() {
                return this.getChildrenNodes(this.options.rootValue)
            },
            getChildrenNodes: function(parentKey) {
                return (0, _query.default)(this._dataStructure).filter(["internalFields.parentKey", parentKey]).toArray()
            },
            getIndexByKey: function(key) {
                return this.options.dataConverter.getIndexByKey(key)
            },
            addItem: function(item) {
                this._addNode(item);
                this._updateFields()
            },
            removeItem: function(key) {
                this._removeNode(key);
                this._updateFields()
            },
            toggleSelection: function(key, state, selectRecursive) {
                var isSingleModeUnselect = this._isSingleModeUnselect(state);
                var node = this._getByKey(selectRecursive || isSingleModeUnselect ? this._initialDataStructure : this._dataStructure, key);
                this._setFieldState(node, SELECTED, state);
                if (this.options.recursiveSelection && !selectRecursive) {
                    state ? this._setChildrenSelection() : this._toggleChildrenSelection(node, state);
                    this._setParentSelection()
                }
                this._selectedNodesKeys = this._updateNodesKeysArray(SELECTED)
            },
            _isSingleModeUnselect: function(selectionState) {
                return !this.options.multipleSelection && !selectionState
            },
            toggleNodeDisabledState: function(key, state) {
                var node = this.getNodeByKey(key);
                this._setFieldState(node, DISABLED, state)
            },
            toggleSelectAll: function(state) {
                if (!(0, _type.isDefined)(state)) {
                    return
                }
                var that = this;
                var lastSelectedKey = that._selectedNodesKeys[that._selectedNodesKeys.length - 1];
                var dataStructure = that._isSingleModeUnselect(state) ? this._initialDataStructure : this._dataStructure;
                (0, _iterator.each)(dataStructure, function(index, node) {
                    if (!that._isNodeVisible(node)) {
                        return
                    }
                    that._setFieldState(node, SELECTED, state)
                });
                that._selectedNodesKeys = that._updateNodesKeysArray(SELECTED);
                if (!state && that.options.selectionRequired) {
                    that.toggleSelection(lastSelectedKey, true)
                }
            },
            isAllSelected: function() {
                if (this.getSelectedNodesKeys().length) {
                    return this.getSelectedNodesKeys().length === this.getVisibleItemsCount() ? true : void 0
                } else {
                    return false
                }
            },
            toggleExpansion: function(key, state) {
                var node = this.getNodeByKey(key);
                this._setFieldState(node, EXPANDED, state);
                if (state) {
                    this._updateExpansion(key)
                }
                this._expandedNodesKeys = this._updateNodesKeysArray(EXPANDED)
            },
            isFiltered: function(item) {
                return !this.options.searchValue.length || !!this._filterDataStructure(this.options.searchValue, [item]).length
            },
            _createCriteria: function(selector, value, operation) {
                var searchFilter = [];
                if (!Array.isArray(selector)) {
                    return [selector, operation, value]
                }(0, _iterator.each)(selector, function(i, item) {
                    searchFilter.push([item, operation, value], "or")
                });
                searchFilter.pop();
                return searchFilter
            },
            _filterDataStructure: function(filterValue, dataStructure) {
                var selector = this.options.searchExpr || this.options.dataAccessors.getters.display;
                var operation = _ui2.default.getOperationBySearchMode(this.options.searchMode);
                var criteria = this._createCriteria(selector, filterValue, operation);
                dataStructure = dataStructure || this._initialDataStructure;
                return (0, _query.default)(dataStructure).filter(criteria).toArray()
            },
            search: function(searchValue) {
                var that = this;
                var matches = this._filterDataStructure(searchValue);
                var dataConverter = this.options.dataConverter;

                function lookForParents(matches, index) {
                    var length = matches.length;
                    while (index < length) {
                        var node = matches[index];
                        if (node.internalFields.parentKey === that.options.rootValue) {
                            index++;
                            continue
                        }
                        var parent = dataConverter.getParentNode(node);
                        if (!parent) {
                            _ui.default.log("W1007", node.internalFields.parentKey, node.internalFields.key);
                            index++;
                            continue
                        }
                        if (!parent.internalFields.expanded) {
                            that._setFieldState(parent, EXPANDED, true)
                        }
                        if ((0, _array.inArray)(parent, matches) > -1) {
                            index++;
                            continue
                        }
                        matches.splice(index, 0, parent);
                        lookForParents(matches, index)
                    }
                }
                lookForParents(matches, 0);
                if (this.options.sort) {
                    matches = _store_helper.default.queryByOptions((0, _query.default)(matches), {
                        sort: this.options.sort
                    }).toArray()
                }
                dataConverter._indexByKey = {};
                (0, _iterator.each)(matches, function(index, node) {
                    node.internalFields.childrenKeys = [];
                    dataConverter._indexByKey[node.internalFields.key] = index
                });
                dataConverter._dataStructure = matches;
                dataConverter.setChildrenKeys();
                return dataConverter._dataStructure
            }
        });
        var _default = DataAdapter;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/hierarchical_collection/ui.data_converter.js ***!
      \**********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../../ui/widget/ui.errors */ 17));
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DataConverter = _class.default.inherit({
            ctor: function() {
                this._dataStructure = [];
                this._itemsCount = 0;
                this._visibleItemsCount = 0
            },
            _indexByKey: {},
            _convertItemsToNodes: function(items, parentKey) {
                var that = this;
                (0, _iterator.each)(items, function(_, item) {
                    var parentId = (0, _type.isDefined)(parentKey) ? parentKey : that._getParentId(item);
                    var node = that._convertItemToNode(item, parentId);
                    that._dataStructure.push(node);
                    that._checkForDuplicateId(node.internalFields.key);
                    that._indexByKey[node.internalFields.key] = that._dataStructure.length - 1;
                    if (that._itemHasChildren(item)) {
                        that._convertItemsToNodes(that._dataAccessors.getters.items(item), node.internalFields.key)
                    }
                })
            },
            _checkForDuplicateId: function(key) {
                if ((0, _type.isDefined)(this._indexByKey[key])) {
                    throw _ui.default.Error("E1040", key)
                }
            },
            _getParentId: function(item) {
                return "plain" === this._dataType ? this._dataAccessors.getters.parentKey(item) : void 0
            },
            _itemHasChildren: function(item) {
                if ("plain" === this._dataType) {
                    return
                }
                var items = this._dataAccessors.getters.items(item);
                return items && items.length
            },
            _getUniqueKey: function(item) {
                var keyGetter = this._dataAccessors.getters.key;
                var itemKey = keyGetter(item);
                var isCorrectKey = keyGetter && (itemKey || 0 === itemKey) && (0, _type.isPrimitive)(itemKey);
                return isCorrectKey ? itemKey : this.getItemsCount()
            },
            _convertItemToNode: function(item, parentKey) {
                this._itemsCount++;
                false !== item.visible && this._visibleItemsCount++;
                var that = this;
                var node = {
                    internalFields: {
                        disabled: that._dataAccessors.getters.disabled(item, {
                            defaultValue: false
                        }),
                        expanded: that._dataAccessors.getters.expanded(item, {
                            defaultValue: false
                        }),
                        selected: that._dataAccessors.getters.selected(item, {
                            defaultValue: false
                        }),
                        key: that._getUniqueKey(item),
                        parentKey: (0, _type.isDefined)(parentKey) ? parentKey : that._rootValue,
                        item: that._makeObjectFromPrimitive(item),
                        childrenKeys: []
                    }
                };
                (0, _extend.extend)(node, item);
                delete node.items;
                return node
            },
            setChildrenKeys: function() {
                var that = this;
                (0, _iterator.each)(this._dataStructure, function(_, node) {
                    if (node.internalFields.parentKey === that._rootValue) {
                        return
                    }
                    var parent = that.getParentNode(node);
                    parent && parent.internalFields.childrenKeys.push(node.internalFields.key)
                })
            },
            _makeObjectFromPrimitive: function(item) {
                if ((0, _type.isPrimitive)(item)) {
                    var key = item;
                    item = {};
                    this._dataAccessors.setters.key(item, key)
                }
                return item
            },
            _convertToPublicNode: function(node, parent) {
                if (!node) {
                    return null
                }
                var publicNode = {
                    text: this._dataAccessors.getters.display(node),
                    key: node.internalFields.key,
                    selected: node.internalFields.selected,
                    expanded: node.internalFields.expanded,
                    disabled: node.internalFields.disabled,
                    parent: parent || null,
                    itemData: node.internalFields.item,
                    children: [],
                    items: []
                };
                if (publicNode.parent) {
                    publicNode.parent.children.push(publicNode);
                    publicNode.parent.items.push(publicNode)
                }
                return publicNode
            },
            convertToPublicNodes: function(data, parent) {
                if (!data.length) {
                    return []
                }
                var that = this;
                var publicNodes = [];
                (0, _iterator.each)(data, function(_, node) {
                    node = (0, _type.isPrimitive)(node) ? that._getByKey(node) : node;
                    var publicNode = that._convertToPublicNode(node, parent);
                    publicNode.children = that.convertToPublicNodes(node.internalFields.childrenKeys, publicNode);
                    publicNodes.push(publicNode);
                    node.internalFields.publicNode = publicNode
                });
                return publicNodes
            },
            setDataAccessors: function(accessors) {
                this._dataAccessors = accessors
            },
            _getByKey: function(key) {
                return this._dataStructure[this.getIndexByKey(key)] || null
            },
            getParentNode: function(node) {
                return this._getByKey(node.internalFields.parentKey)
            },
            getByKey: function getByKey(data, key) {
                if (null === key || void 0 === key) {
                    return null
                }
                var result = null;
                var that = this;
                var getByKey = function(data, key) {
                    (0, _iterator.each)(data, function(_, element) {
                        var currentElementKey = element.internalFields && element.internalFields.key || that._dataAccessors.getters.key(element);
                        if (currentElementKey.toString() === key.toString()) {
                            result = element;
                            return false
                        }
                    });
                    return result
                };
                return getByKey(data, key)
            },
            getItemsCount: function() {
                return this._itemsCount
            },
            getVisibleItemsCount: function() {
                return this._visibleItemsCount
            },
            updateIndexByKey: function() {
                var that = this;
                this._indexByKey = {};
                (0, _iterator.each)(this._dataStructure, function(index, node) {
                    that._checkForDuplicateId(node.internalFields.key);
                    that._indexByKey[node.internalFields.key] = index
                })
            },
            updateChildrenKeys: function() {
                this._indexByKey = {};
                this.removeChildrenKeys();
                this.updateIndexByKey();
                this.setChildrenKeys()
            },
            removeChildrenKeys: function() {
                this._indexByKey = {};
                (0, _iterator.each)(this._dataStructure, function(index, node) {
                    node.internalFields.childrenKeys = []
                })
            },
            getIndexByKey: function(key) {
                return this._indexByKey[key]
            },
            createPlainStructure: function(items, rootValue, dataType) {
                this._itemsCount = 0;
                this._visibleItemsCount = 0;
                this._rootValue = rootValue;
                this._dataType = dataType;
                this._indexByKey = {};
                this._convertItemsToNodes(items);
                this.setChildrenKeys();
                return this._dataStructure
            }
        });
        var _default = DataConverter;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/context_menu/ui.menu_base.edit.strategy.js ***!
      \********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _uiCollection_widgetEditStrategy = _interopRequireDefault(__webpack_require__( /*! ../collection/ui.collection_widget.edit.strategy.plain */ 202));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var MenuBaseEditStrategy = function(_PlainEditStrategy) {
            _inheritsLoose(MenuBaseEditStrategy, _PlainEditStrategy);

            function MenuBaseEditStrategy() {
                return _PlainEditStrategy.apply(this, arguments) || this
            }
            var _proto = MenuBaseEditStrategy.prototype;
            _proto._getPlainItems = function() {
                return (0, _iterator.map)(this._collectionWidget.option("items"), function getMenuItems(item) {
                    return item.items ? [item].concat((0, _iterator.map)(item.items, getMenuItems)) : item
                })
            };
            _proto._stringifyItem = function(item) {
                var _this = this;
                return JSON.stringify(item, function(key, value) {
                    if ("template" === key) {
                        return _this._getTemplateString(value)
                    }
                    return value
                })
            };
            _proto._getTemplateString = function(template) {
                var result;
                if ("object" === _typeof(template)) {
                    result = (0, _renderer.default)(template).text()
                } else {
                    result = template.toString()
                }
                return result
            };
            return MenuBaseEditStrategy
        }(_uiCollection_widgetEditStrategy.default);
        var _default = MenuBaseEditStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./data_grid/ui.data_grid */ 378));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _ui.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.base.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _console = __webpack_require__( /*! ../../core/utils/console */ 110);
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _themes = __webpack_require__( /*! ../themes */ 34);
        __webpack_require__( /*! ./ui.data_grid.column_headers */ 692);
        __webpack_require__( /*! ./ui.data_grid.columns_controller */ 693);
        __webpack_require__( /*! ./ui.data_grid.data_controller */ 694);
        __webpack_require__( /*! ./ui.data_grid.sorting */ 695);
        __webpack_require__( /*! ./ui.data_grid.rows */ 696);
        __webpack_require__( /*! ./ui.data_grid.context_menu */ 697);
        __webpack_require__( /*! ./ui.data_grid.error_handling */ 698);
        __webpack_require__( /*! ./ui.data_grid.grid_view */ 699);
        __webpack_require__( /*! ./ui.data_grid.header_panel */ 700);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DATAGRID_ROW_SELECTOR = ".dx-row";
        var DATAGRID_DEPRECATED_TEMPLATE_WARNING = "Specifying grid templates with the jQuery selector name is now deprecated. Use the DOM Node or the jQuery object that references this selector instead.";
        _uiData_grid.default.registerModulesOrder(["stateStoring", "columns", "selection", "editorFactory", "columnChooser", "grouping", "editing", "masterDetail", "validating", "adaptivity", "data", "virtualScrolling", "columnHeaders", "filterRow", "headerPanel", "headerFilter", "sorting", "search", "rows", "pager", "columnsResizingReordering", "contextMenu", "keyboardNavigation", "errorHandling", "summary", "columnFixing", "export", "gridView"]);
        var DataGrid = _ui.default.inherit({
            _activeStateUnit: DATAGRID_ROW_SELECTOR,
            _getDefaultOptions: function() {
                var that = this;
                var result = that.callBase();
                (0, _iterator.each)(_uiData_grid.default.modules, function() {
                    if ((0, _type.isFunction)(this.defaultOptions)) {
                        (0, _extend.extend)(true, result, this.defaultOptions())
                    }
                });
                return result
            },
            _setDeprecatedOptions: function() {
                this.callBase();
                (0, _extend.extend)(this._deprecatedOptions, {
                    useKeyboard: {
                        since: "19.2",
                        alias: "keyboardNavigation.enabled"
                    }
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: {
                        platform: "ios"
                    },
                    options: {
                        showRowLines: true
                    }
                }, {
                    device: function() {
                        return (0, _themes.isMaterial)()
                    },
                    options: {
                        showRowLines: true,
                        showColumnLines: false,
                        headerFilter: {
                            height: 315
                        },
                        editing: {
                            useIcons: true
                        }
                    }
                }, {
                    device: function() {
                        return _browser.default.webkit
                    },
                    options: {
                        loadingTimeout: 30,
                        loadPanel: {
                            animation: {
                                show: {
                                    easing: "cubic-bezier(1, 0, 1, 0)",
                                    duration: 500,
                                    from: {
                                        opacity: 0
                                    },
                                    to: {
                                        opacity: 1
                                    }
                                }
                            }
                        }
                    }
                }, {
                    device: function(_device) {
                        return "desktop" !== _device.deviceType
                    },
                    options: {
                        grouping: {
                            expandMode: "rowClick"
                        }
                    }
                }])
            },
            _init: function() {
                var that = this;
                that.callBase();
                _uiData_grid.default.processModules(that, _uiData_grid.default);
                _uiData_grid.default.callModuleItemsMethod(that, "init")
            },
            _clean: _common.noop,
            _optionChanged: function(args) {
                var that = this;
                _uiData_grid.default.callModuleItemsMethod(that, "optionChanged", [args]);
                if (!args.handled) {
                    that.callBase(args)
                }
            },
            _dimensionChanged: function() {
                this.updateDimensions(true)
            },
            _visibilityChanged: function(visible) {
                if (visible) {
                    this.updateDimensions()
                }
            },
            _initMarkup: function() {
                this.callBase.apply(this, arguments);
                this.getView("gridView").render(this.$element())
            },
            _renderContentImpl: function() {
                this.getView("gridView").update()
            },
            _renderContent: function() {
                var that = this;
                (0, _common.deferRender)(function() {
                    that._renderContentImpl()
                })
            },
            _getTemplate: function(templateName) {
                var template = templateName;
                if ((0, _type.isString)(template) && "#" === template[0]) {
                    template = (0, _renderer.default)(templateName);
                    _console.logger.warn(DATAGRID_DEPRECATED_TEMPLATE_WARNING)
                }
                return this.callBase(template)
            },
            _dispose: function() {
                var that = this;
                that.callBase();
                _uiData_grid.default.callModuleItemsMethod(that, "dispose")
            },
            isReady: function() {
                return this.getController("data").isReady()
            },
            beginUpdate: function() {
                var that = this;
                that.callBase();
                _uiData_grid.default.callModuleItemsMethod(that, "beginUpdate")
            },
            endUpdate: function() {
                var that = this;
                _uiData_grid.default.callModuleItemsMethod(that, "endUpdate");
                that.callBase()
            },
            getController: function(name) {
                return this._controllers[name]
            },
            getView: function(name) {
                return this._views[name]
            },
            focus: function(element) {
                this.getController("keyboardNavigation").focus(element)
            }
        });
        DataGrid.registerModule = _uiData_grid.default.registerModule.bind(_uiData_grid.default);
        (0, _component_registrator.default)("dxDataGrid", DataGrid);
        var _default = DataGrid;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.column_headers.js ***!
      \******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.ColumnHeadersView = void 0;
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.column_headers */ 379));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ColumnHeadersView = _uiGrid_core.default.views.columnHeadersView;
        exports.ColumnHeadersView = ColumnHeadersView;
        _uiData_grid.default.registerModule("columnHeaders", _uiGrid_core.default)
    },
    /*!**********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.columns_controller.js ***!
      \**********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.columns_controller */ 381));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiData_grid.default.registerModule("columns", {
            defaultOptions: function() {
                return (0, _extend.extend)(true, {}, _uiGrid_core.default.defaultOptions(), {
                    commonColumnSettings: {
                        allowExporting: true
                    }
                })
            },
            controllers: _uiGrid_core.default.controllers
        })
    },
    /*!*******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.data_controller.js ***!
      \*******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.DataController = void 0;
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _uiData_grid2 = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.data_source_adapter */ 218));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.data_controller */ 383));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DataController = _uiGrid_core.default.controllers.data.inherit(function() {
            return {
                _getDataSourceAdapter: function() {
                    return _uiData_grid2.default
                },
                _getSpecificDataSourceOption: function() {
                    var dataSource = this.option("dataSource");
                    if (dataSource && !Array.isArray(dataSource) && this.option("keyExpr")) {
                        _ui.default.log("W1011")
                    }
                    return this.callBase()
                }
            }
        }());
        exports.DataController = DataController;
        _uiData_grid.default.registerModule("data", {
            defaultOptions: _uiGrid_core.default.defaultOptions,
            controllers: {
                data: DataController
            }
        })
    },
    /*!***********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.sorting.js ***!
      \***********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.sorting */ 384));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiData_grid.default.registerModule("sorting", _uiGrid_core.default)
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.rows.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.RowsView = void 0;
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.rows */ 386));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var RowsView = _uiGrid_core.default.views.rowsView;
        exports.RowsView = RowsView;
        _uiData_grid.default.registerModule("rows", _uiGrid_core.default)
    },
    /*!****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.context_menu.js ***!
      \****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.context_menu */ 387));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiData_grid.default.registerModule("contextMenu", _uiGrid_core.default)
    },
    /*!******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.error_handling.js ***!
      \******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.error_handling */ 388));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiData_grid.default.registerModule("errorHandling", _uiGrid_core.default)
    },
    /*!*************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.grid_view.js ***!
      \*************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.grid_view */ 389));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiData_grid.default.registerModule("gridView", _uiGrid_core.default)
    },
    /*!****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.header_panel.js ***!
      \****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.HeaderPanel = void 0;
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.header_panel */ 390));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var HeaderPanel = _uiGrid_core.default.views.headerPanel;
        exports.HeaderPanel = HeaderPanel;
        _uiData_grid.default.registerModule("headerPanel", _uiGrid_core.default)
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.state_storing.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.state_storing */ 391));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiData_grid.default.registerModule("stateStoring", _uiGrid_core.default)
    },
    /*!*************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.selection.js ***!
      \*************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.selection */ 393));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiData_grid.default.registerModule("selection", _uiGrid_core.default)
    },
    /*!******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.column_chooser.js ***!
      \******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.ColumnChooserView = exports.ColumnChooserController = void 0;
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.column_chooser */ 394));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ColumnChooserController = _uiGrid_core.default.controllers.columnChooser;
        exports.ColumnChooserController = ColumnChooserController;
        var ColumnChooserView = _uiGrid_core.default.views.columnChooserView;
        exports.ColumnChooserView = ColumnChooserView;
        _uiData_grid.default.registerModule("columnChooser", _uiGrid_core.default)
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_view/ui.tree_view.base.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _click = __webpack_require__( /*! ../../events/click */ 21);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _element = __webpack_require__( /*! ../../core/element */ 18);
        var _check_box = _interopRequireDefault(__webpack_require__( /*! ../check_box */ 136));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../hierarchical_collection/ui.hierarchical_collection_widget */ 377));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../../events/pointer */ 24));
        var _double_click = __webpack_require__( /*! ../../events/double_click */ 151);
        var _fx = _interopRequireDefault(__webpack_require__( /*! ../../animation/fx */ 42));
        var _ui2 = _interopRequireDefault(__webpack_require__( /*! ../scroll_view/ui.scrollable */ 106));
        var _load_indicator = _interopRequireDefault(__webpack_require__( /*! ../load_indicator */ 83));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _ui3 = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var WIDGET_CLASS = "dx-treeview";
        var NODE_CLASS = "".concat(WIDGET_CLASS, "-node");
        var NODE_CONTAINER_CLASS = "".concat(NODE_CLASS, "-container");
        var NODE_LOAD_INDICATOR_CLASS = "".concat(NODE_CLASS, "-loadindicator");
        var OPENED_NODE_CONTAINER_CLASS = "".concat(NODE_CLASS, "-container-opened");
        var IS_LEAF = "".concat(NODE_CLASS, "-is-leaf");
        var ITEM_CLASS = "".concat(WIDGET_CLASS, "-item");
        var ITEM_WITH_CHECKBOX_CLASS = "".concat(ITEM_CLASS, "-with-checkbox");
        var ITEM_WITHOUT_CHECKBOX_CLASS = "".concat(ITEM_CLASS, "-without-checkbox");
        var ITEM_DATA_KEY = "".concat(ITEM_CLASS, "-data");
        var TOGGLE_ITEM_VISIBILITY_CLASS = "".concat(WIDGET_CLASS, "-toggle-item-visibility");
        var LOAD_INDICATOR_CLASS = "".concat(WIDGET_CLASS, "-loadindicator");
        var LOAD_INDICATOR_WRAPPER_CLASS = "".concat(WIDGET_CLASS, "-loadindicator-wrapper");
        var TOGGLE_ITEM_VISIBILITY_OPENED_CLASS = "".concat(WIDGET_CLASS, "-toggle-item-visibility-opened");
        var SELECT_ALL_ITEM_CLASS = "".concat(WIDGET_CLASS, "-select-all-item");
        var INVISIBLE_STATE_CLASS = "dx-state-invisible";
        var DISABLED_STATE_CLASS = "dx-state-disabled";
        var SELECTED_ITEM_CLASS = "dx-state-selected";
        var EXPAND_EVENT_NAMESPACE = "dxTreeView_expand";
        var DATA_ITEM_ID = "data-item-id";
        var TreeViewBase = _ui.default.inherit({
            _supportedKeys: function(e) {
                var _this = this;
                var click = function(e) {
                    var $itemElement = (0, _renderer.default)(_this.option("focusedElement"));
                    if (!$itemElement.length) {
                        return
                    }
                    e.target = $itemElement;
                    e.currentTarget = $itemElement;
                    _this._itemClickHandler(e, $itemElement.children("." + ITEM_CLASS));
                    var expandEventName = _this._getEventNameByOption(_this.option("expandEvent"));
                    var expandByClick = expandEventName === (0, _index.addNamespace)(_click.name, EXPAND_EVENT_NAMESPACE);
                    if (expandByClick) {
                        _this._expandEventHandler(e)
                    }
                };
                var select = function(e) {
                    e.preventDefault();
                    var $focusedElement = (0, _renderer.default)(_this.option("focusedElement"));
                    var checkboxInstance = _this._getCheckBoxInstance($focusedElement);
                    if (!checkboxInstance.option("disabled")) {
                        var currentState = checkboxInstance.option("value");
                        _this._updateItemSelection(!currentState, $focusedElement.find("." + ITEM_CLASS).get(0), true)
                    }
                };
                var toggleExpandedNestedItems = function(state, e) {
                    if (!this.option("expandAllEnabled")) {
                        return
                    }
                    e.preventDefault();
                    var $rootElement = (0, _renderer.default)(this.option("focusedElement"));
                    if (!$rootElement.length) {
                        return
                    }
                    var rootItem = this._getItemData($rootElement.find(".".concat(ITEM_CLASS)));
                    this._toggleExpandedNestedItems([rootItem], state)
                };
                return (0, _extend.extend)(this.callBase(), {
                    enter: this._showCheckboxes() ? select : click,
                    space: this._showCheckboxes() ? select : click,
                    asterisk: toggleExpandedNestedItems.bind(this, true),
                    minus: toggleExpandedNestedItems.bind(this, false)
                })
            },
            _toggleExpandedNestedItems: function(items, state) {
                if (!items) {
                    return
                }
                for (var i = 0, len = items.length; i < len; i++) {
                    var item = items[i];
                    var node = this._dataAdapter.getNodeByItem(item);
                    this._toggleExpandedState(node, state);
                    this._toggleExpandedNestedItems(item.items, state)
                }
            },
            _getNodeElement: function(node, cache) {
                var key = this._encodeString(node.internalFields.key);
                if (cache) {
                    if (!cache.$nodeByKey) {
                        cache.$nodeByKey = {};
                        this.$element().find(".".concat(NODE_CLASS)).each(function() {
                            var $node = (0, _renderer.default)(this);
                            var key = $node.attr(DATA_ITEM_ID);
                            cache.$nodeByKey[key] = $node
                        })
                    }
                    return cache.$nodeByKey[key] || (0, _renderer.default)()
                }
                var element = this.$element().get(0).querySelector("[".concat(DATA_ITEM_ID, '="').concat(key, '"]'));
                return (0, _renderer.default)(element)
            },
            _activeStateUnit: "." + ITEM_CLASS,
            _widgetClass: function() {
                return WIDGET_CLASS
            },
            _getDefaultOptions: function() {
                var defaultOptions = (0, _extend.extend)(this.callBase(), {
                    animationEnabled: true,
                    dataStructure: "tree",
                    deferRendering: true,
                    expandAllEnabled: false,
                    hasItemsExpr: "hasItems",
                    selectNodesRecursive: true,
                    expandNodesRecursive: true,
                    showCheckBoxesMode: "none",
                    selectAllText: _message.default.format("dxList-selectAll"),
                    onItemSelectionChanged: null,
                    onItemExpanded: null,
                    onItemCollapsed: null,
                    scrollDirection: "vertical",
                    virtualModeEnabled: false,
                    rootValue: 0,
                    focusStateEnabled: false,
                    selectionMode: "multiple",
                    expandEvent: "dblclick",
                    selectByClick: false,
                    createChildren: null,
                    onSelectAllValueChanged: null
                });
                return (0, _extend.extend)(true, defaultOptions, {
                    integrationOptions: {
                        useDeferUpdateForTemplates: false
                    }
                })
            },
            _initSelectedItems: _common.noop,
            _syncSelectionOptions: _common.asyncNoop,
            _fireSelectionChanged: function() {
                var selectionChangePromise = this._selectionChangePromise;
                (0, _deferred.when)(selectionChangePromise).done(function() {
                    this._createActionByOption("onSelectionChanged", {
                        excludeValidators: ["disabled", "readOnly"]
                    })()
                }.bind(this))
            },
            _createSelectAllValueChangedAction: function() {
                this._selectAllValueChangedAction = this._createActionByOption("onSelectAllValueChanged", {
                    excludeValidators: ["disabled", "readOnly"]
                })
            },
            _fireSelectAllValueChanged: function(value) {
                this._selectAllValueChangedAction({
                    value: value
                })
            },
            _checkBoxModeChange: function(value, previousValue) {
                if ("none" === previousValue || "none" === value) {
                    this.repaint();
                    return
                }
                var selectAllExists = this._$selectAllItem && this._$selectAllItem.length;
                switch (value) {
                    case "selectAll":
                        if (!selectAllExists) {
                            this._createSelectAllValueChangedAction();
                            this._renderSelectAllItem()
                        }
                        break;
                    case "normal":
                        if (selectAllExists) {
                            this._$selectAllItem.remove();
                            delete this._$selectAllItem
                        }
                }
            },
            _removeSelection: function() {
                var that = this;
                (0, _iterator.each)(this._dataAdapter.getFullData(), function(_, node) {
                    if (!that._hasChildren(node)) {
                        return
                    }
                    that._dataAdapter.toggleSelection(node.internalFields.key, false, true)
                })
            },
            _optionChanged: function(args) {
                var name = args.name,
                    value = args.value,
                    previousValue = args.previousValue;
                switch (name) {
                    case "selectAllText":
                        if (this._$selectAllItem) {
                            this._$selectAllItem.dxCheckBox("instance").option("text", value)
                        }
                        break;
                    case "showCheckBoxesMode":
                        this._checkBoxModeChange(value, previousValue);
                        break;
                    case "scrollDirection":
                        this._scrollableContainer.option("direction", value);
                        break;
                    case "items":
                        delete this._$selectAllItem;
                        this.callBase(args);
                        break;
                    case "dataSource":
                        this.callBase(args);
                        this._initDataAdapter();
                        this._filter = {};
                        break;
                    case "hasItemsExpr":
                        this._initAccessors();
                        this.repaint();
                        break;
                    case "expandEvent":
                        this._initExpandEvent();
                        break;
                    case "deferRendering":
                    case "dataStructure":
                    case "rootValue":
                    case "createChildren":
                    case "expandNodesRecursive":
                    case "onItemSelectionChanged":
                    case "onItemExpanded":
                    case "onItemCollapsed":
                    case "expandAllEnabled":
                    case "animationEnabled":
                    case "virtualModeEnabled":
                    case "selectByClick":
                        break;
                    case "selectionMode":
                        this._initDataAdapter();
                        this.callBase(args);
                        break;
                    case "onSelectAllValueChanged":
                        this._createSelectAllValueChangedAction();
                        break;
                    case "selectNodesRecursive":
                        this._dataAdapter.setOption("recursiveSelection", args.value);
                        this.repaint();
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _initDataSource: function() {
                if (this._useCustomChildrenLoader()) {
                    this._loadChildrenByCustomLoader(null).done(function(newItems) {
                        if (newItems && newItems.length) {
                            this.option("items", newItems)
                        }
                    }.bind(this))
                } else {
                    this.callBase();
                    this._isVirtualMode() && this._initVirtualMode()
                }
            },
            _initVirtualMode: function() {
                var filter = this._filter;
                if (!filter.custom) {
                    filter.custom = this._dataSource.filter()
                }
                if (!filter.internal) {
                    filter.internal = [this.option("parentIdExpr"), this.option("rootValue")]
                }
            },
            _useCustomChildrenLoader: function() {
                return (0, _type.isFunction)(this.option("createChildren")) && this._isDataStructurePlain()
            },
            _loadChildrenByCustomLoader: function(parentNode) {
                var invocationResult = this.option("createChildren").call(this, parentNode);
                if (Array.isArray(invocationResult)) {
                    return (new _deferred.Deferred).resolve(invocationResult).promise()
                }
                if (invocationResult && (0, _type.isFunction)(invocationResult.then)) {
                    return (0, _deferred.fromPromise)(invocationResult)
                }
                return (new _deferred.Deferred).resolve([]).promise()
            },
            _combineFilter: function() {
                if (!this._filter.custom || !this._filter.custom.length) {
                    return this._filter.internal
                }
                return [this._filter.custom, this._filter.internal]
            },
            _dataSourceLoadErrorHandler: function() {
                this._renderEmptyMessage()
            },
            _init: function() {
                this._filter = {};
                this.callBase();
                this._initStoreChangeHandlers()
            },
            _dataSourceChangedHandler: function(newItems) {
                var items = this.option("items");
                if (this._initialized && this._isVirtualMode() && items.length) {
                    return
                }
                this.option("items", newItems)
            },
            _removeTreeViewLoadIndicator: function() {
                if (!this._treeViewLoadIndicator) {
                    return
                }
                this._treeViewLoadIndicator.remove();
                this._treeViewLoadIndicator = null
            },
            _createTreeViewLoadIndicator: function() {
                this._treeViewLoadIndicator = (0, _renderer.default)("<div>").addClass(LOAD_INDICATOR_CLASS);
                this._createComponent(this._treeViewLoadIndicator, _load_indicator.default, {});
                return this._treeViewLoadIndicator
            },
            _dataSourceLoadingChangedHandler: function(isLoading) {
                var resultFilter;
                if (this._isVirtualMode()) {
                    resultFilter = this._combineFilter();
                    this._dataSource.filter(resultFilter)
                }
                if (isLoading && !this._dataSource.isLoaded()) {
                    this.option("items", []);
                    var $wrapper = (0, _renderer.default)("<div>").addClass(LOAD_INDICATOR_WRAPPER_CLASS);
                    this._createTreeViewLoadIndicator().appendTo($wrapper);
                    this.itemsContainer().append($wrapper);
                    if (this._isVirtualMode() && this._dataSource.filter() !== resultFilter) {
                        this._dataSource.filter([])
                    }
                } else {
                    this._removeTreeViewLoadIndicator()
                }
            },
            _initStoreChangeHandlers: function() {
                var _this2 = this;
                if ("plain" !== this.option("dataStructure")) {
                    return
                }
                this._dataSource && this._dataSource.store().on("inserted", function(newItem) {
                    _this2.option().items = _this2.option("items").concat(newItem);
                    _this2._dataAdapter.addItem(newItem);
                    if (!_this2._dataAdapter.isFiltered(newItem)) {
                        return
                    }
                    _this2._updateLevel(_this2._parentIdGetter(newItem))
                }).on("removed", function(removedKey) {
                    var node = _this2._dataAdapter.getNodeByKey(removedKey);
                    if ((0, _type.isDefined)(node)) {
                        _this2.option("items")[_this2._dataAdapter.getIndexByKey(node.internalFields.key)] = 0;
                        _this2._markChildrenItemsToRemove(node);
                        _this2._removeItems();
                        _this2._dataAdapter.removeItem(removedKey);
                        _this2._updateLevel(_this2._parentIdGetter(node))
                    }
                })
            },
            _markChildrenItemsToRemove: function(node) {
                var _this3 = this;
                var keys = node.internalFields.childrenKeys;
                (0, _iterator.each)(keys, function(_, key) {
                    _this3.option("items")[_this3._dataAdapter.getIndexByKey(key)] = 0;
                    _this3._markChildrenItemsToRemove(_this3._dataAdapter.getNodeByKey(key))
                })
            },
            _removeItems: function() {
                var _this4 = this;
                var items = (0, _extend.extend)(true, [], this.option("items"));
                var counter = 0;
                (0, _iterator.each)(items, function(index, item) {
                    if (!item) {
                        _this4.option("items").splice(index - counter, 1);
                        counter++
                    }
                })
            },
            _updateLevel: function(parentId) {
                var $container = this._getContainerByParentKey(parentId);
                this._renderItems($container, this._dataAdapter.getChildrenNodes(parentId))
            },
            _getOldContainer: function($itemElement) {
                if ($itemElement.length) {
                    return $itemElement.children(".".concat(NODE_CONTAINER_CLASS))
                }
                if (this._scrollableContainer) {
                    return this._scrollableContainer.$content().children()
                }
                return (0, _renderer.default)()
            },
            _getContainerByParentKey: function(parentId) {
                var node = this._dataAdapter.getNodeByKey(parentId);
                var $itemElement = node ? this._getNodeElement(node) : [];
                this._getOldContainer($itemElement).remove();
                var $container = this._renderNodeContainer($itemElement);
                if (this._isRootLevel(parentId)) {
                    if (!this._scrollableContainer) {
                        this._renderScrollableContainer()
                    }
                    this._scrollableContainer.$content().append($container)
                }
                return $container
            },
            _isRootLevel: function(parentId) {
                return parentId === this.option("rootValue")
            },
            _getAccessors: function() {
                var accessors = this.callBase();
                accessors.push("hasItems");
                return accessors
            },
            _getDataAdapterOptions: function() {
                return {
                    rootValue: this.option("rootValue"),
                    multipleSelection: !this._isSingleSelection(),
                    recursiveSelection: this._isRecursiveSelection(),
                    recursiveExpansion: this.option("expandNodesRecursive"),
                    selectionRequired: this.option("selectionRequired"),
                    dataType: this.option("dataStructure"),
                    sort: this._dataSource && this._dataSource.sort()
                }
            },
            _initMarkup: function() {
                this._renderScrollableContainer();
                this._renderEmptyMessage(this._dataAdapter.getRootNodes());
                this.callBase();
                this.setAria("role", "tree")
            },
            _renderContentImpl: function() {
                var $nodeContainer = this._renderNodeContainer();
                this._scrollableContainer.$content().append($nodeContainer);
                if (!this.option("items") || !this.option("items").length) {
                    return
                }
                this._renderItems($nodeContainer, this._dataAdapter.getRootNodes());
                this._initExpandEvent();
                if (this._selectAllEnabled()) {
                    this._createSelectAllValueChangedAction();
                    this._renderSelectAllItem($nodeContainer)
                }
            },
            _isVirtualMode: function() {
                return this.option("virtualModeEnabled") && this._isDataStructurePlain() && !!this.option("dataSource")
            },
            _isDataStructurePlain: function() {
                return "plain" === this.option("dataStructure")
            },
            _fireContentReadyAction: function() {
                var dataSource = this.getDataSource();
                var skipContentReadyAction = dataSource && !dataSource.isLoaded();
                if (this._scrollableContainer && (0, _window.hasWindow)()) {
                    this._scrollableContainer.update()
                }
                if (!skipContentReadyAction) {
                    this.callBase()
                }
                if (this._scrollableContainer && (0, _window.hasWindow)()) {
                    this._scrollableContainer.update()
                }
            },
            _renderScrollableContainer: function() {
                this._scrollableContainer = this._createComponent((0, _renderer.default)("<div>").appendTo(this.$element()), _ui2.default, {
                    direction: this.option("scrollDirection"),
                    useKeyboard: false
                })
            },
            _renderNodeContainer: function($parent) {
                var $container = (0, _renderer.default)("<ul>").addClass(NODE_CONTAINER_CLASS);
                this.setAria("role", "group", $container);
                if ($parent && $parent.length) {
                    var itemData = this._getItemData($parent.children("." + ITEM_CLASS));
                    if (this._expandedGetter(itemData)) {
                        $container.addClass(OPENED_NODE_CONTAINER_CLASS)
                    }
                    $container.appendTo($parent)
                }
                return $container
            },
            _createDOMElement: function($nodeContainer, node) {
                var $node = (0, _renderer.default)("<li>").addClass(NODE_CLASS).attr(DATA_ITEM_ID, this._encodeString(node.internalFields.key)).prependTo($nodeContainer);
                this.setAria({
                    role: "treeitem",
                    label: this._displayGetter(node.internalFields.item) || "",
                    expanded: node.internalFields.expanded || false,
                    level: this._getLevel($nodeContainer)
                }, $node);
                return $node
            },
            _getLevel: function($nodeContainer) {
                var parent = $nodeContainer.parent();
                return parent.hasClass("dx-scrollable-content") ? 1 : parseInt(parent.attr("aria-level")) + 1
            },
            _showCheckboxes: function() {
                return "none" !== this.option("showCheckBoxesMode")
            },
            _selectAllEnabled: function() {
                return "selectAll" === this.option("showCheckBoxesMode") && !this._isSingleSelection()
            },
            _renderItems: function($nodeContainer, nodes) {
                var length = nodes.length - 1;
                for (var i = length; i >= 0; i--) {
                    this._renderItem(i, nodes[i], $nodeContainer)
                }
                this._renderedItemsCount += nodes.length
            },
            _renderItem: function(nodeIndex, node, $nodeContainer) {
                var $node = this._createDOMElement($nodeContainer, node);
                var nodeData = node.internalFields;
                var showCheckBox = this._showCheckboxes();
                $node.addClass(showCheckBox ? ITEM_WITH_CHECKBOX_CLASS : ITEM_WITHOUT_CHECKBOX_CLASS);
                $node.toggleClass(INVISIBLE_STATE_CLASS, false === nodeData.item.visible);
                showCheckBox && this._renderCheckBox($node, node);
                this.setAria("selected", nodeData.selected, $node);
                this._toggleSelectedClass($node, nodeData.selected);
                this.callBase(this._renderedItemsCount + nodeIndex, nodeData.item, $node);
                if (false !== nodeData.item.visible) {
                    this._renderChildren($node, node)
                }
            },
            _setAriaSelected: function() {},
            _renderChildren: function($node, node) {
                var _this5 = this;
                if (!this._hasChildren(node)) {
                    this._addLeafClass($node);
                    return
                }
                this._renderToggleItemVisibilityIcon($node, node);
                if (this.option("deferRendering") && !node.internalFields.expanded) {
                    return
                }
                this._loadSublevel(node).done(function(childNodes) {
                    _this5._renderSublevel($node, _this5._getActualNode(node), childNodes)
                })
            },
            _getActualNode: function(cachedNode) {
                return this._dataAdapter.getNodeByKey(cachedNode.internalFields.key)
            },
            _hasChildren: function(node) {
                if (this._isVirtualMode() || this._useCustomChildrenLoader()) {
                    return false !== this._hasItemsGetter(node.internalFields.item)
                }
                return this.callBase(node)
            },
            _loadSublevel: function(node) {
                var _this6 = this;
                var deferred = new _deferred.Deferred;
                var childrenNodes = this._getChildNodes(node);
                if (childrenNodes.length) {
                    deferred.resolve(childrenNodes)
                } else {
                    this._loadNestedItems(node).done(function(items) {
                        deferred.resolve(_this6._dataAdapter.getNodesByItems(items))
                    })
                }
                return deferred.promise()
            },
            _renderSublevel: function($node, node, childNodes) {
                var $nestedNodeContainer = this._renderNodeContainer($node, node);
                var childNodesByChildrenKeys = childNodes.filter(function(childNode) {
                    return node.internalFields.childrenKeys.indexOf(childNode.internalFields.key) !== -1
                });
                this._renderItems($nestedNodeContainer, childNodesByChildrenKeys);
                if (childNodesByChildrenKeys.length && !node.internalFields.selected) {
                    var firstChild = childNodesByChildrenKeys[0];
                    this._updateParentsState(firstChild, this._getNodeElement(firstChild))
                }
                this._normalizeIconState($node, childNodesByChildrenKeys.length);
                if (node.internalFields.expanded) {
                    $nestedNodeContainer.addClass(OPENED_NODE_CONTAINER_CLASS)
                }
            },
            _executeItemRenderAction: function(itemIndex, itemData, itemElement) {
                var node = this._getNode(itemElement);
                this._getItemRenderAction()({
                    itemElement: itemElement,
                    itemIndex: itemIndex,
                    itemData: itemData,
                    node: this._dataAdapter.getPublicNode(node)
                })
            },
            _addLeafClass: function($node) {
                $node.addClass(IS_LEAF)
            },
            _expandEventHandler: function(e) {
                var $nodeElement = (0, _renderer.default)(e.currentTarget.parentNode);
                if (!$nodeElement.hasClass(IS_LEAF)) {
                    this._toggleExpandedState(e.currentTarget, void 0, e)
                }
            },
            _initExpandEvent: function() {
                var expandedEventName = this._getEventNameByOption(this.option("expandEvent"));
                var $itemsContainer = this._itemContainer();
                var itemSelector = this._itemSelector();
                _events_engine.default.off($itemsContainer, "." + EXPAND_EVENT_NAMESPACE, itemSelector);
                _events_engine.default.on($itemsContainer, expandedEventName, itemSelector, this._expandEventHandler.bind(this))
            },
            _getEventNameByOption: function(name) {
                var event = "click" === name ? _click.name : _double_click.name;
                return (0, _index.addNamespace)(event, EXPAND_EVENT_NAMESPACE)
            },
            _getNode: function(identifier) {
                if (!(0, _type.isDefined)(identifier)) {
                    return null
                }
                if (identifier.internalFields) {
                    return identifier
                }
                if ((0, _type.isPrimitive)(identifier)) {
                    return this._dataAdapter.getNodeByKey(identifier)
                }
                var itemElement = (0, _renderer.default)(identifier).get(0);
                if (!itemElement) {
                    return null
                }
                if (_dom_adapter.default.isElementNode(itemElement)) {
                    return this._getNodeByElement(itemElement)
                }
                return this._dataAdapter.getNodeByItem(itemElement)
            },
            _getNodeByElement: function(itemElement) {
                var $node = (0, _renderer.default)(itemElement).closest("." + NODE_CLASS);
                var key = this._decodeString($node.attr(DATA_ITEM_ID));
                return this._dataAdapter.getNodeByKey(key)
            },
            _toggleExpandedState: function(itemElement, state, e) {
                var node = this._getNode(itemElement);
                if (!node) {
                    return (new _deferred.Deferred).reject().promise()
                }
                if (node.internalFields.disabled) {
                    return (new _deferred.Deferred).reject().promise()
                }
                var currentState = node.internalFields.expanded;
                if (currentState === state) {
                    return (new _deferred.Deferred).resolve().promise()
                }
                if (this._hasChildren(node)) {
                    var $node = this._getNodeElement(node);
                    if ($node.find(".".concat(NODE_LOAD_INDICATOR_CLASS, ":not(.").concat(INVISIBLE_STATE_CLASS, ")")).length) {
                        return (new _deferred.Deferred).reject().promise()
                    }
                    this._createLoadIndicator($node)
                }
                if (!(0, _type.isDefined)(state)) {
                    state = !currentState
                }
                this._dataAdapter.toggleExpansion(node.internalFields.key, state);
                return this._updateExpandedItemsUI(node, state, e)
            },
            _createLoadIndicator: function($node) {
                var $icon = $node.children("." + TOGGLE_ITEM_VISIBILITY_CLASS);
                var $nodeContainer = $node.children(".".concat(NODE_CONTAINER_CLASS));
                if ($icon.hasClass(TOGGLE_ITEM_VISIBILITY_OPENED_CLASS) || $nodeContainer.not(":empty").length) {
                    return
                }
                this._createComponent((0, _renderer.default)("<div>").addClass(NODE_LOAD_INDICATOR_CLASS), _load_indicator.default, {}).$element().appendTo($node);
                $icon.hide()
            },
            _renderToggleItemVisibilityIcon: function($node, node) {
                var $icon = (0, _renderer.default)("<div>").addClass(TOGGLE_ITEM_VISIBILITY_CLASS).appendTo($node);
                if (node.internalFields.expanded) {
                    $icon.addClass(TOGGLE_ITEM_VISIBILITY_OPENED_CLASS);
                    $node.parent().addClass(OPENED_NODE_CONTAINER_CLASS)
                }
                if (node.internalFields.disabled) {
                    $icon.addClass(DISABLED_STATE_CLASS)
                }
                this._renderToggleItemVisibilityIconClick($icon, node)
            },
            _renderToggleItemVisibilityIconClick: function($icon, node) {
                var _this7 = this;
                var eventName = (0, _index.addNamespace)(_click.name, this.NAME);
                _events_engine.default.off($icon, eventName);
                _events_engine.default.on($icon, eventName, function(e) {
                    _this7._toggleExpandedState(node.internalFields.key, void 0, e)
                })
            },
            _updateExpandedItemsUI: function(node, state, e) {
                var $node = this._getNodeElement(node);
                var isHiddenNode = !$node.length || state && $node.is(":hidden");
                if (this.option("expandNodesRecursive") && isHiddenNode) {
                    var parentNode = this._getNode(node.internalFields.parentKey);
                    if (parentNode) {
                        this._updateExpandedItemsUI(parentNode, state, e)
                    }
                }
                var $icon = $node.children("." + TOGGLE_ITEM_VISIBILITY_CLASS);
                var $nodeContainer = $node.children(".".concat(NODE_CONTAINER_CLASS));
                $icon.toggleClass(TOGGLE_ITEM_VISIBILITY_OPENED_CLASS, state);
                var nodeContainerExists = $nodeContainer.length > 0;
                var completionCallback = new _deferred.Deferred;
                if (!state || nodeContainerExists && !$nodeContainer.is(":empty")) {
                    this._animateNodeContainer(node, state, e, completionCallback);
                    return completionCallback.promise()
                }
                if (0 === node.internalFields.childrenKeys.length && (this._isVirtualMode() || this._useCustomChildrenLoader())) {
                    this._loadNestedItemsWithUpdate(node, state, e, completionCallback);
                    return completionCallback.promise()
                }
                this._renderSublevel($node, node, this._getChildNodes(node));
                this._fireContentReadyAction();
                this._animateNodeContainer(node, state, e, completionCallback);
                return completionCallback.promise()
            },
            _loadNestedItemsWithUpdate: function(node, state, e, completionCallback) {
                var _this8 = this;
                var $node = this._getNodeElement(node);
                this._loadNestedItems(node).done(function(items) {
                    var actualNodeData = _this8._getActualNode(node);
                    _this8._renderSublevel($node, actualNodeData, _this8._dataAdapter.getNodesByItems(items));
                    if (!items || !items.length) {
                        return
                    }
                    _this8._fireContentReadyAction();
                    _this8._animateNodeContainer(actualNodeData, state, e, completionCallback)
                })
            },
            _loadNestedItems: function(node) {
                var _this9 = this;
                if (this._useCustomChildrenLoader()) {
                    var publicNode = this._dataAdapter.getPublicNode(node);
                    return this._loadChildrenByCustomLoader(publicNode).done(function(newItems) {
                        if (!_this9._areNodesExists(newItems)) {
                            _this9._appendItems(newItems)
                        }
                    })
                }
                if (!this._isVirtualMode()) {
                    return (new _deferred.Deferred).resolve([]).promise()
                }
                this._filter.internal = [this.option("parentIdExpr"), node.internalFields.key];
                this._dataSource.filter(this._combineFilter());
                return this._dataSource.load().done(function(newItems) {
                    if (!_this9._areNodesExists(newItems)) {
                        _this9._appendItems(newItems)
                    }
                })
            },
            _areNodesExists: function(newItems, items) {
                var keyOfRootItem = this.keyOf(newItems[0]);
                var fullData = this._dataAdapter.getFullData();
                return !!this._dataAdapter.getNodeByKey(keyOfRootItem, fullData)
            },
            _appendItems: function(newItems) {
                this.option().items = this.option("items").concat(newItems);
                this._initDataAdapter()
            },
            _animateNodeContainer: function(node, state, e, completionCallback) {
                var $node = this._getNodeElement(node);
                var $nodeContainer = $node.children(".".concat(NODE_CONTAINER_CLASS));
                if (node && completionCallback && 0 === $nodeContainer.length) {
                    completionCallback.resolve()
                }
                $nodeContainer.addClass(OPENED_NODE_CONTAINER_CLASS);
                var nodeHeight = $nodeContainer.height();
                _fx.default.stop($nodeContainer, true);
                _fx.default.animate($nodeContainer, {
                    type: "custom",
                    duration: this.option("animationEnabled") ? 400 : 0,
                    from: {
                        maxHeight: state ? 0 : nodeHeight
                    },
                    to: {
                        maxHeight: state ? nodeHeight : 0
                    },
                    complete: function() {
                        $nodeContainer.css("maxHeight", "none");
                        $nodeContainer.toggleClass(OPENED_NODE_CONTAINER_CLASS, state);
                        this.setAria("expanded", state, $node);
                        this._scrollableContainer.update();
                        this._fireExpandedStateUpdatedEvent(state, node, e);
                        if (completionCallback) {
                            completionCallback.resolve()
                        }
                    }.bind(this)
                })
            },
            _fireExpandedStateUpdatedEvent: function(isExpanded, node, e) {
                if (!this._hasChildren(node)) {
                    return
                }
                var optionName = isExpanded ? "onItemExpanded" : "onItemCollapsed";
                if ((0, _type.isDefined)(e)) {
                    this._itemDXEventHandler(e, optionName, {
                        node: this._dataAdapter.getPublicNode(node)
                    })
                } else {
                    var target = this._getNodeElement(node);
                    this._itemEventHandler(target, optionName, {
                        event: e,
                        node: this._dataAdapter.getPublicNode(node)
                    })
                }
            },
            _normalizeIconState: function($node, hasNewItems) {
                var $loadIndicator = $node.find(".".concat(NODE_LOAD_INDICATOR_CLASS));
                $loadIndicator.length && _load_indicator.default.getInstance($loadIndicator).option("visible", false);
                if (hasNewItems) {
                    var $icon = $node.find("." + TOGGLE_ITEM_VISIBILITY_CLASS);
                    $icon.show();
                    return
                }
                $node.find("." + TOGGLE_ITEM_VISIBILITY_CLASS).removeClass(TOGGLE_ITEM_VISIBILITY_CLASS);
                $node.addClass(IS_LEAF)
            },
            _emptyMessageContainer: function() {
                return this._scrollableContainer ? this._scrollableContainer.content() : this.callBase()
            },
            _renderContent: function() {
                var items = this.option("items");
                if (items && items.length) {
                    this._contentAlreadyRendered = true
                }
                this.callBase()
            },
            _renderSelectAllItem: function($container) {
                $container = $container || this.$element().find(".".concat(NODE_CONTAINER_CLASS)).first();
                this._$selectAllItem = (0, _renderer.default)("<div>").addClass(SELECT_ALL_ITEM_CLASS);
                var value = this._dataAdapter.isAllSelected();
                this._createComponent(this._$selectAllItem, _check_box.default, {
                    value: value,
                    text: this.option("selectAllText"),
                    onValueChanged: this._onSelectAllCheckboxValueChanged.bind(this)
                });
                this._toggleSelectedClass(this._$selectAllItem, value);
                $container.before(this._$selectAllItem)
            },
            _onSelectAllCheckboxValueChanged: function(args) {
                this._toggleSelectAll(args);
                this._fireSelectAllValueChanged(args.value)
            },
            _toggleSelectAll: function(args) {
                this._dataAdapter.toggleSelectAll(args.value);
                this._updateItemsUI();
                this._fireSelectionChanged()
            },
            _renderCheckBox: function($node, node) {
                var $checkbox = (0, _renderer.default)("<div>").appendTo($node);
                this._createComponent($checkbox, _check_box.default, {
                    value: node.internalFields.selected,
                    onValueChanged: this._changeCheckboxValue.bind(this),
                    focusStateEnabled: false,
                    disabled: this._disabledGetter(node)
                })
            },
            _toggleSelectedClass: function($node, value) {
                $node.toggleClass(SELECTED_ITEM_CLASS, !!value)
            },
            _toggleNodeDisabledState: function(node, state) {
                var $node = this._getNodeElement(node);
                var $item = $node.find("." + ITEM_CLASS).eq(0);
                this._dataAdapter.toggleNodeDisabledState(node.internalFields.key, state);
                $item.toggleClass(DISABLED_STATE_CLASS, !!state);
                if (this._showCheckboxes()) {
                    var checkbox = this._getCheckBoxInstance($node);
                    checkbox.option("disabled", !!state)
                }
            },
            _itemOptionChanged: function(item, property, value) {
                var node = this._dataAdapter.getNodeByItem(item);
                if (property === this.option("disabledExpr")) {
                    this._toggleNodeDisabledState(node, value)
                }
            },
            _changeCheckboxValue: function(e) {
                var $node = (0, _renderer.default)(e.element).parent("." + NODE_CLASS);
                var $item = $node.children("." + ITEM_CLASS);
                var item = this._getItemData($item);
                var node = this._getNodeByElement($item);
                var value = e.value;
                if (node && node.internalFields.selected === value) {
                    return
                }
                this._updateItemSelection(value, item, e.event)
            },
            _isSingleSelection: function() {
                return "single" === this.option("selectionMode")
            },
            _isRecursiveSelection: function() {
                return this.option("selectNodesRecursive") && "single" !== this.option("selectionMode")
            },
            _isLastSelectedBranch: function(publicNode, selectedNodesKeys, deep) {
                var keyIndex = selectedNodesKeys.indexOf(publicNode.key);
                if (keyIndex >= 0) {
                    selectedNodesKeys.splice(keyIndex, 1)
                }
                if (deep) {
                    (0, _iterator.each)(publicNode.children, function(_, childNode) {
                        this._isLastSelectedBranch(childNode, selectedNodesKeys, true)
                    }.bind(this))
                }
                if (publicNode.parent) {
                    this._isLastSelectedBranch(publicNode.parent, selectedNodesKeys)
                }
                return 0 === selectedNodesKeys.length
            },
            _isLastRequired: function(node) {
                var selectionRequired = this.option("selectionRequired");
                var isSingleMode = this._isSingleSelection();
                var selectedNodesKeys = this.getSelectedNodeKeys();
                if (!selectionRequired) {
                    return
                }
                if (isSingleMode) {
                    return 1 === selectedNodesKeys.length
                } else {
                    return this._isLastSelectedBranch(node.internalFields.publicNode, selectedNodesKeys.slice(), true)
                }
            },
            _updateItemSelection: function(value, itemElement, dxEvent) {
                var _this10 = this;
                var node = this._getNode(itemElement);
                if (!node || false === node.visible) {
                    return false
                }
                if (node.internalFields.selected === value) {
                    return true
                }
                if (!value && this._isLastRequired(node)) {
                    if (this._showCheckboxes()) {
                        var $node = this._getNodeElement(node);
                        this._getCheckBoxInstance($node).option("value", true)
                    }
                    return false
                }
                if (value && this._isSingleSelection()) {
                    var selectedKeys = this.getSelectedNodeKeys();
                    (0, _iterator.each)(selectedKeys, function(index, key) {
                        _this10._dataAdapter.toggleSelection(key, false);
                        _this10._updateItemsUI();
                        _this10._fireItemSelectionChanged(_this10._getNode(key))
                    })
                }
                this._dataAdapter.toggleSelection(node.internalFields.key, value);
                var isAllSelected = this._dataAdapter.isAllSelected();
                var needFireSelectAllChanged = this._selectAllEnabled() && this._$selectAllItem.dxCheckBox("instance").option("value") !== isAllSelected;
                this._updateItemsUI();
                this._fireItemSelectionChanged(node, dxEvent);
                this._fireSelectionChanged();
                if (needFireSelectAllChanged) {
                    this._fireSelectAllValueChanged(isAllSelected)
                }
                return true
            },
            _fireItemSelectionChanged: function(node, dxEvent) {
                var initiator = dxEvent || this._findItemElementByItem(node.internalFields.item);
                var handler = dxEvent ? this._itemDXEventHandler : this._itemEventHandler;
                handler.call(this, initiator, "onItemSelectionChanged", {
                    node: this._dataAdapter.getPublicNode(node),
                    itemData: node.internalFields.item
                })
            },
            _getCheckBoxInstance: function($node) {
                return $node.children(".dx-checkbox").dxCheckBox("instance")
            },
            _updateItemsUI: function() {
                var _this11 = this;
                var cache = {};
                (0, _iterator.each)(this._dataAdapter.getData(), function(_, node) {
                    var $node = _this11._getNodeElement(node, cache);
                    var nodeSelection = node.internalFields.selected;
                    if (!$node.length) {
                        return
                    }
                    _this11._toggleSelectedClass($node, nodeSelection);
                    _this11.setAria("selected", nodeSelection, $node);
                    if (_this11._showCheckboxes()) {
                        _this11._getCheckBoxInstance($node).option("value", nodeSelection)
                    }
                });
                if (this._selectAllEnabled()) {
                    var selectAllCheckbox = this._$selectAllItem.dxCheckBox("instance");
                    selectAllCheckbox._setOptionWithoutOptionChange("onValueChanged", void 0);
                    selectAllCheckbox.option("value", this._dataAdapter.isAllSelected());
                    selectAllCheckbox._setOptionWithoutOptionChange("onValueChanged", this._onSelectAllCheckboxValueChanged.bind(this))
                }
            },
            _updateParentsState: function(node, $node) {
                if (!$node) {
                    return
                }
                var parentNode = this._dataAdapter.getNodeByKey(node.internalFields.parentKey);
                var $parentNode = (0, _renderer.default)($node.parents("." + NODE_CLASS)[0]);
                if (this._showCheckboxes()) {
                    var parentValue = parentNode.internalFields.selected;
                    this._getCheckBoxInstance($parentNode).option("value", parentValue);
                    this._toggleSelectedClass($parentNode, parentValue)
                }
                if (parentNode.internalFields.parentKey !== this.option("rootValue")) {
                    this._updateParentsState(parentNode, $parentNode)
                }
            },
            _itemEventHandlerImpl: function(initiator, action, actionArgs) {
                var $itemElement = (0, _renderer.default)(initiator).closest("." + NODE_CLASS).children("." + ITEM_CLASS);
                return action((0, _extend.extend)(this._extendActionArgs($itemElement), actionArgs))
            },
            _itemContextMenuHandler: function(e) {
                this._createEventHandler("onItemContextMenu", e)
            },
            _itemHoldHandler: function(e) {
                this._createEventHandler("onItemHold", e)
            },
            _createEventHandler: function(eventName, e) {
                var node = this._getNodeByElement(e.currentTarget);
                this._itemDXEventHandler(e, eventName, {
                    node: this._dataAdapter.getPublicNode(node)
                })
            },
            _itemClass: function() {
                return ITEM_CLASS
            },
            _itemDataKey: function() {
                return ITEM_DATA_KEY
            },
            _attachClickEvent: function() {
                var clickSelector = "." + this._itemClass();
                var pointerDownSelector = "." + NODE_CLASS + ", ." + SELECT_ALL_ITEM_CLASS;
                var eventName = (0, _index.addNamespace)(_click.name, this.NAME);
                var pointerDownEvent = (0, _index.addNamespace)(_pointer.default.down, this.NAME);
                var $itemContainer = this._itemContainer();
                var that = this;
                _events_engine.default.off($itemContainer, eventName, clickSelector);
                _events_engine.default.off($itemContainer, pointerDownEvent, pointerDownSelector);
                _events_engine.default.on($itemContainer, eventName, clickSelector, function(e) {
                    that._itemClickHandler(e, (0, _renderer.default)(this))
                });
                _events_engine.default.on($itemContainer, pointerDownEvent, pointerDownSelector, function(e) {
                    that._itemPointerDownHandler(e)
                })
            },
            _itemClickHandler: function(e, $item) {
                var itemData = this._getItemData($item);
                var node = this._getNodeByElement($item);
                this._itemDXEventHandler(e, "onItemClick", {
                    node: this._dataAdapter.getPublicNode(node)
                });
                if (this.option("selectByClick") && !e.isDefaultPrevented()) {
                    this._updateItemSelection(!node.internalFields.selected, itemData, e)
                }
            },
            _updateSelectionToFirstItem: function($items, startIndex) {
                var itemIndex = startIndex;
                while (itemIndex >= 0) {
                    var $item = (0, _renderer.default)($items[itemIndex]);
                    this._updateItemSelection(true, $item.find("." + ITEM_CLASS).get(0));
                    itemIndex--
                }
            },
            _updateSelectionToLastItem: function($items, startIndex) {
                var length = $items.length;
                var itemIndex = startIndex;
                while (itemIndex < length) {
                    var $item = (0, _renderer.default)($items[itemIndex]);
                    this._updateItemSelection(true, $item.find("." + ITEM_CLASS).get(0));
                    itemIndex++
                }
            },
            _focusInHandler: function(e) {
                var _this12 = this;
                this._updateFocusState(e, true);
                if (this.option("focusedElement")) {
                    clearTimeout(this._setFocusedItemTimeout);
                    this._setFocusedItemTimeout = setTimeout(function() {
                        _this12._setFocusedItem((0, _renderer.default)(_this12.option("focusedElement")))
                    });
                    return
                }
                var $activeItem = this._getActiveItem();
                this.option("focusedElement", (0, _element.getPublicElement)($activeItem.closest("." + NODE_CLASS)))
            },
            _setFocusedItem: function($target) {
                if (!$target || !$target.length) {
                    return
                }
                if (!$target.children().hasClass(DISABLED_STATE_CLASS)) {
                    this.callBase($target)
                }
            },
            _itemPointerDownHandler: function(e) {
                if (!this.option("focusStateEnabled")) {
                    return
                }
                var $target = (0, _renderer.default)(e.target).closest("." + NODE_CLASS + ", ." + SELECT_ALL_ITEM_CLASS);
                if (!$target.length) {
                    return
                }
                var itemElement = $target.hasClass(DISABLED_STATE_CLASS) ? null : $target;
                this.option("focusedElement", (0, _element.getPublicElement)(itemElement))
            },
            _findNonDisabledNodes: function($nodes) {
                return $nodes.not(function() {
                    return (0, _renderer.default)(this).children("." + ITEM_CLASS).hasClass(DISABLED_STATE_CLASS)
                })
            },
            _moveFocus: function(location, e) {
                var FOCUS_UP = "up";
                var FOCUS_DOWN = "down";
                var FOCUS_FIRST = "first";
                var FOCUS_LAST = "last";
                var FOCUS_LEFT = this.option("rtlEnabled") ? "right" : "left";
                var FOCUS_RIGHT = this.option("rtlEnabled") ? "left" : "right";
                this.$element().find(".".concat(NODE_CONTAINER_CLASS)).each(function() {
                    _fx.default.stop(this, true)
                });
                var $items = this._findNonDisabledNodes(this._nodeElements());
                if (!$items || !$items.length) {
                    return
                }
                switch (location) {
                    case FOCUS_UP:
                        var $prevItem = this._prevItem($items);
                        this.option("focusedElement", (0, _element.getPublicElement)($prevItem));
                        var prevItemElement = this._getNodeItemElement($prevItem);
                        this._scrollableContainer.scrollToElement(prevItemElement);
                        if (e.shiftKey && this._showCheckboxes()) {
                            this._updateItemSelection(true, prevItemElement)
                        }
                        break;
                    case FOCUS_DOWN:
                        var $nextItem = this._nextItem($items);
                        this.option("focusedElement", (0, _element.getPublicElement)($nextItem));
                        var nextItemElement = this._getNodeItemElement($nextItem);
                        this._scrollableContainer.scrollToElement(nextItemElement);
                        if (e.shiftKey && this._showCheckboxes()) {
                            this._updateItemSelection(true, nextItemElement)
                        }
                        break;
                    case FOCUS_FIRST:
                        var $firstItem = $items.first();
                        if (e.shiftKey && this._showCheckboxes()) {
                            this._updateSelectionToFirstItem($items, $items.index(this._prevItem($items)))
                        }
                        this.option("focusedElement", (0, _element.getPublicElement)($firstItem));
                        this._scrollableContainer.scrollToElement(this._getNodeItemElement($firstItem));
                        break;
                    case FOCUS_LAST:
                        var $lastItem = $items.last();
                        if (e.shiftKey && this._showCheckboxes()) {
                            this._updateSelectionToLastItem($items, $items.index(this._nextItem($items)))
                        }
                        this.option("focusedElement", (0, _element.getPublicElement)($lastItem));
                        this._scrollableContainer.scrollToElement(this._getNodeItemElement($lastItem));
                        break;
                    case FOCUS_RIGHT:
                        this._expandFocusedContainer();
                        break;
                    case FOCUS_LEFT:
                        this._collapseFocusedContainer();
                        break;
                    default:
                        this.callBase.apply(this, arguments);
                        return
                }
            },
            _getNodeItemElement: function($node) {
                return $node.find("." + ITEM_CLASS).get(0)
            },
            _nodeElements: function() {
                return this.$element().find("." + NODE_CLASS).not(":hidden")
            },
            _expandFocusedContainer: function() {
                var $focusedNode = (0, _renderer.default)(this.option("focusedElement"));
                if (!$focusedNode.length || $focusedNode.hasClass(IS_LEAF)) {
                    return
                }
                var $node = $focusedNode.find(".".concat(NODE_CONTAINER_CLASS)).eq(0);
                if ($node.hasClass(OPENED_NODE_CONTAINER_CLASS)) {
                    var $nextItem = this._nextItem(this._findNonDisabledNodes(this._nodeElements()));
                    this.option("focusedElement", (0, _element.getPublicElement)($nextItem));
                    this._scrollableContainer.scrollToElement(this._getNodeItemElement($nextItem));
                    return
                }
                var node = this._getNodeByElement($focusedNode.children("." + ITEM_CLASS));
                this._toggleExpandedState(node, true)
            },
            _getClosestNonDisabledNode: function($node) {
                do {
                    $node = $node.parent().closest("." + NODE_CLASS)
                } while ($node.children(".dx-treeview-item.dx-state-disabled").length);
                return $node
            },
            _collapseFocusedContainer: function() {
                var $focusedNode = (0, _renderer.default)(this.option("focusedElement"));
                if (!$focusedNode.length) {
                    return
                }
                var nodeElement = $focusedNode.find(".".concat(NODE_CONTAINER_CLASS)).eq(0);
                if (!$focusedNode.hasClass(IS_LEAF) && nodeElement.hasClass(OPENED_NODE_CONTAINER_CLASS)) {
                    var node = this._getNodeByElement($focusedNode.children("." + ITEM_CLASS));
                    this._toggleExpandedState(node, false)
                } else {
                    var collapsedNode = this._getClosestNonDisabledNode($focusedNode);
                    collapsedNode.length && this.option("focusedElement", (0, _element.getPublicElement)(collapsedNode));
                    this._scrollableContainer.scrollToElement(this._getNodeItemElement(collapsedNode))
                }
            },
            _encodeString: function(value) {
                return (0, _type.isString)(value) ? encodeURI(value) : value
            },
            _decodeString: function(value) {
                return (0, _type.isString)(value) ? decodeURI(value) : value
            },
            updateDimensions: function() {
                var _this13 = this;
                var deferred = new _deferred.Deferred;
                if (this._scrollableContainer) {
                    this._scrollableContainer.update().done(function() {
                        deferred.resolveWith(_this13)
                    })
                } else {
                    deferred.resolveWith(this)
                }
                return deferred.promise()
            },
            selectItem: function(itemElement) {
                return this._updateItemSelection(true, itemElement)
            },
            unselectItem: function(itemElement) {
                return this._updateItemSelection(false, itemElement)
            },
            expandItem: function(itemElement) {
                return this._toggleExpandedState(itemElement, true)
            },
            collapseItem: function(itemElement) {
                return this._toggleExpandedState(itemElement, false)
            },
            getNodes: function() {
                return this._dataAdapter.getTreeNodes()
            },
            getSelectedNodes: function() {
                var _this14 = this;
                return this.getSelectedNodeKeys().map(function(key) {
                    var node = _this14._dataAdapter.getNodeByKey(key);
                    return _this14._dataAdapter.getPublicNode(node)
                })
            },
            getSelectedNodesKeys: function() {
                _ui3.default.log("W0002", "dxTreeView", "getSelectedNodesKeys", "20.1", "Use the 'getSelectedNodeKeys' method instead");
                return this.getSelectedNodeKeys()
            },
            getSelectedNodeKeys: function() {
                return this._dataAdapter.getSelectedNodesKeys()
            },
            selectAll: function() {
                if (this._selectAllEnabled()) {
                    this._$selectAllItem.dxCheckBox("instance").option("value", true)
                } else {
                    this._toggleSelectAll({
                        value: true
                    })
                }
            },
            unselectAll: function() {
                if (this._selectAllEnabled()) {
                    this._$selectAllItem.dxCheckBox("instance").option("value", false)
                } else {
                    this._toggleSelectAll({
                        value: false
                    })
                }
            },
            expandAll: function() {
                var dataAdapter = this._dataAdapter;
                (0, _iterator.each)(dataAdapter.getData(), function(_, node) {
                    return dataAdapter.toggleExpansion(node.internalFields.key, true)
                });
                this.repaint()
            },
            collapseAll: function() {
                (0, _iterator.each)(this._dataAdapter.getExpandedNodesKeys(), function(_, key) {
                    this._toggleExpandedState(key, false)
                }.bind(this))
            },
            scrollToItem: function(keyOrItemOrElement) {
                var _this15 = this;
                var node = this._getNode(keyOrItemOrElement);
                if (!node) {
                    return (new _deferred.Deferred).reject().promise()
                }
                var nodeKeysToExpand = [];
                var parentNode = node.internalFields.publicNode.parent;
                while (null != parentNode) {
                    if (!parentNode.expanded) {
                        nodeKeysToExpand.push(parentNode.key)
                    }
                    parentNode = parentNode.parent
                }
                var scrollCallback = new _deferred.Deferred;
                this._expandNodes(nodeKeysToExpand.reverse()).always(function() {
                    var $element = _this15._getNodeElement(node);
                    if ($element && $element.length) {
                        _this15._scrollableContainer.scrollToElementTopLeft($element);
                        scrollCallback.resolve()
                    } else {
                        scrollCallback.reject()
                    }
                });
                return scrollCallback.promise()
            },
            _expandNodes: function(keysToExpand) {
                var _this16 = this;
                if (!keysToExpand || 0 === keysToExpand.length) {
                    return (new _deferred.Deferred).resolve().promise()
                }
                var resultCallback = new _deferred.Deferred;
                var callbacksByNodes = keysToExpand.map(function(key) {
                    return _this16.expandItem(key)
                });
                _deferred.when.apply(_renderer.default, callbacksByNodes).done(function() {
                    return resultCallback.resolve()
                }).fail(function() {
                    return resultCallback.reject()
                });
                return resultCallback.promise()
            },
            _dispose: function() {
                this.callBase();
                clearTimeout(this._setFocusedItemTimeout)
            }
        });
        var _default = TreeViewBase;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.grouping.js ***!
      \************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.GroupingHeaderPanelExtender = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiData_gridGrouping = __webpack_require__( /*! ./ui.data_grid.grouping.expanded */ 706);
        var _uiData_gridGrouping2 = __webpack_require__( /*! ./ui.data_grid.grouping.collapsed */ 707);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _uiData_grid2 = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.data_source_adapter */ 218));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _uiGrid_core = __webpack_require__( /*! ../grid_core/ui.grid_core.accessibility */ 290);
        var _accessibility = __webpack_require__( /*! ../shared/accessibility */ 118);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DATAGRID_GROUP_PANEL_CLASS = "dx-datagrid-group-panel";
        var DATAGRID_GROUP_PANEL_MESSAGE_CLASS = "dx-group-panel-message";
        var DATAGRID_GROUP_PANEL_ITEM_CLASS = "dx-group-panel-item";
        var DATAGRID_GROUP_PANEL_LABEL_CLASS = "dx-toolbar-label";
        var DATAGRID_EXPAND_CLASS = "dx-datagrid-expand";
        var DATAGRID_GROUP_ROW_CLASS = "dx-group-row";
        var HEADER_FILTER_CLASS_SELECTOR = ".dx-header-filter";
        var GroupingDataSourceAdapterExtender = function() {
            return {
                init: function() {
                    this.callBase.apply(this, arguments);
                    this._initGroupingHelper()
                },
                _initGroupingHelper: function(options) {
                    var grouping = this._grouping;
                    var isAutoExpandAll = this.option("grouping.autoExpandAll");
                    var isFocusedRowEnabled = this.option("focusedRowEnabled");
                    var remoteOperations = options ? options.remoteOperations : this.remoteOperations();
                    var isODataRemoteOperations = remoteOperations.filtering && remoteOperations.sorting && remoteOperations.paging;
                    if (isODataRemoteOperations && !remoteOperations.grouping && (isAutoExpandAll || !isFocusedRowEnabled)) {
                        if (!grouping || grouping instanceof _uiData_gridGrouping2.GroupingHelper) {
                            this._grouping = new _uiData_gridGrouping.GroupingHelper(this)
                        }
                    } else {
                        if (!grouping || grouping instanceof _uiData_gridGrouping.GroupingHelper) {
                            this._grouping = new _uiData_gridGrouping2.GroupingHelper(this)
                        }
                    }
                },
                totalItemsCount: function() {
                    var that = this;
                    var totalCount = that.callBase();
                    return totalCount > 0 && that._dataSource.group() && that._dataSource.requireTotalCount() ? totalCount + that._grouping.totalCountCorrection() : totalCount
                },
                itemsCount: function() {
                    return this._dataSource.group() ? this._grouping.itemsCount() || 0 : this.callBase.apply(this, arguments)
                },
                allowCollapseAll: function() {
                    return this._grouping.allowCollapseAll()
                },
                isGroupItemCountable: function(item) {
                    return this._grouping.isGroupItemCountable(item)
                },
                isRowExpanded: function(key) {
                    var groupInfo = this._grouping.findGroupInfo(key);
                    return groupInfo ? groupInfo.isExpanded : !this._grouping.allowCollapseAll()
                },
                collapseAll: function(groupIndex) {
                    return this._collapseExpandAll(groupIndex, false)
                },
                expandAll: function(groupIndex) {
                    return this._collapseExpandAll(groupIndex, true)
                },
                _collapseExpandAll: function(groupIndex, isExpand) {
                    var that = this;
                    var dataSource = that._dataSource;
                    var group = dataSource.group();
                    var groups = _uiData_grid.default.normalizeSortingInfo(group || []);
                    if (groups.length) {
                        for (var i = 0; i < groups.length; i++) {
                            if (void 0 === groupIndex || groupIndex === i) {
                                groups[i].isExpanded = isExpand
                            } else {
                                if (group && group[i]) {
                                    groups[i].isExpanded = group[i].isExpanded
                                }
                            }
                        }
                        dataSource.group(groups);
                        that._grouping.foreachGroups(function(groupInfo, parents) {
                            if (void 0 === groupIndex || groupIndex === parents.length - 1) {
                                groupInfo.isExpanded = isExpand
                            }
                        }, false, true);
                        that.resetPagesCache()
                    }
                    return true
                },
                refresh: function() {
                    this.callBase.apply(this, arguments);
                    return this._grouping.refresh.apply(this._grouping, arguments)
                },
                changeRowExpand: function(path) {
                    var that = this;
                    var dataSource = that._dataSource;
                    if (dataSource.group()) {
                        dataSource.beginLoading();
                        if (that._lastLoadOptions) {
                            that._lastLoadOptions.groupExpand = true
                        }
                        return that._changeRowExpandCore(path).always(function() {
                            dataSource.endLoading()
                        })
                    }
                },
                _changeRowExpandCore: function(path) {
                    return this._grouping.changeRowExpand(path)
                },
                _hasGroupLevelsExpandState: function(group, isExpanded) {
                    if (group && Array.isArray(group)) {
                        for (var i = 0; i < group.length; i++) {
                            if (group[i].isExpanded === isExpanded) {
                                return true
                            }
                        }
                    }
                },
                _customizeRemoteOperations: function(options, operationTypes) {
                    var remoteOperations = options.remoteOperations;
                    if (options.storeLoadOptions.group) {
                        if (remoteOperations.grouping && !options.isCustomLoading) {
                            if (!remoteOperations.groupPaging || this._hasGroupLevelsExpandState(options.storeLoadOptions.group, true)) {
                                remoteOperations.paging = false
                            }
                        }
                        if (!remoteOperations.grouping && (!remoteOperations.sorting || !remoteOperations.filtering || options.isCustomLoading || this._hasGroupLevelsExpandState(options.storeLoadOptions.group, false))) {
                            remoteOperations.paging = false
                        }
                    } else {
                        if (!options.isCustomLoading && remoteOperations.paging && operationTypes.grouping) {
                            this.resetCache()
                        }
                    }
                    this.callBase.apply(this, arguments)
                },
                _handleDataLoading: function(options) {
                    this.callBase(options);
                    this._initGroupingHelper(options);
                    return this._grouping.handleDataLoading(options)
                },
                _handleDataLoaded: function(options) {
                    return this._grouping.handleDataLoaded(options, this.callBase.bind(this))
                },
                _handleDataLoadedCore: function(options) {
                    return this._grouping.handleDataLoadedCore(options, this.callBase.bind(this))
                }
            }
        }();
        _uiData_grid2.default.extend(GroupingDataSourceAdapterExtender);
        var GroupingDataControllerExtender = function() {
            return {
                init: function() {
                    var that = this;
                    that.callBase();
                    that.createAction("onRowExpanding");
                    that.createAction("onRowExpanded");
                    that.createAction("onRowCollapsing");
                    that.createAction("onRowCollapsed")
                },
                _beforeProcessItems: function(items) {
                    var groupColumns = this._columnsController.getGroupColumns();
                    items = this.callBase(items);
                    if (items.length && groupColumns.length) {
                        items = this._processGroupItems(items, groupColumns.length)
                    }
                    return items
                },
                _processItem: function(item, options) {
                    if ((0, _type.isDefined)(item.groupIndex) && (0, _type.isString)(item.rowType) && 0 === item.rowType.indexOf("group")) {
                        item = this._processGroupItem(item, options);
                        options.dataIndex = 0
                    } else {
                        item = this.callBase.apply(this, arguments)
                    }
                    return item
                },
                _processGroupItem: function(item) {
                    return item
                },
                _processGroupItems: function(items, groupsCount, options) {
                    var that = this;
                    var groupedColumns = that._columnsController.getGroupColumns();
                    var column = groupedColumns[groupedColumns.length - groupsCount];
                    if (!options) {
                        var scrollingMode = that.option("scrolling.mode");
                        options = {
                            collectContinuationItems: "virtual" !== scrollingMode && "infinite" !== scrollingMode,
                            resultItems: [],
                            path: [],
                            values: []
                        }
                    }
                    var resultItems = options.resultItems;
                    if (options.data) {
                        if (options.collectContinuationItems || !options.data.isContinuation) {
                            resultItems.push({
                                rowType: "group",
                                data: options.data,
                                groupIndex: options.path.length - 1,
                                isExpanded: !!options.data.items,
                                key: options.path.slice(0),
                                values: options.values.slice(0)
                            })
                        }
                    }
                    if (items) {
                        if (0 === groupsCount) {
                            resultItems.push.apply(resultItems, items)
                        } else {
                            for (var i = 0; i < items.length; i++) {
                                var item = items[i];
                                if (item && "items" in item) {
                                    options.data = item;
                                    options.path.push(item.key);
                                    options.values.push(column && column.deserializeValue && !column.calculateDisplayValue ? column.deserializeValue(item.key) : item.key);
                                    that._processGroupItems(item.items, groupsCount - 1, options);
                                    options.data = void 0;
                                    options.path.pop();
                                    options.values.pop()
                                } else {
                                    resultItems.push(item)
                                }
                            }
                        }
                    }
                    return resultItems
                },
                publicMethods: function() {
                    return this.callBase().concat(["collapseAll", "expandAll", "isRowExpanded", "expandRow", "collapseRow"])
                },
                collapseAll: function(groupIndex) {
                    var dataSource = this._dataSource;
                    if (dataSource && dataSource.collapseAll(groupIndex)) {
                        dataSource.pageIndex(0);
                        dataSource.reload()
                    }
                },
                expandAll: function(groupIndex) {
                    var dataSource = this._dataSource;
                    if (dataSource && dataSource.expandAll(groupIndex)) {
                        dataSource.pageIndex(0);
                        dataSource.reload()
                    }
                },
                changeRowExpand: function(key) {
                    var that = this;
                    var expanded = that.isRowExpanded(key);
                    var args = {
                        key: key,
                        expanded: expanded
                    };
                    that.executeAction(expanded ? "onRowCollapsing" : "onRowExpanding", args);
                    if (!args.cancel) {
                        return (0, _deferred.when)(that._changeRowExpandCore(key)).done(function() {
                            args.expanded = !expanded;
                            that.executeAction(expanded ? "onRowCollapsed" : "onRowExpanded", args)
                        })
                    }
                    return (new _deferred.Deferred).resolve()
                },
                _changeRowExpandCore: function(key) {
                    var that = this;
                    var dataSource = this._dataSource;
                    var d = new _deferred.Deferred;
                    if (!dataSource) {
                        d.resolve()
                    } else {
                        (0, _deferred.when)(dataSource.changeRowExpand(key)).done(function() {
                            that.load().done(d.resolve).fail(d.reject)
                        }).fail(d.reject)
                    }
                    return d
                },
                isRowExpanded: function(key) {
                    var dataSource = this._dataSource;
                    return dataSource && dataSource.isRowExpanded(key)
                },
                expandRow: function(key) {
                    if (!this.isRowExpanded(key)) {
                        return this.changeRowExpand(key)
                    }
                    return (new _deferred.Deferred).resolve()
                },
                collapseRow: function(key) {
                    if (this.isRowExpanded(key)) {
                        return this.changeRowExpand(key)
                    }
                    return (new _deferred.Deferred).resolve()
                },
                optionChanged: function(args) {
                    if ("grouping" === args.name) {
                        args.name = "dataSource"
                    }
                    this.callBase(args)
                }
            }
        }();
        var onGroupingMenuItemClick = function(column, params) {
            var columnsController = this._columnsController;
            switch (params.itemData.value) {
                case "group":
                    var groups = columnsController._dataSource.group() || [];
                    columnsController.columnOption(column.dataField, "groupIndex", groups.length);
                    break;
                case "ungroup":
                    columnsController.columnOption(column.dataField, "groupIndex", -1);
                    break;
                case "ungroupAll":
                    this.component.clearGrouping()
            }
        };
        var GroupingHeaderPanelExtender = function() {
            return {
                _getToolbarItems: function() {
                    var items = this.callBase();
                    return this._appendGroupingItem(items)
                },
                _appendGroupingItem: function(items) {
                    var _this = this;
                    if (this._isGroupPanelVisible()) {
                        var isRendered = false;
                        var toolbarItem = {
                            template: function() {
                                var $groupPanel = (0, _renderer.default)("<div>").addClass(DATAGRID_GROUP_PANEL_CLASS);
                                _this._updateGroupPanelContent($groupPanel);
                                (0, _uiGrid_core.registerKeyboardAction)("groupPanel", _this, $groupPanel, void 0, _this._handleActionKeyDown.bind(_this));
                                return $groupPanel
                            },
                            name: "groupPanel",
                            onItemRendered: function() {
                                isRendered && _this.renderCompleted.fire();
                                isRendered = true
                            },
                            location: "before",
                            locateInMenu: "never",
                            sortIndex: 1
                        };
                        items.push(toolbarItem)
                    }
                    return items
                },
                _handleActionKeyDown: function(args) {
                    var event = args.event;
                    var $target = (0, _renderer.default)(event.target);
                    var groupColumnIndex = $target.closest(".".concat(DATAGRID_GROUP_PANEL_ITEM_CLASS)).index();
                    var column = this._columnsController.getGroupColumns()[groupColumnIndex];
                    var columnIndex = column && column.index;
                    if ($target.is(HEADER_FILTER_CLASS_SELECTOR)) {
                        this.getController("headerFilter").showHeaderFilterMenu(columnIndex, true)
                    } else {
                        this._processGroupItemAction(columnIndex)
                    }
                    event.preventDefault()
                },
                _isGroupPanelVisible: function() {
                    var groupPanelOptions = this.option("groupPanel");
                    var isVisible;
                    if (groupPanelOptions) {
                        isVisible = groupPanelOptions.visible;
                        if ("auto" === isVisible) {
                            isVisible = "desktop" === _devices.default.current().deviceType ? true : false
                        }
                    }
                    return isVisible
                },
                _renderGroupPanelItems: function($groupPanel, groupColumns) {
                    var that = this;
                    $groupPanel.empty();
                    (0, _iterator.each)(groupColumns, function(index, groupColumn) {
                        that._createGroupPanelItem($groupPanel, groupColumn)
                    });
                    (0, _accessibility.restoreFocus)(this)
                },
                _createGroupPanelItem: function($rootElement, groupColumn) {
                    var $groupPanelItem = (0, _renderer.default)("<div>").addClass(groupColumn.cssClass).addClass(DATAGRID_GROUP_PANEL_ITEM_CLASS).data("columnData", groupColumn).appendTo($rootElement).text(groupColumn.caption);
                    (0, _accessibility.setTabIndex)(this, $groupPanelItem);
                    return $groupPanelItem
                },
                _columnOptionChanged: function(e) {
                    if (!this._requireReady && !_uiData_grid.default.checkChanges(e.optionNames, ["width", "visibleWidth"])) {
                        var $toolbarElement = this.element();
                        var $groupPanel = $toolbarElement && $toolbarElement.find("." + DATAGRID_GROUP_PANEL_CLASS);
                        if ($groupPanel && $groupPanel.length) {
                            this._updateGroupPanelContent($groupPanel);
                            this.renderCompleted.fire()
                        }
                    }
                    this.callBase()
                },
                _updateGroupPanelContent: function($groupPanel) {
                    var that = this;
                    var groupColumns = that.getController("columns").getGroupColumns();
                    var groupPanelOptions = that.option("groupPanel");
                    that._renderGroupPanelItems($groupPanel, groupColumns);
                    if (groupPanelOptions.allowColumnDragging && !groupColumns.length) {
                        (0, _renderer.default)("<div>").addClass(DATAGRID_GROUP_PANEL_MESSAGE_CLASS).text(groupPanelOptions.emptyPanelText).appendTo($groupPanel);
                        $groupPanel.closest("." + DATAGRID_GROUP_PANEL_LABEL_CLASS).css("maxWidth", "none");
                        that.updateToolbarDimensions()
                    }
                },
                allowDragging: function(column) {
                    var groupPanelOptions = this.option("groupPanel");
                    return this._isGroupPanelVisible() && groupPanelOptions.allowColumnDragging && column && column.allowGrouping
                },
                getColumnElements: function() {
                    var $element = this.element();
                    return $element && $element.find("." + DATAGRID_GROUP_PANEL_ITEM_CLASS)
                },
                getColumns: function() {
                    return this.getController("columns").getGroupColumns()
                },
                getBoundingRect: function() {
                    var that = this;
                    var $element = that.element();
                    if ($element && $element.find("." + DATAGRID_GROUP_PANEL_CLASS).length) {
                        var offset = $element.offset();
                        return {
                            top: offset.top,
                            bottom: offset.top + $element.height()
                        }
                    }
                    return null
                },
                getName: function() {
                    return "group"
                },
                getContextMenuItems: function(options) {
                    var that = this;
                    var contextMenuEnabled = that.option("grouping.contextMenuEnabled");
                    var $groupedColumnElement = (0, _renderer.default)(options.targetElement).closest("." + DATAGRID_GROUP_PANEL_ITEM_CLASS);
                    var items;
                    if ($groupedColumnElement.length) {
                        options.column = $groupedColumnElement.data("columnData")
                    }
                    if (contextMenuEnabled && options.column) {
                        var column = options.column;
                        var isGroupingAllowed = (0, _type.isDefined)(column.allowGrouping) ? column.allowGrouping : true;
                        if (isGroupingAllowed) {
                            var isColumnGrouped = (0, _type.isDefined)(column.groupIndex) && column.groupIndex > -1;
                            var groupingTexts = that.option("grouping.texts");
                            var onItemClick = onGroupingMenuItemClick.bind(that, column);
                            items = [{
                                text: groupingTexts.ungroup,
                                value: "ungroup",
                                disabled: !isColumnGrouped,
                                onItemClick: onItemClick
                            }, {
                                text: groupingTexts.ungroupAll,
                                value: "ungroupAll",
                                onItemClick: onItemClick
                            }]
                        }
                    }
                    return items
                },
                isVisible: function() {
                    return this.callBase() || this._isGroupPanelVisible()
                },
                optionChanged: function(args) {
                    if ("groupPanel" === args.name) {
                        this._invalidate();
                        args.handled = true
                    } else {
                        this.callBase(args)
                    }
                }
            }
        }();
        exports.GroupingHeaderPanelExtender = GroupingHeaderPanelExtender;
        var GroupingRowsViewExtender = function() {
            return {
                getContextMenuItems: function(options) {
                    var that = this;
                    var contextMenuEnabled = that.option("grouping.contextMenuEnabled");
                    var items;
                    if (contextMenuEnabled && options.row && "group" === options.row.rowType) {
                        var columnsController = that._columnsController;
                        var column = columnsController.columnOption("groupIndex:" + options.row.groupIndex);
                        if (column && column.allowGrouping) {
                            var groupingTexts = that.option("grouping.texts");
                            var onItemClick = onGroupingMenuItemClick.bind(that, column);
                            items = [];
                            items.push({
                                text: groupingTexts.ungroup,
                                value: "ungroup",
                                onItemClick: onItemClick
                            }, {
                                text: groupingTexts.ungroupAll,
                                value: "ungroupAll",
                                onItemClick: onItemClick
                            })
                        }
                    }
                    return items
                },
                _rowClick: function(e) {
                    var that = this;
                    var expandMode = that.option("grouping.expandMode");
                    var scrollingMode = that.option("scrolling.mode");
                    var isGroupRowStateChanged = "infinite" !== scrollingMode && "rowClick" === expandMode && (0, _renderer.default)(e.event.target).closest("." + DATAGRID_GROUP_ROW_CLASS).length;
                    var isExpandButtonClicked = (0, _renderer.default)(e.event.target).closest("." + DATAGRID_EXPAND_CLASS).length;
                    if (isGroupRowStateChanged || isExpandButtonClicked) {
                        that._changeGroupRowState(e)
                    }
                    that.callBase(e)
                },
                _changeGroupRowState: function(e) {
                    var dataController = this.getController("data");
                    var row = dataController.items()[e.rowIndex];
                    var allowCollapsing = this._columnsController.columnOption("groupIndex:" + row.groupIndex, "allowCollapsing");
                    if ("data" === row.rowType || "group" === row.rowType && false !== allowCollapsing) {
                        dataController.changeRowExpand(row.key, true);
                        e.event.preventDefault();
                        e.handled = true
                    }
                }
            }
        }();
        var columnHeadersViewExtender = function() {
            return {
                getContextMenuItems: function(options) {
                    var that = this;
                    var contextMenuEnabled = that.option("grouping.contextMenuEnabled");
                    var items = that.callBase(options);
                    if (contextMenuEnabled && options.row && ("header" === options.row.rowType || "detailAdaptive" === options.row.rowType)) {
                        var column = options.column;
                        if (!column.command && (!(0, _type.isDefined)(column.allowGrouping) || column.allowGrouping)) {
                            var groupingTexts = that.option("grouping.texts");
                            var isColumnGrouped = (0, _type.isDefined)(column.groupIndex) && column.groupIndex > -1;
                            var onItemClick = onGroupingMenuItemClick.bind(that, column);
                            items = items || [];
                            items.push({
                                text: groupingTexts.groupByThisColumn,
                                value: "group",
                                beginGroup: true,
                                disabled: isColumnGrouped,
                                onItemClick: onItemClick
                            });
                            if (column.showWhenGrouped) {
                                items.push({
                                    text: groupingTexts.ungroup,
                                    value: "ungroup",
                                    disabled: !isColumnGrouped,
                                    onItemClick: onItemClick
                                })
                            }
                            items.push({
                                text: groupingTexts.ungroupAll,
                                value: "ungroupAll",
                                onItemClick: onItemClick
                            })
                        }
                    }
                    return items
                }
            }
        }();
        _uiData_grid.default.registerModule("grouping", {
            defaultOptions: function() {
                return {
                    grouping: {
                        autoExpandAll: true,
                        allowCollapsing: true,
                        contextMenuEnabled: false,
                        expandMode: "buttonClick",
                        texts: {
                            groupContinuesMessage: _message.default.format("dxDataGrid-groupContinuesMessage"),
                            groupContinuedMessage: _message.default.format("dxDataGrid-groupContinuedMessage"),
                            groupByThisColumn: _message.default.format("dxDataGrid-groupHeaderText"),
                            ungroup: _message.default.format("dxDataGrid-ungroupHeaderText"),
                            ungroupAll: _message.default.format("dxDataGrid-ungroupAllText")
                        }
                    },
                    groupPanel: {
                        visible: false,
                        emptyPanelText: _message.default.format("dxDataGrid-groupPanelEmptyText"),
                        allowColumnDragging: true
                    }
                }
            },
            extenders: {
                controllers: {
                    data: GroupingDataControllerExtender,
                    columns: {
                        _getExpandColumnOptions: function() {
                            var options = this.callBase.apply(this, arguments);
                            options.cellTemplate = _uiData_grid.default.getExpandCellTemplate();
                            return options
                        }
                    }
                },
                views: {
                    headerPanel: GroupingHeaderPanelExtender,
                    rowsView: GroupingRowsViewExtender,
                    columnHeadersView: columnHeadersViewExtender
                }
            }
        })
    },
    /*!*********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.grouping.expanded.js ***!
      \*********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.GroupingHelper = void 0;
        var _data = __webpack_require__( /*! ../../core/utils/data */ 20);
        var _utils = _interopRequireDefault(__webpack_require__( /*! ../../data/utils */ 41));
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _store_helper = _interopRequireDefault(__webpack_require__( /*! ../../data/store_helper */ 94));
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiData_gridGrouping = __webpack_require__( /*! ./ui.data_grid.grouping.core */ 396);
        var _uiData_grid2 = __webpack_require__( /*! ./ui.data_grid.utils */ 291);
        var _query = _interopRequireDefault(__webpack_require__( /*! ../../data/query */ 48));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var loadTotalCount = function(dataSource, options) {
            var d = new _deferred.Deferred;
            var loadOptions = (0, _extend.extend)({
                skip: 0,
                take: 1,
                requireTotalCount: true
            }, options);
            dataSource.load(loadOptions).done(function(data, extra) {
                d.resolve(extra && extra.totalCount)
            }).fail(d.reject.bind(d));
            return d
        };
        var GroupingHelper = _uiData_gridGrouping.GroupingHelper.inherit(function() {
            var foreachCollapsedGroups = function(that, callback, updateOffsets) {
                return that.foreachGroups(function(groupInfo) {
                    if (!groupInfo.isExpanded) {
                        return callback(groupInfo)
                    }
                }, false, false, updateOffsets, true)
            };
            var correctSkipLoadOption = function(that, skip) {
                var skipCorrection = 0;
                var resultSkip = skip || 0;
                if (skip) {
                    foreachCollapsedGroups(that, function(groupInfo) {
                        if (groupInfo.offset - skipCorrection >= skip) {
                            return false
                        }
                        skipCorrection += groupInfo.count - 1
                    });
                    resultSkip += skipCorrection
                }
                return resultSkip
            };
            var processGroupItems = function processGroupItems(that, items, path, offset, skipFirstItem, take) {
                var removeLastItemsCount = 0;
                var needRemoveFirstItem = false;
                for (var i = 0; i < items.length; i++) {
                    var item = items[i];
                    if (void 0 !== item.items) {
                        path.push(item.key);
                        var groupInfo = that.findGroupInfo(path);
                        if (groupInfo && !groupInfo.isExpanded) {
                            item.collapsedItems = item.items;
                            item.items = null;
                            offset += groupInfo.count;
                            take--;
                            if (take < 0) {
                                removeLastItemsCount++
                            }
                            if (skipFirstItem) {
                                needRemoveFirstItem = true
                            }
                        } else {
                            if (item.items) {
                                var offsetInfo = processGroupItems(that, item.items, path, offset, skipFirstItem, take);
                                if (skipFirstItem) {
                                    if (offsetInfo.offset - offset > 1) {
                                        item.isContinuation = true
                                    } else {
                                        needRemoveFirstItem = true
                                    }
                                }
                                offset = offsetInfo.offset;
                                take = offsetInfo.take;
                                if (take < 0) {
                                    if (item.items.length) {
                                        item.isContinuationOnNextPage = true
                                    } else {
                                        removeLastItemsCount++
                                    }
                                }
                            }
                        }
                        path.pop()
                    } else {
                        if (skipFirstItem) {
                            needRemoveFirstItem = true
                        }
                        offset++;
                        take--;
                        if (take < 0) {
                            removeLastItemsCount++
                        }
                    }
                    skipFirstItem = false
                }
                if (needRemoveFirstItem) {
                    items.splice(0, 1)
                }
                if (removeLastItemsCount) {
                    items.splice(-removeLastItemsCount, removeLastItemsCount)
                }
                return {
                    offset: offset,
                    take: take
                }
            };
            var pathEquals = function(path1, path2) {
                if (path1.length !== path2.length) {
                    return false
                }
                for (var i = 0; i < path1.length; i++) {
                    if (!_utils.default.keysEqual(null, path1[i], path2[i])) {
                        return false
                    }
                }
                return true
            };
            var updateGroupOffsets = function updateGroupOffsets(that, items, path, offset, additionalGroupInfo) {
                if (!items) {
                    return
                }
                for (var i = 0; i < items.length; i++) {
                    var item = items[i];
                    if ("key" in item && void 0 !== item.items) {
                        path.push(item.key);
                        if (additionalGroupInfo && pathEquals(additionalGroupInfo.path, path) && !item.isContinuation) {
                            additionalGroupInfo.offset = offset
                        }
                        var groupInfo = that.findGroupInfo(path);
                        if (groupInfo && !item.isContinuation) {
                            groupInfo.offset = offset
                        }
                        if (groupInfo && !groupInfo.isExpanded) {
                            offset += groupInfo.count
                        } else {
                            offset = updateGroupOffsets(that, item.items, path, offset, additionalGroupInfo)
                        }
                        path.pop()
                    } else {
                        offset++
                    }
                }
                return offset
            };
            var removeGroupLoadOption = function(storeLoadOptions, loadOptions) {
                if (loadOptions.group) {
                    var groups = _uiData_grid.default.normalizeSortingInfo(loadOptions.group);
                    var sorts = _uiData_grid.default.normalizeSortingInfo(storeLoadOptions.sort);
                    storeLoadOptions.sort = _store_helper.default.arrangeSortingInfo(groups, sorts);
                    delete loadOptions.group
                }
            };
            var createNotGroupFilter = function(path, storeLoadOptions, group) {
                var groups = _uiData_grid.default.normalizeSortingInfo(group || storeLoadOptions.group);
                var filter = [];
                for (var i = 0; i < path.length; i++) {
                    var filterElement = [];
                    for (var j = 0; j <= i; j++) {
                        filterElement.push([groups[j].selector, i === j ? "<>" : "=", path[j]])
                    }
                    filter.push(_uiData_grid.default.combineFilters(filterElement))
                }
                filter = _uiData_grid.default.combineFilters(filter, "or");
                return _uiData_grid.default.combineFilters([filter, storeLoadOptions.filter])
            };
            var getGroupCount = function getGroupCount(item, groupCount) {
                var count = item.count || item.items.length;
                if (!item.count && groupCount > 1) {
                    count = 0;
                    for (var i = 0; i < item.items.length; i++) {
                        count += getGroupCount(item.items[i], groupCount - 1)
                    }
                }
                return count
            };
            return {
                handleDataLoading: function(options) {
                    var that = this;
                    var storeLoadOptions = options.storeLoadOptions;
                    var collapsedGroups = [];
                    var collapsedItemsCount = 0;
                    var skipFirstItem = false;
                    var take;
                    var group = options.loadOptions.group;
                    var skipCorrection = 0;
                    removeGroupLoadOption(storeLoadOptions, options.loadOptions);
                    options.group = options.group || group;
                    if (options.isCustomLoading) {
                        return
                    }
                    var loadOptions = (0, _extend.extend)({}, storeLoadOptions);
                    loadOptions.skip = correctSkipLoadOption(that, storeLoadOptions.skip);
                    if (loadOptions.skip && loadOptions.take && group) {
                        loadOptions.skip--;
                        loadOptions.take++;
                        skipFirstItem = true
                    }
                    if (loadOptions.take && group) {
                        take = loadOptions.take;
                        loadOptions.take++
                    }
                    foreachCollapsedGroups(that, function(groupInfo) {
                        if (groupInfo.offset >= loadOptions.skip + loadOptions.take + skipCorrection) {
                            return false
                        } else {
                            if (groupInfo.offset >= loadOptions.skip + skipCorrection && groupInfo.count) {
                                skipCorrection += groupInfo.count - 1;
                                collapsedGroups.push(groupInfo);
                                collapsedItemsCount += groupInfo.count
                            }
                        }
                    });
                    (0, _iterator.each)(collapsedGroups, function() {
                        loadOptions.filter = createNotGroupFilter(this.path, loadOptions, group)
                    });
                    options.storeLoadOptions = loadOptions;
                    options.collapsedGroups = collapsedGroups;
                    options.collapsedItemsCount = collapsedItemsCount;
                    options.skip = loadOptions.skip || 0;
                    options.skipFirstItem = skipFirstItem;
                    options.take = take
                },
                handleDataLoaded: function(options, callBase) {
                    var that = this;
                    var data = options.data;
                    var collapsedGroups = options.collapsedGroups;
                    var groups = _uiData_grid.default.normalizeSortingInfo(options.group);
                    var groupCount = groups.length;

                    function appendCollapsedPath(data, path, groups, collapsedGroup, offset) {
                        if (!data || !path.length || !groups.length) {
                            return
                        }
                        var keyValue;
                        var i;
                        var pathValue = (0, _data.toComparable)(path[0], true);
                        for (i = 0; i < data.length; i++) {
                            keyValue = (0, _data.toComparable)(data[i].key, true);
                            if (offset >= collapsedGroup.offset || pathValue === keyValue) {
                                break
                            } else {
                                offset += getGroupCount(data[i], groups.length)
                            }
                        }
                        if (!data.length || pathValue !== keyValue) {
                            data.splice(i, 0, {
                                key: path[0],
                                items: [],
                                count: 1 === path.length ? collapsedGroup.count : void 0
                            })
                        }
                        appendCollapsedPath(data[i].items, path.slice(1), groups.slice(1), collapsedGroup, offset)
                    }
                    if (options.collapsedItemsCount && options.extra && options.extra.totalCount >= 0) {
                        options.extra.totalCount += options.collapsedItemsCount
                    }
                    callBase(options);
                    if (groupCount) {
                        var query = (0, _query.default)(data);
                        _store_helper.default.multiLevelGroup(query, groups).enumerate().done(function(groupedData) {
                            data = groupedData
                        });
                        if (collapsedGroups) {
                            for (var pathIndex = 0; pathIndex < collapsedGroups.length; pathIndex++) {
                                appendCollapsedPath(data, collapsedGroups[pathIndex].path, groups, collapsedGroups[pathIndex], options.skip)
                            }
                        }
                        if (!options.isCustomLoading) {
                            processGroupItems(that, data, [], options.skip, options.skipFirstItem, options.take)
                        }
                        options.data = data
                    }
                },
                isGroupItemCountable: function(item) {
                    return null === item.items
                },
                updateTotalItemsCount: function() {
                    var itemsCountCorrection = 0;
                    foreachCollapsedGroups(this, function(groupInfo) {
                        if (groupInfo.count) {
                            itemsCountCorrection -= groupInfo.count - 1
                        }
                    });
                    this.callBase(itemsCountCorrection)
                },
                changeRowExpand: function(path) {
                    var that = this;
                    var dataSource = that._dataSource;
                    var beginPageIndex = dataSource.beginPageIndex ? dataSource.beginPageIndex() : dataSource.pageIndex();
                    var dataSourceItems = dataSource.items();
                    var offset = correctSkipLoadOption(that, beginPageIndex * dataSource.pageSize());
                    var groupInfo = that.findGroupInfo(path);
                    var groupCountQuery;
                    if (groupInfo && !groupInfo.isExpanded) {
                        groupCountQuery = (new _deferred.Deferred).resolve(groupInfo.count)
                    } else {
                        groupCountQuery = loadTotalCount(dataSource, {
                            filter: (0, _uiData_grid2.createGroupFilter)(path, {
                                filter: dataSource.filter(),
                                group: dataSource.group()
                            })
                        })
                    }
                    return (0, _deferred.when)(groupCountQuery).done(function(count) {
                        count = parseInt(count.length ? count[0] : count);
                        if (groupInfo) {
                            updateGroupOffsets(that, dataSourceItems, [], offset);
                            groupInfo.isExpanded = !groupInfo.isExpanded;
                            groupInfo.count = count
                        } else {
                            groupInfo = {
                                offset: -1,
                                count: count,
                                path: path,
                                isExpanded: false
                            };
                            updateGroupOffsets(that, dataSourceItems, [], offset, groupInfo);
                            if (groupInfo.offset >= 0) {
                                that.addGroupInfo(groupInfo)
                            }
                        }
                        that.updateTotalItemsCount()
                    }).fail(function() {
                        dataSource._eventsStrategy.fireEvent("loadError", arguments)
                    })
                },
                allowCollapseAll: function() {
                    return false
                },
                refresh: function(options, operationTypes) {
                    var that = this;
                    var storeLoadOptions = options.storeLoadOptions;
                    var dataSource = that._dataSource;
                    this.callBase.apply(this, arguments);
                    if (operationTypes.reload) {
                        return foreachCollapsedGroups(that, function(groupInfo) {
                            var groupCountQuery = loadTotalCount(dataSource, {
                                filter: (0, _uiData_grid2.createGroupFilter)(groupInfo.path, storeLoadOptions)
                            });
                            var groupOffsetQuery = loadTotalCount(dataSource, {
                                filter: (0, _uiData_gridGrouping.createOffsetFilter)(groupInfo.path, storeLoadOptions)
                            });
                            return (0, _deferred.when)(groupOffsetQuery, groupCountQuery).done(function(offset, count) {
                                offset = parseInt(offset.length ? offset[0] : offset);
                                count = parseInt(count.length ? count[0] : count);
                                groupInfo.offset = offset;
                                if (groupInfo.count !== count) {
                                    groupInfo.count = count;
                                    that.updateTotalItemsCount()
                                }
                            })
                        }, true)
                    }
                }
            }
        }());
        exports.GroupingHelper = GroupingHelper
    },
    /*!**********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.grouping.collapsed.js ***!
      \**********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.GroupingHelper = void 0;
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiData_gridGrouping = __webpack_require__( /*! ./ui.data_grid.grouping.core */ 396);
        var _uiData_grid2 = __webpack_require__( /*! ./ui.data_grid.utils */ 291);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../../data/errors */ 38));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function getContinuationGroupCount(groupOffset, pageSize, groupSize, groupIndex) {
            groupIndex = groupIndex || 0;
            if (pageSize > 1 && groupSize > 0) {
                var pageOffset = groupOffset - Math.floor(groupOffset / pageSize) * pageSize || pageSize;
                pageOffset += groupSize - groupIndex - 2;
                if (pageOffset < 0) {
                    pageOffset += pageSize
                }
                return Math.floor(pageOffset / (pageSize - groupIndex - 1))
            }
            return 0
        }
        var GroupingHelper = _uiData_gridGrouping.GroupingHelper.inherit(function() {
            var foreachExpandedGroups = function(that, callback, updateGroups) {
                return that.foreachGroups(function(groupInfo, parents) {
                    if (groupInfo.isExpanded) {
                        return callback(groupInfo, parents)
                    }
                }, true, false, updateGroups, updateGroups)
            };
            var processGroupItems = function processGroupItems(that, items, groupsCount, expandedInfo, path, isCustomLoading, isLastGroupExpanded) {
                var isExpanded;
                expandedInfo.items = expandedInfo.items || [];
                expandedInfo.paths = expandedInfo.paths || [];
                expandedInfo.count = expandedInfo.count || 0;
                expandedInfo.lastCount = expandedInfo.lastCount || 0;
                if (!groupsCount) {
                    return
                }
                for (var i = 0; i < items.length; i++) {
                    var item = items[i];
                    if (void 0 !== item.items) {
                        path.push(item.key);
                        if (isCustomLoading) {
                            isExpanded = true
                        } else {
                            var groupInfo = that.findGroupInfo(path);
                            isExpanded = groupInfo && groupInfo.isExpanded
                        }
                        if (!isExpanded) {
                            item.collapsedItems = item.items;
                            item.items = null
                        } else {
                            if (item.items) {
                                processGroupItems(that, item.items, groupsCount - 1, expandedInfo, path, isCustomLoading, isLastGroupExpanded)
                            } else {
                                if (1 === groupsCount && item.count && (!isCustomLoading || isLastGroupExpanded)) {
                                    expandedInfo.items.push(item);
                                    expandedInfo.paths.push(path.slice(0));
                                    expandedInfo.count += expandedInfo.lastCount;
                                    expandedInfo.lastCount = item.count
                                }
                            }
                        }
                        path.pop()
                    }
                }
            };
            var updateGroupInfoItem = function(that, item, isLastGroupLevel, path, offset) {
                var groupInfo = that.findGroupInfo(path);
                var count;
                if (!groupInfo) {
                    if (isLastGroupLevel) {
                        count = item.count > 0 ? item.count : item.items.length
                    }
                    that.addGroupInfo({
                        isExpanded: that._isGroupExpanded(path.length - 1),
                        path: path.slice(0),
                        offset: offset,
                        count: count || 0
                    })
                } else {
                    if (isLastGroupLevel) {
                        groupInfo.count = item.count > 0 ? item.count : item.items && item.items.length || 0
                    } else {
                        item.count = groupInfo.count || item.count
                    }
                    groupInfo.offset = offset
                }
            };
            var updateGroupInfos = function updateGroupInfos(that, options, items, loadedGroupCount, groupIndex, path, parentIndex) {
                var groupCount = options.group ? options.group.length : 0;
                var isLastGroupLevel = groupCount === loadedGroupCount;
                var remotePaging = options.remoteOperations.paging;
                var offset = 0;
                var totalCount = 0;
                var count;
                groupIndex = groupIndex || 0;
                path = path || [];
                if (remotePaging && !parentIndex) {
                    offset = 0 === groupIndex ? options.skip || 0 : options.skips[groupIndex - 1] || 0
                }
                if (groupIndex >= loadedGroupCount) {
                    return items.length
                }
                for (var i = 0; i < items.length; i++) {
                    var item = items[i];
                    if (item) {
                        path.push(item.key);
                        if (!item.count && !item.items || void 0 === item.items) {
                            return -1
                        }
                        updateGroupInfoItem(that, item, isLastGroupLevel, path, offset + i);
                        count = item.items ? updateGroupInfos(that, options, item.items, loadedGroupCount, groupIndex + 1, path, i) : item.count || -1;
                        if (count < 0) {
                            return -1
                        }
                        totalCount += count;
                        path.pop()
                    }
                }
                return totalCount
            };
            var isGroupExpanded = function(groups, groupIndex) {
                return groups && groups.length && groups[groupIndex] && !!groups[groupIndex].isExpanded
            };
            var getTotalOffset = function(groupInfos, pageSize, offset) {
                var groupSize;
                var totalOffset = offset;
                for (var groupIndex = 0; groupIndex < groupInfos.length; groupIndex++) {
                    groupSize = groupInfos[groupIndex].offset + 1;
                    if (groupIndex > 0) {
                        groupSize += groupInfos[groupIndex - 1].childrenTotalCount;
                        if (pageSize) {
                            groupSize += getContinuationGroupCount(totalOffset, pageSize, groupSize, groupIndex - 1) * groupIndex
                        }
                    }
                    totalOffset += groupSize
                }
                return totalOffset
            };

            function applyContinuationToGroupItem(options, expandedInfo, groupLevel, expandedItemIndex) {
                var item = expandedInfo.items[expandedItemIndex];
                var skip = options.skips && options.skips[groupLevel];
                var take = options.takes && options.takes[groupLevel];
                var isLastExpandedItem = expandedItemIndex === expandedInfo.items.length - 1;
                var isFirstExpandedItem = 0 === expandedItemIndex;
                var lastExpandedItemSkip = isFirstExpandedItem && skip || 0;
                var isItemsTruncatedByTake = item.count > take + lastExpandedItemSkip;
                if (isFirstExpandedItem && void 0 !== skip) {
                    item.isContinuation = true
                }
                if (isLastExpandedItem && void 0 !== take && isItemsTruncatedByTake) {
                    item.isContinuationOnNextPage = true
                }
            }

            function fillSkipTakeInExpandedInfo(options, expandedInfo, currentGroupCount) {
                var currentGroupIndex = currentGroupCount - 1;
                var groupCount = options.group ? options.group.length : 0;
                expandedInfo.skip = options.skips && options.skips[currentGroupIndex];
                if (options.takes && void 0 !== options.takes[currentGroupIndex]) {
                    if (groupCount === currentGroupCount) {
                        expandedInfo.take = expandedInfo.count ? expandedInfo.count - (expandedInfo.skip || 0) : 0
                    } else {
                        expandedInfo.take = 0
                    }
                    expandedInfo.take += options.takes[currentGroupIndex]
                }
            }

            function isDataDeferred(data) {
                return !Array.isArray(data)
            }

            function makeDataDeferred(options) {
                if (!isDataDeferred(options.data)) {
                    options.data = new _deferred.Deferred
                }
            }

            function loadGroupItems(that, options, loadedGroupCount, expandedInfo, groupLevel, data) {
                if (!options.isCustomLoading) {
                    expandedInfo = {};
                    processGroupItems(that, data, loadedGroupCount, expandedInfo, []);
                    fillSkipTakeInExpandedInfo(options, expandedInfo, loadedGroupCount)
                }
                var groupCount = options.group ? options.group.length : 0;
                if (expandedInfo.paths.length && groupCount - loadedGroupCount > 0) {
                    makeDataDeferred(options);
                    loadExpandedGroups(that, options, expandedInfo, loadedGroupCount, groupLevel, data)
                } else {
                    if (expandedInfo.paths.length && options.storeLoadOptions.group) {
                        makeDataDeferred(options);
                        loadLastLevelGroupItems(that, options, expandedInfo, data)
                    } else {
                        if (isDataDeferred(options.data)) {
                            options.data.resolve(data)
                        }
                    }
                }
            }

            function loadExpandedGroups(that, options, expandedInfo, loadedGroupCount, groupLevel, data) {
                var groups = options.group || [];
                var currentGroup = groups[groupLevel + 1];
                var deferreds = [];
                (0, _iterator.each)(expandedInfo.paths, function(expandedItemIndex) {
                    var loadOptions = {
                        requireTotalCount: false,
                        requireGroupCount: true,
                        group: [currentGroup],
                        groupSummary: options.storeLoadOptions.groupSummary,
                        filter: (0, _uiData_grid2.createGroupFilter)(expandedInfo.paths[expandedItemIndex], {
                            filter: options.storeLoadOptions.filter,
                            group: groups
                        }),
                        select: options.storeLoadOptions.select
                    };
                    if (0 === expandedItemIndex) {
                        loadOptions.skip = expandedInfo.skip || 0
                    }
                    if (expandedItemIndex === expandedInfo.paths.length - 1) {
                        loadOptions.take = expandedInfo.take
                    }
                    var loadResult = 0 === loadOptions.take ? [] : that._dataSource.loadFromStore(loadOptions);
                    (0, _deferred.when)(loadResult).done(function(data) {
                        var item = expandedInfo.items[expandedItemIndex];
                        applyContinuationToGroupItem(options, expandedInfo, groupLevel, expandedItemIndex);
                        item.items = data
                    });
                    deferreds.push(loadResult)
                });
                _deferred.when.apply(null, deferreds).done(function() {
                    updateGroupInfos(that, options, data, loadedGroupCount + 1);
                    loadGroupItems(that, options, loadedGroupCount + 1, expandedInfo, groupLevel + 1, data)
                })
            }

            function loadLastLevelGroupItems(that, options, expandedInfo, data) {
                var expandedFilters = [];
                var groups = options.group || [];
                (0, _iterator.each)(expandedInfo.paths, function(_, expandedPath) {
                    expandedFilters.push((0, _uiData_grid2.createGroupFilter)(expandedPath, {
                        group: options.isCustomLoading ? options.storeLoadOptions.group : groups
                    }))
                });
                var filter = options.storeLoadOptions.filter;
                if (!options.storeLoadOptions.isLoadingAll) {
                    filter = _uiData_grid.default.combineFilters([filter, _uiData_grid.default.combineFilters(expandedFilters, "or")])
                }
                var loadOptions = (0, _extend.extend)({}, options.storeLoadOptions, {
                    requireTotalCount: false,
                    requireGroupCount: false,
                    group: null,
                    sort: groups.concat(_uiData_grid.default.normalizeSortingInfo(options.storeLoadOptions.sort || [])),
                    filter: filter
                });
                var isPagingLocal = that._dataSource.isLastLevelGroupItemsPagingLocal();
                if (!isPagingLocal) {
                    loadOptions.skip = expandedInfo.skip;
                    loadOptions.take = expandedInfo.take
                }(0, _deferred.when)(0 === expandedInfo.take ? [] : that._dataSource.loadFromStore(loadOptions)).done(function(items, extra) {
                    if (isPagingLocal) {
                        items = that._dataSource.sortLastLevelGroupItems(items, groups, expandedInfo.paths);
                        items = expandedInfo.skip ? items.slice(expandedInfo.skip) : items;
                        items = expandedInfo.take ? items.slice(0, expandedInfo.take) : items
                    }(0, _iterator.each)(expandedInfo.items, function(index, item) {
                        var itemCount = item.count - (0 === index && expandedInfo.skip || 0);
                        var expandedItems = items.splice(0, itemCount);
                        applyContinuationToGroupItem(options, expandedInfo, groups.length - 1, index);
                        item.items = expandedItems
                    });
                    options.data.resolve(data)
                }).fail(options.data.reject)
            }
            var loadGroupTotalCount = function(dataSource, options) {
                var d = new _deferred.Deferred;
                var isGrouping = !!(options.group && options.group.length);
                var loadOptions = (0, _extend.extend)({
                    skip: 0,
                    take: 1,
                    requireGroupCount: isGrouping,
                    requireTotalCount: !isGrouping
                }, options, {
                    group: isGrouping ? options.group : null
                });
                dataSource.load(loadOptions).done(function(data, extra) {
                    var count = extra && (isGrouping ? extra.groupCount : extra.totalCount);
                    if (!isFinite(count)) {
                        d.reject(_errors.default.errors.Error(isGrouping ? "E4022" : "E4021"));
                        return
                    }
                    d.resolve(count)
                }).fail(d.reject.bind(d));
                return d
            };
            return {
                updateTotalItemsCount: function(options) {
                    var totalItemsCount = 0;
                    var totalCount = options.extra && options.extra.totalCount || 0;
                    var groupCount = options.extra && options.extra.groupCount || 0;
                    var pageSize = this._dataSource.pageSize();
                    var isVirtualPaging = this._isVirtualPaging();
                    foreachExpandedGroups(this, function(groupInfo) {
                        groupInfo.childrenTotalCount = 0
                    });
                    foreachExpandedGroups(this, function(groupInfo, parents) {
                        var totalOffset = getTotalOffset(parents, isVirtualPaging ? 0 : pageSize, totalItemsCount);
                        var count = groupInfo.count + groupInfo.childrenTotalCount;
                        if (!isVirtualPaging) {
                            count += getContinuationGroupCount(totalOffset, pageSize, count, parents.length - 1)
                        }
                        if (parents[parents.length - 2]) {
                            parents[parents.length - 2].childrenTotalCount += count
                        } else {
                            totalItemsCount += count
                        }
                    });
                    this.callBase(totalItemsCount - totalCount + groupCount)
                },
                _isGroupExpanded: function(groupIndex) {
                    var groups = this._dataSource.group();
                    return isGroupExpanded(groups, groupIndex)
                },
                _updatePagingOptions: function(options, callback) {
                    var that = this;
                    var isVirtualPaging = that._isVirtualPaging();
                    var pageSize = that._dataSource.pageSize();
                    var skips = [];
                    var takes = [];
                    var skipChildrenTotalCount = 0;
                    var childrenTotalCount = 0;
                    if (options.take) {
                        foreachExpandedGroups(this, function(groupInfo) {
                            groupInfo.childrenTotalCount = 0;
                            groupInfo.skipChildrenTotalCount = 0
                        });
                        foreachExpandedGroups(that, function(groupInfo, parents) {
                            var take;
                            var takeCorrection = 0;
                            var parentTakeCorrection = 0;
                            var totalOffset = getTotalOffset(parents, isVirtualPaging ? 0 : pageSize, childrenTotalCount);
                            var continuationGroupCount = 0;
                            var skipContinuationGroupCount = 0;
                            var groupInfoCount = groupInfo.count + groupInfo.childrenTotalCount;
                            var childrenGroupInfoCount = groupInfoCount;
                            callback && callback(groupInfo, totalOffset);
                            var skip = options.skip - totalOffset;
                            if (totalOffset <= options.skip + options.take && groupInfoCount) {
                                take = options.take;
                                if (!isVirtualPaging) {
                                    continuationGroupCount = getContinuationGroupCount(totalOffset, pageSize, groupInfoCount, parents.length - 1);
                                    groupInfoCount += continuationGroupCount * parents.length;
                                    childrenGroupInfoCount += continuationGroupCount;
                                    if (pageSize && skip >= 0) {
                                        takeCorrection = parents.length;
                                        parentTakeCorrection = parents.length - 1;
                                        skipContinuationGroupCount = Math.floor(skip / pageSize)
                                    }
                                }
                                if (skip >= 0) {
                                    if (totalOffset + groupInfoCount > options.skip) {
                                        skips.unshift(skip - skipContinuationGroupCount * takeCorrection - groupInfo.skipChildrenTotalCount)
                                    }
                                    if (totalOffset + groupInfoCount >= options.skip + take) {
                                        takes.unshift(take - takeCorrection - groupInfo.childrenTotalCount + groupInfo.skipChildrenTotalCount)
                                    }
                                } else {
                                    if (totalOffset + groupInfoCount >= options.skip + take) {
                                        takes.unshift(take + skip - groupInfo.childrenTotalCount)
                                    }
                                }
                            }
                            if (totalOffset <= options.skip) {
                                if (parents[parents.length - 2]) {
                                    parents[parents.length - 2].skipChildrenTotalCount += Math.min(childrenGroupInfoCount, skip + 1 - skipContinuationGroupCount * parentTakeCorrection)
                                } else {
                                    skipChildrenTotalCount += Math.min(childrenGroupInfoCount, skip + 1)
                                }
                            }
                            if (totalOffset <= options.skip + take) {
                                groupInfoCount = Math.min(childrenGroupInfoCount, skip + take - (skipContinuationGroupCount + 1) * parentTakeCorrection);
                                if (parents[parents.length - 2]) {
                                    parents[parents.length - 2].childrenTotalCount += groupInfoCount
                                } else {
                                    childrenTotalCount += groupInfoCount
                                }
                            }
                        });
                        options.skip -= skipChildrenTotalCount;
                        options.take -= childrenTotalCount - skipChildrenTotalCount
                    }
                    options.skips = skips;
                    options.takes = takes
                },
                changeRowExpand: function(path) {
                    var that = this;
                    var groupInfo = that.findGroupInfo(path);
                    var dataSource = that._dataSource;
                    var remoteGroupPaging = dataSource.remoteOperations().groupPaging;
                    var groups = _uiData_grid.default.normalizeSortingInfo(dataSource.group());
                    if (groupInfo) {
                        groupInfo.isExpanded = !groupInfo.isExpanded;
                        if (remoteGroupPaging && groupInfo.isExpanded && path.length < groups.length) {
                            return loadGroupTotalCount(dataSource, {
                                filter: (0, _uiData_grid2.createGroupFilter)(path, {
                                    filter: dataSource.lastLoadOptions().filter,
                                    group: dataSource.group()
                                }),
                                group: [groups[path.length]],
                                select: dataSource.select()
                            }).done(function(groupCount) {
                                groupInfo.count = groupCount
                            })
                        }
                        return (new _deferred.Deferred).resolve()
                    }
                    return (new _deferred.Deferred).reject()
                },
                handleDataLoading: function(options) {
                    var that = this;
                    var storeLoadOptions = options.storeLoadOptions;
                    var groups = _uiData_grid.default.normalizeSortingInfo(storeLoadOptions.group || options.loadOptions.group);
                    if (options.isCustomLoading || !groups.length) {
                        return
                    }
                    if (options.remoteOperations.grouping) {
                        var remotePaging = that._dataSource.remoteOperations().paging;
                        storeLoadOptions.group = _uiData_grid.default.normalizeSortingInfo(storeLoadOptions.group);
                        storeLoadOptions.group.forEach(function(group, index) {
                            var isLastGroup = index === storeLoadOptions.group.length - 1;
                            group.isExpanded = !remotePaging || !isLastGroup
                        })
                    }
                    options.group = options.group || groups;
                    if (options.remoteOperations.paging) {
                        options.skip = storeLoadOptions.skip;
                        options.take = storeLoadOptions.take;
                        storeLoadOptions.requireGroupCount = true;
                        storeLoadOptions.group = groups.slice(0, 1);
                        that._updatePagingOptions(options);
                        storeLoadOptions.skip = options.skip;
                        storeLoadOptions.take = options.take
                    }
                },
                handleDataLoadedCore: function(options, callBase) {
                    var that = this;
                    var loadedGroupCount = _uiData_grid.default.normalizeSortingInfo(options.storeLoadOptions.group || options.loadOptions.group).length;
                    var groupCount = options.group ? options.group.length : 0;
                    var totalCount;
                    var expandedInfo = {};
                    if (options.isCustomLoading) {
                        callBase(options);
                        processGroupItems(that, options.data, loadedGroupCount, expandedInfo, [], options.isCustomLoading, options.storeLoadOptions.isLoadingAll)
                    } else {
                        if (!options.remoteOperations.paging) {
                            that.foreachGroups(function(groupInfo) {
                                groupInfo.count = 0
                            })
                        }
                        totalCount = updateGroupInfos(that, options, options.data, loadedGroupCount);
                        if (totalCount < 0) {
                            options.data = (new _deferred.Deferred).reject(_ui.default.Error("E1037"));
                            return
                        }
                        if (!options.remoteOperations.paging) {
                            if (loadedGroupCount && options.extra && options.loadOptions.requireTotalCount) {
                                options.extra.totalCount = totalCount;
                                options.extra.groupCount = options.data.length
                            }
                        }
                        if (groupCount && options.storeLoadOptions.requireGroupCount && !isFinite(options.extra.groupCount)) {
                            options.data = (new _deferred.Deferred).reject(_errors.default.errors.Error("E4022"));
                            return
                        }
                        that.updateTotalItemsCount(options);
                        if (!options.remoteOperations.paging) {
                            that._updatePagingOptions(options)
                        }
                        callBase(options);
                        if (!options.remoteOperations.paging) {
                            that._processPaging(options, loadedGroupCount)
                        }
                    }
                    loadGroupItems(that, options, loadedGroupCount, expandedInfo, 0, options.data)
                },
                _processSkips: function(items, skips, groupCount) {
                    if (!groupCount) {
                        return
                    }
                    var firstItem = items[0];
                    var skip = skips[0];
                    var children = firstItem && firstItem.items;
                    if (void 0 !== skip) {
                        firstItem.isContinuation = true;
                        if (children) {
                            firstItem.items = children.slice(skip);
                            this._processSkips(firstItem.items, skips.slice(1), groupCount - 1)
                        }
                    }
                },
                _processTakes: function(items, skips, takes, groupCount, parents) {
                    if (!groupCount || !items) {
                        return
                    }
                    parents = parents || [];
                    var lastItem = items[items.length - 1];
                    var children = lastItem && lastItem.items;
                    var take = takes[0];
                    var skip = skips[0];
                    if (lastItem) {
                        var maxTakeCount = lastItem.count - (lastItem.isContinuation && skip || 0) || children.length;
                        if (void 0 !== take && maxTakeCount > take) {
                            lastItem.isContinuationOnNextPage = true;
                            parents.forEach(function(parent) {
                                parent.isContinuationOnNextPage = true
                            });
                            if (children) {
                                children = children.slice(0, take);
                                lastItem.items = children
                            }
                        }
                        parents.push(lastItem);
                        this._processTakes(children, skips.slice(1), takes.slice(1), groupCount - 1, parents)
                    }
                },
                _processPaging: function(options, groupCount) {
                    this._processSkips(options.data, options.skips, groupCount);
                    this._processTakes(options.data, options.skips, options.takes, groupCount)
                },
                isLastLevelGroupItemsPagingLocal: function() {
                    return false
                },
                sortLastLevelGroupItems: function(items) {
                    return items
                },
                refresh: function(options, operationTypes) {
                    var that = this;
                    var dataSource = that._dataSource;
                    var storeLoadOptions = options.storeLoadOptions;
                    var group = options.group || options.storeLoadOptions.group;
                    var oldGroups = _uiData_grid.default.normalizeSortingInfo(that._group);
                    var isExpanded;
                    var groupIndex;

                    function handleGroup(groupInfo, parents) {
                        if (parents.length === groupIndex + 1) {
                            groupInfo.isExpanded = isExpanded
                        }
                    }
                    for (groupIndex = 0; groupIndex < oldGroups.length; groupIndex++) {
                        isExpanded = isGroupExpanded(group, groupIndex);
                        if (isGroupExpanded(that._group, groupIndex) !== isExpanded) {
                            that.foreachGroups(handleGroup)
                        }
                    }
                    that.callBase.apply(this, arguments);
                    if (group && options.remoteOperations.paging && operationTypes.reload) {
                        return foreachExpandedGroups(that, function(groupInfo) {
                            var groupCountQuery = loadGroupTotalCount(dataSource, {
                                filter: (0, _uiData_grid2.createGroupFilter)(groupInfo.path, {
                                    filter: storeLoadOptions.filter,
                                    group: group
                                }),
                                group: group.slice(groupInfo.path.length),
                                select: storeLoadOptions.select
                            });
                            var groupOffsetQuery = loadGroupTotalCount(dataSource, {
                                filter: (0, _uiData_gridGrouping.createOffsetFilter)(groupInfo.path, {
                                    filter: storeLoadOptions.filter,
                                    group: group
                                }, true),
                                group: group.slice(groupInfo.path.length - 1, groupInfo.path.length),
                                select: storeLoadOptions.select
                            });
                            return (0, _deferred.when)(groupOffsetQuery, groupCountQuery).done(function(offset, count) {
                                offset = parseInt(offset.length ? offset[0] : offset);
                                count = parseInt(count.length ? count[0] : count);
                                groupInfo.offset = offset;
                                if (groupInfo.count !== count) {
                                    groupInfo.count = count;
                                    that.updateTotalItemsCount(options)
                                }
                            })
                        }, true)
                    }
                }
            }
        }());
        exports.GroupingHelper = GroupingHelper
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.master_detail.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.master_detail */ 397));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiData_grid.default.registerModule("masterDetail", _uiGrid_core.default)
    },
    /*!***********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.editing.js ***!
      \***********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        __webpack_require__( /*! ./ui.data_grid.editor_factory */ 710);
        var _uiData_grid2 = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.editing */ 400));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiData_grid2.default.registerModule("editing", (0, _extend.extend)(true, {}, _uiGrid_core.default, {
            extenders: {
                controllers: {
                    data: {
                        _changeRowExpandCore: function(key) {
                            var editingController = this._editingController;
                            if (Array.isArray(key)) {
                                editingController && editingController.refresh()
                            }
                            return this.callBase.apply(this, arguments)
                        }
                    }
                }
            }
        }))
    },
    /*!******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.editor_factory.js ***!
      \******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.editor_factory */ 398));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiData_grid.default.registerModule("editorFactory", _uiGrid_core.default)
    },
    /*!**************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.validating.js ***!
      \**************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.validating */ 401));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiData_grid.default.registerModule("validating", _uiGrid_core.default)
    },
    /*!*********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.virtual_scrolling.js ***!
      \*********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiData_grid2 = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.data_source_adapter */ 218));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.virtual_scrolling */ 402));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiData_grid.default.registerModule("virtualScrolling", _uiGrid_core.default);
        _uiData_grid2.default.extend(_uiGrid_core.default.extenders.dataSourceAdapter)
    },
    /*!**************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.filter_row.js ***!
      \**************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.filter_row */ 404));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiData_grid.default.registerModule("filterRow", _uiGrid_core.default)
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/menu/ui.submenu.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _element = __webpack_require__( /*! ../../core/element */ 18);
        var _position = _interopRequireDefault(__webpack_require__( /*! ../../animation/position */ 81));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _context_menu = _interopRequireDefault(__webpack_require__( /*! ../context_menu */ 107));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var DX_CONTEXT_MENU_CONTENT_DELIMITER_CLASS = "dx-context-menu-content-delimiter";
        var DX_SUBMENU_CLASS = "dx-submenu";
        var Submenu = function(_ContextMenu) {
            _inheritsLoose(Submenu, _ContextMenu);

            function Submenu() {
                return _ContextMenu.apply(this, arguments) || this
            }
            var _proto = Submenu.prototype;
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_ContextMenu.prototype._getDefaultOptions.call(this), {
                    orientation: "horizontal",
                    tabIndex: null,
                    onHoverStart: _common.noop
                })
            };
            _proto._initDataAdapter = function() {
                this._dataAdapter = this.option("_dataAdapter");
                if (!this._dataAdapter) {
                    _ContextMenu.prototype._initDataAdapter.call(this)
                }
            };
            _proto._renderContentImpl = function() {
                this._renderContextMenuOverlay();
                _ContextMenu.prototype._renderContentImpl.call(this);
                var node = this._dataAdapter.getNodeByKey(this.option("_parentKey"));
                node && this._renderItems(this._getChildNodes(node));
                this._renderDelimiter()
            };
            _proto._renderDelimiter = function() {
                this.$contentDelimiter = (0, _renderer.default)("<div>").appendTo(this._itemContainer()).addClass(DX_CONTEXT_MENU_CONTENT_DELIMITER_CLASS)
            };
            _proto._getOverlayOptions = function() {
                return (0, _extend.extend)(_ContextMenu.prototype._getOverlayOptions.call(this), {
                    onPositioned: this._overlayPositionedActionHandler.bind(this)
                })
            };
            _proto._overlayPositionedActionHandler = function(arg) {
                this._showDelimiter(arg)
            };
            _proto._hoverEndHandler = function(e) {
                _ContextMenu.prototype._hoverEndHandler.call(this, e);
                this._toggleFocusClass(false, e.currentTarget)
            };
            _proto._isMenuHorizontal = function() {
                return "horizontal" === this.option("orientation")
            };
            _proto._hoverStartHandler = function(e) {
                var hoverStartAction = this.option("onHoverStart");
                hoverStartAction(e);
                _ContextMenu.prototype._hoverStartHandler.call(this, e);
                this._toggleFocusClass(true, e.currentTarget)
            };
            _proto._drawSubmenu = function($rootItem) {
                this._actions.onShowing({
                    rootItem: (0, _element.getPublicElement)($rootItem),
                    submenu: this
                });
                _ContextMenu.prototype._drawSubmenu.call(this, $rootItem);
                this._actions.onShown({
                    rootItem: (0, _element.getPublicElement)($rootItem),
                    submenu: this
                })
            };
            _proto._hideSubmenu = function($rootItem) {
                this._actions.onHiding({
                    cancel: true,
                    rootItem: (0, _element.getPublicElement)($rootItem),
                    submenu: this
                });
                _ContextMenu.prototype._hideSubmenu.call(this, $rootItem);
                this._actions.onHidden({
                    rootItem: (0, _element.getPublicElement)($rootItem),
                    submenu: this
                })
            };
            _proto._showDelimiter = function(arg) {
                if (!this.$contentDelimiter) {
                    return
                }
                var $submenu = this._itemContainer().children(".".concat(DX_SUBMENU_CLASS)).eq(0);
                var $rootItem = this.option("position").of;
                var position = {
                    of: $submenu
                };
                var containerOffset = arg.position;
                var vLocation = containerOffset.v.location;
                var hLocation = containerOffset.h.location;
                var rootOffset = $rootItem.offset();
                var offsetLeft = Math.round(rootOffset.left);
                var offsetTop = Math.round(rootOffset.top);
                var rootWidth = $rootItem.width();
                var rootHeight = $rootItem.height();
                var submenuWidth = $submenu.width();
                var submenuHeight = $submenu.height();
                this.$contentDelimiter.css("display", "block");
                this.$contentDelimiter.width(this._isMenuHorizontal() ? rootWidth < submenuWidth ? rootWidth - 2 : submenuWidth : 2);
                this.$contentDelimiter.height(this._isMenuHorizontal() ? 2 : rootHeight < submenuHeight ? rootHeight - 2 : submenuHeight);
                if (this._isMenuHorizontal()) {
                    if (vLocation > offsetTop) {
                        if (Math.round(hLocation) === offsetLeft) {
                            position.offset = "1 -1";
                            position.at = position.my = "left top"
                        } else {
                            position.offset = "-1 -1";
                            position.at = position.my = "right top"
                        }
                    } else {
                        this.$contentDelimiter.height(5);
                        if (Math.round(hLocation) === offsetLeft) {
                            position.offset = "1 4";
                            position.at = position.my = "left bottom"
                        } else {
                            position.offset = "-1 2";
                            position.at = position.my = "right bottom"
                        }
                    }
                } else {
                    if (hLocation > offsetLeft) {
                        if (Math.round(vLocation) === offsetTop) {
                            position.offset = "-1 1";
                            position.at = position.my = "left top"
                        } else {
                            position.offset = "-1 -1";
                            position.at = position.my = "left bottom"
                        }
                    } else {
                        if (Math.round(vLocation) === offsetTop) {
                            position.offset = "1 1";
                            position.at = position.my = "right top"
                        } else {
                            position.offset = "1 -1";
                            position.at = position.my = "right bottom"
                        }
                    }
                }
                _position.default.setup(this.$contentDelimiter, position)
            };
            _proto._getContextMenuPosition = function() {
                return this.option("position")
            };
            _proto.isOverlayVisible = function() {
                return this._overlay.option("visible")
            };
            _proto.getOverlayContent = function() {
                return this._overlay.$content()
            };
            return Submenu
        }(_context_menu.default);
        var _default = Submenu;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.header_filter.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.header_filter */ 407));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiData_grid.default.registerModule("headerFilter", _uiGrid_core.default)
    },
    /*!***************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.filter_sync.js ***!
      \***************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.filter_sync */ 409));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiData_grid.default.registerModule("filterSync", _uiGrid_core.default)
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/filter_builder/between.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getConfig = getConfig;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var FILTER_BUILDER_RANGE_CLASS = "dx-filterbuilder-range";
        var FILTER_BUILDER_RANGE_START_CLASS = FILTER_BUILDER_RANGE_CLASS + "-start";
        var FILTER_BUILDER_RANGE_END_CLASS = FILTER_BUILDER_RANGE_CLASS + "-end";
        var FILTER_BUILDER_RANGE_SEPARATOR_CLASS = FILTER_BUILDER_RANGE_CLASS + "-separator";
        var SEPARATOR = "\u2013";

        function editorTemplate(conditionInfo, container) {
            var $editorStart = (0, _renderer.default)("<div>").addClass(FILTER_BUILDER_RANGE_START_CLASS);
            var $editorEnd = (0, _renderer.default)("<div>").addClass(FILTER_BUILDER_RANGE_END_CLASS);
            var values = conditionInfo.value || [];
            var getStartValue = function(values) {
                return values && values.length > 0 ? values[0] : null
            };
            var getEndValue = function(values) {
                return values && 2 === values.length ? values[1] : null
            };
            container.append($editorStart);
            container.append((0, _renderer.default)("<span>").addClass(FILTER_BUILDER_RANGE_SEPARATOR_CLASS).text(SEPARATOR));
            container.append($editorEnd);
            container.addClass(FILTER_BUILDER_RANGE_CLASS);
            this._editorFactory.createEditor.call(this, $editorStart, (0, _extend.extend)({}, conditionInfo.field, conditionInfo, {
                value: getStartValue(values),
                parentType: "filterBuilder",
                setValue: function(value) {
                    values = [value, getEndValue(values)];
                    conditionInfo.setValue(values)
                }
            }));
            this._editorFactory.createEditor.call(this, $editorEnd, (0, _extend.extend)({}, conditionInfo.field, conditionInfo, {
                value: getEndValue(values),
                parentType: "filterBuilder",
                setValue: function(value) {
                    values = [getStartValue(values), value];
                    conditionInfo.setValue(values)
                }
            }))
        }

        function getConfig(caption, context) {
            return {
                name: "between",
                caption: caption,
                icon: "range",
                valueSeparator: SEPARATOR,
                dataTypes: ["number", "date", "datetime"],
                editorTemplate: editorTemplate.bind(context),
                notForLookup: true
            }
        }
    },
    /*!***************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/filter_builder/ui.filter_operations_dictionary.js ***!
      \***************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var OPERATION_ICONS = {
            "=": "equal",
            "<>": "notequal",
            "<": "less",
            "<=": "lessorequal",
            ">": "greater",
            ">=": "greaterorequal",
            notcontains: "doesnotcontain",
            contains: "contains",
            startswith: "startswith",
            endswith: "endswith",
            isblank: "isblank",
            isnotblank: "isnotblank"
        };
        var OPERATION_NAME = {
            "=": "equal",
            "<>": "notEqual",
            "<": "lessThan",
            "<=": "lessThanOrEqual",
            ">": "greaterThan",
            ">=": "greaterThanOrEqual",
            startswith: "startsWith",
            contains: "contains",
            notcontains: "notContains",
            endswith: "endsWith",
            isblank: "isBlank",
            isnotblank: "isNotBlank",
            between: "between"
        };
        var _default = {
            getIconByFilterOperation: function(filterOperation) {
                return OPERATION_ICONS[filterOperation]
            },
            getNameByFilterOperation: function(filterOperation) {
                return OPERATION_NAME[filterOperation]
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/grid_core/ui.grid_core.filter_custom_operations.js ***!
      \****************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.anyOf = anyOf;
        exports.noneOf = noneOf;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _data_source = __webpack_require__( /*! ../../data/data_source/data_source */ 68);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _utils = __webpack_require__( /*! ../filter_builder/utils */ 219);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function baseOperation(grid) {
            var calculateFilterExpression = function(filterValue, field, fields) {
                var result = [];
                var lastIndex = filterValue.length - 1;
                filterValue && filterValue.forEach(function(value, index) {
                    if ((0, _utils.isCondition)(value) || (0, _utils.isGroup)(value)) {
                        var filterExpression = (0, _utils.getFilterExpression)(value, fields, [], "headerFilter");
                        result.push(filterExpression)
                    } else {
                        result.push((0, _utils.getFilterExpression)([field.dataField, "=", value], fields, [], "headerFilter"))
                    }
                    index !== lastIndex && result.push("or")
                });
                if (1 === result.length) {
                    result = result[0]
                }
                return result
            };
            var getFullText = function(itemText, parentText) {
                return parentText ? parentText + "/" + itemText : itemText
            };
            var getSelectedItemsTexts = function getSelectedItemsTexts(items, parentText) {
                var result = [];
                items.forEach(function(item) {
                    if (item.items) {
                        var selectedItemsTexts = getSelectedItemsTexts(item.items, getFullText(item.text, parentText));
                        result = result.concat(selectedItemsTexts)
                    }
                    item.selected && result.push(getFullText(item.text, parentText))
                });
                return result
            };
            var headerFilterController = grid && grid.getController("headerFilter");
            var customizeText = function(fieldInfo) {
                var value = fieldInfo.value;
                var column = grid.columnOption(fieldInfo.field.dataField);
                var headerFilter = column && column.headerFilter;
                var lookup = column && column.lookup;
                if (headerFilter && headerFilter.dataSource || lookup && lookup.dataSource) {
                    column = (0, _extend.extend)({}, column, {
                        filterType: "include",
                        filterValues: [value]
                    });
                    var dataSourceOptions = headerFilterController.getDataSource(column);
                    dataSourceOptions.paginate = false;
                    var dataSource = new _data_source.DataSource(dataSourceOptions);
                    var result = new _deferred.Deferred;
                    var key = dataSource.store().key();
                    if (key) {
                        dataSource.filter([key, "=", fieldInfo.value])
                    }
                    dataSource.load().done(function(items) {
                        result.resolve(getSelectedItemsTexts(items)[0])
                    });
                    return result
                } else {
                    var text = headerFilterController.getHeaderItemText(value, column, 0, grid.option("headerFilter"));
                    return text
                }
            };
            return {
                dataTypes: ["string", "date", "datetime", "number", "boolean", "object"],
                calculateFilterExpression: calculateFilterExpression,
                editorTemplate: function(conditionInfo, container) {
                    var div = (0, _renderer.default)("<div>").addClass("dx-filterbuilder-item-value-text").appendTo(container);
                    var column = (0, _extend.extend)(true, {}, grid.columnOption(conditionInfo.field.dataField));
                    (0, _utils.renderValueText)(div, conditionInfo.text && conditionInfo.text.split("|"));
                    var setValue = function(value) {
                        conditionInfo.setValue(value)
                    };
                    column.filterType = "include";
                    column.filterValues = conditionInfo.value ? conditionInfo.value.slice() : [];
                    headerFilterController.showHeaderFilterMenuBase({
                        columnElement: div,
                        column: column,
                        apply: function() {
                            setValue(this.filterValues);
                            headerFilterController.hideHeaderFilterMenu();
                            conditionInfo.closeEditor()
                        },
                        onHidden: function() {
                            conditionInfo.closeEditor()
                        },
                        isFilterBuilder: true
                    });
                    return container
                },
                customizeText: customizeText
            }
        }

        function anyOf(grid) {
            return (0, _extend.extend)(baseOperation(grid), {
                name: "anyof",
                icon: "selectall",
                caption: _message.default.format("dxFilterBuilder-filterOperationAnyOf")
            })
        }

        function noneOf(grid) {
            var baseOp = baseOperation(grid);
            return (0, _extend.extend)({}, baseOp, {
                calculateFilterExpression: function(filterValue, field, fields) {
                    var baseFilter = baseOp.calculateFilterExpression(filterValue, field, fields);
                    if (!baseFilter || 0 === baseFilter.length) {
                        return null
                    }
                    return "!" === baseFilter[0] ? baseFilter : ["!", baseFilter]
                },
                name: "noneof",
                icon: "unselectall",
                caption: _message.default.format("dxFilterBuilder-filterOperationNoneOf")
            })
        }
    },
    /*!******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.filter_builder.js ***!
      \******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.filter_builder */ 410));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiData_grid.default.registerModule("filterBuilder", _uiGrid_core.default)
    },
    /*!**********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/filter_builder/filter_builder.js ***!
      \**********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _tree_view = _interopRequireDefault(__webpack_require__( /*! ../tree_view */ 158));
        var _popup = _interopRequireDefault(__webpack_require__( /*! ../popup */ 46));
        var _utils = __webpack_require__( /*! ../overlay/utils */ 280);
        var _ui2 = _interopRequireDefault(__webpack_require__( /*! ../shared/ui.editor_factory_mixin */ 399));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _utils2 = __webpack_require__( /*! ./utils */ 219);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var FILTER_BUILDER_CLASS = "dx-filterbuilder";
        var FILTER_BUILDER_GROUP_CLASS = FILTER_BUILDER_CLASS + "-group";
        var FILTER_BUILDER_GROUP_ITEM_CLASS = FILTER_BUILDER_GROUP_CLASS + "-item";
        var FILTER_BUILDER_GROUP_CONTENT_CLASS = FILTER_BUILDER_GROUP_CLASS + "-content";
        var FILTER_BUILDER_GROUP_OPERATIONS_CLASS = FILTER_BUILDER_GROUP_CLASS + "-operations";
        var FILTER_BUILDER_GROUP_OPERATION_CLASS = FILTER_BUILDER_GROUP_CLASS + "-operation";
        var FILTER_BUILDER_ACTION_CLASS = FILTER_BUILDER_CLASS + "-action";
        var FILTER_BUILDER_IMAGE_CLASS = FILTER_BUILDER_ACTION_CLASS + "-icon";
        var FILTER_BUILDER_IMAGE_ADD_CLASS = "dx-icon-plus";
        var FILTER_BUILDER_IMAGE_REMOVE_CLASS = "dx-icon-remove";
        var FILTER_BUILDER_ITEM_TEXT_CLASS = FILTER_BUILDER_CLASS + "-text";
        var FILTER_BUILDER_ITEM_FIELD_CLASS = FILTER_BUILDER_CLASS + "-item-field";
        var FILTER_BUILDER_ITEM_OPERATION_CLASS = FILTER_BUILDER_CLASS + "-item-operation";
        var FILTER_BUILDER_ITEM_VALUE_CLASS = FILTER_BUILDER_CLASS + "-item-value";
        var FILTER_BUILDER_ITEM_VALUE_TEXT_CLASS = FILTER_BUILDER_CLASS + "-item-value-text";
        var FILTER_BUILDER_OVERLAY_CLASS = FILTER_BUILDER_CLASS + "-overlay";
        var FILTER_BUILDER_FILTER_OPERATIONS_CLASS = FILTER_BUILDER_CLASS + "-operations";
        var FILTER_BUILDER_FIELDS_CLASS = FILTER_BUILDER_CLASS + "-fields";
        var FILTER_BUILDER_ADD_CONDITION_CLASS = FILTER_BUILDER_CLASS + "-add-condition";
        var ACTIVE_CLASS = "dx-state-active";
        var FILTER_BUILDER_MENU_CUSTOM_OPERATION_CLASS = FILTER_BUILDER_CLASS + "-menu-custom-operation";
        var SOURCE = "filterBuilder";
        var DISABLED_STATE_CLASS = "dx-state-disabled";
        var TAB_KEY = "tab";
        var ENTER_KEY = "enter";
        var ESCAPE_KEY = "escape";
        var ACTIONS = [{
            name: "onEditorPreparing",
            config: {
                excludeValidators: ["disabled", "readOnly"],
                category: "rendering"
            }
        }, {
            name: "onEditorPrepared",
            config: {
                excludeValidators: ["disabled", "readOnly"],
                category: "rendering"
            }
        }, {
            name: "onValueChanged",
            config: {
                excludeValidators: ["disabled", "readOnly"]
            }
        }];
        var OPERATORS = {
            and: "and",
            or: "or",
            notAnd: "!and",
            notOr: "!or"
        };
        var EditorFactory = _class.default.inherit(_ui2.default);
        var FilterBuilder = _ui.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    onEditorPreparing: null,
                    onEditorPrepared: null,
                    onValueChanged: null,
                    fields: [],
                    defaultGroupOperation: "and",
                    groupOperations: ["and", "or", "notAnd", "notOr"],
                    maxGroupLevel: void 0,
                    value: null,
                    allowHierarchicalFields: false,
                    groupOperationDescriptions: {
                        and: _message.default.format("dxFilterBuilder-and"),
                        or: _message.default.format("dxFilterBuilder-or"),
                        notAnd: _message.default.format("dxFilterBuilder-notAnd"),
                        notOr: _message.default.format("dxFilterBuilder-notOr")
                    },
                    customOperations: [],
                    closePopupOnTargetScroll: true,
                    filterOperationDescriptions: {
                        between: _message.default.format("dxFilterBuilder-filterOperationBetween"),
                        equal: _message.default.format("dxFilterBuilder-filterOperationEquals"),
                        notEqual: _message.default.format("dxFilterBuilder-filterOperationNotEquals"),
                        lessThan: _message.default.format("dxFilterBuilder-filterOperationLess"),
                        lessThanOrEqual: _message.default.format("dxFilterBuilder-filterOperationLessOrEquals"),
                        greaterThan: _message.default.format("dxFilterBuilder-filterOperationGreater"),
                        greaterThanOrEqual: _message.default.format("dxFilterBuilder-filterOperationGreaterOrEquals"),
                        startsWith: _message.default.format("dxFilterBuilder-filterOperationStartsWith"),
                        contains: _message.default.format("dxFilterBuilder-filterOperationContains"),
                        notContains: _message.default.format("dxFilterBuilder-filterOperationNotContains"),
                        endsWith: _message.default.format("dxFilterBuilder-filterOperationEndsWith"),
                        isBlank: _message.default.format("dxFilterBuilder-filterOperationIsBlank"),
                        isNotBlank: _message.default.format("dxFilterBuilder-filterOperationIsNotBlank")
                    }
                })
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "closePopupOnTargetScroll":
                        break;
                    case "onEditorPreparing":
                    case "onEditorPrepared":
                    case "onValueChanged":
                        this._initActions();
                        break;
                    case "customOperations":
                        this._initCustomOperations();
                        this._invalidate();
                        break;
                    case "fields":
                    case "defaultGroupOperation":
                    case "maxGroupLevel":
                    case "groupOperations":
                    case "allowHierarchicalFields":
                    case "groupOperationDescriptions":
                    case "filterOperationDescriptions":
                        this._invalidate();
                        break;
                    case "value":
                        if (args.value !== args.previousValue) {
                            var disableInvalidateForValue = this._disableInvalidateForValue;
                            if (!disableInvalidateForValue) {
                                this._initModel();
                                this._invalidate()
                            }
                            this._disableInvalidateForValue = false;
                            this.executeAction("onValueChanged", {
                                value: args.value,
                                previousValue: args.previousValue
                            });
                            this._disableInvalidateForValue = disableInvalidateForValue
                        }
                        break;
                    default:
                        this.callBase(args)
                }
            },
            getFilterExpression: function() {
                var fields = this._getNormalizedFields();
                var value = (0, _extend.extend)(true, [], this._model);
                return (0, _utils2.getFilterExpression)((0, _utils2.getNormalizedFilter)(value), fields, this._customOperations, SOURCE)
            },
            _getNormalizedFields: function() {
                return (0, _utils2.getNormalizedFields)(this.option("fields"))
            },
            _updateFilter: function() {
                this._disableInvalidateForValue = true;
                var value = (0, _extend.extend)(true, [], this._model);
                var normalizedValue = (0, _utils2.getNormalizedFilter)(value);
                var oldValue = (0, _utils2.getNormalizedFilter)(this._getModel(this.option("value")));
                if (JSON.stringify(oldValue) !== JSON.stringify(normalizedValue)) {
                    this.option("value", normalizedValue)
                }
                this._disableInvalidateForValue = false;
                this._fireContentReadyAction()
            },
            _init: function() {
                this._initCustomOperations();
                this._initModel();
                this._initEditorFactory();
                this._initActions();
                this.callBase()
            },
            _initEditorFactory: function() {
                this._editorFactory = new EditorFactory
            },
            _initCustomOperations: function() {
                this._customOperations = (0, _utils2.getMergedOperations)(this.option("customOperations"), this.option("filterOperationDescriptions.between"), this)
            },
            _getModel: function(value) {
                return (0, _utils2.convertToInnerStructure)(value, this._customOperations)
            },
            _initModel: function() {
                this._model = this._getModel(this.option("value"))
            },
            _initActions: function() {
                var that = this;
                that._actions = {};
                ACTIONS.forEach(function(action) {
                    var actionConfig = (0, _extend.extend)({}, action.config);
                    that._actions[action.name] = that._createActionByOption(action.name, actionConfig)
                })
            },
            executeAction: function(actionName, options) {
                var action = this._actions[actionName];
                return action && action(options)
            },
            _initMarkup: function() {
                this.$element().addClass(FILTER_BUILDER_CLASS);
                this.callBase();
                this._createGroupElementByCriteria(this._model).appendTo(this.$element())
            },
            _createConditionElement: function(condition, parent) {
                return (0, _renderer.default)("<div>").addClass(FILTER_BUILDER_GROUP_CLASS).append(this._createConditionItem(condition, parent))
            },
            _createGroupElementByCriteria: function(criteria, parent) {
                var groupLevel = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                var $group = this._createGroupElement(criteria, parent, groupLevel);
                var $groupContent = $group.find("." + FILTER_BUILDER_GROUP_CONTENT_CLASS);
                var groupCriteria = (0, _utils2.getGroupCriteria)(criteria);
                for (var i = 0; i < groupCriteria.length; i++) {
                    var innerCriteria = groupCriteria[i];
                    if ((0, _utils2.isGroup)(innerCriteria)) {
                        this._createGroupElementByCriteria(innerCriteria, criteria, groupLevel + 1).appendTo($groupContent)
                    } else {
                        if ((0, _utils2.isCondition)(innerCriteria)) {
                            this._createConditionElement(innerCriteria, criteria).appendTo($groupContent)
                        }
                    }
                }
                return $group
            },
            _createGroupElement: function(criteria, parent, groupLevel) {
                var _this = this;
                var $groupItem = (0, _renderer.default)("<div>").addClass(FILTER_BUILDER_GROUP_ITEM_CLASS);
                var $groupContent = (0, _renderer.default)("<div>").addClass(FILTER_BUILDER_GROUP_CONTENT_CLASS);
                var $group = (0, _renderer.default)("<div>").addClass(FILTER_BUILDER_GROUP_CLASS).append($groupItem).append($groupContent);
                if (null != parent) {
                    this._createRemoveButton(function() {
                        (0, _utils2.removeItem)(parent, criteria);
                        $group.remove();
                        _this._updateFilter()
                    }).appendTo($groupItem)
                }
                this._createGroupOperationButton(criteria).appendTo($groupItem);
                this._createAddButton(function() {
                    var newGroup = (0, _utils2.createEmptyGroup)(_this.option("defaultGroupOperation"));
                    (0, _utils2.addItem)(newGroup, criteria);
                    _this._createGroupElement(newGroup, criteria, groupLevel + 1).appendTo($groupContent);
                    _this._updateFilter()
                }, function() {
                    var field = _this.option("fields")[0];
                    var newCondition = (0, _utils2.createCondition)(field, _this._customOperations);
                    (0, _utils2.addItem)(newCondition, criteria);
                    _this._createConditionElement(newCondition, criteria).appendTo($groupContent);
                    _this._updateFilter()
                }, groupLevel).appendTo($groupItem);
                return $group
            },
            _createButton: function(caption) {
                return (0, _renderer.default)("<div>").text(caption)
            },
            _createGroupOperationButton: function(criteria) {
                var _this2 = this;
                var groupOperations = this._getGroupOperations(criteria);
                var groupMenuItem = (0, _utils2.getGroupMenuItem)(criteria, groupOperations);
                var caption = groupMenuItem.text;
                var $operationButton = groupOperations && groupOperations.length < 2 ? this._createButton(caption).addClass(DISABLED_STATE_CLASS) : this._createButtonWithMenu({
                    caption: caption,
                    menu: {
                        items: groupOperations,
                        displayExpr: "text",
                        keyExpr: "value",
                        onItemClick: function(e) {
                            if (groupMenuItem !== e.itemData) {
                                (0, _utils2.setGroupValue)(criteria, e.itemData.value);
                                $operationButton.html(e.itemData.text);
                                groupMenuItem = e.itemData;
                                _this2._updateFilter()
                            }
                        },
                        onContentReady: function(e) {
                            e.component.selectItem(groupMenuItem)
                        },
                        cssClass: FILTER_BUILDER_GROUP_OPERATIONS_CLASS
                    }
                });
                return $operationButton.addClass(FILTER_BUILDER_ITEM_TEXT_CLASS).addClass(FILTER_BUILDER_GROUP_OPERATION_CLASS).attr("tabindex", 0)
            },
            _createButtonWithMenu: function(options) {
                var that = this;
                var removeMenu = function() {
                    that.$element().find("." + ACTIVE_CLASS).removeClass(ACTIVE_CLASS);
                    that.$element().find(".dx-overlay .dx-treeview").remove();
                    that.$element().find(".dx-overlay").remove()
                };
                var rtlEnabled = this.option("rtlEnabled");
                var menuOnItemClickWrapper = function(handler) {
                    return function(e) {
                        handler(e);
                        if ("dxclick" === e.event.type) {
                            removeMenu()
                        }
                    }
                };
                var position = rtlEnabled ? "right" : "left";
                var $button = this._createButton(options.caption);
                (0, _extend.extend)(options.menu, {
                    focusStateEnabled: true,
                    selectionMode: "single",
                    onItemClick: menuOnItemClickWrapper(options.menu.onItemClick),
                    onHiding: function(e) {
                        $button.removeClass(ACTIVE_CLASS)
                    },
                    position: {
                        my: position + " top",
                        at: position + " bottom",
                        offset: "0 1",
                        of: $button,
                        collision: "flip"
                    },
                    animation: null,
                    onHidden: function() {
                        removeMenu()
                    },
                    cssClass: FILTER_BUILDER_OVERLAY_CLASS + " " + options.menu.cssClass,
                    rtlEnabled: rtlEnabled
                });
                options.popup = {
                    onShown: function(info) {
                        var treeViewElement = (0, _renderer.default)(info.component.content()).find(".dx-treeview");
                        var treeView = treeViewElement.dxTreeView("instance");
                        _events_engine.default.on(treeViewElement, "keyup keydown", function(e) {
                            var keyName = (0, _index.normalizeKeyName)(e);
                            if ("keydown" === e.type && keyName === TAB_KEY || "keyup" === e.type && (keyName === ESCAPE_KEY || keyName === ENTER_KEY)) {
                                info.component.hide();
                                _events_engine.default.trigger(options.menu.position.of, "focus")
                            }
                        });
                        treeView.focus();
                        treeView.option("focusedElement", null)
                    }
                };
                this._subscribeOnClickAndEnterKey($button, function() {
                    removeMenu();
                    that._createPopupWithTreeView(options, that.$element());
                    $button.addClass(ACTIVE_CLASS)
                });
                return $button
            },
            _hasValueButton: function(condition) {
                var customOperation = (0, _utils2.getCustomOperation)(this._customOperations, condition[1]);
                return customOperation ? false !== customOperation.hasValue : null !== condition[2]
            },
            _createOperationButtonWithMenu: function(condition, field) {
                var _this3 = this;
                var that = this;
                var availableOperations = (0, _utils2.getAvailableOperations)(field, this.option("filterOperationDescriptions"), this._customOperations);
                var currentOperation = (0, _utils2.getOperationFromAvailable)((0, _utils2.getOperationValue)(condition), availableOperations);
                var $operationButton = this._createButtonWithMenu({
                    caption: currentOperation.text,
                    menu: {
                        items: availableOperations,
                        displayExpr: "text",
                        onItemRendered: function(e) {
                            e.itemData.isCustom && (0, _renderer.default)(e.itemElement).addClass(FILTER_BUILDER_MENU_CUSTOM_OPERATION_CLASS)
                        },
                        onContentReady: function(e) {
                            e.component.selectItem(currentOperation)
                        },
                        onItemClick: function(e) {
                            if (currentOperation !== e.itemData) {
                                currentOperation = e.itemData;
                                (0, _utils2.updateConditionByOperation)(condition, currentOperation.value, that._customOperations);
                                var $valueButton = $operationButton.siblings().filter("." + FILTER_BUILDER_ITEM_VALUE_CLASS);
                                if (that._hasValueButton(condition)) {
                                    if (0 !== $valueButton.length) {
                                        $valueButton.remove()
                                    }
                                    that._createValueButton(condition, field).appendTo($operationButton.parent())
                                } else {
                                    $valueButton.remove()
                                }
                                $operationButton.html(currentOperation.text);
                                _this3._updateFilter()
                            }
                        },
                        cssClass: FILTER_BUILDER_FILTER_OPERATIONS_CLASS
                    }
                }).addClass(FILTER_BUILDER_ITEM_TEXT_CLASS).addClass(FILTER_BUILDER_ITEM_OPERATION_CLASS).attr("tabindex", 0);
                return $operationButton
            },
            _createOperationAndValueButtons: function(condition, field, $item) {
                this._createOperationButtonWithMenu(condition, field).appendTo($item);
                if (this._hasValueButton(condition)) {
                    this._createValueButton(condition, field).appendTo($item)
                }
            },
            _createFieldButtonWithMenu: function(fields, condition, field) {
                var _this4 = this;
                var that = this;
                var allowHierarchicalFields = this.option("allowHierarchicalFields");
                var items = (0, _utils2.getItems)(fields, allowHierarchicalFields);
                var item = (0, _utils2.getField)(field.name || field.dataField, items);
                var getFullCaption = function(item, items) {
                    return allowHierarchicalFields ? (0, _utils2.getCaptionWithParents)(item, items) : item.caption
                };
                var $fieldButton = this._createButtonWithMenu({
                    caption: getFullCaption(item, items),
                    menu: {
                        items: items,
                        dataStructure: "plain",
                        keyExpr: "id",
                        parentId: "parentId",
                        displayExpr: "caption",
                        onItemClick: function(e) {
                            if (item !== e.itemData) {
                                item = e.itemData;
                                condition[0] = item.name || item.dataField;
                                condition[2] = "object" === item.dataType ? null : "";
                                (0, _utils2.updateConditionByOperation)(condition, (0, _utils2.getDefaultOperation)(item), that._customOperations);
                                $fieldButton.siblings().filter("." + FILTER_BUILDER_ITEM_TEXT_CLASS).remove();
                                that._createOperationAndValueButtons(condition, item, $fieldButton.parent());
                                var caption = getFullCaption(item, e.component.option("items"));
                                $fieldButton.html(caption);
                                _this4._updateFilter()
                            }
                        },
                        onContentReady: function(e) {
                            e.component.selectItem(item)
                        },
                        cssClass: FILTER_BUILDER_FIELDS_CLASS
                    }
                }).addClass(FILTER_BUILDER_ITEM_TEXT_CLASS).addClass(FILTER_BUILDER_ITEM_FIELD_CLASS).attr("tabindex", 0);
                return $fieldButton
            },
            _createConditionItem: function(condition, parent) {
                var _this5 = this;
                var $item = (0, _renderer.default)("<div>").addClass(FILTER_BUILDER_GROUP_ITEM_CLASS);
                var fields = this._getNormalizedFields();
                var field = (0, _utils2.getField)(condition[0], fields);
                this._createRemoveButton(function() {
                    (0, _utils2.removeItem)(parent, condition);
                    var isSingleChild = 1 === $item.parent().children().length;
                    if (isSingleChild) {
                        $item.parent().remove()
                    } else {
                        $item.remove()
                    }
                    _this5._updateFilter()
                }).appendTo($item);
                this._createFieldButtonWithMenu(fields, condition, field).appendTo($item);
                this._createOperationAndValueButtons(condition, field, $item);
                return $item
            },
            _getGroupOperations: function(criteria) {
                var groupOperations = this.option("groupOperations");
                var groupOperationDescriptions = this.option("groupOperationDescriptions");
                if (!groupOperations || !groupOperations.length) {
                    groupOperations = [(0, _utils2.getGroupValue)(criteria).replace("!", "not")]
                }
                return groupOperations.map(function(operation) {
                    return {
                        text: groupOperationDescriptions[operation],
                        value: OPERATORS[operation]
                    }
                })
            },
            _createRemoveButton: function(handler) {
                var $removeButton = (0, _renderer.default)("<div>").addClass(FILTER_BUILDER_IMAGE_CLASS).addClass(FILTER_BUILDER_IMAGE_REMOVE_CLASS).addClass(FILTER_BUILDER_ACTION_CLASS).attr("tabindex", 0);
                this._subscribeOnClickAndEnterKey($removeButton, handler);
                return $removeButton
            },
            _createAddButton: function(addGroupHandler, addConditionHandler, groupLevel) {
                var $button;
                var maxGroupLevel = this.option("maxGroupLevel");
                if ((0, _type.isDefined)(maxGroupLevel) && groupLevel >= maxGroupLevel) {
                    $button = this._createButton();
                    this._subscribeOnClickAndEnterKey($button, addConditionHandler)
                } else {
                    $button = this._createButtonWithMenu({
                        menu: {
                            items: [{
                                caption: _message.default.format("dxFilterBuilder-addCondition"),
                                click: addConditionHandler
                            }, {
                                caption: _message.default.format("dxFilterBuilder-addGroup"),
                                click: addGroupHandler
                            }],
                            displayExpr: "caption",
                            onItemClick: function(e) {
                                e.itemData.click()
                            },
                            cssClass: FILTER_BUILDER_ADD_CONDITION_CLASS
                        }
                    })
                }
                return $button.addClass(FILTER_BUILDER_IMAGE_CLASS).addClass(FILTER_BUILDER_IMAGE_ADD_CLASS).addClass(FILTER_BUILDER_ACTION_CLASS).attr("tabindex", 0)
            },
            _createValueText: function(item, field, $container) {
                var that = this;
                var $text = (0, _renderer.default)("<div>").html("&nbsp;").addClass(FILTER_BUILDER_ITEM_VALUE_TEXT_CLASS).attr("tabindex", 0).appendTo($container);
                var value = item[2];
                var customOperation = (0, _utils2.getCustomOperation)(that._customOperations, item[1]);
                if (!customOperation && field.lookup) {
                    (0, _utils2.getCurrentLookupValueText)(field, value, function(result) {
                        (0, _utils2.renderValueText)($text, result)
                    })
                } else {
                    (0, _deferred.when)((0, _utils2.getCurrentValueText)(field, value, customOperation)).done(function(result) {
                        (0, _utils2.renderValueText)($text, result, customOperation)
                    })
                }
                that._subscribeOnClickAndEnterKey($text, function(e) {
                    if ("keyup" === e.type) {
                        e.stopPropagation()
                    }
                    that._createValueEditorWithEvents(item, field, $container)
                });
                return $text
            },
            _updateConditionValue: function(item, value, callback) {
                var areValuesDifferent = item[2] !== value;
                if (areValuesDifferent) {
                    item[2] = value
                }
                callback();
                this._updateFilter()
            },
            _addDocumentKeyUp: function($editor, handler) {
                var isComposing = false;
                var hasCompositionJustEnded = false;
                var document = _dom_adapter.default.getDocument();
                var documentKeyUpHandler = function(e) {
                    if (isComposing || hasCompositionJustEnded) {
                        hasCompositionJustEnded = false;
                        return
                    }
                    handler(e)
                };
                _events_engine.default.on(document, "keyup", documentKeyUpHandler);
                var input = $editor.find("input");
                _events_engine.default.on(input, "compositionstart", function() {
                    isComposing = true
                });
                _events_engine.default.on(input, "compositionend", function() {
                    isComposing = false;
                    hasCompositionJustEnded = true
                });
                _events_engine.default.on(input, "keydown", function(event) {
                    if (229 !== event.which) {
                        hasCompositionJustEnded = false
                    }
                });
                this._documentKeyUpHandler = documentKeyUpHandler
            },
            _addDocumentClick: function($editor, closeEditorFunc) {
                var _this6 = this;
                var document = _dom_adapter.default.getDocument();
                var documentClickHandler = function(e) {
                    if (!_this6._isFocusOnEditorParts($editor, e.target)) {
                        _events_engine.default.trigger($editor.find("input"), "change");
                        closeEditorFunc()
                    }
                };
                _events_engine.default.on(document, "dxpointerdown", documentClickHandler);
                this._documentClickHandler = documentClickHandler
            },
            _isFocusOnEditorParts: function($editor, target) {
                var activeElement = target || _dom_adapter.default.getActiveElement();
                return (0, _renderer.default)(activeElement).closest($editor.children()).length || (0, _renderer.default)(activeElement).closest(".dx-dropdowneditor-overlay").length
            },
            _removeEvents: function() {
                var document = _dom_adapter.default.getDocument();
                (0, _type.isDefined)(this._documentKeyUpHandler) && _events_engine.default.off(document, "keyup", this._documentKeyUpHandler);
                (0, _type.isDefined)(this._documentClickHandler) && _events_engine.default.off(document, "dxpointerdown", this._documentClickHandler)
            },
            _dispose: function() {
                this._removeEvents();
                this.callBase()
            },
            _createValueEditorWithEvents: function(item, field, $container) {
                var _this7 = this;
                var value = item[2];
                var createValueText = function() {
                    $container.empty();
                    _this7._removeEvents();
                    return _this7._createValueText(item, field, $container)
                };
                var closeEditor = function() {
                    _this7._updateConditionValue(item, value, function() {
                        createValueText()
                    })
                };
                var options = {
                    value: "" === value ? null : value,
                    filterOperation: (0, _utils2.getOperationValue)(item),
                    setValue: function(data) {
                        value = null === data ? "" : data
                    },
                    closeEditor: closeEditor,
                    text: $container.text()
                };
                $container.empty();
                var $editor = this._createValueEditor($container, field, options);
                _events_engine.default.trigger($editor.find("input").not(":hidden").eq(0), "focus");
                this._removeEvents();
                this._addDocumentClick($editor, closeEditor);
                this._addDocumentKeyUp($editor, function(e) {
                    var keyName = (0, _index.normalizeKeyName)(e);
                    if (keyName === TAB_KEY) {
                        if (_this7._isFocusOnEditorParts($editor)) {
                            return
                        }
                        _this7._updateConditionValue(item, value, function() {
                            createValueText();
                            if (e.shiftKey) {
                                _events_engine.default.trigger($container.prev(), "focus")
                            }
                        })
                    }
                    if (keyName === ESCAPE_KEY) {
                        _events_engine.default.trigger(createValueText(), "focus")
                    }
                    if (keyName === ENTER_KEY) {
                        _this7._updateConditionValue(item, value, function() {
                            _events_engine.default.trigger(createValueText(), "focus")
                        })
                    }
                });
                this._fireContentReadyAction()
            },
            _createValueButton: function(item, field) {
                var $valueButton = (0, _renderer.default)("<div>").addClass(FILTER_BUILDER_ITEM_TEXT_CLASS).addClass(FILTER_BUILDER_ITEM_VALUE_CLASS);
                this._createValueText(item, field, $valueButton);
                return $valueButton
            },
            _createValueEditor: function($container, field, options) {
                var $editor = (0, _renderer.default)("<div>").attr("tabindex", 0).appendTo($container);
                var customOperation = (0, _utils2.getCustomOperation)(this._customOperations, options.filterOperation);
                var editorTemplate = customOperation && customOperation.editorTemplate ? customOperation.editorTemplate : field.editorTemplate;
                if (editorTemplate) {
                    var template = this._getTemplate(editorTemplate);
                    template.render({
                        model: (0, _extend.extend)({
                            field: field
                        }, options),
                        container: $editor
                    })
                } else {
                    this._editorFactory.createEditor.call(this, $editor, (0, _extend.extend)({}, field, options, {
                        parentType: SOURCE
                    }))
                }
                return $editor
            },
            _createPopupWithTreeView: function(options, $container) {
                var that = this;
                var $popup = (0, _renderer.default)("<div>").addClass(options.menu.cssClass).appendTo($container);
                this._createComponent($popup, _popup.default, {
                    onHiding: options.menu.onHiding,
                    onHidden: options.menu.onHidden,
                    rtlEnabled: options.menu.rtlEnabled,
                    position: options.menu.position,
                    animation: options.menu.animation,
                    contentTemplate: function(contentElement) {
                        var $menuContainer = (0, _renderer.default)("<div>").appendTo(contentElement);
                        that._createComponent($menuContainer, _tree_view.default, options.menu);
                        this.repaint()
                    },
                    maxHeight: function() {
                        return (0, _utils.getElementMaxHeightByWindow)(options.menu.position.of)
                    },
                    visible: true,
                    focusStateEnabled: false,
                    closeOnTargetScroll: this.option("closePopupOnTargetScroll"),
                    closeOnOutsideClick: true,
                    onShown: options.popup.onShown,
                    shading: false,
                    width: "auto",
                    height: "auto",
                    showTitle: false
                })
            },
            _subscribeOnClickAndEnterKey: function($button, handler) {
                _events_engine.default.on($button, "dxclick", handler);
                _events_engine.default.on($button, "keyup", function(e) {
                    if ((0, _index.normalizeKeyName)(e) === ENTER_KEY) {
                        handler(e)
                    }
                })
            }
        });
        (0, _component_registrator.default)("dxFilterBuilder", FilterBuilder);
        var _default = FilterBuilder;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.filter_panel.js ***!
      \****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.filter_panel */ 412));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiData_grid.default.registerModule("filterPanel", _uiGrid_core.default)
    },
    /*!**********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.search.js ***!
      \**********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.search */ 413));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiData_grid.default.registerModule("search", _uiGrid_core.default)
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.pager.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.pager */ 414));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiData_grid.default.registerModule("pager", _uiGrid_core.default)
    },
    /*!**********************************************!*\
      !*** ./artifacts/transpiled-npm/ui/pager.js ***!
      \**********************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../events/core/events_engine */ 5));
        var _class = _interopRequireDefault(__webpack_require__( /*! ../core/class */ 15));
        var _string = __webpack_require__( /*! ../core/utils/string */ 43);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _click = __webpack_require__( /*! ../events/click */ 21);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../events/pointer */ 24));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../localization/message */ 10));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./widget/ui.widget */ 16));
        var _select_box = _interopRequireDefault(__webpack_require__( /*! ./select_box */ 117));
        var _number_box = _interopRequireDefault(__webpack_require__( /*! ./number_box */ 116));
        var _index = __webpack_require__( /*! ../events/utils/index */ 8);
        var _accessibility = __webpack_require__( /*! ./shared/accessibility */ 118);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var PAGES_LIMITER = 4;
        var PAGER_CLASS = "dx-pager";
        var PAGER_PAGE_CLASS = "dx-page";
        var PAGER_PAGE_CLASS_SELECTOR = "." + PAGER_PAGE_CLASS;
        var PAGER_PAGES_CLASS = "dx-pages";
        var LIGHT_MODE_CLASS = "dx-light-mode";
        var LIGHT_PAGES_CLASS = "dx-light-pages";
        var PAGER_PAGE_INDEX_CLASS = "dx-page-index";
        var PAGER_PAGES_COUNT_CLASS = "dx-pages-count";
        var PAGER_SELECTION_CLASS = "dx-selection";
        var PAGER_PAGE_SEPARATOR_CLASS = "dx-separator";
        var PAGER_PAGE_SIZES_CLASS = "dx-page-sizes";
        var PAGER_PAGE_SIZE_CLASS = "dx-page-size";
        var PAGER_PAGE_SIZE_CLASS_SELECTOR = "." + PAGER_PAGE_SIZE_CLASS;
        var PAGER_NAVIGATE_BUTTON = "dx-navigate-button";
        var PAGER_PREV_BUTTON_CLASS = "dx-prev-button";
        var PAGER_NEXT_BUTTON_CLASS = "dx-next-button";
        var PAGER_INFO_CLASS = "dx-info";
        var PAGER_INFO_TEXT_CLASS = "dx-info-text";
        var PAGER_BUTTON_DISABLE_CLASS = "dx-button-disable";
        var Page = _class.default.inherit({
            ctor: function(value, index) {
                var that = this;
                that.index = index;
                that._$page = (0, _renderer.default)("<div>").text(value).addClass(PAGER_PAGE_CLASS)
            },
            value: function(_value) {
                var that = this;
                if ((0, _type.isDefined)(_value)) {
                    that._$page.text(_value)
                } else {
                    var text = that._$page.text();
                    if ((0, _type.isNumeric)(text)) {
                        return parseInt(text)
                    } else {
                        return text
                    }
                }
            },
            element: function() {
                return this._$page
            },
            select: function(value) {
                this._$page.toggleClass(PAGER_SELECTION_CLASS, value)
            },
            render: function(rootElement, rtlEnabled) {
                rtlEnabled ? this._$page.prependTo(rootElement) : this._$page.appendTo(rootElement)
            }
        });
        var Pager = _ui.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    visible: true,
                    pagesNavigatorVisible: "auto",
                    pageIndex: 1,
                    maxPagesCount: 10,
                    pageCount: 10,
                    totalCount: 0,
                    pageSize: 5,
                    showPageSizes: true,
                    pageSizes: [5, 10],
                    hasKnownLastPage: true,
                    showNavigationButtons: false,
                    showInfo: false,
                    infoText: _message.default.getFormatter("dxPager-infoText"),
                    pagesCountText: _message.default.getFormatter("dxPager-pagesCountText"),
                    rtlEnabled: false,
                    lightModeEnabled: false,
                    pageIndexChanged: _common.noop,
                    pageSizeChanged: _common.noop
                })
            },
            _toggleVisibility: function(value) {
                var $element = this.$element();
                if ($element) {
                    $element.css("display", value ? "" : "none")
                }
            },
            _getPages: function(currentPage, count) {
                var pages = [];
                var showMoreButton = !this.option("hasKnownLastPage");
                var firstValue;
                var i;
                if (count > 0 || showMoreButton) {
                    if (count <= this.option("maxPagesCount")) {
                        for (i = 1; i <= count; i++) {
                            pages.push(new Page(i, i - 1))
                        }
                        if (showMoreButton) {
                            pages.push(new Page(">", i - 1))
                        }
                    } else {
                        pages.push(new Page(1, 0));
                        firstValue = currentPage ? currentPage.value() - currentPage.index : 1;
                        var pagesCount = count === firstValue + PAGES_LIMITER ? PAGES_LIMITER - 1 : PAGES_LIMITER;
                        for (i = 1; i <= pagesCount; i++) {
                            pages.push(new Page(firstValue + i, i))
                        }
                        pages.push(new Page(count, PAGES_LIMITER + 1));
                        if (showMoreButton) {
                            pages.push(new Page(">", PAGES_LIMITER + 1))
                        }
                    }
                }
                return pages
            },
            _getPageByValue: function(value) {
                var that = this;
                var page;
                var i;
                for (i = 0; i < that._pages.length; i++) {
                    page = that._pages[i];
                    if (page.value() === value) {
                        return page
                    }
                }
            },
            _processSelectedPage: function(maxPagesCount, pageIndex, pageCount) {
                var that = this;
                var isPageIndexValid = false;
                var selectedPageIndex;
                if (that._pages) {
                    (0, _iterator.each)(that._pages, function(key, page) {
                        if (pageIndex === page.value()) {
                            isPageIndexValid = true
                        }
                    });
                    if (!isPageIndexValid) {
                        that.selectedPage = null
                    }
                }
                if ((0, _type.isDefined)(that.selectedPage)) {
                    if (pageIndex === pageCount && pageCount > maxPagesCount && that.selectedPage.index !== PAGES_LIMITER + 1) {
                        that.selectedPage.index = PAGES_LIMITER + 1
                    }
                } else {
                    if (pageIndex > PAGES_LIMITER && pageIndex < pageCount) {
                        selectedPageIndex = pageCount - PAGES_LIMITER < pageIndex ? PAGES_LIMITER - (pageCount - pageIndex) + 1 : 2;
                        that.selectedPage = new Page(pageIndex, selectedPageIndex)
                    }
                }
            },
            _selectPageByValue: function(value) {
                var that = this;
                var i;
                var page = that._getPageByValue(value);
                var pages = that._pages;
                var pagesLength = pages.length;
                var nextPage;
                var morePage;
                if (!(0, _type.isDefined)(page)) {
                    return
                }
                var prevPage = that._pages[page.index - 1];
                nextPage = that._pages[page.index + 1];
                if (nextPage && ">" === nextPage.value()) {
                    morePage = nextPage;
                    nextPage = void 0;
                    pagesLength--;
                    pages.pop()
                }
                if (that.selectedPage) {
                    that.selectedPage.select(false)
                }
                page.select(true);
                that.selectedPage = page;
                if (nextPage && nextPage.value() - value > 1) {
                    if (0 !== page.index) {
                        prevPage.value(value + 1);
                        that._pages.splice(page.index, 1);
                        that._pages.splice(page.index - 1, 0, page);
                        that._pages[page.index].index = page.index;
                        page.index = page.index - 1;
                        for (i = page.index - 1; i > 0; i--) {
                            that._pages[i].value(that._pages[i + 1].value() - 1)
                        }
                    } else {
                        for (i = 0; i < pagesLength - 1; i++) {
                            that._pages[i].value(i + 1)
                        }
                    }
                }
                if (prevPage && value - prevPage.value() > 1) {
                    if (page.index !== pagesLength - 1) {
                        nextPage.value(value - 1);
                        that._pages.splice(page.index, 1);
                        that._pages.splice(page.index + 1, 0, page);
                        that._pages[page.index].index = page.index;
                        page.index = page.index + 1;
                        for (i = page.index + 1; i < pagesLength - 1; i++) {
                            that._pages[i].value(that._pages[i - 1].value() + 1)
                        }
                    } else {
                        for (i = 1; i <= pagesLength - 2; i++) {
                            that._pages[pagesLength - 1 - i].value(that._pages[pagesLength - 1].value() - i)
                        }
                    }
                }
                if (morePage) {
                    pages.push(morePage)
                }
            },
            _updatePagesTabIndices: function() {
                var _this = this;
                var $selectedPage = this.selectedPage._$page;
                var updatePageIndices = function updatePageIndices() {
                    var buttons = (0, _renderer.default)(_this.element()).find("[role=button]:not(.dx-button-disable)");
                    (0, _iterator.each)(buttons, function(_, element) {
                        return (0, _renderer.default)(element).attr("tabindex", 0)
                    });
                    _events_engine.default.off($selectedPage, "focus", updatePageIndices)
                };
                _events_engine.default.on($selectedPage, "focus", updatePageIndices)
            },
            _nextPage: function(direction) {
                var pageIndex = this.option("pageIndex");
                var pageCount = this.option("pageCount");
                if ((0, _type.isDefined)(pageIndex)) {
                    pageIndex = "next" === direction ? ++pageIndex : --pageIndex;
                    if (pageIndex > 0 && pageIndex <= pageCount) {
                        this.option("pageIndex", pageIndex)
                    }
                }
            },
            _wrapClickAction: function(action) {
                var _this2 = this;
                return function(e) {
                    if ("dxpointerup" === e.type) {
                        _this2._pointerUpHappened = true
                    } else {
                        if (_this2._pointerUpHappened) {
                            _this2._pointerUpHappened = false;
                            return
                        }
                    }
                    action({
                        event: e
                    })
                }
            },
            _renderPages: function(pages) {
                var that = this;
                var $separator;
                var pagesLength = pages.length;
                var clickPagesIndexAction = that._createAction(function(args) {
                    var e = args.event;
                    var pageNumber = (0, _renderer.default)(e.target).text();
                    var pageIndex = ">" === pageNumber ? that.option("pageCount") + 1 : Number(pageNumber);
                    that.option("pageIndex", pageIndex)
                });
                var page;
                if (pagesLength > 1) {
                    that._pageClickHandler = this._wrapClickAction(clickPagesIndexAction);
                    _events_engine.default.on(that._$pagesChooser, (0, _index.addNamespace)([_pointer.default.up, _click.name], that.Name + "Pages"), PAGER_PAGE_CLASS_SELECTOR, that._pageClickHandler);
                    (0, _accessibility.registerKeyboardAction)("pager", that, that._$pagesChooser, PAGER_PAGE_CLASS_SELECTOR, clickPagesIndexAction)
                }
                for (var i = 0; i < pagesLength; i++) {
                    page = pages[i];
                    page.render(that._$pagesChooser, that.option("rtlEnabled"));
                    that.setAria({
                        role: "button",
                        label: "Page " + page.value()
                    }, page.element());
                    (0, _accessibility.setTabIndex)(that, page.element());
                    if (pages[i + 1] && pages[i + 1].value() - page.value() > 1) {
                        $separator = (0, _renderer.default)("<div>").text(". . .").addClass(PAGER_PAGE_SEPARATOR_CLASS);
                        that.option("rtlEnabled") ? $separator.prependTo(that._$pagesChooser) : $separator.appendTo(that._$pagesChooser)
                    }
                }
            },
            _calculateLightPagesWidth: function($pageIndex, pageCount) {
                return Number($pageIndex.css("minWidth").replace("px", "")) + 10 * pageCount.toString().length
            },
            _renderLightPages: function() {
                var that = this;
                var pageCount = this.option("pageCount");
                var pageIndex = this.option("pageIndex");
                var clickAction = that._createAction(function() {
                    that.option("pageIndex", pageCount)
                });
                var pagesCountText = this.option("pagesCountText");
                var $container = (0, _renderer.default)("<div>").addClass(LIGHT_PAGES_CLASS).appendTo(this._$pagesChooser);
                var $pageIndex = (0, _renderer.default)("<div>").addClass(PAGER_PAGE_INDEX_CLASS).appendTo($container);
                that._pageIndexEditor = that._createComponent($pageIndex, _number_box.default, {
                    value: pageIndex,
                    min: 1,
                    max: pageCount,
                    width: that._calculateLightPagesWidth($pageIndex, pageCount),
                    onValueChanged: function(e) {
                        if (null === e.value) {
                            return
                        }
                        that.option("pageIndex", e.value)
                    }
                });
                (0, _renderer.default)("<span>").text(pagesCountText).addClass(PAGER_INFO_TEXT_CLASS + " " + PAGER_INFO_CLASS).appendTo($container);
                var $pageCount = (0, _renderer.default)("<span>").addClass(PAGER_PAGES_COUNT_CLASS).text(pageCount);
                _events_engine.default.on($pageCount, (0, _index.addNamespace)(_click.name, that.Name + "PagesCount"), function(e) {
                    clickAction({
                        event: e
                    })
                });
                (0, _accessibility.registerKeyboardAction)("pager", that, $pageCount, void 0, clickAction);
                $pageCount.appendTo($container);
                that.setAria({
                    role: "button",
                    label: "Navigates to the last page"
                }, $pageCount)
            },
            _renderPagesChooser: function() {
                var that = this;
                var lightModeEnabled = that.option("lightModeEnabled");
                var pagesNavigatorVisible = that.option("pagesNavigatorVisible");
                var $element = that.$element();
                that._$pagesChooser && that._$pagesChooser.remove();
                if (!pagesNavigatorVisible) {
                    return
                }
                if (that._pages && 0 === that._pages.length) {
                    that.selectedPage = null;
                    return
                }
                that._$pagesChooser = (0, _renderer.default)("<div>").addClass(PAGER_PAGES_CLASS).appendTo($element);
                if ("auto" === pagesNavigatorVisible) {
                    that._$pagesChooser.css("visibility", 1 === that.option("pageCount") ? "hidden" : "")
                }
                if (!lightModeEnabled) {
                    that._renderInfo()
                }
                that._renderNavigateButton("prev");
                if (lightModeEnabled) {
                    that._renderLightPages()
                } else {
                    that._renderPages(that._pages)
                }
                that._renderNavigateButton("next");
                that._updatePagesChooserWidth()
            },
            _renderPageSizes: function() {
                var that = this;
                var i;
                var pageSizes = that.option("pageSizes");
                var pagesSizesLength = pageSizes && pageSizes.length;
                var pageSizeValue;
                var currentPageSize = that.option("pageSize");
                var $pageSize;
                var clickPagesSizeAction = that._createAction(function(args) {
                    var e = args.event;
                    pageSizeValue = parseInt((0, _renderer.default)(e.target).text());
                    that.option("pageSize", pageSizeValue)
                });
                _events_engine.default.on(that._$pagesSizeChooser, (0, _index.addNamespace)(_click.name, that.Name + "PageSize"), PAGER_PAGE_SIZE_CLASS_SELECTOR, function(e) {
                    clickPagesSizeAction({
                        event: e
                    })
                });
                (0, _accessibility.registerKeyboardAction)("pager", that, that._$pagesSizeChooser, PAGER_PAGE_SIZE_CLASS_SELECTOR, clickPagesSizeAction);
                for (i = 0; i < pagesSizesLength; i++) {
                    $pageSize = (0, _renderer.default)("<div>").text(pageSizes[i]).addClass(PAGER_PAGE_SIZE_CLASS);
                    that.setAria({
                        role: "button",
                        label: "Display " + pageSizes[i] + " items on page"
                    }, $pageSize);
                    (0, _accessibility.setTabIndex)(that, $pageSize);
                    if (currentPageSize === pageSizes[i]) {
                        $pageSize.addClass(PAGER_SELECTION_CLASS)
                    }
                    that._$pagesSizeChooser.append($pageSize)
                }
            },
            _calculateLightPageSizesWidth: function(pageSizes) {
                return Number(this._$pagesSizeChooser.css("minWidth").replace("px", "")) + 10 * Math.max.apply(Math, pageSizes).toString().length
            },
            _renderLightPageSizes: function() {
                var that = this;
                var pageSizes = that.option("pageSizes");
                var $editor = (0, _renderer.default)("<div>").appendTo(that._$pagesSizeChooser);
                that._pageSizeEditor = that._createComponent($editor, _select_box.default, {
                    dataSource: pageSizes,
                    value: that.option("pageSize"),
                    onSelectionChanged: function(e) {
                        that.option("pageSize", e.selectedItem)
                    },
                    width: that._calculateLightPageSizesWidth(pageSizes)
                })
            },
            _renderPagesSizeChooser: function() {
                var that = this;
                var pageSizes = that.option("pageSizes");
                var showPageSizes = that.option("showPageSizes");
                var pagesSizesLength = pageSizes && pageSizes.length;
                var $element = that.$element();
                that._$pagesSizeChooser && that._$pagesSizeChooser.remove();
                if (!showPageSizes || !pagesSizesLength) {
                    return
                }
                that._$pagesSizeChooser = (0, _renderer.default)("<div>").addClass(PAGER_PAGE_SIZES_CLASS).appendTo($element);
                if (that.option("lightModeEnabled")) {
                    that._renderLightPageSizes()
                } else {
                    that._renderPageSizes()
                }
                that._pagesSizeChooserWidth = that._$pagesSizeChooser.width()
            },
            _renderInfo: function() {
                var infoText = this.option("infoText");
                if (this.option("showInfo") && (0, _type.isDefined)(infoText)) {
                    this._$info = (0, _renderer.default)("<div>").css("display", this._isInfoHide ? "none" : "").addClass(PAGER_INFO_CLASS).text((0, _string.format)(infoText, this.selectedPage && this.selectedPage.value(), this.option("pageCount"), this.option("totalCount"))).appendTo(this._$pagesChooser);
                    if (!this._isInfoHide) {
                        this._infoWidth = this._$info.outerWidth(true)
                    }
                }
            },
            _renderNavigateButton: function(direction) {
                var that = this;
                var clickAction = that._createAction(function() {
                    that._nextPage(direction)
                });
                var $button;
                if (that.option("showNavigationButtons") || that.option("lightModeEnabled")) {
                    $button = (0, _renderer.default)("<div>").addClass(PAGER_NAVIGATE_BUTTON);
                    _events_engine.default.on($button, (0, _index.addNamespace)([_pointer.default.up, _click.name], that.Name + "Pages"), that._wrapClickAction(clickAction));
                    (0, _accessibility.registerKeyboardAction)("pager", that, $button, void 0, clickAction);
                    that.setAria({
                        role: "button",
                        label: "prev" === direction ? "Previous page" : " Next page"
                    }, $button);
                    (0, _accessibility.setTabIndex)(that, $button);
                    if (that.option("rtlEnabled")) {
                        $button.addClass("prev" === direction ? PAGER_NEXT_BUTTON_CLASS : PAGER_PREV_BUTTON_CLASS);
                        $button.prependTo(this._$pagesChooser)
                    } else {
                        $button.addClass("prev" === direction ? PAGER_PREV_BUTTON_CLASS : PAGER_NEXT_BUTTON_CLASS);
                        $button.appendTo(this._$pagesChooser)
                    }
                }
            },
            _renderContentImpl: function() {
                this.$element().toggleClass(LIGHT_MODE_CLASS, this.option("lightModeEnabled"));
                this._toggleVisibility(this.option("visible"));
                this._updatePageSizes(true);
                this._updatePages(true);
                (0, _accessibility.restoreFocus)(this)
            },
            _initMarkup: function() {
                var $element = this.$element();
                $element.addClass(PAGER_CLASS);
                var $pageSize = (0, _renderer.default)("<div>").addClass(PAGER_PAGE_CLASS);
                this._$pagesChooser = (0, _renderer.default)("<div>").addClass(PAGER_PAGES_CLASS).append($pageSize).appendTo($element)
            },
            _render: function() {
                this.option().lightModeEnabled = false;
                this.callBase();
                this._updateLightMode()
            },
            _updatePageSizes: function(forceRender) {
                var lightModeEnabled = this.option("lightModeEnabled");
                var pageSize = this.option("pageSize");
                var pageSizes = this.option("pageSizes");
                if (lightModeEnabled) {
                    this._pageSizeEditor && this._pageSizeEditor.option({
                        value: pageSize,
                        dataSource: pageSizes,
                        width: this._calculateLightPageSizesWidth(pageSizes)
                    })
                }
                if (!lightModeEnabled || forceRender) {
                    this._renderPagesSizeChooser()
                }
            },
            _updatePages: function(forceRender) {
                var pageCount = this.option("pageCount");
                var pageIndex = this.option("pageIndex");
                var lightModeEnabled = this.option("lightModeEnabled");
                if (!lightModeEnabled) {
                    this._processSelectedPage(this.option("maxPagesCount"), pageIndex, pageCount);
                    this._pages = this._getPages(this.selectedPage, pageCount);
                    this._selectPageByValue(pageIndex)
                } else {
                    this._pageIndexEditor && this._pageIndexEditor.option({
                        value: pageIndex,
                        width: this._calculateLightPagesWidth(this._pageIndexEditor.$element(), pageCount)
                    })
                }
                if (!lightModeEnabled || forceRender) {
                    this._renderPagesChooser()
                }
                this._updateButtonsState(pageIndex)
            },
            _isPageIndexInvalid: function(direction, pageIndex) {
                var isNextDirection = "next" === direction;
                var rtlEnabled = this.option("rtlEnabled");
                if (rtlEnabled && isNextDirection || !rtlEnabled && !isNextDirection) {
                    return pageIndex <= 1
                }
                return pageIndex >= this.option("pageCount")
            },
            _updateButtonsState: function(pageIndex) {
                var nextButton = this.$element().find("." + PAGER_NEXT_BUTTON_CLASS);
                var prevButton = this.$element().find("." + PAGER_PREV_BUTTON_CLASS);
                nextButton.toggleClass(PAGER_BUTTON_DISABLE_CLASS, this._isPageIndexInvalid("next", pageIndex));
                prevButton.toggleClass(PAGER_BUTTON_DISABLE_CLASS, this._isPageIndexInvalid("prev", pageIndex))
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "visible":
                        this._toggleVisibility(args.value);
                        break;
                    case "pageIndex":
                        var pageIndexChanged = this.option("pageIndexChanged");
                        if (pageIndexChanged) {
                            pageIndexChanged(args.value)
                        }
                        this._updatePages();
                        break;
                    case "maxPagesCount":
                    case "pageCount":
                    case "totalCount":
                    case "hasKnownLastPage":
                    case "pagesNavigatorVisible":
                    case "showNavigationButtons":
                        this._updatePages();
                        break;
                    case "pageSize":
                        var pageSizeChanged = this.option("pageSizeChanged");
                        if (pageSizeChanged) {
                            pageSizeChanged(args.value)
                        }
                        this._updatePageSizes();
                        break;
                    case "pageSizes":
                        this._updatePageSizes();
                        break;
                    case "lightModeEnabled":
                        this._renderContentImpl();
                        !args.value && this._updateLightMode();
                        break;
                    default:
                        this._invalidate()
                }
            },
            _clean: function() {
                if (this._$pagesChooser) {
                    _events_engine.default.off(this._$pagesChooser, (0, _index.addNamespace)([_pointer.default.up, _click.name], this.Name + "Pages"), PAGER_PAGE_CLASS_SELECTOR, this._pageClickHandler);
                    (0, _accessibility.registerKeyboardAction)("pager", this, this._$pagesChooser, PAGER_PAGE_CLASS_SELECTOR, this._pageKeyDownHandler)
                }
                this.callBase()
            },
            _getMinPagerWidth: function() {
                var pagesChooserWidth = (0, _type.isDefined)(this._pagesChooserWidth) ? this._pagesChooserWidth : 0;
                var pagesSizeChooserWidth = (0, _type.isDefined)(this._pagesSizeChooserWidth) ? this._pagesSizeChooserWidth : 0;
                return pagesChooserWidth + pagesSizeChooserWidth
            },
            _updatePagesChooserWidth: (0, _common.deferUpdater)(function() {
                var lastPageWidth = this._pages && this._pages.length > 0 ? this._pages[this._pages.length - 1]._$page.width() : 0;
                this._pagesChooserWidth = this._$pagesChooser.width() + lastPageWidth
            }),
            _updateLightMode: (0, _common.deferUpdater)(function() {
                var that = this;
                var width = this.$element().width();
                var infoWidth = (0, _type.isDefined)(this._infoWidth) ? this._infoWidth : 0;
                (0, _common.deferRender)(function() {
                    if (that._isInfoHide && width > that._getMinPagerWidth() + infoWidth) {
                        that._$info.css("display", "");
                        that._updatePagesChooserWidth();
                        that._isInfoHide = false
                    }
                    if (!that._isInfoHide && width > that._getMinPagerWidth() - infoWidth && width < that._getMinPagerWidth()) {
                        that._$info.css("display", "none");
                        that._updatePagesChooserWidth();
                        that._isInfoHide = true
                    }(0, _common.deferUpdate)(function() {
                        (0, _common.deferRender)(function() {
                            if (that.option("lightModeEnabled") && width > that._previousWidth) {
                                that.option("lightModeEnabled", false)
                            } else {
                                if (width < that._getMinPagerWidth()) {
                                    that.option("lightModeEnabled", true)
                                }
                            }
                            that._previousWidth = width
                        })
                    })
                })
            }),
            _dimensionChanged: function() {
                this._updateLightMode()
            },
            getHeight: function() {
                return this.option("visible") ? this.$element().outerHeight() : 0
            }
        });
        var _default = Pager;
        exports.default = _default;
        (0, _component_registrator.default)("dxPager", Pager);
        module.exports = exports.default
    },
    /*!*******************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.columns_resizing_reordering.js ***!
      \*******************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.TrackerView = exports.ColumnsResizerViewController = exports.TablePositionViewController = exports.ColumnsSeparatorView = exports.DraggingHeaderViewController = exports.DraggingHeaderView = void 0;
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.columns_resizing_reordering */ 415));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DraggingHeaderView = _uiGrid_core.default.views.draggingHeaderView;
        exports.DraggingHeaderView = DraggingHeaderView;
        var DraggingHeaderViewController = _uiGrid_core.default.controllers.draggingHeader;
        exports.DraggingHeaderViewController = DraggingHeaderViewController;
        var ColumnsSeparatorView = _uiGrid_core.default.views.columnsSeparatorView;
        exports.ColumnsSeparatorView = ColumnsSeparatorView;
        var TablePositionViewController = _uiGrid_core.default.controllers.tablePosition;
        exports.TablePositionViewController = TablePositionViewController;
        var ColumnsResizerViewController = _uiGrid_core.default.controllers.columnsResizer;
        exports.ColumnsResizerViewController = ColumnsResizerViewController;
        var TrackerView = _uiGrid_core.default.views.trackerView;
        exports.TrackerView = TrackerView;
        _uiData_grid.default.registerModule("columnsResizingReordering", _uiGrid_core.default)
    },
    /*!***********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.keyboard_navigation.js ***!
      \***********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.keyboard_navigation */ 416));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiData_grid.default.registerModule("keyboardNavigation", _uiGrid_core.default)
    },
    /*!***********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.summary.js ***!
      \***********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.FooterView = exports.renderSummaryCell = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _data = __webpack_require__( /*! ../../core/utils/data */ 20);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _uiData_grid2 = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.data_source_adapter */ 218));
        var _uiGrid_core = __webpack_require__( /*! ../grid_core/ui.grid_core.columns_view */ 183);
        var _aggregate_calculator = _interopRequireDefault(__webpack_require__( /*! ./aggregate_calculator */ 729));
        var _query = _interopRequireDefault(__webpack_require__( /*! ../../data/query */ 48));
        var _store_helper = _interopRequireDefault(__webpack_require__( /*! ../../data/store_helper */ 94));
        var _utils = _interopRequireDefault(__webpack_require__( /*! ../../data/utils */ 41));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DATAGRID_TOTAL_FOOTER_CLASS = "dx-datagrid-total-footer";
        var DATAGRID_SUMMARY_ITEM_CLASS = "dx-datagrid-summary-item";
        var DATAGRID_TEXT_CONTENT_CLASS = "dx-datagrid-text-content";
        var DATAGRID_GROUP_FOOTER_CLASS = "dx-datagrid-group-footer";
        var DATAGRID_GROUP_TEXT_CONTENT_CLASS = "dx-datagrid-group-text-content";
        var DATAGRID_NOWRAP_CLASS = "dx-datagrid-nowrap";
        var DATAGRID_GROUP_FOOTER_ROW_TYPE = "groupFooter";
        var renderSummaryCell = function(cell, options) {
            var $cell = (0, _renderer.default)(cell);
            var column = options.column;
            var summaryItems = options.summaryItems;
            var $summaryItems = [];
            if (!column.command && summaryItems) {
                for (var i = 0; i < summaryItems.length; i++) {
                    var summaryItem = summaryItems[i];
                    $summaryItems.push((0, _renderer.default)("<div>").css("textAlign", summaryItem.alignment || column.alignment).addClass(DATAGRID_SUMMARY_ITEM_CLASS).addClass(DATAGRID_TEXT_CONTENT_CLASS).addClass(summaryItem.cssClass).toggleClass(DATAGRID_GROUP_TEXT_CONTENT_CLASS, "group" === options.rowType).text(_uiData_grid.default.getSummaryText(summaryItem, options.summaryTexts)))
                }
                $cell.append($summaryItems)
            }
        };
        exports.renderSummaryCell = renderSummaryCell;
        var getSummaryCellOptions = function(that, options) {
            var summaryTexts = that.option("summary.texts") || {};
            return {
                totalItem: options.row,
                summaryItems: options.row.summaryCells[options.columnIndex],
                summaryTexts: summaryTexts
            }
        };
        var getGroupAggregates = function(data) {
            return data.summary || data.aggregates || []
        };
        var recalculateWhileEditing = function(that) {
            return that.option("summary.recalculateWhileEditing")
        };
        var FooterView = _uiGrid_core.ColumnsView.inherit(function() {
            return {
                _getRows: function() {
                    return this._dataController.footerItems()
                },
                _getCellOptions: function(options) {
                    return (0, _extend.extend)(this.callBase(options), getSummaryCellOptions(this, options))
                },
                _renderCellContent: function($cell, options) {
                    renderSummaryCell($cell, options);
                    this.callBase($cell, options)
                },
                _renderCore: function(change) {
                    var totalItem = this._dataController.footerItems()[0];
                    if (!change || !change.columnIndices) {
                        this.element().empty().addClass(DATAGRID_TOTAL_FOOTER_CLASS).toggleClass(DATAGRID_NOWRAP_CLASS, !this.option("wordWrapEnabled"))
                    }
                    if (totalItem && totalItem.summaryCells && totalItem.summaryCells.length) {
                        this._updateContent(this._renderTable({
                            change: change
                        }), change)
                    }
                },
                _updateContent: function($newTable, change) {
                    if (change && "update" === change.changeType && change.columnIndices) {
                        var $row = this.getTableElement().find(".dx-row");
                        var $newRow = $newTable.find(".dx-row");
                        this._updateCells($row, $newRow, change.columnIndices[0])
                    } else {
                        return this.callBase.apply(this, arguments)
                    }
                },
                _rowClick: function(e) {
                    var item = this._dataController.footerItems()[e.rowIndex] || {};
                    this.executeAction("onRowClick", (0, _extend.extend)({}, e, item))
                },
                _columnOptionChanged: function(e) {
                    var optionNames = e.optionNames;
                    if (e.changeTypes.grouping) {
                        return
                    }
                    if (optionNames.width || optionNames.visibleWidth) {
                        this.callBase(e)
                    }
                },
                _handleDataChanged: function(e) {
                    var changeType = e.changeType;
                    if ("update" === e.changeType && e.repaintChangesOnly) {
                        if (!e.totalColumnIndices) {
                            this.render()
                        } else {
                            if (e.totalColumnIndices.length) {
                                this.render(null, {
                                    changeType: "update",
                                    columnIndices: [e.totalColumnIndices]
                                })
                            }
                        }
                    } else {
                        if ("refresh" === changeType || "append" === changeType || "prepend" === changeType) {
                            this.render()
                        }
                    }
                },
                getHeight: function() {
                    return this.getElementHeight()
                },
                isVisible: function() {
                    return !!this._dataController.footerItems().length
                }
            }
        }());
        exports.FooterView = FooterView;
        var SummaryDataSourceAdapterExtender = function() {
            function forEachGroup(groups, groupCount, callback, path) {
                path = path || [];
                for (var i = 0; i < groups.length; i++) {
                    path.push(groups[i].key);
                    if (1 === groupCount) {
                        callback(path, groups[i].items)
                    } else {
                        forEachGroup(groups[i].items, groupCount - 1, callback, path)
                    }
                    path.pop()
                }
            }
            return {
                init: function() {
                    this.callBase.apply(this, arguments);
                    this._totalAggregates = [];
                    this._summaryGetter = _common.noop
                },
                summaryGetter: function(_summaryGetter) {
                    if (!arguments.length) {
                        return this._summaryGetter
                    }
                    if ((0, _type.isFunction)(_summaryGetter)) {
                        this._summaryGetter = _summaryGetter
                    }
                },
                summary: function(_summary) {
                    if (!arguments.length) {
                        return this._summaryGetter()
                    }
                    this._summaryGetter = function() {
                        return _summary
                    }
                },
                totalAggregates: function() {
                    return this._totalAggregates
                },
                isLastLevelGroupItemsPagingLocal: function() {
                    var summary = this.summary();
                    var sortByGroupsInfo = summary && summary.sortByGroups();
                    return sortByGroupsInfo && sortByGroupsInfo.length
                },
                sortLastLevelGroupItems: function(items, groups, paths) {
                    var groupedItems = _store_helper.default.multiLevelGroup((0, _query.default)(items), groups).toArray();
                    var result = [];
                    paths.forEach(function(path) {
                        forEachGroup(groupedItems, groups.length, function(itemsPath, items) {
                            if (path.toString() === itemsPath.toString()) {
                                result = result.concat(items)
                            }
                        })
                    });
                    return result
                }
            }
        }();
        var SummaryDataSourceAdapterClientExtender = function() {
            var applyAddedData = function applyAddedData(data, insertedData, groupLevel) {
                if (groupLevel) {
                    return applyAddedData(data, insertedData.map(function(item) {
                        return {
                            items: [item]
                        }
                    }, groupLevel - 1))
                }
                return data.concat(insertedData)
            };
            var applyRemovedData = function applyRemovedData(data, removedData, groupLevel) {
                if (groupLevel) {
                    return data.map(function(data) {
                        var updatedData = {};
                        var updatedItems = applyRemovedData(data.items || [], removedData, groupLevel - 1);
                        Object.defineProperty(updatedData, "aggregates", {
                            get: function() {
                                return data.aggregates
                            },
                            set: function(value) {
                                data.aggregates = value
                            }
                        });
                        return (0, _extend.extend)(updatedData, data, {
                            items: updatedItems
                        })
                    })
                }
                return data.filter(function(data) {
                    return removedData.indexOf(data) < 0
                })
            };
            var calculateAggregates = function(that, summary, data, groupLevel) {
                var calculator;
                if (recalculateWhileEditing(that)) {
                    var editingController = that.getController("editing");
                    if (editingController) {
                        var insertedData = editingController.getInsertedData();
                        if (insertedData.length) {
                            data = applyAddedData(data, insertedData, groupLevel)
                        }
                        var removedData = editingController.getRemovedData();
                        if (removedData.length) {
                            data = applyRemovedData(data, removedData, groupLevel)
                        }
                    }
                }
                if (summary) {
                    calculator = new _aggregate_calculator.default({
                        totalAggregates: summary.totalAggregates,
                        groupAggregates: summary.groupAggregates,
                        data: data,
                        groupLevel: groupLevel
                    });
                    calculator.calculate()
                }
                return calculator ? calculator.totalAggregates() : []
            };
            var sortGroupsBySummaryCore = function sortGroupsBySummaryCore(items, groups, sortByGroups) {
                if (!items || !groups.length) {
                    return items
                }
                var group = groups[0];
                var sorts = sortByGroups[0];
                var query;
                if (group && sorts && sorts.length) {
                    query = (0, _query.default)(items);
                    (0, _iterator.each)(sorts, function(index) {
                        if (0 === index) {
                            query = query.sortBy(this.selector, this.desc)
                        } else {
                            query = query.thenBy(this.selector, this.desc)
                        }
                    });
                    query.enumerate().done(function(sortedItems) {
                        items = sortedItems
                    })
                }
                groups = groups.slice(1);
                sortByGroups = sortByGroups.slice(1);
                if (groups.length && sortByGroups.length) {
                    (0, _iterator.each)(items, function() {
                        this.items = sortGroupsBySummaryCore(this.items, groups, sortByGroups)
                    })
                }
                return items
            };
            var sortGroupsBySummary = function(data, group, summary) {
                var sortByGroups = summary && summary.sortByGroups && summary.sortByGroups();
                if (sortByGroups && sortByGroups.length) {
                    return sortGroupsBySummaryCore(data, group, sortByGroups)
                }
                return data
            };
            return {
                _customizeRemoteOperations: function(options) {
                    var summary = this.summary();
                    if (summary) {
                        if (options.remoteOperations.summary) {
                            if (!options.isCustomLoading || options.storeLoadOptions.isLoadingAll) {
                                if (options.storeLoadOptions.group) {
                                    if (options.remoteOperations.grouping) {
                                        options.storeLoadOptions.groupSummary = summary.groupAggregates
                                    } else {
                                        if (summary.groupAggregates.length) {
                                            options.remoteOperations.paging = false
                                        }
                                    }
                                }
                                options.storeLoadOptions.totalSummary = summary.totalAggregates
                            }
                        } else {
                            if (summary.totalAggregates.length || summary.groupAggregates.length && options.storeLoadOptions.group) {
                                options.remoteOperations.paging = false
                            }
                        }
                    }
                    this.callBase.apply(this, arguments);
                    var cachedExtra = options.cachedPagesData.extra;
                    if (cachedExtra && cachedExtra.summary && !options.isCustomLoading) {
                        options.storeLoadOptions.totalSummary = void 0
                    }
                },
                _handleDataLoadedCore: function(options) {
                    var that = this;
                    var groups = _utils.default.normalizeSortingInfo(options.storeLoadOptions.group || options.loadOptions.group || []);
                    var remoteOperations = options.remoteOperations || {};
                    var summary = that.summaryGetter()(remoteOperations);
                    var totalAggregates;
                    if (!options.isCustomLoading || options.storeLoadOptions.isLoadingAll) {
                        if (remoteOperations.summary) {
                            if (!remoteOperations.paging && groups.length && summary) {
                                if (!remoteOperations.grouping) {
                                    calculateAggregates(that, {
                                        groupAggregates: summary.groupAggregates
                                    }, options.data, groups.length)
                                }
                                options.data = sortGroupsBySummary(options.data, groups, summary)
                            }
                        } else {
                            if (!remoteOperations.paging) {
                                totalAggregates = calculateAggregates(that, summary, options.data, groups.length);
                                options.data = sortGroupsBySummary(options.data, groups, summary);
                                options.extra = (0, _type.isPlainObject)(options.extra) ? options.extra : {};
                                options.extra.summary = totalAggregates
                            }
                        }
                    }
                    if (!options.isCustomLoading) {
                        that._totalAggregates = options.extra && options.extra.summary || that._totalAggregates
                    }
                    that.callBase(options)
                }
            }
        }();
        _uiData_grid2.default.extend(SummaryDataSourceAdapterExtender);
        _uiData_grid2.default.extend(SummaryDataSourceAdapterClientExtender);
        _uiData_grid.default.registerModule("summary", {
            defaultOptions: function() {
                return {
                    summary: {
                        groupItems: void 0,
                        totalItems: void 0,
                        calculateCustomSummary: void 0,
                        skipEmptyValues: true,
                        recalculateWhileEditing: false,
                        texts: {
                            sum: _message.default.getFormatter("dxDataGrid-summarySum"),
                            sumOtherColumn: _message.default.getFormatter("dxDataGrid-summarySumOtherColumn"),
                            min: _message.default.getFormatter("dxDataGrid-summaryMin"),
                            minOtherColumn: _message.default.getFormatter("dxDataGrid-summaryMinOtherColumn"),
                            max: _message.default.getFormatter("dxDataGrid-summaryMax"),
                            maxOtherColumn: _message.default.getFormatter("dxDataGrid-summaryMaxOtherColumn"),
                            avg: _message.default.getFormatter("dxDataGrid-summaryAvg"),
                            avgOtherColumn: _message.default.getFormatter("dxDataGrid-summaryAvgOtherColumn"),
                            count: _message.default.getFormatter("dxDataGrid-summaryCount")
                        }
                    },
                    sortByGroupSummaryInfo: void 0
                }
            },
            views: {
                footerView: FooterView
            },
            extenders: {
                controllers: {
                    data: function() {
                        return {
                            _isDataColumn: function(column) {
                                return column && (!(0, _type.isDefined)(column.groupIndex) || column.showWhenGrouped)
                            },
                            _isGroupFooterVisible: function() {
                                var groupItems = this.option("summary.groupItems") || [];
                                for (var i = 0; i < groupItems.length; i++) {
                                    var groupItem = groupItems[i];
                                    var column = this._columnsController.columnOption(groupItem.showInColumn || groupItem.column);
                                    if (groupItem.showInGroupFooter && this._isDataColumn(column)) {
                                        return true
                                    }
                                }
                                return false
                            },
                            _processGroupItems: function(items, groupCount, options) {
                                var data = options && options.data;
                                var result = this.callBase.apply(this, arguments);
                                if (options) {
                                    if (void 0 === options.isGroupFooterVisible) {
                                        options.isGroupFooterVisible = this._isGroupFooterVisible()
                                    }
                                    if (data && data.items && options.isGroupFooterVisible && (options.collectContinuationItems || !data.isContinuationOnNextPage)) {
                                        result.push({
                                            rowType: DATAGRID_GROUP_FOOTER_ROW_TYPE,
                                            key: options.path.slice(),
                                            data: data,
                                            groupIndex: options.path.length - 1,
                                            values: []
                                        })
                                    }
                                }
                                return result
                            },
                            _processGroupItem: function(groupItem, options) {
                                var that = this;
                                if (!options.summaryGroupItems) {
                                    options.summaryGroupItems = that.option("summary.groupItems") || []
                                }
                                if ("group" === groupItem.rowType) {
                                    var groupColumnIndex = -1;
                                    var afterGroupColumnIndex = -1;
                                    (0, _iterator.each)(options.visibleColumns, function(visibleIndex) {
                                        var prevColumn = options.visibleColumns[visibleIndex - 1];
                                        if (groupItem.groupIndex === this.groupIndex) {
                                            groupColumnIndex = this.index
                                        }
                                        if (visibleIndex > 0 && "expand" === prevColumn.command && "expand" !== this.command) {
                                            afterGroupColumnIndex = this.index
                                        }
                                    });
                                    groupItem.summaryCells = this._calculateSummaryCells(options.summaryGroupItems, getGroupAggregates(groupItem.data), options.visibleColumns, function(summaryItem, column) {
                                        if (summaryItem.showInGroupFooter) {
                                            return -1
                                        }
                                        if (summaryItem.alignByColumn && column && !(0, _type.isDefined)(column.groupIndex) && column.index !== afterGroupColumnIndex) {
                                            return column.index
                                        } else {
                                            return groupColumnIndex
                                        }
                                    })
                                }
                                if (groupItem.rowType === DATAGRID_GROUP_FOOTER_ROW_TYPE) {
                                    groupItem.summaryCells = this._calculateSummaryCells(options.summaryGroupItems, getGroupAggregates(groupItem.data), options.visibleColumns, function(summaryItem, column) {
                                        return summaryItem.showInGroupFooter && that._isDataColumn(column) ? column.index : -1
                                    })
                                }
                                return groupItem
                            },
                            _calculateSummaryCells: function(summaryItems, aggregates, visibleColumns, calculateTargetColumnIndex) {
                                var that = this;
                                var summaryCells = [];
                                var summaryCellsByColumns = {};
                                (0, _iterator.each)(summaryItems, function(summaryIndex, summaryItem) {
                                    var column = that._columnsController.columnOption(summaryItem.column);
                                    var showInColumn = summaryItem.showInColumn && that._columnsController.columnOption(summaryItem.showInColumn) || column;
                                    var columnIndex = calculateTargetColumnIndex(summaryItem, showInColumn);
                                    if (columnIndex >= 0) {
                                        if (!summaryCellsByColumns[columnIndex]) {
                                            summaryCellsByColumns[columnIndex] = []
                                        }
                                        var aggregate = aggregates[summaryIndex];
                                        if (aggregate === aggregate) {
                                            var valueFormat;
                                            if ((0, _type.isDefined)(summaryItem.valueFormat)) {
                                                valueFormat = summaryItem.valueFormat
                                            } else {
                                                if ("count" !== summaryItem.summaryType) {
                                                    valueFormat = _uiData_grid.default.getFormatByDataType(column && column.dataType)
                                                }
                                            }
                                            summaryCellsByColumns[columnIndex].push((0, _extend.extend)({}, summaryItem, {
                                                value: (0, _type.isString)(aggregate) && column && column.deserializeValue ? column.deserializeValue(aggregate) : aggregate,
                                                valueFormat: valueFormat,
                                                columnCaption: column && column.index !== columnIndex ? column.caption : void 0
                                            }))
                                        }
                                    }
                                });
                                if (!(0, _type.isEmptyObject)(summaryCellsByColumns)) {
                                    (0, _iterator.each)(visibleColumns, function() {
                                        summaryCells.push(summaryCellsByColumns[this.index] || [])
                                    })
                                }
                                return summaryCells
                            },
                            _getSummaryCells: function(summaryTotalItems, totalAggregates) {
                                var that = this;
                                var columnsController = that._columnsController;
                                return that._calculateSummaryCells(summaryTotalItems, totalAggregates, columnsController.getVisibleColumns(), function(summaryItem, column) {
                                    return that._isDataColumn(column) ? column.index : -1
                                })
                            },
                            _updateItemsCore: function(change) {
                                var that = this;
                                var summaryCells;
                                var dataSource = that._dataSource;
                                var footerItems = that._footerItems;
                                var oldSummaryCells = footerItems && footerItems[0] && footerItems[0].summaryCells;
                                var summaryTotalItems = that.option("summary.totalItems");
                                that._footerItems = [];
                                if (dataSource && summaryTotalItems && summaryTotalItems.length) {
                                    var totalAggregates = dataSource.totalAggregates();
                                    summaryCells = that._getSummaryCells(summaryTotalItems, totalAggregates);
                                    if (change && change.repaintChangesOnly && oldSummaryCells) {
                                        change.totalColumnIndices = summaryCells.map(function(summaryCell, index) {
                                            if (JSON.stringify(summaryCell) !== JSON.stringify(oldSummaryCells[index])) {
                                                return index
                                            }
                                            return -1
                                        }).filter(function(index) {
                                            return index >= 0
                                        })
                                    }
                                    if (summaryCells.length) {
                                        that._footerItems.push({
                                            rowType: "totalFooter",
                                            summaryCells: summaryCells
                                        })
                                    }
                                }
                                that.callBase(change)
                            },
                            _prepareUnsavedDataSelector: function(selector) {
                                var that = this;
                                if (recalculateWhileEditing(that)) {
                                    var editingController = that.getController("editing");
                                    if (editingController) {
                                        return function(data) {
                                            data = editingController.getUpdatedData(data);
                                            return selector(data)
                                        }
                                    }
                                }
                                return selector
                            },
                            _prepareAggregateSelector: function(selector, aggregator) {
                                selector = this._prepareUnsavedDataSelector(selector);
                                if ("avg" === aggregator || "sum" === aggregator) {
                                    return function(data) {
                                        var value = selector(data);
                                        return (0, _type.isDefined)(value) ? Number(value) : value
                                    }
                                }
                                return selector
                            },
                            _getAggregates: function(summaryItems, remoteOperations) {
                                var that = this;
                                var columnsController = that.getController("columns");
                                var calculateCustomSummary = that.option("summary.calculateCustomSummary");
                                var commonSkipEmptyValues = that.option("summary.skipEmptyValues");
                                return (0, _iterator.map)(summaryItems || [], function(summaryItem) {
                                    var column = columnsController.columnOption(summaryItem.column);
                                    var calculateCellValue = column && column.calculateCellValue ? column.calculateCellValue.bind(column) : (0, _data.compileGetter)(column ? column.dataField : summaryItem.column);
                                    var aggregator = summaryItem.summaryType || "count";
                                    var selector = summaryItem.column;
                                    var skipEmptyValues = (0, _type.isDefined)(summaryItem.skipEmptyValues) ? summaryItem.skipEmptyValues : commonSkipEmptyValues;
                                    if (remoteOperations) {
                                        return {
                                            selector: summaryItem.column,
                                            summaryType: aggregator
                                        }
                                    } else {
                                        selector = that._prepareAggregateSelector(calculateCellValue, aggregator);
                                        if ("custom" === aggregator) {
                                            if (!calculateCustomSummary) {
                                                _ui.default.log("E1026");
                                                calculateCustomSummary = function() {}
                                            }
                                            var options = {
                                                component: that.component,
                                                name: summaryItem.name
                                            };
                                            calculateCustomSummary(options);
                                            options.summaryProcess = "calculate";
                                            aggregator = {
                                                seed: function(groupIndex) {
                                                    options.summaryProcess = "start";
                                                    options.totalValue = void 0;
                                                    options.groupIndex = groupIndex;
                                                    delete options.value;
                                                    calculateCustomSummary(options);
                                                    return options.totalValue
                                                },
                                                step: function(totalValue, value) {
                                                    options.summaryProcess = "calculate";
                                                    options.totalValue = totalValue;
                                                    options.value = value;
                                                    calculateCustomSummary(options);
                                                    return options.totalValue
                                                },
                                                finalize: function(totalValue) {
                                                    options.summaryProcess = "finalize";
                                                    options.totalValue = totalValue;
                                                    delete options.value;
                                                    calculateCustomSummary(options);
                                                    return options.totalValue
                                                }
                                            }
                                        }
                                        return {
                                            selector: selector,
                                            aggregator: aggregator,
                                            skipEmptyValues: skipEmptyValues
                                        }
                                    }
                                })
                            },
                            _addSortInfo: function(sortByGroups, groupColumn, selector, sortOrder) {
                                if (groupColumn) {
                                    var groupIndex = groupColumn.groupIndex;
                                    sortOrder = sortOrder || groupColumn.sortOrder;
                                    if ((0, _type.isDefined)(groupIndex)) {
                                        sortByGroups[groupIndex] = sortByGroups[groupIndex] || [];
                                        sortByGroups[groupIndex].push({
                                            selector: selector,
                                            desc: "desc" === sortOrder
                                        })
                                    }
                                }
                            },
                            _findSummaryItem: function(summaryItems, name) {
                                var summaryItemIndex = -1;
                                var getFullName = function(summaryItem) {
                                    var summaryType = summaryItem.summaryType;
                                    var column = summaryItem.column;
                                    return summaryType && column && summaryType + "_" + column
                                };
                                if ((0, _type.isDefined)(name)) {
                                    (0, _iterator.each)(summaryItems || [], function(index) {
                                        if (this.name === name || index === name || this.summaryType === name || this.column === name || getFullName(this) === name) {
                                            summaryItemIndex = index;
                                            return false
                                        }
                                    })
                                }
                                return summaryItemIndex
                            },
                            _getSummarySortByGroups: function(sortByGroupSummaryInfo, groupSummaryItems) {
                                var that = this;
                                var columnsController = that._columnsController;
                                var groupColumns = columnsController.getGroupColumns();
                                var sortByGroups = [];
                                if (!groupSummaryItems || !groupSummaryItems.length) {
                                    return
                                }(0, _iterator.each)(sortByGroupSummaryInfo || [], function() {
                                    var sortOrder = this.sortOrder;
                                    var groupColumn = this.groupColumn;
                                    var summaryItemIndex = that._findSummaryItem(groupSummaryItems, this.summaryItem);
                                    if (summaryItemIndex < 0) {
                                        return
                                    }
                                    var selector = function(data) {
                                        return getGroupAggregates(data)[summaryItemIndex]
                                    };
                                    if ((0, _type.isDefined)(groupColumn)) {
                                        groupColumn = columnsController.columnOption(groupColumn);
                                        that._addSortInfo(sortByGroups, groupColumn, selector, sortOrder)
                                    } else {
                                        (0, _iterator.each)(groupColumns, function(groupIndex, groupColumn) {
                                            that._addSortInfo(sortByGroups, groupColumn, selector, sortOrder)
                                        })
                                    }
                                });
                                return sortByGroups
                            },
                            _createDataSourceAdapterCore: function(dataSource, remoteOperations) {
                                var that = this;
                                var dataSourceAdapter = this.callBase(dataSource, remoteOperations);
                                dataSourceAdapter.summaryGetter(function(currentRemoteOperations) {
                                    return that._getSummaryOptions(currentRemoteOperations || remoteOperations)
                                });
                                return dataSourceAdapter
                            },
                            _getSummaryOptions: function(remoteOperations) {
                                var that = this;
                                var groupSummaryItems = that.option("summary.groupItems");
                                var totalSummaryItems = that.option("summary.totalItems");
                                var sortByGroupSummaryInfo = that.option("sortByGroupSummaryInfo");
                                var groupAggregates = that._getAggregates(groupSummaryItems, remoteOperations && remoteOperations.grouping && remoteOperations.summary);
                                var totalAggregates = that._getAggregates(totalSummaryItems, remoteOperations && remoteOperations.summary);
                                var sortByGroups = function() {
                                    return that._getSummarySortByGroups(sortByGroupSummaryInfo, groupSummaryItems)
                                };
                                if (groupAggregates.length || totalAggregates.length) {
                                    return {
                                        groupAggregates: groupAggregates,
                                        totalAggregates: totalAggregates,
                                        sortByGroups: sortByGroups
                                    }
                                }
                            },
                            publicMethods: function() {
                                var methods = this.callBase();
                                methods.push("getTotalSummaryValue");
                                return methods
                            },
                            getTotalSummaryValue: function(summaryItemName) {
                                var summaryItemIndex = this._findSummaryItem(this.option("summary.totalItems"), summaryItemName);
                                var aggregates = this._dataSource.totalAggregates();
                                if (aggregates.length && summaryItemIndex > -1) {
                                    return aggregates[summaryItemIndex]
                                }
                            },
                            optionChanged: function(args) {
                                if ("summary" === args.name || "sortByGroupSummaryInfo" === args.name) {
                                    args.name = "dataSource"
                                }
                                this.callBase(args)
                            },
                            init: function() {
                                this._footerItems = [];
                                this.callBase()
                            },
                            footerItems: function() {
                                return this._footerItems
                            }
                        }
                    }(),
                    editing: function() {
                        return {
                            _refreshSummary: function() {
                                if (recalculateWhileEditing(this) && !this.isSaving()) {
                                    this._dataController.refresh({
                                        load: true,
                                        changesOnly: true
                                    })
                                }
                            },
                            _addChange: function(params) {
                                var result = this.callBase.apply(this, arguments);
                                if (params.type) {
                                    this._refreshSummary()
                                }
                                return result
                            },
                            _removeChange: function() {
                                var result = this.callBase.apply(this, arguments);
                                this._refreshSummary();
                                return result
                            },
                            cancelEditData: function() {
                                var result = this.callBase.apply(this, arguments);
                                this._refreshSummary();
                                return result
                            }
                        }
                    }()
                },
                views: {
                    rowsView: function() {
                        return {
                            _createRow: function(row) {
                                var $row = this.callBase(row);
                                row && $row.addClass(row.rowType === DATAGRID_GROUP_FOOTER_ROW_TYPE ? DATAGRID_GROUP_FOOTER_CLASS : "");
                                return $row
                            },
                            _renderCells: function($row, options) {
                                this.callBase.apply(this, arguments);
                                if ("group" === options.row.rowType && options.row.summaryCells && options.row.summaryCells.length) {
                                    this._renderGroupSummaryCells($row, options)
                                }
                            },
                            _hasAlignByColumnSummaryItems: function(columnIndex, options) {
                                return !(0, _type.isDefined)(options.columns[columnIndex].groupIndex) && options.row.summaryCells[columnIndex].length
                            },
                            _getAlignByColumnCellCount: function(groupCellColSpan, options) {
                                var alignByColumnCellCount = 0;
                                for (var i = 1; i < groupCellColSpan; i++) {
                                    var columnIndex = options.row.summaryCells.length - i;
                                    alignByColumnCellCount = this._hasAlignByColumnSummaryItems(columnIndex, options) ? i : alignByColumnCellCount
                                }
                                return alignByColumnCellCount
                            },
                            _renderGroupSummaryCells: function($row, options) {
                                var $groupCell = $row.children().last();
                                var groupCellColSpan = Number($groupCell.attr("colSpan")) || 1;
                                var alignByColumnCellCount = this._getAlignByColumnCellCount(groupCellColSpan, options);
                                this._renderGroupSummaryCellsCore($groupCell, options, groupCellColSpan, alignByColumnCellCount)
                            },
                            _renderGroupSummaryCellsCore: function($groupCell, options, groupCellColSpan, alignByColumnCellCount) {
                                if (alignByColumnCellCount > 0) {
                                    $groupCell.attr("colSpan", groupCellColSpan - alignByColumnCellCount);
                                    for (var i = 0; i < alignByColumnCellCount; i++) {
                                        var columnIndex = options.columns.length - alignByColumnCellCount + i;
                                        this._renderCell($groupCell.parent(), (0, _extend.extend)({
                                            column: options.columns[columnIndex],
                                            columnIndex: this._getSummaryCellIndex(columnIndex, options.columns)
                                        }, options))
                                    }
                                }
                            },
                            _getSummaryCellIndex: function(columnIndex) {
                                return columnIndex
                            },
                            _getCellTemplate: function(options) {
                                if (!options.column.command && !(0, _type.isDefined)(options.column.groupIndex) && options.summaryItems && options.summaryItems.length) {
                                    return renderSummaryCell
                                } else {
                                    return this.callBase(options)
                                }
                            },
                            _getCellOptions: function(options) {
                                var that = this;
                                var parameters = that.callBase(options);
                                if (options.row.summaryCells) {
                                    return (0, _extend.extend)(parameters, getSummaryCellOptions(that, options))
                                } else {
                                    return parameters
                                }
                            }
                        }
                    }()
                }
            }
        })
    },
    /*!***********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/aggregate_calculator.js ***!
      \***********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _data = __webpack_require__( /*! ../../core/utils/data */ 20);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../../data/errors */ 38));
        var _utils = _interopRequireDefault(__webpack_require__( /*! ../../data/utils */ 41));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function depthFirstSearch(i, depth, root, callback) {
            var j = 0;
            if (i < depth) {
                for (; j < root.items.length; j++) {
                    depthFirstSearch(i + 1, depth, root.items[j], callback)
                }
            }
            if (i === depth) {
                callback(root)
            }
        }

        function map(array, callback) {
            var i;
            if ("map" in array) {
                return array.map(callback)
            }
            var result = new Array(array.length);
            for (i in array) {
                result[i] = callback(array[i], i)
            }
            return result
        }

        function isEmpty(x) {
            return x !== x || "" === x || null === x || void 0 === x
        }

        function isCount(aggregator) {
            return aggregator === _utils.default.aggregators.count
        }

        function normalizeAggregate(aggregate) {
            var selector = (0, _data.compileGetter)(aggregate.selector);
            var skipEmptyValues = "skipEmptyValues" in aggregate ? aggregate.skipEmptyValues : true;
            var aggregator = aggregate.aggregator;
            if ("string" === typeof aggregator) {
                aggregator = _utils.default.aggregators[aggregator];
                if (!aggregator) {
                    throw _errors.default.errors.Error("E4001", aggregate.aggregator)
                }
            }
            return {
                selector: selector,
                aggregator: aggregator,
                skipEmptyValues: skipEmptyValues
            }
        }
        var _default = _class.default.inherit({
            ctor: function(options) {
                this._data = options.data;
                this._groupLevel = options.groupLevel || 0;
                this._totalAggregates = map(options.totalAggregates || [], normalizeAggregate);
                this._groupAggregates = map(options.groupAggregates || [], normalizeAggregate);
                this._totals = []
            },
            calculate: function() {
                if (this._totalAggregates.length) {
                    this._calculateTotals(0, {
                        items: this._data
                    })
                }
                if (this._groupAggregates.length && this._groupLevel > 0) {
                    this._calculateGroups({
                        items: this._data
                    })
                }
            },
            totalAggregates: function() {
                return this._totals
            },
            _aggregate: function(aggregates, data, container) {
                var length = data.items ? data.items.length : 0;
                for (var i = 0; i < aggregates.length; i++) {
                    if (isCount(aggregates[i].aggregator)) {
                        container[i] = (container[i] || 0) + length;
                        continue
                    }
                    for (var j = 0; j < length; j++) {
                        this._accumulate(i, aggregates[i], container, data.items[j])
                    }
                }
            },
            _calculateTotals: function(level, data) {
                if (0 === level) {
                    this._totals = this._seed(this._totalAggregates)
                }
                if (level === this._groupLevel) {
                    this._aggregate(this._totalAggregates, data, this._totals)
                } else {
                    for (var i = 0; i < data.items.length; i++) {
                        this._calculateTotals(level + 1, data.items[i])
                    }
                }
                if (0 === level) {
                    this._totals = this._finalize(this._totalAggregates, this._totals)
                }
            },
            _calculateGroups: function(root) {
                var maxLevel = this._groupLevel;
                var currentLevel = maxLevel + 1;
                var seedFn = this._seed.bind(this, this._groupAggregates);
                var stepFn = this._aggregate.bind(this, this._groupAggregates);
                var finalizeFn = this._finalize.bind(this, this._groupAggregates);

                function aggregator(node) {
                    node.aggregates = seedFn(currentLevel - 1);
                    if (currentLevel === maxLevel) {
                        stepFn(node, node.aggregates)
                    } else {
                        depthFirstSearch(currentLevel, maxLevel, node, function(innerNode) {
                            stepFn(innerNode, node.aggregates)
                        })
                    }
                    node.aggregates = finalizeFn(node.aggregates)
                }
                while (--currentLevel > 0) {
                    depthFirstSearch(0, currentLevel, root, aggregator)
                }
            },
            _seed: function(aggregates, groupIndex) {
                return map(aggregates, function(aggregate) {
                    var aggregator = aggregate.aggregator;
                    var seed = "seed" in aggregator ? (0, _type.isFunction)(aggregator.seed) ? aggregator.seed(groupIndex) : aggregator.seed : NaN;
                    return seed
                })
            },
            _accumulate: function(aggregateIndex, aggregate, results, item) {
                var value = aggregate.selector(item);
                var aggregator = aggregate.aggregator;
                var skipEmptyValues = aggregate.skipEmptyValues;
                if (skipEmptyValues && isEmpty(value)) {
                    return
                }
                if (results[aggregateIndex] !== results[aggregateIndex]) {
                    results[aggregateIndex] = value
                } else {
                    results[aggregateIndex] = aggregator.step(results[aggregateIndex], value)
                }
            },
            _finalize: function(aggregates, results) {
                return map(aggregates, function(aggregate, index) {
                    var fin = aggregate.aggregator.finalize;
                    return fin ? fin(results[index]) : results[index]
                })
            }
        });
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.column_fixing.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.column_fixing */ 417));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiData_grid.default.registerModule("columnFixing", _uiGrid_core.default)
    },
    /*!**************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.adaptivity.js ***!
      \**************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.adaptivity */ 418));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiData_grid.default.registerModule("adaptivity", _uiGrid_core.default)
    },
    /*!*******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.virtual_columns.js ***!
      \*******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.virtual_columns */ 419));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiData_grid.default.registerModule("virtualColumns", _uiGrid_core.default)
    },
    /*!**********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.export.js ***!
      \**********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.ExportController = exports.DataProvider = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _position = __webpack_require__( /*! ../../core/utils/position */ 22);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.export_mixin */ 421));
        var _exporter = __webpack_require__( /*! ../../exporter */ 191);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _button = _interopRequireDefault(__webpack_require__( /*! ../button */ 37));
        var _list = _interopRequireDefault(__webpack_require__( /*! ../list */ 112));
        var _context_menu = _interopRequireDefault(__webpack_require__( /*! ../context_menu */ 107));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }
        var DATAGRID_EXPORT_MENU_CLASS = "dx-datagrid-export-menu";
        var DATAGRID_EXPORT_BUTTON_CLASS = "dx-datagrid-export-button";
        var DATAGRID_EXPORT_ICON = "export-to";
        var DATAGRID_EXPORT_EXCEL_ICON = "xlsxfile";
        var DATAGRID_EXPORT_SELECTED_ICON = "exportselected";
        var DATAGRID_EXPORT_EXCEL_BUTTON_ICON = "export-excel-button";
        var TOOLBAR_ITEM_AUTO_HIDE_CLASS = "dx-toolbar-item-auto-hide";
        var TOOLBAR_HIDDEN_BUTTON_CLASS = "dx-toolbar-hidden-button";
        var BUTTON_CLASS = "dx-button";
        var DataProvider = _class.default.inherit({
            _getGroupValue: function(item) {
                var key = item.key,
                    data = item.data,
                    rowType = item.rowType,
                    groupIndex = item.groupIndex,
                    summaryCells = item.summaryCells;
                var groupColumn = this._options.groupColumns[groupIndex];
                var value = _uiData_grid.default.getDisplayValue(groupColumn, groupColumn.deserializeValue ? groupColumn.deserializeValue(key[groupIndex]) : key[groupIndex], data, rowType);
                var result = groupColumn.caption + ": " + _uiData_grid.default.formatValue(value, groupColumn);
                if (summaryCells && summaryCells[0] && summaryCells[0].length) {
                    result += " " + _uiData_grid.default.getGroupRowSummaryText(summaryCells[0], this._options.summaryTexts)
                }
                return result
            },
            _correctCellIndex: function(cellIndex) {
                return cellIndex
            },
            _initOptions: function() {
                var exportController = this._exportController;
                var groupColumns = exportController._columnsController.getGroupColumns();
                var excelWrapTextEnabled = exportController.option("export.excelWrapTextEnabled");
                this._options = {
                    columns: exportController._getColumns(this._initialColumnWidthsByColumnIndex),
                    groupColumns: groupColumns,
                    items: this._selectedRowsOnly || exportController._selectionOnly ? exportController._getSelectedItems() : exportController._getAllItems(),
                    getVisibleIndex: exportController._columnsController.getVisibleIndex.bind(exportController._columnsController),
                    isHeadersVisible: exportController.option("showColumnHeaders"),
                    summaryTexts: exportController.option("summary.texts"),
                    customizeExportData: exportController.option("customizeExportData"),
                    rtlEnabled: exportController.option("rtlEnabled"),
                    wrapTextEnabled: (0, _type.isDefined)(excelWrapTextEnabled) ? excelWrapTextEnabled : !!exportController.option("wordWrapEnabled"),
                    customizeExcelCell: exportController.option("export.customizeExcelCell")
                }
            },
            hasCustomizeExcelCell: function() {
                return (0, _type.isDefined)(this._options.customizeExcelCell)
            },
            customizeExcelCell: function(e, cellSourceData) {
                if (this._options.customizeExcelCell) {
                    e.gridCell = cellSourceData;
                    if ((0, _type.isDefined)(this._exportController) && (0, _type.isDefined)(this._exportController.component)) {
                        e.component = this._exportController.component
                    }
                    this._options.customizeExcelCell(e)
                }
            },
            ctor: function(exportController, initialColumnWidthsByColumnIndex, selectedRowsOnly) {
                this._exportController = exportController;
                this._initialColumnWidthsByColumnIndex = initialColumnWidthsByColumnIndex;
                this._selectedRowsOnly = selectedRowsOnly
            },
            getHeaderStyles: function() {
                return [{
                    bold: true,
                    alignment: "center",
                    wrapText: true
                }, {
                    bold: true,
                    alignment: "left",
                    wrapText: true
                }, {
                    bold: true,
                    alignment: "right",
                    wrapText: true
                }]
            },
            getGroupRowStyle: function() {
                return {
                    bold: true,
                    wrapText: false,
                    alignment: (0, _position.getDefaultAlignment)(this._options.rtlEnabled)
                }
            },
            getColumnStyles: function() {
                var wrapTextEnabled = this._options.wrapTextEnabled;
                var columnStyles = [];
                this.getColumns().forEach(function(column) {
                    columnStyles.push({
                        alignment: column.alignment || "left",
                        format: column.format,
                        wrapText: wrapTextEnabled,
                        dataType: column.dataType
                    })
                });
                return columnStyles
            },
            getStyles: function() {
                return [].concat(_toConsumableArray(this.getHeaderStyles()), _toConsumableArray(this.getColumnStyles()), [this.getGroupRowStyle()])
            },
            _getTotalCellStyleId: function(cellIndex) {
                var _this$getColumns$cell;
                var alignment = (null === (_this$getColumns$cell = this.getColumns()[cellIndex]) || void 0 === _this$getColumns$cell ? void 0 : _this$getColumns$cell.alignment) || "right";
                return this.getHeaderStyles().map(function(style) {
                    return style.alignment
                }).indexOf(alignment)
            },
            getStyleId: function(rowIndex, cellIndex) {
                if (rowIndex < this.getHeaderRowCount()) {
                    return 0
                } else {
                    if (this.isTotalCell(rowIndex - this.getHeaderRowCount(), cellIndex)) {
                        return this._getTotalCellStyleId(cellIndex)
                    } else {
                        if (this.isGroupRow(rowIndex - this.getHeaderRowCount())) {
                            return this.getHeaderStyles().length + this.getColumns().length
                        } else {
                            return cellIndex + this.getHeaderStyles().length
                        }
                    }
                }
            },
            getColumns: function(getColumnsByAllRows) {
                var columns = this._options.columns;
                return getColumnsByAllRows ? columns : columns[columns.length - 1]
            },
            getColumnsWidths: function() {
                var columns = this.getColumns();
                return (0, _type.isDefined)(columns) ? columns.map(function(c) {
                    return c.width
                }) : void 0
            },
            getRowsCount: function() {
                return this._options.items.length + this.getHeaderRowCount()
            },
            getHeaderRowCount: function() {
                if (this.isHeadersVisible()) {
                    return this._options.columns.length - 1
                }
                return 0
            },
            isGroupRow: function(rowIndex) {
                return rowIndex < this._options.items.length && "group" === this._options.items[rowIndex].rowType
            },
            getGroupLevel: function(rowIndex) {
                var item = this._options.items[rowIndex - this.getHeaderRowCount()];
                var groupIndex = item && item.groupIndex;
                if (item && "totalFooter" === item.rowType) {
                    return 0
                }
                return (0, _type.isDefined)(groupIndex) ? groupIndex : this._options.groupColumns.length
            },
            getCellType: function(rowIndex, cellIndex) {
                var columns = this.getColumns();
                if (rowIndex < this.getHeaderRowCount()) {
                    return "string"
                } else {
                    rowIndex -= this.getHeaderRowCount()
                }
                if (cellIndex < columns.length) {
                    var item = this._options.items.length && this._options.items[rowIndex];
                    var column = columns[cellIndex];
                    if (item && "data" === item.rowType) {
                        if (isFinite(item.values[this._correctCellIndex(cellIndex)]) && !(0, _type.isDefined)(column.customizeText)) {
                            return (0, _type.isDefined)(column.lookup) ? column.lookup.dataType : column.dataType
                        }
                    }
                    return "string"
                }
            },
            ready: function() {
                var that = this;
                that._initOptions();
                var options = that._options;
                return (0, _deferred.when)(options.items).done(function(items) {
                    options.customizeExportData && options.customizeExportData(that.getColumns(that.getHeaderRowCount() > 1), items);
                    options.items = items
                }).fail(function() {
                    options.items = []
                })
            },
            _convertFromGridGroupSummaryItems: function(gridGroupSummaryItems) {
                if ((0, _type.isDefined)(gridGroupSummaryItems) && gridGroupSummaryItems.length > 0) {
                    return gridGroupSummaryItems.map(function(item) {
                        return {
                            value: item.value,
                            name: item.name
                        }
                    })
                }
            },
            getCellData: function(rowIndex, cellIndex, isExcelJS) {
                var value;
                var column;
                var result = {
                    cellSourceData: {},
                    value: value
                };
                var columns = this.getColumns();
                var correctedCellIndex = this._correctCellIndex(cellIndex);
                if (rowIndex < this.getHeaderRowCount()) {
                    var columnsRow = this.getColumns(true)[rowIndex];
                    column = columnsRow[cellIndex];
                    result.cellSourceData.rowType = "header";
                    result.cellSourceData.column = column && column.gridColumn;
                    result.value = column && column.caption
                } else {
                    rowIndex -= this.getHeaderRowCount();
                    var item = this._options.items.length && this._options.items[rowIndex];
                    if (item) {
                        var itemValues = item.values;
                        result.cellSourceData.rowType = item.rowType;
                        result.cellSourceData.column = columns[cellIndex] && columns[cellIndex].gridColumn;
                        switch (item.rowType) {
                            case "groupFooter":
                            case "totalFooter":
                                if (correctedCellIndex < itemValues.length) {
                                    value = itemValues[correctedCellIndex];
                                    if ((0, _type.isDefined)(value)) {
                                        result.cellSourceData.value = value.value;
                                        result.cellSourceData.totalSummaryItemName = value.name;
                                        result.value = _uiData_grid.default.getSummaryText(value, this._options.summaryTexts)
                                    } else {
                                        result.cellSourceData.value = void 0
                                    }
                                }
                                break;
                            case "group":
                                result.cellSourceData.groupIndex = item.groupIndex;
                                if (cellIndex < 1) {
                                    result.cellSourceData.column = this._options.groupColumns[item.groupIndex];
                                    result.cellSourceData.value = item.key[item.groupIndex];
                                    result.cellSourceData.groupSummaryItems = this._convertFromGridGroupSummaryItems(item.summaryCells[0]);
                                    result.value = this._getGroupValue(item)
                                } else {
                                    var summaryItems = item.values[correctedCellIndex];
                                    if (Array.isArray(summaryItems)) {
                                        result.cellSourceData.groupSummaryItems = this._convertFromGridGroupSummaryItems(summaryItems);
                                        value = "";
                                        for (var i = 0; i < summaryItems.length; i++) {
                                            value += (i > 0 ? isExcelJS ? "\n" : " \n " : "") + _uiData_grid.default.getSummaryText(summaryItems[i], this._options.summaryTexts)
                                        }
                                        result.value = value
                                    } else {
                                        result.cellSourceData.value = void 0
                                    }
                                }
                                break;
                            default:
                                column = columns[cellIndex];
                                if (column) {
                                    var _value = itemValues[correctedCellIndex];
                                    var displayValue = _uiData_grid.default.getDisplayValue(column, _value, item.data, item.rowType);
                                    if (!isFinite(displayValue) || (0, _type.isDefined)(column.customizeText)) {
                                        if (isExcelJS && (0, _type.isDefined)(column.customizeText) && column.customizeText === this._exportController._columnsController.getCustomizeTextByDataType("boolean")) {
                                            result.value = displayValue
                                        } else {
                                            result.value = _uiData_grid.default.formatValue(displayValue, column)
                                        }
                                    } else {
                                        result.value = displayValue
                                    }
                                    result.cellSourceData.value = _value
                                }
                                result.cellSourceData.data = item.data
                        }
                    }
                }
                return result
            },
            isHeadersVisible: function() {
                return this._options.isHeadersVisible
            },
            isTotalCell: function(rowIndex, cellIndex) {
                var items = this._options.items;
                var item = items[rowIndex];
                var correctCellIndex = this._correctCellIndex(cellIndex);
                var isSummaryAlignByColumn = item.summaryCells && item.summaryCells[correctCellIndex] && item.summaryCells[correctCellIndex].length > 0 && item.summaryCells[correctCellIndex][0].alignByColumn;
                return item && "groupFooter" === item.rowType || "totalFooter" === item.rowType || isSummaryAlignByColumn
            },
            getCellMerging: function(rowIndex, cellIndex) {
                var columns = this._options.columns;
                var column = columns[rowIndex] && columns[rowIndex][cellIndex];
                return column ? {
                    colspan: (column.exportColspan || 1) - 1,
                    rowspan: (column.rowspan || 1) - 1
                } : {
                    colspan: 0,
                    rowspan: 0
                }
            },
            getFrozenArea: function() {
                var that = this;
                return {
                    x: 0,
                    y: that.getHeaderRowCount()
                }
            }
        });
        exports.DataProvider = DataProvider;
        var ExportController = _uiData_grid.default.ViewController.inherit({}).include(_uiGrid_core.default).inherit({
            _getEmptyCell: function() {
                return {
                    caption: "",
                    colspan: 1,
                    rowspan: 1
                }
            },
            _updateColumnWidth: function(column, width) {
                column.width = width
            },
            _getColumns: function(initialColumnWidthsByColumnIndex) {
                var result = [];
                var i;
                var columns;
                var columnsController = this._columnsController;
                var rowCount = columnsController.getRowCount();
                for (i = 0; i <= rowCount; i++) {
                    var currentHeaderRow = [];
                    columns = columnsController.getVisibleColumns(i, true);
                    var columnWidthsByColumnIndex = void 0;
                    if (i === rowCount) {
                        if (this._updateLockCount) {
                            columnWidthsByColumnIndex = initialColumnWidthsByColumnIndex
                        } else {
                            var columnWidths = this._getColumnWidths(this._headersView, this._rowsView);
                            if (columnWidths && columnWidths.length) {
                                columnWidthsByColumnIndex = {};
                                for (var _i = 0; _i < columns.length; _i++) {
                                    columnWidthsByColumnIndex[columns[_i].index] = columnWidths[_i]
                                }
                            }
                        }
                    }
                    for (var j = 0; j < columns.length; j++) {
                        var column = (0, _extend.extend)({}, columns[j], {
                            dataType: "datetime" === columns[j].dataType ? "date" : columns[j].dataType,
                            gridColumn: columns[j]
                        });
                        if (this._needColumnExporting(column)) {
                            var currentColspan = this._calculateExportColspan(column);
                            if ((0, _type.isDefined)(currentColspan)) {
                                column.exportColspan = currentColspan
                            }
                            if (columnWidthsByColumnIndex) {
                                this._updateColumnWidth(column, columnWidthsByColumnIndex[column.index])
                            }
                            currentHeaderRow.push(column)
                        }
                    }
                    result.push(currentHeaderRow)
                }
                columns = result[rowCount];
                result = this._prepareItems(result.slice(0, -1));
                result.push(columns);
                return result
            },
            _calculateExportColspan: function(column) {
                var _this = this;
                if (!column.isBand) {
                    return
                }
                var childColumns = this._columnsController.getChildrenByBandColumn(column.index, true);
                if (!(0, _type.isDefined)(childColumns)) {
                    return
                }
                return childColumns.reduce(function(result, childColumn) {
                    if (_this._needColumnExporting(childColumn)) {
                        return result + (_this._calculateExportColspan(childColumn) || 1)
                    } else {
                        return result
                    }
                }, 0)
            },
            _needColumnExporting: function(column) {
                return !column.command && (column.allowExporting || void 0 === column.allowExporting)
            },
            _getFooterSummaryItems: function(summaryCells, isTotal) {
                var result = [];
                var estimatedItemsCount = 1;
                var i = 0;
                do {
                    var values = [];
                    for (var j = 0; j < summaryCells.length; j++) {
                        var summaryCell = summaryCells[j];
                        var itemsLength = summaryCell.length;
                        if (estimatedItemsCount < itemsLength) {
                            estimatedItemsCount = itemsLength
                        }
                        values.push(summaryCell[i])
                    }
                    result.push({
                        values: values,
                        rowType: isTotal ? "totalFooter" : "groupFooter"
                    })
                } while (i++ < estimatedItemsCount - 1);
                return result
            },
            _hasSummaryGroupFooters: function() {
                var groupItems = this.option("summary.groupItems");
                if ((0, _type.isDefined)(groupItems)) {
                    for (var i = 0; i < groupItems.length; i++) {
                        if (groupItems[i].showInGroupFooter) {
                            return true
                        }
                    }
                }
                return false
            },
            _getItemsWithSummaryGroupFooters: function(sourceItems) {
                var result = [];
                var beforeGroupFooterItems = [];
                var groupFooterItems = [];
                for (var i = 0; i < sourceItems.length; i++) {
                    var item = sourceItems[i];
                    if ("groupFooter" === item.rowType) {
                        groupFooterItems = this._getFooterSummaryItems(item.summaryCells);
                        result = result.concat(beforeGroupFooterItems, groupFooterItems);
                        beforeGroupFooterItems = []
                    } else {
                        beforeGroupFooterItems.push(item)
                    }
                }
                return result.length ? result : beforeGroupFooterItems
            },
            _updateGroupValuesWithSummaryByColumn: function(sourceItems) {
                var summaryValues = [];
                for (var i = 0; i < sourceItems.length; i++) {
                    var item = sourceItems[i];
                    var summaryCells = item.summaryCells;
                    if ("group" === item.rowType && summaryCells && summaryCells.length > 1) {
                        var groupColumnCount = item.values.length;
                        for (var j = 1; j < summaryCells.length; j++) {
                            for (var k = 0; k < summaryCells[j].length; k++) {
                                var summaryItem = summaryCells[j][k];
                                if (summaryItem && summaryItem.alignByColumn) {
                                    if (!Array.isArray(summaryValues[j - groupColumnCount])) {
                                        summaryValues[j - groupColumnCount] = []
                                    }
                                    summaryValues[j - groupColumnCount].push(summaryItem)
                                }
                            }
                        }
                        if (summaryValues.length > 0) {
                            (0, _array.merge)(item.values, summaryValues);
                            summaryValues = []
                        }
                    }
                }
            },
            _processUnExportedItems: function(items) {
                var columns = this._columnsController.getVisibleColumns(null, true);
                var groupColumns = this._columnsController.getGroupColumns();
                var values;
                var summaryCells;
                for (var i = 0; i < items.length; i++) {
                    var item = items[i];
                    var isDetailExpandColumn = false;
                    values = [];
                    summaryCells = [];
                    for (var j = 0; j < columns.length; j++) {
                        var column = columns[j];
                        isDetailExpandColumn = isDetailExpandColumn || "detailExpand" === column.type;
                        if (this._needColumnExporting(column)) {
                            if (item.values) {
                                if ("group" === item.rowType && !values.length) {
                                    values.push(item.key[item.groupIndex])
                                } else {
                                    values.push(item.values[j])
                                }
                            }
                            if (item.summaryCells) {
                                if ("group" === item.rowType && !summaryCells.length) {
                                    var index = j - groupColumns.length + item.groupIndex;
                                    summaryCells.push(item.summaryCells[isDetailExpandColumn ? index - 1 : index])
                                } else {
                                    summaryCells.push(item.summaryCells[j])
                                }
                            }
                        }
                    }
                    if (values.length) {
                        item.values = values
                    }
                    if (summaryCells.length) {
                        item.summaryCells = summaryCells
                    }
                }
            },
            _getAllItems: function(data) {
                var that = this;
                var d = new _deferred.Deferred;
                var dataController = this.getController("data");
                var footerItems = dataController.footerItems();
                var totalItem = footerItems.length && footerItems[0];
                var summaryTotalItems = that.option("summary.totalItems");
                var summaryCells;
                (0, _deferred.when)(data).done(function(data) {
                    dataController.loadAll(data).done(function(sourceItems, totalAggregates) {
                        that._updateGroupValuesWithSummaryByColumn(sourceItems);
                        if (that._hasSummaryGroupFooters()) {
                            sourceItems = that._getItemsWithSummaryGroupFooters(sourceItems)
                        }
                        summaryCells = totalItem && totalItem.summaryCells;
                        if ((0, _type.isDefined)(totalAggregates) && summaryTotalItems) {
                            summaryCells = that._getSummaryCells(summaryTotalItems, totalAggregates)
                        }
                        var summaryItems = totalItem && that._getFooterSummaryItems(summaryCells, true);
                        if (summaryItems) {
                            sourceItems = sourceItems.concat(summaryItems)
                        }
                        that._processUnExportedItems(sourceItems);
                        d.resolve(sourceItems)
                    }).fail(d.reject)
                }).fail(d.reject);
                return d
            },
            _getSummaryCells: function(summaryTotalItems, totalAggregates) {
                var dataController = this.getController("data");
                var columnsController = dataController._columnsController;
                return dataController._calculateSummaryCells(summaryTotalItems, totalAggregates, columnsController.getVisibleColumns(null, true), function(summaryItem, column) {
                    return dataController._isDataColumn(column) ? column.index : -1
                })
            },
            _getSelectedItems: function() {
                var selectionController = this.getController("selection");
                var selectedRowData = selectionController.getSelectedRowsData();
                return this._getAllItems(selectedRowData)
            },
            _getColumnWidths: function(headersView, rowsView) {
                return headersView && headersView.isVisible() ? headersView.getColumnWidths() : rowsView.getColumnWidths()
            },
            init: function() {
                this._columnsController = this.getController("columns");
                this._rowsView = this.getView("rowsView");
                this._headersView = this.getView("columnHeadersView");
                this.createAction("onExporting", {
                    excludeValidators: ["disabled", "readOnly"]
                });
                this.createAction("onExported", {
                    excludeValidators: ["disabled", "readOnly"]
                });
                this.createAction("onFileSaving", {
                    excludeValidators: ["disabled", "readOnly"]
                })
            },
            callbackNames: function() {
                return ["selectionOnlyChanged"]
            },
            getExportFormat: function() {
                return ["EXCEL"]
            },
            getDataProvider: function(selectedRowsOnly) {
                var columnWidths = this._getColumnWidths(this._headersView, this._rowsView);
                var initialColumnWidthsByColumnIndex;
                if (columnWidths && columnWidths.length) {
                    initialColumnWidthsByColumnIndex = {};
                    var columnsLastRowVisibleColumns = this._columnsController.getVisibleColumns(this._columnsController.getRowCount(), true);
                    for (var i = 0; i < columnsLastRowVisibleColumns.length; i++) {
                        initialColumnWidthsByColumnIndex[columnsLastRowVisibleColumns[i].index] = columnWidths[i]
                    }
                }
                return new DataProvider(this, initialColumnWidthsByColumnIndex, selectedRowsOnly)
            },
            exportToExcel: function(selectionOnly) {
                var that = this;
                that._selectionOnly = selectionOnly;
                (0, _exporter.export)(that.component.getDataProvider(), {
                    fileName: that.option("export.fileName"),
                    proxyUrl: that.option("export.proxyUrl"),
                    format: "EXCEL",
                    autoFilterEnabled: !!that.option("export.excelFilterEnabled"),
                    rtlEnabled: that.option("rtlEnabled"),
                    ignoreErrors: that.option("export.ignoreExcelErrors"),
                    exportingAction: that.getAction("onExporting"),
                    exportedAction: that.getAction("onExported"),
                    fileSavingAction: that.getAction("onFileSaving")
                }, _exporter.excel.getData)
            },
            publicMethods: function() {
                return ["getDataProvider", "getExportFormat", "exportToExcel"]
            },
            selectionOnly: function(value) {
                if ((0, _type.isDefined)(value)) {
                    this._isSelectedRows = value;
                    this.selectionOnlyChanged.fire()
                } else {
                    return this._isSelectedRows
                }
            }
        });
        exports.ExportController = ExportController;
        _uiData_grid.default.registerModule("export", {
            defaultOptions: function() {
                return {
                    "export": {
                        enabled: false,
                        fileName: "DataGrid",
                        excelFilterEnabled: false,
                        excelWrapTextEnabled: void 0,
                        proxyUrl: void 0,
                        allowExportSelectedData: false,
                        ignoreExcelErrors: true,
                        texts: {
                            exportTo: _message.default.format("dxDataGrid-exportTo"),
                            exportAll: _message.default.format("dxDataGrid-exportAll"),
                            exportSelectedRows: _message.default.format("dxDataGrid-exportSelectedRows")
                        }
                    }
                }
            },
            controllers: {
                "export": ExportController
            },
            extenders: {
                controllers: {
                    editing: {
                        callbackNames: function() {
                            var callbackList = this.callBase();
                            return (0, _type.isDefined)(callbackList) ? callbackList.push("editingChanged") : ["editingChanged"]
                        },
                        _updateEditButtons: function() {
                            this.callBase();
                            this.editingChanged.fire(this.hasChanges())
                        }
                    }
                },
                views: {
                    headerPanel: {
                        _getToolbarItems: function() {
                            var items = this.callBase();
                            return this._appendExportItems(items)
                        },
                        _appendExportItems: function(items) {
                            var that = this;
                            var exportOptions = that.option("export");
                            if (exportOptions.enabled) {
                                var exportItems = [];
                                if (exportOptions.allowExportSelectedData) {
                                    exportItems.push({
                                        template: function(data, index, container) {
                                            var $container = (0, _renderer.default)(container);
                                            that._renderButton(data, $container);
                                            that._renderExportMenu($container)
                                        },
                                        menuItemTemplate: function(data, index, container) {
                                            that._renderList(data, (0, _renderer.default)(container))
                                        },
                                        name: "exportButton",
                                        allowExportSelected: true,
                                        location: "after",
                                        locateInMenu: "auto",
                                        sortIndex: 30
                                    })
                                } else {
                                    exportItems.push({
                                        template: function(data, index, container) {
                                            that._renderButton(data, (0, _renderer.default)(container))
                                        },
                                        menuItemTemplate: function(data, index, container) {
                                            that._renderButton(data, (0, _renderer.default)(container), true)
                                        },
                                        name: "exportButton",
                                        location: "after",
                                        locateInMenu: "auto",
                                        sortIndex: 30
                                    })
                                }
                                items = items.concat(exportItems);
                                that._correctItemsPosition(items)
                            }
                            return items
                        },
                        _renderButton: function(data, $container, withText) {
                            var that = this;
                            var buttonOptions = that._getButtonOptions(data.allowExportSelected);
                            var $buttonContainer = that._getButtonContainer().addClass(DATAGRID_EXPORT_BUTTON_CLASS).appendTo($container);
                            if (withText) {
                                var wrapperNode = (0, _renderer.default)("<div>").addClass(TOOLBAR_ITEM_AUTO_HIDE_CLASS);
                                $container.wrapInner(wrapperNode).parent().addClass("dx-toolbar-menu-action dx-toolbar-menu-button " + TOOLBAR_HIDDEN_BUTTON_CLASS);
                                buttonOptions.text = buttonOptions.hint
                            }
                            that._createComponent($buttonContainer, _button.default, buttonOptions)
                        },
                        _renderList: function(data, $container) {
                            var that = this;
                            var texts = that.option("export.texts");
                            var items = [{
                                template: function(data, index, container) {
                                    that._renderFakeButton(data, (0, _renderer.default)(container), DATAGRID_EXPORT_EXCEL_ICON)
                                },
                                text: texts.exportAll
                            }, {
                                template: function(data, index, container) {
                                    that._renderFakeButton(data, (0, _renderer.default)(container), DATAGRID_EXPORT_SELECTED_ICON)
                                },
                                text: texts.exportSelectedRows,
                                exportSelected: true
                            }];
                            that._createComponent($container, _list.default, {
                                items: items,
                                onItemClick: function(e) {
                                    that._exportController.exportToExcel(e.itemData.exportSelected)
                                },
                                scrollingEnabled: false
                            })
                        },
                        _renderFakeButton: function(data, $container, iconName) {
                            var $icon = (0, _renderer.default)("<div>").addClass("dx-icon dx-icon-" + iconName);
                            var $text = (0, _renderer.default)("<span>").addClass("dx-button-text").text(data.text);
                            var $content = (0, _renderer.default)("<div>").addClass("dx-button-content").append($icon).append($text);
                            var $button = (0, _renderer.default)("<div>").addClass(BUTTON_CLASS + " dx-button-has-text dx-button-has-icon dx-datagrid-toolbar-button").append($content);
                            var $toolbarItem = (0, _renderer.default)("<div>").addClass(TOOLBAR_ITEM_AUTO_HIDE_CLASS).append($button);
                            $container.append($toolbarItem).parent().addClass("dx-toolbar-menu-custom " + TOOLBAR_HIDDEN_BUTTON_CLASS)
                        },
                        _correctItemsPosition: function(items) {
                            items.sort(function(itemA, itemB) {
                                return itemA.sortIndex - itemB.sortIndex
                            })
                        },
                        _renderExportMenu: function($buttonContainer) {
                            var that = this;
                            var $button = $buttonContainer.find("." + BUTTON_CLASS);
                            var texts = that.option("export.texts");
                            var menuItems = [{
                                text: texts.exportAll,
                                icon: DATAGRID_EXPORT_EXCEL_ICON
                            }, {
                                text: texts.exportSelectedRows,
                                exportSelected: true,
                                icon: DATAGRID_EXPORT_SELECTED_ICON
                            }];
                            var $menuContainer = (0, _renderer.default)("<div>").appendTo($buttonContainer);
                            that._contextMenu = that._createComponent($menuContainer, _context_menu.default, {
                                showEvent: "dxclick",
                                items: menuItems,
                                cssClass: DATAGRID_EXPORT_MENU_CLASS,
                                onItemClick: function(e) {
                                    that._exportController.exportToExcel(e.itemData.exportSelected)
                                },
                                target: $button,
                                position: {
                                    at: "left bottom",
                                    my: "left top",
                                    offset: "0 3",
                                    collision: "fit",
                                    boundary: that._$parent,
                                    boundaryOffset: "1 1"
                                }
                            })
                        },
                        _isExportButtonVisible: function() {
                            return this.option("export.enabled")
                        },
                        _getButtonOptions: function(allowExportSelected) {
                            var that = this;
                            var texts = that.option("export.texts");
                            var options;
                            if (allowExportSelected) {
                                options = {
                                    hint: texts.exportTo,
                                    icon: DATAGRID_EXPORT_ICON
                                }
                            } else {
                                options = {
                                    hint: texts.exportAll,
                                    icon: DATAGRID_EXPORT_EXCEL_BUTTON_ICON,
                                    onClick: function() {
                                        that._exportController.exportToExcel()
                                    }
                                }
                            }
                            return options
                        },
                        optionChanged: function(args) {
                            this.callBase(args);
                            if ("export" === args.name) {
                                args.handled = true;
                                this._invalidate()
                            }
                        },
                        init: function() {
                            var that = this;
                            this.callBase();
                            this._exportController = this.getController("export");
                            this._editingController = this.getController("editing");
                            this._editingController.editingChanged.add(function(hasChanges) {
                                that.setToolbarItemDisabled("exportButton", hasChanges)
                            })
                        },
                        isVisible: function() {
                            return this.callBase() || this._isExportButtonVisible()
                        }
                    }
                }
            }
        })
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.focus.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.focus */ 422));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _uiData_grid2 = __webpack_require__( /*! ./ui.data_grid.utils */ 291);
        var _data = __webpack_require__( /*! ../../core/utils/data */ 20);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
        _uiData_grid.default.registerModule("focus", (0, _extend.extend)(true, {}, _uiGrid_core.default, {
            extenders: {
                controllers: {
                    data: {
                        changeRowExpand: function(path, isRowClick) {
                            if (this.option("focusedRowEnabled") && Array.isArray(path) && this.isRowExpanded(path)) {
                                var keyboardNavigation = this.getController("keyboardNavigation");
                                if ((!isRowClick || !keyboardNavigation.isKeyboardEnabled()) && this._isFocusedRowInsideGroup(path)) {
                                    this.option("focusedRowKey", path)
                                }
                            }
                            return this.callBase.apply(this, arguments)
                        },
                        _isFocusedRowInsideGroup: function(path) {
                            var columnsController = this.getController("columns");
                            var focusedRowKey = this.option("focusedRowKey");
                            var rowIndex = this.getRowIndexByKey(focusedRowKey);
                            var focusedRow = rowIndex >= 0 && this.getVisibleRows()[rowIndex];
                            var groups = columnsController.getGroupDataSourceParameters(true);
                            if (focusedRow) {
                                for (var i = 0; i < path.length; ++i) {
                                    var getter = (0, _data.compileGetter)(groups[i] && groups[i].selector);
                                    if (getter(focusedRow.data) !== path[i]) {
                                        return false
                                    }
                                }
                            }
                            return true
                        },
                        _getGroupPath: function(group) {
                            var groupPath = [group.key];
                            var items = group.items;
                            while (items && items[0]) {
                                var item = items[0];
                                if (void 0 !== item.key) {
                                    groupPath.push(item.key)
                                }
                                items = item.items
                            }
                            return groupPath
                        },
                        _expandGroupByPath: function(that, groupPath, level) {
                            var d = new _deferred.Deferred;
                            level++;
                            that.expandRow(groupPath.slice(0, level)).done(function() {
                                if (level === groupPath.length) {
                                    d.resolve()
                                } else {
                                    that._expandGroupByPath(that, groupPath, level).done(d.resolve).fail(d.reject)
                                }
                            }).fail(d.reject);
                            return d.promise()
                        },
                        _calculateGlobalRowIndexByGroupedData: function(key) {
                            var that = this;
                            var dataSource = that._dataSource;
                            var filter = that._generateFilterByKey(key);
                            var deferred = new _deferred.Deferred;
                            var isGroupKey = Array.isArray(key);
                            var group = dataSource.group();
                            if (isGroupKey) {
                                return deferred.resolve(-1).promise()
                            }
                            if (!dataSource._grouping._updatePagingOptions) {
                                that._calculateGlobalRowIndexByFlatData(key, null, true).done(deferred.resolve).fail(deferred.reject);
                                return deferred
                            }
                            dataSource.load({
                                filter: that._concatWithCombinedFilter(filter),
                                group: group
                            }).done(function(data) {
                                if (!data || 0 === data.length || !(0, _type.isDefined)(data[0].key) || data[0].key === -1) {
                                    return deferred.resolve(-1).promise()
                                }
                                var groupPath = that._getGroupPath(data[0]);
                                that._expandGroupByPath(that, groupPath, 0).done(function() {
                                    that._calculateExpandedRowGlobalIndex(deferred, key, groupPath, group)
                                }).fail(deferred.reject)
                            }).fail(deferred.reject);
                            return deferred.promise()
                        },
                        _calculateExpandedRowGlobalIndex: function(deferred, key, groupPath, group) {
                            var groupFilter = (0, _uiData_grid2.createGroupFilter)(groupPath, {
                                group: group
                            });
                            var dataSource = this._dataSource;
                            var scrollingMode = this.option("scrolling.mode");
                            var isVirtualScrolling = "virtual" === scrollingMode || "infinite" === scrollingMode;
                            var pageSize = dataSource.pageSize();
                            var groupOffset;
                            dataSource._grouping._updatePagingOptions({
                                skip: 0,
                                take: MAX_SAFE_INTEGER
                            }, function(groupInfo, totalOffset) {
                                if ((0, _common.equalByValue)(groupInfo.path, groupPath)) {
                                    groupOffset = totalOffset
                                }
                            });
                            this._calculateGlobalRowIndexByFlatData(key, groupFilter).done(function(dataOffset) {
                                var count;
                                var groupContinuationCount;
                                if (dataOffset < 0) {
                                    deferred.resolve(-1);
                                    return
                                }
                                var currentPageOffset = groupOffset % pageSize || pageSize;
                                count = currentPageOffset + dataOffset - groupPath.length;
                                if (isVirtualScrolling) {
                                    groupContinuationCount = 0
                                } else {
                                    groupContinuationCount = Math.floor(count / (pageSize - groupPath.length)) * groupPath.length
                                }
                                count = groupOffset + dataOffset + groupContinuationCount;
                                deferred.resolve(count)
                            }).fail(deferred.reject)
                        }
                    }
                }
            }
        }))
    },
    /*!****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/data_grid/ui.data_grid.row_dragging.js ***!
      \****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiData_grid = _interopRequireDefault(__webpack_require__( /*! ./ui.data_grid.core */ 26));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.row_dragging */ 423));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiData_grid.default.registerModule("rowDragging", _uiGrid_core.default)
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.base */ 737));
        __webpack_require__( /*! ./ui.tree_list.state_storing */ 747);
        __webpack_require__( /*! ./ui.tree_list.column_chooser */ 748);
        __webpack_require__( /*! ./ui.tree_list.master_detail */ 749);
        __webpack_require__( /*! ./ui.tree_list.editing */ 750);
        __webpack_require__( /*! ./ui.tree_list.validating */ 752);
        __webpack_require__( /*! ./ui.tree_list.virtual_scrolling */ 753);
        __webpack_require__( /*! ./ui.tree_list.filter_row */ 754);
        __webpack_require__( /*! ./ui.tree_list.header_filter */ 755);
        __webpack_require__( /*! ./ui.tree_list.filter_sync */ 756);
        __webpack_require__( /*! ./ui.tree_list.filter_builder */ 757);
        __webpack_require__( /*! ./ui.tree_list.filter_panel */ 758);
        __webpack_require__( /*! ./ui.tree_list.pager */ 759);
        __webpack_require__( /*! ./ui.tree_list.columns_resizing_reordering */ 760);
        __webpack_require__( /*! ./ui.tree_list.column_fixing */ 761);
        __webpack_require__( /*! ./ui.tree_list.adaptivity */ 762);
        __webpack_require__( /*! ./ui.tree_list.selection */ 763);
        __webpack_require__( /*! ./ui.tree_list.search */ 764);
        __webpack_require__( /*! ./ui.tree_list.keyboard_navigation */ 765);
        __webpack_require__( /*! ./ui.tree_list.virtual_columns */ 766);
        __webpack_require__( /*! ./ui.tree_list.focus */ 767);
        __webpack_require__( /*! ./ui.tree_list.row_dragging */ 768);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _uiTree_list.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.base.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _themes = __webpack_require__( /*! ../themes */ 34);
        __webpack_require__( /*! ./ui.tree_list.column_headers */ 738);
        __webpack_require__( /*! ./ui.tree_list.columns_controller */ 739);
        __webpack_require__( /*! ./ui.tree_list.data_controller */ 740);
        __webpack_require__( /*! ./ui.tree_list.sorting */ 741);
        __webpack_require__( /*! ./ui.tree_list.rows */ 742);
        __webpack_require__( /*! ./ui.tree_list.context_menu */ 743);
        __webpack_require__( /*! ./ui.tree_list.error_handling */ 744);
        __webpack_require__( /*! ./ui.tree_list.grid_view */ 745);
        __webpack_require__( /*! ./ui.tree_list.header_panel */ 746);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var callModuleItemsMethod = _uiTree_list.default.callModuleItemsMethod;
        var DATAGRID_ROW_SELECTOR = ".dx-row";
        var TREELIST_CLASS = "dx-treelist";
        _uiTree_list.default.registerModulesOrder(["stateStoring", "columns", "selection", "editorFactory", "columnChooser", "editing", "grouping", "masterDetail", "validating", "adaptivity", "data", "virtualScrolling", "columnHeaders", "filterRow", "headerPanel", "headerFilter", "sorting", "search", "rows", "pager", "columnsResizingReordering", "contextMenu", "keyboardNavigation", "errorHandling", "summary", "columnFixing", "export", "gridView"]);
        var TreeList = _ui.default.inherit({
            _activeStateUnit: DATAGRID_ROW_SELECTOR,
            _getDefaultOptions: function() {
                var that = this;
                var result = that.callBase();
                (0, _iterator.each)(_uiTree_list.default.modules, function() {
                    if ((0, _type.isFunction)(this.defaultOptions)) {
                        (0, _extend.extend)(true, result, this.defaultOptions())
                    }
                });
                return result
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: function() {
                        return (0, _themes.isMaterial)()
                    },
                    options: {
                        showRowLines: true,
                        showColumnLines: false,
                        headerFilter: {
                            height: 315
                        },
                        editing: {
                            useIcons: true
                        }
                    }
                }])
            },
            _init: function() {
                var that = this;
                that.callBase();
                _uiTree_list.default.processModules(that, _uiTree_list.default);
                callModuleItemsMethod(that, "init")
            },
            _clean: _common.noop,
            _optionChanged: function(args) {
                var that = this;
                callModuleItemsMethod(that, "optionChanged", [args]);
                if (!args.handled) {
                    that.callBase(args)
                }
            },
            _dimensionChanged: function() {
                this.updateDimensions(true)
            },
            _visibilityChanged: function(visible) {
                if (visible) {
                    this.updateDimensions()
                }
            },
            _initMarkup: function() {
                this.callBase.apply(this, arguments);
                this.$element().addClass(TREELIST_CLASS);
                this.getView("gridView").render(this.$element())
            },
            _renderContentImpl: function() {
                this.getView("gridView").update()
            },
            _renderContent: function() {
                var that = this;
                (0, _common.deferRender)(function() {
                    that._renderContentImpl()
                })
            },
            _dispose: function() {
                var that = this;
                that.callBase();
                callModuleItemsMethod(that, "dispose")
            },
            isReady: function() {
                return this.getController("data").isReady()
            },
            beginUpdate: function() {
                var that = this;
                that.callBase();
                callModuleItemsMethod(that, "beginUpdate")
            },
            endUpdate: function() {
                var that = this;
                callModuleItemsMethod(that, "endUpdate");
                that.callBase()
            },
            getController: function(name) {
                return this._controllers[name]
            },
            getView: function(name) {
                return this._views[name]
            },
            focus: function(element) {
                this.callBase();
                if ((0, _type.isDefined)(element)) {
                    this.getController("keyboardNavigation").focus(element)
                }
            }
        });
        TreeList.registerModule = _uiTree_list.default.registerModule.bind(_uiTree_list.default);
        (0, _component_registrator.default)("dxTreeList", TreeList);
        var _default = TreeList;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.column_headers.js ***!
      \******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.column_headers */ 379));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiTree_list.default.registerModule("columnHeaders", _uiGrid_core.default)
    },
    /*!**********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.columns_controller.js ***!
      \**********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.ColumnsController = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.columns_controller */ 381));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ColumnsController = _uiGrid_core.default.controllers.columns.inherit(function() {
            return {
                _getFirstItems: function(dataSourceAdapter) {
                    return this.callBase(dataSourceAdapter).map(function(node) {
                        return node.data
                    })
                },
                getFirstDataColumnIndex: function() {
                    var visibleColumns = this.getVisibleColumns();
                    var visibleColumnsLength = visibleColumns.length;
                    var firstDataColumnIndex = 0;
                    for (var i = 0; i <= visibleColumnsLength - 1; i++) {
                        if (!(0, _type.isDefined)(visibleColumns[i].command)) {
                            firstDataColumnIndex = visibleColumns[i].index;
                            break
                        }
                    }
                    return firstDataColumnIndex
                }
            }
        }());
        exports.ColumnsController = ColumnsController;
        _uiTree_list.default.registerModule("columns", {
            defaultOptions: _uiGrid_core.default.defaultOptions,
            controllers: {
                columns: ColumnsController
            }
        })
    },
    /*!*******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.data_controller.js ***!
      \*******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.DataController = void 0;
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _uiTree_list2 = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.data_source_adapter */ 425));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.data_controller */ 383));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DataController = _uiGrid_core.default.controllers.data.inherit(function() {
            return {
                _getDataSourceAdapter: function() {
                    return _uiTree_list2.default
                },
                _getNodeLevel: function(node) {
                    var level = -1;
                    while (node.parent) {
                        if (node.visible) {
                            level++
                        }
                        node = node.parent
                    }
                    return level
                },
                _generateDataItem: function(node, options) {
                    return {
                        rowType: "data",
                        node: node,
                        key: node.key,
                        data: node.data,
                        isExpanded: this.isRowExpanded(node.key, options),
                        level: this._getNodeLevel(node)
                    }
                },
                _loadOnOptionChange: function() {
                    this._dataSource.load()
                },
                _isItemEquals: function(item1, item2) {
                    if (!this.callBase.apply(this, arguments)) {
                        return false
                    }
                    if (item1.node && item2.node && item1.node.hasChildren !== item2.node.hasChildren) {
                        return false
                    }
                    if (item1.level !== item2.level) {
                        return false
                    }
                    return true
                },
                init: function() {
                    this.createAction("onRowExpanding");
                    this.createAction("onRowExpanded");
                    this.createAction("onRowCollapsing");
                    this.createAction("onRowCollapsed");
                    this.callBase.apply(this, arguments)
                },
                keyOf: function(data) {
                    var dataSource = this._dataSource;
                    if (dataSource) {
                        return dataSource.keyOf(data)
                    }
                },
                key: function() {
                    var dataSource = this._dataSource;
                    if (dataSource) {
                        return dataSource.getKeyExpr()
                    }
                },
                publicMethods: function() {
                    return this.callBase().concat(["expandRow", "collapseRow", "isRowExpanded", "getRootNode", "getNodeByKey", "loadDescendants", "forEachNode"])
                },
                changeRowExpand: function(key) {
                    if (this._dataSource) {
                        var that = this;
                        var args = {
                            key: key
                        };
                        var isExpanded = this.isRowExpanded(key);
                        that.executeAction(isExpanded ? "onRowCollapsing" : "onRowExpanding", args);
                        if (!args.cancel) {
                            return that._dataSource.changeRowExpand(key).done(function() {
                                that.executeAction(isExpanded ? "onRowCollapsed" : "onRowExpanded", args)
                            })
                        }
                    }
                    return (new _deferred.Deferred).resolve()
                },
                isRowExpanded: function(key, cache) {
                    return this._dataSource && this._dataSource.isRowExpanded(key, cache)
                },
                expandRow: function(key) {
                    if (!this.isRowExpanded(key)) {
                        return this.changeRowExpand(key)
                    }
                    return (new _deferred.Deferred).resolve()
                },
                collapseRow: function(key) {
                    if (this.isRowExpanded(key)) {
                        return this.changeRowExpand(key)
                    }
                    return (new _deferred.Deferred).resolve()
                },
                getRootNode: function() {
                    return this._dataSource && this._dataSource.getRootNode()
                },
                optionChanged: function(args) {
                    switch (args.name) {
                        case "rootValue":
                        case "parentIdExpr":
                        case "itemsExpr":
                        case "filterMode":
                        case "expandNodesOnFiltering":
                        case "autoExpandAll":
                        case "hasItemsExpr":
                        case "dataStructure":
                            this._columnsController.reset();
                            this._items = [];
                            this._refreshDataSource();
                            args.handled = true;
                            break;
                        case "expandedRowKeys":
                        case "onNodesInitialized":
                            if (this._dataSource && !this._dataSource._isNodesInitializing && !(0, _common.equalByValue)(args.value, args.previousValue)) {
                                this._loadOnOptionChange()
                            }
                            args.handled = true;
                            break;
                        case "maxFilterLengthInRequest":
                            args.handled = true;
                            break;
                        default:
                            this.callBase(args)
                    }
                },
                getNodeByKey: function(key) {
                    if (!this._dataSource) {
                        return
                    }
                    return this._dataSource.getNodeByKey(key)
                },
                getChildNodeKeys: function(parentKey) {
                    if (!this._dataSource) {
                        return
                    }
                    return this._dataSource.getChildNodeKeys(parentKey)
                },
                loadDescendants: function(keys, childrenOnly) {
                    if (!this._dataSource) {
                        return
                    }
                    return this._dataSource.loadDescendants(keys, childrenOnly)
                },
                forEachNode: function() {
                    this._dataSource.forEachNode.apply(this, arguments)
                }
            }
        }());
        exports.DataController = DataController;
        _uiTree_list.default.registerModule("data", {
            defaultOptions: function() {
                return (0, _extend.extend)({}, _uiGrid_core.default.defaultOptions(), {
                    itemsExpr: "items",
                    parentIdExpr: "parentId",
                    rootValue: 0,
                    dataStructure: "plain",
                    expandedRowKeys: [],
                    filterMode: "withAncestors",
                    expandNodesOnFiltering: true,
                    autoExpandAll: false,
                    onNodesInitialized: null,
                    maxFilterLengthInRequest: 1500,
                    paging: {
                        enabled: false
                    }
                })
            },
            controllers: {
                data: DataController
            }
        })
    },
    /*!***********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.sorting.js ***!
      \***********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.sorting */ 384));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiTree_list.default.registerModule("sorting", _uiGrid_core.default)
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.rows.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.RowsView = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.rows */ 386));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var TREELIST_TEXT_CONTENT = "dx-treelist-text-content";
        var TREELIST_EXPAND_ICON_CONTAINER_CLASS = "dx-treelist-icon-container";
        var TREELIST_CELL_EXPANDABLE_CLASS = "dx-treelist-cell-expandable";
        var TREELIST_EMPTY_SPACE = "dx-treelist-empty-space";
        var TREELIST_EXPANDED_CLASS = "dx-treelist-expanded";
        var TREELIST_COLLAPSED_CLASS = "dx-treelist-collapsed";
        var RowsView = _uiGrid_core.default.views.rowsView.inherit(function() {
            var createCellContent = function($container) {
                return (0, _renderer.default)("<div>").addClass(TREELIST_TEXT_CONTENT).appendTo($container)
            };
            var createIcon = function(hasIcon, isExpanded) {
                var $iconElement = (0, _renderer.default)("<div>").addClass(TREELIST_EMPTY_SPACE);
                if (hasIcon) {
                    $iconElement.toggleClass(TREELIST_EXPANDED_CLASS, isExpanded).toggleClass(TREELIST_COLLAPSED_CLASS, !isExpanded).append((0, _renderer.default)("<span>"))
                }
                return $iconElement
            };
            return {
                _renderIconContainer: function($container, options) {
                    var _this = this;
                    var $iconContainer = (0, _renderer.default)("<div>").addClass(TREELIST_EXPAND_ICON_CONTAINER_CLASS).appendTo($container);
                    options.watch && options.watch(function() {
                        return [options.row.level, options.row.isExpanded, options.row.node.hasChildren]
                    }, function() {
                        $iconContainer.empty();
                        _this._renderIcons($iconContainer, options)
                    });
                    $container.addClass(TREELIST_CELL_EXPANDABLE_CLASS);
                    return this._renderIcons($iconContainer, options)
                },
                _renderIcons: function($iconContainer, options) {
                    var row = options.row;
                    var level = row.level;
                    for (var i = 0; i <= level; i++) {
                        $iconContainer.append(createIcon(i === level && row.node.hasChildren, row.isExpanded))
                    }
                    return $iconContainer
                },
                _renderCellCommandContent: function(container, model) {
                    this._renderIconContainer(container, model);
                    return true
                },
                _processTemplate: function(template, options) {
                    var that = this;
                    var resultTemplate;
                    var renderingTemplate = this.callBase(template);
                    var firstDataColumnIndex = that._columnsController.getFirstDataColumnIndex();
                    if (renderingTemplate && options.column.index === firstDataColumnIndex) {
                        resultTemplate = {
                            render: function(options) {
                                var $container = options.container;
                                if (that._renderCellCommandContent($container, options.model)) {
                                    options.container = createCellContent($container)
                                }
                                renderingTemplate.render(options)
                            }
                        }
                    } else {
                        resultTemplate = renderingTemplate
                    }
                    return resultTemplate
                },
                _updateCell: function($cell, options) {
                    $cell = $cell.hasClass(TREELIST_TEXT_CONTENT) ? $cell.parent() : $cell;
                    this.callBase($cell, options)
                },
                _rowClick: function(e) {
                    var dataController = this._dataController;
                    var $targetElement = (0, _renderer.default)(e.event.target);
                    var isExpandIcon = this.isExpandIcon($targetElement);
                    var item = dataController && dataController.items()[e.rowIndex];
                    if (isExpandIcon && item) {
                        dataController.changeRowExpand(item.key)
                    }
                    this.callBase(e)
                },
                _createRow: function(row) {
                    var node = row && row.node;
                    var $rowElement = this.callBase.apply(this, arguments);
                    if (node) {
                        this.setAria("level", row.level, $rowElement);
                        if (node.hasChildren) {
                            this.setAria("expanded", row.isExpanded, $rowElement)
                        }
                    }
                    return $rowElement
                },
                isExpandIcon: function($targetElement) {
                    return !!$targetElement.closest("." + TREELIST_EXPANDED_CLASS + ", ." + TREELIST_COLLAPSED_CLASS).length
                }
            }
        }());
        exports.RowsView = RowsView;
        _uiTree_list.default.registerModule("rows", {
            defaultOptions: _uiGrid_core.default.defaultOptions,
            views: {
                rowsView: RowsView
            }
        })
    },
    /*!****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.context_menu.js ***!
      \****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.context_menu */ 387));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiTree_list.default.registerModule("contextMenu", _uiGrid_core.default)
    },
    /*!******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.error_handling.js ***!
      \******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.error_handling */ 388));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiTree_list.default.registerModule("errorHandling", _uiGrid_core.default)
    },
    /*!*************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.grid_view.js ***!
      \*************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.grid_view */ 389));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var GridView = _uiGrid_core.default.views.gridView.inherit(function() {
            return {
                _getWidgetAriaLabel: function() {
                    return "dxTreeList-ariaTreeList"
                },
                _getTableRoleName: function() {
                    return "treegrid"
                }
            }
        }());
        _uiTree_list.default.registerModule("gridView", {
            defaultOptions: _uiGrid_core.default.defaultOptions,
            controllers: _uiGrid_core.default.controllers,
            views: {
                gridView: GridView
            },
            extenders: {
                controllers: {
                    resizing: {
                        _toggleBestFitMode: function(isBestFit) {
                            this.callBase(isBestFit);
                            if (!this.option("legacyRendering")) {
                                var $rowsTable = this._rowsView.getTableElement();
                                $rowsTable.find(".dx-treelist-cell-expandable").toggleClass(this.addWidgetPrefix("best-fit"), isBestFit)
                            }
                        }
                    }
                }
            }
        })
    },
    /*!****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.header_panel.js ***!
      \****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.header_panel */ 390));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiTree_list.default.registerModule("headerPanel", _uiGrid_core.default)
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.state_storing.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.state_storing */ 391));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var origApplyState = _uiGrid_core.default.extenders.controllers.stateStoring.applyState;
        _uiTree_list.default.registerModule("stateStoring", (0, _extend.extend)(true, {}, _uiGrid_core.default, {
            extenders: {
                controllers: {
                    stateStoring: {
                        applyState: function(state) {
                            origApplyState.apply(this, arguments);
                            if (Object.prototype.hasOwnProperty.call(state, "expandedRowKeys")) {
                                this.option("expandedRowKeys", state.expandedRowKeys && state.expandedRowKeys.slice())
                            }
                        }
                    },
                    data: {
                        getUserState: function() {
                            var state = this.callBase.apply(this, arguments);
                            if (!this.option("autoExpandAll")) {
                                state.expandedRowKeys = this.option("expandedRowKeys")
                            }
                            return state
                        }
                    }
                }
            }
        }))
    },
    /*!******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.column_chooser.js ***!
      \******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.column_chooser */ 394));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiTree_list.default.registerModule("columnChooser", _uiGrid_core.default)
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.master_detail.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.master_detail */ 397));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiTree_list.default.registerModule("masterDetail", (0, _extend.extend)(true, {}, _uiGrid_core.default, {
            extenders: {
                controllers: {
                    data: {
                        isRowExpanded: function() {
                            return this.callBase.apply(this, arguments)
                        },
                        _processItems: function() {
                            return this.callBase.apply(this, arguments)
                        },
                        _processDataItem: function() {
                            return this.callBase.apply(this, arguments)
                        }
                    }
                }
            }
        }))
    },
    /*!***********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.editing.js ***!
      \***********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        __webpack_require__( /*! ./ui.tree_list.editor_factory */ 751);
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _uiTree_list2 = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.utils */ 35));
        var _uiGrid_core2 = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.editing */ 400));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var TREELIST_EXPAND_ICON_CONTAINER_CLASS = "dx-treelist-icon-container";
        var SELECT_CHECKBOX_CLASS = "dx-select-checkbox";
        var DATA_EDIT_DATA_INSERT_TYPE = "insert";
        var EditingController = _uiGrid_core2.default.controllers.editing.inherit(function() {
            return {
                _generateNewItem: function(key) {
                    var item = this.callBase(key);
                    item.data = {
                        key: key
                    };
                    item.children = [];
                    item.level = 0;
                    item.parentKey = this.option("rootValue");
                    return item
                },
                _needInsertItem: function(change, changeType, items, item) {
                    var parentKey = change.key.parentKey;
                    if (void 0 !== parentKey && parentKey !== this.option("rootValue")) {
                        var rowIndex = _uiGrid_core.default.getIndexByKey(parentKey, items);
                        if (rowIndex >= 0 && this._dataController.isRowExpanded(parentKey)) {
                            items.splice(rowIndex + 1, 0, item)
                        }
                        return false
                    }
                    return this.callBase.apply(this, arguments)
                },
                _isEditColumnVisible: function() {
                    var result = this.callBase.apply(this, arguments);
                    var editingOptions = this.option("editing");
                    return result || editingOptions && editingOptions.allowAdding
                },
                _isDefaultButtonVisible: function(button, options) {
                    var result = this.callBase.apply(this, arguments);
                    var row = options.row;
                    if ("add" === button.name) {
                        return this.allowAdding(options) && row.rowIndex !== this._getVisibleEditRowIndex() && !(row.removed || row.isNewRow)
                    }
                    return result
                },
                _getEditingButtons: function(options) {
                    var buttons = this.callBase.apply(this, arguments);
                    if (!options.column.buttons) {
                        buttons.unshift(this._getButtonConfig("add", options))
                    }
                    return buttons
                },
                _beforeSaveEditData: function(change) {
                    var dataController = this._dataController;
                    var result = this.callBase.apply(this, arguments);
                    if (change && change.type !== DATA_EDIT_DATA_INSERT_TYPE) {
                        var store = null === dataController || void 0 === dataController ? void 0 : dataController.store();
                        var key = null === store || void 0 === store ? void 0 : store.key();
                        if (!(0, _type.isDefined)(key)) {
                            throw _ui.default.Error("E1045")
                        }
                    }
                    return result
                },
                addRowByRowIndex: function(rowIndex) {
                    var dataController = this.getController("data");
                    var row = dataController.getVisibleRows()[rowIndex];
                    return this.addRow(row ? row.key : void 0)
                },
                addRow: function(key) {
                    var that = this;
                    var callBase = that.callBase;
                    var dataController = that.getController("data");
                    if (void 0 !== key && !dataController.isRowExpanded(key)) {
                        var deferred = new _deferred.Deferred;
                        dataController.expandRow(key).done(function() {
                            setTimeout(function() {
                                callBase.call(that, key).done(deferred.resolve).fail(deferred.reject)
                            })
                        }).fail(deferred.reject);
                        return deferred.promise()
                    }
                    if (void 0 === key) {
                        key = that.option("rootValue")
                    }
                    return callBase.call(that, key)
                },
                _initNewRow: function(options, parentKey) {
                    var dataController = this.getController("data");
                    var dataSourceAdapter = dataController.dataSource();
                    var parentIdSetter = dataSourceAdapter.createParentIdSetter();
                    parentIdSetter(options.data, parentKey);
                    return this.callBase.apply(this, arguments)
                },
                allowAdding: function(options) {
                    return this._allowEditAction("allowAdding", options)
                },
                _needToCloseEditableCell: function($targetElement) {
                    return this.callBase.apply(this, arguments) || $targetElement.closest("." + TREELIST_EXPAND_ICON_CONTAINER_CLASS).length && this.isEditing()
                },
                getButtonLocalizationNames: function() {
                    var names = this.callBase.apply(this);
                    names.add = "dxTreeList-editingAddRowToNode";
                    return names
                }
            }
        }());
        var originalRowClick = _uiGrid_core2.default.extenders.views.rowsView._rowClick;
        var originalRowDblClick = _uiGrid_core2.default.extenders.views.rowsView._rowDblClick;
        var validateClick = function(e) {
            var $targetElement = (0, _renderer.default)(e.event.target);
            var originalClickHandler = "dxdblclick" === e.event.type ? originalRowDblClick : originalRowClick;
            if ($targetElement.closest("." + SELECT_CHECKBOX_CLASS).length) {
                return false
            }
            return !needToCallOriginalClickHandler.call(this, e, originalClickHandler)
        };

        function needToCallOriginalClickHandler(e, originalClickHandler) {
            var $targetElement = (0, _renderer.default)(e.event.target);
            if (!$targetElement.closest("." + TREELIST_EXPAND_ICON_CONTAINER_CLASS).length) {
                originalClickHandler.call(this, e);
                return true
            }
            return false
        }
        var RowsViewExtender = (0, _extend.extend)({}, _uiGrid_core2.default.extenders.views.rowsView, {
            _renderCellCommandContent: function($container, options) {
                var editingController = this._editingController;
                var isEditRow = options.row && editingController.isEditRow(options.row.rowIndex);
                var isEditing = options.isEditing || isEditRow;
                if (!isEditing) {
                    return this.callBase.apply(this, arguments)
                }
                return false
            },
            _rowClick: function(e) {
                if (validateClick.call(this, e)) {
                    this.callBase.apply(this, arguments)
                }
            },
            _rowDblClick: function(e) {
                if (validateClick.call(this, e)) {
                    this.callBase.apply(this, arguments)
                }
            }
        });
        _uiTree_list2.default.registerModule("editing", {
            defaultOptions: function() {
                return (0, _extend.extend)(true, _uiGrid_core2.default.defaultOptions(), {
                    editing: {
                        texts: {
                            addRowToNode: _message.default.format("dxTreeList-editingAddRowToNode")
                        }
                    }
                })
            },
            controllers: {
                editing: EditingController
            },
            extenders: {
                controllers: (0, _extend.extend)(true, {}, _uiGrid_core2.default.extenders.controllers, {
                    data: {
                        changeRowExpand: function() {
                            this._editingController.refresh();
                            return this.callBase.apply(this, arguments)
                        }
                    }
                }),
                views: {
                    rowsView: RowsViewExtender,
                    headerPanel: _uiGrid_core2.default.extenders.views.headerPanel
                }
            }
        })
    },
    /*!******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.editor_factory.js ***!
      \******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.editor_factory */ 398));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiTree_list.default.registerModule("editorFactory", _uiGrid_core.default)
    },
    /*!**************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.validating.js ***!
      \**************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.validating */ 401));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var EditingControllerExtender = (0, _extend.extend)({}, _uiGrid_core.default.extenders.controllers.editing);
        delete EditingControllerExtender.processItems;
        delete EditingControllerExtender.processDataItem;
        _uiTree_list.default.registerModule("validating", {
            defaultOptions: _uiGrid_core.default.defaultOptions,
            controllers: _uiGrid_core.default.controllers,
            extenders: {
                controllers: {
                    editing: EditingControllerExtender,
                    editorFactory: _uiGrid_core.default.extenders.controllers.editorFactory
                },
                views: _uiGrid_core.default.extenders.views
            }
        })
    },
    /*!*********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.virtual_scrolling.js ***!
      \*********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _uiTree_list2 = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.data_source_adapter */ 425));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.virtual_scrolling */ 402));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var oldDefaultOptions = _uiGrid_core.default.defaultOptions;
        var originalDataControllerExtender = _uiGrid_core.default.extenders.controllers.data;
        var originalDataSourceAdapterExtender = _uiGrid_core.default.extenders.dataSourceAdapter;
        _uiGrid_core.default.extenders.controllers.data = (0, _extend.extend)({}, originalDataControllerExtender, {
            _loadOnOptionChange: function() {
                var virtualScrollController = this._dataSource && this._dataSource._virtualScrollController;
                virtualScrollController && virtualScrollController.reset();
                this.callBase()
            }
        });
        _uiGrid_core.default.extenders.dataSourceAdapter = (0, _extend.extend)({}, originalDataSourceAdapterExtender, {
            changeRowExpand: function() {
                var _this = this;
                return this.callBase.apply(this, arguments).done(function() {
                    var viewportItemIndex = _this.getViewportItemIndex();
                    viewportItemIndex >= 0 && _this.setViewportItemIndex(viewportItemIndex)
                })
            }
        });
        _uiTree_list.default.registerModule("virtualScrolling", (0, _extend.extend)({}, _uiGrid_core.default, {
            defaultOptions: function() {
                return (0, _extend.extend)(true, oldDefaultOptions(), {
                    scrolling: {
                        mode: "virtual"
                    }
                })
            }
        }));
        _uiTree_list2.default.extend(_uiGrid_core.default.extenders.dataSourceAdapter)
    },
    /*!**************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.filter_row.js ***!
      \**************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.filter_row */ 404));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiTree_list.default.registerModule("filterRow", _uiGrid_core.default)
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.header_filter.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.header_filter */ 407));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiTree_list.default.registerModule("headerFilter", _uiGrid_core.default)
    },
    /*!***************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.filter_sync.js ***!
      \***************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.filter_sync */ 409));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiTree_list.default.registerModule("filterSync", _uiGrid_core.default)
    },
    /*!******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.filter_builder.js ***!
      \******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.filter_builder */ 410));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiTree_list.default.registerModule("filterBuilder", _uiGrid_core.default)
    },
    /*!****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.filter_panel.js ***!
      \****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.filter_panel */ 412));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiTree_list.default.registerModule("filterPanel", _uiGrid_core.default)
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.pager.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.pager */ 414));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiTree_list.default.registerModule("pager", _uiGrid_core.default)
    },
    /*!*******************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.columns_resizing_reordering.js ***!
      \*******************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.columns_resizing_reordering */ 415));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiTree_list.default.registerModule("columnsResizingReordering", _uiGrid_core.default)
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.column_fixing.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.column_fixing */ 417));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiTree_list.default.registerModule("columnFixing", _uiGrid_core.default)
    },
    /*!**************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.adaptivity.js ***!
      \**************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.adaptivity */ 418));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiTree_list.default.registerModule("adaptivity", _uiGrid_core.default)
    },
    /*!*************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.selection.js ***!
      \*************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.selection */ 393));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var TREELIST_SELECT_ALL_CLASS = "dx-treelist-select-all";
        var CELL_FOCUS_DISABLED_CLASS = "dx-cell-focus-disabled";
        var SELECT_CHECKBOX_CLASS = "dx-select-checkbox";
        var originalRowClick = _uiGrid_core.default.extenders.views.rowsView._rowClick;
        var originalHandleDataChanged = _uiGrid_core.default.extenders.controllers.data._handleDataChanged;
        var nodeExists = function(array, currentKey) {
            return !!array.filter(function(key) {
                return key === currentKey
            }).length
        };
        _uiTree_list.default.registerModule("selection", (0, _extend.extend)(true, {}, _uiGrid_core.default, {
            defaultOptions: function() {
                return (0, _extend.extend)(true, _uiGrid_core.default.defaultOptions(), {
                    selection: {
                        showCheckBoxesMode: "always",
                        recursive: false
                    }
                })
            },
            extenders: {
                controllers: {
                    data: {
                        _handleDataChanged: function(e) {
                            var selectionController = this.getController("selection");
                            var isRecursiveSelection = selectionController.isRecursiveSelection();
                            if (isRecursiveSelection && (!e || "updateSelectionState" !== e.changeType)) {
                                selectionController.updateSelectionState({
                                    selectedItemKeys: this.option("selectedRowKeys")
                                })
                            }
                            originalHandleDataChanged.apply(this, arguments)
                        },
                        loadDescendants: function() {
                            var that = this;
                            var d = that.callBase.apply(that, arguments);
                            var selectionController = that.getController("selection");
                            var isRecursiveSelection = selectionController.isRecursiveSelection();
                            if (isRecursiveSelection) {
                                d.done(function() {
                                    selectionController.updateSelectionState({
                                        selectedItemKeys: that.option("selectedRowKeys")
                                    })
                                })
                            }
                            return d
                        }
                    },
                    selection: {
                        init: function() {
                            this.callBase.apply(this, arguments);
                            this._selectionStateByKey = {}
                        },
                        _getSelectionConfig: function() {
                            var _arguments = arguments,
                                _this = this;
                            var config = this.callBase.apply(this, arguments);
                            var plainItems = config.plainItems;
                            config.plainItems = function(all) {
                                if (all) {
                                    return _this._dataController.getCachedStoreData() || []
                                }
                                return plainItems.apply(_this, _arguments).map(function(item) {
                                    return item.data
                                })
                            };
                            config.isItemSelected = function(item) {
                                var key = _this._dataController.keyOf(item);
                                return _this.isRowSelected(key)
                            };
                            config.isSelectableItem = function() {
                                return true
                            };
                            config.getItemData = function(item) {
                                return item
                            };
                            return config
                        },
                        renderSelectCheckBoxContainer: function($container, model) {
                            var that = this;
                            var rowsView = that.component.getView("rowsView");
                            $container.addClass(CELL_FOCUS_DISABLED_CLASS);
                            var $checkbox = rowsView._renderSelectCheckBox($container, {
                                value: model.row.isSelected,
                                row: model.row,
                                column: model.column
                            });
                            rowsView._attachCheckBoxClickEvent($checkbox)
                        },
                        _updateSelectColumn: _common.noop,
                        _getSelectAllNodeKeys: function() {
                            var component = this.component;
                            var root = component.getRootNode();
                            var cache = {};
                            var keys = [];
                            var isRecursiveSelection = this.isRecursiveSelection();
                            root && _uiTree_list.default.foreachNodes(root.children, function(node) {
                                if (void 0 !== node.key && (node.visible || isRecursiveSelection)) {
                                    keys.push(node.key)
                                }
                                if (!node.visible) {
                                    return true
                                }
                                return isRecursiveSelection ? false : component.isRowExpanded(node.key, cache)
                            });
                            return keys
                        },
                        isSelectAll: function() {
                            var component = this.component;
                            var visibleKeys = this._getSelectAllNodeKeys();
                            var selectedVisibleKeys = visibleKeys.filter(function(key) {
                                return component.isRowSelected(key)
                            });
                            if (!selectedVisibleKeys.length) {
                                var hasIndeterminateState = visibleKeys.some(function(key) {
                                    return void 0 === component.isRowSelected(key)
                                });
                                return hasIndeterminateState ? void 0 : false
                            } else {
                                if (selectedVisibleKeys.length === visibleKeys.length) {
                                    return true
                                }
                            }
                        },
                        selectAll: function() {
                            var _this2 = this;
                            var visibleKeys = this._getSelectAllNodeKeys().filter(function(key) {
                                return !_this2.isRowSelected(key)
                            });
                            this.focusedItemIndex(-1);
                            return this.selectRows(visibleKeys, true)
                        },
                        deselectAll: function() {
                            var visibleKeys = this._getSelectAllNodeKeys();
                            this.focusedItemIndex(-1);
                            return this.deselectRows(visibleKeys)
                        },
                        selectedItemKeys: function(value, preserve, isDeselect, isSelectAll) {
                            var that = this;
                            var selectedRowKeys = that.option("selectedRowKeys");
                            var isRecursiveSelection = this.isRecursiveSelection();
                            var normalizedArgs = isRecursiveSelection && that._normalizeSelectionArgs({
                                keys: (0, _type.isDefined)(value) ? value : []
                            }, !isDeselect);
                            if (normalizedArgs && !(0, _common.equalByValue)(normalizedArgs.selectedRowKeys, selectedRowKeys)) {
                                that._isSelectionNormalizing = true;
                                return this.callBase(normalizedArgs.selectedRowKeys, false, false, false).always(function() {
                                    that._isSelectionNormalizing = false
                                }).done(function(items) {
                                    normalizedArgs.selectedRowsData = items;
                                    that._fireSelectionChanged(normalizedArgs)
                                })
                            }
                            return this.callBase(value, preserve, isDeselect, isSelectAll)
                        },
                        changeItemSelection: function(itemIndex, keyboardKeys) {
                            var isRecursiveSelection = this.isRecursiveSelection();
                            if (isRecursiveSelection && !keyboardKeys.shift) {
                                var key = this._dataController.getKeyByRowIndex(itemIndex);
                                return this.selectedItemKeys(key, true, this.isRowSelected(key))
                            }
                            return this.callBase.apply(this, arguments)
                        },
                        _updateParentSelectionState: function(node, isSelected) {
                            var that = this;
                            var state = isSelected;
                            var parentNode = node.parent;
                            if (parentNode) {
                                if (parentNode.children.length > 1) {
                                    if (false === isSelected) {
                                        var hasSelectedState = parentNode.children.some(function(childNode, index, children) {
                                            return that._selectionStateByKey[childNode.key]
                                        });
                                        state = hasSelectedState ? void 0 : false
                                    } else {
                                        if (true === isSelected) {
                                            var hasNonSelectedState = parentNode.children.some(function(childNode) {
                                                return !that._selectionStateByKey[childNode.key]
                                            });
                                            state = hasNonSelectedState ? void 0 : true
                                        }
                                    }
                                }
                                this._selectionStateByKey[parentNode.key] = state;
                                if (parentNode.parent && parentNode.parent.level >= 0) {
                                    this._updateParentSelectionState(parentNode, state)
                                }
                            }
                        },
                        _updateChildrenSelectionState: function(node, isSelected) {
                            var that = this;
                            var children = node.children;
                            children && children.forEach(function(childNode) {
                                that._selectionStateByKey[childNode.key] = isSelected;
                                if (childNode.children.length > 0) {
                                    that._updateChildrenSelectionState(childNode, isSelected)
                                }
                            })
                        },
                        _updateSelectionStateCore: function(keys, isSelected) {
                            var dataController = this._dataController;
                            for (var i = 0; i < keys.length; i++) {
                                this._selectionStateByKey[keys[i]] = isSelected;
                                var node = dataController.getNodeByKey(keys[i]);
                                if (node) {
                                    this._updateParentSelectionState(node, isSelected);
                                    this._updateChildrenSelectionState(node, isSelected)
                                }
                            }
                        },
                        _getSelectedParentKeys: function(key, selectedItemKeys, useCash) {
                            var selectedParentNode;
                            var node = this._dataController.getNodeByKey(key);
                            var parentNode = node && node.parent;
                            var result = [];
                            while (parentNode && parentNode.level >= 0) {
                                result.unshift(parentNode.key);
                                var isSelected = useCash ? !nodeExists(selectedItemKeys, parentNode.key) && this.isRowSelected(parentNode.key) : selectedItemKeys.indexOf(parentNode.key) >= 0;
                                if (isSelected) {
                                    selectedParentNode = parentNode;
                                    result = this._getSelectedParentKeys(selectedParentNode.key, selectedItemKeys, useCash).concat(result);
                                    break
                                } else {
                                    if (useCash) {
                                        break
                                    }
                                }
                                parentNode = parentNode.parent
                            }
                            return selectedParentNode && result || []
                        },
                        _getSelectedChildKeys: function(key, keysToIgnore) {
                            var _this3 = this;
                            var childKeys = [];
                            var node = this._dataController.getNodeByKey(key);
                            node && _uiTree_list.default.foreachNodes(node.children, function(childNode) {
                                var ignoreKeyIndex = keysToIgnore.indexOf(childNode.key);
                                if (ignoreKeyIndex < 0) {
                                    childKeys.push(childNode.key)
                                }
                                return ignoreKeyIndex > 0 || ignoreKeyIndex < 0 && void 0 === _this3._selectionStateByKey[childNode.key]
                            });
                            return childKeys
                        },
                        _normalizeParentKeys: function(key, args) {
                            var that = this;
                            var keysToIgnore = [key];
                            var parentNodeKeys = that._getSelectedParentKeys(key, args.selectedRowKeys);
                            if (parentNodeKeys.length) {
                                keysToIgnore = keysToIgnore.concat(parentNodeKeys);
                                keysToIgnore.forEach(function(key) {
                                    var index = args.selectedRowKeys.indexOf(key);
                                    if (index >= 0) {
                                        args.selectedRowKeys.splice(index, 1)
                                    }
                                });
                                var childKeys = that._getSelectedChildKeys(parentNodeKeys[0], keysToIgnore);
                                args.selectedRowKeys = args.selectedRowKeys.concat(childKeys)
                            }
                        },
                        _normalizeChildrenKeys: function(key, args) {
                            var _this4 = this;
                            var node = this._dataController.getNodeByKey(key);
                            node && node.children.forEach(function(childNode) {
                                var index = args.selectedRowKeys.indexOf(childNode.key);
                                if (index >= 0) {
                                    args.selectedRowKeys.splice(index, 1)
                                }
                                _this4._normalizeChildrenKeys(childNode.key, args)
                            })
                        },
                        _normalizeSelectedRowKeysCore: function(keys, args, isSelect) {
                            var that = this;
                            keys.forEach(function(key) {
                                if (that.isRowSelected(key) === isSelect) {
                                    return
                                }
                                that._normalizeChildrenKeys(key, args);
                                var index = args.selectedRowKeys.indexOf(key);
                                if (isSelect) {
                                    if (index < 0) {
                                        args.selectedRowKeys.push(key)
                                    }
                                    args.currentSelectedRowKeys.push(key)
                                } else {
                                    if (index >= 0) {
                                        args.selectedRowKeys.splice(index, 1)
                                    }
                                    args.currentDeselectedRowKeys.push(key);
                                    that._normalizeParentKeys(key, args)
                                }
                            })
                        },
                        _normalizeSelectionArgs: function(args, isSelect) {
                            var result;
                            var keys = Array.isArray(args.keys) ? args.keys : [args.keys];
                            var selectedRowKeys = this.option("selectedRowKeys") || [];
                            if (keys.length) {
                                result = {
                                    currentSelectedRowKeys: [],
                                    currentDeselectedRowKeys: [],
                                    selectedRowKeys: selectedRowKeys.slice(0)
                                };
                                this._normalizeSelectedRowKeysCore(keys, result, isSelect)
                            }
                            return result
                        },
                        _updateSelectedItems: function(args) {
                            this.updateSelectionState(args);
                            this.callBase(args)
                        },
                        _fireSelectionChanged: function() {
                            if (!this._isSelectionNormalizing) {
                                this.callBase.apply(this, arguments)
                            }
                        },
                        _isModeLeavesOnly: function(mode) {
                            return "leavesOnly" === mode
                        },
                        _removeDuplicatedKeys: function(keys) {
                            var result = [];
                            var processedKeys = {};
                            keys.forEach(function(key) {
                                if (!processedKeys[key]) {
                                    processedKeys[key] = true;
                                    result.push(key)
                                }
                            });
                            return result
                        },
                        _getAllChildKeys: function(key) {
                            var childKeys = [];
                            var node = this._dataController.getNodeByKey(key);
                            node && _uiTree_list.default.foreachNodes(node.children, function(childNode) {
                                childKeys.push(childNode.key)
                            }, true);
                            return childKeys
                        },
                        _getAllSelectedRowKeys: function(keys) {
                            var _this5 = this;
                            var result = [];
                            keys.forEach(function(key) {
                                var parentKeys = _this5._getSelectedParentKeys(key, [], true);
                                var childKeys = _this5._getAllChildKeys(key);
                                result.push.apply(result, parentKeys.concat([key], childKeys))
                            });
                            result = this._removeDuplicatedKeys(result);
                            return result
                        },
                        _getParentSelectedRowKeys: function(keys) {
                            var that = this;
                            var result = [];
                            keys.forEach(function(key) {
                                var parentKeys = that._getSelectedParentKeys(key, keys);
                                !parentKeys.length && result.push(key)
                            });
                            return result
                        },
                        _getLeafSelectedRowKeys: function(keys) {
                            var that = this;
                            var result = [];
                            var dataController = that._dataController;
                            keys.forEach(function(key) {
                                var node = dataController.getNodeByKey(key);
                                node && !node.hasChildren && result.push(key)
                            });
                            return result
                        },
                        isRecursiveSelection: function() {
                            var selectionMode = this.option("selection.mode");
                            var isRecursive = this.option("selection.recursive");
                            return "multiple" === selectionMode && isRecursive
                        },
                        updateSelectionState: function(options) {
                            var removedItemKeys = options.removedItemKeys || [];
                            var selectedItemKeys = options.selectedItemKeys || [];
                            this._updateSelectionStateCore(removedItemKeys, false);
                            this._updateSelectionStateCore(selectedItemKeys, true)
                        },
                        isRowSelected: function(key) {
                            var result = this.callBase.apply(this, arguments);
                            var isRecursiveSelection = this.isRecursiveSelection();
                            if (!result && isRecursiveSelection) {
                                if (key in this._selectionStateByKey) {
                                    return this._selectionStateByKey[key]
                                }
                                return false
                            }
                            return result
                        },
                        getSelectedRowKeys: function(mode) {
                            var that = this;
                            if (!that._dataController) {
                                return []
                            }
                            var selectedRowKeys = that.callBase.apply(that, arguments);
                            if (mode) {
                                if (this.isRecursiveSelection()) {
                                    selectedRowKeys = this._getAllSelectedRowKeys(selectedRowKeys)
                                }
                                if ("all" !== mode) {
                                    if ("excludeRecursive" === mode) {
                                        selectedRowKeys = that._getParentSelectedRowKeys(selectedRowKeys)
                                    } else {
                                        if (that._isModeLeavesOnly(mode)) {
                                            selectedRowKeys = that._getLeafSelectedRowKeys(selectedRowKeys)
                                        }
                                    }
                                }
                            }
                            return selectedRowKeys
                        },
                        getSelectedRowsData: function(mode) {
                            var that = this;
                            var dataController = that._dataController;
                            var selectedKeys = this.getSelectedRowKeys(mode) || [];
                            var selectedRowsData = [];
                            selectedKeys.forEach(function(key) {
                                var node = dataController.getNodeByKey(key);
                                node && selectedRowsData.push(node.data)
                            });
                            return selectedRowsData
                        },
                        refresh: function() {
                            this._selectionStateByKey = {};
                            return this.callBase.apply(this, arguments)
                        }
                    }
                },
                views: {
                    columnHeadersView: {
                        _processTemplate: function(template, options) {
                            var that = this;
                            var resultTemplate;
                            var renderingTemplate = this.callBase(template, options);
                            var firstDataColumnIndex = that._columnsController.getFirstDataColumnIndex();
                            if (renderingTemplate && "header" === options.rowType && options.column.index === firstDataColumnIndex) {
                                resultTemplate = {
                                    render: function(options) {
                                        if ("multiple" === that.option("selection.mode")) {
                                            that.renderSelectAll(options.container, options.model)
                                        }
                                        renderingTemplate.render(options)
                                    }
                                }
                            } else {
                                resultTemplate = renderingTemplate
                            }
                            return resultTemplate
                        },
                        renderSelectAll: function($cell, options) {
                            $cell.addClass(TREELIST_SELECT_ALL_CLASS);
                            this._renderSelectAllCheckBox($cell)
                        },
                        _isSortableElement: function($target) {
                            return this.callBase($target) && !$target.closest("." + SELECT_CHECKBOX_CLASS).length
                        }
                    },
                    rowsView: {
                        _renderIcons: function($iconContainer, options) {
                            this.callBase.apply(this, arguments);
                            if ("multiple" === this.option("selection.mode")) {
                                this.getController("selection").renderSelectCheckBoxContainer($iconContainer, options)
                            }
                            return $iconContainer
                        },
                        _rowClick: function(e) {
                            var $targetElement = (0, _renderer.default)(e.event.target);
                            if (this.isExpandIcon($targetElement)) {
                                this.callBase.apply(this, arguments)
                            } else {
                                originalRowClick.apply(this, arguments)
                            }
                        }
                    }
                }
            }
        }))
    },
    /*!**********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.search.js ***!
      \**********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.search */ 413));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiTree_list.default.registerModule("search", _uiGrid_core.default)
    },
    /*!***********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.keyboard_navigation.js ***!
      \***********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.keyboard_navigation */ 416));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiTree_list.default.registerModule("keyboardNavigation", (0, _extend.extend)(true, {}, _uiGrid_core.default, {
            extenders: {
                controllers: {
                    keyboardNavigation: {
                        _leftRightKeysHandler: function(eventArgs, isEditing) {
                            var rowIndex = this.getVisibleRowIndex();
                            var dataController = this._dataController;
                            if (eventArgs.ctrl) {
                                var directionCode = this._getDirectionCodeByKey(eventArgs.keyName);
                                var key = dataController.getKeyByRowIndex(rowIndex);
                                if ("nextInRow" === directionCode) {
                                    dataController.expandRow(key)
                                } else {
                                    dataController.collapseRow(key)
                                }
                            } else {
                                return this.callBase.apply(this, arguments)
                            }
                        }
                    }
                }
            }
        }))
    },
    /*!*******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.virtual_columns.js ***!
      \*******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.virtual_columns */ 419));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiTree_list.default.registerModule("virtualColumns", _uiGrid_core.default)
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.focus.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.focus */ 422));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function findIndex(items, callback) {
            var result = -1;
            items.forEach(function(node, index) {
                if (callback(node)) {
                    result = index
                }
            });
            return result
        }
        _uiTree_list.default.registerModule("focus", (0, _extend.extend)(true, {}, _uiGrid_core.default, {
            extenders: {
                controllers: {
                    data: {
                        changeRowExpand: function(key) {
                            if (this.option("focusedRowEnabled") && this.isRowExpanded(key)) {
                                if (this._isFocusedRowInside(key)) {
                                    this.option("focusedRowKey", key)
                                }
                            }
                            return this.callBase.apply(this, arguments)
                        },
                        _isFocusedRowInside: function(parentKey) {
                            var focusedRowKey = this.option("focusedRowKey");
                            var rowIndex = this.getRowIndexByKey(focusedRowKey);
                            var focusedRow = rowIndex >= 0 && this.getVisibleRows()[rowIndex];
                            var parent = focusedRow && focusedRow.node.parent;
                            while (parent) {
                                if (parent.key === parentKey) {
                                    return true
                                }
                                parent = parent.parent
                            }
                            return false
                        },
                        getParentKey: function(key) {
                            var that = this;
                            var dataSource = that._dataSource;
                            var node = that.getNodeByKey(key);
                            var d = new _deferred.Deferred;
                            if (node) {
                                d.resolve(node.parent ? node.parent.key : void 0)
                            } else {
                                dataSource.load({
                                    filter: [dataSource.getKeyExpr(), "=", key]
                                }).done(function(items) {
                                    var parentData = items[0];
                                    if (parentData) {
                                        d.resolve(dataSource.parentKeyOf(parentData))
                                    } else {
                                        d.reject()
                                    }
                                }).fail(d.reject)
                            }
                            return d.promise()
                        },
                        expandAscendants: function(key) {
                            var that = this;
                            var dataSource = that._dataSource;
                            var d = new _deferred.Deferred;
                            that.getParentKey(key).done(function(parentKey) {
                                if (dataSource && void 0 !== parentKey && parentKey !== that.option("rootValue")) {
                                    dataSource._isNodesInitializing = true;
                                    that.expandRow(parentKey);
                                    dataSource._isNodesInitializing = false;
                                    that.expandAscendants(parentKey).done(d.resolve).fail(d.reject)
                                } else {
                                    d.resolve()
                                }
                            }).fail(d.reject);
                            return d.promise()
                        },
                        getPageIndexByKey: function(key) {
                            var that = this;
                            var dataSource = that._dataSource;
                            var d = new _deferred.Deferred;
                            that.expandAscendants(key).done(function() {
                                dataSource.load({
                                    filter: that.getCombinedFilter(),
                                    sort: that.getController("columns").getSortDataSourceParameters(!dataSource.remoteOperations().sorting),
                                    parentIds: []
                                }).done(function(nodes) {
                                    var offset = findIndex(nodes, function(node) {
                                        return that.keyOf(node.data) === key
                                    });
                                    var pageIndex = that.pageIndex();
                                    if (offset >= 0) {
                                        pageIndex = Math.floor(offset / that.pageSize())
                                    }
                                    d.resolve(pageIndex)
                                }).fail(d.reject)
                            }).fail(d.reject);
                            return d.promise()
                        }
                    }
                }
            }
        }))
    },
    /*!****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tree_list/ui.tree_list.row_dragging.js ***!
      \****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _uiTree_list = _interopRequireDefault(__webpack_require__( /*! ./ui.tree_list.core */ 30));
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.row_dragging */ 423));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _uiTree_list.default.registerModule("rowDragging", _uiGrid_core.default)
    },
    /*!***************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/pivot_grid.js ***!
      \***************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./pivot_grid/ui.pivot_grid */ 770));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _ui.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/pivot_grid/ui.pivot_grid.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _element = __webpack_require__( /*! ../../core/element */ 18);
        var _string = __webpack_require__( /*! ../../core/utils/string */ 43);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _click = __webpack_require__( /*! ../../events/click */ 21);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.utils */ 35));
        var _uiPivot_grid = __webpack_require__( /*! ./ui.pivot_grid.utils */ 84);
        var _uiPivot_grid2 = __webpack_require__( /*! ./ui.pivot_grid.data_controller */ 771);
        var _uiPivot_grid3 = __webpack_require__( /*! ./ui.pivot_grid.data_area */ 777);
        var _uiPivot_grid4 = __webpack_require__( /*! ./ui.pivot_grid.headers_area */ 778);
        var _size = __webpack_require__( /*! ../../core/utils/size */ 192);
        var _uiPivot_grid5 = __webpack_require__( /*! ./ui.pivot_grid.fields_area */ 779);
        var _uiPivot_grid6 = _interopRequireDefault(__webpack_require__( /*! ./ui.pivot_grid.field_chooser */ 427));
        var _uiPivot_grid7 = _interopRequireDefault(__webpack_require__( /*! ./ui.pivot_grid.field_chooser_base */ 294));
        var _uiPivot_grid8 = __webpack_require__( /*! ./ui.pivot_grid.export */ 781);
        var _uiPivot_grid9 = _interopRequireDefault(__webpack_require__( /*! ./ui.pivot_grid.chart_integration */ 782));
        var _popup = _interopRequireDefault(__webpack_require__( /*! ../popup */ 46));
        var _context_menu = _interopRequireDefault(__webpack_require__( /*! ../context_menu */ 107));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var window = (0, _window.getWindow)();
        var DATA_AREA_CELL_CLASS = "dx-area-data-cell";
        var ROW_AREA_CELL_CLASS = "dx-area-row-cell";
        var COLUMN_AREA_CELL_CLASS = "dx-area-column-cell";
        var DESCRIPTION_AREA_CELL_CLASS = "dx-area-description-cell";
        var BORDERS_CLASS = "dx-pivotgrid-border";
        var PIVOTGRID_CLASS = "dx-pivotgrid";
        var ROW_LINES_CLASS = "dx-row-lines";
        var BOTTOM_ROW_CLASS = "dx-bottom-row";
        var BOTTOM_BORDER_CLASS = "dx-bottom-border";
        var FIELDS_CONTAINER_CLASS = "dx-pivotgrid-fields-container";
        var FIELDS_CLASS = "dx-area-fields";
        var FIELD_CHOOSER_POPUP_CLASS = "dx-fieldchooser-popup";
        var INCOMPRESSIBLE_FIELDS_CLASS = "dx-incompressible-fields";
        var OVERFLOW_HIDDEN_CLASS = "dx-overflow-hidden";
        var TR = "<tr>";
        var TD = "<td>";
        var DIV = "<div>";
        var TEST_HEIGHT = 66666;
        var FIELD_CALCULATED_OPTIONS = ["allowSorting", "allowSortingBySummary", "allowFiltering", "allowExpandAll"];

        function getArraySum(array) {
            var sum = 0;
            (0, _iterator.each)(array, function(_, value) {
                sum += value || 0
            });
            return sum
        }

        function adjustSizeArray(sizeArray, space) {
            var delta = space / sizeArray.length;
            for (var i = 0; i < sizeArray.length; i++) {
                sizeArray[i] -= delta
            }
        }

        function unsubscribeScrollEvents(area) {
            area.off("scroll").off("stop")
        }

        function subscribeToScrollEvent(area, handler) {
            unsubscribeScrollEvents(area);
            area.on("scroll", handler).on("stop", handler)
        }
        var scrollBarInfoCache = {};

        function getScrollBarInfo(useNativeScrolling) {
            if (scrollBarInfoCache[useNativeScrolling]) {
                return scrollBarInfoCache[useNativeScrolling]
            }
            var scrollBarWidth = 0;
            var options = {};
            var container = (0, _renderer.default)(DIV).css({
                position: "absolute",
                visibility: "hidden",
                top: -1e3,
                left: -1e3,
                width: 100,
                height: 100
            }).appendTo("body");
            var content = (0, _renderer.default)("<p>").css({
                width: "100%",
                height: 200
            }).appendTo(container);
            if ("auto" !== useNativeScrolling) {
                options.useNative = !!useNativeScrolling;
                options.useSimulatedScrollbar = !useNativeScrolling
            }
            container.dxScrollable(options);
            var scrollBarUseNative = container.dxScrollable("instance").option("useNative");
            scrollBarWidth = scrollBarUseNative ? container.width() - content.width() : 0;
            container.remove();
            scrollBarInfoCache[useNativeScrolling] = {
                scrollBarWidth: scrollBarWidth,
                scrollBarUseNative: scrollBarUseNative
            };
            return scrollBarInfoCache[useNativeScrolling]
        }

        function getCommonBorderWidth(elements, direction) {
            var borderStyleNames = "width" === direction ? ["borderLeftWidth", "borderRightWidth"] : ["borderTopWidth", "borderBottomWidth"];
            var width = 0;
            (0, _iterator.each)(elements, function(_, elem) {
                var computedStyle = window.getComputedStyle(elem.get(0));
                borderStyleNames.forEach(function(borderStyleName) {
                    width += parseFloat(computedStyle[borderStyleName]) || 0
                })
            });
            return width
        }

        function clickedOnFieldsArea($targetElement) {
            return $targetElement.closest("." + FIELDS_CLASS).length || $targetElement.find("." + FIELDS_CLASS).length
        }
        var PivotGrid = _ui.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    scrolling: {
                        timeout: 300,
                        renderingThreshold: 150,
                        minTimeout: 10,
                        mode: "standard",
                        useNative: "auto",
                        removeInvisiblePages: true,
                        virtualRowHeight: 50,
                        virtualColumnWidth: 100,
                        loadTwoPagesOnStart: true
                    },
                    encodeHtml: true,
                    dataSource: null,
                    activeStateEnabled: false,
                    fieldChooser: {
                        minWidth: 250,
                        minHeight: 250,
                        enabled: true,
                        allowSearch: false,
                        searchTimeout: 500,
                        layout: 0,
                        title: _message.default.format("dxPivotGrid-fieldChooserTitle"),
                        width: 600,
                        height: 600,
                        applyChangesMode: "instantly"
                    },
                    onContextMenuPreparing: null,
                    allowSorting: false,
                    allowSortingBySummary: false,
                    allowFiltering: false,
                    allowExpandAll: false,
                    wordWrapEnabled: true,
                    fieldPanel: {
                        showColumnFields: true,
                        showFilterFields: true,
                        showDataFields: true,
                        showRowFields: true,
                        allowFieldDragging: true,
                        visible: false,
                        texts: {
                            columnFieldArea: _message.default.format("dxPivotGrid-columnFieldArea"),
                            rowFieldArea: _message.default.format("dxPivotGrid-rowFieldArea"),
                            filterFieldArea: _message.default.format("dxPivotGrid-filterFieldArea"),
                            dataFieldArea: _message.default.format("dxPivotGrid-dataFieldArea")
                        }
                    },
                    dataFieldArea: "column",
                    "export": {
                        enabled: false,
                        fileName: "PivotGrid",
                        proxyUrl: void 0,
                        ignoreExcelErrors: true
                    },
                    showRowTotals: true,
                    showRowGrandTotals: true,
                    showColumnTotals: true,
                    showColumnGrandTotals: true,
                    hideEmptySummaryCells: true,
                    showTotalsPrior: "none",
                    rowHeaderLayout: "standard",
                    loadPanel: {
                        enabled: true,
                        text: _message.default.format("Loading"),
                        width: 200,
                        height: 70,
                        showIndicator: true,
                        indicatorSrc: "",
                        showPane: true
                    },
                    texts: {
                        grandTotal: _message.default.format("dxPivotGrid-grandTotal"),
                        total: _message.default.getFormatter("dxPivotGrid-total"),
                        noData: _message.default.format("dxDataGrid-noDataText"),
                        showFieldChooser: _message.default.format("dxPivotGrid-showFieldChooser"),
                        expandAll: _message.default.format("dxPivotGrid-expandAll"),
                        collapseAll: _message.default.format("dxPivotGrid-collapseAll"),
                        sortColumnBySummary: _message.default.getFormatter("dxPivotGrid-sortColumnBySummary"),
                        sortRowBySummary: _message.default.getFormatter("dxPivotGrid-sortRowBySummary"),
                        removeAllSorting: _message.default.format("dxPivotGrid-removeAllSorting"),
                        exportToExcel: _message.default.format("dxDataGrid-exportToExcel"),
                        dataNotAvailable: _message.default.format("dxPivotGrid-dataNotAvailable")
                    },
                    onCellClick: null,
                    onCellPrepared: null,
                    showBorders: false,
                    stateStoring: {
                        enabled: false,
                        storageKey: null,
                        type: "localStorage",
                        customLoad: null,
                        customSave: null,
                        savingTimeout: 2e3
                    },
                    onExpandValueChanging: null,
                    renderCellCountLimit: 2e4,
                    onExporting: null,
                    onExported: null,
                    onFileSaving: null,
                    headerFilter: {
                        width: 252,
                        height: 325,
                        allowSearch: false,
                        showRelevantValues: false,
                        searchTimeout: 500,
                        texts: {
                            emptyValue: _message.default.format("dxDataGrid-headerFilterEmptyValue"),
                            ok: _message.default.format("dxDataGrid-headerFilterOK"),
                            cancel: _message.default.format("dxDataGrid-headerFilterCancel")
                        }
                    }
                })
            },
            _updateCalculatedOptions: function(fields) {
                var that = this;
                (0, _iterator.each)(fields, function(index, field) {
                    (0, _iterator.each)(FIELD_CALCULATED_OPTIONS, function(_, optionName) {
                        var isCalculated = field._initProperties && optionName in field._initProperties && void 0 === field._initProperties[optionName];
                        var needUpdate = void 0 === field[optionName] || isCalculated;
                        if (needUpdate) {
                            (0, _uiPivot_grid.setFieldProperty)(field, optionName, that.option(optionName))
                        }
                    })
                })
            },
            _getDataControllerOptions: function() {
                var that = this;
                return {
                    component: that,
                    dataSource: that.option("dataSource"),
                    texts: that.option("texts"),
                    showRowTotals: that.option("showRowTotals"),
                    showRowGrandTotals: that.option("showRowGrandTotals"),
                    showColumnTotals: that.option("showColumnTotals"),
                    showTotalsPrior: that.option("showTotalsPrior"),
                    showColumnGrandTotals: that.option("showColumnGrandTotals"),
                    dataFieldArea: that.option("dataFieldArea"),
                    rowHeaderLayout: that.option("rowHeaderLayout"),
                    hideEmptySummaryCells: that.option("hideEmptySummaryCells"),
                    onFieldsPrepared: function(fields) {
                        that._updateCalculatedOptions(fields)
                    }
                }
            },
            _initDataController: function() {
                var that = this;
                that._dataController && that._dataController.dispose();
                that._dataController = new _uiPivot_grid2.DataController(that._getDataControllerOptions());
                if ((0, _window.hasWindow)()) {
                    that._dataController.changed.add(function() {
                        that._render()
                    })
                }
                that._dataController.scrollChanged.add(function(options) {
                    that._scrollLeft = options.left;
                    that._scrollTop = options.top
                });
                that._dataController.loadingChanged.add(function(isLoading) {
                    that._updateLoading()
                });
                that._dataController.progressChanged.add(that._updateLoading.bind(that));
                that._dataController.dataSourceChanged.add(function() {
                    that._trigger("onChanged")
                });
                var expandValueChanging = that.option("onExpandValueChanging");
                if (expandValueChanging) {
                    that._dataController.expandValueChanging.add(function(e) {
                        expandValueChanging(e)
                    })
                }
            },
            _init: function() {
                var that = this;
                that.callBase();
                that._initDataController();
                that._scrollLeft = that._scrollTop = null;
                that._initActions()
            },
            _initActions: function() {
                var that = this;
                that._actions = {
                    onChanged: that._createActionByOption("onChanged"),
                    onContextMenuPreparing: that._createActionByOption("onContextMenuPreparing"),
                    onCellClick: that._createActionByOption("onCellClick"),
                    onExporting: that._createActionByOption("onExporting"),
                    onExported: that._createActionByOption("onExported"),
                    onFileSaving: that._createActionByOption("onFileSaving"),
                    onCellPrepared: that._createActionByOption("onCellPrepared")
                }
            },
            _trigger: function(eventName, eventArg) {
                this._actions[eventName](eventArg)
            },
            _optionChanged: function(args) {
                var that = this;
                if (FIELD_CALCULATED_OPTIONS.indexOf(args.name) >= 0) {
                    var fields = this.getDataSource().fields();
                    this._updateCalculatedOptions(fields)
                }
                switch (args.name) {
                    case "dataSource":
                    case "allowSorting":
                    case "allowFiltering":
                    case "allowExpandAll":
                    case "allowSortingBySummary":
                    case "scrolling":
                    case "stateStoring":
                        that._initDataController();
                        that._fieldChooserPopup.hide();
                        that._renderFieldChooser();
                        that._invalidate();
                        break;
                    case "texts":
                    case "showTotalsPrior":
                    case "showRowTotals":
                    case "showRowGrandTotals":
                    case "showColumnTotals":
                    case "showColumnGrandTotals":
                    case "hideEmptySummaryCells":
                    case "dataFieldArea":
                        that._dataController.updateViewOptions(that._getDataControllerOptions());
                        break;
                    case "useNativeScrolling":
                    case "encodeHtml":
                    case "renderCellCountLimit":
                        break;
                    case "rtlEnabled":
                        that.callBase(args);
                        that._renderFieldChooser();
                        that._renderContextMenu();
                        (0, _window.hasWindow)() && that._renderLoadPanel(that._dataArea.groupElement(), that.$element());
                        that._invalidate();
                        break;
                    case "export":
                        that._renderDescriptionArea();
                        break;
                    case "onExpandValueChanging":
                        break;
                    case "onCellClick":
                    case "onContextMenuPreparing":
                    case "onExporting":
                    case "onExported":
                    case "onFileSaving":
                    case "onCellPrepared":
                        that._actions[args.name] = that._createActionByOption(args.name);
                        break;
                    case "fieldChooser":
                        that._renderFieldChooser();
                        that._renderDescriptionArea();
                        break;
                    case "loadPanel":
                        if ((0, _window.hasWindow)()) {
                            that._renderLoadPanel(that._dataArea.groupElement(), that.$element());
                            that._invalidate()
                        }
                        break;
                    case "fieldPanel":
                        that._renderDescriptionArea();
                        that._invalidate();
                        break;
                    case "headerFilter":
                        that._renderFieldChooser();
                        that._invalidate();
                        break;
                    case "showBorders":
                        that._tableElement().toggleClass(BORDERS_CLASS, !!args.value);
                        that.updateDimensions();
                        break;
                    case "wordWrapEnabled":
                        that._tableElement().toggleClass("dx-word-wrap", !!args.value);
                        that.updateDimensions();
                        break;
                    case "rowHeaderLayout":
                        that._tableElement().find("." + ROW_AREA_CELL_CLASS).toggleClass("dx-area-tree-view", "tree" === args.value);
                        that._dataController.updateViewOptions(that._getDataControllerOptions());
                        break;
                    case "height":
                    case "width":
                        that._hasHeight = null;
                        that.callBase(args);
                        that.resize();
                        break;
                    default:
                        that.callBase(args)
                }
            },
            _updateScrollPosition: function(columnsArea, rowsArea, dataArea) {
                var that = this;
                var scrollTop;
                var scrollLeft;
                var scrolled = that._scrollTop || that._scrollLeft;
                if (that._scrollUpdating) {
                    return
                }
                that._scrollUpdating = true;
                if (rowsArea && !rowsArea.hasScroll() && that._hasHeight) {
                    that._scrollTop = null
                }
                if (columnsArea && !columnsArea.hasScroll()) {
                    that._scrollLeft = null
                }
                if (null !== that._scrollTop || null !== that._scrollLeft || scrolled || that.option("rtlEnabled")) {
                    scrollTop = that._scrollTop || 0;
                    scrollLeft = that._scrollLeft || 0;
                    dataArea.scrollTo({
                        x: scrollLeft,
                        y: scrollTop
                    });
                    columnsArea.scrollTo(scrollLeft);
                    rowsArea.scrollTo(scrollTop);
                    that._dataController.updateWindowScrollPosition(that._scrollTop)
                }
                that._scrollUpdating = false
            },
            _subscribeToEvents: function(columnsArea, rowsArea, dataArea) {
                var that = this;
                var scrollHandler = function(e) {
                    var scrollOffset = e.scrollOffset;
                    var leftOffset = (0, _type.isDefined)(scrollOffset.left) ? scrollOffset.left : that._scrollLeft;
                    var topOffset = (0, _type.isDefined)(scrollOffset.top) && that._hasHeight ? scrollOffset.top : that._scrollTop;
                    if ((that._scrollLeft || 0) !== (leftOffset || 0) || (that._scrollTop || 0) !== (topOffset || 0)) {
                        that._scrollLeft = leftOffset;
                        that._scrollTop = topOffset;
                        that._updateScrollPosition(columnsArea, rowsArea, dataArea);
                        if ("virtual" === that.option("scrolling.mode")) {
                            that._dataController.setViewportPosition(that._scrollLeft, that._scrollTop)
                        }
                    }
                };
                (0, _iterator.each)([columnsArea, rowsArea, dataArea], function(_, area) {
                    subscribeToScrollEvent(area, scrollHandler)
                });
                !that._hasHeight && that._dataController.subscribeToWindowScrollEvents(dataArea.groupElement())
            },
            _clean: _common.noop,
            _needDelayResizing: function(cellsInfo) {
                var cellsCount = cellsInfo.length * (cellsInfo.length ? cellsInfo[0].length : 0);
                return cellsCount > this.option("renderCellCountLimit")
            },
            _renderFieldChooser: function() {
                var that = this;
                var container = that._pivotGridContainer;
                var fieldChooserOptions = that.option("fieldChooser") || {};
                var toolbarItems = "onDemand" === fieldChooserOptions.applyChangesMode ? [{
                    toolbar: "bottom",
                    location: "after",
                    widget: "dxButton",
                    options: {
                        text: _message.default.format("OK"),
                        onClick: function(e) {
                            that._fieldChooserPopup.$content().dxPivotGridFieldChooser("applyChanges");
                            that._fieldChooserPopup.hide()
                        }
                    }
                }, {
                    toolbar: "bottom",
                    location: "after",
                    widget: "dxButton",
                    options: {
                        text: _message.default.format("Cancel"),
                        onClick: function(e) {
                            that._fieldChooserPopup.hide()
                        }
                    }
                }] : [];
                var fieldChooserComponentOptions = {
                    layout: fieldChooserOptions.layout,
                    texts: fieldChooserOptions.texts || {},
                    dataSource: that.getDataSource(),
                    allowSearch: fieldChooserOptions.allowSearch,
                    searchTimeout: fieldChooserOptions.searchTimeout,
                    width: void 0,
                    height: void 0,
                    headerFilter: that.option("headerFilter"),
                    encodeHtml: that.option("encodeHtml"),
                    applyChangesMode: fieldChooserOptions.applyChangesMode,
                    onContextMenuPreparing: function(e) {
                        that._trigger("onContextMenuPreparing", e)
                    }
                };
                var popupOptions = {
                    shading: false,
                    title: fieldChooserOptions.title,
                    width: fieldChooserOptions.width,
                    height: fieldChooserOptions.height,
                    showCloseButton: true,
                    resizeEnabled: true,
                    minWidth: fieldChooserOptions.minWidth,
                    minHeight: fieldChooserOptions.minHeight,
                    toolbarItems: toolbarItems,
                    onResize: function(e) {
                        e.component.$content().dxPivotGridFieldChooser("updateDimensions")
                    },
                    onShown: function(e) {
                        that._createComponent(e.component.content(), _uiPivot_grid6.default, fieldChooserComponentOptions)
                    },
                    onHidden: function(e) {
                        var fieldChooser = e.component.$content().dxPivotGridFieldChooser("instance");
                        fieldChooser.resetTreeView();
                        fieldChooser.cancelChanges()
                    }
                };
                if (that._fieldChooserPopup) {
                    that._fieldChooserPopup.option(popupOptions);
                    that._fieldChooserPopup.$content().dxPivotGridFieldChooser(fieldChooserComponentOptions)
                } else {
                    that._fieldChooserPopup = that._createComponent((0, _renderer.default)(DIV).addClass(FIELD_CHOOSER_POPUP_CLASS).appendTo(container), _popup.default, popupOptions)
                }
            },
            _renderContextMenu: function() {
                var that = this;
                var $container = that._pivotGridContainer;
                if (that._contextMenu) {
                    that._contextMenu.$element().remove()
                }
                that._contextMenu = that._createComponent((0, _renderer.default)(DIV).appendTo($container), _context_menu.default, {
                    onPositioning: function(actionArgs) {
                        var event = actionArgs.event;
                        actionArgs.cancel = true;
                        if (!event) {
                            return
                        }
                        var targetElement = event.target.cellIndex >= 0 ? event.target : (0, _renderer.default)(event.target).closest("td").get(0);
                        if (!targetElement) {
                            return
                        }
                        var args = that._createEventArgs(targetElement, event);
                        var items = that._getContextMenuItems(args);
                        if (items) {
                            actionArgs.component.option("items", items);
                            actionArgs.cancel = false;
                            return
                        }
                    },
                    onItemClick: function(params) {
                        params.itemData.onItemClick && params.itemData.onItemClick(params)
                    },
                    cssClass: PIVOTGRID_CLASS,
                    target: that.$element()
                })
            },
            _getContextMenuItems: function(e) {
                var that = this;
                var items = [];
                var texts = that.option("texts");
                if ("row" === e.area || "column" === e.area) {
                    var areaFields = e[e.area + "Fields"];
                    var oppositeAreaFields = e["column" === e.area ? "rowFields" : "columnFields"];
                    var field = e.cell.path && areaFields[e.cell.path.length - 1];
                    var dataSource = that.getDataSource();
                    if (field && field.allowExpandAll && e.cell.path.length < e[e.area + "Fields"].length && !dataSource.paginate()) {
                        items.push({
                            beginGroup: true,
                            icon: "none",
                            text: texts.expandAll,
                            onItemClick: function() {
                                dataSource.expandAll(field.index)
                            }
                        });
                        items.push({
                            text: texts.collapseAll,
                            icon: "none",
                            onItemClick: function() {
                                dataSource.collapseAll(field.index)
                            }
                        })
                    }
                    if (e.cell.isLast && !dataSource.paginate()) {
                        var sortingBySummaryItemCount = 0;
                        (0, _iterator.each)(oppositeAreaFields, function(index, field) {
                            if (!field.allowSortingBySummary) {
                                return
                            }(0, _iterator.each)(e.dataFields, function(dataIndex, dataField) {
                                if ((0, _type.isDefined)(e.cell.dataIndex) && e.cell.dataIndex !== dataIndex) {
                                    return
                                }
                                var showDataFieldCaption = !(0, _type.isDefined)(e.cell.dataIndex) && e.dataFields.length > 1;
                                var textFormat = "column" === e.area ? texts.sortColumnBySummary : texts.sortRowBySummary;
                                var checked = (0, _uiPivot_grid.findField)(e.dataFields, field.sortBySummaryField) === dataIndex && (e.cell.path || []).join("/") === (field.sortBySummaryPath || []).join("/");
                                var text = (0, _string.format)(textFormat, showDataFieldCaption ? field.caption + " - " + dataField.caption : field.caption);
                                items.push({
                                    beginGroup: 0 === sortingBySummaryItemCount,
                                    icon: checked ? "desc" === field.sortOrder ? "sortdowntext" : "sortuptext" : "none",
                                    text: text,
                                    onItemClick: function() {
                                        dataSource.field(field.index, {
                                            sortBySummaryField: dataField.name || dataField.caption || dataField.dataField,
                                            sortBySummaryPath: e.cell.path,
                                            sortOrder: "desc" === field.sortOrder ? "asc" : "desc"
                                        });
                                        dataSource.load()
                                    }
                                });
                                sortingBySummaryItemCount++
                            })
                        });
                        (0, _iterator.each)(oppositeAreaFields, function(index, field) {
                            if (!field.allowSortingBySummary || !(0, _type.isDefined)(field.sortBySummaryField)) {
                                return
                            }
                            items.push({
                                beginGroup: 0 === sortingBySummaryItemCount,
                                icon: "none",
                                text: texts.removeAllSorting,
                                onItemClick: function() {
                                    (0, _iterator.each)(oppositeAreaFields, function(index, field) {
                                        dataSource.field(field.index, {
                                            sortBySummaryField: void 0,
                                            sortBySummaryPath: void 0,
                                            sortOrder: void 0
                                        })
                                    });
                                    dataSource.load()
                                }
                            });
                            return false
                        })
                    }
                }
                if (that.option("fieldChooser.enabled")) {
                    items.push({
                        beginGroup: true,
                        icon: "columnchooser",
                        text: texts.showFieldChooser,
                        onItemClick: function() {
                            that._fieldChooserPopup.show()
                        }
                    })
                }
                if (that.option("export.enabled")) {
                    items.push({
                        beginGroup: true,
                        icon: "xlsxfile",
                        text: texts.exportToExcel,
                        onItemClick: function() {
                            that.exportToExcel()
                        }
                    })
                }
                e.items = items;
                that._trigger("onContextMenuPreparing", e);
                items = e.items;
                if (items && items.length) {
                    return items
                }
            },
            _createEventArgs: function(targetElement, dxEvent) {
                var that = this;
                var dataSource = that.getDataSource();
                var args = {
                    rowFields: dataSource.getAreaFields("row"),
                    columnFields: dataSource.getAreaFields("column"),
                    dataFields: dataSource.getAreaFields("data"),
                    event: dxEvent
                };
                if (clickedOnFieldsArea((0, _renderer.default)(targetElement))) {
                    return (0, _extend.extend)(that._createFieldArgs(targetElement), args)
                } else {
                    return (0, _extend.extend)(that._createCellArgs(targetElement), args)
                }
            },
            _createFieldArgs: function(targetElement) {
                var field = (0, _renderer.default)(targetElement).children().data("field");
                var args = {
                    field: field
                };
                return (0, _type.isDefined)(field) ? args : {}
            },
            _createCellArgs: function(cellElement) {
                var $cellElement = (0, _renderer.default)(cellElement);
                var columnIndex = cellElement.cellIndex;
                var rowIndex = cellElement.parentElement.rowIndex;
                var $table = $cellElement.closest("table");
                var data = $table.data("data");
                var cell = data && data[rowIndex] && data[rowIndex][columnIndex];
                var args = {
                    area: $table.data("area"),
                    rowIndex: rowIndex,
                    columnIndex: columnIndex,
                    cellElement: (0, _element.getPublicElement)($cellElement),
                    cell: cell
                };
                return args
            },
            _handleCellClick: function(e) {
                var that = this;
                var args = that._createEventArgs(e.currentTarget, e);
                var cell = args.cell;
                if (!cell || !args.area && (args.rowIndex || args.columnIndex)) {
                    return
                }
                that._trigger("onCellClick", args);
                cell && !args.cancel && (0, _type.isDefined)(cell.expanded) && setTimeout(function() {
                    that._dataController[cell.expanded ? "collapseHeaderItem" : "expandHeaderItem"](args.area, cell.path)
                })
            },
            _getNoDataText: function() {
                return this.option("texts.noData")
            },
            _renderNoDataText: _uiGrid_core.default.renderNoDataText,
            _renderLoadPanel: _uiGrid_core.default.renderLoadPanel,
            _updateLoading: function(progress) {
                var that = this;
                var isLoading = that._dataController.isLoading();
                if (!that._loadPanel) {
                    return
                }
                var loadPanelVisible = that._loadPanel.option("visible");
                if (!loadPanelVisible) {
                    that._startLoadingTime = new Date
                }
                if (isLoading) {
                    if (progress) {
                        if (new Date - that._startLoadingTime >= 1e3) {
                            that._loadPanel.option("message", Math.floor(100 * progress) + "%")
                        }
                    } else {
                        that._loadPanel.option("message", that.option("loadPanel.text"))
                    }
                }
                clearTimeout(that._hideLoadingTimeoutID);
                if (loadPanelVisible && !isLoading) {
                    that._hideLoadingTimeoutID = setTimeout(function() {
                        that._loadPanel.option("visible", false);
                        that.$element().removeClass(OVERFLOW_HIDDEN_CLASS)
                    })
                } else {
                    that._loadPanel.option("visible", isLoading);
                    that.$element().toggleClass(OVERFLOW_HIDDEN_CLASS, !isLoading)
                }
            },
            _renderDescriptionArea: function() {
                var _this = this;
                var $element = this.$element();
                var $descriptionCell = $element.find("." + DESCRIPTION_AREA_CELL_CLASS);
                var $toolbarContainer = (0, _renderer.default)(DIV).addClass("dx-pivotgrid-toolbar");
                var fieldPanel = this.option("fieldPanel");
                var $filterHeader = $element.find(".dx-filter-header");
                var $columnHeader = $element.find(".dx-column-header");
                var $targetContainer;
                if (fieldPanel.visible && fieldPanel.showFilterFields) {
                    $targetContainer = $filterHeader
                } else {
                    if (fieldPanel.visible && (fieldPanel.showDataFields || fieldPanel.showColumnFields)) {
                        $targetContainer = $columnHeader
                    } else {
                        $targetContainer = $descriptionCell
                    }
                }
                $columnHeader.toggleClass(BOTTOM_BORDER_CLASS, !!(fieldPanel.visible && (fieldPanel.showDataFields || fieldPanel.showColumnFields)));
                $filterHeader.toggleClass(BOTTOM_BORDER_CLASS, !!(fieldPanel.visible && fieldPanel.showFilterFields));
                $descriptionCell.toggleClass("dx-pivotgrid-background", fieldPanel.visible && (fieldPanel.showDataFields || fieldPanel.showColumnFields || fieldPanel.showRowFields));
                this.$element().find(".dx-pivotgrid-toolbar").remove();
                $toolbarContainer.prependTo($targetContainer);
                if (this.option("fieldChooser.enabled")) {
                    var $buttonElement = (0, _renderer.default)(DIV).appendTo($toolbarContainer).addClass("dx-pivotgrid-field-chooser-button");
                    var buttonOptions = {
                        icon: "columnchooser",
                        hint: this.option("texts.showFieldChooser"),
                        onClick: function() {
                            _this.getFieldChooserPopup().show()
                        }
                    };
                    this._createComponent($buttonElement, "dxButton", buttonOptions)
                }
                if (this.option("export.enabled")) {
                    var _$buttonElement = (0, _renderer.default)(DIV).appendTo($toolbarContainer).addClass("dx-pivotgrid-export-button");
                    var _buttonOptions = {
                        icon: "xlsxfile",
                        hint: this.option("texts.exportToExcel"),
                        onClick: function() {
                            _this.exportToExcel()
                        }
                    };
                    this._createComponent(_$buttonElement, "dxButton", _buttonOptions)
                }
            },
            _detectHasContainerHeight: function() {
                var that = this;
                var element = that.$element();
                if ((0, _type.isDefined)(that._hasHeight)) {
                    var height = that.option("height") || that.$element().get(0).style.height;
                    if (height && that._hasHeight ^ "auto" !== height) {
                        that._hasHeight = null
                    }
                }
                if ((0, _type.isDefined)(that._hasHeight) || element.is(":hidden")) {
                    return
                }
                that._pivotGridContainer.addClass("dx-hidden");
                var testElement = (0, _renderer.default)(DIV).height(TEST_HEIGHT);
                element.append(testElement);
                that._hasHeight = element.height() !== TEST_HEIGHT;
                that._pivotGridContainer.removeClass("dx-hidden");
                testElement.remove()
            },
            _renderHeaders: function(rowHeaderContainer, columnHeaderContainer, filterHeaderContainer, dataHeaderContainer) {
                var that = this;
                var dataSource = that.getDataSource();
                that._rowFields = that._rowFields || new _uiPivot_grid5.FieldsArea(that, "row");
                that._rowFields.render(rowHeaderContainer, dataSource.getAreaFields("row"));
                that._columnFields = that._columnFields || new _uiPivot_grid5.FieldsArea(that, "column");
                that._columnFields.render(columnHeaderContainer, dataSource.getAreaFields("column"));
                that._filterFields = that._filterFields || new _uiPivot_grid5.FieldsArea(that, "filter");
                that._filterFields.render(filterHeaderContainer, dataSource.getAreaFields("filter"));
                that._dataFields = that._dataFields || new _uiPivot_grid5.FieldsArea(that, "data");
                that._dataFields.render(dataHeaderContainer, dataSource.getAreaFields("data"));
                that.$element().dxPivotGridFieldChooserBase("instance").renderSortable()
            },
            _createTableElement: function() {
                var that = this;
                var $table = (0, _renderer.default)("<table>").css({
                    width: "100%"
                }).toggleClass(BORDERS_CLASS, !!that.option("showBorders")).toggleClass("dx-word-wrap", !!that.option("wordWrapEnabled"));
                _events_engine.default.on($table, (0, _index.addNamespace)(_click.name, "dxPivotGrid"), "td", that._handleCellClick.bind(that));
                return $table
            },
            _renderDataArea: function(dataAreaElement) {
                var that = this;
                var dataArea = that._dataArea || new _uiPivot_grid3.DataArea(that);
                that._dataArea = dataArea;
                dataArea.render(dataAreaElement, that._dataController.getCellsInfo());
                return dataArea
            },
            _renderRowsArea: function(rowsAreaElement) {
                var that = this;
                var rowsArea = that._rowsArea || new _uiPivot_grid4.VerticalHeadersArea(that);
                that._rowsArea = rowsArea;
                rowsArea.render(rowsAreaElement, that._dataController.getRowsInfo());
                return rowsArea
            },
            _renderColumnsArea: function(columnsAreaElement) {
                var that = this;
                var columnsArea = that._columnsArea || new _uiPivot_grid4.HorizontalHeadersArea(that);
                that._columnsArea = columnsArea;
                columnsArea.render(columnsAreaElement, that._dataController.getColumnsInfo());
                return columnsArea
            },
            _initMarkup: function() {
                var that = this;
                that.callBase.apply(this, arguments);
                that.$element().addClass(PIVOTGRID_CLASS)
            },
            _renderContentImpl: function() {
                var that = this;
                var columnsAreaElement;
                var rowsAreaElement;
                var dataAreaElement;
                var tableElement;
                var isFirstDrawing = !that._pivotGridContainer;
                var rowHeaderContainer;
                var columnHeaderContainer;
                var filterHeaderContainer;
                var dataHeaderContainer;
                tableElement = !isFirstDrawing && that._tableElement();
                if (!tableElement) {
                    that.$element().addClass(ROW_LINES_CLASS).addClass(FIELDS_CONTAINER_CLASS);
                    that._pivotGridContainer = (0, _renderer.default)(DIV).addClass("dx-pivotgrid-container");
                    that._renderFieldChooser();
                    that._renderContextMenu();
                    columnsAreaElement = (0, _renderer.default)(TD).addClass(COLUMN_AREA_CELL_CLASS);
                    rowsAreaElement = (0, _renderer.default)(TD).addClass(ROW_AREA_CELL_CLASS);
                    dataAreaElement = (0, _renderer.default)(TD).addClass(DATA_AREA_CELL_CLASS);
                    tableElement = that._createTableElement();
                    dataHeaderContainer = (0, _renderer.default)(TD).addClass("dx-data-header");
                    filterHeaderContainer = (0, _renderer.default)("<td>").attr("colspan", "2").addClass("dx-filter-header");
                    columnHeaderContainer = (0, _renderer.default)(TD).addClass("dx-column-header");
                    rowHeaderContainer = (0, _renderer.default)(TD).addClass(DESCRIPTION_AREA_CELL_CLASS);
                    (0, _renderer.default)(TR).append(filterHeaderContainer).appendTo(tableElement);
                    (0, _renderer.default)(TR).append(dataHeaderContainer).append(columnHeaderContainer).appendTo(tableElement);
                    (0, _renderer.default)(TR).toggleClass("dx-ie", true === _browser.default.msie).append(rowHeaderContainer).append(columnsAreaElement).appendTo(tableElement);
                    (0, _renderer.default)(TR).addClass(BOTTOM_ROW_CLASS).append(rowsAreaElement).append(dataAreaElement).appendTo(tableElement);
                    that._pivotGridContainer.append(tableElement);
                    that.$element().append(that._pivotGridContainer);
                    if ("tree" === that.option("rowHeaderLayout")) {
                        rowsAreaElement.addClass("dx-area-tree-view")
                    }
                }
                that.$element().addClass(OVERFLOW_HIDDEN_CLASS);
                that._createComponent(that.$element(), _uiPivot_grid7.default, {
                    dataSource: that.getDataSource(),
                    encodeHtml: that.option("encodeHtml"),
                    allowFieldDragging: that.option("fieldPanel.allowFieldDragging"),
                    headerFilter: that.option("headerFilter"),
                    visible: that.option("visible")
                });
                var dataArea = that._renderDataArea(dataAreaElement);
                var rowsArea = that._renderRowsArea(rowsAreaElement);
                var columnsArea = that._renderColumnsArea(columnsAreaElement);
                dataArea.tableElement().prepend(columnsArea.headElement());
                if (isFirstDrawing) {
                    that._renderLoadPanel(dataArea.groupElement().parent(), that.$element());
                    that._renderDescriptionArea();
                    rowsArea.processScroll();
                    columnsArea.processScroll()
                } [dataArea, rowsArea, columnsArea].forEach(function(area) {
                    unsubscribeScrollEvents(area)
                });
                that._renderHeaders(rowHeaderContainer, columnHeaderContainer, filterHeaderContainer, dataHeaderContainer);
                that._update(isFirstDrawing)
            },
            _update: function(isFirstDrawing) {
                var that = this;
                var updateHandler = function() {
                    that.updateDimensions()
                };
                if (that._needDelayResizing(that._dataArea.getData()) && isFirstDrawing) {
                    setTimeout(updateHandler)
                } else {
                    updateHandler()
                }
            },
            _fireContentReadyAction: function() {
                if (!this._dataController.isLoading()) {
                    this.callBase()
                }
            },
            getScrollPath: function(area) {
                var that = this;
                if ("column" === area) {
                    return that._columnsArea.getScrollPath(that._scrollLeft)
                } else {
                    return that._rowsArea.getScrollPath(that._scrollTop)
                }
            },
            getDataSource: function() {
                return this._dataController.getDataSource()
            },
            getFieldChooserPopup: function() {
                return this._fieldChooserPopup
            },
            hasScroll: function(area) {
                var that = this;
                return "column" === area ? that._columnsArea.hasScroll() : that._rowsArea.hasScroll()
            },
            _dimensionChanged: function() {
                this.updateDimensions()
            },
            _visibilityChanged: function(visible) {
                if (visible) {
                    this.updateDimensions()
                }
            },
            _dispose: function() {
                var that = this;
                clearTimeout(that._hideLoadingTimeoutID);
                that.callBase.apply(that, arguments);
                if (that._dataController) {
                    that._dataController.dispose()
                }
            },
            _tableElement: function() {
                return this.$element().find("table").first()
            },
            addWidgetPrefix: function(className) {
                return "dx-pivotgrid-" + className
            },
            resize: function() {
                this.updateDimensions()
            },
            isReady: function() {
                return this.callBase() && !this._dataController.isLoading()
            },
            updateDimensions: function() {
                var that = this;
                var groupWidth;
                var tableElement = that._tableElement();
                var rowsArea = that._rowsArea;
                var columnsArea = that._columnsArea;
                var dataArea = that._dataArea;
                var bordersWidth;
                var totalWidth = 0;
                var totalHeight = 0;
                var rowsAreaWidth = 0;
                var hasRowsScroll;
                var hasColumnsScroll;
                var scrollingOptions = that.option("scrolling") || {};
                var scrollBarInfo = getScrollBarInfo(scrollingOptions.useNative);
                var scrollBarWidth = scrollBarInfo.scrollBarWidth;
                var dataAreaCell = tableElement.find("." + DATA_AREA_CELL_CLASS);
                var rowAreaCell = tableElement.find("." + ROW_AREA_CELL_CLASS);
                var columnAreaCell = tableElement.find("." + COLUMN_AREA_CELL_CLASS);
                var descriptionCell = tableElement.find("." + DESCRIPTION_AREA_CELL_CLASS);
                var filterHeaderCell = tableElement.find(".dx-filter-header");
                var columnHeaderCell = tableElement.find(".dx-column-header");
                var rowFieldsHeader = that._rowFields;
                var d = new _deferred.Deferred;
                if (!(0, _window.hasWindow)()) {
                    return
                }
                var needSynchronizeFieldPanel = rowFieldsHeader.isVisible() && "tree" !== that.option("rowHeaderLayout");
                that._detectHasContainerHeight();
                if (!dataArea.headElement().length) {
                    dataArea.tableElement().prepend(columnsArea.headElement())
                }
                if (needSynchronizeFieldPanel) {
                    rowsArea.updateColspans(rowFieldsHeader.getColumnsCount());
                    rowsArea.tableElement().prepend(rowFieldsHeader.headElement())
                }
                tableElement.addClass(INCOMPRESSIBLE_FIELDS_CLASS);
                dataArea.reset();
                rowsArea.reset();
                columnsArea.reset();
                rowFieldsHeader.reset();
                var calculateHasScroll = function(areaSize, totalSize) {
                    return totalSize - areaSize >= 1
                };
                var calculateGroupHeight = function(dataAreaHeight, totalHeight, hasRowsScroll, hasColumnsScroll, scrollBarWidth) {
                    return hasRowsScroll ? dataAreaHeight : totalHeight + (hasColumnsScroll ? scrollBarWidth : 0)
                };
                (0, _common.deferUpdate)(function() {
                    var resultWidths = dataArea.getColumnsWidth();
                    var rowHeights = rowsArea.getRowsHeight();
                    var rowsAreaHeights = needSynchronizeFieldPanel ? rowHeights.slice(1) : rowHeights;
                    var dataAreaHeights = dataArea.getRowsHeight();
                    var descriptionCellHeight = (0, _size.getSize)(descriptionCell[0], "height", {
                        paddings: true,
                        borders: true,
                        margins: true
                    }) + (needSynchronizeFieldPanel ? rowHeights[0] : 0);
                    var columnsAreaRowCount = that._dataController.getColumnsInfo().length;
                    var resultHeights = (0, _uiPivot_grid.mergeArraysByMaxValue)(rowsAreaHeights, dataAreaHeights.slice(columnsAreaRowCount));
                    var columnsAreaRowHeights = dataAreaHeights.slice(0, columnsAreaRowCount);
                    var columnsAreaHeight = getArraySum(columnsAreaRowHeights);
                    var rowsAreaColumnWidths = rowsArea.getColumnsWidth();
                    var filterAreaHeight = 0;
                    var dataAreaHeight = 0;
                    if (that._hasHeight) {
                        filterAreaHeight = filterHeaderCell.height();
                        var $dataHeader = tableElement.find(".dx-data-header");
                        var dataHeaderHeight = _browser.default.msie ? (0, _size.getSize)($dataHeader.get(0), "height", {
                            paddings: false,
                            borders: false,
                            margins: false
                        }) : $dataHeader.height();
                        bordersWidth = getCommonBorderWidth([columnAreaCell, dataAreaCell, tableElement, columnHeaderCell, filterHeaderCell], "height");
                        dataAreaHeight = that.$element().height() - filterAreaHeight - dataHeaderHeight - (Math.max(dataArea.headElement().height(), columnAreaCell.height(), descriptionCellHeight) + bordersWidth)
                    }
                    totalWidth = dataArea.tableElement().width();
                    totalHeight = getArraySum(resultHeights);
                    if (!totalWidth || !totalHeight) {
                        d.resolve();
                        return
                    }
                    rowsAreaWidth = getArraySum(rowsAreaColumnWidths);
                    var elementWidth = that.$element().width();
                    bordersWidth = getCommonBorderWidth([rowAreaCell, dataAreaCell, tableElement], "width");
                    groupWidth = elementWidth - rowsAreaWidth - bordersWidth;
                    groupWidth = groupWidth > 0 ? groupWidth : totalWidth;
                    var diff = totalWidth - groupWidth;
                    var needAdjustWidthOnZoom = diff >= 0 && diff <= 2;
                    if (needAdjustWidthOnZoom) {
                        adjustSizeArray(resultWidths, diff);
                        totalWidth = groupWidth
                    }
                    hasRowsScroll = that._hasHeight && calculateHasScroll(dataAreaHeight, totalHeight);
                    hasColumnsScroll = calculateHasScroll(groupWidth, totalWidth);
                    var groupHeight = calculateGroupHeight(dataAreaHeight, totalHeight, hasRowsScroll, hasColumnsScroll, scrollBarWidth);
                    (0, _common.deferRender)(function() {
                        columnsArea.tableElement().append(dataArea.headElement());
                        rowFieldsHeader.tableElement().append(rowsArea.headElement());
                        if (!hasColumnsScroll && hasRowsScroll && scrollBarWidth) {
                            adjustSizeArray(resultWidths, scrollBarWidth);
                            totalWidth -= scrollBarWidth
                        }
                        if (descriptionCellHeight > columnsAreaHeight) {
                            adjustSizeArray(columnsAreaRowHeights, columnsAreaHeight - descriptionCellHeight);
                            columnsArea.setRowsHeight(columnsAreaRowHeights)
                        }
                        tableElement.removeClass(INCOMPRESSIBLE_FIELDS_CLASS);
                        columnHeaderCell.children().css("maxWidth", groupWidth);
                        columnsArea.groupWidth(groupWidth);
                        columnsArea.processScrollBarSpacing(hasRowsScroll ? scrollBarWidth : 0);
                        columnsArea.setColumnsWidth(resultWidths);
                        rowsArea.groupHeight(that._hasHeight ? groupHeight : "auto");
                        rowsArea.processScrollBarSpacing(hasColumnsScroll ? scrollBarWidth : 0);
                        rowsArea.setColumnsWidth(rowsAreaColumnWidths);
                        rowsArea.setRowsHeight(resultHeights);
                        dataArea.setColumnsWidth(resultWidths);
                        dataArea.setRowsHeight(resultHeights);
                        dataArea.groupWidth(groupWidth);
                        dataArea.groupHeight(that._hasHeight ? groupHeight : "auto");
                        needSynchronizeFieldPanel && rowFieldsHeader.setColumnsWidth(rowsAreaColumnWidths);
                        dataAreaCell.toggleClass(BOTTOM_BORDER_CLASS, !hasRowsScroll);
                        rowAreaCell.toggleClass(BOTTOM_BORDER_CLASS, !hasRowsScroll);
                        if (!that._hasHeight && elementWidth !== that.$element().width()) {
                            var _diff = elementWidth - that.$element().width();
                            if (!hasColumnsScroll) {
                                adjustSizeArray(resultWidths, _diff);
                                columnsArea.setColumnsWidth(resultWidths);
                                dataArea.setColumnsWidth(resultWidths)
                            }
                            dataArea.groupWidth(groupWidth - _diff);
                            columnsArea.groupWidth(groupWidth - _diff)
                        }
                        if (that._hasHeight && that._filterFields.isVisible() && filterHeaderCell.height() !== filterAreaHeight) {
                            var _diff2 = filterHeaderCell.height() - filterAreaHeight;
                            if (_diff2 > 0) {
                                hasRowsScroll = calculateHasScroll(dataAreaHeight - _diff2, totalHeight);
                                var _groupHeight = calculateGroupHeight(dataAreaHeight - _diff2, totalHeight, hasRowsScroll, hasColumnsScroll, scrollBarWidth);
                                dataArea.groupHeight(_groupHeight);
                                rowsArea.groupHeight(_groupHeight)
                            }
                        }
                        if ("virtual" === scrollingOptions.mode) {
                            var virtualContentParams = that._dataController.calculateVirtualContentParams({
                                virtualRowHeight: scrollingOptions.virtualRowHeight,
                                virtualColumnWidth: scrollingOptions.virtualColumnWidth,
                                itemWidths: resultWidths,
                                itemHeights: resultHeights,
                                rowCount: resultHeights.length,
                                columnCount: resultWidths.length,
                                viewportWidth: groupWidth,
                                viewportHeight: that._hasHeight ? groupHeight : (0, _renderer.default)(window).outerHeight()
                            });
                            dataArea.setVirtualContentParams({
                                top: virtualContentParams.contentTop,
                                left: virtualContentParams.contentLeft,
                                width: virtualContentParams.width,
                                height: virtualContentParams.height
                            });
                            rowsArea.setVirtualContentParams({
                                top: virtualContentParams.contentTop,
                                width: rowsAreaWidth,
                                height: virtualContentParams.height
                            });
                            columnsArea.setVirtualContentParams({
                                left: virtualContentParams.contentLeft,
                                width: virtualContentParams.width,
                                height: columnsArea.groupElement().height()
                            })
                        }
                        var updateScrollableResults = [];
                        dataArea.processScroll(scrollBarInfo.scrollBarUseNative, hasColumnsScroll, hasRowsScroll);
                        (0, _iterator.each)([columnsArea, rowsArea, dataArea], function(_, area) {
                            updateScrollableResults.push(area && area.updateScrollable())
                        });
                        that._updateLoading();
                        that._renderNoDataText(dataAreaCell);
                        _deferred.when.apply(_renderer.default, updateScrollableResults).done(function() {
                            that._updateScrollPosition(columnsArea, rowsArea, dataArea);
                            that._subscribeToEvents(columnsArea, rowsArea, dataArea);
                            d.resolve()
                        })
                    })
                });
                return d
            },
            applyPartialDataSource: function(area, path, dataSource) {
                this._dataController.applyPartialDataSource(area, path, dataSource)
            }
        }).inherit(_uiPivot_grid8.ExportMixin).include(_uiPivot_grid9.default);
        (0, _component_registrator.default)("dxPivotGrid", PivotGrid);
        var _default = PivotGrid;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/pivot_grid/ui.pivot_grid.data_controller.js ***!
      \*********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.DataController = void 0;
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/callbacks */ 27));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _extend2 = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _string = __webpack_require__( /*! ../../core/utils/string */ 43);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _uiGrid_core = __webpack_require__( /*! ../grid_core/ui.grid_core.virtual_scrolling_core */ 403);
        var _uiGrid_core2 = __webpack_require__( /*! ../grid_core/ui.grid_core.virtual_columns_core */ 420);
        var _uiGrid_core3 = __webpack_require__( /*! ../grid_core/ui.grid_core.state_storing_core */ 392);
        var _data_source = _interopRequireDefault(__webpack_require__( /*! ./data_source */ 292));
        var _uiPivot_grid = __webpack_require__( /*! ./ui.pivot_grid.utils */ 84);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }
        var math = Math;
        var GRAND_TOTAL_TYPE = "GT";
        var TOTAL_TYPE = "T";
        var DATA_TYPE = "D";
        var NOT_AVAILABLE = "#N/A";
        var CHANGING_DURATION_IF_PAGINATE = 300;
        var proxyMethod = function(instance, methodName, defaultResult) {
            if (!instance[methodName]) {
                instance[methodName] = function() {
                    var dataSource = this._dataSource;
                    return dataSource ? dataSource[methodName].apply(dataSource, arguments) : defaultResult
                }
            }
        };
        var DataController = _class.default.inherit(function() {
            function getHeaderItemText(item, description, options) {
                var text = item.text;
                if ((0, _type.isDefined)(item.displayText)) {
                    text = item.displayText
                } else {
                    if ((0, _type.isDefined)(item.caption)) {
                        text = item.caption
                    } else {
                        if (item.type === GRAND_TOTAL_TYPE) {
                            text = options.texts.grandTotal
                        }
                    }
                }
                if (item.isAdditionalTotal) {
                    text = (0, _string.format)(options.texts.total || "", text)
                }
                return text
            }

            function formatCellValue(value, dataField, errorText) {
                return value === NOT_AVAILABLE ? errorText : (0, _uiPivot_grid.formatValue)(value, dataField)
            }
            var createHeaderInfo = function() {
                var getHeaderItemsDepth = function(headerItems) {
                    var depth = 0;
                    (0, _uiPivot_grid.foreachTree)(headerItems, function(items) {
                        depth = math.max(depth, items.length)
                    });
                    return depth
                };
                var createInfoItem = function(headerItem, breadth, isHorizontal, isTree) {
                    var infoItem = {
                        type: headerItem.type,
                        text: headerItem.text
                    };
                    if (headerItem.path) {
                        infoItem.path = headerItem.path
                    }
                    if (headerItem.width) {
                        infoItem.width = headerItem.width
                    }
                    if ((0, _type.isDefined)(headerItem.wordWrapEnabled)) {
                        infoItem.wordWrapEnabled = headerItem.wordWrapEnabled
                    }
                    if (headerItem.isLast) {
                        infoItem.isLast = true
                    }
                    if (headerItem.sorted) {
                        infoItem.sorted = true
                    }
                    if (headerItem.isMetric) {
                        infoItem.dataIndex = headerItem.dataIndex
                    }
                    if ((0, _type.isDefined)(headerItem.expanded)) {
                        infoItem.expanded = headerItem.expanded
                    }
                    if (breadth > 1) {
                        infoItem[isHorizontal ? "colspan" : "rowspan"] = breadth
                    }
                    if (headerItem.depthSize && headerItem.depthSize > 1) {
                        infoItem[isHorizontal ? "rowspan" : "colspan"] = headerItem.depthSize
                    }
                    if (headerItem.index >= 0) {
                        infoItem.dataSourceIndex = headerItem.index
                    }
                    if (isTree && headerItem.children && headerItem.children.length && !headerItem.children[0].isMetric) {
                        infoItem.width = null;
                        infoItem.isWhiteSpace = true
                    }
                    return infoItem
                };
                var addInfoItem = function(info, options) {
                    var breadth = options.lastIndex - options.index || 1;
                    var addInfoItemCore = function(info, infoItem, itemIndex, depthIndex, isHorizontal) {
                        var index = isHorizontal ? depthIndex : itemIndex;
                        while (!info[index]) {
                            info.push([])
                        }
                        if (isHorizontal) {
                            info[index].push(infoItem)
                        } else {
                            info[index].unshift(infoItem)
                        }
                    };
                    var itemInfo = createInfoItem(options.headerItem, breadth, options.isHorizontal, options.isTree);
                    addInfoItemCore(info, itemInfo, options.index, options.depth, options.isHorizontal);
                    if (!options.headerItem.children || 0 === options.headerItem.children.length) {
                        return options.lastIndex + 1
                    }
                    return options.lastIndex
                };
                var isItemSorted = function(items, sortBySummaryPath) {
                    var path;
                    var item = items[0];
                    var stringValuesUsed = (0, _type.isString)(sortBySummaryPath[0]);
                    var headerItem = item.dataIndex >= 0 ? items[1] : item;
                    if (stringValuesUsed && sortBySummaryPath[0].indexOf("&[") !== -1 && headerItem.key || !headerItem.key) {
                        path = (0, _uiPivot_grid.createPath)(items)
                    } else {
                        path = (0, _iterator.map)(items, function(item) {
                            return item.dataIndex >= 0 ? item.value : item.text
                        }).reverse()
                    }
                    if (item.type === GRAND_TOTAL_TYPE) {
                        path = path.slice(1)
                    }
                    return path.join("/") === sortBySummaryPath.join("/")
                };
                var getViewHeaderItems = function(headerItems, headerDescriptions, cellDescriptions, depthSize, options) {
                    var cellDescriptionsCount = cellDescriptions.length;
                    var viewHeaderItems = createViewHeaderItems(headerItems, headerDescriptions);
                    var dataFields = options.dataFields;
                    var d = new _deferred.Deferred;
                    (0, _deferred.when)(viewHeaderItems).done(function(viewHeaderItems) {
                        options.notifyProgress(.5);
                        if (options.showGrandTotals) {
                            viewHeaderItems[!options.showTotalsPrior ? "push" : "unshift"]({
                                type: GRAND_TOTAL_TYPE,
                                isEmpty: options.isEmptyGrandTotal
                            })
                        }
                        var hideTotals = false === options.showTotals || dataFields.length > 0 && dataFields.length === options.hiddenTotals.length;
                        var hideData = dataFields.length > 0 && options.hiddenValues.length === dataFields.length;
                        if (hideData && hideTotals) {
                            depthSize = 1
                        }
                        if (!hideTotals || "tree" === options.layout) {
                            addAdditionalTotalHeaderItems(viewHeaderItems, headerDescriptions, options.showTotalsPrior, "tree" === options.layout)
                        }(0, _deferred.when)((0, _uiPivot_grid.foreachTreeAsync)(viewHeaderItems, function(items) {
                            var item = items[0];
                            if (!item.children || 0 === item.children.length) {
                                item.depthSize = depthSize - items.length + 1
                            }
                        })).done(function() {
                            if (cellDescriptionsCount > 1) {
                                addMetricHeaderItems(viewHeaderItems, cellDescriptions, options)
                            }!options.showEmpty && removeHiddenItems(viewHeaderItems);
                            options.notifyProgress(.75);
                            (0, _deferred.when)((0, _uiPivot_grid.foreachTreeAsync)(viewHeaderItems, function(items) {
                                var item = items[0];
                                var isMetric = item.isMetric;
                                var field = headerDescriptions[items.length - 1] || {};
                                if (item.type === DATA_TYPE && !isMetric) {
                                    item.width = field.width
                                }
                                if (true === hideData && item.type === DATA_TYPE) {
                                    var parentChildren = (items[1] ? items[1].children : viewHeaderItems) || [];
                                    parentChildren.splice((0, _array.inArray)(item, parentChildren), 1);
                                    return
                                }
                                if (isMetric) {
                                    item.wordWrapEnabled = cellDescriptions[item.dataIndex].wordWrapEnabled
                                } else {
                                    item.wordWrapEnabled = field.wordWrapEnabled
                                }
                                item.isLast = !item.children || !item.children.length;
                                if (item.isLast) {
                                    (0, _iterator.each)(options.sortBySummaryPaths, function(index, sortBySummaryPath) {
                                        if (!(0, _type.isDefined)(item.dataIndex)) {
                                            sortBySummaryPath = sortBySummaryPath.slice(0);
                                            sortBySummaryPath.pop()
                                        }
                                        if (isItemSorted(items, sortBySummaryPath)) {
                                            item.sorted = true;
                                            return false
                                        }
                                    })
                                }
                                item.text = getHeaderItemText(item, field, options)
                            })).done(function() {
                                if (!viewHeaderItems.length) {
                                    viewHeaderItems.push({})
                                }
                                options.notifyProgress(1);
                                d.resolve(viewHeaderItems)
                            })
                        })
                    });
                    return d
                };

                function createHeaderItem(childrenStack, depth, index) {
                    var parent = childrenStack[depth] = childrenStack[depth] || [];
                    var node = parent[index] = {};
                    if (childrenStack[depth + 1]) {
                        node.children = childrenStack[depth + 1];
                        for (var i = depth + 1; i < childrenStack.length; i++) {
                            childrenStack[i] = void 0
                        }
                        childrenStack.length = depth + 1
                    }
                    return node
                }

                function createViewHeaderItems(headerItems, headerDescriptions) {
                    var headerDescriptionsCount = headerDescriptions && headerDescriptions.length || 0;
                    var childrenStack = [];
                    var d = new _deferred.Deferred;
                    var headerItem;
                    (0, _deferred.when)((0, _uiPivot_grid.foreachTreeAsync)(headerItems, function(items, index) {
                        var item = items[0];
                        var path = (0, _uiPivot_grid.createPath)(items);
                        headerItem = createHeaderItem(childrenStack, path.length, index);
                        headerItem.type = DATA_TYPE;
                        headerItem.value = item.value;
                        headerItem.path = path;
                        headerItem.text = item.text;
                        headerItem.index = item.index;
                        headerItem.displayText = item.displayText;
                        headerItem.key = item.key;
                        headerItem.isEmpty = item.isEmpty;
                        if (path.length < headerDescriptionsCount && (!item.children || 0 !== item.children.length)) {
                            headerItem.expanded = !!item.children
                        }
                    })).done(function() {
                        d.resolve(createHeaderItem(childrenStack, 0, 0).children || [])
                    });
                    return d
                }

                function addMetricHeaderItems(headerItems, cellDescriptions, options) {
                    (0, _uiPivot_grid.foreachTree)(headerItems, function(items) {
                        var item = items[0];
                        var i;
                        if (!item.children || 0 === item.children.length) {
                            item.children = [];
                            for (i = 0; i < cellDescriptions.length; i++) {
                                var isGrandTotal = item.type === GRAND_TOTAL_TYPE;
                                var isTotal = item.type === TOTAL_TYPE;
                                var isValue = item.type === DATA_TYPE;
                                var columnIsHidden = false === cellDescriptions[i].visible || isGrandTotal && (0, _array.inArray)(i, options.hiddenGrandTotals) !== -1 || isTotal && (0, _array.inArray)(i, options.hiddenTotals) !== -1 || isValue && (0, _array.inArray)(i, options.hiddenValues) !== -1;
                                if (columnIsHidden) {
                                    continue
                                }
                                item.children.push({
                                    caption: cellDescriptions[i].caption,
                                    path: item.path,
                                    type: item.type,
                                    value: i,
                                    index: item.index,
                                    dataIndex: i,
                                    isMetric: true,
                                    isEmpty: item.isEmpty && item.isEmpty[i]
                                })
                            }
                        }
                    })
                }

                function addAdditionalTotalHeaderItems(headerItems, headerDescriptions, showTotalsPrior, isTree) {
                    showTotalsPrior = showTotalsPrior || isTree;
                    (0, _uiPivot_grid.foreachTree)(headerItems, function(items, index) {
                        var item = items[0];
                        var parentChildren = (items[1] ? items[1].children : headerItems) || [];
                        var dataField = headerDescriptions[items.length - 1];
                        if (item.type === DATA_TYPE && item.expanded && (false !== dataField.showTotals || isTree)) {
                            index !== -1 && parentChildren.splice(showTotalsPrior ? index : index + 1, 0, (0, _extend2.extend)({}, item, {
                                children: null,
                                type: TOTAL_TYPE,
                                expanded: showTotalsPrior ? true : null,
                                isAdditionalTotal: true
                            }));
                            if (showTotalsPrior) {
                                item.expanded = null
                            }
                        }
                    })
                }
                var removeEmptyParent = function removeEmptyParent(items, index) {
                    var parent = items[index + 1];
                    if (!items[index].children.length && parent && parent.children) {
                        parent.children.splice((0, _array.inArray)(items[index], parent.children), 1);
                        removeEmptyParent(items, index + 1)
                    }
                };

                function removeHiddenItems(headerItems) {
                    (0, _uiPivot_grid.foreachTree)([{
                        children: headerItems
                    }], function(items, index) {
                        var item = items[0];
                        var parentChildren = (items[1] ? items[1].children : headerItems) || [];
                        var isEmpty = item.isEmpty;
                        if (isEmpty && isEmpty.length) {
                            isEmpty = item.isEmpty.filter(function(isEmpty) {
                                return isEmpty
                            }).length === isEmpty.length
                        }
                        if (item && !item.children && isEmpty) {
                            parentChildren.splice(index, 1);
                            removeEmptyParent(items, 1)
                        }
                    })
                }
                var fillHeaderInfo = function(info, viewHeaderItems, depthSize, isHorizontal, isTree) {
                    var lastIndex = 0;
                    var index;
                    var depth;
                    var indexesByDepth = [0];
                    (0, _uiPivot_grid.foreachTree)(viewHeaderItems, function(items) {
                        var headerItem = items[0];
                        depth = headerItem.isMetric ? depthSize : items.length - 1;
                        while (indexesByDepth.length - 1 < depth) {
                            indexesByDepth.push(indexesByDepth[indexesByDepth.length - 1])
                        }
                        index = indexesByDepth[depth] || 0;
                        lastIndex = addInfoItem(info, {
                            headerItem: headerItem,
                            index: index,
                            lastIndex: lastIndex,
                            depth: depth,
                            isHorizontal: isHorizontal,
                            isTree: isTree
                        });
                        indexesByDepth.length = depth;
                        indexesByDepth.push(lastIndex)
                    })
                };
                return function(headerItems, headerDescriptions, cellDescriptions, isHorizontal, options) {
                    var info = [];
                    var depthSize = getHeaderItemsDepth(headerItems) || 1;
                    var d = new _deferred.Deferred;
                    getViewHeaderItems(headerItems, headerDescriptions, cellDescriptions, depthSize, options).done(function(viewHeaderItems) {
                        fillHeaderInfo(info, viewHeaderItems, depthSize, isHorizontal, "tree" === options.layout);
                        options.notifyProgress(1);
                        d.resolve(info)
                    });
                    return d
                }
            }();

            function createSortPaths(headerFields, dataFields) {
                var sortBySummaryPaths = [];
                (0, _iterator.each)(headerFields, function(index, headerField) {
                    var fieldIndex = (0, _uiPivot_grid.findField)(dataFields, headerField.sortBySummaryField);
                    if (fieldIndex >= 0) {
                        sortBySummaryPaths.push((headerField.sortBySummaryPath || []).concat([fieldIndex]))
                    }
                });
                return sortBySummaryPaths
            }

            function foreachRowInfo(rowsInfo, callback) {
                var columnOffset = 0;
                var columnOffsetResetIndexes = [];
                for (var i = 0; i < rowsInfo.length; i++) {
                    for (var j = 0; j < rowsInfo[i].length; j++) {
                        var rowSpanOffset = (rowsInfo[i][j].rowspan || 1) - 1;
                        var visibleIndex = i + rowSpanOffset;
                        if (columnOffsetResetIndexes[i]) {
                            columnOffset -= columnOffsetResetIndexes[i];
                            columnOffsetResetIndexes[i] = 0
                        }
                        if (false === callback(rowsInfo[i][j], visibleIndex, i, j, columnOffset)) {
                            break
                        }
                        columnOffsetResetIndexes[i + (rowsInfo[i][j].rowspan || 1)] = (columnOffsetResetIndexes[i + (rowsInfo[i][j].rowspan || 1)] || 0) + 1;
                        columnOffset++
                    }
                }
            }

            function createCellsInfo(rowsInfo, columnsInfo, data, dataFields, dataFieldArea, errorText) {
                var info = [];
                var dataFieldAreaInRows = "row" === dataFieldArea;
                var dataSourceCells = data.values;
                dataSourceCells.length && foreachRowInfo(rowsInfo, function(rowInfo, rowIndex) {
                    var row = info[rowIndex] = [];
                    var dataRow = dataSourceCells[rowInfo.dataSourceIndex >= 0 ? rowInfo.dataSourceIndex : data.grandTotalRowIndex] || [];
                    rowInfo.isLast && (0, _uiGrid_core2.foreachColumnInfo)(columnsInfo, function(columnInfo, columnIndex) {
                        var dataIndex = (dataFieldAreaInRows ? rowInfo.dataIndex : columnInfo.dataIndex) || 0;
                        var dataField = dataFields[dataIndex];
                        if (columnInfo.isLast && dataField) {
                            var cell = dataRow[columnInfo.dataSourceIndex >= 0 ? columnInfo.dataSourceIndex : data.grandTotalColumnIndex];
                            if (!Array.isArray(cell)) {
                                cell = [cell]
                            }
                            var cellValue = cell[dataIndex];
                            row[columnIndex] = {
                                text: formatCellValue(cellValue, dataField, errorText),
                                value: cellValue,
                                format: dataField.format,
                                dataType: dataField.dataType,
                                columnType: columnInfo.type,
                                rowType: rowInfo.type,
                                rowPath: rowInfo.path || [],
                                columnPath: columnInfo.path || [],
                                dataIndex: dataIndex
                            };
                            if (dataField.width) {
                                row[columnIndex].width = dataField.width
                            }
                        }
                    })
                });
                return info
            }

            function getHeaderIndexedItems(headerItems, options) {
                var visibleIndex = 0;
                var indexedItems = [];
                (0, _uiPivot_grid.foreachTree)(headerItems, function(items) {
                    var headerItem = items[0];
                    var path = (0, _uiPivot_grid.createPath)(items);
                    if (headerItem.children && false === options.showTotals) {
                        return
                    }
                    var indexedItem = (0, _extend2.extend)(true, {}, headerItem, {
                        visibleIndex: visibleIndex++,
                        path: path
                    });
                    if ((0, _type.isDefined)(indexedItem.index)) {
                        indexedItems[indexedItem.index] = indexedItem
                    } else {
                        indexedItems.push(indexedItem)
                    }
                });
                return indexedItems
            }

            function createScrollController(dataController, component, dataAdapter) {
                if (component && "virtual" === component.option("scrolling.mode")) {
                    return new _uiGrid_core.VirtualScrollController(component, (0, _extend2.extend)({
                        hasKnownLastPage: function() {
                            return true
                        },
                        pageCount: function() {
                            return math.ceil(this.totalItemsCount() / this.pageSize())
                        },
                        updateLoading: function() {},
                        itemsCount: function() {
                            if (this.pageIndex() < this.pageCount() - 1) {
                                return this.pageSize()
                            } else {
                                return this.totalItemsCount() % this.pageSize()
                            }
                        },
                        items: function() {
                            return []
                        },
                        viewportItems: function() {
                            return []
                        },
                        onChanged: function() {},
                        isLoading: function() {
                            return dataController.isLoading()
                        },
                        changingDuration: function() {
                            var dataSource = dataController._dataSource;
                            if (dataSource.paginate()) {
                                return CHANGING_DURATION_IF_PAGINATE
                            }
                            return dataController._changingDuration || 0
                        }
                    }, dataAdapter))
                }
            }

            function getHiddenTotals(dataFields) {
                var result = [];
                (0, _iterator.each)(dataFields, function(index, field) {
                    if (false === field.showTotals) {
                        result.push(index)
                    }
                });
                return result
            }

            function getHiddenValues(dataFields) {
                var result = [];
                dataFields.forEach(function(field, index) {
                    if (void 0 === field.showValues && false === field.showTotals || false === field.showValues) {
                        result.push(index)
                    }
                });
                return result
            }

            function getHiddenGrandTotalsTotals(dataFields, columnFields) {
                var result = [];
                (0, _iterator.each)(dataFields, function(index, field) {
                    if (false === field.showGrandTotals) {
                        result.push(index)
                    }
                });
                if (0 === columnFields.length && result.length === dataFields.length) {
                    result = []
                }
                return result
            }
            var members = {
                ctor: function(options) {
                    var that = this;
                    var virtualScrollControllerChanged = that._fireChanged.bind(that);
                    options = that._options = options || {};
                    that.dataSourceChanged = (0, _callbacks.default)();
                    that._dataSource = that._createDataSource(options);
                    that._rowsScrollController = createScrollController(that, options.component, {
                        totalItemsCount: function() {
                            return that.totalRowCount()
                        },
                        pageIndex: function(index) {
                            return that.rowPageIndex(index)
                        },
                        pageSize: function() {
                            return that.rowPageSize()
                        },
                        load: function() {
                            if (that._rowsScrollController.pageIndex() >= this.pageCount()) {
                                that._rowsScrollController.pageIndex(this.pageCount() - 1)
                            }
                            return that._rowsScrollController.handleDataChanged(function() {
                                if (that._dataSource.paginate()) {
                                    that._dataSource.load()
                                } else {
                                    virtualScrollControllerChanged.apply(this, arguments)
                                }
                            })
                        }
                    });
                    that._columnsScrollController = createScrollController(that, options.component, {
                        totalItemsCount: function() {
                            return that.totalColumnCount()
                        },
                        pageIndex: function(index) {
                            return that.columnPageIndex(index)
                        },
                        pageSize: function() {
                            return that.columnPageSize()
                        },
                        load: function() {
                            if (that._columnsScrollController.pageIndex() >= this.pageCount()) {
                                that._columnsScrollController.pageIndex(this.pageCount() - 1)
                            }
                            return that._columnsScrollController.handleDataChanged(function() {
                                if (that._dataSource.paginate()) {
                                    that._dataSource.load()
                                } else {
                                    virtualScrollControllerChanged.apply(this, arguments)
                                }
                            })
                        }
                    });
                    that._stateStoringController = new _uiGrid_core3.StateStoringController(options.component).init();
                    that._columnsInfo = [];
                    that._rowsInfo = [];
                    that._cellsInfo = [];
                    that.expandValueChanging = (0, _callbacks.default)();
                    that.loadingChanged = (0, _callbacks.default)();
                    that.progressChanged = (0, _callbacks.default)();
                    that.scrollChanged = (0, _callbacks.default)();
                    that.load();
                    that._update();
                    that.changed = (0, _callbacks.default)()
                },
                _fireChanged: function() {
                    var that = this;
                    var startChanging = new Date;
                    that.changed && !that._lockChanged && that.changed.fire();
                    that._changingDuration = new Date - startChanging
                },
                _correctSkipsTakes: function(rowIndex, rowSkip, rowSpan, levels, skips, takes) {
                    var endIndex = rowSpan ? rowIndex + rowSpan - 1 : rowIndex;
                    skips[levels.length] = skips[levels.length] || 0;
                    takes[levels.length] = takes[levels.length] || 0;
                    if (endIndex < rowSkip) {
                        skips[levels.length]++
                    } else {
                        takes[levels.length]++
                    }
                },
                _calculatePagingForRowExpandedPaths: function(options, skips, takes, rowExpandedSkips, rowExpandedTakes) {
                    var rows = this._rowsInfo;
                    var rowCount = Math.min(options.rowSkip + options.rowTake, rows.length);
                    var rowExpandedPaths = options.rowExpandedPaths;
                    var levels = [];
                    var expandedPathIndexes = {};
                    var i;
                    var j;
                    var path;
                    rowExpandedPaths.forEach(function(path, index) {
                        expandedPathIndexes[path] = index
                    });
                    for (i = 0; i < rowCount; i++) {
                        takes.length = skips.length = levels.length + 1;
                        for (j = 0; j < rows[i].length; j++) {
                            var cell = rows[i][j];
                            if ("D" === cell.type) {
                                this._correctSkipsTakes(i, options.rowSkip, cell.rowspan, levels, skips, takes);
                                path = cell.path || path;
                                var expandIndex = path && path.length > 1 ? expandedPathIndexes[path.slice(0, -1)] : -1;
                                if (expandIndex >= 0) {
                                    rowExpandedSkips[expandIndex] = skips[levels.length] || 0;
                                    rowExpandedTakes[expandIndex] = takes[levels.length] || 0
                                }
                                if (cell.rowspan) {
                                    levels.push(cell.rowspan)
                                }
                            }
                        }
                        levels = levels.map(function(level) {
                            return level - 1
                        }).filter(function(level) {
                            return level > 0
                        })
                    }
                },
                _calculatePagingForColumnExpandedPaths: function(options, skips, takes, expandedSkips, expandedTakes) {
                    var skipByPath = {};
                    var takeByPath = {};
                    (0, _uiGrid_core2.foreachColumnInfo)(this._columnsInfo, function(columnInfo, columnIndex) {
                        if ("D" === columnInfo.type && columnInfo.path && void 0 === columnInfo.dataIndex) {
                            var colspan = columnInfo.colspan || 1;
                            var path = columnInfo.path.slice(0, -1).toString();
                            skipByPath[path] = skipByPath[path] || 0;
                            takeByPath[path] = takeByPath[path] || 0;
                            if (columnIndex + colspan <= options.columnSkip) {
                                skipByPath[path]++
                            } else {
                                if (columnIndex < options.columnSkip + options.columnTake) {
                                    takeByPath[path]++
                                }
                            }
                        }
                    });
                    skips[0] = skipByPath[[]];
                    takes[0] = takeByPath[[]];
                    options.columnExpandedPaths.forEach(function(path, index) {
                        var skip = skipByPath[path];
                        var take = takeByPath[path];
                        if (void 0 !== skip) {
                            expandedSkips[index] = skip
                        }
                        if (void 0 !== take) {
                            expandedTakes[index] = take
                        }
                    })
                },
                _processPagingForExpandedPaths: function(options, area, storeLoadOptions, reload) {
                    var expandedPaths = options[area + "ExpandedPaths"];
                    var expandedSkips = expandedPaths.map(function() {
                        return 0
                    });
                    var expandedTakes = expandedPaths.map(function() {
                        return reload ? options.pageSize : 0
                    });
                    var skips = [];
                    var takes = [];
                    if (!reload) {
                        if ("row" === area) {
                            this._calculatePagingForRowExpandedPaths(options, skips, takes, expandedSkips, expandedTakes)
                        } else {
                            this._calculatePagingForColumnExpandedPaths(options, skips, takes, expandedSkips, expandedTakes)
                        }
                    }
                    this._savePagingForExpandedPaths(options, area, storeLoadOptions, skips[0], takes[0], expandedSkips, expandedTakes)
                },
                _savePagingForExpandedPaths: function(options, area, storeLoadOptions, skip, take, expandedSkips, expandedTakes) {
                    var expandedPaths = options[area + "ExpandedPaths"];
                    options[area + "ExpandedPaths"] = [];
                    options[area + "Skip"] = void 0 !== skip ? skip : options[area + "Skip"];
                    options[area + "Take"] = void 0 !== take ? take : options[area + "Take"];
                    for (var i = 0; i < expandedPaths.length; i++) {
                        if (expandedTakes[i]) {
                            var _extend;
                            var isOppositeArea = options.area && options.area !== area;
                            storeLoadOptions.push((0, _extend2.extend)({
                                area: area,
                                headerName: area + "s"
                            }, options, (_extend = {}, _defineProperty(_extend, area + "Skip", expandedSkips[i]), _defineProperty(_extend, area + "Take", expandedTakes[i]), _defineProperty(_extend, isOppositeArea ? "oppositePath" : "path", expandedPaths[i]), _extend)))
                        }
                    }
                },
                _handleCustomizeStoreLoadOptions: function(storeLoadOptions, reload) {
                    var _this = this;
                    var options = storeLoadOptions[0];
                    var rowsScrollController = this._rowsScrollController;
                    if (this._dataSource.paginate() && rowsScrollController) {
                        var rowPageSize = rowsScrollController._dataSource.pageSize();
                        if ("rows" === options.headerName) {
                            options.rowSkip = 0;
                            options.rowTake = rowPageSize;
                            options.rowExpandedPaths = []
                        } else {
                            options.rowSkip = rowsScrollController.beginPageIndex() * rowPageSize;
                            options.rowTake = (rowsScrollController.endPageIndex() - rowsScrollController.beginPageIndex() + 1) * rowPageSize;
                            this._processPagingForExpandedPaths(options, "row", storeLoadOptions, reload)
                        }
                    }
                    var columnsScrollController = this._columnsScrollController;
                    if (this._dataSource.paginate() && columnsScrollController) {
                        var columnPageSize = columnsScrollController._dataSource.pageSize();
                        storeLoadOptions.forEach(function(options, index) {
                            if ("columns" === options.headerName) {
                                options.columnSkip = 0;
                                options.columnTake = columnPageSize;
                                options.columnExpandedPaths = []
                            } else {
                                options.columnSkip = columnsScrollController.beginPageIndex() * columnPageSize;
                                options.columnTake = (columnsScrollController.endPageIndex() - columnsScrollController.beginPageIndex() + 1) * columnPageSize;
                                _this._processPagingForExpandedPaths(options, "column", storeLoadOptions, reload)
                            }
                        })
                    }
                },
                load: function() {
                    var that = this;
                    var stateStoringController = this._stateStoringController;
                    if (stateStoringController.isEnabled() && !stateStoringController.isLoaded()) {
                        stateStoringController.load().always(function(state) {
                            if (state) {
                                that._dataSource.state(state)
                            } else {
                                that._dataSource.load()
                            }
                        })
                    } else {
                        that._dataSource.load()
                    }
                },
                calculateVirtualContentParams: function(contentParams) {
                    var that = this;
                    var rowsScrollController = that._rowsScrollController;
                    var columnsScrollController = that._columnsScrollController;
                    if (rowsScrollController && columnsScrollController) {
                        rowsScrollController.viewportItemSize(contentParams.virtualRowHeight);
                        rowsScrollController.viewportSize(contentParams.viewportHeight / rowsScrollController.viewportItemSize());
                        rowsScrollController.setContentSize(contentParams.itemHeights);
                        columnsScrollController.viewportItemSize(contentParams.virtualColumnWidth);
                        columnsScrollController.viewportSize(contentParams.viewportWidth / columnsScrollController.viewportItemSize());
                        columnsScrollController.setContentSize(contentParams.itemWidths);
                        (0, _common.deferUpdate)(function() {
                            columnsScrollController.loadIfNeed();
                            rowsScrollController.loadIfNeed()
                        });
                        that.scrollChanged.fire({
                            left: columnsScrollController.getViewportPosition(),
                            top: rowsScrollController.getViewportPosition()
                        });
                        return {
                            contentTop: rowsScrollController.getContentOffset(),
                            contentLeft: columnsScrollController.getContentOffset(),
                            width: columnsScrollController.getVirtualContentSize(),
                            height: rowsScrollController.getVirtualContentSize()
                        }
                    }
                },
                setViewportPosition: function(left, top) {
                    this._rowsScrollController.setViewportPosition(top || 0);
                    this._columnsScrollController.setViewportPosition(left || 0)
                },
                subscribeToWindowScrollEvents: function($element) {
                    this._rowsScrollController && this._rowsScrollController.subscribeToWindowScrollEvents($element)
                },
                updateWindowScrollPosition: function(position) {
                    this._rowsScrollController && this._rowsScrollController.scrollTo(position)
                },
                updateViewOptions: function(options) {
                    (0, _extend2.extend)(this._options, options);
                    this._update()
                },
                _handleExpandValueChanging: function(e) {
                    this.expandValueChanging.fire(e)
                },
                _handleLoadingChanged: function(isLoading) {
                    this.loadingChanged.fire(isLoading)
                },
                _handleProgressChanged: function(progress) {
                    this.progressChanged.fire(progress)
                },
                _handleFieldsPrepared: function(e) {
                    this._options.onFieldsPrepared && this._options.onFieldsPrepared(e)
                },
                _createDataSource: function(options) {
                    var that = this;
                    var dataSourceOptions = options.dataSource;
                    var dataSource;
                    that._isSharedDataSource = dataSourceOptions instanceof _data_source.default;
                    if (that._isSharedDataSource) {
                        dataSource = dataSourceOptions
                    } else {
                        dataSource = new _data_source.default(dataSourceOptions)
                    }
                    that._expandValueChangingHandler = that._handleExpandValueChanging.bind(that);
                    that._loadingChangedHandler = that._handleLoadingChanged.bind(that);
                    that._fieldsPreparedHandler = that._handleFieldsPrepared.bind(that);
                    that._customizeStoreLoadOptionsHandler = that._handleCustomizeStoreLoadOptions.bind(that);
                    that._changedHandler = function() {
                        that._update();
                        that.dataSourceChanged.fire()
                    };
                    that._progressChangedHandler = function(progress) {
                        that._handleProgressChanged(.8 * progress)
                    };
                    dataSource.on("changed", that._changedHandler);
                    dataSource.on("expandValueChanging", that._expandValueChangingHandler);
                    dataSource.on("loadingChanged", that._loadingChangedHandler);
                    dataSource.on("progressChanged", that._progressChangedHandler);
                    dataSource.on("fieldsPrepared", that._fieldsPreparedHandler);
                    dataSource.on("customizeStoreLoadOptions", that._customizeStoreLoadOptionsHandler);
                    return dataSource
                },
                getDataSource: function() {
                    return this._dataSource
                },
                isLoading: function() {
                    return this._dataSource.isLoading()
                },
                beginLoading: function() {
                    this._dataSource.beginLoading()
                },
                endLoading: function() {
                    this._dataSource.endLoading()
                },
                _update: function() {
                    var that = this;
                    var dataSource = that._dataSource;
                    var options = that._options;
                    var columnFields = dataSource.getAreaFields("column");
                    var rowFields = dataSource.getAreaFields("row");
                    var dataFields = dataSource.getAreaFields("data");
                    var dataFieldsForRows = "row" === options.dataFieldArea ? dataFields : [];
                    var dataFieldsForColumns = "row" !== options.dataFieldArea ? dataFields : [];
                    var data = dataSource.getData();
                    var hiddenTotals = getHiddenTotals(dataFields);
                    var hiddenValues = getHiddenValues(dataFields);
                    var hiddenGrandTotals = getHiddenGrandTotalsTotals(dataFields, columnFields);
                    var grandTotalsAreHiddenForNotAllDataFields = dataFields.length > 0 ? hiddenGrandTotals.length !== dataFields.length : true;
                    var rowOptions = {
                        isEmptyGrandTotal: data.isEmptyGrandTotalRow,
                        texts: options.texts || {},
                        hiddenTotals: hiddenTotals,
                        hiddenValues: hiddenValues,
                        hiddenGrandTotals: [],
                        showTotals: options.showRowTotals,
                        showGrandTotals: false !== options.showRowGrandTotals && grandTotalsAreHiddenForNotAllDataFields,
                        sortBySummaryPaths: createSortPaths(columnFields, dataFields),
                        showTotalsPrior: "rows" === options.showTotalsPrior || "both" === options.showTotalsPrior,
                        showEmpty: !options.hideEmptySummaryCells,
                        layout: options.rowHeaderLayout,
                        fields: rowFields,
                        dataFields: dataFields,
                        progress: 0
                    };
                    var columnOptions = {
                        isEmptyGrandTotal: data.isEmptyGrandTotalColumn,
                        texts: options.texts || {},
                        hiddenTotals: hiddenTotals,
                        hiddenValues: hiddenValues,
                        hiddenGrandTotals: hiddenGrandTotals,
                        showTotals: options.showColumnTotals,
                        showTotalsPrior: "columns" === options.showTotalsPrior || "both" === options.showTotalsPrior,
                        showGrandTotals: false !== options.showColumnGrandTotals && grandTotalsAreHiddenForNotAllDataFields,
                        sortBySummaryPaths: createSortPaths(rowFields, dataFields),
                        showEmpty: !options.hideEmptySummaryCells,
                        fields: columnFields,
                        dataFields: dataFields,
                        progress: 0
                    };
                    var notifyProgress = function(progress) {
                        this.progress = progress;
                        that._handleProgressChanged(.8 + .1 * rowOptions.progress + .1 * columnOptions.progress)
                    };
                    rowOptions.notifyProgress = notifyProgress;
                    columnOptions.notifyProgress = notifyProgress;
                    if (!(0, _type.isDefined)(data.grandTotalRowIndex)) {
                        data.grandTotalRowIndex = getHeaderIndexedItems(data.rows, rowOptions).length
                    }
                    if (!(0, _type.isDefined)(data.grandTotalColumnIndex)) {
                        data.grandTotalColumnIndex = getHeaderIndexedItems(data.columns, columnOptions).length
                    }
                    dataSource._changeLoadingCount(1);
                    (0, _deferred.when)(createHeaderInfo(data.columns, columnFields, dataFieldsForColumns, true, columnOptions), createHeaderInfo(data.rows, rowFields, dataFieldsForRows, false, rowOptions)).always(function() {
                        dataSource._changeLoadingCount(-1)
                    }).done(function(columnsInfo, rowsInfo) {
                        that._columnsInfo = columnsInfo;
                        that._rowsInfo = rowsInfo;
                        if (that._rowsScrollController && that._columnsScrollController && that.changed && !that._dataSource.paginate()) {
                            that._lockChanged = true;
                            that._rowsScrollController.load();
                            that._columnsScrollController.load();
                            that._lockChanged = false
                        }
                    }).done(function() {
                        that._fireChanged();
                        if (that._stateStoringController.isEnabled() && !that._dataSource.isLoading()) {
                            that._stateStoringController.state(that._dataSource.state());
                            that._stateStoringController.save()
                        }
                    })
                },
                getRowsInfo: function(getAllData) {
                    var that = this;
                    var rowsInfo = that._rowsInfo;
                    var scrollController = that._rowsScrollController;
                    var rowspan;
                    var i;
                    if (scrollController && !getAllData) {
                        var startIndex = scrollController.beginPageIndex() * that.rowPageSize();
                        var endIndex = scrollController.endPageIndex() * that.rowPageSize() + that.rowPageSize();
                        var newRowsInfo = [];
                        var maxDepth = 1;
                        foreachRowInfo(rowsInfo, function(rowInfo, visibleIndex, rowIndex, _, columnIndex) {
                            var isVisible = visibleIndex >= startIndex && rowIndex < endIndex;
                            var index = rowIndex < startIndex ? 0 : rowIndex - startIndex;
                            var cell = rowInfo;
                            if (isVisible) {
                                newRowsInfo[index] = newRowsInfo[index] || [];
                                rowspan = rowIndex < startIndex ? rowInfo.rowspan - (startIndex - rowIndex) || 1 : rowInfo.rowspan;
                                if (startIndex + index + rowspan > endIndex) {
                                    rowspan = endIndex - (index + startIndex) || 1
                                }
                                if (rowspan !== rowInfo.rowspan) {
                                    cell = (0, _extend2.extend)({}, cell, {
                                        rowspan: rowspan
                                    })
                                }
                                newRowsInfo[index].push(cell);
                                maxDepth = math.max(maxDepth, columnIndex + 1)
                            } else {
                                if (i > endIndex) {
                                    return false
                                }
                            }
                        });
                        foreachRowInfo(newRowsInfo, function(rowInfo, visibleIndex, rowIndex, columnIndex, realColumnIndex) {
                            var colspan = rowInfo.colspan || 1;
                            if (realColumnIndex + colspan > maxDepth) {
                                newRowsInfo[rowIndex][columnIndex] = (0, _extend2.extend)({}, rowInfo, {
                                    colspan: maxDepth - realColumnIndex || 1
                                })
                            }
                        });
                        return newRowsInfo
                    }
                    return rowsInfo
                },
                getColumnsInfo: function(getAllData) {
                    var that = this;
                    var info = that._columnsInfo;
                    var scrollController = that._columnsScrollController;
                    if (scrollController && !getAllData) {
                        var startIndex = scrollController.beginPageIndex() * that.columnPageSize();
                        var endIndex = scrollController.endPageIndex() * that.columnPageSize() + that.columnPageSize();
                        info = (0, _uiGrid_core2.createColumnsInfo)(info, startIndex, endIndex)
                    }
                    return info
                },
                totalRowCount: function() {
                    return this._rowsInfo.length
                },
                rowPageIndex: function(index) {
                    if (void 0 !== index) {
                        this._rowPageIndex = index
                    }
                    return this._rowPageIndex || 0
                },
                totalColumnCount: function() {
                    var count = 0;
                    if (this._columnsInfo && this._columnsInfo.length) {
                        for (var i = 0; i < this._columnsInfo[0].length; i++) {
                            count += this._columnsInfo[0][i].colspan || 1
                        }
                    }
                    return count
                },
                rowPageSize: function(size) {
                    if (void 0 !== size) {
                        this._rowPageSize = size
                    }
                    return this._rowPageSize || 20
                },
                columnPageSize: function(size) {
                    if (void 0 !== size) {
                        this._columnPageSize = size
                    }
                    return this._columnPageSize || 20
                },
                columnPageIndex: function(index) {
                    if (void 0 !== index) {
                        this._columnPageIndex = index
                    }
                    return this._columnPageIndex || 0
                },
                getCellsInfo: function(getAllData) {
                    var rowsInfo = this.getRowsInfo(getAllData);
                    var columnsInfo = this.getColumnsInfo(getAllData);
                    var data = this._dataSource.getData();
                    var texts = this._options.texts || {};
                    return createCellsInfo(rowsInfo, columnsInfo, data, this._dataSource.getAreaFields("data"), this._options.dataFieldArea, texts.dataNotAvailable)
                },
                dispose: function() {
                    var that = this;
                    if (that._isSharedDataSource) {
                        that._dataSource.off("changed", that._changedHandler);
                        that._dataSource.off("expandValueChanging", that._expandValueChangingHandler);
                        that._dataSource.off("loadingChanged", that._loadingChangedHandler);
                        that._dataSource.off("progressChanged", that._progressChangedHandler);
                        that._dataSource.off("fieldsPrepared", that._fieldsPreparedHandler);
                        that._dataSource.off("customizeStoreLoadOptions", that._customizeStoreLoadOptionsHandler);
                    } else {
                        that._dataSource.dispose()
                    }
                    that._columnsScrollController && that._columnsScrollController.dispose();
                    that._rowsScrollController && that._rowsScrollController.dispose();
                    that._stateStoringController.dispose();
                    that.expandValueChanging.empty();
                    that.changed.empty();
                    that.loadingChanged.empty();
                    that.progressChanged.empty();
                    that.scrollChanged.empty();
                    that.dataSourceChanged.empty()
                }
            };
            proxyMethod(members, "applyPartialDataSource");
            proxyMethod(members, "collapseHeaderItem");
            proxyMethod(members, "expandHeaderItem");
            proxyMethod(members, "getData");
            proxyMethod(members, "isEmpty");
            return members
        }());
        exports.DataController = DataController
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/pivot_grid/local_store.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.LocalStore = void 0;
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _utils = _interopRequireDefault(__webpack_require__( /*! ../../data/utils */ 41));
        var _query = _interopRequireDefault(__webpack_require__( /*! ../../data/query */ 48));
        var _date_serialization = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date_serialization */ 57));
        var _data_source = __webpack_require__( /*! ../../data/data_source/data_source */ 68);
        var _custom_store = _interopRequireDefault(__webpack_require__( /*! ../../data/custom_store */ 130));
        var _data = __webpack_require__( /*! ../../core/utils/data */ 20);
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _uiPivot_grid = __webpack_require__( /*! ./ui.pivot_grid.utils */ 84);
        var _array_store = _interopRequireDefault(__webpack_require__( /*! ../../data/array_store */ 77));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var PATH_DELIMETER = "/./";
        var LocalStore = _class.default.inherit(function() {
            var DATE_INTERVAL_SELECTORS = {
                year: function(date) {
                    return date && date.getFullYear()
                },
                quarter: function(date) {
                    return date && Math.floor(date.getMonth() / 3) + 1
                },
                month: function(date) {
                    return date && date.getMonth() + 1
                },
                day: function(date) {
                    return date && date.getDate()
                },
                dayOfWeek: function(date) {
                    return date && date.getDay()
                }
            };

            function getDataSelector(dataField) {
                return dataField.indexOf(".") !== -1 ? (0, _data.compileGetter)(dataField) : function(data) {
                    return data[dataField]
                }
            }

            function getDateValue(dataSelector) {
                return function(data) {
                    var value = dataSelector(data);
                    if (value && !(value instanceof Date)) {
                        value = _date_serialization.default.deserializeDate(value)
                    }
                    return value
                }
            }

            function prepareFields(fields) {
                (0, _iterator.each)(fields || [], function(_, field) {
                    var fieldSelector;
                    var intervalSelector;
                    var dataField = field.dataField;
                    var groupInterval;
                    var levels = field.levels;
                    var dataSelector;
                    if (!field.selector) {
                        if (!dataField) {
                            dataSelector = function(data) {
                                return data
                            }
                        } else {
                            dataSelector = getDataSelector(dataField)
                        }
                        if (levels) {
                            prepareFields(levels)
                        }
                        if ("date" === field.dataType) {
                            intervalSelector = DATE_INTERVAL_SELECTORS[field.groupInterval];
                            var valueSelector = getDateValue(dataSelector);
                            fieldSelector = function(data) {
                                var value = valueSelector(data);
                                return intervalSelector ? intervalSelector(value) : value
                            }
                        } else {
                            if ("number" === field.dataType) {
                                groupInterval = (0, _type.isNumeric)(field.groupInterval) && field.groupInterval > 0 && field.groupInterval;
                                fieldSelector = function(data) {
                                    var value = dataSelector(data);
                                    if ((0, _type.isString)(value)) {
                                        value = Number(value)
                                    }
                                    return groupInterval ? Math.floor(value / groupInterval) * groupInterval : value
                                }
                            } else {
                                fieldSelector = dataSelector
                            }
                        }(0, _uiPivot_grid.setDefaultFieldValueFormatting)(field);
                        (0, _uiPivot_grid.setFieldProperty)(field, "selector", fieldSelector)
                    }
                })
            }
            var addHierarchyItem = function(value, hierarchyItems, pathHash, childrenHash) {
                var hierarchyItem = childrenHash[pathHash];
                if (!hierarchyItem) {
                    hierarchyItem = {
                        value: value,
                        index: childrenHash.length++
                    };
                    childrenHash[pathHash] = hierarchyItem;
                    hierarchyItems.push(hierarchyItem)
                }
                return hierarchyItem
            };

            function fillHierarchyItemIndexesCore(indexes, options, children, expandIndex, pathHash) {
                var dimension = options.dimensions[expandIndex];
                var expandedPathsHash = options.expandedPathsHash;
                var dimensionValue;
                var hierarchyItem;
                if (dimension) {
                    dimensionValue = dimension.selector(options.data);
                    pathHash = void 0 !== pathHash ? pathHash + PATH_DELIMETER + dimensionValue : dimensionValue + "";
                    hierarchyItem = addHierarchyItem(dimensionValue, children, pathHash, options.childrenHash);
                    indexes.push(hierarchyItem.index);
                    if (expandedPathsHash && expandedPathsHash[pathHash] || dimension.expanded) {
                        if (!hierarchyItem.children) {
                            hierarchyItem.children = []
                        }
                        fillHierarchyItemIndexesCore(indexes, options, hierarchyItem.children, expandIndex + 1, pathHash)
                    }
                }
            }

            function generateHierarchyItems(data, loadOptions, headers, headerName) {
                var result = [0];
                var expandIndex = loadOptions.headerName === headerName ? loadOptions.path.length : 0;
                var expandedPaths = "rows" === headerName ? loadOptions.rowExpandedPaths : loadOptions.columnExpandedPaths;
                var options = {
                    data: data,
                    childrenHash: headers[headerName + "Hash"],
                    dimensions: loadOptions[headerName],
                    expandedPathsHash: loadOptions.headerName !== headerName && expandedPaths && expandedPaths.hash
                };
                fillHierarchyItemIndexesCore(result, options, headers[headerName], expandIndex);
                return result
            }

            function generateAggregationCells(data, cells, headers, options) {
                var cellSet = [];
                var x;
                var y;
                var rowIndex;
                var columnIndex;
                var rowIndexes = generateHierarchyItems(data, options, headers, "rows");
                var columnIndexes = generateHierarchyItems(data, options, headers, "columns");
                for (y = 0; y < rowIndexes.length; y++) {
                    rowIndex = rowIndexes[y];
                    cells[rowIndex] = cells[rowIndex] || [];
                    for (x = 0; x < columnIndexes.length; x++) {
                        columnIndex = columnIndexes[x];
                        cellSet.push(cells[rowIndex][columnIndex] = cells[rowIndex][columnIndex] || [])
                    }
                }
                return cellSet
            }

            function fillHashExpandedPath(expandedPaths) {
                if (expandedPaths) {
                    var hash = expandedPaths.hash = {};
                    expandedPaths.forEach(function(path) {
                        var pathValue = path.map(function(value) {
                            return value + ""
                        }).join(PATH_DELIMETER);
                        hash[pathValue] = true
                    })
                }
            }

            function prepareLoadOption(options) {
                options.rows = options.rows || [];
                options.columns = options.columns || [];
                options.filters = options.filters || [];
                fillHashExpandedPath(options.columnExpandedPaths);
                fillHashExpandedPath(options.rowExpandedPaths);
                prepareFields(options.columns);
                prepareFields(options.rows);
                prepareFields(options.values);
                prepareFields(options.filters)
            }

            function getAggregator(field) {
                if ("custom" === field.summaryType) {
                    field.calculateCustomSummary = field.calculateCustomSummary || _common.noop;
                    return {
                        seed: function() {
                            var options = {
                                summaryProcess: "start",
                                totalValue: void 0
                            };
                            field.calculateCustomSummary(options);
                            return options
                        },
                        step: function(options, value) {
                            options.summaryProcess = "calculate";
                            options.value = value;
                            field.calculateCustomSummary(options);
                            return options
                        },
                        finalize: function(options) {
                            options.summaryProcess = "finalize";
                            delete options.value;
                            field.calculateCustomSummary(options);
                            return options.totalValue
                        }
                    }
                }
                return _utils.default.aggregators[field.summaryType] || _utils.default.aggregators.count
            }

            function aggregationStep(measures, aggregationCells, data) {
                for (var aggregatorIndex = 0; aggregatorIndex < measures.length; aggregatorIndex++) {
                    var cellField = measures[aggregatorIndex];
                    var cellValue = cellField.selector(data);
                    var aggregator = getAggregator(cellField);
                    var isAggregatorSeedFunction = "function" === typeof aggregator.seed;
                    for (var cellSetIndex = 0; cellSetIndex < aggregationCells.length; cellSetIndex++) {
                        var cell = aggregationCells[cellSetIndex];
                        if (cell.length <= aggregatorIndex) {
                            cell[aggregatorIndex] = isAggregatorSeedFunction ? aggregator.seed() : aggregator.seed
                        }
                        if (void 0 === cell[aggregatorIndex]) {
                            cell[aggregatorIndex] = cellValue
                        } else {
                            if ((0, _type.isDefined)(cellValue)) {
                                cell[aggregatorIndex] = aggregator.step(cell[aggregatorIndex], cellValue)
                            }
                        }
                    }
                }
            }

            function aggregationFinalize(measures, cells) {
                (0, _iterator.each)(measures, function(aggregatorIndex, cellField) {
                    var aggregator = getAggregator(cellField);
                    if (aggregator.finalize) {
                        (0, _iterator.each)(cells, function(_, row) {
                            (0, _iterator.each)(row, function(_, cell) {
                                if (cell && void 0 !== cell[aggregatorIndex]) {
                                    cell[aggregatorIndex] = aggregator.finalize(cell[aggregatorIndex])
                                }
                            })
                        })
                    }
                })
            }

            function areValuesEqual(filterValue, fieldValue) {
                var valueOfFilter = filterValue && filterValue.valueOf();
                var valueOfField = fieldValue && fieldValue.valueOf();
                if (Array.isArray(filterValue)) {
                    fieldValue = fieldValue || [];
                    for (var i = 0; i < filterValue.length; i++) {
                        valueOfFilter = filterValue[i] && filterValue[i].valueOf();
                        valueOfField = fieldValue[i] && fieldValue[i].valueOf();
                        if (valueOfFilter !== valueOfField) {
                            return false
                        }
                    }
                    return true
                } else {
                    return valueOfFilter === valueOfField
                }
            }

            function getGroupValue(levels, data) {
                var value = [];
                (0, _iterator.each)(levels, function(_, field) {
                    value.push(field.selector(data))
                });
                return value
            }

            function createDimensionFilters(dimension) {
                var filters = [];
                (0, _iterator.each)(dimension, function(_, field) {
                    var filterValues = field.filterValues || [];
                    var groupName = field.groupName;
                    if (groupName && (0, _type.isNumeric)(field.groupIndex)) {
                        return
                    }
                    var filter = function(dataItem) {
                        var value = field.levels ? getGroupValue(field.levels, dataItem) : field.selector(dataItem);
                        var result = false;
                        for (var i = 0; i < filterValues.length; i++) {
                            if (areValuesEqual(filterValues[i], value)) {
                                result = true;
                                break
                            }
                        }
                        return "exclude" === field.filterType ? !result : result
                    };
                    filterValues.length && filters.push(filter)
                });
                return filters
            }

            function createFilter(options) {
                var filters = createDimensionFilters(options.rows).concat(createDimensionFilters(options.columns)).concat(createDimensionFilters(options.filters));
                var expandedDimensions = options[options.headerName];
                var path = options.path;
                if (expandedDimensions) {
                    filters.push(function(dataItem) {
                        var expandValue;
                        for (var i = 0; i < path.length; i++) {
                            expandValue = expandedDimensions[i].selector(dataItem);
                            if ((0, _data.toComparable)(expandValue, true) !== (0, _data.toComparable)(path[i], true)) {
                                return false
                            }
                        }
                        return true
                    })
                }
                return function(dataItem) {
                    for (var i = 0; i < filters.length; i++) {
                        if (!filters[i](dataItem)) {
                            return false
                        }
                    }
                    return true
                }
            }

            function loadCore(items, options, notifyProgress) {
                var headers = {
                    columns: [],
                    rows: [],
                    columnsHash: {
                        length: 1
                    },
                    rowsHash: {
                        length: 1
                    }
                };
                var values = [];
                var aggregationCells;
                var data;
                var d = new _deferred.Deferred;
                var i = 0;
                var filter = createFilter(options);

                function processData() {
                    var t = new Date;
                    var startIndex = i;
                    for (; i < items.length; i++) {
                        if (i > startIndex && i % 1e4 === 0) {
                            if (new Date - t >= 300) {
                                notifyProgress(i / items.length);
                                setTimeout(processData, 0);
                                return
                            }
                        }
                        data = items[i];
                        if (filter(data)) {
                            aggregationCells = generateAggregationCells(data, values, headers, options);
                            aggregationStep(options.values, aggregationCells, data)
                        }
                    }
                    aggregationFinalize(options.values, values);
                    notifyProgress(1);
                    d.resolve({
                        rows: headers.rows,
                        columns: headers.columns,
                        values: values,
                        grandTotalRowIndex: 0,
                        grandTotalColumnIndex: 0
                    })
                }
                processData();
                return d
            }

            function filterDataSource(dataSource, fieldSelectors) {
                var filter = dataSource.filter();
                if (dataSource.store() instanceof _custom_store.default && filter) {
                    filter = processFilter(filter, fieldSelectors);
                    return (0, _query.default)(dataSource.items()).filter(filter).toArray()
                }
                return dataSource.items()
            }

            function loadDataSource(dataSource, fieldSelectors, reload) {
                var d = new _deferred.Deferred;
                var customizeStoreLoadOptionsHandler = function(options) {
                    if (dataSource.store() instanceof _array_store.default) {
                        options.storeLoadOptions.filter = processFilter(options.storeLoadOptions.filter, fieldSelectors)
                    }
                };
                dataSource.on("customizeStoreLoadOptions", customizeStoreLoadOptionsHandler);
                if (!dataSource.isLoaded() || reload) {
                    var loadDeferred = reload ? dataSource.load() : dataSource.reload();
                    (0, _deferred.when)(loadDeferred).done(function() {
                        loadDataSource(dataSource, fieldSelectors).done(function() {
                            d.resolve(filterDataSource(dataSource, fieldSelectors))
                        }).fail(d.reject)
                    }).fail(d.reject)
                } else {
                    d.resolve(filterDataSource(dataSource, fieldSelectors))
                }
                return d.always(function() {
                    dataSource.off("customizeStoreLoadOptions", customizeStoreLoadOptionsHandler)
                })
            }

            function fillSelectorsByFields(selectors, fields) {
                fields.forEach(function(field) {
                    if (field.dataField && "date" === field.dataType) {
                        var valueSelector = getDateValue(getDataSelector(field.dataField));
                        selectors[field.dataField] = function(data) {
                            return valueSelector(data)
                        }
                    }
                })
            }

            function getFieldSelectors(options) {
                var selectors = {};
                if (Array.isArray(options)) {
                    fillSelectorsByFields(selectors, options)
                } else {
                    if (options) {
                        ["rows", "columns", "filters"].forEach(function(area) {
                            options[area] && fillSelectorsByFields(selectors, options[area])
                        })
                    }
                }
                return selectors
            }

            function processFilter(filter, fieldSelectors) {
                if (!Array.isArray(filter)) {
                    return filter
                }
                filter = filter.slice(0);
                if ((0, _type.isString)(filter[0]) && (filter[1] instanceof Date || filter[2] instanceof Date)) {
                    filter[0] = fieldSelectors[filter[0]]
                }
                for (var i = 0; i < filter.length; i++) {
                    filter[i] = processFilter(filter[i], fieldSelectors)
                }
                return filter
            }
            return {
                ctor: function(options) {
                    this._progressChanged = options.onProgressChanged || _common.noop;
                    this._dataSource = new _data_source.DataSource(options);
                    this._dataSource.paginate(false)
                },
                getFields: function(fields) {
                    var that = this;
                    var dataSource = that._dataSource;
                    var d = new _deferred.Deferred;
                    loadDataSource(dataSource, getFieldSelectors(fields)).done(function(data) {
                        d.resolve((0, _uiPivot_grid.discoverObjectFields)(data, fields))
                    }).fail(d.reject);
                    return d
                },
                key: function() {
                    return this._dataSource.key()
                },
                load: function(options) {
                    var that = this;
                    var dataSource = that._dataSource;
                    var d = new _deferred.Deferred;
                    prepareLoadOption(options);
                    loadDataSource(dataSource, getFieldSelectors(options), options.reload).done(function(data) {
                        (0, _deferred.when)(loadCore(data, options, that._progressChanged)).done(d.resolve)
                    }).fail(d.reject);
                    return d
                },
                filter: function() {
                    var dataSource = this._dataSource;
                    return dataSource.filter.apply(dataSource, arguments)
                },
                supportPaging: function() {
                    return false
                },
                getDrillDownItems: function(loadOptions, params) {
                    loadOptions = loadOptions || {};
                    params = params || {};
                    prepareLoadOption(loadOptions);
                    var drillDownItems = [];
                    var items = this._dataSource.items();
                    var item;
                    var maxRowCount = params.maxRowCount;
                    var customColumns = params.customColumns;
                    var filter = createFilter(loadOptions);
                    var pathFilter = createFilter({
                        rows: (0, _uiPivot_grid.getFiltersByPath)(loadOptions.rows, params.rowPath),
                        columns: (0, _uiPivot_grid.getFiltersByPath)(loadOptions.columns, params.columnPath),
                        filters: []
                    });
                    for (var i = 0; i < items.length; i++) {
                        if (pathFilter(items[i]) && filter(items[i])) {
                            if (customColumns) {
                                item = {};
                                for (var j = 0; j < customColumns.length; j++) {
                                    item[customColumns[j]] = items[i][customColumns[j]]
                                }
                            } else {
                                item = items[i]
                            }
                            drillDownItems.push(item)
                        }
                        if (maxRowCount > 0 && drillDownItems.length === maxRowCount) {
                            break
                        }
                    }
                    return drillDownItems
                }
            }
        }()).include(_uiPivot_grid.storeDrillDownMixin);
        exports.LocalStore = LocalStore
    },
    /*!****************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/pivot_grid/remote_store.js ***!
      \****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _data_source = __webpack_require__( /*! ../../data/data_source/data_source */ 68);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _uiPivot_grid = __webpack_require__( /*! ./ui.pivot_grid.utils */ 84);
        var _remote_store = __webpack_require__( /*! ./remote_store.utils */ 774);
        var _date_serialization = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date_serialization */ 57));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }

        function createGroupingOptions(dimensionOptions, useSortOrder) {
            var groupingOptions = [];
            (0, _iterator.each)(dimensionOptions, function(index, dimensionOption) {
                groupingOptions.push({
                    selector: dimensionOption.dataField,
                    groupInterval: dimensionOption.groupInterval,
                    desc: useSortOrder && "desc" === dimensionOption.sortOrder,
                    isExpanded: index < dimensionOptions.length - 1
                })
            });
            return groupingOptions
        }

        function getFieldFilterSelector(field) {
            var selector = field.dataField;
            var groupInterval = field.groupInterval;
            if ("date" === field.dataType && "string" === typeof groupInterval) {
                if ("quarter" === groupInterval.toLowerCase()) {
                    groupInterval = "Month"
                }
                selector = selector + "." + (0, _uiPivot_grid.capitalizeFirstLetter)(groupInterval)
            }
            return selector
        }

        function getIntervalFilterExpression(selector, numericInterval, numericValue, isExcludedFilterType) {
            var startFilterValue = [selector, isExcludedFilterType ? "<" : ">=", numericValue];
            var endFilterValue = [selector, isExcludedFilterType ? ">=" : "<", numericValue + numericInterval];
            return [startFilterValue, isExcludedFilterType ? "or" : "and", endFilterValue]
        }

        function getFilterExpressionForFilterValue(field, filterValue) {
            var selector = getFieldFilterSelector(field);
            var isExcludedFilterType = "exclude" === field.filterType;
            var expression = [selector, isExcludedFilterType ? "<>" : "=", filterValue];
            if ((0, _type.isDefined)(field.groupInterval)) {
                if ("string" === typeof field.groupInterval && "quarter" === field.groupInterval.toLowerCase()) {
                    expression = getIntervalFilterExpression(selector, 3, 3 * (filterValue - 1) + 1, isExcludedFilterType)
                } else {
                    if ("number" === typeof field.groupInterval && "date" !== field.dataType) {
                        expression = getIntervalFilterExpression(selector, field.groupInterval, filterValue, isExcludedFilterType)
                    }
                }
            }
            return expression
        }

        function createFieldFilterExpressions(field, operation) {
            var fieldFilterExpressions = [];
            if (field.searchValue) {
                return [field.dataField, "contains", field.searchValue]
            }
            if ("exclude" === field.filterType) {
                operation = operation || "and"
            } else {
                operation = operation || "or"
            }(0, _iterator.each)(field.filterValues, function(index, filterValue) {
                var currentExpression = [];
                if (Array.isArray(filterValue)) {
                    var parseLevelsRecursive = field.levels && field.levels.length;
                    if (parseLevelsRecursive) {
                        currentExpression = createFieldFilterExpressions({
                            filterValues: filterValue,
                            filterType: field.filterType,
                            levels: field.levels
                        }, "and")
                    }
                } else {
                    var currentField = field.levels ? field.levels[index] : field;
                    currentExpression = getFilterExpressionForFilterValue(currentField, filterValue)
                }
                if (!currentExpression.length) {
                    return
                }
                if (fieldFilterExpressions.length) {
                    fieldFilterExpressions.push(operation)
                }
                fieldFilterExpressions.push(currentExpression)
            });
            return fieldFilterExpressions
        }

        function createFilterExpressions(fields) {
            var filterExpressions = [];
            (0, _iterator.each)(fields, function(_, field) {
                var fieldExpressions = createFieldFilterExpressions(field);
                if (!fieldExpressions.length) {
                    return []
                }
                if (filterExpressions.length) {
                    filterExpressions.push("and")
                }
                filterExpressions.push(fieldExpressions)
            });
            if (1 === filterExpressions.length) {
                filterExpressions = filterExpressions[0]
            }
            return filterExpressions
        }

        function mergeFilters(filter1, filter2) {
            var mergedFilter;
            var notEmpty = function(filter) {
                return filter && filter.length
            };
            if (notEmpty(filter1) && notEmpty(filter2)) {
                mergedFilter = [filter1, "and", filter2]
            } else {
                mergedFilter = notEmpty(filter1) ? filter1 : filter2
            }
            return mergedFilter
        }

        function createLoadOptions(options, externalFilterExpr, hasRows) {
            var filterExpressions = createFilterExpressions(options.filters);
            var groupingOptions = createGroupingOptions(options.rows, options.rowTake).concat(createGroupingOptions(options.columns, options.columnTake));
            var loadOptions = {
                groupSummary: [],
                totalSummary: [],
                group: groupingOptions.length ? groupingOptions : void 0,
                take: groupingOptions.length ? void 0 : 1
            };
            if (options.rows.length && options.rowTake) {
                loadOptions.skip = options.rowSkip;
                loadOptions.take = options.rowTake;
                loadOptions.requireGroupCount = true
            } else {
                if (options.columns.length && options.columnTake && !hasRows) {
                    loadOptions.skip = options.columnSkip;
                    loadOptions.take = options.columnTake;
                    loadOptions.requireGroupCount = true
                }
            }
            if (externalFilterExpr) {
                filterExpressions = mergeFilters(filterExpressions, externalFilterExpr)
            }
            if (filterExpressions.length) {
                loadOptions.filter = filterExpressions
            }(0, _iterator.each)(options.values, function(_, value) {
                var summaryOption = {
                    selector: value.dataField,
                    summaryType: value.summaryType || "count"
                };
                loadOptions.groupSummary.push(summaryOption);
                options.includeTotalSummary && loadOptions.totalSummary.push(summaryOption)
            });
            return loadOptions
        }

        function setValue(valuesArray, value, rowIndex, columnIndex, dataIndex) {
            valuesArray[rowIndex] = valuesArray[rowIndex] || [];
            valuesArray[rowIndex][columnIndex] = valuesArray[rowIndex][columnIndex] || [];
            if (!(0, _type.isDefined)(valuesArray[rowIndex][columnIndex][dataIndex])) {
                valuesArray[rowIndex][columnIndex][dataIndex] = value
            }
        }

        function parseValue(value, field) {
            if (field && "number" === field.dataType && (0, _type.isString)(value)) {
                return Number(value)
            }
            if (field && "date" === field.dataType && !field.groupInterval && !(value instanceof Date)) {
                return _date_serialization.default.deserializeDate(value)
            }
            return value
        }

        function parseResult(data, total, descriptions, result) {
            var rowPath = [];
            var columnPath = [];
            var rowHash = result.rowHash;
            var columnHash = result.columnHash;
            if (total && total.summary) {
                (0, _iterator.each)(total.summary, function(index, summary) {
                    setValue(result.values, summary, result.grandTotalRowIndex, result.grandTotalColumnIndex, index)
                })
            }
            if (total && total.groupCount >= 0) {
                var skip = descriptions.rows.length ? descriptions.rowSkip : descriptions.columnSkip;
                data = _toConsumableArray(Array(skip)).concat(data);
                data.length = total.groupCount
            }

            function getItem(dataItem, dimensionName, path, level, field) {
                var dimensionHash = result[dimensionName + "Hash"];
                var parentItem;
                var parentItemChildren;
                var item;
                var pathValue = path.slice(0, level + 1).join("/");
                var parentPathValue;
                if (void 0 !== dimensionHash[pathValue]) {
                    item = dimensionHash[pathValue]
                } else {
                    item = {
                        value: parseValue(dataItem.key, field),
                        index: result[dimensionName + "Index"]++
                    };
                    parentPathValue = path.slice(0, level).join("/");
                    if (level > 0 && void 0 !== dimensionHash[parentPathValue]) {
                        parentItem = dimensionHash[parentPathValue];
                        parentItemChildren = parentItem.children = parentItem.children || []
                    } else {
                        parentItemChildren = result[dimensionName + "s"]
                    }
                    parentItemChildren.push(item);
                    dimensionHash[pathValue] = item
                }
                return item
            }(0, _remote_store.forEachGroup)(data, function(item, level) {
                var rowLevel = level >= descriptions.rows.length ? descriptions.rows.length : level;
                var columnLevel = level >= descriptions.rows.length ? level - descriptions.rows.length : 0;
                var columnItem;
                var rowItem;
                if (level >= descriptions.rows.length && columnLevel >= descriptions.columns.length) {
                    return
                }
                if (level < descriptions.rows.length) {
                    columnPath = []
                }
                if (level >= descriptions.rows.length) {
                    if (item) {
                        columnPath[columnLevel] = item.key + "";
                        columnItem = getItem(item, "column", columnPath, columnLevel, descriptions.columns[columnLevel]);
                        rowItem = rowHash[rowPath.slice(0, rowLevel + 1).join("/")]
                    } else {
                        result.columns.push({})
                    }
                } else {
                    if (item) {
                        rowPath[rowLevel] = item.key + "";
                        rowItem = getItem(item, "row", rowPath, rowLevel, descriptions.rows[rowLevel]);
                        columnItem = columnHash[columnPath.slice(0, columnLevel + 1).join("/")]
                    } else {
                        result.rows.push({})
                    }
                }
                var currentRowIndex = rowItem && rowItem.index || result.grandTotalRowIndex;
                var currentColumnIndex = columnItem && columnItem.index || result.grandTotalColumnIndex;
                (0, _iterator.each)(item && item.summary || [], function(i, summary) {
                    setValue(result.values, summary, currentRowIndex, currentColumnIndex, i)
                })
            });
            return result
        }

        function getFiltersForDimension(fields) {
            return (fields || []).filter(function(f) {
                return f.filterValues && f.filterValues.length || f.searchValue
            })
        }

        function getExpandedIndex(options, axis) {
            if (options.headerName) {
                if (axis === options.headerName) {
                    return options.path.length
                } else {
                    if (options.oppositePath) {
                        return options.oppositePath.length
                    }
                }
            }
            return 0
        }

        function getFiltersForExpandedDimension(options) {
            return (0, _uiPivot_grid.getFiltersByPath)(options[options.headerName], options.path).concat((0, _uiPivot_grid.getFiltersByPath)(options["rows" === options.headerName ? "columns" : "rows"], options.oppositePath || []))
        }

        function getExpandedPathSliceFilter(options, dimensionName, level, firstCollapsedFieldIndex) {
            var result = [];
            var startSliceIndex = level > firstCollapsedFieldIndex ? 0 : firstCollapsedFieldIndex;
            var fields = options.headerName !== dimensionName ? options[dimensionName].slice(startSliceIndex, level) : [];
            var paths = "rows" === dimensionName ? options.rowExpandedPaths : options.columnExpandedPaths;
            (0, _iterator.each)(fields, function(index, field) {
                var filterValues = [];
                (0, _iterator.each)(paths, function(_, path) {
                    path = path.slice(startSliceIndex, level);
                    if (index < path.length) {
                        var filterValue = path[index];
                        if (filterValues.indexOf(filterValue) === -1) {
                            filterValues.push(filterValue)
                        }
                    }
                });
                if (filterValues.length) {
                    result.push((0, _extend.extend)({}, field, {
                        filterType: "include",
                        filterValues: filterValues
                    }))
                }
            });
            return result
        }

        function getGrandTotalRequest(options, dimensionName, expandedIndex, expandedLevel, commonFilters, firstCollapsedFieldIndex) {
            var expandedPaths = ("columns" === dimensionName ? options.columnExpandedPaths : options.rowExpandedPaths) || [];
            var oppositeDimensionName = "columns" === dimensionName ? "rows" : "columns";
            var fields = options[dimensionName];
            var result = [];
            var newOptions;
            if (expandedPaths.length) {
                for (var i = expandedIndex; i < expandedLevel + 1; i++) {
                    newOptions = {
                        filters: commonFilters.concat(getExpandedPathSliceFilter(options, dimensionName, i, firstCollapsedFieldIndex))
                    };
                    newOptions[dimensionName] = fields.slice(expandedIndex, i + 1);
                    newOptions[oppositeDimensionName] = [];
                    result.push((0, _extend.extend)({}, options, newOptions))
                }
            } else {
                newOptions = {
                    filters: commonFilters
                };
                newOptions[dimensionName] = fields.slice(expandedIndex, expandedLevel + 1);
                newOptions[oppositeDimensionName] = [];
                result.push((0, _extend.extend)({}, options, newOptions))
            }
            result[0].includeTotalSummary = true;
            return result
        }

        function getFirstCollapsedIndex(fields) {
            var firstCollapsedIndex = 0;
            (0, _iterator.each)(fields, function(index, field) {
                if (!field.expanded) {
                    firstCollapsedIndex = index;
                    return false
                }
            });
            return firstCollapsedIndex
        }

        function getRequestsData(options) {
            var rowExpandedLevel = (0, _uiPivot_grid.getExpandedLevel)(options, "rows");
            var columnExpandedLevel = (0, _uiPivot_grid.getExpandedLevel)(options, "columns");
            var filters = options.filters || [];
            var columnExpandedIndex = getExpandedIndex(options, "columns");
            var firstCollapsedColumnIndex = getFirstCollapsedIndex(options.columns);
            var firstCollapsedRowIndex = getFirstCollapsedIndex(options.rows);
            var rowExpandedIndex = getExpandedIndex(options, "rows");
            var data = [];
            filters = filters.concat(getFiltersForDimension(options.rows)).concat(getFiltersForDimension(options.columns)).concat(getFiltersForExpandedDimension(options));
            var columnTotalsOptions = getGrandTotalRequest(options, "columns", columnExpandedIndex, columnExpandedLevel, filters, firstCollapsedColumnIndex);
            if (options.rows.length && options.columns.length) {
                if ("rows" !== options.headerName) {
                    data = data.concat(columnTotalsOptions)
                }
                for (var i = rowExpandedIndex; i < rowExpandedLevel + 1; i++) {
                    var rows = options.rows.slice(rowExpandedIndex, i + 1);
                    var rowFilterByExpandedPaths = getExpandedPathSliceFilter(options, "rows", i, firstCollapsedRowIndex);
                    for (var j = columnExpandedIndex; j < columnExpandedLevel + 1; j++) {
                        var preparedOptions = (0, _extend.extend)({}, options, {
                            columns: options.columns.slice(columnExpandedIndex, j + 1),
                            rows: rows,
                            filters: filters.concat(getExpandedPathSliceFilter(options, "columns", j, firstCollapsedColumnIndex)).concat(rowFilterByExpandedPaths)
                        });
                        data.push(preparedOptions)
                    }
                }
            } else {
                data = options.columns.length ? columnTotalsOptions : getGrandTotalRequest(options, "rows", rowExpandedIndex, rowExpandedLevel, filters, firstCollapsedRowIndex)
            }
            return data
        }

        function prepareFields(fields) {
            (0, _iterator.each)(fields || [], function(_, field) {
                var levels = field.levels;
                if (levels) {
                    prepareFields(levels)
                }(0, _uiPivot_grid.setDefaultFieldValueFormatting)(field)
            })
        }
        var _default = _class.default.inherit(function() {
            return {
                ctor: function(options) {
                    this._dataSource = new _data_source.DataSource(options);
                    this._store = this._dataSource.store()
                },
                getFields: function(fields) {
                    var d = new _deferred.Deferred;
                    this._store.load({
                        skip: 0,
                        take: 20
                    }).done(function(data) {
                        d.resolve((0, _uiPivot_grid.discoverObjectFields)(data, fields))
                    }).fail(d.reject);
                    return d
                },
                key: function() {
                    return this._store.key()
                },
                load: function(options) {
                    var that = this;
                    var d = new _deferred.Deferred;
                    var result = {
                        rows: [],
                        columns: [],
                        values: [],
                        grandTotalRowIndex: 0,
                        grandTotalColumnIndex: 0,
                        rowHash: {},
                        columnHash: {},
                        rowIndex: 1,
                        columnIndex: 1
                    };
                    var requestsData = getRequestsData(options);
                    var deferreds = [];
                    prepareFields(options.rows);
                    prepareFields(options.columns);
                    prepareFields(options.filters);
                    (0, _iterator.each)(requestsData, function(_, dataItem) {
                        deferreds.push(that._store.load(createLoadOptions(dataItem, that.filter(), options.rows.length)))
                    });
                    _deferred.when.apply(null, deferreds).done(function() {
                        var args = deferreds.length > 1 ? arguments : [arguments];
                        (0, _iterator.each)(args, function(index, argument) {
                            parseResult(argument[0], argument[1], requestsData[index], result)
                        });
                        d.resolve({
                            rows: result.rows,
                            columns: result.columns,
                            values: result.values,
                            grandTotalRowIndex: result.grandTotalRowIndex,
                            grandTotalColumnIndex: result.grandTotalColumnIndex
                        })
                    }).fail(d.reject);
                    return d
                },
                filter: function() {
                    return this._dataSource.filter.apply(this._dataSource, arguments)
                },
                supportPaging: function() {
                    return false
                },
                createDrillDownDataSource: function(loadOptions, params) {
                    loadOptions = loadOptions || {};
                    params = params || {};
                    var store = this._store;
                    var filters = (0, _uiPivot_grid.getFiltersByPath)(loadOptions.rows, params.rowPath).concat((0, _uiPivot_grid.getFiltersByPath)(loadOptions.columns, params.columnPath)).concat(getFiltersForDimension(loadOptions.rows)).concat(loadOptions.filters || []).concat(getFiltersForDimension(loadOptions.columns));
                    var filterExp = createFilterExpressions(filters);
                    return new _data_source.DataSource({
                        load: function(loadOptions) {
                            return store.load((0, _extend.extend)({}, loadOptions, {
                                filter: mergeFilters(filterExp, loadOptions.filter),
                                select: params.customColumns
                            }))
                        }
                    })
                }
            }
        }());
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/pivot_grid/remote_store.utils.js ***!
      \**********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.forEachGroup = void 0;
        var forEachGroup = function forEachGroup(data, callback, level) {
            data = data || [];
            level = level || 0;
            for (var i = 0; i < data.length; i++) {
                var group = data[i];
                callback(group, level);
                if (group && group.items && group.items.length) {
                    forEachGroup(group.items, callback, level + 1)
                }
            }
        };
        exports.forEachGroup = forEachGroup
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/pivot_grid/data_source.utils.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.sort = sort;
        var _uiPivot_grid = __webpack_require__( /*! ./ui.pivot_grid.utils */ 84);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);

        function sort(loadOptions, dataSource, getAscOrder) {
            sortDimension(dataSource, loadOptions, "rows", getAscOrder);
            sortDimension(dataSource, loadOptions, "columns", getAscOrder)
        }

        function sortDimension(dataSource, loadOptions, dimensionName, getAscOrder) {
            var fields = loadOptions[dimensionName] || [];
            var baseIndex = loadOptions.headerName === dimensionName ? loadOptions.path.length : 0;
            var sortingMethodByLevel = [];
            (0, _uiPivot_grid.foreachDataLevel)(dataSource[dimensionName], function(item, index) {
                var field = fields[index] || {};
                var sortingMethod = sortingMethodByLevel[index] = sortingMethodByLevel[index] || getSortingMethod(field, dataSource, loadOptions, dimensionName, getAscOrder);
                item.sort(sortingMethod)
            }, baseIndex)
        }

        function getSortingMethod(field, dataSource, loadOptions, dimensionName, getAscOrder) {
            var sortOrder = getAscOrder ? "asc" : field.sortOrder;
            var sortBy = getMemberForSortBy(field.sortBy, getAscOrder);
            var defaultCompare = field.sortingMethod ? function(a, b) {
                return field.sortingMethod(a, b)
            } : (0, _uiPivot_grid.getCompareFunction)(function(item) {
                return item[sortBy]
            });
            var summaryValueSelector = !getAscOrder && getFieldSummaryValueSelector(field, dataSource, loadOptions, dimensionName);
            var summaryCompare = summaryValueSelector && (0, _uiPivot_grid.getCompareFunction)(summaryValueSelector);
            var sortingMethod = function(a, b) {
                var result = summaryCompare && summaryCompare(a, b) || defaultCompare(a, b);
                return "desc" === sortOrder ? -result : result
            };
            return sortingMethod
        }

        function getFieldSummaryValueSelector(field, dataSource, loadOptions, dimensionName) {
            var values = dataSource.values;
            var sortBySummaryFieldIndex = (0, _uiPivot_grid.findField)(loadOptions.values, field.sortBySummaryField);
            var areRows = "rows" === dimensionName;
            var sortByDimension = areRows ? dataSource.columns : dataSource.rows;
            var grandTotalIndex = areRows ? dataSource.grandTotalRowIndex : dataSource.grandTotalColumnIndex;
            var sortBySummaryPath = field.sortBySummaryPath || [];
            var sliceIndex = sortBySummaryPath.length ? getSliceIndex(sortByDimension, sortBySummaryPath) : grandTotalIndex;
            if (values && values.length && sortBySummaryFieldIndex >= 0 && (0, _type.isDefined)(sliceIndex)) {
                return function(field) {
                    var rowIndex = areRows ? field.index : sliceIndex;
                    var columnIndex = areRows ? sliceIndex : field.index;
                    var value = ((values[rowIndex] || [
                        []
                    ])[columnIndex] || [])[sortBySummaryFieldIndex];
                    return (0, _type.isDefined)(value) ? value : null
                }
            }
        }

        function getMemberForSortBy(sortBy, getAscOrder) {
            var member = "text";
            if ("none" === sortBy) {
                member = "index"
            } else {
                if (getAscOrder || "displayText" !== sortBy) {
                    member = "value"
                }
            }
            return member
        }

        function getSliceIndex(items, path) {
            var index = null;
            var pathValue = (path || []).join(".");
            if (pathValue.length) {
                (0, _uiPivot_grid.foreachTree)(items, function(items) {
                    var item = items[0];
                    var itemPath = (0, _uiPivot_grid.createPath)(items).join(".");
                    var textPath = (0, _iterator.map)(items, function(item) {
                        return item.text
                    }).reverse().join(".");
                    if (pathValue === itemPath || item.key && textPath === pathValue) {
                        index = items[0].index;
                        return false
                    }
                })
            }
            return index
        }
    },
    /*!***************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/pivot_grid/ui.pivot_grid.summary_display_modes.js ***!
      \***************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.applyDisplaySummaryMode = applyDisplaySummaryMode;
        exports.applyRunningTotal = applyRunningTotal;
        exports.createMockSummaryCell = createMockSummaryCell;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _uiPivot_grid = __webpack_require__( /*! ./ui.pivot_grid.utils */ 84);
        var COLUMN = "column";
        var ROW = "row";
        var NULL = null;
        var calculatePercentValue = function(value, totalValue) {
            var result = value / totalValue;
            if (!(0, _type.isDefined)(value) || isNaN(result)) {
                result = NULL
            }
            return result
        };
        var _percentOfGrandTotal = function(e, dimension) {
            return calculatePercentValue(e.value(), e.grandTotal(dimension).value())
        };
        var percentOfParent = function(e, dimension) {
            var parent = e.parent(dimension);
            var parentValue = parent ? parent.value() : e.value();
            return calculatePercentValue(e.value(), parentValue)
        };
        var createAbsoluteVariationExp = function(allowCrossGroup) {
            return function(e) {
                var prevCell = e.prev(COLUMN, allowCrossGroup);
                var prevValue = prevCell && prevCell.value();
                if ((0, _type.isDefined)(prevValue) && (0, _type.isDefined)(e.value())) {
                    return e.value() - prevValue
                }
                return NULL
            }
        };
        var createPercentVariationExp = function(allowCrossGroup) {
            var absoluteExp = createAbsoluteVariationExp(allowCrossGroup);
            return function(e) {
                var absVar = absoluteExp(e);
                var prevCell = e.prev(COLUMN, allowCrossGroup);
                var prevValue = prevCell && prevCell.value();
                return absVar !== NULL && prevValue ? absVar / prevValue : NULL
            }
        };
        var summaryDictionary = {
            percentOfColumnTotal: function(e) {
                return percentOfParent(e, ROW)
            },
            percentOfRowTotal: function(e) {
                return percentOfParent(e, COLUMN)
            },
            percentOfColumnGrandTotal: function(e) {
                return _percentOfGrandTotal(e, ROW)
            },
            percentOfRowGrandTotal: function(e) {
                return _percentOfGrandTotal(e, COLUMN)
            },
            percentOfGrandTotal: function(e) {
                return _percentOfGrandTotal(e)
            }
        };
        var getPrevCellCrossGroup = function getPrevCellCrossGroup(cell, direction) {
            if (!cell || !cell.parent(direction)) {
                return
            }
            var prevCell = cell.prev(direction);
            if (!prevCell) {
                prevCell = getPrevCellCrossGroup(cell.parent(direction), direction)
            }
            return prevCell
        };
        var createRunningTotalExpr = function(field) {
            if (!field.runningTotal) {
                return
            }
            var direction = field.runningTotal === COLUMN ? ROW : COLUMN;
            return function(e) {
                var prevCell = field.allowCrossGroupCalculation ? getPrevCellCrossGroup(e, direction) : e.prev(direction, false);
                var value = e.value(true);
                var prevValue = prevCell && prevCell.value(true);
                if ((0, _type.isDefined)(prevValue) && (0, _type.isDefined)(value)) {
                    value = prevValue + value
                } else {
                    if ((0, _type.isDefined)(prevValue)) {
                        value = prevValue
                    }
                }
                return value
            }
        };

        function createCache() {
            return {
                fields: {},
                positions: {}
            }
        }

        function getFieldPos(descriptions, field, cache) {
            var fieldParams = {
                index: -1
            };
            if (!(0, _type.isObject)(field)) {
                if (cache.fields[field]) {
                    field = cache[field]
                } else {
                    var allFields = descriptions.columns.concat(descriptions.rows).concat(descriptions.values);
                    var fieldIndex = (0, _uiPivot_grid.findField)(allFields, field);
                    field = cache[field] = allFields[fieldIndex]
                }
            }
            if (field) {
                var area = field.area || "data";
                fieldParams = cache.positions[field.index] = cache.positions[field.index] || {
                    area: area,
                    index: (0, _array.inArray)(field, descriptions["data" === area ? "values" : area + "s"])
                }
            }
            return fieldParams
        }

        function getPathFieldName(dimension) {
            return dimension === ROW ? "_rowPath" : "_columnPath"
        }
        var SummaryCell = function(columnPath, rowPath, data, descriptions, fieldIndex, fieldsCache) {
            this._columnPath = columnPath;
            this._rowPath = rowPath;
            this._fieldIndex = fieldIndex;
            this._fieldsCache = fieldsCache || createCache();
            this._data = data;
            this._descriptions = descriptions;
            var cell = data.values && data.values[rowPath[0].index] && data.values[rowPath[0].index][columnPath[0].index];
            if (cell) {
                cell.originalCell = cell.originalCell || cell.slice();
                cell.postProcessedFlags = cell.postProcessedFlags || [];
                this._cell = cell
            }
        };
        SummaryCell.prototype = (0, _extend.extend)(SummaryCell.prototype, {
            _getPath: function(dimension) {
                return this[getPathFieldName(dimension)]
            },
            _getDimension: function(dimension) {
                dimension = dimension === ROW ? "rows" : "columns";
                return this._descriptions[dimension]
            },
            _createCell: function(config) {
                var that = this;
                return new SummaryCell(config._columnPath || that._columnPath, config._rowPath || that._rowPath, that._data, that._descriptions, that._fieldIndex)
            },
            parent: function(direction) {
                var path = this._getPath(direction).slice();
                var config = {};
                path.shift();
                if (path.length) {
                    config[getPathFieldName(direction)] = path;
                    return this._createCell(config)
                }
                return NULL
            },
            children: function(direction) {
                var path = this._getPath(direction).slice();
                var item = path[0];
                var result = [];
                var cellConfig = {};
                if (item.children) {
                    for (var i = 0; i < item.children.length; i++) {
                        cellConfig[getPathFieldName(direction)] = [item.children[i]].concat(path.slice());
                        result.push(this._createCell(cellConfig))
                    }
                }
                return result
            },
            grandTotal: function(direction) {
                var config = {};
                var rowPath = this._rowPath;
                var columnPath = this._columnPath;
                var dimensionPath = this._getPath(direction);
                var pathFieldName = getPathFieldName(direction);
                if (!direction) {
                    config._rowPath = [rowPath[rowPath.length - 1]];
                    config._columnPath = [columnPath[columnPath.length - 1]]
                } else {
                    config[pathFieldName] = [dimensionPath[dimensionPath.length - 1]]
                }
                return this._createCell(config)
            },
            next: function(direction, allowCrossGroup) {
                var currentPath = this._getPath(direction);
                var item = currentPath[0];
                var parent = this.parent(direction);
                var siblings;
                if (parent) {
                    var index = (0, _array.inArray)(item, currentPath[1].children);
                    siblings = parent.children(direction);
                    if (siblings[index + 1]) {
                        return siblings[index + 1]
                    }
                }
                if (allowCrossGroup && parent) {
                    do {
                        parent = parent.next(direction, allowCrossGroup);
                        siblings = parent ? parent.children(direction) : []
                    } while (parent && !siblings.length);
                    return siblings[0] || NULL
                }
                return NULL
            },
            prev: function(direction, allowCrossGroup) {
                var currentPath = this._getPath(direction);
                var item = currentPath[0];
                var parent = this.parent(direction);
                var siblings;
                if (parent) {
                    var index = (0, _array.inArray)(item, currentPath[1].children);
                    siblings = parent.children(direction);
                    if (siblings[index - 1]) {
                        return siblings[index - 1]
                    }
                }
                if (allowCrossGroup && parent) {
                    do {
                        parent = parent.prev(direction, allowCrossGroup);
                        siblings = parent ? parent.children(direction) : []
                    } while (parent && !siblings.length);
                    return siblings[siblings.length - 1] || NULL
                }
                return NULL
            },
            cell: function() {
                return this._cell
            },
            field: function field(area) {
                if ("data" === area) {
                    return this._descriptions.values[this._fieldIndex]
                }
                var path = this._getPath(area);
                var descriptions = this._getDimension(area);
                var field = descriptions[path.length - 2];
                return field || NULL
            },
            child: function(direction, fieldValue) {
                var children = this.children(direction);
                for (var i = 0; i < children.length; i++) {
                    var childLevelField = childLevelField || children[i].field(direction);
                    if (children[i].value(childLevelField) === fieldValue) {
                        return children[i]
                    }
                }
                return NULL
            },
            slice: function(field, value) {
                var that = this;
                var config = {};
                var fieldPos = getFieldPos(this._descriptions, field, this._fieldsCache);
                var area = fieldPos.area;
                var fieldIndex = fieldPos.index;
                var sliceCell = NULL;
                var newPath = [];
                if (area === ROW || area === COLUMN) {
                    var path = this._getPath(area).slice();
                    var level = fieldIndex !== -1 && path.length - 2 - fieldIndex;
                    if (path[level]) {
                        newPath[path.length - 1] = path[path.length - 1];
                        for (var i = level; i >= 0; i--) {
                            if (path[i + 1]) {
                                var childItems = path[i + 1].children || [];
                                var currentValue = i === level ? value : path[i].value;
                                path[i] = void 0;
                                for (var childIndex = 0; childIndex < childItems.length; childIndex++) {
                                    if (childItems[childIndex].value === currentValue) {
                                        path[i] = childItems[childIndex];
                                        break
                                    }
                                }
                            }
                            if (void 0 === path[i]) {
                                return sliceCell
                            }
                        }
                        config[getPathFieldName(area)] = path;
                        sliceCell = that._createCell(config)
                    }
                }
                return sliceCell
            },
            value: function(arg1, arg2) {
                var cell = this._cell;
                var fieldIndex = this._fieldIndex;
                var fistArgIsBoolean = true === arg1 || false === arg1;
                var field = !fistArgIsBoolean ? arg1 : NULL;
                var needCalculatedValue = fistArgIsBoolean && arg1 || arg2;
                if ((0, _type.isDefined)(field)) {
                    var fieldPos = getFieldPos(this._descriptions, field, this._fieldsCache);
                    fieldIndex = fieldPos.index;
                    if ("data" !== fieldPos.area) {
                        var path = this._getPath(fieldPos.area);
                        var level = fieldIndex !== -1 && path.length - 2 - fieldIndex;
                        return path[level] && path[level].value
                    }
                }
                if (cell && cell.originalCell) {
                    return needCalculatedValue ? cell[fieldIndex] : cell.originalCell[fieldIndex]
                }
                return NULL
            },
            isPostProcessed: function(field) {
                var fieldIndex = this._fieldIndex;
                if ((0, _type.isDefined)(field)) {
                    var fieldPos = getFieldPos(this._descriptions, field, this._fieldsCache);
                    fieldIndex = fieldPos.index;
                    if ("data" !== fieldPos.area) {
                        return false
                    }
                }
                return !!(this._cell && this._cell.postProcessedFlags[fieldIndex])
            }
        });

        function getExpression(field) {
            var summaryDisplayMode = field.summaryDisplayMode;
            var crossGroupCalculation = field.allowCrossGroupCalculation;
            var expression = NULL;
            if ((0, _type.isFunction)(field.calculateSummaryValue)) {
                expression = field.calculateSummaryValue
            } else {
                if (summaryDisplayMode) {
                    if ("absoluteVariation" === summaryDisplayMode) {
                        expression = createAbsoluteVariationExp(crossGroupCalculation)
                    } else {
                        if ("percentVariation" === summaryDisplayMode) {
                            expression = createPercentVariationExp(crossGroupCalculation)
                        } else {
                            expression = summaryDictionary[summaryDisplayMode]
                        }
                    }
                    if (expression && !field.format && summaryDisplayMode.indexOf("percent") !== -1) {
                        (0, _uiPivot_grid.setFieldProperty)(field, "format", "percent")
                    }
                }
            }
            return expression
        }

        function processDataCell(data, rowIndex, columnIndex, isRunningTotalCalculation) {
            var values = data.values[rowIndex][columnIndex] = data.values[rowIndex][columnIndex] || [];
            var originalCell = values.originalCell;
            if (!originalCell) {
                return
            }
            if (values.allowResetting || !isRunningTotalCalculation) {
                data.values[rowIndex][columnIndex] = originalCell.slice()
            }
            data.values[rowIndex][columnIndex].allowResetting = isRunningTotalCalculation
        }

        function applyDisplaySummaryMode(descriptions, data) {
            var expressions = [];
            var columnElements = [{
                index: data.grandTotalColumnIndex,
                children: data.columns
            }];
            var rowElements = [{
                index: data.grandTotalRowIndex,
                children: data.rows
            }];
            var valueFields = descriptions.values;
            var fieldsCache = createCache();
            data.values = data.values || [];
            (0, _uiPivot_grid.foreachTree)(columnElements, function(columnPath) {
                columnPath[0].isEmpty = []
            }, false);
            (0, _uiPivot_grid.foreachTree)(rowElements, function(rowPath) {
                var rowItem = rowPath[0];
                rowItem.isEmpty = [];
                data.values[rowItem.index] = data.values[rowItem.index] || [];
                (0, _uiPivot_grid.foreachTree)(columnElements, function(columnPath) {
                    var columnItem = columnPath[0];
                    var isEmptyCell;
                    processDataCell(data, rowItem.index, columnItem.index, false);
                    for (var i = 0; i < valueFields.length; i++) {
                        var field = valueFields[i];
                        var expression = expressions[i] = void 0 === expressions[i] ? getExpression(field) : expressions[i];
                        isEmptyCell = false;
                        if (expression) {
                            var expressionArg = new SummaryCell(columnPath, rowPath, data, descriptions, i, fieldsCache);
                            var cell = expressionArg.cell();
                            var value = cell[i] = expression(expressionArg);
                            cell.postProcessedFlags[i] = true;
                            isEmptyCell = null === value || void 0 === value
                        }
                        if (void 0 === columnItem.isEmpty[i]) {
                            columnItem.isEmpty[i] = true
                        }
                        if (void 0 === rowItem.isEmpty[i]) {
                            rowItem.isEmpty[i] = true
                        }
                        if (!isEmptyCell) {
                            rowItem.isEmpty[i] = columnItem.isEmpty[i] = false
                        }
                    }
                }, false)
            }, false);
            data.isEmptyGrandTotalRow = rowElements[0].isEmpty;
            data.isEmptyGrandTotalColumn = columnElements[0].isEmpty
        }

        function applyRunningTotal(descriptions, data) {
            var expressions = [];
            var columnElements = [{
                index: data.grandTotalColumnIndex,
                children: data.columns
            }];
            var rowElements = [{
                index: data.grandTotalRowIndex,
                children: data.rows
            }];
            var valueFields = descriptions.values;
            var fieldsCache = createCache();
            data.values = data.values || [];
            (0, _uiPivot_grid.foreachTree)(rowElements, function(rowPath) {
                var rowItem = rowPath[0];
                data.values[rowItem.index] = data.values[rowItem.index] || [];
                (0, _uiPivot_grid.foreachTree)(columnElements, function(columnPath) {
                    var columnItem = columnPath[0];
                    processDataCell(data, rowItem.index, columnItem.index, true);
                    for (var i = 0; i < valueFields.length; i++) {
                        var field = valueFields[i];
                        var expression = expressions[i] = void 0 === expressions[i] ? createRunningTotalExpr(field) : expressions[i];
                        if (expression) {
                            var expressionArg = new SummaryCell(columnPath, rowPath, data, descriptions, i, fieldsCache);
                            var cell = expressionArg.cell();
                            cell[i] = expression(expressionArg);
                            cell.postProcessedFlags[i] = true
                        }
                    }
                }, false)
            }, false)
        }

        function createMockSummaryCell(descriptions, fields, indices) {
            var summaryCell = new SummaryCell([], [], {}, descriptions, 0);
            summaryCell.value = function(fieldId) {
                if ((0, _type.isDefined)(fieldId)) {
                    var index = (0, _uiPivot_grid.findField)(fields, fieldId);
                    var field = fields[index];
                    if (!indices[index] && field && !(0, _type.isDefined)(field.area)) {
                        descriptions.values.push(field);
                        indices[index] = true
                    }
                }
            };
            summaryCell.grandTotal = function() {
                return this
            };
            summaryCell.children = function() {
                return []
            };
            return summaryCell
        }
    },
    /*!***************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/pivot_grid/ui.pivot_grid.data_area.js ***!
      \***************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.DataArea = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _uiPivot_grid = __webpack_require__( /*! ./ui.pivot_grid.area_item */ 293);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var PIVOTGRID_AREA_CLASS = "dx-pivotgrid-area";
        var PIVOTGRID_AREA_DATA_CLASS = "dx-pivotgrid-area-data";
        var PIVOTGRID_TOTAL_CLASS = "dx-total";
        var PIVOTGRID_GRAND_TOTAL_CLASS = "dx-grandtotal";
        var PIVOTGRID_ROW_TOTAL_CLASS = "dx-row-total";
        var DataArea = _uiPivot_grid.AreaItem.inherit({
            _getAreaName: function() {
                return "data"
            },
            _createGroupElement: function() {
                return (0, _renderer.default)("<div>").addClass(PIVOTGRID_AREA_CLASS).addClass(PIVOTGRID_AREA_DATA_CLASS)
            },
            _applyCustomStyles: function(options) {
                var cell = options.cell;
                var classArray = options.classArray;
                if ("T" === cell.rowType || "T" === cell.columnType) {
                    classArray.push(PIVOTGRID_TOTAL_CLASS)
                }
                if ("GT" === cell.rowType || "GT" === cell.columnType) {
                    classArray.push(PIVOTGRID_GRAND_TOTAL_CLASS)
                }
                if ("T" === cell.rowType || "GT" === cell.rowType) {
                    classArray.push(PIVOTGRID_ROW_TOTAL_CLASS)
                }
                if (options.rowIndex === options.rowsCount - 1) {
                    options.cssArray.push("border-bottom: 0px")
                }
                this.callBase(options)
            },
            _moveFakeTable: function(scrollPos) {
                this._moveFakeTableHorizontally(scrollPos.x);
                this._moveFakeTableTop(scrollPos.y);
                this.callBase()
            },
            processScroll: function(useNativeScrolling, horizontalScroll, verticalScroll) {
                var direction = "both";
                if (horizontalScroll && !verticalScroll) {
                    direction = "horizontal"
                } else {
                    if (!horizontalScroll && verticalScroll) {
                        direction = "vertical"
                    }
                }
                this._groupElement.css("borderTopWidth", 0).dxScrollable({
                    useNative: !!useNativeScrolling,
                    useSimulatedScrollbar: !useNativeScrolling,
                    direction: direction,
                    bounceEnabled: false,
                    updateManually: true
                })
            },
            reset: function() {
                this.callBase();
                if (this._virtualContent) {
                    this._virtualContent.parent().css("height", "auto")
                }
            },
            setVirtualContentParams: function(params) {
                this.callBase(params);
                this._virtualContent.parent().css("height", params.height);
                this._setTableCss({
                    top: params.top,
                    left: params.left
                })
            }
        });
        exports.DataArea = DataArea
    },
    /*!******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/pivot_grid/ui.pivot_grid.headers_area.js ***!
      \******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.VerticalHeadersArea = exports.HorizontalHeadersArea = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _uiPivot_grid = __webpack_require__( /*! ./ui.pivot_grid.area_item */ 293);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var PIVOTGRID_AREA_CLASS = "dx-pivotgrid-area";
        var PIVOTGRID_AREA_COLUMN_CLASS = "dx-pivotgrid-horizontal-headers";
        var PIVOTGRID_AREA_ROW_CLASS = "dx-pivotgrid-vertical-headers";
        var PIVOTGRID_TOTAL_CLASS = "dx-total";
        var PIVOTGRID_GRAND_TOTAL_CLASS = "dx-grandtotal";
        var PIVOTGRID_ROW_TOTAL_CLASS = "dx-row-total";
        var PIVOTGRID_EXPANDED_CLASS = "dx-pivotgrid-expanded";
        var PIVOTGRID_COLLAPSED_CLASS = "dx-pivotgrid-collapsed";
        var PIVOTGRID_LAST_CELL_CLASS = "dx-last-cell";
        var PIVOTGRID_VERTICAL_SCROLL_CLASS = "dx-vertical-scroll";
        var PIVOTGRID_EXPAND_BORDER = "dx-expand-border";

        function getCellPath(tableElement, cell) {
            if (cell) {
                var data = tableElement.data().data;
                var rowIndex = cell.parentNode.rowIndex;
                var cellIndex = cell.cellIndex;
                return data[rowIndex] && data[rowIndex][cellIndex] && data[rowIndex][cellIndex].path
            }
        }
        var HorizontalHeadersArea = _uiPivot_grid.AreaItem.inherit({
            _getAreaName: function() {
                return "column"
            },
            _getAreaClassName: function() {
                return PIVOTGRID_AREA_COLUMN_CLASS
            },
            _createGroupElement: function() {
                return (0, _renderer.default)("<div>").addClass(this._getAreaClassName()).addClass(PIVOTGRID_AREA_CLASS)
            },
            _applyCustomStyles: function(options) {
                var cssArray = options.cssArray;
                var cell = options.cell;
                var rowsCount = options.rowsCount;
                var classArray = options.classArray;
                if (options.cellIndex === options.cellsCount - 1) {
                    cssArray.push((options.rtlEnabled ? "border-left:" : "border-right:") + "0px")
                }
                if (cell.rowspan === rowsCount - options.rowIndex || options.rowIndex + 1 === rowsCount) {
                    cssArray.push("border-bottom-width:0px")
                }
                if ("T" === cell.type || "GT" === cell.type) {
                    classArray.push(PIVOTGRID_ROW_TOTAL_CLASS)
                }
                if ("T" === options.cell.type) {
                    classArray.push(PIVOTGRID_TOTAL_CLASS)
                }
                if ("GT" === options.cell.type) {
                    classArray.push(PIVOTGRID_GRAND_TOTAL_CLASS)
                }
                if ((0, _type.isDefined)(cell.expanded)) {
                    classArray.push(cell.expanded ? PIVOTGRID_EXPANDED_CLASS : PIVOTGRID_COLLAPSED_CLASS)
                }
                this.callBase(options)
            },
            _getMainElementMarkup: function() {
                return "<thead class='" + this._getAreaClassName() + "'>"
            },
            _getCloseMainElementMarkup: function() {
                return "</thead>"
            },
            setVirtualContentParams: function(params) {
                this.callBase(params);
                this._setTableCss({
                    left: params.left,
                    top: 0
                });
                this._virtualContentWidth = params.width
            },
            hasScroll: function() {
                var tableWidth = this._virtualContent ? this._virtualContentWidth : this._tableWidth;
                if (this._groupWidth && tableWidth) {
                    return tableWidth - this._groupWidth >= 1
                }
                return false
            },
            processScroll: function() {
                if (!this._getScrollable()) {
                    this._groupElement.dxScrollable({
                        useNative: false,
                        useSimulatedScrollbar: false,
                        showScrollbar: false,
                        bounceEnabled: false,
                        direction: "horizontal",
                        updateManually: true
                    })
                }
            },
            processScrollBarSpacing: function(scrollBarWidth) {
                var that = this;
                var groupAlignment = that.option("rtlEnabled") ? "right" : "left";
                if (that._groupWidth) {
                    that.groupWidth(that._groupWidth - scrollBarWidth)
                }
                if (that._scrollBarWidth) {
                    that._groupElement.next().remove()
                }
                that._groupElement.toggleClass(PIVOTGRID_VERTICAL_SCROLL_CLASS, scrollBarWidth > 0);
                that._groupElement.css("float", groupAlignment).width(that._groupHeight);
                that._scrollBarWidth = scrollBarWidth
            },
            ctor: function(component) {
                this.callBase(component);
                this._scrollBarWidth = 0
            },
            getScrollPath: function(offset) {
                var tableElement = this.tableElement();
                var cell;
                offset -= parseInt(tableElement[0].style.left, 10) || 0;
                (0, _iterator.each)(tableElement.find("td"), function(_, td) {
                    if (1 === td.colSpan && td.offsetLeft <= offset && td.offsetWidth + td.offsetLeft > offset) {
                        cell = td;
                        return false
                    }
                });
                return getCellPath(tableElement, cell)
            },
            _moveFakeTable: function(scrollPos) {
                this._moveFakeTableHorizontally(scrollPos);
                this.callBase()
            }
        });
        exports.HorizontalHeadersArea = HorizontalHeadersArea;
        var VerticalHeadersArea = HorizontalHeadersArea.inherit({
            _getAreaClassName: function() {
                return PIVOTGRID_AREA_ROW_CLASS
            },
            _applyCustomStyles: function(options) {
                this.callBase(options);
                if (options.cellIndex === options.cellsCount - 1) {
                    options.classArray.push(PIVOTGRID_LAST_CELL_CLASS)
                }
                if (options.rowIndex === options.rowsCount - 1) {
                    options.cssArray.push("border-bottom: 0px")
                }
                if (options.cell.isWhiteSpace) {
                    options.classArray.push("dx-white-space-column")
                }
            },
            _getAreaName: function() {
                return "row"
            },
            setVirtualContentParams: function(params) {
                this.callBase(params);
                this._setTableCss({
                    top: params.top,
                    left: 0
                });
                this._virtualContentHeight = params.height
            },
            hasScroll: function() {
                var tableHeight = this._virtualContent ? this._virtualContentHeight : this._tableHeight;
                if (this._groupHeight && tableHeight) {
                    return tableHeight - this._groupHeight >= 1
                }
                return false
            },
            processScroll: function() {
                if (!this._getScrollable()) {
                    this._groupElement.dxScrollable({
                        useNative: false,
                        useSimulatedScrollbar: false,
                        showScrollbar: false,
                        bounceEnabled: false,
                        direction: "vertical",
                        updateManually: true
                    })
                }
            },
            processScrollBarSpacing: function(scrollBarWidth) {
                var that = this;
                if (that._groupHeight) {
                    that.groupHeight(that._groupHeight - scrollBarWidth)
                }
                if (that._scrollBarWidth) {
                    that._groupElement.next().remove()
                }
                if (scrollBarWidth) {
                    that._groupElement.after((0, _renderer.default)("<div>").width("100%").height(scrollBarWidth - 1))
                }
                that._scrollBarWidth = scrollBarWidth
            },
            getScrollPath: function(offset) {
                var tableElement = this.tableElement();
                var cell;
                offset -= parseInt(tableElement[0].style.top, 10) || 0;
                (0, _iterator.each)(tableElement.find("tr"), function(_, tr) {
                    var td = tr.childNodes[tr.childNodes.length - 1];
                    if (td && 1 === td.rowSpan && td.offsetTop <= offset && td.offsetHeight + td.offsetTop > offset) {
                        cell = td;
                        return false
                    }
                });
                return getCellPath(tableElement, cell)
            },
            _moveFakeTable: function(scrollPos) {
                this._moveFakeTableTop(scrollPos);
                this.callBase()
            },
            _getRowClassNames: function(rowIndex, cell, rowClassNames) {
                if (0 !== rowIndex & cell.expanded && (0, _array.inArray)(PIVOTGRID_EXPAND_BORDER, rowClassNames) === -1) {
                    rowClassNames.push(PIVOTGRID_EXPAND_BORDER)
                }
            },
            _getMainElementMarkup: function() {
                return "<tbody class='" + this._getAreaClassName() + "'>"
            },
            _getCloseMainElementMarkup: function() {
                return "</tbody>"
            },
            updateColspans: function(columnCount) {
                var rows = this.tableElement()[0].rows;
                var columnOffset = 0;
                var columnOffsetResetIndexes = [];
                if (this.getColumnsCount() - columnCount > 0) {
                    return
                }
                for (var i = 0; i < rows.length; i++) {
                    for (var j = 0; j < rows[i].cells.length; j++) {
                        var cell = rows[i].cells[j];
                        var rowSpan = cell.rowSpan;
                        if (columnOffsetResetIndexes[i]) {
                            columnOffset -= columnOffsetResetIndexes[i];
                            columnOffsetResetIndexes[i] = 0
                        }
                        var diff = columnCount - (columnOffset + cell.colSpan);
                        if (j === rows[i].cells.length - 1 && diff > 0) {
                            cell.colSpan = cell.colSpan + diff
                        }
                        columnOffsetResetIndexes[i + rowSpan] = (columnOffsetResetIndexes[i + rowSpan] || 0) + cell.colSpan;
                        columnOffset += cell.colSpan
                    }
                }
            }
        });
        exports.VerticalHeadersArea = VerticalHeadersArea
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/pivot_grid/ui.pivot_grid.fields_area.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.FieldsArea = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _uiPivot_grid = __webpack_require__( /*! ./ui.pivot_grid.area_item */ 293);
        var _uiPivot_grid2 = __webpack_require__( /*! ./ui.pivot_grid.utils */ 84);
        var _popup = _interopRequireDefault(__webpack_require__( /*! ../popup */ 46));
        var _button = _interopRequireDefault(__webpack_require__( /*! ../button */ 37));
        __webpack_require__( /*! ./ui.pivot_grid.field_chooser_base */ 294);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DIV = "<div>";
        var AREA_DRAG_CLASS = "dx-pivotgrid-drag-action";

        function renderGroupConnector(field, nextField, prevField, $container) {
            if (prevField && prevField.groupName && prevField.groupName === field.groupName) {
                (0, _renderer.default)(DIV).addClass("dx-group-connector").addClass("dx-group-connector-prev").appendTo($container)
            }
            if (nextField && nextField.groupName && nextField.groupName === field.groupName) {
                (0, _renderer.default)(DIV).addClass("dx-group-connector").addClass("dx-group-connector-next").appendTo($container)
            }
        }
        var FieldsArea = _uiPivot_grid.AreaItem.inherit({
            ctor: function(component, area) {
                this.callBase(component);
                this._area = area
            },
            _getAreaName: function() {
                return "fields"
            },
            _createGroupElement: function() {
                return (0, _renderer.default)(DIV).addClass("dx-pivotgrid-fields-area").addClass("dx-area-fields").addClass(AREA_DRAG_CLASS).attr("group", this._area)
            },
            isVisible: function() {
                return !!this.option("fieldPanel.visible") && this.option("fieldPanel.show" + (0, _uiPivot_grid2.capitalizeFirstLetter)(this._area) + "Fields")
            },
            _renderButton: function(element) {
                var that = this;
                var container = (0, _renderer.default)("<td>").appendTo((0, _renderer.default)("<tr>").appendTo(element));
                var button = that.component._createComponent((0, _renderer.default)(DIV).appendTo(container), _button.default, {
                    text: "Fields",
                    icon: "menu",
                    width: "auto",
                    onClick: function() {
                        var popup = that.tableElement().find(".dx-fields-area-popup").dxPopup("instance");
                        if (!popup.option("visible")) {
                            popup.show()
                        }
                    }
                });
                button.$element().addClass("dx-pivotgrid-fields-area-hamburger")
            },
            _getPopupOptions: function(row, button) {
                return {
                    contentTemplate: function() {
                        return (0, _renderer.default)("<table>").addClass("dx-area-field-container").append((0, _renderer.default)("<thead>").addClass("dx-pivotgrid-fields-area-head").append(row))
                    },
                    height: "auto",
                    width: "auto",
                    position: {
                        at: "left",
                        my: "left",
                        of: button
                    },
                    dragEnabled: false,
                    animation: {
                        show: {
                            type: "pop",
                            duration: 200
                        }
                    },
                    shading: false,
                    showTitle: false,
                    closeOnOutsideClick: true,
                    container: button.parent()
                }
            },
            _renderPopup: function(tableElement, row) {
                var that = this;
                var button = tableElement.find(".dx-button");
                var popupOptions = that._getPopupOptions(row, button);
                var FieldChooserBase = that.component.$element().dxPivotGridFieldChooserBase("instance");
                if (that._rowPopup) {
                    that._rowPopup.$element().remove()
                }
                that._rowPopup = that.component._createComponent((0, _renderer.default)(DIV).appendTo(tableElement), _popup.default, popupOptions);
                that._rowPopup.$element().addClass("dx-fields-area-popup");
                that._rowPopup.content().addClass("dx-pivotgrid-fields-container");
                that._rowPopup.content().parent().attr("group", "row");
                FieldChooserBase.subscribeToEvents(that._rowPopup.content());
                FieldChooserBase.renderSortable(that._rowPopup.content())
            },
            _shouldCreateButton: function() {
                return false
            },
            _renderTableContent: function(tableElement, data) {
                var that = this;
                var groupElement = this.groupElement();
                var isVisible = this.isVisible();
                var fieldChooserBase = that.component.$element().dxPivotGridFieldChooserBase("instance");
                var head = (0, _renderer.default)("<thead>").addClass("dx-pivotgrid-fields-area-head").appendTo(tableElement);
                var area = that._area;
                var row = (0, _renderer.default)("<tr>");
                groupElement.toggleClass("dx-hidden", !isVisible);
                tableElement.addClass("dx-area-field-container");
                if (!isVisible) {
                    return
                }(0, _iterator.each)(data, function(index, field) {
                    if (field.area === area && false !== field.visible) {
                        var td = (0, _renderer.default)("<td>").append(fieldChooserBase.renderField(field, "row" === field.area));
                        var indicators = td.find(".dx-column-indicators");
                        if (indicators.length && that._shouldCreateButton()) {
                            indicators.insertAfter(indicators.next())
                        }
                        td.appendTo(row);
                        renderGroupConnector(field, data[index + 1], data[index - 1], td)
                    }
                });
                if (!row.children().length) {
                    (0, _renderer.default)("<td>").append((0, _renderer.default)(DIV).addClass("dx-empty-area-text").text(this.option("fieldPanel.texts." + area + "FieldArea"))).appendTo(row)
                }
                if (that._shouldCreateButton()) {
                    that._renderButton(head);
                    that._renderPopup(tableElement, row)
                } else {
                    head.append(row)
                }
            },
            reset: function() {
                this.callBase();
                this.groupElement().css("marginTop", 0)
            },
            _renderVirtualContent: _common.noop
        });
        exports.FieldsArea = FieldsArea
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/pivot_grid/ui.sortable.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _dom_component = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_component */ 67));
        var _drag = __webpack_require__( /*! ../../events/drag */ 76);
        var _swatch_container = _interopRequireDefault(__webpack_require__( /*! ../widget/swatch_container */ 170));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var getSwatchContainer = _swatch_container.default.getSwatchContainer;
        var SORTABLE_NAMESPACE = "dxSortable";
        var SORTABLE_CLASS = "dx-sortable-old";
        var SCROLL_STEP = 2;
        var START_SCROLL_OFFSET = 20;
        var SCROLL_TIMEOUT = 10;

        function elementHasPoint(element, x, y) {
            var $item = (0, _renderer.default)(element);
            var offset = $item.offset();
            if (x >= offset.left && x <= offset.left + $item.outerWidth(true)) {
                if (y >= offset.top && y <= offset.top + $item.outerHeight(true)) {
                    return true
                }
            }
        }

        function checkHorizontalPosition(position, itemOffset, rtl) {
            if ((0, _type.isDefined)(itemOffset.posHorizontal)) {
                return rtl ? position > itemOffset.posHorizontal : position < itemOffset.posHorizontal
            } else {
                return true
            }
        }

        function getIndex($items, $item) {
            var index = -1;
            var itemElement = $item.get(0);
            (0, _iterator.each)($items, function(elementIndex, element) {
                var $element = (0, _renderer.default)(element);
                if (!($element.attr("item-group") && $element.attr("item-group") === $items.eq(elementIndex - 1).attr("item-group"))) {
                    index++
                }
                if (element === itemElement) {
                    return false
                }
            });
            return index === $items.length ? -1 : index
        }

        function getTargetGroup(e, $groups) {
            var result;
            (0, _iterator.each)($groups, function() {
                if (elementHasPoint(this, e.pageX, e.pageY)) {
                    result = (0, _renderer.default)(this)
                }
            });
            return result
        }

        function getItemsOffset($elements, isVertical, $itemsContainer) {
            var result = [];
            var $item = [];
            for (var i = 0; i < $elements.length; i += $item.length) {
                $item = $elements.eq(i);
                if ($item.attr("item-group")) {
                    $item = $itemsContainer.find("[item-group='" + $item.attr("item-group") + "']")
                }
                if ($item.is(":visible")) {
                    var offset = {
                        item: $item,
                        index: result.length,
                        posHorizontal: isVertical ? void 0 : ($item.last().outerWidth(true) + $item.last().offset().left + $item.offset().left) / 2
                    };
                    if (isVertical) {
                        offset.posVertical = ($item.last().offset().top + $item.offset().top + $item.last().outerHeight(true)) / 2
                    } else {
                        offset.posVertical = $item.last().outerHeight(true) + $item.last().offset().top
                    }
                    result.push(offset)
                }
            }
            return result
        }

        function getScrollWrapper(scrollable) {
            var timeout = null;
            var scrollTop = scrollable.scrollTop();
            var $element = scrollable.$element();
            var top = $element.offset().top;
            var height = $element.height();
            var delta = 0;

            function onScroll(e) {
                scrollTop = e.scrollOffset.top
            }
            scrollable.on("scroll", onScroll);

            function move() {
                stop();
                scrollable.scrollTo(scrollTop += delta);
                timeout = setTimeout(move, SCROLL_TIMEOUT)
            }

            function stop() {
                clearTimeout(timeout)
            }

            function moveIfNeed(event) {
                if (event.pageY <= top + START_SCROLL_OFFSET) {
                    delta = -SCROLL_STEP
                } else {
                    if (event.pageY >= top + height - START_SCROLL_OFFSET) {
                        delta = SCROLL_STEP
                    } else {
                        delta = 0;
                        stop();
                        return
                    }
                }
                move()
            }
            return {
                moveIfNeed: moveIfNeed,
                element: function() {
                    return $element
                },
                dispose: function() {
                    stop();
                    scrollable.off("scroll", onScroll)
                }
            }
        }
        var Sortable = _dom_component.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    onChanged: null,
                    onDragging: null,
                    itemRender: null,
                    groupSelector: null,
                    itemSelector: ".dx-sort-item",
                    itemContainerSelector: ".dx-sortable-old",
                    sourceClass: "dx-drag-source",
                    dragClass: "dx-drag",
                    targetClass: "dx-drag-target",
                    direction: "vertical",
                    allowDragging: true,
                    groupFilter: null,
                    useIndicator: false
                })
            },
            _renderItem: function($sourceItem, target) {
                var itemRender = this.option("itemRender");
                var $item;
                if (itemRender) {
                    $item = itemRender($sourceItem, target)
                } else {
                    $item = $sourceItem.clone();
                    $item.css({
                        width: $sourceItem.width(),
                        height: $sourceItem.height()
                    })
                }
                return $item
            },
            _renderIndicator: function($item, isVertical, $targetGroup, isLast) {
                var height = $item.outerHeight(true);
                var width = $item.outerWidth(true);
                var top = $item.offset().top - $targetGroup.offset().top;
                var left = $item.offset().left - $targetGroup.offset().left;
                this._indicator.css({
                    position: "absolute",
                    top: isLast && isVertical ? top + height : top,
                    left: isLast && !isVertical ? left + width : left
                }).toggleClass("dx-position-indicator-horizontal", !isVertical).toggleClass("dx-position-indicator-vertical", !!isVertical).toggleClass("dx-position-indicator-last", !!isLast).height("").width("").appendTo($targetGroup);
                isVertical ? this._indicator.width(width) : this._indicator.height(height)
            },
            _renderDraggable: function($sourceItem) {
                this._$draggable && this._$draggable.remove();
                this._$draggable = this._renderItem($sourceItem, "drag").addClass(this.option("dragClass")).appendTo(getSwatchContainer($sourceItem)).css({
                    zIndex: 1e6,
                    position: "absolute"
                })
            },
            _detachEventHandlers: function() {
                var dragEventsString = [_drag.move, _drag.start, _drag.end, _drag.enter, _drag.leave, _drag.drop].join(" ");
                _events_engine.default.off(this._getEventListener(), (0, _index.addNamespace)(dragEventsString, SORTABLE_NAMESPACE))
            },
            _getItemOffset: function(isVertical, itemsOffset, e) {
                for (var i = 0; i < itemsOffset.length; i++) {
                    var shouldInsert = void 0;
                    var sameLine = e.pageY < itemsOffset[i].posVertical;
                    if (isVertical) {
                        shouldInsert = sameLine
                    } else {
                        if (sameLine) {
                            shouldInsert = checkHorizontalPosition(e.pageX, itemsOffset[i], this.option("rtlEnabled"));
                            if (!shouldInsert && itemsOffset[i + 1] && itemsOffset[i + 1].posVertical > itemsOffset[i].posVertical) {
                                shouldInsert = true
                            }
                        }
                    }
                    if (shouldInsert) {
                        return itemsOffset[i]
                    }
                }
            },
            _getEventListener: function() {
                var groupSelector = this.option("groupSelector");
                var element = this.$element();
                return groupSelector ? element.find(groupSelector) : element
            },
            _attachEventHandlers: function() {
                var that = this;
                var itemSelector = that.option("itemSelector");
                var itemContainerSelector = that.option("itemContainerSelector");
                var groupSelector = that.option("groupSelector");
                var sourceClass = that.option("sourceClass");
                var targetClass = that.option("targetClass");
                var onDragging = that.option("onDragging");
                var groupFilter = that.option("groupFilter");
                var $sourceItem;
                var sourceIndex;
                var $targetItem;
                var $targetGroup;
                var startPositions;
                var sourceGroup;
                var element = that.$element();
                var $groups;
                var scrollWrapper = null;
                var targetIndex = -1;
                var setStartPositions = function() {
                    startPositions = [];
                    (0, _iterator.each)($sourceItem, function(_, item) {
                        startPositions.push((0, _renderer.default)(item).offset())
                    })
                };
                var createGroups = function() {
                    if (!groupSelector) {
                        return element
                    } else {
                        return groupFilter ? (0, _renderer.default)(groupSelector).filter(groupFilter) : element.find(groupSelector)
                    }
                };
                var disposeScrollWrapper = function() {
                    scrollWrapper && scrollWrapper.dispose();
                    scrollWrapper = null
                };
                var invokeOnDraggingEvent = function() {
                    var draggingArgs = {
                        sourceGroup: sourceGroup,
                        sourceIndex: sourceIndex,
                        sourceElement: $sourceItem,
                        targetGroup: $targetGroup.attr("group"),
                        targetIndex: $targetGroup.find(itemSelector).index($targetItem)
                    };
                    onDragging && onDragging(draggingArgs);
                    if (draggingArgs.cancel) {
                        $targetGroup = void 0
                    }
                };
                that._detachEventHandlers();
                if (that.option("allowDragging")) {
                    var $eventListener = that._getEventListener();
                    _events_engine.default.on($eventListener, (0, _index.addNamespace)(_drag.start, SORTABLE_NAMESPACE), itemSelector, function(e) {
                        $sourceItem = (0, _renderer.default)(e.currentTarget);
                        var $sourceGroup = $sourceItem.closest(groupSelector);
                        sourceGroup = $sourceGroup.attr("group");
                        sourceIndex = getIndex((groupSelector ? $sourceGroup : element).find(itemSelector), $sourceItem);
                        if ($sourceItem.attr("item-group")) {
                            $sourceItem = $sourceGroup.find("[item-group='" + $sourceItem.attr("item-group") + "']")
                        }
                        that._renderDraggable($sourceItem);
                        $targetItem = that._renderItem($sourceItem, "target").addClass(targetClass);
                        $sourceItem.addClass(sourceClass);
                        setStartPositions();
                        $groups = createGroups();
                        that._indicator = (0, _renderer.default)("<div>").addClass("dx-position-indicator")
                    });
                    _events_engine.default.on($eventListener, (0, _index.addNamespace)(_drag.move, SORTABLE_NAMESPACE), function(e) {
                        var $item;
                        var $lastItem;
                        var $prevItem;
                        if (!$sourceItem) {
                            return
                        }
                        targetIndex = -1;
                        that._indicator.detach();
                        (0, _iterator.each)(that._$draggable, function(index, draggableElement) {
                            (0, _renderer.default)(draggableElement).css({
                                top: startPositions[index].top + e.offset.y,
                                left: startPositions[index].left + e.offset.x
                            })
                        });
                        $targetGroup && $targetGroup.removeClass(targetClass);
                        $targetGroup = getTargetGroup(e, $groups);
                        $targetGroup && invokeOnDraggingEvent();
                        if ($targetGroup && scrollWrapper && $targetGroup.get(0) !== scrollWrapper.element().get(0)) {
                            disposeScrollWrapper()
                        }
                        scrollWrapper && scrollWrapper.moveIfNeed(e);
                        if (!$targetGroup) {
                            $targetItem.detach();
                            return
                        }
                        if (!scrollWrapper && $targetGroup.attr("allow-scrolling")) {
                            scrollWrapper = getScrollWrapper($targetGroup.dxScrollable("instance"))
                        }
                        $targetGroup.addClass(targetClass);
                        var $itemContainer = $targetGroup.find(itemContainerSelector);
                        var $items = $itemContainer.find(itemSelector);
                        var targetSortable = $targetGroup.closest("." + SORTABLE_CLASS).data("dxSortableOld");
                        var useIndicator = targetSortable.option("useIndicator");
                        var isVertical = "vertical" === (targetSortable || that).option("direction");
                        var itemsOffset = getItemsOffset($items, isVertical, $itemContainer);
                        var itemOffset = that._getItemOffset(isVertical, itemsOffset, e);
                        if (itemOffset) {
                            $item = itemOffset.item;
                            $prevItem = itemsOffset[itemOffset.index - 1] && itemsOffset[itemOffset.index - 1].item;
                            if ($item.hasClass(sourceClass) || $prevItem && $prevItem.hasClass(sourceClass) && $prevItem.is(":visible")) {
                                $targetItem.detach();
                                return
                            }
                            targetIndex = itemOffset.index;
                            if (!useIndicator) {
                                $targetItem.insertBefore($item);
                                return
                            }
                            var isAnotherGroup = $targetGroup.attr("group") !== sourceGroup;
                            var isSameIndex = targetIndex === sourceIndex;
                            var isNextIndex = targetIndex === sourceIndex + 1;
                            if (isAnotherGroup) {
                                that._renderIndicator($item, isVertical, $targetGroup, that.option("rtlEnabled") && !isVertical);
                                return
                            }
                            if (!isSameIndex && !isNextIndex) {
                                that._renderIndicator($item, isVertical, $targetGroup, that.option("rtlEnabled") && !isVertical)
                            }
                        } else {
                            $lastItem = $items.last();
                            if ($lastItem.is(":visible") && $lastItem.hasClass(sourceClass)) {
                                return
                            }
                            if ($itemContainer.length) {
                                targetIndex = itemsOffset.length ? itemsOffset[itemsOffset.length - 1].index + 1 : 0
                            }
                            if (useIndicator) {
                                $items.length && that._renderIndicator($lastItem, isVertical, $targetGroup, !that.option("rtlEnabled") || isVertical)
                            } else {
                                $targetItem.appendTo($itemContainer)
                            }
                        }
                    });
                    _events_engine.default.on($eventListener, (0, _index.addNamespace)(_drag.end, SORTABLE_NAMESPACE), function() {
                        disposeScrollWrapper();
                        if (!$sourceItem) {
                            return
                        }
                        var onChanged = that.option("onChanged");
                        var changedArgs = {
                            sourceIndex: sourceIndex,
                            sourceElement: $sourceItem,
                            sourceGroup: sourceGroup,
                            targetIndex: targetIndex,
                            removeSourceElement: true,
                            removeTargetElement: false,
                            removeSourceClass: true
                        };
                        if ($targetGroup) {
                            $targetGroup.removeClass(targetClass);
                            changedArgs.targetGroup = $targetGroup.attr("group");
                            if (sourceGroup !== changedArgs.targetGroup || targetIndex > -1) {
                                onChanged && onChanged(changedArgs);
                                changedArgs.removeSourceElement && $sourceItem.remove()
                            }
                        }
                        that._indicator.detach();
                        changedArgs.removeSourceClass && $sourceItem.removeClass(sourceClass);
                        $sourceItem = null;
                        that._$draggable.remove();
                        that._$draggable = null;
                        changedArgs.removeTargetElement && $targetItem.remove();
                        $targetItem.removeClass(targetClass);
                        $targetItem = null
                    })
                }
            },
            _init: function() {
                this.callBase();
                this._attachEventHandlers()
            },
            _render: function() {
                this.callBase();
                this.$element().addClass(SORTABLE_CLASS)
            },
            _dispose: function() {
                var that = this;
                that.callBase.apply(that, arguments);
                that._$draggable && that._$draggable.detach();
                that._indicator && that._indicator.detach()
            },
            _optionChanged: function(args) {
                var that = this;
                switch (args.name) {
                    case "onDragging":
                    case "onChanged":
                    case "itemRender":
                    case "groupSelector":
                    case "itemSelector":
                    case "itemContainerSelector":
                    case "sourceClass":
                    case "targetClass":
                    case "dragClass":
                    case "allowDragging":
                    case "groupFilter":
                    case "useIndicator":
                        that._attachEventHandlers();
                        break;
                    case "direction":
                        break;
                    default:
                        that.callBase(args)
                }
            },
            _useTemplates: function() {
                return false
            }
        });
        (0, _component_registrator.default)("dxSortableOld", Sortable);
        var _default = Sortable;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/pivot_grid/ui.pivot_grid.export.js ***!
      \************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.DataProvider = exports.ExportMixin = void 0;
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _position = __webpack_require__( /*! ../../core/utils/position */ 22);
        var _format_helper = _interopRequireDefault(__webpack_require__( /*! ../../format_helper */ 71));
        var _number = _interopRequireDefault(__webpack_require__( /*! ../../localization/number */ 47));
        var _exporter = __webpack_require__( /*! ../../exporter */ 191);
        var _uiGrid_core = _interopRequireDefault(__webpack_require__( /*! ../grid_core/ui.grid_core.export_mixin */ 421));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }
        var DEFAULT_DATA_TYPE = "string";
        var DEFAUL_COLUMN_WIDTH = 100;
        var ExportMixin = (0, _extend.extend)({}, _uiGrid_core.default, {
            exportToExcel: function() {
                var that = this;
                (0, _exporter.export)(that.getDataProvider(), {
                    fileName: that.option("export.fileName"),
                    proxyUrl: that.option("export.proxyUrl"),
                    format: "EXCEL",
                    rtlEnabled: that.option("rtlEnabled"),
                    ignoreErrors: that.option("export.ignoreExcelErrors"),
                    exportingAction: that._actions.onExporting,
                    exportedAction: that._actions.onExported,
                    fileSavingAction: that._actions.onFileSaving
                }, _exporter.excel.getData)
            },
            _getLength: function(items) {
                var i;
                var itemCount = items[0].length;
                var cellCount = 0;
                for (i = 0; i < itemCount; i++) {
                    cellCount += items[0][i].colspan || 1
                }
                return cellCount
            },
            _correctCellsInfoItemLengths: function(cellsInfo, expectedLength) {
                for (var i = 0; i < cellsInfo.length; i++) {
                    while (cellsInfo[i].length < expectedLength) {
                        cellsInfo[i].push({})
                    }
                }
                return cellsInfo
            },
            _calculateCellInfoItemLength: function(columnsRow) {
                var result = 0;
                for (var columnIndex = 0; columnIndex < columnsRow.length; columnIndex++) {
                    result += (0, _type.isDefined)(columnsRow[columnIndex].colspan) ? columnsRow[columnIndex].colspan : 1
                }
                return result
            },
            _getAllItems: function(columnsInfo, rowsInfoItems, cellsInfo) {
                var cellIndex;
                var rowIndex;
                var correctedCellsInfo = cellsInfo;
                var rowsLength = this._getLength(rowsInfoItems);
                var headerRowsCount = columnsInfo.length;
                if (columnsInfo.length > 0 && columnsInfo[0].length > 0 && cellsInfo.length > 0 && 0 === cellsInfo[0].length) {
                    var cellInfoItemLength = this._calculateCellInfoItemLength(columnsInfo[0]);
                    if (cellInfoItemLength > 0) {
                        correctedCellsInfo = this._correctCellsInfoItemLengths(cellsInfo, cellInfoItemLength)
                    }
                }
                var sourceItems = columnsInfo.concat(correctedCellsInfo);
                for (rowIndex = 0; rowIndex < rowsInfoItems.length; rowIndex++) {
                    for (cellIndex = rowsInfoItems[rowIndex].length - 1; cellIndex >= 0; cellIndex--) {
                        if (!(0, _type.isDefined)(sourceItems[rowIndex + headerRowsCount])) {
                            sourceItems[rowIndex + headerRowsCount] = []
                        }
                        sourceItems[rowIndex + headerRowsCount].splice(0, 0, (0, _extend.extend)({}, rowsInfoItems[rowIndex][cellIndex]))
                    }
                }
                sourceItems[0].splice(0, 0, (0, _extend.extend)({}, this._getEmptyCell(), {
                    alignment: (0, _position.getDefaultAlignment)(this._options.rtlEnabled),
                    colspan: rowsLength,
                    rowspan: headerRowsCount
                }));
                return this._prepareItems(sourceItems)
            },
            getDataProvider: function() {
                var that = this;
                var dataController = this._dataController;
                var items = new _deferred.Deferred;
                dataController.beginLoading();
                setTimeout(function() {
                    var columnsInfo = (0, _extend.extend)(true, [], dataController.getColumnsInfo(true));
                    var rowsInfoItems = (0, _extend.extend)(true, [], dataController.getRowsInfo(true));
                    var cellsInfo = dataController.getCellsInfo(true);
                    items.resolve(that._getAllItems(columnsInfo, rowsInfoItems, cellsInfo));
                    dataController.endLoading()
                });
                return new DataProvider({
                    items: items,
                    rtlEnabled: this.option("rtlEnabled"),
                    dataFields: this.getDataSource().getAreaFields("data"),
                    customizeExcelCell: this.option("export.customizeExcelCell"),
                    rowsArea: this._rowsArea,
                    columnsArea: this._columnsArea
                })
            }
        });
        exports.ExportMixin = ExportMixin;
        var DataProvider = _class.default.inherit({
            ctor: function(options) {
                this._options = options
            },
            ready: function() {
                var options = this._options;
                return (0, _deferred.when)(options.items).done(function(items) {
                    var headerSize = items[0][0].rowspan;
                    var columns = items[headerSize - 1];
                    (0, _iterator.each)(columns, function(columnIndex, column) {
                        column.width = DEFAUL_COLUMN_WIDTH
                    });
                    options.columns = columns;
                    options.items = items
                })
            },
            getColumns: function() {
                return this._options.columns
            },
            getColumnsWidths: function() {
                var colsArea = this._options.columnsArea;
                var rowsArea = this._options.rowsArea;
                var columns = this._options.columns;
                var useDefaultWidth = !(0, _window.hasWindow)() || "virtual" === colsArea.option("scrolling.mode") || colsArea.element().is(":hidden");
                return useDefaultWidth ? columns.map(function(_) {
                    return DEFAUL_COLUMN_WIDTH
                }) : rowsArea.getColumnsWidth().concat(colsArea.getColumnsWidth())
            },
            getRowsCount: function() {
                return this._options.items.length
            },
            getGroupLevel: function() {
                return 0
            },
            getCellMerging: function(rowIndex, cellIndex) {
                var items = this._options.items;
                var item = items[rowIndex] && items[rowIndex][cellIndex];
                return item ? {
                    colspan: item.colspan - 1,
                    rowspan: item.rowspan - 1
                } : {
                    colspan: 0,
                    rowspan: 0
                }
            },
            getFrozenArea: function() {
                return {
                    x: this.getRowAreaColCount(),
                    y: this.getColumnAreaRowCount()
                }
            },
            getCellType: function(rowIndex, cellIndex) {
                var style = this.getStyles()[this.getStyleId(rowIndex, cellIndex)];
                return style && style.dataType || "string"
            },
            getCellData: function(rowIndex, cellIndex, isExcelJS) {
                var result = {};
                var items = this._options.items;
                var item = items[rowIndex] && items[rowIndex][cellIndex] || {};
                if (isExcelJS) {
                    result.cellSourceData = item;
                    var areaName = this._tryGetAreaName(item, rowIndex, cellIndex);
                    if (areaName) {
                        result.cellSourceData.area = areaName
                    }
                    result.cellSourceData.rowIndex = rowIndex;
                    result.cellSourceData.columnIndex = cellIndex
                }
                if ("string" === this.getCellType(rowIndex, cellIndex)) {
                    result.value = item.text
                } else {
                    result.value = item.value
                }
                if (result.cellSourceData && result.cellSourceData.isWhiteSpace) {
                    result.value = ""
                }
                return result
            },
            _tryGetAreaName: function(item, rowIndex, cellIndex) {
                if (this.isColumnAreaCell(rowIndex, cellIndex)) {
                    return "column"
                } else {
                    if (this.isRowAreaCell(rowIndex, cellIndex)) {
                        return "row"
                    } else {
                        if ((0, _type.isDefined)(item.dataIndex)) {
                            return "data"
                        }
                    }
                }
            },
            isRowAreaCell: function(rowIndex, cellIndex) {
                return rowIndex >= this.getColumnAreaRowCount() && cellIndex < this.getRowAreaColCount()
            },
            isColumnAreaCell: function(rowIndex, cellIndex) {
                return cellIndex >= this.getRowAreaColCount() && rowIndex < this.getColumnAreaRowCount()
            },
            getColumnAreaRowCount: function() {
                return this._options.items[0][0].rowspan
            },
            getRowAreaColCount: function() {
                return this._options.items[0][0].colspan
            },
            getHeaderStyles: function() {
                return [{
                    alignment: "center",
                    dataType: "string"
                }, {
                    alignment: (0, _position.getDefaultAlignment)(this._options.rtlEnabled),
                    dataType: "string"
                }]
            },
            getDataFieldStyles: function() {
                var _this = this;
                var dataFields = this._options.dataFields;
                var dataItemStyle = {
                    alignment: this._options.rtlEnabled ? "left" : "right"
                };
                var dataFieldStyles = [];
                if (dataFields.length) {
                    dataFields.forEach(function(dataField) {
                        dataFieldStyles.push(_objectSpread(_objectSpread({}, dataItemStyle), {
                            format: dataField.format,
                            dataType: _this.getCellDataType(dataField)
                        }))
                    });
                    return dataFieldStyles
                }
                return [dataItemStyle]
            },
            getStyles: function() {
                if (this._styles) {
                    return this._styles
                }
                this._styles = [].concat(_toConsumableArray(this.getHeaderStyles()), _toConsumableArray(this.getDataFieldStyles()));
                return this._styles
            },
            getCellDataType: function(field) {
                if (field && field.customizeText) {
                    return "string"
                }
                if (field.dataType) {
                    return field.dataType
                }
                if (field.format) {
                    if (1 === _number.default.parse(_format_helper.default.format(1, field.format))) {
                        return "number"
                    }
                    if (_format_helper.default.format(new Date, field.format)) {
                        return "date"
                    }
                }
                return DEFAULT_DATA_TYPE
            },
            getStyleId: function(rowIndex, cellIndex) {
                var items = this._options.items;
                var item = items[rowIndex] && items[rowIndex][cellIndex] || {};
                if (0 === cellIndex && 0 === rowIndex || this.isColumnAreaCell(rowIndex, cellIndex)) {
                    return 0
                } else {
                    if (this.isRowAreaCell(rowIndex, cellIndex)) {
                        return 1
                    }
                }
                return this.getHeaderStyles().length + (item.dataIndex || 0)
            },
            hasCustomizeExcelCell: function() {
                return (0, _type.isDefined)(this._options.customizeExcelCell)
            },
            customizeExcelCell: function(e) {
                if (this._options.customizeExcelCell) {
                    this._options.customizeExcelCell(e)
                }
            }
        });
        exports.DataProvider = DataProvider
    },
    /*!***********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/pivot_grid/ui.pivot_grid.chart_integration.js ***!
      \***********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _uiPivot_grid = __webpack_require__( /*! ./ui.pivot_grid.utils */ 84);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var FORMAT_DICTIONARY = {
            number: "numeric",
            date: "datetime"
        };
        var UNBIND_KEY = "dxPivotGridUnbinding";

        function getFormattedValue(path, fields) {
            var value = [];
            var lastFieldIndex = fields.length - 1;
            (0, _iterator.each)(path, function(i, item) {
                value.push(item.text || (0, _uiPivot_grid.formatValue)(item.value, fields[lastFieldIndex - i]))
            });
            return value.reverse()
        }

        function getExpandedLevel(node) {
            var level = 0;
            (0, _uiPivot_grid.foreachTree)(node, function(members) {
                level = Math.max(level, members.length - 1)
            });
            return level
        }

        function processDataCell(processCellArgs, processCell) {
            var chartDataItem = processCellArgs.chartDataItem;
            var processedCell = processCell && processCell(processCellArgs);
            if (processedCell) {
                chartDataItem = (0, _extend.extend)({}, chartDataItem, processedCell.chartDataItem);
                processedCell = (0, _extend.extend)({}, processCellArgs, processedCell, {
                    chartDataItem: chartDataItem
                });
                return processedCell
            }
            return processCellArgs
        }

        function createChartDataSource(pivotGridDataSource, mapOptions, axisDictionary) {
            var data = pivotGridDataSource.getData();
            var dataSource = [];
            var dataFields = pivotGridDataSource.getAreaFields("data");
            var rowFields = pivotGridDataSource.getAreaFields("row");
            var columnFields = pivotGridDataSource.getAreaFields("column");
            var columnElements = [{
                index: data.grandTotalColumnIndex,
                children: data.columns
            }];
            var rowElements = [{
                index: data.grandTotalRowIndex,
                children: data.rows
            }];
            var rowLevel = getExpandedLevel(rowElements);
            var columnLevel = getExpandedLevel(columnElements);
            var measureIndex;
            var dataField;
            var rowMemberIndex;
            var rowVisibility;
            var rowPathFormatted;
            var rowPath;
            var columnMemberIndex;
            var columnVisibility;
            var columnPath;
            var columnPathFormatted;

            function createDataItem() {
                var dataCell = (data.values[rowMemberIndex] || [])[columnMemberIndex] || [];
                var value = dataCell[measureIndex];
                var axis;
                var processCellArgs = {
                    rowPath: rowPath,
                    maxRowLevel: rowLevel,
                    rowPathFormatted: rowPathFormatted,
                    rowFields: rowFields,
                    columnPathFormatted: columnPathFormatted,
                    maxColumnLevel: columnLevel,
                    columnPath: columnPath,
                    columnFields: columnFields,
                    dataFields: dataFields,
                    dataIndex: measureIndex,
                    dataValues: dataCell,
                    visible: columnVisibility && rowVisibility
                };
                var seriesName = (mapOptions.inverted ? columnPathFormatted : rowPathFormatted).join(" - ");
                var argument = (mapOptions.inverted ? rowPathFormatted : columnPathFormatted).join("/");
                if (dataFields.length > 1) {
                    if ("args" === mapOptions.putDataFieldsInto || "both" === mapOptions.putDataFieldsInto) {
                        argument += " | " + dataField.caption
                    }
                    if ("args" !== mapOptions.putDataFieldsInto) {
                        seriesName += " | " + dataField.caption;
                        if ("singleAxis" !== mapOptions.dataFieldsDisplayMode) {
                            axis = dataField.caption
                        }
                    }
                }
                processCellArgs.chartDataItem = {
                    val: void 0 === value ? null : value,
                    series: seriesName,
                    arg: argument
                };
                processCellArgs = processDataCell(processCellArgs, mapOptions.processCell);
                if (processCellArgs.visible) {
                    axisDictionary[processCellArgs.chartDataItem.series] = axisDictionary[processCellArgs.chartDataItem.series] || axis;
                    dataSource.push(processCellArgs.chartDataItem)
                }
            }

            function foreachRowColumn(callBack) {
                (0, _uiPivot_grid.foreachTree)(rowElements, function(rowMembers) {
                    rowMemberIndex = rowMembers[0].index;
                    rowMembers = rowMembers.slice(0, rowMembers.length - 1);
                    rowVisibility = rowLevel === rowMembers.length;
                    rowPath = (0, _uiPivot_grid.createPath)(rowMembers);
                    rowPathFormatted = getFormattedValue(rowMembers, rowFields);
                    if (0 === rowPath.length) {
                        rowPathFormatted = [mapOptions.grandTotalText]
                    }(0, _uiPivot_grid.foreachTree)(columnElements, function(columnMembers) {
                        columnMemberIndex = columnMembers[0].index;
                        columnMembers = columnMembers.slice(0, columnMembers.length - 1);
                        columnVisibility = columnLevel === columnMembers.length;
                        columnPath = (0, _uiPivot_grid.createPath)(columnMembers);
                        columnPathFormatted = getFormattedValue(columnMembers, columnFields);
                        if (0 === columnPath.length) {
                            columnPathFormatted = [mapOptions.grandTotalText]
                        }
                        callBack()
                    })
                })
            }

            function foreachDataField(callback) {
                (0, _iterator.each)(dataFields, function(index, field) {
                    dataField = field;
                    measureIndex = index;
                    callback()
                })
            }
            if (false === mapOptions.alternateDataFields) {
                foreachDataField(function() {
                    foreachRowColumn(createDataItem)
                })
            } else {
                foreachRowColumn(function() {
                    foreachDataField(createDataItem)
                })
            }
            return dataSource
        }

        function createValueAxisOptions(dataSource, options) {
            var dataFields = dataSource.getAreaFields("data");
            if ("args" !== options.putDataFieldsInto && "singleAxis" !== options.dataFieldsDisplayMode || 1 === dataFields.length) {
                var valueAxisSettings = [];
                (0, _iterator.each)(dataFields, function(_, dataField) {
                    var valueAxisOptions = {
                        name: dataField.caption,
                        title: dataField.caption,
                        valueType: FORMAT_DICTIONARY[dataField.dataType] || dataField.dataType,
                        label: {
                            format: dataField.format
                        }
                    };
                    if (dataField.customizeText) {
                        valueAxisOptions.label.customizeText = function(formatObject) {
                            return dataField.customizeText.call(dataField, formatObject)
                        }
                    }
                    if ("splitPanes" === options.dataFieldsDisplayMode) {
                        valueAxisOptions.pane = dataField.caption
                    }
                    valueAxisSettings.push(valueAxisOptions)
                });
                return valueAxisSettings
            }
            return [{}]
        }

        function createPanesOptions(dataSource, options) {
            var panes = [];
            var dataFields = dataSource.getAreaFields("data");
            if (dataFields.length > 1 && "splitPanes" === options.dataFieldsDisplayMode && "args" !== options.putDataFieldsInto) {
                (0, _iterator.each)(dataFields, function(_, dataField) {
                    panes.push({
                        name: dataField.caption
                    })
                })
            }
            if (!panes.length) {
                panes.push({})
            }
            return panes
        }

        function createChartOptions(dataSource, options) {
            var _customizeSeries = options.customizeSeries;
            var customizeChart = options.customizeChart;
            var chartOptions = {
                valueAxis: createValueAxisOptions(dataSource, options),
                panes: createPanesOptions(dataSource, options)
            };
            var axisDictionary = {};
            if (customizeChart) {
                chartOptions = (0, _extend.extend)(true, {}, chartOptions, customizeChart(chartOptions))
            }
            chartOptions.dataSource = createChartDataSource(dataSource, options, axisDictionary);
            chartOptions.seriesTemplate = {
                nameField: "series",
                customizeSeries: function(seriesName) {
                    var seriesOptions = {};
                    if ("splitPanes" === options.dataFieldsDisplayMode) {
                        seriesOptions.pane = axisDictionary[seriesName]
                    } else {
                        if ("singleAxis" !== options.dataFieldsDisplayMode) {
                            seriesOptions.axis = axisDictionary[seriesName]
                        }
                    }
                    if (_customizeSeries) {
                        seriesOptions = (0, _extend.extend)(seriesOptions, _customizeSeries(seriesName, seriesOptions))
                    }
                    return seriesOptions
                }
            };
            return chartOptions
        }

        function getChartInstance(chartElement) {
            if (!chartElement) {
                return false
            }
            if (chartElement.NAME) {
                return "dxChart" === chartElement.NAME && chartElement
            }
            var element = (0, _renderer.default)(chartElement);
            return element.data("dxChart") && element.dxChart("instance")
        }

        function removeBinding(chart) {
            var unbind = chart.$element().data(UNBIND_KEY);
            unbind && unbind()
        }
        var _default = {
            bindChart: function(chart, integrationOptions) {
                integrationOptions = (0, _extend.extend)({}, integrationOptions);
                var that = this;
                var updateChart = function() {
                    integrationOptions.grandTotalText = that.option("texts.grandTotal");
                    var chartOptions = createChartOptions(that.getDataSource(), integrationOptions);
                    chart.option(chartOptions)
                };
                chart = getChartInstance(chart);
                if (!chart) {
                    return null
                }
                removeBinding(chart);
                that.on("changed", updateChart);
                updateChart();
                var disposeBinding = function() {
                    chart.$element().removeData(UNBIND_KEY);
                    that.off("changed", updateChart)
                };
                chart.on("disposing", disposeBinding);
                this.on("disposing", disposeBinding);
                chart.$element().data(UNBIND_KEY, disposeBinding);
                return disposeBinding
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/pivot_grid_field_chooser.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiPivot_grid = _interopRequireDefault(__webpack_require__( /*! ./pivot_grid/ui.pivot_grid.field_chooser */ 427));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _uiPivot_grid.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/pivot_grid/xmla_store.js ***!
      \**************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _xmla_store = __webpack_require__( /*! ./xmla_store/xmla_store */ 426);
        var _default = _xmla_store.XmlaStore;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./scheduler/ui.scheduler */ 786));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _ui.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/ui.scheduler.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _config = _interopRequireDefault(__webpack_require__( /*! ../../core/config */ 31));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _bindable_template = __webpack_require__( /*! ../../core/templates/bindable_template */ 65);
        var _empty_template = __webpack_require__( /*! ../../core/templates/empty_template */ 91);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _browser = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/browser */ 23));
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/callbacks */ 27));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _data = __webpack_require__( /*! ../../core/utils/data */ 20);
        var _position = __webpack_require__( /*! ../../core/utils/position */ 22);
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));
        var _date_serialization = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date_serialization */ 57));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _support = __webpack_require__( /*! ../../core/utils/support */ 45);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _data_helper = _interopRequireDefault(__webpack_require__( /*! ../../data_helper */ 92));
        var _visibility_change = __webpack_require__( /*! ../../events/visibility_change */ 59);
        var _date2 = _interopRequireDefault(__webpack_require__( /*! ../../localization/date */ 32));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _dialog = __webpack_require__( /*! ../dialog */ 267);
        var _themes = __webpack_require__( /*! ../themes */ 34);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _ui2 = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _appointmentPopup = _interopRequireDefault(__webpack_require__( /*! ./appointmentPopup */ 787));
        var _compactAppointmentsHelper = __webpack_require__( /*! ./compactAppointmentsHelper */ 803);
        var _desktopTooltipStrategy = __webpack_require__( /*! ./tooltip_strategies/desktopTooltipStrategy */ 804);
        var _mobileTooltipStrategy = __webpack_require__( /*! ./tooltip_strategies/mobileTooltipStrategy */ 805);
        var _ui3 = __webpack_require__( /*! ./ui.loading */ 434);
        var _uiScheduler = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.appointments */ 806));
        var _uiSchedulerAppointments = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.appointments.layout_manager */ 809));
        var _uiScheduler2 = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.appointment_model */ 814));
        var _uiScheduler3 = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.header */ 815));
        var _uiScheduler4 = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.resource_manager */ 817));
        var _uiScheduler5 = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.subscribes */ 818));
        var _recurrence = __webpack_require__( /*! ./recurrence */ 139);
        var _utils = _interopRequireDefault(__webpack_require__( /*! ./utils.timeZone */ 86));
        var _uiScheduler6 = _interopRequireDefault(__webpack_require__( /*! ./workspaces/ui.scheduler.agenda */ 819));
        var _uiScheduler7 = _interopRequireDefault(__webpack_require__( /*! ./workspaces/ui.scheduler.timeline_day */ 840));
        var _uiScheduler8 = _interopRequireDefault(__webpack_require__( /*! ./workspaces/ui.scheduler.timeline_month */ 842));
        var _uiScheduler9 = _interopRequireDefault(__webpack_require__( /*! ./workspaces/ui.scheduler.timeline_week */ 447));
        var _uiScheduler10 = _interopRequireDefault(__webpack_require__( /*! ./workspaces/ui.scheduler.timeline_work_week */ 843));
        var _uiScheduler11 = _interopRequireDefault(__webpack_require__( /*! ./workspaces/ui.scheduler.work_space_day */ 844));
        var _uiScheduler12 = _interopRequireDefault(__webpack_require__( /*! ./workspaces/ui.scheduler.work_space_month */ 849));
        var _uiScheduler13 = _interopRequireDefault(__webpack_require__( /*! ./workspaces/ui.scheduler.work_space_week */ 451));
        var _uiScheduler14 = _interopRequireDefault(__webpack_require__( /*! ./workspaces/ui.scheduler.work_space_work_week */ 852));
        var _appointmentAdapter = _interopRequireDefault(__webpack_require__( /*! ./appointmentAdapter */ 853));
        var _timeZoneCalculator = __webpack_require__( /*! ./timeZoneCalculator */ 854);
        var _dataStructures = __webpack_require__( /*! ./dataStructures */ 435);
        var _appointmentSettingsGenerator = __webpack_require__( /*! ./appointmentSettingsGenerator */ 855);
        var _utils2 = _interopRequireDefault(__webpack_require__( /*! ./utils */ 440));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var MINUTES_IN_HOUR = 60;
        var WIDGET_CLASS = "dx-scheduler";
        var WIDGET_SMALL_CLASS = "".concat(WIDGET_CLASS, "-small");
        var WIDGET_ADAPTIVE_CLASS = "".concat(WIDGET_CLASS, "-adaptive");
        var WIDGET_WIN_NO_TOUCH_CLASS = "".concat(WIDGET_CLASS, "-win-no-touch");
        var WIDGET_READONLY_CLASS = "".concat(WIDGET_CLASS, "-readonly");
        var WIDGET_SMALL_WIDTH = 400;
        var FULL_DATE_FORMAT = "yyyyMMddTHHmmss";
        var UTC_FULL_DATE_FORMAT = FULL_DATE_FORMAT + "Z";
        var VIEWS_CONFIG = {
            day: {
                workSpace: _uiScheduler11.default,
                renderingStrategy: "vertical"
            },
            week: {
                workSpace: _uiScheduler13.default,
                renderingStrategy: "vertical"
            },
            workWeek: {
                workSpace: _uiScheduler14.default,
                renderingStrategy: "vertical"
            },
            month: {
                workSpace: _uiScheduler12.default,
                renderingStrategy: "horizontalMonth"
            },
            timelineDay: {
                workSpace: _uiScheduler7.default,
                renderingStrategy: "horizontal"
            },
            timelineWeek: {
                workSpace: _uiScheduler9.default,
                renderingStrategy: "horizontal"
            },
            timelineWorkWeek: {
                workSpace: _uiScheduler10.default,
                renderingStrategy: "horizontal"
            },
            timelineMonth: {
                workSpace: _uiScheduler8.default,
                renderingStrategy: "horizontalMonthLine"
            },
            agenda: {
                workSpace: _uiScheduler6.default,
                renderingStrategy: "agenda"
            }
        };
        var StoreEventNames = {
            ADDING: "onAppointmentAdding",
            ADDED: "onAppointmentAdded",
            DELETING: "onAppointmentDeleting",
            DELETED: "onAppointmentDeleted",
            UPDATING: "onAppointmentUpdating",
            UPDATED: "onAppointmentUpdated"
        };
        var Scheduler = function(_Widget) {
            _inheritsLoose(Scheduler, _Widget);

            function Scheduler() {
                return _Widget.apply(this, arguments) || this
            }
            var _proto = Scheduler.prototype;
            _proto._getDefaultOptions = function() {
                var defaultOptions = (0, _extend.extend)(_Widget.prototype._getDefaultOptions.call(this), {
                    views: ["day", "week"],
                    currentView: "day",
                    currentDate: _date.default.trimTime(new Date),
                    min: void 0,
                    max: void 0,
                    dateSerializationFormat: void 0,
                    firstDayOfWeek: void 0,
                    groups: [],
                    resources: [],
                    dataSource: null,
                    customizeDateNavigatorText: void 0,
                    appointmentTemplate: "item",
                    dropDownAppointmentTemplate: "dropDownAppointment",
                    appointmentCollectorTemplate: "appointmentCollector",
                    dataCellTemplate: null,
                    timeCellTemplate: null,
                    resourceCellTemplate: null,
                    dateCellTemplate: null,
                    startDayHour: 0,
                    endDayHour: 24,
                    editing: {
                        allowAdding: true,
                        allowDeleting: true,
                        allowDragging: true,
                        allowResizing: true,
                        allowUpdating: true,
                        allowTimeZoneEditing: false,
                        allowEditingTimeZones: false
                    },
                    showAllDayPanel: true,
                    showCurrentTimeIndicator: true,
                    shadeUntilCurrentTime: false,
                    indicatorUpdateInterval: 3e5,
                    indicatorTime: void 0,
                    recurrenceEditMode: "dialog",
                    cellDuration: 30,
                    maxAppointmentsPerCell: "auto",
                    selectedCellData: [],
                    groupByDate: false,
                    onAppointmentRendered: null,
                    onAppointmentClick: null,
                    onAppointmentDblClick: null,
                    onAppointmentContextMenu: null,
                    onCellClick: null,
                    onCellContextMenu: null,
                    onAppointmentAdding: null,
                    onAppointmentAdded: null,
                    onAppointmentUpdating: null,
                    onAppointmentUpdated: null,
                    onAppointmentDeleting: null,
                    onAppointmentDeleted: null,
                    onAppointmentFormOpening: null,
                    appointmentTooltipTemplate: "appointmentTooltip",
                    appointmentPopupTemplate: "appointmentPopup",
                    crossScrollingEnabled: false,
                    useDropDownViewSwitcher: false,
                    startDateExpr: "startDate",
                    endDateExpr: "endDate",
                    textExpr: "text",
                    descriptionExpr: "description",
                    allDayExpr: "allDay",
                    recurrenceRuleExpr: "recurrenceRule",
                    recurrenceExceptionExpr: "recurrenceException",
                    disabledExpr: "disabled",
                    remoteFiltering: false,
                    timeZone: "",
                    startDateTimeZoneExpr: "startDateTimeZone",
                    endDateTimeZoneExpr: "endDateTimeZone",
                    noDataText: _message.default.format("dxCollectionWidget-noDataText"),
                    adaptivityEnabled: false,
                    allowMultipleCellSelection: true,
                    scrolling: {
                        mode: "standard"
                    },
                    renovateRender: false,
                    _appointmentTooltipOffset: {
                        x: 0,
                        y: 0
                    },
                    _appointmentTooltipButtonsPosition: "bottom",
                    _appointmentTooltipOpenButtonText: _message.default.format("dxScheduler-openAppointment"),
                    _dropDownButtonIcon: "overflow",
                    _appointmentCountPerCell: 2,
                    _collectorOffset: 0,
                    _appointmentOffset: 26
                });
                return (0, _extend.extend)(true, defaultOptions, {
                    integrationOptions: {
                        useDeferUpdateForTemplates: false
                    }
                })
            };
            _proto._defaultOptionsRules = function() {
                return _Widget.prototype._defaultOptionsRules.call(this).concat([{
                    device: function() {
                        return "desktop" === _devices.default.real().deviceType && !_devices.default.isSimulator()
                    },
                    options: {
                        focusStateEnabled: true
                    }
                }, {
                    device: function() {
                        return !_devices.default.current().generic
                    },
                    options: {
                        useDropDownViewSwitcher: true,
                        editing: {
                            allowDragging: false,
                            allowResizing: false
                        }
                    }
                }, {
                    device: function() {
                        return (0, _themes.isMaterial)()
                    },
                    options: {
                        useDropDownViewSwitcher: true,
                        dateCellTemplate: function(data, index, element) {
                            var text = data.text;
                            text.split(" ").forEach(function(text, index) {
                                var span = (0, _renderer.default)("<span>").text(text).addClass("dx-scheduler-header-panel-cell-date");
                                (0, _renderer.default)(element).append(span);
                                if (!index) {
                                    (0, _renderer.default)(element).append(" ")
                                }
                            })
                        },
                        _appointmentTooltipOffset: {
                            x: 0,
                            y: 11
                        },
                        _appointmentTooltipButtonsPosition: "top",
                        _appointmentTooltipOpenButtonText: null,
                        _dropDownButtonIcon: "chevrondown",
                        _appointmentCountPerCell: 1,
                        _collectorOffset: 20,
                        _appointmentOffset: 30
                    }
                }])
            };
            _proto._setDeprecatedOptions = function() {
                _Widget.prototype._setDeprecatedOptions.call(this);
                (0, _extend.extend)(this._deprecatedOptions, {
                    dropDownAppointmentTemplate: {
                        since: "19.2",
                        message: "appointmentTooltipTemplate"
                    },
                    allowEditingTimeZones: {
                        since: "20.1",
                        alias: "allowTimeZoneEditing"
                    }
                })
            };
            _proto._getAppointmentSettingsGenerator = function() {
                return new _appointmentSettingsGenerator.AppointmentSettingsGenerator(this)
            };
            _proto._postponeDataSourceLoading = function(promise) {
                this.postponedOperations.add("_reloadDataSource", this._reloadDataSource.bind(this), promise)
            };
            _proto._postponeResourceLoading = function() {
                var _this = this;
                var whenLoaded = this.postponedOperations.add("_loadResources", function() {
                    return _this._loadResources()
                });
                var resolveCallbacks = new _deferred.Deferred;
                whenLoaded.done(function(resources) {
                    resolveCallbacks.resolve(resources)
                });
                this._postponeDataSourceLoading(whenLoaded);
                return resolveCallbacks.promise()
            };
            _proto._optionChanged = function(args) {
                var _this2 = this;
                var value = args.value;
                var name = args.name;
                switch (args.name) {
                    case "customizeDateNavigatorText":
                        this._updateOption("header", name, value);
                        break;
                    case "firstDayOfWeek":
                        this._updateOption("workSpace", name, value);
                        this._updateOption("header", name, value);
                        break;
                    case "currentDate":
                        value = this._dateOption(name);
                        value = _date.default.trimTime(new Date(value));
                        this.option("selectedCellData", []);
                        this._workSpace.option(name, new Date(value));
                        this._header.option(name, new Date(value));
                        this._header.option("displayedDate", this._workSpace._getViewStartByOptions());
                        this._appointments.option("items", []);
                        this._filterAppointmentsByDate();
                        this._postponeDataSourceLoading();
                        break;
                    case "dataSource":
                        this._initDataSource();
                        this._appointmentModel.setDataSource(this._dataSource);
                        this._postponeResourceLoading().done(function(resources) {
                            _this2._filterAppointmentsByDate();
                            _this2._updateOption("workSpace", "showAllDayPanel", _this2.option("showAllDayPanel"))
                        });
                        break;
                    case "min":
                    case "max":
                        value = this._dateOption(name);
                        this._updateOption("header", name, new Date(value));
                        this._updateOption("workSpace", name, new Date(value));
                        break;
                    case "views":
                        this._processCurrentView();
                        if (this._getCurrentViewOptions()) {
                            this.repaint()
                        } else {
                            this._header.option(name, value)
                        }
                        break;
                    case "useDropDownViewSwitcher":
                        this._header.option(name, value);
                        break;
                    case "currentView":
                        this._processCurrentView();
                        this.fire("validateDayHours");
                        this.getLayoutManager().initRenderingStrategy(this._getAppointmentsRenderingStrategy());
                        this._validateCellDuration();
                        this._appointments.option({
                            items: [],
                            allowDrag: this._allowDragging(),
                            allowResize: this._allowResizing(),
                            itemTemplate: this._getAppointmentTemplate("appointmentTemplate")
                        });
                        this._postponeResourceLoading().done(function(resources) {
                            _this2._refreshWorkSpace(resources);
                            _this2._updateHeader();
                            _this2._filterAppointmentsByDate();
                            _this2._appointments.option("allowAllDayResize", "day" !== value)
                        });
                        break;
                    case "appointmentTemplate":
                        this._appointments.option("itemTemplate", value);
                        break;
                    case "dateCellTemplate":
                    case "resourceCellTemplate":
                    case "dataCellTemplate":
                    case "timeCellTemplate":
                        this._updateOption("workSpace", name, value);
                        this.repaint();
                        break;
                    case "groups":
                        this._postponeResourceLoading().done(function(resources) {
                            _this2._refreshWorkSpace(resources);
                            _this2._filterAppointmentsByDate()
                        });
                        break;
                    case "resources":
                        this._resourcesManager.setResources(this.option("resources"));
                        this._appointmentModel.setDataAccessors(this._combineDataAccessors());
                        this._postponeResourceLoading().done(function(resources) {
                            _this2._appointments.option("items", []);
                            _this2._refreshWorkSpace(resources);
                            _this2._filterAppointmentsByDate()
                        });
                        break;
                    case "startDayHour":
                    case "endDayHour":
                        this.fire("validateDayHours");
                        this._appointments.option("items", []);
                        this._updateOption("workSpace", name, value);
                        this._appointments.repaint();
                        this._filterAppointmentsByDate();
                        this._postponeDataSourceLoading();
                        break;
                    case StoreEventNames.ADDING:
                    case StoreEventNames.ADDED:
                    case StoreEventNames.UPDATING:
                    case StoreEventNames.UPDATED:
                    case StoreEventNames.DELETING:
                    case StoreEventNames.DELETED:
                    case "onAppointmentFormOpening":
                        this._actions[name] = this._createActionByOption(name);
                        break;
                    case "onAppointmentRendered":
                        this._appointments.option("onItemRendered", this._getAppointmentRenderedAction());
                        break;
                    case "onAppointmentClick":
                        this._appointments.option("onItemClick", this._createActionByOption(name));
                        break;
                    case "onAppointmentDblClick":
                        this._appointments.option(name, this._createActionByOption(name));
                        break;
                    case "onAppointmentContextMenu":
                        this._appointments.option("onItemContextMenu", this._createActionByOption(name));
                        break;
                    case "noDataText":
                    case "allowMultipleCellSelection":
                    case "selectedCellData":
                    case "accessKey":
                    case "onCellClick":
                        this._workSpace.option(name, value);
                        break;
                    case "onCellContextMenu":
                        this._workSpace.option(name, value);
                        break;
                    case "crossScrollingEnabled":
                        this._postponeResourceLoading().done(function(resources) {
                            _this2._appointments.option("items", []);
                            _this2._refreshWorkSpace(resources);
                            if (_this2._readyToRenderAppointments) {
                                _this2._appointments.option("items", _this2._getAppointmentsToRepaint())
                            }
                        });
                        break;
                    case "cellDuration":
                        this._validateCellDuration();
                        this._appointments.option("items", []);
                        if (this._readyToRenderAppointments) {
                            this._updateOption("workSpace", "hoursInterval", value / 60);
                            this._appointments.option("items", this._getAppointmentsToRepaint())
                        }
                        break;
                    case "tabIndex":
                    case "focusStateEnabled":
                        this._updateOption("header", name, value);
                        this._updateOption("workSpace", name, value);
                        this._appointments.option(name, value);
                        _Widget.prototype._optionChanged.call(this, args);
                        break;
                    case "width":
                        this._updateOption("header", name, value);
                        if (this.option("crossScrollingEnabled")) {
                            this._updateOption("workSpace", "width", value)
                        }
                        _Widget.prototype._optionChanged.call(this, args);
                        this._dimensionChanged();
                        break;
                    case "height":
                        _Widget.prototype._optionChanged.call(this, args);
                        this._dimensionChanged();
                        break;
                    case "editing":
                        this._initEditing();
                        var editing = this._editing;
                        this._bringEditingModeToAppointments(editing);
                        this.hideAppointmentTooltip();
                        this._cleanPopup();
                        break;
                    case "showAllDayPanel":
                        this._postponeResourceLoading().done(function(resources) {
                            _this2._filterAppointmentsByDate();
                            _this2._updateOption("workSpace", "allDayExpanded", value);
                            _this2._updateOption("workSpace", name, value)
                        });
                        break;
                    case "showCurrentTimeIndicator":
                    case "indicatorTime":
                    case "indicatorUpdateInterval":
                    case "shadeUntilCurrentTime":
                    case "groupByDate":
                        this._updateOption("workSpace", name, value);
                        this.repaint();
                        break;
                    case "appointmentDragging":
                    case "appointmentTooltipTemplate":
                    case "appointmentPopupTemplate":
                    case "recurrenceEditMode":
                    case "remoteFiltering":
                    case "timeZone":
                    case "dropDownAppointmentTemplate":
                    case "appointmentCollectorTemplate":
                    case "_appointmentTooltipOffset":
                    case "_appointmentTooltipButtonsPosition":
                    case "_appointmentTooltipOpenButtonText":
                    case "_dropDownButtonIcon":
                    case "_appointmentCountPerCell":
                    case "_collectorOffset":
                    case "_appointmentOffset":
                        this.repaint();
                        break;
                    case "dateSerializationFormat":
                        break;
                    case "maxAppointmentsPerCell":
                        break;
                    case "startDateExpr":
                    case "endDateExpr":
                    case "startDateTimeZoneExpr":
                    case "endDateTimeZoneExpr":
                    case "textExpr":
                    case "descriptionExpr":
                    case "allDayExpr":
                    case "recurrenceRuleExpr":
                    case "recurrenceExceptionExpr":
                    case "disabledExpr":
                        this._updateExpression(name, value);
                        this._appointmentModel.setDataAccessors(this._combineDataAccessors());
                        this._initAppointmentTemplate();
                        this.repaint();
                        break;
                    case "adaptivityEnabled":
                        this._toggleAdaptiveClass();
                        this.repaint();
                        break;
                    case "scrolling":
                        this._updateOption("workSpace", args.fullName, value);
                        break;
                    case "renovateRender":
                        this._updateOption("workSpace", name, value);
                        break;
                    default:
                        _Widget.prototype._optionChanged.call(this, args)
                }
            };
            _proto._updateHeader = function() {
                var viewCountConfig = this._getViewCountConfig();
                this._header.option("intervalCount", viewCountConfig.intervalCount);
                this._header.option("displayedDate", this._workSpace._getViewStartByOptions());
                this._header.option("min", this._dateOption("min"));
                this._header.option("max", this._dateOption("max"));
                this._header.option("currentDate", this._dateOption("currentDate"));
                this._header.option("firstDayOfWeek", this._getCurrentViewOption("firstDayOfWeek"));
                this._header.option("currentView", this._currentView)
            };
            _proto._dateOption = function(optionName) {
                var optionValue = this._getCurrentViewOption(optionName);
                return _date_serialization.default.deserializeDate(optionValue)
            };
            _proto._getSerializationFormat = function(optionName) {
                var value = this._getCurrentViewOption(optionName);
                if ("number" === typeof value) {
                    return "number"
                }
                if (!(0, _type.isString)(value)) {
                    return
                }
                return _date_serialization.default.getDateSerializationFormat(value)
            };
            _proto._bringEditingModeToAppointments = function(editing) {
                var editingConfig = {
                    allowDelete: editing.allowUpdating && editing.allowDeleting
                };
                if (!this._isAgenda()) {
                    editingConfig.allowDrag = editing.allowDragging;
                    editingConfig.allowResize = editing.allowResizing;
                    editingConfig.allowAllDayResize = editing.allowResizing && this._supportAllDayResizing()
                }
                this._appointments.option(editingConfig);
                this.repaint()
            };
            _proto._isAgenda = function() {
                return "agenda" === this._getAppointmentsRenderingStrategy()
            };
            _proto._allowDragging = function() {
                return this._editing.allowDragging && !this._isAgenda()
            };
            _proto._allowResizing = function() {
                return this._editing.allowResizing && !this._isAgenda()
            };
            _proto._allowAllDayResizing = function() {
                return this._editing.allowResizing && this._supportAllDayResizing()
            };
            _proto._supportAllDayResizing = function() {
                return "day" !== this._getCurrentViewType() || this._currentView.intervalCount > 1
            };
            _proto._isAllDayExpanded = function(items) {
                return this.option("showAllDayPanel") && this._appointmentModel.hasAllDayAppointments(items, this._getCurrentViewOption("startDayHour"), this._getCurrentViewOption("endDayHour"))
            };
            _proto._getTimezoneOffsetByOption = function(date) {
                return _utils.default.calculateTimezoneByValue(this.option("timeZone"), date)
            };
            _proto._filterAppointmentsByDate = function() {
                var dateRange = this._workSpace.getDateRange();
                this._appointmentModel.filterByDate(dateRange[0], dateRange[1], this.option("remoteFiltering"), this.option("dateSerializationFormat"))
            };
            _proto._loadResources = function() {
                var groups = this._getCurrentViewOption("groups");
                var result = new _deferred.Deferred;
                this._resourcesManager.loadResources(groups).done(function(resources) {
                    this._loadedResources = resources;
                    result.resolve(resources)
                }.bind(this));
                return result.promise()
            };
            _proto._reloadDataSource = function() {
                var result = new _deferred.Deferred;
                if (this._dataSource) {
                    this._dataSource.load().done(function() {
                        (0, _ui3.hide)();
                        this._fireContentReadyAction(result)
                    }.bind(this)).fail(function() {
                        (0, _ui3.hide)();
                        result.reject()
                    });
                    this._dataSource.isLoading() && (0, _ui3.show)({
                        container: this.$element(),
                        position: {
                            of: this.$element()
                        }
                    })
                } else {
                    this._fireContentReadyAction(result)
                }
                return result.promise()
            };
            _proto._fireContentReadyAction = function(result) {
                var contentReadyBase = _Widget.prototype._fireContentReadyAction.bind(this);
                var fireContentReady = function() {
                    contentReadyBase();
                    null === result || void 0 === result ? void 0 : result.resolve()
                };
                if (this._workSpaceRecalculation) {
                    var _this$_workSpaceRecal;
                    null === (_this$_workSpaceRecal = this._workSpaceRecalculation) || void 0 === _this$_workSpaceRecal ? void 0 : _this$_workSpaceRecal.done(function() {
                        fireContentReady()
                    })
                } else {
                    fireContentReady()
                }
            };
            _proto._dimensionChanged = function() {
                var filteredItems = this.getFilteredItems();
                this._toggleSmallClass();
                if (!this._isAgenda() && filteredItems && this._isVisible()) {
                    this._workSpace._cleanAllowedPositions();
                    this._workSpace.option("allDayExpanded", this._isAllDayExpanded(filteredItems));
                    this._workSpace._dimensionChanged();
                    var appointments = this._layoutManager.createAppointmentsMap(filteredItems);
                    this._appointments.option("items", appointments)
                }
                this.hideAppointmentTooltip();
                this._appointmentPopup.triggerResize();
                this._appointmentPopup.updatePopupFullScreenMode()
            };
            _proto._clean = function() {
                this._cleanPopup();
                _Widget.prototype._clean.call(this)
            };
            _proto._toggleSmallClass = function() {
                var width = (0, _position.getBoundingRect)(this.$element().get(0)).width;
                this.$element().toggleClass(WIDGET_SMALL_CLASS, width < WIDGET_SMALL_WIDTH)
            };
            _proto._toggleAdaptiveClass = function() {
                this.$element().toggleClass(WIDGET_ADAPTIVE_CLASS, this.option("adaptivityEnabled"))
            };
            _proto._visibilityChanged = function(visible) {
                visible && this._dimensionChanged()
            };
            _proto._dataSourceOptions = function() {
                return {
                    paginate: false
                }
            };
            _proto._init = function() {
                var _this3 = this;
                this._initExpressions({
                    startDate: this.option("startDateExpr"),
                    endDate: this.option("endDateExpr"),
                    startDateTimeZone: this.option("startDateTimeZoneExpr"),
                    endDateTimeZone: this.option("endDateTimeZoneExpr"),
                    allDay: this.option("allDayExpr"),
                    text: this.option("textExpr"),
                    description: this.option("descriptionExpr"),
                    recurrenceRule: this.option("recurrenceRuleExpr"),
                    recurrenceException: this.option("recurrenceExceptionExpr"),
                    disabled: this.option("disabledExpr")
                });
                _Widget.prototype._init.call(this);
                this._initDataSource();
                this._loadedResources = [];
                this.$element().addClass(WIDGET_CLASS).toggleClass(WIDGET_WIN_NO_TOUCH_CLASS, !!(_browser.default.msie && _support.touch));
                this._initEditing();
                this._resourcesManager = new _uiScheduler4.default(this.option("resources"));
                var combinedDataAccessors = this._combineDataAccessors();
                this._appointmentModel = new _uiScheduler2.default(this._dataSource, combinedDataAccessors, this.getAppointmentDurationInMinutes());
                this._initActions();
                this._compactAppointmentsHelper = new _compactAppointmentsHelper.CompactAppointmentsHelper(this);
                this._asyncTemplatesTimers = [];
                this._dataSourceLoadedCallback = (0, _callbacks.default)();
                this._subscribes = _uiScheduler5.default;
                this.timeZoneCalculator = new _timeZoneCalculator.TimeZoneCalculator({
                    getClientOffset: function(date) {
                        return _utils.default.getClientTimezoneOffset(date)
                    },
                    getCommonOffset: function(date, timeZone) {
                        return _utils.default.calculateTimezoneByValue(timeZone || _this3.option("timeZone"), date)
                    },
                    getAppointmentOffset: function(date, appointmentTimezone) {
                        return _utils.default.calculateTimezoneByValue(appointmentTimezone, date)
                    }
                })
            };
            _proto._initTemplates = function() {
                this._initAppointmentTemplate();
                this._templateManager.addDefaultTemplates({
                    appointmentTooltip: new _empty_template.EmptyTemplate,
                    dropDownAppointment: new _empty_template.EmptyTemplate
                });
                _Widget.prototype._initTemplates.call(this)
            };
            _proto._initAppointmentTemplate = function() {
                var _this4 = this;
                var expr = this._dataAccessors.expr;
                var createGetter = function(property) {
                    return (0, _data.compileGetter)("appointmentData.".concat(property))
                };
                var getDate = function(getter) {
                    return function(data) {
                        var value = getter(data);
                        if (value instanceof Date) {
                            return value.valueOf()
                        }
                        return value
                    }
                };
                this._templateManager.addDefaultTemplates(_defineProperty({}, "item", new _bindable_template.BindableTemplate(function($container, data, model) {
                    return _this4.getAppointmentsInstance()._renderAppointmentTemplate($container, data, model)
                }, ["html", "text", "startDate", "endDate", "allDay", "description", "recurrenceRule", "recurrenceException", "startDateTimeZone", "endDateTimeZone"], this.option("integrationOptions.watchMethod"), {
                    text: createGetter(expr.textExpr),
                    startDate: getDate(createGetter(expr.startDateExpr)),
                    endDate: getDate(createGetter(expr.endDateExpr)),
                    startDateTimeZone: createGetter(expr.startDateTimeZoneExpr),
                    endDateTimeZone: createGetter(expr.endDateTimeZoneExpr),
                    allDay: createGetter(expr.allDayExpr),
                    recurrenceRule: createGetter(expr.recurrenceRuleExpr)
                })))
            };
            _proto._combineDataAccessors = function() {
                var resourcesDataAccessors = this._resourcesManager._dataAccessors;
                var result = (0, _extend.extend)(true, {}, this._dataAccessors);
                (0, _iterator.each)(resourcesDataAccessors, function(type, accessor) {
                    result[type].resources = accessor
                }.bind(this));
                return result
            };
            _proto._renderContent = function() {
                this._renderContentImpl()
            };
            _proto._dataSourceChangedHandler = function(result) {
                if (this._readyToRenderAppointments) {
                    this._workSpaceRecalculation.done(function() {
                        this._renderAppointments();
                        if (this._isAgenda()) {
                            this._workSpace._renderView();
                            this._dataSourceLoadedCallback.fireWith(this, [this.getFilteredItems()])
                        }
                    }.bind(this))
                }
            };
            _proto.isVirtualScrolling = function() {
                var _this$getWorkSpace;
                return null === (_this$getWorkSpace = this.getWorkSpace()) || void 0 === _this$getWorkSpace ? void 0 : _this$getWorkSpace.isVirtualScrolling()
            };
            _proto._filterAppointments = function() {
                var prerenderFilterName = this.isVirtualScrolling() ? "prerenderFilterVirtual" : "prerenderFilter";
                return this.fire(prerenderFilterName)
            };
            _proto._renderAppointments = function() {
                this._filteredItems = this._filterAppointments();
                this._workSpace.option("allDayExpanded", this._isAllDayExpanded(this._filteredItems));
                if (this._isAgenda()) {
                    this.getRenderingStrategyInstance().calculateRows(this._filteredItems, 7, this.option("currentDate"), true)
                }
                if (this._filteredItems.length && this._isVisible()) {
                    this._appointments.option("items", this._getAppointmentsToRepaint());
                    this._appointmentModel.cleanModelState()
                } else {
                    this._appointments.option("items", [])
                }
            };
            _proto._getAppointmentsToRepaint = function() {
                var appointments = this._layoutManager.createAppointmentsMap(this._filteredItems);
                return this._layoutManager.getRepaintedAppointments(appointments, this.getAppointmentsInstance().option("items"))
            };
            _proto._initExpressions = function(fields) {
                var isDateField = function(field) {
                    return "startDate" === field || "endDate" === field
                };
                if (!this._dataAccessors) {
                    this._dataAccessors = {
                        getter: {},
                        setter: {},
                        expr: {}
                    }
                }(0, _iterator.each)(fields, function(name, expr) {
                    if (expr) {
                        var getter = (0, _data.compileGetter)(expr);
                        var setter = (0, _data.compileSetter)(expr);
                        var dateGetter;
                        var dateSetter;
                        if (isDateField(name)) {
                            var that = this;
                            dateGetter = function() {
                                var value = getter.apply(this, arguments);
                                if ((0, _config.default)().forceIsoDateParsing) {
                                    if (!that.option("dateSerializationFormat")) {
                                        var format = _date_serialization.default.getDateSerializationFormat(value);
                                        if (format) {
                                            that.option("dateSerializationFormat", format)
                                        }
                                    }
                                    value = _date_serialization.default.deserializeDate(value)
                                }
                                return value
                            };
                            dateSetter = function(object, value) {
                                if ((0, _config.default)().forceIsoDateParsing || that.option("dateSerializationFormat")) {
                                    value = _date_serialization.default.serializeDate(value, that.option("dateSerializationFormat"))
                                }
                                setter.call(this, object, value)
                            }
                        }
                        this._dataAccessors.getter[name] = dateGetter || getter;
                        this._dataAccessors.setter[name] = dateSetter || setter;
                        this._dataAccessors.expr[name + "Expr"] = expr
                    } else {
                        delete this._dataAccessors.getter[name];
                        delete this._dataAccessors.setter[name];
                        delete this._dataAccessors.expr[name + "Expr"]
                    }
                }.bind(this))
            };
            _proto._updateExpression = function(name, value) {
                var exprObj = {};
                exprObj[name.replace("Expr", "")] = value;
                this._initExpressions(exprObj)
            };
            _proto._initEditing = function() {
                var editing = this.option("editing");
                this._editing = {
                    allowAdding: !!editing,
                    allowUpdating: !!editing,
                    allowDeleting: !!editing,
                    allowResizing: !!editing,
                    allowDragging: !!editing
                };
                if ((0, _type.isObject)(editing)) {
                    this._editing = (0, _extend.extend)(this._editing, editing)
                }
                this._editing.allowDragging = this._editing.allowDragging && this._editing.allowUpdating;
                this._editing.allowResizing = this._editing.allowResizing && this._editing.allowUpdating;
                this.$element().toggleClass(WIDGET_READONLY_CLASS, this._isReadOnly())
            };
            _proto._isReadOnly = function() {
                var result = true;
                var editing = this._editing;
                for (var prop in editing) {
                    if (Object.prototype.hasOwnProperty.call(editing, prop)) {
                        result = result && !editing[prop]
                    }
                }
                return result
            };
            _proto._dispose = function() {
                this._appointmentTooltip && this._appointmentTooltip.dispose();
                this.hideAppointmentPopup();
                this.hideAppointmentTooltip();
                this._asyncTemplatesTimers.forEach(clearTimeout);
                this._asyncTemplatesTimers = [];
                _Widget.prototype._dispose.call(this)
            };
            _proto._initActions = function() {
                this._actions = {
                    onAppointmentAdding: this._createActionByOption(StoreEventNames.ADDING),
                    onAppointmentAdded: this._createActionByOption(StoreEventNames.ADDED),
                    onAppointmentUpdating: this._createActionByOption(StoreEventNames.UPDATING),
                    onAppointmentUpdated: this._createActionByOption(StoreEventNames.UPDATED),
                    onAppointmentDeleting: this._createActionByOption(StoreEventNames.DELETING),
                    onAppointmentDeleted: this._createActionByOption(StoreEventNames.DELETED),
                    onAppointmentFormOpening: this._createActionByOption("onAppointmentFormOpening")
                }
            };
            _proto._getAppointmentRenderedAction = function() {
                return this._createActionByOption("onAppointmentRendered", {
                    excludeValidators: ["disabled", "readOnly"]
                })
            };
            _proto._renderFocusTarget = function() {
                return (0, _common.noop)()
            };
            _proto._initMarkup = function() {
                _Widget.prototype._initMarkup.call(this);
                this.fire("validateDayHours");
                this._validateCellDuration();
                this._processCurrentView();
                this._renderHeader();
                this._layoutManager = new _uiSchedulerAppointments.default(this, this._getAppointmentsRenderingStrategy());
                this._appointments = this._createComponent("<div>", _uiScheduler.default, this._appointmentsConfig());
                this._appointments.option("itemTemplate", this._getAppointmentTemplate("appointmentTemplate"));
                this._appointmentTooltip = new(this.option("adaptivityEnabled") ? _mobileTooltipStrategy.MobileTooltipStrategy : _desktopTooltipStrategy.DesktopTooltipStrategy)(this._getAppointmentTooltipOptions());
                this._appointmentPopup = new _appointmentPopup.default(this);
                if (this._isLoaded() || this._isDataSourceLoading()) {
                    this._initMarkupCore(this._loadedResources);
                    this._dataSourceChangedHandler(this._dataSource.items());
                    this._fireContentReadyAction()
                } else {
                    this._loadResources().done(function(resources) {
                        this._initMarkupCore(resources);
                        this._reloadDataSource()
                    }.bind(this))
                }
            };
            _proto._getAppointmentTooltipOptions = function() {
                var _this5 = this;
                var that = this;
                return {
                    createComponent: that._createComponent.bind(that),
                    container: that.$element(),
                    getScrollableContainer: that.getWorkSpaceScrollableContainer.bind(that),
                    addDefaultTemplates: that._templateManager.addDefaultTemplates.bind(that._templateManager),
                    getAppointmentTemplate: that._getAppointmentTemplate.bind(that),
                    showAppointmentPopup: that.showAppointmentPopup.bind(that),
                    checkAndDeleteAppointment: that.checkAndDeleteAppointment.bind(that),
                    isAppointmentInAllDayPanel: that.isAppointmentInAllDayPanel.bind(that),
                    createFormattedDateText: function(appointment, targetedAppointment, format) {
                        return _this5.fire("getTextAndFormatDate", appointment, targetedAppointment, format)
                    },
                    getAppointmentDisabled: function(appointment) {
                        return _this5.createAppointmentAdapter(appointment).disabled
                    }
                }
            };
            _proto.checkAndDeleteAppointment = function(appointment, targetedAppointment) {
                var _this6 = this;
                var targetedAdapter = this.createAppointmentAdapter(targetedAppointment);
                this._checkRecurringAppointment(appointment, targetedAppointment, targetedAdapter.startDate, function() {
                    _this6.deleteAppointment(appointment)
                }, true)
            };
            _proto._getExtraAppointmentTooltipOptions = function() {
                return {
                    rtlEnabled: this.option("rtlEnabled"),
                    focusStateEnabled: this.option("focusStateEnabled"),
                    editing: this.option("editing"),
                    offset: this.option("_appointmentTooltipOffset")
                }
            };
            _proto.isAppointmentInAllDayPanel = function(appointmentData) {
                var workSpace = this._workSpace;
                var itTakesAllDay = this.appointmentTakesAllDay(appointmentData);
                return itTakesAllDay && workSpace.supportAllDayRow() && workSpace.option("showAllDayPanel")
            };
            _proto._initMarkupCore = function(resources) {
                var _this7 = this;
                this._readyToRenderAppointments = (0, _window.hasWindow)();
                this._workSpace && this._cleanWorkspace();
                this._renderWorkSpace(resources);
                this._appointments.option({
                    fixedContainer: this._workSpace.getFixedContainer(),
                    allDayContainer: this._workSpace.getAllDayContainer()
                });
                this._waitAsyncTemplate(function() {
                    var _this7$_workSpaceReca;
                    return null === (_this7$_workSpaceReca = _this7._workSpaceRecalculation) || void 0 === _this7$_workSpaceReca ? void 0 : _this7$_workSpaceReca.resolve()
                });
                this._filterAppointmentsByDate()
            };
            _proto._isLoaded = function() {
                return this._isResourcesLoaded() && this._isDataSourceLoaded()
            };
            _proto._isResourcesLoaded = function() {
                return (0, _type.isDefined)(this._loadedResources)
            };
            _proto._isDataSourceLoaded = function() {
                return this._dataSource && this._dataSource.isLoaded()
            };
            _proto._render = function() {
                this._toggleSmallClass();
                this._toggleAdaptiveClass();
                _Widget.prototype._render.call(this)
            };
            _proto._renderHeader = function() {
                var $header = (0, _renderer.default)("<div>").appendTo(this.$element());
                this._header = this._createComponent($header, _uiScheduler3.default, this._headerConfig())
            };
            _proto._headerConfig = function() {
                var _this8 = this;
                var currentViewOptions = this._getCurrentViewOptions();
                var countConfig = this._getViewCountConfig();
                var result = (0, _extend.extend)({
                    isAdaptive: this.option("adaptivityEnabled"),
                    firstDayOfWeek: this.option("firstDayOfWeek"),
                    currentView: this._currentView,
                    tabIndex: this.option("tabIndex"),
                    focusStateEnabled: this.option("focusStateEnabled"),
                    width: this.option("width"),
                    rtlEnabled: this.option("rtlEnabled"),
                    useDropDownViewSwitcher: this.option("useDropDownViewSwitcher"),
                    _dropDownButtonIcon: this.option("_dropDownButtonIcon"),
                    customizeDateNavigatorText: this.option("customizeDateNavigatorText")
                }, currentViewOptions);
                result.observer = this;
                result.intervalCount = countConfig.intervalCount;
                result.views = this.option("views");
                result.min = new Date(this._dateOption("min"));
                result.max = new Date(this._dateOption("max"));
                result.currentDate = _date.default.trimTime(new Date(this._dateOption("currentDate")));
                result.todayDate = function() {
                    var result = _this8.timeZoneCalculator.createDate(new Date, {
                        path: "toGrid"
                    });
                    return result
                };
                return result
            };
            _proto._appointmentsConfig = function() {
                var that = this;
                var config = {
                    observer: this,
                    onItemRendered: this._getAppointmentRenderedAction(),
                    onItemClick: this._createActionByOption("onAppointmentClick"),
                    onItemContextMenu: this._createActionByOption("onAppointmentContextMenu"),
                    onAppointmentDblClick: this._createActionByOption("onAppointmentDblClick"),
                    tabIndex: this.option("tabIndex"),
                    focusStateEnabled: this.option("focusStateEnabled"),
                    allowDrag: this._allowDragging(),
                    allowDelete: this._editing.allowUpdating && this._editing.allowDeleting,
                    allowResize: this._allowResizing(),
                    allowAllDayResize: this._allowAllDayResizing(),
                    rtlEnabled: this.option("rtlEnabled"),
                    currentView: this.option("currentView"),
                    onContentReady: function() {
                        that._workSpace && that._workSpace.option("allDayExpanded", that._isAllDayExpanded(that.getFilteredItems()))
                    }
                };
                return config
            };
            _proto.getCollectorOffset = function() {
                if (this._workSpace.needApplyCollectorOffset() && !this.option("adaptivityEnabled")) {
                    return this.option("_collectorOffset")
                } else {
                    return 0
                }
            };
            _proto.getAppointmentDurationInMinutes = function() {
                return this._getCurrentViewOption("cellDuration")
            };
            _proto._processCurrentView = function() {
                var views = this.option("views");
                var currentView = this.option("currentView");
                var that = this;
                this._currentView = currentView;
                (0, _iterator.each)(views, function(_, view) {
                    var isViewIsObject = (0, _type.isObject)(view);
                    var viewName = isViewIsObject ? view.name : view;
                    var viewType = view.type;
                    if (currentView === viewName || currentView === viewType) {
                        that._currentView = view;
                        return false
                    }
                })
            };
            _proto._validateCellDuration = function() {
                var endDayHour = this._getCurrentViewOption("endDayHour");
                var startDayHour = this._getCurrentViewOption("startDayHour");
                var cellDuration = this._getCurrentViewOption("cellDuration");
                if ((endDayHour - startDayHour) * MINUTES_IN_HOUR % cellDuration !== 0) {
                    _ui.default.log("W1015")
                }
            };
            _proto._getCurrentViewType = function() {
                return this._currentView.type || this._currentView
            };
            _proto._getAppointmentsRenderingStrategy = function() {
                return VIEWS_CONFIG[this._getCurrentViewType()].renderingStrategy
            };
            _proto._renderWorkSpace = function(groups) {
                this._readyToRenderAppointments && this._toggleSmallClass();
                var $workSpace = (0, _renderer.default)("<div>").appendTo(this.$element());
                var countConfig = this._getViewCountConfig();
                var workSpaceComponent = VIEWS_CONFIG[this._getCurrentViewType()].workSpace;
                var workSpaceConfig = this._workSpaceConfig(groups, countConfig);
                this._workSpace = this._createComponent($workSpace, workSpaceComponent, workSpaceConfig);
                this._allowDragging() && this._workSpace.initDragBehavior(this, this._all);
                this._workSpace._attachTablesEvents();
                this._workSpace.getWorkArea().append(this._appointments.$element());
                this._recalculateWorkspace();
                countConfig.startDate && this._header && this._header.option("currentDate", this._workSpace._getHeaderDate());
                this._appointments.option("_collectorOffset", this.getCollectorOffset())
            };
            _proto._getViewCountConfig = function() {
                var currentView = this.option("currentView");
                var view = this._getViewByName(currentView);
                var viewCount = view && view.intervalCount || 1;
                var startDate = view && view.startDate || null;
                return {
                    intervalCount: viewCount,
                    startDate: startDate
                }
            };
            _proto._getViewByName = function(name) {
                var views = this.option("views");
                for (var i = 0; i < views.length; i++) {
                    if (views[i].name === name || views[i].type === name || views[i] === name) {
                        return views[i]
                    }
                }
            };
            _proto._recalculateWorkspace = function() {
                var _this9 = this;
                this._workSpaceRecalculation = new _deferred.Deferred;
                this._waitAsyncTemplate(function() {
                    (0, _visibility_change.triggerResizeEvent)(_this9._workSpace.$element());
                    _this9._workSpace._refreshDateTimeIndication()
                })
            };
            _proto._workSpaceConfig = function(groups, countConfig) {
                var _currentViewOptions$s, _this10 = this;
                var currentViewOptions = this._getCurrentViewOptions();
                var scrolling = this.option("scrolling");
                var result = (0, _extend.extend)({
                    noDataText: this.option("noDataText"),
                    firstDayOfWeek: this.option("firstDayOfWeek"),
                    startDayHour: this.option("startDayHour"),
                    endDayHour: this.option("endDayHour"),
                    tabIndex: this.option("tabIndex"),
                    accessKey: this.option("accessKey"),
                    focusStateEnabled: this.option("focusStateEnabled"),
                    cellDuration: this.option("cellDuration"),
                    showAllDayPanel: this.option("showAllDayPanel"),
                    showCurrentTimeIndicator: this.option("showCurrentTimeIndicator"),
                    indicatorTime: this.option("indicatorTime"),
                    indicatorUpdateInterval: this.option("indicatorUpdateInterval"),
                    shadeUntilCurrentTime: this.option("shadeUntilCurrentTime"),
                    allDayExpanded: this._appointments.option("items"),
                    crossScrollingEnabled: this.option("crossScrollingEnabled"),
                    dataCellTemplate: this.option("dataCellTemplate"),
                    timeCellTemplate: this.option("timeCellTemplate"),
                    resourceCellTemplate: this.option("resourceCellTemplate"),
                    dateCellTemplate: this.option("dateCellTemplate"),
                    allowMultipleCellSelection: this.option("allowMultipleCellSelection"),
                    selectedCellData: this.option("selectedCellData"),
                    onSelectionChanged: function(args) {
                        _this10.option("selectedCellData", args.selectedCellData)
                    },
                    groupByDate: this._getCurrentViewOption("groupByDate"),
                    scrolling: scrolling,
                    renovateRender: this.option("renovateRender") || "virtual" === scrolling.mode || "virtual" === (null === (_currentViewOptions$s = currentViewOptions.scrolling) || void 0 === _currentViewOptions$s ? void 0 : _currentViewOptions$s.mode)
                }, currentViewOptions);
                result.observer = this;
                result.intervalCount = countConfig.intervalCount;
                result.startDate = countConfig.startDate;
                result.groups = groups;
                result.onCellClick = this._createActionByOption("onCellClick");
                result.onCellContextMenu = this._createActionByOption("onCellContextMenu");
                result.min = new Date(this._dateOption("min"));
                result.max = new Date(this._dateOption("max"));
                result.currentDate = _date.default.trimTime(new Date(this._dateOption("currentDate")));
                result.hoursInterval = result.cellDuration / 60;
                result.allDayExpanded = this._isAllDayExpanded(this.getFilteredItems());
                result.dataCellTemplate = result.dataCellTemplate ? this._getTemplate(result.dataCellTemplate) : null;
                result.timeCellTemplate = result.timeCellTemplate ? this._getTemplate(result.timeCellTemplate) : null;
                result.resourceCellTemplate = result.resourceCellTemplate ? this._getTemplate(result.resourceCellTemplate) : null;
                result.dateCellTemplate = result.dateCellTemplate ? this._getTemplate(result.dateCellTemplate) : null;
                return result
            };
            _proto._waitAsyncTemplate = function(callback) {
                if (this._options.silent("templatesRenderAsynchronously")) {
                    var timer = setTimeout(function() {
                        callback();
                        clearTimeout(timer)
                    });
                    this._asyncTemplatesTimers.push(timer)
                } else {
                    callback()
                }
            };
            _proto._getCurrentViewOptions = function() {
                return this._currentView
            };
            _proto._getCurrentViewOption = function(optionName) {
                var currentViewOptions = this._getCurrentViewOptions();
                if (currentViewOptions && void 0 !== currentViewOptions[optionName]) {
                    return currentViewOptions[optionName]
                }
                return this.option(optionName)
            };
            _proto._getAppointmentTemplate = function(optionName) {
                var currentViewOptions = this._getCurrentViewOptions();
                if (currentViewOptions && currentViewOptions[optionName]) {
                    return this._getTemplate(currentViewOptions[optionName])
                }
                return this._getTemplateByOption(optionName)
            };
            _proto._updateOption = function(viewName, optionName, value) {
                var currentViewOptions = this._getCurrentViewOptions();
                if (!currentViewOptions || !(0, _type.isDefined)(currentViewOptions[optionName])) {
                    this["_" + viewName].option(optionName, value)
                }
            };
            _proto._refreshWorkSpace = function(groups) {
                var _this11 = this;
                this._cleanWorkspace();
                delete this._workSpace;
                this._renderWorkSpace(groups);
                if (this._readyToRenderAppointments) {
                    this._appointments.option({
                        fixedContainer: this._workSpace.getFixedContainer(),
                        allDayContainer: this._workSpace.getAllDayContainer()
                    });
                    this._waitAsyncTemplate(function() {
                        return _this11._workSpaceRecalculation.resolve()
                    })
                }
            };
            _proto._cleanWorkspace = function() {
                this._appointments.$element().detach();
                this._workSpace._dispose();
                this._workSpace.$element().remove();
                this.option("selectedCellData", [])
            };
            _proto.getWorkSpaceScrollable = function() {
                return this._workSpace.getScrollable()
            };
            _proto.getWorkSpaceScrollableScrollTop = function(allDay) {
                return this._workSpace.getGroupedScrollableScrollTop(allDay)
            };
            _proto.getWorkSpaceScrollableScrollLeft = function() {
                return this._workSpace.getScrollableScrollLeft()
            };
            _proto.getWorkSpaceScrollableContainer = function() {
                return this._workSpace.getScrollableContainer()
            };
            _proto.getWorkSpaceAllDayHeight = function() {
                return this._workSpace.getAllDayHeight()
            };
            _proto.getWorkSpaceAllDayOffset = function() {
                return this._workSpace.getAllDayOffset()
            };
            _proto.getWorkSpaceHeaderPanelHeight = function() {
                return this._workSpace.getHeaderPanelHeight()
            };
            _proto.getWorkSpaceDateTableOffset = function() {
                return !this.option("crossScrollingEnabled") || this.option("rtlEnabled") ? this._workSpace.getWorkSpaceLeftOffset() : 0
            };
            _proto.getWorkSpace = function() {
                return this._workSpace
            };
            _proto.getAppointmentModel = function() {
                return this._appointmentModel
            };
            _proto.getHeader = function() {
                return this._header
            };
            _proto.getMaxAppointmentsPerCell = function() {
                return this._getCurrentViewOption("maxAppointmentsPerCell")
            };
            _proto._cleanPopup = function() {
                this._appointmentPopup && this._appointmentPopup.dispose()
            };
            _proto._checkRecurringAppointment = function(targetAppointment, singleAppointment, exceptionDate, callback, isDeleted, isPopupEditing, dragEvent) {
                var _this12 = this;
                delete this._updatedRecAppointment;
                var recurrenceRule = this.fire("getField", "recurrenceRule", targetAppointment);
                if (!(0, _recurrence.getRecurrenceProcessor)().evalRecurrenceRule(recurrenceRule).isValid || !this._editing.allowUpdating) {
                    callback();
                    return
                }
                var editMode = this.option("recurrenceEditMode");
                switch (editMode) {
                    case "series":
                        callback();
                        break;
                    case "occurrence":
                        this._excludeAppointmentFromSeries(targetAppointment, singleAppointment, exceptionDate, isDeleted, isPopupEditing, dragEvent);
                        break;
                    default:
                        if (dragEvent) {
                            dragEvent.cancel = new _deferred.Deferred
                        }
                        this._showRecurrenceChangeConfirm(isDeleted).done(function(result) {
                            result && callback();
                            !result && _this12._excludeAppointmentFromSeries(targetAppointment, singleAppointment, exceptionDate, isDeleted, isPopupEditing, dragEvent)
                        }).fail(function() {
                            return _this12._appointments.moveAppointmentBack(dragEvent)
                        })
                }
            };
            _proto._excludeAppointmentFromSeries = function(rawAppointment, newRawAppointment, exceptionDate, isDeleted, isPopupEditing, dragEvent) {
                var _this13 = this;
                var appointment = this.createAppointmentAdapter(_objectSpread({}, rawAppointment));
                var newAppointment = this.createAppointmentAdapter(newRawAppointment);
                newAppointment.recurrenceRule = "";
                newAppointment.recurrenceException = "";
                var canCreateNewAppointment = !isDeleted && !isPopupEditing;
                if (canCreateNewAppointment) {
                    var keyPropertyName = this._appointmentModel.keyName;
                    delete newRawAppointment[keyPropertyName];
                    this.addAppointment(newRawAppointment)
                }
                appointment.recurrenceException = this._createRecurrenceException(appointment, exceptionDate);
                if (isPopupEditing) {
                    this._updatedRecAppointment = appointment.source();
                    this._appointmentPopup.show(newRawAppointment, true);
                    this._editAppointmentData = rawAppointment
                } else {
                    this._updateAppointment(rawAppointment, appointment.source(), function() {
                        _this13._appointments.moveAppointmentBack(dragEvent)
                    }, dragEvent)
                }
            };
            _proto._createRecurrenceException = function(appointment, exceptionDate) {
                var result = [];
                if (appointment.recurrenceException) {
                    result.push(appointment.recurrenceException)
                }
                result.push(this._getSerializedDate(exceptionDate, appointment.startDate, appointment.allDay));
                return result.join()
            };
            _proto._getSerializedDate = function(date, startDate, isAllDay) {
                isAllDay && date.setHours(startDate.getHours(), startDate.getMinutes(), startDate.getSeconds(), startDate.getMilliseconds());
                return _date_serialization.default.serializeDate(date, UTC_FULL_DATE_FORMAT)
            };
            _proto._showRecurrenceChangeConfirm = function(isDeleted) {
                var message = _message.default.format(isDeleted ? "dxScheduler-confirmRecurrenceDeleteMessage" : "dxScheduler-confirmRecurrenceEditMessage");
                var seriesText = _message.default.format(isDeleted ? "dxScheduler-confirmRecurrenceDeleteSeries" : "dxScheduler-confirmRecurrenceEditSeries");
                var occurrenceText = _message.default.format(isDeleted ? "dxScheduler-confirmRecurrenceDeleteOccurrence" : "dxScheduler-confirmRecurrenceEditOccurrence");
                return (0, _dialog.custom)({
                    messageHtml: message,
                    showCloseButton: true,
                    showTitle: true,
                    buttons: [{
                        text: seriesText,
                        onClick: function() {
                            return true
                        }
                    }, {
                        text: occurrenceText,
                        onClick: function() {
                            return false
                        }
                    }]
                }).show()
            };
            _proto._getUpdatedData = function(rawAppointment) {
                var _this14 = this;
                var getConvertedFromGrid = function(date) {
                    return date ? _this14.timeZoneCalculator.createDate(date, {
                        path: "fromGrid"
                    }) : void 0
                };
                var isValidDate = function(date) {
                    return !isNaN(new Date(date).getTime())
                };
                var targetCell = this.getTargetCellData();
                var appointment = this.createAppointmentAdapter(rawAppointment);
                var cellStartDate = getConvertedFromGrid(targetCell.startDate);
                var cellEndDate = getConvertedFromGrid(targetCell.endDate);
                var appointmentStartDate = new Date(appointment.startDate);
                var appointmentEndDate = new Date(appointment.endDate);
                var resultedStartDate = cellStartDate || appointmentStartDate;
                if (!isValidDate(appointmentStartDate)) {
                    appointmentStartDate = resultedStartDate
                }
                if (!isValidDate(appointmentEndDate)) {
                    appointmentEndDate = cellEndDate
                }
                var duration = appointmentEndDate.getTime() - appointmentStartDate.getTime();
                var isKeepAppointmentHours = this._workSpace.keepOriginalHours() && isValidDate(appointment.startDate) && isValidDate(cellStartDate);
                if (isKeepAppointmentHours) {
                    var trimTime = _date.default.trimTime;
                    var startDate = this.timeZoneCalculator.createDate(appointment.startDate, {
                        path: "toGrid"
                    });
                    var timeInMs = startDate.getTime() - trimTime(startDate).getTime();
                    resultedStartDate = new Date(trimTime(targetCell.startDate).getTime() + timeInMs);
                    resultedStartDate = this.timeZoneCalculator.createDate(resultedStartDate, {
                        path: "fromGrid"
                    })
                }
                var result = this.createAppointmentAdapter({});
                if (void 0 !== targetCell.allDay) {
                    result.allDay = targetCell.allDay
                }
                result.startDate = resultedStartDate;
                var resultedEndDate = new Date(resultedStartDate.getTime() + duration);
                if (this.appointmentTakesAllDay(rawAppointment) && !result.allDay && this._workSpace.supportAllDayRow()) {
                    resultedEndDate = this._workSpace.calculateEndDate(resultedStartDate)
                }
                if (appointment.allDay && !this._workSpace.supportAllDayRow() && !this._workSpace.keepOriginalHours()) {
                    var dateCopy = new Date(resultedStartDate);
                    dateCopy.setHours(0);
                    resultedEndDate = new Date(dateCopy.getTime() + duration);
                    if (0 !== resultedEndDate.getHours()) {
                        resultedEndDate.setHours(this._getCurrentViewOption("endDayHour"))
                    }
                }
                var timeZoneOffset = _utils.default.getTimezoneOffsetChangeInMs(appointmentStartDate, appointmentEndDate, resultedStartDate, resultedEndDate);
                result.endDate = new Date(resultedEndDate.getTime() - timeZoneOffset);
                var rawResult = result.source();
                this._resourcesManager.setResourcesToItem(rawResult, targetCell.groups);
                return rawResult
            };
            _proto.getTargetedAppointment = function(appointment, element) {
                var settings = _utils2.default.dataAccessors.getAppointmentSettings(element);
                var info = _utils2.default.dataAccessors.getAppointmentInfo(element);
                var appointmentIndex = (0, _renderer.default)(element).data(this._appointments._itemIndexKey());
                var adapter = this.createAppointmentAdapter(appointment);
                var targetedAdapter = adapter.clone();
                if (this._isAgenda() && adapter.isRecurrent) {
                    var getStartDate = this.getRenderingStrategyInstance().getAppointmentDataCalculator();
                    var newStartDate = getStartDate((0, _renderer.default)(element), adapter.startDate).startDate;
                    targetedAdapter.startDate = newStartDate;
                    targetedAdapter.endDate = new Date(newStartDate.getTime() + adapter.duration)
                } else {
                    if (settings) {
                        targetedAdapter.startDate = info ? info.sourceAppointment.startDate : adapter.startDate;
                        targetedAdapter.endDate = info ? info.sourceAppointment.endDate : adapter.endDate
                    }
                }
                var rawTargetedAppointment = targetedAdapter.source();
                if (element) {
                    this.setTargetedAppointmentResources(rawTargetedAppointment, element, appointmentIndex)
                }
                return rawTargetedAppointment
            };
            _proto.subscribe = function(subject, action) {
                this._subscribes[subject] = _uiScheduler5.default[subject] = action
            };
            _proto.fire = function(subject) {
                var callback = this._subscribes[subject];
                var args = Array.prototype.slice.call(arguments);
                if (!(0, _type.isFunction)(callback)) {
                    throw _ui.default.Error("E1031", subject)
                }
                return callback.apply(this, args.slice(1))
            };
            _proto.getTargetCellData = function() {
                return this._workSpace.getDataByDroppableCell()
            };
            _proto._updateAppointment = function(target, rawAppointment, onUpdatePrevented, dragEvent) {
                var updatingOptions = {
                    newData: rawAppointment,
                    oldData: (0, _extend.extend)({}, target),
                    cancel: false
                };
                var performFailAction = function(err) {
                    if (onUpdatePrevented) {
                        onUpdatePrevented.call(this)
                    }
                    if (err && "Error" === err.name) {
                        throw err
                    }
                }.bind(this);
                this._actions[StoreEventNames.UPDATING](updatingOptions);
                if (dragEvent && !(0, _type.isDeferred)(dragEvent.cancel)) {
                    dragEvent.cancel = new _deferred.Deferred
                }
                return this._processActionResult(updatingOptions, function(canceled) {
                    var _this15 = this;
                    var deferred = new _deferred.Deferred;
                    if (!canceled) {
                        this._expandAllDayPanel(rawAppointment);
                        try {
                            deferred = this._appointmentModel.update(target, rawAppointment).done(function() {
                                dragEvent && dragEvent.cancel.resolve(false)
                            }).always(function(storeAppointment) {
                                return _this15._onDataPromiseCompleted(StoreEventNames.UPDATED, storeAppointment)
                            }).fail(function() {
                                return performFailAction()
                            })
                        } catch (err) {
                            performFailAction(err);
                            deferred.resolve()
                        }
                    } else {
                        performFailAction();
                        deferred.resolve()
                    }
                    return deferred.promise()
                })
            };
            _proto._processActionResult = function(actionOptions, callback) {
                var _this16 = this;
                var deferred = new _deferred.Deferred;
                var resolveCallback = function(callbackResult) {
                    (0, _deferred.when)((0, _deferred.fromPromise)(callbackResult)).always(deferred.resolve)
                };
                if ((0, _type.isPromise)(actionOptions.cancel)) {
                    (0, _deferred.when)((0, _deferred.fromPromise)(actionOptions.cancel)).always(function(cancel) {
                        if (!(0, _type.isDefined)(cancel)) {
                            cancel = "rejected" === actionOptions.cancel.state()
                        }
                        resolveCallback(callback.call(_this16, cancel))
                    })
                } else {
                    resolveCallback(callback.call(this, actionOptions.cancel))
                }
                return deferred.promise()
            };
            _proto._expandAllDayPanel = function(appointment) {
                if (!this._isAllDayExpanded(this.getFilteredItems()) && this.appointmentTakesAllDay(appointment)) {
                    this._workSpace.option("allDayExpanded", true)
                }
            };
            _proto._onDataPromiseCompleted = function(handlerName, storeAppointment, appointment) {
                var args = {
                    appointmentData: appointment || storeAppointment
                };
                if (storeAppointment instanceof Error) {
                    args.error = storeAppointment
                } else {
                    this._appointmentPopup.isVisible() && this._appointmentPopup.hide()
                }
                this._actions[handlerName](args);
                this._fireContentReadyAction()
            };
            _proto.getAppointmentPopup = function() {
                return this._appointmentPopup.getPopup()
            };
            _proto.getUpdatedAppointment = function() {
                return this._appointmentModel.getUpdatedAppointment()
            };
            _proto.getUpdatedAppointmentKeys = function() {
                return this._appointmentModel.getUpdatedAppointmentKeys()
            };
            _proto.getAppointmentsInstance = function() {
                return this._appointments
            };
            _proto.getResourceManager = function() {
                return this._resourcesManager
            };
            _proto.getLayoutManager = function() {
                return this._layoutManager
            };
            _proto.getRenderingStrategyInstance = function() {
                return this._layoutManager.getRenderingStrategyInstance()
            };
            _proto.getFilteredItems = function() {
                return this._filteredItems
            };
            _proto.getActions = function() {
                return this._actions
            };
            _proto.appointmentTakesAllDay = function(appointment) {
                return this._appointmentModel.appointmentTakesAllDay(appointment, this._getCurrentViewOption("startDayHour"), this._getCurrentViewOption("endDayHour"))
            };
            _proto._getRecurrenceException = function(rawAppointment) {
                var appointment = this.createAppointmentAdapter(rawAppointment);
                var recurrenceException = appointment.recurrenceException;
                if (recurrenceException) {
                    var exceptions = recurrenceException.split(",");
                    for (var i = 0; i < exceptions.length; i++) {
                        exceptions[i] = this._convertRecurrenceException(exceptions[i], appointment.startDate)
                    }
                    return exceptions.join()
                }
                return recurrenceException
            };
            _proto._convertRecurrenceException = function(exceptionString, startDate) {
                var _this17 = this;
                exceptionString = exceptionString.replace(/\s/g, "");
                var getConvertedToTimeZone = function(date) {
                    return _this17.timeZoneCalculator.createDate(date, {
                        path: "toGrid"
                    })
                };
                var exceptionDate = _date_serialization.default.deserializeDate(exceptionString);
                var convertedStartDate = getConvertedToTimeZone(startDate);
                var convertedExceptionDate = getConvertedToTimeZone(exceptionDate);
                convertedExceptionDate = _utils.default.correctRecurrenceExceptionByTimezone(convertedExceptionDate, convertedStartDate, this.option("timeZone"));
                exceptionString = _date_serialization.default.serializeDate(convertedExceptionDate, FULL_DATE_FORMAT);
                return exceptionString
            };
            _proto.dayHasAppointment = function(day, rawAppointment, trimTime) {
                var _this18 = this;
                var getConvertedToTimeZone = function(date) {
                    return _this18.timeZoneCalculator.createDate(date, {
                        path: "toGrid"
                    })
                };
                var appointment = this.createAppointmentAdapter(rawAppointment);
                var startDate = new Date(appointment.startDate);
                var endDate = new Date(appointment.endDate);
                startDate = getConvertedToTimeZone(startDate);
                endDate = getConvertedToTimeZone(endDate);
                if (day.getTime() === endDate.getTime()) {
                    return startDate.getTime() === endDate.getTime()
                }
                if (trimTime) {
                    day = _date.default.trimTime(day);
                    startDate = _date.default.trimTime(startDate);
                    endDate = _date.default.trimTime(endDate)
                }
                var dayTimeStamp = day.getTime();
                var startDateTimeStamp = startDate.getTime();
                var endDateTimeStamp = endDate.getTime();
                return (0, _array.inArray)(dayTimeStamp, [startDateTimeStamp, endDateTimeStamp]) > -1 || startDateTimeStamp < dayTimeStamp && endDateTimeStamp > dayTimeStamp
            };
            _proto.setTargetedAppointmentResources = function(rawAppointment, element, appointmentIndex) {
                var groups = this._getCurrentViewOption("groups");
                if (null !== groups && void 0 !== groups && groups.length) {
                    var resourcesSetter = this._resourcesManager._dataAccessors.setter;
                    var workSpace = this._workSpace;
                    var getGroups;
                    var setResourceCallback;
                    if (this._isAgenda()) {
                        getGroups = function() {
                            var apptSettings = this.getLayoutManager()._positionMap[appointmentIndex];
                            return workSpace._getCellGroups(apptSettings[0].groupIndex)
                        };
                        setResourceCallback = function(_, group) {
                            resourcesSetter[group.name](rawAppointment, group.id)
                        }
                    } else {
                        getGroups = function() {
                            var setting = _utils2.default.dataAccessors.getAppointmentSettings(element) || {};
                            return workSpace.getCellDataByCoordinates({
                                left: setting.left,
                                top: setting.top
                            }).groups
                        };
                        setResourceCallback = function(field, value) {
                            resourcesSetter[field](rawAppointment, value)
                        }
                    }(0, _iterator.each)(getGroups.call(this), setResourceCallback)
                }
            };
            _proto.getStartViewDate = function() {
                return this._workSpace.getStartViewDate()
            };
            _proto.getEndViewDate = function() {
                return this._workSpace.getEndViewDate()
            };
            _proto.showAppointmentPopup = function(rawAppointment, createNewAppointment, rawTargetedAppointment) {
                var _this19 = this;
                var appointment = this.createAppointmentAdapter(rawTargetedAppointment || rawAppointment);
                var newTargetedAppointment = (0, _extend.extend)({}, rawAppointment, rawTargetedAppointment);
                this._checkRecurringAppointment(rawAppointment, newTargetedAppointment, appointment.startDate, function() {
                    if (createNewAppointment || (0, _type.isEmptyObject)(rawAppointment)) {
                        delete _this19._editAppointmentData;
                        _this19._editing.allowAdding && _this19._appointmentPopup.show(rawAppointment, true)
                    } else {
                        _this19._editAppointmentData = rawAppointment;
                        _this19._appointmentPopup.show(rawAppointment, _this19._editing.allowUpdating)
                    }
                }, false, true)
            };
            _proto.hideAppointmentPopup = function(saveChanges) {
                if (this._appointmentPopup && this._appointmentPopup.isVisible()) {
                    saveChanges && this._appointmentPopup.saveChanges();
                    this._appointmentPopup.hide()
                }
            };
            _proto.showAppointmentTooltip = function(appointment, target, targetedAppointment) {
                if (appointment) {
                    var info = new _dataStructures.AppointmentTooltipInfo(appointment, targetedAppointment, this._appointments._tryGetAppointmentColor(target));
                    this.showAppointmentTooltipCore(target, [info])
                }
            };
            _proto.showAppointmentTooltipCore = function(target, data, options) {
                if (this._appointmentTooltip.isAlreadyShown(target)) {
                    this.hideAppointmentTooltip()
                } else {
                    this._appointmentTooltip.show(target, data, (0, _extend.extend)(this._getExtraAppointmentTooltipOptions(), options))
                }
            };
            _proto.hideAppointmentTooltip = function() {
                this._appointmentTooltip && this._appointmentTooltip.hide()
            };
            _proto.scrollToTime = function(hours, minutes, date) {
                this._workSpace.scrollToTime(hours, minutes, date)
            };
            _proto.scrollTo = function(date, groups, allDay) {
                this._workSpace.scrollTo(date, groups, allDay)
            };
            _proto.addAppointment = function(rawAppointment) {
                var _this20 = this;
                var appointment = this.createAppointmentAdapter(rawAppointment);
                appointment.text = appointment.text || "";
                var serializedAppointment = appointment.source(true);
                var addingOptions = {
                    appointmentData: serializedAppointment,
                    cancel: false
                };
                this._actions[StoreEventNames.ADDING](addingOptions);
                return this._processActionResult(addingOptions, function(canceled) {
                    if (canceled) {
                        return (new _deferred.Deferred).resolve()
                    }
                    _this20._expandAllDayPanel(serializedAppointment);
                    return _this20._appointmentModel.add(serializedAppointment).always(function(storeAppointment) {
                        return _this20._onDataPromiseCompleted(StoreEventNames.ADDED, storeAppointment)
                    })
                })
            };
            _proto.updateAppointment = function(target, appointment) {
                return this._updateAppointment(target, appointment)
            };
            _proto.deleteAppointment = function(rawAppointment) {
                var deletingOptions = {
                    appointmentData: rawAppointment,
                    cancel: false
                };
                this._actions[StoreEventNames.DELETING](deletingOptions);
                this._processActionResult(deletingOptions, function(canceled) {
                    var _this21 = this;
                    if (!canceled) {
                        this._appointmentModel.remove(rawAppointment).always(function(storeAppointment) {
                            return _this21._onDataPromiseCompleted(StoreEventNames.DELETED, storeAppointment, rawAppointment)
                        })
                    }
                })
            };
            _proto.focus = function() {
                if (this._editAppointmentData) {
                    this._appointments.focus()
                } else {
                    this._workSpace.focus()
                }
            };
            _proto.getFirstDayOfWeek = function() {
                return (0, _type.isDefined)(this.option("firstDayOfWeek")) ? this.option("firstDayOfWeek") : _date2.default.firstDayOfWeekIndex()
            };
            _proto.createAppointmentAdapter = function(rawAppointment) {
                var _this22 = this;
                var options = {
                    getField: function(rawAppointment, property) {
                        return _this22.fire("getField", property, rawAppointment)
                    },
                    setField: function(rawAppointment, property, value) {
                        return _this22.fire("setField", property, rawAppointment, value)
                    },
                    getTimeZoneCalculator: function() {
                        return _this22.timeZoneCalculator
                    }
                };
                return new _appointmentAdapter.default(rawAppointment, options)
            };
            return Scheduler
        }(_ui2.default);
        Scheduler.include(_data_helper.default);
        (0, _component_registrator.default)("dxScheduler", Scheduler);
        var _default = Scheduler;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/appointmentPopup.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _visibility_change = __webpack_require__( /*! ../../events/visibility_change */ 59);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _popup = _interopRequireDefault(__webpack_require__( /*! ../popup */ 46));
        var _uiScheduler = __webpack_require__( /*! ./ui.scheduler.appointment_form */ 788);
        var _ui = __webpack_require__( /*! ./ui.loading */ 434);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var toMs = _date.default.dateToMilliseconds;
        var WIDGET_CLASS = "dx-scheduler";
        var APPOINTMENT_POPUP_CLASS = "".concat(WIDGET_CLASS, "-appointment-popup");
        var APPOINTMENT_POPUP_WIDTH = 485;
        var APPOINTMENT_POPUP_WIDTH_WITH_RECURRENCE = 970;
        var APPOINTMENT_POPUP_FULLSCREEN_WINDOW_WIDTH = 1e3;
        var APPOINTMENT_POPUP_FULLSCREEN_WINDOW_WIDTH_MOBILE = 500;
        var APPOINTMENT_POPUP_WIDTH_MOBILE = 350;
        var TOOLBAR_ITEM_AFTER_LOCATION = "after";
        var TOOLBAR_ITEM_BEFORE_LOCATION = "before";
        var DAY_IN_MS = toMs("day");
        var AppointmentPopup = function() {
            function AppointmentPopup(scheduler) {
                this.scheduler = scheduler;
                this._popup = null;
                this._appointmentForm = null;
                this.state = {
                    lastEditData: null,
                    saveChangesLocker: false,
                    appointment: {
                        data: null,
                        isEmptyText: false,
                        isEmptyDescription: false
                    }
                }
            }
            var _proto = AppointmentPopup.prototype;
            _proto.show = function() {
                var data = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                var isDoneButtonVisible = arguments.length > 1 ? arguments[1] : void 0;
                if ((0, _type.isEmptyObject)(data)) {
                    var startDate = this.scheduler.option("currentDate");
                    var endDate = new Date(startDate.getTime() + this.scheduler.option("cellDuration") * toMs("minute"));
                    this.scheduler.fire("setField", "startDate", data, startDate);
                    this.scheduler.fire("setField", "endDate", data, endDate)
                }
                this.state.appointment.data = data;
                if (!this._popup) {
                    var popupConfig = this._createPopupConfig();
                    this._popup = this._createPopup(popupConfig)
                }
                this._popup.option("toolbarItems", this._createPopupToolbarItems(isDoneButtonVisible));
                this._popup.show()
            };
            _proto.hide = function() {
                this._popup.hide()
            };
            _proto.isVisible = function() {
                return this._popup ? this._popup.option("visible") : false
            };
            _proto.dispose = function() {
                if (this._$popup) {
                    this._popup.$element().remove();
                    this._$popup = null
                }
            };
            _proto._createPopup = function(options) {
                var popupElement = (0, _renderer.default)("<div>").addClass(APPOINTMENT_POPUP_CLASS).appendTo(this.scheduler.$element());
                return this.scheduler._createComponent(popupElement, _popup.default, options)
            };
            _proto._createPopupConfig = function() {
                var _this = this;
                return {
                    height: "auto",
                    maxHeight: "100%",
                    showCloseButton: false,
                    showTitle: false,
                    onHiding: function() {
                        _this.scheduler.focus()
                    },
                    contentTemplate: function() {
                        return _this._createPopupContent()
                    },
                    onShowing: function(e) {
                        return _this._onShowing(e)
                    },
                    defaultOptionsRules: [{
                        device: function() {
                            return _devices.default.current().android
                        },
                        options: {
                            showTitle: false
                        }
                    }]
                }
            };
            _proto._onShowing = function(e) {
                var _this2 = this;
                this._updateForm();
                var arg = {
                    form: this._appointmentForm,
                    popup: this._popup,
                    appointmentData: this.state.appointment.data,
                    cancel: false
                };
                this.scheduler._actions.onAppointmentFormOpening(arg);
                this.scheduler._processActionResult(arg, function(canceled) {
                    if (canceled) {
                        e.cancel = true
                    } else {
                        _this2.updatePopupFullScreenMode()
                    }
                })
            };
            _proto._createPopupContent = function() {
                var formElement = (0, _renderer.default)("<div>");
                this._appointmentForm = this._createForm(formElement);
                return formElement
            };
            _proto._createAppointmentFormData = function(rawAppointment) {
                var appointment = this._createAppointmentAdapter(rawAppointment);
                var result = (0, _extend.extend)(true, {
                    repeat: !!appointment.recurrenceRule
                }, rawAppointment);
                (0, _iterator.each)(this.scheduler._resourcesManager.getResourcesFromItem(result, true) || {}, function(name, value) {
                    return result[name] = value
                });
                return result
            };
            _proto._createForm = function(element) {
                var expr = this.scheduler._dataAccessors.expr;
                var resources = this.scheduler.option("resources");
                var allowTimeZoneEditing = this._getAllowTimeZoneEditing();
                var rawAppointment = this.state.appointment.data;
                var formData = this._createAppointmentFormData(rawAppointment);
                var readOnly = this._isReadOnly(rawAppointment);
                _uiScheduler.AppointmentForm.prepareAppointmentFormEditors(expr, this.scheduler, this.triggerResize.bind(this), this.changeSize.bind(this), formData, allowTimeZoneEditing, readOnly);
                if (resources && resources.length) {
                    _uiScheduler.AppointmentForm.concatResources(this.scheduler._resourcesManager.getEditors())
                }
                return _uiScheduler.AppointmentForm.create(this.scheduler._createComponent.bind(this.scheduler), element, readOnly, formData)
            };
            _proto._getAllowTimeZoneEditing = function() {
                var scheduler = this.scheduler;
                return scheduler.option("editing.allowTimeZoneEditing") || scheduler.option("editing.allowEditingTimeZones")
            };
            _proto._isReadOnly = function(rawAppointment) {
                var adapter = this.scheduler.createAppointmentAdapter(rawAppointment);
                if (rawAppointment && adapter.disabled) {
                    return true
                }
                return this.scheduler._editAppointmentData ? !this.scheduler._editing.allowUpdating : false
            };
            _proto._createAppointmentAdapter = function(rawAppointment) {
                return this.scheduler.createAppointmentAdapter(rawAppointment)
            };
            _proto._updateForm = function() {
                var data = this.state.appointment.data;
                var adapter = this._createAppointmentAdapter(data);
                var allDay = adapter.allDay;
                var startDate = adapter.startDate && adapter.calculateStartDate("toAppointment");
                var endDate = adapter.endDate && adapter.calculateEndDate("toAppointment");
                this.state.appointment.isEmptyText = void 0 === data || void 0 === adapter.text;
                this.state.appointment.isEmptyDescription = void 0 === data || void 0 === adapter.description;
                var appointment = this._createAppointmentAdapter(this._createAppointmentFormData(data));
                if (void 0 === appointment.text) {
                    appointment.text = ""
                }
                if (void 0 === appointment.description) {
                    appointment.description = ""
                }
                if (void 0 === appointment.recurrenceRule) {
                    appointment.recurrenceRule = ""
                }
                var formData = appointment.source();
                if (startDate) {
                    this.scheduler.fire("setField", "startDate", formData, startDate)
                }
                if (endDate) {
                    this.scheduler.fire("setField", "endDate", formData, endDate)
                }
                var _this$scheduler$_data = this.scheduler._dataAccessors.expr,
                    startDateExpr = _this$scheduler$_data.startDateExpr,
                    endDateExpr = _this$scheduler$_data.endDateExpr;
                this._appointmentForm.option("readOnly", this._isReadOnly(data));
                _uiScheduler.AppointmentForm.updateFormData(this._appointmentForm, formData, this.scheduler._dataAccessors.expr);
                _uiScheduler.AppointmentForm.setEditorsType(this._appointmentForm, startDateExpr, endDateExpr, allDay)
            };
            _proto._isDeviceMobile = function() {
                return "desktop" !== _devices.default.current().deviceType
            };
            _proto._isPopupFullScreenNeeded = function() {
                var width = this._tryGetWindowWidth();
                if (width) {
                    return this._isDeviceMobile() ? width < APPOINTMENT_POPUP_FULLSCREEN_WINDOW_WIDTH_MOBILE : width < APPOINTMENT_POPUP_FULLSCREEN_WINDOW_WIDTH
                }
                return false
            };
            _proto._tryGetWindowWidth = function() {
                if ((0, _window.hasWindow)()) {
                    var window = (0, _window.getWindow)();
                    return (0, _renderer.default)(window).width()
                }
            };
            _proto.triggerResize = function() {
                this._popup && (0, _visibility_change.triggerResizeEvent)(this._popup.$element())
            };
            _proto._getMaxWidth = function(isRecurrence) {
                if (this._isDeviceMobile()) {
                    return APPOINTMENT_POPUP_WIDTH_MOBILE
                }
                return isRecurrence ? APPOINTMENT_POPUP_WIDTH_WITH_RECURRENCE : APPOINTMENT_POPUP_WIDTH
            };
            _proto.changeSize = function(isRecurrence) {
                var isFullScreen = this._isPopupFullScreenNeeded();
                this._popup.option({
                    maxWidth: isFullScreen ? "100%" : this._getMaxWidth(isRecurrence),
                    fullScreen: isFullScreen
                })
            };
            _proto.updatePopupFullScreenMode = function() {
                if (!this._appointmentForm) {
                    return
                }
                var isRecurrence = _uiScheduler.AppointmentForm.getRecurrenceRule(this._appointmentForm.option("formData"), this.scheduler._dataAccessors.expr);
                if (this.isVisible()) {
                    this.changeSize(isRecurrence)
                }
            };
            _proto._createPopupToolbarItems = function(isDoneButtonVisible) {
                var _this3 = this;
                var result = [];
                var isIOs = "ios" === _devices.default.current().platform;
                if (isDoneButtonVisible) {
                    result.push({
                        shortcut: "done",
                        options: {
                            text: _message.default.format("Done")
                        },
                        location: TOOLBAR_ITEM_AFTER_LOCATION,
                        onClick: function(e) {
                            return _this3._doneButtonClickHandler(e)
                        }
                    })
                }
                result.push({
                    shortcut: "cancel",
                    location: isIOs ? TOOLBAR_ITEM_BEFORE_LOCATION : TOOLBAR_ITEM_AFTER_LOCATION
                });
                return result
            };
            _proto.saveChanges = function(showLoadPanel) {
                var _this4 = this;
                var deferred = new _deferred.Deferred;
                var validation = this._appointmentForm.validate();
                var state = this.state.appointment;
                showLoadPanel && this._showLoadPanel();
                (0, _deferred.when)(validation && validation.complete || validation).done(function(validation) {
                    if (validation && !validation.isValid) {
                        _this4._hideLoadPanel();
                        deferred.resolve(false);
                        return
                    }
                    var formData = _this4._appointmentForm.option("formData");
                    var adapter = _this4.scheduler.createAppointmentAdapter(formData);
                    var appointment = adapter.clone({
                        pathTimeZone: "fromAppointment"
                    }).source();
                    var oldData = _this4.scheduler._editAppointmentData;
                    var recData = _this4.scheduler._updatedRecAppointment;
                    if (state.isEmptyText && "" === adapter.text) {
                        delete appointment.text
                    }
                    if (state.isEmptyDescription && "" === adapter.description) {
                        delete appointment.description
                    }
                    if (void 0 === state.data.recurrenceRule && "" === adapter.recurrenceRule) {
                        delete appointment.recurrenceRule
                    }
                    if ((0, _type.isDefined)(appointment.repeat)) {
                        delete appointment.repeat
                    }
                    if (oldData && !recData) {
                        _this4.scheduler.updateAppointment(oldData, appointment).done(deferred.resolve)
                    } else {
                        if (recData) {
                            _this4.scheduler.updateAppointment(oldData, recData);
                            delete _this4.scheduler._updatedRecAppointment
                        }
                        _this4.scheduler.addAppointment(appointment).done(deferred.resolve)
                    }
                    deferred.done(function() {
                        _this4._hideLoadPanel();
                        _this4.state.lastEditData = appointment
                    })
                });
                return deferred.promise()
            };
            _proto._doneButtonClickHandler = function(e) {
                e.cancel = true;
                this.saveEditData()
            };
            _proto.saveEditData = function() {
                var _this5 = this;
                var deferred = new _deferred.Deferred;
                if (this._tryLockSaveChanges()) {
                    (0, _deferred.when)(this.saveChanges(true)).done(function() {
                        if (_this5.state.lastEditData) {
                            var adapter = _this5.scheduler.createAppointmentAdapter(_this5.state.lastEditData);
                            var startDate = adapter.startDate,
                                endDate = adapter.endDate,
                                allDay = adapter.allDay;
                            var startTime = startDate.getTime();
                            var endTime = endDate.getTime();
                            var inAllDayRow = allDay || endTime - startTime >= DAY_IN_MS;
                            _this5.scheduler._workSpace.updateScrollPosition(startDate, _this5.scheduler._resourcesManager.getResourcesFromItem(_this5.state.lastEditData, true), inAllDayRow);
                            _this5.state.lastEditData = null
                        }
                        _this5._unlockSaveChanges();
                        deferred.resolve()
                    })
                }
                return deferred.promise()
            };
            _proto._hideLoadPanel = function() {
                (0, _ui.hide)()
            };
            _proto._showLoadPanel = function() {
                var $overlayContent = this._popup.overlayContent();
                (0, _ui.show)({
                    container: $overlayContent,
                    position: {
                        of: $overlayContent
                    }
                })
            };
            _proto._tryLockSaveChanges = function() {
                if (false === this.state.saveChangesLocker) {
                    this.state.saveChangesLocker = true;
                    return true
                }
                return false
            };
            _proto._unlockSaveChanges = function() {
                this.state.saveChangesLocker = false
            };
            return AppointmentPopup
        }();
        exports.default = AppointmentPopup;
        module.exports = exports.default
    },
    /*!********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/ui.scheduler.appointment_form.js ***!
      \********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.AppointmentForm = exports.APPOINTMENT_FORM_GROUP_NAMES = void 0;
        var _form = _interopRequireDefault(__webpack_require__( /*! ../form */ 138));
        var _date_serialization = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date_serialization */ 57));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _data_source = _interopRequireDefault(__webpack_require__( /*! ../../data/data_source */ 332));
        var _utils = _interopRequireDefault(__webpack_require__( /*! ./timezones/utils.timezones_data */ 325));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        __webpack_require__( /*! ./ui.scheduler.recurrence_editor */ 789);
        __webpack_require__( /*! ../text_area */ 373);
        __webpack_require__( /*! ../tag_box */ 289);
        __webpack_require__( /*! ../switch */ 372);
        __webpack_require__( /*! ../select_box */ 117);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var SCREEN_SIZE_OF_SINGLE_COLUMN = 600;
        var APPOINTMENT_FORM_GROUP_NAMES = {
            Main: "mainGroup",
            Recurrence: "recurrenceGroup"
        };
        exports.APPOINTMENT_FORM_GROUP_NAMES = APPOINTMENT_FORM_GROUP_NAMES;
        var SchedulerAppointmentForm = {
            _appointmentForm: {},
            _lockDateShiftFlag: false,
            _validateAppointmentFormDate: function(editor, value, previousValue) {
                var isCurrentDateCorrect = null === value || !!value;
                var isPreviousDateCorrect = null === previousValue || !!previousValue;
                if (!isCurrentDateCorrect && isPreviousDateCorrect) {
                    editor.option("value", previousValue)
                }
            },
            _getAllDayStartDate: function(startDate) {
                return new Date(new Date(startDate).setHours(0, 0, 0, 0))
            },
            _getAllDayEndDate: function(startDate) {
                return new Date(new Date(startDate).setDate(startDate.getDate() + 1))
            },
            _getStartDateWithStartHour: function(startDate, startDayHour) {
                return new Date(new Date(startDate).setHours(startDayHour))
            },
            create: function(componentCreator, $container, isReadOnly, formData) {
                this._appointmentForm = componentCreator($container, _form.default, {
                    items: this._editors,
                    readOnly: isReadOnly,
                    showValidationSummary: true,
                    scrollingEnabled: true,
                    colCount: "auto",
                    colCountByScreen: {
                        lg: 2,
                        xs: 1
                    },
                    formData: formData,
                    showColonAfterLabel: false,
                    labelLocation: "top",
                    screenByWidth: function(width) {
                        return width < SCREEN_SIZE_OF_SINGLE_COLUMN || "desktop" !== _devices.default.current().deviceType ? "xs" : "lg"
                    }
                });
                return this._appointmentForm
            },
            _dateBoxValueChanged: function(args, dateExpr, isNeedCorrect) {
                this._validateAppointmentFormDate(args.component, args.value, args.previousValue);
                var value = _date_serialization.default.deserializeDate(args.value);
                var previousValue = _date_serialization.default.deserializeDate(args.previousValue);
                var dateEditor = this._appointmentForm.getEditor(dateExpr);
                var dateValue = _date_serialization.default.deserializeDate(dateEditor.option("value"));
                if (!this._appointmentForm._lockDateShiftFlag && dateValue && value && isNeedCorrect(dateValue, value)) {
                    var duration = previousValue ? dateValue.getTime() - previousValue.getTime() : 0;
                    dateEditor.option("value", new Date(value.getTime() + duration))
                }
            },
            _createTimezoneEditor: function(timeZoneExpr, secondTimeZoneExpr, visibleIndex, colSpan, isMainTimeZone) {
                var _this = this;
                var isShow = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : false;
                var noTzTitle = _message.default.format("dxScheduler-noTimezoneTitle");
                return {
                    dataField: timeZoneExpr,
                    editorType: "dxSelectBox",
                    visibleIndex: visibleIndex,
                    colSpan: colSpan,
                    label: {
                        text: " "
                    },
                    editorOptions: {
                        displayExpr: "title",
                        valueExpr: "id",
                        placeholder: noTzTitle,
                        searchEnabled: true,
                        onValueChanged: function(args) {
                            var form = _this._appointmentForm;
                            var secondTimezoneEditor = form.getEditor(secondTimeZoneExpr);
                            if (isMainTimeZone) {
                                secondTimezoneEditor.option("value", args.value)
                            }
                        }
                    },
                    visible: isShow
                }
            },
            _createDateBoxEditor: function(dataExpr, colSpan, firstDayOfWeek, label, callback) {
                return {
                    dataField: dataExpr,
                    editorType: "dxDateBox",
                    colSpan: colSpan,
                    label: {
                        text: _message.default.format(label)
                    },
                    validationRules: [{
                        type: "required"
                    }],
                    editorOptions: {
                        width: "100%",
                        calendarOptions: {
                            firstDayOfWeek: firstDayOfWeek
                        },
                        onValueChanged: callback
                    }
                }
            },
            _createDateBoxItems: function(dataExprs, schedulerInst, allowTimeZoneEditing) {
                var _this2 = this;
                var colSpan = allowTimeZoneEditing ? 2 : 1;
                var firstDayOfWeek = schedulerInst.option("firstDayOfWeek");
                return [this._createDateBoxEditor(dataExprs.startDateExpr, colSpan, firstDayOfWeek, "dxScheduler-editorLabelStartDate", function(args) {
                    _this2._dateBoxValueChanged(args, dataExprs.endDateExpr, function(endValue, startValue) {
                        return endValue < startValue
                    })
                }), this._createTimezoneEditor(dataExprs.startDateTimeZoneExpr, dataExprs.endDateTimeZoneExpr, 1, colSpan, true, allowTimeZoneEditing), this._createDateBoxEditor(dataExprs.endDateExpr, colSpan, firstDayOfWeek, "dxScheduler-editorLabelEndDate", function(args) {
                    _this2._dateBoxValueChanged(args, dataExprs.startDateExpr, function(startValue, endValue) {
                        return endValue < startValue
                    })
                }), this._createTimezoneEditor(dataExprs.endDateTimeZoneExpr, dataExprs.startDateTimeZoneExpr, 3, colSpan, false, allowTimeZoneEditing)]
            },
            _createMainItems: function(dataExprs, schedulerInst, triggerResize, changeSize, allowTimeZoneEditing) {
                var _this3 = this;
                return [{
                    dataField: dataExprs.textExpr,
                    editorType: "dxTextBox",
                    colSpan: 2,
                    label: {
                        text: _message.default.format("dxScheduler-editorLabelTitle")
                    }
                }, {
                    itemType: "group",
                    colSpan: 2,
                    colCountByScreen: {
                        lg: 2,
                        xs: 1
                    },
                    items: this._createDateBoxItems(dataExprs, schedulerInst, allowTimeZoneEditing)
                }, {
                    itemType: "group",
                    colCountByScreen: {
                        lg: 3,
                        xs: 3
                    },
                    colSpan: 2,
                    items: [{
                        dataField: dataExprs.allDayExpr,
                        cssClass: "dx-appointment-form-switch",
                        editorType: "dxSwitch",
                        label: {
                            text: _message.default.format("dxScheduler-allDay"),
                            location: "right"
                        },
                        editorOptions: {
                            onValueChanged: function(args) {
                                var value = args.value;
                                var startDateEditor = _this3._appointmentForm.getEditor(dataExprs.startDateExpr);
                                var endDateEditor = _this3._appointmentForm.getEditor(dataExprs.endDateExpr);
                                var startDate = _date_serialization.default.deserializeDate(startDateEditor.option("value"));
                                if (!_this3._appointmentForm._lockDateShiftFlag && startDate) {
                                    if (value) {
                                        var allDayStartDate = _this3._getAllDayStartDate(startDate);
                                        startDateEditor.option("value", allDayStartDate);
                                        endDateEditor.option("value", _this3._getAllDayEndDate(allDayStartDate))
                                    } else {
                                        var startDateWithStartHour = _this3._getStartDateWithStartHour(startDate, schedulerInst.option("startDayHour"));
                                        var endDate = schedulerInst._workSpace.calculateEndDate(startDateWithStartHour);
                                        startDateEditor.option("value", startDateWithStartHour);
                                        endDateEditor.option("value", endDate)
                                    }
                                }
                                startDateEditor.option("type", value ? "date" : "datetime");
                                endDateEditor.option("type", value ? "date" : "datetime")
                            }
                        }
                    }, {
                        editorType: "dxSwitch",
                        dataField: "repeat",
                        cssClass: "dx-appointment-form-switch",
                        name: "visibilityChanged",
                        label: {
                            text: _message.default.format("dxScheduler-editorLabelRecurrence"),
                            location: "right"
                        },
                        editorOptions: {
                            onValueChanged: function(args) {
                                var form = _this3._appointmentForm;
                                var colSpan = args.value ? 1 : 2;
                                form.itemOption(APPOINTMENT_FORM_GROUP_NAMES.Main, "colSpan", colSpan);
                                form.itemOption(APPOINTMENT_FORM_GROUP_NAMES.Recurrence, "colSpan", colSpan);
                                _this3._updateRecurrenceItemVisibility(dataExprs.recurrenceRuleExpr, args.value, form);
                                changeSize(args.value);
                                triggerResize()
                            }
                        }
                    }]
                }, {
                    itemType: "empty",
                    colSpan: 2
                }, {
                    dataField: dataExprs.descriptionExpr,
                    editorType: "dxTextArea",
                    colSpan: 2,
                    label: {
                        text: _message.default.format("dxScheduler-editorLabelDescription")
                    }
                }, {
                    itemType: "empty",
                    colSpan: 2
                }]
            },
            _updateRecurrenceItemVisibility: function(recurrenceRuleExpr, value, form) {
                var _form$getEditor;
                form.itemOption(APPOINTMENT_FORM_GROUP_NAMES.Recurrence, "visible", value);
                !value && form.updateData(recurrenceRuleExpr, "");
                null === (_form$getEditor = form.getEditor(recurrenceRuleExpr)) || void 0 === _form$getEditor ? void 0 : _form$getEditor.changeValueByVisibility(value)
            },
            prepareAppointmentFormEditors: function(dataExprs, schedulerInst, triggerResize, changeSize, appointmentData, allowTimeZoneEditing, readOnly) {
                var recurrenceEditorVisibility = !!this.getRecurrenceRule(appointmentData, dataExprs);
                changeSize(recurrenceEditorVisibility);
                this._editors = [{
                    itemType: "group",
                    name: APPOINTMENT_FORM_GROUP_NAMES.Main,
                    colCountByScreen: {
                        lg: 2,
                        xs: 1
                    },
                    colSpan: recurrenceEditorVisibility ? 1 : 2,
                    items: this._createMainItems(dataExprs, schedulerInst, triggerResize, changeSize, allowTimeZoneEditing)
                }, {
                    itemType: "group",
                    name: APPOINTMENT_FORM_GROUP_NAMES.Recurrence,
                    visible: recurrenceEditorVisibility,
                    colSpan: recurrenceEditorVisibility ? 1 : 2,
                    items: this._createRecurrenceEditor(dataExprs, schedulerInst, readOnly)
                }];
                return this._editors
            },
            _createRecurrenceEditor: function(dataExprs, schedulerInst, readOnly) {
                return [{
                    dataField: dataExprs.recurrenceRuleExpr,
                    editorType: "dxRecurrenceEditor",
                    editorOptions: {
                        readOnly: readOnly,
                        firstDayOfWeek: schedulerInst.option("firstDayOfWeek")
                    },
                    label: {
                        text: " ",
                        visible: false
                    }
                }]
            },
            getRecurrenceRule: function(data, dataExprs) {
                return data[dataExprs.recurrenceRuleExpr]
            },
            concatResources: function(resources) {
                this._editors[0].items = this._editors[0].items.concat(resources)
            },
            setEditorsType: function(form, startDateExpr, endDateExpr, allDay) {
                var startDateItemPath = "".concat(APPOINTMENT_FORM_GROUP_NAMES.Main, ".").concat(startDateExpr);
                var endDateItemPath = "".concat(APPOINTMENT_FORM_GROUP_NAMES.Recurrence, ".").concat(endDateExpr);
                var startDateFormItem = form.itemOption(startDateItemPath);
                var endDateFormItem = form.itemOption(endDateItemPath);
                if (startDateFormItem && endDateFormItem) {
                    var startDateEditorOptions = startDateFormItem.editorOptions;
                    var endDateEditorOptions = endDateFormItem.editorOptions;
                    startDateEditorOptions.type = endDateEditorOptions.type = allDay ? "date" : "datetime";
                    form.itemOption(startDateItemPath, "editorOptions", startDateEditorOptions);
                    form.itemOption(endDateItemPath, "editorOptions", endDateEditorOptions)
                }
            },
            updateTimeZoneEditorDataSource: function(date, expression) {
                var timeZoneDataSource = new _data_source.default({
                    store: _utils.default.getDisplayedTimeZones(date),
                    paginate: true,
                    pageSize: 10
                });
                var options = {
                    dataSource: timeZoneDataSource
                };
                this.setEditorOptions(expression, "Main", options)
            },
            updateRecurrenceEditorStartDate: function(date, expression) {
                var options = {
                    startDate: date
                };
                this.setEditorOptions(expression, "Recurrence", options)
            },
            setEditorOptions: function(name, groupName, options) {
                var editorPath = "".concat(APPOINTMENT_FORM_GROUP_NAMES.groupName, ".").concat(name);
                var editor = this._appointmentForm.itemOption(editorPath);
                editor && this._appointmentForm.itemOption(editorPath, "editorOptions", (0, _extend.extend)({}, editor.editorOptions, options))
            },
            updateFormData: function(appointmentForm, formData, dataExprs) {
                appointmentForm._lockDateShiftFlag = true;
                var startDate = new Date(formData[dataExprs.startDateExpr]);
                var endDate = new Date(formData[dataExprs.endDateExpr]);
                this.updateTimeZoneEditorDataSource(startDate, dataExprs.startDateTimeZoneExpr);
                this.updateTimeZoneEditorDataSource(endDate, dataExprs.endDateTimeZoneExpr);
                this.updateRecurrenceEditorStartDate(startDate, dataExprs.recurrenceRuleExpr);
                appointmentForm.option("formData", formData);
                appointmentForm._lockDateShiftFlag = false
            }
        };
        exports.AppointmentForm = SchedulerAppointmentForm
    },
    /*!*********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/ui.scheduler.recurrence_editor.js ***!
      \*********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _guid = _interopRequireDefault(__webpack_require__( /*! ../../core/guid */ 36));
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _date2 = _interopRequireDefault(__webpack_require__( /*! ../../localization/date */ 32));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _form = _interopRequireDefault(__webpack_require__( /*! ../form */ 138));
        var _button_group = _interopRequireDefault(__webpack_require__( /*! ../button_group */ 276));
        var _date_box = _interopRequireDefault(__webpack_require__( /*! ../date_box */ 212));
        var _editor = _interopRequireDefault(__webpack_require__( /*! ../editor/editor */ 52));
        var _number_box = _interopRequireDefault(__webpack_require__( /*! ../number_box */ 116));
        var _recurrence = __webpack_require__( /*! ./recurrence */ 139);
        __webpack_require__( /*! ../radio_group */ 288);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var RECURRENCE_EDITOR = "dx-recurrence-editor";
        var LABEL_POSTFIX = "-label";
        var WRAPPER_POSTFIX = "-wrapper";
        var RECURRENCE_EDITOR_CONTAINER = "dx-recurrence-editor-container";
        var REPEAT_END_EDITOR = "dx-recurrence-repeat-end";
        var REPEAT_END_TYPE_EDITOR = "dx-recurrence-radiogroup-repeat-type";
        var REPEAT_COUNT_EDITOR = "dx-recurrence-numberbox-repeat-count";
        var REPEAT_UNTIL_DATE_EDITOR = "dx-recurrence-datebox-until-date";
        var RECURRENCE_BUTTON_GROUP = "dx-recurrence-button-group";
        var FREQUENCY_EDITOR = "dx-recurrence-selectbox-freq";
        var INTERVAL_EDITOR = "dx-recurrence-numberbox-interval";
        var REPEAT_ON_EDITOR = "dx-recurrence-repeat-on";
        var DAY_OF_MONTH = "dx-recurrence-numberbox-day-of-month";
        var MONTH_OF_YEAR = "dx-recurrence-selectbox-month-of-year";
        var recurrentEditorNumberBoxWidth = 70;
        var recurrentEditorSelectBoxWidth = 120;
        var defaultRecurrenceTypeIndex = 1;
        var frequenciesMessages = [{
            recurrence: "dxScheduler-recurrenceHourly",
            value: "hourly"
        }, {
            recurrence: "dxScheduler-recurrenceDaily",
            value: "daily"
        }, {
            recurrence: "dxScheduler-recurrenceWeekly",
            value: "weekly"
        }, {
            recurrence: "dxScheduler-recurrenceMonthly",
            value: "monthly"
        }, {
            recurrence: "dxScheduler-recurrenceYearly",
            value: "yearly"
        }];
        var frequencies = frequenciesMessages.map(function(item) {
            return {
                text: function() {
                    return _message.default.format(item.recurrence)
                },
                value: item.value
            }
        });
        var repeatEndTypes = [{
            type: "never"
        }, {
            type: "until"
        }, {
            type: "count"
        }];
        var days = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"];
        var RecurrenceRule = function() {
            function RecurrenceRule(rule) {
                this._recurrenceProcessor = (0, _recurrence.getRecurrenceProcessor)();
                this._recurrenceRule = this._recurrenceProcessor.evalRecurrenceRule(rule).rule
            }
            var _proto = RecurrenceRule.prototype;
            _proto.makeRules = function(string) {
                this._recurrenceRule = this._recurrenceProcessor.evalRecurrenceRule(string).rule
            };
            _proto.makeRule = function(field, value) {
                if (!value || Array.isArray(value) && !value.length) {
                    delete this._recurrenceRule[field];
                    return
                }
                if ((0, _type.isDefined)(field)) {
                    if ("until" === field) {
                        delete this._recurrenceRule.count
                    }
                    if ("count" === field) {
                        delete this._recurrenceRule.until
                    }
                    this._recurrenceRule[field] = value
                }
            };
            _proto.getRepeatEndRule = function() {
                var rules = this._recurrenceRule;
                if ("count" in rules) {
                    return "count"
                }
                if ("until" in rules) {
                    return "until"
                }
                return "never"
            };
            _proto.getRecurrenceString = function() {
                return this._recurrenceProcessor.getRecurrenceString(this._recurrenceRule)
            };
            _proto.getRules = function() {
                return this._recurrenceRule
            };
            _proto.getDaysFromByDayRule = function() {
                return this._recurrenceProcessor.daysFromByDayRule(this._recurrenceRule)
            };
            return RecurrenceRule
        }();
        var RecurrenceEditor = function(_Editor) {
            _inheritsLoose(RecurrenceEditor, _Editor);

            function RecurrenceEditor() {
                return _Editor.apply(this, arguments) || this
            }
            var _proto2 = RecurrenceEditor.prototype;
            _proto2._getDefaultOptions = function() {
                var defaultOptions = _Editor.prototype._getDefaultOptions.call(this);
                return (0, _extend.extend)(defaultOptions, {
                    value: null,
                    startDate: new Date,
                    firstDayOfWeek: void 0
                })
            };
            _proto2._getFirstDayOfWeek = function() {
                var firstDayOfWeek = this.option("firstDayOfWeek");
                return (0, _type.isDefined)(firstDayOfWeek) ? firstDayOfWeek : _date2.default.firstDayOfWeekIndex()
            };
            _proto2._createComponent = function(element, name) {
                var config = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                this._extendConfig(config, {
                    readOnly: this.option("readOnly")
                });
                return _Editor.prototype._createComponent.call(this, element, name, config)
            };
            _proto2._init = function() {
                _Editor.prototype._init.call(this);
                this._recurrenceRule = new RecurrenceRule(this.option("value"))
            };
            _proto2._render = function() {
                _Editor.prototype._render.call(this);
                this.$element().addClass(RECURRENCE_EDITOR);
                this._$container = (0, _renderer.default)("<div>").addClass(RECURRENCE_EDITOR_CONTAINER).appendTo(this.$element());
                this._prepareEditors();
                this._renderEditors(this._$container)
            };
            _proto2.getEditorByField = function(fieldName) {
                var editor = this.getRecurrenceForm().getEditor(fieldName);
                if (!(0, _type.isDefined)(editor)) {
                    switch (fieldName) {
                        case "byday":
                            editor = this._weekEditor;
                            break;
                        case "count":
                            editor = this._repeatCountEditor;
                            break;
                        case "until":
                            editor = this._repeatUntilDate
                    }
                }
                return editor
            };
            _proto2._prepareEditors = function() {
                var freq = (this._recurrenceRule.getRules().freq || frequenciesMessages[defaultRecurrenceTypeIndex].value).toLowerCase();
                this._editors = [this._createFreqEditor(freq), this._createIntervalEditor(freq), this._createRepeatOnLabel(freq), {
                    itemType: "group",
                    cssClass: REPEAT_ON_EDITOR,
                    colCount: 2,
                    colCountByScreen: {
                        xs: 2
                    },
                    items: this._createRepeatOnEditor(freq)
                }, {
                    itemType: "group",
                    items: this._createRepeatEndEditor()
                }];
                return this._editors
            };
            _proto2._createFreqEditor = function(freq) {
                var _this = this;
                return {
                    dataField: "freq",
                    name: "FREQ",
                    editorType: "dxSelectBox",
                    cssClass: FREQUENCY_EDITOR,
                    editorOptions: {
                        items: frequencies,
                        value: freq,
                        field: "freq",
                        valueExpr: "value",
                        displayExpr: "text",
                        layout: "horizontal",
                        elementAttr: {
                            "class": FREQUENCY_EDITOR
                        },
                        onValueChanged: function(args) {
                            return _this._valueChangedHandler(args)
                        }
                    },
                    label: {
                        text: _message.default.format("dxScheduler-editorLabelRecurrence")
                    }
                }
            };
            _proto2._createIntervalEditor = function(freq) {
                var _this2 = this;
                var interval = this._recurrenceRule.getRules().interval || 1;
                return {
                    itemType: "group",
                    colCount: 2,
                    cssClass: "".concat(INTERVAL_EDITOR).concat(WRAPPER_POSTFIX),
                    colCountByScreen: {
                        xs: 2
                    },
                    items: [{
                        dataField: "interval",
                        editorType: "dxNumberBox",
                        editorOptions: {
                            width: recurrentEditorNumberBoxWidth,
                            min: 1,
                            field: "interval",
                            value: interval,
                            showSpinButtons: true,
                            useLargeSpinButtons: false,
                            elementAttr: {
                                "class": INTERVAL_EDITOR
                            },
                            onValueChanged: function(args) {
                                return _this2._valueChangedHandler(args)
                            }
                        },
                        label: {
                            text: _message.default.format("dxScheduler-recurrenceRepeatEvery")
                        }
                    }, {
                        name: "intervalLabel",
                        cssClass: "".concat(INTERVAL_EDITOR).concat(LABEL_POSTFIX),
                        template: function() {
                            return _message.default.format("dxScheduler-recurrenceRepeat".concat(freq.charAt(0).toUpperCase()).concat(freq.substr(1).toLowerCase()))
                        }
                    }]
                }
            };
            _proto2._createRepeatOnLabel = function(freq) {
                return {
                    itemType: "group",
                    cssClass: "".concat(REPEAT_ON_EDITOR).concat(LABEL_POSTFIX),
                    items: [{
                        name: "repeatOnLabel",
                        colSpan: 2,
                        template: function() {
                            return _message.default.format("dxScheduler-recurrenceRepeatOn")
                        },
                        visible: freq && "daily" !== freq && "hourly" !== freq
                    }]
                }
            };
            _proto2._createRepeatOnEditor = function(freq) {
                return [this._createByDayEditor(freq), this._createByMonthEditor(freq), this._createByMonthDayEditor(freq)]
            };
            _proto2._createByDayEditor = function(freq) {
                var _this3 = this;
                return {
                    dataField: "byday",
                    colSpan: 2,
                    template: function(_, itemElement) {
                        var firstDayOfWeek = _this3._getFirstDayOfWeek();
                        var byDay = _this3._daysOfWeekByRules();
                        var localDaysNames = _date2.default.getDayNames("abbreviated");
                        var dayNames = days.slice(firstDayOfWeek).concat(days.slice(0, firstDayOfWeek));
                        var itemsButtonGroup = localDaysNames.slice(firstDayOfWeek).concat(localDaysNames.slice(0, firstDayOfWeek)).map(function(item, index) {
                            return {
                                text: item,
                                key: dayNames[index]
                            }
                        });
                        _this3._$repeatOnWeek = (0, _renderer.default)("<div>").addClass(RECURRENCE_BUTTON_GROUP).appendTo(itemElement);
                        _this3._weekEditor = _this3._createComponent(_this3._$repeatOnWeek, _button_group.default, {
                            items: itemsButtonGroup,
                            field: "byday",
                            selectionMode: "multiple",
                            selectedItemKeys: byDay,
                            keyExpr: "key",
                            onSelectionChanged: function(e) {
                                var selectedKeys = e.component.option("selectedItemKeys");
                                _this3._recurrenceRule.makeRule("byday", selectedKeys);
                                _this3._changeEditorValue()
                            }
                        })
                    },
                    visible: "weekly" === freq,
                    label: {
                        visible: false
                    }
                }
            };
            _proto2._createByMonthEditor = function(freq) {
                var _this4 = this;
                var monthsName = _date2.default.getMonthNames("wide");
                var months = _toConsumableArray(Array(12)).map(function(_, i) {
                    return {
                        value: "".concat(i + 1),
                        text: monthsName[i]
                    }
                });
                return {
                    dataField: "bymonth",
                    editorType: "dxSelectBox",
                    editorOptions: {
                        field: "bymonth",
                        items: months,
                        value: this._monthOfYearByRules(),
                        width: recurrentEditorSelectBoxWidth,
                        displayExpr: "text",
                        valueExpr: "value",
                        elementAttr: {
                            "class": MONTH_OF_YEAR
                        },
                        onValueChanged: function(args) {
                            return _this4._valueChangedHandler(args)
                        }
                    },
                    visible: "yearly" === freq,
                    label: {
                        visible: false
                    }
                }
            };
            _proto2._createByMonthDayEditor = function(freq) {
                var _this5 = this;
                return {
                    dataField: "bymonthday",
                    editorType: "dxNumberBox",
                    editorOptions: {
                        min: 1,
                        max: 31,
                        width: recurrentEditorNumberBoxWidth,
                        field: "bymonthday",
                        showSpinButtons: true,
                        useLargeSpinButtons: false,
                        value: this._dayOfMonthByRules(),
                        elementAttr: {
                            "class": DAY_OF_MONTH
                        },
                        onValueChanged: function(args) {
                            return _this5._valueChangedHandler(args)
                        }
                    },
                    visible: "monthly" === freq || "yearly" === freq,
                    label: {
                        visible: false
                    }
                }
            };
            _proto2._createRepeatEndEditor = function() {
                var _this6 = this;
                var repeatType = this._recurrenceRule.getRepeatEndRule();
                return [{
                    dataField: "repeatEnd",
                    editorType: "dxRadioGroup",
                    editorOptions: {
                        items: repeatEndTypes,
                        value: repeatType,
                        valueExpr: "type",
                        field: "repeatEnd",
                        itemTemplate: function(itemData) {
                            if ("count" === itemData.type) {
                                return _this6._renderRepeatCountEditor()
                            }
                            if ("until" === itemData.type) {
                                return _this6._renderRepeatUntilEditor()
                            }
                            return _this6._renderDefaultRepeatEnd()
                        },
                        layout: "vertical",
                        elementAttr: {
                            "class": REPEAT_END_TYPE_EDITOR
                        },
                        onValueChanged: function(args) {
                            return _this6._repeatEndValueChangedHandler(args)
                        }
                    },
                    label: {
                        text: _message.default.format("dxScheduler-recurrenceEnd")
                    }
                }]
            };
            _proto2._renderEditors = function($container) {
                this._recurrenceForm = this._createComponent($container, _form.default, {
                    items: this._editors,
                    showValidationSummary: true,
                    scrollingEnabled: true,
                    showColonAfterLabel: false,
                    labelLocation: "top"
                });
                this._disableRepeatEndParts()
            };
            _proto2._setAriaDescribedBy = function(editor, $label) {
                var labelId = "label-".concat(new _guid.default);
                editor.setAria("describedby", labelId);
                editor.setAria("id", labelId, $label)
            };
            _proto2.getRecurrenceForm = function() {
                return this._recurrenceForm
            };
            _proto2.changeValueByVisibility = function(value) {
                if (value) {
                    if (!this.option("value")) {
                        this._handleDefaults()
                    }
                } else {
                    this._recurrenceRule.makeRules("");
                    this.option("value", "")
                }
            };
            _proto2._handleDefaults = function() {
                this._recurrenceRule.makeRule("freq", frequenciesMessages[defaultRecurrenceTypeIndex].value);
                this._changeEditorValue()
            };
            _proto2._changeEditorValue = function() {
                this.option("value", this._recurrenceRule.getRecurrenceString() || "")
            };
            _proto2._daysOfWeekByRules = function() {
                var daysByRule = this._recurrenceRule.getDaysFromByDayRule();
                if (!daysByRule.length) {
                    daysByRule = [days[this.option("startDate").getDay()]]
                }
                return daysByRule
            };
            _proto2._dayOfMonthByRules = function() {
                var dayByRule = this._recurrenceRule.getRules().bymonthday;
                if (!dayByRule) {
                    dayByRule = this.option("startDate").getDate()
                }
                return dayByRule
            };
            _proto2._monthOfYearByRules = function() {
                var monthByRule = this._recurrenceRule.getRules().bymonth;
                if (!monthByRule) {
                    monthByRule = this.option("startDate").getMonth() + 1
                }
                return String(monthByRule)
            };
            _proto2._renderDefaultRepeatEnd = function() {
                var $editorTemplate = (0, _renderer.default)("<div>").addClass(REPEAT_END_EDITOR + WRAPPER_POSTFIX);
                (0, _renderer.default)("<div>").text(_message.default.format("dxScheduler-recurrenceNever")).addClass(REPEAT_END_EDITOR + LABEL_POSTFIX).appendTo($editorTemplate);
                return $editorTemplate
            };
            _proto2._repeatEndValueChangedHandler = function(args) {
                var value = args.value;
                this._disableRepeatEndParts(value);
                if ("until" === value) {
                    this._recurrenceRule.makeRule(value, this._getUntilValue())
                }
                if ("count" === value) {
                    this._recurrenceRule.makeRule(value, this._repeatCountEditor.option("value"))
                }
                if ("never" === value) {
                    this._recurrenceRule.makeRule("count", "");
                    this._recurrenceRule.makeRule("until", "")
                }
                this._changeEditorValue()
            };
            _proto2._disableRepeatEndParts = function() {
                var value = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this._recurrenceRule.getRepeatEndRule();
                if ("until" === value) {
                    this._repeatCountEditor.option("disabled", true);
                    this._repeatUntilDate.option("disabled", false)
                }
                if ("count" === value) {
                    this._repeatCountEditor.option("disabled", false);
                    this._repeatUntilDate.option("disabled", true)
                }
                if ("never" === value) {
                    this._repeatCountEditor.option("disabled", true);
                    this._repeatUntilDate.option("disabled", true)
                }
            };
            _proto2._renderRepeatCountEditor = function() {
                var repeatCount = this._recurrenceRule.getRules().count || 1;
                var $editorWrapper = (0, _renderer.default)("<div>").addClass(REPEAT_END_EDITOR + WRAPPER_POSTFIX);
                (0, _renderer.default)("<div>").text(_message.default.format("dxScheduler-recurrenceAfter")).addClass(REPEAT_END_EDITOR + LABEL_POSTFIX).appendTo($editorWrapper);
                this._$repeatCountEditor = (0, _renderer.default)("<div>").addClass(REPEAT_COUNT_EDITOR).appendTo($editorWrapper);
                (0, _renderer.default)("<div>").text(_message.default.format("dxScheduler-recurrenceRepeatCount")).addClass(REPEAT_END_EDITOR + LABEL_POSTFIX).appendTo($editorWrapper);
                this._repeatCountEditor = this._createComponent(this._$repeatCountEditor, _number_box.default, {
                    field: "count",
                    width: recurrentEditorNumberBoxWidth,
                    min: 1,
                    showSpinButtons: true,
                    useLargeSpinButtons: false,
                    value: repeatCount,
                    onValueChanged: this._repeatCountValueChangeHandler.bind(this)
                });
                return $editorWrapper
            };
            _proto2._repeatCountValueChangeHandler = function(args) {
                if ("count" === this._recurrenceRule.getRepeatEndRule()) {
                    var value = args.value;
                    this._recurrenceRule.makeRule("count", value);
                    this._changeEditorValue()
                }
            };
            _proto2._formatUntilDate = function(date) {
                if (this._recurrenceRule.getRules().until && _date.default.sameDate(this._recurrenceRule.getRules().until, date)) {
                    return date
                }
                return _date.default.setToDayEnd(date)
            };
            _proto2._renderRepeatUntilEditor = function() {
                var repeatUntil = this._recurrenceRule.getRules().until || this._formatUntilDate(new Date);
                var $editorWrapper = (0, _renderer.default)("<div>").addClass(REPEAT_END_EDITOR + WRAPPER_POSTFIX);
                (0, _renderer.default)("<div>").text(_message.default.format("dxScheduler-recurrenceOn")).addClass(REPEAT_END_EDITOR + LABEL_POSTFIX).appendTo($editorWrapper);
                this._$repeatDateEditor = (0, _renderer.default)("<div>").addClass(REPEAT_UNTIL_DATE_EDITOR).appendTo($editorWrapper);
                this._repeatUntilDate = this._createComponent(this._$repeatDateEditor, _date_box.default, {
                    field: "until",
                    value: repeatUntil,
                    type: "date",
                    onValueChanged: this._repeatUntilValueChangeHandler.bind(this),
                    calendarOptions: {
                        firstDayOfWeek: this._getFirstDayOfWeek()
                    }
                });
                return $editorWrapper
            };
            _proto2._repeatUntilValueChangeHandler = function(args) {
                if ("until" === this._recurrenceRule.getRepeatEndRule()) {
                    var untilDate = this._formatUntilDate(new Date(args.value));
                    this._repeatUntilDate.option("value", untilDate);
                    this._recurrenceRule.makeRule("until", untilDate);
                    this._changeEditorValue()
                }
            };
            _proto2._valueChangedHandler = function(args) {
                var value = args.value,
                    previousValue = args.previousValue;
                var field = args.component.option("field");
                if (!this.option("visible")) {
                    this.option("value", "")
                } else {
                    this._recurrenceRule.makeRule(field, value);
                    if ("freq" === field) {
                        this._makeRepeatOnRule(value);
                        this._changeRepeatOnVisibility(value, previousValue)
                    }
                    this._changeEditorValue()
                }
            };
            _proto2._makeRepeatOnRule = function(value) {
                if ("daily" === value || "hourly" === value) {
                    this._recurrenceRule.makeRule("byday", "");
                    this._recurrenceRule.makeRule("bymonth", "");
                    this._recurrenceRule.makeRule("bymonthday", "")
                }
                if ("weekly" === value) {
                    this._recurrenceRule.makeRule("byday", this._daysOfWeekByRules());
                    this._recurrenceRule.makeRule("bymonth", "");
                    this._recurrenceRule.makeRule("bymonthday", "")
                }
                if ("monthly" === value) {
                    this._recurrenceRule.makeRule("bymonthday", this._dayOfMonthByRules());
                    this._recurrenceRule.makeRule("bymonth", "");
                    this._recurrenceRule.makeRule("byday", "")
                }
                if ("yearly" === value) {
                    this._recurrenceRule.makeRule("bymonthday", this._dayOfMonthByRules());
                    this._recurrenceRule.makeRule("bymonth", this._monthOfYearByRules());
                    this._recurrenceRule.makeRule("byday", "")
                }
            };
            _proto2._optionChanged = function(args) {
                switch (args.name) {
                    case "value":
                        this._recurrenceRule.makeRules(args.value);
                        this._changeRepeatIntervalLabel();
                        this._disableRepeatEndParts();
                        this._changeEditorsValue(this._recurrenceRule.getRules());
                        _Editor.prototype._optionChanged.call(this, args);
                        break;
                    case "startDate":
                        this._makeRepeatOnRule(this._recurrenceRule.getRules().freq);
                        if ((0, _type.isDefined)(this._recurrenceRule.getRecurrenceString())) {
                            this._changeEditorValue()
                        }
                        break;
                    case "firstDayOfWeek":
                        if (this._weekEditor) {
                            var localDaysNames = _date2.default.getDayNames("abbreviated");
                            var dayNames = days.slice(args.value).concat(days.slice(0, args.value));
                            var itemsButtonGroup = localDaysNames.slice(args.value).concat(localDaysNames.slice(0, args.value)).map(function(item, index) {
                                return {
                                    text: item,
                                    key: dayNames[index]
                                }
                            });
                            this._weekEditor.option("items", itemsButtonGroup)
                        }
                        if (this._$repeatDateEditor) {
                            this._repeatUntilDate.option("calendarOptions.firstDayOfWeek", this._getFirstDayOfWeek())
                        }
                        break;
                    default:
                        _Editor.prototype._optionChanged.call(this, args)
                }
            };
            _proto2._changeRepeatOnVisibility = function(freq, previousFreq) {
                if (freq !== previousFreq) {
                    this._recurrenceForm.itemOption("byday", "visible", false);
                    this._recurrenceForm.itemOption("bymonthday", "visible", false);
                    this._recurrenceForm.itemOption("bymonth", "visible", false);
                    this._recurrenceForm.itemOption("repeatOnLabel", "visible", freq && "daily" !== freq && "hourly" !== freq);
                    if ("weekly" === freq) {
                        this._recurrenceForm.itemOption("byday", "visible", true)
                    }
                    if ("monthly" === freq) {
                        this._recurrenceForm.itemOption("bymonthday", "visible", true)
                    }
                    if ("yearly" === freq) {
                        this._recurrenceForm.itemOption("bymonthday", "visible", true);
                        this._recurrenceForm.itemOption("bymonth", "visible", true)
                    }
                }
            };
            _proto2._changeRepeatIntervalLabel = function() {
                var freq = this._recurrenceRule.getRules().freq;
                freq && this._recurrenceForm.itemOption("intervalLabel", "template", _message.default.format("dxScheduler-recurrenceRepeat".concat(freq.charAt(0).toUpperCase()).concat(freq.substr(1).toLowerCase())))
            };
            _proto2._changeEditorsValue = function(rules) {
                this._recurrenceForm.getEditor("freq").option("value", (rules.freq || frequenciesMessages[defaultRecurrenceTypeIndex].value).toLowerCase());
                this._changeDayOfWeekValue();
                this._changeDayOfMonthValue();
                this._changeMonthOfYearValue();
                this._changeIntervalValue(rules.interval);
                this._changeRepeatCountValue();
                this._changeRepeatEndValue();
                this._changeRepeatUntilValue()
            };
            _proto2._changeIntervalValue = function(value) {
                this._recurrenceForm.getEditor("interval").option("value", value || 1)
            };
            _proto2._changeRepeatEndValue = function() {
                var repeatType = this._recurrenceRule.getRepeatEndRule();
                this._recurrenceForm.getEditor("repeatEnd").option("value", repeatType)
            };
            _proto2._changeDayOfWeekValue = function() {
                var isEditorVisible = this._recurrenceForm.itemOption("byday").visible;
                if (isEditorVisible) {
                    var _days = this._daysOfWeekByRules();
                    this.getEditorByField("byday").option("selectedItemKeys", _days)
                }
            };
            _proto2._changeDayOfMonthValue = function() {
                var isEditorVisible = this._recurrenceForm.itemOption("bymonthday").visible;
                if (isEditorVisible) {
                    var day = this._dayOfMonthByRules();
                    this._recurrenceForm.getEditor("bymonthday").option("value", day)
                }
            };
            _proto2._changeMonthOfYearValue = function() {
                var isEditorVisible = this._recurrenceForm.itemOption("bymonth").visible;
                if (isEditorVisible) {
                    var month = this._monthOfYearByRules();
                    this._recurrenceForm.getEditor("bymonth").option("value", month)
                }
            };
            _proto2._changeRepeatCountValue = function() {
                var count = this._recurrenceRule.getRules().count || 1;
                this._repeatCountEditor.option("value", count)
            };
            _proto2._changeRepeatUntilValue = function() {
                this._repeatUntilDate.option("value", this._getUntilValue())
            };
            _proto2._getUntilValue = function() {
                return this._recurrenceRule.getRules().until || this._formatUntilDate(new Date)
            };
            _proto2.toggle = function() {
                this._freqEditor.focus()
            };
            _proto2.setAria = function() {
                if (this._switchEditor) {
                    this._switchEditor.setAria(arguments.length <= 0 ? void 0 : arguments[0], arguments.length <= 1 ? void 0 : arguments[1])
                }
            };
            return RecurrenceEditor
        }(_editor.default);
        (0, _component_registrator.default)("dxRecurrenceEditor", RecurrenceEditor);
        var _default = RecurrenceEditor;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/callbackiterresult.js ***!
      \***************************************************************/
    /*! exports provided: default */
    /*! exports used: default */
    function(module, __webpack_exports__, __webpack_require__) {
        var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__( /*! tslib */ 120);
        var __WEBPACK_IMPORTED_MODULE_1__iterresult__ = __webpack_require__( /*! ./iterresult */ 295);
        var CallbackIterResult = function(_super) {
            Object(__WEBPACK_IMPORTED_MODULE_0_tslib__.b)(CallbackIterResult, _super);

            function CallbackIterResult(method, args, iterator) {
                var _this = _super.call(this, method, args) || this;
                _this.iterator = iterator;
                return _this
            }
            CallbackIterResult.prototype.add = function(date) {
                if (this.iterator(date, this._result.length)) {
                    this._result.push(date);
                    return true
                }
                return false
            };
            return CallbackIterResult
        }(__WEBPACK_IMPORTED_MODULE_1__iterresult__.a);
        __webpack_exports__.a = CallbackIterResult
    },
    /*!*******************************!*\
      !*** external "window.luxon" ***!
      \*******************************/
    /*! dynamic exports provided */
    /*! exports used: DateTime */
    function(module, exports) {
        module.exports = window.luxon
    },
    /*!**************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/cache.js ***!
      \**************************************************/
    /*! exports provided: Cache */
    /*! exports used: Cache */
    function(module, __webpack_exports__, __webpack_require__) {
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return Cache
        });
        var __WEBPACK_IMPORTED_MODULE_0__iterresult__ = __webpack_require__( /*! ./iterresult */ 295);
        var __WEBPACK_IMPORTED_MODULE_1__dateutil__ = __webpack_require__( /*! ./dateutil */ 62);
        var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__( /*! ./helpers */ 63);
        var Cache = function() {
            function Cache() {
                this.all = false;
                this.before = [];
                this.after = [];
                this.between = []
            }
            Cache.prototype._cacheAdd = function(what, value, args) {
                if (value) {
                    value = value instanceof Date ? __WEBPACK_IMPORTED_MODULE_1__dateutil__.b.clone(value) : __WEBPACK_IMPORTED_MODULE_1__dateutil__.b.cloneDates(value)
                }
                if ("all" === what) {
                    this.all = value
                } else {
                    args._value = value;
                    this[what].push(args)
                }
            };
            Cache.prototype._cacheGet = function(what, args) {
                var cached = false;
                var argsKeys = args ? Object.keys(args) : [];
                var findCacheDiff = function(item) {
                    for (var i = 0; i < argsKeys.length; i++) {
                        var key = argsKeys[i];
                        if (String(args[key]) !== String(item[key])) {
                            return true
                        }
                    }
                    return false
                };
                var cachedObject = this[what];
                if ("all" === what) {
                    cached = this.all
                } else {
                    if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.d)(cachedObject)) {
                        for (var i = 0; i < cachedObject.length; i++) {
                            var item = cachedObject[i];
                            if (argsKeys.length && findCacheDiff(item)) {
                                continue
                            }
                            cached = item._value;
                            break
                        }
                    }
                }
                if (!cached && this.all) {
                    var iterResult = new __WEBPACK_IMPORTED_MODULE_0__iterresult__.a(what, args);
                    for (var i = 0; i < this.all.length; i++) {
                        if (!iterResult.accept(this.all[i])) {
                            break
                        }
                    }
                    cached = iterResult.getValue();
                    this._cacheAdd(what, cached, args)
                }
                return Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.d)(cached) ? __WEBPACK_IMPORTED_MODULE_1__dateutil__.b.cloneDates(cached) : cached instanceof Date ? __WEBPACK_IMPORTED_MODULE_1__dateutil__.b.clone(cached) : cached
            };
            return Cache
        }()
    },
    /*!***********************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/iterinfo/index.js ***!
      \***********************************************************/
    /*! exports provided: default */
    /*! exports used: default */
    function(module, __webpack_exports__, __webpack_require__) {
        var __WEBPACK_IMPORTED_MODULE_0__dateutil__ = __webpack_require__( /*! ../dateutil */ 62);
        var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__( /*! ../helpers */ 63);
        var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__( /*! ../types */ 140);
        var __WEBPACK_IMPORTED_MODULE_3__yearinfo__ = __webpack_require__( /*! ./yearinfo */ 794);
        var __WEBPACK_IMPORTED_MODULE_4__monthinfo__ = __webpack_require__( /*! ./monthinfo */ 796);
        var __WEBPACK_IMPORTED_MODULE_5__easter__ = __webpack_require__( /*! ./easter */ 797);
        var __WEBPACK_IMPORTED_MODULE_6__datetime__ = __webpack_require__( /*! ../datetime */ 296);
        var Iterinfo = function() {
            function Iterinfo(options) {
                this.options = options
            }
            Iterinfo.prototype.rebuild = function(year, month) {
                var options = this.options;
                if (year !== this.lastyear) {
                    this.yearinfo = Object(__WEBPACK_IMPORTED_MODULE_3__yearinfo__.a)(year, options)
                }
                if (Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.h)(options.bynweekday) && (month !== this.lastmonth || year !== this.lastyear)) {
                    var _a = this.yearinfo,
                        yearlen = _a.yearlen,
                        mrange = _a.mrange,
                        wdaymask = _a.wdaymask;
                    this.monthinfo = Object(__WEBPACK_IMPORTED_MODULE_4__monthinfo__.a)(year, month, yearlen, mrange, wdaymask, options)
                }
                if (Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.f)(options.byeaster)) {
                    this.eastermask = Object(__WEBPACK_IMPORTED_MODULE_5__easter__.a)(year, options.byeaster)
                }
            };
            Object.defineProperty(Iterinfo.prototype, "lastyear", {
                get: function() {
                    return this.monthinfo ? this.monthinfo.lastyear : null
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Iterinfo.prototype, "lastmonth", {
                get: function() {
                    return this.monthinfo ? this.monthinfo.lastmonth : null
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Iterinfo.prototype, "yearlen", {
                get: function() {
                    return this.yearinfo.yearlen
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Iterinfo.prototype, "yearordinal", {
                get: function() {
                    return this.yearinfo.yearordinal
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Iterinfo.prototype, "mrange", {
                get: function() {
                    return this.yearinfo.mrange
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Iterinfo.prototype, "wdaymask", {
                get: function() {
                    return this.yearinfo.wdaymask
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Iterinfo.prototype, "mmask", {
                get: function() {
                    return this.yearinfo.mmask
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Iterinfo.prototype, "wnomask", {
                get: function() {
                    return this.yearinfo.wnomask
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Iterinfo.prototype, "nwdaymask", {
                get: function() {
                    return this.monthinfo ? this.monthinfo.nwdaymask : []
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Iterinfo.prototype, "nextyearlen", {
                get: function() {
                    return this.yearinfo.nextyearlen
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Iterinfo.prototype, "mdaymask", {
                get: function() {
                    return this.yearinfo.mdaymask
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Iterinfo.prototype, "nmdaymask", {
                get: function() {
                    return this.yearinfo.nmdaymask
                },
                enumerable: true,
                configurable: true
            });
            Iterinfo.prototype.ydayset = function() {
                return [Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.k)(this.yearlen), 0, this.yearlen]
            };
            Iterinfo.prototype.mdayset = function(_, month, __) {
                var start = this.mrange[month - 1];
                var end = this.mrange[month];
                var set = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(null, this.yearlen);
                for (var i = start; i < end; i++) {
                    set[i] = i
                }
                return [set, start, end]
            };
            Iterinfo.prototype.wdayset = function(year, month, day) {
                var set = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(null, this.yearlen + 7);
                var i = __WEBPACK_IMPORTED_MODULE_0__dateutil__.b.toOrdinal(new Date(Date.UTC(year, month - 1, day))) - this.yearordinal;
                var start = i;
                for (var j = 0; j < 7; j++) {
                    set[i] = i;
                    ++i;
                    if (this.wdaymask[i] === this.options.wkst) {
                        break
                    }
                }
                return [set, start, i]
            };
            Iterinfo.prototype.ddayset = function(year, month, day) {
                var set = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(null, this.yearlen);
                var i = __WEBPACK_IMPORTED_MODULE_0__dateutil__.b.toOrdinal(new Date(Date.UTC(year, month - 1, day))) - this.yearordinal;
                set[i] = i;
                return [set, i, i + 1]
            };
            Iterinfo.prototype.htimeset = function(hour, _, second, millisecond) {
                var _this = this;
                var set = [];
                this.options.byminute.forEach(function(minute) {
                    set = set.concat(_this.mtimeset(hour, minute, second, millisecond))
                });
                __WEBPACK_IMPORTED_MODULE_0__dateutil__.b.sort(set);
                return set
            };
            Iterinfo.prototype.mtimeset = function(hour, minute, _, millisecond) {
                var set = this.options.bysecond.map(function(second) {
                    return new __WEBPACK_IMPORTED_MODULE_6__datetime__.b(hour, minute, second, millisecond)
                });
                __WEBPACK_IMPORTED_MODULE_0__dateutil__.b.sort(set);
                return set
            };
            Iterinfo.prototype.stimeset = function(hour, minute, second, millisecond) {
                return [new __WEBPACK_IMPORTED_MODULE_6__datetime__.b(hour, minute, second, millisecond)]
            };
            Iterinfo.prototype.getdayset = function(freq) {
                switch (freq) {
                    case __WEBPACK_IMPORTED_MODULE_2__types__.a.YEARLY:
                        return this.ydayset.bind(this);
                    case __WEBPACK_IMPORTED_MODULE_2__types__.a.MONTHLY:
                        return this.mdayset.bind(this);
                    case __WEBPACK_IMPORTED_MODULE_2__types__.a.WEEKLY:
                        return this.wdayset.bind(this);
                    case __WEBPACK_IMPORTED_MODULE_2__types__.a.DAILY:
                        return this.ddayset.bind(this);
                    default:
                        return this.ddayset.bind(this)
                }
            };
            Iterinfo.prototype.gettimeset = function(freq) {
                switch (freq) {
                    case __WEBPACK_IMPORTED_MODULE_2__types__.a.HOURLY:
                        return this.htimeset.bind(this);
                    case __WEBPACK_IMPORTED_MODULE_2__types__.a.MINUTELY:
                        return this.mtimeset.bind(this);
                    case __WEBPACK_IMPORTED_MODULE_2__types__.a.SECONDLY:
                        return this.stimeset.bind(this)
                }
            };
            return Iterinfo
        }();
        __webpack_exports__.a = Iterinfo
    },
    /*!**************************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/iterinfo/yearinfo.js ***!
      \**************************************************************/
    /*! exports provided: rebuildYear */
    /*! exports used: rebuildYear */
    function(module, __webpack_exports__, __webpack_require__) {
        __webpack_exports__.a = rebuildYear;
        var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__( /*! tslib */ 120);
        var __WEBPACK_IMPORTED_MODULE_1__dateutil__ = __webpack_require__( /*! ../dateutil */ 62);
        var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__( /*! ../helpers */ 63);
        var __WEBPACK_IMPORTED_MODULE_3__masks__ = __webpack_require__( /*! ../masks */ 795);

        function rebuildYear(year, options) {
            var firstyday = new Date(Date.UTC(year, 0, 1));
            var yearlen = __WEBPACK_IMPORTED_MODULE_1__dateutil__.b.isLeapYear(year) ? 366 : 365;
            var nextyearlen = __WEBPACK_IMPORTED_MODULE_1__dateutil__.b.isLeapYear(year + 1) ? 366 : 365;
            var yearordinal = __WEBPACK_IMPORTED_MODULE_1__dateutil__.b.toOrdinal(firstyday);
            var yearweekday = __WEBPACK_IMPORTED_MODULE_1__dateutil__.b.getWeekday(firstyday);
            var result = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__.a)(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__.a)({
                yearlen: yearlen,
                nextyearlen: nextyearlen,
                yearordinal: yearordinal,
                yearweekday: yearweekday
            }, baseYearMasks(year)), {
                wnomask: null
            });
            if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.b)(options.byweekno)) {
                return result
            }
            result.wnomask = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.l)(0, yearlen + 7);
            var firstwkst;
            var wyearlen;
            var no1wkst = firstwkst = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.j)(7 - yearweekday + options.wkst, 7);
            if (no1wkst >= 4) {
                no1wkst = 0;
                wyearlen = result.yearlen + Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.j)(yearweekday - options.wkst, 7)
            } else {
                wyearlen = yearlen - no1wkst
            }
            var div = Math.floor(wyearlen / 7);
            var mod = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.j)(wyearlen, 7);
            var numweeks = Math.floor(div + mod / 4);
            for (var j = 0; j < options.byweekno.length; j++) {
                var n = options.byweekno[j];
                if (n < 0) {
                    n += numweeks + 1
                }
                if (!(n > 0 && n <= numweeks)) {
                    continue
                }
                var i = void 0;
                if (n > 1) {
                    i = no1wkst + 7 * (n - 1);
                    if (no1wkst !== firstwkst) {
                        i -= 7 - firstwkst
                    }
                } else {
                    i = no1wkst
                }
                for (var k = 0; k < 7; k++) {
                    result.wnomask[i] = 1;
                    i++;
                    if (result.wdaymask[i] === options.wkst) {
                        break
                    }
                }
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.c)(options.byweekno, 1)) {
                var i = no1wkst + 7 * numweeks;
                if (no1wkst !== firstwkst) {
                    i -= 7 - firstwkst
                }
                if (i < yearlen) {
                    for (var j = 0; j < 7; j++) {
                        result.wnomask[i] = 1;
                        i += 1;
                        if (result.wdaymask[i] === options.wkst) {
                            break
                        }
                    }
                }
            }
            if (no1wkst) {
                var lnumweeks = void 0;
                if (!Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.c)(options.byweekno, -1)) {
                    var lyearweekday = __WEBPACK_IMPORTED_MODULE_1__dateutil__.b.getWeekday(new Date(Date.UTC(year - 1, 0, 1)));
                    var lno1wkst = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.j)(7 - lyearweekday.valueOf() + options.wkst, 7);
                    var lyearlen = __WEBPACK_IMPORTED_MODULE_1__dateutil__.b.isLeapYear(year - 1) ? 366 : 365;
                    var weekst = void 0;
                    if (lno1wkst >= 4) {
                        lno1wkst = 0;
                        weekst = lyearlen + Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.j)(lyearweekday - options.wkst, 7)
                    } else {
                        weekst = yearlen - no1wkst
                    }
                    lnumweeks = Math.floor(52 + Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.j)(weekst, 7) / 4)
                } else {
                    lnumweeks = -1
                }
                if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.c)(options.byweekno, lnumweeks)) {
                    for (var i = 0; i < no1wkst; i++) {
                        result.wnomask[i] = 1
                    }
                }
            }
            return result
        }

        function baseYearMasks(year) {
            var yearlen = __WEBPACK_IMPORTED_MODULE_1__dateutil__.b.isLeapYear(year) ? 366 : 365;
            var firstyday = new Date(Date.UTC(year, 0, 1));
            var wday = __WEBPACK_IMPORTED_MODULE_1__dateutil__.b.getWeekday(firstyday);
            if (365 === yearlen) {
                return {
                    mmask: __WEBPACK_IMPORTED_MODULE_3__masks__.a,
                    mdaymask: __WEBPACK_IMPORTED_MODULE_3__masks__.e,
                    nmdaymask: __WEBPACK_IMPORTED_MODULE_3__masks__.g,
                    wdaymask: __WEBPACK_IMPORTED_MODULE_3__masks__.i.slice(wday),
                    mrange: __WEBPACK_IMPORTED_MODULE_3__masks__.b
                }
            }
            return {
                mmask: __WEBPACK_IMPORTED_MODULE_3__masks__.c,
                mdaymask: __WEBPACK_IMPORTED_MODULE_3__masks__.f,
                nmdaymask: __WEBPACK_IMPORTED_MODULE_3__masks__.h,
                wdaymask: __WEBPACK_IMPORTED_MODULE_3__masks__.i.slice(wday),
                mrange: __WEBPACK_IMPORTED_MODULE_3__masks__.d
            }
        }
    },
    /*!**************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/masks.js ***!
      \**************************************************/
    /*! exports provided: WDAYMASK, M365MASK, M365RANGE, M366MASK, M366RANGE, MDAY365MASK, MDAY366MASK, NMDAY365MASK, NMDAY366MASK */
    /*! exports used: M365MASK, M365RANGE, M366MASK, M366RANGE, MDAY365MASK, MDAY366MASK, NMDAY365MASK, NMDAY366MASK, WDAYMASK */
    function(module, __webpack_exports__, __webpack_require__) {
        __webpack_require__.d(__webpack_exports__, "i", function() {
            return WDAYMASK
        });
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return M365MASK
        });
        __webpack_require__.d(__webpack_exports__, "b", function() {
            return M365RANGE
        });
        __webpack_require__.d(__webpack_exports__, "c", function() {
            return M366MASK
        });
        __webpack_require__.d(__webpack_exports__, "d", function() {
            return M366RANGE
        });
        __webpack_require__.d(__webpack_exports__, "e", function() {
            return MDAY365MASK
        });
        __webpack_require__.d(__webpack_exports__, "f", function() {
            return MDAY366MASK
        });
        __webpack_require__.d(__webpack_exports__, "g", function() {
            return NMDAY365MASK
        });
        __webpack_require__.d(__webpack_exports__, "h", function() {
            return NMDAY366MASK
        });
        var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__( /*! tslib */ 120);
        var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__( /*! ./helpers */ 63);
        var M365MASK = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__.c)(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(1, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(2, 28), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(3, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(4, 30), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(5, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(6, 30), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(7, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(8, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(9, 30), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(10, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(11, 30), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(12, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(1, 7));
        var M366MASK = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__.c)(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(1, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(2, 29), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(3, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(4, 30), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(5, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(6, 30), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(7, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(8, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(9, 30), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(10, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(11, 30), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(12, 31), Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(1, 7));
        var M28 = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.k)(1, 29);
        var M29 = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.k)(1, 30);
        var M30 = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.k)(1, 31);
        var M31 = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.k)(1, 32);
        var MDAY366MASK = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__.c)(M31, M29, M31, M30, M31, M30, M31, M31, M30, M31, M30, M31, M31.slice(0, 7));
        var MDAY365MASK = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__.c)(M31, M28, M31, M30, M31, M30, M31, M31, M30, M31, M30, M31, M31.slice(0, 7));
        var NM28 = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.k)(-28, 0);
        var NM29 = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.k)(-29, 0);
        var NM30 = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.k)(-30, 0);
        var NM31 = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.k)(-31, 0);
        var NMDAY366MASK = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__.c)(NM31, NM29, NM31, NM30, NM31, NM30, NM31, NM31, NM30, NM31, NM30, NM31, NM31.slice(0, 7));
        var NMDAY365MASK = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__.c)(NM31, NM28, NM31, NM30, NM31, NM30, NM31, NM31, NM30, NM31, NM30, NM31, NM31.slice(0, 7));
        var M366RANGE = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335, 366];
        var M365RANGE = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365];
        var WDAYMASK = function() {
            var wdaymask = [];
            for (var i = 0; i < 55; i++) {
                wdaymask = wdaymask.concat(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.k)(7))
            }
            return wdaymask
        }()
    },
    /*!***************************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/iterinfo/monthinfo.js ***!
      \***************************************************************/
    /*! exports provided: rebuildMonth */
    /*! exports used: rebuildMonth */
    function(module, __webpack_exports__, __webpack_require__) {
        __webpack_exports__.a = rebuildMonth;
        var __WEBPACK_IMPORTED_MODULE_0__rrule__ = __webpack_require__( /*! ../rrule */ 119);
        var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__( /*! ../helpers */ 63);

        function rebuildMonth(year, month, yearlen, mrange, wdaymask, options) {
            var result = {
                lastyear: year,
                lastmonth: month,
                nwdaymask: []
            };
            var ranges = [];
            if (options.freq === __WEBPACK_IMPORTED_MODULE_0__rrule__.c.YEARLY) {
                if (Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.b)(options.bymonth)) {
                    ranges = [
                        [0, yearlen]
                    ]
                } else {
                    for (var j = 0; j < options.bymonth.length; j++) {
                        month = options.bymonth[j];
                        ranges.push(mrange.slice(month - 1, month + 1))
                    }
                }
            } else {
                if (options.freq === __WEBPACK_IMPORTED_MODULE_0__rrule__.c.MONTHLY) {
                    ranges = [mrange.slice(month - 1, month + 1)]
                }
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.b)(ranges)) {
                return result
            }
            result.nwdaymask = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.l)(0, yearlen);
            for (var j = 0; j < ranges.length; j++) {
                var rang = ranges[j];
                var first = rang[0];
                var last = rang[1] - 1;
                for (var k = 0; k < options.bynweekday.length; k++) {
                    var i = void 0;
                    var _a = options.bynweekday[k],
                        wday = _a[0],
                        n = _a[1];
                    if (n < 0) {
                        i = last + 7 * (n + 1);
                        i -= Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.j)(wdaymask[i] - wday, 7)
                    } else {
                        i = first + 7 * (n - 1);
                        i += Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.j)(7 - wdaymask[i] + wday, 7)
                    }
                    if (first <= i && i <= last) {
                        result.nwdaymask[i] = 1
                    }
                }
            }
            return result
        }
    },
    /*!************************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/iterinfo/easter.js ***!
      \************************************************************/
    /*! exports provided: easter */
    /*! exports used: easter */
    function(module, __webpack_exports__, __webpack_require__) {
        __webpack_exports__.a = easter;

        function easter(y, offset) {
            if (void 0 === offset) {
                offset = 0
            }
            var a = y % 19;
            var b = Math.floor(y / 100);
            var c = y % 100;
            var d = Math.floor(b / 4);
            var e = b % 4;
            var f = Math.floor((b + 8) / 25);
            var g = Math.floor((b - f + 1) / 3);
            var h = Math.floor(19 * a + b - d - g + 15) % 30;
            var i = Math.floor(c / 4);
            var k = c % 4;
            var l = Math.floor(32 + 2 * e + 2 * i - h - k) % 7;
            var m = Math.floor((a + 11 * h + 22 * l) / 451);
            var month = Math.floor((h + l - 7 * m + 114) / 31);
            var day = (h + l - 7 * m + 114) % 31 + 1;
            var date = Date.UTC(y, month - 1, day + offset);
            var yearStart = Date.UTC(y, 0, 1);
            return [Math.ceil((date - yearStart) / 864e5)]
        }
    },
    /*!*********************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/iter/poslist.js ***!
      \*********************************************************/
    /*! exports provided: buildPoslist */
    /*! exports used: buildPoslist */
    function(module, __webpack_exports__, __webpack_require__) {
        __webpack_exports__.a = buildPoslist;
        var __WEBPACK_IMPORTED_MODULE_0__dateutil__ = __webpack_require__( /*! ../dateutil */ 62);
        var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__( /*! ../helpers */ 63);

        function buildPoslist(bysetpos, timeset, start, end, ii, dayset) {
            var poslist = [];
            for (var j = 0; j < bysetpos.length; j++) {
                var daypos = void 0;
                var timepos = void 0;
                var pos = bysetpos[j];
                if (pos < 0) {
                    daypos = Math.floor(pos / timeset.length);
                    timepos = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.j)(pos, timeset.length)
                } else {
                    daypos = Math.floor((pos - 1) / timeset.length);
                    timepos = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.j)(pos - 1, timeset.length)
                }
                var tmp = [];
                for (var k = start; k < end; k++) {
                    var val = dayset[k];
                    if (!Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.f)(val)) {
                        continue
                    }
                    tmp.push(val)
                }
                var i = void 0;
                if (daypos < 0) {
                    i = tmp.slice(daypos)[0]
                } else {
                    i = tmp[daypos]
                }
                var time = timeset[timepos];
                var date = __WEBPACK_IMPORTED_MODULE_0__dateutil__.b.fromOrdinal(ii.yearordinal + i);
                var res = __WEBPACK_IMPORTED_MODULE_0__dateutil__.b.combine(date, time);
                if (!Object(__WEBPACK_IMPORTED_MODULE_1__helpers__.c)(poslist, res)) {
                    poslist.push(res)
                }
            }
            __WEBPACK_IMPORTED_MODULE_0__dateutil__.b.sort(poslist);
            return poslist
        }
    },
    /*!******************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/nlp/index.js ***!
      \******************************************************/
    /*! exports provided: fromText, parseText, isFullyConvertible, toText */
    /*! all exports used */
    function(module, __webpack_exports__, __webpack_require__) {
        Object.defineProperty(__webpack_exports__, "__esModule", {
            value: true
        });
        __webpack_require__.d(__webpack_exports__, "fromText", function() {
            return fromText
        });
        __webpack_require__.d(__webpack_exports__, "isFullyConvertible", function() {
            return isFullyConvertible
        });
        __webpack_require__.d(__webpack_exports__, "toText", function() {
            return toText
        });
        var __WEBPACK_IMPORTED_MODULE_0__totext__ = __webpack_require__( /*! ./totext */ 800);
        var __WEBPACK_IMPORTED_MODULE_1__parsetext__ = __webpack_require__( /*! ./parsetext */ 801);
        var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__( /*! ../index */ 220);
        var __WEBPACK_IMPORTED_MODULE_3__i18n__ = __webpack_require__( /*! ./i18n */ 298);
        __webpack_require__.d(__webpack_exports__, "parseText", function() {
            return __WEBPACK_IMPORTED_MODULE_1__parsetext__.a
        });
        /*!
         * rrule.js - Library for working with recurrence rules for calendar dates.
         * https://github.com/jakubroztocil/rrule
         *
         * Copyright 2010, Jakub Roztocil and Lars Schoning
         * Licenced under the BSD licence.
         * https://github.com/jakubroztocil/rrule/blob/master/LICENCE
         *
         */
        var fromText = function(text, language) {
            if (void 0 === language) {
                language = __WEBPACK_IMPORTED_MODULE_3__i18n__.a
            }
            return new __WEBPACK_IMPORTED_MODULE_2__index__.default(Object(__WEBPACK_IMPORTED_MODULE_1__parsetext__.a)(text, language) || void 0)
        };
        var common = ["count", "until", "interval", "byweekday", "bymonthday", "bymonth"];
        __WEBPACK_IMPORTED_MODULE_0__totext__.a.IMPLEMENTED = [];
        __WEBPACK_IMPORTED_MODULE_0__totext__.a.IMPLEMENTED[__WEBPACK_IMPORTED_MODULE_2__index__.default.HOURLY] = common;
        __WEBPACK_IMPORTED_MODULE_0__totext__.a.IMPLEMENTED[__WEBPACK_IMPORTED_MODULE_2__index__.default.MINUTELY] = common;
        __WEBPACK_IMPORTED_MODULE_0__totext__.a.IMPLEMENTED[__WEBPACK_IMPORTED_MODULE_2__index__.default.DAILY] = ["byhour"].concat(common);
        __WEBPACK_IMPORTED_MODULE_0__totext__.a.IMPLEMENTED[__WEBPACK_IMPORTED_MODULE_2__index__.default.WEEKLY] = common;
        __WEBPACK_IMPORTED_MODULE_0__totext__.a.IMPLEMENTED[__WEBPACK_IMPORTED_MODULE_2__index__.default.MONTHLY] = common;
        __WEBPACK_IMPORTED_MODULE_0__totext__.a.IMPLEMENTED[__WEBPACK_IMPORTED_MODULE_2__index__.default.YEARLY] = ["byweekno", "byyearday"].concat(common);
        var toText = function(rrule, gettext, language, dateFormatter) {
            return new __WEBPACK_IMPORTED_MODULE_0__totext__.a(rrule, gettext, language, dateFormatter).toString()
        };
        var isFullyConvertible = __WEBPACK_IMPORTED_MODULE_0__totext__.a.isFullyConvertible
    },
    /*!*******************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/nlp/totext.js ***!
      \*******************************************************/
    /*! exports provided: default */
    /*! exports used: default */
    function(module, __webpack_exports__, __webpack_require__) {
        var __WEBPACK_IMPORTED_MODULE_0__i18n__ = __webpack_require__( /*! ./i18n */ 298);
        var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__( /*! ../index */ 220);
        var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__( /*! ../helpers */ 63);
        var contains = function(arr, val) {
            return arr.indexOf(val) !== -1
        };
        var defaultGetText = function(id) {
            return id.toString()
        };
        var defaultDateFormatter = function(year, month, day) {
            return month + " " + day + ", " + year
        };
        var ToText = function() {
            function ToText(rrule, gettext, language, dateFormatter) {
                if (void 0 === gettext) {
                    gettext = defaultGetText
                }
                if (void 0 === language) {
                    language = __WEBPACK_IMPORTED_MODULE_0__i18n__.a
                }
                if (void 0 === dateFormatter) {
                    dateFormatter = defaultDateFormatter
                }
                this.text = [];
                this.language = language || __WEBPACK_IMPORTED_MODULE_0__i18n__.a;
                this.gettext = gettext;
                this.dateFormatter = dateFormatter;
                this.rrule = rrule;
                this.options = rrule.options;
                this.origOptions = rrule.origOptions;
                if (this.origOptions.bymonthday) {
                    var bymonthday = [].concat(this.options.bymonthday);
                    var bynmonthday = [].concat(this.options.bynmonthday);
                    bymonthday.sort(function(a, b) {
                        return a - b
                    });
                    bynmonthday.sort(function(a, b) {
                        return b - a
                    });
                    this.bymonthday = bymonthday.concat(bynmonthday);
                    if (!this.bymonthday.length) {
                        this.bymonthday = null
                    }
                }
                if (Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.f)(this.origOptions.byweekday)) {
                    var byweekday = !Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.d)(this.origOptions.byweekday) ? [this.origOptions.byweekday] : this.origOptions.byweekday;
                    var days = String(byweekday);
                    this.byweekday = {
                        allWeeks: byweekday.filter(function(weekday) {
                            return !weekday.n
                        }),
                        someWeeks: byweekday.filter(function(weekday) {
                            return Boolean(weekday.n)
                        }),
                        isWeekdays: days.indexOf("MO") !== -1 && days.indexOf("TU") !== -1 && days.indexOf("WE") !== -1 && days.indexOf("TH") !== -1 && days.indexOf("FR") !== -1 && days.indexOf("SA") === -1 && days.indexOf("SU") === -1,
                        isEveryDay: days.indexOf("MO") !== -1 && days.indexOf("TU") !== -1 && days.indexOf("WE") !== -1 && days.indexOf("TH") !== -1 && days.indexOf("FR") !== -1 && days.indexOf("SA") !== -1 && days.indexOf("SU") !== -1
                    };
                    var sortWeekDays = function(a, b) {
                        return a.weekday - b.weekday
                    };
                    this.byweekday.allWeeks.sort(sortWeekDays);
                    this.byweekday.someWeeks.sort(sortWeekDays);
                    if (!this.byweekday.allWeeks.length) {
                        this.byweekday.allWeeks = null
                    }
                    if (!this.byweekday.someWeeks.length) {
                        this.byweekday.someWeeks = null
                    }
                } else {
                    this.byweekday = null
                }
            }
            ToText.isFullyConvertible = function(rrule) {
                var canConvert = true;
                if (!(rrule.options.freq in ToText.IMPLEMENTED)) {
                    return false
                }
                if (rrule.origOptions.until && rrule.origOptions.count) {
                    return false
                }
                for (var key in rrule.origOptions) {
                    if (contains(["dtstart", "wkst", "freq"], key)) {
                        return true
                    }
                    if (!contains(ToText.IMPLEMENTED[rrule.options.freq], key)) {
                        return false
                    }
                }
                return canConvert
            };
            ToText.prototype.isFullyConvertible = function() {
                return ToText.isFullyConvertible(this.rrule)
            };
            ToText.prototype.toString = function() {
                var gettext = this.gettext;
                if (!(this.options.freq in ToText.IMPLEMENTED)) {
                    return gettext("RRule error: Unable to fully convert this rrule to text")
                }
                this.text = [gettext("every")];
                this[__WEBPACK_IMPORTED_MODULE_1__index__.default.FREQUENCIES[this.options.freq]]();
                if (this.options.until) {
                    this.add(gettext("until"));
                    var until = this.options.until;
                    this.add(this.dateFormatter(until.getUTCFullYear(), this.language.monthNames[until.getUTCMonth()], until.getUTCDate()))
                } else {
                    if (this.options.count) {
                        this.add(gettext("for")).add(this.options.count.toString()).add(this.plural(this.options.count) ? gettext("times") : gettext("time"))
                    }
                }
                if (!this.isFullyConvertible()) {
                    this.add(gettext("(~ approximate)"))
                }
                return this.text.join("")
            };
            ToText.prototype.HOURLY = function() {
                var gettext = this.gettext;
                if (1 !== this.options.interval) {
                    this.add(this.options.interval.toString())
                }
                this.add(this.plural(this.options.interval) ? gettext("hours") : gettext("hour"))
            };
            ToText.prototype.MINUTELY = function() {
                var gettext = this.gettext;
                if (1 !== this.options.interval) {
                    this.add(this.options.interval.toString())
                }
                this.add(this.plural(this.options.interval) ? gettext("minutes") : gettext("minute"))
            };
            ToText.prototype.DAILY = function() {
                var gettext = this.gettext;
                if (1 !== this.options.interval) {
                    this.add(this.options.interval.toString())
                }
                if (this.byweekday && this.byweekday.isWeekdays) {
                    this.add(this.plural(this.options.interval) ? gettext("weekdays") : gettext("weekday"))
                } else {
                    this.add(this.plural(this.options.interval) ? gettext("days") : gettext("day"))
                }
                if (this.origOptions.bymonth) {
                    this.add(gettext("in"));
                    this._bymonth()
                }
                if (this.bymonthday) {
                    this._bymonthday()
                } else {
                    if (this.byweekday) {
                        this._byweekday()
                    } else {
                        if (this.origOptions.byhour) {
                            this._byhour()
                        }
                    }
                }
            };
            ToText.prototype.WEEKLY = function() {
                var gettext = this.gettext;
                if (1 !== this.options.interval) {
                    this.add(this.options.interval.toString()).add(this.plural(this.options.interval) ? gettext("weeks") : gettext("week"))
                }
                if (this.byweekday && this.byweekday.isWeekdays) {
                    if (1 === this.options.interval) {
                        this.add(this.plural(this.options.interval) ? gettext("weekdays") : gettext("weekday"))
                    } else {
                        this.add(gettext("on")).add(gettext("weekdays"))
                    }
                } else {
                    if (this.byweekday && this.byweekday.isEveryDay) {
                        this.add(this.plural(this.options.interval) ? gettext("days") : gettext("day"))
                    } else {
                        if (1 === this.options.interval) {
                            this.add(gettext("week"))
                        }
                        if (this.origOptions.bymonth) {
                            this.add(gettext("in"));
                            this._bymonth()
                        }
                        if (this.bymonthday) {
                            this._bymonthday()
                        } else {
                            if (this.byweekday) {
                                this._byweekday()
                            }
                        }
                    }
                }
            };
            ToText.prototype.MONTHLY = function() {
                var gettext = this.gettext;
                if (this.origOptions.bymonth) {
                    if (1 !== this.options.interval) {
                        this.add(this.options.interval.toString()).add(gettext("months"));
                        if (this.plural(this.options.interval)) {
                            this.add(gettext("in"))
                        }
                    } else {}
                    this._bymonth()
                } else {
                    if (1 !== this.options.interval) {
                        this.add(this.options.interval.toString())
                    }
                    this.add(this.plural(this.options.interval) ? gettext("months") : gettext("month"))
                }
                if (this.bymonthday) {
                    this._bymonthday()
                } else {
                    if (this.byweekday && this.byweekday.isWeekdays) {
                        this.add(gettext("on")).add(gettext("weekdays"))
                    } else {
                        if (this.byweekday) {
                            this._byweekday()
                        }
                    }
                }
            };
            ToText.prototype.YEARLY = function() {
                var gettext = this.gettext;
                if (this.origOptions.bymonth) {
                    if (1 !== this.options.interval) {
                        this.add(this.options.interval.toString());
                        this.add(gettext("years"))
                    } else {}
                    this._bymonth()
                } else {
                    if (1 !== this.options.interval) {
                        this.add(this.options.interval.toString())
                    }
                    this.add(this.plural(this.options.interval) ? gettext("years") : gettext("year"))
                }
                if (this.bymonthday) {
                    this._bymonthday()
                } else {
                    if (this.byweekday) {
                        this._byweekday()
                    }
                }
                if (this.options.byyearday) {
                    this.add(gettext("on the")).add(this.list(this.options.byyearday, this.nth, gettext("and"))).add(gettext("day"))
                }
                if (this.options.byweekno) {
                    this.add(gettext("in")).add(this.plural(this.options.byweekno.length) ? gettext("weeks") : gettext("week")).add(this.list(this.options.byweekno, void 0, gettext("and")))
                }
            };
            ToText.prototype._bymonthday = function() {
                var gettext = this.gettext;
                if (this.byweekday && this.byweekday.allWeeks) {
                    this.add(gettext("on")).add(this.list(this.byweekday.allWeeks, this.weekdaytext, gettext("or"))).add(gettext("the")).add(this.list(this.bymonthday, this.nth, gettext("or")))
                } else {
                    this.add(gettext("on the")).add(this.list(this.bymonthday, this.nth, gettext("and")))
                }
            };
            ToText.prototype._byweekday = function() {
                var gettext = this.gettext;
                if (this.byweekday.allWeeks && !this.byweekday.isWeekdays) {
                    this.add(gettext("on")).add(this.list(this.byweekday.allWeeks, this.weekdaytext))
                }
                if (this.byweekday.someWeeks) {
                    if (this.byweekday.allWeeks) {
                        this.add(gettext("and"))
                    }
                    this.add(gettext("on the")).add(this.list(this.byweekday.someWeeks, this.weekdaytext, gettext("and")))
                }
            };
            ToText.prototype._byhour = function() {
                var gettext = this.gettext;
                this.add(gettext("at")).add(this.list(this.origOptions.byhour, void 0, gettext("and")))
            };
            ToText.prototype._bymonth = function() {
                this.add(this.list(this.options.bymonth, this.monthtext, this.gettext("and")))
            };
            ToText.prototype.nth = function(n) {
                n = parseInt(n.toString(), 10);
                var nth;
                var npos;
                var gettext = this.gettext;
                if (n === -1) {
                    return gettext("last")
                }
                npos = Math.abs(n);
                switch (npos) {
                    case 1:
                    case 21:
                    case 31:
                        nth = npos + gettext("st");
                        break;
                    case 2:
                    case 22:
                        nth = npos + gettext("nd");
                        break;
                    case 3:
                    case 23:
                        nth = npos + gettext("rd");
                        break;
                    default:
                        nth = npos + gettext("th")
                }
                return n < 0 ? nth + " " + gettext("last") : nth
            };
            ToText.prototype.monthtext = function(m) {
                return this.language.monthNames[m - 1]
            };
            ToText.prototype.weekdaytext = function(wday) {
                var weekday = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.e)(wday) ? (wday + 1) % 7 : wday.getJsWeekday();
                return (wday.n ? this.nth(wday.n) + " " : "") + this.language.dayNames[weekday]
            };
            ToText.prototype.plural = function(n) {
                return n % 100 !== 1
            };
            ToText.prototype.add = function(s) {
                this.text.push(" ");
                this.text.push(s);
                return this
            };
            ToText.prototype.list = function(arr, callback, finalDelim, delim) {
                if (void 0 === delim) {
                    delim = ","
                }
                if (!Object(__WEBPACK_IMPORTED_MODULE_2__helpers__.d)(arr)) {
                    arr = [arr]
                }
                var delimJoin = function(array, delimiter, finalDelimiter) {
                    var list = "";
                    for (var i = 0; i < array.length; i++) {
                        if (0 !== i) {
                            if (i === array.length - 1) {
                                list += " " + finalDelimiter + " "
                            } else {
                                list += delimiter + " "
                            }
                        }
                        list += array[i]
                    }
                    return list
                };
                callback = callback || function(o) {
                    return o.toString()
                };
                var self = this;
                var realCallback = function(arg) {
                    return callback && callback.call(self, arg)
                };
                if (finalDelim) {
                    return delimJoin(arr.map(realCallback), delim, finalDelim)
                } else {
                    return arr.map(realCallback).join(delim + " ")
                }
            };
            return ToText
        }();
        __webpack_exports__.a = ToText
    },
    /*!**********************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/nlp/parsetext.js ***!
      \**********************************************************/
    /*! exports provided: default */
    /*! exports used: default */
    function(module, __webpack_exports__, __webpack_require__) {
        __webpack_exports__.a = parseText;
        var __WEBPACK_IMPORTED_MODULE_0__i18n__ = __webpack_require__( /*! ./i18n */ 298);
        var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__( /*! ../index */ 220);
        var Parser = function() {
            function Parser(rules) {
                this.done = true;
                this.rules = rules
            }
            Parser.prototype.start = function(text) {
                this.text = text;
                this.done = false;
                return this.nextSymbol()
            };
            Parser.prototype.isDone = function() {
                return this.done && null === this.symbol
            };
            Parser.prototype.nextSymbol = function() {
                var best;
                var bestSymbol;
                var p = this;
                this.symbol = null;
                this.value = null;
                do {
                    if (this.done) {
                        return false
                    }
                    var rule = void 0;
                    best = null;
                    for (var name_1 in this.rules) {
                        rule = this.rules[name_1];
                        var match = rule.exec(p.text);
                        if (match) {
                            if (null === best || match[0].length > best[0].length) {
                                best = match;
                                bestSymbol = name_1
                            }
                        }
                    }
                    if (null != best) {
                        this.text = this.text.substr(best[0].length);
                        if ("" === this.text) {
                            this.done = true
                        }
                    }
                    if (null == best) {
                        this.done = true;
                        this.symbol = null;
                        this.value = null;
                        return
                    }
                } while ("SKIP" === bestSymbol);
                this.symbol = bestSymbol;
                this.value = best;
                return true
            };
            Parser.prototype.accept = function(name) {
                if (this.symbol === name) {
                    if (this.value) {
                        var v = this.value;
                        this.nextSymbol();
                        return v
                    }
                    this.nextSymbol();
                    return true
                }
                return false
            };
            Parser.prototype.acceptNumber = function() {
                return this.accept("number")
            };
            Parser.prototype.expect = function(name) {
                if (this.accept(name)) {
                    return true
                }
                throw new Error("expected " + name + " but found " + this.symbol)
            };
            return Parser
        }();

        function parseText(text, language) {
            if (void 0 === language) {
                language = __WEBPACK_IMPORTED_MODULE_0__i18n__.a
            }
            var options = {};
            var ttr = new Parser(language.tokens);
            if (!ttr.start(text)) {
                return null
            }
            S();
            return options;

            function S() {
                ttr.expect("every");
                var n = ttr.acceptNumber();
                if (n) {
                    options.interval = parseInt(n[0], 10)
                }
                if (ttr.isDone()) {
                    throw new Error("Unexpected end")
                }
                switch (ttr.symbol) {
                    case "day(s)":
                        options.freq = __WEBPACK_IMPORTED_MODULE_1__index__.default.DAILY;
                        if (ttr.nextSymbol()) {
                            AT();
                            F()
                        }
                        break;
                    case "weekday(s)":
                        options.freq = __WEBPACK_IMPORTED_MODULE_1__index__.default.WEEKLY;
                        options.byweekday = [__WEBPACK_IMPORTED_MODULE_1__index__.default.MO, __WEBPACK_IMPORTED_MODULE_1__index__.default.TU, __WEBPACK_IMPORTED_MODULE_1__index__.default.WE, __WEBPACK_IMPORTED_MODULE_1__index__.default.TH, __WEBPACK_IMPORTED_MODULE_1__index__.default.FR];
                        ttr.nextSymbol();
                        F();
                        break;
                    case "week(s)":
                        options.freq = __WEBPACK_IMPORTED_MODULE_1__index__.default.WEEKLY;
                        if (ttr.nextSymbol()) {
                            ON();
                            F()
                        }
                        break;
                    case "hour(s)":
                        options.freq = __WEBPACK_IMPORTED_MODULE_1__index__.default.HOURLY;
                        if (ttr.nextSymbol()) {
                            ON();
                            F()
                        }
                        break;
                    case "minute(s)":
                        options.freq = __WEBPACK_IMPORTED_MODULE_1__index__.default.MINUTELY;
                        if (ttr.nextSymbol()) {
                            ON();
                            F()
                        }
                        break;
                    case "month(s)":
                        options.freq = __WEBPACK_IMPORTED_MODULE_1__index__.default.MONTHLY;
                        if (ttr.nextSymbol()) {
                            ON();
                            F()
                        }
                        break;
                    case "year(s)":
                        options.freq = __WEBPACK_IMPORTED_MODULE_1__index__.default.YEARLY;
                        if (ttr.nextSymbol()) {
                            ON();
                            F()
                        }
                        break;
                    case "monday":
                    case "tuesday":
                    case "wednesday":
                    case "thursday":
                    case "friday":
                    case "saturday":
                    case "sunday":
                        options.freq = __WEBPACK_IMPORTED_MODULE_1__index__.default.WEEKLY;
                        var key = ttr.symbol.substr(0, 2).toUpperCase();
                        options.byweekday = [__WEBPACK_IMPORTED_MODULE_1__index__.default[key]];
                        if (!ttr.nextSymbol()) {
                            return
                        }
                        while (ttr.accept("comma")) {
                            if (ttr.isDone()) {
                                throw new Error("Unexpected end")
                            }
                            var wkd = decodeWKD();
                            if (!wkd) {
                                throw new Error("Unexpected symbol " + ttr.symbol + ", expected weekday")
                            }
                            options.byweekday.push(__WEBPACK_IMPORTED_MODULE_1__index__.default[wkd]);
                            ttr.nextSymbol()
                        }
                        MDAYs();
                        F();
                        break;
                    case "january":
                    case "february":
                    case "march":
                    case "april":
                    case "may":
                    case "june":
                    case "july":
                    case "august":
                    case "september":
                    case "october":
                    case "november":
                    case "december":
                        options.freq = __WEBPACK_IMPORTED_MODULE_1__index__.default.YEARLY;
                        options.bymonth = [decodeM()];
                        if (!ttr.nextSymbol()) {
                            return
                        }
                        while (ttr.accept("comma")) {
                            if (ttr.isDone()) {
                                throw new Error("Unexpected end")
                            }
                            var m = decodeM();
                            if (!m) {
                                throw new Error("Unexpected symbol " + ttr.symbol + ", expected month")
                            }
                            options.bymonth.push(m);
                            ttr.nextSymbol()
                        }
                        ON();
                        F();
                        break;
                    default:
                        throw new Error("Unknown symbol")
                }
            }

            function ON() {
                var on = ttr.accept("on");
                var the = ttr.accept("the");
                if (!(on || the)) {
                    return
                }
                do {
                    var nth = decodeNTH();
                    var wkd = decodeWKD();
                    var m = decodeM();
                    if (nth) {
                        if (wkd) {
                            ttr.nextSymbol();
                            if (!options.byweekday) {
                                options.byweekday = []
                            }
                            options.byweekday.push(__WEBPACK_IMPORTED_MODULE_1__index__.default[wkd].nth(nth))
                        } else {
                            if (!options.bymonthday) {
                                options.bymonthday = []
                            }
                            options.bymonthday.push(nth);
                            ttr.accept("day(s)")
                        }
                    } else {
                        if (wkd) {
                            ttr.nextSymbol();
                            if (!options.byweekday) {
                                options.byweekday = []
                            }
                            options.byweekday.push(__WEBPACK_IMPORTED_MODULE_1__index__.default[wkd])
                        } else {
                            if ("weekday(s)" === ttr.symbol) {
                                ttr.nextSymbol();
                                if (!options.byweekday) {
                                    options.byweekday = [__WEBPACK_IMPORTED_MODULE_1__index__.default.MO, __WEBPACK_IMPORTED_MODULE_1__index__.default.TU, __WEBPACK_IMPORTED_MODULE_1__index__.default.WE, __WEBPACK_IMPORTED_MODULE_1__index__.default.TH, __WEBPACK_IMPORTED_MODULE_1__index__.default.FR]
                                }
                            } else {
                                if ("week(s)" === ttr.symbol) {
                                    ttr.nextSymbol();
                                    var n = ttr.acceptNumber();
                                    if (!n) {
                                        throw new Error("Unexpected symbol " + ttr.symbol + ", expected week number")
                                    }
                                    options.byweekno = [parseInt(n[0], 10)];
                                    while (ttr.accept("comma")) {
                                        n = ttr.acceptNumber();
                                        if (!n) {
                                            throw new Error("Unexpected symbol " + ttr.symbol + "; expected monthday")
                                        }
                                        options.byweekno.push(parseInt(n[0], 10))
                                    }
                                } else {
                                    if (m) {
                                        ttr.nextSymbol();
                                        if (!options.bymonth) {
                                            options.bymonth = []
                                        }
                                        options.bymonth.push(m)
                                    } else {
                                        return
                                    }
                                }
                            }
                        }
                    }
                } while (ttr.accept("comma") || ttr.accept("the") || ttr.accept("on"))
            }

            function AT() {
                var at = ttr.accept("at");
                if (!at) {
                    return
                }
                do {
                    var n = ttr.acceptNumber();
                    if (!n) {
                        throw new Error("Unexpected symbol " + ttr.symbol + ", expected hour")
                    }
                    options.byhour = [parseInt(n[0], 10)];
                    while (ttr.accept("comma")) {
                        n = ttr.acceptNumber();
                        if (!n) {
                            throw new Error("Unexpected symbol " + ttr.symbol + "; expected hour")
                        }
                        options.byhour.push(parseInt(n[0], 10))
                    }
                } while (ttr.accept("comma") || ttr.accept("at"))
            }

            function decodeM() {
                switch (ttr.symbol) {
                    case "january":
                        return 1;
                    case "february":
                        return 2;
                    case "march":
                        return 3;
                    case "april":
                        return 4;
                    case "may":
                        return 5;
                    case "june":
                        return 6;
                    case "july":
                        return 7;
                    case "august":
                        return 8;
                    case "september":
                        return 9;
                    case "october":
                        return 10;
                    case "november":
                        return 11;
                    case "december":
                        return 12;
                    default:
                        return false
                }
            }

            function decodeWKD() {
                switch (ttr.symbol) {
                    case "monday":
                    case "tuesday":
                    case "wednesday":
                    case "thursday":
                    case "friday":
                    case "saturday":
                    case "sunday":
                        return ttr.symbol.substr(0, 2).toUpperCase();
                    default:
                        return false
                }
            }

            function decodeNTH() {
                switch (ttr.symbol) {
                    case "last":
                        ttr.nextSymbol();
                        return -1;
                    case "first":
                        ttr.nextSymbol();
                        return 1;
                    case "second":
                        ttr.nextSymbol();
                        return ttr.accept("last") ? -2 : 2;
                    case "third":
                        ttr.nextSymbol();
                        return ttr.accept("last") ? -3 : 3;
                    case "nth":
                        var v = parseInt(ttr.value[1], 10);
                        if (v < -366 || v > 366) {
                            throw new Error("Nth out of range: " + v)
                        }
                        ttr.nextSymbol();
                        return ttr.accept("last") ? -v : v;
                    default:
                        return false
                }
            }

            function MDAYs() {
                ttr.accept("on");
                ttr.accept("the");
                var nth = decodeNTH();
                if (!nth) {
                    return
                }
                options.bymonthday = [nth];
                ttr.nextSymbol();
                while (ttr.accept("comma")) {
                    nth = decodeNTH();
                    if (!nth) {
                        throw new Error("Unexpected symbol " + ttr.symbol + "; expected monthday")
                    }
                    options.bymonthday.push(nth);
                    ttr.nextSymbol()
                }
            }

            function F() {
                if ("until" === ttr.symbol) {
                    var date = Date.parse(ttr.text);
                    if (!date) {
                        throw new Error("Cannot parse until date:" + ttr.text)
                    }
                    options.until = new Date(date)
                } else {
                    if (ttr.accept("for")) {
                        options.count = parseInt(ttr.value[0], 10);
                        ttr.expect("number")
                    }
                }
            }
        }
    },
    /*!****************************************************!*\
      !*** ./node_modules/rrule/dist/esm/src/iterset.js ***!
      \****************************************************/
    /*! exports provided: iterSet */
    /*! exports used: iterSet */
    function(module, __webpack_exports__, __webpack_require__) {
        __webpack_exports__.a = iterSet;
        var __WEBPACK_IMPORTED_MODULE_0__datewithzone__ = __webpack_require__( /*! ./datewithzone */ 297);
        var __WEBPACK_IMPORTED_MODULE_1__iter_index__ = __webpack_require__( /*! ./iter/index */ 431);
        var __WEBPACK_IMPORTED_MODULE_2__dateutil__ = __webpack_require__( /*! ./dateutil */ 62);

        function iterSet(iterResult, _rrule, _exrule, _rdate, _exdate, tzid) {
            var _exdateHash = {};
            var _accept = iterResult.accept;

            function evalExdate(after, before) {
                _exrule.forEach(function(rrule) {
                    rrule.between(after, before, true).forEach(function(date) {
                        _exdateHash[Number(date)] = true
                    })
                })
            }
            _exdate.forEach(function(date) {
                var zonedDate = new __WEBPACK_IMPORTED_MODULE_0__datewithzone__.a(date, tzid).rezonedDate();
                _exdateHash[Number(zonedDate)] = true
            });
            iterResult.accept = function(date) {
                var dt = Number(date);
                if (isNaN(dt)) {
                    return _accept.call(this, date)
                }
                if (!_exdateHash[dt]) {
                    evalExdate(new Date(dt - 1), new Date(dt + 1));
                    if (!_exdateHash[dt]) {
                        _exdateHash[dt] = true;
                        return _accept.call(this, date)
                    }
                }
                return true
            };
            if ("between" === iterResult.method) {
                evalExdate(iterResult.args.after, iterResult.args.before);
                iterResult.accept = function(date) {
                    var dt = Number(date);
                    if (!_exdateHash[dt]) {
                        _exdateHash[dt] = true;
                        return _accept.call(this, date)
                    }
                    return true
                }
            }
            for (var i = 0; i < _rdate.length; i++) {
                var zonedDate = new __WEBPACK_IMPORTED_MODULE_0__datewithzone__.a(_rdate[i], tzid).rezonedDate();
                if (!iterResult.accept(new Date(zonedDate.getTime()))) {
                    break
                }
            }
            _rrule.forEach(function(rrule) {
                Object(__WEBPACK_IMPORTED_MODULE_1__iter_index__.a)(iterResult, rrule.options)
            });
            var res = iterResult._result;
            __WEBPACK_IMPORTED_MODULE_2__dateutil__.b.sort(res);
            switch (iterResult.method) {
                case "all":
                case "between":
                    return res;
                case "before":
                    return res.length && res[res.length - 1] || null;
                case "after":
                default:
                    return res.length && res[0] || null
            }
        }
    },
    /*!****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/compactAppointmentsHelper.js ***!
      \****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.CompactAppointmentsHelper = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _button = _interopRequireDefault(__webpack_require__( /*! ../button */ 37));
        var _translator = __webpack_require__( /*! ../../animation/translator */ 28);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _function_template = __webpack_require__( /*! ../../core/templates/function_template */ 126);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _position = __webpack_require__( /*! ../../core/utils/position */ 22);
        var _dataStructures = __webpack_require__( /*! ./dataStructures */ 435);
        var _constants = __webpack_require__( /*! ./constants */ 160);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var APPOINTMENT_COLLECTOR_CLASS = "dx-scheduler-appointment-collector";
        var COMPACT_APPOINTMENT_COLLECTOR_CLASS = APPOINTMENT_COLLECTOR_CLASS + "-compact";
        var APPOINTMENT_COLLECTOR_CONTENT_CLASS = APPOINTMENT_COLLECTOR_CLASS + "-content";
        var WEEK_VIEW_COLLECTOR_OFFSET = 5;
        var COMPACT_THEME_WEEK_VIEW_COLLECTOR_OFFSET = 1;
        var CompactAppointmentsHelper = function() {
            function CompactAppointmentsHelper(instance) {
                this.instance = instance;
                this.elements = []
            }
            var _proto = CompactAppointmentsHelper.prototype;
            _proto.render = function(options) {
                var isCompact = options.isCompact,
                    items = options.items,
                    buttonColor = options.buttonColor;
                var template = this._createTemplate(items.data.length, isCompact);
                var button = this._createCompactButton(template, options);
                var $button = button.$element();
                this._makeBackgroundColor($button, items.colors, buttonColor);
                this._makeBackgroundDarker($button);
                this.elements.push($button);
                $button.data("items", this._createTooltipInfos(items));
                return $button
            };
            _proto.clear = function() {
                this.elements.forEach(function(button) {
                    button.detach();
                    button.remove()
                });
                this.elements = []
            };
            _proto._createTooltipInfos = function(items) {
                var _this = this;
                return items.data.map(function(appointment, index) {
                    var _items$settings;
                    var targetedAdapter = _this.instance.createAppointmentAdapter(appointment).clone();
                    if ((null === (_items$settings = items.settings) || void 0 === _items$settings ? void 0 : _items$settings.length) > 0) {
                        var info = items.settings[index].info;
                        targetedAdapter.startDate = info.sourceAppointment.startDate;
                        targetedAdapter.endDate = info.sourceAppointment.endDate
                    }
                    return new _dataStructures.AppointmentTooltipInfo(appointment, targetedAdapter.source(), items.colors[index], items.settings[index])
                })
            };
            _proto._onButtonClick = function(e, options) {
                var $button = (0, _renderer.default)(e.element);
                this.instance.showAppointmentTooltipCore($button, $button.data("items"), this._getExtraOptionsForTooltip(options))
            };
            _proto._getExtraOptionsForTooltip = function(options) {
                return {
                    clickEvent: this._clickEvent(options.onAppointmentClick).bind(this),
                    dragBehavior: options.allowDrag && this._createTooltipDragBehavior().bind(this),
                    dropDownAppointmentTemplate: this.instance.option().dropDownAppointmentTemplate,
                    isButtonClick: true
                }
            };
            _proto._clickEvent = function(onAppointmentClick) {
                var _this2 = this;
                return function(e) {
                    var config = {
                        itemData: e.itemData.appointment,
                        itemElement: e.itemElement
                    };
                    var createClickEvent = (0, _extend.extendFromObject)(_this2.instance.fire("mapAppointmentFields", config), e, false);
                    delete createClickEvent.itemData;
                    delete createClickEvent.itemIndex;
                    delete createClickEvent.itemElement;
                    onAppointmentClick(createClickEvent)
                }
            };
            _proto._createTooltipDragBehavior = function() {
                var _this3 = this;
                return function(e) {
                    var $element = (0, _renderer.default)(e.element);
                    var workSpace = _this3.instance.getWorkSpace();
                    var getItemData = function(itemElement) {
                        var _$$data;
                        return null === (_$$data = (0, _renderer.default)(itemElement).data(_constants.LIST_ITEM_DATA_KEY)) || void 0 === _$$data ? void 0 : _$$data.appointment
                    };
                    var getItemSettings = function(_, event) {
                        return event.itemSettings
                    };
                    var options = {
                        filter: ".".concat(_constants.LIST_ITEM_CLASS),
                        isSetCursorOffset: true
                    };
                    workSpace._createDragBehaviorBase($element, getItemData, getItemSettings, options)
                }
            };
            _proto._getCollectorOffset = function(width, cellWidth) {
                return cellWidth - width - this._getCollectorRightOffset()
            };
            _proto._getCollectorRightOffset = function() {
                return this.instance.getRenderingStrategyInstance()._isCompactTheme() ? COMPACT_THEME_WEEK_VIEW_COLLECTOR_OFFSET : WEEK_VIEW_COLLECTOR_OFFSET
            };
            _proto._makeBackgroundDarker = function(button) {
                button.css("boxShadow", "inset ".concat((0, _position.getBoundingRect)(button.get(0)).width, "px 0 0 0 rgba(0, 0, 0, 0.3)"))
            };
            _proto._makeBackgroundColor = function($button, colors, color) {
                _deferred.when.apply(null, colors).done(function() {
                    this._makeBackgroundColorCore($button, color, arguments)
                }.bind(this))
            };
            _proto._makeBackgroundColorCore = function($button, color, itemsColors) {
                var paintButton = true;
                var currentItemColor;
                color && color.done(function(color) {
                    if (itemsColors.length) {
                        currentItemColor = itemsColors[0];
                        for (var i = 1; i < itemsColors.length; i++) {
                            if (currentItemColor !== itemsColors[i]) {
                                paintButton = false;
                                break
                            }
                            currentItemColor = color
                        }
                    }
                    color && paintButton && $button.css("backgroundColor", color)
                }.bind(this))
            };
            _proto._setPosition = function(element, position) {
                (0, _translator.move)(element, {
                    top: position.top,
                    left: position.left
                })
            };
            _proto._createCompactButton = function(template, options) {
                var _this4 = this;
                var $button = this._createCompactButtonElement(options);
                return this.instance._createComponent($button, _button.default, {
                    type: "default",
                    width: options.width,
                    height: options.height,
                    onClick: function(e) {
                        return _this4._onButtonClick(e, options)
                    },
                    template: this._renderTemplate(template, options.items, options.isCompact)
                })
            };
            _proto._createCompactButtonElement = function(_ref) {
                var isCompact = _ref.isCompact,
                    $container = _ref.$container,
                    width = _ref.width,
                    coordinates = _ref.coordinates,
                    applyOffset = _ref.applyOffset,
                    cellWidth = _ref.cellWidth;
                var result = (0, _renderer.default)("<div>").addClass(APPOINTMENT_COLLECTOR_CLASS).toggleClass(COMPACT_APPOINTMENT_COLLECTOR_CLASS, isCompact).appendTo($container);
                var offset = applyOffset ? this._getCollectorOffset(width, cellWidth) : 0;
                this._setPosition(result, {
                    top: coordinates.top,
                    left: coordinates.left + offset
                });
                return result
            };
            _proto._renderTemplate = function(template, items, isCompact) {
                return new _function_template.FunctionTemplate(function(options) {
                    return template.render({
                        model: {
                            appointmentCount: items.data.length,
                            isCompact: isCompact
                        },
                        container: options.container
                    })
                })
            };
            _proto._createTemplate = function(count, isCompact) {
                this._initButtonTemplate(count, isCompact);
                return this.instance._getAppointmentTemplate("appointmentCollectorTemplate")
            };
            _proto._initButtonTemplate = function(count, isCompact) {
                var _this5 = this;
                this.instance._templateManager.addDefaultTemplates({
                    appointmentCollector: new _function_template.FunctionTemplate(function(options) {
                        return _this5._createButtonTemplate(count, (0, _renderer.default)(options.container), isCompact)
                    })
                })
            };
            _proto._createButtonTemplate = function(appointmentCount, element, isCompact) {
                var text = isCompact ? appointmentCount : _message.default.getFormatter("dxScheduler-moreAppointments")(appointmentCount);
                return element.append((0, _renderer.default)("<span>").text(text)).addClass(APPOINTMENT_COLLECTOR_CONTENT_CLASS)
            };
            return CompactAppointmentsHelper
        }();
        exports.CompactAppointmentsHelper = CompactAppointmentsHelper
    },
    /*!********************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/tooltip_strategies/desktopTooltipStrategy.js ***!
      \********************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.DesktopTooltipStrategy = void 0;
        var _tooltipStrategyBase = __webpack_require__( /*! ./tooltipStrategyBase */ 436);
        var _tooltip = _interopRequireDefault(__webpack_require__( /*! ../../tooltip */ 217));
        var _support = __webpack_require__( /*! ../../../core/utils/support */ 45);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var APPOINTMENT_TOOLTIP_WRAPPER_CLASS = "dx-scheduler-appointment-tooltip-wrapper";
        var MAX_TOOLTIP_HEIGHT = 200;
        var DesktopTooltipStrategy = function(_TooltipStrategyBase) {
            _inheritsLoose(DesktopTooltipStrategy, _TooltipStrategyBase);

            function DesktopTooltipStrategy() {
                return _TooltipStrategyBase.apply(this, arguments) || this
            }
            var _proto = DesktopTooltipStrategy.prototype;
            _proto._prepareBeforeVisibleChanged = function(dataList) {
                this._tooltip.option("position", {
                    my: "bottom",
                    at: "top",
                    boundary: this._getBoundary(dataList),
                    offset: this._extraOptions.offset,
                    collision: "fit flipfit"
                })
            };
            _proto._getBoundary = function(dataList) {
                return this._options.isAppointmentInAllDayPanel(dataList[0].appointment) ? this._options.container : this._options.getScrollableContainer()
            };
            _proto._onShown = function() {
                _TooltipStrategyBase.prototype._onShown.call(this);
                if (this._extraOptions.isButtonClick) {
                    this._list.focus();
                    this._list.option("focusedElement", null)
                }
            };
            _proto._createListOption = function(target, dataList) {
                var result = _TooltipStrategyBase.prototype._createListOption.call(this, target, dataList);
                result.showScrollbar = _support.touch ? "always" : "onHover";
                return result
            };
            _proto._createTooltip = function(target, dataList) {
                var tooltip = this._createTooltipElement(APPOINTMENT_TOOLTIP_WRAPPER_CLASS);
                return this._options.createComponent(tooltip, _tooltip.default, {
                    target: target,
                    maxHeight: MAX_TOOLTIP_HEIGHT,
                    rtlEnabled: this._extraOptions.rtlEnabled,
                    onShown: this._onShown.bind(this),
                    contentTemplate: this._getContentTemplate(dataList)
                })
            };
            _proto._onListRender = function(e) {
                return this._extraOptions.dragBehavior && this._extraOptions.dragBehavior(e)
            };
            return DesktopTooltipStrategy
        }(_tooltipStrategyBase.TooltipStrategyBase);
        exports.DesktopTooltipStrategy = DesktopTooltipStrategy
    },
    /*!*******************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/tooltip_strategies/mobileTooltipStrategy.js ***!
      \*******************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.MobileTooltipStrategy = void 0;
        var _overlay = _interopRequireDefault(__webpack_require__( /*! ../../overlay */ 64));
        var _tooltipStrategyBase = __webpack_require__( /*! ./tooltipStrategyBase */ 436);
        var _window = __webpack_require__( /*! ../../../core/utils/window */ 7);
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../../core/renderer */ 2));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var SLIDE_PANEL_CLASS_NAME = "dx-scheduler-overlay-panel";
        var MAX_TABLET_OVERLAY_HEIGHT_FACTOR = .9;
        var MAX_HEIGHT = {
            PHONE: 250,
            TABLET: "90%",
            DEFAULT: "auto"
        };
        var MAX_WIDTH = {
            PHONE: "100%",
            TABLET: "80%"
        };
        var animationConfig = {
            show: {
                type: "slide",
                duration: 300,
                from: {
                    position: {
                        my: "top",
                        at: "bottom",
                        of: (0, _window.getWindow)()
                    }
                },
                to: {
                    position: {
                        my: "center",
                        at: "center",
                        of: (0, _window.getWindow)()
                    }
                }
            },
            hide: {
                type: "slide",
                duration: 300,
                to: {
                    position: {
                        my: "top",
                        at: "bottom",
                        of: (0, _window.getWindow)()
                    }
                },
                from: {
                    position: {
                        my: "center",
                        at: "center",
                        of: (0, _window.getWindow)()
                    }
                }
            }
        };
        var createPhoneDeviceConfig = function(listHeight) {
            return {
                shading: false,
                width: MAX_WIDTH.PHONE,
                height: listHeight > MAX_HEIGHT.PHONE ? MAX_HEIGHT.PHONE : MAX_HEIGHT.DEFAULT,
                position: {
                    my: "bottom",
                    at: "bottom",
                    of: (0, _window.getWindow)()
                }
            }
        };
        var createTabletDeviceConfig = function(listHeight) {
            var currentMaxHeight = (0, _renderer.default)((0, _window.getWindow)()).height() * MAX_TABLET_OVERLAY_HEIGHT_FACTOR;
            return {
                shading: true,
                width: MAX_WIDTH.TABLET,
                height: listHeight > currentMaxHeight ? MAX_HEIGHT.TABLET : MAX_HEIGHT.DEFAULT,
                position: {
                    my: "center",
                    at: "center",
                    of: (0, _window.getWindow)()
                }
            }
        };
        var MobileTooltipStrategy = function(_TooltipStrategyBase) {
            _inheritsLoose(MobileTooltipStrategy, _TooltipStrategyBase);

            function MobileTooltipStrategy() {
                return _TooltipStrategyBase.apply(this, arguments) || this
            }
            var _proto = MobileTooltipStrategy.prototype;
            _proto._shouldUseTarget = function() {
                return false
            };
            _proto._onShowing = function() {
                var isTabletWidth = (0, _renderer.default)((0, _window.getWindow)()).width() > 700;
                this._tooltip.option("height", MAX_HEIGHT.DEFAULT);
                var listHeight = this._list.$element().outerHeight();
                this._tooltip.option(isTabletWidth ? createTabletDeviceConfig(listHeight) : createPhoneDeviceConfig(listHeight))
            };
            _proto._createTooltip = function(target, dataList) {
                var _this = this;
                var element = this._createTooltipElement(SLIDE_PANEL_CLASS_NAME);
                return this._options.createComponent(element, _overlay.default, {
                    target: (0, _window.getWindow)(),
                    closeOnOutsideClick: true,
                    animation: animationConfig,
                    onShowing: function() {
                        return _this._onShowing()
                    },
                    onShown: this._onShown.bind(this),
                    contentTemplate: this._getContentTemplate(dataList)
                })
            };
            return MobileTooltipStrategy
        }(_tooltipStrategyBase.TooltipStrategyBase);
        exports.MobileTooltipStrategy = MobileTooltipStrategy
    },
    /*!****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/ui.scheduler.appointments.js ***!
      \****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _element_data = __webpack_require__( /*! ../../core/element_data */ 40);
        var _translator = __webpack_require__( /*! ../../animation/translator */ 28);
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _object = __webpack_require__( /*! ../../core/utils/object */ 51);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _element = __webpack_require__( /*! ../../core/element */ 18);
        var _recurrence = __webpack_require__( /*! ./recurrence */ 139);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _uiScheduler = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.publisher_mixin */ 221));
        var _uiScheduler2 = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.appointment */ 807));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _double_click = __webpack_require__( /*! ../../events/double_click */ 151);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _uiCollection_widget = _interopRequireDefault(__webpack_require__( /*! ../collection/ui.collection_widget.edit */ 54));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _utilsTimeZone = _interopRequireDefault(__webpack_require__( /*! ./utils.timeZone.js */ 86));
        var _constants = __webpack_require__( /*! ./constants */ 160);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var COMPONENT_CLASS = "dx-scheduler-scrollable-appointments";
        var APPOINTMENT_ITEM_CLASS = "dx-scheduler-appointment";
        var APPOINTMENT_TITLE_CLASS = "dx-scheduler-appointment-title";
        var APPOINTMENT_CONTENT_DETAILS_CLASS = "dx-scheduler-appointment-content-details";
        var APPOINTMENT_DATE_CLASS = "dx-scheduler-appointment-content-date";
        var RECURRING_ICON_CLASS = "dx-scheduler-appointment-recurrence-icon";
        var ALL_DAY_CONTENT_CLASS = "dx-scheduler-appointment-content-allday";
        var DBLCLICK_EVENT_NAME = (0, _index.addNamespace)(_double_click.name, "dxSchedulerAppointment");
        var toMs = _date.default.dateToMilliseconds;
        var SchedulerAppointments = _uiCollection_widget.default.inherit({
            ctor: function(element, options) {
                this.callBase(element, options)
            },
            _supportedKeys: function() {
                var parent = this.callBase();
                var tabHandler = function(e) {
                    var appointments = this._getAccessAppointments();
                    var focusedAppointment = appointments.filter(".dx-state-focused");
                    var index = focusedAppointment.data(_constants.APPOINTMENT_SETTINGS_KEY).sortedIndex;
                    var lastIndex = appointments.length - 1;
                    if (index > 0 && e.shiftKey || index < lastIndex && !e.shiftKey) {
                        e.preventDefault();
                        e.shiftKey ? index-- : index++;
                        var $nextAppointment = this._getAppointmentByIndex(index);
                        this._resetTabIndex($nextAppointment);
                        _events_engine.default.trigger($nextAppointment, "focus")
                    }
                };
                return (0, _extend.extend)(parent, {
                    escape: function() {
                        this.moveAppointmentBack();
                        this._escPressed = true
                    }.bind(this),
                    del: function(e) {
                        if (this.option("allowDelete")) {
                            e.preventDefault();
                            var data = this._getItemData(e.target);
                            this.notifyObserver("onDeleteButtonPress", {
                                data: data,
                                target: e.target
                            })
                        }
                    }.bind(this),
                    tab: tabHandler
                })
            },
            _getAppointmentByIndex: function(sortedIndex) {
                var appointments = this._getAccessAppointments();
                return appointments.filter(function(_, $item) {
                    return (0, _element_data.data)($item, _constants.APPOINTMENT_SETTINGS_KEY).sortedIndex === sortedIndex
                }).eq(0)
            },
            _getAccessAppointments: function() {
                return this._itemElements().filter(":visible").not(".dx-state-disabled")
            },
            _resetTabIndex: function($appointment) {
                this._focusTarget().attr("tabIndex", -1);
                $appointment.attr("tabIndex", this.option("tabIndex"))
            },
            _moveFocus: _common.noop,
            _focusTarget: function() {
                return this._itemElements()
            },
            _renderFocusTarget: function() {
                var $appointment = this._getAppointmentByIndex(0);
                this._resetTabIndex($appointment)
            },
            _focusInHandler: function(e) {
                this.callBase.apply(this, arguments);
                this._$currentAppointment = (0, _renderer.default)(e.target);
                this.option("focusedElement", (0, _element.getPublicElement)((0, _renderer.default)(e.target)))
            },
            _focusOutHandler: function() {
                var $appointment = this._getAppointmentByIndex(0);
                this.option("focusedElement", (0, _element.getPublicElement)($appointment));
                this.callBase.apply(this, arguments)
            },
            _eventBindingTarget: function() {
                return this._itemContainer()
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    noDataText: null,
                    activeStateEnabled: true,
                    hoverStateEnabled: true,
                    tabIndex: 0,
                    fixedContainer: null,
                    allDayContainer: null,
                    allowDrag: true,
                    allowResize: true,
                    allowAllDayResize: true,
                    onAppointmentDblClick: null,
                    _collectorOffset: 0
                })
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "items":
                        this._cleanFocusState();
                        this._clearDropDownItems();
                        this._clearDropDownItemsElements();
                        this._repaintAppointments(args.value);
                        this._renderDropDownAppointments();
                        this._attachAppointmentsEvents();
                        break;
                    case "fixedContainer":
                    case "allDayContainer":
                    case "onAppointmentDblClick":
                        break;
                    case "allowDrag":
                    case "allowResize":
                    case "allowAllDayResize":
                        this._invalidate();
                        break;
                    case "focusedElement":
                        this._resetTabIndex((0, _renderer.default)(args.value));
                        this.callBase(args);
                        break;
                    case "allowDelete":
                        break;
                    case "focusStateEnabled":
                        this._clearDropDownItemsElements();
                        this._renderDropDownAppointments();
                        this.callBase(args);
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _isAllDayAppointment: function(appointment) {
                return appointment.settings.length && appointment.settings[0].allDay || false
            },
            _isRepaintAppointment: function(appointment) {
                return !(0, _type.isDefined)(appointment.needRepaint) || true === appointment.needRepaint
            },
            _isRepaintAll: function(appointments) {
                if (this.invoke("isVirtualScrolling")) {
                    return true
                }
                if (this.invoke("isCurrentViewAgenda")) {
                    return true
                }
                for (var i = 0; i < appointments.length; i++) {
                    var appointment = appointments[i];
                    if (!this._isRepaintAppointment(appointment)) {
                        return false
                    }
                }
                return true
            },
            _applyFragment: function(fragment, allDay) {
                if (fragment.children().length > 0) {
                    this._getAppointmentContainer(allDay).append(fragment)
                }
            },
            _onEachAppointment: function(appointment, index, container, isRepaintAll) {
                var _this = this;
                var repaintAppointment = function() {
                    appointment.needRepaint = false;
                    _this._clearItem(appointment);
                    _this._renderItem(index, appointment, container)
                };
                if (true === (null === appointment || void 0 === appointment ? void 0 : appointment.needRemove)) {
                    this._clearItem(appointment)
                } else {
                    if (isRepaintAll || this._isRepaintAppointment(appointment)) {
                        repaintAppointment()
                    }
                }
            },
            _repaintAppointments: function(appointments) {
                var _this2 = this;
                this._renderByFragments(function($commonFragment, $allDayFragment) {
                    var isRepaintAll = _this2._isRepaintAll(appointments);
                    if (isRepaintAll) {
                        _this2._getAppointmentContainer(true).html("");
                        _this2._getAppointmentContainer(false).html("")
                    }!appointments.length && _this2._cleanItemContainer();
                    appointments.forEach(function(appointment, index) {
                        var container = _this2._isAllDayAppointment(appointment) ? $allDayFragment : $commonFragment;
                        _this2._onEachAppointment(appointment, index, container, isRepaintAll)
                    })
                })
            },
            _renderByFragments: function(renderFunction) {
                var isVirtualScrolling = this.invoke("isVirtualScrolling");
                if (isVirtualScrolling) {
                    var $commonFragment = (0, _renderer.default)(_dom_adapter.default.createDocumentFragment());
                    var $allDayFragment = (0, _renderer.default)(_dom_adapter.default.createDocumentFragment());
                    renderFunction($commonFragment, $allDayFragment);
                    this._applyFragment($commonFragment, false);
                    this._applyFragment($allDayFragment, true)
                } else {
                    renderFunction(this._getAppointmentContainer(false), this._getAppointmentContainer(true))
                }
            },
            _attachAppointmentsEvents: function() {
                this._attachClickEvent();
                this._attachHoldEvent();
                this._attachContextMenuEvent();
                this._attachAppointmentDblClick();
                this._renderFocusState();
                this._attachFeedbackEvents();
                this._attachHoverEvents()
            },
            _clearItem: function(item) {
                var $items = this._findItemElementByItem(item.itemData);
                if (!$items.length) {
                    return
                }(0, _iterator.each)($items, function(_, $item) {
                    $item.detach();
                    $item.remove()
                })
            },
            _clearDropDownItems: function() {
                this._virtualAppointments = {}
            },
            _clearDropDownItemsElements: function() {
                this.invoke("clearCompactAppointments")
            },
            _findItemElementByItem: function(item) {
                var result = [];
                var that = this;
                this.itemElements().each(function() {
                    var $item = (0, _renderer.default)(this);
                    if ($item.data(that._itemDataKey()) === item) {
                        result.push($item)
                    }
                });
                return result
            },
            _itemClass: function() {
                return APPOINTMENT_ITEM_CLASS
            },
            _itemContainer: function() {
                var $container = this.callBase();
                var $result = $container;
                var $allDayContainer = this.option("allDayContainer");
                if ($allDayContainer) {
                    $result = $container.add($allDayContainer)
                }
                return $result
            },
            _cleanItemContainer: function() {
                this.callBase();
                var $allDayContainer = this.option("allDayContainer");
                if ($allDayContainer) {
                    $allDayContainer.empty()
                }
                this._virtualAppointments = {}
            },
            _clean: function() {
                this.callBase();
                delete this._$currentAppointment;
                delete this._initialSize;
                delete this._initialCoordinates
            },
            _init: function() {
                this.callBase();
                this.$element().addClass(COMPONENT_CLASS);
                this._preventSingleAppointmentClick = false
            },
            _renderAppointmentTemplate: function($container, data, model) {
                var formatText = this.invoke("getTextAndFormatDate", model.appointmentData, this._currentAppointmentSettings.agendaSettings || model.targetedAppointmentData, "TIME");
                (0, _renderer.default)("<div>").text(formatText.text).addClass(APPOINTMENT_TITLE_CLASS).appendTo($container);
                if ((0, _type.isPlainObject)(data)) {
                    if (data.html) {
                        $container.html(data.html)
                    }
                }
                var $contentDetails = (0, _renderer.default)("<div>").addClass(APPOINTMENT_CONTENT_DETAILS_CLASS);
                (0, _renderer.default)("<div>").addClass(APPOINTMENT_DATE_CLASS).text(formatText.formatDate).appendTo($contentDetails);
                $contentDetails.appendTo($container);
                if (data.recurrenceRule) {
                    (0, _renderer.default)("<span>").addClass(RECURRING_ICON_CLASS + " dx-icon-repeat").appendTo($container)
                }
                if (data.allDay) {
                    (0, _renderer.default)("<div>").text(" " + _message.default.format("dxScheduler-allDay") + ": ").addClass(ALL_DAY_CONTENT_CLASS).prependTo($contentDetails)
                }
            },
            _executeItemRenderAction: function(index, itemData, itemElement) {
                var action = this._getItemRenderAction();
                if (action) {
                    action(this.invoke("mapAppointmentFields", {
                        itemData: itemData,
                        itemElement: itemElement
                    }))
                }
                delete this._currentAppointmentSettings
            },
            _itemClickHandler: function(e) {
                this.callBase(e, {}, {
                    afterExecute: function(e) {
                        this._processItemClick(e.args[0].event)
                    }.bind(this)
                })
            },
            _processItemClick: function(e) {
                var $target = (0, _renderer.default)(e.currentTarget);
                var data = this._getItemData($target);
                if ("keydown" === e.type || (0, _index.isFakeClickEvent)(e)) {
                    this.notifyObserver("showEditAppointmentPopup", {
                        data: data,
                        target: $target
                    });
                    return
                }
                this._appointmentClickTimeout = setTimeout(function() {
                    if (!this._preventSingleAppointmentClick && _dom_adapter.default.getBody().contains($target[0])) {
                        this.notifyObserver("showAppointmentTooltip", {
                            data: data,
                            target: $target
                        })
                    }
                    this._preventSingleAppointmentClick = false
                }.bind(this), 300)
            },
            _extendActionArgs: function() {
                var args = this.callBase.apply(this, arguments);
                return this.invoke("mapAppointmentFields", args)
            },
            _render: function() {
                this.callBase.apply(this, arguments);
                this._attachAppointmentDblClick()
            },
            _attachAppointmentDblClick: function() {
                var that = this;
                var itemSelector = that._itemSelector();
                var itemContainer = this._itemContainer();
                _events_engine.default.off(itemContainer, DBLCLICK_EVENT_NAME, itemSelector);
                _events_engine.default.on(itemContainer, DBLCLICK_EVENT_NAME, itemSelector, function(e) {
                    that._itemDXEventHandler(e, "onAppointmentDblClick", {}, {
                        afterExecute: function(e) {
                            that._dblClickHandler(e.args[0].event)
                        }
                    })
                })
            },
            _dblClickHandler: function(e) {
                var $targetAppointment = (0, _renderer.default)(e.currentTarget);
                var appointmentData = this._getItemData($targetAppointment);
                clearTimeout(this._appointmentClickTimeout);
                this._preventSingleAppointmentClick = true;
                this.notifyObserver("showEditAppointmentPopup", {
                    data: appointmentData,
                    target: $targetAppointment
                })
            },
            _renderItem: function(index, item, container) {
                var itemData = item.itemData;
                var $items = [];
                for (var i = 0; i < item.settings.length; i++) {
                    var setting = item.settings[i];
                    this._currentAppointmentSettings = setting;
                    var $item = this.callBase(index, itemData, container);
                    $item.data(_constants.APPOINTMENT_SETTINGS_KEY, setting);
                    $items.push($item)
                }
                return $items
            },
            _getItemContent: function($itemFrame) {
                $itemFrame.data(_constants.APPOINTMENT_SETTINGS_KEY, this._currentAppointmentSettings);
                var $itemContent = this.callBase($itemFrame);
                return $itemContent
            },
            _createItemByTemplate: function(itemTemplate, renderArgs) {
                var itemData = renderArgs.itemData,
                    container = renderArgs.container,
                    index = renderArgs.index;
                return itemTemplate.render({
                    model: {
                        appointmentData: itemData,
                        targetedAppointmentData: this.invoke("getTargetedAppointmentData", itemData, (0, _renderer.default)(container).parent())
                    },
                    container: container,
                    index: index
                })
            },
            _getAppointmentContainer: function(allDay) {
                var $allDayContainer = this.option("allDayContainer");
                var $container = this.itemsContainer().not($allDayContainer);
                if (allDay && $allDayContainer) {
                    $container = $allDayContainer
                }
                return $container
            },
            _postprocessRenderItem: function(args) {
                this._renderAppointment(args.itemElement, this._currentAppointmentSettings)
            },
            _renderAppointment: function($appointment, settings) {
                $appointment.data(_constants.APPOINTMENT_SETTINGS_KEY, settings);
                this._applyResourceDataAttr($appointment);
                var data = this._getItemData($appointment);
                var geometry = this.invoke("getAppointmentGeometry", settings);
                var allowResize = this.option("allowResize") && (!(0, _type.isDefined)(settings.skipResizing) || (0, _type.isString)(settings.skipResizing));
                var allowDrag = this.option("allowDrag");
                var allDay = settings.allDay;
                this.invoke("setCellDataCacheAlias", this._currentAppointmentSettings, geometry);
                var deferredColor = this._getAppointmentColor($appointment, settings.groupIndex);
                if (settings.virtual) {
                    this._processVirtualAppointment(settings, $appointment, data, deferredColor)
                } else {
                    var info = settings.info;
                    this._createComponent($appointment, _uiScheduler2.default, {
                        observer: this.option("observer"),
                        data: data,
                        geometry: geometry,
                        direction: settings.direction || "vertical",
                        allowResize: allowResize,
                        allowDrag: allowDrag,
                        allDay: allDay,
                        reduced: settings.appointmentReduced,
                        isCompact: settings.isCompact,
                        startDate: new Date(null === info || void 0 === info ? void 0 : info.appointment.startDate),
                        cellWidth: this.invoke("getCellWidth"),
                        cellHeight: this.invoke("getCellHeight"),
                        resizableConfig: this._resizableConfig(data, settings)
                    });
                    deferredColor.done(function(color) {
                        if (color) {
                            $appointment.css("backgroundColor", color)
                        }
                    })
                }
            },
            _applyResourceDataAttr: function($appointment) {
                var resources = this.invoke("getResourcesFromItem", this._getItemData($appointment));
                if (resources) {
                    (0, _iterator.each)(resources, function(name, values) {
                        var attr = "data-" + (0, _common.normalizeKey)(name.toLowerCase()) + "-";
                        for (var i = 0; i < values.length; i++) {
                            $appointment.attr(attr + (0, _common.normalizeKey)(values[i]), true)
                        }
                    })
                }
            },
            _resizableConfig: function(appointmentData, itemSetting) {
                return {
                    area: this._calculateResizableArea(itemSetting, appointmentData),
                    onResizeStart: function(e) {
                        this._$currentAppointment = (0, _renderer.default)(e.element);
                        if (this.invoke("needRecalculateResizableArea")) {
                            var updatedArea = this._calculateResizableArea(this._$currentAppointment.data(_constants.APPOINTMENT_SETTINGS_KEY), this._$currentAppointment.data("dxItemData"));
                            e.component.option("area", updatedArea);
                            e.component._renderDragOffsets(e.event)
                        }
                        this._initialSize = {
                            width: e.width,
                            height: e.height
                        };
                        this._initialCoordinates = (0, _translator.locate)(this._$currentAppointment)
                    }.bind(this),
                    onResizeEnd: function(e) {
                        if (this._escPressed) {
                            e.event.cancel = true;
                            return
                        }
                        this._resizeEndHandler(e)
                    }.bind(this)
                }
            },
            _calculateResizableArea: function(itemSetting, appointmentData) {
                var area = this.$element().closest(".dx-scrollable-content");
                return this.invoke("getResizableAppointmentArea", {
                    coordinates: {
                        left: itemSetting.left,
                        top: 0,
                        groupIndex: itemSetting.groupIndex
                    },
                    allDay: itemSetting.allDay
                }) || area
            },
            _resizeEndHandler: function(e) {
                var scheduler = this.option("observer");
                var $element = (0, _renderer.default)(e.element);
                var _$element$data = $element.data("dxAppointmentSettings"),
                    info = _$element$data.info;
                var sourceAppointment = this._getItemData($element);
                var modifiedAppointmentAdapter = scheduler.createAppointmentAdapter(sourceAppointment).clone();
                var startDate = this._getEndResizeAppointmentStartDate(e, sourceAppointment, info.appointment);
                var endDate = info.appointment.endDate;
                var dateRange = this._getDateRange(e, startDate, endDate);
                modifiedAppointmentAdapter.startDate = new Date(dateRange[0]);
                modifiedAppointmentAdapter.endDate = new Date(dateRange[1]);
                this.notifyObserver("updateAppointmentAfterResize", {
                    target: sourceAppointment,
                    data: modifiedAppointmentAdapter.clone({
                        pathTimeZone: "fromGrid"
                    }).source(),
                    $appointment: $element
                })
            },
            _getEndResizeAppointmentStartDate: function(e, rawAppointment, appointmentInfo) {
                var scheduler = this.option("observer");
                var appointmentAdapter = scheduler.createAppointmentAdapter(rawAppointment);
                var startDate = appointmentInfo.startDate;
                var recurrenceProcessor = (0, _recurrence.getRecurrenceProcessor)();
                var recurrenceRule = appointmentAdapter.recurrenceRule,
                    startDateTimeZone = appointmentAdapter.startDateTimeZone;
                var isAllDay = this.invoke("isAllDay", rawAppointment);
                var isRecurrent = recurrenceProcessor.isValidRecurrenceRule(recurrenceRule);
                if (!e.handles.top && !isRecurrent && !isAllDay) {
                    startDate = scheduler.timeZoneCalculator.createDate(appointmentAdapter.startDate, {
                        appointmentTimeZone: startDateTimeZone,
                        path: "toGrid"
                    })
                }
                return startDate
            },
            _getDateRange: function(e, startDate, endDate) {
                var itemData = this._getItemData(e.element);
                var deltaTime = this.invoke("getDeltaTime", e, this._initialSize, itemData);
                var renderingStrategyDirection = this.invoke("getRenderingStrategyDirection");
                var isStartDateChanged = false;
                var isAllDay = this.invoke("isAllDay", itemData);
                var needCorrectDates = this.invoke("needCorrectAppointmentDates") && !isAllDay;
                var startTime;
                var endTime;
                if ("vertical" !== renderingStrategyDirection || isAllDay) {
                    isStartDateChanged = this.option("rtlEnabled") ? e.handles.right : e.handles.left
                } else {
                    isStartDateChanged = e.handles.top
                }
                if (isStartDateChanged) {
                    startTime = needCorrectDates ? this._correctStartDateByDelta(startDate, deltaTime) : startDate.getTime() - deltaTime;
                    startTime += _utilsTimeZone.default.getTimezoneOffsetChangeInMs(startDate, endDate, startTime, endDate);
                    endTime = endDate.getTime()
                } else {
                    startTime = startDate.getTime();
                    endTime = needCorrectDates ? this._correctEndDateByDelta(endDate, deltaTime) : endDate.getTime() + deltaTime;
                    endTime -= _utilsTimeZone.default.getTimezoneOffsetChangeInMs(startDate, endDate, startDate, endTime)
                }
                return [startTime, endTime]
            },
            _correctEndDateByDelta: function(endDate, deltaTime) {
                var endDayHour = this.invoke("getEndDayHour");
                var startDayHour = this.invoke("getStartDayHour");
                var result = endDate.getTime() + deltaTime;
                var visibleDayDuration = (endDayHour - startDayHour) * toMs("hour");
                var daysCount = deltaTime > 0 ? Math.ceil(deltaTime / visibleDayDuration) : Math.floor(deltaTime / visibleDayDuration);
                var maxDate = new Date(endDate);
                var minDate = new Date(endDate);
                minDate.setHours(startDayHour, 0, 0, 0);
                maxDate.setHours(endDayHour, 0, 0, 0);
                if (result > maxDate.getTime() || result <= minDate.getTime()) {
                    var tailOfCurrentDay = maxDate.getTime() - endDate.getTime();
                    var tailOfPrevDays = deltaTime - tailOfCurrentDay;
                    var lastDay = new Date(endDate.setDate(endDate.getDate() + daysCount));
                    lastDay.setHours(startDayHour, 0, 0, 0);
                    result = lastDay.getTime() + tailOfPrevDays - visibleDayDuration * (daysCount - 1)
                }
                return result
            },
            _correctStartDateByDelta: function(startDate, deltaTime) {
                var endDayHour = this.invoke("getEndDayHour");
                var startDayHour = this.invoke("getStartDayHour");
                var result = startDate.getTime() - deltaTime;
                var visibleDayDuration = (endDayHour - startDayHour) * toMs("hour");
                var daysCount = deltaTime > 0 ? Math.ceil(deltaTime / visibleDayDuration) : Math.floor(deltaTime / visibleDayDuration);
                var maxDate = new Date(startDate);
                var minDate = new Date(startDate);
                minDate.setHours(startDayHour, 0, 0, 0);
                maxDate.setHours(endDayHour, 0, 0, 0);
                if (result < minDate.getTime() || result >= maxDate.getTime()) {
                    var tailOfCurrentDay = startDate.getTime() - minDate.getTime();
                    var tailOfPrevDays = deltaTime - tailOfCurrentDay;
                    var firstDay = new Date(startDate.setDate(startDate.getDate() - daysCount));
                    firstDay.setHours(endDayHour, 0, 0, 0);
                    result = firstDay.getTime() - tailOfPrevDays + visibleDayDuration * (daysCount - 1)
                }
                return result
            },
            _tryGetAppointmentColor: function(appointment) {
                var settings = (0, _renderer.default)(appointment).data(_constants.APPOINTMENT_SETTINGS_KEY);
                if (!settings) {
                    return
                }
                return this._getAppointmentColor(appointment, settings.groupIndex)
            },
            _getAppointmentColor: function($appointment, groupIndex) {
                var res = new _deferred.Deferred;
                var response = this.invoke("getAppointmentColor", {
                    itemData: this._getItemData($appointment),
                    groupIndex: groupIndex
                });
                response.done(function(color) {
                    return res.resolve(color)
                });
                return res.promise()
            },
            _calculateBoundOffset: function() {
                return this.invoke("getBoundOffset")
            },
            _virtualAppointments: {},
            _processVirtualAppointment: function(appointmentSetting, $appointment, appointmentData, color) {
                var virtualAppointment = appointmentSetting.virtual;
                var virtualGroupIndex = virtualAppointment.index;
                if (!(0, _type.isDefined)(this._virtualAppointments[virtualGroupIndex])) {
                    this._virtualAppointments[virtualGroupIndex] = {
                        coordinates: {
                            top: virtualAppointment.top,
                            left: virtualAppointment.left
                        },
                        items: {
                            data: [],
                            colors: [],
                            settings: []
                        },
                        isAllDay: virtualAppointment.isAllDay ? true : false,
                        buttonColor: color
                    }
                }
                appointmentSetting.targetedAppointmentData = this.invoke("getTargetedAppointmentData", appointmentData, $appointment);
                this._virtualAppointments[virtualGroupIndex].items.settings.push(appointmentSetting);
                this._virtualAppointments[virtualGroupIndex].items.data.push(appointmentData);
                this._virtualAppointments[virtualGroupIndex].items.colors.push(color);
                $appointment.remove()
            },
            _renderContentImpl: function() {
                this.callBase();
                this._renderDropDownAppointments()
            },
            _renderDropDownAppointments: function() {
                var _this3 = this;
                this._renderByFragments(function($commonFragment, $allDayFragment) {
                    (0, _iterator.each)(_this3._virtualAppointments, function(groupIndex) {
                        var virtualGroup = this._virtualAppointments[groupIndex];
                        var virtualItems = virtualGroup.items;
                        var virtualCoordinates = virtualGroup.coordinates;
                        var $fragment = virtualGroup.isAllDay ? $allDayFragment : $commonFragment;
                        var left = virtualCoordinates.left;
                        var buttonWidth = this.invoke("getDropDownAppointmentWidth", virtualGroup.isAllDay);
                        var buttonHeight = this.invoke("getDropDownAppointmentHeight");
                        var rtlOffset = this.option("rtlEnabled") ? buttonWidth : 0;
                        this.notifyObserver("renderCompactAppointments", {
                            $container: $fragment,
                            coordinates: {
                                top: virtualCoordinates.top,
                                left: left + rtlOffset
                            },
                            items: virtualItems,
                            buttonColor: virtualGroup.buttonColor,
                            width: buttonWidth - this.option("_collectorOffset"),
                            height: buttonHeight,
                            onAppointmentClick: this.option("onItemClick"),
                            allowDrag: this.option("allowDrag"),
                            cellWidth: this.invoke("getCellWidth"),
                            isCompact: this.invoke("isAdaptive") || this._isGroupCompact(virtualGroup),
                            applyOffset: !virtualGroup.isAllDay && this.invoke("isApplyCompactAppointmentOffset")
                        })
                    }.bind(_this3))
                })
            },
            _isGroupCompact: function(virtualGroup) {
                return !virtualGroup.isAllDay && this.invoke("supportCompactDropDownAppointments")
            },
            _sortAppointmentsByStartDate: function(appointments) {
                appointments.sort(function(a, b) {
                    var result = 0;
                    var firstDate = new Date(this.invoke("getField", "startDate", a.settings || a)).getTime();
                    var secondDate = new Date(this.invoke("getField", "startDate", b.settings || b)).getTime();
                    if (firstDate < secondDate) {
                        result = -1
                    }
                    if (firstDate > secondDate) {
                        result = 1
                    }
                    return result
                }.bind(this))
            },
            _processRecurrenceAppointment: function(appointment, index, skipLongAppointments) {
                var recurrenceRule = this.invoke("getField", "recurrenceRule", appointment);
                var result = {
                    parts: [],
                    indexes: []
                };
                if (recurrenceRule) {
                    var dates = appointment.settings || appointment;
                    var startDate = new Date(this.invoke("getField", "startDate", dates));
                    var endDate = new Date(this.invoke("getField", "endDate", dates));
                    var appointmentDuration = endDate.getTime() - startDate.getTime();
                    var recurrenceException = this.invoke("getField", "recurrenceException", appointment);
                    var startViewDate = this.invoke("getStartViewDate");
                    var endViewDate = this.invoke("getEndViewDate");
                    var recurrentDates = (0, _recurrence.getRecurrenceProcessor)().generateDates({
                        rule: recurrenceRule,
                        exception: recurrenceException,
                        start: startDate,
                        end: endDate,
                        min: startViewDate,
                        max: endViewDate
                    });
                    var recurrentDateCount = appointment.settings ? 1 : recurrentDates.length;
                    for (var i = 0; i < recurrentDateCount; i++) {
                        var appointmentPart = (0, _extend.extend)({}, appointment, true);
                        if (recurrentDates[i]) {
                            var appointmentSettings = this._applyStartDateToObj(recurrentDates[i], {});
                            this._applyEndDateToObj(new Date(recurrentDates[i].getTime() + appointmentDuration), appointmentSettings);
                            appointmentPart.settings = appointmentSettings
                        } else {
                            appointmentPart.settings = dates
                        }
                        result.parts.push(appointmentPart);
                        if (!skipLongAppointments) {
                            this._processLongAppointment(appointmentPart, result)
                        }
                    }
                    result.indexes.push(index)
                }
                return result
            },
            _processLongAppointment: function(appointment, result) {
                var parts = this.splitAppointmentByDay(appointment);
                var partCount = parts.length;
                var endViewDate = this.invoke("getEndViewDate").getTime();
                var startViewDate = this.invoke("getStartViewDate").getTime();
                var timeZoneCalculator = this.invoke("getTimeZoneCalculator");
                result = result || {
                    parts: []
                };
                if (partCount > 1) {
                    (0, _extend.extend)(appointment, parts[0]);
                    for (var i = 1; i < partCount; i++) {
                        var startDate = this.invoke("getField", "startDate", parts[i].settings).getTime();
                        startDate = timeZoneCalculator.createDate(startDate, {
                            path: "toGrid"
                        });
                        if (startDate < endViewDate && startDate > startViewDate) {
                            result.parts.push(parts[i])
                        }
                    }
                }
                return result
            },
            _reduceRecurrenceAppointments: function(recurrenceIndexes, appointments) {
                (0, _iterator.each)(recurrenceIndexes, function(i, index) {
                    appointments.splice(index - i, 1)
                })
            },
            _combineAppointments: function(appointments, additionalAppointments) {
                if (additionalAppointments.length) {
                    (0, _array.merge)(appointments, additionalAppointments)
                }
                this._sortAppointmentsByStartDate(appointments)
            },
            _applyStartDateToObj: function(startDate, obj) {
                this.invoke("setField", "startDate", obj, startDate);
                return obj
            },
            _applyEndDateToObj: function(endDate, obj) {
                this.invoke("setField", "endDate", obj, endDate);
                return obj
            },
            moveAppointmentBack: function(dragEvent) {
                var $appointment = this._$currentAppointment;
                var size = this._initialSize;
                var coords = this._initialCoordinates;
                if (dragEvent) {
                    this._removeDragSourceClassFromDraggedAppointment();
                    if ((0, _type.isDeferred)(dragEvent.cancel)) {
                        dragEvent.cancel.resolve(true)
                    } else {
                        dragEvent.cancel = true
                    }
                }
                if ($appointment && !dragEvent) {
                    if (coords) {
                        (0, _translator.move)($appointment, coords);
                        delete this._initialSize
                    }
                    if (size) {
                        $appointment.outerWidth(size.width);
                        $appointment.outerHeight(size.height);
                        delete this._initialCoordinates
                    }
                }
            },
            focus: function() {
                if (this._$currentAppointment) {
                    var focusedElement = (0, _element.getPublicElement)(this._$currentAppointment);
                    this.option("focusedElement", focusedElement);
                    _events_engine.default.trigger(focusedElement, "focus")
                }
            },
            splitAppointmentByDay: function(appointment) {
                var dates = appointment.settings || appointment;
                var originalStartDate = new Date(this.invoke("getField", "startDate", dates));
                var startDate = _date.default.makeDate(originalStartDate);
                var endDate = _date.default.makeDate(this.invoke("getField", "endDate", dates));
                var maxAllowedDate = this.invoke("getEndViewDate");
                var startDayHour = this.invoke("getStartDayHour");
                var endDayHour = this.invoke("getEndDayHour");
                var appointmentIsLong = this.invoke("appointmentTakesSeveralDays", appointment);
                var result = [];
                var timeZoneCalculator = this.invoke("getTimeZoneCalculator");
                startDate = timeZoneCalculator.createDate(startDate, {
                    path: "toGrid"
                });
                endDate = timeZoneCalculator.createDate(endDate, {
                    path: "toGrid"
                });
                if (startDate.getHours() <= endDayHour && startDate.getHours() >= startDayHour && !appointmentIsLong) {
                    result.push(this._applyStartDateToObj(new Date(startDate), {
                        appointmentData: appointment
                    }));
                    startDate.setDate(startDate.getDate() + 1)
                }
                while (appointmentIsLong && startDate.getTime() < endDate.getTime() && startDate < maxAllowedDate) {
                    var currentStartDate = new Date(startDate);
                    var currentEndDate = new Date(startDate);
                    this._checkStartDate(currentStartDate, originalStartDate, startDayHour);
                    this._checkEndDate(currentEndDate, endDate, endDayHour);
                    var appointmentData = (0, _object.deepExtendArraySafe)({}, appointment, true);
                    var appointmentSettings = {};
                    this._applyStartDateToObj(currentStartDate, appointmentSettings);
                    this._applyEndDateToObj(currentEndDate, appointmentSettings);
                    appointmentData.settings = appointmentSettings;
                    result.push(appointmentData);
                    startDate = _date.default.trimTime(startDate);
                    startDate.setDate(startDate.getDate() + 1);
                    startDate.setHours(startDayHour)
                }
                return result
            },
            _checkStartDate: function(currentDate, originalDate, startDayHour) {
                if (!_date.default.sameDate(currentDate, originalDate) || currentDate.getHours() <= startDayHour) {
                    currentDate.setHours(startDayHour, 0, 0, 0)
                } else {
                    currentDate.setHours(originalDate.getHours(), originalDate.getMinutes(), originalDate.getSeconds(), originalDate.getMilliseconds())
                }
            },
            _checkEndDate: function(currentDate, originalDate, endDayHour) {
                if (!_date.default.sameDate(currentDate, originalDate) || currentDate.getHours() > endDayHour) {
                    currentDate.setHours(endDayHour, 0, 0, 0)
                } else {
                    currentDate.setHours(originalDate.getHours(), originalDate.getMinutes(), originalDate.getSeconds(), originalDate.getMilliseconds())
                }
            },
            _removeDragSourceClassFromDraggedAppointment: function() {
                var $appointments = this._itemElements().filter(".".concat(_constants.APPOINTMENT_DRAG_SOURCE_CLASS));
                $appointments.each(function(_, element) {
                    var appointmentInstance = (0, _renderer.default)(element).dxSchedulerAppointment("instance");
                    appointmentInstance.option("isDragSource", false)
                })
            },
            _setDragSourceAppointment: function(appointment, settings) {
                var $appointments = this._findItemElementByItem(appointment);
                var _settings$info$source = settings.info.sourceAppointment,
                    startDate = _settings$info$source.startDate,
                    endDate = _settings$info$source.endDate;
                var groupIndex = settings.groupIndex;
                $appointments.forEach(function($item) {
                    var _$item$data = $item.data(_constants.APPOINTMENT_SETTINGS_KEY),
                        itemInfo = _$item$data.info,
                        itemGroupIndex = _$item$data.groupIndex;
                    var _itemInfo$sourceAppoi = itemInfo.sourceAppointment,
                        itemStartDate = _itemInfo$sourceAppoi.startDate,
                        itemEndDate = _itemInfo$sourceAppoi.endDate;
                    var appointmentInstance = $item.dxSchedulerAppointment("instance");
                    var isDragSource = startDate.getTime() === itemStartDate.getTime() && endDate.getTime() === itemEndDate.getTime() && groupIndex === itemGroupIndex;
                    appointmentInstance.option("isDragSource", isDragSource)
                })
            }
        }).include(_uiScheduler.default);
        (0, _component_registrator.default)("dxSchedulerAppointments", SchedulerAppointments);
        var _default = SchedulerAppointments;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/ui.scheduler.appointment.js ***!
      \***************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _translator = __webpack_require__( /*! ../../animation/translator */ 28);
        var _recurrence = __webpack_require__( /*! ./recurrence */ 139);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _ui = __webpack_require__( /*! ../tooltip/ui.tooltip */ 808);
        var _uiScheduler = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.publisher_mixin */ 221));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../../events/pointer */ 24));
        var _dom_component = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_component */ 67));
        var _resizable = _interopRequireDefault(__webpack_require__( /*! ../resizable */ 193));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../localization/date */ 32));
        var _constants = __webpack_require__( /*! ./constants */ 160);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DEFAULT_HORIZONTAL_HANDLES = "left right";
        var DEFAULT_VERTICAL_HANDLES = "top bottom";
        var REDUCED_APPOINTMENT_POINTERENTER_EVENT_NAME = (0, _index.addNamespace)(_pointer.default.enter, "dxSchedulerAppointment");
        var REDUCED_APPOINTMENT_POINTERLEAVE_EVENT_NAME = (0, _index.addNamespace)(_pointer.default.leave, "dxSchedulerAppointment");
        var Appointment = _dom_component.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    data: {},
                    geometry: {
                        top: 0,
                        left: 0,
                        width: 0,
                        height: 0
                    },
                    allowDrag: true,
                    allowResize: true,
                    reduced: null,
                    isCompact: false,
                    direction: "vertical",
                    resizableConfig: {},
                    cellHeight: 0,
                    cellWidth: 0,
                    isDragSource: false
                })
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "data":
                    case "geometry":
                    case "allowDrag":
                    case "allowResize":
                    case "reduced":
                    case "sortedIndex":
                    case "isCompact":
                    case "direction":
                    case "resizableConfig":
                    case "cellHeight":
                    case "cellWidth":
                        this._invalidate();
                        break;
                    case "isDragSource":
                        this._renderDragSourceClass();
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _getHorizontalResizingRule: function() {
                var reducedHandles = {
                    head: this.option("rtlEnabled") ? "right" : "left",
                    body: "",
                    tail: this.option("rtlEnabled") ? "left" : "right"
                };
                return {
                    handles: this.option("reduced") ? reducedHandles[this.option("reduced")] : DEFAULT_HORIZONTAL_HANDLES,
                    minHeight: 0,
                    minWidth: this.invoke("getCellWidth"),
                    step: this.invoke("getResizableStep"),
                    roundStepValue: false
                }
            },
            _getVerticalResizingRule: function() {
                var height = this.invoke("getCellHeight");
                return {
                    handles: DEFAULT_VERTICAL_HANDLES,
                    minWidth: 0,
                    minHeight: height,
                    step: height,
                    roundStepValue: true
                }
            },
            _render: function() {
                this.callBase();
                this._renderAppointmentGeometry();
                this._renderEmptyClass();
                this._renderReducedAppointment();
                this._renderAllDayClass();
                this._renderDragSourceClass();
                this._renderDirection();
                this.$element().data("dxAppointmentStartDate", this.option("startDate"));
                this.$element().attr("title", this.invoke("getField", "text", this.option("data")));
                this.$element().attr("role", "button");
                this._renderRecurrenceClass();
                this._renderResizable()
            },
            _renderAppointmentGeometry: function() {
                var geometry = this.option("geometry");
                var $element = this.$element();
                (0, _translator.move)($element, {
                    top: geometry.top,
                    left: geometry.left
                });
                $element.css({
                    width: geometry.width < 0 ? 0 : geometry.width,
                    height: geometry.height < 0 ? 0 : geometry.height
                })
            },
            _renderEmptyClass: function() {
                var geometry = this.option("geometry");
                if (geometry.empty || this.option("isCompact")) {
                    this.$element().addClass(_constants.EMPTY_APPOINTMENT_CLASS)
                }
            },
            _renderReducedAppointment: function() {
                var reducedPart = this.option("reduced");
                if (!reducedPart) {
                    return
                }
                this.$element().toggleClass(_constants.REDUCED_APPOINTMENT_CLASS, true).toggleClass(_constants.REDUCED_APPOINTMENT_PARTS_CLASSES[reducedPart], true);
                this._renderAppointmentReducedIcon()
            },
            _renderAppointmentReducedIcon: function() {
                var $icon = (0, _renderer.default)("<div>").addClass(_constants.REDUCED_APPOINTMENT_ICON).appendTo(this.$element());
                var endDate = this._getEndDate();
                var tooltipLabel = _message.default.format("dxScheduler-editorLabelEndDate");
                var tooltipText = [tooltipLabel, ": ", _date.default.format(endDate, "monthAndDay"), ", ", _date.default.format(endDate, "year")].join("");
                _events_engine.default.off($icon, REDUCED_APPOINTMENT_POINTERENTER_EVENT_NAME);
                _events_engine.default.on($icon, REDUCED_APPOINTMENT_POINTERENTER_EVENT_NAME, function() {
                    (0, _ui.show)({
                        target: $icon,
                        content: tooltipText
                    })
                });
                _events_engine.default.off($icon, REDUCED_APPOINTMENT_POINTERLEAVE_EVENT_NAME);
                _events_engine.default.on($icon, REDUCED_APPOINTMENT_POINTERLEAVE_EVENT_NAME, function() {
                    (0, _ui.hide)()
                })
            },
            _getEndDate: function() {
                var result = this.invoke("getField", "endDate", this.option("data"));
                if (result) {
                    return new Date(result)
                }
                return result
            },
            _renderAllDayClass: function() {
                this.$element().toggleClass(_constants.ALL_DAY_APPOINTMENT_CLASS, !!this.option("allDay"))
            },
            _renderDragSourceClass: function() {
                this.$element().toggleClass(_constants.APPOINTMENT_DRAG_SOURCE_CLASS, !!this.option("isDragSource"))
            },
            _renderRecurrenceClass: function() {
                var rule = this.invoke("getField", "recurrenceRule", this.option("data"));
                if ((0, _recurrence.getRecurrenceProcessor)().isValidRecurrenceRule(rule)) {
                    this.$element().addClass(_constants.RECURRENCE_APPOINTMENT_CLASS)
                }
            },
            _renderDirection: function() {
                this.$element().addClass(_constants.DIRECTION_APPOINTMENT_CLASSES[this.option("direction")])
            },
            _createResizingConfig: function() {
                var config = "vertical" === this.option("direction") ? this._getVerticalResizingRule() : this._getHorizontalResizingRule();
                if (!this.invoke("isGroupedByDate")) {
                    config.stepPrecision = "strict"
                }
                return config
            },
            _renderResizable: function() {
                if (this.option("allowResize")) {
                    this._createComponent(this.$element(), _resizable.default, (0, _extend.extend)(this._createResizingConfig(), this.option("resizableConfig")))
                }
            },
            _useTemplates: function() {
                return false
            }
        }).include(_uiScheduler.default);
        (0, _component_registrator.default)("dxSchedulerAppointment", Appointment);
        var _default = Appointment;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/tooltip/ui.tooltip.js ***!
      \***********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.show = show;
        exports.hide = hide;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _tooltip = _interopRequireDefault(__webpack_require__( /*! ./tooltip */ 371));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _view_port = __webpack_require__( /*! ../../core/utils/view_port */ 80);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var tooltip = null;
        var removeTooltipElement = null;
        var createTooltip = function(options) {
            options = (0, _extend.extend)({
                position: "top"
            }, options);
            var content = options.content;
            delete options.content;
            var $tooltip = (0, _renderer.default)("<div>").html(content).appendTo((0, _view_port.value)());
            removeTooltipElement = function() {
                $tooltip.remove()
            };
            tooltip = new _tooltip.default($tooltip, options)
        };
        var removeTooltip = function() {
            if (!tooltip) {
                return
            }
            removeTooltipElement();
            tooltip = null
        };

        function show(options) {
            removeTooltip();
            createTooltip(options);
            return tooltip.show()
        }

        function hide() {
            if (!tooltip) {
                return (new _deferred.Deferred).resolve()
            }
            return tooltip.hide().done(removeTooltip).promise()
        }
    },
    /*!*******************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/ui.scheduler.appointments.layout_manager.js ***!
      \*******************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _uiSchedulerAppointmentsStrategy = _interopRequireDefault(__webpack_require__( /*! ./rendering_strategies/ui.scheduler.appointments.strategy.vertical */ 810));
        var _uiSchedulerAppointmentsStrategy2 = _interopRequireDefault(__webpack_require__( /*! ./rendering_strategies/ui.scheduler.appointments.strategy.horizontal */ 438));
        var _uiSchedulerAppointmentsStrategy3 = _interopRequireDefault(__webpack_require__( /*! ./rendering_strategies/ui.scheduler.appointments.strategy.horizontal_month_line */ 439));
        var _uiSchedulerAppointmentsStrategy4 = _interopRequireDefault(__webpack_require__( /*! ./rendering_strategies/ui.scheduler.appointments.strategy.horizontal_month */ 812));
        var _uiSchedulerAppointmentsStrategy5 = _interopRequireDefault(__webpack_require__( /*! ./rendering_strategies/ui.scheduler.appointments.strategy.agenda */ 813));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var RENDERING_STRATEGIES = {
            horizontal: _uiSchedulerAppointmentsStrategy2.default,
            horizontalMonth: _uiSchedulerAppointmentsStrategy4.default,
            horizontalMonthLine: _uiSchedulerAppointmentsStrategy3.default,
            vertical: _uiSchedulerAppointmentsStrategy.default,
            agenda: _uiSchedulerAppointmentsStrategy5.default
        };
        var AppointmentLayoutManager = function() {
            function AppointmentLayoutManager(instance, renderingStrategy) {
                this.instance = instance;
                renderingStrategy && this.initRenderingStrategy(renderingStrategy)
            }
            var _proto = AppointmentLayoutManager.prototype;
            _proto.getCellDimensions = function(options) {
                if (this.instance._workSpace) {
                    return {
                        width: this.instance._workSpace.getCellWidth(),
                        height: this.instance._workSpace.getCellHeight(),
                        allDayHeight: this.instance._workSpace.getAllDayHeight()
                    }
                }
            };
            _proto.getGroupOrientation = function(options) {
                if (this.instance._workSpace) {
                    options.callback(this.instance._workSpace._getRealGroupOrientation())
                }
            };
            _proto.initRenderingStrategy = function(renderingStrategy) {
                var Strategy = RENDERING_STRATEGIES[renderingStrategy];
                this._renderingStrategyInstance = new Strategy(this.instance);
                this.renderingStrategy = renderingStrategy
            };
            _proto.createAppointmentsMap = function(items) {
                var _this = this;
                var _this$getCellDimensio = this.getCellDimensions(),
                    allDayHeight = _this$getCellDimensio.allDayHeight;
                this.instance._allDayCellHeight = allDayHeight;
                this.getGroupOrientation({
                    callback: function(groupOrientation) {
                        return _this.instance._groupOrientation = groupOrientation
                    }
                });
                var appointments = items ? items.slice() : [];
                this._positionMap = this._renderingStrategyInstance.createTaskPositionMap(appointments);
                return this._createAppointmentsMapCore(appointments, this._positionMap)
            };
            _proto._createAppointmentsMapCore = function(list, positionMap) {
                var _this2 = this;
                return list.map(function(data, index) {
                    if (!_this2._renderingStrategyInstance.keepAppointmentSettings()) {
                        delete data.settings
                    }
                    var appointmentSettings = positionMap[index];
                    appointmentSettings.forEach(function(settings) {
                        settings.direction = "vertical" === _this2.renderingStrategy && !settings.allDay ? "vertical" : "horizontal"
                    });
                    return {
                        itemData: data,
                        settings: appointmentSettings,
                        needRepaint: true,
                        needRemove: false
                    }
                })
            };
            _proto._isDataChanged = function(data) {
                var updatedData = this.instance.getUpdatedAppointment();
                return updatedData === data || this.instance.getUpdatedAppointmentKeys().some(function(item) {
                    return data[item.key] === item.value
                })
            };
            _proto._isAppointmentShouldAppear = function(currentAppointment, sourceAppointment) {
                return currentAppointment.needRepaint && sourceAppointment.needRemove
            };
            _proto._isSettingChanged = function(settings, sourceSetting) {
                if (settings.length !== sourceSetting.length) {
                    return true
                }
                for (var i = 0; i < settings.length; i++) {
                    var newSettings = settings[i];
                    var oldSettings = sourceSetting[i];
                    if (oldSettings) {
                        oldSettings.sortedIndex = newSettings.sortedIndex
                    }
                    if (!(0, _common.equalByValue)(newSettings, oldSettings)) {
                        return true
                    }
                }
                return false
            };
            _proto._getAssociatedSourceAppointment = function(currentAppointment, sourceAppointments) {
                for (var i = 0; i < sourceAppointments.length; i++) {
                    var item = sourceAppointments[i];
                    if (item.itemData === currentAppointment.itemData) {
                        return item
                    }
                }
                return null
            };
            _proto._getDeletedAppointments = function(currentAppointments, sourceAppointments) {
                var result = [];
                for (var i = 0; i < sourceAppointments.length; i++) {
                    var sourceAppointment = sourceAppointments[i];
                    var currentAppointment = this._getAssociatedSourceAppointment(sourceAppointment, currentAppointments);
                    if (!currentAppointment) {
                        sourceAppointment.needRemove = true;
                        result.push(sourceAppointment)
                    }
                }
                return result
            };
            _proto.getRepaintedAppointments = function(currentAppointments, sourceAppointments) {
                var _this3 = this;
                if (0 === sourceAppointments.length || "agenda" === this.renderingStrategy) {
                    return currentAppointments
                }
                currentAppointments.forEach(function(appointment) {
                    var sourceAppointment = _this3._getAssociatedSourceAppointment(appointment, sourceAppointments);
                    if (sourceAppointment) {
                        appointment.needRepaint = _this3._isDataChanged(appointment.itemData) || _this3._isSettingChanged(appointment.settings, sourceAppointment.settings) || _this3._isAppointmentShouldAppear(appointment, sourceAppointment)
                    }
                });
                return currentAppointments.concat(this._getDeletedAppointments(currentAppointments, sourceAppointments))
            };
            _proto.getRenderingStrategyInstance = function() {
                return this._renderingStrategyInstance
            };
            return AppointmentLayoutManager
        }();
        var _default = AppointmentLayoutManager;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/rendering_strategies/ui.scheduler.appointments.strategy.vertical.js ***!
      \*******************************************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiSchedulerAppointmentsStrategy = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.appointments.strategy.base */ 299));
        var _extend = __webpack_require__( /*! ../../../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../../../core/utils/type */ 1);
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../../core/utils/date */ 19));
        var _utils = _interopRequireDefault(__webpack_require__( /*! ./../utils.timeZone */ 86));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var ALLDAY_APPOINTMENT_MIN_VERTICAL_OFFSET = 5;
        var ALLDAY_APPOINTMENT_MAX_VERTICAL_OFFSET = 20;
        var toMs = _date.default.dateToMilliseconds;
        var VerticalRenderingStrategy = function(_BaseAppointmentsStra) {
            _inheritsLoose(VerticalRenderingStrategy, _BaseAppointmentsStra);

            function VerticalRenderingStrategy() {
                return _BaseAppointmentsStra.apply(this, arguments) || this
            }
            var _proto = VerticalRenderingStrategy.prototype;
            _proto.getDeltaTime = function(args, initialSize, appointment) {
                var deltaTime = 0;
                if (this.isAllDay(appointment)) {
                    deltaTime = this._getDeltaWidth(args, initialSize) * toMs("day")
                } else {
                    var deltaHeight = args.height - initialSize.height;
                    deltaTime = toMs("minute") * Math.round(deltaHeight / this.getDefaultCellHeight() * this.instance.getAppointmentDurationInMinutes())
                }
                return deltaTime
            };
            _proto._correctCollectorCoordinatesInAdaptive = function(coordinates, isAllDay) {
                if (isAllDay) {
                    _BaseAppointmentsStra.prototype._correctCollectorCoordinatesInAdaptive.call(this, coordinates, isAllDay)
                } else {
                    if (0 === this._getMaxAppointmentCountPerCellByType()) {
                        var cellHeight = this.getDefaultCellHeight();
                        var cellWidth = this.getDefaultCellWidth();
                        coordinates.top += (cellHeight - this.getDropDownButtonAdaptiveSize()) / 2;
                        coordinates.left += (cellWidth - this.getDropDownButtonAdaptiveSize()) / 2
                    }
                }
            };
            _proto.getAppointmentGeometry = function(coordinates) {
                var geometry = null;
                if (coordinates.allDay) {
                    geometry = this._getAllDayAppointmentGeometry(coordinates)
                } else {
                    geometry = this._isAdaptive() && coordinates.isCompact ? this._getAdaptiveGeometry(coordinates) : this._getVerticalAppointmentGeometry(coordinates)
                }
                return _BaseAppointmentsStra.prototype.getAppointmentGeometry.call(this, geometry)
            };
            _proto._getAdaptiveGeometry = function(coordinates) {
                var config = this._calculateGeometryConfig(coordinates);
                return this._customizeCoordinates(coordinates, config.height, config.appointmentCountPerCell, config.offset)
            };
            _proto._getItemPosition = function(appointment) {
                var adapter = this.instance.createAppointmentAdapter(appointment);
                var allDay = this.isAllDay(appointment);
                var isRecurring = !!adapter.recurrenceRule;
                var appointmentStartDate = adapter.calculateStartDate("toGrid");
                var appointmentEndDate = adapter.calculateEndDate("toGrid");
                var isAppointmentTakesSeveralDays = !_utils.default.isSameAppointmentDates(appointmentStartDate, appointmentEndDate);
                if (allDay) {
                    return _BaseAppointmentsStra.prototype._getItemPosition.call(this, appointment)
                }
                var settings = this._getAppointmentCoordinates(appointment);
                var result = [];
                for (var j = 0; j < settings.length; j++) {
                    var currentSetting = settings[j];
                    var height = this.calculateAppointmentHeight(appointment, currentSetting);
                    var width = this.calculateAppointmentWidth(appointment, currentSetting);
                    var resultHeight = height;
                    var appointmentReduced = null;
                    var multiDaysAppointmentParts = [];
                    var currentMaxAllowedPosition = currentSetting.vMax;
                    if (this._isMultiViewAppointment(currentSetting, height) || isAppointmentTakesSeveralDays && !isRecurring) {
                        var reduceHead = _date.default.sameDate(appointmentStartDate, currentSetting.info.appointment.startDate) || isRecurring;
                        if (reduceHead) {
                            resultHeight = this._reduceMultiDayAppointment(height, {
                                top: currentSetting.top,
                                bottom: currentMaxAllowedPosition
                            });
                            multiDaysAppointmentParts = this._getAppointmentParts({
                                sourceAppointmentHeight: height,
                                reducedHeight: resultHeight,
                                width: width
                            }, currentSetting)
                        }
                        var isMultiDay = this._isMultiDayAppointment(currentSetting, height);
                        if (isMultiDay) {
                            appointmentReduced = reduceHead ? "head" : "tail"
                        }
                    }(0, _extend.extend)(currentSetting, {
                        height: resultHeight,
                        width: width,
                        allDay: allDay,
                        appointmentReduced: appointmentReduced
                    });
                    result = this._getAppointmentPartsPosition(multiDaysAppointmentParts, currentSetting, result)
                }
                return result
            };
            _proto._isMultiDayAppointment = function(position, height) {
                if (this.isVirtualScrolling) {
                    var maxTop = this._getGroupHeight() - this._getGroupTopOffset(position);
                    return height > maxTop
                }
                return false
            };
            _proto._isMultiViewAppointment = function(position, height) {
                return height > position.vMax - position.top
            };
            _proto._reduceMultiDayAppointment = function(sourceAppointmentHeight, bound) {
                sourceAppointmentHeight = bound.bottom - Math.floor(bound.top);
                return sourceAppointmentHeight
            };
            _proto._getGroupHeight = function() {
                var workspace = this.instance.getWorkSpace();
                return workspace.getCellHeight() * workspace._getRowCount()
            };
            _proto._getGroupTopOffset = function(appointmentSettings) {
                var groupTop = Math.max(0, this.instance.fire("getGroupTop", appointmentSettings.groupIndex));
                var allDayPanelOffset = this.instance.fire("getOffsetByAllDayPanel", appointmentSettings.groupIndex);
                var appointmentGroupTopOffset = appointmentSettings.top - groupTop - allDayPanelOffset;
                return appointmentGroupTopOffset
            };
            _proto._getTailHeight = function(appointmentGeometry, appointmentSettings) {
                if (!this.isVirtualScrolling) {
                    return appointmentGeometry.sourceAppointmentHeight - appointmentGeometry.reducedHeight
                }
                var appointmentGroupTopOffset = this._getGroupTopOffset(appointmentSettings);
                var sourceAppointmentHeight = appointmentGeometry.sourceAppointmentHeight;
                var groupHeight = this._getGroupHeight();
                var tailHeight = appointmentGroupTopOffset + sourceAppointmentHeight - groupHeight;
                return tailHeight
            };
            _proto._getAppointmentParts = function(appointmentGeometry, appointmentSettings) {
                var tailHeight = this._getTailHeight(appointmentGeometry, appointmentSettings);
                var width = appointmentGeometry.width;
                var result = [];
                var currentPartTop = Math.max(0, this.instance.fire("getGroupTop", appointmentSettings.groupIndex));
                var cellsDiff = this.instance.fire("isGroupedByDate") ? this.instance.fire("getGroupCount") : 1;
                var offset = this.getDefaultCellWidth() * cellsDiff;
                var left = appointmentSettings.left + offset;
                if (tailHeight > 0) {
                    var minHeight = this.getAppointmentMinSize();
                    if (tailHeight < minHeight) {
                        tailHeight = minHeight
                    }
                    currentPartTop += this.instance.fire("getOffsetByAllDayPanel", appointmentSettings.groupIndex);
                    result.push((0, _extend.extend)(true, {}, appointmentSettings, {
                        top: currentPartTop,
                        left: left,
                        height: tailHeight,
                        width: width,
                        appointmentReduced: "tail",
                        rowIndex: 0,
                        cellIndex: appointmentSettings.cellIndex + cellsDiff
                    }))
                }
                return result
            };
            _proto._getMinuteHeight = function() {
                return this.getDefaultCellHeight() / this.instance.getAppointmentDurationInMinutes()
            };
            _proto._getCompactLeftCoordinate = function(itemLeft, index) {
                var cellBorderSize = 1;
                var cellWidth = this.getDefaultCellWidth() || this.getAppointmentMinSize();
                return itemLeft + (cellBorderSize + cellWidth) * index
            };
            _proto._getVerticalAppointmentGeometry = function(coordinates) {
                var config = this._calculateVerticalGeometryConfig(coordinates);
                return this._customizeVerticalCoordinates(coordinates, config.width, config.appointmentCountPerCell, config.offset)
            };
            _proto._customizeVerticalCoordinates = function(coordinates, width, appointmentCountPerCell, topOffset, isAllDay) {
                var appointmentWidth = Math.max(width / appointmentCountPerCell, width / coordinates.count);
                var height = coordinates.height;
                var appointmentLeft = coordinates.left + coordinates.index * appointmentWidth;
                var top = coordinates.top;
                if (coordinates.isCompact) {
                    this._markAppointmentAsVirtual(coordinates, isAllDay)
                }
                return {
                    height: height,
                    width: appointmentWidth,
                    top: top,
                    left: appointmentLeft,
                    empty: this._isAppointmentEmpty(height, width)
                }
            };
            _proto._calculateVerticalGeometryConfig = function(coordinates) {
                var overlappingMode = this.instance.fire("getMaxAppointmentsPerCell");
                var offsets = this._getOffsets();
                var appointmentDefaultOffset = this._getAppointmentDefaultOffset();
                var appointmentCountPerCell = this._getAppointmentCount(overlappingMode, coordinates);
                var ratio = this._getDefaultRatio(coordinates, appointmentCountPerCell);
                var maxWidth = this._getMaxWidth();
                if (!appointmentCountPerCell) {
                    appointmentCountPerCell = coordinates.count;
                    ratio = (maxWidth - offsets.unlimited) / maxWidth
                }
                var topOffset = (1 - ratio) * maxWidth;
                if ("auto" === overlappingMode || (0, _type.isNumeric)(overlappingMode)) {
                    ratio = 1;
                    maxWidth -= appointmentDefaultOffset;
                    topOffset = 0
                }
                return {
                    width: ratio * maxWidth,
                    appointmentCountPerCell: appointmentCountPerCell,
                    offset: topOffset
                }
            };
            _proto._getMaxWidth = function() {
                return this.getDefaultCellWidth() || this.invoke("getCellWidth")
            };
            _proto.isAllDay = function(appointmentData) {
                var allDay = this.instance.fire("getField", "allDay", appointmentData);
                if (allDay) {
                    return true
                }
                return this.instance.appointmentTakesAllDay(appointmentData)
            };
            _proto._getAppointmentMaxWidth = function() {
                return this.getDefaultCellWidth() - this._getAppointmentDefaultOffset()
            };
            _proto.calculateAppointmentWidth = function(appointment, position) {
                if (!this.isAllDay(appointment)) {
                    return 0
                }
                var startDate = _date.default.trimTime(position.info.appointment.startDate);
                var endDate = this.normalizeEndDateByViewEnd(appointment, position.info.appointment.endDate);
                var cellWidth = this.getDefaultCellWidth() || this.getAppointmentMinSize();
                var durationInHours = (endDate.getTime() - startDate.getTime()) / toMs("hour");
                var width = Math.ceil(durationInHours / 24) * cellWidth;
                width = this.cropAppointmentWidth(width, cellWidth);
                return width
            };
            _proto.calculateAppointmentHeight = function(appointment, position) {
                if (this.isAllDay(appointment)) {
                    return 0
                }
                var startDate = position.info.appointment.startDate;
                var endDate = this.normalizeEndDateByViewEnd(appointment, position.info.appointment.endDate);
                var allDay = this.instance.fire("getField", "allDay", appointment);
                var fullDuration = this._getAppointmentDurationInMs(startDate, endDate, allDay);
                var durationInMinutes = this._adjustDurationByDaylightDiff(fullDuration, startDate, endDate) / toMs("minute");
                var height = durationInMinutes * this._getMinuteHeight();
                return height
            };
            _proto.getDirection = function() {
                return "vertical"
            };
            _proto._sortCondition = function(a, b) {
                var allDayCondition = a.allDay - b.allDay;
                var isAllDay = a.allDay && b.allDay;
                var condition = "vertical" === this.instance._groupOrientation && isAllDay ? this._columnCondition(a, b) : this._rowCondition(a, b);
                return allDayCondition ? allDayCondition : condition
            };
            _proto.hasAllDayAppointments = function() {
                return true
            };
            _proto._getAllDayAppointmentGeometry = function(coordinates) {
                var config = this._calculateGeometryConfig(coordinates);
                return this._customizeCoordinates(coordinates, config.height, config.appointmentCountPerCell, config.offset, true)
            };
            _proto._calculateGeometryConfig = function(coordinates) {
                if (!this.instance._allowResizing() || !this.instance._allowAllDayResizing()) {
                    coordinates.skipResizing = true
                }
                var config = _BaseAppointmentsStra.prototype._calculateGeometryConfig.call(this, coordinates);
                if (coordinates.count <= this._getDynamicAppointmentCountPerCell().allDay) {
                    config.offset = 0
                }
                return config
            };
            _proto._getAppointmentCount = function(overlappingMode, coordinates) {
                return "auto" !== overlappingMode && 1 === coordinates.count && !(0, _type.isNumeric)(overlappingMode) ? coordinates.count : this._getMaxAppointmentCountPerCellByType(coordinates.allDay)
            };
            _proto._getDefaultRatio = function(coordinates, appointmentCountPerCell) {
                return coordinates.count > this.instance.option("_appointmentCountPerCell") ? .65 : 1
            };
            _proto._getOffsets = function() {
                return {
                    unlimited: ALLDAY_APPOINTMENT_MIN_VERTICAL_OFFSET,
                    auto: ALLDAY_APPOINTMENT_MAX_VERTICAL_OFFSET
                }
            };
            _proto._getMaxHeight = function() {
                return this.getDefaultAllDayCellHeight() || this.getAppointmentMinSize()
            };
            _proto._needVerticalGroupBounds = function(allDay) {
                return !allDay
            };
            _proto._needHorizontalGroupBounds = function() {
                return false
            };
            return VerticalRenderingStrategy
        }(_uiSchedulerAppointmentsStrategy.default);
        var _default = VerticalRenderingStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/rendering_strategies/ui.scheduler.appointmentsPositioning.strategy.adaptive.js ***!
      \******************************************************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiSchedulerAppointmentsPositioningStrategy = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.appointmentsPositioning.strategy.base */ 437));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var COLLECTOR_ADAPTIVE_SIZE = 28;
        var COLLECTOR_ADAPTIVE_BOTTOM_OFFSET = 40;
        var ADAPTIVE_APPOINTMENT_DEFAULT_OFFSET = 35;
        var ADAPTIVE_APPOINTMENT_DEFAULT_WIDTH = 30;
        var AdaptivePositioningStrategy = function(_BasePositioningStrat) {
            _inheritsLoose(AdaptivePositioningStrategy, _BasePositioningStrat);

            function AdaptivePositioningStrategy() {
                return _BasePositioningStrat.apply(this, arguments) || this
            }
            var _proto = AdaptivePositioningStrategy.prototype;
            _proto.getDropDownAppointmentWidth = function(intervalCount, isAllDay) {
                return this.getDropDownButtonAdaptiveSize()
            };
            _proto.getDropDownButtonAdaptiveSize = function() {
                return COLLECTOR_ADAPTIVE_SIZE
            };
            _proto.getCollectorTopOffset = function(allDay) {
                var renderingStrategy = this.getRenderingStrategy();
                if (renderingStrategy.hasAllDayAppointments() && allDay) {
                    return (renderingStrategy.getDefaultAllDayCellHeight() - renderingStrategy.getDropDownButtonAdaptiveSize()) / 2
                } else {
                    return this.getRenderingStrategy().getDefaultCellHeight() - COLLECTOR_ADAPTIVE_BOTTOM_OFFSET
                }
            };
            _proto.getCollectorLeftOffset = function() {
                return (this.getRenderingStrategy().getDefaultCellWidth() - COLLECTOR_ADAPTIVE_SIZE) / 2
            };
            _proto.getAppointmentDefaultOffset = function() {
                return ADAPTIVE_APPOINTMENT_DEFAULT_OFFSET
            };
            _proto.getDynamicAppointmentCountPerCell = function() {
                var renderingStrategy = this.getRenderingStrategy();
                if (renderingStrategy.hasAllDayAppointments()) {
                    return {
                        allDay: 0,
                        simple: this._calculateDynamicAppointmentCountPerCell() || this._getAppointmentMinCount()
                    }
                } else {
                    return 0
                }
            };
            _proto.getDropDownAppointmentHeight = function() {
                return COLLECTOR_ADAPTIVE_SIZE
            };
            _proto._getAppointmentMinCount = function() {
                return 0
            };
            _proto._getAppointmentDefaultWidth = function() {
                var renderingStrategy = this.getRenderingStrategy();
                if (renderingStrategy.hasAllDayAppointments()) {
                    return ADAPTIVE_APPOINTMENT_DEFAULT_WIDTH
                }
                return _BasePositioningStrat.prototype._getAppointmentDefaultWidth.call(this)
            };
            _proto._calculateDynamicAppointmentCountPerCell = function() {
                return Math.floor(this.getRenderingStrategy()._getAppointmentMaxWidth() / this.getRenderingStrategy()._getAppointmentDefaultWidth())
            };
            return AdaptivePositioningStrategy
        }(_uiSchedulerAppointmentsPositioningStrategy.default);
        var _default = AdaptivePositioningStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/rendering_strategies/ui.scheduler.appointments.strategy.horizontal_month.js ***!
      \***************************************************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiSchedulerAppointmentsStrategy = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.appointments.strategy.horizontal_month_line */ 439));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function _slicedToArray(arr, i) {
            return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest()
        }

        function _nonIterableRest() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }

        function _iterableToArrayLimit(arr, i) {
            var _i = arr && ("undefined" !== typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]);
            if (null == _i) {
                return
            }
            var _arr = [];
            var _n = true;
            var _d = false;
            var _s, _e;
            try {
                for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
                    _arr.push(_s.value);
                    if (i && _arr.length === i) {
                        break
                    }
                }
            } catch (err) {
                _d = true;
                _e = err
            } finally {
                try {
                    if (!_n && null != _i.return) {
                        _i.return()
                    }
                } finally {
                    if (_d) {
                        throw _e
                    }
                }
            }
            return _arr
        }

        function _arrayWithHoles(arr) {
            if (Array.isArray(arr)) {
                return arr
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var MONTH_APPOINTMENT_HEIGHT_RATIO = .6;
        var MONTH_APPOINTMENT_MIN_OFFSET = 26;
        var MONTH_APPOINTMENT_MAX_OFFSET = 30;
        var MONTH_DROPDOWN_APPOINTMENT_MIN_RIGHT_OFFSET = 36;
        var MONTH_DROPDOWN_APPOINTMENT_MAX_RIGHT_OFFSET = 60;
        var HorizontalMonthRenderingStrategy = function(_HorizontalMonthLineA) {
            _inheritsLoose(HorizontalMonthRenderingStrategy, _HorizontalMonthLineA);

            function HorizontalMonthRenderingStrategy() {
                return _HorizontalMonthLineA.apply(this, arguments) || this
            }
            var _proto = HorizontalMonthRenderingStrategy.prototype;
            _proto._getLeftPosition = function(settings) {
                var fullWeekAppointmentWidth = this._getFullWeekAppointmentWidth(settings.groupIndex);
                var result = this._calculateMultiWeekAppointmentLeftOffset(settings.hMax, fullWeekAppointmentWidth);
                if ("vertical" === this.instance._groupOrientation) {
                    result += this.instance.fire("getWorkSpaceDateTableOffset")
                }
                return result
            };
            _proto._getChunkCount = function(fullChunksWidth, firstChunkWidth, weekWidth) {
                var rawFullChunksWidth = fullChunksWidth - firstChunkWidth + weekWidth;
                return Math.ceil(rawFullChunksWidth / weekWidth)
            };
            _proto._getChunkWidths = function(geometry) {
                var firstChunkWidth = geometry.reducedWidth;
                var fullChunksWidth = Math.round(geometry.sourceAppointmentWidth);
                var widthWithoutFirstChunk = fullChunksWidth - firstChunkWidth;
                return [geometry.reducedWidth, Math.round(geometry.sourceAppointmentWidth), widthWithoutFirstChunk]
            };
            _proto._getTailChunkSettings = function(withoutFirstChunkWidth, weekWidth, leftPosition) {
                var tailChunkWidth = withoutFirstChunkWidth % weekWidth || weekWidth;
                var rtlPosition = leftPosition + (weekWidth - tailChunkWidth);
                var tailChunkLeftPosition = this._isRtl() ? rtlPosition : leftPosition;
                return [tailChunkWidth, tailChunkLeftPosition]
            };
            _proto._getAppointmentParts = function(geometry, settings) {
                var result = [];
                var _this$_getChunkWidths = this._getChunkWidths(geometry),
                    _this$_getChunkWidths2 = _slicedToArray(_this$_getChunkWidths, 3),
                    firstChunkWidth = _this$_getChunkWidths2[0],
                    fullChunksWidth = _this$_getChunkWidths2[1],
                    withoutFirstChunkWidth = _this$_getChunkWidths2[2];
                var leftPosition = this._getLeftPosition(settings);
                var weekWidth = Math.round(this._getFullWeekAppointmentWidth(settings.groupIndex));
                var hasTailChunk = this.instance.fire("getEndViewDate") > settings.info.appointment.endDate;
                var chunkCount = this._getChunkCount(fullChunksWidth, firstChunkWidth, weekWidth);
                var _this$_getTailChunkSe = this._getTailChunkSettings(withoutFirstChunkWidth, weekWidth, leftPosition),
                    _this$_getTailChunkSe2 = _slicedToArray(_this$_getTailChunkSe, 2),
                    tailChunkWidth = _this$_getTailChunkSe2[0],
                    tailChunkLeftPosition = _this$_getTailChunkSe2[1];
                for (var chunkIndex = 1; chunkIndex < chunkCount; chunkIndex++) {
                    var topPosition = settings.top + this.getDefaultCellHeight() * chunkIndex;
                    var isTailChunk = hasTailChunk && chunkIndex === chunkCount - 1;
                    result.push(_objectSpread(_objectSpread({}, settings), {
                        top: topPosition,
                        left: isTailChunk ? tailChunkLeftPosition : leftPosition,
                        height: geometry.height,
                        width: isTailChunk ? tailChunkWidth : weekWidth,
                        appointmentReduced: isTailChunk ? "tail" : "body",
                        rowIndex: ++settings.rowIndex,
                        cellIndex: 0
                    }))
                }
                var groupDeltaWidth = this._getGroupDeltaWidth(settings.groupIndex);
                result.forEach(function(item) {
                    item.left = Math.max(item.left + groupDeltaWidth, 0);
                    item.width = Math.max(item.width - groupDeltaWidth, 0)
                });
                return result
            };
            _proto._getGroupDeltaWidth = function(groupIndex) {
                var result = 0;
                var workspace = this.instance.getWorkSpace();
                if (workspace.isRenovatedRender()) {
                    var viewDataProvider = workspace.viewDataProvider;
                    var cellCountDelta = viewDataProvider.getGroupCellCountDelta(groupIndex);
                    result = cellCountDelta * workspace.getCellWidth()
                }
                return result
            };
            _proto._calculateMultiWeekAppointmentLeftOffset = function(max, width) {
                return this._isRtl() ? max : max - width
            };
            _proto._getFullWeekAppointmentWidth = function(groupIndex) {
                this._maxFullWeekAppointmentWidth = this.instance.fire("getFullWeekAppointmentWidth", {
                    groupIndex: groupIndex
                });
                return this._maxFullWeekAppointmentWidth
            };
            _proto._getAppointmentDefaultHeight = function() {
                return this._getAppointmentHeightByTheme()
            };
            _proto._getAppointmentMinHeight = function() {
                return this._getAppointmentDefaultHeight()
            };
            _proto._columnCondition = function(a, b) {
                var conditions = this._getConditions(a, b);
                return conditions.rowCondition || conditions.columnCondition || conditions.cellPositionCondition
            };
            _proto.createTaskPositionMap = function(items) {
                return _HorizontalMonthLineA.prototype.createTaskPositionMap.call(this, items, true)
            };
            _proto._getSortedPositions = function(map) {
                return _HorizontalMonthLineA.prototype._getSortedPositions.call(this, map, true)
            };
            _proto._getDefaultRatio = function() {
                return MONTH_APPOINTMENT_HEIGHT_RATIO
            };
            _proto._getOffsets = function() {
                return {
                    unlimited: MONTH_APPOINTMENT_MIN_OFFSET,
                    auto: MONTH_APPOINTMENT_MAX_OFFSET
                }
            };
            _proto.getDropDownAppointmentWidth = function(intervalCount) {
                if (this.instance.fire("isAdaptive")) {
                    return this.getDropDownButtonAdaptiveSize()
                }
                var offset = intervalCount > 1 ? MONTH_DROPDOWN_APPOINTMENT_MAX_RIGHT_OFFSET : MONTH_DROPDOWN_APPOINTMENT_MIN_RIGHT_OFFSET;
                return this.getDefaultCellWidth() - offset
            };
            _proto.needCorrectAppointmentDates = function() {
                return false
            };
            _proto._needVerticalGroupBounds = function() {
                return false
            };
            _proto._needHorizontalGroupBounds = function() {
                return true
            };
            return HorizontalMonthRenderingStrategy
        }(_uiSchedulerAppointmentsStrategy.default);
        var _default = HorizontalMonthRenderingStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/rendering_strategies/ui.scheduler.appointments.strategy.agenda.js ***!
      \*****************************************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../../core/utils/date */ 19));
        var _iterator = __webpack_require__( /*! ../../../core/utils/iterator */ 3);
        var _array = __webpack_require__( /*! ../../../core/utils/array */ 12);
        var _uiSchedulerAppointmentsStrategy = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.appointments.strategy.base */ 299));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var AgendaRenderingStrategy = function(_BaseAppointmentsStra) {
            _inheritsLoose(AgendaRenderingStrategy, _BaseAppointmentsStra);

            function AgendaRenderingStrategy() {
                return _BaseAppointmentsStra.apply(this, arguments) || this
            }
            var _proto = AgendaRenderingStrategy.prototype;
            _proto.getAppointmentMinSize = function() {};
            _proto.getDeltaTime = function() {};
            _proto.keepAppointmentSettings = function() {
                return true
            };
            _proto.getAppointmentGeometry = function(geometry) {
                return geometry
            };
            _proto.createTaskPositionMap = function(appointments) {
                var height;
                var appointmentsByResources;
                if (appointments.length) {
                    height = this.instance.fire("getAgendaVerticalStepHeight");
                    appointmentsByResources = this.instance.fire("groupAppointmentsByResources", appointments);
                    var groupedAppts = [];
                    (0, _iterator.each)(appointmentsByResources, function(i, appts) {
                        var additionalAppointments = [];
                        var recurrentIndexes = [];
                        (0, _iterator.each)(appts, function(index, appointment) {
                            var recurrenceBatch = this.instance.getAppointmentsInstance()._processRecurrenceAppointment(appointment, index);
                            var appointmentBatch = null;
                            if (!recurrenceBatch.indexes.length) {
                                appointmentBatch = {
                                    parts: []
                                };
                                appointmentBatch = this.instance.getAppointmentsInstance()._processLongAppointment(appointment);
                                additionalAppointments = additionalAppointments.concat(appointmentBatch.parts)
                            }
                            additionalAppointments = additionalAppointments.concat(recurrenceBatch.parts);
                            recurrentIndexes = recurrentIndexes.concat(recurrenceBatch.indexes)
                        }.bind(this));
                        this.instance.getAppointmentsInstance()._reduceRecurrenceAppointments(recurrentIndexes, appts);
                        this.instance.getAppointmentsInstance()._combineAppointments(appts, additionalAppointments);
                        groupedAppts = groupedAppts.concat(appts)
                    }.bind(this));
                    Array.prototype.splice.apply(appointments, [0, appointments.length].concat(groupedAppts))
                }
                var result = [];
                var sortedIndex = 0;
                appointments.forEach(function(appt, index) {
                    result.push([{
                        height: height,
                        width: "100%",
                        sortedIndex: sortedIndex++,
                        groupIndex: this._calculateGroupIndex(index, appointmentsByResources),
                        agendaSettings: appt.settings
                    }]);
                    delete appt.settings
                }.bind(this));
                return result
            };
            _proto._calculateGroupIndex = function(apptIndex, appointmentsByResources) {
                var resultInd;
                var counter = 0;
                for (var i in appointmentsByResources) {
                    var countApptInGroup = appointmentsByResources[i].length;
                    if (apptIndex >= counter && apptIndex < counter + countApptInGroup) {
                        resultInd = Number(i);
                        break
                    }
                    counter += countApptInGroup
                }
                return resultInd
            };
            _proto._getDeltaWidth = function() {};
            _proto._getAppointmentMaxWidth = function() {
                return this.getDefaultCellWidth()
            };
            _proto._needVerifyItemSize = function() {
                return false
            };
            _proto._isRtl = function() {
                return this.instance.option("rtlEnabled")
            };
            _proto._getAppointmentParts = function() {};
            _proto._reduceMultiWeekAppointment = function() {};
            _proto.calculateAppointmentHeight = function() {
                return 0
            };
            _proto.calculateAppointmentWidth = function() {
                return 0
            };
            _proto.isAppointmentGreaterThan = function() {};
            _proto.isAllDay = function() {
                return false
            };
            _proto._sortCondition = function() {};
            _proto._rowCondition = function() {};
            _proto._columnCondition = function() {};
            _proto._findIndexByKey = function() {};
            _proto._markAppointmentAsVirtual = function() {};
            _proto.getDropDownAppointmentWidth = function() {};
            _proto.getDefaultCellWidth = function() {
                return this._defaultWidth
            };
            _proto.getCollectorLeftOffset = function() {};
            _proto.getCollectorTopOffset = function() {};
            _proto.calculateRows = function(appointments, agendaDuration, currentDate, needClearSettings) {
                this._rows = [];
                var groupedAppointments = this.instance.fire("groupAppointmentsByResources", appointments);
                currentDate = _date.default.trimTime(new Date(currentDate));
                (0, _iterator.each)(groupedAppointments, function(groupIndex, currentAppointments) {
                    var groupResult = [];
                    var appts = {
                        indexes: [],
                        parts: []
                    };
                    if (!currentAppointments.length) {
                        this._rows.push([]);
                        return true
                    }(0, _iterator.each)(currentAppointments, function(index, appointment) {
                        var startDate = this.instance.fire("getField", "startDate", appointment);
                        var endDate = this.instance.fire("getField", "endDate", appointment);
                        this.instance.fire("replaceWrongEndDate", appointment, startDate, endDate);
                        needClearSettings && delete appointment.settings;
                        var result = this.instance.getAppointmentsInstance()._processRecurrenceAppointment(appointment, index, false);
                        appts.parts = appts.parts.concat(result.parts);
                        appts.indexes = appts.indexes.concat(result.indexes)
                    }.bind(this));
                    this.instance.getAppointmentsInstance()._reduceRecurrenceAppointments(appts.indexes, currentAppointments);
                    (0, _array.merge)(currentAppointments, appts.parts);
                    var appointmentCount = currentAppointments.length;
                    for (var i = 0; i < agendaDuration; i++) {
                        var day = new Date(currentDate);
                        day.setMilliseconds(day.getMilliseconds() + 864e5 * i);
                        if (void 0 === groupResult[i]) {
                            groupResult[i] = 0
                        }
                        for (var j = 0; j < appointmentCount; j++) {
                            var appointmentData = currentAppointments[j].settings || currentAppointments[j];
                            var appointmentIsLong = this.instance.fire("appointmentTakesSeveralDays", currentAppointments[j]);
                            var appointmentIsRecurrence = this.instance.fire("getField", "recurrenceRule", currentAppointments[j]);
                            if (this.instance.fire("dayHasAppointment", day, appointmentData, true) || !appointmentIsRecurrence && appointmentIsLong && this.instance.fire("dayHasAppointment", day, currentAppointments[j], true)) {
                                groupResult[i] += 1
                            }
                        }
                    }
                    this._rows.push(groupResult)
                }.bind(this));
                return this._rows
            };
            _proto._iterateRow = function(row, obj, index) {
                for (var i = 0; i < row.length; i++) {
                    obj.counter = obj.counter + row[i];
                    if (obj.counter >= index) {
                        obj.indexInRow = i;
                        break
                    }
                }
            };
            _proto.getDateByIndex = function(index, rows, startViewDate) {
                var obj = {
                    counter: 0,
                    indexInRow: 0
                };
                index++;
                for (var i = 0; i < rows.length; i++) {
                    this._iterateRow(rows[i], obj, index);
                    if (obj.indexInRow) {
                        break
                    }
                }
                return new Date(new Date(startViewDate).setDate(startViewDate.getDate() + obj.indexInRow))
            };
            _proto.getAppointmentDataCalculator = function() {
                return function($appointment, originalStartDate) {
                    var apptIndex = $appointment.index();
                    var startViewDate = this.instance.getStartViewDate();
                    var calculatedStartDate = this.getDateByIndex(apptIndex, this._rows, startViewDate);
                    var wrappedOriginalStartDate = new Date(originalStartDate);
                    return {
                        startDate: new Date(calculatedStartDate.setHours(wrappedOriginalStartDate.getHours(), wrappedOriginalStartDate.getMinutes(), wrappedOriginalStartDate.getSeconds(), wrappedOriginalStartDate.getMilliseconds()))
                    }
                }.bind(this)
            };
            return AgendaRenderingStrategy
        }(_uiSchedulerAppointmentsStrategy.default);
        var _default = AgendaRenderingStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/ui.scheduler.appointment_model.js ***!
      \*********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _config = _interopRequireDefault(__webpack_require__( /*! ../../core/config */ 31));
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _date_serialization = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date_serialization */ 57));
        var _recurrence = __webpack_require__( /*! ./recurrence */ 139);
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _query = _interopRequireDefault(__webpack_require__( /*! ../../data/query */ 48));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }
        var toMs = _date.default.dateToMilliseconds;
        var DATE_FILTER_POSITION = 0;
        var USER_FILTER_POSITION = 1;
        var FilterMaker = function() {
            function FilterMaker(dataAccessors) {
                this._filterRegistry = null;
                this._dataAccessors = dataAccessors
            }
            var _proto = FilterMaker.prototype;
            _proto.isRegistered = function() {
                return !!this._filterRegistry
            };
            _proto.clearRegistry = function() {
                delete this._filterRegistry
            };
            _proto.make = function(type, args) {
                if (!this._filterRegistry) {
                    this._filterRegistry = {}
                }
                this._make(type).apply(this, args)
            };
            _proto._make = function(type) {
                var _this = this;
                switch (type) {
                    case "date":
                        return function(min, max, useAccessors) {
                            var startDate = useAccessors ? _this._dataAccessors.getter.startDate : _this._dataAccessors.expr.startDateExpr;
                            var endDate = useAccessors ? _this._dataAccessors.getter.endDate : _this._dataAccessors.expr.endDateExpr;
                            var recurrenceRule = _this._dataAccessors.expr.recurrenceRuleExpr;
                            _this._filterRegistry.date = [
                                [
                                    [endDate, ">", min],
                                    [startDate, "<", max]
                                ], "or", [recurrenceRule, "startswith", "freq"], "or", [
                                    [endDate, min],
                                    [startDate, min]
                                ]
                            ];
                            if (!recurrenceRule) {
                                _this._filterRegistry.date.splice(1, 2)
                            }
                        };
                    case "user":
                        return function(userFilter) {
                            _this._filterRegistry.user = userFilter
                        }
                }
            };
            _proto.combine = function() {
                var filter = [];
                this._filterRegistry.date && filter.push(this._filterRegistry.date);
                this._filterRegistry.user && filter.push(this._filterRegistry.user);
                return filter
            };
            _proto.dateFilter = function() {
                return this._filterRegistry.date
            };
            return FilterMaker
        }();
        var compareDateWithStartDayHour = function(startDate, endDate, startDayHour, allDay, severalDays) {
            var startTime = _date.default.dateTimeFromDecimal(startDayHour);
            var result = startDate.getHours() >= startTime.hours && startDate.getMinutes() >= startTime.minutes || endDate.getHours() === startTime.hours && endDate.getMinutes() > startTime.minutes || endDate.getHours() > startTime.hours || severalDays || allDay;
            return result
        };
        var compareDateWithEndDayHour = function(startDate, endDate, startDayHour, endDayHour, allDay, severalDays, max, min) {
            var hiddenInterval = (24 - endDayHour + startDayHour) * toMs("hour");
            var apptDuration = endDate.getTime() - startDate.getTime();
            var delta = (hiddenInterval - apptDuration) / toMs("hour");
            var apptStartHour = startDate.getHours();
            var apptStartMinutes = startDate.getMinutes();
            var result;
            var endTime = _date.default.dateTimeFromDecimal(endDayHour);
            var startTime = _date.default.dateTimeFromDecimal(startDayHour);
            result = apptStartHour < endTime.hours || apptStartHour === endTime.hours && apptStartMinutes < endTime.minutes || allDay && startDate <= max || severalDays && startDate < max && endDate > min && (apptStartHour < endTime.hours || 60 * endDate.getHours() + endDate.getMinutes() > 60 * startTime.hours);
            if (apptDuration < hiddenInterval) {
                if (apptStartHour > endTime.hours && apptStartMinutes > endTime.minutes && delta <= apptStartHour - endDayHour) {
                    result = false
                }
            }
            return result
        };
        var AppointmentModel = function() {
            function AppointmentModel(dataSource, dataAccessors, baseAppointmentDuration) {
                this.setDataAccessors(dataAccessors);
                this.setDataSource(dataSource);
                this._updatedAppointmentKeys = [];
                this._filterMaker = new FilterMaker(dataAccessors);
                this._baseAppointmentDuration = baseAppointmentDuration
            }
            var _proto2 = AppointmentModel.prototype;
            _proto2._createFilter = function(min, max, remoteFiltering, dateSerializationFormat) {
                this._filterMaker.make("date", [min, max]);
                var userFilterPosition = this._excessFiltering() ? this._dataSource.filter()[USER_FILTER_POSITION] : this._dataSource.filter();
                this._filterMaker.make("user", [userFilterPosition]);
                if (remoteFiltering) {
                    this._dataSource.filter(this._combineRemoteFilter(dateSerializationFormat))
                }
            };
            _proto2._excessFiltering = function() {
                var dateFilter = this._filterMaker.dateFilter();
                var dataSourceFilter = this._dataSource.filter();
                return dataSourceFilter && ((0, _common.equalByValue)(dataSourceFilter, dateFilter) || dataSourceFilter.length && (0, _common.equalByValue)(dataSourceFilter[DATE_FILTER_POSITION], dateFilter))
            };
            _proto2._combineFilter = function() {
                return this._filterMaker.combine()
            };
            _proto2._getStoreKey = function(target) {
                var store = this._dataSource.store();
                return store.keyOf(target)
            };
            _proto2._filterAppointmentByResources = function(appointment, resources) {
                var _this2 = this;
                var result = false;
                var i;
                var len;
                var resourceName;
                var checkAppointmentResourceValues = function() {
                    var resourceGetter = _this2._dataAccessors.getter.resources[resourceName];
                    var resource;
                    if ((0, _type.isFunction)(resourceGetter)) {
                        resource = resourceGetter(appointment)
                    }
                    var appointmentResourceValues = (0, _array.wrapToArray)(resource);
                    var resourceData = (0, _iterator.map)(resources[i].items, function(item) {
                        return item.id
                    });
                    for (var j = 0, itemDataCount = appointmentResourceValues.length; j < itemDataCount; j++) {
                        if ((0, _array.inArray)(appointmentResourceValues[j], resourceData) > -1) {
                            return true
                        }
                    }
                    return false
                };
                for (i = 0, len = resources.length; i < len; i++) {
                    resourceName = resources[i].name;
                    result = checkAppointmentResourceValues.call(this);
                    if (!result) {
                        return false
                    }
                }
                return result
            };
            _proto2._filterAppointmentByRRule = function(appointment, min, max, startDayHour, endDayHour, firstDayOfWeek) {
                var recurrenceRule = appointment.recurrenceRule;
                var recurrenceException = appointment.recurrenceException;
                var allDay = appointment.allDay;
                var result = true;
                var appointmentStartDate = appointment.startDate;
                var appointmentEndDate = appointment.endDate;
                var recurrenceProcessor = (0, _recurrence.getRecurrenceProcessor)();
                if (allDay || this._appointmentPartInInterval(appointmentStartDate, appointmentEndDate, startDayHour, endDayHour)) {
                    var trimmedDates = this._trimDates(min, max);
                    min = trimmedDates.min;
                    max = new Date(trimmedDates.max.getTime() - toMs("minute"))
                }
                if (recurrenceRule && !recurrenceProcessor.isValidRecurrenceRule(recurrenceRule)) {
                    result = appointmentEndDate > min && appointmentStartDate <= max
                }
                if (result && recurrenceProcessor.isValidRecurrenceRule(recurrenceRule)) {
                    result = recurrenceProcessor.hasRecurrence({
                        rule: recurrenceRule,
                        exception: recurrenceException,
                        start: appointmentStartDate,
                        end: appointmentEndDate,
                        min: min,
                        max: max,
                        firstDayOfWeek: firstDayOfWeek
                    })
                }
                return result
            };
            _proto2._appointmentPartInInterval = function(startDate, endDate, startDayHour, endDayHour) {
                var apptStartDayHour = startDate.getHours();
                var apptEndDayHour = endDate.getHours();
                return apptStartDayHour <= startDayHour && apptEndDayHour <= endDayHour && apptEndDayHour >= startDayHour || apptEndDayHour >= endDayHour && apptStartDayHour <= endDayHour && apptStartDayHour >= startDayHour
            };
            _proto2._createCombinedFilter = function(filterOptions, timeZoneCalculator) {
                var dataAccessors = this._dataAccessors;
                var min = new Date(filterOptions.min);
                var max = new Date(filterOptions.max);
                var getRecurrenceException = filterOptions.recurrenceException;
                var startDayHour = filterOptions.startDayHour,
                    endDayHour = filterOptions.endDayHour,
                    viewStartDayHour = filterOptions.viewStartDayHour,
                    viewEndDayHour = filterOptions.viewEndDayHour,
                    resources = filterOptions.resources,
                    firstDayOfWeek = filterOptions.firstDayOfWeek;
                var that = this;
                return [
                    [function(appointment) {
                        var result = true;
                        var startDate = new Date(dataAccessors.getter.startDate(appointment));
                        var endDate = new Date(dataAccessors.getter.endDate(appointment));
                        var appointmentTakesAllDay = that.appointmentTakesAllDay(appointment, viewStartDayHour, viewEndDayHour);
                        var appointmentTakesSeveralDays = that.appointmentTakesSeveralDays(appointment);
                        var isAllDay = dataAccessors.getter.allDay(appointment);
                        var appointmentIsLong = appointmentTakesSeveralDays || appointmentTakesAllDay;
                        var useRecurrence = (0, _type.isDefined)(dataAccessors.getter.recurrenceRule);
                        var recurrenceRule;
                        if (useRecurrence) {
                            recurrenceRule = dataAccessors.getter.recurrenceRule(appointment)
                        }
                        if (resources && resources.length) {
                            result = that._filterAppointmentByResources(appointment, resources)
                        }
                        if (appointmentTakesAllDay && false === filterOptions.allDay) {
                            result = false
                        }
                        var startDateTimeZone = dataAccessors.getter.startDateTimeZone(appointment);
                        var endDateTimeZone = dataAccessors.getter.endDateTimeZone(appointment);
                        var comparableStartDate = timeZoneCalculator.createDate(startDate, {
                            appointmentTimeZone: startDateTimeZone,
                            path: "toGrid"
                        });
                        var comparableEndDate = timeZoneCalculator.createDate(endDate, {
                            appointmentTimeZone: endDateTimeZone,
                            path: "toGrid"
                        });
                        if (result && useRecurrence) {
                            var recurrenceException = getRecurrenceException ? getRecurrenceException(appointment) : dataAccessors.getter.recurrenceException(appointment);
                            result = that._filterAppointmentByRRule({
                                startDate: comparableStartDate,
                                endDate: comparableEndDate,
                                recurrenceRule: recurrenceRule,
                                recurrenceException: recurrenceException,
                                allDay: appointmentTakesAllDay
                            }, min, max, startDayHour, endDayHour, firstDayOfWeek)
                        }
                        if (result && comparableEndDate < min && appointmentIsLong && !isAllDay && (!useRecurrence || useRecurrence && !recurrenceRule)) {
                            result = false
                        }
                        if (result && void 0 !== startDayHour && (!useRecurrence || !filterOptions.isVirtualScrolling)) {
                            result = compareDateWithStartDayHour(comparableStartDate, comparableEndDate, startDayHour, appointmentTakesAllDay, appointmentTakesSeveralDays)
                        }
                        if (result && void 0 !== endDayHour) {
                            result = compareDateWithEndDayHour(comparableStartDate, comparableEndDate, startDayHour, endDayHour, appointmentTakesAllDay, appointmentTakesSeveralDays, max, min)
                        }
                        if (result && useRecurrence && !recurrenceRule) {
                            if (comparableEndDate < min && !isAllDay) {
                                result = false
                            }
                        }
                        return result
                    }]
                ]
            };
            _proto2.setDataSource = function(dataSource) {
                this._dataSource = dataSource;
                this.cleanModelState();
                this._initStoreChangeHandlers();
                this._filterMaker && this._filterMaker.clearRegistry()
            };
            _proto2._initStoreChangeHandlers = function() {
                var _this3 = this;
                var dataSource = this._dataSource;
                var store = null === dataSource || void 0 === dataSource ? void 0 : dataSource.store();
                if (store) {
                    store.on("updating", function(newItem) {
                        _this3._updatedAppointment = newItem
                    });
                    store.on("push", function(pushItems) {
                        var items = dataSource.items();
                        var keyName = store.key();
                        pushItems.forEach(function(pushItem) {
                            var itemExists = 0 !== items.filter(function(item) {
                                return item[keyName] === pushItem.key
                            }).length;
                            if (itemExists) {
                                _this3._updatedAppointmentKeys.push({
                                    key: keyName,
                                    value: pushItem.key
                                })
                            } else {
                                var data = pushItem.data;
                                data && items.push(data)
                            }
                        })
                    })
                }
            };
            _proto2.getUpdatedAppointment = function() {
                return this._updatedAppointment
            };
            _proto2.getUpdatedAppointmentKeys = function() {
                return this._updatedAppointmentKeys
            };
            _proto2.cleanModelState = function() {
                this._updatedAppointment = null;
                this._updatedAppointmentKeys = []
            };
            _proto2.setDataAccessors = function(dataAccessors) {
                this._dataAccessors = dataAccessors;
                this._filterMaker = new FilterMaker(dataAccessors)
            };
            _proto2.filterByDate = function(min, max, remoteFiltering, dateSerializationFormat) {
                if (!this._dataSource) {
                    return
                }
                var trimmedDates = this._trimDates(min, max);
                if (!this._filterMaker.isRegistered()) {
                    this._createFilter(trimmedDates.min, trimmedDates.max, remoteFiltering, dateSerializationFormat)
                } else {
                    var _this$_dataSource$fil;
                    this._filterMaker.make("date", [trimmedDates.min, trimmedDates.max]);
                    if ((null === (_this$_dataSource$fil = this._dataSource.filter()) || void 0 === _this$_dataSource$fil ? void 0 : _this$_dataSource$fil.length) > 1) {
                        var userFilter = this._serializeRemoteFilter([this._dataSource.filter()[1]], dateSerializationFormat);
                        this._filterMaker.make("user", userFilter)
                    }
                    if (remoteFiltering) {
                        this._dataSource.filter(this._combineRemoteFilter(dateSerializationFormat))
                    }
                }
            };
            _proto2._combineRemoteFilter = function(dateSerializationFormat) {
                var combinedFilter = this._filterMaker.combine();
                return this._serializeRemoteFilter(combinedFilter, dateSerializationFormat)
            };
            _proto2._serializeRemoteFilter = function(filter, dateSerializationFormat) {
                if (!Array.isArray(filter)) {
                    return filter
                }
                filter = (0, _extend.extend)([], filter);
                var startDate = this._dataAccessors.expr.startDateExpr;
                var endDate = this._dataAccessors.expr.endDateExpr;
                if ((0, _type.isString)(filter[0])) {
                    if ((0, _config.default)().forceIsoDateParsing && filter.length > 1) {
                        if (filter[0] === startDate || filter[0] === endDate) {
                            filter[filter.length - 1] = _date_serialization.default.serializeDate(new Date(filter[filter.length - 1]), dateSerializationFormat)
                        }
                    }
                }
                for (var i = 0; i < filter.length; i++) {
                    filter[i] = this._serializeRemoteFilter(filter[i], dateSerializationFormat)
                }
                return filter
            };
            _proto2._createAppointmentFilter = function(filterOptions, timeZoneCalculator) {
                var combinedFilter = this._createCombinedFilter(filterOptions, timeZoneCalculator);
                if (this._filterMaker.isRegistered()) {
                    this._filterMaker.make("user", void 0);
                    var trimmedDates = this._trimDates(filterOptions.min, filterOptions.max);
                    this._filterMaker.make("date", [trimmedDates.min, trimmedDates.max, true]);
                    var dateFilter = this.customizeDateFilter(this._filterMaker.combine(), timeZoneCalculator);
                    combinedFilter.push([dateFilter])
                }
                return combinedFilter
            };
            _proto2.filterLoadedAppointments = function(filterOption, timeZoneCalculator) {
                var combinedFilter = this._createAppointmentFilter(filterOption, timeZoneCalculator);
                return (0, _query.default)(this.getPreparedDataItems()).filter(combinedFilter).toArray()
            };
            _proto2.getPreparedDataItems = function() {
                var _this4 = this;
                var dataItems = this._dataSource.items();
                return (0, _iterator.map)(dataItems, function(item) {
                    var startDate = new Date(_this4._dataAccessors.getter.startDate(item));
                    var endDate = new Date(_this4._dataAccessors.getter.endDate(item));
                    _this4.replaceWrongEndDate(item, startDate, endDate);
                    return item
                })
            };
            _proto2.replaceWrongEndDate = function(appointment, startDate, endDate) {
                if (this._isEndDateWrong(startDate, endDate)) {
                    var isAllDay = this._dataAccessors.getter.allDay(appointment);
                    var calculatedEndDate = this._calculateAppointmentEndDate(isAllDay, startDate);
                    this._dataAccessors.setter.endDate(appointment, calculatedEndDate)
                }
            };
            _proto2.filterLoadedVirtualAppointments = function(filterOptions, timeZoneCalculator, groupCount) {
                var _this5 = this;
                var combinedFilters = [];
                var itemsToFilter = this.getPreparedDataItems();
                var needPreFilter = groupCount > 0;
                if (needPreFilter) {
                    itemsToFilter = itemsToFilter.filter(function(item) {
                        for (var i = 0; i < filterOptions.length; ++i) {
                            var resources = filterOptions[i].resources;
                            if (_this5._filterAppointmentByResources(item, resources)) {
                                return true
                            }
                        }
                    })
                }
                filterOptions.forEach(function(filterOption) {
                    combinedFilters.length && combinedFilters.push("or");
                    var filter = _this5._createAppointmentFilter(filterOption, timeZoneCalculator);
                    combinedFilters.push(filter)
                });
                return (0, _query.default)(itemsToFilter).filter(combinedFilters).toArray()
            };
            _proto2._trimDates = function(min, max) {
                var minCopy = _date.default.trimTime(new Date(min));
                var maxCopy = _date.default.trimTime(new Date(max));
                maxCopy.setDate(maxCopy.getDate() + 1);
                return {
                    min: minCopy,
                    max: maxCopy
                }
            };
            _proto2.hasAllDayAppointments = function(items, startDayHour, endDayHour) {
                if (!items) {
                    return false
                }
                var that = this;
                var result = false;
                (0, _iterator.each)(items, function(index, item) {
                    if (that.appointmentTakesAllDay(item, startDayHour, endDayHour)) {
                        result = true;
                        return false
                    }
                });
                return result
            };
            _proto2.appointmentTakesAllDay = function(appointment, startDayHour, endDayHour) {
                var dataAccessors = this._dataAccessors;
                var startDate = dataAccessors.getter.startDate(appointment);
                var endDate = dataAccessors.getter.endDate(appointment);
                var allDay = dataAccessors.getter.allDay(appointment);
                return allDay || this._appointmentHasAllDayDuration(startDate, endDate, startDayHour, endDayHour)
            };
            _proto2._appointmentHasAllDayDuration = function(startDate, endDate, startDayHour, endDayHour) {
                startDate = new Date(startDate);
                endDate = new Date(endDate);
                var dayDuration = 24;
                var appointmentDurationInHours = this._getAppointmentDurationInHours(startDate, endDate);
                return appointmentDurationInHours >= dayDuration || this._appointmentHasShortDayDuration(startDate, endDate, startDayHour, endDayHour)
            };
            _proto2._appointmentHasShortDayDuration = function(startDate, endDate, startDayHour, endDayHour) {
                var appointmentDurationInHours = this._getAppointmentDurationInHours(startDate, endDate);
                var shortDayDurationInHours = endDayHour - startDayHour;
                return appointmentDurationInHours >= shortDayDurationInHours && startDate.getHours() === startDayHour && endDate.getHours() === endDayHour
            };
            _proto2._getAppointmentDurationInHours = function(startDate, endDate) {
                return (endDate.getTime() - startDate.getTime()) / toMs("hour")
            };
            _proto2.appointmentTakesSeveralDays = function(appointment) {
                var dataAccessors = this._dataAccessors;
                var startDate = new Date(dataAccessors.getter.startDate(appointment));
                var endDate = new Date(dataAccessors.getter.endDate(appointment));
                return !_date.default.sameDate(startDate, endDate)
            };
            _proto2.customizeDateFilter = function(dateFilter, timeZoneCalculator) {
                var _this6 = this;
                var currentFilter = (0, _extend.extend)(true, [], dateFilter);
                return function(appointment) {
                    var startDate = new Date(_this6._dataAccessors.getter.startDate(appointment));
                    var endDate = new Date(_this6._dataAccessors.getter.endDate(appointment));
                    appointment = (0, _extend.extend)(true, {}, appointment);
                    var startDateTimeZone = _this6._dataAccessors.getter.startDateTimeZone(appointment);
                    var endDateTimeZone = _this6._dataAccessors.getter.endDateTimeZone(appointment);
                    var comparableStartDate = timeZoneCalculator.createDate(startDate, {
                        appointmentTimeZone: startDateTimeZone,
                        path: "toGrid"
                    });
                    var comparableEndDate = timeZoneCalculator.createDate(endDate, {
                        appointmentTimeZone: endDateTimeZone,
                        path: "toGrid"
                    });
                    _this6._dataAccessors.setter.startDate(appointment, comparableStartDate);
                    _this6._dataAccessors.setter.endDate(appointment, comparableEndDate);
                    return (0, _query.default)([appointment]).filter(currentFilter).toArray().length > 0
                }.bind(this)
            };
            _proto2._calculateAppointmentEndDate = function(isAllDay, startDate) {
                if (isAllDay) {
                    return _date.default.setToDayEnd(new Date(startDate))
                }
                return new Date(startDate.getTime() + this._baseAppointmentDuration * toMs("minute"))
            };
            _proto2._isEndDateWrong = function(startDate, endDate) {
                return !endDate || isNaN(endDate.getTime()) || startDate.getTime() > endDate.getTime()
            };
            _proto2.add = function(rawAppointment) {
                var _this7 = this;
                return this._dataSource.store().insert(rawAppointment).done(function() {
                    return _this7._dataSource.load()
                })
            };
            _proto2.update = function(target, data) {
                var _this8 = this;
                var key = this._getStoreKey(target);
                var d = new _deferred.Deferred;
                this._dataSource.store().update(key, data).done(function(result) {
                    return _this8._dataSource.load().done(function() {
                        return d.resolve(result)
                    }).fail(d.reject)
                }).fail(d.reject);
                return d.promise()
            };
            _proto2.remove = function(rawAppointment) {
                var _this9 = this;
                var key = this._getStoreKey(rawAppointment);
                return this._dataSource.store().remove(key).done(function() {
                    return _this9._dataSource.load()
                })
            };
            _createClass(AppointmentModel, [{
                key: "keyName",
                get: function() {
                    var store = this._dataSource.store();
                    return store.key()
                }
            }]);
            return AppointmentModel
        }();
        var _default = AppointmentModel;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/ui.scheduler.header.js ***!
      \**********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _inflector = __webpack_require__( /*! ../../core/utils/inflector */ 39);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _uiScheduler = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.publisher_mixin */ 221));
        var _uiScheduler2 = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.navigator */ 816));
        var _drop_down_menu = _interopRequireDefault(__webpack_require__( /*! ../drop_down_menu */ 214));
        var _tabs = _interopRequireDefault(__webpack_require__( /*! ../tabs */ 215));
        var _constants = __webpack_require__( /*! ../tabs/constants */ 360);
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../../core/errors */ 25));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var COMPONENT_CLASS = "dx-scheduler-header";
        var VIEW_SWITCHER_CLASS = "dx-scheduler-view-switcher";
        var VIEW_SWITCHER_LABEL_CLASS = "dx-scheduler-view-switcher-label";
        var STEP_MAP = {
            day: "day",
            week: "week",
            workWeek: "workWeek",
            month: "month",
            timelineDay: "day",
            timelineWeek: "week",
            timelineWorkWeek: "workWeek",
            timelineMonth: "month",
            agenda: "agenda"
        };
        var VIEWS = ["day", "week", "workWeek", "month", "timelineDay", "timelineWeek", "timelineWorkWeek", "timelineMonth", "agenda"];
        var SchedulerHeader = _ui.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    views: [],
                    isAdaptive: false,
                    intervalCount: 1,
                    currentView: "day",
                    firstDayOfWeek: void 0,
                    currentDate: new Date,
                    min: void 0,
                    max: void 0,
                    useDropDownViewSwitcher: false,
                    _dropDownButtonIcon: "overlay"
                })
            },
            _setOptionsByReference: function() {
                this.callBase();
                (0, _extend.extend)(this._optionsByReference, {
                    currentView: true
                })
            },
            _optionChanged: function(args) {
                var value = args.value;
                switch (args.name) {
                    case "views":
                        this._validateViews();
                        this._viewSwitcher.option({
                            items: value,
                            selectedItem: this.option("currentView")
                        });
                        break;
                    case "customizeDateNavigatorText":
                        this._navigator.option(args.name, value);
                        break;
                    case "currentView":
                        this._viewSwitcher.option("selectedItem", value);
                        this._navigator.option("step", STEP_MAP[this._getCurrentViewType()]);
                        this._changeViewSwitcherLabelText();
                        break;
                    case "currentDate":
                        this._navigator.option("date", value);
                        break;
                    case "displayedDate":
                        this._navigator.option("displayedDate", value);
                        break;
                    case "min":
                    case "max":
                    case "firstDayOfWeek":
                    case "intervalCount":
                        this._navigator.option(args.name, value);
                        break;
                    case "tabIndex":
                    case "focusStateEnabled":
                        this._viewSwitcher.option(args.name, value);
                        this._navigator.option(args.name, value);
                        this.callBase(args);
                        break;
                    case "useDropDownViewSwitcher":
                        this._refreshViewSwitcher();
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _init: function() {
                this.callBase();
                this.$element().addClass(COMPONENT_CLASS)
            },
            _initMarkup: function() {
                this.callBase();
                this._renderNavigator();
                this._renderViewSwitcher()
            },
            _renderNavigator: function() {
                this._navigator = this._createComponent("<div>", _uiScheduler2.default, {
                    min: this.option("min"),
                    max: this.option("max"),
                    intervalCount: this.option("intervalCount"),
                    date: this.option("currentDate"),
                    step: STEP_MAP[this._getCurrentViewType()],
                    firstDayOfWeek: this.option("firstDayOfWeek"),
                    tabIndex: this.option("tabIndex"),
                    focusStateEnabled: this.option("focusStateEnabled"),
                    observer: this.option("observer"),
                    customizeDateNavigatorText: this.option("customizeDateNavigatorText"),
                    todayDate: this.option("todayDate")
                });
                this._navigator.$element().appendTo(this.$element())
            },
            _renderViewSwitcher: function() {
                this._validateViews();
                var $viewSwitcher = (0, _renderer.default)("<div>").addClass(VIEW_SWITCHER_CLASS).appendTo(this.$element());
                this.option("useDropDownViewSwitcher") ? this._renderViewSwitcherDropDownMenu($viewSwitcher) : this._renderViewSwitcherTabs($viewSwitcher)
            },
            _validateViews: function() {
                var views = this.option("views");
                (0, _iterator.each)(views, function(_, view) {
                    var isViewIsObject = (0, _type.isObject)(view);
                    var viewType = isViewIsObject && view.type ? view.type : view;
                    if ((0, _array.inArray)(viewType, VIEWS) === -1) {
                        _errors.default.log("W0008", viewType)
                    }
                })
            },
            _getCurrentViewType: function() {
                var currentView = this.option("currentView");
                return currentView.type || currentView
            },
            _renderViewSwitcherTabs: function($element) {
                var that = this;
                $element.addClass(_constants.TABS_EXPANDED_CLASS);
                this._viewSwitcher = this._createComponent($element, _tabs.default, {
                    selectionRequired: true,
                    scrollingEnabled: true,
                    onSelectionChanged: this._updateCurrentView.bind(this),
                    items: this.option("views"),
                    itemTemplate: function(item) {
                        return (0, _renderer.default)("<span>").addClass("dx-tab-text").text(that._getItemText(item))
                    },
                    selectedItem: this.option("currentView"),
                    tabIndex: this.option("tabIndex"),
                    focusStateEnabled: this.option("focusStateEnabled")
                })
            },
            _getItemText: function(item) {
                return item.name || _message.default.format("dxScheduler-switcher" + (0, _inflector.camelize)(item.type || item, true))
            },
            _refreshViewSwitcher: function() {
                this._viewSwitcher._dispose();
                this._viewSwitcher.$element().remove();
                delete this._viewSwitcher;
                this._removeViewSwitcherLabel();
                this._renderViewSwitcher()
            },
            _removeViewSwitcherLabel: function() {
                if ((0, _type.isDefined)(this._$viewSwitcherLabel)) {
                    this._$viewSwitcherLabel.detach();
                    this._$viewSwitcherLabel.remove();
                    delete this._$viewSwitcherLabel
                }
            },
            _renderViewSwitcherDropDownMenu: function($element) {
                var that = this;
                this._$viewSwitcherLabel = (0, _renderer.default)("<div>").addClass(VIEW_SWITCHER_LABEL_CLASS).appendTo(this.$element());
                this._changeViewSwitcherLabelText();
                this._viewSwitcher = this._createComponent($element, _drop_down_menu.default, {
                    onItemClick: this._updateCurrentView.bind(this),
                    buttonIcon: this.option("_dropDownButtonIcon"),
                    items: this.option("views"),
                    selectionMode: this.option("isAdaptive") ? "single" : "none",
                    selectedItemKeys: [this.option("currentView")],
                    itemTemplate: function(item) {
                        return (0, _renderer.default)("<span>").addClass("dx-dropdownmenu-item-text").text(that._getItemText(item))
                    }
                })
            },
            _changeViewSwitcherLabelText: function() {
                if (!(0, _type.isDefined)(this._$viewSwitcherLabel)) {
                    return
                }
                var currentView = this.option("currentView");
                var currentViewText = this._getItemText(currentView);
                this._$viewSwitcherLabel.text(currentViewText)
            },
            _getCurrentViewName: function(currentView) {
                return (0, _type.isObject)(currentView) ? currentView.name || currentView.type : currentView
            },
            _updateCurrentView: function(e) {
                var selectedItem = e.itemData || e.component.option("selectedItem");
                var viewName = this._getCurrentViewName(selectedItem);
                this.notifyObserver("currentViewUpdated", viewName)
            },
            _renderFocusTarget: _common.noop
        }).include(_uiScheduler.default);
        (0, _component_registrator.default)("dxSchedulerHeader", SchedulerHeader);
        var _default = SchedulerHeader;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/ui.scheduler.navigator.js ***!
      \*************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _devices = _interopRequireDefault(__webpack_require__( /*! ../../core/devices */ 13));
        var _ui2 = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _button = _interopRequireDefault(__webpack_require__( /*! ../button */ 37));
        var _calendar = _interopRequireDefault(__webpack_require__( /*! ../calendar */ 277));
        var _popover = _interopRequireDefault(__webpack_require__( /*! ../popover */ 135));
        var _popup = _interopRequireDefault(__webpack_require__( /*! ../popup */ 46));
        var _uiScheduler = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.publisher_mixin */ 221));
        var _date2 = _interopRequireDefault(__webpack_require__( /*! ../../localization/date */ 32));
        var _ui3 = _interopRequireDefault(__webpack_require__( /*! ../scroll_view/ui.scrollable */ 106));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ELEMENT_CLASS = "dx-scheduler-navigator";
        var CALENDAR_CLASS = "dx-scheduler-navigator-calendar";
        var NEXT_BUTTON_CLASS = "dx-scheduler-navigator-next";
        var CAPTION_BUTTON_CLASS = "dx-scheduler-navigator-caption";
        var PREVIOUS_BUTTON_CLASS = "dx-scheduler-navigator-previous";
        var CALENDAR_POPOVER_CLASS = "dx-scheduler-navigator-calendar-popover";
        var MONDAY_INDEX = 1;
        var getDefaultFirstDayOfWeekIndex = function(shift) {
            return shift ? MONDAY_INDEX : _date2.default.firstDayOfWeekIndex()
        };
        var getDateMonthFormat = function(short) {
            return function(date) {
                var monthName = _date2.default.getMonthNames(short ? "abbreviated" : "wide")[date.getMonth()];
                return [_date2.default.format(date, "day"), monthName].join(" ")
            }
        };
        var getMonthYearFormat = function(date) {
            return _date2.default.getMonthNames("abbreviated")[date.getMonth()] + " " + _date2.default.format(date, "year")
        };
        var getCaptionFormat = function getCaptionFormat(short, intervalCount, duration) {
            var dateMonthFormat = getDateMonthFormat(short);
            return function(date) {
                if (intervalCount > 1) {
                    var lastIntervalDate = new Date(date);
                    var defaultViewDuration = duration;
                    lastIntervalDate.setDate(date.getDate() + defaultViewDuration - 1);
                    var isDifferentMonthDates = date.getMonth() !== lastIntervalDate.getMonth();
                    var useShortFormat = isDifferentMonthDates || short;
                    var firstWeekDateText = _date2.default.format(date, isDifferentMonthDates ? getDateMonthFormat(useShortFormat) : "d");
                    var lastWeekDateText = _date2.default.format(lastIntervalDate, getCaptionFormat(useShortFormat));
                    return firstWeekDateText + "-" + lastWeekDateText
                }
                return [dateMonthFormat(date), _date2.default.format(date, "year")].join(" ")
            }
        };
        var getWeekCaption = function(date, shift, rejectWeekend) {
            var firstDayOfWeek = this.option("firstDayOfWeek");
            var firstDayOfWeekIndex = (0, _type.isDefined)(firstDayOfWeek) ? firstDayOfWeek : getDefaultFirstDayOfWeekIndex(shift);
            if (0 === firstDayOfWeekIndex && rejectWeekend) {
                firstDayOfWeekIndex = MONDAY_INDEX
            }
            var firstWeekDate = _date.default.getFirstWeekDate(date, firstDayOfWeekIndex);
            var weekendDuration = 2;
            if (rejectWeekend) {
                firstWeekDate = _date.default.normalizeDateByWeek(firstWeekDate, date)
            }
            if (firstDayOfWeek >= 6 && rejectWeekend) {
                firstWeekDate.setDate(firstWeekDate.getDate() + (7 - firstDayOfWeek + 1))
            }
            var lastWeekDate = new Date(firstWeekDate);
            var intervalCount = this.option("intervalCount");
            shift = shift || 6;
            lastWeekDate = new Date(lastWeekDate.setDate(lastWeekDate.getDate() + (intervalCount > 1 ? 7 * (intervalCount - 1) + shift : shift)));
            if (lastWeekDate.getDay() % 6 === 0 && rejectWeekend) {
                lastWeekDate.setDate(lastWeekDate.getDate() + weekendDuration)
            }
            return {
                text: formatCaptionByMonths.call(this, lastWeekDate, firstWeekDate),
                startDate: firstWeekDate,
                endDate: lastWeekDate
            }
        };
        var formatCaptionByMonths = function(lastDate, firstDate) {
            var isDifferentMonthDates = firstDate.getMonth() !== lastDate.getMonth();
            var isDifferentYears = firstDate.getFullYear() !== lastDate.getFullYear();
            var useShortFormat = isDifferentMonthDates || this.option("_useShortDateFormat");
            var lastDateText;
            var firstDateText;
            if (isDifferentYears) {
                firstDateText = _date2.default.format(firstDate, getCaptionFormat(true));
                lastDateText = _date2.default.format(lastDate, getCaptionFormat(true))
            } else {
                firstDateText = _date2.default.format(firstDate, isDifferentMonthDates ? getDateMonthFormat(useShortFormat) : "d");
                lastDateText = _date2.default.format(lastDate, getCaptionFormat(useShortFormat))
            }
            return firstDateText + "-" + lastDateText
        };
        var getMonthCaption = function(date) {
            var firstDate = new Date(_date.default.getFirstMonthDate(date));
            var lastDate = new Date(_date.default.getLastMonthDate(firstDate));
            var text;
            if (this.option("intervalCount") > 1) {
                lastDate = new Date(firstDate);
                lastDate.setMonth(firstDate.getMonth() + this.option("intervalCount") - 1);
                lastDate = new Date(_date.default.getLastMonthDate(lastDate));
                var isSameYear = firstDate.getYear() === lastDate.getYear();
                var lastDateText = getMonthYearFormat(lastDate);
                var firstDateText = isSameYear ? _date2.default.getMonthNames("abbreviated")[firstDate.getMonth()] : getMonthYearFormat(firstDate);
                text = firstDateText + "-" + lastDateText
            } else {
                text = _date2.default.format(date, "monthandyear")
            }
            return {
                text: text,
                startDate: firstDate,
                endDate: lastDate
            }
        };
        var dateGetter = function(date, offset) {
            return new Date(date[this.setter](date[this.getter]() + offset))
        };
        var getConfig = function(step) {
            var agendaDuration;
            switch (step) {
                case "day":
                    return {
                        duration: 1 * this.option("intervalCount"), setter: "setDate", getter: "getDate", getDate: dateGetter, getCaption: function(date) {
                            var format = getCaptionFormat(false, this.option("intervalCount"), this._getConfig().duration);
                            return {
                                text: _date2.default.format(date, format),
                                startDate: date,
                                endDate: date
                            }
                        }
                    };
                case "week":
                    return {
                        duration: 7 * this.option("intervalCount"), setter: "setDate", getter: "getDate", getDate: dateGetter, getCaption: getWeekCaption
                    };
                case "workWeek":
                    return {
                        duration: 7 * this.option("intervalCount"), setter: "setDate", getter: "getDate", getDate: dateGetter, getCaption: function(date) {
                            return getWeekCaption.call(this, date, 4, true)
                        }
                    };
                case "month":
                    return {
                        duration: 1 * this.option("intervalCount"), setter: "setMonth", getter: "getMonth", getDate: function(date, offset) {
                            var currentDate = date.getDate();
                            date.setDate(1);
                            date = dateGetter.call(this, date, offset);
                            var lastDate = _date.default.getLastMonthDay(date);
                            date.setDate(currentDate < lastDate ? currentDate : lastDate);
                            return date
                        }, getCaption: getMonthCaption
                    };
                case "agenda":
                    agendaDuration = this.invoke("getAgendaDuration");
                    agendaDuration = (0, _type.isNumeric)(agendaDuration) && agendaDuration > 0 ? agendaDuration : 7;
                    return {
                        duration: agendaDuration, setter: "setDate", getter: "getDate", getDate: dateGetter, getCaption: function(date) {
                            var format = getCaptionFormat(this.option("_useShortDateFormat"));
                            var firstDate = new Date(date);
                            var lastDate = new Date(date);
                            var text;
                            if (agendaDuration > 1) {
                                lastDate.setDate(lastDate.getDate() + agendaDuration - 1);
                                text = formatCaptionByMonths.call(this, lastDate, date)
                            } else {
                                text = _date2.default.format(date, format)
                            }
                            return {
                                text: text,
                                startDate: firstDate,
                                endDate: lastDate
                            }
                        }
                    }
            }
        };
        var SchedulerNavigator = _ui2.default.inherit({
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    date: new Date,
                    displayedDate: void 0,
                    step: "day",
                    intervalCount: 1,
                    min: void 0,
                    max: void 0,
                    firstDayOfWeek: void 0,
                    _useShortDateFormat: false,
                    todayDate: function() {
                        return new Date
                    }
                })
            },
            _defaultOptionsRules: function() {
                return this.callBase().concat([{
                    device: function() {
                        return !_devices.default.real().generic || _devices.default.isSimulator()
                    },
                    options: {
                        _useShortDateFormat: true
                    }
                }])
            },
            _optionChanged: function(args) {
                switch (args.name) {
                    case "step":
                    case "date":
                    case "intervalCount":
                    case "displayedDate":
                        this._updateButtonsState();
                        this._renderCaption();
                        this._setCalendarOption("value", this.option("date"));
                        break;
                    case "min":
                    case "max":
                        this._updateButtonsState();
                        this._setCalendarOption(args.name, args.value);
                        break;
                    case "firstDayOfWeek":
                        this._setCalendarOption(args.name, args.value);
                        break;
                    case "customizeDateNavigatorText":
                        this._renderCaption();
                        break;
                    case "tabIndex":
                    case "focusStateEnabled":
                        this._next.option(args.name, args.value);
                        this._caption.option(args.name, args.value);
                        this._prev.option(args.name, args.value);
                        this._setCalendarOption(args.name, args.value);
                        this.callBase(args);
                        break;
                    case "_useShortDateFormat":
                        break;
                    default:
                        this.callBase(args)
                }
            },
            _init: function() {
                this.callBase();
                this.$element().addClass(ELEMENT_CLASS);
                this._initButtons()
            },
            _initButtons: function() {
                var $next = (0, _renderer.default)("<div>").addClass(NEXT_BUTTON_CLASS);
                this._next = this._createComponent($next, _button.default, {
                    icon: "chevronnext",
                    onClick: this._updateCurrentDate.bind(this, 1),
                    focusStateEnabled: this.option("focusStateEnabled"),
                    tabIndex: this.option("tabIndex"),
                    integrationOptions: {}
                });
                var $caption = (0, _renderer.default)("<div>").addClass(CAPTION_BUTTON_CLASS);
                this._caption = this._createComponent($caption, _button.default, {
                    focusStateEnabled: this.option("focusStateEnabled"),
                    tabIndex: this.option("tabIndex"),
                    integrationOptions: {}
                });
                var $prev = (0, _renderer.default)("<div>").addClass(PREVIOUS_BUTTON_CLASS);
                this._prev = this._createComponent($prev, _button.default, {
                    icon: "chevronprev",
                    onClick: this._updateCurrentDate.bind(this, -1),
                    focusStateEnabled: this.option("focusStateEnabled"),
                    tabIndex: this.option("tabIndex"),
                    integrationOptions: {}
                });
                this.setAria("label", "Next period", $next);
                this.setAria("label", "Previous period", $prev);
                this._updateButtonsState();
                this.$element().append($prev, $caption, $next)
            },
            _updateButtonsState: function() {
                var min = this.option("min");
                var max = this.option("max");
                var caption = this._getConfig().getCaption.call(this, this.option("displayedDate") || this.option("date"));
                min = min ? _date.default.trimTime(min) : min;
                max = max ? _date.default.trimTime(max) : max;
                max && max.setHours(23, 59, 59);
                this._prev.option("disabled", min && !isNaN(min.getTime()) && this._getNextDate(-1, caption.endDate) < min);
                this._next.option("disabled", max && !isNaN(max.getTime()) && this._getNextDate(1, caption.startDate) > max)
            },
            _updateCurrentDate: function(direction) {
                var date = this._getNextDate(direction);
                _date.default.normalizeDate(date, this.option("min"), this.option("max"));
                this.notifyObserver("currentDateUpdated", date)
            },
            _getNextDate: function(direction) {
                var initialDate = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                var stepConfig = this._getConfig();
                var offset = stepConfig.duration * direction;
                var date = stepConfig.getDate(new Date(initialDate || this.option("date")), offset);
                return date
            },
            _renderFocusTarget: _common.noop,
            _initMarkup: function() {
                this.callBase();
                this._renderCaption()
            },
            _render: function() {
                this.callBase();
                this._renderPopover();
                this._renderCaptionKeys()
            },
            _isMobileLayout: function() {
                return !_devices.default.current().generic
            },
            _renderPopover: function() {
                var _this = this;
                var overlayType = this._isMobileLayout() ? _popup.default : _popover.default;
                var popoverContainer = (0, _renderer.default)("<div>").addClass(CALENDAR_POPOVER_CLASS);
                this._popover = this._createComponent(popoverContainer, overlayType, {
                    contentTemplate: function() {
                        return _this._createPopupContent()
                    },
                    defaultOptionsRules: [{
                        device: function() {
                            return !_devices.default.current().generic
                        },
                        options: {
                            fullScreen: true,
                            showCloseButton: false,
                            toolbarItems: [{
                                shortcut: "cancel"
                            }]
                        }
                    }, {
                        device: function() {
                            return _devices.default.current().generic
                        },
                        options: {
                            target: this._caption.$element()
                        }
                    }]
                });
                this._popover.$element().appendTo(this.$element())
            },
            _createScrollable: function(content) {
                var result = this._createComponent((0, _renderer.default)("<div>"), _ui3.default, {
                    direction: "vertical"
                });
                result.$content().append(content);
                return result
            },
            _createPopupContent: function() {
                var result = (0, _renderer.default)("<div>").addClass(CALENDAR_CLASS);
                this._calendar = this._createComponent(result, _calendar.default, this._calendarOptions());
                if (this._isMobileLayout()) {
                    var scrollable = this._createScrollable(result);
                    return scrollable.$element()
                }
                return result
            },
            _calendarOptions: function() {
                return {
                    min: this.option("min"),
                    max: this.option("max"),
                    firstDayOfWeek: this.option("firstDayOfWeek"),
                    value: this.option("date"),
                    _todayDate: this.option("todayDate"),
                    focusStateEnabled: this.option("focusStateEnabled"),
                    onValueChanged: function(e) {
                        if (!this.option("visible")) {
                            return
                        }
                        this.notifyObserver("currentDateUpdated", e.value);
                        this._popover.hide()
                    }.bind(this),
                    hasFocus: function() {
                        return true
                    },
                    tabIndex: null
                }
            },
            _renderCaption: function() {
                var _this2 = this;
                var date = this.option("displayedDate") || this.option("date");
                var captionConfig = this._getConfig().getCaption.call(this, date);
                var customizationFunction = this.option("customizeDateNavigatorText");
                var caption = (0, _type.isFunction)(customizationFunction) ? customizationFunction(captionConfig) : captionConfig.text;
                this._caption.option({
                    text: caption,
                    onKeyboardHandled: function(opts) {
                        _this2.option("focusStateEnabled") && !_this2.option("disabled") && _this2._calendar._keyboardHandler(opts)
                    },
                    onClick: function() {
                        return _this2._popover.toggle()
                    }
                })
            },
            _renderCaptionKeys: function() {
                if (!this.option("focusStateEnabled") || this.option("disabled")) {
                    return
                }
                var that = this;
                var executeHandler = function() {
                    if (that._popover.$content().is(":hidden")) {
                        that._popover.show()
                    } else {
                        return true
                    }
                };
                var tabHandler = function() {
                    that._popover.hide()
                };
                this._caption.registerKeyHandler("enter", executeHandler);
                this._caption.registerKeyHandler("space", executeHandler);
                this._caption.registerKeyHandler("tab", tabHandler)
            },
            _setCalendarOption: function(name, value) {
                if (this._calendar) {
                    this._calendar.option(name, value)
                }
            },
            _getConfig: function() {
                var step = this.option("step");
                var config = getConfig.call(this, step);
                if (!config) {
                    throw _ui.default.Error("E1033", step)
                }
                return config
            }
        }).include(_uiScheduler.default);
        (0, _component_registrator.default)("dxSchedulerNavigator", SchedulerNavigator);
        var _default = SchedulerNavigator;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/ui.scheduler.resource_manager.js ***!
      \********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _object = __webpack_require__( /*! ../../core/utils/object */ 51);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _query = _interopRequireDefault(__webpack_require__( /*! ../../data/query */ 48));
        var _data = __webpack_require__( /*! ../../core/utils/data */ 20);
        var _data_source = __webpack_require__( /*! ../../data/data_source/data_source */ 68);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _utils = __webpack_require__( /*! ../../data/data_source/utils */ 69);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var getValueExpr = function(resource) {
            return resource.valueExpr || "id"
        };
        var getDisplayExpr = function(resource) {
            return resource.displayExpr || "text"
        };
        var ResourceManager = function() {
            function ResourceManager(resources) {
                this._resourceLoader = {};
                this.setResources(resources)
            }
            var _proto = ResourceManager.prototype;
            _proto._createWrappedDataSource = function(dataSource) {
                if (dataSource instanceof _data_source.DataSource) {
                    return dataSource
                }
                var result = {
                    store: (0, _utils.normalizeDataSourceOptions)(dataSource).store,
                    pageSize: 0
                };
                if (!Array.isArray(dataSource)) {
                    result.filter = dataSource.filter
                }
                return new _data_source.DataSource(result)
            };
            _proto._mapResourceData = function(resource, data) {
                var valueGetter = (0, _data.compileGetter)(getValueExpr(resource));
                var displayGetter = (0, _data.compileGetter)(getDisplayExpr(resource));
                return (0, _iterator.map)(data, function(item) {
                    var result = {
                        id: valueGetter(item),
                        text: displayGetter(item)
                    };
                    if (item.color) {
                        result.color = item.color
                    }
                    return result
                })
            };
            _proto._isMultipleResource = function(resourceField) {
                var result = false;
                (0, _iterator.each)(this.getResources(), function(_, resource) {
                    var field = this.getField(resource);
                    if (field === resourceField) {
                        result = resource.allowMultiple;
                        return false
                    }
                }.bind(this));
                return result
            };
            _proto.getDataAccessors = function(field, type) {
                var result = null;
                (0, _iterator.each)(this._dataAccessors[type], function(accessorName, accessors) {
                    if (field === accessorName) {
                        result = accessors;
                        return false
                    }
                });
                return result
            };
            _proto.getField = function(resource) {
                return resource.fieldExpr || resource.field
            };
            _proto.setResources = function(resources) {
                this._resources = resources;
                this._dataAccessors = {
                    getter: {},
                    setter: {}
                };
                this._resourceFields = (0, _iterator.map)(resources || [], function(resource) {
                    var field = this.getField(resource);
                    this._dataAccessors.getter[field] = (0, _data.compileGetter)(field);
                    this._dataAccessors.setter[field] = (0, _data.compileSetter)(field);
                    return field
                }.bind(this))
            };
            _proto.getResources = function() {
                return this._resources || []
            };
            _proto.getResourcesData = function() {
                return this._resourcesData || []
            };
            _proto.getEditors = function() {
                var result = [];
                var that = this;
                (0, _iterator.each)(this.getResources(), function(i, resource) {
                    var field = that.getField(resource);
                    var currentResourceItems = that._getResourceDataByField(field);
                    result.push({
                        editorOptions: {
                            dataSource: currentResourceItems.length ? currentResourceItems : that._createWrappedDataSource(resource.dataSource),
                            displayExpr: getDisplayExpr(resource),
                            valueExpr: getValueExpr(resource)
                        },
                        dataField: field,
                        editorType: resource.allowMultiple ? "dxTagBox" : "dxSelectBox",
                        label: {
                            text: resource.label || field
                        }
                    })
                });
                return result
            };
            _proto.getResourceDataByValue = function(field, value) {
                var that = this;
                var result = new _deferred.Deferred;
                (0, _iterator.each)(this.getResources(), function(_, resource) {
                    var resourceField = that.getField(resource);
                    if (resourceField === field) {
                        var dataSource = that._createWrappedDataSource(resource.dataSource);
                        var valueExpr = getValueExpr(resource);
                        if (!that._resourceLoader[field]) {
                            that._resourceLoader[field] = dataSource.load()
                        }
                        that._resourceLoader[field].done(function(data) {
                            var filteredData = (0, _query.default)(data).filter(valueExpr, value).toArray();
                            delete that._resourceLoader[field];
                            result.resolve(filteredData[0])
                        }).fail(function() {
                            delete that._resourceLoader[field];
                            result.reject()
                        });
                        return false
                    }
                });
                return result.promise()
            };
            _proto.setResourcesToItem = function(itemData, resources) {
                var resourcesSetter = this._dataAccessors.setter;
                for (var name in resources) {
                    if (Object.prototype.hasOwnProperty.call(resources, name)) {
                        var resourceData = resources[name];
                        resourcesSetter[name](itemData, this._isMultipleResource(name) ? (0, _array.wrapToArray)(resourceData) : resourceData)
                    }
                }
            };
            _proto.getResourcesFromItem = function(itemData, wrapOnlyMultipleResources) {
                var _this = this;
                var result = null;
                if (!(0, _type.isDefined)(wrapOnlyMultipleResources)) {
                    wrapOnlyMultipleResources = false
                }
                this._resourceFields.forEach(function(field) {
                    (0, _iterator.each)(itemData, function(fieldName, fieldValue) {
                        var tempObject = {};
                        tempObject[fieldName] = fieldValue;
                        var resourceData = _this.getDataAccessors(field, "getter")(tempObject);
                        if ((0, _type.isDefined)(resourceData)) {
                            if (!result) {
                                result = {}
                            }
                            if (1 === resourceData.length) {
                                resourceData = resourceData[0]
                            }
                            if (!wrapOnlyMultipleResources || wrapOnlyMultipleResources && _this._isMultipleResource(field)) {
                                _this.getDataAccessors(field, "setter")(tempObject, (0, _array.wrapToArray)(resourceData))
                            } else {
                                _this.getDataAccessors(field, "setter")(tempObject, resourceData)
                            }(0, _extend.extend)(result, tempObject);
                            return true
                        }
                    })
                });
                return result
            };
            _proto.loadResources = function(groups) {
                var result = new _deferred.Deferred;
                var that = this;
                var deferreds = [];
                (0, _iterator.each)(this.getResourcesByFields(groups), function(i, resource) {
                    var deferred = new _deferred.Deferred;
                    var field = that.getField(resource);
                    deferreds.push(deferred);
                    that._createWrappedDataSource(resource.dataSource).load().done(function(data) {
                        deferred.resolve({
                            name: field,
                            items: that._mapResourceData(resource, data),
                            data: data
                        })
                    }).fail(function() {
                        deferred.reject()
                    })
                });
                if (!deferreds.length) {
                    that._resourcesData = [];
                    return result.resolve([])
                }
                _deferred.when.apply(null, deferreds).done(function() {
                    var data = Array.prototype.slice.call(arguments);
                    var mapFunction = function(obj) {
                        return {
                            name: obj.name,
                            items: obj.items,
                            data: obj.data
                        }
                    };
                    that._resourcesData = data;
                    result.resolve(data.map(mapFunction))
                }).fail(function() {
                    result.reject()
                });
                return result.promise()
            };
            _proto.getResourcesByFields = function(fields) {
                return (0, _common.grep)(this.getResources(), function(resource) {
                    var field = this.getField(resource);
                    return (0, _array.inArray)(field, fields) > -1
                }.bind(this))
            };
            _proto.getResourceByField = function(field) {
                return this.getResourcesByFields([field])[0] || {}
            };
            _proto.getResourceColor = function(field, value) {
                var valueExpr = this.getResourceByField(field).valueExpr || "id";
                var valueGetter = (0, _data.compileGetter)(valueExpr);
                var colorExpr = this.getResourceByField(field).colorExpr || "color";
                var colorGetter = (0, _data.compileGetter)(colorExpr);
                var result = new _deferred.Deferred;
                var resourceData = this._getResourceDataByField(field);
                var resourceDataLength = resourceData.length;
                var color;
                if (resourceDataLength) {
                    for (var i = 0; i < resourceDataLength; i++) {
                        if (valueGetter(resourceData[i]) === value) {
                            color = colorGetter(resourceData[i]);
                            break
                        }
                    }
                    result.resolve(color)
                } else {
                    this.getResourceDataByValue(field, value).done(function(resourceData) {
                        if (resourceData) {
                            color = colorGetter(resourceData)
                        }
                        result.resolve(color)
                    }).fail(function() {
                        result.reject()
                    })
                }
                return result.promise()
            };
            _proto.getResourceForPainting = function(groups) {
                var resources = this.getResources();
                var result;
                (0, _iterator.each)(resources, function(index, resource) {
                    if (resource.useColorAsDefault) {
                        result = resource;
                        return false
                    }
                });
                if (!result) {
                    if (Array.isArray(groups) && groups.length) {
                        resources = this.getResourcesByFields(groups)
                    }
                    result = resources[resources.length - 1]
                }
                return result
            };
            _proto.createResourcesTree = function(groups) {
                var leafIndex = 0;
                var groupIndex = groupIndex || 0;

                function make(group, groupIndex, result, parent) {
                    result = result || [];
                    for (var i = 0; i < group.items.length; i++) {
                        var currentGroupItem = group.items[i];
                        var resultItem = {
                            name: group.name,
                            value: currentGroupItem.id,
                            title: currentGroupItem.text,
                            data: group.data && group.data[i],
                            children: [],
                            parent: parent ? parent : null
                        };
                        result.push(resultItem);
                        var nextGroupIndex = groupIndex + 1;
                        if (groups[nextGroupIndex]) {
                            make.call(this, groups[nextGroupIndex], nextGroupIndex, resultItem.children, resultItem)
                        }
                        if (!resultItem.children.length) {
                            resultItem.leafIndex = leafIndex;
                            leafIndex++
                        }
                    }
                    return result
                }
                return make.call(this, groups[0], 0)
            };
            _proto._hasGroupItem = function(appointmentResources, groupName, itemValue) {
                var group = this.getDataAccessors(groupName, "getter")(appointmentResources);
                if (group) {
                    if ((0, _array.inArray)(itemValue, group) > -1) {
                        return true
                    }
                }
                return false
            };
            _proto._getResourceDataByField = function(fieldName) {
                var loadedResources = this.getResourcesData();
                var currentResourceData = [];
                for (var i = 0, resourceCount = loadedResources.length; i < resourceCount; i++) {
                    if (loadedResources[i].name === fieldName) {
                        currentResourceData = loadedResources[i].data;
                        break
                    }
                }
                return currentResourceData
            };
            _proto.getResourceTreeLeaves = function(tree, appointmentResources, result) {
                result = result || [];
                for (var i = 0; i < tree.length; i++) {
                    if (!this._hasGroupItem(appointmentResources, tree[i].name, tree[i].value)) {
                        continue
                    }
                    if ((0, _type.isDefined)(tree[i].leafIndex)) {
                        result.push(tree[i].leafIndex)
                    }
                    if (tree[i].children) {
                        this.getResourceTreeLeaves(tree[i].children, appointmentResources, result)
                    }
                }
                return result
            };
            _proto.groupAppointmentsByResources = function(appointments, resources) {
                var tree = this.createResourcesTree(resources);
                var result = {};
                (0, _iterator.each)(appointments, function(_, appointment) {
                    var appointmentResources = this.getResourcesFromItem(appointment);
                    var treeLeaves = this.getResourceTreeLeaves(tree, appointmentResources);
                    for (var i = 0; i < treeLeaves.length; i++) {
                        if (!result[treeLeaves[i]]) {
                            result[treeLeaves[i]] = []
                        }
                        result[treeLeaves[i]].push((0, _object.deepExtendArraySafe)({}, appointment, true))
                    }
                }.bind(this));
                return result
            };
            _proto.reduceResourcesTree = function(tree, existingAppointments, _result) {
                _result = _result ? _result.children : [];
                var that = this;
                tree.forEach(function(node, index) {
                    var ok = false;
                    var resourceName = node.name;
                    var resourceValue = node.value;
                    var resourceTitle = node.title;
                    var resourceData = node.data;
                    var resourceGetter = that.getDataAccessors(resourceName, "getter");
                    existingAppointments.forEach(function(appointment) {
                        if (!ok) {
                            var resourceFromAppointment = resourceGetter(appointment);
                            if (Array.isArray(resourceFromAppointment)) {
                                if (resourceFromAppointment.indexOf(resourceValue) > -1) {
                                    _result.push({
                                        name: resourceName,
                                        value: resourceValue,
                                        title: resourceTitle,
                                        data: resourceData,
                                        children: []
                                    });
                                    ok = true
                                }
                            } else {
                                if (resourceFromAppointment === resourceValue) {
                                    _result.push({
                                        name: resourceName,
                                        value: resourceValue,
                                        title: resourceTitle,
                                        data: resourceData,
                                        children: []
                                    });
                                    ok = true
                                }
                            }
                        }
                    });
                    if (ok && node.children && node.children.length) {
                        that.reduceResourcesTree(node.children, existingAppointments, _result[index])
                    }
                });
                return _result
            };
            _proto.getResourcesDataByGroups = function(groups) {
                var _this2 = this;
                var resourcesData = this.getResourcesData();
                if (!groups) {
                    return resourcesData
                }
                var fieldNames = Object.getOwnPropertyNames(groups);
                var resourceData = resourcesData.filter(function(item) {
                    return fieldNames.indexOf(item.name) !== -1
                });
                var currentResourcesData = [];
                resourceData.forEach(function(data) {
                    return currentResourcesData.push((0, _extend.extend)({}, data))
                });
                (0, _iterator.each)(groups, function(_, value) {
                    currentResourcesData.forEach(function(resourceData) {
                        var items = resourceData.items,
                            data = resourceData.data,
                            name = resourceData.name;
                        var resource = _this2.getResourceByField(name);
                        var valueExpr = getValueExpr(resource);
                        var currentItems = items.filter(function(item) {
                            return item.id === value
                        });
                        var currentData = data.filter(function(item) {
                            return item[valueExpr] === value
                        });
                        resourceData.items = currentItems;
                        resourceData.data = currentData
                    })
                });
                return currentResourcesData
            };
            return ResourceManager
        }();
        exports.default = ResourceManager;
        module.exports = exports.default
    },
    /*!**************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/ui.scheduler.subscribes.js ***!
      \**************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _translator = __webpack_require__( /*! ../../animation/translator */ 28);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _date2 = _interopRequireDefault(__webpack_require__( /*! ../../localization/date */ 32));
        var _utils = _interopRequireDefault(__webpack_require__( /*! ./utils.timeZone */ 86));
        var _constants = __webpack_require__( /*! ./constants */ 160);
        var _utils2 = _interopRequireDefault(__webpack_require__( /*! ./utils */ 440));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var HOURS_IN_DAY = 24;
        var toMs = _date.default.dateToMilliseconds;
        var HOUR_MS = toMs("hour");
        var subscribes = {
            getTimeZoneCalculator: function() {
                return this.timeZoneCalculator
            },
            isCurrentViewAgenda: function() {
                return "agenda" === this.option("currentView")
            },
            currentViewUpdated: function(currentView) {
                this.option("currentView", currentView)
            },
            currentDateUpdated: function(date) {
                this.option("currentDate", date)
            },
            getOption: function(name) {
                return this.option(name)
            },
            isVirtualScrolling: function() {
                return this.isVirtualScrolling()
            },
            setCellDataCacheAlias: function(appointment, geometry) {
                this._workSpace.setCellDataCacheAlias(appointment, geometry)
            },
            createAppointmentSettings: function(appointment) {
                return this._getAppointmentSettingsGenerator().create(appointment)
            },
            isGroupedByDate: function() {
                return this.getWorkSpace().isGroupedByDate()
            },
            showAppointmentTooltip: function(options) {
                var targetedAppointment = this.getTargetedAppointment(options.data, options.target);
                this.showAppointmentTooltip(options.data, options.target, targetedAppointment)
            },
            hideAppointmentTooltip: function() {
                this.hideAppointmentTooltip()
            },
            showAddAppointmentPopup: function(cellData, cellGroups) {
                var appointmentAdapter = this.createAppointmentAdapter({});
                appointmentAdapter.allDay = cellData.allDay;
                appointmentAdapter.startDate = this.timeZoneCalculator.createDate(cellData.startDate, {
                    path: "fromGrid"
                });
                appointmentAdapter.endDate = this.timeZoneCalculator.createDate(cellData.endDate, {
                    path: "fromGrid"
                });
                var resultAppointment = (0, _extend.extend)(appointmentAdapter.source(), cellGroups);
                this.showAppointmentPopup(resultAppointment, true)
            },
            showEditAppointmentPopup: function(options) {
                var targetedData = this.getTargetedAppointment(options.data, options.target);
                this.showAppointmentPopup(options.data, false, targetedData)
            },
            updateAppointmentAfterResize: function(options) {
                var info = _utils2.default.dataAccessors.getAppointmentInfo(options.$appointment);
                var exceptionDate = info.sourceAppointment.exceptionDate;
                this._checkRecurringAppointment(options.target, options.data, exceptionDate, function() {
                    this._updateAppointment(options.target, options.data, function() {
                        this._appointments.moveAppointmentBack()
                    })
                }.bind(this))
            },
            getUpdatedData: function(rawAppointment) {
                return this._getUpdatedData(rawAppointment)
            },
            updateAppointmentAfterDrag: function(_ref) {
                var event = _ref.event,
                    element = _ref.element,
                    rawAppointment = _ref.rawAppointment,
                    coordinates = _ref.coordinates;
                var info = _utils2.default.dataAccessors.getAppointmentInfo(element);
                var appointment = this.createAppointmentAdapter(rawAppointment);
                var targetedAppointment = this.createAppointmentAdapter((0, _extend.extend)({}, rawAppointment, this._getUpdatedData(rawAppointment)));
                var targetedRawAppointment = targetedAppointment.source();
                var newCellIndex = this._workSpace.getDroppableCellIndex();
                var oldCellIndex = this._workSpace.getCellIndexByCoordinates(coordinates);
                var becomeAllDay = targetedAppointment.allDay;
                var wasAllDay = appointment.allDay;
                var movedBetweenAllDayAndSimple = this._workSpace.supportAllDayRow() && (wasAllDay && !becomeAllDay || !wasAllDay && becomeAllDay);
                if (newCellIndex !== oldCellIndex || movedBetweenAllDayAndSimple) {
                    this._checkRecurringAppointment(rawAppointment, targetedRawAppointment, info.sourceAppointment.exceptionDate, function() {
                        this._updateAppointment(rawAppointment, targetedRawAppointment, function() {
                            this._appointments.moveAppointmentBack(event)
                        }, event)
                    }.bind(this), void 0, void 0, event)
                } else {
                    this._appointments.moveAppointmentBack(event)
                }
            },
            onDeleteButtonPress: function(options) {
                var targetedData = this.getTargetedAppointment(options.data, (0, _renderer.default)(options.target));
                this.checkAndDeleteAppointment(options.data, targetedData);
                this.hideAppointmentTooltip()
            },
            getAppointmentColor: function(options) {
                var resourcesManager = this._resourcesManager;
                var resourceForPainting = resourcesManager.getResourceForPainting(this._getCurrentViewOption("groups"));
                var response = (new _deferred.Deferred).resolve().promise();
                if (resourceForPainting) {
                    var field = resourcesManager.getField(resourceForPainting);
                    var groupIndex = options.groupIndex;
                    var groups = this._workSpace._getCellGroups(groupIndex);
                    var resourceValues = (0, _array.wrapToArray)(resourcesManager.getDataAccessors(field, "getter")(options.itemData));
                    var groupId = resourceValues.length ? resourceValues[0] : void 0;
                    for (var i = 0; i < groups.length; i++) {
                        if (groups[i].name === field) {
                            groupId = groups[i].id;
                            break
                        }
                    }
                    response = resourcesManager.getResourceColor(field, groupId)
                }
                return response
            },
            getHeaderHeight: function() {
                return this._header._$element && parseInt(this._header._$element.outerHeight(), 10)
            },
            getResourcesFromItem: function(itemData) {
                return this._resourcesManager.getResourcesFromItem(itemData)
            },
            getBoundOffset: function() {
                return {
                    top: -this.getWorkSpaceAllDayHeight()
                }
            },
            appointmentTakesSeveralDays: function(appointment) {
                return this._appointmentModel.appointmentTakesSeveralDays(appointment)
            },
            getTextAndFormatDate: function(appointmentRaw, targetedAppointmentRaw, format) {
                var appointmentAdapter = this.createAppointmentAdapter(appointmentRaw);
                var targetedAdapter = this.createAppointmentAdapter(targetedAppointmentRaw || appointmentRaw);
                var startDate = this.timeZoneCalculator.createDate(targetedAdapter.startDate, {
                    path: "toGrid"
                });
                var endDate = this.timeZoneCalculator.createDate(targetedAdapter.endDate, {
                    path: "toGrid"
                });
                var formatType = format || this.fire("_getTypeFormat", startDate, endDate, targetedAdapter.allDay);
                return {
                    text: targetedAdapter.text || appointmentAdapter.text,
                    formatDate: this.fire("_formatDates", startDate, endDate, formatType)
                }
            },
            _getTypeFormat: function(startDate, endDate, isAllDay) {
                if (isAllDay) {
                    return "DATE"
                }
                if ("month" !== this.option("currentView") && _date.default.sameDate(startDate, endDate)) {
                    return "TIME"
                }
                return "DATETIME"
            },
            _createAppointmentTitle: function(data) {
                if ((0, _type.isPlainObject)(data)) {
                    return data.text
                }
                return String(data)
            },
            _formatDates: function(startDate, endDate, formatType) {
                var dateFormat = "monthandday";
                var timeFormat = "shorttime";
                var isSameDate = startDate.getDate() === endDate.getDate();
                switch (formatType) {
                    case "DATETIME":
                        return [_date2.default.format(startDate, dateFormat), " ", _date2.default.format(startDate, timeFormat), " - ", isSameDate ? "" : _date2.default.format(endDate, dateFormat) + " ", _date2.default.format(endDate, timeFormat)].join("");
                    case "TIME":
                        return "".concat(_date2.default.format(startDate, timeFormat), " - ").concat(_date2.default.format(endDate, timeFormat));
                    case "DATE":
                        return "".concat(_date2.default.format(startDate, dateFormat)).concat(isSameDate ? "" : " - " + _date2.default.format(endDate, dateFormat))
                }
            },
            getResizableAppointmentArea: function(options) {
                var allDay = options.allDay;
                var groups = this._getCurrentViewOption("groups");
                if (groups && groups.length) {
                    if (allDay || this.getLayoutManager().getRenderingStrategyInstance()._needHorizontalGroupBounds()) {
                        var horizontalGroupBounds = this._workSpace.getGroupBounds(options.coordinates);
                        return {
                            left: horizontalGroupBounds.left,
                            right: horizontalGroupBounds.right,
                            top: 0,
                            bottom: 0
                        }
                    }
                    if (this.getLayoutManager().getRenderingStrategyInstance()._needVerticalGroupBounds(allDay) && this._workSpace._isVerticalGroupedWorkSpace()) {
                        var verticalGroupBounds = this._workSpace.getGroupBounds(options.coordinates);
                        return {
                            left: 0,
                            right: 0,
                            top: verticalGroupBounds.top,
                            bottom: verticalGroupBounds.bottom
                        }
                    }
                }
            },
            needRecalculateResizableArea: function() {
                return this.getWorkSpace().needRecalculateResizableArea()
            },
            getAppointmentGeometry: function(settings) {
                return this.getLayoutManager().getRenderingStrategyInstance().getAppointmentGeometry(settings)
            },
            isAllDay: function(appointmentData) {
                return this.getLayoutManager().getRenderingStrategyInstance().isAllDay(appointmentData)
            },
            getDeltaTime: function(e, initialSize, itemData) {
                return this.getLayoutManager().getRenderingStrategyInstance().getDeltaTime(e, initialSize, itemData)
            },
            getDropDownAppointmentWidth: function(isAllDay) {
                return this.getLayoutManager().getRenderingStrategyInstance().getDropDownAppointmentWidth(this._getViewCountConfig().intervalCount, isAllDay)
            },
            getDropDownAppointmentHeight: function() {
                return this.getLayoutManager().getRenderingStrategyInstance().getDropDownAppointmentHeight()
            },
            getCellWidth: function() {
                return this.getWorkSpace().getCellWidth()
            },
            getCellHeight: function() {
                return this.getWorkSpace().getCellHeight()
            },
            getResizableStep: function() {
                var workSpace = this.getWorkSpace();
                var cellWidth = workSpace.getCellWidth();
                if (workSpace.isGroupedByDate()) {
                    return workSpace._getGroupCount() * cellWidth
                }
                return cellWidth
            },
            getRenderingStrategy: function() {
                return this._getAppointmentsRenderingStrategy()
            },
            getMaxAppointmentCountPerCellByType: function(isAllDay) {
                return this.getRenderingStrategyInstance()._getMaxAppointmentCountPerCellByType(isAllDay)
            },
            needCorrectAppointmentDates: function() {
                return this.getRenderingStrategyInstance().needCorrectAppointmentDates()
            },
            getRenderingStrategyDirection: function() {
                return this.getRenderingStrategyInstance().getDirection()
            },
            getWorkSpaceDateTableOffset: function() {
                return this.getWorkSpaceDateTableOffset()
            },
            getFullWeekAppointmentWidth: function(options) {
                var groupIndex = options.groupIndex;
                return this._workSpace.getGroupWidth(groupIndex)
            },
            getMaxAppointmentWidth: function(options) {
                var workSpace = this._workSpace;
                return workSpace.getCellCountToLastViewDate(options.date) * workSpace.getCellWidth()
            },
            updateAppointmentStartDate: function(options) {
                var appointment = options.appointment;
                var firstViewDate = this._workSpace.getStartViewDate();
                var startDate = new Date(options.startDate);
                var startDayHour = this._getCurrentViewOption("startDayHour");
                var updatedStartDate;
                if (this.appointmentTakesAllDay(appointment)) {
                    updatedStartDate = _date.default.normalizeDate(startDate, firstViewDate)
                } else {
                    if (startDate < firstViewDate) {
                        startDate = firstViewDate
                    }
                    updatedStartDate = _date.default.normalizeDate(options.startDate, new Date(startDate))
                }
                return _date.default.roundDateByStartDayHour(updatedStartDate, startDayHour)
            },
            updateAppointmentEndDate: function(options) {
                var endDate = options.endDate;
                var endDayHour = this._getCurrentViewOption("endDayHour");
                var startDayHour = this._getCurrentViewOption("startDayHour");
                var updatedEndDate = endDate;
                if (endDate.getHours() >= endDayHour) {
                    updatedEndDate.setHours(endDayHour, 0, 0, 0)
                } else {
                    if (!options.isSameDate && startDayHour > 0 && 60 * endDate.getHours() + endDate.getMinutes() < 60 * startDayHour) {
                        updatedEndDate = new Date(updatedEndDate.getTime() - toMs("day"));
                        updatedEndDate.setHours(endDayHour, 0, 0, 0)
                    }
                }
                return updatedEndDate
            },
            renderCompactAppointments: function(options) {
                this._compactAppointmentsHelper.render(options)
            },
            clearCompactAppointments: function() {
                this._compactAppointmentsHelper.clear()
            },
            supportCompactDropDownAppointments: function() {
                return this._workSpace._supportCompactDropDownAppointments()
            },
            isApplyCompactAppointmentOffset: function() {
                return this._workSpace._isApplyCompactAppointmentOffset()
            },
            getGroupCount: function() {
                return this._workSpace._getGroupCount()
            },
            mapAppointmentFields: function(config) {
                var targetedData = this.getTargetedAppointment(config.itemData, config.itemElement);
                return {
                    appointmentData: config.itemData,
                    appointmentElement: config.itemElement,
                    targetedAppointmentData: targetedData
                }
            },
            getOffsetByAllDayPanel: function(groupIndex) {
                return this._workSpace._getOffsetByAllDayPanel(groupIndex)
            },
            getGroupTop: function(groupIndex) {
                return this._workSpace._getGroupTop(groupIndex)
            },
            updateResizableArea: function() {
                var $allResizableElements = this.$element().find(".dx-scheduler-appointment.dx-resizable");
                var horizontalResizables = (0, _common.grep)($allResizableElements, function(el) {
                    var $el = (0, _renderer.default)(el);
                    var resizableInst = $el.dxResizable("instance");
                    var area = resizableInst.option("area");
                    return (0, _array.inArray)(resizableInst.option("handles"), ["right left", "left right"]) > -1 && (0, _type.isPlainObject)(area)
                });
                (0, _iterator.each)(horizontalResizables, function(_, el) {
                    var $el = (0, _renderer.default)(el);
                    var position = (0, _translator.locate)($el);
                    var appointmentData = this._appointments._getItemData($el);
                    var area = this._appointments._calculateResizableArea({
                        left: position.left
                    }, appointmentData);
                    $el.dxResizable("instance").option("area", area)
                }.bind(this))
            },
            getField: function(field, obj) {
                if (!(0, _type.isDefined)(this._dataAccessors.getter[field])) {
                    return
                }
                return this._dataAccessors.getter[field](obj)
            },
            setField: function(field, obj, value) {
                if (!(0, _type.isDefined)(this._dataAccessors.setter[field])) {
                    return
                }
                var splitExprStr = this.option(field + "Expr").split(".");
                var rootField = splitExprStr[0];
                if (void 0 === obj[rootField] && splitExprStr.length > 1) {
                    var emptyChain = function(arr) {
                        var result = {};
                        var tmp = result;
                        var arrLength = arr.length - 1;
                        for (var i = 1; i < arrLength; i++) {
                            tmp = tmp[arr[i]] = {}
                        }
                        return result
                    }(splitExprStr);
                    obj[rootField] = emptyChain
                }
                this._dataAccessors.setter[field](obj, value);
                return obj
            },
            renderAppointments: function() {
                this._renderAppointments()
            },
            prerenderFilter: function() {
                var dateRange = this.getWorkSpace().getDateRange();
                var resources = this._resourcesManager.getResourcesData();
                var startDayHour = this._getCurrentViewOption("startDayHour");
                var endDayHour = this._getCurrentViewOption("endDayHour");
                var allDay;
                if (!this.option("showAllDayPanel") && this._workSpace.supportAllDayRow()) {
                    allDay = false
                }
                return this._appointmentModel.filterLoadedAppointments({
                    startDayHour: startDayHour,
                    endDayHour: endDayHour,
                    viewStartDayHour: startDayHour,
                    viewEndDayHour: endDayHour,
                    min: dateRange[0],
                    max: dateRange[1],
                    resources: resources,
                    allDay: allDay,
                    firstDayOfWeek: this.getFirstDayOfWeek(),
                    recurrenceException: this._getRecurrenceException.bind(this)
                }, this.timeZoneCalculator)
            },
            prerenderFilterVirtual: function() {
                var _this = this;
                var workspace = this.getWorkSpace();
                var resourcesManager = this._resourcesManager;
                var isAllDaySupported = this.option("showAllDayPanel") || !this._workSpace.supportAllDayRow();
                var viewDataProvider = workspace.viewDataProvider;
                var groupedData = viewDataProvider.viewData.groupedData;
                var groupedDataToRender = groupedData.filter(function(_ref2) {
                    var dateTable = _ref2.dateTable;
                    return dateTable.length > 0
                });
                var isVerticalGrouping = workspace._isVerticalGroupedWorkSpace();
                var endViewDate = workspace.getEndViewDateByEndDayHour();
                var filterOptions = [];
                groupedDataToRender.forEach(function(_ref3) {
                    var groupIndex = _ref3.groupIndex,
                        allDayPanel = _ref3.allDayPanel;
                    var startDate = viewDataProvider.getGroupStartDate(groupIndex);
                    var endDate = new Date(Math.min(viewDataProvider.getGroupEndDate(groupIndex), endViewDate));
                    var startDayHour = startDate.getHours();
                    var endDayHour = (startDayHour + (endDate - startDate) / HOUR_MS) % HOURS_IN_DAY;
                    var allDay = false !== isAllDaySupported && (null === allDayPanel || void 0 === allDayPanel ? void 0 : allDayPanel.length) > 0;
                    var groups = viewDataProvider.getCellsGroup(groupIndex);
                    var groupResources = isVerticalGrouping ? resourcesManager.getResourcesDataByGroups(groups) : resourcesManager.getResourcesData();
                    filterOptions.push({
                        isVirtualScrolling: true,
                        startDayHour: startDayHour,
                        endDayHour: endDayHour,
                        viewStartDayHour: _this._getCurrentViewOption("startDayHour"),
                        viewEndDayHour: _this._getCurrentViewOption("endDayHour"),
                        min: startDate,
                        max: endDate,
                        resources: groupResources,
                        allDay: allDay,
                        firstDayOfWeek: _this.getFirstDayOfWeek(),
                        recurrenceException: _this._getRecurrenceException.bind(_this)
                    })
                });
                var result = this._appointmentModel.filterLoadedVirtualAppointments(filterOptions, this.timeZoneCalculator, workspace._getGroupCount());
                return result
            },
            dayHasAppointment: function(day, appointment, trimTime) {
                return this.dayHasAppointment(day, appointment, trimTime)
            },
            createResourcesTree: function() {
                return this._resourcesManager.createResourcesTree(this._loadedResources)
            },
            getResourceTreeLeaves: function(tree, appointmentResources) {
                return this._resourcesManager.getResourceTreeLeaves(tree, appointmentResources)
            },
            createReducedResourcesTree: function() {
                var tree = this._resourcesManager.createResourcesTree(this._loadedResources);
                return this._resourcesManager.reduceResourcesTree(tree, this.getFilteredItems())
            },
            groupAppointmentsByResources: function(appointments) {
                var result = {
                    0: appointments
                };
                var groups = this._getCurrentViewOption("groups");
                if (groups && groups.length && this._resourcesManager.getResourcesData().length) {
                    result = this._resourcesManager.groupAppointmentsByResources(appointments, this._loadedResources)
                }
                var totalResourceCount = 0;
                (0, _iterator.each)(this._loadedResources, function(i, resource) {
                    if (!i) {
                        totalResourceCount = resource.items.length
                    } else {
                        totalResourceCount *= resource.items.length
                    }
                });
                for (var j = 0; j < totalResourceCount; j++) {
                    var index = j.toString();
                    if (result[index]) {
                        continue
                    }
                    result[index] = []
                }
                return result
            },
            getAgendaRows: function(options) {
                var renderingStrategy = this._layoutManager.getRenderingStrategyInstance();
                var calculateRows = renderingStrategy.calculateRows.bind(renderingStrategy);
                var d = new _deferred.Deferred;

                function rowsCalculated(appointments) {
                    var result = calculateRows(appointments, options.agendaDuration, options.currentDate);
                    this._dataSourceLoadedCallback.remove(rowsCalculated);
                    d.resolve(result)
                }
                this._dataSourceLoadedCallback.add(rowsCalculated);
                return d.promise()
            },
            getAgendaVerticalStepHeight: function() {
                return this.getWorkSpace().getAgendaVerticalStepHeight()
            },
            getAgendaDuration: function() {
                return this._getCurrentViewOption("agendaDuration")
            },
            getStartViewDate: function() {
                return this.getStartViewDate()
            },
            getEndViewDate: function() {
                return this.getEndViewDate()
            },
            getMaxAppointmentsPerCell: function() {
                return this.getMaxAppointmentsPerCell()
            },
            forceMaxAppointmentPerCell: function() {
                return this.forceMaxAppointmentPerCell()
            },
            onAgendaReady: function(rows) {
                var $appts = this.getAppointmentsInstance()._itemElements();
                var total = 0;
                var applyClass = function(_, count) {
                    var index = count + total - 1;
                    $appts.eq(index).addClass(_constants.AGENDA_LAST_IN_DATE_APPOINTMENT_CLASS);
                    total += count
                };
                for (var i = 0; i < rows.length; i++) {
                    (0, _iterator.each)(rows[i], applyClass)
                }
            },
            getTimezone: function() {
                return this._getTimezoneOffsetByOption()
            },
            getTargetedAppointmentData: function(appointment, element) {
                return this.getTargetedAppointment(appointment, element)
            },
            getAppointmentDurationInMs: function(options) {
                var startDate = options.startDate;
                var endDate = options.endDate;
                var allDay = options.allDay;
                var appointmentDuration = endDate.getTime() - startDate.getTime();
                var dayDuration = toMs("day");
                var visibleDayDuration = this._workSpace.getVisibleDayDuration();
                var result = 0;
                if (allDay) {
                    var ceilQuantityOfDays = Math.ceil(appointmentDuration / dayDuration);
                    result = ceilQuantityOfDays * visibleDayDuration
                } else {
                    var isDifferentDates = !_utils.default.isSameAppointmentDates(startDate, endDate);
                    var floorQuantityOfDays = Math.floor(appointmentDuration / dayDuration);
                    var tailDuration;
                    if (isDifferentDates) {
                        var startDateEndHour = new Date(new Date(startDate).setHours(this.option("endDayHour"), 0, 0));
                        var hiddenDayDuration = dayDuration - visibleDayDuration - (startDate.getTime() > startDateEndHour.getTime() ? startDate.getTime() - startDateEndHour.getTime() : 0);
                        tailDuration = appointmentDuration - (floorQuantityOfDays ? floorQuantityOfDays * dayDuration : hiddenDayDuration);
                        var startDayTime = this.option("startDayHour") * toMs("hour");
                        var endPartDuration = endDate - _date.default.trimTime(endDate);
                        if (endPartDuration < startDayTime) {
                            if (floorQuantityOfDays) {
                                tailDuration -= hiddenDayDuration
                            }
                            tailDuration += startDayTime - endPartDuration
                        }
                    } else {
                        tailDuration = appointmentDuration % dayDuration
                    }
                    if (tailDuration > visibleDayDuration) {
                        tailDuration = visibleDayDuration
                    }
                    result = floorQuantityOfDays * visibleDayDuration + tailDuration || toMs("minute")
                }
                return result
            },
            replaceWrongEndDate: function(appointment, startDate, endDate) {
                this._appointmentModel.replaceWrongEndDate(appointment, startDate, endDate)
            },
            calculateAppointmentEndDate: function(isAllDay, startDate) {
                return this._appointmentModel._calculateAppointmentEndDate(isAllDay, startDate)
            },
            getEndDayHour: function() {
                return this._workSpace.option("endDayHour") || this.option("endDayHour")
            },
            getStartDayHour: function() {
                return this._workSpace.option("startDayHour") || this.option("startDayHour")
            },
            isAdaptive: function() {
                return this.option("adaptivityEnabled")
            },
            validateDayHours: function() {
                var endDayHour = this._getCurrentViewOption("endDayHour");
                var startDayHour = this._getCurrentViewOption("startDayHour");
                if (startDayHour >= endDayHour) {
                    throw _ui.default.Error("E1058")
                }
            },
            removeDroppableCellClass: function() {
                this._workSpace.removeDroppableCellClass()
            }
        };
        var _default = subscribes;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/workspaces/ui.scheduler.agenda.js ***!
      \*********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../../core/renderer */ 2));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../../core/dom_adapter */ 11));
        var _common = __webpack_require__( /*! ../../../core/utils/common */ 4);
        var _iterator = __webpack_require__( /*! ../../../core/utils/iterator */ 3);
        var _element = __webpack_require__( /*! ../../../core/element */ 18);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../../core/component_registrator */ 9));
        var _uiScheduler = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.work_space */ 441));
        var _extend = __webpack_require__( /*! ../../../core/utils/extend */ 0);
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../../localization/date */ 32));
        var _uiScheduler2 = _interopRequireDefault(__webpack_require__( /*! ../ui.scheduler.table_creator */ 300));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var tableCreator = _uiScheduler2.default.tableCreator;
        var AGENDA_CLASS = "dx-scheduler-agenda";
        var AGENDA_DATE_CLASS = "dx-scheduler-agenda-date";
        var GROUP_TABLE_CLASS = "dx-scheduler-group-table";
        var AGENDA_GROUPED_ATTR = "dx-group-column-count";
        var TIME_PANEL_ROW_CLASS = "dx-scheduler-time-panel-row";
        var TIME_PANEL_CELL_CLASS = "dx-scheduler-time-panel-cell";
        var NODATA_CONTAINER_CLASS = "dx-scheduler-agenda-nodata";
        var LAST_ROW_CLASS = "dx-scheduler-date-table-last-row";
        var INNER_CELL_MARGIN = 5;
        var OUTER_CELL_MARGIN = 20;
        var SchedulerAgenda = function(_SchedulerWorkSpace) {
            _inheritsLoose(SchedulerAgenda, _SchedulerWorkSpace);

            function SchedulerAgenda() {
                return _SchedulerWorkSpace.apply(this, arguments) || this
            }
            var _proto = SchedulerAgenda.prototype;
            _proto._init = function() {
                _SchedulerWorkSpace.prototype._init.call(this);
                this._activeStateUnit = void 0
            };
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_SchedulerWorkSpace.prototype._getDefaultOptions.call(this), {
                    agendaDuration: 7,
                    rowHeight: 60,
                    noDataText: ""
                })
            };
            _proto._optionChanged = function(args) {
                var name = args.name;
                var value = args.value;
                switch (name) {
                    case "agendaDuration":
                        break;
                    case "noDataText":
                    case "rowHeight":
                        this._recalculateAgenda(this._rows);
                        break;
                    case "groups":
                        if (!value || !value.length) {
                            if (this._$groupTable) {
                                this._$groupTable.remove();
                                this._$groupTable = null;
                                this._detachGroupCountAttr()
                            }
                        } else {
                            if (!this._$groupTable) {
                                this._initGroupTable();
                                this._dateTableScrollable.$content().prepend(this._$groupTable)
                            }
                        }
                        _SchedulerWorkSpace.prototype._optionChanged.call(this, args);
                        break;
                    default:
                        _SchedulerWorkSpace.prototype._optionChanged.call(this, args)
                }
            };
            _proto._renderFocusState = function() {
                return (0, _common.noop)()
            };
            _proto._renderFocusTarget = function() {
                return (0, _common.noop)()
            };
            _proto._cleanFocusState = function() {
                return (0, _common.noop)()
            };
            _proto.supportAllDayRow = function() {
                return false
            };
            _proto._isVerticalGroupedWorkSpace = function() {
                return false
            };
            _proto._getElementClass = function() {
                return AGENDA_CLASS
            };
            _proto._setFirstViewDate = function() {
                this._firstViewDate = new Date(this.option("currentDate"));
                this._setStartDayHour(this._firstViewDate)
            };
            _proto._getRowCount = function() {
                return this.option("agendaDuration")
            };
            _proto._getCellCount = function() {
                return 1
            };
            _proto._getTimePanelRowCount = function() {
                return this.option("agendaDuration")
            };
            _proto._getDateByIndex = function() {
                return (0, _common.noop)()
            };
            _proto._getFormat = function() {
                return "d ddd"
            };
            _proto._renderAllDayPanel = function() {
                return (0, _common.noop)()
            };
            _proto._toggleAllDayVisibility = function() {
                return (0, _common.noop)()
            };
            _proto._initWorkSpaceUnits = function() {
                this._initGroupTable();
                this._$timePanel = (0, _renderer.default)("<table>").addClass(this._getTimePanelClass());
                this._$dateTable = (0, _renderer.default)("<table>").addClass(this._getDateTableClass())
            };
            _proto._initGroupTable = function() {
                var groups = this.option("groups");
                if (groups && groups.length) {
                    this._$groupTable = (0, _renderer.default)("<table>").addClass(GROUP_TABLE_CLASS)
                }
            };
            _proto._renderView = function() {
                this._setFirstViewDate();
                this._rows = [];
                this.invoke("getAgendaRows", {
                    agendaDuration: this.option("agendaDuration"),
                    currentDate: new Date(this.option("currentDate"))
                }).done(function(rows) {
                    this._recalculateAgenda(rows)
                }.bind(this))
            };
            _proto._recalculateAgenda = function(rows) {
                var cellTemplates = [];
                this._cleanView();
                if (this._rowsIsEmpty(rows)) {
                    this._renderNoData();
                    return
                }
                this._rows = rows;
                if (this._$groupTable) {
                    cellTemplates = this._renderGroupHeader();
                    this._setGroupHeaderCellsHeight()
                }
                this._renderTimePanel();
                this._renderDateTable();
                this.invoke("onAgendaReady", rows);
                this._applyCellTemplates(cellTemplates);
                this._dateTableScrollable.update()
            };
            _proto._renderNoData = function() {
                this._$noDataContainer = (0, _renderer.default)("<div>").addClass(NODATA_CONTAINER_CLASS).html(this.option("noDataText"));
                this._dateTableScrollable.$content().append(this._$noDataContainer)
            };
            _proto._setTableSizes = function() {
                return (0, _common.noop)()
            };
            _proto._toggleHorizontalScrollClass = function() {
                return (0, _common.noop)()
            };
            _proto._createCrossScrollingConfig = function() {
                return (0, _common.noop)()
            };
            _proto._setGroupHeaderCellsHeight = function() {
                var $cells = this._getGroupHeaderCells().filter(function(_, element) {
                    return !element.getAttribute("rowSpan")
                });
                var rows = this._removeEmptyRows(this._rows);
                if (!rows.length) {
                    return
                }
                for (var i = 0; i < $cells.length; i++) {
                    var $cellContent = $cells.eq(i).find(".dx-scheduler-group-header-content");
                    $cellContent.outerHeight(this._getGroupRowHeight(rows[i]))
                }
            };
            _proto._rowsIsEmpty = function(rows) {
                var result = true;
                for (var i = 0; i < rows.length; i++) {
                    var groupRow = rows[i];
                    for (var j = 0; j < groupRow.length; j++) {
                        if (groupRow[j]) {
                            result = false;
                            break
                        }
                    }
                }
                return result
            };
            _proto._detachGroupCountAttr = function() {
                this.$element().removeAttr(AGENDA_GROUPED_ATTR)
            };
            _proto._attachGroupCountAttr = function() {
                this.$element().attr(AGENDA_GROUPED_ATTR, this.option("groups").length)
            };
            _proto._removeEmptyRows = function(rows) {
                var result = [];
                var isEmpty = function(data) {
                    return !data.some(function(value) {
                        return value > 0
                    })
                };
                for (var i = 0; i < rows.length; i++) {
                    if (rows[i].length && !isEmpty(rows[i])) {
                        result.push(rows[i])
                    }
                }
                return result
            };
            _proto._getGroupHeaderContainer = function() {
                return this._$groupTable
            };
            _proto._makeGroupRows = function() {
                var tree = this.invoke("createReducedResourcesTree");
                var cellTemplate = this.option("resourceCellTemplate");
                var getGroupHeaderContentClass = this._getGroupHeaderContentClass();
                var cellTemplates = [];
                var table = tableCreator.makeGroupedTableFromJSON(tableCreator.VERTICAL, tree, {
                    cellTag: "th",
                    groupTableClass: GROUP_TABLE_CLASS,
                    groupRowClass: this._getGroupRowClass(),
                    groupCellClass: this._getGroupHeaderClass(),
                    groupCellCustomContent: function(cell, cellText, index, data) {
                        var container = _dom_adapter.default.createElement("div");
                        var contentWrapper = _dom_adapter.default.createElement("div");
                        container.className = getGroupHeaderContentClass;
                        contentWrapper.appendChild(cellText);
                        container.appendChild(contentWrapper);
                        container.className = getGroupHeaderContentClass;
                        if (cellTemplate && cellTemplate.render) {
                            cellTemplates.push(cellTemplate.render.bind(cellTemplate, {
                                model: {
                                    data: data.data,
                                    id: data.value,
                                    color: data.color,
                                    text: cellText.textContent
                                },
                                container: (0, _element.getPublicElement)((0, _renderer.default)(container)),
                                index: index
                            }))
                        } else {
                            contentWrapper.appendChild(cellText);
                            container.appendChild(contentWrapper)
                        }
                        cell.appendChild(container)
                    },
                    cellTemplate: cellTemplate
                });
                return {
                    elements: (0, _renderer.default)(table).find("." + this._getGroupRowClass()),
                    cellTemplates: cellTemplates
                }
            };
            _proto._cleanView = function() {
                this._$dateTable.empty();
                this._$timePanel.empty();
                if (this._$groupTable) {
                    this._$groupTable.empty()
                }
                if (this._$noDataContainer) {
                    this._$noDataContainer.empty();
                    this._$noDataContainer.remove();
                    delete this._$noDataContainer
                }
            };
            _proto._createWorkSpaceElements = function() {
                this._createWorkSpaceStaticElements()
            };
            _proto._createWorkSpaceStaticElements = function() {
                if (this._$groupTable) {
                    this._dateTableScrollable.$content().prepend(this._$groupTable)
                }
                this._dateTableScrollable.$content().append(this._$timePanel, this._$dateTable);
                this.$element().append(this._dateTableScrollable.$element())
            };
            _proto._renderDateTable = function() {
                this._renderTableBody({
                    container: (0, _element.getPublicElement)(this._$dateTable),
                    rowClass: this._getDateTableRowClass(),
                    cellClass: this._getDateTableCellClass()
                })
            };
            _proto._attachTablesEvents = function() {
                return (0, _common.noop)()
            };
            _proto._attachEvents = function() {
                return (0, _common.noop)()
            };
            _proto._cleanCellDataCache = function() {
                return (0, _common.noop)()
            };
            _proto.isIndicationAvailable = function() {
                return false
            };
            _proto._prepareCellTemplateOptions = function(text, date, rowIndex, $cell) {
                var groupsOpt = this.option("groups");
                var groups = {};
                var path = groupsOpt.length && this._getPathToLeaf(rowIndex) || [];
                path.forEach(function(resourceValue, resourceIndex) {
                    var resourceName = groupsOpt[resourceIndex].name;
                    groups[resourceName] = resourceValue
                });
                return {
                    model: {
                        text: text,
                        date: date,
                        groups: groups
                    },
                    container: (0, _element.getPublicElement)($cell),
                    index: rowIndex
                }
            };
            _proto._renderTableBody = function(options) {
                var cellTemplates = [];
                var cellTemplateOpt = options.cellTemplate;
                this._$rows = [];
                var i;
                var fillTableBody = function(rowIndex, rowSize) {
                    if (rowSize) {
                        var date;
                        var cellDateNumber;
                        var cellDayName;
                        var $row = (0, _renderer.default)("<tr>");
                        var $td = (0, _renderer.default)("<td>").height(this._getRowHeight(rowSize));
                        if (options.getStartDate) {
                            date = options.getStartDate && options.getStartDate(rowIndex);
                            cellDateNumber = _date.default.format(date, "d");
                            cellDayName = _date.default.format(date, this._formatWeekday)
                        }
                        if (cellTemplateOpt && cellTemplateOpt.render) {
                            var templateOptions = this._prepareCellTemplateOptions(cellDateNumber + " " + cellDayName, date, i, $td);
                            cellTemplates.push(cellTemplateOpt.render.bind(cellTemplateOpt, templateOptions))
                        } else {
                            if (cellDateNumber && cellDayName) {
                                $td.addClass(AGENDA_DATE_CLASS).text(cellDateNumber + " " + cellDayName)
                            }
                        }
                        if (options.rowClass) {
                            $row.addClass(options.rowClass)
                        }
                        if (options.cellClass) {
                            $td.addClass(options.cellClass)
                        }
                        $row.append($td);
                        this._$rows.push($row)
                    }
                }.bind(this);
                for (i = 0; i < this._rows.length; i++) {
                    (0, _iterator.each)(this._rows[i], fillTableBody);
                    this._setLastRowClass()
                }(0, _renderer.default)(options.container).append((0, _renderer.default)("<tbody>").append(this._$rows));
                this._applyCellTemplates(cellTemplates)
            };
            _proto._setLastRowClass = function() {
                if (this._rows.length > 1 && this._$rows.length) {
                    var $lastRow = this._$rows[this._$rows.length - 1];
                    $lastRow.addClass(LAST_ROW_CLASS)
                }
            };
            _proto._renderTimePanel = function() {
                this._renderTableBody({
                    container: (0, _element.getPublicElement)(this._$timePanel),
                    rowCount: this._getTimePanelRowCount(),
                    cellCount: 1,
                    rowClass: TIME_PANEL_ROW_CLASS,
                    cellClass: TIME_PANEL_CELL_CLASS,
                    cellTemplate: this.option("dateCellTemplate"),
                    getStartDate: this._getTimePanelStartDate.bind(this)
                })
            };
            _proto._getTimePanelStartDate = function(rowIndex) {
                var current = new Date(this.option("currentDate"));
                var cellDate = new Date(current.setDate(current.getDate() + rowIndex));
                return cellDate
            };
            _proto._getRowHeight = function(rowSize) {
                var baseHeight = this.option("rowHeight");
                var innerOffset = (rowSize - 1) * INNER_CELL_MARGIN;
                return rowSize ? baseHeight * rowSize + innerOffset + OUTER_CELL_MARGIN : 0
            };
            _proto._getGroupRowHeight = function(groupRows) {
                if (!groupRows) {
                    return
                }
                var result = 0;
                for (var i = 0; i < groupRows.length; i++) {
                    result += this._getRowHeight(groupRows[i])
                }
                return result
            };
            _proto.getAgendaVerticalStepHeight = function() {
                return this.option("rowHeight")
            };
            _proto.getEndViewDate = function() {
                var currentDate = new Date(this.option("currentDate"));
                var agendaDuration = this.option("agendaDuration");
                currentDate.setHours(this.option("endDayHour"));
                var result = currentDate.setDate(currentDate.getDate() + agendaDuration - 1) - 6e4;
                return new Date(result)
            };
            _proto.getEndViewDateByEndDayHour = function() {
                return this.getEndViewDate()
            };
            _proto.getCoordinatesByDate = function() {
                return {
                    top: 0,
                    left: 0,
                    max: 0,
                    groupIndex: 0
                }
            };
            _proto.getCellDataByCoordinates = function() {
                return {
                    startDate: null,
                    endDate: null
                }
            };
            _proto.updateScrollPosition = function(date) {
                var scheduler = this.option("observer");
                var newDate = scheduler.timeZoneCalculator.createDate(date, {
                    path: "toGrid"
                });
                var bounds = this.getVisibleBounds();
                var startDateHour = newDate.getHours();
                var startDateMinutes = newDate.getMinutes();
                if (this.needUpdateScrollPosition(startDateHour, startDateMinutes, bounds, newDate)) {
                    this.scrollToTime(startDateHour, startDateMinutes, newDate)
                }
            };
            _proto.needUpdateScrollPosition = function(hours, minutes, bounds) {
                var isUpdateNeeded = false;
                if (hours < bounds.top.hours || hours > bounds.bottom.hours) {
                    isUpdateNeeded = true
                }
                if (hours === bounds.top.hours && minutes < bounds.top.minutes) {
                    isUpdateNeeded = true
                }
                if (hours === bounds.bottom.hours && minutes > bounds.top.minutes) {
                    isUpdateNeeded = true
                }
                return isUpdateNeeded
            };
            return SchedulerAgenda
        }(_uiScheduler.default);
        (0, _component_registrator.default)("dxSchedulerAgenda", SchedulerAgenda);
        var _default = SchedulerAgenda;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/workspaces/ui.scheduler.work_space.grouped.strategy.horizontal.js ***!
      \*****************************************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _position = __webpack_require__( /*! ../../../core/utils/position */ 22);
        var _uiSchedulerWork_spaceGrouped = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.work_space.grouped.strategy */ 442));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var HORIZONTAL_GROUPED_ATTR = "dx-group-row-count";
        var HorizontalGroupedStrategy = function(_GroupedStrategy) {
            _inheritsLoose(HorizontalGroupedStrategy, _GroupedStrategy);

            function HorizontalGroupedStrategy() {
                return _GroupedStrategy.apply(this, arguments) || this
            }
            var _proto = HorizontalGroupedStrategy.prototype;
            _proto.prepareCellIndexes = function(cellCoordinates, groupIndex, inAllDay) {
                var groupByDay = this._workSpace.isGroupedByDate();
                if (!groupByDay) {
                    return {
                        rowIndex: cellCoordinates.rowIndex,
                        cellIndex: cellCoordinates.cellIndex + groupIndex * this._workSpace._getCellCount()
                    }
                } else {
                    return {
                        rowIndex: cellCoordinates.rowIndex,
                        cellIndex: cellCoordinates.cellIndex * this._workSpace._getGroupCount() + groupIndex
                    }
                }
            };
            _proto.calculateCellIndex = function(rowIndex, cellIndex) {
                cellIndex %= this._workSpace._getCellCount();
                return this._workSpace._getRowCount() * cellIndex + rowIndex
            };
            _proto.getGroupIndex = function(rowIndex, cellIndex) {
                var groupByDay = this._workSpace.isGroupedByDate();
                var groupCount = this._workSpace._getGroupCount();
                if (groupByDay) {
                    return cellIndex % groupCount
                } else {
                    return Math.floor(cellIndex / this._workSpace._getCellCount())
                }
            };
            _proto.calculateHeaderCellRepeatCount = function() {
                return this._workSpace._getGroupCount() || 1
            };
            _proto.insertAllDayRowsIntoDateTable = function() {
                return false
            };
            _proto.getTotalCellCount = function(groupCount) {
                groupCount = groupCount || 1;
                return this._workSpace._getCellCount() * groupCount
            };
            _proto.getTotalRowCount = function() {
                return this._workSpace._getRowCount()
            };
            _proto.addAdditionalGroupCellClasses = function(cellClass, index, i, j) {
                var applyUnconditionally = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : false;
                cellClass = this._addLastGroupCellClass(cellClass, index, applyUnconditionally);
                return this._addFirstGroupCellClass(cellClass, index, applyUnconditionally)
            };
            _proto._addLastGroupCellClass = function(cellClass, index, applyUnconditionally) {
                if (applyUnconditionally) {
                    return "".concat(cellClass, " ").concat(this.getLastGroupCellClass())
                }
                var groupByDate = this._workSpace.isGroupedByDate();
                if (groupByDate) {
                    if (index % this._workSpace._getGroupCount() === 0) {
                        return "".concat(cellClass, " ").concat(this.getLastGroupCellClass())
                    }
                } else {
                    if (index % this._workSpace._getCellCount() === 0) {
                        return "".concat(cellClass, " ").concat(this.getLastGroupCellClass())
                    }
                }
                return cellClass
            };
            _proto._addFirstGroupCellClass = function(cellClass, index, applyUnconditionally) {
                if (applyUnconditionally) {
                    return "".concat(cellClass, " ").concat(this.getFirstGroupCellClass())
                }
                var groupByDate = this._workSpace.isGroupedByDate();
                if (groupByDate) {
                    if ((index - 1) % this._workSpace._getGroupCount() === 0) {
                        return "".concat(cellClass, " ").concat(this.getFirstGroupCellClass())
                    }
                } else {
                    if ((index - 1) % this._workSpace._getCellCount() === 0) {
                        return "".concat(cellClass, " ").concat(this.getFirstGroupCellClass())
                    }
                }
                return cellClass
            };
            _proto.getHorizontalMax = function(groupIndex) {
                return this._workSpace.getMaxAllowedPosition()[groupIndex]
            };
            _proto.getVerticalMax = function(groupIndex) {
                return this._workSpace.getMaxAllowedVerticalPosition(0)
            };
            _proto.calculateTimeCellRepeatCount = function() {
                return 1
            };
            _proto.getWorkSpaceMinWidth = function() {
                return (0, _position.getBoundingRect)(this._workSpace.$element().get(0)).width - this._workSpace.getTimePanelWidth()
            };
            _proto.getAllDayOffset = function() {
                return this._workSpace.getAllDayHeight()
            };
            _proto.getAllDayTableHeight = function() {
                return (0, _position.getBoundingRect)(this._workSpace._$allDayTable.get(0)).height || 0
            };
            _proto.getGroupCountAttr = function(groupRowCount, groupRows) {
                return {
                    attr: HORIZONTAL_GROUPED_ATTR,
                    count: groupRows && groupRows.elements.length
                }
            };
            _proto.getLeftOffset = function() {
                return this._workSpace.getTimePanelWidth()
            };
            _proto.getGroupBoundsOffset = function(cellCount, $cells, cellWidth, coordinates) {
                var groupIndex;
                var cellIndex;
                var startCellIndex;
                var startOffset;
                var endOffset;
                if (this._workSpace.isGroupedByDate()) {
                    startCellIndex = 0;
                    startOffset = $cells.eq(startCellIndex).offset().left - cellWidth / 2;
                    endOffset = $cells.eq(cellCount * this._workSpace._getGroupCount() - 1).offset().left + cellWidth + cellWidth / 2
                } else {
                    cellIndex = this._workSpace.getCellIndexByCoordinates(coordinates);
                    groupIndex = coordinates.groupIndex || Math.floor(cellIndex / cellCount);
                    startCellIndex = groupIndex * cellCount;
                    startOffset = $cells.eq(startCellIndex).offset().left - cellWidth / 2;
                    endOffset = $cells.eq(startCellIndex + cellCount - 1).offset().left + cellWidth + cellWidth / 2
                }
                return {
                    left: startOffset,
                    right: endOffset,
                    top: 0,
                    bottom: 0
                }
            };
            _proto.shiftIndicator = function($indicator, height, rtlOffset, groupIndex) {
                var offset = this._getIndicatorOffset(groupIndex);
                var horizontalOffset = rtlOffset ? rtlOffset - offset : offset;
                $indicator.css("left", horizontalOffset);
                $indicator.css("top", height)
            };
            _proto._getIndicatorOffset = function(groupIndex) {
                var groupByDay = this._workSpace.isGroupedByDate();
                return groupByDay ? this._calculateGroupByDateOffset(groupIndex) : this._calculateOffset(groupIndex)
            };
            _proto._calculateOffset = function(groupIndex) {
                return this._workSpace._getCellCount() * this._workSpace.getRoundedCellWidth(groupIndex - 1, 0) * groupIndex + this._workSpace.getIndicatorOffset(groupIndex) + groupIndex
            };
            _proto._calculateGroupByDateOffset = function(groupIndex) {
                return this._workSpace.getIndicatorOffset(0) * this._workSpace._getGroupCount() + this._workSpace.getRoundedCellWidth(groupIndex - 1, 0) * groupIndex
            };
            _proto.getShaderOffset = function(i, width) {
                var offset = this._workSpace._getCellCount() * this._workSpace.getRoundedCellWidth(i - 1) * i;
                return this._workSpace.option("rtlEnabled") ? (0, _position.getBoundingRect)(this._workSpace._dateTableScrollable.$content().get(0)).width - offset - this._workSpace.getTimePanelWidth() - width : offset
            };
            _proto.getShaderTopOffset = function(i) {
                return -this.getShaderMaxHeight() * (i > 0 ? 1 : 0)
            };
            _proto.getShaderHeight = function() {
                var height = this._workSpace.getIndicationHeight();
                return height
            };
            _proto.getShaderMaxHeight = function() {
                return (0, _position.getBoundingRect)(this._workSpace._dateTableScrollable.$content().get(0)).height
            };
            _proto.getShaderWidth = function(i) {
                return this._workSpace.getIndicationWidth(i)
            };
            _proto.getScrollableScrollTop = function(allDay) {
                return !allDay ? this._workSpace.getScrollable().scrollTop() : 0
            };
            _proto.getGroupIndexByCell = function($cell) {
                var rowIndex = $cell.parent().index();
                var cellIndex = $cell.index();
                return this.getGroupIndex(rowIndex, cellIndex)
            };
            return HorizontalGroupedStrategy
        }(_uiSchedulerWork_spaceGrouped.default);
        var _default = HorizontalGroupedStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/workspaces/ui.scheduler.work_space.grouped.strategy.vertical.js ***!
      \***************************************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _position = __webpack_require__( /*! ../../../core/utils/position */ 22);
        var _uiSchedulerWork_spaceGrouped = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.work_space.grouped.strategy */ 442));
        var _cache = __webpack_require__( /*! ./cache */ 443);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var VERTICAL_GROUPED_ATTR = "dx-group-column-count";
        var DATE_HEADER_OFFSET = 10;
        var WORK_SPACE_BORDER = 1;
        var VerticalGroupedStrategy = function(_GroupedStrategy) {
            _inheritsLoose(VerticalGroupedStrategy, _GroupedStrategy);

            function VerticalGroupedStrategy() {
                return _GroupedStrategy.apply(this, arguments) || this
            }
            var _proto = VerticalGroupedStrategy.prototype;
            _proto.prepareCellIndexes = function(cellCoordinates, groupIndex, inAllDayRow) {
                var rowIndex = cellCoordinates.rowIndex + groupIndex * this._workSpace._getRowCount();
                if (this._workSpace.supportAllDayRow() && this._workSpace.option("showAllDayPanel")) {
                    rowIndex += groupIndex;
                    if (!inAllDayRow) {
                        rowIndex += 1
                    }
                }
                return {
                    rowIndex: rowIndex,
                    cellIndex: cellCoordinates.cellIndex
                }
            };
            _proto.calculateCellIndex = function(rowIndex, cellIndex) {
                rowIndex %= this._workSpace._getRowCount();
                return this._workSpace._getRowCount() * cellIndex + rowIndex
            };
            _proto.getGroupIndex = function(rowIndex) {
                return Math.floor(rowIndex / this._workSpace._getRowCount())
            };
            _proto.calculateHeaderCellRepeatCount = function() {
                return 1
            };
            _proto.insertAllDayRowsIntoDateTable = function() {
                return this._workSpace.option("showAllDayPanel")
            };
            _proto.getTotalCellCount = function() {
                return this._workSpace._getCellCount()
            };
            _proto.getTotalRowCount = function() {
                return this._workSpace._getRowCount() * this._workSpace._getGroupCount()
            };
            _proto.addAdditionalGroupCellClasses = function(cellClass, index, i, j) {
                cellClass = this._addLastGroupCellClass(cellClass, i + 1);
                return this._addFirstGroupCellClass(cellClass, i + 1)
            };
            _proto._addLastGroupCellClass = function(cellClass, index) {
                if (index % this._workSpace._getRowCount() === 0) {
                    return cellClass + " " + this.getLastGroupCellClass()
                }
                return cellClass
            };
            _proto._addFirstGroupCellClass = function(cellClass, index) {
                if ((index - 1) % this._workSpace._getRowCount() === 0) {
                    return cellClass + " " + this.getFirstGroupCellClass()
                }
                return cellClass
            };
            _proto.getHorizontalMax = function() {
                return this._workSpace.getMaxAllowedPosition()[0]
            };
            _proto.getVerticalMax = function(groupIndex) {
                var maxAllowedPosition = this._workSpace.getMaxAllowedVerticalPosition(groupIndex);
                maxAllowedPosition += this._getOffsetByAllDayPanel(groupIndex);
                return maxAllowedPosition
            };
            _proto._getOffsetByAllDayPanel = function(groupIndex) {
                var result = 0;
                if (this._workSpace.supportAllDayRow() && this._workSpace.option("showAllDayPanel")) {
                    result = this._workSpace.getAllDayHeight() * (groupIndex + 1)
                }
                return result
            };
            _proto._getGroupTop = function(groupIndex) {
                var workspace = this._workSpace;
                var rowCount = workspace.isVirtualScrolling() ? workspace.viewDataProvider.getRowCountInGroup(groupIndex) : workspace._getRowCount();
                return workspace.getMaxAllowedVerticalPosition(groupIndex) - workspace.getCellHeight() * rowCount
            };
            _proto.calculateTimeCellRepeatCount = function() {
                return this._workSpace._getGroupCount() || 1
            };
            _proto.getWorkSpaceMinWidth = function() {
                var minWidth = this._workSpace._getWorkSpaceWidth();
                var workspaceContainerWidth = (0, _position.getBoundingRect)(this._workSpace.$element().get(0)).width - this._workSpace.getTimePanelWidth() - this._workSpace.getGroupTableWidth() - 2 * WORK_SPACE_BORDER;
                if (minWidth < workspaceContainerWidth) {
                    minWidth = workspaceContainerWidth
                }
                return minWidth
            };
            _proto.getAllDayOffset = function() {
                return 0
            };
            _proto.getAllDayTableHeight = function() {
                return 0
            };
            _proto.getGroupCountAttr = function() {
                return {
                    attr: VERTICAL_GROUPED_ATTR,
                    count: this._workSpace.option("groups") && this._workSpace.option("groups").length
                }
            };
            _proto.getLeftOffset = function() {
                return this._workSpace.getTimePanelWidth() + this._workSpace.getGroupTableWidth()
            };
            _proto.getGroupBoundsOffset = function(cellCount, $cells, cellWidth, coordinates) {
                var _this = this;
                return _cache.cache.get("groupBoundsOffset", function() {
                    var groupIndex = coordinates.groupIndex;
                    var startOffset = $cells.eq(0).offset().left;
                    var endOffset = $cells.eq(cellCount - 1).offset().left + cellWidth;
                    var dayHeight = _this._workSpace._calculateDayDuration() / _this._workSpace.option("hoursInterval") * _this._workSpace.getCellHeight();
                    var scrollTop = _this.getScrollableScrollTop();
                    var topOffset = groupIndex * dayHeight + (0, _position.getBoundingRect)(_this._workSpace._$thead.get(0)).height + _this._workSpace.invoke("getHeaderHeight") + DATE_HEADER_OFFSET - scrollTop;
                    if (_this._workSpace.option("showAllDayPanel") && _this._workSpace.supportAllDayRow()) {
                        topOffset += _this._workSpace.getCellHeight() * (groupIndex + 1)
                    }
                    var bottomOffset = topOffset + dayHeight;
                    return _this._groupBoundsOffset = {
                        left: startOffset,
                        right: endOffset,
                        top: topOffset,
                        bottom: bottomOffset
                    }
                })
            };
            _proto.shiftIndicator = function($indicator, height, rtlOffset, i) {
                var offset = this._workSpace.getIndicatorOffset(0);
                var tableOffset = this._workSpace.option("crossScrollingEnabled") ? 0 : this._workSpace.getGroupTableWidth();
                var horizontalOffset = rtlOffset ? rtlOffset - offset : offset;
                var verticalOffset = this._workSpace._getRowCount() * this._workSpace.getCellHeight() * i;
                if (this._workSpace.supportAllDayRow() && this._workSpace.option("showAllDayPanel")) {
                    verticalOffset += this._workSpace.getAllDayHeight() * (i + 1)
                }
                $indicator.css("left", horizontalOffset + tableOffset);
                $indicator.css("top", height + verticalOffset)
            };
            _proto.getShaderOffset = function(i, width) {
                var offset = this._workSpace.option("crossScrollingEnabled") ? 0 : this._workSpace.getGroupTableWidth();
                return this._workSpace.option("rtlEnabled") ? (0, _position.getBoundingRect)(this._$container.get(0)).width - offset - this._workSpace.getWorkSpaceLeftOffset() - width : offset
            };
            _proto.getShaderTopOffset = function(i) {
                return 0
            };
            _proto.getShaderHeight = function() {
                var height = this._workSpace.getIndicationHeight();
                if (this._workSpace.supportAllDayRow() && this._workSpace.option("showAllDayPanel")) {
                    height += this._workSpace.getCellHeight()
                }
                return height
            };
            _proto.getShaderMaxHeight = function() {
                var height = this._workSpace._getRowCount() * this._workSpace.getCellHeight();
                if (this._workSpace.supportAllDayRow() && this._workSpace.option("showAllDayPanel")) {
                    height += this._workSpace.getCellHeight()
                }
                return height
            };
            _proto.getShaderWidth = function() {
                return this._workSpace.getIndicationWidth(0)
            };
            _proto.getScrollableScrollTop = function() {
                return this._workSpace.getScrollable().scrollTop()
            };
            _proto.getGroupIndexByCell = function($cell) {
                var rowIndex = $cell.parent().index();
                var rowCount = this._workSpace._getRowCountWithAllDayRows();
                return Math.ceil((rowIndex + 1) / rowCount)
            };
            return VerticalGroupedStrategy
        }(_uiSchedulerWork_spaceGrouped.default);
        var _default = VerticalGroupedStrategy;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/shaders/ui.scheduler.current_time_shader.vertical.js ***!
      \****************************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../../core/renderer */ 2));
        var _uiScheduler = _interopRequireDefault(__webpack_require__( /*! ../shaders/ui.scheduler.current_time_shader */ 444));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var DATE_TIME_SHADER_ALL_DAY_CLASS = "dx-scheduler-date-time-shader-all-day";
        var DATE_TIME_SHADER_TOP_CLASS = "dx-scheduler-date-time-shader-top";
        var DATE_TIME_SHADER_BOTTOM_CLASS = "dx-scheduler-date-time-shader-bottom";
        var VerticalCurrentTimeShader = function(_CurrentTimeShader) {
            _inheritsLoose(VerticalCurrentTimeShader, _CurrentTimeShader);

            function VerticalCurrentTimeShader() {
                return _CurrentTimeShader.apply(this, arguments) || this
            }
            var _proto = VerticalCurrentTimeShader.prototype;
            _proto.renderShader = function() {
                var shaderHeight = this._getShaderHeight();
                var maxHeight = this._getShaderMaxHeight();
                var isSolidShader = shaderHeight > maxHeight;
                if (shaderHeight > maxHeight) {
                    shaderHeight = maxHeight
                }
                this._$shader.height(shaderHeight);
                var groupCount = this._workSpace._getGroupCount() || 1;
                if (this._workSpace.isGroupedByDate()) {
                    this._renderGroupedByDateShaderParts(groupCount, shaderHeight, maxHeight, isSolidShader)
                } else {
                    this._renderShaderParts(groupCount, shaderHeight, maxHeight, isSolidShader)
                }
            };
            _proto._renderShaderParts = function(groupCount, shaderHeight, maxHeight, isSolidShader) {
                for (var i = 0; i < groupCount; i++) {
                    var shaderWidth = this._getShaderWidth(i);
                    this._renderTopShader(this._$shader, shaderHeight, shaderWidth, i);
                    !isSolidShader && this._renderBottomShader(this._$shader, maxHeight, shaderHeight, shaderWidth, i);
                    this._renderAllDayShader(shaderWidth, i)
                }
            };
            _proto._renderGroupedByDateShaderParts = function(groupCount, shaderHeight, maxHeight, isSolidShader) {
                var shaderWidth = this._getShaderWidth(0);
                var bottomShaderWidth = shaderWidth - this._workSpace.getCellWidth();
                if (shaderHeight < 0) {
                    shaderHeight = 0;
                    bottomShaderWidth = shaderWidth
                }
                this._renderTopShader(this._$shader, shaderHeight, shaderWidth * groupCount, 0);
                !isSolidShader && this._renderBottomShader(this._$shader, maxHeight, shaderHeight, bottomShaderWidth * groupCount + this._workSpace.getCellWidth(), 0);
                this._renderAllDayShader(shaderWidth * groupCount, 0)
            };
            _proto._renderTopShader = function($shader, height, width, i) {
                this._$topShader = (0, _renderer.default)("<div>").addClass(DATE_TIME_SHADER_TOP_CLASS);
                width && this._$topShader.width(width) && this._$topShader.height(height);
                this._$topShader.css("marginTop", this._getShaderTopOffset(i));
                this._$topShader.css("left", this._getShaderOffset(i, width));
                $shader.append(this._$topShader)
            };
            _proto._renderBottomShader = function($shader, maxHeight, height, width, i) {
                this._$bottomShader = (0, _renderer.default)("<div>").addClass(DATE_TIME_SHADER_BOTTOM_CLASS);
                var shaderWidth = height < 0 ? width : width - this._workSpace.getCellWidth();
                var shaderHeight = height < 0 ? maxHeight : maxHeight - height;
                this._$bottomShader.width(shaderWidth) && this._$bottomShader.height(shaderHeight);
                this._$bottomShader.css("left", this._getShaderOffset(i, width - this._workSpace.getCellWidth()));
                $shader.append(this._$bottomShader)
            };
            _proto._renderAllDayShader = function(shaderWidth, i) {
                if (this._workSpace.option("showAllDayPanel")) {
                    this._$allDayIndicator = (0, _renderer.default)("<div>").addClass(DATE_TIME_SHADER_ALL_DAY_CLASS);
                    this._$allDayIndicator.height(this._workSpace.getAllDayHeight());
                    this._$allDayIndicator.width(shaderWidth);
                    this._$allDayIndicator.css("left", this._getShaderOffset(i, shaderWidth));
                    this._workSpace._$allDayPanel.prepend(this._$allDayIndicator)
                }
            };
            _proto._getShaderOffset = function(i, width) {
                return this._workSpace.getGroupedStrategy().getShaderOffset(i, width)
            };
            _proto._getShaderTopOffset = function(i) {
                return this._workSpace.getGroupedStrategy().getShaderTopOffset(i)
            };
            _proto._getShaderHeight = function(i, width) {
                return this._workSpace.getGroupedStrategy().getShaderHeight()
            };
            _proto._getShaderMaxHeight = function(i, width) {
                return this._workSpace.getGroupedStrategy().getShaderMaxHeight()
            };
            _proto._getShaderWidth = function(i) {
                return this._workSpace.getGroupedStrategy().getShaderWidth(i)
            };
            _proto.clean = function() {
                _CurrentTimeShader.prototype.clean.call(this);
                this._workSpace && this._workSpace._$allDayPanel && this._workSpace._$allDayPanel.find("." + DATE_TIME_SHADER_ALL_DAY_CLASS).remove()
            };
            return VerticalCurrentTimeShader
        }(_uiScheduler.default);
        var _default = VerticalCurrentTimeShader;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/appointmentDragBehavior.js ***!
      \**************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _draggable = _interopRequireDefault(__webpack_require__( /*! ../draggable */ 210));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _constants = __webpack_require__( /*! ./constants */ 160);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var APPOINTMENT_ITEM_CLASS = "dx-scheduler-appointment";
        var AppointmentDragBehavior = function() {
            function AppointmentDragBehavior(scheduler) {
                this.scheduler = scheduler;
                this.appointments = scheduler._appointments;
                this.initialPosition = {
                    left: 0,
                    top: 0
                };
                this.appointmentInfo = null
            }
            var _proto = AppointmentDragBehavior.prototype;
            _proto.isAllDay = function(appointment) {
                return appointment.data("dxAppointmentSettings").allDay
            };
            _proto.onDragStart = function(e) {
                var itemSettings = e.itemSettings,
                    itemData = e.itemData,
                    initialPosition = e.initialPosition;
                this.initialPosition = initialPosition;
                this.appointmentInfo = {
                    appointment: itemData,
                    settings: itemSettings
                };
                this.appointments.notifyObserver("hideAppointmentTooltip")
            };
            _proto.onDragMove = function(e) {
                if (e.fromComponent !== e.toComponent) {
                    this.appointments.notifyObserver("removeDroppableCellClass")
                }
            };
            _proto.getAppointmentElement = function(e) {
                var itemElement = e.event.data && e.event.data.itemElement || e.itemElement;
                return (0, _renderer.default)(itemElement)
            };
            _proto.onDragEnd = function(e) {
                var element = this.getAppointmentElement(e);
                var rawAppointment = this.appointments._getItemData(element);
                var container = this.appointments._getAppointmentContainer(this.isAllDay(element));
                container.append(element);
                this.appointments.notifyObserver("updateAppointmentAfterDrag", {
                    event: e,
                    element: element,
                    rawAppointment: rawAppointment,
                    coordinates: this.initialPosition
                })
            };
            _proto.getItemData = function(appointmentElement) {
                var dataFromTooltip = (0, _renderer.default)(appointmentElement).data(_constants.LIST_ITEM_DATA_KEY);
                var itemDataFromTooltip = null === dataFromTooltip || void 0 === dataFromTooltip ? void 0 : dataFromTooltip.appointment;
                var itemDataFromGrid = this.appointments._getItemData(appointmentElement);
                return itemDataFromTooltip || itemDataFromGrid
            };
            _proto.getItemSettings = function(appointment) {
                var itemData = (0, _renderer.default)(appointment).data(_constants.LIST_ITEM_DATA_KEY);
                return itemData && itemData.settings || []
            };
            _proto.createDragStartHandler = function(options, appointmentDragging) {
                var _this = this;
                return function(e) {
                    e.itemData = _this.getItemData(e.itemElement);
                    e.itemSettings = _this.getItemSettings(e.itemElement);
                    appointmentDragging.onDragStart && appointmentDragging.onDragStart(e);
                    if (!e.cancel) {
                        options.onDragStart(e)
                    }
                }
            };
            _proto.createDragMoveHandler = function(options, appointmentDragging) {
                return function(e) {
                    appointmentDragging.onDragMove && appointmentDragging.onDragMove(e);
                    if (!e.cancel) {
                        options.onDragMove(e)
                    }
                }
            };
            _proto.createDragEndHandler = function(options, appointmentDragging) {
                var _this2 = this;
                return function(e) {
                    _this2.appointmentInfo = null;
                    appointmentDragging.onDragEnd && appointmentDragging.onDragEnd(e);
                    if (!e.cancel) {
                        options.onDragEnd(e);
                        if (e.fromComponent !== e.toComponent) {
                            appointmentDragging.onRemove && appointmentDragging.onRemove(e)
                        }
                    }
                }
            };
            _proto.createDropHandler = function(appointmentDragging) {
                var _this3 = this;
                return function(e) {
                    var updatedData = _this3.appointments.invoke("getUpdatedData", e.itemData);
                    e.itemData = (0, _extend.extend)({}, e.itemData, updatedData);
                    if (e.fromComponent !== e.toComponent) {
                        appointmentDragging.onAdd && appointmentDragging.onAdd(e)
                    }
                }
            };
            _proto.addTo = function(container, config) {
                var appointmentDragging = this.scheduler.option("appointmentDragging") || {};
                var options = (0, _extend.extend)({
                    component: this.scheduler,
                    contentTemplate: null,
                    filter: ".".concat(APPOINTMENT_ITEM_CLASS),
                    immediate: false,
                    onDragStart: this.onDragStart.bind(this),
                    onDragMove: this.onDragMove.bind(this),
                    onDragEnd: this.onDragEnd.bind(this)
                }, config);
                this.appointments._createComponent(container, _draggable.default, (0, _extend.extend)({}, options, appointmentDragging, {
                    onDragStart: this.createDragStartHandler(options, appointmentDragging),
                    onDragMove: this.createDragMoveHandler(options, appointmentDragging),
                    onDragEnd: this.createDragEndHandler(options, appointmentDragging),
                    onDrop: this.createDropHandler(appointmentDragging)
                }))
            };
            _proto.updateDragSource = function(appointment, settings) {
                var appointmentInfo = this.appointmentInfo;
                if (appointmentInfo || appointment) {
                    var currentAppointment = appointment || appointmentInfo.appointment;
                    var currentSettings = settings || appointmentInfo.settings;
                    this.appointments._setDragSourceAppointment(currentAppointment, currentSettings)
                }
            };
            return AppointmentDragBehavior
        }();
        exports.default = AppointmentDragBehavior;
        module.exports = exports.default
    },
    /*!**********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/base/widgetObserver.js ***!
      \**********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../../widget/ui.widget */ 16));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var WidgetObserver = function(_Widget) {
            _inheritsLoose(WidgetObserver, _Widget);

            function WidgetObserver() {
                return _Widget.apply(this, arguments) || this
            }
            var _proto = WidgetObserver.prototype;
            _proto.notifyObserver = function(subject, args) {
                var observer = this.option("observer");
                if (observer) {
                    observer.fire(subject, args)
                }
            };
            _proto.invoke = function() {
                var observer = this.option("observer");
                if (observer) {
                    return observer.fire.apply(observer, arguments)
                }
            };
            return WidgetObserver
        }(_ui.default);
        var _default = WidgetObserver;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/workspaces/ui.scheduler.virtual_scrolling.js ***!
      \********************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../../core/dom_adapter */ 11));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../../events/core/events_engine */ 5));
        var _window = __webpack_require__( /*! ../../../core/utils/window */ 7);
        var _index = __webpack_require__( /*! ../../../events/utils/index */ 8);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }
        var ROW_HEIGHT = 50;
        var CELL_WIDTH = 150;
        var MIN_SCROLL_OFFSET = 10;
        var VIRTUAL_APPOINTMENTS_RENDER_TIMEOUT = 15;
        var DOCUMENT_SCROLL_EVENT_NAMESPACE = (0, _index.addNamespace)("scroll", "dxSchedulerVirtualScrolling");
        var scrollingTypes = {
            vertical: "vertical",
            horizontal: "horizontal",
            both: "both"
        };
        var DefaultScrollingType = scrollingTypes.vertical;
        var VirtualScrollingDispatcher = function() {
            function VirtualScrollingDispatcher(workspace) {
                this._workspace = workspace;
                this._rowHeight = ROW_HEIGHT;
                this._cellWidth = CELL_WIDTH;
                this._renderer = new Renderer(this.workspace);
                this._createVirtualScrolling();
                this._attachScrollableEvents()
            }
            var _proto = VirtualScrollingDispatcher.prototype;
            _proto.calculateCoordinatesByDataAndPosition = function(cellData, position, date) {
                var workSpace = this._workspace;
                var rowIndex = position.rowIndex,
                    columnIndex = position.columnIndex;
                var startDate = cellData.startDate,
                    endDate = cellData.endDate,
                    allDay = cellData.allDay;
                var timeToScroll = date.getTime();
                var cellStartTime = startDate.getTime();
                var cellEndTime = endDate.getTime();
                var scrollInCell = allDay ? 0 : (timeToScroll - cellStartTime) / (cellEndTime - cellStartTime);
                var cellWidth = workSpace.getCellWidth();
                var top = (rowIndex + scrollInCell) * this.rowHeight;
                var left = cellWidth * columnIndex;
                if (workSpace.option("rtlEnabled")) {
                    left = workSpace.getScrollableOuterWidth() - left
                }
                return {
                    top: top,
                    left: left
                }
            };
            _proto.dispose = function() {
                if (this._onScrollHandler) {
                    _events_engine.default.off(this.document, DOCUMENT_SCROLL_EVENT_NAMESPACE, this._onScrollHandler)
                }
            };
            _proto._createVirtualScrolling = function() {
                if (this.verticalScrollingAllowed) {
                    this.verticalVirtualScrolling = new VerticalVirtualScrolling({
                        workspace: this.workspace,
                        viewportHeight: this.viewportHeight,
                        rowHeight: this.rowHeight
                    })
                }
                if (this.horizontalScrollingAllowed) {
                    this.horizontalVirtualScrolling = new HorizontalVirtualScrolling({
                        workspace: this.workspace,
                        viewportWidth: this.viewportWidth,
                        cellWidth: this.cellWidth
                    })
                }
            };
            _proto._attachScrollableEvents = function() {
                if (this.height || this.width) {
                    this._attachScrollableScroll()
                }
                if (!this.height || !this.width) {
                    this._attachWindowScroll()
                }
            };
            _proto._attachScrollableScroll = function() {
                var _this = this;
                var scrollable = this.workspace.getScrollable();
                var currentOnScroll = scrollable.option("onScroll");
                scrollable.option("onScroll", function(e) {
                    null === currentOnScroll || void 0 === currentOnScroll ? void 0 : currentOnScroll.apply(scrollable, [e]);
                    _this._process(null === e || void 0 === e ? void 0 : e.scrollOffset)
                })
            };
            _proto._attachWindowScroll = function() {
                var _this2 = this;
                var window = (0, _window.getWindow)();
                this._onScrollHandler = this.workspace._createAction(function() {
                    var scrollX = window.scrollX,
                        scrollY = window.scrollY;
                    if (scrollX >= _this2.minScrollOffset || scrollY >= _this2.minScrollOffset) {
                        _this2._process({
                            left: scrollX,
                            top: scrollY
                        })
                    }
                });
                _events_engine.default.on(this.document, DOCUMENT_SCROLL_EVENT_NAMESPACE, this._onScrollHandler)
            };
            _proto._process = function(scrollPosition) {
                if (scrollPosition) {
                    var _this$verticalVirtual, _this$horizontalVirtu;
                    var left = scrollPosition.left,
                        top = scrollPosition.top;
                    null === (_this$verticalVirtual = this.verticalVirtualScrolling) || void 0 === _this$verticalVirtual ? void 0 : _this$verticalVirtual.updateState(top);
                    null === (_this$horizontalVirtu = this.horizontalVirtualScrolling) || void 0 === _this$horizontalVirtu ? void 0 : _this$horizontalVirtu.updateState(left);
                    this.renderer.updateRender()
                }
            };
            _proto.updateDimensions = function() {
                var cellHeight = this.workspace.getCellHeight(false);
                var cellWidth = this.workspace.getCellWidth();
                var needUpdate = cellHeight !== this.rowHeight || cellWidth !== this.cellWidth;
                if (needUpdate) {
                    this.rowHeight = cellHeight;
                    this.cellWidth = cellWidth;
                    this._createVirtualScrolling();
                    this.renderer._renderDateTable()
                }
            };
            _createClass(VirtualScrollingDispatcher, [{
                key: "workspace",
                get: function() {
                    return this._workspace
                }
            }, {
                key: "renderer",
                get: function() {
                    return this._renderer
                }
            }, {
                key: "isVirtualScrolling",
                get: function() {
                    return this.workspace.isVirtualScrolling()
                }
            }, {
                key: "minScrollOffset",
                get: function() {
                    return MIN_SCROLL_OFFSET
                }
            }, {
                key: "verticalVirtualScrolling",
                get: function() {
                    return this._verticalVirtualScrolling
                },
                set: function(value) {
                    this._verticalVirtualScrolling = value
                }
            }, {
                key: "horizontalVirtualScrolling",
                get: function() {
                    return this._horizontalVirtualScrolling
                },
                set: function(value) {
                    this._horizontalVirtualScrolling = value
                }
            }, {
                key: "document",
                get: function() {
                    return _dom_adapter.default.getDocument()
                }
            }, {
                key: "height",
                get: function() {
                    return this.workspace.invoke("getOption", "height")
                }
            }, {
                key: "width",
                get: function() {
                    return this.workspace.invoke("getOption", "width")
                }
            }, {
                key: "rowHeight",
                get: function() {
                    return this._rowHeight
                },
                set: function(value) {
                    this._rowHeight = value
                }
            }, {
                key: "viewportHeight",
                get: function() {
                    return this.height ? this.workspace.$element().height() : (0, _window.getWindow)().innerHeight
                }
            }, {
                key: "cellWidth",
                get: function() {
                    return this._cellWidth
                },
                set: function(value) {
                    this._cellWidth = value
                }
            }, {
                key: "viewportWidth",
                get: function() {
                    return this.width ? this.workspace.$element().width() : (0, _window.getWindow)().innerWidth
                }
            }, {
                key: "topVirtualRowsCount",
                get: function() {
                    return this.verticalScrollingState.virtualItemCountBefore > 0 ? 1 : 0
                }
            }, {
                key: "scrollingState",
                get: function() {
                    var _this$verticalVirtual2, _this$horizontalVirtu2;
                    return {
                        vertical: null === (_this$verticalVirtual2 = this.verticalVirtualScrolling) || void 0 === _this$verticalVirtual2 ? void 0 : _this$verticalVirtual2.state,
                        horizontal: null === (_this$horizontalVirtu2 = this.horizontalVirtualScrolling) || void 0 === _this$horizontalVirtu2 ? void 0 : _this$horizontalVirtu2.state
                    }
                }
            }, {
                key: "verticalScrollingState",
                get: function() {
                    return this.scrollingState.vertical
                }
            }, {
                key: "horizontalScrollingState",
                get: function() {
                    return this.scrollingState.horizontal
                }
            }, {
                key: "renderState",
                get: function() {
                    var _this$verticalVirtual3, _this$horizontalVirtu3;
                    var verticalRenderState = (null === (_this$verticalVirtual3 = this.verticalVirtualScrolling) || void 0 === _this$verticalVirtual3 ? void 0 : _this$verticalVirtual3.getRenderState()) || {};
                    var horizontalRenderState = (null === (_this$horizontalVirtu3 = this.horizontalVirtualScrolling) || void 0 === _this$horizontalVirtu3 ? void 0 : _this$horizontalVirtu3.getRenderState()) || {};
                    return _objectSpread(_objectSpread({}, verticalRenderState), horizontalRenderState)
                }
            }, {
                key: "scrollingType",
                get: function() {
                    return this.workspace.option("scrolling.type") || DefaultScrollingType
                }
            }, {
                key: "verticalScrollingAllowed",
                get: function() {
                    return this.scrollingType === scrollingTypes.vertical || this.scrollingType === scrollingTypes.both
                }
            }, {
                key: "horizontalScrollingAllowed",
                get: function() {
                    return this.scrollingType === scrollingTypes.horizontal || this.scrollingType === scrollingTypes.both
                }
            }]);
            return VirtualScrollingDispatcher
        }();
        exports.default = VirtualScrollingDispatcher;
        var VirtualScrollingBase = function() {
            function VirtualScrollingBase(options) {
                this._workspace = options.workspace;
                this._state = this.defaultState;
                this._viewportSize = options.viewportSize;
                this._itemSize = options.itemSize;
                this.updateState(0)
            }
            var _proto2 = VirtualScrollingBase.prototype;
            _proto2.needUpdateState = function(position) {
                var _this$state = this.state,
                    prevPosition = _this$state.prevPosition,
                    startIndex = _this$state.startIndex;
                var isFirstInitialization = startIndex < 0;
                if (!isFirstInitialization && (0 === position || position === this.maxScrollPosition)) {
                    return true
                }
                var currentPosition = prevPosition;
                var currentItemsCount = Math.floor(currentPosition / this.itemSize);
                var itemsCount = Math.floor(position / this.itemSize);
                var isStartIndexChanged = Math.abs(currentItemsCount - itemsCount) >= this.outlineCount;
                return isFirstInitialization || isStartIndexChanged
            };
            _proto2._correctPosition = function(position) {
                if (position < 0) {
                    return 0
                }
                return Math.min(position, this.maxScrollPosition)
            };
            _proto2.updateState = function(position) {
                position = this._correctPosition(position);
                if (!this.needUpdateState(position)) {
                    return false
                }
                var itemsInfoBefore = this._calcItemInfoBefore(position);
                var itemsDeltaBefore = this._calcItemDeltaBefore(itemsInfoBefore);
                var _this$_calcItemInfoAf = this._calcItemInfoAfter(itemsDeltaBefore),
                    outlineCountAfter = _this$_calcItemInfoAf.outlineCountAfter,
                    virtualItemCountAfter = _this$_calcItemInfoAf.virtualItemCountAfter,
                    itemCountWithAfter = _this$_calcItemInfoAf.itemCountWithAfter;
                var virtualItemCountBefore = itemsInfoBefore.virtualItemCountBefore,
                    outlineCountBefore = itemsInfoBefore.outlineCountBefore;
                var itemCount = outlineCountBefore + itemCountWithAfter + outlineCountAfter;
                var itemCountAfter = Math.floor(position / this.itemSize);
                this.state.prevPosition = itemCountAfter * this.itemSize;
                this.state.startIndex = itemCountAfter - outlineCountBefore;
                this.state.virtualItemCountBefore = virtualItemCountBefore;
                this.state.outlineCountBefore = outlineCountBefore;
                this.state.itemCount = itemCount;
                this.state.outlineCountAfter = outlineCountAfter;
                this.state.virtualItemCountAfter = virtualItemCountAfter;
                this._updateStateCore();
                return true
            };
            _proto2._calcItemInfoBefore = function(position) {
                var virtualItemCountBefore = Math.floor(position / this.itemSize);
                var outlineCountBefore = Math.min(virtualItemCountBefore, this.outlineCount);
                virtualItemCountBefore -= outlineCountBefore;
                return {
                    virtualItemCountBefore: virtualItemCountBefore,
                    outlineCountBefore: outlineCountBefore
                }
            };
            _proto2._calcItemDeltaBefore = function(itemInfoBefore) {
                var virtualItemCountBefore = itemInfoBefore.virtualItemCountBefore,
                    outlineCountBefore = itemInfoBefore.outlineCountBefore;
                var totalItemCount = this.getTotalItemCount();
                return totalItemCount - virtualItemCountBefore - outlineCountBefore
            };
            _proto2.getTotalItemCount = function() {
                throw "getTotalItemCount method should be implemented"
            };
            _proto2.getRenderState = function() {
                throw "getRenderState method should be implemented"
            };
            _proto2._calcItemInfoAfter = function(itemsDeltaBefore) {
                var itemCountWithAfter = itemsDeltaBefore >= this.pageSize ? this.pageSize : itemsDeltaBefore;
                var virtualItemCountAfter = itemsDeltaBefore - itemCountWithAfter;
                var outlineCountAfter = virtualItemCountAfter > 0 ? Math.min(virtualItemCountAfter, this.outlineCount) : 0;
                if (virtualItemCountAfter > 0) {
                    virtualItemCountAfter -= outlineCountAfter
                }
                return {
                    virtualItemCountAfter: virtualItemCountAfter,
                    outlineCountAfter: outlineCountAfter,
                    itemCountWithAfter: itemCountWithAfter
                }
            };
            _proto2._updateStateCore = function() {
                var state = this.state;
                var virtualItemCountBefore = state.virtualItemCountBefore;
                var virtualItemCountAfter = state.virtualItemCountAfter;
                var outlineCountBefore = state.outlineCountBefore;
                var outlineCountAfter = state.outlineCountAfter;
                var prevVirtualItemSizeBefore = state.virtualItemSizeBefore;
                var prevVirtualItemSizeAfter = state.virtualItemSizeAfter;
                var prevOutlineSizeBefore = state.outlineSizeBefore;
                var prevOutlineSizeAfter = state.outlineSizeAfter;
                var virtualItemSizeBefore = this.itemSize * virtualItemCountBefore;
                var virtualItemSizeAfter = this.itemSize * virtualItemCountAfter;
                var outlineSizeBefore = this.itemSize * outlineCountBefore;
                var outlineSizeAfter = this.itemSize * outlineCountAfter;
                var prevVirtualSizeBefore = prevVirtualItemSizeBefore + prevOutlineSizeBefore;
                var virtualSizeBefore = virtualItemSizeBefore + outlineSizeBefore;
                var prevVirtualSizeAfter = prevVirtualItemSizeAfter + prevOutlineSizeAfter;
                var virtualSizeAfter = virtualItemSizeAfter + outlineSizeAfter;
                var isAppend = prevVirtualSizeBefore < virtualSizeBefore;
                var isPrepend = prevVirtualSizeAfter < virtualSizeAfter;
                var needAddItems = isAppend || isPrepend;
                if (needAddItems) {
                    state.virtualItemSizeBefore = virtualItemSizeBefore;
                    state.virtualItemSizeAfter = virtualItemSizeAfter
                }
            };
            _createClass(VirtualScrollingBase, [{
                key: "viewportSize",
                get: function() {
                    return this._viewportSize
                }
            }, {
                key: "itemSize",
                get: function() {
                    return this._itemSize
                }
            }, {
                key: "state",
                get: function() {
                    return this._state
                },
                set: function(value) {
                    this._state = value
                }
            }, {
                key: "startIndex",
                get: function() {
                    return this.state.startIndex
                }
            }, {
                key: "pageSize",
                get: function() {
                    return Math.ceil(this.viewportSize / this.itemSize)
                }
            }, {
                key: "outlineCount",
                get: function() {
                    return Math.floor(this.pageSize / 2)
                }
            }, {
                key: "workspace",
                get: function() {
                    return this._workspace
                }
            }, {
                key: "groupCount",
                get: function() {
                    return this.workspace._getGroupCount()
                }
            }, {
                key: "isVerticalGrouping",
                get: function() {
                    return this.workspace._isVerticalGroupedWorkSpace()
                }
            }, {
                key: "defaultState",
                get: function() {
                    return {
                        prevPosition: 0,
                        startIndex: -1,
                        itemCount: 0,
                        virtualItemCountBefore: 0,
                        virtualItemCountAfter: 0,
                        outlineCountBefore: 0,
                        outlineCountAfter: 0,
                        virtualItemSizeBefore: 0,
                        virtualItemSizeAfter: 0,
                        outlineSizeBefore: 0,
                        outlineSizeAfter: 0
                    }
                }
            }, {
                key: "maxScrollPosition",
                get: function() {
                    return this.getTotalItemCount() * this.itemSize - this.viewportSize
                }
            }]);
            return VirtualScrollingBase
        }();
        var VerticalVirtualScrolling = function(_VirtualScrollingBase) {
            _inheritsLoose(VerticalVirtualScrolling, _VirtualScrollingBase);

            function VerticalVirtualScrolling(options) {
                return _VirtualScrollingBase.call(this, {
                    workspace: options.workspace,
                    viewportSize: options.viewportHeight,
                    itemSize: options.rowHeight
                }) || this
            }
            var _proto3 = VerticalVirtualScrolling.prototype;
            _proto3.getTotalItemCount = function() {
                return this.workspace._getTotalRowCount(this.groupCount, this.isVerticalGrouping)
            };
            _proto3.getRenderState = function() {
                return {
                    topVirtualRowHeight: this.state.virtualItemSizeBefore,
                    bottomVirtualRowHeight: this.state.virtualItemSizeAfter,
                    startRowIndex: this.state.startIndex,
                    rowCount: this.state.itemCount,
                    startIndex: this.state.startIndex
                }
            };
            _createClass(VerticalVirtualScrolling, [{
                key: "prevTopPosition",
                get: function() {
                    return this.state.prevPosition
                }
            }, {
                key: "rowCount",
                get: function() {
                    return this.state.itemCount
                }
            }, {
                key: "topVirtualRowCount",
                get: function() {
                    return this.state.virtualItemCountBefore
                }
            }, {
                key: "bottomVirtualRowCount",
                get: function() {
                    return this.state.virtualItemCountAfter
                }
            }]);
            return VerticalVirtualScrolling
        }(VirtualScrollingBase);
        var HorizontalVirtualScrolling = function(_VirtualScrollingBase2) {
            _inheritsLoose(HorizontalVirtualScrolling, _VirtualScrollingBase2);

            function HorizontalVirtualScrolling(options) {
                return _VirtualScrollingBase2.call(this, {
                    workspace: options.workspace,
                    viewportSize: options.viewportWidth,
                    itemSize: options.cellWidth
                }) || this
            }
            var _proto4 = HorizontalVirtualScrolling.prototype;
            _proto4.getTotalItemCount = function() {
                return this.workspace._getTotalCellCount(this.groupCount, this.isVerticalGrouping)
            };
            _proto4.getRenderState = function() {
                return {
                    leftVirtualCellWidth: this.state.virtualItemSizeBefore,
                    rightVirtualCellWidth: this.state.virtualItemSizeAfter,
                    startCellIndex: this.state.startIndex,
                    cellCount: this.state.itemCount,
                    cellWidth: this.state.itemSize
                }
            };
            return HorizontalVirtualScrolling
        }(VirtualScrollingBase);
        var Renderer = function() {
            function Renderer(workspace) {
                this._workspace = workspace;
                this._renderAppointmentTimeout = null
            }
            var _proto5 = Renderer.prototype;
            _proto5.getRenderTimeout = function() {
                return VIRTUAL_APPOINTMENTS_RENDER_TIMEOUT
            };
            _proto5.updateRender = function() {
                this._renderDateTable();
                this._renderAppointments()
            };
            _proto5._renderDateTable = function() {
                this.workspace.renderRWorkspace(false)
            };
            _proto5._renderAppointments = function() {
                var _this3 = this;
                var renderTimeout = this.getRenderTimeout();
                if (renderTimeout >= 0) {
                    clearTimeout(this._renderAppointmentTimeout);
                    this._renderAppointmentTimeout = setTimeout(function() {
                        return _this3.workspace.updateAppointments()
                    }, renderTimeout)
                } else {
                    this.workspace.updateAppointments()
                }
            };
            _createClass(Renderer, [{
                key: "workspace",
                get: function() {
                    return this._workspace
                }
            }]);
            return Renderer
        }();
        module.exports = exports.default
    },
    /*!********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/workspaces/view_data_provider.js ***!
      \********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../../core/utils/date */ 19));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }
        var ViewDataGenerator = function() {
            function ViewDataGenerator(workspace) {
                this.workspace = workspace
            }
            var _proto = ViewDataGenerator.prototype;
            _proto._getCompleteViewDataMap = function(options) {
                var rowCount = options.nonVirtualRowCount,
                    cellCount = options.cellCount,
                    verticalGroupCount = options.verticalGroupCount;
                var viewDataMap = [];
                for (var groupIndex = 0; groupIndex < verticalGroupCount; groupIndex += 1) {
                    var allDayPanelData = this._generateAllDayPanelData(options, groupIndex, rowCount, cellCount);
                    var viewCellsData = this._generateViewCellsData(options, rowCount, 0, rowCount * groupIndex);
                    allDayPanelData && viewDataMap.push(allDayPanelData);
                    viewDataMap.push.apply(viewDataMap, _toConsumableArray(viewCellsData))
                }
                return viewDataMap
            };
            _proto._generateViewDataMap = function(completeViewDataMap, options) {
                var startRowIndex = options.startRowIndex,
                    rowCount = options.rowCount;
                var isVerticalGrouping = this.workspace._isVerticalGroupedWorkSpace();
                var showAllDayPanel = this.workspace._isShowAllDayPanel();
                var indexDifference = isVerticalGrouping || !showAllDayPanel ? 0 : 1;
                var correctedStartRowIndex = startRowIndex + indexDifference;
                return completeViewDataMap.slice(correctedStartRowIndex, correctedStartRowIndex + rowCount).map(function(cellsRow, rowIndex) {
                    return cellsRow.map(function(cellData, cellIndex) {
                        return {
                            cellData: cellData,
                            position: {
                                rowIndex: rowIndex,
                                cellIndex: cellIndex
                            }
                        }
                    })
                })
            };
            _proto._getViewDataFromMap = function(viewDataMap, completeViewDataMap, options) {
                var topVirtualRowHeight = options.topVirtualRowHeight,
                    bottomVirtualRowHeight = options.bottomVirtualRowHeight,
                    cellCountInGroupRow = options.cellCountInGroupRow;
                var isGroupedAllDayPanel = this.workspace.isGroupedAllDayPanel();
                var _viewDataMap$reduce = viewDataMap.reduce(function(_ref, cellsRow) {
                        var previousGroupIndex = _ref.previousGroupIndex,
                            previousGroupedData = _ref.previousGroupedData;
                        var cellDataRow = cellsRow.map(function(_ref2) {
                            var cellData = _ref2.cellData;
                            return cellData
                        });
                        var firstCell = cellDataRow[0];
                        var isAllDayRow = firstCell.allDay;
                        var currentGroupIndex = firstCell.groupIndex;
                        if (currentGroupIndex !== previousGroupIndex) {
                            previousGroupedData.push({
                                dateTable: [],
                                isGroupedAllDayPanel: isGroupedAllDayPanel,
                                groupIndex: currentGroupIndex
                            })
                        }
                        if (isAllDayRow) {
                            previousGroupedData[previousGroupedData.length - 1].allDayPanel = cellDataRow
                        } else {
                            previousGroupedData[previousGroupedData.length - 1].dateTable.push(cellDataRow)
                        }
                        return {
                            previousGroupedData: previousGroupedData,
                            previousGroupIndex: currentGroupIndex
                        }
                    }, {
                        previousGroupIndex: -1,
                        previousGroupedData: []
                    }),
                    groupedData = _viewDataMap$reduce.previousGroupedData;
                var isVirtualScrolling = this.workspace.isVirtualScrolling();
                var isVerticalGrouping = this.workspace._isVerticalGroupedWorkSpace();
                var showAllDayPanel = this.workspace._isShowAllDayPanel();
                if (!isVerticalGrouping && showAllDayPanel) {
                    groupedData[0].allDayPanel = completeViewDataMap[0]
                }
                return {
                    groupedData: groupedData,
                    isVirtual: isVirtualScrolling,
                    topVirtualRowHeight: topVirtualRowHeight,
                    bottomVirtualRowHeight: bottomVirtualRowHeight,
                    cellCountInGroupRow: cellCountInGroupRow
                }
            };
            _proto._generateViewCellsData = function(options, renderRowCount, startRowIndex, rowOffset) {
                var cellCount = options.cellCount,
                    cellDataGetters = options.cellDataGetters,
                    rowCountInGroup = options.rowCountInGroup;
                var viewCellsData = [];
                for (var i = 0; i < renderRowCount; ++i) {
                    var rowIndex = startRowIndex + rowOffset + i;
                    var rowIndexInGroup = rowIndex % rowCountInGroup;
                    viewCellsData.push(this._generateCellsRow(options, cellDataGetters, rowIndex, cellCount, rowIndexInGroup))
                }
                return viewCellsData
            };
            _proto._generateAllDayPanelData = function(options, groupIndex, rowCount, cellCount) {
                var workSpace = this.workspace;
                if (!workSpace._isShowAllDayPanel()) {
                    return null
                }
                var rowIndex = Math.max(groupIndex * rowCount, 0);
                return this._generateCellsRow(options, [workSpace._getAllDayCellData.bind(workSpace)], rowIndex, cellCount, 0, groupIndex)
            };
            _proto._generateCellsRow = function(options, cellDataGetters, rowIndex, cellCount, rowIndexInGroup, groupIndex) {
                var _this = this;
                var cellsRow = [];
                var horizontalGroupCount = options.horizontalGroupCount,
                    groupOrientation = options.groupOrientation,
                    rowCountInGroup = options.rowCountInGroup,
                    cellCountInGroupRow = options.cellCountInGroupRow,
                    groupCount = options.groupCount;
                var _loop = function(columnIndex) {
                    var cellDataValue = cellDataGetters.reduce(function(data, getter) {
                        return _objectSpread(_objectSpread({}, data), getter(void 0, rowIndex, columnIndex, groupIndex).value)
                    }, {});
                    cellDataValue.index = _this._calculateCellIndex(horizontalGroupCount, groupOrientation, _this._workspace.isGroupedByDate(), rowIndexInGroup, columnIndex, cellCount);
                    cellDataValue.isFirstGroupCell = _this._isFirstGroupCell(rowIndex, columnIndex, rowCountInGroup, cellCountInGroupRow, groupCount);
                    cellDataValue.isLastGroupCell = _this._isLastGroupCell(rowIndex, columnIndex, rowCountInGroup, cellCountInGroupRow, groupCount);
                    cellDataValue.key = _this._getKeyByRowAndColumn(rowIndex, columnIndex, cellCount);
                    cellsRow.push(cellDataValue)
                };
                for (var columnIndex = 0; columnIndex < cellCount; ++columnIndex) {
                    _loop(columnIndex)
                }
                return cellsRow
            };
            _proto._calculateCellIndex = function(horizontalGroupCount, groupOrientation, isGroupedByDate, rowIndex, columnIndex, columnsNumber) {
                var groupCount = horizontalGroupCount || 1;
                var index = rowIndex * columnsNumber + columnIndex;
                var columnsInGroup = columnsNumber / groupCount;
                if ("horizontal" === groupOrientation) {
                    var columnIndexInCurrentGroup = columnIndex % columnsInGroup;
                    if (isGroupedByDate) {
                        columnIndexInCurrentGroup = Math.floor(columnIndex / groupCount)
                    }
                    index = rowIndex * columnsInGroup + columnIndexInCurrentGroup
                }
                return index
            };
            _proto._getKeyByRowAndColumn = function(rowIndex, columnIndex, cellCount) {
                return rowIndex * cellCount + columnIndex
            };
            _proto.generateGroupedDataMap = function(viewDataMap) {
                var _viewDataMap$reduce2 = viewDataMap.reduce(function(previousOptions, cellsRow) {
                        var previousGroupedDataMap = previousOptions.previousGroupedDataMap,
                            previousRowIndex = previousOptions.previousRowIndex,
                            previousGroupIndex = previousOptions.previousGroupIndex;
                        var currentGroupIndex = cellsRow[0].cellData.groupIndex;
                        var currentRowIndex = currentGroupIndex === previousGroupIndex ? previousRowIndex + 1 : 0;
                        cellsRow.forEach(function(cell) {
                            var groupIndex = cell.cellData.groupIndex;
                            if (!previousGroupedDataMap[groupIndex]) {
                                previousGroupedDataMap[groupIndex] = []
                            }
                            if (!previousGroupedDataMap[groupIndex][currentRowIndex]) {
                                previousGroupedDataMap[groupIndex][currentRowIndex] = []
                            }
                            previousGroupedDataMap[groupIndex][currentRowIndex].push(cell)
                        });
                        return {
                            previousGroupedDataMap: previousGroupedDataMap,
                            previousRowIndex: currentRowIndex,
                            previousGroupIndex: currentGroupIndex
                        }
                    }, {
                        previousGroupedDataMap: [],
                        previousRowIndex: -1,
                        previousGroupIndex: -1
                    }),
                    groupedDataMap = _viewDataMap$reduce2.previousGroupedDataMap;
                return groupedDataMap
            };
            _proto._isFirstGroupCell = function(rowIndex, columnIndex, singleGroupRowCount, singleGroupColumnCount, groupCount) {
                if (this.workspace.isGroupedByDate()) {
                    return columnIndex % groupCount === 0
                }
                if (this.workspace._isHorizontalGroupedWorkSpace() || 0 === groupCount) {
                    return columnIndex % singleGroupColumnCount === 0
                }
                return rowIndex % singleGroupRowCount === 0
            };
            _proto._isLastGroupCell = function(rowIndex, columnIndex, singleGroupRowCount, singleGroupColumnCount, groupCount) {
                if (this.workspace.isGroupedByDate()) {
                    return (columnIndex + 1) % groupCount === 0
                }
                if (this.workspace._isHorizontalGroupedWorkSpace() || 0 === groupCount) {
                    return (columnIndex + 1) % singleGroupColumnCount === 0
                }
                return (rowIndex + 1) % singleGroupRowCount === 0
            };
            _createClass(ViewDataGenerator, [{
                key: "workspace",
                get: function() {
                    return this._workspace
                },
                set: function(value) {
                    this._workspace = value
                }
            }]);
            return ViewDataGenerator
        }();
        var ViewDataProvider = function() {
            function ViewDataProvider(workspace) {
                this._viewDataGenerator = null;
                this._viewData = [];
                this._completeViewDataMap = [];
                this._completeGroupedViewDataMap = [];
                this._viewDataMap = [];
                this._groupedDataMap = [];
                this._workspace = workspace
            }
            var _proto2 = ViewDataProvider.prototype;
            _proto2.update = function(isGenerateNewViewData) {
                var viewDataGenerator = this.viewDataGenerator,
                    _workspace = this._workspace;
                var renderOptions = _workspace.generateRenderOptions();
                if (isGenerateNewViewData) {
                    this.completeViewDataMap = viewDataGenerator._getCompleteViewDataMap(renderOptions)
                }
                this.viewDataMap = viewDataGenerator._generateViewDataMap(this.completeViewDataMap, renderOptions);
                this.viewData = viewDataGenerator._getViewDataFromMap(this.viewDataMap, this.completeViewDataMap, renderOptions);
                this.groupedDataMap = viewDataGenerator.generateGroupedDataMap(this.viewDataMap)
            };
            _proto2.getStartDate = function() {
                var groupedData = this.viewData.groupedData;
                var dateTable = groupedData[0].dateTable;
                return dateTable[0][0].startDate
            };
            _proto2.getGroupStartDate = function(groupIndex) {
                var _this$getGroupData = this.getGroupData(groupIndex),
                    dateTable = _this$getGroupData.dateTable;
                return dateTable[0][0].startDate
            };
            _proto2.getGroupEndDate = function(groupIndex) {
                var _this$getGroupData2 = this.getGroupData(groupIndex),
                    dateTable = _this$getGroupData2.dateTable;
                var lastRowIndex = dateTable.length - 1;
                var lastCellIndex = dateTable[lastRowIndex].length - 1;
                return dateTable[lastRowIndex][lastCellIndex].endDate
            };
            _proto2.findGroupCellStartDate = function(groupIndex, startDate, endDate, isAllDay) {
                if (isAllDay) {
                    return this.findAllDayGroupCellStartDate(groupIndex, startDate)
                }
                var _this$getGroupData3 = this.getGroupData(groupIndex),
                    dateTable = _this$getGroupData3.dateTable;
                if (!dateTable.length) {
                    return
                }
                for (var i = 0; i < dateTable[0].length; ++i) {
                    var cell = dateTable[0][i];
                    var lastRowIndex = dateTable.length - 1;
                    if (_date.default.sameDate(cell.startDate, startDate)) {
                        var _lastCell;
                        var lastCell = dateTable[lastRowIndex][i];
                        if (lastCell.endDate <= startDate) {
                            if (endDate.getDate() > startDate.getDate()) {
                                cell = dateTable[0][i + 1];
                                lastCell = dateTable[lastRowIndex][i + 1]
                            }
                        }
                        if ((null === (_lastCell = lastCell) || void 0 === _lastCell ? void 0 : _lastCell.endDate) > startDate) {
                            return cell.startDate
                        }
                    }
                }
            };
            _proto2.findAllDayGroupCellStartDate = function(groupIndex, startDate) {
                var groupStartDate = this.getGroupStartDate(groupIndex);
                return groupStartDate > startDate ? groupStartDate : startDate
            };
            _proto2.getCellsGroup = function(groupIndex) {
                var _this$getGroupData4 = this.getGroupData(groupIndex),
                    dateTable = _this$getGroupData4.dateTable;
                return dateTable[0][0].groups
            };
            _proto2.getCellData = function(rowIndex, cellIndex, isAllDay) {
                if (isAllDay && !this._workspace._isVerticalGroupedWorkSpace()) {
                    return this._viewData.groupedData[0].allDayPanel[cellIndex]
                }
                var cellData = this.viewDataMap[rowIndex][cellIndex].cellData;
                return cellData
            };
            _proto2.getCellsByGroupIndexAndAllDay = function(groupIndex, allDay) {
                var workspace = this._workspace;
                var rowsPerGroup = workspace._getRowCountWithAllDayRows();
                var isVerticalGrouping = workspace._isVerticalGroupedWorkSpace();
                var isShowAllDayPanel = workspace._isShowAllDayPanel();
                var firstRowInGroup = isVerticalGrouping ? groupIndex * rowsPerGroup : 0;
                var lastRowInGroup = isVerticalGrouping ? (groupIndex + 1) * rowsPerGroup - 1 : rowsPerGroup;
                var correctedFirstRow = isShowAllDayPanel && !allDay ? firstRowInGroup + 1 : firstRowInGroup;
                var correctedLastRow = allDay ? correctedFirstRow : lastRowInGroup;
                return this.completeViewDataMap.slice(correctedFirstRow, correctedLastRow + 1).map(function(row) {
                    return row.filter(function(_ref3) {
                        var currentGroupIndex = _ref3.groupIndex;
                        return groupIndex === currentGroupIndex
                    })
                })
            };
            _proto2.findCellPositionInMap = function(groupIndex, startDate, isAllDay) {
                var startTime = isAllDay ? _date.default.trimTime(startDate).getTime() : startDate.getTime();
                var isStartTimeInCell = function(cellData) {
                    var cellStartTime = cellData.startDate.getTime();
                    var cellEndTime = cellData.endDate.getTime();
                    return isAllDay ? cellData.allDay && startTime >= cellStartTime && startTime <= cellEndTime : startTime >= cellStartTime && startTime < cellEndTime
                };
                var rows = isAllDay && !this._workspace._isVerticalGroupedWorkSpace() ? [this.completeViewDataMap[0].map(function(cell, index) {
                    return {
                        cellData: cell,
                        position: {
                            cellIndex: index,
                            rowIndex: 0
                        }
                    }
                })] : this.groupedDataMap[groupIndex] || [];
                for (var rowIndex = 0; rowIndex < rows.length; ++rowIndex) {
                    var row = rows[rowIndex];
                    for (var cellIndex = 0; cellIndex < row.length; ++cellIndex) {
                        var cell = row[cellIndex];
                        var cellData = cell.cellData;
                        if (cellData.groupIndex === groupIndex) {
                            if (isStartTimeInCell(cellData)) {
                                return cell.position
                            }
                        }
                    }
                }
                return
            };
            _proto2.getGroupIndices = function() {
                var groupedData = this.viewData.groupedData;
                return groupedData.map(function(_ref4) {
                    var groupIndex = _ref4.groupIndex;
                    return groupIndex
                })
            };
            _proto2._getLastGroupRow = function(groupIndex) {
                var group = this.groupedDataMap[groupIndex];
                var lastIndex = group.length - 1;
                return group[lastIndex]
            };
            _proto2.getLasGroupCellPosition = function(groupIndex) {
                var groupRow = this._getLastGroupRow(groupIndex);
                return groupRow[0].position
            };
            _proto2.getLasGroupCellIndex = function(groupIndex) {
                var group = this.groupedDataMap[groupIndex];
                return group.length - 1
            };
            _proto2.getRowCountInGroup = function(groupIndex) {
                var groupRow = this._getLastGroupRow(groupIndex);
                var cellAmount = groupRow.length;
                var lastCellData = groupRow[cellAmount - 1].cellData;
                var lastCellIndex = lastCellData.index;
                return (lastCellIndex + 1) / groupRow.length
            };
            _proto2.getGroupData = function(groupIndex) {
                var groupedData = this.viewData.groupedData;
                return groupedData.filter(function(item) {
                    return item.groupIndex === groupIndex
                })[0]
            };
            _proto2.isGroupIntersectDateInterval = function(groupIndex, startDate, endDate) {
                var groupStartDate = this.getGroupStartDate(groupIndex);
                var groupEndDate = this.getGroupEndDate(groupIndex);
                return startDate < groupEndDate && endDate > groupStartDate
            };
            _proto2.findGlobalCellPosition = function(date) {
                var groupIndex = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                var allDay = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : false;
                var completeViewDataMap = this.completeViewDataMap,
                    workspace = this._workspace;
                var showAllDayPanel = workspace._isShowAllDayPanel();
                var isVerticalGroupOrientation = workspace._isVerticalGroupedWorkSpace();
                for (var rowIndex = 0; rowIndex < completeViewDataMap.length; rowIndex += 1) {
                    var currentRow = completeViewDataMap[rowIndex];
                    for (var columnIndex = 0; columnIndex < currentRow.length; columnIndex += 1) {
                        var cellData = currentRow[columnIndex];
                        var currentStartDate = cellData.startDate,
                            currentEndDate = cellData.endDate,
                            currentGroupIndex = cellData.groupIndex,
                            currentAllDay = cellData.allDay;
                        if (groupIndex === currentGroupIndex && allDay === currentAllDay && this._compareDatesAndAllDay(date, currentStartDate, currentEndDate, allDay)) {
                            return {
                                position: {
                                    columnIndex: columnIndex,
                                    rowIndex: showAllDayPanel && !isVerticalGroupOrientation ? rowIndex - 1 : rowIndex
                                },
                                cellData: cellData
                            }
                        }
                    }
                }
            };
            _proto2._compareDatesAndAllDay = function(date, cellStartDate, cellEndDate, allDay) {
                var time = date.getTime();
                var trimmedTime = _date.default.trimTime(date).getTime();
                var cellStartTime = cellStartDate.getTime();
                var cellEndTime = cellEndDate.getTime();
                return !allDay && time >= cellStartTime && time < cellEndTime || allDay && trimmedTime === cellStartTime
            };
            _createClass(ViewDataProvider, [{
                key: "viewDataGenerator",
                get: function() {
                    if (!this._viewDataGenerator) {
                        this._viewDataGenerator = new ViewDataGenerator(this._workspace)
                    }
                    return this._viewDataGenerator
                }
            }, {
                key: "completeViewDataMap",
                get: function() {
                    return this._completeViewDataMap
                },
                set: function(value) {
                    this._completeViewDataMap = value
                }
            }, {
                key: "completeGroupedViewDataMap",
                get: function() {
                    return this._completeGroupedViewDataMap
                },
                set: function(value) {
                    this._completeGroupedViewDataMap = value
                }
            }, {
                key: "viewData",
                get: function() {
                    return this._viewData
                },
                set: function(value) {
                    this._viewData = value
                }
            }, {
                key: "viewDataMap",
                get: function() {
                    return this._viewDataMap
                },
                set: function(value) {
                    this._viewDataMap = value
                }
            }, {
                key: "groupedDataMap",
                get: function() {
                    return this._groupedDataMap
                },
                set: function(value) {
                    this._groupedDataMap = value
                }
            }]);
            return ViewDataProvider
        }();
        exports.default = ViewDataProvider;
        module.exports = exports.default
    },
    /*!***************************************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/ui/scheduler/workspaces/base/date_table/all_day_panel/layout.j.js ***!
      \***************************************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../../../../../../core/component_registrator */ 9));
        var _component = _interopRequireDefault(__webpack_require__( /*! ../../../../../../preact_wrapper/component */ 184));
        var _layout = __webpack_require__( /*! ./layout */ 829);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var AllDayPanelLayout = function(_BaseComponent) {
            _inheritsLoose(AllDayPanelLayout, _BaseComponent);

            function AllDayPanelLayout() {
                return _BaseComponent.apply(this, arguments) || this
            }
            var _proto = AllDayPanelLayout.prototype;
            _proto.getProps = function() {
                var props = _BaseComponent.prototype.getProps.call(this);
                props.dataCellTemplate = this._createTemplateComponent(props, props.dataCellTemplate);
                return props
            };
            _createClass(AllDayPanelLayout, [{
                key: "_propsInfo",
                get: function() {
                    return {
                        twoWay: [],
                        allowNull: [],
                        elements: []
                    }
                }
            }, {
                key: "_viewComponent",
                get: function() {
                    return _layout.AllDayPanelLayout
                }
            }]);
            return AllDayPanelLayout
        }(_component.default);
        exports.default = AllDayPanelLayout;
        (0, _component_registrator.default)("dxAllDayPanelLayout", AllDayPanelLayout);
        module.exports = exports.default
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/preact_wrapper/utils.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.removeDifferentElements = void 0;
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var removeDifferentElements = function($children, $newChildren) {
            (0, _iterator.each)($newChildren, function(__, element) {
                var hasComponent = false;
                (0, _iterator.each)($children, function(_, oldElement) {
                    if (element === oldElement) {
                        hasComponent = true
                    }
                });
                if (!hasComponent && element.parentNode) {
                    element.parentNode.removeChild(element)
                }
            })
        };
        exports.removeDifferentElements = removeDifferentElements
    },
    /*!*************************************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/ui/scheduler/workspaces/base/date_table/all_day_panel/layout.js ***!
      \*************************************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.AllDayPanelLayout = AllDayPanelLayout;
        exports.AllDayPanelLayoutProps = exports.viewFunction = void 0;
        var _combine_classes = __webpack_require__( /*! ../../../../../../utils/combine_classes */ 222);
        var _table = __webpack_require__( /*! ../../table */ 301);
        var _table_body = __webpack_require__( /*! ./table_body */ 445);
        var _layout_props = __webpack_require__( /*! ../../layout_props */ 161);
        var _const = __webpack_require__( /*! ../../../const */ 834);
        var Preact = _interopRequireWildcard(__webpack_require__( /*! preact */ 50));
        var _hooks = __webpack_require__( /*! preact/hooks */ 53);

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function _objectWithoutProperties(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = _objectWithoutPropertiesLoose(source, excluded);
            var key, i;
            if (Object.getOwnPropertySymbols) {
                var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
                for (i = 0; i < sourceSymbolKeys.length; i++) {
                    key = sourceSymbolKeys[i];
                    if (excluded.indexOf(key) >= 0) {
                        continue
                    }
                    if (!Object.prototype.propertyIsEnumerable.call(source, key)) {
                        continue
                    }
                    target[key] = source[key]
                }
            }
            return target
        }

        function _objectWithoutPropertiesLoose(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = {};
            var sourceKeys = Object.keys(source);
            var key, i;
            for (i = 0; i < sourceKeys.length; i++) {
                key = sourceKeys[i];
                if (excluded.indexOf(key) >= 0) {
                    continue
                }
                target[key] = source[key]
            }
            return target
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function _extends() {
            _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key]
                        }
                    }
                }
                return target
            };
            return _extends.apply(this, arguments)
        }
        var viewFunction = function(viewModel) {
            return Preact.h("div", _extends({}, viewModel.restAttributes, {
                className: viewModel.classes
            }), viewModel.props.visible && Preact.h(_table.Table, {
                className: "dx-scheduler-all-day-table",
                height: viewModel.emptyTableHeight
            }, Preact.h(_table_body.AllDayPanelTableBody, {
                viewData: viewModel.allDayPanelData,
                dataCellTemplate: viewModel.props.dataCellTemplate
            })))
        };
        exports.viewFunction = viewFunction;
        var AllDayPanelLayoutProps = _objectSpread(_objectSpread({}, _layout_props.LayoutProps), {}, {
            className: "",
            visible: true
        });
        exports.AllDayPanelLayoutProps = AllDayPanelLayoutProps;
        var getTemplate = function(TemplateProp) {
            return TemplateProp && (TemplateProp.defaultProps ? function(props) {
                return Preact.h(TemplateProp, _extends({}, props))
            } : TemplateProp)
        };

        function AllDayPanelLayout(props) {
            var __allDayPanelData = (0, _hooks.useCallback)(function() {
                return props.viewData.groupedData[0].allDayPanel
            }, [props.viewData]);
            var __emptyTableHeight = (0, _hooks.useCallback)(function() {
                return __allDayPanelData() ? void 0 : _const.DefaultSizes.allDayPanelHeight
            }, [props.viewData]);
            var __classes = (0, _hooks.useCallback)(function() {
                return (0, _combine_classes.combineClasses)(_defineProperty({
                    "dx-scheduler-all-day-panel": true,
                    "dx-hidden": !props.visible
                }, props.className, !!props.className))
            }, [props.visible, props.className]);
            var __restAttributes = (0, _hooks.useCallback)(function() {
                var restProps = (props.className, props.dataCellTemplate, props.groupOrientation, props.viewData, props.visible, _objectWithoutProperties(props, ["className", "dataCellTemplate", "groupOrientation", "viewData", "visible"]));
                return restProps
            }, [props]);
            return viewFunction({
                props: _objectSpread(_objectSpread({}, props), {}, {
                    dataCellTemplate: getTemplate(props.dataCellTemplate)
                }),
                allDayPanelData: __allDayPanelData(),
                emptyTableHeight: __emptyTableHeight(),
                classes: __classes(),
                restAttributes: __restAttributes()
            })
        }
        AllDayPanelLayout.defaultProps = _objectSpread({}, AllDayPanelLayoutProps)
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/ui/scheduler/consts.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.HORIZONTAL_GROUP_ORIENTATION = exports.VERTICAL_GROUP_ORIENTATION = void 0;
        var VERTICAL_GROUP_ORIENTATION = "vertical";
        exports.VERTICAL_GROUP_ORIENTATION = VERTICAL_GROUP_ORIENTATION;
        var HORIZONTAL_GROUP_ORIENTATION = "horizontal";
        exports.HORIZONTAL_GROUP_ORIENTATION = HORIZONTAL_GROUP_ORIENTATION
    },
    /*!*****************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/ui/scheduler/workspaces/base/virtual-row.js ***!
      \*****************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.VirtualRow = VirtualRow;
        exports.VirtualRowProps = exports.viewFunction = void 0;
        var _utils = __webpack_require__( /*! ../utils */ 185);
        var _row = __webpack_require__( /*! ./row */ 223);
        var _virtualCell = __webpack_require__( /*! ./virtual-cell */ 832);
        var Preact = _interopRequireWildcard(__webpack_require__( /*! preact */ 50));
        var _hooks = __webpack_require__( /*! preact/hooks */ 53);

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function _objectWithoutProperties(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = _objectWithoutPropertiesLoose(source, excluded);
            var key, i;
            if (Object.getOwnPropertySymbols) {
                var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
                for (i = 0; i < sourceSymbolKeys.length; i++) {
                    key = sourceSymbolKeys[i];
                    if (excluded.indexOf(key) >= 0) {
                        continue
                    }
                    if (!Object.prototype.propertyIsEnumerable.call(source, key)) {
                        continue
                    }
                    target[key] = source[key]
                }
            }
            return target
        }

        function _objectWithoutPropertiesLoose(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = {};
            var sourceKeys = Object.keys(source);
            var key, i;
            for (i = 0; i < sourceKeys.length; i++) {
                key = sourceKeys[i];
                if (excluded.indexOf(key) >= 0) {
                    continue
                }
                target[key] = source[key]
            }
            return target
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function _extends() {
            _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key]
                        }
                    }
                }
                return target
            };
            return _extends.apply(this, arguments)
        }
        var viewFunction = function(viewModel) {
            return Preact.h(_row.Row, _extends({}, viewModel.restAttributes, {
                style: viewModel.style,
                className: viewModel.classes
            }), viewModel.virtualCells.map(function(_, index) {
                return Preact.h(_virtualCell.VirtualCell, {
                    key: index.toString()
                })
            }))
        };
        exports.viewFunction = viewFunction;
        var VirtualRowProps = _objectSpread(_objectSpread({}, _row.RowProps), {}, {
            cellsCount: 1
        });
        exports.VirtualRowProps = VirtualRowProps;

        function VirtualRow(props) {
            var __style = (0, _hooks.useCallback)(function() {
                var height = props.height;
                var _restAttributes = __restAttributes(),
                    style = _restAttributes.style;
                return (0, _utils.addHeightToStyle)(height, style)
            }, [props.height]);
            var __classes = (0, _hooks.useCallback)(function() {
                var className = props.className;
                return "dx-scheduler-virtual-row ".concat(className)
            }, [props.className]);
            var __virtualCells = (0, _hooks.useCallback)(function() {
                var cellsCount = props.cellsCount;
                return _toConsumableArray(Array(cellsCount))
            }, [props.cellsCount]);
            var __restAttributes = (0, _hooks.useCallback)(function() {
                var restProps = (props.cellsCount, props.children, props.className, props.height, _objectWithoutProperties(props, ["cellsCount", "children", "className", "height"]));
                return restProps
            }, [props]);
            return viewFunction({
                props: _objectSpread({}, props),
                style: __style(),
                classes: __classes(),
                virtualCells: __virtualCells(),
                restAttributes: __restAttributes()
            })
        }
        VirtualRow.defaultProps = _objectSpread({}, VirtualRowProps)
    },
    /*!******************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/ui/scheduler/workspaces/base/virtual-cell.js ***!
      \******************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.VirtualCell = VirtualCell;
        exports.VirtualCellProps = exports.viewFunction = void 0;
        var Preact = _interopRequireWildcard(__webpack_require__( /*! preact */ 50));
        var _hooks = __webpack_require__( /*! preact/hooks */ 53);

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function _objectWithoutProperties(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = _objectWithoutPropertiesLoose(source, excluded);
            var key, i;
            if (Object.getOwnPropertySymbols) {
                var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
                for (i = 0; i < sourceSymbolKeys.length; i++) {
                    key = sourceSymbolKeys[i];
                    if (excluded.indexOf(key) >= 0) {
                        continue
                    }
                    if (!Object.prototype.propertyIsEnumerable.call(source, key)) {
                        continue
                    }
                    target[key] = source[key]
                }
            }
            return target
        }

        function _objectWithoutPropertiesLoose(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = {};
            var sourceKeys = Object.keys(source);
            var key, i;
            for (i = 0; i < sourceKeys.length; i++) {
                key = sourceKeys[i];
                if (excluded.indexOf(key) >= 0) {
                    continue
                }
                target[key] = source[key]
            }
            return target
        }

        function _extends() {
            _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key]
                        }
                    }
                }
                return target
            };
            return _extends.apply(this, arguments)
        }
        var viewFunction = function(viewModel) {
            return Preact.h("td", _extends({}, viewModel.restAttributes, {
                className: "dx-scheduler-virtual-cell ".concat(viewModel.props.className)
            }))
        };
        exports.viewFunction = viewFunction;
        var VirtualCellProps = {
            className: ""
        };
        exports.VirtualCellProps = VirtualCellProps;

        function VirtualCell(props) {
            var __restAttributes = (0, _hooks.useCallback)(function() {
                var restProps = (props.className, _objectWithoutProperties(props, ["className"]));
                return restProps
            }, [props]);
            return viewFunction({
                props: _objectSpread({}, props),
                restAttributes: __restAttributes()
            })
        }
        VirtualCell.defaultProps = _objectSpread({}, VirtualCellProps)
    },
    /*!***********************************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/ui/scheduler/workspaces/base/date_table/all_day_panel/cell.js ***!
      \***********************************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.AllDayPanelCell = AllDayPanelCell;
        exports.viewFunction = void 0;
        var _cell = __webpack_require__( /*! ../cell */ 302);
        var Preact = _interopRequireWildcard(__webpack_require__( /*! preact */ 50));
        var _hooks = __webpack_require__( /*! preact/hooks */ 53);

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function _objectWithoutProperties(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = _objectWithoutPropertiesLoose(source, excluded);
            var key, i;
            if (Object.getOwnPropertySymbols) {
                var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
                for (i = 0; i < sourceSymbolKeys.length; i++) {
                    key = sourceSymbolKeys[i];
                    if (excluded.indexOf(key) >= 0) {
                        continue
                    }
                    if (!Object.prototype.propertyIsEnumerable.call(source, key)) {
                        continue
                    }
                    target[key] = source[key]
                }
            }
            return target
        }

        function _objectWithoutPropertiesLoose(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = {};
            var sourceKeys = Object.keys(source);
            var key, i;
            for (i = 0; i < sourceKeys.length; i++) {
                key = sourceKeys[i];
                if (excluded.indexOf(key) >= 0) {
                    continue
                }
                target[key] = source[key]
            }
            return target
        }

        function _extends() {
            _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key]
                        }
                    }
                }
                return target
            };
            return _extends.apply(this, arguments)
        }
        var viewFunction = function(viewModel) {
            return Preact.h(_cell.DateTableCellBase, _extends({}, viewModel.restAttributes, {
                className: "dx-scheduler-all-day-table-cell ".concat(viewModel.props.className),
                startDate: viewModel.props.startDate,
                endDate: viewModel.props.endDate,
                groups: viewModel.props.groups,
                groupIndex: viewModel.props.groupIndex,
                allDay: true,
                isFirstGroupCell: viewModel.props.isFirstGroupCell,
                isLastGroupCell: viewModel.props.isLastGroupCell,
                index: viewModel.props.index,
                dataCellTemplate: viewModel.props.dataCellTemplate
            }))
        };
        exports.viewFunction = viewFunction;
        var getTemplate = function(TemplateProp) {
            return TemplateProp && (TemplateProp.defaultProps ? function(props) {
                return Preact.h(TemplateProp, _extends({}, props))
            } : TemplateProp)
        };

        function AllDayPanelCell(props) {
            var __restAttributes = (0, _hooks.useCallback)(function() {
                var restProps = (props.allDay, props.children, props.className, props.contentTemplate, props.contentTemplateProps, props.dataCellTemplate, props.endDate, props.groupIndex, props.groups, props.index, props.isFirstGroupCell, props.isLastGroupCell, props.startDate, props.text, _objectWithoutProperties(props, ["allDay", "children", "className", "contentTemplate", "contentTemplateProps", "dataCellTemplate", "endDate", "groupIndex", "groups", "index", "isFirstGroupCell", "isLastGroupCell", "startDate", "text"]));
                return restProps
            }, [props]);
            return viewFunction({
                props: _objectSpread(_objectSpread({}, props), {}, {
                    dataCellTemplate: getTemplate(props.dataCellTemplate),
                    contentTemplate: getTemplate(props.contentTemplate)
                }),
                restAttributes: __restAttributes()
            })
        }
        AllDayPanelCell.defaultProps = _objectSpread({}, _cell.DateTableCellBaseProps)
    },
    /*!******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/ui/scheduler/workspaces/const.js ***!
      \******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.DefaultSizes = void 0;
        var DefaultSizes = {
            allDayPanelHeight: 25
        };
        exports.DefaultSizes = DefaultSizes
    },
    /*!**************************************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/ui/scheduler/workspaces/base/date_table/all_day_panel/title.j.js ***!
      \**************************************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../../../../../../core/component_registrator */ 9));
        var _component = _interopRequireDefault(__webpack_require__( /*! ../../../../../../preact_wrapper/component */ 184));
        var _title = __webpack_require__( /*! ./title */ 446);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var AllDayPanelTitle = function(_BaseComponent) {
            _inheritsLoose(AllDayPanelTitle, _BaseComponent);

            function AllDayPanelTitle() {
                return _BaseComponent.apply(this, arguments) || this
            }
            _createClass(AllDayPanelTitle, [{
                key: "_propsInfo",
                get: function() {
                    return {
                        twoWay: [],
                        allowNull: [],
                        elements: []
                    }
                }
            }, {
                key: "_viewComponent",
                get: function() {
                    return _title.AllDayPanelTitle
                }
            }]);
            return AllDayPanelTitle
        }(_component.default);
        exports.default = AllDayPanelTitle;
        (0, _component_registrator.default)("dxAllDayPanelTitle", AllDayPanelTitle);
        module.exports = exports.default
    },
    /*!*************************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/ui/scheduler/workspaces/base/time_panel/layout.j.js ***!
      \*************************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../../../../../core/component_registrator */ 9));
        var _component = _interopRequireDefault(__webpack_require__( /*! ../../../../../preact_wrapper/component */ 184));
        var _layout = __webpack_require__( /*! ./layout */ 837);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var TimePanelTableLayout = function(_BaseComponent) {
            _inheritsLoose(TimePanelTableLayout, _BaseComponent);

            function TimePanelTableLayout() {
                return _BaseComponent.apply(this, arguments) || this
            }
            var _proto = TimePanelTableLayout.prototype;
            _proto.getProps = function() {
                var props = _BaseComponent.prototype.getProps.call(this);
                props.timeCellTemplate = this._createTemplateComponent(props, props.timeCellTemplate);
                props.dataCellTemplate = this._createTemplateComponent(props, props.dataCellTemplate);
                return props
            };
            _createClass(TimePanelTableLayout, [{
                key: "_propsInfo",
                get: function() {
                    return {
                        twoWay: [],
                        allowNull: [],
                        elements: []
                    }
                }
            }, {
                key: "_viewComponent",
                get: function() {
                    return _layout.TimePanelTableLayout
                }
            }]);
            return TimePanelTableLayout
        }(_component.default);
        exports.default = TimePanelTableLayout;
        (0, _component_registrator.default)("dxTimePanelTableLayout", TimePanelTableLayout);
        module.exports = exports.default
    },
    /*!***********************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/ui/scheduler/workspaces/base/time_panel/layout.js ***!
      \***********************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.TimePanelTableLayout = TimePanelTableLayout;
        exports.TimePanelTableLayoutProps = exports.viewFunction = void 0;
        var _row = __webpack_require__( /*! ../row */ 223);
        var _cell = __webpack_require__( /*! ./cell */ 838);
        var _cell2 = __webpack_require__( /*! ../cell */ 303);
        var _utils = __webpack_require__( /*! ../../utils */ 185);
        var _table = __webpack_require__( /*! ../table */ 301);
        var _layout_props = __webpack_require__( /*! ../layout_props */ 161);
        var _title = __webpack_require__( /*! ../date_table/all_day_panel/title */ 446);
        var Preact = _interopRequireWildcard(__webpack_require__( /*! preact */ 50));
        var _hooks = __webpack_require__( /*! preact/hooks */ 53);

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function _objectWithoutProperties(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = _objectWithoutPropertiesLoose(source, excluded);
            var key, i;
            if (Object.getOwnPropertySymbols) {
                var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
                for (i = 0; i < sourceSymbolKeys.length; i++) {
                    key = sourceSymbolKeys[i];
                    if (excluded.indexOf(key) >= 0) {
                        continue
                    }
                    if (!Object.prototype.propertyIsEnumerable.call(source, key)) {
                        continue
                    }
                    target[key] = source[key]
                }
            }
            return target
        }

        function _objectWithoutPropertiesLoose(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = {};
            var sourceKeys = Object.keys(source);
            var key, i;
            for (i = 0; i < sourceKeys.length; i++) {
                key = sourceKeys[i];
                if (excluded.indexOf(key) >= 0) {
                    continue
                }
                target[key] = source[key]
            }
            return target
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function _extends() {
            _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key]
                        }
                    }
                }
                return target
            };
            return _extends.apply(this, arguments)
        }
        var viewFunction = function(_ref) {
            var bottomVirtualRowHeight = _ref.bottomVirtualRowHeight,
                isVerticalGrouping = _ref.isVerticalGroupOrientation,
                isVirtual = _ref.isVirtual,
                props = _ref.props,
                restAttributes = _ref.restAttributes,
                topVirtualRowHeight = _ref.topVirtualRowHeight;
            var timeCellTemplate = props.timeCellTemplate,
                viewData = props.viewData;
            return Preact.h(_table.Table, _extends({}, restAttributes, {
                isVirtual: isVirtual,
                topVirtualRowHeight: topVirtualRowHeight,
                bottomVirtualRowHeight: bottomVirtualRowHeight,
                virtualCellsCount: 1,
                className: "dx-scheduler-time-panel"
            }), viewData.groupedData.map(function(_ref2, index) {
                var dateTable = _ref2.dateTable,
                    groupIndex = _ref2.groupIndex;
                return Preact.h(Preact.Fragment, {
                    key: (0, _utils.getKeyByGroup)(groupIndex)
                }, (0, _utils.getIsGroupedAllDayPanel)(viewData, index) && Preact.h(_row.Row, null, Preact.h(_cell2.CellBase, {
                    className: "dx-scheduler-time-panel-title-cell"
                }, Preact.h(_title.AllDayPanelTitle, null))), dateTable.map(function(cellsRow) {
                    var cellCountInGroupRow = viewData.cellCountInGroupRow;
                    var _cellsRow$ = cellsRow[0],
                        groups = _cellsRow$.groups,
                        cellIndex = _cellsRow$.index,
                        isFirstGroupCell = _cellsRow$.isFirstGroupCell,
                        isLastGroupCell = _cellsRow$.isLastGroupCell,
                        key = _cellsRow$.key,
                        startDate = _cellsRow$.startDate,
                        text = _cellsRow$.text;
                    return Preact.h(_row.Row, {
                        className: "dx-scheduler-time-panel-row",
                        key: key
                    }, Preact.h(_cell.TimePanelCell, {
                        startDate: startDate,
                        text: text,
                        groups: isVerticalGrouping ? groups : void 0,
                        groupIndex: isVerticalGrouping ? groupIndex : void 0,
                        isFirstGroupCell: isVerticalGrouping && isFirstGroupCell,
                        isLastGroupCell: isVerticalGrouping && isLastGroupCell,
                        index: Math.floor(cellIndex / cellCountInGroupRow),
                        timeCellTemplate: timeCellTemplate
                    }))
                }))
            }))
        };
        exports.viewFunction = viewFunction;
        var TimePanelTableLayoutProps = _objectSpread(_objectSpread({}, _layout_props.LayoutProps), {}, {
            className: "",
            allDayPanelVisible: false
        });
        exports.TimePanelTableLayoutProps = TimePanelTableLayoutProps;
        var getTemplate = function(TemplateProp) {
            return TemplateProp && (TemplateProp.defaultProps ? function(props) {
                return Preact.h(TemplateProp, _extends({}, props))
            } : TemplateProp)
        };

        function TimePanelTableLayout(props) {
            var __isVirtual = (0, _hooks.useCallback)(function() {
                var viewData = props.viewData;
                return !!viewData.isVirtual
            }, [props.viewData]);
            var __topVirtualRowHeight = (0, _hooks.useCallback)(function() {
                return props.viewData.topVirtualRowHeight || 0
            }, [props.viewData]);
            var __bottomVirtualRowHeight = (0, _hooks.useCallback)(function() {
                return props.viewData.bottomVirtualRowHeight || 0
            }, [props.viewData]);
            var __isVerticalGroupOrientation = (0, _hooks.useCallback)(function() {
                var groupOrientation = props.groupOrientation;
                return (0, _utils.isVerticalGroupOrientation)(groupOrientation)
            }, [props.groupOrientation]);
            var __restAttributes = (0, _hooks.useCallback)(function() {
                var restProps = (props.allDayPanelVisible, props.className, props.dataCellTemplate, props.groupOrientation, props.timeCellTemplate, props.viewData, _objectWithoutProperties(props, ["allDayPanelVisible", "className", "dataCellTemplate", "groupOrientation", "timeCellTemplate", "viewData"]));
                return restProps
            }, [props]);
            return viewFunction({
                props: _objectSpread(_objectSpread({}, props), {}, {
                    timeCellTemplate: getTemplate(props.timeCellTemplate),
                    dataCellTemplate: getTemplate(props.dataCellTemplate)
                }),
                isVirtual: __isVirtual(),
                topVirtualRowHeight: __topVirtualRowHeight(),
                bottomVirtualRowHeight: __bottomVirtualRowHeight(),
                isVerticalGroupOrientation: __isVerticalGroupOrientation(),
                restAttributes: __restAttributes()
            })
        }
        TimePanelTableLayout.defaultProps = _objectSpread({}, TimePanelTableLayoutProps)
    },
    /*!*********************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/ui/scheduler/workspaces/base/time_panel/cell.js ***!
      \*********************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.TimePanelCell = TimePanelCell;
        exports.TimePanelCellProps = exports.viewFunction = void 0;
        var _cell = __webpack_require__( /*! ../cell */ 303);
        var Preact = _interopRequireWildcard(__webpack_require__( /*! preact */ 50));
        var _hooks = __webpack_require__( /*! preact/hooks */ 53);

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function _objectWithoutProperties(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = _objectWithoutPropertiesLoose(source, excluded);
            var key, i;
            if (Object.getOwnPropertySymbols) {
                var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
                for (i = 0; i < sourceSymbolKeys.length; i++) {
                    key = sourceSymbolKeys[i];
                    if (excluded.indexOf(key) >= 0) {
                        continue
                    }
                    if (!Object.prototype.propertyIsEnumerable.call(source, key)) {
                        continue
                    }
                    target[key] = source[key]
                }
            }
            return target
        }

        function _objectWithoutPropertiesLoose(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = {};
            var sourceKeys = Object.keys(source);
            var key, i;
            for (i = 0; i < sourceKeys.length; i++) {
                key = sourceKeys[i];
                if (excluded.indexOf(key) >= 0) {
                    continue
                }
                target[key] = source[key]
            }
            return target
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function _extends() {
            _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key]
                        }
                    }
                }
                return target
            };
            return _extends.apply(this, arguments)
        }
        var viewFunction = function(viewModel) {
            return Preact.h(_cell.CellBase, _extends({}, viewModel.restAttributes, {
                isFirstGroupCell: viewModel.props.isFirstGroupCell,
                isLastGroupCell: viewModel.props.isLastGroupCell,
                contentTemplate: viewModel.props.timeCellTemplate,
                contentTemplateProps: viewModel.timeCellTemplateProps,
                className: "dx-scheduler-time-panel-cell dx-scheduler-cell-sizes-vertical ".concat(viewModel.props.className)
            }), Preact.h("div", null, viewModel.props.text))
        };
        exports.viewFunction = viewFunction;
        var TimePanelCellProps = _objectSpread({}, _cell.CellBaseProps);
        exports.TimePanelCellProps = TimePanelCellProps;
        var getTemplate = function(TemplateProp) {
            return TemplateProp && (TemplateProp.defaultProps ? function(props) {
                return Preact.h(TemplateProp, _extends({}, props))
            } : TemplateProp)
        };

        function TimePanelCell(props) {
            var __timeCellTemplateProps = (0, _hooks.useCallback)(function() {
                var groupIndex = props.groupIndex,
                    groups = props.groups,
                    index = props.index,
                    startDate = props.startDate,
                    text = props.text;
                return {
                    data: {
                        date: startDate,
                        groups: groups,
                        groupIndex: groupIndex,
                        text: text
                    },
                    index: index
                }
            }, [props.groupIndex, props.groups, props.index, props.startDate, props.text]);
            var __restAttributes = (0, _hooks.useCallback)(function() {
                var restProps = (props.allDay, props.children, props.className, props.contentTemplate, props.contentTemplateProps, props.endDate, props.groupIndex, props.groups, props.index, props.isFirstGroupCell, props.isLastGroupCell, props.startDate, props.text, props.timeCellTemplate, _objectWithoutProperties(props, ["allDay", "children", "className", "contentTemplate", "contentTemplateProps", "endDate", "groupIndex", "groups", "index", "isFirstGroupCell", "isLastGroupCell", "startDate", "text", "timeCellTemplate"]));
                return restProps
            }, [props]);
            return viewFunction({
                props: _objectSpread(_objectSpread({}, props), {}, {
                    timeCellTemplate: getTemplate(props.timeCellTemplate),
                    contentTemplate: getTemplate(props.contentTemplate)
                }),
                timeCellTemplateProps: __timeCellTemplateProps(),
                restAttributes: __restAttributes()
            })
        }
        TimePanelCell.defaultProps = _objectSpread({}, TimePanelCellProps)
    },
    /*!*************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/workspaces/virtual_selection_state.js ***!
      \*************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../../core/utils/date */ 19));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }
        var VirtualSelectionState = function() {
            function VirtualSelectionState(viewDataProvider) {
                this._viewDataProvider = viewDataProvider;
                this._focusedCell = null;
                this._selectedCells = null;
                this._firstSelectedCell = null
            }
            var _proto = VirtualSelectionState.prototype;
            _proto.setFocusedCell = function(rowIndex, columnIndex, isAllDay) {
                if (rowIndex >= 0) {
                    var cell = this._viewDataProvider.getCellData(rowIndex, columnIndex, isAllDay);
                    this._focusedCell = cell
                }
            };
            _proto.getFocusedCell = function(isVerticalGroupOrientation) {
                var _focusedCell = this._focusedCell;
                if (!_focusedCell) {
                    return
                }
                var columnIndex = this._getColumnIndexByCellData(_focusedCell, isVerticalGroupOrientation);
                var rowIndex = this._getRowIndexByColumnAndData(_focusedCell, columnIndex, isVerticalGroupOrientation);
                return {
                    coordinates: {
                        cellIndex: columnIndex,
                        rowIndex: rowIndex
                    },
                    cellData: _focusedCell
                }
            };
            _proto.setSelectedCells = function(lastCellCoordinates) {
                var _this = this;
                var firstCellCoordinates = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                var viewDataProvider = this._viewDataProvider;
                var lastRowIndex = lastCellCoordinates.rowIndex,
                    lastColumnIndex = lastCellCoordinates.columnIndex,
                    isLastCellAllDay = lastCellCoordinates.allDay;
                if (lastRowIndex < 0) {
                    return
                }
                var firstCell = firstCellCoordinates ? viewDataProvider.getCellData(firstCellCoordinates.rowIndex, firstCellCoordinates.columnIndex, firstCellCoordinates.allDay) : this._firstSelectedCell;
                var lastCell = viewDataProvider.getCellData(lastRowIndex, lastColumnIndex, isLastCellAllDay);
                this._firstSelectedCell = firstCell;
                if (firstCell.startDate.getTime() > lastCell.startDate.getTime()) {
                    var _ref = [lastCell, firstCell];
                    firstCell = _ref[0];
                    lastCell = _ref[1]
                }
                var _firstCell = firstCell,
                    firstStartDate = _firstCell.startDate,
                    firstGroupIndex = _firstCell.groupIndex;
                var _lastCell = lastCell,
                    lastStartDate = _lastCell.startDate;
                var cells = viewDataProvider.getCellsByGroupIndexAndAllDay(firstGroupIndex, isLastCellAllDay);
                var filteredCells = cells.reduce(function(selectedCells, cellsRow) {
                    var filteredRow = _this._filterCellsByDate(cellsRow, firstStartDate, lastStartDate);
                    selectedCells.push.apply(selectedCells, _toConsumableArray(filteredRow));
                    return selectedCells
                }, []);
                this._selectedCells = filteredCells.sort(function(firstCell, secondCell) {
                    return firstCell.startDate.getTime() - secondCell.startDate.getTime()
                })
            };
            _proto.getSelectedCells = function() {
                return this._selectedCells
            };
            _proto.releaseSelectedAndFocusedCells = function() {
                this.releaseSelectedCells();
                this.releaseFocusedCell()
            };
            _proto.releaseSelectedCells = function() {
                this._selectedCells = null;
                this._firstSelectedCell = null
            };
            _proto.releaseFocusedCell = function() {
                this._focusedCell = null
            };
            _proto.isValidFocusedCell = function(nextFocusedCellData) {
                var focusedCell = this._focusedCell;
                if (!focusedCell) {
                    return true
                }
                var groupIndex = focusedCell.groupIndex,
                    allDay = focusedCell.allDay;
                var nextGroupIndex = nextFocusedCellData.groupIndex,
                    nextAllDay = nextFocusedCellData.allDay;
                return groupIndex === nextGroupIndex && allDay === nextAllDay
            };
            _proto._getColumnIndexByCellData = function(cellData, isVerticalGroupOrientation) {
                var viewDataMap = this._viewDataProvider.viewDataMap;
                var startDate = cellData.startDate,
                    groupIndex = cellData.groupIndex;
                var firstRow = viewDataMap[0];
                var startTime = _date.default.trimTime(startDate).getTime();
                for (var columnIndex = 0; columnIndex < firstRow.length; columnIndex += 1) {
                    var _firstRow$columnIndex = firstRow[columnIndex].cellData,
                        currentStartDate = _firstRow$columnIndex.startDate,
                        currentGroupIndex = _firstRow$columnIndex.groupIndex;
                    if (startTime === _date.default.trimTime(currentStartDate).getTime() && (groupIndex === currentGroupIndex || isVerticalGroupOrientation)) {
                        return columnIndex
                    }
                }
            };
            _proto._getRowIndexByColumnAndData = function(cellData, columnIndex, isVerticalGroupOrientation) {
                var viewDataMap = this._viewDataProvider.viewDataMap;
                var startDate = cellData.startDate,
                    groupIndex = cellData.groupIndex,
                    allDay = cellData.allDay;
                if (allDay && !isVerticalGroupOrientation) {
                    return 0
                }
                for (var rowIndex = 0; rowIndex < viewDataMap.length; rowIndex += 1) {
                    var currentCellData = viewDataMap[rowIndex][columnIndex].cellData;
                    var currentStartDate = currentCellData.startDate,
                        currentGroupIndex = currentCellData.groupIndex,
                        currentAllDay = currentCellData.allDay;
                    if (startDate.getTime() === currentStartDate.getTime() && groupIndex === currentGroupIndex && allDay === currentAllDay) {
                        return rowIndex
                    }
                }
            };
            _proto._filterCellsByDate = function(cellsRow, firstDate, lastDate) {
                var firstTime = firstDate.getTime();
                var lastTime = lastDate.getTime();
                return cellsRow.filter(function(cell) {
                    var startDate = cell.startDate;
                    var time = startDate.getTime();
                    return firstTime <= time && time <= lastTime
                })
            };
            return VirtualSelectionState
        }();
        exports.default = VirtualSelectionState;
        module.exports = exports.default
    },
    /*!***************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/workspaces/ui.scheduler.timeline_day.js ***!
      \***************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../../core/component_registrator */ 9));
        var _uiScheduler = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.timeline */ 304));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var TIMELINE_CLASS = "dx-scheduler-timeline-day";
        var SchedulerTimelineDay = function(_SchedulerTimeline) {
            _inheritsLoose(SchedulerTimelineDay, _SchedulerTimeline);

            function SchedulerTimelineDay() {
                return _SchedulerTimeline.apply(this, arguments) || this
            }
            var _proto = SchedulerTimelineDay.prototype;
            _proto._getElementClass = function() {
                return TIMELINE_CLASS
            };
            _proto._setFirstViewDate = function() {
                this._firstViewDate = this.option("currentDate");
                this._setStartDayHour(this._firstViewDate)
            };
            _proto._needRenderWeekHeader = function() {
                return this._isWorkSpaceWithCount()
            };
            return SchedulerTimelineDay
        }(_uiScheduler.default);
        (0, _component_registrator.default)("dxSchedulerTimelineDay", SchedulerTimelineDay);
        var _default = SchedulerTimelineDay;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/shaders/ui.scheduler.current_time_shader.horizontal.js ***!
      \******************************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _position = __webpack_require__( /*! ../../../core/utils/position */ 22);
        var _uiScheduler = _interopRequireDefault(__webpack_require__( /*! ../shaders/ui.scheduler.current_time_shader */ 444));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var HorizontalCurrentTimeShader = function(_CurrentTimeShader) {
            _inheritsLoose(HorizontalCurrentTimeShader, _CurrentTimeShader);

            function HorizontalCurrentTimeShader() {
                return _CurrentTimeShader.apply(this, arguments) || this
            }
            var _proto = HorizontalCurrentTimeShader.prototype;
            _proto.renderShader = function() {
                var groupCount = this._workSpace._isHorizontalGroupedWorkSpace() ? this._workSpace._getGroupCount() : 1;
                for (var i = 0; i < groupCount; i++) {
                    var isFirstShader = 0 === i;
                    var $shader = isFirstShader ? this._$shader : this.createShader();
                    this.applyShaderMargin($shader);
                    if (this._workSpace.isGroupedByDate()) {
                        this._customizeGroupedByDateShader($shader, i)
                    } else {
                        this._customizeShader($shader, i)
                    }!isFirstShader && this._shader.push($shader)
                }
            };
            _proto._customizeShader = function($shader, groupIndex) {
                var shaderWidth = this._workSpace.getIndicationWidth();
                this._applyShaderWidth($shader, shaderWidth);
                if (groupIndex >= 1) {
                    var workSpace = this._workSpace;
                    var indicationWidth = workSpace._getCellCount() * workSpace.getCellWidth();
                    $shader.css("left", indicationWidth)
                } else {
                    $shader.css("left", 0)
                }
            };
            _proto._applyShaderWidth = function($shader, width) {
                var maxWidth = (0, _position.getBoundingRect)(this._$container.get(0)).width;
                if (width > maxWidth) {
                    width = maxWidth
                }
                if (width > 0) {
                    $shader.width(width)
                }
            };
            _proto._customizeGroupedByDateShader = function($shader, groupIndex) {
                var cellCount = this._workSpace.getIndicationCellCount();
                var integerPart = Math.floor(cellCount);
                var fractionPart = cellCount - integerPart;
                var isFirstShaderPart = 0 === groupIndex;
                var workSpace = this._workSpace;
                var shaderWidth = isFirstShaderPart ? workSpace.getIndicationWidth() : fractionPart * workSpace.getCellWidth();
                var shaderLeft;
                this._applyShaderWidth($shader, shaderWidth);
                if (isFirstShaderPart) {
                    shaderLeft = workSpace._getCellCount() * workSpace.getCellWidth() * groupIndex
                } else {
                    shaderLeft = workSpace.getCellWidth() * integerPart * workSpace._getGroupCount() + groupIndex * workSpace.getCellWidth()
                }
                $shader.css("left", shaderLeft)
            };
            return HorizontalCurrentTimeShader
        }(_uiScheduler.default);
        var _default = HorizontalCurrentTimeShader;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/workspaces/ui.scheduler.timeline_month.js ***!
      \*****************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../../core/component_registrator */ 9));
        var _uiScheduler = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.timeline */ 304));
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../../core/utils/date */ 19));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var TIMELINE_CLASS = "dx-scheduler-timeline-month";
        var DAY_IN_MILLISECONDS = 864e5;
        var toMs = _date.default.dateToMilliseconds;
        var SchedulerTimelineMonth = function(_SchedulerTimeline) {
            _inheritsLoose(SchedulerTimelineMonth, _SchedulerTimeline);

            function SchedulerTimelineMonth() {
                return _SchedulerTimeline.apply(this, arguments) || this
            }
            var _proto = SchedulerTimelineMonth.prototype;
            _proto._renderView = function() {
                _SchedulerTimeline.prototype._renderView.call(this);
                this._updateScrollable()
            };
            _proto._getElementClass = function() {
                return TIMELINE_CLASS
            };
            _proto._getDateHeaderTemplate = function() {
                return this.option("dateCellTemplate")
            };
            _proto._getHiddenInterval = function() {
                return 0
            };
            _proto._calculateDurationInCells = function(timeDiff) {
                return timeDiff / this.getCellDuration()
            };
            _proto.getCellDuration = function() {
                return toMs("day")
            };
            _proto.calculateEndViewDate = function(dateOfLastViewCell) {
                return new Date(dateOfLastViewCell.getTime() + this._calculateDayDuration() * toMs("hour"))
            };
            _proto.isIndicatorVisible = function() {
                return true
            };
            _proto._getCellCount = function() {
                var currentDate = this.option("currentDate");
                var cellCount = 0;
                if (this._isWorkSpaceWithCount()) {
                    var intervalCount = this.option("intervalCount");
                    for (var i = 1; i <= intervalCount; i++) {
                        cellCount += new Date(currentDate.getFullYear(), currentDate.getMonth() + i, 0).getDate()
                    }
                } else {
                    cellCount = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate()
                }
                return cellCount
            };
            _proto._setFirstViewDate = function() {
                this._firstViewDate = _date.default.getFirstMonthDate(this.option("currentDate"));
                this._setStartDayHour(this._firstViewDate)
            };
            _proto._getFormat = function() {
                return this._formatWeekdayAndDay
            };
            _proto._getDateByIndex = function(headerIndex) {
                var resultDate = new Date(this._firstViewDate);
                resultDate.setDate(this._firstViewDate.getDate() + headerIndex);
                return resultDate
            };
            _proto._getInterval = function() {
                return DAY_IN_MILLISECONDS
            };
            _proto._getIntervalBetween = function(currentDate) {
                var firstViewDate = this.getStartViewDate();
                var timeZoneOffset = _date.default.getTimezonesDifference(firstViewDate, currentDate);
                return currentDate.getTime() - (firstViewDate.getTime() - 36e5 * this.option("startDayHour")) - timeZoneOffset
            };
            _proto.calculateEndDate = function(startDate) {
                var startDateCopy = new Date(startDate);
                return new Date(startDateCopy.setHours(this.option("endDayHour")))
            };
            _proto._calculateHiddenInterval = function() {
                return 0
            };
            _proto._getDateByCellIndexes = function(rowIndex, cellIndex) {
                var date = _SchedulerTimeline.prototype._getDateByCellIndexes.call(this, rowIndex, cellIndex);
                this._setStartDayHour(date);
                return date
            };
            _proto.getPositionShift = function() {
                return {
                    top: 0,
                    left: 0,
                    cellPosition: 0
                }
            };
            return SchedulerTimelineMonth
        }(_uiScheduler.default);
        (0, _component_registrator.default)("dxSchedulerTimelineMonth", SchedulerTimelineMonth);
        var _default = SchedulerTimelineMonth;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/workspaces/ui.scheduler.timeline_work_week.js ***!
      \*********************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../../core/component_registrator */ 9));
        var _uiScheduler = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.timeline_week */ 447));
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../../core/utils/date */ 19));
        var _utils = _interopRequireDefault(__webpack_require__( /*! ./utils.work_week */ 448));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var toMs = _date.default.dateToMilliseconds;
        var TIMELINE_CLASS = "dx-scheduler-timeline-work-week";
        var LAST_DAY_WEEK_INDEX = 5;
        var SchedulerTimelineWorkWeek = function(_SchedulerTimelineWee) {
            _inheritsLoose(SchedulerTimelineWorkWeek, _SchedulerTimelineWee);

            function SchedulerTimelineWorkWeek() {
                var _this;
                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key]
                }
                _this = _SchedulerTimelineWee.call.apply(_SchedulerTimelineWee, [this].concat(args)) || this;
                _this._getWeekendsCount = _utils.default.getWeekendsCount;
                _this._isSkippedData = _utils.default.isDataOnWeekend;
                return _this
            }
            var _proto = SchedulerTimelineWorkWeek.prototype;
            _proto._getElementClass = function() {
                return TIMELINE_CLASS
            };
            _proto._getWeekDuration = function() {
                return 5
            };
            _proto._firstDayOfWeek = function() {
                return _utils.default.getFirstDayOfWeek(this.option("firstDayOfWeek"))
            };
            _proto._isSkippedData = function() {
                return _utils.default.isDataOnWeekend
            };
            _proto._incrementDate = function(date) {
                var day = date.getDay();
                if (day === LAST_DAY_WEEK_INDEX) {
                    date.setDate(date.getDate() + 2)
                }
                _SchedulerTimelineWee.prototype._incrementDate.call(this, date)
            };
            _proto._getOffsetByCount = function(cellIndex) {
                var weekendCount = Math.floor(cellIndex / (5 * this._getCellCountInDay()));
                return toMs("day") * weekendCount * 2
            };
            _proto._setFirstViewDate = function() {
                this._firstViewDate = _utils.default.getFirstViewDate(this.option("currentDate"), this._firstDayOfWeek());
                this._setStartDayHour(this._firstViewDate)
            };
            return SchedulerTimelineWorkWeek
        }(_uiScheduler.default);
        (0, _component_registrator.default)("dxSchedulerTimelineWorkWeek", SchedulerTimelineWorkWeek);
        var _default = SchedulerTimelineWorkWeek;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/workspaces/ui.scheduler.work_space_day.js ***!
      \*****************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../../core/component_registrator */ 9));
        var _uiScheduler = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.work_space_vertical */ 449));
        var _layout = _interopRequireDefault(__webpack_require__( /*! ../../../renovation/ui/scheduler/workspaces/day/date_table/layout.j */ 845));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var DAY_CLASS = "dx-scheduler-work-space-day";
        var SchedulerWorkSpaceDay = function(_SchedulerWorkSpaceVe) {
            _inheritsLoose(SchedulerWorkSpaceDay, _SchedulerWorkSpaceVe);

            function SchedulerWorkSpaceDay() {
                return _SchedulerWorkSpaceVe.apply(this, arguments) || this
            }
            var _proto = SchedulerWorkSpaceDay.prototype;
            _proto._getElementClass = function() {
                return DAY_CLASS
            };
            _proto._getRowCount = function() {
                return this._getCellCountInDay()
            };
            _proto._getCellCount = function() {
                return this.option("intervalCount")
            };
            _proto._setFirstViewDate = function() {
                this._firstViewDate = this._getViewStartByOptions();
                this._setStartDayHour(this._firstViewDate)
            };
            _proto._getDateByIndex = function(headerIndex) {
                if (1 === this.option("intervalCount")) {
                    return this._firstViewDate
                }
                var resultDate = new Date(this._firstViewDate);
                resultDate.setDate(this._firstViewDate.getDate() + headerIndex);
                return resultDate
            };
            _proto._renderDateHeader = function() {
                return 1 === this.option("intervalCount") ? null : _SchedulerWorkSpaceVe.prototype._renderDateHeader.call(this)
            };
            _proto.renderRDateTable = function() {
                this.renderRComponent(this._$dateTable, _layout.default, "renovatedDateTable", {
                    viewData: this.viewDataProvider.viewData,
                    dataCellTemplate: this.option("dataCellTemplate")
                })
            };
            return SchedulerWorkSpaceDay
        }(_uiScheduler.default);
        (0, _component_registrator.default)("dxSchedulerWorkSpaceDay", SchedulerWorkSpaceDay);
        var _default = SchedulerWorkSpaceDay;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/ui/scheduler/workspaces/day/date_table/layout.j.js ***!
      \************************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../../../../../core/component_registrator */ 9));
        var _component = _interopRequireDefault(__webpack_require__( /*! ../../../../../preact_wrapper/component */ 184));
        var _layout = __webpack_require__( /*! ./layout */ 846);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var DayDateTableLayout = function(_BaseComponent) {
            _inheritsLoose(DayDateTableLayout, _BaseComponent);

            function DayDateTableLayout() {
                return _BaseComponent.apply(this, arguments) || this
            }
            var _proto = DayDateTableLayout.prototype;
            _proto.getProps = function() {
                var props = _BaseComponent.prototype.getProps.call(this);
                props.dataCellTemplate = this._createTemplateComponent(props, props.dataCellTemplate);
                return props
            };
            _createClass(DayDateTableLayout, [{
                key: "_propsInfo",
                get: function() {
                    return {
                        twoWay: [],
                        allowNull: [],
                        elements: []
                    }
                }
            }, {
                key: "_viewComponent",
                get: function() {
                    return _layout.DayDateTableLayout
                }
            }]);
            return DayDateTableLayout
        }(_component.default);
        exports.default = DayDateTableLayout;
        (0, _component_registrator.default)("dxDayDateTableLayout", DayDateTableLayout);
        module.exports = exports.default
    },
    /*!**********************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/ui/scheduler/workspaces/day/date_table/layout.js ***!
      \**********************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.DayDateTableLayout = DayDateTableLayout;
        exports.viewFunction = void 0;
        var _layout = __webpack_require__( /*! ../../base/date_table/layout */ 450);
        var _layout_props = __webpack_require__( /*! ../../base/layout_props */ 161);
        var Preact = _interopRequireWildcard(__webpack_require__( /*! preact */ 50));
        var _hooks = __webpack_require__( /*! preact/hooks */ 53);

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function _objectWithoutProperties(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = _objectWithoutPropertiesLoose(source, excluded);
            var key, i;
            if (Object.getOwnPropertySymbols) {
                var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
                for (i = 0; i < sourceSymbolKeys.length; i++) {
                    key = sourceSymbolKeys[i];
                    if (excluded.indexOf(key) >= 0) {
                        continue
                    }
                    if (!Object.prototype.propertyIsEnumerable.call(source, key)) {
                        continue
                    }
                    target[key] = source[key]
                }
            }
            return target
        }

        function _objectWithoutPropertiesLoose(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = {};
            var sourceKeys = Object.keys(source);
            var key, i;
            for (i = 0; i < sourceKeys.length; i++) {
                key = sourceKeys[i];
                if (excluded.indexOf(key) >= 0) {
                    continue
                }
                target[key] = source[key]
            }
            return target
        }

        function _extends() {
            _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key]
                        }
                    }
                }
                return target
            };
            return _extends.apply(this, arguments)
        }
        var viewFunction = function(viewModel) {
            return Preact.h(_layout.DateTableLayoutBase, _extends({
                viewData: viewModel.props.viewData,
                viewType: "day",
                dataCellTemplate: viewModel.props.dataCellTemplate
            }, viewModel.restAttributes))
        };
        exports.viewFunction = viewFunction;
        var getTemplate = function(TemplateProp) {
            return TemplateProp && (TemplateProp.defaultProps ? function(props) {
                return Preact.h(TemplateProp, _extends({}, props))
            } : TemplateProp)
        };

        function DayDateTableLayout(props) {
            var __restAttributes = (0, _hooks.useCallback)(function() {
                var restProps = (props.dataCellTemplate, props.groupOrientation, props.viewData, _objectWithoutProperties(props, ["dataCellTemplate", "groupOrientation", "viewData"]));
                return restProps
            }, [props]);
            return viewFunction({
                props: _objectSpread(_objectSpread({}, props), {}, {
                    dataCellTemplate: getTemplate(props.dataCellTemplate)
                }),
                restAttributes: __restAttributes()
            })
        }
        DayDateTableLayout.defaultProps = _objectSpread({}, _layout_props.LayoutProps)
    },
    /*!***************************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/ui/scheduler/workspaces/base/date_table/table_body.js ***!
      \***************************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.DateTableBody = DateTableBody;
        exports.DateTableBodyProps = exports.viewFunction = void 0;
        var _row = __webpack_require__( /*! ../row */ 223);
        var _utils = __webpack_require__( /*! ../../utils */ 185);
        var _layout_props = __webpack_require__( /*! ../layout_props */ 161);
        var _table_body = __webpack_require__( /*! ./all_day_panel/table_body */ 445);
        var _cell = __webpack_require__( /*! ../../month/date_table/cell */ 848);
        var _cell2 = __webpack_require__( /*! ./cell */ 302);
        var Preact = _interopRequireWildcard(__webpack_require__( /*! preact */ 50));
        var _hooks = __webpack_require__( /*! preact/hooks */ 53);

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function _objectWithoutProperties(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = _objectWithoutPropertiesLoose(source, excluded);
            var key, i;
            if (Object.getOwnPropertySymbols) {
                var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
                for (i = 0; i < sourceSymbolKeys.length; i++) {
                    key = sourceSymbolKeys[i];
                    if (excluded.indexOf(key) >= 0) {
                        continue
                    }
                    if (!Object.prototype.propertyIsEnumerable.call(source, key)) {
                        continue
                    }
                    target[key] = source[key]
                }
            }
            return target
        }

        function _objectWithoutPropertiesLoose(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = {};
            var sourceKeys = Object.keys(source);
            var key, i;
            for (i = 0; i < sourceKeys.length; i++) {
                key = sourceKeys[i];
                if (excluded.indexOf(key) >= 0) {
                    continue
                }
                target[key] = source[key]
            }
            return target
        }

        function _extends() {
            _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key]
                        }
                    }
                }
                return target
            };
            return _extends.apply(this, arguments)
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }
        var viewFunction = function(_ref) {
            var Cell = _ref.cell,
                props = _ref.props;
            var dataCellTemplate = props.dataCellTemplate,
                viewData = props.viewData;
            return Preact.h(Preact.Fragment, null, viewData.groupedData.map(function(_ref2, index) {
                var allDayPanel = _ref2.allDayPanel,
                    dateTable = _ref2.dateTable,
                    groupIndex = _ref2.groupIndex;
                return Preact.h(Preact.Fragment, {
                    key: (0, _utils.getKeyByGroup)(groupIndex)
                }, (0, _utils.getIsGroupedAllDayPanel)(viewData, index) && Preact.h(_table_body.AllDayPanelTableBody, {
                    viewData: allDayPanel,
                    dataCellTemplate: dataCellTemplate,
                    isVerticalGroupOrientation: true
                }), dateTable.map(function(cellsRow) {
                    return Preact.h(_row.Row, {
                        className: "dx-scheduler-date-table-row",
                        key: cellsRow[0].key
                    }, cellsRow.map(function(_ref3) {
                        var endDate = _ref3.endDate,
                            cellGroupIndex = _ref3.groupIndex,
                            groups = _ref3.groups,
                            cellIndex = _ref3.index,
                            isFirstGroupCell = _ref3.isFirstGroupCell,
                            isLastGroupCell = _ref3.isLastGroupCell,
                            key = _ref3.key,
                            startDate = _ref3.startDate;
                        return Preact.h(Cell, {
                            isFirstGroupCell: isFirstGroupCell,
                            isLastGroupCell: isLastGroupCell,
                            startDate: startDate,
                            endDate: endDate,
                            groups: groups,
                            groupIndex: cellGroupIndex,
                            index: cellIndex,
                            dataCellTemplate: dataCellTemplate,
                            key: key
                        })
                    }))
                }))
            }))
        };
        exports.viewFunction = viewFunction;
        var DateTableBodyProps = _objectSpread({}, _layout_props.LayoutProps);
        exports.DateTableBodyProps = DateTableBodyProps;
        var getTemplate = function(TemplateProp) {
            return TemplateProp && (TemplateProp.defaultProps ? function(props) {
                return Preact.h(TemplateProp, _extends({}, props))
            } : TemplateProp)
        };

        function DateTableBody(props) {
            var __cell = (0, _hooks.useCallback)(function() {
                var viewType = props.viewType;
                return "month" === viewType ? _cell.MonthDateTableCell : _cell2.DateTableCellBase
            }, [props.viewType]);
            var __restAttributes = (0, _hooks.useCallback)(function() {
                var restProps = (props.dataCellTemplate, props.groupOrientation, props.viewData, props.viewType, _objectWithoutProperties(props, ["dataCellTemplate", "groupOrientation", "viewData", "viewType"]));
                return restProps
            }, [props]);
            return viewFunction({
                props: _objectSpread(_objectSpread({}, props), {}, {
                    dataCellTemplate: getTemplate(props.dataCellTemplate)
                }),
                cell: __cell(),
                restAttributes: __restAttributes()
            })
        }
        DateTableBody.defaultProps = _objectSpread({}, DateTableBodyProps)
    },
    /*!**********************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/ui/scheduler/workspaces/month/date_table/cell.js ***!
      \**********************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.MonthDateTableCell = MonthDateTableCell;
        exports.MonthDateTableCellProps = exports.viewFunction = void 0;
        var _cell = __webpack_require__( /*! ../../base/date_table/cell */ 302);
        var Preact = _interopRequireWildcard(__webpack_require__( /*! preact */ 50));
        var _hooks = __webpack_require__( /*! preact/hooks */ 53);

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function _objectWithoutProperties(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = _objectWithoutPropertiesLoose(source, excluded);
            var key, i;
            if (Object.getOwnPropertySymbols) {
                var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
                for (i = 0; i < sourceSymbolKeys.length; i++) {
                    key = sourceSymbolKeys[i];
                    if (excluded.indexOf(key) >= 0) {
                        continue
                    }
                    if (!Object.prototype.propertyIsEnumerable.call(source, key)) {
                        continue
                    }
                    target[key] = source[key]
                }
            }
            return target
        }

        function _objectWithoutPropertiesLoose(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = {};
            var sourceKeys = Object.keys(source);
            var key, i;
            for (i = 0; i < sourceKeys.length; i++) {
                key = sourceKeys[i];
                if (excluded.indexOf(key) >= 0) {
                    continue
                }
                target[key] = source[key]
            }
            return target
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function _extends() {
            _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key]
                        }
                    }
                }
                return target
            };
            return _extends.apply(this, arguments)
        }
        var viewFunction = function(viewModel) {
            return Preact.h(_cell.DateTableCellBase, _extends({}, viewModel.restAttributes, {
                className: viewModel.classes,
                dataCellTemplate: viewModel.props.dataCellTemplate,
                startDate: viewModel.props.startDate,
                endDate: viewModel.props.endDate,
                groups: viewModel.props.groups,
                groupIndex: viewModel.props.groupIndex,
                index: viewModel.props.index
            }), Preact.h("div", null, viewModel.props.startDate.getDate()))
        };
        exports.viewFunction = viewFunction;
        var MonthDateTableCellProps = _objectSpread(_objectSpread({}, _cell.DateTableCellBaseProps), {}, {
            otherMonth: false,
            today: false
        });
        exports.MonthDateTableCellProps = MonthDateTableCellProps;
        var getTemplate = function(TemplateProp) {
            return TemplateProp && (TemplateProp.defaultProps ? function(props) {
                return Preact.h(TemplateProp, _extends({}, props))
            } : TemplateProp)
        };

        function MonthDateTableCell(props) {
            var __classes = (0, _hooks.useCallback)(function() {
                var className = props.className,
                    otherMonth = props.otherMonth,
                    today = props.today;
                var classes = [];
                otherMonth && classes.push("dx-scheduler-date-table-other-month");
                today && classes.push("dx-scheduler-date-table-current-date");
                className && classes.push(className);
                return 0 !== classes.length ? classes.join(" ") : void 0
            }, [props.className, props.otherMonth, props.today]);
            var __restAttributes = (0, _hooks.useCallback)(function() {
                var restProps = (props.allDay, props.children, props.className, props.contentTemplate, props.contentTemplateProps, props.dataCellTemplate, props.endDate, props.groupIndex, props.groups, props.index, props.isFirstGroupCell, props.isLastGroupCell, props.otherMonth, props.startDate, props.text, props.today, _objectWithoutProperties(props, ["allDay", "children", "className", "contentTemplate", "contentTemplateProps", "dataCellTemplate", "endDate", "groupIndex", "groups", "index", "isFirstGroupCell", "isLastGroupCell", "otherMonth", "startDate", "text", "today"]));
                return restProps
            }, [props]);
            return viewFunction({
                props: _objectSpread(_objectSpread({}, props), {}, {
                    dataCellTemplate: getTemplate(props.dataCellTemplate),
                    contentTemplate: getTemplate(props.contentTemplate)
                }),
                classes: __classes(),
                restAttributes: __restAttributes()
            })
        }
        MonthDateTableCell.defaultProps = _objectSpread({}, MonthDateTableCellProps)
    },
    /*!*******************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/workspaces/ui.scheduler.work_space_month.js ***!
      \*******************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../../core/renderer */ 2));
        var _common = __webpack_require__( /*! ../../../core/utils/common */ 4);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../../core/component_registrator */ 9));
        var _uiSchedulerWork_space = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.work_space.indicator */ 305));
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../../core/utils/date */ 19));
        var _position = __webpack_require__( /*! ../../../core/utils/position */ 22);
        var _date2 = _interopRequireDefault(__webpack_require__( /*! ../../../localization/date */ 32));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var MONTH_CLASS = "dx-scheduler-work-space-month";
        var DATE_TABLE_CURRENT_DATE_CLASS = "dx-scheduler-date-table-current-date";
        var DATE_TABLE_FIRST_OF_MONTH_CLASS = "dx-scheduler-date-table-first-of-month";
        var DATE_TABLE_OTHER_MONTH_DATE_CLASS = "dx-scheduler-date-table-other-month";
        var DATE_TABLE_SCROLLABLE_FIXED_CLASS = "dx-scheduler-scrollable-fixed-content";
        var DAYS_IN_WEEK = 7;
        var DAY_IN_MILLISECONDS = 864e5;
        var toMs = _date.default.dateToMilliseconds;
        var SchedulerWorkSpaceMonth = function(_SchedulerWorkSpace) {
            _inheritsLoose(SchedulerWorkSpaceMonth, _SchedulerWorkSpace);

            function SchedulerWorkSpaceMonth() {
                return _SchedulerWorkSpace.apply(this, arguments) || this
            }
            var _proto = SchedulerWorkSpaceMonth.prototype;
            _proto._toggleFixedScrollableClass = function() {
                this._dateTableScrollable.$content().toggleClass(DATE_TABLE_SCROLLABLE_FIXED_CLASS, !this._isWorkSpaceWithCount() && !this._isVerticalGroupedWorkSpace())
            };
            _proto._getElementClass = function() {
                return MONTH_CLASS
            };
            _proto._getRowCount = function() {
                return this._isWorkSpaceWithCount() ? 4 * this.option("intervalCount") + 2 : 6
            };
            _proto._getCellCount = function() {
                return DAYS_IN_WEEK
            };
            _proto._getDateByIndex = function(headerIndex) {
                var resultDate = new Date(this._firstViewDate);
                resultDate.setDate(this._firstViewDate.getDate() + headerIndex);
                return resultDate
            };
            _proto._getFormat = function() {
                return this._formatWeekday
            };
            _proto._calculateCellIndex = function(rowIndex, cellIndex) {
                if (this._isVerticalGroupedWorkSpace()) {
                    rowIndex %= this._getRowCount()
                } else {
                    cellIndex %= this._getCellCount()
                }
                return rowIndex * this._getCellCount() + cellIndex
            };
            _proto._getInterval = function() {
                return DAY_IN_MILLISECONDS
            };
            _proto._getIntervalBetween = function(currentDate) {
                var firstViewDate = this.getStartViewDate();
                var timeZoneOffset = _date.default.getTimezonesDifference(firstViewDate, currentDate);
                return currentDate.getTime() - (firstViewDate.getTime() - 36e5 * this.option("startDayHour")) - timeZoneOffset
            };
            _proto._getDateByCellIndexes = function(rowIndex, cellIndex) {
                var date = _SchedulerWorkSpace.prototype._getDateByCellIndexes.call(this, rowIndex, cellIndex);
                this._setStartDayHour(date);
                return date
            };
            _proto.getCellWidth = function() {
                var _this = this;
                return this.cache.get("cellWidth", function() {
                    var DAYS_IN_WEEK = 7;
                    var averageWidth = 0;
                    _this._getCells().slice(0, DAYS_IN_WEEK).each(function(index, element) {
                        return averageWidth += (0, _position.getBoundingRect)(element).width
                    });
                    return averageWidth / DAYS_IN_WEEK
                })
            };
            _proto._calculateHiddenInterval = function() {
                return 0
            };
            _proto._insertAllDayRowsIntoDateTable = function() {
                return false
            };
            _proto._getCellCoordinatesByIndex = function(index) {
                var rowIndex = Math.floor(index / this._getCellCount());
                var cellIndex = index - this._getCellCount() * rowIndex;
                return {
                    rowIndex: rowIndex,
                    cellIndex: cellIndex
                }
            };
            _proto._createWorkSpaceElements = function() {
                if (this._isVerticalGroupedWorkSpace()) {
                    this._createWorkSpaceScrollableElements()
                } else {
                    _SchedulerWorkSpace.prototype._createWorkSpaceElements.call(this)
                }
            };
            _proto._needCreateCrossScrolling = function() {
                return this.option("crossScrollingEnabled") || this._isVerticalGroupedWorkSpace()
            };
            _proto._renderTimePanel = function() {
                return (0, _common.noop)()
            };
            _proto._renderAllDayPanel = function() {
                return (0, _common.noop)()
            };
            _proto._getTableAllDay = function() {
                return (0, _common.noop)()
            };
            _proto._toggleAllDayVisibility = function() {
                return (0, _common.noop)()
            };
            _proto._changeAllDayVisibility = function() {
                return (0, _common.noop)()
            };
            _proto._setFirstViewDate = function() {
                var firstMonthDate = _date.default.getFirstMonthDate(this._getViewStartByOptions());
                var firstDayOfWeek = this._getCalculatedFirstDayOfWeek();
                this._firstViewDate = _date.default.getFirstWeekDate(firstMonthDate, firstDayOfWeek);
                this._setStartDayHour(this._firstViewDate);
                var date = this._getViewStartByOptions();
                this._minVisibleDate = new Date(date.setDate(1));
                this._maxVisibleDate = new Date(new Date(date.setMonth(date.getMonth() + this.option("intervalCount"))).setDate(0))
            };
            _proto._getViewStartByOptions = function() {
                if (!this.option("startDate")) {
                    return new Date(this.option("currentDate").getTime())
                } else {
                    var startDate = this._getStartViewDate();
                    var currentDate = this.option("currentDate");
                    var diff = startDate.getTime() <= currentDate.getTime() ? 1 : -1;
                    var endDate = new Date(new Date(this._getStartViewDate().setMonth(this._getStartViewDate().getMonth() + diff * this.option("intervalCount"))));
                    while (!this._dateInRange(currentDate, startDate, endDate, diff)) {
                        startDate = new Date(endDate);
                        if (diff > 0) {
                            startDate.setDate(1)
                        }
                        endDate = new Date(new Date(endDate.setMonth(endDate.getMonth() + diff * this.option("intervalCount"))))
                    }
                    return diff > 0 ? startDate : endDate
                }
            };
            _proto._getStartViewDate = function() {
                var firstMonthDate = _date.default.getFirstMonthDate(this.option("startDate"));
                return firstMonthDate
            };
            _proto._renderTableBody = function(options) {
                options.getCellText = this._getCellText.bind(this);
                _SchedulerWorkSpace.prototype._renderTableBody.call(this, options)
            };
            _proto._getCellText = function(rowIndex, cellIndex) {
                if (this.isGroupedByDate()) {
                    cellIndex = Math.floor(cellIndex / this._getGroupCount())
                } else {
                    cellIndex %= this._getCellCount()
                }
                var date = this._getDate(rowIndex, cellIndex);
                if (this._isWorkSpaceWithCount() && this._isFirstDayOfMonth(date)) {
                    return this._formatMonthAndDay(date)
                }
                return _date2.default.format(date, "dd")
            };
            _proto._formatMonthAndDay = function(date) {
                var monthName = _date2.default.getMonthNames("abbreviated")[date.getMonth()];
                return [monthName, _date2.default.format(date, "day")].join(" ")
            };
            _proto._getDate = function(week, day) {
                var result = new Date(this._firstViewDate);
                var lastRowInDay = this._getRowCount();
                result.setDate(result.getDate() + week % lastRowInDay * DAYS_IN_WEEK + day);
                return result
            };
            _proto._updateIndex = function(index) {
                return index
            };
            _proto._prepareCellData = function(rowIndex, cellIndex, cell) {
                var data = _SchedulerWorkSpace.prototype._prepareCellData.call(this, rowIndex, cellIndex, cell);
                var $cell = (0, _renderer.default)(cell);
                $cell.toggleClass(DATE_TABLE_CURRENT_DATE_CLASS, this._isCurrentDate(data.startDate)).toggleClass(DATE_TABLE_FIRST_OF_MONTH_CLASS, this._isFirstDayOfMonth(data.startDate)).toggleClass(DATE_TABLE_OTHER_MONTH_DATE_CLASS, this._isOtherMonth(data.startDate));
                return data
            };
            _proto._isCurrentDate = function(cellDate) {
                return _date.default.sameDate(cellDate, this._getToday())
            };
            _proto._isFirstDayOfMonth = function(cellDate) {
                return this._isWorkSpaceWithCount() && 1 === cellDate.getDate()
            };
            _proto._isOtherMonth = function(cellDate) {
                return !_date.default.dateInRange(cellDate, this._minVisibleDate, this._maxVisibleDate, "date")
            };
            _proto.isIndicationAvailable = function() {
                return false
            };
            _proto.getCellDuration = function() {
                return 36e5 * this._calculateDayDuration()
            };
            _proto.getIntervalDuration = function() {
                return toMs("day")
            };
            _proto.getTimePanelWidth = function() {
                return 0
            };
            _proto.getPositionShift = function(timeShift) {
                return {
                    cellPosition: timeShift * this.getCellWidth(),
                    top: 0,
                    left: 0
                }
            };
            _proto.getCellCountToLastViewDate = function(date) {
                var firstDateTime = date.getTime();
                var lastDateTime = this.getEndViewDate().getTime();
                var dayDurationInMs = this.getCellDuration();
                return Math.ceil((lastDateTime - firstDateTime) / dayDurationInMs)
            };
            _proto.supportAllDayRow = function() {
                return false
            };
            _proto.keepOriginalHours = function() {
                return true
            };
            _proto.calculateEndDate = function(startDate) {
                var startDateCopy = new Date(startDate);
                return new Date(startDateCopy.setHours(this.option("endDayHour")))
            };
            _proto.getWorkSpaceLeftOffset = function() {
                return 0
            };
            _proto.needApplyCollectorOffset = function() {
                return true
            };
            _proto._getDateTableBorderOffset = function() {
                return this._getDateTableBorder()
            };
            _proto._getCellPositionByIndex = function(index, groupIndex) {
                var position = _SchedulerWorkSpace.prototype._getCellPositionByIndex.call(this, index, groupIndex);
                var rowIndex = this._getCellCoordinatesByIndex(index).rowIndex;
                var calculatedTopOffset;
                if (!this._isVerticalGroupedWorkSpace()) {
                    calculatedTopOffset = this.getCellHeight() * rowIndex
                } else {
                    calculatedTopOffset = this.getCellHeight() * (rowIndex + groupIndex * this._getRowCount())
                }
                if (calculatedTopOffset) {
                    position.top = calculatedTopOffset
                }
                return position
            };
            _proto._getHeaderDate = function() {
                return this._getViewStartByOptions()
            };
            _proto._supportCompactDropDownAppointments = function() {
                return false
            };
            _proto.scrollToTime = function() {
                return (0, _common.noop)()
            };
            _proto._getRowCountWithAllDayRows = function() {
                return this._getRowCount()
            };
            return SchedulerWorkSpaceMonth
        }(_uiSchedulerWork_space.default);
        (0, _component_registrator.default)("dxSchedulerWorkSpaceMonth", SchedulerWorkSpaceMonth);
        var _default = SchedulerWorkSpaceMonth;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/ui/scheduler/workspaces/week/date_table/layout.j.js ***!
      \*************************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../../../../../core/component_registrator */ 9));
        var _component = _interopRequireDefault(__webpack_require__( /*! ../../../../../preact_wrapper/component */ 184));
        var _layout = __webpack_require__( /*! ./layout */ 851);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var WeekTableLayout = function(_BaseComponent) {
            _inheritsLoose(WeekTableLayout, _BaseComponent);

            function WeekTableLayout() {
                return _BaseComponent.apply(this, arguments) || this
            }
            var _proto = WeekTableLayout.prototype;
            _proto.getProps = function() {
                var props = _BaseComponent.prototype.getProps.call(this);
                props.dataCellTemplate = this._createTemplateComponent(props, props.dataCellTemplate);
                return props
            };
            _createClass(WeekTableLayout, [{
                key: "_propsInfo",
                get: function() {
                    return {
                        twoWay: [],
                        allowNull: [],
                        elements: []
                    }
                }
            }, {
                key: "_viewComponent",
                get: function() {
                    return _layout.WeekTableLayout
                }
            }]);
            return WeekTableLayout
        }(_component.default);
        exports.default = WeekTableLayout;
        (0, _component_registrator.default)("dxWeekTableLayout", WeekTableLayout);
        module.exports = exports.default
    },
    /*!***********************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/renovation/ui/scheduler/workspaces/week/date_table/layout.js ***!
      \***********************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.WeekTableLayout = WeekTableLayout;
        exports.viewFunction = void 0;
        var _layout = __webpack_require__( /*! ../../base/date_table/layout */ 450);
        var _layout_props = __webpack_require__( /*! ../../base/layout_props */ 161);
        var Preact = _interopRequireWildcard(__webpack_require__( /*! preact */ 50));
        var _hooks = __webpack_require__( /*! preact/hooks */ 53);

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function _objectWithoutProperties(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = _objectWithoutPropertiesLoose(source, excluded);
            var key, i;
            if (Object.getOwnPropertySymbols) {
                var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
                for (i = 0; i < sourceSymbolKeys.length; i++) {
                    key = sourceSymbolKeys[i];
                    if (excluded.indexOf(key) >= 0) {
                        continue
                    }
                    if (!Object.prototype.propertyIsEnumerable.call(source, key)) {
                        continue
                    }
                    target[key] = source[key]
                }
            }
            return target
        }

        function _objectWithoutPropertiesLoose(source, excluded) {
            if (null == source) {
                return {}
            }
            var target = {};
            var sourceKeys = Object.keys(source);
            var key, i;
            for (i = 0; i < sourceKeys.length; i++) {
                key = sourceKeys[i];
                if (excluded.indexOf(key) >= 0) {
                    continue
                }
                target[key] = source[key]
            }
            return target
        }

        function _extends() {
            _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key]
                        }
                    }
                }
                return target
            };
            return _extends.apply(this, arguments)
        }
        var viewFunction = function(viewModel) {
            return Preact.h(_layout.DateTableLayoutBase, _extends({
                viewData: viewModel.props.viewData,
                viewType: "week",
                dataCellTemplate: viewModel.props.dataCellTemplate
            }, viewModel.restAttributes))
        };
        exports.viewFunction = viewFunction;
        var getTemplate = function(TemplateProp) {
            return TemplateProp && (TemplateProp.defaultProps ? function(props) {
                return Preact.h(TemplateProp, _extends({}, props))
            } : TemplateProp)
        };

        function WeekTableLayout(props) {
            var __restAttributes = (0, _hooks.useCallback)(function() {
                var restProps = (props.dataCellTemplate, props.groupOrientation, props.viewData, _objectWithoutProperties(props, ["dataCellTemplate", "groupOrientation", "viewData"]));
                return restProps
            }, [props]);
            return viewFunction({
                props: _objectSpread(_objectSpread({}, props), {}, {
                    dataCellTemplate: getTemplate(props.dataCellTemplate)
                }),
                restAttributes: __restAttributes()
            })
        }
        WeekTableLayout.defaultProps = _objectSpread({}, _layout_props.LayoutProps)
    },
    /*!***********************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/workspaces/ui.scheduler.work_space_work_week.js ***!
      \***********************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../../core/component_registrator */ 9));
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../../core/utils/date */ 19));
        var _utils = _interopRequireDefault(__webpack_require__( /*! ./utils.work_week */ 448));
        var _uiScheduler = _interopRequireDefault(__webpack_require__( /*! ./ui.scheduler.work_space_week */ 451));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var toMs = _date.default.dateToMilliseconds;
        var WORK_WEEK_CLASS = "dx-scheduler-work-space-work-week";
        var dayIndexes = [1, 2, 3, 4, 5];
        var weekCounter = 0;
        var SchedulerWorkSpaceWorkWeek = function(_SchedulerWorkSpaceWe) {
            _inheritsLoose(SchedulerWorkSpaceWorkWeek, _SchedulerWorkSpaceWe);

            function SchedulerWorkSpaceWorkWeek() {
                var _this;
                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key]
                }
                _this = _SchedulerWorkSpaceWe.call.apply(_SchedulerWorkSpaceWe, [this].concat(args)) || this;
                _this._isSkippedData = _utils.default.isDataOnWeekend;
                _this._getWeekendsCount = _utils.default.getWeekendsCount;
                return _this
            }
            var _proto = SchedulerWorkSpaceWorkWeek.prototype;
            _proto._getElementClass = function() {
                return WORK_WEEK_CLASS
            };
            _proto._getCellCount = function() {
                return 5 * this.option("intervalCount")
            };
            _proto._firstDayOfWeek = function() {
                return _utils.default.getFirstDayOfWeek(this.option("firstDayOfWeek"))
            };
            _proto._getDateByIndex = function(headerIndex) {
                var resultDate = new Date(this._firstViewDate);
                if (headerIndex % this._getCellCount() === 0) {
                    weekCounter = 0
                }
                resultDate.setDate(this._firstViewDate.getDate() + headerIndex + weekCounter);
                var index = resultDate.getDay();
                while (dayIndexes.indexOf(index) === -1) {
                    resultDate.setDate(resultDate.getDate() + 1);
                    index = resultDate.getDay();
                    weekCounter++
                }
                return resultDate
            };
            _proto._renderView = function() {
                weekCounter = 0;
                _SchedulerWorkSpaceWe.prototype._renderView.call(this)
            };
            _proto._setFirstViewDate = function() {
                this._firstViewDate = _utils.default.getFirstViewDate(this._getViewStartByOptions(), this._firstDayOfWeek());
                this._setStartDayHour(this._firstViewDate)
            };
            _proto._getOffsetByCount = function(cellIndex) {
                var cellsInGroup = this._getCellCount();
                var inGroup = Math.floor(cellIndex / cellsInGroup);
                cellIndex -= cellsInGroup * inGroup;
                var weekendCount = Math.floor(cellIndex / 5);
                return toMs("day") * weekendCount * 2
            };
            return SchedulerWorkSpaceWorkWeek
        }(_uiScheduler.default);
        (0, _component_registrator.default)("dxSchedulerWorkSpaceWorkWeek", SchedulerWorkSpaceWorkWeek);
        var _default = SchedulerWorkSpaceWorkWeek;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/appointmentAdapter.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _object = __webpack_require__( /*! ../../core/utils/object */ 51);
        var _recurrence = __webpack_require__( /*! ./recurrence */ 139);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }
        var PROPERTY_NAMES = {
            startDate: "startDate",
            endDate: "endDate",
            allDay: "allDay",
            text: "text",
            description: "description",
            startDateTimeZone: "startDateTimeZone",
            endDateTimeZone: "endDateTimeZone",
            recurrenceRule: "recurrenceRule",
            recurrenceException: "recurrenceException",
            disabled: "disabled"
        };
        var AppointmentAdapter = function() {
            function AppointmentAdapter(rawAppointment, options) {
                this.rawAppointment = rawAppointment;
                this.options = options
            }
            var _proto = AppointmentAdapter.prototype;
            _proto.getField = function(property) {
                return this.options.getField(this.rawAppointment, property)
            };
            _proto.setField = function(property, value) {
                return this.options.setField(this.rawAppointment, property, value)
            };
            _proto.calculateStartDate = function(pathTimeZoneConversion) {
                if (!this.startDate || isNaN(this.startDate.getTime())) {
                    throw _ui.default.Error("E1032", this.text)
                }
                return this.calculateDate(this.startDate, this.startDateTimeZone, pathTimeZoneConversion)
            };
            _proto.calculateEndDate = function(pathTimeZoneConversion) {
                return this.calculateDate(this.endDate, this.endDateTimeZone, pathTimeZoneConversion)
            };
            _proto.calculateDate = function(date, appointmentTimeZone, pathTimeZoneConversion) {
                if (!date) {
                    return
                }
                return this.timeZoneCalculator.createDate(date, {
                    appointmentTimeZone: appointmentTimeZone,
                    path: pathTimeZoneConversion
                })
            };
            _proto.clone = function() {
                var options = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0;
                var result = new AppointmentAdapter((0, _object.deepExtendArraySafe)({}, this.rawAppointment), this.options);
                if (null !== options && void 0 !== options && options.pathTimeZone) {
                    result.startDate = result.calculateStartDate(options.pathTimeZone);
                    result.endDate = result.calculateEndDate(options.pathTimeZone)
                }
                return result
            };
            _proto.source = function() {
                var serializeDate = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : false;
                if (serializeDate) {
                    var clonedAdapter = this.clone();
                    clonedAdapter.startDate = this.startDate;
                    clonedAdapter.endDate = this.endDate;
                    return clonedAdapter.source()
                }
                return (0, _extend.extend)({}, this.rawAppointment)
            };
            _createClass(AppointmentAdapter, [{
                key: "duration",
                get: function() {
                    return this.endDate ? this.endDate - this.startDate : 0
                }
            }, {
                key: "startDate",
                get: function() {
                    var result = this.getField(PROPERTY_NAMES.startDate);
                    return void 0 === result ? result : new Date(result)
                },
                set: function(value) {
                    this.setField(PROPERTY_NAMES.startDate, value)
                }
            }, {
                key: "endDate",
                get: function() {
                    var result = this.getField(PROPERTY_NAMES.endDate);
                    return void 0 === result ? result : new Date(result)
                },
                set: function(value) {
                    this.setField(PROPERTY_NAMES.endDate, value)
                }
            }, {
                key: "allDay",
                get: function() {
                    return this.getField(PROPERTY_NAMES.allDay)
                },
                set: function(value) {
                    this.setField(PROPERTY_NAMES.allDay, value)
                }
            }, {
                key: "text",
                get: function() {
                    return this.getField(PROPERTY_NAMES.text)
                },
                set: function(value) {
                    this.setField(PROPERTY_NAMES.text, value)
                }
            }, {
                key: "description",
                get: function() {
                    return this.getField(PROPERTY_NAMES.description)
                },
                set: function(value) {
                    this.setField(PROPERTY_NAMES.description, value)
                }
            }, {
                key: "startDateTimeZone",
                get: function() {
                    return this.getField(PROPERTY_NAMES.startDateTimeZone)
                }
            }, {
                key: "endDateTimeZone",
                get: function() {
                    return this.getField(PROPERTY_NAMES.endDateTimeZone)
                }
            }, {
                key: "recurrenceRule",
                get: function() {
                    return this.getField(PROPERTY_NAMES.recurrenceRule)
                },
                set: function(value) {
                    this.setField(PROPERTY_NAMES.recurrenceRule, value)
                }
            }, {
                key: "recurrenceException",
                get: function() {
                    return this.getField(PROPERTY_NAMES.recurrenceException)
                },
                set: function(value) {
                    this.setField(PROPERTY_NAMES.recurrenceException, value)
                }
            }, {
                key: "disabled",
                get: function() {
                    return !!this.getField(PROPERTY_NAMES.disabled)
                }
            }, {
                key: "timeZoneCalculator",
                get: function() {
                    return this.options.getTimeZoneCalculator()
                }
            }, {
                key: "isRecurrent",
                get: function() {
                    return (0, _recurrence.getRecurrenceProcessor)().isValidRecurrenceRule(this.recurrenceRule)
                }
            }]);
            return AppointmentAdapter
        }();
        var _default = AppointmentAdapter;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/timeZoneCalculator.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.TimeZoneCalculator = exports.PathTimeZoneConversion = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var toMs = _date.default.dateToMilliseconds;
        var PathTimeZoneConversion = {
            fromSourceToAppointment: "toAppointment",
            fromAppointmentToSource: "fromAppointment",
            fromSourceToGrid: "toGrid",
            fromGridToSource: "fromGrid"
        };
        exports.PathTimeZoneConversion = PathTimeZoneConversion;
        var TimeZoneCalculator = function() {
            function TimeZoneCalculator(options) {
                this.options = options
            }
            var _proto = TimeZoneCalculator.prototype;
            _proto.createDate = function(sourceDate, info) {
                var date = new Date(sourceDate);
                switch (info.path) {
                    case PathTimeZoneConversion.fromSourceToAppointment:
                        return this._getConvertedDate(date, info.appointmentTimeZone, true);
                    case PathTimeZoneConversion.fromAppointmentToSource:
                        return this._getConvertedDate(date, info.appointmentTimeZone, true, true);
                    case PathTimeZoneConversion.fromSourceToGrid:
                        return this._getConvertedDate(date, info.appointmentTimeZone, false);
                    case PathTimeZoneConversion.fromGridToSource:
                        return this._getConvertedDate(date, info.appointmentTimeZone, false, true)
                }
                throw new Error("not specified pathTimeZoneConversion")
            };
            _proto.getOffsets = function(date, appointmentTimezone) {
                var clientOffset = -this._getClientOffset(date) / toMs("hour");
                var commonOffset = this._getCommonOffset(date);
                var appointmentOffset = this._getAppointmentOffset(date, appointmentTimezone);
                return {
                    client: clientOffset,
                    common: !(0, _type.isDefined)(commonOffset) ? clientOffset : commonOffset,
                    appointment: "number" !== typeof appointmentOffset ? clientOffset : appointmentOffset
                }
            };
            _proto._getClientOffset = function(date) {
                return this.options.getClientOffset(date)
            };
            _proto._getCommonOffset = function(date) {
                return this.options.getCommonOffset(date)
            };
            _proto._getAppointmentOffset = function(date, appointmentTimezone) {
                return this.options.getAppointmentOffset(date, appointmentTimezone)
            };
            _proto._getConvertedDate = function(date, appointmentTimezone, useAppointmentTimeZone, isBack) {
                var newDate = new Date(date.getTime());
                var offsets = this.getOffsets(newDate, appointmentTimezone);
                if (useAppointmentTimeZone && !!appointmentTimezone) {
                    return this._getConvertedDateByOffsets(date, offsets.client, offsets.appointment, isBack)
                }
                return this._getConvertedDateByOffsets(date, offsets.client, offsets.common, isBack)
            };
            _proto._getConvertedDateByOffsets = function(date, clientOffset, targetOffset, isBack) {
                var direction = isBack ? -1 : 1;
                var utcDate = date.getTime() - direction * clientOffset * toMs("hour");
                return new Date(utcDate + direction * targetOffset * toMs("hour"))
            };
            return TimeZoneCalculator
        }();
        exports.TimeZoneCalculator = TimeZoneCalculator
    },
    /*!*******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/scheduler/appointmentSettingsGenerator.js ***!
      \*******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.AppointmentSettingsGeneratorVirtualStrategy = exports.AppointmentSettingsGeneratorBaseStrategy = exports.AppointmentSettingsGenerator = void 0;
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _recurrence = __webpack_require__( /*! ./recurrence */ 139);
        var _utilsTimeZone = _interopRequireDefault(__webpack_require__( /*! ./utils.timeZone.js */ 86));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }

        function _slicedToArray(arr, i) {
            return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest()
        }

        function _nonIterableRest() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }

        function _iterableToArrayLimit(arr, i) {
            var _i = arr && ("undefined" !== typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]);
            if (null == _i) {
                return
            }
            var _arr = [];
            var _n = true;
            var _d = false;
            var _s, _e;
            try {
                for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
                    _arr.push(_s.value);
                    if (i && _arr.length === i) {
                        break
                    }
                }
            } catch (err) {
                _d = true;
                _e = err
            } finally {
                try {
                    if (!_n && null != _i.return) {
                        _i.return()
                    }
                } finally {
                    if (_d) {
                        throw _e
                    }
                }
            }
            return _arr
        }

        function _arrayWithHoles(arr) {
            if (Array.isArray(arr)) {
                return arr
            }
        }

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                if (enumerableOnly) {
                    symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable
                    })
                }
                keys.push.apply(keys, symbols)
            }
            return keys
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                if (i % 2) {
                    ownKeys(Object(source), true).forEach(function(key) {
                        _defineProperty(target, key, source[key])
                    })
                } else {
                    if (Object.getOwnPropertyDescriptors) {
                        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                    } else {
                        ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                        })
                    }
                }
            }
            return target
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }
        var toMs = _date.default.dateToMilliseconds;
        var AppointmentSettingsGenerator = function() {
            function AppointmentSettingsGenerator(scheduler) {
                this.scheduler = scheduler;
                this.settingsStrategy = this.scheduler.isVirtualScrolling() ? new AppointmentSettingsGeneratorVirtualStrategy(this.scheduler) : new AppointmentSettingsGeneratorBaseStrategy(this.scheduler)
            }
            var _proto = AppointmentSettingsGenerator.prototype;
            _proto.create = function(rawAppointment) {
                return this.settingsStrategy.create(rawAppointment)
            };
            return AppointmentSettingsGenerator
        }();
        exports.AppointmentSettingsGenerator = AppointmentSettingsGenerator;
        var AppointmentSettingsGeneratorBaseStrategy = function() {
            function AppointmentSettingsGeneratorBaseStrategy(scheduler) {
                this.scheduler = scheduler
            }
            var _proto2 = AppointmentSettingsGeneratorBaseStrategy.prototype;
            _proto2.create = function(rawAppointment) {
                var scheduler = this.scheduler;
                var appointment = scheduler.createAppointmentAdapter(rawAppointment);
                var itemResources = scheduler._resourcesManager.getResourcesFromItem(rawAppointment);
                var isAllDay = this._isAllDayAppointment(rawAppointment);
                var appointmentList = this._createAppointments(appointment, itemResources);
                appointmentList = this._getProcessedByAppointmentTimeZone(appointmentList, appointment);
                if (this._canProcessNotNativeTimezoneDates(appointment)) {
                    appointmentList = this._getProcessedNotNativeTimezoneDates(appointmentList, appointment)
                }
                var gridAppointmentList = this._createGridAppointmentList(appointmentList, appointment);
                gridAppointmentList = this._cropAppointmentsByStartDayHour(gridAppointmentList, rawAppointment, isAllDay);
                gridAppointmentList = this._getProcessedLongAppointmentsIfRequired(gridAppointmentList, appointment);
                var appointmentInfos = this._createAppointmentInfos(gridAppointmentList, itemResources, isAllDay, appointment.isRecurrent);
                return appointmentInfos
            };
            _proto2._getProcessedByAppointmentTimeZone = function(appointmentList, appointment) {
                var _this = this;
                var hasAppointmentTimeZone = !(0, _type.isEmptyObject)(appointment.startDateTimeZone) || !(0, _type.isEmptyObject)(appointment.endDateTimeZone);
                if (appointmentList.length > 1 && hasAppointmentTimeZone) {
                    var appointmentOffsets = {
                        startDate: this.timeZoneCalculator.getOffsets(appointment.startDate, appointment.startDateTimeZone),
                        endDate: this.timeZoneCalculator.getOffsets(appointment.endDate, appointment.endDateTimeZone)
                    };
                    appointmentList.forEach(function(a) {
                        var sourceOffsets = {
                            startDate: _this.timeZoneCalculator.getOffsets(a.startDate, appointment.startDateTimeZone),
                            endDate: _this.timeZoneCalculator.getOffsets(a.endDate, appointment.endDateTimeZone)
                        };
                        var startDateOffsetDiff = appointmentOffsets.startDate.appointment - sourceOffsets.startDate.appointment;
                        var endDateOffsetDiff = appointmentOffsets.endDate.appointment - sourceOffsets.endDate.appointment;
                        if (0 !== startDateOffsetDiff) {
                            a.startDate = new Date(a.startDate.getTime() + startDateOffsetDiff * toMs("hour"))
                        }
                        if (0 !== endDateOffsetDiff) {
                            a.endDate = new Date(a.endDate.getTime() + endDateOffsetDiff * toMs("hour"))
                        }
                    })
                }
                return appointmentList
            };
            _proto2._isAllDayAppointment = function(rawAppointment) {
                return this.scheduler.appointmentTakesAllDay(rawAppointment) && this.workspace.supportAllDayRow()
            };
            _proto2._createAppointments = function(appointment, resources) {
                var appointments = this._createRecurrenceAppointments(appointment, resources);
                if (!appointment.isRecurrent && 0 === appointments.length) {
                    appointments.push({
                        startDate: appointment.startDate,
                        endDate: appointment.endDate
                    })
                }
                appointments = appointments.map(function(item) {
                    var _item$endDate;
                    var resultEndTime = null === (_item$endDate = item.endDate) || void 0 === _item$endDate ? void 0 : _item$endDate.getTime();
                    if (item.startDate.getTime() === resultEndTime) {
                        item.endDate.setTime(resultEndTime + toMs("minute"))
                    }
                    return _objectSpread(_objectSpread({}, item), {}, {
                        exceptionDate: new Date(item.startDate)
                    })
                });
                return appointments
            };
            _proto2._canProcessNotNativeTimezoneDates = function(appointment) {
                var timeZoneName = this.scheduler.option("timeZone");
                var isTimeZoneSet = !(0, _type.isEmptyObject)(timeZoneName);
                if (!isTimeZoneSet) {
                    return false
                }
                if (!appointment.isRecurrent) {
                    return false
                }
                return !_utilsTimeZone.default.isEqualLocalTimeZone(timeZoneName, appointment.startDate)
            };
            _proto2._getProcessedNotNativeDateIfCrossDST = function(date, offset) {
                if (offset < 0) {
                    var newDate = new Date(date);
                    var newDateMinusOneHour = new Date(newDate);
                    newDateMinusOneHour.setHours(newDateMinusOneHour.getHours() - 1);
                    var newDateOffset = this.timeZoneCalculator.getOffsets(newDate).common;
                    var newDateMinusOneHourOffset = this.timeZoneCalculator.getOffsets(newDateMinusOneHour).common;
                    if (newDateOffset !== newDateMinusOneHourOffset) {
                        return 0
                    }
                }
                return offset
            };
            _proto2._getProcessedNotNativeTimezoneDates = function(appointmentList, appointment) {
                var _this2 = this;
                var startDateRange = appointment.startDate;
                var endDateRange = appointmentList[appointmentList.length - 1].endDate;
                var startDateRangeOffset = this.timeZoneCalculator.getOffsets(startDateRange).common;
                var endDateRangeOffset = this.timeZoneCalculator.getOffsets(endDateRange).common;
                var isChangeOffsetInRange = startDateRangeOffset !== endDateRangeOffset;
                if (isChangeOffsetInRange) {
                    return appointmentList.map(function(a) {
                        var diffStartDateOffset = _this2.timeZoneCalculator.getOffsets(appointment.startDate).common - _this2.timeZoneCalculator.getOffsets(a.startDate).common;
                        var diffEndDateOffset = _this2.timeZoneCalculator.getOffsets(appointment.endDate).common - _this2.timeZoneCalculator.getOffsets(a.endDate).common;
                        diffStartDateOffset = _this2._getProcessedNotNativeDateIfCrossDST(a.startDate, diffStartDateOffset);
                        diffEndDateOffset = _this2._getProcessedNotNativeDateIfCrossDST(a.endDate, diffEndDateOffset);
                        var newStartDate = new Date(a.startDate.getTime() + diffStartDateOffset * toMs("hour"));
                        var newEndDate = new Date(a.endDate.getTime() + diffEndDateOffset * toMs("hour"));
                        var testNewStartDate = _this2.timeZoneCalculator.createDate(newStartDate, {
                            path: "toGrid"
                        });
                        var testNewEndDate = _this2.timeZoneCalculator.createDate(newEndDate, {
                            path: "toGrid"
                        });
                        if (appointment.duration > testNewEndDate.getTime() - testNewStartDate.getTime()) {
                            newEndDate = new Date(newStartDate.getTime() + appointment.duration)
                        }
                        return {
                            startDate: newStartDate,
                            endDate: newEndDate,
                            exceptionDate: new Date(newStartDate)
                        }
                    })
                }
                return appointmentList
            };
            _proto2._getProcessedLongAppointmentsIfRequired = function(gridAppointmentList, appointment) {
                var _this3 = this;
                var rawAppointment = appointment.source();
                var allDay = this.scheduler.appointmentTakesAllDay(rawAppointment);
                var dateRange = this.workspace.getDateRange();
                var renderingStrategy = this.scheduler.getLayoutManager().getRenderingStrategyInstance();
                if (renderingStrategy.needSeparateAppointment(allDay)) {
                    var longStartDateParts = [];
                    var resultDates = [];
                    gridAppointmentList.forEach(function(gridAppointment) {
                        var maxDate = new Date(dateRange[1]);
                        var endDateOfPart = renderingStrategy.normalizeEndDateByViewEnd(rawAppointment, gridAppointment.endDate);
                        longStartDateParts = _date.default.getDatesOfInterval(gridAppointment.startDate, endDateOfPart, {
                            milliseconds: _this3.scheduler.getWorkSpace().getIntervalDuration(allDay)
                        });
                        var list = longStartDateParts.filter(function(startDatePart) {
                            return new Date(startDatePart) < maxDate
                        }).map(function(date) {
                            return {
                                startDate: date,
                                endDate: new Date(new Date(date).setMilliseconds(appointment.duration)),
                                source: gridAppointment.source
                            }
                        });
                        resultDates = resultDates.concat(list)
                    });
                    gridAppointmentList = resultDates
                }
                return gridAppointmentList
            };
            _proto2._createGridAppointmentList = function(appointmentList, appointment) {
                var _this4 = this;
                return appointmentList.map(function(source) {
                    var offsetDifference = appointment.startDate.getTimezoneOffset() - source.startDate.getTimezoneOffset();
                    if (0 !== offsetDifference && _this4._canProcessNotNativeTimezoneDates(appointment)) {
                        source.startDate = new Date(source.startDate.getTime() + offsetDifference * toMs("minute"));
                        source.endDate = new Date(source.endDate.getTime() + offsetDifference * toMs("minute"));
                        source.exceptionDate = new Date(source.startDate)
                    }
                    var startDate = _this4.timeZoneCalculator.createDate(source.startDate, {
                        path: "toGrid"
                    });
                    var endDate = _this4.timeZoneCalculator.createDate(source.endDate, {
                        path: "toGrid"
                    });
                    return {
                        startDate: startDate,
                        endDate: endDate,
                        source: source
                    }
                })
            };
            _proto2._createExtremeRecurrenceDates = function(rawAppointment) {
                var dateRange = this.workspace.getDateRange();
                var startViewDate = this.scheduler.appointmentTakesAllDay(rawAppointment) ? _date.default.trimTime(dateRange[0]) : dateRange[0];
                var endViewDate = dateRange[1];
                var commonTimeZone = this.scheduler.option("timeZone");
                if (commonTimeZone) {
                    startViewDate = this.timeZoneCalculator.createDate(startViewDate, {
                        path: "fromGrid"
                    });
                    endViewDate = this.timeZoneCalculator.createDate(endViewDate, {
                        path: "fromGrid"
                    });
                    var daylightOffset = _utilsTimeZone.default.getDaylightOffsetInMs(startViewDate, endViewDate);
                    if (daylightOffset) {
                        endViewDate = new Date(endViewDate.getTime() + daylightOffset)
                    }
                }
                return [startViewDate, endViewDate]
            };
            _proto2._createRecurrenceOptions = function(appointment, groupIndex) {
                var _this5 = this;
                var _this$_createExtremeR = this._createExtremeRecurrenceDates(appointment.source(), groupIndex),
                    _this$_createExtremeR2 = _slicedToArray(_this$_createExtremeR, 2),
                    minRecurrenceDate = _this$_createExtremeR2[0],
                    maxRecurrenceDate = _this$_createExtremeR2[1];
                return {
                    rule: appointment.recurrenceRule,
                    exception: appointment.recurrenceException,
                    min: minRecurrenceDate,
                    max: maxRecurrenceDate,
                    firstDayOfWeek: this.scheduler.getFirstDayOfWeek(),
                    start: appointment.startDate,
                    end: appointment.endDate,
                    getPostProcessedException: function(date) {
                        var timeZoneName = _this5.scheduler.option("timeZone");
                        if ((0, _type.isEmptyObject)(timeZoneName) || _utilsTimeZone.default.isEqualLocalTimeZone(timeZoneName, date)) {
                            return date
                        }
                        var appointmentOffset = _this5.timeZoneCalculator.getOffsets(appointment.startDate).common;
                        var exceptionAppointmentOffset = _this5.timeZoneCalculator.getOffsets(date).common;
                        var diff = appointmentOffset - exceptionAppointmentOffset;
                        diff = _this5._getProcessedNotNativeDateIfCrossDST(date, diff);
                        return new Date(date.getTime() - diff * _date.default.dateToMilliseconds("hour"))
                    }
                }
            };
            _proto2._createRecurrenceAppointments = function(appointment, resources) {
                var duration = appointment.duration;
                var option = this._createRecurrenceOptions(appointment);
                var generatedStartDates = (0, _recurrence.getRecurrenceProcessor)().generateDates(option);
                return generatedStartDates.map(function(date) {
                    var utcDate = _utilsTimeZone.default.createUTCDateWithLocalOffset(date);
                    utcDate.setTime(utcDate.getTime() + duration);
                    var endDate = _utilsTimeZone.default.createDateFromUTCWithLocalOffset(utcDate);
                    return {
                        startDate: new Date(date),
                        endDate: endDate
                    }
                })
            };
            _proto2._getGroupIndices = function(resources) {
                var workspace = this.scheduler._workSpace;
                return workspace._getGroupIndexes(resources)
            };
            _proto2._cropAppointmentsByStartDayHour = function(appointments, rawAppointment, isAllDay) {
                var _this6 = this;
                return appointments.map(function(appointment) {
                    var startDate = new Date(appointment.startDate);
                    var firstViewDate = _this6._getAppointmentFirstViewDate(appointment, rawAppointment);
                    var startDayHour = _this6._getViewStartDayHour(firstViewDate);
                    appointment.startDate = _this6._getAppointmentResultDate({
                        appointment: appointment,
                        rawAppointment: rawAppointment,
                        startDate: startDate,
                        startDayHour: startDayHour,
                        firstViewDate: firstViewDate
                    });
                    return appointment
                })
            };
            _proto2._getAppointmentFirstViewDate = function() {
                return this.scheduler.getStartViewDate()
            };
            _proto2._getViewStartDayHour = function() {
                return this.scheduler._getCurrentViewOption("startDayHour")
            };
            _proto2._getAppointmentResultDate = function(options) {
                var appointment = options.appointment,
                    rawAppointment = options.rawAppointment,
                    startDayHour = options.startDayHour,
                    firstViewDate = options.firstViewDate;
                var startDate = options.startDate;
                var resultDate = new Date(appointment.startDate);
                if (this.scheduler.appointmentTakesAllDay(rawAppointment)) {
                    resultDate = _date.default.normalizeDate(startDate, firstViewDate)
                } else {
                    if (startDate < firstViewDate) {
                        startDate = firstViewDate
                    }
                    resultDate = _date.default.normalizeDate(appointment.startDate, startDate)
                }
                return _date.default.roundDateByStartDayHour(resultDate, startDayHour)
            };
            _proto2._createAppointmentInfos = function(gridAppointments, resources, allDay, recurrent) {
                var _this7 = this;
                var result = [];
                var _loop = function(i) {
                    var coordinates = _this7.scheduler._workSpace.getCoordinatesByDateInGroup(gridAppointments[i].startDate, resources, allDay);
                    coordinates.forEach(function(coordinate) {
                        (0, _extend.extend)(coordinate, {
                            info: {
                                appointment: gridAppointments[i],
                                sourceAppointment: gridAppointments[i].source
                            }
                        })
                    });
                    result = result.concat(coordinates)
                };
                for (var i = 0; i < gridAppointments.length; i++) {
                    _loop(i)
                }
                return result
            };
            _createClass(AppointmentSettingsGeneratorBaseStrategy, [{
                key: "timeZoneCalculator",
                get: function() {
                    return this.scheduler.timeZoneCalculator
                }
            }, {
                key: "workspace",
                get: function() {
                    return this.scheduler.getWorkSpace()
                }
            }, {
                key: "viewDataProvider",
                get: function() {
                    return this.workspace.viewDataProvider
                }
            }]);
            return AppointmentSettingsGeneratorBaseStrategy
        }();
        exports.AppointmentSettingsGeneratorBaseStrategy = AppointmentSettingsGeneratorBaseStrategy;
        var AppointmentSettingsGeneratorVirtualStrategy = function(_AppointmentSettingsG) {
            _inheritsLoose(AppointmentSettingsGeneratorVirtualStrategy, _AppointmentSettingsG);

            function AppointmentSettingsGeneratorVirtualStrategy() {
                return _AppointmentSettingsG.apply(this, arguments) || this
            }
            var _proto3 = AppointmentSettingsGeneratorVirtualStrategy.prototype;
            _proto3._createAppointmentInfos = function(gridAppointments, resources, allDay, recurrent) {
                var _this8 = this;
                var appointments = allDay ? gridAppointments : gridAppointments.filter(function(item) {
                    var source = item.source,
                        startDate = item.startDate,
                        endDate = item.endDate;
                    var groupIndex = source.groupIndex;
                    return _this8.viewDataProvider.isGroupIntersectDateInterval(groupIndex, startDate, endDate)
                });
                if (recurrent && this.isVerticalGrouping) {
                    return this._createRecurrentAppointmentInfos(appointments, resources, allDay)
                }
                return _AppointmentSettingsG.prototype._createAppointmentInfos.call(this, appointments, resources, allDay, recurrent)
            };
            _proto3._createRecurrentAppointmentInfos = function(gridAppointments, resources, allDay) {
                var _this9 = this;
                var result = [];
                gridAppointments.forEach(function(appointment) {
                    var source = appointment.source;
                    var groupIndex = source.groupIndex;
                    var coordinate = _this9.workspace.getCoordinatesByDate(appointment.startDate, groupIndex, allDay);
                    if (coordinate) {
                        (0, _extend.extend)(coordinate, {
                            info: {
                                appointment: appointment,
                                sourceAppointment: source
                            }
                        });
                        result.push(coordinate)
                    }
                });
                return result
            };
            _proto3._cropAppointmentsByStartDayHour = function(appointments, rawAppointment, isAllDay) {
                var _this10 = this;
                return appointments.filter(function(appointment) {
                    var firstViewDate = _this10._getAppointmentFirstViewDate(appointment, rawAppointment);
                    if (!firstViewDate) {
                        return false
                    }
                    var startDayHour = _this10._getViewStartDayHour(firstViewDate);
                    var startDate = new Date(appointment.startDate);
                    appointment.startDate = _this10._getAppointmentResultDate({
                        appointment: appointment,
                        rawAppointment: rawAppointment,
                        startDate: startDate,
                        startDayHour: startDayHour,
                        firstViewDate: firstViewDate
                    });
                    return !isAllDay ? appointment.endDate > appointment.startDate : true
                })
            };
            _proto3._createRecurrenceAppointments = function(appointment, resources) {
                var _this11 = this;
                var duration = appointment.duration;
                var result = [];
                var groupIndices = this.isVerticalGrouping && this.workspace._getGroupCount() ? this._getGroupIndices(resources) : [0];
                groupIndices.forEach(function(groupIndex) {
                    var option = _this11._createRecurrenceOptions(appointment, groupIndex);
                    var generatedStartDates = (0, _recurrence.getRecurrenceProcessor)().generateDates(option);
                    var recurrentInfo = generatedStartDates.map(function(date) {
                        var startDate = new Date(date);
                        var utcDate = _utilsTimeZone.default.createUTCDateWithLocalOffset(date);
                        utcDate.setTime(utcDate.getTime() + duration);
                        var endDate = _utilsTimeZone.default.createDateFromUTCWithLocalOffset(utcDate);
                        return {
                            startDate: startDate,
                            endDate: endDate,
                            groupIndex: groupIndex
                        }
                    });
                    result.push.apply(result, _toConsumableArray(recurrentInfo))
                });
                return result
            };
            _proto3._getViewStartDayHour = function(firstViewDate) {
                return firstViewDate.getHours()
            };
            _proto3._getAppointmentFirstViewDate = function(appointment, rawAppointment) {
                var _this$scheduler$getWo = this.scheduler.getWorkSpace(),
                    viewDataProvider = _this$scheduler$getWo.viewDataProvider;
                var groupIndex = appointment.source.groupIndex;
                var startDate = appointment.startDate,
                    endDate = appointment.endDate;
                var isAllDay = this._isAllDayAppointment(rawAppointment);
                return viewDataProvider.findGroupCellStartDate(groupIndex, startDate, endDate, isAllDay)
            };
            _proto3._updateGroupIndices = function(appointments, itemResources) {
                var _this12 = this;
                var groupIndices = this.isVerticalGrouping ? this._getGroupIndices(itemResources) : [0];
                var result = [];
                groupIndices.forEach(function(groupIndex) {
                    var groupStartDate = _this12.viewDataProvider.getGroupStartDate(groupIndex);
                    if (groupStartDate) {
                        appointments.forEach(function(appointment) {
                            var appointmentCopy = (0, _extend.extend)({}, appointment);
                            appointmentCopy.groupIndex = groupIndex;
                            result.push(appointmentCopy)
                        })
                    }
                });
                return result
            };
            _proto3._getGroupIndices = function(resources) {
                var groupIndices = _AppointmentSettingsG.prototype._getGroupIndices.call(this, resources);
                var _this$scheduler$getWo2 = this.scheduler.getWorkSpace(),
                    viewDataProvider = _this$scheduler$getWo2.viewDataProvider;
                var viewDataGroupIndices = viewDataProvider.getGroupIndices();
                var result = groupIndices.filter(function(groupIndex) {
                    return viewDataGroupIndices.indexOf(groupIndex) !== -1
                });
                return result
            };
            _proto3._createAppointments = function(appointment, resources) {
                var appointments = _AppointmentSettingsG.prototype._createAppointments.call(this, appointment, resources);
                return !appointment.isRecurrent ? this._updateGroupIndices(appointments, resources) : appointments
            };
            _createClass(AppointmentSettingsGeneratorVirtualStrategy, [{
                key: "viewDataProvider",
                get: function() {
                    return this.workspace.viewDataProvider
                }
            }, {
                key: "isVerticalGrouping",
                get: function() {
                    return this.workspace._isVerticalGroupedWorkSpace()
                }
            }]);
            return AppointmentSettingsGeneratorVirtualStrategy
        }(AppointmentSettingsGeneratorBaseStrategy);
        exports.AppointmentSettingsGeneratorVirtualStrategy = AppointmentSettingsGeneratorVirtualStrategy
    },
    /*!*****************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/file_manager.js ***!
      \*****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./file_manager/ui.file_manager */ 857));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _ui.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/file_manager/ui.file_manager.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _notify = _interopRequireDefault(__webpack_require__( /*! ../notify */ 339));
        var _uiFile_manager = __webpack_require__( /*! ./ui.file_manager.common */ 141);
        var _file_items_controller = _interopRequireDefault(__webpack_require__( /*! ./file_items_controller */ 858));
        var _uiFile_manager2 = __webpack_require__( /*! ./ui.file_manager.command_manager */ 859);
        var _uiFile_manager3 = _interopRequireDefault(__webpack_require__( /*! ./ui.file_manager.context_menu */ 860));
        var _uiFile_manager4 = _interopRequireDefault(__webpack_require__( /*! ./ui.file_manager.files_tree_view */ 452));
        var _uiFile_managerItem_list = _interopRequireDefault(__webpack_require__( /*! ./ui.file_manager.item_list.details */ 861));
        var _uiFile_managerItem_list2 = _interopRequireDefault(__webpack_require__( /*! ./ui.file_manager.item_list.thumbnails */ 862));
        var _uiFile_manager5 = _interopRequireDefault(__webpack_require__( /*! ./ui.file_manager.toolbar */ 864));
        var _uiFile_manager6 = _interopRequireDefault(__webpack_require__( /*! ./ui.file_manager.notification */ 865));
        var _uiFile_manager7 = _interopRequireDefault(__webpack_require__( /*! ./ui.file_manager.editing */ 867));
        var _uiFile_manager8 = _interopRequireDefault(__webpack_require__( /*! ./ui.file_manager.breadcrumbs */ 874));
        var _uiFile_manager9 = _interopRequireDefault(__webpack_require__( /*! ./ui.file_manager.adaptivity */ 875));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var FILE_MANAGER_CLASS = "dx-filemanager";
        var FILE_MANAGER_WRAPPER_CLASS = FILE_MANAGER_CLASS + "-wrapper";
        var FILE_MANAGER_CONTAINER_CLASS = FILE_MANAGER_CLASS + "-container";
        var FILE_MANAGER_DIRS_PANEL_CLASS = FILE_MANAGER_CLASS + "-dirs-panel";
        var FILE_MANAGER_INACTIVE_AREA_CLASS = FILE_MANAGER_CLASS + "-inactive-area";
        var FILE_MANAGER_EDITING_CONTAINER_CLASS = FILE_MANAGER_CLASS + "-editing-container";
        var FILE_MANAGER_ITEMS_PANEL_CLASS = FILE_MANAGER_CLASS + "-items-panel";
        var FILE_MANAGER_ITEM_CUSTOM_THUMBNAIL_CLASS = FILE_MANAGER_CLASS + "-item-custom-thumbnail";
        var PARENT_DIRECTORY_KEY_PREFIX = "[*DXPDK*]$40F96F03-FBD8-43DF-91BE-F55F4B8BA871$";
        var VIEW_AREAS = {
            folders: "navPane",
            items: "itemView"
        };
        var FileManager = function(_Widget) {
            _inheritsLoose(FileManager, _Widget);

            function FileManager() {
                return _Widget.apply(this, arguments) || this
            }
            var _proto = FileManager.prototype;
            _proto._initTemplates = function() {};
            _proto._initMarkup = function() {
                _Widget.prototype._initMarkup.call(this);
                this._initActions();
                this._firstItemViewLoad = true;
                this._lockSelectionProcessing = false;
                this._lockFocusedItemProcessing = false;
                this._itemKeyToFocus = void 0;
                this._controller = new _file_items_controller.default({
                    currentPath: this.option("currentPath"),
                    currentPathKeys: this.option("currentPathKeys"),
                    rootText: this.option("rootFolderName"),
                    fileProvider: this.option("fileSystemProvider"),
                    allowedFileExtensions: this.option("allowedFileExtensions"),
                    uploadMaxFileSize: this.option("upload").maxFileSize,
                    uploadChunkSize: this.option("upload").chunkSize,
                    onInitialized: this._onControllerInitialized.bind(this),
                    onDataLoading: this._onDataLoading.bind(this),
                    onSelectedDirectoryChanged: this._onSelectedDirectoryChanged.bind(this)
                });
                this._commandManager = new _uiFile_manager2.FileManagerCommandManager(this.option("permissions"));
                this.$element().addClass(FILE_MANAGER_CLASS);
                this._createNotificationControl();
                this._initCommandManager();
                this._setItemsViewAreaActive(false)
            };
            _proto._createNotificationControl = function() {
                var _this = this;
                var $notificationControl = (0, _renderer.default)("<div>").addClass("dx-filemanager-notification-container").appendTo(this.$element());
                this._notificationControl = this._createComponent($notificationControl, _uiFile_manager6.default, {
                    progressPanelContainer: this.$element(),
                    contentTemplate: function(container, notificationControl) {
                        return _this._createWrapper(container, notificationControl)
                    },
                    onActionProgress: function(e) {
                        return _this._onActionProgress(e)
                    },
                    positionTarget: ".".concat(FILE_MANAGER_CONTAINER_CLASS)
                })
            };
            _proto._createWrapper = function(container, notificationControl) {
                var _this2 = this;
                this._$wrapper = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_WRAPPER_CLASS).appendTo(container);
                this._createEditing(notificationControl);
                var $toolbar = (0, _renderer.default)("<div>").appendTo(this._$wrapper);
                this._toolbar = this._createComponent($toolbar, _uiFile_manager5.default, {
                    commandManager: this._commandManager,
                    generalItems: this.option("toolbar.items"),
                    fileItems: this.option("toolbar.fileSelectionItems"),
                    itemViewMode: this.option("itemView").mode,
                    onItemClick: function(args) {
                        return _this2._actions.onToolbarItemClick(args)
                    }
                });
                this._createAdaptivityControl()
            };
            _proto._createAdaptivityControl = function() {
                var _this3 = this;
                var $container = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_CONTAINER_CLASS).appendTo(this._$wrapper);
                this._adaptivityControl = this._createComponent($container, _uiFile_manager9.default, {
                    drawerTemplate: function(container) {
                        return _this3._createFilesTreeView(container)
                    },
                    contentTemplate: function(container) {
                        return _this3._createItemsPanel(container)
                    },
                    onAdaptiveStateChanged: function(e) {
                        return _this3._onAdaptiveStateChanged(e)
                    }
                })
            };
            _proto._createEditing = function(notificationControl) {
                var _this4 = this;
                var $editingContainer = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_EDITING_CONTAINER_CLASS).appendTo(this.$element());
                this._editing = this._createComponent($editingContainer, _uiFile_manager7.default, {
                    controller: this._controller,
                    model: {
                        getMultipleSelectedItems: this._getMultipleSelectedItems.bind(this)
                    },
                    getItemThumbnail: this._getItemThumbnailInfo.bind(this),
                    notificationControl: notificationControl,
                    uploadDropZonePlaceholderContainer: this.$element(),
                    onSuccess: function(_ref) {
                        var updatedOnlyFiles = _ref.updatedOnlyFiles;
                        return _this4._redrawComponent(updatedOnlyFiles)
                    },
                    onCreating: function() {
                        return _this4._setItemsViewAreaActive(false)
                    },
                    onError: function(e) {
                        return _this4._onEditingError(e)
                    }
                })
            };
            _proto._createItemsPanel = function($container) {
                this._$itemsPanel = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_ITEMS_PANEL_CLASS).appendTo($container);
                this._createBreadcrumbs(this._$itemsPanel);
                this._createItemView(this._$itemsPanel);
                if (this._commandManager.isCommandAvailable("upload")) {
                    this._editing.setUploaderDropZone(this._$itemsPanel)
                }
            };
            _proto._createFilesTreeView = function(container) {
                var _this5 = this;
                this._filesTreeViewContextMenu = this._createContextMenu(false, VIEW_AREAS.folders);
                var $filesTreeView = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_DIRS_PANEL_CLASS).appendTo(container);
                this._filesTreeView = this._createComponent($filesTreeView, _uiFile_manager4.default, {
                    storeExpandedState: true,
                    contextMenu: this._filesTreeViewContextMenu,
                    getDirectories: this.getDirectories.bind(this),
                    getCurrentDirectory: this._getCurrentDirectory.bind(this),
                    onDirectoryClick: this._onFilesTreeViewDirectoryClick.bind(this),
                    onClick: function() {
                        return _this5._setItemsViewAreaActive(false)
                    }
                });
                this._filesTreeView.updateCurrentDirectory()
            };
            _proto._createItemView = function($container, viewMode) {
                var _this6 = this;
                this._itemViewContextMenu = this._createContextMenu(true, VIEW_AREAS.items);
                var itemViewOptions = this.option("itemView");
                var options = {
                    selectionMode: this.option("selectionMode"),
                    selectedItemKeys: this.option("selectedItemKeys"),
                    focusedItemKey: this.option("focusedItemKey"),
                    contextMenu: this._itemViewContextMenu,
                    getItems: this._getItemViewItems.bind(this),
                    onError: function(_ref2) {
                        var error = _ref2.error;
                        return _this6._showError(error)
                    },
                    onSelectionChanged: this._onItemViewSelectionChanged.bind(this),
                    onFocusedItemChanged: this._onItemViewFocusedItemChanged.bind(this),
                    onSelectedItemOpened: this._onSelectedItemOpened.bind(this),
                    onContextMenuShowing: function() {
                        return _this6._onContextMenuShowing(VIEW_AREAS.items)
                    },
                    getItemThumbnail: this._getItemThumbnailInfo.bind(this),
                    customizeDetailColumns: this.option("customizeDetailColumns"),
                    detailColumns: this.option("itemView.details.columns")
                };
                var $itemView = (0, _renderer.default)("<div>").appendTo($container);
                viewMode = viewMode || itemViewOptions.mode;
                var widgetClass = "thumbnails" === viewMode ? _uiFile_managerItem_list2.default : _uiFile_managerItem_list.default;
                this._itemView = this._createComponent($itemView, widgetClass, options);
                _events_engine.default.on($itemView, "click", this._onItemViewClick.bind(this))
            };
            _proto._createBreadcrumbs = function($container) {
                var _this7 = this;
                var $breadcrumbs = (0, _renderer.default)("<div>").appendTo($container);
                this._breadcrumbs = this._createComponent($breadcrumbs, _uiFile_manager8.default, {
                    rootFolderDisplayName: this.option("rootFolderName"),
                    onCurrentDirectoryChanging: function(_ref3) {
                        var currentDirectory = _ref3.currentDirectory;
                        return _this7._setCurrentDirectory(currentDirectory, true)
                    }
                });
                this._breadcrumbs.setCurrentDirectory(this._getCurrentDirectory())
            };
            _proto._createContextMenu = function(isolateCreationItemCommands, viewArea) {
                var _this8 = this;
                var $contextMenu = (0, _renderer.default)("<div>").appendTo(this._$wrapper);
                return this._createComponent($contextMenu, _uiFile_manager3.default, {
                    commandManager: this._commandManager,
                    items: this.option("contextMenu.items"),
                    onItemClick: function(args) {
                        return _this8._actions.onContextMenuItemClick(args)
                    },
                    onContextMenuShowing: function() {
                        return _this8._onContextMenuShowing(viewArea)
                    },
                    isolateCreationItemCommands: isolateCreationItemCommands,
                    viewArea: viewArea
                })
            };
            _proto._initCommandManager = function() {
                var _this9 = this;
                var actions = (0, _extend.extend)(this._editing.getCommandActions(), {
                    refresh: function() {
                        return _this9._refreshAndShowProgress()
                    },
                    thumbnails: function() {
                        return _this9.option("itemView.mode", "thumbnails")
                    },
                    details: function() {
                        return _this9.option("itemView.mode", "details")
                    },
                    clearSelection: function() {
                        return _this9._clearSelection()
                    },
                    showNavPane: function() {
                        return _this9._adaptivityControl.toggleDrawer()
                    }
                });
                this._commandManager.registerActions(actions)
            };
            _proto._onFilesTreeViewDirectoryClick = function(_ref4) {
                var itemData = _ref4.itemData;
                this._setCurrentDirectory(itemData);
                this._setItemsViewAreaActive(false)
            };
            _proto._onItemViewSelectionChanged = function(_ref5) {
                var selectedItemInfos = _ref5.selectedItemInfos,
                    selectedItems = _ref5.selectedItems,
                    selectedItemKeys = _ref5.selectedItemKeys,
                    currentSelectedItemKeys = _ref5.currentSelectedItemKeys,
                    currentDeselectedItemKeys = _ref5.currentDeselectedItemKeys;
                this._lockSelectionProcessing = true;
                this.option("selectedItemKeys", selectedItemKeys);
                this._lockSelectionProcessing = false;
                this._actions.onSelectionChanged({
                    selectedItems: selectedItems,
                    selectedItemKeys: selectedItemKeys,
                    currentSelectedItemKeys: currentSelectedItemKeys,
                    currentDeselectedItemKeys: currentDeselectedItemKeys
                });
                this._updateToolbar(selectedItemInfos);
                this._setItemsViewAreaActive(true)
            };
            _proto._onItemViewFocusedItemChanged = function(e) {
                this._lockFocusedItemProcessing = true;
                this.option("focusedItemKey", e.itemKey);
                this._lockFocusedItemProcessing = false;
                this._actions.onFocusedItemChanged({
                    item: e.item,
                    itemElement: e.itemElement
                })
            };
            _proto._onAdaptiveStateChanged = function(_ref6) {
                var enabled = _ref6.enabled;
                this._commandManager.setCommandEnabled("showNavPane", enabled);
                this._updateToolbar()
            };
            _proto._onActionProgress = function(_ref7) {
                var message = _ref7.message,
                    status = _ref7.status;
                this._toolbar.updateRefreshItem(message, status);
                this._updateToolbar()
            };
            _proto._onEditingError = function(e) {
                var args = (0, _uiFile_manager.extendAttributes)({}, e, ["errorCode", "errorText", "fileSystemItem"]);
                this._actions.onErrorOccurred(args);
                e.errorText = args.errorText
            };
            _proto._refreshAndShowProgress = function() {
                var _this10 = this;
                return (0, _deferred.when)(this._notificationControl.tryShowProgressPanel(), this._controller.refresh()).then(function() {
                    return _this10._filesTreeView.refresh()
                })
            };
            _proto._updateToolbar = function(selectedItems) {
                var items = selectedItems || this._getSelectedItemInfos();
                this._toolbar.update(items)
            };
            _proto._setItemsViewAreaActive = function(active) {
                if (this._itemsViewAreaActive === active) {
                    return
                }
                this._itemsViewAreaActive = active;
                var $activeArea = null;
                var $inactiveArea = null;
                if (active) {
                    $activeArea = this._itemView.$element();
                    $inactiveArea = this._filesTreeView.$element()
                } else {
                    $activeArea = this._filesTreeView.$element();
                    $inactiveArea = this._itemView.$element()
                }
                $activeArea.removeClass(FILE_MANAGER_INACTIVE_AREA_CLASS);
                $inactiveArea.addClass(FILE_MANAGER_INACTIVE_AREA_CLASS)
            };
            _proto._switchView = function(viewMode) {
                this._disposeWidget(this._itemView.option("contextMenu"));
                this._disposeWidget(this._itemView);
                this._createItemView(this._$itemsPanel, viewMode);
                this._toolbar.option({
                    itemViewMode: viewMode
                })
            };
            _proto._disposeWidget = function(widget) {
                widget.dispose();
                widget.$element().remove()
            };
            _proto._clearSelection = function() {
                this._itemView.clearSelection()
            };
            _proto._getMultipleSelectedItems = function() {
                return this._itemsViewAreaActive ? this._getSelectedItemInfos() : [this._getCurrentDirectory()]
            };
            _proto._showError = function(message) {
                this._showNotification(message, false)
            };
            _proto._showNotification = function(message, isSuccess) {
                (0, _notify.default)({
                    message: message,
                    width: 450
                }, isSuccess ? "success" : "error", 5e3)
            };
            _proto._redrawComponent = function(onlyFileItemsView) {
                var _this11 = this;
                this._itemView.refresh().then(function() {
                    return !onlyFileItemsView && _this11._filesTreeView.refresh()
                })
            };
            _proto._getItemViewItems = function() {
                var _this12 = this;
                var showFolders = this.option("itemView").showFolders;
                var result = this._controller.getCurrentItems(!showFolders);
                this._updateToolbarWithSelectionOnFirstLoad(result);
                if (this.option("itemView.showParentFolder")) {
                    result = (0, _deferred.when)(result).then(function(items) {
                        return _this12._getPreparedItemViewItems(items)
                    })
                }
                return result
            };
            _proto._updateToolbarWithSelectionOnFirstLoad = function(itemsResult) {
                var _this13 = this;
                if (!this._firstItemViewLoad) {
                    return
                }
                this._firstItemViewLoad = false;
                var selectedItemKeys = this.option("selectedItemKeys");
                if (selectedItemKeys.length > 0) {
                    (0, _deferred.when)(itemsResult).done(function(items) {
                        var selectedItems = (0, _uiFile_manager.findItemsByKeys)(items, selectedItemKeys);
                        if (selectedItems.length > 0) {
                            _this13._updateToolbar(selectedItems)
                        }
                    })
                }
            };
            _proto._getPreparedItemViewItems = function(items) {
                var selectedDir = this._getCurrentDirectory();
                if (selectedDir.fileItem.isRoot()) {
                    return items
                }
                var parentDirItem = selectedDir.fileItem.createClone();
                parentDirItem.isParentFolder = true;
                parentDirItem.name = "..";
                parentDirItem.relativeName = "..";
                parentDirItem.key = "".concat(PARENT_DIRECTORY_KEY_PREFIX).concat(selectedDir.fileItem.key);
                var itemsCopy = _toConsumableArray(items);
                itemsCopy.unshift({
                    fileItem: parentDirItem,
                    icon: "parentfolder"
                });
                return itemsCopy
            };
            _proto._onItemViewClick = function() {
                this._setItemsViewAreaActive(true)
            };
            _proto._onContextMenuShowing = function(viewArea) {
                this._setItemsViewAreaActive(viewArea === VIEW_AREAS.items)
            };
            _proto._getItemThumbnailInfo = function(fileInfo) {
                var func = this.option("customizeThumbnail");
                var thumbnail = (0, _type.isFunction)(func) ? func(fileInfo.fileItem) : fileInfo.fileItem.thumbnail;
                if (thumbnail) {
                    return {
                        thumbnail: thumbnail,
                        cssClass: FILE_MANAGER_ITEM_CUSTOM_THUMBNAIL_CLASS
                    }
                }
                return {
                    thumbnail: fileInfo.icon
                }
            };
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_Widget.prototype._getDefaultOptions.call(this), {
                    fileSystemProvider: null,
                    currentPath: "",
                    currentPathKeys: [],
                    rootFolderName: _message.default.format("dxFileManager-rootDirectoryName"),
                    selectionMode: "multiple",
                    selectedItemKeys: [],
                    focusedItemKey: void 0,
                    toolbar: {
                        items: ["showNavPane", "create", "upload", "switchView", {
                            name: "separator",
                            location: "after"
                        }, "refresh"],
                        fileSelectionItems: ["download", "separator", "move", "copy", "rename", "separator", "delete", "clearSelection", {
                            name: "separator",
                            location: "after"
                        }, "refresh"]
                    },
                    contextMenu: {
                        items: ["create", "upload", "rename", "move", "copy", "delete", "refresh", "download"]
                    },
                    itemView: {
                        details: {
                            columns: ["thumbnail", "name", "dateModified", "size"]
                        },
                        mode: "details",
                        showFolders: true,
                        showParentFolder: true
                    },
                    customizeThumbnail: null,
                    customizeDetailColumns: null,
                    onContextMenuItemClick: null,
                    onCurrentDirectoryChanged: null,
                    onSelectedFileOpened: null,
                    onSelectionChanged: null,
                    onFocusedItemChanged: null,
                    onToolbarItemClick: null,
                    onErrorOccurred: null,
                    allowedFileExtensions: [],
                    upload: {
                        maxFileSize: 0,
                        chunkSize: 2e5
                    },
                    permissions: {
                        create: false,
                        copy: false,
                        move: false,
                        "delete": false,
                        rename: false,
                        upload: false,
                        download: false
                    }
                })
            };
            _proto._optionChanged = function(args) {
                var name = args.name;
                switch (name) {
                    case "currentPath":
                        this._controller.setCurrentPath(args.value);
                        break;
                    case "currentPathKeys":
                        this._controller.setCurrentPathByKeys(args.value);
                        break;
                    case "selectedItemKeys":
                        if (!this._lockSelectionProcessing && this._itemView) {
                            this._itemView.option("selectedItemKeys", args.value)
                        }
                        break;
                    case "focusedItemKey":
                        if (!this._lockFocusedItemProcessing && this._itemView) {
                            this._itemView.option("focusedItemKey", args.value)
                        }
                        break;
                    case "fileSystemProvider":
                    case "selectionMode":
                    case "customizeThumbnail":
                    case "customizeDetailColumns":
                    case "rootFolderName":
                    case "allowedFileExtensions":
                    case "permissions":
                    case "upload":
                        this.repaint();
                        break;
                    case "itemView":
                        if ("itemView.mode" === args.fullName) {
                            this._switchView(args.value)
                        } else {
                            this.repaint()
                        }
                        break;
                    case "toolbar":
                        var toolbarOptions = {};
                        if ("toolbar" === args.fullName) {
                            if (args.value.items) {
                                toolbarOptions.generalItems = args.value.items
                            }
                            if (args.value.fileSelectionItems) {
                                toolbarOptions.fileItems = args.value.fileSelectionItems
                            }
                        }
                        if (0 === args.fullName.indexOf("toolbar.items")) {
                            toolbarOptions.generalItems = this.option("toolbar.items")
                        }
                        if (0 === args.fullName.indexOf("toolbar.fileSelectionItems")) {
                            toolbarOptions.fileItems = this.option("toolbar.fileSelectionItems")
                        }
                        this._toolbar.option(toolbarOptions);
                        break;
                    case "contextMenu":
                        if ("contextMenu" === args.fullName && args.value.items || 0 === args.fullName.indexOf("contextMenu.items")) {
                            var contextMenuItems = this.option("contextMenu.items");
                            this._filesTreeViewContextMenu.option("items", contextMenuItems);
                            this._itemViewContextMenu.option("items", contextMenuItems)
                        }
                        break;
                    case "onContextMenuItemClick":
                    case "onCurrentDirectoryChanged":
                    case "onSelectedFileOpened":
                    case "onSelectionChanged":
                    case "onFocusedItemChanged":
                    case "onToolbarItemClick":
                    case "onErrorOccurred":
                        this._actions[name] = this._createActionByOption(name);
                        break;
                    default:
                        _Widget.prototype._optionChanged.call(this, args)
                }
            };
            _proto._initActions = function() {
                this._actions = {
                    onContextMenuItemClick: this._createActionByOption("onContextMenuItemClick"),
                    onCurrentDirectoryChanged: this._createActionByOption("onCurrentDirectoryChanged"),
                    onSelectedFileOpened: this._createActionByOption("onSelectedFileOpened"),
                    onSelectionChanged: this._createActionByOption("onSelectionChanged"),
                    onFocusedItemChanged: this._createActionByOption("onFocusedItemChanged"),
                    onToolbarItemClick: this._createActionByOption("onToolbarItemClick"),
                    onErrorOccurred: this._createActionByOption("onErrorOccurred")
                }
            };
            _proto.executeCommand = function(commandName) {
                return this._commandManager.executeCommand(commandName)
            };
            _proto._setCurrentDirectory = function(directoryInfo, checkActuality) {
                this._controller.setCurrentDirectory(directoryInfo, checkActuality)
            };
            _proto._getCurrentDirectory = function() {
                return this._controller.getCurrentDirectory()
            };
            _proto._onControllerInitialized = function(_ref8) {
                var controller = _ref8.controller;
                this._controller = this._controller || controller;
                var currentDirectory = controller.getCurrentDirectory();
                if (!currentDirectory.fileItem.isRoot()) {
                    this._syncToCurrentDirectory()
                }
            };
            _proto._onDataLoading = function(_ref9) {
                var operation = _ref9.operation;
                var options = null;
                if ("navigation" === operation) {
                    options = {
                        focusedItemKey: this._itemKeyToFocus
                    };
                    this._itemKeyToFocus = void 0
                }
                this._itemView.refresh(options)
            };
            _proto._onSelectedDirectoryChanged = function() {
                var currentDirectory = this._getCurrentDirectory();
                this._syncToCurrentDirectory();
                this._actions.onCurrentDirectoryChanged({
                    directory: currentDirectory.fileItem
                })
            };
            _proto._syncToCurrentDirectory = function() {
                var currentDirectory = this._getCurrentDirectory();
                var currentPath = this._controller.getCurrentPath();
                var currentPathKeys = currentDirectory.fileItem.pathKeys;
                if (this._filesTreeView) {
                    this._filesTreeView.updateCurrentDirectory()
                }
                if (this._breadcrumbs) {
                    this._breadcrumbs.setCurrentDirectory(currentDirectory)
                }
                var options = {
                    currentPath: currentPath
                };
                if (!(0, _common.equalByValue)(this.option("currentPathKeys"), currentPathKeys)) {
                    options.currentPathKeys = currentPathKeys
                }
                this.option(options)
            };
            _proto.getDirectories = function(parentDirectoryInfo, skipNavigationOnError) {
                return this._controller.getDirectories(parentDirectoryInfo, skipNavigationOnError)
            };
            _proto._getSelectedItemInfos = function() {
                return this._itemView ? this._itemView.getSelectedItems() : []
            };
            _proto.refresh = function() {
                return this.executeCommand("refresh")
            };
            _proto.getCurrentDirectory = function() {
                var directoryInfo = this._getCurrentDirectory();
                return directoryInfo && directoryInfo.fileItem || null
            };
            _proto.getSelectedItems = function() {
                return this._getSelectedItemInfos().map(function(itemInfo) {
                    return itemInfo.fileItem
                })
            };
            _proto._onSelectedItemOpened = function(_ref10) {
                var fileItemInfo = _ref10.fileItemInfo;
                var fileItem = fileItemInfo.fileItem;
                if (!fileItem.isDirectory) {
                    this._actions.onSelectedFileOpened({
                        file: fileItem
                    });
                    return
                }
                if (fileItem.isParentFolder) {
                    this._itemKeyToFocus = this._getCurrentDirectory().fileItem.key
                }
                var newCurrentDirectory = fileItem.isParentFolder ? this._getCurrentDirectory().parentDirectory : fileItemInfo;
                this._setCurrentDirectory(newCurrentDirectory);
                if (newCurrentDirectory) {
                    this._filesTreeView.toggleDirectoryExpandedState(newCurrentDirectory.parentDirectory, true)
                }
            };
            return FileManager
        }(_ui.default);
        (0, _component_registrator.default)("dxFileManager", FileManager);
        var _default = FileManager;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/file_manager/file_items_controller.js ***!
      \***************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _provider_base = _interopRequireDefault(__webpack_require__( /*! ../../file_management/provider_base */ 206));
        var _file_system_item = _interopRequireDefault(__webpack_require__( /*! ../../file_management/file_system_item */ 333));
        var _object_provider = _interopRequireDefault(__webpack_require__( /*! ../../file_management/object_provider */ 573));
        var _remote_provider = _interopRequireDefault(__webpack_require__( /*! ../../file_management/remote_provider */ 574));
        var _custom_provider = _interopRequireDefault(__webpack_require__( /*! ../../file_management/custom_provider */ 575));
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../../file_management/errors */ 266));
        var _utils = __webpack_require__( /*! ../../file_management/utils */ 265);
        var _uiFile_manager = __webpack_require__( /*! ./ui.file_manager.common */ 141);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }
        var DEFAULT_ROOT_FILE_SYSTEM_ITEM_NAME = "Files";
        var FileItemsController = function() {
            function FileItemsController(options) {
                options = options || {};
                this._options = (0, _extend.extend)({}, options);
                this._isInitialized = false;
                this._dataLoading = false;
                this._dataLoadingDeferred = null;
                this._rootDirectoryInfo = this._createRootDirectoryInfo(options.rootText);
                this._currentDirectoryInfo = this._rootDirectoryInfo;
                this._defaultIconMap = this._createDefaultIconMap();
                this._securityController = new FileSecurityController({
                    allowedFileExtensions: this._options.allowedFileExtensions,
                    maxFileSize: this._options.uploadMaxFileSize
                });
                this._setProvider(options.fileProvider);
                this._initialize()
            }
            var _proto = FileItemsController.prototype;
            _proto._setProvider = function(fileProvider) {
                this._fileProvider = this._createFileProvider(fileProvider);
                this._resetState()
            };
            _proto._createFileProvider = function(fileProvider) {
                if (!fileProvider) {
                    fileProvider = []
                }
                if (Array.isArray(fileProvider)) {
                    return new _object_provider.default({
                        data: fileProvider
                    })
                }
                if (fileProvider instanceof _provider_base.default) {
                    return fileProvider
                }
                switch (fileProvider.type) {
                    case "remote":
                        return new _remote_provider.default(fileProvider);
                    case "custom":
                        return new _custom_provider.default(fileProvider)
                }
                return new _object_provider.default(fileProvider)
            };
            _proto.setCurrentPath = function(path) {
                var pathParts = (0, _utils.getPathParts)(path);
                var rawPath = _utils.pathCombine.apply(void 0, _toConsumableArray(pathParts));
                if (this.getCurrentDirectory().fileItem.relativeName === rawPath) {
                    return
                }
                return this._setCurrentDirectoryByPathParts(pathParts)
            };
            _proto.setCurrentPathByKeys = function(pathKeys) {
                if ((0, _common.equalByValue)(this.getCurrentDirectory().fileItem.pathKeys, pathKeys, 0, true)) {
                    return
                }
                return this._setCurrentDirectoryByPathParts(pathKeys, true)
            };
            _proto.getCurrentPath = function() {
                var currentPath = "";
                var directory = this.getCurrentDirectory();
                while (directory && !directory.fileItem.isRoot()) {
                    var escapedName = (0, _utils.getEscapedFileName)(directory.fileItem.name);
                    currentPath = (0, _utils.pathCombine)(escapedName, currentPath);
                    directory = directory.parentDirectory
                }
                return currentPath
            };
            _proto.getCurrentDirectory = function() {
                return this._currentDirectoryInfo
            };
            _proto.setCurrentDirectory = function(directoryInfo, checkActuality) {
                if (!directoryInfo) {
                    return
                }
                if (checkActuality) {
                    directoryInfo = this._getActualDirectoryInfo(directoryInfo)
                }
                if (this._currentDirectoryInfo && this._currentDirectoryInfo === directoryInfo) {
                    return
                }
                var requireRaiseSelectedDirectory = this._currentDirectoryInfo.fileItem.key !== directoryInfo.fileItem.key;
                this._currentDirectoryInfo = directoryInfo;
                if (requireRaiseSelectedDirectory && this._isInitialized) {
                    if (!this._dataLoading) {
                        this._raiseDataLoading("navigation")
                    }
                    this._raiseSelectedDirectoryChanged(directoryInfo)
                }
            };
            _proto.getCurrentItems = function(onlyFiles) {
                var _this = this;
                return this._dataLoadingDeferred ? this._dataLoadingDeferred.then(function() {
                    return _this._getCurrentItemsInternal(onlyFiles)
                }) : this._getCurrentItemsInternal(onlyFiles)
            };
            _proto._getCurrentItemsInternal = function(onlyFiles) {
                var _this2 = this;
                var currentDirectory = this.getCurrentDirectory();
                var getItemsPromise = this.getDirectoryContents(currentDirectory);
                return getItemsPromise.then(function(items) {
                    var separatedItems = _this2._separateItemsByType(items);
                    currentDirectory.fileItem.hasSubDirectories = !!separatedItems.folders.length;
                    return onlyFiles ? separatedItems.files : items
                })
            };
            _proto.getDirectories = function(parentDirectoryInfo, skipNavigationOnError) {
                return this.getDirectoryContents(parentDirectoryInfo, skipNavigationOnError).then(function(itemInfos) {
                    return itemInfos.filter(function(info) {
                        return info.fileItem.isDirectory
                    })
                })
            };
            _proto._separateItemsByType = function(itemInfos) {
                var folders = [];
                var files = [];
                itemInfos.forEach(function(info) {
                    return info.fileItem.isDirectory ? folders.push(info) : files.push(info)
                });
                return {
                    folders: folders,
                    files: files
                }
            };
            _proto.getDirectoryContents = function(parentDirectoryInfo, skipNavigationOnError) {
                var _this3 = this;
                if (!parentDirectoryInfo) {
                    return (new _deferred.Deferred).resolve([this._rootDirectoryInfo]).promise()
                }
                if (parentDirectoryInfo.itemsLoaded) {
                    return (new _deferred.Deferred).resolve(parentDirectoryInfo.items).promise()
                }
                var dirKey = parentDirectoryInfo.getInternalKey();
                var loadItemsDeferred = this._loadedItems[dirKey];
                if (loadItemsDeferred) {
                    return loadItemsDeferred
                }
                loadItemsDeferred = this._getFileItems(parentDirectoryInfo, skipNavigationOnError).then(function(fileItems) {
                    fileItems = fileItems || [];
                    parentDirectoryInfo.items = fileItems.map(function(fileItem) {
                        return fileItem.isDirectory && _this3._createDirectoryInfo(fileItem, parentDirectoryInfo) || _this3._createFileInfo(fileItem, parentDirectoryInfo)
                    });
                    parentDirectoryInfo.itemsLoaded = true;
                    return parentDirectoryInfo.items
                });
                this._loadedItems[dirKey] = loadItemsDeferred;
                loadItemsDeferred.always(function() {
                    delete _this3._loadedItems[dirKey]
                });
                return loadItemsDeferred
            };
            _proto._getFileItems = function(parentDirectoryInfo, skipNavigationOnError) {
                var _this4 = this;
                var loadItemsDeferred = null;
                try {
                    loadItemsDeferred = this._fileProvider.getItems(parentDirectoryInfo.fileItem)
                } catch (error) {
                    return this._handleItemLoadError(parentDirectoryInfo, error, skipNavigationOnError)
                }
                return (0, _deferred.when)(loadItemsDeferred).then(function(fileItems) {
                    return _this4._securityController.getAllowedItems(fileItems)
                }, function(errorInfo) {
                    return _this4._handleItemLoadError(parentDirectoryInfo, errorInfo, skipNavigationOnError)
                })
            };
            _proto.createDirectory = function(parentDirectoryInfo, name) {
                var _this5 = this;
                var tempDirInfo = this._createDirInfoByName(name, parentDirectoryInfo);
                var actionInfo = this._createEditActionInfo("create", tempDirInfo, parentDirectoryInfo);
                return this._processEditAction(actionInfo, function() {
                    return _this5._fileProvider.createDirectory(parentDirectoryInfo.fileItem, name).done(function(info) {
                        if (!parentDirectoryInfo.fileItem.isRoot()) {
                            parentDirectoryInfo.fileItem.hasSubDirectories = true
                        }
                        return info
                    })
                }, function() {
                    return _this5._resetDirectoryState(parentDirectoryInfo, true)
                })
            };
            _proto.renameItem = function(fileItemInfo, name) {
                var _this6 = this;
                var actionInfo = this._createEditActionInfo("rename", fileItemInfo, fileItemInfo.parentDirectory, {
                    itemNewName: name
                });
                return this._processEditAction(actionInfo, function() {
                    if (!fileItemInfo.fileItem.isDirectory) {
                        _this6._securityController.validateExtension(name)
                    }
                    return _this6._fileProvider.renameItem(fileItemInfo.fileItem, name)
                }, function() {
                    var parentDirectory = _this6._getActualDirectoryInfo(fileItemInfo.parentDirectory);
                    _this6._resetDirectoryState(parentDirectory);
                    _this6.setCurrentDirectory(parentDirectory)
                })
            };
            _proto.moveItems = function(itemInfos, destinationDirectory) {
                var _this7 = this;
                var items = itemInfos.map(function(i) {
                    return i.fileItem
                });
                var actionInfo = this._createEditActionInfo("move", itemInfos, destinationDirectory);
                return this._processEditAction(actionInfo, function() {
                    return _this7._fileProvider.moveItems(items, destinationDirectory.fileItem)
                }, function() {
                    destinationDirectory = _this7._getActualDirectoryInfo(destinationDirectory);
                    itemInfos.forEach(function(itemInfo) {
                        return _this7._resetDirectoryState(itemInfo.parentDirectory, true)
                    });
                    _this7._resetDirectoryState(destinationDirectory);
                    _this7.setCurrentDirectory(destinationDirectory);
                    destinationDirectory.expanded = true
                })
            };
            _proto.copyItems = function(itemInfos, destinationDirectory) {
                var _this8 = this;
                var items = itemInfos.map(function(i) {
                    return i.fileItem
                });
                var actionInfo = this._createEditActionInfo("copy", itemInfos, destinationDirectory);
                return this._processEditAction(actionInfo, function() {
                    return _this8._fileProvider.copyItems(items, destinationDirectory.fileItem)
                }, function() {
                    destinationDirectory = _this8._getActualDirectoryInfo(destinationDirectory);
                    _this8._resetDirectoryState(destinationDirectory);
                    _this8.setCurrentDirectory(destinationDirectory);
                    destinationDirectory.expanded = true
                })
            };
            _proto.deleteItems = function(itemInfos) {
                var _this9 = this;
                var items = itemInfos.map(function(i) {
                    return i.fileItem
                });
                var directory = itemInfos.length > 0 ? itemInfos[0].parentDirectory : null;
                var actionInfo = this._createEditActionInfo("delete", itemInfos, directory);
                return this._processEditAction(actionInfo, function() {
                    return _this9._fileProvider.deleteItems(items)
                }, function() {
                    itemInfos.forEach(function(itemInfo) {
                        var parentDir = _this9._getActualDirectoryInfo(itemInfo.parentDirectory);
                        _this9._resetDirectoryState(parentDir);
                        _this9.setCurrentDirectory(parentDir)
                    })
                })
            };
            _proto.processUploadSession = function(sessionInfo, uploadDirectoryInfo) {
                var _this10 = this;
                var itemInfos = this._getItemInfosForUploaderFiles(sessionInfo.files, uploadDirectoryInfo);
                var actionInfo = this._createEditActionInfo("upload", itemInfos, uploadDirectoryInfo, {
                    sessionInfo: sessionInfo
                });
                return this._processEditAction(actionInfo, function() {
                    return sessionInfo.deferreds
                }, function() {
                    return _this10._resetDirectoryState(uploadDirectoryInfo, true)
                })
            };
            _proto.uploadFileChunk = function(fileData, chunksInfo, destinationDirectory) {
                this._securityController.validateMaxFileSize(fileData.size);
                this._securityController.validateExtension(fileData.name);
                return (0, _deferred.when)(this._fileProvider.uploadFileChunk(fileData, chunksInfo, destinationDirectory))
            };
            _proto.abortFileUpload = function(fileData, chunksInfo, destinationDirectory) {
                return (0, _deferred.when)(this._fileProvider.abortFileUpload(fileData, chunksInfo, destinationDirectory))
            };
            _proto.getFileUploadChunkSize = function() {
                var chunkSize = this._options.uploadChunkSize;
                if (chunkSize && chunkSize > 0) {
                    return chunkSize
                }
                return this._fileProvider.getFileUploadChunkSize()
            };
            _proto.downloadItems = function(itemInfos) {
                var items = itemInfos.map(function(i) {
                    return i.fileItem
                });
                this._fileProvider.downloadItems(items)
            };
            _proto.getItemContent = function(itemInfos) {
                var items = itemInfos.map(function(i) {
                    return i.fileItem
                });
                return (0, _deferred.when)(this._fileProvider.getItemsContent(items))
            };
            _proto._handleItemLoadError = function(parentDirectoryInfo, errorInfo, skipNavigationOnError) {
                parentDirectoryInfo = this._getActualDirectoryInfo(parentDirectoryInfo);
                var actionInfo = this._createEditActionInfo("getItems", parentDirectoryInfo, parentDirectoryInfo);
                this._raiseEditActionStarting(actionInfo);
                this._raiseEditActionResultAcquired(actionInfo);
                this._raiseEditActionError(actionInfo, {
                    errorId: errorInfo.errorId,
                    errorText: errorInfo.errorText,
                    fileItem: parentDirectoryInfo.fileItem,
                    index: 0
                });
                this._resetDirectoryState(parentDirectoryInfo);
                parentDirectoryInfo.expanded = false;
                if (!skipNavigationOnError) {
                    this.setCurrentDirectory(parentDirectoryInfo.parentDirectory)
                }
                return (new _deferred.Deferred).reject().promise()
            };
            _proto._processEditAction = function(actionInfo, action, completeAction) {
                var _this11 = this;
                var actionResult = null;
                this._raiseEditActionStarting(actionInfo);
                try {
                    actionResult = action()
                } catch (errorInfo) {
                    this._raiseEditActionError(actionInfo, errorInfo);
                    return (new _deferred.Deferred).reject().promise()
                }
                if (!Array.isArray(actionResult)) {
                    actionResult = [actionResult]
                } else {
                    if (actionResult.length > 1) {
                        actionInfo.singleRequest = false
                    }
                }
                this._raiseEditActionResultAcquired(actionInfo);
                return (0, _uiFile_manager.whenSome)(actionResult, function(info) {
                    return _this11._raiseCompleteEditActionItem(actionInfo, info)
                }, function(errorInfo) {
                    return _this11._raiseEditActionItemError(actionInfo, errorInfo)
                }).then(function() {
                    completeAction();
                    _this11._raiseCompleteEditAction(actionInfo)
                })
            };
            _proto._createEditActionInfo = function(name, targetItemInfos, directory, customData) {
                targetItemInfos = Array.isArray(targetItemInfos) ? targetItemInfos : [targetItemInfos];
                customData = customData || {};
                var items = targetItemInfos.map(function(itemInfo) {
                    return itemInfo.fileItem
                });
                return {
                    name: name,
                    itemInfos: targetItemInfos,
                    items: items,
                    directory: directory,
                    customData: customData,
                    singleRequest: true
                }
            };
            _proto._getItemInfosForUploaderFiles = function(files, parentDirectoryInfo) {
                var pathInfo = this._getPathInfo(parentDirectoryInfo);
                var result = [];
                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    var item = new _file_system_item.default(pathInfo, file.name, false);
                    var itemInfo = this._createFileInfo(item, parentDirectoryInfo);
                    result.push(itemInfo)
                }
                return result
            };
            _proto.refresh = function() {
                var _this12 = this;
                if (this._lockRefresh) {
                    return this._refreshDeferred
                }
                this._lockRefresh = true;
                return this._executeDataLoad(function() {
                    return _this12._refreshDeferred = _this12._refreshInternal()
                }, "refresh")
            };
            _proto._refreshInternal = function() {
                var _this13 = this;
                var cachedRootInfo = {
                    items: this._rootDirectoryInfo.items
                };
                var selectedKeyParts = this._getDirectoryPathKeyParts(this.getCurrentDirectory());
                this._resetDirectoryState(this._rootDirectoryInfo);
                return this._loadItemsRecursive(this._rootDirectoryInfo, cachedRootInfo).then(function() {
                    var dirInfo = _this13._findDirectoryByPathKeyParts(selectedKeyParts);
                    _this13.setCurrentDirectory(dirInfo);
                    delete _this13._lockRefresh
                })
            };
            _proto._loadItemsRecursive = function(directoryInfo, cachedDirectoryInfo) {
                var _this14 = this;
                return this.getDirectories(directoryInfo).then(function(dirInfos) {
                    var itemDeferreds = [];
                    var _loop = function(i) {
                        var cachedItem = (0, _array.find)(cachedDirectoryInfo.items, function(cache) {
                            return dirInfos[i].fileItem.key === cache.fileItem.key
                        });
                        if (!cachedItem) {
                            return "continue"
                        }
                        dirInfos[i].expanded = cachedItem.expanded;
                        if (dirInfos[i].expanded) {
                            itemDeferreds.push(_this14._loadItemsRecursive(dirInfos[i], cachedItem))
                        }
                    };
                    for (var i = 0; i < dirInfos.length; i++) {
                        var _ret = _loop(i);
                        if ("continue" === _ret) {
                            continue
                        }
                    }
                    return (0, _uiFile_manager.whenSome)(itemDeferreds)
                }, function() {
                    return null
                })
            };
            _proto._initialize = function() {
                var _this15 = this;
                var result = this._options.currentPathKeys && this._options.currentPathKeys.length ? this.setCurrentPathByKeys(this._options.currentPathKeys) : this.setCurrentPath(this._options.currentPath);
                var completeInitialization = function() {
                    _this15._isInitialized = true;
                    _this15._raiseInitialized()
                };
                if (result) {
                    (0, _deferred.when)(result).always(completeInitialization)
                } else {
                    completeInitialization()
                }
            };
            _proto._setCurrentDirectoryByPathParts = function(pathParts, useKeys) {
                var _this16 = this;
                return this._executeDataLoad(function() {
                    return _this16._setCurrentDirectoryByPathPartsInternal(pathParts, useKeys)
                }, "navigation")
            };
            _proto._setCurrentDirectoryByPathPartsInternal = function(pathParts, useKeys) {
                var _this17 = this;
                return this._getDirectoryByPathParts(this._rootDirectoryInfo, pathParts, useKeys).then(function(directoryInfo) {
                    for (var info = directoryInfo.parentDirectory; info; info = info.parentDirectory) {
                        info.expanded = true
                    }
                    _this17.setCurrentDirectory(directoryInfo)
                })
            };
            _proto._executeDataLoad = function(action, operation) {
                var _this18 = this;
                this._dataLoading = true;
                this._dataLoadingDeferred = new _deferred.Deferred;
                if (this._isInitialized) {
                    this._raiseDataLoading(operation)
                }
                return action().always(function() {
                    _this18._dataLoadingDeferred.resolve();
                    _this18._dataLoadingDeferred = null;
                    _this18._dataLoading = false
                })
            };
            _proto._getDirectoryByPathParts = function(parentDirectoryInfo, pathParts, useKeys) {
                var _this19 = this;
                if (pathParts.length < 1) {
                    return (new _deferred.Deferred).resolve(parentDirectoryInfo).promise()
                }
                var fieldName = useKeys ? "key" : "name";
                return this.getDirectories(parentDirectoryInfo).then(function(dirInfos) {
                    var subDirInfo = (0, _array.find)(dirInfos, function(d) {
                        return d.fileItem[fieldName] === pathParts[0]
                    });
                    if (!subDirInfo) {
                        return (new _deferred.Deferred).reject().promise()
                    }
                    var restPathParts = _toConsumableArray(pathParts).splice(1);
                    return _this19._getDirectoryByPathParts(subDirInfo, restPathParts, useKeys)
                })
            };
            _proto._getDirectoryPathKeyParts = function(directoryInfo) {
                var pathParts = [];
                while (directoryInfo && directoryInfo.parentDirectory) {
                    pathParts.unshift(directoryInfo.fileItem.key);
                    directoryInfo = directoryInfo.parentDirectory
                }
                return pathParts
            };
            _proto._findDirectoryByPathKeyParts = function(keyParts) {
                var selectedDirInfo = this._rootDirectoryInfo;
                if (0 === keyParts.length) {
                    return selectedDirInfo
                }
                var i = 0;
                var newSelectedDir = selectedDirInfo;
                while (newSelectedDir && i < keyParts.length) {
                    newSelectedDir = (0, _array.find)(selectedDirInfo.items, function(info) {
                        return info.fileItem.key === keyParts[i]
                    });
                    if (newSelectedDir) {
                        selectedDirInfo = newSelectedDir
                    }
                    i++
                }
                return selectedDirInfo
            };
            _proto._getActualDirectoryInfo = function(directoryInfo) {
                var keys = this._getDirectoryPathKeyParts(directoryInfo);
                return this._findDirectoryByPathKeyParts(keys)
            };
            _proto._createDirInfoByName = function(name, parentDirectoryInfo) {
                var dirPathInfo = this._getPathInfo(parentDirectoryInfo);
                var fileItem = new _file_system_item.default(dirPathInfo, name, true);
                return this._createDirectoryInfo(fileItem, parentDirectoryInfo)
            };
            _proto._createDirectoryInfo = function(fileItem, parentDirectoryInfo) {
                return (0, _extend.extend)(this._createFileInfo(fileItem, parentDirectoryInfo), {
                    icon: "folder",
                    expanded: fileItem.isRoot(),
                    items: []
                })
            };
            _proto._createFileInfo = function(fileItem, parentDirectoryInfo) {
                return {
                    fileItem: fileItem,
                    parentDirectory: parentDirectoryInfo,
                    icon: this._getFileItemDefaultIcon(fileItem),
                    getInternalKey: function() {
                        return "FIK_".concat(this.fileItem.key)
                    },
                    getDisplayName: function() {
                        return this.displayName || this.fileItem.name
                    }
                }
            };
            _proto._resetDirectoryState = function(directoryInfo, isActualDirectoryRequired) {
                if (isActualDirectoryRequired) {
                    directoryInfo = this._getActualDirectoryInfo(directoryInfo)
                }
                directoryInfo.itemsLoaded = false;
                directoryInfo.items = []
            };
            _proto._getFileItemDefaultIcon = function(fileItem) {
                if (fileItem.isDirectory) {
                    return "folder"
                }
                var extension = fileItem.getFileExtension();
                var icon = this._defaultIconMap[extension];
                return icon || "doc"
            };
            _proto._createDefaultIconMap = function() {
                var result = {
                    ".txt": "txtfile",
                    ".rtf": "rtffile",
                    ".doc": "docfile",
                    ".docx": "docxfile",
                    ".xls": "xlsfile",
                    ".xlsx": "xlsxfile",
                    ".ppt": "pptfile",
                    ".pptx": "pptxfile",
                    ".pdf": "pdffile"
                };
                [".png", ".gif", ".jpg", ".jpeg", ".ico", ".bmp"].forEach(function(extension) {
                    result[extension] = "image"
                });
                return result
            };
            _proto._createRootDirectoryInfo = function(text) {
                var rootDirectory = new _file_system_item.default(null, "", true);
                var result = this._createDirectoryInfo(rootDirectory, null);
                result.displayName = text || DEFAULT_ROOT_FILE_SYSTEM_ITEM_NAME;
                return result
            };
            _proto._raiseInitialized = function() {
                var e = {
                    controller: this
                };
                if (this._options.onInitialized) {
                    this._options.onInitialized(e)
                }
            };
            _proto._raiseDataLoading = function(operation) {
                if (this._options.onDataLoading) {
                    this._options.onDataLoading({
                        operation: operation
                    })
                }
            };
            _proto._raiseSelectedDirectoryChanged = function(directoryInfo) {
                var e = {
                    selectedDirectoryInfo: directoryInfo
                };
                if (this._options.onSelectedDirectoryChanged) {
                    this._options.onSelectedDirectoryChanged(e)
                }
            };
            _proto._raiseEditActionStarting = function(actionInfo) {
                if (this._options.onEditActionStarting) {
                    this._options.onEditActionStarting(actionInfo)
                }
            };
            _proto._raiseEditActionResultAcquired = function(actionInfo) {
                if (this._options.onEditActionResultAcquired) {
                    this._options.onEditActionResultAcquired(actionInfo)
                }
            };
            _proto._raiseEditActionError = function(actionInfo, errorInfo) {
                if (this._options.onEditActionError) {
                    this._options.onEditActionError(actionInfo, errorInfo)
                }
            };
            _proto._raiseEditActionItemError = function(actionInfo, errorInfo) {
                if (this._options.onEditActionItemError) {
                    this._options.onEditActionItemError(actionInfo, errorInfo)
                }
            };
            _proto._raiseCompleteEditActionItem = function(actionInfo, info) {
                if (this._options.onCompleteEditActionItem) {
                    this._options.onCompleteEditActionItem(actionInfo, info)
                }
            };
            _proto._raiseCompleteEditAction = function(actionInfo) {
                if (this._options.onCompleteEditAction) {
                    this._options.onCompleteEditAction(actionInfo)
                }
            };
            _proto._resetState = function() {
                this._selectedDirectory = null;
                this._rootDirectoryInfo.items = [];
                this._loadedItems = {}
            };
            _proto._getPathInfo = function(directoryInfo) {
                var pathInfo = [];
                for (var dirInfo = directoryInfo; dirInfo && !dirInfo.fileItem.isRoot(); dirInfo = dirInfo.parentDirectory) {
                    pathInfo.unshift({
                        key: dirInfo.fileItem.key,
                        name: dirInfo.fileItem.name
                    })
                }
                return pathInfo
            };
            _proto.on = function(eventName, eventHandler) {
                var finalEventName = "on".concat(eventName);
                this._options[finalEventName] = eventHandler
            };
            return FileItemsController
        }();
        exports.default = FileItemsController;
        var FileSecurityController = function() {
            function FileSecurityController(options) {
                var _this20 = this;
                var defaultOptions = {
                    allowedFileExtensions: [],
                    maxFileSize: 0
                };
                this._options = (0, _extend.extend)(defaultOptions, options);
                this._extensionsMap = {};
                this._allowedFileExtensions.forEach(function(extension) {
                    _this20._extensionsMap[extension.toUpperCase()] = true
                })
            }
            var _proto2 = FileSecurityController.prototype;
            _proto2.getAllowedItems = function(items) {
                var _this21 = this;
                if (0 === this._allowedFileExtensions.length) {
                    return items
                }
                return items.filter(function(item) {
                    return item.isDirectory || _this21._isValidExtension(item.name)
                })
            };
            _proto2.validateExtension = function(name) {
                if (!this._isValidExtension(name)) {
                    this._throwError(_errors.default.WrongFileExtension)
                }
            };
            _proto2.validateMaxFileSize = function(size) {
                if (this._maxFileSize && size > this._maxFileSize) {
                    this._throwError(_errors.default.MaxFileSizeExceeded)
                }
            };
            _proto2._isValidExtension = function(name) {
                if (0 === this._allowedFileExtensions.length) {
                    return true
                }
                var extension = (0, _utils.getFileExtension)(name).toUpperCase();
                return this._extensionsMap[extension]
            };
            _proto2._throwError = function(errorId) {
                throw {
                    errorId: errorId
                }
            };
            _createClass(FileSecurityController, [{
                key: "_allowedFileExtensions",
                get: function() {
                    return this._options.allowedFileExtensions
                }
            }, {
                key: "_maxFileSize",
                get: function() {
                    return this._options.maxFileSize
                }
            }]);
            return FileSecurityController
        }();
        module.exports = exports.default
    },
    /*!*************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/file_manager/ui.file_manager.command_manager.js ***!
      \*************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.FileManagerCommandManager = void 0;
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var FileManagerCommandManager = function() {
            function FileManagerCommandManager(permissions) {
                this._actions = {};
                this._permissions = permissions || {};
                this._initCommands()
            }
            var _proto = FileManagerCommandManager.prototype;
            _proto._initCommands = function() {
                var _this = this;
                this._commands = [{
                    name: "create",
                    text: _message.default.format("dxFileManager-commandCreate"),
                    icon: "newfolder",
                    enabled: this._permissions.create,
                    noFileItemRequired: true
                }, {
                    name: "rename",
                    text: _message.default.format("dxFileManager-commandRename"),
                    icon: "rename",
                    enabled: this._permissions.rename,
                    isSingleFileItemCommand: true
                }, {
                    name: "move",
                    text: _message.default.format("dxFileManager-commandMove"),
                    icon: "movetofolder",
                    enabled: this._permissions.move
                }, {
                    name: "copy",
                    text: _message.default.format("dxFileManager-commandCopy"),
                    icon: "copy",
                    enabled: this._permissions.copy
                }, {
                    name: "delete",
                    text: _message.default.format("dxFileManager-commandDelete"),
                    icon: "trash",
                    enabled: this._permissions.delete
                }, {
                    name: "download",
                    text: _message.default.format("dxFileManager-commandDownload"),
                    icon: "download",
                    enabled: this._permissions.download
                }, {
                    name: "upload",
                    text: _message.default.format("dxFileManager-commandUpload"),
                    icon: "upload",
                    enabled: this._permissions.upload,
                    noFileItemRequired: true
                }, {
                    name: "refresh",
                    text: _message.default.format("dxFileManager-commandRefresh"),
                    icon: "dx-filemanager-i dx-filemanager-i-refresh",
                    enabled: true,
                    noFileItemRequired: true
                }, {
                    name: "thumbnails",
                    text: _message.default.format("dxFileManager-commandThumbnails"),
                    icon: "mediumiconslayout",
                    enabled: true,
                    noFileItemRequired: true
                }, {
                    name: "details",
                    text: _message.default.format("dxFileManager-commandDetails"),
                    icon: "detailslayout",
                    enabled: true,
                    noFileItemRequired: true
                }, {
                    name: "clearSelection",
                    text: _message.default.format("dxFileManager-commandClearSelection"),
                    icon: "remove",
                    enabled: true
                }, {
                    name: "showNavPane",
                    hint: _message.default.format("dxFileManager-commandShowNavPane"),
                    icon: "menu",
                    enabled: false,
                    noFileItemRequired: true
                }];
                this._commandMap = {};
                this._commands.forEach(function(command) {
                    _this._commandMap[command.name] = command
                })
            };
            _proto.registerActions = function(actions) {
                this._actions = (0, _extend.extend)(this._actions, actions)
            };
            _proto.executeCommand = function(command, arg) {
                var commandName = (0, _type.isString)(command) ? command : command.name;
                var action = this._actions[commandName];
                if (action) {
                    return action(arg)
                }
            };
            _proto.setCommandEnabled = function(commandName, enabled) {
                var command = this.getCommandByName(commandName);
                if (command) {
                    command.enabled = enabled
                }
            };
            _proto.getCommandByName = function(name) {
                return this._commandMap[name]
            };
            _proto.isCommandAvailable = function(commandName, itemInfos) {
                var command = this.getCommandByName(commandName);
                if (!command || !command.enabled) {
                    return false
                }
                if (command.noFileItemRequired) {
                    return true
                }
                var itemsLength = itemInfos && itemInfos.length || 0;
                if (0 === itemsLength || itemInfos.some(function(item) {
                        return item.fileItem.isRoot() || item.fileItem.isParentFolder
                    })) {
                    return false
                }
                if ("download" === commandName) {
                    return itemInfos.every(function(itemInfo) {
                        return !itemInfo.fileItem.isDirectory
                    })
                }
                return !command.isSingleFileItemCommand || 1 === itemsLength
            };
            return FileManagerCommandManager
        }();
        exports.FileManagerCommandManager = FileManagerCommandManager
    },
    /*!**********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/file_manager/ui.file_manager.context_menu.js ***!
      \**********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _ui2 = _interopRequireDefault(__webpack_require__( /*! ../context_menu/ui.context_menu */ 375));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var FILEMANAGER_CONTEXT_MEMU_CLASS = "dx-filemanager-context-menu";
        var DEFAULT_CONTEXT_MENU_ITEMS = {
            create: {},
            upload: {},
            download: {},
            rename: {},
            move: {},
            copy: {},
            "delete": {},
            refresh: {
                beginGroup: true
            }
        };
        var DEFAULT_ITEM_ALLOWED_PROPERTIES = ["beginGroup", "closeMenuOnClick", "disabled", "icon", "selectable", "selected", "text", "visible"];
        var FileManagerContextMenu = function(_Widget) {
            _inheritsLoose(FileManagerContextMenu, _Widget);

            function FileManagerContextMenu() {
                return _Widget.apply(this, arguments) || this
            }
            var _proto = FileManagerContextMenu.prototype;
            _proto._initMarkup = function() {
                var _this = this;
                this._initActions();
                this._isVisible = false;
                var $menu = (0, _renderer.default)("<div>").appendTo(this.$element());
                this._contextMenu = this._createComponent($menu, _ui2.default, {
                    cssClass: FILEMANAGER_CONTEXT_MEMU_CLASS,
                    showEvent: "",
                    onItemClick: function(args) {
                        return _this._onContextMenuItemClick(args.itemData.name, args)
                    },
                    onShowing: function() {
                        return _this._actions.onContextMenuShowing()
                    },
                    onHidden: function() {
                        return _this._onContextMenuHidden()
                    }
                });
                _Widget.prototype._initMarkup.call(this)
            };
            _proto.showAt = function(fileItems, element, offset, targetFileItem) {
                if (this._isVisible) {
                    this._raiseContextMenuHidden()
                }
                this._isVisible = true;
                var items = this.createContextMenuItems(fileItems, null, targetFileItem);
                var position = {
                    of: element,
                    at: "top left",
                    my: "top left",
                    offset: ""
                };
                if (offset) {
                    position.offset = offset.offsetX + " " + offset.offsetY
                } else {
                    position.my = "left top";
                    position.at = "left bottom";
                    position.boundaryOffset = "1"
                }
                this._contextMenu.option({
                    dataSource: items,
                    target: element,
                    position: position
                });
                this._contextMenu.show()
            };
            _proto.createContextMenuItems = function(fileItems, contextMenuItems, targetFileItem) {
                var _this2 = this;
                this._targetFileItems = fileItems;
                this._targetFileItem = (0, _type.isDefined)(targetFileItem) ? targetFileItem : null === fileItems || void 0 === fileItems ? void 0 : fileItems[0];
                var result = [];
                var itemArray = contextMenuItems || this.option("items");
                itemArray.forEach(function(srcItem) {
                    var commandName = (0, _type.isString)(srcItem) ? srcItem : srcItem.name;
                    var item = _this2._configureItemByCommandName(commandName, srcItem, fileItems, _this2._targetFileItem);
                    if (_this2._isContextMenuItemAvailable(item, fileItems)) {
                        result.push(item)
                    }
                });
                return result
            };
            _proto._isContextMenuItemAvailable = function(menuItem, fileItems) {
                if (!this._isDefaultItem(menuItem.name) || !menuItem._autoHide) {
                    return (0, _common.ensureDefined)(menuItem.visible, true)
                }
                if (this._isIsolatedCreationItemCommand(menuItem.name) && fileItems && fileItems.length) {
                    return false
                }
                return this._commandManager.isCommandAvailable(menuItem.name, fileItems)
            };
            _proto._isIsolatedCreationItemCommand = function(commandName) {
                return ("create" === commandName || "upload" === commandName) && this.option("isolateCreationItemCommands")
            };
            _proto._isDefaultItem = function(commandName) {
                return !!DEFAULT_CONTEXT_MENU_ITEMS[commandName]
            };
            _proto._extendAttributes = function(targetObject, sourceObject, objectKeysArray) {
                objectKeysArray.forEach(function(objectKey) {
                    (0, _extend.extend)(targetObject, (0, _type.isDefined)(sourceObject[objectKey]) ? _defineProperty({}, objectKey, sourceObject[objectKey]) : {})
                })
            };
            _proto._configureItemByCommandName = function(commandName, item, fileItems, targetFileItem) {
                if (!this._isDefaultItem(commandName)) {
                    var res = (0, _extend.extend)(true, {}, item);
                    res.originalItemData = item;
                    this._addItemClickHandler(commandName, res);
                    if (Array.isArray(item.items)) {
                        res.items = this.createContextMenuItems(fileItems, item.items, targetFileItem)
                    }
                    return res
                }
                var result = this._createMenuItemByCommandName(commandName);
                var defaultConfig = DEFAULT_CONTEXT_MENU_ITEMS[commandName];
                (0, _extend.extend)(result, defaultConfig);
                result.originalItemData = item;
                this._extendAttributes(result, item, DEFAULT_ITEM_ALLOWED_PROPERTIES);
                if (!(0, _type.isDefined)(result.visible)) {
                    result._autoHide = true
                }
                if (commandName && !result.name) {
                    (0, _extend.extend)(result, {
                        name: commandName
                    })
                }
                return result
            };
            _proto._createMenuItemByCommandName = function(commandName) {
                var _this$_commandManager = this._commandManager.getCommandByName(commandName),
                    text = _this$_commandManager.text,
                    icon = _this$_commandManager.icon;
                var menuItem = {
                    name: commandName,
                    text: text,
                    icon: icon
                };
                this._addItemClickHandler(commandName, menuItem);
                return menuItem
            };
            _proto._addItemClickHandler = function(commandName, contextMenuItem) {
                var _this3 = this;
                contextMenuItem.onItemClick = function(args) {
                    return _this3._onContextMenuItemClick(commandName, args)
                }
            };
            _proto._onContextMenuItemClick = function(commandName, args) {
                var _this$_targetFileItem;
                var changedArgs = (0, _extend.extend)(true, {}, args);
                changedArgs.itemData = args.itemData.originalItemData;
                changedArgs.fileSystemItem = null === (_this$_targetFileItem = this._targetFileItem) || void 0 === _this$_targetFileItem ? void 0 : _this$_targetFileItem.fileItem;
                changedArgs.viewArea = this.option("viewArea");
                this._actions.onItemClick(changedArgs);
                if (this._isDefaultItem(commandName)) {
                    var targetFileItems = this._isIsolatedCreationItemCommand(commandName) ? null : this._targetFileItems;
                    this._commandManager.executeCommand(commandName, targetFileItems)
                }
            };
            _proto._initActions = function() {
                this._actions = {
                    onContextMenuHidden: this._createActionByOption("onContextMenuHidden"),
                    onContextMenuShowing: this._createActionByOption("onContextMenuShowing"),
                    onItemClick: this._createActionByOption("onItemClick")
                }
            };
            _proto._onContextMenuHidden = function() {
                this._isVisible = false;
                this._raiseContextMenuHidden()
            };
            _proto._raiseContextMenuHidden = function() {
                this._actions.onContextMenuHidden()
            };
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_Widget.prototype._getDefaultOptions.call(this), {
                    commandManager: null,
                    onContextMenuHidden: null,
                    onItemClick: null
                })
            };
            _proto._optionChanged = function(args) {
                var name = args.name;
                switch (name) {
                    case "commandManager":
                        this.repaint();
                        break;
                    case "items":
                        if (this._isVisible) {
                            var items = this.createContextMenuItems(this._targetFileItems);
                            this._contextMenu.option("dataSource", items)
                        }
                        break;
                    case "onItemClick":
                    case "onContextMenuShowing":
                    case "onContextMenuHidden":
                        this._actions[name] = this._createActionByOption(name);
                        break;
                    default:
                        _Widget.prototype._optionChanged.call(this, args)
                }
            };
            _createClass(FileManagerContextMenu, [{
                key: "_commandManager",
                get: function() {
                    return this.option("commandManager")
                }
            }]);
            return FileManagerContextMenu
        }(_ui.default);
        var _default = FileManagerContextMenu;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/file_manager/ui.file_manager.item_list.details.js ***!
      \***************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _uiFile_manager = __webpack_require__( /*! ./ui.file_manager.common */ 141);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../data_grid/ui.data_grid */ 378));
        var _uiFile_manager2 = _interopRequireDefault(__webpack_require__( /*! ./ui.file_manager.item_list */ 454));
        var _uiFile_manager3 = _interopRequireDefault(__webpack_require__( /*! ./ui.file_manager.file_actions_button */ 453));
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var FILE_MANAGER_DETAILS_ITEM_LIST_CLASS = "dx-filemanager-details";
        var FILE_MANAGER_DETAILS_ITEM_THUMBNAIL_CLASS = "dx-filemanager-details-item-thumbnail";
        var FILE_MANAGER_DETAILS_ITEM_NAME_CLASS = "dx-filemanager-details-item-name";
        var FILE_MANAGER_DETAILS_ITEM_NAME_WRAPPER_CLASS = "dx-filemanager-details-item-name-wrapper";
        var FILE_MANAGER_DETAILS_ITEM_IS_DIRECTORY_CLASS = "dx-filemanager-details-item-is-directory";
        var FILE_MANAGER_PARENT_DIRECTORY_ITEM = "dx-filemanager-parent-directory-item";
        var DATA_GRID_DATA_ROW_CLASS = "dx-data-row";
        var DEFAULT_COLUMN_CONFIGS = {
            thumbnail: {
                caption: "",
                calculateSortValue: "isDirectory",
                width: 36,
                alignment: "center",
                cssClass: FILE_MANAGER_DETAILS_ITEM_IS_DIRECTORY_CLASS
            },
            name: {
                caption: _message.default.format("dxFileManager-listDetailsColumnCaptionName")
            },
            dateModified: {
                caption: _message.default.format("dxFileManager-listDetailsColumnCaptionDateModified"),
                width: 110,
                hidingPriority: 1
            },
            size: {
                caption: _message.default.format("dxFileManager-listDetailsColumnCaptionFileSize"),
                width: 90,
                alignment: "right",
                hidingPriority: 0
            },
            isParentFolder: {
                caption: "isParentFolder",
                visible: false,
                sortIndex: 0,
                sortOrder: "asc"
            }
        };
        var FileManagerDetailsItemList = function(_FileManagerItemListB) {
            _inheritsLoose(FileManagerDetailsItemList, _FileManagerItemListB);

            function FileManagerDetailsItemList() {
                return _FileManagerItemListB.apply(this, arguments) || this
            }
            var _proto = FileManagerDetailsItemList.prototype;
            _proto._initMarkup = function() {
                var _this = this;
                this._itemCount = 0;
                this._focusedItem = null;
                this._hasParentDirectoryItem = false;
                this._parentDirectoryItemKey = null;
                this._selectAllCheckBox = null;
                this._selectAllCheckBoxUpdating = false;
                this.$element().addClass(FILE_MANAGER_DETAILS_ITEM_LIST_CLASS);
                this._createFilesView();
                this._contextMenu.option("onContextMenuHidden", function() {
                    return _this._onContextMenuHidden()
                });
                _FileManagerItemListB.prototype._initMarkup.call(this)
            };
            _proto._createFilesView = function() {
                var _this2 = this;
                var $filesView = (0, _renderer.default)("<div>").appendTo(this.$element());
                var selectionMode = this._isMultipleSelectionMode() ? "multiple" : "none";
                this._filesView = this._createComponent($filesView, _ui.default, {
                    dataSource: this._createDataSource(),
                    hoverStateEnabled: true,
                    selection: {
                        mode: selectionMode,
                        showCheckBoxesMode: this._isDesktop() ? "onClick" : "none"
                    },
                    selectedRowKeys: this.option("selectedItemKeys"),
                    focusedRowKey: this.option("focusedItemKey"),
                    focusedRowEnabled: true,
                    allowColumnResizing: true,
                    scrolling: {
                        mode: "virtual"
                    },
                    sorting: {
                        mode: "single",
                        showSortIndexes: false
                    },
                    showColumnLines: false,
                    showRowLines: false,
                    columnHidingEnabled: false,
                    columns: this._createColumns(),
                    onEditorPreparing: this._onEditorPreparing.bind(this),
                    onRowPrepared: this._onRowPrepared.bind(this),
                    onContextMenuPreparing: this._onContextMenuPreparing.bind(this),
                    onSelectionChanged: this._onFilesViewSelectionChanged.bind(this),
                    onFocusedRowChanged: this._onFilesViewFocusedRowChanged.bind(this),
                    onOptionChanged: this._onFilesViewOptionChanged.bind(this),
                    onContentReady: function() {
                        var _this2$_refreshDeferr;
                        return null === (_this2$_refreshDeferr = _this2._refreshDeferred) || void 0 === _this2$_refreshDeferr ? void 0 : _this2$_refreshDeferr.resolve()
                    }
                })
            };
            _proto._createColumns = function() {
                var _this3 = this;
                var columns = this.option("detailColumns");
                columns = columns.slice(0);
                columns = columns.map(function(column) {
                    var extendedItem = column;
                    if ((0, _type.isString)(column)) {
                        extendedItem = {
                            dataField: column
                        }
                    }
                    return _this3._getPreparedColumn(extendedItem)
                });
                var customizeDetailColumns = this.option("customizeDetailColumns");
                if ((0, _type.isFunction)(customizeDetailColumns)) {
                    columns = customizeDetailColumns(columns)
                }
                columns.push(this._getPreparedColumn({
                    dataField: "isParentFolder"
                }));
                columns.forEach(function(column) {
                    return _this3._updateColumnDataField(column)
                });
                return columns
            };
            _proto._getPreparedColumn = function(columnOptions) {
                var result = {};
                var resultCssClass = "";
                if (this._isDefaultColumn(columnOptions.dataField)) {
                    var defaultConfig = (0, _extend.extend)(true, {}, DEFAULT_COLUMN_CONFIGS[columnOptions.dataField]);
                    resultCssClass = defaultConfig.cssClass || "";
                    switch (columnOptions.dataField) {
                        case "thumbnail":
                            defaultConfig.cellTemplate = this._createThumbnailColumnCell.bind(this);
                            defaultConfig.calculateSortValue = "fileItem.".concat(defaultConfig.calculateSortValue);
                            break;
                        case "name":
                            defaultConfig.cellTemplate = this._createNameColumnCell.bind(this);
                            defaultConfig.caption = _message.default.format("dxFileManager-listDetailsColumnCaptionName");
                            break;
                        case "size":
                            defaultConfig.calculateCellValue = this._calculateSizeColumnCellValue.bind(this);
                            defaultConfig.caption = _message.default.format("dxFileManager-listDetailsColumnCaptionFileSize");
                            defaultConfig.calculateSortValue = function(rowData) {
                                return rowData.fileItem.isDirectory ? -1 : rowData.fileItem.size
                            };
                            break;
                        case "dateModified":
                            defaultConfig.caption = _message.default.format("dxFileManager-listDetailsColumnCaptionDateModified")
                    }(0, _extend.extend)(true, result, defaultConfig)
                }(0, _uiFile_manager.extendAttributes)(result, columnOptions, ["alignment", "caption", "dataField", "dataType", "hidingPriority", "sortIndex", "sortOrder", "visible", "visibleIndex", "width"]);
                if (columnOptions.cssClass) {
                    resultCssClass = "".concat(resultCssClass, " ").concat(columnOptions.cssClass)
                }
                if (resultCssClass) {
                    result.cssClass = resultCssClass
                }
                return result
            };
            _proto._updateColumnDataField = function(column) {
                var dataItemSuffix = this._isDefaultColumn(column.dataField) ? "" : "dataItem.";
                column.dataField = "fileItem." + dataItemSuffix + column.dataField;
                return column
            };
            _proto._isDefaultColumn = function(columnDataField) {
                return !!DEFAULT_COLUMN_CONFIGS[columnDataField]
            };
            _proto._onFileItemActionButtonClick = function(_ref) {
                var component = _ref.component,
                    element = _ref.element,
                    event = _ref.event;
                event.stopPropagation();
                var $row = component.$element().closest(this._getItemSelector());
                var fileItemInfo = $row.data("item");
                this._selectItem(fileItemInfo);
                this._showContextMenu(this._getFileItemsForContextMenu(fileItemInfo), element, fileItemInfo);
                this._activeFileActionsButton = component;
                this._activeFileActionsButton.setActive(true)
            };
            _proto._onContextMenuHidden = function() {
                if (this._activeFileActionsButton) {
                    this._activeFileActionsButton.setActive(false)
                }
            };
            _proto._getItemThumbnailCssClass = function() {
                return FILE_MANAGER_DETAILS_ITEM_THUMBNAIL_CLASS
            };
            _proto._getItemSelector = function() {
                return ".".concat(DATA_GRID_DATA_ROW_CLASS)
            };
            _proto._onItemDblClick = function(e) {
                var $row = (0, _renderer.default)(e.currentTarget);
                var fileItemInfo = $row.data("item");
                this._raiseSelectedItemOpened(fileItemInfo)
            };
            _proto._isAllItemsSelected = function() {
                var selectableItemsCount = this._hasParentDirectoryItem ? this._itemCount - 1 : this._itemCount;
                var selectedRowKeys = this._filesView.option("selectedRowKeys");
                if (!selectedRowKeys.length) {
                    return false
                }
                return selectedRowKeys.length >= selectableItemsCount ? true : void 0
            };
            _proto._onEditorPreparing = function(_ref2) {
                var _this4 = this;
                var component = _ref2.component,
                    command = _ref2.command,
                    row = _ref2.row,
                    parentType = _ref2.parentType,
                    editorOptions = _ref2.editorOptions;
                if (!this._filesView) {
                    this._filesView = component
                }
                if ("select" === command && row) {
                    if (this._isParentDirectoryItem(row.data)) {
                        editorOptions.disabled = true
                    }
                } else {
                    if ("headerRow" === parentType) {
                        editorOptions.onInitialized = function(_ref3) {
                            var component = _ref3.component;
                            _this4._selectAllCheckBox = component
                        };
                        editorOptions.value = this._isAllItemsSelected();
                        editorOptions.onValueChanged = function(args) {
                            return _this4._onSelectAllCheckBoxValueChanged(args)
                        }
                    }
                }
            };
            _proto._onSelectAllCheckBoxValueChanged = function(_ref4) {
                var event = _ref4.event,
                    previousValue = _ref4.previousValue,
                    value = _ref4.value;
                if (!event) {
                    if (previousValue && !this._selectAllCheckBoxUpdating && this._selectAllCheckBox) {
                        this._selectAllCheckBox.option("value", previousValue)
                    }
                    return
                }
                if (this._isAllItemsSelected() === value) {
                    return
                }
                if (value) {
                    this._filesView.selectAll()
                } else {
                    this._filesView.deselectAll()
                }
                event.preventDefault()
            };
            _proto._onRowPrepared = function(_ref5) {
                var rowType = _ref5.rowType,
                    rowElement = _ref5.rowElement,
                    data = _ref5.data;
                if ("data" === rowType) {
                    var $row = (0, _renderer.default)(rowElement);
                    $row.data("item", data);
                    if (this._isParentDirectoryItem(data)) {
                        $row.addClass(FILE_MANAGER_PARENT_DIRECTORY_ITEM)
                    }
                }
            };
            _proto._onContextMenuPreparing = function(e) {
                if (!this._isDesktop()) {
                    return
                }
                var fileItems = null;
                var item = null;
                if (e.row && "data" === e.row.rowType) {
                    item = e.row.data;
                    this._selectItem(item);
                    fileItems = this._getFileItemsForContextMenu(item)
                }
                e.items = this._contextMenu.createContextMenuItems(fileItems, null, item);
                this._raiseContextMenuShowing()
            };
            _proto._onFilesViewSelectionChanged = function(_ref6) {
                var component = _ref6.component,
                    selectedRowsData = _ref6.selectedRowsData,
                    selectedRowKeys = _ref6.selectedRowKeys,
                    currentSelectedRowKeys = _ref6.currentSelectedRowKeys,
                    currentDeselectedRowKeys = _ref6.currentDeselectedRowKeys;
                this._filesView = this._filesView || component;
                if (this._selectAllCheckBox) {
                    this._selectAllCheckBoxUpdating = true;
                    this._selectAllCheckBox.option("value", this._isAllItemsSelected());
                    this._selectAllCheckBoxUpdating = false
                }
                var selectedItems = selectedRowsData.map(function(itemInfo) {
                    return itemInfo.fileItem
                });
                this._tryRaiseSelectionChanged({
                    selectedItemInfos: selectedRowsData,
                    selectedItems: selectedItems,
                    selectedItemKeys: selectedRowKeys,
                    currentSelectedItemKeys: currentSelectedRowKeys,
                    currentDeselectedItemKeys: currentDeselectedRowKeys
                })
            };
            _proto._onFilesViewFocusedRowChanged = function(e) {
                var _e$row2;
                if (!this._isMultipleSelectionMode()) {
                    var _e$row;
                    this._selectItemSingleSelection(null === (_e$row = e.row) || void 0 === _e$row ? void 0 : _e$row.data)
                }
                var fileSystemItem = (null === (_e$row2 = e.row) || void 0 === _e$row2 ? void 0 : _e$row2.data.fileItem) || null;
                this._onFocusedItemChanged({
                    item: fileSystemItem,
                    itemKey: null === fileSystemItem || void 0 === fileSystemItem ? void 0 : fileSystemItem.key,
                    itemElement: e.rowElement
                })
            };
            _proto._onFilesViewOptionChanged = function(_ref7) {
                var fullName = _ref7.fullName;
                if (fullName.indexOf("sortOrder") > -1) {
                    this._filesView.columnOption("isParentFolder", {
                        sortOrder: "asc",
                        sortIndex: 0
                    })
                }
            };
            _proto._createThumbnailColumnCell = function(container, cellInfo) {
                this._getItemThumbnailContainer(cellInfo.data).appendTo(container)
            };
            _proto._createNameColumnCell = function(container, cellInfo) {
                var _this5 = this;
                var $button = (0, _renderer.default)("<div>");
                var $name = (0, _renderer.default)("<span>").text(cellInfo.data.fileItem.name).addClass(FILE_MANAGER_DETAILS_ITEM_NAME_CLASS);
                var $wrapper = (0, _renderer.default)("<div>").append($name, $button).addClass(FILE_MANAGER_DETAILS_ITEM_NAME_WRAPPER_CLASS);
                (0, _renderer.default)(container).append($wrapper);
                this._createComponent($button, _uiFile_manager3.default, {
                    onClick: function(e) {
                        return _this5._onFileItemActionButtonClick(e)
                    }
                })
            };
            _proto._calculateSizeColumnCellValue = function(rowData) {
                return rowData.fileItem.isDirectory ? "" : (0, _uiFile_manager.getDisplayFileSize)(rowData.fileItem.size)
            };
            _proto._selectItem = function(fileItemInfo) {
                var selectItemFunc = this._isMultipleSelectionMode() ? this._selectItemMultipleSelection : this._selectItemSingleSelection;
                selectItemFunc.call(this, fileItemInfo)
            };
            _proto._deselectItem = function(item) {
                this._filesView.deselectRows([item.fileItem.key])
            };
            _proto._selectItemSingleSelection = function(fileItemInfo) {
                if (!this._focusedItem || !fileItemInfo || this._focusedItem.fileItem.key !== fileItemInfo.fileItem.key) {
                    var oldFocusedItem = this._focusedItem;
                    this._focusedItem = fileItemInfo;
                    var deselectedKeys = [];
                    if (oldFocusedItem) {
                        deselectedKeys.push(oldFocusedItem.fileItem.key)
                    }
                    var selectedItems = [];
                    var selectedKeys = [];
                    if (fileItemInfo) {
                        selectedItems.push(fileItemInfo.fileItem);
                        selectedKeys.push(fileItemInfo.fileItem.key)
                    }
                    this._raiseSelectionChanged({
                        selectedItems: selectedItems,
                        selectedItemKeys: selectedKeys,
                        currentSelectedItemKeys: [].concat(selectedKeys),
                        currentDeselectedItemKeys: deselectedKeys
                    })
                }
            };
            _proto._selectItemMultipleSelection = function(_ref8) {
                var fileItem = _ref8.fileItem;
                if (!this._filesView.isRowSelected(fileItem.key)) {
                    var selectionController = this._filesView.getController("selection");
                    var preserve = selectionController.isSelectionWithCheckboxes();
                    this._filesView.selectRows([fileItem.key], preserve)
                }
            };
            _proto._setSelectedItemKeys = function(itemKeys) {
                this._filesView.option("selectedRowKeys", itemKeys)
            };
            _proto._setFocusedItemKey = function(itemKey) {
                this._filesView.option("focusedRowKey", itemKey)
            };
            _proto.clearSelection = function() {
                if (this._isMultipleSelectionMode()) {
                    this._filesView.clearSelection()
                } else {
                    this._filesView.option("focusedRowIndex", -1)
                }
            };
            _proto.refresh = function(options) {
                var actualOptions = {
                    dataSource: this._createDataSource()
                };
                if (options && Object.prototype.hasOwnProperty.call(options, "focusedItemKey")) {
                    if ((0, _type.isDefined)(options.focusedItemKey)) {
                        actualOptions.focusedRowKey = options.focusedItemKey
                    } else {
                        actualOptions.focusedRowIndex = -1
                    }
                }
                this._filesView.option(actualOptions);
                this._refreshDeferred = new _deferred.Deferred;
                return this._refreshDeferred.promise()
            };
            _proto.getSelectedItems = function() {
                if (this._isMultipleSelectionMode()) {
                    return this._filesView.getSelectedRowsData()
                }
                return this._focusedItem && !this._isParentDirectoryItem(this._focusedItem) ? [this._focusedItem] : []
            };
            return FileManagerDetailsItemList
        }(_uiFile_manager2.default);
        var _default = FileManagerDetailsItemList;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/file_manager/ui.file_manager.item_list.thumbnails.js ***!
      \******************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _contextmenu = __webpack_require__( /*! ../../events/contextmenu */ 179);
        var _uiFile_manager = __webpack_require__( /*! ./ui.file_manager.common */ 141);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _uiFile_managerItems_listThumbnails = _interopRequireDefault(__webpack_require__( /*! ./ui.file_manager.items_list.thumbnails.list_box */ 863));
        var _uiFile_manager2 = _interopRequireDefault(__webpack_require__( /*! ./ui.file_manager.item_list */ 454));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var FILE_MANAGER_THUMBNAILS_ITEM_LIST_CLASS = "dx-filemanager-thumbnails";
        var FILE_MANAGER_THUMBNAILS_ITEM_CLASS = "dx-filemanager-thumbnails-item";
        var FILE_MANAGER_THUMBNAILS_ITEM_THUMBNAIL_CLASS = "dx-filemanager-thumbnails-item-thumbnail";
        var FILE_MANAGER_THUMBNAILS_EVENT_NAMESPACE = "dxFileManager_thumbnails";
        var FileManagerThumbnailsItemList = function(_FileManagerItemListB) {
            _inheritsLoose(FileManagerThumbnailsItemList, _FileManagerItemListB);

            function FileManagerThumbnailsItemList() {
                return _FileManagerItemListB.apply(this, arguments) || this
            }
            var _proto = FileManagerThumbnailsItemList.prototype;
            _proto._initMarkup = function() {
                _FileManagerItemListB.prototype._initMarkup.call(this);
                this.$element().addClass(FILE_MANAGER_THUMBNAILS_ITEM_LIST_CLASS);
                var contextMenuEvent = (0, _index.addNamespace)(_contextmenu.name, FILE_MANAGER_THUMBNAILS_EVENT_NAMESPACE);
                _events_engine.default.on(this.$element(), contextMenuEvent, this._onContextMenu.bind(this));
                this._createItemList()
            };
            _proto._createItemList = function() {
                var _this = this;
                var selectionMode = this._isMultipleSelectionMode() ? "multiple" : "single";
                var $itemListContainer = (0, _renderer.default)("<div>").appendTo(this.$element());
                this._itemList = this._createComponent($itemListContainer, _uiFile_managerItems_listThumbnails.default, {
                    dataSource: this._createDataSource(),
                    selectionMode: selectionMode,
                    selectedItemKeys: this.option("selectedItemKeys"),
                    focusedItemKey: this.option("focusedItemKey"),
                    activeStateEnabled: true,
                    hoverStateEnabled: true,
                    loopItemFocus: false,
                    focusStateEnabled: true,
                    onItemEnterKeyPressed: this._tryOpen.bind(this),
                    itemThumbnailTemplate: this._getItemThumbnailContainer.bind(this),
                    getTooltipText: this._getTooltipText.bind(this),
                    onSelectionChanged: this._onItemListSelectionChanged.bind(this),
                    onFocusedItemChanged: this._onItemListFocusedItemChanged.bind(this),
                    onContentReady: function() {
                        var _this$_refreshDeferre;
                        return null === (_this$_refreshDeferre = _this._refreshDeferred) || void 0 === _this$_refreshDeferre ? void 0 : _this$_refreshDeferre.resolve()
                    }
                })
            };
            _proto._onContextMenu = function(e) {
                e.preventDefault();
                if (!this._isDesktop()) {
                    return
                }
                var items = null;
                var targetItemElement = (0, _renderer.default)(e.target).closest(this._getItemSelector());
                var targetItem = null;
                if (targetItemElement.length > 0) {
                    targetItem = this._itemList.getItemByItemElement(targetItemElement);
                    this._itemList.selectItem(targetItem);
                    items = this._getFileItemsForContextMenu(targetItem)
                }
                this._showContextMenu(items, e.target, e, targetItem)
            };
            _proto._getItemThumbnailCssClass = function() {
                return FILE_MANAGER_THUMBNAILS_ITEM_THUMBNAIL_CLASS
            };
            _proto._getItemSelector = function() {
                return ".".concat(FILE_MANAGER_THUMBNAILS_ITEM_CLASS)
            };
            _proto._getTooltipText = function(fileItemInfo) {
                var item = fileItemInfo.fileItem;
                if (item.tooltipText) {
                    return item.tooltipText
                }
                var text = "".concat(item.name, "\r\n");
                if (!item.isDirectory) {
                    text += "".concat(_message.default.format("dxFileManager-listThumbnailsTooltipTextSize"), ": ").concat((0, _uiFile_manager.getDisplayFileSize)(item.size), "\r\n")
                }
                text += "".concat(_message.default.format("dxFileManager-listThumbnailsTooltipTextDateModified"), ": ").concat(item.dateModified);
                return text
            };
            _proto._onItemDblClick = function(e) {
                var $item = (0, _renderer.default)(e.currentTarget);
                var item = this._itemList.getItemByItemElement($item);
                this._tryOpen(item)
            };
            _proto._tryOpen = function(item) {
                if (item) {
                    this._raiseSelectedItemOpened(item)
                }
            };
            _proto._getItemsInternal = function() {
                return _FileManagerItemListB.prototype._getItemsInternal.call(this).then(function(items) {
                    var deferred = new _deferred.Deferred;
                    setTimeout(function() {
                        return deferred.resolve(items)
                    });
                    return deferred.promise()
                })
            };
            _proto._disableDragging = function() {
                return false
            };
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_FileManagerItemListB.prototype._getDefaultOptions.call(this), {
                    focusStateEnabled: true
                })
            };
            _proto._onItemListSelectionChanged = function(_ref) {
                var addedItemKeys = _ref.addedItemKeys,
                    removedItemKeys = _ref.removedItemKeys;
                var selectedItemInfos = this.getSelectedItems();
                var selectedItems = selectedItemInfos.map(function(itemInfo) {
                    return itemInfo.fileItem
                });
                var selectedItemKeys = selectedItems.map(function(item) {
                    return item.key
                });
                this._tryRaiseSelectionChanged({
                    selectedItemInfos: selectedItemInfos,
                    selectedItems: selectedItems,
                    selectedItemKeys: selectedItemKeys,
                    currentSelectedItemKeys: addedItemKeys,
                    currentDeselectedItemKeys: removedItemKeys
                })
            };
            _proto._onItemListFocusedItemChanged = function(_ref2) {
                var item = _ref2.item,
                    itemElement = _ref2.itemElement;
                if (!this._isMultipleSelectionMode()) {
                    this._selectItemSingleSelection(item)
                }
                var fileSystemItem = (null === item || void 0 === item ? void 0 : item.fileItem) || null;
                this._onFocusedItemChanged({
                    item: fileSystemItem,
                    itemKey: null === fileSystemItem || void 0 === fileSystemItem ? void 0 : fileSystemItem.key,
                    itemElement: itemElement || void 0
                })
            };
            _proto._setSelectedItemKeys = function(itemKeys) {
                this._itemList.option("selectedItemKeys", itemKeys)
            };
            _proto._setFocusedItemKey = function(itemKey) {
                this._itemList.option("focusedItemKey", itemKey)
            };
            _proto.refresh = function(options) {
                var actualOptions = {
                    dataSource: this._createDataSource()
                };
                if (options && Object.prototype.hasOwnProperty.call(options, "focusedItemKey")) {
                    actualOptions.focusedItemKey = options.focusedItemKey
                }
                this._itemList.option(actualOptions);
                this._refreshDeferred = new _deferred.Deferred;
                return this._refreshDeferred.promise()
            };
            _proto._deselectItem = function(item) {
                var itemElement = this._itemList.getItemElementByItem(item);
                this._itemList.unselectItem(itemElement)
            };
            _proto._selectItemSingleSelection = function(item) {
                if (item) {
                    this._itemList.selectItem(item)
                } else {
                    this._itemList.clearSelection()
                }
            };
            _proto.clearSelection = function() {
                this._itemList.clearSelection()
            };
            _proto.getSelectedItems = function() {
                return this._itemList.getSelectedItems()
            };
            return FileManagerThumbnailsItemList
        }(_uiFile_manager2.default);
        var _default = FileManagerThumbnailsItemList;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/file_manager/ui.file_manager.items_list.thumbnails.list_box.js ***!
      \****************************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _hold = _interopRequireDefault(__webpack_require__( /*! ../../events/hold */ 104));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _bindable_template = __webpack_require__( /*! ../../core/templates/bindable_template */ 65);
        var _scroll_view = _interopRequireDefault(__webpack_require__( /*! ../scroll_view */ 90));
        var _uiCollection_widget = _interopRequireDefault(__webpack_require__( /*! ../collection/ui.collection_widget.edit */ 54));
        var _selection = _interopRequireDefault(__webpack_require__( /*! ../selection/selection */ 233));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var FILE_MANAGER_THUMBNAILS_VIEW_PORT_CLASS = "dx-filemanager-thumbnails-view-port";
        var FILE_MANAGER_THUMBNAILS_ITEM_LIST_CONTAINER_CLASS = "dx-filemanager-thumbnails-container";
        var FILE_MANAGER_THUMBNAILS_ITEM_CLASS = "dx-filemanager-thumbnails-item";
        var FILE_MANAGER_THUMBNAILS_ITEM_NAME_CLASS = "dx-filemanager-thumbnails-item-name";
        var FILE_MANAGER_THUMBNAILS_ITEM_SPACER_CLASS = "dx-filemanager-thumbnails-item-spacer";
        var FILE_MANAGER_THUMBNAILS_ITEM_DATA_KEY = "dxFileManagerItemData";
        var FILE_MANAGER_THUMBNAILS_LIST_BOX_NAMESPACE = "dxFileManagerThumbnailsListBox";
        var FILE_MANAGER_THUMBNAILS_LIST_BOX_HOLD_EVENT_NAME = (0, _index.addNamespace)(_hold.default.name, FILE_MANAGER_THUMBNAILS_LIST_BOX_NAMESPACE);
        var FileManagerThumbnailListBox = function(_CollectionWidget) {
            _inheritsLoose(FileManagerThumbnailListBox, _CollectionWidget);

            function FileManagerThumbnailListBox() {
                return _CollectionWidget.apply(this, arguments) || this
            }
            var _proto = FileManagerThumbnailListBox.prototype;
            _proto._initMarkup = function() {
                this._initActions();
                this._lockFocusedItemProcessing = false;
                this.$element().addClass(FILE_MANAGER_THUMBNAILS_VIEW_PORT_CLASS);
                this._renderScrollView();
                this._renderItemsContainer();
                this._createScrollViewControl();
                _CollectionWidget.prototype._initMarkup.call(this);
                this.onFocusedItemChanged = this._onFocusedItemChanged.bind(this);
                this._layoutUtils = new ListBoxLayoutUtils(this._scrollView, this.$element(), this._$itemContainer, this.itemElements().first());
                this._syncFocusedItemKey()
            };
            _proto._initActions = function() {
                this._actions = {
                    onItemEnterKeyPressed: this._createActionByOption("onItemEnterKeyPressed"),
                    onFocusedItemChanged: this._createActionByOption("onFocusedItemChanged")
                }
            };
            _proto._initTemplates = function() {
                _CollectionWidget.prototype._initTemplates.call(this);
                this._itemThumbnailTemplate = this.option("itemThumbnailTemplate");
                this._getTooltipText = this.option("getTooltipText");
                this._templateManager.addDefaultTemplates({
                    item: new _bindable_template.BindableTemplate(function($container, data, itemModel) {
                        var $itemElement = this._getDefaultItemTemplate(itemModel, $container);
                        $container.append($itemElement)
                    }.bind(this), ["fileItem"], this.option("integrationOptions.watchMethod"))
                })
            };
            _proto._createScrollViewControl = function() {
                if (!this._scrollView) {
                    this._scrollView = this._createComponent(this._$scrollView, _scroll_view.default, {
                        scrollByContent: true,
                        scrollByThumb: true,
                        useKeyboard: false,
                        showScrollbar: "onHover"
                    })
                }
            };
            _proto._renderScrollView = function() {
                if (!this._$scrollView) {
                    this._$scrollView = (0, _renderer.default)("<div>").appendTo(this.$element())
                }
            };
            _proto._renderItemsContainer = function() {
                if (!this._$itemContainer) {
                    this._$itemContainer = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_THUMBNAILS_ITEM_LIST_CONTAINER_CLASS).appendTo(this._$scrollView)
                }
            };
            _proto._render = function() {
                _CollectionWidget.prototype._render.call(this);
                this._detachEventHandlers();
                this._attachEventHandlers()
            };
            _proto._clean = function() {
                this._detachEventHandlers();
                _CollectionWidget.prototype._clean.call(this)
            };
            _proto._supportedKeys = function() {
                return (0, _extend.extend)(_CollectionWidget.prototype._supportedKeys.call(this), {
                    upArrow: function(e) {
                        this._beforeKeyProcessing(e);
                        this._processArrowKeys(-1, false, e)
                    },
                    downArrow: function(e) {
                        this._beforeKeyProcessing(e);
                        this._processArrowKeys(1, false, e)
                    },
                    home: function(e) {
                        this._beforeKeyProcessing(e);
                        this._processHomeEndKeys(0, true, e)
                    },
                    end: function(e) {
                        this._beforeKeyProcessing(e);
                        this._processHomeEndKeys(this._getItemsLength() - 1, true, e)
                    },
                    pageUp: function(e) {
                        this._beforeKeyProcessing(e);
                        this._processPageChange(true, e)
                    },
                    pageDown: function(e) {
                        this._beforeKeyProcessing(e);
                        this._processPageChange(false, e)
                    },
                    enter: function(e) {
                        this._beforeKeyProcessing(e);
                        this._actions.onItemEnterKeyPressed(this._getFocusedItem())
                    },
                    A: function(e) {
                        this._beforeKeyProcessing(e);
                        if ((0, _index.isCommandKeyPressed)(e)) {
                            this.selectAll()
                        }
                    }
                })
            };
            _proto._beforeKeyProcessing = function(e) {
                e.preventDefault();
                this._layoutUtils.reset()
            };
            _proto._processArrowKeys = function(offset, horizontal, eventArgs) {
                var item = this._getFocusedItem();
                if (item) {
                    if (!horizontal) {
                        var layout = this._layoutUtils.getLayoutModel();
                        if (!layout) {
                            return
                        }
                        offset *= layout.itemPerRowCount
                    }
                    var newItemIndex = this._getIndexByItem(item) + offset;
                    this._focusItemByIndex(newItemIndex, true, eventArgs)
                }
            };
            _proto._processHomeEndKeys = function(index, scrollToItem, eventArgs) {
                this._focusItemByIndex(index, scrollToItem, eventArgs)
            };
            _proto._processPageChange = function(pageUp, eventArgs) {
                var item = this._getFocusedItem();
                if (!item) {
                    return
                }
                var layout = this._layoutUtils.getLayoutModel();
                if (!layout) {
                    return
                }
                var itemLayout = this._layoutUtils.createItemLayoutModel(this._getIndexByItem(item));
                var rowOffset = pageUp ? layout.rowPerPageRate : -layout.rowPerPageRate;
                var newRowRate = itemLayout.itemRowIndex - rowOffset;
                var roundFunc = pageUp ? Math.ceil : Math.floor;
                var newRowIndex = roundFunc(newRowRate);
                var newItemIndex = newRowIndex * layout.itemPerRowCount + itemLayout.itemColumnIndex;
                if (newItemIndex < 0) {
                    newItemIndex = 0
                } else {
                    if (newItemIndex >= this._getItemsLength()) {
                        newItemIndex = this._getItemsLength() - 1
                    }
                }
                this._focusItemByIndex(newItemIndex, true, eventArgs)
            };
            _proto._processLongTap = function(e) {
                var $targetItem = this._closestItemElement((0, _renderer.default)(e.target));
                var itemIndex = this._getIndexByItemElement($targetItem);
                this._selection.changeItemSelection(itemIndex, {
                    control: true
                })
            };
            _proto._attachEventHandlers = function() {
                var _this = this;
                if ("multiple" === this.option("selectionMode")) {
                    _events_engine.default.on(this._itemContainer(), FILE_MANAGER_THUMBNAILS_LIST_BOX_HOLD_EVENT_NAME, ".".concat(this._itemContentClass()), function(e) {
                        _this._processLongTap(e);
                        e.stopPropagation()
                    })
                }
                _events_engine.default.on(this._itemContainer(), "mousedown selectstart", function(e) {
                    if (e.shiftKey) {
                        e.preventDefault()
                    }
                })
            };
            _proto._detachEventHandlers = function() {
                _events_engine.default.off(this._itemContainer(), FILE_MANAGER_THUMBNAILS_LIST_BOX_HOLD_EVENT_NAME);
                _events_engine.default.off(this._itemContainer(), "mousedown selectstart")
            };
            _proto._itemContainer = function() {
                return this._$itemContainer
            };
            _proto._itemClass = function() {
                return FILE_MANAGER_THUMBNAILS_ITEM_CLASS
            };
            _proto._itemDataKey = function() {
                return FILE_MANAGER_THUMBNAILS_ITEM_DATA_KEY
            };
            _proto._getDefaultItemTemplate = function(fileItemInfo, $itemElement) {
                $itemElement.attr("title", this._getTooltipText(fileItemInfo));
                var $itemThumbnail = this._itemThumbnailTemplate(fileItemInfo);
                var $itemSpacer = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_THUMBNAILS_ITEM_SPACER_CLASS);
                var $itemName = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_THUMBNAILS_ITEM_NAME_CLASS).text(fileItemInfo.fileItem.name);
                $itemElement.append($itemThumbnail, $itemSpacer, $itemName)
            };
            _proto._itemSelectHandler = function(e) {
                var options = {};
                if ("multiple" === this.option("selectionMode")) {
                    if (!this._isPreserveSelectionMode) {
                        this._isPreserveSelectionMode = (0, _index.isCommandKeyPressed)(e) || e.shiftKey
                    }
                    options = {
                        control: this._isPreserveSelectionMode,
                        shift: e.shiftKey
                    }
                }
                var index = this._getIndexByItemElement(e.currentTarget);
                this._selection.changeItemSelection(index, options)
            };
            _proto._initSelectionModule = function() {
                var _this2 = this;
                _CollectionWidget.prototype._initSelectionModule.call(this);
                var options = (0, _extend.extend)(this._selection.options, {
                    selectedKeys: this.option("selectedItemKeys"),
                    onSelectionChanged: function(args) {
                        _this2.option("selectedItems", _this2._getItemsByKeys(args.selectedItemKeys, args.selectedItems));
                        _this2._updateSelectedItems(args)
                    }
                });
                this._selection = new _selection.default(options)
            };
            _proto._updateSelectedItems = function(args) {
                var _this3 = this;
                var addedItemKeys = args.addedItemKeys;
                var removedItemKeys = args.removedItemKeys;
                if (this._rendered && (addedItemKeys.length || removedItemKeys.length)) {
                    var selectionChangePromise = this._selectionChangePromise;
                    if (!this._rendering) {
                        var addedSelection = [];
                        var normalizedIndex;
                        var removedSelection = [];
                        this._editStrategy.beginCache();
                        for (var i = 0; i < removedItemKeys.length; i++) {
                            normalizedIndex = this._getIndexByKey(removedItemKeys[i]);
                            removedSelection.push(normalizedIndex);
                            this._removeSelection(normalizedIndex)
                        }
                        for (var _i = 0; _i < addedItemKeys.length; _i++) {
                            normalizedIndex = this._getIndexByKey(addedItemKeys[_i]);
                            addedSelection.push(normalizedIndex);
                            this._addSelection(normalizedIndex)
                        }
                        this._editStrategy.endCache();
                        this._updateSelection(addedSelection, removedSelection)
                    }(0, _deferred.when)(selectionChangePromise).done(function() {
                        return _this3._fireSelectionChangeEvent(args)
                    })
                }
            };
            _proto._fireSelectionChangeEvent = function(args) {
                this._createActionByOption("onSelectionChanged", {
                    excludeValidators: ["disabled", "readOnly"]
                })(args)
            };
            _proto._updateSelection = function(addedSelection, removedSelection) {
                var selectedItemsCount = this.getSelectedItems().length;
                if (0 === selectedItemsCount) {
                    this._isPreserveSelectionMode = false
                }
            };
            _proto._normalizeSelectedItems = function() {
                var newKeys = this._getKeysByItems(this.option("selectedItems"));
                var oldKeys = this._selection.getSelectedItemKeys();
                if (!this._compareKeys(oldKeys, newKeys)) {
                    this._selection.setSelection(newKeys)
                }
                return (new _deferred.Deferred).resolve().promise()
            };
            _proto._focusOutHandler = function() {};
            _proto._getItems = function() {
                return this.option("items") || []
            };
            _proto._getItemsLength = function() {
                return this._getItems().length
            };
            _proto._getIndexByItemElement = function(itemElement) {
                return this._editStrategy.getNormalizedIndex(itemElement)
            };
            _proto._getItemByIndex = function(index) {
                return this._getItems()[index]
            };
            _proto._getFocusedItem = function() {
                return this.getItemByItemElement(this.option("focusedElement"))
            };
            _proto._focusItem = function(item, scrollToItem) {
                this.option("focusedElement", this.getItemElementByItem(item));
                if (scrollToItem) {
                    this._layoutUtils.scrollToItem(this._getIndexByItem(item))
                }
            };
            _proto._focusItemByIndex = function(index, scrollToItem, eventArgs) {
                if (index >= 0 && index < this._getItemsLength()) {
                    var item = this._getItemByIndex(index);
                    this._focusItem(item, scrollToItem, eventArgs)
                }
            };
            _proto._syncFocusedItemKey = function() {
                var _this4 = this;
                if (!this._syncFocusedItemKeyDeferred) {
                    this._syncFocusedItemKeyDeferred = new _deferred.Deferred
                }
                var deferred = this._syncFocusedItemKeyDeferred;
                if (this._dataSource && this._dataSource.isLoading()) {
                    return deferred.promise()
                }
                var focusedItemKey = this.option("focusedItemKey");
                if ((0, _type.isDefined)(focusedItemKey)) {
                    var items = this.option("items");
                    var focusedItem = (0, _array.find)(items, function(item) {
                        return _this4.keyOf(item) === focusedItemKey
                    });
                    if (focusedItem) {
                        this._focusItem(focusedItem, true);
                        deferred.resolve()
                    } else {
                        this.option("focusedItemKey", void 0);
                        deferred.reject()
                    }
                } else {
                    deferred.resolve()
                }
                this._syncFocusedItemKeyDeferred = null;
                return deferred.promise()
            };
            _proto._onFocusedItemChanged = function() {
                var focusedItem = this._getFocusedItem();
                var newFocusedItemKey = this.keyOf(focusedItem);
                var oldFocusedItemKey = this.option("focusedItemKey");
                if (newFocusedItemKey !== oldFocusedItemKey) {
                    this._lockFocusedItemProcessing = true;
                    this.option("focusedItemKey", newFocusedItemKey);
                    this._lockFocusedItemProcessing = false;
                    this._raiseFocusedItemChanged(focusedItem)
                }
            };
            _proto._raiseFocusedItemChanged = function(focusedItem) {
                var args = {
                    item: focusedItem,
                    itemElement: this.option("focusedElement")
                };
                this._actions.onFocusedItemChanged(args)
            };
            _proto._changeItemSelection = function(item, select) {
                if (this.isItemSelected(item) === select) {
                    return
                }
                var itemElement = this.getItemElementByItem(item);
                var index = this._getIndexByItemElement(itemElement);
                this._selection.changeItemSelection(index, {
                    control: this._isPreserveSelectionMode
                })
            };
            _proto._chooseSelectOption = function() {
                return "selectedItemKeys"
            };
            _proto.getSelectedItems = function() {
                return this._selection.getSelectedItems()
            };
            _proto.getItemElementByItem = function(item) {
                return this._editStrategy.getItemElement(item)
            };
            _proto.getItemByItemElement = function(itemElement) {
                return this._getItemByIndex(this._getIndexByItemElement(itemElement))
            };
            _proto.selectAll = function() {
                if ("multiple" !== this.option("selectionMode")) {
                    return
                }
                this._selection.selectAll();
                this._isPreserveSelectionMode = true
            };
            _proto.selectItem = function(item) {
                this._changeItemSelection(item, true)
            };
            _proto.deselectItem = function(item) {
                this._changeItemSelection(item, false)
            };
            _proto.clearSelection = function() {
                this._selection.deselectAll()
            };
            _proto._optionChanged = function(args) {
                var _this5 = this;
                switch (args.name) {
                    case "items":
                        if (this._layoutUtils) {
                            this._layoutUtils.updateItems(this.itemElements().first())
                        }
                        _CollectionWidget.prototype._optionChanged.call(this, args);
                        break;
                    case "focusedItemKey":
                        if (this._lockFocusedItemProcessing) {
                            break
                        }
                        if ((0, _type.isDefined)(args.value)) {
                            this._syncFocusedItemKey().done(function() {
                                var focusedItem = _this5._getFocusedItem();
                                _this5._raiseFocusedItemChanged(focusedItem)
                            })
                        } else {
                            this.option("focusedElement", null);
                            this._raiseFocusedItemChanged(null)
                        }
                        break;
                    case "onItemEnterKeyPressed":
                    case "onFocusedItemChanged":
                        this._actions[args.name] = this._createActionByOption(args.name);
                        break;
                    default:
                        _CollectionWidget.prototype._optionChanged.call(this, args)
                }
            };
            return FileManagerThumbnailListBox
        }(_uiCollection_widget.default);
        var ListBoxLayoutUtils = function() {
            function ListBoxLayoutUtils(scrollView, $viewPort, $itemContainer, $item) {
                this._layoutModel = null;
                this._scrollView = scrollView;
                this._$viewPort = $viewPort;
                this._$itemContainer = $itemContainer;
                this._$item = $item
            }
            var _proto2 = ListBoxLayoutUtils.prototype;
            _proto2.updateItems = function($item) {
                this._$item = $item
            };
            _proto2.reset = function() {
                this._layoutModel = null
            };
            _proto2.getLayoutModel = function() {
                if (!this._layoutModel) {
                    this._layoutModel = this._createLayoutModel()
                }
                return this._layoutModel
            };
            _proto2._createLayoutModel = function() {
                if (!this._$item) {
                    return null
                }
                var itemWidth = this._$item.outerWidth(true);
                if (0 === itemWidth) {
                    return null
                }
                var itemHeight = this._$item.outerHeight(true);
                var viewPortWidth = this._$itemContainer.innerWidth();
                var viewPortHeight = this._$viewPort.innerHeight();
                var viewPortScrollTop = this._scrollView.scrollTop();
                var viewPortScrollBottom = viewPortScrollTop + viewPortHeight;
                var itemPerRowCount = Math.floor(viewPortWidth / itemWidth);
                var rowPerPageRate = viewPortHeight / itemHeight;
                return {
                    itemWidth: itemWidth,
                    itemHeight: itemHeight,
                    viewPortWidth: viewPortWidth,
                    viewPortHeight: viewPortHeight,
                    viewPortScrollTop: viewPortScrollTop,
                    viewPortScrollBottom: viewPortScrollBottom,
                    itemPerRowCount: itemPerRowCount,
                    rowPerPageRate: rowPerPageRate
                }
            };
            _proto2.createItemLayoutModel = function(index) {
                var layout = this.getLayoutModel();
                if (!layout) {
                    return null
                }
                var itemRowIndex = Math.floor(index / layout.itemPerRowCount);
                var itemColumnIndex = index % layout.itemPerRowCount;
                var itemTop = itemRowIndex * layout.itemHeight;
                var itemBottom = itemTop + layout.itemHeight;
                return {
                    itemRowIndex: itemRowIndex,
                    itemColumnIndex: itemColumnIndex,
                    itemTop: itemTop,
                    itemBottom: itemBottom
                }
            };
            _proto2.scrollToItem = function(index) {
                var layout = this.getLayoutModel();
                if (!layout) {
                    return
                }
                var itemRowIndex = Math.floor(index / layout.itemPerRowCount);
                var itemTop = itemRowIndex * layout.itemHeight;
                var itemBottom = itemTop + layout.itemHeight;
                var newScrollTop = layout.viewPortScrollTop;
                if (itemTop < layout.viewPortScrollTop) {
                    newScrollTop = itemTop
                } else {
                    if (itemBottom > layout.viewPortScrollBottom) {
                        newScrollTop = itemBottom - layout.viewPortHeight
                    }
                }
                this._scrollView.scrollTo(newScrollTop)
            };
            return ListBoxLayoutUtils
        }();
        var _default = FileManagerThumbnailListBox;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/file_manager/ui.file_manager.toolbar.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _uiFile_manager = __webpack_require__( /*! ./ui.file_manager.common */ 141);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _toolbar = _interopRequireDefault(__webpack_require__( /*! ../toolbar */ 157));
        __webpack_require__( /*! ../drop_down_button */ 352);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var FILE_MANAGER_TOOLBAR_CLASS = "dx-filemanager-toolbar";
        var FILE_MANAGER_GENERAL_TOOLBAR_CLASS = "dx-filemanager-general-toolbar";
        var FILE_MANAGER_FILE_TOOLBAR_CLASS = "dx-filemanager-file-toolbar";
        var FILE_MANAGER_TOOLBAR_SEPARATOR_ITEM_CLASS = FILE_MANAGER_TOOLBAR_CLASS + "-separator-item";
        var FILE_MANAGER_TOOLBAR_VIEWMODE_ITEM_CLASS = FILE_MANAGER_TOOLBAR_CLASS + "-viewmode-item";
        var FILE_MANAGER_TOOLBAR_HAS_LARGE_ICON_CLASS = FILE_MANAGER_TOOLBAR_CLASS + "-has-large-icon";
        var FILE_MANAGER_VIEW_SWITCHER_POPUP_CLASS = "dx-filemanager-view-switcher-popup";
        var DEFAULT_ITEM_CONFIGS = {
            showNavPane: {
                location: "before"
            },
            create: {
                location: "before",
                compactMode: {
                    showText: "inMenu",
                    locateInMenu: "auto"
                }
            },
            upload: {
                location: "before",
                compactMode: {
                    showText: "inMenu",
                    locateInMenu: "auto"
                }
            },
            refresh: {
                location: "after",
                showText: "inMenu",
                cssClass: FILE_MANAGER_TOOLBAR_HAS_LARGE_ICON_CLASS,
                compactMode: {
                    showText: "inMenu",
                    locateInMenu: "auto"
                }
            },
            switchView: {
                location: "after"
            },
            download: {
                location: "before",
                compactMode: {
                    showText: "inMenu",
                    locateInMenu: "auto"
                }
            },
            move: {
                location: "before",
                compactMode: {
                    showText: "inMenu",
                    locateInMenu: "auto"
                }
            },
            copy: {
                location: "before",
                compactMode: {
                    showText: "inMenu",
                    locateInMenu: "auto"
                }
            },
            rename: {
                location: "before",
                compactMode: {
                    showText: "inMenu",
                    locateInMenu: "auto"
                }
            },
            "delete": {
                location: "before",
                compactMode: {
                    showText: "inMenu"
                }
            },
            clearSelection: {
                location: "after",
                locateInMenu: "never",
                compactMode: {
                    showText: "inMenu"
                }
            },
            separator: {
                location: "before"
            }
        };
        var DEFAULT_ITEM_ALLOWED_PROPERTIES = ["visible", "location", "locateInMenu", "disabled", "showText"];
        var DEFAULT_ITEM_ALLOWED_OPTION_PROPERTIES = ["accessKey", "elementAttr", "height", "hint", "icon", "stylingMode", "tabIndex", "text", "width"];
        var ALWAYS_VISIBLE_TOOLBAR_ITEMS = ["separator", "switchView"];
        var REFRESH_ICON_MAP = {
            "default": "dx-filemanager-i dx-filemanager-i-refresh",
            progress: "dx-filemanager-i dx-filemanager-i-progress",
            success: "dx-filemanager-i dx-filemanager-i-done",
            error: "dx-filemanager-i dx-filemanager-i-danger"
        };
        var REFRESH_ITEM_PROGRESS_MESSAGE_DELAY = 500;
        var FileManagerToolbar = function(_Widget) {
            _inheritsLoose(FileManagerToolbar, _Widget);

            function FileManagerToolbar() {
                return _Widget.apply(this, arguments) || this
            }
            var _proto = FileManagerToolbar.prototype;
            _proto._initMarkup = function() {
                this._commandManager = this.option("commandManager");
                this._createItemClickedAction();
                this._generalToolbarVisible = true;
                this._$viewSwitcherPopup = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_VIEW_SWITCHER_POPUP_CLASS);
                this._generalToolbar = this._createToolbar(this.option("generalItems"));
                this._fileToolbar = this._createToolbar(this.option("fileItems"), true);
                this._$viewSwitcherPopup.appendTo(this.$element());
                this.$element().addClass(FILE_MANAGER_TOOLBAR_CLASS + " " + FILE_MANAGER_GENERAL_TOOLBAR_CLASS)
            };
            _proto._render = function() {
                _Widget.prototype._render.call(this);
                var toolbar = this._getVisibleToolbar();
                this._checkCompactMode(toolbar)
            };
            _proto._dimensionChanged = function(dimension) {
                if (!dimension || "height" !== dimension) {
                    var toolbar = this._getVisibleToolbar();
                    this._checkCompactMode(toolbar)
                }
            };
            _proto._getVisibleToolbar = function() {
                return this._generalToolbarVisible ? this._generalToolbar : this._fileToolbar
            };
            _proto._createToolbar = function(items, hidden) {
                var _this = this;
                var toolbarItems = this._getPreparedItems(items);
                var $toolbar = (0, _renderer.default)("<div>").appendTo(this.$element());
                var result = this._createComponent($toolbar, _toolbar.default, {
                    items: toolbarItems,
                    visible: !hidden,
                    onItemClick: function(args) {
                        return _this._raiseItemClicked(args)
                    }
                });
                result.compactMode = false;
                return result
            };
            _proto._getPreparedItems = function(items) {
                var _this2 = this;
                items = items.map(function(item) {
                    var extendedItem = item;
                    if ((0, _type.isString)(item)) {
                        extendedItem = {
                            name: item
                        }
                    }
                    var commandName = extendedItem.name;
                    var preparedItem = _this2._configureItemByCommandName(commandName, extendedItem);
                    preparedItem.originalItemData = item;
                    if ("separator" !== commandName) {
                        _this2._setItemVisibleAvailable(preparedItem)
                    }
                    return preparedItem
                });
                this._updateSeparatorsVisibility(items);
                return items
            };
            _proto._updateSeparatorsVisibility = function(items, toolbar) {
                var _this3 = this;
                var hasModifications = false;
                var menuItems = this._getMenuItems(toolbar);
                var hasItemsBefore = {
                    before: false,
                    center: false,
                    after: false
                };
                var itemGroups = {
                    before: this._getItemsInGroup(items, menuItems, "before"),
                    center: this._getItemsInGroup(items, menuItems, "center"),
                    after: this._getItemsInGroup(items, menuItems, "after")
                };
                items.forEach(function(item, i) {
                    var itemLocation = item.location;
                    if ("separator" === item.name) {
                        var isSeparatorVisible = hasItemsBefore[itemLocation] && _this3._groupHasItemsAfter(itemGroups[itemLocation]);
                        if (item.visible !== isSeparatorVisible) {
                            hasModifications = true;
                            item.visible = isSeparatorVisible
                        }
                        hasItemsBefore[itemLocation] = false
                    } else {
                        if (!_this3._isItemInMenu(menuItems, item)) {
                            hasItemsBefore[itemLocation] = hasItemsBefore[itemLocation] || item.visible
                        }
                        itemGroups[itemLocation].shift()
                    }
                });
                if (toolbar && hasModifications) {
                    toolbar.repaint()
                }
                return hasModifications
            };
            _proto._getMenuItems = function(toolbar) {
                var result = toolbar ? toolbar._getMenuItems() : [];
                return result.map(function(menuItem) {
                    return menuItem.originalItemData
                })
            };
            _proto._isItemInMenu = function(menuItems, item) {
                return !!menuItems.length && "never" !== (0, _common.ensureDefined)(item.locateInMenu, "never") && menuItems.indexOf(item.originalItemData) !== -1
            };
            _proto._getItemsInGroup = function(items, menuItems, groupName) {
                var _this4 = this;
                return items.filter(function(item) {
                    return item.location === groupName && !_this4._isItemInMenu(menuItems, item)
                })
            };
            _proto._groupHasItemsAfter = function(items) {
                for (var i = 0; i < items.length; i++) {
                    if ("separator" !== items[i].name && items[i].visible) {
                        return true
                    }
                }
                return false
            };
            _proto._configureItemByCommandName = function(commandName, item) {
                var _result$options;
                var result = {};
                var command = this._commandManager.getCommandByName(commandName);
                if (command) {
                    result = this._createCommandItem(command)
                }
                switch (commandName) {
                    case "separator":
                        result = this._createSeparatorItem();
                        break;
                    case "switchView":
                        result = this._createViewModeItem()
                }
                if (this._isDefaultItem(commandName)) {
                    var defaultConfig = DEFAULT_ITEM_CONFIGS[commandName];
                    (0, _extend.extend)(true, result, defaultConfig);
                    var resultCssClass = result.cssClass || "";
                    (0, _uiFile_manager.extendAttributes)(result, item, DEFAULT_ITEM_ALLOWED_PROPERTIES);
                    if ((0, _type.isDefined)(item.options)) {
                        (0, _uiFile_manager.extendAttributes)(result.options, item.options, DEFAULT_ITEM_ALLOWED_OPTION_PROPERTIES)
                    }(0, _uiFile_manager.extendAttributes)(result.options, item, ["text", "icon"]);
                    if (item.cssClass) {
                        resultCssClass = "".concat(resultCssClass, " ").concat(item.cssClass)
                    }
                    if (resultCssClass) {
                        result.cssClass = resultCssClass
                    }
                    if (!(0, _type.isDefined)(item.visible)) {
                        result._autoHide = true
                    }
                    if ("dxButton" === result.widget) {
                        if ("inMenu" === result.showText && !(0, _type.isDefined)(result.options.hint)) {
                            result.options.hint = result.options.text
                        }
                        if (result.compactMode && !(0, _type.isDefined)(result.options.hint)) {
                            this._configureHintForCompactMode(result)
                        }
                    }
                } else {
                    (0, _extend.extend)(true, result, item);
                    if (!result.widget) {
                        result.widget = "dxButton"
                    }
                    if ("dxButton" === result.widget && !result.compactMode && !result.showText && result.options && result.options.icon && result.options.text) {
                        result.compactMode = {
                            showText: "inMenu"
                        }
                    }
                }
                if (commandName && !result.name) {
                    (0, _extend.extend)(result, {
                        name: commandName
                    })
                }
                result.location = (0, _common.ensureDefined)(result.location, "before");
                if (!(0, _type.isDefined)(null === (_result$options = result.options) || void 0 === _result$options ? void 0 : _result$options.stylingMode)) {
                    if ("dxButton" === result.widget) {
                        (0, _extend.extend)(true, result, {
                            options: {
                                stylingMode: "text"
                            }
                        })
                    }
                    if ("dxSelectBox" === result.widget) {
                        (0, _extend.extend)(true, result, {
                            options: {
                                stylingMode: "filled"
                            }
                        })
                    }
                }
                return result
            };
            _proto._isDefaultItem = function(commandName) {
                return !!DEFAULT_ITEM_CONFIGS[commandName]
            };
            _proto._createCommandItem = function(command) {
                var _this5 = this;
                return {
                    widget: "dxButton",
                    options: {
                        text: command.text,
                        hint: command.hint,
                        commandText: command.text,
                        icon: command.icon,
                        stylingMode: "text",
                        onClick: function(e) {
                            return _this5._executeCommand(command)
                        }
                    }
                }
            };
            _proto._createSeparatorItem = function() {
                return {
                    template: function(data, index, element) {
                        (0, _renderer.default)(element).addClass(FILE_MANAGER_TOOLBAR_SEPARATOR_ITEM_CLASS)
                    }
                }
            };
            _proto._createViewModeItem = function() {
                var _this6 = this;
                var commandItems = ["details", "thumbnails"].map(function(name) {
                    var _this6$_commandManage = _this6._commandManager.getCommandByName(name),
                        text = _this6$_commandManage.text,
                        icon = _this6$_commandManage.icon;
                    return {
                        name: name,
                        text: text,
                        icon: icon
                    }
                });
                var selectedIndex = "thumbnails" === this.option("itemViewMode") ? 1 : 0;
                return {
                    cssClass: FILE_MANAGER_TOOLBAR_VIEWMODE_ITEM_CLASS,
                    widget: "dxDropDownButton",
                    options: {
                        items: commandItems,
                        keyExpr: "name",
                        selectedItemKey: this.option("itemViewMode"),
                        displayExpr: " ",
                        hint: commandItems[selectedIndex].text,
                        stylingMode: "text",
                        showArrowIcon: false,
                        useSelectMode: true,
                        dropDownOptions: {
                            container: this._$viewSwitcherPopup
                        },
                        onItemClick: function(e) {
                            return _this6._executeCommand(e.itemData.name)
                        }
                    }
                }
            };
            _proto._configureHintForCompactMode = function(item) {
                item.options.hint = "";
                item.compactMode.options = item.compactMode.options || {};
                item.compactMode.options.hint = item.options.text
            };
            _proto._checkCompactMode = function(toolbar) {
                if (toolbar.compactMode) {
                    this._toggleCompactMode(toolbar, false)
                }
                var useCompactMode = this._toolbarHasItemsOverflow(toolbar);
                if (toolbar.compactMode !== useCompactMode) {
                    if (!toolbar.compactMode) {
                        this._toggleCompactMode(toolbar, useCompactMode)
                    }
                    toolbar.compactMode = useCompactMode
                } else {
                    if (toolbar.compactMode) {
                        this._toggleCompactMode(toolbar, true)
                    }
                }
            };
            _proto._toolbarHasItemsOverflow = function(toolbar) {
                var toolbarWidth = toolbar.$element().width();
                var itemsWidth = toolbar._getItemsWidth();
                return toolbarWidth < itemsWidth
            };
            _proto._toggleCompactMode = function(toolbar, useCompactMode) {
                var _this7 = this;
                var hasModifications = false;
                var items = toolbar.option("items");
                items.forEach(function(item) {
                    if (item.compactMode) {
                        var optionsSource = null;
                        if (useCompactMode) {
                            item.saved = _this7._getCompactModeOptions(item, item._available);
                            optionsSource = item.compactMode
                        } else {
                            optionsSource = item.saved
                        }
                        var options = _this7._getCompactModeOptions(optionsSource, item._available);
                        (0, _extend.extend)(true, item, options);
                        hasModifications = true
                    }
                });
                hasModifications = this._updateSeparatorsVisibility(items) || hasModifications;
                if (hasModifications) {
                    toolbar.repaint()
                }
                this._updateSeparatorsVisibility(items, toolbar)
            };
            _proto._getCompactModeOptions = function(_ref, available) {
                var showText = _ref.showText,
                    locateInMenu = _ref.locateInMenu,
                    options = _ref.options;
                return {
                    visible: available,
                    showText: (0, _common.ensureDefined)(showText, "always"),
                    locateInMenu: (0, _common.ensureDefined)(locateInMenu, "never"),
                    options: {
                        hint: null === options || void 0 === options ? void 0 : options.hint
                    }
                }
            };
            _proto._ensureAvailableCommandsVisible = function(toolbar, fileItems) {
                var _this8 = this;
                var hasModifications = false;
                var items = toolbar.option("items");
                items.forEach(function(item) {
                    if ("separator" !== item.name) {
                        var itemVisible = item._available;
                        _this8._setItemVisibleAvailable(item, fileItems);
                        if (item._available !== itemVisible) {
                            hasModifications = true
                        }
                    }
                });
                hasModifications = this._updateSeparatorsVisibility(items) || hasModifications;
                if (hasModifications) {
                    toolbar.repaint()
                }
                this._updateSeparatorsVisibility(items, toolbar)
            };
            _proto._setItemVisibleAvailable = function(item, fileItems) {
                var _item$originalItemDat;
                var originalVisible = null === (_item$originalItemDat = item.originalItemData) || void 0 === _item$originalItemDat ? void 0 : _item$originalItemDat.visible;
                item._available = this._isToolbarItemAvailable(item, fileItems);
                item.visible = (0, _type.isDefined)(originalVisible) ? originalVisible : item._available
            };
            _proto._fileToolbarHasEffectiveItems = function(fileItems) {
                var _this9 = this;
                var items = this._fileToolbar.option("items");
                return items.some(function(item) {
                    return _this9._isFileToolbarItemAvailable(item, fileItems)
                })
            };
            _proto._executeCommand = function(command) {
                this._commandManager.executeCommand(command)
            };
            _proto._isToolbarItemAvailable = function(toolbarItem, fileItems) {
                if (!this._isDefaultItem(toolbarItem.name) || !toolbarItem._autoHide) {
                    return (0, _common.ensureDefined)(toolbarItem.visible, true)
                }
                if ("refresh" === toolbarItem.name) {
                    return this._generalToolbarVisible || !!this._isRefreshVisibleInFileToolbar
                }
                if (ALWAYS_VISIBLE_TOOLBAR_ITEMS.indexOf(toolbarItem.name) > -1) {
                    return true
                }
                return this._commandManager.isCommandAvailable(toolbarItem.name, fileItems)
            };
            _proto._isFileToolbarItemAvailable = function(_ref2, fileItems) {
                var name = _ref2.name,
                    visible = _ref2.visible;
                return !this._isDefaultItem(name) && (0, _common.ensureDefined)(visible, true) || "clearSelection" !== name && "refresh" !== name && this._commandManager.isCommandAvailable(name, fileItems)
            };
            _proto._updateItemInToolbar = function(toolbar, commandName, options) {
                toolbar.beginUpdate();
                var items = toolbar.option("items");
                for (var i = 0; i < items.length; i++) {
                    var item = items[i];
                    if (item.name === commandName) {
                        toolbar.option("items[".concat(i, "]"), options);
                        break
                    }
                }
                toolbar.endUpdate()
            };
            _proto._raiseItemClicked = function(args) {
                var changedArgs = (0, _extend.extend)(true, {}, args);
                changedArgs.itemData = args.itemData.originalItemData;
                this._itemClickedAction(changedArgs)
            };
            _proto._createItemClickedAction = function() {
                this._itemClickedAction = this._createActionByOption("onItemClick")
            };
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_Widget.prototype._getDefaultOptions.call(this), {
                    commandManager: null,
                    generalItems: [],
                    fileItems: [],
                    itemViewMode: "details",
                    onItemClick: null
                })
            };
            _proto._optionChanged = function(args) {
                var name = args.name;
                switch (name) {
                    case "commandManager":
                    case "itemViewMode":
                    case "generalItems":
                    case "fileItems":
                        this.repaint();
                        break;
                    case "onItemClick":
                        this._itemClickedAction = this._createActionByOption(name);
                        break;
                    default:
                        _Widget.prototype._optionChanged.call(this, args)
                }
            };
            _proto.updateRefreshItem = function(message, status) {
                var generalToolbarOptions = null;
                var text = _message.default.format("dxFileManager-commandRefresh");
                var showText = "inMenu";
                this._isRefreshVisibleInFileToolbar = false;
                if ("default" === status) {
                    generalToolbarOptions = {
                        options: {
                            icon: REFRESH_ICON_MAP.default
                        }
                    }
                } else {
                    generalToolbarOptions = {
                        options: {
                            icon: REFRESH_ICON_MAP[status]
                        }
                    };
                    this._isRefreshVisibleInFileToolbar = true;
                    text = message;
                    showText = "always"
                }
                var fileToolbarOptions = (0, _extend.extend)({}, generalToolbarOptions, {
                    visible: this._isRefreshVisibleInFileToolbar
                });
                this._applyRefreshItemOptions(generalToolbarOptions, fileToolbarOptions);
                this._refreshItemTextTimeout = this._updateRefreshItemText("progress" === status, text, showText)
            };
            _proto._updateRefreshItemText = function(isDeferredUpdate, text, showText) {
                var _this10 = this;
                var options = {
                    showText: showText,
                    options: {
                        text: text
                    }
                };
                if (isDeferredUpdate) {
                    return setTimeout(function() {
                        _this10._applyRefreshItemOptions(options);
                        _this10._refreshItemTextTimeout = void 0
                    }, REFRESH_ITEM_PROGRESS_MESSAGE_DELAY)
                } else {
                    if (this._refreshItemTextTimeout) {
                        clearTimeout(this._refreshItemTextTimeout)
                    }
                    this._applyRefreshItemOptions(options);
                    return
                }
            };
            _proto._applyRefreshItemOptions = function(generalToolbarOptions, fileToolbarOptions) {
                if (!fileToolbarOptions) {
                    fileToolbarOptions = (0, _extend.extend)({}, generalToolbarOptions)
                }
                this._updateItemInToolbar(this._generalToolbar, "refresh", generalToolbarOptions);
                this._updateItemInToolbar(this._fileToolbar, "refresh", fileToolbarOptions)
            };
            _proto.update = function(fileItems) {
                fileItems = (0, _common.ensureDefined)(fileItems, []);
                var showGeneralToolbar = 0 === fileItems.length || !this._fileToolbarHasEffectiveItems(fileItems);
                if (this._generalToolbarVisible !== showGeneralToolbar) {
                    this._generalToolbar.option("visible", showGeneralToolbar);
                    this._fileToolbar.option("visible", !showGeneralToolbar);
                    this._generalToolbarVisible = showGeneralToolbar;
                    this.$element().toggleClass(FILE_MANAGER_GENERAL_TOOLBAR_CLASS, showGeneralToolbar);
                    this.$element().toggleClass(FILE_MANAGER_FILE_TOOLBAR_CLASS, !showGeneralToolbar)
                }
                var toolbar = this._getVisibleToolbar();
                this._ensureAvailableCommandsVisible(toolbar, fileItems);
                this._checkCompactMode(toolbar)
            };
            return FileManagerToolbar
        }(_ui.default);
        var _default = FileManagerToolbar;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/file_manager/ui.file_manager.notification.js ***!
      \**********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _popup = _interopRequireDefault(__webpack_require__( /*! ../popup */ 46));
        var _ui2 = _interopRequireDefault(__webpack_require__( /*! ../drawer/ui.drawer */ 278));
        var _uiFile_managerNotification = _interopRequireDefault(__webpack_require__( /*! ./ui.file_manager.notification.progress_panel */ 866));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var window = (0, _window.getWindow)();
        var ADAPTIVE_STATE_SCREEN_WIDTH = 1e3;
        var FILE_MANAGER_NOTIFICATION_CLASS = "dx-filemanager-notification";
        var FILE_MANAGER_NOTIFICATION_DRAWER_CLASS = "".concat(FILE_MANAGER_NOTIFICATION_CLASS, "-drawer");
        var FILE_MANAGER_NOTIFICATION_DRAWER_PANEL_CLASS = "".concat(FILE_MANAGER_NOTIFICATION_DRAWER_CLASS, "-panel");
        var FILE_MANAGER_NOTIFICATION_POPUP_CLASS = "".concat(FILE_MANAGER_NOTIFICATION_CLASS, "-popup");
        var FILE_MANAGER_NOTIFICATION_POPUP_ERROR_CLASS = "".concat(FILE_MANAGER_NOTIFICATION_CLASS, "-popup-error");
        var FILE_MANAGER_NOTIFICATION_COMMON_CLASS = "".concat(FILE_MANAGER_NOTIFICATION_CLASS, "-common");
        var FILE_MANAGER_NOTIFICATION_SEPARATOR_CLASS = "".concat(FILE_MANAGER_NOTIFICATION_CLASS, "-separator");
        var FILE_MANAGER_NOTIFICATION_DETAILS_CLASS = "".concat(FILE_MANAGER_NOTIFICATION_CLASS, "-details");
        var FILE_MANAGER_NOTIFICATION_COMMON_NO_ITEM_CLASS = "".concat(FILE_MANAGER_NOTIFICATION_CLASS, "-common-no-item");
        var FileManagerNotificationControl = function(_Widget) {
            _inheritsLoose(FileManagerNotificationControl, _Widget);

            function FileManagerNotificationControl() {
                return _Widget.apply(this, arguments) || this
            }
            var _proto = FileManagerNotificationControl.prototype;
            _proto._initMarkup = function() {
                var _this = this;
                _Widget.prototype._initMarkup.call(this);
                this._initActions();
                this._actionProgressStatus = "default";
                this._operationInProgressCount = 0;
                this._failedOperationCount = 0;
                this._isInAdaptiveState = this._isSmallScreen();
                var $progressPanelContainer = this.option("progressPanelContainer");
                var $progressDrawer = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_NOTIFICATION_DRAWER_CLASS).appendTo($progressPanelContainer);
                (0, _renderer.default)("<div>").addClass(FILE_MANAGER_NOTIFICATION_DRAWER_PANEL_CLASS).appendTo($progressDrawer);
                var drawerOptions = (0, _extend.extend)({
                    opened: false,
                    position: "right",
                    template: function(container) {
                        return _this._ensureProgressPanelCreated(container)
                    }
                }, this._getProgressDrawerAdaptiveOptions());
                this._progressDrawer = this._createComponent($progressDrawer, _ui2.default, drawerOptions);
                var $drawerContent = $progressDrawer.find(".".concat(FILE_MANAGER_NOTIFICATION_DRAWER_PANEL_CLASS)).first();
                var contentRenderer = this.option("contentTemplate");
                if ((0, _type.isFunction)(contentRenderer)) {
                    contentRenderer($drawerContent, this)
                }
            };
            _proto.tryShowProgressPanel = function() {
                var _this2 = this;
                var promise = new _deferred.Deferred;
                if ("default" === this._actionProgressStatus || this._isProgressDrawerOpened()) {
                    return promise.resolve().promise()
                }
                setTimeout(function() {
                    _this2._progressDrawer.show().done(promise.resolve);
                    _this2._getNotificationPopup().hide();
                    _this2._tryHideActionProgress()
                });
                return promise.promise()
            };
            _proto.addOperation = function(processingMessage, allowCancel, allowProgressAutoUpdate) {
                this._operationInProgressCount++;
                var operationInfo = this._progressPanel.addOperation(processingMessage, allowCancel, allowProgressAutoUpdate);
                this._updateActionProgress(processingMessage, "progress");
                return operationInfo
            };
            _proto.addOperationDetails = function(info, details, showCloseButton) {
                this._progressPanel.addOperationDetails(info, details, showCloseButton)
            };
            _proto.updateOperationItemProgress = function(operationInfo, itemIndex, itemProgress, commonProgress) {
                this._progressPanel.updateOperationItemProgress(operationInfo, itemIndex, itemProgress, commonProgress)
            };
            _proto.completeOperationItem = function(operationInfo, itemIndex, commonProgress) {
                this._progressPanel.completeOperationItem(operationInfo, itemIndex, commonProgress)
            };
            _proto.completeOperation = function(info, commonText, isError, statusText) {
                this._operationInProgressCount--;
                if (isError) {
                    this._failedOperationCount++
                } else {
                    this._showPopup(commonText)
                }
                this._progressPanel.completeOperation(info, commonText, isError, statusText);
                if (!this._isProgressDrawerOpened() || !this._tryHideActionProgress()) {
                    var status = 0 === this._failedOperationCount ? "success" : "error";
                    this._updateActionProgress("", status)
                }
            };
            _proto.completeSingleOperationWithError = function(operationInfo, errorInfo) {
                this._progressPanel.completeSingleOperationWithError(operationInfo, errorInfo.detailErrorText);
                this._notifyError(errorInfo)
            };
            _proto.addOperationDetailsError = function(operationInfo, errorInfo) {
                this._progressPanel.addOperationDetailsError(operationInfo, errorInfo.itemIndex, errorInfo.detailErrorText);
                this._notifyError(errorInfo)
            };
            _proto._hideProgressPanel = function() {
                var _this3 = this;
                setTimeout(function() {
                    return _this3._progressDrawer.hide()
                })
            };
            _proto._tryHideActionProgress = function() {
                if (0 === this._operationInProgressCount && 0 === this._failedOperationCount) {
                    this._updateActionProgress("", "default");
                    return true
                }
                return false
            };
            _proto._updateActionProgress = function(message, status) {
                this._actionProgressStatus = status;
                this._raiseActionProgress(message, status)
            };
            _proto._isSmallScreen = function() {
                if (!(0, _window.hasWindow)()) {
                    return false
                }
                return (0, _renderer.default)(window).width() <= ADAPTIVE_STATE_SCREEN_WIDTH
            };
            _proto._dimensionChanged = function(dimension) {
                if (!dimension || "height" !== dimension) {
                    this._checkAdaptiveState()
                }
            };
            _proto._checkAdaptiveState = function() {
                var oldState = this._isInAdaptiveState;
                this._isInAdaptiveState = this._isSmallScreen();
                if (this._progressDrawer && oldState !== this._isInAdaptiveState) {
                    if (this._progressPanel) {
                        this._progressPanel.$element().detach()
                    }
                    var options = this._getProgressDrawerAdaptiveOptions();
                    this._progressDrawer.option(options)
                }
            };
            _proto._getProgressDrawerAdaptiveOptions = function() {
                if (this._isInAdaptiveState) {
                    return {
                        openedStateMode: "overlap",
                        shading: true,
                        closeOnOutsideClick: true
                    }
                } else {
                    return {
                        openedStateMode: "shrink",
                        shading: false,
                        closeOnOutsideClick: false
                    }
                }
            };
            _proto._ensureProgressPanelCreated = function(container) {
                var _this4 = this;
                if (!this._progressPanel) {
                    var $progressPanelElement = (0, _renderer.default)("<div>").appendTo(container);
                    this._progressPanel = this._createComponent($progressPanelElement, this._getProgressPanelComponent(), {
                        onOperationClosed: function(_ref) {
                            var info = _ref.info;
                            return _this4._onProgressPanelOperationClosed(info)
                        },
                        onOperationCanceled: function(_ref2) {
                            var info = _ref2.info;
                            return _this4._raiseOperationCanceled(info)
                        },
                        onOperationItemCanceled: function(_ref3) {
                            var item = _ref3.item,
                                itemIndex = _ref3.itemIndex;
                            return _this4._raiseOperationItemCanceled(item, itemIndex)
                        },
                        onPanelClosed: function() {
                            return _this4._hideProgressPanel()
                        }
                    })
                } else {
                    this._progressPanel.$element().appendTo(container)
                }
            };
            _proto._getProgressPanelComponent = function() {
                return _uiFile_managerNotification.default
            };
            _proto._notifyError = function(errorInfo) {
                this._showPopupError(errorInfo);
                this._updateActionProgress(errorInfo.commonErrorText, "error")
            };
            _proto._onProgressPanelOperationClosed = function(info) {
                if (info.hasError) {
                    this._failedOperationCount--;
                    this._tryHideActionProgress()
                }
            };
            _proto._isProgressDrawerOpened = function() {
                return this._progressDrawer.option("opened")
            };
            _proto._showPopup = function(content, errorMode) {
                if (this._isProgressDrawerOpened()) {
                    return
                }
                this._getNotificationPopup()._wrapper().toggleClass(FILE_MANAGER_NOTIFICATION_POPUP_ERROR_CLASS, !!errorMode);
                this._getNotificationPopup().option("contentTemplate", content);
                if (!this._getNotificationPopup().option("visible")) {
                    this._getNotificationPopup().show()
                }
            };
            _proto._showPopupError = function(errorInfo) {
                var $content = (0, _renderer.default)("<div>");
                var $message = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_NOTIFICATION_COMMON_CLASS).text(errorInfo.commonErrorText);
                var $separator = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_NOTIFICATION_SEPARATOR_CLASS);
                (0, _renderer.default)("<div>").appendTo($separator);
                var $details = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_NOTIFICATION_DETAILS_CLASS);
                if (errorInfo.item) {
                    this._progressPanel.createErrorDetailsProgressBox($details, errorInfo.item, errorInfo.detailErrorText)
                } else {
                    $message.addClass(FILE_MANAGER_NOTIFICATION_COMMON_NO_ITEM_CLASS);
                    this._progressPanel.renderError($details, $separator, errorInfo.detailErrorText)
                }
                $content.append($message, $separator, $details);
                this._showPopup($content, true)
            };
            _proto._getNotificationPopup = function() {
                if (!this._notificationPopup) {
                    var $popup = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_NOTIFICATION_POPUP_CLASS).appendTo(this.$element());
                    this._notificationPopup = this._createComponent($popup, _popup.default, {
                        container: this.$element(),
                        width: "auto",
                        height: "auto",
                        showTitle: false,
                        dragEnabled: false,
                        shading: false,
                        visible: false,
                        closeOnOutsideClick: true,
                        animation: {
                            duration: 0
                        },
                        position: {
                            my: "right top",
                            at: "right top",
                            of: this.option("positionTarget"),
                            offset: "-10 -5"
                        }
                    })
                }
                return this._notificationPopup
            };
            _proto._raiseActionProgress = function(message, status) {
                this._actions.onActionProgress({
                    message: message,
                    status: status
                })
            };
            _proto._raiseOperationCanceled = function(info) {
                this._actions.onOperationCanceled({
                    info: info
                })
            };
            _proto._raiseOperationItemCanceled = function(item, index) {
                this._actions.onOperationItemCanceled({
                    item: item,
                    itemIndex: index
                })
            };
            _proto._initActions = function() {
                this._actions = {
                    onActionProgress: this._createActionByOption("onActionProgress"),
                    onOperationCanceled: this._createActionByOption("onOperationCanceled"),
                    onOperationItemCanceled: this._createActionByOption("onOperationItemCanceled")
                }
            };
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_Widget.prototype._getDefaultOptions.call(this), {
                    progressPanelContainer: null,
                    contentTemplate: null,
                    onActionProgress: null,
                    onOperationCanceled: null,
                    onOperationItemCanceled: null
                })
            };
            _proto._optionChanged = function(args) {
                var name = args.name;
                switch (name) {
                    case "progressPanelContainer":
                    case "contentTemplate":
                        break;
                    case "onActionProgress":
                    case "onOperationCanceled":
                    case "onOperationItemCanceled":
                        this._actions[name] = this._createActionByOption(name);
                        break;
                    default:
                        _Widget.prototype._optionChanged.call(this, args)
                }
            };
            return FileManagerNotificationControl
        }(_ui.default);
        exports.default = FileManagerNotificationControl;
        module.exports = exports.default
    },
    /*!*************************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/file_manager/ui.file_manager.notification.progress_panel.js ***!
      \*************************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _icon = __webpack_require__( /*! ../../core/utils/icon */ 56);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _progress_bar = _interopRequireDefault(__webpack_require__( /*! ../progress_bar */ 282));
        var _button = _interopRequireDefault(__webpack_require__( /*! ../button */ 37));
        var _scroll_view = _interopRequireDefault(__webpack_require__( /*! ../scroll_view */ 90));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var FILE_MANAGER_PROGRESS_PANEL_CLASS = "dx-filemanager-progress-panel";
        var FILE_MANAGER_PROGRESS_PANEL_CONTAINER_CLASS = "".concat(FILE_MANAGER_PROGRESS_PANEL_CLASS, "-container");
        var FILE_MANAGER_PROGRESS_PANEL_TITLE_CLASS = "".concat(FILE_MANAGER_PROGRESS_PANEL_CLASS, "-title");
        var FILE_MANAGER_PROGRESS_PANEL_TITLE_TEXT_CLASS = "".concat(FILE_MANAGER_PROGRESS_PANEL_CLASS, "-title-text");
        var FILE_MANAGER_PROGRESS_PANEL_CLOSE_BUTTON_CLASS = "".concat(FILE_MANAGER_PROGRESS_PANEL_CLASS, "-close-button");
        var FILE_MANAGER_PROGRESS_PANEL_INFOS_CONTAINER_CLASS = "".concat(FILE_MANAGER_PROGRESS_PANEL_CLASS, "-infos-container");
        var FILE_MANAGER_PROGRESS_PANEL_SEPARATOR_CLASS = "".concat(FILE_MANAGER_PROGRESS_PANEL_CLASS, "-separator");
        var FILE_MANAGER_PROGRESS_PANEL_INFO_CLASS = "".concat(FILE_MANAGER_PROGRESS_PANEL_CLASS, "-info");
        var FILE_MANAGER_PROGRESS_PANEL_COMMON_CLASS = "".concat(FILE_MANAGER_PROGRESS_PANEL_CLASS, "-common");
        var FILE_MANAGER_PROGRESS_PANEL_INFO_WITH_DETAILS_CLASS = "".concat(FILE_MANAGER_PROGRESS_PANEL_CLASS, "-info-with-details");
        var FILE_MANAGER_PROGRESS_PANEL_DETAILS_CLASS = "".concat(FILE_MANAGER_PROGRESS_PANEL_CLASS, "-details");
        var FILE_MANAGER_PROGRESS_BOX_CLASS = "dx-filemanager-progress-box";
        var FILE_MANAGER_PROGRESS_BOX_ERROR_CLASS = "".concat(FILE_MANAGER_PROGRESS_BOX_CLASS, "-error");
        var FILE_MANAGER_PROGRESS_BOX_WITHOUT_CLOSE_BUTTON_CLASS = "".concat(FILE_MANAGER_PROGRESS_BOX_CLASS, "-without-close-button");
        var FILE_MANAGER_PROGRESS_BOX_IMAGE_CLASS = "".concat(FILE_MANAGER_PROGRESS_BOX_CLASS, "-image");
        var FILE_MANAGER_PROGRESS_BOX_WRAPPER_CLASS = "".concat(FILE_MANAGER_PROGRESS_BOX_CLASS, "-wrapper");
        var FILE_MANAGER_PROGRESS_BOX_COMMON_CLASS = "".concat(FILE_MANAGER_PROGRESS_BOX_CLASS, "-common");
        var FILE_MANAGER_PROGRESS_BOX_PROGRESS_BAR_CLASS = "".concat(FILE_MANAGER_PROGRESS_BOX_CLASS, "-progress-bar");
        var FILE_MANAGER_PROGRESS_BOX_CLOSE_BUTTON_CLASS = "".concat(FILE_MANAGER_PROGRESS_BOX_CLASS, "-close-button");
        var DX_CARD_CLASS = "dx-card";
        var FileManagerProgressPanel = function(_Widget) {
            _inheritsLoose(FileManagerProgressPanel, _Widget);

            function FileManagerProgressPanel() {
                return _Widget.apply(this, arguments) || this
            }
            var _proto = FileManagerProgressPanel.prototype;
            _proto._initMarkup = function() {
                var _this = this;
                _Widget.prototype._initMarkup.call(this);
                this._initActions();
                this._operationCount = 0;
                this.$element().addClass(FILE_MANAGER_PROGRESS_PANEL_CLASS);
                var $scrollView = (0, _renderer.default)("<div>").appendTo(this.$element());
                var $container = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_PROGRESS_PANEL_CONTAINER_CLASS).appendTo($scrollView);
                this._scrollView = this._createComponent($scrollView, _scroll_view.default, {
                    scrollByContent: true,
                    scrollByThumb: true,
                    showScrollbar: "onScroll"
                });
                var $title = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_PROGRESS_PANEL_TITLE_CLASS).appendTo($container);
                (0, _renderer.default)("<div>").text(_message.default.format("dxFileManager-notificationProgressPanelTitle")).addClass(FILE_MANAGER_PROGRESS_PANEL_TITLE_TEXT_CLASS).appendTo($title);
                var $closeButton = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_PROGRESS_PANEL_CLOSE_BUTTON_CLASS).appendTo($title);
                this._createComponent($closeButton, _button.default, {
                    icon: "close",
                    stylingMode: "text",
                    onClick: function() {
                        return _this._raisePanelClosed()
                    }
                });
                this._$infosContainer = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_PROGRESS_PANEL_INFOS_CONTAINER_CLASS).appendTo($container);
                this._renderEmptyListText()
            };
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_Widget.prototype._getDefaultOptions.call(this), {
                    onOperationClosed: null,
                    onOperationCanceled: null,
                    onOperationItemCanceled: null,
                    onPanelClosed: null
                })
            };
            _proto._initActions = function() {
                this._actions = {
                    onOperationClosed: this._createActionByOption("onOperationClosed"),
                    onOperationCanceled: this._createActionByOption("onOperationCanceled"),
                    onOperationItemCanceled: this._createActionByOption("onOperationItemCanceled"),
                    onPanelClosed: this._createActionByOption("onPanelClosed")
                }
            };
            _proto._optionChanged = function(args) {
                var name = args.name;
                switch (name) {
                    case "test":
                        break;
                    case "onOperationClosed":
                    case "onOperationCanceled":
                    case "onOperationItemCanceled":
                        this._actions[name] = this._createActionByOption(name);
                        break;
                    default:
                        _Widget.prototype._optionChanged.call(this, args)
                }
            };
            _proto.addOperation = function(commonText, showCloseButtonAlways, allowProgressAutoUpdate) {
                var _this2 = this;
                if (this._operationCount) {
                    (0, _renderer.default)("<div>").addClass(FILE_MANAGER_PROGRESS_PANEL_SEPARATOR_CLASS).prependTo(this._$infosContainer)
                } else {
                    this._$infosContainer.empty()
                }
                this._operationCount++;
                var info = {
                    customCloseHandling: showCloseButtonAlways,
                    allowProgressAutoUpdate: (0, _common.ensureDefined)(allowProgressAutoUpdate, true)
                };
                var $info = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_PROGRESS_PANEL_INFO_CLASS).prependTo(this._$infosContainer);
                info.$info = $info;
                var $common = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_PROGRESS_PANEL_COMMON_CLASS).appendTo($info);
                info.common = this._createProgressBox($common, {
                    commonText: commonText,
                    showCloseButton: true,
                    showCloseButtonAlways: showCloseButtonAlways,
                    onCloseButtonClick: function() {
                        return _this2._closeOperation(info)
                    }
                });
                return info
            };
            _proto.addOperationDetails = function(info, details, showCloseButton) {
                var _this3 = this;
                info.$info.addClass(FILE_MANAGER_PROGRESS_PANEL_INFO_WITH_DETAILS_CLASS);
                var $details = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_PROGRESS_PANEL_DETAILS_CLASS).appendTo(info.$info);
                info.details = details.map(function(itemInfo, index) {
                    itemInfo.info = info;
                    return _this3._createDetailsItem($details, itemInfo, index, false, showCloseButton)
                })
            };
            _proto._createDetailsItem = function($container, item, itemIndex, skipProgressBox, showCloseButton) {
                var _this4 = this;
                var $detailsItem = (0, _renderer.default)("<div>").appendTo($container);
                if (itemIndex !== -1) {
                    $detailsItem.addClass(DX_CARD_CLASS)
                }
                return this._createProgressBox($detailsItem, {
                    commonText: item.commonText,
                    imageUrl: item.imageUrl,
                    skipProgressBox: skipProgressBox,
                    showCloseButton: showCloseButton,
                    showCloseButtonAlways: showCloseButton,
                    onCloseButtonClick: function() {
                        return _this4._cancelOperationItem(item, itemIndex)
                    }
                })
            };
            _proto.completeOperationItem = function(operationInfo, itemIndex, commonProgress) {
                if (operationInfo.allowProgressAutoUpdate) {
                    this.updateOperationItemProgress(operationInfo, itemIndex, 100, commonProgress)
                }
                this._setCloseButtonVisible(operationInfo.details[itemIndex], false)
            };
            _proto.updateOperationItemProgress = function(operationInfo, itemIndex, itemProgress, commonProgress) {
                operationInfo.common.progressBar.option("value", commonProgress);
                if (operationInfo.details) {
                    var detailsItem = operationInfo.details[itemIndex];
                    detailsItem.progressBar.option("value", itemProgress)
                }
            };
            _proto.completeOperation = function(info, commonText, isError, statusText) {
                info.completed = true;
                info.common.$commonText.text(commonText);
                if (isError) {
                    this._removeProgressBar(info.common)
                } else {
                    if (info.allowProgressAutoUpdate) {
                        info.common.progressBar.option("value", 100)
                    }
                }
                if (statusText) {
                    this._setProgressBarText(info.common, statusText)
                }
                this._setCloseButtonVisible(info.common, true)
            };
            _proto.completeSingleOperationWithError = function(info, errorText) {
                var _info$details;
                var detailsItem = null === (_info$details = info.details) || void 0 === _info$details ? void 0 : _info$details[0];
                info.completed = true;
                this._renderOperationError(detailsItem || info.common, errorText);
                this._setCloseButtonVisible(info.common, true);
                if (detailsItem) {
                    this._setCloseButtonVisible(detailsItem, false)
                }
            };
            _proto.addOperationDetailsError = function(info, index, errorText) {
                var detailsItem = info.details[index];
                this._renderOperationError(detailsItem, errorText);
                this._setCloseButtonVisible(detailsItem, false)
            };
            _proto.renderError = function($container, $target, errorText) {
                (0, _renderer.default)("<div>").text(errorText).addClass(FILE_MANAGER_PROGRESS_BOX_ERROR_CLASS).appendTo($container)
            };
            _proto.createErrorDetailsProgressBox = function($container, item, errorText) {
                var detailsItem = this._createDetailsItem($container, item, -1, true);
                this._renderOperationError(detailsItem, errorText)
            };
            _proto._renderEmptyListText = function() {
                this._$infosContainer.text(_message.default.format("dxFileManager-notificationProgressPanelEmptyListText"))
            };
            _proto._renderOperationError = function(info, errorText) {
                this._removeProgressBar(info);
                this.renderError(info.$wrapper, info.$commonText, errorText)
            };
            _proto._removeProgressBar = function(progressBox) {
                if (progressBox.progressBar) {
                    progressBox.progressBar.dispose();
                    progressBox.progressBar.$element().remove();
                    progressBox.progressBar = null
                }
            };
            _proto._createProgressBox = function($container, options) {
                var _this5 = this;
                $container.addClass(FILE_MANAGER_PROGRESS_BOX_CLASS);
                if (!options.showCloseButtonAlways) {
                    $container.addClass(FILE_MANAGER_PROGRESS_BOX_WITHOUT_CLOSE_BUTTON_CLASS)
                }
                if (options.imageUrl) {
                    (0, _icon.getImageContainer)(options.imageUrl).addClass(FILE_MANAGER_PROGRESS_BOX_IMAGE_CLASS).appendTo($container)
                }
                var $wrapper = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_PROGRESS_BOX_WRAPPER_CLASS).appendTo($container);
                var $commonText = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_PROGRESS_BOX_COMMON_CLASS).text(options.commonText).appendTo($wrapper);
                var progressBar = null;
                if (!options.skipProgressBox) {
                    var $progressBar = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_PROGRESS_BOX_PROGRESS_BAR_CLASS).appendTo($wrapper);
                    progressBar = this._createComponent($progressBar, _progress_bar.default, {
                        min: 0,
                        max: 100,
                        width: "100%",
                        validationMessageMode: "always",
                        statusFormat: function(ratio, value) {
                            return _this5._getStatusString(ratio, value)
                        }
                    })
                }
                var closeButton = null;
                if (options.showCloseButton) {
                    var $button = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_PROGRESS_BOX_CLOSE_BUTTON_CLASS).appendTo($container);
                    closeButton = this._createComponent($button, _button.default, {
                        icon: "dx-filemanager-i dx-filemanager-i-cancel",
                        stylingMode: "text",
                        visible: options.showCloseButtonAlways,
                        onClick: options.onCloseButtonClick
                    })
                }
                return {
                    $commonText: $commonText,
                    progressBar: progressBar,
                    $element: $container,
                    $wrapper: $wrapper,
                    closeButton: closeButton
                }
            };
            _proto._setCloseButtonVisible = function(progressBox, visible) {
                if (progressBox.closeButton) {
                    progressBox.$element.toggleClass(FILE_MANAGER_PROGRESS_BOX_WITHOUT_CLOSE_BUTTON_CLASS, !visible);
                    progressBox.closeButton.option("visible", visible)
                }
            };
            _proto._setProgressBarText = function(progressBox, text) {
                progressBox.progressBar.option("statusFormat", function() {
                    return text
                })
            };
            _proto._closeOperation = function(info) {
                var _this6 = this;
                if (info.customCloseHandling && !info.completed) {
                    this._raiseOperationCanceled(info);
                    this._setCloseButtonVisible(info.common, false);
                    info.details.forEach(function(item) {
                        return _this6._displayClosedOperationItem(item)
                    })
                } else {
                    this._raiseOperationClosed(info);
                    info.$info.next(".".concat(FILE_MANAGER_PROGRESS_PANEL_SEPARATOR_CLASS)).remove();
                    info.$info.remove();
                    this._operationCount--;
                    if (!this._operationCount) {
                        this._renderEmptyListText()
                    }
                }
            };
            _proto._cancelOperationItem = function(item, itemIndex) {
                this._raiseOperationItemCanceled(item, itemIndex);
                var itemInfo = item.info.details[itemIndex];
                this._displayClosedOperationItem(itemInfo)
            };
            _proto._displayClosedOperationItem = function(itemInfo) {
                this._setProgressBarText(itemInfo, _message.default.format("dxFileManager-notificationProgressPanelOperationCanceled"));
                this._setCloseButtonVisible(itemInfo, false)
            };
            _proto._getStatusString = function(ratio, value) {
                return 1 === ratio ? _message.default.format("Done") : Math.round(100 * ratio) + "%"
            };
            _proto._raiseOperationClosed = function(info) {
                this._actions.onOperationClosed({
                    info: info
                })
            };
            _proto._raiseOperationCanceled = function(info) {
                this._actions.onOperationCanceled({
                    info: info
                })
            };
            _proto._raiseOperationItemCanceled = function(item, itemIndex) {
                this._actions.onOperationItemCanceled({
                    item: item,
                    itemIndex: itemIndex
                })
            };
            _proto._raisePanelClosed = function() {
                this._actions.onPanelClosed()
            };
            return FileManagerProgressPanel
        }(_ui.default);
        var _default = FileManagerProgressPanel;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/file_manager/ui.file_manager.editing.js ***!
      \*****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _string = __webpack_require__( /*! ../../core/utils/string */ 43);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _uiFile_manager = _interopRequireDefault(__webpack_require__( /*! ./ui.file_manager.dialog_manager */ 868));
        var _uiFile_manager2 = _interopRequireDefault(__webpack_require__( /*! ./ui.file_manager.file_uploader */ 872));
        var _uiFile_manager3 = __webpack_require__( /*! ./ui.file_manager.messages */ 873);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var FileManagerEditingControl = function(_Widget) {
            _inheritsLoose(FileManagerEditingControl, _Widget);

            function FileManagerEditingControl() {
                return _Widget.apply(this, arguments) || this
            }
            var _proto = FileManagerEditingControl.prototype;
            _proto._initMarkup = function() {
                _Widget.prototype._initMarkup.call(this);
                this._initActions();
                this._controller = this.option("controller");
                this._controller.on("EditActionStarting", this._onEditActionStarting.bind(this));
                this._controller.on("EditActionResultAcquired", this._onEditActionResultAcquired.bind(this));
                this._controller.on("EditActionItemError", this._onEditActionItemError.bind(this));
                this._controller.on("EditActionError", this._onEditActionError.bind(this));
                this._controller.on("CompleteEditActionItem", this._onCompleteEditActionItem.bind(this));
                this._controller.on("CompleteEditAction", this._onCompleteEditAction.bind(this));
                this._model = this.option("model");
                this._uploadOperationInfoMap = {};
                this._dialogManager = new _uiFile_manager.default(this.$element(), {
                    chooseDirectoryDialog: {
                        provider: this._controller._fileProvider,
                        getDirectories: this._controller.getDirectories.bind(this._controller),
                        getCurrentDirectory: this._controller.getCurrentDirectory.bind(this._controller)
                    },
                    onDialogClosed: this._onDialogClosed.bind(this)
                });
                this._fileUploader = this._createFileUploader();
                var notificationControl = this.option("notificationControl");
                if (notificationControl) {
                    this._initNotificationControl(notificationControl)
                }
                this._createMetadataMap()
            };
            _proto._initNotificationControl = function(notificationControl) {
                var _this = this;
                this._notificationControl = notificationControl;
                this._notificationControl.option({
                    onOperationCanceled: function(_ref) {
                        var info = _ref.info;
                        return _this._onCancelUploadSession(info)
                    },
                    onOperationItemCanceled: function(_ref2) {
                        var item = _ref2.item,
                            itemIndex = _ref2.itemIndex;
                        return _this._onCancelFileUpload(item, itemIndex)
                    }
                })
            };
            _proto._getFileUploaderComponent = function() {
                return _uiFile_manager2.default
            };
            _proto._createFileUploader = function() {
                var _this2 = this;
                var $fileUploader = (0, _renderer.default)("<div>").appendTo(this.$element());
                return this._createComponent($fileUploader, this._getFileUploaderComponent(), {
                    getController: this._getFileUploaderController.bind(this),
                    dropZonePlaceholderContainer: this.option("uploadDropZonePlaceholderContainer"),
                    onUploadSessionStarted: function(e) {
                        return _this2._onUploadSessionStarted(e)
                    },
                    onUploadProgress: function(e) {
                        return _this2._onUploadProgress(e)
                    }
                })
            };
            _proto.setUploaderDropZone = function($element) {
                this._fileUploader.option("dropZone", $element)
            };
            _proto._getFileUploaderController = function() {
                var _this3 = this;
                var uploadDirectory = this.uploadDirectoryInfo.fileItem;
                return {
                    chunkSize: this._controller.getFileUploadChunkSize(),
                    uploadFileChunk: function(fileData, chunksInfo) {
                        return _this3._controller.uploadFileChunk(fileData, chunksInfo, uploadDirectory)
                    },
                    abortFileUpload: function(fileData, chunksInfo) {
                        return _this3._controller.abortFileUpload(fileData, chunksInfo, uploadDirectory)
                    }
                }
            };
            _proto._createMetadataMap = function() {
                var _this4 = this;
                this._metadataMap = {
                    create: {
                        action: function(arg) {
                            return _this4._tryCreate(arg)
                        },
                        affectsAllItems: true,
                        singleItemProcessingMessage: _message.default.format("dxFileManager-editingCreateSingleItemProcessingMessage"),
                        singleItemSuccessMessage: _message.default.format("dxFileManager-editingCreateSingleItemSuccessMessage"),
                        singleItemErrorMessage: _message.default.format("dxFileManager-editingCreateSingleItemErrorMessage"),
                        commonErrorMessage: _message.default.format("dxFileManager-editingCreateCommonErrorMessage")
                    },
                    rename: {
                        action: function(arg) {
                            return _this4._tryRename(arg)
                        },
                        singleItemProcessingMessage: _message.default.format("dxFileManager-editingRenameSingleItemProcessingMessage"),
                        singleItemSuccessMessage: _message.default.format("dxFileManager-editingRenameSingleItemSuccessMessage"),
                        singleItemErrorMessage: _message.default.format("dxFileManager-editingRenameSingleItemErrorMessage"),
                        commonErrorMessage: _message.default.format("dxFileManager-editingRenameCommonErrorMessage")
                    },
                    "delete": {
                        action: function(arg) {
                            return _this4._tryDelete(arg)
                        },
                        singleItemProcessingMessage: _message.default.format("dxFileManager-editingDeleteSingleItemProcessingMessage"),
                        multipleItemsProcessingMessage: _message.default.format("dxFileManager-editingDeleteMultipleItemsProcessingMessage"),
                        singleItemSuccessMessage: _message.default.format("dxFileManager-editingDeleteSingleItemSuccessMessage"),
                        multipleItemsSuccessMessage: _message.default.format("dxFileManager-editingDeleteMultipleItemsSuccessMessage"),
                        singleItemErrorMessage: _message.default.format("dxFileManager-editingDeleteSingleItemErrorMessage"),
                        multipleItemsErrorMessage: _message.default.format("dxFileManager-editingDeleteMultipleItemsErrorMessage"),
                        commonErrorMessage: _message.default.format("dxFileManager-editingDeleteCommonErrorMessage")
                    },
                    move: {
                        action: function(arg) {
                            return _this4._tryMove(arg)
                        },
                        singleItemProcessingMessage: _message.default.format("dxFileManager-editingMoveSingleItemProcessingMessage"),
                        multipleItemsProcessingMessage: _message.default.format("dxFileManager-editingMoveMultipleItemsProcessingMessage"),
                        singleItemSuccessMessage: _message.default.format("dxFileManager-editingMoveSingleItemSuccessMessage"),
                        multipleItemsSuccessMessage: _message.default.format("dxFileManager-editingMoveMultipleItemsSuccessMessage"),
                        singleItemErrorMessage: _message.default.format("dxFileManager-editingMoveSingleItemErrorMessage"),
                        multipleItemsErrorMessage: _message.default.format("dxFileManager-editingMoveMultipleItemsErrorMessage"),
                        commonErrorMessage: _message.default.format("dxFileManager-editingMoveCommonErrorMessage")
                    },
                    copy: {
                        action: function(arg) {
                            return _this4._tryCopy(arg)
                        },
                        singleItemProcessingMessage: _message.default.format("dxFileManager-editingCopySingleItemProcessingMessage"),
                        multipleItemsProcessingMessage: _message.default.format("dxFileManager-editingCopyMultipleItemsProcessingMessage"),
                        singleItemSuccessMessage: _message.default.format("dxFileManager-editingCopySingleItemSuccessMessage"),
                        multipleItemsSuccessMessage: _message.default.format("dxFileManager-editingCopyMultipleItemsSuccessMessage"),
                        singleItemErrorMessage: _message.default.format("dxFileManager-editingCopySingleItemErrorMessage"),
                        multipleItemsErrorMessage: _message.default.format("dxFileManager-editingCopyMultipleItemsErrorMessage"),
                        commonErrorMessage: _message.default.format("dxFileManager-editingCopyCommonErrorMessage")
                    },
                    upload: {
                        action: function(arg) {
                            return _this4._tryUpload(arg)
                        },
                        allowCancel: true,
                        allowItemProgress: true,
                        singleItemProcessingMessage: _message.default.format("dxFileManager-editingUploadSingleItemProcessingMessage"),
                        multipleItemsProcessingMessage: _message.default.format("dxFileManager-editingUploadMultipleItemsProcessingMessage"),
                        singleItemSuccessMessage: _message.default.format("dxFileManager-editingUploadSingleItemSuccessMessage"),
                        multipleItemsSuccessMessage: _message.default.format("dxFileManager-editingUploadMultipleItemsSuccessMessage"),
                        singleItemErrorMessage: _message.default.format("dxFileManager-editingUploadSingleItemErrorMessage"),
                        multipleItemsErrorMessage: _message.default.format("dxFileManager-editingUploadMultipleItemsErrorMessage"),
                        canceledMessage: _message.default.format("dxFileManager-editingUploadCanceledMessage")
                    },
                    download: {
                        action: function(arg) {
                            return _this4._download(arg)
                        }
                    },
                    getItemContent: {
                        action: function(arg) {
                            return _this4._getItemContent(arg)
                        }
                    },
                    getItems: {
                        singleItemProcessingMessage: "",
                        singleItemErrorMessage: _message.default.format("dxFileManager-errorDirectoryOpenFailed"),
                        commonErrorMessage: _message.default.format("dxFileManager-errorDirectoryOpenFailed")
                    }
                }
            };
            _proto.getCommandActions = function() {
                var _this5 = this;
                var result = {};
                (0, _iterator.each)(this._metadataMap, function(name) {
                    if (Object.prototype.hasOwnProperty.call(_this5._metadataMap, name)) {
                        result[name] = function(arg) {
                            return _this5._executeAction(name, arg)
                        }
                    }
                });
                return result
            };
            _proto._executeAction = function(actionName, arg) {
                var actionMetadata = this._metadataMap[actionName];
                return actionMetadata ? actionMetadata.action(arg) : null
            };
            _proto._onCancelUploadSession = function(info) {
                this._fileUploader.cancelUpload(info.uploadSessionId)
            };
            _proto._onCancelFileUpload = function(item, itemIndex) {
                this._fileUploader.cancelFileUpload(item.info.uploadSessionId, itemIndex)
            };
            _proto._onUploadProgress = function(_ref3) {
                var sessionId = _ref3.sessionId,
                    fileIndex = _ref3.fileIndex,
                    commonValue = _ref3.commonValue,
                    fileValue = _ref3.fileValue;
                var operationInfo = this._uploadOperationInfoMap[sessionId];
                this._notificationControl.updateOperationItemProgress(operationInfo, fileIndex, 100 * fileValue, 100 * commonValue)
            };
            _proto._onUploadSessionStarted = function(_ref4) {
                var sessionInfo = _ref4.sessionInfo;
                this._controller.processUploadSession(sessionInfo, this.uploadDirectoryInfo)
            };
            _proto._onEditActionStarting = function(actionInfo) {
                var actionMetadata = this._metadataMap[actionInfo.name];
                var context = new FileManagerActionContext(actionMetadata, actionInfo.itemInfos, actionInfo.directory);
                var operationInfo = this._notificationControl.addOperation(context.processingMessage, actionMetadata.allowCancel, !actionMetadata.allowItemProgress);
                (0, _extend.extend)(actionInfo.customData, {
                    context: context,
                    operationInfo: operationInfo
                });
                switch (actionInfo.name) {
                    case "upload":
                        var sessionId = actionInfo.customData.sessionInfo.sessionId;
                        operationInfo.uploadSessionId = sessionId;
                        this._uploadOperationInfoMap[sessionId] = operationInfo;
                        break;
                    case "rename":
                        actionInfo.customData.context.itemNewName = actionInfo.customData.itemNewName
                }
            };
            _proto._onEditActionResultAcquired = function(actionInfo) {
                var _this6 = this;
                var _actionInfo$customDat = actionInfo.customData,
                    context = _actionInfo$customDat.context,
                    operationInfo = _actionInfo$customDat.operationInfo;
                context.singleRequest = actionInfo.singleRequest;
                var details = context.itemInfos.map(function(itemInfo) {
                    return _this6._getItemProgressDisplayInfo(itemInfo)
                });
                this._notificationControl.addOperationDetails(operationInfo, details, context.actionMetadata.allowCancel)
            };
            _proto._onEditActionError = function(actionInfo, errorInfo) {
                var _actionInfo$customDat2 = actionInfo.customData,
                    context = _actionInfo$customDat2.context,
                    operationInfo = _actionInfo$customDat2.operationInfo;
                context.singleRequest = actionInfo.singleRequest;
                this._handleActionError(operationInfo, context, errorInfo);
                this._completeAction(operationInfo, context)
            };
            _proto._onEditActionItemError = function(actionInfo, errorInfo) {
                var _actionInfo$customDat3 = actionInfo.customData,
                    context = _actionInfo$customDat3.context,
                    operationInfo = _actionInfo$customDat3.operationInfo;
                this._handleActionError(operationInfo, context, errorInfo)
            };
            _proto._onCompleteEditActionItem = function(actionInfo, info) {
                var _actionInfo$customDat4 = actionInfo.customData,
                    context = _actionInfo$customDat4.context,
                    operationInfo = _actionInfo$customDat4.operationInfo;
                if (!info.result || !info.result.canceled) {
                    context.completeOperationItem(info.index);
                    this._notificationControl.completeOperationItem(operationInfo, info.index, context.commonProgress)
                }
            };
            _proto._onCompleteEditAction = function(actionInfo) {
                var _actionInfo$customDat5 = actionInfo.customData,
                    context = _actionInfo$customDat5.context,
                    operationInfo = _actionInfo$customDat5.operationInfo;
                this._completeAction(operationInfo, context);
                if ("upload" === actionInfo.name) {
                    delete this._uploadOperationInfoMap[actionInfo.customData.sessionInfo.sessionId]
                }
            };
            _proto._tryCreate = function(parentDirectories) {
                var _this7 = this;
                var parentDirectoryInfo = parentDirectories && parentDirectories[0] || this._getCurrentDirectory();
                var newDirName = _message.default.format("dxFileManager-newDirectoryName");
                return this._showDialog(this._dialogManager.getCreateItemDialog(), newDirName).then(function(_ref5) {
                    var name = _ref5.name;
                    return _this7._controller.createDirectory(parentDirectoryInfo, name)
                })
            };
            _proto._tryRename = function(itemInfos) {
                var _this8 = this;
                var itemInfo = itemInfos && itemInfos[0] || this._model.getMultipleSelectedItems()[0];
                return this._showDialog(this._dialogManager.getRenameItemDialog(), itemInfo.fileItem.name).then(function(_ref6) {
                    var name = _ref6.name;
                    return _this8._controller.renameItem(itemInfo, name)
                })
            };
            _proto._tryDelete = function(itemInfos) {
                var _this9 = this;
                itemInfos = itemInfos || this._model.getMultipleSelectedItems();
                var itemName = itemInfos[0].fileItem.name;
                var itemCount = itemInfos.length;
                return this._showDialog(this._dialogManager.getDeleteItemDialog(), {
                    itemName: itemName,
                    itemCount: itemCount
                }).then(function() {
                    return _this9._controller.deleteItems(itemInfos)
                })
            };
            _proto._tryMove = function(itemInfos) {
                var _this10 = this;
                itemInfos = itemInfos || this._model.getMultipleSelectedItems();
                return this._showDialog(this._dialogManager.getMoveDialog(itemInfos)).then(function(_ref7) {
                    var folder = _ref7.folder;
                    return _this10._controller.moveItems(itemInfos, folder)
                })
            };
            _proto._tryCopy = function(itemInfos) {
                var _this11 = this;
                itemInfos = itemInfos || this._model.getMultipleSelectedItems();
                return this._showDialog(this._dialogManager.getCopyDialog(itemInfos)).then(function(_ref8) {
                    var folder = _ref8.folder;
                    return _this11._controller.copyItems(itemInfos, folder)
                })
            };
            _proto._tryUpload = function(destinationFolder) {
                this._uploadDirectoryInfo = null === destinationFolder || void 0 === destinationFolder ? void 0 : destinationFolder[0];
                this._fileUploader.tryUpload()
            };
            _proto._download = function(itemInfos) {
                itemInfos = itemInfos || this._model.getMultipleSelectedItems();
                return this._controller.downloadItems(itemInfos)
            };
            _proto._getItemContent = function(itemInfos) {
                itemInfos = itemInfos || this._model.getMultipleSelectedItems();
                return this._controller.getItemContent(itemInfos)
            };
            _proto._completeAction = function(operationInfo, context) {
                this._notificationControl.completeOperation(operationInfo, context.completionMessage, !context.success, context.statusText);
                if (context.hasModifiedItems()) {
                    this._raiseOnSuccess(context.onlyFiles)
                }
            };
            _proto._handleActionError = function(operationInfo, context, errorInfo) {
                operationInfo.hasError = true;
                if (context.singleRequest) {
                    this._handleSingleRequestActionError(operationInfo, context, errorInfo)
                } else {
                    this._handleMultipleRequestActionError(operationInfo, context, errorInfo)
                }
            };
            _proto._handleSingleRequestActionError = function(operationInfo, context, errorInfo) {
                var itemInfo = context.getItemForSingleRequestError();
                var itemName = context.itemNewName;
                var errorText = this._getErrorText(errorInfo, itemInfo, itemName);
                context.processSingleRequestError(errorText);
                var operationErrorInfo = this._getOperationErrorInfo(context);
                this._notificationControl.completeSingleOperationWithError(operationInfo, operationErrorInfo);
                if (context.multipleItems) {
                    this._raiseOnSuccess(context.onlyFiles)
                }
            };
            _proto._handleMultipleRequestActionError = function(operationInfo, context, errorInfo) {
                var itemInfo = context.getItemForMultipleRequestError(errorInfo.index);
                var errorText = this._getErrorText(errorInfo, itemInfo);
                context.processMultipleRequestError(errorInfo.index, errorText);
                var operationErrorInfo = this._getOperationErrorInfo(context);
                this._notificationControl.addOperationDetailsError(operationInfo, operationErrorInfo)
            };
            _proto._getOperationErrorInfo = function(context) {
                var detailError = context.errorState.currentDetailError;
                return {
                    commonErrorText: context.errorState.commonErrorText,
                    item: detailError.itemInfo ? this._getItemProgressDisplayInfo(detailError.itemInfo) : null,
                    itemIndex: detailError.itemIndex,
                    detailErrorText: detailError.errorText
                }
            };
            _proto._getErrorText = function(errorInfo, itemInfo, itemName) {
                itemName = itemName || (null === itemInfo || void 0 === itemInfo ? void 0 : itemInfo.fileItem.name);
                var errorText = errorInfo.errorText || _uiFile_manager3.FileManagerMessages.get(errorInfo.errorId, itemName);
                var errorArgs = {
                    fileSystemItem: null === itemInfo || void 0 === itemInfo ? void 0 : itemInfo.fileItem,
                    errorCode: errorInfo.errorId,
                    errorText: errorText
                };
                this._raiseOnError(errorArgs);
                return errorArgs.errorText
            };
            _proto._getItemProgressDisplayInfo = function(itemInfo) {
                return {
                    commonText: itemInfo.fileItem.name,
                    imageUrl: this._getItemThumbnail(itemInfo)
                }
            };
            _proto._showDialog = function(dialog, dialogArgument) {
                this._dialogDeferred = new _deferred.Deferred;
                dialog.show(dialogArgument);
                return this._dialogDeferred.promise()
            };
            _proto._onDialogClosed = function(e) {
                var result = e.dialogResult;
                if (result) {
                    this._dialogDeferred.resolve(result)
                } else {
                    this._dialogDeferred.reject()
                }
            };
            _proto._getItemThumbnail = function(item) {
                var itemThumbnailGetter = this.option("getItemThumbnail");
                if (!itemThumbnailGetter) {
                    return null
                }
                var info = itemThumbnailGetter(item);
                return info ? info.thumbnail : null
            };
            _proto._initActions = function() {
                this._actions = {
                    onSuccess: this._createActionByOption("onSuccess"),
                    onError: this._createActionByOption("onError"),
                    onCreating: this._createActionByOption("onCreating")
                }
            };
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_Widget.prototype._getDefaultOptions.call(this), {
                    model: {
                        getMultipleSelectedItems: null
                    },
                    notificationControl: null,
                    getItemThumbnail: null,
                    onSuccess: null,
                    onError: null,
                    onCreating: null
                })
            };
            _proto._optionChanged = function(args) {
                var name = args.name;
                switch (name) {
                    case "model":
                        this.repaint();
                        break;
                    case "notificationControl":
                        this._initNotificationControl(args.value);
                        break;
                    case "getItemThumbnail":
                        break;
                    case "uploadDropZonePlaceholderContainer":
                        this._fileUploader.option("dropZonePlaceholderContainer", args.value);
                        break;
                    case "onSuccess":
                    case "onError":
                    case "onCreating":
                        this._actions[name] = this._createActionByOption(name);
                        break;
                    default:
                        _Widget.prototype._optionChanged.call(this, args)
                }
            };
            _proto._raiseOnSuccess = function(updatedOnlyFiles) {
                this._actions.onSuccess({
                    updatedOnlyFiles: updatedOnlyFiles
                })
            };
            _proto._raiseOnError = function(args) {
                this._actions.onError(args)
            };
            _proto._getCurrentDirectory = function() {
                return this._controller.getCurrentDirectory()
            };
            _createClass(FileManagerEditingControl, [{
                key: "uploadDirectoryInfo",
                get: function() {
                    return this._uploadDirectoryInfo || this._getCurrentDirectory()
                }
            }]);
            return FileManagerEditingControl
        }(_ui.default);
        var FileManagerActionContext = function() {
            function FileManagerActionContext(actionMetadata, itemInfos, directoryInfo) {
                this._actionMetadata = actionMetadata;
                this._itemInfos = itemInfos;
                this._onlyFiles = !this._actionMetadata.affectsAllItems && this._itemInfos.every(function(info) {
                    return !info.fileItem.isDirectory
                });
                this._items = this._itemInfos.map(function(itemInfo) {
                    return itemInfo.fileItem
                });
                this._multipleItems = this._items.length > 1;
                this._location = directoryInfo.getDisplayName();
                this._singleRequest = true;
                this._completedItems = [];
                this._commonProgress = 0;
                this._errorState = {
                    failedCount: 0
                };
                this._itemNewName = ""
            }
            var _proto2 = FileManagerActionContext.prototype;
            _proto2.completeOperationItem = function(itemIndex) {
                if (this._singleRequest) {
                    this._completedItems = _toConsumableArray(this._items)
                } else {
                    var item = this._items[itemIndex];
                    this._completedItems.push(item)
                }
                if (!this._actionMetadata.allowItemProgress) {
                    this._commonProgress = this._completedItems.length / this._items.length * 100
                }
            };
            _proto2.processSingleRequestError = function(errorText) {
                this._errorState.failedCount = 1;
                this._errorState.commonErrorText = this._multipleItems ? this._actionMetadata.commonErrorMessage : this._actionMetadata.singleItemErrorMessage;
                var itemIndex = this._multipleItems ? -1 : 1;
                var itemInfo = this.getItemForSingleRequestError();
                this._setCurrentDetailError(itemIndex, itemInfo, errorText)
            };
            _proto2.processMultipleRequestError = function(itemIndex, errorText) {
                this._errorState.failedCount++;
                this._errorState.commonErrorText = this._errorState.failedCount > 1 ? (0, _string.format)(this._actionMetadata.multipleItemsErrorMessage, this._errorState.failedCount) : this._actionMetadata.singleItemErrorMessage;
                var itemInfo = this.getItemForMultipleRequestError(itemIndex);
                this._setCurrentDetailError(itemIndex, itemInfo, errorText)
            };
            _proto2.hasModifiedItems = function() {
                return this._hasCompletedItems() || this._singleRequest && !this.success && this._multipleItems
            };
            _proto2.getItemForSingleRequestError = function() {
                return this._multipleItems ? null : this._itemInfos[0]
            };
            _proto2.getItemForMultipleRequestError = function(itemIndex) {
                return this._itemInfos[itemIndex]
            };
            _proto2._setCurrentDetailError = function(itemIndex, itemInfo, errorText) {
                this._errorState.currentDetailError = {
                    itemIndex: itemIndex,
                    itemInfo: itemInfo,
                    errorText: errorText
                }
            };
            _proto2._hasCompletedItems = function() {
                return this._completedItems.length > 0
            };
            _createClass(FileManagerActionContext, [{
                key: "actionMetadata",
                get: function() {
                    return this._actionMetadata
                }
            }, {
                key: "itemInfos",
                get: function() {
                    return this._itemInfos
                }
            }, {
                key: "itemNewName",
                get: function() {
                    return this._itemNewName
                },
                set: function(value) {
                    this._itemNewName = value
                }
            }, {
                key: "errorState",
                get: function() {
                    return this._errorState
                }
            }, {
                key: "singleRequest",
                get: function() {
                    return this._singleRequest
                },
                set: function(value) {
                    this._singleRequest = value
                }
            }, {
                key: "multipleItems",
                get: function() {
                    return this._multipleItems
                }
            }, {
                key: "onlyFiles",
                get: function() {
                    return this._onlyFiles
                }
            }, {
                key: "processingMessage",
                get: function() {
                    return this._multipleItems ? (0, _string.format)(this._actionMetadata.multipleItemsProcessingMessage, this._items.length, this._location) : (0, _string.format)(this._actionMetadata.singleItemProcessingMessage, this._location)
                }
            }, {
                key: "successMessage",
                get: function() {
                    if (this._hasCompletedItems()) {
                        return this._multipleItems ? (0, _string.format)(this._actionMetadata.multipleItemsSuccessMessage, this._completedItems.length, this._location) : (0, _string.format)(this._actionMetadata.singleItemSuccessMessage, this._location)
                    } else {
                        return this._multipleItems ? (0, _string.format)(this._actionMetadata.multipleItemsErrorMessage, this._items.length) : this._actionMetadata.singleItemErrorMessage
                    }
                }
            }, {
                key: "completionMessage",
                get: function() {
                    return this.success ? this.successMessage : this.errorState.commonErrorText
                }
            }, {
                key: "statusText",
                get: function() {
                    return this.success && !this._hasCompletedItems() ? this._actionMetadata.canceledMessage : void 0
                }
            }, {
                key: "commonProgress",
                get: function() {
                    return this._commonProgress
                }
            }, {
                key: "success",
                get: function() {
                    return !this._errorState.failedCount
                }
            }]);
            return FileManagerActionContext
        }();
        var _default = FileManagerEditingControl;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/file_manager/ui.file_manager.dialog_manager.js ***!
      \************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _uiFile_managerDialog = _interopRequireDefault(__webpack_require__( /*! ./ui.file_manager.dialog.name_editor */ 869));
        var _uiFile_managerDialog2 = _interopRequireDefault(__webpack_require__( /*! ./ui.file_manager.dialog.folder_chooser */ 870));
        var _uiFile_managerDialog3 = _interopRequireDefault(__webpack_require__( /*! ./ui.file_manager.dialog.delete_item */ 871));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var FileManagerDialogManager = function() {
            function FileManagerDialogManager($element, options) {
                this._$element = $element;
                this._options = options;
                var $chooseFolderDialog = (0, _renderer.default)("<div>").appendTo(this._$element);
                this._chooseDirectoryDialog = new _uiFile_managerDialog2.default($chooseFolderDialog, (0, _extend.extend)(this._options.chooseDirectoryDialog, {
                    onClosed: this._options.onDialogClosed
                }));
                var $renameDialog = (0, _renderer.default)("<div>").appendTo(this._$element);
                this._renameItemDialog = new _uiFile_managerDialog.default($renameDialog, {
                    title: _message.default.format("dxFileManager-dialogRenameItemTitle"),
                    buttonText: _message.default.format("dxFileManager-dialogRenameItemButtonText"),
                    onClosed: this._options.onDialogClosed
                });
                var $createDialog = (0, _renderer.default)("<div>").appendTo(this._$element);
                this._createItemDialog = new _uiFile_managerDialog.default($createDialog, {
                    title: _message.default.format("dxFileManager-dialogCreateDirectoryTitle"),
                    buttonText: _message.default.format("dxFileManager-dialogCreateDirectoryButtonText"),
                    onClosed: this._options.onDialogClosed
                });
                var $deleteItemDialog = (0, _renderer.default)("<div>").appendTo(this._$element);
                this._deleteItemDialog = new _uiFile_managerDialog3.default($deleteItemDialog, {
                    onClosed: this._options.onDialogClosed
                })
            }
            var _proto = FileManagerDialogManager.prototype;
            _proto.getCopyDialog = function(targetItemInfos) {
                this._chooseDirectoryDialog.switchToCopyDialog(targetItemInfos);
                return this._chooseDirectoryDialog
            };
            _proto.getMoveDialog = function(targetItemInfos) {
                this._chooseDirectoryDialog.switchToMoveDialog(targetItemInfos);
                return this._chooseDirectoryDialog
            };
            _proto.getRenameItemDialog = function() {
                return this._renameItemDialog
            };
            _proto.getCreateItemDialog = function() {
                return this._createItemDialog
            };
            _proto.getDeleteItemDialog = function() {
                return this._deleteItemDialog
            };
            return FileManagerDialogManager
        }();
        var _default = FileManagerDialogManager;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/file_manager/ui.file_manager.dialog.name_editor.js ***!
      \****************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _text_box = _interopRequireDefault(__webpack_require__( /*! ../text_box */ 97));
        var _uiFile_managerDialog = _interopRequireDefault(__webpack_require__( /*! ./ui.file_manager.dialog.js */ 306));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var FILE_MANAGER_DIALOG_NAME_EDITOR = "dx-filemanager-dialog-name-editor";
        var FILE_MANAGER_DIALOG_NAME_EDITOR_POPUP = "dx-filemanager-dialog-name-editor-popup";
        var FileManagerNameEditorDialog = function(_FileManagerDialogBas) {
            _inheritsLoose(FileManagerNameEditorDialog, _FileManagerDialogBas);

            function FileManagerNameEditorDialog() {
                return _FileManagerDialogBas.apply(this, arguments) || this
            }
            var _proto = FileManagerNameEditorDialog.prototype;
            _proto.show = function(name) {
                name = name || "";
                if (this._nameTextBox) {
                    this._nameTextBox.option("value", name)
                } else {
                    this._initialNameValue = name
                }
                _FileManagerDialogBas.prototype.show.call(this)
            };
            _proto._onPopupShown = function() {
                if (!this._nameTextBox) {
                    return
                }
                var $textBoxInput = this._nameTextBox._input();
                $textBoxInput.length && $textBoxInput[0].select();
                this._nameTextBox.focus()
            };
            _proto._getDialogOptions = function() {
                return (0, _extend.extend)(_FileManagerDialogBas.prototype._getDialogOptions.call(this), {
                    title: this.option("title"),
                    buttonText: this.option("buttonText"),
                    contentCssClass: FILE_MANAGER_DIALOG_NAME_EDITOR,
                    popupCssClass: FILE_MANAGER_DIALOG_NAME_EDITOR_POPUP
                })
            };
            _proto._createContentTemplate = function(element) {
                _FileManagerDialogBas.prototype._createContentTemplate.call(this, element);
                this._nameTextBox = this._createComponent((0, _renderer.default)("<div>"), _text_box.default, {
                    value: this._initialNameValue,
                    onEnterKey: this._applyDialogChanges.bind(this)
                });
                this._$contentElement.append(this._nameTextBox.$element())
            };
            _proto._getDialogResult = function() {
                var nameValue = this._nameTextBox.option("value");
                return nameValue ? {
                    name: nameValue
                } : null
            };
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_FileManagerDialogBas.prototype._getDefaultOptions.call(this), {
                    title: "",
                    buttonText: ""
                })
            };
            return FileManagerNameEditorDialog
        }(_uiFile_managerDialog.default);
        var _default = FileManagerNameEditorDialog;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/file_manager/ui.file_manager.dialog.folder_chooser.js ***!
      \*******************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _uiFile_manager = __webpack_require__( /*! ./ui.file_manager.common */ 141);
        var _uiFile_managerDialog = _interopRequireDefault(__webpack_require__( /*! ./ui.file_manager.dialog.js */ 306));
        var _uiFile_manager2 = _interopRequireDefault(__webpack_require__( /*! ./ui.file_manager.files_tree_view */ 452));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var FILE_MANAGER_DIALOG_FOLDER_CHOOSER = "dx-filemanager-dialog-folder-chooser";
        var FILE_MANAGER_DIALOG_FOLDER_CHOOSER_POPUP = "dx-filemanager-dialog-folder-chooser-popup";
        var FileManagerFolderChooserDialog = function(_FileManagerDialogBas) {
            _inheritsLoose(FileManagerFolderChooserDialog, _FileManagerDialogBas);

            function FileManagerFolderChooserDialog() {
                return _FileManagerDialogBas.apply(this, arguments) || this
            }
            var _proto = FileManagerFolderChooserDialog.prototype;
            _proto.show = function() {
                var _this$_filesTreeView;
                this._resetDialogSelectedDirectory();
                null === (_this$_filesTreeView = this._filesTreeView) || void 0 === _this$_filesTreeView ? void 0 : _this$_filesTreeView.refresh();
                _FileManagerDialogBas.prototype.show.call(this)
            };
            _proto.switchToCopyDialog = function(targetItemInfos) {
                this._targetItemInfos = targetItemInfos;
                this._setTitle(_message.default.format("dxFileManager-dialogDirectoryChooserCopyTitle"));
                this._setButtonText(_message.default.format("dxFileManager-dialogDirectoryChooserCopyButtonText"))
            };
            _proto.switchToMoveDialog = function(targetItemInfos) {
                this._targetItemInfos = targetItemInfos;
                this._setTitle(_message.default.format("dxFileManager-dialogDirectoryChooserMoveTitle"));
                this._setButtonText(_message.default.format("dxFileManager-dialogDirectoryChooserMoveButtonText"))
            };
            _proto._getDialogOptions = function() {
                return (0, _extend.extend)(_FileManagerDialogBas.prototype._getDialogOptions.call(this), {
                    contentCssClass: FILE_MANAGER_DIALOG_FOLDER_CHOOSER,
                    popupCssClass: FILE_MANAGER_DIALOG_FOLDER_CHOOSER_POPUP
                })
            };
            _proto._createContentTemplate = function(element) {
                var _this = this;
                _FileManagerDialogBas.prototype._createContentTemplate.call(this, element);
                this._filesTreeView = this._createComponent((0, _renderer.default)("<div>"), _uiFile_manager2.default, {
                    getDirectories: this.option("getDirectories"),
                    getCurrentDirectory: function() {
                        return _this._getDialogSelectedDirectory()
                    },
                    onDirectoryClick: function(e) {
                        return _this._onFilesTreeViewDirectoryClick(e)
                    },
                    onFilesTreeViewContentReady: function() {
                        return _this._toggleUnavailableLocationsDisabled(true)
                    }
                });
                this._$contentElement.append(this._filesTreeView.$element())
            };
            _proto._getDialogResult = function() {
                var result = this._getDialogSelectedDirectory();
                return result ? {
                    folder: result
                } : result
            };
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_FileManagerDialogBas.prototype._getDefaultOptions.call(this), {
                    getItems: null
                })
            };
            _proto._getDialogSelectedDirectory = function() {
                return this._selectedDirectoryInfo
            };
            _proto._resetDialogSelectedDirectory = function() {
                this._selectedDirectoryInfo = null
            };
            _proto._onFilesTreeViewDirectoryClick = function(_ref) {
                var itemData = _ref.itemData;
                this._selectedDirectoryInfo = itemData;
                this._filesTreeView.updateCurrentDirectory()
            };
            _proto._onPopupShown = function() {
                this._toggleUnavailableLocationsDisabled(true);
                _FileManagerDialogBas.prototype._onPopupShown.call(this)
            };
            _proto._onPopupHidden = function() {
                this._toggleUnavailableLocationsDisabled(false);
                _FileManagerDialogBas.prototype._onPopupHidden.call(this)
            };
            _proto._toggleUnavailableLocationsDisabled = function(isDisabled) {
                var _this2 = this;
                if (!this._filesTreeView) {
                    return
                }
                var locations = this._getLocationsToProcess(isDisabled);
                this._filesTreeView.toggleDirectoryExpandedStateRecursive(locations.locationsToExpand[0], isDisabled).then(function() {
                    return _this2._filesTreeView.toggleDirectoryLineExpandedState(locations.locationsToCollapse, !isDisabled).then(function() {
                        return locations.locationKeysToDisable.forEach(function(key) {
                            return _this2._filesTreeView.toggleNodeDisabledState(key, isDisabled)
                        })
                    })
                })
            };
            _proto._getLocationsToProcess = function(isDisabled) {
                var _expandMap$keys;
                var expandLocations = {};
                var collapseLocations = {};
                this._targetItemInfos.forEach(function(itemInfo) {
                    if (itemInfo.parentDirectory) {
                        expandLocations[itemInfo.parentDirectory.getInternalKey()] = itemInfo.parentDirectory
                    }
                    if (itemInfo.fileItem.isDirectory) {
                        collapseLocations[itemInfo.getInternalKey()] = itemInfo
                    }
                });
                var expandMap = (0, _uiFile_manager.getMapFromObject)(expandLocations);
                var collapseMap = (0, _uiFile_manager.getMapFromObject)(collapseLocations);
                return {
                    locationsToExpand: isDisabled ? expandMap.values : [],
                    locationsToCollapse: isDisabled ? collapseMap.values : [],
                    locationKeysToDisable: (_expandMap$keys = expandMap.keys).concat.apply(_expandMap$keys, _toConsumableArray(collapseMap.keys))
                }
            };
            return FileManagerFolderChooserDialog
        }(_uiFile_managerDialog.default);
        var _default = FileManagerFolderChooserDialog;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/file_manager/ui.file_manager.dialog.delete_item.js ***!
      \****************************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _scroll_view = _interopRequireDefault(__webpack_require__( /*! ../scroll_view */ 90));
        var _uiFile_managerDialog = _interopRequireDefault(__webpack_require__( /*! ./ui.file_manager.dialog.js */ 306));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var FILE_MANAGER_DIALOG_DELETE_ITEM = "dx-filemanager-dialog-delete-item";
        var FILE_MANAGER_DIALOG_DELETE_ITEM_POPUP = "dx-filemanager-dialog-delete-item-popup";
        var FileManagerDeleteItemDialog = function(_FileManagerDialogBas) {
            _inheritsLoose(FileManagerDeleteItemDialog, _FileManagerDialogBas);

            function FileManagerDeleteItemDialog() {
                return _FileManagerDialogBas.apply(this, arguments) || this
            }
            var _proto = FileManagerDeleteItemDialog.prototype;
            _proto.show = function(_ref) {
                var itemName = _ref.itemName,
                    itemCount = _ref.itemCount;
                var text = 1 === itemCount ? _message.default.format("dxFileManager-dialogDeleteItemSingleItemConfirmation", itemName) : _message.default.format("dxFileManager-dialogDeleteItemMultipleItemsConfirmation", itemCount);
                if (this._$text) {
                    this._$text.text(text)
                } else {
                    this._initialText = text
                }
                _FileManagerDialogBas.prototype.show.call(this)
            };
            _proto._getDialogOptions = function() {
                return (0, _extend.extend)(_FileManagerDialogBas.prototype._getDialogOptions.call(this), {
                    title: _message.default.format("dxFileManager-dialogDeleteItemTitle"),
                    buttonText: _message.default.format("dxFileManager-dialogDeleteItemButtonText"),
                    contentCssClass: FILE_MANAGER_DIALOG_DELETE_ITEM,
                    popupCssClass: FILE_MANAGER_DIALOG_DELETE_ITEM_POPUP,
                    height: "auto",
                    maxHeight: "80vh"
                })
            };
            _proto._createContentTemplate = function(element) {
                _FileManagerDialogBas.prototype._createContentTemplate.call(this, element);
                this._$text = (0, _renderer.default)("<div>").text(this._initialText).appendTo(this._$contentElement);
                this._createComponent(this._$contentElement, _scroll_view.default, {
                    width: "100%",
                    height: "100%"
                })
            };
            _proto._getDialogResult = function() {
                return {}
            };
            return FileManagerDeleteItemDialog
        }(_uiFile_managerDialog.default);
        var _default = FileManagerDeleteItemDialog;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/file_manager/ui.file_manager.file_uploader.js ***!
      \***********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _guid = _interopRequireDefault(__webpack_require__( /*! ../../core/guid */ 36));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _file_uploader = _interopRequireDefault(__webpack_require__( /*! ../file_uploader */ 281));
        var _uiFile_manager = __webpack_require__( /*! ./ui.file_manager.common */ 141);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var FILE_MANAGER_FILE_UPLOADER_CLASS = "dx-filemanager-fileuploader";
        var FILE_MANAGER_FILE_UPLOADER_DROPZONE_PLACEHOLER_CLASS = "dx-filemanager-fileuploader-dropzone-placeholder";
        var FileManagerFileUploader = function(_Widget) {
            _inheritsLoose(FileManagerFileUploader, _Widget);

            function FileManagerFileUploader() {
                return _Widget.apply(this, arguments) || this
            }
            var _proto = FileManagerFileUploader.prototype;
            _proto._initMarkup = function() {
                this._initActions();
                this.$element().addClass(FILE_MANAGER_FILE_UPLOADER_CLASS);
                this._uploaderInfos = [];
                this._createInternalFileUploader();
                this._createDropZonePlaceholder();
                this._setDropZonePlaceholderVisible(false);
                _Widget.prototype._initMarkup.call(this)
            };
            _proto._createInternalFileUploader = function() {
                var _this = this;
                var chunkSize = this._getController().chunkSize;
                var $fileUploader = (0, _renderer.default)("<div>").appendTo(this.$element());
                var fileUploader = this._createComponent($fileUploader, _file_uploader.default, {
                    name: "file",
                    multiple: true,
                    showFileList: false,
                    activeStateEnabled: false,
                    focusStateEnabled: false,
                    hoverStateEnabled: false,
                    labelText: "",
                    readyToUploadMessage: "",
                    accept: "*",
                    chunkSize: chunkSize,
                    dropZone: this.option("dropZone"),
                    onValueChanged: function(e) {
                        return _this._onFileUploaderValueChanged(e)
                    },
                    onProgress: function(e) {
                        return _this._onFileUploaderProgress(e)
                    },
                    onUploaded: function(e) {
                        return _this._onFileUploaderUploaded(e)
                    },
                    onUploadAborted: function(e) {
                        return _this._onFileUploaderUploadAborted(e)
                    },
                    onUploadError: function(e) {
                        return _this._onFileUploaderUploadError(e)
                    },
                    onDropZoneEnter: function() {
                        return _this._setDropZonePlaceholderVisible(true)
                    },
                    onDropZoneLeave: function() {
                        return _this._setDropZonePlaceholderVisible(false)
                    }
                });
                fileUploader.option({
                    uploadChunk: function(file, chunksData) {
                        return _this._fileUploaderUploadChunk(fileUploader, file, chunksData)
                    },
                    abortUpload: function(file, chunksData) {
                        return _this._fileUploaderAbortUpload(fileUploader, file, chunksData)
                    }
                });
                var uploaderInfo = {
                    fileUploader: fileUploader
                };
                this._uploaderInfos.push(uploaderInfo)
            };
            _proto.tryUpload = function() {
                var info = this._findAndUpdateAvailableUploaderInfo();
                if (info) {
                    info.fileUploader._selectButtonClickHandler()
                }
            };
            _proto.cancelUpload = function(sessionId) {
                this._cancelUpload(sessionId)
            };
            _proto.cancelFileUpload = function(sessionId, fileIndex) {
                this._cancelUpload(sessionId, fileIndex)
            };
            _proto._cancelUpload = function(sessionId, fileIndex) {
                var _this$_findUploaderIn = this._findUploaderInfoBySessionId(sessionId),
                    fileUploader = _this$_findUploaderIn.fileUploader;
                fileUploader.abortUpload(fileIndex)
            };
            _proto._fileUploaderUploadChunk = function(fileUploader, file, chunksInfo) {
                var _this$_findSessionByF = this._findSessionByFile(fileUploader, file),
                    session = _this$_findSessionByF.session,
                    fileIndex = _this$_findSessionByF.fileIndex;
                var controller = session.controller;
                chunksInfo.fileIndex = fileIndex;
                return controller.uploadFileChunk(file, chunksInfo)
            };
            _proto._fileUploaderAbortUpload = function(fileUploader, file, chunksInfo) {
                var _this$_findSessionByF2 = this._findSessionByFile(fileUploader, file),
                    session = _this$_findSessionByF2.session,
                    fileIndex = _this$_findSessionByF2.fileIndex;
                var controller = session.controller;
                chunksInfo.fileIndex = fileIndex;
                return controller.abortFileUpload(file, chunksInfo)
            };
            _proto._onFileUploaderValueChanged = function(_ref) {
                var _this2 = this;
                var component = _ref.component,
                    value = _ref.value;
                if (0 === value.length) {
                    return
                }
                var files = value.slice();
                var uploaderInfo = this._findUploaderInfo(component);
                this._uploadFiles(uploaderInfo, files);
                setTimeout(function() {
                    if (!_this2._findAndUpdateAvailableUploaderInfo()) {
                        _this2._createInternalFileUploader()
                    }
                })
            };
            _proto._onFileUploaderProgress = function(_ref2) {
                var component = _ref2.component,
                    file = _ref2.file,
                    bytesLoaded = _ref2.bytesLoaded,
                    bytesTotal = _ref2.bytesTotal;
                var _this$_findSessionByF3 = this._findSessionByFile(component, file),
                    session = _this$_findSessionByF3.session,
                    fileIndex = _this$_findSessionByF3.fileIndex;
                var fileValue = 0 !== bytesTotal ? bytesLoaded / bytesTotal : 1;
                var commonValue = component.option("progress") / 100;
                var args = {
                    sessionId: session.id,
                    fileIndex: fileIndex,
                    commonValue: commonValue,
                    fileValue: fileValue
                };
                this._raiseUploadProgress(args)
            };
            _proto._onFileUploaderUploaded = function(_ref3) {
                var component = _ref3.component,
                    file = _ref3.file;
                var deferred = this._getDeferredForFile(component, file);
                deferred.resolve()
            };
            _proto._onFileUploaderUploadAborted = function(_ref4) {
                var component = _ref4.component,
                    file = _ref4.file;
                var deferred = this._getDeferredForFile(component, file);
                deferred.resolve({
                    canceled: true
                })
            };
            _proto._onFileUploaderUploadError = function(_ref5) {
                var component = _ref5.component,
                    file = _ref5.file,
                    error = _ref5.error;
                var deferred = this._getDeferredForFile(component, file);
                deferred.reject(error)
            };
            _proto._createDropZonePlaceholder = function() {
                this._$dropZonePlaceholder = (0, _renderer.default)("<div>").addClass(FILE_MANAGER_FILE_UPLOADER_DROPZONE_PLACEHOLER_CLASS).appendTo(this.option("dropZonePlaceholderContainer"))
            };
            _proto._adjustDropZonePlaceholder = function() {
                if (!(0, _window.hasWindow)()) {
                    return
                }
                var $dropZoneTarget = this.option("dropZone");
                var placeholderBorderTopWidth = parseFloat(this._$dropZonePlaceholder.css("borderTopWidth"));
                var placeholderBorderLeftWidth = parseFloat(this._$dropZonePlaceholder.css("borderLeftWidth"));
                var $placeholderContainer = this.option("dropZonePlaceholderContainer");
                var containerBorderBottomWidth = parseFloat($placeholderContainer.css("borderBottomWidth"));
                var containerBorderLeftWidth = parseFloat($placeholderContainer.css("borderLeftWidth"));
                var containerHeight = $placeholderContainer.innerHeight();
                var containerOffset = $placeholderContainer.offset();
                var dropZoneOffset = $dropZoneTarget.offset();
                this._$dropZonePlaceholder.css({
                    top: dropZoneOffset.top - containerOffset.top - containerHeight - containerBorderBottomWidth,
                    left: dropZoneOffset.left - containerOffset.left - containerBorderLeftWidth
                });
                this._$dropZonePlaceholder.height($dropZoneTarget.get(0).offsetHeight - 2 * placeholderBorderTopWidth);
                this._$dropZonePlaceholder.width($dropZoneTarget.get(0).offsetWidth - 2 * placeholderBorderLeftWidth)
            };
            _proto._setDropZonePlaceholderVisible = function(visible) {
                if (visible) {
                    this._adjustDropZonePlaceholder();
                    this._$dropZonePlaceholder.css("display", "")
                } else {
                    this._$dropZonePlaceholder.css("display", "none")
                }
            };
            _proto._uploadFiles = function(uploaderInfo, files) {
                this._setDropZonePlaceholderVisible(false);
                var sessionId = (new _guid.default).toString();
                var controller = this._getController();
                var deferreds = files.map(function() {
                    return new _deferred.Deferred
                });
                var session = {
                    id: sessionId,
                    controller: controller,
                    files: files,
                    deferreds: deferreds
                };
                uploaderInfo.session = session;
                var sessionInfo = {
                    sessionId: sessionId,
                    deferreds: deferreds,
                    files: files
                };
                this._raiseUploadSessionStarted(sessionInfo);
                return (0, _uiFile_manager.whenSome)(deferreds).always(function() {
                    return setTimeout(function() {
                        uploaderInfo.fileUploader.reset();
                        uploaderInfo.session = null
                    })
                })
            };
            _proto._getDeferredForFile = function(fileUploader, file) {
                var _this$_findSessionByF4 = this._findSessionByFile(fileUploader, file),
                    session = _this$_findSessionByF4.session,
                    fileIndex = _this$_findSessionByF4.fileIndex;
                return session.deferreds[fileIndex]
            };
            _proto._findSessionByFile = function(fileUploader, file) {
                var uploaderInfo = this._findUploaderInfo(fileUploader);
                var session = uploaderInfo.session;
                var fileIndex = session.files.indexOf(file);
                return {
                    session: session,
                    fileIndex: fileIndex
                }
            };
            _proto._findUploaderInfoBySessionId = function(sessionId) {
                for (var i = 0; i < this._uploaderInfos.length; i++) {
                    var uploaderInfo = this._uploaderInfos[i];
                    var session = uploaderInfo.session;
                    if (session && session.id === sessionId) {
                        return uploaderInfo
                    }
                }
                return null
            };
            _proto._findAndUpdateAvailableUploaderInfo = function() {
                var _info;
                var info = null;
                for (var i = 0; i < this._uploaderInfos.length; i++) {
                    var currentInfo = this._uploaderInfos[i];
                    currentInfo.fileUploader.option("dropZone", "");
                    if (!info && !currentInfo.session) {
                        info = currentInfo
                    }
                }
                null === (_info = info) || void 0 === _info ? void 0 : _info.fileUploader.option("dropZone", this.option("dropZone"));
                return info
            };
            _proto._findUploaderInfo = function(fileUploader) {
                for (var i = 0; i < this._uploaderInfos.length; i++) {
                    var info = this._uploaderInfos[i];
                    if (info.fileUploader === fileUploader) {
                        return info
                    }
                }
                return null
            };
            _proto._getController = function() {
                var controllerGetter = this.option("getController");
                return controllerGetter()
            };
            _proto._raiseUploadSessionStarted = function(sessionInfo) {
                this._actions.onUploadSessionStarted({
                    sessionInfo: sessionInfo
                })
            };
            _proto._raiseUploadProgress = function(args) {
                this._actions.onUploadProgress(args)
            };
            _proto._initActions = function() {
                this._actions = {
                    onUploadSessionStarted: this._createActionByOption("onUploadSessionStarted"),
                    onUploadProgress: this._createActionByOption("onUploadProgress")
                }
            };
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_Widget.prototype._getDefaultOptions.call(this), {
                    getController: null,
                    onUploadSessionStarted: null,
                    onUploadProgress: null
                })
            };
            _proto._optionChanged = function(args) {
                var name = args.name;
                switch (name) {
                    case "getController":
                        this.repaint();
                        break;
                    case "onUploadSessionStarted":
                    case "onUploadProgress":
                        this._actions[name] = this._createActionByOption(name);
                        break;
                    case "dropZone":
                        this._findAndUpdateAvailableUploaderInfo();
                        this._adjustDropZonePlaceholder();
                        break;
                    case "dropZonePlaceholderContainer":
                        this._$dropZonePlaceholder.detach();
                        this._$dropZonePlaceholder.appendTo(args.value);
                        break;
                    default:
                        _Widget.prototype._optionChanged.call(this, args)
                }
            };
            return FileManagerFileUploader
        }(_ui.default);
        var _default = FileManagerFileUploader;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/file_manager/ui.file_manager.messages.js ***!
      \******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        Object.defineProperty(exports, "ErrorCode", {
            enumerable: true,
            get: function() {
                return _errors.default
            }
        });
        exports.FileManagerMessages = void 0;
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _errors = _interopRequireDefault(__webpack_require__( /*! ../../file_management/errors */ 266));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var FileManagerMessages = {
            get: function(errorId, args) {
                switch (errorId) {
                    case _errors.default.NoAccess:
                        return _message.default.format("dxFileManager-errorNoAccess");
                    case _errors.default.FileExists:
                        return _message.default.format("dxFileManager-errorFileExistsFormat", args);
                    case _errors.default.FileNotFound:
                        return _message.default.format("dxFileManager-errorFileNotFoundFormat", args);
                    case _errors.default.DirectoryExists:
                        return _message.default.format("dxFileManager-errorDirectoryExistsFormat", args);
                    case _errors.default.DirectoryNotFound:
                        return _message.default.format("dxFileManager-errorDirectoryNotFoundFormat", args);
                    case _errors.default.WrongFileExtension:
                        return _message.default.format("dxFileManager-errorWrongFileExtension");
                    case _errors.default.MaxFileSizeExceeded:
                        return _message.default.format("dxFileManager-errorMaxFileSizeExceeded");
                    case _errors.default.InvalidSymbols:
                        return _message.default.format("dxFileManager-errorInvalidSymbols")
                }
                return _message.default.format("dxFileManager-errorDefault")
            }
        };
        exports.FileManagerMessages = FileManagerMessages
    },
    /*!*********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/file_manager/ui.file_manager.breadcrumbs.js ***!
      \*********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _ui2 = _interopRequireDefault(__webpack_require__( /*! ../menu/ui.menu */ 406));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var FILE_MANAGER_BREADCRUMBS_CLASS = "dx-filemanager-breadcrumbs";
        var FILE_MANAGER_BREADCRUMBS_PARENT_FOLDER_ITEM_CLASS = FILE_MANAGER_BREADCRUMBS_CLASS + "-parent-folder-item";
        var FILE_MANAGER_BREADCRUMBS_SEPARATOR_ITEM_CLASS = FILE_MANAGER_BREADCRUMBS_CLASS + "-separator-item";
        var FILE_MANAGER_BREADCRUMBS_PATH_SEPARATOR_ITEM_CLASS = FILE_MANAGER_BREADCRUMBS_CLASS + "-path-separator-item";
        var FileManagerBreadcrumbs = function(_Widget) {
            _inheritsLoose(FileManagerBreadcrumbs, _Widget);

            function FileManagerBreadcrumbs() {
                return _Widget.apply(this, arguments) || this
            }
            var _proto = FileManagerBreadcrumbs.prototype;
            _proto._init = function() {
                _Widget.prototype._init.call(this);
                this._currentDirectory = null
            };
            _proto._initMarkup = function() {
                _Widget.prototype._initMarkup.call(this);
                this._initActions();
                if (this._currentDirectory) {
                    this._renderMenu()
                }
                this.$element().addClass(FILE_MANAGER_BREADCRUMBS_CLASS)
            };
            _proto.setCurrentDirectory = function(directory) {
                if (!this._areDirsEqual(this._currentDirectory, directory)) {
                    this._currentDirectory = directory;
                    this.repaint()
                }
            };
            _proto._renderMenu = function() {
                var $menu = (0, _renderer.default)("<div>").appendTo(this.$element());
                this._menu = this._createComponent($menu, _ui2.default, {
                    dataSource: this._getMenuItems(),
                    onItemClick: this._onItemClick.bind(this),
                    onItemRendered: this._onItemRendered.bind(this)
                })
            };
            _proto._getMenuItems = function() {
                var dirLine = this._getParentDirsLine();
                var result = [{
                    icon: "arrowup",
                    directory: this._currentDirectory.parentDirectory,
                    isPathItem: true,
                    cssClass: FILE_MANAGER_BREADCRUMBS_PARENT_FOLDER_ITEM_CLASS
                }, {
                    text: "\xa0",
                    cssClass: FILE_MANAGER_BREADCRUMBS_SEPARATOR_ITEM_CLASS
                }];
                dirLine.forEach(function(dir, index) {
                    result.push({
                        text: dir.getDisplayName(),
                        directory: dir,
                        isPathItem: true
                    });
                    if (index !== dirLine.length - 1) {
                        result.push({
                            icon: "spinnext",
                            cssClass: FILE_MANAGER_BREADCRUMBS_PATH_SEPARATOR_ITEM_CLASS
                        })
                    }
                });
                return result
            };
            _proto._onItemClick = function(_ref) {
                var itemData = _ref.itemData;
                if (!itemData.isPathItem) {
                    return
                }
                var newDir = itemData.directory;
                if (!this._areDirsEqual(newDir, this._currentDirectory)) {
                    this._raiseCurrentDirectoryChanged(newDir)
                }
            };
            _proto._onItemRendered = function(_ref2) {
                var itemElement = _ref2.itemElement,
                    itemData = _ref2.itemData;
                if (itemData.cssClass) {
                    (0, _renderer.default)(itemElement).addClass(itemData.cssClass)
                }
            };
            _proto._getParentDirsLine = function() {
                var currentDirectory = this._currentDirectory;
                var result = [];
                while (currentDirectory) {
                    result.unshift(currentDirectory);
                    currentDirectory = currentDirectory.parentDirectory
                }
                return result
            };
            _proto._areDirsEqual = function(dir1, dir2) {
                return dir1 && dir2 && dir1 === dir2 && dir1.fileItem.key === dir2.fileItem.key
            };
            _proto._initActions = function() {
                this._actions = {
                    onCurrentDirectoryChanging: this._createActionByOption("onCurrentDirectoryChanging")
                }
            };
            _proto._raiseCurrentDirectoryChanged = function(currentDirectory) {
                this._actions.onCurrentDirectoryChanging({
                    currentDirectory: currentDirectory
                })
            };
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_Widget.prototype._getDefaultOptions.call(this), {
                    rootFolderDisplayName: "Files",
                    onCurrentDirectoryChanging: null
                })
            };
            _proto._optionChanged = function(args) {
                var name = args.name;
                switch (name) {
                    case "rootFolderDisplayName":
                        this.repaint();
                        break;
                    case "onCurrentDirectoryChanging":
                        this._actions[name] = this._createActionByOption(name);
                        break;
                    default:
                        _Widget.prototype._optionChanged.call(this, args)
                }
            };
            return FileManagerBreadcrumbs
        }(_ui.default);
        var _default = FileManagerBreadcrumbs;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/file_manager/ui.file_manager.adaptivity.js ***!
      \********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _ui2 = _interopRequireDefault(__webpack_require__( /*! ../drawer/ui.drawer */ 278));
        var _splitter = _interopRequireDefault(__webpack_require__( /*! ../splitter */ 455));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var window = (0, _window.getWindow)();
        var ADAPTIVE_STATE_SCREEN_WIDTH = 573;
        var FILE_MANAGER_ADAPTIVITY_DRAWER_PANEL_CLASS = "dx-filemanager-adaptivity-drawer-panel";
        var DRAWER_PANEL_CONTENT_INITIAL = "dx-drawer-panel-content-initial";
        var DRAWER_PANEL_CONTENT_ADAPTIVE = "dx-drawer-panel-content-adaptive";
        var FileManagerAdaptivityControl = function(_Widget) {
            _inheritsLoose(FileManagerAdaptivityControl, _Widget);

            function FileManagerAdaptivityControl() {
                return _Widget.apply(this, arguments) || this
            }
            var _proto = FileManagerAdaptivityControl.prototype;
            _proto._initMarkup = function() {
                _Widget.prototype._initMarkup.call(this);
                this._initActions();
                this._isInAdaptiveState = false;
                var $drawer = (0, _renderer.default)("<div>").appendTo(this.$element());
                (0, _renderer.default)("<div>").addClass(FILE_MANAGER_ADAPTIVITY_DRAWER_PANEL_CLASS).appendTo($drawer);
                this._drawer = this._createComponent($drawer, _ui2.default);
                this._drawer.option({
                    opened: true,
                    template: this._createDrawerTemplate.bind(this)
                });
                (0, _renderer.default)(this._drawer.content()).addClass(DRAWER_PANEL_CONTENT_INITIAL);
                var $drawerContent = $drawer.find(".".concat(FILE_MANAGER_ADAPTIVITY_DRAWER_PANEL_CLASS)).first();
                var contentRenderer = this.option("contentTemplate");
                if ((0, _type.isFunction)(contentRenderer)) {
                    contentRenderer($drawerContent)
                }
                this._updateDrawerMaxSize()
            };
            _proto._createDrawerTemplate = function(container) {
                this.option("drawerTemplate")(container);
                this._splitter = this._createComponent("<div>", _splitter.default, {
                    container: this.$element(),
                    leftElement: (0, _renderer.default)(this._drawer.content()),
                    rightElement: (0, _renderer.default)(this._drawer.viewContent()),
                    onApplyPanelSize: this._onApplyPanelSize.bind(this),
                    onActiveStateChanged: this._onActiveStateChanged.bind(this)
                });
                this._splitter.$element().appendTo(container);
                this._splitter.disableSplitterCalculation(true)
            };
            _proto._render = function() {
                _Widget.prototype._render.call(this);
                this._checkAdaptiveState()
            };
            _proto._onApplyPanelSize = function(e) {
                if (!(0, _window.hasWindow)()) {
                    return
                }
                if (!this._splitter.isSplitterMoved()) {
                    this._setDrawerWidth("");
                    return
                }(0, _renderer.default)(this._drawer.content()).removeClass(DRAWER_PANEL_CONTENT_INITIAL);
                this._setDrawerWidth(e.leftPanelWidth)
            };
            _proto._onActiveStateChanged = function(_ref) {
                var isActive = _ref.isActive;
                this._splitter.disableSplitterCalculation(!isActive);
                !isActive && this._splitter.$element().css("left", "auto")
            };
            _proto._setDrawerWidth = function(width) {
                (0, _renderer.default)(this._drawer.content()).css("width", width);
                this._updateDrawerMaxSize();
                this._drawer.resizeViewContent()
            };
            _proto._updateDrawerMaxSize = function() {
                this._drawer.option("maxSize", this._drawer.getRealPanelWidth())
            };
            _proto._dimensionChanged = function(dimension) {
                if (!dimension || "height" !== dimension) {
                    this._checkAdaptiveState()
                }
            };
            _proto._checkAdaptiveState = function() {
                var oldState = this._isInAdaptiveState;
                this._isInAdaptiveState = this._isSmallScreen();
                if (oldState !== this._isInAdaptiveState) {
                    this.toggleDrawer(!this._isInAdaptiveState, true);
                    (0, _renderer.default)(this._drawer.content()).toggleClass(DRAWER_PANEL_CONTENT_ADAPTIVE, this._isInAdaptiveState);
                    this._raiseAdaptiveStateChanged(this._isInAdaptiveState)
                }
                if (this._isInAdaptiveState && this._isDrawerOpened()) {
                    this._updateDrawerMaxSize()
                }
            };
            _proto._isSmallScreen = function() {
                return (0, _renderer.default)(window).width() <= ADAPTIVE_STATE_SCREEN_WIDTH
            };
            _proto._isDrawerOpened = function() {
                return this._drawer.option("opened")
            };
            _proto._initActions = function() {
                this._actions = {
                    onAdaptiveStateChanged: this._createActionByOption("onAdaptiveStateChanged")
                }
            };
            _proto._raiseAdaptiveStateChanged = function(enabled) {
                this._actions.onAdaptiveStateChanged({
                    enabled: enabled
                })
            };
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_Widget.prototype._getDefaultOptions.call(this), {
                    drawerTemplate: null,
                    contentTemplate: null,
                    onAdaptiveStateChanged: null
                })
            };
            _proto._optionChanged = function(args) {
                var name = args.name;
                switch (name) {
                    case "drawerTemplate":
                    case "contentTemplate":
                        this.repaint();
                        break;
                    case "onAdaptiveStateChanged":
                        this._actions[name] = this._createActionByOption(name);
                        break;
                    default:
                        _Widget.prototype._optionChanged.call(this, args)
                }
            };
            _proto.isInAdaptiveState = function() {
                return this._isInAdaptiveState
            };
            _proto.toggleDrawer = function(showing, skipAnimation) {
                this._updateDrawerMaxSize();
                this._drawer.option("animationEnabled", !skipAnimation);
                this._drawer.toggle(showing);
                var isSplitterActive = this._isDrawerOpened() && !this.isInAdaptiveState();
                this._splitter.toggleDisabled(!isSplitterActive)
            };
            return FileManagerAdaptivityControl
        }(_ui.default);
        var _default = FileManagerAdaptivityControl;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/diagram.js ***!
      \************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./diagram/ui.diagram */ 877));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _ui.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/diagram/ui.diagram.js ***!
      \***********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _load_indicator = _interopRequireDefault(__webpack_require__( /*! ../load_indicator */ 83));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _data = __webpack_require__( /*! ../../core/utils/data */ 20);
        var _position = _interopRequireDefault(__webpack_require__( /*! ../../animation/position */ 81));
        var _resize_callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/resize_callbacks */ 125));
        var _diagram = __webpack_require__( /*! ./diagram.importer */ 98);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _element = __webpack_require__( /*! ../../core/element */ 18);
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _number = _interopRequireDefault(__webpack_require__( /*! ../../localization/number */ 47));
        var zIndexPool = _interopRequireWildcard(__webpack_require__( /*! ../overlay/z_index */ 329));
        var _ui2 = _interopRequireDefault(__webpack_require__( /*! ../overlay/ui.overlay */ 328));
        var _uiDiagram = _interopRequireDefault(__webpack_require__( /*! ./ui.diagram.toolbar */ 186));
        var _uiDiagram2 = _interopRequireDefault(__webpack_require__( /*! ./ui.diagram.main_toolbar */ 879));
        var _uiDiagram3 = _interopRequireDefault(__webpack_require__( /*! ./ui.diagram.history_toolbar */ 880));
        var _uiDiagram4 = _interopRequireDefault(__webpack_require__( /*! ./ui.diagram.view_toolbar */ 881));
        var _uiDiagram5 = _interopRequireDefault(__webpack_require__( /*! ./ui.diagram.properties_toolbar */ 882));
        var _uiDiagram6 = _interopRequireDefault(__webpack_require__( /*! ./ui.diagram.context_menu */ 883));
        var _uiDiagram7 = _interopRequireDefault(__webpack_require__( /*! ./ui.diagram.context_toolbox */ 884));
        var _uiDiagram8 = _interopRequireDefault(__webpack_require__( /*! ./ui.diagram.dialogs */ 885));
        var _uiDiagram9 = _interopRequireDefault(__webpack_require__( /*! ./ui.diagram.scroll_view */ 886));
        var _diagram2 = _interopRequireDefault(__webpack_require__( /*! ./diagram.toolbox_manager */ 887));
        var _uiDiagram10 = _interopRequireDefault(__webpack_require__( /*! ./ui.diagram.toolbox */ 888));
        var _uiDiagram11 = _interopRequireDefault(__webpack_require__( /*! ./ui.diagram.properties_panel */ 889));
        var _diagram3 = _interopRequireDefault(__webpack_require__( /*! ./diagram.options_update */ 890));
        var _uiDiagram12 = _interopRequireDefault(__webpack_require__( /*! ./ui.diagram.dialog_manager */ 891));
        var _diagram4 = _interopRequireDefault(__webpack_require__( /*! ./diagram.commands_manager */ 142));
        var _diagram5 = _interopRequireDefault(__webpack_require__( /*! ./diagram.nodes_option */ 892));
        var _diagram6 = _interopRequireDefault(__webpack_require__( /*! ./diagram.edges_option */ 893));

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var DIAGRAM_CLASS = "dx-diagram";
        var DIAGRAM_FULLSCREEN_CLASS = "dx-diagram-fullscreen";
        var DIAGRAM_TOOLBAR_WRAPPER_CLASS = DIAGRAM_CLASS + "-toolbar-wrapper";
        var DIAGRAM_CONTENT_WRAPPER_CLASS = DIAGRAM_CLASS + "-content-wrapper";
        var DIAGRAM_CONTENT_CLASS = DIAGRAM_CLASS + "-content";
        var DIAGRAM_SCROLL_VIEW_CLASS = DIAGRAM_CLASS + "-scroll-view";
        var DIAGRAM_FLOATING_TOOLBAR_CONTAINER_CLASS = DIAGRAM_CLASS + "-floating-toolbar-container";
        var DIAGRAM_PROPERTIES_PANEL_TOOLBAR_CONTAINER_CLASS = DIAGRAM_CLASS + "-properties-panel-toolbar-container";
        var DIAGRAM_LOADING_INDICATOR_CLASS = DIAGRAM_CLASS + "-loading-indicator";
        var DIAGRAM_FLOATING_PANEL_OFFSET = 12;
        var DIAGRAM_DEFAULT_UNIT = "in";
        var DIAGRAM_DEFAULT_ZOOMLEVEL = 1;
        var DIAGRAM_DEFAULT_AUTOZOOM_MODE = "disabled";
        var DIAGRAM_DEFAULT_PAGE_ORIENTATION = "portrait";
        var DIAGRAM_DEFAULT_PAGE_COLOR = "#ffffff";
        var DIAGRAM_MAX_MOBILE_WINDOW_WIDTH = 576;
        var DIAGRAM_TOOLBOX_SHAPE_SPACING = 12;
        var DIAGRAM_TOOLBOX_SHAPES_PER_ROW = 3;
        var DIAGRAM_CONTEXT_TOOLBOX_SHAPE_SPACING = 12;
        var DIAGRAM_CONTEXT_TOOLBOX_SHAPES_PER_ROW = 4;
        var DIAGRAM_CONTEXT_TOOLBOX_DEFAULT_WIDTH = 152;
        var DIAGRAM_NAMESPACE = "dxDiagramEvent";
        var FULLSCREEN_CHANGE_EVENT_NAME = (0, _index.addNamespace)("fullscreenchange", DIAGRAM_NAMESPACE);
        var IE_FULLSCREEN_CHANGE_EVENT_NAME = (0, _index.addNamespace)("msfullscreenchange", DIAGRAM_NAMESPACE);
        var WEBKIT_FULLSCREEN_CHANGE_EVENT_NAME = (0, _index.addNamespace)("webkitfullscreenchange", DIAGRAM_NAMESPACE);
        var MOZ_FULLSCREEN_CHANGE_EVENT_NAME = (0, _index.addNamespace)("mozfullscreenchange", DIAGRAM_NAMESPACE);
        var Diagram = function(_Widget) {
            _inheritsLoose(Diagram, _Widget);

            function Diagram() {
                return _Widget.apply(this, arguments) || this
            }
            var _proto = Diagram.prototype;
            _proto._init = function() {
                this._updateDiagramLockCount = 0;
                this.toggleFullscreenLock = 0;
                this._browserResizeTimer = -1;
                this._toolbars = [];
                _Widget.prototype._init.call(this);
                this._initDiagram();
                this._createCustomCommand()
            };
            _proto._initMarkup = function() {
                var _this = this;
                _Widget.prototype._initMarkup.call(this);
                this._toolbars = [];
                delete this._isMobileScreenSize;
                var isServerSide = !(0, _window.hasWindow)();
                this.$element().addClass(DIAGRAM_CLASS);
                delete this._mainToolbar;
                if (this.option("mainToolbar.visible")) {
                    this._renderMainToolbar()
                }
                var $contentWrapper = (0, _renderer.default)("<div>").addClass(DIAGRAM_CONTENT_WRAPPER_CLASS).appendTo(this.$element());
                delete this._historyToolbar;
                delete this._historyToolbarResizeCallback;
                if (this._isHistoryToolbarVisible()) {
                    this._renderHistoryToolbar($contentWrapper)
                }
                delete this._propertiesToolbar;
                delete this._propertiesToolbarResizeCallback;
                if (this._isPropertiesPanelEnabled()) {
                    this._renderPropertiesToolbar($contentWrapper)
                }
                delete this._viewToolbar;
                delete this._viewToolbarResizeCallback;
                if (this.option("viewToolbar.visible")) {
                    this._renderViewToolbar($contentWrapper)
                }
                delete this._toolbox;
                delete this._toolboxResizeCallback;
                if (this._isToolboxEnabled()) {
                    this._renderToolbox($contentWrapper)
                }
                delete this._propertiesPanel;
                delete this._propertiesPanelResizeCallback;
                if (this._isPropertiesPanelEnabled()) {
                    this._renderPropertiesPanel($contentWrapper)
                }
                this._$content = (0, _renderer.default)("<div>").addClass(DIAGRAM_CONTENT_CLASS).appendTo($contentWrapper);
                delete this._contextMenu;
                if (this.option("contextMenu.enabled")) {
                    this._renderContextMenu($contentWrapper)
                }
                delete this._contextToolbox;
                if (this.option("contextToolbox.enabled")) {
                    this._renderContextToolbox($contentWrapper)
                }
                this._renderDialog($contentWrapper);
                if (!isServerSide) {
                    var $scrollViewWrapper = (0, _renderer.default)("<div>").addClass(DIAGRAM_SCROLL_VIEW_CLASS).appendTo(this._$content);
                    this._createComponent($scrollViewWrapper, _uiDiagram9.default, {
                        onCreateDiagram: function(e) {
                            _this._diagramInstance.createDocument(e.$parent[0], e.scrollView)
                        }
                    })
                }
                if ((0, _window.hasWindow)()) {
                    _resize_callbacks.default.add(function() {
                        _this._killBrowserResizeTimer();
                        _this._browserResizeTimer = setTimeout(function() {
                            return _this._processBrowserResize()
                        }, 100)
                    })
                }
                this._setCustomCommandChecked(_diagram4.default.SHOW_PROPERTIES_PANEL_COMMAND_NAME, this._isPropertiesPanelVisible());
                this._setCustomCommandChecked(_diagram4.default.SHOW_TOOLBOX_COMMAND_NAME, this._isToolboxVisible())
            };
            _proto._processBrowserResize = function() {
                this._isMobileScreenSize = void 0;
                this._processDiagramResize();
                this._killBrowserResizeTimer()
            };
            _proto._processDiagramResize = function() {
                if (this._historyToolbarResizeCallback) {
                    this._historyToolbarResizeCallback.call(this)
                }
                if (this._propertiesToolbarResizeCallback) {
                    this._propertiesToolbarResizeCallback.call(this)
                }
                if (this._propertiesPanelResizeCallback) {
                    this._propertiesPanelResizeCallback.call(this)
                }
                if (this._viewToolbarResizeCallback) {
                    this._viewToolbarResizeCallback.call(this)
                }
                if (this._toolboxResizeCallback) {
                    this._toolboxResizeCallback.call(this)
                }
            };
            _proto._killBrowserResizeTimer = function() {
                if (this._browserResizeTimer > -1) {
                    clearTimeout(this._browserResizeTimer)
                }
                this._browserResizeTimer = -1
            };
            _proto.isMobileScreenSize = function() {
                if (void 0 === this._isMobileScreenSize) {
                    this._isMobileScreenSize = (0, _window.hasWindow)() && this.$element().outerWidth() < DIAGRAM_MAX_MOBILE_WINDOW_WIDTH
                }
                return this._isMobileScreenSize
            };
            _proto._captureFocus = function() {
                if (this._diagramInstance) {
                    this._diagramInstance.captureFocus()
                }
            };
            _proto._captureFocusOnTimeout = function() {
                var _this2 = this;
                this._captureFocusTimeout = setTimeout(function() {
                    _this2._captureFocus();
                    delete _this2._captureFocusTimeout
                }, 100)
            };
            _proto._killCaptureFocusTimeout = function() {
                if (this._captureFocusTimeout) {
                    clearTimeout(this._captureFocusTimeout);
                    delete this._captureFocusTimeout
                }
            };
            _proto.notifyBarCommandExecuted = function() {
                this._captureFocusOnTimeout()
            };
            _proto._registerToolbar = function(component) {
                this._registerBar(component);
                this._toolbars.push(component)
            };
            _proto._registerBar = function(component) {
                component.bar.onChanged.add(this);
                this._diagramInstance.registerBar(component.bar)
            };
            _proto._getExcludeCommands = function() {
                var excludeCommands = [];
                if (!this._isToolboxEnabled()) {
                    excludeCommands.push(_diagram4.default.SHOW_TOOLBOX_COMMAND_NAME)
                }
                if (!this._isPropertiesPanelEnabled()) {
                    excludeCommands.push(_diagram4.default.SHOW_PROPERTIES_PANEL_COMMAND_NAME)
                }
                return excludeCommands
            };
            _proto._getToolbarBaseOptions = function() {
                var _this3 = this;
                return {
                    onContentReady: function(_ref) {
                        var component = _ref.component;
                        return _this3._registerToolbar(component)
                    },
                    onSubMenuVisibilityChanging: function(_ref2) {
                        var component = _ref2.component;
                        return _this3._diagramInstance.updateBarItemsState(component.bar)
                    },
                    onPointerUp: this._onPanelPointerUp.bind(this),
                    "export": this.option("export"),
                    container: this.$element(),
                    excludeCommands: this._getExcludeCommands(),
                    onInternalCommand: this._onInternalCommand.bind(this),
                    onCustomCommand: this._onCustomCommand.bind(this),
                    isMobileView: this.isMobileScreenSize()
                }
            };
            _proto._onInternalCommand = function(e) {
                switch (e.command) {
                    case _diagram4.default.SHOW_TOOLBOX_COMMAND_NAME:
                        if (this._toolbox) {
                            this._toolbox.toggle()
                        }
                        break;
                    case _diagram4.default.SHOW_PROPERTIES_PANEL_COMMAND_NAME:
                        if (this._propertiesPanel) {
                            this._propertiesPanel.toggle()
                        }
                }
            };
            _proto._onCustomCommand = function(e) {
                this._customCommandAction({
                    name: e.name
                })
            };
            _proto._renderMainToolbar = function() {
                var $toolbarWrapper = (0, _renderer.default)("<div>").addClass(DIAGRAM_TOOLBAR_WRAPPER_CLASS).appendTo(this.$element());
                this._mainToolbar = this._createComponent($toolbarWrapper, _uiDiagram2.default, (0, _extend.extend)(this._getToolbarBaseOptions(), {
                    commands: this.option("mainToolbar.commands"),
                    skipAdjustSize: true
                }))
            };
            _proto._isHistoryToolbarVisible = function() {
                return this.option("historyToolbar.visible") && !this.isReadOnlyMode()
            };
            _proto._renderHistoryToolbar = function($parent) {
                var _this4 = this;
                var isServerSide = !(0, _window.hasWindow)();
                var $container = (0, _renderer.default)("<div>").addClass(DIAGRAM_FLOATING_TOOLBAR_CONTAINER_CLASS).appendTo($parent);
                this._historyToolbar = this._createComponent($container, _uiDiagram3.default, (0, _extend.extend)(this._getToolbarBaseOptions(), {
                    commands: this.option("historyToolbar.commands"),
                    locateInMenu: "never"
                }));
                this._updateHistoryToolbarPosition($container, $parent, isServerSide);
                this._historyToolbarResizeCallback = function() {
                    _this4._historyToolbar.option("isMobileView", _this4.isMobileScreenSize())
                }
            };
            _proto._updateHistoryToolbarPosition = function($container, $parent, isServerSide) {
                if (isServerSide) {
                    return
                }
                _position.default.setup($container, {
                    my: "left top",
                    at: "left top",
                    of: $parent,
                    offset: DIAGRAM_FLOATING_PANEL_OFFSET + " " + DIAGRAM_FLOATING_PANEL_OFFSET
                })
            };
            _proto._isToolboxEnabled = function() {
                return "disabled" !== this.option("toolbox.visibility") && !this.isReadOnlyMode()
            };
            _proto._isToolboxVisible = function() {
                return "visible" === this.option("toolbox.visibility") || "auto" === this.option("toolbox.visibility") && !this.isMobileScreenSize()
            };
            _proto._renderToolbox = function($parent) {
                var _this5 = this;
                var isServerSide = !(0, _window.hasWindow)();
                var $toolBox = (0, _renderer.default)("<div>").appendTo($parent);
                var bounds = this._getToolboxBounds($parent, isServerSide);
                this._toolbox = this._createComponent($toolBox, _uiDiagram10.default, {
                    isMobileView: this.isMobileScreenSize(),
                    isVisible: this._isToolboxVisible(),
                    container: this.$element(),
                    height: bounds.height,
                    offsetParent: $parent,
                    offsetX: bounds.offsetX,
                    offsetY: bounds.offsetY,
                    showSearch: this.option("toolbox.showSearch"),
                    toolboxGroups: this._getToolboxGroups(),
                    toolboxWidth: this.option("toolbox.width"),
                    onShapeCategoryRendered: function(e) {
                        if (isServerSide) {
                            return
                        }
                        _this5._diagramInstance.createToolbox(e.$element[0], "texts" === e.displayMode, e.shapes || e.category, {
                            shapeIconSpacing: DIAGRAM_TOOLBOX_SHAPE_SPACING,
                            shapeIconCountInRow: _this5.option("toolbox.shapeIconsPerRow"),
                            shapeIconAttributes: {
                                "data-toggle": e.dataToggle
                            }
                        })
                    },
                    onFilterChanged: function(e) {
                        if (isServerSide) {
                            return
                        }
                        _this5._diagramInstance.applyToolboxFilter(e.text, e.filteringToolboxes)
                    },
                    onVisibilityChanging: function(e) {
                        if (isServerSide) {
                            return
                        }
                        _this5._setCustomCommandChecked(_diagram4.default.SHOW_TOOLBOX_COMMAND_NAME, e.visible);
                        if (_this5._propertiesPanel) {
                            if (e.visible && _this5.isMobileScreenSize()) {
                                _this5._propertiesPanel.hide()
                            }
                        }
                        if (_this5._historyToolbar) {
                            if (e.visible && _this5.isMobileScreenSize()) {
                                _this5._historyToolbarZIndex = zIndexPool.create(_ui2.default.baseZIndex());
                                _this5._historyToolbar.$element().css("zIndex", _this5._historyToolbarZIndex);
                                _this5._historyToolbar.$element().css("boxShadow", "none")
                            }
                        }
                        if (_this5._viewToolbar) {
                            _this5._viewToolbar.$element().css("opacity", e.visible && _this5.isMobileScreenSize() ? "0" : "1");
                            _this5._viewToolbar.$element().css("pointerEvents", e.visible && _this5.isMobileScreenSize() ? "none" : "")
                        }
                    },
                    onVisibilityChanged: function(e) {
                        if (!e.visible && !_this5._textInputStarted) {
                            _this5._captureFocus()
                        }
                        if (!isServerSide) {
                            if (_this5._historyToolbar) {
                                if (!e.visible && _this5.isMobileScreenSize() && _this5._historyToolbarZIndex) {
                                    zIndexPool.remove(_this5._historyToolbarZIndex);
                                    _this5._historyToolbar.$element().css("zIndex", "");
                                    _this5._historyToolbar.$element().css("boxShadow", "");
                                    _this5._historyToolbarZIndex = void 0
                                }
                            }
                        }
                    },
                    onPointerUp: this._onPanelPointerUp.bind(this)
                });
                this._toolboxResizeCallback = function() {
                    var bounds = _this5._getToolboxBounds($parent, isServerSide);
                    _this5._toolbox.option("height", bounds.height);
                    var prevIsMobileView = _this5._toolbox.option("isMobileView");
                    if (prevIsMobileView !== _this5.isMobileScreenSize()) {
                        _this5._toolbox.option({
                            isMobileView: _this5.isMobileScreenSize(),
                            isVisible: _this5._isToolboxVisible()
                        });
                        _this5._setCustomCommandChecked(_diagram4.default.SHOW_TOOLBOX_COMMAND_NAME, _this5._isToolboxVisible())
                    }
                    _this5._toolbox.updateMaxHeight()
                }
            };
            _proto._getToolboxBounds = function($parent, isServerSide) {
                var result = {
                    offsetX: DIAGRAM_FLOATING_PANEL_OFFSET,
                    offsetY: DIAGRAM_FLOATING_PANEL_OFFSET,
                    height: !isServerSide ? $parent.height() - 2 * DIAGRAM_FLOATING_PANEL_OFFSET : 0
                };
                if (this._historyToolbar && !isServerSide) {
                    result.offsetY += this._historyToolbar.$element().outerHeight() + DIAGRAM_FLOATING_PANEL_OFFSET;
                    result.height -= this._historyToolbar.$element().outerHeight() + DIAGRAM_FLOATING_PANEL_OFFSET
                }
                if (this._viewToolbar && !isServerSide) {
                    result.height -= this._viewToolbar.$element().outerHeight() + this._getViewToolbarYOffset(isServerSide)
                }
                return result
            };
            _proto._renderViewToolbar = function($parent) {
                var _this6 = this;
                var isServerSide = !(0, _window.hasWindow)();
                var $container = (0, _renderer.default)("<div>").addClass(DIAGRAM_FLOATING_TOOLBAR_CONTAINER_CLASS).appendTo($parent);
                this._viewToolbar = this._createComponent($container, _uiDiagram4.default, (0, _extend.extend)(this._getToolbarBaseOptions(), {
                    commands: this.option("viewToolbar.commands"),
                    locateInMenu: "never"
                }));
                this._updateViewToolbarPosition($container, $parent, isServerSide);
                this._viewToolbarResizeCallback = function() {
                    _this6._updateViewToolbarPosition($container, $parent, isServerSide)
                }
            };
            _proto._getViewToolbarYOffset = function(isServerSide) {
                if (isServerSide) {
                    return
                }
                var result = DIAGRAM_FLOATING_PANEL_OFFSET;
                if (this._viewToolbar && this._propertiesToolbar) {
                    result += (this._propertiesToolbar.$element().outerHeight() - this._viewToolbar.$element().outerHeight()) / 2
                }
                return result
            };
            _proto._updateViewToolbarPosition = function($container, $parent, isServerSide) {
                if (isServerSide) {
                    return
                }
                _position.default.setup($container, {
                    my: "left bottom",
                    at: "left bottom",
                    of: $parent,
                    offset: DIAGRAM_FLOATING_PANEL_OFFSET + " -" + this._getViewToolbarYOffset(isServerSide)
                })
            };
            _proto._isPropertiesPanelEnabled = function() {
                return "disabled" !== this.option("propertiesPanel.visibility") && !this.isReadOnlyMode()
            };
            _proto._isPropertiesPanelVisible = function() {
                return "visible" === this.option("propertiesPanel.visibility")
            };
            _proto._renderPropertiesToolbar = function($parent) {
                var _this7 = this;
                var isServerSide = !(0, _window.hasWindow)();
                var $container = (0, _renderer.default)("<div>").addClass(DIAGRAM_FLOATING_TOOLBAR_CONTAINER_CLASS).addClass(DIAGRAM_PROPERTIES_PANEL_TOOLBAR_CONTAINER_CLASS).appendTo($parent);
                this._propertiesToolbar = this._createComponent($container, _uiDiagram5.default, (0, _extend.extend)(this._getToolbarBaseOptions(), {
                    buttonStylingMode: "contained",
                    buttonType: "default",
                    locateInMenu: "never"
                }));
                this._updatePropertiesToolbarPosition($container, $parent, isServerSide);
                this._propertiesToolbarResizeCallback = function() {
                    _this7._updatePropertiesToolbarPosition($container, $parent, isServerSide)
                }
            };
            _proto._updatePropertiesToolbarPosition = function($container, $parent, isServerSide) {
                if (isServerSide) {
                    return
                }
                _position.default.setup($container, {
                    my: "right bottom",
                    at: "right bottom",
                    of: $parent,
                    offset: "-" + DIAGRAM_FLOATING_PANEL_OFFSET + " -" + DIAGRAM_FLOATING_PANEL_OFFSET
                })
            };
            _proto._renderPropertiesPanel = function($parent) {
                var _this8 = this;
                var isServerSide = !(0, _window.hasWindow)();
                var $propertiesPanel = (0, _renderer.default)("<div>").appendTo($parent);
                var offsetX = DIAGRAM_FLOATING_PANEL_OFFSET;
                var offsetY = 2 * DIAGRAM_FLOATING_PANEL_OFFSET + (!isServerSide ? this._propertiesToolbar.$element().outerHeight() : 0);
                this._propertiesPanel = this._createComponent($propertiesPanel, _uiDiagram11.default, {
                    isMobileView: this.isMobileScreenSize(),
                    isVisible: this._isPropertiesPanelVisible(),
                    container: this.$element(),
                    offsetParent: $parent,
                    offsetX: offsetX,
                    offsetY: offsetY,
                    propertyTabs: this.option("propertiesPanel.tabs"),
                    onCreateToolbar: function(e) {
                        e.toolbar = _this8._createComponent(e.$parent, _uiDiagram.default, (0, _extend.extend)(_this8._getToolbarBaseOptions(), {
                            commands: e.commands,
                            locateInMenu: "never",
                            editorStylingMode: "outlined"
                        }))
                    },
                    onVisibilityChanging: function(e) {
                        if (isServerSide) {
                            return
                        }
                        _this8._updatePropertiesPanelGroupBars(e.component);
                        _this8._setCustomCommandChecked(_diagram4.default.SHOW_PROPERTIES_PANEL_COMMAND_NAME, e.visible);
                        if (_this8._toolbox) {
                            if (e.visible && _this8.isMobileScreenSize()) {
                                _this8._toolbox.hide()
                            }
                        }
                    },
                    onVisibilityChanged: function(e) {
                        if (!e.visible && !_this8._textInputStarted) {
                            _this8._captureFocus()
                        }
                    },
                    onSelectedGroupChanged: function(_ref3) {
                        var component = _ref3.component;
                        return _this8._updatePropertiesPanelGroupBars(component)
                    },
                    onPointerUp: this._onPanelPointerUp.bind(this)
                });
                this._propertiesPanelResizeCallback = function() {
                    var prevIsMobileView = _this8._propertiesPanel.option("isMobileView");
                    if (prevIsMobileView !== _this8.isMobileScreenSize()) {
                        _this8._propertiesPanel.option({
                            isMobileView: _this8.isMobileScreenSize(),
                            isVisible: _this8._isPropertiesPanelVisible()
                        });
                        _this8._setCustomCommandChecked(_diagram4.default.SHOW_PROPERTIES_PANEL_COMMAND_NAME, _this8._isPropertiesPanelVisible())
                    }
                }
            };
            _proto._updatePropertiesPanelGroupBars = function(component) {
                var _this9 = this;
                component.getActiveToolbars().forEach(function(toolbar) {
                    _this9._diagramInstance.updateBarItemsState(toolbar.bar)
                })
            };
            _proto._onPanelPointerUp = function() {
                this._captureFocusOnTimeout()
            };
            _proto._renderContextMenu = function($parent) {
                var _this10 = this;
                var $contextMenu = (0, _renderer.default)("<div>").appendTo($parent);
                this._contextMenu = this._createComponent($contextMenu, _uiDiagram6.default.DiagramContextMenuWrapper, {
                    commands: this.option("contextMenu.commands"),
                    onContentReady: function(_ref4) {
                        var component = _ref4.component;
                        return _this10._registerBar(component)
                    },
                    onVisibilityChanging: function(_ref5) {
                        var component = _ref5.component;
                        return _this10._diagramInstance.updateBarItemsState(component.bar)
                    },
                    onItemClick: function(itemData) {
                        return _this10._onBeforeCommandExecuted(itemData.command)
                    },
                    "export": this.option("export"),
                    excludeCommands: this._getExcludeCommands(),
                    onInternalCommand: this._onInternalCommand.bind(this),
                    onCustomCommand: this._onCustomCommand.bind(this)
                })
            };
            _proto._renderContextToolbox = function($parent) {
                var _this11 = this;
                var isServerSide = !(0, _window.hasWindow)();
                var category = this.option("contextToolbox.category");
                var displayMode = this.option("contextToolbox.displayMode");
                var shapes = this.option("contextToolbox.shapes");
                var $contextToolbox = (0, _renderer.default)("<div>").appendTo($parent);
                this._contextToolbox = this._createComponent($contextToolbox, _uiDiagram7.default, {
                    toolboxWidth: this.option("contextToolbox.width"),
                    onShown: function(e) {
                        if (isServerSide) {
                            return
                        }
                        var $toolboxContainer = (0, _renderer.default)(e.$element);
                        var isTextGroup = "texts" === displayMode;
                        if (!shapes && !category && !isTextGroup) {
                            var group = _this11._getToolboxGroups().filter(function(g) {
                                return g.category === e.category
                            })[0];
                            if (group) {
                                isTextGroup = "texts" === group.displayMode
                            }
                        }
                        _this11._diagramInstance.createContextToolbox($toolboxContainer[0], isTextGroup, shapes || category || e.category, {
                            shapeIconSpacing: DIAGRAM_CONTEXT_TOOLBOX_SHAPE_SPACING,
                            shapeIconCountInRow: _this11.option("contextToolbox.shapeIconsPerRow")
                        }, function(shapeType) {
                            e.callback(shapeType);
                            _this11._captureFocus();
                            e.hide()
                        })
                    }
                })
            };
            _proto._setCustomCommandChecked = function(command, checked) {
                this._toolbars.forEach(function(tb) {
                    tb.setCommandChecked(command, checked)
                })
            };
            _proto._onBeforeCommandExecuted = function(command) {
                var dialogParameters = _uiDiagram12.default.getDialogParameters(command);
                if (dialogParameters) {
                    this._showDialog(dialogParameters)
                }
                return !!dialogParameters
            };
            _proto._renderDialog = function($parent) {
                var $dialogElement = (0, _renderer.default)("<div>").appendTo($parent);
                this._dialogInstance = this._createComponent($dialogElement, _uiDiagram8.default, {})
            };
            _proto._showDialog = function(dialogParameters) {
                if (this._dialogInstance) {
                    this._dialogInstance.option("onGetContent", dialogParameters.onGetContent);
                    this._dialogInstance.option("onHidden", function() {
                        this._captureFocus()
                    }.bind(this));
                    this._dialogInstance.option("command", this._diagramInstance.getCommand(dialogParameters.command));
                    this._dialogInstance.option("title", dialogParameters.title);
                    this._dialogInstance._show()
                }
            };
            _proto._showLoadingIndicator = function() {
                this._loadingIndicator = (0, _renderer.default)("<div>").addClass(DIAGRAM_LOADING_INDICATOR_CLASS);
                this._createComponent(this._loadingIndicator, _load_indicator.default, {});
                var $parent = this._$content || this.$element();
                $parent.append(this._loadingIndicator)
            };
            _proto._hideLoadingIndicator = function() {
                if (!this._loadingIndicator) {
                    return
                }
                this._loadingIndicator.remove();
                this._loadingIndicator = null
            };
            _proto._initDiagram = function() {
                var _getDiagram = (0, _diagram.getDiagram)(),
                    DiagramControl = _getDiagram.DiagramControl;
                this._diagramInstance = new DiagramControl;
                this._diagramInstance.onChanged = this._raiseDataChangeAction.bind(this);
                this._diagramInstance.onEdgeInserted = this._raiseEdgeInsertedAction.bind(this);
                this._diagramInstance.onEdgeUpdated = this._raiseEdgeUpdatedAction.bind(this);
                this._diagramInstance.onEdgeRemoved = this._raiseEdgeRemovedAction.bind(this);
                this._diagramInstance.onNodeInserted = this._raiseNodeInsertedAction.bind(this);
                this._diagramInstance.onNodeUpdated = this._raiseNodeUpdatedAction.bind(this);
                this._diagramInstance.onNodeRemoved = this._raiseNodeRemovedAction.bind(this);
                this._diagramInstance.onToolboxDragStart = this._raiseToolboxDragStart.bind(this);
                this._diagramInstance.onToolboxDragEnd = this._raiseToolboxDragEnd.bind(this);
                this._diagramInstance.onTextInputStart = this._raiseTextInputStart.bind(this);
                this._diagramInstance.onTextInputEnd = this._raiseTextInputEnd.bind(this);
                this._diagramInstance.onToggleFullscreen = this._onToggleFullScreen.bind(this);
                this._diagramInstance.onShowContextMenu = this._onShowContextMenu.bind(this);
                this._diagramInstance.onHideContextMenu = this._onHideContextMenu.bind(this);
                this._diagramInstance.onShowContextToolbox = this._onShowContextToolbox.bind(this);
                this._diagramInstance.onHideContextToolbox = this._onHideContextToolbox.bind(this);
                this._diagramInstance.onNativeAction.add({
                    notifyItemClick: this._raiseItemClickAction.bind(this),
                    notifyItemDblClick: this._raiseItemDblClickAction.bind(this),
                    notifySelectionChanged: this._raiseSelectionChanged.bind(this)
                });
                this._diagramInstance.onRequestOperation = this._raiseRequestEditOperation.bind(this);
                this._updateEventSubscriptionMethods();
                this._updateDefaultItemProperties();
                this._updateEditingSettings();
                this._updateShapeTexts();
                this._updateUnitItems();
                this._updateFormatUnitsMethod();
                if (this.option("units") !== DIAGRAM_DEFAULT_UNIT) {
                    this._updateUnitsState()
                }
                if (this.isReadOnlyMode()) {
                    this._updateReadOnlyState()
                }
                if (this.option("pageSize")) {
                    if (this.option("pageSize.items")) {
                        this._updatePageSizeItemsState()
                    }
                    if (this.option("pageSize.width") && this.option("pageSize.height")) {
                        this._updatePageSizeState()
                    }
                }
                if (this.option("pageOrientation") !== DIAGRAM_DEFAULT_PAGE_ORIENTATION) {
                    this._updatePageOrientationState()
                }
                if (this.option("pageColor") !== DIAGRAM_DEFAULT_PAGE_COLOR) {
                    this._updatePageColorState()
                }
                if (this.option("viewUnits") !== DIAGRAM_DEFAULT_UNIT) {
                    this._updateViewUnitsState()
                }
                if (!this.option("showGrid")) {
                    this._updateShowGridState()
                }
                if (!this.option("snapToGrid")) {
                    this._updateSnapToGridState()
                }
                if (this.option("gridSize")) {
                    this._updateGridSizeState()
                }
                if (this.option("zoomLevel") !== DIAGRAM_DEFAULT_ZOOMLEVEL) {
                    this._updateZoomLevelState()
                }
                if (this.option("simpleView")) {
                    this._updateSimpleViewState()
                }
                if (this.option("autoZoomMode") !== DIAGRAM_DEFAULT_AUTOZOOM_MODE) {
                    this._updateAutoZoomState()
                }
                if (this.option("fullScreen")) {
                    var window = (0, _window.getWindow)();
                    if (window && window.self !== window.top) {
                        this.option("fullScreen", false)
                    } else {
                        this._updateFullscreenState()
                    }
                }
                this.optionsUpdateBar = new _diagram3.default(this);
                this._diagramInstance.registerBar(this.optionsUpdateBar);
                if ((0, _window.hasWindow)()) {
                    this._diagramInstance.initMeasurer(this.$element()[0])
                }
                this._updateCustomShapes(this._getCustomShapes());
                this._refreshDataSources()
            };
            _proto._clean = function() {
                if (this._diagramInstance) {
                    this._diagramInstance.cleanMarkup(function(element) {
                        (0, _renderer.default)(element).empty()
                    })
                }
                _Widget.prototype._clean.call(this)
            };
            _proto._dispose = function() {
                this._killCaptureFocusTimeout();
                _Widget.prototype._dispose.call(this);
                this._diagramInstance = void 0
            };
            _proto._executeDiagramCommand = function(command, parameter) {
                this._diagramInstance.getCommand(command).execute(parameter)
            };
            _proto.getNodeDataSource = function() {
                return this._nodesOption && this._nodesOption.getDataSource()
            };
            _proto.getEdgeDataSource = function() {
                return this._edgesOption && this._edgesOption.getDataSource()
            };
            _proto._refreshDataSources = function() {
                this._beginUpdateDiagram();
                this._refreshNodesDataSource();
                this._refreshEdgesDataSource();
                this._endUpdateDiagram()
            };
            _proto._refreshNodesDataSource = function() {
                if (this._nodesOption) {
                    this._nodesOption._disposeDataSource();
                    delete this._nodesOption
                }
                if (this.option("nodes.dataSource")) {
                    this._nodesOption = new _diagram5.default(this);
                    this._nodesOption.option("dataSource", this.option("nodes.dataSource"));
                    this._nodesOption._refreshDataSource()
                }
            };
            _proto._refreshEdgesDataSource = function() {
                if (this._edgesOption) {
                    this._edgesOption._disposeDataSource();
                    delete this._edgesOption
                }
                if (this.option("edges.dataSource")) {
                    this._edgesOption = new _diagram6.default(this);
                    this._edgesOption.option("dataSource", this.option("edges.dataSource"));
                    this._edgesOption._refreshDataSource()
                }
            };
            _proto._getDiagramData = function() {
                var value;
                var _getDiagram2 = (0, _diagram.getDiagram)(),
                    DiagramCommand = _getDiagram2.DiagramCommand;
                this._executeDiagramCommand(DiagramCommand.Export, function(data) {
                    value = data
                });
                return value
            };
            _proto._setDiagramData = function(data, keepExistingItems) {
                var _getDiagram3 = (0, _diagram.getDiagram)(),
                    DiagramCommand = _getDiagram3.DiagramCommand;
                this._executeDiagramCommand(DiagramCommand.Import, {
                    data: data,
                    keepExistingItems: keepExistingItems
                })
            };
            _proto.isReadOnlyMode = function() {
                return this.option("readOnly") || this.option("disabled")
            };
            _proto._onDataSourceChanged = function() {
                this._bindDiagramData()
            };
            _proto._getChangesKeys = function(changes) {
                return changes.map(function(change) {
                    return change.internalKey || change.key
                }).filter(function(key) {
                    return !!key
                })
            };
            _proto._createOptionGetter = function(optionName) {
                var expr = this.option(optionName);
                return expr && (0, _data.compileGetter)(expr)
            };
            _proto._onRequestUpdateLayout = function(changes) {
                if (!this._requestLayoutUpdateAction) {
                    this._createRequestLayoutUpdateAction()
                }
                var eventArgs = {
                    changes: changes,
                    allowed: false
                };
                this._requestLayoutUpdateAction(eventArgs);
                return eventArgs.allowed
            };
            _proto._createOptionSetter = function(optionName) {
                var expr = this.option(optionName);
                if ((0, _type.isFunction)(expr)) {
                    return expr
                }
                return expr && (0, _data.compileSetter)(expr)
            };
            _proto._bindDiagramData = function() {
                if (this._updateDiagramLockCount || !this._isBindingMode()) {
                    return
                }
                var _getDiagram4 = (0, _diagram.getDiagram)(),
                    DiagramCommand = _getDiagram4.DiagramCommand,
                    ConnectorLineOption = _getDiagram4.ConnectorLineOption,
                    ConnectorLineEnding = _getDiagram4.ConnectorLineEnding;
                var lineOptionGetter;
                var lineOptionSetter;
                var startLineEndingGetter;
                var startLineEndingSetter;
                var endLineEndingGetter;
                var endLineEndingSetter;
                var containerKeyGetter;
                var containerKeySetter;
                var data = {
                    nodeDataSource: this._nodesOption && this._nodesOption.getItems(),
                    edgeDataSource: this._edgesOption && this._edgesOption.getItems(),
                    nodeDataImporter: {
                        getKey: this._createOptionGetter("nodes.keyExpr"),
                        setKey: this._createOptionSetter("nodes.keyExpr"),
                        getCustomData: this._createOptionGetter("nodes.customDataExpr"),
                        setCustomData: this._createOptionSetter("nodes.customDataExpr"),
                        getLocked: this._createOptionGetter("nodes.lockedExpr"),
                        setLocked: this._createOptionSetter("nodes.lockedExpr"),
                        getStyle: this._createOptionGetter("nodes.styleExpr"),
                        setStyle: this._createOptionSetter("nodes.styleExpr"),
                        getStyleText: this._createOptionGetter("nodes.textStyleExpr"),
                        setStyleText: this._createOptionSetter("nodes.textStyleExpr"),
                        getZIndex: this._createOptionGetter("nodes.zIndexExpr"),
                        setZIndex: this._createOptionSetter("nodes.zIndexExpr"),
                        getType: this._createOptionGetter("nodes.typeExpr"),
                        setType: this._createOptionSetter("nodes.typeExpr"),
                        getText: this._createOptionGetter("nodes.textExpr"),
                        setText: this._createOptionSetter("nodes.textExpr"),
                        getImage: this._createOptionGetter("nodes.imageUrlExpr"),
                        setImage: this._createOptionSetter("nodes.imageUrlExpr"),
                        getLeft: this._createOptionGetter("nodes.leftExpr"),
                        setLeft: this._createOptionSetter("nodes.leftExpr"),
                        getTop: this._createOptionGetter("nodes.topExpr"),
                        setTop: this._createOptionSetter("nodes.topExpr"),
                        getWidth: this._createOptionGetter("nodes.widthExpr"),
                        setWidth: this._createOptionSetter("nodes.widthExpr"),
                        getHeight: this._createOptionGetter("nodes.heightExpr"),
                        setHeight: this._createOptionSetter("nodes.heightExpr"),
                        getParentKey: this._createOptionGetter("nodes.parentKeyExpr"),
                        setParentKey: this._createOptionSetter("nodes.parentKeyExpr"),
                        getItems: this._createOptionGetter("nodes.itemsExpr"),
                        setItems: this._createOptionSetter("nodes.itemsExpr"),
                        getContainerKey: containerKeyGetter = this._createOptionGetter("nodes.containerKeyExpr"),
                        setContainerKey: containerKeySetter = this._createOptionSetter("nodes.containerKeyExpr"),
                        getChildren: !containerKeyGetter && !containerKeySetter && this._createOptionGetter("nodes.containerChildrenExpr"),
                        setChildren: !containerKeyGetter && !containerKeySetter && this._createOptionSetter("nodes.containerChildrenExpr")
                    },
                    edgeDataImporter: {
                        getKey: this._createOptionGetter("edges.keyExpr"),
                        setKey: this._createOptionSetter("edges.keyExpr"),
                        getCustomData: this._createOptionGetter("edges.customDataExpr"),
                        setCustomData: this._createOptionSetter("edges.customDataExpr"),
                        getLocked: this._createOptionGetter("edges.lockedExpr"),
                        setLocked: this._createOptionSetter("edges.lockedExpr"),
                        getStyle: this._createOptionGetter("edges.styleExpr"),
                        setStyle: this._createOptionSetter("edges.styleExpr"),
                        getStyleText: this._createOptionGetter("edges.textStyleExpr"),
                        setStyleText: this._createOptionSetter("edges.textStyleExpr"),
                        getZIndex: this._createOptionGetter("edges.zIndexExpr"),
                        setZIndex: this._createOptionSetter("edges.zIndexExpr"),
                        getFrom: this._createOptionGetter("edges.fromExpr"),
                        setFrom: this._createOptionSetter("edges.fromExpr"),
                        getFromPointIndex: this._createOptionGetter("edges.fromPointIndexExpr"),
                        setFromPointIndex: this._createOptionSetter("edges.fromPointIndexExpr"),
                        getTo: this._createOptionGetter("edges.toExpr"),
                        setTo: this._createOptionSetter("edges.toExpr"),
                        getToPointIndex: this._createOptionGetter("edges.toPointIndexExpr"),
                        setToPointIndex: this._createOptionSetter("edges.toPointIndexExpr"),
                        getPoints: this._createOptionGetter("edges.pointsExpr"),
                        setPoints: this._createOptionSetter("edges.pointsExpr"),
                        getText: this._createOptionGetter("edges.textExpr"),
                        setText: this._createOptionSetter("edges.textExpr"),
                        getLineOption: (lineOptionGetter = this._createOptionGetter("edges.lineTypeExpr")) && function(obj) {
                            var lineType = lineOptionGetter(obj);
                            return this._getConnectorLineOption(lineType)
                        }.bind(this),
                        setLineOption: (lineOptionSetter = this._createOptionSetter("edges.lineTypeExpr")) && function(obj, value) {
                            switch (value) {
                                case ConnectorLineOption.Straight:
                                    value = "straight";
                                    break;
                                case ConnectorLineOption.Orthogonal:
                                    value = "orthogonal"
                            }
                            lineOptionSetter(obj, value)
                        }.bind(this),
                        getStartLineEnding: (startLineEndingGetter = this._createOptionGetter("edges.fromLineEndExpr")) && function(obj) {
                            var lineEnd = startLineEndingGetter(obj);
                            return this._getConnectorLineEnding(lineEnd)
                        }.bind(this),
                        setStartLineEnding: (startLineEndingSetter = this._createOptionSetter("edges.fromLineEndExpr")) && function(obj, value) {
                            switch (value) {
                                case ConnectorLineEnding.Arrow:
                                    value = "arrow";
                                    break;
                                case ConnectorLineEnding.OutlinedTriangle:
                                    value = "outlinedTriangle";
                                    break;
                                case ConnectorLineEnding.FilledTriangle:
                                    value = "filledTriangle";
                                    break;
                                case ConnectorLineEnding.None:
                                    value = "none"
                            }
                            startLineEndingSetter(obj, value)
                        }.bind(this),
                        getEndLineEnding: (endLineEndingGetter = this._createOptionGetter("edges.toLineEndExpr")) && function(obj) {
                            var lineEnd = endLineEndingGetter(obj);
                            return this._getConnectorLineEnding(lineEnd)
                        }.bind(this),
                        setEndLineEnding: (endLineEndingSetter = this._createOptionSetter("edges.toLineEndExpr")) && function(obj, value) {
                            switch (value) {
                                case ConnectorLineEnding.Arrow:
                                    value = "arrow";
                                    break;
                                case ConnectorLineEnding.OutlinedTriangle:
                                    value = "outlinedTriangle";
                                    break;
                                case ConnectorLineEnding.FilledTriangle:
                                    value = "filledTriangle";
                                    break;
                                case ConnectorLineEnding.None:
                                    value = "none"
                            }
                            endLineEndingSetter(obj, value)
                        }.bind(this)
                    },
                    layoutParameters: this._getDataBindingLayoutParameters()
                };
                this._executeDiagramCommand(DiagramCommand.BindDocument, data)
            };
            _proto._reloadContentByChanges = function(changes, isExternalChanges) {
                var keys = this._getChangesKeys(changes);
                var applyLayout = this._onRequestUpdateLayout(changes);
                this._reloadContent(keys, applyLayout, isExternalChanges)
            };
            _proto._reloadContent = function(itemKeys, applyLayout, isExternalChanges) {
                var _this12 = this;
                var getData = function() {
                    var nodeDataSource;
                    var edgeDataSource;
                    if (_this12._nodesOption && isExternalChanges) {
                        nodeDataSource = _this12._nodesOption.getItems()
                    }
                    if (_this12._edgesOption && isExternalChanges) {
                        edgeDataSource = _this12._edgesOption.getItems()
                    }
                    return {
                        nodeDataSource: nodeDataSource,
                        edgeDataSource: edgeDataSource
                    }
                };
                this._diagramInstance.reloadContent(itemKeys, getData, applyLayout && this._getDataBindingLayoutParameters(), isExternalChanges)
            };
            _proto._getConnectorLineOption = function(lineType) {
                var _getDiagram5 = (0, _diagram.getDiagram)(),
                    ConnectorLineOption = _getDiagram5.ConnectorLineOption;
                switch (lineType) {
                    case "straight":
                        return ConnectorLineOption.Straight;
                    default:
                        return ConnectorLineOption.Orthogonal
                }
            };
            _proto._getConnectorLineEnding = function(lineEnd) {
                var _getDiagram6 = (0, _diagram.getDiagram)(),
                    ConnectorLineEnding = _getDiagram6.ConnectorLineEnding;
                switch (lineEnd) {
                    case "arrow":
                        return ConnectorLineEnding.Arrow;
                    case "outlinedTriangle":
                        return ConnectorLineEnding.OutlinedTriangle;
                    case "filledTriangle":
                        return ConnectorLineEnding.FilledTriangle;
                    default:
                        return ConnectorLineEnding.None
                }
            };
            _proto._getDataBindingLayoutParameters = function() {
                var _getDiagram7 = (0, _diagram.getDiagram)(),
                    DataLayoutType = _getDiagram7.DataLayoutType,
                    DataLayoutOrientation = _getDiagram7.DataLayoutOrientation;
                var layoutParametersOption = this.option("nodes.autoLayout") || "off";
                var layoutType = layoutParametersOption.type || layoutParametersOption;
                var parameters = {};
                if ("off" !== layoutType && ("auto" !== layoutType || !this._hasNodePositionExprs())) {
                    switch (layoutType) {
                        case "tree":
                            parameters.type = DataLayoutType.Tree;
                            break;
                        default:
                            parameters.type = DataLayoutType.Sugiyama
                    }
                    switch (layoutParametersOption.orientation) {
                        case "vertical":
                            parameters.orientation = DataLayoutOrientation.Vertical;
                            break;
                        case "horizontal":
                            parameters.orientation = DataLayoutOrientation.Horizontal
                    }
                    if (this.option("edges.fromPointIndexExpr") || this.option("edges.toPointIndexExpr")) {
                        parameters.skipPointIndices = true
                    }
                }
                parameters.autoSizeEnabled = !!this.option("nodes.autoSizeEnabled");
                return parameters
            };
            _proto._hasNodePositionExprs = function() {
                return this.option("nodes.topExpr") && this.option("nodes.leftExpr")
            };
            _proto._getAutoZoomValue = function(option) {
                var _getDiagram8 = (0, _diagram.getDiagram)(),
                    AutoZoomMode = _getDiagram8.AutoZoomMode;
                switch (option) {
                    case "fitContent":
                        return AutoZoomMode.FitContent;
                    case "fitWidth":
                        return AutoZoomMode.FitToWidth;
                    default:
                        return AutoZoomMode.Disabled
                }
            };
            _proto._isBindingMode = function() {
                return this._nodesOption && this._nodesOption.hasItems() || this._edgesOption && this._nodesOption.hasItems()
            };
            _proto._beginUpdateDiagram = function() {
                this._updateDiagramLockCount++
            };
            _proto._endUpdateDiagram = function() {
                this._updateDiagramLockCount = Math.max(this._updateDiagramLockCount - 1, 0);
                if (!this._updateDiagramLockCount) {
                    this._bindDiagramData()
                }
            };
            _proto._getCustomShapes = function() {
                return this.option("customShapes") || []
            };
            _proto._getToolboxGroups = function() {
                return _diagram2.default.getGroups(this.option("toolbox.groups"))
            };
            _proto._updateCustomShapes = function(customShapes, prevCustomShapes) {
                var _this13 = this;
                if (Array.isArray(prevCustomShapes)) {
                    this._diagramInstance.removeCustomShapes(prevCustomShapes.map(function(s) {
                        return s.type
                    }))
                }
                if (Array.isArray(customShapes)) {
                    this._diagramInstance.addCustomShapes(customShapes.map(function(s) {
                        var templateOption = s.template || _this13.option("customShapeTemplate");
                        var template = templateOption && _this13._getTemplate(templateOption);
                        var toolboxTemplateOption = s.toolboxTemplate || _this13.option("customShapeToolboxTemplate");
                        var toolboxTemplate = toolboxTemplateOption && _this13._getTemplate(toolboxTemplateOption);
                        return {
                            category: s.category,
                            type: s.type,
                            baseType: s.baseType,
                            title: s.title,
                            svgUrl: s.backgroundImageUrl,
                            svgToolboxUrl: s.backgroundImageToolboxUrl,
                            svgLeft: s.backgroundImageLeft,
                            svgTop: s.backgroundImageTop,
                            svgWidth: s.backgroundImageWidth,
                            svgHeight: s.backgroundImageHeight,
                            defaultWidth: s.defaultWidth,
                            defaultHeight: s.defaultHeight,
                            toolboxWidthToHeightRatio: s.toolboxWidthToHeightRatio,
                            minWidth: s.minWidth,
                            minHeight: s.minHeight,
                            maxWidth: s.maxWidth,
                            maxHeight: s.maxHeight,
                            allowResize: s.allowResize,
                            defaultText: s.defaultText,
                            allowEditText: s.allowEditText,
                            textLeft: s.textLeft,
                            textTop: s.textTop,
                            textWidth: s.textWidth,
                            textHeight: s.textHeight,
                            defaultImageUrl: s.defaultImageUrl,
                            allowEditImage: s.allowEditImage,
                            imageLeft: s.imageLeft,
                            imageTop: s.imageTop,
                            imageWidth: s.imageWidth,
                            imageHeight: s.imageHeight,
                            connectionPoints: s.connectionPoints && s.connectionPoints.map(function(pt) {
                                return {
                                    x: pt.x,
                                    y: pt.y
                                }
                            }),
                            createTemplate: template && function(container, item) {
                                template.render({
                                    model: _this13._nativeItemToDiagramItem(item),
                                    container: (0, _element.getPublicElement)((0, _renderer.default)(container))
                                })
                            },
                            createToolboxTemplate: toolboxTemplate && function(container, item) {
                                toolboxTemplate.render({
                                    model: _this13._nativeItemToDiagramItem(item),
                                    container: (0, _element.getPublicElement)((0, _renderer.default)(container))
                                })
                            },
                            destroyTemplate: template && function(container) {
                                (0, _renderer.default)(container).empty()
                            },
                            templateLeft: s.templateLeft,
                            templateTop: s.templateTop,
                            templateWidth: s.templateWidth,
                            templateHeight: s.templateHeight,
                            keepRatioOnAutoSize: s.keepRatioOnAutoSize
                        }
                    }))
                }
            };
            _proto._onToggleFullScreen = function(fullScreen) {
                if (this.toggleFullscreenLock > 0) {
                    return
                }
                this._changeNativeFullscreen(fullScreen);
                this.$element().toggleClass(DIAGRAM_FULLSCREEN_CLASS, fullScreen);
                this._diagramInstance.updateLayout(true);
                this._processDiagramResize();
                if (this._toolbox) {
                    this._toolbox.repaint()
                }
                if (this._propertiesPanel) {
                    this._propertiesPanel.repaint()
                }
            };
            _proto._changeNativeFullscreen = function(setModeOn) {
                var window = (0, _window.getWindow)();
                if (window.self === window.top || setModeOn === this._inNativeFullscreen()) {
                    return
                }
                if (setModeOn) {
                    this._subscribeFullscreenNativeChanged()
                } else {
                    this._unsubscribeFullscreenNativeChanged()
                }
                this._setNativeFullscreen(setModeOn)
            };
            _proto._setNativeFullscreen = function(on) {
                var window = (0, _window.getWindow)();
                var document = window.self.document;
                var body = window.self.document.body;
                if (on) {
                    if (body.requestFullscreen) {
                        body.requestFullscreen()
                    } else {
                        if (body.mozRequestFullscreen) {
                            body.mozRequestFullscreen()
                        } else {
                            if (body.webkitRequestFullscreen) {
                                body.webkitRequestFullscreen()
                            } else {
                                if (body.msRequestFullscreen) {
                                    body.msRequestFullscreen()
                                }
                            }
                        }
                    }
                } else {
                    if (document.exitFullscreen) {
                        document.exitFullscreen()
                    } else {
                        if (document.mozCancelFullscreen) {
                            document.mozCancelFullscreen()
                        } else {
                            if (document.webkitExitFullscreen) {
                                document.webkitExitFullscreen()
                            } else {
                                if (document.msExitFullscreen) {
                                    document.msExitFullscreen()
                                }
                            }
                        }
                    }
                }
            };
            _proto._inNativeFullscreen = function() {
                var document = (0, _window.getWindow)().document;
                var fullscreenElement = document.fullscreenElement || document.msFullscreenElement || document.webkitFullscreenElement;
                var isInFullscreen = fullscreenElement === document.body || document.webkitIsFullscreen;
                return !!isInFullscreen
            };
            _proto._subscribeFullscreenNativeChanged = function() {
                var document = (0, _window.getWindow)().document;
                var handler = this._onNativeFullscreenChangeHandler.bind(this);
                _events_engine.default.on(document, FULLSCREEN_CHANGE_EVENT_NAME, handler);
                _events_engine.default.on(document, IE_FULLSCREEN_CHANGE_EVENT_NAME, handler);
                _events_engine.default.on(document, WEBKIT_FULLSCREEN_CHANGE_EVENT_NAME, handler);
                _events_engine.default.on(document, MOZ_FULLSCREEN_CHANGE_EVENT_NAME, handler)
            };
            _proto._unsubscribeFullscreenNativeChanged = function() {
                var document = (0, _window.getWindow)().document;
                _events_engine.default.off(document, FULLSCREEN_CHANGE_EVENT_NAME);
                _events_engine.default.off(document, IE_FULLSCREEN_CHANGE_EVENT_NAME);
                _events_engine.default.off(document, WEBKIT_FULLSCREEN_CHANGE_EVENT_NAME);
                _events_engine.default.off(document, MOZ_FULLSCREEN_CHANGE_EVENT_NAME)
            };
            _proto._onNativeFullscreenChangeHandler = function() {
                if (!this._inNativeFullscreen()) {
                    this._unsubscribeFullscreenNativeChanged();
                    this.option("fullScreen", false)
                }
            };
            _proto._executeDiagramFullscreenCommand = function(fullscreen) {
                var _getDiagram9 = (0, _diagram.getDiagram)(),
                    DiagramCommand = _getDiagram9.DiagramCommand;
                this.toggleFullscreenLock++;
                this._executeDiagramCommand(DiagramCommand.Fullscreen, fullscreen);
                this.toggleFullscreenLock--
            };
            _proto._onShowContextMenu = function(x, y, selection) {
                if (this._contextMenu) {
                    this._contextMenu._show(x, y, selection)
                }
            };
            _proto._onHideContextMenu = function() {
                if (this._contextMenu) {
                    this._contextMenu._hide()
                }
            };
            _proto._onShowContextToolbox = function(x, y, side, category, callback) {
                if (this._contextToolbox) {
                    this._contextToolbox._show(x, y, side, category, callback)
                }
            };
            _proto._onHideContextToolbox = function() {
                if (this._contextToolbox) {
                    this._contextToolbox._hide()
                }
            };
            _proto._getDiagramUnitValue = function(value) {
                var _getDiagram10 = (0, _diagram.getDiagram)(),
                    DiagramUnit = _getDiagram10.DiagramUnit;
                switch (value) {
                    case "in":
                        return DiagramUnit.In;
                    case "cm":
                        return DiagramUnit.Cm;
                    case "px":
                        return DiagramUnit.Px;
                    default:
                        return DiagramUnit.In
                }
            };
            _proto._updateReadOnlyState = function() {
                var _getDiagram11 = (0, _diagram.getDiagram)(),
                    DiagramCommand = _getDiagram11.DiagramCommand;
                var readOnly = this.isReadOnlyMode();
                this._executeDiagramCommand(DiagramCommand.ToggleReadOnly, readOnly)
            };
            _proto._updateZoomLevelState = function() {
                if (this.option("zoomLevel.items")) {
                    this._updateZoomLevelItemsState();
                    var zoomLevel = this.option("zoomLevel.value");
                    if (!zoomLevel) {
                        return
                    }
                    var _getDiagram12 = (0, _diagram.getDiagram)(),
                        DiagramCommand = _getDiagram12.DiagramCommand;
                    this._executeDiagramCommand(DiagramCommand.ZoomLevel, zoomLevel)
                } else {
                    var _zoomLevel = this.option("zoomLevel.value") || this.option("zoomLevel");
                    if (!_zoomLevel) {
                        return
                    }
                    var _getDiagram13 = (0, _diagram.getDiagram)(),
                        _DiagramCommand = _getDiagram13.DiagramCommand;
                    this._executeDiagramCommand(_DiagramCommand.ZoomLevel, _zoomLevel)
                }
            };
            _proto._updateZoomLevelItemsState = function() {
                var zoomLevelItems = this.option("zoomLevel.items");
                if (!Array.isArray(zoomLevelItems)) {
                    return
                }
                var _getDiagram14 = (0, _diagram.getDiagram)(),
                    DiagramCommand = _getDiagram14.DiagramCommand;
                this._executeDiagramCommand(DiagramCommand.ZoomLevelItems, zoomLevelItems)
            };
            _proto._updateAutoZoomState = function() {
                var _getDiagram15 = (0, _diagram.getDiagram)(),
                    DiagramCommand = _getDiagram15.DiagramCommand;
                this._executeDiagramCommand(DiagramCommand.SwitchAutoZoom, this._getAutoZoomValue(this.option("autoZoomMode")))
            };
            _proto._updateSimpleViewState = function() {
                var _getDiagram16 = (0, _diagram.getDiagram)(),
                    DiagramCommand = _getDiagram16.DiagramCommand;
                this._executeDiagramCommand(DiagramCommand.ToggleSimpleView, this.option("simpleView"))
            };
            _proto._updateFullscreenState = function() {
                var fullscreen = this.option("fullScreen");
                this._executeDiagramFullscreenCommand(fullscreen);
                this._onToggleFullScreen(fullscreen)
            };
            _proto._updateShowGridState = function() {
                var _getDiagram17 = (0, _diagram.getDiagram)(),
                    DiagramCommand = _getDiagram17.DiagramCommand;
                this._executeDiagramCommand(DiagramCommand.ShowGrid, this.option("showGrid"))
            };
            _proto._updateSnapToGridState = function() {
                var _getDiagram18 = (0, _diagram.getDiagram)(),
                    DiagramCommand = _getDiagram18.DiagramCommand;
                this._executeDiagramCommand(DiagramCommand.SnapToGrid, this.option("snapToGrid"))
            };
            _proto._updateGridSizeState = function() {
                if (this.option("gridSize.items")) {
                    this._updateGridSizeItemsState();
                    var gridSize = this.option("gridSize.value");
                    if (!gridSize) {
                        return
                    }
                    var _getDiagram19 = (0, _diagram.getDiagram)(),
                        DiagramCommand = _getDiagram19.DiagramCommand;
                    this._executeDiagramCommand(DiagramCommand.GridSize, gridSize)
                } else {
                    var _gridSize = this.option("gridSize.value") || this.option("gridSize");
                    if (!_gridSize) {
                        return
                    }
                    var _getDiagram20 = (0, _diagram.getDiagram)(),
                        _DiagramCommand2 = _getDiagram20.DiagramCommand;
                    this._executeDiagramCommand(_DiagramCommand2.GridSize, _gridSize)
                }
            };
            _proto._updateGridSizeItemsState = function() {
                var gridSizeItems = this.option("gridSize.items");
                if (!Array.isArray(gridSizeItems)) {
                    return
                }
                var _getDiagram21 = (0, _diagram.getDiagram)(),
                    DiagramCommand = _getDiagram21.DiagramCommand;
                this._executeDiagramCommand(DiagramCommand.GridSizeItems, gridSizeItems)
            };
            _proto._updateUnitItems = function() {
                var _getDiagram22 = (0, _diagram.getDiagram)(),
                    DiagramLocalizationService = _getDiagram22.DiagramLocalizationService;
                var items = this._getUnitItems();
                if (this._unitItems !== items) {
                    this._unitItems = items;
                    DiagramLocalizationService.unitItems = items
                }
            };
            _proto._getUnitItems = function() {
                var _getDiagram23 = (0, _diagram.getDiagram)(),
                    DiagramUnit = _getDiagram23.DiagramUnit;
                var items = {};
                items[DiagramUnit.In] = _message.default.format("dxDiagram-unitIn");
                items[DiagramUnit.Cm] = _message.default.format("dxDiagram-unitCm");
                items[DiagramUnit.Px] = _message.default.format("dxDiagram-unitPx");
                return items
            };
            _proto._updateFormatUnitsMethod = function() {
                var _getDiagram24 = (0, _diagram.getDiagram)(),
                    DiagramLocalizationService = _getDiagram24.DiagramLocalizationService;
                DiagramLocalizationService.formatUnit = function(value) {
                    return _number.default.format(value)
                }
            };
            _proto._updateViewUnitsState = function() {
                var _getDiagram25 = (0, _diagram.getDiagram)(),
                    DiagramCommand = _getDiagram25.DiagramCommand;
                this._executeDiagramCommand(DiagramCommand.ViewUnits, this._getDiagramUnitValue(this.option("viewUnits")))
            };
            _proto._updateUnitsState = function() {
                var _getDiagram26 = (0, _diagram.getDiagram)(),
                    DiagramCommand = _getDiagram26.DiagramCommand;
                this._executeDiagramCommand(DiagramCommand.Units, this._getDiagramUnitValue(this.option("units")))
            };
            _proto._updatePageSizeState = function() {
                var pageSize = this.option("pageSize");
                if (!pageSize || !pageSize.width || !pageSize.height) {
                    return
                }
                var _getDiagram27 = (0, _diagram.getDiagram)(),
                    DiagramCommand = _getDiagram27.DiagramCommand;
                this._executeDiagramCommand(DiagramCommand.PageSize, pageSize)
            };
            _proto._updatePageSizeItemsState = function() {
                var pageSizeItems = this.option("pageSize.items");
                if (!Array.isArray(pageSizeItems)) {
                    return
                }
                var _getDiagram28 = (0, _diagram.getDiagram)(),
                    DiagramCommand = _getDiagram28.DiagramCommand;
                this._executeDiagramCommand(DiagramCommand.PageSizeItems, pageSizeItems)
            };
            _proto._updatePageOrientationState = function() {
                var _getDiagram29 = (0, _diagram.getDiagram)(),
                    DiagramCommand = _getDiagram29.DiagramCommand;
                this._executeDiagramCommand(DiagramCommand.PageLandscape, "landscape" === this.option("pageOrientation"))
            };
            _proto._updatePageColorState = function() {
                var _getDiagram30 = (0, _diagram.getDiagram)(),
                    DiagramCommand = _getDiagram30.DiagramCommand;
                this._executeDiagramCommand(DiagramCommand.PageColor, this.option("pageColor"))
            };
            _proto._updateShapeTexts = function() {
                var _getDiagram31 = (0, _diagram.getDiagram)(),
                    DiagramLocalizationService = _getDiagram31.DiagramLocalizationService;
                var texts = this._getShapeTexts();
                if (this._shapeTexts !== texts) {
                    this._shapeTexts = texts;
                    DiagramLocalizationService.shapeTexts = texts
                }
            };
            _proto._getShapeTexts = function() {
                var _getDiagram32 = (0, _diagram.getDiagram)(),
                    ShapeTypes = _getDiagram32.ShapeTypes;
                var texts = {};
                texts[ShapeTypes.Text] = _message.default.format("dxDiagram-shapeText");
                texts[ShapeTypes.Rectangle] = _message.default.format("dxDiagram-shapeRectangle");
                texts[ShapeTypes.Ellipse] = _message.default.format("dxDiagram-shapeEllipse");
                texts[ShapeTypes.Cross] = _message.default.format("dxDiagram-shapeCross");
                texts[ShapeTypes.Triangle] = _message.default.format("dxDiagram-shapeTriangle");
                texts[ShapeTypes.Diamond] = _message.default.format("dxDiagram-shapeDiamond");
                texts[ShapeTypes.Heart] = _message.default.format("dxDiagram-shapeHeart");
                texts[ShapeTypes.Pentagon] = _message.default.format("dxDiagram-shapePentagon");
                texts[ShapeTypes.Hexagon] = _message.default.format("dxDiagram-shapeHexagon");
                texts[ShapeTypes.Octagon] = _message.default.format("dxDiagram-shapeOctagon");
                texts[ShapeTypes.Star] = _message.default.format("dxDiagram-shapeStar");
                texts[ShapeTypes.ArrowLeft] = _message.default.format("dxDiagram-shapeArrowLeft");
                texts[ShapeTypes.ArrowUp] = _message.default.format("dxDiagram-shapeArrowUp");
                texts[ShapeTypes.ArrowRight] = _message.default.format("dxDiagram-shapeArrowRight");
                texts[ShapeTypes.ArrowDown] = _message.default.format("dxDiagram-shapeArrowDown");
                texts[ShapeTypes.ArrowUpDown] = _message.default.format("dxDiagram-shapeArrowUpDown");
                texts[ShapeTypes.ArrowLeftRight] = _message.default.format("dxDiagram-shapeArrowLeftRight");
                texts[ShapeTypes.Process] = _message.default.format("dxDiagram-shapeProcess");
                texts[ShapeTypes.Decision] = _message.default.format("dxDiagram-shapeDecision");
                texts[ShapeTypes.Terminator] = _message.default.format("dxDiagram-shapeTerminator");
                texts[ShapeTypes.PredefinedProcess] = _message.default.format("dxDiagram-shapePredefinedProcess");
                texts[ShapeTypes.Document] = _message.default.format("dxDiagram-shapeDocument");
                texts[ShapeTypes.MultipleDocuments] = _message.default.format("dxDiagram-shapeMultipleDocuments");
                texts[ShapeTypes.ManualInput] = _message.default.format("dxDiagram-shapeManualInput");
                texts[ShapeTypes.Preparation] = _message.default.format("dxDiagram-shapePreparation");
                texts[ShapeTypes.Data] = _message.default.format("dxDiagram-shapeData");
                texts[ShapeTypes.Database] = _message.default.format("dxDiagram-shapeDatabase");
                texts[ShapeTypes.HardDisk] = _message.default.format("dxDiagram-shapeHardDisk");
                texts[ShapeTypes.InternalStorage] = _message.default.format("dxDiagram-shapeInternalStorage");
                texts[ShapeTypes.PaperTape] = _message.default.format("dxDiagram-shapePaperTape");
                texts[ShapeTypes.ManualOperation] = _message.default.format("dxDiagram-shapeManualOperation");
                texts[ShapeTypes.Delay] = _message.default.format("dxDiagram-shapeDelay");
                texts[ShapeTypes.StoredData] = _message.default.format("dxDiagram-shapeStoredData");
                texts[ShapeTypes.Display] = _message.default.format("dxDiagram-shapeDisplay");
                texts[ShapeTypes.Merge] = _message.default.format("dxDiagram-shapeMerge");
                texts[ShapeTypes.Connector] = _message.default.format("dxDiagram-shapeConnector");
                texts[ShapeTypes.Or] = _message.default.format("dxDiagram-shapeOr");
                texts[ShapeTypes.SummingJunction] = _message.default.format("dxDiagram-shapeSummingJunction");
                texts[ShapeTypes.Container] = _message.default.format("dxDiagram-shapeContainerDefaultText");
                texts[ShapeTypes.VerticalContainer] = _message.default.format("dxDiagram-shapeVerticalContainer");
                texts[ShapeTypes.HorizontalContainer] = _message.default.format("dxDiagram-shapeHorizontalContainer");
                texts[ShapeTypes.Card] = _message.default.format("dxDiagram-shapeCardDefaultText");
                texts[ShapeTypes.CardWithImageOnLeft] = _message.default.format("dxDiagram-shapeCardWithImageOnLeft");
                texts[ShapeTypes.CardWithImageOnTop] = _message.default.format("dxDiagram-shapeCardWithImageOnTop");
                texts[ShapeTypes.CardWithImageOnRight] = _message.default.format("dxDiagram-shapeCardWithImageOnRight");
                return texts
            };
            _proto._updateEventSubscriptionMethods = function() {
                var _getDiagram33 = (0, _diagram.getDiagram)(),
                    RenderHelper = _getDiagram33.RenderHelper;
                RenderHelper.addEventListener = function(element, eventName, handler) {
                    _events_engine.default.on(element, eventName, handler)
                };
                RenderHelper.removeEventListener = function(element, eventName, handler) {
                    _events_engine.default.off(element, eventName, handler)
                }
            };
            _proto._updateDefaultItemProperties = function() {
                if (this.option("defaultItemProperties.style")) {
                    this._diagramInstance.setInitialStyleProperties(this.option("defaultItemProperties.style"))
                }
                if (this.option("defaultItemProperties.textStyle")) {
                    this._diagramInstance.setInitialTextStyleProperties(this.option("defaultItemProperties.textStyle"))
                }
                this._diagramInstance.setInitialConnectorProperties({
                    lineOption: this._getConnectorLineOption(this.option("defaultItemProperties.connectorLineType")),
                    startLineEnding: this._getConnectorLineEnding(this.option("defaultItemProperties.connectorLineStart")),
                    endLineEnding: this._getConnectorLineEnding(this.option("defaultItemProperties.connectorLineEnd"))
                });
                this._diagramInstance.applyShapeSizeSettings({
                    shapeMinWidth: this.option("defaultItemProperties.shapeMinWidth"),
                    shapeMaxWidth: this.option("defaultItemProperties.shapeMaxWidth"),
                    shapeMinHeight: this.option("defaultItemProperties.shapeMinHeight"),
                    shapeMaxHeight: this.option("defaultItemProperties.shapeMaxHeight")
                })
            };
            _proto._updateEditingSettings = function() {
                this._diagramInstance.applyOperationSettings({
                    addShape: this.option("editing.allowAddShape"),
                    addShapeFromToolbox: this.option("editing.allowAddShape"),
                    deleteShape: this.option("editing.allowDeleteShape"),
                    deleteConnector: this.option("editing.allowDeleteConnector"),
                    changeConnection: this.option("editing.allowChangeConnection"),
                    changeConnectorPoints: this.option("editing.allowChangeConnectorPoints"),
                    changeShapeText: this.option("editing.allowChangeShapeText"),
                    changeConnectorText: this.option("editing.allowChangeConnectorText"),
                    resizeShape: this.option("editing.allowResizeShape"),
                    moveShape: this.option("editing.allowMoveShape")
                })
            };
            _proto.focus = function() {
                this._captureFocus()
            };
            _proto.export = function() {
                return this._getDiagramData()
            };
            _proto.exportTo = function(format, callback) {
                var command = this._getDiagramExportToCommand(format);
                this._executeDiagramCommand(command, callback)
            };
            _proto._getDiagramExportToCommand = function(format) {
                var _getDiagram34 = (0, _diagram.getDiagram)(),
                    DiagramCommand = _getDiagram34.DiagramCommand;
                switch (format) {
                    case "png":
                        return DiagramCommand.ExportPng;
                    case "jpg":
                        return DiagramCommand.ExportJpg;
                    default:
                        return DiagramCommand.ExportSvg
                }
            };
            _proto.import = function(data, updateExistingItemsOnly) {
                this._setDiagramData(data, updateExistingItemsOnly);
                this._raiseDataChangeAction()
            };
            _proto.updateToolbox = function() {
                this._diagramInstance && this._diagramInstance.refreshToolbox();
                this._toolbox && this._toolbox.updateMaxHeight()
            };
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_Widget.prototype._getDefaultOptions.call(this), {
                    readOnly: false,
                    zoomLevel: DIAGRAM_DEFAULT_ZOOMLEVEL,
                    simpleView: false,
                    autoZoomMode: DIAGRAM_DEFAULT_AUTOZOOM_MODE,
                    fullScreen: false,
                    showGrid: true,
                    snapToGrid: true,
                    units: DIAGRAM_DEFAULT_UNIT,
                    viewUnits: DIAGRAM_DEFAULT_UNIT,
                    pageOrientation: DIAGRAM_DEFAULT_PAGE_ORIENTATION,
                    pageColor: DIAGRAM_DEFAULT_PAGE_COLOR,
                    hasChanges: false,
                    nodes: {
                        dataSource: null,
                        keyExpr: "id",
                        customDataExpr: void 0,
                        lockedExpr: void 0,
                        styleExpr: void 0,
                        textStyleExpr: void 0,
                        zIndexExpr: void 0,
                        typeExpr: "type",
                        textExpr: "text",
                        imageUrlExpr: void 0,
                        parentKeyExpr: void 0,
                        itemsExpr: void 0,
                        leftExpr: void 0,
                        topExpr: void 0,
                        widthExpr: void 0,
                        heightExpr: void 0,
                        containerKeyExpr: void 0,
                        containerChildrenExpr: "children",
                        autoLayout: "auto",
                        autoSizeEnabled: true
                    },
                    edges: {
                        dataSource: null,
                        keyExpr: "id",
                        customDataExpr: void 0,
                        lockedExpr: void 0,
                        styleExpr: void 0,
                        textStyleExpr: void 0,
                        zIndexExpr: void 0,
                        fromExpr: "from",
                        fromPointIndexExpr: void 0,
                        toExpr: "to",
                        toPointIndexExpr: void 0,
                        pointsExpr: void 0,
                        textExpr: void 0,
                        lineTypeExpr: void 0,
                        fromLineEndExpr: void 0,
                        toLineEndExpr: void 0
                    },
                    customShapes: [],
                    toolbox: {
                        visibility: "auto",
                        shapeIconsPerRow: DIAGRAM_TOOLBOX_SHAPES_PER_ROW,
                        showSearch: true
                    },
                    mainToolbar: {
                        visible: false
                    },
                    historyToolbar: {
                        visible: true
                    },
                    viewToolbar: {
                        visible: true
                    },
                    contextMenu: {
                        enabled: true
                    },
                    contextToolbox: {
                        enabled: true,
                        shapeIconsPerRow: DIAGRAM_CONTEXT_TOOLBOX_SHAPES_PER_ROW,
                        width: DIAGRAM_CONTEXT_TOOLBOX_DEFAULT_WIDTH
                    },
                    propertiesPanel: {
                        visibility: "auto"
                    },
                    defaultItemProperties: {
                        connectorLineType: "orthogonal",
                        connectorLineStart: "none",
                        connectorLineEnd: "arrow"
                    },
                    editing: {
                        allowAddShape: true,
                        allowDeleteShape: true,
                        allowDeleteConnector: true,
                        allowChangeConnection: true,
                        allowChangeConnectorPoints: true,
                        allowChangeShapeText: true,
                        allowChangeConnectorText: true,
                        allowResizeShape: true,
                        allowMoveShape: true
                    },
                    "export": {
                        fileName: "Diagram",
                        proxyUrl: void 0
                    },
                    onItemClick: null,
                    onItemDblClick: null,
                    onSelectionChanged: null,
                    onRequestEditOperation: null,
                    onRequestLayoutUpdate: null
                })
            };
            _proto._raiseDataChangeAction = function() {
                if (this._initialized) {
                    this.option("hasChanges", true)
                }
            };
            _proto._raiseEdgeInsertedAction = function(data, callback, errorCallback) {
                if (this._edgesOption) {
                    this._edgesOption.insert(data, callback, errorCallback)
                }
            };
            _proto._raiseEdgeUpdatedAction = function(key, data, callback, errorCallback) {
                if (this._edgesOption) {
                    this._edgesOption.update(key, data, callback, errorCallback)
                }
            };
            _proto._raiseEdgeRemovedAction = function(key, data, callback, errorCallback) {
                if (this._edgesOption) {
                    this._edgesOption.remove(key, data, callback, errorCallback)
                }
            };
            _proto._raiseNodeInsertedAction = function(data, callback, errorCallback) {
                if (this._nodesOption) {
                    this._nodesOption.insert(data, callback, errorCallback)
                }
            };
            _proto._raiseNodeUpdatedAction = function(key, data, callback, errorCallback) {
                if (this._nodesOption) {
                    this._nodesOption.update(key, data, callback, errorCallback)
                }
            };
            _proto._raiseNodeRemovedAction = function(key, data, callback, errorCallback) {
                if (this._nodesOption) {
                    this._nodesOption.remove(key, data, callback, errorCallback)
                }
            };
            _proto._raiseToolboxDragStart = function() {
                if (this._toolbox) {
                    this._toolbox._raiseToolboxDragStart();
                    if (this.isMobileScreenSize()) {
                        this._toolbox.hide();
                        this._toolboxDragHidden = true
                    }
                }
            };
            _proto._raiseToolboxDragEnd = function() {
                if (this._toolbox) {
                    this._toolbox._raiseToolboxDragEnd();
                    if (this._toolboxDragHidden) {
                        this._toolbox.show();
                        delete this._toolboxDragHidden
                    }
                }
            };
            _proto._raiseTextInputStart = function() {
                this._textInputStarted = true;
                if (this._propertiesPanel) {
                    if (this.isMobileScreenSize() && this._propertiesPanel.isVisible()) {
                        this._propertiesPanel.hide();
                        this._propertiesPanelTextInputHidden = true
                    }
                }
                if (this._toolbox) {
                    if (this.isMobileScreenSize() && this._toolbox.isVisible()) {
                        this._toolbox.hide();
                        this._toolboxTextInputHidden = true
                    }
                }
            };
            _proto._raiseTextInputEnd = function() {
                if (this._propertiesPanel) {
                    if (this._propertiesPanelTextInputHidden) {
                        this._propertiesPanel.show();
                        delete this._propertiesPanelTextInputHidden
                    }
                }
                if (this._toolbox) {
                    if (this._toolboxTextInputHidden) {
                        this._toolbox.show();
                        delete this._toolboxTextInputHidden
                    }
                }
                this._textInputStarted = false
            };
            _proto._createItemClickAction = function() {
                this._itemClickAction = this._createActionByOption("onItemClick")
            };
            _proto._createItemDblClickAction = function() {
                this._itemDblClickAction = this._createActionByOption("onItemDblClick")
            };
            _proto._createSelectionChangedAction = function() {
                this._selectionChangedAction = this._createActionByOption("onSelectionChanged")
            };
            _proto._createRequestEditOperationAction = function() {
                this._requestEditOperationAction = this._createActionByOption("onRequestEditOperation")
            };
            _proto._createRequestLayoutUpdateAction = function() {
                this._requestLayoutUpdateAction = this._createActionByOption("onRequestLayoutUpdate")
            };
            _proto._createCustomCommand = function() {
                this._customCommandAction = this._createActionByOption("onCustomCommand")
            };
            _proto._raiseItemClickAction = function(nativeItem) {
                if (!this._itemClickAction) {
                    this._createItemClickAction()
                }
                this._itemClickAction({
                    item: this._nativeItemToDiagramItem(nativeItem)
                })
            };
            _proto._raiseItemDblClickAction = function(nativeItem) {
                if (!this._itemDblClickAction) {
                    this._createItemDblClickAction()
                }
                this._itemDblClickAction({
                    item: this._nativeItemToDiagramItem(nativeItem)
                })
            };
            _proto._raiseSelectionChanged = function(nativeItems) {
                if (!this._selectionChangedAction) {
                    this._createSelectionChangedAction()
                }
                this._selectionChangedAction({
                    items: nativeItems.map(this._nativeItemToDiagramItem.bind(this))
                })
            };
            _proto._raiseRequestEditOperation = function(operation, args) {
                if (!this._requestEditOperationAction) {
                    this._createRequestEditOperationAction()
                }
                var eventArgs = this._getRequestEditOperationEventArgs(operation, args);
                this._requestEditOperationAction(eventArgs);
                args.allowed = eventArgs.allowed
            };
            _proto._getModelOperation = function(operation) {
                var _getDiagram35 = (0, _diagram.getDiagram)(),
                    DiagramModelOperation = _getDiagram35.DiagramModelOperation;
                switch (operation) {
                    case DiagramModelOperation.AddShape:
                        return "addShape";
                    case DiagramModelOperation.AddShapeFromToolbox:
                        return "addShapeFromToolbox";
                    case DiagramModelOperation.DeleteShape:
                        return "deleteShape";
                    case DiagramModelOperation.DeleteConnector:
                        return "deleteConnector";
                    case DiagramModelOperation.ChangeConnection:
                        return "changeConnection";
                    case DiagramModelOperation.ChangeConnectorPoints:
                        return "changeConnectorPoints";
                    case DiagramModelOperation.BeforeChangeShapeText:
                        return "beforeChangeShapeText";
                    case DiagramModelOperation.ChangeShapeText:
                        return "changeShapeText";
                    case DiagramModelOperation.BeforeChangeConnectorText:
                        return "beforeChangeConnectorText";
                    case DiagramModelOperation.ChangeConnectorText:
                        return "changeConnectorText";
                    case DiagramModelOperation.ResizeShape:
                        return "resizeShape";
                    case DiagramModelOperation.MoveShape:
                        return "moveShape"
                }
            };
            _proto._getRequestEditOperationEventArgs = function(operation, args) {
                var _getDiagram36 = (0, _diagram.getDiagram)(),
                    DiagramModelOperation = _getDiagram36.DiagramModelOperation,
                    ConnectorPosition = _getDiagram36.ConnectorPosition;
                var eventArgs = {
                    operation: this._getModelOperation(operation),
                    allowed: args.allowed,
                    updateUI: args.updateUI,
                    reason: args.updateUI ? "checkUIElementAvailability" : "modelModification"
                };
                switch (operation) {
                    case DiagramModelOperation.AddShape:
                        eventArgs.args = {
                            shape: args.shape && this._nativeItemToDiagramItem(args.shape),
                            position: args.position && {
                                x: args.position.x,
                                y: args.position.y
                            }
                        };
                        break;
                    case DiagramModelOperation.AddShapeFromToolbox:
                        eventArgs.args = {
                            shapeType: args.shapeType
                        };
                        break;
                    case DiagramModelOperation.DeleteShape:
                        eventArgs.args = {
                            shape: args.shape && this._nativeItemToDiagramItem(args.shape)
                        };
                        break;
                    case DiagramModelOperation.DeleteConnector:
                        eventArgs.args = {
                            connector: args.connector && this._nativeItemToDiagramItem(args.connector)
                        };
                        break;
                    case DiagramModelOperation.ChangeConnection:
                        eventArgs.args = {
                            newShape: args.shape && this._nativeItemToDiagramItem(args.shape),
                            oldShape: args.oldShape && this._nativeItemToDiagramItem(args.oldShape),
                            connector: args.connector && this._nativeItemToDiagramItem(args.connector),
                            connectionPointIndex: args.connectionPointIndex,
                            connectorPosition: args.position === ConnectorPosition.Begin ? "start" : "end"
                        };
                        break;
                    case DiagramModelOperation.ChangeConnectorPoints:
                        eventArgs.args = {
                            connector: args.connector && this._nativeItemToDiagramItem(args.connector),
                            newPoints: args.points && args.points.map(function(pt) {
                                return {
                                    x: pt.x,
                                    y: pt.y
                                }
                            }),
                            oldPoints: args.oldPoints && args.oldPoints.map(function(pt) {
                                return {
                                    x: pt.x,
                                    y: pt.y
                                }
                            })
                        };
                        break;
                    case DiagramModelOperation.BeforeChangeShapeText:
                        eventArgs.args = {
                            shape: args.shape && this._nativeItemToDiagramItem(args.shape)
                        };
                        break;
                    case DiagramModelOperation.ChangeShapeText:
                        eventArgs.args = {
                            shape: args.shape && this._nativeItemToDiagramItem(args.shape),
                            text: args.text
                        };
                        break;
                    case DiagramModelOperation.BeforeChangeConnectorText:
                        eventArgs.args = {
                            connector: args.connector && this._nativeItemToDiagramItem(args.connector),
                            index: args.index
                        };
                        break;
                    case DiagramModelOperation.ChangeConnectorText:
                        eventArgs.args = {
                            connector: args.connector && this._nativeItemToDiagramItem(args.connector),
                            index: args.index,
                            text: args.text
                        };
                        break;
                    case DiagramModelOperation.ResizeShape:
                        eventArgs.args = {
                            shape: args.shape && this._nativeItemToDiagramItem(args.shape),
                            newSize: args.size && {
                                width: args.size.width,
                                height: args.size.height
                            },
                            oldSize: args.oldSize && {
                                width: args.oldSize.width,
                                height: args.oldSize.height
                            }
                        };
                        break;
                    case DiagramModelOperation.MoveShape:
                        eventArgs.args = {
                            shape: args.shape && this._nativeItemToDiagramItem(args.shape),
                            newPosition: args.position && {
                                x: args.position.x,
                                y: args.position.y
                            },
                            oldPosition: args.oldPosition && {
                                x: args.oldPosition.x,
                                y: args.oldPosition.y
                            }
                        }
                }
                return eventArgs
            };
            _proto._nativeItemToDiagramItem = function(nativeItem) {
                var _getDiagram37 = (0, _diagram.getDiagram)(),
                    NativeShape = _getDiagram37.NativeShape;
                var createMethod = nativeItem instanceof NativeShape ? this._nativeShapeToDiagramShape.bind(this) : this._nativeConnectorToDiagramConnector.bind(this);
                return (0, _extend.extend)({
                    id: nativeItem.id,
                    key: nativeItem.key,
                    dataItem: void 0
                }, createMethod(nativeItem))
            };
            _proto._nativeShapeToDiagramShape = function(nativeShape) {
                return {
                    dataItem: this._nodesOption && this._nodesOption.findItem(nativeShape.key),
                    itemType: "shape",
                    text: nativeShape.text,
                    type: nativeShape.type,
                    position: {
                        x: nativeShape.position.x,
                        y: nativeShape.position.y
                    },
                    size: {
                        width: nativeShape.size.width,
                        height: nativeShape.size.height
                    },
                    attachedConnectorIds: nativeShape.attachedConnectorIds,
                    containerId: nativeShape.containerId,
                    containerChildItemIds: nativeShape.containerChildItemIds,
                    containerExpanded: nativeShape.containerExpanded
                }
            };
            _proto._nativeConnectorToDiagramConnector = function(nativeConnector) {
                return {
                    dataItem: this._edgesOption && this._edgesOption.findItem(nativeConnector.key),
                    itemType: "connector",
                    texts: nativeConnector.texts,
                    fromKey: nativeConnector.fromKey,
                    toKey: nativeConnector.toKey,
                    fromId: nativeConnector.fromId,
                    fromPointIndex: nativeConnector.fromPointIndex,
                    toId: nativeConnector.toId,
                    toPointIndex: nativeConnector.toPointIndex,
                    points: nativeConnector.points.map(function(pt) {
                        return {
                            x: pt.x,
                            y: pt.y
                        }
                    })
                }
            };
            _proto.getItemByKey = function(key) {
                var nativeItem = this._diagramInstance && this._diagramInstance.getNativeItemByDataKey(key);
                return nativeItem && this._nativeItemToDiagramItem(nativeItem)
            };
            _proto.getItemById = function(id) {
                var nativeItem = this._diagramInstance && this._diagramInstance.getNativeItemByKey(id);
                return nativeItem && this._nativeItemToDiagramItem(nativeItem)
            };
            _proto._invalidateContextMenuCommands = function() {
                if (this._contextMenu) {
                    this._contextMenu.option({
                        commands: this.option("contextMenu.commands")
                    })
                }
            };
            _proto._invalidatePropertiesPanelTabs = function() {
                if (this._propertiesPanel) {
                    this._propertiesPanel.option({
                        propertyTabs: this.option("propertiesPanel.tabs")
                    })
                }
            };
            _proto._invalidateMainToolbarCommands = function() {
                if (this._mainToolbar) {
                    this._mainToolbar.option({
                        commands: this.option("mainToolbar.commands")
                    })
                }
            };
            _proto._invalidateHistoryToolbarCommands = function() {
                if (this._historyToolbar) {
                    this._historyToolbar.option({
                        commands: this.option("historyToolbar.commands")
                    })
                }
            };
            _proto._invalidateViewToolbarCommands = function() {
                if (this._viewToolbar) {
                    this._viewToolbar.option({
                        commands: this.option("viewToolbar.commands")
                    })
                }
            };
            _proto._invalidateToolboxGroups = function() {
                if (this._toolbox) {
                    this._toolbox.option({
                        toolboxGroups: this._getToolboxGroups()
                    })
                }
            };
            _proto._optionChanged = function(args) {
                if (this.optionsUpdateBar.isUpdateLocked()) {
                    return
                }
                this.optionsUpdateBar.beginUpdate();
                try {
                    this._optionChangedCore(args)
                } finally {
                    this.optionsUpdateBar.endUpdate()
                }
            };
            _proto._optionChangedCore = function(args) {
                var _this14 = this;
                switch (args.name) {
                    case "readOnly":
                    case "disabled":
                        this._updateReadOnlyState();
                        this._invalidate();
                        break;
                    case "zoomLevel":
                        if ("zoomLevel" === args.fullName || "zoomLevel.items" === args.fullName || "zoomLevel.value" === args.fullName) {
                            this._updateZoomLevelState()
                        }
                        break;
                    case "autoZoomMode":
                        this._updateAutoZoomState();
                        break;
                    case "simpleView":
                        this._updateSimpleViewState();
                        break;
                    case "fullScreen":
                        this._updateFullscreenState();
                        break;
                    case "showGrid":
                        this._updateShowGridState();
                        break;
                    case "snapToGrid":
                        this._updateSnapToGridState();
                        break;
                    case "gridSize":
                        if ("gridSize" === args.fullName || "gridSize.items" === args.fullName || "gridSize.value" === args.fullName) {
                            this._updateGridSizeState()
                        }
                        break;
                    case "viewUnits":
                        this._updateViewUnitsState();
                        break;
                    case "units":
                        this._updateUnitsState();
                        break;
                    case "pageSize":
                        if ("pageSize" === args.fullName || "pageSize.items" === args.fullName) {
                            this._updatePageSizeItemsState()
                        }
                        if ("pageSize" === args.fullName || "pageSize.width" === args.fullName || "pageSize.height" === args.fullName) {
                            this._updatePageSizeState()
                        }
                        break;
                    case "pageOrientation":
                        this._updatePageOrientationState();
                        break;
                    case "pageColor":
                        this._updatePageColorState();
                        break;
                    case "nodes":
                        if ("nodes.autoLayout" === args.fullName) {
                            this._refreshDataSources()
                        } else {
                            this._refreshNodesDataSource()
                        }
                        break;
                    case "edges":
                        this._refreshEdgesDataSource();
                        break;
                    case "customShapes":
                        this._updateCustomShapes(args.value, args.previousValue);
                        this._invalidate();
                        break;
                    case "contextMenu":
                        if ("contextMenu.commands" === args.fullName) {
                            this._invalidateContextMenuCommands()
                        } else {
                            this._invalidate()
                        }
                        break;
                    case "contextToolbox":
                        this._invalidate();
                        break;
                    case "propertiesPanel":
                        if ("propertiesPanel.tabs" === args.name) {
                            this._invalidatePropertiesPanelTabs()
                        } else {
                            this._invalidate()
                        }
                        break;
                    case "toolbox":
                        if ("toolbox.groups" === args.fullName) {
                            this._invalidateToolboxGroups()
                        } else {
                            this._invalidate()
                        }
                        break;
                    case "mainToolbar":
                        if ("mainToolbar.commands" === args.fullName) {
                            this._invalidateMainToolbarCommands()
                        } else {
                            this._invalidate()
                        }
                        break;
                    case "historyToolbar":
                        if ("historyToolbar.commands" === args.fullName) {
                            this._invalidateHistoryToolbarCommands()
                        } else {
                            this._invalidate()
                        }
                        break;
                    case "viewToolbar":
                        if ("viewToolbar.commands" === args.fullName) {
                            this._invalidateViewToolbarCommands()
                        } else {
                            this._invalidate()
                        }
                        break;
                    case "onItemClick":
                        this._createItemClickAction();
                        break;
                    case "onItemDblClick":
                        this._createItemDblClickAction();
                        break;
                    case "onSelectionChanged":
                        this._createSelectionChangedAction();
                        break;
                    case "onRequestEditOperation":
                        this._createRequestEditOperationAction();
                        break;
                    case "onRequestLayoutUpdate":
                        this._createRequestLayoutUpdateAction();
                        break;
                    case "onCustomCommand":
                        this._createCustomCommand();
                        break;
                    case "defaultItemProperties":
                        this._updateDefaultItemProperties();
                        break;
                    case "editing":
                        this._updateEditingSettings();
                        break;
                    case "export":
                        this._toolbars.forEach(function(toolbar) {
                            toolbar.option("export", _this14.option("export"))
                        });
                        if (this._contextMenu) {
                            this._contextMenu.option("export", this.option("export"))
                        }
                        break;
                    case "hasChanges":
                        break;
                    default:
                        _Widget.prototype._optionChanged.call(this, args)
                }
            };
            return Diagram
        }(_ui.default);
        (0, _component_registrator.default)("dxDiagram", Diagram);
        var _default = Diagram;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************!*\
      !*** external "window.DevExpress.diagram" ***!
      \********************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports) {
        module.exports = window.DevExpress.diagram
    },
    /*!************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/diagram/ui.diagram.main_toolbar.js ***!
      \************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiDiagram = _interopRequireDefault(__webpack_require__( /*! ./ui.diagram.toolbar */ 186));
        var _diagram = _interopRequireDefault(__webpack_require__( /*! ./diagram.commands_manager */ 142));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var DiagramMainToolbar = function(_DiagramToolbar) {
            _inheritsLoose(DiagramMainToolbar, _DiagramToolbar);

            function DiagramMainToolbar() {
                return _DiagramToolbar.apply(this, arguments) || this
            }
            var _proto = DiagramMainToolbar.prototype;
            _proto._getCommands = function() {
                return _diagram.default.getMainToolbarCommands(this.option("commands"), this.option("excludeCommands"))
            };
            return DiagramMainToolbar
        }(_uiDiagram.default);
        var _default = DiagramMainToolbar;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/diagram/ui.diagram.history_toolbar.js ***!
      \***************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiDiagram = _interopRequireDefault(__webpack_require__( /*! ./ui.diagram.toolbar */ 186));
        var _diagram = _interopRequireDefault(__webpack_require__( /*! ./diagram.commands_manager */ 142));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var DiagramHistoryToolbar = function(_DiagramToolbar) {
            _inheritsLoose(DiagramHistoryToolbar, _DiagramToolbar);

            function DiagramHistoryToolbar() {
                return _DiagramToolbar.apply(this, arguments) || this
            }
            var _proto = DiagramHistoryToolbar.prototype;
            _proto._getCommands = function() {
                return _diagram.default.getHistoryToolbarCommands(this.option("commands"), this._getExcludeCommands())
            };
            _proto._getExcludeCommands = function() {
                var commands = [].concat(this.option("excludeCommands"));
                if (!this.option("isMobileView")) {
                    commands.push(_diagram.default.SHOW_TOOLBOX_COMMAND_NAME)
                }
                return commands
            };
            return DiagramHistoryToolbar
        }(_uiDiagram.default);
        var _default = DiagramHistoryToolbar;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/diagram/ui.diagram.view_toolbar.js ***!
      \************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiDiagram = _interopRequireDefault(__webpack_require__( /*! ./ui.diagram.toolbar */ 186));
        var _diagram = _interopRequireDefault(__webpack_require__( /*! ./diagram.commands_manager */ 142));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var DiagramViewToolbar = function(_DiagramToolbar) {
            _inheritsLoose(DiagramViewToolbar, _DiagramToolbar);

            function DiagramViewToolbar() {
                return _DiagramToolbar.apply(this, arguments) || this
            }
            var _proto = DiagramViewToolbar.prototype;
            _proto._getCommands = function() {
                return _diagram.default.getViewToolbarCommands(this.option("commands"), this.option("excludeCommands"))
            };
            return DiagramViewToolbar
        }(_uiDiagram.default);
        var _default = DiagramViewToolbar;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/diagram/ui.diagram.properties_toolbar.js ***!
      \******************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _uiDiagram = _interopRequireDefault(__webpack_require__( /*! ./ui.diagram.toolbar */ 186));
        var _diagram = _interopRequireDefault(__webpack_require__( /*! ./diagram.commands_manager */ 142));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var DiagramPropertiesToolbar = function(_DiagramToolbar) {
            _inheritsLoose(DiagramPropertiesToolbar, _DiagramToolbar);

            function DiagramPropertiesToolbar() {
                return _DiagramToolbar.apply(this, arguments) || this
            }
            var _proto = DiagramPropertiesToolbar.prototype;
            _proto._getCommands = function() {
                return _diagram.default.getPropertiesToolbarCommands()
            };
            return DiagramPropertiesToolbar
        }(_uiDiagram.default);
        var _default = DiagramPropertiesToolbar;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/diagram/ui.diagram.context_menu.js ***!
      \************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _context_menu = _interopRequireDefault(__webpack_require__( /*! ../context_menu */ 107));
        var _diagram = _interopRequireDefault(__webpack_require__( /*! ./diagram.commands_manager */ 142));
        var _uiDiagram = _interopRequireDefault(__webpack_require__( /*! ./ui.diagram.menu_helper */ 457));
        var _diagram2 = _interopRequireDefault(__webpack_require__( /*! ./diagram.bar */ 307));
        var _diagram3 = __webpack_require__( /*! ./diagram.importer */ 98);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var DIAGRAM_TOUCHBAR_CLASS = "dx-diagram-touchbar";
        var DIAGRAM_TOUCHBAR_OVERLAY_CLASS = "dx-diagram-touchbar-overlay";
        var DIAGRAM_TOUCHBAR_TARGET_CLASS = "dx-diagram-touchbar-target";
        var DIAGRAM_TOUCHBAR_MIN_UNWRAPPED_WIDTH = 800;
        var DIAGRAM_TOUCHBAR_Y_OFFSET = 32;
        var DiagramContextMenuWrapper = function(_Widget) {
            _inheritsLoose(DiagramContextMenuWrapper, _Widget);

            function DiagramContextMenuWrapper() {
                return _Widget.apply(this, arguments) || this
            }
            var _proto = DiagramContextMenuWrapper.prototype;
            _proto._init = function() {
                _Widget.prototype._init.call(this);
                this._createOnVisibilityChangingAction();
                this._createOnInternalCommand();
                this._createOnCustomCommand();
                this._createOnItemClickAction();
                this._tempState = void 0;
                this._commands = [];
                this._commandToIndexMap = {};
                this.bar = new DiagramContextMenuBar(this)
            };
            _proto._initMarkup = function() {
                var _this = this;
                _Widget.prototype._initMarkup.call(this);
                this._commands = this._getCommands();
                this._commandToIndexMap = {};
                this._fillCommandToIndexMap(this._commands, []);
                this._$contextMenuTargetElement = (0, _renderer.default)("<div>").addClass(DIAGRAM_TOUCHBAR_TARGET_CLASS).appendTo(this.$element());
                var $contextMenu = (0, _renderer.default)("<div>").appendTo(this.$element());
                this._contextMenuInstance = this._createComponent($contextMenu, DiagramContextMenu, {
                    isTouchBarMode: this._isTouchBarMode(),
                    cssClass: this._isTouchBarMode() ? DIAGRAM_TOUCHBAR_CLASS : _uiDiagram.default.getContextMenuCssClass(),
                    closeOnOutsideClick: false,
                    showEvent: "",
                    focusStateEnabled: false,
                    items: this._commands,
                    position: this._isTouchBarMode() ? {
                        my: {
                            x: "center",
                            y: "bottom"
                        },
                        at: {
                            x: "center",
                            y: "top"
                        },
                        of: this._$contextMenuTargetElement
                    } : {},
                    itemTemplate: function(itemData, itemIndex, itemElement) {
                        _uiDiagram.default.getContextMenuItemTemplate(this, itemData, itemIndex, itemElement)
                    },
                    onItemClick: function(_ref) {
                        var itemData = _ref.itemData;
                        return _this._onItemClick(itemData)
                    },
                    onShowing: function(e) {
                        if (true === _this._inOnShowing) {
                            return
                        }
                        _this._inOnShowing = true;
                        _this._onVisibilityChangingAction({
                            visible: true,
                            component: _this
                        });
                        e.component.option("items", e.component.option("items"));
                        delete _this._inOnShowing
                    }
                })
            };
            _proto._show = function(x, y, selection) {
                this._contextMenuInstance.hide();
                if (this._isTouchBarMode()) {
                    this._$contextMenuTargetElement.show();
                    if (!selection) {
                        selection = {
                            x: x,
                            y: y,
                            width: 0,
                            height: 0
                        }
                    }
                    var widthCorrection = selection.width > DIAGRAM_TOUCHBAR_MIN_UNWRAPPED_WIDTH ? 0 : (DIAGRAM_TOUCHBAR_MIN_UNWRAPPED_WIDTH - selection.width) / 2;
                    this._$contextMenuTargetElement.css({
                        left: selection.x - widthCorrection,
                        top: selection.y - DIAGRAM_TOUCHBAR_Y_OFFSET,
                        width: selection.width + 2 * widthCorrection,
                        height: selection.height + 2 * DIAGRAM_TOUCHBAR_Y_OFFSET
                    });
                    this._contextMenuInstance.show()
                } else {
                    this._contextMenuInstance.option("position", {
                        offset: x + " " + y
                    });
                    this._contextMenuInstance.show()
                }
            };
            _proto._hide = function() {
                this._$contextMenuTargetElement.hide();
                this._contextMenuInstance.hide()
            };
            _proto._isTouchBarMode = function() {
                var _getDiagram = (0, _diagram3.getDiagram)(),
                    Browser = _getDiagram.Browser;
                return Browser.TouchUI
            };
            _proto._onItemClick = function(itemData) {
                var processed = false;
                if (this._onItemClickAction) {
                    processed = this._onItemClickAction(itemData)
                }
                if (!processed) {
                    _uiDiagram.default.onContextMenuItemClick(this, itemData, this._executeCommand.bind(this));
                    this._contextMenuInstance.hide()
                }
            };
            _proto._executeCommand = function(command, name, value) {
                if ("number" === typeof command) {
                    this.bar.raiseBarCommandExecuted(command, value)
                } else {
                    if ("string" === typeof command) {
                        this._onInternalCommandAction({
                            command: command
                        })
                    }
                }
                if (void 0 !== name) {
                    this._onCustomCommandAction({
                        name: name
                    })
                }
            };
            _proto._createOnInternalCommand = function() {
                this._onInternalCommandAction = this._createActionByOption("onInternalCommand")
            };
            _proto._createOnCustomCommand = function() {
                this._onCustomCommandAction = this._createActionByOption("onCustomCommand")
            };
            _proto._getCommands = function() {
                return _diagram.default.getContextMenuCommands(this.option("commands"))
            };
            _proto._fillCommandToIndexMap = function(commands, indexPath) {
                var _this2 = this;
                commands.forEach(function(command, index) {
                    var commandIndexPath = indexPath.concat([index]);
                    if (void 0 !== command.command) {
                        _this2._commandToIndexMap[command.command] = commandIndexPath
                    }
                    if (Array.isArray(command.items)) {
                        _this2._fillCommandToIndexMap(command.items, commandIndexPath)
                    }
                })
            };
            _proto._setItemEnabled = function(key, enabled) {
                this._setItemVisible(key, enabled)
            };
            _proto._setItemVisible = function(key, visible) {
                var itemOptionText = _uiDiagram.default.getItemOptionText(this._contextMenuInstance, this._commandToIndexMap[key]);
                _uiDiagram.default.updateContextMenuItemVisible(this._contextMenuInstance, itemOptionText, visible)
            };
            _proto._setItemValue = function(key, value) {
                var itemOptionText = _uiDiagram.default.getItemOptionText(this._contextMenuInstance, this._commandToIndexMap[key]);
                _uiDiagram.default.updateContextMenuItemValue(this._contextMenuInstance, itemOptionText, key, value)
            };
            _proto._setItemSubItems = function(key, items) {
                var itemOptionText = _uiDiagram.default.getItemOptionText(this._contextMenuInstance, this._commandToIndexMap[key]);
                _uiDiagram.default.updateContextMenuItems(this._contextMenuInstance, itemOptionText, key, items)
            };
            _proto._setEnabled = function(enabled) {
                this._contextMenuInstance.option("disabled", !enabled)
            };
            _proto.isVisible = function() {
                return this._inOnShowing
            };
            _proto._createOnVisibilityChangingAction = function() {
                this._onVisibilityChangingAction = this._createActionByOption("onVisibilityChanging")
            };
            _proto._createOnItemClickAction = function() {
                this._onItemClickAction = this._createActionByOption("onItemClick")
            };
            _proto._optionChanged = function(args) {
                switch (args.name) {
                    case "onVisibilityChanging":
                        this._createOnVisibilityChangingAction();
                        break;
                    case "onInternalCommand":
                        this._createOnInternalCommand();
                        break;
                    case "onCustomCommand":
                        this._createOnCustomCommand();
                        break;
                    case "onItemClick":
                        this._createOnItemClickAction();
                        break;
                    case "commands":
                        this._invalidate();
                        break;
                    case "export":
                        break;
                    default:
                        _Widget.prototype._optionChanged.call(this, args)
                }
            };
            return DiagramContextMenuWrapper
        }(_ui.default);
        var DiagramContextMenu = function(_ContextMenu) {
            _inheritsLoose(DiagramContextMenu, _ContextMenu);

            function DiagramContextMenu() {
                return _ContextMenu.apply(this, arguments) || this
            }
            var _proto2 = DiagramContextMenu.prototype;
            _proto2._renderContextMenuOverlay = function() {
                var _this3 = this;
                _ContextMenu.prototype._renderContextMenuOverlay.call(this);
                if (this._overlay && this.option("isTouchBarMode")) {
                    this._overlay && this._overlay.option("onShown", function() {
                        var $content = (0, _renderer.default)(_this3._overlay.$content());
                        $content.parent().addClass(DIAGRAM_TOUCHBAR_OVERLAY_CLASS)
                    })
                }
            };
            return DiagramContextMenu
        }(_context_menu.default);
        var DiagramContextMenuBar = function(_DiagramBar) {
            _inheritsLoose(DiagramContextMenuBar, _DiagramBar);

            function DiagramContextMenuBar(owner) {
                return _DiagramBar.call(this, owner) || this
            }
            var _proto3 = DiagramContextMenuBar.prototype;
            _proto3.getCommandKeys = function() {
                return this._getKeys(this._owner._commands)
            };
            _proto3.setItemValue = function(key, value) {
                this._owner._setItemValue(key, value)
            };
            _proto3.setItemEnabled = function(key, enabled) {
                this._owner._setItemEnabled(key, enabled)
            };
            _proto3.setItemVisible = function(key, visible) {
                this._owner._setItemVisible(key, visible)
            };
            _proto3.setItemSubItems = function(key, items) {
                this._owner._setItemSubItems(key, items)
            };
            _proto3.setEnabled = function(enabled) {
                this._owner._setEnabled(enabled)
            };
            _proto3.isVisible = function() {
                return this._owner.isVisible()
            };
            return DiagramContextMenuBar
        }(_diagram2.default);
        var _default = {
            DiagramContextMenuWrapper: DiagramContextMenuWrapper,
            DiagramContextMenu: DiagramContextMenu
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/diagram/ui.diagram.context_toolbox.js ***!
      \***************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _popover = _interopRequireDefault(__webpack_require__( /*! ../popover */ 135));
        var _diagram = __webpack_require__( /*! ./diagram.importer */ 98);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var DIAGRAM_CONTEXT_TOOLBOX_TARGET_CLASS = "dx-diagram-context-toolbox-target";
        var DIAGRAM_CONTEXT_TOOLBOX_CLASS = "dx-diagram-context-toolbox";
        var DIAGRAM_TOUCH_CONTEXT_TOOLBOX_CLASS = "dx-diagram-touch-context-toolbox";
        var DIAGRAM_CONTEXT_TOOLBOX_CONTENT_CLASS = "dx-diagram-context-toolbox-content";
        var DiagramContextToolbox = function(_Widget) {
            _inheritsLoose(DiagramContextToolbox, _Widget);

            function DiagramContextToolbox() {
                return _Widget.apply(this, arguments) || this
            }
            var _proto = DiagramContextToolbox.prototype;
            _proto._init = function() {
                _Widget.prototype._init.call(this);
                this._onShownAction = this._createActionByOption("onShown");
                this._popoverPositionData = [{
                    my: {
                        x: "center",
                        y: "top"
                    },
                    at: {
                        x: "center",
                        y: "bottom"
                    },
                    offset: {
                        x: 0,
                        y: 5
                    }
                }, {
                    my: {
                        x: "right",
                        y: "center"
                    },
                    at: {
                        x: "left",
                        y: "center"
                    },
                    offset: {
                        x: -5,
                        y: 0
                    }
                }, {
                    my: {
                        x: "center",
                        y: "bottom"
                    },
                    at: {
                        x: "center",
                        y: "top"
                    },
                    offset: {
                        x: 0,
                        y: -5
                    }
                }, {
                    my: {
                        x: "left",
                        y: "center"
                    },
                    at: {
                        x: "right",
                        y: "center"
                    },
                    offset: {
                        x: 5,
                        y: 0
                    }
                }]
            };
            _proto._initMarkup = function() {
                _Widget.prototype._initMarkup.call(this);
                this._$popoverTargetElement = (0, _renderer.default)("<div>").addClass(DIAGRAM_CONTEXT_TOOLBOX_TARGET_CLASS).appendTo(this.$element());
                var $popoverElement = (0, _renderer.default)("<div>").appendTo(this.$element());
                var _getDiagram = (0, _diagram.getDiagram)(),
                    Browser = _getDiagram.Browser;
                var popoverClass = DIAGRAM_CONTEXT_TOOLBOX_CLASS;
                if (Browser.TouchUI) {
                    popoverClass += " " + DIAGRAM_TOUCH_CONTEXT_TOOLBOX_CLASS
                }
                this._popoverInstance = this._createComponent($popoverElement, _popover.default, {
                    closeOnOutsideClick: false,
                    container: this.$element(),
                    elementAttr: {
                        "class": popoverClass
                    }
                })
            };
            _proto._show = function(x, y, side, category, callback) {
                this._popoverInstance.hide();
                var $content = (0, _renderer.default)("<div>").addClass(DIAGRAM_CONTEXT_TOOLBOX_CONTENT_CLASS);
                if (void 0 !== this.option("toolboxWidth")) {
                    $content.css("width", this.option("toolboxWidth"))
                }
                this._$popoverTargetElement.css({
                    left: x + this._popoverPositionData[side].offset.x,
                    top: y + this._popoverPositionData[side].offset.y
                }).show();
                this._popoverInstance.option({
                    position: {
                        my: this._popoverPositionData[side].my,
                        at: this._popoverPositionData[side].at,
                        of: this._$popoverTargetElement
                    },
                    contentTemplate: $content,
                    onContentReady: function() {
                        var _this = this;
                        var $element = this.$element().find("." + DIAGRAM_CONTEXT_TOOLBOX_CONTENT_CLASS);
                        this._onShownAction({
                            category: category,
                            callback: callback,
                            $element: $element,
                            hide: function() {
                                return _this._popoverInstance.hide()
                            }
                        })
                    }.bind(this)
                });
                this._popoverInstance.show()
            };
            _proto._hide = function() {
                this._$popoverTargetElement.hide();
                this._popoverInstance.hide()
            };
            return DiagramContextToolbox
        }(_ui.default);
        var _default = DiagramContextToolbox;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/diagram/ui.diagram.dialogs.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _popup = _interopRequireDefault(__webpack_require__( /*! ../popup */ 46));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var DiagramDialog = function(_Widget) {
            _inheritsLoose(DiagramDialog, _Widget);

            function DiagramDialog() {
                return _Widget.apply(this, arguments) || this
            }
            var _proto = DiagramDialog.prototype;
            _proto._init = function() {
                _Widget.prototype._init.call(this);
                this._command = void 0;
                this._isShown = false;
                this._createOnGetContentOption();
                this._createOnHiddenOption()
            };
            _proto._initMarkup = function() {
                _Widget.prototype._initMarkup.call(this);
                this._command = this.option("command");
                this._$popupElement = (0, _renderer.default)("<div>").appendTo(this.$element());
                this._popup = this._createComponent(this._$popupElement, _popup.default, {
                    title: this.option("title"),
                    maxWidth: this.option("maxWidth"),
                    height: this.option("height"),
                    toolbarItems: this.option("toolbarItems"),
                    onHidden: this._onHiddenAction
                })
            };
            _proto._clean = function() {
                delete this._popup;
                this._$popupElement && this._$popupElement.remove()
            };
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_Widget.prototype._getDefaultOptions.call(this), {
                    title: "",
                    maxWidth: 500,
                    height: "auto",
                    toolbarItems: this._getToolbarItems()
                })
            };
            _proto._getToolbarItems = function() {
                return [this._getOkToolbarItem(), this._getCancelToolbarItem()]
            };
            _proto._getOkToolbarItem = function() {
                return {
                    widget: "dxButton",
                    location: "after",
                    toolbar: "bottom",
                    options: {
                        text: _message.default.format("dxDiagram-dialogButtonOK"),
                        onClick: function() {
                            this._command.execute(this._commandParameter);
                            this._hide()
                        }.bind(this)
                    }
                }
            };
            _proto._getCancelToolbarItem = function() {
                return {
                    widget: "dxButton",
                    location: "after",
                    toolbar: "bottom",
                    options: {
                        text: _message.default.format("dxDiagram-dialogButtonCancel"),
                        onClick: this._hide.bind(this)
                    }
                }
            };
            _proto._optionChanged = function(args) {
                switch (args.name) {
                    case "title":
                    case "maxWidth":
                    case "height":
                    case "toolbarItems":
                        this._popup.option(args.name, args.value);
                        break;
                    case "command":
                        this._command = args.value;
                        break;
                    case "onGetContent":
                        this._createOnGetContentOption();
                        break;
                    case "onHidden":
                        this._createOnHiddenOption();
                        break;
                    default:
                        _Widget.prototype._optionChanged.call(this, args)
                }
            };
            _proto._createOnGetContentOption = function() {
                this._onGetContentAction = this._createActionByOption("onGetContent")
            };
            _proto._createOnHiddenOption = function() {
                this._onHiddenAction = this._createActionByOption("onHidden")
            };
            _proto._hide = function() {
                this._popup.hide();
                this._isShown = false
            };
            _proto._show = function() {
                this._popup.$content().empty().append(this._onGetContentAction());
                this._popup.show();
                this._isShown = true
            };
            _proto.isVisible = function() {
                return this._isShown
            };
            return DiagramDialog
        }(_ui.default);
        var _default = DiagramDialog;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/diagram/ui.diagram.scroll_view.js ***!
      \***********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _scroll_view = _interopRequireDefault(__webpack_require__( /*! ../scroll_view */ 90));
        var _diagram = __webpack_require__( /*! ./diagram.importer */ 98);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var DiagramScrollView = function(_Widget) {
            _inheritsLoose(DiagramScrollView, _Widget);

            function DiagramScrollView() {
                return _Widget.apply(this, arguments) || this
            }
            var _proto = DiagramScrollView.prototype;
            _proto._init = function() {
                _Widget.prototype._init.call(this);
                var _getDiagram = (0, _diagram.getDiagram)(),
                    EventDispatcher = _getDiagram.EventDispatcher;
                this.onScroll = new EventDispatcher;
                this._createOnCreateDiagramAction()
            };
            _proto._initMarkup = function() {
                var _this = this;
                _Widget.prototype._initMarkup.call(this);
                var $scrollViewWrapper = (0, _renderer.default)("<div>").appendTo(this.$element());
                this._scrollView = this._createComponent($scrollViewWrapper, _scroll_view.default, {
                    direction: "both",
                    bounceEnabled: false,
                    onScroll: function(_ref) {
                        var scrollOffset = _ref.scrollOffset;
                        _this._raiseOnScroll(scrollOffset.left, scrollOffset.top)
                    }
                });
                this._onCreateDiagramAction({
                    $parent: (0, _renderer.default)(this._scrollView.content()),
                    scrollView: this
                })
            };
            _proto.setScroll = function(left, top) {
                this._scrollView.scrollTo({
                    left: left,
                    top: top
                });
                this._raiseOnScrollWithoutPoint()
            };
            _proto.offsetScroll = function(left, top) {
                this._scrollView.scrollBy({
                    left: left,
                    top: top
                });
                this._raiseOnScrollWithoutPoint()
            };
            _proto.getSize = function() {
                var _getDiagram2 = (0, _diagram.getDiagram)(),
                    Size = _getDiagram2.Size;
                var $element = this._scrollView.$element();
                return new Size(Math.floor($element.width()), Math.floor($element.height()))
            };
            _proto.getScrollContainer = function() {
                return this._scrollView.$element()[0]
            };
            _proto.getScrollBarWidth = function() {
                return 0
            };
            _proto.detachEvents = function() {};
            _proto._raiseOnScroll = function(left, top) {
                var _getDiagram3 = (0, _diagram.getDiagram)(),
                    Point = _getDiagram3.Point;
                this.onScroll.raise("notifyScrollChanged", function() {
                    return new Point(left, top)
                })
            };
            _proto._raiseOnScrollWithoutPoint = function() {
                var _this2 = this;
                var _getDiagram4 = (0, _diagram.getDiagram)(),
                    Point = _getDiagram4.Point;
                this.onScroll.raise("notifyScrollChanged", function() {
                    return new Point(_this2._scrollView.scrollLeft(), _this2._scrollView.scrollTop())
                })
            };
            _proto._createOnCreateDiagramAction = function() {
                this._onCreateDiagramAction = this._createActionByOption("onCreateDiagram")
            };
            _proto._optionChanged = function(args) {
                switch (args.name) {
                    case "onCreateDiagram":
                        this._createOnCreateDiagramAction();
                        break;
                    default:
                        _Widget.prototype._optionChanged.call(this, args)
                }
            };
            return DiagramScrollView
        }(_ui.default);
        var _default = DiagramScrollView;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/diagram/diagram.toolbox_manager.js ***!
      \************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DiagramToolboxManager = {
            getDefaultGroups: function() {
                return this._groups || (this._groups = {
                    general: {
                        category: "general",
                        title: _message.default.format("dxDiagram-categoryGeneral")
                    },
                    flowchart: {
                        category: "flowchart",
                        title: _message.default.format("dxDiagram-categoryFlowchart")
                    },
                    orgChart: {
                        category: "orgChart",
                        title: _message.default.format("dxDiagram-categoryOrgChart")
                    },
                    containers: {
                        category: "containers",
                        title: _message.default.format("dxDiagram-categoryContainers")
                    },
                    custom: {
                        category: "custom",
                        title: _message.default.format("dxDiagram-categoryCustom")
                    }
                })
            },
            getGroups: function(groups) {
                var defaultGroups = this.getDefaultGroups();
                if (groups) {
                    return groups.map(function(g) {
                        if ("string" === typeof g) {
                            return {
                                category: g,
                                title: defaultGroups[g] && defaultGroups[g].title || g
                            }
                        }
                        return g
                    }).filter(function(g) {
                        return g
                    })
                }
                return [defaultGroups.general, defaultGroups.flowchart, defaultGroups.orgChart, defaultGroups.containers]
            }
        };
        var _default = DiagramToolboxManager;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/diagram/ui.diagram.toolbox.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _text_box = _interopRequireDefault(__webpack_require__( /*! ../text_box */ 97));
        var _accordion = _interopRequireDefault(__webpack_require__( /*! ../accordion */ 374));
        var _scroll_view = _interopRequireDefault(__webpack_require__( /*! ../scroll_view */ 90));
        var _tooltip = _interopRequireDefault(__webpack_require__( /*! ../tooltip */ 217));
        var _diagram = __webpack_require__( /*! ./diagram.importer */ 98);
        var _uiDiagram = _interopRequireDefault(__webpack_require__( /*! ./ui.diagram.floating_panel */ 458));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var DIAGRAM_TOOLBOX_MIN_HEIGHT = 130;
        var DIAGRAM_TOOLBOX_POPUP_CLASS = "dx-diagram-toolbox-popup";
        var DIAGRAM_TOOLBOX_PANEL_CLASS = "dx-diagram-toolbox-panel";
        var DIAGRAM_TOOLBOX_INPUT_CONTAINER_CLASS = "dx-diagram-toolbox-input-container";
        var DIAGRAM_TOOLBOX_INPUT_CLASS = "dx-diagram-toolbox-input";
        var DIAGRAM_TOOLTIP_DATATOGGLE = "shape-toolbox-tooltip";
        var DIAGRAM_SKIP_GESTURE_CLASS = "dx-skip-gesture-event";
        var DiagramToolbox = function(_DiagramFloatingPanel) {
            _inheritsLoose(DiagramToolbox, _DiagramFloatingPanel);

            function DiagramToolbox() {
                return _DiagramFloatingPanel.apply(this, arguments) || this
            }
            var _proto = DiagramToolbox.prototype;
            _proto._init = function() {
                _DiagramFloatingPanel.prototype._init.call(this);
                this._toolboxes = [];
                this._filterText = "";
                this._createOnShapeCategoryRenderedAction();
                this._createOnFilterChangedAction()
            };
            _proto._getPopupClass = function() {
                return DIAGRAM_TOOLBOX_POPUP_CLASS
            };
            _proto._getPopupHeight = function() {
                return this.isMobileView() ? "100%" : _DiagramFloatingPanel.prototype._getPopupHeight.call(this)
            };
            _proto._getPopupMaxHeight = function() {
                return this.isMobileView() ? "100%" : _DiagramFloatingPanel.prototype._getPopupMaxHeight.call(this)
            };
            _proto._getPopupMinHeight = function() {
                return DIAGRAM_TOOLBOX_MIN_HEIGHT
            };
            _proto._getPopupPosition = function() {
                var $parent = this.option("offsetParent");
                var position = {
                    my: "left top",
                    at: "left top",
                    of: $parent
                };
                if (!this.isMobileView()) {
                    return (0, _extend.extend)(position, {
                        offset: this.option("offsetX") + " " + this.option("offsetY")
                    })
                }
                return position
            };
            _proto._getPopupAnimation = function() {
                var $parent = this.option("offsetParent");
                if (this.isMobileView()) {
                    return {
                        hide: this._getPopupSlideAnimationObject({
                            direction: "left",
                            from: {
                                position: {
                                    my: "left top",
                                    at: "left top",
                                    of: $parent
                                }
                            },
                            to: {
                                position: {
                                    my: "right top",
                                    at: "left top",
                                    of: $parent
                                }
                            }
                        }),
                        show: this._getPopupSlideAnimationObject({
                            direction: "right",
                            from: {
                                position: {
                                    my: "right top",
                                    at: "left top",
                                    of: $parent
                                }
                            },
                            to: {
                                position: {
                                    my: "left top",
                                    at: "left top",
                                    of: $parent
                                }
                            }
                        })
                    }
                }
                return _DiagramFloatingPanel.prototype._getPopupAnimation.call(this)
            };
            _proto._getPopupOptions = function() {
                var options = _DiagramFloatingPanel.prototype._getPopupOptions.call(this);
                if (!this.isMobileView()) {
                    return (0, _extend.extend)(options, {
                        showTitle: true,
                        toolbarItems: [{
                            widget: "dxButton",
                            location: "center",
                            options: {
                                activeStateEnabled: false,
                                focusStateEnabled: false,
                                hoverStateEnabled: false,
                                icon: "diagram-toolbox-drag",
                                stylingMode: "outlined",
                                type: "normal"
                            }
                        }]
                    })
                }
                return options
            };
            _proto._renderPopupContent = function($parent) {
                var panelHeight = "100%";
                if (this.option("showSearch")) {
                    var $inputContainer = (0, _renderer.default)("<div>").addClass(DIAGRAM_TOOLBOX_INPUT_CONTAINER_CLASS).appendTo($parent);
                    this._updateElementWidth($inputContainer);
                    this._renderSearchInput($inputContainer);
                    if ((0, _window.hasWindow)()) {
                        panelHeight = "calc(100% - " + this._searchInput.$element().height() + "px)"
                    }
                }
                var $panel = (0, _renderer.default)("<div>").addClass(DIAGRAM_TOOLBOX_PANEL_CLASS).appendTo($parent).height(panelHeight);
                this._updateElementWidth($panel);
                this._renderScrollView($panel)
            };
            _proto._updateElementWidth = function($element) {
                if (void 0 !== this.option("toolboxWidth")) {
                    $element.css("width", this.option("toolboxWidth"))
                }
            };
            _proto.updateMaxHeight = function() {
                if (this.isMobileView()) {
                    return
                }
                var maxHeight = 6;
                if (this._popup) {
                    var $title = this._getPopupTitle();
                    maxHeight += $title.outerHeight()
                }
                if (this._accordion) {
                    maxHeight += this._accordion.$element().outerHeight()
                }
                if (this._searchInput) {
                    maxHeight += this._searchInput.$element().outerHeight()
                }
                this.option("maxHeight", maxHeight)
            };
            _proto._renderSearchInput = function($parent) {
                var _this = this;
                var $input = (0, _renderer.default)("<div>").addClass(DIAGRAM_TOOLBOX_INPUT_CLASS).appendTo($parent);
                this._searchInput = this._createComponent($input, _text_box.default, {
                    stylingMode: "outlined",
                    placeholder: _message.default.format("dxDiagram-uiSearch"),
                    onValueChanged: function(data) {
                        _this._onInputChanged(data.value)
                    },
                    valueChangeEvent: "keyup",
                    buttons: [{
                        name: "search",
                        location: "after",
                        options: {
                            activeStateEnabled: false,
                            focusStateEnabled: false,
                            hoverStateEnabled: false,
                            icon: "search",
                            stylingMode: "outlined",
                            type: "normal",
                            onClick: function() {
                                _this._searchInput.focus()
                            }
                        }
                    }]
                })
            };
            _proto._renderScrollView = function($parent) {
                var $scrollViewWrapper = (0, _renderer.default)("<div>").appendTo($parent);
                this._scrollView = this._createComponent($scrollViewWrapper, _scroll_view.default);
                var $accordion = (0, _renderer.default)("<div>").appendTo(this._scrollView.content());
                this._updateElementWidth($accordion);
                this._renderAccordion($accordion)
            };
            _proto._getAccordionDataSource = function() {
                var _this2 = this;
                var result = [];
                var toolboxGroups = this.option("toolboxGroups");
                for (var i = 0; i < toolboxGroups.length; i++) {
                    var category = toolboxGroups[i].category;
                    var title = toolboxGroups[i].title;
                    var groupObj = {
                        category: category,
                        title: title || category,
                        expanded: toolboxGroups[i].expanded,
                        displayMode: toolboxGroups[i].displayMode,
                        shapes: toolboxGroups[i].shapes,
                        onTemplate: function(widget, $element, data) {
                            var $toolboxElement = (0, _renderer.default)($element);
                            _this2._onShapeCategoryRenderedAction({
                                category: data.category,
                                displayMode: data.displayMode,
                                dataToggle: DIAGRAM_TOOLTIP_DATATOGGLE,
                                shapes: data.shapes,
                                $element: $toolboxElement
                            });
                            _this2._toolboxes.push($toolboxElement);
                            if ("" !== _this2._filterText) {
                                _this2._onFilterChangedAction({
                                    text: _this2._filterText,
                                    filteringToolboxes: _this2._toolboxes.length - 1
                                })
                            }
                            _this2._createTooltips($toolboxElement.find('[data-toggle="' + DIAGRAM_TOOLTIP_DATATOGGLE + '"]'))
                        }
                    };
                    result.push(groupObj)
                }
                return result
            };
            _proto._createTooltips = function(targets) {
                var _this3 = this;
                var _getDiagram = (0, _diagram.getDiagram)(),
                    Browser = _getDiagram.Browser;
                if (Browser.TouchUI) {
                    return
                }
                var $container = this.$element();
                targets.each(function(index, element) {
                    var $target = (0, _renderer.default)(element);
                    var title = $target.attr("title");
                    if (title) {
                        var $tooltip = (0, _renderer.default)("<div>").html(title).appendTo($container);
                        _this3._createComponent($tooltip, _tooltip.default, {
                            target: $target.get(0),
                            showEvent: "mouseenter",
                            hideEvent: "mouseleave",
                            position: "top",
                            animation: {
                                show: {
                                    type: "fade",
                                    from: 0,
                                    to: 1,
                                    delay: 500
                                },
                                hide: {
                                    type: "fade",
                                    from: 1,
                                    to: 0,
                                    delay: 100
                                }
                            }
                        })
                    }
                })
            };
            _proto._renderAccordion = function($container) {
                var _this4 = this;
                var data = this._getAccordionDataSource();
                this._accordion = this._createComponent($container, _accordion.default, {
                    multiple: true,
                    animationDuration: 0,
                    activeStateEnabled: false,
                    focusStateEnabled: false,
                    hoverStateEnabled: false,
                    collapsible: true,
                    displayExpr: "title",
                    dataSource: data,
                    disabled: this.option("disabled"),
                    itemTemplate: function(data, index, $element) {
                        data.onTemplate(_this4, $element, data)
                    },
                    onSelectionChanged: function(e) {
                        _this4._updateScrollAnimateSubscription(e.component)
                    },
                    onContentReady: function(e) {
                        for (var i = 0; i < data.length; i++) {
                            if (false === data[i].expanded) {
                                e.component.collapseItem(i)
                            } else {
                                if (true === data[i].expanded) {
                                    e.component.expandItem(i)
                                }
                            }
                        }
                        _this4._updateScrollAnimateSubscription(e.component)
                    }
                })
            };
            _proto._updateScrollAnimateSubscription = function(component) {
                var _this5 = this;
                component._deferredAnimate = new _deferred.Deferred;
                component._deferredAnimate.done(function() {
                    _this5.updateMaxHeight();
                    _this5._scrollView.update();
                    _this5._updateScrollAnimateSubscription(component)
                })
            };
            _proto._raiseToolboxDragStart = function() {
                this._scrollView.$element().addClass(DIAGRAM_SKIP_GESTURE_CLASS)
            };
            _proto._raiseToolboxDragEnd = function() {
                this._scrollView.$element().removeClass(DIAGRAM_SKIP_GESTURE_CLASS)
            };
            _proto._onInputChanged = function(text) {
                var _this6 = this;
                this._filterText = text;
                this._onFilterChangedAction({
                    text: this._filterText,
                    filteringToolboxes: this._toolboxes.map(function($element, index) {
                        return index
                    })
                });
                this._toolboxes.forEach(function($element) {
                    var $tooltipContainer = (0, _renderer.default)($element);
                    _this6._createTooltips($tooltipContainer.find('[data-toggle="' + DIAGRAM_TOOLTIP_DATATOGGLE + '"]'))
                });
                this.updateMaxHeight();
                this._scrollView.update()
            };
            _proto._createOnShapeCategoryRenderedAction = function() {
                this._onShapeCategoryRenderedAction = this._createActionByOption("onShapeCategoryRendered")
            };
            _proto._createOnFilterChangedAction = function() {
                this._onFilterChangedAction = this._createActionByOption("onFilterChanged")
            };
            _proto._optionChanged = function(args) {
                switch (args.name) {
                    case "onShapeCategoryRendered":
                        this._createOnShapeCategoryRenderedAction();
                        break;
                    case "onFilterChanged":
                        this._createOnFilterChangedAction();
                        break;
                    case "showSearch":
                    case "toolboxWidth":
                        this._invalidate();
                        break;
                    case "toolboxGroups":
                        this._accordion.option("dataSource", this._getAccordionDataSource());
                        break;
                    default:
                        _DiagramFloatingPanel.prototype._optionChanged.call(this, args)
                }
            };
            return DiagramToolbox
        }(_uiDiagram.default);
        var _default = DiagramToolbox;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/diagram/ui.diagram.properties_panel.js ***!
      \****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _scroll_view = _interopRequireDefault(__webpack_require__( /*! ../scroll_view */ 90));
        var _tab_panel = _interopRequireDefault(__webpack_require__( /*! ../tab_panel */ 284));
        var _uiDiagram = _interopRequireDefault(__webpack_require__( /*! ./ui.diagram.floating_panel */ 458));
        var _diagram = _interopRequireDefault(__webpack_require__( /*! ./diagram.commands_manager */ 142));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var DIAGRAM_PROPERTIES_POPUP_WIDTH = 420;
        var DIAGRAM_PROPERTIES_POPUP_HEIGHT = 340;
        var DIAGRAM_PROPERTIES_POPUP_CLASS = "dx-diagram-properties-popup";
        var DIAGRAM_PROPERTIES_POPUP_NOTABS_CLASS = "dx-diagram-properties-popup-notabs";
        var DIAGRAM_PROPERTIES_PANEL_CLASS = "dx-diagram-properties-panel";
        var DIAGRAM_PROPERTIES_PANEL_GROUP_TITLE_CLASS = "dx-diagram-properties-panel-group-title";
        var DIAGRAM_PROPERTIES_PANEL_GROUP_TOOLBAR_CLASS = "dx-diagram-properties-panel-group-toolbar";
        var DiagramPropertiesPanel = function(_DiagramFloatingPanel) {
            _inheritsLoose(DiagramPropertiesPanel, _DiagramFloatingPanel);

            function DiagramPropertiesPanel() {
                return _DiagramFloatingPanel.apply(this, arguments) || this
            }
            var _proto = DiagramPropertiesPanel.prototype;
            _proto._init = function() {
                _DiagramFloatingPanel.prototype._init.call(this);
                this._commandTabs = _diagram.default.getPropertyPanelCommandTabs(this.option("propertyTabs"));
                this._createOnCreateToolbar();
                this._createOnSelectedGroupChanged()
            };
            _proto._initMarkup = function() {
                this._toolbars = [];
                this._selectedToolbar = void 0;
                _DiagramFloatingPanel.prototype._initMarkup.call(this)
            };
            _proto._getPopupClass = function() {
                var className = DIAGRAM_PROPERTIES_POPUP_CLASS;
                if (!this._hasTabPanel()) {
                    className += " " + DIAGRAM_PROPERTIES_POPUP_NOTABS_CLASS
                }
                return className
            };
            _proto._getPopupWidth = function() {
                return this.isMobileView() ? "100%" : DIAGRAM_PROPERTIES_POPUP_WIDTH
            };
            _proto._getPopupHeight = function() {
                return DIAGRAM_PROPERTIES_POPUP_HEIGHT
            };
            _proto._getPopupPosition = function() {
                var $parent = this.option("offsetParent");
                if (this.isMobileView()) {
                    return {
                        my: "left bottom",
                        at: "left bottom",
                        of: $parent
                    }
                }
                return {
                    my: "right bottom",
                    at: "right bottom",
                    of: $parent,
                    offset: "-" + this.option("offsetX") + " -" + this.option("offsetY")
                }
            };
            _proto._getPopupAnimation = function() {
                var $parent = this.option("offsetParent");
                if (this.isMobileView()) {
                    return {
                        hide: this._getPopupSlideAnimationObject({
                            direction: "bottom",
                            from: {
                                position: {
                                    my: "left bottom",
                                    at: "left bottom",
                                    of: $parent
                                }
                            },
                            to: {
                                position: {
                                    my: "left top",
                                    at: "left bottom",
                                    of: $parent
                                }
                            }
                        }),
                        show: this._getPopupSlideAnimationObject({
                            direction: "top",
                            from: {
                                position: {
                                    my: "left top",
                                    at: "left bottom",
                                    of: $parent
                                }
                            },
                            to: {
                                position: {
                                    my: "left bottom",
                                    at: "left bottom",
                                    of: $parent
                                }
                            }
                        })
                    }
                }
                return _DiagramFloatingPanel.prototype._getPopupAnimation.call(this)
            };
            _proto._getPopupOptions = function() {
                return (0, _extend.extend)(_DiagramFloatingPanel.prototype._getPopupOptions.call(this), {
                    showTitle: this.isMobileView(),
                    showCloseButton: this.isMobileView()
                })
            };
            _proto._renderPopupContent = function($parent) {
                if (!this._commandTabs.length) {
                    return
                }
                var $panel = (0, _renderer.default)("<div>").addClass(DIAGRAM_PROPERTIES_PANEL_CLASS).appendTo($parent);
                if (this._hasTabPanel()) {
                    this._renderTabPanel($panel)
                } else {
                    this._renderTabContent($panel, this._commandTabs[0], 0, true)
                }
            };
            _proto._hasTabPanel = function() {
                return this._commandTabs.length > 1
            };
            _proto._renderTabPanel = function($parent) {
                var _this = this;
                var $tabPanel = (0, _renderer.default)("<div>").appendTo($parent);
                this._tabPanel = this._createComponent($tabPanel, _tab_panel.default, {
                    focusStateEnabled: false,
                    dataSource: this._commandTabs,
                    itemTemplate: function(data, index, $element) {
                        _this._renderTabContent($element, data, index)
                    },
                    onSelectionChanged: function(e) {
                        _this._onSelectedGroupChangedAction();
                        _this._onPointerUpAction()
                    },
                    onContentReady: function(e) {
                        _this._popup.option("height", e.component.$element().height() + _this._getVerticalPaddingsAndBorders());
                        if (_this._firstScrollView) {
                            _this._scrollViewHeight = _this._firstScrollView.$element().outerHeight();
                            _this._firstScrollView.option("height", _this._scrollViewHeight)
                        }
                    }
                })
            };
            _proto._renderTabContent = function($parent, tab, index, isSingleTab) {
                var $scrollViewWrapper = (0, _renderer.default)("<div>").appendTo($parent);
                var scrollView = this._createComponent($scrollViewWrapper, _scroll_view.default, {
                    height: this._scrollViewHeight
                });
                this._renderTabInnerContent(scrollView.content(), tab, index);
                if (isSingleTab) {
                    this._popup.option("height", scrollView.$element().height() + this._getVerticalPaddingsAndBorders())
                } else {
                    this._firstScrollView = this._firstScrollView || scrollView
                }
            };
            _proto._renderTabInnerContent = function($parent, group, index) {
                var _this2 = this;
                if (group.groups) {
                    group.groups.forEach(function(sg, si) {
                        _this2._renderTabGroupContent($parent, index, sg.title, sg.commands)
                    })
                } else {
                    if (group.commands) {
                        this._renderTabGroupContent($parent, index, void 0, group.commands)
                    }
                }
            };
            _proto._renderTabGroupContent = function($parent, index, title, commands) {
                if (title) {
                    (0, _renderer.default)("<div>").addClass(DIAGRAM_PROPERTIES_PANEL_GROUP_TITLE_CLASS).appendTo($parent).text(title)
                }
                var $toolbar = (0, _renderer.default)("<div>").addClass(DIAGRAM_PROPERTIES_PANEL_GROUP_TOOLBAR_CLASS).appendTo($parent);
                var args = {
                    $parent: $toolbar,
                    commands: commands
                };
                this._onCreateToolbarAction(args);
                if (!this._toolbars[index]) {
                    this._toolbars[index] = []
                }
                this._toolbars[index].push(args.toolbar);
                this._selectedToolbar = args.toolbar
            };
            _proto.getActiveToolbars = function() {
                var index = this._tabPanel ? this._tabPanel.option("selectedIndex") : 0;
                return this._toolbars[index]
            };
            _proto._createOnCreateToolbar = function() {
                this._onCreateToolbarAction = this._createActionByOption("onCreateToolbar")
            };
            _proto._createOnSelectedGroupChanged = function() {
                this._onSelectedGroupChangedAction = this._createActionByOption("onSelectedGroupChanged")
            };
            _proto._optionChanged = function(args) {
                switch (args.name) {
                    case "onCreateToolbar":
                        this._createOnCreateToolbar();
                        break;
                    case "onSelectedGroupChanged":
                        this._createOnSelectedGroupChanged();
                        break;
                    case "propertyTabs":
                        this._invalidate();
                        break;
                    default:
                        _DiagramFloatingPanel.prototype._optionChanged.call(this, args)
                }
            };
            return DiagramPropertiesPanel
        }(_uiDiagram.default);
        var _default = DiagramPropertiesPanel;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/diagram/diagram.options_update.js ***!
      \***********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _diagram = _interopRequireDefault(__webpack_require__( /*! ./diagram.bar */ 307));
        var _diagram2 = __webpack_require__( /*! ./diagram.importer */ 98);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var DiagramOptionsUpdateBar = function(_DiagramBar) {
            _inheritsLoose(DiagramOptionsUpdateBar, _DiagramBar);

            function DiagramOptionsUpdateBar(owner) {
                var _this;
                _this = _DiagramBar.call(this, owner) || this;
                var _getDiagram = (0, _diagram2.getDiagram)(),
                    DiagramCommand = _getDiagram.DiagramCommand;
                _this.commandOptions = {};
                _this.commandOptions[DiagramCommand.Fullscreen] = "fullScreen";
                _this.commandOptions[DiagramCommand.ZoomLevel] = function(value) {
                    if ("object" === _typeof(this._getOption("zoomLevel"))) {
                        this._setOption("zoomLevel.value", value)
                    } else {
                        this._setOption("zoomLevel", value)
                    }
                };
                _this.commandOptions[DiagramCommand.SwitchAutoZoom] = function(value) {
                    var _getDiagram2 = (0, _diagram2.getDiagram)(),
                        AutoZoomMode = _getDiagram2.AutoZoomMode;
                    switch (value) {
                        case AutoZoomMode.FitContent:
                            this._setOption("autoZoomMode", "fitContent");
                            break;
                        case AutoZoomMode.FitToWidth:
                            this._setOption("autoZoomMode", "fitWidth");
                            break;
                        case AutoZoomMode.Disabled:
                            this._setOption("autoZoomMode", "disabled")
                    }
                };
                _this.commandOptions[DiagramCommand.ToggleSimpleView] = "simpleView";
                _this.commandOptions[DiagramCommand.ShowGrid] = "showGrid";
                _this.commandOptions[DiagramCommand.SnapToGrid] = "snapToGrid";
                _this.commandOptions[DiagramCommand.GridSize] = function(value) {
                    if ("object" === _typeof(this._getOption("gridSize"))) {
                        this._setOption("gridSize.value", value)
                    } else {
                        this._setOption("gridSize", value)
                    }
                };
                _this.commandOptions[DiagramCommand.ViewUnits] = "viewUnits";
                _this.commandOptions[DiagramCommand.PageSize] = function(value) {
                    var pageSize = this._getOption("pageSize");
                    if (void 0 === pageSize || pageSize.width !== value.width || pageSize.height !== value.height) {
                        this._setOption("pageSize", value)
                    }
                };
                _this.commandOptions[DiagramCommand.PageLandscape] = function(value) {
                    this._setOption("pageOrientation", value ? "landscape" : "portrait")
                };
                _this.commandOptions[DiagramCommand.ViewUnits] = function(value) {
                    var _getDiagram3 = (0, _diagram2.getDiagram)(),
                        DiagramUnit = _getDiagram3.DiagramUnit;
                    switch (value) {
                        case DiagramUnit.In:
                            this._setOption("viewUnits", "in");
                            break;
                        case DiagramUnit.Cm:
                            this._setOption("viewUnits", "cm");
                            break;
                        case DiagramUnit.Px:
                            this._setOption("viewUnits", "px")
                    }
                };
                _this.commandOptions[DiagramCommand.PageColor] = "pageColor";
                _this._updateLock = 0;
                return _this
            }
            var _proto = DiagramOptionsUpdateBar.prototype;
            _proto.getCommandKeys = function() {
                return Object.keys(this.commandOptions).map(function(key) {
                    return parseInt(key)
                })
            };
            _proto.setItemValue = function(key, value) {
                if (this.isUpdateLocked()) {
                    return
                }
                this.beginUpdate();
                try {
                    if ("function" === typeof this.commandOptions[key]) {
                        this.commandOptions[key].call(this, value)
                    } else {
                        this._setOption(this.commandOptions[key], value)
                    }
                } finally {
                    this.endUpdate()
                }
            };
            _proto.beginUpdate = function() {
                this._updateLock++
            };
            _proto.endUpdate = function() {
                this._updateLock--
            };
            _proto.isUpdateLocked = function() {
                return this._updateLock > 0
            };
            _proto._getOption = function(name) {
                return this._owner.option(name)
            };
            _proto._setOption = function(name, value) {
                this._owner.option(name, value)
            };
            return DiagramOptionsUpdateBar
        }(_diagram.default);
        var _default = DiagramOptionsUpdateBar;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/diagram/ui.diagram.dialog_manager.js ***!
      \**************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _diagram = __webpack_require__( /*! ./diagram.importer */ 98);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _file_uploader = _interopRequireDefault(__webpack_require__( /*! ../file_uploader */ 281));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DiagramDialogManager = {
            getConfigurations: function() {
                var _getDiagram = (0, _diagram.getDiagram)(),
                    DiagramCommand = _getDiagram.DiagramCommand;
                return this.dialogList || (this.dialogList = [{
                    command: DiagramCommand.InsertShapeImage,
                    title: _message.default.format("dxDiagram-dialogInsertShapeImageTitle"),
                    onGetContent: this.getChangeImageDialogContent
                }, {
                    command: DiagramCommand.EditShapeImage,
                    title: _message.default.format("dxDiagram-dialogEditShapeImageTitle"),
                    onGetContent: this.getChangeImageDialogContent
                }])
            },
            getChangeImageDialogContent: function(args) {
                var $uploader = (0, _renderer.default)("<div>");
                args.component._createComponent($uploader, _file_uploader.default, {
                    selectButtonText: _message.default.format("dxDiagram-dialogEditShapeImageSelectButton"),
                    accept: "image/*",
                    uploadMode: "useForm",
                    onValueChanged: function(e) {
                        var window = (0, _window.getWindow)();
                        var reader = new window.FileReader;
                        reader.onload = function(e) {
                            args.component._commandParameter = e.target.result
                        };
                        reader.readAsDataURL(e.value[0])
                    }
                });
                return $uploader
            },
            getDialogParameters: function(command) {
                var commandIndex = this.getConfigurations().map(function(c) {
                    return c.command
                }).indexOf(command);
                if (commandIndex >= 0) {
                    return this.getConfigurations()[commandIndex]
                } else {
                    return null
                }
            }
        };
        var _default = DiagramDialogManager;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/diagram/diagram.nodes_option.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _diagram = _interopRequireDefault(__webpack_require__( /*! ./diagram.items_option */ 459));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var NodesOption = function(_ItemsOption) {
            _inheritsLoose(NodesOption, _ItemsOption);

            function NodesOption() {
                return _ItemsOption.apply(this, arguments) || this
            }
            var _proto = NodesOption.prototype;
            _proto._getKeyExpr = function() {
                return this._diagramWidget._createOptionGetter("nodes.keyExpr")
            };
            _proto._getItemsExpr = function() {
                return this._diagramWidget._createOptionGetter("nodes.itemsExpr")
            };
            _proto._getContainerChildrenExpr = function() {
                return this._diagramWidget._createOptionGetter("nodes.containerChildrenExpr")
            };
            return NodesOption
        }(_diagram.default);
        var _default = NodesOption;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/diagram/diagram.edges_option.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _diagram = _interopRequireDefault(__webpack_require__( /*! ./diagram.items_option */ 459));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var EdgesOption = function(_ItemsOption) {
            _inheritsLoose(EdgesOption, _ItemsOption);

            function EdgesOption() {
                return _ItemsOption.apply(this, arguments) || this
            }
            var _proto = EdgesOption.prototype;
            _proto._getKeyExpr = function() {
                return this._diagramWidget._createOptionGetter("edges.keyExpr")
            };
            return EdgesOption
        }(_diagram.default);
        var _default = EdgesOption;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************!*\
      !*** ./artifacts/transpiled-npm/ui/gantt.js ***!
      \**********************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _ui = _interopRequireDefault(__webpack_require__( /*! ./gantt/ui.gantt */ 895));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _ui.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/gantt/ui.gantt.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _data = __webpack_require__( /*! ../../core/utils/data */ 20);
        var _uiGantt = __webpack_require__( /*! ./ui.gantt.view */ 896);
        var _uiGantt2 = __webpack_require__( /*! ./ui.gantt.bars */ 900);
        var _tree_list = _interopRequireDefault(__webpack_require__( /*! ../tree_list */ 424));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _position = __webpack_require__( /*! ../../core/utils/position */ 22);
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _uiGanttData = _interopRequireDefault(__webpack_require__( /*! ./ui.gantt.data.option */ 901));
        var _splitter = _interopRequireDefault(__webpack_require__( /*! ../splitter */ 455));
        var _uiGantt3 = __webpack_require__( /*! ./ui.gantt.dialogs */ 902);
        var _load_panel = _interopRequireDefault(__webpack_require__( /*! ../load_panel */ 180));
        var _element = __webpack_require__( /*! ../../core/element */ 18);
        var _uiGantt4 = __webpack_require__( /*! ./ui.gantt.cache */ 903);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var GANTT_CLASS = "dx-gantt";
        var GANTT_VIEW_CLASS = "dx-gantt-view";
        var GANTT_COLLAPSABLE_ROW = "dx-gantt-collapsable-row";
        var GANTT_TREE_LIST_WRAPPER = "dx-gantt-treelist-wrapper";
        var GANTT_TOOLBAR_WRAPPER = "dx-gantt-toolbar-wrapper";
        var GANTT_MAIN_WRAPPER = "dx-gantt-main-wrapper";
        var GANTT_TASKS = "tasks";
        var GANTT_DEPENDENCIES = "dependencies";
        var GANTT_RESOURCES = "resources";
        var GANTT_RESOURCE_ASSIGNMENTS = "resourceAssignments";
        var GANTT_NEW_TASK_CACHE_KEY = "gantt_new_task_key";
        var GANTT_DEFAULT_ROW_HEIGHT = 34;
        var GANTT_MAPPED_FIELD_REGEX = /(\w*)Expr/;
        var Gantt = function(_Widget) {
            _inheritsLoose(Gantt, _Widget);

            function Gantt() {
                return _Widget.apply(this, arguments) || this
            }
            var _proto = Gantt.prototype;
            _proto._init = function() {
                _Widget.prototype._init.call(this);
                this._cache = new _uiGantt4.GanttDataCache;
                this._isGanttRendered = false
            };
            _proto._initMarkup = function() {
                _Widget.prototype._initMarkup.call(this);
                this.$element().addClass(GANTT_CLASS);
                this._$toolbarWrapper = (0, _renderer.default)("<div>").addClass(GANTT_TOOLBAR_WRAPPER).appendTo(this.$element());
                this._$toolbar = (0, _renderer.default)("<div>").appendTo(this._$toolbarWrapper);
                this._$mainWrapper = (0, _renderer.default)("<div>").addClass(GANTT_MAIN_WRAPPER).appendTo(this.$element());
                this._$treeListWrapper = (0, _renderer.default)("<div>").addClass(GANTT_TREE_LIST_WRAPPER).appendTo(this._$mainWrapper);
                this._$treeList = (0, _renderer.default)("<div>").appendTo(this._$treeListWrapper);
                this._$splitter = (0, _renderer.default)("<div>").appendTo(this._$mainWrapper);
                this._$ganttView = (0, _renderer.default)("<div>").addClass(GANTT_VIEW_CLASS).appendTo(this._$mainWrapper);
                this._$dialog = (0, _renderer.default)("<div>").appendTo(this.$element());
                this._$loadPanel = (0, _renderer.default)("<div>").appendTo(this.$element());
                this._$contextMenu = (0, _renderer.default)("<div>").appendTo(this.$element());
                this._refreshDataSource(GANTT_TASKS);
                this._refreshDataSource(GANTT_DEPENDENCIES);
                this._refreshDataSource(GANTT_RESOURCES);
                this._refreshDataSource(GANTT_RESOURCE_ASSIGNMENTS)
            };
            _proto._refresh = function() {
                this._isGanttRendered = false;
                _Widget.prototype._refresh.call(this)
            };
            _proto._renderContent = function() {
                this._isMainElementVisible = this.$element().is(":visible");
                if (this._isMainElementVisible && !this._isGanttRendered) {
                    this._isGanttRendered = true;
                    this._renderBars();
                    this._renderTreeList();
                    this._renderSplitter()
                }
            };
            _proto._renderTreeList = function() {
                var _this = this;
                var _this$option = this.option(GANTT_TASKS),
                    keyExpr = _this$option.keyExpr,
                    parentIdExpr = _this$option.parentIdExpr;
                this._treeList = this._createComponent(this._$treeList, _tree_list.default, {
                    dataSource: this._tasksRaw,
                    keyExpr: keyExpr,
                    parentIdExpr: parentIdExpr,
                    columns: this._getTreeListColumns(),
                    columnResizingMode: "nextColumn",
                    height: this._getTreeListHeight(),
                    width: this.option("taskListWidth"),
                    selection: {
                        mode: this._getSelectionMode(this.option("allowSelection"))
                    },
                    selectedRowKeys: this._getArrayFromOneElement(this.option("selectedRowKey")),
                    sorting: {
                        mode: "none"
                    },
                    scrolling: {
                        showScrollbar: "onHover",
                        mode: "virtual"
                    },
                    allowColumnResizing: true,
                    autoExpandAll: true,
                    showRowLines: this.option("showRowLines"),
                    rootValue: this.option("rootValue"),
                    onContentReady: function(e) {
                        _this._onTreeListContentReady(e)
                    },
                    onSelectionChanged: function(e) {
                        _this._onTreeListSelectionChanged(e)
                    },
                    onRowCollapsed: function(e) {
                        _this._onTreeListRowCollapsed(e)
                    },
                    onRowExpanded: function(e) {
                        _this._onTreeListRowExpanded(e)
                    },
                    onRowPrepared: function(e) {
                        _this._onTreeListRowPrepared(e)
                    },
                    onContextMenuPreparing: function(e) {
                        _this._onTreeListContextMenuPreparing(e)
                    },
                    onRowClick: function(e) {
                        _this._onTreeListRowClick(e)
                    },
                    onRowDblClick: function(e) {
                        _this._onTreeListRowDblClick(e)
                    }
                })
            };
            _proto._renderSplitter = function() {
                this._splitter = this._createComponent(this._$splitter, _splitter.default, {
                    container: this.$element(),
                    leftElement: this._$treeListWrapper,
                    rightElement: this._$ganttView,
                    onApplyPanelSize: this._onApplyPanelSize.bind(this)
                });
                this._splitter.option("initialLeftPanelWidth", this.option("taskListWidth"))
            };
            _proto._renderBars = function() {
                this._bars = [];
                this._toolbar = new _uiGantt2.GanttToolbar(this._$toolbar, this);
                this._updateToolbarContent();
                this._bars.push(this._toolbar);
                this._contextMenuBar = new _uiGantt2.GanttContextMenuBar(this._$contextMenu, this);
                this._updateContextMenu();
                this._bars.push(this._contextMenuBar)
            };
            _proto._initGanttView = function() {
                var _this2 = this;
                if (this._ganttView) {
                    return
                }
                this._ganttView = this._createComponent(this._$ganttView, _uiGantt.GanttView, {
                    width: "100%",
                    height: this._treeList._$element.get(0).offsetHeight,
                    rowHeight: this._getTreeListRowHeight(),
                    headerHeight: this._getTreeListHeaderHeight(),
                    tasks: this._tasks,
                    dependencies: this._dependencies,
                    resources: this._resources,
                    resourceAssignments: this._resourceAssignments,
                    allowSelection: this.option("allowSelection"),
                    selectedRowKey: this.option("selectedRowKey"),
                    showResources: this.option("showResources"),
                    taskTitlePosition: this.option("taskTitlePosition"),
                    firstDayOfWeek: this.option("firstDayOfWeek"),
                    showRowLines: this.option("showRowLines"),
                    scaleType: this.option("scaleType"),
                    editing: this.option("editing"),
                    validation: this.option("validation"),
                    stripLines: this.option("stripLines"),
                    bars: this._bars,
                    mainElement: this.$element(),
                    onSelectionChanged: this._onGanttViewSelectionChanged.bind(this),
                    onScroll: this._onGanttViewScroll.bind(this),
                    onDialogShowing: this._showDialog.bind(this),
                    onPopupMenuShowing: this._showPopupMenu.bind(this),
                    onExpandAll: this._expandAll.bind(this),
                    onCollapseAll: this._collapseAll.bind(this),
                    modelChangesListener: this._createModelChangesListener(),
                    taskTooltipContentTemplate: this._getTaskTooltipContentTemplateFunc(this.option("taskTooltipContentTemplate")),
                    onTaskClick: function(e) {
                        _this2._onTreeListRowClick(e)
                    },
                    onTaskDblClick: function(e) {
                        _this2._onTreeListRowDblClick(e)
                    },
                    onAdjustControl: function() {
                        _this2._onAdjustControl()
                    }
                });
                this._fireContentReadyAction()
            };
            _proto._onAdjustControl = function() {
                var elementHeight = this._$element.height();
                this._updateGanttWidth();
                this._setGanttHeight(elementHeight)
            };
            _proto._onApplyPanelSize = function(e) {
                var _this$_ganttView;
                this._setInnerElementsWidth(e);
                var rowHeight = this._getTreeListRowHeight();
                null === (_this$_ganttView = this._ganttView) || void 0 === _this$_ganttView ? void 0 : _this$_ganttView._ganttViewCore.updateRowHeights(rowHeight)
            };
            _proto._onTreeListContentReady = function(e) {
                if (e.component.getDataSource()) {
                    this._initGanttView();
                    this._initScrollSync(e.component)
                }
            };
            _proto._onTreeListRowPrepared = function(e) {
                if ("data" === e.rowType && e.node.children.length > 0) {
                    (0, _renderer.default)(e.rowElement).addClass(GANTT_COLLAPSABLE_ROW)
                }
            };
            _proto._onTreeListContextMenuPreparing = function(e) {
                var _e$row, _e$row2;
                if ("data" === (null === (_e$row = e.row) || void 0 === _e$row ? void 0 : _e$row.rowType)) {
                    this._setTreeListOption("selectedRowKeys", [e.row.data[this.option("tasks.keyExpr")]])
                }
                e.items = [];
                var info = {
                    cancel: false,
                    event: e.event,
                    type: "task",
                    key: null === (_e$row2 = e.row) || void 0 === _e$row2 ? void 0 : _e$row2.key,
                    position: {
                        x: e.event.pageX,
                        y: e.event.pageY
                    }
                };
                this._showPopupMenu(info)
            };
            _proto._onTreeListRowClick = function(e) {
                this._raiseTaskClickAction(e.key, e.event)
            };
            _proto._onTreeListRowDblClick = function(e) {
                if (this._raiseTaskDblClickAction(e.key, e.event)) {
                    this._ganttView._ganttViewCore.commandManager.showTaskEditDialog.execute()
                }
            };
            _proto._onTreeListSelectionChanged = function(e) {
                var selectedRowKey = e.currentSelectedRowKeys[0];
                this._setGanttViewOption("selectedRowKey", selectedRowKey);
                this._setOptionWithoutOptionChange("selectedRowKey", selectedRowKey);
                this._raiseSelectionChangedAction(selectedRowKey)
            };
            _proto._onTreeListRowCollapsed = function(e) {
                this._ganttView.changeTaskExpanded(e.key, false);
                this._adjustHeight()
            };
            _proto._onTreeListRowExpanded = function(e) {
                this._ganttView.changeTaskExpanded(e.key, true);
                this._adjustHeight()
            };
            _proto._adjustHeight = function() {
                if (!this._hasHeight) {
                    this._setGanttViewOption("height", 0);
                    this._setGanttViewOption("height", this._treeList._$element.get(0).offsetHeight)
                }
            };
            _proto._getTreeListHeight = function() {
                if (this._$treeList.height()) {
                    return this._$treeList.height()
                }
                this._hasHeight = (0, _type.isDefined)(this.option("height")) && "" !== this.option("height");
                return this._hasHeight ? "100%" : ""
            };
            _proto._getTreeListColumns = function() {
                var columns = this.option("columns");
                if (columns) {
                    for (var i = 0; i < columns.length; i++) {
                        var column = columns[i];
                        var isKeyColumn = column.dataField === this.option("".concat(GANTT_TASKS, ".keyExpr")) || column.dataField === this.option("".concat(GANTT_TASKS, ".parentIdExpr"));
                        if (isKeyColumn && !column.dataType) {
                            column.dataType = "object"
                        }
                    }
                }
                return columns
            };
            _proto._onGanttViewSelectionChanged = function(e) {
                this._setTreeListOption("selectedRowKeys", this._getArrayFromOneElement(e.id))
            };
            _proto._onGanttViewScroll = function(e) {
                var treeListScrollable = this._treeList.getScrollable();
                if (treeListScrollable) {
                    var diff = e.scrollTop - treeListScrollable.scrollTop();
                    if (0 !== diff) {
                        treeListScrollable.scrollBy({
                            left: 0,
                            top: diff
                        })
                    }
                }
            };
            _proto._onTreeListScroll = function(treeListScrollView) {
                var ganttViewTaskAreaContainer = this._ganttView.getTaskAreaContainer();
                if (ganttViewTaskAreaContainer.scrollTop !== treeListScrollView.component.scrollTop()) {
                    ganttViewTaskAreaContainer.scrollTop = treeListScrollView.component.scrollTop()
                }
            };
            _proto._expandAll = function() {
                var _this3 = this;
                this._treeList.forEachNode(function(node) {
                    if (node.children && node.children.length) {
                        _this3._treeList.expandRow(node.key);
                        _this3._ganttView.changeTaskExpanded(node.key, true)
                    }
                })
            };
            _proto._collapseAll = function() {
                var _this4 = this;
                this._treeList.forEachNode(function(node) {
                    if (node.children && node.children.length) {
                        _this4._treeList.collapseRow(node.key);
                        _this4._ganttView.changeTaskExpanded(node.key, false)
                    }
                })
            };
            _proto._initScrollSync = function(treeList) {
                var _this5 = this;
                var treeListScrollable = treeList.getScrollable();
                if (treeListScrollable) {
                    treeListScrollable.off("scroll");
                    treeListScrollable.on("scroll", function(e) {
                        _this5._onTreeListScroll(e)
                    })
                }
            };
            _proto._getTreeListRowHeight = function() {
                var $row = this._treeList._$element.find(".dx-data-row");
                var height = $row.length ? (0, _position.getBoundingRect)($row.last().get(0)).height : GANTT_DEFAULT_ROW_HEIGHT;
                if (!height) {
                    height = GANTT_DEFAULT_ROW_HEIGHT
                }
                this._correctRowsViewRowHeight(height);
                return height
            };
            _proto._correctRowsViewRowHeight = function(height) {
                var view = this._treeList._views && this._treeList._views.rowsView;
                if ((null === view || void 0 === view ? void 0 : view._rowHeight) !== height) {
                    view._rowHeight = height
                }
            };
            _proto._getTreeListHeaderHeight = function() {
                return (0, _position.getBoundingRect)(this._treeList._$element.find(".dx-treelist-headers").get(0)).height
            };
            _proto._setInnerElementsWidth = function(widths) {
                if (!(0, _window.hasWindow)()) {
                    return
                }
                if (!widths) {
                    widths = this._getPanelsWidthByOption()
                }
                this._setTreeListDimension("width", widths.leftPanelWidth);
                this._setGanttViewDimension("width", widths.rightPanelWidth)
            };
            _proto._setTreeListDimension = function(dimension, value) {
                this._$treeListWrapper[dimension](value);
                this._setTreeListOption(dimension, this._$treeListWrapper[dimension]())
            };
            _proto._setGanttViewDimension = function(dimension, value) {
                this._$ganttView[dimension](value);
                this._setGanttViewOption(dimension, this._$ganttView[dimension]())
            };
            _proto._updateGanttWidth = function() {
                this._splitter._dimensionChanged()
            };
            _proto._setGanttHeight = function(height) {
                var _this$_ganttView2;
                var toolbarHeightOffset = this._$toolbarWrapper.get(0).offsetHeight;
                var mainWrapperHeight = height - toolbarHeightOffset;
                this._setTreeListDimension("height", mainWrapperHeight);
                this._setGanttViewDimension("height", mainWrapperHeight);
                null === (_this$_ganttView2 = this._ganttView) || void 0 === _this$_ganttView2 ? void 0 : _this$_ganttView2._ganttViewCore.resetAndUpdate()
            };
            _proto._getPanelsWidthByOption = function() {
                return {
                    leftPanelWidth: this.option("taskListWidth"),
                    rightPanelWidth: this._$element.width() - this.option("taskListWidth")
                }
            };
            _proto._setGanttViewOption = function(optionName, value) {
                this._ganttView && this._ganttView.option(optionName, value)
            };
            _proto._setTreeListOption = function(optionName, value) {
                this._treeList && this._treeList.option(optionName, value)
            };
            _proto._refreshDataSource = function(name) {
                var _this6 = this;
                var dataOption = this["_".concat(name, "Option")];
                if (dataOption) {
                    dataOption._disposeDataSource();
                    delete this["_".concat(name, "Option")];
                    delete this["_".concat(name)]
                }
                if (this.option("".concat(name, ".dataSource"))) {
                    dataOption = new _uiGanttData.default(name, this._getLoadPanel(), function(name, data) {
                        _this6._dataSourceChanged(name, data)
                    });
                    dataOption.option("dataSource", this._getSpecificDataSourceOption(name));
                    dataOption._refreshDataSource();
                    this["_".concat(name, "Option")] = dataOption
                }
            };
            _proto._getSpecificDataSourceOption = function(name) {
                var dataSource = this.option("".concat(name, ".dataSource"));
                if (Array.isArray(dataSource)) {
                    return {
                        store: {
                            type: "array",
                            data: dataSource,
                            key: this.option("".concat(name, ".keyExpr"))
                        }
                    }
                }
                return dataSource
            };
            _proto._compileGettersByOption = function(optionName) {
                var getters = {};
                var optionValue = this.option(optionName);
                for (var field in optionValue) {
                    var exprMatches = field.match(/(\w*)Expr/);
                    if (exprMatches) {
                        getters[exprMatches[1]] = (0, _data.compileGetter)(optionValue[exprMatches[0]])
                    }
                }
                return getters
            };
            _proto._compileSettersByOption = function(optionName) {
                var setters = {};
                var optionValue = this.option(optionName);
                for (var field in optionValue) {
                    var exprMatches = field.match(/(\w*)Expr/);
                    if (exprMatches) {
                        setters[exprMatches[1]] = (0, _data.compileSetter)(optionValue[exprMatches[0]])
                    }
                }
                return setters
            };
            _proto._getStoreObject = function(optionName, modelObject) {
                var setters = this._compileSettersByOption(optionName);
                return Object.keys(setters).reduce(function(previous, key) {
                    if ("key" !== key) {
                        setters[key](previous, modelObject[key])
                    }
                    return previous
                }, {})
            };
            _proto._prepareSetterMapHandler = function(setters) {
                return function(data) {
                    return Object.keys(setters).reduce(function(previous, key) {
                        var resultKey = "key" === key ? "id" : key;
                        setters[key](previous, data[resultKey]);
                        return previous
                    }, {})
                }
            };
            _proto._prepareMapHandler = function(getters) {
                return function(data) {
                    return Object.keys(getters).reduce(function(previous, key) {
                        var resultKey = "key" === key ? "id" : key;
                        previous[resultKey] = getters[key](data);
                        return previous
                    }, {})
                }
            };
            _proto._dataSourceChanged = function(dataSourceName, data) {
                var _this7 = this;
                var getters = this._compileGettersByOption(dataSourceName);
                var mappedData = data.map(this._prepareMapHandler(getters));
                this["_".concat(dataSourceName)] = mappedData;
                this._setGanttViewOption(dataSourceName, mappedData);
                if (dataSourceName === GANTT_TASKS) {
                    this._tasksRaw = data;
                    var expandedRowKeys = data.map(function(t) {
                        return t[_this7.option("tasks.parentIdExpr")]
                    }).filter(function(value, index, self) {
                        return value && self.indexOf(value) === index
                    });
                    this._setTreeListOption("expandedRowKeys", expandedRowKeys);
                    this._setTreeListOption("dataSource", data)
                }
            };
            _proto._createModelChangesListener = function() {
                var _this8 = this;
                return {
                    NotifyTaskCreated: function(task, callback, errorCallback) {
                        _this8._onRecordInserted(GANTT_TASKS, task, callback)
                    },
                    NotifyTaskRemoved: function(taskId, errorCallback, task) {
                        _this8._onRecordRemoved(GANTT_TASKS, taskId, task)
                    },
                    NotifyTaskTitleChanged: function(taskId, newValue, errorCallback) {
                        _this8._onRecordUpdated(GANTT_TASKS, taskId, "title", newValue)
                    },
                    NotifyTaskDescriptionChanged: function(taskId, newValue, errorCallback) {
                        _this8._onRecordUpdated(GANTT_TASKS, taskId, "description", newValue)
                    },
                    NotifyTaskStartChanged: function(taskId, newValue, errorCallback) {
                        _this8._onRecordUpdated(GANTT_TASKS, taskId, "start", newValue)
                    },
                    NotifyTaskEndChanged: function(taskId, newValue, errorCallback) {
                        _this8._onRecordUpdated(GANTT_TASKS, taskId, "end", newValue)
                    },
                    NotifyTaskProgressChanged: function(taskId, newValue, errorCallback) {
                        _this8._onRecordUpdated(GANTT_TASKS, taskId, "progress", newValue)
                    },
                    NotifyTaskColorChanged: function(taskId, newValue, errorCallback) {
                        _this8._onRecordUpdated(GANTT_TASKS, taskId, "color", newValue)
                    },
                    NotifyDependencyInserted: function(dependency, callback, errorCallback) {
                        _this8._onRecordInserted(GANTT_DEPENDENCIES, dependency, callback)
                    },
                    NotifyDependencyRemoved: function(dependencyId, errorCallback, dependency) {
                        _this8._onRecordRemoved(GANTT_DEPENDENCIES, dependencyId, dependency)
                    },
                    NotifyResourceCreated: function(resource, callback, errorCallback) {
                        _this8._onRecordInserted(GANTT_RESOURCES, resource, callback)
                    },
                    NotifyResourceRemoved: function(resourceId, errorCallback, resource) {
                        _this8._onRecordRemoved(GANTT_RESOURCES, resourceId, resource)
                    },
                    NotifyResourceAssigned: function(assignment, callback, errorCallback) {
                        _this8._onRecordInserted(GANTT_RESOURCE_ASSIGNMENTS, assignment, callback)
                    },
                    NotifyResourceUnassigned: function(assignmentId, errorCallback, assignment) {
                        _this8._onRecordRemoved(GANTT_RESOURCE_ASSIGNMENTS, assignmentId, assignment)
                    },
                    NotifyParentDataRecalculated: function(data) {
                        _this8._onParentTasksRecalculated(data)
                    },
                    NotifyTaskCreating: function(args) {
                        _this8._raiseInsertingAction(GANTT_TASKS, args)
                    },
                    NotifyTaskRemoving: function(args) {
                        _this8._raiseDeletingAction(GANTT_TASKS, args)
                    },
                    NotifyTaskUpdating: function(args) {
                        _this8._raiseUpdatingAction(GANTT_TASKS, args)
                    },
                    NotifyTaskMoving: function(args) {
                        _this8._raiseUpdatingAction(GANTT_TASKS, args, _this8._getTaskMovingAction())
                    },
                    NotifyTaskEditDialogShowing: function(args) {
                        _this8._raiseTaskEditDialogShowingAction(args)
                    },
                    NotifyDependencyInserting: function(args) {
                        _this8._raiseInsertingAction(GANTT_DEPENDENCIES, args)
                    },
                    NotifyDependencyRemoving: function(args) {
                        _this8._raiseDeletingAction(GANTT_DEPENDENCIES, args)
                    },
                    NotifyResourceCreating: function(args) {
                        _this8._raiseInsertingAction(GANTT_RESOURCES, args)
                    },
                    NotifyResourceRemoving: function(args) {
                        _this8._raiseDeletingAction(GANTT_RESOURCES, args)
                    },
                    NotifyResourceAssigning: function(args) {
                        _this8._raiseInsertingAction(GANTT_RESOURCE_ASSIGNMENTS, args)
                    },
                    NotifyResourceUnassigning: function(args) {
                        _this8._raiseDeletingAction(GANTT_RESOURCE_ASSIGNMENTS, args)
                    }
                }
            };
            _proto._onRecordInserted = function(optionName, record, callback) {
                var _this9 = this;
                var dataOption = this["_".concat(optionName, "Option")];
                if (dataOption) {
                    var data = this._getStoreObject(optionName, record);
                    if (optionName === GANTT_TASKS) {
                        this._addCustomFieldsDataFromCache(GANTT_NEW_TASK_CACHE_KEY, data)
                    }
                    dataOption.insert(data, function(response) {
                        var keyGetter = (0, _data.compileGetter)(_this9.option("".concat(optionName, ".keyExpr")));
                        var insertedId = keyGetter(response);
                        callback(insertedId);
                        if (optionName === GANTT_TASKS) {
                            _this9._updateTreeListDataSource();
                            var parentId = record.parentId;
                            if (void 0 !== parentId) {
                                var expandedRowKeys = _this9._treeList.option("expandedRowKeys");
                                if (expandedRowKeys.indexOf(parentId) === -1) {
                                    expandedRowKeys.push(parentId);
                                    _this9._treeList.option("expandedRowKeys", expandedRowKeys)
                                }
                            }
                            _this9._selectTreeListRows(_this9._getArrayFromOneElement(insertedId));
                            _this9._setTreeListOption("focusedRowKey", insertedId)
                        }
                        _this9._raiseInsertedAction(optionName, data, insertedId)
                    })
                }
            };
            _proto._onRecordRemoved = function(optionName, key, data) {
                var _this10 = this;
                var dataOption = this["_".concat(optionName, "Option")];
                if (dataOption) {
                    dataOption.remove(key, function() {
                        if (optionName === GANTT_TASKS) {
                            _this10._updateTreeListDataSource()
                        }
                        _this10._raiseDeletedAction(optionName, key, _this10._convertCoreToMappedData(optionName, data))
                    })
                }
            };
            _proto._onRecordUpdated = function(optionName, key, fieldName, value) {
                var _this11 = this;
                var dataOption = this["_".concat(optionName, "Option")];
                var isTaskUpdated = optionName === GANTT_TASKS;
                if (dataOption) {
                    var setter = (0, _data.compileSetter)(this.option("".concat(optionName, ".").concat(fieldName, "Expr")));
                    var data = {};
                    setter(data, value);
                    var hasCustomFieldsData = isTaskUpdated && this._cache.hasData(key);
                    if (hasCustomFieldsData) {
                        this._addCustomFieldsDataFromCache(key, data)
                    }
                    dataOption.update(key, data, function() {
                        if (isTaskUpdated) {
                            if (hasCustomFieldsData) {
                                dataOption._refreshDataSource()
                            }
                            _this11._updateTreeListDataSource()
                        }
                        _this11._raiseUpdatedAction(optionName, data, key)
                    })
                }
            };
            _proto._onParentTasksRecalculated = function(data) {
                var setters = this._compileSettersByOption(GANTT_TASKS);
                var treeDataSource = this._appendCustomFields(data.map(this._prepareSetterMapHandler(setters)));
                this._setTreeListOption("dataSource", treeDataSource)
            };
            _proto._appendCustomFields = function(data) {
                var modelData = this._tasksOption && this._tasksOption._getItems();
                var keyGetter = (0, _data.compileGetter)(this.option("".concat(GANTT_TASKS, ".keyExpr")));
                var invertedData = this.getInvertedData(modelData, keyGetter);
                return data.reduce(function(previous, item) {
                    var key = keyGetter(item);
                    var modelItem = invertedData[key];
                    if (!modelItem) {
                        previous.push(item)
                    } else {
                        var updatedItem = {};
                        for (var field in modelItem) {
                            updatedItem[field] = Object.prototype.hasOwnProperty.call(item, field) ? item[field] : modelItem[field]
                        }
                        previous.push(updatedItem)
                    }
                    return previous
                }, [])
            };
            _proto.getInvertedData = function(data, keyGetter) {
                var inverted = {};
                if (data) {
                    for (var i = 0; i < data.length; i++) {
                        var dataItem = data[i];
                        var key = keyGetter(dataItem);
                        inverted[key] = dataItem
                    }
                }
                return inverted
            };
            _proto._updateTreeListDataSource = function() {
                if (!this._skipUpdateTreeListDataSource()) {
                    var dataSource = this.option("tasks.dataSource");
                    var storeArray = this._tasksOption._getStore()._array || dataSource.items && dataSource.items();
                    this._setTreeListOption("dataSource", storeArray ? storeArray : dataSource)
                }
            };
            _proto._skipUpdateTreeListDataSource = function() {
                return this.option("validation.autoUpdateParentTasks")
            };
            _proto._selectTreeListRows = function(keys) {
                var _this$_treeList;
                null === (_this$_treeList = this._treeList) || void 0 === _this$_treeList ? void 0 : _this$_treeList.selectRows(keys)
            };
            _proto._addCustomFieldsDataFromCache = function(key, data) {
                this._cache.pullDataFromCache(key, data)
            };
            _proto._saveCustomFieldsDataToCache = function(key, data) {
                var _this12 = this;
                var forceUpdateOnKeyExpire = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : false;
                var customFieldsData = this._getCustomFieldsData(data);
                if (Object.keys(customFieldsData).length > 0) {
                    var updateCallback = function(key, data) {
                        var dataOption = _this12["_".concat(GANTT_TASKS, "Option")];
                        if (dataOption && data) {
                            dataOption.update(key, data, function() {
                                _this12._updateTreeListDataSource();
                                dataOption._refreshDataSource()
                            })
                        }
                    };
                    this._cache.saveData(key, customFieldsData, forceUpdateOnKeyExpire ? updateCallback : null)
                }
            };
            _proto._getLoadPanel = function() {
                if (!this._loadPanel) {
                    this._loadPanel = this._createComponent(this._$loadPanel, _load_panel.default, {
                        position: {
                            of: this.$element()
                        }
                    })
                }
                return this._loadPanel
            };
            _proto._createSelectionChangedAction = function() {
                this._selectionChangedAction = this._createActionByOption("onSelectionChanged")
            };
            _proto._createTaskClickAction = function() {
                this._taskClickAction = this._createActionByOption("onTaskClick")
            };
            _proto._createTaskDblClickAction = function() {
                this._taskDblClickAction = this._createActionByOption("onTaskDblClick")
            };
            _proto._createCustomCommandAction = function() {
                this._customCommandAction = this._createActionByOption("onCustomCommand")
            };
            _proto._createContextMenuPreparingAction = function() {
                this._contextMenuPreparingAction = this._createActionByOption("onContextMenuPreparing")
            };
            _proto._raiseSelectionChangedAction = function(selectedRowKey) {
                if (!this._selectionChangedAction) {
                    this._createSelectionChangedAction()
                }
                this._selectionChangedAction({
                    selectedRowKey: selectedRowKey
                })
            };
            _proto._raiseCustomCommand = function(commandName) {
                if (!this._customCommandAction) {
                    this._createCustomCommandAction()
                }
                this._customCommandAction({
                    name: commandName
                })
            };
            _proto._raiseContextMenuPreparing = function(options) {
                if (!this._contextMenuPreparingAction) {
                    this._createContextMenuPreparingAction()
                }
                this._contextMenuPreparingAction(options)
            };
            _proto._raiseInsertingAction = function(optionName, coreArgs) {
                var action = this._getInsertingAction(optionName);
                if (action) {
                    var args = {
                        cancel: false,
                        values: this._convertCoreToMappedData(optionName, coreArgs.values)
                    };
                    action(args);
                    coreArgs.cancel = args.cancel;
                    coreArgs.values = this._convertMappedToCoreData(optionName, args.values);
                    if (optionName === GANTT_TASKS) {
                        this._saveCustomFieldsDataToCache(GANTT_NEW_TASK_CACHE_KEY, args.values)
                    }
                }
            };
            _proto._raiseInsertedAction = function(optionName, data, key) {
                var action = this._getInsertedAction(optionName);
                if (action) {
                    var args = {
                        values: data,
                        key: key
                    };
                    action(args)
                }
            };
            _proto._raiseDeletingAction = function(optionName, coreArgs) {
                var action = this._getDeletingAction(optionName);
                if (action) {
                    var args = {
                        cancel: false,
                        key: coreArgs.key,
                        values: this._convertCoreToMappedData(optionName, coreArgs.values)
                    };
                    action(args);
                    coreArgs.cancel = args.cancel
                }
            };
            _proto._raiseDeletedAction = function(optionName, key, data) {
                var action = this._getDeletedAction(optionName);
                if (action) {
                    var args = {
                        key: key,
                        values: data
                    };
                    action(args)
                }
            };
            _proto._raiseUpdatingAction = function(optionName, coreArgs, action) {
                action = action || this._getUpdatingAction(optionName);
                if (action) {
                    var args = {
                        cancel: false,
                        key: coreArgs.key,
                        newValues: this._convertCoreToMappedData(optionName, coreArgs.newValues),
                        values: this._convertCoreToMappedData(optionName, coreArgs.values)
                    };
                    action(args);
                    coreArgs.cancel = args.cancel;
                    coreArgs.newValues = this._convertMappedToCoreData(optionName, args.newValues);
                    if (optionName === GANTT_TASKS) {
                        this._saveCustomFieldsDataToCache(args.key, args.newValues)
                    }
                }
            };
            _proto._raiseUpdatedAction = function(optionName, data, key) {
                var action = this._getUpdatedAction(optionName);
                if (action) {
                    var args = {
                        values: data,
                        key: key
                    };
                    action(args)
                }
            };
            _proto._raiseTaskEditDialogShowingAction = function(coreArgs) {
                var action = this._getTaskEditDialogShowingAction();
                if (action) {
                    var args = {
                        cancel: false,
                        key: coreArgs.key,
                        values: this._convertCoreToMappedData(GANTT_TASKS, coreArgs.values),
                        readOnlyFields: this._convertCoreToMappedFields(GANTT_TASKS, coreArgs.readOnlyFields),
                        hiddenFields: this._convertCoreToMappedFields(GANTT_TASKS, coreArgs.hiddenFields)
                    };
                    action(args);
                    coreArgs.cancel = args.cancel;
                    coreArgs.values = this._convertMappedToCoreData(GANTT_TASKS, args.values);
                    coreArgs.readOnlyFields = this._convertMappedToCoreFields(GANTT_TASKS, args.readOnlyFields);
                    coreArgs.hiddenFields = this._convertMappedToCoreFields(GANTT_TASKS, args.hiddenFields)
                }
            };
            _proto._raiseTaskClickAction = function(key, event) {
                if (!this._taskClickAction) {
                    this._createTaskClickAction()
                }
                var args = {
                    key: key,
                    event: event,
                    data: this.getTaskData(key)
                };
                this._taskClickAction(args)
            };
            _proto._raiseTaskDblClickAction = function(key, event) {
                if (!this._taskDblClickAction) {
                    this._createTaskDblClickAction()
                }
                var args = {
                    cancel: false,
                    data: this.getTaskData(key),
                    event: event,
                    key: key
                };
                this._taskDblClickAction(args);
                return !args.cancel
            };
            _proto._getInsertingAction = function(optionName) {
                switch (optionName) {
                    case GANTT_TASKS:
                        return this._getTaskInsertingAction();
                    case GANTT_DEPENDENCIES:
                        return this._getDependencyInsertingAction();
                    case GANTT_RESOURCES:
                        return this._getResourceInsertingAction();
                    case GANTT_RESOURCE_ASSIGNMENTS:
                        return this._getResourceAssigningAction()
                }
                return function() {}
            };
            _proto._getInsertedAction = function(optionName) {
                switch (optionName) {
                    case GANTT_TASKS:
                        return this._getTaskInsertedAction();
                    case GANTT_DEPENDENCIES:
                        return this._getDependencyInsertedAction();
                    case GANTT_RESOURCES:
                        return this._getResourceInsertedAction();
                    case GANTT_RESOURCE_ASSIGNMENTS:
                        return this._getResourceAssignedAction()
                }
                return function() {}
            };
            _proto._getDeletingAction = function(optionName) {
                switch (optionName) {
                    case GANTT_TASKS:
                        return this._getTaskDeletingAction();
                    case GANTT_DEPENDENCIES:
                        return this._getDependencyDeletingAction();
                    case GANTT_RESOURCES:
                        return this._getResourceDeletingAction();
                    case GANTT_RESOURCE_ASSIGNMENTS:
                        return this._getResourceUnassigningAction()
                }
                return function() {}
            };
            _proto._getDeletedAction = function(optionName) {
                switch (optionName) {
                    case GANTT_TASKS:
                        return this._getTaskDeletedAction();
                    case GANTT_DEPENDENCIES:
                        return this._getDependencyDeletedAction();
                    case GANTT_RESOURCES:
                        return this._getResourceDeletedAction();
                    case GANTT_RESOURCE_ASSIGNMENTS:
                        return this._getResourceUnassignedAction()
                }
                return function() {}
            };
            _proto._getUpdatingAction = function(optionName) {
                switch (optionName) {
                    case GANTT_TASKS:
                        return this._getTaskUpdatingAction()
                }
                return function() {}
            };
            _proto._getUpdatedAction = function(optionName) {
                switch (optionName) {
                    case GANTT_TASKS:
                        return this._getTaskUpdatedAction()
                }
                return function() {}
            };
            _proto._getTaskInsertingAction = function() {
                if (!this._taskInsertingAction) {
                    this._createTaskInsertingAction()
                }
                return this._taskInsertingAction
            };
            _proto._getTaskInsertedAction = function() {
                if (!this._taskInsertedAction) {
                    this._createTaskInsertedAction()
                }
                return this._taskInsertedAction
            };
            _proto._getTaskDeletingAction = function() {
                if (!this._taskDeletingAction) {
                    this._createTaskDeletingAction()
                }
                return this._taskDeletingAction
            };
            _proto._getTaskDeletedAction = function() {
                if (!this._taskDeletedAction) {
                    this._createTaskDeletedAction()
                }
                return this._taskDeletedAction
            };
            _proto._getTaskUpdatingAction = function() {
                if (!this._taskUpdatingAction) {
                    this._createTaskUpdatingAction()
                }
                return this._taskUpdatingAction
            };
            _proto._getTaskUpdatedAction = function() {
                if (!this._taskUpdatedAction) {
                    this._createTaskUpdatedAction()
                }
                return this._taskUpdatedAction
            };
            _proto._getTaskMovingAction = function() {
                if (!this._taskMovingAction) {
                    this._createTaskMovingAction()
                }
                return this._taskMovingAction
            };
            _proto._getTaskEditDialogShowingAction = function() {
                if (!this._taskEditDialogShowingAction) {
                    this._createTaskEditDialogShowingAction()
                }
                return this._taskEditDialogShowingAction
            };
            _proto._getDependencyInsertingAction = function() {
                if (!this._dependencyInsertingAction) {
                    this._createDependencyInsertingAction()
                }
                return this._dependencyInsertingAction
            };
            _proto._getDependencyInsertedAction = function() {
                if (!this._dependencyInsertedAction) {
                    this._createDependencyInsertedAction()
                }
                return this._dependencyInsertedAction
            };
            _proto._getDependencyDeletingAction = function() {
                if (!this._dependencyDeletingAction) {
                    this._createDependencyDeletingAction()
                }
                return this._dependencyDeletingAction
            };
            _proto._getDependencyDeletedAction = function() {
                if (!this._dependencyDeletedAction) {
                    this._createDependencyDeletedAction()
                }
                return this._dependencyDeletedAction
            };
            _proto._getResourceInsertingAction = function() {
                if (!this._resourceInsertingAction) {
                    this._createResourceInsertingAction()
                }
                return this._resourceInsertingAction
            };
            _proto._getResourceInsertedAction = function() {
                if (!this._resourceInsertedAction) {
                    this._createResourceInsertedAction()
                }
                return this._resourceInsertedAction
            };
            _proto._getResourceDeletingAction = function() {
                if (!this._resourceDeletingAction) {
                    this._createResourceDeletingAction()
                }
                return this._resourceDeletingAction
            };
            _proto._getResourceDeletedAction = function() {
                if (!this._resourceDeletedAction) {
                    this._createResourceDeletedAction()
                }
                return this._resourceDeletedAction
            };
            _proto._getResourceAssigningAction = function() {
                if (!this._resourceAssigningAction) {
                    this._createResourceAssigningAction()
                }
                return this._resourceAssigningAction
            };
            _proto._getResourceAssignedAction = function() {
                if (!this._resourceAssignedAction) {
                    this._createResourceAssignedAction()
                }
                return this._resourceAssignedAction
            };
            _proto._getResourceUnassigningAction = function() {
                if (!this._resourceUnassigningAction) {
                    this._createResourceUnassigningAction()
                }
                return this._resourceUnassigningAction;
            };
            _proto._getResourceUnassignedAction = function() {
                if (!this._resourceUnassignedAction) {
                    this._createResourceUnassignedAction()
                }
                return this._resourceUnassignedAction
            };
            _proto._createResourceUnassigningAction = function() {
                this._resourceUnassigningAction = this._createActionByOption("onResourceUnassigning")
            };
            _proto._createResourceUnassignedAction = function() {
                this._resourceUnassignedAction = this._createActionByOption("onResourceUnassigned")
            };
            _proto._createTaskInsertingAction = function() {
                this._taskInsertingAction = this._createActionByOption("onTaskInserting")
            };
            _proto._createTaskInsertedAction = function() {
                this._taskInsertedAction = this._createActionByOption("onTaskInserted")
            };
            _proto._createTaskDeletingAction = function() {
                this._taskDeletingAction = this._createActionByOption("onTaskDeleting")
            };
            _proto._createTaskDeletedAction = function() {
                this._taskDeletedAction = this._createActionByOption("onTaskDeleted")
            };
            _proto._createTaskUpdatingAction = function() {
                this._taskUpdatingAction = this._createActionByOption("onTaskUpdating")
            };
            _proto._createTaskUpdatedAction = function() {
                this._taskUpdatedAction = this._createActionByOption("onTaskUpdated")
            };
            _proto._createTaskMovingAction = function() {
                this._taskMovingAction = this._createActionByOption("onTaskMoving")
            };
            _proto._createTaskEditDialogShowingAction = function() {
                this._taskEditDialogShowingAction = this._createActionByOption("onTaskEditDialogShowing")
            };
            _proto._createDependencyInsertingAction = function() {
                this._dependencyInsertingAction = this._createActionByOption("onDependencyInserting")
            };
            _proto._createDependencyInsertedAction = function() {
                this._dependencyInsertedAction = this._createActionByOption("onDependencyInserted")
            };
            _proto._createDependencyDeletingAction = function() {
                this._dependencyDeletingAction = this._createActionByOption("onDependencyDeleting")
            };
            _proto._createDependencyDeletedAction = function() {
                this._dependencyDeletedAction = this._createActionByOption("onDependencyDeleted")
            };
            _proto._createResourceInsertingAction = function() {
                this._resourceInsertingAction = this._createActionByOption("onResourceInserting")
            };
            _proto._createResourceInsertedAction = function() {
                this._resourceInsertedAction = this._createActionByOption("onResourceInserted")
            };
            _proto._createResourceDeletingAction = function() {
                this._resourceDeletingAction = this._createActionByOption("onResourceDeleting")
            };
            _proto._createResourceDeletedAction = function() {
                this._resourceDeletedAction = this._createActionByOption("onResourceDeleted")
            };
            _proto._createResourceAssigningAction = function() {
                this._resourceAssigningAction = this._createActionByOption("onResourceAssigning")
            };
            _proto._createResourceAssignedAction = function() {
                this._resourceAssignedAction = this._createActionByOption("onResourceAssigned")
            };
            _proto._convertCoreToMappedData = function(optionName, coreData) {
                var _this13 = this;
                return Object.keys(coreData).reduce(function(previous, f) {
                    var mappedField = _this13._getMappedFieldName(optionName, f);
                    if (mappedField) {
                        var setter = (0, _data.compileSetter)(mappedField);
                        setter(previous, coreData[f])
                    }
                    return previous
                }, {})
            };
            _proto._convertMappedToCoreData = function(optionName, mappedData) {
                var coreData = {};
                if (mappedData) {
                    var mappedFields = this.option(optionName);
                    for (var field in mappedFields) {
                        var exprMatches = field.match(GANTT_MAPPED_FIELD_REGEX);
                        var mappedFieldName = exprMatches && mappedFields[exprMatches[0]];
                        if (mappedFieldName && void 0 !== mappedData[mappedFieldName]) {
                            var getter = (0, _data.compileGetter)(mappedFieldName);
                            var coreFieldName = exprMatches[1];
                            coreData[coreFieldName] = getter(mappedData)
                        }
                    }
                }
                return coreData
            };
            _proto._getMappedFieldName = function(optionName, coreField) {
                var coreFieldName = coreField;
                if ("id" === coreField) {
                    coreFieldName = "key"
                }
                return this.option("".concat(optionName, ".").concat(coreFieldName, "Expr"))
            };
            _proto._convertCoreToMappedFields = function(optionName, fields) {
                var _this14 = this;
                return fields.reduce(function(previous, f) {
                    var mappedField = _this14._getMappedFieldName(optionName, f);
                    if (mappedField) {
                        previous.push(mappedField)
                    }
                    return previous
                }, [])
            };
            _proto._convertMappedToCoreFields = function(optionName, fields) {
                var coreFields = [];
                var mappedFields = this.option(optionName);
                for (var field in mappedFields) {
                    var exprMatches = field.match(GANTT_MAPPED_FIELD_REGEX);
                    var mappedFieldName = exprMatches && mappedFields[exprMatches[0]];
                    if (mappedFieldName && fields.indexOf(mappedFieldName) > -1) {
                        var coreFieldName = exprMatches[1];
                        coreFields.push(coreFieldName)
                    }
                }
                return coreFields
            };
            _proto._getTaskMappedFieldNames = function() {
                var mappedFields = [];
                var mappedFieldsData = this.option(GANTT_TASKS);
                for (var field in mappedFieldsData) {
                    var exprMatches = field.match(GANTT_MAPPED_FIELD_REGEX);
                    var mappedFieldName = exprMatches && mappedFieldsData[exprMatches[0]];
                    if (mappedFieldName) {
                        mappedFields.push(mappedFieldName)
                    }
                }
                return mappedFields
            };
            _proto._getTaskCustomFields = function() {
                var columns = this.option("columns");
                var columnFields = columns && columns.map(function(c) {
                    return c.dataField
                });
                var mappedFields = this._getTaskMappedFieldNames();
                return columnFields ? columnFields.filter(function(f) {
                    return mappedFields.indexOf(f) < 0
                }) : []
            };
            _proto._getCustomFieldsData = function(data) {
                return this._getTaskCustomFields().reduce(function(previous, field) {
                    if (data && void 0 !== data[field]) {
                        previous[field] = data[field]
                    }
                    return previous
                }, {})
            };
            _proto._addCustomFieldsData = function(key, data) {
                if (data) {
                    var modelData = this._tasksOption && this._tasksOption._getItems();
                    var keyGetter = (0, _data.compileGetter)(this.option("".concat(GANTT_TASKS, ".keyExpr")));
                    var modelItem = modelData && modelData.filter(function(obj) {
                        return keyGetter(obj) === key
                    })[0];
                    var customFields = this._getTaskCustomFields();
                    for (var i = 0; i < customFields.length; i++) {
                        var field = customFields[i];
                        if (Object.prototype.hasOwnProperty.call(modelItem, field)) {
                            data[field] = modelItem[field]
                        }
                    }
                }
            };
            _proto._getSelectionMode = function(allowSelection) {
                return allowSelection ? "single" : "none"
            };
            _proto._getArrayFromOneElement = function(element) {
                return void 0 === element || null === element ? [] : [element]
            };
            _proto._getToolbarItems = function() {
                var items = this.option("toolbar.items");
                return items ? items : []
            };
            _proto._updateToolbarContent = function() {
                var items = this._getToolbarItems();
                if (items.length) {
                    this._$toolbarWrapper.show()
                } else {
                    this._$toolbarWrapper.hide()
                }
                this._toolbar && this._toolbar.createItems(items);
                this._updateBarItemsState()
            };
            _proto._updateContextMenu = function() {
                var contextMenuOptions = this.option("contextMenu");
                if (contextMenuOptions.enabled && this._contextMenuBar) {
                    this._contextMenuBar.createItems(contextMenuOptions.items);
                    this._updateBarItemsState()
                }
            };
            _proto._updateBarItemsState = function() {
                this._ganttView && this._ganttView.updateBarItemsState()
            };
            _proto._showDialog = function(e) {
                if (!this._dialogInstance) {
                    this._dialogInstance = new _uiGantt3.GanttDialog(this, this._$dialog)
                }
                this._dialogInstance.show(e.name, e.parameters, e.callback, e.afterClosing, this.option("editing"))
            };
            _proto._showPopupMenu = function(info) {
                if (this.option("contextMenu.enabled")) {
                    this._ganttView.getBarManager().updateContextMenu();
                    var args = {
                        cancel: false,
                        event: info.event,
                        targetType: info.type,
                        targetKey: info.key,
                        items: (0, _extend.extend)(true, [], this._contextMenuBar._items),
                        data: "task" === info.type ? this.getTaskData(info.key) : this.getDependencyData(info.key)
                    };
                    this._raiseContextMenuPreparing(args);
                    if (!args.cancel) {
                        this._contextMenuBar.show(info.position, args.items)
                    }
                }
            };
            _proto._executeCoreCommand = function(id) {
                this._ganttView.executeCoreCommand(id)
            };
            _proto._clean = function() {
                var _this$_ganttView3;
                null === (_this$_ganttView3 = this._ganttView) || void 0 === _this$_ganttView3 ? void 0 : _this$_ganttView3._ganttViewCore.cleanMarkup();
                delete this._ganttView;
                delete this._dialogInstance;
                _Widget.prototype._clean.call(this)
            };
            _proto._getTaskTooltipContentTemplateFunc = function(taskTooltipContentTemplateOption) {
                var _this15 = this;
                var isTooltipShowing = true;
                var template = taskTooltipContentTemplateOption && this._getTemplate(taskTooltipContentTemplateOption);
                var createTemplateFunction = template && function(container, item) {
                    template.render({
                        model: _this15.getTaskDataByCoreData(item),
                        container: (0, _element.getPublicElement)((0, _renderer.default)(container))
                    });
                    return isTooltipShowing
                };
                return createTemplateFunction
            };
            _proto._getDefaultOptions = function() {
                return (0, _extend.extend)(_Widget.prototype._getDefaultOptions.call(this), {
                    tasks: {
                        dataSource: null,
                        keyExpr: "id",
                        parentIdExpr: "parentId",
                        startExpr: "start",
                        endExpr: "end",
                        progressExpr: "progress",
                        titleExpr: "title",
                        colorExpr: "color"
                    },
                    dependencies: {
                        dataSource: null,
                        keyExpr: "id",
                        predecessorIdExpr: "predecessorId",
                        successorIdExpr: "successorId",
                        typeExpr: "type"
                    },
                    resources: {
                        dataSource: null,
                        keyExpr: "id",
                        textExpr: "text",
                        colorExpr: "color"
                    },
                    resourceAssignments: {
                        dataSource: null,
                        keyExpr: "id",
                        taskIdExpr: "taskId",
                        resourceIdExpr: "resourceId"
                    },
                    columns: void 0,
                    taskListWidth: 300,
                    showResources: true,
                    taskTitlePosition: "inside",
                    firstDayOfWeek: void 0,
                    selectedRowKey: void 0,
                    onSelectionChanged: null,
                    onTaskClick: null,
                    onTaskDblClick: null,
                    onTaskInserting: null,
                    onTaskInserted: null,
                    onTaskDeleting: null,
                    onTaskDeleted: null,
                    onTaskUpdating: null,
                    onTaskUpdated: null,
                    onTaskMoving: null,
                    onTaskEditDialogShowing: null,
                    onDependencyInserting: null,
                    onDependencyInserted: null,
                    onDependencyDeleting: null,
                    onDependencyDeleted: null,
                    onResourceInserting: null,
                    onResourceInserted: null,
                    onResourceDeleting: null,
                    onResourceDeleted: null,
                    onResourceAssigning: null,
                    onResourceAssigned: null,
                    onResourceUnassigning: null,
                    onResourceUnassigned: null,
                    onCustomCommand: null,
                    onContextMenuPreparing: null,
                    allowSelection: true,
                    showRowLines: true,
                    stripLines: void 0,
                    scaleType: "auto",
                    editing: {
                        enabled: false,
                        allowTaskAdding: true,
                        allowTaskDeleting: true,
                        allowTaskUpdating: true,
                        allowDependencyAdding: true,
                        allowDependencyDeleting: true,
                        allowResourceAdding: true,
                        allowResourceDeleting: true,
                        allowResourceUpdating: true,
                        allowTaskResourceUpdating: true
                    },
                    validation: {
                        validateDependencies: false,
                        autoUpdateParentTasks: false
                    },
                    toolbar: null,
                    contextMenu: {
                        enabled: true,
                        items: void 0
                    },
                    taskTooltipContentTemplate: null,
                    rootValue: 0
                })
            };
            _proto.getTaskResources = function(key) {
                var _this16 = this;
                if (!(0, _type.isDefined)(key)) {
                    return null
                }
                var coreData = this._ganttView._ganttViewCore.getTaskResources(key);
                return coreData.map(function(r) {
                    return _this16._convertCoreToMappedData(GANTT_RESOURCES, r)
                })
            };
            _proto.getVisibleTaskKeys = function() {
                return this._ganttView._ganttViewCore.getVisibleTaskKeys()
            };
            _proto.getVisibleDependencyKeys = function() {
                return this._ganttView._ganttViewCore.getVisibleDependencyKeys()
            };
            _proto.getVisibleResourceKeys = function() {
                return this._ganttView._ganttViewCore.getVisibleResourceKeys()
            };
            _proto.getVisibleResourceAssignmentKeys = function() {
                return this._ganttView._ganttViewCore.getVisibleResourceAssignmentKeys()
            };
            _proto.getTaskData = function(key) {
                if (!(0, _type.isDefined)(key)) {
                    return null
                }
                var coreData = this._ganttView._ganttViewCore.getTaskData(key);
                var mappedData = this.getTaskDataByCoreData(coreData);
                return mappedData
            };
            _proto.getTaskDataByCoreData = function(coreData) {
                var mappedData = coreData ? this._convertCoreToMappedData(GANTT_TASKS, coreData) : null;
                this._addCustomFieldsData(coreData.id, mappedData);
                return mappedData
            };
            _proto.insertTask = function(data) {
                this._saveCustomFieldsDataToCache(GANTT_NEW_TASK_CACHE_KEY, data);
                this._ganttView._ganttViewCore.insertTask(this._convertMappedToCoreData(GANTT_TASKS, data))
            };
            _proto.deleteTask = function(key) {
                this._ganttView._ganttViewCore.deleteTask(key)
            };
            _proto.updateTask = function(key, data) {
                this._saveCustomFieldsDataToCache(key, data, true);
                this._ganttView._ganttViewCore.updateTask(key, this._convertMappedToCoreData(GANTT_TASKS, data))
            };
            _proto.getDependencyData = function(key) {
                if (!(0, _type.isDefined)(key)) {
                    return null
                }
                var coreData = this._ganttView._ganttViewCore.getDependencyData(key);
                return coreData ? this._convertCoreToMappedData(GANTT_DEPENDENCIES, coreData) : null
            };
            _proto.insertDependency = function(data) {
                this._ganttView._ganttViewCore.insertDependency(this._convertMappedToCoreData(GANTT_DEPENDENCIES, data))
            };
            _proto.deleteDependency = function(key) {
                this._ganttView._ganttViewCore.deleteDependency(key)
            };
            _proto.getResourceData = function(key) {
                var coreData = this._ganttView._ganttViewCore.getResourceData(key);
                return coreData ? this._convertCoreToMappedData(GANTT_RESOURCES, coreData) : null
            };
            _proto.deleteResource = function(key) {
                this._ganttView._ganttViewCore.deleteResource(key)
            };
            _proto.insertResource = function(data, taskKeys) {
                this._ganttView._ganttViewCore.insertResource(this._convertMappedToCoreData(GANTT_RESOURCES, data), taskKeys)
            };
            _proto.getResourceAssignmentData = function(key) {
                var coreData = this._ganttView._ganttViewCore.getResourceAssignmentData(key);
                return coreData ? this._convertCoreToMappedData(GANTT_RESOURCE_ASSIGNMENTS, coreData) : null
            };
            _proto.assignResourceToTask = function(resourceKey, taskKey) {
                this._ganttView._ganttViewCore.assignResourceToTask(resourceKey, taskKey)
            };
            _proto.unassignResourceFromTask = function(resourceKey, taskKey) {
                this._ganttView._ganttViewCore.unassignResourceFromTask(resourceKey, taskKey)
            };
            _proto.updateDimensions = function() {
                this._onAdjustControl()
            };
            _proto._optionChanged = function(args) {
                switch (args.name) {
                    case "tasks":
                        this._refreshDataSource(GANTT_TASKS);
                        break;
                    case "dependencies":
                        this._refreshDataSource(GANTT_DEPENDENCIES);
                        break;
                    case "resources":
                        this._refreshDataSource(GANTT_RESOURCES);
                        break;
                    case "resourceAssignments":
                        this._refreshDataSource(GANTT_RESOURCE_ASSIGNMENTS);
                        break;
                    case "columns":
                        this._setTreeListOption("columns", this._getTreeListColumns());
                        break;
                    case "taskListWidth":
                        this._setInnerElementsWidth();
                        break;
                    case "showResources":
                        this._setGanttViewOption("showResources", args.value);
                        break;
                    case "taskTitlePosition":
                        this._setGanttViewOption("taskTitlePosition", args.value);
                        break;
                    case "firstDayOfWeek":
                        this._setGanttViewOption("firstDayOfWeek", args.value);
                        break;
                    case "selectedRowKey":
                        this._selectTreeListRows(this._getArrayFromOneElement(args.value));
                        break;
                    case "onSelectionChanged":
                        this._createSelectionChangedAction();
                        break;
                    case "onTaskClick":
                        this._createTaskClickAction();
                        break;
                    case "onTaskDblClick":
                        this._createTaskDblClickAction();
                        break;
                    case "onTaskInserting":
                        this._createTaskInsertingAction();
                        break;
                    case "onTaskInserted":
                        this._createTaskInsertedAction();
                        break;
                    case "onTaskDeleting":
                        this._createTaskDeletingAction();
                        break;
                    case "onTaskDeleted":
                        this._createTaskDeletedAction();
                        break;
                    case "onTaskUpdating":
                        this._createTaskUpdatingAction();
                        break;
                    case "onTaskUpdated":
                        this._createTaskUpdatedAction();
                        break;
                    case "onTaskMoving":
                        this._createTaskMovingAction();
                        break;
                    case "onTaskEditDialogShowing":
                        this._createTaskEditDialogShowingAction();
                        break;
                    case "onDependencyInserting":
                        this._createDependencyInsertingAction();
                        break;
                    case "onDependencyInserted":
                        this._createDependencyInsertedAction();
                        break;
                    case "onDependencyDeleting":
                        this._createDependencyDeletingAction();
                        break;
                    case "onDependencyDeleted":
                        this._createDependencyDeletedAction();
                        break;
                    case "onResourceInserting":
                        this._createResourceInsertingAction();
                        break;
                    case "onResourceInserted":
                        this._createResourceInsertedAction();
                        break;
                    case "onResourceDeleting":
                        this._createResourceDeletingAction();
                        break;
                    case "onResourceDeleted":
                        this._createResourceDeletedAction();
                        break;
                    case "onResourceAssigning":
                        this._createResourceAssigningAction();
                        break;
                    case "onResourceAssigned":
                        this._createResourceAssignedAction();
                        break;
                    case "onResourceUnassigning":
                        this._createResourceUnassigningAction();
                        break;
                    case "onResourceUnassigned":
                        this._createResourceUnassignedAction();
                        break;
                    case "onCustomCommand":
                        this._createCustomCommandAction();
                        break;
                    case "onContextMenuPreparing":
                        this._createContextMenuPreparingAction();
                        break;
                    case "allowSelection":
                        this._setTreeListOption("selection.mode", this._getSelectionMode(args.value));
                        this._setGanttViewOption("allowSelection", args.value);
                        break;
                    case "showRowLines":
                        this._setTreeListOption("showRowLines", args.value);
                        this._setGanttViewOption("showRowLines", args.value);
                        break;
                    case "stripLines":
                        this._setGanttViewOption("stripLines", args.value);
                        break;
                    case "scaleType":
                        this._setGanttViewOption("scaleType", args.value);
                        break;
                    case "editing":
                        this._setGanttViewOption("editing", this.option(args.name));
                        break;
                    case "validation":
                        this._setGanttViewOption("validation", this.option(args.name));
                        break;
                    case "toolbar":
                        this._updateToolbarContent();
                        break;
                    case "contextMenu":
                        this._updateContextMenu();
                        break;
                    case "taskTooltipContentTemplate":
                        this._setGanttViewOption("taskTooltipContentTemplate", this._getTaskTooltipContentTemplateFunc(args.value));
                        break;
                    case "rootValue":
                        this._setTreeListOption("rootValue", args.value);
                        break;
                    case "width":
                        _Widget.prototype._optionChanged.call(this, args);
                        this._updateGanttWidth();
                        break;
                    case "height":
                        _Widget.prototype._optionChanged.call(this, args);
                        this._setGanttHeight(this._$element.height());
                        break;
                    default:
                        _Widget.prototype._optionChanged.call(this, args)
                }
            };
            return Gantt
        }(_ui.default);
        (0, _component_registrator.default)("dxGantt", Gantt);
        var _default = Gantt;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/gantt/ui.gantt.view.js ***!
      \************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.GanttView = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.widget */ 16));
        var _gantt_importer = __webpack_require__( /*! ./gantt_importer */ 897);
        var _uiGanttTaskArea = __webpack_require__( /*! ./ui.gantt.task.area.container */ 899);
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../localization/date */ 32));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var GanttView = function(_Widget) {
            _inheritsLoose(GanttView, _Widget);

            function GanttView() {
                return _Widget.apply(this, arguments) || this
            }
            var _proto = GanttView.prototype;
            _proto._init = function() {
                _Widget.prototype._init.call(this);
                this._onSelectionChanged = this._createActionByOption("onSelectionChanged");
                this._onScroll = this._createActionByOption("onScroll");
                this._onDialogShowing = this._createActionByOption("onDialogShowing");
                this._onPopupMenuShowing = this._createActionByOption("onPopupMenuShowing");
                this._expandAll = this._createActionByOption("onExpandAll");
                this._collapseAll = this._createActionByOption("onCollapseAll");
                this._taskClick = this._createActionByOption("onTaskClick");
                this._taskDblClick = this._createActionByOption("onTaskDblClick");
                this._onAdjustControl = this._createActionByOption("onAdjustControl")
            };
            _proto._initMarkup = function() {
                var _GanttView = (0, _gantt_importer.getGanttViewCore)();
                this._ganttViewCore = new _GanttView(this.$element().get(0), this, {
                    showResources: this.option("showResources"),
                    taskTitlePosition: this._getTaskTitlePosition(this.option("taskTitlePosition")),
                    firstDayOfWeek: this._getFirstDayOfWeek(this.option("firstDayOfWeek")),
                    allowSelectTask: this.option("allowSelection"),
                    editing: this._parseEditingSettings(this.option("editing")),
                    validation: this.option("validation"),
                    stripLines: {
                        stripLines: this.option("stripLines")
                    },
                    areHorizontalBordersEnabled: this.option("showRowLines"),
                    areAlternateRowsEnabled: false,
                    viewType: this._getViewTypeByScaleType(this.option("scaleType")),
                    cultureInfo: this._getCultureInfo(),
                    taskTooltipContentTemplate: this.option("taskTooltipContentTemplate")
                });
                this._selectTask(this.option("selectedRowKey"));
                this.updateBarItemsState()
            };
            _proto._getFirstDayOfWeek = function(value) {
                return (0, _type.isDefined)(value) ? value : _date.default.firstDayOfWeekIndex()
            };
            _proto.getTaskAreaContainer = function() {
                return this._ganttViewCore.taskAreaContainer
            };
            _proto.getBarManager = function() {
                return this._ganttViewCore.barManager
            };
            _proto.executeCoreCommand = function(id) {
                var command = this._ganttViewCore.commandManager.getCommand(id);
                if (command) {
                    command.execute()
                }
            };
            _proto.changeTaskExpanded = function(id, value) {
                this._ganttViewCore.changeTaskExpanded(id, value)
            };
            _proto.updateView = function() {
                this._ganttViewCore.updateView()
            };
            _proto.updateBarItemsState = function() {
                this._ganttViewCore.barManager.updateItemsState([])
            };
            _proto.setWidth = function(value) {
                this._ganttViewCore.setWidth(value)
            };
            _proto._selectTask = function(id) {
                this._ganttViewCore.selectTaskById(id)
            };
            _proto._update = function() {
                this._ganttViewCore.loadOptionsFromGanttOwner();
                this._ganttViewCore.resetAndUpdate()
            };
            _proto._getCultureInfo = function() {
                return {
                    monthNames: _date.default.getMonthNames("wide"),
                    dayNames: _date.default.getDayNames("wide"),
                    abbrMonthNames: _date.default.getMonthNames("abbreviated"),
                    abbrDayNames: _date.default.getDayNames("abbreviated"),
                    quarterNames: _date.default.getQuarterNames(),
                    amText: _date.default.getPeriodNames()[0],
                    pmText: _date.default.getPeriodNames()[1]
                }
            };
            _proto._getTaskTitlePosition = function(value) {
                switch (value) {
                    case "outside":
                        return 1;
                    case "none":
                        return 2;
                    default:
                        return 0
                }
            };
            _proto._getViewTypeByScaleType = function(scaleType) {
                switch (scaleType) {
                    case "minutes":
                        return 0;
                    case "hours":
                        return 1;
                    case "days":
                        return 3;
                    case "weeks":
                        return 4;
                    case "months":
                        return 5;
                    case "quarters":
                        return 6;
                    case "years":
                        return 7;
                    default:
                        return
                }
            };
            _proto._parseEditingSettings = function(value) {
                return {
                    enabled: value.enabled,
                    allowDependencyDelete: value.allowDependencyDeleting,
                    allowDependencyInsert: value.allowDependencyAdding,
                    allowTaskDelete: value.allowTaskDeleting,
                    allowTaskInsert: value.allowTaskAdding,
                    allowTaskUpdate: value.allowTaskUpdating,
                    allowResourceDelete: value.allowResourceDeleting,
                    allowResourceInsert: value.allowResourceAdding,
                    allowResourceUpdate: value.allowResourceUpdating,
                    allowTaskResourceUpdate: value.allowTaskResourceUpdating
                }
            };
            _proto._optionChanged = function(args) {
                switch (args.name) {
                    case "width":
                        _Widget.prototype._optionChanged.call(this, args);
                        this._ganttViewCore.setWidth(args.value);
                        break;
                    case "height":
                        this._ganttViewCore.setHeight(args.value);
                        break;
                    case "tasks":
                    case "dependencies":
                    case "resources":
                    case "resourceAssignments":
                        this._update();
                        break;
                    case "showResources":
                        this._ganttViewCore.setShowResources(args.value);
                        break;
                    case "taskTitlePosition":
                        this._ganttViewCore.setTaskTitlePosition(this._getTaskTitlePosition(args.value));
                        break;
                    case "firstDayOfWeek":
                        this._ganttViewCore.setFirstDayOfWeek(this._getFirstDayOfWeek(args.value));
                        break;
                    case "allowSelection":
                        this._ganttViewCore.setAllowSelection(args.value);
                        break;
                    case "selectedRowKey":
                        this._selectTask(args.value);
                        break;
                    case "editing":
                        this._ganttViewCore.setEditingSettings(this._parseEditingSettings(args.value));
                        break;
                    case "validation":
                        this._ganttViewCore.setValidationSettings(args.value);
                        this._update();
                        break;
                    case "showRowLines":
                        this._ganttViewCore.setRowLinesVisible(args.value);
                        break;
                    case "scaleType":
                        this._ganttViewCore.setViewType(this._getViewTypeByScaleType(args.value));
                        break;
                    case "stripLines":
                        this._ganttViewCore.setStripLines({
                            stripLines: args.value
                        });
                        break;
                    case "taskTooltipContentTemplate":
                        this._ganttViewCore.setTaskTooltipContentTemplate(args.value);
                        break;
                    default:
                        _Widget.prototype._optionChanged.call(this, args)
                }
            };
            _proto.getRowHeight = function() {
                return this.option("rowHeight")
            };
            _proto.getHeaderHeight = function() {
                return this.option("headerHeight")
            };
            _proto.getGanttTasksData = function() {
                return this.option("tasks")
            };
            _proto.getGanttDependenciesData = function() {
                return this.option("dependencies")
            };
            _proto.getGanttResourcesData = function() {
                return this.option("resources")
            };
            _proto.getGanttResourceAssignmentsData = function() {
                return this.option("resourceAssignments")
            };
            _proto.getGanttWorkTimeRules = function() {
                return {}
            };
            _proto.getExternalTaskAreaContainer = function(element) {
                if (!this._taskAreaContainer) {
                    this._taskAreaContainer = new _uiGanttTaskArea.TaskAreaContainer(element, this)
                }
                return this._taskAreaContainer
            };
            _proto.changeGanttTaskSelection = function(id, selected) {
                this._onSelectionChanged({
                    id: id,
                    selected: selected
                })
            };
            _proto.onGanttScroll = function(scrollTop) {
                this._onScroll({
                    scrollTop: scrollTop
                })
            };
            _proto.showDialog = function(name, parameters, callback, afterClosing) {
                this._onDialogShowing({
                    name: name,
                    parameters: parameters,
                    callback: callback,
                    afterClosing: afterClosing
                })
            };
            _proto.getModelChangesListener = function() {
                return this.option("modelChangesListener")
            };
            _proto.showPopupMenu = function(info) {
                this._onPopupMenuShowing(info)
            };
            _proto.getMainElement = function() {
                return this.option("mainElement").get(0)
            };
            _proto.adjustControl = function() {
                this._onAdjustControl()
            };
            _proto.getRequireFirstLoadParentAutoCalc = function() {
                return this.option("validation.autoUpdateParentTasks")
            };
            _proto.collapseAll = function() {
                this._collapseAll()
            };
            _proto.expandAll = function() {
                this._expandAll()
            };
            _proto.onTaskClick = function(key, event) {
                this._taskClick({
                    key: key,
                    event: event
                });
                return true
            };
            _proto.onTaskDblClick = function(key, event) {
                return this._taskDblClick({
                    key: key,
                    event: event
                })
            };
            _proto.onGanttViewContextMenu = function(event, key, type) {
                return true
            };
            _proto.getFormattedDateText = function(date) {
                var result = "";
                if (date) {
                    var datePart = _date.default.format(date, "shortDate");
                    var timePart = _date.default.format(date, "hh:mm");
                    result = datePart + " " + timePart
                }
                return result
            };
            _proto.destroyTemplate = function(container) {
                (0, _renderer.default)(container).empty()
            };
            _createClass(GanttView, [{
                key: "bars",
                get: function() {
                    return this.option("bars")
                }
            }]);
            return GanttView
        }(_ui.default);
        exports.GanttView = GanttView
    },
    /*!*************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/gantt/gantt_importer.js ***!
      \*************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getGanttViewCore = getGanttViewCore;
        var _ui = _interopRequireDefault(__webpack_require__( /*! ../widget/ui.errors */ 17));
        var _devexpressGantt = _interopRequireDefault(__webpack_require__( /*! devexpress-gantt */ 898));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function getGanttViewCore() {
            if (!_devexpressGantt.default) {
                throw _ui.default.Error("E1041", "devexpress-gantt")
            }
            return _devexpressGantt.default
        }
    },
    /*!******************************************!*\
      !*** external "window.DevExpress.Gantt" ***!
      \******************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports) {
        module.exports = window.DevExpress.Gantt
    },
    /*!***************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/gantt/ui.gantt.task.area.container.js ***!
      \***************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.TaskAreaContainer = void 0;
        var _scroll_view = _interopRequireDefault(__webpack_require__( /*! ../scroll_view */ 90));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) {
                    descriptor.writable = true
                }
                Object.defineProperty(target, descriptor.key, descriptor)
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) {
                _defineProperties(Constructor.prototype, protoProps)
            }
            if (staticProps) {
                _defineProperties(Constructor, staticProps)
            }
            return Constructor
        }
        var TaskAreaContainer = function() {
            function TaskAreaContainer(element, ganttViewWidget) {
                this._element = element;
                this._scrollView = ganttViewWidget._createComponent(this._element, _scroll_view.default, {
                    scrollByContent: false,
                    scrollByThumb: true,
                    showScrollbar: "onHover",
                    direction: "both",
                    onScroll: function() {
                        ganttViewWidget.updateView()
                    }
                })
            }
            var _proto = TaskAreaContainer.prototype;
            _proto.getWidth = function() {
                return this._element.offsetWidth
            };
            _proto.getHeight = function() {
                return this._element.offsetHeight
            };
            _proto.getElement = function() {
                return this._element
            };
            _createClass(TaskAreaContainer, [{
                key: "scrollTop",
                get: function() {
                    return this._scrollView.scrollTop()
                },
                set: function(value) {
                    var diff = value - this._scrollView.scrollTop();
                    if (0 !== diff) {
                        this._scrollView.scrollBy({
                            left: 0,
                            top: diff
                        })
                    }
                }
            }, {
                key: "scrollLeft",
                get: function() {
                    return this._scrollView.scrollLeft()
                },
                set: function(value) {
                    var diff = value - this._scrollView.scrollLeft();
                    if (0 !== diff) {
                        this._scrollView.scrollBy({
                            left: diff,
                            top: 0
                        })
                    }
                }
            }, {
                key: "scrollWidth",
                get: function() {
                    return this._scrollView.scrollWidth()
                }
            }, {
                key: "scrollHeight",
                get: function() {
                    return this._scrollView.scrollHeight()
                }
            }, {
                key: "isExternal",
                get: function() {
                    return true
                }
            }]);
            return TaskAreaContainer
        }();
        exports.TaskAreaContainer = TaskAreaContainer
    },
    /*!************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/gantt/ui.gantt.bars.js ***!
      \************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.GanttContextMenuBar = exports.GanttToolbar = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../../core/renderer */ 2));
        var _toolbar = _interopRequireDefault(__webpack_require__( /*! ../toolbar */ 157));
        var _context_menu = _interopRequireDefault(__webpack_require__( /*! ../context_menu */ 107));
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var TOOLBAR_SEPARATOR_CLASS = "dx-gantt-toolbar-separator";
        var COMMANDS = {
            createTask: 0,
            createSubTask: 1,
            removeTask: 2,
            removeDependency: 3,
            taskInformation: 4,
            taskAddContextItem: 5,
            undo: 6,
            redo: 7,
            zoomIn: 8,
            zoomOut: 9,
            fullScreen: 10,
            collapseAll: 11,
            expandAll: 12
        };
        var Bar = function() {
            function Bar(element, owner) {
                this._element = element;
                this._owner = owner;
                this._items = [];
                this._createControl()
            }
            var _proto = Bar.prototype;
            _proto.createItems = function(items) {
                this._cache = null;
                this._items = this._createItemsCore(items);
                this._menu.option("items", this._items)
            };
            _proto._createItemsCore = function(items) {
                var _this = this;
                return items.map(function(item) {
                    var result;
                    if ("string" === typeof item) {
                        result = _this._createItemByText(item)
                    } else {
                        result = item.name ? (0, _extend.extend)(_this._createItemByText(item.name), item) : (0, _extend.extend)(_this._getDefaultItemOptions(), item)
                    }
                    if (item.items) {
                        result.items = _this._createItemsCore(item.items)
                    }
                    return result
                })
            };
            _proto._createItemByText = function(text) {
                switch (text.toLowerCase()) {
                    case "separator":
                        return this._createSeparator();
                    case "undo":
                        return this._createDefaultItem(COMMANDS.undo, _message.default.format("dxGantt-undo"), this._getIcon("undo"));
                    case "redo":
                        return this._createDefaultItem(COMMANDS.redo, _message.default.format("dxGantt-redo"), this._getIcon("redo"));
                    case "expandall":
                        return this._createDefaultItem(COMMANDS.expandAll, _message.default.format("dxGantt-expandAll"), this._getIcon("expand"));
                    case "collapseall":
                        return this._createDefaultItem(COMMANDS.collapseAll, _message.default.format("dxGantt-collapseAll"), this._getIcon("collapse"));
                    case "addtask":
                        return this._createDefaultItem(COMMANDS.createTask, _message.default.format("dxGantt-addNewTask"), this._getIcon("add"));
                    case "addsubtask":
                        return this._createDefaultItem(COMMANDS.createSubTask, _message.default.format("dxGantt-contextMenuNewSubtask"), this._getIcon("add-sub-task"));
                    case "deletetask":
                        return this._createDefaultItem(COMMANDS.removeTask, _message.default.format("dxGantt-deleteSelectedTask"), this._getIcon("delete"));
                    case "deletedependency":
                        return this._createDefaultItem(COMMANDS.removeDependency, _message.default.format("dxGantt-contextMenuDeleteDependency"), this._getIcon("delete-dependency"));
                    case "zoomin":
                        return this._createDefaultItem(COMMANDS.zoomIn, _message.default.format("dxGantt-zoomIn"), this._getIcon("zoom-in"));
                    case "zoomout":
                        return this._createDefaultItem(COMMANDS.zoomOut, _message.default.format("dxGantt-zoomOut"), this._getIcon("zoom-out"));
                    case "fullscreen":
                        return this._createDefaultItem(COMMANDS.fullScreen, _message.default.format("dxGantt-fullScreen"), this._getIcon("full-screen"));
                    case "taskdetails":
                        return this._createDefaultItem(COMMANDS.taskInformation, _message.default.format("dxGantt-dialogTaskDetailsTitle") + "...", this._getIcon("task-details"));
                    default:
                        return (0, _extend.extend)(this._getDefaultItemOptions(), {
                            options: {
                                text: text
                            }
                        })
                }
            };
            _proto._getDefaultItemOptions = function() {
                return {}
            };
            _proto._getItemsCache = function() {
                if (!this._cache) {
                    this._cache = {};
                    this._fillCache(this._items)
                }
                return this._cache
            };
            _proto._fillCache = function(items) {
                var _this2 = this;
                items.forEach(function(item) {
                    var key = item.commandId;
                    if (void 0 !== key) {
                        if (!_this2._cache[key]) {
                            _this2._cache[key] = []
                        }
                        _this2._cache[key].push(item)
                    }
                    if (item.items) {
                        _this2._fillCache(item.items)
                    }
                })
            };
            _proto._getIcon = function(name) {
                return "dx-gantt-i dx-gantt-i-" + name
            };
            _proto.getCommandKeys = function() {
                var itemsCache = this._getItemsCache();
                var result = [];
                for (var itemKey in itemsCache) {
                    result.push(parseInt(itemKey))
                }
                return result
            };
            _proto.setItemEnabled = function(key, enabled) {
                var itemsCache = this._getItemsCache();
                itemsCache[key].forEach(function(item) {
                    item.disabled = !enabled
                })
            };
            _proto.setItemVisible = function(key, visible) {
                var itemsCache = this._getItemsCache();
                itemsCache[key].forEach(function(item) {
                    item.visible = visible
                })
            };
            _proto.setItemValue = function(_key, _value) {};
            _proto.setEnabled = function(enabled) {
                this._menu.option("disabled", !enabled)
            };
            _proto.updateItemsList = function() {};
            _proto.isVisible = function() {
                return true
            };
            _proto.isContextMenu = function() {
                return false
            };
            _proto.completeUpdate = function() {};
            return Bar
        }();
        var GanttToolbar = function(_Bar) {
            _inheritsLoose(GanttToolbar, _Bar);

            function GanttToolbar() {
                return _Bar.apply(this, arguments) || this
            }
            var _proto2 = GanttToolbar.prototype;
            _proto2._createControl = function() {
                var _this3 = this;
                this._menu = this._owner._createComponent(this._element, _toolbar.default, {
                    onItemClick: function(e) {
                        var commandId = e.itemData.commandId;
                        if (void 0 !== commandId) {
                            _this3._owner._executeCoreCommand(e.itemData.commandId)
                        }
                    }
                })
            };
            _proto2._createDefaultItem = function(commandId, hint, icon) {
                return {
                    commandId: commandId,
                    disabled: true,
                    widget: "dxButton",
                    location: "before",
                    options: {
                        icon: icon,
                        stylingMode: "text",
                        hint: hint
                    }
                }
            };
            _proto2._createSeparator = function() {
                return {
                    location: "before",
                    template: function(_data, _index, element) {
                        (0, _renderer.default)(element).addClass(TOOLBAR_SEPARATOR_CLASS)
                    }
                }
            };
            _proto2._getDefaultItemOptions = function() {
                return {
                    location: "before",
                    widget: "dxButton"
                }
            };
            _proto2.completeUpdate = function() {
                this._menu.option("items", this._items)
            };
            return GanttToolbar
        }(Bar);
        exports.GanttToolbar = GanttToolbar;
        var GanttContextMenuBar = function(_Bar2) {
            _inheritsLoose(GanttContextMenuBar, _Bar2);

            function GanttContextMenuBar() {
                return _Bar2.apply(this, arguments) || this
            }
            var _proto3 = GanttContextMenuBar.prototype;
            _proto3._createControl = function() {
                var _this4 = this;
                this._menu = this._owner._createComponent(this._element, _context_menu.default, {
                    showEvent: void 0,
                    onItemClick: function(e) {
                        if (void 0 !== e.itemData.commandId) {
                            _this4._owner._executeCoreCommand(e.itemData.commandId)
                        } else {
                            if (void 0 !== e.itemData.name) {
                                _this4._owner._raiseCustomCommand(e.itemData.name)
                            }
                        }
                    }
                })
            };
            _proto3.createItems = function(items) {
                if (!items || 0 === items.length) {
                    items = this._getDefaultItems()
                }
                _Bar2.prototype.createItems.call(this, items)
            };
            _proto3._getDefaultItems = function() {
                return [{
                    text: _message.default.format("dxGantt-dialogButtonAdd"),
                    commandId: COMMANDS.taskAddContextItem,
                    icon: this._getIcon("add"),
                    items: [{
                        text: _message.default.format("dxGantt-contextMenuNewTask"),
                        commandId: COMMANDS.createTask,
                        icon: this._getIcon("add-task")
                    }, {
                        text: _message.default.format("dxGantt-contextMenuNewSubtask"),
                        commandId: COMMANDS.createSubTask,
                        icon: this._getIcon("add-sub-task")
                    }]
                }, {
                    text: _message.default.format("dxGantt-dialogTaskDetailsTitle") + "...",
                    commandId: COMMANDS.taskInformation,
                    icon: this._getIcon("task-details")
                }, {
                    text: _message.default.format("dxGantt-contextMenuDeleteTask"),
                    commandId: COMMANDS.removeTask,
                    icon: this._getIcon("delete")
                }, {
                    text: _message.default.format("dxGantt-contextMenuDeleteDependency"),
                    commandId: COMMANDS.removeDependency,
                    icon: this._getIcon("delete-dependency")
                }]
            };
            _proto3._createDefaultItem = function(commandId, text, icon) {
                return {
                    commandId: commandId,
                    text: text,
                    icon: icon
                }
            };
            _proto3.show = function(point, items) {
                this._menu.option("items", items || this._items);
                this._menu.option("position.offset", {
                    x: point.x,
                    y: point.y
                });
                this._menu.show()
            };
            _proto3.isContextMenu = function() {
                return true
            };
            return GanttContextMenuBar
        }(Bar);
        exports.GanttContextMenuBar = GanttContextMenuBar
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/gantt/ui.gantt.data.option.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _component = _interopRequireDefault(__webpack_require__( /*! ../../core/component */ 127));
        var _data_helper = _interopRequireDefault(__webpack_require__( /*! ../../data_helper */ 92));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var DataOption = function(_Component) {
            _inheritsLoose(DataOption, _Component);

            function DataOption(optionName, loadPanel, dataSourceChangedCallback) {
                var _this;
                _this = _Component.call(this) || this;
                _this._optionName = optionName;
                _this._loadPanel = loadPanel;
                _this._dataSourceChangedCallback = dataSourceChangedCallback;
                return _this
            }
            var _proto = DataOption.prototype;
            _proto.insert = function(data, callback, errorCallback) {
                var _this2 = this;
                this._showLoadPanel();
                this._getStore().insert(data).done(function(response) {
                    if (callback) {
                        callback(response)
                    }
                    _this2._hideLoadPanel()
                }).fail(function(error) {
                    if (errorCallback) {
                        errorCallback(error)
                    }
                    _this2._hideLoadPanel()
                })
            };
            _proto.update = function(key, data, callback, errorCallback) {
                var _this3 = this;
                this._showLoadPanel();
                this._getStore().update(key, data).done(function(data, key) {
                    if (callback) {
                        callback(data, key)
                    }
                    _this3._hideLoadPanel()
                }).fail(function(error) {
                    if (errorCallback) {
                        errorCallback(error)
                    }
                    _this3._hideLoadPanel()
                })
            };
            _proto.remove = function(key, callback, errorCallback) {
                var _this4 = this;
                this._showLoadPanel();
                this._getStore().remove(key).done(function(key) {
                    if (callback) {
                        callback(key)
                    }
                    _this4._hideLoadPanel()
                }).fail(function(error) {
                    if (errorCallback) {
                        errorCallback(error)
                    }
                    _this4._hideLoadPanel()
                })
            };
            _proto._dataSourceChangedHandler = function(newItems, e) {
                this._dataSourceChangedCallback(this._optionName, newItems)
            };
            _proto._dataSourceOptions = function() {
                return {
                    paginate: false
                }
            };
            _proto._dataSourceLoadingChangedHandler = function(isLoading) {
                if (isLoading && !this._dataSource.isLoaded()) {
                    this._showLoadPanel()
                } else {
                    this._hideLoadPanel()
                }
            };
            _proto._showLoadPanel = function() {
                this._loadPanel.show()
            };
            _proto._hideLoadPanel = function() {
                this._loadPanel.hide()
            };
            _proto._getStore = function() {
                return this._dataSource.store()
            };
            _proto._getItems = function() {
                return this._getStore()._array || this._dataSource.items()
            };
            return DataOption
        }(_component.default);
        DataOption.include(_data_helper.default);
        var _default = DataOption;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/gantt/ui.gantt.dialogs.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.GanttDialog = void 0;
        var _popup = _interopRequireDefault(__webpack_require__( /*! ../popup */ 46));
        var _form = _interopRequireDefault(__webpack_require__( /*! ../form */ 138));
        __webpack_require__( /*! ../tag_box */ 289);
        __webpack_require__( /*! ../radio_group */ 288);
        var _message = _interopRequireDefault(__webpack_require__( /*! ../../localization/message */ 10));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass)
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o
            };
            return _setPrototypeOf(o, p)
        }
        var GanttDialog = function() {
            function GanttDialog(owner, $element) {
                this._popupInstance = owner._createComponent($element, _popup.default);
                this.infoMap = {
                    TaskEdit: TaskEditDialogInfo,
                    Resources: ResourcesEditDialogInfo,
                    Confirmation: ConfirmDialogInfo,
                    ConstraintViolation: ConstraintViolationDialogInfo
                }
            }
            var _proto = GanttDialog.prototype;
            _proto._apply = function() {
                if (this._dialogInfo.isValidated()) {
                    var result = this._dialogInfo.getResult();
                    this._callback(result);
                    this.hide()
                }
            };
            _proto.show = function(name, parameters, callback, afterClosing, editingOptions) {
                this._callback = callback;
                this._afterClosing = afterClosing;
                if (!this.infoMap[name]) {
                    return
                }
                this._dialogInfo = new this.infoMap[name](parameters, this._apply.bind(this), this.hide.bind(this), editingOptions);
                this._popupInstance.option({
                    showTitle: !!this._dialogInfo.getTitle(),
                    title: this._dialogInfo.getTitle(),
                    toolbarItems: this._dialogInfo.getToolbarItems(),
                    maxWidth: this._dialogInfo.getMaxWidth(),
                    height: this._dialogInfo.getHeight(),
                    contentTemplate: this._dialogInfo.getContentTemplate()
                });
                this._popupInstance.show()
            };
            _proto.hide = function() {
                this._popupInstance.hide();
                if (this._afterClosing) {
                    this._afterClosing()
                }
            };
            return GanttDialog
        }();
        exports.GanttDialog = GanttDialog;
        var DialogInfoBase = function() {
            function DialogInfoBase(parameters, applyAction, hideAction, editingOptions) {
                this._parameters = parameters;
                this._applyAction = applyAction;
                this._hideAction = hideAction;
                this._editingOptions = editingOptions
            }
            var _proto2 = DialogInfoBase.prototype;
            _proto2._getFormItems = function() {
                return {}
            };
            _proto2._getFormCssClass = function() {
                return ""
            };
            _proto2._getFormData = function() {
                return this._parameters
            };
            _proto2._updateParameters = function() {};
            _proto2._getOkToolbarItem = function() {
                return this._getToolbarItem("OK", this._applyAction)
            };
            _proto2._getCancelToolbarItem = function() {
                return this._getToolbarItem("Cancel", this._hideAction)
            };
            _proto2._getYesToolbarItem = function() {
                return this._getToolbarItem("Yes", this._applyAction)
            };
            _proto2._getNoToolbarItem = function() {
                return this._getToolbarItem("No", this._hideAction)
            };
            _proto2._getToolbarItem = function(localizationText, action) {
                return {
                    widget: "dxButton",
                    toolbar: "bottom",
                    options: {
                        text: _message.default.format(localizationText),
                        onClick: action
                    }
                }
            };
            _proto2.getTitle = function() {
                return ""
            };
            _proto2.getToolbarItems = function() {
                return this._editingOptions.enabled ? [this._getOkToolbarItem(), this._getCancelToolbarItem()] : [this._getCancelToolbarItem()]
            };
            _proto2.getMaxWidth = function() {
                return 400
            };
            _proto2.getHeight = function() {
                return "auto"
            };
            _proto2.getContentTemplate = function() {
                var _this = this;
                return function(content) {
                    _this._form = new _form.default(content, {
                        formData: _this._getFormData(),
                        items: _this._getFormItems(),
                        elementAttr: {
                            "class": _this._getFormCssClass()
                        }
                    });
                    return content
                }
            };
            _proto2.getResult = function() {
                var formData = this._form && this._form.option("formData");
                this._updateParameters(formData);
                return this._parameters
            };
            _proto2.isValidated = function() {
                return true
            };
            return DialogInfoBase
        }();
        var TaskEditDialogInfo = function(_DialogInfoBase) {
            _inheritsLoose(TaskEditDialogInfo, _DialogInfoBase);

            function TaskEditDialogInfo() {
                return _DialogInfoBase.apply(this, arguments) || this
            }
            var _proto3 = TaskEditDialogInfo.prototype;
            _proto3.getTitle = function() {
                return _message.default.format("dxGantt-dialogTaskDetailsTitle")
            };
            _proto3._getFormItems = function() {
                var _this2 = this;
                var readOnly = !this._editingOptions.enabled || !this._editingOptions.allowTaskUpdating;
                var readOnlyRange = readOnly || !this._parameters.enableRangeEdit;
                return [{
                    dataField: "title",
                    editorType: "dxTextBox",
                    label: {
                        text: _message.default.format("dxGantt-dialogTitle")
                    },
                    editorOptions: {
                        readOnly: readOnly || this._isReadOnlyField("title")
                    },
                    visible: !this._isHiddenField("title")
                }, {
                    dataField: "start",
                    editorType: "dxDateBox",
                    label: {
                        text: _message.default.format("dxGantt-dialogStartTitle")
                    },
                    editorOptions: {
                        type: "datetime",
                        width: "100%",
                        readOnly: readOnlyRange || this._isReadOnlyField("start")
                    },
                    visible: !this._isHiddenField("start"),
                    validationRules: [{
                        type: "required",
                        message: _message.default.format("validation-required-formatted", _message.default.format("dxGantt-dialogStartTitle"))
                    }]
                }, {
                    dataField: "end",
                    editorType: "dxDateBox",
                    label: {
                        text: _message.default.format("dxGantt-dialogEndTitle")
                    },
                    editorOptions: {
                        type: "datetime",
                        width: "100%",
                        readOnly: readOnlyRange || this._isReadOnlyField("end")
                    },
                    visible: !this._isHiddenField("end"),
                    validationRules: [{
                        type: "required",
                        message: _message.default.format("validation-required-formatted", _message.default.format("dxGantt-dialogEndTitle"))
                    }]
                }, {
                    dataField: "progress",
                    editorType: "dxNumberBox",
                    label: {
                        text: _message.default.format("dxGantt-dialogProgressTitle")
                    },
                    editorOptions: {
                        showSpinButtons: true,
                        min: 0,
                        max: 1,
                        format: "#0%",
                        step: .01,
                        readOnly: readOnlyRange || this._isReadOnlyField("progress")
                    },
                    visible: !this._isHiddenField("progress")
                }, {
                    dataField: "assigned.items",
                    editorType: "dxTagBox",
                    label: {
                        text: _message.default.format("dxGantt-dialogResourcesTitle")
                    },
                    editorOptions: {
                        readOnly: readOnly || !this._editingOptions.allowTaskResourceUpdating,
                        dataSource: this._parameters.resources.items,
                        displayExpr: "text",
                        buttons: [{
                            name: "editResources",
                            location: "after",
                            options: {
                                disabled: !this._editingOptions.allowResourceAdding && !this._editingOptions.allowResourceDeleting,
                                text: "...",
                                hint: _message.default.format("dxGantt-dialogEditResourceListHint"),
                                onClick: function() {
                                    var showTaskEditDialogCallback = function() {
                                        _this2._parameters.showTaskEditDialogCommand.execute()
                                    };
                                    _this2._parameters.showResourcesDialogCommand.execute(showTaskEditDialogCallback)
                                }
                            }
                        }]
                    }
                }]
            };
            _proto3._isReadOnlyField = function(field) {
                return this._parameters.readOnlyFields.indexOf(field) > -1
            };
            _proto3._isHiddenField = function(field) {
                return this._parameters.hiddenFields.indexOf(field) > -1
            };
            _proto3._getFormData = function() {
                var data = {};
                for (var field in this._parameters) {
                    data[field] = "progress" === field ? this._parameters[field] / 100 : this._parameters[field]
                }
                return data
            };
            _proto3._updateParameters = function(formData) {
                this._parameters.title = formData.title;
                this._parameters.start = formData.start;
                this._parameters.end = formData.end;
                this._parameters.progress = 100 * formData.progress;
                this._parameters.assigned = formData.assigned
            };
            _proto3.isValidated = function() {
                var _this$_form;
                var validationResult = null === (_this$_form = this._form) || void 0 === _this$_form ? void 0 : _this$_form.validate();
                return null === validationResult || void 0 === validationResult ? void 0 : validationResult.isValid
            };
            return TaskEditDialogInfo
        }(DialogInfoBase);
        var ResourcesEditDialogInfo = function(_DialogInfoBase2) {
            _inheritsLoose(ResourcesEditDialogInfo, _DialogInfoBase2);

            function ResourcesEditDialogInfo() {
                return _DialogInfoBase2.apply(this, arguments) || this
            }
            var _proto4 = ResourcesEditDialogInfo.prototype;
            _proto4.getTitle = function() {
                return _message.default.format("dxGantt-dialogResourceManagerTitle")
            };
            _proto4._getFormItems = function() {
                var _this3 = this;
                return [{
                    label: {
                        visible: false
                    },
                    dataField: "resources.items",
                    editorType: "dxList",
                    editorOptions: {
                        allowItemDeleting: this._editingOptions.enabled && this._editingOptions.allowResourceDeleting,
                        itemDeleteMode: "static",
                        selectionMode: "none",
                        items: this._parameters.resources.items,
                        height: 250,
                        noDataText: _message.default.format("dxGantt-dialogEditNoResources"),
                        onInitialized: function(e) {
                            _this3.list = e.component
                        },
                        onItemDeleted: function(e) {
                            _this3._parameters.resources.remove(e.itemData)
                        }
                    }
                }, {
                    label: {
                        visible: false
                    },
                    editorType: "dxTextBox",
                    editorOptions: {
                        readOnly: !this._editingOptions.enabled || !this._editingOptions.allowResourceAdding,
                        onInitialized: function(e) {
                            _this3.textBox = e.component
                        },
                        onInput: function(e) {
                            var addButton = e.component.getButton("addResource");
                            var resourceName = e.component.option("text");
                            addButton.option("disabled", 0 === resourceName.length)
                        },
                        buttons: [{
                            name: "addResource",
                            location: "after",
                            options: {
                                text: _message.default.format("dxGantt-dialogButtonAdd"),
                                disabled: true,
                                onClick: function(e) {
                                    var newItem = _this3._parameters.resources.createItem();
                                    newItem.text = _this3.textBox.option("text");
                                    _this3._parameters.resources.add(newItem);
                                    _this3.list.option("items", _this3._parameters.resources.items);
                                    _this3.list.scrollToItem(newItem);
                                    _this3.textBox.reset();
                                    e.component.option("disabled", true)
                                }
                            }
                        }]
                    }
                }]
            };
            return ResourcesEditDialogInfo
        }(DialogInfoBase);
        var ConfirmDialogInfo = function(_DialogInfoBase3) {
            _inheritsLoose(ConfirmDialogInfo, _DialogInfoBase3);

            function ConfirmDialogInfo() {
                return _DialogInfoBase3.apply(this, arguments) || this
            }
            var _proto5 = ConfirmDialogInfo.prototype;
            _proto5.getContentTemplate = function() {
                var _this4 = this;
                return function(content) {
                    return _this4._getConfirmMessage()
                }
            };
            _proto5._getConfirmMessage = function() {
                switch (this._parameters.type) {
                    case 0:
                        return _message.default.format("dxGantt-dialogTaskDeleteConfirmation");
                    case 1:
                        return _message.default.format("dxGantt-dialogDependencyDeleteConfirmation");
                    case 2:
                        return _message.default.format("dxGantt-dialogResourcesDeleteConfirmation", this._parameters.message);
                    default:
                        return ""
                }
            };
            _proto5.getToolbarItems = function() {
                return [this._getYesToolbarItem(), this._getNoToolbarItem()]
            };
            return ConfirmDialogInfo
        }(DialogInfoBase);
        var ConstraintViolationDialogInfo = function(_DialogInfoBase4) {
            _inheritsLoose(ConstraintViolationDialogInfo, _DialogInfoBase4);

            function ConstraintViolationDialogInfo() {
                return _DialogInfoBase4.apply(this, arguments) || this
            }
            var _proto6 = ConstraintViolationDialogInfo.prototype;
            _proto6._getFormItems = function() {
                var items = [];
                items.push({
                    text: _message.default.format("dxGantt-dialogCancelOperationMessage"),
                    value: 0
                });
                items.push({
                    text: _message.default.format("dxGantt-dialogDeleteDependencyMessage"),
                    value: 1
                });
                if (!this._parameters.validationError.critical) {
                    items.push({
                        text: _message.default.format("dxGantt-dialogMoveTaskAndKeepDependencyMessage"),
                        value: 2
                    })
                }
                return [{
                    template: this._parameters.validationError.critical ? _message.default.format("dxGantt-dialogConstraintCriticalViolationMessage") : _message.default.format("dxGantt-dialogConstraintViolationMessage")
                }, {
                    cssClass: "dx-cv-dialog-row",
                    dataField: "option",
                    label: {
                        visible: false
                    },
                    editorType: "dxRadioGroup",
                    editorOptions: {
                        items: items,
                        valueExpr: "value",
                        value: 0
                    }
                }]
            };
            _proto6._getFormCssClass = function() {
                return "dx-cv-dialog"
            };
            _proto6._updateParameters = function(formData) {
                this._parameters.option = formData.option
            };
            return ConstraintViolationDialogInfo
        }(DialogInfoBase)
    },
    /*!*************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/gantt/ui.gantt.cache.js ***!
      \*************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.GanttDataCache = void 0;
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var GanttDataCache = function() {
            function GanttDataCache() {
                this._cache = {};
                this._timers = {}
            }
            var _proto = GanttDataCache.prototype;
            _proto.saveData = function(key, data, keyExpireCallback) {
                if (data) {
                    this._clearTimer(key);
                    var storage = this._getCache(key, true);
                    (0, _extend.extendFromObject)(storage, data, true);
                    if (keyExpireCallback) {
                        this._setExpireTimer(key, keyExpireCallback)
                    }
                }
            };
            _proto.pullDataFromCache = function(key, target) {
                var data = this._getCache(key);
                if (data) {
                    (0, _extend.extendFromObject)(target, data)
                }
                this._onKeyExpired(key)
            };
            _proto.hasData = function(key) {
                return !!this._cache[key]
            };
            _proto._getCache = function(key, forceCreate) {
                if (!this._cache[key] && forceCreate) {
                    this._cache[key] = {}
                }
                return this._cache[key]
            };
            _proto._setExpireTimer = function(key, callback) {
                var _this = this;
                this._timers[key] = setTimeout(function() {
                    callback(key, _this._getCache(key));
                    _this._onKeyExpired(key)
                }, 200)
            };
            _proto._onKeyExpired = function(key) {
                this._clearCache(key);
                this._clearTimer(key)
            };
            _proto._clearCache = function(key) {
                delete this._cache[key]
            };
            _proto._clearTimer = function(key) {
                var timers = this._timers;
                if (timers && timers[key]) {
                    clearTimeout(timers[key]);
                    delete timers[key]
                }
            };
            return GanttDataCache
        }();
        exports.GanttDataCache = GanttDataCache
    },
    /*!*********************************************************!*\
      !*** ./artifacts/transpiled-npm/bundles/modules/viz.js ***!
      \*********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        __webpack_require__( /*! ./core */ 154);
        module.exports = DevExpress.viz = DevExpress.viz || {}
    },
    /*!***********************************************!*\
      !*** ./artifacts/transpiled-npm/viz/chart.js ***!
      \***********************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _extend2 = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _array = __webpack_require__( /*! ../core/utils/array */ 12);
        var _window = __webpack_require__( /*! ../core/utils/window */ 7);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _utils = __webpack_require__( /*! ./utils */ 576);
        var _utils2 = __webpack_require__( /*! ./core/utils */ 14);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _math = __webpack_require__( /*! ../core/utils/math */ 29);
        var _base_chart = __webpack_require__( /*! ./chart_components/base_chart */ 309);
        var _multi_axes_synchronizer = _interopRequireDefault(__webpack_require__( /*! ./chart_components/multi_axes_synchronizer */ 929));
        var _advanced_chart = __webpack_require__( /*! ./chart_components/advanced_chart */ 467);
        var _scroll_bar = __webpack_require__( /*! ./chart_components/scroll_bar */ 938);
        var _crosshair = __webpack_require__( /*! ./chart_components/crosshair */ 474);
        var _range_data_calculator = _interopRequireDefault(__webpack_require__( /*! ./series/helpers/range_data_calculator */ 226));
        var _layout_manager = __webpack_require__( /*! ./chart_components/layout_manager */ 465);
        var _range = __webpack_require__( /*! ./translators/range */ 124);
        var _shutter_zoom = _interopRequireDefault(__webpack_require__( /*! ./chart_components/shutter_zoom */ 939));
        var _zoom_and_pan = _interopRequireDefault(__webpack_require__( /*! ./chart_components/zoom_and_pan */ 940));
        var _annotations = __webpack_require__( /*! ./core/annotations */ 228);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DEFAULT_PANE_NAME = "default";
        var VISUAL_RANGE = "VISUAL_RANGE";
        var DEFAULT_PANES = [{
            name: DEFAULT_PANE_NAME,
            border: {}
        }];
        var DISCRETE = "discrete";
        var _isArray = Array.isArray;

        function getFirstAxisNameForPane(axes, paneName, defaultPane) {
            var result;
            for (var i = 0; i < axes.length; i++) {
                if (axes[i].pane === paneName || void 0 === axes[i].pane && paneName === defaultPane) {
                    result = axes[i].name;
                    break
                }
            }
            if (!result) {
                result = axes[0].name
            }
            return result
        }

        function changeVisibilityAxisGrids(axis, gridVisibility, minorGridVisibility) {
            var gridOpt = axis.getOptions().grid;
            var minorGridOpt = axis.getOptions().minorGrid;
            gridOpt.visible = gridVisibility;
            minorGridOpt && (minorGridOpt.visible = minorGridVisibility)
        }

        function hideGridsOnNonFirstValueAxisForPane(axesForPane) {
            var axisShown = false;
            var hiddenStubAxis = [];
            var minorGridVisibility = axesForPane.some(function(axis) {
                var minorGridOptions = axis.getOptions().minorGrid;
                return minorGridOptions && minorGridOptions.visible
            });
            var gridVisibility = axesForPane.some(function(axis) {
                var gridOptions = axis.getOptions().grid;
                return gridOptions && gridOptions.visible
            });
            if (axesForPane.length > 1) {
                axesForPane.forEach(function(axis) {
                    var gridOpt = axis.getOptions().grid;
                    if (axisShown) {
                        changeVisibilityAxisGrids(axis, false, false)
                    } else {
                        if (gridOpt && gridOpt.visible) {
                            if (axis.getTranslator().getBusinessRange().isEmpty()) {
                                changeVisibilityAxisGrids(axis, false, false);
                                hiddenStubAxis.push(axis)
                            } else {
                                axisShown = true;
                                changeVisibilityAxisGrids(axis, gridVisibility, minorGridVisibility)
                            }
                        }
                    }
                });
                !axisShown && hiddenStubAxis.length && changeVisibilityAxisGrids(hiddenStubAxis[0], gridVisibility, minorGridVisibility)
            }
        }

        function findAxisOptions(valueAxes, valueAxesOptions, axisName) {
            var result;
            var axInd;
            for (axInd = 0; axInd < valueAxesOptions.length; axInd++) {
                if (valueAxesOptions[axInd].name === axisName) {
                    result = valueAxesOptions[axInd];
                    result.priority = axInd;
                    break
                }
            }
            if (!result) {
                for (axInd = 0; axInd < valueAxes.length; axInd++) {
                    if (valueAxes[axInd].name === axisName) {
                        result = valueAxes[axInd].getOptions();
                        result.priority = valueAxes[axInd].priority;
                        break
                    }
                }
            }
            return result
        }

        function findAxis(paneName, axisName, axes) {
            var axis;
            var i;
            for (i = 0; i < axes.length; i++) {
                axis = axes[i];
                if (axis.name === axisName && axis.pane === paneName) {
                    return axis
                }
            }
            if (paneName) {
                return findAxis(void 0, axisName, axes)
            }
        }

        function compareAxes(a, b) {
            return a.priority - b.priority
        }

        function doesPaneExist(panes, paneName) {
            var found = false;
            (0, _iterator.each)(panes, function(_, pane) {
                if (pane.name === paneName) {
                    found = true;
                    return false
                }
            });
            return found
        }

        function accumulate(field, src1, src2, auxSpacing) {
            var val1 = src1[field] || 0;
            var val2 = src2[field] || 0;
            return val1 + val2 + (val1 && val2 ? auxSpacing : 0)
        }

        function pickMax(field, src1, src2) {
            return pickMaxValue(src1[field], src2[field])
        }

        function pickMaxValue(val1, val2) {
            return Math.max(val1 || 0, val2 || 0)
        }

        function getAxisMargins(axis) {
            return axis.getMargins()
        }

        function getHorizontalAxesMargins(axes, getMarginsFunc) {
            return axes.reduce(function(margins, axis) {
                var _axis$getOrthogonalAx;
                var axisMargins = getMarginsFunc(axis);
                var paneMargins = margins.panes[axis.pane] = margins.panes[axis.pane] || {};
                var spacing = axis.getMultipleAxesSpacing();
                paneMargins.top = accumulate("top", paneMargins, axisMargins, spacing);
                paneMargins.bottom = accumulate("bottom", paneMargins, axisMargins, spacing);
                paneMargins.left = pickMax("left", paneMargins, axisMargins);
                paneMargins.right = pickMax("right", paneMargins, axisMargins);
                margins.top = pickMax("top", paneMargins, margins);
                margins.bottom = pickMax("bottom", paneMargins, margins);
                margins.left = pickMax("left", paneMargins, margins);
                margins.right = pickMax("right", paneMargins, margins);
                var orthogonalAxis = null === (_axis$getOrthogonalAx = axis.getOrthogonalAxis) || void 0 === _axis$getOrthogonalAx ? void 0 : _axis$getOrthogonalAx.call(axis);
                if (orthogonalAxis && orthogonalAxis.customPositionIsAvailable() && (!axis.customPositionIsBoundaryOrthogonalAxis() || !orthogonalAxis.customPositionEqualsToPredefined())) {
                    margins[orthogonalAxis.getResolvedBoundaryPosition()] = 0
                }
                return margins
            }, {
                panes: {}
            })
        }

        function getVerticalAxesMargins(axes) {
            return axes.reduce(function(margins, axis) {
                var axisMargins = axis.getMargins();
                var paneMargins = margins.panes[axis.pane] = margins.panes[axis.pane] || {};
                var spacing = axis.getMultipleAxesSpacing();
                paneMargins.top = pickMax("top", paneMargins, axisMargins);
                paneMargins.bottom = pickMax("bottom", paneMargins, axisMargins);
                paneMargins.left = accumulate("left", paneMargins, axisMargins, spacing);
                paneMargins.right = accumulate("right", paneMargins, axisMargins, spacing);
                margins.top = pickMax("top", paneMargins, margins);
                margins.bottom = pickMax("bottom", paneMargins, margins);
                margins.left = pickMax("left", paneMargins, margins);
                margins.right = pickMax("right", paneMargins, margins);
                return margins
            }, {
                panes: {}
            })
        }

        function performActionOnAxes(axes, action, actionArgument1, actionArgument2, actionArgument3) {
            axes.forEach(function(axis) {
                axis[action](actionArgument1 && actionArgument1[axis.pane], actionArgument2 && actionArgument2[axis.pane] || actionArgument2, actionArgument3)
            })
        }

        function shrinkCanvases(isRotated, canvases, sizes, verticalMargins, horizontalMargins) {
            function getMargin(side, margins, pane) {
                var m = (isRotated ? ["left", "right"] : ["top", "bottom"]).indexOf(side) === -1 ? margins : margins.panes[pane] || {};
                return m[side]
            }

            function getMaxMargin(side, margins1, margins2, pane) {
                return pickMaxValue(getMargin(side, margins1, pane), getMargin(side, margins2, pane))
            }
            var getOriginalField = function(field) {
                return "original".concat(field[0].toUpperCase()).concat(field.slice(1))
            };

            function shrink(canvases, paneNames, sizeField, startMargin, endMargin, oppositeMargins) {
                paneNames = paneNames.sort(function(p1, p2) {
                    return canvases[p2][startMargin] - canvases[p1][startMargin]
                });
                paneNames.forEach(function(pane) {
                    var canvas = canvases[pane];
                    oppositeMargins.forEach(function(margin) {
                        canvas[margin] = canvas[getOriginalField(margin)] + getMaxMargin(margin, verticalMargins, horizontalMargins, pane)
                    })
                });
                var firstPane = canvases[paneNames[0]];
                var emptySpace = paneNames.reduce(function(space, paneName) {
                    space -= getMaxMargin(startMargin, verticalMargins, horizontalMargins, paneName) + getMaxMargin(endMargin, verticalMargins, horizontalMargins, paneName);
                    return space
                }, firstPane[sizeField] - firstPane[getOriginalField(endMargin)] - canvases[paneNames[paneNames.length - 1]][getOriginalField(startMargin)]) - _utils2.PANE_PADDING * (paneNames.length - 1);
                emptySpace -= Object.keys(sizes).reduce(function(prev, key) {
                    return prev + (!(0, _utils2.isRelativeHeightPane)(sizes[key]) ? sizes[key].height : 0)
                }, 0);
                paneNames.reduce(function(offset, pane) {
                    var canvas = canvases[pane];
                    var paneSize = sizes[pane];
                    offset -= getMaxMargin(endMargin, verticalMargins, horizontalMargins, pane);
                    canvas[endMargin] = firstPane[sizeField] - offset;
                    offset -= !(0, _utils2.isRelativeHeightPane)(paneSize) ? paneSize.height : Math.floor(emptySpace * paneSize.height);
                    canvas[startMargin] = offset;
                    offset -= getMaxMargin(startMargin, verticalMargins, horizontalMargins, pane) + _utils2.PANE_PADDING;
                    return offset
                }, firstPane[sizeField] - firstPane[getOriginalField(endMargin)] - (emptySpace < 0 ? emptySpace : 0))
            }
            var paneNames = Object.keys(canvases);
            if (!isRotated) {
                shrink(canvases, paneNames, "height", "top", "bottom", ["left", "right"])
            } else {
                shrink(canvases, paneNames, "width", "left", "right", ["top", "bottom"])
            }
            return canvases
        }

        function drawAxesWithTicks(axes, condition, canvases, panesBorderOptions) {
            if (condition) {
                performActionOnAxes(axes, "createTicks", canvases);
                _multi_axes_synchronizer.default.synchronize(axes)
            }
            performActionOnAxes(axes, "draw", !condition && canvases, panesBorderOptions)
        }

        function shiftAxis(side1, side2) {
            var shifts = {};
            return function(axis) {
                if (!axis.customPositionIsAvailable() || axis.customPositionEqualsToPredefined()) {
                    var shift = shifts[axis.pane] = shifts[axis.pane] || {
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0
                    };
                    var spacing = axis.getMultipleAxesSpacing();
                    var margins = axis.getMargins();
                    axis.shift(shift);
                    shift[side1] = accumulate(side1, shift, margins, spacing);
                    shift[side2] = accumulate(side2, shift, margins, spacing)
                } else {
                    axis.shift({
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0
                    })
                }
            }
        }

        function getCommonSize(side, margins) {
            var size = 0;
            var pane;
            var paneMargins;
            for (pane in margins.panes) {
                paneMargins = margins.panes[pane];
                size += "height" === side ? paneMargins.top + paneMargins.bottom : paneMargins.left + paneMargins.right
            }
            return size
        }

        function checkUsedSpace(sizeShortage, side, axes, getMarginFunc) {
            var size = 0;
            if (sizeShortage[side] > 0) {
                size = getCommonSize(side, getMarginFunc(axes, getAxisMargins));
                performActionOnAxes(axes, "hideTitle");
                sizeShortage[side] -= size - getCommonSize(side, getMarginFunc(axes, getAxisMargins))
            }
            if (sizeShortage[side] > 0) {
                performActionOnAxes(axes, "hideOuterElements")
            }
        }

        function axisAnimationEnabled(drawOptions, pointsToAnimation) {
            var pointsCount = pointsToAnimation.reduce(function(sum, count) {
                return sum + count
            }, 0) / pointsToAnimation.length;
            return drawOptions.animate && pointsCount <= drawOptions.animationPointsLimit
        }

        function collectMarkersInfoBySeries(allSeries, filteredSeries, argAxis) {
            var series = [];
            var overloadedSeries = {};
            var argVisualRange = argAxis.visualRange();
            var argTranslator = argAxis.getTranslator();
            var argViewPortFilter = _range_data_calculator.default.getViewPortFilter(argVisualRange || {});
            filteredSeries.forEach(function(s) {
                var valAxis = s.getValueAxis();
                var valVisualRange = valAxis.getCanvasRange();
                var valTranslator = valAxis.getTranslator();
                var seriesIndex = allSeries.indexOf(s);
                var valViewPortFilter = _range_data_calculator.default.getViewPortFilter(valVisualRange || {});
                overloadedSeries[seriesIndex] = {};
                filteredSeries.forEach(function(sr) {
                    return overloadedSeries[seriesIndex][allSeries.indexOf(sr)] = 0
                });
                var seriesPoints = [];
                s.getPoints().filter(function(p) {
                    return p.getOptions().visible && argViewPortFilter(p.argument) && (valViewPortFilter(p.getMinValue(true)) || valViewPortFilter(p.getMaxValue(true)))
                }).forEach(function(p) {
                    var tp = {
                        seriesIndex: seriesIndex,
                        argument: p.argument,
                        value: p.getMaxValue(true),
                        size: p.bubbleSize || p.getOptions().size
                    };
                    if (p.getMinValue(true) !== p.getMaxValue(true)) {
                        var mp = (0, _extend2.extend)({}, tp);
                        mp.value = p.getMinValue(true);
                        mp.x = argTranslator.to(mp.argument, 1);
                        mp.y = valTranslator.to(mp.value, 1);
                        seriesPoints.push(mp)
                    }
                    tp.x = argTranslator.to(tp.argument, 1);
                    tp.y = valTranslator.to(tp.value, 1);
                    seriesPoints.push(tp)
                });
                overloadedSeries[seriesIndex].pointsCount = seriesPoints.length;
                overloadedSeries[seriesIndex].total = 0;
                overloadedSeries[seriesIndex].continuousSeries = 0;
                series.push({
                    name: s.name,
                    index: seriesIndex,
                    points: seriesPoints
                })
            });
            return {
                series: series,
                overloadedSeries: overloadedSeries
            }
        }

        function applyAutoHidePointMarkers(allSeries, filteredSeries, overloadedSeries, argAxis) {
            var argAxisType = argAxis.getOptions().type;
            filteredSeries.forEach(function(s) {
                var seriesIndex = allSeries.indexOf(s);
                s.autoHidePointMarkers = false;
                var tickCount = argAxis.getTicksValues().majorTicksValues.length;
                if (s.autoHidePointMarkersEnabled() && (argAxisType === DISCRETE || overloadedSeries[seriesIndex].pointsCount > tickCount)) {
                    for (var index in overloadedSeries[seriesIndex]) {
                        var i = parseInt(index);
                        if (isNaN(i) || overloadedSeries[seriesIndex].total / overloadedSeries[seriesIndex].continuousSeries < 3) {
                            continue
                        }
                        if (i === seriesIndex) {
                            if (2 * overloadedSeries[i][i] >= overloadedSeries[i].pointsCount) {
                                s.autoHidePointMarkers = true;
                                break
                            }
                        } else {
                            if (overloadedSeries[seriesIndex].total >= overloadedSeries[seriesIndex].pointsCount) {
                                s.autoHidePointMarkers = true;
                                break
                            }
                        }
                    }
                }
            })
        }

        function fastHidingPointMarkersByArea(canvas, markersInfo, series) {
            var area = canvas.width * canvas.height;
            var seriesPoints = markersInfo.series;
            var _loop = function(i) {
                var currentSeries = series.filter(function(s) {
                    return s.name === seriesPoints[i].name
                })[0];
                var points = seriesPoints[i].points;
                var pointSize = points.length ? points[0].size : 0;
                var pointsArea = pointSize * pointSize * points.length;
                if (currentSeries.autoHidePointMarkersEnabled() && pointsArea >= area / seriesPoints.length) {
                    var index = seriesPoints[i].index;
                    currentSeries.autoHidePointMarkers = true;
                    seriesPoints.splice(i, 1);
                    series.splice(series.indexOf(currentSeries), 1);
                    delete markersInfo.overloadedSeries[index]
                }
            };
            for (var i = seriesPoints.length - 1; i >= 0; i--) {
                _loop(i)
            }
        }

        function updateMarkersInfo(points, overloadedSeries) {
            var isContinuousSeries = false;
            for (var i = 0; i < points.length - 1; i++) {
                var curPoint = points[i];
                var size = curPoint.size;
                if ((0, _type.isDefined)(curPoint.x) && (0, _type.isDefined)(curPoint.y)) {
                    for (var j = i + 1; j < points.length; j++) {
                        var nextPoint = points[j];
                        var next_x = null === nextPoint || void 0 === nextPoint ? void 0 : nextPoint.x;
                        var next_y = null === nextPoint || void 0 === nextPoint ? void 0 : nextPoint.y;
                        if (!(0, _type.isDefined)(next_x) || Math.abs(curPoint.x - next_x) >= size) {
                            isContinuousSeries &= j !== i + 1;
                            break
                        } else {
                            var distance = (0, _type.isDefined)(next_x) && (0, _type.isDefined)(next_y) && Math.sqrt(Math.pow(curPoint.x - next_x, 2) + Math.pow(curPoint.y - next_y, 2));
                            if (distance && distance < size) {
                                overloadedSeries[curPoint.seriesIndex][nextPoint.seriesIndex]++;
                                overloadedSeries[curPoint.seriesIndex].total++;
                                if (!isContinuousSeries) {
                                    overloadedSeries[curPoint.seriesIndex].continuousSeries++;
                                    isContinuousSeries = true
                                }
                            }
                        }
                    }
                }
            }
        }
        var dxChart = _advanced_chart.AdvancedChart.inherit({
            _themeSection: "chart",
            _fontFields: ["crosshair.label.font"],
            _initCore: function() {
                this.paneAxis = {};
                this.callBase()
            },
            _init: function() {
                this._containerInitialHeight = (0, _window.hasWindow)() ? this._$element.height() : 0;
                this.callBase()
            },
            _correctAxes: function() {
                this._correctValueAxes(true)
            },
            _getExtraOptions: _common.noop,
            _createPanes: function() {
                var that = this;
                var panes = that.option("panes");
                var panesNameCounter = 0;
                var defaultPane;
                if (!panes || _isArray(panes) && !panes.length) {
                    panes = DEFAULT_PANES
                }
                that.callBase();
                defaultPane = that.option("defaultPane");
                panes = (0, _extend2.extend)(true, [], _isArray(panes) ? panes : [panes]);
                (0, _iterator.each)(panes, function(_, pane) {
                    pane.name = !(0, _type.isDefined)(pane.name) ? DEFAULT_PANE_NAME + panesNameCounter++ : pane.name
                });
                if ((0, _type.isDefined)(defaultPane)) {
                    if (!doesPaneExist(panes, defaultPane)) {
                        that._incidentOccurred("W2101", [defaultPane]);
                        defaultPane = panes[panes.length - 1].name
                    }
                } else {
                    defaultPane = panes[panes.length - 1].name
                }
                that.defaultPane = defaultPane;
                panes = that._isRotated() ? panes.reverse() : panes;
                return panes
            },
            _getAxisRenderingOptions: function() {
                return {
                    axisType: "xyAxes",
                    drawingType: "linear"
                }
            },
            _prepareAxisOptions: function(typeSelector, userOptions, rotated) {
                return {
                    isHorizontal: "argumentAxis" === typeSelector !== rotated,
                    containerColor: this._themeManager.getOptions("containerBackgroundColor")
                }
            },
            _checkPaneName: function(seriesTheme) {
                var paneList = (0, _utils2.map)(this.panes, function(pane) {
                    return pane.name
                });
                seriesTheme.pane = seriesTheme.pane || this.defaultPane;
                return (0, _array.inArray)(seriesTheme.pane, paneList) !== -1
            },
            _initCustomPositioningAxes: function() {
                var that = this;
                var argumentAxis = that.getArgumentAxis();
                var valueAxisName = argumentAxis.getOptions().customPositionAxis;
                var valueAxis = that._valueAxes.filter(function(v) {
                    return v.pane === argumentAxis.pane && (!valueAxisName || valueAxisName === v.name)
                })[0];
                that._valueAxes.forEach(function(v) {
                    if (argumentAxis !== v.getOrthogonalAxis()) {
                        v.getOrthogonalAxis = function() {
                            return argumentAxis
                        };
                        v.customPositionIsBoundaryOrthogonalAxis = function() {
                            return argumentAxis.customPositionIsBoundary()
                        }
                    }
                });
                if ((0, _type.isDefined)(valueAxis) && valueAxis !== argumentAxis.getOrthogonalAxis()) {
                    argumentAxis.getOrthogonalAxis = function() {
                        return valueAxis
                    };
                    argumentAxis.customPositionIsBoundaryOrthogonalAxis = function() {
                        return that._valueAxes.some(function(v) {
                            return v.customPositionIsBoundary()
                        })
                    }
                } else {
                    if ((0, _type.isDefined)(argumentAxis.getOrthogonalAxis()) && !(0, _type.isDefined)(valueAxis)) {
                        argumentAxis.getOrthogonalAxis = _common.noop
                    }
                }
            },
            _getAllAxes: function() {
                return this._argumentAxes.concat(this._valueAxes)
            },
            _resetAxesAnimation: function(isFirstDrawing, isHorizontal) {
                var axes = (0, _type.isDefined)(isHorizontal) ? isHorizontal ^ this._isRotated() ? this._argumentAxes : this._valueAxes : this._getAllAxes();
                axes.forEach(function(a) {
                    a.resetApplyingAnimation(isFirstDrawing)
                })
            },
            _cleanGroups: function() {
                this._getAllAxes().forEach(function(a) {
                    return a.beforeCleanGroups()
                });
                this.callBase();
                this._getAllAxes().forEach(function(a) {
                    return a.afterCleanGroups()
                })
            },
            _axesBoundaryPositioning: function() {
                var that = this;
                var allAxes = that._getAllAxes();
                var boundaryStateChanged = false;
                allAxes.forEach(function(a) {
                    if (!a.customPositionIsAvailable()) {
                        return false
                    }
                    var prevBoundaryState = a.customPositionIsBoundary();
                    a._customBoundaryPosition = a.getCustomBoundaryPosition();
                    boundaryStateChanged |= prevBoundaryState !== a.customPositionIsBoundary()
                });
                return boundaryStateChanged
            },
            _getValueAxis: function(paneName, axisName) {
                var that = this;
                var valueAxes = that._valueAxes;
                var valueAxisOptions = that.option("valueAxis") || {};
                var valueAxesOptions = _isArray(valueAxisOptions) ? valueAxisOptions : [valueAxisOptions];
                var rotated = that._isRotated();
                var crosshairMargins = that._getCrosshairMargins();
                var axisOptions;
                var axis;
                axisName = axisName || getFirstAxisNameForPane(valueAxes, paneName, that.defaultPane);
                axis = findAxis(paneName, axisName, valueAxes);
                if (!axis) {
                    axisOptions = findAxisOptions(valueAxes, valueAxesOptions, axisName);
                    if (!axisOptions) {
                        that._incidentOccurred("W2102", [axisName]);
                        axisOptions = {
                            name: axisName,
                            priority: valueAxes.length
                        }
                    }
                    axis = that._createAxis(false, that._populateAxesOptions("valueAxis", axisOptions, {
                        pane: paneName,
                        name: axisName,
                        optionPath: _isArray(valueAxisOptions) ? "valueAxis[".concat(axisOptions.priority, "]") : "valueAxis",
                        crosshairMargin: rotated ? crosshairMargins.y : crosshairMargins.x
                    }, rotated));
                    axis.applyVisualRangeSetter(that._getVisualRangeSetter());
                    valueAxes.push(axis)
                }
                axis.setPane(paneName);
                return axis
            },
            _correctValueAxes: function(needHideGrids) {
                var that = this;
                var synchronizeMultiAxes = that._themeManager.getOptions("synchronizeMultiAxes");
                var valueAxes = that._valueAxes;
                var paneWithAxis = {};
                that.series.forEach(function(series) {
                    var axis = series.getValueAxis();
                    paneWithAxis[axis.pane] = true
                });
                that.panes.forEach(function(pane) {
                    var paneName = pane.name;
                    if (!paneWithAxis[paneName]) {
                        that._getValueAxis(paneName)
                    }
                    if (needHideGrids && synchronizeMultiAxes) {
                        hideGridsOnNonFirstValueAxisForPane(valueAxes.filter(function(axis) {
                            return axis.pane === paneName
                        }))
                    }
                });
                that._valueAxes = valueAxes.filter(function(axis) {
                    if (!axis.pane) {
                        axis.setPane(that.defaultPane)
                    }
                    return doesPaneExist(that.panes, axis.pane)
                }).sort(compareAxes);
                var defaultAxis = this.getValueAxis();
                that._valueAxes.forEach(function(axis) {
                    var optionPath = axis.getOptions().optionPath;
                    if (optionPath) {
                        var axesWithSamePath = that._valueAxes.filter(function(a) {
                            return a.getOptions().optionPath === optionPath
                        });
                        if (axesWithSamePath.length > 1) {
                            if (axesWithSamePath.some(function(a) {
                                    return a === defaultAxis
                                })) {
                                axesWithSamePath.forEach(function(a) {
                                    if (a !== defaultAxis) {
                                        a.getOptions().optionPath = null
                                    }
                                })
                            } else {
                                axesWithSamePath.forEach(function(a, i) {
                                    if (0 !== i) {
                                        a.getOptions().optionPath = null
                                    }
                                })
                            }
                        }
                    }
                })
            },
            _getSeriesForPane: function(paneName) {
                var paneSeries = [];
                (0, _iterator.each)(this.series, function(_, oneSeries) {
                    if (oneSeries.pane === paneName) {
                        paneSeries.push(oneSeries)
                    }
                });
                return paneSeries
            },
            _createPanesBorderOptions: function() {
                var commonBorderOptions = this._themeManager.getOptions("commonPaneSettings").border;
                var panesBorderOptions = {};
                this.panes.forEach(function(pane) {
                    return panesBorderOptions[pane.name] = (0, _extend2.extend)(true, {}, commonBorderOptions, pane.border)
                });
                return panesBorderOptions
            },
            _createScrollBar: function() {
                var that = this;
                var scrollBarOptions = that._themeManager.getOptions("scrollBar") || {};
                var scrollBarGroup = that._scrollBarGroup;
                if (scrollBarOptions.visible) {
                    scrollBarOptions.rotated = that._isRotated();
                    that._scrollBar = (that._scrollBar || new _scroll_bar.ScrollBar(that._renderer, scrollBarGroup)).update(scrollBarOptions)
                } else {
                    scrollBarGroup.linkRemove();
                    that._scrollBar && that._scrollBar.dispose();
                    that._scrollBar = null
                }
            },
            _prepareToRender: function(drawOptions) {
                var panesBorderOptions = this._createPanesBorderOptions();
                this._createPanesBackground();
                this._appendAxesGroups();
                this._adjustViewport();
                return panesBorderOptions
            },
            _adjustViewport: function() {
                var that = this;
                var series = that._getVisibleSeries();
                var argumentAxis = that.getArgumentAxis();
                var useAggregation = series.some(function(s) {
                    return s.useAggregation()
                });
                var adjustOnZoom = that._themeManager.getOptions("adjustOnZoom");
                var alignToBounds = !argumentAxis.dataVisualRangeIsReduced();
                if (!useAggregation && !adjustOnZoom) {
                    return
                }
                that._valueAxes.forEach(function(axis) {
                    return axis.adjust(alignToBounds)
                })
            },
            _recreateSizeDependentObjects: function(isCanvasChanged) {
                var that = this;
                var series = that._getVisibleSeries();
                var useAggregation = series.some(function(s) {
                    return s.useAggregation()
                });
                var zoomChanged = that._isZooming();
                if (!useAggregation) {
                    return
                }
                that._argumentAxes.forEach(function(axis) {
                    axis.updateCanvas(that._canvas, true)
                });
                series.forEach(function(series) {
                    if (series.useAggregation() && (isCanvasChanged || zoomChanged || !series._useAllAggregatedPoints)) {
                        series.createPoints()
                    }
                });
                that._processSeriesFamilies()
            },
            _isZooming: function() {
                var that = this;
                var argumentAxis = that.getArgumentAxis();
                if (!argumentAxis || !argumentAxis.getTranslator()) {
                    return false
                }
                var businessRange = argumentAxis.getTranslator().getBusinessRange();
                var zoomRange = argumentAxis.getViewport();
                var min = zoomRange ? zoomRange.min : 0;
                var max = zoomRange ? zoomRange.max : 0;
                if ("logarithmic" === businessRange.axisType) {
                    min = (0, _utils2.getLog)(min, businessRange.base);
                    max = (0, _utils2.getLog)(max, businessRange.base)
                }
                var viewportDistance = businessRange.axisType === DISCRETE ? (0, _utils2.getCategoriesInfo)(businessRange.categories, min, max).categories.length : Math.abs(max - min);
                var precision = (0, _math.getPrecision)(viewportDistance);
                precision = precision > 1 ? Math.pow(10, precision - 2) : 1;
                var zoomChanged = Math.round((that._zoomLength - viewportDistance) * precision) / precision !== 0;
                that._zoomLength = viewportDistance;
                return zoomChanged
            },
            _handleSeriesDataUpdated: function() {
                var that = this;
                var viewport = new _range.Range;
                that.series.forEach(function(s) {
                    viewport.addRange(s.getArgumentRange())
                });
                that._argumentAxes.forEach(function(axis) {
                    axis.updateCanvas(that._canvas, true);
                    axis.setBusinessRange(viewport, that._axesReinitialized)
                });
                that.callBase()
            },
            _isLegendInside: function() {
                return this._legend && "inside" === this._legend.getPosition()
            },
            _isRotated: function() {
                return this._themeManager.getOptions("rotated")
            },
            _getLayoutTargets: function() {
                return this.panes
            },
            _applyClipRects: function(panesBorderOptions) {
                var that = this;
                that._drawPanesBorders(panesBorderOptions);
                that._createClipRectsForPanes();
                that._applyClipRectsForAxes();
                that._fillPanesBackground()
            },
            _updateLegendPosition: function(drawOptions, legendHasInsidePosition) {
                var that = this;
                if (drawOptions.drawLegend && that._legend && legendHasInsidePosition) {
                    var panes = that.panes;
                    var newCanvas = (0, _extend2.extend)({}, panes[0].canvas);
                    var layoutManager = new _layout_manager.LayoutManager;
                    newCanvas.right = panes[panes.length - 1].canvas.right;
                    newCanvas.bottom = panes[panes.length - 1].canvas.bottom;
                    layoutManager.layoutInsideLegend(that._legend, newCanvas)
                }
            },
            _allowLegendInsidePosition: function() {
                return true
            },
            _applyExtraSettings: function(series) {
                var that = this;
                var paneIndex = that._getPaneIndex(series.pane);
                var panesClipRects = that._panesClipRects;
                var wideClipRect = panesClipRects.wide[paneIndex];
                series.setClippingParams(panesClipRects.base[paneIndex].id, wideClipRect && wideClipRect.id, that._getPaneBorderVisibility(paneIndex))
            },
            _updatePanesCanvases: function(drawOptions) {
                if (!drawOptions.recreateCanvas) {
                    return
                }(0, _utils2.updatePanesCanvases)(this.panes, this._canvas, this._isRotated())
            },
            _normalizePanesHeight: function() {
                (0, _utils2.normalizePanesHeight)(this.panes)
            },
            _renderScaleBreaks: function() {
                this._valueAxes.concat(this._argumentAxes).forEach(function(axis) {
                    axis.drawScaleBreaks()
                })
            },
            _getArgFilter: function() {
                return _range_data_calculator.default.getViewPortFilter(this.getArgumentAxis().visualRange() || {})
            },
            _applyPointMarkersAutoHiding: function() {
                var that = this;
                var allSeries = that.series;
                if (!that._themeManager.getOptions("autoHidePointMarkers")) {
                    allSeries.forEach(function(s) {
                        return s.autoHidePointMarkers = false
                    });
                    return
                }
                that.panes.forEach(function(_ref) {
                    var borderCoords = _ref.borderCoords,
                        name = _ref.name;
                    var series = allSeries.filter(function(s) {
                        return s.pane === name && s.usePointsToDefineAutoHiding()
                    });
                    var argAxis = that.getArgumentAxis();
                    var markersInfo = collectMarkersInfoBySeries(allSeries, series, argAxis);
                    fastHidingPointMarkersByArea(borderCoords, markersInfo, series);
                    if (markersInfo.series.length) {
                        var argVisualRange = argAxis.visualRange();
                        var argAxisIsDiscrete = argAxis.getOptions().type === DISCRETE;
                        var sortingCallback = argAxisIsDiscrete ? function(p1, p2) {
                            return argVisualRange.categories.indexOf(p1.argument) - argVisualRange.categories.indexOf(p2.argument)
                        } : function(p1, p2) {
                            return p1.argument - p2.argument
                        };
                        var points = [];
                        markersInfo.series.forEach(function(s) {
                            return points = points.concat(s.points)
                        });
                        points.sort(sortingCallback);
                        updateMarkersInfo(points, markersInfo.overloadedSeries);
                        applyAutoHidePointMarkers(allSeries, series, markersInfo.overloadedSeries, argAxis)
                    }
                })
            },
            _renderAxes: function(drawOptions, panesBorderOptions) {
                function calculateTitlesWidth(axes) {
                    return axes.map(function(axis) {
                        if (!axis.getTitle) {
                            return 0
                        }
                        var title = axis.getTitle();
                        return title ? title.bBox.width : 0
                    })
                }
                var that = this;
                var rotated = that._isRotated();
                var synchronizeMultiAxes = that._themeManager.getOptions("synchronizeMultiAxes");
                var scrollBar = that._scrollBar ? [that._scrollBar] : [];
                var extendedArgAxes = that._isArgumentAxisBeforeScrollBar() ? that._argumentAxes.concat(scrollBar) : scrollBar.concat(that._argumentAxes);
                var verticalAxes = rotated ? that._argumentAxes : that._valueAxes;
                var verticalElements = rotated ? extendedArgAxes : that._valueAxes;
                var horizontalAxes = rotated ? that._valueAxes : that._argumentAxes;
                var horizontalElements = rotated ? that._valueAxes : extendedArgAxes;
                var allAxes = verticalAxes.concat(horizontalAxes);
                var allElements = allAxes.concat(scrollBar);
                var verticalAxesFirstDrawing = verticalAxes.some(function(v) {
                    return v.isFirstDrawing()
                });
                that._normalizePanesHeight();
                that._updatePanesCanvases(drawOptions);
                var panesCanvases = that.panes.reduce(function(canvases, pane) {
                    canvases[pane.name] = (0, _extend2.extend)({}, pane.canvas);
                    return canvases
                }, {});
                var paneSizes = that.panes.reduce(function(sizes, pane) {
                    sizes[pane.name] = {
                        height: pane.height,
                        unit: pane.unit
                    };
                    return sizes
                }, {});
                var cleanPanesCanvases = (0, _extend2.extend)(true, {}, panesCanvases);
                that._initCustomPositioningAxes();
                var needCustomAdjustAxes = that._axesBoundaryPositioning();
                if (!drawOptions.adjustAxes && !needCustomAdjustAxes) {
                    drawAxesWithTicks(verticalAxes, !rotated && synchronizeMultiAxes, panesCanvases, panesBorderOptions);
                    drawAxesWithTicks(horizontalAxes, rotated && synchronizeMultiAxes, panesCanvases, panesBorderOptions);
                    performActionOnAxes(allAxes, "prepareAnimation");
                    that._renderScaleBreaks();
                    horizontalAxes.forEach(function(a) {
                        return a.resolveOverlappingForCustomPositioning(verticalAxes)
                    });
                    verticalAxes.forEach(function(a) {
                        return a.resolveOverlappingForCustomPositioning(horizontalAxes)
                    });
                    return false
                }
                if (needCustomAdjustAxes) {
                    allAxes.forEach(function(a) {
                        return a.customPositionIsAvailable() && a.shift({
                            top: 0,
                            left: 0,
                            bottom: 0,
                            right: 0
                        })
                    })
                }
                if (that._scrollBar) {
                    that._scrollBar.setPane(that.panes)
                }
                var vAxesMargins = {
                    panes: {}
                };
                var hAxesMargins = getHorizontalAxesMargins(horizontalElements, function(axis) {
                    return axis.estimateMargins(panesCanvases[axis.pane])
                });
                panesCanvases = shrinkCanvases(rotated, panesCanvases, paneSizes, vAxesMargins, hAxesMargins);
                var drawAxesAndSetCanvases = function(isHorizontal) {
                    var axes = isHorizontal ? horizontalAxes : verticalAxes;
                    var condition = (isHorizontal ? rotated : !rotated) && synchronizeMultiAxes;
                    drawAxesWithTicks(axes, condition, panesCanvases, panesBorderOptions);
                    if (isHorizontal) {
                        hAxesMargins = getHorizontalAxesMargins(horizontalElements, getAxisMargins)
                    } else {
                        vAxesMargins = getVerticalAxesMargins(verticalElements)
                    }
                    panesCanvases = shrinkCanvases(rotated, panesCanvases, paneSizes, vAxesMargins, hAxesMargins)
                };
                drawAxesAndSetCanvases(false);
                drawAxesAndSetCanvases(true);
                if (!that._changesApplying && that._estimateTickIntervals(verticalAxes, panesCanvases)) {
                    drawAxesAndSetCanvases(false)
                }
                var oldTitlesWidth = calculateTitlesWidth(verticalAxes);
                var visibleSeries = that._getVisibleSeries();
                var pointsToAnimation = that._getPointsToAnimation(visibleSeries);
                var axesIsAnimated = axisAnimationEnabled(drawOptions, pointsToAnimation);
                performActionOnAxes(allElements, "updateSize", panesCanvases, axesIsAnimated);
                horizontalElements.forEach(shiftAxis("top", "bottom"));
                verticalElements.forEach(shiftAxis("left", "right"));
                that._renderScaleBreaks();
                that.panes.forEach(function(pane) {
                    (0, _extend2.extend)(pane.canvas, panesCanvases[pane.name])
                });
                that._valueAxes.forEach(function(axis) {
                    axis.setInitRange()
                });
                verticalAxes.forEach(function(axis, i) {
                    var _axis$hasWrap;
                    if (null !== (_axis$hasWrap = axis.hasWrap) && void 0 !== _axis$hasWrap && _axis$hasWrap.call(axis)) {
                        var title = axis.getTitle();
                        var newTitleWidth = title ? title.bBox.width : 0;
                        var offset = newTitleWidth - oldTitlesWidth[i];
                        if ("right" === axis.getOptions().position) {
                            vAxesMargins.right += offset
                        } else {
                            vAxesMargins.left += offset;
                            that.panes.forEach(function(_ref2) {
                                var name = _ref2.name;
                                return vAxesMargins.panes[name].left += offset
                            })
                        }
                        panesCanvases = shrinkCanvases(rotated, panesCanvases, paneSizes, vAxesMargins, hAxesMargins);
                        performActionOnAxes(allElements, "updateSize", panesCanvases, false, false);
                        oldTitlesWidth = calculateTitlesWidth(verticalAxes)
                    }
                });
                if (verticalAxes.some(function(v) {
                        return v.customPositionIsAvailable() && v.getCustomPosition() !== v._axisPosition
                    })) {
                    axesIsAnimated && that._resetAxesAnimation(verticalAxesFirstDrawing, false);
                    performActionOnAxes(verticalAxes, "updateSize", panesCanvases, axesIsAnimated)
                }
                horizontalAxes.forEach(function(a) {
                    return a.resolveOverlappingForCustomPositioning(verticalAxes)
                });
                verticalAxes.forEach(function(a) {
                    return a.resolveOverlappingForCustomPositioning(horizontalAxes)
                });
                return cleanPanesCanvases
            },
            _getExtraTemplatesItems: function() {
                var that = this;
                var allAxes = (that._argumentAxes || []).concat(that._valueAxes || []);
                var elements = that._collectTemplatesFromItems(allAxes);
                return {
                    items: elements.items,
                    groups: elements.groups,
                    launchRequest: function() {
                        allAxes.forEach(function(a) {
                            a.setRenderedState(true)
                        })
                    },
                    doneRequest: function() {
                        allAxes.forEach(function(a) {
                            a.setRenderedState(false)
                        })
                    }
                }
            },
            _estimateTickIntervals: function(axes, canvases) {
                return axes.some(function(axis) {
                    return axis.estimateTickInterval(canvases[axis.pane])
                })
            },
            checkForMoreSpaceForPanesCanvas: function() {
                var that = this;
                var rotated = that._isRotated();
                var panesAreCustomSized = that.panes.filter(function(p) {
                    return p.unit
                }).length === that.panes.length;
                var needSpace = false;
                if (panesAreCustomSized) {
                    var needHorizontalSpace = 0;
                    var needVerticalSpace = 0;
                    if (rotated) {
                        var argAxisRightMargin = that.getArgumentAxis().getMargins().right;
                        var rightPanesIndent = Math.min.apply(Math, that.panes.map(function(p) {
                            return p.canvas.right
                        }));
                        needHorizontalSpace = that._canvas.right + argAxisRightMargin - rightPanesIndent;
                    } else {
                        var argAxisBottomMargin = that.getArgumentAxis().getMargins().bottom;
                        var bottomPanesIndent = Math.min.apply(Math, that.panes.map(function(p) {
                            return p.canvas.bottom
                        }));
                        needVerticalSpace = that._canvas.bottom + argAxisBottomMargin - bottomPanesIndent
                    }
                    needSpace = needHorizontalSpace > 0 || needVerticalSpace > 0 ? {
                        width: needHorizontalSpace,
                        height: needVerticalSpace
                    } : false;
                    if (0 !== needVerticalSpace) {
                        var realSize = that.getSize();
                        var customSize = that.option("size");
                        var container = that._$element[0];
                        var containerHasStyledHeight = !!parseInt(container.style.height) || 0 !== that._containerInitialHeight;
                        if (!rotated && !(customSize && customSize.height) && !containerHasStyledHeight) {
                            that._forceResize(realSize.width, realSize.height + needVerticalSpace);
                            needSpace = false
                        }
                    }
                } else {
                    needSpace = that.layoutManager.needMoreSpaceForPanesCanvas(that._getLayoutTargets(), rotated, function(pane) {
                        return {
                            width: rotated && !!pane.unit,
                            height: !rotated && !!pane.unit
                        }
                    })
                }
                return needSpace
            },
            _forceResize: function(width, height) {
                this._renderer.resize(width, height);
                this._updateSize();
                this._setContentSize();
                this._preserveOriginalCanvas();
                this._updateCanvasClipRect(this._canvas)
            },
            _shrinkAxes: function(sizeShortage, panesCanvases) {
                if (!sizeShortage || !panesCanvases) {
                    return
                }
                this._renderer.stopAllAnimations(true);
                var that = this;
                var rotated = that._isRotated();
                var scrollBar = that._scrollBar ? [that._scrollBar] : [];
                var extendedArgAxes = that._isArgumentAxisBeforeScrollBar() ? that._argumentAxes.concat(scrollBar) : scrollBar.concat(that._argumentAxes);
                var verticalAxes = rotated ? extendedArgAxes : that._valueAxes;
                var horizontalAxes = rotated ? that._valueAxes : extendedArgAxes;
                var allAxes = verticalAxes.concat(horizontalAxes);
                if (sizeShortage.width || sizeShortage.height) {
                    checkUsedSpace(sizeShortage, "height", horizontalAxes, getHorizontalAxesMargins);
                    checkUsedSpace(sizeShortage, "width", verticalAxes, getVerticalAxesMargins);
                    performActionOnAxes(allAxes, "updateSize", panesCanvases);
                    var paneSizes = that.panes.reduce(function(sizes, pane) {
                        sizes[pane.name] = {
                            height: pane.height,
                            unit: pane.unit
                        };
                        return sizes
                    }, {});
                    panesCanvases = shrinkCanvases(rotated, panesCanvases, paneSizes, getVerticalAxesMargins(verticalAxes), getHorizontalAxesMargins(horizontalAxes, getAxisMargins));
                    performActionOnAxes(allAxes, "updateSize", panesCanvases);
                    horizontalAxes.forEach(shiftAxis("top", "bottom"));
                    verticalAxes.forEach(shiftAxis("left", "right"));
                    that.panes.forEach(function(pane) {
                        return (0, _extend2.extend)(pane.canvas, panesCanvases[pane.name])
                    })
                }
            },
            _isArgumentAxisBeforeScrollBar: function() {
                var that = this;
                var argumentAxis = that.getArgumentAxis();
                if (that._scrollBar) {
                    var _argumentAxis$getOpti;
                    var argAxisPosition = argumentAxis.getResolvedBoundaryPosition();
                    var argAxisLabelPosition = null === (_argumentAxis$getOpti = argumentAxis.getOptions().label) || void 0 === _argumentAxis$getOpti ? void 0 : _argumentAxis$getOpti.position;
                    var scrollBarPosition = that._scrollBar.getOptions().position;
                    return argumentAxis.hasNonBoundaryPosition() || scrollBarPosition === argAxisPosition && argAxisLabelPosition !== scrollBarPosition
                }
                return false
            },
            _getPanesParameters: function() {
                var that = this;
                var panes = that.panes;
                var i;
                var params = [];
                for (i = 0; i < panes.length; i++) {
                    if (that._getPaneBorderVisibility(i)) {
                        params.push({
                            coords: panes[i].borderCoords,
                            clipRect: that._panesClipRects.fixed[i]
                        })
                    }
                }
                return params
            },
            _createCrosshairCursor: function() {
                var that = this;
                var options = that._themeManager.getOptions("crosshair") || {};
                var argumentAxis = that.getArgumentAxis();
                var axes = !that._isRotated() ? [
                    [argumentAxis], that._valueAxes
                ] : [that._valueAxes, [argumentAxis]];
                var parameters = {
                    canvas: that._getCommonCanvas(),
                    panes: that._getPanesParameters(),
                    axes: axes
                };
                if (!options || !options.enabled) {
                    return
                }
                if (!that._crosshair) {
                    that._crosshair = new _crosshair.Crosshair(that._renderer, options, parameters, that._crosshairCursorGroup)
                } else {
                    that._crosshair.update(options, parameters)
                }
                that._crosshair.render()
            },
            _getCommonCanvas: function() {
                var i;
                var canvas;
                var commonCanvas;
                var panes = this.panes;
                for (i = 0; i < panes.length; i++) {
                    canvas = panes[i].canvas;
                    if (!commonCanvas) {
                        commonCanvas = (0, _extend2.extend)({}, canvas)
                    } else {
                        commonCanvas.right = canvas.right;
                        commonCanvas.bottom = canvas.bottom
                    }
                }
                return commonCanvas
            },
            _createPanesBackground: function() {
                var that = this;
                var defaultBackgroundColor = that._themeManager.getOptions("commonPaneSettings").backgroundColor;
                var backgroundColor;
                var renderer = that._renderer;
                var rect;
                var i;
                var rects = [];
                that._panesBackgroundGroup.clear();
                for (i = 0; i < that.panes.length; i++) {
                    backgroundColor = that.panes[i].backgroundColor || defaultBackgroundColor;
                    if (!backgroundColor || "none" === backgroundColor) {
                        rects.push(null);
                        continue
                    }
                    rect = renderer.rect(0, 0, 0, 0).attr({
                        fill: backgroundColor,
                        "stroke-width": 0
                    }).append(that._panesBackgroundGroup);
                    rects.push(rect)
                }
                that.panesBackground = rects
            },
            _fillPanesBackground: function() {
                var that = this;
                var bc;
                (0, _iterator.each)(that.panes, function(i, pane) {
                    bc = pane.borderCoords;
                    if (null !== that.panesBackground[i]) {
                        that.panesBackground[i].attr({
                            x: bc.left,
                            y: bc.top,
                            width: bc.width,
                            height: bc.height
                        })
                    }
                })
            },
            _calcPaneBorderCoords: function(pane) {
                var canvas = pane.canvas;
                var bc = pane.borderCoords = pane.borderCoords || {};
                bc.left = canvas.left;
                bc.top = canvas.top;
                bc.right = canvas.width - canvas.right;
                bc.bottom = canvas.height - canvas.bottom;
                bc.width = Math.max(bc.right - bc.left, 0);
                bc.height = Math.max(bc.bottom - bc.top, 0)
            },
            _drawPanesBorders: function(panesBorderOptions) {
                var that = this;
                var rotated = that._isRotated();
                that._panesBorderGroup.linkRemove().clear();
                (0, _iterator.each)(that.panes, function(i, pane) {
                    var borderOptions = panesBorderOptions[pane.name];
                    var attr = {
                        fill: "none",
                        stroke: borderOptions.color,
                        "stroke-opacity": borderOptions.opacity,
                        "stroke-width": borderOptions.width,
                        dashStyle: borderOptions.dashStyle,
                        "stroke-linecap": "square"
                    };
                    that._calcPaneBorderCoords(pane, rotated);
                    if (!borderOptions.visible) {
                        return
                    }
                    var bc = pane.borderCoords;
                    var segmentRectParams = (0, _utils.prepareSegmentRectPoints)(bc.left, bc.top, bc.width, bc.height, borderOptions);
                    that._renderer.path(segmentRectParams.points, segmentRectParams.pathType).attr(attr).append(that._panesBorderGroup)
                });
                that._panesBorderGroup.linkAppend()
            },
            _createClipRect: function(clipArray, index, left, top, width, height) {
                var that = this;
                var clipRect = clipArray[index];
                if (!clipRect) {
                    clipRect = that._renderer.clipRect(left, top, width, height);
                    clipArray[index] = clipRect
                } else {
                    clipRect.attr({
                        x: left,
                        y: top,
                        width: width,
                        height: height
                    })
                }
            },
            _createClipRectsForPanes: function() {
                var that = this;
                var canvas = that._canvas;
                (0, _iterator.each)(that.panes, function(i, pane) {
                    var needWideClipRect = false;
                    var bc = pane.borderCoords;
                    var left = bc.left;
                    var top = bc.top;
                    var width = bc.width;
                    var height = bc.height;
                    var panesClipRects = that._panesClipRects;
                    that._createClipRect(panesClipRects.fixed, i, left, top, width, height);
                    that._createClipRect(panesClipRects.base, i, left, top, width, height);
                    (0, _iterator.each)(that.series, function(_, series) {
                        if (series.pane === pane.name && (series.isFinancialSeries() || series.areErrorBarsVisible())) {
                            needWideClipRect = true
                        }
                    });
                    if (needWideClipRect) {
                        if (that._isRotated()) {
                            top = 0;
                            height = canvas.height
                        } else {
                            left = 0;
                            width = canvas.width
                        }
                        that._createClipRect(panesClipRects.wide, i, left, top, width, height)
                    } else {
                        panesClipRects.wide[i] = null
                    }
                })
            },
            _applyClipRectsForAxes: function() {
                var that = this;
                var axes = that._getAllAxes();
                var chartCanvasClipRectID = that._getCanvasClipRectID();
                for (var i = 0; i < axes.length; i++) {
                    var elementsClipRectID = that._getElementsClipRectID(axes[i].pane);
                    axes[i].applyClipRects(elementsClipRectID, chartCanvasClipRectID)
                }
            },
            _getPaneBorderVisibility: function(paneIndex) {
                var commonPaneBorderVisible = this._themeManager.getOptions("commonPaneSettings").border.visible;
                var pane = this.panes[paneIndex] || {};
                var paneBorder = pane.border || {};
                return "visible" in paneBorder ? paneBorder.visible : commonPaneBorderVisible
            },
            _getCanvasForPane: function(paneName) {
                var panes = this.panes;
                var panesNumber = panes.length;
                var i;
                for (i = 0; i < panesNumber; i++) {
                    if (panes[i].name === paneName) {
                        return panes[i].canvas
                    }
                }
            },
            _getTrackerSettings: function() {
                var that = this;
                var themeManager = that._themeManager;
                return (0, _extend2.extend)(this.callBase(), {
                    chart: that,
                    rotated: that._isRotated(),
                    crosshair: that._getCrosshairOptions().enabled ? that._crosshair : null,
                    stickyHovering: themeManager.getOptions("stickyHovering")
                })
            },
            _resolveLabelOverlappingStack: function() {
                var that = this;
                var isRotated = that._isRotated();
                var shiftDirection = isRotated ? function(box, length) {
                    return {
                        x: box.x - length,
                        y: box.y
                    }
                } : function(box, length) {
                    return {
                        x: box.x,
                        y: box.y - length
                    }
                };
                (0, _iterator.each)(that._getStackPoints(), function(_, stacks) {
                    (0, _iterator.each)(stacks, function(_, points) {
                        _base_chart.overlapping.resolveLabelOverlappingInOneDirection(points, that._getCommonCanvas(), isRotated, shiftDirection, function(a, b) {
                            var coordPosition = isRotated ? 1 : 0;
                            var figureCenter1 = a.labels[0].getFigureCenter()[coordPosition];
                            var figureCenter12 = b.labels[0].getFigureCenter()[coordPosition];
                            if (figureCenter1 - figureCenter12 === 0) {
                                return (a.value() - b.value()) * (a.labels[0].getPoint().series.getValueAxis().getTranslator().isInverted() ? -1 : 1)
                            }
                            return 0
                        })
                    })
                })
            },
            _getStackPoints: function() {
                var stackPoints = {};
                var visibleSeries = this._getVisibleSeries();
                (0, _iterator.each)(visibleSeries, function(_, singleSeries) {
                    var points = singleSeries.getPoints();
                    var stackName = singleSeries.getStackName() || null;
                    (0, _iterator.each)(points, function(_, point) {
                        var argument = point.argument;
                        if (!stackPoints[argument]) {
                            stackPoints[argument] = {}
                        }
                        if (!stackPoints[argument][stackName]) {
                            stackPoints[argument][stackName] = []
                        }
                        stackPoints[argument][stackName].push(point)
                    })
                });
                return stackPoints
            },
            _getCrosshairOptions: function() {
                return this._getOption("crosshair")
            },
            zoomArgument: function(min, max) {
                var that = this;
                if (!that._initialized || !(0, _type.isDefined)(min) && !(0, _type.isDefined)(max)) {
                    return
                }
                that.getArgumentAxis().visualRange([min, max])
            },
            resetVisualRange: function() {
                var that = this;
                var axes = that._argumentAxes;
                var nonVirtualArgumentAxis = that.getArgumentAxis();
                axes.forEach(function(axis) {
                    axis.resetVisualRange(nonVirtualArgumentAxis !== axis);
                    that._applyCustomVisualRangeOption(axis)
                });
                that.callBase()
            },
            getVisibleArgumentBounds: function() {
                var translator = this._argumentAxes[0].getTranslator();
                var range = translator.getBusinessRange();
                var isDiscrete = range.axisType === DISCRETE;
                var categories = range.categories;
                return {
                    minVisible: isDiscrete ? range.minVisible || categories[0] : range.minVisible,
                    maxVisible: isDiscrete ? range.maxVisible || categories[categories.length - 1] : range.maxVisible
                }
            },
            _change_FULL_RENDER: function() {
                this.callBase();
                if (this._changes.has(VISUAL_RANGE)) {
                    this._raiseZoomEndHandlers()
                }
            },
            _getAxesForScaling: function() {
                return [this.getArgumentAxis()].concat(this._valueAxes)
            },
            _applyVisualRangeByVirtualAxes: function(axis, range) {
                var that = this;
                if (axis.isArgumentAxis) {
                    if (axis !== that.getArgumentAxis()) {
                        return true
                    }
                    that._argumentAxes.filter(function(a) {
                        return a !== axis
                    }).forEach(function(a) {
                        return a.visualRange(range, {
                            start: true,
                            end: true
                        })
                    })
                }
                return false
            },
            _raiseZoomEndHandlers: function() {
                this._argumentAxes.forEach(function(axis) {
                    return axis.handleZoomEnd()
                });
                this.callBase()
            },
            _setOptionsByReference: function() {
                this.callBase();
                (0, _extend2.extend)(this._optionsByReference, {
                    "argumentAxis.visualRange": true
                })
            },
            option: function option() {
                var option = this.callBase.apply(this, arguments);
                var valueAxis = this._options.silent("valueAxis");
                if ("array" === (0, _type.type)(valueAxis)) {
                    for (var i = 0; i < valueAxis.length; i++) {
                        var optionPath = "valueAxis[".concat(i, "].visualRange");
                        this._optionsByReference[optionPath] = true
                    }
                }
                return option
            },
            _notifyVisualRange: function() {
                var that = this;
                var argAxis = that._argumentAxes[0];
                var argumentVisualRange = (0, _utils2.convertVisualRangeObject)(argAxis.visualRange(), !_isArray(that.option("argumentAxis.visualRange")));
                if (!argAxis.skipEventRising || !(0, _utils2.rangesAreEqual)(argumentVisualRange, that.option("argumentAxis.visualRange"))) {
                    that.option("argumentAxis.visualRange", argumentVisualRange)
                } else {
                    argAxis.skipEventRising = null
                }
                that.callBase()
            }
        });
        dxChart.addPlugin(_shutter_zoom.default);
        dxChart.addPlugin(_zoom_and_pan.default);
        dxChart.addPlugin(_annotations.plugins.core);
        dxChart.addPlugin(_annotations.plugins.chart);
        (0, _component_registrator.default)("dxChart", dxChart);
        var _default = dxChart;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/core/renderers/animation.js ***!
      \******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.AnimationController = AnimationController;
        exports.animationSvgStep = exports.easingFunctions = void 0;
        var _frame = __webpack_require__( /*! ../../../animation/frame */ 129);
        var noop = function() {};
        var easingFunctions = {
            easeOutCubic: function(pos, start, end) {
                return 1 === pos ? end : (1 - Math.pow(1 - pos, 3)) * (end - start) + +start
            },
            linear: function(pos, start, end) {
                return 1 === pos ? end : pos * (end - start) + +start
            }
        };
        exports.easingFunctions = easingFunctions;
        var animationSvgStep = {
            segments: function segments(elem, params, progress, easing, currentParams) {
                var from = params.from;
                var to = params.to;
                var curSeg;
                var seg;
                var i;
                var j;
                var segments = [];
                for (i = 0; i < from.length; i++) {
                    curSeg = from[i];
                    seg = [curSeg[0]];
                    if (curSeg.length > 1) {
                        for (j = 1; j < curSeg.length; j++) {
                            seg.push(easing(progress, curSeg[j], to[i][j]))
                        }
                    }
                    segments.push(seg)
                }
                currentParams.segments = params.end && 1 === progress ? params.end : segments;
                elem.attr({
                    segments: segments
                })
            },
            arc: function(elem, params, progress, easing) {
                var from = params.from;
                var to = params.to;
                var current = {};
                for (var i in from) {
                    current[i] = easing(progress, from[i], to[i])
                }
                elem.attr(current)
            },
            transform: function(elem, params, progress, easing, currentParams) {
                var from = params.from;
                var to = params.to;
                var current = {};
                for (var i in from) {
                    current[i] = currentParams[i] = easing(progress, from[i], to[i])
                }
                elem.attr(current)
            },
            base: function(elem, params, progress, easing, currentParams, attributeName) {
                var obj = {};
                obj[attributeName] = currentParams[attributeName] = easing(progress, params.from, params.to);
                elem.attr(obj)
            },
            _: noop,
            complete: function(element, currentSettings) {
                element.attr(currentSettings)
            }
        };
        exports.animationSvgStep = animationSvgStep;

        function step(now) {
            var that = this;
            var animateStep = that._animateStep;
            var attrName;
            that._progress = that._calcProgress(now);
            for (attrName in that.params) {
                var anim = animateStep[attrName] || animateStep.base;
                anim(that.element, that.params[attrName], that._progress, that._easing, that._currentParams, attrName)
            }
            that.options.step && that.options.step(that._easing(that._progress, 0, 1), that._progress);
            if (1 === that._progress) {
                return that.stop()
            }
            return true
        }

        function delayTick(now) {
            if (now - this._startTime >= this.delay) {
                this.tick = step
            }
            return true
        }

        function start(now) {
            this._startTime = now;
            this.tick = this.delay ? delayTick : step;
            return true
        }

        function Animation(element, params, options) {
            var that = this;
            that._progress = 0;
            that.element = element;
            that.params = params;
            that.options = options;
            that.duration = options.partitionDuration ? options.duration * options.partitionDuration : options.duration;
            that.delay = options.delay && options.duration * options.delay || 0;
            that._animateStep = options.animateStep || animationSvgStep;
            that._easing = easingFunctions[options.easing] || easingFunctions.easeOutCubic;
            that._currentParams = {};
            that.tick = start
        }
        Animation.prototype = {
            _calcProgress: function(now) {
                return Math.min(1, (now - this.delay - this._startTime) / this.duration)
            },
            stop: function(disableComplete) {
                var that = this;
                var options = that.options;
                var animateStep = that._animateStep;
                that.stop = that.tick = noop;
                animateStep.complete && animateStep.complete(that.element, that._currentParams);
                options.complete && !disableComplete && options.complete()
            }
        };

        function AnimationController(element) {
            var that = this;
            that._animationCount = 0;
            that._timerId = null;
            that._animations = {};
            that.element = element
        }
        AnimationController.prototype = {
            _loop: function() {
                var that = this;
                var animations = that._animations;
                var activeAnimation = 0;
                var now = (new Date).getTime();
                var an;
                var endAnimation = that._endAnimation;
                for (an in animations) {
                    if (!animations[an].tick(now)) {
                        delete animations[an]
                    }
                    activeAnimation++
                }
                if (0 === activeAnimation) {
                    that.stop();
                    that._endAnimationTimer = endAnimation && setTimeout(function() {
                        if (0 === that._animationCount) {
                            endAnimation();
                            that._endAnimation = null
                        }
                    });
                    return
                }
                that._timerId = _frame.requestAnimationFrame.call(null, function() {
                    that._loop()
                }, that.element)
            },
            addAnimation: function(animation) {
                var that = this;
                that._animations[that._animationCount++] = animation;
                clearTimeout(that._endAnimationTimer);
                if (!that._timerId) {
                    clearTimeout(that._startDelay);
                    that._startDelay = setTimeout(function() {
                        that._timerId = 1;
                        that._loop()
                    }, 0)
                }
            },
            animateElement: function(elem, params, options) {
                if (elem && params && options) {
                    elem.animation && elem.animation.stop();
                    this.addAnimation(elem.animation = new Animation(elem, params, options))
                }
            },
            onEndAnimation: function(endAnimation) {
                this._animationCount ? this._endAnimation = endAnimation : endAnimation()
            },
            dispose: function() {
                this.stop();
                this.element = null
            },
            stop: function() {
                var that = this;
                that._animations = {};
                that._animationCount = 0;
                (0, _frame.cancelAnimationFrame)(that._timerId);
                clearTimeout(that._startDelay);
                clearTimeout(that._endAnimationTimer);
                that._timerId = null
            },
            lock: function() {
                var an;
                var animations = this._animations;
                var unstoppable;
                var hasUnstoppableInAnimations;
                for (an in animations) {
                    unstoppable = animations[an].options.unstoppable;
                    hasUnstoppableInAnimations = hasUnstoppableInAnimations || unstoppable;
                    if (!unstoppable) {
                        animations[an].stop(true);
                        delete animations[an]
                    }
                }!hasUnstoppableInAnimations && this.stop()
            }
        }
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/core/themes/generic.light.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _themes = __webpack_require__( /*! ../../themes */ 55);
        var WHITE = "#ffffff";
        var BLACK = "#000000";
        var LIGHT_GREY = "#d3d3d3";
        var GREY_GREEN = "#303030";
        var SOME_GREY = "#2b2b2b";
        var RED = "#ff0000";
        var PRIMARY_TITLE_COLOR = "#232323";
        var SECONDARY_TITLE_COLOR = "#767676";
        var NONE = "none";
        var SOLID = "solid";
        var TOP = "top";
        var RIGHT = "right";
        var BOTTOM = "bottom";
        var LEFT = "left";
        var CENTER = "center";
        var INSIDE = "inside";
        var OUTSIDE = "outside";
        (0, _themes.registerTheme)({
            name: "generic.light",
            isDefault: true,
            font: {
                color: SECONDARY_TITLE_COLOR,
                family: "'Segoe UI', 'Helvetica Neue', 'Trebuchet MS', Verdana, sans-serif",
                weight: 400,
                size: 12,
                cursor: "default"
            },
            redrawOnResize: true,
            backgroundColor: WHITE,
            primaryTitleColor: PRIMARY_TITLE_COLOR,
            secondaryTitleColor: SECONDARY_TITLE_COLOR,
            gridColor: LIGHT_GREY,
            axisColor: SECONDARY_TITLE_COLOR,
            title: {
                backgroundColor: WHITE,
                font: {
                    size: 28,
                    family: "'Segoe UI Light', 'Helvetica Neue Light', 'Segoe UI', 'Helvetica Neue', 'Trebuchet MS', Verdana, sans-serif",
                    weight: 200
                },
                subtitle: {
                    font: {
                        size: 16
                    },
                    offset: 0,
                    wordWrap: "normal",
                    textOverflow: "ellipsis"
                },
                wordWrap: "normal",
                textOverflow: "ellipsis"
            },
            loadingIndicator: {
                text: "Loading..."
            },
            "export": {
                backgroundColor: WHITE,
                margin: 10,
                font: {
                    size: 14,
                    color: PRIMARY_TITLE_COLOR,
                    weight: 400
                },
                button: {
                    margin: {
                        top: 8,
                        left: 10,
                        right: 10,
                        bottom: 8
                    },
                    "default": {
                        color: "#333",
                        borderColor: "#ddd",
                        backgroundColor: WHITE
                    },
                    hover: {
                        color: "#333",
                        borderColor: "#bebebe",
                        backgroundColor: "#e6e6e6"
                    },
                    focus: {
                        color: BLACK,
                        borderColor: "#9d9d9d",
                        backgroundColor: "#e6e6e6"
                    },
                    active: {
                        color: "#333",
                        borderColor: "#9d9d9d",
                        backgroundColor: "#d4d4d4"
                    }
                },
                shadowColor: LIGHT_GREY
            },
            tooltip: {
                enabled: false,
                border: {
                    width: 1,
                    color: LIGHT_GREY,
                    dashStyle: SOLID,
                    visible: true
                },
                font: {
                    color: PRIMARY_TITLE_COLOR
                },
                color: WHITE,
                arrowLength: 10,
                paddingLeftRight: 18,
                paddingTopBottom: 15,
                textAlignment: "center",
                shared: false,
                location: CENTER,
                shadow: {
                    opacity: .4,
                    offsetX: 0,
                    offsetY: 4,
                    blur: 2,
                    color: BLACK
                },
                interactive: false
            },
            legend: {
                hoverMode: "includePoints",
                verticalAlignment: TOP,
                horizontalAlignment: RIGHT,
                position: OUTSIDE,
                visible: true,
                margin: 10,
                markerSize: 12,
                border: {
                    visible: false,
                    width: 1,
                    cornerRadius: 0,
                    dashStyle: SOLID
                },
                paddingLeftRight: 20,
                paddingTopBottom: 15,
                columnCount: 0,
                rowCount: 0,
                columnItemSpacing: 20,
                rowItemSpacing: 8,
                title: {
                    backgroundColor: WHITE,
                    margin: {
                        left: 0,
                        bottom: 9,
                        right: 0,
                        top: 0
                    },
                    font: {
                        size: 18,
                        weight: 200
                    },
                    subtitle: {
                        offset: 0,
                        font: {
                            size: 14
                        },
                        wordWrap: "none",
                        textOverflow: "ellipsis"
                    },
                    wordWrap: "none",
                    textOverflow: "ellipsis"
                }
            },
            "chart:common": {
                animation: {
                    enabled: true,
                    duration: 1e3,
                    easing: "easeOutCubic",
                    maxPointCountSupported: 300
                },
                commonSeriesSettings: {
                    border: {
                        visible: false,
                        width: 2
                    },
                    showInLegend: true,
                    visible: true,
                    hoverMode: "nearestPoint",
                    selectionMode: "includePoints",
                    hoverStyle: {
                        hatching: {
                            direction: RIGHT,
                            width: 2,
                            step: 6,
                            opacity: .75
                        },
                        border: {
                            visible: false,
                            width: 3
                        }
                    },
                    selectionStyle: {
                        hatching: {
                            direction: RIGHT,
                            width: 2,
                            step: 6,
                            opacity: .5
                        },
                        border: {
                            visible: false,
                            width: 3
                        }
                    },
                    valueErrorBar: {
                        displayMode: "auto",
                        value: 1,
                        color: BLACK,
                        lineWidth: 2,
                        edgeLength: 8
                    },
                    label: {
                        visible: false,
                        alignment: CENTER,
                        rotationAngle: 0,
                        horizontalOffset: 0,
                        verticalOffset: 0,
                        radialOffset: 0,
                        showForZeroValues: true,
                        customizeText: void 0,
                        maxLabelCount: void 0,
                        position: OUTSIDE,
                        font: {
                            color: WHITE
                        },
                        border: {
                            visible: false,
                            width: 1,
                            color: LIGHT_GREY,
                            dashStyle: SOLID
                        },
                        connector: {
                            visible: false,
                            width: 1
                        }
                    }
                },
                seriesSelectionMode: "single",
                pointSelectionMode: "single",
                equalRowHeight: true,
                dataPrepareSettings: {
                    checkTypeForAllData: false,
                    convertToAxisDataType: true,
                    sortingMethod: true
                },
                title: {
                    margin: 10
                },
                adaptiveLayout: {
                    width: 80,
                    height: 80,
                    keepLabels: true
                },
                _rtl: {
                    legend: {
                        itemTextPosition: LEFT
                    }
                },
                resolveLabelOverlapping: NONE
            },
            "chart:common:axis": {
                visible: true,
                valueMarginsEnabled: true,
                placeholderSize: null,
                logarithmBase: 10,
                discreteAxisDivisionMode: "betweenLabels",
                width: 1,
                label: {
                    visible: true
                },
                grid: {
                    visible: false,
                    width: 1
                },
                minorGrid: {
                    visible: false,
                    width: 1,
                    opacity: .3
                },
                tick: {
                    visible: true,
                    width: 1,
                    length: 7,
                    shift: 3
                },
                minorTick: {
                    visible: false,
                    width: 1,
                    opacity: .3,
                    length: 7,
                    shift: 3
                },
                stripStyle: {
                    paddingLeftRight: 10,
                    paddingTopBottom: 5
                },
                constantLineStyle: {
                    width: 1,
                    color: BLACK,
                    dashStyle: SOLID,
                    label: {
                        visible: true,
                        position: INSIDE
                    }
                },
                marker: {
                    label: {}
                }
            },
            "chart:common:annotation": {
                font: {
                    color: "#333333"
                },
                tooltipEnabled: true,
                border: {
                    width: 1,
                    color: "#dddddd",
                    dashStyle: SOLID,
                    visible: true
                },
                color: WHITE,
                opacity: .9,
                arrowLength: 14,
                arrowWidth: 14,
                paddingLeftRight: 10,
                paddingTopBottom: 10,
                shadow: {
                    opacity: .15,
                    offsetX: 0,
                    offsetY: 1,
                    blur: 4,
                    color: BLACK
                },
                image: {
                    width: 30,
                    height: 30
                },
                wordWrap: "normal",
                textOverflow: "ellipsis",
                allowDragging: false
            },
            chart: {
                commonSeriesSettings: {
                    type: "line",
                    stack: "default",
                    aggregation: {
                        enabled: void 0
                    },
                    point: {
                        visible: true,
                        symbol: "circle",
                        size: 12,
                        border: {
                            visible: false,
                            width: 1
                        },
                        hoverMode: "onlyPoint",
                        selectionMode: "onlyPoint",
                        hoverStyle: {
                            border: {
                                visible: true,
                                width: 4
                            }
                        },
                        selectionStyle: {
                            border: {
                                visible: true,
                                width: 4
                            }
                        }
                    },
                    scatter: {},
                    line: {
                        width: 2,
                        dashStyle: SOLID,
                        hoverStyle: {
                            width: 3,
                            hatching: {
                                direction: NONE
                            }
                        },
                        selectionStyle: {
                            width: 3
                        }
                    },
                    stackedline: {
                        width: 2,
                        dashStyle: SOLID,
                        hoverStyle: {
                            width: 3,
                            hatching: {
                                direction: NONE
                            }
                        },
                        selectionStyle: {
                            width: 3
                        }
                    },
                    stackedspline: {
                        width: 2,
                        dashStyle: SOLID,
                        hoverStyle: {
                            width: 3,
                            hatching: {
                                direction: NONE
                            }
                        },
                        selectionStyle: {
                            width: 3
                        }
                    },
                    fullstackedline: {
                        width: 2,
                        dashStyle: SOLID,
                        hoverStyle: {
                            width: 3,
                            hatching: {
                                direction: NONE
                            }
                        },
                        selectionStyle: {
                            width: 3
                        }
                    },
                    fullstackedspline: {
                        width: 2,
                        dashStyle: SOLID,
                        hoverStyle: {
                            width: 3,
                            hatching: {
                                direction: NONE
                            }
                        },
                        selectionStyle: {
                            width: 3
                        }
                    },
                    stepline: {
                        width: 2,
                        dashStyle: SOLID,
                        hoverStyle: {
                            width: 3,
                            hatching: {
                                direction: NONE
                            }
                        },
                        selectionStyle: {
                            width: 3
                        }
                    },
                    area: {
                        point: {
                            visible: false
                        },
                        opacity: .5
                    },
                    stackedarea: {
                        point: {
                            visible: false
                        },
                        opacity: .5
                    },
                    fullstackedarea: {
                        point: {
                            visible: false
                        },
                        opacity: .5
                    },
                    fullstackedsplinearea: {
                        point: {
                            visible: false
                        },
                        opacity: .5
                    },
                    steparea: {
                        border: {
                            visible: true,
                            width: 2
                        },
                        point: {
                            visible: false
                        },
                        hoverStyle: {
                            border: {
                                visible: true,
                                width: 3
                            }
                        },
                        selectionStyle: {
                            border: {
                                visible: true,
                                width: 3
                            }
                        },
                        opacity: .5
                    },
                    spline: {
                        width: 2,
                        hoverStyle: {
                            width: 3,
                            hatching: {
                                direction: NONE
                            }
                        },
                        selectionStyle: {
                            width: 3
                        }
                    },
                    splinearea: {
                        point: {
                            visible: false
                        },
                        opacity: .5
                    },
                    stackedsplinearea: {
                        point: {
                            visible: false
                        },
                        opacity: .5
                    },
                    bar: {
                        cornerRadius: 0,
                        point: {
                            hoverStyle: {
                                border: {
                                    visible: false
                                }
                            },
                            selectionStyle: {
                                border: {
                                    visible: false
                                }
                            }
                        }
                    },
                    stackedbar: {
                        cornerRadius: 0,
                        point: {
                            hoverStyle: {
                                border: {
                                    visible: false
                                }
                            },
                            selectionStyle: {
                                border: {
                                    visible: false
                                }
                            }
                        },
                        label: {
                            position: INSIDE
                        }
                    },
                    fullstackedbar: {
                        cornerRadius: 0,
                        point: {
                            hoverStyle: {
                                border: {
                                    visible: false
                                }
                            },
                            selectionStyle: {
                                border: {
                                    visible: false
                                }
                            }
                        },
                        label: {
                            position: INSIDE
                        }
                    },
                    rangebar: {
                        cornerRadius: 0,
                        point: {
                            hoverStyle: {
                                border: {
                                    visible: false
                                }
                            },
                            selectionStyle: {
                                border: {
                                    visible: false
                                }
                            }
                        }
                    },
                    rangearea: {
                        point: {
                            visible: false
                        },
                        opacity: .5
                    },
                    rangesplinearea: {
                        point: {
                            visible: false
                        },
                        opacity: .5
                    },
                    bubble: {
                        opacity: .5,
                        point: {
                            hoverStyle: {
                                border: {
                                    visible: false
                                }
                            },
                            selectionStyle: {
                                border: {
                                    visible: false
                                }
                            }
                        }
                    },
                    candlestick: {
                        width: 1,
                        reduction: {
                            color: RED
                        },
                        hoverStyle: {
                            width: 3,
                            hatching: {
                                direction: NONE
                            }
                        },
                        selectionStyle: {
                            width: 3
                        },
                        point: {
                            border: {
                                visible: true
                            }
                        }
                    },
                    stock: {
                        width: 1,
                        reduction: {
                            color: RED
                        },
                        hoverStyle: {
                            width: 3,
                            hatching: {
                                direction: NONE
                            }
                        },
                        selectionStyle: {
                            width: 3
                        },
                        point: {
                            border: {
                                visible: true
                            }
                        }
                    }
                },
                crosshair: {
                    enabled: false,
                    color: "#f05b41",
                    width: 1,
                    dashStyle: SOLID,
                    label: {
                        visible: false,
                        font: {
                            color: WHITE,
                            size: 12
                        }
                    },
                    verticalLine: {
                        visible: true
                    },
                    horizontalLine: {
                        visible: true
                    }
                },
                commonAxisSettings: {
                    multipleAxesSpacing: 5,
                    forceUserTickInterval: false,
                    breakStyle: {
                        width: 5,
                        color: "#ababab",
                        line: "waved"
                    },
                    label: {
                        displayMode: "standard",
                        overlappingBehavior: "hide",
                        indentFromAxis: 10,
                        wordWrap: "normal",
                        textOverflow: "none"
                    },
                    title: {
                        font: {
                            size: 16
                        },
                        margin: 6,
                        alignment: CENTER
                    },
                    constantLineStyle: {
                        paddingLeftRight: 10,
                        paddingTopBottom: 10
                    }
                },
                horizontalAxis: {
                    position: BOTTOM,
                    axisDivisionFactor: 70,
                    label: {
                        rotationAngle: 90,
                        staggeringSpacing: 5,
                        alignment: CENTER
                    },
                    stripStyle: {
                        label: {
                            horizontalAlignment: CENTER,
                            verticalAlignment: TOP
                        }
                    },
                    constantLineStyle: {
                        label: {
                            horizontalAlignment: RIGHT,
                            verticalAlignment: TOP
                        }
                    },
                    constantLines: []
                },
                verticalAxis: {
                    position: LEFT,
                    axisDivisionFactor: 40,
                    label: {
                        alignment: RIGHT
                    },
                    stripStyle: {
                        label: {
                            horizontalAlignment: LEFT,
                            verticalAlignment: CENTER
                        }
                    },
                    constantLineStyle: {
                        label: {
                            horizontalAlignment: LEFT,
                            verticalAlignment: TOP
                        }
                    },
                    constantLines: []
                },
                argumentAxis: {
                    endOnTick: false,
                    workWeek: [1, 2, 3, 4, 5]
                },
                valueAxis: {
                    grid: {
                        visible: true
                    },
                    autoBreaksEnabled: false,
                    maxAutoBreakCount: 4
                },
                commonPaneSettings: {
                    backgroundColor: NONE,
                    border: {
                        color: LIGHT_GREY,
                        width: 1,
                        visible: false,
                        top: true,
                        bottom: true,
                        left: true,
                        right: true,
                        dashStyle: SOLID
                    }
                },
                scrollBar: {
                    visible: false,
                    offset: 5,
                    color: "gray",
                    width: 10
                },
                adjustOnZoom: true,
                autoHidePointMarkers: true,
                rotated: false,
                synchronizeMultiAxes: true,
                stickyHovering: true,
                barGroupPadding: .3,
                minBubbleSize: 12,
                maxBubbleSize: .2,
                zoomAndPan: {
                    dragBoxStyle: {
                        color: "#2a2a2a",
                        opacity: .2
                    },
                    panKey: "shift",
                    allowMouseWheel: true,
                    allowTouchGestures: true
                }
            },
            pie: {
                innerRadius: .5,
                minDiameter: .5,
                type: "pie",
                dataPrepareSettings: {
                    _skipArgumentSorting: true
                },
                commonSeriesSettings: {
                    pie: {
                        border: {
                            visible: false,
                            width: 2,
                            color: WHITE
                        },
                        hoverStyle: {
                            hatching: {
                                direction: RIGHT,
                                width: 4,
                                step: 10,
                                opacity: .75
                            },
                            border: {
                                visible: false,
                                width: 2
                            }
                        },
                        selectionStyle: {
                            hatching: {
                                direction: RIGHT,
                                width: 4,
                                step: 10,
                                opacity: .5
                            },
                            border: {
                                visible: false,
                                width: 2
                            }
                        }
                    },
                    doughnut: {
                        border: {
                            visible: false,
                            width: 2,
                            color: WHITE
                        },
                        hoverStyle: {
                            hatching: {
                                direction: RIGHT,
                                width: 4,
                                step: 10,
                                opacity: .75
                            },
                            border: {
                                visible: false,
                                width: 2
                            }
                        },
                        selectionStyle: {
                            hatching: {
                                direction: RIGHT,
                                width: 4,
                                step: 10,
                                opacity: .5
                            },
                            border: {
                                visible: false,
                                width: 2
                            }
                        }
                    },
                    donut: {
                        border: {
                            visible: false,
                            width: 2,
                            color: WHITE
                        },
                        hoverStyle: {
                            hatching: {
                                direction: RIGHT,
                                width: 4,
                                step: 10,
                                opacity: .75
                            },
                            border: {
                                visible: false,
                                width: 2
                            }
                        },
                        selectionStyle: {
                            hatching: {
                                direction: RIGHT,
                                width: 4,
                                step: 10,
                                opacity: .5
                            },
                            border: {
                                visible: false,
                                width: 2
                            }
                        }
                    },
                    label: {
                        textOverflow: "ellipsis",
                        wordWrap: "normal"
                    }
                },
                legend: {
                    hoverMode: "allArgumentPoints",
                    backgroundColor: NONE
                },
                adaptiveLayout: {
                    keepLabels: false
                }
            },
            gauge: {
                scale: {
                    tick: {
                        visible: true,
                        length: 5,
                        width: 2,
                        opacity: 1
                    },
                    minorTick: {
                        visible: false,
                        length: 3,
                        width: 1,
                        opacity: 1
                    },
                    label: {
                        visible: true,
                        alignment: CENTER,
                        hideFirstOrLast: "last",
                        overlappingBehavior: "hide"
                    },
                    position: TOP,
                    endOnTick: false
                },
                rangeContainer: {
                    offset: 0,
                    width: 5,
                    backgroundColor: "#808080"
                },
                valueIndicators: {
                    _default: {
                        color: "#c2c2c2"
                    },
                    rangebar: {
                        space: 2,
                        size: 10,
                        color: "#cbc5cf",
                        backgroundColor: NONE,
                        text: {
                            indent: 0,
                            font: {
                                size: 14,
                                color: null
                            }
                        }
                    },
                    twocolorneedle: {
                        secondColor: "#e18e92"
                    },
                    trianglemarker: {
                        space: 2,
                        length: 14,
                        width: 13,
                        color: "#8798a5"
                    },
                    textcloud: {
                        arrowLength: 5,
                        horizontalOffset: 6,
                        verticalOffset: 3,
                        color: "#679ec5",
                        text: {
                            font: {
                                color: WHITE,
                                size: 18
                            }
                        }
                    }
                },
                indicator: {
                    hasPositiveMeaning: true,
                    layout: {
                        horizontalAlignment: CENTER,
                        verticalAlignment: BOTTOM
                    },
                    text: {
                        font: {
                            size: 18
                        }
                    }
                },
                _circular: {
                    scale: {
                        scaleDivisionFactor: 17,
                        orientation: OUTSIDE,
                        label: {
                            indentFromTick: 10
                        }
                    },
                    rangeContainer: {
                        orientation: OUTSIDE
                    },
                    valueIndicatorType: "rectangleneedle",
                    subvalueIndicatorType: "trianglemarker",
                    valueIndicators: {
                        _type: "rectangleneedle",
                        _default: {
                            offset: 20,
                            indentFromCenter: 0,
                            width: 2,
                            spindleSize: 14,
                            spindleGapSize: 10,
                            beginAdaptingAtRadius: 50
                        },
                        triangleneedle: {
                            width: 4
                        },
                        twocolorneedle: {
                            space: 2,
                            secondFraction: .4
                        },
                        rangebar: {
                            offset: 30
                        },
                        trianglemarker: {
                            offset: 6
                        },
                        textcloud: {
                            offset: -6
                        }
                    }
                },
                _linear: {
                    scale: {
                        scaleDivisionFactor: 25,
                        horizontalOrientation: RIGHT,
                        verticalOrientation: BOTTOM,
                        label: {
                            indentFromTick: -10
                        }
                    },
                    rangeContainer: {
                        horizontalOrientation: RIGHT,
                        verticalOrientation: BOTTOM
                    },
                    valueIndicatorType: "rangebar",
                    subvalueIndicatorType: "trianglemarker",
                    valueIndicators: {
                        _type: "rectangle",
                        _default: {
                            offset: 2.5,
                            length: 15,
                            width: 15
                        },
                        rectangle: {
                            width: 10
                        },
                        rangebar: {
                            offset: 10,
                            horizontalOrientation: RIGHT,
                            verticalOrientation: BOTTOM
                        },
                        trianglemarker: {
                            offset: 10,
                            horizontalOrientation: LEFT,
                            verticalOrientation: TOP
                        },
                        textcloud: {
                            offset: -1,
                            horizontalOrientation: LEFT,
                            verticalOrientation: TOP
                        }
                    }
                }
            },
            barGauge: {
                backgroundColor: "#e0e0e0",
                relativeInnerRadius: .3,
                barSpacing: 4,
                resolveLabelOverlapping: "hide",
                label: {
                    indent: 20,
                    connectorWidth: 2,
                    font: {
                        size: 16
                    }
                },
                legend: {
                    visible: false
                },
                indicator: {
                    hasPositiveMeaning: true,
                    layout: {
                        horizontalAlignment: CENTER,
                        verticalAlignment: BOTTOM
                    },
                    text: {
                        font: {
                            size: 18
                        }
                    }
                }
            },
            rangeSelector: {
                scale: {
                    valueMarginsEnabled: true,
                    width: 1,
                    color: BLACK,
                    opacity: .1,
                    showCustomBoundaryTicks: true,
                    label: {
                        overlappingBehavior: "hide",
                        alignment: CENTER,
                        visible: true,
                        topIndent: 7,
                        font: {
                            size: 11
                        }
                    },
                    tick: {
                        width: 1,
                        color: BLACK,
                        opacity: .17,
                        visible: true,
                        length: 12
                    },
                    minorTick: {
                        width: 1,
                        color: BLACK,
                        opacity: .05,
                        visible: true,
                        length: 12
                    },
                    marker: {
                        width: 1,
                        color: "#000000",
                        opacity: .1,
                        visible: true,
                        separatorHeight: 33,
                        topIndent: 10,
                        textLeftIndent: 7,
                        textTopIndent: 11,
                        label: {}
                    },
                    logarithmBase: 10,
                    workWeek: [1, 2, 3, 4, 5],
                    breakStyle: {
                        width: 5,
                        color: "#ababab",
                        line: "waved"
                    },
                    endOnTick: false
                },
                selectedRangeColor: "#606060",
                sliderMarker: {
                    visible: true,
                    paddingTopBottom: 2,
                    paddingLeftRight: 4,
                    color: "#606060",
                    invalidRangeColor: RED,
                    font: {
                        color: WHITE,
                        size: 11
                    }
                },
                sliderHandle: {
                    width: 1,
                    color: BLACK,
                    opacity: .2
                },
                shutter: {
                    opacity: .75
                },
                background: {
                    color: "#c0bae1",
                    visible: true,
                    image: {
                        location: "full"
                    }
                },
                behavior: {
                    snapToTicks: true,
                    animationEnabled: true,
                    moveSelectedRangeByClick: true,
                    manualRangeSelectionEnabled: true,
                    allowSlidersSwap: true,
                    callValueChanged: "onMovingComplete"
                },
                redrawOnResize: true,
                chart: {
                    barGroupPadding: .3,
                    minBubbleSize: 12,
                    maxBubbleSize: .2,
                    topIndent: .1,
                    bottomIndent: 0,
                    valueAxis: {
                        inverted: false,
                        logarithmBase: 10
                    },
                    commonSeriesSettings: {
                        type: "area",
                        aggregation: {
                            enabled: void 0
                        },
                        point: {
                            visible: false
                        },
                        scatter: {
                            point: {
                                visible: true
                            }
                        }
                    }
                }
            },
            map: {
                title: {
                    margin: 10
                },
                background: {
                    borderWidth: 1,
                    borderColor: "#cacaca"
                },
                layer: {
                    label: {
                        enabled: false,
                        stroke: WHITE,
                        "stroke-width": 1,
                        "stroke-opacity": .7,
                        font: {
                            color: SOME_GREY,
                            size: 12
                        }
                    }
                },
                "layer:area": {
                    borderWidth: 1,
                    borderColor: WHITE,
                    color: "#d2d2d2",
                    hoveredBorderColor: GREY_GREEN,
                    selectedBorderWidth: 2,
                    selectedBorderColor: GREY_GREEN,
                    label: {
                        "stroke-width": 2,
                        font: {
                            size: 16
                        }
                    }
                },
                "layer:line": {
                    borderWidth: 2,
                    color: "#ba8365",
                    hoveredColor: "#a94813",
                    selectedBorderWidth: 3,
                    selectedColor: "#e55100",
                    label: {
                        "stroke-width": 2,
                        font: {
                            size: 16
                        }
                    }
                },
                "layer:marker": {
                    label: {
                        enabled: true,
                        "stroke-width": 1,
                        font: {
                            size: 12
                        }
                    }
                },
                "layer:marker:dot": {
                    borderWidth: 2,
                    borderColor: WHITE,
                    size: 8,
                    selectedStep: 2,
                    backStep: 18,
                    backColor: WHITE,
                    backOpacity: .32,
                    shadow: true
                },
                "layer:marker:bubble": {
                    minSize: 20,
                    maxSize: 50,
                    hoveredBorderWidth: 1,
                    hoveredBorderColor: GREY_GREEN,
                    selectedBorderWidth: 2,
                    selectedBorderColor: GREY_GREEN
                },
                "layer:marker:pie": {
                    size: 50,
                    hoveredBorderWidth: 1,
                    hoveredBorderColor: GREY_GREEN,
                    selectedBorderWidth: 2,
                    selectedBorderColor: GREY_GREEN
                },
                "layer:marker:image": {
                    size: 20
                },
                legend: {
                    verticalAlignment: BOTTOM,
                    horizontalAlignment: RIGHT,
                    position: INSIDE,
                    backgroundOpacity: .65,
                    border: {
                        visible: true
                    },
                    paddingLeftRight: 16,
                    paddingTopBottom: 12
                },
                controlBar: {
                    borderColor: "#5d5d5d",
                    borderWidth: 3,
                    color: WHITE,
                    margin: 20,
                    opacity: .3
                },
                _rtl: {
                    legend: {
                        itemTextPosition: LEFT
                    }
                }
            },
            treeMap: {
                tile: {
                    border: {
                        width: 1,
                        opacity: .2,
                        color: "#000000"
                    },
                    color: "#5f8b95",
                    hoverStyle: {
                        hatching: {
                            opacity: .75,
                            step: 6,
                            width: 2,
                            direction: "right"
                        },
                        border: {}
                    },
                    selectionStyle: {
                        hatching: {
                            opacity: .5,
                            step: 6,
                            width: 2,
                            direction: "right"
                        },
                        border: {
                            opacity: 1
                        }
                    },
                    label: {
                        visible: true,
                        paddingLeftRight: 5,
                        paddingTopBottom: 4,
                        font: {
                            color: "#ffffff",
                            weight: 600
                        },
                        shadow: {
                            opacity: .6,
                            offsetX: 0,
                            offsetY: 1,
                            blur: 2,
                            color: "#000000"
                        },
                        wordWrap: "normal",
                        textOverflow: "ellipsis"
                    }
                },
                group: {
                    padding: 4,
                    border: {
                        width: 1
                    },
                    color: "#eeeeee",
                    hoverStyle: {
                        hatching: {
                            opacity: 0,
                            step: 6,
                            width: 2,
                            direction: "right"
                        },
                        border: {}
                    },
                    selectionStyle: {
                        hatching: {
                            opacity: 0,
                            step: 6,
                            width: 2,
                            direction: "right"
                        },
                        border: {}
                    },
                    label: {
                        visible: true,
                        paddingLeftRight: 5,
                        paddingTopBottom: 4,
                        font: {
                            color: SECONDARY_TITLE_COLOR,
                            weight: 600
                        },
                        textOverflow: "ellipsis"
                    }
                },
                title: {
                    subtitle: {}
                },
                tooltip: {},
                loadingIndicator: {}
            },
            sparkline: {
                lineColor: "#666666",
                lineWidth: 2,
                areaOpacity: .2,
                minColor: "#e8c267",
                maxColor: "#e55253",
                barPositiveColor: "#a9a9a9",
                barNegativeColor: "#d7d7d7",
                winColor: "#a9a9a9",
                lossColor: "#d7d7d7",
                firstLastColor: "#666666",
                pointSymbol: "circle",
                pointColor: WHITE,
                pointSize: 4,
                type: "line",
                argumentField: "arg",
                valueField: "val",
                winlossThreshold: 0,
                showFirstLast: true,
                showMinMax: false,
                tooltip: {
                    enabled: true
                }
            },
            bullet: {
                color: "#e8c267",
                targetColor: "#666666",
                targetWidth: 4,
                showTarget: true,
                showZeroLevel: true,
                tooltip: {
                    enabled: true
                }
            },
            polar: {
                commonSeriesSettings: {
                    type: "scatter",
                    closed: true,
                    point: {
                        visible: true,
                        symbol: "circle",
                        size: 12,
                        border: {
                            visible: false,
                            width: 1
                        },
                        hoverMode: "onlyPoint",
                        selectionMode: "onlyPoint",
                        hoverStyle: {
                            border: {
                                visible: true,
                                width: 4
                            },
                            size: 12
                        },
                        selectionStyle: {
                            border: {
                                visible: true,
                                width: 4
                            },
                            size: 12
                        }
                    },
                    scatter: {},
                    line: {
                        width: 2,
                        dashStyle: SOLID,
                        hoverStyle: {
                            width: 3,
                            hatching: {
                                direction: NONE
                            }
                        },
                        selectionStyle: {
                            width: 3
                        }
                    },
                    area: {
                        point: {
                            visible: false
                        },
                        opacity: .5
                    },
                    stackedline: {
                        width: 2
                    },
                    bar: {
                        opacity: .8
                    },
                    stackedbar: {
                        opacity: .8
                    }
                },
                adaptiveLayout: {
                    width: 80,
                    height: 80,
                    keepLabels: true
                },
                barGroupPadding: .3,
                commonAxisSettings: {
                    visible: true,
                    forceUserTickInterval: false,
                    label: {
                        overlappingBehavior: "hide",
                        indentFromAxis: 5
                    },
                    grid: {
                        visible: true
                    },
                    minorGrid: {
                        visible: true
                    },
                    tick: {
                        visible: true
                    },
                    title: {
                        font: {
                            size: 16
                        },
                        margin: 10
                    }
                },
                argumentAxis: {
                    startAngle: 0,
                    firstPointOnStartAngle: false,
                    period: void 0
                },
                valueAxis: {
                    endOnTick: false,
                    tick: {
                        visible: false
                    }
                },
                horizontalAxis: {
                    position: TOP,
                    axisDivisionFactor: 50,
                    label: {
                        alignment: CENTER
                    }
                },
                verticalAxis: {
                    position: TOP,
                    axisDivisionFactor: 30,
                    label: {
                        alignment: RIGHT
                    }
                }
            },
            funnel: {
                sortData: true,
                valueField: "val",
                colorField: "color",
                argumentField: "arg",
                hoverEnabled: true,
                selectionMode: "single",
                item: {
                    border: {
                        visible: false,
                        width: 2,
                        color: WHITE
                    },
                    hoverStyle: {
                        hatching: {
                            opacity: .75,
                            step: 6,
                            width: 2,
                            direction: RIGHT
                        },
                        border: {}
                    },
                    selectionStyle: {
                        hatching: {
                            opacity: .5,
                            step: 6,
                            width: 2,
                            direction: RIGHT
                        },
                        border: {}
                    }
                },
                title: {
                    margin: 10
                },
                adaptiveLayout: {
                    width: 80,
                    height: 80,
                    keepLabels: true
                },
                legend: {
                    visible: false
                },
                _rtl: {
                    legend: {
                        itemTextPosition: LEFT
                    }
                },
                tooltip: {
                    customizeTooltip: function(info) {
                        return {
                            text: info.item.argument + " " + info.valueText
                        }
                    }
                },
                inverted: false,
                algorithm: "dynamicSlope",
                neckWidth: 0,
                neckHeight: 0,
                resolveLabelOverlapping: "shift",
                label: {
                    textOverflow: "ellipsis",
                    wordWrap: "normal",
                    visible: true,
                    horizontalAlignment: RIGHT,
                    horizontalOffset: 0,
                    verticalOffset: 0,
                    showForZeroValues: false,
                    customizeText: function(info) {
                        return info.item.argument + " " + info.valueText
                    },
                    position: "columns",
                    font: {
                        color: WHITE
                    },
                    border: {
                        visible: false,
                        width: 1,
                        color: LIGHT_GREY,
                        dashStyle: SOLID
                    },
                    connector: {
                        visible: true,
                        width: 1,
                        opacity: .5
                    }
                }
            },
            sankey: {
                sourceField: "source",
                targetField: "target",
                weightField: "weight",
                hoverEnabled: true,
                alignment: CENTER,
                adaptiveLayout: {
                    width: 80,
                    height: 80,
                    keepLabels: true
                },
                label: {
                    visible: true,
                    horizontalOffset: 8,
                    verticalOffset: 0,
                    overlappingBehavior: "ellipsis",
                    useNodeColors: false,
                    font: {
                        color: BLACK,
                        weight: 500
                    },
                    border: {
                        visible: false,
                        width: 2,
                        color: WHITE
                    },
                    customizeText: function(info) {
                        return info.title
                    },
                    shadow: {
                        opacity: .2,
                        offsetX: 0,
                        offsetY: 1,
                        blur: 1,
                        color: WHITE
                    }
                },
                title: {
                    margin: 10,
                    font: {
                        size: 28,
                        weight: 200
                    },
                    subtitle: {
                        font: {
                            size: 16
                        }
                    }
                },
                tooltip: {
                    enabled: true
                },
                node: {
                    padding: 30,
                    width: 8,
                    opacity: 1,
                    border: {
                        color: WHITE,
                        width: 1,
                        visible: false
                    },
                    hoverStyle: {
                        hatching: {
                            opacity: .75,
                            step: 6,
                            width: 2,
                            direction: RIGHT
                        },
                        border: {}
                    }
                },
                link: {
                    color: "#888888",
                    colorMode: "none",
                    opacity: .3,
                    border: {
                        color: WHITE,
                        width: 1,
                        visible: false
                    },
                    hoverStyle: {
                        opacity: .5,
                        hatching: {
                            opacity: .75,
                            step: 6,
                            width: 2,
                            direction: RIGHT
                        },
                        border: {}
                    }
                }
            }
        });
        (0, _themes.registerTheme)({
            name: "generic.light.compact"
        }, "generic.light")
    },
    /*!******************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/core/themes/generic.dark.js ***!
      \******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _themes = __webpack_require__( /*! ../../themes */ 55);
        var WHITE = "#ffffff";
        var BLACK = "#000000";
        var SOME_GREY = "#2b2b2b";
        var RANGE_COLOR = "#b5b5b5";
        var GREY_GREEN = "#303030";
        var AREA_LAYER_COLOR = "#686868";
        var LINE_COLOR = "#c7c7c7";
        var TARGET_COLOR = "#8e8e8e";
        var POSITIVE_COLOR = "#b8b8b8";
        var BORDER_COLOR = "#494949";
        (0, _themes.registerTheme)({
            name: "generic.dark",
            font: {
                color: "#808080"
            },
            backgroundColor: "#2a2a2a",
            primaryTitleColor: "#dedede",
            secondaryTitleColor: "#a3a3a3",
            gridColor: "#555555",
            axisColor: "#a3a3a3",
            "export": {
                backgroundColor: "#2a2a2a",
                font: {
                    color: "#dbdbdb"
                },
                button: {
                    "default": {
                        color: "#dedede",
                        borderColor: "#4d4d4d",
                        backgroundColor: "#2e2e2e"
                    },
                    hover: {
                        color: "#dedede",
                        borderColor: "#6c6c6c",
                        backgroundColor: "#444"
                    },
                    focus: {
                        color: "#dedede",
                        borderColor: "#8d8d8d",
                        backgroundColor: "#444444"
                    },
                    active: {
                        color: "#dedede",
                        borderColor: "#8d8d8d",
                        backgroundColor: "#555555"
                    }
                },
                shadowColor: "#292929"
            },
            tooltip: {
                color: SOME_GREY,
                border: {
                    color: BORDER_COLOR
                },
                font: {
                    color: "#929292"
                }
            },
            "chart:common": {
                commonSeriesSettings: {
                    label: {
                        border: {
                            color: BORDER_COLOR
                        }
                    },
                    valueErrorBar: {
                        color: WHITE
                    }
                }
            },
            "chart:common:axis": {
                constantLineStyle: {
                    color: WHITE
                }
            },
            "chart:common:annotation": {
                font: {
                    color: "#929292"
                },
                border: {
                    color: BORDER_COLOR
                },
                color: SOME_GREY,
                shadow: {
                    opacity: .008,
                    offsetY: 4,
                    blur: 8
                }
            },
            chart: {
                commonPaneSettings: {
                    border: {
                        color: BORDER_COLOR
                    }
                },
                commonAxisSettings: {
                    breakStyle: {
                        color: "#818181"
                    }
                },
                zoomAndPan: {
                    dragBoxStyle: {
                        color: WHITE
                    }
                }
            },
            gauge: {
                rangeContainer: {
                    backgroundColor: RANGE_COLOR
                },
                valueIndicators: {
                    _default: {
                        color: RANGE_COLOR
                    },
                    rangebar: {
                        color: "#84788b"
                    },
                    twocolorneedle: {
                        secondColor: "#ba544d"
                    },
                    trianglemarker: {
                        color: "#b7918f"
                    },
                    textcloud: {
                        color: "#ba544d"
                    }
                }
            },
            barGauge: {
                backgroundColor: "#3c3c3c"
            },
            rangeSelector: {
                scale: {
                    tick: {
                        color: WHITE,
                        opacity: .32
                    },
                    minorTick: {
                        color: WHITE,
                        opacity: .1
                    },
                    breakStyle: {
                        color: "#818181"
                    }
                },
                selectedRangeColor: RANGE_COLOR,
                sliderMarker: {
                    color: RANGE_COLOR,
                    font: {
                        color: GREY_GREEN
                    }
                },
                sliderHandle: {
                    color: WHITE,
                    opacity: .2
                },
                shutter: {
                    color: SOME_GREY,
                    opacity: .9
                }
            },
            map: {
                background: {
                    borderColor: "#3f3f3f"
                },
                layer: {
                    label: {
                        stroke: BLACK,
                        font: {
                            color: WHITE
                        }
                    }
                },
                "layer:area": {
                    borderColor: GREY_GREEN,
                    color: AREA_LAYER_COLOR,
                    hoveredBorderColor: WHITE,
                    selectedBorderColor: WHITE
                },
                "layer:line": {
                    color: "#c77244",
                    hoveredColor: "#ff5d04",
                    selectedColor: "#ff784f"
                },
                "layer:marker:bubble": {
                    hoveredBorderColor: WHITE,
                    selectedBorderColor: WHITE
                },
                "layer:marker:pie": {
                    hoveredBorderColor: WHITE,
                    selectedBorderColor: WHITE
                },
                legend: {
                    border: {
                        color: "#3f3f3f"
                    },
                    font: {
                        color: WHITE
                    }
                },
                controlBar: {
                    borderColor: LINE_COLOR,
                    color: GREY_GREEN
                }
            },
            treeMap: {
                group: {
                    color: "#4c4c4c",
                    label: {
                        font: {
                            color: "#a3a3a3"
                        }
                    }
                }
            },
            sparkline: {
                lineColor: LINE_COLOR,
                firstLastColor: LINE_COLOR,
                barPositiveColor: POSITIVE_COLOR,
                barNegativeColor: TARGET_COLOR,
                winColor: POSITIVE_COLOR,
                lossColor: TARGET_COLOR,
                pointColor: GREY_GREEN
            },
            bullet: {
                targetColor: TARGET_COLOR
            },
            funnel: {
                item: {
                    border: {
                        color: "#2a2a2a"
                    }
                }
            },
            sankey: {
                label: {
                    font: {
                        color: WHITE
                    },
                    shadow: {
                        opacity: 0
                    }
                },
                node: {
                    border: {
                        color: "#2a2a2a"
                    }
                },
                link: {
                    color: "#888888",
                    border: {
                        color: "#2a2a2a"
                    },
                    hoverStyle: {
                        color: "#bbbbbb"
                    }
                }
            }
        }, "generic.light");
        (0, _themes.registerTheme)({
            name: "generic.dark.compact"
        }, "generic.dark")
    },
    /*!**********************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/core/themes/generic.contrast.js ***!
      \**********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _themes = __webpack_require__( /*! ../../themes */ 55);
        var WHITE = "#ffffff";
        var BLACK = "#000000";
        var CONTRAST_ACTIVE = "#cf00da";
        var MARKER_COLOR = "#f8ca00";
        var AREA_LAYER_COLOR = "#686868";
        (0, _themes.registerTheme)({
            name: "generic.contrast",
            defaultPalette: "Bright",
            font: {
                color: WHITE
            },
            backgroundColor: BLACK,
            primaryTitleColor: WHITE,
            secondaryTitleColor: WHITE,
            gridColor: WHITE,
            axisColor: WHITE,
            "export": {
                backgroundColor: BLACK,
                font: {
                    color: WHITE
                },
                button: {
                    "default": {
                        color: WHITE,
                        borderColor: WHITE,
                        backgroundColor: BLACK
                    },
                    hover: {
                        color: WHITE,
                        borderColor: WHITE,
                        backgroundColor: "#cf00d7"
                    },
                    focus: {
                        color: WHITE,
                        borderColor: "#cf00d7",
                        backgroundColor: BLACK
                    },
                    active: {
                        color: BLACK,
                        borderColor: WHITE,
                        backgroundColor: WHITE
                    }
                },
                borderColor: WHITE,
                menuButtonColor: BLACK,
                activeBackgroundColor: WHITE,
                activeColor: BLACK,
                selectedBorderColor: CONTRAST_ACTIVE,
                selectedColor: CONTRAST_ACTIVE,
                shadowColor: "none"
            },
            tooltip: {
                border: {
                    color: WHITE
                },
                font: {
                    color: WHITE
                },
                color: BLACK
            },
            "chart:common": {
                commonSeriesSettings: {
                    valueErrorBar: {
                        color: WHITE
                    },
                    hoverStyle: {
                        hatching: {
                            opacity: .5
                        }
                    },
                    selectionStyle: {
                        hatching: {
                            opacity: .35
                        }
                    },
                    label: {
                        font: {
                            color: WHITE
                        },
                        border: {
                            color: WHITE
                        }
                    }
                }
            },
            "chart:common:axis": {
                constantLineStyle: {
                    color: WHITE
                }
            },
            "chart:common:annotation": {
                font: {
                    color: WHITE
                },
                border: {
                    color: WHITE
                },
                color: BLACK
            },
            chart: {
                commonSeriesSettings: {},
                crosshair: {
                    color: "#cf00d7"
                },
                commonPaneSettings: {
                    backgroundColor: BLACK,
                    border: {
                        color: WHITE
                    }
                },
                scrollBar: {
                    color: WHITE
                },
                commonAxisSettings: {
                    breakStyle: {
                        color: "#cf00d7"
                    }
                },
                zoomAndPan: {
                    dragBoxStyle: {
                        color: WHITE,
                        opacity: .7
                    }
                }
            },
            pie: {
                commonSeriesSettings: {
                    pie: {
                        hoverStyle: {
                            hatching: {
                                opacity: .5
                            }
                        },
                        selectionStyle: {
                            hatching: {
                                opacity: .35
                            }
                        }
                    },
                    doughnut: {
                        hoverStyle: {
                            hatching: {
                                opacity: .5
                            }
                        },
                        selectionStyle: {
                            hatching: {
                                opacity: .35
                            }
                        }
                    },
                    donut: {
                        hoverStyle: {
                            hatching: {
                                opacity: .5
                            }
                        },
                        selectionStyle: {
                            hatching: {
                                opacity: .35
                            }
                        }
                    }
                }
            },
            gauge: {
                rangeContainer: {
                    backgroundColor: WHITE
                },
                valueIndicators: {
                    _default: {
                        color: WHITE
                    },
                    rangebar: {
                        color: WHITE,
                        backgroundColor: BLACK
                    },
                    twocolorneedle: {
                        secondColor: WHITE
                    },
                    trianglemarker: {
                        color: WHITE
                    },
                    textcloud: {
                        color: WHITE,
                        text: {
                            font: {
                                color: BLACK
                            }
                        }
                    }
                }
            },
            barGauge: {
                backgroundColor: "#3c3c3c"
            },
            rangeSelector: {
                scale: {
                    tick: {
                        color: WHITE,
                        opacity: .4
                    },
                    minorTick: {
                        color: WHITE,
                        opacity: .12
                    },
                    breakStyle: {
                        color: "#cf00d7"
                    }
                },
                selectedRangeColor: CONTRAST_ACTIVE,
                sliderMarker: {
                    color: CONTRAST_ACTIVE
                },
                sliderHandle: {
                    color: CONTRAST_ACTIVE,
                    opacity: 1
                },
                shutter: {
                    opacity: .75
                },
                background: {
                    color: BLACK
                }
            },
            map: {
                background: {
                    borderColor: WHITE
                },
                layer: {
                    label: {
                        stroke: BLACK,
                        font: {
                            color: WHITE
                        }
                    }
                },
                "layer:area": {
                    borderColor: BLACK,
                    color: AREA_LAYER_COLOR,
                    hoveredBorderColor: WHITE,
                    selectedBorderColor: WHITE,
                    label: {
                        font: {
                            opacity: 1
                        }
                    }
                },
                "layer:line": {
                    color: "#267cff",
                    hoveredColor: "#f613ff",
                    selectedColor: WHITE
                },
                "layer:marker:dot": {
                    borderColor: BLACK,
                    color: MARKER_COLOR,
                    backColor: BLACK,
                    backOpacity: .32
                },
                "layer:marker:bubble": {
                    color: MARKER_COLOR,
                    hoveredBorderColor: WHITE,
                    selectedBorderColor: WHITE
                },
                "layer:marker:pie": {
                    hoveredBorderColor: WHITE,
                    selectedBorderColor: WHITE
                },
                controlBar: {
                    borderColor: WHITE,
                    color: BLACK,
                    opacity: .3
                }
            },
            treeMap: {
                tile: {
                    color: "#70c92f"
                },
                group: {
                    color: "#797979",
                    label: {
                        font: {
                            color: WHITE
                        }
                    }
                }
            },
            sparkline: {
                pointColor: BLACK
            },
            bullet: {},
            polar: {
                commonSeriesSettings: {}
            },
            funnel: {
                label: {
                    connector: {
                        opacity: 1
                    }
                }
            },
            sankey: {
                label: {
                    font: {
                        color: WHITE
                    },
                    shadow: {
                        opacity: 0
                    }
                },
                node: {
                    border: {
                        visible: true,
                        width: 1,
                        color: WHITE
                    }
                },
                link: {
                    opacity: .5,
                    border: {
                        visible: true,
                        width: 1,
                        color: WHITE
                    },
                    hoverStyle: {
                        opacity: .9
                    }
                }
            }
        }, "generic.light");
        (0, _themes.registerTheme)({
            name: "generic.contrast.compact"
        }, "generic.contrast")
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/core/themes/generic.carmine.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _themes = __webpack_require__( /*! ../../themes */ 55);
        var ACCENT_COLOR = "#f05b41";
        var BACKGROUND_COLOR = "#fff";
        var TITLE_COLOR = "#333";
        var SUBTITLE_COLOR = "#8899a8";
        var TEXT_COLOR = "#707070";
        var BORDER_COLOR = "#dee1e3";
        (0, _themes.registerTheme)({
            name: "generic.carmine",
            defaultPalette: "Carmine",
            backgroundColor: BACKGROUND_COLOR,
            primaryTitleColor: TITLE_COLOR,
            secondaryTitleColor: SUBTITLE_COLOR,
            gridColor: BORDER_COLOR,
            axisColor: TEXT_COLOR,
            "export": {
                backgroundColor: BACKGROUND_COLOR,
                font: {
                    color: TITLE_COLOR
                },
                button: {
                    "default": {
                        color: TITLE_COLOR,
                        borderColor: "#b1b7bd",
                        backgroundColor: BACKGROUND_COLOR
                    },
                    hover: {
                        color: TITLE_COLOR,
                        borderColor: "#b1b7bd",
                        backgroundColor: "#faf2f0"
                    },
                    focus: {
                        color: TITLE_COLOR,
                        borderColor: "#6d7781",
                        backgroundColor: "#faf2f0"
                    },
                    active: {
                        color: TITLE_COLOR,
                        borderColor: "#6d7781",
                        backgroundColor: "#f5e7e4"
                    }
                }
            },
            legend: {
                font: {
                    color: TEXT_COLOR
                }
            },
            tooltip: {
                color: BACKGROUND_COLOR,
                border: {
                    color: BORDER_COLOR
                },
                font: {
                    color: TITLE_COLOR
                }
            },
            "chart:common": {
                commonSeriesSettings: {
                    label: {
                        border: {
                            color: BORDER_COLOR
                        }
                    }
                }
            },
            "chart:common:annotation": {
                font: {
                    color: TITLE_COLOR
                },
                border: {
                    color: BORDER_COLOR
                },
                color: BACKGROUND_COLOR
            },
            chart: {
                commonPaneSettings: {
                    border: {
                        color: BORDER_COLOR
                    }
                },
                commonAxisSettings: {
                    breakStyle: {
                        color: "#c1c5c7"
                    }
                }
            },
            rangeSelector: {
                scale: {
                    breakStyle: {
                        color: "#c1c5c7"
                    },
                    tick: {
                        opacity: .12
                    }
                },
                selectedRangeColor: ACCENT_COLOR,
                sliderMarker: {
                    color: ACCENT_COLOR
                },
                sliderHandle: {
                    color: ACCENT_COLOR,
                    opacity: .5
                }
            },
            sparkline: {
                pointColor: BACKGROUND_COLOR,
                minColor: "#f0ad4e",
                maxColor: "#f74d61"
            },
            treeMap: {
                group: {
                    color: BORDER_COLOR,
                    label: {
                        font: {
                            color: SUBTITLE_COLOR
                        }
                    }
                }
            },
            bullet: {
                color: ACCENT_COLOR
            },
            gauge: {
                valueIndicators: {
                    rangebar: {
                        color: ACCENT_COLOR
                    },
                    textcloud: {
                        color: ACCENT_COLOR
                    }
                }
            }
        }, "generic.light");
        (0, _themes.registerTheme)({
            name: "generic.carmine.compact"
        }, "generic.carmine")
    },
    /*!**********************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/core/themes/generic.darkmoon.js ***!
      \**********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _themes = __webpack_require__( /*! ../../themes */ 55);
        var ACCENT_COLOR = "#3debd3";
        var BACKGROUND_COLOR = "#465672";
        var TITLE_COLOR = "#fff";
        var SUBTITLE_COLOR = "#919bac";
        var TEXT_COLOR = "#c7ccd4";
        var BORDER_COLOR = "#596980";
        (0, _themes.registerTheme)({
            name: "generic.darkmoon",
            defaultPalette: "Dark Moon",
            backgroundColor: BACKGROUND_COLOR,
            primaryTitleColor: TITLE_COLOR,
            secondaryTitleColor: SUBTITLE_COLOR,
            gridColor: BORDER_COLOR,
            axisColor: TEXT_COLOR,
            "export": {
                backgroundColor: BACKGROUND_COLOR,
                font: {
                    color: TITLE_COLOR
                },
                button: {
                    "default": {
                        color: TITLE_COLOR,
                        borderColor: "#7a889e",
                        backgroundColor: BACKGROUND_COLOR
                    },
                    hover: {
                        color: TITLE_COLOR,
                        borderColor: "#9da8b8",
                        backgroundColor: "#596e92"
                    },
                    focus: {
                        color: TITLE_COLOR,
                        borderColor: "#c4cad4",
                        backgroundColor: "#596e92"
                    },
                    active: {
                        color: TITLE_COLOR,
                        borderColor: "#c4cad4",
                        backgroundColor: "#6b80a4"
                    }
                }
            },
            legend: {
                font: {
                    color: TEXT_COLOR
                }
            },
            tooltip: {
                color: "#62789e",
                border: {
                    color: BORDER_COLOR
                },
                font: {
                    color: TITLE_COLOR
                }
            },
            "chart:common": {
                commonSeriesSettings: {
                    label: {
                        border: {
                            color: BORDER_COLOR
                        }
                    }
                }
            },
            "chart:common:annotation": {
                font: {
                    color: TITLE_COLOR
                },
                border: {
                    color: BORDER_COLOR
                },
                color: "#62789e"
            },
            chart: {
                commonPaneSettings: {
                    border: {
                        color: BORDER_COLOR
                    }
                },
                commonAxisSettings: {
                    breakStyle: {
                        color: "#73869e"
                    }
                }
            },
            gauge: {
                valueIndicators: {
                    rangebar: {
                        color: ACCENT_COLOR
                    },
                    textcloud: {
                        color: ACCENT_COLOR,
                        text: {
                            font: {
                                color: BACKGROUND_COLOR
                            }
                        }
                    }
                }
            },
            barGauge: {
                backgroundColor: "#526280"
            },
            funnel: {
                item: {
                    border: {
                        color: BACKGROUND_COLOR
                    }
                }
            },
            sparkline: {
                pointColor: BACKGROUND_COLOR,
                minColor: "#f0ad4e",
                maxColor: "#f9517e"
            },
            treeMap: {
                group: {
                    color: BORDER_COLOR,
                    label: {
                        font: {
                            color: TITLE_COLOR
                        }
                    }
                }
            },
            map: {
                background: {
                    borderColor: BORDER_COLOR
                },
                "layer:area": {
                    color: "#97a3b6",
                    borderColor: BACKGROUND_COLOR
                }
            },
            rangeSelector: {
                shutter: {
                    color: BACKGROUND_COLOR
                },
                scale: {
                    breakStyle: {
                        color: "#73869e"
                    },
                    tick: {
                        opacity: .2
                    }
                },
                selectedRangeColor: ACCENT_COLOR,
                sliderMarker: {
                    color: ACCENT_COLOR,
                    font: {
                        color: "#000"
                    }
                },
                sliderHandle: {
                    color: ACCENT_COLOR,
                    opacity: .5
                }
            },
            bullet: {
                color: ACCENT_COLOR
            },
            sankey: {
                link: {
                    border: {
                        color: BACKGROUND_COLOR
                    }
                },
                node: {
                    border: {
                        color: BACKGROUND_COLOR
                    }
                }
            }
        }, "generic.dark");
        (0, _themes.registerTheme)({
            name: "generic.darkmoon.compact"
        }, "generic.darkmoon")
    },
    /*!**********************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/core/themes/generic.softblue.js ***!
      \**********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _themes = __webpack_require__( /*! ../../themes */ 55);
        var ACCENT_COLOR = "#7ab8eb";
        var BACKGROUND_COLOR = "#fff";
        var TITLE_COLOR = "#333";
        var SUBTITLE_COLOR = "#99a1a8";
        var TEXT_COLOR = "#707070";
        var BORDER_COLOR = "#e8eaeb";
        (0, _themes.registerTheme)({
            name: "generic.softblue",
            defaultPalette: "Soft Blue",
            backgroundColor: BACKGROUND_COLOR,
            primaryTitleColor: TITLE_COLOR,
            secondaryTitleColor: SUBTITLE_COLOR,
            gridColor: BORDER_COLOR,
            axisColor: TEXT_COLOR,
            "export": {
                backgroundColor: BACKGROUND_COLOR,
                font: {
                    color: TITLE_COLOR
                },
                button: {
                    "default": {
                        color: TITLE_COLOR,
                        borderColor: "#c9d0d4",
                        backgroundColor: BACKGROUND_COLOR
                    },
                    hover: {
                        color: TITLE_COLOR,
                        borderColor: "#a7b2b9",
                        backgroundColor: "#e6e6e6"
                    },
                    focus: {
                        color: TITLE_COLOR,
                        borderColor: "#82929b",
                        backgroundColor: "#e6e6e6"
                    },
                    active: {
                        color: TITLE_COLOR,
                        borderColor: "#82929b",
                        backgroundColor: "#d4d4d4"
                    }
                }
            },
            legend: {
                font: {
                    color: TEXT_COLOR
                }
            },
            tooltip: {
                color: BACKGROUND_COLOR,
                border: {
                    color: BORDER_COLOR
                },
                font: {
                    color: TITLE_COLOR
                }
            },
            "chart:common": {
                commonSeriesSettings: {
                    label: {
                        border: {
                            color: BORDER_COLOR
                        }
                    }
                }
            },
            "chart:common:annotation": {
                color: BACKGROUND_COLOR,
                border: {
                    color: BORDER_COLOR
                },
                font: {
                    color: TITLE_COLOR
                }
            },
            chart: {
                commonPaneSettings: {
                    border: {
                        color: BORDER_COLOR
                    }
                },
                commonAxisSettings: {
                    breakStyle: {
                        color: "#cfd2d3"
                    }
                }
            },
            rangeSelector: {
                scale: {
                    breakStyle: {
                        color: "#cfd2d3"
                    },
                    tick: {
                        opacity: .12
                    }
                },
                selectedRangeColor: ACCENT_COLOR,
                sliderMarker: {
                    color: ACCENT_COLOR
                },
                sliderHandle: {
                    color: ACCENT_COLOR,
                    opacity: .5
                }
            },
            sparkline: {
                pointColor: BACKGROUND_COLOR,
                minColor: "#f0ad4e",
                maxColor: "#d9534f"
            },
            treeMap: {
                group: {
                    color: BORDER_COLOR,
                    label: {
                        font: {
                            color: SUBTITLE_COLOR
                        }
                    }
                }
            },
            bullet: {
                color: ACCENT_COLOR
            },
            gauge: {
                valueIndicators: {
                    rangebar: {
                        color: ACCENT_COLOR
                    },
                    textcloud: {
                        color: ACCENT_COLOR
                    }
                }
            }
        }, "generic.light");
        (0, _themes.registerTheme)({
            name: "generic.softblue.compact"
        }, "generic.softblue")
    },
    /*!************************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/core/themes/generic.darkviolet.js ***!
      \************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _themes = __webpack_require__( /*! ../../themes */ 55);
        var ACCENT_COLOR = "#9c63ff";
        var BACKGROUND_COLOR = "#17171f";
        var TITLE_COLOR = "#f5f6f7";
        var SUBTITLE_COLOR = "#fff";
        var TEXT_COLOR = "#b2b2b6";
        var BORDER_COLOR = "#343840";
        (0, _themes.registerTheme)({
            name: "generic.darkviolet",
            defaultPalette: "Dark Violet",
            backgroundColor: BACKGROUND_COLOR,
            primaryTitleColor: TITLE_COLOR,
            secondaryTitleColor: SUBTITLE_COLOR,
            gridColor: BORDER_COLOR,
            axisColor: TEXT_COLOR,
            "export": {
                backgroundColor: BACKGROUND_COLOR,
                font: {
                    color: TITLE_COLOR
                },
                button: {
                    "default": {
                        color: TITLE_COLOR,
                        borderColor: "#414152",
                        backgroundColor: BACKGROUND_COLOR
                    },
                    hover: {
                        color: TITLE_COLOR,
                        borderColor: "#5c5c74",
                        backgroundColor: "#2d2d3c"
                    },
                    focus: {
                        color: TITLE_COLOR,
                        borderColor: "#7c7c97",
                        backgroundColor: "#2d2d3c"
                    },
                    active: {
                        color: TITLE_COLOR,
                        borderColor: "#7c7c97",
                        backgroundColor: "#3c3c51"
                    }
                }
            },
            legend: {
                font: {
                    color: TEXT_COLOR
                }
            },
            tooltip: {
                color: BACKGROUND_COLOR,
                border: {
                    color: "#414152"
                },
                font: {
                    color: TITLE_COLOR
                }
            },
            "chart:common": {
                commonSeriesSettings: {
                    label: {
                        border: {
                            color: BORDER_COLOR
                        }
                    }
                }
            },
            "chart:common:annotation": {
                font: {
                    color: TITLE_COLOR
                },
                border: {
                    color: "#414152"
                },
                color: BACKGROUND_COLOR
            },
            chart: {
                commonPaneSettings: {
                    border: {
                        color: BORDER_COLOR
                    }
                },
                commonAxisSettings: {
                    breakStyle: {
                        color: "#575e6b"
                    }
                }
            },
            funnel: {
                item: {
                    border: {
                        color: BACKGROUND_COLOR
                    }
                }
            },
            sparkline: {
                pointColor: BACKGROUND_COLOR,
                minColor: "#f0ad4e",
                maxColor: "#d9534f"
            },
            treeMap: {
                group: {
                    color: BORDER_COLOR,
                    label: {
                        font: {
                            color: SUBTITLE_COLOR
                        }
                    }
                }
            },
            rangeSelector: {
                shutter: {
                    color: BACKGROUND_COLOR
                },
                scale: {
                    breakStyle: {
                        color: "#575e6b"
                    },
                    tick: {
                        opacity: .2
                    }
                },
                selectedRangeColor: ACCENT_COLOR,
                sliderMarker: {
                    color: ACCENT_COLOR,
                    font: {
                        color: "#fff"
                    }
                },
                sliderHandle: {
                    color: ACCENT_COLOR,
                    opacity: .5
                }
            },
            bullet: {
                color: ACCENT_COLOR
            },
            gauge: {
                valueIndicators: {
                    rangebar: {
                        color: ACCENT_COLOR
                    },
                    textcloud: {
                        color: ACCENT_COLOR
                    }
                }
            },
            sankey: {
                link: {
                    border: {
                        color: BACKGROUND_COLOR
                    }
                },
                node: {
                    border: {
                        color: BACKGROUND_COLOR
                    }
                }
            }
        }, "generic.dark");
        (0, _themes.registerTheme)({
            name: "generic.darkviolet.compact"
        }, "generic.darkviolet")
    },
    /*!***********************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/core/themes/generic.greenmist.js ***!
      \***********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _themes = __webpack_require__( /*! ../../themes */ 55);
        var ACCENT_COLOR = "#3cbab2";
        var BACKGROUND_COLOR = "#f5f5f5";
        var TITLE_COLOR = "#28484f";
        var SUBTITLE_COLOR = "#7eb2be";
        var TEXT_COLOR = "#657c80";
        var BORDER_COLOR = "#dedede";
        (0, _themes.registerTheme)({
            name: "generic.greenmist",
            defaultPalette: "Green Mist",
            backgroundColor: BACKGROUND_COLOR,
            primaryTitleColor: TITLE_COLOR,
            secondaryTitleColor: SUBTITLE_COLOR,
            gridColor: BORDER_COLOR,
            axisColor: TEXT_COLOR,
            "export": {
                backgroundColor: BACKGROUND_COLOR,
                font: {
                    color: TITLE_COLOR
                },
                button: {
                    "default": {
                        color: TITLE_COLOR,
                        borderColor: "#a2b4b8",
                        backgroundColor: BACKGROUND_COLOR
                    },
                    hover: {
                        color: TITLE_COLOR,
                        borderColor: "#7f989e",
                        backgroundColor: "rgba(222, 222, 222, 0.4)"
                    },
                    focus: {
                        color: TITLE_COLOR,
                        borderColor: "#5f777c",
                        backgroundColor: "rgba(222, 222, 222, 0.4)"
                    },
                    active: {
                        color: TITLE_COLOR,
                        borderColor: "#5f777c",
                        backgroundColor: "rgba(222, 222, 222, 0.8)"
                    }
                }
            },
            legend: {
                font: {
                    color: TEXT_COLOR
                }
            },
            tooltip: {
                color: "#fff",
                border: {
                    color: BORDER_COLOR
                },
                font: {
                    color: TITLE_COLOR
                }
            },
            "chart:common": {
                commonSeriesSettings: {
                    label: {
                        border: {
                            color: BORDER_COLOR
                        }
                    }
                }
            },
            "chart:common:annotation": {
                color: "#fff",
                border: {
                    color: BORDER_COLOR
                },
                font: {
                    color: TITLE_COLOR
                }
            },
            chart: {
                commonPaneSettings: {
                    border: {
                        color: BORDER_COLOR
                    }
                },
                commonAxisSettings: {
                    breakStyle: {
                        color: "#c1c1c1"
                    }
                }
            },
            funnel: {
                item: {
                    border: {
                        color: BACKGROUND_COLOR
                    }
                }
            },
            sparkline: {
                pointColor: BACKGROUND_COLOR,
                minColor: "#ffc852",
                maxColor: "#f74a5e"
            },
            treeMap: {
                group: {
                    color: BORDER_COLOR,
                    label: {
                        font: {
                            color: SUBTITLE_COLOR
                        }
                    }
                }
            },
            rangeSelector: {
                shutter: {
                    color: BACKGROUND_COLOR
                },
                scale: {
                    breakStyle: {
                        color: "#c1c1c1"
                    },
                    tick: {
                        opacity: .12
                    }
                },
                selectedRangeColor: ACCENT_COLOR,
                sliderMarker: {
                    color: ACCENT_COLOR
                },
                sliderHandle: {
                    color: ACCENT_COLOR,
                    opacity: .5
                }
            },
            bullet: {
                color: ACCENT_COLOR
            },
            gauge: {
                valueIndicators: {
                    rangebar: {
                        color: ACCENT_COLOR
                    },
                    textcloud: {
                        color: ACCENT_COLOR
                    }
                }
            }
        }, "generic.light");
        (0, _themes.registerTheme)({
            name: "generic.greenmist.compact"
        }, "generic.greenmist")
    },
    /*!**************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/core/themes/material.js ***!
      \**************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _themes = __webpack_require__( /*! ../../themes */ 55);
        var FONT_FAMILY = "'Roboto', 'RobotoFallback', 'Helvetica', 'Arial', sans-serif";
        var LIGHT_TITLE_COLOR = "rgba(0,0,0,0.87)";
        var LIGHT_LABEL_COLOR = "rgba(0,0,0,0.54)";
        var DARK_TITLE_COLOR = "rgba(255,255,255,0.87)";
        var DARK_LABEL_COLOR = "rgba(255,255,255,0.54)";
        var DARK_BACKGROUND_COLOR = "#363640";
        var WHITE = "#ffffff";
        var BLACK = "#000000";
        var RANGE_COLOR = "#b5b5b5";
        var AREA_LAYER_COLOR = "#686868";
        var LINE_COLOR = "#c7c7c7";
        var TARGET_COLOR = "#8e8e8e";
        var POSITIVE_COLOR = "#b8b8b8";
        var LABEL_BORDER_COLOR = "#494949";
        var BREAK_STYLE_COLOR = "#818181";
        (0, _themes.registerTheme)({
            name: "material",
            defaultPalette: "Material",
            font: {
                family: FONT_FAMILY
            },
            title: {
                margin: {
                    top: 20,
                    bottom: 20,
                    left: 0,
                    right: 0
                },
                font: {
                    size: 20,
                    family: FONT_FAMILY,
                    weight: 500
                },
                horizontalAlignment: "left",
                subtitle: {
                    font: {
                        size: 14
                    },
                    horizontalAlignment: "left"
                }
            },
            tooltip: {
                shadow: {
                    opacity: 0
                },
                border: {
                    visible: false
                },
                paddingLeftRight: 8,
                paddingTopBottom: 6,
                arrowLength: 0,
                location: "edge",
                color: "#616161",
                font: {
                    color: WHITE
                },
                cornerRadius: 4
            },
            chart: {
                commonAxisSettings: {
                    minorTick: {
                        opacity: .5
                    },
                    label: {
                        font: {
                            size: 11
                        }
                    }
                },
                commonAnnotationSettings: {
                    font: {
                        color: WHITE
                    },
                    border: {
                        color: "#616161"
                    },
                    color: "#616161",
                    arrowLength: 14,
                    arrowWidth: 0,
                    shadow: {
                        opacity: .08,
                        offsetY: 4,
                        blur: 8
                    },
                    cornerRadius: 4
                }
            },
            pie: {
                title: {
                    horizontalAlignment: "center",
                    subtitle: {
                        horizontalAlignment: "center"
                    }
                }
            },
            polar: {
                commonAxisSettings: {
                    minorTick: {
                        opacity: .5
                    }
                },
                title: {
                    horizontalAlignment: "center",
                    subtitle: {
                        horizontalAlignment: "center"
                    }
                }
            },
            funnel: {
                title: {
                    horizontalAlignment: "center",
                    subtitle: {
                        horizontalAlignment: "center"
                    }
                }
            },
            gauge: {
                title: {
                    horizontalAlignment: "center",
                    subtitle: {
                        horizontalAlignment: "center"
                    }
                }
            },
            barGauge: {
                title: {
                    horizontalAlignment: "center",
                    subtitle: {
                        horizontalAlignment: "center"
                    }
                }
            },
            rangeSelector: {
                sliderHandle: {
                    opacity: .5
                }
            },
            treeMap: {
                group: {
                    label: {
                        font: {
                            weight: 500
                        }
                    }
                }
            }
        }, "generic.light");
        (0, _themes.registerTheme)({
            name: "material.light",
            gridColor: "#e0e0e0",
            axisColor: LIGHT_LABEL_COLOR,
            primaryTitleColor: LIGHT_TITLE_COLOR,
            legend: {
                font: {
                    color: LIGHT_LABEL_COLOR
                }
            },
            chart: {
                scrollBar: {
                    color: "#bfbfbf",
                    opacity: .7
                }
            },
            gauge: {
                rangeContainer: {
                    backgroundColor: "rgba(0,0,0,0.2)"
                }
            },
            barGauge: {
                backgroundColor: "#efefef"
            }
        }, "material");
        (0, _themes.registerTheme)({
            name: "material.dark",
            gridColor: "#515159",
            backgroundColor: DARK_BACKGROUND_COLOR,
            axisColor: DARK_LABEL_COLOR,
            font: {
                color: DARK_LABEL_COLOR
            },
            primaryTitleColor: DARK_TITLE_COLOR,
            secondaryTitleColor: DARK_TITLE_COLOR,
            tooltip: {
                color: "#000"
            },
            "export": {
                backgroundColor: DARK_BACKGROUND_COLOR,
                font: {
                    color: "#dbdbdb"
                },
                button: {
                    "default": {
                        color: "#dedede",
                        borderColor: "#4d4d4d",
                        backgroundColor: DARK_BACKGROUND_COLOR
                    },
                    hover: {
                        color: "#dedede",
                        borderColor: "#6c6c6c",
                        backgroundColor: "#3f3f4b"
                    },
                    focus: {
                        color: "#dedede",
                        borderColor: "#8d8d8d",
                        backgroundColor: "#494956"
                    },
                    active: {
                        color: "#dedede",
                        borderColor: "#8d8d8d",
                        backgroundColor: "#494956"
                    }
                },
                shadowColor: "#292929"
            },
            "chart:common": {
                commonSeriesSettings: {
                    label: {
                        border: {
                            color: LABEL_BORDER_COLOR
                        }
                    },
                    valueErrorBar: {
                        color: WHITE
                    }
                }
            },
            "chart:common:axis": {
                constantLineStyle: {
                    color: WHITE
                }
            },
            "chart:common:annotation": {
                border: {
                    color: "#000"
                },
                color: "#000"
            },
            chart: {
                commonPaneSettings: {
                    border: {
                        color: LABEL_BORDER_COLOR
                    }
                },
                commonAxisSettings: {
                    breakStyle: {
                        color: BREAK_STYLE_COLOR
                    }
                },
                zoomAndPan: {
                    dragBoxStyle: {
                        color: WHITE
                    }
                }
            },
            gauge: {
                rangeContainer: {
                    backgroundColor: RANGE_COLOR
                },
                valueIndicators: {
                    _default: {
                        color: RANGE_COLOR
                    },
                    rangebar: {
                        color: "#84788b"
                    },
                    twocolorneedle: {
                        secondColor: "#ba544d"
                    },
                    trianglemarker: {
                        color: "#b7918f"
                    },
                    textcloud: {
                        color: "#ba544d"
                    }
                }
            },
            barGauge: {
                backgroundColor: "#3c3c3c"
            },
            rangeSelector: {
                scale: {
                    tick: {
                        color: WHITE,
                        opacity: .32
                    },
                    minorTick: {
                        color: WHITE,
                        opacity: .1
                    },
                    breakStyle: {
                        color: BREAK_STYLE_COLOR
                    }
                },
                selectedRangeColor: RANGE_COLOR,
                sliderMarker: {
                    color: RANGE_COLOR,
                    font: {
                        color: DARK_BACKGROUND_COLOR
                    }
                },
                sliderHandle: {
                    color: WHITE,
                    opacity: .2
                },
                shutter: {
                    color: WHITE,
                    opacity: .1
                }
            },
            map: {
                background: {
                    borderColor: "#3f3f3f"
                },
                layer: {
                    label: {
                        stroke: BLACK,
                        font: {
                            color: WHITE
                        }
                    }
                },
                "layer:area": {
                    borderColor: DARK_BACKGROUND_COLOR,
                    color: AREA_LAYER_COLOR,
                    hoveredBorderColor: WHITE,
                    selectedBorderColor: WHITE
                },
                "layer:line": {
                    color: "#c77244",
                    hoveredColor: "#ff5d04",
                    selectedColor: "#ff784f"
                },
                "layer:marker:bubble": {
                    hoveredBorderColor: WHITE,
                    selectedBorderColor: WHITE
                },
                "layer:marker:pie": {
                    hoveredBorderColor: WHITE,
                    selectedBorderColor: WHITE
                },
                legend: {
                    border: {
                        color: "#3f3f3f"
                    },
                    font: {
                        color: WHITE
                    }
                },
                controlBar: {
                    borderColor: LINE_COLOR,
                    color: DARK_BACKGROUND_COLOR
                }
            },
            treeMap: {
                group: {
                    color: "#4c4c4c",
                    label: {
                        font: {
                            color: "#a3a3a3"
                        }
                    }
                }
            },
            sparkline: {
                lineColor: LINE_COLOR,
                firstLastColor: LINE_COLOR,
                barPositiveColor: POSITIVE_COLOR,
                barNegativeColor: TARGET_COLOR,
                winColor: POSITIVE_COLOR,
                lossColor: TARGET_COLOR,
                pointColor: DARK_BACKGROUND_COLOR
            },
            bullet: {
                targetColor: TARGET_COLOR
            },
            funnel: {
                item: {
                    border: {
                        color: DARK_BACKGROUND_COLOR
                    }
                }
            },
            sankey: {
                label: {
                    font: {
                        color: WHITE
                    }
                }
            }
        }, "material");

        function registerMaterialColorScheme(accentName, themeName, accentColor) {
            (0, _themes.registerTheme)({
                name: "material." + accentName + "." + themeName,
                rangeSelector: {
                    selectedRangeColor: accentColor,
                    sliderMarker: {
                        color: accentColor
                    },
                    sliderHandle: {
                        color: accentColor
                    }
                },
                map: {
                    "layer:marker:dot": {
                        color: accentColor
                    },
                    "layer:marker:bubble": {
                        color: accentColor
                    },
                    legend: {
                        markerColor: accentColor
                    }
                },
                bullet: {
                    color: accentColor
                },
                gauge: {
                    valueIndicators: {
                        rangebar: {
                            color: accentColor
                        },
                        textcloud: {
                            color: accentColor
                        }
                    }
                }
            }, "material." + themeName)
        }
        var materialAccents = {
            blue: "#03a9f4",
            lime: "#cddc39",
            orange: "#ff5722",
            purple: "#9c27b0",
            teal: "#009688"
        };
        for (var accent in materialAccents) {
            if (Object.prototype.hasOwnProperty.call(materialAccents, accent)) {
                var color = materialAccents[accent];
                registerMaterialColorScheme(accent, "light", color);
                registerMaterialColorScheme(accent, "dark", color);
                (0, _themes.registerTheme)({
                    name: "material.".concat(accent, ".light.compact")
                }, "material.".concat(accent, ".light"));
                (0, _themes.registerTheme)({
                    name: "material.".concat(accent, ".dark.compact")
                }, "material.".concat(accent, ".dark"))
            }
        }
    },
    /*!*****************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/core/layout.js ***!
      \*****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _utils = __webpack_require__( /*! ./utils */ 14);
        var _min = Math.min;
        var _max = Math.max;
        var _round = Math.round;
        var ALIGN_START = 0;
        var ALIGN_MIDDLE = 1;
        var ALIGN_END = 2;
        var horizontalAlignmentMap = {
            left: ALIGN_START,
            center: ALIGN_MIDDLE,
            right: ALIGN_END
        };
        var verticalAlignmentMap = {
            top: ALIGN_START,
            center: ALIGN_MIDDLE,
            bottom: ALIGN_END
        };
        var sideMap = {
            horizontal: 0,
            vertical: 1
        };
        var slicersMap = {};
        var BBOX_CEIL_CORRECTION = 2;
        slicersMap[ALIGN_START] = function(a, b, size) {
            return [a, _min(b, a + size)]
        };
        slicersMap[ALIGN_MIDDLE] = function(a, b, size) {
            return [_max(a, (a + b - size) / 2), _min(b, (a + b + size) / 2)]
        };
        slicersMap[ALIGN_END] = function(a, b, size) {
            return [_max(a, b - size), b]
        };

        function pickValue(value, map, defaultValue) {
            var val = (0, _utils.normalizeEnum)(value);
            return val in map ? map[val] : defaultValue
        }

        function normalizeLayoutOptions(options) {
            var side = pickValue(options.side, sideMap, 1);
            var alignment = [pickValue(options.horizontalAlignment, horizontalAlignmentMap, ALIGN_MIDDLE), pickValue(options.verticalAlignment, verticalAlignmentMap, ALIGN_START)];
            return {
                side: side,
                primary: bringToEdge(alignment[side]),
                secondary: alignment[1 - side],
                weak: options.weak,
                priority: options.priority || 0,
                header: options.header,
                position: options.position
            }
        }

        function bringToEdge(primary) {
            return primary < 2 ? 0 : 2
        }

        function getConjugateSide(side) {
            return 1 - side
        }

        function getSlice(alignment, a, b, size) {
            return slicersMap[alignment](a, b, size)
        }

        function getShrink(alignment, size) {
            return (alignment > 0 ? -1 : 1) * size
        }

        function processForward(item, rect, minSize) {
            var side = item.side;
            var size = item.element.measure([rect[2] - rect[0], rect[3] - rect[1]]);
            var minSide = "indside" === item.position ? 0 : minSize[side];
            var isValid = size[side] < rect[2 + side] - rect[side] - minSide;
            if (isValid) {
                if ("inside" !== item.position) {
                    rect[item.primary + side] += getShrink(item.primary, size[side])
                }
                item.size = size
            }
            return isValid
        }

        function processRectBackward(item, rect, alignmentRect) {
            var primarySide = item.side;
            var secondarySide = getConjugateSide(primarySide);
            var itemRect = [];
            var secondary = getSlice(item.secondary, alignmentRect[secondarySide], alignmentRect[2 + secondarySide], item.size[secondarySide]);
            itemRect[primarySide] = _round(itemRect[2 + primarySide] = rect[item.primary + primarySide] + ("inside" === item.position ? getShrink(item.primary, item.size[primarySide]) : 0));
            itemRect[item.primary + primarySide] = _round(rect[item.primary + primarySide] - getShrink(item.primary, item.size[primarySide]));
            if ("inside" !== item.position) {
                rect[item.primary + primarySide] = itemRect[item.primary + primarySide]
            }
            itemRect[secondarySide] = _round(secondary[0]);
            itemRect[2 + secondarySide] = _round(secondary[1]);
            return itemRect
        }

        function processBackward(item, rect, alignmentRect, fitRect, size, targetRect) {
            var itemRect = processRectBackward(item, rect, alignmentRect);
            var itemFitRect = processRectBackward(item, fitRect, fitRect);
            if (size[item.side] > 0) {
                size[item.side] -= item.size[item.side];
                targetRect[item.primary + item.side] = itemRect[item.primary + item.side];
                item.element.freeSpace()
            } else {
                item.element.move(itemRect, itemFitRect)
            }
        }

        function Layout() {
            this._targets = []
        }
        Layout.prototype = {
            constructor: Layout,
            dispose: function() {
                this._targets = null
            },
            add: function(target) {
                this._targets.push(target)
            },
            forward: function(targetRect, minSize) {
                var rect = targetRect.slice();
                var targets = createTargets(this._targets);
                var i;
                var ii = targets.length;
                var cache = [];
                for (i = 0; i < ii; ++i) {
                    if (processForward(targets[i], rect, minSize)) {
                        cache.push(targets[i])
                    } else {
                        targets[i].element.freeSpace()
                    }
                }
                this._cache = cache.reverse();
                return rect
            },
            backward: function(targetRect, alignmentRect) {
                var size = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [0, 0];
                var backwardRect = targetRect.slice();
                var fitRect = targetRect.slice();
                var targets = this._cache;
                var targetSide = 0;
                var target;
                var i;
                var ii = targets.length;
                for (i = 0; i < ii; ++i) {
                    target = targets[i];
                    if (target.side !== targetSide) {
                        backwardRect = targetRect.slice()
                    }
                    processBackward(target, backwardRect, alignmentRect, fitRect, size, targetRect);
                    targetSide = target.side
                }
                return size
            }
        };

        function createTargets(targets) {
            var i;
            var ii = targets.length;
            var collection = [];
            var layout;
            for (i = 0; i < ii; ++i) {
                layout = targets[i].layoutOptions();
                if (layout) {
                    layout = normalizeLayoutOptions(layout);
                    layout.element = targets[i];
                    collection.push(layout)
                }
            }
            collection.sort(function(a, b) {
                return b.side - a.side || a.priority - b.priority
            });
            collection = processWeakItems(collection);
            return collection
        }

        function processWeakItems(collection) {
            var weakItem = collection.filter(function(item) {
                return true === item.weak
            })[0];
            var headerItem;
            if (weakItem) {
                headerItem = collection.filter(function(item) {
                    return weakItem.primary === item.primary && item.side === weakItem.side && item !== weakItem
                })[0]
            }
            if (weakItem && headerItem) {
                return [makeHeader(headerItem, weakItem)].concat(collection.filter(function(item) {
                    return !(item === headerItem || item === weakItem)
                }))
            }
            return collection
        }

        function processBackwardHeaderRect(element, rect) {
            var rectCopy = rect.slice();
            var itemRect = processRectBackward(element, rectCopy, rectCopy);
            itemRect[element.side] = rect[element.side];
            itemRect[2 + element.side] = rect[2 + element.side];
            return itemRect
        }

        function makeHeader(header, weakElement) {
            var side = header.side;
            var primary = header.primary;
            var secondary = header.secondary;
            return {
                side: side,
                primary: primary,
                secondary: secondary,
                priority: 0,
                element: {
                    measure: function(targetSize) {
                        var result = targetSize.slice();
                        var weakSize = weakElement.element.measure(targetSize.slice());
                        targetSize[primary] -= weakSize[primary];
                        var headerSize = header.element.measure(targetSize.slice());
                        result[side] = weakSize[side] = headerSize[side] = Math.max(headerSize[side], weakSize[side]);
                        weakElement.size = weakSize;
                        header.size = headerSize;
                        return result
                    },
                    move: function(rect, fitRect) {
                        if (fitRect[2] - fitRect[0] < header.size[0] + weakElement.size[0] - BBOX_CEIL_CORRECTION) {
                            this.freeSpace();
                            return
                        }
                        var weakRect = processBackwardHeaderRect(weakElement, fitRect, fitRect);
                        fitRect[2 + weakElement.primary] = weakRect[weakElement.primary];
                        var headerFitReact = processBackwardHeaderRect(header, fitRect, fitRect);
                        if (fitRect[2 + weakElement.primary] < rect[2 + weakElement.primary] && header.size[header.primary] > rect[2 + header.primary] - rect[header.primary]) {
                            rect[2 + weakElement.primary] = fitRect[2 + weakElement.primary]
                        }
                        var headerRect = processBackwardHeaderRect(header, rect, rect);
                        if (headerRect[2 + weakElement.primary] > fitRect[2 + weakElement.primary]) {
                            rect[2 + weakElement.primary] = fitRect[2 + weakElement.primary];
                            headerRect = processBackwardHeaderRect(header, rect, rect)
                        }
                        weakElement.element.move(weakRect);
                        header.element.move(headerRect, headerFitReact)
                    },
                    freeSpace: function() {
                        header.element.freeSpace();
                        weakElement.element.freeSpace()
                    }
                }
            }
        }
        var _default = Layout;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/core/base_widget.utils.js ***!
      \****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.createEventTrigger = createEventTrigger;
        exports.createResizeHandler = createResizeHandler;
        exports.createIncidentOccurred = void 0;
        var _version = _interopRequireDefault(__webpack_require__( /*! ../../core/version */ 173));
        var _string = __webpack_require__( /*! ../../core/utils/string */ 43);
        var _errors_warnings = _interopRequireDefault(__webpack_require__( /*! ./errors_warnings */ 460));
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ERROR_MESSAGES = _errors_warnings.default.ERROR_MESSAGES;

        function createEventTrigger(eventsMap, callbackGetter) {
            var triggers = {};
            (0, _iterator.each)(eventsMap, function(name, info) {
                if (info.name) {
                    createEvent(name)
                }
            });
            var changes;
            triggerEvent.change = function(name) {
                var eventInfo = eventsMap[name];
                if (eventInfo) {
                    (changes = changes || {})[name] = eventInfo
                }
                return !!eventInfo
            };
            triggerEvent.applyChanges = function() {
                if (changes) {
                    (0, _iterator.each)(changes, function(name, eventInfo) {
                        createEvent(eventInfo.newName || name)
                    });
                    changes = null
                }
            };
            triggerEvent.dispose = function() {
                eventsMap = callbackGetter = triggers = null
            };
            return triggerEvent;

            function createEvent(name) {
                var eventInfo = eventsMap[name];
                triggers[eventInfo.name] = callbackGetter(name)
            }

            function triggerEvent(name, arg, complete) {
                triggers[name](arg);
                complete && complete()
            }
        }
        var createIncidentOccurred = function(widgetName, eventTrigger) {
            return function(id, args) {
                eventTrigger("incidentOccurred", {
                    target: {
                        id: id,
                        type: "E" === id[0] ? "error" : "warning",
                        args: args,
                        text: _string.format.apply(null, [ERROR_MESSAGES[id]].concat(args || [])),
                        widget: widgetName,
                        version: _version.default
                    }
                })
            }
        };
        exports.createIncidentOccurred = createIncidentOccurred;

        function createResizeHandler(callback) {
            var timeout;
            var handler = function() {
                clearTimeout(timeout);
                timeout = setTimeout(callback, 100)
            };
            handler.dispose = function() {
                clearTimeout(timeout);
                return this
            };
            return handler
        }
    },
    /*!******************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/series/points/base_point.js ***!
      \******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.Point = Point;
        var _consts = _interopRequireDefault(__webpack_require__( /*! ../../components/consts */ 143));
        var _symbol_point = _interopRequireDefault(__webpack_require__( /*! ./symbol_point */ 144));
        var _bar_point = _interopRequireDefault(__webpack_require__( /*! ./bar_point */ 225));
        var _bubble_point = _interopRequireDefault(__webpack_require__( /*! ./bubble_point */ 919));
        var _pie_point = _interopRequireDefault(__webpack_require__( /*! ./pie_point */ 461));
        var _range_symbol_point = _interopRequireDefault(__webpack_require__( /*! ./range_symbol_point */ 462));
        var _range_bar_point = _interopRequireDefault(__webpack_require__( /*! ./range_bar_point */ 920));
        var _candlestick_point = _interopRequireDefault(__webpack_require__( /*! ./candlestick_point */ 463));
        var _stock_point = _interopRequireDefault(__webpack_require__( /*! ./stock_point */ 921));
        var _polar_point = __webpack_require__( /*! ./polar_point */ 922);
        var _utils = __webpack_require__( /*! ../../core/utils */ 14);
        var _extend2 = __webpack_require__( /*! ../../../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../../../core/utils/type */ 1);
        var _common = __webpack_require__( /*! ../../../core/utils/common */ 4);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var mixins = {};
        var _extend = _extend2.extend;
        var statesConsts = _consts.default.states;
        var SYMBOL_POINT = "symbolPoint";
        var POLAR_SYMBOL_POINT = "polarSymbolPoint";
        var BAR_POINT = "barPoint";
        var POLAR_BAR_POINT = "polarBarPoint";
        var PIE_POINT = "piePoint";
        var SELECTED_STATE = statesConsts.selectedMark;
        var HOVER_STATE = statesConsts.hoverMark;
        var NORMAL_STATE = statesConsts.normalMark;
        var HOVER = statesConsts.hover;
        var NORMAL = statesConsts.normal;
        var SELECTION = statesConsts.selection;
        var pointTypes = {
            chart: {
                scatter: SYMBOL_POINT,
                line: SYMBOL_POINT,
                spline: SYMBOL_POINT,
                stepline: SYMBOL_POINT,
                stackedline: SYMBOL_POINT,
                fullstackedline: SYMBOL_POINT,
                stackedspline: SYMBOL_POINT,
                fullstackedspline: SYMBOL_POINT,
                stackedsplinearea: SYMBOL_POINT,
                fullstackedsplinearea: SYMBOL_POINT,
                area: SYMBOL_POINT,
                splinearea: SYMBOL_POINT,
                steparea: SYMBOL_POINT,
                stackedarea: SYMBOL_POINT,
                fullstackedarea: SYMBOL_POINT,
                rangearea: "rangeSymbolPoint",
                bar: BAR_POINT,
                stackedbar: BAR_POINT,
                fullstackedbar: BAR_POINT,
                rangebar: "rangeBarPoint",
                bubble: "bubblePoint",
                stock: "stockPoint",
                candlestick: "candlestickPoint"
            },
            pie: {
                pie: PIE_POINT,
                doughnut: PIE_POINT,
                donut: PIE_POINT
            },
            polar: {
                scatter: POLAR_SYMBOL_POINT,
                line: POLAR_SYMBOL_POINT,
                area: POLAR_SYMBOL_POINT,
                bar: POLAR_BAR_POINT,
                stackedbar: POLAR_BAR_POINT
            }
        };

        function isNoneMode(mode) {
            return "none" === (0, _utils.normalizeEnum)(mode)
        }

        function Point(series, dataItem, options) {
            this.fullState = NORMAL_STATE;
            this.series = series;
            this.update(dataItem, options);
            this._viewCounters = {
                hover: 0,
                selection: 0
            };
            this._emptySettings = {
                fill: null,
                stroke: null,
                dashStyle: null
            }
        }
        mixins.symbolPoint = _symbol_point.default;
        mixins.barPoint = _bar_point.default;
        mixins.bubblePoint = _bubble_point.default;
        mixins.piePoint = _pie_point.default;
        mixins.rangeSymbolPoint = _range_symbol_point.default;
        mixins.rangeBarPoint = _range_bar_point.default;
        mixins.candlestickPoint = _candlestick_point.default;
        mixins.stockPoint = _stock_point.default;
        mixins.polarSymbolPoint = _polar_point.polarSymbolPoint;
        mixins.polarBarPoint = _polar_point.polarBarPoint;
        Point.prototype = {
            constructor: Point,
            getColor: function() {
                if (!this.hasValue() && !this._styles.usePointCustomOptions) {
                    this.series.customizePoint(this, this._dataItem)
                }
                return this._styles.normal.fill || this.series.getColor()
            },
            _getStyle: function() {
                return this._styles[this._currentStyle || "normal"]
            },
            update: function(dataItem, options) {
                this.updateOptions(options);
                this.updateData(dataItem)
            },
            updateData: function(dataItem) {
                var that = this;
                var argumentWasChanged = that.argument !== dataItem.argument;
                that.argument = that.initialArgument = that.originalArgument = dataItem.argument;
                that.tag = dataItem.tag;
                that.index = dataItem.index;
                that._dataItem = dataItem;
                that.data = dataItem.data;
                that.lowError = dataItem.lowError;
                that.highError = dataItem.highError;
                that.aggregationInfo = dataItem.aggregationInfo;
                that._updateData(dataItem, argumentWasChanged);
                !that.hasValue() && that.setInvisibility();
                that._fillStyle();
                that._updateLabelData()
            },
            deleteMarker: function() {
                var that = this;
                if (that.graphic) {
                    that.graphic.dispose()
                }
                that.graphic = null
            },
            draw: function(renderer, groups, animationEnabled, firstDrawing) {
                var that = this;
                if (that._needDeletingOnDraw || that.series.autoHidePointMarkers && !that.isSelected()) {
                    that.deleteMarker();
                    that._needDeletingOnDraw = false
                }
                if (that._needClearingOnDraw) {
                    that.clearMarker();
                    that._needClearingOnDraw = false
                }
                if (!that._hasGraphic()) {
                    that.getMarkerVisibility() && !that.series.autoHidePointMarkers && that._drawMarker(renderer, groups.markers, animationEnabled, firstDrawing)
                } else {
                    that._updateMarker(animationEnabled, this._getStyle(), groups.markers)
                }
                that._drawLabel();
                that._drawErrorBar(renderer, groups.errorBars, animationEnabled);
                return that
            },
            _getViewStyle: function() {
                var state = NORMAL_STATE;
                var fullState = this.fullState;
                var styles = [NORMAL, HOVER, SELECTION, SELECTION];
                if (this._viewCounters.hover) {
                    state |= HOVER_STATE
                }
                if (this._viewCounters.selection) {
                    state |= SELECTED_STATE
                }
                if (isNoneMode(this.getOptions().selectionMode)) {
                    fullState &= ~SELECTED_STATE
                }
                if (isNoneMode(this.getOptions().hoverMode)) {
                    fullState &= ~HOVER_STATE
                }
                state |= fullState;
                return styles[state]
            },
            applyView: function(legendCallback) {
                var style = this._getViewStyle();
                var that = this;
                that._currentStyle = style;
                if (!that.graphic && that.series.autoHidePointMarkers && (style === SELECTION || style === HOVER)) {
                    that._drawMarker(that.series.getRenderer(), that.series.getMarkersGroup())
                }
                if (that.graphic) {
                    if (that.series.autoHidePointMarkers && style !== SELECTION && style !== HOVER) {
                        that.deleteMarker()
                    } else {
                        if ("normal" === style) {
                            that.clearMarker()
                        } else {
                            that.graphic.toForeground()
                        }
                        that._updateMarker(true, that._styles[style], void 0, legendCallback)
                    }
                }
            },
            setView: function(style) {
                this._viewCounters[style]++;
                this.applyView()
            },
            resetView: function(style) {
                var viewCounters = this._viewCounters;
                --viewCounters[style];
                if (viewCounters[style] < 0) {
                    viewCounters[style] = 0
                }
                this.applyView()
            },
            releaseHoverState: function() {
                var that = this;
                if (that.graphic && !that.isSelected()) {
                    that.graphic.toBackground()
                }
            },
            select: function() {
                this.series.selectPoint(this)
            },
            clearSelection: function() {
                this.series.deselectPoint(this)
            },
            hover: function() {
                this.series.hoverPoint(this)
            },
            clearHover: function() {
                this.series.clearPointHover()
            },
            showTooltip: function() {
                this.series.showPointTooltip(this)
            },
            hideTooltip: function() {
                this.series.hidePointTooltip(this)
            },
            _checkLabelsChanging: function(oldType, newType) {
                var isNewRange = ~newType.indexOf("range");
                var isOldRange = ~oldType.indexOf("range");
                return isOldRange && !isNewRange || !isOldRange && isNewRange
            },
            updateOptions: function(newOptions) {
                if (!newOptions) {
                    return
                }
                var that = this;
                var oldOptions = that._options;
                var widgetType = newOptions.widgetType;
                var oldType = oldOptions && oldOptions.type;
                var newType = newOptions.type;
                var newPointTypeMixin = pointTypes[widgetType][newType];
                if (oldType !== newType) {
                    that._needDeletingOnDraw = true;
                    that._needClearingOnDraw = false;
                    if (oldType) {
                        that._checkLabelsChanging(oldType, newType) && that.deleteLabel();
                        that._resetType(mixins[pointTypes[oldType]])
                    }
                    that._setType(mixins[newPointTypeMixin])
                } else {
                    that._needDeletingOnDraw = that._checkSymbol(oldOptions, newOptions);
                    that._needClearingOnDraw = that._checkCustomize(oldOptions, newOptions)
                }
                that._options = newOptions;
                that._fillStyle();
                that._updateLabelOptions(newPointTypeMixin)
            },
            translate: function() {
                if (this.hasValue()) {
                    this._translate();
                    this.translated = true
                }
            },
            _checkCustomize: function(oldOptions, newOptions) {
                return oldOptions.styles.usePointCustomOptions && !newOptions.styles.usePointCustomOptions
            },
            _getCustomLabelVisibility: function() {
                return this._styles.useLabelCustomOptions ? !!this._options.label.visible : null
            },
            getBoundingRect: function() {
                return this._getGraphicBBox()
            },
            _resetType: function(methods) {
                for (var methodName in methods) {
                    delete this[methodName]
                }
            },
            _setType: function(methods) {
                for (var methodName in methods) {
                    this[methodName] = methods[methodName]
                }
            },
            isInVisibleArea: function() {
                return this.inVisibleArea
            },
            isSelected: function() {
                return !!(this.fullState & SELECTED_STATE)
            },
            isHovered: function() {
                return !!(this.fullState & HOVER_STATE)
            },
            getOptions: function() {
                return this._options
            },
            animate: function(complete, settings, partitionDuration) {
                if (!this.graphic) {
                    complete && complete();
                    return
                }
                this.graphic.animate(settings, {
                    partitionDuration: partitionDuration
                }, complete)
            },
            getCoords: function(min) {
                var that = this;
                if (!min) {
                    return {
                        x: that.x,
                        y: that.y
                    }
                }
                if (!that._options.rotated) {
                    return {
                        x: that.x,
                        y: that.minY + (that.y - that.minY ? 0 : 1)
                    }
                }
                return {
                    x: that.minX - (that.x - that.minX ? 0 : 1),
                    y: that.y
                }
            },
            getDefaultCoords: function() {
                var that = this;
                return !that._options.rotated ? {
                    x: that.x,
                    y: that.defaultY
                } : {
                    x: that.defaultX,
                    y: that.y
                }
            },
            setDefaultCoords: function() {
                var coords = this.getDefaultCoords();
                this.x = coords.x;
                this.y = coords.y
            },
            _getVisibleArea: function() {
                return this.series.getVisibleArea()
            },
            _getArgTranslator: function() {
                return this.series.getArgumentAxis().getTranslator()
            },
            _getValTranslator: function() {
                return this.series.getValueAxis().getTranslator()
            },
            _calculateVisibility: function(x, y, width, height) {
                var that = this;
                var visibleArea = that._getVisibleArea();
                var rotated = that._options.rotated;
                if (visibleArea.minX > x + (width || 0) || visibleArea.maxX < x || visibleArea.minY > y + (height || 0) || visibleArea.maxY < y || rotated && (0, _type.isDefined)(width) && 0 !== width && (visibleArea.minX === x + width || visibleArea.maxX === x) || !rotated && (0, _type.isDefined)(height) && 0 !== height && (visibleArea.minY === y + height || visibleArea.maxY === y)) {
                    that.inVisibleArea = false
                } else {
                    that.inVisibleArea = true
                }
            },
            isArgumentCorrect: function() {
                return this.series._argumentChecker(this.argument)
            },
            isValueCorrect: function() {
                var valueChecker = this.series._valueChecker;
                return valueChecker(this.getMinValue()) && valueChecker(this.getMaxValue())
            },
            hasValue: function() {
                return null !== this.value && null !== this.minValue && this.isArgumentCorrect() && this.isValueCorrect()
            },
            hasCoords: _common.noop,
            correctPosition: _common.noop,
            correctRadius: _common.noop,
            correctLabelRadius: _common.noop,
            getCrosshairData: _common.noop,
            getPointRadius: _common.noop,
            _populatePointShape: _common.noop,
            _checkSymbol: _common.noop,
            getMarkerCoords: _common.noop,
            hide: _common.noop,
            show: _common.noop,
            hideMarker: _common.noop,
            setInvisibility: _common.noop,
            clearVisibility: _common.noop,
            isVisible: _common.noop,
            resetCorrection: _common.noop,
            correctValue: _common.noop,
            resetValue: _common.noop,
            setPercentValue: _common.noop,
            correctCoordinates: _common.noop,
            coordsIn: _common.noop,
            getTooltipParams: _common.noop,
            applyWordWrap: _common.noop,
            setLabelTrackerData: _common.noop,
            updateLabelCoord: _common.noop,
            drawLabel: _common.noop,
            correctLabelPosition: _common.noop,
            getMinValue: _common.noop,
            getMaxValue: _common.noop,
            _drawErrorBar: _common.noop,
            getMarkerVisibility: _common.noop,
            dispose: function() {
                var that = this;
                that.deleteMarker();
                that.deleteLabel();
                that._errorBar && this._errorBar.dispose();
                that._options = that._styles = that.series = that._errorBar = null
            },
            getTooltipFormatObject: function(tooltip, stackPoints) {
                var that = this;
                var tooltipFormatObject = that._getFormatObject(tooltip);
                var sharedTooltipValuesArray = [];
                var tooltipStackPointsFormatObject = [];
                if (stackPoints) {
                    stackPoints.forEach(function(point) {
                        if (!point.isVisible()) {
                            return
                        }
                        var formatObject = point._getFormatObject(tooltip);
                        tooltipStackPointsFormatObject.push(formatObject);
                        sharedTooltipValuesArray.push(formatObject.seriesName + ": " + formatObject.valueText)
                    });
                    _extend(tooltipFormatObject, {
                        points: tooltipStackPointsFormatObject,
                        valueText: sharedTooltipValuesArray.join("\n"),
                        stackName: that.series.getStackName() || null
                    })
                }
                var aggregationInfo = that.aggregationInfo;
                if (aggregationInfo) {
                    var axis = that.series.getArgumentAxis();
                    var rangeText = axis.formatRange(aggregationInfo.intervalStart, aggregationInfo.intervalEnd, aggregationInfo.aggregationInterval);
                    if (rangeText) {
                        tooltipFormatObject.valueText += "\n".concat(rangeText)
                    }
                }
                return tooltipFormatObject
            },
            setHole: function(holeValue, position) {
                var that = this;
                var minValue = isFinite(that.minValue) ? that.minValue : 0;
                if ((0, _type.isDefined)(holeValue)) {
                    if ("left" === position) {
                        that.leftHole = that.value - holeValue;
                        that.minLeftHole = minValue - holeValue
                    } else {
                        that.rightHole = that.value - holeValue;
                        that.minRightHole = minValue - holeValue
                    }
                }
            },
            resetHoles: function() {
                this.leftHole = null;
                this.minLeftHole = null;
                this.rightHole = null;
                this.minRightHole = null
            },
            getLabel: function() {
                return this._label
            },
            getLabels: function() {
                return [this._label]
            },
            getCenterCoord: function() {
                return {
                    x: this.x,
                    y: this.y
                }
            }
        }
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/series/points/bubble_point.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _extend2 = __webpack_require__( /*! ../../../core/utils/extend */ 0);
        var _symbol_point = _interopRequireDefault(__webpack_require__( /*! ./symbol_point */ 144));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _extend = _extend2.extend;
        var MIN_BUBBLE_HEIGHT = 20;
        var _default = _extend({}, _symbol_point.default, {
            correctCoordinates: function(diameter) {
                this.bubbleSize = diameter / 2
            },
            _drawMarker: function(renderer, group, animationEnabled) {
                var that = this;
                var attr = _extend({
                    translateX: that.x,
                    translateY: that.y
                }, that._getStyle());
                that.graphic = renderer.circle(0, 0, animationEnabled ? 0 : that.bubbleSize).smartAttr(attr).data({
                    "chart-data-point": that
                }).append(group)
            },
            getTooltipParams: function(location) {
                var that = this;
                var graphic = that.graphic;
                if (!graphic) {
                    return
                }
                var height = graphic.getBBox().height;
                return {
                    x: that.x,
                    y: that.y,
                    offset: height < MIN_BUBBLE_HEIGHT || "edge" === location ? height / 2 : 0
                }
            },
            _getLabelFormatObject: function() {
                var formatObject = _symbol_point.default._getLabelFormatObject.call(this);
                formatObject.size = this.initialSize;
                return formatObject
            },
            _updateData: function(data) {
                _symbol_point.default._updateData.call(this, data);
                this.size = this.initialSize = data.size
            },
            _getGraphicBBox: function() {
                var that = this;
                return that._getSymbolBBox(that.x, that.y, that.bubbleSize)
            },
            _updateMarker: function(animationEnabled, style) {
                var that = this;
                if (!animationEnabled) {
                    style = _extend({
                        r: that.bubbleSize,
                        translateX: that.x,
                        translateY: that.y
                    }, style)
                }
                that.graphic.smartAttr(style)
            },
            _getFormatObject: function(tooltip) {
                var formatObject = _symbol_point.default._getFormatObject.call(this, tooltip);
                formatObject.sizeText = tooltip.formatValue(this.initialSize);
                return formatObject
            },
            _storeTrackerR: function() {
                return this.bubbleSize
            },
            _getLabelCoords: function(label) {
                var coords;
                if ("inside" === label.getLayoutOptions().position) {
                    coords = this._getLabelCoordOfPosition(label, "inside")
                } else {
                    coords = _symbol_point.default._getLabelCoords.call(this, label)
                }
                return coords
            }
        });
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/series/points/range_bar_point.js ***!
      \***********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _common = __webpack_require__( /*! ../../../core/utils/common */ 4);
        var _extend2 = __webpack_require__( /*! ../../../core/utils/extend */ 0);
        var _bar_point = _interopRequireDefault(__webpack_require__( /*! ./bar_point */ 225));
        var _range_symbol_point = _interopRequireDefault(__webpack_require__( /*! ./range_symbol_point */ 462));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _extend = _extend2.extend;
        var _default = _extend({}, _bar_point.default, {
            deleteLabel: _range_symbol_point.default.deleteLabel,
            _getFormatObject: _range_symbol_point.default._getFormatObject,
            clearVisibility: function() {
                var graphic = this.graphic;
                if (graphic && graphic.attr("visibility")) {
                    graphic.attr({
                        visibility: null
                    })
                }
            },
            setInvisibility: function() {
                var graphic = this.graphic;
                if (graphic && "hidden" !== graphic.attr("visibility")) {
                    graphic.attr({
                        visibility: "hidden"
                    })
                }
                this._topLabel.draw(false);
                this._bottomLabel.draw(false)
            },
            getTooltipParams: function(location) {
                var that = this;
                var edgeLocation = "edge" === location;
                var x;
                var y;
                if (that._options.rotated) {
                    x = edgeLocation ? that.x + that.width : that.x + that.width / 2;
                    y = that.y + that.height / 2
                } else {
                    x = that.x + that.width / 2;
                    y = edgeLocation ? that.y : that.y + that.height / 2
                }
                return {
                    x: x,
                    y: y,
                    offset: 0
                }
            },
            _translate: function() {
                var that = this;
                var barMethods = _bar_point.default;
                barMethods._translate.call(that);
                if (that._options.rotated) {
                    that.width = that.width || 1
                } else {
                    that.height = that.height || 1
                }
            },
            hasCoords: _range_symbol_point.default.hasCoords,
            _updateData: _range_symbol_point.default._updateData,
            _getLabelPosition: _range_symbol_point.default._getLabelPosition,
            _getLabelMinFormatObject: _range_symbol_point.default._getLabelMinFormatObject,
            _updateLabelData: _range_symbol_point.default._updateLabelData,
            _updateLabelOptions: _range_symbol_point.default._updateLabelOptions,
            getCrosshairData: _range_symbol_point.default.getCrosshairData,
            _createLabel: _range_symbol_point.default._createLabel,
            _checkOverlay: _range_symbol_point.default._checkOverlay,
            _checkLabelsOverlay: _range_symbol_point.default._checkLabelsOverlay,
            _getOverlayCorrections: _range_symbol_point.default._getOverlayCorrections,
            _drawLabel: _range_symbol_point.default._drawLabel,
            _getLabelCoords: _range_symbol_point.default._getLabelCoords,
            getLabel: _range_symbol_point.default.getLabel,
            getLabels: _range_symbol_point.default.getLabels,
            getBoundingRect: _common.noop,
            getMinValue: _range_symbol_point.default.getMinValue,
            getMaxValue: _range_symbol_point.default.getMaxValue
        });
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/series/points/stock_point.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _extend2 = __webpack_require__( /*! ../../../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../../../core/utils/type */ 1);
        var _candlestick_point = _interopRequireDefault(__webpack_require__( /*! ./candlestick_point */ 463));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _extend = _extend2.extend;
        var _isNumeric = _type.isNumeric;
        var _default = _extend({}, _candlestick_point.default, {
            _getPoints: function() {
                var that = this;
                var createPoint = that._options.rotated ? function(x, y) {
                    return [y, x]
                } : function(x, y) {
                    return [x, y]
                };
                var openYExist = _isNumeric(that.openY);
                var closeYExist = _isNumeric(that.closeY);
                var x = that.x;
                var width = that.width;
                var points = [].concat(createPoint(x, that.highY));
                openYExist && (points = points.concat(createPoint(x, that.openY)));
                openYExist && (points = points.concat(createPoint(x - width / 2, that.openY)));
                openYExist && (points = points.concat(createPoint(x, that.openY)));
                closeYExist && (points = points.concat(createPoint(x, that.closeY)));
                closeYExist && (points = points.concat(createPoint(x + width / 2, that.closeY)));
                closeYExist && (points = points.concat(createPoint(x, that.closeY)));
                points = points.concat(createPoint(x, that.lowY));
                return points
            },
            _drawMarkerInGroup: function(group, attributes, renderer) {
                this.graphic = renderer.path(this._getPoints(), "line").attr({
                    "stroke-linecap": "square"
                }).attr(attributes).data({
                    "chart-data-point": this
                }).sharp().append(group)
            },
            _getMinTrackerWidth: function() {
                var width = 2 + this._styles.normal["stroke-width"];
                return width + width % 2
            }
        });
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/series/points/polar_point.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.polarBarPoint = exports.polarSymbolPoint = void 0;
        var _extend2 = __webpack_require__( /*! ../../../core/utils/extend */ 0);
        var _symbol_point = _interopRequireDefault(__webpack_require__( /*! ./symbol_point */ 144));
        var _bar_point = _interopRequireDefault(__webpack_require__( /*! ./bar_point */ 225));
        var _pie_point = _interopRequireDefault(__webpack_require__( /*! ./pie_point */ 461));
        var _type = __webpack_require__( /*! ../../../core/utils/type */ 1);
        var _utils = __webpack_require__( /*! ../../core/utils */ 14);
        var _consts = _interopRequireDefault(__webpack_require__( /*! ../../components/consts */ 143));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _extend = _extend2.extend;
        var _math = Math;
        var _max = _math.max;
        var RADIAL_LABEL_INDENT = _consts.default.radialLabelIndent;
        var ERROR_BARS_ANGLE_OFFSET = 90;
        var CANVAS_POSITION_END = "canvas_position_end";
        var CANVAS_POSITION_DEFAULT = "canvas_position_default";
        var polarSymbolPoint = _extend({}, _symbol_point.default, {
            _getLabelCoords: _pie_point.default._getLabelCoords,
            _getElementCoords: _pie_point.default._getElementCoords,
            _moveLabelOnCanvas: function(coord, visibleArea, labelBBox) {
                var x = coord.x;
                var y = coord.y;
                if (visibleArea.minX > x) {
                    x = visibleArea.minX
                }
                if (visibleArea.maxX < x + labelBBox.width) {
                    x = visibleArea.maxX - labelBBox.width
                }
                if (visibleArea.minY > y) {
                    y = visibleArea.minY
                }
                if (visibleArea.maxY < y + labelBBox.height) {
                    y = visibleArea.maxY - labelBBox.height
                }
                return {
                    x: x,
                    y: y
                }
            },
            _getLabelPosition: function() {
                return "outside"
            },
            _getCoords: function(argument, value) {
                var axis = this.series.getValueAxis();
                var startAngle = axis.getAngles()[0];
                var angle = this._getArgTranslator().translate(argument);
                var radius = this._getValTranslator().translate(value);
                var coords = (0, _utils.convertPolarToXY)(axis.getCenter(), axis.getAngles()[0], angle, radius);
                coords.angle = angle + startAngle - 90, coords.radius = radius;
                return coords
            },
            _translate: function() {
                var that = this;
                var center = that.series.getValueAxis().getCenter();
                var coord = that._getCoords(that.argument, that.value);
                var maxRadius = that._getValTranslator().translate(CANVAS_POSITION_END);
                var normalizedRadius = (0, _type.isDefined)(coord.radius) && coord.radius >= 0 ? coord.radius : null;
                that.vx = (0, _utils.normalizeAngle)(coord.angle);
                that.vy = that.radiusOuter = that.radiusLabels = normalizedRadius;
                that.radiusLabels += RADIAL_LABEL_INDENT;
                that.radius = normalizedRadius;
                that.middleAngle = -coord.angle;
                that.angle = -coord.angle;
                that.x = coord.x;
                that.y = coord.y;
                that.defaultX = that.centerX = center.x;
                that.defaultY = that.centerY = center.y;
                that._translateErrorBars();
                that.inVisibleArea = that._checkRadiusForVisibleArea(normalizedRadius, maxRadius)
            },
            _checkRadiusForVisibleArea: function(radius, maxRadius) {
                return (0, _type.isDefined)(radius) && radius <= maxRadius
            },
            _translateErrorBars: function() {
                var that = this;
                var errorBars = that._options.errorBars;
                var translator = that._getValTranslator();
                if (!errorBars) {
                    return
                }(0, _type.isDefined)(that.lowError) && (that._lowErrorCoord = that.centerY - translator.translate(that.lowError));
                (0, _type.isDefined)(that.highError) && (that._highErrorCoord = that.centerY - translator.translate(that.highError));
                that._errorBarPos = that.centerX;
                that._baseErrorBarPos = "stdDeviation" === errorBars.type ? that._lowErrorCoord + (that._highErrorCoord - that._lowErrorCoord) / 2 : that.centerY - that.radius
            },
            _getTranslates: function(animationEnabled) {
                return animationEnabled ? this.getDefaultCoords() : {
                    x: this.x,
                    y: this.y
                }
            },
            getDefaultCoords: function() {
                var cosSin = (0, _utils.getCosAndSin)(-this.angle);
                var radius = this._getValTranslator().translate(CANVAS_POSITION_DEFAULT);
                var x = this.defaultX + radius * cosSin.cos;
                var y = this.defaultY + radius * cosSin.sin;
                return {
                    x: x,
                    y: y
                }
            },
            _addLabelAlignmentAndOffset: function(label, coord) {
                return coord
            },
            _checkLabelPosition: function(label, coord) {
                var that = this;
                var visibleArea = that._getVisibleArea();
                var graphicBBox = that._getGraphicBBox();
                if (that._isPointInVisibleArea(visibleArea, graphicBBox)) {
                    coord = that._moveLabelOnCanvas(coord, visibleArea, label.getBoundingRect())
                }
                return coord
            },
            _getErrorBarSettings: function(errorBarOptions, animationEnabled) {
                var settings = _symbol_point.default._getErrorBarSettings.call(this, errorBarOptions, animationEnabled);
                settings.rotate = ERROR_BARS_ANGLE_OFFSET - this.angle;
                settings.rotateX = this.centerX;
                settings.rotateY = this.centerY;
                return settings
            },
            getCoords: function(min) {
                return min ? this.getDefaultCoords() : {
                    x: this.x,
                    y: this.y
                }
            }
        });
        exports.polarSymbolPoint = polarSymbolPoint;
        var polarBarPoint = _extend({}, _bar_point.default, {
            _translateErrorBars: polarSymbolPoint._translateErrorBars,
            _getErrorBarSettings: polarSymbolPoint._getErrorBarSettings,
            _moveLabelOnCanvas: polarSymbolPoint._moveLabelOnCanvas,
            _getLabelCoords: _pie_point.default._getLabelCoords,
            _getElementCoords: _pie_point.default._getElementCoords,
            _getLabelConnector: _pie_point.default._getLabelConnector,
            getTooltipParams: _pie_point.default.getTooltipParams,
            _getLabelPosition: _pie_point.default._getLabelPosition,
            _getCoords: polarSymbolPoint._getCoords,
            _translate: function() {
                var that = this;
                var translator = that._getValTranslator();
                var businessRange = translator.getBusinessRange();
                var maxRadius = translator.translate(CANVAS_POSITION_END);
                that.radiusInner = translator.translate(that.minValue);
                polarSymbolPoint._translate.call(that);
                if (null === that.radiusInner) {
                    that.radiusInner = that.radius = maxRadius
                } else {
                    if (null === that.radius) {
                        that.radius = that.value >= businessRange.minVisible ? maxRadius : 0
                    } else {
                        if (that.radius > maxRadius) {
                            that.radius = maxRadius
                        }
                    }
                }
                that.radiusOuter = that.radiusLabels = _max(that.radiusInner, that.radius);
                that.radiusLabels += RADIAL_LABEL_INDENT;
                that.radiusInner = that.defaultRadius = _math.min(that.radiusInner, that.radius);
                that.middleAngle = that.angle = -(0, _utils.normalizeAngle)(that.middleAngleCorrection - that.angle)
            },
            _checkRadiusForVisibleArea: function(radius) {
                return (0, _type.isDefined)(radius) || this._getValTranslator().translate(this.minValue) > 0
            },
            _getErrorBarBaseEdgeLength: function() {
                var coord = this.getMarkerCoords();
                return _math.PI * coord.outerRadius * _math.abs(coord.startAngle - coord.endAngle) / 180
            },
            getMarkerCoords: function() {
                return {
                    x: this.centerX,
                    y: this.centerY,
                    outerRadius: this.radiusOuter,
                    innerRadius: this.defaultRadius,
                    startAngle: this.middleAngle - this.interval / 2,
                    endAngle: this.middleAngle + this.interval / 2
                }
            },
            _drawMarker: function(renderer, group, animationEnabled) {
                var that = this;
                var styles = that._getStyle();
                var coords = that.getMarkerCoords();
                var innerRadius = coords.innerRadius;
                var outerRadius = coords.outerRadius;
                var start = that._getCoords(that.argument, CANVAS_POSITION_DEFAULT);
                var x = coords.x;
                var y = coords.y;
                if (animationEnabled) {
                    innerRadius = 0;
                    outerRadius = 0;
                    x = start.x;
                    y = start.y
                }
                that.graphic = renderer.arc(x, y, innerRadius, outerRadius, coords.startAngle, coords.endAngle).attr(styles).data({
                    "chart-data-point": that
                }).append(group)
            },
            _checkLabelPosition: function(label, coord) {
                var that = this;
                var visibleArea = that._getVisibleArea();
                var angleFunctions = (0, _utils.getCosAndSin)(that.middleAngle);
                var x = that.centerX + that.defaultRadius * angleFunctions.cos;
                var y = that.centerY - that.defaultRadius * angleFunctions.sin;
                if (x > visibleArea.minX && x < visibleArea.maxX && y > visibleArea.minY && y < visibleArea.maxY) {
                    coord = that._moveLabelOnCanvas(coord, visibleArea, label.getBoundingRect())
                }
                return coord
            },
            _addLabelAlignmentAndOffset: function(label, coord) {
                return coord
            },
            correctCoordinates: function(correctOptions) {
                this.middleAngleCorrection = correctOptions.offset;
                this.interval = correctOptions.width
            },
            coordsIn: function(x, y) {
                var val = (0, _utils.convertXYToPolar)(this.series.getValueAxis().getCenter(), x, y);
                var coords = this.getMarkerCoords();
                var isBetweenAngles = coords.startAngle < coords.endAngle ? -val.phi >= coords.startAngle && -val.phi <= coords.endAngle : -val.phi <= coords.startAngle && -val.phi >= coords.endAngle;
                return val.r >= coords.innerRadius && val.r <= coords.outerRadius && isBetweenAngles
            }
        });
        exports.polarBarPoint = polarBarPoint
    },
    /*!*************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/series/range_series.js ***!
      \*************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.chart = void 0;
        var _extend2 = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _scatter_series = __webpack_require__( /*! ./scatter_series */ 122);
        var _bar_series = __webpack_require__( /*! ./bar_series */ 163);
        var _area_series = __webpack_require__( /*! ./area_series */ 188);

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }
        var _extend = _extend2.extend;
        var barSeries = _bar_series.chart.bar;
        var areaSeries = _area_series.chart.area;
        var chart = {};
        exports.chart = chart;
        var baseRangeSeries = {
            areErrorBarsVisible: _common.noop,
            _createErrorBarGroup: _common.noop,
            _checkData: function(data, skippedFields) {
                var valueFields = this.getValueFields();
                return _scatter_series.chart._checkData.call(this, data, skippedFields, {
                    minValue: valueFields[0],
                    value: valueFields[1]
                }) && data.minValue === data.minValue
            },
            getValueRangeInitialValue: _scatter_series.chart.getValueRangeInitialValue,
            _getPointDataSelector: function(data) {
                var _this = this;
                var valueFields = this.getValueFields();
                var val1Field = valueFields[0];
                var val2Field = valueFields[1];
                var tagField = this.getTagField();
                var argumentField = this.getArgumentField();
                return function(data) {
                    return {
                        tag: data[tagField],
                        minValue: _this._processEmptyValue(data[val1Field]),
                        value: _this._processEmptyValue(data[val2Field]),
                        argument: data[argumentField],
                        data: data
                    }
                }
            },
            _defaultAggregator: "range",
            _aggregators: {
                range: function(_ref, series) {
                    var _data$reduce;
                    var intervalStart = _ref.intervalStart,
                        data = _ref.data;
                    if (!data.length) {
                        return
                    }
                    var valueFields = series.getValueFields();
                    var val1Field = valueFields[0];
                    var val2Field = valueFields[1];
                    var result = data.reduce(function(result, item) {
                        var val1 = item[val1Field];
                        var val2 = item[val2Field];
                        if (!(0, _type.isDefined)(val1) || !(0, _type.isDefined)(val2)) {
                            return result
                        }
                        result[val1Field] = Math.min(result[val1Field], Math.min(val1, val2));
                        result[val2Field] = Math.max(result[val2Field], Math.max(val1, val2));
                        return result
                    }, (_data$reduce = {}, _defineProperty(_data$reduce, val1Field, 1 / 0), _defineProperty(_data$reduce, val2Field, -(1 / 0)), _defineProperty(_data$reduce, series.getArgumentField(), intervalStart), _data$reduce));
                    if (!isFinite(result[val1Field]) || !isFinite(result[val2Field])) {
                        if (data.filter(function(i) {
                                return null === i[val1Field] && null === i[val2Field]
                            }).length === data.length) {
                            result[val1Field] = result[val2Field] = null
                        } else {
                            return
                        }
                    }
                    return result
                }
            },
            getValueFields: function() {
                return [this._options.rangeValue1Field || "val1", this._options.rangeValue2Field || "val2"]
            },
            getSeriesPairCoord: function(coord, isArgument) {
                var oppositeCoord = null;
                var rotated = this._options.rotated;
                var isOpposite = !isArgument && !rotated || isArgument && rotated;
                var coordName = isOpposite ? "vy" : "vx";
                var minCoordName = rotated ? "minX" : "minY";
                var oppositeCoordName = isOpposite ? "vx" : "vy";
                var points = this.getPoints();
                for (var i = 0; i < points.length; i++) {
                    var p = points[i];
                    var tmpCoord = void 0;
                    if (isArgument) {
                        tmpCoord = p.getCenterCoord()[coordName[1]] === coord ? p[oppositeCoordName] : void 0
                    } else {
                        var coords = [Math.min(p[coordName], p[minCoordName]), Math.max(p[coordName], p[minCoordName])];
                        tmpCoord = coord >= coords[0] && coord <= coords[1] ? p[oppositeCoordName] : void 0
                    }
                    if (this._checkAxisVisibleAreaCoord(!isArgument, tmpCoord)) {
                        oppositeCoord = tmpCoord;
                        break
                    }
                }
                return oppositeCoord
            }
        };
        chart.rangebar = _extend({}, barSeries, baseRangeSeries);
        chart.rangearea = _extend({}, areaSeries, {
            _drawPoint: function(options) {
                var point = options.point;
                if (point.isInVisibleArea()) {
                    point.clearVisibility();
                    point.draw(this._renderer, options.groups);
                    this._drawnPoints.push(point);
                    if (!point.visibleTopMarker) {
                        point.hideMarker("top")
                    }
                    if (!point.visibleBottomMarker) {
                        point.hideMarker("bottom")
                    }
                } else {
                    point.setInvisibility()
                }
            },
            _prepareSegment: function(points, rotated) {
                var processedPoints = this._processSinglePointsAreaSegment(points, rotated);
                var processedMinPointsCoords = (0, _utils.map)(processedPoints, function(pt) {
                    return pt.getCoords(true)
                });
                return {
                    line: processedPoints,
                    bottomLine: processedMinPointsCoords,
                    area: (0, _utils.map)(processedPoints, function(pt) {
                        return pt.getCoords()
                    }).concat(processedMinPointsCoords.slice().reverse()),
                    singlePointSegment: processedPoints !== points
                }
            },
            _getDefaultSegment: function(segment) {
                var defaultSegment = areaSeries._getDefaultSegment.call(this, segment);
                defaultSegment.bottomLine = defaultSegment.line;
                return defaultSegment
            },
            _removeElement: function(element) {
                areaSeries._removeElement.call(this, element);
                element.bottomLine && element.bottomLine.remove()
            },
            _drawElement: function(segment, group) {
                var that = this;
                var drawnElement = areaSeries._drawElement.call(that, segment, group);
                drawnElement.bottomLine = that._bordersGroup && that._createBorderElement(segment.bottomLine, {
                    "stroke-width": that._styles.normal.border["stroke-width"]
                }).append(that._bordersGroup);
                return drawnElement
            },
            _applyStyle: function(style) {
                var that = this;
                var elementsGroup = that._elementsGroup;
                var bordersGroup = that._bordersGroup;
                elementsGroup && elementsGroup.smartAttr(style.elements);
                bordersGroup && bordersGroup.attr(style.border);
                (that._graphics || []).forEach(function(graphic) {
                    graphic.line && graphic.line.attr({
                        "stroke-width": style.border["stroke-width"]
                    });
                    graphic.bottomLine && graphic.bottomLine.attr({
                        "stroke-width": style.border["stroke-width"]
                    })
                })
            },
            _updateElement: function(element, segment, animate, complete) {
                var bottomLineParams = {
                    points: segment.bottomLine
                };
                var bottomBorderElement = element.bottomLine;
                areaSeries._updateElement.apply(this, arguments);
                if (bottomBorderElement) {
                    animate ? bottomBorderElement.animate(bottomLineParams) : bottomBorderElement.attr(bottomLineParams)
                }
            }
        }, baseRangeSeries)
    },
    /*!**************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/series/bubble_series.js ***!
      \**************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.chart = void 0;
        var _line_series = __webpack_require__( /*! ./line_series */ 227);
        var _scatter_series = __webpack_require__( /*! ./scatter_series */ 122);
        var _area_series = __webpack_require__( /*! ./area_series */ 188);
        var _bar_series = __webpack_require__( /*! ./bar_series */ 163);
        var _extend2 = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }
        var lineSeries = _line_series.chart.line;
        var areaSeries = _area_series.chart.area;
        var chartBarSeries = _bar_series.chart.bar;
        var polarBarSeries = _bar_series.polar.bar;
        var _extend = _extend2.extend;
        var _each = _iterator.each;
        var _noop = _common.noop;
        var chart = {};
        exports.chart = chart;
        chart.bubble = _extend({}, _scatter_series.chart, {
            _calculateErrorBars: _noop,
            _getMainColor: chartBarSeries._getMainColor,
            _createPointStyles: chartBarSeries._createPointStyles,
            _updatePointsVisibility: chartBarSeries._updatePointsVisibility,
            _getOptionsForPoint: chartBarSeries._getOptionsForPoint,
            _applyMarkerClipRect: lineSeries._applyElementsClipRect,
            _parsePointStyle: polarBarSeries._parsePointStyle,
            _createLegendState: areaSeries._createLegendState,
            _setMarkerGroupSettings: polarBarSeries._setMarkerGroupSettings,
            areErrorBarsVisible: _noop,
            _createErrorBarGroup: _noop,
            _checkData: function(data, skippedFields) {
                return _scatter_series.chart._checkData.call(this, data, skippedFields, {
                    value: this.getValueFields()[0],
                    size: this.getSizeField()
                })
            },
            _getPointDataSelector: function(data, options) {
                var sizeField = this.getSizeField();
                var baseGetter = _scatter_series.chart._getPointDataSelector.call(this);
                return function(data) {
                    var pointData = baseGetter(data);
                    pointData.size = data[sizeField];
                    return pointData
                }
            },
            _aggregators: {
                avg: function(_ref, series) {
                    var _ref2;
                    var data = _ref.data,
                        intervalStart = _ref.intervalStart;
                    if (!data.length) {
                        return
                    }
                    var valueField = series.getValueFields()[0];
                    var sizeField = series.getSizeField();
                    var aggregate = data.reduce(function(result, item) {
                        result[0] += item[valueField];
                        result[1] += item[sizeField];
                        result[2]++;
                        return result
                    }, [0, 0, 0]);
                    return _ref2 = {}, _defineProperty(_ref2, valueField, aggregate[0] / aggregate[2]), _defineProperty(_ref2, sizeField, aggregate[1] / aggregate[2]), _defineProperty(_ref2, series.getArgumentField(), intervalStart), _ref2
                }
            },
            getValueFields: function() {
                return [this._options.valueField || "val"]
            },
            getSizeField: function() {
                return this._options.sizeField || "size"
            },
            _animate: function() {
                var that = this;
                var lastPointIndex = that._drawnPoints.length - 1;
                var labelsGroup = that._labelsGroup;
                var labelAnimFunc = function() {
                    labelsGroup && labelsGroup.animate({
                        opacity: 1
                    }, {
                        duration: that._defaultDuration
                    })
                };
                _each(that._drawnPoints || [], function(i, p) {
                    p.animate(i === lastPointIndex ? labelAnimFunc : void 0, {
                        r: p.bubbleSize,
                        translateX: p.x,
                        translateY: p.y
                    })
                })
            },
            _patchMarginOptions: function(options) {
                options.processBubbleSize = true;
                return options
            }
        })
    },
    /*!***********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/series/pie_series.js ***!
      \***********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.donut = exports.doughnut = exports.pie = void 0;
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _scatter_series = __webpack_require__( /*! ./scatter_series */ 122);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _extend2 = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _bar_series = __webpack_require__( /*! ./bar_series */ 163);
        var chartScatterSeries = _scatter_series.chart;
        var barSeries = _bar_series.chart.bar;
        var _extend = _extend2.extend;
        var _each = _iterator.each;
        var _noop = _common.noop;
        var _map = _utils.map;
        var _isFinite = isFinite;
        var _max = Math.max;
        var ANIMATION_DURATION = .7;
        var INSIDE = "inside";
        var pie = _extend({}, barSeries, {
            _setGroupsSettings: function() {
                chartScatterSeries._setGroupsSettings.apply(this, arguments);
                this._labelsGroup.attr({
                    "pointer-events": null
                })
            },
            _createErrorBarGroup: _noop,
            _drawPoint: function(options) {
                var point = options.point;
                var legendCallback = this._legendCallback;
                chartScatterSeries._drawPoint.call(this, options);
                !point.isVisible() && point.setInvisibility();
                point.isSelected() && legendCallback()
            },
            _getOldPoint: function(data, oldPointsByArgument, index) {
                var point = (this._points || [])[index];
                if (point) {
                    oldPointsByArgument[point.argument.valueOf()] = oldPointsByArgument[point.argument.valueOf()].filter(function(p) {
                        return p !== point
                    })
                }
                return point
            },
            adjustLabels: function(moveLabelsFromCenter) {
                return (this._points || []).reduce(function(r, p) {
                    if (p._label.isVisible()) {
                        p.setLabelTrackerData();
                        r = p.applyWordWrap(moveLabelsFromCenter) || r;
                        p.updateLabelCoord(moveLabelsFromCenter);
                        return r
                    }
                }, false)
            },
            _applyElementsClipRect: _noop,
            getColor: _noop,
            areErrorBarsVisible: _noop,
            drawLabelsWOPoints: function() {
                var that = this;
                if (that._options.label.position === INSIDE) {
                    return false
                }
                that._labelsGroup.append(that._extGroups.labelsGroup);
                (that._points || []).forEach(function(point) {
                    point.drawLabel()
                });
                return true
            },
            getPointsCount: function() {
                var _this = this;
                return this._data.filter(function(d) {
                    return _this._checkData(d)
                }).length
            },
            setMaxPointsCount: function(count) {
                this._pointsCount = count
            },
            _getCreatingPointOptions: function(data, dataIndex) {
                return this._getPointOptions(data, dataIndex)
            },
            _updateOptions: function(options) {
                this.labelSpace = 0;
                this.innerRadius = "pie" === this.type ? 0 : options.innerRadius
            },
            _checkData: function(data, skippedFields) {
                var base = barSeries._checkData.call(this, data, skippedFields, {
                    value: this.getValueFields()[0]
                });
                return this._options.paintNullPoints ? base : base && null !== data.value
            },
            _createGroups: chartScatterSeries._createGroups,
            _setMarkerGroupSettings: function() {
                this._markersGroup.attr({
                    "class": "dxc-markers"
                })
            },
            _getMainColor: function(data, point) {
                var pointsByArg = this.getPointsByArg(data.argument);
                var argumentIndex = point ? pointsByArg.indexOf(point) : pointsByArg.length;
                return this._options.mainSeriesColor(data.argument, argumentIndex, this._pointsCount)
            },
            _getPointOptions: function(data) {
                return this._parsePointOptions(this._preparePointOptions(), this._options.label, data)
            },
            _getRangeData: function() {
                return this._rangeData
            },
            _createPointStyles: function(pointOptions, data, point) {
                var that = this;
                var mainColor = pointOptions.color || that._getMainColor(data, point);
                return {
                    normal: that._parsePointStyle(pointOptions, mainColor, mainColor),
                    hover: that._parsePointStyle(pointOptions.hoverStyle, mainColor, mainColor),
                    selection: that._parsePointStyle(pointOptions.selectionStyle, mainColor, mainColor),
                    legendStyles: {
                        normal: that._createLegendState(pointOptions, mainColor),
                        hover: that._createLegendState(pointOptions.hoverStyle, mainColor),
                        selection: that._createLegendState(pointOptions.selectionStyle, mainColor)
                    }
                }
            },
            _getArrangeMinShownValue: function(points, total) {
                var minSegmentSize = this._options.minSegmentSize;
                var totalMinSegmentSize = 0;
                var totalNotMinValues = 0;
                total = total || points.length;
                _each(points, function(_, point) {
                    if (point.isVisible()) {
                        if (point.normalInitialValue < minSegmentSize * total / 360) {
                            totalMinSegmentSize += minSegmentSize
                        } else {
                            totalNotMinValues += point.normalInitialValue
                        }
                    }
                });
                return totalMinSegmentSize < 360 ? minSegmentSize * totalNotMinValues / (360 - totalMinSegmentSize) : 0
            },
            _applyArrangeCorrection: function(points, minShownValue, total) {
                var options = this._options;
                var isClockWise = "anticlockwise" !== options.segmentsDirection;
                var shiftedAngle = _isFinite(options.startAngle) ? (0, _utils.normalizeAngle)(options.startAngle) : 0;
                var minSegmentSize = options.minSegmentSize;
                var percent;
                var correction = 0;
                var zeroTotalCorrection = 0;
                if (0 === total) {
                    total = points.filter(function(el) {
                        return el.isVisible()
                    }).length;
                    zeroTotalCorrection = 1
                }
                _each(isClockWise ? points : points.concat([]).reverse(), function(_, point) {
                    var val = point.isVisible() ? zeroTotalCorrection || point.normalInitialValue : 0;
                    var updatedZeroValue;
                    if (minSegmentSize && point.isVisible() && val < minShownValue) {
                        updatedZeroValue = minShownValue
                    }
                    percent = val / total;
                    point.correctValue(correction, percent, zeroTotalCorrection + (updatedZeroValue || 0));
                    point.shiftedAngle = shiftedAngle;
                    correction += updatedZeroValue || val
                });
                this._rangeData = {
                    val: {
                        min: 0,
                        max: correction
                    }
                }
            },
            _removePoint: function(point) {
                var points = this.getPointsByArg(point.argument);
                points.splice(points.indexOf(point), 1);
                point.dispose()
            },
            arrangePoints: function() {
                var that = this;
                var originalPoints = that._points || [];
                var minSegmentSize = that._options.minSegmentSize;
                var minShownValue;
                var isAllPointsNegative = true;
                var i = 0;
                var len = originalPoints.length;
                while (i < len && isAllPointsNegative) {
                    isAllPointsNegative = originalPoints[i].value <= 0;
                    i++
                }
                var points = that._points = _map(originalPoints, function(point) {
                    if (null === point.value || !isAllPointsNegative && point.value < 0) {
                        that._removePoint(point);
                        return null
                    } else {
                        return point
                    }
                });
                var maxValue = points.reduce(function(max, p) {
                    return _max(max, Math.abs(p.initialValue))
                }, 0);
                points.forEach(function(p) {
                    p.normalInitialValue = p.initialValue / (0 !== maxValue ? maxValue : 1)
                });
                var total = points.reduce(function(total, point) {
                    return total + (point.isVisible() ? point.normalInitialValue : 0)
                }, 0);
                if (minSegmentSize) {
                    minShownValue = this._getArrangeMinShownValue(points, total)
                }
                that._applyArrangeCorrection(points, minShownValue, total)
            },
            correctPosition: function(correction, canvas) {
                _each(this._points, function(_, point) {
                    point.correctPosition(correction)
                });
                this.setVisibleArea(canvas)
            },
            correctRadius: function(correction) {
                this._points.forEach(function(point) {
                    point.correctRadius(correction)
                })
            },
            correctLabelRadius: function(labelRadius) {
                this._points.forEach(function(point) {
                    point.correctLabelRadius(labelRadius)
                })
            },
            setVisibleArea: function(canvas) {
                this._visibleArea = {
                    minX: canvas.left,
                    maxX: canvas.width - canvas.right,
                    minY: canvas.top,
                    maxY: canvas.height - canvas.bottom
                }
            },
            _applyVisibleArea: _noop,
            _animate: function(firstDrawing) {
                var that = this;
                var points = that._points;
                var pointsCount = points && points.length;
                var completeFunc = function() {
                    that._animateComplete()
                };
                var animatePoint;
                if (firstDrawing) {
                    animatePoint = function(p, i) {
                        p.animate(i === pointsCount - 1 ? completeFunc : void 0, ANIMATION_DURATION, (1 - ANIMATION_DURATION) * i / (pointsCount - 1))
                    }
                } else {
                    animatePoint = function(p, i) {
                        p.animate(i === pointsCount - 1 ? completeFunc : void 0)
                    }
                }
                points.forEach(animatePoint)
            },
            getVisiblePoints: function() {
                return _map(this._points, function(p) {
                    return p.isVisible() ? p : null
                })
            },
            getPointsByKeys: function(arg, argumentIndex) {
                var pointsByArg = this.getPointsByArg(arg);
                return pointsByArg[argumentIndex] && [pointsByArg[argumentIndex]] || []
            }
        });
        exports.pie = pie;
        var doughnut = pie;
        exports.doughnut = doughnut;
        var donut = pie;
        exports.donut = donut
    },
    /*!*****************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/series/financial_series.js ***!
      \*****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.candlestick = exports.stock = void 0;
        var _scatter_series = __webpack_require__( /*! ./scatter_series */ 122);
        var _bar_series = __webpack_require__( /*! ./bar_series */ 163);
        var _extend2 = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var barSeries = _bar_series.chart.bar;
        var DEFAULT_FINANCIAL_POINT_SIZE = 10;
        var stock = (0, _extend2.extend)({}, _scatter_series.chart, {
            _animate: _common.noop,
            _applyMarkerClipRect: function(settings) {
                settings["clip-path"] = this._forceClipping ? this._paneClipRectID : this._widePaneClipRectID
            },
            _updatePointsVisibility: barSeries._updatePointsVisibility,
            _getOptionsForPoint: barSeries._getOptionsForPoint,
            _createErrorBarGroup: _common.noop,
            areErrorBarsVisible: _common.noop,
            _createGroups: _scatter_series.chart._createGroups,
            _setMarkerGroupSettings: function() {
                var that = this;
                var markersGroup = that._markersGroup;
                var styles = that._createPointStyles(that._getMarkerGroupOptions());
                var defaultStyle = (0, _extend2.extend)(styles.normal, {
                    "class": "default-markers"
                });
                var defaultPositiveStyle = (0, _extend2.extend)(styles.positive.normal, {
                    "class": "default-positive-markers"
                });
                var reductionStyle = (0, _extend2.extend)(styles.reduction.normal, {
                    "class": "reduction-markers"
                });
                var reductionPositiveStyle = (0, _extend2.extend)(styles.reductionPositive.normal, {
                    "class": "reduction-positive-markers"
                });
                var markerSettings = {
                    "class": "dxc-markers"
                };
                that._applyMarkerClipRect(markerSettings);
                markersGroup.attr(markerSettings);
                that._createGroup("defaultMarkersGroup", markersGroup, markersGroup, defaultStyle);
                that._createGroup("reductionMarkersGroup", markersGroup, markersGroup, reductionStyle);
                that._createGroup("defaultPositiveMarkersGroup", markersGroup, markersGroup, defaultPositiveStyle);
                that._createGroup("reductionPositiveMarkersGroup", markersGroup, markersGroup, reductionPositiveStyle)
            },
            _setGroupsSettings: function() {
                _scatter_series.chart._setGroupsSettings.call(this, false)
            },
            _getCreatingPointOptions: function() {
                var that = this;
                var defaultPointOptions;
                var creatingPointOptions = that._predefinedPointOptions;
                if (!creatingPointOptions) {
                    defaultPointOptions = this._getPointOptions();
                    that._predefinedPointOptions = creatingPointOptions = (0, _extend2.extend)(true, {
                        styles: {}
                    }, defaultPointOptions);
                    creatingPointOptions.styles.normal = creatingPointOptions.styles.positive.normal = creatingPointOptions.styles.reduction.normal = creatingPointOptions.styles.reductionPositive.normal = {
                        "stroke-width": defaultPointOptions.styles && defaultPointOptions.styles.normal && defaultPointOptions.styles.normal["stroke-width"]
                    }
                }
                return creatingPointOptions
            },
            _checkData: function(data, skippedFields) {
                var valueFields = this.getValueFields();
                return _scatter_series.chart._checkData.call(this, data, skippedFields, {
                    openValue: valueFields[0],
                    highValue: valueFields[1],
                    lowValue: valueFields[2],
                    closeValue: valueFields[3]
                }) && data.highValue === data.highValue && data.lowValue === data.lowValue
            },
            _getPointDataSelector: function(data, options) {
                var _this = this;
                var that = this;
                var level;
                var valueFields = that.getValueFields();
                var argumentField = that.getArgumentField();
                var openValueField = valueFields[0];
                var highValueField = valueFields[1];
                var lowValueField = valueFields[2];
                var closeValueField = valueFields[3];
                that.level = that._options.reduction.level;
                switch ((0, _utils.normalizeEnum)(that.level)) {
                    case "open":
                        level = openValueField;
                        break;
                    case "high":
                        level = highValueField;
                        break;
                    case "low":
                        level = lowValueField;
                        break;
                    default:
                        level = closeValueField;
                        that.level = "close"
                }
                var prevLevelValue;
                return function(data) {
                    var reductionValue = data[level];
                    var isReduction = false;
                    if ((0, _type.isDefined)(reductionValue)) {
                        if ((0, _type.isDefined)(prevLevelValue)) {
                            isReduction = reductionValue < prevLevelValue
                        }
                        prevLevelValue = reductionValue
                    }
                    return {
                        argument: data[argumentField],
                        highValue: _this._processEmptyValue(data[highValueField]),
                        lowValue: _this._processEmptyValue(data[lowValueField]),
                        closeValue: _this._processEmptyValue(data[closeValueField]),
                        openValue: _this._processEmptyValue(data[openValueField]),
                        reductionValue: reductionValue,
                        tag: data[that.getTagField()],
                        isReduction: isReduction,
                        data: data
                    }
                }
            },
            _parsePointStyle: function(style, defaultColor, innerColor) {
                return {
                    stroke: style.color || defaultColor,
                    "stroke-width": style.width,
                    fill: style.color || innerColor
                }
            },
            _getDefaultStyle: function(options) {
                var that = this;
                var mainPointColor = options.color || that._options.mainSeriesColor;
                return {
                    normal: that._parsePointStyle(options, mainPointColor, mainPointColor),
                    hover: that._parsePointStyle(options.hoverStyle, mainPointColor, mainPointColor),
                    selection: that._parsePointStyle(options.selectionStyle, mainPointColor, mainPointColor)
                }
            },
            _getReductionStyle: function(options) {
                var that = this;
                var reductionColor = options.reduction.color;
                return {
                    normal: that._parsePointStyle({
                        color: reductionColor,
                        width: options.width,
                        hatching: options.hatching
                    }, reductionColor, reductionColor),
                    hover: that._parsePointStyle(options.hoverStyle, reductionColor, reductionColor),
                    selection: that._parsePointStyle(options.selectionStyle, reductionColor, reductionColor)
                }
            },
            _createPointStyles: function(pointOptions) {
                var that = this;
                var innerColor = that._options.innerColor;
                var styles = that._getDefaultStyle(pointOptions);
                var positiveStyle = (0, _extend2.extend)(true, {}, styles);
                var reductionStyle = that._getReductionStyle(pointOptions);
                var reductionPositiveStyle = (0, _extend2.extend)(true, {}, reductionStyle);
                positiveStyle.normal.fill = positiveStyle.hover.fill = positiveStyle.selection.fill = innerColor;
                reductionPositiveStyle.normal.fill = reductionPositiveStyle.hover.fill = reductionPositiveStyle.selection.fill = innerColor;
                styles.positive = positiveStyle;
                styles.reduction = reductionStyle;
                styles.reductionPositive = reductionPositiveStyle;
                return styles
            },
            _endUpdateData: function() {
                delete this._predefinedPointOptions
            },
            _defaultAggregator: "ohlc",
            _aggregators: {
                ohlc: function(_ref, series) {
                    var intervalStart = _ref.intervalStart,
                        data = _ref.data;
                    if (!data.length) {
                        return
                    }
                    var result = {};
                    var valueFields = series.getValueFields();
                    var highValueField = valueFields[1];
                    var lowValueField = valueFields[2];
                    result[highValueField] = -(1 / 0);
                    result[lowValueField] = 1 / 0;
                    result = data.reduce(function(result, item) {
                        if (null !== item[highValueField]) {
                            result[highValueField] = Math.max(result[highValueField], item[highValueField])
                        }
                        if (null !== item[lowValueField]) {
                            result[lowValueField] = Math.min(result[lowValueField], item[lowValueField])
                        }
                        return result
                    }, result);
                    result[valueFields[0]] = data[0][valueFields[0]];
                    result[valueFields[3]] = data[data.length - 1][valueFields[3]];
                    if (!isFinite(result[highValueField])) {
                        result[highValueField] = null
                    }
                    if (!isFinite(result[lowValueField])) {
                        result[lowValueField] = null
                    }
                    result[series.getArgumentField()] = intervalStart;
                    return result
                }
            },
            getValueFields: function() {
                var options = this._options;
                return [options.openValueField || "open", options.highValueField || "high", options.lowValueField || "low", options.closeValueField || "close"]
            },
            getArgumentField: function() {
                return this._options.argumentField || "date"
            },
            _patchMarginOptions: function(options) {
                var pointOptions = this._getCreatingPointOptions();
                var styles = pointOptions.styles;
                var border = [styles.normal, styles.hover, styles.selection].reduce(function(max, style) {
                    return Math.max(max, style["stroke-width"])
                }, 0);
                options.size = DEFAULT_FINANCIAL_POINT_SIZE + border;
                options.sizePointNormalState = DEFAULT_FINANCIAL_POINT_SIZE;
                return options
            },
            getSeriesPairCoord: function(coord, isArgument) {
                var oppositeCoord = null;
                var points = this.getVisiblePoints();
                for (var i = 0; i < points.length; i++) {
                    var p = points[i];
                    var tmpCoord = void 0;
                    if (isArgument) {
                        tmpCoord = p.vx === coord ? (p.openY + p.closeY) / 2 : void 0
                    } else {
                        var coords = [Math.min(p.lowY, p.highY), Math.max(p.lowY, p.highY)];
                        tmpCoord = coord >= coords[0] && coord <= coords[1] ? p.vx : void 0
                    }
                    if (this._checkAxisVisibleAreaCoord(!isArgument, tmpCoord)) {
                        oppositeCoord = tmpCoord;
                        break
                    }
                }
                return oppositeCoord
            },
            usePointsToDefineAutoHiding: function() {
                return false
            }
        });
        exports.stock = stock;
        var candlestick = (0, _extend2.extend)({}, stock, {
            _parsePointStyle: function(style, defaultColor, innerColor) {
                var color = style.color || innerColor;
                var base = stock._parsePointStyle.call(this, style, defaultColor, color);
                base.fill = color;
                base.hatching = style.hatching;
                return base
            }
        });
        exports.candlestick = candlestick
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/series/stacked_series.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.polar = exports.chart = void 0;
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _extend2 = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _area_series = __webpack_require__( /*! ./area_series */ 188);
        var _bar_series = __webpack_require__( /*! ./bar_series */ 163);
        var _line_series = __webpack_require__( /*! ./line_series */ 227);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _object = __webpack_require__( /*! ../../core/utils/object */ 51);
        var chartAreaSeries = _area_series.chart.area;
        var chartBarSeries = _bar_series.chart.bar;
        var baseStackedSeries = {
            _calculateErrorBars: _common.noop,
            _updateOptions: function(options) {
                this._stackName = "axis_" + (options.axis || "default")
            }
        };
        var chart = {};
        exports.chart = chart;
        var polar = {};
        exports.polar = polar;
        chart.stackedline = (0, _extend2.extend)({}, _line_series.chart.line, baseStackedSeries, {});
        chart.stackedspline = (0, _extend2.extend)({}, _line_series.chart.spline, baseStackedSeries, {});
        chart.fullstackedline = (0, _extend2.extend)({}, _line_series.chart.line, baseStackedSeries, {
            getValueRangeInitialValue: _area_series.chart.area.getValueRangeInitialValue
        });
        chart.fullstackedspline = (0, _extend2.extend)({}, _line_series.chart.spline, baseStackedSeries, {
            getValueRangeInitialValue: _area_series.chart.area.getValueRangeInitialValue
        });
        var stackedBar = chart.stackedbar = (0, _extend2.extend)({}, chartBarSeries, baseStackedSeries, {
            _updateOptions: function(options) {
                baseStackedSeries._updateOptions.call(this, options);
                this._stackName = this._stackName + "_stack_" + (options.stack || "default")
            }
        });
        chart.fullstackedbar = (0, _extend2.extend)({}, chartBarSeries, baseStackedSeries, {
            _updateOptions: stackedBar._updateOptions
        });

        function clonePoint(point, value, minValue, position) {
            point = (0, _object.clone)(point);
            point.value = value;
            point.minValue = minValue;
            point.translate();
            point.argument = point.argument + position;
            return point
        }

        function preparePointsForStackedAreaSegment(points) {
            var i = 0;
            var p;
            var result = [];
            var array;
            var len = points.length;
            while (i < len) {
                p = points[i];
                array = [p];
                if (p.leftHole) {
                    array = [clonePoint(p, p.leftHole, p.minLeftHole, "left"), p]
                }
                if (p.rightHole) {
                    array.push(clonePoint(p, p.rightHole, p.minRightHole, "right"))
                }
                result.push(array);
                i++
            }
            return [].concat.apply([], result)
        }
        chart.stackedarea = (0, _extend2.extend)({}, chartAreaSeries, baseStackedSeries, {
            _prepareSegment: function(points, rotated) {
                return chartAreaSeries._prepareSegment.call(this, preparePointsForStackedAreaSegment(points), rotated)
            },
            _appendInGroup: function() {
                this._group.append(this._extGroups.seriesGroup).toBackground()
            }
        });

        function getPointsByArgFromPrevSeries(prevSeries, argument) {
            var result;
            while (!result && prevSeries) {
                result = prevSeries._segmentByArg && prevSeries._segmentByArg[argument];
                prevSeries = prevSeries._prevSeries
            }
            return result
        }
        chart.stackedsplinearea = (0, _extend2.extend)({}, _area_series.chart.splinearea, baseStackedSeries, {
            _prepareSegment: function(points, rotated) {
                var that = this;
                var areaSegment;
                points = preparePointsForStackedAreaSegment(points);
                if (!this._prevSeries || 1 === points.length) {
                    areaSegment = _area_series.chart.splinearea._prepareSegment.call(this, points, rotated)
                } else {
                    var forwardPoints = _line_series.chart.spline._calculateBezierPoints(points, rotated);
                    var backwardPoints = (0, _utils.map)(points, function(p) {
                        var point = p.getCoords(true);
                        point.argument = p.argument;
                        return point
                    });
                    var prevSeriesForwardPoints = [];
                    var pointByArg = {};
                    var i = 0;
                    var len = that._prevSeries._segments.length;
                    while (i < len) {
                        prevSeriesForwardPoints = prevSeriesForwardPoints.concat(that._prevSeries._segments[i].line);
                        i++
                    }(0, _iterator.each)(prevSeriesForwardPoints, function(_, p) {
                        if (null !== p.argument) {
                            var argument = p.argument.valueOf();
                            if (!pointByArg[argument]) {
                                pointByArg[argument] = [p]
                            } else {
                                pointByArg[argument].push(p)
                            }
                        }
                    });
                    that._prevSeries._segmentByArg = pointByArg;
                    backwardPoints = _line_series.chart.spline._calculateBezierPoints(backwardPoints, rotated);
                    (0, _iterator.each)(backwardPoints, function(i, p) {
                        var argument = p.argument.valueOf();
                        var prevSeriesPoints;
                        if (i % 3 === 0) {
                            prevSeriesPoints = pointByArg[argument] || getPointsByArgFromPrevSeries(that._prevSeries, argument);
                            if (prevSeriesPoints) {
                                backwardPoints[i - 1] && prevSeriesPoints[0] && (backwardPoints[i - 1] = prevSeriesPoints[0]);
                                backwardPoints[i + 1] && (backwardPoints[i + 1] = prevSeriesPoints[2] || p)
                            }
                        }
                    });
                    areaSegment = {
                        line: forwardPoints,
                        area: forwardPoints.concat(backwardPoints.reverse())
                    };
                    that._areaPointsToSplineAreaPoints(areaSegment.area)
                }
                return areaSegment
            },
            _appendInGroup: chart.stackedarea._appendInGroup
        });
        chart.fullstackedarea = (0, _extend2.extend)({}, chartAreaSeries, baseStackedSeries, {
            _prepareSegment: chart.stackedarea._prepareSegment,
            _appendInGroup: chart.stackedarea._appendInGroup
        });
        chart.fullstackedsplinearea = (0, _extend2.extend)({}, _area_series.chart.splinearea, baseStackedSeries, {
            _prepareSegment: chart.stackedsplinearea._prepareSegment,
            _appendInGroup: chart.stackedarea._appendInGroup
        });
        polar.stackedbar = (0, _extend2.extend)({}, _bar_series.polar.bar, baseStackedSeries, {})
    },
    /*!******************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/chart_components/tracker.js ***!
      \******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.PieTracker = exports.ChartTracker = void 0;
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _click = __webpack_require__( /*! ../../events/click */ 21);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _consts = _interopRequireDefault(__webpack_require__( /*! ../components/consts */ 143));
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../../events/pointer */ 24));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _floor = Math.floor;
        var eventsConsts = _consts.default.events;
        var statesConsts = _consts.default.states;
        var HOVER_STATE = statesConsts.hoverMark;
        var NORMAL_STATE = statesConsts.normalMark;
        var EVENT_NS = "dxChartTracker";
        var DOT_EVENT_NS = "." + EVENT_NS;
        var POINTER_ACTION = (0, _index.addNamespace)([_pointer.default.down, _pointer.default.move], EVENT_NS);
        var LEGEND_CLICK = "legendClick";
        var SERIES_CLICK = "seriesClick";
        var POINT_CLICK = "pointClick";
        var POINT_DATA = "chart-data-point";
        var SERIES_DATA = "chart-data-series";
        var ARG_DATA = "chart-data-argument";
        var DELAY = 100;
        var HOLD_TIMEOUT = 300;
        var NONE_MODE = "none";
        var ALL_ARGUMENT_POINTS_MODE = "allargumentpoints";
        var INCLUDE_POINTS_MODE = "includepoints";
        var EXLUDE_POINTS_MODE = "excludepoints";
        var LEGEND_HOVER_MODES = [INCLUDE_POINTS_MODE, EXLUDE_POINTS_MODE, NONE_MODE];

        function getData(event, dataKey, tryCheckParent) {
            var target = event.target;
            if ("tspan" === target.tagName) {
                return target.parentNode[dataKey]
            }
            var data = target[dataKey];
            if (tryCheckParent && !(0, _type.isDefined)(data)) {
                var getParentData = function getParentData(node) {
                    if (node.parentNode) {
                        if ((0, _type.isDefined)(node.parentNode[dataKey])) {
                            return node.parentNode[dataKey]
                        } else {
                            return getParentData(node.parentNode)
                        }
                    }
                    return
                };
                return getParentData(target)
            }
            return data
        }

        function eventCanceled(event, target) {
            return event.cancel || !target.getOptions()
        }

        function correctLegendHoverMode(mode) {
            if (LEGEND_HOVER_MODES.indexOf(mode) > -1) {
                return mode
            } else {
                return INCLUDE_POINTS_MODE
            }
        }

        function correctHoverMode(target) {
            var mode = target.getOptions().hoverMode;
            return mode === NONE_MODE ? mode : ALL_ARGUMENT_POINTS_MODE
        }
        var baseTrackerPrototype = {
            ctor: function(options) {
                var that = this;
                var data = {
                    tracker: that
                };
                that._renderer = options.renderer;
                that._legend = options.legend;
                that._tooltip = options.tooltip;
                that._eventTrigger = options.eventTrigger;
                that._seriesGroup = options.seriesGroup;
                options.seriesGroup.off(DOT_EVENT_NS).on((0, _index.addNamespace)(eventsConsts.showPointTooltip, EVENT_NS), data, that._showPointTooltip).on((0, _index.addNamespace)(eventsConsts.hidePointTooltip, EVENT_NS), data, that._hidePointTooltip);
                that._renderer.root.off(DOT_EVENT_NS).on(POINTER_ACTION, data, that._pointerHandler).on((0, _index.addNamespace)(_pointer.default.up, EVENT_NS), function() {
                    return clearTimeout(that._holdTimer)
                }).on((0, _index.addNamespace)(_click.name, EVENT_NS), data, that._clickHandler)
            },
            update: function(options) {
                this._chart = options.chart
            },
            updateSeries: function(series, resetDecorations) {
                var that = this;
                var noHoveredSeries = !(null !== series && void 0 !== series && series.some(function(s) {
                    return s === that.hoveredSeries
                }) || that._hoveredPoint && that._hoveredPoint.series);
                if (that._storedSeries !== series) {
                    that._storedSeries = series || []
                }
                if (noHoveredSeries) {
                    that._clean();
                    that._renderer.initHatching()
                }
                if (resetDecorations) {
                    that.clearSelection();
                    if (!noHoveredSeries) {
                        that._hideTooltip(that.pointAtShownTooltip);
                        that.clearHover()
                    }
                }
            },
            setCanvases: function(mainCanvas, paneCanvases) {
                this._mainCanvas = mainCanvas;
                this._canvases = paneCanvases
            },
            repairTooltip: function() {
                var point = this.pointAtShownTooltip;
                if (!point || !point.series || !point.isVisible()) {
                    this._hideTooltip(point, true)
                } else {
                    this._showTooltip(point)
                }
            },
            _setHoveredPoint: function(point) {
                if (point === this._hoveredPoint) {
                    return
                }
                this._releaseHoveredPoint();
                point.hover();
                this._hoveredPoint = point
            },
            _releaseHoveredPoint: function() {
                if (this._hoveredPoint && this._hoveredPoint.getOptions()) {
                    this._hoveredPoint.clearHover();
                    this._hoveredPoint = null;
                    if (this._tooltip.isEnabled()) {
                        this._hideTooltip(this._hoveredPoint)
                    }
                }
            },
            _setHoveredSeries: function(series, mode) {
                this._releaseHoveredSeries();
                this._releaseHoveredPoint();
                series.hover(mode);
                this.hoveredSeries = series
            },
            _releaseHoveredSeries: function() {
                if (this.hoveredSeries) {
                    this.hoveredSeries.clearHover();
                    this.hoveredSeries = null
                }
            },
            clearSelection: function() {
                this._storedSeries.forEach(function(series) {
                    if (series) {
                        series.clearSelection();
                        series.getPoints().forEach(function(point) {
                            return point.clearSelection()
                        })
                    }
                })
            },
            _clean: function() {
                var that = this;
                that.hoveredPoint = that.hoveredSeries = that._hoveredArgumentPoints = null;
                that._hideTooltip(that.pointAtShownTooltip)
            },
            clearHover: function() {
                this._resetHoveredArgument();
                this._releaseHoveredSeries();
                this._releaseHoveredPoint()
            },
            _hideTooltip: function(point, silent) {
                var that = this;
                if (!that._tooltip || point && that.pointAtShownTooltip !== point) {
                    return
                }
                if (!silent && that.pointAtShownTooltip) {
                    that.pointAtShownTooltip = null
                }
                that._tooltip.hide()
            },
            _showTooltip: function(point) {
                var that = this;
                var tooltipFormatObject;
                var eventData = {
                    target: point
                };
                if (null !== point && void 0 !== point && point.getOptions()) {
                    tooltipFormatObject = point.getTooltipFormatObject(that._tooltip, that._tooltip.isShared() && that._chart.getStackedPoints(point));
                    if (!(0, _type.isDefined)(tooltipFormatObject.valueText) && !tooltipFormatObject.points || !point.isVisible()) {
                        return
                    }
                    var coords = point.getTooltipParams(that._tooltip.getLocation());
                    var rootOffset = that._renderer.getRootOffset();
                    coords.x += rootOffset.left;
                    coords.y += rootOffset.top;
                    var callback = function(result) {
                        result && (that.pointAtShownTooltip = point)
                    };
                    callback(that._tooltip.show(tooltipFormatObject, coords, eventData, void 0, callback))
                }
            },
            _showPointTooltip: function(event, point) {
                var that = event.data.tracker;
                var pointWithTooltip = that.pointAtShownTooltip;
                if (pointWithTooltip && pointWithTooltip !== point) {
                    that._hideTooltip(pointWithTooltip)
                }
                that._showTooltip(point)
            },
            _hidePointTooltip: function(event, point) {
                event.data.tracker._hideTooltip(point)
            },
            _enableOutHandler: function() {
                if (this._outHandler) {
                    return
                }
                var that = this;
                var handler = function(e) {
                    var rootOffset = that._renderer.getRootOffset();
                    var x = _floor(e.pageX - rootOffset.left);
                    var y = _floor(e.pageY - rootOffset.top);
                    if (!(0, _utils.pointInCanvas)(that._mainCanvas, x, y) && !that._tooltip.isCursorOnTooltip(e.pageX, e.pageY)) {
                        that._pointerOut();
                        that._disableOutHandler()
                    }
                };
                _events_engine.default.on(_dom_adapter.default.getDocument(), POINTER_ACTION, handler);
                this._outHandler = handler
            },
            _disableOutHandler: function() {
                this._outHandler && _events_engine.default.off(_dom_adapter.default.getDocument(), POINTER_ACTION, this._outHandler);
                this._outHandler = null
            },
            stopCurrentHandling: function() {
                this._pointerOut(true)
            },
            _pointerOut: function(force) {
                this.clearHover();
                (force || this._tooltip.isEnabled()) && this._hideTooltip(this.pointAtShownTooltip)
            },
            _triggerLegendClick: function(eventArgs, elementClick) {
                var eventTrigger = this._eventTrigger;
                eventTrigger(LEGEND_CLICK, eventArgs, function() {
                    !eventCanceled(eventArgs.event, eventArgs.target) && eventTrigger(elementClick, eventArgs)
                })
            },
            _hoverLegendItem: function(x, y) {
                var that = this;
                var item = that._legend.getItemByCoord(x, y);
                var series;
                var legendHoverMode = correctLegendHoverMode(that._legend.getOptions().hoverMode);
                if (item) {
                    series = that._storedSeries[item.id];
                    if (!series.isHovered() || series.lastHoverMode !== legendHoverMode) {
                        that._setHoveredSeries(series, legendHoverMode)
                    }
                    that._tooltip.isEnabled() && that._hideTooltip(that.pointAtShownTooltip)
                } else {
                    that.clearHover()
                }
            },
            _hoverArgument: function(argument, argumentIndex) {
                var that = this;
                var hoverMode = that._getArgumentHoverMode();
                if ((0, _type.isDefined)(argument)) {
                    that._releaseHoveredPoint();
                    that._hoveredArgument = argument;
                    that._argumentIndex = argumentIndex;
                    that._notifySeries({
                        action: "pointHover",
                        notifyLegend: that._notifyLegendOnHoverArgument,
                        target: {
                            argument: argument,
                            fullState: HOVER_STATE,
                            argumentIndex: argumentIndex,
                            getOptions: function() {
                                return {
                                    hoverMode: hoverMode
                                }
                            }
                        }
                    })
                }
            },
            _resetHoveredArgument: function() {
                var that = this;
                var hoverMode;
                if ((0, _type.isDefined)(that._hoveredArgument)) {
                    hoverMode = that._getArgumentHoverMode();
                    that._notifySeries({
                        action: "clearPointHover",
                        notifyLegend: that._notifyLegendOnHoverArgument,
                        target: {
                            fullState: NORMAL_STATE,
                            argumentIndex: that._argumentIndex,
                            argument: that._hoveredArgument,
                            getOptions: function() {
                                return {
                                    hoverMode: hoverMode
                                }
                            }
                        }
                    });
                    that._hoveredArgument = null
                }
            },
            _notifySeries: function(data) {
                this._storedSeries.forEach(function(series) {
                    series.notify(data)
                })
            },
            _pointerHandler: function(e) {
                var _series;
                var that = e.data.tracker;
                var rootOffset = that._renderer.getRootOffset();
                var x = _floor(e.pageX - rootOffset.left);
                var y = _floor(e.pageY - rootOffset.top);
                var canvas = that._getCanvas(x, y);
                var series = getData(e, SERIES_DATA);
                var point = getData(e, POINT_DATA) || (null === (_series = series) || void 0 === _series ? void 0 : _series.getPointByCoord(x, y));
                that._isHolding = false;
                clearTimeout(that._holdTimer);
                if (e.type === _pointer.default.down) {
                    that._holdTimer = setTimeout(function() {
                        return that._isHolding = true
                    }, HOLD_TIMEOUT)
                }
                if (point && !point.getMarkerVisibility()) {
                    point = void 0
                }
                that._enableOutHandler();
                if (that._legend.coordsIn(x, y)) {
                    that._hoverLegendItem(x, y);
                    return
                }
                if (that.hoveredSeries && that.hoveredSeries !== that._stuckSeries) {
                    that._releaseHoveredSeries()
                }
                if (that._hoverArgumentAxis(x, y, e)) {
                    return
                }
                if (that._isPointerOut(canvas, point)) {
                    that._pointerOut()
                }
                if (!canvas && !point) {
                    return
                }
                if (series && !point) {
                    point = series.getNeighborPoint(x, y);
                    if (!that._stickyHovering && point && !point.coordsIn(x, y)) {
                        point = null
                    }
                    if (series !== that.hoveredSeries) {
                        that._setTimeout(function() {
                            that._setHoveredSeries(series);
                            that._setStuckSeries(e, series, x, y);
                            that._pointerComplete(point, x, y)
                        }, series);
                        return
                    }
                } else {
                    if (point) {
                        if (e.type !== _pointer.default.move && "touch" !== e.pointerType) {
                            return
                        }
                        if (that.hoveredSeries) {
                            that._setTimeout(function() {
                                return that._pointerOnPoint(point, x, y, e)
                            }, point)
                        } else {
                            that._pointerOnPoint(point, x, y, e)
                        }
                        return
                    } else {
                        if (that._setStuckSeries(e, void 0, x, y) && that._stickyHovering) {
                            var _point;
                            series = that._stuckSeries;
                            point = series.getNeighborPoint(x, y);
                            that._releaseHoveredSeries();
                            (null === (_point = point) || void 0 === _point ? void 0 : _point.getMarkerVisibility()) && that._setHoveredPoint(point)
                        } else {
                            if (!that._stickyHovering) {
                                that._pointerOut()
                            }
                        }
                    }
                }
                that._pointerComplete(point, x, y)
            },
            _pointerOnPoint: function(point, x, y) {
                this._resetHoveredArgument();
                this._setHoveredPoint(point);
                this._pointerComplete(point, x, y)
            },
            _pointerComplete: function(point) {
                this.pointAtShownTooltip !== point && this._tooltip.isEnabled() && this._showTooltip(point)
            },
            _clickHandler: function(e) {
                var _point2;
                var that = e.data.tracker;
                if (that._isHolding) {
                    return
                }
                var rootOffset = that._renderer.getRootOffset();
                var x = _floor(e.pageX - rootOffset.left);
                var y = _floor(e.pageY - rootOffset.top);
                var point = getData(e, POINT_DATA);
                var series = that._stuckSeries || getData(e, SERIES_DATA) || (null === (_point2 = point) || void 0 === _point2 ? void 0 : _point2.series);
                var axis = that._argumentAxis;
                if (that._legend.coordsIn(x, y)) {
                    var item = that._legend.getItemByCoord(x, y);
                    if (item) {
                        that._legendClick(item, e)
                    }
                } else {
                    if (null !== axis && void 0 !== axis && axis.coordsIn(x, y)) {
                        var argument = getData(e, ARG_DATA, true);
                        if ((0, _type.isDefined)(argument)) {
                            that._eventTrigger("argumentAxisClick", {
                                argument: argument,
                                event: e
                            })
                        }
                    } else {
                        if (series) {
                            var _point3;
                            point = point || series.getPointByCoord(x, y);
                            if (null !== (_point3 = point) && void 0 !== _point3 && _point3.getMarkerVisibility()) {
                                that._pointClick(point, e)
                            } else {
                                getData(e, SERIES_DATA) && that._eventTrigger(SERIES_CLICK, {
                                    target: series,
                                    event: e
                                })
                            }
                        }
                    }
                }
            },
            dispose: function() {
                var that = this;
                that._disableOutHandler();
                that._renderer.root.off(DOT_EVENT_NS);
                that._seriesGroup.off(DOT_EVENT_NS)
            }
        };
        var ChartTracker = function(options) {
            this.ctor(options)
        };
        exports.ChartTracker = ChartTracker;
        (0, _extend.extend)(ChartTracker.prototype, baseTrackerPrototype, {
            _pointClick: function(point, event) {
                var that = this;
                var eventTrigger = that._eventTrigger;
                var series = point.series;
                eventTrigger(POINT_CLICK, {
                    target: point,
                    event: event
                }, function() {
                    !eventCanceled(event, series) && eventTrigger(SERIES_CLICK, {
                        target: series,
                        event: event
                    })
                })
            },
            update: function(options) {
                var that = this;
                baseTrackerPrototype.update.call(this, options);
                that._argumentAxis = options.argumentAxis || {};
                that._axisHoverEnabled = that._argumentAxis && (0, _utils.normalizeEnum)(that._argumentAxis.getOptions().hoverMode) === ALL_ARGUMENT_POINTS_MODE;
                that._rotated = options.rotated;
                that._crosshair = options.crosshair;
                that._stickyHovering = options.stickyHovering
            },
            _getCanvas: function(x, y) {
                var that = this;
                var canvases = that._canvases || [];
                for (var i = 0; i < canvases.length; i++) {
                    var c = canvases[i];
                    if ((0, _utils.pointInCanvas)(c, x, y)) {
                        return c
                    }
                }
                return null
            },
            _isPointerOut: function(canvas) {
                return !canvas && this._stuckSeries
            },
            _hideCrosshair: function() {
                var _this$_crosshair;
                null === (_this$_crosshair = this._crosshair) || void 0 === _this$_crosshair ? void 0 : _this$_crosshair.hide()
            },
            _moveCrosshair: function(point, x, y) {
                if (this._crosshair && null !== point && void 0 !== point && point.isVisible()) {
                    this._crosshair.show({
                        point: point,
                        x: x,
                        y: y
                    })
                }
            },
            _clean: function() {
                var that = this;
                baseTrackerPrototype._clean.call(that);
                that._resetTimer();
                that._stuckSeries = null
            },
            _getSeriesForShared: function(x, y) {
                var _point4;
                var that = this;
                var points = [];
                var point = null;
                var distance = 1 / 0;
                if (that._tooltip.isShared() && !that.hoveredSeries) {
                    (0, _iterator.each)(that._storedSeries, function(_, series) {
                        var point = series.getNeighborPoint(x, y);
                        point && points.push(point)
                    });
                    (0, _iterator.each)(points, function(_, p) {
                        var coords = p.getCrosshairData(x, y);
                        var d = (0, _utils.getDistance)(x, y, coords.x, coords.y);
                        if (d < distance) {
                            point = p;
                            distance = d
                        }
                    })
                }
                return null === (_point4 = point) || void 0 === _point4 ? void 0 : _point4.series
            },
            _setTimeout: function(callback, keeper) {
                var that = this;
                if (that._timeoutKeeper !== keeper) {
                    that._resetTimer();
                    that._hoverTimeout = setTimeout(function() {
                        callback();
                        that._timeoutKeeper = null
                    }, DELAY);
                    that._timeoutKeeper = keeper
                }
            },
            _resetTimer: function() {
                clearTimeout(this._hoverTimeout);
                this._timeoutKeeper = this._hoverTimeout = null
            },
            _stopEvent: function(e) {
                if (!(0, _type.isDefined)(e.cancelable) || e.cancelable) {
                    e.preventDefault();
                    e.stopPropagation()
                }
            },
            _setStuckSeries: function(e, series, x, y) {
                if ("mouse" !== e.pointerType) {
                    this._stuckSeries = null
                } else {
                    this._stuckSeries = series || this._stuckSeries || this._getSeriesForShared(x, y)
                }
                return !!this._stuckSeries
            },
            _pointerOut: function() {
                var that = this;
                that._stuckSeries = null;
                that._hideCrosshair();
                that._resetTimer();
                baseTrackerPrototype._pointerOut.apply(that, arguments)
            },
            _hoverArgumentAxis: function(x, y, e) {
                var that = this;
                that._resetHoveredArgument();
                if (that._axisHoverEnabled && that._argumentAxis.coordsIn(x, y)) {
                    that._hoverArgument(getData(e, ARG_DATA, true));
                    return true
                }
            },
            _pointerComplete: function(point, x, y) {
                var that = this;
                that.hoveredSeries && that.hoveredSeries.updateHover(x, y);
                that._resetTimer();
                that._moveCrosshair(point, x, y);
                baseTrackerPrototype._pointerComplete.call(that, point)
            },
            _legendClick: function(item, e) {
                var series = this._storedSeries[item.id];
                this._triggerLegendClick({
                    target: series,
                    event: e
                }, SERIES_CLICK)
            },
            _hoverLegendItem: function(x, y) {
                this._stuckSeries = null;
                this._hideCrosshair();
                baseTrackerPrototype._hoverLegendItem.call(this, x, y)
            },
            _pointerOnPoint: function(point, x, y, e) {
                this._setStuckSeries(e, point.series, x, y);
                this._releaseHoveredSeries();
                baseTrackerPrototype._pointerOnPoint.call(this, point, x, y, e)
            },
            _notifyLegendOnHoverArgument: false,
            _getArgumentHoverMode: function() {
                return correctHoverMode(this._argumentAxis)
            },
            dispose: function() {
                this._resetTimer();
                baseTrackerPrototype.dispose.call(this)
            }
        });
        var PieTracker = function(options) {
            this.ctor(options)
        };
        exports.PieTracker = PieTracker;
        (0, _extend.extend)(PieTracker.prototype, baseTrackerPrototype, {
            _isPointerOut: function(_, point) {
                return !point
            },
            _legendClick: function(item, e) {
                var that = this;
                var points = [];
                that._storedSeries.forEach(function(s) {
                    return points.push.apply(points, s.getPointsByKeys(item.argument, item.argumentIndex))
                });
                that._eventTrigger(LEGEND_CLICK, {
                    target: item.argument,
                    points: points,
                    event: e
                })
            },
            _pointClick: function(point, e) {
                this._eventTrigger(POINT_CLICK, {
                    target: point,
                    event: e
                })
            },
            _hoverLegendItem: function(x, y) {
                var that = this;
                var item = that._legend.getItemByCoord(x, y);
                if (item && that._hoveredArgument !== item.argument) {
                    that._resetHoveredArgument();
                    that._hoverArgument(item.argument, item.argumentIndex)
                } else {
                    if (!item) {
                        that.clearHover()
                    }
                }
            },
            _getArgumentHoverMode: function() {
                return correctHoverMode(this._legend)
            },
            _hoverArgumentAxis: _common.noop,
            _setStuckSeries: _common.noop,
            _getCanvas: _common.noop,
            _notifyLegendOnHoverArgument: true
        })
    },
    /*!**********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/chart_components/multi_axes_synchronizer.js ***!
      \**********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        __webpack_require__( /*! ../../core/utils/console */ 110);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _math2 = __webpack_require__( /*! ../../core/utils/math */ 29);
        var _math = Math;
        var _floor = _math.floor;
        var _max = _math.max;
        var _abs = _math.abs;

        function getValueAxesPerPanes(valueAxes) {
            var result = {};
            valueAxes.forEach(function(axis) {
                var pane = axis.pane;
                if (!result[pane]) {
                    result[pane] = []
                }
                result[pane].push(axis)
            });
            return result
        }
        var linearConverter = {
            transform: function(v, b) {
                return (0, _math2.adjust)((0, _utils.getLog)(v, b))
            },
            addInterval: function(v, i) {
                return (0, _math2.adjust)(v + i)
            },
            getInterval: function(base, tickInterval) {
                return tickInterval
            }
        };
        var logConverter = {
            transform: function(v, b) {
                return (0, _math2.adjust)((0, _utils.raiseTo)(v, b))
            },
            addInterval: function(v, i) {
                return (0, _math2.adjust)(v * i)
            },
            getInterval: function(base, tickInterval) {
                return _math.pow(base, tickInterval)
            }
        };

        function convertAxisInfo(axisInfo, converter) {
            if (!axisInfo.isLogarithmic) {
                return
            }
            var base = axisInfo.logarithmicBase;
            var tickValues = axisInfo.tickValues;
            var tick;
            var ticks = [];
            axisInfo.minValue = converter.transform(axisInfo.minValue, base);
            axisInfo.oldMinValue = converter.transform(axisInfo.oldMinValue, base);
            axisInfo.maxValue = converter.transform(axisInfo.maxValue, base);
            axisInfo.oldMaxValue = converter.transform(axisInfo.oldMaxValue, base);
            axisInfo.tickInterval = _math.round(axisInfo.tickInterval);
            if (axisInfo.tickInterval < 1) {
                axisInfo.tickInterval = 1
            }
            var interval = converter.getInterval(base, axisInfo.tickInterval);
            tick = converter.transform(tickValues[0], base);
            while (ticks.length < tickValues.length) {
                ticks.push(tick);
                tick = converter.addInterval(tick, interval)
            }
            ticks.tickInterval = axisInfo.tickInterval;
            axisInfo.tickValues = ticks
        }

        function populateAxesInfo(axes) {
            return axes.reduce(function(result, axis) {
                var ticksValues = axis.getTicksValues();
                var majorTicks = ticksValues.majorTicksValues;
                var options = axis.getOptions();
                var businessRange = axis.getTranslator().getBusinessRange();
                var visibleArea = axis.getVisibleArea();
                var axisInfo;
                var tickInterval = axis._tickInterval;
                var synchronizedValue = options.synchronizedValue;
                var action = axis.getViewport().action;
                if (majorTicks && majorTicks.length > 0 && (0, _type.isNumeric)(majorTicks[0]) && "discrete" !== options.type && !businessRange.isEmpty() && !(businessRange.breaks && businessRange.breaks.length) && "zoom" !== action && "pan" !== action) {
                    axis.applyMargins();
                    var startValue = axis.getTranslator().from(visibleArea[0]);
                    var endValue = axis.getTranslator().from(visibleArea[1]);
                    var minValue = startValue < endValue ? startValue : endValue;
                    var maxValue = startValue < endValue ? endValue : startValue;
                    if (minValue === maxValue && (0, _type.isDefined)(synchronizedValue)) {
                        tickInterval = _abs(majorTicks[0] - synchronizedValue) || 1;
                        minValue = majorTicks[0] - tickInterval;
                        maxValue = majorTicks[0] + tickInterval
                    }
                    axisInfo = {
                        axis: axis,
                        isLogarithmic: "logarithmic" === options.type,
                        logarithmicBase: businessRange.base,
                        tickValues: majorTicks,
                        minorValues: ticksValues.minorTicksValues,
                        minorTickInterval: axis._minorTickInterval,
                        minValue: minValue,
                        oldMinValue: minValue,
                        maxValue: maxValue,
                        oldMaxValue: maxValue,
                        inverted: businessRange.invert,
                        tickInterval: tickInterval,
                        synchronizedValue: synchronizedValue
                    };
                    convertAxisInfo(axisInfo, linearConverter);
                    result.push(axisInfo)
                }
                return result
            }, [])
        }

        function updateTickValues(axesInfo) {
            var maxTicksCount = axesInfo.reduce(function(max, axisInfo) {
                return _max(max, axisInfo.tickValues.length)
            }, 0);
            axesInfo.forEach(function(axisInfo) {
                var ticksMultiplier;
                var ticksCount;
                var additionalStartTicksCount = 0;
                var synchronizedValue = axisInfo.synchronizedValue;
                var tickValues = axisInfo.tickValues;
                var tickInterval = axisInfo.tickInterval;
                if ((0, _type.isDefined)(synchronizedValue)) {
                    axisInfo.baseTickValue = axisInfo.invertedBaseTickValue = synchronizedValue;
                    axisInfo.tickValues = [axisInfo.baseTickValue]
                } else {
                    if (tickValues.length > 1 && tickInterval) {
                        ticksMultiplier = _floor((maxTicksCount + 1) / tickValues.length);
                        ticksCount = ticksMultiplier > 1 ? _floor((maxTicksCount + 1) / ticksMultiplier) : maxTicksCount;
                        additionalStartTicksCount = _floor((ticksCount - tickValues.length) / 2);
                        while (additionalStartTicksCount > 0 && 0 !== tickValues[0]) {
                            tickValues.unshift((0, _math2.adjust)(tickValues[0] - tickInterval));
                            additionalStartTicksCount--
                        }
                        while (tickValues.length < ticksCount) {
                            tickValues.push((0, _math2.adjust)(tickValues[tickValues.length - 1] + tickInterval))
                        }
                        axisInfo.tickInterval = tickInterval / ticksMultiplier
                    }
                    axisInfo.baseTickValue = tickValues[0];
                    axisInfo.invertedBaseTickValue = tickValues[tickValues.length - 1]
                }
            })
        }

        function getAxisRange(axisInfo) {
            return axisInfo.maxValue - axisInfo.minValue || 1
        }

        function getMainAxisInfo(axesInfo) {
            for (var i = 0; i < axesInfo.length; i++) {
                if (!axesInfo[i].stubData) {
                    return axesInfo[i]
                }
            }
            return null
        }

        function correctMinMaxValues(axesInfo) {
            var mainAxisInfo = getMainAxisInfo(axesInfo);
            var mainAxisInfoTickInterval = mainAxisInfo.tickInterval;
            axesInfo.forEach(function(axisInfo) {
                var scale;
                var move;
                var mainAxisBaseValueOffset;
                var valueFromAxisInfo;
                if (axisInfo !== mainAxisInfo) {
                    if (mainAxisInfoTickInterval && axisInfo.tickInterval) {
                        if (axisInfo.stubData && (0, _type.isDefined)(axisInfo.synchronizedValue)) {
                            axisInfo.oldMinValue = axisInfo.minValue = axisInfo.baseTickValue - (mainAxisInfo.baseTickValue - mainAxisInfo.minValue) / mainAxisInfoTickInterval * axisInfo.tickInterval;
                            axisInfo.oldMaxValue = axisInfo.maxValue = axisInfo.baseTickValue - (mainAxisInfo.baseTickValue - mainAxisInfo.maxValue) / mainAxisInfoTickInterval * axisInfo.tickInterval
                        }
                        scale = mainAxisInfoTickInterval / getAxisRange(mainAxisInfo) / axisInfo.tickInterval * getAxisRange(axisInfo);
                        axisInfo.maxValue = axisInfo.minValue + getAxisRange(axisInfo) / scale
                    }
                    if (mainAxisInfo.inverted && !axisInfo.inverted || !mainAxisInfo.inverted && axisInfo.inverted) {
                        mainAxisBaseValueOffset = mainAxisInfo.maxValue - mainAxisInfo.invertedBaseTickValue
                    } else {
                        mainAxisBaseValueOffset = mainAxisInfo.baseTickValue - mainAxisInfo.minValue
                    }
                    valueFromAxisInfo = getAxisRange(axisInfo);
                    move = (mainAxisBaseValueOffset / getAxisRange(mainAxisInfo) - (axisInfo.baseTickValue - axisInfo.minValue) / valueFromAxisInfo) * valueFromAxisInfo;
                    axisInfo.minValue -= move;
                    axisInfo.maxValue -= move
                }
            })
        }

        function calculatePaddings(axesInfo) {
            var minPadding;
            var maxPadding;
            var startPadding = 0;
            var endPadding = 0;
            axesInfo.forEach(function(axisInfo) {
                var inverted = axisInfo.inverted;
                minPadding = axisInfo.minValue > axisInfo.oldMinValue ? (axisInfo.minValue - axisInfo.oldMinValue) / getAxisRange(axisInfo) : 0;
                maxPadding = axisInfo.maxValue < axisInfo.oldMaxValue ? (axisInfo.oldMaxValue - axisInfo.maxValue) / getAxisRange(axisInfo) : 0;
                startPadding = _max(startPadding, inverted ? maxPadding : minPadding);
                endPadding = _max(endPadding, inverted ? minPadding : maxPadding)
            });
            return {
                start: startPadding,
                end: endPadding
            }
        }

        function correctMinMaxValuesByPaddings(axesInfo, paddings) {
            axesInfo.forEach(function(info) {
                var range = getAxisRange(info);
                var inverted = info.inverted;
                info.minValue = (0, _math2.adjust)(info.minValue - paddings[inverted ? "end" : "start"] * range);
                info.maxValue = (0, _math2.adjust)(info.maxValue + paddings[inverted ? "start" : "end"] * range)
            })
        }

        function updateTickValuesIfSynchronizedValueUsed(axesInfo) {
            var hasSynchronizedValue = false;
            axesInfo.forEach(function(info) {
                hasSynchronizedValue = hasSynchronizedValue || (0, _type.isDefined)(info.synchronizedValue)
            });
            axesInfo.forEach(function(info) {
                var tickInterval = info.tickInterval;
                var tickValues = info.tickValues;
                var maxValue = info.maxValue;
                var minValue = info.minValue;
                var tick;
                if (hasSynchronizedValue && tickInterval) {
                    while ((tick = (0, _math2.adjust)(tickValues[0] - tickInterval)) >= minValue) {
                        tickValues.unshift(tick)
                    }
                    tick = tickValues[tickValues.length - 1];
                    while ((tick = (0, _math2.adjust)(tick + tickInterval)) <= maxValue) {
                        tickValues.push(tick)
                    }
                }
                while (tickValues[0] + tickInterval / 10 < minValue) {
                    tickValues.shift()
                }
                while (tickValues[tickValues.length - 1] - tickInterval / 10 > maxValue) {
                    tickValues.pop()
                }
            })
        }

        function applyMinMaxValues(axesInfo) {
            axesInfo.forEach(function(info) {
                var axis = info.axis;
                var range = axis.getTranslator().getBusinessRange();
                if (range.min === range.minVisible) {
                    range.min = info.minValue
                }
                if (range.max === range.maxVisible) {
                    range.max = info.maxValue
                }
                range.minVisible = info.minValue;
                range.maxVisible = info.maxValue;
                if (range.min > range.minVisible) {
                    range.min = range.minVisible
                }
                if (range.max < range.maxVisible) {
                    range.max = range.maxVisible
                }
                axis.getTranslator().updateBusinessRange(range);
                axis.setTicks({
                    majorTicks: info.tickValues,
                    minorTicks: info.minorValues
                })
            })
        }

        function correctAfterSynchronize(axesInfo) {
            var invalidAxisInfo = [];
            var correctValue;
            axesInfo.forEach(function(info) {
                if (info.oldMaxValue - info.oldMinValue === 0) {
                    invalidAxisInfo.push(info)
                } else {
                    if (!(0, _type.isDefined)(correctValue) && !(0, _type.isDefined)(info.synchronizedValue)) {
                        correctValue = _abs((info.maxValue - info.minValue) / (info.tickValues[_floor(info.tickValues.length / 2)] - info.minValue || info.maxValue))
                    }
                }
            });
            if (!(0, _type.isDefined)(correctValue)) {
                return
            }
            invalidAxisInfo.forEach(function(info) {
                var firstTick = info.tickValues[0];
                var correctedTick = firstTick * correctValue;
                if (firstTick > 0) {
                    info.maxValue = correctedTick;
                    info.minValue = 0
                } else {
                    if (firstTick < 0) {
                        info.minValue = correctedTick;
                        info.maxValue = 0
                    }
                }
            })
        }

        function updateMinorTicks(axesInfo) {
            axesInfo.forEach(function(axisInfo) {
                if (!axisInfo.minorTickInterval) {
                    return
                }
                var ticks = [];
                var interval = axisInfo.minorTickInterval;
                var tickCount = axisInfo.tickInterval / interval - 1;
                for (var i = 1; i < axisInfo.tickValues.length; i++) {
                    var tick = axisInfo.tickValues[i - 1];
                    for (var j = 0; j < tickCount; j++) {
                        tick += interval;
                        ticks.push(tick)
                    }
                }
                axisInfo.minorValues = ticks
            })
        }

        function correctPaddings(axesInfo, paddings) {
            return axesInfo.reduce(function(prev, info) {
                var inverted = info.inverted;
                var _info$axis$getCorrect = info.axis.getCorrectedValuesToZero(info.minValue, info.maxValue),
                    start = _info$axis$getCorrect.start,
                    end = _info$axis$getCorrect.end;
                if ((0, _type.isDefined)(start) || (0, _type.isDefined)(end)) {
                    return inverted ? {
                        start: prev.start,
                        end: Math.min(prev.end, end)
                    } : {
                        start: Math.min(prev.start, start),
                        end: prev.end
                    }
                }
                return prev
            }, paddings)
        }
        var multiAxesSynchronizer = {
            synchronize: function(valueAxes) {
                (0, _iterator.each)(getValueAxesPerPanes(valueAxes), function(_, axes) {
                    var axesInfo;
                    var paddings;
                    if (axes.length > 1) {
                        axesInfo = populateAxesInfo(axes);
                        if (axesInfo.length < 2 || !getMainAxisInfo(axesInfo)) {
                            return
                        }
                        updateTickValues(axesInfo);
                        correctMinMaxValues(axesInfo);
                        paddings = calculatePaddings(axesInfo);
                        paddings = correctPaddings(axesInfo, paddings);
                        correctMinMaxValuesByPaddings(axesInfo, paddings);
                        correctAfterSynchronize(axesInfo);
                        updateTickValuesIfSynchronizedValueUsed(axesInfo);
                        updateMinorTicks(axesInfo);
                        axesInfo.forEach(function(info) {
                            convertAxisInfo(info, logConverter)
                        });
                        applyMinMaxValues(axesInfo)
                    }
                })
            }
        };
        var _default = multiAxesSynchronizer;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/translators/category_translator.js ***!
      \*************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _math = __webpack_require__( /*! ../../core/utils/math */ 29);
        var round = Math.round;

        function getValue(value) {
            return value
        }
        var _default = {
            translate: function(category, directionOffset) {
                var that = this;
                var canvasOptions = that._canvasOptions;
                var categoryIndex = that._categoriesToPoints[category.valueOf()];
                var specialValue = that.translateSpecialCase(category);
                var startPointIndex = canvasOptions.startPointIndex || 0;
                var stickInterval = that._options.stick ? 0 : .5;
                if ((0, _type.isDefined)(specialValue)) {
                    return round(specialValue)
                }
                if (!categoryIndex && 0 !== categoryIndex) {
                    return null
                }
                directionOffset = directionOffset || 0;
                var stickDelta = categoryIndex + stickInterval - startPointIndex + .5 * directionOffset;
                return round(that._calculateProjection(canvasOptions.interval * stickDelta))
            },
            getInterval: function() {
                return this._canvasOptions.interval
            },
            getEventScale: function(zoomEvent) {
                var scale = zoomEvent.deltaScale || 1;
                return 1 - (1 - scale) / (.75 + this.visibleCategories.length / this._categories.length)
            },
            zoom: function(translate, scale) {
                var that = this;
                var categories = that._categories;
                var canvasOptions = that._canvasOptions;
                var stick = that._options.stick;
                var invert = canvasOptions.invert;
                var interval = canvasOptions.interval * scale;
                var translateCategories = translate / interval;
                var visibleCount = (that.visibleCategories || []).length;
                var startCategoryIndex = parseInt((canvasOptions.startPointIndex || 0) + translateCategories + .5);
                var categoriesLength = parseInt((0, _math.adjust)(canvasOptions.canvasLength / interval) + (stick ? 1 : 0)) || 1;
                var endCategoryIndex;
                if (invert) {
                    startCategoryIndex = parseInt((canvasOptions.startPointIndex || 0) + visibleCount - translateCategories + .5) - categoriesLength
                }
                if (startCategoryIndex < 0) {
                    startCategoryIndex = 0
                }
                endCategoryIndex = startCategoryIndex + categoriesLength;
                if (endCategoryIndex > categories.length) {
                    endCategoryIndex = categories.length;
                    startCategoryIndex = endCategoryIndex - categoriesLength;
                    if (startCategoryIndex < 0) {
                        startCategoryIndex = 0
                    }
                }
                var newVisibleCategories = categories.slice(parseInt(startCategoryIndex), parseInt(endCategoryIndex));
                var newInterval = that._getDiscreteInterval(newVisibleCategories.length, canvasOptions);
                scale = newInterval / canvasOptions.interval;
                translate = that.translate(!invert ? newVisibleCategories[0] : newVisibleCategories[newVisibleCategories.length - 1]) * scale - (canvasOptions.startPoint + (stick ? 0 : newInterval / 2));
                return {
                    min: newVisibleCategories[0],
                    max: newVisibleCategories[newVisibleCategories.length - 1],
                    translate: translate,
                    scale: scale
                }
            },
            getMinScale: function(zoom) {
                var that = this;
                var canvasOptions = that._canvasOptions;
                var categoriesLength = (that.visibleCategories || that._categories).length;
                categoriesLength += (parseInt(.1 * categoriesLength) || 1) * (zoom ? -2 : 2);
                return canvasOptions.canvasLength / (Math.max(categoriesLength, 1) * canvasOptions.interval)
            },
            getScale: function(min, max) {
                var that = this;
                var canvasOptions = that._canvasOptions;
                var visibleArea = that.getCanvasVisibleArea();
                var stickOffset = !that._options.stick && 1;
                var minPoint = (0, _type.isDefined)(min) ? that.translate(min, -stickOffset) : null;
                var maxPoint = (0, _type.isDefined)(max) ? that.translate(max, +stickOffset) : null;
                if (null === minPoint) {
                    minPoint = canvasOptions.invert ? visibleArea.max : visibleArea.min
                }
                if (null === maxPoint) {
                    maxPoint = canvasOptions.invert ? visibleArea.min : visibleArea.max
                }
                return that.canvasLength / Math.abs(maxPoint - minPoint)
            },
            isValid: function(value) {
                return (0, _type.isDefined)(value) ? this._categoriesToPoints[value.valueOf()] >= 0 : false
            },
            getCorrectValue: getValue,
            to: function(value, direction) {
                var canvasOptions = this._canvasOptions;
                var categoryIndex = this._categoriesToPoints[value.valueOf()];
                var startPointIndex = canvasOptions.startPointIndex || 0;
                var stickDelta = categoryIndex + (this._options.stick ? 0 : .5) - startPointIndex + (this._businessRange.invert ? -1 : 1) * direction * .5;
                return round(this._calculateProjection(canvasOptions.interval * stickDelta))
            },
            from: function(position) {
                var direction = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                var canvasOptions = this._canvasOptions;
                var startPoint = canvasOptions.startPoint;
                var categories = this.visibleCategories || this._categories;
                var categoriesLength = categories.length;
                var stickInterval = this._options.stick ? .5 : 0;
                var result = round((position - startPoint) / canvasOptions.interval + stickInterval - .5 - .5 * direction);
                if (result >= categoriesLength) {
                    result = categoriesLength - 1
                }
                if (result < 0) {
                    result = 0
                }
                if (canvasOptions.invert) {
                    result = categoriesLength - result - 1
                }
                return categories[result]
            },
            _add: function() {
                return NaN
            },
            _toValue: getValue,
            isValueProlonged: true,
            getRangeByMinZoomValue: function(minZoom, visualRange) {
                var categories = this._categories;
                var minVisibleIndex = categories.indexOf(visualRange.minVisible);
                var maxVisibleIndex = categories.indexOf(visualRange.maxVisible);
                var startIndex = minVisibleIndex + minZoom - 1;
                var endIndex = maxVisibleIndex - minZoom + 1;
                if (categories[startIndex]) {
                    return [visualRange.minVisible, categories[startIndex]]
                } else {
                    return [categories[endIndex], visualRange.maxVisible]
                }
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/translators/interval_translator.js ***!
      \*************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));
        var _math = __webpack_require__( /*! ../../core/utils/math */ 29);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var floor = Math.floor;
        var _default = {
            _intervalize: function(value, interval) {
                if (!(0, _type.isDefined)(value)) {
                    return
                }
                if ("datetime" === this._businessRange.dataType) {
                    if ((0, _type.isNumeric)(value)) {
                        value = new Date(value)
                    } else {
                        value = new Date(value.getTime())
                    }
                    value = _date.default.correctDateWithUnitBeginning(value, interval, null, this._options.firstDayOfWeek)
                } else {
                    value = (0, _math.adjust)(floor((0, _math.adjust)(value / interval)) * interval, interval)
                }
                return value
            },
            translate: function(bp, direction, interval) {
                var that = this;
                var specialValue = that.translateSpecialCase(bp);
                if ((0, _type.isDefined)(specialValue)) {
                    return Math.round(specialValue)
                }
                interval = interval || that._options.interval;
                if (!that.isValid(bp, interval)) {
                    return null
                }
                return that.to(bp, direction, interval)
            },
            getInterval: function() {
                return Math.round(this._canvasOptions.ratioOfCanvasRange * (this._businessRange.interval || Math.abs(this._canvasOptions.rangeMax - this._canvasOptions.rangeMin)))
            },
            zoom: function() {},
            getMinScale: function() {},
            getScale: function() {},
            _parse: function(value) {
                return "datetime" === this._businessRange.dataType ? new Date(value) : Number(value)
            },
            _fromValue: function(value) {
                return this._parse(value)
            },
            _toValue: function(value) {
                return this._parse(value)
            },
            isValid: function(value, interval) {
                var that = this;
                var co = that._canvasOptions;
                var rangeMin = co.rangeMin;
                var rangeMax = co.rangeMax;
                interval = interval || that._options.interval;
                if (null === value || isNaN(value)) {
                    return false
                }
                value = "datetime" === that._businessRange.dataType && (0, _type.isNumeric)(value) ? new Date(value) : value;
                if (interval !== that._options.interval) {
                    rangeMin = that._intervalize(rangeMin, interval);
                    rangeMax = that._intervalize(rangeMax, interval)
                }
                if (value.valueOf() < rangeMin || value.valueOf() >= _date.default.addInterval(rangeMax, interval)) {
                    return false
                }
                return true
            },
            to: function(bp, direction, interval) {
                var that = this;
                interval = interval || that._options.interval;
                var v1 = that._intervalize(bp, interval);
                var v2 = _date.default.addInterval(v1, interval);
                var res = that._to(v1);
                var p2 = that._to(v2);
                if (!direction) {
                    res = floor((res + p2) / 2)
                } else {
                    if (direction > 0) {
                        res = p2
                    }
                }
                return res
            },
            _to: function(value) {
                var co = this._canvasOptions;
                var rMin = co.rangeMinVisible;
                var rMax = co.rangeMaxVisible;
                var offset = value - rMin;
                if (value < rMin) {
                    offset = 0
                } else {
                    if (value > rMax) {
                        offset = _date.default.addInterval(rMax, this._options.interval) - rMin
                    }
                }
                return this._conversionValue(this._calculateProjection(offset * this._canvasOptions.ratioOfCanvasRange))
            },
            from: function(position, direction) {
                var that = this;
                var origInterval = that._options.interval;
                var interval = origInterval;
                var co = that._canvasOptions;
                var rMin = co.rangeMinVisible;
                var rMax = co.rangeMaxVisible;
                var value;
                if ("datetime" === that._businessRange.dataType) {
                    interval = _date.default.dateToMilliseconds(origInterval)
                }
                value = that._calculateUnProjection((position - that._canvasOptions.startPoint) / that._canvasOptions.ratioOfCanvasRange);
                value = that._intervalize(_date.default.addInterval(value, interval / 2, direction > 0), origInterval);
                if (value < rMin) {
                    value = rMin
                } else {
                    if (value > rMax) {
                        value = rMax
                    }
                }
                return value
            },
            _add: function() {
                return NaN
            },
            isValueProlonged: true
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/translators/datetime_translator.js ***!
      \*************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function parse(value) {
            return null !== value ? new Date(value) : value
        }
        var _default = {
            _fromValue: parse,
            _toValue: parse,
            _add: _date.default.addDateInterval,
            convert: _date.default.dateToMilliseconds
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/translators/logarithmic_translator.js ***!
      \****************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _default = {
            _fromValue: function(value) {
                return null !== value ? (0, _utils.getLogExt)(value, this._canvasOptions.base, this._businessRange.allowNegatives, this._businessRange.linearThreshold) : value
            },
            _toValue: function(value) {
                return null !== value ? (0, _utils.raiseToExt)(value, this._canvasOptions.base, this._businessRange.allowNegatives, this._businessRange.linearThreshold) : value
            },
            getMinBarSize: function(minBarSize) {
                var visibleArea = this.getCanvasVisibleArea();
                var minValue = this.from(visibleArea.min + minBarSize);
                var canvasOptions = this._canvasOptions;
                return Math.pow(canvasOptions.base, canvasOptions.rangeMinVisible + this._fromValue(this.from(visibleArea.min)) - this._fromValue(!(0, _type.isDefined)(minValue) ? this.from(visibleArea.max) : minValue))
            },
            checkMinBarSize: function(initialValue, minShownValue, stackValue) {
                var canvasOptions = this._canvasOptions;
                var prevValue = stackValue - initialValue;
                var baseMethod = this.constructor.prototype.checkMinBarSize;
                var minBarSize;
                var updateValue;
                if ((0, _type.isDefined)(minShownValue) && prevValue > 0) {
                    minBarSize = baseMethod(this._fromValue(stackValue / prevValue), this._fromValue(minShownValue) - canvasOptions.rangeMinVisible);
                    updateValue = Math.pow(canvasOptions.base, this._fromValue(prevValue) + minBarSize) - prevValue
                } else {
                    updateValue = baseMethod(initialValue, minShownValue)
                }
                return updateValue
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/axes/datetime_breaks.js ***!
      \**************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.generateDateBreaks = generateDateBreaks;
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var days = [0, 1, 2, 3, 4, 5, 6];

        function getWeekendDays(workdays) {
            return days.filter(function(day) {
                return !workdays.some(function(workDay) {
                    return workDay === day
                })
            })
        }

        function getNextDayIndex(dayIndex) {
            return (dayIndex + 1) % 7
        }

        function dayBetweenWeekend(weekend, day) {
            var start = weekend.start;
            var end = weekend.end;
            while (start !== end) {
                if (start === day) {
                    return true
                }
                start = getNextDayIndex(start)
            }
            return false
        }

        function getDaysDistance(day, end) {
            var length = 0;
            while (day !== end) {
                day = getNextDayIndex(day);
                length++
            }
            return length
        }

        function separateBreak(scaleBreak, day) {
            var result = [];
            var dayEnd = new Date(day);
            dayEnd.setDate(day.getDate() + 1);
            if (day > scaleBreak.from) {
                result.push({
                    from: scaleBreak.from,
                    to: day
                })
            }
            if (dayEnd < scaleBreak.to) {
                result.push({
                    from: dayEnd,
                    to: scaleBreak.to
                })
            }
            return result
        }

        function getWeekEndDayIndices(workDays) {
            var indices = getWeekendDays(workDays);
            if (indices.length < 7) {
                while (getNextDayIndex(indices[indices.length - 1]) === indices[0]) {
                    indices.unshift(indices.pop())
                }
            }
            return indices
        }

        function generateDateBreaksForWeekend(min, max, weekendDayIndices) {
            var day = min.getDate();
            var breaks = [];
            var weekends = weekendDayIndices.reduce(function(obj, day) {
                var currentWeekEnd = obj[1];
                if (void 0 === currentWeekEnd.start) {
                    currentWeekEnd = {
                        start: day,
                        end: getNextDayIndex(day)
                    };
                    obj[0].push(currentWeekEnd);
                    return [obj[0], currentWeekEnd]
                } else {
                    if (currentWeekEnd.end === day) {
                        currentWeekEnd.end = getNextDayIndex(day);
                        return obj
                    }
                }
                currentWeekEnd = {
                    start: day,
                    end: getNextDayIndex(day)
                };
                obj[0].push(currentWeekEnd);
                return [obj[0], currentWeekEnd]
            }, [
                [], {}
            ]);
            weekends[0].forEach(function(weekend) {
                var currentDate = new Date(min);
                currentDate = _date.default.trimTime(currentDate);
                while (currentDate < max) {
                    day = currentDate.getDay();
                    var date = currentDate.getDate();
                    if (dayBetweenWeekend(weekend, day)) {
                        var from = new Date(currentDate);
                        currentDate.setDate(date + getDaysDistance(day, weekend.end));
                        var to = new Date(currentDate);
                        breaks.push({
                            from: from,
                            to: to
                        })
                    }
                    currentDate.setDate(currentDate.getDate() + 1)
                }
            });
            return breaks
        }

        function excludeWorkDaysFromWeekEndBreaks(breaks, exactWorkDays) {
            var result = breaks.slice();
            var i;
            var processWorkDay = function(workday) {
                workday = _date.default.trimTime(new Date(workday));
                if (result[i].from <= workday && result[i].to > workday) {
                    var separatedBreak = separateBreak(result[i], workday);
                    if (2 === separatedBreak.length) {
                        result.splice(i, 1, separatedBreak[0], separatedBreak[1])
                    } else {
                        if (1 === separatedBreak.length) {
                            result.splice(i, 1, separatedBreak[0])
                        } else {
                            result.splice(i, 1)
                        }
                    }
                }
            };
            for (i = 0; i < result.length; i++) {
                exactWorkDays.forEach(processWorkDay)
            }
            return result
        }

        function generateBreaksForHolidays(min, max, holidays, weekendDayIndices) {
            var day;
            var dayInWeekend = function(dayIndex) {
                return dayIndex === day
            };
            var adjustedMin = _date.default.trimTime(min);
            var adjustedMax = _date.default.trimTime(max);
            adjustedMax.setDate(max.getDate() + 1);
            return holidays.reduce(function(breaks, holiday) {
                var holidayStart;
                var holidayEnd;
                holiday = new Date(holiday);
                day = holiday.getDay();
                if (!weekendDayIndices.some(dayInWeekend) && holiday >= adjustedMin && holiday <= adjustedMax) {
                    holidayStart = _date.default.trimTime(holiday);
                    holidayEnd = new Date(holidayStart);
                    holidayEnd.setDate(holidayStart.getDate() + 1);
                    breaks.push({
                        from: holidayStart,
                        to: holidayEnd
                    })
                }
                return breaks
            }, [])
        }

        function calculateGaps(breaks) {
            return breaks.map(function(b) {
                return {
                    from: b.from,
                    to: b.to,
                    gapSize: _date.default.convertMillisecondsToDateUnits(b.to - b.from)
                }
            })
        }

        function generateDateBreaks(min, max, workWeek, singleWorkdays, holidays) {
            var weekendDayIndices = getWeekEndDayIndices(workWeek);
            var breaks = generateDateBreaksForWeekend(min, max, weekendDayIndices);
            breaks.push.apply(breaks, generateBreaksForHolidays(min, max, holidays || [], weekendDayIndices));
            return calculateGaps(excludeWorkDaysFromWeekEndBreaks(breaks, singleWorkdays || []))
        }
    },
    /*!*********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/axes/polar_axes.js ***!
      \*********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.linearSpider = exports.linear = exports.circularSpider = exports.circular = void 0;
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _axes_constants = _interopRequireDefault(__webpack_require__( /*! ./axes_constants */ 317));
        var _xy_axes = _interopRequireDefault(__webpack_require__( /*! ./xy_axes */ 471));
        var _tick = __webpack_require__( /*! ./tick */ 470);
        var _axes_utils = __webpack_require__( /*! ./axes_utils */ 472);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var PI = Math.PI,
            abs = Math.abs,
            atan = Math.atan,
            round = Math.round;
        var _min = Math.min;
        var _max = Math.max;
        var xyAxesLinear = _xy_axes.default.linear;
        var HALF_PI_ANGLE = 90;

        function getPolarQuarter(angle) {
            var quarter;
            angle = (0, _utils.normalizeAngle)(angle);
            if (angle >= 315 && angle <= 360 || angle < 45 && angle >= 0) {
                quarter = 1
            } else {
                if (angle >= 45 && angle < 135) {
                    quarter = 2
                } else {
                    if (angle >= 135 && angle < 225) {
                        quarter = 3
                    } else {
                        if (angle >= 225 && angle < 315) {
                            quarter = 4
                        }
                    }
                }
            }
            return quarter
        }
        var circularAxes = {
            _calculateValueMargins: function(ticks) {
                var _this$_getViewportRan = this._getViewportRange(),
                    minVisible = _this$_getViewportRan.minVisible,
                    maxVisible = _this$_getViewportRan.maxVisible;
                if (ticks && ticks.length > 1) {
                    minVisible = minVisible < ticks[0].value ? minVisible : ticks[0].value;
                    maxVisible = minVisible > ticks[ticks.length - 1].value ? maxVisible : ticks[ticks.length - 1].value
                }
                return {
                    minValue: minVisible,
                    maxValue: maxVisible
                }
            },
            applyMargins: function() {
                var margins = this._calculateValueMargins(this._majorTicks);
                var br = this._translator.getBusinessRange();
                br.addRange({
                    minVisible: margins.minValue,
                    maxVisible: margins.maxValue,
                    interval: this._calculateRangeInterval(br.interval)
                });
                this._translator.updateBusinessRange(br)
            },
            _getTranslatorOptions: function() {
                return {
                    isHorizontal: true,
                    conversionValue: true,
                    addSpiderCategory: this._getSpiderCategoryOption(),
                    stick: this._getStick()
                }
            },
            getCenter: function() {
                return this._center
            },
            getRadius: function() {
                return this._radius
            },
            getAngles: function() {
                var options = this._options;
                return [options.startAngle, options.endAngle]
            },
            _updateRadius: function(canvas) {
                var rad = _min(canvas.width - canvas.left - canvas.right, canvas.height - canvas.top - canvas.bottom) / 2;
                this._radius = rad < 0 ? 0 : rad
            },
            _updateCenter: function(canvas) {
                this._center = {
                    x: canvas.left + (canvas.width - canvas.right - canvas.left) / 2,
                    y: canvas.top + (canvas.height - canvas.top - canvas.bottom) / 2
                }
            },
            _processCanvas: function(canvas) {
                this._updateRadius(canvas);
                this._updateCenter(canvas);
                return {
                    left: 0,
                    right: 0,
                    width: this._getScreenDelta()
                }
            },
            _createAxisElement: function() {
                return this._renderer.circle()
            },
            _updateAxisElementPosition: function() {
                var center = this.getCenter();
                this._axisElement.attr({
                    cx: center.x,
                    cy: center.y,
                    r: this.getRadius()
                })
            },
            _boundaryTicksVisibility: {
                min: true
            },
            _getSpiderCategoryOption: function() {
                return this._options.firstPointOnStartAngle
            },
            _validateOptions: function(options) {
                var that = this;
                var originValue = options.originValue;
                var wholeRange = options.wholeRange = {};
                var period = options.period;
                if ((0, _type.isDefined)(originValue)) {
                    originValue = that.validateUnit(originValue)
                }
                if (period > 0 && options.argumentType === _axes_constants.default.numeric) {
                    originValue = originValue || 0;
                    wholeRange.endValue = originValue + period;
                    that._viewport = (0, _utils.getVizRangeObject)([originValue, wholeRange.endValue])
                }
                if ((0, _type.isDefined)(originValue)) {
                    wholeRange.startValue = originValue
                }
            },
            getMargins: function() {
                var tickOptions = this._options.tick;
                var tickOuterLength = _max(tickOptions.visible ? tickOptions.length / 2 + tickOptions.shift : 0, 0);
                var radius = this.getRadius();
                var _this$_center = this._center,
                    x = _this$_center.x,
                    y = _this$_center.y;
                var labelBoxes = this._majorTicks.map(function(t) {
                    return t.label && t.label.getBBox()
                }).filter(function(b) {
                    return b
                });
                var canvas = (0, _extend.extend)({}, this._canvas, {
                    left: x - radius,
                    top: y - radius,
                    right: this._canvas.width - (x + radius),
                    bottom: this._canvas.height - (y + radius)
                });
                var margins = (0, _axes_utils.calculateCanvasMargins)(labelBoxes, canvas);
                Object.keys(margins).forEach(function(k) {
                    return margins[k] = margins[k] < tickOuterLength ? tickOuterLength : margins[k]
                });
                return margins
            },
            _updateLabelsPosition: function() {
                var that = this;
                (0, _axes_utils.measureLabels)(that._majorTicks);
                that._adjustLabelsCoord(0, 0, true);
                that._checkBoundedLabelsOverlapping(this._majorTicks, this._majorTicks.map(function(t) {
                    return t.labelBBox
                }))
            },
            _setVisualRange: _common.noop,
            applyVisualRangeSetter: _common.noop,
            _getStick: function() {
                return this._options.firstPointOnStartAngle || this._options.type !== _axes_constants.default.discrete
            },
            _getTranslatedCoord: function(value, offset) {
                return this._translator.translate(value, offset) - HALF_PI_ANGLE
            },
            _getCanvasStartEnd: function() {
                return {
                    start: 0 - HALF_PI_ANGLE,
                    end: 360 - HALF_PI_ANGLE
                }
            },
            _getStripGraphicAttributes: function(fromAngle, toAngle) {
                var center = this.getCenter();
                var angle = this.getAngles()[0];
                var r = this.getRadius();
                return {
                    x: center.x,
                    y: center.y,
                    innerRadius: 0,
                    outerRadius: r,
                    startAngle: -toAngle - angle,
                    endAngle: -fromAngle - angle
                }
            },
            _createStrip: function(coords) {
                return this._renderer.arc(coords.x, coords.y, coords.innerRadius, coords.outerRadius, coords.startAngle, coords.endAngle)
            },
            _getStripLabelCoords: function(from, to) {
                var that = this;
                var coords = that._getStripGraphicAttributes(from, to);
                var angle = coords.startAngle + (coords.endAngle - coords.startAngle) / 2;
                var cosSin = (0, _utils.getCosAndSin)(angle);
                var halfRad = that.getRadius() / 2;
                var center = that.getCenter();
                var x = round(center.x + halfRad * cosSin.cos);
                var y = round(center.y - halfRad * cosSin.sin);
                return {
                    x: x,
                    y: y,
                    align: _axes_constants.default.center
                }
            },
            _getConstantLineGraphicAttributes: function(value) {
                var center = this.getCenter();
                var r = this.getRadius();
                return {
                    points: [center.x, center.y, center.x + r, center.y]
                }
            },
            _createConstantLine: function(value, attr) {
                return this._createPathElement(this._getConstantLineGraphicAttributes(value).points, attr)
            },
            _rotateConstantLine: function(line, value) {
                var _this$getCenter = this.getCenter(),
                    x = _this$getCenter.x,
                    y = _this$getCenter.y;
                line.rotate(value + this.getAngles()[0], x, y)
            },
            _getConstantLineLabelsCoords: function(value) {
                var that = this;
                var cosSin = (0, _utils.getCosAndSin)(-value - that.getAngles()[0]);
                var halfRad = that.getRadius() / 2;
                var center = that.getCenter();
                var x = round(center.x + halfRad * cosSin.cos);
                var y = round(center.y - halfRad * cosSin.sin);
                return {
                    x: x,
                    y: y
                }
            },
            _checkAlignmentConstantLineLabels: _common.noop,
            _adjustDivisionFactor: function(val) {
                return 180 * val / (this.getRadius() * PI)
            },
            _getScreenDelta: function() {
                var angles = this.getAngles();
                return abs(angles[0] - angles[1])
            },
            _getTickMarkPoints: function(coords, length, _ref) {
                var _ref$shift = _ref.shift,
                    shift = void 0 === _ref$shift ? 0 : _ref$shift;
                var center = this.getCenter();
                var corrections = {
                    inside: -1,
                    center: -.5,
                    outside: 0
                };
                var radiusWithTicks = this.getRadius() + length * corrections[this._options.tickOrientation || "center"];
                return [center.x + radiusWithTicks + shift, center.y, center.x + radiusWithTicks + length + shift, center.y]
            },
            _getLabelAdjustedCoord: function(tick, _offset, _maxWidth, checkCanvas) {
                var that = this;
                var labelCoords = tick.labelCoords;
                var labelY = labelCoords.y;
                var labelAngle = labelCoords.angle;
                var cosSin = (0, _utils.getCosAndSin)(labelAngle);
                var cos = cosSin.cos;
                var sin = cosSin.sin;
                var box = tick.labelBBox;
                var halfWidth = box.width / 2;
                var halfHeight = box.height / 2;
                var indentFromAxis = that._options.label.indentFromAxis || 0;
                var x = labelCoords.x + indentFromAxis * cos;
                var y = labelY + (labelY - box.y - halfHeight) + indentFromAxis * sin;
                var shiftX = 0;
                var shiftY = 0;
                switch (getPolarQuarter(labelAngle)) {
                    case 1:
                        shiftX = halfWidth;
                        shiftY = halfHeight * sin;
                        break;
                    case 2:
                        shiftX = halfWidth * cos;
                        shiftY = halfHeight;
                        break;
                    case 3:
                        shiftX = -halfWidth;
                        shiftY = halfHeight * sin;
                        break;
                    case 4:
                        shiftX = halfWidth * cos;
                        shiftY = -halfHeight
                }
                if (checkCanvas) {
                    var canvas = that._canvas;
                    var boxShiftX = x - labelCoords.x + shiftX;
                    var boxShiftY = y - labelCoords.y + shiftY;
                    if (box.x + boxShiftX < canvas.originalLeft) {
                        shiftX -= box.x + boxShiftX - canvas.originalLeft
                    }
                    if (box.x + box.width + boxShiftX > canvas.width - canvas.originalRight) {
                        shiftX -= box.x + box.width + boxShiftX - (canvas.width - canvas.originalRight)
                    }
                    if (box.y + boxShiftY < canvas.originalTop) {
                        shiftY -= box.y + boxShiftY - canvas.originalTop
                    }
                    if (box.y + box.height + boxShiftY > canvas.height - canvas.originalBottom) {
                        shiftY -= box.y + box.height + boxShiftY - (canvas.height - canvas.originalBottom)
                    }
                }
                return {
                    x: x + shiftX,
                    y: y + shiftY
                }
            },
            _getGridLineDrawer: function() {
                var that = this;
                return function(tick, gridStyle) {
                    var center = that.getCenter();
                    return that._createPathElement(that._getGridPoints().points, gridStyle).rotate(tick.coords.angle, center.x, center.y)
                }
            },
            _getGridPoints: function() {
                var r = this.getRadius();
                var center = this.getCenter();
                return {
                    points: [center.x, center.y, center.x + r, center.y]
                }
            },
            _getTranslatedValue: function(value, offset) {
                var startAngle = this.getAngles()[0];
                var angle = this._translator.translate(value, -offset);
                var coords = (0, _utils.convertPolarToXY)(this.getCenter(), startAngle, angle, this.getRadius());
                return {
                    x: coords.x,
                    y: coords.y,
                    angle: this.getTranslatedAngle(angle)
                }
            },
            _getAdjustedStripLabelCoords: function(strip) {
                var box = strip.labelBBox;
                return {
                    translateY: strip.label.attr("y") - box.y - box.height / 2
                }
            },
            coordsIn: function(x, y) {
                return (0, _utils.convertXYToPolar)(this.getCenter(), x, y).r > this.getRadius()
            },
            _rotateTick: function(element, coords) {
                var center = this.getCenter();
                element.rotate(coords.angle, center.x, center.y)
            },
            _validateOverlappingMode: function(mode) {
                return _axes_constants.default.validateOverlappingMode(mode)
            },
            _validateDisplayMode: function() {
                return "standard"
            },
            _getStep: function(boxes) {
                var that = this;
                var radius = that.getRadius() + (that._options.label.indentFromAxis || 0);
                var maxLabelBox = boxes.reduce(function(prevValue, box) {
                    var curValue = prevValue;
                    if (prevValue.width < box.width) {
                        curValue.width = box.width
                    }
                    if (prevValue.height < box.height) {
                        curValue.height = box.height
                    }
                    return curValue
                }, {
                    width: 0,
                    height: 0
                });
                var angle1 = abs(2 * atan(maxLabelBox.height / (2 * radius - maxLabelBox.width)) * 180 / PI);
                var angle2 = abs(2 * atan(maxLabelBox.width / (2 * radius - maxLabelBox.height)) * 180 / PI);
                return _axes_constants.default.getTicksCountInRange(that._majorTicks, "angle", _max(angle1, angle2))
            },
            _checkBoundedLabelsOverlapping: function(majorTicks, boxes, mode) {
                var labelOpt = this._options.label;
                mode = mode || this._validateOverlappingMode(labelOpt.overlappingBehavior);
                if ("hide" !== mode) {
                    return
                }
                var lastVisibleLabelIndex = majorTicks.reduce(function(lastVisibleLabelIndex, tick, index) {
                    return tick.label ? index : lastVisibleLabelIndex
                }, null);
                if (!lastVisibleLabelIndex) {
                    return
                }
                if (_axes_constants.default.areLabelsOverlap(boxes[0], boxes[lastVisibleLabelIndex], labelOpt.minSpacing, _axes_constants.default.center)) {
                    "first" === labelOpt.hideFirstOrLast ? majorTicks[0].label.remove() : majorTicks[lastVisibleLabelIndex].label.remove()
                }
            },
            shift: function(margins) {
                this._axisGroup.attr({
                    translateX: margins.right,
                    translateY: margins.bottom
                })
            },
            getTranslatedAngle: function(angle) {
                var startAngle = this.getAngles()[0];
                return angle + startAngle - HALF_PI_ANGLE
            }
        };
        var circular = circularAxes;
        exports.circular = circular;
        var circularSpider = (0, _extend.extend)({}, circularAxes, {
            _createAxisElement: function() {
                return this._renderer.path([], "area")
            },
            _updateAxisElementPosition: function() {
                this._axisElement.attr({
                    points: (0, _utils.map)(this.getSpiderTicks(), function(tick) {
                        return {
                            x: tick.coords.x,
                            y: tick.coords.y
                        }
                    })
                })
            },
            _getStick: function() {
                return true
            },
            _getSpiderCategoryOption: function() {
                return true
            },
            getSpiderTicks: function() {
                var that = this;
                var ticks = that.getFullTicks();
                that._spiderTicks = ticks.map((0, _tick.tick)(that, that.renderer, {}, {}, that._getSkippedCategory(ticks), true));
                that._spiderTicks.forEach(function(tick) {
                    tick.initCoords()
                });
                return that._spiderTicks
            },
            _getStripGraphicAttributes: function(fromAngle, toAngle) {
                var center = this.getCenter();
                var spiderTicks = this.getSpiderTicks();
                var firstTick;
                var lastTick;
                var nextTick;
                var tick;
                var points = [];
                var i = 0;
                var len = spiderTicks.length;
                while (i < len) {
                    tick = spiderTicks[i].coords;
                    if (tick.angle >= fromAngle && tick.angle <= toAngle) {
                        if (!firstTick) {
                            firstTick = (spiderTicks[i - 1] || spiderTicks[spiderTicks.length - 1]).coords;
                            points.push((tick.x + firstTick.x) / 2, (tick.y + firstTick.y) / 2)
                        }
                        points.push(tick.x, tick.y);
                        nextTick = (spiderTicks[i + 1] || spiderTicks[0]).coords;
                        lastTick = {
                            x: (tick.x + nextTick.x) / 2,
                            y: (tick.y + nextTick.y) / 2
                        }
                    }
                    i++
                }
                points.push(lastTick.x, lastTick.y);
                points.push(center.x, center.y);
                return {
                    points: points
                }
            },
            _createStrip: function(_ref2) {
                var points = _ref2.points;
                return this._renderer.path(points, "area")
            },
            _getTranslatedCoord: function(value, offset) {
                return this._translator.translate(value, offset) - HALF_PI_ANGLE
            },
            _setTickOffset: function() {
                this._tickOffset = false
            }
        });
        exports.circularSpider = circularSpider;
        var linear = {
            _resetMargins: function() {
                this._reinitTranslator(this._getViewportRange())
            },
            _getStick: xyAxesLinear._getStick,
            _getSpiderCategoryOption: _common.noop,
            _getTranslatorOptions: function() {
                return {
                    isHorizontal: true,
                    stick: this._getStick()
                }
            },
            getRadius: circularAxes.getRadius,
            getCenter: circularAxes.getCenter,
            getAngles: circularAxes.getAngles,
            _updateRadius: circularAxes._updateRadius,
            _updateCenter: circularAxes._updateCenter,
            _processCanvas: function(canvas) {
                this._updateRadius(canvas);
                this._updateCenter(canvas);
                return {
                    left: 0,
                    right: 0,
                    startPadding: canvas.startPadding,
                    endPadding: canvas.endPadding,
                    width: this.getRadius()
                }
            },
            _createAxisElement: xyAxesLinear._createAxisElement,
            _updateAxisElementPosition: function() {
                var centerCoord = this.getCenter();
                this._axisElement.attr({
                    points: [centerCoord.x, centerCoord.y, centerCoord.x + this.getRadius(), centerCoord.y]
                }).rotate(this.getAngles()[0] - HALF_PI_ANGLE, centerCoord.x, centerCoord.y)
            },
            _getScreenDelta: function() {
                return this.getRadius()
            },
            _getTickMarkPoints: function(coords, length) {
                return [coords.x - length / 2, coords.y, coords.x + length / 2, coords.y]
            },
            _getLabelAdjustedCoord: function(tick) {
                var that = this;
                var labelCoords = tick.labelCoords;
                var labelY = labelCoords.y;
                var cosSin = (0, _utils.getCosAndSin)(labelCoords.angle);
                var indentFromAxis = that._options.label.indentFromAxis || 0;
                var box = tick.labelBBox;
                var x = labelCoords.x - abs(indentFromAxis * cosSin.sin) + abs(box.width / 2 * cosSin.cos) - box.width / 2;
                var y = labelY + (labelY - box.y) - abs(box.height / 2 * cosSin.sin) + abs(indentFromAxis * cosSin.cos);
                return {
                    x: x,
                    y: y
                }
            },
            _getGridLineDrawer: function() {
                var that = this;
                return function(tick, gridStyle) {
                    var grid = that._getGridPoints(tick.coords);
                    return that._renderer.circle(grid.cx, grid.cy, grid.r).attr(gridStyle).sharp()
                }
            },
            _getGridPoints: function(coords) {
                var pos = this.getCenter();
                var radius = (0, _utils.getDistance)(pos.x, pos.y, coords.x, coords.y);
                if (radius > this.getRadius()) {
                    return {
                        cx: null,
                        cy: null,
                        r: null
                    }
                }
                return {
                    cx: pos.x,
                    cy: pos.y,
                    r: radius
                }
            },
            _getTranslatedValue: function(value, offset) {
                var startAngle = this.getAngles()[0];
                var xy = (0, _utils.convertPolarToXY)(this.getCenter(), startAngle, 0, this._translator.translate(value, offset));
                return {
                    x: xy.x,
                    y: xy.y,
                    angle: startAngle - HALF_PI_ANGLE
                }
            },
            _getTranslatedCoord: function(value, offset) {
                return this._translator.translate(value, offset)
            },
            _getCanvasStartEnd: function() {
                var invert = this.getTranslator().getBusinessRange().invert;
                var coords = [0, this.getRadius()];
                invert && coords.reverse();
                return {
                    start: coords[0],
                    end: coords[1]
                }
            },
            _getStripGraphicAttributes: function(fromPoint, toPoint) {
                var center = this.getCenter();
                return {
                    x: center.x,
                    y: center.y,
                    innerRadius: fromPoint,
                    outerRadius: toPoint
                }
            },
            _createStrip: function(attrs) {
                return this._renderer.arc(attrs.x, attrs.y, attrs.innerRadius, attrs.outerRadius, 0, 360)
            },
            _getAdjustedStripLabelCoords: circularAxes._getAdjustedStripLabelCoords,
            _getStripLabelCoords: function(from, to) {
                var that = this;
                var labelPos = from + (to - from) / 2;
                var center = that.getCenter();
                var y = round(center.y - labelPos);
                return {
                    x: center.x,
                    y: y,
                    align: _axes_constants.default.center
                }
            },
            _getConstantLineGraphicAttributes: function(value) {
                var center = this.getCenter();
                return {
                    cx: center.x,
                    cy: center.y,
                    r: value
                }
            },
            _createConstantLine: function(value, attr) {
                var attrs = this._getConstantLineGraphicAttributes(value);
                return this._renderer.circle(attrs.cx, attrs.cy, attrs.r).attr(attr).sharp()
            },
            _getConstantLineLabelsCoords: function(value) {
                var that = this;
                var center = that.getCenter();
                var y = round(center.y - value);
                return {
                    x: center.x,
                    y: y
                }
            },
            _checkAlignmentConstantLineLabels: _common.noop,
            _rotateTick: function(element, coords, isGridLine) {
                !isGridLine && element.rotate(coords.angle + HALF_PI_ANGLE, coords.x, coords.y)
            },
            _validateOverlappingMode: circularAxes._validateOverlappingMode,
            _validateDisplayMode: circularAxes._validateDisplayMode,
            _getStep: function(boxes) {
                var quarter = getPolarQuarter(this.getAngles()[0]);
                var spacing = this._options.label.minSpacing;
                var func = 2 === quarter || 4 === quarter ? function(box) {
                    return box.width + spacing
                } : function(box) {
                    return box.height
                };
                var maxLabelLength = boxes.reduce(function(prevValue, box) {
                    return _max(prevValue, func(box))
                }, 0);
                return _axes_constants.default.getTicksCountInRange(this._majorTicks, 2 === quarter || 4 === quarter ? "x" : "y", maxLabelLength)
            }
        };
        exports.linear = linear;
        var linearSpider = (0, _extend.extend)({}, linear, {
            _createPathElement: function(points, attr) {
                return this._renderer.path(points, "area").attr(attr).sharp()
            },
            setSpiderTicks: function(ticks) {
                this._spiderTicks = ticks
            },
            _getGridLineDrawer: function() {
                var that = this;
                return function(tick, gridStyle) {
                    return that._createPathElement(that._getGridPoints(tick.coords).points, gridStyle)
                }
            },
            _getGridPoints: function(coords) {
                var pos = this.getCenter();
                var radius = (0, _utils.getDistance)(pos.x, pos.y, coords.x, coords.y);
                return this._getGridPointsByRadius(radius)
            },
            _getGridPointsByRadius: function(radius) {
                var pos = this.getCenter();
                if (radius > this.getRadius()) {
                    return {
                        points: null
                    }
                }
                return {
                    points: (0, _utils.map)(this._spiderTicks, function(tick) {
                        var cosSin = (0, _utils.getCosAndSin)(tick.coords.angle);
                        return {
                            x: round(pos.x + radius * cosSin.cos),
                            y: round(pos.y + radius * cosSin.sin)
                        }
                    })
                }
            },
            _getStripGraphicAttributes: function(fromPoint, toPoint) {
                var innerPoints = this._getGridPointsByRadius(toPoint).points;
                var outerPoints = this._getGridPointsByRadius(fromPoint).points;
                return {
                    points: [outerPoints, innerPoints.reverse()]
                }
            },
            _createStrip: circularSpider._createStrip,
            _getConstantLineGraphicAttributes: function(value) {
                return this._getGridPointsByRadius(value)
            },
            _createConstantLine: function(value, attr) {
                return this._createPathElement(this._getConstantLineGraphicAttributes(value).points, attr)
            }
        });
        exports.linearSpider = linearSpider
    },
    /*!************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/axes/constant_line.js ***!
      \************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = createConstantLine;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);

        function createConstantLine(axis, options) {
            var labelOptions = options.label || {};
            var labelPosition = labelOptions.position || "inside";
            var parsedValue;
            var valueIsParsed = false;
            var lastStoredCoordinates;
            axis._checkAlignmentConstantLineLabels(labelOptions);
            var storedCoord;
            return {
                options: options,
                labelOptions: labelOptions,
                labelPosition: labelPosition,
                label: null,
                line: null,
                getParsedValue: function() {
                    if (!valueIsParsed) {
                        parsedValue = axis.validateUnit(options.value, "E2105", "constantLine");
                        valueIsParsed = true;
                        return parsedValue
                    }
                    return parsedValue
                },
                draw: function() {
                    if (!(0, _type.isDefined)(options.value) || axis._translator.getBusinessRange().isEmpty()) {
                        return this
                    }
                    var canvas = axis._getCanvasStartEnd();
                    var parsedValue = this.getParsedValue();
                    this.coord = axis._getConstantLinePos(parsedValue, canvas.start, canvas.end);
                    var rootGroup = options.displayBehindSeries ? axis._axisConstantLineGroups.under : axis._axisConstantLineGroups.above;
                    var group = rootGroup[labelPosition];
                    if (!group) {
                        var side = axis._isHorizontal ? labelOptions.verticalAlignment : labelOptions.horizontalAlignment;
                        group = rootGroup[side]
                    }
                    if (!(0, _type.isDefined)(this.coord)) {
                        return this
                    }
                    var path = axis._createConstantLine(this.coord, {
                        stroke: options.color,
                        "stroke-width": options.width,
                        dashStyle: options.dashStyle
                    });
                    this.line = path.append(rootGroup.inside);
                    this.label = labelOptions.visible ? axis._drawConstantLineLabels(parsedValue, labelOptions, this.coord, group) : null;
                    this.updatePosition();
                    return this
                },
                getContentContainer: function() {
                    return this.label
                },
                removeLabel: function() {
                    this.label && this.label.remove()
                },
                updatePosition: function(animate) {
                    var canvas = axis._getCanvasStartEnd();
                    var coord = axis._getConstantLinePos(this.getParsedValue(), canvas.start, canvas.end);
                    if (!(0, _type.isDefined)(coord)) {
                        return
                    }
                    this.coord = coord;
                    if (animate && storedCoord) {
                        this.label && this.label.attr(axis._getConstantLineLabelsCoords(storedCoord, this.labelOptions));
                        this.line && this.line.attr(axis._getConstantLineGraphicAttributes(storedCoord));
                        this.label && this.label.animate(axis._getConstantLineLabelsCoords(this.coord, this.labelOptions));
                        this.line && this.line.animate(axis._getConstantLineGraphicAttributes(this.coord))
                    } else {
                        this.label && this.label.attr(axis._getConstantLineLabelsCoords(this.coord, this.labelOptions));
                        this.line && this.line.attr(axis._getConstantLineGraphicAttributes(this.coord));
                        axis._rotateConstantLine(this.line, this.coord)
                    }
                },
                saveCoords: function() {
                    lastStoredCoordinates = storedCoord;
                    storedCoord = this.coord
                },
                resetCoordinates: function() {
                    storedCoord = lastStoredCoordinates
                }
            }
        }
        module.exports = exports.default
    },
    /*!****************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/axes/strip.js ***!
      \****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = createStrip;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);

        function createStrip(axis, options) {
            var storedCoord;
            var lastStoredCoordinates;
            var labelOptions = options.label || {};
            return {
                options: options,
                label: null,
                rect: null,
                _getCoord: function() {
                    var canvas = axis._getCanvasStartEnd();
                    var range = axis._translator.getBusinessRange();
                    return axis._getStripPos(options.startValue, options.endValue, canvas.start, canvas.end, range)
                },
                _drawLabel: function(coords) {
                    return axis._renderer.text(labelOptions.text, coords.x, coords.y).css((0, _utils.patchFontOptions)((0, _extend.extend)({}, axis.getOptions().label.font, labelOptions.font))).attr({
                        align: "center",
                        "class": labelOptions.cssClass
                    }).append(axis._axisStripLabelGroup)
                },
                draw: function() {
                    if (axis._translator.getBusinessRange().isEmpty()) {
                        return
                    }
                    if (((0, _type.isDefined)(options.startValue) || (0, _type.isDefined)(options.endValue)) && (0, _type.isDefined)(options.color)) {
                        var stripPos = this._getCoord();
                        this.labelCoords = labelOptions.text ? axis._getStripLabelCoords(stripPos.from, stripPos.to, labelOptions) : null;
                        if (stripPos.outOfCanvas || !(0, _type.isDefined)(stripPos.to) || !(0, _type.isDefined)(stripPos.from)) {
                            return
                        }
                        this.rect = axis._createStrip(axis._getStripGraphicAttributes(stripPos.from, stripPos.to)).attr({
                            fill: options.color
                        }).append(axis._axisStripGroup);
                        this.label = labelOptions.text ? this._drawLabel(this.labelCoords) : null
                    }
                },
                getContentContainer: function() {
                    return this.label
                },
                removeLabel: function() {},
                updatePosition: function(animate) {
                    var stripPos = this._getCoord();
                    if (animate && storedCoord) {
                        this.label && this.label.attr(axis._getStripLabelCoords(storedCoord.from, storedCoord.to, options.label));
                        this.rect && this.rect.attr(axis._getStripGraphicAttributes(storedCoord.from, storedCoord.to));
                        this.label && this.label.animate(axis._getStripLabelCoords(stripPos.from, stripPos.to, options.label));
                        this.rect && this.rect.animate(axis._getStripGraphicAttributes(stripPos.from, stripPos.to))
                    } else {
                        this.label && this.label.attr(axis._getStripLabelCoords(stripPos.from, stripPos.to, options.label));
                        this.rect && this.rect.attr(axis._getStripGraphicAttributes(stripPos.from, stripPos.to))
                    }
                },
                saveCoords: function() {
                    lastStoredCoordinates = storedCoord;
                    storedCoord = this._getCoord()
                },
                resetCoordinates: function() {
                    storedCoord = lastStoredCoordinates
                }
            }
        }
        module.exports = exports.default
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/chart_components/scroll_bar.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.ScrollBar = void 0;
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _translator2d = __webpack_require__( /*! ../translators/translator2d */ 318);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _drag = __webpack_require__( /*! ../../events/drag */ 76);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _min = Math.min;
        var _max = Math.max;
        var MIN_SCROLL_BAR_SIZE = 2;
        var ScrollBar = function(renderer, group) {
            this._translator = new _translator2d.Translator2D({}, {}, {});
            this._scroll = renderer.rect().append(group);
            this._addEvents()
        };
        exports.ScrollBar = ScrollBar;

        function _getXCoord(canvas, pos, offset, width) {
            var x = 0;
            if ("right" === pos) {
                x = canvas.width - canvas.right + offset
            } else {
                if ("left" === pos) {
                    x = canvas.left - offset - width
                }
            }
            return x
        }

        function _getYCoord(canvas, pos, offset, width) {
            var y = 0;
            if ("top" === pos) {
                y = canvas.top - offset
            } else {
                if ("bottom" === pos) {
                    y = canvas.height - canvas.bottom + width + offset
                }
            }
            return y
        }
        ScrollBar.prototype = {
            _addEvents: function() {
                var _this = this;
                var scrollElement = this._scroll.element;
                _events_engine.default.on(scrollElement, _drag.start, function(e) {
                    (0, _index.fireEvent)({
                        type: "dxc-scroll-start",
                        originalEvent: e,
                        target: scrollElement
                    })
                });
                _events_engine.default.on(scrollElement, _drag.move, function(e) {
                    var dX = -e.offset.x * _this._scale;
                    var dY = -e.offset.y * _this._scale;
                    var lx = _this._offset - (_this._layoutOptions.vertical ? dY : dX) / _this._scale;
                    _this._applyPosition(lx, lx + _this._translator.canvasLength / _this._scale);
                    (0, _index.fireEvent)({
                        type: "dxc-scroll-move",
                        originalEvent: e,
                        target: scrollElement,
                        offset: {
                            x: dX,
                            y: dY
                        }
                    })
                });
                _events_engine.default.on(scrollElement, _drag.end, function(e) {
                    (0, _index.fireEvent)({
                        type: "dxc-scroll-end",
                        originalEvent: e,
                        target: scrollElement,
                        offset: {
                            x: -e.offset.x * _this._scale,
                            y: -e.offset.y * _this._scale
                        }
                    })
                })
            },
            update: function(options) {
                var that = this;
                var position = options.position;
                var isVertical = options.rotated;
                var defaultPosition = isVertical ? "right" : "top";
                var secondaryPosition = isVertical ? "left" : "bottom";
                if (position !== defaultPosition && position !== secondaryPosition) {
                    position = defaultPosition
                }
                that._scroll.attr({
                    rotate: !options.rotated ? -90 : 0,
                    rotateX: 0,
                    rotateY: 0,
                    fill: options.color,
                    width: options.width,
                    opacity: options.opacity
                });
                that._layoutOptions = {
                    width: options.width,
                    offset: options.offset,
                    vertical: isVertical,
                    position: position
                };
                return that
            },
            init: function(range, stick) {
                var that = this;
                var isDiscrete = "discrete" === range.axisType;
                that._translateWithOffset = isDiscrete && !stick && 1 || 0;
                that._translator.update((0, _extend.extend)({}, range, {
                    minVisible: null,
                    maxVisible: null,
                    visibleCategories: null
                }, isDiscrete && {
                    min: null,
                    max: null
                } || {}), that._canvas, {
                    isHorizontal: !that._layoutOptions.vertical,
                    stick: stick
                });
                return that
            },
            getOptions: function() {
                return this._layoutOptions
            },
            setPane: function(panes) {
                var position = this._layoutOptions.position;
                var pane;
                if ("left" === position || "top" === position) {
                    pane = panes[0]
                } else {
                    pane = panes[panes.length - 1]
                }
                this.pane = pane.name;
                return this
            },
            updateSize: function(canvas) {
                this._canvas = (0, _extend.extend)({}, canvas);
                var options = this._layoutOptions;
                var pos = options.position;
                var offset = options.offset;
                var width = options.width;
                this._scroll.attr({
                    translateX: _getXCoord(canvas, pos, offset, width),
                    translateY: _getYCoord(canvas, pos, offset, width)
                })
            },
            getMultipleAxesSpacing: function() {
                return 0
            },
            estimateMargins: function() {
                return this.getMargins()
            },
            getMargins: function() {
                var options = this._layoutOptions;
                var margins = {
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0
                };
                margins[options.position] = options.width + options.offset;
                return margins
            },
            shift: function shift(margins) {
                var _that$_scroll$attr, _that$_scroll$attr2;
                var that = this;
                var options = that._layoutOptions;
                var side = options.position;
                var isVertical = options.vertical;
                var attr = {
                    translateX: null !== (_that$_scroll$attr = that._scroll.attr("translateX")) && void 0 !== _that$_scroll$attr ? _that$_scroll$attr : 0,
                    translateY: null !== (_that$_scroll$attr2 = that._scroll.attr("translateY")) && void 0 !== _that$_scroll$attr2 ? _that$_scroll$attr2 : 0
                };
                var shift = margins[side];
                attr[isVertical ? "translateX" : "translateY"] += ("left" === side || "top" === side ? -1 : 1) * shift;
                that._scroll.attr(attr)
            },
            hideTitle: _common.noop,
            hideOuterElements: _common.noop,
            setPosition: function(min, max) {
                var that = this;
                var translator = that._translator;
                var minPoint = (0, _type.isDefined)(min) ? translator.translate(min, -that._translateWithOffset) : translator.translate("canvas_position_start");
                var maxPoint = (0, _type.isDefined)(max) ? translator.translate(max, that._translateWithOffset) : translator.translate("canvas_position_end");
                that._offset = _min(minPoint, maxPoint);
                that._scale = translator.getScale(min, max);
                that._applyPosition(_min(minPoint, maxPoint), _max(minPoint, maxPoint))
            },
            customPositionIsAvailable: function() {
                return false
            },
            dispose: function() {
                this._scroll.dispose();
                this._scroll = this._translator = null
            },
            _applyPosition: function(x1, x2) {
                var that = this;
                var visibleArea = that._translator.getCanvasVisibleArea();
                x1 = _max(x1, visibleArea.min);
                x1 = _min(x1, visibleArea.max);
                x2 = _min(x2, visibleArea.max);
                x2 = _max(x2, visibleArea.min);
                var height = Math.abs(x2 - x1);
                that._scroll.attr({
                    y: x1,
                    height: height < MIN_SCROLL_BAR_SIZE ? MIN_SCROLL_BAR_SIZE : height
                })
            }
        }
    },
    /*!***********************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/chart_components/shutter_zoom.js ***!
      \***********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _drag = __webpack_require__( /*! ../../events/drag */ 76);
        var SHUTTER_EVENTS_NS = ".shutter-zoom";
        var DRAG_START_EVENT_NAME = _drag.start + SHUTTER_EVENTS_NS;
        var DRAG_UPDATE_EVENT_NAME = _drag.move + SHUTTER_EVENTS_NS;
        var DRAG_END_EVENT_NAME = _drag.end + SHUTTER_EVENTS_NS;

        function getPointerCoord(rootOffset, canvas, rotated, e) {
            var coord = Math.floor(rotated ? e.pageY - rootOffset.top : e.pageX - rootOffset.left);
            var min = rotated ? canvas.y1 : canvas.x1;
            var max = rotated ? canvas.y2 : canvas.x2;
            if (coord < min) {
                coord = min
            } else {
                if (coord > max) {
                    coord = max
                }
            }
            return coord
        }

        function checkCoords(rootOffset, canvas, e) {
            var x = e.pageX - rootOffset.left;
            var y = e.pageY - rootOffset.top;
            return x >= canvas.x1 && x <= canvas.x2 && y >= canvas.y1 && y <= canvas.y2
        }

        function dragStartHandler(ctx) {
            return function(e) {
                var offset = ctx.getRootOffset();
                var canvas = ctx.getCanvas();
                if (!checkCoords(offset, canvas, e)) {
                    e.cancel = true;
                    return
                }
                ctx.rootOffset = offset;
                ctx.canvas = canvas;
                ctx.startCoord = getPointerCoord(offset, canvas, ctx.rotated, e);
                ctx.triggerStart();
                ctx.rect.attr({
                    x: canvas.x1,
                    y: canvas.y1,
                    width: canvas.width,
                    height: canvas.height
                }).append(ctx.root)
            }
        }

        function dragHandler(ctx) {
            return function(e) {
                var curCoord = getPointerCoord(ctx.rootOffset, ctx.canvas, ctx.rotated, e);
                var attr = {};
                ctx.curCoord = curCoord;
                attr[ctx.rotated ? "y" : "x"] = Math.min(ctx.startCoord, curCoord);
                attr[ctx.rotated ? "height" : "width"] = Math.abs(ctx.startCoord - curCoord);
                ctx.rect.attr(attr)
            }
        }

        function dragEndHandler(ctx) {
            return function(e) {
                ctx.triggerEnd();
                ctx.rect.remove()
            }
        }

        function shutterZoom(options) {
            var chart = options.chart;
            var renderer = options.renderer;
            var rotated = options.rotated;
            var rect = renderer.rect(0, 0, 0, 0).attr(options.shutterOptions);
            var shutter = {
                rect: rect,
                root: renderer.root,
                rotated: rotated,
                triggerStart: function() {
                    chart._eventTrigger("zoomStart")
                },
                triggerEnd: function() {
                    var tr = chart._argumentAxes[0].getTranslator();
                    var rangeStart = Math.min(this.startCoord, this.curCoord);
                    var rangeEnd = Math.max(this.startCoord, this.curCoord);
                    chart._eventTrigger("zoomEnd", {
                        rangeStart: tr.from(rangeStart),
                        rangeEnd: tr.from(rangeEnd)
                    })
                },
                dispose: function() {
                    renderer.root.off(SHUTTER_EVENTS_NS);
                    rect.dispose()
                },
                getRootOffset: function() {
                    return renderer.getRootOffset()
                },
                getCanvas: function() {
                    var canvas = chart._canvas;
                    var panes = chart.panes;
                    var firstPane = panes[0].canvas;
                    var lastPane = panes[panes.length - 1].canvas;
                    return {
                        x1: firstPane.left,
                        y1: firstPane.top,
                        x2: canvas.width - lastPane.right,
                        y2: canvas.height - lastPane.bottom,
                        width: canvas.width - firstPane.left - lastPane.right,
                        height: canvas.height - firstPane.top - lastPane.bottom
                    }
                }
            };
            renderer.root.off(SHUTTER_EVENTS_NS).on(DRAG_START_EVENT_NAME, {
                direction: rotated ? "vertical" : "horizontal",
                immediate: true
            }, dragStartHandler(shutter)).on(DRAG_UPDATE_EVENT_NAME, dragHandler(shutter)).on(DRAG_END_EVENT_NAME, dragEndHandler(shutter));
            return shutter
        }
        var _default = {
            name: "shutter_zoom",
            init: function() {
                var options = this.option("shutterZoom") || {};
                if (!options.enabled) {
                    return
                }
                this._shutterZoom = shutterZoom({
                    chart: this,
                    renderer: this._renderer,
                    rotated: this.option("rotated"),
                    shutterOptions: options
                })
            },
            dispose: function() {
                this._shutterZoom && this._shutterZoom.dispose()
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/chart_components/zoom_and_pan.js ***!
      \***********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.default = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _wheel = __webpack_require__( /*! ../../events/core/wheel */ 148);
        var transformEvents = _interopRequireWildcard(__webpack_require__( /*! ../../events/transform */ 331));
        var _drag = __webpack_require__( /*! ../../events/drag */ 76);

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }
        var EVENTS_NS = ".zoomAndPanNS";
        var DRAG_START_EVENT_NAME = _drag.start + EVENTS_NS;
        var DRAG_EVENT_NAME = _drag.move + EVENTS_NS;
        var DRAG_END_EVENT_NAME = _drag.end + EVENTS_NS;
        var PINCH_START_EVENT_NAME = transformEvents.pinchstart + EVENTS_NS;
        var PINCH_EVENT_NAME = transformEvents.pinch + EVENTS_NS;
        var PINCH_END_EVENT_NAME = transformEvents.pinchend + EVENTS_NS;
        var SCROLL_BAR_START_EVENT_NAME = "dxc-scroll-start" + EVENTS_NS;
        var SCROLL_BAR_MOVE_EVENT_NAME = "dxc-scroll-move" + EVENTS_NS;
        var SCROLL_BAR_END_EVENT_NAME = "dxc-scroll-end" + EVENTS_NS;
        var GESTURE_TIMEOUT = 300;
        var MIN_DRAG_DELTA = 5;
        var _min = Math.min;
        var _max = Math.max;
        var _abs = Math.abs;

        function canvasToRect(canvas) {
            return {
                x: canvas.left,
                y: canvas.top,
                width: canvas.width - canvas.left - canvas.right,
                height: canvas.height - canvas.top - canvas.bottom
            }
        }

        function checkCoords(rect, coords) {
            var x = coords.x;
            var y = coords.y;
            return x >= rect.x && x <= rect.width + rect.x && y >= rect.y && y <= rect.height + rect.y
        }

        function sortAxes(axes, onlyAxisToNotify) {
            if (onlyAxisToNotify) {
                axes = axes.sort(function(a, b) {
                    if (a === onlyAxisToNotify) {
                        return -1
                    }
                    if (b === onlyAxisToNotify) {
                        return 1
                    }
                    return 0
                })
            }
            return axes
        }

        function isNotEmptyAxisBusinessRange(axis) {
            return !axis.getTranslator().getBusinessRange().isEmpty()
        }

        function axisZoom(axis, onlyAxisToNotify, getRange, getParameters, actionField, scale, e) {
            var silent = onlyAxisToNotify && axis !== onlyAxisToNotify;
            var range = getRange(axis);
            var _axis$checkZoomingLow = axis.checkZoomingLowerLimitOvercome(actionField, scale, range),
                stopInteraction = _axis$checkZoomingLow.stopInteraction,
                correctedRange = _axis$checkZoomingLow.correctedRange;
            var result = axis.handleZooming(stopInteraction ? null : correctedRange, getParameters(silent), e, actionField);
            stopInteraction && axis.handleZoomEnd();
            return {
                stopInteraction: stopInteraction,
                result: result
            }
        }
        var _default = {
            name: "zoom_and_pan",
            init: function() {
                var chart = this;
                var renderer = this._renderer;

                function cancelEvent(e) {
                    if (e.originalEvent) {
                        cancelEvent(e.originalEvent)
                    }
                    if (false !== e.cancelable) {
                        e.cancel = true
                    }
                }

                function startAxesViewportChanging(zoomAndPan, actionField, e) {
                    var options = zoomAndPan.options;
                    var actionData = zoomAndPan.actionData;
                    var axes = [];
                    if (options.argumentAxis[actionField]) {
                        axes.push(chart.getArgumentAxis())
                    }
                    if (options.valueAxis[actionField]) {
                        axes = axes.concat(actionData.valueAxes)
                    }
                    axes.reduce(function(isPrevented, axis) {
                        if (isPrevented) {
                            return isPrevented
                        }
                        if (isNotEmptyAxisBusinessRange(axis)) {
                            return axis.handleZooming(null, {
                                end: true
                            }, e, actionField).isPrevented
                        }
                        return isPrevented
                    }, false) && cancelEvent(e)
                }

                function axesViewportChanging(zoomAndPan, actionField, e, offsetCalc, centerCalc) {
                    function zoomAxes(axes, criteria, coordField, e, actionData) {
                        var zoom = {
                            zoomed: false
                        };
                        criteria && axes.filter(isNotEmptyAxisBusinessRange).forEach(function(axis) {
                            var options = axis.getOptions();
                            var viewport = axis.visualRange();
                            var scale = axis.getTranslator().getEventScale(e);
                            var translate = -offsetCalc(e, actionData, coordField, scale);
                            zoom = (0, _extend.extend)(true, zoom, axis.getTranslator().zoom(translate, scale, axis.getZoomBounds()));
                            var range = axis.adjustRange((0, _utils.getVizRangeObject)([zoom.min, zoom.max]));
                            var _axis$checkZoomingLow2 = axis.checkZoomingLowerLimitOvercome(actionField, scale, range),
                                stopInteraction = _axis$checkZoomingLow2.stopInteraction,
                                correctedRange = _axis$checkZoomingLow2.correctedRange;
                            if (!(0, _type.isDefined)(viewport) || viewport.startValue.valueOf() !== correctedRange.startValue.valueOf() || viewport.endValue.valueOf() !== correctedRange.endValue.valueOf()) {
                                axis.handleZooming(stopInteraction ? null : correctedRange, {
                                    start: true,
                                    end: true
                                }, e, actionField);
                                if (!stopInteraction) {
                                    zoom.zoomed = true;
                                    zoom.deltaTranslate = translate - zoom.translate
                                }
                            } else {
                                if ("touch" === e.pointerType && "discrete" === options.type) {
                                    var isMinPosition = axis.isExtremePosition(false);
                                    var isMaxPosition = axis.isExtremePosition(true);
                                    var zoomInEnabled = scale > 1 && !stopInteraction;
                                    var zoomOutEnabled = scale < 1 && (!isMinPosition || !isMaxPosition);
                                    var panningEnabled = 1 === scale && !(isMinPosition && (translate < 0 && !options.inverted || translate > 0 && options.inverted) || isMaxPosition && (translate > 0 && !options.inverted || translate < 0 && options.inverted));
                                    zoom.enabled = zoomInEnabled || zoomOutEnabled || panningEnabled
                                }
                            }
                        });
                        return zoom
                    }

                    function storeOffset(e, actionData, zoom, coordField) {
                        if (zoom.zoomed) {
                            actionData.offset[coordField] = (e.offset ? e.offset[coordField] : actionData.offset[coordField]) + zoom.deltaTranslate
                        }
                    }

                    function storeCenter(center, actionData, zoom, coordField) {
                        if (zoom.zoomed) {
                            actionData.center[coordField] = center[coordField] + zoom.deltaTranslate
                        }
                    }
                    var rotated = chart.option("rotated");
                    var actionData = zoomAndPan.actionData;
                    var options = zoomAndPan.options;
                    var argZoom = {};
                    var valZoom = {};
                    if (!actionData.fallback) {
                        argZoom = zoomAxes(chart._argumentAxes, options.argumentAxis[actionField], rotated ? "y" : "x", e, actionData);
                        valZoom = zoomAxes(actionData.valueAxes, options.valueAxis[actionField], rotated ? "x" : "y", e, actionData);
                        chart._requestChange(["VISUAL_RANGE"]);
                        storeOffset(e, actionData, argZoom, rotated ? "y" : "x");
                        storeOffset(e, actionData, valZoom, rotated ? "x" : "y")
                    }
                    var center = centerCalc(e);
                    storeCenter(center, actionData, argZoom, rotated ? "y" : "x");
                    storeCenter(center, actionData, valZoom, rotated ? "x" : "y");
                    if (!argZoom.zoomed && !valZoom.zoomed) {
                        actionData.center = center
                    }
                    return argZoom.zoomed || valZoom.zoomed || actionData.fallback || argZoom.enabled || valZoom.enabled
                }

                function finishAxesViewportChanging(zoomAndPan, actionField, e, offsetCalc) {
                    function zoomAxes(axes, criteria, coordField, actionData, onlyAxisToNotify) {
                        var zoomStarted = false;
                        var scale = e.scale || 1;
                        var getRange = function(axis) {
                            var zoom = axis.getTranslator().zoom(-offsetCalc(e, actionData, coordField, scale), scale, axis.getZoomBounds());
                            return {
                                startValue: zoom.min,
                                endValue: zoom.max
                            }
                        };
                        var getParameters = function(silent) {
                            return {
                                start: true,
                                end: silent
                            }
                        };
                        criteria && axes.forEach(function(axis) {
                            zoomStarted = !axisZoom(axis, onlyAxisToNotify, getRange, getParameters, actionField, scale, e).stopInteraction
                        });
                        return zoomStarted
                    }
                    var rotated = chart.option("rotated");
                    var actionData = zoomAndPan.actionData;
                    var options = zoomAndPan.options;
                    var zoomStarted = true;
                    if (actionData.fallback) {
                        zoomStarted &= zoomAxes(chart._argumentAxes, options.argumentAxis[actionField], rotated ? "y" : "x", actionData, chart.getArgumentAxis());
                        zoomStarted |= zoomAxes(actionData.valueAxes, options.valueAxis[actionField], rotated ? "x" : "y", actionData)
                    } else {
                        var axes = [];
                        if (options.argumentAxis[actionField]) {
                            axes.push(chart.getArgumentAxis())
                        }
                        if (options.valueAxis[actionField]) {
                            axes = axes.concat(actionData.valueAxes)
                        }
                        axes.filter(isNotEmptyAxisBusinessRange).forEach(function(axis) {
                            axis.handleZooming(null, {
                                start: true
                            }, e, actionField)
                        });
                        zoomStarted = zoomStarted && axes.length
                    }
                    zoomStarted && chart._requestChange(["VISUAL_RANGE"])
                }

                function prepareActionData(coords, action) {
                    var axes = chart._argumentAxes.filter(function(axis) {
                        return checkCoords(canvasToRect(axis.getCanvas()), coords)
                    });
                    return {
                        fallback: chart._lastRenderingTime > GESTURE_TIMEOUT,
                        cancel: !axes.length || !(0, _type.isDefined)(action),
                        action: action,
                        curAxisRect: axes.length && canvasToRect(axes[0].getCanvas()),
                        valueAxes: axes.length && chart._valueAxes.filter(function(axis) {
                            return checkCoords(canvasToRect(axis.getCanvas()), coords)
                        }),
                        offset: {
                            x: 0,
                            y: 0
                        },
                        center: coords,
                        startCenter: coords
                    }
                }

                function getPointerCoord(rect, e) {
                    var rootOffset = renderer.getRootOffset();
                    return {
                        x: _min(_max(e.pageX - rootOffset.left, rect.x), rect.width + rect.x),
                        y: _min(_max(e.pageY - rootOffset.top, rect.y), rect.height + rect.y)
                    }
                }

                function calcCenterForPinch(e) {
                    var rootOffset = renderer.getRootOffset();
                    var x1 = e.pointers[0].pageX;
                    var x2 = e.pointers[1].pageX;
                    var y1 = e.pointers[0].pageY;
                    var y2 = e.pointers[1].pageY;
                    return {
                        x: _min(x1, x2) + _abs(x2 - x1) / 2 - rootOffset.left,
                        y: _min(y1, y2) + _abs(y2 - y1) / 2 - rootOffset.top
                    }
                }

                function calcCenterForDrag(e) {
                    var rootOffset = renderer.getRootOffset();
                    return {
                        x: e.pageX - rootOffset.left,
                        y: e.pageY - rootOffset.top
                    }
                }

                function calcOffsetForDrag(e, actionData, coordField) {
                    return e.offset[coordField] - actionData.offset[coordField]
                }

                function preventDefaults(e) {
                    if (false !== e.cancelable) {
                        e.preventDefault();
                        e.stopPropagation()
                    }
                    chart._stopCurrentHandling()
                }
                var zoomAndPan = {
                    dragStartHandler: function(e) {
                        var options = zoomAndPan.options;
                        var isTouch = "touch" === e.pointerType;
                        var wantPan = options.argumentAxis.pan || options.valueAxis.pan;
                        var wantZoom = options.argumentAxis.zoom || options.valueAxis.zoom;
                        var panKeyPressed = (0, _type.isDefined)(options.panKey) && e[(0, _utils.normalizeEnum)(options.panKey) + "Key"];
                        var dragToZoom = options.dragToZoom;
                        var action;
                        e._cancelPreventDefault = true;
                        if (isTouch) {
                            if (options.allowTouchGestures && wantPan) {
                                var cancelPanning = !zoomAndPan.panningVisualRangeEnabled() || zoomAndPan.skipEvent;
                                action = cancelPanning ? null : "pan"
                            }
                        } else {
                            if (dragToZoom && wantPan && panKeyPressed) {
                                action = "pan"
                            } else {
                                if (!dragToZoom && wantPan) {
                                    action = "pan"
                                } else {
                                    if (dragToZoom && wantZoom) {
                                        action = "zoom"
                                    }
                                }
                            }
                        }
                        var actionData = prepareActionData(calcCenterForDrag(e), action);
                        if (actionData.cancel) {
                            zoomAndPan.skipEvent = false;
                            if (false !== e.cancelable) {
                                e.cancel = true
                            }
                            return
                        }
                        zoomAndPan.actionData = actionData;
                        if ("zoom" === action) {
                            actionData.startCoords = getPointerCoord(actionData.curAxisRect, e);
                            actionData.rect = renderer.rect(0, 0, 0, 0).attr(options.dragBoxStyle).append(renderer.root)
                        } else {
                            startAxesViewportChanging(zoomAndPan, "pan", e)
                        }
                    },
                    dragHandler: function(e) {
                        var rotated = chart.option("rotated");
                        var options = zoomAndPan.options;
                        var actionData = zoomAndPan.actionData;
                        var isTouch = "touch" === e.pointerType;
                        e._cancelPreventDefault = true;
                        if (!actionData || isTouch && !zoomAndPan.panningVisualRangeEnabled()) {
                            return
                        }
                        if ("zoom" === actionData.action) {
                            preventDefaults(e);
                            var curCanvas = actionData.curAxisRect;
                            var startCoords = actionData.startCoords;
                            var curCoords = getPointerCoord(curCanvas, e);
                            var zoomArg = options.argumentAxis.zoom;
                            var zoomVal = options.valueAxis.zoom;
                            var rect = {
                                x: _min(startCoords.x, curCoords.x),
                                y: _min(startCoords.y, curCoords.y),
                                width: _abs(startCoords.x - curCoords.x),
                                height: _abs(startCoords.y - curCoords.y)
                            };
                            if (!zoomArg || !zoomVal) {
                                if (!zoomArg && !rotated || !zoomVal && rotated) {
                                    rect.x = curCanvas.x;
                                    rect.width = curCanvas.width
                                } else {
                                    rect.y = curCanvas.y;
                                    rect.height = curCanvas.height
                                }
                            }
                            actionData.rect.attr(rect)
                        } else {
                            if ("pan" === actionData.action) {
                                axesViewportChanging(zoomAndPan, "pan", e, calcOffsetForDrag, function(e) {
                                    return e.offset
                                });
                                var deltaOffsetY = Math.abs(e.offset.y - actionData.offset.y);
                                var deltaOffsetX = Math.abs(e.offset.x - actionData.offset.x);
                                if (isTouch && (deltaOffsetY > MIN_DRAG_DELTA && deltaOffsetY > Math.abs(actionData.offset.x) || deltaOffsetX > MIN_DRAG_DELTA && deltaOffsetX > Math.abs(actionData.offset.y))) {
                                    return
                                }
                                preventDefaults(e)
                            }
                        }
                    },
                    dragEndHandler: function(e) {
                        var rotated = chart.option("rotated");
                        var options = zoomAndPan.options;
                        var actionData = zoomAndPan.actionData;
                        var isTouch = "touch" === e.pointerType;
                        var panIsEmpty = actionData && "pan" === actionData.action && !actionData.fallback && 0 === actionData.offset.x && 0 === actionData.offset.y;
                        if (!actionData || isTouch && !zoomAndPan.panningVisualRangeEnabled() || panIsEmpty) {
                            return
                        }(!isTouch || !zoomAndPan.actionData.isNative) && preventDefaults(e);
                        if ("zoom" === actionData.action) {
                            var zoomAxes = function(axes, criteria, coordField, startCoords, curCoords, onlyAxisToNotify) {
                                axes = sortAxes(axes, onlyAxisToNotify);
                                var curCoord = curCoords[coordField];
                                var startCoord = startCoords[coordField];
                                var zoomStarted = false;
                                var getParameters = function(silent) {
                                    return {
                                        start: !!silent,
                                        end: !!silent
                                    }
                                };
                                if (criteria && _abs(curCoord - startCoord) > MIN_DRAG_DELTA) {
                                    axes.some(function(axis) {
                                        var tr = axis.getTranslator();
                                        if (tr.getBusinessRange().isEmpty()) {
                                            return
                                        }
                                        var getRange = function() {
                                            return [tr.from(startCoord), tr.from(curCoord)]
                                        };
                                        var _axisZoom = axisZoom(axis, onlyAxisToNotify, getRange, getParameters, actionData.action, tr.getMinScale(true), e),
                                            stopInteraction = _axisZoom.stopInteraction,
                                            result = _axisZoom.result;
                                        zoomStarted = !stopInteraction;
                                        return onlyAxisToNotify && result.isPrevented
                                    })
                                }
                                return zoomStarted
                            };
                            var curCoords = getPointerCoord(actionData.curAxisRect, e);
                            var argumentAxesZoomed = zoomAxes(chart._argumentAxes, options.argumentAxis.zoom, rotated ? "y" : "x", actionData.startCoords, curCoords, chart.getArgumentAxis());
                            var valueAxesZoomed = zoomAxes(actionData.valueAxes, options.valueAxis.zoom, rotated ? "x" : "y", actionData.startCoords, curCoords);
                            if (valueAxesZoomed || argumentAxesZoomed) {
                                chart._requestChange(["VISUAL_RANGE"])
                            }
                            actionData.rect.dispose()
                        } else {
                            if ("pan" === actionData.action) {
                                finishAxesViewportChanging(zoomAndPan, "pan", e, calcOffsetForDrag)
                            }
                        }
                        zoomAndPan.actionData = null
                    },
                    pinchStartHandler: function(e) {
                        var actionData = prepareActionData(calcCenterForPinch(e), "zoom");
                        actionData.isNative = !zoomAndPan.panningVisualRangeEnabled();
                        if (actionData.cancel) {
                            cancelEvent(e);
                            return
                        }
                        zoomAndPan.actionData = actionData;
                        startAxesViewportChanging(zoomAndPan, "zoom", e)
                    },
                    pinchHandler: function(e) {
                        if (!zoomAndPan.actionData) {
                            return
                        }
                        var viewportChanged = axesViewportChanging(zoomAndPan, "zoom", e, function(e, actionData, coordField, scale) {
                            return calcCenterForPinch(e)[coordField] - actionData.center[coordField] + (actionData.center[coordField] - actionData.center[coordField] * scale)
                        }, calcCenterForPinch);
                        zoomAndPan.defineTouchBehavior(!viewportChanged, e);
                        !viewportChanged && (zoomAndPan.actionData = null)
                    },
                    pinchEndHandler: function(e) {
                        if (!zoomAndPan.actionData) {
                            return
                        }
                        finishAxesViewportChanging(zoomAndPan, "zoom", e, function(e, actionData, coordField, scale) {
                            return actionData.center[coordField] - actionData.startCenter[coordField] + (actionData.startCenter[coordField] - actionData.startCenter[coordField] * scale)
                        });
                        zoomAndPan.actionData = null
                    },
                    cleanup: function() {
                        renderer.root.off(EVENTS_NS);
                        zoomAndPan.actionData && zoomAndPan.actionData.rect && zoomAndPan.actionData.rect.dispose();
                        zoomAndPan.actionData = null;
                        renderer.root.css({
                            "touch-action": "",
                            "-ms-touch-action": ""
                        })
                    },
                    setup: function(options) {
                        zoomAndPan.cleanup();
                        if (!options.argumentAxis.pan) {
                            renderer.root.on(SCROLL_BAR_START_EVENT_NAME, cancelEvent)
                        }
                        if (options.argumentAxis.none && options.valueAxis.none) {
                            return
                        }
                        zoomAndPan.options = options;
                        var rotated = chart.option("rotated");
                        if ((options.argumentAxis.zoom || options.valueAxis.zoom) && options.allowMouseWheel) {
                            renderer.root.on(_wheel.name + EVENTS_NS, function(e) {
                                function zoomAxes(axes, coord, delta, onlyAxisToNotify) {
                                    axes = sortAxes(axes, onlyAxisToNotify);
                                    var zoomStarted = false;
                                    var getParameters = function(silent) {
                                        return {
                                            start: !!silent,
                                            end: !!silent
                                        }
                                    };
                                    axes.some(function(axis) {
                                        var translator = axis.getTranslator();
                                        if (translator.getBusinessRange().isEmpty()) {
                                            return
                                        }
                                        var scale = translator.getMinScale(delta > 0);
                                        var getRange = function() {
                                            var zoom = translator.zoom(-(coord - coord * scale), scale, axis.getZoomBounds());
                                            return {
                                                startValue: zoom.min,
                                                endValue: zoom.max
                                            }
                                        };
                                        var _axisZoom2 = axisZoom(axis, onlyAxisToNotify, getRange, getParameters, "zoom", scale, e),
                                            stopInteraction = _axisZoom2.stopInteraction,
                                            result = _axisZoom2.result;
                                        zoomStarted = !stopInteraction;
                                        return onlyAxisToNotify && result.isPrevented
                                    });
                                    return zoomStarted
                                }
                                var coords = calcCenterForDrag(e);
                                var axesZoomed = false;
                                var targetAxes;
                                if (options.valueAxis.zoom) {
                                    targetAxes = chart._valueAxes.filter(function(axis) {
                                        return checkCoords(canvasToRect(axis.getCanvas()), coords)
                                    });
                                    if (0 === targetAxes.length) {
                                        var targetCanvas = chart._valueAxes.reduce(function(r, axis) {
                                            if (!r && axis.coordsIn(coords.x, coords.y)) {
                                                r = axis.getCanvas()
                                            }
                                            return r
                                        }, null);
                                        if (targetCanvas) {
                                            targetAxes = chart._valueAxes.filter(function(axis) {
                                                return checkCoords(canvasToRect(axis.getCanvas()), {
                                                    x: targetCanvas.left,
                                                    y: targetCanvas.top
                                                })
                                            })
                                        }
                                    }
                                    axesZoomed |= zoomAxes(targetAxes, rotated ? coords.x : coords.y, e.delta)
                                }
                                if (options.argumentAxis.zoom) {
                                    var canZoom = chart._argumentAxes.some(function(axis) {
                                        if (checkCoords(canvasToRect(axis.getCanvas()), coords) || axis.coordsIn(coords.x, coords.y)) {
                                            return true
                                        }
                                        return false
                                    });
                                    axesZoomed |= canZoom && zoomAxes(chart._argumentAxes, rotated ? coords.y : coords.x, e.delta, chart.getArgumentAxis())
                                }
                                if (axesZoomed) {
                                    chart._requestChange(["VISUAL_RANGE"]);
                                    zoomAndPan.panningVisualRangeEnabled(targetAxes) && preventDefaults(e)
                                }
                            })
                        }
                        if (options.allowTouchGestures) {
                            if (options.argumentAxis.zoom || options.valueAxis.zoom) {
                                renderer.root.on(PINCH_START_EVENT_NAME, {
                                    passive: false
                                }, zoomAndPan.pinchStartHandler).on(PINCH_EVENT_NAME, {
                                    passive: false
                                }, zoomAndPan.pinchHandler).on(PINCH_END_EVENT_NAME, zoomAndPan.pinchEndHandler)
                            }
                        }
                        renderer.root.on(DRAG_START_EVENT_NAME, {
                            immediate: true,
                            passive: false
                        }, zoomAndPan.dragStartHandler).on(DRAG_EVENT_NAME, {
                            immediate: true,
                            passive: false
                        }, zoomAndPan.dragHandler).on(DRAG_END_EVENT_NAME, zoomAndPan.dragEndHandler);
                        if (options.argumentAxis.pan) {
                            renderer.root.on(SCROLL_BAR_START_EVENT_NAME, function(e) {
                                zoomAndPan.actionData = {
                                    valueAxes: [],
                                    offset: {
                                        x: 0,
                                        y: 0
                                    },
                                    center: {
                                        x: 0,
                                        y: 0
                                    }
                                };
                                preventDefaults(e);
                                startAxesViewportChanging(zoomAndPan, "pan", e)
                            }).on(SCROLL_BAR_MOVE_EVENT_NAME, function(e) {
                                preventDefaults(e);
                                axesViewportChanging(zoomAndPan, "pan", e, calcOffsetForDrag, function(e) {
                                    return e.offset
                                })
                            }).on(SCROLL_BAR_END_EVENT_NAME, function(e) {
                                preventDefaults(e);
                                finishAxesViewportChanging(zoomAndPan, "pan", e, calcOffsetForDrag);
                                zoomAndPan.actionData = null
                            })
                        }
                    },
                    defineTouchBehavior: function(isDefault, e) {
                        zoomAndPan.actionData && (zoomAndPan.actionData.isNative = isDefault);
                        if (!isDefault) {
                            preventDefaults(e)
                        }
                    },
                    panningVisualRangeEnabled: function(targetAxes) {
                        if (null !== targetAxes && void 0 !== targetAxes && targetAxes.length) {
                            return targetAxes.some(function(axis) {
                                return !axis.isExtremePosition(false) || !axis.isExtremePosition(true)
                            })
                        }
                        var enablePanByValueAxis = chart._valueAxes.some(function(axis) {
                            return !axis.isExtremePosition(false) || !axis.isExtremePosition(true)
                        });
                        var enablePanByArgumentAxis = chart._argumentAxes.some(function(axis) {
                            return !axis.isExtremePosition(false) || !axis.isExtremePosition(true)
                        });
                        return enablePanByValueAxis || enablePanByArgumentAxis
                    }
                };
                this._zoomAndPan = zoomAndPan
            },
            members: {
                _setupZoomAndPan: function() {
                    this._zoomAndPan.setup(this._themeManager.getOptions("zoomAndPan"))
                }
            },
            dispose: function() {
                this._zoomAndPan.cleanup()
            },
            customize: function(constructor) {
                constructor.addChange({
                    code: "ZOOM_AND_PAN",
                    handler: function() {
                        this._setupZoomAndPan()
                    },
                    isThemeDependent: true,
                    isOptionChange: true,
                    option: "zoomAndPan"
                })
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/pie_chart.js ***!
      \***************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _consts = _interopRequireDefault(__webpack_require__( /*! ./components/consts */ 143));
        var _utils = __webpack_require__( /*! ./core/utils */ 14);
        var _extend2 = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _iterator = __webpack_require__( /*! ../core/utils/iterator */ 3);
        var _range = __webpack_require__( /*! ./translators/range */ 124);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _base_chart = __webpack_require__( /*! ./chart_components/base_chart */ 309);
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _translator1d = __webpack_require__( /*! ./translators/translator1d */ 475);
        var _annotations = __webpack_require__( /*! ./core/annotations */ 228);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var states = _consts.default.states;
        var seriesSpacing = _consts.default.pieSeriesSpacing;
        var OPTIONS_FOR_REFRESH_SERIES = ["startAngle", "innerRadius", "segmentsDirection", "type"];
        var NORMAL_STATE = states.normalMark;
        var HOVER_STATE = states.hoverMark;
        var SELECTED_STATE = states.selectedMark;
        var MAX_RESOLVE_ITERATION_COUNT = 5;
        var LEGEND_ACTIONS = [states.resetItem, states.applyHover, states.applySelected, states.applySelected];

        function getLegendItemAction(points) {
            var state = NORMAL_STATE;
            points.forEach(function(point) {
                var _point$series;
                var seriesOptions = null === (_point$series = point.series) || void 0 === _point$series ? void 0 : _point$series.getOptions();
                var pointState = point.fullState;
                if ("none" === (null === seriesOptions || void 0 === seriesOptions ? void 0 : seriesOptions.hoverMode)) {
                    pointState &= ~HOVER_STATE
                }
                if ("none" === (null === seriesOptions || void 0 === seriesOptions ? void 0 : seriesOptions.selectionMode)) {
                    pointState &= ~SELECTED_STATE
                }
                state |= pointState
            });
            return LEGEND_ACTIONS[state]
        }

        function correctPercentValue(value) {
            if ((0, _type.isNumeric)(value)) {
                if (value > 1) {
                    value = 1
                } else {
                    if (value < 0) {
                        value = 0
                    }
                }
            } else {
                value = void 0
            }
            return value
        }
        var pieSizeEqualizer = function() {
            function equalize(group, allPies) {
                var pies = allPies.filter(function(p) {
                    return p._isVisible() && p.getSizeGroup() === group
                });
                var minRadius = Math.min.apply(null, pies.map(function(p) {
                    return p.getSizeGroupLayout().radius
                }));
                var minPie = pies.filter(function(p) {
                    return p.getSizeGroupLayout().radius === minRadius
                });
                pies.forEach(function(p) {
                    return p.render({
                        force: true,
                        sizeGroupLayout: minPie.length ? minPie[0].getSizeGroupLayout() : {}
                    })
                })
            }

            function removeFromList(list, item) {
                return list.filter(function(li) {
                    return li !== item
                })
            }

            function addToList(list, item) {
                return removeFromList(list, item).concat(item)
            }
            var pies = [];
            var timers = {};
            return {
                queue: function(pie) {
                    var group = pie.getSizeGroup();
                    pies = addToList(pies, pie);
                    clearTimeout(timers[group]);
                    timers[group] = setTimeout(function() {
                        equalize(group, pies)
                    })
                },
                remove: function(pie) {
                    pies = removeFromList(pies, pie);
                    if (!pies.length) {
                        timers = {}
                    }
                }
            }
        }();
        var dxPieChart = _base_chart.BaseChart.inherit({
            _themeSection: "pie",
            _layoutManagerOptions: function() {
                return (0, _extend2.extend)(true, {}, this.callBase(), {
                    piePercentage: correctPercentValue(this._themeManager.getOptions("diameter")),
                    minPiePercentage: correctPercentValue(this._themeManager.getOptions("minDiameter"))
                })
            },
            _optionChangesMap: {
                diameter: "REINIT",
                minDiameter: "REINIT",
                sizeGroup: "REINIT"
            },
            _disposeCore: function() {
                pieSizeEqualizer.remove(this);
                this.callBase()
            },
            _groupSeries: function() {
                var series = this.series;
                this._groupsData = {
                    groups: [{
                        series: series,
                        valueOptions: {
                            valueType: "numeric"
                        }
                    }],
                    argumentOptions: series[0] && series[0].getOptions()
                }
            },
            getArgumentAxis: function() {
                return null
            },
            _getValueAxis: function() {
                var translator = (new _translator1d.Translator1D).setCodomain(360, 0);
                return {
                    getTranslator: function() {
                        return translator
                    },
                    setBusinessRange: function(range) {
                        translator.setDomain(range.min, range.max)
                    }
                }
            },
            _populateBusinessRange: function() {
                this.series.map(function(series) {
                    var range = new _range.Range;
                    range.addRange(series.getRangeData().val);
                    series.getValueAxis().setBusinessRange(range);
                    return range
                })
            },
            _specialProcessSeries: function() {
                (0, _iterator.each)(this.series, function(_, singleSeries) {
                    singleSeries.arrangePoints()
                })
            },
            _checkPaneName: function() {
                return true
            },
            _processSingleSeries: function(singleSeries) {
                this.callBase(singleSeries);
                singleSeries.arrangePoints()
            },
            _handleSeriesDataUpdated: function() {
                var maxPointCount = 0;
                this.series.forEach(function(s) {
                    maxPointCount = Math.max(s.getPointsCount(), maxPointCount)
                });
                this.series.forEach(function(s) {
                    s.setMaxPointsCount(maxPointCount)
                });
                this.callBase()
            },
            _getLegendOptions: function(item) {
                var legendItem = this.callBase(item);
                var legendData = legendItem.legendData;
                legendData.argument = item.argument;
                legendData.argumentIndex = item.argumentIndex;
                legendData.points = [item];
                return legendItem
            },
            _getLegendTargets: function() {
                var that = this;
                var itemsByArgument = {};
                (that.series || []).forEach(function(series) {
                    series.getPoints().forEach(function(point) {
                        var argument = point.argument.valueOf();
                        var index = series.getPointsByArg(argument).indexOf(point);
                        var key = argument.valueOf().toString() + index;
                        itemsByArgument[key] = itemsByArgument[key] || [];
                        var argumentCount = itemsByArgument[key].push(point);
                        point.index = itemsByArgument[key][argumentCount - 2] ? itemsByArgument[key][argumentCount - 2].index : Object.keys(itemsByArgument).length - 1;
                        point.argumentIndex = index
                    })
                });
                var items = [];
                (0, _iterator.each)(itemsByArgument, function(_, points) {
                    points.forEach(function(point, index) {
                        if (0 === index) {
                            items.push(that._getLegendOptions(point));
                            return
                        }
                        var item = items[items.length - 1];
                        item.legendData.points.push(point);
                        if (!item.visible) {
                            item.visible = point.isVisible()
                        }
                    })
                });
                return items
            },
            _getLayoutTargets: function() {
                return [{
                    canvas: this._canvas
                }]
            },
            _getLayoutSeries: function(series, drawOptions) {
                var that = this;
                var layout;
                var canvas = that._canvas;
                var drawnLabels = false;
                layout = that.layoutManager.applyPieChartSeriesLayout(canvas, series, true);
                series.forEach(function(singleSeries) {
                    singleSeries.correctPosition(layout, canvas);
                    drawnLabels = singleSeries.drawLabelsWOPoints() || drawnLabels
                });
                if (drawnLabels) {
                    layout = that.layoutManager.applyPieChartSeriesLayout(canvas, series, drawOptions.hideLayoutLabels)
                }
                series.forEach(function(singleSeries) {
                    singleSeries.hideLabels()
                });
                that._sizeGroupLayout = {
                    x: layout.centerX,
                    y: layout.centerY,
                    radius: layout.radiusOuter,
                    drawOptions: drawOptions
                };
                return layout
            },
            _getLayoutSeriesForEqualPies: function(series, sizeGroupLayout) {
                var canvas = this._canvas;
                var layout = this.layoutManager.applyEqualPieChartLayout(series, sizeGroupLayout);
                series.forEach(function(s) {
                    s.correctPosition(layout, canvas);
                    s.drawLabelsWOPoints()
                });
                this.layoutManager.correctPieLabelRadius(series, layout, canvas);
                return layout
            },
            _updateSeriesDimensions: function(drawOptions) {
                var that = this;
                var visibleSeries = that._getVisibleSeries();
                var lengthVisibleSeries = visibleSeries.length;
                var innerRad;
                var delta;
                var layout;
                var sizeGroupLayout = drawOptions.sizeGroupLayout;
                if (lengthVisibleSeries) {
                    layout = sizeGroupLayout ? that._getLayoutSeriesForEqualPies(visibleSeries, sizeGroupLayout) : that._getLayoutSeries(visibleSeries, drawOptions);
                    delta = (layout.radiusOuter - layout.radiusInner - seriesSpacing * (lengthVisibleSeries - 1)) / lengthVisibleSeries;
                    innerRad = layout.radiusInner;
                    that._setGeometry(layout);
                    visibleSeries.forEach(function(singleSeries) {
                        singleSeries.correctRadius({
                            radiusInner: innerRad,
                            radiusOuter: innerRad + delta
                        });
                        innerRad += delta + seriesSpacing
                    })
                }
            },
            _renderSeries: function(drawOptions, isRotated, isLegendInside) {
                this._calculateSeriesLayout(drawOptions, isRotated);
                if (!drawOptions.sizeGroupLayout && this.getSizeGroup()) {
                    pieSizeEqualizer.queue(this);
                    this._clearCanvas();
                    return
                }
                this._renderSeriesElements(drawOptions, isLegendInside)
            },
            _renderExtraElements: function() {
                var _this = this;
                var template = this.option("centerTemplate");
                if (this._centerTemplateGroup) {
                    this._centerTemplateGroup.clear()
                }
                if (!template) {
                    return
                }
                if (!this._centerTemplateGroup) {
                    this._centerTemplateGroup = this._renderer.g().attr({
                        "class": "dxc-hole-template"
                    }).css((0, _utils.patchFontOptions)(this._themeManager._font))
                }
                this._centerTemplateGroup.attr({
                    visibility: "hidden"
                }).append(this._renderer.root);
                template = this._getTemplate(template);
                template.render({
                    model: this,
                    container: this._centerTemplateGroup.element,
                    onRendered: function() {
                        var group = _this._centerTemplateGroup;
                        var bBox = group.getBBox();
                        group.move(_this._center.x - (bBox.x + bBox.width / 2), _this._center.y - (bBox.y + bBox.height / 2));
                        group.attr({
                            visibility: "visible"
                        })
                    }
                })
            },
            getInnerRadius: function() {
                return this._innerRadius
            },
            _getLegendCallBack: function() {
                var that = this;
                var legend = this._legend;
                var items = this._getLegendTargets().map(function(i) {
                    return i.legendData
                });
                return function(target) {
                    items.forEach(function(data) {
                        var points = [];
                        var callback = legend.getActionCallback({
                            index: data.id
                        });
                        that.series.forEach(function(series) {
                            var seriesPoints = series.getPointsByKeys(data.argument, data.argumentIndex);
                            points.push.apply(points, seriesPoints)
                        });
                        if (target && target.argument === data.argument && target.argumentIndex === data.argumentIndex) {
                            points.push(target)
                        }
                        callback(getLegendItemAction(points))
                    })
                }
            },
            _locateLabels: function(resolveLabelOverlapping) {
                var iterationCount = 0;
                var labelsWereOverlapped;
                var wordWrapApplied;
                do {
                    wordWrapApplied = this._adjustSeriesLabels("shift" === resolveLabelOverlapping);
                    labelsWereOverlapped = this._resolveLabelOverlapping(resolveLabelOverlapping)
                } while ((labelsWereOverlapped || wordWrapApplied) && ++iterationCount < MAX_RESOLVE_ITERATION_COUNT)
            },
            _adjustSeriesLabels: function(moveLabelsFromCenter) {
                return this.series.reduce(function(r, s) {
                    return s.adjustLabels(moveLabelsFromCenter) || r
                }, false)
            },
            _applyExtraSettings: _common.noop,
            _resolveLabelOverlappingShift: function() {
                var that = this;
                var inverseDirection = "anticlockwise" === that.option("segmentsDirection");
                var seriesByPosition = that.series.reduce(function(r, s) {
                    (r[s.getOptions().label.position] || r.outside).push(s);
                    return r
                }, {
                    inside: [],
                    columns: [],
                    outside: []
                });
                var labelsOverlapped = false;
                if (seriesByPosition.inside.length > 0) {
                    labelsOverlapped = resolve(seriesByPosition.inside.reduce(function(r, singleSeries) {
                        return singleSeries.getVisiblePoints().reduce(function(r, point) {
                            r.left.push(point);
                            return r
                        }, r)
                    }, {
                        left: [],
                        right: []
                    }), shiftInColumnFunction) || labelsOverlapped
                }
                labelsOverlapped = seriesByPosition.columns.reduce(function(r, singleSeries) {
                    return resolve(dividePoints(singleSeries), shiftInColumnFunction) || r
                }, labelsOverlapped);
                if (seriesByPosition.outside.length > 0) {
                    labelsOverlapped = resolve(seriesByPosition.outside.reduce(function(r, singleSeries) {
                        return dividePoints(singleSeries, r)
                    }, null), shiftFunction) || labelsOverlapped
                }
                return labelsOverlapped;

                function dividePoints(series, points) {
                    return series.getVisiblePoints().reduce(function(r, point) {
                        var angle = (0, _utils.normalizeAngle)(point.middleAngle);
                        (angle <= 90 || angle >= 270 ? r.right : r.left).push(point);
                        return r
                    }, points || {
                        left: [],
                        right: []
                    })
                }

                function resolve(points, shiftCallback) {
                    var overlapped = false;
                    if (inverseDirection) {
                        points.left.reverse();
                        points.right.reverse()
                    }
                    overlapped = _base_chart.overlapping.resolveLabelOverlappingInOneDirection(points.left, that._canvas, false, shiftCallback);
                    return _base_chart.overlapping.resolveLabelOverlappingInOneDirection(points.right, that._canvas, false, shiftCallback) || overlapped
                }

                function shiftFunction(box, length) {
                    return (0, _utils.getVerticallyShiftedAngularCoords)(box, -length, that._center)
                }

                function shiftInColumnFunction(box, length) {
                    return {
                        x: box.x,
                        y: box.y - length
                    }
                }
            },
            _setGeometry: function(_ref) {
                var x = _ref.centerX,
                    y = _ref.centerY,
                    radiusInner = _ref.radiusInner;
                this._center = {
                    x: x,
                    y: y
                };
                this._innerRadius = radiusInner
            },
            _disposeSeries: function(seriesIndex) {
                this.callBase.apply(this, arguments);
                this._abstractSeries = null
            },
            _legendDataField: "point",
            _legendItemTextField: "argument",
            _applyPointMarkersAutoHiding: _common.noop,
            _renderTrackers: _common.noop,
            _trackerType: "PieTracker",
            _createScrollBar: _common.noop,
            _updateAxesLayout: _common.noop,
            _applyClipRects: _common.noop,
            _appendAdditionalSeriesGroups: _common.noop,
            _prepareToRender: _common.noop,
            _isLegendInside: _common.noop,
            _renderAxes: _common.noop,
            _shrinkAxes: _common.noop,
            _isRotated: _common.noop,
            _seriesPopulatedHandlerCore: _common.noop,
            _reinitAxes: _common.noop,
            _correctAxes: _common.noop,
            _getExtraOptions: function() {
                var that = this;
                return {
                    startAngle: that.option("startAngle"),
                    innerRadius: that.option("innerRadius"),
                    segmentsDirection: that.option("segmentsDirection"),
                    type: that.option("type")
                }
            },
            getSizeGroup: function() {
                return this._themeManager.getOptions("sizeGroup")
            },
            getSizeGroupLayout: function() {
                return this._sizeGroupLayout || {}
            }
        });
        (0, _iterator.each)(OPTIONS_FOR_REFRESH_SERIES, function(_, name) {
            dxPieChart.prototype._optionChangesMap[name] = "REFRESH_SERIES_DATA_INIT"
        });
        dxPieChart.addPlugin(_annotations.plugins.core);
        dxPieChart.addPlugin(_annotations.plugins.pieChart);
        (0, _component_registrator.default)("dxPieChart", dxPieChart);
        var _default = dxPieChart;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/polar_chart.js ***!
      \*****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _utils = __webpack_require__( /*! ./core/utils */ 14);
        var _advanced_chart = __webpack_require__( /*! ./chart_components/advanced_chart */ 467);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _annotations = __webpack_require__( /*! ./core/annotations */ 228);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DEFAULT_PANE_NAME = "default";
        var DOUBLE_PI_ANGLE = 360;
        var dxPolarChart = _advanced_chart.AdvancedChart.inherit({
            _themeSection: "polar",
            _createPanes: function() {
                this.callBase();
                return [{
                    name: DEFAULT_PANE_NAME
                }]
            },
            _checkPaneName: function() {
                return true
            },
            _getAxisRenderingOptions: function(typeSelector) {
                var isArgumentAxis = "argumentAxis" === typeSelector;
                var type = isArgumentAxis ? "circular" : "linear";
                var useSpiderWeb = this.option("useSpiderWeb");
                if (useSpiderWeb) {
                    type += "Spider"
                }
                return {
                    axisType: "polarAxes",
                    drawingType: type
                }
            },
            _prepareAxisOptions: function(typeSelector, axisOptions) {
                var isArgumentAxis = "argumentAxis" === typeSelector;
                var themeManager = this._themeManager;
                var axisUserOptions = this.option("argumentAxis");
                var argumentAxisOptions = themeManager.getOptions("argumentAxis", axisUserOptions) || {};
                var startAngle = isFinite(argumentAxisOptions.startAngle) ? (0, _utils.normalizeAngle)(argumentAxisOptions.startAngle) : 0;
                return {
                    type: this.option("useSpiderWeb") && isArgumentAxis ? "discrete" : axisOptions.type,
                    isHorizontal: true,
                    showCustomBoundaryTicks: isArgumentAxis,
                    startAngle: startAngle,
                    endAngle: startAngle + 360
                }
            },
            _optionChangesMap: {
                useSpiderWeb: "AXES_AND_PANES"
            },
            _getExtraOptions: function() {
                return {
                    spiderWidget: this.option("useSpiderWeb")
                }
            },
            _prepareToRender: function() {
                this._appendAxesGroups();
                return {}
            },
            _calcCanvas: function() {
                var canvas = (0, _extend.extend)({}, this._canvas);
                var argumentAxis = this.getArgumentAxis();
                var margins = argumentAxis.getMargins();
                Object.keys(margins).forEach(function(margin) {
                    return canvas[margin] = canvas["original".concat(margin[0].toUpperCase()).concat(margin.slice(1))] + margins[margin]
                });
                return canvas
            },
            _renderAxes: function(drawOptions) {
                var that = this;
                var valueAxis = that._getValueAxis();
                var argumentAxis = that.getArgumentAxis();
                argumentAxis.draw(that._canvas);
                valueAxis.setSpiderTicks(argumentAxis.getSpiderTicks());
                var canvas = that._calcCanvas();
                argumentAxis.updateSize(canvas);
                valueAxis.draw(canvas);
                return canvas
            },
            _getValueAxis: function() {
                return this._valueAxes[0]
            },
            _shrinkAxes: function(sizeStorage) {
                var valueAxis = this._getValueAxis();
                var argumentAxis = this.getArgumentAxis();
                if (sizeStorage && (sizeStorage.width || sizeStorage.height)) {
                    argumentAxis.hideOuterElements();
                    var canvas = this._calcCanvas();
                    argumentAxis.updateSize(canvas);
                    valueAxis.updateSize(canvas)
                }
            },
            checkForMoreSpaceForPanesCanvas: function() {
                return this.layoutManager.needMoreSpaceForPanesCanvas([{
                    canvas: this.getArgumentAxis().getCanvas()
                }], this._isRotated())
            },
            _getLayoutTargets: function() {
                return [{
                    canvas: this._canvas
                }]
            },
            _getSeriesForPane: function() {
                return this.series
            },
            _applyClipRects: function() {
                var canvasClipRectID = this._getCanvasClipRectID();
                this._createClipPathForPane();
                this.getArgumentAxis().applyClipRects(this._getElementsClipRectID(), canvasClipRectID);
                this._getValueAxis().applyClipRects(this._getElementsClipRectID(), canvasClipRectID)
            },
            _createClipPathForPane: function() {
                var that = this;
                var valueAxis = that._getValueAxis();
                var center = valueAxis.getCenter();
                var radius = valueAxis.getRadius();
                var panesClipRects = that._panesClipRects;
                center = {
                    x: Math.round(center.x),
                    y: Math.round(center.y)
                };
                that._createClipCircle(panesClipRects.fixed, center.x, center.y, radius);
                that._createClipCircle(panesClipRects.base, center.x, center.y, radius);
                if (that.series.some(function(s) {
                        return s.areErrorBarsVisible()
                    })) {
                    that._createClipCircle(panesClipRects.wide, center.x, center.y, radius)
                } else {
                    panesClipRects.wide[0] = null
                }
            },
            _createClipCircle: function(clipArray, left, top, radius) {
                var that = this;
                var clipCircle = clipArray[0];
                if (!clipCircle) {
                    clipCircle = that._renderer.clipCircle(left, top, radius);
                    clipArray[0] = clipCircle
                } else {
                    clipCircle.attr({
                        cx: left,
                        cy: top,
                        r: radius
                    })
                }
            },
            _applyExtraSettings: function(series) {
                var wideClipRect = this._panesClipRects.wide[0];
                series.setClippingParams(this._panesClipRects.base[0].id, wideClipRect && wideClipRect.id, false, false)
            },
            getActualAngle: function(angle) {
                return this.getArgumentAxis().getOptions().inverted ? DOUBLE_PI_ANGLE - angle : angle
            },
            getXYFromPolar: function(angle, radius, argument, value) {
                var layoutInfo = {
                    angle: void 0,
                    radius: void 0,
                    x: void 0,
                    y: void 0
                };
                if (!(0, _type.isDefined)(angle) && !(0, _type.isDefined)(radius) && !(0, _type.isDefined)(argument) && !(0, _type.isDefined)(value)) {
                    return layoutInfo
                }
                var argAxis = this.getArgumentAxis();
                var startAngle = argAxis.getAngles()[0];
                var argAngle;
                var translatedRadius;
                if ((0, _type.isDefined)(argument)) {
                    argAngle = argAxis.getTranslator().translate(argument)
                } else {
                    if (isFinite(angle)) {
                        argAngle = this.getActualAngle(angle)
                    } else {
                        if (!(0, _type.isDefined)(angle)) {
                            argAngle = 0
                        }
                    }
                }
                if ((0, _type.isDefined)(value)) {
                    translatedRadius = this.getValueAxis().getTranslator().translate(value)
                } else {
                    if (isFinite(radius)) {
                        translatedRadius = radius
                    } else {
                        if (!(0, _type.isDefined)(radius)) {
                            translatedRadius = argAxis.getRadius()
                        }
                    }
                }
                if ((0, _type.isDefined)(argAngle) && (0, _type.isDefined)(translatedRadius)) {
                    var coords = (0, _utils.convertPolarToXY)(argAxis.getCenter(), startAngle, argAngle, translatedRadius);
                    (0, _extend.extend)(layoutInfo, coords, {
                        angle: argAxis.getTranslatedAngle(argAngle),
                        radius: translatedRadius
                    })
                }
                return layoutInfo
            },
            _applyPointMarkersAutoHiding: _common.noop,
            _createScrollBar: _common.noop,
            _isRotated: _common.noop,
            _getCrosshairOptions: _common.noop,
            _isLegendInside: _common.noop
        });
        dxPolarChart.addPlugin(_annotations.plugins.core);
        dxPolarChart.addPlugin(_annotations.plugins.polarChart);
        (0, _component_registrator.default)("dxPolarChart", dxPolarChart);
        var _default = dxPolarChart;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/linear_gauge.js ***!
      \******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _linear_gauge = _interopRequireDefault(__webpack_require__( /*! ./gauges/linear_gauge */ 944));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _linear_gauge.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/gauges/linear_gauge.js ***!
      \*************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        function _typeof(obj) {
            "@babel/helpers - typeof";
            if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
                _typeof = function(obj) {
                    return typeof obj
                }
            } else {
                _typeof = function(obj) {
                    return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
                }
            }
            return _typeof(obj)
        }
        exports.default = void 0;
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _object = __webpack_require__( /*! ../../core/utils/object */ 51);
        var _base_gauge = __webpack_require__( /*! ./base_gauge */ 189);
        var _common = __webpack_require__( /*! ./common */ 476);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var linearIndicators = _interopRequireWildcard(__webpack_require__( /*! ./linear_indicators */ 947));
        var _linear_range_container = _interopRequireDefault(__webpack_require__( /*! ./linear_range_container */ 948));

        function _getRequireWildcardCache() {
            if ("function" !== typeof WeakMap) {
                return null
            }
            var cache = new WeakMap;
            _getRequireWildcardCache = function() {
                return cache
            };
            return cache
        }

        function _interopRequireWildcard(obj) {
            if (obj && obj.__esModule) {
                return obj
            }
            if (null === obj || "object" !== _typeof(obj) && "function" !== typeof obj) {
                return {
                    "default": obj
                }
            }
            var cache = _getRequireWildcardCache();
            if (cache && cache.has(obj)) {
                return cache.get(obj)
            }
            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                    if (desc && (desc.get || desc.set)) {
                        Object.defineProperty(newObj, key, desc)
                    } else {
                        newObj[key] = obj[key]
                    }
                }
            }
            newObj.default = obj;
            if (cache) {
                cache.set(obj, newObj)
            }
            return newObj
        }

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _max = Math.max;
        var _min = Math.min;
        var _round = Math.round;
        var dxLinearGauge = _common.dxGauge.inherit({
            _rootClass: "dxg-linear-gauge",
            _factoryMethods: {
                rangeContainer: "createLinearRangeContainer",
                indicator: "createLinearIndicator"
            },
            _gridSpacingFactor: 25,
            _scaleTypes: {
                type: "xyAxes",
                drawingType: "linear"
            },
            _getTicksOrientation: function(scaleOptions) {
                return scaleOptions.isHorizontal ? scaleOptions.verticalOrientation : scaleOptions.horizontalOrientation
            },
            _getThemeManagerOptions: function() {
                var options = this.callBase.apply(this, arguments);
                options.subTheme = "_linear";
                return options
            },
            _getInvertedState: function() {
                return !this._area.vertical && this.option("rtlEnabled")
            },
            _prepareScaleSettings: function() {
                var scaleOptions = this.callBase();
                scaleOptions.inverted = this._getInvertedState();
                return scaleOptions
            },
            _updateScaleTickIndent: function(scaleOptions) {
                var indentFromTick = scaleOptions.label.indentFromTick;
                var length = scaleOptions.tick.length;
                var textParams = this._scale.measureLabels((0, _extend.extend)({}, this._canvas));
                var verticalTextCorrection = scaleOptions.isHorizontal ? textParams.height + textParams.y : 0;
                var isIndentPositive = indentFromTick > 0;
                var orientation;
                var textCorrection;
                var tickCorrection;
                if (scaleOptions.isHorizontal) {
                    orientation = isIndentPositive ? {
                        center: .5,
                        top: 0,
                        bottom: 1
                    } : {
                        center: .5,
                        top: 1,
                        bottom: 0
                    };
                    tickCorrection = length * orientation[scaleOptions.verticalOrientation];
                    textCorrection = textParams.y
                } else {
                    orientation = isIndentPositive ? {
                        center: .5,
                        left: 0,
                        right: 1
                    } : {
                        center: .5,
                        left: 1,
                        right: 0
                    };
                    tickCorrection = length * orientation[scaleOptions.horizontalOrientation];
                    textCorrection = -textParams.width
                }
                scaleOptions.label.indentFromAxis = -indentFromTick + (isIndentPositive ? -tickCorrection + textCorrection : tickCorrection - verticalTextCorrection);
                this._scale.updateOptions(scaleOptions)
            },
            _shiftScale: function(layout, scaleOptions) {
                var that = this;
                var canvas = (0, _extend.extend)({}, that._canvas);
                var isHorizontal = scaleOptions.isHorizontal;
                var scale = that._scale;
                canvas[isHorizontal ? "left" : "top"] = that._area[isHorizontal ? "startCoord" : "endCoord"];
                canvas[isHorizontal ? "right" : "bottom"] = canvas[isHorizontal ? "width" : "height"] - that._area[isHorizontal ? "endCoord" : "startCoord"];
                scale.draw(canvas);
                scale.shift({
                    left: -layout.x,
                    top: -layout.y
                })
            },
            _setupCodomain: function() {
                var that = this;
                var geometry = that.option("geometry") || {};
                var vertical = "vertical" === (0, _utils.normalizeEnum)(geometry.orientation);
                var initialStartCoord = -100;
                var initialEndCoord = 100;
                that._area = {
                    vertical: vertical,
                    x: 0,
                    y: 0,
                    startCoord: initialStartCoord,
                    endCoord: initialEndCoord
                };
                that._rangeContainer.vertical = vertical;
                that._translator.setInverted(that._getInvertedState());
                that._translator.setCodomain(initialStartCoord, initialEndCoord)
            },
            _getScaleLayoutValue: function() {
                return this._area[this._area.vertical ? "x" : "y"]
            },
            _getTicksCoefficients: function(options) {
                var coefs = {
                    inner: 0,
                    outer: 1
                };
                if (this._area.vertical) {
                    if ("left" === options.horizontalOrientation) {
                        coefs.inner = 1;
                        coefs.outer = 0
                    } else {
                        if ("center" === options.horizontalOrientation) {
                            coefs.inner = coefs.outer = .5
                        }
                    }
                } else {
                    if ("top" === options.verticalOrientation) {
                        coefs.inner = 1;
                        coefs.outer = 0
                    } else {
                        if ("center" === options.verticalOrientation) {
                            coefs.inner = coefs.outer = .5
                        }
                    }
                }
                return coefs
            },
            _correctScaleIndents: function(result, indentFromTick, textParams) {
                var vertical = this._area.vertical;
                if (indentFromTick >= 0) {
                    result.max += indentFromTick + textParams[vertical ? "width" : "height"]
                } else {
                    result.min -= -indentFromTick + textParams[vertical ? "width" : "height"]
                }
                result.indent = textParams[vertical ? "height" : "width"] / 2
            },
            _measureMainElements: function(elements, scaleMeasurement) {
                var that = this;
                var x = that._area.x;
                var y = that._area.y;
                var minBound = 1e3;
                var maxBound = 0;
                var indent = 0;
                var scale = that._scale;
                (0, _iterator.each)(elements.concat(scale), function(_, element) {
                    var bounds = element.measure ? element.measure({
                        x: x + element.getOffset(),
                        y: y + element.getOffset()
                    }) : scaleMeasurement;
                    void 0 !== bounds.max && (maxBound = _max(maxBound, bounds.max));
                    void 0 !== bounds.min && (minBound = _min(minBound, bounds.min));
                    bounds.indent > 0 && (indent = _max(indent, bounds.indent))
                });
                return {
                    minBound: minBound,
                    maxBound: maxBound,
                    indent: indent
                }
            },
            _applyMainLayout: function(elements, scaleMeasurement) {
                var that = this;
                var measurements = that._measureMainElements(elements, scaleMeasurement);
                var area = that._area;
                var rect;
                var offset;
                if (area.vertical) {
                    rect = selectRectBySizes(that._innerRect, {
                        width: measurements.maxBound - measurements.minBound
                    });
                    offset = (rect.left + rect.right) / 2 - (measurements.minBound + measurements.maxBound) / 2;
                    area.startCoord = rect.bottom - measurements.indent;
                    area.endCoord = rect.top + measurements.indent;
                    area.x = _round(area.x + offset)
                } else {
                    rect = selectRectBySizes(that._innerRect, {
                        height: measurements.maxBound - measurements.minBound
                    });
                    offset = (rect.top + rect.bottom) / 2 - (measurements.minBound + measurements.maxBound) / 2;
                    area.startCoord = rect.left + measurements.indent;
                    area.endCoord = rect.right - measurements.indent;
                    area.y = _round(area.y + offset)
                }
                that._translator.setCodomain(area.startCoord, area.endCoord);
                that._innerRect = rect
            },
            _getElementLayout: function(offset) {
                return {
                    x: _round(this._area.x + offset),
                    y: _round(this._area.y + offset)
                }
            },
            _getApproximateScreenRange: function() {
                var that = this;
                var area = that._area;
                var s = area.vertical ? that._canvas.height : that._canvas.width;
                s > area.totalSize && (s = area.totalSize);
                s = .8 * s;
                return s
            },
            _getDefaultSize: function() {
                var geometry = this.option("geometry") || {};
                if ("vertical" === geometry.orientation) {
                    return {
                        width: 100,
                        height: 300
                    }
                } else {
                    return {
                        width: 300,
                        height: 100
                    }
                }
            },
            _factory: (0, _object.clone)(_base_gauge.dxBaseGauge.prototype._factory)
        });

        function selectRectBySizes(srcRect, sizes, margins) {
            var rect = (0, _extend.extend)({}, srcRect);
            var step;
            margins = margins || {};
            if (sizes) {
                rect.left += margins.left || 0;
                rect.right -= margins.right || 0;
                rect.top += margins.top || 0;
                rect.bottom -= margins.bottom || 0;
                if (sizes.width > 0) {
                    step = (rect.right - rect.left - sizes.width) / 2;
                    if (step > 0) {
                        rect.left += step;
                        rect.right -= step
                    }
                }
                if (sizes.height > 0) {
                    step = (rect.bottom - rect.top - sizes.height) / 2;
                    if (step > 0) {
                        rect.top += step;
                        rect.bottom -= step
                    }
                }
            }
            return rect
        }
        var indicators = dxLinearGauge.prototype._factory.indicators = {};
        dxLinearGauge.prototype._factory.createIndicator = (0, _common.createIndicatorCreator)(indicators);
        indicators._default = linearIndicators._default;
        indicators.rectangle = linearIndicators.rectangle;
        indicators.rhombus = linearIndicators.rhombus;
        indicators.circle = linearIndicators.circle;
        indicators.trianglemarker = linearIndicators.trianglemarker;
        indicators.textcloud = linearIndicators.textcloud;
        indicators.rangebar = linearIndicators.rangebar;
        dxLinearGauge.prototype._factory.RangeContainer = _linear_range_container.default;
        (0, _component_registrator.default)("dxLinearGauge", dxLinearGauge);
        var _default = dxLinearGauge;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/gauges/theme_manager.js ***!
      \**************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _extend2 = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _base_theme_manager = __webpack_require__( /*! ../core/base_theme_manager */ 310);
        var _extend = _extend2.extend;
        var ThemeManager = _base_theme_manager.BaseThemeManager.inherit({
            ctor: function(options) {
                this.callBase.apply(this, arguments);
                this._subTheme = options.subTheme
            },
            _initializeTheme: function() {
                var that = this;
                var subTheme;
                if (that._subTheme) {
                    subTheme = _extend(true, {}, that._theme[that._subTheme], that._theme);
                    _extend(true, that._theme, subTheme)
                }
                that.callBase.apply(that, arguments)
            }
        });
        var _default = {
            ThemeManager: ThemeManager
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/gauges/tracker.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _class = _interopRequireDefault(__webpack_require__( /*! ../../core/class */ 15));
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _wheel = __webpack_require__( /*! ../../events/core/wheel */ 148);
        var _ready_callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/ready_callbacks */ 49));
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../../events/pointer */ 24));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var EVENT_NS = "gauge-tooltip";
        var TOOLTIP_HIDE_DELAY = 100;
        var ready = _ready_callbacks.default.add;
        var Tracker = _class.default.inherit({
            ctor: function(parameters) {
                var that = this;
                that._element = parameters.renderer.g().attr({
                    "class": "dxg-tracker",
                    stroke: "none",
                    "stroke-width": 0,
                    fill: "#000000",
                    opacity: 1e-4
                }).linkOn(parameters.container, {
                    name: "tracker",
                    after: "peripheral"
                });
                that._showTooltipCallback = function() {
                    var target = that._tooltipEvent.target;
                    var data_target = target["gauge-data-target"];
                    var data_info = target["gauge-data-info"];
                    that._targetEvent = null;
                    if (that._tooltipTarget !== target) {
                        var callback = function(result) {
                            result && (that._tooltipTarget = target)
                        };
                        callback(that._callbacks["tooltip-show"](data_target, data_info, callback))
                    }
                };
                that._hideTooltipCallback = function() {
                    that._hideTooltipTimeout = null;
                    that._targetEvent = null;
                    if (that._tooltipTarget) {
                        that._callbacks["tooltip-hide"]();
                        that._tooltipTarget = null
                    }
                };
                that._dispose = function() {
                    clearTimeout(that._hideTooltipTimeout);
                    that._showTooltipCallback = that._hideTooltipCallback = that._dispose = null
                }
            },
            dispose: function() {
                var that = this;
                that._dispose();
                that.deactivate();
                that._element.off("." + EVENT_NS);
                that._element.linkOff();
                that._element = that._context = that._callbacks = null;
                return that
            },
            activate: function() {
                this._element.linkAppend();
                return this
            },
            deactivate: function() {
                this._element.linkRemove().clear();
                return this
            },
            attach: function(element, target, info) {
                element.data({
                    "gauge-data-target": target,
                    "gauge-data-info": info
                }).append(this._element);
                return this
            },
            detach: function(element) {
                element.remove();
                return this
            },
            setTooltipState: function(state) {
                var that = this;
                that._element.off("." + EVENT_NS);
                if (state) {
                    var data = {
                        tracker: that
                    };
                    that._element.on((0, _index.addNamespace)([_pointer.default.move], EVENT_NS), data, handleTooltipMouseOver).on((0, _index.addNamespace)([_pointer.default.out], EVENT_NS), data, handleTooltipMouseOut).on((0, _index.addNamespace)([_pointer.default.down], EVENT_NS), data, handleTooltipTouchStart).on((0, _index.addNamespace)([_pointer.default.up], EVENT_NS), data, handleTooltipTouchEnd).on((0, _index.addNamespace)([_wheel.name], EVENT_NS), data, handleTooltipMouseWheel)
                }
                return that
            },
            setCallbacks: function(callbacks) {
                this._callbacks = callbacks;
                return this
            },
            _showTooltip: function(event) {
                var that = this;
                clearTimeout(that._hideTooltipTimeout);
                that._hideTooltipTimeout = null;
                if (that._tooltipTarget === event.target) {
                    return
                }
                that._tooltipEvent = event;
                that._showTooltipCallback()
            },
            _hideTooltip: function(delay) {
                var that = this;
                clearTimeout(that._hideTooltipTimeout);
                if (delay) {
                    that._hideTooltipTimeout = setTimeout(that._hideTooltipCallback, delay)
                } else {
                    that._hideTooltipCallback()
                }
            }
        });
        var active_touch_tooltip_tracker = null;

        function handleTooltipMouseOver(event) {
            var tracker = event.data.tracker;
            tracker._x = event.pageX;
            tracker._y = event.pageY;
            tracker._showTooltip(event)
        }

        function handleTooltipMouseOut(event) {
            event.data.tracker._hideTooltip(TOOLTIP_HIDE_DELAY)
        }

        function handleTooltipMouseWheel(event) {
            event.data.tracker._hideTooltip()
        }

        function handleTooltipTouchStart(event) {
            var tracker = active_touch_tooltip_tracker = event.data.tracker;
            tracker._touch = true;
            handleTooltipMouseOver(event)
        }

        function handleTooltipTouchEnd() {
            active_touch_tooltip_tracker._touch = false
        }

        function handleDocumentTooltipTouchStart(event) {
            var tracker = active_touch_tooltip_tracker;
            if (tracker && !tracker._touch) {
                tracker._hideTooltip(TOOLTIP_HIDE_DELAY);
                active_touch_tooltip_tracker = null
            }
        }
        ready(function() {
            _events_engine.default.subscribeGlobal(_dom_adapter.default.getDocument(), (0, _index.addNamespace)([_pointer.default.down], EVENT_NS), handleDocumentTooltipTouchStart)
        });
        var _default = Tracker;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/gauges/linear_indicators.js ***!
      \******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.textcloud = exports.trianglemarker = exports.circle = exports.rhombus = exports.rectangle = exports.rangebar = exports._default = void 0;
        var _base_indicators = __webpack_require__( /*! ./base_indicators */ 319);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _Number = Number;
        var SimpleIndicator = _base_indicators.BaseIndicator.inherit({
            _move: function() {
                var that = this;
                var delta = that._actualPosition - that._zeroPosition;
                that._rootElement.move(that.vertical ? 0 : delta, that.vertical ? delta : 0);
                that._trackerElement && that._trackerElement.move(that.vertical ? 0 : delta, that.vertical ? delta : 0)
            },
            _isEnabled: function() {
                this.vertical = this._options.vertical;
                return this._options.length > 0 && this._options.width > 0
            },
            _isVisible: function() {
                return true
            },
            _getTrackerSettings: function() {
                var options = this._options;
                var x1;
                var x2;
                var y1;
                var y2;
                var width = options.width / 2;
                var length = options.length / 2;
                var p = this._zeroPosition;
                width > 10 || (width = 10);
                length > 10 || (length = 10);
                if (this.vertical) {
                    x1 = options.x - length;
                    x2 = options.x + length;
                    y1 = p + width;
                    y2 = p - width
                } else {
                    x1 = p - width;
                    x2 = p + width;
                    y1 = options.y + length;
                    y2 = options.y - length
                }
                return {
                    points: [x1, y1, x1, y2, x2, y2, x2, y1]
                }
            },
            _render: function() {
                var that = this;
                that._zeroPosition = that._translator.getCodomainStart()
            },
            _clear: function() {
                delete this._element
            },
            measure: function(layout) {
                var p = this.vertical ? layout.x : layout.y;
                return {
                    min: p - this._options.length / 2,
                    max: p + this._options.length / 2
                }
            },
            getTooltipParameters: function() {
                var that = this;
                var options = that._options;
                var p = that._actualPosition;
                var parameters = {
                    x: p,
                    y: p,
                    value: that._currentValue,
                    color: options.color,
                    offset: options.width / 2
                };
                that.vertical ? parameters.x = options.x : parameters.y = options.y;
                return parameters
            }
        });
        var rectangle = SimpleIndicator.inherit({
            _render: function() {
                var that = this;
                var options = that._options;
                var x1;
                var x2;
                var y1;
                var y2;
                that.callBase();
                var p = that._zeroPosition;
                if (that.vertical) {
                    x1 = options.x - options.length / 2;
                    x2 = options.x + options.length / 2;
                    y1 = p + options.width / 2;
                    y2 = p - options.width / 2
                } else {
                    x1 = p - options.width / 2;
                    x2 = p + options.width / 2;
                    y1 = options.y + options.length / 2;
                    y2 = options.y - options.length / 2
                }
                that._element = that._element || that._renderer.path([], "area").append(that._rootElement);
                that._element.attr({
                    points: [x1, y1, x1, y2, x2, y2, x2, y1]
                })
            }
        });
        exports.rectangle = rectangle;
        var rhombus = SimpleIndicator.inherit({
            _render: function() {
                var that = this;
                var options = that._options;
                var x;
                var y;
                var dx;
                var dy;
                that.callBase();
                if (that.vertical) {
                    x = options.x;
                    y = that._zeroPosition;
                    dx = options.length / 2 || 0;
                    dy = options.width / 2 || 0
                } else {
                    x = that._zeroPosition;
                    y = options.y;
                    dx = options.width / 2 || 0;
                    dy = options.length / 2 || 0
                }
                that._element = that._element || that._renderer.path([], "area").append(that._rootElement);
                that._element.attr({
                    points: [x - dx, y, x, y - dy, x + dx, y, x, y + dy]
                })
            }
        });
        exports.rhombus = rhombus;
        var circle = SimpleIndicator.inherit({
            _render: function() {
                var that = this;
                var options = that._options;
                var x;
                var y;
                that.callBase();
                if (that.vertical) {
                    x = options.x;
                    y = that._zeroPosition
                } else {
                    x = that._zeroPosition;
                    y = options.y
                }
                var r = options.length / 2 || 0;
                that._element = that._element || that._renderer.circle().append(that._rootElement);
                that._element.attr({
                    cx: x,
                    cy: y,
                    r: r
                })
            }
        });
        exports.circle = circle;
        var triangleMarker = SimpleIndicator.inherit({
            _isEnabled: function() {
                var that = this;
                that.vertical = that._options.vertical;
                that._inverted = that.vertical ? "right" === (0, _utils.normalizeEnum)(that._options.horizontalOrientation) : "bottom" === (0, _utils.normalizeEnum)(that._options.verticalOrientation);
                return that._options.length > 0 && that._options.width > 0
            },
            _isVisible: function() {
                return true
            },
            _render: function() {
                var that = this;
                var options = that._options;
                var x1;
                var x2;
                var y1;
                var y2;
                var settings = {
                    stroke: "none",
                    "stroke-width": 0,
                    "stroke-linecap": "square"
                };
                that.callBase();
                if (that.vertical) {
                    x1 = options.x;
                    y1 = that._zeroPosition;
                    x2 = x1 + _Number(that._inverted ? options.length : -options.length);
                    settings.points = [x1, y1, x2, y1 - options.width / 2, x2, y1 + options.width / 2]
                } else {
                    y1 = options.y;
                    x1 = that._zeroPosition;
                    y2 = y1 + _Number(that._inverted ? options.length : -options.length);
                    settings.points = [x1, y1, x1 - options.width / 2, y2, x1 + options.width / 2, y2]
                }
                if (options.space > 0) {
                    settings["stroke-width"] = Math.min(options.space, options.width / 4) || 0;
                    settings.stroke = settings["stroke-width"] > 0 ? options.containerBackgroundColor || "none" : "none"
                }
                that._element = that._element || that._renderer.path([], "area").append(that._rootElement);
                that._element.attr(settings).sharp()
            },
            _getTrackerSettings: function() {
                var that = this;
                var options = that._options;
                var width = options.width / 2;
                var length = _Number(options.length);
                var x1;
                var x2;
                var y1;
                var y2;
                var result;
                width > 10 || (width = 10);
                length > 20 || (length = 20);
                if (that.vertical) {
                    x1 = x2 = options.x;
                    x2 = x1 + (that._inverted ? length : -length);
                    y1 = that._zeroPosition + width;
                    y2 = that._zeroPosition - width;
                    result = [x1, y1, x2, y1, x2, y2, x1, y2]
                } else {
                    y1 = options.y;
                    y2 = y1 + (that._inverted ? length : -length);
                    x1 = that._zeroPosition - width;
                    x2 = that._zeroPosition + width;
                    result = [x1, y1, x1, y2, x2, y2, x2, y1]
                }
                return {
                    points: result
                }
            },
            measure: function(layout) {
                var that = this;
                var length = _Number(that._options.length);
                var minBound;
                var maxBound;
                if (that.vertical) {
                    minBound = maxBound = layout.x;
                    if (that._inverted) {
                        maxBound = minBound + length
                    } else {
                        minBound = maxBound - length
                    }
                } else {
                    minBound = maxBound = layout.y;
                    if (that._inverted) {
                        maxBound = minBound + length
                    } else {
                        minBound = maxBound - length
                    }
                }
                return {
                    min: minBound,
                    max: maxBound,
                    indent: that._options.width / 2
                }
            },
            getTooltipParameters: function() {
                var that = this;
                var options = that._options;
                var s = (that._inverted ? options.length : -options.length) / 2;
                var parameters = that.callBase();
                that.vertical ? parameters.x += s : parameters.y += s;
                parameters.offset = options.length / 2;
                return parameters
            }
        });
        exports.trianglemarker = triangleMarker;
        var textCloud = _base_indicators.BaseTextCloudMarker.inherit({
            _isEnabled: function() {
                var that = this;
                that.vertical = that._options.vertical;
                that._inverted = that.vertical ? "right" === (0, _utils.normalizeEnum)(that._options.horizontalOrientation) : "bottom" === (0, _utils.normalizeEnum)(that._options.verticalOrientation);
                return true
            },
            _isVisible: function() {
                return true
            },
            _getTextCloudOptions: function() {
                var that = this;
                var x = that._actualPosition;
                var y = that._actualPosition;
                var type;
                if (that.vertical) {
                    x = that._options.x;
                    type = that._inverted ? "top-left" : "top-right"
                } else {
                    y = that._options.y;
                    type = that._inverted ? "right-top" : "right-bottom"
                }
                return {
                    x: x,
                    y: y,
                    type: type
                }
            },
            measure: function(layout) {
                var that = this;
                var minBound;
                var maxBound;
                var arrowLength = _Number(that._options.arrowLength) || 0;
                that._measureText();
                if (that.vertical) {
                    if (that._inverted) {
                        minBound = layout.x;
                        maxBound = layout.x + arrowLength + that._textFullWidth
                    } else {
                        minBound = layout.x - arrowLength - that._textFullWidth;
                        maxBound = layout.x
                    }
                } else {
                    if (that._inverted) {
                        minBound = layout.y;
                        maxBound = layout.y + arrowLength + that._textFullHeight
                    } else {
                        minBound = layout.y - arrowLength - that._textFullHeight;
                        maxBound = layout.y
                    }
                }
                return {
                    min: minBound,
                    max: maxBound,
                    indent: 0
                }
            },
            _correctCloudType: function(type, _ref, _ref2) {
                var x = _ref.x,
                    y = _ref.y;
                var width = _ref2.width,
                    height = _ref2.height;
                if ("right-top" === type || "right-bottom" === type) {
                    if (x - width < this._translator.getCodomainStart()) {
                        type = "left-".concat(type.split("-")[1])
                    }
                } else {
                    if ("top-left" === type || "top-right" === type) {
                        if (y + height > this._translator.getCodomainStart()) {
                            type = "bottom-".concat(type.split("-")[1])
                        }
                    }
                }
                return type
            }
        });
        exports.textcloud = textCloud;
        var rangeBar = _base_indicators.BaseRangeBar.inherit({
            _isEnabled: function() {
                var that = this;
                that.vertical = that._options.vertical;
                that._inverted = that.vertical ? "right" === (0, _utils.normalizeEnum)(that._options.horizontalOrientation) : "bottom" === (0, _utils.normalizeEnum)(that._options.verticalOrientation);
                return that._options.size > 0
            },
            _isVisible: function() {
                return true
            },
            _createBarItem: function() {
                return this._renderer.path([], "area").append(this._rootElement)
            },
            _createTracker: function() {
                return this._renderer.path([], "area")
            },
            _setBarSides: function() {
                var that = this;
                var options = that._options;
                var size = _Number(options.size);
                var minSide;
                var maxSide;
                if (that.vertical) {
                    if (that._inverted) {
                        minSide = options.x;
                        maxSide = options.x + size
                    } else {
                        minSide = options.x - size;
                        maxSide = options.x
                    }
                } else {
                    if (that._inverted) {
                        minSide = options.y;
                        maxSide = options.y + size
                    } else {
                        minSide = options.y - size;
                        maxSide = options.y
                    }
                }
                that._minSide = minSide;
                that._maxSide = maxSide;
                that._minBound = minSide;
                that._maxBound = maxSide
            },
            _getSpace: function() {
                var options = this._options;
                return options.space > 0 ? _Number(options.space) : 0
            },
            _isTextVisible: function() {
                var textOptions = this._options.text || {};
                return textOptions.indent > 0 || textOptions.indent < 0
            },
            _getTextAlign: function() {
                return this.vertical ? this._options.text.indent > 0 ? "left" : "right" : "center"
            },
            _setTextItemsSides: function() {
                var that = this;
                var indent = _Number(that._options.text.indent);
                if (indent > 0) {
                    that._lineStart = that._maxSide;
                    that._lineEnd = that._maxSide + indent;
                    that._textPosition = that._lineEnd + (that.vertical ? 2 : that._textHeight / 2);
                    that._maxBound = that._textPosition + (that.vertical ? that._textWidth : that._textHeight / 2)
                } else {
                    if (indent < 0) {
                        that._lineStart = that._minSide;
                        that._lineEnd = that._minSide + indent;
                        that._textPosition = that._lineEnd - (that.vertical ? 2 : that._textHeight / 2);
                        that._minBound = that._textPosition - (that.vertical ? that._textWidth : that._textHeight / 2)
                    }
                }
            },
            _getPositions: function() {
                var that = this;
                var startPosition = that._startPosition;
                var endPosition = that._endPosition;
                var space = that._space;
                var basePosition = that._basePosition;
                var actualPosition = that._actualPosition;
                var mainPosition1;
                var mainPosition2;
                var backPosition1;
                var backPosition2;
                if (startPosition < endPosition) {
                    if (basePosition < actualPosition) {
                        mainPosition1 = basePosition;
                        mainPosition2 = actualPosition
                    } else {
                        mainPosition1 = actualPosition;
                        mainPosition2 = basePosition
                    }
                    backPosition1 = mainPosition1 - space;
                    backPosition2 = mainPosition2 + space
                } else {
                    if (basePosition > actualPosition) {
                        mainPosition1 = basePosition;
                        mainPosition2 = actualPosition
                    } else {
                        mainPosition1 = actualPosition;
                        mainPosition2 = basePosition
                    }
                    backPosition1 = mainPosition1 + space;
                    backPosition2 = mainPosition2 - space
                }
                return {
                    start: startPosition,
                    end: endPosition,
                    main1: mainPosition1,
                    main2: mainPosition2,
                    back1: backPosition1,
                    back2: backPosition2
                }
            },
            _buildItemSettings: function(from, to) {
                var that = this;
                var side1 = that._minSide;
                var side2 = that._maxSide;
                var points = that.vertical ? [side1, from, side1, to, side2, to, side2, from] : [from, side1, from, side2, to, side2, to, side1];
                return {
                    points: points
                }
            },
            _updateTextPosition: function() {
                var that = this;
                that._text.attr(that.vertical ? {
                    x: that._textPosition,
                    y: that._actualPosition + that._textVerticalOffset
                } : {
                    x: that._actualPosition,
                    y: that._textPosition + that._textVerticalOffset
                })
            },
            _updateLinePosition: function() {
                var that = this;
                var actualPosition = that._actualPosition;
                var side1;
                var side2;
                var points;
                if (that.vertical) {
                    if (that._basePosition >= actualPosition) {
                        side1 = actualPosition;
                        side2 = actualPosition + 2
                    } else {
                        side1 = actualPosition - 2;
                        side2 = actualPosition
                    }
                    points = [that._lineStart, side1, that._lineStart, side2, that._lineEnd, side2, that._lineEnd, side1]
                } else {
                    if (that._basePosition <= actualPosition) {
                        side1 = actualPosition - 2;
                        side2 = actualPosition
                    } else {
                        side1 = actualPosition;
                        side2 = actualPosition + 2
                    }
                    points = [side1, that._lineStart, side1, that._lineEnd, side2, that._lineEnd, side2, that._lineStart]
                }
                that._line.attr({
                    points: points
                }).sharp()
            },
            _getTooltipPosition: function() {
                var that = this;
                var crossCenter = (that._minSide + that._maxSide) / 2;
                var alongCenter = (that._basePosition + that._actualPosition) / 2;
                return that.vertical ? {
                    x: crossCenter,
                    y: alongCenter
                } : {
                    x: alongCenter,
                    y: crossCenter
                }
            },
            measure: function(layout) {
                var that = this;
                var size = _Number(that._options.size);
                var textIndent = _Number(that._options.text.indent);
                var minBound;
                var maxBound;
                var indent;
                that._measureText();
                if (that.vertical) {
                    minBound = maxBound = layout.x;
                    if (that._inverted) {
                        maxBound += size
                    } else {
                        minBound -= size
                    }
                    if (that._hasText) {
                        indent = that._textHeight / 2;
                        if (textIndent > 0) {
                            maxBound += textIndent + that._textWidth
                        }
                        if (textIndent < 0) {
                            minBound += textIndent - that._textWidth
                        }
                    }
                } else {
                    minBound = maxBound = layout.y;
                    if (that._inverted) {
                        maxBound += size
                    } else {
                        minBound -= size
                    }
                    if (that._hasText) {
                        indent = that._textWidth / 2;
                        if (textIndent > 0) {
                            maxBound += textIndent + that._textHeight
                        }
                        if (textIndent < 0) {
                            minBound += textIndent - that._textHeight
                        }
                    }
                }
                return {
                    min: minBound,
                    max: maxBound,
                    indent: indent
                }
            }
        });
        exports.rangebar = exports._default = rangeBar
    },
    /*!***********************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/gauges/linear_range_container.js ***!
      \***********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _base_range_container = _interopRequireDefault(__webpack_require__( /*! ./base_range_container */ 477));
        var _utils = __webpack_require__( /*! ../core/utils */ 14);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _Number = Number;
        var _max = Math.max;
        var LinearRangeContainer = _base_range_container.default.inherit({
            _processOptions: function() {
                var that = this;
                that.vertical = that._options.vertical;
                that._inner = that._outer = 0;
                if (that.vertical) {
                    switch ((0, _utils.normalizeEnum)(that._options.horizontalOrientation)) {
                        case "left":
                            that._inner = 1;
                            break;
                        case "center":
                            that._inner = that._outer = .5;
                            break;
                        default:
                            that._outer = 1
                    }
                } else {
                    switch ((0, _utils.normalizeEnum)(that._options.verticalOrientation)) {
                        case "top":
                            that._inner = 1;
                            break;
                        case "center":
                            that._inner = that._outer = .5;
                            break;
                        default:
                            that._outer = 1
                    }
                }
            },
            _isVisible: function() {
                return true
            },
            _createRange: function(range, layout) {
                var that = this;
                var inner = that._inner;
                var outer = that._outer;
                var startPosition = that._translator.translate(range.start);
                var endPosition = that._translator.translate(range.end);
                var points;
                var x = layout.x;
                var y = layout.y;
                var startWidth = range.startWidth;
                var endWidth = range.endWidth;
                if (that.vertical) {
                    points = [x - startWidth * inner, startPosition, x - endWidth * inner, endPosition, x + endWidth * outer, endPosition, x + startWidth * outer, startPosition]
                } else {
                    points = [startPosition, y + startWidth * outer, startPosition, y - startWidth * inner, endPosition, y - endWidth * inner, endPosition, y + endWidth * outer]
                }
                return that._renderer.path(points, "area")
            },
            measure: function(layout) {
                var result = {};
                var width;
                result.min = result.max = layout[this.vertical ? "x" : "y"];
                width = this._options.width;
                width = _Number(width) || _max(_Number(width.start), _Number(width.end));
                result.min -= this._inner * width;
                result.max += this._outer * width;
                return result
            }
        });
        var _default = LinearRangeContainer;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/circular_gauge.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _circular_gauge = _interopRequireDefault(__webpack_require__( /*! ./gauges/circular_gauge */ 478));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _circular_gauge.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/gauges/circular_indicators.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.rangebar = exports.textcloud = exports.trianglemarker = exports.twocolorneedle = exports.triangleneedle = exports.rectangleneedle = exports._default = void 0;
        var _base_indicators = __webpack_require__( /*! ./base_indicators */ 319);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _Number = Number;
        var _getCosAndSin = _utils.getCosAndSin;
        var _convertAngleToRendererSpace = _utils.convertAngleToRendererSpace;
        var SimpleIndicator = _base_indicators.BaseIndicator.inherit({
            _move: function() {
                var that = this;
                var options = that._options;
                var angle = _convertAngleToRendererSpace(that._actualPosition);
                that._rootElement.rotate(angle, options.x, options.y);
                that._trackerElement && that._trackerElement.rotate(angle, options.x, options.y)
            },
            _isEnabled: function() {
                return this._options.width > 0
            },
            _isVisible: function(layout) {
                return layout.radius - _Number(this._options.indentFromCenter) > 0
            },
            _getTrackerSettings: function() {
                var options = this._options;
                var radius = this._getRadius();
                var indentFromCenter = this._getIndentFromCenter();
                var x = options.x;
                var y = options.y - (radius + indentFromCenter) / 2;
                var width = options.width / 2;
                var length = (radius - indentFromCenter) / 2;
                width > 10 || (width = 10);
                length > 10 || (length = 10);
                return {
                    points: [x - width, y - length, x - width, y + length, x + width, y + length, x + width, y - length]
                }
            },
            _render: function() {
                var that = this;
                that._renderPointer()
            },
            _clearPointer: function() {
                delete this._element
            },
            _clear: function() {
                this._clearPointer()
            },
            _getIndentFromCenter: function(radius) {
                return Number(this._options.indentFromCenter) || 0
            },
            _getRadius: function() {
                return 0
            },
            measure: function(layout) {
                var result = {
                    max: layout.radius
                };
                if (this._options.indentFromCenter < 0) {
                    result.inverseHorizontalOffset = result.inverseVerticalOffset = -_Number(this._options.indentFromCenter)
                }
                return result
            },
            getTooltipParameters: function() {
                var options = this._options;
                var cosSin = _getCosAndSin(this._actualPosition);
                var r = (this._getRadius() + this._getIndentFromCenter()) / 2;
                return {
                    x: options.x + cosSin.cos * r,
                    y: options.y - cosSin.sin * r,
                    value: this._currentValue,
                    color: options.color,
                    offset: options.width / 2
                }
            }
        });
        var NeedleIndicator = SimpleIndicator.inherit({
            _isVisible: function(layout) {
                var indentFromCenter = this._adjustOffset(Number(this._options.indentFromCenter), layout.radius);
                var offset = this._adjustOffset(Number(this._options.offset), layout.radius);
                return layout.radius - indentFromCenter - offset > 0
            },
            getOffset: function() {
                return 0
            },
            _adjustOffset: function(value, radius) {
                var minRadius = Number(this._options.beginAdaptingAtRadius);
                var diff = radius / minRadius;
                if (diff < 1) {
                    value = Math.floor(value * diff)
                }
                return value || 0
            },
            _getIndentFromCenter: function(radius) {
                return this._adjustOffset(Number(this._options.indentFromCenter), this._options.radius)
            },
            _getRadius: function() {
                var options = this._options;
                return options.radius - this._adjustOffset(Number(options.offset), options.radius)
            },
            _renderSpindle: function() {
                var that = this;
                var options = that._options;
                var radius = options.radius;
                var spindleSize = 2 * this._adjustOffset(_Number(options.spindleSize) / 2, radius);
                var gapSize = 2 * this._adjustOffset(_Number(options.spindleGapSize) / 2, radius) || 0;
                if (gapSize > 0) {
                    gapSize = gapSize <= spindleSize ? gapSize : spindleSize
                }
                if (spindleSize > 0) {
                    that._spindleOuter = that._spindleOuter || that._renderer.circle().append(that._rootElement);
                    that._spindleInner = that._spindleInner || that._renderer.circle().append(that._rootElement);
                    that._spindleOuter.attr({
                        "class": "dxg-spindle-border",
                        cx: options.x,
                        cy: options.y,
                        r: spindleSize / 2
                    });
                    that._spindleInner.attr({
                        "class": "dxg-spindle-hole",
                        cx: options.x,
                        cy: options.y,
                        r: gapSize / 2,
                        fill: options.containerBackgroundColor
                    })
                }
            },
            _render: function() {
                var that = this;
                that.callBase();
                that._renderSpindle()
            },
            _clear: function() {
                this.callBase();
                delete this._spindleOuter;
                delete this._spindleInner
            }
        });
        var rectangleNeedle = NeedleIndicator.inherit({
            _renderPointer: function() {
                var that = this;
                var options = that._options;
                var y2 = options.y - this._getRadius();
                var y1 = options.y - this._getIndentFromCenter();
                var x1 = options.x - options.width / 2;
                var x2 = x1 + _Number(options.width);
                that._element = that._element || that._renderer.path([], "area").append(that._rootElement);
                that._element.attr({
                    points: [x1, y1, x1, y2, x2, y2, x2, y1]
                })
            }
        });
        exports.rectangleneedle = exports._default = rectangleNeedle;
        var triangleNeedle = NeedleIndicator.inherit({
            _renderPointer: function() {
                var that = this;
                var options = that._options;
                var y2 = options.y - this._getRadius();
                var y1 = options.y - this._getIndentFromCenter();
                var x1 = options.x - options.width / 2;
                var x2 = options.x + options.width / 2;
                that._element = that._element || that._renderer.path([], "area").append(that._rootElement);
                that._element.attr({
                    points: [x1, y1, options.x, y2, x2, y1]
                })
            }
        });
        exports.triangleneedle = triangleNeedle;
        var twoColorNeedle = NeedleIndicator.inherit({
            _renderPointer: function() {
                var that = this;
                var options = that._options;
                var x1 = options.x - options.width / 2;
                var x2 = options.x + options.width / 2;
                var y4 = options.y - this._getRadius();
                var y1 = options.y - this._getIndentFromCenter();
                var fraction = _Number(options.secondFraction) || 0;
                var y2;
                var y3;
                if (fraction >= 1) {
                    y2 = y3 = y1
                } else {
                    if (fraction <= 0) {
                        y2 = y3 = y4
                    } else {
                        y3 = y4 + (y1 - y4) * fraction;
                        y2 = y3 + _Number(options.space)
                    }
                }
                that._firstElement = that._firstElement || that._renderer.path([], "area").append(that._rootElement);
                that._spaceElement = that._spaceElement || that._renderer.path([], "area").append(that._rootElement);
                that._secondElement = that._secondElement || that._renderer.path([], "area").append(that._rootElement);
                that._firstElement.attr({
                    points: [x1, y1, x1, y2, x2, y2, x2, y1]
                });
                that._spaceElement.attr({
                    points: [x1, y2, x1, y3, x2, y3, x2, y2],
                    "class": "dxg-hole",
                    fill: options.containerBackgroundColor
                });
                that._secondElement.attr({
                    points: [x1, y3, x1, y4, x2, y4, x2, y3],
                    "class": "dxg-part",
                    fill: options.secondColor
                })
            },
            _clearPointer: function() {
                delete this._firstElement;
                delete this._secondElement;
                delete this._spaceElement
            }
        });
        exports.twocolorneedle = twoColorNeedle;
        var triangleMarker = SimpleIndicator.inherit({
            _isEnabled: function() {
                return this._options.length > 0 && this._options.width > 0
            },
            _isVisible: function(layout) {
                return layout.radius > 0
            },
            _render: function() {
                var that = this;
                var options = that._options;
                var x = options.x;
                var y1 = options.y - options.radius;
                var dx = options.width / 2 || 0;
                var y2 = y1 - _Number(options.length);
                that._element = that._element || that._renderer.path([], "area").append(that._rootElement);
                var settings = {
                    points: [x, y1, x - dx, y2, x + dx, y2],
                    stroke: "none",
                    "stroke-width": 0,
                    "stroke-linecap": "square"
                };
                if (options.space > 0) {
                    settings["stroke-width"] = Math.min(options.space, options.width / 4) || 0;
                    settings.stroke = settings["stroke-width"] > 0 ? options.containerBackgroundColor || "none" : "none"
                }
                that._element.attr(settings).sharp()
            },
            _clear: function() {
                delete this._element
            },
            _getTrackerSettings: function() {
                var options = this._options;
                var x = options.x;
                var y = options.y - options.radius - options.length / 2;
                var width = options.width / 2;
                var length = options.length / 2;
                width > 10 || (width = 10);
                length > 10 || (length = 10);
                return {
                    points: [x - width, y - length, x - width, y + length, x + width, y + length, x + width, y - length]
                }
            },
            measure: function(layout) {
                return {
                    min: layout.radius,
                    max: layout.radius + _Number(this._options.length)
                }
            },
            getTooltipParameters: function() {
                var options = this._options;
                var cosSin = _getCosAndSin(this._actualPosition);
                var r = options.radius + options.length / 2;
                var parameters = this.callBase();
                parameters.x = options.x + cosSin.cos * r;
                parameters.y = options.y - cosSin.sin * r;
                parameters.offset = options.length / 2;
                return parameters
            }
        });
        exports.trianglemarker = triangleMarker;
        var textCloud = _base_indicators.BaseTextCloudMarker.inherit({
            _isEnabled: function() {
                return true
            },
            _isVisible: function(layout) {
                return layout.radius > 0
            },
            _getTextCloudOptions: function() {
                var that = this;
                var cosSin = _getCosAndSin(that._actualPosition);
                var nAngle = (0, _utils.normalizeAngle)(that._actualPosition);
                return {
                    x: that._options.x + cosSin.cos * that._options.radius,
                    y: that._options.y - cosSin.sin * that._options.radius,
                    type: nAngle > 270 ? "left-top" : nAngle > 180 ? "top-right" : nAngle > 90 ? "right-bottom" : "bottom-left"
                }
            },
            measure: function(layout) {
                var that = this;
                var arrowLength = _Number(that._options.arrowLength) || 0;
                that._measureText();
                var verticalOffset = that._textFullHeight + arrowLength;
                var horizontalOffset = that._textFullWidth + arrowLength;
                return {
                    min: layout.radius,
                    max: layout.radius,
                    horizontalOffset: horizontalOffset,
                    verticalOffset: verticalOffset,
                    inverseHorizontalOffset: horizontalOffset,
                    inverseVerticalOffset: verticalOffset
                }
            }
        });
        exports.textcloud = textCloud;
        var rangeBar = _base_indicators.BaseRangeBar.inherit({
            _isEnabled: function() {
                return this._options.size > 0
            },
            _isVisible: function(layout) {
                return layout.radius - _Number(this._options.size) > 0
            },
            _createBarItem: function() {
                return this._renderer.arc().attr({
                    "stroke-linejoin": "round"
                }).append(this._rootElement)
            },
            _createTracker: function() {
                return this._renderer.arc().attr({
                    "stroke-linejoin": "round"
                })
            },
            _setBarSides: function() {
                var that = this;
                that._maxSide = that._options.radius;
                that._minSide = that._maxSide - _Number(that._options.size)
            },
            _getSpace: function() {
                var options = this._options;
                return options.space > 0 ? 180 * options.space / options.radius / Math.PI : 0
            },
            _isTextVisible: function() {
                var options = this._options.text || {};
                return options.indent > 0
            },
            _setTextItemsSides: function() {
                var that = this;
                var options = that._options;
                var indent = _Number(options.text.indent);
                that._lineFrom = options.y - options.radius;
                that._lineTo = that._lineFrom - indent;
                that._textRadius = options.radius + indent
            },
            _getPositions: function() {
                var that = this;
                var basePosition = that._basePosition;
                var actualPosition = that._actualPosition;
                var mainPosition1;
                var mainPosition2;
                if (basePosition >= actualPosition) {
                    mainPosition1 = basePosition;
                    mainPosition2 = actualPosition
                } else {
                    mainPosition1 = actualPosition;
                    mainPosition2 = basePosition
                }
                return {
                    start: that._startPosition,
                    end: that._endPosition,
                    main1: mainPosition1,
                    main2: mainPosition2,
                    back1: Math.min(mainPosition1 + that._space, that._startPosition),
                    back2: Math.max(mainPosition2 - that._space, that._endPosition)
                }
            },
            _buildItemSettings: function(from, to) {
                var that = this;
                return {
                    x: that._options.x,
                    y: that._options.y,
                    innerRadius: that._minSide,
                    outerRadius: that._maxSide,
                    startAngle: to,
                    endAngle: from
                }
            },
            _updateTextPosition: function() {
                var that = this;
                var cosSin = _getCosAndSin(that._actualPosition);
                var x = that._options.x + that._textRadius * cosSin.cos;
                var y = that._options.y - that._textRadius * cosSin.sin;
                x += cosSin.cos * that._textWidth * .6;
                y -= cosSin.sin * that._textHeight * .6;
                that._text.attr({
                    x: x,
                    y: y + that._textVerticalOffset
                })
            },
            _updateLinePosition: function() {
                var that = this;
                var x = that._options.x;
                var x1;
                var x2;
                if (that._basePosition > that._actualPosition) {
                    x1 = x - 2;
                    x2 = x
                } else {
                    if (that._basePosition < that._actualPosition) {
                        x1 = x;
                        x2 = x + 2
                    } else {
                        x1 = x - 1;
                        x2 = x + 1
                    }
                }
                that._line.attr({
                    points: [x1, that._lineFrom, x1, that._lineTo, x2, that._lineTo, x2, that._lineFrom]
                }).rotate(_convertAngleToRendererSpace(that._actualPosition), x, that._options.y).sharp()
            },
            _getTooltipPosition: function() {
                var that = this;
                var cosSin = _getCosAndSin((that._basePosition + that._actualPosition) / 2);
                var r = (that._minSide + that._maxSide) / 2;
                return {
                    x: that._options.x + cosSin.cos * r,
                    y: that._options.y - cosSin.sin * r
                }
            },
            measure: function(layout) {
                var that = this;
                var result = {
                    min: layout.radius - _Number(that._options.size),
                    max: layout.radius
                };
                that._measureText();
                if (that._hasText) {
                    result.max += _Number(that._options.text.indent);
                    result.horizontalOffset = that._textWidth;
                    result.verticalOffset = that._textHeight
                }
                return result
            }
        });
        exports.rangebar = rangeBar
    },
    /*!*************************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/gauges/circular_range_container.js ***!
      \*************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _base_range_container = _interopRequireDefault(__webpack_require__( /*! ./base_range_container */ 477));
        var _utils = __webpack_require__( /*! ../core/utils */ 14);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _Number = Number;
        var _max = Math.max;
        var CircularRangeContainer = _base_range_container.default.inherit({
            _processOptions: function() {
                var that = this;
                that._inner = that._outer = 0;
                switch ((0, _utils.normalizeEnum)(that._options.orientation)) {
                    case "inside":
                        that._inner = 1;
                        break;
                    case "center":
                        that._inner = that._outer = .5;
                        break;
                    default:
                        that._outer = 1
                }
            },
            _isVisible: function(layout) {
                var width = this._options.width;
                width = _Number(width) || _max(_Number(width.start), _Number(width.end));
                return layout.radius - this._inner * width > 0
            },
            _createRange: function(range, layout) {
                var that = this;
                var width = (range.startWidth + range.endWidth) / 2;
                return that._renderer.arc(layout.x, layout.y, layout.radius - that._inner * width, layout.radius + that._outer * width, that._translator.translate(range.end), that._translator.translate(range.start)).attr({
                    "stroke-linejoin": "round"
                })
            },
            measure: function(layout) {
                var width = this._options.width;
                width = _Number(width) || _max(_Number(width.start), _Number(width.end));
                return {
                    min: layout.radius - this._inner * width,
                    max: layout.radius + this._outer * width
                }
            }
        });
        var _default = CircularRangeContainer;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/bar_gauge.js ***!
      \***************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _bar_gauge = __webpack_require__( /*! ./gauges/bar_gauge */ 953);
        var _default = _bar_gauge.dxBarGauge;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/gauges/bar_gauge.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.dxBarGauge = void 0;
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _object = __webpack_require__( /*! ../../core/utils/object */ 51);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _extend2 = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _base_gauge = __webpack_require__( /*! ./base_gauge */ 189);
        var _circular_gauge = _interopRequireDefault(__webpack_require__( /*! ./circular_gauge */ 478));
        var _legend = __webpack_require__( /*! ../components/legend */ 224);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var PI_DIV_180 = Math.PI / 180;
        var _abs = Math.abs;
        var _round = Math.round;
        var _floor = Math.floor;
        var _min = Math.min;
        var _max = Math.max;
        var _getSampleText = _base_gauge.getSampleText;
        var _formatValue = _base_gauge.formatValue;
        var _compareArrays = _base_gauge.compareArrays;
        var _isArray = Array.isArray;
        var _convertAngleToRendererSpace = _utils.convertAngleToRendererSpace;
        var _getCosAndSin = _utils.getCosAndSin;
        var _patchFontOptions = _utils.patchFontOptions;
        var _Number = Number;
        var _isFinite = isFinite;
        var _noop = _common.noop;
        var _extend = _extend2.extend;
        var OPTION_VALUES = "values";
        var BarWrapper;
        var dxBarGauge = _base_gauge.dxBaseGauge.inherit({
            _rootClass: "dxbg-bar-gauge",
            _themeSection: "barGauge",
            _fontFields: ["label.font", "legend.font", "legend.title.font", "legend.title.subtitle.font"],
            _initCore: function() {
                var that = this;
                that.callBase.apply(that, arguments);
                that._barsGroup = that._renderer.g().attr({
                    "class": "dxbg-bars"
                }).linkOn(that._renderer.root, "bars");
                that._values = [];
                that._context = {
                    renderer: that._renderer,
                    translator: that._translator,
                    tracker: that._tracker,
                    group: that._barsGroup
                };
                that._animateStep = function(pos) {
                    var bars = that._bars;
                    var i;
                    var ii;
                    for (i = 0, ii = bars.length; i < ii; ++i) {
                        bars[i].animate(pos)
                    }
                };
                that._animateComplete = function() {
                    that._bars.forEach(function(bar) {
                        return bar.endAnimation()
                    });
                    that._checkOverlap()
                }
            },
            _disposeCore: function() {
                var that = this;
                that._barsGroup.linkOff();
                that._barsGroup = that._values = that._context = that._animateStep = that._animateComplete = null;
                that.callBase.apply(that, arguments)
            },
            _setupDomainCore: function() {
                var that = this;
                var startValue = that.option("startValue");
                var endValue = that.option("endValue");
                _isFinite(startValue) || (startValue = 0);
                _isFinite(endValue) || (endValue = 100);
                that._translator.setDomain(startValue, endValue);
                that._baseValue = that._translator.adjust(that.option("baseValue"));
                _isFinite(that._baseValue) || (that._baseValue = startValue < endValue ? startValue : endValue)
            },
            _getDefaultSize: function() {
                return {
                    width: 300,
                    height: 300
                }
            },
            _setupCodomain: _circular_gauge.default.prototype._setupCodomain,
            _getApproximateScreenRange: function() {
                var that = this;
                var sides = that._area.sides;
                var width = that._canvas.width / (sides.right - sides.left);
                var height = that._canvas.height / (sides.down - sides.up);
                var r = width < height ? width : height;
                return -that._translator.getCodomainRange() * r * PI_DIV_180
            },
            _setupAnimationSettings: function() {
                var that = this;
                that.callBase.apply(that, arguments);
                if (that._animationSettings) {
                    that._animationSettings.step = that._animateStep;
                    that._animationSettings.complete = that._animateComplete
                }
            },
            _cleanContent: function() {
                var that = this;
                that._barsGroup.linkRemove();
                that._animationSettings && that._barsGroup.stopAnimation();
                that._barsGroup.clear()
            },
            _renderContent: function() {
                var that = this;
                var labelOptions = that.option("label");
                var text;
                var bBox;
                var context = that._context;
                that._barsGroup.linkAppend();
                context.textEnabled = void 0 === labelOptions || labelOptions && (!("visible" in labelOptions) || labelOptions.visible);
                if (context.textEnabled) {
                    context.textColor = labelOptions && labelOptions.font && labelOptions.font.color || null;
                    labelOptions = _extend(true, {}, that._themeManager.theme().label, labelOptions);
                    context.formatOptions = {
                        format: void 0 !== labelOptions.format ? labelOptions.format : that._defaultFormatOptions,
                        customizeText: labelOptions.customizeText
                    };
                    context.textOptions = {
                        align: "center"
                    };
                    context.fontStyles = _patchFontOptions(_extend({}, that._themeManager.theme().label.font, labelOptions.font, {
                        color: null
                    }));
                    that._textIndent = labelOptions.indent > 0 ? _Number(labelOptions.indent) : 0;
                    context.lineWidth = labelOptions.connectorWidth > 0 ? _Number(labelOptions.connectorWidth) : 0;
                    context.lineColor = labelOptions.connectorColor || null;
                    text = that._renderer.text(_getSampleText(that._translator, context.formatOptions), 0, 0).attr(context.textOptions).css(context.fontStyles).append(that._barsGroup);
                    bBox = text.getBBox();
                    text.remove();
                    context.textY = bBox.y;
                    context.textWidth = bBox.width;
                    context.textHeight = bBox.height
                }
                _circular_gauge.default.prototype._applyMainLayout.call(that);
                that._renderBars()
            },
            _measureMainElements: function() {
                var result = {
                    maxRadius: this._area.radius
                };
                if (this._context.textEnabled) {
                    result.horizontalMargin = this._context.textWidth;
                    result.verticalMargin = this._context.textHeight;
                    result.inverseHorizontalMargin = this._context.textWidth / 2;
                    result.inverseVerticalMargin = this._context.textHeight / 2
                }
                return result
            },
            _renderBars: function() {
                var that = this;
                var options = _extend({}, that._themeManager.theme(), that.option());
                var radius;
                var area = that._area;
                var relativeInnerRadius = options.relativeInnerRadius > 0 && options.relativeInnerRadius < 1 ? _Number(options.relativeInnerRadius) : .1;
                radius = area.radius;
                if (that._context.textEnabled) {
                    that._textIndent = _round(_min(that._textIndent, radius / 2));
                    radius -= that._textIndent
                }
                that._outerRadius = _floor(radius);
                that._innerRadius = _floor(radius * relativeInnerRadius);
                that._barSpacing = options.barSpacing > 0 ? _Number(options.barSpacing) : 0;
                _extend(that._context, {
                    backgroundColor: options.backgroundColor,
                    x: area.x,
                    y: area.y,
                    startAngle: area.startCoord,
                    endAngle: area.endCoord,
                    baseAngle: that._translator.translate(that._baseValue)
                });
                that._arrangeBars()
            },
            _arrangeBars: function() {
                var that = this;
                var radius = that._outerRadius - that._innerRadius;
                var context = that._context;
                var i;
                var count = that._bars.length;
                that._beginValueChanging();
                context.barSize = count > 0 ? _max((radius - (count - 1) * that._barSpacing) / count, 1) : 0;
                var spacing = count > 1 ? _max(_min((radius - count * context.barSize) / (count - 1), that._barSpacing), 0) : 0;
                var _count = _min(_floor((radius + spacing) / context.barSize), count);
                that._setBarsCount(count);
                radius = that._outerRadius;
                context.textRadius = radius;
                context.textIndent = that._textIndent;
                that._palette.reset();
                var unitOffset = context.barSize + spacing;
                var colors = that._palette.generateColors(_count);
                for (i = 0; i < _count; ++i, radius -= unitOffset) {
                    that._bars[i].arrange({
                        radius: radius,
                        color: colors[i]
                    })
                }
                for (var _i = _count; _i < count; _i++) {
                    that._bars[_i].hide()
                }
                if (that._animationSettings && !that._noAnimation) {
                    that._animateBars()
                } else {
                    that._updateBars()
                }
                that._endValueChanging()
            },
            _setBarsCount: function() {
                var that = this;
                if (that._bars.length > 0) {
                    if (that._dummyBackground) {
                        that._dummyBackground.dispose();
                        that._dummyBackground = null
                    }
                } else {
                    if (!that._dummyBackground) {
                        that._dummyBackground = that._renderer.arc().attr({
                            "stroke-linejoin": "round"
                        })
                    }
                    that._dummyBackground.attr({
                        x: that._context.x,
                        y: that._context.y,
                        outerRadius: that._outerRadius,
                        innerRadius: that._innerRadius,
                        startAngle: that._context.endAngle,
                        endAngle: that._context.startAngle,
                        fill: that._context.backgroundColor
                    }).append(that._barsGroup)
                }
            },
            _updateBars: function() {
                this._bars.forEach(function(bar) {
                    return bar.applyValue()
                });
                this._checkOverlap()
            },
            _checkOverlap: function() {
                var that = this;
                var bars = that._bars;
                var overlapStrategy = (0, _utils.normalizeEnum)(that._getOption("resolveLabelOverlapping", true));
                if ("none" === overlapStrategy) {
                    return
                }
                var sortedBars = bars.concat().sort(function(a, b) {
                    return a.getValue() - b.getValue()
                });
                var currentIndex = 0;
                var nextIndex = 1;
                while (currentIndex < sortedBars.length && nextIndex < sortedBars.length) {
                    var current = sortedBars[currentIndex];
                    var next = sortedBars[nextIndex];
                    if (current.checkIntersect(next)) {
                        next.hideLabel();
                        nextIndex++
                    } else {
                        currentIndex = nextIndex;
                        nextIndex = currentIndex + 1
                    }
                }
            },
            _animateBars: function() {
                var that = this;
                var i;
                var ii = that._bars.length;
                if (ii > 0) {
                    for (i = 0; i < ii; ++i) {
                        that._bars[i].beginAnimation()
                    }
                    that._barsGroup.animate({
                        _: 0
                    }, that._animationSettings)
                }
            },
            _buildNodes: function() {
                var that = this;
                var options = that._options.silent();
                that._palette = that._themeManager.createPalette(options.palette, {
                    useHighlight: true,
                    extensionMode: options.paletteExtensionMode
                });
                that._palette.reset();
                that._bars = that._bars || [];
                that._animationSettings && that._barsGroup.stopAnimation();
                var barValues = that._values.filter(_isFinite);
                var count = barValues.length;
                if (that._bars.length > count) {
                    var ii = that._bars.length;
                    for (var i = count; i < ii; ++i) {
                        that._bars[i].dispose()
                    }
                    that._bars.splice(count, ii - count)
                } else {
                    if (that._bars.length < count) {
                        for (var _i2 = that._bars.length; _i2 < count; ++_i2) {
                            that._bars.push(new BarWrapper(_i2, that._context))
                        }
                    }
                }
                that._bars.forEach(function(bar, index) {
                    bar.update({
                        color: that._palette.getNextColor(count),
                        value: barValues[index]
                    })
                })
            },
            _updateValues: function(values) {
                var that = this;
                var list = _isArray(values) && values || _isFinite(values) && [values] || [];
                var i;
                var ii = list.length;
                var value;
                that._values.length = ii;
                for (i = 0; i < ii; ++i) {
                    value = list[i];
                    that._values[i] = value = _Number(_isFinite(value) ? value : that._values[i])
                }
                if (!that._resizing) {
                    if (!_compareArrays(that._values, that.option(OPTION_VALUES))) {
                        that.option(OPTION_VALUES, that._values.slice())
                    }
                }
                this._change(["NODES"])
            },
            values: function(arg) {
                if (void 0 !== arg) {
                    this._updateValues(arg);
                    return this
                } else {
                    return this._values.slice(0)
                }
            },
            _optionChangesMap: {
                backgroundColor: "MOSTLY_TOTAL",
                relativeInnerRadius: "MOSTLY_TOTAL",
                barSpacing: "MOSTLY_TOTAL",
                label: "MOSTLY_TOTAL",
                resolveLabelOverlapping: "MOSTLY_TOTAL",
                palette: "MOSTLY_TOTAL",
                paletteExtensionMode: "MOSTLY_TOTAL",
                values: "VALUES"
            },
            _change_VALUES: function() {
                this._updateValues(this.option(OPTION_VALUES))
            },
            _factory: (0, _object.clone)(_base_gauge.dxBaseGauge.prototype._factory),
            _optionChangesOrder: ["VALUES", "NODES"],
            _initialChanges: ["VALUES"],
            _change_NODES: function() {
                this._buildNodes()
            },
            _change_MOSTLY_TOTAL: function() {
                this._change(["NODES"]);
                this.callBase()
            },
            _proxyData: [],
            _getLegendData: function() {
                var that = this;
                var formatOptions = {};
                var options = that._options.silent();
                var labelFormatOptions = (options.label || {}).format;
                var legendFormatOptions = (options.legend || {}).itemTextFormat;
                if (legendFormatOptions) {
                    formatOptions.format = legendFormatOptions
                } else {
                    formatOptions.format = labelFormatOptions || that._defaultFormatOptions
                }
                return (this._bars || []).map(function(b) {
                    return {
                        id: b.index,
                        item: {
                            value: b.getValue(),
                            color: b.getColor(),
                            index: b.index
                        },
                        text: _formatValue(b.getValue(), formatOptions),
                        visible: true,
                        states: {
                            normal: {
                                fill: b.getColor()
                            }
                        }
                    }
                })
            }
        });
        exports.dxBarGauge = dxBarGauge;
        BarWrapper = function(index, context) {
            var that = this;
            that._context = context;
            that._tracker = context.renderer.arc().attr({
                "stroke-linejoin": "round"
            });
            that.index = index
        };
        _extend(BarWrapper.prototype, {
            dispose: function() {
                var that = this;
                that._background.dispose();
                that._bar.dispose();
                if (that._context.textEnabled) {
                    that._line.dispose();
                    that._text.dispose()
                }
                that._context.tracker.detach(that._tracker);
                that._context = that._settings = that._background = that._bar = that._line = that._text = that._tracker = null;
                return that
            },
            arrange: function(options) {
                var that = this;
                var context = that._context;
                this._visible = true;
                context.tracker.attach(that._tracker, that, {
                    index: that.index
                });
                that._background = context.renderer.arc().attr({
                    "stroke-linejoin": "round",
                    fill: context.backgroundColor
                }).append(context.group);
                that._settings = that._settings || {
                    x: context.x,
                    y: context.y,
                    startAngle: context.baseAngle,
                    endAngle: context.baseAngle
                };
                that._bar = context.renderer.arc().attr(_extend({
                    "stroke-linejoin": "round"
                }, that._settings)).append(context.group);
                if (context.textEnabled) {
                    that._line = context.renderer.path([], "line").attr({
                        "stroke-width": context.lineWidth
                    }).append(context.group);
                    that._text = context.renderer.text().css(context.fontStyles).attr(context.textOptions).append(context.group)
                }
                that._angle = isFinite(that._angle) ? that._angle : context.baseAngle;
                that._settings.outerRadius = options.radius;
                that._settings.innerRadius = options.radius - context.barSize;
                that._settings.x = context.x;
                that._settings.y = context.y;
                that._background.attr(_extend({}, that._settings, {
                    startAngle: context.endAngle,
                    endAngle: context.startAngle,
                    fill: that._context.backgroundColor
                }));
                that._bar.attr({
                    x: context.x,
                    y: context.y,
                    outerRadius: that._settings.outerRadius,
                    innerRadius: that._settings.innerRadius,
                    fill: that._color
                });
                that._tracker.attr(that._settings);
                if (context.textEnabled) {
                    that._line.attr({
                        points: [context.x, context.y - that._settings.innerRadius, context.x, context.y - context.textRadius - context.textIndent],
                        stroke: context.lineColor || that._color
                    }).sharp();
                    that._text.css({
                        fill: context.textColor || that._color
                    })
                }
                return that
            },
            getTooltipParameters: function() {
                var that = this;
                var cosSin = _getCosAndSin((that._angle + that._context.baseAngle) / 2);
                return {
                    x: _round(that._context.x + (that._settings.outerRadius + that._settings.innerRadius) / 2 * cosSin.cos),
                    y: _round(that._context.y - (that._settings.outerRadius + that._settings.innerRadius) / 2 * cosSin.sin),
                    offset: 0,
                    color: that._color,
                    value: that._value
                }
            },
            setAngle: function(angle) {
                var that = this;
                var context = that._context;
                var settings = that._settings;
                var cosSin;
                that._angle = angle;
                setAngles(settings, context.baseAngle, angle);
                that._bar.attr(settings);
                that._tracker.attr(settings);
                if (context.textEnabled) {
                    cosSin = _getCosAndSin(angle);
                    var indent = context.textIndent;
                    var radius = context.textRadius + indent;
                    var x = context.x + radius * cosSin.cos;
                    var y = context.y - radius * cosSin.sin;
                    var halfWidth = .5 * context.textWidth;
                    var textHeight = context.textHeight;
                    var textY = context.textY;
                    if (_abs(x - context.x) > indent) {
                        x += x < context.x ? -halfWidth : halfWidth
                    }
                    if (_abs(y - context.y) <= indent) {
                        y -= textY + .5 * textHeight
                    } else {
                        y -= y < context.y ? textY + textHeight : textY
                    }
                    var text = _formatValue(that._value, context.formatOptions, {
                        index: that.index
                    });
                    var visibility = "" === text ? "hidden" : null;
                    that._text.attr({
                        text: text,
                        x: x,
                        y: y,
                        visibility: visibility
                    });
                    that._line.attr({
                        visibility: visibility
                    });
                    that._line.rotate(_convertAngleToRendererSpace(angle), context.x, context.y)
                }
                return that
            },
            hideLabel: function() {
                this._text.attr({
                    visibility: "hidden"
                });
                this._line.attr({
                    visibility: "hidden"
                })
            },
            checkIntersect: function(anotherBar) {
                var coords = this.calculateLabelCoords();
                var anotherCoords = anotherBar.calculateLabelCoords();
                if (!coords || !anotherCoords) {
                    return false
                }
                var width = Math.max(0, Math.min(coords.bottomRight.x, anotherCoords.bottomRight.x) - Math.max(coords.topLeft.x, anotherCoords.topLeft.x));
                var height = Math.max(0, Math.min(coords.bottomRight.y, anotherCoords.bottomRight.y) - Math.max(coords.topLeft.y, anotherCoords.topLeft.y));
                return width * height !== 0
            },
            calculateLabelCoords: function() {
                if (!this._text) {
                    return
                }
                var box = this._text.getBBox();
                return {
                    topLeft: {
                        x: box.x,
                        y: box.y
                    },
                    bottomRight: {
                        x: box.x + box.width,
                        y: box.y + box.height
                    }
                }
            },
            _processValue: function(value) {
                return this._context.translator.translate(this._context.translator.adjust(value))
            },
            applyValue: function() {
                if (!this._visible) {
                    return this
                }
                return this.setAngle(this._processValue(this.getValue()))
            },
            update: function(_ref) {
                var color = _ref.color,
                    value = _ref.value;
                this._color = color;
                this._value = value
            },
            hide: function() {
                this._visible = false
            },
            getColor: function() {
                return this._color
            },
            getValue: function() {
                return this._value
            },
            beginAnimation: function() {
                if (!this._visible) {
                    return this
                }
                var that = this;
                var angle = this._processValue(this.getValue());
                if (!compareFloats(that._angle, angle)) {
                    that._start = that._angle;
                    that._delta = angle - that._angle;
                    that._tracker.attr({
                        visibility: "hidden"
                    });
                    if (that._context.textEnabled) {
                        that._line.attr({
                            visibility: "hidden"
                        });
                        that._text.attr({
                            visibility: "hidden"
                        })
                    }
                } else {
                    that.animate = _noop;
                    that.setAngle(that._angle)
                }
            },
            animate: function(pos) {
                if (!this._visible) {
                    return this
                }
                var that = this;
                that._angle = that._start + that._delta * pos;
                setAngles(that._settings, that._context.baseAngle, that._angle);
                that._bar.attr(that._settings)
            },
            endAnimation: function() {
                var that = this;
                if (void 0 !== that._delta) {
                    if (compareFloats(that._angle, that._start + that._delta)) {
                        that._tracker.attr({
                            visibility: null
                        });
                        that.setAngle(that._angle)
                    }
                } else {
                    delete that.animate
                }
                delete that._start;
                delete that._delta
            }
        });

        function setAngles(target, angle1, angle2) {
            target.startAngle = angle1 < angle2 ? angle1 : angle2;
            target.endAngle = angle1 < angle2 ? angle2 : angle1
        }

        function compareFloats(value1, value2) {
            return _abs(value1 - value2) < 1e-4
        }(0, _component_registrator.default)("dxBarGauge", dxBarGauge);
        dxBarGauge.addPlugin(_legend.plugin)
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/range_selector.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _range_selector = _interopRequireDefault(__webpack_require__( /*! ./range_selector/range_selector */ 955));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _range_selector.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/range_selector/range_selector.js ***!
      \***********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _type2 = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _date = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/date */ 19));
        var _math = __webpack_require__( /*! ../../core/utils/math */ 29);
        var _range = __webpack_require__( /*! ../translators/range */ 124);
        var _base_axis = __webpack_require__( /*! ../axes/base_axis */ 316);
        var _parse_utils = __webpack_require__( /*! ../components/parse_utils */ 313);
        var _format_helper = _interopRequireDefault(__webpack_require__( /*! ../../format_helper */ 71));
        var _common = __webpack_require__( /*! ./common */ 229);
        var _sliders_controller = __webpack_require__( /*! ./sliders_controller */ 956);
        var _tracker = __webpack_require__( /*! ./tracker */ 959);
        var _range_view = __webpack_require__( /*! ./range_view */ 960);
        var _series_data_source = __webpack_require__( /*! ./series_data_source */ 961);
        var _tick_generator = __webpack_require__( /*! ../axes/tick_generator */ 469);
        var _base_widget = _interopRequireDefault(__webpack_require__( /*! ../core/base_widget */ 113));
        var _export = __webpack_require__( /*! ../core/export */ 108);
        var _title = __webpack_require__( /*! ../core/title */ 121);
        var _loading_indicator = __webpack_require__( /*! ../core/loading_indicator */ 145);
        var _data_source = __webpack_require__( /*! ../core/data_source */ 164);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _max = Math.max;
        var _ceil = Math.ceil;
        var _floor = Math.floor;
        var START_VALUE = "startValue";
        var END_VALUE = "endValue";
        var DATETIME = "datetime";
        var VALUE = "value";
        var DISCRETE = "discrete";
        var SEMIDISCRETE = "semidiscrete";
        var STRING = "string";
        var VALUE_CHANGED = VALUE + "Changed";
        var CONTAINER_BACKGROUND_COLOR = "containerBackgroundColor";
        var SLIDER_MARKER = "sliderMarker";
        var OPTION_BACKGROUND = "background";
        var LOGARITHMIC = "logarithmic";
        var KEEP = "keep";
        var SHIFT = "shift";
        var RESET = "reset";
        var INVISIBLE_POS = -1e3;
        var SEMIDISCRETE_GRID_SPACING_FACTOR = 50;
        var DEFAULT_AXIS_DIVISION_FACTOR = 30;
        var DEFAULT_MINOR_AXIS_DIVISION_FACTOR = 15;
        var logarithmBase = 10;

        function calculateMarkerHeight(renderer, value, sliderMarkerOptions) {
            var formattedText = void 0 === value ? _common.consts.emptySliderMarkerText : (0, _common.formatValue)(value, sliderMarkerOptions);
            var textBBox = getTextBBox(renderer, formattedText, sliderMarkerOptions.font);
            return _ceil(textBBox.height) + 2 * sliderMarkerOptions.paddingTopBottom + _common.consts.pointerSize
        }

        function calculateScaleLabelHalfWidth(renderer, value, scaleOptions, tickIntervalsInfo) {
            var formattedText = (0, _common.formatValue)(value, scaleOptions.label, tickIntervalsInfo, scaleOptions.valueType, scaleOptions.type, scaleOptions.logarithmBase);
            var textBBox = getTextBBox(renderer, formattedText, scaleOptions.label.font);
            return _ceil(textBBox.width / 2)
        }

        function calculateIndents(renderer, scale, sliderMarkerOptions, indentOptions, tickIntervalsInfo) {
            var leftMarkerHeight;
            var leftScaleLabelWidth = 0;
            var rightScaleLabelWidth = 0;
            var rightMarkerHeight;
            var placeholderWidthLeft;
            var placeholderWidthRight;
            var placeholderHeight;
            var ticks = "semidiscrete" === scale.type ? scale.customTicks : tickIntervalsInfo.ticks;
            var startTickValue;
            var endTickValue;
            indentOptions = indentOptions || {};
            placeholderWidthLeft = indentOptions.left;
            placeholderWidthRight = indentOptions.right;
            placeholderHeight = sliderMarkerOptions.placeholderHeight;
            if (sliderMarkerOptions.visible) {
                leftMarkerHeight = calculateMarkerHeight(renderer, scale.startValue, sliderMarkerOptions);
                rightMarkerHeight = calculateMarkerHeight(renderer, scale.endValue, sliderMarkerOptions);
                if (void 0 === placeholderHeight) {
                    placeholderHeight = _max(leftMarkerHeight, rightMarkerHeight)
                }
            }
            if (scale.label.visible) {
                startTickValue = (0, _type2.isDefined)(scale.startValue) ? ticks[0] : void 0;
                endTickValue = (0, _type2.isDefined)(scale.endValue) ? ticks[ticks.length - 1] : void 0;
                leftScaleLabelWidth = calculateScaleLabelHalfWidth(renderer, startTickValue, scale, tickIntervalsInfo);
                rightScaleLabelWidth = calculateScaleLabelHalfWidth(renderer, endTickValue, scale, tickIntervalsInfo)
            }
            placeholderWidthLeft = void 0 !== placeholderWidthLeft ? placeholderWidthLeft : leftScaleLabelWidth;
            placeholderWidthRight = (void 0 !== placeholderWidthRight ? placeholderWidthRight : rightScaleLabelWidth) || 1;
            return {
                left: placeholderWidthLeft,
                right: placeholderWidthRight,
                top: placeholderHeight || 0,
                bottom: 0
            }
        }

        function calculateValueType(firstValue, secondValue) {
            var typeFirstValue = (0, _type2.type)(firstValue);
            var typeSecondValue = (0, _type2.type)(secondValue);
            var validType = function(type) {
                return typeFirstValue === type || typeSecondValue === type
            };
            return validType("date") ? DATETIME : validType("number") ? "numeric" : validType(STRING) ? STRING : ""
        }

        function showScaleMarkers(scaleOptions) {
            return scaleOptions.valueType === DATETIME && scaleOptions.marker.visible
        }

        function updateTranslatorRangeInterval(translatorRange, scaleOptions) {
            var intervalX = scaleOptions.minorTickInterval || scaleOptions.tickInterval;
            if ("datetime" === scaleOptions.valueType) {
                intervalX = _date.default.dateToMilliseconds(intervalX)
            }
            translatorRange.addRange({
                interval: intervalX
            })
        }

        function checkLogarithmicOptions(options, defaultLogarithmBase, incidentOccurred) {
            if (!options) {
                return
            }
            var logarithmBase = options.logarithmBase;
            if (options.type === LOGARITHMIC && logarithmBase <= 0 || logarithmBase && !(0, _type2.isNumeric)(logarithmBase)) {
                options.logarithmBase = defaultLogarithmBase;
                incidentOccurred("E2104")
            } else {
                if (options.type !== LOGARITHMIC) {
                    options.logarithmBase = void 0
                }
            }
        }

        function calculateScaleAreaHeight(renderer, scaleOptions, visibleMarkers, tickIntervalsInfo) {
            var labelScaleOptions = scaleOptions.label;
            var markerScaleOptions = scaleOptions.marker;
            var placeholderHeight = scaleOptions.placeholderHeight;
            var ticks = "semidiscrete" === scaleOptions.type ? scaleOptions.customTicks : tickIntervalsInfo.ticks;
            var text = (0, _common.formatValue)(ticks[0], labelScaleOptions);
            if (placeholderHeight) {
                return placeholderHeight
            } else {
                return (labelScaleOptions.visible ? labelScaleOptions.topIndent + getTextBBox(renderer, text, labelScaleOptions.font).height : 0) + (visibleMarkers ? markerScaleOptions.topIndent + markerScaleOptions.separatorHeight : 0)
            }
        }

        function getMinorTickIntervalUnit(tickInterval, minorTickInterval, withCorrection) {
            var interval = _date.default.getDateUnitInterval(minorTickInterval);
            var majorUnit = _date.default.getDateUnitInterval(tickInterval);
            var idx = _date.default.dateUnitIntervals.indexOf(interval);
            if (withCorrection && interval === majorUnit && idx > 0) {
                interval = _date.default.dateUnitIntervals[idx - 1]
            }
            return interval
        }

        function getNextTickInterval(tickInterval, minorTickInterval, isDateType) {
            if (!tickInterval) {
                tickInterval = minorTickInterval
            } else {
                if (isDateType) {
                    tickInterval = _date.default.getNextDateUnit(tickInterval)
                } else {
                    tickInterval += minorTickInterval
                }
            }
            return tickInterval
        }

        function calculateTickIntervalsForSemidiscreteScale(scaleOptions, min, max, screenDelta) {
            var minorTickInterval = scaleOptions.minorTickInterval;
            var tickInterval = scaleOptions.tickInterval;
            var interval;
            var isDateType = "datetime" === scaleOptions.valueType;
            var gridSpacingFactor = scaleOptions.axisDivisionFactor || {};
            var tickCountByInterval;
            var tickCountByScreen;
            if (!tickInterval) {
                do {
                    interval = getNextTickInterval(tickInterval, minorTickInterval, isDateType);
                    if (tickInterval !== interval) {
                        tickInterval = interval
                    } else {
                        break
                    }
                    if (isDateType) {
                        interval = _date.default.dateToMilliseconds(tickInterval)
                    }
                    tickCountByInterval = _ceil((max - min) / interval);
                    tickCountByScreen = _floor(screenDelta / (gridSpacingFactor[tickInterval] || SEMIDISCRETE_GRID_SPACING_FACTOR)) || 1
                } while (interval && tickCountByInterval > tickCountByScreen)
            }
            return {
                tickInterval: tickInterval,
                minorTickInterval: minorTickInterval,
                bounds: {
                    minVisible: min,
                    maxVisible: max
                },
                ticks: []
            }
        }

        function updateTickIntervals(scaleOptions, screenDelta, incidentOccurred, range) {
            var result;
            var min = (0, _type2.isDefined)(range.minVisible) ? range.minVisible : range.min;
            var max = (0, _type2.isDefined)(range.maxVisible) ? range.maxVisible : range.max;
            var categoriesInfo = scaleOptions._categoriesInfo;
            var ticksInfo;
            var length;
            var bounds = {};
            if (scaleOptions.type === SEMIDISCRETE) {
                result = calculateTickIntervalsForSemidiscreteScale(scaleOptions, min, max, screenDelta)
            } else {
                ticksInfo = (0, _tick_generator.tickGenerator)({
                    axisType: scaleOptions.type,
                    dataType: scaleOptions.valueType,
                    logBase: scaleOptions.logarithmBase,
                    allowNegatives: true,
                    linearThreshold: Math.abs(scaleOptions.linearThreshold || 0),
                    axisDivisionFactor: scaleOptions.axisDivisionFactor,
                    minorAxisDivisionFactor: scaleOptions.minorAxisDivisionFactor,
                    calculateMinors: true,
                    allowDecimals: scaleOptions.allowDecimals,
                    endOnTick: scaleOptions.endOnTick,
                    incidentOccurred: incidentOccurred,
                    rangeIsEmpty: range.isEmpty()
                })({
                    min: min,
                    max: max,
                    categories: (0, _type2.isDefined)(categoriesInfo) ? categoriesInfo.categories : []
                }, screenDelta, scaleOptions.tickInterval, scaleOptions.forceUserTickInterval, void 0, scaleOptions.minorTickInterval, scaleOptions.minorTickCount);
                length = ticksInfo.ticks.length;
                bounds.minVisible = ticksInfo.ticks[0] < min ? ticksInfo.ticks[0] : min;
                bounds.maxVisible = ticksInfo.ticks[length - 1] > max ? ticksInfo.ticks[length - 1] : max;
                result = {
                    tickInterval: ticksInfo.tickInterval,
                    minorTickInterval: 0 === scaleOptions.minorTickInterval ? 0 : ticksInfo.minorTickInterval,
                    bounds: bounds,
                    ticks: ticksInfo.ticks
                }
            }
            return result
        }

        function getFirstDayOfWeek(options) {
            var _options$workWeek;
            return null === (_options$workWeek = options.workWeek) || void 0 === _options$workWeek ? void 0 : _options$workWeek[0]
        }

        function calculateTranslatorRange(seriesDataSource, scaleOptions) {
            var minValue;
            var maxValue;
            var inverted = false;
            var startValue = scaleOptions.startValue;
            var endValue = scaleOptions.endValue;
            var categories;
            var categoriesInfo;
            var translatorRange = seriesDataSource ? seriesDataSource.getBoundRange().arg : new _range.Range;
            var rangeForCategories;
            var isDate = "datetime" === scaleOptions.valueType;
            var firstDayOfWeek = getFirstDayOfWeek(scaleOptions);
            var minRange = scaleOptions.minRange;
            if (scaleOptions.type === DISCRETE) {
                rangeForCategories = new _range.Range({
                    minVisible: startValue,
                    maxVisible: endValue
                });
                rangeForCategories.addRange(translatorRange);
                translatorRange = rangeForCategories;
                categories = seriesDataSource ? seriesDataSource.argCategories : scaleOptions.categories || !seriesDataSource && startValue && endValue && [startValue, endValue];
                categories = categories || [];
                scaleOptions._categoriesInfo = categoriesInfo = (0, _utils.getCategoriesInfo)(categories, startValue, endValue)
            }
            if (scaleOptions.type === SEMIDISCRETE) {
                startValue = scaleOptions.startValue = correctValueByInterval(scaleOptions.startValue, isDate, minRange, firstDayOfWeek);
                endValue = scaleOptions.endValue = correctValueByInterval(scaleOptions.endValue, isDate, minRange, firstDayOfWeek);
                translatorRange.minVisible = correctValueByInterval(translatorRange.minVisible, isDate, minRange, firstDayOfWeek);
                translatorRange.maxVisible = correctValueByInterval(translatorRange.maxVisible, isDate, minRange, firstDayOfWeek);
                translatorRange.min = correctValueByInterval(translatorRange.min, isDate, minRange, firstDayOfWeek);
                translatorRange.max = correctValueByInterval(translatorRange.max, isDate, minRange, firstDayOfWeek)
            }
            if ((0, _type2.isDefined)(startValue) && (0, _type2.isDefined)(endValue)) {
                inverted = categoriesInfo ? categoriesInfo.inverted : startValue > endValue;
                minValue = categoriesInfo ? categoriesInfo.start : inverted ? endValue : startValue;
                maxValue = categoriesInfo ? categoriesInfo.end : inverted ? startValue : endValue
            } else {
                if ((0, _type2.isDefined)(startValue) || (0, _type2.isDefined)(endValue)) {
                    minValue = startValue;
                    maxValue = endValue
                } else {
                    if (categoriesInfo) {
                        minValue = categoriesInfo.start;
                        maxValue = categoriesInfo.end
                    }
                }
            }
            translatorRange.addRange({
                invert: inverted,
                min: minValue,
                max: maxValue,
                minVisible: minValue,
                maxVisible: maxValue,
                dataType: scaleOptions.valueType
            });
            translatorRange.addRange({
                categories: !seriesDataSource ? categories : void 0,
                base: scaleOptions.logarithmBase,
                axisType: scaleOptions.type,
                dataType: scaleOptions.valueType
            });
            seriesDataSource && translatorRange.sortCategories(categories);
            return translatorRange
        }

        function startEndNotDefined(start, end) {
            return !(0, _type2.isDefined)(start) || !(0, _type2.isDefined)(end)
        }

        function getTextBBox(renderer, text, fontOptions) {
            var textElement = renderer.text(text, INVISIBLE_POS, INVISIBLE_POS).css((0, _utils.patchFontOptions)(fontOptions)).append(renderer.root);
            var textBBox = textElement.getBBox();
            textElement.remove();
            return textBBox
        }

        function getDateMarkerVisibilityChecker(screenDelta) {
            return function(isDateScale, isMarkerVisible, min, max, tickInterval) {
                if (isMarkerVisible && isDateScale) {
                    if (!(0, _type2.isDefined)(tickInterval) || tickInterval.years || tickInterval.months >= 6 || screenDelta / SEMIDISCRETE_GRID_SPACING_FACTOR < _ceil((max - min) / _date.default.dateToMilliseconds("year")) + 1) {
                        isMarkerVisible = false
                    }
                }
                return isMarkerVisible
            }
        }

        function updateScaleOptions(scaleOptions, seriesDataSource, translatorRange, tickIntervalsInfo, checkDateMarkerVisibility) {
            var bounds;
            var isEmptyInterval;
            var categoriesInfo = scaleOptions._categoriesInfo;
            var intervals;
            var isDateTime = scaleOptions.valueType === DATETIME;
            if (seriesDataSource && !seriesDataSource.isEmpty() && !translatorRange.isEmpty()) {
                bounds = tickIntervalsInfo.bounds;
                translatorRange.addRange(bounds);
                scaleOptions.startValue = translatorRange.invert ? bounds.maxVisible : bounds.minVisible;
                scaleOptions.endValue = translatorRange.invert ? bounds.minVisible : bounds.maxVisible
            }
            scaleOptions.marker.visible = checkDateMarkerVisibility(isDateTime && scaleOptions.type.indexOf(DISCRETE) === -1, scaleOptions.marker.visible, scaleOptions.startValue, scaleOptions.endValue, tickIntervalsInfo.tickInterval);
            if (categoriesInfo) {
                scaleOptions.startValue = categoriesInfo.start;
                scaleOptions.endValue = categoriesInfo.end
            }
            if (scaleOptions.type.indexOf(DISCRETE) === -1) {
                isEmptyInterval = (0, _type2.isDate)(scaleOptions.startValue) && (0, _type2.isDate)(scaleOptions.endValue) && scaleOptions.startValue.getTime() === scaleOptions.endValue.getTime() || scaleOptions.startValue === scaleOptions.endValue
            }
            scaleOptions.isEmpty = startEndNotDefined(scaleOptions.startValue, scaleOptions.endValue) || isEmptyInterval;
            if (scaleOptions.isEmpty) {
                scaleOptions.startValue = scaleOptions.endValue = void 0
            } else {
                scaleOptions.minorTickInterval = tickIntervalsInfo.minorTickInterval;
                scaleOptions.tickInterval = tickIntervalsInfo.tickInterval;
                if (isDateTime && (!(0, _type2.isDefined)(scaleOptions.label.format) || scaleOptions.type === SEMIDISCRETE && scaleOptions.minorTickInterval !== scaleOptions.tickInterval)) {
                    if (scaleOptions.type === DISCRETE) {
                        scaleOptions.label.format = _format_helper.default.getDateFormatByTicks(tickIntervalsInfo.ticks)
                    } else {
                        if (!scaleOptions.marker.visible) {
                            scaleOptions.label.format = _format_helper.default.getDateFormatByTickInterval(scaleOptions.startValue, scaleOptions.endValue, scaleOptions.tickInterval)
                        } else {
                            scaleOptions.label.format = _date.default.getDateFormatByTickInterval(scaleOptions.tickInterval)
                        }
                    }
                }
            }
            if (scaleOptions.type === SEMIDISCRETE) {
                intervals = getIntervalCustomTicks(scaleOptions);
                scaleOptions.customMinorTicks = intervals.altIntervals;
                scaleOptions.customTicks = intervals.intervals;
                scaleOptions.customBoundTicks = [scaleOptions.customTicks[0]]
            }
        }

        function prepareScaleOptions(scaleOption, calculatedValueType, incidentOccurred, containerColor) {
            var parsedValue = 0;
            var valueType = (0, _parse_utils.correctValueType)((0, _utils.normalizeEnum)(scaleOption.valueType));
            var validateStartEndValues = function(field, parser) {
                var messageToIncidentOccurred = field === START_VALUE ? "start" : "end";
                if ((0, _type2.isDefined)(scaleOption[field])) {
                    parsedValue = parser(scaleOption[field]);
                    if ((0, _type2.isDefined)(parsedValue)) {
                        scaleOption[field] = parsedValue
                    } else {
                        scaleOption[field] = void 0;
                        incidentOccurred("E2202", [messageToIncidentOccurred])
                    }
                }
            };
            valueType = calculatedValueType || valueType;
            if (!valueType) {
                valueType = calculateValueType(scaleOption.startValue, scaleOption.endValue) || "numeric"
            }
            if (valueType === STRING || scaleOption.categories) {
                scaleOption.type = DISCRETE;
                valueType = STRING
            }
            scaleOption.containerColor = containerColor;
            scaleOption.valueType = valueType;
            scaleOption.dataType = valueType;
            var parser = (0, _parse_utils.getParser)(valueType);
            validateStartEndValues(START_VALUE, parser);
            validateStartEndValues(END_VALUE, parser);
            checkLogarithmicOptions(scaleOption, logarithmBase, incidentOccurred);
            if (!scaleOption.type) {
                scaleOption.type = "continuous"
            }
            scaleOption.parser = parser;
            if (scaleOption.type === SEMIDISCRETE) {
                scaleOption.minorTick.visible = false;
                scaleOption.minorTickInterval = scaleOption.minRange;
                scaleOption.marker.visible = false;
                scaleOption.maxRange = void 0
            }
            scaleOption.forceUserTickInterval |= (0, _type2.isDefined)(scaleOption.tickInterval) && !(0, _type2.isDefined)(scaleOption.axisDivisionFactor);
            scaleOption.axisDivisionFactor = (0, _type2.isDefined)(scaleOption.axisDivisionFactor) ? scaleOption.axisDivisionFactor : DEFAULT_AXIS_DIVISION_FACTOR;
            scaleOption.minorAxisDivisionFactor = (0, _type2.isDefined)(scaleOption.minorAxisDivisionFactor) ? scaleOption.minorAxisDivisionFactor : DEFAULT_MINOR_AXIS_DIVISION_FACTOR;
            return scaleOption
        }

        function correctValueByInterval(value, isDate, interval, firstDayOfWeek) {
            if ((0, _type2.isDefined)(value)) {
                value = isDate ? _date.default.correctDateWithUnitBeginning(new Date(value), interval, null, firstDayOfWeek) : (0, _math.adjust)(_floor((0, _math.adjust)(value / interval)) * interval)
            }
            return value
        }

        function getIntervalCustomTicks(options) {
            var min = options.startValue;
            var max = options.endValue;
            var isDate = "datetime" === options.valueType;
            var firstDayOfWeek = getFirstDayOfWeek(options);
            var tickInterval = options.tickInterval;
            var res = {
                intervals: []
            };
            if (!(0, _type2.isDefined)(min) || !(0, _type2.isDefined)(max)) {
                return res
            }
            res.intervals = _date.default.getSequenceByInterval(min, max, options.minorTickInterval);
            if (tickInterval !== options.minorTickInterval) {
                res.altIntervals = res.intervals;
                min = correctValueByInterval(min, isDate, tickInterval, firstDayOfWeek);
                max = correctValueByInterval(max, isDate, tickInterval, firstDayOfWeek);
                res.intervals = _date.default.getSequenceByInterval(min, max, tickInterval);
                res.intervals[0] = res.altIntervals[0]
            }
            return res
        }

        function getPrecisionForSlider(startValue, endValue, screenDelta) {
            var d = Math.abs(endValue - startValue) / screenDelta;
            var tail = d - _floor(d);
            return tail > 0 ? _ceil(Math.abs((0, _math.adjust)((0, _utils.getLog)(tail, 10)))) : 0
        }
        var dxRangeSelector = _base_widget.default.inherit({
            _toggleParentsScrollSubscription: function() {},
            _eventsMap: {
                onValueChanged: {
                    name: VALUE_CHANGED
                }
            },
            _rootClassPrefix: "dxrs",
            _rootClass: "dxrs-range-selector",
            _dataIsReady: function() {
                return this._dataIsLoaded()
            },
            _initialChanges: ["DATA_SOURCE", "VALUE"],
            _themeDependentChanges: ["MOSTLY_TOTAL"],
            _themeSection: "rangeSelector",
            _fontFields: ["scale.label.font", "sliderMarker.font"],
            _initCore: function() {
                var that = this;
                var renderer = that._renderer;
                var root = renderer.root;
                root.css({
                    "touch-action": "pan-y"
                });
                that._clipRect = renderer.clipRect();
                var rangeViewGroup = renderer.g().attr({
                    "class": "dxrs-view"
                }).append(root);
                var slidersGroup = renderer.g().attr({
                    "class": "dxrs-slidersContainer",
                    "clip-path": that._clipRect.id
                }).append(root);
                var scaleGroup = renderer.g().attr({
                    "class": "dxrs-scale",
                    "clip-path": that._clipRect.id
                }).append(root);
                var scaleBreaksGroup = renderer.g().attr({
                    "class": "dxrs-scale-breaks"
                }).append(root);
                var trackersGroup = renderer.g().attr({
                    "class": "dxrs-trackers"
                }).append(root);
                that._axis = new AxisWrapper({
                    renderer: renderer,
                    root: scaleGroup,
                    scaleBreaksGroup: scaleBreaksGroup,
                    updateSelectedRange: function(range, e) {
                        that.setValue((0, _utils.convertVisualRangeObject)(range), e)
                    },
                    incidentOccurred: that._incidentOccurred
                });
                that._rangeView = new _range_view.RangeView({
                    renderer: renderer,
                    root: rangeViewGroup,
                    translator: that._axis.getTranslator()
                });
                that._slidersController = new _sliders_controller.SlidersController({
                    renderer: renderer,
                    root: slidersGroup,
                    trackersGroup: trackersGroup,
                    updateSelectedRange: function(range, lastSelectedRange, e) {
                        if (!that._rangeOption) {
                            that.option(VALUE, (0, _utils.convertVisualRangeObject)(range, (0, _type2.isPlainObject)(that._options.silent(VALUE))))
                        }
                        that._eventTrigger(VALUE_CHANGED, {
                            value: (0, _utils.convertVisualRangeObject)(range),
                            previousValue: (0, _utils.convertVisualRangeObject)(lastSelectedRange),
                            event: e
                        })
                    },
                    axis: that._axis,
                    translator: that._axis.getTranslator()
                });
                that._tracker = new _tracker.Tracker({
                    renderer: renderer,
                    controller: that._slidersController
                })
            },
            _getDefaultSize: function() {
                return {
                    width: 400,
                    height: 160
                }
            },
            _disposeCore: function() {
                this._axis.dispose();
                this._slidersController.dispose();
                this._tracker.dispose()
            },
            _applySize: function(rect) {
                this._clientRect = rect.slice();
                this._change(["MOSTLY_TOTAL"])
            },
            _optionChangesMap: {
                scale: "SCALE",
                value: "VALUE",
                dataSource: "DATA_SOURCE"
            },
            _optionChangesOrder: ["SCALE", "DATA_SOURCE"],
            _change_SCALE: function() {
                this._change(["MOSTLY_TOTAL"])
            },
            _setValueByDataSource: function() {
                var that = this;
                var options = that._options.silent();
                var axis = that._axis;
                if (options.dataSource) {
                    var selectedRangeUpdateMode = that.option("selectedRangeUpdateMode");
                    var value = that.getValue();
                    var valueIsReady = (0, _type2.isDefined)(value[0]) && (0, _type2.isDefined)(value[1]);
                    if ((0, _type2.isDefined)(selectedRangeUpdateMode)) {
                        selectedRangeUpdateMode = (0, _utils.normalizeEnum)(selectedRangeUpdateMode);
                        that.__skipAnimation = true
                    } else {
                        if (valueIsReady && !that._dataSourceIsAsync) {
                            selectedRangeUpdateMode = RESET
                        }
                    }
                    if ("auto" === selectedRangeUpdateMode && valueIsReady) {
                        var rangesInfo = axis.allScaleSelected(value);
                        if (rangesInfo.startValue && rangesInfo.endValue) {
                            selectedRangeUpdateMode = RESET
                        } else {
                            if (rangesInfo.endValue) {
                                selectedRangeUpdateMode = SHIFT
                            } else {
                                selectedRangeUpdateMode = KEEP
                            }
                        }
                    }
                    if (selectedRangeUpdateMode === RESET) {
                        options[VALUE] = null
                    } else {
                        if (selectedRangeUpdateMode === SHIFT && valueIsReady) {
                            var _value = that.getValue();
                            that.__skipAnimation = true;
                            options[VALUE] = {
                                length: axis.getVisualRangeLength({
                                    minVisible: _value[0],
                                    maxVisible: _value[1]
                                })
                            }
                        } else {
                            if (selectedRangeUpdateMode === KEEP) {
                                that.__skipAnimation = true
                            }
                        }
                    }
                }
                that._dataSourceIsAsync = void 0
            },
            _change_DATA_SOURCE: function() {
                if (this._options.silent("dataSource")) {
                    this._updateDataSource()
                }
            },
            _customChangesOrder: ["MOSTLY_TOTAL", "VALUE", "SLIDER_SELECTION"],
            _change_MOSTLY_TOTAL: function() {
                this._applyMostlyTotalChange()
            },
            _change_SLIDER_SELECTION: function() {
                var that = this;
                var value = that._options.silent(VALUE);
                that._slidersController.setSelectedRange(value && (0, _utils.getVizRangeObject)(value))
            },
            _change_VALUE: function() {
                var that = this;
                var option = that._rangeOption;
                that._dataSourceIsAsync = !that._dataIsReady();
                if (option) {
                    that._options.silent(VALUE, option);
                    that.setValue(option)
                }
            },
            _validateRange: function(start, end) {
                var that = this;
                var translator = that._axis.getTranslator();
                if ((0, _type2.isDefined)(start) && !translator.isValid(start) || (0, _type2.isDefined)(end) && !translator.isValid(end)) {
                    that._incidentOccurred("E2203")
                }
            },
            _applyChanges: function() {
                var that = this;
                var value = that._options.silent(VALUE);
                if (that._changes.has("VALUE") && value) {
                    that._rangeOption = value
                }
                that.callBase.apply(that, arguments);
                that._rangeOption = null;
                that.__isResizing = that.__skipAnimation = false
            },
            _applyMostlyTotalChange: function() {
                var that = this;
                var renderer = that._renderer;
                var rect = that._clientRect;
                var currentAnimationEnabled;
                var canvas = {
                    left: rect[0],
                    top: rect[1],
                    width: rect[2] - rect[0],
                    height: rect[3] - rect[1]
                };
                if (that.__isResizing || that.__skipAnimation) {
                    currentAnimationEnabled = renderer.animationEnabled();
                    renderer.updateAnimationOptions({
                        enabled: false
                    })
                }
                that._clipRect.attr({
                    x: rect[0],
                    y: rect[1],
                    width: rect[2] - rect[0],
                    height: rect[3] - rect[1]
                });
                that._axis.getTranslator().update(new _range.Range, canvas, {
                    isHorizontal: true
                });
                that._updateContent({
                    left: rect[0],
                    top: rect[1],
                    width: rect[2] - rect[0],
                    height: rect[3] - rect[1]
                });
                if (that.__isResizing || that.__skipAnimation) {
                    renderer.updateAnimationOptions({
                        enabled: currentAnimationEnabled
                    })
                }
                that._drawn()
            },
            _dataSourceChangedHandler: function() {
                this._setValueByDataSource();
                this._requestChange(["MOSTLY_TOTAL"])
            },
            _completeSeriesDataSourceCreation: function(scaleOptions, seriesDataSource) {
                var rect = this._clientRect;
                var canvas = {
                    left: rect[0],
                    top: rect[1],
                    width: rect[2] - rect[0],
                    height: rect[3] - rect[1]
                };
                this._axis.updateOptions((0, _extend.extend)({}, scaleOptions, {
                    isHorizontal: true,
                    label: {}
                }));
                seriesDataSource.isShowChart() && this._axis.setMarginOptions(seriesDataSource.getMarginOptions(canvas));
                this._axis.updateCanvas(canvas);
                seriesDataSource.createPoints()
            },
            _updateContent: function(canvas) {
                var that = this;
                var chartOptions = that.option("chart");
                var seriesDataSource = that._createSeriesDataSource(chartOptions);
                var isCompactMode = !(seriesDataSource && seriesDataSource.isShowChart() || that.option("background.image.url"));
                var scaleOptions = prepareScaleOptions(that._getOption("scale"), seriesDataSource && seriesDataSource.getCalculatedValueType(), that._incidentOccurred, this._getOption("containerBackgroundColor", true));
                seriesDataSource && that._completeSeriesDataSourceCreation(scaleOptions, seriesDataSource);
                var argTranslatorRange = calculateTranslatorRange(seriesDataSource, scaleOptions);
                var tickIntervalsInfo = updateTickIntervals(scaleOptions, canvas.width, that._incidentOccurred, argTranslatorRange);
                var chartThemeManager = seriesDataSource && seriesDataSource.isShowChart() && seriesDataSource.getThemeManager();
                if (chartThemeManager) {
                    checkLogarithmicOptions(chartOptions && chartOptions.valueAxis, chartThemeManager.getOptions("valueAxis").logarithmBase, that._incidentOccurred)
                }
                updateScaleOptions(scaleOptions, seriesDataSource, argTranslatorRange, tickIntervalsInfo, getDateMarkerVisibilityChecker(canvas.width));
                updateTranslatorRangeInterval(argTranslatorRange, scaleOptions);
                var sliderMarkerOptions = that._prepareSliderMarkersOptions(scaleOptions, canvas.width, tickIntervalsInfo, argTranslatorRange);
                var indents = calculateIndents(that._renderer, scaleOptions, sliderMarkerOptions, that.option("indent"), tickIntervalsInfo);
                var rangeContainerCanvas = {
                    left: canvas.left + indents.left,
                    top: canvas.top + indents.top,
                    width: canvas.left + indents.left + _max(canvas.width - indents.left - indents.right, 1),
                    height: _max(!isCompactMode ? canvas.height - indents.top - indents.bottom - calculateScaleAreaHeight(that._renderer, scaleOptions, showScaleMarkers(scaleOptions), tickIntervalsInfo) : _common.HEIGHT_COMPACT_MODE, 0),
                    right: 0,
                    bottom: 0
                };
                that._axis.update(scaleOptions, isCompactMode, rangeContainerCanvas, argTranslatorRange, seriesDataSource);
                scaleOptions.minorTickInterval = scaleOptions.isEmpty ? 0 : scaleOptions.minorTickInterval;
                that._updateElements(scaleOptions, sliderMarkerOptions, isCompactMode, rangeContainerCanvas, seriesDataSource);
                if (chartThemeManager) {
                    chartThemeManager.dispose()
                }
            },
            _updateElements: function(scaleOptions, sliderMarkerOptions, isCompactMode, canvas, seriesDataSource) {
                var that = this;
                var behavior = that._getOption("behavior");
                var shutterOptions = that._getOption("shutter");
                var isNotSemiDiscrete = scaleOptions.type !== SEMIDISCRETE;
                shutterOptions.color = shutterOptions.color || that._getOption(CONTAINER_BACKGROUND_COLOR, true);
                that._rangeView.update(that.option("background"), that._themeManager.theme("background"), canvas, isCompactMode, behavior.animationEnabled && that._renderer.animationEnabled(), seriesDataSource);
                that._isUpdating = true;
                that._slidersController.update([canvas.top, canvas.top + canvas.height], behavior, isCompactMode, that._getOption("sliderHandle"), sliderMarkerOptions, shutterOptions, {
                    minRange: isNotSemiDiscrete ? that.option("scale.minRange") : void 0,
                    maxRange: isNotSemiDiscrete ? that.option("scale.maxRange") : void 0
                }, that._axis.getFullTicks(), that._getOption("selectedRangeColor", true));
                that._requestChange(["SLIDER_SELECTION"]);
                that._isUpdating = false;
                that._tracker.update(!that._axis.getTranslator().getBusinessRange().isEmpty(), behavior)
            },
            _createSeriesDataSource: function(chartOptions) {
                var that = this;
                var seriesDataSource;
                var dataSource = that._dataSourceItems();
                var scaleOptions = that._getOption("scale");
                var valueType = scaleOptions.valueType || calculateValueType(scaleOptions.startValue, scaleOptions.endValue);
                var valueAxis = new _base_axis.Axis({
                    renderer: that._renderer,
                    axisType: "xyAxes",
                    drawingType: "linear"
                });
                valueAxis.updateOptions({
                    isHorizontal: false,
                    label: {},
                    categoriesSortingMethod: that._getOption("chart").valueAxis.categoriesSortingMethod
                });
                if (dataSource || chartOptions && chartOptions.series) {
                    chartOptions = (0, _extend.extend)({}, chartOptions, {
                        theme: that.option("theme")
                    });
                    seriesDataSource = new _series_data_source.SeriesDataSource({
                        renderer: that._renderer,
                        dataSource: dataSource,
                        valueType: (0, _utils.normalizeEnum)(valueType),
                        axisType: scaleOptions.type,
                        chart: chartOptions,
                        dataSourceField: that.option("dataSourceField"),
                        incidentOccurred: that._incidentOccurred,
                        categories: scaleOptions.categories,
                        argumentAxis: that._axis,
                        valueAxis: valueAxis
                    })
                }
                return seriesDataSource
            },
            _prepareSliderMarkersOptions: function(scaleOptions, screenDelta, tickIntervalsInfo, argRange) {
                var that = this;
                var minorTickInterval = tickIntervalsInfo.minorTickInterval;
                var tickInterval = tickIntervalsInfo.tickInterval;
                var interval = tickInterval;
                var endValue = scaleOptions.endValue;
                var startValue = scaleOptions.startValue;
                var sliderMarkerOptions = that._getOption(SLIDER_MARKER);
                var doNotSnap = !that._getOption("behavior").snapToTicks;
                var isTypeDiscrete = scaleOptions.type === DISCRETE;
                var isValueTypeDatetime = scaleOptions.valueType === DATETIME;
                sliderMarkerOptions.borderColor = that._getOption(CONTAINER_BACKGROUND_COLOR, true);
                if (!sliderMarkerOptions.format && !argRange.isEmpty()) {
                    if (doNotSnap && (0, _type2.isNumeric)(scaleOptions.startValue)) {
                        sliderMarkerOptions.format = {
                            type: "fixedPoint",
                            precision: getPrecisionForSlider(startValue, endValue, screenDelta)
                        }
                    }
                    if (isValueTypeDatetime && !isTypeDiscrete) {
                        if ((0, _type2.isDefined)(minorTickInterval) && 0 !== minorTickInterval) {
                            interval = getMinorTickIntervalUnit(tickInterval, minorTickInterval, doNotSnap)
                        }
                        if (!scaleOptions.marker.visible) {
                            if ((0, _type2.isDefined)(startValue) && (0, _type2.isDefined)(endValue)) {
                                sliderMarkerOptions.format = _format_helper.default.getDateFormatByTickInterval(startValue, endValue, interval)
                            }
                        } else {
                            sliderMarkerOptions.format = _date.default.getDateFormatByTickInterval(interval)
                        }
                    }
                    if (isValueTypeDatetime && isTypeDiscrete && tickIntervalsInfo.ticks.length) {
                        sliderMarkerOptions.format = _format_helper.default.getDateFormatByTicks(tickIntervalsInfo.ticks)
                    }
                }
                return sliderMarkerOptions
            },
            getValue: function() {
                return (0, _utils.convertVisualRangeObject)(this._slidersController.getSelectedRange())
            },
            setValue: function(value, e) {
                var visualRange = (0, _utils.getVizRangeObject)(value);
                if (!this._isUpdating && value) {
                    this._validateRange(visualRange.startValue, visualRange.endValue);
                    !(0, _utils.rangesAreEqual)(visualRange, this._slidersController.getSelectedRange()) && this._slidersController.setSelectedRange(visualRange, e)
                }
            },
            _setContentSize: function() {
                this.__isResizing = 2 === this._changes.count();
                this.callBase.apply(this, arguments)
            }
        });
        (0, _iterator.each)(["selectedRangeColor", "containerBackgroundColor", "sliderMarker", "sliderHandle", "shutter", OPTION_BACKGROUND, "behavior", "chart", "indent"], function(_, name) {
            dxRangeSelector.prototype._optionChangesMap[name] = "MOSTLY_TOTAL"
        });

        function prepareAxisOptions(scaleOptions, isCompactMode, height, axisPosition) {
            scaleOptions.marker.label.font = scaleOptions.label.font;
            scaleOptions.color = scaleOptions.marker.color = scaleOptions.tick.color;
            scaleOptions.opacity = scaleOptions.marker.opacity = scaleOptions.tick.opacity;
            scaleOptions.width = scaleOptions.marker.width = scaleOptions.tick.width;
            scaleOptions.placeholderSize = (scaleOptions.placeholderHeight || 0) + axisPosition;
            scaleOptions.argumentType = scaleOptions.valueType;
            scaleOptions.visible = isCompactMode;
            scaleOptions.isHorizontal = true;
            scaleOptions.calculateMinors = true;
            scaleOptions.semiDiscreteInterval = scaleOptions.minRange;
            if (!isCompactMode) {
                scaleOptions.minorTick.length = scaleOptions.tick.length = height
            }
            scaleOptions.label.indentFromAxis = scaleOptions.label.topIndent + axisPosition;
            return scaleOptions
        }

        function createDateMarkersEvent(scaleOptions, markerTrackers, setSelectedRange) {
            (0, _iterator.each)(markerTrackers, function(_, value) {
                value.on("dxpointerdown", onPointerDown)
            });

            function onPointerDown(e) {
                var range = e.target.range;
                var minRange = scaleOptions.minRange ? _date.default.addInterval(range.startValue, scaleOptions.minRange) : void 0;
                var maxRange = scaleOptions.maxRange ? _date.default.addInterval(range.startValue, scaleOptions.maxRange) : void 0;
                if (!(minRange && minRange > range.endValue || maxRange && maxRange < range.endValue)) {
                    setSelectedRange(range, e)
                }
            }
        }

        function getShiftDirection() {
            return 1
        }

        function getTickStartPositionShift(length) {
            return length % 2 === 1 ? -_floor(length / 2) : -length / 2;
        }

        function AxisWrapper(params) {
            var that = this;
            that._axis = new _base_axis.Axis({
                renderer: params.renderer,
                axesContainerGroup: params.root,
                scaleBreaksGroup: params.scaleBreaksGroup,
                incidentOccurred: params.incidentOccurred,
                axisType: "xyAxes",
                drawingType: "linear",
                widgetClass: "dxrs",
                axisClass: "range-selector",
                isArgumentAxis: true,
                getTemplate: function() {}
            });
            that._updateSelectedRangeCallback = params.updateSelectedRange;
            that._axis.getAxisSharpDirection = that._axis.getSharpDirectionByCoords = getShiftDirection;
            that._axis.getTickStartPositionShift = getTickStartPositionShift
        }
        AxisWrapper.prototype = {
            constructor: AxisWrapper,
            dispose: function() {
                this._axis.dispose()
            },
            calculateInterval: function(value, prevValue) {
                return this._axis.calculateInterval(value, prevValue)
            },
            update: function(options, isCompactMode, canvas, businessRange, seriesDataSource) {
                var axis = this._axis;
                axis.updateOptions(prepareAxisOptions(options, isCompactMode, canvas.height, canvas.height / 2 - _ceil(options.width / 2)));
                axis.validate();
                axis.setBusinessRange(businessRange, true);
                if (void 0 !== seriesDataSource && seriesDataSource.isShowChart()) {
                    axis.setMarginOptions(seriesDataSource.getMarginOptions(canvas))
                }
                axis.draw(canvas);
                axis.shift({
                    left: 0,
                    bottom: -canvas.height / 2 + canvas.top
                });
                if (axis.getMarkerTrackers()) {
                    createDateMarkersEvent(options, axis.getMarkerTrackers(), this._updateSelectedRangeCallback)
                }
                axis.drawScaleBreaks({
                    start: canvas.top,
                    end: canvas.top + canvas.height
                })
            },
            visualRange: function() {},
            getViewport: function() {
                return {}
            },
            allScaleSelected: function(value) {
                var _this$_axis$visualRan = this._axis.visualRange(),
                    startValue = _this$_axis$visualRan.startValue,
                    endValue = _this$_axis$visualRan.endValue;
                return {
                    startValue: value[0].valueOf() === startValue.valueOf(),
                    endValue: value[1].valueOf() === endValue.valueOf()
                }
            },
            getOptions: function() {
                return this._axis.getOptions() || {}
            }
        };
        ["setMarginOptions", "getFullTicks", "updateCanvas", "updateOptions", "getAggregationInfo", "getTranslator", "getVisualRangeLength", "getVisibleArea", "getMarginOptions"].forEach(function(methodName) {
            AxisWrapper.prototype[methodName] = function() {
                var axis = this._axis;
                return axis[methodName].apply(axis, arguments)
            }
        });
        (0, _component_registrator.default)("dxRangeSelector", dxRangeSelector);
        var _default = dxRangeSelector;
        exports.default = _default;
        dxRangeSelector.addPlugin(_export.plugin);
        dxRangeSelector.addPlugin(_title.plugin);
        dxRangeSelector.addPlugin(_loading_indicator.plugin);
        dxRangeSelector.addPlugin(_data_source.plugin);
        module.exports = exports.default
    },
    /*!***************************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/range_selector/sliders_controller.js ***!
      \***************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.SlidersController = SlidersController;
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _common2 = __webpack_require__( /*! ./common */ 229);
        var _slider = _interopRequireDefault(__webpack_require__( /*! ./slider */ 957));
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _math = __webpack_require__( /*! ../../core/utils/math */ 29);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var animationSettings = _common2.utils.animationSettings;
        var emptySliderMarkerText = _common2.consts.emptySliderMarkerText;

        function buildRectPoints(left, top, right, bottom) {
            return [left, top, right, top, right, bottom, left, bottom]
        }

        function isLess(a, b) {
            return a < b
        }

        function isGreater(a, b) {
            return a > b
        }

        function selectClosestValue(target, values) {
            var start = 0;
            var end = values ? values.length - 1 : 0;
            var middle;
            var val = target;
            while (end - start > 1) {
                middle = start + end >> 1;
                val = values[middle];
                if (val === target) {
                    return target
                } else {
                    if (target < val) {
                        end = middle
                    } else {
                        start = middle
                    }
                }
            }
            if (values) {
                val = values[target - values[start] <= values[end] - target ? start : end]
            }
            return val
        }

        function dummyProcessSelectionChanged() {
            this._lastSelectedRange = this.getSelectedRange();
            delete this._processSelectionChanged
        }

        function suppressSetSelectedRange(controller) {
            controller.setSelectedRange = _common.noop;
            if (controller._processSelectionChanged === dummyProcessSelectionChanged) {
                controller._processSelectionChanged()
            }
        }

        function restoreSetSelectedRange(controller) {
            delete controller.setSelectedRange
        }

        function SlidersController(params) {
            var that = this;
            var sliderParams = {
                renderer: params.renderer,
                root: params.root,
                trackersGroup: params.trackersGroup,
                translator: params.translator
            };
            that._params = params;
            that._areaTracker = params.renderer.path(null, "area").attr({
                "class": "area-tracker",
                fill: "#000000",
                opacity: 1e-4
            }).append(params.trackersGroup);
            that._selectedAreaTracker = params.renderer.path(null, "area").attr({
                "class": "selected-area-tracker",
                fill: "#000000",
                opacity: 1e-4
            }).append(params.trackersGroup);
            that._shutter = params.renderer.path(null, "area").append(params.root);
            that._sliders = [new _slider.default(sliderParams, 0), new _slider.default(sliderParams, 1)];
            that._processSelectionChanged = dummyProcessSelectionChanged
        }
        SlidersController.prototype = {
            constructor: SlidersController,
            dispose: function() {
                this._sliders[0].dispose();
                this._sliders[1].dispose()
            },
            getTrackerTargets: function() {
                return {
                    area: this._areaTracker,
                    selectedArea: this._selectedAreaTracker,
                    sliders: this._sliders
                }
            },
            _processSelectionChanged: function(e) {
                var that = this;
                var selectedRange = that.getSelectedRange();
                if (!(0, _utils.rangesAreEqual)(selectedRange, that._lastSelectedRange)) {
                    that._params.updateSelectedRange(selectedRange, that._lastSelectedRange, e);
                    that._lastSelectedRange = selectedRange
                }
            },
            update: function(verticalRange, behavior, isCompactMode, sliderHandleOptions, sliderMarkerOptions, shutterOptions, rangeBounds, fullTicks, selectedRangeColor) {
                var that = this;
                var screenRange = that._params.translator.getScreenRange();
                that._verticalRange = verticalRange;
                that._minRange = rangeBounds.minRange;
                that._maxRange = rangeBounds.maxRange;
                that._animationEnabled = behavior.animationEnabled && that._params.renderer.animationEnabled();
                that._allowSlidersSwap = behavior.allowSlidersSwap;
                that._sliders[0].update(verticalRange, sliderHandleOptions, sliderMarkerOptions);
                that._sliders[1].update(verticalRange, sliderHandleOptions, sliderMarkerOptions);
                that._sliders[0]._position = that._sliders[1]._position = screenRange[0];
                that._values = !that._params.translator.isValueProlonged && behavior.snapToTicks ? fullTicks : null;
                that._areaTracker.attr({
                    points: buildRectPoints(screenRange[0], verticalRange[0], screenRange[1], verticalRange[1])
                });
                that._isCompactMode = isCompactMode;
                that._shutterOffset = sliderHandleOptions.width / 2;
                that._updateSelectedView(shutterOptions, selectedRangeColor);
                that._isOnMoving = "onmoving" === (0, _utils.normalizeEnum)(behavior.callValueChanged);
                that._updateSelectedRange();
                that._applyTotalPosition(false)
            },
            _updateSelectedView: function(shutterOptions, selectedRangeColor) {
                var settings = {
                    fill: null,
                    "fill-opacity": null,
                    stroke: null,
                    "stroke-width": null
                };
                if (this._isCompactMode) {
                    settings.stroke = selectedRangeColor;
                    settings["stroke-width"] = 3;
                    settings.sharp = "v"
                } else {
                    settings.fill = shutterOptions.color;
                    settings["fill-opacity"] = shutterOptions.opacity
                }
                this._shutter.attr(settings)
            },
            _updateSelectedRange: function() {
                var that = this;
                var sliders = that._sliders;
                sliders[0].cancelAnimation();
                sliders[1].cancelAnimation();
                that._shutter.stopAnimation();
                if (that._params.translator.getBusinessRange().isEmpty()) {
                    sliders[0]._setText(emptySliderMarkerText);
                    sliders[1]._setText(emptySliderMarkerText);
                    sliders[0]._value = sliders[1]._value = void 0;
                    sliders[0]._position = that._params.translator.getScreenRange()[0];
                    sliders[1]._position = that._params.translator.getScreenRange()[1];
                    that._applyTotalPosition(false);
                    suppressSetSelectedRange(that)
                } else {
                    restoreSetSelectedRange(that)
                }
            },
            _applyTotalPosition: function(isAnimated) {
                var sliders = this._sliders;
                isAnimated = this._animationEnabled && isAnimated;
                sliders[0].applyPosition(isAnimated);
                sliders[1].applyPosition(isAnimated);
                var areOverlapped = sliders[0].getCloudBorder() > sliders[1].getCloudBorder();
                sliders[0].setOverlapped(areOverlapped);
                sliders[1].setOverlapped(areOverlapped);
                this._applyAreaTrackersPosition();
                this._applySelectedRangePosition(isAnimated)
            },
            _applyAreaTrackersPosition: function() {
                var that = this;
                var position1 = that._sliders[0].getPosition();
                var position2 = that._sliders[1].getPosition();
                that._selectedAreaTracker.attr({
                    points: buildRectPoints(position1, that._verticalRange[0], position2, that._verticalRange[1])
                }).css({
                    cursor: Math.abs(that._params.translator.getScreenRange()[1] - that._params.translator.getScreenRange()[0] - position2 + position1) < .001 ? "default" : "pointer"
                })
            },
            _applySelectedRangePosition: function(isAnimated) {
                var that = this;
                var verticalRange = that._verticalRange;
                var pos1 = that._sliders[0].getPosition();
                var pos2 = that._sliders[1].getPosition();
                var screenRange;
                var points;
                if (that._isCompactMode) {
                    points = [pos1 + Math.ceil(that._shutterOffset), (verticalRange[0] + verticalRange[1]) / 2, pos2 - Math.floor(that._shutterOffset), (verticalRange[0] + verticalRange[1]) / 2]
                } else {
                    screenRange = that._params.axis.getVisibleArea();
                    points = [buildRectPoints(screenRange[0], verticalRange[0], Math.max(pos1 - Math.floor(that._shutterOffset), screenRange[0]), verticalRange[1]), buildRectPoints(screenRange[1], verticalRange[0], Math.min(pos2 + Math.ceil(that._shutterOffset), screenRange[1]), verticalRange[1])]
                }
                if (isAnimated) {
                    that._shutter.animate({
                        points: points
                    }, animationSettings)
                } else {
                    that._shutter.attr({
                        points: points
                    })
                }
            },
            getSelectedRange: function() {
                return {
                    startValue: this._sliders[0].getValue(),
                    endValue: this._sliders[1].getValue()
                }
            },
            setSelectedRange: function(visualRange, e) {
                visualRange = visualRange || {};
                var that = this;
                var translator = that._params.translator;
                var businessRange = translator.getBusinessRange();
                var compare = "discrete" === businessRange.axisType ? function(a, b) {
                    return a < b
                } : function(a, b) {
                    return a <= b
                };
                var _adjustVisualRange = (0, _utils.adjustVisualRange)({
                        dataType: businessRange.dataType,
                        axisType: businessRange.axisType,
                        base: businessRange.base
                    }, {
                        startValue: translator.isValid(visualRange.startValue) ? translator.getCorrectValue(visualRange.startValue, 1) : void 0,
                        endValue: translator.isValid(visualRange.endValue) ? translator.getCorrectValue(visualRange.endValue, -1) : void 0,
                        length: visualRange.length
                    }, {
                        min: businessRange.minVisible,
                        max: businessRange.maxVisible,
                        categories: businessRange.categories
                    }),
                    startValue = _adjustVisualRange.startValue,
                    endValue = _adjustVisualRange.endValue;
                startValue = (0, _type.isNumeric)(startValue) ? (0, _math.adjust)(startValue) : startValue;
                endValue = (0, _type.isNumeric)(endValue) ? (0, _math.adjust)(endValue) : endValue;
                var values = compare(translator.to(startValue, -1), translator.to(endValue, 1)) ? [startValue, endValue] : [endValue, startValue];
                that._sliders[0].setDisplayValue(values[0]);
                that._sliders[1].setDisplayValue(values[1]);
                that._sliders[0]._position = translator.to(values[0], -1);
                that._sliders[1]._position = translator.to(values[1], 1);
                that._applyTotalPosition(true);
                that._processSelectionChanged(e)
            },
            beginSelectedAreaMoving: function(initialPosition) {
                var that = this;
                var sliders = that._sliders;
                var offset = (sliders[0].getPosition() + sliders[1].getPosition()) / 2 - initialPosition;
                var currentPosition = initialPosition;
                move.complete = function(e) {
                    that._dockSelectedArea(e)
                };
                return move;

                function move(position, e) {
                    if (position !== currentPosition && position > currentPosition === position > (sliders[0].getPosition() + sliders[1].getPosition()) / 2 - offset) {
                        that._moveSelectedArea(position + offset, false, e)
                    }
                    currentPosition = position
                }
            },
            _dockSelectedArea: function(e) {
                var translator = this._params.translator;
                var sliders = this._sliders;
                sliders[0]._position = translator.to(sliders[0].getValue(), -1);
                sliders[1]._position = translator.to(sliders[1].getValue(), 1);
                this._applyTotalPosition(true);
                this._processSelectionChanged(e)
            },
            moveSelectedArea: function(screenPosition, e) {
                this._moveSelectedArea(screenPosition, true, e);
                this._dockSelectedArea(e)
            },
            _moveSelectedArea: function(screenPosition, isAnimated, e) {
                var that = this;
                var translator = that._params.translator;
                var sliders = that._sliders;
                var interval = sliders[1].getPosition() - sliders[0].getPosition();
                var startPosition = screenPosition - interval / 2;
                var endPosition = screenPosition + interval / 2;
                if (startPosition < translator.getScreenRange()[0]) {
                    startPosition = translator.getScreenRange()[0];
                    endPosition = startPosition + interval
                }
                if (endPosition > translator.getScreenRange()[1]) {
                    endPosition = translator.getScreenRange()[1];
                    startPosition = endPosition - interval
                }
                var startValue = selectClosestValue(translator.from(startPosition, -1), that._values);
                sliders[0].setDisplayValue(startValue);
                sliders[1].setDisplayValue(selectClosestValue(translator.from(translator.to(startValue, -1) + interval, 1), that._values));
                sliders[0]._position = startPosition;
                sliders[1]._position = endPosition;
                that._applyTotalPosition(isAnimated);
                if (that._isOnMoving) {
                    that._processSelectionChanged(e)
                }
            },
            placeSliderAndBeginMoving: function(firstPosition, secondPosition, e) {
                var that = this;
                var translator = that._params.translator;
                var sliders = that._sliders;
                var index = firstPosition < secondPosition ? 0 : 1;
                var dir = index > 0 ? 1 : -1;
                var compare = index > 0 ? isGreater : isLess;
                var antiCompare = index > 0 ? isLess : isGreater;
                var thresholdPosition;
                var positions = [];
                var values = [];
                values[index] = translator.from(firstPosition, dir);
                values[1 - index] = translator.from(secondPosition, -dir);
                positions[1 - index] = secondPosition;
                if (translator.isValueProlonged) {
                    if (compare(firstPosition, translator.to(values[index], dir))) {
                        values[index] = translator.from(firstPosition, -dir)
                    }
                    if (compare(secondPosition, translator.to(values[index], -dir))) {
                        values[1 - index] = values[index]
                    }
                }
                if (that._minRange) {
                    thresholdPosition = translator.to(translator.add(selectClosestValue(values[index], that._values), that._minRange, -dir), -dir);
                    if (compare(secondPosition, thresholdPosition)) {
                        values[1 - index] = translator.add(values[index], that._minRange, -dir)
                    }
                    thresholdPosition = translator.to(translator.add(translator.getRange()[1 - index], that._minRange, dir), -dir);
                    if (antiCompare(firstPosition, thresholdPosition)) {
                        values[1 - index] = translator.getRange()[1 - index];
                        values[index] = translator.add(values[1 - index], that._minRange, dir);
                        positions[1 - index] = firstPosition
                    }
                }
                values[0] = selectClosestValue(values[0], that._values);
                values[1] = selectClosestValue(values[1], that._values);
                positions[index] = translator.to(values[index], dir);
                sliders[0].setDisplayValue(values[0]);
                sliders[1].setDisplayValue(values[1]);
                sliders[0]._position = positions[0];
                sliders[1]._position = positions[1];
                that._applyTotalPosition(true);
                if (that._isOnMoving) {
                    that._processSelectionChanged(e)
                }
                var handler = that.beginSliderMoving(1 - index, secondPosition);
                sliders[1 - index]._sliderGroup.stopAnimation();
                that._shutter.stopAnimation();
                handler(secondPosition);
                return handler
            },
            beginSliderMoving: function(initialIndex, initialPosition) {
                var that = this;
                var translator = that._params.translator;
                var sliders = that._sliders;
                var minPosition = translator.getScreenRange()[0];
                var maxPosition = translator.getScreenRange()[1];
                var index = initialIndex;
                var staticPosition = sliders[1 - index].getPosition();
                var currentPosition = initialPosition;
                var dir = index > 0 ? 1 : -1;
                var compareMin = index > 0 ? isLess : isGreater;
                var compareMax = index > 0 ? isGreater : isLess;
                var moveOffset = sliders[index].getPosition() - initialPosition;
                var swapOffset = compareMin(sliders[index].getPosition(), initialPosition) ? -moveOffset : moveOffset;
                move.complete = function(e) {
                    sliders[index]._setValid(true);
                    that._dockSelectedArea(e)
                };
                return move;

                function move(position, e) {
                    var isValid;
                    var temp;
                    var pos;
                    var slider;
                    var value;
                    if (position !== currentPosition) {
                        if (compareMin(position + swapOffset, staticPosition)) {
                            isValid = that._allowSlidersSwap;
                            if (isValid && !translator.isValueProlonged && that._minRange) {
                                isValid = translator.isValid(translator.add(sliders[1 - index].getValue(), that._minRange, -dir))
                            }
                            if (isValid) {
                                that._changeMovingSlider(index);
                                index = 1 - index;
                                dir = -dir;
                                temp = compareMin;
                                compareMin = compareMax;
                                compareMax = temp;
                                moveOffset = -dir * Math.abs(moveOffset);
                                swapOffset = -moveOffset
                            }
                        }
                        if (compareMax(position + moveOffset, staticPosition)) {
                            isValid = true;
                            slider = sliders[index];
                            value = sliders[1 - index].getValue();
                            pos = Math.max(Math.min(position + moveOffset, maxPosition), minPosition);
                            if (isValid && translator.isValueProlonged) {
                                isValid = !compareMin(pos, translator.to(value, dir))
                            }
                            var invalidStateValue;
                            if (isValid && that._minRange) {
                                isValid = !compareMin(pos, translator.to(translator.add(value, that._minRange, dir), dir));
                                if (!isValid) {
                                    invalidStateValue = translator.add(value, that._minRange, dir)
                                }
                            }
                            if (isValid && that._maxRange) {
                                isValid = !compareMax(pos, translator.to(translator.add(value, that._maxRange, dir), dir));
                                if (!isValid) {
                                    invalidStateValue = translator.add(value, that._maxRange, dir)
                                }
                            }
                            slider._setValid(isValid);
                            slider.setDisplayValue(isValid ? selectClosestValue(translator.from(pos, dir), that._values) : (0, _type.isDefined)(invalidStateValue) ? invalidStateValue : slider.getValue());
                            slider._position = pos;
                            that._applyTotalPosition(false);
                            slider.toForeground();
                            if (that._isOnMoving) {
                                that._processSelectionChanged(e)
                            }
                        }
                    }
                    currentPosition = position
                }
            },
            _changeMovingSlider: function(index) {
                var that = this;
                var translator = that._params.translator;
                var sliders = that._sliders;
                var position = sliders[1 - index].getPosition();
                var dir = index > 0 ? 1 : -1;
                var newValue;
                sliders[index].setDisplayValue(selectClosestValue(translator.from(position, dir), that._values));
                newValue = translator.from(position, -dir);
                if (translator.isValueProlonged) {
                    newValue = translator.from(position, dir)
                } else {
                    if (that._minRange) {
                        newValue = translator.add(newValue, that._minRange, -dir)
                    }
                }
                sliders[1 - index].setDisplayValue(selectClosestValue(newValue, that._values));
                sliders[index]._setValid(true);
                sliders[index]._marker._update();
                sliders[0]._position = sliders[1]._position = position
            },
            foregroundSlider: function(index) {
                this._sliders[index].toForeground()
            }
        }
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/range_selector/slider.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _common = __webpack_require__( /*! ./common */ 229);
        var _slider_marker = _interopRequireDefault(__webpack_require__( /*! ./slider_marker */ 958));
        var _support = __webpack_require__( /*! ../../core/utils/support */ 45);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var animationSettings = _common.utils.animationSettings;
        var SPLITTER_WIDTH = 8;
        var TOUCH_SPLITTER_WIDTH = 20;

        function getSliderTrackerWidth(sliderHandleWidth) {
            return _support.touchEvents || _support.pointerEvents ? TOUCH_SPLITTER_WIDTH : SPLITTER_WIDTH < sliderHandleWidth ? sliderHandleWidth : SPLITTER_WIDTH
        }

        function Slider(params, index) {
            var that = this;
            that._translator = params.translator;
            that._sliderGroup = params.renderer.g().attr({
                "class": "slider"
            }).append(params.root);
            that._line = params.renderer.path(null, "line").append(that._sliderGroup);
            that._marker = new _slider_marker.default(params.renderer, that._sliderGroup, 1 === index);
            that._tracker = params.renderer.rect().attr({
                "class": "slider-tracker",
                fill: "#000000",
                opacity: 1e-4
            }).css({
                cursor: "w-resize"
            }).append(params.trackersGroup)
        }
        Slider.prototype = {
            constructor: Slider,
            cancelAnimation: function() {
                this._sliderGroup.stopAnimation();
                this._tracker.stopAnimation()
            },
            applyPosition: function(isAnimated) {
                var that = this;
                var slider = that._sliderGroup;
                var tracker = that._tracker;
                var attrs = {
                    translateX: that._position
                };
                that._marker.setPosition(that._position);
                if (isAnimated) {
                    slider.animate(attrs, animationSettings);
                    tracker.animate(attrs, animationSettings)
                } else {
                    slider.attr(attrs);
                    tracker.attr(attrs)
                }
            },
            _setValid: function(isValid) {
                this._marker.setValid(isValid);
                this._line.attr({
                    stroke: this._colors[Number(isValid)]
                })
            },
            _setText: function(text) {
                this._marker.setText(text)
            },
            update: function(verticalRange, sliderHandleOptions, sliderMarkerOptions) {
                var that = this;
                that._formatOptions = {
                    format: sliderMarkerOptions.format,
                    customizeText: sliderMarkerOptions.customizeText
                };
                that._marker.applyOptions(sliderMarkerOptions, that._translator.getScreenRange());
                that._colors = [sliderMarkerOptions.invalidRangeColor, sliderHandleOptions.color];
                that._sliderGroup.attr({
                    translateY: verticalRange[0]
                });
                that._line.attr({
                    "stroke-width": sliderHandleOptions.width,
                    stroke: sliderHandleOptions.color,
                    "stroke-opacity": sliderHandleOptions.opacity,
                    sharp: "h",
                    points: [0, 0, 0, verticalRange[1] - verticalRange[0]]
                });
                var trackerWidth = getSliderTrackerWidth(sliderHandleOptions.width);
                that._tracker.attr({
                    x: -trackerWidth / 2,
                    y: 0,
                    width: trackerWidth,
                    height: verticalRange[1] - verticalRange[0],
                    translateY: verticalRange[0]
                })
            },
            toForeground: function() {
                this._sliderGroup.toForeground()
            },
            getSliderTracker: function() {
                return this._tracker
            },
            getPosition: function() {
                return this._position
            },
            setDisplayValue: function(value) {
                this._value = value;
                this._setText((0, _common.formatValue)(value, this._formatOptions))
            },
            setOverlapped: function(isOverlapped) {
                this._marker.setOverlapped(isOverlapped)
            },
            getValue: function() {
                return this._value
            },
            on: function(event, handler) {
                this._tracker.on(event, handler);
                this._marker.getTracker().on(event, handler)
            },
            getCloudBorder: function() {
                return this._marker.getBorderPosition()
            },
            dispose: function() {
                this._marker.dispose()
            }
        };
        var _default = Slider;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/range_selector/slider_marker.js ***!
      \**********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _common = __webpack_require__( /*! ./common */ 229);
        var POINTER_SIZE = _common.consts.pointerSize;
        var SLIDER_MARKER_UPDATE_DELAY = 75;

        function SliderMarker(renderer, root, isLeftPointer) {
            var that = this;
            that._isLeftPointer = isLeftPointer;
            that._isOverlapped = false;
            that._group = renderer.g().attr({
                "class": "slider-marker"
            }).append(root);
            that._area = renderer.path(null, "area").append(that._group);
            that._label = renderer.text().attr({
                align: "left"
            }).append(that._group);
            that._tracker = renderer.rect().attr({
                "class": "slider-marker-tracker",
                fill: "#000000",
                opacity: 1e-4
            }).css({
                cursor: "pointer"
            }).append(that._group);
            that._border = renderer.rect(0, 0, 1, 0)
        }
        SliderMarker.prototype = {
            constructor: SliderMarker,
            _getRectSize: function(textSize) {
                return {
                    width: Math.round(2 * this._paddingLeftRight + textSize.width),
                    height: Math.round(2 * this._paddingTopBottom + textSize.height)
                }
            },
            _getTextSize: function() {
                var textSize = this._label.getBBox();
                if (!this._textHeight && isFinite(textSize.height)) {
                    this._textHeight = textSize.height
                }
                return {
                    width: textSize.width,
                    height: this._textHeight,
                    y: textSize.y
                }
            },
            _getAreaPointsInfo: function(textSize) {
                var that = this;
                var rectSize = that._getRectSize(textSize);
                var rectWidth = rectSize.width;
                var rectHeight = rectSize.height;
                var rectLeftBorder = -rectWidth;
                var rectRightBorder = 0;
                var pointerRightPoint = POINTER_SIZE;
                var pointerCenterPoint = 0;
                var pointerLeftPoint = -POINTER_SIZE;
                var position = that._position;
                var isLeft = that._isLeftPointer;
                var correctCloudBorders = function() {
                    rectLeftBorder++;
                    rectRightBorder++;
                    pointerRightPoint++;
                    pointerCenterPoint++;
                    pointerLeftPoint++
                };
                var checkPointerBorders = function() {
                    if (pointerRightPoint > rectRightBorder) {
                        pointerRightPoint = rectRightBorder
                    } else {
                        if (pointerLeftPoint < rectLeftBorder) {
                            pointerLeftPoint = rectLeftBorder
                        }
                    }
                    isLeft && correctCloudBorders()
                };
                var borderPosition = position;
                if (isLeft) {
                    if (position > that._range[1] - rectWidth) {
                        rectRightBorder = -position + that._range[1];
                        rectLeftBorder = rectRightBorder - rectWidth;
                        checkPointerBorders();
                        borderPosition += rectLeftBorder
                    } else {
                        rectLeftBorder = pointerLeftPoint = 0;
                        rectRightBorder = rectWidth
                    }
                } else {
                    if (position - that._range[0] < rectWidth) {
                        rectLeftBorder = -(position - that._range[0]);
                        rectRightBorder = rectLeftBorder + rectWidth;
                        checkPointerBorders();
                        borderPosition += rectRightBorder
                    } else {
                        pointerRightPoint = 0;
                        correctCloudBorders()
                    }
                }
                that._borderPosition = borderPosition;
                return {
                    offset: rectLeftBorder,
                    isCut: (!isLeft || pointerCenterPoint !== pointerLeftPoint) && (isLeft || pointerCenterPoint !== pointerRightPoint),
                    points: [rectLeftBorder, 0, rectRightBorder, 0, rectRightBorder, rectHeight, pointerRightPoint, rectHeight, pointerCenterPoint, rectHeight + POINTER_SIZE, pointerLeftPoint, rectHeight, rectLeftBorder, rectHeight]
                }
            },
            _update: function() {
                var that = this;
                var textSize;
                clearTimeout(that._timeout);
                that._label.attr({
                    text: that._text || ""
                });
                var currentTextSize = that._getTextSize();
                var rectSize = that._getRectSize(currentTextSize);
                textSize = that._textSize || currentTextSize;
                textSize = that._textSize = currentTextSize.width > textSize.width || currentTextSize.height > textSize.height ? currentTextSize : textSize;
                that._timeout = setTimeout(function() {
                    updateSliderMarker(currentTextSize, rectSize);
                    that._textSize = currentTextSize
                }, SLIDER_MARKER_UPDATE_DELAY);

                function updateSliderMarker(size, rectSize) {
                    rectSize = rectSize || that._getRectSize(size);
                    that._group.attr({
                        translateY: -(rectSize.height + POINTER_SIZE)
                    });
                    var pointsData = that._getAreaPointsInfo(size);
                    var points = pointsData.points;
                    var offset = pointsData.offset;
                    that._area.attr({
                        points: points
                    });
                    that._border.attr({
                        x: that._isLeftPointer ? points[0] - 1 : points[2],
                        height: pointsData.isCut ? rectSize.height : rectSize.height + POINTER_SIZE
                    });
                    that._tracker.attr({
                        translateX: offset,
                        width: rectSize.width,
                        height: rectSize.height + POINTER_SIZE
                    });
                    that._label.attr({
                        translateX: that._paddingLeftRight + offset,
                        translateY: rectSize.height / 2 - (size.y + size.height / 2)
                    })
                }
                updateSliderMarker(textSize)
            },
            setText: function(value) {
                this._text = value
            },
            setPosition: function(position) {
                this._position = position;
                this._update()
            },
            applyOptions: function(options, screenRange) {
                var that = this;
                that._range = screenRange;
                that._paddingLeftRight = options.paddingLeftRight;
                that._paddingTopBottom = options.paddingTopBottom;
                that._textHeight = null;
                that._colors = [options.invalidRangeColor, options.color];
                that._area.attr({
                    fill: options.color
                });
                that._border.attr({
                    fill: options.borderColor
                });
                that._label.css((0, _utils.patchFontOptions)(options.font));
                that._update()
            },
            getTracker: function() {
                return this._tracker
            },
            setValid: function(isValid) {
                this._area.attr({
                    fill: this._colors[Number(isValid)]
                })
            },
            setColor: function(color) {
                this._area.attr({
                    fill: color
                })
            },
            dispose: function() {
                clearTimeout(this._timeout)
            },
            setOverlapped: function(isOverlapped) {
                var that = this;
                if (that._isOverlapped !== isOverlapped) {
                    if (isOverlapped) {
                        that._border.append(that._group)
                    } else {
                        that._isOverlapped && that._border.remove()
                    }
                    that._isOverlapped = isOverlapped
                }
            },
            getBorderPosition: function() {
                return this._borderPosition
            }
        };
        var _default = SliderMarker;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!****************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/range_selector/tracker.js ***!
      \****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.Tracker = Tracker;
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _pointer = _interopRequireDefault(__webpack_require__( /*! ../../events/pointer */ 24));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _support = __webpack_require__( /*! ../../core/utils/support */ 45);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                })
            } else {
                obj[key] = value
            }
            return obj
        }
        var MIN_MANUAL_SELECTING_WIDTH = 10;
        var window = (0, _window.getWindow)();

        function isLeftButtonPressed(event) {
            var e = event || window.event;
            var originalEvent = e.originalEvent;
            var touches = e.touches;
            var pointerType = originalEvent ? originalEvent.pointerType : false;
            var eventTouches = originalEvent ? originalEvent.touches : false;
            var isMSPointerLeftClick = originalEvent && void 0 !== pointerType && (pointerType === (originalEvent.MSPOINTER_TYPE_TOUCH || "touch") || pointerType === (originalEvent.MSPOINTER_TYPE_MOUSE || "mouse") && 1 === originalEvent.buttons);
            var isTouches = touches && touches.length > 0 || eventTouches && eventTouches.length > 0;
            return 1 === e.which || isMSPointerLeftClick || isTouches
        }

        function isMultiTouches(event) {
            var originalEvent = event.originalEvent;
            var touches = event.touches;
            var eventTouches = originalEvent && originalEvent.touches;
            return touches && touches.length > 1 || eventTouches && eventTouches.length > 1 || null
        }

        function preventDefault(e) {
            if (!isMultiTouches(e)) {
                e.preventDefault()
            }
        }

        function stopPropagationAndPreventDefault(e) {
            if (!isMultiTouches(e)) {
                e.stopPropagation();
                e.preventDefault()
            }
        }

        function isTouchEventArgs(e) {
            return e && e.type && 0 === e.type.indexOf("touch")
        }

        function getEventPageX(event) {
            var originalEvent = event.originalEvent;
            var result = 0;
            if (event.pageX) {
                result = event.pageX
            } else {
                if (originalEvent && originalEvent.pageX) {
                    result = originalEvent.pageX
                }
            }
            if (originalEvent && originalEvent.touches) {
                if (originalEvent.touches.length > 0) {
                    result = originalEvent.touches[0].pageX
                } else {
                    if (originalEvent.changedTouches.length > 0) {
                        result = originalEvent.changedTouches[0].pageX
                    }
                }
            }
            return result
        }

        function initializeAreaEvents(controller, area, state, getRootOffsetLeft) {
            var _docEvents;
            var isTouchEvent;
            var isActive = false;
            var initialPosition;
            var movingHandler = null;
            var docEvents = (_docEvents = {}, _defineProperty(_docEvents, _pointer.default.move, function(e) {
                var position;
                var offset;
                if (isTouchEvent !== isTouchEventArgs(e)) {
                    return
                }
                if (!isLeftButtonPressed(e)) {
                    cancel(e)
                }
                if (isActive) {
                    position = getEventPageX(e);
                    offset = getRootOffsetLeft();
                    if (movingHandler) {
                        movingHandler(position - offset, e)
                    } else {
                        if (state.manualRangeSelectionEnabled && Math.abs(initialPosition - position) >= MIN_MANUAL_SELECTING_WIDTH) {
                            movingHandler = controller.placeSliderAndBeginMoving(initialPosition - offset, position - offset, e)
                        }
                    }
                }
            }), _defineProperty(_docEvents, _pointer.default.up, function(e) {
                var position;
                if (isActive) {
                    position = getEventPageX(e);
                    if (!movingHandler && state.moveSelectedRangeByClick && Math.abs(initialPosition - position) < MIN_MANUAL_SELECTING_WIDTH) {
                        controller.moveSelectedArea(position - getRootOffsetLeft(), e)
                    }
                    cancel(e)
                }
            }), _docEvents);

            function cancel(e) {
                if (isActive) {
                    isActive = false;
                    if (movingHandler) {
                        movingHandler.complete(e);
                        movingHandler = null
                    }
                }
            }
            area.on(_pointer.default.down, function(e) {
                if (!state.enabled || !isLeftButtonPressed(e) || isActive) {
                    return
                }
                isActive = true;
                isTouchEvent = isTouchEventArgs(e);
                initialPosition = getEventPageX(e)
            });
            return docEvents
        }

        function initializeSelectedAreaEvents(controller, area, state, getRootOffsetLeft) {
            var _docEvents2;
            var isTouchEvent;
            var isActive = false;
            var movingHandler = null;
            var docEvents = (_docEvents2 = {}, _defineProperty(_docEvents2, _pointer.default.move, function(e) {
                if (isTouchEvent !== isTouchEventArgs(e)) {
                    return
                }
                if (!isLeftButtonPressed(e)) {
                    cancel(e)
                }
                if (isActive) {
                    preventDefault(e);
                    movingHandler(getEventPageX(e) - getRootOffsetLeft(), e)
                }
            }), _defineProperty(_docEvents2, _pointer.default.up, cancel), _docEvents2);

            function cancel(e) {
                if (isActive) {
                    isActive = false;
                    movingHandler.complete(e);
                    movingHandler = null
                }
            }
            area.on(_pointer.default.down, function(e) {
                if (!state.enabled || !isLeftButtonPressed(e) || isActive) {
                    return
                }
                isActive = true;
                isTouchEvent = isTouchEventArgs(e);
                movingHandler = controller.beginSelectedAreaMoving(getEventPageX(e) - getRootOffsetLeft());
                stopPropagationAndPreventDefault(e)
            });
            return docEvents
        }

        function initializeSliderEvents(controller, sliders, state, getRootOffsetLeft) {
            var _docEvents3;
            var isTouchEvent;
            var isActive = false;
            var movingHandler = null;
            var docEvents = (_docEvents3 = {}, _defineProperty(_docEvents3, _pointer.default.move, function(e) {
                if (isTouchEvent !== isTouchEventArgs(e)) {
                    return
                }
                if (!isLeftButtonPressed(e)) {
                    cancel(e)
                }
                if (isActive) {
                    preventDefault(e);
                    movingHandler(getEventPageX(e) - getRootOffsetLeft(), e)
                }
            }), _defineProperty(_docEvents3, _pointer.default.up, cancel), _docEvents3);
            (0, _iterator.each)(sliders, function(i, slider) {
                var _slider$on;
                slider.on((_slider$on = {}, _defineProperty(_slider$on, _pointer.default.down, function(e) {
                    if (!state.enabled || !isLeftButtonPressed(e) || isActive) {
                        return
                    }
                    isActive = true;
                    isTouchEvent = isTouchEventArgs(e);
                    movingHandler = controller.beginSliderMoving(i, getEventPageX(e) - getRootOffsetLeft());
                    stopPropagationAndPreventDefault(e)
                }), _defineProperty(_slider$on, _pointer.default.move, function() {
                    if (!movingHandler) {
                        controller.foregroundSlider(i)
                    }
                }), _slider$on))
            });

            function cancel(e) {
                if (isActive) {
                    isActive = false;
                    movingHandler.complete(e);
                    movingHandler = null
                }
            }
            return docEvents
        }

        function Tracker(params) {
            var state = this._state = {};
            var targets = params.controller.getTrackerTargets();
            if (_support.pointerEvents) {
                params.renderer.root.css({
                    msTouchAction: "pinch-zoom"
                })
            }
            this._docEvents = [initializeSelectedAreaEvents(params.controller, targets.selectedArea, state, getRootOffsetLeft), initializeAreaEvents(params.controller, targets.area, state, getRootOffsetLeft), initializeSliderEvents(params.controller, targets.sliders, state, getRootOffsetLeft)];
            (0, _iterator.each)(this._docEvents, function(_, events) {
                _events_engine.default.on(_dom_adapter.default.getDocument(), events)
            });

            function getRootOffsetLeft() {
                return params.renderer.getRootOffset().left
            }
        }
        Tracker.prototype = {
            constructor: Tracker,
            dispose: function() {
                (0, _iterator.each)(this._docEvents, function(_, events) {
                    _events_engine.default.off(_dom_adapter.default.getDocument(), events)
                })
            },
            update: function(enabled, behavior) {
                var state = this._state;
                state.enabled = enabled;
                state.moveSelectedRangeByClick = behavior.moveSelectedRangeByClick;
                state.manualRangeSelectionEnabled = behavior.manualRangeSelectionEnabled
            }
        }
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/range_selector/range_view.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.RangeView = RangeView;

        function drawSeriesView(root, seriesDataSource, canvas, isAnimationEnabled) {
            var seriesList = seriesDataSource.getSeries();
            if (!seriesList.length) {
                return
            }
            var valueAxis = seriesList[0].getValueAxis();
            valueAxis.updateCanvas({
                top: canvas.top,
                bottom: 0,
                height: canvas.height + canvas.top
            });
            seriesDataSource.adjustSeriesDimensions();
            var valueRange = seriesDataSource.getBoundRange().val;
            valueRange.sortCategories(valueAxis.getCategoriesSorter());
            valueAxis.setBusinessRange(valueRange);
            seriesList.forEach(function(series) {
                series._extGroups.seriesGroup = series._extGroups.labelsGroup = root;
                series.draw(isAnimationEnabled)
            })
        }

        function merge(a, b) {
            return void 0 !== a ? a : b
        }

        function RangeView(params) {
            this._params = params;
            this._clipRect = params.renderer.clipRect();
            params.root.attr({
                "clip-path": this._clipRect.id
            })
        }
        RangeView.prototype = {
            constructor: RangeView,
            update: function(backgroundOption, backgroundTheme, canvas, isCompactMode, isAnimationEnabled, seriesDataSource) {
                var renderer = this._params.renderer;
                var root = this._params.root;
                var canvasWidth = canvas.width - canvas.left;
                var seriesGroup;
                backgroundOption = backgroundOption || {};
                root.clear();
                this._clipRect.attr({
                    x: canvas.left,
                    y: canvas.top,
                    width: canvasWidth,
                    height: canvas.height
                });
                if (!isCompactMode) {
                    if (merge(backgroundOption.visible, backgroundTheme.visible)) {
                        if (backgroundOption.color) {
                            renderer.rect(canvas.left, canvas.top, canvasWidth + 1, canvas.height).attr({
                                fill: merge(backgroundOption.color, backgroundTheme.color),
                                "class": "dx-range-selector-background"
                            }).append(root)
                        }
                        if (backgroundOption.image && backgroundOption.image.url) {
                            renderer.image(canvas.left, canvas.top, canvasWidth + 1, canvas.height, backgroundOption.image.url, merge(backgroundOption.image.location, backgroundTheme.image.location)).append(root)
                        }
                    }
                    if (seriesDataSource && seriesDataSource.isShowChart()) {
                        seriesGroup = renderer.g().attr({
                            "class": "dxrs-series-group"
                        }).append(root);
                        drawSeriesView(seriesGroup, seriesDataSource, canvas, isAnimationEnabled)
                    }
                }
            }
        }
    },
    /*!***************************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/range_selector/series_data_source.js ***!
      \***************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.SeriesDataSource = void 0;
        var _base_series = __webpack_require__( /*! ../series/base_series */ 314);
        var _series_family = __webpack_require__( /*! ../core/series_family */ 473);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _range = __webpack_require__( /*! ../translators/range */ 124);
        var _data_validator = __webpack_require__( /*! ../components/data_validator */ 312);
        var _chart_theme_manager = __webpack_require__( /*! ../components/chart_theme_manager */ 464);
        var createThemeManager = function(chartOptions) {
            return new _chart_theme_manager.ThemeManager({
                options: chartOptions,
                themeSection: "rangeSelector.chart",
                fontFields: ["commonSeriesSettings.label.font"]
            })
        };
        var processSeriesFamilies = function(series, minBubbleSize, maxBubbleSize, barOptions, negativesAsZeroes) {
            var families = [];
            var types = [];
            (0, _iterator.each)(series, function(i, item) {
                if ((0, _array.inArray)(item.type, types) === -1) {
                    types.push(item.type)
                }
            });
            (0, _iterator.each)(types, function(_, type) {
                var family = new _series_family.SeriesFamily({
                    type: type,
                    minBubbleSize: minBubbleSize,
                    maxBubbleSize: maxBubbleSize,
                    barGroupPadding: barOptions.barGroupPadding,
                    barGroupWidth: barOptions.barGroupWidth,
                    negativesAsZeroes: negativesAsZeroes
                });
                family.add(series);
                family.adjustSeriesValues();
                families.push(family)
            });
            return families
        };
        var SeriesDataSource = function(options) {
            var that = this;
            var themeManager = that._themeManager = createThemeManager(options.chart);
            themeManager.setTheme(options.chart.theme);
            var topIndent = themeManager.getOptions("topIndent");
            var bottomIndent = themeManager.getOptions("bottomIndent");
            that._indent = {
                top: topIndent >= 0 && topIndent < 1 ? topIndent : 0,
                bottom: bottomIndent >= 0 && bottomIndent < 1 ? bottomIndent : 0
            };
            that._valueAxis = themeManager.getOptions("valueAxisRangeSelector") || {};
            that._hideChart = false;
            that._series = that._calculateSeries(options);
            that._seriesFamilies = []
        };
        exports.SeriesDataSource = SeriesDataSource;
        SeriesDataSource.prototype = {
            constructor: SeriesDataSource,
            _calculateSeries: function(options) {
                var that = this;
                var series = [];
                var particularSeriesOptions;
                var seriesTheme;
                var data = options.dataSource || [];
                var parsedData;
                var chartThemeManager = that._themeManager;
                var seriesTemplate = chartThemeManager.getOptions("seriesTemplate");
                var allSeriesOptions = seriesTemplate ? (0, _utils.processSeriesTemplate)(seriesTemplate, data) : options.chart.series;
                var dataSourceField;
                var valueAxis = that._valueAxis;
                var i;
                var newSeries;
                var groupsData;
                if (options.dataSource && !allSeriesOptions) {
                    dataSourceField = options.dataSourceField || "arg";
                    allSeriesOptions = {
                        argumentField: dataSourceField,
                        valueField: dataSourceField
                    };
                    that._hideChart = true
                }
                allSeriesOptions = Array.isArray(allSeriesOptions) ? allSeriesOptions : allSeriesOptions ? [allSeriesOptions] : [];
                for (i = 0; i < allSeriesOptions.length; i++) {
                    particularSeriesOptions = (0, _extend.extend)(true, {}, allSeriesOptions[i]);
                    particularSeriesOptions.rotated = false;
                    seriesTheme = chartThemeManager.getOptions("series", particularSeriesOptions, allSeriesOptions.length);
                    seriesTheme.argumentField = seriesTheme.argumentField || options.dataSourceField;
                    if (!seriesTheme.name) {
                        seriesTheme.name = "Series " + (i + 1).toString()
                    }
                    if (data && data.length > 0) {
                        newSeries = new _base_series.Series({
                            renderer: options.renderer,
                            argumentAxis: options.argumentAxis,
                            valueAxis: options.valueAxis,
                            incidentOccurred: options.incidentOccurred
                        }, seriesTheme);
                        series.push(newSeries)
                    }
                }
                if (series.length) {
                    groupsData = {
                        groups: [{
                            series: series,
                            valueAxis: options.valueAxis,
                            valueOptions: {
                                type: valueAxis.type,
                                valueType: dataSourceField ? options.valueType : valueAxis.valueType
                            }
                        }],
                        argumentOptions: {
                            categories: options.categories,
                            argumentType: options.valueType,
                            type: options.axisType
                        }
                    };
                    parsedData = (0, _data_validator.validateData)(data, groupsData, options.incidentOccurred, chartThemeManager.getOptions("dataPrepareSettings"));
                    that.argCategories = groupsData.categories;
                    for (i = 0; i < series.length; i++) {
                        series[i].updateData(parsedData[series[i].getArgumentField()])
                    }
                }
                return series
            },
            createPoints: function() {
                if (0 === this._series.length) {
                    return
                }
                var series = this._series;
                var viewport = new _range.Range;
                var axis = series[0].getArgumentAxis();
                var themeManager = this._themeManager;
                var negativesAsZeroes = themeManager.getOptions("negativesAsZeroes");
                var negativesAsZeros = themeManager.getOptions("negativesAsZeros");
                series.forEach(function(s) {
                    viewport.addRange(s.getArgumentRange())
                });
                axis.getTranslator().updateBusinessRange(viewport);
                series.forEach(function(s) {
                    s.createPoints()
                });
                this._seriesFamilies = processSeriesFamilies(series, themeManager.getOptions("minBubbleSize"), themeManager.getOptions("maxBubbleSize"), {
                    barGroupPadding: themeManager.getOptions("barGroupPadding"),
                    barGroupWidth: themeManager.getOptions("barGroupWidth")
                }, (0, _type.isDefined)(negativesAsZeroes) ? negativesAsZeroes : negativesAsZeros)
            },
            adjustSeriesDimensions: function() {
                (0, _iterator.each)(this._seriesFamilies, function(_, family) {
                    family.adjustSeriesDimensions()
                })
            },
            getBoundRange: function() {
                var that = this;
                var rangeData;
                var valueAxis = that._valueAxis;
                var valRange = new _range.Range({
                    min: valueAxis.min,
                    minVisible: valueAxis.min,
                    max: valueAxis.max,
                    maxVisible: valueAxis.max,
                    axisType: valueAxis.type,
                    base: valueAxis.logarithmBase
                });
                var argRange = new _range.Range({});
                var rangeYSize;
                var rangeVisibleSizeY;
                var minIndent;
                var maxIndent;
                (0, _iterator.each)(that._series, function(_, series) {
                    rangeData = series.getRangeData();
                    valRange.addRange(rangeData.val);
                    argRange.addRange(rangeData.arg)
                });
                if (!valRange.isEmpty() && !argRange.isEmpty()) {
                    minIndent = valueAxis.inverted ? that._indent.top : that._indent.bottom;
                    maxIndent = valueAxis.inverted ? that._indent.bottom : that._indent.top;
                    rangeYSize = valRange.max - valRange.min;
                    rangeVisibleSizeY = ((0, _type.isNumeric)(valRange.maxVisible) ? valRange.maxVisible : valRange.max) - ((0, _type.isNumeric)(valRange.minVisible) ? valRange.minVisible : valRange.min);
                    if ((0, _type.isDate)(valRange.min)) {
                        valRange.min = new Date(valRange.min.valueOf() - rangeYSize * minIndent)
                    } else {
                        valRange.min -= rangeYSize * minIndent
                    }
                    if ((0, _type.isDate)(valRange.max)) {
                        valRange.max = new Date(valRange.max.valueOf() + rangeYSize * maxIndent)
                    } else {
                        valRange.max += rangeYSize * maxIndent
                    }
                    if ((0, _type.isNumeric)(rangeVisibleSizeY)) {
                        valRange.maxVisible = valRange.maxVisible ? valRange.maxVisible + rangeVisibleSizeY * maxIndent : void 0;
                        valRange.minVisible = valRange.minVisible ? valRange.minVisible - rangeVisibleSizeY * minIndent : void 0
                    }
                    valRange.invert = valueAxis.inverted
                }
                return {
                    arg: argRange,
                    val: valRange
                }
            },
            getMarginOptions: function(canvas) {
                var bubbleSize = Math.min(canvas.width, canvas.height) * this._themeManager.getOptions("maxBubbleSize");
                return this._series.reduce(function(marginOptions, series) {
                    var seriesOptions = series.getMarginOptions();
                    if (true === seriesOptions.processBubbleSize) {
                        seriesOptions.size = bubbleSize
                    }
                    return (0, _utils.mergeMarginOptions)(marginOptions, seriesOptions)
                }, {})
            },
            getSeries: function() {
                return this._series
            },
            isEmpty: function() {
                return 0 === this.getSeries().length
            },
            isShowChart: function() {
                return !this._hideChart
            },
            getCalculatedValueType: function() {
                var series = this._series[0];
                return null === series || void 0 === series ? void 0 : series.argumentType
            },
            getThemeManager: function() {
                return this._themeManager
            }
        }
    },
    /*!****************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/vector_map.js ***!
      \****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _vector_map = _interopRequireDefault(__webpack_require__( /*! ./vector_map/vector_map */ 963));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _vector_map.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/vector_map/vector_map.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _projection = __webpack_require__( /*! ./projection.main */ 479);
        var _control_bar = __webpack_require__( /*! ./control_bar */ 964);
        var _gesture_handler = __webpack_require__( /*! ./gesture_handler */ 965);
        var _tracker = __webpack_require__( /*! ./tracker */ 966);
        var _data_exchanger = __webpack_require__( /*! ./data_exchanger */ 967);
        var _legend = __webpack_require__( /*! ./legend */ 968);
        var _layout = __webpack_require__( /*! ./layout */ 969);
        var _map_layer = __webpack_require__( /*! ./map_layer */ 970);
        var _tooltip_viewer = __webpack_require__( /*! ./tooltip_viewer */ 971);
        var _vector_map = __webpack_require__( /*! ./vector_map.utils */ 972);
        __webpack_require__( /*! ./projection */ 481);
        var _base_widget = _interopRequireDefault(__webpack_require__( /*! ../core/base_widget */ 113));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _export = __webpack_require__( /*! ../core/export */ 108);
        var _title = __webpack_require__( /*! ../core/title */ 121);
        var _tooltip = __webpack_require__( /*! ../core/tooltip */ 123);
        var _loading_indicator = __webpack_require__( /*! ../core/loading_indicator */ 145);
        var _annotations = __webpack_require__( /*! ../core/annotations */ 228);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DEFAULT_WIDTH = 800;
        var DEFAULT_HEIGHT = 400;
        var RE_STARTS_LAYERS = /^layers/;
        var RE_ENDS_DATA_SOURCE = /\.dataSource$/;

        function mergeBounds(sumBounds, dataBounds) {
            return dataBounds ? [Math.min(dataBounds[0], dataBounds[2], sumBounds[0]), Math.min(dataBounds[1], dataBounds[3], sumBounds[3]), Math.max(dataBounds[0], dataBounds[2], sumBounds[2]), Math.max(dataBounds[1], dataBounds[3], sumBounds[1])] : sumBounds
        }
        var dxVectorMap = _base_widget.default.inherit({
            _eventsMap: {
                onClick: {
                    name: "click"
                },
                onCenterChanged: {
                    name: "centerChanged"
                },
                onZoomFactorChanged: {
                    name: "zoomFactorChanged"
                },
                onHoverChanged: {
                    name: "hoverChanged"
                },
                onSelectionChanged: {
                    name: "selectionChanged"
                }
            },
            _rootClassPrefix: "dxm",
            _rootClass: "dxm-vector-map",
            _themeSection: "map",
            _fontFields: ["layer:area.label.font", "layer:marker:dot.label.font", "layer:marker:bubble.label.font", "layer:marker:pie.label.font", "layer:marker:image.label.font", "legend.font", "legend.title.font", "legend.title.subtitle.font"],
            _initLayerCollection: function(dataKey) {
                var that = this;
                that._layerCollection = new _map_layer.MapLayerCollection({
                    renderer: that._renderer,
                    projection: that._projection,
                    themeManager: that._themeManager,
                    tracker: that._tracker,
                    dataKey: dataKey,
                    eventTrigger: that._eventTrigger,
                    dataExchanger: that._dataExchanger,
                    tooltip: that._tooltip,
                    notifyDirty: that._notifyDirty,
                    notifyReady: that._notifyReady,
                    dataReady: function() {
                        var bounds;
                        if (that.option("getBoundsFromData") && !that.option("bounds")) {
                            that._preventProjectionEvents();
                            bounds = that._getBoundsFromData();
                            that._projection.setBounds(bounds);
                            that._allowProjectionEvents()
                        }
                        if (!that.option("projection")) {
                            bounds = bounds || that._getBoundsFromData();
                            if (Math.ceil(bounds[0]) < -180 || Math.ceil(bounds[3]) < -90 || Math.floor(bounds[2]) > 180 || Math.floor(bounds[1]) > 90) {
                                var longitudeLength = bounds[2] - bounds[0];
                                var latitudeLength = bounds[1] - bounds[3];
                                that._projection.setEngine({
                                    to: function(coordinates) {
                                        return [2 * (coordinates[0] - bounds[0]) / longitudeLength - 1, 2 * (coordinates[1] - bounds[3]) / latitudeLength - 1]
                                    },
                                    from: function(coordinates) {
                                        return [(coordinates[0] + 1) * longitudeLength / 2 + bounds[0], (coordinates[1] + 1) * latitudeLength / 2 + bounds[3]]
                                    }
                                })
                            }
                        }
                    }
                })
            },
            _getBoundsFromData: function() {
                var bounds = this._getBoundingBoxFromDataSource();
                if (!bounds) {
                    var boundsByData = (0, _map_layer.getMaxBound)(this.getLayers().map(function(l) {
                        return l.getBounds()
                    }));
                    if (boundsByData) {
                        bounds = boundsByData
                    }
                }
                bounds = bounds || [];
                bounds = [bounds[0], bounds[3], bounds[2], bounds[1]];
                return bounds
            },
            _initLegendsControl: function() {
                var that = this;
                that._legendsControl = new _legend.LegendsControl({
                    renderer: that._renderer,
                    container: that._root,
                    widget: that,
                    layoutControl: that._layoutControl,
                    themeManager: that._themeManager,
                    dataExchanger: that._dataExchanger,
                    notifyDirty: that._notifyDirty,
                    notifyReady: that._notifyReady
                })
            },
            _initControlBar: function(dataKey) {
                var that = this;
                that._controlBar = new _control_bar.ControlBar({
                    renderer: that._renderer,
                    container: that._root,
                    layoutControl: that._layoutControl,
                    projection: that._projection,
                    tracker: that._tracker,
                    dataKey: dataKey
                })
            },
            _initElements: function() {
                var that = this;
                var dataKey = (0, _vector_map.generateDataKey)();
                var notifyCounter = 0;
                var preventProjectionEvents;
                that._preventProjectionEvents = function() {
                    preventProjectionEvents = true
                };
                that._allowProjectionEvents = function() {
                    preventProjectionEvents = false
                };
                that._notifyDirty = function() {
                    that._resetIsReady();
                    ++notifyCounter
                };
                that._notifyReady = function() {
                    that._allowProjectionEvents();
                    if (0 === --notifyCounter) {
                        that._drawn()
                    }
                };
                that._preventProjectionEvents();
                that._dataExchanger = new _data_exchanger.DataExchanger;
                that._projection = new _projection.Projection({
                    centerChanged: function(value) {
                        if (!preventProjectionEvents) {
                            that._eventTrigger("centerChanged", {
                                center: value
                            })
                        }
                    },
                    zoomChanged: function(value) {
                        if (!preventProjectionEvents) {
                            that._eventTrigger("zoomFactorChanged", {
                                zoomFactor: value
                            })
                        }
                    }
                });
                that._tracker = new _tracker.Tracker({
                    root: that._root,
                    projection: that._projection,
                    dataKey: dataKey
                });
                that._gestureHandler = new _gesture_handler.GestureHandler({
                    projection: that._projection,
                    renderer: that._renderer,
                    tracker: that._tracker
                });
                that._layoutControl = new _layout.LayoutControl(that);
                that._layoutControl.suspend();
                that._initLayerCollection(dataKey);
                that._createHtmlStructure();
                that._initControlBar(dataKey);
                that._initLegendsControl();
                that._prepareExtraElements();
                that._tooltipViewer = new _tooltip_viewer.TooltipViewer({
                    tracker: that._tracker,
                    tooltip: that._tooltip,
                    layerCollection: that._layerCollection
                })
            },
            _change_RESUME_LAYOUT: function() {
                this._layoutControl.resume()
            },
            _initialChanges: ["PROJECTION", "RESUME_LAYOUT", "LAYOUT_INIT", "BOUNDS", "MAX_ZOOM_FACTOR", "ZOOM_FACTOR", "CENTER"],
            _layoutChangesOrder: ["RESUME_LAYOUT", "LAYERS"],
            _customChangesOrder: ["EXTRA_ELEMENTS"],
            _initCore: function() {
                this._root = this._renderer.root.attr({
                    align: "center",
                    cursor: "default"
                });
                this._initElements()
            },
            _disposeCore: function() {
                var that = this;
                that._controlBar.dispose();
                that._gestureHandler.dispose();
                that._tracker.dispose();
                that._legendsControl.dispose();
                that._layerCollection.dispose();
                that._layoutControl.dispose();
                that._tooltipViewer.dispose();
                that._dataExchanger.dispose();
                that._projection.dispose();
                that._dataExchanger = that._gestureHandler = that._projection = that._tracker = that._layoutControl = that._root = that._layerCollection = that._controlBar = that._legendsControl = null
            },
            _setupInteraction: function() {
                var options = {
                    centeringEnabled: !!(0, _utils.parseScalar)(this._getOption("panningEnabled", true), true),
                    zoomingEnabled: !!(0, _utils.parseScalar)(this._getOption("zoomingEnabled", true), true)
                };
                this._gestureHandler.setInteraction(options);
                this._controlBar.setInteraction(options)
            },
            _getDefaultSize: function() {
                return {
                    width: DEFAULT_WIDTH,
                    height: DEFAULT_HEIGHT
                }
            },
            _applySize: function(rect) {
                var layout = {
                    left: rect[0],
                    top: rect[1],
                    width: rect[2] - rect[0],
                    height: rect[3] - rect[1],
                    right: 0,
                    bottom: 0
                };
                this._projection.setSize(layout);
                this._layoutControl.setSize(layout);
                this._layerCollection.setRect([layout.left, layout.top, layout.width, layout.height]);
                this._requestChange(["EXTRA_ELEMENTS"])
            },
            _optionChanging: function(name, currentValue, nextValue) {
                if (currentValue && nextValue) {
                    if (RE_STARTS_LAYERS.test(name)) {
                        if (currentValue.dataSource && nextValue.dataSource && currentValue !== nextValue) {
                            currentValue.dataSource = null
                        } else {
                            if (RE_ENDS_DATA_SOURCE.test(name)) {
                                this.option(name, null)
                            }
                        }
                    }
                }
            },
            _applyChanges: function() {
                this._notifyDirty();
                this.callBase.apply(this, arguments);
                this._notifyReady()
            },
            _optionChangesMap: {
                background: "BACKGROUND",
                layers: "LAYERS",
                extraElements: "EXTRA_ELEMENTS",
                controlBar: "CONTROL_BAR",
                legends: "LEGENDS",
                touchEnabled: "TRACKER",
                wheelEnabled: "TRACKER",
                panningEnabled: "INTERACTION",
                zoomingEnabled: "INTERACTION",
                projection: "PROJECTION",
                bounds: "BOUNDS",
                maxZoomFactor: "MAX_ZOOM_FACTOR",
                zoomFactor: "ZOOM_FACTOR",
                center: "CENTER"
            },
            _optionChangesOrder: ["PROJECTION", "BOUNDS", "MAX_ZOOM_FACTOR", "ZOOM_FACTOR", "CENTER", "BACKGROUND", "CONTROL_BAR", "LEGENDS", "TRACKER", "INTERACTION"],
            _change_PROJECTION: function() {
                this._setProjection()
            },
            _change_BOUNDS: function() {
                this._setBounds()
            },
            _change_MAX_ZOOM_FACTOR: function() {
                this._setMaxZoom()
            },
            _change_ZOOM_FACTOR: function() {
                this._setZoom()
            },
            _change_CENTER: function() {
                this._setCenter()
            },
            _change_BACKGROUND: function() {
                this._setBackgroundOptions()
            },
            _change_LAYERS: function() {
                this._setLayerCollectionOptions()
            },
            _change_CONTROL_BAR: function() {
                this._setControlBarOptions()
            },
            _change_EXTRA_ELEMENTS: function() {
                this._renderExtraElements()
            },
            _change_LEGENDS: function() {
                this._setLegendsOptions()
            },
            _change_TRACKER: function() {
                this._setTrackerOptions()
            },
            _change_INTERACTION: function() {
                this._setupInteraction()
            },
            _themeDependentChanges: ["BACKGROUND", "LAYERS", "CONTROL_BAR", "LEGENDS", "TRACKER", "INTERACTION"],
            _setProjection: function() {
                this._projection.setEngine(this.option("projection"))
            },
            _setBounds: function() {
                this._projection.setBounds(this.option("bounds"))
            },
            _setMaxZoom: function() {
                this._projection.setMaxZoom(this.option("maxZoomFactor"))
            },
            _setZoom: function() {
                this._projection.setZoom(this.option("zoomFactor"))
            },
            _setCenter: function() {
                this._projection.setCenter(this.option("center"))
            },
            _setBackgroundOptions: function() {
                this._layerCollection.setBackgroundOptions(this._getOption("background"))
            },
            _setLayerCollectionOptions: function() {
                this._layerCollection.setOptions(this.option("layers"))
            },
            _getBoundingBoxFromDataSource: function() {
                var that = this;
                var layers = that._layerCollection.items();
                var infinityBounds = [1 / 0, -(1 / 0), -(1 / 0), 1 / 0];
                var resultBBox = layers && layers.length ? layers.reduce(function(sumBBox, l) {
                    var layerData = l.getData();
                    var itemCount = layerData.count();
                    if (itemCount > 0) {
                        var rootBBox = layerData.getBBox();
                        if (rootBBox) {
                            sumBBox = mergeBounds(sumBBox, rootBBox)
                        } else {
                            for (var i = 0; i < itemCount; i++) {
                                sumBBox = mergeBounds(sumBBox, layerData.getBBox(i))
                            }
                        }
                    }
                    return sumBBox
                }, infinityBounds) : void 0;
                return resultBBox === infinityBounds ? void 0 : resultBBox
            },
            _setControlBarOptions: function() {
                this._controlBar.setOptions(this._getOption("controlBar"))
            },
            _setLegendsOptions: function() {
                this._legendsControl.setOptions(this.option("legends"))
            },
            _setTrackerOptions: function() {
                this._tracker.setOptions({
                    touchEnabled: this._getOption("touchEnabled", true),
                    wheelEnabled: this._getOption("wheelEnabled", true)
                })
            },
            getLayers: function() {
                return this._layerCollection.items().map(function(l) {
                    return l.proxy
                })
            },
            getLayerByIndex: function(index) {
                var layer = this._layerCollection.byIndex(index);
                return layer ? layer.proxy : null
            },
            getLayerByName: function(name) {
                var layer = this._layerCollection.byName(name);
                return layer ? layer.proxy : null
            },
            clearSelection: function(_noEvent) {
                var layers = this._layerCollection.items();
                var i;
                var ii = layers.length;
                for (i = 0; i < ii; ++i) {
                    layers[i].clearSelection(_noEvent)
                }
                return this
            },
            center: function(value) {
                var that = this;
                if (void 0 === value) {
                    return that._projection.getCenter()
                } else {
                    that._projection.setCenter(value);
                    return that
                }
            },
            zoomFactor: function(value) {
                var that = this;
                if (void 0 === value) {
                    return that._projection.getZoom()
                } else {
                    that._projection.setZoom(value);
                    return that
                }
            },
            viewport: function(value) {
                var that = this;
                if (void 0 === value) {
                    return that._projection.getViewport()
                } else {
                    that._projection.setViewport(value);
                    return that
                }
            },
            convertCoordinates: function(coordinates) {
                coordinates = coordinates && coordinates.length ? coordinates : [arguments[0], arguments[1]];
                return this.convertToGeo(coordinates[0], coordinates[1])
            },
            convertToGeo: function(x, y) {
                return this._projection.fromScreenPoint([x, y])
            },
            convertToXY: function(longitude, latitude) {
                return this._projection.toScreenPoint([longitude, latitude])
            }
        });
        (0, _component_registrator.default)("dxVectorMap", dxVectorMap);
        var _default = dxVectorMap;
        exports.default = _default;
        dxVectorMap.addPlugin(_export.plugin);
        dxVectorMap.addPlugin(_title.plugin);
        dxVectorMap.addPlugin(_tooltip.plugin);
        dxVectorMap.addPlugin(_loading_indicator.plugin);
        dxVectorMap.addPlugin(_annotations.plugins.core);
        dxVectorMap.addPlugin(_annotations.plugins.vectorMap);
        module.exports = exports.default
    },
    /*!****************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/vector_map/control_bar.js ***!
      \****************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.ControlBar = ControlBar;
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _math = Math;
        var _min = _math.min;
        var _max = _math.max;
        var _round = _math.round;
        var _floor = _math.floor;
        var _sqrt = _math.sqrt;
        var parseHorizontalAlignment = (0, _utils.enumParser)(["left", "center", "right"]);
        var parseVerticalAlignment = (0, _utils.enumParser)(["top", "bottom"]);
        var COMMAND_RESET = "command-reset";
        var COMMAND_MOVE_UP = "command-move-up";
        var COMMAND_MOVE_RIGHT = "command-move-right";
        var COMMAND_MOVE_DOWN = "command-move-down";
        var COMMAND_MOVE_LEFT = "command-move-left";
        var COMMAND_ZOOM_IN = "command-zoom-in";
        var COMMAND_ZOOM_OUT = "command-zoom-out";
        var COMMAND_ZOOM_DRAG_LINE = "command-zoom-drag-line";
        var COMMAND_ZOOM_DRAG = "command-zoom-drag";
        var EVENT_TARGET_TYPE = "control-bar";
        var FLAG_CENTERING = 1;
        var FLAG_ZOOMING = 2;
        var SIZE_OPTIONS = {
            bigCircleSize: 58,
            smallCircleSize: 28,
            buttonSize: 10,
            arrowButtonOffset: 20,
            incDecButtonSize: 11,
            incButtonOffset: 66,
            decButtonOffset: 227,
            sliderLineStartOffset: 88.5,
            sliderLineEndOffset: 205.5,
            sliderLength: 20,
            sliderWidth: 8,
            trackerGap: 4
        };
        var OFFSET_X = 30.5;
        var OFFSET_Y = 30.5;
        var TOTAL_WIDTH = 61;
        var TOTAL_HEIGHT = 274;
        var COMMAND_TO_TYPE_MAP = {};
        COMMAND_TO_TYPE_MAP[COMMAND_RESET] = ResetCommand;
        COMMAND_TO_TYPE_MAP[COMMAND_MOVE_UP] = COMMAND_TO_TYPE_MAP[COMMAND_MOVE_RIGHT] = COMMAND_TO_TYPE_MAP[COMMAND_MOVE_DOWN] = COMMAND_TO_TYPE_MAP[COMMAND_MOVE_LEFT] = MoveCommand;
        COMMAND_TO_TYPE_MAP[COMMAND_ZOOM_IN] = COMMAND_TO_TYPE_MAP[COMMAND_ZOOM_OUT] = ZoomCommand;
        COMMAND_TO_TYPE_MAP[COMMAND_ZOOM_DRAG] = ZoomDragCommand;

        function ControlBar(parameters) {
            var that = this;
            that._params = parameters;
            that._createElements(parameters.renderer, parameters.container, parameters.dataKey);
            parameters.layoutControl.addItem(that);
            that._subscribeToProjection(parameters.projection);
            that._subscribeToTracker(parameters.tracker);
            that._createCallbacks(parameters.projection)
        }
        ControlBar.prototype = {
            constructor: ControlBar,
            _flags: 0,
            dispose: function() {
                var that = this;
                that._params.layoutControl.removeItem(that);
                that._root.linkRemove().linkOff();
                that._offProjection();
                that._offTracker();
                that._params = that._root = that._offProjection = that._offTracker = that._callbacks = null
            },
            _subscribeToProjection: function(projection) {
                var that = this;
                that._offProjection = projection.on({
                    engine: function() {
                        that._update()
                    },
                    zoom: updateZoom,
                    "max-zoom": function() {
                        that._zoomPartition = projection.getZoomScalePartition();
                        that._sliderUnitLength = that._sliderLineLength / that._zoomPartition;
                        updateZoom()
                    }
                });

                function updateZoom() {
                    that._adjustZoom(projection.getScaledZoom())
                }
            },
            _subscribeToTracker: function(tracker) {
                var that = this;
                var isActive = false;
                that._offTracker = tracker.on({
                    start: function(arg) {
                        isActive = arg.data.name === EVENT_TARGET_TYPE;
                        if (isActive) {
                            that._processStart(arg.data.index, arg)
                        }
                    },
                    move: function(arg) {
                        if (isActive) {
                            that._processMove(arg.data.index, arg)
                        }
                    },
                    end: function() {
                        if (isActive) {
                            that._processEnd();
                            isActive = false
                        }
                    }
                })
            },
            _createCallbacks: function(projection) {
                var that = this;
                that._callbacks = {
                    reset: function(isCenter, isZoom) {
                        if (isCenter) {
                            projection.setCenter(null)
                        }
                        if (isZoom) {
                            projection.setZoom(null)
                        }
                    },
                    beginMove: function() {
                        projection.beginMoveCenter()
                    },
                    endMove: function() {
                        projection.endMoveCenter()
                    },
                    move: function(shift) {
                        projection.moveCenter(shift)
                    },
                    zoom: function(_zoom) {
                        projection.setScaledZoom(_zoom)
                    }
                }
            },
            _createElements: function(renderer, container, dataKey) {
                var that = this;
                that._root = renderer.g().attr({
                    "class": "dxm-control-bar"
                }).linkOn(container, "control-bar");
                var buttonsGroups = that._buttonsGroup = renderer.g().attr({
                    "class": "dxm-control-buttons"
                }).append(that._root);
                var trackersGroup = renderer.g().attr({
                    stroke: "none",
                    "stroke-width": 0,
                    fill: "#000000",
                    opacity: 1e-4
                }).css({
                    cursor: "pointer"
                }).append(that._root);
                that._createButtons(renderer, dataKey, buttonsGroups);
                that._createTrackers(renderer, dataKey, trackersGroup)
            },
            _createButtons: function(renderer, dataKey, group) {
                var that = this;
                var options = SIZE_OPTIONS;
                var size = options.buttonSize / 2;
                var offset1 = options.arrowButtonOffset - size;
                var offset2 = options.arrowButtonOffset;
                var incDecButtonSize = options.incDecButtonSize / 2;
                var directionOptions = {
                    "stroke-linecap": "square",
                    fill: "none"
                };
                var line = "line";
                renderer.circle(0, 0, options.bigCircleSize / 2).append(group);
                renderer.circle(0, 0, size).attr({
                    fill: "none"
                }).append(group);
                renderer.path([-size, -offset1, 0, -offset2, size, -offset1], line).attr(directionOptions).append(group);
                renderer.path([offset1, -size, offset2, 0, offset1, size], line).attr(directionOptions).append(group);
                renderer.path([size, offset1, 0, offset2, -size, offset1], line).attr(directionOptions).append(group);
                renderer.path([-offset1, size, -offset2, 0, -offset1, -size], line).attr(directionOptions).append(group);
                renderer.circle(0, options.incButtonOffset, options.smallCircleSize / 2).append(group);
                renderer.path([
                    [-incDecButtonSize, options.incButtonOffset, incDecButtonSize, options.incButtonOffset],
                    [0, options.incButtonOffset - incDecButtonSize, 0, options.incButtonOffset + incDecButtonSize]
                ], "area").append(group);
                renderer.circle(0, options.decButtonOffset, options.smallCircleSize / 2).append(group);
                renderer.path([-incDecButtonSize, options.decButtonOffset, incDecButtonSize, options.decButtonOffset], "area").append(group);
                that._zoomLine = renderer.path([], "line").append(group);
                that._zoomDrag = renderer.rect(_floor(-options.sliderLength / 2), _floor(options.sliderLineEndOffset - options.sliderWidth / 2), options.sliderLength, options.sliderWidth).append(group);
                that._sliderLineLength = options.sliderLineEndOffset - options.sliderLineStartOffset
            },
            _createTrackers: function(renderer, dataKey, group) {
                var options = SIZE_OPTIONS;
                var size = _round((options.arrowButtonOffset - options.trackerGap) / 2);
                var offset1 = options.arrowButtonOffset - size;
                var offset2 = _round(_sqrt(options.bigCircleSize * options.bigCircleSize / 4 - size * size));
                var size2 = offset2 - offset1;
                renderer.rect(-size, -size, 2 * size, 2 * size).data(dataKey, {
                    index: COMMAND_RESET,
                    name: EVENT_TARGET_TYPE
                }).append(group);
                renderer.rect(-size, -offset2, 2 * size, size2).data(dataKey, {
                    index: COMMAND_MOVE_UP,
                    name: EVENT_TARGET_TYPE
                }).append(group);
                renderer.rect(offset1, -size, size2, 2 * size).data(dataKey, {
                    index: COMMAND_MOVE_RIGHT,
                    name: EVENT_TARGET_TYPE
                }).append(group);
                renderer.rect(-size, offset1, 2 * size, size2).data(dataKey, {
                    index: COMMAND_MOVE_DOWN,
                    name: EVENT_TARGET_TYPE
                }).append(group);
                renderer.rect(-offset2, -size, size2, 2 * size).data(dataKey, {
                    index: COMMAND_MOVE_LEFT,
                    name: EVENT_TARGET_TYPE
                }).append(group);
                renderer.circle(0, options.incButtonOffset, options.smallCircleSize / 2).data(dataKey, {
                    index: COMMAND_ZOOM_IN,
                    name: EVENT_TARGET_TYPE
                }).append(group);
                renderer.circle(0, options.decButtonOffset, options.smallCircleSize / 2).data(dataKey, {
                    index: COMMAND_ZOOM_OUT,
                    name: EVENT_TARGET_TYPE
                }).append(group);
                renderer.rect(-2, options.sliderLineStartOffset - 2, 4, options.sliderLineEndOffset - options.sliderLineStartOffset + 4).css({
                    cursor: "default"
                }).data(dataKey, {
                    index: COMMAND_ZOOM_DRAG_LINE,
                    name: EVENT_TARGET_TYPE
                }).append(group);
                this._zoomDragTracker = renderer.rect(-options.sliderLength / 2, options.sliderLineEndOffset - options.sliderWidth / 2, options.sliderLength, options.sliderWidth).data(dataKey, {
                    index: COMMAND_ZOOM_DRAG,
                    name: EVENT_TARGET_TYPE
                }).append(group)
            },
            resize: function(size) {
                if (this._isActive) {
                    this._root.attr({
                        visibility: null !== size ? null : "hidden"
                    })
                }
            },
            getLayoutOptions: function() {
                return this._isActive ? this._layoutOptions : null
            },
            locate: function(x, y) {
                this._root.attr({
                    translateX: x + this._margin + OFFSET_X,
                    translateY: y + this._margin + OFFSET_Y
                })
            },
            _update: function() {
                var that = this;
                that._isActive = that._isEnabled && that._flags && that._params.projection.isInvertible();
                if (that._isActive) {
                    that._root.linkAppend()
                } else {
                    that._root.linkRemove()
                }
                that._processEnd();
                that.updateLayout()
            },
            setInteraction: function(interaction) {
                var that = this;
                if ((0, _utils.parseScalar)(interaction.centeringEnabled, true)) {
                    that._flags |= FLAG_CENTERING
                } else {
                    that._flags &= ~FLAG_CENTERING
                }
                if ((0, _utils.parseScalar)(interaction.zoomingEnabled, true)) {
                    that._flags |= FLAG_ZOOMING
                } else {
                    that._flags &= ~FLAG_ZOOMING
                }
                that._update()
            },
            setOptions: function(options) {
                var that = this;
                that._isEnabled = !!(0, _utils.parseScalar)(options.enabled, true);
                that._margin = options.margin || 0;
                that._layoutOptions = {
                    width: 2 * that._margin + TOTAL_WIDTH,
                    height: 2 * that._margin + TOTAL_HEIGHT,
                    horizontalAlignment: parseHorizontalAlignment(options.horizontalAlignment, "left"),
                    verticalAlignment: parseVerticalAlignment(options.verticalAlignment, "top")
                };
                that._buttonsGroup.attr({
                    "stroke-width": options.borderWidth,
                    stroke: options.borderColor,
                    fill: options.color,
                    "fill-opacity": options.opacity
                });
                that._update()
            },
            _adjustZoom: function(zoom) {
                var that = this;
                var start = SIZE_OPTIONS.sliderLineStartOffset;
                var end = SIZE_OPTIONS.sliderLineEndOffset;
                var h = SIZE_OPTIONS.sliderWidth;
                that._zoomFactor = _max(_min(_round(zoom), that._zoomPartition), 0);
                var transform = {
                    translateY: -_round(that._zoomFactor * that._sliderUnitLength)
                };
                var y = end - h / 2 + transform.translateY;
                that._zoomLine.attr({
                    points: [
                        [0, start, 0, _max(start, y)],
                        [0, _min(end, y + h), 0, end]
                    ]
                });
                that._zoomDrag.attr(transform);
                that._zoomDragTracker.attr(transform)
            },
            _applyZoom: function() {
                this._callbacks.zoom(this._zoomFactor)
            },
            _processStart: function(command, arg) {
                var commandType;
                if (this._isActive) {
                    commandType = COMMAND_TO_TYPE_MAP[command];
                    this._command = commandType && commandType.flags & this._flags ? new commandType(this, command, arg) : null
                }
            },
            _processMove: function(command, arg) {
                this._command && this._command.update(command, arg)
            },
            _processEnd: function() {
                this._command && this._command.finish();
                this._command = null
            }
        };

        function disposeCommand(command) {
            delete command._owner;
            command.update = function() {};
            command.finish = function() {}
        }

        function ResetCommand(owner, command) {
            this._owner = owner;
            this._command = command
        }
        ResetCommand.flags = FLAG_CENTERING | FLAG_ZOOMING;
        ResetCommand.prototype.update = function(command) {
            command !== this._command && disposeCommand(this)
        };
        ResetCommand.prototype.finish = function() {
            var flags = this._owner._flags;
            this._owner._callbacks.reset(!!(flags & FLAG_CENTERING), !!(flags & FLAG_ZOOMING));
            disposeCommand(this)
        };

        function MoveCommand(owner, command, arg) {
            this._command = command;
            var timeout = null;
            var interval = 100;
            var dx = 0;
            var dy = 0;
            switch (this._command) {
                case COMMAND_MOVE_UP:
                    dy = -10;
                    break;
                case COMMAND_MOVE_RIGHT:
                    dx = 10;
                    break;
                case COMMAND_MOVE_DOWN:
                    dy = 10;
                    break;
                case COMMAND_MOVE_LEFT:
                    dx = -10
            }

            function callback() {
                owner._callbacks.move([dx, dy]);
                timeout = setTimeout(callback, interval)
            }
            this._stop = function() {
                clearTimeout(timeout);
                owner._callbacks.endMove();
                this._stop = owner = null;
                return this
            };
            arg = null;
            owner._callbacks.beginMove();
            callback()
        }
        MoveCommand.flags = FLAG_CENTERING;
        MoveCommand.prototype.update = function(command) {
            this._command !== command && this.finish()
        };
        MoveCommand.prototype.finish = function() {
            disposeCommand(this._stop())
        };

        function ZoomCommand(owner, command) {
            this._owner = owner;
            this._command = command;
            var timeout = null;
            var interval = 150;
            var dZoom = this._command === COMMAND_ZOOM_IN ? 1 : -1;

            function callback() {
                owner._adjustZoom(owner._zoomFactor + dZoom);
                timeout = setTimeout(callback, interval)
            }
            this._stop = function() {
                clearTimeout(timeout);
                this._stop = owner = null;
                return this
            };
            callback()
        }
        ZoomCommand.flags = FLAG_ZOOMING;
        ZoomCommand.prototype.update = function(command) {
            this._command !== command && this.finish()
        };
        ZoomCommand.prototype.finish = function() {
            this._owner._applyZoom();
            disposeCommand(this._stop())
        };

        function ZoomDragCommand(owner, command, arg) {
            this._owner = owner;
            this._zoomFactor = owner._zoomFactor;
            this._pos = arg.y
        }
        ZoomDragCommand.flags = FLAG_ZOOMING;
        ZoomDragCommand.prototype.update = function(command, arg) {
            var owner = this._owner;
            owner._adjustZoom(this._zoomFactor + owner._zoomPartition * (this._pos - arg.y) / owner._sliderLineLength)
        };
        ZoomDragCommand.prototype.finish = function() {
            this._owner._applyZoom();
            disposeCommand(this)
        }
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/vector_map/gesture_handler.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.GestureHandler = GestureHandler;
        var _ln = Math.log;
        var _LN2 = Math.LN2;

        function GestureHandler(params) {
            var that = this;
            that._projection = params.projection;
            that._renderer = params.renderer;
            that._x = that._y = 0;
            that._subscribeToTracker(params.tracker)
        }
        GestureHandler.prototype = {
            constructor: GestureHandler,
            dispose: function() {
                this._offTracker();
                this._offTracker = null
            },
            _subscribeToTracker: function(tracker) {
                var that = this;
                var isActive = false;
                that._offTracker = tracker.on({
                    start: function(arg) {
                        isActive = "control-bar" !== arg.data.name;
                        if (isActive) {
                            that._processStart(arg)
                        }
                    },
                    move: function(arg) {
                        if (isActive) {
                            that._processMove(arg)
                        }
                    },
                    end: function() {
                        if (isActive) {
                            that._processEnd()
                        }
                    },
                    zoom: function(arg) {
                        that._processZoom(arg)
                    }
                })
            },
            setInteraction: function(options) {
                this._processEnd();
                this._centeringEnabled = options.centeringEnabled;
                this._zoomingEnabled = options.zoomingEnabled
            },
            _processStart: function(arg) {
                if (this._centeringEnabled) {
                    this._x = arg.x;
                    this._y = arg.y;
                    this._projection.beginMoveCenter()
                }
            },
            _processMove: function(arg) {
                var that = this;
                if (that._centeringEnabled) {
                    that._renderer.root.attr({
                        cursor: "move"
                    });
                    that._projection.moveCenter([that._x - arg.x, that._y - arg.y]);
                    that._x = arg.x;
                    that._y = arg.y
                }
            },
            _processEnd: function() {
                if (this._centeringEnabled) {
                    this._renderer.root.attr({
                        cursor: "default"
                    });
                    this._projection.endMoveCenter()
                }
            },
            _processZoom: function(arg) {
                var that = this;
                var delta;
                var screenPosition;
                var coords;
                if (that._zoomingEnabled) {
                    if (arg.delta) {
                        delta = arg.delta
                    } else {
                        if (arg.ratio) {
                            delta = _ln(arg.ratio) / _LN2
                        }
                    }
                    if (that._centeringEnabled) {
                        screenPosition = that._renderer.getRootOffset();
                        screenPosition = [arg.x - screenPosition.left, arg.y - screenPosition.top];
                        coords = that._projection.fromScreenPoint(screenPosition)
                    }
                    that._projection.changeScaledZoom(delta);
                    if (that._centeringEnabled) {
                        that._projection.setCenterByPoint(coords, screenPosition)
                    }
                }
            }
        }
    },
    /*!************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/vector_map/tracker.js ***!
      \************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.Tracker = Tracker;
        var _events_engine = _interopRequireDefault(__webpack_require__( /*! ../../events/core/events_engine */ 5));
        var _window = __webpack_require__( /*! ../../core/utils/window */ 7);
        var _dom_adapter = _interopRequireDefault(__webpack_require__( /*! ../../core/dom_adapter */ 11));
        var _event_emitter = __webpack_require__( /*! ./event_emitter */ 480);
        var _index = __webpack_require__( /*! ../../events/utils/index */ 8);
        var _wheel = __webpack_require__( /*! ../../events/core/wheel */ 148);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var navigator = (0, _window.getNavigator)();
        var _math = Math;
        var _abs = _math.abs;
        var _sqrt = _math.sqrt;
        var _round = _math.round;
        var _addNamespace = _index.addNamespace;
        var _NAME = "dxVectorMap";
        var EVENT_START = "start";
        var EVENT_MOVE = "move";
        var EVENT_END = "end";
        var EVENT_ZOOM = "zoom";
        var EVENT_HOVER_ON = "hover-on";
        var EVENT_HOVER_OFF = "hover-off";
        var EVENT_CLICK = "click";
        var EVENT_FOCUS_ON = "focus-on";
        var EVENT_FOCUS_MOVE = "focus-move";
        var EVENT_FOCUS_OFF = "focus-off";
        var CLICK_TIME_THRESHOLD = 500;
        var CLICK_COORD_THRESHOLD_MOUSE = 5;
        var CLICK_COORD_THRESHOLD_TOUCH = 20;
        var DRAG_COORD_THRESHOLD_MOUSE = 5;
        var DRAG_COORD_THRESHOLD_TOUCH = 10;
        var FOCUS_OFF_DELAY = 100;
        var WHEEL_COOLDOWN = 50;
        var WHEEL_DIRECTION_COOLDOWN = 300;
        var EVENTS;
        var Focus;
        setupEvents();

        function Tracker(parameters) {
            var that = this;
            that._root = parameters.root;
            that._createEventHandlers(parameters.dataKey);
            that._createProjectionHandlers(parameters.projection);
            that._initEvents();
            that._focus = new Focus(function(name, arg) {
                that._fire(name, arg)
            });
            that._attachHandlers()
        }
        Tracker.prototype = {
            constructor: Tracker,
            dispose: function() {
                var that = this;
                that._detachHandlers();
                that._disposeEvents();
                that._focus.dispose();
                that._root = that._focus = that._docHandlers = that._rootHandlers = null
            },
            _eventNames: [EVENT_START, EVENT_MOVE, EVENT_END, EVENT_ZOOM, EVENT_CLICK, EVENT_HOVER_ON, EVENT_HOVER_OFF, EVENT_FOCUS_ON, EVENT_FOCUS_OFF, EVENT_FOCUS_MOVE],
            _startClick: function(event, data) {
                if (!data) {
                    return
                }
                var coords = getEventCoords(event);
                this._clickState = {
                    x: coords.x,
                    y: coords.y,
                    threshold: isTouchEvent(event) ? CLICK_COORD_THRESHOLD_TOUCH : CLICK_COORD_THRESHOLD_MOUSE,
                    time: Date.now()
                }
            },
            _endClick: function(event, data) {
                var state = this._clickState;
                var threshold;
                var coords;
                if (!state) {
                    return
                }
                if (data && Date.now() - state.time <= CLICK_TIME_THRESHOLD) {
                    threshold = state.threshold;
                    coords = getEventCoords(event);
                    if (_abs(coords.x - state.x) <= threshold && _abs(coords.y - state.y) <= threshold) {
                        this._fire(EVENT_CLICK, {
                            data: data,
                            x: coords.x,
                            y: coords.y,
                            $event: event
                        })
                    }
                }
                this._clickState = null
            },
            _startDrag: function(event, data) {
                if (!data) {
                    return
                }
                var coords = getEventCoords(event);
                var state = this._dragState = {
                    x: coords.x,
                    y: coords.y,
                    data: data
                };
                this._fire(EVENT_START, {
                    x: state.x,
                    y: state.y,
                    data: state.data
                })
            },
            _moveDrag: function(event, data) {
                var state = this._dragState;
                if (!state) {
                    return
                }
                var coords = getEventCoords(event);
                var threshold = isTouchEvent(event) ? DRAG_COORD_THRESHOLD_TOUCH : DRAG_COORD_THRESHOLD_MOUSE;
                if (state.active || _abs(coords.x - state.x) > threshold || _abs(coords.y - state.y) > threshold) {
                    state.x = coords.x;
                    state.y = coords.y;
                    state.active = true;
                    state.data = data || {};
                    this._fire(EVENT_MOVE, {
                        x: state.x,
                        y: state.y,
                        data: state.data
                    })
                }
            },
            _endDrag: function() {
                var state = this._dragState;
                if (!state) {
                    return
                }
                this._dragState = null;
                this._fire(EVENT_END, {
                    x: state.x,
                    y: state.y,
                    data: state.data
                })
            },
            _wheelZoom: function(event, data) {
                if (!data) {
                    return
                }
                var that = this;
                var lock = that._wheelLock;
                var time = Date.now();
                if (time - lock.time <= WHEEL_COOLDOWN) {
                    return
                }
                if (time - lock.dirTime > WHEEL_DIRECTION_COOLDOWN) {
                    lock.dir = 0
                }
                var delta = adjustWheelDelta(event.delta / 120 || 0, lock);
                if (0 === delta) {
                    return
                }
                var coords = getEventCoords(event);
                that._fire(EVENT_ZOOM, {
                    delta: delta,
                    x: coords.x,
                    y: coords.y
                });
                lock.time = lock.dirTime = time
            },
            _startZoom: function(event, data) {
                if (!isTouchEvent(event) || !data) {
                    return
                }
                var state = this._zoomState = this._zoomState || {};
                var coords;
                var pointer2;
                if (state.pointer1 && state.pointer2) {
                    return
                }
                if (void 0 === state.pointer1) {
                    state.pointer1 = getPointerId(event) || 0;
                    coords = getMultitouchEventCoords(event, state.pointer1);
                    state.x1 = state.x1_0 = coords.x;
                    state.y1 = state.y1_0 = coords.y
                }
                if (void 0 === state.pointer2) {
                    pointer2 = getPointerId(event) || 1;
                    if (pointer2 !== state.pointer1) {
                        coords = getMultitouchEventCoords(event, pointer2);
                        if (coords) {
                            state.x2 = state.x2_0 = coords.x;
                            state.y2 = state.y2_0 = coords.y;
                            state.pointer2 = pointer2;
                            state.ready = true;
                            this._endDrag()
                        }
                    }
                }
            },
            _moveZoom: function(event) {
                var state = this._zoomState;
                var coords;
                if (!state || !isTouchEvent(event)) {
                    return
                }
                if (void 0 !== state.pointer1) {
                    coords = getMultitouchEventCoords(event, state.pointer1);
                    if (coords) {
                        state.x1 = coords.x;
                        state.y1 = coords.y
                    }
                }
                if (void 0 !== state.pointer2) {
                    coords = getMultitouchEventCoords(event, state.pointer2);
                    if (coords) {
                        state.x2 = coords.x;
                        state.y2 = coords.y
                    }
                }
            },
            _endZoom: function(event) {
                var state = this._zoomState;
                var startDistance;
                var currentDistance;
                if (!state || !isTouchEvent(event)) {
                    return
                }
                if (state.ready) {
                    startDistance = getDistance(state.x1_0, state.y1_0, state.x2_0, state.y2_0);
                    currentDistance = getDistance(state.x1, state.y1, state.x2, state.y2);
                    this._fire(EVENT_ZOOM, {
                        ratio: currentDistance / startDistance,
                        x: (state.x1_0 + state.x2_0) / 2,
                        y: (state.y1_0 + state.y2_0) / 2
                    })
                }
                this._zoomState = null
            },
            _startHover: function(event, data) {
                this._doHover(event, data, true)
            },
            _moveHover: function(event, data) {
                this._doHover(event, data, false)
            },
            _doHover: function(event, data, isTouch) {
                var that = this;
                if (that._dragState && that._dragState.active || that._zoomState && that._zoomState.ready) {
                    that._cancelHover();
                    return
                }
                if (isTouchEvent(event) !== isTouch || that._hoverTarget === event.target || that._hoverState && that._hoverState.data === data) {
                    return
                }
                that._cancelHover();
                if (data) {
                    that._hoverState = {
                        data: data
                    };
                    that._fire(EVENT_HOVER_ON, {
                        data: data
                    })
                }
                that._hoverTarget = event.target
            },
            _cancelHover: function() {
                var state = this._hoverState;
                this._hoverState = this._hoverTarget = null;
                if (state) {
                    this._fire(EVENT_HOVER_OFF, {
                        data: state.data
                    })
                }
            },
            _startFocus: function(event, data) {
                this._doFocus(event, data, true)
            },
            _moveFocus: function(event, data) {
                this._doFocus(event, data, false)
            },
            _doFocus: function(event, data, isTouch) {
                var that = this;
                if (that._dragState && that._dragState.active || that._zoomState && that._zoomState.ready) {
                    that._cancelFocus();
                    return
                }
                if (isTouchEvent(event) !== isTouch) {
                    return
                }
                that._focus.turnOff();
                data && that._focus.turnOn(data, getEventCoords(event))
            },
            _cancelFocus: function() {
                this._focus.cancel()
            },
            _createEventHandlers: function(DATA_KEY) {
                var that = this;
                that._docHandlers = {};
                that._rootHandlers = {};
                that._rootHandlers[EVENTS.start] = that._docHandlers[EVENTS.start] = function(event) {
                    var isTouch = isTouchEvent(event);
                    var data = getData(event);
                    if (isTouch && !that._isTouchEnabled) {
                        return
                    }
                    if (data) {
                        event.preventDefault();
                        event.stopPropagation()
                    }
                    that._startClick(event, data);
                    that._startDrag(event, data);
                    that._startZoom(event, data);
                    that._startHover(event, data);
                    that._startFocus(event, data)
                };
                that._docHandlers[EVENTS.move] = function(event) {
                    var isTouch = isTouchEvent(event);
                    var data = getData(event);
                    if (isTouch && !that._isTouchEnabled) {
                        return
                    }
                    that._moveDrag(event, data);
                    that._moveZoom(event, data);
                    that._moveHover(event, data);
                    that._moveFocus(event, data)
                };
                that._docHandlers[EVENTS.end] = function(event) {
                    var isTouch = isTouchEvent(event);
                    var data = getData(event);
                    if (isTouch && !that._isTouchEnabled) {
                        return
                    }
                    that._endClick(event, data);
                    that._endDrag(event, data);
                    that._endZoom(event, data)
                };
                that._rootHandlers[EVENTS.wheel] = function(event) {
                    that._cancelFocus();
                    if (!that._isWheelEnabled) {
                        return
                    }
                    var data = getData(event);
                    if (data) {
                        event.preventDefault();
                        event.stopPropagation();
                        that._wheelZoom(event, data)
                    }
                };
                that._wheelLock = {
                    dir: 0
                };

                function getData(event) {
                    var target = event.target;
                    return ("tspan" === target.tagName ? target.parentNode : target)[DATA_KEY]
                }
            },
            _createProjectionHandlers: function(projection) {
                var that = this;
                projection.on({
                    center: handler,
                    zoom: handler
                });

                function handler() {
                    that._cancelFocus()
                }
            },
            reset: function() {
                var that = this;
                that._clickState = null;
                that._endDrag();
                that._cancelHover();
                that._cancelFocus()
            },
            setOptions: function(options) {
                var that = this;
                that.reset();
                that._detachHandlers();
                that._isTouchEnabled = !!(0, _utils.parseScalar)(options.touchEnabled, true);
                that._isWheelEnabled = !!(0, _utils.parseScalar)(options.wheelEnabled, true);
                that._attachHandlers()
            },
            _detachHandlers: function() {
                var that = this;
                if (that._isTouchEnabled) {
                    that._root.css({
                        "touch-action": "",
                        "-webkit-user-select": ""
                    }).off(_addNamespace("MSHoldVisual", _NAME)).off(_addNamespace("contextmenu", _NAME))
                }
                _events_engine.default.off(_dom_adapter.default.getDocument(), that._docHandlers);
                that._root.off(that._rootHandlers)
            },
            _attachHandlers: function() {
                var that = this;
                if (that._isTouchEnabled) {
                    that._root.css({
                        "touch-action": "none",
                        "-webkit-user-select": "none"
                    }).on(_addNamespace("MSHoldVisual", _NAME), function(event) {
                        event.preventDefault()
                    }).on(_addNamespace("contextmenu", _NAME), function(event) {
                        isTouchEvent(event) && event.preventDefault()
                    })
                }
                _events_engine.default.on(_dom_adapter.default.getDocument(), that._docHandlers);
                that._root.on(that._rootHandlers)
            }
        };
        Focus = function(fire) {
            var that = this;
            var _activeData = null;
            var _data = null;
            var _disabled = false;
            var _offTimer = null;
            var _x;
            var _y;
            that.dispose = function() {
                clearTimeout(_offTimer);
                that.turnOn = that.turnOff = that.cancel = that.dispose = that = fire = _activeData = _data = _offTimer = null
            };
            that.turnOn = function(data, coords) {
                if (data === _data && _disabled) {
                    return
                }
                _disabled = false;
                _data = data;
                if (_activeData) {
                    _x = coords.x;
                    _y = coords.y;
                    if (_data === _activeData) {
                        fire(EVENT_FOCUS_MOVE, {
                            data: _data,
                            x: _x,
                            y: _y
                        });
                        onCheck(true)
                    } else {
                        fire(EVENT_FOCUS_ON, {
                            data: _data,
                            x: _x,
                            y: _y,
                            done: onCheck
                        })
                    }
                } else {
                    _x = coords.x;
                    _y = coords.y;
                    fire(EVENT_FOCUS_ON, {
                        data: _data,
                        x: _x,
                        y: _y,
                        done: onCheck
                    })
                }

                function onCheck(result) {
                    _disabled = !result;
                    if (result) {
                        _activeData = _data;
                        clearTimeout(_offTimer);
                        _offTimer = null
                    }
                }
            };
            that.turnOff = function() {
                _data = null;
                if (_activeData && !_disabled) {
                    _offTimer = _offTimer || setTimeout(function() {
                        _offTimer = null;
                        fire(EVENT_FOCUS_OFF, {
                            data: _activeData
                        });
                        _activeData = null
                    }, FOCUS_OFF_DELAY)
                }
            };
            that.cancel = function() {
                clearTimeout(_offTimer);
                if (_activeData) {
                    fire(EVENT_FOCUS_OFF, {
                        data: _activeData
                    })
                }
                _activeData = _data = _offTimer = null
            }
        };
        (0, _event_emitter.makeEventEmitter)(Tracker);

        function getDistance(x1, y1, x2, y2) {
            return _sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2))
        }

        function isTouchEvent(event) {
            var type = event.originalEvent.type;
            var pointerType = event.originalEvent.pointerType;
            return /^touch/.test(type) || /^MSPointer/.test(type) && 4 !== pointerType || /^pointer/.test(type) && "mouse" !== pointerType
        }

        function selectItem(flags, items) {
            var i = 0;
            var ii = flags.length;
            var item;
            for (; i < ii; ++i) {
                if (flags[i]) {
                    item = items[i];
                    break
                }
            }
            return _addNamespace(item || items[i], _NAME)
        }

        function setupEvents() {
            var flags = [navigator.pointerEnabled, navigator.msPointerEnabled, (0, _window.hasProperty)("ontouchstart")];
            EVENTS = {
                start: selectItem(flags, ["pointerdown", "MSPointerDown", "touchstart mousedown", "mousedown"]),
                move: selectItem(flags, ["pointermove", "MSPointerMove", "touchmove mousemove", "mousemove"]),
                end: selectItem(flags, ["pointerup", "MSPointerUp", "touchend mouseup", "mouseup"]),
                wheel: _addNamespace(_wheel.name, _NAME)
            }
        }

        function getEventCoords(event) {
            var originalEvent = event.originalEvent;
            var touch = originalEvent.touches && originalEvent.touches[0] || {};
            return {
                x: touch.pageX || originalEvent.pageX || event.pageX,
                y: touch.pageY || originalEvent.pageY || event.pageY
            }
        }

        function getPointerId(event) {
            return event.originalEvent.pointerId
        }

        function getMultitouchEventCoords(event, pointerId) {
            var originalEvent = event.originalEvent;
            if (void 0 !== originalEvent.pointerId) {
                originalEvent = originalEvent.pointerId === pointerId ? originalEvent : null
            } else {
                originalEvent = originalEvent.touches[pointerId]
            }
            return originalEvent ? {
                x: originalEvent.pageX || event.pageX,
                y: originalEvent.pageY || event.pageY
            } : null
        }

        function adjustWheelDelta(delta, lock) {
            if (0 === delta) {
                return 0
            }
            var _delta = _abs(delta);
            var sign = _round(delta / _delta);
            if (lock.dir && sign !== lock.dir) {
                return 0
            }
            lock.dir = sign;
            if (_delta < .1) {
                _delta = 0
            } else {
                if (_delta < 1) {
                    _delta = 1
                } else {
                    if (_delta > 4) {
                        _delta = 4
                    } else {
                        _delta = _round(_delta)
                    }
                }
            }
            return sign * _delta
        }
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/vector_map/data_exchanger.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.DataExchanger = DataExchanger;
        var _callbacks = _interopRequireDefault(__webpack_require__( /*! ../../core/utils/callbacks */ 27));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function DataExchanger() {
            this._store = {}
        }
        DataExchanger.prototype = {
            constructor: DataExchanger,
            dispose: function() {
                this._store = null;
                return this
            },
            _get: function(category, name) {
                var store = this._store[category] || (this._store[category] = {});
                return store[name] || (store[name] = {
                    callbacks: (0, _callbacks.default)()
                })
            },
            set: function(category, name, data) {
                var item = this._get(category, name);
                item.data = data;
                item.callbacks.fire(data);
                return this
            },
            bind: function(category, name, callback) {
                var item = this._get(category, name);
                item.callbacks.add(callback);
                item.data && callback(item.data);
                return this
            },
            unbind: function(category, name, callback) {
                var item = this._get(category, name);
                item.callbacks.remove(callback);
                return this
            }
        }
    },
    /*!***********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/vector_map/legend.js ***!
      \***********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.LegendsControl = LegendsControl;
        var _extend2 = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _object = __webpack_require__( /*! ../../core/utils/object */ 51);
        var _legend = __webpack_require__( /*! ../components/legend */ 224);
        var _extend = _extend2.extend;
        var _each = _iterator.each;
        var unknownSource = {
            category: "UNKNOWN",
            name: "UNKNOWN"
        };

        function buildData(partition, values, field) {
            var i;
            var ii = values.length;
            var list = [];
            var item;
            for (i = 0; i < ii; ++i) {
                list[i] = item = {
                    start: partition[i],
                    end: partition[i + 1],
                    index: i
                };
                item[field] = values[i];
                item.states = {
                    normal: {
                        fill: item.color
                    }
                };
                item.visible = true
            }
            return list
        }
        var Legend = function(parameters) {
            var that = this;
            that._params = parameters;
            that._root = parameters.renderer.g().attr({
                "class": "dxm-legend"
            }).linkOn(parameters.container, {
                name: "legend",
                after: "legend-base"
            }).enableLinks().linkAppend();
            parameters.layoutControl.addItem(that);
            _legend.Legend.call(that, {
                renderer: parameters.renderer,
                widget: parameters.widget,
                group: that._root,
                backgroundClass: null,
                itemsGroupClass: null,
                textField: "text",
                getFormatObject: function(data) {
                    return data
                }
            });
            that._onDataChanged = function(data) {
                that._updateData(data)
            }
        };
        Legend.prototype = _extend((0, _object.clone)(_legend.Legend.prototype), {
            constructor: Legend,
            dispose: function() {
                var that = this;
                that._params.layoutControl.removeItem(that);
                that._unbindData();
                that._root.linkRemove().linkOff();
                that._params = that._root = that._onDataChanged = null;
                return _legend.Legend.prototype.dispose.apply(that, arguments)
            },
            resize: function(size) {
                this._params.notifyDirty();
                if (null === size) {
                    this.erase()
                } else {
                    this.draw(size.width, size.height)
                }
                this._params.notifyReady()
            },
            locate: _legend.Legend.prototype.shift,
            _updateData: function(data) {
                this._options.defaultColor = data && data.defaultColor;
                this.update(data ? buildData(data.partition, data.values, this._dataName) : [], this._options, this._params.themeManager.theme("legend").title);
                this.updateLayout()
            },
            _unbindData: function() {
                if (this._dataCategory) {
                    this._params.dataExchanger.unbind(this._dataCategory, this._dataName, this._onDataChanged)
                }
            },
            _bindData: function(arg) {
                this._params.dataExchanger.bind(this._dataCategory = arg.category, this._dataName = arg.name, this._onDataChanged)
            },
            setOptions: function(options) {
                var that = this;
                that.update(that._data, options, this._params.themeManager.theme("legend").title);
                that._unbindData();
                var source = options.source;
                that._bindData(source ? {
                    category: source.layer,
                    name: source.grouping
                } : unknownSource);
                that.updateLayout();
                return that
            }
        });

        function LegendsControl(parameters) {
            this._params = parameters;
            this._items = [];
            parameters.container.virtualLink("legend-base")
        }
        LegendsControl.prototype = {
            constructor: LegendsControl,
            dispose: function() {
                _each(this._items, function(_, item) {
                    item.dispose()
                });
                this._params = this._items = null
            },
            setOptions: function(options) {
                var optionList = options && options.length ? options : [];
                var items = this._items;
                var i;
                var ii = optionList.length;
                var params = this._params;
                var theme = params.themeManager.theme("legend");
                for (i = items.length; i < ii; ++i) {
                    items[i] = new Legend(params)
                }
                for (i = items.length - 1; i >= ii; --i) {
                    items[i].dispose();
                    items.splice(i, 1)
                }
                params.layoutControl.suspend();
                for (i = 0; i < ii; ++i) {
                    items[i].setOptions(_extend(true, {}, theme, optionList[i]))
                }
                params.layoutControl.resume()
            }
        }
    },
    /*!***********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/vector_map/layout.js ***!
      \***********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.LayoutControl = LayoutControl;
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _round = Math.round;
        var _min = Math.min;
        var _max = Math.max;
        var _each = _iterator.each;
        var _inArray = _array.inArray;
        var horizontalAlignmentMap = {
            left: 0,
            center: 1,
            right: 2
        };
        var verticalAlignmentMap = {
            top: 0,
            bottom: 1
        };

        function getCellIndex(options) {
            return 3 * verticalAlignmentMap[options.verticalAlignment] + horizontalAlignmentMap[options.horizontalAlignment]
        }

        function createCells(canvas, items) {
            var hStep = (canvas.right - canvas.left) / 3;
            var vStep = (canvas.bottom - canvas.top) / 2;
            var h1 = canvas.left;
            var h2 = _round(h1 + hStep);
            var h3 = _round(h1 + hStep + hStep);
            var h4 = canvas.right;
            var v1 = canvas.top;
            var v2 = _round(v1 + vStep);
            var v3 = canvas.bottom;
            var cells = [{
                rect: [h1, v1, h2, v2]
            }, {
                rect: [h2, v1, h3, v2],
                center: true
            }, {
                rect: [h3, v1, h4, v2],
                horInversion: true
            }, {
                rect: [h1, v2, h2, v3],
                verInversion: true
            }, {
                rect: [h2, v2, h3, v3],
                center: true,
                verInversion: true
            }, {
                rect: [h3, v2, h4, v3],
                horInversion: true,
                verInversion: true
            }];
            var itemsList = [
                [],
                [],
                [],
                [],
                [],
                []
            ];
            _each(items, function(_, item) {
                var options = item.getLayoutOptions();
                if (options) {
                    itemsList[getCellIndex(options)].push({
                        item: item,
                        width: options.width,
                        height: options.height
                    })
                }
            });
            _each(cells, function(i, cell) {
                if (itemsList[i].length) {
                    cell.items = itemsList[i]
                } else {
                    if (cell.center) {
                        cell.rect[0] = cell.rect[2] = (cell.rect[0] + cell.rect[2]) / 2
                    } else {
                        cell.rect[cell.horInversion ? 0 : 2] = cell.rect[cell.horInversion ? 2 : 0]
                    }
                    cell.rect[cell.verInversion ? 1 : 3] = cell.rect[cell.verInversion ? 3 : 1]
                }
            });
            return cells
        }

        function adjustCellSizes(cells) {
            _each([0, 1, 2, 3, 4, 5], function(_, index) {
                var cell = cells[index];
                var otherCell = cells[(index + 3) % 6];
                if (cell.items) {
                    if (!otherCell.items) {
                        cell.rect[1] = _min(cell.rect[1], otherCell.rect[3]);
                        cell.rect[3] = _max(cell.rect[3], otherCell.rect[1])
                    }
                }
            });
            _each([1, 4], function(_, index) {
                var cell = cells[index];
                var otherCell1 = cells[index - 1];
                var otherCell2 = cells[index + 1];
                var size1;
                var size2;
                if (cell.items) {
                    if (!otherCell1.items && !otherCell2.items) {
                        size1 = cell.rect[0] - otherCell1.rect[2];
                        size2 = otherCell2.rect[0] - cell.rect[2];
                        if (size1 > size2) {
                            if (size1 / size2 >= 2) {
                                cell.rect[0] -= size1;
                                cell.right = true
                            } else {
                                cell.rect[0] -= size2;
                                cell.rect[2] += size2
                            }
                        } else {
                            if (size2 / size1 >= 2) {
                                cell.rect[2] += size2;
                                cell.center = null
                            } else {
                                cell.rect[0] -= size1;
                                cell.rect[2] += size1
                            }
                        }
                    }
                } else {
                    if (otherCell1.items) {
                        otherCell1.rect[2] = (cell.rect[0] + cell.rect[2]) / 2
                    }
                    if (otherCell2.items) {
                        otherCell2.rect[0] = (cell.rect[0] + cell.rect[2]) / 2
                    }
                }
            })
        }

        function adjustCellsAndApplyLayout(cells, forceMode) {
            var hasHiddenItems = false;
            adjustCellSizes(cells);
            _each(cells, function(_, cell) {
                if (cell.items) {
                    hasHiddenItems = applyCellLayout(cell, forceMode) || hasHiddenItems
                }
            });
            return hasHiddenItems
        }

        function applyCellLayout(cell, forceMode) {
            var cellRect = cell.rect;
            var cellWidth = cellRect[2] - cellRect[0];
            var cellHeight = cellRect[3] - cellRect[1];
            var xOffset = 0;
            var yOffset = 0;
            var currentHeight = 0;
            var totalL = cellRect[2];
            var totalT = cellRect[3];
            var totalR = cellRect[0];
            var totalB = cellRect[1];
            var moves = [];
            var hasHiddenItems = false;
            _each(cell.items, function(_, item) {
                if (item.width > cellWidth || item.height > cellHeight) {
                    moves.push(null);
                    hasHiddenItems = true;
                    return forceMode || false
                }
                if (xOffset + item.width > cellWidth) {
                    yOffset += currentHeight;
                    xOffset = currentHeight = 0
                }
                if (yOffset + item.height > cellHeight) {
                    moves.push(null);
                    hasHiddenItems = true;
                    return forceMode || false
                }
                currentHeight = _max(currentHeight, item.height);
                var dx = cell.horInversion ? cellRect[2] - item.width - xOffset : cellRect[0] + xOffset;
                var dy = cell.verInversion ? cellRect[3] - item.height - yOffset : cellRect[1] + yOffset;
                xOffset += item.width;
                totalL = _min(totalL, dx);
                totalT = _min(totalT, dy);
                totalR = _max(totalR, dx + item.width);
                totalB = _max(totalB, dy + item.height);
                moves.push([dx, dy])
            });
            if (forceMode || !hasHiddenItems) {
                xOffset = 0;
                if (cell.right) {
                    xOffset = cellRect[2] - cellRect[0] - totalR + totalL
                } else {
                    if (cell.center) {
                        xOffset = _round((cellRect[2] - cellRect[0] - totalR + totalL) / 2)
                    }
                }
                _each(cell.items, function(i, item) {
                    var move = moves[i];
                    if (move) {
                        item.item.locate(move[0] + xOffset, move[1])
                    } else {
                        item.item.resize(null)
                    }
                });
                cell.rect = [totalL, totalT, totalR, totalB];
                cell.items = null
            }
            return hasHiddenItems
        }

        function applyLayout(canvas, items) {
            var cells = createCells(canvas, items);
            if (adjustCellsAndApplyLayout(cells)) {
                adjustCellsAndApplyLayout(cells, true)
            }
        }

        function LayoutControl(widget) {
            var that = this;
            that._items = [];
            that._suspended = 0;
            that._widget = widget;
            that._updateLayout = function() {
                that._update()
            }
        }
        LayoutControl.prototype = {
            constructor: LayoutControl,
            dispose: function() {
                this._items = this._updateLayout = null
            },
            setSize: function(canvas) {
                this._canvas = canvas;
                this._update()
            },
            suspend: function() {
                ++this._suspended
            },
            resume: function() {
                if (0 === --this._suspended) {
                    this._update()
                }
            },
            addItem: function(item) {
                this._items.push(item);
                item.updateLayout = this._updateLayout
            },
            removeItem: function(item) {
                this._items.splice(_inArray(item, this._items), 1);
                item.updateLayout = null
            },
            _update: function() {
                var canvas;
                if (0 === this._suspended) {
                    canvas = this._canvas;
                    _each(this._items, function(_, item) {
                        item.resize(canvas)
                    });
                    this._widget.resolveItemsDeferred(this._items.filter(function(el) {
                        return el.getTemplatesGroups && el.getTemplatesDef
                    }));
                    applyLayout({
                        left: canvas.left,
                        top: canvas.top,
                        right: canvas.width + canvas.left,
                        bottom: canvas.height + canvas.top
                    }, this._items)
                }
            }
        }
    },
    /*!**************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/vector_map/map_layer.js ***!
      \**************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getMaxBound = getMaxBound;
        exports.MapLayerCollection = MapLayerCollection;
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _extend2 = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _data_helper = _interopRequireDefault(__webpack_require__( /*! ../../data_helper */ 92));
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _deferred = __webpack_require__( /*! ../../core/utils/deferred */ 6);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _noop = _common.noop;
        var _extend = _extend2.extend;
        var _each = _iterator.each;
        var _concat = Array.prototype.concat;
        var TYPE_AREA = "area";
        var TYPE_LINE = "line";
        var TYPE_MARKER = "marker";
        var STATE_DEFAULT = 0;
        var STATE_HOVERED = 1;
        var STATE_SELECTED = 2;
        var STATE_TO_INDEX = [0, 1, 2, 2];
        var TOLERANCE = 1;
        var SELECTIONS = {
            none: null,
            single: -1,
            multiple: NaN
        };
        var _isArray = Array.isArray;
        var _Number = Number;
        var _String = String;
        var _abs = Math.abs;
        var _round = Math.round;
        var _min = Math.min;
        var _max = Math.max;
        var _sqrt = Math.sqrt;

        function getMaxBound(arr) {
            return arr.reduce(function(a, c) {
                return c ? [_min(a[0], c[0]), _min(a[1], c[1]), _max(a[2], c[2]), _max(a[3], c[3])] : a
            }, arr[0])
        }

        function getSelection(selectionMode) {
            var selection = (0, _utils.normalizeEnum)(selectionMode);
            selection = selection in SELECTIONS ? SELECTIONS[selection] : SELECTIONS.single;
            if (null !== selection) {
                selection = {
                    state: {},
                    single: selection
                }
            }
            return selection
        }

        function getName(opt, index) {
            return (opt[index] || {}).name
        }

        function EmptySource() {}
        EmptySource.prototype.count = function() {
            return 0
        };

        function ArraySource(raw) {
            this.raw = raw
        }
        ArraySource.prototype = {
            constructor: ArraySource,
            count: function() {
                return this.raw.length
            },
            item: function(index) {
                return this.raw[index]
            },
            geometry: function(item) {
                return {
                    coordinates: item.coordinates
                }
            },
            attributes: function(item) {
                return item.attributes
            },
            getBBox: function(index) {
                return 0 === arguments.length ? void 0 : this.raw[index].bbox
            }
        };

        function GeoJsonSource(raw) {
            this.raw = raw
        }
        GeoJsonSource.prototype = {
            constructor: GeoJsonSource,
            count: function() {
                return this.raw.features.length
            },
            item: function(index) {
                return this.raw.features[index]
            },
            geometry: function(item) {
                return item.geometry
            },
            attributes: function(item) {
                return item.properties
            },
            getBBox: function(index) {
                return 0 === arguments.length ? this.raw.bbox : this.raw.features[index].bbox
            }
        };

        function isGeoJsonObject(obj) {
            return _isArray(obj.features)
        }

        function unwrapFromDataSource(source) {
            var sourceType;
            if (source) {
                if (isGeoJsonObject(source)) {
                    sourceType = GeoJsonSource
                } else {
                    if (1 === source.length && source[0] && isGeoJsonObject(source[0])) {
                        sourceType = GeoJsonSource;
                        source = source[0]
                    } else {
                        if (_isArray(source)) {
                            sourceType = ArraySource
                        }
                    }
                }
            }
            sourceType = sourceType || EmptySource;
            return new sourceType(source)
        }

        function wrapToDataSource(option) {
            return option ? isGeoJsonObject(option) ? [option] : option : []
        }

        function customizeHandles(proxies, callback, widget) {
            callback.call(widget, proxies)
        }

        function setAreaLabelVisibility(label) {
            label.text.attr({
                visibility: label.size[0] / label.spaceSize[0] < TOLERANCE && label.size[1] / label.spaceSize[1] < TOLERANCE ? null : "hidden"
            })
        }

        function setLineLabelVisibility(label) {
            label.text.attr({
                visibility: label.size[0] / label.spaceSize[0] < TOLERANCE || label.size[1] / label.spaceSize[1] < TOLERANCE ? null : "hidden"
            })
        }

        function getDataValue(proxy, dataField) {
            return proxy.attribute(dataField)
        }
        var TYPE_TO_TYPE_MAP = {
            Point: TYPE_MARKER,
            MultiPoint: TYPE_LINE,
            LineString: TYPE_LINE,
            MultiLineString: TYPE_LINE,
            Polygon: TYPE_AREA,
            MultiPolygon: TYPE_AREA
        };

        function pick(a, b) {
            return void 0 !== a ? a : b
        }

        function guessTypeByData(sample) {
            var type = TYPE_TO_TYPE_MAP[sample.type];
            var coordinates = sample.coordinates;
            if (!type) {
                if ("number" === typeof coordinates[0]) {
                    type = TYPE_MARKER
                } else {
                    if ("number" === typeof coordinates[0][0]) {
                        type = TYPE_LINE
                    } else {
                        type = TYPE_AREA
                    }
                }
            }
            return type
        }
        var emptyStrategy = {
            setup: _noop,
            reset: _noop,
            arrange: _noop,
            updateGrouping: _noop,
            getDefaultColor: _noop
        };
        var strategiesByType = {};
        var strategiesByGeometry = {};
        var strategiesByElementType = {};
        var groupByColor;
        var groupBySize;
        var selectStrategy = function(options, data) {
            var type = (0, _utils.normalizeEnum)(options.type);
            var elementType = (0, _utils.normalizeEnum)(options.elementType);
            var sample;
            var strategy = _extend({}, emptyStrategy);
            if (data.count() > 0) {
                sample = data.geometry(data.item(0));
                type = strategiesByType[type] ? type : guessTypeByData(sample);
                _extend(strategy, strategiesByType[type]);
                strategy.fullType = strategy.type = type;
                if (strategiesByGeometry[type]) {
                    _extend(strategy, strategiesByGeometry[type](sample))
                }
                if (strategiesByElementType[type]) {
                    elementType = strategiesByElementType[type][elementType] ? elementType : strategiesByElementType[type]._default;
                    _extend(strategy, strategiesByElementType[type][elementType]);
                    strategy.elementType = elementType;
                    strategy.fullType += ":" + elementType
                }
            }
            return strategy
        };

        function applyElementState(figure, styles, state, field) {
            figure[field].attr(styles[field][state])
        }
        strategiesByType[TYPE_AREA] = {
            projectLabel: projectAreaLabel,
            transform: transformPointList,
            transformLabel: transformAreaLabel,
            draw: function(context, figure, data) {
                figure.root = context.renderer.path([], "area").data(context.dataKey, data)
            },
            refresh: _noop,
            getLabelOffset: function(label) {
                setAreaLabelVisibility(label);
                return [0, 0]
            },
            getStyles: function(settings) {
                var color = settings.color || null;
                var borderColor = settings.borderColor || null;
                var borderWidth = pick(settings.borderWidth, null);
                var opacity = pick(settings.opacity, null);
                return {
                    root: [{
                        "class": "dxm-area",
                        stroke: borderColor,
                        "stroke-width": borderWidth,
                        fill: color,
                        opacity: opacity
                    }, {
                        "class": "dxm-area dxm-area-hovered",
                        stroke: settings.hoveredBorderColor || borderColor,
                        "stroke-width": pick(settings.hoveredBorderWidth, borderWidth),
                        fill: settings.hoveredColor || color,
                        opacity: pick(settings.hoveredOpacity, opacity)
                    }, {
                        "class": "dxm-area dxm-area-selected",
                        stroke: settings.selectedBorderColor || borderColor,
                        "stroke-width": pick(settings.selectedBorderWidth, borderWidth),
                        fill: settings.selectedColor || color,
                        opacity: pick(settings.selectedOpacity, opacity)
                    }]
                }
            },
            setState: function(figure, styles, state) {
                applyElementState(figure, styles, state, "root")
            },
            hasLabelsGroup: true,
            updateGrouping: function(context) {
                groupByColor(context)
            },
            getDefaultColor: _noop
        };
        strategiesByType[TYPE_LINE] = {
            projectLabel: projectLineLabel,
            transform: transformPointList,
            transformLabel: transformLineLabel,
            draw: function(context, figure, data) {
                figure.root = context.renderer.path([], "line").data(context.dataKey, data)
            },
            refresh: _noop,
            getLabelOffset: function(label) {
                setLineLabelVisibility(label);
                return [0, 0]
            },
            getStyles: function(settings) {
                var color = settings.color || settings.borderColor || null;
                var width = pick(settings.borderWidth, null);
                var opacity = pick(settings.opacity, null);
                return {
                    root: [{
                        "class": "dxm-line",
                        stroke: color,
                        "stroke-width": width,
                        opacity: opacity
                    }, {
                        "class": "dxm-line dxm-line-hovered",
                        stroke: settings.hoveredColor || settings.hoveredBorderColor || color,
                        "stroke-width": pick(settings.hoveredBorderWidth, width),
                        opacity: pick(settings.hoveredOpacity, opacity)
                    }, {
                        "class": "dxm-line dxm-line-selected",
                        stroke: settings.selectedColor || settings.selectedBorderColor || color,
                        "stroke-width": pick(settings.selectedBorderWidth, width),
                        opacity: pick(settings.selectedOpacity, opacity)
                    }]
                }
            },
            setState: function(figure, styles, state) {
                applyElementState(figure, styles, state, "root")
            },
            hasLabelsGroup: true,
            updateGrouping: function(context) {
                groupByColor(context)
            },
            getDefaultColor: _noop
        };
        strategiesByType[TYPE_MARKER] = {
            project: projectPoint,
            transform: transformPoint,
            draw: function(context, figure, data) {
                figure.root = context.renderer.g();
                this._draw(context, figure, data)
            },
            refresh: _noop,
            hasLabelsGroup: false,
            getLabelOffset: function(label, settings) {
                return [_round((label.size[0] + _max(settings.size || 0, 0)) / 2) + 2, 0]
            },
            getStyles: function(settings) {
                var styles = {
                    root: [{
                        "class": "dxm-marker"
                    }, {
                        "class": "dxm-marker dxm-marker-hovered"
                    }, {
                        "class": "dxm-marker dxm-marker-selected"
                    }]
                };
                this._getStyles(styles, settings);
                return styles
            },
            setState: function(figure, styles, state) {
                applyElementState(figure, styles, state, "root");
                this._setState(figure, styles, state)
            },
            updateGrouping: function(context) {
                groupByColor(context);
                groupBySize(context)
            },
            getDefaultColor: function(ctx, palette) {
                return ctx.params.themeManager.getAccentColor(palette)
            }
        };
        strategiesByGeometry[TYPE_AREA] = function(sample) {
            return {
                project: function(projection, coordinates) {
                    return coordinates[0] && coordinates[0][0] && coordinates[0][0][0] && "number" === typeof coordinates[0][0][0][0] ? projectMultiPolygon(projection, coordinates) : projectPolygon(projection, coordinates)
                }
            }
        };
        strategiesByGeometry[TYPE_LINE] = function(sample) {
            var coordinates = sample.coordinates;
            return {
                project: coordinates[0] && coordinates[0][0] && "number" === typeof coordinates[0][0][0] ? projectPolygon : projectLineString
            }
        };
        strategiesByElementType[TYPE_MARKER] = {
            _default: "dot",
            dot: {
                setup: function(context) {
                    context.filter = context.renderer.shadowFilter("-40%", "-40%", "180%", "200%", 0, 1, 1, "#000000", .2)
                },
                reset: function(context) {
                    context.filter.dispose();
                    context.filter = null
                },
                _draw: function(ctx, figure, data) {
                    figure.back = ctx.renderer.circle().sharp().data(ctx.dataKey, data).append(figure.root);
                    figure.dot = ctx.renderer.circle().sharp().data(ctx.dataKey, data).append(figure.root)
                },
                refresh: function(ctx, figure, data, proxy, settings) {
                    figure.dot.attr({
                        filter: settings.shadow ? ctx.filter.id : null
                    })
                },
                _getStyles: function(styles, style) {
                    var size = style.size > 0 ? _Number(style.size) : 0;
                    var hoveredSize = size;
                    var selectedSize = size + (style.selectedStep > 0 ? _Number(style.selectedStep) : 0);
                    var hoveredBackSize = hoveredSize + (style.backStep > 0 ? _Number(style.backStep) : 0);
                    var selectedBackSize = selectedSize + (style.backStep > 0 ? _Number(style.backStep) : 0);
                    var color = style.color || null;
                    var borderColor = style.borderColor || null;
                    var borderWidth = pick(style.borderWidth, null);
                    var opacity = pick(style.opacity, null);
                    var backColor = style.backColor || null;
                    var backOpacity = pick(style.backOpacity, null);
                    styles.dot = [{
                        r: size / 2,
                        stroke: borderColor,
                        "stroke-width": borderWidth,
                        fill: color,
                        opacity: opacity
                    }, {
                        r: hoveredSize / 2,
                        stroke: style.hoveredBorderColor || borderColor,
                        "stroke-width": pick(style.hoveredBorderWidth, borderWidth),
                        fill: style.hoveredColor || color,
                        opacity: pick(style.hoveredOpacity, opacity)
                    }, {
                        r: selectedSize / 2,
                        stroke: style.selectedBorderColor || borderColor,
                        "stroke-width": pick(style.selectedBorderWidth, borderWidth),
                        fill: style.selectedColor || color,
                        opacity: pick(style.selectedOpacity, opacity)
                    }];
                    styles.back = [{
                        r: size / 2,
                        stroke: "none",
                        "stroke-width": 0,
                        fill: backColor,
                        opacity: backOpacity
                    }, {
                        r: hoveredBackSize / 2,
                        stroke: "none",
                        "stroke-width": 0,
                        fill: backColor,
                        opacity: backOpacity
                    }, {
                        r: selectedBackSize / 2,
                        stroke: "none",
                        "stroke-width": 0,
                        fill: backColor,
                        opacity: backOpacity
                    }]
                },
                _setState: function(figure, styles, state) {
                    applyElementState(figure, styles, state, "dot");
                    applyElementState(figure, styles, state, "back")
                }
            },
            bubble: {
                _draw: function(ctx, figure, data) {
                    figure.bubble = ctx.renderer.circle().sharp().data(ctx.dataKey, data).append(figure.root)
                },
                refresh: function(ctx, figure, data, proxy, settings) {
                    figure.bubble.attr({
                        r: settings.size / 2
                    })
                },
                _getStyles: function(styles, style) {
                    var color = style.color || null;
                    var borderColor = style.borderColor || null;
                    var borderWidth = pick(style.borderWidth, null);
                    var opacity = pick(style.opacity, null);
                    styles.bubble = [{
                        stroke: borderColor,
                        "stroke-width": borderWidth,
                        fill: color,
                        opacity: opacity
                    }, {
                        stroke: style.hoveredBorderColor || borderColor,
                        "stroke-width": pick(style.hoveredBorderWidth, borderWidth),
                        fill: style.hoveredColor || style.color,
                        opacity: pick(style.hoveredOpacity, opacity)
                    }, {
                        stroke: style.selectedBorderColor || borderColor,
                        "stroke-width": pick(style.selectedBorderWidth, borderWidth),
                        fill: style.selectedColor || style.color,
                        opacity: pick(style.selectedOpacity, opacity)
                    }]
                },
                _setState: function(figure, styles, state) {
                    applyElementState(figure, styles, state, "bubble")
                },
                arrange: function(context, handles) {
                    var values = [];
                    var i;
                    var ii = values.length = handles.length;
                    var settings = context.settings;
                    var dataField = settings.dataField;
                    var minSize = settings.minSize > 0 ? _Number(settings.minSize) : 0;
                    var maxSize = settings.maxSize > minSize ? _Number(settings.maxSize) : minSize;
                    if (settings.sizeGroups) {
                        return
                    }
                    for (i = 0; i < ii; ++i) {
                        values[i] = _max(getDataValue(handles[i].proxy, dataField) || 0, 0)
                    }
                    var minValue = _min.apply(null, values);
                    var maxValue = _max.apply(null, values);
                    var deltaValue = maxValue - minValue || 1;
                    var deltaSize = maxSize - minSize;
                    for (i = 0; i < ii; ++i) {
                        handles[i]._settings.size = minSize + deltaSize * (values[i] - minValue) / deltaValue
                    }
                },
                updateGrouping: function(context) {
                    var dataField = context.settings.dataField;
                    strategiesByType[TYPE_MARKER].updateGrouping(context);
                    groupBySize(context, function(proxy) {
                        return getDataValue(proxy, dataField)
                    })
                }
            },
            pie: {
                _draw: function(ctx, figure, data) {
                    figure.pie = ctx.renderer.g().append(figure.root);
                    figure.border = ctx.renderer.circle().sharp().data(ctx.dataKey, data).append(figure.root)
                },
                refresh: function(ctx, figure, data, proxy, settings) {
                    var values = getDataValue(proxy, ctx.settings.dataField) || [];
                    var colors = settings._colors;
                    var sum = 0;
                    var pie = figure.pie;
                    var renderer = ctx.renderer;
                    var dataKey = ctx.dataKey;
                    var r = (settings.size > 0 ? _Number(settings.size) : 0) / 2;
                    var start = 90;
                    var end = start;
                    var zeroSum = false;
                    sum = values.reduce(function(total, item) {
                        return total + (item || 0)
                    }, 0);
                    if (0 === sum) {
                        zeroSum = true;
                        sum = 360 / values.length
                    }
                    values.forEach(function(item, i) {
                        start = end;
                        end += zeroSum ? sum : (item || 0) / sum * 360;
                        renderer.arc(0, 0, 0, r, start, end).attr({
                            "stroke-linejoin": "round",
                            fill: colors[i]
                        }).data(dataKey, data).append(pie)
                    });
                    figure.border.attr({
                        r: r
                    })
                },
                _getStyles: function(styles, style) {
                    var opacity = pick(style.opacity, null);
                    var borderColor = style.borderColor || null;
                    var borderWidth = pick(style.borderWidth, null);
                    styles.pie = [{
                        opacity: opacity
                    }, {
                        opacity: pick(style.hoveredOpacity, opacity)
                    }, {
                        opacity: pick(style.selectedOpacity, opacity)
                    }];
                    styles.border = [{
                        stroke: borderColor,
                        "stroke-width": borderWidth
                    }, {
                        stroke: style.hoveredBorderColor || borderColor,
                        "stroke-width": pick(style.hoveredBorderWidth, borderWidth)
                    }, {
                        stroke: style.selectedBorderColor || borderColor,
                        "stroke-width": pick(style.selectedBorderWidth, borderWidth)
                    }]
                },
                _setState: function(figure, styles, state) {
                    applyElementState(figure, styles, state, "pie");
                    applyElementState(figure, styles, state, "border")
                },
                arrange: function(context, handles) {
                    var i;
                    var ii = handles.length;
                    var dataField = context.settings.dataField;
                    var values;
                    var count = 0;
                    var palette;
                    for (i = 0; i < ii; ++i) {
                        values = getDataValue(handles[i].proxy, dataField);
                        if (values && values.length > count) {
                            count = values.length
                        }
                    }
                    if (count > 0) {
                        palette = context.params.themeManager.createPalette(context.settings.palette, {
                            useHighlight: true,
                            extensionMode: "alternate"
                        });
                        values = palette.generateColors(count);
                        context.settings._colors = values;
                        context.grouping.color = {
                            callback: _noop,
                            field: "",
                            partition: [],
                            values: []
                        };
                        context.params.dataExchanger.set(context.name, "color", {
                            partition: [],
                            values: values
                        })
                    }
                }
            },
            image: {
                _draw: function(ctx, figure, data) {
                    figure.image = ctx.renderer.image(null, null, null, null, null, "center").attr({
                        "pointer-events": "visible"
                    }).data(ctx.dataKey, data).append(figure.root)
                },
                refresh: function(ctx, figure, data, proxy) {
                    figure.image.attr({
                        href: getDataValue(proxy, ctx.settings.dataField)
                    })
                },
                _getStyles: function(styles, style) {
                    var size = style.size > 0 ? _Number(style.size) : 0;
                    var hoveredSize = size + (style.hoveredStep > 0 ? _Number(style.hoveredStep) : 0);
                    var selectedSize = size + (style.selectedStep > 0 ? _Number(style.selectedStep) : 0);
                    var opacity = pick(style.opacity, null);
                    styles.image = [{
                        x: -size / 2,
                        y: -size / 2,
                        width: size,
                        height: size,
                        opacity: opacity
                    }, {
                        x: -hoveredSize / 2,
                        y: -hoveredSize / 2,
                        width: hoveredSize,
                        height: hoveredSize,
                        opacity: pick(style.hoveredOpacity, opacity)
                    }, {
                        x: -selectedSize / 2,
                        y: -selectedSize / 2,
                        width: selectedSize,
                        height: selectedSize,
                        opacity: pick(style.selectedOpacity, opacity)
                    }]
                },
                _setState: function(figure, styles, state) {
                    applyElementState(figure, styles, state, "image")
                }
            }
        };

        function projectPoint(projection, coordinates) {
            return projection.project(coordinates)
        }

        function projectPointList(projection, coordinates) {
            var output = [];
            var i;
            var ii = output.length = coordinates.length;
            for (i = 0; i < ii; ++i) {
                output[i] = projection.project(coordinates[i])
            }
            return output
        }

        function projectLineString(projection, coordinates) {
            return [projectPointList(projection, coordinates)]
        }

        function projectPolygon(projection, coordinates) {
            var output = [];
            var i;
            var ii = output.length = coordinates.length;
            for (i = 0; i < ii; ++i) {
                output[i] = projectPointList(projection, coordinates[i])
            }
            return output
        }

        function projectMultiPolygon(projection, coordinates) {
            var output = [];
            var i;
            var ii = output.length = coordinates.length;
            for (i = 0; i < ii; ++i) {
                output[i] = projectPolygon(projection, coordinates[i])
            }
            return _concat.apply([], output)
        }

        function transformPoint(content, projection, coordinates) {
            var data = projection.transform(coordinates);
            content.root.attr({
                translateX: data[0],
                translateY: data[1]
            })
        }

        function transformList(projection, coordinates) {
            var output = [];
            var i;
            var ii = coordinates.length;
            var item;
            var k = 0;
            output.length = 2 * ii;
            for (i = 0; i < ii; ++i) {
                item = projection.transform(coordinates[i]);
                output[k++] = item[0];
                output[k++] = item[1]
            }
            return output
        }

        function transformPointList(content, projection, coordinates) {
            var output = [];
            var i;
            var ii = output.length = coordinates.length;
            for (i = 0; i < ii; ++i) {
                output[i] = transformList(projection, coordinates[i])
            }
            content.root.attr({
                points: output
            })
        }

        function transformAreaLabel(label, projection, coordinates) {
            var data = projection.transform(coordinates[0]);
            label.spaceSize = projection.getSquareSize(coordinates[1]);
            label.text.attr({
                translateX: data[0],
                translateY: data[1]
            });
            setAreaLabelVisibility(label)
        }

        function transformLineLabel(label, projection, coordinates) {
            var data = projection.transform(coordinates[0]);
            label.spaceSize = projection.getSquareSize(coordinates[1]);
            label.text.attr({
                translateX: data[0],
                translateY: data[1]
            });
            setLineLabelVisibility(label)
        }

        function getItemSettings(context, proxy, settings) {
            var result = combineSettings(context.settings, settings);
            applyGrouping(context.grouping, proxy, result);
            if (void 0 === settings.color && settings.paletteIndex >= 0) {
                result.color = result._colors[settings.paletteIndex]
            }
            return result
        }

        function applyGrouping(grouping, proxy, settings) {
            _each(grouping, function(name, data) {
                var index = findGroupingIndex(data.callback(proxy, data.field), data.partition);
                if (index >= 0) {
                    settings[name] = data.values[index]
                }
            })
        }

        function findGroupingIndex(value, partition) {
            var start = 0;
            var end = partition.length - 1;
            var index = -1;
            var middle;
            if (partition[start] <= value && value <= partition[end]) {
                if (value === partition[end]) {
                    index = end - 1
                } else {
                    while (end - start > 1) {
                        middle = start + end >> 1;
                        if (value < partition[middle]) {
                            end = middle
                        } else {
                            start = middle
                        }
                    }
                    index = start
                }
            }
            return index
        }

        function raiseChanged(context, handle, state, name) {
            context.params.eventTrigger(name, {
                target: handle.proxy,
                state: state
            })
        }

        function combineSettings(common, partial) {
            var obj = _extend({}, common, partial);
            obj.label = _extend({}, common.label, obj.label);
            obj.label.font = _extend({}, common.label.font, obj.label.font);
            return obj
        }

        function processCommonSettings(context, options) {
            var themeManager = context.params.themeManager;
            var strategy = context.str;
            var settings = combineSettings(_extend({
                label: {},
                color: strategy.getDefaultColor(context, options.palette)
            }, themeManager.theme("layer:" + strategy.fullType)), options);
            var colors;
            var i;
            var palette;
            if (settings.paletteSize > 0) {
                palette = themeManager.createDiscretePalette(settings.palette, settings.paletteSize);
                for (i = 0, colors = []; i < settings.paletteSize; ++i) {
                    colors.push(palette.getColor(i))
                }
                settings._colors = colors
            }
            return settings
        }

        function valueCallback(proxy, dataField) {
            return proxy.attribute(dataField)
        }
        var performGrouping = function(context, partition, settingField, dataField, valuesCallback) {
            var values;
            if (dataField && partition && partition.length > 1) {
                values = valuesCallback(partition.length - 1);
                context.grouping[settingField] = {
                    callback: (0, _type.isFunction)(dataField) ? dataField : valueCallback,
                    field: dataField,
                    partition: partition,
                    values: values
                };
                context.params.dataExchanger.set(context.name, settingField, {
                    partition: partition,
                    values: values,
                    defaultColor: context.settings.color
                })
            }
        };

        function dropGrouping(context) {
            var name = context.name;
            var dataExchanger = context.params.dataExchanger;
            _each(context.grouping, function(field) {
                dataExchanger.set(name, field, null)
            });
            context.grouping = {}
        }
        groupByColor = function(context) {
            performGrouping(context, context.settings.colorGroups, "color", context.settings.colorGroupingField, function(count) {
                var _palette = context.params.themeManager.createDiscretePalette(context.settings.palette, count);
                var i;
                var list = [];
                for (i = 0; i < count; ++i) {
                    list.push(_palette.getColor(i))
                }
                return list
            })
        };
        groupBySize = function(context, valueCallback) {
            var settings = context.settings;
            performGrouping(context, settings.sizeGroups, "size", valueCallback || settings.sizeGroupingField, function(count) {
                var minSize = settings.minSize > 0 ? _Number(settings.minSize) : 0;
                var maxSize = settings.maxSize >= minSize ? _Number(settings.maxSize) : 0;
                var i = 0;
                var sizes = [];
                if (count > 1) {
                    for (i = 0; i < count; ++i) {
                        sizes.push((minSize * (count - i - 1) + maxSize * i) / (count - 1))
                    }
                } else {
                    if (1 === count) {
                        sizes.push((minSize + maxSize) / 2)
                    }
                }
                return sizes
            })
        };

        function setFlag(flags, flag, state) {
            if (state) {
                flags |= flag
            } else {
                flags &= ~flag
            }
            return flags
        }

        function hasFlag(flags, flag) {
            return !!(flags & flag)
        }

        function createLayerProxy(layer, name, index) {
            var proxy = {
                index: index,
                name: name,
                getElements: function() {
                    return layer.getProxies()
                },
                clearSelection: function(_noEvent) {
                    layer.clearSelection(_noEvent);
                    return proxy
                },
                getDataSource: function() {
                    return layer.getDataSource()
                },
                getBounds: function() {
                    return layer.getBounds()
                }
            };
            return proxy
        }
        var MapLayerElement;
        var MapLayer = function(params, container, name, index) {
            var that = this;
            that._params = params;
            that._onProjection();
            that.proxy = createLayerProxy(that, name, index);
            that._context = {
                name: name,
                layer: that.proxy,
                renderer: params.renderer,
                projection: params.projection,
                params: params,
                dataKey: params.dataKey,
                str: emptyStrategy,
                hover: false,
                selection: null,
                grouping: {},
                root: params.renderer.g().attr({
                    "class": "dxm-layer"
                }).linkOn(container, name).linkAppend()
            };
            that._container = container;
            that._options = {};
            that._handles = [];
            that._data = new EmptySource;
            that._dataSourceLoaded = null
        };
        MapLayer.prototype = _extend({
            constructor: MapLayer,
            getDataReadyCallback: function() {
                return this._dataSourceLoaded
            },
            _onProjection: function() {
                var that = this;
                that._removeHandlers = that._params.projection.on({
                    engine: function() {
                        that._project()
                    },
                    screen: function() {
                        that._transform()
                    },
                    center: function() {
                        that._transformCore()
                    },
                    zoom: function() {
                        that._transform()
                    }
                })
            },
            getData: function() {
                return this._data
            },
            _dataSourceLoadErrorHandler: function() {
                this._dataSourceChangedHandler()
            },
            _dataSourceChangedHandler: function() {
                var that = this;
                that._data = unwrapFromDataSource(that._dataSource && that._dataSource.items());
                that._update(true)
            },
            _dataSourceOptions: function() {
                return {
                    paginate: false
                }
            },
            _getSpecificDataSourceOption: function() {
                return this._specificDataSourceOption
            },
            _normalizeDataSource: function(dataSource) {
                var store = dataSource.store();
                if ("raw" === store._loadMode) {
                    store._loadMode = void 0
                }
                return dataSource
            },
            _offProjection: function() {
                this._removeHandlers();
                this._removeHandlers = null
            },
            dispose: function() {
                var that = this;
                that._disposeDataSource();
                that._destroyHandles();
                dropGrouping(that._context);
                that._context.root.linkRemove().linkOff();
                that._context.labelRoot && that._context.labelRoot.linkRemove().linkOff();
                that._context.str.reset(that._context);
                that._offProjection();
                that._params = that._container = that._context = that.proxy = null;
                return that
            },
            setOptions: function(options) {
                var that = this;
                options = that._options = options || {};
                that._dataSourceLoaded = new _deferred.Deferred;
                if ("dataSource" in options && options.dataSource !== that._options_dataSource) {
                    that._options_dataSource = options.dataSource;
                    that._params.notifyDirty();
                    that._specificDataSourceOption = wrapToDataSource(options.dataSource);
                    that._refreshDataSource()
                } else {
                    if (that._data.count() > 0) {
                        that._params.notifyDirty();
                        that._update(void 0 !== options.type && options.type !== that._context.str.type || void 0 !== options.elementType && options.elementType !== that._context.str.elementType)
                    }
                }
                that._transformCore()
            },
            _update: function(isContextChanged) {
                var that = this;
                var context = that._context;
                if (isContextChanged) {
                    context.str.reset(context);
                    context.root.clear();
                    context.labelRoot && context.labelRoot.clear();
                    that._params.tracker.reset();
                    that._destroyHandles();
                    context.str = selectStrategy(that._options, that._data);
                    context.str.setup(context);
                    that.proxy.type = context.str.type;
                    that.proxy.elementType = context.str.elementType
                }
                context.settings = processCommonSettings(context, that._options);
                context.hasSeparateLabel = !!(context.settings.label.enabled && context.str.hasLabelsGroup);
                context.hover = !!(0, _utils.parseScalar)(context.settings.hoverEnabled, true);
                if (context.selection) {
                    _each(context.selection.state, function(_, handle) {
                        handle && handle.resetSelected()
                    })
                }
                context.selection = getSelection(context.settings.selectionMode);
                if (context.hasSeparateLabel) {
                    if (!context.labelRoot) {
                        context.labelRoot = context.renderer.g().attr({
                            "class": "dxm-layer-labels"
                        }).linkOn(that._container, {
                            name: context.name + "-labels",
                            after: context.name
                        }).linkAppend();
                        that._transformCore()
                    }
                } else {
                    if (context.labelRoot) {
                        context.labelRoot.linkRemove().linkOff();
                        context.labelRoot = null
                    }
                }
                if (isContextChanged) {
                    that._createHandles()
                }
                dropGrouping(context);
                context.str.arrange(context, that._handles);
                context.str.updateGrouping(context);
                that._updateHandles();
                that._params.notifyReady();
                if (that._dataSourceLoaded) {
                    that._dataSourceLoaded.resolve();
                    that._dataSourceLoaded = null
                } else {
                    that._params.dataReady()
                }
            },
            getBounds: function() {
                return getMaxBound(this._handles.map(function(_ref) {
                    var proxy = _ref.proxy;
                    return proxy.coordinates().map(function(coords) {
                        if (!_isArray(coords)) {
                            return
                        }
                        var coordsToBoundsSearch = _isArray(coords[0][0]) ? coords.reduce(function(ac, val) {
                            return ac.concat(val)
                        }, []) : coords;
                        var initValue = coordsToBoundsSearch[0];
                        return coordsToBoundsSearch.reduce(function(min, c) {
                            return [_min(min[0], c[0]), _min(min[1], c[1]), _max(min[2], c[0]), _max(min[3], c[1])]
                        }, [initValue[0], initValue[1], initValue[0], initValue[1]])
                    })
                }).map(getMaxBound))
            },
            _destroyHandles: function() {
                this._handles.forEach(function(h) {
                    return h.dispose()
                });
                if (this._context.selection) {
                    this._context.selection.state = {}
                }
                this._handles = []
            },
            _createHandles: function() {
                var that = this;
                var handles = that._handles = [];
                var data = that._data;
                var i;
                var ii = handles.length = data.count();
                var context = that._context;
                var geometry = data.geometry;
                var attributes = data.attributes;
                var handle;
                var dataItem;
                for (i = 0; i < ii; ++i) {
                    dataItem = data.item(i);
                    handles[i] = new MapLayerElement(context, i, geometry(dataItem), attributes(dataItem))
                }(0, _type.isFunction)(that._options.customize) && customizeHandles(that.getProxies(), that._options.customize, that._params.widget);
                for (i = 0; i < ii; ++i) {
                    handle = handles[i];
                    handle.project();
                    handle.draw();
                    handle.transform()
                }
                if (context.selection) {
                    _each(context.selection.state, function(_, handle) {
                        handle && handle.restoreSelected()
                    })
                }
            },
            _updateHandles: function() {
                var handles = this._handles;
                var i;
                var ii = handles.length;
                for (i = 0; i < ii; ++i) {
                    handles[i].refresh()
                }
                if (this._context.settings.label.enabled) {
                    for (i = 0; i < ii; ++i) {
                        handles[i].measureLabel()
                    }
                    for (i = 0; i < ii; ++i) {
                        handles[i].adjustLabel()
                    }
                }
            },
            _transformCore: function() {
                var transform = this._params.projection.getTransform();
                this._context.root.attr(transform);
                this._context.labelRoot && this._context.labelRoot.attr(transform)
            },
            _project: function() {
                var handles = this._handles;
                var i;
                var ii = handles.length;
                for (i = 0; i < ii; ++i) {
                    handles[i].project()
                }
            },
            _transform: function() {
                var handles = this._handles;
                var i;
                var ii = handles.length;
                this._transformCore();
                for (i = 0; i < ii; ++i) {
                    handles[i].transform()
                }
            },
            getProxies: function() {
                return this._handles.map(function(p) {
                    return p.proxy
                })
            },
            getProxy: function(index) {
                return this._handles[index].proxy
            },
            raiseClick: function(i, dxEvent) {
                this._params.eventTrigger("click", {
                    target: this._handles[i].proxy,
                    event: dxEvent
                })
            },
            hoverItem: function(i, state) {
                this._handles[i].setHovered(state)
            },
            selectItem: function(i, state, _noEvent) {
                this._handles[i].setSelected(state, _noEvent)
            },
            clearSelection: function() {
                var selection = this._context.selection;
                if (selection) {
                    _each(selection.state, function(_, handle) {
                        handle && handle.setSelected(false)
                    });
                    selection.state = {}
                }
            }
        }, _data_helper.default);

        function createProxy(handle, coords, attrs) {
            var proxy = {
                coordinates: function() {
                    return coords
                },
                attribute: function(name, value) {
                    if (arguments.length > 1) {
                        attrs[name] = value;
                        return proxy
                    } else {
                        return arguments.length > 0 ? attrs[name] : attrs
                    }
                },
                selected: function(state, _noEvent) {
                    if (arguments.length > 0) {
                        handle.setSelected(state, _noEvent);
                        return proxy
                    } else {
                        return handle.isSelected()
                    }
                },
                applySettings: function(settings) {
                    handle.update(settings);
                    return proxy
                }
            };
            return proxy
        }
        MapLayerElement = function(context, index, geometry, attributes) {
            var that = this;
            var proxy = that.proxy = createProxy(that, geometry.coordinates, _extend({}, attributes));
            that._ctx = context;
            that._index = index;
            that._fig = that._label = null;
            that._state = STATE_DEFAULT;
            that._coordinates = geometry.coordinates;
            that._settings = {
                label: {}
            };
            proxy.index = index;
            proxy.layer = context.layer;
            that._data = {
                name: context.name,
                index: index
            }
        };
        MapLayerElement.prototype = {
            constructor: MapLayerElement,
            dispose: function() {
                var that = this;
                that._ctx = that.proxy = that._settings = that._fig = that._label = that.data = null;
                return that
            },
            project: function() {
                var context = this._ctx;
                this._projection = context.str.project(context.projection, this._coordinates);
                if (context.hasSeparateLabel && this._label) {
                    this._projectLabel()
                }
            },
            _projectLabel: function() {
                this._labelProjection = this._ctx.str.projectLabel(this._projection)
            },
            draw: function() {
                var that = this;
                var context = this._ctx;
                context.str.draw(context, that._fig = {}, that._data);
                that._fig.root.append(context.root)
            },
            transform: function() {
                var that = this;
                var context = that._ctx;
                context.str.transform(that._fig, context.projection, that._projection);
                if (context.hasSeparateLabel && that._label) {
                    that._transformLabel()
                }
            },
            _transformLabel: function() {
                this._ctx.str.transformLabel(this._label, this._ctx.projection, this._labelProjection)
            },
            refresh: function() {
                var that = this;
                var strategy = that._ctx.str;
                var settings = getItemSettings(that._ctx, that.proxy, that._settings);
                that._styles = strategy.getStyles(settings);
                strategy.refresh(that._ctx, that._fig, that._data, that.proxy, settings);
                that._refreshLabel(settings);
                that._setState()
            },
            _refreshLabel: function(settings) {
                var that = this;
                var context = that._ctx;
                var labelSettings = settings.label;
                var label = that._label;
                if (context.settings.label.enabled) {
                    if (!label) {
                        label = that._label = {
                            root: context.labelRoot || that._fig.root,
                            text: context.renderer.text().attr({
                                "class": "dxm-label"
                            }),
                            size: [0, 0]
                        };
                        if (context.hasSeparateLabel) {
                            that._projectLabel();
                            that._transformLabel()
                        }
                    }
                    label.value = _String(that.proxy.text || that.proxy.attribute(labelSettings.dataField) || "");
                    if (label.value) {
                        label.text.attr({
                            text: label.value,
                            x: 0,
                            y: 0
                        }).css((0, _utils.patchFontOptions)(labelSettings.font)).attr({
                            align: "center",
                            stroke: labelSettings.stroke,
                            "stroke-width": labelSettings["stroke-width"],
                            "stroke-opacity": labelSettings["stroke-opacity"]
                        }).data(context.dataKey, that._data).append(label.root);
                        label.settings = settings
                    }
                } else {
                    if (label) {
                        label.text.remove();
                        that._label = null
                    }
                }
            },
            measureLabel: function() {
                var label = this._label;
                var bBox;
                if (label.value) {
                    bBox = label.text.getBBox();
                    label.size = [bBox.width, bBox.height, -bBox.y - bBox.height / 2]
                }
            },
            adjustLabel: function() {
                var label = this._label;
                var offset;
                if (label.value) {
                    offset = this._ctx.str.getLabelOffset(label, label.settings);
                    label.settings = null;
                    label.text.attr({
                        x: offset[0],
                        y: offset[1] + label.size[2]
                    })
                }
            },
            update: function(settings) {
                var that = this;
                that._settings = combineSettings(that._settings, settings);
                if (that._fig) {
                    that.refresh();
                    if (that._label && that._label.value) {
                        that.measureLabel();
                        that.adjustLabel()
                    }
                }
            },
            _setState: function() {
                this._ctx.str.setState(this._fig, this._styles, STATE_TO_INDEX[this._state])
            },
            _setForeground: function() {
                var root = this._fig.root;
                this._state ? root.toForeground() : root.toBackground()
            },
            setHovered: function(state) {
                var that = this;
                var currentState = hasFlag(that._state, STATE_HOVERED);
                var newState = !!state;
                if (that._ctx.hover && currentState !== newState) {
                    that._state = setFlag(that._state, STATE_HOVERED, newState);
                    that._setState();
                    that._setForeground();
                    raiseChanged(that._ctx, that, newState, "hoverChanged")
                }
                return that
            },
            setSelected: function(state, _noEvent) {
                var that = this;
                var currentState = hasFlag(that._state, STATE_SELECTED);
                var newState = !!state;
                var selection = that._ctx.selection;
                var tmp;
                if (selection && currentState !== newState) {
                    that._state = setFlag(that._state, STATE_SELECTED, newState);
                    tmp = selection.state[selection.single];
                    selection.state[selection.single] = null;
                    if (tmp) {
                        tmp.setSelected(false)
                    }
                    selection.state[selection.single || that._index] = state ? that : null;
                    if (that._fig) {
                        that._setState();
                        that._setForeground();
                        if (!_noEvent) {
                            raiseChanged(that._ctx, that, newState, "selectionChanged")
                        }
                    }
                }
            },
            isSelected: function() {
                return hasFlag(this._state, STATE_SELECTED)
            },
            resetSelected: function() {
                this._state = setFlag(this._state, STATE_SELECTED, false)
            },
            restoreSelected: function() {
                this._fig.root.toForeground()
            }
        };

        function calculatePolygonCentroid(coordinates) {
            var i;
            var length = coordinates.length;
            var v1;
            var v2 = coordinates[length - 1];
            var cross;
            var cx = 0;
            var cy = 0;
            var area = 0;
            var minX = 1 / 0;
            var maxX = -(1 / 0);
            var minY = 1 / 0;
            var maxY = -(1 / 0);
            for (i = 0; i < length; ++i) {
                v1 = v2;
                v2 = coordinates[i];
                cross = v1[0] * v2[1] - v2[0] * v1[1];
                area += cross;
                cx += (v1[0] + v2[0]) * cross;
                cy += (v1[1] + v2[1]) * cross;
                minX = _min(minX, v2[0]);
                maxX = _max(maxX, v2[0]);
                minY = _min(minY, v2[1]);
                maxY = _max(maxY, v2[1])
            }
            return {
                area: _abs(area) / 2,
                center: [2 * cx / 3 / area - (minX + maxX) / 2, 2 * cy / 3 / area - (minY + maxY) / 2]
            }
        }

        function calculateLineStringData(coordinates) {
            var i;
            var ii = coordinates.length;
            var v1;
            var v2 = coordinates[0] || [];
            var totalLength = 0;
            var items = [0];
            var min0 = v2[0];
            var max0 = v2[0];
            var min1 = v2[1];
            var max1 = v2[1];
            for (i = 1; i < ii; ++i) {
                v1 = v2;
                v2 = coordinates[i];
                totalLength += _sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
                items[i] = totalLength;
                min0 = _min(min0, v2[0]);
                max0 = _max(max0, v2[0]);
                min1 = _min(min1, v2[1]);
                max1 = _max(max1, v2[1])
            }
            i = findGroupingIndex(totalLength / 2, items);
            v1 = coordinates[i];
            v2 = coordinates[i + 1];
            var t = (totalLength / 2 - items[i]) / (items[i + 1] - items[i]);
            return ii ? [
                [v1[0] * (1 - t) + v2[0] * t, v1[1] * (1 - t) + v2[1] * t],
                [max0 - min0, max1 - min1], totalLength
            ] : []
        }

        function projectAreaLabel(coordinates) {
            var i;
            var ii = coordinates.length;
            var centroid;
            var resultCentroid;
            var maxArea = 0;
            for (i = 0; i < ii; ++i) {
                centroid = calculatePolygonCentroid(coordinates[i]);
                if (centroid.area > maxArea) {
                    maxArea = centroid.area;
                    resultCentroid = centroid
                }
            }
            return resultCentroid ? [resultCentroid.center, [_sqrt(resultCentroid.area), _sqrt(resultCentroid.area)]] : [
                [],
                []
            ]
        }

        function projectLineLabel(coordinates) {
            var i;
            var ii = coordinates.length;
            var maxLength = 0;
            var data;
            var resultData;
            for (i = 0; i < ii; ++i) {
                data = calculateLineStringData(coordinates[i]);
                if (data[2] > maxLength) {
                    maxLength = data[2];
                    resultData = data
                }
            }
            return resultData || [
                [],
                []
            ]
        }

        function MapLayerCollection(params) {
            var that = this;
            var renderer = params.renderer;
            that._params = params;
            that._layers = [];
            that._layerByName = {};
            that._rect = [0, 0, 0, 0];
            that._clip = renderer.clipRect();
            that._background = renderer.rect().attr({
                "class": "dxm-background"
            }).data(params.dataKey, {
                name: "background"
            }).append(renderer.root);
            that._container = renderer.g().attr({
                "class": "dxm-layers",
                "clip-path": that._clip.id
            }).append(renderer.root).enableLinks();
            that._subscribeToTracker(params.tracker, renderer, params.eventTrigger);
            that._dataReady = params.dataReady
        }
        MapLayerCollection.prototype = {
            constructor: MapLayerCollection,
            dispose: function() {
                var that = this;
                that._clip.dispose();
                that._layers.forEach(function(l) {
                    return l.dispose()
                });
                that._offTracker();
                that._params = that._offTracker = that._layers = that._layerByName = that._clip = that._background = that._container = null
            },
            _subscribeToTracker: function(tracker, renderer, eventTrigger) {
                var that = this;
                that._offTracker = tracker.on({
                    click: function(arg) {
                        var offset = renderer.getRootOffset();
                        var layer = that.byName(arg.data.name);
                        arg.$event.x = arg.x - offset.left;
                        arg.$event.y = arg.y - offset.top;
                        if (layer) {
                            layer.raiseClick(arg.data.index, arg.$event)
                        } else {
                            if ("background" === arg.data.name) {
                                eventTrigger("click", {
                                    event: arg.$event
                                })
                            }
                        }
                    },
                    "hover-on": function(arg) {
                        var layer = that.byName(arg.data.name);
                        if (layer) {
                            layer.hoverItem(arg.data.index, true)
                        }
                    },
                    "hover-off": function(arg) {
                        var layer = that.byName(arg.data.name);
                        if (layer) {
                            layer.hoverItem(arg.data.index, false)
                        }
                    }
                })
            },
            setOptions: function(options) {
                var that = this;
                var optionList = options ? _isArray(options) ? options : [options] : [];
                var layerByName = that._layerByName;
                var layers = that._layers;
                var readyCallbacks = [];
                var needToCreateLayers = optionList.length !== layers.length || layers.some(function(l, i) {
                    var name = getName(optionList, i);
                    return (0, _type.isDefined)(name) && name !== l.proxy.name
                });
                if (needToCreateLayers) {
                    that._params.tracker.reset();
                    that._layers.forEach(function(l) {
                        return l.dispose()
                    });
                    that._layerByName = layerByName = {};
                    that._layers = layers = [];
                    for (var i = 0, ii = optionList.length; i < ii; ++i) {
                        var name = getName(optionList, i) || "map-layer-" + i;
                        var layer = layers[i] = new MapLayer(that._params, that._container, name, i);
                        layerByName[name] = layer
                    }
                }
                layers.forEach(function(l, i) {
                    l.setOptions(optionList[i])
                });
                readyCallbacks = layers.map(function(l) {
                    return l.getDataReadyCallback()
                });
                readyCallbacks.length && _deferred.when.apply(void 0, readyCallbacks).done(that._dataReady)
            },
            _updateClip: function() {
                var rect = this._rect;
                var bw = this._borderWidth;
                this._clip.attr({
                    x: rect[0] + bw,
                    y: rect[1] + bw,
                    width: _max(rect[2] - 2 * bw, 0),
                    height: _max(rect[3] - 2 * bw, 0)
                })
            },
            setBackgroundOptions: function(options) {
                this._background.attr({
                    stroke: options.borderColor,
                    "stroke-width": options.borderWidth,
                    fill: options.color
                });
                this._borderWidth = _max(options.borderWidth, 0);
                this._updateClip()
            },
            setRect: function(rect) {
                this._rect = rect;
                this._background.attr({
                    x: rect[0],
                    y: rect[1],
                    width: rect[2],
                    height: rect[3]
                });
                this._updateClip()
            },
            byIndex: function(index) {
                return this._layers[index]
            },
            byName: function(name) {
                return this._layerByName[name]
            },
            items: function() {
                return this._layers
            }
        }
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/vector_map/tooltip_viewer.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.TooltipViewer = TooltipViewer;
        var TOOLTIP_OFFSET = 12;

        function TooltipViewer(params) {
            this._subscribeToTracker(params.tracker, params.tooltip, params.layerCollection)
        }
        TooltipViewer.prototype = {
            constructor: TooltipViewer,
            dispose: function() {
                this._offTracker();
                this._offTracker = null
            },
            _subscribeToTracker: function(tracker, tooltip, layerCollection) {
                this._offTracker = tracker.on({
                    "focus-on": function(arg) {
                        var layer;
                        var proxy;
                        if (tooltip.isEnabled()) {
                            layer = layerCollection.byName(arg.data.name);
                            proxy = layer && layer.getProxy(arg.data.index);
                            var callback = function(result) {
                                result && arg.done(result)
                            };
                            proxy && callback(tooltip.show(proxy, {
                                x: arg.x,
                                y: arg.y,
                                offset: TOOLTIP_OFFSET
                            }, {
                                target: proxy
                            }, void 0, callback))
                        }
                    },
                    "focus-move": function(arg) {
                        tooltip.move(arg.x, arg.y, TOOLTIP_OFFSET)
                    },
                    "focus-off": function() {
                        tooltip.hide()
                    }
                })
            }
        }
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/vector_map/vector_map.utils.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.generateDataKey = generateDataKey;
        var nextDataKey = 1;

        function generateDataKey() {
            return "vectormap-data-" + nextDataKey++
        }
    },
    /*!***************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/sparkline.js ***!
      \***************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _sparkline = _interopRequireDefault(__webpack_require__( /*! ./sparklines/sparkline */ 974));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _sparkline.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/sparklines/sparkline.js ***!
      \**************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _base_sparkline = _interopRequireDefault(__webpack_require__( /*! ./base_sparkline */ 482));
        var _data_validator = __webpack_require__( /*! ../components/data_validator */ 312);
        var _base_series = __webpack_require__( /*! ../series/base_series */ 314);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));
        var _data_source = __webpack_require__( /*! ../core/data_source */ 164);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var MIN_BAR_WIDTH = 1;
        var MAX_BAR_WIDTH = 50;
        var DEFAULT_BAR_INTERVAL = 4;
        var DEFAULT_CANVAS_WIDTH = 250;
        var DEFAULT_CANVAS_HEIGHT = 30;
        var DEFAULT_POINT_BORDER = 2;
        var ALLOWED_TYPES = {
            line: true,
            spline: true,
            stepline: true,
            area: true,
            steparea: true,
            splinearea: true,
            bar: true,
            winloss: true
        };
        var _math = Math;
        var _abs = _math.abs;
        var _round = _math.round;
        var _max = _math.max;
        var _min = _math.min;
        var _isFinite = isFinite;
        var _Number = Number;
        var _String = String;

        function findMinMax(data, valField) {
            var firstItem = data[0] || {};
            var firstValue = firstItem[valField] || 0;
            var min = firstValue;
            var max = firstValue;
            var minIndexes = [0];
            var maxIndexes = [0];
            var dataLength = data.length;
            var value;
            var i;
            for (i = 1; i < dataLength; i++) {
                value = data[i][valField];
                if (value < min) {
                    min = value;
                    minIndexes = [i]
                } else {
                    if (value === min) {
                        minIndexes.push(i)
                    }
                }
                if (value > max) {
                    max = value;
                    maxIndexes = [i]
                } else {
                    if (value === max) {
                        maxIndexes.push(i)
                    }
                }
            }
            if (max === min) {
                minIndexes = maxIndexes = []
            }
            return {
                minIndexes: minIndexes,
                maxIndexes: maxIndexes
            }
        }

        function parseNumericDataSource(data, argField, valField, ignoreEmptyPoints) {
            return (0, _utils.map)(data, function(dataItem, index) {
                var item = null;
                var isDataNumber;
                var value;
                if (void 0 !== dataItem) {
                    item = {};
                    isDataNumber = _isFinite(dataItem);
                    item[argField] = isDataNumber ? _String(index) : dataItem[argField];
                    value = isDataNumber ? dataItem : dataItem[valField];
                    item[valField] = null === value ? ignoreEmptyPoints ? void 0 : value : _Number(value);
                    item = void 0 !== item[argField] && void 0 !== item[valField] ? item : null
                }
                return item
            })
        }

        function parseWinlossDataSource(data, argField, valField, target) {
            var lowBarValue = -1;
            var zeroBarValue = 0;
            var highBarValue = 1;
            var delta = 1e-4;
            return (0, _utils.map)(data, function(dataItem) {
                var item = {};
                item[argField] = dataItem[argField];
                if (_abs(dataItem[valField] - target) < delta) {
                    item[valField] = zeroBarValue
                } else {
                    if (dataItem[valField] > target) {
                        item[valField] = highBarValue
                    } else {
                        item[valField] = lowBarValue
                    }
                }
                return item
            })
        }

        function selectPointColor(color, options, index, pointIndexes) {
            if (index === pointIndexes.first || index === pointIndexes.last) {
                color = options.firstLastColor
            }
            if ((pointIndexes.min || []).indexOf(index) >= 0) {
                color = options.minColor
            }
            if ((pointIndexes.max || []).indexOf(index) >= 0) {
                color = options.maxColor
            }
            return color
        }

        function createLineCustomizeFunction(pointIndexes, options) {
            return function() {
                var color = selectPointColor(void 0, options, this.index, pointIndexes);
                return color ? {
                    visible: true,
                    border: {
                        color: color
                    }
                } : {}
            }
        }

        function createBarCustomizeFunction(pointIndexes, options, winlossData) {
            return function() {
                var index = this.index;
                var isWinloss = "winloss" === options.type;
                var target = isWinloss ? options.winlossThreshold : 0;
                var value = isWinloss ? winlossData[index][options.valueField] : this.value;
                var positiveColor = isWinloss ? options.winColor : options.barPositiveColor;
                var negativeColor = isWinloss ? options.lossColor : options.barNegativeColor;
                return {
                    color: selectPointColor(value >= target ? positiveColor : negativeColor, options, index, pointIndexes)
                }
            }
        }
        var dxSparkline = _base_sparkline.default.inherit({
            _rootClassPrefix: "dxsl",
            _rootClass: "dxsl-sparkline",
            _themeSection: "sparkline",
            _defaultSize: {
                width: DEFAULT_CANVAS_WIDTH,
                height: DEFAULT_CANVAS_HEIGHT
            },
            _initCore: function() {
                this.callBase();
                this._createSeries()
            },
            _initialChanges: ["DATA_SOURCE"],
            _dataSourceChangedHandler: function() {
                this._requestChange(["UPDATE"])
            },
            _updateWidgetElements: function() {
                this._updateSeries();
                this.callBase()
            },
            _disposeWidgetElements: function() {
                var that = this;
                that._series && that._series.dispose();
                that._series = that._seriesGroup = that._seriesLabelGroup = null
            },
            _cleanWidgetElements: function() {
                this._seriesGroup.remove();
                this._seriesLabelGroup.remove();
                this._seriesGroup.clear();
                this._seriesLabelGroup.clear()
            },
            _drawWidgetElements: function() {
                if (this._dataIsLoaded()) {
                    this._drawSeries();
                    this._drawn()
                }
            },
            _getCorrectCanvas: function() {
                var options = this._allOptions;
                var canvas = this._canvas;
                var halfPointSize = options.pointSize && Math.ceil(options.pointSize / 2) + DEFAULT_POINT_BORDER;
                var type = options.type;
                if ("bar" !== type && "winloss" !== type && (options.showFirstLast || options.showMinMax)) {
                    return {
                        width: canvas.width,
                        height: canvas.height,
                        left: canvas.left + halfPointSize,
                        right: canvas.right + halfPointSize,
                        top: canvas.top + halfPointSize,
                        bottom: canvas.bottom + halfPointSize
                    }
                }
                return canvas
            },
            _prepareOptions: function() {
                var that = this;
                that._allOptions = that.callBase();
                that._allOptions.type = (0, _utils.normalizeEnum)(that._allOptions.type);
                if (!ALLOWED_TYPES[that._allOptions.type]) {
                    that._allOptions.type = "line"
                }
            },
            _createHtmlElements: function() {
                this._seriesGroup = this._renderer.g().attr({
                    "class": "dxsl-series"
                });
                this._seriesLabelGroup = this._renderer.g().attr({
                    "class": "dxsl-series-labels"
                })
            },
            _createSeries: function() {
                this._series = new _base_series.Series({
                    renderer: this._renderer,
                    seriesGroup: this._seriesGroup,
                    labelsGroup: this._seriesLabelGroup,
                    argumentAxis: this._argumentAxis,
                    valueAxis: this._valueAxis
                }, {
                    widgetType: "chart",
                    type: "line"
                })
            },
            _updateSeries: function() {
                var that = this;
                var singleSeries = that._series;
                that._prepareDataSource();
                var seriesOptions = that._prepareSeriesOptions();
                singleSeries.updateOptions(seriesOptions);
                var groupsData = {
                    groups: [{
                        series: [singleSeries]
                    }]
                };
                groupsData.argumentOptions = {
                    type: "bar" === seriesOptions.type ? "discrete" : void 0
                };
                that._simpleDataSource = (0, _data_validator.validateData)(that._simpleDataSource, groupsData, that._incidentOccurred, {
                    checkTypeForAllData: false,
                    convertToAxisDataType: true,
                    sortingMethod: true
                })[singleSeries.getArgumentField()];
                seriesOptions.customizePoint = that._getCustomizeFunction();
                singleSeries.updateData(that._simpleDataSource);
                singleSeries.createPoints();
                that._groupsDataCategories = groupsData.categories
            },
            _optionChangesMap: {
                dataSource: "DATA_SOURCE"
            },
            _optionChangesOrder: ["DATA_SOURCE"],
            _change_DATA_SOURCE: function() {
                this._updateDataSource()
            },
            _prepareDataSource: function() {
                var that = this;
                var options = that._allOptions;
                var argField = options.argumentField;
                var valField = options.valueField;
                var dataSource = that._dataSourceItems() || [];
                var data = parseNumericDataSource(dataSource, argField, valField, that.option("ignoreEmptyPoints"));
                if ("winloss" === options.type) {
                    that._winlossDataSource = data;
                    that._simpleDataSource = parseWinlossDataSource(data, argField, valField, options.winlossThreshold)
                } else {
                    that._simpleDataSource = data
                }
            },
            _prepareSeriesOptions: function() {
                var that = this;
                var options = that._allOptions;
                var type = "winloss" === options.type ? "bar" : options.type;
                return {
                    visible: true,
                    argumentField: options.argumentField,
                    valueField: options.valueField,
                    color: options.lineColor,
                    width: options.lineWidth,
                    widgetType: "chart",
                    type: type,
                    opacity: type.indexOf("area") !== -1 ? that._allOptions.areaOpacity : void 0,
                    point: {
                        size: options.pointSize,
                        symbol: options.pointSymbol,
                        border: {
                            visible: true,
                            width: DEFAULT_POINT_BORDER
                        },
                        color: options.pointColor,
                        visible: false,
                        hoverStyle: {
                            border: {}
                        },
                        selectionStyle: {
                            border: {}
                        }
                    },
                    border: {
                        color: options.lineColor,
                        width: options.lineWidth,
                        visible: "bar" !== type
                    }
                }
            },
            _getCustomizeFunction: function() {
                var that = this;
                var options = that._allOptions;
                var dataSource = that._winlossDataSource || that._simpleDataSource;
                var drawnPointIndexes = that._getExtremumPointsIndexes(dataSource);
                var customizeFunction;
                if ("winloss" === options.type || "bar" === options.type) {
                    customizeFunction = createBarCustomizeFunction(drawnPointIndexes, options, that._winlossDataSource)
                } else {
                    customizeFunction = createLineCustomizeFunction(drawnPointIndexes, options)
                }
                return customizeFunction
            },
            _getExtremumPointsIndexes: function(data) {
                var that = this;
                var options = that._allOptions;
                var lastIndex = data.length - 1;
                var indexes = {};
                that._minMaxIndexes = findMinMax(data, options.valueField);
                if (options.showFirstLast) {
                    indexes.first = 0;
                    indexes.last = lastIndex
                }
                if (options.showMinMax) {
                    indexes.min = that._minMaxIndexes.minIndexes;
                    indexes.max = that._minMaxIndexes.maxIndexes
                }
                return indexes
            },
            _getStick: function() {
                return {
                    stick: "bar" !== this._series.type
                }
            },
            _updateRange: function() {
                var that = this;
                var series = that._series;
                var type = series.type;
                var isBarType = "bar" === type;
                var isWinlossType = "winloss" === type;
                var DEFAULT_VALUE_RANGE_MARGIN = .15;
                var DEFAULT_ARGUMENT_RANGE_MARGIN = .1;
                var WINLOSS_MAX_RANGE = 1;
                var WINLOSS_MIN_RANGE = -1;
                var rangeData = series.getRangeData();
                var minValue = that._allOptions.minValue;
                var hasMinY = (0, _type.isDefined)(minValue) && _isFinite(minValue);
                var maxValue = that._allOptions.maxValue;
                var hasMaxY = (0, _type.isDefined)(maxValue) && _isFinite(maxValue);
                var argCoef;
                var valCoef = (rangeData.val.max - rangeData.val.min) * DEFAULT_VALUE_RANGE_MARGIN;
                if (isBarType || isWinlossType || "area" === type) {
                    if (0 !== rangeData.val.min) {
                        rangeData.val.min -= valCoef
                    }
                    if (0 !== rangeData.val.max) {
                        rangeData.val.max += valCoef
                    }
                } else {
                    rangeData.val.min -= valCoef;
                    rangeData.val.max += valCoef
                }
                if (hasMinY || hasMaxY) {
                    if (hasMinY && hasMaxY) {
                        rangeData.val.minVisible = _min(minValue, maxValue);
                        rangeData.val.maxVisible = _max(minValue, maxValue)
                    } else {
                        rangeData.val.minVisible = hasMinY ? _Number(minValue) : void 0;
                        rangeData.val.maxVisible = hasMaxY ? _Number(maxValue) : void 0
                    }
                    if (isWinlossType) {
                        rangeData.val.minVisible = hasMinY ? _max(rangeData.val.minVisible, WINLOSS_MIN_RANGE) : void 0;
                        rangeData.val.maxVisible = hasMaxY ? _min(rangeData.val.maxVisible, WINLOSS_MAX_RANGE) : void 0
                    }
                }
                if (series.getPoints().length > 1) {
                    if (isBarType) {
                        argCoef = (rangeData.arg.max - rangeData.arg.min) * DEFAULT_ARGUMENT_RANGE_MARGIN;
                        rangeData.arg.min = rangeData.arg.min - argCoef;
                        rangeData.arg.max = rangeData.arg.max + argCoef
                    }
                }
                rangeData.arg.categories = that._groupsDataCategories;
                that._ranges = rangeData
            },
            _getBarWidth: function(pointsCount) {
                var that = this;
                var canvas = that._canvas;
                var intervalWidth = pointsCount * DEFAULT_BAR_INTERVAL;
                var rangeWidth = canvas.width - canvas.left - canvas.right - intervalWidth;
                var width = _round(rangeWidth / pointsCount);
                if (width < MIN_BAR_WIDTH) {
                    width = MIN_BAR_WIDTH
                }
                if (width > MAX_BAR_WIDTH) {
                    width = MAX_BAR_WIDTH
                }
                return width
            },
            _correctPoints: function() {
                var that = this;
                var seriesType = that._allOptions.type;
                var seriesPoints = that._series.getPoints();
                var pointsLength = seriesPoints.length;
                var barWidth;
                var i;
                if ("bar" === seriesType || "winloss" === seriesType) {
                    barWidth = that._getBarWidth(pointsLength);
                    for (i = 0; i < pointsLength; i++) {
                        seriesPoints[i].correctCoordinates({
                            width: barWidth,
                            offset: 0
                        })
                    }
                }
            },
            _drawSeries: function() {
                var that = this;
                if (that._simpleDataSource.length > 0) {
                    that._correctPoints();
                    that._series.draw();
                    that._seriesGroup.append(that._renderer.root)
                }
            },
            _isTooltipEnabled: function() {
                return !!this._simpleDataSource.length
            },
            _getTooltipData: function() {
                var that = this;
                var options = that._allOptions;
                var dataSource = that._winlossDataSource || that._simpleDataSource;
                var tooltip = that._tooltip;
                if (0 === dataSource.length) {
                    return {}
                }
                var minMax = that._minMaxIndexes;
                var valueField = options.valueField;
                var first = dataSource[0][valueField];
                var last = dataSource[dataSource.length - 1][valueField];
                var min = (0, _type.isDefined)(minMax.minIndexes[0]) ? dataSource[minMax.minIndexes[0]][valueField] : first;
                var max = (0, _type.isDefined)(minMax.maxIndexes[0]) ? dataSource[minMax.maxIndexes[0]][valueField] : first;
                var formattedFirst = tooltip.formatValue(first);
                var formattedLast = tooltip.formatValue(last);
                var formattedMin = tooltip.formatValue(min);
                var formattedMax = tooltip.formatValue(max);
                var customizeObject = {
                    firstValue: formattedFirst,
                    lastValue: formattedLast,
                    minValue: formattedMin,
                    maxValue: formattedMax,
                    originalFirstValue: first,
                    originalLastValue: last,
                    originalMinValue: min,
                    originalMaxValue: max,
                    valueText: ["Start:", formattedFirst, "End:", formattedLast, "Min:", formattedMin, "Max:", formattedMax]
                };
                if ("winloss" === options.type) {
                    customizeObject.originalThresholdValue = options.winlossThreshold;
                    customizeObject.thresholdValue = tooltip.formatValue(options.winlossThreshold)
                }
                return customizeObject
            }
        });
        (0, _utils.map)(["lineColor", "lineWidth", "areaOpacity", "minColor", "maxColor", "barPositiveColor", "barNegativeColor", "winColor", "lessColor", "firstLastColor", "pointSymbol", "pointColor", "pointSize", "type", "argumentField", "valueField", "winlossThreshold", "showFirstLast", "showMinMax", "ignoreEmptyPoints", "minValue", "maxValue"], function(name) {
            dxSparkline.prototype._optionChangesMap[name] = "OPTIONS"
        });
        (0, _component_registrator.default)("dxSparkline", dxSparkline);
        var _default = dxSparkline;
        exports.default = _default;
        dxSparkline.addPlugin(_data_source.plugin);
        module.exports = exports.default
    },
    /*!************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/bullet.js ***!
      \************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _bullet = _interopRequireDefault(__webpack_require__( /*! ./sparklines/bullet */ 976));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _bullet.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/sparklines/bullet.js ***!
      \***********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _iterator = __webpack_require__( /*! ../../core/utils/iterator */ 3);
        var _base_sparkline = _interopRequireDefault(__webpack_require__( /*! ./base_sparkline */ 482));
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../../core/component_registrator */ 9));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var TARGET_MIN_Y = .02;
        var TARGET_MAX_Y = .98;
        var BAR_VALUE_MIN_Y = .1;
        var BAR_VALUE_MAX_Y = .9;
        var DEFAULT_CANVAS_WIDTH = 300;
        var DEFAULT_CANVAS_HEIGHT = 30;
        var DEFAULT_HORIZONTAL_MARGIN = 1;
        var DEFAULT_VERTICAL_MARGIN = 2;
        var _Number = Number;
        var _isFinite = isFinite;
        var dxBullet = _base_sparkline.default.inherit({
            _rootClassPrefix: "dxb",
            _rootClass: "dxb-bullet",
            _themeSection: "bullet",
            _defaultSize: {
                width: DEFAULT_CANVAS_WIDTH,
                height: DEFAULT_CANVAS_HEIGHT,
                left: DEFAULT_HORIZONTAL_MARGIN,
                right: DEFAULT_HORIZONTAL_MARGIN,
                top: DEFAULT_VERTICAL_MARGIN,
                bottom: DEFAULT_VERTICAL_MARGIN
            },
            _disposeWidgetElements: function() {
                delete this._zeroLevelPath;
                delete this._targetPath;
                delete this._barValuePath
            },
            _cleanWidgetElements: function() {
                this._zeroLevelPath.remove();
                this._targetPath.remove();
                this._barValuePath.remove()
            },
            _drawWidgetElements: function() {
                this._drawBullet();
                this._drawn()
            },
            _createHtmlElements: function() {
                var renderer = this._renderer;
                this._zeroLevelPath = renderer.path(void 0, "line").attr({
                    "class": "dxb-zero-level",
                    "stroke-linecap": "square"
                });
                this._targetPath = renderer.path(void 0, "line").attr({
                    "class": "dxb-target",
                    "stroke-linecap": "square"
                });
                this._barValuePath = renderer.path(void 0, "line").attr({
                    "class": "dxb-bar-value",
                    "stroke-linecap": "square"
                })
            },
            _prepareOptions: function() {
                var that = this;
                var options;
                var startScaleValue;
                var endScaleValue;
                var level;
                var value;
                var target;
                that._allOptions = options = that.callBase();
                var isValueUndefined = void 0 === that._allOptions.value;
                var isTargetUndefined = void 0 === that._allOptions.target;
                that._tooltipEnabled = !(isValueUndefined && isTargetUndefined);
                if (isValueUndefined) {
                    that._allOptions.value = 0
                }
                if (isTargetUndefined) {
                    that._allOptions.target = 0
                }
                options.value = value = _Number(options.value);
                options.target = target = _Number(options.target);
                if (void 0 === that._allOptions.startScaleValue) {
                    that._allOptions.startScaleValue = target < value ? target : value;
                    that._allOptions.startScaleValue = that._allOptions.startScaleValue < 0 ? that._allOptions.startScaleValue : 0
                }
                if (void 0 === that._allOptions.endScaleValue) {
                    that._allOptions.endScaleValue = target > value ? target : value
                }
                options.startScaleValue = startScaleValue = _Number(options.startScaleValue);
                options.endScaleValue = endScaleValue = _Number(options.endScaleValue);
                if (endScaleValue < startScaleValue) {
                    level = endScaleValue;
                    that._allOptions.endScaleValue = startScaleValue;
                    that._allOptions.startScaleValue = level;
                    that._allOptions.inverted = true
                }
            },
            _updateRange: function() {
                var that = this;
                var options = that._allOptions;
                that._ranges = {
                    arg: {
                        invert: options.rtlEnabled ? !options.inverted : options.inverted,
                        min: options.startScaleValue,
                        max: options.endScaleValue,
                        axisType: "continuous",
                        dataType: "numeric"
                    },
                    val: {
                        min: 0,
                        max: 1,
                        axisType: "continuous",
                        dataType: "numeric"
                    }
                }
            },
            _drawBullet: function() {
                var that = this;
                var options = that._allOptions;
                var isValidBounds = options.startScaleValue !== options.endScaleValue;
                var isValidMin = _isFinite(options.startScaleValue);
                var isValidMax = _isFinite(options.endScaleValue);
                var isValidValue = _isFinite(options.value);
                var isValidTarget = _isFinite(options.target);
                if (isValidBounds && isValidMax && isValidMin && isValidTarget && isValidValue) {
                    this._drawBarValue();
                    this._drawTarget();
                    this._drawZeroLevel()
                }
            },
            _getTargetParams: function() {
                var that = this;
                var options = that._allOptions;
                var translatorY = that._valueAxis.getTranslator();
                var x = that._argumentAxis.getTranslator().translate(options.target);
                return {
                    points: [x, translatorY.translate(TARGET_MIN_Y), x, translatorY.translate(TARGET_MAX_Y)],
                    stroke: options.targetColor,
                    "stroke-width": options.targetWidth
                }
            },
            _getBarValueParams: function() {
                var that = this;
                var options = that._allOptions;
                var translatorX = that._argumentAxis.getTranslator();
                var translatorY = that._valueAxis.getTranslator();
                var startLevel = options.startScaleValue;
                var endLevel = options.endScaleValue;
                var value = options.value;
                var y2 = translatorY.translate(BAR_VALUE_MIN_Y);
                var y1 = translatorY.translate(BAR_VALUE_MAX_Y);
                var x1;
                var x2;
                if (value > 0) {
                    x1 = startLevel <= 0 ? 0 : startLevel;
                    x2 = value >= endLevel ? endLevel : value < x1 ? x1 : value
                } else {
                    x1 = endLevel >= 0 ? 0 : endLevel;
                    x2 = value < startLevel ? startLevel : value > x1 ? x1 : value
                }
                x1 = translatorX.translate(x1);
                x2 = translatorX.translate(x2);
                return {
                    points: [x1, y1, x2, y1, x2, y2, x1, y2],
                    fill: options.color
                }
            },
            _getCorrectCanvas: function() {
                return this._canvas
            },
            _getZeroLevelParams: function() {
                var that = this;
                var translatorY = that._valueAxis.getTranslator();
                var x = that._argumentAxis.getTranslator().translate(0);
                return {
                    points: [x, translatorY.translate(TARGET_MIN_Y), x, translatorY.translate(TARGET_MAX_Y)],
                    stroke: that._allOptions.targetColor,
                    "stroke-width": 1
                }
            },
            _drawZeroLevel: function() {
                var that = this;
                var options = that._allOptions;
                if (0 > options.endScaleValue || 0 < options.startScaleValue || !options.showZeroLevel) {
                    return
                }
                that._zeroLevelPath.attr(that._getZeroLevelParams()).sharp().append(that._renderer.root)
            },
            _drawTarget: function() {
                var that = this;
                var options = that._allOptions;
                var target = options.target;
                if (target > options.endScaleValue || target < options.startScaleValue || !options.showTarget) {
                    return
                }
                that._targetPath.attr(that._getTargetParams()).sharp().append(that._renderer.root)
            },
            _drawBarValue: function() {
                this._barValuePath.attr(this._getBarValueParams()).append(this._renderer.root)
            },
            _getTooltipCoords: function() {
                var canvas = this._canvas;
                var rootOffset = this._renderer.getRootOffset();
                var bBox = this._barValuePath.getBBox();
                return {
                    x: bBox.x + bBox.width / 2 + rootOffset.left,
                    y: canvas.height / 2 + rootOffset.top
                }
            },
            _getTooltipData: function() {
                var that = this;
                var tooltip = that._tooltip;
                var options = that._allOptions;
                var value = options.value;
                var target = options.target;
                var valueText = tooltip.formatValue(value);
                var targetText = tooltip.formatValue(target);
                return {
                    originalValue: value,
                    originalTarget: target,
                    value: valueText,
                    target: targetText,
                    valueText: ["Actual Value:", valueText, "Target Value:", targetText]
                }
            },
            _isTooltipEnabled: function() {
                return this._tooltipEnabled
            }
        });
        (0, _iterator.each)(["color", "targetColor", "targetWidth", "showTarget", "showZeroLevel", "value", "target", "startScaleValue", "endScaleValue"], function(_, name) {
            dxBullet.prototype._optionChangesMap[name] = "OPTIONS"
        });
        (0, _component_registrator.default)("dxBullet", dxBullet);
        var _default = dxBullet;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/tree_map.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _tree_map = _interopRequireDefault(__webpack_require__( /*! ./tree_map/tree_map */ 978));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _tree_map.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/tree_map/tree_map.js ***!
      \***********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _tree_map = _interopRequireDefault(__webpack_require__( /*! ./tree_map.base */ 109));
        __webpack_require__( /*! ./tiling.squarified */ 483);
        __webpack_require__( /*! ./tiling.strip */ 979);
        __webpack_require__( /*! ./tiling.slice_and_dice */ 980);
        __webpack_require__( /*! ./tiling.rotated_slice_and_dice */ 981);
        __webpack_require__( /*! ./colorizing.discrete */ 485);
        __webpack_require__( /*! ./colorizing.gradient */ 982);
        __webpack_require__( /*! ./colorizing.range */ 983);
        __webpack_require__( /*! ./api */ 166);
        __webpack_require__( /*! ./hover */ 486);
        __webpack_require__( /*! ./selection */ 984);
        __webpack_require__( /*! ./tooltip */ 488);
        __webpack_require__( /*! ./tracker */ 985);
        __webpack_require__( /*! ./drilldown */ 986);
        __webpack_require__( /*! ./plain_data_source */ 987);
        var _export = __webpack_require__( /*! ../core/export */ 108);
        var _title = __webpack_require__( /*! ../core/title */ 121);
        var _loading_indicator = __webpack_require__( /*! ../core/loading_indicator */ 145);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _default = _tree_map.default;
        exports.default = _default;
        _tree_map.default.addPlugin(_export.plugin);
        _tree_map.default.addPlugin(_title.plugin);
        _tree_map.default.addPlugin(_loading_indicator.plugin);
        module.exports = exports.default
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/tree_map/tiling.strip.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _tilingSquarified = _interopRequireDefault(__webpack_require__( /*! ./tiling.squarified.base */ 484));
        var _tiling = __webpack_require__( /*! ./tiling */ 165);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }

        function accumulate(total, current, count) {
            return ((count - 1) * total + current) / count
        }

        function strip(data) {
            return (0, _tilingSquarified.default)(data, accumulate, true)
        }(0, _tiling.addAlgorithm)("strip", strip);
        var _default = strip;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/tree_map/tiling.slice_and_dice.js ***!
      \************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _tiling = __webpack_require__( /*! ./tiling */ 165);

        function sliceAndDice(data) {
            var items = data.items;
            var sidesData = (0, _tiling.buildSidesData)(data.rect, data.directions, data.isRotated ? 1 : 0);
            (0, _tiling.calculateRectangles)(items, 0, data.rect, sidesData, {
                sum: data.sum,
                count: items.length,
                side: sidesData.variedSide
            })
        }(0, _tiling.addAlgorithm)("sliceanddice", sliceAndDice);
        var _default = sliceAndDice;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/tree_map/tiling.rotated_slice_and_dice.js ***!
      \********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _tiling = __webpack_require__( /*! ./tiling */ 165);
        var sliceAndDiceAlgorithm = (0, _tiling.getAlgorithm)("sliceanddice");

        function rotatedSliceAndDice(data) {
            data.isRotated = !data.isRotated;
            return sliceAndDiceAlgorithm.call(this, data)
        }(0, _tiling.addAlgorithm)("rotatedsliceanddice", rotatedSliceAndDice)
    },
    /*!**********************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/tree_map/colorizing.gradient.js ***!
      \**********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _colorizing = __webpack_require__( /*! ./colorizing */ 230);
        var _min = Math.min;
        var _max = Math.max;

        function createSimpleColorizer(getColor, range) {
            return function(node) {
                return getColor(node, range)
            }
        }

        function getRangeData(range) {
            return [Number(range[0]) || 0, range[1] - range[0] || 1]
        }

        function calculateRange(nodes, getValue) {
            var i;
            var ii = nodes.length;
            var codes = [];
            var code;
            for (i = 0; i < ii; ++i) {
                code = getValue(nodes[i]);
                if (isFinite(code)) {
                    codes.push(code)
                }
            }
            return getRangeData([_min.apply(null, codes), _max.apply(null, codes)])
        }

        function createGuessingColorizer(getColor, getValue) {
            var ranges = {};
            return function(node) {
                var parent = node.parent;
                return getColor(node, ranges[parent._id] || (ranges[parent._id] = calculateRange(parent.nodes, getValue)))
            }
        }

        function gradientColorizer(options, themeManager) {
            var palette = themeManager.createGradientPalette(options.palette);
            var getValue = (0, _colorizing.createColorCodeGetter)(options);
            return "range" in options ? createSimpleColorizer(getColor, getRangeData(options.range || [])) : createGuessingColorizer(getColor, getValue);

            function getColor(node, arg) {
                return palette.getColor((getValue(node) - arg[0]) / arg[1])
            }
        }(0, _colorizing.addColorizer)("gradient", gradientColorizer);
        var _default = gradientColorizer;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/tree_map/colorizing.range.js ***!
      \*******************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _colorizing = __webpack_require__( /*! ./colorizing */ 230);

        function getPaletteIndex(value, items) {
            var start = 0;
            var end = items.length - 1;
            var index = -1;
            var middle;
            if (items[start] <= value && value <= items[end]) {
                if (value === items[end]) {
                    index = end - 1
                } else {
                    while (end - start > 1) {
                        middle = start + end >> 1;
                        if (value < items[middle]) {
                            end = middle
                        } else {
                            start = middle
                        }
                    }
                    index = start
                }
            }
            return index
        }

        function rangeColorizer(options, themeManager) {
            var range = options.range || [];
            var palette = themeManager.createDiscretePalette(options.palette, range.length - 1);
            var getValue = (0, _colorizing.createColorCodeGetter)(options);
            return function(node) {
                return palette.getColor(getPaletteIndex(getValue(node), range))
            }
        }(0, _colorizing.addColorizer)("range", rangeColorizer);
        var _default = rangeColorizer;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/tree_map/selection.js ***!
      \************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _tree_map = _interopRequireDefault(__webpack_require__( /*! ./tree_map.base */ 109));
        var _node = _interopRequireDefault(__webpack_require__( /*! ./node */ 190));
        var _helpers = __webpack_require__( /*! ../core/helpers */ 162);
        var _common = __webpack_require__( /*! ./common */ 320);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _array = __webpack_require__( /*! ../../core/utils/array */ 12);
        __webpack_require__( /*! ./api */ 166);
        __webpack_require__( /*! ./states */ 487);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var proto = _tree_map.default.prototype;
        var nodeProto = _node.default.prototype;
        var MODE_NONE = 0;
        var MODE_SINGLE = 1;
        var MODE_MULTIPLE = 2;
        var STATE_CODE = 2;
        proto._eventsMap.onSelectionChanged = {
            name: "selectionChanged"
        };
        (0, _helpers.expand)(proto._handlers, "calculateAdditionalStates", function(states, options) {
            states[2] = options.selectionStyle ? (0, _common.buildRectAppearance)(options.selectionStyle) : {}
        });
        nodeProto.statesMap[2] = nodeProto.statesMap[3] = STATE_CODE;
        nodeProto.additionalStates.push(2);
        (0, _helpers.expand)(proto, "_onNodesCreated", function() {
            this._selectionList.length = 0
        });
        (0, _helpers.expand)(proto, "_extendProxyType", function(proto) {
            var that = this;
            proto.select = function(state) {
                that._selectNode(this._id, !!state)
            };
            proto.isSelected = function() {
                return (0, _array.inArray)(this._id, that._selectionList) >= 0
            };
            that._selectionList = []
        });
        _tree_map.default.addChange({
            code: "SELECTION_MODE",
            handler: function() {
                var that = this;
                var option = (0, _utils.normalizeEnum)(that._getOption("selectionMode", true));
                var selectionList = that._selectionList;
                var tmp;
                var mode = "none" === option ? MODE_NONE : "multiple" === option ? MODE_MULTIPLE : MODE_SINGLE;
                if (mode === MODE_SINGLE && selectionList.length > 1) {
                    tmp = selectionList.pop();
                    that.clearSelection();
                    selectionList.push(tmp)
                } else {
                    if (mode === MODE_NONE) {
                        that.clearSelection()
                    }
                }
                that._selectionMode = mode
            },
            isThemeDependent: true,
            isOptionChange: true,
            option: "selectionMode"
        });
        (0, _helpers.expand)(proto, "_applyTilesAppearance", function() {
            if (this._selectionList.length) {
                bringSelectedTilesToForeground(this._nodes, this._selectionList)
            }
        });
        var tileToFront = [leafToFront, groupToFront];

        function bringSelectedTilesToForeground(nodes, selectionList) {
            var i;
            var ii = selectionList.length;
            var node;
            for (i = 0; i < ii; ++i) {
                node = nodes[selectionList[i]];
                tileToFront[Number(node.isNode())](node.tile)
            }
        }

        function leafToFront(content) {
            content.toForeground()
        }

        function groupToFront(content) {
            content.outer.toForeground();
            content.inner.toForeground()
        }
        proto._applySelectionState = function(index, state) {
            var node = this._nodes[index];
            node.setState(STATE_CODE, state);
            this._eventTrigger("selectionChanged", {
                node: node.proxy
            })
        };
        proto._selectNode = function(index, state) {
            var that = this;
            var selectionList;
            var k;
            var tmp;
            if (that._selectionMode !== MODE_NONE) {
                that._context.suspend();
                selectionList = that._selectionList;
                k = (0, _array.inArray)(index, selectionList);
                if (state && k === -1) {
                    if (that._selectionMode === MODE_SINGLE) {
                        if (selectionList.length) {
                            tmp = selectionList.pop();
                            that._applySelectionState(tmp, false)
                        }
                    }
                    selectionList.push(index);
                    that._applySelectionState(index, true)
                } else {
                    if (!state && k >= 0) {
                        selectionList.splice(k, 1);
                        that._applySelectionState(index, false)
                    }
                }
                that._context.resume()
            }
        };
        proto.clearSelection = function() {
            var that = this;
            var selectionList = that._selectionList;
            var i;
            var ii = selectionList.length;
            if (that._selectionMode !== MODE_NONE) {
                that._context.suspend();
                for (i = 0; i < ii; ++i) {
                    that._applySelectionState(selectionList[i], false)
                }
                selectionList.length = 0;
                that._context.resume()
            }
        }
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/tree_map/tracker.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _tree_map = _interopRequireDefault(__webpack_require__( /*! ./tree_map.base */ 109));
        var _tracker = __webpack_require__( /*! ../components/tracker */ 321);
        var _helpers = __webpack_require__( /*! ../core/helpers */ 162);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        __webpack_require__( /*! ./api */ 166);
        __webpack_require__( /*! ./hover */ 486);
        __webpack_require__( /*! ./tooltip */ 488);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DATA_KEY_BASE = "__treemap_data_";
        var dataKeyModifier = 0;
        var proto = _tree_map.default.prototype;
        proto._eventsMap.onClick = {
            name: "click"
        };
        var getDataKey = function() {
            var dataKey = DATA_KEY_BASE + dataKeyModifier++;
            return dataKey
        };
        (0, _helpers.expand)(proto, "_initCore", function() {
            var that = this;
            var dataKey = getDataKey();
            var getProxy = function(index) {
                return that._nodes[index].proxy
            };
            that._tracker = new _tracker.Tracker({
                widget: that,
                root: that._renderer.root,
                getNode: function(id) {
                    var proxy = getProxy(id);
                    var interactWithGroup = (0, _utils.parseScalar)(that._getOption("interactWithGroup", true));
                    return interactWithGroup && proxy.isLeaf() && proxy.getParent().isActive() ? proxy.getParent() : proxy
                },
                getData: function(e) {
                    var target = e.target;
                    return ("tspan" === target.tagName ? target.parentNode : target)[dataKey]
                },
                getProxy: getProxy,
                click: function(e) {
                    that._eventTrigger("click", e)
                }
            });
            that._handlers.setTrackerData = function(node, element) {
                element.data(dataKey, node._id)
            }
        });
        (0, _helpers.expand)(proto, "_disposeCore", function() {
            this._tracker.dispose()
        })
    },
    /*!************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/tree_map/drilldown.js ***!
      \************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _tree_map = _interopRequireDefault(__webpack_require__( /*! ./tree_map.base */ 109));
        var _helpers = __webpack_require__( /*! ../core/helpers */ 162);
        __webpack_require__( /*! ./api */ 166);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var proto = _tree_map.default.prototype;
        proto._eventsMap.onDrill = {
            name: "drill"
        };
        (0, _helpers.expand)(proto, "_extendProxyType", function(proto) {
            var that = this;
            proto.drillDown = function() {
                that._drillToNode(this._id)
            }
        });
        (0, _helpers.expand)(proto, "_onNodesCreated", function() {
            this._drilldownIndex = -1
        });
        proto._drillToNode = function(index) {
            var that = this;
            var node;
            if (that._drilldownIndex !== index) {
                node = that._nodes[index] || that._root;
                if (node.nodes) {
                    that._drilldownIndex = index;
                    that._topNode = node;
                    that._context.suspend();
                    that._context.change(["MAX_DEPTH", "NODES_RESET"]);
                    that._context.resume();
                    that._eventTrigger("drill", {
                        node: node.proxy
                    })
                }
            }
        };
        proto.resetDrillDown = function() {
            this._drillToNode(-1);
            return this
        };
        proto.drillUp = function() {
            this._drillToNode(this._topNode.parent._id || -1);
            return this
        };
        proto.getCurrentNode = function() {
            return this._topNode.proxy
        }
    },
    /*!********************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/tree_map/plain_data_source.js ***!
      \********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _tree_map = _interopRequireDefault(__webpack_require__( /*! ./tree_map.base */ 109));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var proto = _tree_map.default.prototype;
        proto._optionChangesMap.idField = proto._optionChangesMap.parentField = "NODES_CREATE";
        proto._processDataSourceItems = function(items) {
            var i;
            var struct = {};
            var currentItem;
            var idField = this._getOption("idField", true);
            var parentField = this._getOption("parentField", true);
            var parentId;
            var rootNodes = [];
            var tmpItems;
            var item;
            if (!idField || !parentField || 0 === items.length) {
                return {
                    items: items,
                    isPlain: false
                }
            }
            for (i = 0; i < items.length; i++) {
                currentItem = items[i];
                parentId = currentItem[parentField];
                if (parentId) {
                    struct[parentId] = struct[parentId] || {
                        items: []
                    };
                    tmpItems = struct[parentId].items
                } else {
                    tmpItems = rootNodes
                }
                tmpItems.push(currentItem)
            }
            treeFiller({
                struct: struct,
                idField: idField
            }, rootNodes);
            for (item in struct) {
                struct[item] && rootNodes.push(struct[item])
            }
            return {
                items: rootNodes,
                isPlain: true
            }
        };

        function treeFiller(context, items) {
            var currentItem;
            var i;
            var struct = context.struct;
            var id;
            for (i = 0; i < items.length; i++) {
                currentItem = items[i];
                id = currentItem[context.idField];
                if (struct[id]) {
                    currentItem.items = struct[id].items;
                    struct[id] = null;
                    treeFiller(context, currentItem.items)
                }
            }
        }
    },
    /*!************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/funnel.js ***!
      \************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _funnel = _interopRequireDefault(__webpack_require__( /*! ./funnel/funnel */ 489));
        var _label = __webpack_require__( /*! ./funnel/label */ 993);
        var _export = __webpack_require__( /*! ./core/export */ 108);
        var _title = __webpack_require__( /*! ./core/title */ 121);
        var _legend = __webpack_require__( /*! ./components/legend */ 224);
        var _tracker = __webpack_require__( /*! ./funnel/tracker */ 994);
        var _tooltip = __webpack_require__( /*! ./funnel/tooltip */ 995);
        var _loading_indicator = __webpack_require__( /*! ./core/loading_indicator */ 145);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _funnel.default.addPlugin(_label.plugin);
        _funnel.default.addPlugin(_export.plugin);
        _funnel.default.addPlugin(_title.plugin);
        _funnel.default.addPlugin(_legend.plugin);
        _funnel.default.addPlugin(_tracker.plugin);
        _funnel.default.addPlugin(_tooltip.plugin);
        _funnel.default.addPlugin(_loading_indicator.plugin);
        var _default = _funnel.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/funnel/tiling.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.getAlgorithm = getAlgorithm;
        exports.addAlgorithm = addAlgorithm;
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var algorithms = {};
        var defaultAlgorithm;

        function getAlgorithm(name) {
            return algorithms[(0, _utils.normalizeEnum)(name)] || defaultAlgorithm
        }

        function addAlgorithm(name, callback, setDefault) {
            algorithms[name] = callback;
            if (setDefault) {
                defaultAlgorithm = algorithms[name]
            }
        }
    },
    /*!**************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/funnel/tiling.funnel.js ***!
      \**************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var CENTER = .5;
        var _default = {
            getFigures: function(data) {
                var height = 1 / data.length;
                return data.map(function(value, index, array) {
                    var nextValue = array[index + 1] ? array[index + 1] : array[index];
                    return [CENTER - value / 2, height * index, CENTER + value / 2, height * index, CENTER + nextValue / 2, height * (index + 1), CENTER - nextValue / 2, height * (index + 1)]
                })
            },
            normalizeValues: function(items) {
                var max = items.reduce(function(max, item) {
                    return Math.max(item.value, max)
                }, items[0] && items[0].value || 0);
                return items.map(function(item) {
                    return item.value / max
                })
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/funnel/tiling.pyramid.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var CENTER = .5;
        var LEFTCORNER = 0;
        var RIGHTCORNER = 1;
        var _default = {
            getFigures: function(data, neckWidth, neckHeight) {
                var height = 0;
                var y = 0;
                var x = 0;
                var offsetX = 0;
                var halfNeckWidth = neckWidth / 2;
                var offsetFromCorner = CENTER - halfNeckWidth;
                var funnelHeight = 1 - neckHeight;
                var neckLeftCorner = CENTER - halfNeckWidth;
                var neckRightCorner = CENTER + halfNeckWidth;
                return data.map(function(value) {
                    x = offsetX;
                    y = height;
                    height += value;
                    offsetX = offsetFromCorner * height / funnelHeight;
                    if (y <= funnelHeight && height <= funnelHeight) {
                        return [x, y, RIGHTCORNER - x, y, RIGHTCORNER - offsetX, height, LEFTCORNER + offsetX, height]
                    } else {
                        if (y <= funnelHeight && height > funnelHeight) {
                            return [x, y, RIGHTCORNER - x, y, neckRightCorner, funnelHeight, neckRightCorner, height, neckLeftCorner, height, neckLeftCorner, funnelHeight]
                        } else {
                            return [neckLeftCorner, y, neckRightCorner, y, neckRightCorner, height, neckLeftCorner, height]
                        }
                    }
                })
            },
            normalizeValues: function(items) {
                var sum = items.reduce(function(sum, item) {
                    return sum + item.value
                }, 0);
                return items.map(function(item) {
                    return item.value / sum
                })
            }
        };
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*****************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/funnel/item.js ***!
      \*****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var states = ["normal", "hover", "selection", "selection"];

        function parseStyles(color, style, baseStyle) {
            var border = style.border;
            var baseBorder = baseStyle.border;
            var borderVisible = (0, _type.isDefined)(border.visible) ? border.visible : baseBorder.visible;
            var borderWidth = (0, _type.isDefined)(border.width) ? border.width : baseBorder.width;
            return {
                fill: color,
                hatching: style.hatching,
                stroke: border.color || baseBorder.color,
                "stroke-width": borderVisible ? borderWidth : 0
            }
        }

        function Item(widget, options) {
            var that = this;
            var data = options.data;
            that.code = 0;
            that.widget = widget;
            that.figure = options.figure;
            that.argument = data.argument;
            that.value = data.value;
            that.data = data.dataItem;
            that.percent = options.percent;
            that.id = options.id;
            that.color = options.color;
            that.states = {
                normal: parseStyles(options.color, options.itemOptions, options.itemOptions),
                hover: parseStyles(options.color, options.itemOptions.hoverStyle, options.itemOptions),
                selection: parseStyles(options.color, options.itemOptions.selectionStyle, options.itemOptions)
            }
        }
        Item.prototype = {
            getState: function() {
                return states[this.code]
            },
            getNormalStyle: function() {
                return this.states.normal
            },
            setHover: function() {
                this.hover(true)
            },
            hover: function(state) {
                if (!this.widget._getOption("hoverEnabled", true) || state === this.isHovered()) {
                    return
                }
                this.widget._suspend();
                state && this.widget.clearHover();
                this.setState(1, state);
                this.widget._eventTrigger("hoverChanged", {
                    item: this
                });
                this.widget._resume()
            },
            setState: function(code, state) {
                if (state) {
                    this.code |= code
                } else {
                    this.code &= ~code
                }
                this.widget._applyTilesAppearance()
            },
            select: function(state) {
                var mode = this.widget._getOption("selectionMode", true);
                if ("none" === mode || state === this.isSelected()) {
                    return
                }
                this.widget._suspend();
                if (state && "multiple" !== mode) {
                    this.widget.clearSelection()
                }
                this.setState(2, state);
                this.widget._eventTrigger("selectionChanged", {
                    item: this
                });
                this.widget._resume()
            },
            showTooltip: function(coords) {
                this.widget._showTooltip(this.id, coords)
            },
            getColor: function() {
                return this.color
            },
            isHovered: function() {
                return !!(1 & this.code)
            },
            isSelected: function() {
                return !!(2 & this.code)
            }
        };
        var _default = Item;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!******************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/funnel/label.js ***!
      \******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.plugin = void 0;
        var _label = __webpack_require__( /*! ../series/points/label */ 315);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var _extend = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);

        function _slicedToArray(arr, i) {
            return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest()
        }

        function _nonIterableRest() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _iterableToArrayLimit(arr, i) {
            var _i = arr && ("undefined" !== typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]);
            if (null == _i) {
                return
            }
            var _arr = [];
            var _n = true;
            var _d = false;
            var _s, _e;
            try {
                for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
                    _arr.push(_s.value);
                    if (i && _arr.length === i) {
                        break
                    }
                }
            } catch (err) {
                _d = true;
                _e = err
            } finally {
                try {
                    if (!_n && null != _i.return) {
                        _i.return()
                    }
                } finally {
                    if (_d) {
                        throw _e
                    }
                }
            }
            return _arr
        }

        function _arrayWithHoles(arr) {
            if (Array.isArray(arr)) {
                return arr
            }
        }

        function _toConsumableArray(arr) {
            return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread()
        }

        function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }

        function _unsupportedIterableToArray(o, minLen) {
            if (!o) {
                return
            }
            if ("string" === typeof o) {
                return _arrayLikeToArray(o, minLen)
            }
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if ("Object" === n && o.constructor) {
                n = o.constructor.name
            }
            if ("Map" === n || "Set" === n) {
                return Array.from(o)
            }
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {
                return _arrayLikeToArray(o, minLen)
            }
        }

        function _iterableToArray(iter) {
            if ("undefined" !== typeof Symbol && null != iter[Symbol.iterator] || null != iter["@@iterator"]) {
                return Array.from(iter)
            }
        }

        function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) {
                return _arrayLikeToArray(arr)
            }
        }

        function _arrayLikeToArray(arr, len) {
            if (null == len || len > arr.length) {
                len = arr.length
            }
            for (var i = 0, arr2 = new Array(len); i < len; i++) {
                arr2[i] = arr[i]
            }
            return arr2
        }
        var OUTSIDE_POSITION = "outside";
        var INSIDE_POSITION = "inside";
        var OUTSIDE_LABEL_INDENT = 5;
        var COLUMNS_LABEL_INDENT = 20;
        var CONNECTOR_INDENT = 4;
        var PREVENT_EMPTY_PIXEL_OFFSET = 1;

        function getLabelIndent(pos) {
            pos = (0, _utils.normalizeEnum)(pos);
            if (pos === OUTSIDE_POSITION) {
                return OUTSIDE_LABEL_INDENT
            } else {
                if (pos === INSIDE_POSITION) {
                    return 0
                }
            }
            return COLUMNS_LABEL_INDENT
        }

        function isOutsidePosition(pos) {
            pos = (0, _utils.normalizeEnum)(pos);
            return pos === OUTSIDE_POSITION || pos !== INSIDE_POSITION
        }

        function correctYForInverted(y, bBox, inverted) {
            return inverted ? y - bBox.height : y
        }

        function getOutsideRightLabelPosition(coords, bBox, options, inverted) {
            return {
                x: coords[2] + options.horizontalOffset + OUTSIDE_LABEL_INDENT,
                y: correctYForInverted(coords[3] + options.verticalOffset, bBox, inverted)
            }
        }

        function getOutsideLeftLabelPosition(coords, bBox, options, inverted) {
            return {
                x: coords[0] - bBox.width - options.horizontalOffset - OUTSIDE_LABEL_INDENT,
                y: correctYForInverted(coords[1] + options.verticalOffset, bBox, inverted)
            }
        }

        function getInsideLabelPosition(coords, bBox, options) {
            var width = coords[2] - coords[0];
            var height = coords[7] - coords[1];
            return {
                x: coords[0] + width / 2 + options.horizontalOffset - bBox.width / 2,
                y: coords[1] + options.verticalOffset + height / 2 - bBox.height / 2
            }
        }

        function getColumnLabelRightPosition(labelRect, rect, textAlignment) {
            return function(coords, bBox, options, inverted) {
                return {
                    x: "left" === textAlignment ? rect[2] + options.horizontalOffset + COLUMNS_LABEL_INDENT : labelRect[2] - bBox.width,
                    y: correctYForInverted(coords[3] + options.verticalOffset, bBox, inverted)
                }
            }
        }

        function getColumnLabelLeftPosition(labelRect, rect, textAlignment) {
            return function(coords, bBox, options, inverted) {
                return {
                    x: "left" === textAlignment ? labelRect[0] : rect[0] - bBox.width - options.horizontalOffset - COLUMNS_LABEL_INDENT,
                    y: correctYForInverted(coords[3] + options.verticalOffset, bBox, inverted)
                }
            }
        }

        function getConnectorStrategy(options, inverted) {
            var isLeftPos = "left" === options.horizontalAlignment;
            var connectorIndent = isLeftPos ? CONNECTOR_INDENT : -CONNECTOR_INDENT;
            var verticalCorrection = inverted ? -PREVENT_EMPTY_PIXEL_OFFSET : 0;

            function getFigureCenter(figure) {
                return isLeftPos ? [figure[0] + PREVENT_EMPTY_PIXEL_OFFSET, figure[1] + verticalCorrection] : [figure[2] - PREVENT_EMPTY_PIXEL_OFFSET, figure[3] + verticalCorrection]
            }
            return {
                isLabelInside: function() {
                    return !isOutsidePosition(options.position)
                },
                getFigureCenter: getFigureCenter,
                prepareLabelPoints: function(bBox) {
                    var x = bBox.x + connectorIndent;
                    var y = bBox.y;
                    var x1 = x + bBox.width;
                    return _toConsumableArray(Array(bBox.height + 1)).map(function(_, i) {
                        return [x, y + i]
                    }).concat(_toConsumableArray(Array(bBox.height + 1)).map(function(_, i) {
                        return [x1, y + i]
                    }))
                },
                isHorizontal: function() {
                    return true
                },
                findFigurePoint: function(figure) {
                    return getFigureCenter(figure)
                },
                adjustPoints: function(points) {
                    return points.map(Math.round)
                }
            }
        }

        function getLabelOptions(labelOptions, defaultColor, defaultTextAlignment) {
            var opt = labelOptions || {};
            var labelFont = (0, _extend.extend)({}, opt.font) || {};
            var labelBorder = opt.border || {};
            var labelConnector = opt.connector || {};
            var backgroundAttr = {
                fill: opt.backgroundColor || defaultColor,
                "stroke-width": labelBorder.visible ? labelBorder.width || 0 : 0,
                stroke: labelBorder.visible && labelBorder.width ? labelBorder.color : "none",
                dashStyle: labelBorder.dashStyle
            };
            var connectorAttr = {
                stroke: labelConnector.visible && labelConnector.width ? labelConnector.color || defaultColor : "none",
                "stroke-width": labelConnector.visible ? labelConnector.width || 0 : 0,
                opacity: labelConnector.opacity
            };
            labelFont.color = "none" === opt.backgroundColor && "#ffffff" === (0, _utils.normalizeEnum)(labelFont.color) && "inside" !== opt.position ? defaultColor : labelFont.color;
            return {
                format: opt.format,
                textAlignment: opt.textAlignment || (isOutsidePosition(opt.position) ? defaultTextAlignment : "center"),
                customizeText: opt.customizeText,
                attributes: {
                    font: labelFont
                },
                visible: 0 !== labelFont.size ? opt.visible : false,
                showForZeroValues: opt.showForZeroValues,
                horizontalOffset: opt.horizontalOffset,
                verticalOffset: opt.verticalOffset,
                background: backgroundAttr,
                connector: connectorAttr,
                wordWrap: labelOptions.wordWrap,
                textOverflow: labelOptions.textOverflow
            }
        }

        function correctLabelPosition(pos, bBox, rect) {
            if (pos.x < rect[0]) {
                pos.x = rect[0]
            }
            if (pos.x + bBox.width > rect[2]) {
                pos.x = rect[2] - bBox.width
            }
            if (pos.y < rect[1]) {
                pos.y = rect[1]
            }
            if (pos.y + bBox.height > rect[3]) {
                pos.y = rect[3] - bBox.height
            }
            return pos
        }

        function removeEmptySpace(labels, requiredSpace, startPoint) {
            labels.reduce(function(requiredSpace, label, index, labels) {
                var prevLabel = labels[index + 1];
                if (requiredSpace > 0) {
                    var bBox = label.getBoundingRect();
                    var point = prevLabel ? prevLabel.getBoundingRect().y + prevLabel.getBoundingRect().height : startPoint;
                    var emptySpace = bBox.y - point;
                    var shift = Math.min(emptySpace, requiredSpace);
                    labels.slice(0, index + 1).forEach(function(label) {
                        var bBox = label.getBoundingRect();
                        label.shift(bBox.x, bBox.y - shift)
                    });
                    requiredSpace -= shift
                }
                return requiredSpace
            }, requiredSpace)
        }
        var plugin = {
            name: "lables",
            init: _common.noop,
            dispose: _common.noop,
            extenders: {
                _initCore: function() {
                    this._labelsGroup = this._renderer.g().attr({
                        "class": this._rootClassPrefix + "-labels"
                    }).append(this._renderer.root);
                    this._labels = []
                },
                _applySize: function() {
                    var options = this._getOption("label");
                    var adaptiveLayout = this._getOption("adaptiveLayout");
                    var rect = this._rect;
                    var labelWidth = 0;
                    var width = rect[2] - rect[0];
                    this._labelRect = rect.slice();
                    if (!this._labels.length || !isOutsidePosition(options.position)) {
                        if ((0, _utils.normalizeEnum)("none" !== this._getOption("resolveLabelOverlapping", true))) {
                            this._labels.forEach(function(l) {
                                return !l.isVisible() && l.draw(true)
                            })
                        }
                        return
                    }
                    var groupWidth = this._labels.map(function(label) {
                        label.resetEllipsis();
                        return label.getBoundingRect().width
                    }).reduce(function(max, width) {
                        return Math.max(max, width)
                    }, 0);
                    labelWidth = groupWidth + options.horizontalOffset + getLabelIndent(options.position);
                    if (!adaptiveLayout.keepLabels && width - labelWidth < adaptiveLayout.width) {
                        this._labels.forEach(function(label) {
                            label.draw(false)
                        });
                        return
                    } else {
                        if (width - labelWidth < adaptiveLayout.width) {
                            labelWidth = width - adaptiveLayout.width;
                            labelWidth = labelWidth > 0 ? labelWidth : 0
                        }
                        this._labels.forEach(function(label) {
                            label.draw(true)
                        })
                    }
                    if ("left" === options.horizontalAlignment) {
                        rect[0] += labelWidth
                    } else {
                        rect[2] -= labelWidth
                    }
                },
                _buildNodes: function() {
                    this._createLabels()
                },
                _change_TILING: function() {
                    var that = this;
                    var options = that._getOption("label");
                    var getCoords = getInsideLabelPosition;
                    var inverted = that._getOption("inverted", true);
                    var textAlignment;
                    if (isOutsidePosition(options.position)) {
                        if ((0, _utils.normalizeEnum)(options.position) === OUTSIDE_POSITION) {
                            getCoords = "left" === options.horizontalAlignment ? getOutsideLeftLabelPosition : getOutsideRightLabelPosition
                        } else {
                            textAlignment = this._defaultLabelTextAlignment();
                            getCoords = "left" === options.horizontalAlignment ? getColumnLabelLeftPosition(this._labelRect, this._rect, textAlignment) : getColumnLabelRightPosition(this._labelRect, this._rect, textAlignment)
                        }
                    }
                    that._labels.forEach(function(label, index) {
                        var item = that._items[index];
                        var borderWidth = item.getNormalStyle()["stroke-width"];
                        var halfBorderWidth = inverted ? borderWidth / 2 : -borderWidth / 2;
                        var coords = halfBorderWidth ? item.coords.map(function(coord, index) {
                            if (1 === index || 3 === index) {
                                return coord - halfBorderWidth
                            } else {
                                if (2 === index) {
                                    return coord - borderWidth
                                } else {
                                    if (0 === index) {
                                        return coord + borderWidth
                                    }
                                }
                            }
                            return coord
                        }) : item.coords;
                        if (!options.showForZeroValues && 0 === item.value) {
                            label.draw(false);
                            return
                        }
                        if (isOutsidePosition(options.position)) {
                            that._correctLabelWidth(label, item.coords, options)
                        }
                        var bBox = label.getBoundingRect();
                        var pos = correctLabelPosition(getCoords(coords, bBox, options, inverted), bBox, that._labelRect);
                        label.setFigureToDrawConnector(coords);
                        label.shift(pos.x, pos.y)
                    });
                    that._resolveLabelOverlapping()
                }
            },
            members: {
                _resolveLabelOverlapping: function() {
                    var that = this;
                    var resolveLabelOverlapping = (0, _utils.normalizeEnum)(that._getOption("resolveLabelOverlapping", true));
                    var labels = this._getOption("inverted", true) ? that._labels.slice().reverse() : that._labels;
                    if ("hide" === resolveLabelOverlapping) {
                        labels.reduce(function(height, label) {
                            if (label.getBoundingRect().y < height) {
                                label.hide()
                            } else {
                                height = label.getBoundingRect().y + label.getBoundingRect().height
                            }
                            return height
                        }, 0)
                    } else {
                        if ("shift" === resolveLabelOverlapping) {
                            var maxHeight = this._labelRect[3];
                            labels.reduce(function(_ref, label, index, labels) {
                                var _ref2 = _slicedToArray(_ref, 2),
                                    height = _ref2[0],
                                    emptySpace = _ref2[1];
                                var bBox = label.getBoundingRect();
                                var y = bBox.y;
                                if (bBox.y < height) {
                                    label.shift(bBox.x, height);
                                    y = height
                                }
                                if (y - height > 0) {
                                    emptySpace += y - height
                                }
                                if (y + bBox.height > maxHeight) {
                                    if (emptySpace && emptySpace > y + bBox.height - maxHeight) {
                                        removeEmptySpace(labels.slice(0, index).reverse(), y + bBox.height - maxHeight, that._labelRect[1]);
                                        emptySpace -= y + bBox.height - maxHeight;
                                        label.shift(bBox.x, y - (y + bBox.height - maxHeight));
                                        height = y - (y + bBox.height - maxHeight) + bBox.height
                                    } else {
                                        label.hide()
                                    }
                                } else {
                                    height = y + bBox.height
                                }
                                return [height, emptySpace]
                            }, [this._labelRect[1], 0])
                        }
                    }
                },
                _defaultLabelTextAlignment: function() {
                    return this._getOption("rtlEnabled", true) ? "right" : "left"
                },
                _correctLabelWidth: function(label, item, options) {
                    var isLeftPos = "left" === options.horizontalAlignment;
                    var minX = isLeftPos ? this._labelRect[0] : item[2];
                    var maxX = isLeftPos ? item[0] : this._labelRect[2];
                    var maxWidth = maxX - minX;
                    if (label.getBoundingRect().width > maxWidth) {
                        label.fit(maxWidth)
                    }
                },
                _createLabels: function() {
                    var that = this;
                    var labelOptions = that._getOption("label");
                    var connectorStrategy = getConnectorStrategy(labelOptions, that._getOption("inverted", true));
                    this._labelsGroup.clear();
                    if (!labelOptions.visible) {
                        return
                    }
                    this._labels = that._items.map(function(item) {
                        var label = new _label.Label({
                            renderer: that._renderer,
                            labelsGroup: that._labelsGroup,
                            strategy: connectorStrategy
                        });
                        label.setOptions(getLabelOptions(labelOptions, item.color, that._defaultLabelTextAlignment()));
                        label.setData({
                            item: item,
                            value: item.value,
                            percent: item.percent
                        });
                        label.draw(true);
                        return label
                    });
                    if (this._labels.length && isOutsidePosition(labelOptions.position)) {
                        this._requestChange(["LAYOUT"])
                    }
                }
            },
            customize: function(constructor) {
                constructor.prototype._proxyData.push(function(x, y) {
                    var that = this;
                    var data;
                    that._labels.forEach(function(label, index) {
                        var rect = label.getBoundingRect();
                        if (x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height) {
                            var pos = isOutsidePosition(that._getOption("label").position) ? "outside" : "inside";
                            data = {
                                id: index,
                                type: pos + "-label"
                            };
                            return true
                        }
                    });
                    return data
                });
                ["label", "resolveLabelOverlapping"].forEach(function(optionName) {
                    constructor.addChange({
                        code: optionName.toUpperCase(),
                        handler: function() {
                            this._createLabels();
                            this._requestChange(["LAYOUT"])
                        },
                        isThemeDependent: true,
                        isOptionChange: true,
                        option: optionName
                    })
                })
            },
            fontFields: ["label.font"]
        };
        exports.plugin = plugin
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/funnel/tracker.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.plugin = void 0;
        var _funnel = _interopRequireDefault(__webpack_require__( /*! ./funnel */ 489));
        var _tracker = __webpack_require__( /*! ../components/tracker */ 321);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var DATA_KEY_BASE = "__funnel_data_";
        var dataKeyModifier = 0;
        var proto = _funnel.default.prototype;
        proto._eventsMap.onItemClick = {
            name: "itemClick"
        };
        proto._eventsMap.onLegendClick = {
            name: "legendClick"
        };
        var getDataKey = function() {
            return DATA_KEY_BASE + dataKeyModifier++
        };
        var plugin = {
            name: "tracker",
            init: function() {
                var that = this;
                var dataKey = getDataKey();
                var getProxyData = function(e) {
                    var rootOffset = that._renderer.getRootOffset();
                    var x = Math.floor(e.pageX - rootOffset.left);
                    var y = Math.floor(e.pageY - rootOffset.top);
                    return that._hitTestTargets(x, y)
                };
                that._tracker = new _tracker.Tracker({
                    widget: that,
                    root: that._renderer.root,
                    getData: function(e, tooltipData) {
                        var target = e.target;
                        var data = target[dataKey];
                        if ((0, _type.isDefined)(data)) {
                            return data
                        }
                        var proxyData = getProxyData(e);
                        if (tooltipData && proxyData && "inside-label" !== proxyData.type) {
                            return
                        }
                        return proxyData && proxyData.id
                    },
                    getNode: function(index) {
                        return that._items[index]
                    },
                    click: function(e) {
                        var proxyData = getProxyData(e.event);
                        var dataType = proxyData && proxyData.type;
                        var event = "legend" === dataType ? "legendClick" : "itemClick";
                        that._eventTrigger(event, {
                            item: e.node,
                            event: e.event
                        })
                    }
                });
                this._dataKey = dataKey
            },
            dispose: function() {
                this._tracker.dispose()
            },
            extenders: {
                _change_TILING: function() {
                    var dataKey = this._dataKey;
                    this._items.forEach(function(item, index) {
                        item.element.data(dataKey, index)
                    })
                }
            }
        };
        exports.plugin = plugin
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/funnel/tooltip.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.plugin = void 0;
        var _common = __webpack_require__( /*! ../../core/utils/common */ 4);
        var _tooltip = __webpack_require__( /*! ../core/tooltip */ 123);

        function getCoords(coords, figureCoords, renderer) {
            var offset = renderer.getRootOffset();
            return coords || figureCoords && [(figureCoords[0] + figureCoords[2]) / 2 + offset.left, (figureCoords[1] + figureCoords[5]) / 2 + offset.top] || [-1e3, -1e3]
        }
        var plugin = {
            name: "funnel-tooltip",
            init: _common.noop,
            dispose: _common.noop,
            extenders: {
                _buildNodes: function() {
                    this.hideTooltip()
                },
                _change_TILING: function() {
                    if (this._tooltipIndex >= 0) {
                        this._moveTooltip(this._items[this._tooltipIndex])
                    }
                }
            },
            members: {
                hideTooltip: function() {
                    if (this._tooltipIndex >= 0) {
                        this._tooltipIndex = -1;
                        this._tooltip.hide()
                    }
                },
                _moveTooltip: function(item, coords) {
                    var xy = getCoords(coords, item.coords, this._renderer);
                    this._tooltip.move(xy[0], xy[1], 0)
                },
                _showTooltip: function(index, coords) {
                    var that = this;
                    var tooltip = that._tooltip;
                    var item = that._items[index];
                    if (that._tooltipIndex === index) {
                        that._moveTooltip(item, coords);
                        return
                    }
                    var callback = function(result) {
                        if (void 0 === result) {
                            return
                        }
                        if (!result) {
                            tooltip.hide()
                        }
                        that._tooltipIndex = result ? index : -1
                    };
                    var xy = getCoords(coords, item.coords, this._renderer);
                    callback(tooltip.show({
                        value: item.value,
                        valueText: tooltip.formatValue(item.value),
                        percentText: tooltip.formatValue(item.percent, "percent"),
                        percent: item.percent,
                        item: item
                    }, {
                        x: xy[0],
                        y: xy[1],
                        offset: 0
                    }, {
                        item: item
                    }, void 0, callback))
                }
            },
            customize: function(constructor) {
                constructor.addPlugin(_tooltip.plugin)
            }
        };
        exports.plugin = plugin
    },
    /*!************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/sankey.js ***!
      \************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _sankey = _interopRequireDefault(__webpack_require__( /*! ./sankey/sankey */ 490));
        var _tooltip = __webpack_require__( /*! ./sankey/tooltip */ 1001);
        var _export = __webpack_require__( /*! ./core/export */ 108);
        var _title = __webpack_require__( /*! ./core/title */ 121);
        var _tracker = __webpack_require__( /*! ./sankey/tracker */ 1002);
        var _tooltip2 = __webpack_require__( /*! ./core/tooltip */ 123);
        var _loading_indicator = __webpack_require__( /*! ./core/loading_indicator */ 145);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _sankey.default.addPlugin(_export.plugin);
        _sankey.default.addPlugin(_title.plugin);
        _sankey.default.addPlugin(_tracker.plugin);
        _sankey.default.addPlugin(_loading_indicator.plugin);
        _sankey.default.addPlugin(_tooltip2.plugin);
        (0, _tooltip.setTooltipCustomOptions)(_sankey.default);
        var _default = _sankey.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/sankey/node_item.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var _utils = __webpack_require__( /*! ../core/utils */ 14);
        var states = ["normal", "hover"];

        function _compileAttrs(color, itemOptions, itemBaseOptions) {
            var border = itemOptions.border;
            var baseBorder = itemBaseOptions.border;
            var borderVisible = (0, _type.isDefined)(border.visible) ? border.visible : baseBorder.visible;
            var borderWidth = (0, _type.isDefined)(border.width) ? border.width : baseBorder.width;
            var borderOpacity = (0, _type.isDefined)(border.opacity) ? border.opacity : (0, _type.isDefined)(baseBorder.opacity) ? baseBorder.opacity : 1;
            var opacity = (0, _type.isDefined)(itemOptions.opacity) ? itemOptions.opacity : (0, _type.isDefined)(itemBaseOptions.opacity) ? itemBaseOptions.opacity : 1;
            return {
                fill: itemOptions.color || color,
                "stroke-width": borderVisible ? borderWidth : 0,
                stroke: itemOptions.border.color || itemBaseOptions.border.color,
                "stroke-opacity": borderOpacity,
                opacity: opacity,
                hatching: itemOptions.hatching
            }
        }

        function compileLabelAttrs(labelOptions, filter, node) {
            var _patchFontOptions = _utils.patchFontOptions;
            if (labelOptions.useNodeColors) {
                labelOptions.font.color = node.color
            }
            var borderVisible = (0, _type.isDefined)(labelOptions.border.visible) ? labelOptions.border.visible : false;
            var borderWidth = (0, _type.isDefined)(labelOptions.border.width) ? labelOptions.border.width : 0;
            var borderColor = (0, _type.isDefined)(labelOptions.border.color) ? labelOptions.border.color : labelOptions.font.color;
            var borderOpacity = (0, _type.isDefined)(labelOptions.border.opacity) ? labelOptions.border.opacity : 1;
            var attr = {
                filter: filter
            };
            if (borderVisible && borderWidth) {
                attr.stroke = borderColor;
                attr["stroke-width"] = borderVisible ? borderWidth : 0;
                attr["stroke-opacity"] = borderOpacity
            }
            return {
                attr: attr,
                css: _patchFontOptions(labelOptions.font)
            }
        }

        function Node(widget, params) {
            var that = this;
            var widgetOffset = widget._renderer.getRootOffset();
            that.code = 0;
            that.widget = widget;
            that.color = params.color;
            that.options = params.options;
            that.rect = params.rect;
            that.label = that.title = params.rect._name;
            that.coords = {
                x: params.rect.x + params.rect.width / 2 + widgetOffset.left,
                y: params.rect.y + params.rect.height / 2 + widgetOffset.top
            };
            that.id = params.id;
            that.linksIn = params.linksIn;
            that.linksOut = params.linksOut;
            this.states = {
                normal: _compileAttrs(this.color, that.options, that.options),
                hover: _compileAttrs(this.color, that.options.hoverStyle, that.options)
            }
        }
        Node.prototype = {
            compileAttrs: function() {
                return _compileAttrs(this.color, this.options)
            },
            getState: function() {
                return states[this.code]
            },
            isHovered: function() {
                return !!(1 & this.code)
            },
            setState: function(code, state) {
                var _this = this;
                if (state) {
                    this.code |= code
                } else {
                    this.code &= ~code
                }
                if (state) {
                    this.linksIn.concat(this.linksOut).forEach(function(adjacentLink) {
                        _this.widget._links[adjacentLink.index].setAdjacentNodeHover(true)
                    })
                } else {
                    this.widget._links.forEach(function(link) {
                        link.isAdjacentNodeHovered() && link.adjacentNodeHover(false)
                    });
                    this.hideTooltip()
                }
                this.widget._applyNodesAppearance();
                this.widget._applyLinksAppearance()
            },
            hover: function(state) {
                if (!this.widget._getOption("hoverEnabled", true) || state === this.isHovered()) {
                    return
                }
                this.widget._suspend();
                state && this.widget.clearHover();
                this.setState(1, state);
                this.widget._eventTrigger("nodeHoverChanged", {
                    target: this
                });
                this.widget._resume()
            },
            setHover: function() {
                this.hover(true)
            },
            showTooltip: function(coords) {
                this.widget._getOption("hoverEnabled", true) && this.widget._tooltip && this.widget._tooltip.show({
                    type: "node",
                    info: {
                        label: this.label,
                        title: this.label,
                        weightIn: this.linksIn.reduce(function(previousValue, currentValue) {
                            return previousValue + currentValue.weight
                        }, 0),
                        weightOut: this.linksOut.reduce(function(previousValue, currentValue) {
                            return previousValue + currentValue.weight
                        }, 0)
                    }
                }, "undefined" !== typeof coords ? {
                    x: coords[0],
                    y: coords[1]
                } : this.coords)
            },
            hideTooltip: function() {
                this.widget._tooltip && this.widget._tooltip.hide()
            },
            getLabelAttributes: function(labelSettings, filter) {
                return compileLabelAttrs(labelSettings, filter, this)
            }
        };
        var _default = Node;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!**********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/sankey/link_item.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _constants = __webpack_require__( /*! ./constants */ 491);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var states = ["normal", "adjacentNodeHover", "hover"];

        function compileAttrs(color, itemOptions, itemBaseOptions, gradient) {
            var border = itemOptions.border;
            var baseBorder = itemBaseOptions.border;
            var borderVisible = (0, _type.isDefined)(border.visible) ? border.visible : baseBorder.visible;
            var borderWidth = (0, _type.isDefined)(border.width) ? border.width : baseBorder.width;
            var borderOpacity = (0, _type.isDefined)(border.opacity) ? border.opacity : (0, _type.isDefined)(baseBorder.opacity) ? baseBorder.opacity : 1;
            var opacity = (0, _type.isDefined)(itemOptions.opacity) ? itemOptions.opacity : (0, _type.isDefined)(itemBaseOptions.opacity) ? itemBaseOptions.opacity : 1;
            var fill = itemOptions.color || color;
            if (itemBaseOptions.colorMode === _constants.COLOR_MODE_TARGET || itemBaseOptions.colorMode === _constants.COLOR_MODE_SOURCE) {
                fill = color
            } else {
                if (itemBaseOptions.colorMode === _constants.COLOR_MODE_GRADIENT && gradient && (0, _type.isDefined)(gradient.id)) {
                    fill = gradient.id
                }
            }
            return {
                fill: fill,
                "stroke-width": borderVisible ? borderWidth : 0,
                stroke: itemOptions.border.color || itemBaseOptions.border.color,
                "stroke-opacity": borderOpacity,
                opacity: opacity,
                hatching: itemOptions.hatching
            }
        }

        function Link(widget, params) {
            var that = this;
            var widgetOffset = widget._renderer.getRootOffset();
            that.code = 0;
            that.widget = widget;
            that.color = params.color;
            that.connection = params.connection;
            that.d = params.d;
            that.options = params.options;
            that.boundingRect = params.boundingRect, that.coords = {
                x: params.boundingRect.x + params.boundingRect.width / 2 + widgetOffset.left,
                y: params.boundingRect.y + params.boundingRect.height / 2 + widgetOffset.top
            };
            that.states = {
                normal: compileAttrs(that.color, that.options, that.options, params.gradient),
                adjacentNodeHover: compileAttrs(that.color, {
                    opacity: 0,
                    border: {}
                }, that.options, params.gradient),
                hover: compileAttrs(that.color, {
                    opacity: 0,
                    border: {}
                }, that.options, params.gradient)
            };
            that.overlayStates = {
                normal: compileAttrs(that.color, {
                    opacity: 0,
                    border: {}
                }, that.options),
                adjacentNodeHover: compileAttrs(that.color, that.options.hoverStyle, that.options),
                hover: compileAttrs(that.color, that.options.hoverStyle, that.options)
            }
        }
        Link.prototype = {
            getState: function() {
                return states[this.code]
            },
            isHovered: function() {
                return 2 === this.code
            },
            isAdjacentNodeHovered: function() {
                return 1 === this.code
            },
            setState: function(code, state) {
                if (state) {
                    this.code = code
                } else {
                    this.code = 0;
                    this.hideTooltip()
                }
                this.widget._applyLinksAppearance()
            },
            setHover: function() {
                this.hover(true)
            },
            hover: function(state) {
                if (!this.widget._getOption("hoverEnabled", true) || state === this.isHovered()) {
                    return
                }
                this.widget._suspend();
                state && this.widget.clearHover();
                this.setState(2, state);
                this.widget._eventTrigger("linkHoverChanged", {
                    target: this
                });
                this.widget._resume()
            },
            adjacentNodeHover: function(state) {
                if (!this.widget._getOption("hoverEnabled", true) || state === this.isAdjacentNodeHovered()) {
                    return
                }
                this.widget._suspend();
                this.setState(1, state);
                this.widget._resume()
            },
            setAdjacentNodeHover: function() {
                this.adjacentNodeHover(true)
            },
            showTooltip: function(coords) {
                this.widget._getOption("hoverEnabled", true) && this.widget._tooltip && this.widget._tooltip.show({
                    type: "link",
                    info: {
                        source: this.connection.source,
                        target: this.connection.target,
                        weight: this.connection.weight
                    }
                }, "undefined" !== typeof coords ? {
                    x: coords[0],
                    y: coords[1]
                } : this.coords)
            },
            hideTooltip: function() {
                this.widget._tooltip && this.widget._tooltip.hide()
            }
        };
        var _default = Link;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!*******************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/sankey/layout.js ***!
      \*******************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _graph = _interopRequireDefault(__webpack_require__( /*! ./graph */ 492));
        var _data_validator = _interopRequireDefault(__webpack_require__( /*! ./data_validator */ 1e3));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var _SPLINE_TENSION = .3;
        var _ALIGNMENT_CENTER = "center";
        var _ALIGNMENT_BOTTOM = "bottom";
        var _ALIGNMENT_DEFAULT = _ALIGNMENT_CENTER;
        var layout = {
            _weightPerPixel: null,
            _getCascadeIdx: function(nodeTitle, cascadesConfig) {
                var nodeInfo = cascadesConfig.filter(function(c) {
                    return c.name === nodeTitle
                })[0];
                if (nodeInfo.outgoing.length > 0) {
                    return nodeInfo.lp
                } else {
                    return _graph.default.routines.maxOfArray(cascadesConfig.map(function(c) {
                        return c.lp
                    }))
                }
            },
            _getInWeightForNode: function(nodeTitle, links) {
                var w = 0;
                links.forEach(function(link) {
                    if (link[1] === nodeTitle) {
                        w += link[2]
                    }
                });
                return w
            },
            _getOutWeightForNode: function(nodeTitle, links) {
                var w = 0;
                links.forEach(function(link) {
                    if (link[0] === nodeTitle) {
                        w += link[2]
                    }
                });
                return w
            },
            _computeCascades: function(links) {
                var _this = this;
                var cascadesConfig = _graph.default.struct.computeLongestPaths(links);
                var maxCascade = _graph.default.routines.maxOfArray(cascadesConfig.map(function(c) {
                    return c.lp
                }));
                var cascades = [];
                for (var i = 0; i < maxCascade + 1; i++) {
                    cascades.push({})
                }
                links.forEach(function(link) {
                    var cascade = cascades[_this._getCascadeIdx(link[0], cascadesConfig)];
                    if (!cascade[link[0]]) {
                        cascade[link[0]] = {
                            nodeTitle: link[0]
                        }
                    }
                    cascade = cascades[_this._getCascadeIdx(link[1], cascadesConfig)];
                    if (!cascade[link[1]]) {
                        cascade[link[1]] = {
                            nodeTitle: link[1]
                        }
                    }
                });
                cascades.forEach(function(cascade) {
                    Object.keys(cascade).forEach(function(nodeTitle) {
                        var node = cascade[nodeTitle];
                        node.inWeight = _this._getInWeightForNode(node.nodeTitle, links);
                        node.outWeight = _this._getOutWeightForNode(node.nodeTitle, links);
                        node.maxWeight = Math.max(node.inWeight, node.outWeight)
                    })
                });
                return cascades
            },
            _getWeightForCascade: function(cascades, cascadeIdx) {
                var wMax = 0;
                var cascade = cascades[cascadeIdx];
                Object.keys(cascade).forEach(function(nodeTitle) {
                    wMax += Math.max(cascade[nodeTitle].inWeight, cascade[nodeTitle].outWeight)
                });
                return wMax
            },
            _getMaxWeightThroughCascades: function(cascades) {
                var max = [];
                cascades.forEach(function(cascade) {
                    var mW = 0;
                    Object.keys(cascade).forEach(function(nodeTitle) {
                        var node = cascade[nodeTitle];
                        mW += Math.max(node.inWeight, node.outWeight)
                    });
                    max.push(mW)
                });
                return _graph.default.routines.maxOfArray(max)
            },
            _computeNodes: function(cascades, options) {
                var _this2 = this;
                var rects = [];
                var maxWeight = this._getMaxWeightThroughCascades(cascades);
                var maxNodeNum = _graph.default.routines.maxOfArray(cascades.map(function(nodesInCascade) {
                    return Object.keys(nodesInCascade).length
                }));
                var nodePadding = options.nodePadding;
                var heightAvailable = options.height - nodePadding * (maxNodeNum - 1);
                if (heightAvailable < 0) {
                    nodePadding = 0;
                    heightAvailable = options.height - nodePadding * (maxNodeNum - 1)
                }
                this._weightPerPixel = maxWeight / heightAvailable;
                var cascadeIdx = 0;
                cascades.forEach(function(cascade) {
                    var cascadeRects = [];
                    var y = 0;
                    var nodesInCascade = Object.keys(cascade).length;
                    var cascadeHeight = _this2._getWeightForCascade(cascades, cascadeIdx) / _this2._weightPerPixel + nodePadding * (nodesInCascade - 1);
                    var cascadeAlign = _ALIGNMENT_DEFAULT;
                    if (Array.isArray(options.nodeAlign)) {
                        cascadeAlign = cascadeIdx < options.nodeAlign.length ? options.nodeAlign[cascadeIdx] : _ALIGNMENT_DEFAULT
                    } else {
                        cascadeAlign = options.nodeAlign
                    }
                    if (cascadeAlign === _ALIGNMENT_BOTTOM) {
                        y = options.height - cascadeHeight
                    } else {
                        if (cascadeAlign === _ALIGNMENT_CENTER) {
                            y = .5 * (options.height - cascadeHeight)
                        }
                    }
                    y = Math.round(y);
                    Object.keys(cascade).forEach(function(nodeTitle) {
                        cascade[nodeTitle].sort = _this2._sort && Object.prototype.hasOwnProperty.call(_this2._sort, nodeTitle) ? _this2._sort[nodeTitle] : 1
                    });
                    Object.keys(cascade).sort(function(a, b) {
                        return cascade[a].sort - cascade[b].sort
                    }).forEach(function(nodeTitle) {
                        var node = cascade[nodeTitle];
                        var height = Math.floor(heightAvailable * node.maxWeight / maxWeight);
                        var x = Math.round(cascadeIdx * options.width / (cascades.length - 1)) - (0 === cascadeIdx ? 0 : options.nodeWidth);
                        var rect = {};
                        rect._name = nodeTitle;
                        rect.width = options.nodeWidth;
                        rect.height = height;
                        rect.x = x + options.x;
                        rect.y = y + options.y;
                        y += height + nodePadding;
                        cascadeRects.push(rect)
                    });
                    cascadeIdx++;
                    rects.push(cascadeRects)
                });
                return rects
            },
            _findRectByName: function(rects, name) {
                for (var c = 0; c < rects.length; c++) {
                    for (var r = 0; r < rects[c].length; r++) {
                        if (name === rects[c][r]._name) {
                            return rects[c][r]
                        }
                    }
                }
                return null
            },
            _findIndexByName: function(rects, nodeTitle) {
                var index = 0;
                for (var c = 0; c < rects.length; c++) {
                    for (var r = 0; r < rects[c].length; r++) {
                        if (nodeTitle === rects[c][r]._name) {
                            return index
                        }
                        index++
                    }
                }
                return null
            },
            _computeLinks: function(links, rects, cascades) {
                var _this3 = this;
                var yOffsets = {};
                var paths = [];
                var result = [];
                cascades.forEach(function(cascade) {
                    Object.keys(cascade).forEach(function(nodeTitle) {
                        yOffsets[nodeTitle] = {
                            "in": 0,
                            out: 0
                        }
                    })
                });
                rects.forEach(function(rectsOfCascade) {
                    rectsOfCascade.forEach(function(nodeRect) {
                        var nodeTitle = nodeRect._name;
                        var rectFrom = _this3._findRectByName(rects, nodeTitle);
                        var linksFromNode = links.filter(function(link) {
                            return link[0] === nodeTitle
                        });
                        linksFromNode.forEach(function(link) {
                            link.sort = _this3._findIndexByName(rects, link[1])
                        });
                        linksFromNode.sort(function(a, b) {
                            return a.sort - b.sort
                        }).forEach(function(link) {
                            var rectTo = _this3._findRectByName(rects, link[1]);
                            var height = Math.round(link[2] / _this3._weightPerPixel);
                            var yOffsetFrom = yOffsets[link[0]].out;
                            var yOffsetTo = yOffsets[link[1]].in;
                            var heightFrom = yOffsets[link[0]].out + height > rectFrom.height ? rectFrom.height - yOffsets[link[0]].out : height;
                            var heightTo = yOffsets[link[1]].in + height > rectTo.height ? rectTo.height - yOffsets[link[1]].in : height;
                            paths.push({
                                from: {
                                    x: rectFrom.x,
                                    y: rectFrom.y + yOffsetFrom,
                                    width: rectFrom.width,
                                    height: heightFrom,
                                    node: rectFrom,
                                    weight: link[2]
                                },
                                to: {
                                    x: rectTo.x,
                                    y: rectTo.y + yOffsetTo,
                                    width: rectTo.width,
                                    height: heightTo,
                                    node: rectTo
                                }
                            });
                            yOffsets[link[0]].out += height;
                            yOffsets[link[1]].in += height
                        })
                    })
                });
                paths.forEach(function(link) {
                    var path = {
                        d: _this3._spline(link.from, link.to),
                        _boundingRect: {
                            x: link.from.x + link.from.width,
                            y: Math.min(link.from.y, link.to.y),
                            width: link.to.x - (link.from.x + link.from.width),
                            height: Math.max(link.from.x + link.from.height, link.to.y + link.to.height) - Math.min(link.from.y, link.to.y)
                        },
                        _weight: link.from.weight,
                        _from: link.from.node,
                        _to: link.to.node
                    };
                    result.push(path)
                });
                this._fitAllNodesHeight(rects, paths);
                return result
            },
            _fitNodeHeight: function(nodeName, nodeRects, paths) {
                var targetRect = this._findRectByName(nodeRects, nodeName);
                var heightOfLinksSummaryIn = 0;
                var heightOfLinksSummaryOut = 0;
                paths.forEach(function(path) {
                    if (path.from.node._name === nodeName) {
                        heightOfLinksSummaryOut += path.from.height
                    }
                    if (path.to.node._name === nodeName) {
                        heightOfLinksSummaryIn += path.to.height
                    }
                });
                targetRect.height = Math.max(heightOfLinksSummaryIn, heightOfLinksSummaryOut)
            },
            _fitAllNodesHeight: function(nodeRects, paths) {
                for (var c = 0; c < nodeRects.length; c++) {
                    for (var r = 0; r < nodeRects[c].length; r++) {
                        this._fitNodeHeight(nodeRects[c][r]._name, nodeRects, paths)
                    }
                }
            },
            _spline: function(rectLeft, rectRight) {
                var p_UpLeft = {
                    x: rectLeft.x + rectLeft.width,
                    y: rectLeft.y
                };
                var p_DownLeft = {
                    x: rectLeft.x + rectLeft.width,
                    y: rectLeft.y + rectLeft.height
                };
                var p_UpRight = {
                    x: rectRight.x,
                    y: rectRight.y
                };
                var p_DownRight = {
                    x: rectRight.x,
                    y: rectRight.y + rectRight.height
                };
                var curve_width = _SPLINE_TENSION * (p_UpRight.x - p_UpLeft.x);
                var result = "M ".concat(p_UpLeft.x, " ").concat(p_UpLeft.y, " C ").concat(p_UpLeft.x + curve_width, " ").concat(p_UpLeft.y, " ").concat(p_UpRight.x - curve_width, " ").concat(p_UpRight.y, " ").concat(p_UpRight.x, " ").concat(p_UpRight.y, " L ").concat(p_DownRight.x, " ").concat(p_DownRight.y, " C ").concat(p_DownRight.x - curve_width, " ").concat(p_DownRight.y, " ").concat(p_DownLeft.x + curve_width, " ").concat(p_DownLeft.y, " ").concat(p_DownLeft.x, " ").concat(p_DownLeft.y, " Z");
                return result
            },
            computeLayout: function(linksData, sortData, options, incidentOccurred) {
                this._sort = sortData;
                var result = {};
                var validateResult = _data_validator.default.validate(linksData, incidentOccurred);
                if (!validateResult) {
                    result.cascades = this._computeCascades(linksData);
                    result.nodes = this._computeNodes(result.cascades, {
                        width: options.availableRect.width,
                        height: options.availableRect.height,
                        x: options.availableRect.x,
                        y: options.availableRect.y,
                        nodePadding: options.nodePadding,
                        nodeWidth: options.nodeWidth,
                        nodeAlign: options.nodeAlign
                    });
                    result.links = this._computeLinks(linksData, result.nodes, result.cascades)
                } else {
                    result.error = validateResult
                }
                return result
            },
            overlap: function(box1, box2) {
                return !(box2.x > box1.x + box1.width || box2.x + box2.width < box1.x || box2.y >= box1.y + box1.height || box2.y + box2.height <= box1.y)
            }
        };
        var _default = layout;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/sankey/data_validator.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _graph = _interopRequireDefault(__webpack_require__( /*! ./graph */ 492));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var validator = {
            validate: function(data, incidentOccurred) {
                var result = null;
                if (this._hasCycle(data)) {
                    result = "E2006";
                    incidentOccurred("E2006")
                }
                return result
            },
            _hasCycle: function(data) {
                return _graph.default.struct.hasCycle(data)
            }
        };
        var _default = validator;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/sankey/tooltip.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.setTooltipCustomOptions = setTooltipCustomOptions;
        var _extend2 = __webpack_require__( /*! ../../core/utils/extend */ 0);
        var _type = __webpack_require__( /*! ../../core/utils/type */ 1);
        var defaultCustomizeLinkTooltip = function(info) {
            return {
                html: "<strong>".concat(info.source, " > ").concat(info.target, "</strong><br/>Weight: ").concat(info.weight)
            }
        };
        var defaultCustomizeNodeTooltip = function(info) {
            return {
                html: "<strong>".concat(info.label, "</strong><br/>Incoming weight: ").concat(info.weightIn, "<br/>Outgoing weight: ").concat(info.weightOut)
            }
        };
        var generateCustomCallback = function(customCallback, defaultCallback) {
            return function(objectInfo) {
                var res = (0, _type.isFunction)(customCallback) ? customCallback.call(objectInfo, objectInfo) : {};
                var hasOwnProperty = Object.prototype.hasOwnProperty.bind(res);
                if (!hasOwnProperty("html") && !hasOwnProperty("text")) {
                    res = (0, _extend2.extend)(res, defaultCallback.call(objectInfo, objectInfo))
                }
                return res
            }
        };

        function setTooltipCustomOptions(sankey) {
            sankey.prototype._setTooltipOptions = function() {
                var tooltip = this._tooltip;
                var options = tooltip && this._getOption("tooltip");
                var linkTemplate;
                var nodeTemplate;
                if (options.linkTooltipTemplate) {
                    linkTemplate = this._getTemplate(options.linkTooltipTemplate)
                }
                if (options.nodeTooltipTemplate) {
                    nodeTemplate = this._getTemplate(options.nodeTooltipTemplate)
                }
                tooltip && tooltip.update((0, _extend2.extend)({}, options, {
                    customizeTooltip: function(args) {
                        if (!(linkTemplate && "link" === args.type || nodeTemplate && "node" === args.type)) {
                            args.skipTemplate = true
                        }
                        if ("node" === args.type) {
                            return generateCustomCallback(options.customizeNodeTooltip, defaultCustomizeNodeTooltip)(args.info)
                        } else {
                            if ("link" === args.type) {
                                return generateCustomCallback(options.customizeLinkTooltip, defaultCustomizeLinkTooltip)(args.info)
                            }
                        }
                        return {}
                    },
                    contentTemplate: function(arg, div) {
                        var templateArgs = {
                            model: arg.info,
                            container: div
                        };
                        if (linkTemplate && "link" === arg.type) {
                            return linkTemplate.render(templateArgs)
                        }
                        if (nodeTemplate && "node" === arg.type) {
                            return nodeTemplate.render(templateArgs)
                        }
                    },
                    enabled: options.enabled
                }))
            };
            sankey.prototype.hideTooltip = function() {
                this._tooltip && this._tooltip.hide()
            }
        }
    },
    /*!********************************************************!*\
      !*** ./artifacts/transpiled-npm/viz/sankey/tracker.js ***!
      \********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.plugin = void 0;
        var _sankey = _interopRequireDefault(__webpack_require__( /*! ./sankey */ 490));
        var _tracker = __webpack_require__( /*! ../components/tracker */ 321);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var proto = _sankey.default.prototype;
        var DATA_KEY_BASE = "__sankey_data_";
        var dataKeyModifier = 0;
        proto._eventsMap.onNodeClick = {
            name: "nodeClick"
        };
        proto._eventsMap.onLinkClick = {
            name: "linkClick"
        };
        var getDataKey = function() {
            return DATA_KEY_BASE + dataKeyModifier++
        };
        var plugin = {
            name: "tracker",
            init: function() {
                var that = this;
                var dataKey = getDataKey();
                that._tracker = new _tracker.Tracker({
                    widget: that,
                    root: that._renderer.root,
                    getData: function(e) {
                        var target = e.target;
                        return target[dataKey]
                    },
                    getNode: function(index) {
                        if (index < that._nodes.length) {
                            return that._nodes[index]
                        } else {
                            return that._links[index - that._nodes.length]
                        }
                    },
                    click: function(e) {
                        var eventName = this.getData(e.event) < that._nodes.length ? "nodeClick" : "linkClick";
                        that._eventTrigger(eventName, {
                            target: e.node,
                            event: e.event
                        })
                    }
                });
                this._dataKey = dataKey
            },
            dispose: function() {
                this._tracker.dispose()
            },
            extenders: {
                _change_LINKS_DRAW: function() {
                    var dataKey = this._dataKey;
                    this._nodes.concat(this._links).forEach(function(item, index) {
                        item.element.data(dataKey, index)
                    })
                }
            }
        };
        exports.plugin = plugin
    },
    /*!************************************************************************!*\
      !*** ./artifacts/transpiled-npm/bundles/modules/parts/widgets-base.js ***!
      \************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var DevExpress = __webpack_require__( /*! ./core */ 235);
        __webpack_require__( /*! ./data */ 336);
        __webpack_require__( /*! ./file_management */ 1004);
        var ui = DevExpress.ui = __webpack_require__( /*! ../../../bundles/modules/ui */ 577);
        ui.themes = __webpack_require__( /*! ../../../ui/themes */ 34);
        ui.setTemplateEngine = __webpack_require__( /*! ../../../core/templates/template_engine_registry */ 175).setTemplateEngine;
        ui.dialog = __webpack_require__( /*! ../../../ui/dialog */ 267);
        ui.notify = __webpack_require__( /*! ../../../ui/notify */ 339);
        ui.repaintFloatingActionButton = __webpack_require__( /*! ../../../ui/speed_dial_action/repaint_floating_action_button */ 579);
        ui.dxActionSheet = __webpack_require__( /*! ../../../ui/action_sheet */ 268);
        ui.dxAutocomplete = __webpack_require__( /*! ../../../ui/autocomplete */ 581);
        ui.dxBox = __webpack_require__( /*! ../../../ui/box */ 211);
        ui.dxButton = __webpack_require__( /*! ../../../ui/button */ 37);
        ui.dxDropDownButton = __webpack_require__( /*! ../../../ui/drop_down_button */ 352);
        ui.dxButtonGroup = __webpack_require__( /*! ../../../ui/button_group */ 276);
        ui.dxCalendar = __webpack_require__( /*! ../../../ui/calendar */ 277);
        ui.dxCheckBox = __webpack_require__( /*! ../../../ui/check_box */ 136);
        ui.dxColorBox = __webpack_require__( /*! ../../../ui/color_box */ 353);
        ui.dxDateBox = __webpack_require__( /*! ../../../ui/date_box */ 212);
        ui.dxDrawer = __webpack_require__( /*! ../../../ui/drawer */ 631);
        ui.dxDeferRendering = __webpack_require__( /*! ../../../ui/defer_rendering */ 635);
        ui.dxDropDownBox = __webpack_require__( /*! ../../../ui/drop_down_box */ 636);
        ui.dxDropDownMenu = __webpack_require__( /*! ../../../ui/drop_down_menu */ 214);
        ui.dxFileUploader = __webpack_require__( /*! ../../../ui/file_uploader */ 281);
        ui.dxForm = __webpack_require__( /*! ../../../ui/form */ 138);
        ui.dxGallery = __webpack_require__( /*! ../../../ui/gallery */ 644);
        ui.dxHtmlEditor = __webpack_require__( /*! ../../../ui/html_editor */ 645);
        ui.dxList = __webpack_require__( /*! ../../../ui/list */ 112);
        ui.dxLoadIndicator = __webpack_require__( /*! ../../../ui/load_indicator */ 83);
        ui.dxLoadPanel = __webpack_require__( /*! ../../../ui/load_panel */ 180);
        ui.dxLookup = __webpack_require__( /*! ../../../ui/lookup */ 669);
        ui.dxMap = __webpack_require__( /*! ../../../ui/map */ 670);
        ui.dxMultiView = __webpack_require__( /*! ../../../ui/multi_view */ 358);
        ui.dxNavBar = __webpack_require__( /*! ../../../ui/nav_bar */ 674);
        ui.dxNumberBox = __webpack_require__( /*! ../../../ui/number_box */ 116);
        ui.dxOverlay = __webpack_require__( /*! ../../../ui/overlay */ 64);
        ui.dxPopover = __webpack_require__( /*! ../../../ui/popover */ 135);
        ui.dxPopup = __webpack_require__( /*! ../../../ui/popup */ 46);
        ui.dxProgressBar = __webpack_require__( /*! ../../../ui/progress_bar */ 282);
        ui.dxRadioGroup = __webpack_require__( /*! ../../../ui/radio_group */ 288);
        ui.dxRangeSlider = __webpack_require__( /*! ../../../ui/range_slider */ 677);
        ui.dxResizable = __webpack_require__( /*! ../../../ui/resizable */ 193);
        ui.dxResponsiveBox = __webpack_require__( /*! ../../../ui/responsive_box */ 362);
        ui.dxScrollView = __webpack_require__( /*! ../../../ui/scroll_view */ 90);
        ui.dxSelectBox = __webpack_require__( /*! ../../../ui/select_box */ 117);
        ui.dxSlider = __webpack_require__( /*! ../../../ui/slider */ 369);
        ui.dxSpeedDialAction = __webpack_require__( /*! ../../../ui/speed_dial_action */ 679);
        ui.dxSwitch = __webpack_require__( /*! ../../../ui/switch */ 372);
        ui.dxTabPanel = __webpack_require__( /*! ../../../ui/tab_panel */ 284);
        ui.dxTabs = __webpack_require__( /*! ../../../ui/tabs */ 215);
        ui.dxTagBox = __webpack_require__( /*! ../../../ui/tag_box */ 289);
        ui.dxTextArea = __webpack_require__( /*! ../../../ui/text_area */ 373);
        ui.dxTextBox = __webpack_require__( /*! ../../../ui/text_box */ 97);
        ui.dxTileView = __webpack_require__( /*! ../../../ui/tile_view */ 682);
        ui.dxToast = __webpack_require__( /*! ../../../ui/toast */ 340);
        ui.dxToolbar = __webpack_require__( /*! ../../../ui/toolbar */ 157);
        ui.dxTooltip = __webpack_require__( /*! ../../../ui/tooltip */ 217);
        ui.dxTrackBar = __webpack_require__( /*! ../../../ui/track_bar */ 283);
        ui.dxDraggable = __webpack_require__( /*! ../../../ui/draggable */ 210);
        ui.dxSortable = __webpack_require__( /*! ../../../ui/sortable */ 273);
        DevExpress.validationEngine = __webpack_require__( /*! ../../../ui/validation_engine */ 96);
        ui.dxValidationSummary = __webpack_require__( /*! ../../../ui/validation_summary */ 285);
        ui.dxValidationGroup = __webpack_require__( /*! ../../../ui/validation_group */ 364);
        ui.dxValidator = __webpack_require__( /*! ../../../ui/validator */ 216);
        __webpack_require__( /*! ../../../ui/html_editor/converters/markdown */ 683);
        ui.CollectionWidget = __webpack_require__( /*! ../../../ui/collection/ui.collection_widget.edit */ 54);
        ui.dxDropDownEditor = __webpack_require__( /*! ../../../ui/drop_down_editor/ui.drop_down_editor */ 195);
        module.exports = ui
    },
    /*!***************************************************************************!*\
      !*** ./artifacts/transpiled-npm/bundles/modules/parts/file_management.js ***!
      \***************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _core = _interopRequireDefault(__webpack_require__( /*! ./core */ 235));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var fileManagement = __webpack_require__( /*! ../../../bundles/modules/file_management */ 1005);
        _core.default.fileManagement = fileManagement;
        module.exports = fileManagement
    },
    /*!*********************************************************************!*\
      !*** ./artifacts/transpiled-npm/bundles/modules/file_management.js ***!
      \*********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var _core = _interopRequireDefault(__webpack_require__( /*! ./core */ 154));
        var _file_system_item = _interopRequireDefault(__webpack_require__( /*! ../../file_management/file_system_item */ 333));
        var _object_provider = _interopRequireDefault(__webpack_require__( /*! ../../file_management/object_provider */ 573));
        var _remote_provider = _interopRequireDefault(__webpack_require__( /*! ../../file_management/remote_provider */ 574));
        var _custom_provider = _interopRequireDefault(__webpack_require__( /*! ../../file_management/custom_provider */ 575));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        module.exports = _core.default.fileManagement = _core.default.fileManagement || {};
        _core.default.fileManagement.FileSystemItem = _file_system_item.default;
        _core.default.fileManagement.ObjectFileSystemProvider = _object_provider.default;
        _core.default.fileManagement.RemoteFileSystemProvider = _remote_provider.default;
        _core.default.fileManagement.CustomFileSystemProvider = _custom_provider.default
    },
    /*!**************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/slide_out.js ***!
      \**************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        var _renderer = _interopRequireDefault(__webpack_require__( /*! ../core/renderer */ 2));
        var _element = __webpack_require__( /*! ../core/element */ 18);
        var _common = __webpack_require__( /*! ../core/utils/common */ 4);
        var _type = __webpack_require__( /*! ../core/utils/type */ 1);
        var _component_registrator = _interopRequireDefault(__webpack_require__( /*! ../core/component_registrator */ 9));
        var _extend = __webpack_require__( /*! ../core/utils/extend */ 0);
        var _uiCollection_widgetEditStrategy = _interopRequireDefault(__webpack_require__( /*! ./collection/ui.collection_widget.edit.strategy.plain */ 202));
        var _slide_out_view = _interopRequireDefault(__webpack_require__( /*! ./slide_out_view */ 686));
        var _uiCollection_widget = _interopRequireDefault(__webpack_require__( /*! ./collection/ui.collection_widget.edit */ 54));
        var _list = _interopRequireDefault(__webpack_require__( /*! ./list */ 112));
        var _child_default_template = __webpack_require__( /*! ../core/templates/child_default_template */ 153);
        var _empty_template = __webpack_require__( /*! ../core/templates/empty_template */ 91);
        var _grouped_data_converter_mixin = _interopRequireDefault(__webpack_require__( /*! ./shared/grouped_data_converter_mixin */ 334));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var SLIDEOUT_CLASS = "dx-slideout";
        var SLIDEOUT_ITEM_CONTAINER_CLASS = "dx-slideout-item-container";
        var SLIDEOUT_MENU = "dx-slideout-menu";
        var SLIDEOUT_ITEM_CLASS = "dx-slideout-item";
        var SLIDEOUT_ITEM_DATA_KEY = "dxSlideoutItemData";
        var SlideOut = _uiCollection_widget.default.inherit({
            ctor: function(element, options) {
                this.callBase(element, options);
                this._logDeprecatedComponentWarning("20.1", "dxDrawer")
            },
            _getDefaultOptions: function() {
                return (0, _extend.extend)(this.callBase(), {
                    activeStateEnabled: false,
                    menuItemTemplate: "menuItem",
                    swipeEnabled: true,
                    menuVisible: false,
                    menuPosition: "normal",
                    menuGrouped: false,
                    menuGroupTemplate: "menuGroup",
                    onMenuItemRendered: null,
                    onMenuGroupRendered: null,
                    contentTemplate: "content",
                    selectionMode: "single",
                    selectedIndex: 0,
                    selectionRequired: true
                })
            },
            _itemClass: function() {
                return SLIDEOUT_ITEM_CLASS
            },
            _itemDataKey: function() {
                return SLIDEOUT_ITEM_DATA_KEY
            },
            _itemContainer: function() {
                return (0, _renderer.default)(this._slideOutView.content())
            },
            _init: function() {
                this._selectedItemContentRendered = false;
                this.callBase();
                this.$element().addClass(SLIDEOUT_CLASS);
                this._initSlideOutView()
            },
            _initTemplates: function() {
                this.callBase();
                this._templateManager.addDefaultTemplates({
                    menuItem: new _child_default_template.ChildDefaultTemplate("item"),
                    menuGroup: new _child_default_template.ChildDefaultTemplate("group"),
                    content: new _empty_template.EmptyTemplate
                })
            },
            _initEditStrategy: function() {
                if (this.option("menuGrouped")) {
                    var strategy = _uiCollection_widgetEditStrategy.default.inherit({
                        _getPlainItems: function() {
                            return this.callBase().reduce(function(result, group) {
                                result.push.apply(result, group.items);
                                return result
                            }, [])
                        }
                    });
                    this._editStrategy = new strategy(this)
                } else {
                    this.callBase()
                }
            },
            _initSlideOutView: function() {
                this._slideOutView = this._createComponent(this.$element(), _slide_out_view.default, {
                    integrationOptions: {},
                    menuVisible: this.option("menuVisible"),
                    swipeEnabled: this.option("swipeEnabled"),
                    menuPosition: this.option("menuPosition"),
                    onOptionChanged: this._slideOutViewOptionChanged.bind(this)
                });
                this._itemContainer().addClass(SLIDEOUT_ITEM_CONTAINER_CLASS)
            },
            _slideOutViewOptionChanged: function(args) {
                if ("menuVisible" === args.name) {
                    this.option(args.name, args.value)
                }
            },
            _initMarkup: function() {
                this._renderList();
                this._renderContentTemplate();
                this.callBase()
            },
            _render: function() {
                this._slideOutView._renderShield();
                this.callBase()
            },
            _renderList: function() {
                var $list = this._list && this._list.$element() || (0, _renderer.default)("<div>").addClass(SLIDEOUT_MENU).appendTo((0, _renderer.default)(this._slideOutView.menuContent()));
                this._renderItemClickAction();
                this._list = this._createComponent($list, _list.default, {
                    itemTemplateProperty: "menuTemplate",
                    selectionMode: this.option("selectionMode"),
                    selectionRequired: this.option("selectionRequired"),
                    indicateLoading: false,
                    onItemClick: this._listItemClickHandler.bind(this),
                    items: this.option("items"),
                    dataSource: this._dataSource,
                    itemTemplate: this._getTemplateByOption("menuItemTemplate"),
                    grouped: this.option("menuGrouped"),
                    groupTemplate: this._getTemplateByOption("menuGroupTemplate"),
                    onItemRendered: this.option("onMenuItemRendered"),
                    onGroupRendered: this.option("onMenuGroupRendered"),
                    onContentReady: this._updateSlideOutView.bind(this)
                });
                this._list.option("selectedIndex", this.option("selectedIndex"))
            },
            _getGroupedOption: function() {
                return this.option("menuGrouped")
            },
            _updateSlideOutView: function() {
                this._slideOutView._dimensionChanged()
            },
            _renderItemClickAction: function() {
                this._itemClickAction = this._createActionByOption("onItemClick")
            },
            _listItemClickHandler: function(e) {
                var selectedIndex = this._list.$element().find(".dx-list-item").index(e.itemElement);
                this.option("selectedIndex", selectedIndex);
                this._itemClickAction(e)
            },
            _renderContentTemplate: function() {
                if ((0, _type.isDefined)(this._singleContent)) {
                    return
                }
                var itemsLength = this._itemContainer().html().length;
                this._getTemplateByOption("contentTemplate").render({
                    container: (0, _element.getPublicElement)(this._itemContainer())
                });
                this._singleContent = this._itemContainer().html().length !== itemsLength
            },
            _itemClickHandler: _common.noop,
            _renderContentImpl: function() {
                if (this._singleContent) {
                    return
                }
                var items = this.option("items");
                var selectedIndex = this.option("selectedIndex");
                if (items.length && selectedIndex > -1) {
                    this._selectedItemContentRendered = true;
                    var selectedItem = this._list.getItemByIndex(selectedIndex);
                    this._renderItems([selectedItem])
                }
            },
            _renderItem: function(index, item) {
                this._itemContainer().find("." + SLIDEOUT_ITEM_CLASS).remove();
                this.callBase(index, item)
            },
            _selectedItemElement: function() {
                return this._itemElements().eq(0)
            },
            _updateSelection: function() {
                this._prepareContent();
                this._renderContent()
            },
            _getListWidth: function() {
                return this._slideOutView._getMenuWidth()
            },
            _changeMenuOption: function(name, value) {
                this._list.option(name, value);
                this._updateSlideOutView()
            },
            _cleanItemContainer: function() {
                if (this._singleContent) {
                    return
                }
                this.callBase()
            },
            beginUpdate: function() {
                this.callBase();
                this._list && this._list.beginUpdate()
            },
            endUpdate: function() {
                this._list && this._list.endUpdate();
                this.callBase()
            },
            _optionChanged: function(args) {
                var name = args.name;
                var value = args.value;
                switch (name) {
                    case "menuVisible":
                    case "swipeEnabled":
                    case "rtlEnabled":
                    case "menuPosition":
                        this._slideOutView.option(name, value);
                        break;
                    case "width":
                        this.callBase(args);
                        this._updateSlideOutView();
                        break;
                    case "menuItemTemplate":
                        this._changeMenuOption("itemTemplate", this._getTemplate(value));
                        break;
                    case "items":
                        this._changeMenuOption("items", this.option("items"));
                        if (!this._selectedItemContentRendered) {
                            this._updateSelection()
                        }
                        break;
                    case "dataSource":
                    case "selectedIndex":
                    case "selectedItem":
                        this._changeMenuOption(name, value);
                        this.callBase(args);
                        break;
                    case "menuGrouped":
                        this._initEditStrategy();
                        this._changeMenuOption("grouped", value);
                        break;
                    case "menuGroupTemplate":
                        this._changeMenuOption("groupTemplate", this._getTemplate(value));
                        break;
                    case "onMenuItemRendered":
                        this._changeMenuOption("onItemRendered", value);
                        break;
                    case "onMenuGroupRendered":
                        this._changeMenuOption("onGroupRendered", value);
                        break;
                    case "onItemClick":
                        this._renderItemClickAction();
                        break;
                    case "contentTemplate":
                        this._singleContent = null;
                        this._invalidate();
                        break;
                    default:
                        this.callBase(args)
                }
            },
            showMenu: function() {
                return this._slideOutView.toggleMenuVisibility(true)
            },
            hideMenu: function() {
                return this._slideOutView.toggleMenuVisibility(false)
            },
            toggleMenuVisibility: function(showing) {
                return this._slideOutView.toggleMenuVisibility(showing)
            }
        }).include(_grouped_data_converter_mixin.default);
        (0, _component_registrator.default)("dxSlideOut", SlideOut);
        var _default = SlideOut;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************************!*\
      !*** ./artifacts/transpiled-npm/ui/slide_out_view/ui.slide_out_view.animation.js ***!
      \***********************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.animation = void 0;
        var _fx = _interopRequireDefault(__webpack_require__( /*! ../../animation/fx */ 42));

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        var ANIMATION_DURATION = 400;
        var animation = {
            moveTo: function($element, position, completeAction) {
                _fx.default.animate($element, {
                    type: "slide",
                    to: {
                        left: position
                    },
                    duration: ANIMATION_DURATION,
                    complete: completeAction
                })
            },
            complete: function($element) {
                _fx.default.stop($element, true)
            }
        };
        exports.animation = animation
    },
    /*!***********************************************************************!*\
      !*** ./artifacts/transpiled-npm/bundles/modules/parts/widgets-web.js ***!
      \***********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var data = __webpack_require__( /*! ./data */ 336);
        var ui = __webpack_require__( /*! ./widgets-base */ 1003);
        ui.dxAccordion = __webpack_require__( /*! ../../../ui/accordion */ 374);
        ui.dxContextMenu = __webpack_require__( /*! ../../../ui/context_menu */ 107);
        ui.dxDataGrid = __webpack_require__( /*! ../../../ui/data_grid */ 690);
        ui.dxTreeList = __webpack_require__( /*! ../../../ui/tree_list */ 424);
        ui.dxMenu = __webpack_require__( /*! ../../../ui/menu */ 405);
        ui.dxPivotGrid = __webpack_require__( /*! ../../../ui/pivot_grid */ 769);
        ui.dxPivotGridFieldChooser = __webpack_require__( /*! ../../../ui/pivot_grid_field_chooser */ 783);
        data.PivotGridDataSource = __webpack_require__( /*! ../../../ui/pivot_grid/data_source */ 292);
        data.XmlaStore = __webpack_require__( /*! ../../../ui/pivot_grid/xmla_store */ 784);
        ui.dxScheduler = __webpack_require__( /*! ../../../ui/scheduler */ 785);
        ui.dxTreeView = __webpack_require__( /*! ../../../ui/tree_view */ 158);
        ui.dxFilterBuilder = __webpack_require__( /*! ../../../ui/filter_builder */ 411);
        ui.dxFileManager = __webpack_require__( /*! ../../../ui/file_manager */ 856);
        ui.dxDiagram = __webpack_require__( /*! ../../../ui/diagram */ 876);
        ui.dxGantt = __webpack_require__( /*! ../../../ui/gantt */ 894)
    },
    /*!***************************************************************!*\
      !*** ./artifacts/transpiled-npm/bundles/modules/parts/viz.js ***!
      \***************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var DevExpress = __webpack_require__( /*! ./core */ 235);
        __webpack_require__( /*! ./data */ 336);
        var viz = DevExpress.viz = __webpack_require__( /*! ../../../bundles/modules/viz */ 904);
        viz.currentTheme = __webpack_require__( /*! ../../../viz/themes */ 55).currentTheme;
        viz.registerTheme = __webpack_require__( /*! ../../../viz/themes */ 55).registerTheme;
        viz.exportFromMarkup = __webpack_require__( /*! ../../../viz/export */ 308).exportFromMarkup;
        viz.getMarkup = __webpack_require__( /*! ../../../viz/export */ 308).getMarkup;
        viz.exportWidgets = __webpack_require__( /*! ../../../viz/export */ 308).exportWidgets;
        viz.currentPalette = __webpack_require__( /*! ../../../viz/palette */ 187).currentPalette;
        viz.getPalette = __webpack_require__( /*! ../../../viz/palette */ 187).getPalette;
        viz.generateColors = __webpack_require__( /*! ../../../viz/palette */ 187).generateColors;
        viz.registerPalette = __webpack_require__( /*! ../../../viz/palette */ 187).registerPalette;
        viz.refreshTheme = __webpack_require__( /*! ../../../viz/themes */ 55).refreshTheme;
        viz.dxChart = __webpack_require__( /*! ../../../viz/chart */ 905);
        viz.dxPieChart = __webpack_require__( /*! ../../../viz/pie_chart */ 941);
        viz.dxPolarChart = __webpack_require__( /*! ../../../viz/polar_chart */ 942);
        viz.dxLinearGauge = __webpack_require__( /*! ../../../viz/linear_gauge */ 943);
        viz.dxCircularGauge = __webpack_require__( /*! ../../../viz/circular_gauge */ 949);
        viz.dxBarGauge = __webpack_require__( /*! ../../../viz/bar_gauge */ 952);
        viz.dxRangeSelector = __webpack_require__( /*! ../../../viz/range_selector */ 954);
        viz.dxVectorMap = __webpack_require__( /*! ../../../viz/vector_map */ 962);
        viz.map = {};
        viz.map.sources = {};
        viz.map.projection = __webpack_require__( /*! ../../../viz/vector_map/projection */ 481).projection;
        viz.dxSparkline = __webpack_require__( /*! ../../../viz/sparkline */ 973);
        viz.dxBullet = __webpack_require__( /*! ../../../viz/bullet */ 975);
        viz.dxTreeMap = __webpack_require__( /*! ../../../viz/tree_map */ 977);
        viz.dxFunnel = __webpack_require__( /*! ../../../viz/funnel */ 988);
        viz.dxSankey = __webpack_require__( /*! ../../../viz/sankey */ 996);
        viz.BaseWidget = __webpack_require__( /*! ../../../viz/core/base_widget */ 113);
        viz.getTheme = __webpack_require__( /*! ../../../viz/themes */ 55).getTheme;
        viz.findTheme = __webpack_require__( /*! ../../../viz/themes */ 55).getTheme;
        viz.refreshAll = __webpack_require__( /*! ../../../viz/themes */ 55).refreshTheme;
        viz.refreshPaths = __webpack_require__( /*! ../../../viz/utils */ 576).refreshPaths;
        viz.gauges = {
            __internals: {}
        };
        viz._dashboard = {};
        viz._dashboard.Renderer = __webpack_require__( /*! ../../../viz/core/renderers/renderer */ 177).Renderer;
        viz._dashboard.SvgElement = __webpack_require__( /*! ../../../viz/core/renderers/renderer */ 177).SvgElement;
        viz._dashboard.patchFontOptions = __webpack_require__( /*! ../../../viz/core/utils */ 14).patchFontOptions;
        module.exports = viz
    },
    /*!**********************************************************!*\
      !*** multi ./artifacts/transpiled-npm/bundles/dx.all.js ***!
      \**********************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        module.exports = __webpack_require__( /*! c:\Projects\DevExtreme\20.2\BuildLabel\Temp\DevExtreme.v20.2\repo\GitHub\artifacts\transpiled-npm\bundles\dx.all.js */ 1011)
    },
    /*!****************************************************!*\
      !*** ./artifacts/transpiled-npm/bundles/dx.all.js ***!
      \****************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        exports.default = void 0;
        __webpack_require__( /*! ./modules/parts/widgets-all */ 1012);
        __webpack_require__( /*! ./modules/parts/viz */ 1009);
        var _core = _interopRequireDefault(__webpack_require__( /*! ./modules/core */ 154));
        var _events_strategy = __webpack_require__( /*! ../core/events_strategy */ 100);
        var _index = __webpack_require__( /*! ../core/options/index */ 335);

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            }
        }
        _core.default.integration = {};
        _core.default.integration.EventsStrategy = _events_strategy.EventsStrategy;
        _core.default.integration.Options = _index.Options;
        var _default = _core.default;
        exports.default = _default;
        module.exports = exports.default
    },
    /*!***********************************************************************!*\
      !*** ./artifacts/transpiled-npm/bundles/modules/parts/widgets-all.js ***!
      \***********************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        __webpack_require__( /*! ./widgets-mobile */ 1013);
        __webpack_require__( /*! ./widgets-web */ 1008)
    },
    /*!**************************************************************************!*\
      !*** ./artifacts/transpiled-npm/bundles/modules/parts/widgets-mobile.js ***!
      \**************************************************************************/
    /*! dynamic exports provided */
    /*! all exports used */
    function(module, exports, __webpack_require__) {
        var ui = __webpack_require__( /*! ./widgets-base */ 1003);
        ui.dxSlideOut = __webpack_require__( /*! ../../../ui/slide_out */ 1006);
        ui.dxSlideOutView = __webpack_require__( /*! ../../../ui/slide_out_view */ 686)
    }
]);
